
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree8cb"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree8cb"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("pmAdi", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $04c3da7200079922$export$ffb0004e005737fa, (v) => $04c3da7200079922$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $04c3da7200079922$export$34b9dba7ce09269b, (v) => $04c3da7200079922$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $04c3da7200079922$export$25062201e9e25d76, (v) => $04c3da7200079922$export$25062201e9e25d76 = v);
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $04c3da7200079922$export$ffb0004e005737fa;
var $04c3da7200079922$export$34b9dba7ce09269b;
var $04c3da7200079922$export$25062201e9e25d76;
'use strict';


(function() {
    'use strict';
    var React = (parcelRequire("8T3gX"));
    var _assign = (parcelRequire("7nROE"));
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var REACT_ELEMENT_TYPE = 0xeac7;
    var REACT_PORTAL_TYPE = 0xeaca;
    $04c3da7200079922$export$ffb0004e005737fa = 0xeacb;
    var REACT_STRICT_MODE_TYPE = 0xeacc;
    var REACT_PROFILER_TYPE = 0xead2;
    var REACT_PROVIDER_TYPE = 0xeacd;
    var REACT_CONTEXT_TYPE = 0xeace;
    var REACT_FORWARD_REF_TYPE = 0xead0;
    var REACT_SUSPENSE_TYPE = 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = 0xead8;
    var REACT_MEMO_TYPE = 0xead3;
    var REACT_LAZY_TYPE = 0xead4;
    var REACT_BLOCK_TYPE = 0xead9;
    var REACT_SERVER_BLOCK_TYPE = 0xeada;
    var REACT_FUNDAMENTAL_TYPE = 0xead5;
    var REACT_SCOPE_TYPE = 0xead7;
    var REACT_OPAQUE_ID_TYPE = 0xeae0;
    var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
    var REACT_OFFSCREEN_TYPE = 0xeae2;
    var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;
    if (typeof Symbol === 'function' && Symbol.for) {
        var symbolFor = Symbol.for;
        REACT_ELEMENT_TYPE = symbolFor('react.element');
        REACT_PORTAL_TYPE = symbolFor('react.portal');
        $04c3da7200079922$export$ffb0004e005737fa = symbolFor('react.fragment');
        REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
        REACT_PROFILER_TYPE = symbolFor('react.profiler');
        REACT_PROVIDER_TYPE = symbolFor('react.provider');
        REACT_CONTEXT_TYPE = symbolFor('react.context');
        REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
        REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
        REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
        REACT_MEMO_TYPE = symbolFor('react.memo');
        REACT_LAZY_TYPE = symbolFor('react.lazy');
        REACT_BLOCK_TYPE = symbolFor('react.block');
        REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
        REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
        REACT_SCOPE_TYPE = symbolFor('react.scope');
        REACT_OPAQUE_ID_TYPE = symbolFor('react.opaque.id');
        REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
        REACT_OFFSCREEN_TYPE = symbolFor('react.offscreen');
        REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
    }
    var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator';
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === 'function') return maybeIterator;
        return null;
    }
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning('error', format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== '') {
            format += '%s';
            args = args.concat([
                stack
            ]);
        }
        var argsWithFormat = args.map(function(item) {
            return '' + item;
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === $04c3da7200079922$export$ffb0004e005737fa || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) return true;
        if (typeof type === 'object' && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) return true;
        }
        return false;
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || '';
        return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
    }
    function getContextName(type) {
        return type.displayName || 'Context';
    }
    function getComponentName(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === 'number') error("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue.");
        if (typeof type === 'function') return type.displayName || type.name || null;
        if (typeof type === 'string') return type;
        switch(type){
            case $04c3da7200079922$export$ffb0004e005737fa:
                return 'Fragment';
            case REACT_PORTAL_TYPE:
                return 'Portal';
            case REACT_PROFILER_TYPE:
                return 'Profiler';
            case REACT_STRICT_MODE_TYPE:
                return 'StrictMode';
            case REACT_SUSPENSE_TYPE:
                return 'Suspense';
            case REACT_SUSPENSE_LIST_TYPE:
                return 'SuspenseList';
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + '.Consumer';
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + '.Provider';
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
                return getComponentName(type.type);
            case REACT_BLOCK_TYPE:
                return getComponentName(type._render);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentName(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: _assign({}, props, {
                    value: prevLog
                }),
                info: _assign({}, props, {
                    value: prevInfo
                }),
                warn: _assign({}, props, {
                    value: prevWarn
                }),
                error: _assign({}, props, {
                    value: prevError
                }),
                group: _assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: _assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: _assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || '';
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return '\n' + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return '';
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, 'props', {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === 'object' && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === 'string') {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split('\n');
                var controlLines = control.stack.split('\n');
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');
                            if (typeof fn === 'function') componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        if (typeof fn === 'function') componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return '';
        if (typeof type === 'function') return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === 'string') return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame('Suspense');
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame('SuspenseList');
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_BLOCK_TYPE:
                return describeFunctionComponentFrame(type._render);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return '';
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(Object.prototype.hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                    var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                    err.name = 'Invariant Violation';
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || 'React class', location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown;
    var specialPropRefWarningShown;
    var didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, 'ref')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, 'key')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function warnIfStringRefCannotBeAutoConverted(config, self) {
        if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentName(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, 'key', {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, 'ref', {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, 'validated', {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, '_self', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, '_source', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * https://github.com/reactjs/rfcs/pull/107
 * @param {*} type
 * @param {object} props
 * @param {string} key
 */ function jsxDEV(type, config, maybeKey, source, self) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null; // Currently, key can be spread in as a prop. This causes a potential
        // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
        // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
        // but as an intermediary step, we will use jsxDEV for everything except
        // <div {...props} key="Hi" />, because we aren't currently able to tell if
        // key is explicitly declared to be undefined or not.
        if (maybeKey !== undefined) key = '' + maybeKey;
        if (hasValidKey(config)) key = '' + config.key;
        if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
        } // Remaining properties are added to a new props object
        for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
         // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner$1.current) {
            var name = getComponentName(ReactCurrentOwner$1.current.type);
            if (name) return '\n\nCheck the render method of `' + name + '`.';
        }
        return '';
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, '');
            var lineNumber = source.lineNumber;
            return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
        }
        return '';
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = '';
        if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== 'object') return;
        if (Array.isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === 'function') // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === 'string') return;
        var propTypes;
        if (typeof type === 'function') propTypes = type.propTypes;
        else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentName(type);
            checkPropTypes(propTypes, element.props, 'prop', name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentName(type);
            error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
        }
        if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== 'children' && key !== 'key') {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error('Invalid attribute `ref` supplied to `React.Fragment`.');
            setCurrentlyValidatingElement$1(null);
        }
    }
    function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = '';
            if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendum(source);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = 'null';
            else if (Array.isArray(type)) typeString = 'array';
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
                info = ' Did you accidentally export a JSX literal instead of a component?';
            } else typeString = typeof type;
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) {
            var children = props.children;
            if (children !== undefined) {
                if (isStaticChildren) {
                    if (Array.isArray(children)) {
                        for(var i = 0; i < children.length; i++)validateChildKeys(children[i], type);
                        if (Object.freeze) Object.freeze(children);
                    } else error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                } else validateChildKeys(children, type);
            }
        }
        if (type === $04c3da7200079922$export$ffb0004e005737fa) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    } // These two functions exist to still get child warnings in dev
    // even with the prod transform. This means that jsxDEV is purely
    // opt-in behavior for better messages but that we won't stop
    // giving you warnings if you use production apis.
    function jsxWithValidationStatic(type, props, key) {
        return jsxWithValidation(type, props, key, true);
    }
    function jsxWithValidationDynamic(type, props, key) {
        return jsxWithValidation(type, props, key, false);
    }
    var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
    // for now we can ship identical prod functions
    var jsxs = jsxWithValidationStatic;
    $04c3da7200079922$export$34b9dba7ce09269b = jsx;
    $04c3da7200079922$export$25062201e9e25d76 = jsxs;
})();

});
parcelRegister("8T3gX", function(module, exports) {
'use strict';

module.exports = (parcelRequire("385MT"));

});
parcelRegister("385MT", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $24769bbf71790f4c$export$ffb0004e005737fa, (v) => $24769bbf71790f4c$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "StrictMode", () => $24769bbf71790f4c$export$5f8d39834fd61797, (v) => $24769bbf71790f4c$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Profiler", () => $24769bbf71790f4c$export$e2c29f18771995cb, (v) => $24769bbf71790f4c$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "Suspense", () => $24769bbf71790f4c$export$74bf444e3cd11ea5, (v) => $24769bbf71790f4c$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "Children", () => $24769bbf71790f4c$export$dca3b0875bd9a954, (v) => $24769bbf71790f4c$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $24769bbf71790f4c$export$16fa2f45be04daa8, (v) => $24769bbf71790f4c$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "PureComponent", () => $24769bbf71790f4c$export$221d75b3f55bb0bd, (v) => $24769bbf71790f4c$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $24769bbf71790f4c$export$ae55be85d98224ed, (v) => $24769bbf71790f4c$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $24769bbf71790f4c$export$e530037191fcd5d7, (v) => $24769bbf71790f4c$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $24769bbf71790f4c$export$fd42f52fd3ae1109, (v) => $24769bbf71790f4c$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $24769bbf71790f4c$export$c8a8987d4410bf2d, (v) => $24769bbf71790f4c$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $24769bbf71790f4c$export$d38cd72104c1f0e9, (v) => $24769bbf71790f4c$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $24769bbf71790f4c$export$7d1e3a5e95ceca43, (v) => $24769bbf71790f4c$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $24769bbf71790f4c$export$257a8862b851cb5b, (v) => $24769bbf71790f4c$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $24769bbf71790f4c$export$a8257692ac88316c, (v) => $24769bbf71790f4c$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $24769bbf71790f4c$export$488013bae63b21da, (v) => $24769bbf71790f4c$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $24769bbf71790f4c$export$7c73462e0d25e514, (v) => $24769bbf71790f4c$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $24769bbf71790f4c$export$35808ee640e87ca7, (v) => $24769bbf71790f4c$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $24769bbf71790f4c$export$fae74005e78b1a27, (v) => $24769bbf71790f4c$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $24769bbf71790f4c$export$dc8fbce3eb94dc1e, (v) => $24769bbf71790f4c$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $24769bbf71790f4c$export$6d9c69b0de29b591, (v) => $24769bbf71790f4c$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $24769bbf71790f4c$export$d5a552a76deda3c2, (v) => $24769bbf71790f4c$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $24769bbf71790f4c$export$e5c5a5f917a5871c, (v) => $24769bbf71790f4c$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $24769bbf71790f4c$export$1538c33de8887b59, (v) => $24769bbf71790f4c$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $24769bbf71790f4c$export$13e3392192263954, (v) => $24769bbf71790f4c$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $24769bbf71790f4c$export$b8f5890fc79d6aca, (v) => $24769bbf71790f4c$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $24769bbf71790f4c$export$60241385465d0a34, (v) => $24769bbf71790f4c$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $24769bbf71790f4c$export$83d89fbfd8236492, (v) => $24769bbf71790f4c$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $24769bbf71790f4c$export$ffb0004e005737fa;
var $24769bbf71790f4c$export$5f8d39834fd61797;
var $24769bbf71790f4c$export$e2c29f18771995cb;
var $24769bbf71790f4c$export$74bf444e3cd11ea5;
var $24769bbf71790f4c$export$dca3b0875bd9a954;
var $24769bbf71790f4c$export$16fa2f45be04daa8;
var $24769bbf71790f4c$export$221d75b3f55bb0bd;
var $24769bbf71790f4c$export$ae55be85d98224ed;
var $24769bbf71790f4c$export$e530037191fcd5d7;
var $24769bbf71790f4c$export$fd42f52fd3ae1109;
var $24769bbf71790f4c$export$c8a8987d4410bf2d;
var $24769bbf71790f4c$export$d38cd72104c1f0e9;
var $24769bbf71790f4c$export$7d1e3a5e95ceca43;
var $24769bbf71790f4c$export$257a8862b851cb5b;
var $24769bbf71790f4c$export$a8257692ac88316c;
var $24769bbf71790f4c$export$488013bae63b21da;
var $24769bbf71790f4c$export$7c73462e0d25e514;
var $24769bbf71790f4c$export$35808ee640e87ca7;
var $24769bbf71790f4c$export$fae74005e78b1a27;
var $24769bbf71790f4c$export$dc8fbce3eb94dc1e;
var $24769bbf71790f4c$export$6d9c69b0de29b591;
var $24769bbf71790f4c$export$d5a552a76deda3c2;
var $24769bbf71790f4c$export$e5c5a5f917a5871c;
var $24769bbf71790f4c$export$1538c33de8887b59;
var $24769bbf71790f4c$export$13e3392192263954;
var $24769bbf71790f4c$export$b8f5890fc79d6aca;
var $24769bbf71790f4c$export$60241385465d0a34;
var $24769bbf71790f4c$export$83d89fbfd8236492;
'use strict';

(function() {
    'use strict';
    var _assign = (parcelRequire("7nROE"));
    // TODO: this is special because it gets imported during build.
    var ReactVersion = '17.0.2';
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var REACT_ELEMENT_TYPE = 0xeac7;
    var REACT_PORTAL_TYPE = 0xeaca;
    $24769bbf71790f4c$export$ffb0004e005737fa = 0xeacb;
    $24769bbf71790f4c$export$5f8d39834fd61797 = 0xeacc;
    $24769bbf71790f4c$export$e2c29f18771995cb = 0xead2;
    var REACT_PROVIDER_TYPE = 0xeacd;
    var REACT_CONTEXT_TYPE = 0xeace;
    var REACT_FORWARD_REF_TYPE = 0xead0;
    $24769bbf71790f4c$export$74bf444e3cd11ea5 = 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = 0xead8;
    var REACT_MEMO_TYPE = 0xead3;
    var REACT_LAZY_TYPE = 0xead4;
    var REACT_BLOCK_TYPE = 0xead9;
    var REACT_SERVER_BLOCK_TYPE = 0xeada;
    var REACT_FUNDAMENTAL_TYPE = 0xead5;
    var REACT_SCOPE_TYPE = 0xead7;
    var REACT_OPAQUE_ID_TYPE = 0xeae0;
    var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
    var REACT_OFFSCREEN_TYPE = 0xeae2;
    var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;
    if (typeof Symbol === 'function' && Symbol.for) {
        var symbolFor = Symbol.for;
        REACT_ELEMENT_TYPE = symbolFor('react.element');
        REACT_PORTAL_TYPE = symbolFor('react.portal');
        $24769bbf71790f4c$export$ffb0004e005737fa = symbolFor('react.fragment');
        $24769bbf71790f4c$export$5f8d39834fd61797 = symbolFor('react.strict_mode');
        $24769bbf71790f4c$export$e2c29f18771995cb = symbolFor('react.profiler');
        REACT_PROVIDER_TYPE = symbolFor('react.provider');
        REACT_CONTEXT_TYPE = symbolFor('react.context');
        REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
        $24769bbf71790f4c$export$74bf444e3cd11ea5 = symbolFor('react.suspense');
        REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
        REACT_MEMO_TYPE = symbolFor('react.memo');
        REACT_LAZY_TYPE = symbolFor('react.lazy');
        REACT_BLOCK_TYPE = symbolFor('react.block');
        REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
        REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
        REACT_SCOPE_TYPE = symbolFor('react.scope');
        REACT_OPAQUE_ID_TYPE = symbolFor('react.opaque.id');
        REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
        REACT_OFFSCREEN_TYPE = symbolFor('react.offscreen');
        REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
    }
    var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator';
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === 'function') return maybeIterator;
        return null;
    }
    /**
 * Keeps track of the current dispatcher.
 */ var ReactCurrentDispatcher = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    /**
 * Keeps track of the current batch's configuration such as how long an update
 * should suspend for if it needs to.
 */ var ReactCurrentBatchConfig = {
        transition: 0
    };
    /**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */ var ReactCurrentOwner = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    var ReactDebugCurrentFrame = {};
    var currentExtraStackFrame = null;
    function setExtraStackFrame(stack) {
        currentExtraStackFrame = stack;
    }
    ReactDebugCurrentFrame.setExtraStackFrame = function(stack) {
        currentExtraStackFrame = stack;
    }; // Stack implementation injected by the current renderer.
    ReactDebugCurrentFrame.getCurrentStack = null;
    ReactDebugCurrentFrame.getStackAddendum = function() {
        var stack = ''; // Add an extra top frame while an element is being validated
        if (currentExtraStackFrame) stack += currentExtraStackFrame;
         // Delegate to the injected renderer-specific implementation
        var impl = ReactDebugCurrentFrame.getCurrentStack;
        if (impl) stack += impl() || '';
        return stack;
    };
    /**
 * Used by act() to track whether you're inside an act() scope.
 */ var IsSomeRendererActing = {
        current: false
    };
    var ReactSharedInternals = {
        ReactCurrentDispatcher: ReactCurrentDispatcher,
        ReactCurrentBatchConfig: ReactCurrentBatchConfig,
        ReactCurrentOwner: ReactCurrentOwner,
        IsSomeRendererActing: IsSomeRendererActing,
        // Used by renderers to avoid bundling object-assign twice in UMD bundles:
        assign: _assign
    };
    ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning('warn', format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning('error', format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== '') {
            format += '%s';
            args = args.concat([
                stack
            ]);
        }
        var argsWithFormat = args.map(function(item) {
            return '' + item;
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var didWarnStateUpdateForUnmountedComponent = {};
    function warnNoop(publicInstance, callerName) {
        var _constructor = publicInstance.constructor;
        var componentName = _constructor && (_constructor.displayName || _constructor.name) || 'ReactClass';
        var warningKey = componentName + "." + callerName;
        if (didWarnStateUpdateForUnmountedComponent[warningKey]) return;
        error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, componentName);
        didWarnStateUpdateForUnmountedComponent[warningKey] = true;
    }
    /**
 * This is the abstract API for an update queue.
 */ var ReactNoopUpdateQueue = {
        /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */ isMounted: function(publicInstance) {
            return false;
        },
        /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueForceUpdate: function(publicInstance, callback, callerName) {
            warnNoop(publicInstance, 'forceUpdate');
        },
        /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueReplaceState: function(publicInstance, completeState, callback, callerName) {
            warnNoop(publicInstance, 'replaceState');
        },
        /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */ enqueueSetState: function(publicInstance, partialState, callback, callerName) {
            warnNoop(publicInstance, 'setState');
        }
    };
    var emptyObject = {};
    Object.freeze(emptyObject);
    /**
 * Base class helpers for the updating state of a component.
 */ function Component(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
        // renderer.
        this.updater = updater || ReactNoopUpdateQueue;
    }
    Component.prototype.isReactComponent = {};
    /**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */ Component.prototype.setState = function(partialState, callback) {
        if (!(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null)) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, partialState, callback, 'setState');
    };
    /**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */ Component.prototype.forceUpdate = function(callback) {
        this.updater.enqueueForceUpdate(this, callback, 'forceUpdate');
    };
    var deprecatedAPIs = {
        isMounted: [
            'isMounted',
            "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
            'replaceState',
            "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
    };
    var defineDeprecationWarning = function(methodName, info) {
        Object.defineProperty(Component.prototype, methodName, {
            get: function() {
                warn('%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
                return undefined;
            }
        });
    };
    for(var fnName in deprecatedAPIs)if (deprecatedAPIs.hasOwnProperty(fnName)) defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    function ComponentDummy() {}
    ComponentDummy.prototype = Component.prototype;
    /**
 * Convenience component with default shallow equality check for sCU.
 */ function PureComponent(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
    pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.
    _assign(pureComponentPrototype, Component.prototype);
    pureComponentPrototype.isPureReactComponent = true;
    // an immutable object with a single mutable value
    function createRef() {
        var refObject = {
            current: null
        };
        Object.seal(refObject);
        return refObject;
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || '';
        return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
    }
    function getContextName(type) {
        return type.displayName || 'Context';
    }
    function getComponentName(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === 'number') error("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue.");
        if (typeof type === 'function') return type.displayName || type.name || null;
        if (typeof type === 'string') return type;
        switch(type){
            case $24769bbf71790f4c$export$ffb0004e005737fa:
                return 'Fragment';
            case REACT_PORTAL_TYPE:
                return 'Portal';
            case $24769bbf71790f4c$export$e2c29f18771995cb:
                return 'Profiler';
            case $24769bbf71790f4c$export$5f8d39834fd61797:
                return 'StrictMode';
            case $24769bbf71790f4c$export$74bf444e3cd11ea5:
                return 'Suspense';
            case REACT_SUSPENSE_LIST_TYPE:
                return 'SuspenseList';
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + '.Consumer';
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + '.Provider';
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
                return getComponentName(type.type);
            case REACT_BLOCK_TYPE:
                return getComponentName(type._render);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentName(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, 'ref')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, 'key')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, 'key', {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, 'ref', {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    function warnIfStringRefCannotBeAutoConverted(config) {
        if (typeof config.ref === 'string' && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
            var componentName = getComponentName(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, 'validated', {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, '_self', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, '_source', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */ function createElement(type, config, children) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null;
        var self = null;
        var source = null;
        if (config != null) {
            if (hasValidRef(config)) {
                ref = config.ref;
                warnIfStringRefCannotBeAutoConverted(config);
            }
            if (hasValidKey(config)) key = '' + config.key;
            self = config.__self === undefined ? null : config.__self;
            source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            if (Object.freeze) Object.freeze(childArray);
            props.children = childArray;
        } // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    function cloneAndReplaceKey(oldElement, newKey) {
        var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
        return newElement;
    }
    /**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */ function cloneElement(element, config, children) {
        if (!!(element === null || element === undefined)) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
        var propName; // Original props are copied
        var props = _assign({}, element.props); // Reserved names are extracted
        var key = element.key;
        var ref = element.ref; // Self is preserved since the owner is preserved.
        var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
        // transpiler, and the original source is probably a better indicator of the
        // true owner.
        var source = element._source; // Owner will be preserved, unless ref is overridden
        var owner = element._owner;
        if (config != null) {
            if (hasValidRef(config)) {
                // Silently steal the ref from the parent.
                ref = config.ref;
                owner = ReactCurrentOwner.current;
            }
            if (hasValidKey(config)) key = '' + config.key;
             // Remaining properties override existing props
            var defaultProps;
            if (element.type && element.type.defaultProps) defaultProps = element.type.defaultProps;
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                if (config[propName] === undefined && defaultProps !== undefined) // Resolve default props
                props[propName] = defaultProps[propName];
                else props[propName] = config[propName];
            }
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            props.children = childArray;
        }
        return ReactElement(element.type, key, ref, self, source, owner, props);
    }
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var SEPARATOR = '.';
    var SUBSEPARATOR = ':';
    /**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */ function escape(key) {
        var escapeRegex = /[=:]/g;
        var escaperLookup = {
            '=': '=0',
            ':': '=2'
        };
        var escapedString = key.replace(escapeRegex, function(match) {
            return escaperLookup[match];
        });
        return '$' + escapedString;
    }
    /**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */ var didWarnAboutMaps = false;
    var userProvidedKeyEscapeRegex = /\/+/g;
    function escapeUserProvidedKey(text) {
        return text.replace(userProvidedKeyEscapeRegex, '$&/');
    }
    /**
 * Generate a key string that identifies a element within a set.
 *
 * @param {*} element A element that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */ function getElementKey(element, index) {
        // Do some typechecking here since we call this blindly. We want to ensure
        // that we don't block potential future ES APIs.
        if (typeof element === 'object' && element !== null && element.key != null) // Explicit key
        return escape('' + element.key);
         // Implicit key determined by the index in the set
        return index.toString(36);
    }
    function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
        var type = typeof children;
        if (type === 'undefined' || type === 'boolean') // All of the above are perceived as null.
        children = null;
        var invokeCallback = false;
        if (children === null) invokeCallback = true;
        else switch(type){
            case 'string':
            case 'number':
                invokeCallback = true;
                break;
            case 'object':
                switch(children.$$typeof){
                    case REACT_ELEMENT_TYPE:
                    case REACT_PORTAL_TYPE:
                        invokeCallback = true;
                }
        }
        if (invokeCallback) {
            var _child = children;
            var mappedChild = callback(_child); // If it's the only child, treat the name as if it was wrapped in an array
            // so that it's consistent if the number of children grows:
            var childKey = nameSoFar === '' ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;
            if (Array.isArray(mappedChild)) {
                var escapedChildKey = '';
                if (childKey != null) escapedChildKey = escapeUserProvidedKey(childKey) + '/';
                mapIntoArray(mappedChild, array, escapedChildKey, '', function(c) {
                    return c;
                });
            } else if (mappedChild != null) {
                if (isValidElement(mappedChild)) mappedChild = cloneAndReplaceKey(mappedChild, // traverseAllChildren used to do for objects as children
                escapedPrefix + (mappedChild.key && (!_child || _child.key !== mappedChild.key) ? escapeUserProvidedKey('' + mappedChild.key) + '/' : '') + childKey);
                array.push(mappedChild);
            }
            return 1;
        }
        var child;
        var nextName;
        var subtreeCount = 0; // Count of children found in the current subtree.
        var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
        if (Array.isArray(children)) for(var i = 0; i < children.length; i++){
            child = children[i];
            nextName = nextNamePrefix + getElementKey(child, i);
            subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
        }
        else {
            var iteratorFn = getIteratorFn(children);
            if (typeof iteratorFn === 'function') {
                var iterableChildren = children;
                // Warn about using Maps as children
                if (iteratorFn === iterableChildren.entries) {
                    if (!didWarnAboutMaps) warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                    didWarnAboutMaps = true;
                }
                var iterator = iteratorFn.call(iterableChildren);
                var step;
                var ii = 0;
                while(!(step = iterator.next()).done){
                    child = step.value;
                    nextName = nextNamePrefix + getElementKey(child, ii++);
                    subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
                }
            } else if (type === 'object') {
                var childrenString = '' + children;
                throw Error("Objects are not valid as a React child (found: " + (childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString) + "). If you meant to render a collection of children, use an array instead.");
            }
        }
        return subtreeCount;
    }
    /**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */ function mapChildren(children, func, context) {
        if (children == null) return children;
        var result = [];
        var count = 0;
        mapIntoArray(children, result, '', '', function(child) {
            return func.call(context, child, count++);
        });
        return result;
    }
    /**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */ function countChildren(children) {
        var n = 0;
        mapChildren(children, function() {
            n++; // Don't return anything
        });
        return n;
    }
    /**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */ function forEachChildren(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments); // Don't return anything.
        }, forEachContext);
    }
    /**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */ function toArray(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    }
    /**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */ function onlyChild(children) {
        if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
    function createContext(defaultValue, calculateChangedBits) {
        if (calculateChangedBits === undefined) calculateChangedBits = null;
        else if (calculateChangedBits !== null && typeof calculateChangedBits !== 'function') error("createContext: Expected the optional second argument to be a function. Instead received: %s", calculateChangedBits);
        var context = {
            $$typeof: REACT_CONTEXT_TYPE,
            _calculateChangedBits: calculateChangedBits,
            // As a workaround to support multiple concurrent renderers, we categorize
            // some renderers as primary and others as secondary. We only expect
            // there to be two concurrent renderers at most: React Native (primary) and
            // Fabric (secondary); React DOM (primary) and React ART (secondary).
            // Secondary renderers store their context values on separate fields.
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            // Used to track how many concurrent renderers this context currently
            // supports within in a single renderer. Such as parallel server rendering.
            _threadCount: 0,
            // These are circular
            Provider: null,
            Consumer: null
        };
        context.Provider = {
            $$typeof: REACT_PROVIDER_TYPE,
            _context: context
        };
        var hasWarnedAboutUsingNestedContextConsumers = false;
        var hasWarnedAboutUsingConsumerProvider = false;
        var hasWarnedAboutDisplayNameOnConsumer = false;
        // A separate object, but proxies back to the original context object for
        // backwards compatibility. It has a different $$typeof, so we can properly
        // warn for the incorrect usage of Context as a Consumer.
        var Consumer = {
            $$typeof: REACT_CONTEXT_TYPE,
            _context: context,
            _calculateChangedBits: context._calculateChangedBits
        }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here
        Object.defineProperties(Consumer, {
            Provider: {
                get: function() {
                    if (!hasWarnedAboutUsingConsumerProvider) {
                        hasWarnedAboutUsingConsumerProvider = true;
                        error("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?");
                    }
                    return context.Provider;
                },
                set: function(_Provider) {
                    context.Provider = _Provider;
                }
            },
            _currentValue: {
                get: function() {
                    return context._currentValue;
                },
                set: function(_currentValue) {
                    context._currentValue = _currentValue;
                }
            },
            _currentValue2: {
                get: function() {
                    return context._currentValue2;
                },
                set: function(_currentValue2) {
                    context._currentValue2 = _currentValue2;
                }
            },
            _threadCount: {
                get: function() {
                    return context._threadCount;
                },
                set: function(_threadCount) {
                    context._threadCount = _threadCount;
                }
            },
            Consumer: {
                get: function() {
                    if (!hasWarnedAboutUsingNestedContextConsumers) {
                        hasWarnedAboutUsingNestedContextConsumers = true;
                        error("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                    }
                    return context.Consumer;
                }
            },
            displayName: {
                get: function() {
                    return context.displayName;
                },
                set: function(displayName) {
                    if (!hasWarnedAboutDisplayNameOnConsumer) {
                        warn("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", displayName);
                        hasWarnedAboutDisplayNameOnConsumer = true;
                    }
                }
            }
        }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty
        context.Consumer = Consumer;
        context._currentRenderer = null;
        context._currentRenderer2 = null;
        return context;
    }
    var Uninitialized = -1;
    var Pending = 0;
    var Resolved = 1;
    var Rejected = 2;
    function lazyInitializer(payload) {
        if (payload._status === Uninitialized) {
            var ctor = payload._result;
            var thenable = ctor(); // Transition to the next state.
            var pending = payload;
            pending._status = Pending;
            pending._result = thenable;
            thenable.then(function(moduleObject) {
                if (payload._status === Pending) {
                    var defaultExport = moduleObject.default;
                    if (defaultExport === undefined) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
                    var resolved = payload;
                    resolved._status = Resolved;
                    resolved._result = defaultExport;
                }
            }, function(error) {
                if (payload._status === Pending) {
                    // Transition to the next state.
                    var rejected = payload;
                    rejected._status = Rejected;
                    rejected._result = error;
                }
            });
        }
        if (payload._status === Resolved) return payload._result;
        else throw payload._result;
    }
    function lazy(ctor) {
        var payload = {
            // We use these fields to store the result.
            _status: -1,
            _result: ctor
        };
        var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _payload: payload,
            _init: lazyInitializer
        };
        // In production, this would just set it on the object.
        var defaultProps;
        var propTypes; // $FlowFixMe
        Object.defineProperties(lazyType, {
            defaultProps: {
                configurable: true,
                get: function() {
                    return defaultProps;
                },
                set: function(newDefaultProps) {
                    error("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    defaultProps = newDefaultProps; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, 'defaultProps', {
                        enumerable: true
                    });
                }
            },
            propTypes: {
                configurable: true,
                get: function() {
                    return propTypes;
                },
                set: function(newPropTypes) {
                    error("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    propTypes = newPropTypes; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, 'propTypes', {
                        enumerable: true
                    });
                }
            }
        });
        return lazyType;
    }
    function forwardRef(render) {
        if (render != null && render.$$typeof === REACT_MEMO_TYPE) error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).");
        else if (typeof render !== 'function') error('forwardRef requires a render function but was given %s.', render === null ? 'null' : typeof render);
        else if (render.length !== 0 && render.length !== 2) error('forwardRef render functions accept exactly two parameters: props and ref. %s', render.length === 1 ? 'Did you forget to use the ref parameter?' : 'Any additional parameter will be undefined.');
        if (render != null) {
            if (render.defaultProps != null || render.propTypes != null) error("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        }
        var elementType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render
        };
        var ownName;
        Object.defineProperty(elementType, 'displayName', {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name;
                if (render.displayName == null) render.displayName = name;
            }
        });
        return elementType;
    }
    // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === $24769bbf71790f4c$export$ffb0004e005737fa || type === $24769bbf71790f4c$export$e2c29f18771995cb || type === REACT_DEBUG_TRACING_MODE_TYPE || type === $24769bbf71790f4c$export$5f8d39834fd61797 || type === $24769bbf71790f4c$export$74bf444e3cd11ea5 || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) return true;
        if (typeof type === 'object' && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) return true;
        }
        return false;
    }
    function memo(type, compare) {
        if (!isValidElementType(type)) error("memo: The first argument must be a component. Instead received: %s", type === null ? 'null' : typeof type);
        var elementType = {
            $$typeof: REACT_MEMO_TYPE,
            type: type,
            compare: compare === undefined ? null : compare
        };
        var ownName;
        Object.defineProperty(elementType, 'displayName', {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name;
                if (type.displayName == null) type.displayName = name;
            }
        });
        return elementType;
    }
    function resolveDispatcher() {
        var dispatcher = ReactCurrentDispatcher.current;
        if (!(dispatcher !== null)) throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
        return dispatcher;
    }
    function useContext(Context, unstable_observedBits) {
        var dispatcher = resolveDispatcher();
        if (unstable_observedBits !== undefined) error("useContext() second argument is reserved for future use in React. Passing it is not supported. You passed: %s.%s", unstable_observedBits, typeof unstable_observedBits === 'number' && Array.isArray(arguments[2]) ? "\n\nDid you call array.map(useContext)? Calling Hooks inside a loop is not supported. Learn more at https://reactjs.org/link/rules-of-hooks" : '');
         // TODO: add a more generic warning for invalid values.
        if (Context._context !== undefined) {
            var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
            // and nobody should be using this in existing code.
            if (realContext.Consumer === Context) error("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?");
            else if (realContext.Provider === Context) error("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return dispatcher.useContext(Context, unstable_observedBits);
    }
    function useState(initialState) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useState(initialState);
    }
    function useReducer(reducer, initialArg, init) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useReducer(reducer, initialArg, init);
    }
    function useRef(initialValue) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useRef(initialValue);
    }
    function useEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useEffect(create, deps);
    }
    function useLayoutEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useLayoutEffect(create, deps);
    }
    function useCallback(callback, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useCallback(callback, deps);
    }
    function useMemo(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useMemo(create, deps);
    }
    function useImperativeHandle(ref, create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useImperativeHandle(ref, create, deps);
    }
    function useDebugValue(value, formatterFn) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDebugValue(value, formatterFn);
    }
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: _assign({}, props, {
                    value: prevLog
                }),
                info: _assign({}, props, {
                    value: prevInfo
                }),
                warn: _assign({}, props, {
                    value: prevWarn
                }),
                error: _assign({}, props, {
                    value: prevError
                }),
                group: _assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: _assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: _assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || '';
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return '\n' + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return '';
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher$1.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher$1.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, 'props', {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === 'object' && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === 'string') {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split('\n');
                var controlLines = control.stack.split('\n');
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');
                            if (typeof fn === 'function') componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher$1.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        if (typeof fn === 'function') componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return '';
        if (typeof type === 'function') return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === 'string') return describeBuiltInComponentFrame(type);
        switch(type){
            case $24769bbf71790f4c$export$74bf444e3cd11ea5:
                return describeBuiltInComponentFrame('Suspense');
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame('SuspenseList');
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_BLOCK_TYPE:
                return describeFunctionComponentFrame(type._render);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return '';
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(Object.prototype.hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                    var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                    err.name = 'Invariant Violation';
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || 'React class', location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            setExtraStackFrame(stack);
        } else setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner.current) {
            var name = getComponentName(ReactCurrentOwner.current.type);
            if (name) return '\n\nCheck the render method of `' + name + '`.';
        }
        return '';
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, '');
            var lineNumber = source.lineNumber;
            return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
        }
        return '';
    }
    function getSourceInfoErrorAddendumForProps(elementProps) {
        if (elementProps !== null && elementProps !== undefined) return getSourceInfoErrorAddendum(elementProps.__source);
        return '';
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = '';
        if (element && element._owner && element._owner !== ReactCurrentOwner.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== 'object') return;
        if (Array.isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === 'function') // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === 'string') return;
        var propTypes;
        if (typeof type === 'function') propTypes = type.propTypes;
        else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentName(type);
            checkPropTypes(propTypes, element.props, 'prop', name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentName(type);
            error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
        }
        if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== 'children' && key !== 'key') {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error('Invalid attribute `ref` supplied to `React.Fragment`.');
            setCurrentlyValidatingElement$1(null);
        }
    }
    function createElementWithValidation(type, props, children) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = '';
            if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendumForProps(props);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = 'null';
            else if (Array.isArray(type)) typeString = 'array';
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
                info = ' Did you accidentally export a JSX literal instead of a component?';
            } else typeString = typeof type;
            error("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], type);
        if (type === $24769bbf71790f4c$export$ffb0004e005737fa) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    }
    var didWarnAboutDeprecatedCreateFactory = false;
    function createFactoryWithValidation(type) {
        var validatedFactory = createElementWithValidation.bind(null, type);
        validatedFactory.type = type;
        if (!didWarnAboutDeprecatedCreateFactory) {
            didWarnAboutDeprecatedCreateFactory = true;
            warn("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.");
        } // Legacy hook: remove it
        Object.defineProperty(validatedFactory, 'type', {
            enumerable: false,
            get: function() {
                warn("Factory.type is deprecated. Access the class directly before passing it to createFactory.");
                Object.defineProperty(this, 'type', {
                    value: type
                });
                return type;
            }
        });
        return validatedFactory;
    }
    function cloneElementWithValidation(element, props, children) {
        var newElement = cloneElement.apply(this, arguments);
        for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], newElement.type);
        validatePropTypes(newElement);
        return newElement;
    }
    try {
        var frozenObject = Object.freeze({});
        /* eslint-disable no-new */ new Map([
            [
                frozenObject,
                null
            ]
        ]);
        new Set([
            frozenObject
        ]);
    /* eslint-enable no-new */ } catch (e) {}
    var createElement$1 = createElementWithValidation;
    var cloneElement$1 = cloneElementWithValidation;
    var createFactory = createFactoryWithValidation;
    var Children = {
        map: mapChildren,
        forEach: forEachChildren,
        count: countChildren,
        toArray: toArray,
        only: onlyChild
    };
    $24769bbf71790f4c$export$dca3b0875bd9a954 = Children;
    $24769bbf71790f4c$export$16fa2f45be04daa8 = Component;
    $24769bbf71790f4c$export$221d75b3f55bb0bd = PureComponent;
    $24769bbf71790f4c$export$ae55be85d98224ed = ReactSharedInternals;
    $24769bbf71790f4c$export$e530037191fcd5d7 = cloneElement$1;
    $24769bbf71790f4c$export$fd42f52fd3ae1109 = createContext;
    $24769bbf71790f4c$export$c8a8987d4410bf2d = createElement$1;
    $24769bbf71790f4c$export$d38cd72104c1f0e9 = createFactory;
    $24769bbf71790f4c$export$7d1e3a5e95ceca43 = createRef;
    $24769bbf71790f4c$export$257a8862b851cb5b = forwardRef;
    $24769bbf71790f4c$export$a8257692ac88316c = isValidElement;
    $24769bbf71790f4c$export$488013bae63b21da = lazy;
    $24769bbf71790f4c$export$7c73462e0d25e514 = memo;
    $24769bbf71790f4c$export$35808ee640e87ca7 = useCallback;
    $24769bbf71790f4c$export$fae74005e78b1a27 = useContext;
    $24769bbf71790f4c$export$dc8fbce3eb94dc1e = useDebugValue;
    $24769bbf71790f4c$export$6d9c69b0de29b591 = useEffect;
    $24769bbf71790f4c$export$d5a552a76deda3c2 = useImperativeHandle;
    $24769bbf71790f4c$export$e5c5a5f917a5871c = useLayoutEffect;
    $24769bbf71790f4c$export$1538c33de8887b59 = useMemo;
    $24769bbf71790f4c$export$13e3392192263954 = useReducer;
    $24769bbf71790f4c$export$b8f5890fc79d6aca = useRef;
    $24769bbf71790f4c$export$60241385465d0a34 = useState;
    $24769bbf71790f4c$export$83d89fbfd8236492 = ReactVersion;
})();

});
parcelRegister("7nROE", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $56046d22c0cc6239$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $56046d22c0cc6239$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $56046d22c0cc6239$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $56046d22c0cc6239$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $56046d22c0cc6239$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $56046d22c0cc6239$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $56046d22c0cc6239$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($56046d22c0cc6239$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($56046d22c0cc6239$var$getOwnPropertySymbols) {
            symbols = $56046d22c0cc6239$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($56046d22c0cc6239$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});




parcelRegister("dSyRI", function(module, exports) {
/** @license React v17.0.2
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';




(function() {
    'use strict';
    var React = (parcelRequire("8T3gX"));
    var _assign = (parcelRequire("7nROE"));
    var Scheduler = (parcelRequire("74qJ9"));
    var tracing = (parcelRequire("7gB5I"));
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning('warn', format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning('error', format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== '') {
            format += '%s';
            args = args.concat([
                stack
            ]);
        }
        var argsWithFormat = args.map(function(item) {
            return '' + item;
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    if (!React) throw Error("ReactDOM was loaded before React. Make sure you load the React package before loading ReactDOM.");
    var FunctionComponent = 0;
    var ClassComponent = 1;
    var IndeterminateComponent = 2; // Before we know whether it is function or class
    var HostRoot = 3; // Root of a host tree. Could be nested inside another node.
    var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.
    var HostComponent = 5;
    var HostText = 6;
    var Fragment = 7;
    var Mode = 8;
    var ContextConsumer = 9;
    var ContextProvider = 10;
    var ForwardRef = 11;
    var Profiler = 12;
    var SuspenseComponent = 13;
    var MemoComponent = 14;
    var SimpleMemoComponent = 15;
    var LazyComponent = 16;
    var IncompleteClassComponent = 17;
    var DehydratedFragment = 18;
    var SuspenseListComponent = 19;
    var FundamentalComponent = 20;
    var ScopeComponent = 21;
    var Block = 22;
    var OffscreenComponent = 23;
    var LegacyHiddenComponent = 24;
    // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.
    var enableProfilerTimer = true; // Record durations for commit and passive effects phases.
    var enableFundamentalAPI = false; // Experimental Scope support.
    var enableNewReconciler = false; // Errors that are thrown while unmounting (or after in the case of passive effects)
    var warnAboutStringRefs = false;
    var allNativeEvents = new Set();
    /**
 * Mapping from registration name to event name
 */ var registrationNameDependencies = {};
    /**
 * Mapping from lowercase registration names to the properly cased version,
 * used to warn in the case of missing event handlers. Available
 * only in true.
 * @type {Object}
 */ var possibleRegistrationNames = {}; // Trust the developer to only use possibleRegistrationNames in true
    function registerTwoPhaseEvent(registrationName, dependencies) {
        registerDirectEvent(registrationName, dependencies);
        registerDirectEvent(registrationName + 'Capture', dependencies);
    }
    function registerDirectEvent(registrationName, dependencies) {
        if (registrationNameDependencies[registrationName]) error("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", registrationName);
        registrationNameDependencies[registrationName] = dependencies;
        var lowerCasedName = registrationName.toLowerCase();
        possibleRegistrationNames[lowerCasedName] = registrationName;
        if (registrationName === 'onDoubleClick') possibleRegistrationNames.ondblclick = registrationName;
        for(var i = 0; i < dependencies.length; i++)allNativeEvents.add(dependencies[i]);
    }
    var canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
    // A reserved attribute.
    // It is handled by React separately and shouldn't be written to the DOM.
    var RESERVED = 0; // A simple string attribute.
    // Attributes that aren't in the filter are presumed to have this type.
    var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
    // "enumerated" attributes with "true" and "false" as possible values.
    // When true, it should be set to a "true" string.
    // When false, it should be set to a "false" string.
    var BOOLEANISH_STRING = 2; // A real boolean attribute.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    // For any other value, should be present with that value.
    var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
    // When falsy, it should be removed.
    var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
    // When falsy, it should be removed.
    var POSITIVE_NUMERIC = 6;
    /* eslint-disable max-len */ var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
    /* eslint-enable max-len */ var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
    var ROOT_ATTRIBUTE_NAME = 'data-reactroot';
    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + ATTRIBUTE_NAME_START_CHAR + '][' + ATTRIBUTE_NAME_CHAR + ']*$');
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var illegalAttributeNameCache = {};
    var validatedAttributeNameCache = {};
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return true;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
        }
        illegalAttributeNameCache[attributeName] = true;
        error('Invalid attribute name: `%s`', attributeName);
        return false;
    }
    function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null) return propertyInfo.type === RESERVED;
        if (isCustomComponentTag) return false;
        if (name.length > 2 && (name[0] === 'o' || name[0] === 'O') && (name[1] === 'n' || name[1] === 'N')) return true;
        return false;
    }
    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) return false;
        switch(typeof value){
            case 'function':
            case 'symbol':
                // eslint-disable-line
                return true;
            case 'boolean':
                if (isCustomComponentTag) return false;
                if (propertyInfo !== null) return !propertyInfo.acceptsBooleans;
                else {
                    var prefix = name.toLowerCase().slice(0, 5);
                    return prefix !== 'data-' && prefix !== 'aria-';
                }
            default:
                return false;
        }
    }
    function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
        if (value === null || typeof value === 'undefined') return true;
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) return true;
        if (isCustomComponentTag) return false;
        if (propertyInfo !== null) switch(propertyInfo.type){
            case BOOLEAN:
                return !value;
            case OVERLOADED_BOOLEAN:
                return value === false;
            case NUMERIC:
                return isNaN(value);
            case POSITIVE_NUMERIC:
                return isNaN(value) || value < 1;
        }
        return false;
    }
    function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
    }
    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
        this.removeEmptyString = removeEmptyString;
    } // When adding attributes to this list, be sure to also add them to
    // the `possibleStandardNames` module to ensure casing and incorrect
    // name warnings.
    var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
    var reservedProps = [
        'children',
        'dangerouslySetInnerHTML',
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        'defaultValue',
        'defaultChecked',
        'innerHTML',
        'suppressContentEditableWarning',
        'suppressHydrationWarning',
        'style'
    ];
    reservedProps.forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
    }); // A few React string attributes have a different name.
    // This is a mapping from React prop names to the attribute names.
    [
        [
            'acceptCharset',
            'accept-charset'
        ],
        [
            'className',
            'class'
        ],
        [
            'htmlFor',
            'for'
        ],
        [
            'httpEquiv',
            'http-equiv'
        ]
    ].forEach(function(_ref) {
        var name = _ref[0], attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // These are "enumerated" HTML attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    [
        'contentEditable',
        'draggable',
        'spellCheck',
        'value'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
    }); // These are "enumerated" SVG attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    // Since these are SVG attributes, their attribute names are case-sensitive.
    [
        'autoReverse',
        'externalResourcesRequired',
        'focusable',
        'preserveAlpha'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
    }); // These are HTML boolean attributes.
    [
        'allowFullScreen',
        'async',
        // on the client side because the browsers are inconsistent. Instead we call focus().
        'autoFocus',
        'autoPlay',
        'controls',
        'default',
        'defer',
        'disabled',
        'disablePictureInPicture',
        'disableRemotePlayback',
        'formNoValidate',
        'hidden',
        'loop',
        'noModule',
        'noValidate',
        'open',
        'playsInline',
        'readOnly',
        'required',
        'reversed',
        'scoped',
        'seamless',
        'itemScope'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
    }); // These are the few React props that we set as DOM properties
    // rather than attributes. These are all booleans.
    [
        'checked',
        // disabled with `removeAttribute`. We have special logic for handling this.
        'multiple',
        'muted',
        'selected' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
    }); // These are HTML attributes that are "overloaded booleans": they behave like
    // booleans, but can also accept a string value.
    [
        'capture',
        'download' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
    }); // These are HTML attributes that must be positive numbers.
    [
        'cols',
        'rows',
        'size',
        'span' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
    }); // These are HTML attributes that must be numbers.
    [
        'rowSpan',
        'start'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
    });
    var CAMELIZE = /[\-\:]([a-z])/g;
    var capitalize = function(token) {
        return token[1].toUpperCase();
    }; // This is a list of all SVG attributes that need special casing, namespacing,
    // or boolean value assignment. Regular attributes that just accept strings
    // and have the same names are omitted, just like in the HTML attribute filter.
    // Some of these attributes can be hard to find. This list was created by
    // scraping the MDN documentation.
    [
        'accent-height',
        'alignment-baseline',
        'arabic-form',
        'baseline-shift',
        'cap-height',
        'clip-path',
        'clip-rule',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'dominant-baseline',
        'enable-background',
        'fill-opacity',
        'fill-rule',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'glyph-name',
        'glyph-orientation-horizontal',
        'glyph-orientation-vertical',
        'horiz-adv-x',
        'horiz-origin-x',
        'image-rendering',
        'letter-spacing',
        'lighting-color',
        'marker-end',
        'marker-mid',
        'marker-start',
        'overline-position',
        'overline-thickness',
        'paint-order',
        'panose-1',
        'pointer-events',
        'rendering-intent',
        'shape-rendering',
        'stop-color',
        'stop-opacity',
        'strikethrough-position',
        'strikethrough-thickness',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke-width',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'underline-position',
        'underline-thickness',
        'unicode-bidi',
        'unicode-range',
        'units-per-em',
        'v-alphabetic',
        'v-hanging',
        'v-ideographic',
        'v-mathematical',
        'vector-effect',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'word-spacing',
        'writing-mode',
        'xmlns:xlink',
        'x-height' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // String SVG attributes with the xlink namespace.
    [
        'xlink:actuate',
        'xlink:arcrole',
        'xlink:role',
        'xlink:show',
        'xlink:title',
        'xlink:type' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, 'http://www.w3.org/1999/xlink', false, false);
    }); // String SVG attributes with the xml namespace.
    [
        'xml:base',
        'xml:lang',
        'xml:space' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, 'http://www.w3.org/XML/1998/namespace', false, false);
    }); // These attribute exists both in HTML and SVG.
    // The attribute name is case-sensitive in SVG so we can't just use
    // the React name like we do for attributes that exist only in HTML.
    [
        'tabIndex',
        'crossOrigin'
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
    }); // These attributes accept URLs. These must not allow javascript: URLS.
    // These will also need to accept Trusted Types object in the future.
    var xlinkHref = 'xlinkHref';
    properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false, 'xlink:href', 'http://www.w3.org/1999/xlink', true, false);
    [
        'src',
        'href',
        'action',
        'formAction'
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
    });
    // and any newline or tab are filtered out as if they're not part of the URL.
    // https://url.spec.whatwg.org/#url-parsing
    // Tab or newline are defined as \r\n\t:
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    // A C0 control is a code point in the range \u0000 NULL to \u001F
    // INFORMATION SEPARATOR ONE, inclusive:
    // https://infra.spec.whatwg.org/#c0-control-or-space
    /* eslint-disable max-len */ var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
    var didWarn = false;
    function sanitizeURL(url) {
        if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
        }
    }
    /**
 * Get the value for a property on a node. Only used in DEV for SSR validation.
 * The "expected" argument is used as a hint of what the expected value is.
 * Some properties have multiple equivalent values.
 */ function getValueForProperty(node, name, expected, propertyInfo) {
        if (propertyInfo.mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            return node[propertyName];
        } else {
            if (propertyInfo.sanitizeURL) // If we haven't fully disabled javascript: URLs, and if
            // the hydration is successful of a javascript: URL, we
            // still want to warn on the client.
            sanitizeURL('' + expected);
            var attributeName = propertyInfo.attributeName;
            var stringValue = null;
            if (propertyInfo.type === OVERLOADED_BOOLEAN) {
                if (node.hasAttribute(attributeName)) {
                    var value = node.getAttribute(attributeName);
                    if (value === '') return true;
                    if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return value;
                    if (value === '' + expected) return expected;
                    return value;
                }
            } else if (node.hasAttribute(attributeName)) {
                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) // We had an attribute but shouldn't have had one, so read it
                // for the error message.
                return node.getAttribute(attributeName);
                if (propertyInfo.type === BOOLEAN) // If this was a boolean, it doesn't matter what the value is
                // the fact that we have it is the same as the expected.
                return expected;
                 // Even if this property uses a namespace we use getAttribute
                // because we assume its namespaced name is the same as our config.
                // To use getAttributeNS we need the local name which we don't have
                // in our config atm.
                stringValue = node.getAttribute(attributeName);
            }
            if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return stringValue === null ? expected : stringValue;
            else if (stringValue === '' + expected) return expected;
            else return stringValue;
        }
    }
    /**
 * Get the value for a attribute on a node. Only used in DEV for SSR validation.
 * The third argument is used as a hint of what the expected value is. Some
 * attributes have multiple equivalent values.
 */ function getValueForAttribute(node, name, expected) {
        if (!isAttributeNameSafe(name)) return;
         // If the object is an opaque reference ID, it's expected that
        // the next prop is different than the server value, so just return
        // expected
        if (isOpaqueHydratingObject(expected)) return expected;
        if (!node.hasAttribute(name)) return expected === undefined ? undefined : null;
        var value = node.getAttribute(name);
        if (value === '' + expected) return expected;
        return value;
    }
    /**
 * Sets the value for a property on a node.
 *
 * @param {DOMElement} node
 * @param {string} name
 * @param {*} value
 */ function setValueForProperty(node, name, value, isCustomComponentTag) {
        var propertyInfo = getPropertyInfo(name);
        if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) return;
        if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) value = null;
         // If the prop isn't in the special list, treat it as a simple attribute.
        if (isCustomComponentTag || propertyInfo === null) {
            if (isAttributeNameSafe(name)) {
                var _attributeName = name;
                if (value === null) node.removeAttribute(_attributeName);
                else node.setAttribute(_attributeName, '' + value);
            }
            return;
        }
        var mustUseProperty = propertyInfo.mustUseProperty;
        if (mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            if (value === null) {
                var type = propertyInfo.type;
                node[propertyName] = type === BOOLEAN ? false : '';
            } else // Contrary to `setAttribute`, object properties are properly
            // `toString`ed by IE8/9.
            node[propertyName] = value;
            return;
        } // The rest are treated as attributes with special cases.
        var attributeName = propertyInfo.attributeName, attributeNamespace = propertyInfo.attributeNamespace;
        if (value === null) node.removeAttribute(attributeName);
        else {
            var _type = propertyInfo.type;
            var attributeValue;
            if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) // If attribute type is boolean, we know for sure it won't be an execution sink
            // and we won't require Trusted Type here.
            attributeValue = '';
            else {
                attributeValue = '' + value;
                if (propertyInfo.sanitizeURL) sanitizeURL(attributeValue.toString());
            }
            if (attributeNamespace) node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
            else node.setAttribute(attributeName, attributeValue);
        }
    }
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var REACT_ELEMENT_TYPE = 0xeac7;
    var REACT_PORTAL_TYPE = 0xeaca;
    var REACT_FRAGMENT_TYPE = 0xeacb;
    var REACT_STRICT_MODE_TYPE = 0xeacc;
    var REACT_PROFILER_TYPE = 0xead2;
    var REACT_PROVIDER_TYPE = 0xeacd;
    var REACT_CONTEXT_TYPE = 0xeace;
    var REACT_FORWARD_REF_TYPE = 0xead0;
    var REACT_SUSPENSE_TYPE = 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = 0xead8;
    var REACT_MEMO_TYPE = 0xead3;
    var REACT_LAZY_TYPE = 0xead4;
    var REACT_BLOCK_TYPE = 0xead9;
    var REACT_SERVER_BLOCK_TYPE = 0xeada;
    var REACT_FUNDAMENTAL_TYPE = 0xead5;
    var REACT_SCOPE_TYPE = 0xead7;
    var REACT_OPAQUE_ID_TYPE = 0xeae0;
    var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
    var REACT_OFFSCREEN_TYPE = 0xeae2;
    var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;
    if (typeof Symbol === 'function' && Symbol.for) {
        var symbolFor = Symbol.for;
        REACT_ELEMENT_TYPE = symbolFor('react.element');
        REACT_PORTAL_TYPE = symbolFor('react.portal');
        REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
        REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
        REACT_PROFILER_TYPE = symbolFor('react.profiler');
        REACT_PROVIDER_TYPE = symbolFor('react.provider');
        REACT_CONTEXT_TYPE = symbolFor('react.context');
        REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
        REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
        REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
        REACT_MEMO_TYPE = symbolFor('react.memo');
        REACT_LAZY_TYPE = symbolFor('react.lazy');
        REACT_BLOCK_TYPE = symbolFor('react.block');
        REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
        REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
        REACT_SCOPE_TYPE = symbolFor('react.scope');
        REACT_OPAQUE_ID_TYPE = symbolFor('react.opaque.id');
        REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
        REACT_OFFSCREEN_TYPE = symbolFor('react.offscreen');
        REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
    }
    var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator';
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === 'function') return maybeIterator;
        return null;
    }
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: _assign({}, props, {
                    value: prevLog
                }),
                info: _assign({}, props, {
                    value: prevInfo
                }),
                warn: _assign({}, props, {
                    value: prevWarn
                }),
                error: _assign({}, props, {
                    value: prevError
                }),
                group: _assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: _assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: _assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || '';
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return '\n' + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return '';
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, 'props', {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === 'object' && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === 'string') {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split('\n');
                var controlLines = control.stack.split('\n');
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');
                            if (typeof fn === 'function') componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        if (typeof fn === 'function') componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeClassComponentFrame(ctor, source, ownerFn) {
        return describeNativeComponentFrame(ctor, true);
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return '';
        if (typeof type === 'function') return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === 'string') return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame('Suspense');
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame('SuspenseList');
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_BLOCK_TYPE:
                return describeFunctionComponentFrame(type._render);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return '';
    }
    function describeFiber(fiber) {
        var owner = fiber._debugOwner ? fiber._debugOwner.type : null;
        var source = fiber._debugSource;
        switch(fiber.tag){
            case HostComponent:
                return describeBuiltInComponentFrame(fiber.type);
            case LazyComponent:
                return describeBuiltInComponentFrame('Lazy');
            case SuspenseComponent:
                return describeBuiltInComponentFrame('Suspense');
            case SuspenseListComponent:
                return describeBuiltInComponentFrame('SuspenseList');
            case FunctionComponent:
            case IndeterminateComponent:
            case SimpleMemoComponent:
                return describeFunctionComponentFrame(fiber.type);
            case ForwardRef:
                return describeFunctionComponentFrame(fiber.type.render);
            case Block:
                return describeFunctionComponentFrame(fiber.type._render);
            case ClassComponent:
                return describeClassComponentFrame(fiber.type);
            default:
                return '';
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        try {
            var info = '';
            var node = workInProgress;
            do {
                info += describeFiber(node);
                node = node.return;
            }while (node);
            return info;
        } catch (x) {
            return '\nError generating stack: ' + x.message + '\n' + x.stack;
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || '';
        return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
    }
    function getContextName(type) {
        return type.displayName || 'Context';
    }
    function getComponentName(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === 'number') error("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue.");
        if (typeof type === 'function') return type.displayName || type.name || null;
        if (typeof type === 'string') return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return 'Fragment';
            case REACT_PORTAL_TYPE:
                return 'Portal';
            case REACT_PROFILER_TYPE:
                return 'Profiler';
            case REACT_STRICT_MODE_TYPE:
                return 'StrictMode';
            case REACT_SUSPENSE_TYPE:
                return 'Suspense';
            case REACT_SUSPENSE_LIST_TYPE:
                return 'SuspenseList';
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + '.Consumer';
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + '.Provider';
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
                return getComponentName(type.type);
            case REACT_BLOCK_TYPE:
                return getComponentName(type._render);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentName(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var current = null;
    var isRendering = false;
    function getCurrentFiberOwnerNameInDevOrNull() {
        if (current === null) return null;
        var owner = current._debugOwner;
        if (owner !== null && typeof owner !== 'undefined') return getComponentName(owner.type);
        return null;
    }
    function getCurrentFiberStackInDev() {
        if (current === null) return '';
         // Safe because if current fiber exists, we are reconciling,
        // and it is guaranteed to be the work-in-progress version.
        return getStackByFiberInDevAndProd(current);
    }
    function resetCurrentFiber() {
        ReactDebugCurrentFrame.getCurrentStack = null;
        current = null;
        isRendering = false;
    }
    function setCurrentFiber(fiber) {
        ReactDebugCurrentFrame.getCurrentStack = getCurrentFiberStackInDev;
        current = fiber;
        isRendering = false;
    }
    function setIsRendering(rendering) {
        isRendering = rendering;
    }
    function getIsRendering() {
        return isRendering;
    }
    // Flow does not allow string concatenation of most non-string types. To work
    // around this limitation, we use an opaque type that can only be obtained by
    // passing the value through getToStringValue first.
    function toString(value) {
        return '' + value;
    }
    function getToStringValue(value) {
        switch(typeof value){
            case 'boolean':
            case 'number':
            case 'object':
            case 'string':
            case 'undefined':
                return value;
            default:
                // function, symbol are assigned as empty strings
                return '';
        }
    }
    var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
    };
    function checkControlledValueProps(tagName, props) {
        if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
        if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function isCheckable(elem) {
        var type = elem.type;
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
    }
    function getTracker(node) {
        return node._valueTracker;
    }
    function detachTracker(node) {
        node._valueTracker = null;
    }
    function getValueFromNode(node) {
        var value = '';
        if (!node) return value;
        if (isCheckable(node)) value = node.checked ? 'true' : 'false';
        else value = node.value;
        return value;
    }
    function trackValueOnNode(node) {
        var valueField = isCheckable(node) ? 'checked' : 'value';
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        var currentValue = '' + node[valueField]; // if someone has already defined a value or Safari, then bail
        // and don't track value will cause over reporting of changes,
        // but it's better then a hard failure
        // (needed for certain tests that spyOn input values and Safari)
        if (node.hasOwnProperty(valueField) || typeof descriptor === 'undefined' || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') return;
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: true,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = '' + value;
                set.call(this, value);
            }
        }); // We could've passed this the first time
        // but it triggers a bug in IE11 and Edge 14/15.
        // Calling defineProperty() again should be equivalent.
        // https://github.com/facebook/react/issues/11768
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        var tracker = {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = '' + value;
            },
            stopTracking: function() {
                detachTracker(node);
                delete node[valueField];
            }
        };
        return tracker;
    }
    function track(node) {
        if (getTracker(node)) return;
         // TODO: Once it's just Fiber we can move this to node._wrapperState
        node._valueTracker = trackValueOnNode(node);
    }
    function updateValueIfChanged(node) {
        if (!node) return false;
        var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
        // that trying again will succeed
        if (!tracker) return true;
        var lastValue = tracker.getValue();
        var nextValue = getValueFromNode(node);
        if (nextValue !== lastValue) {
            tracker.setValue(nextValue);
            return true;
        }
        return false;
    }
    function getActiveElement(doc) {
        doc = doc || (typeof document !== 'undefined' ? document : undefined);
        if (typeof doc === 'undefined') return null;
        try {
            return doc.activeElement || doc.body;
        } catch (e) {
            return doc.body;
        }
    }
    var didWarnValueDefaultValue = false;
    var didWarnCheckedDefaultChecked = false;
    var didWarnControlledToUncontrolled = false;
    var didWarnUncontrolledToControlled = false;
    function isControlled(props) {
        var usesChecked = props.type === 'checkbox' || props.type === 'radio';
        return usesChecked ? props.checked != null : props.value != null;
    }
    /**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */ function getHostProps(element, props) {
        var node = element;
        var checked = props.checked;
        var hostProps = _assign({}, props, {
            defaultChecked: undefined,
            defaultValue: undefined,
            value: undefined,
            checked: checked != null ? checked : node._wrapperState.initialChecked
        });
        return hostProps;
    }
    function initWrapperState(element, props) {
        checkControlledValueProps('input', props);
        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
            error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);
            didWarnCheckedDefaultChecked = true;
        }
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
            error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);
            didWarnValueDefaultValue = true;
        }
        var node = element;
        var defaultValue = props.defaultValue == null ? '' : props.defaultValue;
        node._wrapperState = {
            initialChecked: props.checked != null ? props.checked : props.defaultChecked,
            initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
            controlled: isControlled(props)
        };
    }
    function updateChecked(element, props) {
        var node = element;
        var checked = props.checked;
        if (checked != null) setValueForProperty(node, 'checked', checked, false);
    }
    function updateWrapper(element, props) {
        var node = element;
        var controlled = isControlled(props);
        if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
            error("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnUncontrolledToControlled = true;
        }
        if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
            error("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnControlledToUncontrolled = true;
        }
        updateChecked(element, props);
        var value = getToStringValue(props.value);
        var type = props.type;
        if (value != null) {
            if (type === 'number') {
                if (value === 0 && node.value === '' || // We explicitly want to coerce to number here if possible.
                // eslint-disable-next-line
                node.value != value) node.value = toString(value);
            } else if (node.value !== toString(value)) node.value = toString(value);
        } else if (type === 'submit' || type === 'reset') {
            // Submit/reset inputs need the attribute removed completely to avoid
            // blank-text buttons.
            node.removeAttribute('value');
            return;
        }
        // When syncing the value attribute, the value comes from a cascade of
        // properties:
        //  1. The value React property
        //  2. The defaultValue React property
        //  3. Otherwise there should be no change
        if (props.hasOwnProperty('value')) setDefaultValue(node, props.type, value);
        else if (props.hasOwnProperty('defaultValue')) setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
        // When syncing the checked attribute, it only changes when it needs
        // to be removed, such as transitioning from a checkbox into a text input
        if (props.checked == null && props.defaultChecked != null) node.defaultChecked = !!props.defaultChecked;
    }
    function postMountWrapper(element, props, isHydrating) {
        var node = element; // Do not assign value if it is already set. This prevents user text input
        // from being lost during SSR hydration.
        if (props.hasOwnProperty('value') || props.hasOwnProperty('defaultValue')) {
            var type = props.type;
            var isButton = type === 'submit' || type === 'reset'; // Avoid setting value attribute on submit/reset inputs as it overrides the
            // default value provided by the browser. See: #12872
            if (isButton && (props.value === undefined || props.value === null)) return;
            var initialValue = toString(node._wrapperState.initialValue); // Do not assign value if it is already set. This prevents user text input
            // from being lost during SSR hydration.
            if (!isHydrating) // When syncing the value attribute, the value property should use
            // the wrapperState._initialValue property. This uses:
            //
            //   1. The value React property when present
            //   2. The defaultValue React property when present
            //   3. An empty string
            {
                if (initialValue !== node.value) node.value = initialValue;
            }
            // Otherwise, the value attribute is synchronized to the property,
            // so we assign defaultValue to the same thing as the value property
            // assignment step above.
            node.defaultValue = initialValue;
        } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
        // this is needed to work around a chrome bug where setting defaultChecked
        // will sometimes influence the value of checked (even after detachment).
        // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
        // We need to temporarily unset name to avoid disrupting radio button groups.
        var name = node.name;
        if (name !== '') node.name = '';
        // When syncing the checked attribute, both the checked property and
        // attribute are assigned at the same time using defaultChecked. This uses:
        //
        //   1. The checked React property when present
        //   2. The defaultChecked React property when present
        //   3. Otherwise, false
        node.defaultChecked = !node.defaultChecked;
        node.defaultChecked = !!node._wrapperState.initialChecked;
        if (name !== '') node.name = name;
    }
    function restoreControlledState(element, props) {
        var node = element;
        updateWrapper(node, props);
        updateNamedCousins(node, props);
    }
    function updateNamedCousins(rootNode, props) {
        var name = props.name;
        if (props.type === 'radio' && name != null) {
            var queryRoot = rootNode;
            while(queryRoot.parentNode)queryRoot = queryRoot.parentNode;
             // If `rootNode.form` was non-null, then we could try `form.elements`,
            // but that sometimes behaves strangely in IE8. We could also try using
            // `form.getElementsByName`, but that will only return direct children
            // and won't include inputs that use the HTML5 `form=` attribute. Since
            // the input might not even be in a form. It might not even be in the
            // document. Let's just use the local `querySelectorAll` to ensure we don't
            // miss anything.
            var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
            for(var i = 0; i < group.length; i++){
                var otherNode = group[i];
                if (otherNode === rootNode || otherNode.form !== rootNode.form) continue;
                 // This will throw if radio buttons rendered by different copies of React
                // and the same name are rendered into the same form (same as #1939).
                // That's probably okay; we don't support it just as we don't support
                // mixing React radio buttons with non-React ones.
                var otherProps = getFiberCurrentPropsFromNode(otherNode);
                if (!otherProps) throw Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                 // We need update the tracked value on the named cousin since the value
                // was changed but the input saw no event or value set
                updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
                // was previously checked to update will cause it to be come re-checked
                // as appropriate.
                updateWrapper(otherNode, otherProps);
            }
        }
    } // In Chrome, assigning defaultValue to certain input types triggers input validation.
    // For number inputs, the display value loses trailing decimal points. For email inputs,
    // Chrome raises "The specified value <x> is not a valid email address".
    //
    // Here we check to see if the defaultValue has actually changed, avoiding these problems
    // when the user is inputting text
    //
    // https://github.com/facebook/react/issues/7253
    function setDefaultValue(node, type, value) {
        if (type !== 'number' || getActiveElement(node.ownerDocument) !== node) {
            if (value == null) node.defaultValue = toString(node._wrapperState.initialValue);
            else if (node.defaultValue !== toString(value)) node.defaultValue = toString(value);
        }
    }
    var didWarnSelectedSetOnOption = false;
    var didWarnInvalidChild = false;
    function flattenChildren(children) {
        var content = ''; // Flatten children. We'll warn if they are invalid
        // during validateProps() which runs for hydration too.
        // Note that this would throw on non-element objects.
        // Elements are stringified (which is normally irrelevant
        // but matters for <fbt>).
        React.Children.forEach(children, function(child) {
            if (child == null) return;
            content += child; // Note: we don't warn about invalid children here.
        // Instead, this is done separately below so that
        // it happens during the hydration code path too.
        });
        return content;
    }
    /**
 * Implements an <option> host component that warns when `selected` is set.
 */ function validateProps(element, props) {
        // This mirrors the code path above, but runs for hydration too.
        // Warn about invalid children here so that client and hydration are consistent.
        // TODO: this seems like it could cause a DEV-only throw for hydration
        // if children contains a non-element object. We should try to avoid that.
        if (typeof props.children === 'object' && props.children !== null) React.Children.forEach(props.children, function(child) {
            if (child == null) return;
            if (typeof child === 'string' || typeof child === 'number') return;
            if (typeof child.type !== 'string') return;
            if (!didWarnInvalidChild) {
                didWarnInvalidChild = true;
                error('Only strings and numbers are supported as <option> children.');
            }
        });
         // TODO: Remove support for `selected` in <option>.
        if (props.selected != null && !didWarnSelectedSetOnOption) {
            error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
            didWarnSelectedSetOnOption = true;
        }
    }
    function postMountWrapper$1(element, props) {
        // value="" should make a value attribute (#6219)
        if (props.value != null) element.setAttribute('value', toString(getToStringValue(props.value)));
    }
    function getHostProps$1(element, props) {
        var hostProps = _assign({
            children: undefined
        }, props);
        var content = flattenChildren(props.children);
        if (content) hostProps.children = content;
        return hostProps;
    }
    var didWarnValueDefaultValue$1;
    didWarnValueDefaultValue$1 = false;
    function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        if (ownerName) return '\n\nCheck the render method of `' + ownerName + '`.';
        return '';
    }
    var valuePropNames = [
        'value',
        'defaultValue'
    ];
    /**
 * Validation function for `value` and `defaultValue`.
 */ function checkSelectPropTypes(props) {
        checkControlledValueProps('select', props);
        for(var i = 0; i < valuePropNames.length; i++){
            var propName = valuePropNames[i];
            if (props[propName] == null) continue;
            var isArray = Array.isArray(props[propName]);
            if (props.multiple && !isArray) error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum());
            else if (!props.multiple && isArray) error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
        }
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
        var options = node.options;
        if (multiple) {
            var selectedValues = propValue;
            var selectedValue = {};
            for(var i = 0; i < selectedValues.length; i++)// Prefix to avoid chaos with special keys.
            selectedValue['$' + selectedValues[i]] = true;
            for(var _i = 0; _i < options.length; _i++){
                var selected = selectedValue.hasOwnProperty('$' + options[_i].value);
                if (options[_i].selected !== selected) options[_i].selected = selected;
                if (selected && setDefaultSelected) options[_i].defaultSelected = true;
            }
        } else {
            // Do not set `select.value` as exact behavior isn't consistent across all
            // browsers for all cases.
            var _selectedValue = toString(getToStringValue(propValue));
            var defaultSelected = null;
            for(var _i2 = 0; _i2 < options.length; _i2++){
                if (options[_i2].value === _selectedValue) {
                    options[_i2].selected = true;
                    if (setDefaultSelected) options[_i2].defaultSelected = true;
                    return;
                }
                if (defaultSelected === null && !options[_i2].disabled) defaultSelected = options[_i2];
            }
            if (defaultSelected !== null) defaultSelected.selected = true;
        }
    }
    /**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */ function getHostProps$2(element, props) {
        return _assign({}, props, {
            value: undefined
        });
    }
    function initWrapperState$1(element, props) {
        var node = element;
        checkSelectPropTypes(props);
        node._wrapperState = {
            wasMultiple: !!props.multiple
        };
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
            error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components");
            didWarnValueDefaultValue$1 = true;
        }
    }
    function postMountWrapper$2(element, props) {
        var node = element;
        node.multiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
    }
    function postUpdateWrapper(element, props) {
        var node = element;
        var wasMultiple = node._wrapperState.wasMultiple;
        node._wrapperState.wasMultiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (wasMultiple !== !!props.multiple) {
            // For simplicity, reapply `defaultValue` if `multiple` is toggled.
            if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
            else // Revert the select back to its default unselected state.
            updateOptions(node, !!props.multiple, props.multiple ? [] : '', false);
        }
    }
    function restoreControlledState$1(element, props) {
        var node = element;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
    }
    var didWarnValDefaultVal = false;
    /**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */ function getHostProps$3(element, props) {
        var node = element;
        if (!(props.dangerouslySetInnerHTML == null)) throw Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
         // Always set children to the same thing. In IE9, the selection range will
        // get reset if `textContent` is mutated.  We could add a check in setTextContent
        // to only set the value if/when the value differs from the node value (which would
        // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
        // solution. The value can be a boolean or object so that's why it's forced
        // to be a string.
        var hostProps = _assign({}, props, {
            value: undefined,
            defaultValue: undefined,
            children: toString(node._wrapperState.initialValue)
        });
        return hostProps;
    }
    function initWrapperState$2(element, props) {
        var node = element;
        checkControlledValueProps('textarea', props);
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
            error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || 'A component');
            didWarnValDefaultVal = true;
        }
        var initialValue = props.value; // Only bother fetching default value if we're going to use it
        if (initialValue == null) {
            var children = props.children, defaultValue = props.defaultValue;
            if (children != null) {
                error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
                if (!(defaultValue == null)) throw Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                if (Array.isArray(children)) {
                    if (!(children.length <= 1)) throw Error("<textarea> can only have at most one child.");
                    children = children[0];
                }
                defaultValue = children;
            }
            if (defaultValue == null) defaultValue = '';
            initialValue = defaultValue;
        }
        node._wrapperState = {
            initialValue: getToStringValue(initialValue)
        };
    }
    function updateWrapper$1(element, props) {
        var node = element;
        var value = getToStringValue(props.value);
        var defaultValue = getToStringValue(props.defaultValue);
        if (value != null) {
            // Cast `value` to a string to ensure the value is set correctly. While
            // browsers typically do this as necessary, jsdom doesn't.
            var newValue = toString(value); // To avoid side effects (such as losing text selection), only set value if changed
            if (newValue !== node.value) node.value = newValue;
            if (props.defaultValue == null && node.defaultValue !== newValue) node.defaultValue = newValue;
        }
        if (defaultValue != null) node.defaultValue = toString(defaultValue);
    }
    function postMountWrapper$3(element, props) {
        var node = element; // This is in postMount because we need access to the DOM node, which is not
        // available until after the component has mounted.
        var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
        // initial value. In IE10/IE11 there is a bug where the placeholder attribute
        // will populate textContent as well.
        // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
        if (textContent === node._wrapperState.initialValue) {
            if (textContent !== '' && textContent !== null) node.value = textContent;
        }
    }
    function restoreControlledState$2(element, props) {
        // DOM component is still mounted; update
        updateWrapper$1(element, props);
    }
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    var MATH_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    var Namespaces = {
        html: HTML_NAMESPACE,
        mathml: MATH_NAMESPACE,
        svg: SVG_NAMESPACE
    }; // Assumes there is no parent namespace.
    function getIntrinsicNamespace(type) {
        switch(type){
            case 'svg':
                return SVG_NAMESPACE;
            case 'math':
                return MATH_NAMESPACE;
            default:
                return HTML_NAMESPACE;
        }
    }
    function getChildNamespace(parentNamespace, type) {
        if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) // No (or default) parent namespace: potential entry point.
        return getIntrinsicNamespace(type);
        if (parentNamespace === SVG_NAMESPACE && type === 'foreignObject') // We're leaving SVG.
        return HTML_NAMESPACE;
         // By default, pass namespace below.
        return parentNamespace;
    }
    /* globals MSApp */ /**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */ var createMicrosoftUnsafeLocalFunction = function(func) {
        if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) return function(arg0, arg1, arg2, arg3) {
            MSApp.execUnsafeLocalFunction(function() {
                return func(arg0, arg1, arg2, arg3);
            });
        };
        else return func;
    };
    var reusableSVGContainer;
    /**
 * Set the innerHTML property of a node
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */ var setInnerHTML = createMicrosoftUnsafeLocalFunction(function(node, html) {
        if (node.namespaceURI === Namespaces.svg) {
            if (!('innerHTML' in node)) {
                // IE does not have innerHTML for SVG nodes, so instead we inject the
                // new markup in a temp node and then move the child nodes across into
                // the target node
                reusableSVGContainer = reusableSVGContainer || document.createElement('div');
                reusableSVGContainer.innerHTML = '<svg>' + html.valueOf().toString() + '</svg>';
                var svgNode = reusableSVGContainer.firstChild;
                while(node.firstChild)node.removeChild(node.firstChild);
                while(svgNode.firstChild)node.appendChild(svgNode.firstChild);
                return;
            }
        }
        node.innerHTML = html;
    });
    /**
 * HTML nodeType values that represent the type of the node
 */ var ELEMENT_NODE = 1;
    var TEXT_NODE = 3;
    var COMMENT_NODE = 8;
    var DOCUMENT_NODE = 9;
    var DOCUMENT_FRAGMENT_NODE = 11;
    /**
 * Set the textContent property of a node. For text updates, it's faster
 * to set the `nodeValue` of the Text node directly instead of using
 * `.textContent` which will remove the existing node and create a new one.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */ var setTextContent = function(node, text) {
        if (text) {
            var firstChild = node.firstChild;
            if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
                firstChild.nodeValue = text;
                return;
            }
        }
        node.textContent = text;
    };
    // List derived from Gecko source code:
    // https://github.com/mozilla/gecko-dev/blob/4e638efc71/layout/style/test/property_database.js
    var shorthandToLonghand = {
        animation: [
            'animationDelay',
            'animationDirection',
            'animationDuration',
            'animationFillMode',
            'animationIterationCount',
            'animationName',
            'animationPlayState',
            'animationTimingFunction'
        ],
        background: [
            'backgroundAttachment',
            'backgroundClip',
            'backgroundColor',
            'backgroundImage',
            'backgroundOrigin',
            'backgroundPositionX',
            'backgroundPositionY',
            'backgroundRepeat',
            'backgroundSize'
        ],
        backgroundPosition: [
            'backgroundPositionX',
            'backgroundPositionY'
        ],
        border: [
            'borderBottomColor',
            'borderBottomStyle',
            'borderBottomWidth',
            'borderImageOutset',
            'borderImageRepeat',
            'borderImageSlice',
            'borderImageSource',
            'borderImageWidth',
            'borderLeftColor',
            'borderLeftStyle',
            'borderLeftWidth',
            'borderRightColor',
            'borderRightStyle',
            'borderRightWidth',
            'borderTopColor',
            'borderTopStyle',
            'borderTopWidth'
        ],
        borderBlockEnd: [
            'borderBlockEndColor',
            'borderBlockEndStyle',
            'borderBlockEndWidth'
        ],
        borderBlockStart: [
            'borderBlockStartColor',
            'borderBlockStartStyle',
            'borderBlockStartWidth'
        ],
        borderBottom: [
            'borderBottomColor',
            'borderBottomStyle',
            'borderBottomWidth'
        ],
        borderColor: [
            'borderBottomColor',
            'borderLeftColor',
            'borderRightColor',
            'borderTopColor'
        ],
        borderImage: [
            'borderImageOutset',
            'borderImageRepeat',
            'borderImageSlice',
            'borderImageSource',
            'borderImageWidth'
        ],
        borderInlineEnd: [
            'borderInlineEndColor',
            'borderInlineEndStyle',
            'borderInlineEndWidth'
        ],
        borderInlineStart: [
            'borderInlineStartColor',
            'borderInlineStartStyle',
            'borderInlineStartWidth'
        ],
        borderLeft: [
            'borderLeftColor',
            'borderLeftStyle',
            'borderLeftWidth'
        ],
        borderRadius: [
            'borderBottomLeftRadius',
            'borderBottomRightRadius',
            'borderTopLeftRadius',
            'borderTopRightRadius'
        ],
        borderRight: [
            'borderRightColor',
            'borderRightStyle',
            'borderRightWidth'
        ],
        borderStyle: [
            'borderBottomStyle',
            'borderLeftStyle',
            'borderRightStyle',
            'borderTopStyle'
        ],
        borderTop: [
            'borderTopColor',
            'borderTopStyle',
            'borderTopWidth'
        ],
        borderWidth: [
            'borderBottomWidth',
            'borderLeftWidth',
            'borderRightWidth',
            'borderTopWidth'
        ],
        columnRule: [
            'columnRuleColor',
            'columnRuleStyle',
            'columnRuleWidth'
        ],
        columns: [
            'columnCount',
            'columnWidth'
        ],
        flex: [
            'flexBasis',
            'flexGrow',
            'flexShrink'
        ],
        flexFlow: [
            'flexDirection',
            'flexWrap'
        ],
        font: [
            'fontFamily',
            'fontFeatureSettings',
            'fontKerning',
            'fontLanguageOverride',
            'fontSize',
            'fontSizeAdjust',
            'fontStretch',
            'fontStyle',
            'fontVariant',
            'fontVariantAlternates',
            'fontVariantCaps',
            'fontVariantEastAsian',
            'fontVariantLigatures',
            'fontVariantNumeric',
            'fontVariantPosition',
            'fontWeight',
            'lineHeight'
        ],
        fontVariant: [
            'fontVariantAlternates',
            'fontVariantCaps',
            'fontVariantEastAsian',
            'fontVariantLigatures',
            'fontVariantNumeric',
            'fontVariantPosition'
        ],
        gap: [
            'columnGap',
            'rowGap'
        ],
        grid: [
            'gridAutoColumns',
            'gridAutoFlow',
            'gridAutoRows',
            'gridTemplateAreas',
            'gridTemplateColumns',
            'gridTemplateRows'
        ],
        gridArea: [
            'gridColumnEnd',
            'gridColumnStart',
            'gridRowEnd',
            'gridRowStart'
        ],
        gridColumn: [
            'gridColumnEnd',
            'gridColumnStart'
        ],
        gridColumnGap: [
            'columnGap'
        ],
        gridGap: [
            'columnGap',
            'rowGap'
        ],
        gridRow: [
            'gridRowEnd',
            'gridRowStart'
        ],
        gridRowGap: [
            'rowGap'
        ],
        gridTemplate: [
            'gridTemplateAreas',
            'gridTemplateColumns',
            'gridTemplateRows'
        ],
        listStyle: [
            'listStyleImage',
            'listStylePosition',
            'listStyleType'
        ],
        margin: [
            'marginBottom',
            'marginLeft',
            'marginRight',
            'marginTop'
        ],
        marker: [
            'markerEnd',
            'markerMid',
            'markerStart'
        ],
        mask: [
            'maskClip',
            'maskComposite',
            'maskImage',
            'maskMode',
            'maskOrigin',
            'maskPositionX',
            'maskPositionY',
            'maskRepeat',
            'maskSize'
        ],
        maskPosition: [
            'maskPositionX',
            'maskPositionY'
        ],
        outline: [
            'outlineColor',
            'outlineStyle',
            'outlineWidth'
        ],
        overflow: [
            'overflowX',
            'overflowY'
        ],
        padding: [
            'paddingBottom',
            'paddingLeft',
            'paddingRight',
            'paddingTop'
        ],
        placeContent: [
            'alignContent',
            'justifyContent'
        ],
        placeItems: [
            'alignItems',
            'justifyItems'
        ],
        placeSelf: [
            'alignSelf',
            'justifySelf'
        ],
        textDecoration: [
            'textDecorationColor',
            'textDecorationLine',
            'textDecorationStyle'
        ],
        textEmphasis: [
            'textEmphasisColor',
            'textEmphasisStyle'
        ],
        transition: [
            'transitionDelay',
            'transitionDuration',
            'transitionProperty',
            'transitionTimingFunction'
        ],
        wordWrap: [
            'overflowWrap'
        ]
    };
    /**
 * CSS properties which accept numbers but are not in units of "px".
 */ var isUnitlessNumber = {
        animationIterationCount: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related properties
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
    };
    /**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */ function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
    }
    /**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */ var prefixes = [
        'Webkit',
        'ms',
        'Moz',
        'O'
    ]; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
    // infinite loop, because it iterates over the newly added props too.
    Object.keys(isUnitlessNumber).forEach(function(prop) {
        prefixes.forEach(function(prefix) {
            isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
    });
    /**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */ function dangerousStyleValue(name, value, isCustomProperty) {
        // Note that we've removed escapeTextForBrowser() calls here since the
        // whole string will be escaped when the attribute is injected into
        // the markup. If you provide unsafe user data here they can inject
        // arbitrary CSS which may be problematic (I couldn't repro this):
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
        // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
        // This is not an XSS hole but instead a potential CSS injection issue
        // which has lead to a greater discussion about how we're going to
        // trust URLs moving forward. See #2115901
        var isEmpty = value == null || typeof value === 'boolean' || value === '';
        if (isEmpty) return '';
        if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
        return ('' + value).trim();
    }
    var uppercasePattern = /([A-Z])/g;
    var msPattern = /^ms-/;
    /**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */ function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
    }
    var warnValidStyle = function() {};
    // 'msTransform' is correct, but the other prefixes should be capitalized
    var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
    var msPattern$1 = /^-ms-/;
    var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon
    var badStyleValueWithSemicolonPattern = /;\s*$/;
    var warnedStyleNames = {};
    var warnedStyleValues = {};
    var warnedForNaNValue = false;
    var warnedForInfinityValue = false;
    var camelize = function(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    };
    var warnHyphenatedStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error('Unsupported style property %s. Did you mean %s?', name, // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
        // is converted to lowercase `ms`.
        camelize(name.replace(msPattern$1, 'ms-')));
    };
    var warnBadVendoredStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error('Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1));
    };
    var warnStyleValueWithSemicolon = function(name, value) {
        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) return;
        warnedStyleValues[value] = true;
        error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ''));
    };
    var warnStyleValueIsNaN = function(name, value) {
        if (warnedForNaNValue) return;
        warnedForNaNValue = true;
        error('`NaN` is an invalid value for the `%s` css style property.', name);
    };
    var warnStyleValueIsInfinity = function(name, value) {
        if (warnedForInfinityValue) return;
        warnedForInfinityValue = true;
        error('`Infinity` is an invalid value for the `%s` css style property.', name);
    };
    warnValidStyle = function(name, value) {
        if (name.indexOf('-') > -1) warnHyphenatedStyleName(name);
        else if (badVendoredStyleNamePattern.test(name)) warnBadVendoredStyleName(name);
        else if (badStyleValueWithSemicolonPattern.test(value)) warnStyleValueWithSemicolon(name, value);
        if (typeof value === 'number') {
            if (isNaN(value)) warnStyleValueIsNaN(name, value);
            else if (!isFinite(value)) warnStyleValueIsInfinity(name, value);
        }
    };
    var warnValidStyle$1 = warnValidStyle;
    /**
 * Operations for dealing with CSS properties.
 */ /**
 * This creates a string that is expected to be equivalent to the style
 * attribute generated by server-side rendering. It by-passes warnings and
 * security checks so it's not safe to use this value for anything other than
 * comparison. It is only used in DEV for SSR validation.
 */ function createDangerousStringForStyles(styles) {
        var serialized = '';
        var delimiter = '';
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var styleValue = styles[styleName];
            if (styleValue != null) {
                var isCustomProperty = styleName.indexOf('--') === 0;
                serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ':';
                serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
                delimiter = ';';
            }
        }
        return serialized || null;
    }
    /**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */ function setValueForStyles(node, styles) {
        var style = node.style;
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var isCustomProperty = styleName.indexOf('--') === 0;
            if (!isCustomProperty) warnValidStyle$1(styleName, styles[styleName]);
            var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);
            if (styleName === 'float') styleName = 'cssFloat';
            if (isCustomProperty) style.setProperty(styleName, styleValue);
            else style[styleName] = styleValue;
        }
    }
    function isValueEmpty(value) {
        return value == null || typeof value === 'boolean' || value === '';
    }
    /**
 * Given {color: 'red', overflow: 'hidden'} returns {
 *   color: 'color',
 *   overflowX: 'overflow',
 *   overflowY: 'overflow',
 * }. This can be read as "the overflowY property was set by the overflow
 * shorthand". That is, the values are the property that each was derived from.
 */ function expandShorthandMap(styles) {
        var expanded = {};
        for(var key in styles){
            var longhands = shorthandToLonghand[key] || [
                key
            ];
            for(var i = 0; i < longhands.length; i++)expanded[longhands[i]] = key;
        }
        return expanded;
    }
    /**
 * When mixing shorthand and longhand property names, we warn during updates if
 * we expect an incorrect result to occur. In particular, we warn for:
 *
 * Updating a shorthand property (longhand gets overwritten):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'baz', fontVariant: 'bar'}
 *   becomes .style.font = 'baz'
 * Removing a shorthand property (longhand gets lost too):
 *   {font: 'foo', fontVariant: 'bar'} -> {fontVariant: 'bar'}
 *   becomes .style.font = ''
 * Removing a longhand property (should revert to shorthand; doesn't):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'foo'}
 *   becomes .style.fontVariant = ''
 */ function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
        if (!nextStyles) return;
        var expandedUpdates = expandShorthandMap(styleUpdates);
        var expandedStyles = expandShorthandMap(nextStyles);
        var warnedAbout = {};
        for(var key in expandedUpdates){
            var originalKey = expandedUpdates[key];
            var correctOriginalKey = expandedStyles[key];
            if (correctOriginalKey && originalKey !== correctOriginalKey) {
                var warningKey = originalKey + ',' + correctOriginalKey;
                if (warnedAbout[warningKey]) continue;
                warnedAbout[warningKey] = true;
                error("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", isValueEmpty(styleUpdates[originalKey]) ? 'Removing' : 'Updating', originalKey, correctOriginalKey);
            }
        }
    }
    // For HTML, certain tags should omit their close tag. We keep a list for
    // those special-case tags.
    var omittedCloseTags = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.
    };
    // `omittedCloseTags` except that `menuitem` should still have its closing tag.
    var voidElementTags = _assign({
        menuitem: true
    }, omittedCloseTags);
    var HTML = '__html';
    function assertValidProps(tag, props) {
        if (!props) return;
         // Note the use of `==` which checks for null or undefined.
        if (voidElementTags[tag]) {
            if (!(props.children == null && props.dangerouslySetInnerHTML == null)) throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        }
        if (props.dangerouslySetInnerHTML != null) {
            if (!(props.children == null)) throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
            if (!(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML)) throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
        if (!(props.style == null || typeof props.style === 'object')) throw Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
    }
    function isCustomComponent(tagName, props) {
        if (tagName.indexOf('-') === -1) return typeof props.is === 'string';
        switch(tagName){
            // These are reserved SVG and MathML elements.
            // We don't mind this list too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case 'annotation-xml':
            case 'color-profile':
            case 'font-face':
            case 'font-face-src':
            case 'font-face-uri':
            case 'font-face-format':
            case 'font-face-name':
            case 'missing-glyph':
                return false;
            default:
                return true;
        }
    }
    // When adding attributes to the HTML or SVG allowed attribute list, be sure to
    // also add them to this module to ensure casing and incorrect name
    // warnings.
    var possibleStandardNames = {
        // HTML
        accept: 'accept',
        acceptcharset: 'acceptCharset',
        'accept-charset': 'acceptCharset',
        accesskey: 'accessKey',
        action: 'action',
        allowfullscreen: 'allowFullScreen',
        alt: 'alt',
        as: 'as',
        async: 'async',
        autocapitalize: 'autoCapitalize',
        autocomplete: 'autoComplete',
        autocorrect: 'autoCorrect',
        autofocus: 'autoFocus',
        autoplay: 'autoPlay',
        autosave: 'autoSave',
        capture: 'capture',
        cellpadding: 'cellPadding',
        cellspacing: 'cellSpacing',
        challenge: 'challenge',
        charset: 'charSet',
        checked: 'checked',
        children: 'children',
        cite: 'cite',
        class: 'className',
        classid: 'classID',
        classname: 'className',
        cols: 'cols',
        colspan: 'colSpan',
        content: 'content',
        contenteditable: 'contentEditable',
        contextmenu: 'contextMenu',
        controls: 'controls',
        controlslist: 'controlsList',
        coords: 'coords',
        crossorigin: 'crossOrigin',
        dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
        data: 'data',
        datetime: 'dateTime',
        default: 'default',
        defaultchecked: 'defaultChecked',
        defaultvalue: 'defaultValue',
        defer: 'defer',
        dir: 'dir',
        disabled: 'disabled',
        disablepictureinpicture: 'disablePictureInPicture',
        disableremoteplayback: 'disableRemotePlayback',
        download: 'download',
        draggable: 'draggable',
        enctype: 'encType',
        enterkeyhint: 'enterKeyHint',
        for: 'htmlFor',
        form: 'form',
        formmethod: 'formMethod',
        formaction: 'formAction',
        formenctype: 'formEncType',
        formnovalidate: 'formNoValidate',
        formtarget: 'formTarget',
        frameborder: 'frameBorder',
        headers: 'headers',
        height: 'height',
        hidden: 'hidden',
        high: 'high',
        href: 'href',
        hreflang: 'hrefLang',
        htmlfor: 'htmlFor',
        httpequiv: 'httpEquiv',
        'http-equiv': 'httpEquiv',
        icon: 'icon',
        id: 'id',
        innerhtml: 'innerHTML',
        inputmode: 'inputMode',
        integrity: 'integrity',
        is: 'is',
        itemid: 'itemID',
        itemprop: 'itemProp',
        itemref: 'itemRef',
        itemscope: 'itemScope',
        itemtype: 'itemType',
        keyparams: 'keyParams',
        keytype: 'keyType',
        kind: 'kind',
        label: 'label',
        lang: 'lang',
        list: 'list',
        loop: 'loop',
        low: 'low',
        manifest: 'manifest',
        marginwidth: 'marginWidth',
        marginheight: 'marginHeight',
        max: 'max',
        maxlength: 'maxLength',
        media: 'media',
        mediagroup: 'mediaGroup',
        method: 'method',
        min: 'min',
        minlength: 'minLength',
        multiple: 'multiple',
        muted: 'muted',
        name: 'name',
        nomodule: 'noModule',
        nonce: 'nonce',
        novalidate: 'noValidate',
        open: 'open',
        optimum: 'optimum',
        pattern: 'pattern',
        placeholder: 'placeholder',
        playsinline: 'playsInline',
        poster: 'poster',
        preload: 'preload',
        profile: 'profile',
        radiogroup: 'radioGroup',
        readonly: 'readOnly',
        referrerpolicy: 'referrerPolicy',
        rel: 'rel',
        required: 'required',
        reversed: 'reversed',
        role: 'role',
        rows: 'rows',
        rowspan: 'rowSpan',
        sandbox: 'sandbox',
        scope: 'scope',
        scoped: 'scoped',
        scrolling: 'scrolling',
        seamless: 'seamless',
        selected: 'selected',
        shape: 'shape',
        size: 'size',
        sizes: 'sizes',
        span: 'span',
        spellcheck: 'spellCheck',
        src: 'src',
        srcdoc: 'srcDoc',
        srclang: 'srcLang',
        srcset: 'srcSet',
        start: 'start',
        step: 'step',
        style: 'style',
        summary: 'summary',
        tabindex: 'tabIndex',
        target: 'target',
        title: 'title',
        type: 'type',
        usemap: 'useMap',
        value: 'value',
        width: 'width',
        wmode: 'wmode',
        wrap: 'wrap',
        // SVG
        about: 'about',
        accentheight: 'accentHeight',
        'accent-height': 'accentHeight',
        accumulate: 'accumulate',
        additive: 'additive',
        alignmentbaseline: 'alignmentBaseline',
        'alignment-baseline': 'alignmentBaseline',
        allowreorder: 'allowReorder',
        alphabetic: 'alphabetic',
        amplitude: 'amplitude',
        arabicform: 'arabicForm',
        'arabic-form': 'arabicForm',
        ascent: 'ascent',
        attributename: 'attributeName',
        attributetype: 'attributeType',
        autoreverse: 'autoReverse',
        azimuth: 'azimuth',
        basefrequency: 'baseFrequency',
        baselineshift: 'baselineShift',
        'baseline-shift': 'baselineShift',
        baseprofile: 'baseProfile',
        bbox: 'bbox',
        begin: 'begin',
        bias: 'bias',
        by: 'by',
        calcmode: 'calcMode',
        capheight: 'capHeight',
        'cap-height': 'capHeight',
        clip: 'clip',
        clippath: 'clipPath',
        'clip-path': 'clipPath',
        clippathunits: 'clipPathUnits',
        cliprule: 'clipRule',
        'clip-rule': 'clipRule',
        color: 'color',
        colorinterpolation: 'colorInterpolation',
        'color-interpolation': 'colorInterpolation',
        colorinterpolationfilters: 'colorInterpolationFilters',
        'color-interpolation-filters': 'colorInterpolationFilters',
        colorprofile: 'colorProfile',
        'color-profile': 'colorProfile',
        colorrendering: 'colorRendering',
        'color-rendering': 'colorRendering',
        contentscripttype: 'contentScriptType',
        contentstyletype: 'contentStyleType',
        cursor: 'cursor',
        cx: 'cx',
        cy: 'cy',
        d: 'd',
        datatype: 'datatype',
        decelerate: 'decelerate',
        descent: 'descent',
        diffuseconstant: 'diffuseConstant',
        direction: 'direction',
        display: 'display',
        divisor: 'divisor',
        dominantbaseline: 'dominantBaseline',
        'dominant-baseline': 'dominantBaseline',
        dur: 'dur',
        dx: 'dx',
        dy: 'dy',
        edgemode: 'edgeMode',
        elevation: 'elevation',
        enablebackground: 'enableBackground',
        'enable-background': 'enableBackground',
        end: 'end',
        exponent: 'exponent',
        externalresourcesrequired: 'externalResourcesRequired',
        fill: 'fill',
        fillopacity: 'fillOpacity',
        'fill-opacity': 'fillOpacity',
        fillrule: 'fillRule',
        'fill-rule': 'fillRule',
        filter: 'filter',
        filterres: 'filterRes',
        filterunits: 'filterUnits',
        floodopacity: 'floodOpacity',
        'flood-opacity': 'floodOpacity',
        floodcolor: 'floodColor',
        'flood-color': 'floodColor',
        focusable: 'focusable',
        fontfamily: 'fontFamily',
        'font-family': 'fontFamily',
        fontsize: 'fontSize',
        'font-size': 'fontSize',
        fontsizeadjust: 'fontSizeAdjust',
        'font-size-adjust': 'fontSizeAdjust',
        fontstretch: 'fontStretch',
        'font-stretch': 'fontStretch',
        fontstyle: 'fontStyle',
        'font-style': 'fontStyle',
        fontvariant: 'fontVariant',
        'font-variant': 'fontVariant',
        fontweight: 'fontWeight',
        'font-weight': 'fontWeight',
        format: 'format',
        from: 'from',
        fx: 'fx',
        fy: 'fy',
        g1: 'g1',
        g2: 'g2',
        glyphname: 'glyphName',
        'glyph-name': 'glyphName',
        glyphorientationhorizontal: 'glyphOrientationHorizontal',
        'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
        glyphorientationvertical: 'glyphOrientationVertical',
        'glyph-orientation-vertical': 'glyphOrientationVertical',
        glyphref: 'glyphRef',
        gradienttransform: 'gradientTransform',
        gradientunits: 'gradientUnits',
        hanging: 'hanging',
        horizadvx: 'horizAdvX',
        'horiz-adv-x': 'horizAdvX',
        horizoriginx: 'horizOriginX',
        'horiz-origin-x': 'horizOriginX',
        ideographic: 'ideographic',
        imagerendering: 'imageRendering',
        'image-rendering': 'imageRendering',
        in2: 'in2',
        in: 'in',
        inlist: 'inlist',
        intercept: 'intercept',
        k1: 'k1',
        k2: 'k2',
        k3: 'k3',
        k4: 'k4',
        k: 'k',
        kernelmatrix: 'kernelMatrix',
        kernelunitlength: 'kernelUnitLength',
        kerning: 'kerning',
        keypoints: 'keyPoints',
        keysplines: 'keySplines',
        keytimes: 'keyTimes',
        lengthadjust: 'lengthAdjust',
        letterspacing: 'letterSpacing',
        'letter-spacing': 'letterSpacing',
        lightingcolor: 'lightingColor',
        'lighting-color': 'lightingColor',
        limitingconeangle: 'limitingConeAngle',
        local: 'local',
        markerend: 'markerEnd',
        'marker-end': 'markerEnd',
        markerheight: 'markerHeight',
        markermid: 'markerMid',
        'marker-mid': 'markerMid',
        markerstart: 'markerStart',
        'marker-start': 'markerStart',
        markerunits: 'markerUnits',
        markerwidth: 'markerWidth',
        mask: 'mask',
        maskcontentunits: 'maskContentUnits',
        maskunits: 'maskUnits',
        mathematical: 'mathematical',
        mode: 'mode',
        numoctaves: 'numOctaves',
        offset: 'offset',
        opacity: 'opacity',
        operator: 'operator',
        order: 'order',
        orient: 'orient',
        orientation: 'orientation',
        origin: 'origin',
        overflow: 'overflow',
        overlineposition: 'overlinePosition',
        'overline-position': 'overlinePosition',
        overlinethickness: 'overlineThickness',
        'overline-thickness': 'overlineThickness',
        paintorder: 'paintOrder',
        'paint-order': 'paintOrder',
        panose1: 'panose1',
        'panose-1': 'panose1',
        pathlength: 'pathLength',
        patterncontentunits: 'patternContentUnits',
        patterntransform: 'patternTransform',
        patternunits: 'patternUnits',
        pointerevents: 'pointerEvents',
        'pointer-events': 'pointerEvents',
        points: 'points',
        pointsatx: 'pointsAtX',
        pointsaty: 'pointsAtY',
        pointsatz: 'pointsAtZ',
        prefix: 'prefix',
        preservealpha: 'preserveAlpha',
        preserveaspectratio: 'preserveAspectRatio',
        primitiveunits: 'primitiveUnits',
        property: 'property',
        r: 'r',
        radius: 'radius',
        refx: 'refX',
        refy: 'refY',
        renderingintent: 'renderingIntent',
        'rendering-intent': 'renderingIntent',
        repeatcount: 'repeatCount',
        repeatdur: 'repeatDur',
        requiredextensions: 'requiredExtensions',
        requiredfeatures: 'requiredFeatures',
        resource: 'resource',
        restart: 'restart',
        result: 'result',
        results: 'results',
        rotate: 'rotate',
        rx: 'rx',
        ry: 'ry',
        scale: 'scale',
        security: 'security',
        seed: 'seed',
        shaperendering: 'shapeRendering',
        'shape-rendering': 'shapeRendering',
        slope: 'slope',
        spacing: 'spacing',
        specularconstant: 'specularConstant',
        specularexponent: 'specularExponent',
        speed: 'speed',
        spreadmethod: 'spreadMethod',
        startoffset: 'startOffset',
        stddeviation: 'stdDeviation',
        stemh: 'stemh',
        stemv: 'stemv',
        stitchtiles: 'stitchTiles',
        stopcolor: 'stopColor',
        'stop-color': 'stopColor',
        stopopacity: 'stopOpacity',
        'stop-opacity': 'stopOpacity',
        strikethroughposition: 'strikethroughPosition',
        'strikethrough-position': 'strikethroughPosition',
        strikethroughthickness: 'strikethroughThickness',
        'strikethrough-thickness': 'strikethroughThickness',
        string: 'string',
        stroke: 'stroke',
        strokedasharray: 'strokeDasharray',
        'stroke-dasharray': 'strokeDasharray',
        strokedashoffset: 'strokeDashoffset',
        'stroke-dashoffset': 'strokeDashoffset',
        strokelinecap: 'strokeLinecap',
        'stroke-linecap': 'strokeLinecap',
        strokelinejoin: 'strokeLinejoin',
        'stroke-linejoin': 'strokeLinejoin',
        strokemiterlimit: 'strokeMiterlimit',
        'stroke-miterlimit': 'strokeMiterlimit',
        strokewidth: 'strokeWidth',
        'stroke-width': 'strokeWidth',
        strokeopacity: 'strokeOpacity',
        'stroke-opacity': 'strokeOpacity',
        suppresscontenteditablewarning: 'suppressContentEditableWarning',
        suppresshydrationwarning: 'suppressHydrationWarning',
        surfacescale: 'surfaceScale',
        systemlanguage: 'systemLanguage',
        tablevalues: 'tableValues',
        targetx: 'targetX',
        targety: 'targetY',
        textanchor: 'textAnchor',
        'text-anchor': 'textAnchor',
        textdecoration: 'textDecoration',
        'text-decoration': 'textDecoration',
        textlength: 'textLength',
        textrendering: 'textRendering',
        'text-rendering': 'textRendering',
        to: 'to',
        transform: 'transform',
        typeof: 'typeof',
        u1: 'u1',
        u2: 'u2',
        underlineposition: 'underlinePosition',
        'underline-position': 'underlinePosition',
        underlinethickness: 'underlineThickness',
        'underline-thickness': 'underlineThickness',
        unicode: 'unicode',
        unicodebidi: 'unicodeBidi',
        'unicode-bidi': 'unicodeBidi',
        unicoderange: 'unicodeRange',
        'unicode-range': 'unicodeRange',
        unitsperem: 'unitsPerEm',
        'units-per-em': 'unitsPerEm',
        unselectable: 'unselectable',
        valphabetic: 'vAlphabetic',
        'v-alphabetic': 'vAlphabetic',
        values: 'values',
        vectoreffect: 'vectorEffect',
        'vector-effect': 'vectorEffect',
        version: 'version',
        vertadvy: 'vertAdvY',
        'vert-adv-y': 'vertAdvY',
        vertoriginx: 'vertOriginX',
        'vert-origin-x': 'vertOriginX',
        vertoriginy: 'vertOriginY',
        'vert-origin-y': 'vertOriginY',
        vhanging: 'vHanging',
        'v-hanging': 'vHanging',
        videographic: 'vIdeographic',
        'v-ideographic': 'vIdeographic',
        viewbox: 'viewBox',
        viewtarget: 'viewTarget',
        visibility: 'visibility',
        vmathematical: 'vMathematical',
        'v-mathematical': 'vMathematical',
        vocab: 'vocab',
        widths: 'widths',
        wordspacing: 'wordSpacing',
        'word-spacing': 'wordSpacing',
        writingmode: 'writingMode',
        'writing-mode': 'writingMode',
        x1: 'x1',
        x2: 'x2',
        x: 'x',
        xchannelselector: 'xChannelSelector',
        xheight: 'xHeight',
        'x-height': 'xHeight',
        xlinkactuate: 'xlinkActuate',
        'xlink:actuate': 'xlinkActuate',
        xlinkarcrole: 'xlinkArcrole',
        'xlink:arcrole': 'xlinkArcrole',
        xlinkhref: 'xlinkHref',
        'xlink:href': 'xlinkHref',
        xlinkrole: 'xlinkRole',
        'xlink:role': 'xlinkRole',
        xlinkshow: 'xlinkShow',
        'xlink:show': 'xlinkShow',
        xlinktitle: 'xlinkTitle',
        'xlink:title': 'xlinkTitle',
        xlinktype: 'xlinkType',
        'xlink:type': 'xlinkType',
        xmlbase: 'xmlBase',
        'xml:base': 'xmlBase',
        xmllang: 'xmlLang',
        'xml:lang': 'xmlLang',
        xmlns: 'xmlns',
        'xml:space': 'xmlSpace',
        xmlnsxlink: 'xmlnsXlink',
        'xmlns:xlink': 'xmlnsXlink',
        xmlspace: 'xmlSpace',
        y1: 'y1',
        y2: 'y2',
        y: 'y',
        ychannelselector: 'yChannelSelector',
        z: 'z',
        zoomandpan: 'zoomAndPan'
    };
    var ariaProperties = {
        'aria-current': 0,
        // state
        'aria-details': 0,
        'aria-disabled': 0,
        // state
        'aria-hidden': 0,
        // state
        'aria-invalid': 0,
        // state
        'aria-keyshortcuts': 0,
        'aria-label': 0,
        'aria-roledescription': 0,
        // Widget Attributes
        'aria-autocomplete': 0,
        'aria-checked': 0,
        'aria-expanded': 0,
        'aria-haspopup': 0,
        'aria-level': 0,
        'aria-modal': 0,
        'aria-multiline': 0,
        'aria-multiselectable': 0,
        'aria-orientation': 0,
        'aria-placeholder': 0,
        'aria-pressed': 0,
        'aria-readonly': 0,
        'aria-required': 0,
        'aria-selected': 0,
        'aria-sort': 0,
        'aria-valuemax': 0,
        'aria-valuemin': 0,
        'aria-valuenow': 0,
        'aria-valuetext': 0,
        // Live Region Attributes
        'aria-atomic': 0,
        'aria-busy': 0,
        'aria-live': 0,
        'aria-relevant': 0,
        // Drag-and-Drop Attributes
        'aria-dropeffect': 0,
        'aria-grabbed': 0,
        // Relationship Attributes
        'aria-activedescendant': 0,
        'aria-colcount': 0,
        'aria-colindex': 0,
        'aria-colspan': 0,
        'aria-controls': 0,
        'aria-describedby': 0,
        'aria-errormessage': 0,
        'aria-flowto': 0,
        'aria-labelledby': 0,
        'aria-owns': 0,
        'aria-posinset': 0,
        'aria-rowcount': 0,
        'aria-rowindex': 0,
        'aria-rowspan': 0,
        'aria-setsize': 0
    };
    var warnedProperties = {};
    var rARIA = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
    var rARIACamel = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
    var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
    function validateProperty(tagName, name) {
        if (hasOwnProperty$1.call(warnedProperties, name) && warnedProperties[name]) return true;
        if (rARIACamel.test(name)) {
            var ariaName = 'aria-' + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (correctName == null) {
                error('Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.', name);
                warnedProperties[name] = true;
                return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== correctName) {
                error('Invalid ARIA attribute `%s`. Did you mean `%s`?', name, correctName);
                warnedProperties[name] = true;
                return true;
            }
        }
        if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (standardName == null) {
                warnedProperties[name] = true;
                return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== standardName) {
                error('Unknown ARIA attribute `%s`. Did you mean `%s`?', name, standardName);
                warnedProperties[name] = true;
                return true;
            }
        }
        return true;
    }
    function warnInvalidARIAProps(type, props) {
        var invalidProps = [];
        for(var key in props){
            var isValid = validateProperty(type, key);
            if (!isValid) invalidProps.push(key);
        }
        var unknownPropString = invalidProps.map(function(prop) {
            return '`' + prop + '`';
        }).join(', ');
        if (invalidProps.length === 1) error("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
        else if (invalidProps.length > 1) error("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
    }
    function validateProperties(type, props) {
        if (isCustomComponent(type, props)) return;
        warnInvalidARIAProps(type, props);
    }
    var didWarnValueNull = false;
    function validateProperties$1(type, props) {
        if (type !== 'input' && type !== 'textarea' && type !== 'select') return;
        if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;
            if (type === 'select' && props.multiple) error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
            else error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
        }
    }
    var validateProperty$1 = function() {};
    var warnedProperties$1 = {};
    var _hasOwnProperty = Object.prototype.hasOwnProperty;
    var EVENT_NAME_REGEX = /^on./;
    var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
    var rARIA$1 = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
    var rARIACamel$1 = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
    validateProperty$1 = function(tagName, name, value, eventRegistry) {
        if (_hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return true;
        var lowerCasedName = name.toLowerCase();
        if (lowerCasedName === 'onfocusin' || lowerCasedName === 'onfocusout') {
            error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
            warnedProperties$1[name] = true;
            return true;
        } // We can't rely on the event system being injected on the server.
        if (eventRegistry != null) {
            var registrationNameDependencies = eventRegistry.registrationNameDependencies, possibleRegistrationNames = eventRegistry.possibleRegistrationNames;
            if (registrationNameDependencies.hasOwnProperty(name)) return true;
            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
            if (registrationName != null) {
                error('Invalid event handler property `%s`. Did you mean `%s`?', name, registrationName);
                warnedProperties$1[name] = true;
                return true;
            }
            if (EVENT_NAME_REGEX.test(name)) {
                error('Unknown event handler property `%s`. It will be ignored.', name);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (EVENT_NAME_REGEX.test(name)) {
            // If no event plugins have been injected, we are in a server environment.
            // So we can't tell if the event name is correct for sure, but we can filter
            // out known bad ones like `onclick`. We can't suggest a specific replacement though.
            if (INVALID_EVENT_NAME_REGEX.test(name)) error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
            warnedProperties$1[name] = true;
            return true;
        } // Let the ARIA attribute hook validate ARIA attributes
        if (rARIA$1.test(name) || rARIACamel$1.test(name)) return true;
        if (lowerCasedName === 'innerhtml') {
            error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === 'aria') {
            error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === 'is' && value !== null && value !== undefined && typeof value !== 'string') {
            error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === 'number' && isNaN(value)) {
            error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
            warnedProperties$1[name] = true;
            return true;
        }
        var propertyInfo = getPropertyInfo(name);
        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];
            if (standardName !== name) {
                error('Invalid DOM property `%s`. Did you mean `%s`?', name, standardName);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (!isReserved && name !== lowerCasedName) {
            // Unknown attributes should have lowercase casing since that's how they
            // will be cased anyway with server rendering.
            error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === 'boolean' && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
            else error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            warnedProperties$1[name] = true;
            return true;
        } // Now that we've validated casing, do not validate
        // data types for reserved props
        if (isReserved) return true;
         // Warn when a known attribute is a bad type
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
        } // Warn when passing the strings 'false' or 'true' into a boolean prop
        if ((value === 'false' || value === 'true') && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === 'false' ? 'The browser will interpret it as a truthy value.' : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
        }
        return true;
    };
    var warnUnknownProperties = function(type, props, eventRegistry) {
        var unknownProps = [];
        for(var key in props){
            var isValid = validateProperty$1(type, key, props[key], eventRegistry);
            if (!isValid) unknownProps.push(key);
        }
        var unknownPropString = unknownProps.map(function(prop) {
            return '`' + prop + '`';
        }).join(', ');
        if (unknownProps.length === 1) error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
        else if (unknownProps.length > 1) error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
    };
    function validateProperties$2(type, props, eventRegistry) {
        if (isCustomComponent(type, props)) return;
        warnUnknownProperties(type, props, eventRegistry);
    }
    var IS_EVENT_HANDLE_NON_MANAGED_NODE = 1;
    var IS_NON_DELEGATED = 2;
    var IS_CAPTURE_PHASE = 4;
    var IS_REPLAYED = 16;
    // set to LEGACY_FB_SUPPORT. LEGACY_FB_SUPPORT only gets set when
    // we call willDeferLaterForLegacyFBSupport, thus not bailing out
    // will result in endless cycles like an infinite loop.
    // We also don't want to defer during event replaying.
    var SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS = IS_EVENT_HANDLE_NON_MANAGED_NODE | IS_NON_DELEGATED | IS_CAPTURE_PHASE;
    /**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */ function getEventTarget(nativeEvent) {
        // Fallback to nativeEvent.srcElement for IE9
        // https://github.com/facebook/react/issues/12506
        var target = nativeEvent.target || nativeEvent.srcElement || window; // Normalize SVG <use> element events #4963
        if (target.correspondingUseElement) target = target.correspondingUseElement;
         // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
        // @see http://www.quirksmode.org/js/events_properties.html
        return target.nodeType === TEXT_NODE ? target.parentNode : target;
    }
    var restoreImpl = null;
    var restoreTarget = null;
    var restoreQueue = null;
    function restoreStateOfTarget(target) {
        // We perform this translation at the end of the event loop so that we
        // always receive the correct fiber here
        var internalInstance = getInstanceFromNode(target);
        if (!internalInstance) // Unmounted
        return;
        if (!(typeof restoreImpl === 'function')) throw Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var stateNode = internalInstance.stateNode; // Guard against Fiber being unmounted.
        if (stateNode) {
            var _props = getFiberCurrentPropsFromNode(stateNode);
            restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
        }
    }
    function setRestoreImplementation(impl) {
        restoreImpl = impl;
    }
    function enqueueStateRestore(target) {
        if (restoreTarget) {
            if (restoreQueue) restoreQueue.push(target);
            else restoreQueue = [
                target
            ];
        } else restoreTarget = target;
    }
    function needsStateRestore() {
        return restoreTarget !== null || restoreQueue !== null;
    }
    function restoreStateIfNeeded() {
        if (!restoreTarget) return;
        var target = restoreTarget;
        var queuedTargets = restoreQueue;
        restoreTarget = null;
        restoreQueue = null;
        restoreStateOfTarget(target);
        if (queuedTargets) for(var i = 0; i < queuedTargets.length; i++)restoreStateOfTarget(queuedTargets[i]);
    }
    // the renderer. Such as when we're dispatching events or if third party
    // libraries need to call batchedUpdates. Eventually, this API will go away when
    // everything is batched by default. We'll then have a similar API to opt-out of
    // scheduled work and instead do synchronous work.
    // Defaults
    var batchedUpdatesImpl = function(fn, bookkeeping) {
        return fn(bookkeeping);
    };
    var discreteUpdatesImpl = function(fn, a, b, c, d) {
        return fn(a, b, c, d);
    };
    var flushDiscreteUpdatesImpl = function() {};
    var batchedEventUpdatesImpl = batchedUpdatesImpl;
    var isInsideEventHandler = false;
    var isBatchingEventUpdates = false;
    function finishEventHandler() {
        // Here we wait until all updates have propagated, which is important
        // when using controlled components within layers:
        // https://github.com/facebook/react/issues/1698
        // Then we restore state of any controlled component.
        var controlledComponentsHavePendingUpdates = needsStateRestore();
        if (controlledComponentsHavePendingUpdates) {
            // If a controlled event was fired, we may need to restore the state of
            // the DOM node back to the controlled value. This is necessary when React
            // bails out of the update without touching the DOM.
            flushDiscreteUpdatesImpl();
            restoreStateIfNeeded();
        }
    }
    function batchedUpdates(fn, bookkeeping) {
        if (isInsideEventHandler) // If we are currently inside another batch, we need to wait until it
        // fully completes before restoring state.
        return fn(bookkeeping);
        isInsideEventHandler = true;
        try {
            return batchedUpdatesImpl(fn, bookkeeping);
        } finally{
            isInsideEventHandler = false;
            finishEventHandler();
        }
    }
    function batchedEventUpdates(fn, a, b) {
        if (isBatchingEventUpdates) // If we are currently inside another batch, we need to wait until it
        // fully completes before restoring state.
        return fn(a, b);
        isBatchingEventUpdates = true;
        try {
            return batchedEventUpdatesImpl(fn, a, b);
        } finally{
            isBatchingEventUpdates = false;
            finishEventHandler();
        }
    }
    function discreteUpdates(fn, a, b, c, d) {
        var prevIsInsideEventHandler = isInsideEventHandler;
        isInsideEventHandler = true;
        try {
            return discreteUpdatesImpl(fn, a, b, c, d);
        } finally{
            isInsideEventHandler = prevIsInsideEventHandler;
            if (!isInsideEventHandler) finishEventHandler();
        }
    }
    function flushDiscreteUpdatesIfNeeded(timeStamp) {
        if (!isInsideEventHandler) flushDiscreteUpdatesImpl();
    }
    function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushDiscreteUpdatesImpl, _batchedEventUpdatesImpl) {
        batchedUpdatesImpl = _batchedUpdatesImpl;
        discreteUpdatesImpl = _discreteUpdatesImpl;
        flushDiscreteUpdatesImpl = _flushDiscreteUpdatesImpl;
        batchedEventUpdatesImpl = _batchedEventUpdatesImpl;
    }
    function isInteractive(tag) {
        return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
    }
    function shouldPreventMouseEvent(name, type, props) {
        switch(name){
            case 'onClick':
            case 'onClickCapture':
            case 'onDoubleClick':
            case 'onDoubleClickCapture':
            case 'onMouseDown':
            case 'onMouseDownCapture':
            case 'onMouseMove':
            case 'onMouseMoveCapture':
            case 'onMouseUp':
            case 'onMouseUpCapture':
            case 'onMouseEnter':
                return !!(props.disabled && isInteractive(type));
            default:
                return false;
        }
    }
    /**
 * @param {object} inst The instance, which is the source of events.
 * @param {string} registrationName Name of listener (e.g. `onClick`).
 * @return {?function} The stored callback.
 */ function getListener(inst, registrationName) {
        var stateNode = inst.stateNode;
        if (stateNode === null) // Work in progress (ex: onload events in incremental mode).
        return null;
        var props = getFiberCurrentPropsFromNode(stateNode);
        if (props === null) // Work in progress.
        return null;
        var listener = props[registrationName];
        if (shouldPreventMouseEvent(registrationName, inst.type, props)) return null;
        if (!(!listener || typeof listener === 'function')) throw Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
        return listener;
    }
    var passiveBrowserEventsSupported = false; // Check if browser support events with passive listeners
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
    if (canUseDOM) try {
        var options = {}; // $FlowFixMe: Ignore Flow complaining about needing a value
        Object.defineProperty(options, 'passive', {
            get: function() {
                passiveBrowserEventsSupported = true;
            }
        });
        window.addEventListener('test', options, options);
        window.removeEventListener('test', options, options);
    } catch (e) {
        passiveBrowserEventsSupported = false;
    }
    function invokeGuardedCallbackProd(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);
        try {
            func.apply(context, funcArgs);
        } catch (error) {
            this.onError(error);
        }
    }
    var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
    // In DEV mode, we swap out invokeGuardedCallback for a special version
    // that plays more nicely with the browser's DevTools. The idea is to preserve
    // "Pause on exceptions" behavior. Because React wraps all user-provided
    // functions in invokeGuardedCallback, and the production version of
    // invokeGuardedCallback uses a try-catch, all user exceptions are treated
    // like caught exceptions, and the DevTools won't pause unless the developer
    // takes the extra step of enabling pause on caught exceptions. This is
    // unintuitive, though, because even though React has caught the error, from
    // the developer's perspective, the error is uncaught.
    //
    // To preserve the expected "Pause on exceptions" behavior, we don't use a
    // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
    // DOM node, and call the user-provided callback from inside an event handler
    // for that fake event. If the callback throws, the error is "captured" using
    // a global event handler. But because the error happens in a different
    // event loop context, it does not interrupt the normal program flow.
    // Effectively, this gives us try-catch behavior without actually using
    // try-catch. Neat!
    // Check that the browser supports the APIs we need to implement our special
    // DEV version of invokeGuardedCallback
    if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
        var fakeNode = document.createElement('react');
        invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
            // If document doesn't exist we know for sure we will crash in this method
            // when we call document.createEvent(). However this can cause confusing
            // errors: https://github.com/facebookincubator/create-react-app/issues/3482
            // So we preemptively throw with a better message instead.
            if (!(typeof document !== 'undefined')) throw Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
            var evt = document.createEvent('Event');
            var didCall = false; // Keeps track of whether the user-provided callback threw an error. We
            // set this to true at the beginning, then set it to false right after
            // calling the function. If the function errors, `didError` will never be
            // set to false. This strategy works even if the browser is flaky and
            // fails to call our global error handler, because it doesn't rely on
            // the error event at all.
            var didError = true; // Keeps track of the value of window.event so that we can reset it
            // during the callback to let user code access window.event in the
            // browsers that support it.
            var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
            // dispatching: https://github.com/facebook/react/issues/13688
            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, 'event');
            function restoreAfterDispatch() {
                // We immediately remove the callback from event listeners so that
                // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
                // nested call would trigger the fake event handlers of any call higher
                // in the stack.
                fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
                // window.event assignment in both IE <= 10 as they throw an error
                // "Member not found" in strict mode, and in Firefox which does not
                // support window.event.
                if (typeof window.event !== 'undefined' && window.hasOwnProperty('event')) window.event = windowEvent;
            } // Create an event handler for our fake event. We will synchronously
            // dispatch our fake event using `dispatchEvent`. Inside the handler, we
            // call the user-provided callback.
            var funcArgs = Array.prototype.slice.call(arguments, 3);
            function callCallback() {
                didCall = true;
                restoreAfterDispatch();
                func.apply(context, funcArgs);
                didError = false;
            } // Create a global error event handler. We use this to capture the value
            // that was thrown. It's possible that this error handler will fire more
            // than once; for example, if non-React code also calls `dispatchEvent`
            // and a handler for that event throws. We should be resilient to most of
            // those cases. Even if our error event handler fires more than once, the
            // last error event is always used. If the callback actually does error,
            // we know that the last error event is the correct one, because it's not
            // possible for anything else to have happened in between our callback
            // erroring and the code that follows the `dispatchEvent` call below. If
            // the callback doesn't error, but the error event was fired, we know to
            // ignore it because `didError` will be false, as described above.
            var error; // Use this to track whether the error event is ever called.
            var didSetError = false;
            var isCrossOriginError = false;
            function handleWindowError(event) {
                error = event.error;
                didSetError = true;
                if (error === null && event.colno === 0 && event.lineno === 0) isCrossOriginError = true;
                if (event.defaultPrevented) {
                    // Some other error handler has prevented default.
                    // Browsers silence the error report if this happens.
                    // We'll remember this to later decide whether to log it or not.
                    if (error != null && typeof error === 'object') try {
                        error._suppressLogging = true;
                    } catch (inner) {}
                }
            } // Create a fake event type.
            var evtType = "react-" + (name ? name : 'invokeguardedcallback'); // Attach our event handlers
            window.addEventListener('error', handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
            // errors, it will trigger our global error handler.
            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);
            if (windowEventDescriptor) Object.defineProperty(window, 'event', windowEventDescriptor);
            if (didCall && didError) {
                if (!didSetError) // The callback errored, but the error event never fired.
                error = new Error("An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the \"Pause on exceptions\" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.");
                else if (isCrossOriginError) error = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.");
                this.onError(error);
            } // Remove our event listeners
            window.removeEventListener('error', handleWindowError);
            if (!didCall) {
                // Something went really wrong, and our event was not dispatched.
                // https://github.com/facebook/react/issues/16734
                // https://github.com/facebook/react/issues/16585
                // Fall back to the production implementation.
                restoreAfterDispatch();
                return invokeGuardedCallbackProd.apply(this, arguments);
            }
        };
    }
    var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
    var hasError = false;
    var caughtError = null; // Used by event system to capture/rethrow the first error.
    var hasRethrowError = false;
    var rethrowError = null;
    var reporter = {
        onError: function(error) {
            hasError = true;
            caughtError = error;
        }
    };
    /**
 * Call a function while guarding against errors that happens within it.
 * Returns an error if it throws, otherwise null.
 *
 * In production, this is implemented using a try-catch. The reason we don't
 * use a try-catch directly is so that we can swap out a different
 * implementation in DEV mode.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
    }
    /**
 * Same as invokeGuardedCallback, but instead of returning an error, it stores
 * it in a global so it can be rethrown by `rethrowCaughtError` later.
 * TODO: See if caughtError and rethrowError can be unified.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
        invokeGuardedCallback.apply(this, arguments);
        if (hasError) {
            var error = clearCaughtError();
            if (!hasRethrowError) {
                hasRethrowError = true;
                rethrowError = error;
            }
        }
    }
    /**
 * During execution of guarded functions we will capture the first error which
 * we will rethrow to be handled by the top level error handler.
 */ function rethrowCaughtError() {
        if (hasRethrowError) {
            var error = rethrowError;
            hasRethrowError = false;
            rethrowError = null;
            throw error;
        }
    }
    function hasCaughtError() {
        return hasError;
    }
    function clearCaughtError() {
        if (hasError) {
            var error = caughtError;
            hasError = false;
            caughtError = null;
            return error;
        } else throw Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    /**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 *
 * Note that this module is currently shared and assumed to be stateless.
 * If this becomes an actual Map, that will break.
 */ function get(key) {
        return key._reactInternals;
    }
    function has(key) {
        return key._reactInternals !== undefined;
    }
    function set(key, value) {
        key._reactInternals = value;
    }
    // Don't change these two values. They're used by React Dev Tools.
    var NoFlags = /*                      */ 0;
    var PerformedWork = /*                */ 1; // You can change the rest (and add more).
    var Placement = /*                    */ 2;
    var Update = /*                       */ 4;
    var PlacementAndUpdate = /*           */ 6;
    var Deletion = /*                     */ 8;
    var ContentReset = /*                 */ 16;
    var Callback = /*                     */ 32;
    var DidCapture = /*                   */ 64;
    var Ref = /*                          */ 128;
    var Snapshot = /*                     */ 256;
    var Passive = /*                      */ 512; // TODO (effects) Remove this bit once the new reconciler is synced to the old.
    var PassiveUnmountPendingDev = /*     */ 8192;
    var Hydrating = /*                    */ 1024;
    var HydratingAndUpdate = /*           */ 1028; // Passive & Update & Callback & Ref & Snapshot
    var LifecycleEffectMask = /*          */ 932; // Union of all host effects
    var HostEffectMask = /*               */ 2047; // These are not really side effects, but we still reuse this field.
    var Incomplete = /*                   */ 2048;
    var ShouldCapture = /*                */ 4096;
    var ForceUpdateForLegacySuspense = /* */ 16384; // Static tags describe aspects of a fiber that are not specific to a render,
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;
        if (!fiber.alternate) {
            // If there is no alternate, this might be a new tree that isn't inserted
            // yet. If it is, then it will have a pending insertion effect on it.
            var nextNode = node;
            do {
                node = nextNode;
                if ((node.flags & (Placement | Hydrating)) !== NoFlags) // This is an insertion or in-progress hydration. The nearest possible
                // mounted fiber is the parent but we need to continue to figure out
                // if that one is still mounted.
                nearestMounted = node.return;
                nextNode = node.return;
            }while (nextNode);
        } else while(node.return)node = node.return;
        if (node.tag === HostRoot) // TODO: Check if this was a nested HostRoot when used with
        // renderContainerIntoSubtree.
        return nearestMounted;
         // If we didn't hit the root, that means that we're in an disconnected tree
        // that has been unmounted.
        return null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
        if (fiber.tag === SuspenseComponent) {
            var suspenseState = fiber.memoizedState;
            if (suspenseState === null) {
                var current = fiber.alternate;
                if (current !== null) suspenseState = current.memoizedState;
            }
            if (suspenseState !== null) return suspenseState.dehydrated;
        }
        return null;
    }
    function getContainerFromFiber(fiber) {
        return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
    }
    function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
    }
    function isMounted(component) {
        var owner = ReactCurrentOwner.current;
        if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;
            if (!instance._warnedAboutRefsInRender) error("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentName(ownerFiber.type) || 'A component');
            instance._warnedAboutRefsInRender = true;
        }
        var fiber = get(component);
        if (!fiber) return false;
        return getNearestMountedFiber(fiber) === fiber;
    }
    function assertIsMounted(fiber) {
        if (!(getNearestMountedFiber(fiber) === fiber)) throw Error("Unable to find node on an unmounted component.");
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            // If there is no alternate, then we only need to check if it is mounted.
            var nearestMounted = getNearestMountedFiber(fiber);
            if (!(nearestMounted !== null)) throw Error("Unable to find node on an unmounted component.");
            if (nearestMounted !== fiber) return null;
            return fiber;
        } // If we have two possible branches, we'll walk backwards up to the root
        // to see what path the root points to. On the way we may hit one of the
        // special cases and we'll deal with them.
        var a = fiber;
        var b = alternate;
        while(true){
            var parentA = a.return;
            if (parentA === null) break;
            var parentB = parentA.alternate;
            if (parentB === null) {
                // There is no alternate. This is an unusual case. Currently, it only
                // happens when a Suspense component is hidden. An extra fragment fiber
                // is inserted in between the Suspense fiber and its children. Skip
                // over this extra fragment fiber and proceed to the next parent.
                var nextParent = parentA.return;
                if (nextParent !== null) {
                    a = b = nextParent;
                    continue;
                } // If there's no parent, we're at the root.
                break;
            } // If both copies of the parent fiber point to the same child, we can
            // assume that the child is current. This happens when we bailout on low
            // priority: the bailed out fiber's child reuses the current child.
            if (parentA.child === parentB.child) {
                var child = parentA.child;
                while(child){
                    if (child === a) {
                        // We've determined that A is the current branch.
                        assertIsMounted(parentA);
                        return fiber;
                    }
                    if (child === b) {
                        // We've determined that B is the current branch.
                        assertIsMounted(parentA);
                        return alternate;
                    }
                    child = child.sibling;
                } // We should never have an alternate for any mounting node. So the only
                throw Error("Unable to find node on an unmounted component.");
            }
            if (a.return !== b.return) {
                // The return pointer of A and the return pointer of B point to different
                // fibers. We assume that return pointers never criss-cross, so A must
                // belong to the child set of A.return, and B must belong to the child
                // set of B.return.
                a = parentA;
                b = parentB;
            } else {
                // The return pointers point to the same fiber. We'll have to use the
                // default, slow path: scan the child sets of each parent alternate to see
                // which child belongs to which set.
                //
                // Search parent A's child set
                var didFindChild = false;
                var _child = parentA.child;
                while(_child){
                    if (_child === a) {
                        didFindChild = true;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (_child === b) {
                        didFindChild = true;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    _child = _child.sibling;
                }
                if (!didFindChild) {
                    // Search parent B's child set
                    _child = parentB.child;
                    while(_child){
                        if (_child === a) {
                            didFindChild = true;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = true;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
            }
            if (!(a.alternate === b)) throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        } // If the root is not a host container, we're in a disconnected tree. I.e.
        // unmounted.
        if (!(a.tag === HostRoot)) throw Error("Unable to find node on an unmounted component.");
        if (a.stateNode.current === a) // We've determined that A is the current branch.
        return fiber;
         // Otherwise B has to be current branch.
        return alternate;
    }
    function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        if (!currentParent) return null;
         // Next we'll drill down this component to find the first HostComponent/Text.
        var node = currentParent;
        while(true){
            if (node.tag === HostComponent || node.tag === HostText) return node;
            else if (node.child) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === currentParent) return null;
            while(!node.sibling){
                if (!node.return || node.return === currentParent) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow needs the return null here, but ESLint complains about it.
        // eslint-disable-next-line no-unreachable
        return null;
    }
    function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        if (!currentParent) return null;
         // Next we'll drill down this component to find the first HostComponent/Text.
        var node = currentParent;
        while(true){
            if (node.tag === HostComponent || node.tag === HostText || enableFundamentalAPI) return node;
            else if (node.child && node.tag !== HostPortal) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === currentParent) return null;
            while(!node.sibling){
                if (!node.return || node.return === currentParent) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow needs the return null here, but ESLint complains about it.
        // eslint-disable-next-line no-unreachable
        return null;
    }
    function doesFiberContain(parentFiber, childFiber) {
        var node = childFiber;
        var parentFiberAlternate = parentFiber.alternate;
        while(node !== null){
            if (node === parentFiber || node === parentFiberAlternate) return true;
            node = node.return;
        }
        return false;
    }
    var attemptUserBlockingHydration;
    function setAttemptUserBlockingHydration(fn) {
        attemptUserBlockingHydration = fn;
    }
    var attemptContinuousHydration;
    function setAttemptContinuousHydration(fn) {
        attemptContinuousHydration = fn;
    }
    var attemptHydrationAtCurrentPriority;
    function setAttemptHydrationAtCurrentPriority(fn) {
        attemptHydrationAtCurrentPriority = fn;
    }
    var attemptHydrationAtPriority;
    function setAttemptHydrationAtPriority(fn) {
        attemptHydrationAtPriority = fn;
    } // TODO: Upgrade this definition once we're on a newer version of Flow that
    var hasScheduledReplayAttempt = false; // The queue of discrete events to be replayed.
    var queuedDiscreteEvents = []; // Indicates if any continuous event targets are non-null for early bailout.
    // if the last target was dehydrated.
    var queuedFocus = null;
    var queuedDrag = null;
    var queuedMouse = null; // For pointer events there can be one latest event per pointerId.
    var queuedPointers = new Map();
    var queuedPointerCaptures = new Map(); // We could consider replaying selectionchange and touchmoves too.
    var queuedExplicitHydrationTargets = [];
    function hasQueuedDiscreteEvents() {
        return queuedDiscreteEvents.length > 0;
    }
    var discreteReplayableEvents = [
        'mousedown',
        'mouseup',
        'touchcancel',
        'touchend',
        'touchstart',
        'auxclick',
        'dblclick',
        'pointercancel',
        'pointerdown',
        'pointerup',
        'dragend',
        'dragstart',
        'drop',
        'compositionend',
        'compositionstart',
        'keydown',
        'keypress',
        'keyup',
        'input',
        'textInput',
        'copy',
        'cut',
        'paste',
        'click',
        'change',
        'contextmenu',
        'reset',
        'submit'
    ];
    function isReplayableDiscreteEvent(eventType) {
        return discreteReplayableEvents.indexOf(eventType) > -1;
    }
    function createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        return {
            blockedOn: blockedOn,
            domEventName: domEventName,
            eventSystemFlags: eventSystemFlags | IS_REPLAYED,
            nativeEvent: nativeEvent,
            targetContainers: [
                targetContainer
            ]
        };
    }
    function queueDiscreteEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
        queuedDiscreteEvents.push(queuedEvent);
    } // Resets the replaying for this type of continuous event to no event.
    function clearIfContinuousEvent(domEventName, nativeEvent) {
        switch(domEventName){
            case 'focusin':
            case 'focusout':
                queuedFocus = null;
                break;
            case 'dragenter':
            case 'dragleave':
                queuedDrag = null;
                break;
            case 'mouseover':
            case 'mouseout':
                queuedMouse = null;
                break;
            case 'pointerover':
            case 'pointerout':
                var pointerId = nativeEvent.pointerId;
                queuedPointers.delete(pointerId);
                break;
            case 'gotpointercapture':
            case 'lostpointercapture':
                var _pointerId = nativeEvent.pointerId;
                queuedPointerCaptures.delete(_pointerId);
                break;
        }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
            var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
            if (blockedOn !== null) {
                var _fiber2 = getInstanceFromNode(blockedOn);
                if (_fiber2 !== null) // Attempt to increase the priority of this target.
                attemptContinuousHydration(_fiber2);
            }
            return queuedEvent;
        } // If we have already queued this exact event, then it's because
        // the different event systems have different DOM event listeners.
        // We can accumulate the flags, and the targetContainers, and
        // store a single event to be replayed.
        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        var targetContainers = existingQueuedEvent.targetContainers;
        if (targetContainer !== null && targetContainers.indexOf(targetContainer) === -1) targetContainers.push(targetContainer);
        return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // These set relatedTarget to null because the replayed event will be treated as if we
        // moved from outside the window (no target) onto the target once it hydrates.
        // Instead of mutating we could clone the event.
        switch(domEventName){
            case 'focusin':
                var focusEvent = nativeEvent;
                queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, focusEvent);
                return true;
            case 'dragenter':
                var dragEvent = nativeEvent;
                queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, dragEvent);
                return true;
            case 'mouseover':
                var mouseEvent = nativeEvent;
                queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, mouseEvent);
                return true;
            case 'pointerover':
                var pointerEvent = nativeEvent;
                var pointerId = pointerEvent.pointerId;
                queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, pointerEvent));
                return true;
            case 'gotpointercapture':
                var _pointerEvent = nativeEvent;
                var _pointerId2 = _pointerEvent.pointerId;
                queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, _pointerEvent));
                return true;
        }
        return false;
    } // Check if this target is unblocked. Returns true if it's unblocked.
    function attemptExplicitHydrationTarget(queuedTarget) {
        // TODO: This function shares a lot of logic with attemptToDispatchEvent.
        // Try to unify them. It's a bit tricky since it would require two return
        // values.
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted !== null) {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) {
                        // We're blocked on hydrating this boundary.
                        // Increase its priority.
                        queuedTarget.blockedOn = instance;
                        attemptHydrationAtPriority(queuedTarget.lanePriority, function() {
                            Scheduler.unstable_runWithPriority(queuedTarget.priority, function() {
                                attemptHydrationAtCurrentPriority(nearestMounted);
                            });
                        });
                        return;
                    }
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (root.hydrate) {
                        queuedTarget.blockedOn = getContainerFromFiber(nearestMounted); // We don't currently have a way to increase the priority of
                        // a root other than sync.
                        return;
                    }
                }
            }
        }
        queuedTarget.blockedOn = null;
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (queuedEvent.blockedOn !== null) return false;
        var targetContainers = queuedEvent.targetContainers;
        while(targetContainers.length > 0){
            var targetContainer = targetContainers[0];
            var nextBlockedOn = attemptToDispatchEvent(queuedEvent.domEventName, queuedEvent.eventSystemFlags, targetContainer, queuedEvent.nativeEvent);
            if (nextBlockedOn !== null) {
                // We're still blocked. Try again later.
                var _fiber3 = getInstanceFromNode(nextBlockedOn);
                if (_fiber3 !== null) attemptContinuousHydration(_fiber3);
                queuedEvent.blockedOn = nextBlockedOn;
                return false;
            } // This target container was successfully dispatched. Try the next.
            targetContainers.shift();
        }
        return true;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        if (attemptReplayContinuousQueuedEvent(queuedEvent)) map.delete(key);
    }
    function replayUnblockedEvents() {
        hasScheduledReplayAttempt = false; // First replay discrete events.
        while(queuedDiscreteEvents.length > 0){
            var nextDiscreteEvent = queuedDiscreteEvents[0];
            if (nextDiscreteEvent.blockedOn !== null) {
                // We're still blocked.
                // Increase the priority of this boundary to unblock
                // the next discrete event.
                var _fiber4 = getInstanceFromNode(nextDiscreteEvent.blockedOn);
                if (_fiber4 !== null) attemptUserBlockingHydration(_fiber4);
                break;
            }
            var targetContainers = nextDiscreteEvent.targetContainers;
            while(targetContainers.length > 0){
                var targetContainer = targetContainers[0];
                var nextBlockedOn = attemptToDispatchEvent(nextDiscreteEvent.domEventName, nextDiscreteEvent.eventSystemFlags, targetContainer, nextDiscreteEvent.nativeEvent);
                if (nextBlockedOn !== null) {
                    // We're still blocked. Try again later.
                    nextDiscreteEvent.blockedOn = nextBlockedOn;
                    break;
                } // This target container was successfully dispatched. Try the next.
                targetContainers.shift();
            }
            if (nextDiscreteEvent.blockedOn === null) // We've successfully replayed the first event. Let's try the next one.
            queuedDiscreteEvents.shift();
        } // Next replay any continuous events.
        if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) queuedFocus = null;
        if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) queuedDrag = null;
        if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) queuedMouse = null;
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        if (queuedEvent.blockedOn === unblocked) {
            queuedEvent.blockedOn = null;
            if (!hasScheduledReplayAttempt) {
                hasScheduledReplayAttempt = true; // Schedule a callback to attempt replaying as many events as are
                // now unblocked. This first might not actually be unblocked yet.
                // We could check it early to avoid scheduling an unnecessary callback.
                Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
            }
        }
    }
    function retryIfBlockedOn(unblocked) {
        // Mark anything that was blocked on this as no longer blocked
        // and eligible for a replay.
        if (queuedDiscreteEvents.length > 0) {
            scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked); // This is a exponential search for each boundary that commits. I think it's
            // worth it because we expect very few discrete events to queue up and once
            // we are actually fully unblocked it will be fast to replay them.
            for(var i = 1; i < queuedDiscreteEvents.length; i++){
                var queuedEvent = queuedDiscreteEvents[i];
                if (queuedEvent.blockedOn === unblocked) queuedEvent.blockedOn = null;
            }
        }
        if (queuedFocus !== null) scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        if (queuedDrag !== null) scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        if (queuedMouse !== null) scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        var unblock = function(queuedEvent) {
            return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        };
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for(var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++){
            var queuedTarget = queuedExplicitHydrationTargets[_i];
            if (queuedTarget.blockedOn === unblocked) queuedTarget.blockedOn = null;
        }
        while(queuedExplicitHydrationTargets.length > 0){
            var nextExplicitTarget = queuedExplicitHydrationTargets[0];
            if (nextExplicitTarget.blockedOn !== null) break;
            else {
                attemptExplicitHydrationTarget(nextExplicitTarget);
                if (nextExplicitTarget.blockedOn === null) // We're unblocked.
                queuedExplicitHydrationTargets.shift();
            }
        }
    }
    var DiscreteEvent = 0;
    var UserBlockingEvent = 1;
    var ContinuousEvent = 2;
    /**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */ function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes['Webkit' + styleProp] = 'webkit' + eventName;
        prefixes['Moz' + styleProp] = 'moz' + eventName;
        return prefixes;
    }
    /**
 * A list of event names to a configurable list of vendor prefixes.
 */ var vendorPrefixes = {
        animationend: makePrefixMap('Animation', 'AnimationEnd'),
        animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
        animationstart: makePrefixMap('Animation', 'AnimationStart'),
        transitionend: makePrefixMap('Transition', 'TransitionEnd')
    };
    /**
 * Event names that have already been detected and prefixed (if applicable).
 */ var prefixedEventNames = {};
    /**
 * Element to check for prefixes on.
 */ var style = {};
    /**
 * Bootstrap if a DOM exists.
 */ if (canUseDOM) {
        style = document.createElement('div').style; // On some platforms, in particular some releases of Android 4.x,
        // the un-prefixed "animation" and "transition" properties are defined on the
        // style object but the events that fire will still be prefixed, so we need
        // to check if the un-prefixed events are usable, and if not remove them from the map.
        if (!('AnimationEvent' in window)) {
            delete vendorPrefixes.animationend.animation;
            delete vendorPrefixes.animationiteration.animation;
            delete vendorPrefixes.animationstart.animation;
        } // Same as above
        if (!('TransitionEvent' in window)) delete vendorPrefixes.transitionend.transition;
    }
    /**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */ function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
        else if (!vendorPrefixes[eventName]) return eventName;
        var prefixMap = vendorPrefixes[eventName];
        for(var styleProp in prefixMap){
            if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
        }
        return eventName;
    }
    var ANIMATION_END = getVendorPrefixedEventName('animationend');
    var ANIMATION_ITERATION = getVendorPrefixedEventName('animationiteration');
    var ANIMATION_START = getVendorPrefixedEventName('animationstart');
    var TRANSITION_END = getVendorPrefixedEventName('transitionend');
    var topLevelEventsToReactNames = new Map();
    var eventPriorities = new Map(); // We store most of the events in this module in pairs of two strings so we can re-use
    // the code required to apply the same logic for event prioritization and that of the
    // SimpleEventPlugin. This complicates things slightly, but the aim is to reduce code
    // duplication (for which there would be quite a bit). For the events that are not needed
    // for the SimpleEventPlugin (otherDiscreteEvents) we process them separately as an
    // array of top level events.
    // Lastly, we ignore prettier so we can keep the formatting sane.
    // prettier-ignore
    var discreteEventPairsForSimpleEventPlugin = [
        'cancel',
        'cancel',
        'click',
        'click',
        'close',
        'close',
        'contextmenu',
        'contextMenu',
        'copy',
        'copy',
        'cut',
        'cut',
        'auxclick',
        'auxClick',
        'dblclick',
        'doubleClick',
        'dragend',
        'dragEnd',
        'dragstart',
        'dragStart',
        'drop',
        'drop',
        'focusin',
        'focus',
        'focusout',
        'blur',
        'input',
        'input',
        'invalid',
        'invalid',
        'keydown',
        'keyDown',
        'keypress',
        'keyPress',
        'keyup',
        'keyUp',
        'mousedown',
        'mouseDown',
        'mouseup',
        'mouseUp',
        'paste',
        'paste',
        'pause',
        'pause',
        'play',
        'play',
        'pointercancel',
        'pointerCancel',
        'pointerdown',
        'pointerDown',
        'pointerup',
        'pointerUp',
        'ratechange',
        'rateChange',
        'reset',
        'reset',
        'seeked',
        'seeked',
        'submit',
        'submit',
        'touchcancel',
        'touchCancel',
        'touchend',
        'touchEnd',
        'touchstart',
        'touchStart',
        'volumechange',
        'volumeChange'
    ];
    var otherDiscreteEvents = [
        'change',
        'selectionchange',
        'textInput',
        'compositionstart',
        'compositionend',
        'compositionupdate'
    ];
    var userBlockingPairsForSimpleEventPlugin = [
        'drag',
        'drag',
        'dragenter',
        'dragEnter',
        'dragexit',
        'dragExit',
        'dragleave',
        'dragLeave',
        'dragover',
        'dragOver',
        'mousemove',
        'mouseMove',
        'mouseout',
        'mouseOut',
        'mouseover',
        'mouseOver',
        'pointermove',
        'pointerMove',
        'pointerout',
        'pointerOut',
        'pointerover',
        'pointerOver',
        'scroll',
        'scroll',
        'toggle',
        'toggle',
        'touchmove',
        'touchMove',
        'wheel',
        'wheel'
    ]; // prettier-ignore
    var continuousPairsForSimpleEventPlugin = [
        'abort',
        'abort',
        ANIMATION_END,
        'animationEnd',
        ANIMATION_ITERATION,
        'animationIteration',
        ANIMATION_START,
        'animationStart',
        'canplay',
        'canPlay',
        'canplaythrough',
        'canPlayThrough',
        'durationchange',
        'durationChange',
        'emptied',
        'emptied',
        'encrypted',
        'encrypted',
        'ended',
        'ended',
        'error',
        'error',
        'gotpointercapture',
        'gotPointerCapture',
        'load',
        'load',
        'loadeddata',
        'loadedData',
        'loadedmetadata',
        'loadedMetadata',
        'loadstart',
        'loadStart',
        'lostpointercapture',
        'lostPointerCapture',
        'playing',
        'playing',
        'progress',
        'progress',
        'seeking',
        'seeking',
        'stalled',
        'stalled',
        'suspend',
        'suspend',
        'timeupdate',
        'timeUpdate',
        TRANSITION_END,
        'transitionEnd',
        'waiting',
        'waiting'
    ];
    /**
 * Turns
 * ['abort', ...]
 *
 * into
 *
 * topLevelEventsToReactNames = new Map([
 *   ['abort', 'onAbort'],
 * ]);
 *
 * and registers them.
 */ function registerSimplePluginEventsAndSetTheirPriorities(eventTypes, priority) {
        // As the event types are in pairs of two, we need to iterate
        // through in twos. The events are in pairs of two to save code
        // and improve init perf of processing this array, as it will
        // result in far fewer object allocations and property accesses
        // if we only use three arrays to process all the categories of
        // instead of tuples.
        for(var i = 0; i < eventTypes.length; i += 2){
            var topEvent = eventTypes[i];
            var event = eventTypes[i + 1];
            var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
            var reactName = 'on' + capitalizedEvent;
            eventPriorities.set(topEvent, priority);
            topLevelEventsToReactNames.set(topEvent, reactName);
            registerTwoPhaseEvent(reactName, [
                topEvent
            ]);
        }
    }
    function setEventPriorities(eventTypes, priority) {
        for(var i = 0; i < eventTypes.length; i++)eventPriorities.set(eventTypes[i], priority);
    }
    function getEventPriorityForPluginSystem(domEventName) {
        var priority = eventPriorities.get(domEventName); // Default to a ContinuousEvent. Note: we might
        // want to warn if we can't detect the priority
        // for the event.
        return priority === undefined ? ContinuousEvent : priority;
    }
    function registerSimpleEvents() {
        registerSimplePluginEventsAndSetTheirPriorities(discreteEventPairsForSimpleEventPlugin, DiscreteEvent);
        registerSimplePluginEventsAndSetTheirPriorities(userBlockingPairsForSimpleEventPlugin, UserBlockingEvent);
        registerSimplePluginEventsAndSetTheirPriorities(continuousPairsForSimpleEventPlugin, ContinuousEvent);
        setEventPriorities(otherDiscreteEvents, DiscreteEvent);
    }
    var Scheduler_now = Scheduler.unstable_now;
    // Provide explicit error message when production+profiling bundle of e.g.
    // react-dom is used with production (non-profiling) bundle of
    // scheduler/tracing
    if (!(tracing.__interactionsRef != null && tracing.__interactionsRef.current != null)) throw Error("It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at https://reactjs.org/link/profiling");
    // ascending numbers so we can compare them like numbers. They start at 90 to
    // avoid clashing with Scheduler's priorities.
    var ImmediatePriority = 99;
    var UserBlockingPriority = 98;
    var NormalPriority = 97;
    var LowPriority = 96;
    var IdlePriority = 95; // NoPriority is the absence of priority. Also React-only.
    var NoPriority = 90;
    var initialTimeMs = Scheduler_now(); // If the initial timestamp is reasonably small, use Scheduler's `now` directly.
    var SyncLanePriority = 15;
    var SyncBatchedLanePriority = 14;
    var InputDiscreteHydrationLanePriority = 13;
    var InputDiscreteLanePriority = 12;
    var InputContinuousHydrationLanePriority = 11;
    var InputContinuousLanePriority = 10;
    var DefaultHydrationLanePriority = 9;
    var DefaultLanePriority = 8;
    var TransitionHydrationPriority = 7;
    var TransitionPriority = 6;
    var RetryLanePriority = 5;
    var SelectiveHydrationLanePriority = 4;
    var IdleHydrationLanePriority = 3;
    var IdleLanePriority = 2;
    var OffscreenLanePriority = 1;
    var NoLanePriority = 0;
    var TotalLanes = 31;
    var NoLanes = /*                        */ 0;
    var NoLane = /*                          */ 0;
    var SyncLane = /*                        */ 1;
    var SyncBatchedLane = /*                 */ 2;
    var InputDiscreteHydrationLane = /*      */ 4;
    var InputDiscreteLanes = /*                    */ 24;
    var InputContinuousHydrationLane = /*           */ 32;
    var InputContinuousLanes = /*                  */ 192;
    var DefaultHydrationLane = /*            */ 256;
    var DefaultLanes = /*                   */ 3584;
    var TransitionHydrationLane = /*                */ 4096;
    var TransitionLanes = /*                       */ 4186112;
    var RetryLanes = /*                            */ 62914560;
    var SomeRetryLane = /*                  */ 33554432;
    var SelectiveHydrationLane = /*          */ 67108864;
    var NonIdleLanes = /*                                 */ 134217727;
    var IdleHydrationLane = /*               */ 134217728;
    var IdleLanes = /*                             */ 805306368;
    var OffscreenLane = /*                   */ 1073741824;
    var NoTimestamp = -1;
    function setCurrentUpdateLanePriority(newLanePriority) {} // "Registers" used to "return" multiple values
    // Used by getHighestPriorityLanes and getNextLanes:
    var return_highestLanePriority = DefaultLanePriority;
    function getHighestPriorityLanes(lanes) {
        if ((SyncLane & lanes) !== NoLanes) {
            return_highestLanePriority = SyncLanePriority;
            return SyncLane;
        }
        if ((SyncBatchedLane & lanes) !== NoLanes) {
            return_highestLanePriority = SyncBatchedLanePriority;
            return SyncBatchedLane;
        }
        if ((InputDiscreteHydrationLane & lanes) !== NoLanes) {
            return_highestLanePriority = InputDiscreteHydrationLanePriority;
            return InputDiscreteHydrationLane;
        }
        var inputDiscreteLanes = InputDiscreteLanes & lanes;
        if (inputDiscreteLanes !== NoLanes) {
            return_highestLanePriority = InputDiscreteLanePriority;
            return inputDiscreteLanes;
        }
        if ((lanes & InputContinuousHydrationLane) !== NoLanes) {
            return_highestLanePriority = InputContinuousHydrationLanePriority;
            return InputContinuousHydrationLane;
        }
        var inputContinuousLanes = InputContinuousLanes & lanes;
        if (inputContinuousLanes !== NoLanes) {
            return_highestLanePriority = InputContinuousLanePriority;
            return inputContinuousLanes;
        }
        if ((lanes & DefaultHydrationLane) !== NoLanes) {
            return_highestLanePriority = DefaultHydrationLanePriority;
            return DefaultHydrationLane;
        }
        var defaultLanes = DefaultLanes & lanes;
        if (defaultLanes !== NoLanes) {
            return_highestLanePriority = DefaultLanePriority;
            return defaultLanes;
        }
        if ((lanes & TransitionHydrationLane) !== NoLanes) {
            return_highestLanePriority = TransitionHydrationPriority;
            return TransitionHydrationLane;
        }
        var transitionLanes = TransitionLanes & lanes;
        if (transitionLanes !== NoLanes) {
            return_highestLanePriority = TransitionPriority;
            return transitionLanes;
        }
        var retryLanes = RetryLanes & lanes;
        if (retryLanes !== NoLanes) {
            return_highestLanePriority = RetryLanePriority;
            return retryLanes;
        }
        if (lanes & SelectiveHydrationLane) {
            return_highestLanePriority = SelectiveHydrationLanePriority;
            return SelectiveHydrationLane;
        }
        if ((lanes & IdleHydrationLane) !== NoLanes) {
            return_highestLanePriority = IdleHydrationLanePriority;
            return IdleHydrationLane;
        }
        var idleLanes = IdleLanes & lanes;
        if (idleLanes !== NoLanes) {
            return_highestLanePriority = IdleLanePriority;
            return idleLanes;
        }
        if ((OffscreenLane & lanes) !== NoLanes) {
            return_highestLanePriority = OffscreenLanePriority;
            return OffscreenLane;
        }
        error('Should have found matching lanes. This is a bug in React.');
        return_highestLanePriority = DefaultLanePriority;
        return lanes;
    }
    function schedulerPriorityToLanePriority(schedulerPriorityLevel) {
        switch(schedulerPriorityLevel){
            case ImmediatePriority:
                return SyncLanePriority;
            case UserBlockingPriority:
                return InputContinuousLanePriority;
            case NormalPriority:
            case LowPriority:
                // TODO: Handle LowSchedulerPriority, somehow. Maybe the same lane as hydration.
                return DefaultLanePriority;
            case IdlePriority:
                return IdleLanePriority;
            default:
                return NoLanePriority;
        }
    }
    function lanePriorityToSchedulerPriority(lanePriority) {
        switch(lanePriority){
            case SyncLanePriority:
            case SyncBatchedLanePriority:
                return ImmediatePriority;
            case InputDiscreteHydrationLanePriority:
            case InputDiscreteLanePriority:
            case InputContinuousHydrationLanePriority:
            case InputContinuousLanePriority:
                return UserBlockingPriority;
            case DefaultHydrationLanePriority:
            case DefaultLanePriority:
            case TransitionHydrationPriority:
            case TransitionPriority:
            case SelectiveHydrationLanePriority:
            case RetryLanePriority:
                return NormalPriority;
            case IdleHydrationLanePriority:
            case IdleLanePriority:
            case OffscreenLanePriority:
                return IdlePriority;
            case NoLanePriority:
                return NoPriority;
            default:
                throw Error("Invalid update priority: " + lanePriority + ". This is a bug in React.");
        }
    }
    function getNextLanes(root, wipLanes) {
        // Early bailout if there's no pending work left.
        var pendingLanes = root.pendingLanes;
        if (pendingLanes === NoLanes) {
            return_highestLanePriority = NoLanePriority;
            return NoLanes;
        }
        var nextLanes = NoLanes;
        var nextLanePriority = NoLanePriority;
        var expiredLanes = root.expiredLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes; // Check if any work has expired.
        if (expiredLanes !== NoLanes) {
            nextLanes = expiredLanes;
            nextLanePriority = return_highestLanePriority = SyncLanePriority;
        } else {
            // Do not work on any idle work until all the non-idle work has finished,
            // even if the work is suspended.
            var nonIdlePendingLanes = pendingLanes & NonIdleLanes;
            if (nonIdlePendingLanes !== NoLanes) {
                var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;
                if (nonIdleUnblockedLanes !== NoLanes) {
                    nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
                    nextLanePriority = return_highestLanePriority;
                } else {
                    var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;
                    if (nonIdlePingedLanes !== NoLanes) {
                        nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
                        nextLanePriority = return_highestLanePriority;
                    }
                }
            } else {
                // The only remaining work is Idle.
                var unblockedLanes = pendingLanes & ~suspendedLanes;
                if (unblockedLanes !== NoLanes) {
                    nextLanes = getHighestPriorityLanes(unblockedLanes);
                    nextLanePriority = return_highestLanePriority;
                } else if (pingedLanes !== NoLanes) {
                    nextLanes = getHighestPriorityLanes(pingedLanes);
                    nextLanePriority = return_highestLanePriority;
                }
            }
        }
        if (nextLanes === NoLanes) // This should only be reachable if we're suspended
        // TODO: Consider warning in this path if a fallback timer is not scheduled.
        return NoLanes;
         // If there are higher priority lanes, we'll include them even if they
        // are suspended.
        nextLanes = pendingLanes & getEqualOrHigherPriorityLanes(nextLanes); // If we're already in the middle of a render, switching lanes will interrupt
        // it and we'll lose our progress. We should only do this if the new lanes are
        // higher priority.
        if (wipLanes !== NoLanes && wipLanes !== nextLanes && // If we already suspended with a delay, then interrupting is fine. Don't
        // bother waiting until the root is complete.
        (wipLanes & suspendedLanes) === NoLanes) {
            getHighestPriorityLanes(wipLanes);
            var wipLanePriority = return_highestLanePriority;
            if (nextLanePriority <= wipLanePriority) return wipLanes;
            else return_highestLanePriority = nextLanePriority;
        } // Check for entangled lanes and add them to the batch.
        //
        // A lane is said to be entangled with another when it's not allowed to render
        // in a batch that does not also include the other lane. Typically we do this
        // when multiple updates have the same source, and we only want to respond to
        // the most recent event from that source.
        //
        // Note that we apply entanglements *after* checking for partial work above.
        // This means that if a lane is entangled during an interleaved event while
        // it's already rendering, we won't interrupt it. This is intentional, since
        // entanglement is usually "best effort": we'll try our best to render the
        // lanes in the same batch, but it's not worth throwing out partially
        // completed work in order to do it.
        //
        // For those exceptions where entanglement is semantically important, like
        // useMutableSource, we should ensure that there is no partial work at the
        // time we apply the entanglement.
        var entangledLanes = root.entangledLanes;
        if (entangledLanes !== NoLanes) {
            var entanglements = root.entanglements;
            var lanes = nextLanes & entangledLanes;
            while(lanes > 0){
                var index = pickArbitraryLaneIndex(lanes);
                var lane = 1 << index;
                nextLanes |= entanglements[index];
                lanes &= ~lane;
            }
        }
        return nextLanes;
    }
    function getMostRecentEventTime(root, lanes) {
        var eventTimes = root.eventTimes;
        var mostRecentEventTime = NoTimestamp;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var eventTime = eventTimes[index];
            if (eventTime > mostRecentEventTime) mostRecentEventTime = eventTime;
            lanes &= ~lane;
        }
        return mostRecentEventTime;
    }
    function computeExpirationTime(lane, currentTime) {
        // TODO: Expiration heuristic is constant per lane, so could use a map.
        getHighestPriorityLanes(lane);
        var priority = return_highestLanePriority;
        if (priority >= InputContinuousLanePriority) // User interactions should expire slightly more quickly.
        //
        // NOTE: This is set to the corresponding constant as in Scheduler.js. When
        // we made it larger, a product metric in www regressed, suggesting there's
        // a user interaction that's being starved by a series of synchronous
        // updates. If that theory is correct, the proper solution is to fix the
        // starvation. However, this scenario supports the idea that expiration
        // times are an important safeguard when starvation does happen.
        //
        // Also note that, in the case of user input specifically, this will soon no
        // longer be an issue because we plan to make user input synchronous by
        // default (until you enter `startTransition`, of course.)
        //
        // If weren't planning to make these updates synchronous soon anyway, I
        // would probably make this number a configurable parameter.
        return currentTime + 250;
        else if (priority >= TransitionPriority) return currentTime + 5000;
        else // Anything idle priority or lower should never expire.
        return NoTimestamp;
    }
    function markStarvedLanesAsExpired(root, currentTime) {
        // TODO: This gets called every time we yield. We can optimize by storing
        // the earliest expiration time on the root. Then use that to quickly bail out
        // of this function.
        var pendingLanes = root.pendingLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes;
        var expirationTimes = root.expirationTimes; // Iterate through the pending lanes and check if we've reached their
        // expiration time. If so, we'll assume the update is being starved and mark
        // it as expired to force it to finish.
        var lanes = pendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var expirationTime = expirationTimes[index];
            if (expirationTime === NoTimestamp) // Found a pending lane with no expiration time. If it's not suspended, or
            // if it's pinged, assume it's CPU-bound. Compute a new expiration time
            // using the current time.
            {
                if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) // Assumes timestamps are monotonically increasing.
                expirationTimes[index] = computeExpirationTime(lane, currentTime);
            } else if (expirationTime <= currentTime) // This lane expired
            root.expiredLanes |= lane;
            lanes &= ~lane;
        }
    } // This returns the highest priority pending lanes regardless of whether they
    function getLanesToRetrySynchronouslyOnError(root) {
        var everythingButOffscreen = root.pendingLanes & ~OffscreenLane;
        if (everythingButOffscreen !== NoLanes) return everythingButOffscreen;
        if (everythingButOffscreen & OffscreenLane) return OffscreenLane;
        return NoLanes;
    }
    function returnNextLanesPriority() {
        return return_highestLanePriority;
    }
    function includesNonIdleWork(lanes) {
        return (lanes & NonIdleLanes) !== NoLanes;
    }
    function includesOnlyRetries(lanes) {
        return (lanes & RetryLanes) === lanes;
    }
    function includesOnlyTransitions(lanes) {
        return (lanes & TransitionLanes) === lanes;
    } // To ensure consistency across multiple updates in the same event, this should
    // be a pure function, so that it always returns the same lane for given inputs.
    function findUpdateLane(lanePriority, wipLanes) {
        switch(lanePriority){
            case NoLanePriority:
                break;
            case SyncLanePriority:
                return SyncLane;
            case SyncBatchedLanePriority:
                return SyncBatchedLane;
            case InputDiscreteLanePriority:
                var _lane = pickArbitraryLane(InputDiscreteLanes & ~wipLanes);
                if (_lane === NoLane) // Shift to the next priority level
                return findUpdateLane(InputContinuousLanePriority, wipLanes);
                return _lane;
            case InputContinuousLanePriority:
                var _lane2 = pickArbitraryLane(InputContinuousLanes & ~wipLanes);
                if (_lane2 === NoLane) // Shift to the next priority level
                return findUpdateLane(DefaultLanePriority, wipLanes);
                return _lane2;
            case DefaultLanePriority:
                var _lane3 = pickArbitraryLane(DefaultLanes & ~wipLanes);
                if (_lane3 === NoLane) {
                    // If all the default lanes are already being worked on, look for a
                    // lane in the transition range.
                    _lane3 = pickArbitraryLane(TransitionLanes & ~wipLanes);
                    if (_lane3 === NoLane) // All the transition lanes are taken, too. This should be very
                    // rare, but as a last resort, pick a default lane. This will have
                    // the effect of interrupting the current work-in-progress render.
                    _lane3 = pickArbitraryLane(DefaultLanes);
                }
                return _lane3;
            case TransitionPriority:
            case RetryLanePriority:
                break;
            case IdleLanePriority:
                var lane = pickArbitraryLane(IdleLanes & ~wipLanes);
                if (lane === NoLane) lane = pickArbitraryLane(IdleLanes);
                return lane;
        }
        throw Error("Invalid update priority: " + lanePriority + ". This is a bug in React.");
    } // To ensure consistency across multiple updates in the same event, this should
    // be pure function, so that it always returns the same lane for given inputs.
    function findTransitionLane(wipLanes, pendingLanes) {
        // First look for lanes that are completely unclaimed, i.e. have no
        // pending work.
        var lane = pickArbitraryLane(TransitionLanes & ~pendingLanes);
        if (lane === NoLane) {
            // If all lanes have pending work, look for a lane that isn't currently
            // being worked on.
            lane = pickArbitraryLane(TransitionLanes & ~wipLanes);
            if (lane === NoLane) // If everything is being worked on, pick any lane. This has the
            // effect of interrupting the current work-in-progress.
            lane = pickArbitraryLane(TransitionLanes);
        }
        return lane;
    } // To ensure consistency across multiple updates in the same event, this should
    // be pure function, so that it always returns the same lane for given inputs.
    function findRetryLane(wipLanes) {
        // This is a fork of `findUpdateLane` designed specifically for Suspense
        // "retries" — a special update that attempts to flip a Suspense boundary
        // from its placeholder state to its primary/resolved state.
        var lane = pickArbitraryLane(RetryLanes & ~wipLanes);
        if (lane === NoLane) lane = pickArbitraryLane(RetryLanes);
        return lane;
    }
    function getHighestPriorityLane(lanes) {
        return lanes & -lanes;
    }
    function getLowestPriorityLane(lanes) {
        // This finds the most significant non-zero bit.
        var index = 31 - clz32(lanes);
        return index < 0 ? NoLanes : 1 << index;
    }
    function getEqualOrHigherPriorityLanes(lanes) {
        return (getLowestPriorityLane(lanes) << 1) - 1;
    }
    function pickArbitraryLane(lanes) {
        // This wrapper function gets inlined. Only exists so to communicate that it
        // doesn't matter which bit is selected; you can pick any bit without
        // affecting the algorithms where its used. Here I'm using
        // getHighestPriorityLane because it requires the fewest operations.
        return getHighestPriorityLane(lanes);
    }
    function pickArbitraryLaneIndex(lanes) {
        return 31 - clz32(lanes);
    }
    function laneToIndex(lane) {
        return pickArbitraryLaneIndex(lane);
    }
    function includesSomeLane(a, b) {
        return (a & b) !== NoLanes;
    }
    function isSubsetOfLanes(set, subset) {
        return (set & subset) === subset;
    }
    function mergeLanes(a, b) {
        return a | b;
    }
    function removeLanes(set, subset) {
        return set & ~subset;
    } // Seems redundant, but it changes the type from a single lane (used for
    // updates) to a group of lanes (used for flushing work).
    function laneToLanes(lane) {
        return lane;
    }
    function higherPriorityLane(a, b) {
        // This works because the bit ranges decrease in priority as you go left.
        return a !== NoLane && a < b ? a : b;
    }
    function createLaneMap(initial) {
        // Intentionally pushing one by one.
        // https://v8.dev/blog/elements-kinds#avoid-creating-holes
        var laneMap = [];
        for(var i = 0; i < TotalLanes; i++)laneMap.push(initial);
        return laneMap;
    }
    function markRootUpdated(root, updateLane, eventTime) {
        root.pendingLanes |= updateLane; // TODO: Theoretically, any update to any lane can unblock any other lane. But
        // it's not practical to try every single possible combination. We need a
        // heuristic to decide which lanes to attempt to render, and in which batches.
        // For now, we use the same heuristic as in the old ExpirationTimes model:
        // retry any lane at equal or lower priority, but don't try updates at higher
        // priority without also including the lower priority updates. This works well
        // when considering updates across different priority levels, but isn't
        // sufficient for updates within the same priority, since we want to treat
        // those updates as parallel.
        // Unsuspend any update at equal or lower priority.
        var higherPriorityLanes = updateLane - 1; // Turns 0b1000 into 0b0111
        root.suspendedLanes &= higherPriorityLanes;
        root.pingedLanes &= higherPriorityLanes;
        var eventTimes = root.eventTimes;
        var index = laneToIndex(updateLane); // We can always overwrite an existing timestamp because we prefer the most
        // recent event, and we assume time is monotonically increasing.
        eventTimes[index] = eventTime;
    }
    function markRootSuspended(root, suspendedLanes) {
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes; // The suspended lanes are no longer CPU-bound. Clear their expiration times.
        var expirationTimes = root.expirationTimes;
        var lanes = suspendedLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootPinged(root, pingedLanes, eventTime) {
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
    }
    function markDiscreteUpdatesExpired(root) {
        root.expiredLanes |= InputDiscreteLanes & root.pendingLanes;
    }
    function hasDiscreteLanes(lanes) {
        return (lanes & InputDiscreteLanes) !== NoLanes;
    }
    function markRootMutableRead(root, updateLane) {
        root.mutableReadLanes |= updateLane & root.pendingLanes;
    }
    function markRootFinished(root, remainingLanes) {
        var noLongerPendingLanes = root.pendingLanes & ~remainingLanes;
        root.pendingLanes = remainingLanes; // Let's try everything again
        root.suspendedLanes = 0;
        root.pingedLanes = 0;
        root.expiredLanes &= remainingLanes;
        root.mutableReadLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        var entanglements = root.entanglements;
        var eventTimes = root.eventTimes;
        var expirationTimes = root.expirationTimes; // Clear the lanes that no longer have pending work
        var lanes = noLongerPendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            entanglements[index] = NoLanes;
            eventTimes[index] = NoTimestamp;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootEntangled(root, entangledLanes) {
        root.entangledLanes |= entangledLanes;
        var entanglements = root.entanglements;
        var lanes = entangledLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            entanglements[index] |= entangledLanes;
            lanes &= ~lane;
        }
    }
    var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback; // Count leading zeros. Only used on lanes, so assume input is an integer.
    // Based on:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32
    var log = Math.log;
    var LN2 = Math.LN2;
    function clz32Fallback(lanes) {
        if (lanes === 0) return 32;
        return 31 - (log(lanes) / LN2 | 0) | 0;
    }
    // Intentionally not named imports because Rollup would use dynamic dispatch for
    var UserBlockingPriority$1 = Scheduler.unstable_UserBlockingPriority, runWithPriority = Scheduler.unstable_runWithPriority; // TODO: can we stop exporting these?
    var _enabled = true; // This is exported in FB builds for use by legacy FB layer infra.
    // We'd like to remove this but it's not clear if this is safe.
    function setEnabled(enabled) {
        _enabled = !!enabled;
    }
    function isEnabled() {
        return _enabled;
    }
    function createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags) {
        var eventPriority = getEventPriorityForPluginSystem(domEventName);
        var listenerWrapper;
        switch(eventPriority){
            case DiscreteEvent:
                listenerWrapper = dispatchDiscreteEvent;
                break;
            case UserBlockingEvent:
                listenerWrapper = dispatchUserBlockingUpdate;
                break;
            case ContinuousEvent:
            default:
                listenerWrapper = dispatchEvent;
                break;
        }
        return listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    }
    function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        flushDiscreteUpdatesIfNeeded(nativeEvent.timeStamp);
        discreteUpdates(dispatchEvent, domEventName, eventSystemFlags, container, nativeEvent);
    }
    function dispatchUserBlockingUpdate(domEventName, eventSystemFlags, container, nativeEvent) {
        runWithPriority(UserBlockingPriority$1, dispatchEvent.bind(null, domEventName, eventSystemFlags, container, nativeEvent));
    }
    function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (!_enabled) return;
        var allowReplay = true;
        // TODO: replaying capture phase events is currently broken
        // because we used to do it during top-level native bubble handlers
        // but now we use different bubble and capture handlers.
        // In eager mode, we attach capture listeners early, so we need
        // to filter them out until we fix the logic to handle them correctly.
        // This could've been outside the flag but I put it inside to reduce risk.
        allowReplay = (eventSystemFlags & IS_CAPTURE_PHASE) === 0;
        if (allowReplay && hasQueuedDiscreteEvents() && isReplayableDiscreteEvent(domEventName)) {
            // If we already have a queue of discrete events, and this is another discrete
            // event, then we can't dispatch it regardless of its target, since they
            // need to dispatch in order.
            queueDiscreteEvent(null, domEventName, eventSystemFlags, targetContainer, nativeEvent);
            return;
        }
        var blockedOn = attemptToDispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
        if (blockedOn === null) {
            // We successfully dispatched this event.
            if (allowReplay) clearIfContinuousEvent(domEventName, nativeEvent);
            return;
        }
        if (allowReplay) {
            if (isReplayableDiscreteEvent(domEventName)) {
                // This this to be replayed later once the target is available.
                queueDiscreteEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
                return;
            }
            if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) return;
             // We need to clear only if we didn't queue because
            // queueing is accummulative.
            clearIfContinuousEvent(domEventName, nativeEvent);
        } // This is not replayable so we'll invoke it but without a target,
        // in case the event system needs to trace it.
        dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    } // Attempt dispatching an event. Returns a SuspenseInstance or Container if it's blocked.
    function attemptToDispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // TODO: Warn if _enabled is false.
        var nativeEventTarget = getEventTarget(nativeEvent);
        var targetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted === null) // This tree has been unmounted already. Dispatch without a target.
            targetInst = null;
            else {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) // Queue the event to be replayed later. Abort dispatching since we
                    // don't want this event dispatched twice through the event system.
                    // TODO: If this is the first discrete event in the queue. Schedule an increased
                    // priority for this boundary.
                    return instance;
                     // This shouldn't happen, something went wrong but to avoid blocking
                    // the whole system, dispatch the event without a target.
                    // TODO: Warn.
                    targetInst = null;
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (root.hydrate) // If this happens during a replay something went wrong and it might block
                    // the whole system.
                    return getContainerFromFiber(nearestMounted);
                    targetInst = null;
                } else if (nearestMounted !== targetInst) // If we get an event (ex: img onload) before committing that
                // component's mount, ignore it for now (that is, treat it as if it was an
                // event on a non-React tree). We might also consider queueing events and
                // dispatching them after the mount.
                targetInst = null;
            }
        }
        dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer); // We're not blocked on anything.
        return null;
    }
    function addEventBubbleListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, false);
        return listener;
    }
    function addEventCaptureListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, true);
        return listener;
    }
    function addEventCaptureListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            capture: true,
            passive: passive
        });
        return listener;
    }
    function addEventBubbleListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            passive: passive
        });
        return listener;
    }
    /**
 * These variables store information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 *
 */ var root = null;
    var startText = null;
    var fallbackText = null;
    function initialize(nativeEventTarget) {
        root = nativeEventTarget;
        startText = getText();
        return true;
    }
    function reset() {
        root = null;
        startText = null;
        fallbackText = null;
    }
    function getData() {
        if (fallbackText) return fallbackText;
        var start;
        var startValue = startText;
        var startLength = startValue.length;
        var end;
        var endValue = getText();
        var endLength = endValue.length;
        for(start = 0; start < startLength; start++){
            if (startValue[start] !== endValue[start]) break;
        }
        var minEnd = startLength - start;
        for(end = 1; end <= minEnd; end++){
            if (startValue[startLength - end] !== endValue[endLength - end]) break;
        }
        var sliceTail = end > 1 ? 1 - end : undefined;
        fallbackText = endValue.slice(start, sliceTail);
        return fallbackText;
    }
    function getText() {
        if ('value' in root) return root.value;
        return root.textContent;
    }
    /**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */ function getEventCharCode(nativeEvent) {
        var charCode;
        var keyCode = nativeEvent.keyCode;
        if ('charCode' in nativeEvent) {
            charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.
            if (charCode === 0 && keyCode === 13) charCode = 13;
        } else // IE8 does not implement `charCode`, but `keyCode` has the correct value.
        charCode = keyCode;
         // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
        // report Enter as charCode 10 when ctrl is pressed.
        if (charCode === 10) charCode = 13;
         // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
        // Must not discard the (non-)printable Enter-key.
        if (charCode >= 32 || charCode === 13) return charCode;
        return 0;
    }
    function functionThatReturnsTrue() {
        return true;
    }
    function functionThatReturnsFalse() {
        return false;
    } // This is intentionally a factory so that we have different returned constructors.
    // If we had a single constructor, it would be megamorphic and engines would deopt.
    function createSyntheticEvent(Interface) {
        /**
   * Synthetic events are dispatched by event plugins, typically in response to a
   * top-level event delegation handler.
   *
   * These systems should generally use pooling to reduce the frequency of garbage
   * collection. The system should check `isPersistent` to determine whether the
   * event should be released into the pool after being dispatched. Users that
   * need a persisted event should invoke `persist`.
   *
   * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
   * normalizing browser quirks. Subclasses do not necessarily have to implement a
   * DOM interface; custom application-specific events can also subclass this.
   */ function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
            this._reactName = reactName;
            this._targetInst = targetInst;
            this.type = reactEventType;
            this.nativeEvent = nativeEvent;
            this.target = nativeEventTarget;
            this.currentTarget = null;
            for(var _propName in Interface){
                if (!Interface.hasOwnProperty(_propName)) continue;
                var normalize = Interface[_propName];
                if (normalize) this[_propName] = normalize(nativeEvent);
                else this[_propName] = nativeEvent[_propName];
            }
            var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
            if (defaultPrevented) this.isDefaultPrevented = functionThatReturnsTrue;
            else this.isDefaultPrevented = functionThatReturnsFalse;
            this.isPropagationStopped = functionThatReturnsFalse;
            return this;
        }
        _assign(SyntheticBaseEvent.prototype, {
            preventDefault: function() {
                this.defaultPrevented = true;
                var event = this.nativeEvent;
                if (!event) return;
                if (event.preventDefault) event.preventDefault(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.returnValue !== 'unknown') event.returnValue = false;
                this.isDefaultPrevented = functionThatReturnsTrue;
            },
            stopPropagation: function() {
                var event = this.nativeEvent;
                if (!event) return;
                if (event.stopPropagation) event.stopPropagation(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.cancelBubble !== 'unknown') // The ChangeEventPlugin registers a "propertychange" event for
                // IE. This event does not support bubbling or cancelling, and
                // any references to cancelBubble throw "Member not found".  A
                // typeof check of "unknown" circumvents this issue (and is also
                // IE specific).
                event.cancelBubble = true;
                this.isPropagationStopped = functionThatReturnsTrue;
            },
            /**
     * We release all dispatched `SyntheticEvent`s after each event loop, adding
     * them back into the pool. This allows a way to hold onto a reference that
     * won't be added back into the pool.
     */ persist: function() {},
            /**
     * Checks if this event should be released back into the pool.
     *
     * @return {boolean} True if this should not be released, false otherwise.
     */ isPersistent: functionThatReturnsTrue
        });
        return SyntheticBaseEvent;
    }
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var EventInterface = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(event) {
            return event.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
    };
    var SyntheticEvent = createSyntheticEvent(EventInterface);
    var UIEventInterface = _assign({}, EventInterface, {
        view: 0,
        detail: 0
    });
    var SyntheticUIEvent = createSyntheticEvent(UIEventInterface);
    var lastMovementX;
    var lastMovementY;
    var lastMouseEvent;
    function updateMouseMovementPolyfillState(event) {
        if (event !== lastMouseEvent) {
            if (lastMouseEvent && event.type === 'mousemove') {
                lastMovementX = event.screenX - lastMouseEvent.screenX;
                lastMovementY = event.screenY - lastMouseEvent.screenY;
            } else {
                lastMovementX = 0;
                lastMovementY = 0;
            }
            lastMouseEvent = event;
        }
    }
    /**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var MouseEventInterface = _assign({}, UIEventInterface, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: getEventModifierState,
        button: 0,
        buttons: 0,
        relatedTarget: function(event) {
            if (event.relatedTarget === undefined) return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
            return event.relatedTarget;
        },
        movementX: function(event) {
            if ('movementX' in event) return event.movementX;
            updateMouseMovementPolyfillState(event);
            return lastMovementX;
        },
        movementY: function(event) {
            if ('movementY' in event) return event.movementY;
             // Don't need to call updateMouseMovementPolyfillState() here
            // because it's guaranteed to have already run when movementX
            // was copied.
            return lastMovementY;
        }
    });
    var SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface);
    /**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var DragEventInterface = _assign({}, MouseEventInterface, {
        dataTransfer: 0
    });
    var SyntheticDragEvent = createSyntheticEvent(DragEventInterface);
    /**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var FocusEventInterface = _assign({}, UIEventInterface, {
        relatedTarget: 0
    });
    var SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */ var AnimationEventInterface = _assign({}, EventInterface, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */ var ClipboardEventInterface = _assign({}, EventInterface, {
        clipboardData: function(event) {
            return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
        }
    });
    var SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */ var CompositionEventInterface = _assign({}, EventInterface, {
        data: 0
    });
    var SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */ // Happens to share the same list for now.
    var SyntheticInputEvent = SyntheticCompositionEvent;
    /**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var normalizeKey = {
        Esc: 'Escape',
        Spacebar: ' ',
        Left: 'ArrowLeft',
        Up: 'ArrowUp',
        Right: 'ArrowRight',
        Down: 'ArrowDown',
        Del: 'Delete',
        Win: 'OS',
        Menu: 'ContextMenu',
        Apps: 'ContextMenu',
        Scroll: 'ScrollLock',
        MozPrintableKey: 'Unidentified'
    };
    /**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var translateToKey = {
        '8': 'Backspace',
        '9': 'Tab',
        '12': 'Clear',
        '13': 'Enter',
        '16': 'Shift',
        '17': 'Control',
        '18': 'Alt',
        '19': 'Pause',
        '20': 'CapsLock',
        '27': 'Escape',
        '32': ' ',
        '33': 'PageUp',
        '34': 'PageDown',
        '35': 'End',
        '36': 'Home',
        '37': 'ArrowLeft',
        '38': 'ArrowUp',
        '39': 'ArrowRight',
        '40': 'ArrowDown',
        '45': 'Insert',
        '46': 'Delete',
        '112': 'F1',
        '113': 'F2',
        '114': 'F3',
        '115': 'F4',
        '116': 'F5',
        '117': 'F6',
        '118': 'F7',
        '119': 'F8',
        '120': 'F9',
        '121': 'F10',
        '122': 'F11',
        '123': 'F12',
        '144': 'NumLock',
        '145': 'ScrollLock',
        '224': 'Meta'
    };
    /**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */ function getEventKey(nativeEvent) {
        if (nativeEvent.key) {
            // Normalize inconsistent values reported by browsers due to
            // implementations of a working draft specification.
            // FireFox implements `key` but returns `MozPrintableKey` for all
            // printable characters (normalized to `Unidentified`), ignore it.
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if (key !== 'Unidentified') return key;
        } // Browser does not implement `key`, polyfill as much of it as we can.
        if (nativeEvent.type === 'keypress') {
            var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
            // thus be captured by `keypress`, no other non-printable key should.
            return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
        }
        if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') // While user keyboard layout determines the actual meaning of each
        // `keyCode` value, almost all function keys have a universal value.
        return translateToKey[nativeEvent.keyCode] || 'Unidentified';
        return '';
    }
    /**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */ var modifierKeyToProp = {
        Alt: 'altKey',
        Control: 'ctrlKey',
        Meta: 'metaKey',
        Shift: 'shiftKey'
    }; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
    // getModifierState. If getModifierState is not supported, we map it to a set of
    // modifier keys exposed by the event. In this case, Lock-keys are not supported.
    function modifierStateGetter(keyArg) {
        var syntheticEvent = this;
        var nativeEvent = syntheticEvent.nativeEvent;
        if (nativeEvent.getModifierState) return nativeEvent.getModifierState(keyArg);
        var keyProp = modifierKeyToProp[keyArg];
        return keyProp ? !!nativeEvent[keyProp] : false;
    }
    function getEventModifierState(nativeEvent) {
        return modifierStateGetter;
    }
    /**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var KeyboardEventInterface = _assign({}, UIEventInterface, {
        key: getEventKey,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: getEventModifierState,
        // Legacy Interface
        charCode: function(event) {
            // `charCode` is the result of a KeyPress event and represents the value of
            // the actual printable character.
            // KeyPress is deprecated, but its replacement is not yet final and not
            // implemented in any major browser. Only KeyPress has charCode.
            if (event.type === 'keypress') return getEventCharCode(event);
            return 0;
        },
        keyCode: function(event) {
            // `keyCode` is the result of a KeyDown/Up event and represents the value of
            // physical keyboard key.
            // The actual meaning of the value depends on the users' keyboard layout
            // which cannot be detected. Assuming that it is a US keyboard layout
            // provides a surprisingly accurate mapping for US and European users.
            // Due to this, it is left to the user to implement at this time.
            if (event.type === 'keydown' || event.type === 'keyup') return event.keyCode;
            return 0;
        },
        which: function(event) {
            // `which` is an alias for either `keyCode` or `charCode` depending on the
            // type of the event.
            if (event.type === 'keypress') return getEventCharCode(event);
            if (event.type === 'keydown' || event.type === 'keyup') return event.keyCode;
            return 0;
        }
    });
    var SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface);
    /**
 * @interface PointerEvent
 * @see http://www.w3.org/TR/pointerevents/
 */ var PointerEventInterface = _assign({}, MouseEventInterface, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    });
    var SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface);
    /**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */ var TouchEventInterface = _assign({}, UIEventInterface, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: getEventModifierState
    });
    var SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */ var TransitionEventInterface = _assign({}, EventInterface, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface);
    /**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var WheelEventInterface = _assign({}, MouseEventInterface, {
        deltaX: function(event) {
            return 'deltaX' in event ? event.deltaX : 'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function(event) {
            return 'deltaY' in event ? event.deltaY : 'wheelDeltaY' in event ? -event.wheelDeltaY : 'wheelDelta' in event ? -event.wheelDelta : 0;
        },
        deltaZ: 0,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: 0
    });
    var SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface);
    var END_KEYCODES = [
        9,
        13,
        27,
        32
    ]; // Tab, Return, Esc, Space
    var START_KEYCODE = 229;
    var canUseCompositionEvent = canUseDOM && 'CompositionEvent' in window;
    var documentMode = null;
    if (canUseDOM && 'documentMode' in document) documentMode = document.documentMode;
     // Webkit offers a very useful `textInput` event that can be used to
    // directly represent `beforeInput`. The IE `textinput` event is not as
    // useful, so we don't use it.
    var canUseTextInputEvent = canUseDOM && 'TextEvent' in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
    // by the native compositionend event may be incorrect. Japanese ideographic
    // spaces, for instance (\u3000) are not recorded correctly.
    var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
    var SPACEBAR_CODE = 32;
    var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
    function registerEvents() {
        registerTwoPhaseEvent('onBeforeInput', [
            'compositionend',
            'keypress',
            'textInput',
            'paste'
        ]);
        registerTwoPhaseEvent('onCompositionEnd', [
            'compositionend',
            'focusout',
            'keydown',
            'keypress',
            'keyup',
            'mousedown'
        ]);
        registerTwoPhaseEvent('onCompositionStart', [
            'compositionstart',
            'focusout',
            'keydown',
            'keypress',
            'keyup',
            'mousedown'
        ]);
        registerTwoPhaseEvent('onCompositionUpdate', [
            'compositionupdate',
            'focusout',
            'keydown',
            'keypress',
            'keyup',
            'mousedown'
        ]);
    } // Track whether we've ever handled a keypress on the space key.
    var hasSpaceKeypress = false;
    /**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */ function isKeypressCommand(nativeEvent) {
        return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
        !(nativeEvent.ctrlKey && nativeEvent.altKey);
    }
    /**
 * Translate native top level events into event types.
 */ function getCompositionEventType(domEventName) {
        switch(domEventName){
            case 'compositionstart':
                return 'onCompositionStart';
            case 'compositionend':
                return 'onCompositionEnd';
            case 'compositionupdate':
                return 'onCompositionUpdate';
        }
    }
    /**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 */ function isFallbackCompositionStart(domEventName, nativeEvent) {
        return domEventName === 'keydown' && nativeEvent.keyCode === START_KEYCODE;
    }
    /**
 * Does our fallback mode think that this event is the end of composition?
 */ function isFallbackCompositionEnd(domEventName, nativeEvent) {
        switch(domEventName){
            case 'keyup':
                // Command keys insert or clear IME input.
                return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
            case 'keydown':
                // Expect IME keyCode on each keydown. If we get any other
                // code we must have exited earlier.
                return nativeEvent.keyCode !== START_KEYCODE;
            case 'keypress':
            case 'mousedown':
            case 'focusout':
                // Events are not possible without cancelling IME.
                return true;
            default:
                return false;
        }
    }
    /**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */ function getDataFromCustomEvent(nativeEvent) {
        var detail = nativeEvent.detail;
        if (typeof detail === 'object' && 'data' in detail) return detail.data;
        return null;
    }
    /**
 * Check if a composition event was triggered by Korean IME.
 * Our fallback mode does not work well with IE's Korean IME,
 * so just use native composition events when Korean IME is used.
 * Although CompositionEvent.locale property is deprecated,
 * it is available in IE, where our fallback mode is enabled.
 *
 * @param {object} nativeEvent
 * @return {boolean}
 */ function isUsingKoreanIME(nativeEvent) {
        return nativeEvent.locale === 'ko';
    } // Track the current IME composition status, if any.
    var isComposing = false;
    /**
 * @return {?object} A SyntheticCompositionEvent.
 */ function extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var eventType;
        var fallbackData;
        if (canUseCompositionEvent) eventType = getCompositionEventType(domEventName);
        else if (!isComposing) {
            if (isFallbackCompositionStart(domEventName, nativeEvent)) eventType = 'onCompositionStart';
        } else if (isFallbackCompositionEnd(domEventName, nativeEvent)) eventType = 'onCompositionEnd';
        if (!eventType) return null;
        if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
            // The current composition is stored statically and must not be
            // overwritten while composition continues.
            if (!isComposing && eventType === 'onCompositionStart') isComposing = initialize(nativeEventTarget);
            else if (eventType === 'onCompositionEnd') {
                if (isComposing) fallbackData = getData();
            }
        }
        var listeners = accumulateTwoPhaseListeners(targetInst, eventType);
        if (listeners.length > 0) {
            var event = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            if (fallbackData) // Inject data generated from fallback path into the synthetic event.
            // This matches the property of native CompositionEventInterface.
            event.data = fallbackData;
            else {
                var customData = getDataFromCustomEvent(nativeEvent);
                if (customData !== null) event.data = customData;
            }
        }
    }
    function getNativeBeforeInputChars(domEventName, nativeEvent) {
        switch(domEventName){
            case 'compositionend':
                return getDataFromCustomEvent(nativeEvent);
            case 'keypress':
                /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */ var which = nativeEvent.which;
                if (which !== SPACEBAR_CODE) return null;
                hasSpaceKeypress = true;
                return SPACEBAR_CHAR;
            case 'textInput':
                // Record the characters to be added to the DOM.
                var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
                // it at the keypress level and bail immediately. Android Chrome
                // doesn't give us keycodes, so we need to ignore it.
                if (chars === SPACEBAR_CHAR && hasSpaceKeypress) return null;
                return chars;
            default:
                // For other native event types, do nothing.
                return null;
        }
    }
    /**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 */ function getFallbackBeforeInputChars(domEventName, nativeEvent) {
        // If we are currently composing (IME) and using a fallback to do so,
        // try to extract the composed characters from the fallback object.
        // If composition event is available, we extract a string only at
        // compositionevent, otherwise extract it at fallback events.
        if (isComposing) {
            if (domEventName === 'compositionend' || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent)) {
                var chars = getData();
                reset();
                isComposing = false;
                return chars;
            }
            return null;
        }
        switch(domEventName){
            case 'paste':
                // If a paste event occurs after a keypress, throw out the input
                // chars. Paste events should not lead to BeforeInput events.
                return null;
            case 'keypress':
                /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */ if (!isKeypressCommand(nativeEvent)) {
                    // IE fires the `keypress` event when a user types an emoji via
                    // Touch keyboard of Windows.  In such a case, the `char` property
                    // holds an emoji character like `\uD83D\uDE0A`.  Because its length
                    // is 2, the property `which` does not represent an emoji correctly.
                    // In such a case, we directly return the `char` property instead of
                    // using `which`.
                    if (nativeEvent.char && nativeEvent.char.length > 1) return nativeEvent.char;
                    else if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
                }
                return null;
            case 'compositionend':
                return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;
            default:
                return null;
        }
    }
    /**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */ function extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var chars;
        if (canUseTextInputEvent) chars = getNativeBeforeInputChars(domEventName, nativeEvent);
        else chars = getFallbackBeforeInputChars(domEventName, nativeEvent);
         // If no characters are being inserted, no BeforeInput event should
        // be fired.
        if (!chars) return null;
        var listeners = accumulateTwoPhaseListeners(targetInst, 'onBeforeInput');
        if (listeners.length > 0) {
            var event = new SyntheticInputEvent('onBeforeInput', 'beforeinput', null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            event.data = chars;
        }
    }
    /**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */ function extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
    }
    /**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */ var supportedInputTypes = {
        color: true,
        date: true,
        datetime: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        password: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true
    };
    function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        if (nodeName === 'input') return !!supportedInputTypes[elem.type];
        if (nodeName === 'textarea') return true;
        return false;
    }
    /**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) return false;
        var eventName = 'on' + eventNameSuffix;
        var isSupported = eventName in document;
        if (!isSupported) {
            var element = document.createElement('div');
            element.setAttribute(eventName, 'return;');
            isSupported = typeof element[eventName] === 'function';
        }
        return isSupported;
    }
    function registerEvents$1() {
        registerTwoPhaseEvent('onChange', [
            'change',
            'click',
            'focusin',
            'focusout',
            'input',
            'keydown',
            'keyup',
            'selectionchange'
        ]);
    }
    function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
        // Flag this event loop as needing state restore.
        enqueueStateRestore(target);
        var listeners = accumulateTwoPhaseListeners(inst, 'onChange');
        if (listeners.length > 0) {
            var event = new SyntheticEvent('onChange', 'change', null, nativeEvent, target);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
        }
    }
    /**
 * For IE shims
 */ var activeElement = null;
    var activeElementInst = null;
    /**
 * SECTION: handle `change` event
 */ function shouldUseChangeEvent(elem) {
        var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
    }
    function manualDispatchChangeEvent(nativeEvent) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
        // other events and have it go through ReactBrowserEventEmitter. Since it
        // doesn't, we manually listen for the events and so we have to enqueue and
        // process the abstract event manually.
        //
        // Batching is necessary here in order to ensure that all event handlers run
        // before the next rerender (including event handlers attached to ancestor
        // elements instead of directly on the input). Without this, controlled
        // components don't work properly in conjunction with event bubbling because
        // the component is rerendered and the value reverted before all the event
        // handlers can run. See https://github.com/facebook/react/issues/708.
        batchedUpdates(runEventInBatch, dispatchQueue);
    }
    function runEventInBatch(dispatchQueue) {
        processDispatchQueue(dispatchQueue, 0);
    }
    function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance(targetInst);
        if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(domEventName, targetInst) {
        if (domEventName === 'change') return targetInst;
    }
    /**
 * SECTION: handle `input` event
 */ var isInputEventSupported = false;
    if (canUseDOM) // IE9 claims to support the input event but fails to trigger it when
    // deleting text, so we ignore its input events.
    isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
    /**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */ function startWatchingForValueChange(target, targetInst) {
        activeElement = target;
        activeElementInst = targetInst;
        activeElement.attachEvent('onpropertychange', handlePropertyChange);
    }
    /**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */ function stopWatchingForValueChange() {
        if (!activeElement) return;
        activeElement.detachEvent('onpropertychange', handlePropertyChange);
        activeElement = null;
        activeElementInst = null;
    }
    /**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */ function handlePropertyChange(nativeEvent) {
        if (nativeEvent.propertyName !== 'value') return;
        if (getInstIfValueChanged(activeElementInst)) manualDispatchChangeEvent(nativeEvent);
    }
    function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
        if (domEventName === 'focusin') {
            // In IE9, propertychange fires for most input events but is buggy and
            // doesn't fire when text is deleted, but conveniently, selectionchange
            // appears to fire in all of the remaining cases so we catch those and
            // forward the event if the value has changed
            // In either case, we don't want to call the event handler if the value
            // is changed from JS so we redefine a setter for `.value` that updates
            // our activeElementValue variable, allowing us to ignore those changes
            //
            // stopWatching() should be a noop here but we call it just in case we
            // missed a blur event somehow.
            stopWatchingForValueChange();
            startWatchingForValueChange(target, targetInst);
        } else if (domEventName === 'focusout') stopWatchingForValueChange();
    } // For IE8 and IE9.
    function getTargetInstForInputEventPolyfill(domEventName, targetInst) {
        if (domEventName === 'selectionchange' || domEventName === 'keyup' || domEventName === 'keydown') // On the selectionchange event, the target is just document which isn't
        // helpful for us so just check activeElement instead.
        //
        // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
        // propertychange on the first input event after setting `value` from a
        // script and fires only keydown, keypress, keyup. Catching keyup usually
        // gets it and catching keydown lets us fire an event for the first
        // keystroke if user does a key repeat (it'll be a little delayed: right
        // before the second keystroke). Other input methods (e.g., paste) seem to
        // fire selectionchange normally.
        return getInstIfValueChanged(activeElementInst);
    }
    /**
 * SECTION: handle `click` event
 */ function shouldUseClickEvent(elem) {
        // Use the `click` event to detect changes to checkbox and radio inputs.
        // This approach works across all browsers, whereas `change` does not fire
        // until `blur` in IE8.
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
    }
    function getTargetInstForClickEvent(domEventName, targetInst) {
        if (domEventName === 'click') return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
        if (domEventName === 'input' || domEventName === 'change') return getInstIfValueChanged(targetInst);
    }
    function handleControlledInputBlur(node) {
        var state = node._wrapperState;
        if (!state || !state.controlled || node.type !== 'number') return;
        // If controlled, assign the value attribute to the current value on blur
        setDefaultValue(node, 'number', node.value);
    }
    /**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */ function extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        var getTargetInstFunc, handleEventFunc;
        if (shouldUseChangeEvent(targetNode)) getTargetInstFunc = getTargetInstForChangeEvent;
        else if (isTextInputElement(targetNode)) {
            if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
            else {
                getTargetInstFunc = getTargetInstForInputEventPolyfill;
                handleEventFunc = handleEventsForInputEventPolyfill;
            }
        } else if (shouldUseClickEvent(targetNode)) getTargetInstFunc = getTargetInstForClickEvent;
        if (getTargetInstFunc) {
            var inst = getTargetInstFunc(domEventName, targetInst);
            if (inst) {
                createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, nativeEventTarget);
                return;
            }
        }
        if (handleEventFunc) handleEventFunc(domEventName, targetNode, targetInst);
         // When blurring, set the value attribute for number inputs
        if (domEventName === 'focusout') handleControlledInputBlur(targetNode);
    }
    function registerEvents$2() {
        registerDirectEvent('onMouseEnter', [
            'mouseout',
            'mouseover'
        ]);
        registerDirectEvent('onMouseLeave', [
            'mouseout',
            'mouseover'
        ]);
        registerDirectEvent('onPointerEnter', [
            'pointerout',
            'pointerover'
        ]);
        registerDirectEvent('onPointerLeave', [
            'pointerout',
            'pointerover'
        ]);
    }
    /**
 * For almost every interaction we care about, there will be both a top-level
 * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
 * we do not extract duplicate events. However, moving the mouse into the
 * browser from outside will not fire a `mouseout` event. In this case, we use
 * the `mouseover` top-level event.
 */ function extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var isOverEvent = domEventName === 'mouseover' || domEventName === 'pointerover';
        var isOutEvent = domEventName === 'mouseout' || domEventName === 'pointerout';
        if (isOverEvent && (eventSystemFlags & IS_REPLAYED) === 0) {
            // If this is an over event with a target, we might have already dispatched
            // the event in the out event of the other target. If this is replayed,
            // then it's because we couldn't dispatch against this target previously
            // so we have to do it now instead.
            var related = nativeEvent.relatedTarget || nativeEvent.fromElement;
            if (related) {
                // If the related node is managed by React, we can assume that we have
                // already dispatched the corresponding events during its mouseout.
                if (getClosestInstanceFromNode(related) || isContainerMarkedAsRoot(related)) return;
            }
        }
        if (!isOutEvent && !isOverEvent) // Must not be a mouse or pointer in or out - ignoring.
        return;
        var win; // TODO: why is this nullable in the types but we read from it?
        if (nativeEventTarget.window === nativeEventTarget) // `nativeEventTarget` is probably a window object.
        win = nativeEventTarget;
        else {
            // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
            var doc = nativeEventTarget.ownerDocument;
            if (doc) win = doc.defaultView || doc.parentWindow;
            else win = window;
        }
        var from;
        var to;
        if (isOutEvent) {
            var _related = nativeEvent.relatedTarget || nativeEvent.toElement;
            from = targetInst;
            to = _related ? getClosestInstanceFromNode(_related) : null;
            if (to !== null) {
                var nearestMounted = getNearestMountedFiber(to);
                if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) to = null;
            }
        } else {
            // Moving to a node from outside the window.
            from = null;
            to = targetInst;
        }
        if (from === to) // Nothing pertains to our managed components.
        return;
        var SyntheticEventCtor = SyntheticMouseEvent;
        var leaveEventType = 'onMouseLeave';
        var enterEventType = 'onMouseEnter';
        var eventTypePrefix = 'mouse';
        if (domEventName === 'pointerout' || domEventName === 'pointerover') {
            SyntheticEventCtor = SyntheticPointerEvent;
            leaveEventType = 'onPointerLeave';
            enterEventType = 'onPointerEnter';
            eventTypePrefix = 'pointer';
        }
        var fromNode = from == null ? win : getNodeFromInstance(from);
        var toNode = to == null ? win : getNodeFromInstance(to);
        var leave = new SyntheticEventCtor(leaveEventType, eventTypePrefix + 'leave', from, nativeEvent, nativeEventTarget);
        leave.target = fromNode;
        leave.relatedTarget = toNode;
        var enter = null; // We should only process this nativeEvent if we are processing
        // the first ancestor. Next time, we will ignore the event.
        var nativeTargetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (nativeTargetInst === targetInst) {
            var enterEvent = new SyntheticEventCtor(enterEventType, eventTypePrefix + 'enter', to, nativeEvent, nativeEventTarget);
            enterEvent.target = toNode;
            enterEvent.relatedTarget = fromNode;
            enter = enterEvent;
        }
        accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leave, enter, from, to);
    }
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === 'function' ? Object.is : is;
    var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
    /**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return true;
        if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(var i = 0; i < keysA.length; i++){
            if (!hasOwnProperty$2.call(objB, keysA[i]) || !objectIs(objA[keysA[i]], objB[keysA[i]])) return false;
        }
        return true;
    }
    /**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */ function getLeafNode(node) {
        while(node && node.firstChild)node = node.firstChild;
        return node;
    }
    /**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */ function getSiblingNode(node) {
        while(node){
            if (node.nextSibling) return node.nextSibling;
            node = node.parentNode;
        }
    }
    /**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */ function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        var nodeStart = 0;
        var nodeEnd = 0;
        while(node){
            if (node.nodeType === TEXT_NODE) {
                nodeEnd = nodeStart + node.textContent.length;
                if (nodeStart <= offset && nodeEnd >= offset) return {
                    node: node,
                    offset: offset - nodeStart
                };
                nodeStart = nodeEnd;
            }
            node = getLeafNode(getSiblingNode(node));
        }
    }
    /**
 * @param {DOMElement} outerNode
 * @return {?object}
 */ function getOffsets(outerNode) {
        var ownerDocument = outerNode.ownerDocument;
        var win = ownerDocument && ownerDocument.defaultView || window;
        var selection = win.getSelection && win.getSelection();
        if (!selection || selection.rangeCount === 0) return null;
        var anchorNode = selection.anchorNode, anchorOffset = selection.anchorOffset, focusNode = selection.focusNode, focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
        // up/down buttons on an <input type="number">. Anonymous divs do not seem to
        // expose properties, triggering a "Permission denied error" if any of its
        // properties are accessed. The only seemingly possible way to avoid erroring
        // is to access a property that typically works for non-anonymous divs and
        // catch any error that may otherwise arise. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
        try {
            /* eslint-disable no-unused-expressions */ anchorNode.nodeType;
            focusNode.nodeType;
        /* eslint-enable no-unused-expressions */ } catch (e) {
            return null;
        }
        return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
    }
    /**
 * Returns {start, end} where `start` is the character/codepoint index of
 * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
 * `end` is the index of (focusNode, focusOffset).
 *
 * Returns null if you pass in garbage input but we should probably just crash.
 *
 * Exported only for testing.
 */ function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
        var length = 0;
        var start = -1;
        var end = -1;
        var indexWithinAnchor = 0;
        var indexWithinFocus = 0;
        var node = outerNode;
        var parentNode = null;
        outer: while(true){
            var next = null;
            while(true){
                if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) start = length + anchorOffset;
                if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) end = length + focusOffset;
                if (node.nodeType === TEXT_NODE) length += node.nodeValue.length;
                if ((next = node.firstChild) === null) break;
                 // Moving from `node` to its first child `next`.
                parentNode = node;
                node = next;
            }
            while(true){
                if (node === outerNode) break outer;
                if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) start = length;
                if (parentNode === focusNode && ++indexWithinFocus === focusOffset) end = length;
                if ((next = node.nextSibling) !== null) break;
                node = parentNode;
                parentNode = node.parentNode;
            } // Moving from `node` to its next sibling `next`.
            node = next;
        }
        if (start === -1 || end === -1) // This should never happen. (Would happen if the anchor/focus nodes aren't
        // actually inside the passed-in node.)
        return null;
        return {
            start: start,
            end: end
        };
    }
    /**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */ function setOffsets(node, offsets) {
        var doc = node.ownerDocument || document;
        var win = doc && doc.defaultView || window; // Edge fails with "Object expected" in some scenarios.
        // (For instance: TinyMCE editor used in a list component that supports pasting to add more,
        // fails when pasting 100+ items)
        if (!win.getSelection) return;
        var selection = win.getSelection();
        var length = node.textContent.length;
        var start = Math.min(offsets.start, length);
        var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
        // Flip backward selections, so we can set with a single range.
        if (!selection.extend && start > end) {
            var temp = end;
            end = start;
            start = temp;
        }
        var startMarker = getNodeForCharacterOffset(node, start);
        var endMarker = getNodeForCharacterOffset(node, end);
        if (startMarker && endMarker) {
            if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) return;
            var range = doc.createRange();
            range.setStart(startMarker.node, startMarker.offset);
            selection.removeAllRanges();
            if (start > end) {
                selection.addRange(range);
                selection.extend(endMarker.node, endMarker.offset);
            } else {
                range.setEnd(endMarker.node, endMarker.offset);
                selection.addRange(range);
            }
        }
    }
    function isTextNode(node) {
        return node && node.nodeType === TEXT_NODE;
    }
    function containsNode(outerNode, innerNode) {
        if (!outerNode || !innerNode) return false;
        else if (outerNode === innerNode) return true;
        else if (isTextNode(outerNode)) return false;
        else if (isTextNode(innerNode)) return containsNode(outerNode, innerNode.parentNode);
        else if ('contains' in outerNode) return outerNode.contains(innerNode);
        else if (outerNode.compareDocumentPosition) return !!(outerNode.compareDocumentPosition(innerNode) & 16);
        else return false;
    }
    function isInDocument(node) {
        return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
    }
    function isSameOriginFrame(iframe) {
        try {
            // Accessing the contentDocument of a HTMLIframeElement can cause the browser
            // to throw, e.g. if it has a cross-origin src attribute.
            // Safari will show an error in the console when the access results in "Blocked a frame with origin". e.g:
            // iframe.contentDocument.defaultView;
            // A safety way is to access one of the cross origin properties: Window or Location
            // Which might result in "SecurityError" DOM Exception and it is compatible to Safari.
            // https://html.spec.whatwg.org/multipage/browsers.html#integration-with-idl
            return typeof iframe.contentWindow.location.href === 'string';
        } catch (err) {
            return false;
        }
    }
    function getActiveElementDeep() {
        var win = window;
        var element = getActiveElement();
        while(element instanceof win.HTMLIFrameElement){
            if (isSameOriginFrame(element)) win = element.contentWindow;
            else return element;
            element = getActiveElement(win.document);
        }
        return element;
    }
    /**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */ /**
 * @hasSelectionCapabilities: we get the element types that support selection
 * from https://html.spec.whatwg.org/#do-not-apply, looking at `selectionStart`
 * and `selectionEnd` rows.
 */ function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && (nodeName === 'input' && (elem.type === 'text' || elem.type === 'search' || elem.type === 'tel' || elem.type === 'url' || elem.type === 'password') || nodeName === 'textarea' || elem.contentEditable === 'true');
    }
    function getSelectionInformation() {
        var focusedElem = getActiveElementDeep();
        return {
            focusedElem: focusedElem,
            selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
        };
    }
    /**
 * @restoreSelection: If any selection information was potentially lost,
 * restore it. This is useful when performing operations that could remove dom
 * nodes and place them back in, resulting in focus being lost.
 */ function restoreSelection(priorSelectionInformation) {
        var curFocusedElem = getActiveElementDeep();
        var priorFocusedElem = priorSelectionInformation.focusedElem;
        var priorSelectionRange = priorSelectionInformation.selectionRange;
        if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
            if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) setSelection(priorFocusedElem, priorSelectionRange);
             // Focusing a node can change the scroll position, which is undesirable
            var ancestors = [];
            var ancestor = priorFocusedElem;
            while(ancestor = ancestor.parentNode)if (ancestor.nodeType === ELEMENT_NODE) ancestors.push({
                element: ancestor,
                left: ancestor.scrollLeft,
                top: ancestor.scrollTop
            });
            if (typeof priorFocusedElem.focus === 'function') priorFocusedElem.focus();
            for(var i = 0; i < ancestors.length; i++){
                var info = ancestors[i];
                info.element.scrollLeft = info.left;
                info.element.scrollTop = info.top;
            }
        }
    }
    /**
 * @getSelection: Gets the selection bounds of a focused textarea, input or
 * contentEditable node.
 * -@input: Look up selection bounds of this input
 * -@return {start: selectionStart, end: selectionEnd}
 */ function getSelection(input) {
        var selection;
        if ('selectionStart' in input) // Modern browser with input or textarea.
        selection = {
            start: input.selectionStart,
            end: input.selectionEnd
        };
        else // Content editable or old IE textarea.
        selection = getOffsets(input);
        return selection || {
            start: 0,
            end: 0
        };
    }
    /**
 * @setSelection: Sets the selection bounds of a textarea or input and focuses
 * the input.
 * -@input     Set selection bounds of this input or textarea
 * -@offsets   Object of same form that is returned from get*
 */ function setSelection(input, offsets) {
        var start = offsets.start;
        var end = offsets.end;
        if (end === undefined) end = start;
        if ('selectionStart' in input) {
            input.selectionStart = start;
            input.selectionEnd = Math.min(end, input.value.length);
        } else setOffsets(input, offsets);
    }
    var skipSelectionChangeEvent = canUseDOM && 'documentMode' in document && document.documentMode <= 11;
    function registerEvents$3() {
        registerTwoPhaseEvent('onSelect', [
            'focusout',
            'contextmenu',
            'dragend',
            'focusin',
            'keydown',
            'keyup',
            'mousedown',
            'mouseup',
            'selectionchange'
        ]);
    }
    var activeElement$1 = null;
    var activeElementInst$1 = null;
    var lastSelection = null;
    var mouseDown = false;
    /**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 */ function getSelection$1(node) {
        if ('selectionStart' in node && hasSelectionCapabilities(node)) return {
            start: node.selectionStart,
            end: node.selectionEnd
        };
        else {
            var win = node.ownerDocument && node.ownerDocument.defaultView || window;
            var selection = win.getSelection();
            return {
                anchorNode: selection.anchorNode,
                anchorOffset: selection.anchorOffset,
                focusNode: selection.focusNode,
                focusOffset: selection.focusOffset
            };
        }
    }
    /**
 * Get document associated with the event target.
 */ function getEventTargetDocument(eventTarget) {
        return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
    }
    /**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @param {object} nativeEventTarget
 * @return {?SyntheticEvent}
 */ function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
        // Ensure we have the right element, and that the user is not dragging a
        // selection (this matches native `select` event behavior). In HTML5, select
        // fires only on input and textarea thus if there's no focused element we
        // won't dispatch.
        var doc = getEventTargetDocument(nativeEventTarget);
        if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) return;
         // Only fire when selection has actually changed.
        var currentSelection = getSelection$1(activeElement$1);
        if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
            lastSelection = currentSelection;
            var listeners = accumulateTwoPhaseListeners(activeElementInst$1, 'onSelect');
            if (listeners.length > 0) {
                var event = new SyntheticEvent('onSelect', 'select', null, nativeEvent, nativeEventTarget);
                dispatchQueue.push({
                    event: event,
                    listeners: listeners
                });
                event.target = activeElement$1;
            }
        }
    }
    /**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */ function extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        switch(domEventName){
            // Track the input node that has focus.
            case 'focusin':
                if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
                    activeElement$1 = targetNode;
                    activeElementInst$1 = targetInst;
                    lastSelection = null;
                }
                break;
            case 'focusout':
                activeElement$1 = null;
                activeElementInst$1 = null;
                lastSelection = null;
                break;
            // Don't fire the event while the user is dragging. This matches the
            // semantics of the native select event.
            case 'mousedown':
                mouseDown = true;
                break;
            case 'contextmenu':
            case 'mouseup':
            case 'dragend':
                mouseDown = false;
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                break;
            // Chrome and IE fire non-standard event when selection is changed (and
            // sometimes when it hasn't). IE's event fires out of order with respect
            // to key and input events on deletion, so we discard it.
            //
            // Firefox doesn't support selectionchange, so check selection status
            // after each key entry. The selection changes after keydown and before
            // keyup, but we check on keydown as well in the case of holding down a
            // key, when multiple keydown events are fired but only one keyup is.
            // This is also our approach for IE handling, for the reason above.
            case 'selectionchange':
                if (skipSelectionChangeEvent) break;
            // falls through
            case 'keydown':
            case 'keyup':
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
        }
    }
    function extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var reactName = topLevelEventsToReactNames.get(domEventName);
        if (reactName === undefined) return;
        var SyntheticEventCtor = SyntheticEvent;
        var reactEventType = domEventName;
        switch(domEventName){
            case 'keypress':
                // Firefox creates a keypress event for function keys too. This removes
                // the unwanted keypress events. Enter is however both printable and
                // non-printable. One would expect Tab to be as well (but it isn't).
                if (getEventCharCode(nativeEvent) === 0) return;
            /* falls through */ case 'keydown':
            case 'keyup':
                SyntheticEventCtor = SyntheticKeyboardEvent;
                break;
            case 'focusin':
                reactEventType = 'focus';
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case 'focusout':
                reactEventType = 'blur';
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case 'beforeblur':
            case 'afterblur':
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case 'click':
                // Firefox creates a click event on right mouse clicks. This removes the
                // unwanted click events.
                if (nativeEvent.button === 2) return;
            /* falls through */ case 'auxclick':
            case 'dblclick':
            case 'mousedown':
            case 'mousemove':
            case 'mouseup':
            /* falls through */ case 'mouseout':
            case 'mouseover':
            case 'contextmenu':
                SyntheticEventCtor = SyntheticMouseEvent;
                break;
            case 'drag':
            case 'dragend':
            case 'dragenter':
            case 'dragexit':
            case 'dragleave':
            case 'dragover':
            case 'dragstart':
            case 'drop':
                SyntheticEventCtor = SyntheticDragEvent;
                break;
            case 'touchcancel':
            case 'touchend':
            case 'touchmove':
            case 'touchstart':
                SyntheticEventCtor = SyntheticTouchEvent;
                break;
            case ANIMATION_END:
            case ANIMATION_ITERATION:
            case ANIMATION_START:
                SyntheticEventCtor = SyntheticAnimationEvent;
                break;
            case TRANSITION_END:
                SyntheticEventCtor = SyntheticTransitionEvent;
                break;
            case 'scroll':
                SyntheticEventCtor = SyntheticUIEvent;
                break;
            case 'wheel':
                SyntheticEventCtor = SyntheticWheelEvent;
                break;
            case 'copy':
            case 'cut':
            case 'paste':
                SyntheticEventCtor = SyntheticClipboardEvent;
                break;
            case 'gotpointercapture':
            case 'lostpointercapture':
            case 'pointercancel':
            case 'pointerdown':
            case 'pointermove':
            case 'pointerout':
            case 'pointerover':
            case 'pointerup':
                SyntheticEventCtor = SyntheticPointerEvent;
                break;
        }
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        // Some events don't bubble in the browser.
        // In the past, React has always bubbled them, but this can be surprising.
        // We're going to try aligning closer to the browser behavior by not bubbling
        // them in React either. We'll start by not bubbling onScroll, and then expand.
        var accumulateTargetOnly = !inCapturePhase && // TODO: ideally, we'd eventually add all events from
        // nonDelegatedEvents list in DOMPluginEventSystem.
        // Then we can remove this special list.
        // This is a breaking change that can wait until React 18.
        domEventName === 'scroll';
        var _listeners = accumulateSinglePhaseListeners(targetInst, reactName, nativeEvent.type, inCapturePhase, accumulateTargetOnly);
        if (_listeners.length > 0) {
            // Intentionally create event lazily.
            var _event = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: _event,
                listeners: _listeners
            });
        }
    }
    // TODO: remove top-level side effect.
    registerSimpleEvents();
    registerEvents$2();
    registerEvents$1();
    registerEvents$3();
    registerEvents();
    function extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        // TODO: we should remove the concept of a "SimpleEventPlugin".
        // This is the basic functionality of the event system. All
        // the other plugins are essentially polyfills. So the plugin
        // should probably be inlined somewhere and have its logic
        // be core the to event system. This would potentially allow
        // us to ship builds of React without the polyfilled plugins below.
        extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        var shouldProcessPolyfillPlugins = (eventSystemFlags & SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS) === 0; // We don't process these events unless we are in the
        // event's native "bubble" phase, which means that we're
        // not in the capture phase. That's because we emulate
        // the capture phase here still. This is a trade-off,
        // because in an ideal world we would not emulate and use
        // the phases properly, like we do with the SimpleEvent
        // plugin. However, the plugins below either expect
        // emulation (EnterLeave) or use state localized to that
        // plugin (BeforeInput, Change, Select). The state in
        // these modules complicates things, as you'll essentially
        // get the case where the capture phase event might change
        // state, only for the following bubble event to come in
        // later and not trigger anything as the state now
        // invalidates the heuristics of the event plugin. We
        // could alter all these plugins to work in such ways, but
        // that might cause other unknown side-effects that we
        // can't forsee right now.
        if (shouldProcessPolyfillPlugins) {
            extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
    } // List of events that need to be individually attached to media elements.
    var mediaEventTypes = [
        'abort',
        'canplay',
        'canplaythrough',
        'durationchange',
        'emptied',
        'encrypted',
        'ended',
        'error',
        'loadeddata',
        'loadedmetadata',
        'loadstart',
        'pause',
        'play',
        'playing',
        'progress',
        'ratechange',
        'seeked',
        'seeking',
        'stalled',
        'suspend',
        'timeupdate',
        'volumechange',
        'waiting'
    ]; // We should not delegate these events to the container, but rather
    // set them on the actual target element itself. This is primarily
    // because these events do not consistently bubble in the DOM.
    var nonDelegatedEvents = new Set([
        'cancel',
        'close',
        'invalid',
        'load',
        'scroll',
        'toggle'
    ].concat(mediaEventTypes));
    function executeDispatch(event, listener, currentTarget) {
        var type = event.type || 'unknown-event';
        event.currentTarget = currentTarget;
        invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
        event.currentTarget = null;
    }
    function processDispatchQueueItemsInOrder(event, dispatchListeners, inCapturePhase) {
        var previousInstance;
        if (inCapturePhase) for(var i = dispatchListeners.length - 1; i >= 0; i--){
            var _dispatchListeners$i = dispatchListeners[i], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget, listener = _dispatchListeners$i.listener;
            if (instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, listener, currentTarget);
            previousInstance = instance;
        }
        else for(var _i = 0; _i < dispatchListeners.length; _i++){
            var _dispatchListeners$_i = dispatchListeners[_i], _instance = _dispatchListeners$_i.instance, _currentTarget = _dispatchListeners$_i.currentTarget, _listener = _dispatchListeners$_i.listener;
            if (_instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, _listener, _currentTarget);
            previousInstance = _instance;
        }
    }
    function processDispatchQueue(dispatchQueue, eventSystemFlags) {
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        for(var i = 0; i < dispatchQueue.length; i++){
            var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event, listeners = _dispatchQueue$i.listeners;
            processDispatchQueueItemsInOrder(event, listeners, inCapturePhase); //  event system doesn't use pooling.
        } // This would be a good time to rethrow if any of the event handlers threw.
        rethrowCaughtError();
    }
    function dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var nativeEventTarget = getEventTarget(nativeEvent);
        var dispatchQueue = [];
        extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    }
    function listenToNonDelegatedEvent(domEventName, targetElement) {
        var isCapturePhaseListener = false;
        var listenerSet = getEventListenerSet(targetElement);
        var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);
        if (!listenerSet.has(listenerSetKey)) {
            addTrappedEventListener(targetElement, domEventName, IS_NON_DELEGATED, isCapturePhaseListener);
            listenerSet.add(listenerSetKey);
        }
    }
    var listeningMarker = '_reactListening' + Math.random().toString(36).slice(2);
    function listenToAllSupportedEvents(rootContainerElement) {
        if (rootContainerElement[listeningMarker]) // Performance optimization: don't iterate through events
        // for the same portal container or root node more than once.
        // TODO: once we remove the flag, we may be able to also
        // remove some of the bookkeeping maps used for laziness.
        return;
        rootContainerElement[listeningMarker] = true;
        allNativeEvents.forEach(function(domEventName) {
            if (!nonDelegatedEvents.has(domEventName)) listenToNativeEvent(domEventName, false, rootContainerElement, null);
            listenToNativeEvent(domEventName, true, rootContainerElement, null);
        });
    }
    function listenToNativeEvent(domEventName, isCapturePhaseListener, rootContainerElement, targetElement) {
        var eventSystemFlags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
        var target = rootContainerElement; // selectionchange needs to be attached to the document
        // otherwise it won't capture incoming events that are only
        // triggered on the document directly.
        if (domEventName === 'selectionchange' && rootContainerElement.nodeType !== DOCUMENT_NODE) target = rootContainerElement.ownerDocument;
         // If the event can be delegated (or is capture phase), we can
        // register it to the root container. Otherwise, we should
        // register the event to the target element and mark it as
        // a non-delegated event.
        if (targetElement !== null && !isCapturePhaseListener && nonDelegatedEvents.has(domEventName)) {
            // For all non-delegated events, apart from scroll, we attach
            // their event listeners to the respective elements that their
            // events fire on. That means we can skip this step, as event
            // listener has already been added previously. However, we
            // special case the scroll event because the reality is that any
            // element can scroll.
            // TODO: ideally, we'd eventually apply the same logic to all
            // events from the nonDelegatedEvents list. Then we can remove
            // this special case and use the same logic for all events.
            if (domEventName !== 'scroll') return;
            eventSystemFlags |= IS_NON_DELEGATED;
            target = targetElement;
        }
        var listenerSet = getEventListenerSet(target);
        var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener); // If the listener entry is empty or we should upgrade, then
        // we need to trap an event listener onto the target.
        if (!listenerSet.has(listenerSetKey)) {
            if (isCapturePhaseListener) eventSystemFlags |= IS_CAPTURE_PHASE;
            addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
            listenerSet.add(listenerSetKey);
        }
    }
    function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener, isDeferredListenerForLegacyFBSupport) {
        var listener = createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags); // If passive option is not supported, then the event will be
        // active and not passive.
        var isPassiveListener = undefined;
        if (passiveBrowserEventsSupported) // Browsers introduced an intervention, making these events
        // passive by default on document. React doesn't bind them
        // to document anymore, but changing this now would undo
        // the performance wins from the change. So we emulate
        // the existing behavior manually on the roots now.
        // https://github.com/facebook/react/issues/19651
        {
            if (domEventName === 'touchstart' || domEventName === 'touchmove' || domEventName === 'wheel') isPassiveListener = true;
        }
        targetContainer;
        var unsubscribeListener; // When legacyFBSupport is enabled, it's for when we
        if (isCapturePhaseListener) {
            if (isPassiveListener !== undefined) unsubscribeListener = addEventCaptureListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
            else unsubscribeListener = addEventCaptureListener(targetContainer, domEventName, listener);
        } else if (isPassiveListener !== undefined) unsubscribeListener = addEventBubbleListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
        else unsubscribeListener = addEventBubbleListener(targetContainer, domEventName, listener);
    }
    function isMatchingRootContainer(grandContainer, targetContainer) {
        return grandContainer === targetContainer || grandContainer.nodeType === COMMENT_NODE && grandContainer.parentNode === targetContainer;
    }
    function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var ancestorInst = targetInst;
        if ((eventSystemFlags & IS_EVENT_HANDLE_NON_MANAGED_NODE) === 0 && (eventSystemFlags & IS_NON_DELEGATED) === 0) {
            var targetContainerNode = targetContainer; // If we are using the legacy FB support flag, we
            if (targetInst !== null) {
                // The below logic attempts to work out if we need to change
                // the target fiber to a different ancestor. We had similar logic
                // in the legacy event system, except the big difference between
                // systems is that the modern event system now has an event listener
                // attached to each React Root and React Portal Root. Together,
                // the DOM nodes representing these roots are the "rootContainer".
                // To figure out which ancestor instance we should use, we traverse
                // up the fiber tree from the target instance and attempt to find
                // root boundaries that match that of our current "rootContainer".
                // If we find that "rootContainer", we find the parent fiber
                // sub-tree for that root and make that our ancestor instance.
                var node = targetInst;
                mainLoop: while(true){
                    if (node === null) return;
                    var nodeTag = node.tag;
                    if (nodeTag === HostRoot || nodeTag === HostPortal) {
                        var container = node.stateNode.containerInfo;
                        if (isMatchingRootContainer(container, targetContainerNode)) break;
                        if (nodeTag === HostPortal) {
                            // The target is a portal, but it's not the rootContainer we're looking for.
                            // Normally portals handle their own events all the way down to the root.
                            // So we should be able to stop now. However, we don't know if this portal
                            // was part of *our* root.
                            var grandNode = node.return;
                            while(grandNode !== null){
                                var grandTag = grandNode.tag;
                                if (grandTag === HostRoot || grandTag === HostPortal) {
                                    var grandContainer = grandNode.stateNode.containerInfo;
                                    if (isMatchingRootContainer(grandContainer, targetContainerNode)) // This is the rootContainer we're looking for and we found it as
                                    // a parent of the Portal. That means we can ignore it because the
                                    // Portal will bubble through to us.
                                    return;
                                }
                                grandNode = grandNode.return;
                            }
                        } // Now we need to find it's corresponding host fiber in the other
                        // tree. To do this we can use getClosestInstanceFromNode, but we
                        // need to validate that the fiber is a host instance, otherwise
                        // we need to traverse up through the DOM till we find the correct
                        // node that is from the other tree.
                        while(container !== null){
                            var parentNode = getClosestInstanceFromNode(container);
                            if (parentNode === null) return;
                            var parentTag = parentNode.tag;
                            if (parentTag === HostComponent || parentTag === HostText) {
                                node = ancestorInst = parentNode;
                                continue mainLoop;
                            }
                            container = container.parentNode;
                        }
                    }
                    node = node.return;
                }
            }
        }
        batchedEventUpdates(function() {
            return dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, ancestorInst);
        });
    }
    function createDispatchListener(instance, listener, currentTarget) {
        return {
            instance: instance,
            listener: listener,
            currentTarget: currentTarget
        };
    }
    function accumulateSinglePhaseListeners(targetFiber, reactName, nativeEventType, inCapturePhase, accumulateTargetOnly) {
        var captureName = reactName !== null ? reactName + 'Capture' : null;
        var reactEventName = inCapturePhase ? captureName : reactName;
        var listeners = [];
        var instance = targetFiber;
        var lastHostComponent = null; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance2 = instance, stateNode = _instance2.stateNode, tag = _instance2.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                lastHostComponent = stateNode; // createEventHandle listeners
                if (reactEventName !== null) {
                    var listener = getListener(instance, reactEventName);
                    if (listener != null) listeners.push(createDispatchListener(instance, listener, lastHostComponent));
                }
            } // If we are only accumulating events for the target, then we don't
            // continue to propagate through the React fiber tree to find other
            // listeners.
            if (accumulateTargetOnly) break;
            instance = instance.return;
        }
        return listeners;
    } // We should only use this function for:
    // - BeforeInputEventPlugin
    // - ChangeEventPlugin
    // - SelectEventPlugin
    // This is because we only process these plugins
    // in the bubble phase, so we need to accumulate two
    // phase event listeners (via emulation).
    function accumulateTwoPhaseListeners(targetFiber, reactName) {
        var captureName = reactName + 'Capture';
        var listeners = [];
        var instance = targetFiber; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance3 = instance, stateNode = _instance3.stateNode, tag = _instance3.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                var captureListener = getListener(instance, captureName);
                if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                var bubbleListener = getListener(instance, reactName);
                if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
            }
            instance = instance.return;
        }
        return listeners;
    }
    function getParent(inst) {
        if (inst === null) return null;
        do inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
        while (inst && inst.tag !== HostComponent);
        if (inst) return inst;
        return null;
    }
    /**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */ function getLowestCommonAncestor(instA, instB) {
        var nodeA = instA;
        var nodeB = instB;
        var depthA = 0;
        for(var tempA = nodeA; tempA; tempA = getParent(tempA))depthA++;
        var depthB = 0;
        for(var tempB = nodeB; tempB; tempB = getParent(tempB))depthB++;
         // If A is deeper, crawl up.
        while(depthA - depthB > 0){
            nodeA = getParent(nodeA);
            depthA--;
        } // If B is deeper, crawl up.
        while(depthB - depthA > 0){
            nodeB = getParent(nodeB);
            depthB--;
        } // Walk in lockstep until we find a match.
        var depth = depthA;
        while(depth--){
            if (nodeA === nodeB || nodeB !== null && nodeA === nodeB.alternate) return nodeA;
            nodeA = getParent(nodeA);
            nodeB = getParent(nodeB);
        }
        return null;
    }
    function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
        var registrationName = event._reactName;
        var listeners = [];
        var instance = target;
        while(instance !== null){
            if (instance === common) break;
            var _instance4 = instance, alternate = _instance4.alternate, stateNode = _instance4.stateNode, tag = _instance4.tag;
            if (alternate !== null && alternate === common) break;
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                if (inCapturePhase) {
                    var captureListener = getListener(instance, registrationName);
                    if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                } else if (!inCapturePhase) {
                    var bubbleListener = getListener(instance, registrationName);
                    if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
                }
            }
            instance = instance.return;
        }
        if (listeners.length !== 0) dispatchQueue.push({
            event: event,
            listeners: listeners
        });
    } // We should only use this function for:
    // - EnterLeaveEventPlugin
    // This is because we only process this plugin
    // in the bubble phase, so we need to accumulate two
    // phase event listeners.
    function accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leaveEvent, enterEvent, from, to) {
        var common = from && to ? getLowestCommonAncestor(from, to) : null;
        if (from !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, leaveEvent, from, common, false);
        if (to !== null && enterEvent !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, enterEvent, to, common, true);
    }
    function getListenerSetKey(domEventName, capture) {
        return domEventName + "__" + (capture ? 'capture' : 'bubble');
    }
    var didWarnInvalidHydration = false;
    var DANGEROUSLY_SET_INNER_HTML = 'dangerouslySetInnerHTML';
    var SUPPRESS_CONTENT_EDITABLE_WARNING = 'suppressContentEditableWarning';
    var SUPPRESS_HYDRATION_WARNING = 'suppressHydrationWarning';
    var AUTOFOCUS = 'autoFocus';
    var CHILDREN = 'children';
    var STYLE = 'style';
    var HTML$1 = '__html';
    var HTML_NAMESPACE$1 = Namespaces.html;
    var warnedUnknownTags;
    var suppressHydrationWarning;
    var validatePropertiesInDevelopment;
    var warnForTextDifference;
    var warnForPropDifference;
    var warnForExtraAttributes;
    var warnForInvalidEventListener;
    var canDiffStyleForHydrationWarning;
    var normalizeMarkupForTextOrAttribute;
    var normalizeHTML;
    warnedUnknownTags = {
        // There are working polyfills for <dialog>. Let people use it.
        dialog: true,
        // Electron ships a custom <webview> tag to display external web content in
        // an isolated frame and process.
        // This tag is not present in non Electron environments such as JSDom which
        // is often used for testing purposes.
        // @see https://electronjs.org/docs/api/webview-tag
        webview: true
    };
    validatePropertiesInDevelopment = function(type, props) {
        validateProperties(type, props);
        validateProperties$1(type, props);
        validateProperties$2(type, props, {
            registrationNameDependencies: registrationNameDependencies,
            possibleRegistrationNames: possibleRegistrationNames
        });
    }; // IE 11 parses & normalizes the style attribute as opposed to other
    // browsers. It adds spaces and sorts the properties in some
    // non-alphabetical order. Handling that would require sorting CSS
    // properties in the client & server versions or applying
    // `expectedStyle` to a temporary DOM node to read its `style` attribute
    // normalized. Since it only affects IE, we're skipping style warnings
    // in that browser completely in favor of doing all that work.
    // See https://github.com/facebook/react/issues/11807
    canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode; // HTML parsing normalizes CR and CRLF to LF.
    // It also can turn \u0000 into \uFFFD inside attributes.
    // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
    // If we have a mismatch, it might be caused by that.
    // We will still patch up in this case but not fire the warning.
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
    var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
    normalizeMarkupForTextOrAttribute = function(markup) {
        var markupString = typeof markup === 'string' ? markup : '' + markup;
        return markupString.replace(NORMALIZE_NEWLINES_REGEX, '\n').replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, '');
    };
    warnForTextDifference = function(serverText, clientText) {
        if (didWarnInvalidHydration) return;
        var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
        var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);
        if (normalizedServerText === normalizedClientText) return;
        didWarnInvalidHydration = true;
        error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
    };
    warnForPropDifference = function(propName, serverValue, clientValue) {
        if (didWarnInvalidHydration) return;
        var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
        var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);
        if (normalizedServerValue === normalizedClientValue) return;
        didWarnInvalidHydration = true;
        error('Prop `%s` did not match. Server: %s Client: %s', propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
    };
    warnForExtraAttributes = function(attributeNames) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        var names = [];
        attributeNames.forEach(function(name) {
            names.push(name);
        });
        error('Extra attributes from the server: %s', names);
    };
    warnForInvalidEventListener = function(registrationName, listener) {
        if (listener === false) error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName);
        else error('Expected `%s` listener to be a function, instead got a value of `%s` type.', registrationName, typeof listener);
    }; // Parse the HTML and read it back to normalize the HTML string so that it
    // can be used for comparison.
    normalizeHTML = function(parent, html) {
        // We could have created a separate document here to avoid
        // re-initializing custom elements if they exist. But this breaks
        // how <noscript> is being handled. So we use the same document.
        // See the discussion in https://github.com/facebook/react/pull/11157.
        var testElement = parent.namespaceURI === HTML_NAMESPACE$1 ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
        testElement.innerHTML = html;
        return testElement.innerHTML;
    };
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function noop() {}
    function trapClickOnNonInteractiveElement(node) {
        // Mobile Safari does not fire properly bubble click events on
        // non-interactive elements, which means delegated click listeners do not
        // fire. The workaround for this bug involves attaching an empty click
        // listener on the target node.
        // https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
        // Just set it using the onclick property so that we don't have to manage any
        // bookkeeping for it. Not sure if we need to clear it when the listener is
        // removed.
        // TODO: Only do this for the relevant Safaris maybe?
        node.onclick = noop;
    }
    function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
        for(var propKey in nextProps){
            if (!nextProps.hasOwnProperty(propKey)) continue;
            var nextProp = nextProps[propKey];
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                setValueForStyles(domElement, nextProp);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                if (nextHtml != null) setInnerHTML(domElement, nextHtml);
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === 'string') {
                    // Avoid setting initial textContent when the text is empty. In IE11 setting
                    // textContent on a <textarea> will cause the placeholder to not
                    // show within the <textarea> until it has been focused and blurred again.
                    // https://github.com/facebook/react/issues/6731#issuecomment-254874553
                    var canSetTextContent = tag !== 'textarea' || nextProp !== '';
                    if (canSetTextContent) setTextContent(domElement, nextProp);
                } else if (typeof nextProp === 'number') setTextContent(domElement, '' + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== 'function') warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === 'onScroll') listenToNonDelegatedEvent('scroll', domElement);
                }
            } else if (nextProp != null) setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
        }
    }
    function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
        // TODO: Handle wasCustomComponentTag
        for(var i = 0; i < updatePayload.length; i += 2){
            var propKey = updatePayload[i];
            var propValue = updatePayload[i + 1];
            if (propKey === STYLE) setValueForStyles(domElement, propValue);
            else if (propKey === DANGEROUSLY_SET_INNER_HTML) setInnerHTML(domElement, propValue);
            else if (propKey === CHILDREN) setTextContent(domElement, propValue);
            else setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
        }
    }
    function createElement(type, props, rootContainerElement, parentNamespace) {
        var isCustomComponentTag; // We create tags in the namespace of their parent container, except HTML
        // tags get no namespace.
        var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
        var domElement;
        var namespaceURI = parentNamespace;
        if (namespaceURI === HTML_NAMESPACE$1) namespaceURI = getIntrinsicNamespace(type);
        if (namespaceURI === HTML_NAMESPACE$1) {
            isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
            // allow <SVG> or <mATH>.
            if (!isCustomComponentTag && type !== type.toLowerCase()) error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
            if (type === 'script') {
                // Create the script via .innerHTML so its "parser-inserted" flag is
                // set to true and it does not execute
                var div = ownerDocument.createElement('div');
                div.innerHTML = "<script></script>"; // eslint-disable-line
                // This is guaranteed to yield a script element.
                var firstChild = div.firstChild;
                domElement = div.removeChild(firstChild);
            } else if (typeof props.is === 'string') // $FlowIssue `createElement` should be updated for Web Components
            domElement = ownerDocument.createElement(type, {
                is: props.is
            });
            else {
                // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
                // See discussion in https://github.com/facebook/react/pull/6896
                // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
                domElement = ownerDocument.createElement(type); // Normally attributes are assigned in `setInitialDOMProperties`, however the `multiple` and `size`
                // attributes on `select`s needs to be added before `option`s are inserted.
                // This prevents:
                // - a bug where the `select` does not scroll to the correct option because singular
                //  `select` elements automatically pick the first item #13222
                // - a bug where the `select` set the first item as selected despite the `size` attribute #14239
                // See https://github.com/facebook/react/issues/13222
                // and https://github.com/facebook/react/issues/14239
                if (type === 'select') {
                    var node = domElement;
                    if (props.multiple) node.multiple = true;
                    else if (props.size) // Setting a size greater than 1 causes a select to behave like `multiple=true`, where
                    // it is possible that no option is selected.
                    //
                    // This is only necessary when a select in "single selection mode".
                    node.size = props.size;
                }
            }
        } else domElement = ownerDocument.createElementNS(namespaceURI, type);
        if (namespaceURI === HTML_NAMESPACE$1) {
            if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === '[object HTMLUnknownElement]' && !Object.prototype.hasOwnProperty.call(warnedUnknownTags, type)) {
                warnedUnknownTags[type] = true;
                error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type);
            }
        }
        return domElement;
    }
    function createTextNode(text, rootContainerElement) {
        return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
    }
    function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
        var isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        var props;
        switch(tag){
            case 'dialog':
                listenToNonDelegatedEvent('cancel', domElement);
                listenToNonDelegatedEvent('close', domElement);
                props = rawProps;
                break;
            case 'iframe':
            case 'object':
            case 'embed':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent('load', domElement);
                props = rawProps;
                break;
            case 'video':
            case 'audio':
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                props = rawProps;
                break;
            case 'source':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent('error', domElement);
                props = rawProps;
                break;
            case 'img':
            case 'image':
            case 'link':
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent('error', domElement);
                listenToNonDelegatedEvent('load', domElement);
                props = rawProps;
                break;
            case 'details':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent('toggle', domElement);
                props = rawProps;
                break;
            case 'input':
                initWrapperState(domElement, rawProps);
                props = getHostProps(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'option':
                validateProps(domElement, rawProps);
                props = getHostProps$1(domElement, rawProps);
                break;
            case 'select':
                initWrapperState$1(domElement, rawProps);
                props = getHostProps$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'textarea':
                initWrapperState$2(domElement, rawProps);
                props = getHostProps$3(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            default:
                props = rawProps;
        }
        assertValidProps(tag, props);
        setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);
        switch(tag){
            case 'input':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, false);
                break;
            case 'textarea':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case 'option':
                postMountWrapper$1(domElement, rawProps);
                break;
            case 'select':
                postMountWrapper$2(domElement, rawProps);
                break;
            default:
                if (typeof props.onClick === 'function') // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
    } // Calculate the diff between the two objects.
    function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
        validatePropertiesInDevelopment(tag, nextRawProps);
        var updatePayload = null;
        var lastProps;
        var nextProps;
        switch(tag){
            case 'input':
                lastProps = getHostProps(domElement, lastRawProps);
                nextProps = getHostProps(domElement, nextRawProps);
                updatePayload = [];
                break;
            case 'option':
                lastProps = getHostProps$1(domElement, lastRawProps);
                nextProps = getHostProps$1(domElement, nextRawProps);
                updatePayload = [];
                break;
            case 'select':
                lastProps = getHostProps$2(domElement, lastRawProps);
                nextProps = getHostProps$2(domElement, nextRawProps);
                updatePayload = [];
                break;
            case 'textarea':
                lastProps = getHostProps$3(domElement, lastRawProps);
                nextProps = getHostProps$3(domElement, nextRawProps);
                updatePayload = [];
                break;
            default:
                lastProps = lastRawProps;
                nextProps = nextRawProps;
                if (typeof lastProps.onClick !== 'function' && typeof nextProps.onClick === 'function') // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        assertValidProps(tag, nextProps);
        var propKey;
        var styleName;
        var styleUpdates = null;
        for(propKey in lastProps){
            if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) continue;
            if (propKey === STYLE) {
                var lastStyle = lastProps[propKey];
                for(styleName in lastStyle)if (lastStyle.hasOwnProperty(styleName)) {
                    if (!styleUpdates) styleUpdates = {};
                    styleUpdates[styleName] = '';
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ;
            else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) // This is a special case. If any listener updates we need to ensure
            // that the "current" fiber pointer gets updated so we need a commit
            // to update this element.
            {
                if (!updatePayload) updatePayload = [];
            } else // For all other deleted properties we add it to the queue. We use
            // the allowed property list in the commit phase instead.
            (updatePayload = updatePayload || []).push(propKey, null);
        }
        for(propKey in nextProps){
            var nextProp = nextProps[propKey];
            var lastProp = lastProps != null ? lastProps[propKey] : undefined;
            if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) continue;
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                if (lastProp) {
                    // Unset styles on `lastProp` but not on `nextProp`.
                    for(styleName in lastProp)if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = '';
                    }
                     // Update styles that changed since `lastProp`.
                    for(styleName in nextProp)if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = nextProp[styleName];
                    }
                } else {
                    // Relies on `updateStylesByID` not mutating `styleUpdates`.
                    if (!styleUpdates) {
                        if (!updatePayload) updatePayload = [];
                        updatePayload.push(propKey, styleUpdates);
                    }
                    styleUpdates = nextProp;
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                var lastHtml = lastProp ? lastProp[HTML$1] : undefined;
                if (nextHtml != null) {
                    if (lastHtml !== nextHtml) (updatePayload = updatePayload || []).push(propKey, nextHtml);
                }
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === 'string' || typeof nextProp === 'number') (updatePayload = updatePayload || []).push(propKey, '' + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    // We eagerly listen to this even though we haven't committed yet.
                    if (typeof nextProp !== 'function') warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === 'onScroll') listenToNonDelegatedEvent('scroll', domElement);
                }
                if (!updatePayload && lastProp !== nextProp) // This is a special case. If any listener updates we need to ensure
                // that the "current" props pointer gets updated so we need a commit
                // to update this element.
                updatePayload = [];
            } else if (typeof nextProp === 'object' && nextProp !== null && nextProp.$$typeof === REACT_OPAQUE_ID_TYPE) // If we encounter useOpaqueReference's opaque object, this means we are hydrating.
            // In this case, call the opaque object's toString function which generates a new client
            // ID so client and server IDs match and throws to rerender.
            nextProp.toString();
            else // For any other property we always add it to the queue and then we
            // filter it out using the allowed property list during the commit.
            (updatePayload = updatePayload || []).push(propKey, nextProp);
        }
        if (styleUpdates) {
            validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
            (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
        }
        return updatePayload;
    } // Apply the diff.
    function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
        // Update checked *before* name.
        // In the middle of an update, it is possible to have multiple checked.
        // When a checked radio tries to change name, browser makes another radio's checked false.
        if (tag === 'input' && nextRawProps.type === 'radio' && nextRawProps.name != null) updateChecked(domElement, nextRawProps);
        var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
        var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.
        updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
        // changed.
        switch(tag){
            case 'input':
                // Update the wrapper around inputs *after* updating props. This has to
                // happen after `updateDOMProperties`. Otherwise HTML5 input validations
                // raise warnings and prevent the new value from being assigned.
                updateWrapper(domElement, nextRawProps);
                break;
            case 'textarea':
                updateWrapper$1(domElement, nextRawProps);
                break;
            case 'select':
                // <select> value update needs to occur after <option> children
                // reconciliation
                postUpdateWrapper(domElement, nextRawProps);
                break;
        }
    }
    function getPossibleStandardName(propName) {
        var lowerCasedName = propName.toLowerCase();
        if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) return null;
        return possibleStandardNames[lowerCasedName] || null;
    }
    function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement) {
        var isCustomComponentTag;
        var extraAttributeNames;
        suppressHydrationWarning = rawProps[SUPPRESS_HYDRATION_WARNING] === true;
        isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        switch(tag){
            case 'dialog':
                listenToNonDelegatedEvent('cancel', domElement);
                listenToNonDelegatedEvent('close', domElement);
                break;
            case 'iframe':
            case 'object':
            case 'embed':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent('load', domElement);
                break;
            case 'video':
            case 'audio':
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                break;
            case 'source':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent('error', domElement);
                break;
            case 'img':
            case 'image':
            case 'link':
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent('error', domElement);
                listenToNonDelegatedEvent('load', domElement);
                break;
            case 'details':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent('toggle', domElement);
                break;
            case 'input':
                initWrapperState(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'option':
                validateProps(domElement, rawProps);
                break;
            case 'select':
                initWrapperState$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'textarea':
                initWrapperState$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
        }
        assertValidProps(tag, rawProps);
        extraAttributeNames = new Set();
        var attributes = domElement.attributes;
        for(var _i = 0; _i < attributes.length; _i++){
            var name = attributes[_i].name.toLowerCase();
            switch(name){
                // Built-in SSR attribute is allowed
                case 'data-reactroot':
                    break;
                // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                case 'value':
                    break;
                case 'checked':
                    break;
                case 'selected':
                    break;
                default:
                    // Intentionally use the original name.
                    // See discussion in https://github.com/facebook/react/pull/10676.
                    extraAttributeNames.add(attributes[_i].name);
            }
        }
        var updatePayload = null;
        for(var propKey in rawProps){
            if (!rawProps.hasOwnProperty(propKey)) continue;
            var nextProp = rawProps[propKey];
            if (propKey === CHILDREN) {
                // For text content children we compare against textContent. This
                // might match additional HTML that is hidden when we read it using
                // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
                // satisfies our requirement. Our requirement is not to produce perfect
                // HTML and attributes. Ideally we should preserve structure but it's
                // ok not to if the visible content is still enough to indicate what
                // even listeners these nodes might be wired up to.
                // TODO: Warn if there is more than a single textNode as a child.
                // TODO: Should we use domElement.firstChild.nodeValue to compare?
                if (typeof nextProp === 'string') {
                    if (domElement.textContent !== nextProp) {
                        if (!suppressHydrationWarning) warnForTextDifference(domElement.textContent, nextProp);
                        updatePayload = [
                            CHILDREN,
                            nextProp
                        ];
                    }
                } else if (typeof nextProp === 'number') {
                    if (domElement.textContent !== '' + nextProp) {
                        if (!suppressHydrationWarning) warnForTextDifference(domElement.textContent, nextProp);
                        updatePayload = [
                            CHILDREN,
                            '' + nextProp
                        ];
                    }
                }
            } else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== 'function') warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === 'onScroll') listenToNonDelegatedEvent('scroll', domElement);
                }
            } else if (typeof isCustomComponentTag === 'boolean') {
                // Validate that the properties correspond to their expected values.
                var serverValue = void 0;
                var propertyInfo = getPropertyInfo(propKey);
                if (suppressHydrationWarning) ;
                else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                propKey === 'value' || propKey === 'checked' || propKey === 'selected') ;
                else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                    var serverHTML = domElement.innerHTML;
                    var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                    if (nextHtml != null) {
                        var expectedHTML = normalizeHTML(domElement, nextHtml);
                        if (expectedHTML !== serverHTML) warnForPropDifference(propKey, serverHTML, expectedHTML);
                    }
                } else if (propKey === STYLE) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey);
                    if (canDiffStyleForHydrationWarning) {
                        var expectedStyle = createDangerousStringForStyles(nextProp);
                        serverValue = domElement.getAttribute('style');
                        if (expectedStyle !== serverValue) warnForPropDifference(propKey, serverValue, expectedStyle);
                    }
                } else if (isCustomComponentTag) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey.toLowerCase());
                    serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    if (nextProp !== serverValue) warnForPropDifference(propKey, serverValue, nextProp);
                } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
                    var isMismatchDueToBadCasing = false;
                    if (propertyInfo !== null) {
                        // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propertyInfo.attributeName);
                        serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
                    } else {
                        var ownNamespace = parentNamespace;
                        if (ownNamespace === HTML_NAMESPACE$1) ownNamespace = getIntrinsicNamespace(tag);
                        if (ownNamespace === HTML_NAMESPACE$1) // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propKey.toLowerCase());
                        else {
                            var standardName = getPossibleStandardName(propKey);
                            if (standardName !== null && standardName !== propKey) {
                                // If an SVG prop is supplied with bad casing, it will
                                // be successfully parsed from HTML, but will produce a mismatch
                                // (and would be incorrectly rendered on the client).
                                // However, we already warn about bad casing elsewhere.
                                // So we'll skip the misleading extra mismatch warning in this case.
                                isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.
                                extraAttributeNames.delete(standardName);
                            } // $FlowFixMe - Should be inferred as not undefined.
                            extraAttributeNames.delete(propKey);
                        }
                        serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    }
                    if (nextProp !== serverValue && !isMismatchDueToBadCasing) warnForPropDifference(propKey, serverValue, nextProp);
                }
            }
        }
        // $FlowFixMe - Should be inferred as not undefined.
        if (extraAttributeNames.size > 0 && !suppressHydrationWarning) // $FlowFixMe - Should be inferred as not undefined.
        warnForExtraAttributes(extraAttributeNames);
        switch(tag){
            case 'input':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, true);
                break;
            case 'textarea':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case 'select':
            case 'option':
                break;
            default:
                if (typeof rawProps.onClick === 'function') // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        return updatePayload;
    }
    function diffHydratedText(textNode, text) {
        var isDifferent = textNode.nodeValue !== text;
        return isDifferent;
    }
    function warnForUnmatchedText(textNode, text) {
        warnForTextDifference(textNode.nodeValue, text);
    }
    function warnForDeletedHydratableElement(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain a <%s> in <%s>.', child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
    }
    function warnForDeletedHydratableText(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedElement(parentNode, tag, props) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching <%s> in <%s>.', tag, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedText(parentNode, text) {
        if (text === '') // We expect to insert empty text nodes since they're not represented in
        // the HTML.
        // TODO: Remove this special case if we can just avoid inserting empty
        // text nodes.
        return;
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
    }
    function restoreControlledState$3(domElement, tag, props) {
        switch(tag){
            case 'input':
                restoreControlledState(domElement, props);
                return;
            case 'textarea':
                restoreControlledState$2(domElement, props);
                return;
            case 'select':
                restoreControlledState$1(domElement, props);
                return;
        }
    }
    var validateDOMNesting = function() {};
    var updatedAncestorInfo = function() {};
    // This validation code was written based on the HTML5 parsing spec:
    // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    //
    // Note: this does not catch all invalid nesting, nor does it try to (as it's
    // not clear what practical benefit doing so provides); instead, we warn only
    // for cases where the parser will give a parse tree differing from what React
    // intended. For example, <b><div></div></b> is invalid but we don't warn
    // because it still parses correctly; we do warn for other cases like nested
    // <p> tags where the beginning of the second element implicitly closes the
    // first, causing a confusing mess.
    // https://html.spec.whatwg.org/multipage/syntax.html#special
    var specialTags = [
        'address',
        'applet',
        'area',
        'article',
        'aside',
        'base',
        'basefont',
        'bgsound',
        'blockquote',
        'body',
        'br',
        'button',
        'caption',
        'center',
        'col',
        'colgroup',
        'dd',
        'details',
        'dir',
        'div',
        'dl',
        'dt',
        'embed',
        'fieldset',
        'figcaption',
        'figure',
        'footer',
        'form',
        'frame',
        'frameset',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'iframe',
        'img',
        'input',
        'isindex',
        'li',
        'link',
        'listing',
        'main',
        'marquee',
        'menu',
        'menuitem',
        'meta',
        'nav',
        'noembed',
        'noframes',
        'noscript',
        'object',
        'ol',
        'p',
        'param',
        'plaintext',
        'pre',
        'script',
        'section',
        'select',
        'source',
        'style',
        'summary',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'title',
        'tr',
        'track',
        'ul',
        'wbr',
        'xmp'
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    var inScopeTags = [
        'applet',
        'caption',
        'html',
        'table',
        'td',
        'th',
        'marquee',
        'object',
        'template',
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        'foreignObject',
        'desc',
        'title'
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
    var buttonScopeTags = inScopeTags.concat([
        'button'
    ]); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
    var impliedEndTags = [
        'dd',
        'dt',
        'li',
        'option',
        'optgroup',
        'p',
        'rp',
        'rt'
    ];
    var emptyAncestorInfo = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
    };
    updatedAncestorInfo = function(oldInfo, tag) {
        var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
        var info = {
            tag: tag
        };
        if (inScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.aTagInScope = null;
            ancestorInfo.buttonTagInScope = null;
            ancestorInfo.nobrTagInScope = null;
        }
        if (buttonScopeTags.indexOf(tag) !== -1) ancestorInfo.pTagInButtonScope = null;
         // See rules for 'li', 'dd', 'dt' start tags in
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
            ancestorInfo.listItemTagAutoclosing = null;
            ancestorInfo.dlItemTagAutoclosing = null;
        }
        ancestorInfo.current = info;
        if (tag === 'form') ancestorInfo.formTag = info;
        if (tag === 'a') ancestorInfo.aTagInScope = info;
        if (tag === 'button') ancestorInfo.buttonTagInScope = info;
        if (tag === 'nobr') ancestorInfo.nobrTagInScope = info;
        if (tag === 'p') ancestorInfo.pTagInButtonScope = info;
        if (tag === 'li') ancestorInfo.listItemTagAutoclosing = info;
        if (tag === 'dd' || tag === 'dt') ancestorInfo.dlItemTagAutoclosing = info;
        return ancestorInfo;
    };
    /**
   * Returns whether
   */ var isTagValidWithParent = function(tag, parentTag) {
        // First, let's check if we're in an unusual parsing mode...
        switch(parentTag){
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case 'select':
                return tag === 'option' || tag === 'optgroup' || tag === '#text';
            case 'optgroup':
                return tag === 'option' || tag === '#text';
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but
            case 'option':
                return tag === '#text';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
            case 'tr':
                return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
            case 'tbody':
            case 'thead':
            case 'tfoot':
                return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
            case 'colgroup':
                return tag === 'col' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
            case 'table':
                return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
            case 'head':
                return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
            case 'html':
                return tag === 'head' || tag === 'body' || tag === 'frameset';
            case 'frameset':
                return tag === 'frame';
            case '#document':
                return tag === 'html';
        } // Probably in the "in body" parsing mode, so we outlaw only tag combos
        // where the parsing rules cause implicit opens or closes to be added.
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        switch(tag){
            case 'h1':
            case 'h2':
            case 'h3':
            case 'h4':
            case 'h5':
            case 'h6':
                return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
            case 'rp':
            case 'rt':
                return impliedEndTags.indexOf(parentTag) === -1;
            case 'body':
            case 'caption':
            case 'col':
            case 'colgroup':
            case 'frameset':
            case 'frame':
            case 'head':
            case 'html':
            case 'tbody':
            case 'td':
            case 'tfoot':
            case 'th':
            case 'thead':
            case 'tr':
                // These tags are only valid with a few parents that have special child
                // parsing rules -- if we're down here, then none of those matched and
                // so we allow it only if we don't know what the parent is, as all other
                // cases are invalid.
                return parentTag == null;
        }
        return true;
    };
    /**
   * Returns whether
   */ var findInvalidAncestorForTag = function(tag, ancestorInfo) {
        switch(tag){
            case 'address':
            case 'article':
            case 'aside':
            case 'blockquote':
            case 'center':
            case 'details':
            case 'dialog':
            case 'dir':
            case 'div':
            case 'dl':
            case 'fieldset':
            case 'figcaption':
            case 'figure':
            case 'footer':
            case 'header':
            case 'hgroup':
            case 'main':
            case 'menu':
            case 'nav':
            case 'ol':
            case 'p':
            case 'section':
            case 'summary':
            case 'ul':
            case 'pre':
            case 'listing':
            case 'table':
            case 'hr':
            case 'xmp':
            case 'h1':
            case 'h2':
            case 'h3':
            case 'h4':
            case 'h5':
            case 'h6':
                return ancestorInfo.pTagInButtonScope;
            case 'form':
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case 'li':
                return ancestorInfo.listItemTagAutoclosing;
            case 'dd':
            case 'dt':
                return ancestorInfo.dlItemTagAutoclosing;
            case 'button':
                return ancestorInfo.buttonTagInScope;
            case 'a':
                // Spec says something about storing a list of markers, but it sounds
                // equivalent to this check.
                return ancestorInfo.aTagInScope;
            case 'nobr':
                return ancestorInfo.nobrTagInScope;
        }
        return null;
    };
    var didWarn$1 = {};
    validateDOMNesting = function(childTag, childText, ancestorInfo) {
        ancestorInfo = ancestorInfo || emptyAncestorInfo;
        var parentInfo = ancestorInfo.current;
        var parentTag = parentInfo && parentInfo.tag;
        if (childText != null) {
            if (childTag != null) error('validateDOMNesting: when childText is passed, childTag should be null');
            childTag = '#text';
        }
        var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
        var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
        var invalidParentOrAncestor = invalidParent || invalidAncestor;
        if (!invalidParentOrAncestor) return;
        var ancestorTag = invalidParentOrAncestor.tag;
        var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag;
        if (didWarn$1[warnKey]) return;
        didWarn$1[warnKey] = true;
        var tagDisplayName = childTag;
        var whitespaceInfo = '';
        if (childTag === '#text') {
            if (/\S/.test(childText)) tagDisplayName = 'Text nodes';
            else {
                tagDisplayName = 'Whitespace text nodes';
                whitespaceInfo = " Make sure you don't have any extra whitespace between tags on each line of your source code.";
            }
        } else tagDisplayName = '<' + childTag + '>';
        if (invalidParent) {
            var info = '';
            if (ancestorTag === 'table' && childTag === 'tr') info += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser.";
            error('validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s', tagDisplayName, ancestorTag, whitespaceInfo, info);
        } else error("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", tagDisplayName, ancestorTag);
    };
    var SUPPRESS_HYDRATION_WARNING$1;
    SUPPRESS_HYDRATION_WARNING$1 = 'suppressHydrationWarning';
    var SUSPENSE_START_DATA = '$';
    var SUSPENSE_END_DATA = '/$';
    var SUSPENSE_PENDING_START_DATA = '$?';
    var SUSPENSE_FALLBACK_START_DATA = '$!';
    var STYLE$1 = 'style';
    var eventsEnabled = null;
    var selectionInformation = null;
    function shouldAutoFocusHostComponent(type, props) {
        switch(type){
            case 'button':
            case 'input':
            case 'select':
            case 'textarea':
                return !!props.autoFocus;
        }
        return false;
    }
    function getRootHostContext(rootContainerInstance) {
        var type;
        var namespace;
        var nodeType = rootContainerInstance.nodeType;
        switch(nodeType){
            case DOCUMENT_NODE:
            case DOCUMENT_FRAGMENT_NODE:
                type = nodeType === DOCUMENT_NODE ? '#document' : '#fragment';
                var root = rootContainerInstance.documentElement;
                namespace = root ? root.namespaceURI : getChildNamespace(null, '');
                break;
            default:
                var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
                var ownNamespace = container.namespaceURI || null;
                type = container.tagName;
                namespace = getChildNamespace(ownNamespace, type);
                break;
        }
        var validatedTag = type.toLowerCase();
        var ancestorInfo = updatedAncestorInfo(null, validatedTag);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getChildHostContext(parentHostContext, type, rootContainerInstance) {
        var parentHostContextDev = parentHostContext;
        var namespace = getChildNamespace(parentHostContextDev.namespace, type);
        var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getPublicInstance(instance) {
        return instance;
    }
    function prepareForCommit(containerInfo) {
        eventsEnabled = isEnabled();
        selectionInformation = getSelectionInformation();
        var activeInstance = null;
        setEnabled(false);
        return activeInstance;
    }
    function resetAfterCommit(containerInfo) {
        restoreSelection(selectionInformation);
        setEnabled(eventsEnabled);
        eventsEnabled = null;
        selectionInformation = null;
    }
    function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        var parentNamespace;
        // TODO: take namespace into account when validating.
        var hostContextDev = hostContext;
        validateDOMNesting(type, null, hostContextDev.ancestorInfo);
        if (typeof props.children === 'string' || typeof props.children === 'number') {
            var string = '' + props.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        parentNamespace = hostContextDev.namespace;
        var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
        precacheFiberNode(internalInstanceHandle, domElement);
        updateFiberProps(domElement, props);
        return domElement;
    }
    function appendInitialChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
        setInitialProperties(domElement, type, props, rootContainerInstance);
        return shouldAutoFocusHostComponent(type, props);
    }
    function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
        var hostContextDev = hostContext;
        if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === 'string' || typeof newProps.children === 'number')) {
            var string = '' + newProps.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        return diffProperties(domElement, type, oldProps, newProps);
    }
    function shouldSetTextContent(type, props) {
        return type === 'textarea' || type === 'option' || type === 'noscript' || typeof props.children === 'string' || typeof props.children === 'number' || typeof props.dangerouslySetInnerHTML === 'object' && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
    }
    function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
        var hostContextDev = hostContext;
        validateDOMNesting(null, text, hostContextDev.ancestorInfo);
        var textNode = createTextNode(text, rootContainerInstance);
        precacheFiberNode(internalInstanceHandle, textNode);
        return textNode;
    }
    // if a component just imports ReactDOM (e.g. for findDOMNode).
    // Some environments might not have setTimeout or clearTimeout.
    var scheduleTimeout = typeof setTimeout === 'function' ? setTimeout : undefined;
    var cancelTimeout = typeof clearTimeout === 'function' ? clearTimeout : undefined;
    var noTimeout = -1; // -------------------
    function commitMount(domElement, type, newProps, internalInstanceHandle) {
        // Despite the naming that might imply otherwise, this method only
        // fires if there is an `Update` effect scheduled during mounting.
        // This happens if `finalizeInitialChildren` returns `true` (which it
        // does to implement the `autoFocus` attribute on the client). But
        // there are also other cases when this might happen (such as patching
        // up text content during hydration mismatch). So we'll check this again.
        if (shouldAutoFocusHostComponent(type, newProps)) domElement.focus();
    }
    function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
        // Update the props handle so that we know which props are the ones with
        // with current event handlers.
        updateFiberProps(domElement, newProps); // Apply the diff to the DOM node.
        updateProperties(domElement, updatePayload, type, oldProps, newProps);
    }
    function resetTextContent(domElement) {
        setTextContent(domElement, '');
    }
    function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
    }
    function appendChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function appendChildToContainer(container, child) {
        var parentNode;
        if (container.nodeType === COMMENT_NODE) {
            parentNode = container.parentNode;
            parentNode.insertBefore(child, container);
        } else {
            parentNode = container;
            parentNode.appendChild(child);
        } // This container might be used for a portal.
        // If something inside a portal is clicked, that click should bubble
        // through the React tree. However, on Mobile Safari the click would
        // never bubble through the *DOM* tree unless an ancestor with onclick
        // event exists. So we wouldn't see it and dispatch it.
        // This is why we ensure that non React root containers have inline onclick
        // defined.
        // https://github.com/facebook/react/issues/11918
        var reactRootContainer = container._reactRootContainer;
        if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(parentNode);
    }
    function insertBefore(parentInstance, child, beforeChild) {
        parentInstance.insertBefore(child, beforeChild);
    }
    function insertInContainerBefore(container, child, beforeChild) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.insertBefore(child, beforeChild);
        else container.insertBefore(child, beforeChild);
    }
    function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.removeChild(child);
        else container.removeChild(child);
    }
    function hideInstance(instance) {
        // TODO: Does this work for all element types? What about MathML? Should we
        // pass host context to this method?
        instance;
        var style = instance.style;
        if (typeof style.setProperty === 'function') style.setProperty('display', 'none', 'important');
        else style.display = 'none';
    }
    function hideTextInstance(textInstance) {
        textInstance.nodeValue = '';
    }
    function unhideInstance(instance, props) {
        instance;
        var styleProp = props[STYLE$1];
        var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty('display') ? styleProp.display : null;
        instance.style.display = dangerousStyleValue('display', display);
    }
    function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
    }
    function clearContainer(container) {
        if (container.nodeType === ELEMENT_NODE) container.textContent = '';
        else if (container.nodeType === DOCUMENT_NODE) {
            var body = container.body;
            if (body != null) body.textContent = '';
        }
    } // -------------------
    function canHydrateInstance(instance, type, props) {
        if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) return null;
         // This has now been refined to an element node.
        return instance;
    }
    function canHydrateTextInstance(instance, text) {
        if (text === '' || instance.nodeType !== TEXT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a text node.
        return instance;
    }
    function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA;
    }
    function getNextHydratable(node) {
        // Skip non-hydratable nodes.
        for(; node != null; node = node.nextSibling){
            var nodeType = node.nodeType;
            if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) break;
        }
        return node;
    }
    function getNextHydratableSibling(instance) {
        return getNextHydratable(instance.nextSibling);
    }
    function getFirstHydratableChild(parentInstance) {
        return getNextHydratable(parentInstance.firstChild);
    }
    function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
        // get attached.
        updateFiberProps(instance, props);
        var parentNamespace;
        var hostContextDev = hostContext;
        parentNamespace = hostContextDev.namespace;
        return diffHydratedProperties(instance, type, props, parentNamespace);
    }
    function hydrateTextInstance(textInstance, text, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, textInstance);
        return diffHydratedText(textInstance, text);
    }
    function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
        var node = suspenseInstance.nextSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) return getNextHydratableSibling(node);
                    else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) depth++;
            }
            node = node.nextSibling;
        } // TODO: Warn, we didn't find the end comment boundary.
        return null;
    } // Returns the SuspenseInstance if this node is a direct child of a
    // SuspenseInstance. I.e. if its previous sibling is a Comment with
    // SUSPENSE_x_START_DATA. Otherwise, null.
    function getParentSuspenseInstance(targetInstance) {
        var node = targetInstance.previousSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
                    if (depth === 0) return node;
                    else depth--;
                } else if (data === SUSPENSE_END_DATA) depth++;
            }
            node = node.previousSibling;
        }
        return null;
    }
    function commitHydratedContainer(container) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text) {
        warnForUnmatchedText(textInstance, text);
    }
    function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForUnmatchedText(textInstance, text);
    }
    function didNotHydrateContainerInstance(parentContainer, instance) {
        if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentContainer, instance);
        else if (instance.nodeType === COMMENT_NODE) ;
        else warnForDeletedHydratableText(parentContainer, instance);
    }
    function didNotHydrateInstance(parentType, parentProps, parentInstance, instance) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentInstance, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentInstance, instance);
        }
    }
    function didNotFindHydratableContainerInstance(parentContainer, type, props) {
        warnForInsertedHydratedElement(parentContainer, type);
    }
    function didNotFindHydratableContainerTextInstance(parentContainer, text) {
        warnForInsertedHydratedText(parentContainer, text);
    }
    function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedElement(parentInstance, type);
    }
    function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedText(parentInstance, text);
    }
    function didNotFindHydratableSuspenseInstance(parentType, parentProps, parentInstance) {
        parentProps[SUPPRESS_HYDRATION_WARNING$1];
    }
    var clientId = 0;
    function makeClientIdInDEV(warnOnAccessInDEV) {
        var id = 'r:' + (clientId++).toString(36);
        return {
            toString: function() {
                warnOnAccessInDEV();
                return id;
            },
            valueOf: function() {
                warnOnAccessInDEV();
                return id;
            }
        };
    }
    function isOpaqueHydratingObject(value) {
        return value !== null && typeof value === 'object' && value.$$typeof === REACT_OPAQUE_ID_TYPE;
    }
    function makeOpaqueHydratingObject(attemptToReadValue) {
        return {
            $$typeof: REACT_OPAQUE_ID_TYPE,
            toString: attemptToReadValue,
            valueOf: attemptToReadValue
        };
    }
    function preparePortalMount(portalInstance) {
        listenToAllSupportedEvents(portalInstance);
    }
    var randomKey = Math.random().toString(36).slice(2);
    var internalInstanceKey = '__reactFiber$' + randomKey;
    var internalPropsKey = '__reactProps$' + randomKey;
    var internalContainerInstanceKey = '__reactContainer$' + randomKey;
    var internalEventHandlersKey = '__reactEvents$' + randomKey;
    function precacheFiberNode(hostInst, node) {
        node[internalInstanceKey] = hostInst;
    }
    function markContainerAsRoot(hostRoot, node) {
        node[internalContainerInstanceKey] = hostRoot;
    }
    function unmarkContainerAsRoot(node) {
        node[internalContainerInstanceKey] = null;
    }
    function isContainerMarkedAsRoot(node) {
        return !!node[internalContainerInstanceKey];
    } // Given a DOM node, return the closest HostComponent or HostText fiber ancestor.
    // If the target node is part of a hydrated or not yet rendered subtree, then
    // this may also return a SuspenseComponent or HostRoot to indicate that.
    // Conceptually the HostRoot fiber is a child of the Container node. So if you
    // pass the Container node as the targetNode, you will not actually get the
    // HostRoot back. To get to the HostRoot, you need to pass a child of it.
    // The same thing applies to Suspense boundaries.
    function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];
        if (targetInst) // Don't return HostRoot or SuspenseComponent here.
        return targetInst;
         // If the direct event target isn't a React owned DOM node, we need to look
        // to see if one of its parents is a React owned DOM node.
        var parentNode = targetNode.parentNode;
        while(parentNode){
            // We'll check if this is a container root that could include
            // React nodes in the future. We need to check this first because
            // if we're a child of a dehydrated container, we need to first
            // find that inner container before moving on to finding the parent
            // instance. Note that we don't check this field on  the targetNode
            // itself because the fibers are conceptually between the container
            // node and the first child. It isn't surrounding the container node.
            // If it's not a container, we check if it's an instance.
            targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];
            if (targetInst) {
                // Since this wasn't the direct target of the event, we might have
                // stepped past dehydrated DOM nodes to get here. However they could
                // also have been non-React nodes. We need to answer which one.
                // If we the instance doesn't have any children, then there can't be
                // a nested suspense boundary within it. So we can use this as a fast
                // bailout. Most of the time, when people add non-React children to
                // the tree, it is using a ref to a child-less DOM node.
                // Normally we'd only need to check one of the fibers because if it
                // has ever gone from having children to deleting them or vice versa
                // it would have deleted the dehydrated boundary nested inside already.
                // However, since the HostRoot starts out with an alternate it might
                // have one on the alternate so we need to check in case this was a
                // root.
                var alternate = targetInst.alternate;
                if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
                    // Next we need to figure out if the node that skipped past is
                    // nested within a dehydrated boundary and if so, which one.
                    var suspenseInstance = getParentSuspenseInstance(targetNode);
                    while(suspenseInstance !== null){
                        // We found a suspense instance. That means that we haven't
                        // hydrated it yet. Even though we leave the comments in the
                        // DOM after hydrating, and there are boundaries in the DOM
                        // that could already be hydrated, we wouldn't have found them
                        // through this pass since if the target is hydrated it would
                        // have had an internalInstanceKey on it.
                        // Let's get the fiber associated with the SuspenseComponent
                        // as the deepest instance.
                        var targetSuspenseInst = suspenseInstance[internalInstanceKey];
                        if (targetSuspenseInst) return targetSuspenseInst;
                         // If we don't find a Fiber on the comment, it might be because
                        // we haven't gotten to hydrate it yet. There might still be a
                        // parent boundary that hasn't above this one so we need to find
                        // the outer most that is known.
                        suspenseInstance = getParentSuspenseInstance(suspenseInstance); // If we don't find one, then that should mean that the parent
                    // host component also hasn't hydrated yet. We can return it
                    // below since it will bail out on the isMounted check later.
                    }
                }
                return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
        }
        return null;
    }
    /**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */ function getInstanceFromNode(node) {
        var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];
        if (inst) {
            if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) return inst;
            else return null;
        }
        return null;
    }
    /**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */ function getNodeFromInstance(inst) {
        if (inst.tag === HostComponent || inst.tag === HostText) // In Fiber this, is just the state node right now. We assume it will be
        // a host component or host text.
        return inst.stateNode;
         // Without this first invariant, passing a non-DOM-component triggers the next
        throw Error("getNodeFromInstance: Invalid argument.");
    }
    function getFiberCurrentPropsFromNode(node) {
        return node[internalPropsKey] || null;
    }
    function updateFiberProps(node, props) {
        node[internalPropsKey] = props;
    }
    function getEventListenerSet(node) {
        var elementListenerSet = node[internalEventHandlersKey];
        if (elementListenerSet === undefined) elementListenerSet = node[internalEventHandlersKey] = new Set();
        return elementListenerSet;
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(Object.prototype.hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                    var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                    err.name = 'Invariant Violation';
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || 'React class', location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var valueStack = [];
    var fiberStack;
    fiberStack = [];
    var index = -1;
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor, fiber) {
        if (index < 0) {
            error('Unexpected pop.');
            return;
        }
        if (fiber !== fiberStack[index]) error('Unexpected Fiber popped.');
        cursor.current = valueStack[index];
        valueStack[index] = null;
        fiberStack[index] = null;
        index--;
    }
    function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        fiberStack[index] = fiber;
        cursor.current = value;
    }
    var warnedAboutMissingGetChildContext;
    warnedAboutMissingGetChildContext = {};
    var emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.
    var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
    // We use this to get access to the parent context after we have already
    // pushed the next context provider, and now need to merge their contexts.
    var previousContext = emptyContextObject;
    function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        if (didPushOwnContextIfProvider && isContextProvider(Component)) // If the fiber is a context provider itself, when we read its context
        // we may have already pushed its own child context on the stack. A context
        // provider should not "see" its own child context. Therefore we read the
        // previous (parent) context instead for a context provider.
        return previousContext;
        return contextStackCursor.current;
    }
    function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        var instance = workInProgress.stateNode;
        instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
        instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
    }
    function getMaskedContext(workInProgress, unmaskedContext) {
        var type = workInProgress.type;
        var contextTypes = type.contextTypes;
        if (!contextTypes) return emptyContextObject;
         // Avoid recreating masked context unless unmasked context has changed.
        // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
        // This may trigger infinite loops if componentWillReceiveProps calls setState.
        var instance = workInProgress.stateNode;
        if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) return instance.__reactInternalMemoizedMaskedChildContext;
        var context = {};
        for(var key in contextTypes)context[key] = unmaskedContext[key];
        var name = getComponentName(type) || 'Unknown';
        checkPropTypes(contextTypes, context, 'context', name);
        // Context is created before the class component is instantiated so check for instance.
        if (instance) cacheContext(workInProgress, unmaskedContext, context);
        return context;
    }
    function hasContextChanged() {
        return didPerformWorkStackCursor.current;
    }
    function isContextProvider(type) {
        var childContextTypes = type.childContextTypes;
        return childContextTypes !== null && childContextTypes !== undefined;
    }
    function popContext(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function popTopLevelContextObject(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function pushTopLevelContextObject(fiber, context, didChange) {
        if (!(contextStackCursor.current === emptyContextObject)) throw Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        push(contextStackCursor, context, fiber);
        push(didPerformWorkStackCursor, didChange, fiber);
    }
    function processChildContext(fiber, type, parentContext) {
        var instance = fiber.stateNode;
        var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
        // It has only been added in Fiber to match the (unintentional) behavior in Stack.
        if (typeof instance.getChildContext !== 'function') {
            var componentName = getComponentName(type) || 'Unknown';
            if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
            }
            return parentContext;
        }
        var childContext = instance.getChildContext();
        for(var contextKey in childContext){
            if (!(contextKey in childContextTypes)) throw Error((getComponentName(type) || 'Unknown') + ".getChildContext(): key \"" + contextKey + "\" is not defined in childContextTypes.");
        }
        var name = getComponentName(type) || 'Unknown';
        checkPropTypes(childContextTypes, childContext, 'child context', name);
        return _assign({}, parentContext, childContext);
    }
    function pushContextProvider(workInProgress) {
        var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
        // If the instance does not exist yet, we will push null at first,
        // and replace it on the stack later when invalidating the context.
        var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
        // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.
        previousContext = contextStackCursor.current;
        push(contextStackCursor, memoizedMergedChildContext, workInProgress);
        push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
        return true;
    }
    function invalidateContextProvider(workInProgress, type, didChange) {
        var instance = workInProgress.stateNode;
        if (!instance) throw Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (didChange) {
            // Merge parent and own context.
            // Skip this if we're not updating due to sCU.
            // This avoids unnecessarily recomputing memoized values.
            var mergedContext = processChildContext(workInProgress, type, previousContext);
            instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
            // It is important to unwind the context in the reverse order.
            pop(didPerformWorkStackCursor, workInProgress);
            pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.
            push(contextStackCursor, mergedContext, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        } else {
            pop(didPerformWorkStackCursor, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        }
    }
    function findCurrentUnmaskedContext(fiber) {
        // Currently this is only used with renderSubtreeIntoContainer; not sure if it
        // makes sense elsewhere
        if (!(isFiberMounted(fiber) && fiber.tag === ClassComponent)) throw Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var node = fiber;
        do {
            switch(node.tag){
                case HostRoot:
                    return node.stateNode.context;
                case ClassComponent:
                    var Component = node.type;
                    if (isContextProvider(Component)) return node.stateNode.__reactInternalMemoizedMergedChildContext;
                    break;
            }
            node = node.return;
        }while (node !== null);
        throw Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    var LegacyRoot = 0;
    var BlockingRoot = 1;
    var ConcurrentRoot = 2;
    var rendererID = null;
    var injectedHook = null;
    var hasLoggedError = false;
    var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined';
    function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') // No DevTools
        return false;
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) // This isn't a real property on the hook, but it can be set to opt out
        // of DevTools integration and associated warnings and logs.
        // https://github.com/facebook/react/issues/3877
        return true;
        if (!hook.supportsFiber) {
            error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools");
            return true;
        }
        try {
            rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.
            injectedHook = hook;
        } catch (err) {
            error('React instrumentation encountered an error: %s.', err);
        } // DevTools exists
        return true;
    }
    function onScheduleRoot(root, children) {
        if (injectedHook && typeof injectedHook.onScheduleFiberRoot === 'function') try {
            injectedHook.onScheduleFiberRoot(rendererID, root, children);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
            }
        }
    }
    function onCommitRoot(root, priorityLevel) {
        if (injectedHook && typeof injectedHook.onCommitFiberRoot === 'function') try {
            var didError = (root.current.flags & DidCapture) === DidCapture;
            if (enableProfilerTimer) injectedHook.onCommitFiberRoot(rendererID, root, priorityLevel, didError);
            else injectedHook.onCommitFiberRoot(rendererID, root, undefined, didError);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
            }
        }
    }
    function onCommitUnmount(fiber) {
        if (injectedHook && typeof injectedHook.onCommitFiberUnmount === 'function') try {
            injectedHook.onCommitFiberUnmount(rendererID, fiber);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
            }
        }
    }
    var Scheduler_runWithPriority = Scheduler.unstable_runWithPriority, Scheduler_scheduleCallback = Scheduler.unstable_scheduleCallback, Scheduler_cancelCallback = Scheduler.unstable_cancelCallback, Scheduler_shouldYield = Scheduler.unstable_shouldYield, Scheduler_requestPaint = Scheduler.unstable_requestPaint, Scheduler_now$1 = Scheduler.unstable_now, Scheduler_getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel, Scheduler_ImmediatePriority = Scheduler.unstable_ImmediatePriority, Scheduler_UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, Scheduler_NormalPriority = Scheduler.unstable_NormalPriority, Scheduler_LowPriority = Scheduler.unstable_LowPriority, Scheduler_IdlePriority = Scheduler.unstable_IdlePriority;
    // Provide explicit error message when production+profiling bundle of e.g.
    // react-dom is used with production (non-profiling) bundle of
    // scheduler/tracing
    if (!(tracing.__interactionsRef != null && tracing.__interactionsRef.current != null)) throw Error("It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at https://reactjs.org/link/profiling");
    var fakeCallbackNode = {}; // Except for NoPriority, these correspond to Scheduler priorities. We use
    // ascending numbers so we can compare them like numbers. They start at 90 to
    // avoid clashing with Scheduler's priorities.
    var ImmediatePriority$1 = 99;
    var UserBlockingPriority$2 = 98;
    var NormalPriority$1 = 97;
    var LowPriority$1 = 96;
    var IdlePriority$1 = 95; // NoPriority is the absence of priority. Also React-only.
    var NoPriority$1 = 90;
    var shouldYield = Scheduler_shouldYield;
    var requestPaint = Scheduler_requestPaint !== undefined ? Scheduler_requestPaint : function() {};
    var syncQueue = null;
    var immediateQueueCallbackNode = null;
    var isFlushingSyncQueue = false;
    var initialTimeMs$1 = Scheduler_now$1(); // If the initial timestamp is reasonably small, use Scheduler's `now` directly.
    // This will be the case for modern browsers that support `performance.now`. In
    // older browsers, Scheduler falls back to `Date.now`, which returns a Unix
    // timestamp. In that case, subtract the module initialization time to simulate
    // the behavior of performance.now and keep our times small enough to fit
    // within 32 bits.
    // TODO: Consider lifting this into Scheduler.
    var now = initialTimeMs$1 < 10000 ? Scheduler_now$1 : function() {
        return Scheduler_now$1() - initialTimeMs$1;
    };
    function getCurrentPriorityLevel() {
        switch(Scheduler_getCurrentPriorityLevel()){
            case Scheduler_ImmediatePriority:
                return ImmediatePriority$1;
            case Scheduler_UserBlockingPriority:
                return UserBlockingPriority$2;
            case Scheduler_NormalPriority:
                return NormalPriority$1;
            case Scheduler_LowPriority:
                return LowPriority$1;
            case Scheduler_IdlePriority:
                return IdlePriority$1;
            default:
                throw Error("Unknown priority level.");
        }
    }
    function reactPriorityToSchedulerPriority(reactPriorityLevel) {
        switch(reactPriorityLevel){
            case ImmediatePriority$1:
                return Scheduler_ImmediatePriority;
            case UserBlockingPriority$2:
                return Scheduler_UserBlockingPriority;
            case NormalPriority$1:
                return Scheduler_NormalPriority;
            case LowPriority$1:
                return Scheduler_LowPriority;
            case IdlePriority$1:
                return Scheduler_IdlePriority;
            default:
                throw Error("Unknown priority level.");
        }
    }
    function runWithPriority$1(reactPriorityLevel, fn) {
        var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
        return Scheduler_runWithPriority(priorityLevel, fn);
    }
    function scheduleCallback(reactPriorityLevel, callback, options) {
        var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
        return Scheduler_scheduleCallback(priorityLevel, callback, options);
    }
    function scheduleSyncCallback(callback) {
        // Push this callback into an internal queue. We'll flush these either in
        // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
        if (syncQueue === null) {
            syncQueue = [
                callback
            ]; // Flush the queue in the next tick, at the earliest.
            immediateQueueCallbackNode = Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueueImpl);
        } else // Push onto existing queue. Don't need to schedule a callback because
        // we already scheduled one when we created the queue.
        syncQueue.push(callback);
        return fakeCallbackNode;
    }
    function cancelCallback(callbackNode) {
        if (callbackNode !== fakeCallbackNode) Scheduler_cancelCallback(callbackNode);
    }
    function flushSyncCallbackQueue() {
        if (immediateQueueCallbackNode !== null) {
            var node = immediateQueueCallbackNode;
            immediateQueueCallbackNode = null;
            Scheduler_cancelCallback(node);
        }
        flushSyncCallbackQueueImpl();
    }
    function flushSyncCallbackQueueImpl() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
            // Prevent re-entrancy.
            isFlushingSyncQueue = true;
            var i = 0;
            try {
                var _isSync2 = true;
                var _queue = syncQueue;
                runWithPriority$1(ImmediatePriority$1, function() {
                    for(; i < _queue.length; i++){
                        var callback = _queue[i];
                        do callback = callback(_isSync2);
                        while (callback !== null);
                    }
                });
                syncQueue = null;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                if (syncQueue !== null) syncQueue = syncQueue.slice(i + 1);
                 // Resume flushing in the next tick
                Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueue);
                throw error;
            } finally{
                isFlushingSyncQueue = false;
            }
        }
    }
    // TODO: this is special because it gets imported during build.
    var ReactVersion = '17.0.2';
    var NoMode = 0;
    var StrictMode = 1; // TODO: Remove BlockingMode and ConcurrentMode by reading from the root
    // tag instead
    var BlockingMode = 2;
    var ConcurrentMode = 4;
    var ProfileMode = 8;
    var DebugTracingMode = 16;
    var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig;
    var NoTransition = 0;
    function requestCurrentTransition() {
        return ReactCurrentBatchConfig.transition;
    }
    var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function(fiber, instance) {},
        flushPendingUnsafeLifecycleWarnings: function() {},
        recordLegacyContextWarning: function(fiber, instance) {},
        flushLegacyContextWarning: function() {},
        discardPendingWarnings: function() {}
    };
    var findStrictRoot = function(fiber) {
        var maybeStrictRoot = null;
        var node = fiber;
        while(node !== null){
            if (node.mode & StrictMode) maybeStrictRoot = node;
            node = node.return;
        }
        return maybeStrictRoot;
    };
    var setToSortedString = function(set) {
        var array = [];
        set.forEach(function(value) {
            array.push(value);
        });
        return array.sort().join(', ');
    };
    var pendingComponentWillMountWarnings = [];
    var pendingUNSAFE_ComponentWillMountWarnings = [];
    var pendingComponentWillReceivePropsWarnings = [];
    var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    var pendingComponentWillUpdateWarnings = [];
    var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.
    var didWarnAboutUnsafeLifecycles = new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
        // Dedup strategy: Warn once per component.
        if (didWarnAboutUnsafeLifecycles.has(fiber.type)) return;
        if (typeof instance.componentWillMount === 'function' && // Don't warn about react-lifecycles-compat polyfilled components.
        instance.componentWillMount.__suppressDeprecationWarning !== true) pendingComponentWillMountWarnings.push(fiber);
        if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillMount === 'function') pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
        if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) pendingComponentWillReceivePropsWarnings.push(fiber);
        if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillReceiveProps === 'function') pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
        if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) pendingComponentWillUpdateWarnings.push(fiber);
        if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillUpdate === 'function') pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
        // We do an initial pass to gather component names
        var componentWillMountUniqueNames = new Set();
        if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function(fiber) {
                componentWillMountUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
        }
        var UNSAFE_componentWillMountUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
                UNSAFE_componentWillMountUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
        }
        var componentWillReceivePropsUniqueNames = new Set();
        if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
                componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
        }
        var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
                UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        }
        var componentWillUpdateUniqueNames = new Set();
        if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function(fiber) {
                componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
        }
        var UNSAFE_componentWillUpdateUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
                UNSAFE_componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
        } // Finally, we flush all the warnings
        // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'
        if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
        }
        if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
            error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n\nPlease update the following components: %s", _sortedNames);
        }
        if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
            error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", _sortedNames2);
        }
        if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
            warn("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames3);
        }
        if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
            warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames4);
        }
        if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
            warn("componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames5);
        }
    };
    var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.
    var didWarnAboutLegacyContext = new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
        var strictRoot = findStrictRoot(fiber);
        if (strictRoot === null) {
            error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
            return;
        } // Dedup strategy: Warn once per component.
        if (didWarnAboutLegacyContext.has(fiber.type)) return;
        var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
        if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === 'function') {
            if (warningsForRoot === undefined) {
                warningsForRoot = [];
                pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }
            warningsForRoot.push(fiber);
        }
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
        pendingLegacyContextWarning.forEach(function(fiberArray, strictRoot) {
            if (fiberArray.length === 0) return;
            var firstFiber = fiberArray[0];
            var uniqueNames = new Set();
            fiberArray.forEach(function(fiber) {
                uniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            try {
                setCurrentFiber(firstFiber);
                error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", sortedNames);
            } finally{
                resetCurrentFiber();
            }
        });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
        pendingComponentWillMountWarnings = [];
        pendingUNSAFE_ComponentWillMountWarnings = [];
        pendingComponentWillReceivePropsWarnings = [];
        pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        pendingComponentWillUpdateWarnings = [];
        pendingUNSAFE_ComponentWillUpdateWarnings = [];
        pendingLegacyContextWarning = new Map();
    };
    function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
            // Resolve default props. Taken from ReactElement
            var props = _assign({}, baseProps);
            var defaultProps = Component.defaultProps;
            for(var propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
            return props;
        }
        return baseProps;
    }
    // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
    // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var MAX_SIGNED_31_BIT_INT = 1073741823;
    var valueCursor = createCursor(null);
    var rendererSigil;
    // Use this to detect multiple renderers using the same context
    rendererSigil = {};
    var currentlyRenderingFiber = null;
    var lastContextDependency = null;
    var lastContextWithAllBitsObserved = null;
    var isDisallowedContextReadInDEV = false;
    function resetContextDependencies() {
        // This is called right before React yields execution, to ensure `readContext`
        // cannot be called outside the render phase.
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastContextWithAllBitsObserved = null;
        isDisallowedContextReadInDEV = false;
    }
    function enterDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = true;
    }
    function exitDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = false;
    }
    function pushProvider(providerFiber, nextValue) {
        var context = providerFiber.type._context;
        push(valueCursor, context._currentValue, providerFiber);
        context._currentValue = nextValue;
        if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
    }
    function popProvider(providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        var context = providerFiber.type._context;
        context._currentValue = currentValue;
    }
    function calculateChangedBits(context, newValue, oldValue) {
        if (objectIs(oldValue, newValue)) // No change
        return 0;
        else {
            var changedBits = typeof context._calculateChangedBits === 'function' ? context._calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
            if ((changedBits & MAX_SIGNED_31_BIT_INT) !== changedBits) error("calculateChangedBits: Expected the return value to be a 31-bit integer. Instead received: %s", changedBits);
            return changedBits | 0;
        }
    }
    function scheduleWorkOnParentPath(parent, renderLanes) {
        // Update the child lanes of all the ancestors, including the alternates.
        var node = parent;
        while(node !== null){
            var alternate = node.alternate;
            if (!isSubsetOfLanes(node.childLanes, renderLanes)) {
                node.childLanes = mergeLanes(node.childLanes, renderLanes);
                if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes)) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            else break;
            node = node.return;
        }
    }
    function propagateContextChange(workInProgress, context, changedBits, renderLanes) {
        var fiber = workInProgress.child;
        if (fiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
        fiber.return = workInProgress;
        while(fiber !== null){
            var nextFiber = void 0; // Visit this fiber.
            var list = fiber.dependencies;
            if (list !== null) {
                nextFiber = fiber.child;
                var dependency = list.firstContext;
                while(dependency !== null){
                    // Check if the context matches.
                    if (dependency.context === context && (dependency.observedBits & changedBits) !== 0) {
                        // Match! Schedule an update on this fiber.
                        if (fiber.tag === ClassComponent) {
                            // Schedule a force update on the work-in-progress.
                            var update = createUpdate(NoTimestamp, pickArbitraryLane(renderLanes));
                            update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
                            // update to the current fiber, too, which means it will persist even if
                            // this render is thrown away. Since it's a race condition, not sure it's
                            // worth fixing.
                            enqueueUpdate(fiber, update);
                        }
                        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
                        var alternate = fiber.alternate;
                        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
                        scheduleWorkOnParentPath(fiber.return, renderLanes); // Mark the updated lanes on the list, too.
                        list.lanes = mergeLanes(list.lanes, renderLanes); // Since we already found a match, we can stop traversing the
                        break;
                    }
                    dependency = dependency.next;
                }
            } else if (fiber.tag === ContextProvider) // Don't scan deeper if this is a matching provider
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
            else // Traverse down.
            nextFiber = fiber.child;
            if (nextFiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
            nextFiber.return = fiber;
            else {
                // No child. Traverse to next sibling.
                nextFiber = fiber;
                while(nextFiber !== null){
                    if (nextFiber === workInProgress) {
                        // We're back to the root of this subtree. Exit.
                        nextFiber = null;
                        break;
                    }
                    var sibling = nextFiber.sibling;
                    if (sibling !== null) {
                        // Set the return pointer of the sibling to the work-in-progress fiber.
                        sibling.return = nextFiber.return;
                        nextFiber = sibling;
                        break;
                    } // No more siblings. Traverse up.
                    nextFiber = nextFiber.return;
                }
            }
            fiber = nextFiber;
        }
    }
    function prepareToReadContext(workInProgress, renderLanes) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastContextWithAllBitsObserved = null;
        var dependencies = workInProgress.dependencies;
        if (dependencies !== null) {
            var firstContext = dependencies.firstContext;
            if (firstContext !== null) {
                if (includesSomeLane(dependencies.lanes, renderLanes)) // Context list has a pending update. Mark that this fiber performed work.
                markWorkInProgressReceivedUpdate();
                 // Reset the work-in-progress list
                dependencies.firstContext = null;
            }
        }
    }
    function readContext(context, observedBits) {
        // This warning would fire if you read context inside a Hook like useMemo.
        // Unlike the class check below, it's not enforced in production for perf.
        if (isDisallowedContextReadInDEV) error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        if (lastContextWithAllBitsObserved === context) ;
        else if (observedBits === false || observedBits === 0) ;
        else {
            var resolvedObservedBits; // Avoid deopting on observable arguments or heterogeneous types.
            if (typeof observedBits !== 'number' || observedBits === MAX_SIGNED_31_BIT_INT) {
                // Observe all updates.
                lastContextWithAllBitsObserved = context;
                resolvedObservedBits = MAX_SIGNED_31_BIT_INT;
            } else resolvedObservedBits = observedBits;
            var contextItem = {
                context: context,
                observedBits: resolvedObservedBits,
                next: null
            };
            if (lastContextDependency === null) {
                if (!(currentlyRenderingFiber !== null)) throw Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
                 // This is the first dependency for this component. Create a new list.
                lastContextDependency = contextItem;
                currentlyRenderingFiber.dependencies = {
                    lanes: NoLanes,
                    firstContext: contextItem,
                    responders: null
                };
            } else // Append a new context item.
            lastContextDependency = lastContextDependency.next = contextItem;
        }
        return context._currentValue;
    }
    var UpdateState = 0;
    var ReplaceState = 1;
    var ForceUpdate = 2;
    var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
    // It should only be read right after calling `processUpdateQueue`, via
    // `checkHasForceUpdateAfterProcessing`.
    var hasForceUpdate = false;
    var didWarnUpdateInsideUpdate;
    var currentlyProcessingQueue;
    didWarnUpdateInsideUpdate = false;
    currentlyProcessingQueue = null;
    function initializeUpdateQueue(fiber) {
        var queue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null
            },
            effects: null
        };
        fiber.updateQueue = queue;
    }
    function cloneUpdateQueue(current, workInProgress) {
        // Clone the update queue from current. Unless it's already a clone.
        var queue = workInProgress.updateQueue;
        var currentQueue = current.updateQueue;
        if (queue === currentQueue) {
            var clone = {
                baseState: currentQueue.baseState,
                firstBaseUpdate: currentQueue.firstBaseUpdate,
                lastBaseUpdate: currentQueue.lastBaseUpdate,
                shared: currentQueue.shared,
                effects: currentQueue.effects
            };
            workInProgress.updateQueue = clone;
        }
    }
    function createUpdate(eventTime, lane) {
        var update = {
            eventTime: eventTime,
            lane: lane,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
        };
        return update;
    }
    function enqueueUpdate(fiber, update) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return;
        var sharedQueue = updateQueue.shared;
        var pending = sharedQueue.pending;
        if (pending === null) // This is the first update. Create a circular list.
        update.next = update;
        else {
            update.next = pending.next;
            pending.next = update;
        }
        sharedQueue.pending = update;
        if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
            error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.");
            didWarnUpdateInsideUpdate = true;
        }
    }
    function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        // Captured updates are updates that are thrown by a child during the render
        // phase. They should be discarded if the render is aborted. Therefore,
        // we should only put them on the work-in-progress queue, not the current one.
        var queue = workInProgress.updateQueue; // Check if the work-in-progress queue is a clone.
        var current = workInProgress.alternate;
        if (current !== null) {
            var currentQueue = current.updateQueue;
            if (queue === currentQueue) {
                // The work-in-progress queue is the same as current. This happens when
                // we bail out on a parent fiber that then captures an error thrown by
                // a child. Since we want to append the update only to the work-in
                // -progress queue, we need to clone the updates. We usually clone during
                // processUpdateQueue, but that didn't happen in this case because we
                // skipped over the parent when we bailed out.
                var newFirst = null;
                var newLast = null;
                var firstBaseUpdate = queue.firstBaseUpdate;
                if (firstBaseUpdate !== null) {
                    // Loop through the updates and clone them.
                    var update = firstBaseUpdate;
                    do {
                        var clone = {
                            eventTime: update.eventTime,
                            lane: update.lane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        if (newLast === null) newFirst = newLast = clone;
                        else {
                            newLast.next = clone;
                            newLast = clone;
                        }
                        update = update.next;
                    }while (update !== null); // Append the captured update the end of the cloned list.
                    if (newLast === null) newFirst = newLast = capturedUpdate;
                    else {
                        newLast.next = capturedUpdate;
                        newLast = capturedUpdate;
                    }
                } else // There are no base updates.
                newFirst = newLast = capturedUpdate;
                queue = {
                    baseState: currentQueue.baseState,
                    firstBaseUpdate: newFirst,
                    lastBaseUpdate: newLast,
                    shared: currentQueue.shared,
                    effects: currentQueue.effects
                };
                workInProgress.updateQueue = queue;
                return;
            }
        } // Append the update to the end of the list.
        var lastBaseUpdate = queue.lastBaseUpdate;
        if (lastBaseUpdate === null) queue.firstBaseUpdate = capturedUpdate;
        else lastBaseUpdate.next = capturedUpdate;
        queue.lastBaseUpdate = capturedUpdate;
    }
    function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch(update.tag){
            case ReplaceState:
                var payload = update.payload;
                if (typeof payload === 'function') {
                    enterDisallowedContextReadInDEV();
                    var nextState = payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictMode) {
                        disableLogs();
                        try {
                            payload.call(instance, prevState, nextProps);
                        } finally{
                            reenableLogs();
                        }
                    }
                    exitDisallowedContextReadInDEV();
                    return nextState;
                } // State object
                return payload;
            case CaptureUpdate:
                workInProgress.flags = workInProgress.flags & ~ShouldCapture | DidCapture;
            // Intentional fallthrough
            case UpdateState:
                var _payload = update.payload;
                var partialState;
                if (typeof _payload === 'function') {
                    enterDisallowedContextReadInDEV();
                    partialState = _payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictMode) {
                        disableLogs();
                        try {
                            _payload.call(instance, prevState, nextProps);
                        } finally{
                            reenableLogs();
                        }
                    }
                    exitDisallowedContextReadInDEV();
                } else // Partial state object
                partialState = _payload;
                if (partialState === null || partialState === undefined) // Null and undefined are treated as no-ops.
                return prevState;
                 // Merge the partial state and the previous state.
                return _assign({}, prevState, partialState);
            case ForceUpdate:
                hasForceUpdate = true;
                return prevState;
        }
        return prevState;
    }
    function processUpdateQueue(workInProgress, props, instance, renderLanes) {
        // This is always non-null on a ClassComponent or HostRoot
        var queue = workInProgress.updateQueue;
        hasForceUpdate = false;
        currentlyProcessingQueue = queue.shared;
        var firstBaseUpdate = queue.firstBaseUpdate;
        var lastBaseUpdate = queue.lastBaseUpdate; // Check if there are pending updates. If so, transfer them to the base queue.
        var pendingQueue = queue.shared.pending;
        if (pendingQueue !== null) {
            queue.shared.pending = null; // The pending queue is circular. Disconnect the pointer between first
            // and last so that it's non-circular.
            var lastPendingUpdate = pendingQueue;
            var firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null; // Append pending updates to base queue
            if (lastBaseUpdate === null) firstBaseUpdate = firstPendingUpdate;
            else lastBaseUpdate.next = firstPendingUpdate;
            lastBaseUpdate = lastPendingUpdate; // If there's a current queue, and it's different from the base queue, then
            // we need to transfer the updates to that queue, too. Because the base
            // queue is a singly-linked list with no cycles, we can append to both
            // lists and take advantage of structural sharing.
            // TODO: Pass `current` as argument
            var current = workInProgress.alternate;
            if (current !== null) {
                // This is always non-null on a ClassComponent or HostRoot
                var currentQueue = current.updateQueue;
                var currentLastBaseUpdate = currentQueue.lastBaseUpdate;
                if (currentLastBaseUpdate !== lastBaseUpdate) {
                    if (currentLastBaseUpdate === null) currentQueue.firstBaseUpdate = firstPendingUpdate;
                    else currentLastBaseUpdate.next = firstPendingUpdate;
                    currentQueue.lastBaseUpdate = lastPendingUpdate;
                }
            }
        } // These values may change as we process the queue.
        if (firstBaseUpdate !== null) {
            // Iterate through the list of updates to compute the result.
            var newState = queue.baseState; // TODO: Don't need to accumulate this. Instead, we can remove renderLanes
            // from the original lanes.
            var newLanes = NoLanes;
            var newBaseState = null;
            var newFirstBaseUpdate = null;
            var newLastBaseUpdate = null;
            var update = firstBaseUpdate;
            do {
                var updateLane = update.lane;
                var updateEventTime = update.eventTime;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        eventTime: updateEventTime,
                        lane: updateLane,
                        tag: update.tag,
                        payload: update.payload,
                        callback: update.callback,
                        next: null
                    };
                    if (newLastBaseUpdate === null) {
                        newFirstBaseUpdate = newLastBaseUpdate = clone;
                        newBaseState = newState;
                    } else newLastBaseUpdate = newLastBaseUpdate.next = clone;
                     // Update the remaining priority in the queue.
                    newLanes = mergeLanes(newLanes, updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newLastBaseUpdate !== null) {
                        var _clone = {
                            eventTime: updateEventTime,
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        newLastBaseUpdate = newLastBaseUpdate.next = _clone;
                    } // Process this update.
                    newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
                    var callback = update.callback;
                    if (callback !== null) {
                        workInProgress.flags |= Callback;
                        var effects = queue.effects;
                        if (effects === null) queue.effects = [
                            update
                        ];
                        else effects.push(update);
                    }
                }
                update = update.next;
                if (update === null) {
                    pendingQueue = queue.shared.pending;
                    if (pendingQueue === null) break;
                    else {
                        // An update was scheduled from inside a reducer. Add the new
                        // pending updates to the end of the list and keep processing.
                        var _lastPendingUpdate = pendingQueue; // Intentionally unsound. Pending updates form a circular list, but we
                        // unravel them when transferring them to the base queue.
                        var _firstPendingUpdate = _lastPendingUpdate.next;
                        _lastPendingUpdate.next = null;
                        update = _firstPendingUpdate;
                        queue.lastBaseUpdate = _lastPendingUpdate;
                        queue.shared.pending = null;
                    }
                }
            }while (true);
            if (newLastBaseUpdate === null) newBaseState = newState;
            queue.baseState = newBaseState;
            queue.firstBaseUpdate = newFirstBaseUpdate;
            queue.lastBaseUpdate = newLastBaseUpdate; // Set the remaining expiration time to be whatever is remaining in the queue.
            // This should be fine because the only two other things that contribute to
            // expiration time are props and context. We're already in the middle of the
            // begin phase by the time we start processing the queue, so we've already
            // dealt with the props. Context in components that specify
            // shouldComponentUpdate is tricky; but we'll have to account for
            // that regardless.
            markSkippedUpdateLanes(newLanes);
            workInProgress.lanes = newLanes;
            workInProgress.memoizedState = newState;
        }
        currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
        if (!(typeof callback === 'function')) throw Error("Invalid argument passed as callback. Expected a function. Instead received: " + callback);
        callback.call(context);
    }
    function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
    }
    function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
    }
    function commitUpdateQueue(finishedWork, finishedQueue, instance) {
        // Commit the effects
        var effects = finishedQueue.effects;
        finishedQueue.effects = null;
        if (effects !== null) for(var i = 0; i < effects.length; i++){
            var effect = effects[i];
            var callback = effect.callback;
            if (callback !== null) {
                effect.callback = null;
                callCallback(callback, instance);
            }
        }
    }
    var fakeInternalInstance = {};
    var isArray = Array.isArray; // React.Component uses a shared frozen object by default.
    // We'll use it to determine whether we need to initialize legacy refs.
    var emptyRefsObject = new React.Component().refs;
    var didWarnAboutStateAssignmentForComponent;
    var didWarnAboutUninitializedState;
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
    var didWarnAboutLegacyLifecyclesAndDerivedState;
    var didWarnAboutUndefinedDerivedState;
    var warnOnUndefinedDerivedState;
    var warnOnInvalidCallback;
    var didWarnAboutDirectlyAssigningPropsToState;
    var didWarnAboutContextTypeAndContextTypes;
    var didWarnAboutInvalidateContextType;
    didWarnAboutStateAssignmentForComponent = new Set();
    didWarnAboutUninitializedState = new Set();
    didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    didWarnAboutDirectlyAssigningPropsToState = new Set();
    didWarnAboutUndefinedDerivedState = new Set();
    didWarnAboutContextTypeAndContextTypes = new Set();
    didWarnAboutInvalidateContextType = new Set();
    var didWarnOnInvalidCallback = new Set();
    warnOnInvalidCallback = function(callback, callerName) {
        if (callback === null || typeof callback === 'function') return;
        var key = callerName + '_' + callback;
        if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
        }
    };
    warnOnUndefinedDerivedState = function(type, partialState) {
        if (partialState === undefined) {
            var componentName = getComponentName(type) || 'Component';
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
            }
        }
    }; // This is so gross but it's at least non-critical and can be removed if
    // it causes problems. This is meant to give a nicer error message for
    // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
    // ...)) which otherwise throws a "_processChildContext is not a function"
    // exception.
    Object.defineProperty(fakeInternalInstance, '_processChildContext', {
        enumerable: false,
        value: function() {
            throw Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
    });
    Object.freeze(fakeInternalInstance);
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        if (workInProgress.mode & StrictMode) {
            disableLogs();
            try {
                // Invoke the function an extra time to help detect side-effects.
                getDerivedStateFromProps(nextProps, prevState);
            } finally{
                reenableLogs();
            }
        }
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        warnOnUndefinedDerivedState(ctor, partialState);
        var memoizedState = partialState === null || partialState === undefined ? prevState : _assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
        // base state.
        if (workInProgress.lanes === NoLanes) {
            // Queue is always non-null for classes
            var updateQueue = workInProgress.updateQueue;
            updateQueue.baseState = memoizedState;
        }
    }
    var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, 'setState');
                update.callback = callback;
            }
            enqueueUpdate(fiber, update);
            scheduleUpdateOnFiber(fiber, lane, eventTime);
        },
        enqueueReplaceState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ReplaceState;
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, 'replaceState');
                update.callback = callback;
            }
            enqueueUpdate(fiber, update);
            scheduleUpdateOnFiber(fiber, lane, eventTime);
        },
        enqueueForceUpdate: function(inst, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ForceUpdate;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, 'forceUpdate');
                update.callback = callback;
            }
            enqueueUpdate(fiber, update);
            scheduleUpdateOnFiber(fiber, lane, eventTime);
        }
    };
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if (typeof instance.shouldComponentUpdate === 'function') {
            if (workInProgress.mode & StrictMode) {
                disableLogs();
                try {
                    // Invoke the function an extra time to help detect side-effects.
                    instance.shouldComponentUpdate(newProps, newState, nextContext);
                } finally{
                    reenableLogs();
                }
            }
            var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
            if (shouldUpdate === undefined) error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentName(ctor) || 'Component');
            return shouldUpdate;
        }
        if (ctor.prototype && ctor.prototype.isPureReactComponent) return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        return true;
    }
    function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        var name = getComponentName(ctor) || 'Component';
        var renderPresent = instance.render;
        if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === 'function') error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
            else error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
        }
        if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
        if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
        if (instance.propTypes) error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
        if (instance.contextType) error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
        if (instance.contextTypes) error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
        if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
            didWarnAboutContextTypeAndContextTypes.add(ctor);
            error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
        }
        if (typeof instance.componentShouldUpdate === 'function') error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== 'undefined') error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentName(ctor) || 'A pure component');
        if (typeof instance.componentDidUnmount === 'function') error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
        if (typeof instance.componentDidReceiveProps === 'function') error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
        if (typeof instance.componentWillRecieveProps === 'function') error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
        if (typeof instance.UNSAFE_componentWillRecieveProps === 'function') error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
        var hasMutatedProps = instance.props !== newProps;
        if (instance.props !== undefined && hasMutatedProps) error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
        if (instance.defaultProps) error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
        if (typeof instance.getSnapshotBeforeUpdate === 'function' && typeof instance.componentDidUpdate !== 'function' && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentName(ctor));
        }
        if (typeof instance.getDerivedStateFromProps === 'function') error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof instance.getDerivedStateFromError === 'function') error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof ctor.getSnapshotBeforeUpdate === 'function') error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
        var _state = instance.state;
        if (_state && (typeof _state !== 'object' || isArray(_state))) error('%s.state: must be set to an object or null', name);
        if (typeof instance.getChildContext === 'function' && typeof ctor.childContextTypes !== 'object') error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
    }
    function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates
        set(instance, workInProgress);
        instance._reactInternalInstance = fakeInternalInstance;
    }
    function constructClassInstance(workInProgress, ctor, props) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        if ('contextType' in ctor) {
            var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>
            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = '';
                if (contextType === undefined) addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                else if (typeof contextType !== 'object') addendum = ' However, it is set to a ' + typeof contextType + '.';
                else if (contextType.$$typeof === REACT_PROVIDER_TYPE) addendum = ' Did you accidentally pass the Context.Provider instead?';
                else if (contextType._context !== undefined) // <Context.Consumer>
                addendum = ' Did you accidentally pass the Context.Consumer instead?';
                else addendum = ' However, it is set to an object with keys {' + Object.keys(contextType).join(', ') + '}.';
                error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentName(ctor) || 'Component', addendum);
            }
        }
        if (typeof contextType === 'object' && contextType !== null) context = readContext(contextType);
        else {
            unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            var contextTypes = ctor.contextTypes;
            isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
            context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        } // Instantiate twice to help detect side-effects.
        if (workInProgress.mode & StrictMode) {
            disableLogs();
            try {
                new ctor(props, context); // eslint-disable-line no-new
            } finally{
                reenableLogs();
            }
        }
        var instance = new ctor(props, context);
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        if (typeof ctor.getDerivedStateFromProps === 'function' && state === null) {
            var componentName = getComponentName(ctor) || 'Component';
            if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? 'null' : 'undefined', componentName);
            }
        } // If new component APIs are defined, "unsafe" lifecycles won't be called.
        // Warn about these lifecycles if they are present.
        // Don't warn about react-lifecycles-compat polyfilled methods though.
        if (typeof ctor.getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function') {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true) foundWillMountName = 'componentWillMount';
            else if (typeof instance.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
            if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) foundWillReceivePropsName = 'componentWillReceiveProps';
            else if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
            if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) foundWillUpdateName = 'componentWillUpdate';
            else if (typeof instance.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentName(ctor) || 'Component';
                var newApiName = typeof ctor.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                    didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                    error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : '', foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : '', foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : '');
                }
            }
        }
        // ReactFiberContext usually updates this cache but can't for newly-created instances.
        if (isLegacyContextConsumer) cacheContext(workInProgress, unmaskedContext, context);
        return instance;
    }
    function callComponentWillMount(workInProgress, instance) {
        var oldState = instance.state;
        if (typeof instance.componentWillMount === 'function') instance.componentWillMount();
        if (typeof instance.UNSAFE_componentWillMount === 'function') instance.UNSAFE_componentWillMount();
        if (oldState !== instance.state) {
            error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentName(workInProgress.type) || 'Component');
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        if (typeof instance.componentWillReceiveProps === 'function') instance.componentWillReceiveProps(newProps, nextContext);
        if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        if (instance.state !== oldState) {
            var componentName = getComponentName(workInProgress.type) || 'Component';
            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                didWarnAboutStateAssignmentForComponent.add(componentName);
                error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", componentName);
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    } // Invokes the mount life-cycles on a previously never rendered instance.
    function mountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        checkClassInstance(workInProgress, ctor, newProps);
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = emptyRefsObject;
        initializeUpdateQueue(workInProgress);
        var contextType = ctor.contextType;
        if (typeof contextType === 'object' && contextType !== null) instance.context = readContext(contextType);
        else {
            var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }
        if (instance.state === newProps) {
            var componentName = getComponentName(ctor) || 'Component';
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
            }
        }
        if (workInProgress.mode & StrictMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        instance.state = workInProgress.memoizedState;
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            instance.state = workInProgress.memoizedState;
        } // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (typeof ctor.getDerivedStateFromProps !== 'function' && typeof instance.getSnapshotBeforeUpdate !== 'function' && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
            callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
            // process them now.
            processUpdateQueue(workInProgress, newProps, instance, renderLanes);
            instance.state = workInProgress.memoizedState;
        }
        if (typeof instance.componentDidMount === 'function') workInProgress.flags |= Update;
    }
    function resumeMountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === 'object' && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
            if (oldProps !== newProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === 'function') workInProgress.flags |= Update;
            return false;
        }
        if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
                if (typeof instance.componentWillMount === 'function') instance.componentWillMount();
                if (typeof instance.UNSAFE_componentWillMount === 'function') instance.UNSAFE_componentWillMount();
            }
            if (typeof instance.componentDidMount === 'function') workInProgress.flags |= Update;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === 'function') workInProgress.flags |= Update;
             // If shouldComponentUpdate returned false, we should still update the
            // memoized state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    } // Invokes the update life-cycles and returns false if it shouldn't rerender.
    function updateClassInstance(current, workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        var unresolvedOldProps = workInProgress.memoizedProps;
        var oldProps = workInProgress.type === workInProgress.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress.type, unresolvedOldProps);
        instance.props = oldProps;
        var unresolvedNewProps = workInProgress.pendingProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === 'object' && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
            if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === 'function') {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === 'function') {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === 'function' || typeof instance.componentWillUpdate === 'function')) {
                if (typeof instance.componentWillUpdate === 'function') instance.componentWillUpdate(newProps, newState, nextContext);
                if (typeof instance.UNSAFE_componentWillUpdate === 'function') instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
            }
            if (typeof instance.componentDidUpdate === 'function') workInProgress.flags |= Update;
            if (typeof instance.getSnapshotBeforeUpdate === 'function') workInProgress.flags |= Snapshot;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === 'function') {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === 'function') {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized props/state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    }
    var didWarnAboutMaps;
    var didWarnAboutGenerators;
    var didWarnAboutStringRefs;
    var ownerHasKeyUseWarning;
    var ownerHasFunctionTypeWarning;
    var warnForMissingKey = function(child, returnFiber) {};
    didWarnAboutMaps = false;
    didWarnAboutGenerators = false;
    didWarnAboutStringRefs = {};
    /**
   * Warn if there's no key explicitly set on dynamic arrays of children or
   * object keys are not valid. This allows us to keep track of children between
   * updates.
   */ ownerHasKeyUseWarning = {};
    ownerHasFunctionTypeWarning = {};
    warnForMissingKey = function(child, returnFiber) {
        if (child === null || typeof child !== 'object') return;
        if (!child._store || child._store.validated || child.key != null) return;
        if (!(typeof child._store === 'object')) throw Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        child._store.validated = true;
        var componentName = getComponentName(returnFiber.type) || 'Component';
        if (ownerHasKeyUseWarning[componentName]) return;
        ownerHasKeyUseWarning[componentName] = true;
        error('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.');
    };
    var isArray$1 = Array.isArray;
    function coerceRef(returnFiber, current, element) {
        var mixedRef = element.ref;
        if (mixedRef !== null && typeof mixedRef !== 'function' && typeof mixedRef !== 'object') {
            // TODO: Clean this up once we turn on the string ref warning for
            // everyone, because the strict mode case will no longer be relevant
            if ((returnFiber.mode & StrictMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
            // because these cannot be automatically converted to an arrow function
            // using a codemod. Therefore, we don't have to warn about string refs again.
            !(element._owner && element._self && element._owner.stateNode !== element._self)) {
                var componentName = getComponentName(returnFiber.type) || 'Component';
                if (!didWarnAboutStringRefs[componentName]) {
                    error('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', mixedRef);
                    didWarnAboutStringRefs[componentName] = true;
                }
            }
            if (element._owner) {
                var owner = element._owner;
                var inst;
                if (owner) {
                    var ownerFiber = owner;
                    if (!(ownerFiber.tag === ClassComponent)) throw Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
                    inst = ownerFiber.stateNode;
                }
                if (!inst) throw Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a bug in React. Please file an issue.");
                var stringRef = '' + mixedRef; // Check if previous string ref matches new string ref
                if (current !== null && current.ref !== null && typeof current.ref === 'function' && current.ref._stringRef === stringRef) return current.ref;
                var ref = function(value) {
                    var refs = inst.refs;
                    if (refs === emptyRefsObject) // This is a lazy pooled frozen object, so we need to initialize.
                    refs = inst.refs = {};
                    if (value === null) delete refs[stringRef];
                    else refs[stringRef] = value;
                };
                ref._stringRef = stringRef;
                return ref;
            } else {
                if (!(typeof mixedRef === 'string')) throw Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
                if (!element._owner) throw Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of the following reasons:\n1. You may be adding a ref to a function component\n2. You may be adding a ref to a component that was not created inside a component's render method\n3. You have multiple copies of React loaded\nSee https://reactjs.org/link/refs-must-have-owner for more information.");
            }
        }
        return mixedRef;
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        if (returnFiber.type !== 'textarea') throw Error("Objects are not valid as a React child (found: " + (Object.prototype.toString.call(newChild) === '[object Object]' ? 'object with keys {' + Object.keys(newChild).join(', ') + '}' : newChild) + "). If you meant to render a collection of children, use an array instead.");
    }
    function warnOnFunctionType(returnFiber) {
        var componentName = getComponentName(returnFiber.type) || 'Component';
        if (ownerHasFunctionTypeWarning[componentName]) return;
        ownerHasFunctionTypeWarning[componentName] = true;
        error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    } // We avoid inlining this to avoid potential deopts from using try/catch.
    // to be able to optimize each path individually by branching early. This needs
    // a compiler or we can do it manually. Helpers that don't need this branching
    // live outside of this function.
    function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (!shouldTrackSideEffects) // Noop.
            return;
             // Deletions are added in reversed order so we add it to the front.
            // At this point, the return fiber's effect list is empty except for
            // deletions, so we can just append the deletion to the list. The remaining
            // effects aren't added until the complete phase. Once we implement
            // resuming, this may not be true.
            var last = returnFiber.lastEffect;
            if (last !== null) {
                last.nextEffect = childToDelete;
                returnFiber.lastEffect = childToDelete;
            } else returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
            childToDelete.nextEffect = null;
            childToDelete.flags = Deletion;
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) // Noop.
            return null;
             // TODO: For the shouldClone case, this could be micro-optimized a bit by
            // assuming that after the first child we've already added everything.
            var childToDelete = currentFirstChild;
            while(childToDelete !== null){
                deleteChild(returnFiber, childToDelete);
                childToDelete = childToDelete.sibling;
            }
            return null;
        }
        function mapRemainingChildren(returnFiber, currentFirstChild) {
            // Add the remaining children to a temporary map so that we can find them by
            // keys quickly. Implicit (null) keys get added to this set with their index
            // instead.
            var existingChildren = new Map();
            var existingChild = currentFirstChild;
            while(existingChild !== null){
                if (existingChild.key !== null) existingChildren.set(existingChild.key, existingChild);
                else existingChildren.set(existingChild.index, existingChild);
                existingChild = existingChild.sibling;
            }
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            // We currently set sibling to null and index to 0 here because it is easy
            // to forget to do before returning it. E.g. for the single child case.
            var clone = createWorkInProgress(fiber, pendingProps);
            clone.index = 0;
            clone.sibling = null;
            return clone;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) // Noop.
            return lastPlacedIndex;
            var current = newFiber.alternate;
            if (current !== null) {
                var oldIndex = current.index;
                if (oldIndex < lastPlacedIndex) {
                    // This is a move.
                    newFiber.flags = Placement;
                    return lastPlacedIndex;
                } else // This item can stay in place.
                return oldIndex;
            } else {
                // This is an insertion.
                newFiber.flags = Placement;
                return lastPlacedIndex;
            }
        }
        function placeSingleChild(newFiber) {
            // This is simpler for the single child case. We only need to do a
            // placement for inserting new children.
            if (shouldTrackSideEffects && newFiber.alternate === null) newFiber.flags = Placement;
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, lanes) {
            if (current === null || current.tag !== HostText) {
                // Insert
                var created = createFiberFromText(textContent, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, textContent);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateElement(returnFiber, current, element, lanes) {
            if (current !== null) {
                if (current.elementType === element.type || isCompatibleFamilyForHotReloading(current, element)) {
                    // Move based on index
                    var existing = useFiber(current, element.props);
                    existing.ref = coerceRef(returnFiber, current, element);
                    existing.return = returnFiber;
                    existing._debugSource = element._source;
                    existing._debugOwner = element._owner;
                    return existing;
                }
            } // Insert
            var created = createFiberFromElement(element, returnFiber.mode, lanes);
            created.ref = coerceRef(returnFiber, current, element);
            created.return = returnFiber;
            return created;
        }
        function updatePortal(returnFiber, current, portal, lanes) {
            if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
                // Insert
                var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, portal.children || []);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateFragment(returnFiber, current, fragment, lanes, key) {
            if (current === null || current.tag !== Fragment) {
                // Insert
                var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, fragment);
                existing.return = returnFiber;
                return existing;
            }
        }
        function createChild(returnFiber, newChild, lanes) {
            if (typeof newChild === 'string' || typeof newChild === 'number') {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                var created = createFiberFromText('' + newChild, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            }
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);
                        _created.ref = coerceRef(returnFiber, null, newChild);
                        _created.return = returnFiber;
                        return _created;
                    case REACT_PORTAL_TYPE:
                        var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        _created2.return = returnFiber;
                        return _created2;
                }
                if (isArray$1(newChild) || getIteratorFn(newChild)) {
                    var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);
                    _created3.return = returnFiber;
                    return _created3;
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'function') warnOnFunctionType(returnFiber);
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            // Update the fiber if the keys match, otherwise return null.
            var key = oldFiber !== null ? oldFiber.key : null;
            if (typeof newChild === 'string' || typeof newChild === 'number') {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                if (key !== null) return null;
                return updateTextNode(returnFiber, oldFiber, '' + newChild, lanes);
            }
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        if (newChild.key === key) {
                            if (newChild.type === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, oldFiber, newChild.props.children, lanes, key);
                            return updateElement(returnFiber, oldFiber, newChild, lanes);
                        } else return null;
                    case REACT_PORTAL_TYPE:
                        if (newChild.key === key) return updatePortal(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                }
                if (isArray$1(newChild) || getIteratorFn(newChild)) {
                    if (key !== null) return null;
                    return updateFragment(returnFiber, oldFiber, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'function') warnOnFunctionType(returnFiber);
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if (typeof newChild === 'string' || typeof newChild === 'number') {
                // Text nodes don't have keys, so we neither have to check the old nor
                // new node for the key. If both are text nodes, they match.
                var matchedFiber = existingChildren.get(newIdx) || null;
                return updateTextNode(returnFiber, matchedFiber, '' + newChild, lanes);
            }
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        if (newChild.type === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, _matchedFiber, newChild.props.children, lanes, newChild.key);
                        return updateElement(returnFiber, _matchedFiber, newChild, lanes);
                    case REACT_PORTAL_TYPE:
                        var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
                }
                if (isArray$1(newChild) || getIteratorFn(newChild)) {
                    var _matchedFiber3 = existingChildren.get(newIdx) || null;
                    return updateFragment(returnFiber, _matchedFiber3, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'function') warnOnFunctionType(returnFiber);
            return null;
        }
        /**
   * Warns if there is a duplicate or missing key
   */ function warnOnInvalidKey(child, knownKeys, returnFiber) {
            if (typeof child !== 'object' || child === null) return knownKeys;
            switch(child.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    warnForMissingKey(child, returnFiber);
                    var key = child.key;
                    if (typeof key !== 'string') break;
                    if (knownKeys === null) {
                        knownKeys = new Set();
                        knownKeys.add(key);
                        break;
                    }
                    if (!knownKeys.has(key)) {
                        knownKeys.add(key);
                        break;
                    }
                    error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key);
                    break;
            }
            return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            // First, validate keys.
            var knownKeys = null;
            for(var i = 0; i < newChildren.length; i++){
                var child = newChildren[i];
                knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            for(; oldFiber !== null && newIdx < newChildren.length; newIdx++){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; newIdx < newChildren.length; newIdx++){
                    var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);
                    if (_newFiber === null) continue;
                    lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber;
                    else previousNewFiber.sibling = _newFiber;
                    previousNewFiber = _newFiber;
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; newIdx < newChildren.length; newIdx++){
                var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);
                if (_newFiber2 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber2.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber2;
                    else previousNewFiber.sibling = _newFiber2;
                    previousNewFiber = _newFiber2;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
            // This is the same implementation as reconcileChildrenArray(),
            // but using the iterator instead.
            var iteratorFn = getIteratorFn(newChildrenIterable);
            if (!(typeof iteratorFn === 'function')) throw Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
            // We don't support rendering Generators because it's a mutation.
            // See https://github.com/facebook/react/issues/12995
            if (typeof Symbol === 'function' && // $FlowFixMe Flow doesn't know about toStringTag
            newChildrenIterable[Symbol.toStringTag] === 'Generator') {
                if (!didWarnAboutGenerators) error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
                didWarnAboutGenerators = true;
            } // Warn about using Maps as children
            if (newChildrenIterable.entries === iteratorFn) {
                if (!didWarnAboutMaps) error("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                didWarnAboutMaps = true;
            } // First, validate keys.
            // We'll get a different iterator later for the main pass.
            var _newChildren = iteratorFn.call(newChildrenIterable);
            if (_newChildren) {
                var knownKeys = null;
                var _step = _newChildren.next();
                for(; !_step.done; _step = _newChildren.next()){
                    var child = _step.value;
                    knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
                }
            }
            var newChildren = iteratorFn.call(newChildrenIterable);
            if (!(newChildren != null)) throw Error("An iterable object provided no iterator.");
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            var step = newChildren.next();
            for(; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; !step.done; newIdx++, step = newChildren.next()){
                    var _newFiber3 = createChild(returnFiber, step.value, lanes);
                    if (_newFiber3 === null) continue;
                    lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber3;
                    else previousNewFiber.sibling = _newFiber3;
                    previousNewFiber = _newFiber3;
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; !step.done; newIdx++, step = newChildren.next()){
                var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);
                if (_newFiber4 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber4.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber4;
                    else previousNewFiber.sibling = _newFiber4;
                    previousNewFiber = _newFiber4;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            return resultingFirstChild;
        }
        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
            // There's no need to check for keys on text nodes since we don't have a
            // way to define them.
            if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
                // We already have an existing node so let's just update it and delete
                // the rest.
                deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                var existing = useFiber(currentFirstChild, textContent);
                existing.return = returnFiber;
                return existing;
            } // The existing first child is not a text node so we need to create one
            // and delete the existing ones.
            deleteRemainingChildren(returnFiber, currentFirstChild);
            var created = createFiberFromText(textContent, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        }
        function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
            var key = element.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    switch(child.tag){
                        case Fragment:
                            if (element.type === REACT_FRAGMENT_TYPE) {
                                deleteRemainingChildren(returnFiber, child.sibling);
                                var existing = useFiber(child, element.props.children);
                                existing.return = returnFiber;
                                existing._debugSource = element._source;
                                existing._debugOwner = element._owner;
                                return existing;
                            }
                            break;
                        case Block:
                        // We intentionally fallthrough here if enableBlocksAPI is not on.
                        // eslint-disable-next-lined no-fallthrough
                        default:
                            if (child.elementType === element.type || isCompatibleFamilyForHotReloading(child, element)) {
                                deleteRemainingChildren(returnFiber, child.sibling);
                                var _existing3 = useFiber(child, element.props);
                                _existing3.ref = coerceRef(returnFiber, child, element);
                                _existing3.return = returnFiber;
                                _existing3._debugSource = element._source;
                                _existing3._debugOwner = element._owner;
                                return _existing3;
                            }
                            break;
                    } // Didn't match.
                    deleteRemainingChildren(returnFiber, child);
                    break;
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            if (element.type === REACT_FRAGMENT_TYPE) {
                var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
                created.return = returnFiber;
                return created;
            } else {
                var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);
                _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
                _created4.return = returnFiber;
                return _created4;
            }
        }
        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
            var key = portal.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var existing = useFiber(child, portal.children || []);
                        existing.return = returnFiber;
                        return existing;
                    } else {
                        deleteRemainingChildren(returnFiber, child);
                        break;
                    }
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        } // This API will tag the children with the side-effect of the reconciliation
        // itself. They will be added to the side-effect list as we pass through the
        // children and the parent.
        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, lanes) {
            // This function is not recursive.
            // If the top level item is an array, we treat it as a set of children,
            // not as a fragment. Nested arrays on the other hand will be treated as
            // fragment nodes. Recursion happens at the normal flow.
            // Handle top level unkeyed fragments as if they were arrays.
            // This leads to an ambiguity between <>{[...]}</> and <>...</>.
            // We treat the ambiguous cases above the same.
            var isUnkeyedTopLevelFragment = typeof newChild === 'object' && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
            if (isUnkeyedTopLevelFragment) newChild = newChild.props.children;
             // Handle object types
            var isObject = typeof newChild === 'object' && newChild !== null;
            if (isObject) switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));
                case REACT_PORTAL_TYPE:
                    return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));
            }
            if (typeof newChild === 'string' || typeof newChild === 'number') return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, '' + newChild, lanes));
            if (isArray$1(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if (getIteratorFn(newChild)) return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            if (isObject) throwOnInvalidObjectType(returnFiber, newChild);
            if (typeof newChild === 'function') warnOnFunctionType(returnFiber);
            if (typeof newChild === 'undefined' && !isUnkeyedTopLevelFragment) // If the new child is undefined, and the return fiber is a composite
            // component, throw an error. If Fiber return types are disabled,
            // we already threw above.
            switch(returnFiber.tag){
                case ClassComponent:
                    var instance = returnFiber.stateNode;
                    if (instance.render._isMockFunction) break;
                // Intentionally fall through to the next case, which handles both
                // functions and classes
                // eslint-disable-next-lined no-fallthrough
                case Block:
                case FunctionComponent:
                case ForwardRef:
                case SimpleMemoComponent:
                    throw Error((getComponentName(returnFiber.type) || 'Component') + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null.");
            }
             // Remaining cases are all treated as empty.
            return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return reconcileChildFibers;
    }
    var reconcileChildFibers = ChildReconciler(true);
    var mountChildFibers = ChildReconciler(false);
    function cloneChildFibers(current, workInProgress) {
        if (!(current === null || workInProgress.child === current.child)) throw Error("Resuming work not yet implemented.");
        if (workInProgress.child === null) return;
        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
        workInProgress.child = newChild;
        newChild.return = workInProgress;
        while(currentChild.sibling !== null){
            currentChild = currentChild.sibling;
            newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
            newChild.return = workInProgress;
        }
        newChild.sibling = null;
    } // Reset a workInProgress child set to prepare it for a second pass.
    function resetChildFibers(workInProgress, lanes) {
        var child = workInProgress.child;
        while(child !== null){
            resetWorkInProgress(child, lanes);
            child = child.sibling;
        }
    }
    var NO_CONTEXT = {};
    var contextStackCursor$1 = createCursor(NO_CONTEXT);
    var contextFiberStackCursor = createCursor(NO_CONTEXT);
    var rootInstanceStackCursor = createCursor(NO_CONTEXT);
    function requiredContext(c) {
        if (!(c !== NO_CONTEXT)) throw Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return c;
    }
    function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        // Push current root instance onto the stack;
        // This allows us to reset root when portals are popped.
        push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
        // However, we can't just call getRootHostContext() and push it because
        // we'd have a different number of entries on the stack depending on
        // whether getRootHostContext() throws somewhere in renderer code or not.
        // So we push an empty value first. This lets us safely unwind on errors.
        push(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.
        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
    }
    function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.
        if (context === nextContext) return;
         // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
    }
    function popHostContext(fiber) {
        // Do not pop unless this Fiber provided the current context.
        // pushHostContext() only pushes Fibers that provide unique contexts.
        if (contextFiberStackCursor.current !== fiber) return;
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
    }
    var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
    // inherited deeply down the subtree. The upper bits only affect
    // this immediate suspense boundary and gets reset each new
    // boundary or suspense list.
    var SubtreeSuspenseContextMask = 1; // Subtree Flags:
    // InvisibleParentSuspenseContext indicates that one of our parent Suspense
    // boundaries is not currently showing visible main content.
    // Either because it is already showing a fallback or is not mounted at all.
    // We can use this to determine if it is desirable to trigger a fallback at
    // the parent. If not, then we might need to trigger undesirable boundaries
    // and/or suspend the commit to avoid hiding the parent content.
    var InvisibleParentSuspenseContext = 1; // Shallow Flags:
    // ForceSuspenseFallback can be used by SuspenseList to force newly added
    // items into their fallback state during one of the render passes.
    var ForceSuspenseFallback = 2;
    var suspenseStackCursor = createCursor(DefaultSuspenseContext);
    function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
    }
    function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
    }
    function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
    }
    function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
    }
    function pushSuspenseContext(fiber, newContext) {
        push(suspenseStackCursor, newContext, fiber);
    }
    function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
    }
    function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
        // If it was the primary children that just suspended, capture and render the
        // fallback. Otherwise, don't capture and bubble to the next boundary.
        var nextState = workInProgress.memoizedState;
        if (nextState !== null) {
            if (nextState.dehydrated !== null) // A dehydrated boundary always captures.
            return true;
            return false;
        }
        var props = workInProgress.memoizedProps; // In order to capture, the Suspense component must have a fallback prop.
        if (props.fallback === undefined) return false;
         // Regular boundaries always capture.
        if (props.unstable_avoidThisFallback !== true) return true;
         // If it's a boundary we should avoid, then we prefer to bubble up to the
        // parent boundary if it is currently invisible.
        if (hasInvisibleParent) return false;
         // If the parent is not able to handle it, we must handle it.
        return true;
    }
    function findFirstSuspended(row) {
        var node = row;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) {
                    var dehydrated = state.dehydrated;
                    if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) return node;
                }
            } else if (node.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
            // keep track of whether it suspended or not.
            node.memoizedProps.revealOrder !== undefined) {
                var didSuspend = (node.flags & DidCapture) !== NoFlags;
                if (didSuspend) return node;
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) return null;
            while(node.sibling === null){
                if (node.return === null || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    var NoFlags$1 = /*  */ 0; // Represents whether effect should fire.
    var HasEffect = /* */ 1; // Represents the phase in which the effect (not the clean-up) fires.
    var Layout = /*    */ 2;
    var Passive$1 = /*   */ 4;
    // This may have been an insertion or a hydration.
    var hydrationParentFiber = null;
    var nextHydratableInstance = null;
    var isHydrating = false;
    function enterHydrationState(fiber) {
        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChild(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        return true;
    }
    function deleteHydratableInstance(returnFiber, instance) {
        switch(returnFiber.tag){
            case HostRoot:
                didNotHydrateContainerInstance(returnFiber.stateNode.containerInfo, instance);
                break;
            case HostComponent:
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance);
                break;
        }
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance;
        childToDelete.return = returnFiber;
        childToDelete.flags = Deletion; // This might seem like it belongs on progressedFirstDeletion. However,
        // these children are not part of the reconciliation list of children.
        // Even if we abort and rereconcile the children, that will try to hydrate
        // again and the nodes are still in the host tree so these will be
        // recreated.
        if (returnFiber.lastEffect !== null) {
            returnFiber.lastEffect.nextEffect = childToDelete;
            returnFiber.lastEffect = childToDelete;
        } else returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
    }
    function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.flags = fiber.flags & ~Hydrating | Placement;
        switch(returnFiber.tag){
            case HostRoot:
                var parentContainer = returnFiber.stateNode.containerInfo;
                switch(fiber.tag){
                    case HostComponent:
                        var type = fiber.type;
                        var props = fiber.pendingProps;
                        didNotFindHydratableContainerInstance(parentContainer, type);
                        break;
                    case HostText:
                        var text = fiber.pendingProps;
                        didNotFindHydratableContainerTextInstance(parentContainer, text);
                        break;
                }
                break;
            case HostComponent:
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;
                switch(fiber.tag){
                    case HostComponent:
                        var _type = fiber.type;
                        var _props = fiber.pendingProps;
                        didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type);
                        break;
                    case HostText:
                        var _text = fiber.pendingProps;
                        didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text);
                        break;
                    case SuspenseComponent:
                        didNotFindHydratableSuspenseInstance(parentType, parentProps);
                        break;
                }
                break;
            default:
                return;
        }
    }
    function tryHydrate(fiber, nextInstance) {
        switch(fiber.tag){
            case HostComponent:
                var type = fiber.type;
                var props = fiber.pendingProps;
                var instance = canHydrateInstance(nextInstance, type);
                if (instance !== null) {
                    fiber.stateNode = instance;
                    return true;
                }
                return false;
            case HostText:
                var text = fiber.pendingProps;
                var textInstance = canHydrateTextInstance(nextInstance, text);
                if (textInstance !== null) {
                    fiber.stateNode = textInstance;
                    return true;
                }
                return false;
            case SuspenseComponent:
                return false;
            default:
                return false;
        }
    }
    function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) return;
        var nextInstance = nextHydratableInstance;
        if (!nextInstance) {
            // Nothing to hydrate. Make it an insertion.
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
        }
        var firstAttemptedInstance = nextInstance;
        if (!tryHydrate(fiber, nextInstance)) {
            // If we can't hydrate this instance let's try the next one.
            // We use this as a heuristic. It's based on intuition and not data so it
            // might be flawed or unnecessary.
            nextInstance = getNextHydratableSibling(firstAttemptedInstance);
            if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
                // Nothing to hydrate. Make it an insertion.
                insertNonHydratedInstance(hydrationParentFiber, fiber);
                isHydrating = false;
                hydrationParentFiber = fiber;
                return;
            } // We matched the next one, we'll now assume that the first one was
            // superfluous and we'll delete it. Since we can't eagerly delete it
            // we'll have to schedule a deletion. To do that, this node needs a dummy
            // fiber associated with it.
            deleteHydratableInstance(hydrationParentFiber, firstAttemptedInstance);
        }
        hydrationParentFiber = fiber;
        nextHydratableInstance = getFirstHydratableChild(nextInstance);
    }
    function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        var instance = fiber.stateNode;
        var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber); // TODO: Type this specific to this type of component.
        fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update.
        if (updatePayload !== null) return true;
        return false;
    }
    function prepareToHydrateHostTextInstance(fiber) {
        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
        if (shouldUpdate) {
            // We assume that prepareToHydrateHostTextInstance is called in a context where the
            // hydration parent is the parent host component of this host text.
            var returnFiber = hydrationParentFiber;
            if (returnFiber !== null) switch(returnFiber.tag){
                case HostRoot:
                    var parentContainer = returnFiber.stateNode.containerInfo;
                    didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent);
                    break;
                case HostComponent:
                    var parentType = returnFiber.type;
                    var parentProps = returnFiber.memoizedProps;
                    var parentInstance = returnFiber.stateNode;
                    didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent);
                    break;
            }
        }
        return shouldUpdate;
    }
    function skipPastDehydratedSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
    }
    function popToNextHostParent(fiber) {
        var parent = fiber.return;
        while(parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent)parent = parent.return;
        hydrationParentFiber = parent;
    }
    function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) // We're deeper than the current hydration context, inside an inserted
        // tree.
        return false;
        if (!isHydrating) {
            // If we're not currently hydrating but we're in a hydration context, then
            // we were an insertion and now need to pop up reenter hydration of our
            // siblings.
            popToNextHostParent(fiber);
            isHydrating = true;
            return false;
        }
        var type = fiber.type; // If we have any remaining hydratable nodes, we need to delete them now.
        // We only do this deeper than head and body since they tend to have random
        // other nodes in them. We also ignore components with pure text content in
        // side of them.
        // TODO: Better heuristic.
        if (fiber.tag !== HostComponent || type !== 'head' && type !== 'body' && !shouldSetTextContent(type, fiber.memoizedProps)) {
            var nextInstance = nextHydratableInstance;
            while(nextInstance){
                deleteHydratableInstance(fiber, nextInstance);
                nextInstance = getNextHydratableSibling(nextInstance);
            }
        }
        popToNextHostParent(fiber);
        if (fiber.tag === SuspenseComponent) nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
        else nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        return true;
    }
    function resetHydrationState() {
        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
    }
    function getIsHydrating() {
        return isHydrating;
    }
    // and should be reset before starting a new render.
    // This tracks which mutable sources need to be reset after a render.
    var workInProgressSources = [];
    var rendererSigil$1;
    // Used to detect multiple renderers using the same mutable source.
    rendererSigil$1 = {};
    function markSourceAsDirty(mutableSource) {
        workInProgressSources.push(mutableSource);
    }
    function resetWorkInProgressVersions() {
        for(var i = 0; i < workInProgressSources.length; i++){
            var mutableSource = workInProgressSources[i];
            mutableSource._workInProgressVersionPrimary = null;
        }
        workInProgressSources.length = 0;
    }
    function getWorkInProgressVersion(mutableSource) {
        return mutableSource._workInProgressVersionPrimary;
    }
    function setWorkInProgressVersion(mutableSource, version) {
        mutableSource._workInProgressVersionPrimary = version;
        workInProgressSources.push(mutableSource);
    }
    function warnAboutMultipleRenderersDEV(mutableSource) {
        if (mutableSource._currentPrimaryRenderer == null) mutableSource._currentPrimaryRenderer = rendererSigil$1;
        else if (mutableSource._currentPrimaryRenderer !== rendererSigil$1) error("Detected multiple renderers concurrently rendering the same mutable source. This is currently unsupported.");
    } // Eager reads the version of a mutable source and stores it on the root.
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
    var didWarnAboutMismatchedHooksForComponent;
    var didWarnAboutUseOpaqueIdentifier;
    didWarnAboutUseOpaqueIdentifier = {};
    didWarnAboutMismatchedHooksForComponent = new Set();
    // These are set right before calling the component.
    var renderLanes = NoLanes; // The work-in-progress fiber. I've named it differently to distinguish it from
    // the work-in-progress hook.
    var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
    // current hook list is the list that belongs to the current fiber. The
    // work-in-progress hook list is a new list that will be added to the
    // work-in-progress fiber.
    var currentHook = null;
    var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
    // does not get reset if we do another render pass; only when we're completely
    // finished evaluating this component. This is an optimization so we know
    // whether we need to clear render phase updates after a throw.
    var didScheduleRenderPhaseUpdate = false; // Where an update was scheduled only during the current render pass. This
    // gets reset after each attempt.
    // TODO: Maybe there's some way to consolidate this with
    // `didScheduleRenderPhaseUpdate`. Or with `numberOfReRenders`.
    var didScheduleRenderPhaseUpdateDuringThisPass = false;
    var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook
    var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
    // The list stores the order of hooks used during the initial render (mount).
    // Subsequent renders (updates) reference this list.
    var hookTypesDev = null;
    var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
    // the dependencies for Hooks that need them (e.g. useEffect or useMemo).
    // When true, such Hooks will always be "remounted". Only used during hot reload.
    var ignorePreviousDependencies = false;
    function mountHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev === null) hookTypesDev = [
            hookName
        ];
        else hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;
            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) warnOnHookMismatchInDev(hookName);
        }
    }
    function checkDepsAreArrayDev(deps) {
        if (deps !== undefined && deps !== null && !Array.isArray(deps)) // Verify deps, but only on mount to avoid extra checks.
        // It's unlikely their type would change as usually you define them inline.
        error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
    }
    function warnOnHookMismatchInDev(currentHookName) {
        var componentName = getComponentName(currentlyRenderingFiber$1.type);
        if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);
            if (hookTypesDev !== null) {
                var table = '';
                var secondColumnStart = 30;
                for(var i = 0; i <= hookTypesUpdateIndexDev; i++){
                    var oldHookName = hookTypesDev[i];
                    var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                    var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
                    // lol @ IE not supporting String#repeat
                    while(row.length < secondColumnStart)row += ' ';
                    row += newHookName + '\n';
                    table += row;
                }
                error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
        }
    }
    function throwInvalidHookError() {
        throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (ignorePreviousDependencies) // Only true when this component is being hot reloaded.
        return false;
        if (prevDeps === null) {
            error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            return false;
        }
        // Don't bother comparing lengths in prod because these arrays should be
        // passed inline.
        if (nextDeps.length !== prevDeps.length) error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(', ') + "]", "[" + nextDeps.join(', ') + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++){
            if (objectIs(nextDeps[i], prevDeps[i])) continue;
            return false;
        }
        return true;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber$1 = workInProgress;
        hookTypesDev = current !== null ? current._debugHookTypes : null;
        hookTypesUpdateIndexDev = -1; // Used for hot reloading:
        ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = NoLanes; // The following should have already been reset
        if (current !== null && current.memoizedState !== null) ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
        else if (hookTypesDev !== null) // This dispatcher handles an edge case where a component is updating,
        // but no stateful hooks have been used.
        // We want to match the production code behavior (which will use HooksDispatcherOnMount),
        // but with the extra DEV validation to ensure hooks ordering hasn't changed.
        // This dispatcher does that.
        ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
        else ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
        var children = Component(props, secondArg); // Check if there was a render phase update
        if (didScheduleRenderPhaseUpdateDuringThisPass) {
            // Keep rendering in a loop for as long as render phase updates continue to
            // be scheduled. Use a counter to prevent infinite loops.
            var numberOfReRenders = 0;
            do {
                didScheduleRenderPhaseUpdateDuringThisPass = false;
                if (!(numberOfReRenders < RE_RENDER_LIMIT)) throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
                numberOfReRenders += 1;
                // Even when hot reloading, allow dependencies to stabilize
                // after first render to prevent infinite render phase updates.
                ignorePreviousDependencies = false;
                currentHook = null;
                workInProgressHook = null;
                workInProgress.updateQueue = null;
                // Also validate hook order for cascading updates.
                hookTypesUpdateIndexDev = -1;
                ReactCurrentDispatcher$1.current = HooksDispatcherOnRerenderInDEV;
                children = Component(props, secondArg);
            }while (didScheduleRenderPhaseUpdateDuringThisPass);
        } // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrancy.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        workInProgress._debugHookTypes = hookTypesDev;
        // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.
        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        currentHookNameInDev = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        didScheduleRenderPhaseUpdate = false;
        if (!!didRenderTooFewHooks) throw Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        return children;
    }
    function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue;
        workInProgress.flags &= ~(Passive | Update);
        current.lanes = removeLanes(current.lanes, lanes);
    }
    function resetHooksAfterThrow() {
        // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrancy.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        if (didScheduleRenderPhaseUpdate) {
            // There were render phase updates. These are only valid for this render
            // phase, which we are now aborting. Remove the updates from the queues so
            // they do not persist to the next render. Do not remove updates from hooks
            // that weren't processed.
            //
            // Only reset the updates from the queue if it has a clone. If it does
            // not have a clone, that means it wasn't processed, and the updates were
            // scheduled before we entered the render phase.
            var hook = currentlyRenderingFiber$1.memoizedState;
            while(hook !== null){
                var queue = hook.queue;
                if (queue !== null) queue.pending = null;
                hook = hook.next;
            }
            didScheduleRenderPhaseUpdate = false;
        }
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        currentHookNameInDev = null;
        isUpdatingOpaqueValueInRenderPhase = false;
        didScheduleRenderPhaseUpdateDuringThisPass = false;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        if (workInProgressHook === null) // This is the first hook in the list
        currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
        else // Append to the end of the list
        workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        // This function is used both for updates and for re-renders triggered by a
        // render phase update. It assumes there is either a current hook we can
        // clone, or a work-in-progress hook from a previous render pass that we can
        // use as a base. When we reach the end of the base list, we must switch to
        // the dispatcher used for mounts.
        var nextCurrentHook;
        if (currentHook === null) {
            var current = currentlyRenderingFiber$1.alternate;
            if (current !== null) nextCurrentHook = current.memoizedState;
            else nextCurrentHook = null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook;
        if (workInProgressHook === null) nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
        else nextWorkInProgressHook = workInProgressHook.next;
        if (nextWorkInProgressHook !== null) {
            // There's already a work-in-progress. Reuse it.
            workInProgressHook = nextWorkInProgressHook;
            nextWorkInProgressHook = workInProgressHook.next;
            currentHook = nextCurrentHook;
        } else {
            // Clone from the current hook.
            if (!(nextCurrentHook !== null)) throw Error("Rendered more hooks than during the previous render.");
            currentHook = nextCurrentHook;
            var newHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            if (workInProgressHook === null) // This is the first hook in the list.
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
            else // Append to the end of the list.
            workInProgressHook = workInProgressHook.next = newHook;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null
        };
    }
    function basicStateReducer(state, action) {
        // $FlowFixMe: Flow doesn't like mixed types
        return typeof action === 'function' ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        var initialState;
        if (init !== undefined) initialState = init(initialArg);
        else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        var queue = hook.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (!(queue !== null)) throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer;
        var current = currentHook; // The last rebase update that is NOT part of the base state.
        var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.
        var pendingQueue = queue.pending;
        if (pendingQueue !== null) {
            // We have new updates that haven't been processed yet.
            // We'll add them to the base queue.
            if (baseQueue !== null) {
                // Merge the pending queue and the base queue.
                var baseFirst = baseQueue.next;
                var pendingFirst = pendingQueue.next;
                baseQueue.next = pendingFirst;
                pendingQueue.next = baseFirst;
            }
            if (current.baseQueue !== baseQueue) // Internal invariant that should never happen, but feasibly could in
            // the future if we implement resuming, or some form of that.
            error("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.");
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        if (baseQueue !== null) {
            // We have a queue to process.
            var first = baseQueue.next;
            var newState = current.baseState;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            var update = first;
            do {
                var updateLane = update.lane;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        lane: updateLane,
                        action: update.action,
                        eagerReducer: update.eagerReducer,
                        eagerState: update.eagerState,
                        next: null
                    };
                    if (newBaseQueueLast === null) {
                        newBaseQueueFirst = newBaseQueueLast = clone;
                        newBaseState = newState;
                    } else newBaseQueueLast = newBaseQueueLast.next = clone;
                     // Update the remaining priority in the queue.
                    // TODO: Don't need to accumulate this. Instead, we can remove
                    // renderLanes from the original lanes.
                    currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
                    markSkippedUpdateLanes(updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newBaseQueueLast !== null) {
                        var _clone = {
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            action: update.action,
                            eagerReducer: update.eagerReducer,
                            eagerState: update.eagerState,
                            next: null
                        };
                        newBaseQueueLast = newBaseQueueLast.next = _clone;
                    } // Process this update.
                    if (update.eagerReducer === reducer) // If this update was processed eagerly, and its reducer matches the
                    // current reducer, we can use the eagerly computed state.
                    newState = update.eagerState;
                    else {
                        var action = update.action;
                        newState = reducer(newState, action);
                    }
                }
                update = update.next;
            }while (update !== null && update !== first);
            if (newBaseQueueLast === null) newBaseState = newState;
            else newBaseQueueLast.next = newBaseQueueFirst;
             // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState;
            hook.baseState = newBaseState;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = newState;
        }
        var dispatch = queue.dispatch;
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function rerenderReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (!(queue !== null)) throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
        // work-in-progress hook.
        var dispatch = queue.dispatch;
        var lastRenderPhaseUpdate = queue.pending;
        var newState = hook.memoizedState;
        if (lastRenderPhaseUpdate !== null) {
            // The queue doesn't persist past this render pass.
            queue.pending = null;
            var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            var update = firstRenderPhaseUpdate;
            do {
                // Process this render phase update. We don't have to check the
                // priority because it will always be the same as the current
                // render's.
                var action = update.action;
                newState = reducer(newState, action);
                update = update.next;
            }while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
            // the base state unless the queue is empty.
            // TODO: Not sure if this is the desired semantics, but it's what we
            // do for gDSFP. I can't remember why.
            if (hook.baseQueue === null) hook.baseState = newState;
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function readFromUnsubcribedMutableSource(root, source, getSnapshot) {
        warnAboutMultipleRenderersDEV(source);
        var getVersion = source._getVersion;
        var version = getVersion(source._source); // Is it safe for this component to read from this source during the current render?
        var isSafeToReadFromSource = false; // Check the version first.
        // If this render has already been started with a specific version,
        // we can use it alone to determine if we can safely read from the source.
        var currentRenderVersion = getWorkInProgressVersion(source);
        if (currentRenderVersion !== null) // It's safe to read if the store hasn't been mutated since the last time
        // we read something.
        isSafeToReadFromSource = currentRenderVersion === version;
        else {
            // If there's no version, then this is the first time we've read from the
            // source during the current render pass, so we need to do a bit more work.
            // What we need to determine is if there are any hooks that already
            // subscribed to the source, and if so, whether there are any pending
            // mutations that haven't been synchronized yet.
            //
            // If there are no pending mutations, then `root.mutableReadLanes` will be
            // empty, and we know we can safely read.
            //
            // If there *are* pending mutations, we may still be able to safely read
            // if the currently rendering lanes are inclusive of the pending mutation
            // lanes, since that guarantees that the value we're about to read from
            // the source is consistent with the values that we read during the most
            // recent mutation.
            isSafeToReadFromSource = isSubsetOfLanes(renderLanes, root.mutableReadLanes);
            if (isSafeToReadFromSource) // If it's safe to read from this source during the current render,
            // store the version in case other components read from it.
            // A changed version number will let those components know to throw and restart the render.
            setWorkInProgressVersion(source, version);
        }
        if (isSafeToReadFromSource) {
            var snapshot = getSnapshot(source._source);
            if (typeof snapshot === 'function') error("Mutable source should not return a function as the snapshot value. Functions may close over mutable values and cause tearing.");
            return snapshot;
        } else {
            // This handles the special case of a mutable source being shared between renderers.
            // In that case, if the source is mutated between the first and second renderer,
            // The second renderer don't know that it needs to reset the WIP version during unwind,
            // (because the hook only marks sources as dirty if it's written to their WIP version).
            // That would cause this tear check to throw again and eventually be visible to the user.
            // We can avoid this infinite loop by explicitly marking the source as dirty.
            //
            // This can lead to tearing in the first renderer when it resumes,
            // but there's nothing we can do about that (short of throwing here and refusing to continue the render).
            markSourceAsDirty(source);
            throw Error("Cannot read from mutable source during the current render without tearing. This is a bug in React. Please file an issue.");
        }
    }
    function useMutableSource(hook, source, getSnapshot, subscribe) {
        var root = getWorkInProgressRoot();
        if (!(root !== null)) throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        var getVersion = source._getVersion;
        var version = getVersion(source._source);
        var dispatcher = ReactCurrentDispatcher$1.current; // eslint-disable-next-line prefer-const
        var _dispatcher$useState = dispatcher.useState(function() {
            return readFromUnsubcribedMutableSource(root, source, getSnapshot);
        }), currentSnapshot = _dispatcher$useState[0], setSnapshot = _dispatcher$useState[1];
        var snapshot = currentSnapshot; // Grab a handle to the state hook as well.
        // We use it to clear the pending update queue if we have a new source.
        var stateHook = workInProgressHook;
        var memoizedState = hook.memoizedState;
        var refs = memoizedState.refs;
        var prevGetSnapshot = refs.getSnapshot;
        var prevSource = memoizedState.source;
        var prevSubscribe = memoizedState.subscribe;
        var fiber = currentlyRenderingFiber$1;
        hook.memoizedState = {
            refs: refs,
            source: source,
            subscribe: subscribe
        }; // Sync the values needed by our subscription handler after each commit.
        dispatcher.useEffect(function() {
            refs.getSnapshot = getSnapshot; // Normally the dispatch function for a state hook never changes,
            // but this hook recreates the queue in certain cases  to avoid updates from stale sources.
            // handleChange() below needs to reference the dispatch function without re-subscribing,
            // so we use a ref to ensure that it always has the latest version.
            refs.setSnapshot = setSnapshot; // Check for a possible change between when we last rendered now.
            var maybeNewVersion = getVersion(source._source);
            if (!objectIs(version, maybeNewVersion)) {
                var maybeNewSnapshot = getSnapshot(source._source);
                if (typeof maybeNewSnapshot === 'function') error("Mutable source should not return a function as the snapshot value. Functions may close over mutable values and cause tearing.");
                if (!objectIs(snapshot, maybeNewSnapshot)) {
                    setSnapshot(maybeNewSnapshot);
                    var lane = requestUpdateLane(fiber);
                    markRootMutableRead(root, lane);
                } // If the source mutated between render and now,
                // there may be state updates already scheduled from the old source.
                // Entangle the updates so that they render in the same batch.
                markRootEntangled(root, root.mutableReadLanes);
            }
        }, [
            getSnapshot,
            source,
            subscribe
        ]); // If we got a new source or subscribe function, re-subscribe in a passive effect.
        dispatcher.useEffect(function() {
            var handleChange = function() {
                var latestGetSnapshot = refs.getSnapshot;
                var latestSetSnapshot = refs.setSnapshot;
                try {
                    latestSetSnapshot(latestGetSnapshot(source._source)); // Record a pending mutable source update with the same expiration time.
                    var lane = requestUpdateLane(fiber);
                    markRootMutableRead(root, lane);
                } catch (error) {
                    // A selector might throw after a source mutation.
                    // e.g. it might try to read from a part of the store that no longer exists.
                    // In this case we should still schedule an update with React.
                    // Worst case the selector will throw again and then an error boundary will handle it.
                    latestSetSnapshot(function() {
                        throw error;
                    });
                }
            };
            var unsubscribe = subscribe(source._source, handleChange);
            if (typeof unsubscribe !== 'function') error('Mutable source subscribe function must return an unsubscribe function.');
            return unsubscribe;
        }, [
            source,
            subscribe
        ]); // If any of the inputs to useMutableSource change, reading is potentially unsafe.
        //
        // If either the source or the subscription have changed we can't can't trust the update queue.
        // Maybe the source changed in a way that the old subscription ignored but the new one depends on.
        //
        // If the getSnapshot function changed, we also shouldn't rely on the update queue.
        // It's possible that the underlying source was mutated between the when the last "change" event fired,
        // and when the current render (with the new getSnapshot function) is processed.
        //
        // In both cases, we need to throw away pending updates (since they are no longer relevant)
        // and treat reading from the source as we do in the mount case.
        if (!objectIs(prevGetSnapshot, getSnapshot) || !objectIs(prevSource, source) || !objectIs(prevSubscribe, subscribe)) {
            // Create a new queue and setState method,
            // So if there are interleaved updates, they get pushed to the older queue.
            // When this becomes current, the previous queue and dispatch method will be discarded,
            // including any interleaving updates that occur.
            var newQueue = {
                pending: null,
                dispatch: null,
                lastRenderedReducer: basicStateReducer,
                lastRenderedState: snapshot
            };
            newQueue.dispatch = setSnapshot = dispatchAction.bind(null, currentlyRenderingFiber$1, newQueue);
            stateHook.queue = newQueue;
            stateHook.baseQueue = null;
            snapshot = readFromUnsubcribedMutableSource(root, source, getSnapshot);
            stateHook.memoizedState = stateHook.baseState = snapshot;
        }
        return snapshot;
    }
    function mountMutableSource(source, getSnapshot, subscribe) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = {
            refs: {
                getSnapshot: getSnapshot,
                setSnapshot: null
            },
            source: source,
            subscribe: subscribe
        };
        return useMutableSource(hook, source, getSnapshot, subscribe);
    }
    function updateMutableSource(source, getSnapshot, subscribe) {
        var hook = updateWorkInProgressHook();
        return useMutableSource(hook, source, getSnapshot, subscribe);
    }
    function mountState(initialState) {
        var hook = mountWorkInProgressHook();
        if (typeof initialState === 'function') // $FlowFixMe: Flow doesn't like mixed types
        initialState = initialState();
        hook.memoizedState = hook.baseState = initialState;
        var queue = hook.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateState(initialState) {
        return updateReducer(basicStateReducer);
    }
    function rerenderState(initialState) {
        return rerenderReducer(basicStateReducer);
    }
    function pushEffect(tag, create, destroy, deps) {
        var effect = {
            tag: tag,
            create: create,
            destroy: destroy,
            deps: deps,
            // Circular
            next: null
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
            var lastEffect = componentUpdateQueue.lastEffect;
            if (lastEffect === null) componentUpdateQueue.lastEffect = effect.next = effect;
            else {
                var firstEffect = lastEffect.next;
                lastEffect.next = effect;
                effect.next = firstEffect;
                componentUpdateQueue.lastEffect = effect;
            }
        }
        return effect;
    }
    function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        var ref = {
            current: initialValue
        };
        Object.seal(ref);
        hook.memoizedState = ref;
        return ref;
    }
    function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, undefined, nextDeps);
    }
    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var destroy = undefined;
        if (currentHook !== null) {
            var prevEffect = currentHook.memoizedState;
            destroy = prevEffect.destroy;
            if (nextDeps !== null) {
                var prevDeps = prevEffect.deps;
                if (areHookInputsEqual(nextDeps, prevDeps)) {
                    pushEffect(hookFlags, create, destroy, nextDeps);
                    return;
                }
            }
        }
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, destroy, nextDeps);
    }
    function mountEffect(create, deps) {
        // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
        if ('undefined' !== typeof jest) warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
        return mountEffectImpl(Update | Passive, Passive$1, create, deps);
    }
    function updateEffect(create, deps) {
        // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
        if ('undefined' !== typeof jest) warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
        return updateEffectImpl(Update | Passive, Passive$1, create, deps);
    }
    function mountLayoutEffect(create, deps) {
        return mountEffectImpl(Update, Layout, create, deps);
    }
    function updateLayoutEffect(create, deps) {
        return updateEffectImpl(Update, Layout, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if (typeof ref === 'function') {
            var refCallback = ref;
            var _inst = create();
            refCallback(_inst);
            return function() {
                refCallback(null);
            };
        } else if (ref !== null && ref !== undefined) {
            var refObject = ref;
            if (!refObject.hasOwnProperty('current')) error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", 'an object with keys {' + Object.keys(refObject).join(', ') + '}');
            var _inst2 = create();
            refObject.current = _inst2;
            return function() {
                refObject.current = null;
            };
        }
    }
    function mountImperativeHandle(ref, create, deps) {
        if (typeof create !== 'function') error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : 'null');
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return mountEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function updateImperativeHandle(ref, create, deps) {
        if (typeof create !== 'function') error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : 'null');
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function mountDebugValue(value, formatterFn) {
    // The react-debug-hooks package injects its own implementation
    // so that e.g. DevTools can display custom hook values.
    }
    var updateDebugValue = mountDebugValue;
    function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) // Assume these are defined. If they're not, areHookInputsEqual will warn.
        {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function mountDeferredValue(value) {
        var _mountState = mountState(value), prevValue = _mountState[0], setValue = _mountState[1];
        mountEffect(function() {
            var prevTransition = ReactCurrentBatchConfig$1.transition;
            ReactCurrentBatchConfig$1.transition = 1;
            try {
                setValue(value);
            } finally{
                ReactCurrentBatchConfig$1.transition = prevTransition;
            }
        }, [
            value
        ]);
        return prevValue;
    }
    function updateDeferredValue(value) {
        var _updateState = updateState(), prevValue = _updateState[0], setValue = _updateState[1];
        updateEffect(function() {
            var prevTransition = ReactCurrentBatchConfig$1.transition;
            ReactCurrentBatchConfig$1.transition = 1;
            try {
                setValue(value);
            } finally{
                ReactCurrentBatchConfig$1.transition = prevTransition;
            }
        }, [
            value
        ]);
        return prevValue;
    }
    function rerenderDeferredValue(value) {
        var _rerenderState = rerenderState(), prevValue = _rerenderState[0], setValue = _rerenderState[1];
        updateEffect(function() {
            var prevTransition = ReactCurrentBatchConfig$1.transition;
            ReactCurrentBatchConfig$1.transition = 1;
            try {
                setValue(value);
            } finally{
                ReactCurrentBatchConfig$1.transition = prevTransition;
            }
        }, [
            value
        ]);
        return prevValue;
    }
    function startTransition(setPending, callback) {
        var priorityLevel = getCurrentPriorityLevel();
        runWithPriority$1(priorityLevel < UserBlockingPriority$2 ? UserBlockingPriority$2 : priorityLevel, function() {
            setPending(true);
        });
        runWithPriority$1(priorityLevel > NormalPriority$1 ? NormalPriority$1 : priorityLevel, function() {
            var prevTransition = ReactCurrentBatchConfig$1.transition;
            ReactCurrentBatchConfig$1.transition = 1;
            try {
                setPending(false);
                callback();
            } finally{
                ReactCurrentBatchConfig$1.transition = prevTransition;
            }
        });
    }
    function mountTransition() {
        var _mountState2 = mountState(false), isPending = _mountState2[0], setPending = _mountState2[1]; // The `start` method can be stored on a ref, since `setPending`
        // never changes.
        var start = startTransition.bind(null, setPending);
        mountRef(start);
        return [
            start,
            isPending
        ];
    }
    function updateTransition() {
        var _updateState2 = updateState(), isPending = _updateState2[0];
        var startRef = updateRef();
        var start = startRef.current;
        return [
            start,
            isPending
        ];
    }
    function rerenderTransition() {
        var _rerenderState2 = rerenderState(), isPending = _rerenderState2[0];
        var startRef = updateRef();
        var start = startRef.current;
        return [
            start,
            isPending
        ];
    }
    var isUpdatingOpaqueValueInRenderPhase = false;
    function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
        return isUpdatingOpaqueValueInRenderPhase;
    }
    function warnOnOpaqueIdentifierAccessInDEV(fiber) {
        // TODO: Should warn in effects and callbacks, too
        var name = getComponentName(fiber.type) || 'Unknown';
        if (getIsRendering() && !didWarnAboutUseOpaqueIdentifier[name]) {
            error("The object passed back from useOpaqueIdentifier is meant to be passed through to attributes only. Do not read the value directly.");
            didWarnAboutUseOpaqueIdentifier[name] = true;
        }
    }
    function mountOpaqueIdentifier() {
        var makeId = makeClientIdInDEV.bind(null, warnOnOpaqueIdentifierAccessInDEV.bind(null, currentlyRenderingFiber$1));
        if (getIsHydrating()) {
            var didUpgrade = false;
            var fiber = currentlyRenderingFiber$1;
            var readValue = function() {
                if (!didUpgrade) {
                    // Only upgrade once. This works even inside the render phase because
                    // the update is added to a shared queue, which outlasts the
                    // in-progress render.
                    didUpgrade = true;
                    isUpdatingOpaqueValueInRenderPhase = true;
                    setId(makeId());
                    isUpdatingOpaqueValueInRenderPhase = false;
                    warnOnOpaqueIdentifierAccessInDEV(fiber);
                }
                throw Error("The object passed back from useOpaqueIdentifier is meant to be passed through to attributes only. Do not read the value directly.");
            };
            var id = makeOpaqueHydratingObject(readValue);
            var setId = mountState(id)[1];
            if ((currentlyRenderingFiber$1.mode & BlockingMode) === NoMode) {
                currentlyRenderingFiber$1.flags |= Update | Passive;
                pushEffect(HasEffect | Passive$1, function() {
                    setId(makeId());
                }, undefined, null);
            }
            return id;
        } else {
            var _id = makeId();
            mountState(_id);
            return _id;
        }
    }
    function updateOpaqueIdentifier() {
        var id = updateState()[0];
        return id;
    }
    function rerenderOpaqueIdentifier() {
        var id = rerenderState()[0];
        return id;
    }
    function dispatchAction(fiber, queue, action) {
        if (typeof arguments[3] === 'function') error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            eagerReducer: null,
            eagerState: null,
            next: null
        }; // Append the update to the end of the list.
        var pending = queue.pending;
        if (pending === null) // This is the first update. Create a circular list.
        update.next = update;
        else {
            update.next = pending.next;
            pending.next = update;
        }
        queue.pending = update;
        var alternate = fiber.alternate;
        if (fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1) // This is a render phase update. Stash it in a lazily-created map of
        // queue -> linked list of updates. After this render pass, we'll restart
        // and apply the stashed updates on top of the work-in-progress hook.
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
        else {
            if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
                // The queue is currently empty, which means we can eagerly compute the
                // next state before entering the render phase. If the new state is the
                // same as the current state, we may be able to bail out entirely.
                var lastRenderedReducer = queue.lastRenderedReducer;
                if (lastRenderedReducer !== null) {
                    var prevDispatcher;
                    prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        var currentState = queue.lastRenderedState;
                        var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
                        // it, on the update object. If the reducer hasn't changed by the
                        // time we enter the render phase, then the eager state can be used
                        // without calling the reducer again.
                        update.eagerReducer = lastRenderedReducer;
                        update.eagerState = eagerState;
                        if (objectIs(eagerState, currentState)) // Fast path. We can bail out without scheduling React to re-render.
                        // It's still possible that we'll need to rebase this update later,
                        // if the component re-renders for a different reason and by that
                        // time the reducer has changed.
                        return;
                    } catch (error) {} finally{
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                }
            }
            // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
            if ('undefined' !== typeof jest) {
                warnIfNotScopedWithMatchingAct(fiber);
                warnIfNotCurrentlyActingUpdatesInDev(fiber);
            }
            scheduleUpdateOnFiber(fiber, lane, eventTime);
        }
    }
    var ContextOnlyDispatcher = {
        readContext: readContext,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useMutableSource: throwInvalidHookError,
        useOpaqueIdentifier: throwInvalidHookError,
        unstable_isNewReconciler: enableNewReconciler
    };
    var HooksDispatcherOnMountInDEV = null;
    var HooksDispatcherOnMountWithHookTypesInDEV = null;
    var HooksDispatcherOnUpdateInDEV = null;
    var HooksDispatcherOnRerenderInDEV = null;
    var InvalidNestedHooksDispatcherOnMountInDEV = null;
    var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
    var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    var warnInvalidContextAccess = function() {
        error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    };
    var warnInvalidHookAccess = function() {
        error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
    };
    HooksDispatcherOnMountInDEV = {
        readContext: function(context, observedBits) {
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = 'useContext';
            mountHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            mountHookTypesDev();
            return mountMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = 'useOpaqueIdentifier';
            mountHookTypesDev();
            return mountOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
        readContext: function(context, observedBits) {
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            updateHookTypesDev();
            return mountMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = 'useOpaqueIdentifier';
            updateHookTypesDev();
            return mountOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnUpdateInDEV = {
        readContext: function(context, observedBits) {
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            updateHookTypesDev();
            return updateMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = 'useOpaqueIdentifier';
            updateHookTypesDev();
            return updateOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnRerenderInDEV = {
        readContext: function(context, observedBits) {
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            updateHookTypesDev();
            return updateMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = 'useOpaqueIdentifier';
            updateHookTypesDev();
            return rerenderOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
        readContext: function(context, observedBits) {
            warnInvalidContextAccess();
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = 'useOpaqueIdentifier';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
        readContext: function(context, observedBits) {
            warnInvalidContextAccess();
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = 'useOpaqueIdentifier';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
        readContext: function(context, observedBits) {
            warnInvalidContextAccess();
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = 'useOpaqueIdentifier';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    var now$1 = Scheduler.unstable_now;
    var commitTime = 0;
    var profilerStartTime = -1;
    function getCommitTime() {
        return commitTime;
    }
    function recordCommitTime() {
        commitTime = now$1();
    }
    function startProfilerTimer(fiber) {
        profilerStartTime = now$1();
        if (fiber.actualStartTime < 0) fiber.actualStartTime = now$1();
    }
    function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
    }
    function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
            var elapsedTime = now$1() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            if (overrideBaseTime) fiber.selfBaseDuration = elapsedTime;
            profilerStartTime = -1;
        }
    }
    function transferActualDuration(fiber) {
        // Transfer time spent rendering these children so we don't lose it
        // after we rerender. This is used as a helper in special cases
        // where we should count the work of multiple passes.
        var child = fiber.child;
        while(child){
            fiber.actualDuration += child.actualDuration;
            child = child.sibling;
        }
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var didReceiveUpdate = false;
    var didWarnAboutBadClass;
    var didWarnAboutModulePatternComponent;
    var didWarnAboutContextTypeOnFunctionComponent;
    var didWarnAboutGetDerivedStateOnFunctionComponent;
    var didWarnAboutFunctionRefs;
    var didWarnAboutReassigningProps;
    var didWarnAboutRevealOrder;
    var didWarnAboutTailOptions;
    didWarnAboutBadClass = {};
    didWarnAboutModulePatternComponent = {};
    didWarnAboutContextTypeOnFunctionComponent = {};
    didWarnAboutGetDerivedStateOnFunctionComponent = {};
    didWarnAboutFunctionRefs = {};
    didWarnAboutReassigningProps = false;
    didWarnAboutRevealOrder = {};
    didWarnAboutTailOptions = {};
    function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        if (current === null) // If this is a fresh new component that hasn't been rendered yet, we
        // won't update its child set by applying minimal side-effects. Instead,
        // we will add them all to the child before it gets rendered. That means
        // we can optimize this reconciliation pass by not tracking side-effects.
        workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
        else // If the current child is the same as the work in progress, it means that
        // we haven't yet started any work on these children. Therefore, we use
        // the clone algorithm to create a copy of all the current children.
        // If we had any progressed work already, that is invalid at this point so
        // let's throw it out.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
    }
    function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes) {
        // This function is fork of reconcileChildren. It's used in cases where we
        // want to reconcile without matching against the existing set. This has the
        // effect of all current children being unmounted; even if the type and key
        // are the same, the old child is unmounted and a new child is created.
        //
        // To do this, we're going to go through the reconcile algorithm twice. In
        // the first pass, we schedule a deletion for all the current children by
        // passing null.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes); // In the second pass, we mount the new children. The trick here is that we
        // pass null in place of where we usually pass the current child set. This has
        // the effect of remounting all children regardless of whether their
        // identities match.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentName(Component));
        }
        var render = Component.render;
        var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent
        var nextChildren;
        prepareToReadContext(workInProgress, renderLanes);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
        if (workInProgress.mode & StrictMode) {
            disableLogs();
            try {
                nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
            } finally{
                reenableLogs();
            }
        }
        setIsRendering(false);
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, updateLanes, renderLanes) {
        if (current === null) {
            var type = Component.type;
            if (isSimpleFunctionComponent(type) && Component.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
            Component.defaultProps === undefined) {
                var resolvedType = type;
                resolvedType = resolveFunctionForHotReloading(type);
                // and with only the default shallow comparison, we upgrade it
                // to a SimpleMemoComponent to allow fast path updates.
                workInProgress.tag = SimpleMemoComponent;
                workInProgress.type = resolvedType;
                validateFunctionComponentInDev(workInProgress, type);
                return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, updateLanes, renderLanes);
            }
            var innerPropTypes = type.propTypes;
            if (innerPropTypes) // Inner memo component props aren't currently validated in createElement.
            // We could move it there, but we'd still need this for lazy code path.
            checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentName(type));
            var child = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
            child.ref = workInProgress.ref;
            child.return = workInProgress;
            workInProgress.child = child;
            return child;
        }
        var _type = Component.type;
        var _innerPropTypes = _type.propTypes;
        if (_innerPropTypes) // Inner memo component props aren't currently validated in createElement.
        // We could move it there, but we'd still need this for lazy code path.
        checkPropTypes(_innerPropTypes, nextProps, 'prop', getComponentName(_type));
        var currentChild = current.child; // This is always exactly one child
        if (!includesSomeLane(updateLanes, renderLanes)) {
            // This will be the props with resolved defaultProps,
            // unlike current.memoizedProps which will be the unresolved ones.
            var prevProps = currentChild.memoizedProps; // Default to shallow comparison
            var compare = Component.compare;
            compare = compare !== null ? compare : shallowEqual;
            if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps);
        newChild.ref = workInProgress.ref;
        newChild.return = workInProgress;
        workInProgress.child = newChild;
        return newChild;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, updateLanes, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var outerMemoType = workInProgress.elementType;
            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
                // We warn when you define propTypes on lazy()
                // so let's just skip over it to find memo() outer wrapper.
                // Inner props for memo are validated later.
                var lazyComponent = outerMemoType;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    outerMemoType = init(payload);
                } catch (x) {
                    outerMemoType = null;
                } // Inner propTypes will be validated in the function component path.
                var outerPropTypes = outerMemoType && outerMemoType.propTypes;
                if (outerPropTypes) checkPropTypes(outerPropTypes, nextProps, 'prop', getComponentName(outerMemoType));
            }
        }
        if (current !== null) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
                didReceiveUpdate = false;
                if (!includesSomeLane(renderLanes, updateLanes)) {
                    // The pending lanes were cleared at the beginning of beginWork. We're
                    // about to bail out, but there might be other lanes that weren't
                    // included in the current render. Usually, the priority level of the
                    // remaining updates is accumlated during the evaluation of the
                    // component (i.e. when processing the update queue). But since since
                    // we're bailing out early *without* evaluating the component, we need
                    // to account for it here, too. Reset to the value of the current fiber.
                    // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
                    // because a MemoComponent fiber does not have hooks or an update queue;
                    // rather, it wraps around an inner component, which may or may not
                    // contains hooks.
                    // TODO: Move the reset at in beginWork out of the common path so that
                    // this is no longer necessary.
                    workInProgress.lanes = current.lanes;
                    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
    }
    function updateOffscreenComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        var prevState = current !== null ? current.memoizedState : null;
        if (nextProps.mode === 'hidden' || nextProps.mode === 'unstable-defer-without-hiding') {
            if ((workInProgress.mode & ConcurrentMode) === NoMode) {
                // In legacy sync mode, don't defer the subtree. Render it now.
                // TODO: Figure out what we should do in Blocking mode.
                var nextState = {
                    baseLanes: NoLanes
                };
                workInProgress.memoizedState = nextState;
                pushRenderLanes(workInProgress, renderLanes);
            } else if (!includesSomeLane(renderLanes, OffscreenLane)) {
                var nextBaseLanes;
                if (prevState !== null) {
                    var prevBaseLanes = prevState.baseLanes;
                    nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes);
                } else nextBaseLanes = renderLanes;
                 // Schedule this fiber to re-render at offscreen priority. Then bailout.
                markSpawnedWork(OffscreenLane);
                workInProgress.lanes = workInProgress.childLanes = laneToLanes(OffscreenLane);
                var _nextState = {
                    baseLanes: nextBaseLanes
                };
                workInProgress.memoizedState = _nextState; // We're about to bail out, but we need to push this to the stack anyway
                // to avoid a push/pop misalignment.
                pushRenderLanes(workInProgress, nextBaseLanes);
                return null;
            } else {
                // Rendering at offscreen, so we can clear the base lanes.
                var _nextState2 = {
                    baseLanes: NoLanes
                };
                workInProgress.memoizedState = _nextState2; // Push the lanes that were skipped when we bailed out.
                var subtreeRenderLanes = prevState !== null ? prevState.baseLanes : renderLanes;
                pushRenderLanes(workInProgress, subtreeRenderLanes);
            }
        } else {
            var _subtreeRenderLanes;
            if (prevState !== null) {
                _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes); // Since we're not hidden anymore, reset the state
                workInProgress.memoizedState = null;
            } else // We weren't previously hidden, and we still aren't, so there's nothing
            // special to do. Need to push to the stack regardless, though, to avoid
            // a push/pop misalignment.
            _subtreeRenderLanes = renderLanes;
            pushRenderLanes(workInProgress, _subtreeRenderLanes);
        }
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    } // Note: These happen to have identical begin phases, for now. We shouldn't hold
    // ourselves to this constraint, though. If the behavior diverges, we should
    // fork the function.
    var updateLegacyHiddenComponent = updateOffscreenComponent;
    function updateFragment(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMode(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateProfiler(current, workInProgress, renderLanes) {
        workInProgress.flags |= Update; // Reset effect durations for the next eventual effect phase.
        // These are reset during render to allow the DevTools commit hook a chance to read them,
        var stateNode = workInProgress.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (current === null && ref !== null || current !== null && current.ref !== ref) // Schedule a Ref effect
        workInProgress.flags |= Ref;
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentName(Component));
        }
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
        context = getMaskedContext(workInProgress, unmaskedContext);
        var nextChildren;
        prepareToReadContext(workInProgress, renderLanes);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
        if (workInProgress.mode & StrictMode) {
            disableLogs();
            try {
                nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
            } finally{
                reenableLogs();
            }
        }
        setIsRendering(false);
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentName(Component));
        }
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        var instance = workInProgress.stateNode;
        var shouldUpdate;
        if (instance === null) {
            if (current !== null) {
                // A class component without an instance only mounts if it suspended
                // inside a non-concurrent tree, in an inconsistent state. We want to
                // treat it like a new mount, even though an empty version of it already
                // committed. Disconnect the alternate pointers.
                current.alternate = null;
                workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
                workInProgress.flags |= Placement;
            } // In the initial pass we might need to construct the instance.
            constructClassInstance(workInProgress, Component, nextProps);
            mountClassInstance(workInProgress, Component, nextProps, renderLanes);
            shouldUpdate = true;
        } else if (current === null) // In a resume, we'll already have an instance we can reuse.
        shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderLanes);
        else shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderLanes);
        var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes);
        var inst = workInProgress.stateNode;
        if (shouldUpdate && inst.props !== nextProps) {
            if (!didWarnAboutReassigningProps) error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentName(workInProgress.type) || 'a component');
            didWarnAboutReassigningProps = true;
        }
        return nextUnitOfWork;
    }
    function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes) {
        // Refs should update even if shouldComponentUpdate returns false
        markRef(current, workInProgress);
        var didCaptureError = (workInProgress.flags & DidCapture) !== NoFlags;
        if (!shouldUpdate && !didCaptureError) {
            // Context providers should defer to sCU for rendering
            if (hasContext) invalidateContextProvider(workInProgress, Component, false);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        var instance = workInProgress.stateNode; // Rerender
        ReactCurrentOwner$1.current = workInProgress;
        var nextChildren;
        if (didCaptureError && typeof Component.getDerivedStateFromError !== 'function') {
            // If we captured an error, but getDerivedStateFromError is not defined,
            // unmount all the children. componentDidCatch will schedule an update to
            // re-render a fallback. This is temporary until we migrate everyone to
            // the new API.
            // TODO: Warn in a future release.
            nextChildren = null;
            stopProfilerTimerIfRunning();
        } else {
            setIsRendering(true);
            nextChildren = instance.render();
            if (workInProgress.mode & StrictMode) {
                disableLogs();
                try {
                    instance.render();
                } finally{
                    reenableLogs();
                }
            }
            setIsRendering(false);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        if (current !== null && didCaptureError) // If we're recovering from an error, reconcile without reusing any of
        // the existing children. Conceptually, the normal children and the children
        // that are shown on error are two different sets, so we shouldn't reuse
        // normal children even if their identities match.
        forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
         // Memoize state using the values we just used to render.
        // TODO: Restructure so we never read values from the instance.
        workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.
        if (hasContext) invalidateContextProvider(workInProgress, Component, true);
        return workInProgress.child;
    }
    function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;
        if (root.pendingContext) pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        else if (root.context) // Should always be set
        pushTopLevelContextObject(workInProgress, root.context, false);
        pushHostContainer(workInProgress, root.containerInfo);
    }
    function updateHostRoot(current, workInProgress, renderLanes) {
        pushHostRootContext(workInProgress);
        var updateQueue = workInProgress.updateQueue;
        if (!(current !== null && updateQueue !== null)) throw Error("If the root does not have an updateQueue, we should have already bailed out. This error is likely caused by a bug in React. Please file an issue.");
        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState !== null ? prevState.element : null;
        cloneUpdateQueue(current, workInProgress);
        processUpdateQueue(workInProgress, nextProps, null, renderLanes);
        var nextState = workInProgress.memoizedState; // Caution: React DevTools currently depends on this property
        // being called "element".
        var nextChildren = nextState.element;
        if (nextChildren === prevChildren) {
            resetHydrationState();
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        var root = workInProgress.stateNode;
        if (root.hydrate && enterHydrationState(workInProgress)) {
            var mutableSourceEagerHydrationData = root.mutableSourceEagerHydrationData;
            if (mutableSourceEagerHydrationData != null) for(var i = 0; i < mutableSourceEagerHydrationData.length; i += 2){
                var mutableSource = mutableSourceEagerHydrationData[i];
                var version = mutableSourceEagerHydrationData[i + 1];
                setWorkInProgressVersion(mutableSource, version);
            }
            var child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
            workInProgress.child = child;
            var node = child;
            while(node){
                // Mark each child as hydrating. This is a fast path to know whether this
                // tree is part of a hydrating tree. This is used to determine if a child
                // node has fully mounted yet, and for scheduling event replaying.
                // Conceptually this is similar to Placement in that a new subtree is
                // inserted into the React tree here. It just happens to not need DOM
                // mutations because it already exists.
                node.flags = node.flags & ~Placement | Hydrating;
                node = node.sibling;
            }
        } else {
            // Otherwise reset hydration state in case we aborted and resumed another
            // root.
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
            resetHydrationState();
        }
        return workInProgress.child;
    }
    function updateHostComponent(current, workInProgress, renderLanes) {
        pushHostContext(workInProgress);
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current !== null ? current.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);
        if (isDirectTextChild) // We special case a direct text child of a host node. This is a common
        // case. We won't handle it as a reified child. We will instead handle
        // this in the host environment that also has access to this prop. That
        // avoids allocating another HostText fiber and traversing it.
        nextChildren = null;
        else if (prevProps !== null && shouldSetTextContent(type, prevProps)) // If we're switching from a direct text child to a normal child, or to
        // empty, we need to schedule the text content to be reset.
        workInProgress.flags |= ContentReset;
        markRef(current, workInProgress);
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostText(current, workInProgress) {
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
         // Nothing to do here. This is terminal. We'll do the completion step
        // immediately after.
        return null;
    }
    function mountLazyComponent(_current, workInProgress, elementType, updateLanes, renderLanes) {
        if (_current !== null) {
            // A lazy component only mounts if it suspended inside a non-
            // concurrent tree, in an inconsistent state. We want to treat it like
            // a new mount, even though an empty version of it already committed.
            // Disconnect the alternate pointers.
            _current.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
            workInProgress.flags |= Placement;
        }
        var props = workInProgress.pendingProps;
        var lazyComponent = elementType;
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;
        var Component = init(payload); // Store the unwrapped component in the type.
        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child;
        switch(resolvedTag){
            case FunctionComponent:
                validateFunctionComponentInDev(workInProgress, Component);
                workInProgress.type = Component = resolveFunctionForHotReloading(Component);
                child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ClassComponent:
                workInProgress.type = Component = resolveClassForHotReloading(Component);
                child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ForwardRef:
                workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
                child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case MemoComponent:
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = Component.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, resolvedProps, 'prop', getComponentName(Component));
                }
                child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), updateLanes, renderLanes);
                return child;
        }
        var hint = '';
        if (Component !== null && typeof Component === 'object' && Component.$$typeof === REACT_LAZY_TYPE) hint = ' Did you wrap a component in React.lazy() more than once?';
        throw Error("Element type is invalid. Received a promise that resolves to: " + Component + ". Lazy element type must resolve to a class or function." + hint);
    }
    function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderLanes) {
        if (_current !== null) {
            // An incomplete component only mounts if it suspended inside a non-
            // concurrent tree, in an inconsistent state. We want to treat it like
            // a new mount, even though an empty version of it already committed.
            // Disconnect the alternate pointers.
            _current.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
            workInProgress.flags |= Placement;
        } // Promote the fiber to a class and try rendering again.
        workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
        // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        constructClassInstance(workInProgress, Component, nextProps);
        mountClassInstance(workInProgress, Component, nextProps, renderLanes);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
    }
    function mountIndeterminateComponent(_current, workInProgress, Component, renderLanes) {
        if (_current !== null) {
            // An indeterminate component only mounts if it suspended inside a non-
            // concurrent tree, in an inconsistent state. We want to treat it like
            // a new mount, even though an empty version of it already committed.
            // Disconnect the alternate pointers.
            _current.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
            workInProgress.flags |= Placement;
        }
        var props = workInProgress.pendingProps;
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
        context = getMaskedContext(workInProgress, unmaskedContext);
        prepareToReadContext(workInProgress, renderLanes);
        var value;
        if (Component.prototype && typeof Component.prototype.render === 'function') {
            var componentName = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutBadClass[componentName]) {
                error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
            }
        }
        if (workInProgress.mode & StrictMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
        setIsRendering(true);
        ReactCurrentOwner$1.current = workInProgress;
        value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
        setIsRendering(false);
        workInProgress.flags |= PerformedWork;
        // Support for module components is deprecated and is removed behind a flag.
        // Whether or not it would crash later, we want to show a good message in DEV first.
        if (typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
            var _componentName = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutModulePatternComponent[_componentName]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
            }
        }
        if (// Eventually we'll delete this branch altogether.
        typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
            var _componentName2 = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutModulePatternComponent[_componentName2]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
                didWarnAboutModulePatternComponent[_componentName2] = true;
            }
            workInProgress.tag = ClassComponent; // Throw out any hooks that were used.
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
            // During mounting we don't know the child context yet as the instance doesn't exist.
            // We will invalidate the child context in finishClassComponent() right after rendering.
            var hasContext = false;
            if (isContextProvider(Component)) {
                hasContext = true;
                pushContextProvider(workInProgress);
            } else hasContext = false;
            workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
            initializeUpdateQueue(workInProgress);
            var getDerivedStateFromProps = Component.getDerivedStateFromProps;
            if (typeof getDerivedStateFromProps === 'function') applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, props);
            adoptClassInstance(workInProgress, value);
            mountClassInstance(workInProgress, Component, props, renderLanes);
            return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
        } else {
            // Proceed under the assumption that this is a function component
            workInProgress.tag = FunctionComponent;
            if (workInProgress.mode & StrictMode) {
                disableLogs();
                try {
                    value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
                } finally{
                    reenableLogs();
                }
            }
            reconcileChildren(null, workInProgress, value, renderLanes);
            validateFunctionComponentInDev(workInProgress, Component);
            return workInProgress.child;
        }
    }
    function validateFunctionComponentInDev(workInProgress, Component) {
        if (Component) {
            if (Component.childContextTypes) error('%s(...): childContextTypes cannot be defined on a function component.', Component.displayName || Component.name || 'Component');
        }
        if (workInProgress.ref !== null) {
            var info = '';
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();
            if (ownerName) info += '\n\nCheck the render method of `' + ownerName + '`.';
            var warningKey = ownerName || workInProgress._debugID || '';
            var debugSource = workInProgress._debugSource;
            if (debugSource) warningKey = debugSource.fileName + ':' + debugSource.lineNumber;
            if (!didWarnAboutFunctionRefs[warningKey]) {
                didWarnAboutFunctionRefs[warningKey] = true;
                error("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", info);
            }
        }
        if (typeof Component.getDerivedStateFromProps === 'function') {
            var _componentName3 = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
                error('%s: Function components do not support getDerivedStateFromProps.', _componentName3);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
            }
        }
        if (typeof Component.contextType === 'object' && Component.contextType !== null) {
            var _componentName4 = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
                error('%s: Function components do not support contextType.', _componentName4);
                didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
            }
        }
    }
    var SUSPENDED_MARKER = {
        dehydrated: null,
        retryLane: NoLane
    };
    function mountSuspenseOffscreenState(renderLanes) {
        return {
            baseLanes: renderLanes
        };
    }
    function updateSuspenseOffscreenState(prevOffscreenState, renderLanes) {
        return {
            baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes)
        };
    } // TODO: Probably should inline this back
    function shouldRemainOnFallback(suspenseContext, current, workInProgress, renderLanes) {
        // If we're already showing a fallback, there are cases where we need to
        // remain on that fallback regardless of whether the content has resolved.
        // For example, SuspenseList coordinates when nested content appears.
        if (current !== null) {
            var suspenseState = current.memoizedState;
            if (suspenseState === null) // Currently showing content. Don't hide it, even if ForceSuspenseFallack
            // is true. More precise name might be "ForceRemainSuspenseFallback".
            // Note: This is a factoring smell. Can't remain on a fallback if there's
            // no fallback to remain on.
            return false;
        } // Not currently showing content. Consult the Suspense context.
        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
    }
    function getRemainingWorkInPrimaryTree(current, renderLanes) {
        // TODO: Should not remove render lanes that were pinged during this render
        return removeLanes(current.childLanes, renderLanes);
    }
    function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.
        if (shouldSuspend(workInProgress)) workInProgress.flags |= DidCapture;
        var suspenseContext = suspenseStackCursor.current;
        var showFallback = false;
        var didSuspend = (workInProgress.flags & DidCapture) !== NoFlags;
        if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
            // Something in this boundary's subtree already suspended. Switch to
            // rendering the fallback children.
            showFallback = true;
            workInProgress.flags &= ~DidCapture;
        } else {
            // Attempting the main content
            if (current === null || current.memoizedState !== null) // This is a new mount or this boundary is already showing a fallback state.
            // Mark this subtree context as having at least one invisible parent that could
            // handle the fallback state.
            // Boundaries without fallbacks or should be avoided are not considered since
            // they cannot handle preferred fallback states.
            {
                if (nextProps.fallback !== undefined && nextProps.unstable_avoidThisFallback !== true) suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
            }
        }
        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress, suspenseContext); // OK, the next part is confusing. We're about to reconcile the Suspense
        // boundary's children. This involves some custom reconcilation logic. Two
        // main reasons this is so complicated.
        //
        // First, Legacy Mode has different semantics for backwards compatibility. The
        // primary tree will commit in an inconsistent state, so when we do the
        // second pass to render the fallback, we do some exceedingly, uh, clever
        // hacks to make that not totally break. Like transferring effects and
        // deletions from hidden tree. In Concurrent Mode, it's much simpler,
        // because we bailout on the primary tree completely and leave it in its old
        // state, no effects. Same as what we do for Offscreen (except that
        // Offscreen doesn't have the first render pass).
        //
        // Second is hydration. During hydration, the Suspense fiber has a slightly
        // different layout, where the child points to a dehydrated fragment, which
        // contains the DOM rendered by the server.
        //
        // Third, even if you set all that aside, Suspense is like error boundaries in
        // that we first we try to render one tree, and if that fails, we render again
        // and switch to a different tree. Like a try/catch block. So we have to track
        // which branch we're currently rendering. Ideally we would model this using
        // a stack.
        if (current === null) {
            // Initial mount
            // If we're currently hydrating, try to hydrate this boundary.
            // But only if this has a fallback.
            if (nextProps.fallback !== undefined) tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
            var nextPrimaryChildren = nextProps.children;
            var nextFallbackChildren = nextProps.fallback;
            if (showFallback) {
                var fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var primaryChildFragment = workInProgress.child;
                primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackFragment;
            } else if (typeof nextProps.unstable_expectedLoadTime === 'number') {
                // This is a CPU-bound tree. Skip this tree and show a placeholder to
                // unblock the surrounding content. Then immediately retry after the
                // initial commit.
                var _fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var _primaryChildFragment = workInProgress.child;
                _primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER; // Since nothing actually suspended, there will nothing to ping this to
                // get it started back up to attempt the next item. While in terms of
                // priority this work has the same priority as this current render, it's
                // not part of the same transition once the transition has committed. If
                // it's sync, we still want to yield so that it can be painted.
                // Conceptually, this is really the same as pinging. We can use any
                // RetryLane even if it's the one currently rendering since we're leaving
                // it behind on this node.
                workInProgress.lanes = SomeRetryLane;
                markSpawnedWork(SomeRetryLane);
                return _fallbackFragment;
            } else return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren, renderLanes);
        } else {
            // This is an update.
            // If the current fiber has a SuspenseState, that means it's already showing
            // a fallback.
            var prevState = current.memoizedState;
            if (prevState !== null) {
                if (showFallback) {
                    var _nextFallbackChildren2 = nextProps.fallback;
                    var _nextPrimaryChildren2 = nextProps.children;
                    var _fallbackChildFragment = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren2, _nextFallbackChildren2, renderLanes);
                    var _primaryChildFragment3 = workInProgress.child;
                    var prevOffscreenState = current.child.memoizedState;
                    _primaryChildFragment3.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes);
                    _primaryChildFragment3.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
                    workInProgress.memoizedState = SUSPENDED_MARKER;
                    return _fallbackChildFragment;
                } else {
                    var _nextPrimaryChildren3 = nextProps.children;
                    var _primaryChildFragment4 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren3, renderLanes);
                    workInProgress.memoizedState = null;
                    return _primaryChildFragment4;
                }
            } else // The current tree is not already showing a fallback.
            if (showFallback) {
                // Timed out.
                var _nextFallbackChildren3 = nextProps.fallback;
                var _nextPrimaryChildren4 = nextProps.children;
                var _fallbackChildFragment2 = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren4, _nextFallbackChildren3, renderLanes);
                var _primaryChildFragment5 = workInProgress.child;
                var _prevOffscreenState = current.child.memoizedState;
                _primaryChildFragment5.memoizedState = _prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(_prevOffscreenState, renderLanes);
                _primaryChildFragment5.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes); // Skip the primary children, and continue working on the
                // fallback children.
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return _fallbackChildFragment2;
            } else {
                // Still haven't timed out. Continue rendering the children, like we
                // normally do.
                var _nextPrimaryChildren5 = nextProps.children;
                var _primaryChildFragment6 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren5, renderLanes);
                workInProgress.memoizedState = null;
                return _primaryChildFragment6;
            }
        }
    }
    function mountSuspensePrimaryChildren(workInProgress, primaryChildren, renderLanes) {
        var mode = workInProgress.mode;
        var primaryChildProps = {
            mode: 'visible',
            children: primaryChildren
        };
        var primaryChildFragment = createFiberFromOffscreen(primaryChildProps, mode, renderLanes, null);
        primaryChildFragment.return = workInProgress;
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackChildren(workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var progressedPrimaryFragment = workInProgress.child;
        var primaryChildProps = {
            mode: 'hidden',
            children: primaryChildren
        };
        var primaryChildFragment;
        var fallbackChildFragment;
        if ((mode & BlockingMode) === NoMode && progressedPrimaryFragment !== null) {
            // In legacy mode, we commit the primary tree as if it successfully
            // completed, even though it's in an inconsistent state.
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = 0;
                primaryChildFragment.treeBaseDuration = 0;
            }
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        } else {
            primaryChildFragment = createFiberFromOffscreen(primaryChildProps, mode, NoLanes, null);
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        }
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function createWorkInProgressOffscreenFiber(current, offscreenProps) {
        // The props argument to `createWorkInProgress` is `any` typed, so we use this
        // wrapper function to constrain it.
        return createWorkInProgress(current, offscreenProps);
    }
    function updateSuspensePrimaryChildren(current, workInProgress, primaryChildren, renderLanes) {
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildFragment = createWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
            mode: 'visible',
            children: primaryChildren
        });
        if ((workInProgress.mode & BlockingMode) === NoMode) primaryChildFragment.lanes = renderLanes;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = null;
        if (currentFallbackChildFragment !== null) {
            // Delete the fallback child fragment
            currentFallbackChildFragment.nextEffect = null;
            currentFallbackChildFragment.flags = Deletion;
            workInProgress.firstEffect = workInProgress.lastEffect = currentFallbackChildFragment;
        }
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function updateSuspenseFallbackChildren(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildProps = {
            mode: 'hidden',
            children: primaryChildren
        };
        var primaryChildFragment;
        if (// completed, even though it's in an inconsistent state.
        (mode & BlockingMode) === NoMode && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        workInProgress.child !== currentPrimaryChildFragment) {
            var progressedPrimaryFragment = workInProgress.child;
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
                primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
            } // The fallback fiber was added as a deletion effect during the first pass.
            // However, since we're going to remain on the fallback, we no longer want
            // to delete it. So we need to remove it from the list. Deletions are stored
            // on the same list as effects. We want to keep the effects from the primary
            // tree. So we copy the primary child fragment's effect list, which does not
            // include the fallback deletion effect.
            var progressedLastEffect = primaryChildFragment.lastEffect;
            if (progressedLastEffect !== null) {
                workInProgress.firstEffect = primaryChildFragment.firstEffect;
                workInProgress.lastEffect = progressedLastEffect;
                progressedLastEffect.nextEffect = null;
            } else // TODO: Reset this somewhere else? Lol legacy mode is so weird.
            workInProgress.firstEffect = workInProgress.lastEffect = null;
        } else primaryChildFragment = createWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps);
        var fallbackChildFragment;
        if (currentFallbackChildFragment !== null) fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
        else {
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null); // Needs a placement effect because the parent (the Suspense boundary) already
            // mounted but this is a new fiber.
            fallbackChildFragment.flags |= Placement;
        }
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function scheduleWorkOnFiber(fiber, renderLanes) {
        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
        scheduleWorkOnParentPath(fiber.return, renderLanes);
    }
    function propagateSuspenseContextChange(workInProgress, firstChild, renderLanes) {
        // Mark any Suspense boundaries with fallbacks as having work to do.
        // If they were previously forced into fallbacks, they may now be able
        // to unblock.
        var node = firstChild;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) scheduleWorkOnFiber(node, renderLanes);
            } else if (node.tag === SuspenseListComponent) // If the tail is hidden there might not be an Suspense boundaries
            // to schedule work on. In this case we have to schedule it on the
            // list itself.
            // We don't have to traverse to the children of the list since
            // the list will propagate the change when it rerenders.
            scheduleWorkOnFiber(node, renderLanes);
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function findLastContentRow(firstChild) {
        // This is going to find the last row among these children that is already
        // showing content on the screen, as opposed to being in fallback state or
        // new. If a row has multiple Suspense boundaries, any of them being in the
        // fallback state, counts as the whole row being in a fallback state.
        // Note that the "rows" will be workInProgress, but any nested children
        // will still be current since we haven't rendered them yet. The mounted
        // order may not be the same as the new order. We use the new order.
        var row = firstChild;
        var lastContentRow = null;
        while(row !== null){
            var currentRow = row.alternate; // New rows can't be content rows.
            if (currentRow !== null && findFirstSuspended(currentRow) === null) lastContentRow = row;
            row = row.sibling;
        }
        return lastContentRow;
    }
    function validateRevealOrder(revealOrder) {
        if (revealOrder !== undefined && revealOrder !== 'forwards' && revealOrder !== 'backwards' && revealOrder !== 'together' && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;
            if (typeof revealOrder === 'string') switch(revealOrder.toLowerCase()){
                case 'together':
                case 'forwards':
                case 'backwards':
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                case 'forward':
                case 'backward':
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                default:
                    error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
                    break;
            }
            else error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
        }
    }
    function validateTailOptions(tailMode, revealOrder) {
        if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== 'collapsed' && tailMode !== 'hidden') {
                didWarnAboutTailOptions[tailMode] = true;
                error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== 'forwards' && revealOrder !== 'backwards') {
                didWarnAboutTailOptions[tailMode] = true;
                error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode);
            }
        }
    }
    function validateSuspenseListNestedChild(childSlot, index) {
        var isArray = Array.isArray(childSlot);
        var isIterable = !isArray && typeof getIteratorFn(childSlot) === 'function';
        if (isArray || isIterable) {
            var type = isArray ? 'array' : 'iterable';
            error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", type, index, type);
            return false;
        }
        return true;
    }
    function validateSuspenseListChildren(children, revealOrder) {
        if ((revealOrder === 'forwards' || revealOrder === 'backwards') && children !== undefined && children !== null && children !== false) {
            if (Array.isArray(children)) for(var i = 0; i < children.length; i++){
                if (!validateSuspenseListNestedChild(children[i], i)) return;
            }
            else {
                var iteratorFn = getIteratorFn(children);
                if (typeof iteratorFn === 'function') {
                    var childrenIterator = iteratorFn.call(children);
                    if (childrenIterator) {
                        var step = childrenIterator.next();
                        var _i = 0;
                        for(; !step.done; step = childrenIterator.next()){
                            if (!validateSuspenseListNestedChild(step.value, _i)) return;
                            _i++;
                        }
                    }
                } else error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
            }
        }
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, lastEffectBeforeRendering) {
        var renderState = workInProgress.memoizedState;
        if (renderState === null) workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode,
            lastEffect: lastEffectBeforeRendering
        };
        else {
            // We can reuse the existing object from previous renders.
            renderState.isBackwards = isBackwards;
            renderState.rendering = null;
            renderState.renderingStartTime = 0;
            renderState.last = lastContentRow;
            renderState.tail = tail;
            renderState.tailMode = tailMode;
            renderState.lastEffect = lastEffectBeforeRendering;
        }
    } // This can end up rendering this component multiple passes.
    // The first pass splits the children fibers into two sets. A head and tail.
    // We first render the head. If anything is in fallback state, we do another
    // pass through beginWork to rerender all children (including the tail) with
    // the force suspend context. If the first render didn't have anything in
    // in fallback state. Then we render each row in the tail one-by-one.
    // That happens in the completeWork phase without going back to beginWork.
    function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        if (shouldForceFallback) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
            workInProgress.flags |= DidCapture;
        } else {
            var didSuspendBefore = current !== null && (current.flags & DidCapture) !== NoFlags;
            if (didSuspendBefore) // If we previously forced a fallback, we need to schedule work
            // on any nested boundaries to let them know to try to render
            // again. This is the same as context updating.
            propagateSuspenseContextChange(workInProgress, workInProgress.child, renderLanes);
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }
        pushSuspenseContext(workInProgress, suspenseContext);
        if ((workInProgress.mode & BlockingMode) === NoMode) // In legacy mode, SuspenseList doesn't work so we just
        // use make it a noop by treating it as the default revealOrder.
        workInProgress.memoizedState = null;
        else switch(revealOrder){
            case 'forwards':
                var lastContentRow = findLastContentRow(workInProgress.child);
                var tail;
                if (lastContentRow === null) {
                    // The whole list is part of the tail.
                    // TODO: We could fast path by just rendering the tail now.
                    tail = workInProgress.child;
                    workInProgress.child = null;
                } else {
                    // Disconnect the tail rows after the content row.
                    // We're going to render them separately later.
                    tail = lastContentRow.sibling;
                    lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(workInProgress, false, tail, lastContentRow, tailMode, workInProgress.lastEffect);
                break;
            case 'backwards':
                // We're going to find the first row that has existing content.
                // At the same time we're going to reverse the list of everything
                // we pass in the meantime. That's going to be our tail in reverse
                // order.
                var _tail = null;
                var row = workInProgress.child;
                workInProgress.child = null;
                while(row !== null){
                    var currentRow = row.alternate; // New rows can't be content rows.
                    if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                        // This is the beginning of the main content.
                        workInProgress.child = row;
                        break;
                    }
                    var nextRow = row.sibling;
                    row.sibling = _tail;
                    _tail = row;
                    row = nextRow;
                } // TODO: If workInProgress.child is null, we can continue on the tail immediately.
                initSuspenseListRenderState(workInProgress, true, _tail, null, tailMode, workInProgress.lastEffect);
                break;
            case 'together':
                initSuspenseListRenderState(workInProgress, false, null, null, undefined, workInProgress.lastEffect);
                break;
            default:
                // The default reveal order is the same as not having
                // a boundary.
                workInProgress.memoizedState = null;
        }
        return workInProgress.child;
    }
    function updatePortalComponent(current, workInProgress, renderLanes) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;
        if (current === null) // Portals are special because we don't append the children during mount
        // but at commit. Therefore we need to track insertions which the normal
        // flow doesn't do during mount. This doesn't happen at the root because
        // the root always starts with a "current" with a null child.
        // TODO: Consider unifying this with how the root works.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingNoValuePropOnContextProvider = false;
    function updateContextProvider(current, workInProgress, renderLanes) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        if (!('value' in newProps)) {
            if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
                hasWarnedAboutUsingNoValuePropOnContextProvider = true;
                error('The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?');
            }
        }
        var providerPropTypes = workInProgress.type.propTypes;
        if (providerPropTypes) checkPropTypes(providerPropTypes, newProps, 'prop', 'Context.Provider');
        pushProvider(workInProgress, newValue);
        if (oldProps !== null) {
            var oldValue = oldProps.value;
            var changedBits = calculateChangedBits(context, newValue, oldValue);
            if (changedBits === 0) {
                // No change. Bailout early if children are the same.
                if (oldProps.children === newProps.children && !hasContextChanged()) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            } else // The context value changed. Search for matching consumers and schedule
            // them to update.
            propagateContextChange(workInProgress, context, changedBits, renderLanes);
        }
        var newChildren = newProps.children;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingContextAsConsumer = false;
    function updateContextConsumer(current, workInProgress, renderLanes) {
        var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
        if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                    hasWarnedAboutUsingContextAsConsumer = true;
                    error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                }
            }
        } else context = context._context;
        var newProps = workInProgress.pendingProps;
        var render = newProps.children;
        if (typeof render !== 'function') error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
        prepareToReadContext(workInProgress, renderLanes);
        var newValue = readContext(context, newProps.unstable_observedBits);
        var newChildren;
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        newChildren = render(newValue);
        setIsRendering(false);
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        if (current !== null) // Reuse previous dependencies
        workInProgress.dependencies = current.dependencies;
        // Don't update "base" render times for bailouts.
        stopProfilerTimerIfRunning();
        markSkippedUpdateLanes(workInProgress.lanes); // Check if the children have any pending work.
        if (!includesSomeLane(renderLanes, workInProgress.childLanes)) // The children don't have any work either. We can skip them.
        // TODO: Once we add back resuming, we should check if the children are
        // a work-in-progress set. If so, we need to transfer their effects.
        return null;
        else {
            // This fiber doesn't have work, but its subtree does. Clone the child
            // fibers and continue.
            cloneChildFibers(current, workInProgress);
            return workInProgress.child;
        }
    }
    function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
        var returnFiber = oldWorkInProgress.return;
        if (returnFiber === null) throw new Error('Cannot swap the root fiber.');
         // Disconnect from the old current.
        // It will get deleted.
        current.alternate = null;
        oldWorkInProgress.alternate = null; // Connect to the new tree.
        newWorkInProgress.index = oldWorkInProgress.index;
        newWorkInProgress.sibling = oldWorkInProgress.sibling;
        newWorkInProgress.return = oldWorkInProgress.return;
        newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.
        if (oldWorkInProgress === returnFiber.child) returnFiber.child = newWorkInProgress;
        else {
            var prevSibling = returnFiber.child;
            if (prevSibling === null) throw new Error('Expected parent to have a child.');
            while(prevSibling.sibling !== oldWorkInProgress){
                prevSibling = prevSibling.sibling;
                if (prevSibling === null) throw new Error('Expected to find the previous sibling.');
            }
            prevSibling.sibling = newWorkInProgress;
        } // Delete the old fiber and place the new one.
        // Since the old fiber is disconnected, we have to schedule it manually.
        var last = returnFiber.lastEffect;
        if (last !== null) {
            last.nextEffect = current;
            returnFiber.lastEffect = current;
        } else returnFiber.firstEffect = returnFiber.lastEffect = current;
        current.nextEffect = null;
        current.flags = Deletion;
        newWorkInProgress.flags |= Placement; // Restart work from the new fiber.
        return newWorkInProgress;
    }
    function beginWork(current, workInProgress, renderLanes) {
        var updateLanes = workInProgress.lanes;
        if (workInProgress._debugNeedsRemount && current !== null) // This will restart the begin phase with a new fiber.
        return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes));
        if (current !== null) {
            var oldProps = current.memoizedProps;
            var newProps = workInProgress.pendingProps;
            if (oldProps !== newProps || hasContextChanged() || workInProgress.type !== current.type) // If props or context changed, mark the fiber as having performed work.
            // This may be unset if the props are determined to be equal later (memo).
            didReceiveUpdate = true;
            else if (!includesSomeLane(renderLanes, updateLanes)) {
                didReceiveUpdate = false; // This fiber does not have any pending work. Bailout without entering
                // the begin phase. There's still some bookkeeping we that needs to be done
                // in this optimized path, mostly pushing stuff onto the stack.
                switch(workInProgress.tag){
                    case HostRoot:
                        pushHostRootContext(workInProgress);
                        resetHydrationState();
                        break;
                    case HostComponent:
                        pushHostContext(workInProgress);
                        break;
                    case ClassComponent:
                        var Component = workInProgress.type;
                        if (isContextProvider(Component)) pushContextProvider(workInProgress);
                        break;
                    case HostPortal:
                        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                        break;
                    case ContextProvider:
                        var newValue = workInProgress.memoizedProps.value;
                        pushProvider(workInProgress, newValue);
                        break;
                    case Profiler:
                        // Profiler should only call onRender when one of its descendants actually rendered.
                        var hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                        if (hasChildWork) workInProgress.flags |= Update;
                         // Reset effect durations for the next eventual effect phase.
                        // These are reset during render to allow the DevTools commit hook a chance to read them,
                        var stateNode = workInProgress.stateNode;
                        stateNode.effectDuration = 0;
                        stateNode.passiveEffectDuration = 0;
                        break;
                    case SuspenseComponent:
                        var state = workInProgress.memoizedState;
                        if (state !== null) {
                            // whether to retry the primary children, or to skip over it and
                            // go straight to the fallback. Check the priority of the primary
                            // child fragment.
                            var primaryChildFragment = workInProgress.child;
                            var primaryChildLanes = primaryChildFragment.childLanes;
                            if (includesSomeLane(renderLanes, primaryChildLanes)) // The primary children have pending work. Use the normal path
                            // to attempt to render the primary children again.
                            return updateSuspenseComponent(current, workInProgress, renderLanes);
                            else {
                                // The primary child fragment does not have pending work marked
                                // on it
                                pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                                // priority. Bailout.
                                var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                                if (child !== null) // The fallback children have pending work. Skip over the
                                // primary children and work on the fallback.
                                return child.sibling;
                                else return null;
                            }
                        } else pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                        break;
                    case SuspenseListComponent:
                        var didSuspendBefore = (current.flags & DidCapture) !== NoFlags;
                        var _hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                        if (didSuspendBefore) {
                            if (_hasChildWork) // If something was in fallback state last time, and we have all the
                            // same children then we're still in progressive loading state.
                            // Something might get unblocked by state updates or retries in the
                            // tree which will affect the tail. So we need to use the normal
                            // path to compute the correct tail.
                            return updateSuspenseListComponent(current, workInProgress, renderLanes);
                             // If none of the children had any work, that means that none of
                            // them got retried so they'll still be blocked in the same way
                            // as before. We can fast bail out.
                            workInProgress.flags |= DidCapture;
                        } // If nothing suspended before and we're rendering the same children,
                        // then the tail doesn't matter. Anything new that suspends will work
                        // in the "together" mode, so we can continue from the state we had.
                        var renderState = workInProgress.memoizedState;
                        if (renderState !== null) {
                            // Reset to the "together" mode in case we've started a different
                            // update in the past but didn't complete it.
                            renderState.rendering = null;
                            renderState.tail = null;
                            renderState.lastEffect = null;
                        }
                        pushSuspenseContext(workInProgress, suspenseStackCursor.current);
                        if (_hasChildWork) break;
                        else // If none of the children had any work, that means that none of
                        // them got retried so they'll still be blocked in the same way
                        // as before. We can fast bail out.
                        return null;
                    case OffscreenComponent:
                    case LegacyHiddenComponent:
                        // Need to check if the tree still needs to be deferred. This is
                        // almost identical to the logic used in the normal update path,
                        // so we'll just enter that. The only difference is we'll bail out
                        // at the next level instead of this one, because the child props
                        // have not changed. Which is fine.
                        // TODO: Probably should refactor `beginWork` to split the bailout
                        // path from the normal path. I'm tempted to do a labeled break here
                        // but I won't :)
                        workInProgress.lanes = NoLanes;
                        return updateOffscreenComponent(current, workInProgress, renderLanes);
                }
                return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
            // See https://github.com/facebook/react/pull/19216.
            didReceiveUpdate = true;
            else // An update was scheduled on this fiber, but there are no new props
            // nor legacy context. Set this to false. If an update queue or context
            // consumer produces a changed value, it will set this to true. Otherwise,
            // the component will assume the children have not changed and bail out.
            didReceiveUpdate = false;
        } else didReceiveUpdate = false;
         // Before entering the begin phase, clear pending update priority.
        // TODO: This assumes that we're about to evaluate the component and process
        // the update queue. However, there's an exception: SimpleMemoComponent
        // sometimes bails out later in the begin phase. This indicates that we should
        // move this assignment out of the common path and into each branch.
        workInProgress.lanes = NoLanes;
        switch(workInProgress.tag){
            case IndeterminateComponent:
                return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderLanes);
            case LazyComponent:
                var elementType = workInProgress.elementType;
                return mountLazyComponent(current, workInProgress, elementType, updateLanes, renderLanes);
            case FunctionComponent:
                var _Component = workInProgress.type;
                var unresolvedProps = workInProgress.pendingProps;
                var resolvedProps = workInProgress.elementType === _Component ? unresolvedProps : resolveDefaultProps(_Component, unresolvedProps);
                return updateFunctionComponent(current, workInProgress, _Component, resolvedProps, renderLanes);
            case ClassComponent:
                var _Component2 = workInProgress.type;
                var _unresolvedProps = workInProgress.pendingProps;
                var _resolvedProps = workInProgress.elementType === _Component2 ? _unresolvedProps : resolveDefaultProps(_Component2, _unresolvedProps);
                return updateClassComponent(current, workInProgress, _Component2, _resolvedProps, renderLanes);
            case HostRoot:
                return updateHostRoot(current, workInProgress, renderLanes);
            case HostComponent:
                return updateHostComponent(current, workInProgress, renderLanes);
            case HostText:
                return updateHostText(current, workInProgress);
            case SuspenseComponent:
                return updateSuspenseComponent(current, workInProgress, renderLanes);
            case HostPortal:
                return updatePortalComponent(current, workInProgress, renderLanes);
            case ForwardRef:
                var type = workInProgress.type;
                var _unresolvedProps2 = workInProgress.pendingProps;
                var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
                return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderLanes);
            case Fragment:
                return updateFragment(current, workInProgress, renderLanes);
            case Mode:
                return updateMode(current, workInProgress, renderLanes);
            case Profiler:
                return updateProfiler(current, workInProgress, renderLanes);
            case ContextProvider:
                return updateContextProvider(current, workInProgress, renderLanes);
            case ContextConsumer:
                return updateContextConsumer(current, workInProgress, renderLanes);
            case MemoComponent:
                var _type2 = workInProgress.type;
                var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.
                var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = _type2.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, _resolvedProps3, 'prop', getComponentName(_type2));
                }
                _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
                return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, updateLanes, renderLanes);
            case SimpleMemoComponent:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, updateLanes, renderLanes);
            case IncompleteClassComponent:
                var _Component3 = workInProgress.type;
                var _unresolvedProps4 = workInProgress.pendingProps;
                var _resolvedProps4 = workInProgress.elementType === _Component3 ? _unresolvedProps4 : resolveDefaultProps(_Component3, _unresolvedProps4);
                return mountIncompleteClassComponent(current, workInProgress, _Component3, _resolvedProps4, renderLanes);
            case SuspenseListComponent:
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
            case FundamentalComponent:
                break;
            case ScopeComponent:
                break;
            case Block:
                break;
            case OffscreenComponent:
                return updateOffscreenComponent(current, workInProgress, renderLanes);
            case LegacyHiddenComponent:
                return updateLegacyHiddenComponent(current, workInProgress, renderLanes);
        }
        throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function markUpdate(workInProgress) {
        // Tag the fiber with an update effect. This turns a Placement into
        // a PlacementAndUpdate.
        workInProgress.flags |= Update;
    }
    function markRef$1(workInProgress) {
        workInProgress.flags |= Ref;
    }
    var appendAllChildren;
    var updateHostContainer;
    var updateHostComponent$1;
    var updateHostText$1;
    // Mutation mode
    appendAllChildren = function(parent, workInProgress, needsVisibilityToggle, isHidden) {
        // We only have the top Fiber that was created but we need recurse down its
        // children to find all the terminal nodes.
        var node = workInProgress.child;
        while(node !== null){
            if (node.tag === HostComponent || node.tag === HostText) appendInitialChild(parent, node.stateNode);
            else if (node.tag === HostPortal) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    };
    updateHostContainer = function(workInProgress) {};
    updateHostComponent$1 = function(current, workInProgress, type, newProps, rootContainerInstance) {
        // If we have an alternate, that means this is an update and we need to
        // schedule a side-effect to do the updates.
        var oldProps = current.memoizedProps;
        if (oldProps === newProps) // In mutation mode, this is sufficient for a bailout because
        // we won't touch this node even if children changed.
        return;
         // If we get updated because one of our children updated, we don't
        // have newProps so we'll have to reuse them.
        // TODO: Split the update API as separate for the props vs. children.
        // Even better would be if children weren't special cased at all tho.
        var instance = workInProgress.stateNode;
        var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
        // component is hitting the resume path. Figure out why. Possibly
        // related to `hidden`.
        var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.
        workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update. All the work is done in commitWork.
        if (updatePayload) markUpdate(workInProgress);
    };
    updateHostText$1 = function(current, workInProgress, oldText, newText) {
        // If the text differs, mark it as an update. All the work in done in commitWork.
        if (oldText !== newText) markUpdate(workInProgress);
    };
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (getIsHydrating()) // If we're hydrating, we should consume as many items as we can
        // so we don't leave any behind.
        return;
        switch(renderState.tailMode){
            case 'hidden':
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var tailNode = renderState.tail;
                var lastTailNode = null;
                while(tailNode !== null){
                    if (tailNode.alternate !== null) lastTailNode = tailNode;
                    tailNode = tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (lastTailNode === null) // All remaining items in the tail are insertions.
                renderState.tail = null;
                else // Detach the insertion after the last node that was already
                // inserted.
                lastTailNode.sibling = null;
                break;
            case 'collapsed':
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var _tailNode = renderState.tail;
                var _lastTailNode = null;
                while(_tailNode !== null){
                    if (_tailNode.alternate !== null) _lastTailNode = _tailNode;
                    _tailNode = _tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (_lastTailNode === null) {
                    // All remaining items in the tail are insertions.
                    if (!hasRenderedATailFallback && renderState.tail !== null) // We suspended during the head. We want to show at least one
                    // row at the tail. So we'll keep on and cut off the rest.
                    renderState.tail.sibling = null;
                    else renderState.tail = null;
                } else // Detach the insertion after the last node that was already
                // inserted.
                _lastTailNode.sibling = null;
                break;
        }
    }
    function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case LazyComponent:
            case SimpleMemoComponent:
            case FunctionComponent:
            case ForwardRef:
            case Fragment:
            case Mode:
            case Profiler:
            case ContextConsumer:
            case MemoComponent:
                return null;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                return null;
            case HostRoot:
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                var fiberRoot = workInProgress.stateNode;
                if (fiberRoot.pendingContext) {
                    fiberRoot.context = fiberRoot.pendingContext;
                    fiberRoot.pendingContext = null;
                }
                if (current === null || current.child === null) {
                    // If we hydrated, pop so that we can delete any remaining children
                    // that weren't hydrated.
                    var wasHydrated = popHydrationState(workInProgress);
                    if (wasHydrated) // If we hydrated, then we'll need to schedule an update for
                    // the commit side-effects on the root.
                    markUpdate(workInProgress);
                    else if (!fiberRoot.hydrate) // Schedule an effect to clear this container at the start of the next commit.
                    // This handles the case of React rendering into a container with previous children.
                    // It's also safe to do for updates too, because current.child would only be null
                    // if the previous render was null (so the the container would already be empty).
                    workInProgress.flags |= Snapshot;
                }
                updateHostContainer(workInProgress);
                return null;
            case HostComponent:
                popHostContext(workInProgress);
                var rootContainerInstance = getRootHostContainer();
                var type = workInProgress.type;
                if (current !== null && workInProgress.stateNode != null) {
                    updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);
                    if (current.ref !== workInProgress.ref) markRef$1(workInProgress);
                } else {
                    if (!newProps) {
                        if (!(workInProgress.stateNode !== null)) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                        return null;
                    }
                    var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                    // "stack" as the parent. Then append children as we go in beginWork
                    // or completeWork depending on whether we want to add them top->down or
                    // bottom->up. Top->down is faster in IE11.
                    var _wasHydrated = popHydrationState(workInProgress);
                    if (_wasHydrated) // TODO: Move this and createInstance step into the beginPhase
                    // to consolidate.
                    {
                        if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) // If changes to the hydrated node need to be applied at the
                        // commit-phase we mark this as such.
                        markUpdate(workInProgress);
                    } else {
                        var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                        appendAllChildren(instance, workInProgress, false, false);
                        workInProgress.stateNode = instance; // Certain renderers require commit-time effects for initial mount.
                        // (eg DOM renderer supports auto-focus for certain elements).
                        // Make sure such renderers get scheduled for later work.
                        if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) markUpdate(workInProgress);
                    }
                    if (workInProgress.ref !== null) // If there is a ref on a host node we need to schedule a callback
                    markRef$1(workInProgress);
                }
                return null;
            case HostText:
                var newText = newProps;
                if (current && workInProgress.stateNode != null) {
                    var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                    // to schedule a side-effect to do the updates.
                    updateHostText$1(current, workInProgress, oldText, newText);
                } else {
                    if (typeof newText !== 'string') {
                        if (!(workInProgress.stateNode !== null)) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                    }
                    var _rootContainerInstance = getRootHostContainer();
                    var _currentHostContext = getHostContext();
                    var _wasHydrated2 = popHydrationState(workInProgress);
                    if (_wasHydrated2) {
                        if (prepareToHydrateHostTextInstance(workInProgress)) markUpdate(workInProgress);
                    } else workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                }
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var nextState = workInProgress.memoizedState;
                if ((workInProgress.flags & DidCapture) !== NoFlags) {
                    // Something suspended. Re-render with the fallback children.
                    workInProgress.lanes = renderLanes; // Do not reset the effect list.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                var nextDidTimeout = nextState !== null;
                var prevDidTimeout = false;
                if (current === null) {
                    if (workInProgress.memoizedProps.fallback !== undefined) popHydrationState(workInProgress);
                } else {
                    var prevState = current.memoizedState;
                    prevDidTimeout = prevState !== null;
                }
                if (nextDidTimeout && !prevDidTimeout) // If this subtreee is running in blocking mode we can suspend,
                // otherwise we won't suspend.
                // TODO: This will still suspend a synchronous tree if anything
                // in the concurrent tree already suspended during this render.
                // This is a known bug.
                {
                    if ((workInProgress.mode & BlockingMode) !== NoMode) {
                        // TODO: Move this back to throwException because this is too late
                        // if this is a large tree which is common for initial loads. We
                        // don't know if we should restart a render or not until we get
                        // this marker, and this is too late.
                        // If this render already had a ping or lower pri updates,
                        // and this is the first time we know we're going to suspend we
                        // should be able to immediately restart from within throwException.
                        var hasInvisibleChildContext = current === null && workInProgress.memoizedProps.unstable_avoidThisFallback !== true;
                        if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) // If this was in an invisible tree or a new render, then showing
                        // this boundary is ok.
                        renderDidSuspend();
                        else // Otherwise, we're going to have to hide content so we should
                        // suspend for longer if possible.
                        renderDidSuspendDelayIfPossible();
                    }
                }
                // TODO: Only schedule updates if these values are non equal, i.e. it changed.
                if (nextDidTimeout || prevDidTimeout) // If this boundary just timed out, schedule an effect to attach a
                // retry listener to the promise. This flag is also used to hide the
                // primary children. In mutation mode, we also need the flag to
                // *unhide* children that were previously hidden, so check if this
                // is currently timed out, too.
                workInProgress.flags |= Update;
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                updateHostContainer(workInProgress);
                if (current === null) preparePortalMount(workInProgress.stateNode.containerInfo);
                return null;
            case ContextProvider:
                // Pop provider fiber
                popProvider(workInProgress);
                return null;
            case IncompleteClassComponent:
                // Same as class component case. I put it down here so that the tags are
                // sequential to ensure this switch is compiled to a jump table.
                var _Component = workInProgress.type;
                if (isContextProvider(_Component)) popContext(workInProgress);
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress);
                var renderState = workInProgress.memoizedState;
                if (renderState === null) // We're running in the default, "independent" mode.
                // We don't do anything in this mode.
                return null;
                var didSuspendAlready = (workInProgress.flags & DidCapture) !== NoFlags;
                var renderedTail = renderState.rendering;
                if (renderedTail === null) {
                    // We just rendered the head.
                    if (!didSuspendAlready) {
                        // This is the first pass. We need to figure out if anything is still
                        // suspended in the rendered set.
                        // If new content unsuspended, but there's still some content that
                        // didn't. Then we need to do a second pass that forces everything
                        // to keep showing their fallbacks.
                        // We might be suspended if something in this render pass suspended, or
                        // something in the previous committed pass suspended. Otherwise,
                        // there's no chance so we can skip the expensive call to
                        // findFirstSuspended.
                        var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.flags & DidCapture) === NoFlags);
                        if (!cannotBeSuspended) {
                            var row = workInProgress.child;
                            while(row !== null){
                                var suspended = findFirstSuspended(row);
                                if (suspended !== null) {
                                    didSuspendAlready = true;
                                    workInProgress.flags |= DidCapture;
                                    cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                                    // part of the second pass. In that case nothing will subscribe to
                                    // its thennables. Instead, we'll transfer its thennables to the
                                    // SuspenseList so that it can retry if they resolve.
                                    // There might be multiple of these in the list but since we're
                                    // going to wait for all of them anyway, it doesn't really matter
                                    // which ones gets to ping. In theory we could get clever and keep
                                    // track of how many dependencies remain but it gets tricky because
                                    // in the meantime, we can add/remove/change items and dependencies.
                                    // We might bail out of the loop before finding any but that
                                    // doesn't matter since that means that the other boundaries that
                                    // we did find already has their listeners attached.
                                    var newThennables = suspended.updateQueue;
                                    if (newThennables !== null) {
                                        workInProgress.updateQueue = newThennables;
                                        workInProgress.flags |= Update;
                                    } // Rerender the whole list, but this time, we'll force fallbacks
                                    // to stay in place.
                                    // Reset the effect list before doing the second pass since that's now invalid.
                                    if (renderState.lastEffect === null) workInProgress.firstEffect = null;
                                    workInProgress.lastEffect = renderState.lastEffect; // Reset the child fibers to their original state.
                                    resetChildFibers(workInProgress, renderLanes); // Set up the Suspense Context to force suspense and immediately
                                    // rerender the children.
                                    pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback));
                                    return workInProgress.child;
                                }
                                row = row.sibling;
                            }
                        }
                        if (renderState.tail !== null && now() > getRenderTargetTime()) {
                            // We have already passed our CPU deadline but we still have rows
                            // left in the tail. We'll just give up further attempts to render
                            // the main content and only render fallbacks.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                            markSpawnedWork(SomeRetryLane);
                        }
                    } else cutOffTailIfNeeded(renderState, false);
                     // Next we're going to render the tail.
                } else {
                    // Append the rendered row to the child list.
                    if (!didSuspendAlready) {
                        var _suspended = findFirstSuspended(renderedTail);
                        if (_suspended !== null) {
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
                            // get lost if this row ends up dropped during a second pass.
                            var _newThennables = _suspended.updateQueue;
                            if (_newThennables !== null) {
                                workInProgress.updateQueue = _newThennables;
                                workInProgress.flags |= Update;
                            }
                            cutOffTailIfNeeded(renderState, true); // This might have been modified.
                            if (renderState.tail === null && renderState.tailMode === 'hidden' && !renderedTail.alternate && !getIsHydrating() // We don't cut it if we're hydrating.
                            ) {
                                // We need to delete the row we just rendered.
                                // Reset the effect list to what it was before we rendered this
                                // child. The nested children have already appended themselves.
                                var lastEffect = workInProgress.lastEffect = renderState.lastEffect; // Remove any effects that were appended after this point.
                                if (lastEffect !== null) lastEffect.nextEffect = null;
                                 // We're done.
                                return null;
                            }
                        } else if (// time we have to render. So rendering one more row would likely
                        // exceed it.
                        now() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes !== OffscreenLane) {
                            // We have now passed our CPU deadline and we'll just give up further
                            // attempts to render the main content and only render fallbacks.
                            // The assumption is that this is usually faster.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                            markSpawnedWork(SomeRetryLane);
                        }
                    }
                    if (renderState.isBackwards) {
                        // The effect list of the backwards tail will have been added
                        // to the end. This breaks the guarantee that life-cycles fire in
                        // sibling order but that isn't a strong guarantee promised by React.
                        // Especially since these might also just pop in during future commits.
                        // Append to the beginning of the list.
                        renderedTail.sibling = workInProgress.child;
                        workInProgress.child = renderedTail;
                    } else {
                        var previousSibling = renderState.last;
                        if (previousSibling !== null) previousSibling.sibling = renderedTail;
                        else workInProgress.child = renderedTail;
                        renderState.last = renderedTail;
                    }
                }
                if (renderState.tail !== null) {
                    // We still have tail rows to render.
                    // Pop a row.
                    var next = renderState.tail;
                    renderState.rendering = next;
                    renderState.tail = next.sibling;
                    renderState.lastEffect = workInProgress.lastEffect;
                    renderState.renderingStartTime = now();
                    next.sibling = null; // Restore the context.
                    // TODO: We can probably just avoid popping it instead and only
                    // setting it the first time we go from not suspended to suspended.
                    var suspenseContext = suspenseStackCursor.current;
                    if (didSuspendAlready) suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                    else suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                    pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.
                    return next;
                }
                return null;
            case FundamentalComponent:
                break;
            case ScopeComponent:
                break;
            case Block:
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                if (current !== null) {
                    var _nextState = workInProgress.memoizedState;
                    var _prevState = current.memoizedState;
                    var prevIsHidden = _prevState !== null;
                    var nextIsHidden = _nextState !== null;
                    if (prevIsHidden !== nextIsHidden && newProps.mode !== 'unstable-defer-without-hiding') workInProgress.flags |= Update;
                }
                return null;
        }
        throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function unwindWork(workInProgress, renderLanes) {
        switch(workInProgress.tag){
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                var flags = workInProgress.flags;
                if (flags & ShouldCapture) {
                    workInProgress.flags = flags & ~ShouldCapture | DidCapture;
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case HostRoot:
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                var _flags = workInProgress.flags;
                if (!((_flags & DidCapture) === NoFlags)) throw Error("The root failed to unmount after an error. This is likely a bug in React. Please file an issue.");
                workInProgress.flags = _flags & ~ShouldCapture | DidCapture;
                return workInProgress;
            case HostComponent:
                // TODO: popHydrationState
                popHostContext(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var _flags2 = workInProgress.flags;
                if (_flags2 & ShouldCapture) {
                    workInProgress.flags = _flags2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
                // caught by a nested boundary. If not, it should bubble through.
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                return null;
            case ContextProvider:
                popProvider(workInProgress);
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(interruptedWork) {
        switch(interruptedWork.tag){
            case ClassComponent:
                var childContextTypes = interruptedWork.type.childContextTypes;
                if (childContextTypes !== null && childContextTypes !== undefined) popContext(interruptedWork);
                break;
            case HostRoot:
                popHostContainer(interruptedWork);
                popTopLevelContextObject(interruptedWork);
                resetWorkInProgressVersions();
                break;
            case HostComponent:
                popHostContext(interruptedWork);
                break;
            case HostPortal:
                popHostContainer(interruptedWork);
                break;
            case SuspenseComponent:
                popSuspenseContext(interruptedWork);
                break;
            case SuspenseListComponent:
                popSuspenseContext(interruptedWork);
                break;
            case ContextProvider:
                popProvider(interruptedWork);
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(interruptedWork);
                break;
        }
    }
    function createCapturedValue(value, source) {
        // If the value is an error, call this function immediately after it is thrown
        // so the stack is accurate.
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source)
        };
    }
    // This module is forked in different environments.
    // By default, return `true` to log errors to the console.
    // Forks can return `false` if this isn't desirable.
    function showErrorDialog(boundary, errorInfo) {
        return true;
    }
    function logCapturedError(boundary, errorInfo) {
        try {
            var logError = showErrorDialog(boundary, errorInfo); // Allow injected showErrorDialog() to prevent default console.error logging.
            // This enables renderers like ReactNative to better manage redbox behavior.
            if (logError === false) return;
            var error = errorInfo.value;
            var source = errorInfo.source;
            var stack = errorInfo.stack;
            var componentStack = stack !== null ? stack : ''; // Browsers support silencing uncaught errors by calling
            // `preventDefault()` in window `error` handler.
            // We record this information as an expando on the error.
            if (error != null && error._suppressLogging) {
                if (boundary.tag === ClassComponent) // The error is recoverable and was silenced.
                // Ignore it and don't print the stack addendum.
                // This is handy for testing error boundaries without noise.
                return;
                 // The error is fatal. Since the silencing might have
                // been accidental, we'll surface it anyway.
                // However, the browser would have silenced the original error
                // so we'll print it first, and then print the stack addendum.
                console['error'](error); // Don't transform to our wrapper
            // For a more detailed description of this block, see:
            // https://github.com/facebook/react/pull/13384
            }
            var componentName = source ? getComponentName(source.type) : null;
            var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : 'The above error occurred in one of your React components:';
            var errorBoundaryMessage;
            var errorBoundaryName = getComponentName(boundary.type);
            if (errorBoundaryName) errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            else errorBoundaryMessage = "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://reactjs.org/link/error-boundaries to learn more about error boundaries.";
            var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
            // We don't include the original error message and JS stack because the browser
            // has already printed it. Even if the application swallows the error, it is still
            // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.
            console['error'](combinedMessage); // Don't transform to our wrapper
        } catch (e) {
            // This method must not throw, or React internal state will get messed up.
            // If console.error is overridden, or logCapturedError() shows a dialog that throws,
            // we want to report this error outside of the normal stack as a last resort.
            // https://github.com/facebook/react/issues/13188
            setTimeout(function() {
                throw e;
            });
        }
    }
    var PossiblyWeakMap$1 = typeof WeakMap === 'function' ? WeakMap : Map;
    function createRootErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane); // Unmount the root by rendering null.
        update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: null
        };
        var error = errorInfo.value;
        update.callback = function() {
            onUncaughtError(error);
            logCapturedError(fiber, errorInfo);
        };
        return update;
    }
    function createClassErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if (typeof getDerivedStateFromError === 'function') {
            var error$1 = errorInfo.value;
            update.payload = function() {
                logCapturedError(fiber, errorInfo);
                return getDerivedStateFromError(error$1);
            };
        }
        var inst = fiber.stateNode;
        if (inst !== null && typeof inst.componentDidCatch === 'function') update.callback = function callback() {
            markFailedErrorBoundaryForHotReloading(fiber);
            if (typeof getDerivedStateFromError !== 'function') {
                // To preserve the preexisting retry behavior of error boundaries,
                // we keep track of which ones already failed during this batch.
                // This gets reset before we yield back to the browser.
                // TODO: Warn in strict mode if getDerivedStateFromError is
                // not defined.
                markLegacyErrorBoundaryAsFailed(this); // Only log here if componentDidCatch is the only error boundary method defined
                logCapturedError(fiber, errorInfo);
            }
            var error$1 = errorInfo.value;
            var stack = errorInfo.stack;
            this.componentDidCatch(error$1, {
                componentStack: stack !== null ? stack : ''
            });
            if (typeof getDerivedStateFromError !== 'function') // If componentDidCatch is the only error boundary method defined,
            // then it needs to call setState to recover from errors.
            // If no state update is scheduled then the boundary will swallow the error.
            {
                if (!includesSomeLane(fiber.lanes, SyncLane)) error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentName(fiber.type) || 'Unknown');
            }
        };
        else update.callback = function() {
            markFailedErrorBoundaryForHotReloading(fiber);
        };
        return update;
    }
    function attachPingListener(root, wakeable, lanes) {
        // Attach a listener to the promise to "ping" the root and retry. But only if
        // one does not already exist for the lanes we're currently rendering (which
        // acts like a "thread ID" here).
        var pingCache = root.pingCache;
        var threadIDs;
        if (pingCache === null) {
            pingCache = root.pingCache = new PossiblyWeakMap$1();
            threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
        } else {
            threadIDs = pingCache.get(wakeable);
            if (threadIDs === undefined) {
                threadIDs = new Set();
                pingCache.set(wakeable, threadIDs);
            }
        }
        if (!threadIDs.has(lanes)) {
            // Memoize using the thread ID to prevent redundant listeners.
            threadIDs.add(lanes);
            var ping = pingSuspendedRoot.bind(null, root, wakeable, lanes);
            wakeable.then(ping, ping);
        }
    }
    function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        // The source fiber did not complete.
        sourceFiber.flags |= Incomplete; // Its effect list is no longer valid.
        sourceFiber.firstEffect = sourceFiber.lastEffect = null;
        if (value !== null && typeof value === 'object' && typeof value.then === 'function') {
            // This is a wakeable.
            var wakeable = value;
            if ((sourceFiber.mode & BlockingMode) === NoMode) {
                // Reset the memoizedState to what it was before we attempted
                // to render it.
                var currentSource = sourceFiber.alternate;
                if (currentSource) {
                    sourceFiber.updateQueue = currentSource.updateQueue;
                    sourceFiber.memoizedState = currentSource.memoizedState;
                    sourceFiber.lanes = currentSource.lanes;
                } else {
                    sourceFiber.updateQueue = null;
                    sourceFiber.memoizedState = null;
                }
            }
            var hasInvisibleParentBoundary = hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext); // Schedule the nearest Suspense to re-render the timed out view.
            var _workInProgress = returnFiber;
            do {
                if (_workInProgress.tag === SuspenseComponent && shouldCaptureSuspense(_workInProgress, hasInvisibleParentBoundary)) {
                    // Found the nearest boundary.
                    // Stash the promise on the boundary fiber. If the boundary times out, we'll
                    // attach another listener to flip the boundary back to its normal state.
                    var wakeables = _workInProgress.updateQueue;
                    if (wakeables === null) {
                        var updateQueue = new Set();
                        updateQueue.add(wakeable);
                        _workInProgress.updateQueue = updateQueue;
                    } else wakeables.add(wakeable);
                     // If the boundary is outside of blocking mode, we should *not*
                    // suspend the commit. Pretend as if the suspended component rendered
                    // null and keep rendering. In the commit phase, we'll schedule a
                    // subsequent synchronous update to re-render the Suspense.
                    //
                    // Note: It doesn't matter whether the component that suspended was
                    // inside a blocking mode tree. If the Suspense is outside of it, we
                    // should *not* suspend the commit.
                    if ((_workInProgress.mode & BlockingMode) === NoMode) {
                        _workInProgress.flags |= DidCapture;
                        sourceFiber.flags |= ForceUpdateForLegacySuspense; // We're going to commit this fiber even though it didn't complete.
                        // But we shouldn't call any lifecycle methods or callbacks. Remove
                        // all lifecycle effect tags.
                        sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);
                        if (sourceFiber.tag === ClassComponent) {
                            var currentSourceFiber = sourceFiber.alternate;
                            if (currentSourceFiber === null) // This is a new mount. Change the tag so it's not mistaken for a
                            // completed class component. For example, we should not call
                            // componentWillUnmount if it is deleted.
                            sourceFiber.tag = IncompleteClassComponent;
                            else {
                                // When we try rendering again, we should not reuse the current fiber,
                                // since it's known to be in an inconsistent state. Use a force update to
                                // prevent a bail out.
                                var update = createUpdate(NoTimestamp, SyncLane);
                                update.tag = ForceUpdate;
                                enqueueUpdate(sourceFiber, update);
                            }
                        } // The source fiber did not complete. Mark it with Sync priority to
                        // indicate that it still has pending work.
                        sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane); // Exit without suspending.
                        return;
                    } // Confirmed that the boundary is in a concurrent mode tree. Continue
                    // with the normal suspend path.
                    //
                    // After this we'll use a set of heuristics to determine whether this
                    // render pass will run to completion or restart or "suspend" the commit.
                    // The actual logic for this is spread out in different places.
                    //
                    // This first principle is that if we're going to suspend when we complete
                    // a root, then we should also restart if we get an update or ping that
                    // might unsuspend it, and vice versa. The only reason to suspend is
                    // because you think you might want to restart before committing. However,
                    // it doesn't make sense to restart only while in the period we're suspended.
                    //
                    // Restarting too aggressively is also not good because it starves out any
                    // intermediate loading state. So we use heuristics to determine when.
                    // Suspense Heuristics
                    //
                    // If nothing threw a Promise or all the same fallbacks are already showing,
                    // then don't suspend/restart.
                    //
                    // If this is an initial render of a new tree of Suspense boundaries and
                    // those trigger a fallback, then don't suspend/restart. We want to ensure
                    // that we can show the initial loading state as quickly as possible.
                    //
                    // If we hit a "Delayed" case, such as when we'd switch from content back into
                    // a fallback, then we should always suspend/restart. Transitions apply
                    // to this case. If none is defined, JND is used instead.
                    //
                    // If we're already showing a fallback and it gets "retried", allowing us to show
                    // another level, but there's still an inner boundary that would show a fallback,
                    // then we suspend/restart for 500ms since the last time we showed a fallback
                    // anywhere in the tree. This effectively throttles progressive loading into a
                    // consistent train of commits. This also gives us an opportunity to restart to
                    // get to the completed state slightly earlier.
                    //
                    // If there's ambiguity due to batching it's resolved in preference of:
                    // 1) "delayed", 2) "initial render", 3) "retry".
                    //
                    // We want to ensure that a "busy" state doesn't get force committed. We want to
                    // ensure that new initial loading states can commit as soon as possible.
                    attachPingListener(root, wakeable, rootRenderLanes);
                    _workInProgress.flags |= ShouldCapture;
                    _workInProgress.lanes = rootRenderLanes;
                    return;
                } // This boundary already captured during this render. Continue to the next
                // boundary.
                _workInProgress = _workInProgress.return;
            }while (_workInProgress !== null); // No boundary was found. Fallthrough to error mode.
            // TODO: Use invariant so the message is stripped in prod?
            value = new Error((getComponentName(sourceFiber.type) || 'A React component') + ' suspended while rendering, but no fallback UI was specified.\n' + '\n' + 'Add a <Suspense fallback=...> component higher in the tree to ' + 'provide a loading indicator or placeholder to display.');
        } // We didn't find a boundary that could handle this type of exception. Start
        // over and traverse parent path again, this time treating the exception
        // as an error.
        renderDidError();
        value = createCapturedValue(value, sourceFiber);
        var workInProgress = returnFiber;
        do {
            switch(workInProgress.tag){
                case HostRoot:
                    var _errorInfo = value;
                    workInProgress.flags |= ShouldCapture;
                    var lane = pickArbitraryLane(rootRenderLanes);
                    workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);
                    var _update = createRootErrorUpdate(workInProgress, _errorInfo, lane);
                    enqueueCapturedUpdate(workInProgress, _update);
                    return;
                case ClassComponent:
                    // Capture and retry
                    var errorInfo = value;
                    var ctor = workInProgress.type;
                    var instance = workInProgress.stateNode;
                    if ((workInProgress.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === 'function' || instance !== null && typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                        workInProgress.flags |= ShouldCapture;
                        var _lane = pickArbitraryLane(rootRenderLanes);
                        workInProgress.lanes = mergeLanes(workInProgress.lanes, _lane); // Schedule the error boundary to re-render using updated state
                        var _update2 = createClassErrorUpdate(workInProgress, errorInfo, _lane);
                        enqueueCapturedUpdate(workInProgress, _update2);
                        return;
                    }
                    break;
            }
            workInProgress = workInProgress.return;
        }while (workInProgress !== null);
    }
    var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
    var PossiblyWeakSet = typeof WeakSet === 'function' ? WeakSet : Set;
    var callComponentWillUnmountWithTimer = function(current, instance) {
        instance.props = current.memoizedProps;
        instance.state = current.memoizedState;
        instance.componentWillUnmount();
    }; // Capture errors so they don't interrupt unmounting.
    function safelyCallComponentWillUnmount(current, instance) {
        invokeGuardedCallback(null, callComponentWillUnmountWithTimer, null, current, instance);
        if (hasCaughtError()) {
            var unmountError = clearCaughtError();
            captureCommitPhaseError(current, unmountError);
        }
    }
    function safelyDetachRef(current) {
        var ref = current.ref;
        if (ref !== null) {
            if (typeof ref === 'function') {
                invokeGuardedCallback(null, ref, null, null);
                if (hasCaughtError()) {
                    var refError = clearCaughtError();
                    captureCommitPhaseError(current, refError);
                }
            } else ref.current = null;
        }
    }
    function safelyCallDestroy(current, destroy) {
        invokeGuardedCallback(null, destroy, null);
        if (hasCaughtError()) {
            var error = clearCaughtError();
            captureCommitPhaseError(current, error);
        }
    }
    function commitBeforeMutationLifeCycles(current, finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
            case Block:
                return;
            case ClassComponent:
                if (finishedWork.flags & Snapshot) {
                    if (current !== null) {
                        var prevProps = current.memoizedProps;
                        var prevState = current.memoizedState;
                        var instance = finishedWork.stateNode; // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                        }
                        var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                        var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                        if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                            didWarnSet.add(finishedWork.type);
                            error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentName(finishedWork.type));
                        }
                        instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                    }
                }
                return;
            case HostRoot:
                if (finishedWork.flags & Snapshot) {
                    var root = finishedWork.stateNode;
                    clearContainer(root.containerInfo);
                }
                return;
            case HostComponent:
            case HostText:
            case HostPortal:
            case IncompleteClassComponent:
                // Nothing to do for these component types
                return;
        }
        throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
    }
    function commitHookEffectListUnmount(tag, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & tag) === tag) {
                    // Unmount
                    var destroy = effect.destroy;
                    effect.destroy = undefined;
                    if (destroy !== undefined) destroy();
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitHookEffectListMount(tag, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & tag) === tag) {
                    // Mount
                    var create = effect.create;
                    effect.destroy = create();
                    var destroy = effect.destroy;
                    if (destroy !== undefined && typeof destroy !== 'function') {
                        var addendum = void 0;
                        if (destroy === null) addendum = " You returned null. If your effect does not require clean up, return undefined (or nothing).";
                        else if (typeof destroy.then === 'function') addendum = "\n\nIt looks like you wrote useEffect(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:\n\nuseEffect(() => {\n  async function fetchData() {\n    // You can await here\n    const response = await MyAPI.getData(someId);\n    // ...\n  }\n  fetchData();\n}, [someId]); // Or [] if effect doesn't need props or state\n\nLearn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching";
                        else addendum = ' You returned: ' + destroy;
                        error("An effect function must not return anything besides a function, which is used for clean-up.%s", addendum);
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function schedulePassiveEffects(finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                var _effect = effect, next = _effect.next, tag = _effect.tag;
                if ((tag & Passive$1) !== NoFlags$1 && (tag & HasEffect) !== NoFlags$1) {
                    enqueuePendingPassiveHookEffectUnmount(finishedWork, effect);
                    enqueuePendingPassiveHookEffectMount(finishedWork, effect);
                }
                effect = next;
            }while (effect !== firstEffect);
        }
    }
    function commitLifeCycles(finishedRoot, current, finishedWork, committedLanes) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
            case Block:
                commitHookEffectListMount(Layout | HasEffect, finishedWork);
                schedulePassiveEffects(finishedWork);
                return;
            case ClassComponent:
                var instance = finishedWork.stateNode;
                if (finishedWork.flags & Update) {
                    if (current === null) {
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                        }
                        instance.componentDidMount();
                    } else {
                        var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                        var prevState = current.memoizedState; // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                        }
                        instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                    }
                } // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var updateQueue = finishedWork.updateQueue;
                if (updateQueue !== null) {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                        if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                        if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                    }
                    // but instead we rely on them being set during last render.
                    // TODO: revisit this when we implement resuming.
                    commitUpdateQueue(finishedWork, updateQueue, instance);
                }
                return;
            case HostRoot:
                // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var _updateQueue = finishedWork.updateQueue;
                if (_updateQueue !== null) {
                    var _instance = null;
                    if (finishedWork.child !== null) switch(finishedWork.child.tag){
                        case HostComponent:
                            _instance = getPublicInstance(finishedWork.child.stateNode);
                            break;
                        case ClassComponent:
                            _instance = finishedWork.child.stateNode;
                            break;
                    }
                    commitUpdateQueue(finishedWork, _updateQueue, _instance);
                }
                return;
            case HostComponent:
                var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
                // (eg DOM renderer may schedule auto-focus for inputs and form controls).
                // These effects should only be committed when components are first mounted,
                // aka when there is no current/alternate.
                if (current === null && finishedWork.flags & Update) {
                    var type = finishedWork.type;
                    var props = finishedWork.memoizedProps;
                    commitMount(_instance2, type, props);
                }
                return;
            case HostText:
                // We have no life-cycles associated with text.
                return;
            case HostPortal:
                // We have no life-cycles associated with portals.
                return;
            case Profiler:
                var _finishedWork$memoize2 = finishedWork.memoizedProps, onCommit = _finishedWork$memoize2.onCommit, onRender = _finishedWork$memoize2.onRender;
                var effectDuration = finishedWork.stateNode.effectDuration;
                var commitTime = getCommitTime();
                if (typeof onRender === 'function') onRender(finishedWork.memoizedProps.id, current === null ? 'mount' : 'update', finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime, finishedRoot.memoizedInteractions);
                return;
            case SuspenseComponent:
                commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                return;
            case SuspenseListComponent:
            case IncompleteClassComponent:
            case FundamentalComponent:
            case ScopeComponent:
            case OffscreenComponent:
            case LegacyHiddenComponent:
                return;
        }
        throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
    }
    function hideOrUnhideAllChildren(finishedWork, isHidden) {
        // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = finishedWork;
        while(true){
            if (node.tag === HostComponent) {
                var instance = node.stateNode;
                if (isHidden) hideInstance(instance);
                else unhideInstance(node.stateNode, node.memoizedProps);
            } else if (node.tag === HostText) {
                var _instance3 = node.stateNode;
                if (isHidden) hideTextInstance(_instance3);
                else unhideTextInstance(_instance3, node.memoizedProps);
            } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === finishedWork) return;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (ref !== null) {
            var instance = finishedWork.stateNode;
            var instanceToUse;
            switch(finishedWork.tag){
                case HostComponent:
                    instanceToUse = getPublicInstance(instance);
                    break;
                default:
                    instanceToUse = instance;
            } // Moved outside to ensure DCE works with this flag
            if (typeof ref === 'function') ref(instanceToUse);
            else {
                if (!ref.hasOwnProperty('current')) error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", getComponentName(finishedWork.type));
                ref.current = instanceToUse;
            }
        }
    }
    function commitDetachRef(current) {
        var currentRef = current.ref;
        if (currentRef !== null) {
            if (typeof currentRef === 'function') currentRef(null);
            else currentRef.current = null;
        }
    } // User-originating errors (lifecycles and refs) should not interrupt
    // deletion, so don't let them throw. Host-originating errors should
    // interrupt deletion, so it's okay
    function commitUnmount(finishedRoot, current, renderPriorityLevel) {
        onCommitUnmount(current);
        switch(current.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
            case Block:
                var updateQueue = current.updateQueue;
                if (updateQueue !== null) {
                    var lastEffect = updateQueue.lastEffect;
                    if (lastEffect !== null) {
                        var firstEffect = lastEffect.next;
                        var effect = firstEffect;
                        do {
                            var _effect2 = effect, destroy = _effect2.destroy, tag = _effect2.tag;
                            if (destroy !== undefined) {
                                if ((tag & Passive$1) !== NoFlags$1) enqueuePendingPassiveHookEffectUnmount(current, effect);
                                else safelyCallDestroy(current, destroy);
                            }
                            effect = effect.next;
                        }while (effect !== firstEffect);
                    }
                }
                return;
            case ClassComponent:
                safelyDetachRef(current);
                var instance = current.stateNode;
                if (typeof instance.componentWillUnmount === 'function') safelyCallComponentWillUnmount(current, instance);
                return;
            case HostComponent:
                safelyDetachRef(current);
                return;
            case HostPortal:
                unmountHostComponents(finishedRoot, current);
                return;
            case FundamentalComponent:
                return;
            case DehydratedFragment:
                return;
            case ScopeComponent:
                return;
        }
    }
    function commitNestedUnmounts(finishedRoot, root, renderPriorityLevel) {
        // While we're inside a removed host node we don't want to call
        // removeChild on the inner nodes because they're removed by the top
        // call anyway. We also want to call componentWillUnmount on all
        // composites before this host node is removed from the tree. Therefore
        // we do an inner loop while we're still inside the host node.
        var node = root;
        while(true){
            commitUnmount(finishedRoot, node); // Visit children because they may contain more composite or host nodes.
            // Skip portals because commitUnmount() currently visits them recursively.
            if (node.child !== null && // If we don't use mutation we drill down into portals here instead.
            node.tag !== HostPortal) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === root) return;
            while(node.sibling === null){
                if (node.return === null || node.return === root) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function detachFiberMutation(fiber) {
        // Cut off the return pointers to disconnect it from the tree. Ideally, we
        // should clear the child pointer of the parent alternate to let this
        // get GC:ed but we don't know which for sure which parent is the current
        // one so we'll settle for GC:ing the subtree of this child. This child
        // itself will be GC:ed when the parent updates the next time.
        // Note: we cannot null out sibling here, otherwise it can cause issues
        // with findDOMNode and how it requires the sibling field to carry out
        // traversal in a later effect. See PR #16820. We now clear the sibling
        // field after effects, see: detachFiberAfterEffects.
        //
        // Don't disconnect stateNode now; it will be detached in detachFiberAfterEffects.
        // It may be required if the current component is an error boundary,
        // and one of its descendants throws while unmounting a passive effect.
        fiber.alternate = null;
        fiber.child = null;
        fiber.dependencies = null;
        fiber.firstEffect = null;
        fiber.lastEffect = null;
        fiber.memoizedProps = null;
        fiber.memoizedState = null;
        fiber.pendingProps = null;
        fiber.return = null;
        fiber.updateQueue = null;
        fiber._debugOwner = null;
    }
    function getHostParentFiber(fiber) {
        var parent = fiber.return;
        while(parent !== null){
            if (isHostParent(parent)) return parent;
            parent = parent.return;
        }
        throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
    }
    function getHostSibling(fiber) {
        // We're going to search forward into the tree until we find a sibling host
        // node. Unfortunately, if multiple insertions are done in a row we have to
        // search past them. This leads to exponential search for the next sibling.
        // TODO: Find a more efficient way to do this.
        var node = fiber;
        siblings: while(true){
            // If we didn't find anything, let's try the next sibling.
            while(node.sibling === null){
                if (node.return === null || isHostParent(node.return)) // If we pop out of the root or hit the parent the fiber we are the
                // last sibling.
                return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
            while(node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment){
                // If it is not host node and, we might have a host node inside it.
                // Try to search down until we find one.
                if (node.flags & Placement) continue siblings;
                 // If we don't have a child, try the siblings instead.
                // We also skip portals because they are not part of this host tree.
                if (node.child === null || node.tag === HostPortal) continue siblings;
                else {
                    node.child.return = node;
                    node = node.child;
                }
            } // Check if this host node is stable or about to be placed.
            if (!(node.flags & Placement)) // Found it!
            return node.stateNode;
        }
    }
    function commitPlacement(finishedWork) {
        var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.
        var parent;
        var isContainer;
        var parentStateNode = parentFiber.stateNode;
        switch(parentFiber.tag){
            case HostComponent:
                parent = parentStateNode;
                isContainer = false;
                break;
            case HostRoot:
                parent = parentStateNode.containerInfo;
                isContainer = true;
                break;
            case HostPortal:
                parent = parentStateNode.containerInfo;
                isContainer = true;
                break;
            case FundamentalComponent:
            // eslint-disable-next-line-no-fallthrough
            default:
                throw Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (parentFiber.flags & ContentReset) {
            // Reset the text content of the parent before doing any insertions
            resetTextContent(parent); // Clear ContentReset from the effect tag
            parentFiber.flags &= ~ContentReset;
        }
        var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        if (isContainer) insertOrAppendPlacementNodeIntoContainer(finishedWork, before, parent);
        else insertOrAppendPlacementNode(finishedWork, before, parent);
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost || enableFundamentalAPI) {
            var stateNode = isHost ? node.stateNode : node.stateNode.instance;
            if (before) insertInContainerBefore(parent, stateNode, before);
            else appendChildToContainer(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNodeIntoContainer(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    }
    function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost || enableFundamentalAPI) {
            var stateNode = isHost ? node.stateNode : node.stateNode.instance;
            if (before) insertBefore(parent, stateNode, before);
            else appendChild(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNode(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNode(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    }
    function unmountHostComponents(finishedRoot, current, renderPriorityLevel) {
        // We only have the top Fiber that was deleted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = current; // Each iteration, currentParent is populated with node's host parent if not
        // currentParentIsValid.
        var currentParentIsValid = false; // Note: these two variables *must* always be updated together.
        var currentParent;
        var currentParentIsContainer;
        while(true){
            if (!currentParentIsValid) {
                var parent = node.return;
                findParent: while(true){
                    if (!(parent !== null)) throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
                    var parentStateNode = parent.stateNode;
                    switch(parent.tag){
                        case HostComponent:
                            currentParent = parentStateNode;
                            currentParentIsContainer = false;
                            break findParent;
                        case HostRoot:
                            currentParent = parentStateNode.containerInfo;
                            currentParentIsContainer = true;
                            break findParent;
                        case HostPortal:
                            currentParent = parentStateNode.containerInfo;
                            currentParentIsContainer = true;
                            break findParent;
                    }
                    parent = parent.return;
                }
                currentParentIsValid = true;
            }
            if (node.tag === HostComponent || node.tag === HostText) {
                commitNestedUnmounts(finishedRoot, node); // After all the children have unmounted, it is now safe to remove the
                // node from the tree.
                if (currentParentIsContainer) removeChildFromContainer(currentParent, node.stateNode);
                else removeChild(currentParent, node.stateNode);
                 // Don't visit children because we already visited them.
            } else if (node.tag === HostPortal) {
                if (node.child !== null) {
                    // When we go into a portal, it becomes the parent to remove from.
                    // We will reassign it back when we pop the portal on the way up.
                    currentParent = node.stateNode.containerInfo;
                    currentParentIsContainer = true; // Visit children because portals might contain host components.
                    node.child.return = node;
                    node = node.child;
                    continue;
                }
            } else {
                commitUnmount(finishedRoot, node); // Visit children because we may find more host components below.
                if (node.child !== null) {
                    node.child.return = node;
                    node = node.child;
                    continue;
                }
            }
            if (node === current) return;
            while(node.sibling === null){
                if (node.return === null || node.return === current) return;
                node = node.return;
                if (node.tag === HostPortal) // When we go out of the portal, we need to restore the parent.
                // Since we don't keep a stack of them, we will search for it.
                currentParentIsValid = false;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitDeletion(finishedRoot, current, renderPriorityLevel) {
        // Recursively delete all host nodes from the parent.
        // Detach refs and call componentWillUnmount() on the whole subtree.
        unmountHostComponents(finishedRoot, current);
        var alternate = current.alternate;
        detachFiberMutation(current);
        if (alternate !== null) detachFiberMutation(alternate);
    }
    function commitWork(current, finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
            case Block:
                commitHookEffectListUnmount(Layout | HasEffect, finishedWork);
                return;
            case ClassComponent:
                return;
            case HostComponent:
                var instance = finishedWork.stateNode;
                if (instance != null) {
                    // Commit the work prepared earlier.
                    var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                    // as the newProps. The updatePayload will contain the real change in
                    // this case.
                    var oldProps = current !== null ? current.memoizedProps : newProps;
                    var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.
                    var updatePayload = finishedWork.updateQueue;
                    finishedWork.updateQueue = null;
                    if (updatePayload !== null) commitUpdate(instance, updatePayload, type, oldProps, newProps);
                }
                return;
            case HostText:
                if (!(finishedWork.stateNode !== null)) throw Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                var textInstance = finishedWork.stateNode;
                var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                // as the newProps. The updatePayload will contain the real change in
                // this case.
                var oldText = current !== null ? current.memoizedProps : newText;
                commitTextUpdate(textInstance, oldText, newText);
                return;
            case HostRoot:
                var _root = finishedWork.stateNode;
                if (_root.hydrate) {
                    // We've just hydrated. No need to hydrate again.
                    _root.hydrate = false;
                    commitHydratedContainer(_root.containerInfo);
                }
                return;
            case Profiler:
                return;
            case SuspenseComponent:
                commitSuspenseComponent(finishedWork);
                attachSuspenseRetryListeners(finishedWork);
                return;
            case SuspenseListComponent:
                attachSuspenseRetryListeners(finishedWork);
                return;
            case IncompleteClassComponent:
                return;
            case FundamentalComponent:
                break;
            case ScopeComponent:
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                var newState = finishedWork.memoizedState;
                var isHidden = newState !== null;
                hideOrUnhideAllChildren(finishedWork, isHidden);
                return;
        }
        throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
    }
    function commitSuspenseComponent(finishedWork) {
        var newState = finishedWork.memoizedState;
        if (newState !== null) {
            markCommitTimeOfFallback();
            // Hide the Offscreen component that contains the primary children. TODO:
            // Ideally, this effect would have been scheduled on the Offscreen fiber
            // itself. That's how unhiding works: the Offscreen component schedules an
            // effect on itself. However, in this case, the component didn't complete,
            // so the fiber was never added to the effect list in the normal path. We
            // could have appended it to the effect list in the Suspense component's
            // second pass, but doing it this way is less complicated. This would be
            // simpler if we got rid of the effect list and traversed the tree, like
            // we're planning to do.
            var primaryChildParent = finishedWork.child;
            hideOrUnhideAllChildren(primaryChildParent, true);
        }
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        var newState = finishedWork.memoizedState;
        if (newState === null) {
            var current = finishedWork.alternate;
            if (current !== null) {
                var prevState = current.memoizedState;
                if (prevState !== null) {
                    var suspenseInstance = prevState.dehydrated;
                    if (suspenseInstance !== null) commitHydratedSuspenseInstance(suspenseInstance);
                }
            }
        }
    }
    function attachSuspenseRetryListeners(finishedWork) {
        // If this boundary just timed out, then it will have a set of wakeables.
        // For each wakeable, attach a listener so that when it resolves, React
        // attempts to re-render the boundary in the primary (pre-timeout) state.
        var wakeables = finishedWork.updateQueue;
        if (wakeables !== null) {
            finishedWork.updateQueue = null;
            var retryCache = finishedWork.stateNode;
            if (retryCache === null) retryCache = finishedWork.stateNode = new PossiblyWeakSet();
            wakeables.forEach(function(wakeable) {
                // Memoize using the boundary fiber to prevent redundant listeners.
                var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
                if (!retryCache.has(wakeable)) {
                    if (wakeable.__reactDoNotTraceInteractions !== true) retry = tracing.unstable_wrap(retry);
                    retryCache.add(wakeable);
                    wakeable.then(retry, retry);
                }
            });
        }
    } // This function detects when a Suspense boundary goes from visible to hidden.
    // It returns false if the boundary is already hidden.
    // TODO: Use an effect tag.
    function isSuspenseBoundaryBeingHidden(current, finishedWork) {
        if (current !== null) {
            var oldState = current.memoizedState;
            if (oldState === null || oldState.dehydrated !== null) {
                var newState = finishedWork.memoizedState;
                return newState !== null && newState.dehydrated === null;
            }
        }
        return false;
    }
    function commitResetTextContent(current) {
        resetTextContent(current.stateNode);
    }
    var COMPONENT_TYPE = 0;
    var HAS_PSEUDO_CLASS_TYPE = 1;
    var ROLE_TYPE = 2;
    var TEST_NAME_TYPE = 3;
    var TEXT_TYPE = 4;
    if (typeof Symbol === 'function' && Symbol.for) {
        var symbolFor$1 = Symbol.for;
        COMPONENT_TYPE = symbolFor$1('selector.component');
        HAS_PSEUDO_CLASS_TYPE = symbolFor$1('selector.has_pseudo_class');
        ROLE_TYPE = symbolFor$1('selector.role');
        TEST_NAME_TYPE = symbolFor$1('selector.test_id');
        TEXT_TYPE = symbolFor$1('selector.text');
    }
    var commitHooks = [];
    function onCommitRoot$1() {
        commitHooks.forEach(function(commitHook) {
            return commitHook();
        });
    }
    var ceil = Math.ceil;
    var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner, IsSomeRendererActing = ReactSharedInternals.IsSomeRendererActing;
    var NoContext = /*             */ 0;
    var BatchedContext = /*               */ 1;
    var EventContext = /*                 */ 2;
    var DiscreteEventContext = /*         */ 4;
    var LegacyUnbatchedContext = /*       */ 8;
    var RenderContext = /*                */ 16;
    var CommitContext = /*                */ 32;
    var RetryAfterError = /*       */ 64;
    var RootIncomplete = 0;
    var RootFatalErrored = 1;
    var RootErrored = 2;
    var RootSuspended = 3;
    var RootSuspendedWithDelay = 4;
    var RootCompleted = 5; // Describes where we are in the React execution stack
    var executionContext = NoContext; // The root we're working on
    var workInProgressRoot = null; // The fiber we're working on
    var workInProgress = null; // The lanes we're rendering
    var workInProgressRootRenderLanes = NoLanes; // Stack that allows components to change the render lanes for its subtree
    // This is a superset of the lanes we started working on at the root. The only
    // case where it's different from `workInProgressRootRenderLanes` is when we
    // enter a subtree that is hidden and needs to be unhidden: Suspense and
    // Offscreen component.
    //
    // Most things in the work loop should deal with workInProgressRootRenderLanes.
    // Most things in begin/complete phases should deal with subtreeRenderLanes.
    var subtreeRenderLanes = NoLanes;
    var subtreeRenderLanesCursor = createCursor(NoLanes); // Whether to root completed, errored, suspended, etc.
    var workInProgressRootExitStatus = RootIncomplete; // A fatal error, if one is thrown
    var workInProgressRootFatalError = null; // "Included" lanes refer to lanes that were worked on during this render. It's
    // slightly different than `renderLanes` because `renderLanes` can change as you
    // enter and exit an Offscreen tree. This value is the combination of all render
    // lanes for the entire render phase.
    var workInProgressRootIncludedLanes = NoLanes; // The work left over by components that were visited during this render. Only
    // includes unprocessed updates, not work in bailed out children.
    var workInProgressRootSkippedLanes = NoLanes; // Lanes that were updated (in an interleaved event) during this render.
    var workInProgressRootUpdatedLanes = NoLanes; // Lanes that were pinged (in an interleaved event) during this render.
    var workInProgressRootPingedLanes = NoLanes;
    var mostRecentlyUpdatedRoot = null; // The most recent time we committed a fallback. This lets us ensure a train
    // model where we don't commit new loading states in too quick succession.
    var globalMostRecentFallbackTime = 0;
    var FALLBACK_THROTTLE_MS = 500; // The absolute time for when we should start giving up on rendering
    // more and prefer CPU suspense heuristics instead.
    var workInProgressRootRenderTargetTime = Infinity; // How long a render is supposed to take before we start following CPU
    // suspense heuristics and opt out of rendering more content.
    var RENDER_TIMEOUT_MS = 500;
    function resetRenderTimer() {
        workInProgressRootRenderTargetTime = now() + RENDER_TIMEOUT_MS;
    }
    function getRenderTargetTime() {
        return workInProgressRootRenderTargetTime;
    }
    var nextEffect = null;
    var hasUncaughtError = false;
    var firstUncaughtError = null;
    var legacyErrorBoundariesThatAlreadyFailed = null;
    var rootDoesHavePassiveEffects = false;
    var rootWithPendingPassiveEffects = null;
    var pendingPassiveEffectsRenderPriority = NoPriority$1;
    var pendingPassiveEffectsLanes = NoLanes;
    var pendingPassiveHookEffectsMount = [];
    var pendingPassiveHookEffectsUnmount = [];
    var rootsWithPendingDiscreteUpdates = null; // Use these to prevent an infinite loop of nested updates
    var NESTED_UPDATE_LIMIT = 50;
    var nestedUpdateCount = 0;
    var rootWithNestedUpdates = null;
    var NESTED_PASSIVE_UPDATE_LIMIT = 50;
    var nestedPassiveUpdateCount = 0; // Marks the need to reschedule pending interactions at these lanes
    // during the commit phase. This enables them to be traced across components
    // that spawn new work during render. E.g. hidden boundaries, suspended SSR
    // hydration or SuspenseList.
    // TODO: Can use a bitmask instead of an array
    var spawnedWorkDuringRender = null; // If two updates are scheduled within the same event, we should treat their
    // event times as simultaneous, even if the actual clock time has advanced
    // between the first and second call.
    var currentEventTime = NoTimestamp;
    var currentEventWipLanes = NoLanes;
    var currentEventPendingLanes = NoLanes; // Dev only flag that tracks if passive effects are currently being flushed.
    // We warn about state updates for unmounted components differently in this case.
    var isFlushingPassiveEffects = false;
    var focusedInstanceHandle = null;
    var shouldFireAfterActiveInstanceBlur = false;
    function getWorkInProgressRoot() {
        return workInProgressRoot;
    }
    function requestEventTime() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) // We're inside React, so it's fine to read the actual time.
        return now();
         // We're not inside React, so we may be in the middle of a browser event.
        if (currentEventTime !== NoTimestamp) // Use the same start time for all updates until we enter React again.
        return currentEventTime;
         // This is the first update since React yielded. Compute a new start time.
        currentEventTime = now();
        return currentEventTime;
    }
    function requestUpdateLane(fiber) {
        // Special cases
        var mode = fiber.mode;
        if ((mode & BlockingMode) === NoMode) return SyncLane;
        else if ((mode & ConcurrentMode) === NoMode) return getCurrentPriorityLevel() === ImmediatePriority$1 ? SyncLane : SyncBatchedLane;
         // The algorithm for assigning an update to a lane should be stable for all
        // updates at the same priority within the same event. To do this, the inputs
        // to the algorithm must be the same. For example, we use the `renderLanes`
        // to avoid choosing a lane that is already in the middle of rendering.
        //
        // However, the "included" lanes could be mutated in between updates in the
        // same event, like if you perform an update inside `flushSync`. Or any other
        // code path that might call `prepareFreshStack`.
        //
        // The trick we use is to cache the first of each of these inputs within an
        // event. Then reset the cached values once we can be sure the event is over.
        // Our heuristic for that is whenever we enter a concurrent work loop.
        //
        // We'll do the same for `currentEventPendingLanes` below.
        if (currentEventWipLanes === NoLanes) currentEventWipLanes = workInProgressRootIncludedLanes;
        var isTransition = requestCurrentTransition() !== NoTransition;
        if (isTransition) {
            if (currentEventPendingLanes !== NoLanes) currentEventPendingLanes = mostRecentlyUpdatedRoot !== null ? mostRecentlyUpdatedRoot.pendingLanes : NoLanes;
            return findTransitionLane(currentEventWipLanes, currentEventPendingLanes);
        } // TODO: Remove this dependency on the Scheduler priority.
        // To do that, we're replacing it with an update lane priority.
        var schedulerPriority = getCurrentPriorityLevel(); // The old behavior was using the priority level of the Scheduler.
        // This couples React to the Scheduler internals, so we're replacing it
        // with the currentUpdateLanePriority above. As an example of how this
        // could be problematic, if we're not inside `Scheduler.runWithPriority`,
        // then we'll get the priority of the current running Scheduler task,
        // which is probably not what we want.
        var lane;
        if ((executionContext & DiscreteEventContext) !== NoContext && schedulerPriority === UserBlockingPriority$2) lane = findUpdateLane(InputDiscreteLanePriority, currentEventWipLanes);
        else {
            var schedulerLanePriority = schedulerPriorityToLanePriority(schedulerPriority);
            lane = findUpdateLane(schedulerLanePriority, currentEventWipLanes);
        }
        return lane;
    }
    function requestRetryLane(fiber) {
        // This is a fork of `requestUpdateLane` designed specifically for Suspense
        // "retries" — a special update that attempts to flip a Suspense boundary
        // from its placeholder state to its primary/resolved state.
        // Special cases
        var mode = fiber.mode;
        if ((mode & BlockingMode) === NoMode) return SyncLane;
        else if ((mode & ConcurrentMode) === NoMode) return getCurrentPriorityLevel() === ImmediatePriority$1 ? SyncLane : SyncBatchedLane;
         // See `requestUpdateLane` for explanation of `currentEventWipLanes`
        if (currentEventWipLanes === NoLanes) currentEventWipLanes = workInProgressRootIncludedLanes;
        return findRetryLane(currentEventWipLanes);
    }
    function scheduleUpdateOnFiber(fiber, lane, eventTime) {
        checkForNestedUpdates();
        warnAboutRenderPhaseUpdatesInDEV(fiber);
        var root = markUpdateLaneFromFiberToRoot(fiber, lane);
        if (root === null) {
            warnAboutUpdateOnUnmountedFiberInDEV(fiber);
            return null;
        } // Mark that the root has a pending update.
        markRootUpdated(root, lane, eventTime);
        if (root === workInProgressRoot) {
            workInProgressRootUpdatedLanes = mergeLanes(workInProgressRootUpdatedLanes, lane);
            if (workInProgressRootExitStatus === RootSuspendedWithDelay) // The root already suspended with a delay, which means this render
            // definitely won't finish. Since we have a new update, let's mark it as
            // suspended now, right before marking the incoming update. This has the
            // effect of interrupting the current render and switching to the update.
            // TODO: Make sure this doesn't override pings that happen while we've
            // already started rendering.
            markRootSuspended$1(root, workInProgressRootRenderLanes);
        } // TODO: requestUpdateLanePriority also reads the priority. Pass the
        // priority as an argument to that function and this one.
        var priorityLevel = getCurrentPriorityLevel();
        if (lane === SyncLane) {
            if ((executionContext & LegacyUnbatchedContext) !== NoContext && // Check if we're not already rendering
            (executionContext & (RenderContext | CommitContext)) === NoContext) {
                // Register pending interactions on the root to avoid losing traced interaction data.
                schedulePendingInteractions(root, lane); // This is a legacy edge case. The initial mount of a ReactDOM.render-ed
                // root inside of batchedUpdates should be synchronous, but layout updates
                // should be deferred until the end of the batch.
                performSyncWorkOnRoot(root);
            } else {
                ensureRootIsScheduled(root, eventTime);
                schedulePendingInteractions(root, lane);
                if (executionContext === NoContext) {
                    // Flush the synchronous work now, unless we're already working or inside
                    // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
                    // scheduleCallbackForFiber to preserve the ability to schedule a callback
                    // without immediately flushing it. We only do this for user-initiated
                    // updates, to preserve historical behavior of legacy mode.
                    resetRenderTimer();
                    flushSyncCallbackQueue();
                }
            }
        } else {
            // Schedule a discrete update but only if it's not Sync.
            if ((executionContext & DiscreteEventContext) !== NoContext && // discrete, even inside a discrete event.
            (priorityLevel === UserBlockingPriority$2 || priorityLevel === ImmediatePriority$1)) {
                // This is the result of a discrete event. Track the lowest priority
                // discrete update per root so we can flush them early, if needed.
                if (rootsWithPendingDiscreteUpdates === null) rootsWithPendingDiscreteUpdates = new Set([
                    root
                ]);
                else rootsWithPendingDiscreteUpdates.add(root);
            } // Schedule other updates after in case the callback is sync.
            ensureRootIsScheduled(root, eventTime);
            schedulePendingInteractions(root, lane);
        } // We use this when assigning a lane for a transition inside
        // `requestUpdateLane`. We assume it's the same as the root being updated,
        // since in the common case of a single root app it probably is. If it's not
        // the same root, then it's not a huge deal, we just might batch more stuff
        // together more than necessary.
        mostRecentlyUpdatedRoot = root;
    } // This is split into a separate function so we can mark a fiber with pending
    // work without treating it as a typical update that originates from an event;
    // e.g. retrying a Suspense boundary isn't an update, but it does schedule work
    // on a fiber.
    function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
        // Update the source fiber's lanes
        sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
        var alternate = sourceFiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, lane);
        if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
        var node = sourceFiber;
        var parent = sourceFiber.return;
        while(parent !== null){
            parent.childLanes = mergeLanes(parent.childLanes, lane);
            alternate = parent.alternate;
            if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, lane);
            else if ((parent.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
            node = parent;
            parent = parent.return;
        }
        if (node.tag === HostRoot) {
            var root = node.stateNode;
            return root;
        } else return null;
    } // Use this function to schedule a task for a root. There's only one task per
    // root; if a task was already scheduled, we'll check to make sure the priority
    // of the existing task is the same as the priority of the next level that the
    // root has work on. This function is called on every update, and right before
    // exiting a task.
    function ensureRootIsScheduled(root, currentTime) {
        var existingCallbackNode = root.callbackNode; // Check if any lanes are being starved by other work. If so, mark them as
        // expired so we know to work on those next.
        markStarvedLanesAsExpired(root, currentTime); // Determine the next lanes to work on, and their priority.
        var nextLanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes); // This returns the priority level computed during the `getNextLanes` call.
        var newCallbackPriority = returnNextLanesPriority();
        if (nextLanes === NoLanes) {
            // Special case: There's nothing to work on.
            if (existingCallbackNode !== null) {
                cancelCallback(existingCallbackNode);
                root.callbackNode = null;
                root.callbackPriority = NoLanePriority;
            }
            return;
        } // Check if there's an existing task. We may be able to reuse it.
        if (existingCallbackNode !== null) {
            var existingCallbackPriority = root.callbackPriority;
            if (existingCallbackPriority === newCallbackPriority) // The priority hasn't changed. We can reuse the existing task. Exit.
            return;
             // The priority changed. Cancel the existing callback. We'll schedule a new
            // one below.
            cancelCallback(existingCallbackNode);
        } // Schedule a new callback.
        var newCallbackNode;
        if (newCallbackPriority === SyncLanePriority) // Special case: Sync React callbacks are scheduled on a special
        // internal queue
        newCallbackNode = scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
        else if (newCallbackPriority === SyncBatchedLanePriority) newCallbackNode = scheduleCallback(ImmediatePriority$1, performSyncWorkOnRoot.bind(null, root));
        else {
            var schedulerPriorityLevel = lanePriorityToSchedulerPriority(newCallbackPriority);
            newCallbackNode = scheduleCallback(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root));
        }
        root.callbackPriority = newCallbackPriority;
        root.callbackNode = newCallbackNode;
    } // This is the entry point for every concurrent task, i.e. anything that
    // goes through Scheduler.
    function performConcurrentWorkOnRoot(root) {
        // Since we know we're in a React event, we can clear the current
        // event time. The next update will compute a new event time.
        currentEventTime = NoTimestamp;
        currentEventWipLanes = NoLanes;
        currentEventPendingLanes = NoLanes;
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Should not already be working.");
         // Flush any pending passive effects before deciding which lanes to work on,
        // in case they schedule additional work.
        var originalCallbackNode = root.callbackNode;
        var didFlushPassiveEffects = flushPassiveEffects();
        if (didFlushPassiveEffects) {
            // Something in the passive effect phase may have canceled the current task.
            // Check if the task node for this root was changed.
            if (root.callbackNode !== originalCallbackNode) // The current task was canceled. Exit. We don't need to call
            // `ensureRootIsScheduled` because the check above implies either that
            // there's a new task, or that there's no remaining work on this root.
            return null;
        } // Determine the next expiration time to work on, using the fields stored
        // on the root.
        var lanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (lanes === NoLanes) // Defensive coding. This is never expected to happen.
        return null;
        var exitStatus = renderRootConcurrent(root, lanes);
        if (includesSomeLane(workInProgressRootIncludedLanes, workInProgressRootUpdatedLanes)) // The render included lanes that were updated during the render phase.
        // For example, when unhiding a hidden tree, we include all the lanes
        // that were previously skipped when the tree was hidden. That set of
        // lanes is a superset of the lanes we started rendering with.
        //
        // So we'll throw out the current work and restart.
        prepareFreshStack(root, NoLanes);
        else if (exitStatus !== RootIncomplete) {
            if (exitStatus === RootErrored) {
                executionContext |= RetryAfterError; // If an error occurred during hydration,
                // discard server response and fall back to client side render.
                if (root.hydrate) {
                    root.hydrate = false;
                    clearContainer(root.containerInfo);
                } // If something threw an error, try rendering one more time. We'll render
                // synchronously to block concurrent data mutations, and we'll includes
                // all pending updates are included. If it still fails after the second
                // attempt, we'll give up and commit the resulting tree.
                lanes = getLanesToRetrySynchronouslyOnError(root);
                if (lanes !== NoLanes) exitStatus = renderRootSync(root, lanes);
            }
            if (exitStatus === RootFatalErrored) {
                var fatalError = workInProgressRootFatalError;
                prepareFreshStack(root, NoLanes);
                markRootSuspended$1(root, lanes);
                ensureRootIsScheduled(root, now());
                throw fatalError;
            } // We now have a consistent tree. The next step is either to commit it,
            // or, if something suspended, wait to commit it after a timeout.
            var finishedWork = root.current.alternate;
            root.finishedWork = finishedWork;
            root.finishedLanes = lanes;
            finishConcurrentRender(root, exitStatus, lanes);
        }
        ensureRootIsScheduled(root, now());
        if (root.callbackNode === originalCallbackNode) // The task node scheduled for this root is the same one that's
        // currently executed. Need to return a continuation.
        return performConcurrentWorkOnRoot.bind(null, root);
        return null;
    }
    function finishConcurrentRender(root, exitStatus, lanes) {
        switch(exitStatus){
            case RootIncomplete:
            case RootFatalErrored:
                throw Error("Root did not complete. This is a bug in React.");
            // Flow knows about invariant, so it complains if I add a break
            // statement, but eslint doesn't know about invariant, so it complains
            // if I do. eslint-disable-next-line no-fallthrough
            case RootErrored:
                // We should have already attempted to retry this tree. If we reached
                // this point, it errored again. Commit it.
                commitRoot(root);
                break;
            case RootSuspended:
                markRootSuspended$1(root, lanes); // We have an acceptable loading state. We need to figure out if we
                // should immediately commit it or wait a bit.
                if (includesOnlyRetries(lanes) && // do not delay if we're inside an act() scope
                !shouldForceFlushFallbacksInDEV()) {
                    // This render only included retries, no updates. Throttle committing
                    // retries so that we don't show too many loading states too quickly.
                    var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.
                    if (msUntilTimeout > 10) {
                        var nextLanes = getNextLanes(root, NoLanes);
                        if (nextLanes !== NoLanes) break;
                        var suspendedLanes = root.suspendedLanes;
                        if (!isSubsetOfLanes(suspendedLanes, lanes)) {
                            // We should prefer to render the fallback of at the last
                            // suspended level. Ping the last suspended level to try
                            // rendering it again.
                            // FIXME: What if the suspended lanes are Idle? Should not restart.
                            var eventTime = requestEventTime();
                            markRootPinged(root, suspendedLanes);
                            break;
                        } // The render is suspended, it hasn't timed out, and there's no
                        // lower priority work to do. Instead of committing the fallback
                        // immediately, wait for more data to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), msUntilTimeout);
                        break;
                    }
                } // The work expired. Commit immediately.
                commitRoot(root);
                break;
            case RootSuspendedWithDelay:
                markRootSuspended$1(root, lanes);
                if (includesOnlyTransitions(lanes)) break;
                if (!shouldForceFlushFallbacksInDEV()) {
                    // This is not a transition, but we did trigger an avoided state.
                    // Schedule a placeholder to display after a short delay, using the Just
                    // Noticeable Difference.
                    // TODO: Is the JND optimization worth the added complexity? If this is
                    // the only reason we track the event time, then probably not.
                    // Consider removing.
                    var mostRecentEventTime = getMostRecentEventTime(root, lanes);
                    var eventTimeMs = mostRecentEventTime;
                    var timeElapsedMs = now() - eventTimeMs;
                    var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs; // Don't bother with a very short suspense time.
                    if (_msUntilTimeout > 10) {
                        // Instead of committing the fallback immediately, wait for more data
                        // to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), _msUntilTimeout);
                        break;
                    }
                } // Commit the placeholder.
                commitRoot(root);
                break;
            case RootCompleted:
                // The work completed. Ready to commit.
                commitRoot(root);
                break;
            default:
                throw Error("Unknown root exit status.");
        }
    }
    function markRootSuspended$1(root, suspendedLanes) {
        // When suspending, we should always exclude lanes that were pinged or (more
        // rarely, since we try to avoid it) updated during the render phase.
        // TODO: Lol maybe there's a better way to factor this besides this
        // obnoxiously named function :)
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootUpdatedLanes);
        markRootSuspended(root, suspendedLanes);
    } // This is the entry point for synchronous tasks that don't go
    // through Scheduler
    function performSyncWorkOnRoot(root) {
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Should not already be working.");
        flushPassiveEffects();
        var lanes;
        var exitStatus;
        if (root === workInProgressRoot && includesSomeLane(root.expiredLanes, workInProgressRootRenderLanes)) {
            // There's a partial tree, and at least one of its lanes has expired. Finish
            // rendering it before rendering the rest of the expired work.
            lanes = workInProgressRootRenderLanes;
            exitStatus = renderRootSync(root, lanes);
            if (includesSomeLane(workInProgressRootIncludedLanes, workInProgressRootUpdatedLanes)) {
                // The render included lanes that were updated during the render phase.
                // For example, when unhiding a hidden tree, we include all the lanes
                // that were previously skipped when the tree was hidden. That set of
                // lanes is a superset of the lanes we started rendering with.
                //
                // Note that this only happens when part of the tree is rendered
                // concurrently. If the whole tree is rendered synchronously, then there
                // are no interleaved events.
                lanes = getNextLanes(root, lanes);
                exitStatus = renderRootSync(root, lanes);
            }
        } else {
            lanes = getNextLanes(root, NoLanes);
            exitStatus = renderRootSync(root, lanes);
        }
        if (root.tag !== LegacyRoot && exitStatus === RootErrored) {
            executionContext |= RetryAfterError; // If an error occurred during hydration,
            // discard server response and fall back to client side render.
            if (root.hydrate) {
                root.hydrate = false;
                clearContainer(root.containerInfo);
            } // If something threw an error, try rendering one more time. We'll render
            // synchronously to block concurrent data mutations, and we'll includes
            // all pending updates are included. If it still fails after the second
            // attempt, we'll give up and commit the resulting tree.
            lanes = getLanesToRetrySynchronouslyOnError(root);
            if (lanes !== NoLanes) exitStatus = renderRootSync(root, lanes);
        }
        if (exitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            prepareFreshStack(root, NoLanes);
            markRootSuspended$1(root, lanes);
            ensureRootIsScheduled(root, now());
            throw fatalError;
        } // We now have a consistent tree. Because this is a sync render, we
        // will commit it even if something suspended.
        var finishedWork = root.current.alternate;
        root.finishedWork = finishedWork;
        root.finishedLanes = lanes;
        commitRoot(root); // Before exiting, make sure there's a callback scheduled for the next
        // pending level.
        ensureRootIsScheduled(root, now());
        return null;
    }
    function flushDiscreteUpdates() {
        // TODO: Should be able to flush inside batchedUpdates, but not inside `act`.
        // However, `act` uses `batchedUpdates`, so there's no way to distinguish
        // those two cases. Need to fix this before exposing flushDiscreteUpdates
        // as a public API.
        if ((executionContext & (BatchedContext | RenderContext | CommitContext)) !== NoContext) {
            if ((executionContext & RenderContext) !== NoContext) error("unstable_flushDiscreteUpdates: Cannot flush updates when React is already rendering.");
            // This is probably a nested event dispatch triggered by a lifecycle/effect,
            // like `el.focus()`. Exit.
            return;
        }
        flushPendingDiscreteUpdates(); // If the discrete updates scheduled passive effects, flush them now so that
        // they fire before the next serial event.
        flushPassiveEffects();
    }
    function flushPendingDiscreteUpdates() {
        if (rootsWithPendingDiscreteUpdates !== null) {
            // For each root with pending discrete updates, schedule a callback to
            // immediately flush them.
            var roots = rootsWithPendingDiscreteUpdates;
            rootsWithPendingDiscreteUpdates = null;
            roots.forEach(function(root) {
                markDiscreteUpdatesExpired(root);
                ensureRootIsScheduled(root, now());
            });
        } // Now flush the immediate queue.
        flushSyncCallbackQueue();
    }
    function batchedUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) {
                // Flush the immediate callbacks that were scheduled during this batch
                resetRenderTimer();
                flushSyncCallbackQueue();
            }
        }
    }
    function batchedEventUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= EventContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) {
                // Flush the immediate callbacks that were scheduled during this batch
                resetRenderTimer();
                flushSyncCallbackQueue();
            }
        }
    }
    function discreteUpdates$1(fn, a, b, c, d) {
        var prevExecutionContext = executionContext;
        executionContext |= DiscreteEventContext;
        try {
            return runWithPriority$1(UserBlockingPriority$2, fn.bind(null, a, b, c, d));
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) {
                // Flush the immediate callbacks that were scheduled during this batch
                resetRenderTimer();
                flushSyncCallbackQueue();
            }
        }
    }
    function unbatchedUpdates(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext &= ~BatchedContext;
        executionContext |= LegacyUnbatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) {
                // Flush the immediate callbacks that were scheduled during this batch
                resetRenderTimer();
                flushSyncCallbackQueue();
            }
        }
    }
    function flushSync(fn, a) {
        var prevExecutionContext = executionContext;
        if ((prevExecutionContext & (RenderContext | CommitContext)) !== NoContext) {
            error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
            return fn(a);
        }
        executionContext |= BatchedContext;
        try {
            if (fn) return runWithPriority$1(ImmediatePriority$1, fn.bind(null, a));
            else return undefined;
        } finally{
            executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
            // Note that this will happen even if batchedUpdates is higher up
            // the stack.
            flushSyncCallbackQueue();
        }
    }
    function pushRenderLanes(fiber, lanes) {
        push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
        subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
        workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
    }
    function popRenderLanes(fiber) {
        subtreeRenderLanes = subtreeRenderLanesCursor.current;
        pop(subtreeRenderLanesCursor, fiber);
    }
    function prepareFreshStack(root, lanes) {
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        var timeoutHandle = root.timeoutHandle;
        if (timeoutHandle !== noTimeout) {
            // The root previous suspended and scheduled a timeout to commit a fallback
            // state. Now that we have additional work, cancel the timeout.
            root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above
            cancelTimeout(timeoutHandle);
        }
        if (workInProgress !== null) {
            var interruptedWork = workInProgress.return;
            while(interruptedWork !== null){
                unwindInterruptedWork(interruptedWork);
                interruptedWork = interruptedWork.return;
            }
        }
        workInProgressRoot = root;
        workInProgress = createWorkInProgress(root.current, null);
        workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
        workInProgressRootExitStatus = RootIncomplete;
        workInProgressRootFatalError = null;
        workInProgressRootSkippedLanes = NoLanes;
        workInProgressRootUpdatedLanes = NoLanes;
        workInProgressRootPingedLanes = NoLanes;
        spawnedWorkDuringRender = null;
        ReactStrictModeWarnings.discardPendingWarnings();
    }
    function handleError(root, thrownValue) {
        do {
            var erroredWork = workInProgress;
            try {
                // Reset module-level state that was set during the render phase.
                resetContextDependencies();
                resetHooksAfterThrow();
                resetCurrentFiber(); // TODO: I found and added this missing line while investigating a
                // separate issue. Write a regression test using string refs.
                ReactCurrentOwner$2.current = null;
                if (erroredWork === null || erroredWork.return === null) {
                    // Expected to be working on a non-root fiber. This is a fatal error
                    // because there's no ancestor that can handle it; the root is
                    // supposed to capture all errors that weren't caught by an error
                    // boundary.
                    workInProgressRootExitStatus = RootFatalErrored;
                    workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
                    // sibling, or the parent if there are no siblings. But since the root
                    // has no siblings nor a parent, we set it to null. Usually this is
                    // handled by `completeUnitOfWork` or `unwindWork`, but since we're
                    // intentionally not calling those, we need set it here.
                    // TODO: Consider calling `unwindWork` to pop the contexts.
                    workInProgress = null;
                    return;
                }
                if (enableProfilerTimer && erroredWork.mode & ProfileMode) // Record the time spent rendering before an error was thrown. This
                // avoids inaccurate Profiler durations in the case of a
                // suspended render.
                stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
                throwException(root, erroredWork.return, erroredWork, thrownValue, workInProgressRootRenderLanes);
                completeUnitOfWork(erroredWork);
            } catch (yetAnotherThrownValue) {
                // Something in the return path also threw.
                thrownValue = yetAnotherThrownValue;
                if (workInProgress === erroredWork && erroredWork !== null) {
                    // If this boundary has already errored, then we had trouble processing
                    // the error. Bubble it to the next boundary.
                    erroredWork = erroredWork.return;
                    workInProgress = erroredWork;
                } else erroredWork = workInProgress;
                continue;
            } // Return to the normal work loop.
            return;
        }while (true);
    }
    function pushDispatcher() {
        var prevDispatcher = ReactCurrentDispatcher$2.current;
        ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;
        if (prevDispatcher === null) // The React isomorphic package does not include a default dispatcher.
        // Instead the first renderer will lazily attach one, in order to give
        // nicer error messages.
        return ContextOnlyDispatcher;
        else return prevDispatcher;
    }
    function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher$2.current = prevDispatcher;
    }
    function pushInteractions(root) {
        var prevInteractions = tracing.__interactionsRef.current;
        tracing.__interactionsRef.current = root.memoizedInteractions;
        return prevInteractions;
    }
    function popInteractions(prevInteractions) {
        tracing.__interactionsRef.current = prevInteractions;
    }
    function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now();
    }
    function markSkippedUpdateLanes(lane) {
        workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
    }
    function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootIncomplete) workInProgressRootExitStatus = RootSuspended;
    }
    function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootIncomplete || workInProgressRootExitStatus === RootSuspended) workInProgressRootExitStatus = RootSuspendedWithDelay;
         // Check if there are updates that we skipped tree that might have unblocked
        // this render.
        if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootUpdatedLanes))) // Mark the current render as suspended so that we switch to working on
        // the updates that were skipped. Usually we only suspend at the end of
        // the render phase.
        // TODO: We should probably always mark the root as suspended immediately
        // (inside this function), since by suspending at the end of the render
        // phase introduces a potential mistake where we suspend lanes that were
        // pinged or updated while we were rendering.
        markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
    }
    function renderDidError() {
        if (workInProgressRootExitStatus !== RootCompleted) workInProgressRootExitStatus = RootErrored;
    } // Called during render to determine if anything has suspended.
    // Returns false if we're not sure.
    function renderHasNotSuspendedYet() {
        // If something errored or completed, we can't really be sure,
        // so those are false.
        return workInProgressRootExitStatus === RootIncomplete;
    }
    function renderRootSync(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            prepareFreshStack(root, lanes);
            startWorkOnPendingInteractions(root, lanes);
        }
        var prevInteractions = pushInteractions(root);
        for(;;)try {
            workLoopSync();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        popInteractions(prevInteractions);
        executionContext = prevExecutionContext;
        popDispatcher(prevDispatcher);
        if (workInProgress !== null) throw Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
        workInProgressRoot = null;
        workInProgressRootRenderLanes = NoLanes;
        return workInProgressRootExitStatus;
    } // The work loop is an extremely hot path. Tell Closure not to inline it.
    /** @noinline */ function workLoopSync() {
        // Already timed out, so perform work without checking if we need to yield.
        while(workInProgress !== null)performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            resetRenderTimer();
            prepareFreshStack(root, lanes);
            startWorkOnPendingInteractions(root, lanes);
        }
        var prevInteractions = pushInteractions(root);
        for(;;)try {
            workLoopConcurrent();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        popInteractions(prevInteractions);
        popDispatcher(prevDispatcher);
        executionContext = prevExecutionContext;
        if (workInProgress !== null) return RootIncomplete;
        else {
            workInProgressRoot = null;
            workInProgressRootRenderLanes = NoLanes; // Return the final exit status.
            return workInProgressRootExitStatus;
        }
    }
    /** @noinline */ function workLoopConcurrent() {
        // Perform work until Scheduler asks us to yield
        while(workInProgress !== null && !shouldYield())performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        // The current, flushed, state of this fiber is the alternate. Ideally
        // nothing should rely on this, but relying on it here means that we don't
        // need an additional field on the work in progress.
        var current = unitOfWork.alternate;
        setCurrentFiber(unitOfWork);
        var next;
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
            startProfilerTimer(unitOfWork);
            next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
            stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        if (next === null) // If this doesn't spawn new work, complete the current work.
        completeUnitOfWork(unitOfWork);
        else workInProgress = next;
        ReactCurrentOwner$2.current = null;
    }
    function completeUnitOfWork(unitOfWork) {
        // Attempt to complete the current unit of work, then move to the next
        // sibling. If there are no more siblings, return to the parent fiber.
        var completedWork = unitOfWork;
        do {
            // The current, flushed, state of this fiber is the alternate. Ideally
            // nothing should rely on this, but relying on it here means that we don't
            // need an additional field on the work in progress.
            var current = completedWork.alternate;
            var returnFiber = completedWork.return; // Check if the work completed or if something threw.
            if ((completedWork.flags & Incomplete) === NoFlags) {
                setCurrentFiber(completedWork);
                var next = void 0;
                if ((completedWork.mode & ProfileMode) === NoMode) next = completeWork(current, completedWork, subtreeRenderLanes);
                else {
                    startProfilerTimer(completedWork);
                    next = completeWork(current, completedWork, subtreeRenderLanes); // Update render duration assuming we didn't error.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
                }
                resetCurrentFiber();
                if (next !== null) {
                    // Completing this fiber spawned new work. Work on that next.
                    workInProgress = next;
                    return;
                }
                resetChildLanes(completedWork);
                if (returnFiber !== null && // Do not append effects to parents if a sibling failed to complete
                (returnFiber.flags & Incomplete) === NoFlags) {
                    // Append all the effects of the subtree and this fiber onto the effect
                    // list of the parent. The completion order of the children affects the
                    // side-effect order.
                    if (returnFiber.firstEffect === null) returnFiber.firstEffect = completedWork.firstEffect;
                    if (completedWork.lastEffect !== null) {
                        if (returnFiber.lastEffect !== null) returnFiber.lastEffect.nextEffect = completedWork.firstEffect;
                        returnFiber.lastEffect = completedWork.lastEffect;
                    } // If this fiber had side-effects, we append it AFTER the children's
                    // side-effects. We can perform certain side-effects earlier if needed,
                    // by doing multiple passes over the effect list. We don't want to
                    // schedule our own side-effect on our own list because if end up
                    // reusing children we'll schedule this effect onto itself since we're
                    // at the end.
                    var flags = completedWork.flags; // Skip both NoWork and PerformedWork tags when creating the effect
                    // list. PerformedWork effect is read by React DevTools but shouldn't be
                    // committed.
                    if (flags > PerformedWork) {
                        if (returnFiber.lastEffect !== null) returnFiber.lastEffect.nextEffect = completedWork;
                        else returnFiber.firstEffect = completedWork;
                        returnFiber.lastEffect = completedWork;
                    }
                }
            } else {
                // This fiber did not complete because something threw. Pop values off
                // the stack without entering the complete phase. If this is a boundary,
                // capture values if possible.
                var _next = unwindWork(completedWork); // Because this fiber did not complete, don't reset its expiration time.
                if (_next !== null) {
                    // If completing this work spawned new work, do that next. We'll come
                    // back here again.
                    // Since we're restarting, remove anything that is not a host effect
                    // from the effect tag.
                    _next.flags &= HostEffectMask;
                    workInProgress = _next;
                    return;
                }
                if ((completedWork.mode & ProfileMode) !== NoMode) {
                    // Record the render duration for the fiber that errored.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false); // Include the time spent working on failed children before continuing.
                    var actualDuration = completedWork.actualDuration;
                    var child = completedWork.child;
                    while(child !== null){
                        actualDuration += child.actualDuration;
                        child = child.sibling;
                    }
                    completedWork.actualDuration = actualDuration;
                }
                if (returnFiber !== null) {
                    // Mark the parent fiber as incomplete and clear its effect list.
                    returnFiber.firstEffect = returnFiber.lastEffect = null;
                    returnFiber.flags |= Incomplete;
                }
            }
            var siblingFiber = completedWork.sibling;
            if (siblingFiber !== null) {
                // If there is more work to do in this returnFiber, do that next.
                workInProgress = siblingFiber;
                return;
            } // Otherwise, return to the parent
            completedWork = returnFiber; // Update the next thing we're working on in case something throws.
            workInProgress = completedWork;
        }while (completedWork !== null); // We've reached the root.
        if (workInProgressRootExitStatus === RootIncomplete) workInProgressRootExitStatus = RootCompleted;
    }
    function resetChildLanes(completedWork) {
        if (// to switch statement in `completeWork`.
        (completedWork.tag === LegacyHiddenComponent || completedWork.tag === OffscreenComponent) && completedWork.memoizedState !== null && !includesSomeLane(subtreeRenderLanes, OffscreenLane) && (completedWork.mode & ConcurrentMode) !== NoLanes) // The children of this component are hidden. Don't bubble their
        // expiration times.
        return;
        var newChildLanes = NoLanes; // Bubble up the earliest expiration time.
        if ((completedWork.mode & ProfileMode) !== NoMode) {
            // In profiling mode, resetChildExpirationTime is also used to reset
            // profiler durations.
            var actualDuration = completedWork.actualDuration;
            var treeBaseDuration = completedWork.selfBaseDuration; // When a fiber is cloned, its actualDuration is reset to 0. This value will
            // only be updated if work is done on the fiber (i.e. it doesn't bailout).
            // When work is done, it should bubble to the parent's actualDuration. If
            // the fiber has not been cloned though, (meaning no work was done), then
            // this value will reflect the amount of time spent working on a previous
            // render. In that case it should not bubble. We determine whether it was
            // cloned by comparing the child pointer.
            var shouldBubbleActualDurations = completedWork.alternate === null || completedWork.child !== completedWork.alternate.child;
            var child = completedWork.child;
            while(child !== null){
                newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));
                if (shouldBubbleActualDurations) actualDuration += child.actualDuration;
                treeBaseDuration += child.treeBaseDuration;
                child = child.sibling;
            }
            var isTimedOutSuspense = completedWork.tag === SuspenseComponent && completedWork.memoizedState !== null;
            if (isTimedOutSuspense) {
                // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                var primaryChildFragment = completedWork.child;
                if (primaryChildFragment !== null) treeBaseDuration -= primaryChildFragment.treeBaseDuration;
            }
            completedWork.actualDuration = actualDuration;
            completedWork.treeBaseDuration = treeBaseDuration;
        } else {
            var _child = completedWork.child;
            while(_child !== null){
                newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
                _child = _child.sibling;
            }
        }
        completedWork.childLanes = newChildLanes;
    }
    function commitRoot(root) {
        var renderPriorityLevel = getCurrentPriorityLevel();
        runWithPriority$1(ImmediatePriority$1, commitRootImpl.bind(null, root, renderPriorityLevel));
        return null;
    }
    function commitRootImpl(root, renderPriorityLevel) {
        do // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
        // means `flushPassiveEffects` will sometimes result in additional
        // passive effects. So we need to keep flushing in a loop until there are
        // no more pending effects.
        // TODO: Might be better if `flushPassiveEffects` did not automatically
        // flush synchronous work at the end, to avoid factoring hazards like this.
        flushPassiveEffects();
        while (rootWithPendingPassiveEffects !== null);
        flushRenderPhaseStrictModeWarningsInDEV();
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Should not already be working.");
        var finishedWork = root.finishedWork;
        var lanes = root.finishedLanes;
        if (finishedWork === null) return null;
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        if (!(finishedWork !== root.current)) throw Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
         // commitRoot never returns a continuation; it always finishes synchronously.
        // So we can clear these now to allow a new callback to be scheduled.
        root.callbackNode = null; // Update the first and last pending times on this root. The new first
        // pending time is whatever is left on the root fiber.
        var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
        markRootFinished(root, remainingLanes); // Clear already finished discrete updates in case that a later call of
        // `flushDiscreteUpdates` starts a useless render pass which may cancels
        // a scheduled timeout.
        if (rootsWithPendingDiscreteUpdates !== null) {
            if (!hasDiscreteLanes(remainingLanes) && rootsWithPendingDiscreteUpdates.has(root)) rootsWithPendingDiscreteUpdates.delete(root);
        }
        if (root === workInProgressRoot) {
            // We can reset these now that they are finished.
            workInProgressRoot = null;
            workInProgress = null;
            workInProgressRootRenderLanes = NoLanes;
        } // Get the list of effects.
        var firstEffect;
        if (finishedWork.flags > PerformedWork) {
            // A fiber's effect list consists only of its children, not itself. So if
            // the root has an effect, we need to add it to the end of the list. The
            // resulting list is the set that would belong to the root's parent, if it
            // had one; that is, all the effects in the tree including the root.
            if (finishedWork.lastEffect !== null) {
                finishedWork.lastEffect.nextEffect = finishedWork;
                firstEffect = finishedWork.firstEffect;
            } else firstEffect = finishedWork;
        } else // There is no effect on the root.
        firstEffect = finishedWork.firstEffect;
        if (firstEffect !== null) {
            var prevExecutionContext = executionContext;
            executionContext |= CommitContext;
            var prevInteractions = pushInteractions(root); // Reset this to null before calling lifecycles
            ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
            // of the effect list for each phase: all mutation effects come before all
            // layout effects, and so on.
            // The first phase a "before mutation" phase. We use this phase to read the
            // state of the host tree right before we mutate it. This is where
            // getSnapshotBeforeUpdate is called.
            focusedInstanceHandle = prepareForCommit(root.containerInfo);
            shouldFireAfterActiveInstanceBlur = false;
            nextEffect = firstEffect;
            do {
                invokeGuardedCallback(null, commitBeforeMutationEffects, null);
                if (hasCaughtError()) {
                    if (!(nextEffect !== null)) throw Error("Should be working on an effect.");
                    var error = clearCaughtError();
                    captureCommitPhaseError(nextEffect, error);
                    nextEffect = nextEffect.nextEffect;
                }
            }while (nextEffect !== null); // We no longer need to track the active instance fiber
            focusedInstanceHandle = null;
            // Mark the current commit time to be shared by all Profilers in this
            // batch. This enables them to be grouped later.
            recordCommitTime();
            nextEffect = firstEffect;
            do {
                invokeGuardedCallback(null, commitMutationEffects, null, root, renderPriorityLevel);
                if (hasCaughtError()) {
                    if (!(nextEffect !== null)) throw Error("Should be working on an effect.");
                    var _error = clearCaughtError();
                    captureCommitPhaseError(nextEffect, _error);
                    nextEffect = nextEffect.nextEffect;
                }
            }while (nextEffect !== null);
            resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
            // the mutation phase, so that the previous tree is still current during
            // componentWillUnmount, but before the layout phase, so that the finished
            // work is current during componentDidMount/Update.
            root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
            // the host tree after it's been mutated. The idiomatic use case for this is
            // layout, but class component lifecycles also fire here for legacy reasons.
            nextEffect = firstEffect;
            do {
                invokeGuardedCallback(null, commitLayoutEffects, null, root, lanes);
                if (hasCaughtError()) {
                    if (!(nextEffect !== null)) throw Error("Should be working on an effect.");
                    var _error2 = clearCaughtError();
                    captureCommitPhaseError(nextEffect, _error2);
                    nextEffect = nextEffect.nextEffect;
                }
            }while (nextEffect !== null);
            nextEffect = null; // Tell Scheduler to yield at the end of the frame, so the browser has an
            // opportunity to paint.
            requestPaint();
            popInteractions(prevInteractions);
            executionContext = prevExecutionContext;
        } else {
            // No effects.
            root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
            recordCommitTime();
        }
        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
        if (rootDoesHavePassiveEffects) {
            // This commit has passive effects. Stash a reference to them. But don't
            // schedule a callback until after flushing layout work.
            rootDoesHavePassiveEffects = false;
            rootWithPendingPassiveEffects = root;
            pendingPassiveEffectsLanes = lanes;
            pendingPassiveEffectsRenderPriority = renderPriorityLevel;
        } else {
            // We are done with the effect chain at this point so let's clear the
            // nextEffect pointers to assist with GC. If we have passive effects, we'll
            // clear this in flushPassiveEffects.
            nextEffect = firstEffect;
            while(nextEffect !== null){
                var nextNextEffect = nextEffect.nextEffect;
                nextEffect.nextEffect = null;
                if (nextEffect.flags & Deletion) detachFiberAfterEffects(nextEffect);
                nextEffect = nextNextEffect;
            }
        } // Read this again, since an effect might have updated it
        remainingLanes = root.pendingLanes; // Check if there's remaining work on this root
        if (remainingLanes !== NoLanes) {
            if (spawnedWorkDuringRender !== null) {
                var expirationTimes = spawnedWorkDuringRender;
                spawnedWorkDuringRender = null;
                for(var i = 0; i < expirationTimes.length; i++)scheduleInteractions(root, expirationTimes[i], root.memoizedInteractions);
            }
            schedulePendingInteractions(root, remainingLanes);
        } else // If there's no remaining work, we can clear the set of already failed
        // error boundaries.
        legacyErrorBoundariesThatAlreadyFailed = null;
        if (!rootDidHavePassiveEffects) // If there are no passive effects, then we can complete the pending interactions.
        // Otherwise, we'll wait until after the passive effects are flushed.
        // Wait to do this until after remaining work has been scheduled,
        // so that we don't prematurely signal complete for interactions when there's e.g. hidden work.
        finishPendingInteractions(root, lanes);
        if (remainingLanes === SyncLane) {
            // Count the number of times the root synchronously re-renders without
            // finishing. If there are too many, it indicates an infinite update loop.
            if (root === rootWithNestedUpdates) nestedUpdateCount++;
            else {
                nestedUpdateCount = 0;
                rootWithNestedUpdates = root;
            }
        } else nestedUpdateCount = 0;
        onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
        onCommitRoot$1();
        // additional work on this root is scheduled.
        ensureRootIsScheduled(root, now());
        if (hasUncaughtError) {
            hasUncaughtError = false;
            var _error3 = firstUncaughtError;
            firstUncaughtError = null;
            throw _error3;
        }
        if ((executionContext & LegacyUnbatchedContext) !== NoContext) // a ReactDOM.render-ed root inside of batchedUpdates. The commit fired
        // synchronously, but layout updates should be deferred until the end
        // of the batch.
        return null;
         // If layout work was scheduled, flush it now.
        flushSyncCallbackQueue();
        return null;
    }
    function commitBeforeMutationEffects() {
        while(nextEffect !== null){
            var current = nextEffect.alternate;
            if (!shouldFireAfterActiveInstanceBlur && focusedInstanceHandle !== null) {
                if ((nextEffect.flags & Deletion) !== NoFlags) {
                    if (doesFiberContain(nextEffect, focusedInstanceHandle)) shouldFireAfterActiveInstanceBlur = true;
                } else // TODO: Move this out of the hot path using a dedicated effect tag.
                if (nextEffect.tag === SuspenseComponent && isSuspenseBoundaryBeingHidden(current, nextEffect) && doesFiberContain(nextEffect, focusedInstanceHandle)) shouldFireAfterActiveInstanceBlur = true;
            }
            var flags = nextEffect.flags;
            if ((flags & Snapshot) !== NoFlags) {
                setCurrentFiber(nextEffect);
                commitBeforeMutationLifeCycles(current, nextEffect);
                resetCurrentFiber();
            }
            if ((flags & Passive) !== NoFlags) // If there are passive effects, schedule a callback to flush at
            // the earliest opportunity.
            {
                if (!rootDoesHavePassiveEffects) {
                    rootDoesHavePassiveEffects = true;
                    scheduleCallback(NormalPriority$1, function() {
                        flushPassiveEffects();
                        return null;
                    });
                }
            }
            nextEffect = nextEffect.nextEffect;
        }
    }
    function commitMutationEffects(root, renderPriorityLevel) {
        // TODO: Should probably move the bulk of this function to commitWork.
        while(nextEffect !== null){
            setCurrentFiber(nextEffect);
            var flags = nextEffect.flags;
            if (flags & ContentReset) commitResetTextContent(nextEffect);
            if (flags & Ref) {
                var current = nextEffect.alternate;
                if (current !== null) commitDetachRef(current);
            } // The following switch statement is only concerned about placement,
            // updates, and deletions. To avoid needing to add a case for every possible
            // bitmap value, we remove the secondary effects from the effect tag and
            // switch on that value.
            var primaryFlags = flags & (Placement | Update | Deletion | Hydrating);
            switch(primaryFlags){
                case Placement:
                    commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
                    // inserted, before any life-cycles like componentDidMount gets called.
                    // TODO: findDOMNode doesn't rely on this any more but isMounted does
                    // and isMounted is deprecated anyway so we should be able to kill this.
                    nextEffect.flags &= ~Placement;
                    break;
                case PlacementAndUpdate:
                    // Placement
                    commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
                    // inserted, before any life-cycles like componentDidMount gets called.
                    nextEffect.flags &= ~Placement; // Update
                    var _current = nextEffect.alternate;
                    commitWork(_current, nextEffect);
                    break;
                case Hydrating:
                    nextEffect.flags &= ~Hydrating;
                    break;
                case HydratingAndUpdate:
                    nextEffect.flags &= ~Hydrating; // Update
                    var _current2 = nextEffect.alternate;
                    commitWork(_current2, nextEffect);
                    break;
                case Update:
                    var _current3 = nextEffect.alternate;
                    commitWork(_current3, nextEffect);
                    break;
                case Deletion:
                    commitDeletion(root, nextEffect);
                    break;
            }
            resetCurrentFiber();
            nextEffect = nextEffect.nextEffect;
        }
    }
    function commitLayoutEffects(root, committedLanes) {
        while(nextEffect !== null){
            setCurrentFiber(nextEffect);
            var flags = nextEffect.flags;
            if (flags & (Update | Callback)) {
                var current = nextEffect.alternate;
                commitLifeCycles(root, current, nextEffect);
            }
            if (flags & Ref) commitAttachRef(nextEffect);
            resetCurrentFiber();
            nextEffect = nextEffect.nextEffect;
        }
    }
    function flushPassiveEffects() {
        // Returns whether passive effects were flushed.
        if (pendingPassiveEffectsRenderPriority !== NoPriority$1) {
            var priorityLevel = pendingPassiveEffectsRenderPriority > NormalPriority$1 ? NormalPriority$1 : pendingPassiveEffectsRenderPriority;
            pendingPassiveEffectsRenderPriority = NoPriority$1;
            return runWithPriority$1(priorityLevel, flushPassiveEffectsImpl);
        }
        return false;
    }
    function enqueuePendingPassiveHookEffectMount(fiber, effect) {
        pendingPassiveHookEffectsMount.push(effect, fiber);
        if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback(NormalPriority$1, function() {
                flushPassiveEffects();
                return null;
            });
        }
    }
    function enqueuePendingPassiveHookEffectUnmount(fiber, effect) {
        pendingPassiveHookEffectsUnmount.push(effect, fiber);
        fiber.flags |= PassiveUnmountPendingDev;
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.flags |= PassiveUnmountPendingDev;
        if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback(NormalPriority$1, function() {
                flushPassiveEffects();
                return null;
            });
        }
    }
    function invokePassiveEffectCreate(effect) {
        var create = effect.create;
        effect.destroy = create();
    }
    function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) return false;
        var root = rootWithPendingPassiveEffects;
        var lanes = pendingPassiveEffectsLanes;
        rootWithPendingPassiveEffects = null;
        pendingPassiveEffectsLanes = NoLanes;
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Cannot flush passive effects while already rendering.");
        isFlushingPassiveEffects = true;
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        var prevInteractions = pushInteractions(root); // It's important that ALL pending passive effect destroy functions are called
        // before ANY passive effect create functions are called.
        // Otherwise effects in sibling components might interfere with each other.
        // e.g. a destroy function in one component may unintentionally override a ref
        // value set by a create function in another component.
        // Layout effects have the same constraint.
        // First pass: Destroy stale passive effects.
        var unmountEffects = pendingPassiveHookEffectsUnmount;
        pendingPassiveHookEffectsUnmount = [];
        for(var i = 0; i < unmountEffects.length; i += 2){
            var _effect = unmountEffects[i];
            var fiber = unmountEffects[i + 1];
            var destroy = _effect.destroy;
            _effect.destroy = undefined;
            fiber.flags &= ~PassiveUnmountPendingDev;
            var alternate = fiber.alternate;
            if (alternate !== null) alternate.flags &= ~PassiveUnmountPendingDev;
            if (typeof destroy === 'function') {
                setCurrentFiber(fiber);
                invokeGuardedCallback(null, destroy, null);
                if (hasCaughtError()) {
                    if (!(fiber !== null)) throw Error("Should be working on an effect.");
                    var error = clearCaughtError();
                    captureCommitPhaseError(fiber, error);
                }
                resetCurrentFiber();
            }
        } // Second pass: Create new passive effects.
        var mountEffects = pendingPassiveHookEffectsMount;
        pendingPassiveHookEffectsMount = [];
        for(var _i = 0; _i < mountEffects.length; _i += 2){
            var _effect2 = mountEffects[_i];
            var _fiber = mountEffects[_i + 1];
            setCurrentFiber(_fiber);
            invokeGuardedCallback(null, invokePassiveEffectCreate, null, _effect2);
            if (hasCaughtError()) {
                if (!(_fiber !== null)) throw Error("Should be working on an effect.");
                var _error4 = clearCaughtError();
                captureCommitPhaseError(_fiber, _error4);
            }
            resetCurrentFiber();
        } // Note: This currently assumes there are no passive effects on the root fiber
        // because the root is not part of its own effect list.
        // This could change in the future.
        var effect = root.current.firstEffect;
        while(effect !== null){
            var nextNextEffect = effect.nextEffect; // Remove nextEffect pointer to assist GC
            effect.nextEffect = null;
            if (effect.flags & Deletion) detachFiberAfterEffects(effect);
            effect = nextNextEffect;
        }
        popInteractions(prevInteractions);
        finishPendingInteractions(root, lanes);
        isFlushingPassiveEffects = false;
        executionContext = prevExecutionContext;
        flushSyncCallbackQueue(); // If additional passive effects were scheduled, increment a counter. If this
        // exceeds the limit, we'll fire a warning.
        nestedPassiveUpdateCount = rootWithPendingPassiveEffects === null ? 0 : nestedPassiveUpdateCount + 1;
        return true;
    }
    function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
    }
    function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) legacyErrorBoundariesThatAlreadyFailed = new Set([
            instance
        ]);
        else legacyErrorBoundariesThatAlreadyFailed.add(instance);
    }
    function prepareToThrowUncaughtError(error) {
        if (!hasUncaughtError) {
            hasUncaughtError = true;
            firstUncaughtError = error;
        }
    }
    var onUncaughtError = prepareToThrowUncaughtError;
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        var errorInfo = createCapturedValue(error, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
        enqueueUpdate(rootFiber, update);
        var eventTime = requestEventTime();
        var root = markUpdateLaneFromFiberToRoot(rootFiber, SyncLane);
        if (root !== null) {
            markRootUpdated(root, SyncLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
            schedulePendingInteractions(root, SyncLane);
        }
    }
    function captureCommitPhaseError(sourceFiber, error) {
        if (sourceFiber.tag === HostRoot) {
            // Error was thrown at the root. There is no parent, so the root
            // itself should capture it.
            captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
            return;
        }
        var fiber = sourceFiber.return;
        while(fiber !== null){
            if (fiber.tag === HostRoot) {
                captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error);
                return;
            } else if (fiber.tag === ClassComponent) {
                var ctor = fiber.type;
                var instance = fiber.stateNode;
                if (typeof ctor.getDerivedStateFromError === 'function' || typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                    var errorInfo = createCapturedValue(error, sourceFiber);
                    var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
                    enqueueUpdate(fiber, update);
                    var eventTime = requestEventTime();
                    var root = markUpdateLaneFromFiberToRoot(fiber, SyncLane);
                    if (root !== null) {
                        markRootUpdated(root, SyncLane, eventTime);
                        ensureRootIsScheduled(root, eventTime);
                        schedulePendingInteractions(root, SyncLane);
                    } else {
                        // This component has already been unmounted.
                        // We can't schedule any follow up work for the root because the fiber is already unmounted,
                        // but we can still call the log-only boundary so the error isn't swallowed.
                        //
                        // TODO This is only a temporary bandaid for the old reconciler fork.
                        // We can delete this special case once the new fork is merged.
                        if (typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance)) try {
                            instance.componentDidCatch(error, errorInfo);
                        } catch (errorToIgnore) {
                        // This is kind of an edge case.
                        }
                    }
                    return;
                }
            }
            fiber = fiber.return;
        }
    }
    function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;
        if (pingCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        pingCache.delete(wakeable);
        var eventTime = requestEventTime();
        markRootPinged(root, pingedLanes);
        if (workInProgressRoot === root && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
            // Received a ping at the same priority level at which we're currently
            // rendering. We might want to restart this render. This should mirror
            // the logic of whether or not a root suspends once it completes.
            // TODO: If we're rendering sync either due to Sync, Batched or expired,
            // we should probably never restart.
            // If we're suspended with delay, or if it's a retry, we'll always suspend
            // so we can always restart.
            if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) // Restart from the root.
            prepareFreshStack(root, NoLanes);
            else // Even though we can't restart right now, we might get an
            // opportunity later. So we mark this render as having a ping.
            workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
        }
        ensureRootIsScheduled(root, eventTime);
        schedulePendingInteractions(root, pingedLanes);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
        // The boundary fiber (a Suspense component or SuspenseList component)
        // previously was rendered in its fallback state. One of the promises that
        // suspended it has resolved, which means at least part of the tree was
        // likely unblocked. Try rendering again, at a new expiration time.
        if (retryLane === NoLane) retryLane = requestRetryLane(boundaryFiber);
         // TODO: Special case idle priority?
        var eventTime = requestEventTime();
        var root = markUpdateLaneFromFiberToRoot(boundaryFiber, retryLane);
        if (root !== null) {
            markRootUpdated(root, retryLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
            schedulePendingInteractions(root, retryLane);
        }
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = NoLane; // Default
        var retryCache;
        retryCache = boundaryFiber.stateNode;
        if (retryCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        retryCache.delete(wakeable);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    } // Computes the next Just Noticeable Difference (JND) boundary.
    // The theory is that a person can't tell the difference between small differences in time.
    // Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
    // difference in the experience. However, waiting for longer might mean that we can avoid
    // showing an intermediate loading state. The longer we have already waited, the harder it
    // is to tell small differences in time. Therefore, the longer we've already waited,
    // the longer we can wait additionally. At some point we have to give up though.
    // We pick a train model where the next boundary commits at a consistent schedule.
    // These particular numbers are vague estimates. We expect to adjust them based on research.
    function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
    }
    function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = null;
            throw Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        }
        if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.");
        }
    }
    function flushRenderPhaseStrictModeWarningsInDEV() {
        ReactStrictModeWarnings.flushLegacyContextWarning();
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
    }
    var didWarnStateUpdateForNotYetMountedComponent = null;
    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
        if ((executionContext & RenderContext) !== NoContext) // We let the other warning about render phase updates deal with this one.
        return;
        if (!(fiber.mode & (BlockingMode | ConcurrentMode))) return;
        var tag = fiber.tag;
        if (tag !== IndeterminateComponent && tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent && tag !== Block) // Only warn for user-defined components, not internal ones like Suspense.
        return;
         // We show the whole stack but dedupe on the top component's name because
        // the problematic code almost always lies inside that component.
        var componentName = getComponentName(fiber.type) || 'ReactComponent';
        if (didWarnStateUpdateForNotYetMountedComponent !== null) {
            if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) return;
            didWarnStateUpdateForNotYetMountedComponent.add(componentName);
        } else didWarnStateUpdateForNotYetMountedComponent = new Set([
            componentName
        ]);
        var previousFiber = current;
        try {
            setCurrentFiber(fiber);
            error("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally{
            if (previousFiber) setCurrentFiber(fiber);
            else resetCurrentFiber();
        }
    }
    var didWarnStateUpdateForUnmountedComponent = null;
    function warnAboutUpdateOnUnmountedFiberInDEV(fiber) {
        var tag = fiber.tag;
        if (tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent && tag !== Block) // Only warn for user-defined components, not internal ones like Suspense.
        return;
         // If there are pending passive effects unmounts for this Fiber,
        // we can assume that they would have prevented this update.
        if ((fiber.flags & PassiveUnmountPendingDev) !== NoFlags) return;
         // We show the whole stack but dedupe on the top component's name because
        // the problematic code almost always lies inside that component.
        var componentName = getComponentName(fiber.type) || 'ReactComponent';
        if (didWarnStateUpdateForUnmountedComponent !== null) {
            if (didWarnStateUpdateForUnmountedComponent.has(componentName)) return;
            didWarnStateUpdateForUnmountedComponent.add(componentName);
        } else didWarnStateUpdateForUnmountedComponent = new Set([
            componentName
        ]);
        if (isFlushingPassiveEffects) ;
        else {
            var previousFiber = current;
            try {
                setCurrentFiber(fiber);
                error("Can't perform a React state update on an unmounted component. This is a no-op, but it indicates a memory leak in your application. To fix, cancel all subscriptions and asynchronous tasks in %s.", tag === ClassComponent ? 'the componentWillUnmount method' : 'a useEffect cleanup function');
            } finally{
                if (previousFiber) setCurrentFiber(fiber);
                else resetCurrentFiber();
            }
        }
    }
    var beginWork$1;
    var dummyFiber = null;
    beginWork$1 = function(current, unitOfWork, lanes) {
        // If a component throws an error, we replay it again in a synchronously
        // dispatched event, so that the debugger will treat it as an uncaught
        // error See ReactErrorUtils for more information.
        // Before entering the begin phase, copy the work-in-progress onto a dummy
        // fiber. If beginWork throws, we'll use this to reset the state.
        var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
        try {
            return beginWork(current, unitOfWork, lanes);
        } catch (originalError) {
            if (originalError !== null && typeof originalError === 'object' && typeof originalError.then === 'function') // Don't replay promises. Treat everything else like an error.
            throw originalError;
             // Keep this code in sync with handleError; any changes here must have
            // corresponding changes there.
            resetContextDependencies();
            resetHooksAfterThrow(); // Don't reset current debug fiber, since we're about to work on the
            // same fiber again.
            // Unwind the failed stack frame
            unwindInterruptedWork(unitOfWork); // Restore the original properties of the fiber.
            assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
            if (unitOfWork.mode & ProfileMode) // Reset the profiler timer.
            startProfilerTimer(unitOfWork);
             // Run beginWork again.
            invokeGuardedCallback(null, beginWork, null, current, unitOfWork, lanes);
            if (hasCaughtError()) {
                var replayError = clearCaughtError(); // `invokeGuardedCallback` sometimes sets an expando `_suppressLogging`.
                // Rethrow this error instead of the original one.
                throw replayError;
            } else // This branch is reachable if the render phase is impure.
            throw originalError;
        }
    };
    var didWarnAboutUpdateInRender = false;
    var didWarnAboutUpdateInRenderForAnotherComponent;
    didWarnAboutUpdateInRenderForAnotherComponent = new Set();
    function warnAboutRenderPhaseUpdatesInDEV(fiber) {
        if (isRendering && (executionContext & RenderContext) !== NoContext && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                var renderingComponentName = workInProgress && getComponentName(workInProgress.type) || 'Unknown'; // Dedupe by the rendering component because it's the one that needs to be fixed.
                var dedupeKey = renderingComponentName;
                if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentName(fiber.type) || 'Unknown';
                    error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", setStateComponentName, renderingComponentName, renderingComponentName);
                }
                break;
            case ClassComponent:
                if (!didWarnAboutUpdateInRender) {
                    error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.");
                    didWarnAboutUpdateInRender = true;
                }
                break;
        }
    } // a 'shared' variable that changes when act() opens/closes in tests.
    var IsThisRendererActing = {
        current: false
    };
    function warnIfNotScopedWithMatchingAct(fiber) {
        if (IsSomeRendererActing.current === true && IsThisRendererActing.current !== true) {
            var previousFiber = current;
            try {
                setCurrentFiber(fiber);
                error("It looks like you're using the wrong act() around your test interactions.\nBe sure to use the matching version of act() corresponding to your renderer:\n\n// for react-dom:\nimport {act} from 'react-dom/test-utils';\n// ...\nact(() => ...);\n\n// for react-test-renderer:\nimport TestRenderer from react-test-renderer';\nconst {act} = TestRenderer;\n// ...\nact(() => ...);");
            } finally{
                if (previousFiber) setCurrentFiber(fiber);
                else resetCurrentFiber();
            }
        }
    }
    function warnIfNotCurrentlyActingEffectsInDEV(fiber) {
        if ((fiber.mode & StrictMode) !== NoMode && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) error("An update to %s ran an effect, but was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentName(fiber.type));
    }
    function warnIfNotCurrentlyActingUpdatesInDEV(fiber) {
        if (executionContext === NoContext && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) {
            var previousFiber = current;
            try {
                setCurrentFiber(fiber);
                error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentName(fiber.type));
            } finally{
                if (previousFiber) setCurrentFiber(fiber);
                else resetCurrentFiber();
            }
        }
    }
    var warnIfNotCurrentlyActingUpdatesInDev = warnIfNotCurrentlyActingUpdatesInDEV; // In tests, we want to enforce a mocked scheduler.
    var didWarnAboutUnmockedScheduler = false; // TODO Before we release concurrent mode, revisit this and decide whether a mocked
    // scheduler is the actual recommendation. The alternative could be a testing build,
    // a new lib, or whatever; we dunno just yet. This message is for early adopters
    // to get their tests right.
    function warnIfUnmockedScheduler(fiber) {
        if (didWarnAboutUnmockedScheduler === false && Scheduler.unstable_flushAllWithoutAsserting === undefined) {
            if (fiber.mode & BlockingMode || fiber.mode & ConcurrentMode) {
                didWarnAboutUnmockedScheduler = true;
                error("In Concurrent or Sync modes, the \"scheduler\" module needs to be mocked to guarantee consistent behaviour across tests and browsers. For example, with jest: \njest.mock('scheduler', () => require('scheduler/unstable_mock'));\n\nFor more info, visit https://reactjs.org/link/mock-scheduler");
            }
        }
    }
    function computeThreadID(root, lane) {
        // Interaction threads are unique per root and expiration time.
        // NOTE: Intentionally unsound cast. All that matters is that it's a number
        // and it represents a batch of work. Could make a helper function instead,
        // but meh this is fine for now.
        return lane * 1000 + root.interactionThreadID;
    }
    function markSpawnedWork(lane) {
        if (spawnedWorkDuringRender === null) spawnedWorkDuringRender = [
            lane
        ];
        else spawnedWorkDuringRender.push(lane);
    }
    function scheduleInteractions(root, lane, interactions) {
        if (interactions.size > 0) {
            var pendingInteractionMap = root.pendingInteractionMap;
            var pendingInteractions = pendingInteractionMap.get(lane);
            if (pendingInteractions != null) interactions.forEach(function(interaction) {
                if (!pendingInteractions.has(interaction)) // Update the pending async work count for previously unscheduled interaction.
                interaction.__count++;
                pendingInteractions.add(interaction);
            });
            else {
                pendingInteractionMap.set(lane, new Set(interactions)); // Update the pending async work count for the current interactions.
                interactions.forEach(function(interaction) {
                    interaction.__count++;
                });
            }
            var subscriber = tracing.__subscriberRef.current;
            if (subscriber !== null) {
                var threadID = computeThreadID(root, lane);
                subscriber.onWorkScheduled(interactions, threadID);
            }
        }
    }
    function schedulePendingInteractions(root, lane) {
        scheduleInteractions(root, lane, tracing.__interactionsRef.current);
    }
    function startWorkOnPendingInteractions(root, lanes) {
        // we can accurately attribute time spent working on it, And so that cascading
        // work triggered during the render phase will be associated with it.
        var interactions = new Set();
        root.pendingInteractionMap.forEach(function(scheduledInteractions, scheduledLane) {
            if (includesSomeLane(lanes, scheduledLane)) scheduledInteractions.forEach(function(interaction) {
                return interactions.add(interaction);
            });
        }); // Store the current set of interactions on the FiberRoot for a few reasons:
        // We can re-use it in hot functions like performConcurrentWorkOnRoot()
        // without having to recalculate it. We will also use it in commitWork() to
        // pass to any Profiler onRender() hooks. This also provides DevTools with a
        // way to access it when the onCommitRoot() hook is called.
        root.memoizedInteractions = interactions;
        if (interactions.size > 0) {
            var subscriber = tracing.__subscriberRef.current;
            if (subscriber !== null) {
                var threadID = computeThreadID(root, lanes);
                try {
                    subscriber.onWorkStarted(interactions, threadID);
                } catch (error) {
                    // If the subscriber throws, rethrow it in a separate task
                    scheduleCallback(ImmediatePriority$1, function() {
                        throw error;
                    });
                }
            }
        }
    }
    function finishPendingInteractions(root, committedLanes) {
        var remainingLanesAfterCommit = root.pendingLanes;
        var subscriber;
        try {
            subscriber = tracing.__subscriberRef.current;
            if (subscriber !== null && root.memoizedInteractions.size > 0) {
                // FIXME: More than one lane can finish in a single commit.
                var threadID = computeThreadID(root, committedLanes);
                subscriber.onWorkStopped(root.memoizedInteractions, threadID);
            }
        } catch (error) {
            // If the subscriber throws, rethrow it in a separate task
            scheduleCallback(ImmediatePriority$1, function() {
                throw error;
            });
        } finally{
            // Clear completed interactions from the pending Map.
            // Unless the render was suspended or cascading work was scheduled,
            // In which case– leave pending interactions until the subsequent render.
            var pendingInteractionMap = root.pendingInteractionMap;
            pendingInteractionMap.forEach(function(scheduledInteractions, lane) {
                // Only decrement the pending interaction count if we're done.
                // If there's still work at the current priority,
                // That indicates that we are waiting for suspense data.
                if (!includesSomeLane(remainingLanesAfterCommit, lane)) {
                    pendingInteractionMap.delete(lane);
                    scheduledInteractions.forEach(function(interaction) {
                        interaction.__count--;
                        if (subscriber !== null && interaction.__count === 0) try {
                            subscriber.onInteractionScheduledWorkCompleted(interaction);
                        } catch (error) {
                            // If the subscriber throws, rethrow it in a separate task
                            scheduleCallback(ImmediatePriority$1, function() {
                                throw error;
                            });
                        }
                    });
                }
            });
        }
    } // `act` testing API
    function shouldForceFlushFallbacksInDEV() {
        // Never force flush in production. This function should get stripped out.
        return actingUpdatesScopeDepth > 0;
    }
    // so we can tell if any async act() calls try to run in parallel.
    var actingUpdatesScopeDepth = 0;
    function detachFiberAfterEffects(fiber) {
        fiber.sibling = null;
        fiber.stateNode = null;
    }
    var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.
    var failedBoundaries = null;
    var setRefreshHandler = function(handler) {
        resolveFamily = handler;
    };
    function resolveFunctionForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) return type;
         // Use the latest known implementation.
        return family.current;
    }
    function resolveClassForHotReloading(type) {
        // No implementation differences.
        return resolveFunctionForHotReloading(type);
    }
    function resolveForwardRefForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) {
            // Check if we're dealing with a real forwardRef. Don't want to crash early.
            if (type !== null && type !== undefined && typeof type.render === 'function') {
                // ForwardRef is special because its resolved .type is an object,
                // but it's possible that we only have its inner render function in the map.
                // If that inner render function is different, we'll build a new forwardRef type.
                var currentRender = resolveFunctionForHotReloading(type.render);
                if (type.render !== currentRender) {
                    var syntheticType = {
                        $$typeof: REACT_FORWARD_REF_TYPE,
                        render: currentRender
                    };
                    if (type.displayName !== undefined) syntheticType.displayName = type.displayName;
                    return syntheticType;
                }
            }
            return type;
        } // Use the latest known implementation.
        return family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return false;
        var prevType = fiber.elementType;
        var nextType = element.type; // If we got here, we know types aren't === equal.
        var needsCompareFamilies = false;
        var $$typeofNextType = typeof nextType === 'object' && nextType !== null ? nextType.$$typeof : null;
        switch(fiber.tag){
            case ClassComponent:
                if (typeof nextType === 'function') needsCompareFamilies = true;
                break;
            case FunctionComponent:
                if (typeof nextType === 'function') needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) // We don't know the inner type yet.
                // We're going to assume that the lazy inner type is stable,
                // and so it is sufficient to avoid reconciling it away.
                // We're not going to unwrap or actually use the new lazy type.
                needsCompareFamilies = true;
                break;
            case ForwardRef:
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            case MemoComponent:
            case SimpleMemoComponent:
                if ($$typeofNextType === REACT_MEMO_TYPE) // TODO: if it was but can no longer be simple,
                // we shouldn't set this.
                needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            default:
                return false;
        } // Check if both types have a family and it's the same one.
        if (needsCompareFamilies) {
            // Note: memo() and forwardRef() we'll compare outer rather than inner type.
            // This means both of them need to be registered to preserve state.
            // If we unwrapped and compared the inner types for wrappers instead,
            // then we would risk falsely saying two separate memo(Foo)
            // calls are equivalent because they wrap the same Foo function.
            var prevFamily = resolveFamily(prevType);
            if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) return true;
        }
        return false;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        if (typeof WeakSet !== 'function') return;
        if (failedBoundaries === null) failedBoundaries = new WeakSet();
        failedBoundaries.add(fiber);
    }
    var scheduleRefresh = function(root, update) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        var staleFamilies = update.staleFamilies, updatedFamilies = update.updatedFamilies;
        flushPassiveEffects();
        flushSync(function() {
            scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
        });
    };
    var scheduleRoot = function(root, element) {
        if (root.context !== emptyContextObject) // Super edge case: root has a legacy _renderSubtree context
        // but we don't know the parentComponent so we can't pass it.
        // Just ignore. We'll delete this with _renderSubtree code path later.
        return;
        flushPassiveEffects();
        flushSync(function() {
            updateContainer(element, root, null, null);
        });
    };
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        var alternate = fiber.alternate, child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        if (resolveFamily === null) throw new Error('Expected resolveFamily to be set during hot reload.');
        var needsRender = false;
        var needsRemount = false;
        if (candidateType !== null) {
            var family = resolveFamily(candidateType);
            if (family !== undefined) {
                if (staleFamilies.has(family)) needsRemount = true;
                else if (updatedFamilies.has(family)) {
                    if (tag === ClassComponent) needsRemount = true;
                    else needsRender = true;
                }
            }
        }
        if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) needsRemount = true;
        }
        if (needsRemount) fiber._debugNeedsRemount = true;
        if (needsRemount || needsRender) scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        if (child !== null && !needsRemount) scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
        if (sibling !== null) scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
    }
    var findHostInstancesForRefresh = function(root, families) {
        var hostInstances = new Set();
        var types = new Set(families.map(function(family) {
            return family.current;
        }));
        findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
        return hostInstances;
    };
    function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
        var child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        var didMatch = false;
        if (candidateType !== null) {
            if (types.has(candidateType)) didMatch = true;
        }
        if (didMatch) // We have a match. This only drills down to the closest host components.
        // There's no need to search deeper because for the purpose of giving
        // visual feedback, "flashing" outermost parent rectangles is sufficient.
        findHostInstancesForFiberShallowly(fiber, hostInstances);
        else // If there's no match, maybe there will be one further down in the child tree.
        if (child !== null) findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
        if (sibling !== null) findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
    }
    function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
        if (foundHostInstances) return;
         // If we didn't find any host children, fallback to closest host parent.
        var node = fiber;
        while(true){
            switch(node.tag){
                case HostComponent:
                    hostInstances.add(node.stateNode);
                    return;
                case HostPortal:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
                case HostRoot:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
            }
            if (node.return === null) throw new Error('Expected to reach root first.');
            node = node.return;
        }
    }
    function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        var node = fiber;
        var foundHostInstances = false;
        while(true){
            if (node.tag === HostComponent) {
                // We got a match.
                foundHostInstances = true;
                hostInstances.add(node.stateNode); // There may still be more, so keep searching.
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === fiber) return foundHostInstances;
            while(node.sibling === null){
                if (node.return === null || node.return === fiber) return foundHostInstances;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return false;
    }
    var hasBadMapPolyfill;
    hasBadMapPolyfill = false;
    try {
        var nonExtensibleObject = Object.preventExtensions({});
        /* eslint-disable no-new */ new Map([
            [
                nonExtensibleObject,
                null
            ]
        ]);
        new Set([
            nonExtensibleObject
        ]);
    /* eslint-enable no-new */ } catch (e) {
        // TODO: Consider warning about bad polyfills
        hasBadMapPolyfill = true;
    }
    var debugCounter = 1;
    function FiberNode(tag, pendingProps, key, mode) {
        // Instance
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null; // Fiber
        this.return = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode; // Effects
        this.flags = NoFlags;
        this.nextEffect = null;
        this.firstEffect = null;
        this.lastEffect = null;
        this.lanes = NoLanes;
        this.childLanes = NoLanes;
        this.alternate = null;
        // Note: The following is done to avoid a v8 performance cliff.
        //
        // Initializing the fields below to smis and later updating them with
        // double values will cause Fibers to end up having separate shapes.
        // This behavior/bug has something to do with Object.preventExtension().
        // Fortunately this only impacts DEV builds.
        // Unfortunately it makes React unusably slow for some applications.
        // To work around this, initialize the fields below with doubles.
        //
        // Learn more about this here:
        // https://github.com/facebook/react/issues/14365
        // https://bugs.chromium.org/p/v8/issues/detail?id=8538
        this.actualDuration = Number.NaN;
        this.actualStartTime = Number.NaN;
        this.selfBaseDuration = Number.NaN;
        this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
        // This won't trigger the performance cliff mentioned above,
        // and it simplifies other profiler code (including DevTools).
        this.actualDuration = 0;
        this.actualStartTime = -1;
        this.selfBaseDuration = 0;
        this.treeBaseDuration = 0;
        // This isn't directly used but is handy for debugging internals:
        this._debugID = debugCounter++;
        this._debugSource = null;
        this._debugOwner = null;
        this._debugNeedsRemount = false;
        this._debugHookTypes = null;
        if (!hasBadMapPolyfill && typeof Object.preventExtensions === 'function') Object.preventExtensions(this);
    } // This is a constructor function, rather than a POJO constructor, still
    // please ensure we do the following:
    // 1) Nobody should add any instance methods on this. Instance methods can be
    //    more difficult to predict when they get optimized and they are almost
    //    never inlined properly in static compilers.
    // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
    //    always know when it is a fiber.
    // 3) We might want to experiment with using numeric keys since they are easier
    //    to optimize in a non-JIT environment.
    // 4) We can easily go from a constructor to a createFiber object literal if that
    //    is faster.
    // 5) It should be easy to port this to a C struct and keep a C implementation
    //    compatible.
    var createFiber = function(tag, pendingProps, key, mode) {
        // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
        return new FiberNode(tag, pendingProps, key, mode);
    };
    function shouldConstruct$1(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function isSimpleFunctionComponent(type) {
        return typeof type === 'function' && !shouldConstruct$1(type) && type.defaultProps === undefined;
    }
    function resolveLazyComponentTag(Component) {
        if (typeof Component === 'function') return shouldConstruct$1(Component) ? ClassComponent : FunctionComponent;
        else if (Component !== undefined && Component !== null) {
            var $$typeof = Component.$$typeof;
            if ($$typeof === REACT_FORWARD_REF_TYPE) return ForwardRef;
            if ($$typeof === REACT_MEMO_TYPE) return MemoComponent;
        }
        return IndeterminateComponent;
    } // This is used to create an alternate fiber to do work on.
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        if (workInProgress === null) {
            // We use a double buffering pooling technique because we know that we'll
            // only ever need at most two versions of a tree. We pool the "other" unused
            // node that we're free to reuse. This is lazily created to avoid allocating
            // extra objects for things that are never updated. It also allow us to
            // reclaim the extra memory if needed.
            workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
            workInProgress.elementType = current.elementType;
            workInProgress.type = current.type;
            workInProgress.stateNode = current.stateNode;
            // DEV-only fields
            workInProgress._debugID = current._debugID;
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
            workInProgress._debugHookTypes = current._debugHookTypes;
            workInProgress.alternate = current;
            current.alternate = workInProgress;
        } else {
            workInProgress.pendingProps = pendingProps; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // We already have an alternate.
            // Reset the effect tag.
            workInProgress.flags = NoFlags; // The effect list is no longer valid.
            workInProgress.nextEffect = null;
            workInProgress.firstEffect = null;
            workInProgress.lastEffect = null;
            // We intentionally reset, rather than copy, actualDuration & actualStartTime.
            // This prevents time from endlessly accumulating in new commits.
            // This has the downside of resetting values for different priority renders,
            // But works for yielding (the common case) and should support resuming.
            workInProgress.actualDuration = 0;
            workInProgress.actualStartTime = -1;
        }
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
        // it cannot be shared with the current fiber.
        var currentDependencies = current.dependencies;
        workInProgress.dependencies = currentDependencies === null ? null : {
            lanes: currentDependencies.lanes,
            firstContext: currentDependencies.firstContext
        }; // These will be overridden during the parent's reconciliation
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.selfBaseDuration = current.selfBaseDuration;
        workInProgress.treeBaseDuration = current.treeBaseDuration;
        workInProgress._debugNeedsRemount = current._debugNeedsRemount;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case ClassComponent:
                workInProgress.type = resolveClassForHotReloading(current.type);
                break;
            case ForwardRef:
                workInProgress.type = resolveForwardRefForHotReloading(current.type);
                break;
        }
        return workInProgress;
    } // Used to reuse a Fiber for a second pass.
    function resetWorkInProgress(workInProgress, renderLanes) {
        // This resets the Fiber to what createFiber or createWorkInProgress would
        // have set the values to before during the first pass. Ideally this wouldn't
        // be necessary but unfortunately many code paths reads from the workInProgress
        // when they should be reading from current and writing to workInProgress.
        // We assume pendingProps, index, key, ref, return are still untouched to
        // avoid doing another reconciliation.
        // Reset the effect tag but keep any Placement tags, since that's something
        // that child fiber is setting, not the reconciliation.
        workInProgress.flags &= Placement; // The effect list is no longer valid.
        workInProgress.nextEffect = null;
        workInProgress.firstEffect = null;
        workInProgress.lastEffect = null;
        var current = workInProgress.alternate;
        if (current === null) {
            // Reset to createFiber's initial values.
            workInProgress.childLanes = NoLanes;
            workInProgress.lanes = renderLanes;
            workInProgress.child = null;
            workInProgress.memoizedProps = null;
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null;
            workInProgress.dependencies = null;
            workInProgress.stateNode = null;
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = 0;
            workInProgress.treeBaseDuration = 0;
        } else {
            // Reset to the cloned values that createWorkInProgress would've.
            workInProgress.childLanes = current.childLanes;
            workInProgress.lanes = current.lanes;
            workInProgress.child = current.child;
            workInProgress.memoizedProps = current.memoizedProps;
            workInProgress.memoizedState = current.memoizedState;
            workInProgress.updateQueue = current.updateQueue; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // Clone the dependencies object. This is mutated during the render phase, so
            // it cannot be shared with the current fiber.
            var currentDependencies = current.dependencies;
            workInProgress.dependencies = currentDependencies === null ? null : {
                lanes: currentDependencies.lanes,
                firstContext: currentDependencies.firstContext
            };
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        return workInProgress;
    }
    function createHostRootFiber(tag) {
        var mode;
        if (tag === ConcurrentRoot) mode = ConcurrentMode | BlockingMode | StrictMode;
        else if (tag === BlockingRoot) mode = BlockingMode | StrictMode;
        else mode = NoMode;
        if (isDevToolsPresent) // Always collect profile timings when DevTools are present.
        // This enables DevTools to start capturing timing at any point–
        // Without some nodes in the tree having empty base times.
        mode |= ProfileMode;
        return createFiber(HostRoot, null, null, mode);
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.
        var resolvedType = type;
        if (typeof type === 'function') {
            if (shouldConstruct$1(type)) {
                fiberTag = ClassComponent;
                resolvedType = resolveClassForHotReloading(resolvedType);
            } else resolvedType = resolveFunctionForHotReloading(resolvedType);
        } else if (typeof type === 'string') fiberTag = HostComponent;
        else getTag: switch(type){
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, lanes, key);
            case REACT_DEBUG_TRACING_MODE_TYPE:
                fiberTag = Mode;
                mode |= DebugTracingMode;
                break;
            case REACT_STRICT_MODE_TYPE:
                fiberTag = Mode;
                mode |= StrictMode;
                break;
            case REACT_PROFILER_TYPE:
                return createFiberFromProfiler(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_TYPE:
                return createFiberFromSuspense(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_LIST_TYPE:
                return createFiberFromSuspenseList(pendingProps, mode, lanes, key);
            case REACT_OFFSCREEN_TYPE:
                return createFiberFromOffscreen(pendingProps, mode, lanes, key);
            case REACT_LEGACY_HIDDEN_TYPE:
                return createFiberFromLegacyHidden(pendingProps, mode, lanes, key);
            case REACT_SCOPE_TYPE:
            // eslint-disable-next-line no-fallthrough
            default:
                if (typeof type === 'object' && type !== null) switch(type.$$typeof){
                    case REACT_PROVIDER_TYPE:
                        fiberTag = ContextProvider;
                        break getTag;
                    case REACT_CONTEXT_TYPE:
                        // This is a consumer
                        fiberTag = ContextConsumer;
                        break getTag;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = ForwardRef;
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        break getTag;
                    case REACT_MEMO_TYPE:
                        fiberTag = MemoComponent;
                        break getTag;
                    case REACT_LAZY_TYPE:
                        fiberTag = LazyComponent;
                        resolvedType = null;
                        break getTag;
                    case REACT_BLOCK_TYPE:
                        fiberTag = Block;
                        break getTag;
                }
                var info = '';
                if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                var ownerName = owner ? getComponentName(owner.type) : null;
                if (ownerName) info += '\n\nCheck the render method of `' + ownerName + '`.';
                throw Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (type == null ? type : typeof type) + "." + info);
        }
        var fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.lanes = lanes;
        fiber._debugOwner = owner;
        return fiber;
    }
    function createFiberFromElement(element, mode, lanes) {
        var owner = null;
        owner = element._owner;
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes);
        fiber._debugSource = element._source;
        fiber._debugOwner = element._owner;
        return fiber;
    }
    function createFiberFromFragment(elements, mode, lanes, key) {
        var fiber = createFiber(Fragment, elements, key, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromProfiler(pendingProps, mode, lanes, key) {
        if (typeof pendingProps.id !== 'string') error('Profiler must specify an "id" as a prop');
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode); // TODO: The Profiler fiber shouldn't have a type. It has a tag.
        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.type = REACT_PROFILER_TYPE;
        fiber.lanes = lanes;
        fiber.stateNode = {
            effectDuration: 0,
            passiveEffectDuration: 0
        };
        return fiber;
    }
    function createFiberFromSuspense(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode); // TODO: The SuspenseComponent fiber shouldn't have a type. It has a tag.
        // This needs to be fixed in getComponentName so that it relies on the tag
        // instead.
        fiber.type = REACT_SUSPENSE_TYPE;
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
        // TODO: The SuspenseListComponent fiber shouldn't have a type. It has a tag.
        // This needs to be fixed in getComponentName so that it relies on the tag
        // instead.
        fiber.type = REACT_SUSPENSE_LIST_TYPE;
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
        var fiber = createFiber(OffscreenComponent, pendingProps, key, mode); // TODO: The OffscreenComponent fiber shouldn't have a type. It has a tag.
        fiber.type = REACT_OFFSCREEN_TYPE;
        fiber.elementType = REACT_OFFSCREEN_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromLegacyHidden(pendingProps, mode, lanes, key) {
        var fiber = createFiber(LegacyHiddenComponent, pendingProps, key, mode); // TODO: The LegacyHidden fiber shouldn't have a type. It has a tag.
        fiber.type = REACT_LEGACY_HIDDEN_TYPE;
        fiber.elementType = REACT_LEGACY_HIDDEN_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromText(content, mode, lanes) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoMode); // TODO: These should not need a type.
        fiber.elementType = 'DELETED';
        fiber.type = 'DELETED';
        return fiber;
    }
    function createFiberFromPortal(portal, mode, lanes) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.lanes = lanes;
        fiber.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            // Used by persistent updates
            implementation: portal.implementation
        };
        return fiber;
    } // Used for stashing WIP properties to replay failed work in DEV.
    function assignFiberPropertiesInDEV(target, source) {
        if (target === null) // This Fiber's initial properties will always be overwritten.
        // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
        target = createFiber(IndeterminateComponent, null, null, NoMode);
         // This is intentionally written as a list of all properties.
        // We tried to use Object.assign() instead but this is called in
        // the hottest path, and Object.assign() was too slow:
        // https://github.com/facebook/react/issues/12502
        // This code is DEV-only so size is not a concern.
        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target.return = source.return;
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.dependencies = source.dependencies;
        target.mode = source.mode;
        target.flags = source.flags;
        target.nextEffect = source.nextEffect;
        target.firstEffect = source.firstEffect;
        target.lastEffect = source.lastEffect;
        target.lanes = source.lanes;
        target.childLanes = source.childLanes;
        target.alternate = source.alternate;
        target.actualDuration = source.actualDuration;
        target.actualStartTime = source.actualStartTime;
        target.selfBaseDuration = source.selfBaseDuration;
        target.treeBaseDuration = source.treeBaseDuration;
        target._debugID = source._debugID;
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugNeedsRemount = source._debugNeedsRemount;
        target._debugHookTypes = source._debugHookTypes;
        return target;
    }
    function FiberRootNode(containerInfo, tag, hydrate) {
        this.tag = tag;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.current = null;
        this.pingCache = null;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.hydrate = hydrate;
        this.callbackNode = null;
        this.callbackPriority = NoLanePriority;
        this.eventTimes = createLaneMap(NoLanes);
        this.expirationTimes = createLaneMap(NoTimestamp);
        this.pendingLanes = NoLanes;
        this.suspendedLanes = NoLanes;
        this.pingedLanes = NoLanes;
        this.expiredLanes = NoLanes;
        this.mutableReadLanes = NoLanes;
        this.finishedLanes = NoLanes;
        this.entangledLanes = NoLanes;
        this.entanglements = createLaneMap(NoLanes);
        this.mutableSourceEagerHydrationData = null;
        this.interactionThreadID = tracing.unstable_getThreadID();
        this.memoizedInteractions = new Set();
        this.pendingInteractionMap = new Map();
        switch(tag){
            case BlockingRoot:
                this._debugRootType = 'createBlockingRoot()';
                break;
            case ConcurrentRoot:
                this._debugRootType = 'createRoot()';
                break;
            case LegacyRoot:
                this._debugRootType = 'createLegacyRoot()';
                break;
        }
    }
    function createFiberRoot(containerInfo, tag, hydrate, hydrationCallbacks) {
        var root = new FiberRootNode(containerInfo, tag, hydrate);
        // stateNode is any.
        var uninitializedFiber = createHostRootFiber(tag);
        root.current = uninitializedFiber;
        uninitializedFiber.stateNode = root;
        initializeUpdateQueue(uninitializedFiber);
        return root;
    }
    // This ensures that the version used for server rendering matches the one
    // that is eventually read during hydration.
    // If they don't match there's a potential tear and a full deopt render is required.
    function registerMutableSourceForHydration(root, mutableSource) {
        var getVersion = mutableSource._getVersion;
        var version = getVersion(mutableSource._source); // TODO Clear this data once all pending hydration work is finished.
        // Retaining it forever may interfere with GC.
        if (root.mutableSourceEagerHydrationData == null) root.mutableSourceEagerHydrationData = [
            mutableSource,
            version
        ];
        else root.mutableSourceEagerHydrationData.push(mutableSource, version);
    }
    function createPortal(children, containerInfo, implementation) {
        var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        return {
            // This tag allow us to uniquely identify this as a React Portal
            $$typeof: REACT_PORTAL_TYPE,
            key: key == null ? null : '' + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    }
    var didWarnAboutNestedUpdates;
    var didWarnAboutFindNodeInStrictMode;
    didWarnAboutNestedUpdates = false;
    didWarnAboutFindNodeInStrictMode = {};
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);
        if (fiber.tag === ClassComponent) {
            var Component = fiber.type;
            if (isContextProvider(Component)) return processChildContext(fiber, Component, parentContext);
        }
        return parentContext;
    }
    function findHostInstanceWithWarning(component, methodName) {
        var fiber = get(component);
        if (fiber === undefined) {
            if (typeof component.render === 'function') throw Error("Unable to find node on an unmounted component.");
            else throw Error("Argument appears to not be a ReactComponent. Keys: " + Object.keys(component));
        }
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.mode & StrictMode) {
            var componentName = getComponentName(fiber.type) || 'Component';
            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
                didWarnAboutFindNodeInStrictMode[componentName] = true;
                var previousFiber = current;
                try {
                    setCurrentFiber(hostFiber);
                    if (fiber.mode & StrictMode) error("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                    else error("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                } finally{
                    // Ideally this should reset to previous but this shouldn't be called in
                    // render and there's another warning for that anyway.
                    if (previousFiber) setCurrentFiber(previousFiber);
                    else resetCurrentFiber();
                }
            }
        }
        return hostFiber.stateNode;
    }
    function createContainer(containerInfo, tag, hydrate, hydrationCallbacks) {
        return createFiberRoot(containerInfo, tag, hydrate);
    }
    function updateContainer(element, container, parentComponent, callback) {
        onScheduleRoot(container, element);
        var current$1 = container.current;
        var eventTime = requestEventTime();
        // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
        if ('undefined' !== typeof jest) {
            warnIfUnmockedScheduler(current$1);
            warnIfNotScopedWithMatchingAct(current$1);
        }
        var lane = requestUpdateLane(current$1);
        var context = getContextForSubtree(parentComponent);
        if (container.context === null) container.context = context;
        else container.pendingContext = context;
        if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentName(current.type) || 'Unknown');
        }
        var update = createUpdate(eventTime, lane); // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: element
        };
        callback = callback === undefined ? null : callback;
        if (callback !== null) {
            if (typeof callback !== 'function') error("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callback);
            update.callback = callback;
        }
        enqueueUpdate(current$1, update);
        scheduleUpdateOnFiber(current$1, lane, eventTime);
        return lane;
    }
    function getPublicRootInstance(container) {
        var containerFiber = container.current;
        if (!containerFiber.child) return null;
        switch(containerFiber.child.tag){
            case HostComponent:
                return getPublicInstance(containerFiber.child.stateNode);
            default:
                return containerFiber.child.stateNode;
        }
    }
    function markRetryLaneImpl(fiber, retryLane) {
        var suspenseState = fiber.memoizedState;
        if (suspenseState !== null && suspenseState.dehydrated !== null) suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
    } // Increases the priority of thennables when they resolve within this boundary.
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        var alternate = fiber.alternate;
        if (alternate) markRetryLaneImpl(alternate, retryLane);
    }
    function attemptUserBlockingHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        var eventTime = requestEventTime();
        var lane = InputDiscreteHydrationLane;
        scheduleUpdateOnFiber(fiber, lane, eventTime);
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function attemptContinuousHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        var eventTime = requestEventTime();
        var lane = SelectiveHydrationLane;
        scheduleUpdateOnFiber(fiber, lane, eventTime);
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function attemptHydrationAtCurrentPriority$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority other than synchronously flush it.
        return;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(fiber);
        scheduleUpdateOnFiber(fiber, lane, eventTime);
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function runWithPriority$2(priority, fn) {
        setCurrentUpdateLanePriority(priority);
        return fn();
    }
    function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.tag === FundamentalComponent) return hostFiber.stateNode.instance;
        return hostFiber.stateNode;
    }
    var shouldSuspendImpl = function(fiber) {
        return false;
    };
    function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
    }
    var overrideHookState = null;
    var overrideHookStateDeletePath = null;
    var overrideHookStateRenamePath = null;
    var overrideProps = null;
    var overridePropsDeletePath = null;
    var overridePropsRenamePath = null;
    var scheduleUpdate = null;
    var setSuspenseHandler = null;
    var copyWithDeleteImpl = function(obj, path, index) {
        var key = path[index];
        var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj);
        if (index + 1 === path.length) {
            if (Array.isArray(updated)) updated.splice(key, 1);
            else delete updated[key];
            return updated;
        } // $FlowFixMe number or string is fine here
        updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
        return updated;
    };
    var copyWithDelete = function(obj, path) {
        return copyWithDeleteImpl(obj, path, 0);
    };
    var copyWithRenameImpl = function(obj, oldPath, newPath, index) {
        var oldKey = oldPath[index];
        var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj);
        if (index + 1 === oldPath.length) {
            var newKey = newPath[index]; // $FlowFixMe number or string is fine here
            updated[newKey] = updated[oldKey];
            if (Array.isArray(updated)) updated.splice(oldKey, 1);
            else delete updated[oldKey];
        } else // $FlowFixMe number or string is fine here
        updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index + 1);
        return updated;
    };
    var copyWithRename = function(obj, oldPath, newPath) {
        if (oldPath.length !== newPath.length) {
            warn('copyWithRename() expects paths of the same length');
            return;
        } else {
            for(var i = 0; i < newPath.length - 1; i++)if (oldPath[i] !== newPath[i]) {
                warn('copyWithRename() expects paths to be the same except for the deepest key');
                return;
            }
        }
        return copyWithRenameImpl(obj, oldPath, newPath, 0);
    };
    var copyWithSetImpl = function(obj, path, index, value) {
        if (index >= path.length) return value;
        var key = path[index];
        var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj); // $FlowFixMe number or string is fine here
        updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
        return updated;
    };
    var copyWithSet = function(obj, path, value) {
        return copyWithSetImpl(obj, path, 0, value);
    };
    var findHook = function(fiber, id) {
        // For now, the "id" of stateful hooks is just the stateful hook index.
        // This may change in the future with e.g. nested hooks.
        var currentHook = fiber.memoizedState;
        while(currentHook !== null && id > 0){
            currentHook = currentHook.next;
            id--;
        }
        return currentHook;
    }; // Support DevTools editable values for useState and useReducer.
    overrideHookState = function(fiber, id, path, value) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithSet(hook.memoizedState, path, value);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = _assign({}, fiber.memoizedProps);
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateDeletePath = function(fiber, id, path) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithDelete(hook.memoizedState, path);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = _assign({}, fiber.memoizedProps);
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateRenamePath = function(fiber, id, oldPath, newPath) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = _assign({}, fiber.memoizedProps);
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        }
    }; // Support DevTools props for function components, forwardRef, memo, host components, etc.
    overrideProps = function(fiber, path, value) {
        fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    };
    overridePropsDeletePath = function(fiber, path) {
        fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    };
    overridePropsRenamePath = function(fiber, oldPath, newPath) {
        fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    };
    scheduleUpdate = function(fiber) {
        scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
        shouldSuspendImpl = newShouldSuspendImpl;
    };
    function findHostInstanceByFiber(fiber) {
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    function emptyFindFiberByHostInstance(instance) {
        return null;
    }
    function getCurrentFiberForDevTools() {
        return current;
    }
    function injectIntoDevTools(devToolsConfig) {
        var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals({
            bundleType: devToolsConfig.bundleType,
            version: devToolsConfig.version,
            rendererPackageName: devToolsConfig.rendererPackageName,
            rendererConfig: devToolsConfig.rendererConfig,
            overrideHookState: overrideHookState,
            overrideHookStateDeletePath: overrideHookStateDeletePath,
            overrideHookStateRenamePath: overrideHookStateRenamePath,
            overrideProps: overrideProps,
            overridePropsDeletePath: overridePropsDeletePath,
            overridePropsRenamePath: overridePropsRenamePath,
            setSuspenseHandler: setSuspenseHandler,
            scheduleUpdate: scheduleUpdate,
            currentDispatcherRef: ReactCurrentDispatcher,
            findHostInstanceByFiber: findHostInstanceByFiber,
            findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
            // React Refresh
            findHostInstancesForRefresh: findHostInstancesForRefresh,
            scheduleRefresh: scheduleRefresh,
            scheduleRoot: scheduleRoot,
            setRefreshHandler: setRefreshHandler,
            // Enables DevTools to append owner stacks to error messages in DEV mode.
            getCurrentFiber: getCurrentFiberForDevTools
        });
    }
    function ReactDOMRoot(container, options) {
        this._internalRoot = createRootImpl(container, ConcurrentRoot, options);
    }
    function ReactDOMBlockingRoot(container, tag, options) {
        this._internalRoot = createRootImpl(container, tag, options);
    }
    ReactDOMRoot.prototype.render = ReactDOMBlockingRoot.prototype.render = function(children) {
        var root = this._internalRoot;
        if (typeof arguments[1] === 'function') error("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var container = root.containerInfo;
        if (container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(root.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
            }
        }
        updateContainer(children, root, null, null);
    };
    ReactDOMRoot.prototype.unmount = ReactDOMBlockingRoot.prototype.unmount = function() {
        if (typeof arguments[0] === 'function') error("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var root = this._internalRoot;
        var container = root.containerInfo;
        updateContainer(null, root, null, function() {
            unmarkContainerAsRoot(container);
        });
    };
    function createRootImpl(container, tag, options) {
        // Tag is either LegacyRoot or Concurrent Root
        var hydrate = options != null && options.hydrate === true;
        var hydrationCallbacks = options != null && options.hydrationOptions || null;
        var mutableSources = options != null && options.hydrationOptions != null && options.hydrationOptions.mutableSources || null;
        var root = createContainer(container, tag, hydrate);
        markContainerAsRoot(root.current, container);
        var containerNodeType = container.nodeType;
        var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
        listenToAllSupportedEvents(rootContainerElement);
        if (mutableSources) for(var i = 0; i < mutableSources.length; i++){
            var mutableSource = mutableSources[i];
            registerMutableSourceForHydration(root, mutableSource);
        }
        return root;
    }
    function createLegacyRoot(container, options) {
        return new ReactDOMBlockingRoot(container, LegacyRoot, options);
    }
    function isValidContainer(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === ' react-mount-point-unstable '));
    }
    var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
    var topLevelUpdateWarnings;
    var warnedAboutHydrateAPI = false;
    topLevelUpdateWarnings = function(container) {
        if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer._internalRoot.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
            }
        }
        var isRootRenderedBySomeReact = !!container._reactRootContainer;
        var rootEl = getReactRootElementInContainer(container);
        var hasNonRootReactChild = !!(rootEl && getInstanceFromNode(rootEl));
        if (hasNonRootReactChild && !isRootRenderedBySomeReact) error("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render.");
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === 'BODY') error("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function getReactRootElementInContainer(container) {
        if (!container) return null;
        if (container.nodeType === DOCUMENT_NODE) return container.documentElement;
        else return container.firstChild;
    }
    function shouldHydrateDueToLegacyHeuristic(container) {
        var rootElement = getReactRootElementInContainer(container);
        return !!(rootElement && rootElement.nodeType === ELEMENT_NODE && rootElement.hasAttribute(ROOT_ATTRIBUTE_NAME));
    }
    function legacyCreateRootFromDOMContainer(container, forceHydrate) {
        var shouldHydrate = forceHydrate || shouldHydrateDueToLegacyHeuristic(container); // First clear any existing content.
        if (!shouldHydrate) {
            var warned = false;
            var rootSibling;
            while(rootSibling = container.lastChild){
                if (!warned && rootSibling.nodeType === ELEMENT_NODE && rootSibling.hasAttribute(ROOT_ATTRIBUTE_NAME)) {
                    warned = true;
                    error("render(): Target node has markup rendered by React, but there are unrelated nodes as well. This is most commonly caused by white-space inserted around server-rendered markup.");
                }
                container.removeChild(rootSibling);
            }
        }
        if (shouldHydrate && !forceHydrate && !warnedAboutHydrateAPI) {
            warnedAboutHydrateAPI = true;
            warn("render(): Calling ReactDOM.render() to hydrate server-rendered markup will stop working in React v18. Replace the ReactDOM.render() call with ReactDOM.hydrate() if you want React to attach to the server HTML.");
        }
        return createLegacyRoot(container, shouldHydrate ? {
            hydrate: true
        } : undefined);
    }
    function warnOnInvalidCallback$1(callback, callerName) {
        if (callback !== null && typeof callback !== 'function') error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
    }
    function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
        topLevelUpdateWarnings(container);
        warnOnInvalidCallback$1(callback === undefined ? null : callback, 'render');
        // member of intersection type." Whyyyyyy.
        var root = container._reactRootContainer;
        var fiberRoot;
        if (!root) {
            // Initial mount
            root = container._reactRootContainer = legacyCreateRootFromDOMContainer(container, forceHydrate);
            fiberRoot = root._internalRoot;
            if (typeof callback === 'function') {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(fiberRoot);
                    originalCallback.call(instance);
                };
            } // Initial mount should not be batched.
            unbatchedUpdates(function() {
                updateContainer(children, fiberRoot, parentComponent, callback);
            });
        } else {
            fiberRoot = root._internalRoot;
            if (typeof callback === 'function') {
                var _originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(fiberRoot);
                    _originalCallback.call(instance);
                };
            } // Update
            updateContainer(children, fiberRoot, parentComponent, callback);
        }
        return getPublicRootInstance(fiberRoot);
    }
    function findDOMNode(componentOrElement) {
        var owner = ReactCurrentOwner$3.current;
        if (owner !== null && owner.stateNode !== null) {
            var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;
            if (!warnedAboutRefsInRender) error("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentName(owner.type) || 'A component');
            owner.stateNode._warnedAboutRefsInRender = true;
        }
        if (componentOrElement == null) return null;
        if (componentOrElement.nodeType === ELEMENT_NODE) return componentOrElement;
        return findHostInstanceWithWarning(componentOrElement, 'findDOMNode');
    }
    function hydrate(element, container, callback) {
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call createRoot(container, {hydrate: true}).render(element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
    }
    function render(element, container, callback) {
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.render() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call root.render(element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
    }
    function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        if (!isValidContainer(containerNode)) throw Error("Target container is not a DOM element.");
        if (!(parentComponent != null && has(parentComponent))) throw Error("parentComponent must be a valid React Component");
        return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
    }
    function unmountComponentAtNode(container) {
        if (!isValidContainer(container)) throw Error("unmountComponentAtNode(...): Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call root.unmount()?");
        if (container._reactRootContainer) {
            var rootEl = getReactRootElementInContainer(container);
            var renderedByDifferentReact = rootEl && !getInstanceFromNode(rootEl);
            if (renderedByDifferentReact) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
            unbatchedUpdates(function() {
                legacyRenderSubtreeIntoContainer(null, null, container, false, function() {
                    // $FlowFixMe This should probably use `delete container._reactRootContainer`
                    container._reactRootContainer = null;
                    unmarkContainerAsRoot(container);
                });
            }); // If you call unmountComponentAtNode twice in quick succession, you'll
            // get `true` twice. That's probably fine?
            return true;
        } else {
            var _rootEl = getReactRootElementInContainer(container);
            var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode(_rootEl)); // Check if the container itself is a React root node.
            var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainer(container.parentNode) && !!container.parentNode._reactRootContainer;
            if (hasNonRootReactChild) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", isContainerReactRoot ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
            return false;
        }
    }
    setAttemptUserBlockingHydration(attemptUserBlockingHydration$1);
    setAttemptContinuousHydration(attemptContinuousHydration$1);
    setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
    setAttemptHydrationAtPriority(runWithPriority$2);
    var didWarnAboutUnstableCreatePortal = false;
    if (typeof Map !== 'function' || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach !== 'function' || typeof Set !== 'function' || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear !== 'function' || typeof Set.prototype.forEach !== 'function') error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    setRestoreImplementation(restoreControlledState$3);
    setBatchingImplementation(batchedUpdates$1, discreteUpdates$1, flushDiscreteUpdates, batchedEventUpdates$1);
    function createPortal$1(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
         // TODO: pass ReactDOM portal implementation as third argument
        // $FlowFixMe The Flow type is opaque but there's no way to actually create it.
        return createPortal(children, container, null, key);
    }
    function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
    }
    function unstable_createPortal(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!didWarnAboutUnstableCreatePortal) {
            didWarnAboutUnstableCreatePortal = true;
            warn('The ReactDOM.unstable_createPortal() alias has been deprecated, and will be removed in React 18+. Update your code to use ReactDOM.createPortal() instead. It has the exact same API, but without the "unstable_" prefix.');
        }
        return createPortal$1(children, container, key);
    }
    var Internals = {
        // Keep in sync with ReactTestUtils.js, and ReactTestUtilsAct.js.
        // This is an array for better minification.
        Events: [
            getInstanceFromNode,
            getNodeFromInstance,
            getFiberCurrentPropsFromNode,
            enqueueStateRestore,
            restoreStateIfNeeded,
            flushPassiveEffects,
            IsThisRendererActing
        ]
    };
    var foundDevTools = injectIntoDevTools({
        findFiberByHostInstance: getClosestInstanceFromNode,
        bundleType: 1,
        version: ReactVersion,
        rendererPackageName: 'react-dom'
    });
    if (!foundDevTools && canUseDOM && window.top === window.self) // If we're in Chrome or Firefox, provide a download link if not installed.
    {
        if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
            var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.
            if (/^(https?|file):$/.test(protocol)) // eslint-disable-next-line react-internal/no-production-logging
            console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (protocol === 'file:' ? "\nYou might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq" : ''), 'font-weight:bold');
        }
    }
    exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Internals;
    exports.createPortal = createPortal$1;
    exports.findDOMNode = findDOMNode;
    exports.flushSync = flushSync;
    exports.hydrate = hydrate;
    exports.render = render;
    exports.unmountComponentAtNode = unmountComponentAtNode;
    exports.unstable_batchedUpdates = batchedUpdates$1;
    exports.unstable_createPortal = unstable_createPortal;
    exports.unstable_renderSubtreeIntoContainer = renderSubtreeIntoContainer;
    exports.version = ReactVersion;
})();

});
parcelRegister("74qJ9", function(module, exports) {
'use strict';

module.exports = (parcelRequire("H6kC4"));

});
parcelRegister("H6kC4", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $0818ed9087a5a453$export$c4744153514ff05d, (v) => $0818ed9087a5a453$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $0818ed9087a5a453$export$b5836b71941fa3ed, (v) => $0818ed9087a5a453$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $0818ed9087a5a453$export$d66a1c1c77bd778b, (v) => $0818ed9087a5a453$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $0818ed9087a5a453$export$3e506c1ccc9cc1a7, (v) => $0818ed9087a5a453$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $0818ed9087a5a453$export$e26fe2ed2fa76875, (v) => $0818ed9087a5a453$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $0818ed9087a5a453$export$502329bbf4b505b1, (v) => $0818ed9087a5a453$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $0818ed9087a5a453$export$6e3807111c4874c4, (v) => $0818ed9087a5a453$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $0818ed9087a5a453$export$c27134553091fb3a, (v) => $0818ed9087a5a453$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $0818ed9087a5a453$export$33ee1acdc04fd2a2, (v) => $0818ed9087a5a453$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $0818ed9087a5a453$export$b00a404bbd5edef2, (v) => $0818ed9087a5a453$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $0818ed9087a5a453$export$8352ce38b91d0c62, (v) => $0818ed9087a5a453$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $0818ed9087a5a453$export$d3dfb8e4810cb555, (v) => $0818ed9087a5a453$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $0818ed9087a5a453$export$839f9183b0465a69, (v) => $0818ed9087a5a453$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $0818ed9087a5a453$export$72fdf0e06517287b, (v) => $0818ed9087a5a453$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $0818ed9087a5a453$export$4b844e58a3e414b4, (v) => $0818ed9087a5a453$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $0818ed9087a5a453$export$816d2913ae6b83b1, (v) => $0818ed9087a5a453$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $0818ed9087a5a453$export$61bcfe829111a1d0, (v) => $0818ed9087a5a453$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $0818ed9087a5a453$export$7ee8c9beb337bc3f, (v) => $0818ed9087a5a453$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $0818ed9087a5a453$export$cf845f2c119da08a, (v) => $0818ed9087a5a453$export$cf845f2c119da08a = v);
/** @license React v0.20.2
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0818ed9087a5a453$export$c4744153514ff05d;
var $0818ed9087a5a453$export$b5836b71941fa3ed;
var $0818ed9087a5a453$export$d66a1c1c77bd778b;
var $0818ed9087a5a453$export$3e506c1ccc9cc1a7;
var $0818ed9087a5a453$export$e26fe2ed2fa76875;
var $0818ed9087a5a453$export$502329bbf4b505b1;
var $0818ed9087a5a453$export$6e3807111c4874c4;
var $0818ed9087a5a453$export$c27134553091fb3a;
var $0818ed9087a5a453$export$33ee1acdc04fd2a2;
var $0818ed9087a5a453$export$b00a404bbd5edef2;
var $0818ed9087a5a453$export$8352ce38b91d0c62;
var $0818ed9087a5a453$export$d3dfb8e4810cb555;
var $0818ed9087a5a453$export$839f9183b0465a69;
var $0818ed9087a5a453$export$72fdf0e06517287b;
var $0818ed9087a5a453$export$4b844e58a3e414b4;
var $0818ed9087a5a453$export$816d2913ae6b83b1;
var $0818ed9087a5a453$export$61bcfe829111a1d0;
var $0818ed9087a5a453$export$7ee8c9beb337bc3f;
var $0818ed9087a5a453$export$cf845f2c119da08a;
'use strict';
(function() {
    'use strict';
    var enableSchedulerDebugging = false;
    var enableProfiling = false;
    var requestHostCallback;
    var requestHostTimeout;
    var cancelHostTimeout;
    var requestPaint;
    var hasPerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';
    if (hasPerformanceNow) {
        var localPerformance = performance;
        $0818ed9087a5a453$export$c4744153514ff05d = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date;
        var initialTime = localDate.now();
        $0818ed9087a5a453$export$c4744153514ff05d = function() {
            return localDate.now() - initialTime;
        };
    }
    if (// implementation using setTimeout.
    typeof window === 'undefined' || // Check if MessageChannel is supported, too.
    typeof MessageChannel !== 'function') {
        // If this accidentally gets imported in a non-browser environment, e.g. JavaScriptCore,
        // fallback to a naive implementation.
        var _callback = null;
        var _timeoutID = null;
        var _flushCallback = function() {
            if (_callback !== null) try {
                var currentTime = $0818ed9087a5a453$export$c4744153514ff05d();
                var hasRemainingTime = true;
                _callback(hasRemainingTime, currentTime);
                _callback = null;
            } catch (e) {
                setTimeout(_flushCallback, 0);
                throw e;
            }
        };
        requestHostCallback = function(cb) {
            if (_callback !== null) // Protect against re-entrancy.
            setTimeout(requestHostCallback, 0, cb);
            else {
                _callback = cb;
                setTimeout(_flushCallback, 0);
            }
        };
        requestHostTimeout = function(cb, ms) {
            _timeoutID = setTimeout(cb, ms);
        };
        cancelHostTimeout = function() {
            clearTimeout(_timeoutID);
        };
        $0818ed9087a5a453$export$b5836b71941fa3ed = function() {
            return false;
        };
        requestPaint = $0818ed9087a5a453$export$d66a1c1c77bd778b = function() {};
    } else {
        // Capture local references to native APIs, in case a polyfill overrides them.
        var _setTimeout = window.setTimeout;
        var _clearTimeout = window.clearTimeout;
        if (typeof console !== 'undefined') {
            // TODO: Scheduler no longer requires these methods to be polyfilled. But
            // maybe we want to continue warning if they don't exist, to preserve the
            // option to rely on it in the future?
            var requestAnimationFrame = window.requestAnimationFrame;
            var cancelAnimationFrame = window.cancelAnimationFrame;
            if (typeof requestAnimationFrame !== 'function') // Using console['error'] to evade Babel and ESLint
            console['error']("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
            if (typeof cancelAnimationFrame !== 'function') // Using console['error'] to evade Babel and ESLint
            console['error']("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        }
        var isMessageLoopRunning = false;
        var scheduledHostCallback = null;
        var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
        // thread, like user events. By default, it yields multiple times per frame.
        // It does not attempt to align with frame boundaries, since most tasks don't
        // need to be frame aligned; for those that do, use requestAnimationFrame.
        var yieldInterval = 5;
        var deadline = 0; // TODO: Make this configurable
        // `isInputPending` is not available. Since we have no way of knowing if
        // there's pending input, always yield at the end of the frame.
        $0818ed9087a5a453$export$b5836b71941fa3ed = function() {
            return $0818ed9087a5a453$export$c4744153514ff05d() >= deadline;
        }; // Since we yield every frame regardless, `requestPaint` has no effect.
        requestPaint = function() {};
        $0818ed9087a5a453$export$d66a1c1c77bd778b = function(fps) {
            if (fps < 0 || fps > 125) {
                // Using console['error'] to evade Babel and ESLint
                console['error']("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
                return;
            }
            if (fps > 0) yieldInterval = Math.floor(1000 / fps);
            else // reset the framerate
            yieldInterval = 5;
        };
        var performWorkUntilDeadline = function() {
            if (scheduledHostCallback !== null) {
                var currentTime = $0818ed9087a5a453$export$c4744153514ff05d(); // Yield after `yieldInterval` ms, regardless of where we are in the vsync
                // cycle. This means there's always time remaining at the beginning of
                // the message event.
                deadline = currentTime + yieldInterval;
                var hasTimeRemaining = true;
                try {
                    var hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
                    if (!hasMoreWork) {
                        isMessageLoopRunning = false;
                        scheduledHostCallback = null;
                    } else // If there's more work, schedule the next message event at the end
                    // of the preceding one.
                    port.postMessage(null);
                } catch (error) {
                    // If a scheduler task throws, exit the current browser task so the
                    // error can be observed.
                    port.postMessage(null);
                    throw error;
                }
            } else isMessageLoopRunning = false;
             // Yielding to the browser will give it a chance to paint, so we can
        };
        var channel = new MessageChannel();
        var port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        requestHostCallback = function(callback) {
            scheduledHostCallback = callback;
            if (!isMessageLoopRunning) {
                isMessageLoopRunning = true;
                port.postMessage(null);
            }
        };
        requestHostTimeout = function(callback, ms) {
            taskTimeoutID = _setTimeout(function() {
                callback($0818ed9087a5a453$export$c4744153514ff05d());
            }, ms);
        };
        cancelHostTimeout = function() {
            _clearTimeout(taskTimeoutID);
            taskTimeoutID = -1;
        };
    }
    function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        siftUp(heap, node, index);
    }
    function peek(heap) {
        var first = heap[0];
        return first === undefined ? null : first;
    }
    function pop(heap) {
        var first = heap[0];
        if (first !== undefined) {
            var last = heap.pop();
            if (last !== first) {
                heap[0] = last;
                siftDown(heap, last, 0);
            }
            return first;
        } else return null;
    }
    function siftUp(heap, node, i) {
        var index = i;
        while(true){
            var parentIndex = index - 1 >>> 1;
            var parent = heap[parentIndex];
            if (parent !== undefined && compare(parent, node) > 0) {
                // The parent is larger. Swap positions.
                heap[parentIndex] = node;
                heap[index] = parent;
                index = parentIndex;
            } else // The parent is smaller. Exit.
            return;
        }
    }
    function siftDown(heap, node, i) {
        var index = i;
        var length = heap.length;
        while(index < length){
            var leftIndex = (index + 1) * 2 - 1;
            var left = heap[leftIndex];
            var rightIndex = leftIndex + 1;
            var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.
            if (left !== undefined && compare(left, node) < 0) {
                if (right !== undefined && compare(right, left) < 0) {
                    heap[index] = right;
                    heap[rightIndex] = node;
                    index = rightIndex;
                } else {
                    heap[index] = left;
                    heap[leftIndex] = node;
                    index = leftIndex;
                }
            } else if (right !== undefined && compare(right, node) < 0) {
                heap[index] = right;
                heap[rightIndex] = node;
                index = rightIndex;
            } else // Neither child is smaller. Exit.
            return;
        }
    }
    function compare(a, b) {
        // Compare sort index first, then task id.
        var diff = a.sortIndex - b.sortIndex;
        return diff !== 0 ? diff : a.id - b.id;
    }
    // TODO: Use symbols?
    var ImmediatePriority = 1;
    var UserBlockingPriority = 2;
    var NormalPriority = 3;
    var LowPriority = 4;
    var IdlePriority = 5;
    function markTaskErrored(task, ms) {}
    /* eslint-disable no-var */ // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var maxSigned31BitInt = 1073741823; // Times out immediately
    var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out
    var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
    var NORMAL_PRIORITY_TIMEOUT = 5000;
    var LOW_PRIORITY_TIMEOUT = 10000; // Never times out
    var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt; // Tasks are stored on a min heap
    var taskQueue = [];
    var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.
    var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
    var currentTask = null;
    var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrancy.
    var isPerformingWork = false;
    var isHostCallbackScheduled = false;
    var isHostTimeoutScheduled = false;
    function advanceTimers(currentTime) {
        // Check for tasks that are no longer delayed and add them to the queue.
        var timer = peek(timerQueue);
        while(timer !== null){
            if (timer.callback === null) // Timer was cancelled.
            pop(timerQueue);
            else if (timer.startTime <= currentTime) {
                // Timer fired. Transfer to the task queue.
                pop(timerQueue);
                timer.sortIndex = timer.expirationTime;
                push(taskQueue, timer);
            } else // Remaining timers are pending.
            return;
            timer = peek(timerQueue);
        }
    }
    function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
            if (peek(taskQueue) !== null) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            } else {
                var firstTimer = peek(timerQueue);
                if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
        }
    }
    function flushWork(hasTimeRemaining, initialTime) {
        isHostCallbackScheduled = false;
        if (isHostTimeoutScheduled) {
            // We scheduled a timeout but it's no longer needed. Cancel it.
            isHostTimeoutScheduled = false;
            cancelHostTimeout();
        }
        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;
        try {
            if (enableProfiling) try {
                return workLoop(hasTimeRemaining, initialTime);
            } catch (error) {
                if (currentTask !== null) {
                    var currentTime = $0818ed9087a5a453$export$c4744153514ff05d();
                    markTaskErrored(currentTask, currentTime);
                    currentTask.isQueued = false;
                }
                throw error;
            }
            else // No catch in prod code path.
            return workLoop(hasTimeRemaining, initialTime);
        } finally{
            currentTask = null;
            currentPriorityLevel = previousPriorityLevel;
            isPerformingWork = false;
        }
    }
    function workLoop(hasTimeRemaining, initialTime) {
        var currentTime = initialTime;
        advanceTimers(currentTime);
        currentTask = peek(taskQueue);
        while(currentTask !== null && !enableSchedulerDebugging){
            if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || $0818ed9087a5a453$export$b5836b71941fa3ed())) break;
            var callback = currentTask.callback;
            if (typeof callback === 'function') {
                currentTask.callback = null;
                currentPriorityLevel = currentTask.priorityLevel;
                var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
                var continuationCallback = callback(didUserCallbackTimeout);
                currentTime = $0818ed9087a5a453$export$c4744153514ff05d();
                if (typeof continuationCallback === 'function') currentTask.callback = continuationCallback;
                else if (currentTask === peek(taskQueue)) pop(taskQueue);
                advanceTimers(currentTime);
            } else pop(taskQueue);
            currentTask = peek(taskQueue);
        } // Return whether there's additional work
        if (currentTask !== null) return true;
        else {
            var firstTimer = peek(timerQueue);
            if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            return false;
        }
    }
    function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch(priorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
            case LowPriority:
            case IdlePriority:
                break;
            default:
                priorityLevel = NormalPriority;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_next(eventHandler) {
        var priorityLevel;
        switch(currentPriorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
                // Shift down to normal priority
                priorityLevel = NormalPriority;
                break;
            default:
                // Anything lower than normal priority should remain at the current level.
                priorityLevel = currentPriorityLevel;
                break;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
            // This is a fork of runWithPriority, inlined for performance.
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
                return callback.apply(this, arguments);
            } finally{
                currentPriorityLevel = previousPriorityLevel;
            }
        };
    }
    function unstable_scheduleCallback(priorityLevel, callback, options) {
        var currentTime = $0818ed9087a5a453$export$c4744153514ff05d();
        var startTime;
        if (typeof options === 'object' && options !== null) {
            var delay = options.delay;
            if (typeof delay === 'number' && delay > 0) startTime = currentTime + delay;
            else startTime = currentTime;
        } else startTime = currentTime;
        var timeout;
        switch(priorityLevel){
            case ImmediatePriority:
                timeout = IMMEDIATE_PRIORITY_TIMEOUT;
                break;
            case UserBlockingPriority:
                timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
                break;
            case IdlePriority:
                timeout = IDLE_PRIORITY_TIMEOUT;
                break;
            case LowPriority:
                timeout = LOW_PRIORITY_TIMEOUT;
                break;
            case NormalPriority:
            default:
                timeout = NORMAL_PRIORITY_TIMEOUT;
                break;
        }
        var expirationTime = startTime + timeout;
        var newTask = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: startTime,
            expirationTime: expirationTime,
            sortIndex: -1
        };
        if (startTime > currentTime) {
            // This is a delayed task.
            newTask.sortIndex = startTime;
            push(timerQueue, newTask);
            if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
                // All tasks are delayed, and this is the task with the earliest delay.
                if (isHostTimeoutScheduled) // Cancel an existing timeout.
                cancelHostTimeout();
                else isHostTimeoutScheduled = true;
                 // Schedule a timeout.
                requestHostTimeout(handleTimeout, startTime - currentTime);
            }
        } else {
            newTask.sortIndex = expirationTime;
            push(taskQueue, newTask);
            // wait until the next time we yield.
            if (!isHostCallbackScheduled && !isPerformingWork) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            }
        }
        return newTask;
    }
    function unstable_pauseExecution() {}
    function unstable_continueExecution() {
        if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
        }
    }
    function unstable_getFirstCallbackNode() {
        return peek(taskQueue);
    }
    function unstable_cancelCallback(task) {
        // remove from the queue because you can't remove arbitrary nodes from an
        // array based heap, only the first one.)
        task.callback = null;
    }
    function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
    }
    var unstable_requestPaint = requestPaint;
    var unstable_Profiling = null;
    $0818ed9087a5a453$export$3e506c1ccc9cc1a7 = IdlePriority;
    $0818ed9087a5a453$export$e26fe2ed2fa76875 = ImmediatePriority;
    $0818ed9087a5a453$export$502329bbf4b505b1 = LowPriority;
    $0818ed9087a5a453$export$6e3807111c4874c4 = NormalPriority;
    $0818ed9087a5a453$export$c27134553091fb3a = unstable_Profiling;
    $0818ed9087a5a453$export$33ee1acdc04fd2a2 = UserBlockingPriority;
    $0818ed9087a5a453$export$b00a404bbd5edef2 = unstable_cancelCallback;
    $0818ed9087a5a453$export$8352ce38b91d0c62 = unstable_continueExecution;
    $0818ed9087a5a453$export$d3dfb8e4810cb555 = unstable_getCurrentPriorityLevel;
    $0818ed9087a5a453$export$839f9183b0465a69 = unstable_getFirstCallbackNode;
    $0818ed9087a5a453$export$72fdf0e06517287b = unstable_next;
    $0818ed9087a5a453$export$4b844e58a3e414b4 = unstable_pauseExecution;
    $0818ed9087a5a453$export$816d2913ae6b83b1 = unstable_requestPaint;
    $0818ed9087a5a453$export$61bcfe829111a1d0 = unstable_runWithPriority;
    $0818ed9087a5a453$export$7ee8c9beb337bc3f = unstable_scheduleCallback;
    $0818ed9087a5a453$export$cf845f2c119da08a = unstable_wrapCallback;
})();

});


parcelRegister("7gB5I", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3pbAn"));

});
parcelRegister("3pbAn", function(module, exports) {

$parcel$export(module.exports, "__interactionsRef", () => $27acb190d9350205$export$236303149b061964, (v) => $27acb190d9350205$export$236303149b061964 = v);
$parcel$export(module.exports, "__subscriberRef", () => $27acb190d9350205$export$d8c36835f54f0a3b, (v) => $27acb190d9350205$export$d8c36835f54f0a3b = v);
$parcel$export(module.exports, "unstable_clear", () => $27acb190d9350205$export$4a908c8bc96de6cd, (v) => $27acb190d9350205$export$4a908c8bc96de6cd = v);
$parcel$export(module.exports, "unstable_getCurrent", () => $27acb190d9350205$export$49d8199c8144c803, (v) => $27acb190d9350205$export$49d8199c8144c803 = v);
$parcel$export(module.exports, "unstable_getThreadID", () => $27acb190d9350205$export$c7d3dd8712817dbc, (v) => $27acb190d9350205$export$c7d3dd8712817dbc = v);
$parcel$export(module.exports, "unstable_subscribe", () => $27acb190d9350205$export$932a6d6a24b633a5, (v) => $27acb190d9350205$export$932a6d6a24b633a5 = v);
$parcel$export(module.exports, "unstable_trace", () => $27acb190d9350205$export$8405cb466bd0a1f1, (v) => $27acb190d9350205$export$8405cb466bd0a1f1 = v);
$parcel$export(module.exports, "unstable_unsubscribe", () => $27acb190d9350205$export$4fd753a282912317, (v) => $27acb190d9350205$export$4fd753a282912317 = v);
$parcel$export(module.exports, "unstable_wrap", () => $27acb190d9350205$export$230d7bceee602808, (v) => $27acb190d9350205$export$230d7bceee602808 = v);
/** @license React v0.20.2
 * scheduler-tracing.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ // Interactions "stack"–
// Meaning that newly traced interactions are appended to the previously active set.
// When an interaction goes out of scope, the previous set (if any) is restored.
var $27acb190d9350205$export$236303149b061964;
var $27acb190d9350205$export$d8c36835f54f0a3b;
var $27acb190d9350205$export$4a908c8bc96de6cd;
var $27acb190d9350205$export$49d8199c8144c803;
var $27acb190d9350205$export$c7d3dd8712817dbc;
var $27acb190d9350205$export$932a6d6a24b633a5;
var $27acb190d9350205$export$8405cb466bd0a1f1;
var $27acb190d9350205$export$4fd753a282912317;
var $27acb190d9350205$export$230d7bceee602808;
'use strict';
(function() {
    'use strict';
    var DEFAULT_THREAD_ID = 0; // Counters used to generate unique IDs.
    var interactionIDCounter = 0;
    var threadIDCounter = 0; // Set of currently traced interactions.
    $27acb190d9350205$export$236303149b061964 = null; // Listener(s) to notify when interactions begin and end.
    $27acb190d9350205$export$d8c36835f54f0a3b = null;
    $27acb190d9350205$export$236303149b061964 = {
        current: new Set()
    };
    $27acb190d9350205$export$d8c36835f54f0a3b = {
        current: null
    };
    function unstable_clear(callback) {
        var prevInteractions = $27acb190d9350205$export$236303149b061964.current;
        $27acb190d9350205$export$236303149b061964.current = new Set();
        try {
            return callback();
        } finally{
            $27acb190d9350205$export$236303149b061964.current = prevInteractions;
        }
    }
    function unstable_getCurrent() {
        return $27acb190d9350205$export$236303149b061964.current;
    }
    function unstable_getThreadID() {
        return ++threadIDCounter;
    }
    function unstable_trace(name, timestamp, callback) {
        var threadID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_THREAD_ID;
        var interaction = {
            __count: 1,
            id: interactionIDCounter++,
            name: name,
            timestamp: timestamp
        };
        var prevInteractions = $27acb190d9350205$export$236303149b061964.current; // Traced interactions should stack/accumulate.
        // To do that, clone the current interactions.
        // The previous set will be restored upon completion.
        var interactions = new Set(prevInteractions);
        interactions.add(interaction);
        $27acb190d9350205$export$236303149b061964.current = interactions;
        var subscriber = $27acb190d9350205$export$d8c36835f54f0a3b.current;
        var returnValue;
        try {
            if (subscriber !== null) subscriber.onInteractionTraced(interaction);
        } finally{
            try {
                if (subscriber !== null) subscriber.onWorkStarted(interactions, threadID);
            } finally{
                try {
                    returnValue = callback();
                } finally{
                    $27acb190d9350205$export$236303149b061964.current = prevInteractions;
                    try {
                        if (subscriber !== null) subscriber.onWorkStopped(interactions, threadID);
                    } finally{
                        interaction.__count--; // If no async work was scheduled for this interaction,
                        // Notify subscribers that it's completed.
                        if (subscriber !== null && interaction.__count === 0) subscriber.onInteractionScheduledWorkCompleted(interaction);
                    }
                }
            }
        }
        return returnValue;
    }
    function unstable_wrap(callback) {
        var threadID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_THREAD_ID;
        var wrappedInteractions = $27acb190d9350205$export$236303149b061964.current;
        var subscriber = $27acb190d9350205$export$d8c36835f54f0a3b.current;
        if (subscriber !== null) subscriber.onWorkScheduled(wrappedInteractions, threadID);
         // Update the pending async work count for the current interactions.
        // Update after calling subscribers in case of error.
        wrappedInteractions.forEach(function(interaction) {
            interaction.__count++;
        });
        var hasRun = false;
        function wrapped() {
            var prevInteractions = $27acb190d9350205$export$236303149b061964.current;
            $27acb190d9350205$export$236303149b061964.current = wrappedInteractions;
            subscriber = $27acb190d9350205$export$d8c36835f54f0a3b.current;
            try {
                var returnValue;
                try {
                    if (subscriber !== null) subscriber.onWorkStarted(wrappedInteractions, threadID);
                } finally{
                    try {
                        returnValue = callback.apply(undefined, arguments);
                    } finally{
                        $27acb190d9350205$export$236303149b061964.current = prevInteractions;
                        if (subscriber !== null) subscriber.onWorkStopped(wrappedInteractions, threadID);
                    }
                }
                return returnValue;
            } finally{
                if (!hasRun) {
                    // We only expect a wrapped function to be executed once,
                    // But in the event that it's executed more than once–
                    // Only decrement the outstanding interaction counts once.
                    hasRun = true; // Update pending async counts for all wrapped interactions.
                    // If this was the last scheduled async work for any of them,
                    // Mark them as completed.
                    wrappedInteractions.forEach(function(interaction) {
                        interaction.__count--;
                        if (subscriber !== null && interaction.__count === 0) subscriber.onInteractionScheduledWorkCompleted(interaction);
                    });
                }
            }
        }
        wrapped.cancel = function cancel() {
            subscriber = $27acb190d9350205$export$d8c36835f54f0a3b.current;
            try {
                if (subscriber !== null) subscriber.onWorkCanceled(wrappedInteractions, threadID);
            } finally{
                // Update pending async counts for all wrapped interactions.
                // If this was the last scheduled async work for any of them,
                // Mark them as completed.
                wrappedInteractions.forEach(function(interaction) {
                    interaction.__count--;
                    if (subscriber && interaction.__count === 0) subscriber.onInteractionScheduledWorkCompleted(interaction);
                });
            }
        };
        return wrapped;
    }
    var subscribers = null;
    subscribers = new Set();
    function unstable_subscribe(subscriber) {
        subscribers.add(subscriber);
        if (subscribers.size === 1) $27acb190d9350205$export$d8c36835f54f0a3b.current = {
            onInteractionScheduledWorkCompleted: onInteractionScheduledWorkCompleted,
            onInteractionTraced: onInteractionTraced,
            onWorkCanceled: onWorkCanceled,
            onWorkScheduled: onWorkScheduled,
            onWorkStarted: onWorkStarted,
            onWorkStopped: onWorkStopped
        };
    }
    function unstable_unsubscribe(subscriber) {
        subscribers.delete(subscriber);
        if (subscribers.size === 0) $27acb190d9350205$export$d8c36835f54f0a3b.current = null;
    }
    function onInteractionTraced(interaction) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onInteractionTraced(interaction);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onInteractionScheduledWorkCompleted(interaction) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onInteractionScheduledWorkCompleted(interaction);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkScheduled(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkScheduled(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkStarted(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkStarted(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkStopped(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkStopped(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkCanceled(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkCanceled(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    $27acb190d9350205$export$4a908c8bc96de6cd = unstable_clear;
    $27acb190d9350205$export$49d8199c8144c803 = unstable_getCurrent;
    $27acb190d9350205$export$c7d3dd8712817dbc = unstable_getThreadID;
    $27acb190d9350205$export$932a6d6a24b633a5 = unstable_subscribe;
    $27acb190d9350205$export$8405cb466bd0a1f1 = unstable_trace;
    $27acb190d9350205$export$4fd753a282912317 = unstable_unsubscribe;
    $27acb190d9350205$export$230d7bceee602808 = unstable_wrap;
})();

});



parcelRegister("ax3yI", function(module, exports) {

$parcel$export(module.exports, "handleRedirect", () => $636f621e7ec208fa$export$733e9c9bfa11b30e);
$parcel$export(module.exports, "Login", () => $636f621e7ec208fa$export$21a94553ffa41578);

var $k4ank = parcelRequire("k4ank");

var $8QmWm = parcelRequire("8QmWm");
const $636f621e7ec208fa$export$733e9c9bfa11b30e = ()=>{
    localStorage.setItem("parentGroupId", "false");
    const redirectUrl = `${document.location.origin}/callback/`;
    const cognitoUrl = new URL("https://actuate-settings.auth.us-west-2.amazoncognito.com/login");
    cognitoUrl.searchParams.append("client_id", "2qbaet284cs7p5oq9ppg4llj1n");
    cognitoUrl.searchParams.append("response_type", "code");
    cognitoUrl.searchParams.append("scope", "email openid phone profile aws.cognito.signin.user.admin");
    cognitoUrl.searchParams.append("redirect_uri", redirectUrl);
    const url = cognitoUrl.toString();
    // Use safe redirect with allowed AWS Cognito domain
    (0, $8QmWm.safeRedirect)(url, [
        "amazoncognito.com",
        "actuateui.eu"
    ], "/callback/");
    // Only store the Cognito URL if there isn't already a redirect URL stored
    // (This preserves the original redirect URL set by RequireAuth)
    if (!localStorage.getItem("redirectURL")) localStorage.setItem("redirectURL", url);
};
const $636f621e7ec208fa$export$21a94553ffa41578 = ()=>{
    const urlParams = new URLSearchParams(window.location.search);
    const error = urlParams.get("error");
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "flex items-center justify-center font-black",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "absolute top-8 font-mulish text-xl",
                children: error === "failed" ? "Login failed. Please try again." : "For security reasons you have been logged out."
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "absolute font-mulish top-20 text-xl",
                children: error === "failed" ? "Click below to try logging in again." : "Please click below to log back in."
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                className: "shadow-button bg-actuate-orange rounded font-mulish text-white text-base p-1.5 absolute top-36",
                onClick: $636f621e7ec208fa$export$733e9c9bfa11b30e,
                children: error === "failed" ? "Try Again" : "Login"
            })
        ]
    });
};

});
parcelRegister("k4ank", function(module, exports) {
'use strict';

module.exports = (parcelRequire("pmAdi"));

});

parcelRegister("8QmWm", function(module, exports) {

$parcel$export(module.exports, "isValidInternalPath", () => $6d5c501fa988001f$export$1939da1a9732210d);
$parcel$export(module.exports, "isValidAppRoute", () => $6d5c501fa988001f$export$9096c884d3f0b524);
$parcel$export(module.exports, "safeRedirect", () => $6d5c501fa988001f$export$58e5087af7616817);
/**
 * URL validation utilities to prevent open redirect vulnerabilities
 */ /**
 * Validates if a URL is safe for redirects
 * @param url - The URL to validate
 * @param allowedDomains - Array of allowed domains (optional)
 * @returns boolean indicating if the URL is safe
 */ const $6d5c501fa988001f$export$aed51752c5165419 = (url, allowedDomains)=>{
    if (!url || typeof url !== "string") return false;
    try {
        const urlObj = new URL(url);
        // Check if it's a relative URL (safe)
        if (!urlObj.protocol && !urlObj.hostname) return true;
        // Check if it's HTTPS (preferred)
        if (urlObj.protocol !== "https:" && urlObj.protocol !== "http:") return false;
        // If allowedDomains is provided, check against it
        if (allowedDomains && allowedDomains.length > 0) return allowedDomains.some((domain)=>urlObj.hostname === domain || urlObj.hostname.endsWith(`.${domain}`));
        // Default: only allow same-origin redirects
        return urlObj.origin === window.location.origin;
    } catch (error) {
        // Invalid URL format
        return false;
    }
};
const $6d5c501fa988001f$export$1939da1a9732210d = (path)=>{
    if (!path || typeof path !== "string") return false;
    // Must start with /
    if (!path.startsWith("/")) return false;
    // Check for dangerous patterns
    const dangerousPatterns = [
        "//",
        "javascript:",
        "data:",
        "vbscript:",
        "file:",
        "ftp:",
        "mailto:",
        "tel:"
    ];
    const lowerPath = path.toLowerCase();
    for (const pattern of dangerousPatterns){
        if (lowerPath.includes(pattern)) return false;
    }
    // Check for suspicious characters
    const suspiciousChars = [
        "<",
        ">",
        '"',
        "'",
        "`",
        "\\"
    ];
    for (const char of suspiciousChars){
        if (path.includes(char)) return false;
    }
    return true;
};
const $6d5c501fa988001f$export$9096c884d3f0b524 = (path)=>{
    if (!$6d5c501fa988001f$export$1939da1a9732210d(path)) return false;
    // Remove query parameters and hash for route matching
    const cleanPath = path.split("?")[0].split("#")[0];
    // Define valid route patterns based on App.jsx routes
    const validRoutePatterns = [
        // Exact matches
        "/",
        "/login",
        "/dashboard",
        "/sites",
        "/sites_patrol",
        "/clips",
        "/patrols",
        "/patrols_test",
        "/smtp",
        "/calendars",
        "/alerts",
        "/analytics",
        "/user",
        "/groupuser",
        "/health",
        "/productrequirements",
        "/callback",
        "/eecallback",
        "/MFA",
        "/no-internet",
        // Dynamic routes with parameters
        /^\/sites\/addsite$/,
        /^\/sites\/cameracheck$/,
        /^\/sites\/addCamera$/,
        /^\/sites\/autoaddcamera$/,
        /^\/sites\/addschedule$/,
        /^\/sites\/addschedulesecret$/,
        /^\/sites\/aboutsite\/\d+$/,
        /^\/sites\/aboutsitesecret\/\d+$/,
        /^\/sites\/\d+\/videowall$/,
        /^\/sites\/\d+\/editcamera\/\d+\/editignorezones$/,
        /^\/sites\/\d+\/editcamera\/\d+\/ignorezones$/,
        /^\/sites\/\d+\/editcamera\/\d+\/editmetadatatagzones$/,
        /^\/sites\/\d+\/editcamera\/\d+$/,
        /^\/actionlogs\/\d+$/,
        /^\/alerts&.*$/,
        /^\/analytics&.*$/
    ];
    // Check against exact matches first
    if (validRoutePatterns.some((pattern)=>pattern === cleanPath)) return true;
    // Check against regex patterns
    return validRoutePatterns.some((pattern)=>{
        if (pattern instanceof RegExp) return pattern.test(cleanPath);
        return false;
    });
};
const $6d5c501fa988001f$export$58e5087af7616817 = (url, allowedDomains, fallbackUrl = "/dashboard")=>{
    if ($6d5c501fa988001f$export$aed51752c5165419(url, allowedDomains)) window.location.href = url;
    else {
        console.warn(`Blocked unsafe redirect to: ${url}`);
        window.location.href = fallbackUrl;
    }
};

});


parcelRegister("7lnJ6", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $558ce62783cd8aaa$export$2b8d127b894957b9, (v) => $558ce62783cd8aaa$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $558ce62783cd8aaa$export$cea3a54a6425200c, (v) => $558ce62783cd8aaa$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $558ce62783cd8aaa$export$a7c73072b1a182ae, (v) => $558ce62783cd8aaa$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $558ce62783cd8aaa$export$9f27bc3417b4524d, (v) => $558ce62783cd8aaa$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $558ce62783cd8aaa$export$db77ccec0bb4ccac, (v) => $558ce62783cd8aaa$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $558ce62783cd8aaa$export$8392c0c9d3dcbd35, (v) => $558ce62783cd8aaa$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $558ce62783cd8aaa$export$ffb0004e005737fa, (v) => $558ce62783cd8aaa$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $558ce62783cd8aaa$export$b624eff549462981, (v) => $558ce62783cd8aaa$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $558ce62783cd8aaa$export$7897aa7841a5380c, (v) => $558ce62783cd8aaa$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $558ce62783cd8aaa$export$602eac185826482c, (v) => $558ce62783cd8aaa$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $558ce62783cd8aaa$export$e2c29f18771995cb, (v) => $558ce62783cd8aaa$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $558ce62783cd8aaa$export$5f8d39834fd61797, (v) => $558ce62783cd8aaa$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $558ce62783cd8aaa$export$74bf444e3cd11ea5, (v) => $558ce62783cd8aaa$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $558ce62783cd8aaa$export$92387174baf9b227, (v) => $558ce62783cd8aaa$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $558ce62783cd8aaa$export$ec112efeb987d9c6, (v) => $558ce62783cd8aaa$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $558ce62783cd8aaa$export$b706b080d889d2c9, (v) => $558ce62783cd8aaa$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $558ce62783cd8aaa$export$5be5a87408f70ddc, (v) => $558ce62783cd8aaa$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $558ce62783cd8aaa$export$45a5e7f76e0caa8d, (v) => $558ce62783cd8aaa$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $558ce62783cd8aaa$export$455c2e768291efa6, (v) => $558ce62783cd8aaa$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $558ce62783cd8aaa$export$9522e17588c12572, (v) => $558ce62783cd8aaa$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $558ce62783cd8aaa$export$2110ac352bb060b9, (v) => $558ce62783cd8aaa$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $558ce62783cd8aaa$export$56885ab8b9c456ab, (v) => $558ce62783cd8aaa$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $558ce62783cd8aaa$export$d927fcb6adf8f9de, (v) => $558ce62783cd8aaa$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $558ce62783cd8aaa$export$b82d16f27459e05a, (v) => $558ce62783cd8aaa$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $558ce62783cd8aaa$export$522c17b4f5e123e8, (v) => $558ce62783cd8aaa$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $558ce62783cd8aaa$export$1aabd8a0274ecfd6, (v) => $558ce62783cd8aaa$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $558ce62783cd8aaa$export$9b621391a187a31a, (v) => $558ce62783cd8aaa$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $558ce62783cd8aaa$export$f5bbd400c2f4426f, (v) => $558ce62783cd8aaa$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $558ce62783cd8aaa$export$2b8d127b894957b9;
var $558ce62783cd8aaa$export$cea3a54a6425200c;
var $558ce62783cd8aaa$export$a7c73072b1a182ae;
var $558ce62783cd8aaa$export$9f27bc3417b4524d;
var $558ce62783cd8aaa$export$db77ccec0bb4ccac;
var $558ce62783cd8aaa$export$8392c0c9d3dcbd35;
var $558ce62783cd8aaa$export$ffb0004e005737fa;
var $558ce62783cd8aaa$export$b624eff549462981;
var $558ce62783cd8aaa$export$7897aa7841a5380c;
var $558ce62783cd8aaa$export$602eac185826482c;
var $558ce62783cd8aaa$export$e2c29f18771995cb;
var $558ce62783cd8aaa$export$5f8d39834fd61797;
var $558ce62783cd8aaa$export$74bf444e3cd11ea5;
var $558ce62783cd8aaa$export$92387174baf9b227;
var $558ce62783cd8aaa$export$ec112efeb987d9c6;
var $558ce62783cd8aaa$export$b706b080d889d2c9;
var $558ce62783cd8aaa$export$5be5a87408f70ddc;
var $558ce62783cd8aaa$export$45a5e7f76e0caa8d;
var $558ce62783cd8aaa$export$455c2e768291efa6;
var $558ce62783cd8aaa$export$9522e17588c12572;
var $558ce62783cd8aaa$export$2110ac352bb060b9;
var $558ce62783cd8aaa$export$56885ab8b9c456ab;
var $558ce62783cd8aaa$export$d927fcb6adf8f9de;
var $558ce62783cd8aaa$export$b82d16f27459e05a;
var $558ce62783cd8aaa$export$522c17b4f5e123e8;
var $558ce62783cd8aaa$export$1aabd8a0274ecfd6;
var $558ce62783cd8aaa$export$9b621391a187a31a;
var $558ce62783cd8aaa$export$f5bbd400c2f4426f;
'use strict';
(function() {
    'use strict';
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
    function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console['warn']("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $558ce62783cd8aaa$export$2b8d127b894957b9 = AsyncMode;
    $558ce62783cd8aaa$export$cea3a54a6425200c = ConcurrentMode;
    $558ce62783cd8aaa$export$a7c73072b1a182ae = ContextConsumer;
    $558ce62783cd8aaa$export$9f27bc3417b4524d = ContextProvider;
    $558ce62783cd8aaa$export$db77ccec0bb4ccac = Element;
    $558ce62783cd8aaa$export$8392c0c9d3dcbd35 = ForwardRef;
    $558ce62783cd8aaa$export$ffb0004e005737fa = Fragment;
    $558ce62783cd8aaa$export$b624eff549462981 = Lazy;
    $558ce62783cd8aaa$export$7897aa7841a5380c = Memo;
    $558ce62783cd8aaa$export$602eac185826482c = Portal;
    $558ce62783cd8aaa$export$e2c29f18771995cb = Profiler;
    $558ce62783cd8aaa$export$5f8d39834fd61797 = StrictMode;
    $558ce62783cd8aaa$export$74bf444e3cd11ea5 = Suspense;
    $558ce62783cd8aaa$export$92387174baf9b227 = isAsyncMode;
    $558ce62783cd8aaa$export$ec112efeb987d9c6 = isConcurrentMode;
    $558ce62783cd8aaa$export$b706b080d889d2c9 = isContextConsumer;
    $558ce62783cd8aaa$export$5be5a87408f70ddc = isContextProvider;
    $558ce62783cd8aaa$export$45a5e7f76e0caa8d = isElement;
    $558ce62783cd8aaa$export$455c2e768291efa6 = isForwardRef;
    $558ce62783cd8aaa$export$9522e17588c12572 = isFragment;
    $558ce62783cd8aaa$export$2110ac352bb060b9 = isLazy;
    $558ce62783cd8aaa$export$56885ab8b9c456ab = isMemo;
    $558ce62783cd8aaa$export$d927fcb6adf8f9de = isPortal;
    $558ce62783cd8aaa$export$b82d16f27459e05a = isProfiler;
    $558ce62783cd8aaa$export$522c17b4f5e123e8 = isStrictMode;
    $558ce62783cd8aaa$export$1aabd8a0274ecfd6 = isSuspense;
    $558ce62783cd8aaa$export$9b621391a187a31a = isValidElementType;
    $558ce62783cd8aaa$export$f5bbd400c2f4426f = typeOf;
})();

});

parcelRegister("aNxwx", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $lVitD = parcelRequire("lVitD");

var $7nROE = parcelRequire("7nROE");

var $7bPDF = parcelRequire("7bPDF");

var $aKc7x = parcelRequire("aKc7x");

var $dZGsg = parcelRequire("dZGsg");
var $7dc87c1ad9207928$var$printWarning = function() {};
$7dc87c1ad9207928$var$printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
function $7dc87c1ad9207928$var$emptyFunctionThatReturnsNull() {
    return null;
}
module.exports = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === 'function') return iteratorFn;
    }
    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = '<<anonymous>>';
    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
        array: createPrimitiveTypeChecker('array'),
        bigint: createPrimitiveTypeChecker('bigint'),
        bool: createPrimitiveTypeChecker('boolean'),
        func: createPrimitiveTypeChecker('function'),
        number: createPrimitiveTypeChecker('number'),
        object: createPrimitiveTypeChecker('object'),
        string: createPrimitiveTypeChecker('string'),
        symbol: createPrimitiveTypeChecker('symbol'),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
    };
    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
        // SameValue algorithm
        if (x === y) // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
        else // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === 'object' ? data : {};
        this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;
            if (secret !== $7bPDF) {
                if (throwOnDirectAccess) {
                    // New behavior only for users of `prop-types` package
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = 'Invariant Violation';
                    throw err;
                } else if (typeof console !== 'undefined') {
                    // Old behavior for people using React.PropTypes
                    var cacheKey = componentName + ':' + propName;
                    if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                    manualPropTypeWarningCount < 3) {
                        $7dc87c1ad9207928$var$printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
                        manualPropTypeCallCache[cacheKey] = true;
                        manualPropTypeWarningCount++;
                    }
                }
            }
            if (props[propName] == null) {
                if (isRequired) {
                    if (props[propName] === null) return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                    return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
                }
                return null;
            } else return validate(props, propName, componentName, location, propFullName);
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
                    expectedType: expectedType
                });
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
        return createChainableTypeChecker($7dc87c1ad9207928$var$emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
            }
            for(var i = 0; i < propValue.length; i++){
                var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', $7bPDF);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!$lVitD.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
            {
                if (arguments.length > 1) $7dc87c1ad9207928$var$printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
                else $7dc87c1ad9207928$var$printWarning('Invalid argument supplied to oneOf, expected an array.');
            }
            return $7dc87c1ad9207928$var$emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for(var i = 0; i < expectedValues.length; i++){
                if (is(propValue, expectedValues[i])) return null;
            }
            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);
                if (type === 'symbol') return String(value);
                return value;
            });
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
            for(var key in propValue)if ($aKc7x(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, $7bPDF);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
            $7dc87c1ad9207928$var$printWarning('Invalid argument supplied to oneOfType, expected an instance of array.');
            return $7dc87c1ad9207928$var$emptyFunctionThatReturnsNull;
        }
        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== 'function') {
                $7dc87c1ad9207928$var$printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
                return $7dc87c1ad9207928$var$emptyFunctionThatReturnsNull;
            }
        }
        function validate(props, propName, componentName, location, propFullName) {
            var expectedTypes = [];
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                var checkerResult = checker(props, propName, componentName, location, propFullName, $7bPDF);
                if (checkerResult == null) return null;
                if (checkerResult.data && $aKc7x(checkerResult.data, 'expectedType')) expectedTypes.push(checkerResult.data.expectedType);
            }
            var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
    }
    function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            for(var key in shapeTypes){
                var checker = shapeTypes[key];
                if (typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, $7bPDF);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            // We need to check all keys in case some are required but missing from props.
            var allKeys = $7nROE({}, props[propName], shapeTypes);
            for(var key in allKeys){
                var checker = shapeTypes[key];
                if ($aKc7x(shapeTypes, key) && typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                if (!checker) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, $7bPDF);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
        switch(typeof propValue){
            case 'number':
            case 'string':
            case 'undefined':
                return true;
            case 'boolean':
                return !propValue;
            case 'object':
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (propValue === null || isValidElement(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                    var iterator = iteratorFn.call(propValue);
                    var step;
                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                        if (!isNode(step.value)) return false;
                    }
                    else // Iterator will provide entry [k,v] tuples rather than values.
                    while(!(step = iterator.next()).done){
                        var entry = step.value;
                        if (entry) {
                            if (!isNode(entry[1])) return false;
                        }
                    }
                } else return false;
                return true;
            default:
                return false;
        }
    }
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === 'symbol') return true;
        // falsy value can't be a Symbol
        if (!propValue) return false;
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue['@@toStringTag'] === 'Symbol') return true;
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === 'function' && propValue instanceof Symbol) return true;
        return false;
    }
    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) return 'array';
        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
        if (isSymbol(propType, propValue)) return 'symbol';
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
        if (typeof propValue === 'undefined' || propValue === null) return '' + propValue;
        var propType = getPropType(propValue);
        if (propType === 'object') {
            if (propValue instanceof Date) return 'date';
            else if (propValue instanceof RegExp) return 'regexp';
        }
        return propType;
    }
    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch(type){
            case 'array':
            case 'object':
                return 'an ' + type;
            case 'boolean':
            case 'date':
            case 'regexp':
                return 'a ' + type;
            default:
                return type;
        }
    }
    // Returns class name of the object, if any.
    function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
        return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = $dZGsg;
    ReactPropTypes.resetWarningCache = $dZGsg.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("lVitD", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7lnJ6"));

});

parcelRegister("7bPDF", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $53c19de1399be13b$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $53c19de1399be13b$var$ReactPropTypesSecret;

});

parcelRegister("aKc7x", function(module, exports) {
module.exports = Function.call.bind(Object.prototype.hasOwnProperty);

});

parcelRegister("dZGsg", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $a301e786a398b29f$var$printWarning = function() {};

var $7bPDF = parcelRequire("7bPDF");
var $a301e786a398b29f$var$loggedTypeFailures = {};

var $aKc7x = parcelRequire("aKc7x");
$a301e786a398b29f$var$printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function $a301e786a398b29f$var$checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    for(var typeSpecName in typeSpecs)if ($aKc7x(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== 'function') {
                var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                err.name = 'Invariant Violation';
                throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, $7bPDF);
        } catch (ex) {
            error = ex;
        }
        if (error && !(error instanceof Error)) $a301e786a398b29f$var$printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        if (error instanceof Error && !(error.message in $a301e786a398b29f$var$loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            $a301e786a398b29f$var$loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : '';
            $a301e786a398b29f$var$printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
    }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */ $a301e786a398b29f$var$checkPropTypes.resetWarningCache = function() {
    $a301e786a398b29f$var$loggedTypeFailures = {};
};
module.exports = $a301e786a398b29f$var$checkPropTypes;

});


parcelRegister("cYIhZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("3cj28")).default);

var $3cj28 = parcelRequire("3cj28");

});
parcelRegister("3cj28", function(module, exports) {

$parcel$export(module.exports, "default", () => $254141bf89307051$export$2e2bcd8739ae039);
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $254141bf89307051$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});


parcelRegister("5mb8k", function(module, exports) {
function $3e67a4b2041241a8$var$_extends() {
    return module.exports = $3e67a4b2041241a8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $3e67a4b2041241a8$var$_extends.apply(null, arguments);
}
module.exports = $3e67a4b2041241a8$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("9MMlq", function(module, exports) {
function $71fe18fcbeb6a361$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $71fe18fcbeb6a361$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("7P7g9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5b22ed62fb95b4f4$export$2e2bcd8739ae039);
$parcel$export(module.exports, "internal_processStyles", () => $5b22ed62fb95b4f4$export$e00380445f2b9e0c);
$parcel$export(module.exports, "internal_serializeStyles", () => $5b22ed62fb95b4f4$export$13a2d3ef13012b32);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("iHk77")).T);
$parcel$export(module.exports, "keyframes", () => (parcelRequire("3JV9M")).keyframes);
$parcel$export(module.exports, "css", () => (parcelRequire("3JV9M")).css);
$parcel$export(module.exports, "StyledEngineProvider", () => (parcelRequire("5ITL1")).default);
$parcel$export(module.exports, "GlobalStyles", () => (parcelRequire("lMsz6")).default);
/**
 * @mui/styled-engine v5.18.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $iGH60 = parcelRequire("iGH60");

var $42i5o = parcelRequire("42i5o");

var $3JV9M = parcelRequire("3JV9M");
var $iHk77 = parcelRequire("iHk77");

var $5ITL1 = parcelRequire("5ITL1");

var $lMsz6 = parcelRequire("lMsz6");
'use client';
function $5b22ed62fb95b4f4$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $iGH60.default)(tag, options);
    return (...styles)=>{
        const component = typeof tag === 'string' ? `"${tag}"` : 'component';
        if (styles.length === 0) console.error([
            `MUI: Seems like you called \`styled(${component})()\` without a \`style\` argument.`,
            'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'
        ].join('\n'));
        else if (styles.some((style)=>style === undefined)) console.error(`MUI: the styled(${component})(...args) API requires all its args to be defined.`);
        return stylesFactory(...styles);
    };
}
const $5b22ed62fb95b4f4$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};
// Emotion only accepts an array, but we want to avoid allocations
const $5b22ed62fb95b4f4$var$wrapper = [];
function $5b22ed62fb95b4f4$export$13a2d3ef13012b32(styles) {
    $5b22ed62fb95b4f4$var$wrapper[0] = styles;
    return (0, $42i5o.serializeStyles)($5b22ed62fb95b4f4$var$wrapper);
}

});
parcelRegister("iGH60", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9ad9428e5551a23$export$2e2bcd8739ae039);

var $aTd9r = parcelRequire("aTd9r");
parcelRequire("5mb8k");

parcelRequire("42i5o");
parcelRequire("aGMlr");
parcelRequire("f2aKd");
parcelRequire("8T3gX");
parcelRequire("a2t1f");
var $d9ad9428e5551a23$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $d9ad9428e5551a23$export$2e2bcd8739ae039 = (0, $aTd9r.default).bind(null);
$d9ad9428e5551a23$var$tags.forEach(function(tagName) {
    $d9ad9428e5551a23$export$2e2bcd8739ae039[tagName] = $d9ad9428e5551a23$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("aTd9r", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ed93dfe4e218525$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");
parcelRequire("3JV9M");
var $iHk77 = parcelRequire("iHk77");

var $42i5o = parcelRequire("42i5o");

var $aGMlr = parcelRequire("aGMlr");

var $f2aKd = parcelRequire("f2aKd");

var $8T3gX = parcelRequire("8T3gX");

var $a2t1f = parcelRequire("a2t1f");
var $7ed93dfe4e218525$var$isBrowser = typeof document !== 'undefined';
var $7ed93dfe4e218525$var$isDevelopment = false;
var $7ed93dfe4e218525$var$testOmitPropsOnStringTag = (0, $a2t1f.default);
var $7ed93dfe4e218525$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $7ed93dfe4e218525$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $7ed93dfe4e218525$var$testOmitPropsOnStringTag : $7ed93dfe4e218525$var$testOmitPropsOnComponent;
};
var $7ed93dfe4e218525$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $7ed93dfe4e218525$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $f2aKd.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $aGMlr.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $f2aKd.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$7ed93dfe4e218525$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $8T3gX.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $7ed93dfe4e218525$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $7ed93dfe4e218525$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $7ed93dfe4e218525$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $iHk77.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $8T3gX.useContext((0, $iHk77.T));
            }
            if (typeof props.className === 'string') className = (0, $f2aKd.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $42i5o.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $7ed93dfe4e218525$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $8T3gX.createElement($8T3gX.Fragment, null, /*#__PURE__*/ $8T3gX.createElement($7ed93dfe4e218525$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $8T3gX.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $7ed93dfe4e218525$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $eJfrs.default)({}, options, nextOptions, {
                shouldForwardProp: $7ed93dfe4e218525$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("eJfrs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab913f14053e1f45$export$2e2bcd8739ae039);
function $ab913f14053e1f45$export$2e2bcd8739ae039() {
    return $ab913f14053e1f45$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ab913f14053e1f45$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("3JV9M", function(module, exports) {

$parcel$export(module.exports, "Global", () => $2b91e9321c2536e0$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $2b91e9321c2536e0$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $2b91e9321c2536e0$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("iHk77")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("iHk77")).w);

var $iHk77 = parcelRequire("iHk77");

var $8T3gX = parcelRequire("8T3gX");

var $f2aKd = parcelRequire("f2aKd");

var $aGMlr = parcelRequire("aGMlr");

var $42i5o = parcelRequire("42i5o");
parcelRequire("ixydH");
parcelRequire("5mb8k");
parcelRequire("7hKne");

parcelRequire("2k72C");
var $2b91e9321c2536e0$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $iHk77.h).call(props, 'css')) return $8T3gX.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $iHk77.E);
    createElementArgArray[1] = (0, $iHk77.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $8T3gX.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($2b91e9321c2536e0$export$c8a8987d4410bf2d || ($2b91e9321c2536e0$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $2b91e9321c2536e0$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $iHk77.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $42i5o.serializeStyles)([
        styles
    ], undefined, $8T3gX.useContext((0, $iHk77.T)));
    if (!(0, $iHk77.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $8T3gX.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $8T3gX.useRef();
    (0, $aGMlr.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $aGMlr.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $f2aKd.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $2b91e9321c2536e0$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $42i5o.serializeStyles)(args);
}
function $2b91e9321c2536e0$export$d25ddfdf17c3ad3e() {
    var insertable = $2b91e9321c2536e0$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $2b91e9321c2536e0$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $2b91e9321c2536e0$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $f2aKd.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $2b91e9321c2536e0$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $aGMlr.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $f2aKd.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $iHk77.i) && res !== undefined) rules += res;
        }
        if (!(0, $iHk77.i)) return rules;
    });
    if (!(0, $iHk77.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $8T3gX.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $2b91e9321c2536e0$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $iHk77.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $iHk77.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $42i5o.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $f2aKd.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $iHk77.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $2b91e9321c2536e0$var$merge(cache.registered, css, $2b91e9321c2536e0$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $8T3gX.useContext((0, $iHk77.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $8T3gX.createElement($8T3gX.Fragment, null, /*#__PURE__*/ $8T3gX.createElement($2b91e9321c2536e0$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("iHk77", function(module, exports) {

$parcel$export(module.exports, "a", () => $d9cbd85395178628$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $d9cbd85395178628$export$23f2a1d2818174ef);
$parcel$export(module.exports, "C", () => $d9cbd85395178628$export$e7094788287c5e9b);
$parcel$export(module.exports, "w", () => $d9cbd85395178628$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $d9cbd85395178628$export$971d5caa766a69d7);
$parcel$export(module.exports, "b", () => $d9cbd85395178628$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "h", () => $d9cbd85395178628$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $d9cbd85395178628$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $d9cbd85395178628$export$a9c23c6ac3fc3eca);

var $8T3gX = parcelRequire("8T3gX");

var $ixydH = parcelRequire("ixydH");

var $eJfrs = parcelRequire("eJfrs");

var $7hKne = parcelRequire("7hKne");

var $eqD8X = parcelRequire("eqD8X");

var $f2aKd = parcelRequire("f2aKd");

var $42i5o = parcelRequire("42i5o");

var $aGMlr = parcelRequire("aGMlr");
var $d9cbd85395178628$export$407448d2b89b1813 = false;
var $d9cbd85395178628$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $d9cbd85395178628$var$EmotionCacheContext = /* #__PURE__ */ $8T3gX.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $ixydH.default)({
    key: 'css'
}) : null);
var $d9cbd85395178628$export$e7094788287c5e9b = $d9cbd85395178628$var$EmotionCacheContext.Provider;
var $d9cbd85395178628$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $8T3gX.useContext)($d9cbd85395178628$var$EmotionCacheContext);
};
var $d9cbd85395178628$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $8T3gX.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $8T3gX.useContext)($d9cbd85395178628$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$d9cbd85395178628$export$23f2a1d2818174ef) $d9cbd85395178628$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $8T3gX.useContext)($d9cbd85395178628$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $ixydH.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $8T3gX.createElement($d9cbd85395178628$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $d9cbd85395178628$export$971d5caa766a69d7 = /* #__PURE__ */ $8T3gX.createContext({});
var $d9cbd85395178628$export$3b14a55fb2447963 = function useTheme() {
    return $8T3gX.useContext($d9cbd85395178628$export$971d5caa766a69d7);
};
var $d9cbd85395178628$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $eJfrs.default)({}, outerTheme, theme);
};
var $d9cbd85395178628$var$createCacheWithTheme = /* #__PURE__ */ (0, $7hKne.default)(function(outerTheme) {
    return (0, $7hKne.default)(function(theme) {
        return $d9cbd85395178628$var$getTheme(outerTheme, theme);
    });
});
var $d9cbd85395178628$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $8T3gX.useContext($d9cbd85395178628$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $d9cbd85395178628$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $8T3gX.createElement($d9cbd85395178628$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $d9cbd85395178628$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $8T3gX.forwardRef(function render(props, ref) {
        var theme = $8T3gX.useContext($d9cbd85395178628$export$971d5caa766a69d7);
        return /*#__PURE__*/ $8T3gX.createElement(Component, (0, $eJfrs.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $eqD8X.default)(WithTheme, Component);
}
var $d9cbd85395178628$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $d9cbd85395178628$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $d9cbd85395178628$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($d9cbd85395178628$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$d9cbd85395178628$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $d9cbd85395178628$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $f2aKd.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $aGMlr.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $f2aKd.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$d9cbd85395178628$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $8T3gX.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $d9cbd85395178628$var$Emotion = /* #__PURE__ */ $d9cbd85395178628$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$d9cbd85395178628$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $f2aKd.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $42i5o.serializeStyles)(registeredStyles, undefined, $8T3gX.useContext($d9cbd85395178628$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($d9cbd85395178628$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $d9cbd85395178628$var$typePropName && !$d9cbd85395178628$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $8T3gX.createElement($8T3gX.Fragment, null, /*#__PURE__*/ $8T3gX.createElement($d9cbd85395178628$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $8T3gX.createElement(WrappedComponent, newProps));
});
var $d9cbd85395178628$export$a9c23c6ac3fc3eca = $d9cbd85395178628$var$Emotion;

});
parcelRegister("ixydH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7f5da6c539777af$export$2e2bcd8739ae039);

var $8ThhO = parcelRequire("8ThhO");

var $gkjyM = parcelRequire("gkjyM");

var $7hKne = parcelRequire("7hKne");

var $lMLEj = parcelRequire("lMLEj");
var $d7f5da6c539777af$var$isBrowser = typeof document !== 'undefined';
var $d7f5da6c539777af$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $gkjyM.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $gkjyM.token)(character)) break;
        (0, $gkjyM.next)();
    }
    return (0, $gkjyM.slice)(begin, (0, $gkjyM.position));
};
var $d7f5da6c539777af$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $gkjyM.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $gkjyM.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $d7f5da6c539777af$var$identifierWithPointTracking((0, $gkjyM.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $gkjyM.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $gkjyM.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $gkjyM.from)(character);
    }
    while (character = (0, $gkjyM.next)());
    return parsed;
};
var $d7f5da6c539777af$var$getRules = function getRules(value, points) {
    return (0, $gkjyM.dealloc)($d7f5da6c539777af$var$toRules((0, $gkjyM.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $d7f5da6c539777af$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $d7f5da6c539777af$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$d7f5da6c539777af$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $d7f5da6c539777af$var$fixedElements.set(element, true);
    var points = [];
    var rules = $d7f5da6c539777af$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $d7f5da6c539777af$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $d7f5da6c539777af$var$prefix(value, length) {
    switch((0, $gkjyM.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $gkjyM.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $gkjyM.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $gkjyM.WEBKIT) + value + (0, $gkjyM.MOZ) + value + (0, $gkjyM.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $gkjyM.WEBKIT) + value + (0, $gkjyM.MS) + value + value;
        // order
        case 6165:
            return (0, $gkjyM.WEBKIT) + value + (0, $gkjyM.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $gkjyM.WEBKIT) + value + (0, $gkjyM.replace)(value, /(\w+).+(:[^]+)/, (0, $gkjyM.WEBKIT) + 'box-$1$2' + (0, $gkjyM.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $gkjyM.WEBKIT) + value + (0, $gkjyM.MS) + 'flex-item-' + (0, $gkjyM.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $gkjyM.WEBKIT) + value + (0, $gkjyM.MS) + 'flex-line-pack' + (0, $gkjyM.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $gkjyM.WEBKIT) + value + (0, $gkjyM.MS) + (0, $gkjyM.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $gkjyM.WEBKIT) + value + (0, $gkjyM.MS) + (0, $gkjyM.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $gkjyM.WEBKIT) + 'box-' + (0, $gkjyM.replace)(value, '-grow', '') + (0, $gkjyM.WEBKIT) + value + (0, $gkjyM.MS) + (0, $gkjyM.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $gkjyM.WEBKIT) + (0, $gkjyM.replace)(value, /([^-])(transform)/g, '$1' + (0, $gkjyM.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $gkjyM.replace)((0, $gkjyM.replace)((0, $gkjyM.replace)(value, /(zoom-|grab)/, (0, $gkjyM.WEBKIT) + '$1'), /(image-set)/, (0, $gkjyM.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $gkjyM.replace)(value, /(image-set\([^]*)/, (0, $gkjyM.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $gkjyM.replace)((0, $gkjyM.replace)(value, /(.+:)(flex-)?(.*)/, (0, $gkjyM.WEBKIT) + 'box-pack:$3' + (0, $gkjyM.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $gkjyM.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $gkjyM.replace)(value, /(.+)-inline(.+)/, (0, $gkjyM.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $gkjyM.strlen)(value) - 1 - length > 6) switch((0, $gkjyM.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $gkjyM.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $gkjyM.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $gkjyM.WEBKIT) + '$2-$3' + '$1' + (0, $gkjyM.MOZ) + ((0, $gkjyM.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $gkjyM.indexof)(value, 'stretch') ? $d7f5da6c539777af$var$prefix((0, $gkjyM.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $gkjyM.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $gkjyM.charat)(value, (0, $gkjyM.strlen)(value) - 3 - (~(0, $gkjyM.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $gkjyM.replace)(value, ':', ':' + (0, $gkjyM.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $gkjyM.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $gkjyM.WEBKIT) + ((0, $gkjyM.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $gkjyM.WEBKIT) + '$2$3' + '$1' + (0, $gkjyM.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $gkjyM.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $gkjyM.WEBKIT) + value + (0, $gkjyM.MS) + (0, $gkjyM.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $gkjyM.WEBKIT) + value + (0, $gkjyM.MS) + (0, $gkjyM.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $gkjyM.WEBKIT) + value + (0, $gkjyM.MS) + (0, $gkjyM.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $gkjyM.WEBKIT) + value + (0, $gkjyM.MS) + value + value;
    }
    return value;
}
var $d7f5da6c539777af$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $gkjyM.DECLARATION:
                element["return"] = $d7f5da6c539777af$var$prefix(element.value, element.length);
                break;
            case 0, $gkjyM.KEYFRAMES:
                return (0, $gkjyM.serialize)([
                    (0, $gkjyM.copy)(element, {
                        value: (0, $gkjyM.replace)(element.value, '@', '@' + (0, $gkjyM.WEBKIT))
                    })
                ], callback);
            case 0, $gkjyM.RULESET:
                if (element.length) return (0, $gkjyM.combine)(element.props, function(value) {
                    switch((0, $gkjyM.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $gkjyM.serialize)([
                                (0, $gkjyM.copy)(element, {
                                    props: [
                                        (0, $gkjyM.replace)(value, /:(read-\w+)/, ':' + (0, $gkjyM.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $gkjyM.serialize)([
                                (0, $gkjyM.copy)(element, {
                                    props: [
                                        (0, $gkjyM.replace)(value, /:(plac\w+)/, ':' + (0, $gkjyM.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $gkjyM.copy)(element, {
                                    props: [
                                        (0, $gkjyM.replace)(value, /:(plac\w+)/, ':' + (0, $gkjyM.MOZ) + '$1')
                                    ]
                                }),
                                (0, $gkjyM.copy)(element, {
                                    props: [
                                        (0, $gkjyM.replace)(value, /:(plac\w+)/, (0, $gkjyM.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $d7f5da6c539777af$var$getServerStylisCache = $d7f5da6c539777af$var$isBrowser ? undefined : (0, $7hKne.default)(function() {
    return (0, $lMLEj.default)(function() {
        return {};
    });
});
var $d7f5da6c539777af$var$defaultStylisPlugins = [
    $d7f5da6c539777af$var$prefixer
];
var $d7f5da6c539777af$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($d7f5da6c539777af$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $d7f5da6c539777af$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($d7f5da6c539777af$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $d7f5da6c539777af$var$compat,
        $d7f5da6c539777af$var$removeLabel
    ];
    if (!$d7f5da6c539777af$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $gkjyM.stringify),
            (0, $gkjyM.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $gkjyM.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $gkjyM.serialize)((0, $gkjyM.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $gkjyM.stringify)
        ];
        var _serializer = (0, $gkjyM.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $gkjyM.serialize)((0, $gkjyM.compile)(styles), _serializer);
        };
        var serverStylisCache = $d7f5da6c539777af$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $8ThhO.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("8ThhO", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $6790de765bfb681e$export$9d753cd7ae895cce);
var $6790de765bfb681e$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $6790de765bfb681e$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $6790de765bfb681e$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $6790de765bfb681e$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$6790de765bfb681e$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($6790de765bfb681e$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $6790de765bfb681e$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("gkjyM", function(module, exports) {

$parcel$export(module.exports, "MS", () => $63d7f7f1e984e0f3$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $63d7f7f1e984e0f3$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $63d7f7f1e984e0f3$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $63d7f7f1e984e0f3$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $63d7f7f1e984e0f3$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $63d7f7f1e984e0f3$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $63d7f7f1e984e0f3$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $63d7f7f1e984e0f3$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $63d7f7f1e984e0f3$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $63d7f7f1e984e0f3$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $63d7f7f1e984e0f3$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $63d7f7f1e984e0f3$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $63d7f7f1e984e0f3$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $63d7f7f1e984e0f3$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $63d7f7f1e984e0f3$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $63d7f7f1e984e0f3$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $63d7f7f1e984e0f3$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $63d7f7f1e984e0f3$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $63d7f7f1e984e0f3$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $63d7f7f1e984e0f3$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $63d7f7f1e984e0f3$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $63d7f7f1e984e0f3$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $63d7f7f1e984e0f3$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $63d7f7f1e984e0f3$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $63d7f7f1e984e0f3$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $63d7f7f1e984e0f3$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $63d7f7f1e984e0f3$export$38bcb760f1d4871c);
var $63d7f7f1e984e0f3$export$71ad59f2e432cfe8 = "-ms-";
var $63d7f7f1e984e0f3$export$2c0f367103c8d01c = "-moz-";
var $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 = "-webkit-";
var $63d7f7f1e984e0f3$export$a29989082612d0d9 = "comm";
var $63d7f7f1e984e0f3$export$aa3a2e812ca8570d = "rule";
var $63d7f7f1e984e0f3$export$527d108ccf083c2b = "decl";
var $63d7f7f1e984e0f3$export$d3d35020fa5b54f0 = "@page";
var $63d7f7f1e984e0f3$export$500415a86c544f73 = "@media";
var $63d7f7f1e984e0f3$export$a763edbf796b780a = "@import";
var $63d7f7f1e984e0f3$export$2790aeb8b4e5c826 = "@charset";
var $63d7f7f1e984e0f3$export$1cc683e23b84b133 = "@viewport";
var $63d7f7f1e984e0f3$export$9447a5efea57e862 = "@supports";
var $63d7f7f1e984e0f3$export$ef011b4e114b1fba = "@document";
var $63d7f7f1e984e0f3$export$6aad947bda0f3f46 = "@namespace";
var $63d7f7f1e984e0f3$export$b44a8529a35fcb60 = "@keyframes";
var $63d7f7f1e984e0f3$export$2c16de31893252e6 = "@font-face";
var $63d7f7f1e984e0f3$export$3d846dd52e150c6f = "@counter-style";
var $63d7f7f1e984e0f3$export$22314bfbb57653fe = "@font-feature-values";
var $63d7f7f1e984e0f3$export$d773506282b3cfe6 = "@layer";
var $63d7f7f1e984e0f3$export$2335f513bbd82c6d = Math.abs;
var $63d7f7f1e984e0f3$export$6788812c4e6611e6 = String.fromCharCode;
var $63d7f7f1e984e0f3$export$e6e34fd1f2686227 = Object.assign;
function $63d7f7f1e984e0f3$export$d6af199866bfb566(e, r) {
    return $63d7f7f1e984e0f3$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $63d7f7f1e984e0f3$export$a9db5e087081082d(e, 0)) << 2 ^ $63d7f7f1e984e0f3$export$a9db5e087081082d(e, 1)) << 2 ^ $63d7f7f1e984e0f3$export$a9db5e087081082d(e, 2)) << 2 ^ $63d7f7f1e984e0f3$export$a9db5e087081082d(e, 3) : 0;
}
function $63d7f7f1e984e0f3$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $63d7f7f1e984e0f3$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $63d7f7f1e984e0f3$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $63d7f7f1e984e0f3$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $63d7f7f1e984e0f3$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $63d7f7f1e984e0f3$export$36776f635604f274(e) {
    return e.length;
}
function $63d7f7f1e984e0f3$export$f9084667e487ed46(e) {
    return e.length;
}
function $63d7f7f1e984e0f3$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $63d7f7f1e984e0f3$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $63d7f7f1e984e0f3$export$53f1d5ea8de3d7c = 1;
var $63d7f7f1e984e0f3$export$4e0c71f277ca26b3 = 1;
var $63d7f7f1e984e0f3$export$f24224f1c91d8156 = 0;
var $63d7f7f1e984e0f3$export$5880b8b5730aff45 = 0;
var $63d7f7f1e984e0f3$export$c0306caf338ac095 = 0;
var $63d7f7f1e984e0f3$export$30a86d91af8ff6e6 = "";
function $63d7f7f1e984e0f3$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $63d7f7f1e984e0f3$export$53f1d5ea8de3d7c,
        column: $63d7f7f1e984e0f3$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $63d7f7f1e984e0f3$export$784d13d8ee351f07(e, r) {
    return $63d7f7f1e984e0f3$export$e6e34fd1f2686227($63d7f7f1e984e0f3$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $63d7f7f1e984e0f3$export$eba6f6f03b0a92e7() {
    return $63d7f7f1e984e0f3$export$c0306caf338ac095;
}
function $63d7f7f1e984e0f3$export$232faf9add678146() {
    $63d7f7f1e984e0f3$export$c0306caf338ac095 = $63d7f7f1e984e0f3$export$5880b8b5730aff45 > 0 ? $63d7f7f1e984e0f3$export$a9db5e087081082d($63d7f7f1e984e0f3$export$30a86d91af8ff6e6, --$63d7f7f1e984e0f3$export$5880b8b5730aff45) : 0;
    if ($63d7f7f1e984e0f3$export$4e0c71f277ca26b3--, $63d7f7f1e984e0f3$export$c0306caf338ac095 === 10) $63d7f7f1e984e0f3$export$4e0c71f277ca26b3 = 1, $63d7f7f1e984e0f3$export$53f1d5ea8de3d7c--;
    return $63d7f7f1e984e0f3$export$c0306caf338ac095;
}
function $63d7f7f1e984e0f3$export$48cfd1e771a65c4f() {
    $63d7f7f1e984e0f3$export$c0306caf338ac095 = $63d7f7f1e984e0f3$export$5880b8b5730aff45 < $63d7f7f1e984e0f3$export$f24224f1c91d8156 ? $63d7f7f1e984e0f3$export$a9db5e087081082d($63d7f7f1e984e0f3$export$30a86d91af8ff6e6, $63d7f7f1e984e0f3$export$5880b8b5730aff45++) : 0;
    if ($63d7f7f1e984e0f3$export$4e0c71f277ca26b3++, $63d7f7f1e984e0f3$export$c0306caf338ac095 === 10) $63d7f7f1e984e0f3$export$4e0c71f277ca26b3 = 1, $63d7f7f1e984e0f3$export$53f1d5ea8de3d7c++;
    return $63d7f7f1e984e0f3$export$c0306caf338ac095;
}
function $63d7f7f1e984e0f3$export$4d3fb11e950abb9e() {
    return $63d7f7f1e984e0f3$export$a9db5e087081082d($63d7f7f1e984e0f3$export$30a86d91af8ff6e6, $63d7f7f1e984e0f3$export$5880b8b5730aff45);
}
function $63d7f7f1e984e0f3$export$e88cb2efb12ae807() {
    return $63d7f7f1e984e0f3$export$5880b8b5730aff45;
}
function $63d7f7f1e984e0f3$export$58adb3bec8346d0f(e, r) {
    return $63d7f7f1e984e0f3$export$2f35ab04d2335697($63d7f7f1e984e0f3$export$30a86d91af8ff6e6, e, r);
}
function $63d7f7f1e984e0f3$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $63d7f7f1e984e0f3$export$2de70f21292aac9e(e) {
    return $63d7f7f1e984e0f3$export$53f1d5ea8de3d7c = $63d7f7f1e984e0f3$export$4e0c71f277ca26b3 = 1, $63d7f7f1e984e0f3$export$f24224f1c91d8156 = $63d7f7f1e984e0f3$export$36776f635604f274($63d7f7f1e984e0f3$export$30a86d91af8ff6e6 = e), $63d7f7f1e984e0f3$export$5880b8b5730aff45 = 0, [];
}
function $63d7f7f1e984e0f3$export$45918ac1574455b1(e) {
    return $63d7f7f1e984e0f3$export$30a86d91af8ff6e6 = "", e;
}
function $63d7f7f1e984e0f3$export$410ac95b9ec204b8(e) {
    return $63d7f7f1e984e0f3$export$87c2784dc9fc4ab($63d7f7f1e984e0f3$export$58adb3bec8346d0f($63d7f7f1e984e0f3$export$5880b8b5730aff45 - 1, $63d7f7f1e984e0f3$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $63d7f7f1e984e0f3$export$660b2ee2d4fb4eff(e) {
    return $63d7f7f1e984e0f3$export$45918ac1574455b1($63d7f7f1e984e0f3$export$5f8c09e3ae6f64e1($63d7f7f1e984e0f3$export$2de70f21292aac9e(e)));
}
function $63d7f7f1e984e0f3$export$7af1228ff777d175(e) {
    while($63d7f7f1e984e0f3$export$c0306caf338ac095 = $63d7f7f1e984e0f3$export$4d3fb11e950abb9e())if ($63d7f7f1e984e0f3$export$c0306caf338ac095 < 33) $63d7f7f1e984e0f3$export$48cfd1e771a65c4f();
    else break;
    return $63d7f7f1e984e0f3$export$9e1725a4cfeada27(e) > 2 || $63d7f7f1e984e0f3$export$9e1725a4cfeada27($63d7f7f1e984e0f3$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $63d7f7f1e984e0f3$export$5f8c09e3ae6f64e1(e) {
    while($63d7f7f1e984e0f3$export$48cfd1e771a65c4f())switch($63d7f7f1e984e0f3$export$9e1725a4cfeada27($63d7f7f1e984e0f3$export$c0306caf338ac095)){
        case 0:
            $63d7f7f1e984e0f3$export$10d8903dec122b9d($63d7f7f1e984e0f3$export$c2ab62c7bf24634($63d7f7f1e984e0f3$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $63d7f7f1e984e0f3$export$10d8903dec122b9d($63d7f7f1e984e0f3$export$410ac95b9ec204b8($63d7f7f1e984e0f3$export$c0306caf338ac095), e);
            break;
        default:
            $63d7f7f1e984e0f3$export$10d8903dec122b9d($63d7f7f1e984e0f3$export$6788812c4e6611e6($63d7f7f1e984e0f3$export$c0306caf338ac095), e);
    }
    return e;
}
function $63d7f7f1e984e0f3$export$955ba06d119e085e(e, r) {
    while(--r && $63d7f7f1e984e0f3$export$48cfd1e771a65c4f())if ($63d7f7f1e984e0f3$export$c0306caf338ac095 < 48 || $63d7f7f1e984e0f3$export$c0306caf338ac095 > 102 || $63d7f7f1e984e0f3$export$c0306caf338ac095 > 57 && $63d7f7f1e984e0f3$export$c0306caf338ac095 < 65 || $63d7f7f1e984e0f3$export$c0306caf338ac095 > 70 && $63d7f7f1e984e0f3$export$c0306caf338ac095 < 97) break;
    return $63d7f7f1e984e0f3$export$58adb3bec8346d0f(e, $63d7f7f1e984e0f3$export$e88cb2efb12ae807() + (r < 6 && $63d7f7f1e984e0f3$export$4d3fb11e950abb9e() == 32 && $63d7f7f1e984e0f3$export$48cfd1e771a65c4f() == 32));
}
function $63d7f7f1e984e0f3$export$c889f2fcc19dbf12(e) {
    while($63d7f7f1e984e0f3$export$48cfd1e771a65c4f())switch($63d7f7f1e984e0f3$export$c0306caf338ac095){
        case e:
            return $63d7f7f1e984e0f3$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $63d7f7f1e984e0f3$export$c889f2fcc19dbf12($63d7f7f1e984e0f3$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $63d7f7f1e984e0f3$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $63d7f7f1e984e0f3$export$48cfd1e771a65c4f();
            break;
    }
    return $63d7f7f1e984e0f3$export$5880b8b5730aff45;
}
function $63d7f7f1e984e0f3$export$4254d4e2b3745c4c(e, r) {
    while($63d7f7f1e984e0f3$export$48cfd1e771a65c4f())if (e + $63d7f7f1e984e0f3$export$c0306caf338ac095 === 57) break;
    else if (e + $63d7f7f1e984e0f3$export$c0306caf338ac095 === 84 && $63d7f7f1e984e0f3$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $63d7f7f1e984e0f3$export$58adb3bec8346d0f(r, $63d7f7f1e984e0f3$export$5880b8b5730aff45 - 1) + "*" + $63d7f7f1e984e0f3$export$6788812c4e6611e6(e === 47 ? e : $63d7f7f1e984e0f3$export$48cfd1e771a65c4f());
}
function $63d7f7f1e984e0f3$export$c2ab62c7bf24634(e) {
    while(!$63d7f7f1e984e0f3$export$9e1725a4cfeada27($63d7f7f1e984e0f3$export$4d3fb11e950abb9e()))$63d7f7f1e984e0f3$export$48cfd1e771a65c4f();
    return $63d7f7f1e984e0f3$export$58adb3bec8346d0f(e, $63d7f7f1e984e0f3$export$5880b8b5730aff45);
}
function $63d7f7f1e984e0f3$export$ef7acd7185315e22(e) {
    return $63d7f7f1e984e0f3$export$45918ac1574455b1($63d7f7f1e984e0f3$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $63d7f7f1e984e0f3$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $63d7f7f1e984e0f3$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $63d7f7f1e984e0f3$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $63d7f7f1e984e0f3$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($63d7f7f1e984e0f3$export$f8e21b1e77979a08(j += $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed($63d7f7f1e984e0f3$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $63d7f7f1e984e0f3$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $63d7f7f1e984e0f3$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $63d7f7f1e984e0f3$export$955ba06d119e085e($63d7f7f1e984e0f3$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($63d7f7f1e984e0f3$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $63d7f7f1e984e0f3$export$10d8903dec122b9d($63d7f7f1e984e0f3$export$4a34f930e789283c($63d7f7f1e984e0f3$export$4254d4e2b3745c4c($63d7f7f1e984e0f3$export$48cfd1e771a65c4f(), $63d7f7f1e984e0f3$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $63d7f7f1e984e0f3$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $63d7f7f1e984e0f3$export$36776f635604f274(j) - l) $63d7f7f1e984e0f3$export$10d8903dec122b9d(p > 32 ? $63d7f7f1e984e0f3$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $63d7f7f1e984e0f3$export$f8483753829ec8f3($63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $63d7f7f1e984e0f3$export$10d8903dec122b9d(y = $63d7f7f1e984e0f3$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $63d7f7f1e984e0f3$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $63d7f7f1e984e0f3$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $63d7f7f1e984e0f3$export$98e6a39c04603d36(e, y, y, n && $63d7f7f1e984e0f3$export$10d8903dec122b9d($63d7f7f1e984e0f3$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $63d7f7f1e984e0f3$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $63d7f7f1e984e0f3$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $63d7f7f1e984e0f3$export$232faf9add678146() == 125) continue;
            }
            switch(j += $63d7f7f1e984e0f3$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($63d7f7f1e984e0f3$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($63d7f7f1e984e0f3$export$4d3fb11e950abb9e() === 45) j += $63d7f7f1e984e0f3$export$410ac95b9ec204b8($63d7f7f1e984e0f3$export$48cfd1e771a65c4f());
                    v = $63d7f7f1e984e0f3$export$4d3fb11e950abb9e(), o = l = $63d7f7f1e984e0f3$export$36776f635604f274(g = j += $63d7f7f1e984e0f3$export$c2ab62c7bf24634($63d7f7f1e984e0f3$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $63d7f7f1e984e0f3$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $63d7f7f1e984e0f3$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $63d7f7f1e984e0f3$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $63d7f7f1e984e0f3$export$2f35ab04d2335697(e, v + 1, v = $63d7f7f1e984e0f3$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $63d7f7f1e984e0f3$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $63d7f7f1e984e0f3$export$35059013cd4a06db(e, r, a, s === 0 ? $63d7f7f1e984e0f3$export$aa3a2e812ca8570d : i, f, o, l);
}
function $63d7f7f1e984e0f3$export$4a34f930e789283c(e, r, a) {
    return $63d7f7f1e984e0f3$export$35059013cd4a06db(e, r, a, $63d7f7f1e984e0f3$export$a29989082612d0d9, $63d7f7f1e984e0f3$export$6788812c4e6611e6($63d7f7f1e984e0f3$export$eba6f6f03b0a92e7()), $63d7f7f1e984e0f3$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $63d7f7f1e984e0f3$export$f8483753829ec8f3(e, r, a, n) {
    return $63d7f7f1e984e0f3$export$35059013cd4a06db(e, r, a, $63d7f7f1e984e0f3$export$527d108ccf083c2b, $63d7f7f1e984e0f3$export$2f35ab04d2335697(e, 0, n), $63d7f7f1e984e0f3$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $63d7f7f1e984e0f3$export$82e9f45cca5ba907(n, c, s) {
    switch($63d7f7f1e984e0f3$export$d6af199866bfb566(n, c)){
        case 5103:
            return $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $63d7f7f1e984e0f3$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + n + $63d7f7f1e984e0f3$export$2c0f367103c8d01c + n + $63d7f7f1e984e0f3$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($63d7f7f1e984e0f3$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + n + $63d7f7f1e984e0f3$export$71ad59f2e432cfe8 + $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + n + $63d7f7f1e984e0f3$export$71ad59f2e432cfe8 + $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + n + $63d7f7f1e984e0f3$export$71ad59f2e432cfe8 + $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + n + $63d7f7f1e984e0f3$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + n + $63d7f7f1e984e0f3$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + n + $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + "box-$1$2" + $63d7f7f1e984e0f3$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + n + $63d7f7f1e984e0f3$export$71ad59f2e432cfe8 + "flex-item-" + $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$63d7f7f1e984e0f3$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $63d7f7f1e984e0f3$export$71ad59f2e432cfe8 + "grid-row-" + $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + n + $63d7f7f1e984e0f3$export$71ad59f2e432cfe8 + "flex-line-pack" + $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + n + $63d7f7f1e984e0f3$export$71ad59f2e432cfe8 + $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + n + $63d7f7f1e984e0f3$export$71ad59f2e432cfe8 + $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + "box-" + $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n, "-grow", "") + $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + n + $63d7f7f1e984e0f3$export$71ad59f2e432cfe8 + $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed($63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed($63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed($63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + "box-pack:$3" + $63d7f7f1e984e0f3$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$63d7f7f1e984e0f3$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $63d7f7f1e984e0f3$export$71ad59f2e432cfe8 + "grid-column-align" + $63d7f7f1e984e0f3$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $63d7f7f1e984e0f3$export$71ad59f2e432cfe8 + $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $63d7f7f1e984e0f3$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$63d7f7f1e984e0f3$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $63d7f7f1e984e0f3$export$71ad59f2e432cfe8 + $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $63d7f7f1e984e0f3$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$63d7f7f1e984e0f3$export$f8e21b1e77979a08(s, "span") ? $63d7f7f1e984e0f3$export$4659b591c19bdf3d(s, /\d+/) : +$63d7f7f1e984e0f3$export$4659b591c19bdf3d(s, /\d+/) - +$63d7f7f1e984e0f3$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $63d7f7f1e984e0f3$export$71ad59f2e432cfe8 + $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $63d7f7f1e984e0f3$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $63d7f7f1e984e0f3$export$71ad59f2e432cfe8 + $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed($63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($63d7f7f1e984e0f3$export$36776f635604f274(n) - 1 - c > 6) switch($63d7f7f1e984e0f3$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($63d7f7f1e984e0f3$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $63d7f7f1e984e0f3$export$2c0f367103c8d01c + ($63d7f7f1e984e0f3$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$63d7f7f1e984e0f3$export$f8e21b1e77979a08(n, "stretch") ? $63d7f7f1e984e0f3$export$82e9f45cca5ba907($63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $63d7f7f1e984e0f3$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $63d7f7f1e984e0f3$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($63d7f7f1e984e0f3$export$a9db5e087081082d(n, c + 6) === 121) return $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n, ":", ":" + $63d7f7f1e984e0f3$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($63d7f7f1e984e0f3$export$a9db5e087081082d(n, $63d7f7f1e984e0f3$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + ($63d7f7f1e984e0f3$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $63d7f7f1e984e0f3$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n, ":", ":" + $63d7f7f1e984e0f3$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $63d7f7f1e984e0f3$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $63d7f7f1e984e0f3$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $63d7f7f1e984e0f3$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $63d7f7f1e984e0f3$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $63d7f7f1e984e0f3$export$a763edbf796b780a:
        case $63d7f7f1e984e0f3$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $63d7f7f1e984e0f3$export$a29989082612d0d9:
            return "";
        case $63d7f7f1e984e0f3$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $63d7f7f1e984e0f3$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $63d7f7f1e984e0f3$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $63d7f7f1e984e0f3$export$36776f635604f274(a = $63d7f7f1e984e0f3$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $63d7f7f1e984e0f3$export$5a7767152ae0305f(e) {
    var r = $63d7f7f1e984e0f3$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $63d7f7f1e984e0f3$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $63d7f7f1e984e0f3$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $63d7f7f1e984e0f3$export$527d108ccf083c2b:
                n.return = $63d7f7f1e984e0f3$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $63d7f7f1e984e0f3$export$b44a8529a35fcb60:
                return $63d7f7f1e984e0f3$export$dfdc1655ccc5b9cb([
                    $63d7f7f1e984e0f3$export$784d13d8ee351f07(n, {
                        value: $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $63d7f7f1e984e0f3$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $63d7f7f1e984e0f3$export$aa3a2e812ca8570d:
                if (n.length) return $63d7f7f1e984e0f3$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($63d7f7f1e984e0f3$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $63d7f7f1e984e0f3$export$dfdc1655ccc5b9cb([
                                $63d7f7f1e984e0f3$export$784d13d8ee351f07(n, {
                                    props: [
                                        $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $63d7f7f1e984e0f3$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $63d7f7f1e984e0f3$export$dfdc1655ccc5b9cb([
                                $63d7f7f1e984e0f3$export$784d13d8ee351f07(n, {
                                    props: [
                                        $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $63d7f7f1e984e0f3$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $63d7f7f1e984e0f3$export$784d13d8ee351f07(n, {
                                    props: [
                                        $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $63d7f7f1e984e0f3$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $63d7f7f1e984e0f3$export$784d13d8ee351f07(n, {
                                    props: [
                                        $63d7f7f1e984e0f3$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $63d7f7f1e984e0f3$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $63d7f7f1e984e0f3$export$76a88f7de6507443(e) {
    switch(e.type){
        case $63d7f7f1e984e0f3$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $63d7f7f1e984e0f3$export$1be1fc439b849fdf($63d7f7f1e984e0f3$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($63d7f7f1e984e0f3$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $63d7f7f1e984e0f3$export$2f35ab04d2335697(r, 1, $63d7f7f1e984e0f3$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $63d7f7f1e984e0f3$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $63d7f7f1e984e0f3$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $63d7f7f1e984e0f3$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("7hKne", function(module, exports) {

$parcel$export(module.exports, "default", () => $54de17ce3d0589e4$export$2e2bcd8739ae039);
var $54de17ce3d0589e4$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("lMLEj", function(module, exports) {

$parcel$export(module.exports, "default", () => $0417ca7f4e8dcd5c$export$2e2bcd8739ae039);
function $0417ca7f4e8dcd5c$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("eqD8X", function(module, exports) {

$parcel$export(module.exports, "default", () => $a811db73313514c8$export$2e2bcd8739ae039);

var $2k72C = parcelRequire("2k72C");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $a811db73313514c8$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($2k72C)))(targetComponent, sourceComponent);
};

});
parcelRegister("2k72C", function(module, exports) {
'use strict';

var $59DE1 = parcelRequire("59DE1");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $1b12e941a87d6796$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $1b12e941a87d6796$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $1b12e941a87d6796$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $1b12e941a87d6796$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $1b12e941a87d6796$var$TYPE_STATICS = {};
$1b12e941a87d6796$var$TYPE_STATICS[$59DE1.ForwardRef] = $1b12e941a87d6796$var$FORWARD_REF_STATICS;
$1b12e941a87d6796$var$TYPE_STATICS[$59DE1.Memo] = $1b12e941a87d6796$var$MEMO_STATICS;
function $1b12e941a87d6796$var$getStatics(component) {
    // React v16.11 and below
    if ($59DE1.isMemo(component)) return $1b12e941a87d6796$var$MEMO_STATICS;
     // React v16.12 and above
    return $1b12e941a87d6796$var$TYPE_STATICS[component['$$typeof']] || $1b12e941a87d6796$var$REACT_STATICS;
}
var $1b12e941a87d6796$var$defineProperty = Object.defineProperty;
var $1b12e941a87d6796$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $1b12e941a87d6796$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $1b12e941a87d6796$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $1b12e941a87d6796$var$getPrototypeOf = Object.getPrototypeOf;
var $1b12e941a87d6796$var$objectPrototype = Object.prototype;
function $1b12e941a87d6796$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($1b12e941a87d6796$var$objectPrototype) {
            var inheritedComponent = $1b12e941a87d6796$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $1b12e941a87d6796$var$objectPrototype) $1b12e941a87d6796$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $1b12e941a87d6796$var$getOwnPropertyNames(sourceComponent);
        if ($1b12e941a87d6796$var$getOwnPropertySymbols) keys = keys.concat($1b12e941a87d6796$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $1b12e941a87d6796$var$getStatics(targetComponent);
        var sourceStatics = $1b12e941a87d6796$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$1b12e941a87d6796$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $1b12e941a87d6796$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $1b12e941a87d6796$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $1b12e941a87d6796$var$hoistNonReactStatics;

});
parcelRegister("59DE1", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bP8X8"));

});
parcelRegister("bP8X8", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $89bb66f20154b1a6$export$2b8d127b894957b9, (v) => $89bb66f20154b1a6$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $89bb66f20154b1a6$export$cea3a54a6425200c, (v) => $89bb66f20154b1a6$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $89bb66f20154b1a6$export$a7c73072b1a182ae, (v) => $89bb66f20154b1a6$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $89bb66f20154b1a6$export$9f27bc3417b4524d, (v) => $89bb66f20154b1a6$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $89bb66f20154b1a6$export$db77ccec0bb4ccac, (v) => $89bb66f20154b1a6$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $89bb66f20154b1a6$export$8392c0c9d3dcbd35, (v) => $89bb66f20154b1a6$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $89bb66f20154b1a6$export$ffb0004e005737fa, (v) => $89bb66f20154b1a6$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $89bb66f20154b1a6$export$b624eff549462981, (v) => $89bb66f20154b1a6$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $89bb66f20154b1a6$export$7897aa7841a5380c, (v) => $89bb66f20154b1a6$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $89bb66f20154b1a6$export$602eac185826482c, (v) => $89bb66f20154b1a6$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $89bb66f20154b1a6$export$e2c29f18771995cb, (v) => $89bb66f20154b1a6$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $89bb66f20154b1a6$export$5f8d39834fd61797, (v) => $89bb66f20154b1a6$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $89bb66f20154b1a6$export$74bf444e3cd11ea5, (v) => $89bb66f20154b1a6$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $89bb66f20154b1a6$export$92387174baf9b227, (v) => $89bb66f20154b1a6$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $89bb66f20154b1a6$export$ec112efeb987d9c6, (v) => $89bb66f20154b1a6$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $89bb66f20154b1a6$export$b706b080d889d2c9, (v) => $89bb66f20154b1a6$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $89bb66f20154b1a6$export$5be5a87408f70ddc, (v) => $89bb66f20154b1a6$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $89bb66f20154b1a6$export$45a5e7f76e0caa8d, (v) => $89bb66f20154b1a6$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $89bb66f20154b1a6$export$455c2e768291efa6, (v) => $89bb66f20154b1a6$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $89bb66f20154b1a6$export$9522e17588c12572, (v) => $89bb66f20154b1a6$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $89bb66f20154b1a6$export$2110ac352bb060b9, (v) => $89bb66f20154b1a6$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $89bb66f20154b1a6$export$56885ab8b9c456ab, (v) => $89bb66f20154b1a6$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $89bb66f20154b1a6$export$d927fcb6adf8f9de, (v) => $89bb66f20154b1a6$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $89bb66f20154b1a6$export$b82d16f27459e05a, (v) => $89bb66f20154b1a6$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $89bb66f20154b1a6$export$522c17b4f5e123e8, (v) => $89bb66f20154b1a6$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $89bb66f20154b1a6$export$1aabd8a0274ecfd6, (v) => $89bb66f20154b1a6$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $89bb66f20154b1a6$export$9b621391a187a31a, (v) => $89bb66f20154b1a6$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $89bb66f20154b1a6$export$f5bbd400c2f4426f, (v) => $89bb66f20154b1a6$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $89bb66f20154b1a6$export$2b8d127b894957b9;
var $89bb66f20154b1a6$export$cea3a54a6425200c;
var $89bb66f20154b1a6$export$a7c73072b1a182ae;
var $89bb66f20154b1a6$export$9f27bc3417b4524d;
var $89bb66f20154b1a6$export$db77ccec0bb4ccac;
var $89bb66f20154b1a6$export$8392c0c9d3dcbd35;
var $89bb66f20154b1a6$export$ffb0004e005737fa;
var $89bb66f20154b1a6$export$b624eff549462981;
var $89bb66f20154b1a6$export$7897aa7841a5380c;
var $89bb66f20154b1a6$export$602eac185826482c;
var $89bb66f20154b1a6$export$e2c29f18771995cb;
var $89bb66f20154b1a6$export$5f8d39834fd61797;
var $89bb66f20154b1a6$export$74bf444e3cd11ea5;
var $89bb66f20154b1a6$export$92387174baf9b227;
var $89bb66f20154b1a6$export$ec112efeb987d9c6;
var $89bb66f20154b1a6$export$b706b080d889d2c9;
var $89bb66f20154b1a6$export$5be5a87408f70ddc;
var $89bb66f20154b1a6$export$45a5e7f76e0caa8d;
var $89bb66f20154b1a6$export$455c2e768291efa6;
var $89bb66f20154b1a6$export$9522e17588c12572;
var $89bb66f20154b1a6$export$2110ac352bb060b9;
var $89bb66f20154b1a6$export$56885ab8b9c456ab;
var $89bb66f20154b1a6$export$d927fcb6adf8f9de;
var $89bb66f20154b1a6$export$b82d16f27459e05a;
var $89bb66f20154b1a6$export$522c17b4f5e123e8;
var $89bb66f20154b1a6$export$1aabd8a0274ecfd6;
var $89bb66f20154b1a6$export$9b621391a187a31a;
var $89bb66f20154b1a6$export$f5bbd400c2f4426f;
'use strict';
(function() {
    'use strict';
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
    function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console['warn']("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $89bb66f20154b1a6$export$2b8d127b894957b9 = AsyncMode;
    $89bb66f20154b1a6$export$cea3a54a6425200c = ConcurrentMode;
    $89bb66f20154b1a6$export$a7c73072b1a182ae = ContextConsumer;
    $89bb66f20154b1a6$export$9f27bc3417b4524d = ContextProvider;
    $89bb66f20154b1a6$export$db77ccec0bb4ccac = Element;
    $89bb66f20154b1a6$export$8392c0c9d3dcbd35 = ForwardRef;
    $89bb66f20154b1a6$export$ffb0004e005737fa = Fragment;
    $89bb66f20154b1a6$export$b624eff549462981 = Lazy;
    $89bb66f20154b1a6$export$7897aa7841a5380c = Memo;
    $89bb66f20154b1a6$export$602eac185826482c = Portal;
    $89bb66f20154b1a6$export$e2c29f18771995cb = Profiler;
    $89bb66f20154b1a6$export$5f8d39834fd61797 = StrictMode;
    $89bb66f20154b1a6$export$74bf444e3cd11ea5 = Suspense;
    $89bb66f20154b1a6$export$92387174baf9b227 = isAsyncMode;
    $89bb66f20154b1a6$export$ec112efeb987d9c6 = isConcurrentMode;
    $89bb66f20154b1a6$export$b706b080d889d2c9 = isContextConsumer;
    $89bb66f20154b1a6$export$5be5a87408f70ddc = isContextProvider;
    $89bb66f20154b1a6$export$45a5e7f76e0caa8d = isElement;
    $89bb66f20154b1a6$export$455c2e768291efa6 = isForwardRef;
    $89bb66f20154b1a6$export$9522e17588c12572 = isFragment;
    $89bb66f20154b1a6$export$2110ac352bb060b9 = isLazy;
    $89bb66f20154b1a6$export$56885ab8b9c456ab = isMemo;
    $89bb66f20154b1a6$export$d927fcb6adf8f9de = isPortal;
    $89bb66f20154b1a6$export$b82d16f27459e05a = isProfiler;
    $89bb66f20154b1a6$export$522c17b4f5e123e8 = isStrictMode;
    $89bb66f20154b1a6$export$1aabd8a0274ecfd6 = isSuspense;
    $89bb66f20154b1a6$export$9b621391a187a31a = isValidElementType;
    $89bb66f20154b1a6$export$f5bbd400c2f4426f = typeOf;
})();

});




parcelRegister("f2aKd", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $af1f608440ff2f82$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $af1f608440ff2f82$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $af1f608440ff2f82$export$6f077d94b33a01aa);
var $af1f608440ff2f82$var$isBrowser = typeof document !== 'undefined';
function $af1f608440ff2f82$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $af1f608440ff2f82$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $af1f608440ff2f82$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $af1f608440ff2f82$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $af1f608440ff2f82$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$af1f608440ff2f82$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$af1f608440ff2f82$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("42i5o", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $2f0560d7c295d890$export$6321afa313b251b5);

var $csG74 = parcelRequire("csG74");

var $6awXI = parcelRequire("6awXI");

var $lMLEj = parcelRequire("lMLEj");
var $2f0560d7c295d890$var$isDevelopment = false;
var $2f0560d7c295d890$var$hyphenateRegex = /[A-Z]|^ms/g;
var $2f0560d7c295d890$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $2f0560d7c295d890$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $2f0560d7c295d890$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $2f0560d7c295d890$var$processStyleName = /* #__PURE__ */ (0, $lMLEj.default)(function(styleName) {
    return $2f0560d7c295d890$var$isCustomProperty(styleName) ? styleName : styleName.replace($2f0560d7c295d890$var$hyphenateRegex, '-$&').toLowerCase();
});
var $2f0560d7c295d890$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($2f0560d7c295d890$var$animationRegex, function(match, p1, p2) {
                $2f0560d7c295d890$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $2f0560d7c295d890$var$cursor
                };
                return p1;
            });
    }
    if ((0, $6awXI.default)[key] !== 1 && !$2f0560d7c295d890$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $2f0560d7c295d890$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $2f0560d7c295d890$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $2f0560d7c295d890$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $2f0560d7c295d890$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $2f0560d7c295d890$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $2f0560d7c295d890$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $2f0560d7c295d890$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $2f0560d7c295d890$var$cursor;
                var result = interpolation(mergedProps);
                $2f0560d7c295d890$var$cursor = previousCursor;
                return $2f0560d7c295d890$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $2f0560d7c295d890$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $2f0560d7c295d890$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($2f0560d7c295d890$var$isProcessableValue(asString)) string += $2f0560d7c295d890$var$processStyleName(key) + ":" + $2f0560d7c295d890$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $2f0560d7c295d890$var$isDevelopment) throw new Error($2f0560d7c295d890$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($2f0560d7c295d890$var$isProcessableValue(value[_i])) string += $2f0560d7c295d890$var$processStyleName(key) + ":" + $2f0560d7c295d890$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $2f0560d7c295d890$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $2f0560d7c295d890$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $2f0560d7c295d890$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $2f0560d7c295d890$var$cursor;
function $2f0560d7c295d890$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $2f0560d7c295d890$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $2f0560d7c295d890$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $2f0560d7c295d890$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $2f0560d7c295d890$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $2f0560d7c295d890$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $csG74.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $2f0560d7c295d890$var$cursor
    };
}

});
parcelRegister("csG74", function(module, exports) {

$parcel$export(module.exports, "default", () => $9128c4568891f25b$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $9128c4568891f25b$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("6awXI", function(module, exports) {

$parcel$export(module.exports, "default", () => $47dd3ed7d11cf0ff$export$2e2bcd8739ae039);
var $47dd3ed7d11cf0ff$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("aGMlr", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $7c8353e515c1a977$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $7c8353e515c1a977$export$811a713a7276cb9d);

var $8T3gX = parcelRequire("8T3gX");
var $7c8353e515c1a977$var$isBrowser = typeof document !== 'undefined';
var $7c8353e515c1a977$var$syncFallback = function syncFallback(create) {
    return create();
};
var $7c8353e515c1a977$var$useInsertionEffect = $8T3gX.useInsertionEffect ? $8T3gX.useInsertionEffect : false;
var $7c8353e515c1a977$export$db21c7ffa21794e7 = !$7c8353e515c1a977$var$isBrowser ? $7c8353e515c1a977$var$syncFallback : $7c8353e515c1a977$var$useInsertionEffect || $7c8353e515c1a977$var$syncFallback;
var $7c8353e515c1a977$export$811a713a7276cb9d = $7c8353e515c1a977$var$useInsertionEffect || $8T3gX.useLayoutEffect;

});



parcelRegister("a2t1f", function(module, exports) {

$parcel$export(module.exports, "default", () => $74f099e34587c522$export$2e2bcd8739ae039);

var $lMLEj = parcelRequire("lMLEj");
// eslint-disable-next-line no-undef
var $74f099e34587c522$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $74f099e34587c522$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $lMLEj.default)(function(prop) {
    return $74f099e34587c522$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("5ITL1", function(module, exports) {

$parcel$export(module.exports, "default", () => $42ac500febee5116$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iHk77 = parcelRequire("iHk77");

var $ixydH = parcelRequire("ixydH");

var $k4ank = parcelRequire("k4ank");
'use client';
function $42ac500febee5116$var$getCache(injectFirst, enableCssLayer) {
    const emotionCache = (0, $ixydH.default)({
        key: 'css',
        prepend: injectFirst
    });
    if (enableCssLayer) {
        const prevInsert = emotionCache.insert;
        emotionCache.insert = (...args)=>{
            if (!args[1].styles.match(/^@layer\s+[^{]*$/)) // avoid nested @layer
            args[1].styles = `@layer mui {${args[1].styles}}`;
            return prevInsert(...args);
        };
    }
    return emotionCache;
}
const $42ac500febee5116$var$cacheMap = new Map();
function $42ac500febee5116$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $8T3gX.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if (typeof document === 'object' && $42ac500febee5116$var$cacheMap.has(cacheKey)) return $42ac500febee5116$var$cacheMap.get(cacheKey);
        const fresh = $42ac500febee5116$var$getCache(injectFirst, enableCssLayer);
        $42ac500febee5116$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    if (injectFirst || enableCssLayer) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $iHk77.C), {
        value: cache,
        children: children
    });
    return children;
}
$42ac500febee5116$export$2e2bcd8739ae039.propTypes = {
    /**
   * Your component tree.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * If true, MUI styles are wrapped in CSS `@layer mui` rule.
   * It helps to override MUI styles when using CSS Modules, Tailwind CSS, plain CSS, or any other styling solution.
   */ enableCssLayer: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */ injectFirst: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
};

});
parcelRegister("fdGrT", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $lVitD = parcelRequire("lVitD");
// By explicitly using `prop-types` you are opting into new development behavior.
// http://fb.me/prop-types-in-prod
var $b148ff5b5aa079db$var$throwOnDirectAccess = true;

module.exports = (parcelRequire("aNxwx"))($lVitD.isElement, $b148ff5b5aa079db$var$throwOnDirectAccess);

});


parcelRegister("lMsz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdb43d1b6730ef78$export$2e2bcd8739ae039);
parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $3JV9M = parcelRequire("3JV9M");

var $k4ank = parcelRequire("k4ank");
'use client';
function $fdb43d1b6730ef78$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $fdb43d1b6730ef78$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($fdb43d1b6730ef78$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3JV9M.Global), {
        styles: globalStyles
    });
}
$fdb43d1b6730ef78$export$2e2bcd8739ae039.propTypes = {
    defaultTheme: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ])
};

});


parcelRegister("23Jeg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("flLLM")).default);

var $flLLM = parcelRequire("flLLM");

});
parcelRegister("flLLM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2cddf39142b4342$export$2e2bcd8739ae039);

function $b2cddf39142b4342$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error(`MUI: \`capitalize(string)\` expects a string argument.`);
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});


parcelRegister("5RQIC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("7xMeJ")).default);

var $7xMeJ = parcelRequire("7xMeJ");
$parcel$exportWildcard(module.exports, $7xMeJ);

});
parcelRegister("7xMeJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", () => $57e1083ff9071659$export$aad197c7121a6651);
$parcel$export(module.exports, "default", () => $57e1083ff9071659$export$2e2bcd8739ae039);

var $7Se60 = parcelRequire("7Se60");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $57e1083ff9071659$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $57e1083ff9071659$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($57e1083ff9071659$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || '';
}
function $57e1083ff9071659$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || $57e1083ff9071659$export$aad197c7121a6651(Component) || fallback;
}
function $57e1083ff9071659$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $57e1083ff9071659$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $57e1083ff9071659$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $57e1083ff9071659$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $7Se60.ForwardRef:
            return $57e1083ff9071659$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $7Se60.Memo:
            return $57e1083ff9071659$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("7Se60", function(module, exports) {
'use strict';

module.exports = (parcelRequire("a3Dsv"));

});
parcelRegister("a3Dsv", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $7528cae431c5bd64$export$a7c73072b1a182ae, (v) => $7528cae431c5bd64$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $7528cae431c5bd64$export$9f27bc3417b4524d, (v) => $7528cae431c5bd64$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $7528cae431c5bd64$export$db77ccec0bb4ccac, (v) => $7528cae431c5bd64$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $7528cae431c5bd64$export$8392c0c9d3dcbd35, (v) => $7528cae431c5bd64$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $7528cae431c5bd64$export$ffb0004e005737fa, (v) => $7528cae431c5bd64$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $7528cae431c5bd64$export$b624eff549462981, (v) => $7528cae431c5bd64$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $7528cae431c5bd64$export$7897aa7841a5380c, (v) => $7528cae431c5bd64$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $7528cae431c5bd64$export$602eac185826482c, (v) => $7528cae431c5bd64$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $7528cae431c5bd64$export$e2c29f18771995cb, (v) => $7528cae431c5bd64$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $7528cae431c5bd64$export$5f8d39834fd61797, (v) => $7528cae431c5bd64$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $7528cae431c5bd64$export$74bf444e3cd11ea5, (v) => $7528cae431c5bd64$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $7528cae431c5bd64$export$998bcd577473dd93, (v) => $7528cae431c5bd64$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isContextConsumer", () => $7528cae431c5bd64$export$b706b080d889d2c9, (v) => $7528cae431c5bd64$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $7528cae431c5bd64$export$5be5a87408f70ddc, (v) => $7528cae431c5bd64$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $7528cae431c5bd64$export$45a5e7f76e0caa8d, (v) => $7528cae431c5bd64$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $7528cae431c5bd64$export$455c2e768291efa6, (v) => $7528cae431c5bd64$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $7528cae431c5bd64$export$9522e17588c12572, (v) => $7528cae431c5bd64$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $7528cae431c5bd64$export$2110ac352bb060b9, (v) => $7528cae431c5bd64$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $7528cae431c5bd64$export$56885ab8b9c456ab, (v) => $7528cae431c5bd64$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $7528cae431c5bd64$export$d927fcb6adf8f9de, (v) => $7528cae431c5bd64$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $7528cae431c5bd64$export$b82d16f27459e05a, (v) => $7528cae431c5bd64$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $7528cae431c5bd64$export$522c17b4f5e123e8, (v) => $7528cae431c5bd64$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $7528cae431c5bd64$export$1aabd8a0274ecfd6, (v) => $7528cae431c5bd64$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $7528cae431c5bd64$export$3d6c20d97e46b957, (v) => $7528cae431c5bd64$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $7528cae431c5bd64$export$9b621391a187a31a, (v) => $7528cae431c5bd64$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $7528cae431c5bd64$export$f5bbd400c2f4426f, (v) => $7528cae431c5bd64$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7528cae431c5bd64$export$a7c73072b1a182ae;
var $7528cae431c5bd64$export$9f27bc3417b4524d;
var $7528cae431c5bd64$export$db77ccec0bb4ccac;
var $7528cae431c5bd64$export$8392c0c9d3dcbd35;
var $7528cae431c5bd64$export$ffb0004e005737fa;
var $7528cae431c5bd64$export$b624eff549462981;
var $7528cae431c5bd64$export$7897aa7841a5380c;
var $7528cae431c5bd64$export$602eac185826482c;
var $7528cae431c5bd64$export$e2c29f18771995cb;
var $7528cae431c5bd64$export$5f8d39834fd61797;
var $7528cae431c5bd64$export$74bf444e3cd11ea5;
var $7528cae431c5bd64$export$998bcd577473dd93;
var $7528cae431c5bd64$export$b706b080d889d2c9;
var $7528cae431c5bd64$export$5be5a87408f70ddc;
var $7528cae431c5bd64$export$45a5e7f76e0caa8d;
var $7528cae431c5bd64$export$455c2e768291efa6;
var $7528cae431c5bd64$export$9522e17588c12572;
var $7528cae431c5bd64$export$2110ac352bb060b9;
var $7528cae431c5bd64$export$56885ab8b9c456ab;
var $7528cae431c5bd64$export$d927fcb6adf8f9de;
var $7528cae431c5bd64$export$b82d16f27459e05a;
var $7528cae431c5bd64$export$522c17b4f5e123e8;
var $7528cae431c5bd64$export$1aabd8a0274ecfd6;
var $7528cae431c5bd64$export$3d6c20d97e46b957;
var $7528cae431c5bd64$export$9b621391a187a31a;
var $7528cae431c5bd64$export$f5bbd400c2f4426f;
"use strict";
(function() {
    function typeOf(object) {
        if ("object" === typeof object && null !== object) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    switch(object = object.type, object){
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                        case REACT_SUSPENSE_LIST_TYPE:
                        case REACT_VIEW_TRANSITION_TYPE:
                            return object;
                        default:
                            switch(object = object && object.$$typeof, object){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                    return object;
                                case REACT_CONSUMER_TYPE:
                                    return object;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
    }
    var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
    $7528cae431c5bd64$export$a7c73072b1a182ae = REACT_CONSUMER_TYPE;
    $7528cae431c5bd64$export$9f27bc3417b4524d = REACT_CONTEXT_TYPE;
    $7528cae431c5bd64$export$db77ccec0bb4ccac = REACT_ELEMENT_TYPE;
    $7528cae431c5bd64$export$8392c0c9d3dcbd35 = REACT_FORWARD_REF_TYPE;
    $7528cae431c5bd64$export$ffb0004e005737fa = REACT_FRAGMENT_TYPE;
    $7528cae431c5bd64$export$b624eff549462981 = REACT_LAZY_TYPE;
    $7528cae431c5bd64$export$7897aa7841a5380c = REACT_MEMO_TYPE;
    $7528cae431c5bd64$export$602eac185826482c = REACT_PORTAL_TYPE;
    $7528cae431c5bd64$export$e2c29f18771995cb = REACT_PROFILER_TYPE;
    $7528cae431c5bd64$export$5f8d39834fd61797 = REACT_STRICT_MODE_TYPE;
    $7528cae431c5bd64$export$74bf444e3cd11ea5 = REACT_SUSPENSE_TYPE;
    $7528cae431c5bd64$export$998bcd577473dd93 = REACT_SUSPENSE_LIST_TYPE;
    $7528cae431c5bd64$export$b706b080d889d2c9 = function(object) {
        return typeOf(object) === REACT_CONSUMER_TYPE;
    };
    $7528cae431c5bd64$export$5be5a87408f70ddc = function(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    };
    $7528cae431c5bd64$export$45a5e7f76e0caa8d = function(object) {
        return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
    };
    $7528cae431c5bd64$export$455c2e768291efa6 = function(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    };
    $7528cae431c5bd64$export$9522e17588c12572 = function(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    };
    $7528cae431c5bd64$export$2110ac352bb060b9 = function(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    };
    $7528cae431c5bd64$export$56885ab8b9c456ab = function(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    };
    $7528cae431c5bd64$export$d927fcb6adf8f9de = function(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    };
    $7528cae431c5bd64$export$b82d16f27459e05a = function(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    };
    $7528cae431c5bd64$export$522c17b4f5e123e8 = function(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    };
    $7528cae431c5bd64$export$1aabd8a0274ecfd6 = function(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    };
    $7528cae431c5bd64$export$3d6c20d97e46b957 = function(object) {
        return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
    };
    $7528cae431c5bd64$export$9b621391a187a31a = function(type) {
        return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
    };
    $7528cae431c5bd64$export$f5bbd400c2f4426f = typeOf;
})();

});




parcelRegister("9ZhGv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("6IeW0")).default);
$parcel$export(module.exports, "private_createBreakpoints", () => (parcelRequire("8N6xX")).default);
$parcel$export(module.exports, "unstable_applyStyles", () => (parcelRequire("awIHI")).default);

var $6IeW0 = parcelRequire("6IeW0");

var $8N6xX = parcelRequire("8N6xX");

var $awIHI = parcelRequire("awIHI");

});
parcelRegister("6IeW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e326fd8f1969933$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $b4f8D = parcelRequire("b4f8D");

var $8N6xX = parcelRequire("8N6xX");

var $lEFi9 = parcelRequire("lEFi9");

var $fDWHf = parcelRequire("fDWHf");

var $6VmXC = parcelRequire("6VmXC");

var $dbrxt = parcelRequire("dbrxt");

var $awIHI = parcelRequire("awIHI");
const $4e326fd8f1969933$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $4e326fd8f1969933$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $fAJB5.default)(options, $4e326fd8f1969933$var$_excluded);
    const breakpoints = (0, $8N6xX.default)(breakpointsInput);
    const spacing = (0, $fDWHf.default)(spacingInput);
    let muiTheme = (0, $b4f8D.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, $eJfrs.default)({
            mode: 'light'
        }, paletteInput),
        spacing: spacing,
        shape: (0, $eJfrs.default)({}, (0, $lEFi9.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $awIHI.default);
    muiTheme = args.reduce((acc, argument)=>(0, $b4f8D.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $eJfrs.default)({}, (0, $dbrxt.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $6VmXC.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $4e326fd8f1969933$export$2e2bcd8739ae039 = $4e326fd8f1969933$var$createTheme;

});
parcelRegister("fAJB5", function(module, exports) {

$parcel$export(module.exports, "default", () => $b59d967182239c8b$export$2e2bcd8739ae039);
function $b59d967182239c8b$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("b4f8D", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $80ebcf97adf7c467$export$53b83ca8eaab0383);
$parcel$export(module.exports, "default", () => $80ebcf97adf7c467$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");
function $80ebcf97adf7c467$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $80ebcf97adf7c467$var$deepClone(source) {
    if (/*#__PURE__*/ $8T3gX.isValidElement(source) || !$80ebcf97adf7c467$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $80ebcf97adf7c467$var$deepClone(source[key]);
    });
    return output;
}
function $80ebcf97adf7c467$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $eJfrs.default)({}, target) : target;
    if ($80ebcf97adf7c467$export$53b83ca8eaab0383(target) && $80ebcf97adf7c467$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $8T3gX.isValidElement(source[key])) output[key] = source[key];
        else if ($80ebcf97adf7c467$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $80ebcf97adf7c467$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $80ebcf97adf7c467$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $80ebcf97adf7c467$export$53b83ca8eaab0383(source[key]) ? $80ebcf97adf7c467$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("8N6xX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6667fa5d68e93323$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");
const $6667fa5d68e93323$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $6667fa5d68e93323$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $6667fa5d68e93323$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $eJfrs.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $6667fa5d68e93323$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5 } = breakpoints, other = (0, $fAJB5.default)(breakpoints, $6667fa5d68e93323$var$_excluded);
    const sortedValues = $6667fa5d68e93323$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return (0, $eJfrs.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("lEFi9", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc3d5d1aa5d9879c$export$2e2bcd8739ae039);
const $fc3d5d1aa5d9879c$var$shape = {
    borderRadius: 4
};
var $fc3d5d1aa5d9879c$export$2e2bcd8739ae039 = $fc3d5d1aa5d9879c$var$shape;

});

parcelRegister("fDWHf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b638077591bebbaa$export$2e2bcd8739ae039);

var $eOD94 = parcelRequire("eOD94");
function $b638077591bebbaa$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $eOD94.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        if (!(argsInput.length <= 4)) console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${argsInput.length}`);
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("eOD94", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", () => $ac9419a58aaa76b2$export$cb5ee237cce814a2);
$parcel$export(module.exports, "createUnarySpacing", () => $ac9419a58aaa76b2$export$1def6f833384e3d1);
$parcel$export(module.exports, "getValue", () => $ac9419a58aaa76b2$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "margin", () => $ac9419a58aaa76b2$export$7ede87f9b603dd3c);
$parcel$export(module.exports, "padding", () => $ac9419a58aaa76b2$export$6f98e8eaf0be1996);

var $l0PXY = parcelRequire("l0PXY");

var $o68UK = parcelRequire("o68UK");

var $8QOpa = parcelRequire("8QOpa");

var $pWGGF = parcelRequire("pWGGF");

var $5lKBK = parcelRequire("5lKBK");
const $ac9419a58aaa76b2$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $ac9419a58aaa76b2$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $ac9419a58aaa76b2$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $ac9419a58aaa76b2$var$getCssProperties = (0, $5lKBK.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($ac9419a58aaa76b2$var$aliases[prop]) prop = $ac9419a58aaa76b2$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $ac9419a58aaa76b2$var$properties[a];
    const direction = $ac9419a58aaa76b2$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $ac9419a58aaa76b2$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $ac9419a58aaa76b2$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $ac9419a58aaa76b2$var$spacingKeys = [
    ...$ac9419a58aaa76b2$export$aab52a0dde05ad8a,
    ...$ac9419a58aaa76b2$export$f8397d44f03ab6ad
];
function $ac9419a58aaa76b2$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $8QOpa.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number') return (abs)=>{
        if (typeof abs === 'string') return abs;
        if (typeof abs !== 'number') console.error(`MUI: Expected ${propName} argument to be a number or a string, got ${abs}.`);
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === 'string') return abs;
        if (!Number.isInteger(abs)) console.error([
            `MUI: The \`theme.${themeKey}\` array type cannot be combined with non integer values.` + `You should either use an integer value that can be used as index, or define the \`theme.${themeKey}\` as a number.`
        ].join('\n'));
        else if (abs > themeSpacing.length - 1) console.error([
            `MUI: The value provided (${abs}) overflows.`,
            `The supported values are: ${JSON.stringify(themeSpacing)}.`,
            `${abs} > ${themeSpacing.length - 1}, you need to add the missing values.`
        ].join('\n'));
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    console.error([
        `MUI: The \`theme.${themeKey}\` value (${themeSpacing}) is invalid.`,
        'It should be a number, an array or a function.'
    ].join('\n'));
    return ()=>undefined;
}
function $ac9419a58aaa76b2$export$1def6f833384e3d1(theme) {
    return $ac9419a58aaa76b2$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $ac9419a58aaa76b2$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return `-${transformed}`;
}
function $ac9419a58aaa76b2$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $ac9419a58aaa76b2$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $ac9419a58aaa76b2$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $ac9419a58aaa76b2$var$getCssProperties(prop);
    const styleFromPropValue = $ac9419a58aaa76b2$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $o68UK.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $ac9419a58aaa76b2$var$style(props, keys) {
    const transformer = $ac9419a58aaa76b2$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$ac9419a58aaa76b2$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $pWGGF.default), {});
}
function $ac9419a58aaa76b2$export$7ede87f9b603dd3c(props) {
    return $ac9419a58aaa76b2$var$style(props, $ac9419a58aaa76b2$export$aab52a0dde05ad8a);
}
$ac9419a58aaa76b2$export$7ede87f9b603dd3c.propTypes = $ac9419a58aaa76b2$export$aab52a0dde05ad8a.reduce((obj, key)=>{
    obj[key] = (0, $l0PXY.default);
    return obj;
}, {});
$ac9419a58aaa76b2$export$7ede87f9b603dd3c.filterProps = $ac9419a58aaa76b2$export$aab52a0dde05ad8a;
function $ac9419a58aaa76b2$export$6f98e8eaf0be1996(props) {
    return $ac9419a58aaa76b2$var$style(props, $ac9419a58aaa76b2$export$f8397d44f03ab6ad);
}
$ac9419a58aaa76b2$export$6f98e8eaf0be1996.propTypes = $ac9419a58aaa76b2$export$f8397d44f03ab6ad.reduce((obj, key)=>{
    obj[key] = (0, $l0PXY.default);
    return obj;
}, {});
$ac9419a58aaa76b2$export$6f98e8eaf0be1996.filterProps = $ac9419a58aaa76b2$export$f8397d44f03ab6ad;
function $ac9419a58aaa76b2$var$spacing(props) {
    return $ac9419a58aaa76b2$var$style(props, $ac9419a58aaa76b2$var$spacingKeys);
}
$ac9419a58aaa76b2$var$spacing.propTypes = $ac9419a58aaa76b2$var$spacingKeys.reduce((obj, key)=>{
    obj[key] = (0, $l0PXY.default);
    return obj;
}, {});
$ac9419a58aaa76b2$var$spacing.filterProps = $ac9419a58aaa76b2$var$spacingKeys;
var $ac9419a58aaa76b2$export$2e2bcd8739ae039 = $ac9419a58aaa76b2$var$spacing;

});
parcelRegister("l0PXY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4c1e8790cc7b6c1$export$2e2bcd8739ae039);

var $fdGrT = parcelRequire("fdGrT");
const $f4c1e8790cc7b6c1$var$responsivePropType = (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array
]);
var $f4c1e8790cc7b6c1$export$2e2bcd8739ae039 = $f4c1e8790cc7b6c1$var$responsivePropType;

});

parcelRegister("o68UK", function(module, exports) {

$parcel$export(module.exports, "values", () => $048701d5604f3a08$export$68c286be0e7e55b7);
$parcel$export(module.exports, "handleBreakpoints", () => $048701d5604f3a08$export$88347efdb2e19abd);
$parcel$export(module.exports, "createEmptyBreakpointObject", () => $048701d5604f3a08$export$1f2600516e91381f);
$parcel$export(module.exports, "removeUnusedBreakpoints", () => $048701d5604f3a08$export$8922c90b6e020726);
$parcel$export(module.exports, "mergeBreakpointsInOrder", () => $048701d5604f3a08$export$b89a003a1e05c0ee);
$parcel$export(module.exports, "resolveBreakpointValues", () => $048701d5604f3a08$export$980e6a259d807490);

var $eJfrs = parcelRequire("eJfrs");

var $fdGrT = parcelRequire("fdGrT");

var $b4f8D = parcelRequire("b4f8D");

var $pWGGF = parcelRequire("pWGGF");
const $048701d5604f3a08$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $048701d5604f3a08$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$048701d5604f3a08$export$68c286be0e7e55b7[key]}px)`
};
function $048701d5604f3a08$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $048701d5604f3a08$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $048701d5604f3a08$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $048701d5604f3a08$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $048701d5604f3a08$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $048701d5604f3a08$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $eJfrs.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $pWGGF.default)(base, extended);
    };
    newStyleFunction.propTypes = (0, $eJfrs.default)({}, styleFunction.propTypes, {
        xs: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        sm: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        md: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        lg: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        xl: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    });
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $048701d5604f3a08$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $048701d5604f3a08$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $048701d5604f3a08$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $048701d5604f3a08$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $b4f8D.default)(prev, next), {});
    return $048701d5604f3a08$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $048701d5604f3a08$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $048701d5604f3a08$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $048701d5604f3a08$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $048701d5604f3a08$export$2e2bcd8739ae039 = $048701d5604f3a08$var$breakpoints;

});
parcelRegister("pWGGF", function(module, exports) {

$parcel$export(module.exports, "default", () => $04dfdc079122d612$export$2e2bcd8739ae039);

var $b4f8D = parcelRequire("b4f8D");
function $04dfdc079122d612$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $b4f8D.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $04dfdc079122d612$export$2e2bcd8739ae039 = $04dfdc079122d612$var$merge;

});


parcelRegister("8QOpa", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $671a47737bb33023$export$2aa3fd96c49a84a8);
$parcel$export(module.exports, "getStyleValue", () => $671a47737bb33023$export$741ad47189a64aa0);
$parcel$export(module.exports, "default", () => $671a47737bb33023$export$2e2bcd8739ae039);

var $flLLM = parcelRequire("flLLM");

var $l0PXY = parcelRequire("l0PXY");

var $o68UK = parcelRequire("o68UK");
function $671a47737bb33023$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $671a47737bb33023$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $671a47737bb33023$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $671a47737bb33023$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $671a47737bb33023$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $671a47737bb33023$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $671a47737bb33023$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $flLLM.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $o68UK.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {
        [prop]: (0, $l0PXY.default)
    };
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $671a47737bb33023$export$2e2bcd8739ae039 = $671a47737bb33023$var$style;

});

parcelRegister("5lKBK", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e5311420d798b7b$export$2e2bcd8739ae039);
function $3e5311420d798b7b$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("6VmXC", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => $50a9e0708c04b7f4$export$7d53d8bf2911e013);
$parcel$export(module.exports, "default", () => $50a9e0708c04b7f4$export$2e2bcd8739ae039);

var $flLLM = parcelRequire("flLLM");

var $pWGGF = parcelRequire("pWGGF");

var $8QOpa = parcelRequire("8QOpa");

var $o68UK = parcelRequire("o68UK");

var $dbrxt = parcelRequire("dbrxt");
function $50a9e0708c04b7f4$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $50a9e0708c04b7f4$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $50a9e0708c04b7f4$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $8QOpa.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $8QOpa.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $8QOpa.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $flLLM.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $o68UK.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $dbrxt.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $o68UK.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $50a9e0708c04b7f4$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $pWGGF.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $o68UK.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($50a9e0708c04b7f4$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $pWGGF.default)(css, breakpointsValues);
                        }
                    } else css = (0, $pWGGF.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $o68UK.removeUnusedBreakpoints)(breakpointsKeys, css)
            };
            return (0, $o68UK.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $50a9e0708c04b7f4$var$styleFunctionSx = $50a9e0708c04b7f4$export$7d53d8bf2911e013();
$50a9e0708c04b7f4$var$styleFunctionSx.filterProps = [
    'sx'
];
var $50a9e0708c04b7f4$export$2e2bcd8739ae039 = $50a9e0708c04b7f4$var$styleFunctionSx;

});
parcelRegister("dbrxt", function(module, exports) {

$parcel$export(module.exports, "default", () => $9991aa17ab0f51bc$export$2e2bcd8739ae039);

var $eOD94 = parcelRequire("eOD94");

var $3pdyt = parcelRequire("3pdyt");

var $b4NLf = parcelRequire("b4NLf");

var $KAi8C = parcelRequire("KAi8C");

var $2hG7b = parcelRequire("2hG7b");
const $9991aa17ab0f51bc$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $3pdyt.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $3pdyt.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $3pdyt.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $3pdyt.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $3pdyt.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $3pdyt.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $3pdyt.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $KAi8C.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $KAi8C.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $KAi8C.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $eOD94.padding)
    },
    pt: {
        style: (0, $eOD94.padding)
    },
    pr: {
        style: (0, $eOD94.padding)
    },
    pb: {
        style: (0, $eOD94.padding)
    },
    pl: {
        style: (0, $eOD94.padding)
    },
    px: {
        style: (0, $eOD94.padding)
    },
    py: {
        style: (0, $eOD94.padding)
    },
    padding: {
        style: (0, $eOD94.padding)
    },
    paddingTop: {
        style: (0, $eOD94.padding)
    },
    paddingRight: {
        style: (0, $eOD94.padding)
    },
    paddingBottom: {
        style: (0, $eOD94.padding)
    },
    paddingLeft: {
        style: (0, $eOD94.padding)
    },
    paddingX: {
        style: (0, $eOD94.padding)
    },
    paddingY: {
        style: (0, $eOD94.padding)
    },
    paddingInline: {
        style: (0, $eOD94.padding)
    },
    paddingInlineStart: {
        style: (0, $eOD94.padding)
    },
    paddingInlineEnd: {
        style: (0, $eOD94.padding)
    },
    paddingBlock: {
        style: (0, $eOD94.padding)
    },
    paddingBlockStart: {
        style: (0, $eOD94.padding)
    },
    paddingBlockEnd: {
        style: (0, $eOD94.padding)
    },
    m: {
        style: (0, $eOD94.margin)
    },
    mt: {
        style: (0, $eOD94.margin)
    },
    mr: {
        style: (0, $eOD94.margin)
    },
    mb: {
        style: (0, $eOD94.margin)
    },
    ml: {
        style: (0, $eOD94.margin)
    },
    mx: {
        style: (0, $eOD94.margin)
    },
    my: {
        style: (0, $eOD94.margin)
    },
    margin: {
        style: (0, $eOD94.margin)
    },
    marginTop: {
        style: (0, $eOD94.margin)
    },
    marginRight: {
        style: (0, $eOD94.margin)
    },
    marginBottom: {
        style: (0, $eOD94.margin)
    },
    marginLeft: {
        style: (0, $eOD94.margin)
    },
    marginX: {
        style: (0, $eOD94.margin)
    },
    marginY: {
        style: (0, $eOD94.margin)
    },
    marginInline: {
        style: (0, $eOD94.margin)
    },
    marginInlineStart: {
        style: (0, $eOD94.margin)
    },
    marginInlineEnd: {
        style: (0, $eOD94.margin)
    },
    marginBlock: {
        style: (0, $eOD94.margin)
    },
    marginBlockStart: {
        style: (0, $eOD94.margin)
    },
    marginBlockEnd: {
        style: (0, $eOD94.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $b4NLf.gap)
    },
    rowGap: {
        style: (0, $b4NLf.rowGap)
    },
    columnGap: {
        style: (0, $b4NLf.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $2hG7b.sizingTransform)
    },
    maxWidth: {
        style: (0, $2hG7b.maxWidth)
    },
    minWidth: {
        transform: (0, $2hG7b.sizingTransform)
    },
    height: {
        transform: (0, $2hG7b.sizingTransform)
    },
    maxHeight: {
        transform: (0, $2hG7b.sizingTransform)
    },
    minHeight: {
        transform: (0, $2hG7b.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $9991aa17ab0f51bc$export$2e2bcd8739ae039 = $9991aa17ab0f51bc$var$defaultSxConfig;

});
parcelRegister("3pdyt", function(module, exports) {

$parcel$export(module.exports, "borderTransform", () => $27ae38a1502aebc1$export$34e2febe53ae29cc);
$parcel$export(module.exports, "borderRadius", () => $27ae38a1502aebc1$export$7a57f79000377ca2);

var $l0PXY = parcelRequire("l0PXY");

var $8QOpa = parcelRequire("8QOpa");

var $5EkMR = parcelRequire("5EkMR");

var $eOD94 = parcelRequire("eOD94");

var $o68UK = parcelRequire("o68UK");
function $27ae38a1502aebc1$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $27ae38a1502aebc1$var$createBorderStyle(prop, transform) {
    return (0, $8QOpa.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $27ae38a1502aebc1$export$1edee58a52776cd9 = $27ae38a1502aebc1$var$createBorderStyle('border', $27ae38a1502aebc1$export$34e2febe53ae29cc);
const $27ae38a1502aebc1$export$f9a7b6bd24892946 = $27ae38a1502aebc1$var$createBorderStyle('borderTop', $27ae38a1502aebc1$export$34e2febe53ae29cc);
const $27ae38a1502aebc1$export$5abca33e6be905d2 = $27ae38a1502aebc1$var$createBorderStyle('borderRight', $27ae38a1502aebc1$export$34e2febe53ae29cc);
const $27ae38a1502aebc1$export$e2ce9f12a980a822 = $27ae38a1502aebc1$var$createBorderStyle('borderBottom', $27ae38a1502aebc1$export$34e2febe53ae29cc);
const $27ae38a1502aebc1$export$47658cca1a909427 = $27ae38a1502aebc1$var$createBorderStyle('borderLeft', $27ae38a1502aebc1$export$34e2febe53ae29cc);
const $27ae38a1502aebc1$export$e7fb0694ba2404fc = $27ae38a1502aebc1$var$createBorderStyle('borderColor');
const $27ae38a1502aebc1$export$126a92c968acdb85 = $27ae38a1502aebc1$var$createBorderStyle('borderTopColor');
const $27ae38a1502aebc1$export$85cc51cb8fbb8c0e = $27ae38a1502aebc1$var$createBorderStyle('borderRightColor');
const $27ae38a1502aebc1$export$340b0327727f6d1a = $27ae38a1502aebc1$var$createBorderStyle('borderBottomColor');
const $27ae38a1502aebc1$export$60beef91a985b4bf = $27ae38a1502aebc1$var$createBorderStyle('borderLeftColor');
const $27ae38a1502aebc1$export$f9258c55612cbed7 = $27ae38a1502aebc1$var$createBorderStyle('outline', $27ae38a1502aebc1$export$34e2febe53ae29cc);
const $27ae38a1502aebc1$export$621fe586efeb64b9 = $27ae38a1502aebc1$var$createBorderStyle('outlineColor');
const $27ae38a1502aebc1$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $eOD94.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $eOD94.getValue)(transformer, propValue)
            });
        return (0, $o68UK.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$27ae38a1502aebc1$export$7a57f79000377ca2.propTypes = {
    borderRadius: (0, $l0PXY.default)
};
$27ae38a1502aebc1$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $27ae38a1502aebc1$var$borders = (0, $5EkMR.default)($27ae38a1502aebc1$export$1edee58a52776cd9, $27ae38a1502aebc1$export$f9a7b6bd24892946, $27ae38a1502aebc1$export$5abca33e6be905d2, $27ae38a1502aebc1$export$e2ce9f12a980a822, $27ae38a1502aebc1$export$47658cca1a909427, $27ae38a1502aebc1$export$e7fb0694ba2404fc, $27ae38a1502aebc1$export$126a92c968acdb85, $27ae38a1502aebc1$export$85cc51cb8fbb8c0e, $27ae38a1502aebc1$export$340b0327727f6d1a, $27ae38a1502aebc1$export$60beef91a985b4bf, $27ae38a1502aebc1$export$7a57f79000377ca2, $27ae38a1502aebc1$export$f9258c55612cbed7, $27ae38a1502aebc1$export$621fe586efeb64b9);
var $27ae38a1502aebc1$export$2e2bcd8739ae039 = $27ae38a1502aebc1$var$borders;

});
parcelRegister("5EkMR", function(module, exports) {

$parcel$export(module.exports, "default", () => $41d0d00cc85110a2$export$2e2bcd8739ae039);

var $pWGGF = parcelRequire("pWGGF");
function $41d0d00cc85110a2$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $pWGGF.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = styles.reduce((acc, style)=>Object.assign(acc, style.propTypes), {});
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $41d0d00cc85110a2$export$2e2bcd8739ae039 = $41d0d00cc85110a2$var$compose;

});


parcelRegister("b4NLf", function(module, exports) {

$parcel$export(module.exports, "gap", () => $8106aaf2536b6b07$export$5df9adcb0db95e1e);
$parcel$export(module.exports, "columnGap", () => $8106aaf2536b6b07$export$ec60d70ff941a580);
$parcel$export(module.exports, "rowGap", () => $8106aaf2536b6b07$export$8a833ffa5f5dbeda);

var $8QOpa = parcelRequire("8QOpa");

var $5EkMR = parcelRequire("5EkMR");

var $eOD94 = parcelRequire("eOD94");

var $o68UK = parcelRequire("o68UK");

var $l0PXY = parcelRequire("l0PXY");
const $8106aaf2536b6b07$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $eOD94.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $eOD94.getValue)(transformer, propValue)
            });
        return (0, $o68UK.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$8106aaf2536b6b07$export$5df9adcb0db95e1e.propTypes = {
    gap: (0, $l0PXY.default)
};
$8106aaf2536b6b07$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $8106aaf2536b6b07$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $eOD94.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $eOD94.getValue)(transformer, propValue)
            });
        return (0, $o68UK.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$8106aaf2536b6b07$export$ec60d70ff941a580.propTypes = {
    columnGap: (0, $l0PXY.default)
};
$8106aaf2536b6b07$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $8106aaf2536b6b07$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $eOD94.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $eOD94.getValue)(transformer, propValue)
            });
        return (0, $o68UK.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$8106aaf2536b6b07$export$8a833ffa5f5dbeda.propTypes = {
    rowGap: (0, $l0PXY.default)
};
$8106aaf2536b6b07$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $8106aaf2536b6b07$export$baf44164ca3a34e8 = (0, $8QOpa.default)({
    prop: 'gridColumn'
});
const $8106aaf2536b6b07$export$8f7213a1cd01e832 = (0, $8QOpa.default)({
    prop: 'gridRow'
});
const $8106aaf2536b6b07$export$b0e0abbc49ba668 = (0, $8QOpa.default)({
    prop: 'gridAutoFlow'
});
const $8106aaf2536b6b07$export$bcd8b929d4b4142 = (0, $8QOpa.default)({
    prop: 'gridAutoColumns'
});
const $8106aaf2536b6b07$export$e5039a674e14c828 = (0, $8QOpa.default)({
    prop: 'gridAutoRows'
});
const $8106aaf2536b6b07$export$42bd9088661ffb03 = (0, $8QOpa.default)({
    prop: 'gridTemplateColumns'
});
const $8106aaf2536b6b07$export$920682ae05b999bc = (0, $8QOpa.default)({
    prop: 'gridTemplateRows'
});
const $8106aaf2536b6b07$export$1b88fbdd482fd33a = (0, $8QOpa.default)({
    prop: 'gridTemplateAreas'
});
const $8106aaf2536b6b07$export$bdb486e40d52d26f = (0, $8QOpa.default)({
    prop: 'gridArea'
});
const $8106aaf2536b6b07$var$grid = (0, $5EkMR.default)($8106aaf2536b6b07$export$5df9adcb0db95e1e, $8106aaf2536b6b07$export$ec60d70ff941a580, $8106aaf2536b6b07$export$8a833ffa5f5dbeda, $8106aaf2536b6b07$export$baf44164ca3a34e8, $8106aaf2536b6b07$export$8f7213a1cd01e832, $8106aaf2536b6b07$export$b0e0abbc49ba668, $8106aaf2536b6b07$export$bcd8b929d4b4142, $8106aaf2536b6b07$export$e5039a674e14c828, $8106aaf2536b6b07$export$42bd9088661ffb03, $8106aaf2536b6b07$export$920682ae05b999bc, $8106aaf2536b6b07$export$1b88fbdd482fd33a, $8106aaf2536b6b07$export$bdb486e40d52d26f);
var $8106aaf2536b6b07$export$2e2bcd8739ae039 = $8106aaf2536b6b07$var$grid;

});

parcelRegister("KAi8C", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", () => $08c072bcfecd8f69$export$dbaffd4420ea0ac6);

var $8QOpa = parcelRequire("8QOpa");

var $5EkMR = parcelRequire("5EkMR");
function $08c072bcfecd8f69$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $08c072bcfecd8f69$export$35e9368ef982300f = (0, $8QOpa.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $08c072bcfecd8f69$export$dbaffd4420ea0ac6
});
const $08c072bcfecd8f69$export$2506f56c10355b33 = (0, $8QOpa.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $08c072bcfecd8f69$export$dbaffd4420ea0ac6
});
const $08c072bcfecd8f69$export$8c5a050822fd698c = (0, $8QOpa.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $08c072bcfecd8f69$export$dbaffd4420ea0ac6
});
const $08c072bcfecd8f69$var$palette = (0, $5EkMR.default)($08c072bcfecd8f69$export$35e9368ef982300f, $08c072bcfecd8f69$export$2506f56c10355b33, $08c072bcfecd8f69$export$8c5a050822fd698c);
var $08c072bcfecd8f69$export$2e2bcd8739ae039 = $08c072bcfecd8f69$var$palette;

});

parcelRegister("2hG7b", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", () => $1a9dd66bf4f4a25b$export$8afece71750ec241);
$parcel$export(module.exports, "maxWidth", () => $1a9dd66bf4f4a25b$export$488fda99655ff65a);

var $8QOpa = parcelRequire("8QOpa");

var $5EkMR = parcelRequire("5EkMR");

var $o68UK = parcelRequire("o68UK");
function $1a9dd66bf4f4a25b$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $1a9dd66bf4f4a25b$export$7e3df82ee760448c = (0, $8QOpa.default)({
    prop: 'width',
    transform: $1a9dd66bf4f4a25b$export$8afece71750ec241
});
const $1a9dd66bf4f4a25b$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $o68UK.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $1a9dd66bf4f4a25b$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $o68UK.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$1a9dd66bf4f4a25b$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $1a9dd66bf4f4a25b$export$ee148fbbe8357dd2 = (0, $8QOpa.default)({
    prop: 'minWidth',
    transform: $1a9dd66bf4f4a25b$export$8afece71750ec241
});
const $1a9dd66bf4f4a25b$export$ac607276a8fe9f0a = (0, $8QOpa.default)({
    prop: 'height',
    transform: $1a9dd66bf4f4a25b$export$8afece71750ec241
});
const $1a9dd66bf4f4a25b$export$dc0d8bd0b94f8570 = (0, $8QOpa.default)({
    prop: 'maxHeight',
    transform: $1a9dd66bf4f4a25b$export$8afece71750ec241
});
const $1a9dd66bf4f4a25b$export$a43cf604e12f3b17 = (0, $8QOpa.default)({
    prop: 'minHeight',
    transform: $1a9dd66bf4f4a25b$export$8afece71750ec241
});
const $1a9dd66bf4f4a25b$export$ffed9f14fb65e276 = (0, $8QOpa.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $1a9dd66bf4f4a25b$export$8afece71750ec241
});
const $1a9dd66bf4f4a25b$export$905076ed6620e671 = (0, $8QOpa.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $1a9dd66bf4f4a25b$export$8afece71750ec241
});
const $1a9dd66bf4f4a25b$export$6ccc93f785106a58 = (0, $8QOpa.default)({
    prop: 'boxSizing'
});
const $1a9dd66bf4f4a25b$var$sizing = (0, $5EkMR.default)($1a9dd66bf4f4a25b$export$7e3df82ee760448c, $1a9dd66bf4f4a25b$export$488fda99655ff65a, $1a9dd66bf4f4a25b$export$ee148fbbe8357dd2, $1a9dd66bf4f4a25b$export$ac607276a8fe9f0a, $1a9dd66bf4f4a25b$export$dc0d8bd0b94f8570, $1a9dd66bf4f4a25b$export$a43cf604e12f3b17, $1a9dd66bf4f4a25b$export$6ccc93f785106a58);
var $1a9dd66bf4f4a25b$export$2e2bcd8739ae039 = $1a9dd66bf4f4a25b$var$sizing;

});



parcelRegister("awIHI", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a9f91d38a89d1a9$export$2e2bcd8739ae039);
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $7a9f91d38a89d1a9$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("fa0wV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("6VmXC")).default);
$parcel$export(module.exports, "unstable_createStyleFunctionSx", () => (parcelRequire("6VmXC")).unstable_createStyleFunctionSx);
$parcel$export(module.exports, "extendSxProp", () => (parcelRequire("bmcE0")).default);
$parcel$export(module.exports, "unstable_defaultSxConfig", () => (parcelRequire("dbrxt")).default);

var $6VmXC = parcelRequire("6VmXC");

var $bmcE0 = parcelRequire("bmcE0");

var $dbrxt = parcelRequire("dbrxt");

});
parcelRegister("bmcE0", function(module, exports) {

$parcel$export(module.exports, "default", () => $844b8eae0a572420$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $b4f8D = parcelRequire("b4f8D");

var $dbrxt = parcelRequire("dbrxt");
const $844b8eae0a572420$var$_excluded = [
    "sx"
];
const $844b8eae0a572420$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $dbrxt.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $844b8eae0a572420$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $fAJB5.default)(props, $844b8eae0a572420$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $844b8eae0a572420$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $b4f8D.isPlainObject)(result)) return systemProps;
        return (0, $eJfrs.default)({}, systemProps, result);
    };
    else finalSx = (0, $eJfrs.default)({}, systemProps, inSx);
    return (0, $eJfrs.default)({}, otherProps, {
        sx: finalSx
    });
}

});


parcelRegister("9hqRN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("eKiFq")).default);

var $eKiFq = parcelRequire("eKiFq");

});
parcelRegister("eKiFq", function(module, exports) {

$parcel$export(module.exports, "default", () => $abc3d779b35499b3$export$2e2bcd8739ae039);
function $abc3d779b35499b3$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $abc3d779b35499b3$export$2e2bcd8739ae039 = $abc3d779b35499b3$var$clamp;

});


parcelRegister("4E8mP", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a7uO0.default;
    }
});

var $a7uO0 = parcelRequire("a7uO0");

});
parcelRegister("a7uO0", function(module, exports) {

$parcel$export(module.exports, "default", () => $75e2742cf9216c63$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $axLMO = parcelRequire("axLMO");

var $k4ank = parcelRequire("k4ank");
'use client';
function $75e2742cf9216c63$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), (0, $eJfrs.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    // Need to set `displayName` on the inner component for React.memo.
    // React prior to 16.14 ignores `displayName` on the wrapper.
    Component.displayName = `${displayName}Icon`;
    Component.muiName = (0, $axLMO.default).muiName;
    return /*#__PURE__*/ $8T3gX.memo(/*#__PURE__*/ $8T3gX.forwardRef(Component));
}

});
parcelRegister("axLMO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ad20dcb9f886a17$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $iMOmE = parcelRequire("iMOmE");

var $7AQZl = parcelRequire("7AQZl");

var $anJSP = parcelRequire("anJSP");

var $bPE0v = parcelRequire("bPE0v");

var $k4ank = parcelRequire("k4ank");
'use client';
const $7ad20dcb9f886a17$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $7ad20dcb9f886a17$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $iMOmE.default)(color)}`,
            `fontSize${(0, $iMOmE.default)(fontSize)}`
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $bPE0v.getSvgIconUtilityClass), classes);
};
const $7ad20dcb9f886a17$var$SvgIconRoot = (0, $anJSP.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $iMOmE.default)(ownerState.color)}`],
            styles[`fontSize${(0, $iMOmE.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: 'inherit',
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $7ad20dcb9f886a17$var$SvgIcon = /*#__PURE__*/ $8T3gX.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24' } = props, other = (0, $fAJB5.default)(props, $7ad20dcb9f886a17$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $8T3gX.isValidElement(children) && children.type === 'svg';
    const ownerState = (0, $eJfrs.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $7ad20dcb9f886a17$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsxs)($7ad20dcb9f886a17$var$SvgIconRoot, (0, $eJfrs.default)({
        as: component,
        className: (0, $iVyaN.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $k4ank.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$7ad20dcb9f886a17$var$SvgIcon.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Node passed into the SVG element.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'inherit',
            'action',
            'disabled',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */ fontSize: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'inherit',
            'large',
            'medium',
            'small'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * Applies a color attribute to the SVG element.
   */ htmlColor: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */ inheritViewBox: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */ shapeRendering: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */ titleAccess: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */ viewBox: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
};
$7ad20dcb9f886a17$var$SvgIcon.muiName = 'SvgIcon';
var $7ad20dcb9f886a17$export$2e2bcd8739ae039 = $7ad20dcb9f886a17$var$SvgIcon;

});
parcelRegister("iVyaN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1bf9bfe81fb1fc0$export$2e2bcd8739ae039);
function $e1bf9bfe81fb1fc0$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $e1bf9bfe81fb1fc0$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $e1bf9bfe81fb1fc0$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $e1bf9bfe81fb1fc0$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $e1bf9bfe81fb1fc0$export$2e2bcd8739ae039 = $e1bf9bfe81fb1fc0$export$4f5d2d50c9deca37;

});

parcelRegister("aYNpO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fe5d6d4483bdd37$export$2e2bcd8739ae039);
function $7fe5d6d4483bdd37$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}

});

parcelRegister("iMOmE", function(module, exports) {

$parcel$export(module.exports, "default", () => $dad3c70534875d2e$export$2e2bcd8739ae039);

var $flLLM = parcelRequire("flLLM");
var $dad3c70534875d2e$export$2e2bcd8739ae039 = (0, $flLLM.default);

});

parcelRegister("7AQZl", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $5874ff950ff669e1$export$2440da353cedad43);

var $eJfrs = parcelRequire("eJfrs");
parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $1inFE = parcelRequire("1inFE");

var $k4ank = parcelRequire("k4ank");
'use client';
function $5874ff950ff669e1$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $1inFE.default), (0, $eJfrs.default)({}, props));
}
$5874ff950ff669e1$var$DefaultPropsProvider.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * @ignore
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object.isRequired
};
var $5874ff950ff669e1$export$2e2bcd8739ae039 = $5874ff950ff669e1$var$DefaultPropsProvider;
function $5874ff950ff669e1$export$2440da353cedad43(params) {
    return (0, $1inFE.useDefaultProps)(params);
}

});
parcelRegister("1inFE", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $0f19d56bbc041e71$export$2440da353cedad43);
$parcel$export(module.exports, "default", () => $0f19d56bbc041e71$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $cA45A = parcelRequire("cA45A");

var $k4ank = parcelRequire("k4ank");
'use client';
const $0f19d56bbc041e71$var$PropsContext = /*#__PURE__*/ $8T3gX.createContext(undefined);
function $0f19d56bbc041e71$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $k4ank.jsx)($0f19d56bbc041e71$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
$0f19d56bbc041e71$var$DefaultPropsProvider.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * @ignore
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
};
function $0f19d56bbc041e71$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $cA45A.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $cA45A.default)(config, props);
    return props;
}
function $0f19d56bbc041e71$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $8T3gX.useContext($0f19d56bbc041e71$var$PropsContext);
    return $0f19d56bbc041e71$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $0f19d56bbc041e71$export$2e2bcd8739ae039 = $0f19d56bbc041e71$var$DefaultPropsProvider;

});
parcelRegister("cA45A", function(module, exports) {

$parcel$export(module.exports, "default", () => $928c04d4cfbc99c3$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");
function $928c04d4cfbc99c3$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $eJfrs.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $eJfrs.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $eJfrs.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $928c04d4cfbc99c3$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});



parcelRegister("anJSP", function(module, exports) {

$parcel$export(module.exports, "default", () => $78efa4dba77fcbf3$export$2e2bcd8739ae039);
$parcel$export(module.exports, "rootShouldForwardProp", () => (parcelRequire("3dQcH")).default);

var $heDbu = parcelRequire("heDbu");

var $ehyEf = parcelRequire("ehyEf");

var $kuBjs = parcelRequire("kuBjs");

var $3dQcH = parcelRequire("3dQcH");

var $hxpHQ = parcelRequire("hxpHQ");
'use client';
const $78efa4dba77fcbf3$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($heDbu)))({
    themeId: (0, $kuBjs.default),
    defaultTheme: $ehyEf.default,
    rootShouldForwardProp: $3dQcH.default
});
var $78efa4dba77fcbf3$export$2e2bcd8739ae039 = $78efa4dba77fcbf3$var$styled;

});
parcelRegister("heDbu", function(module, exports) {
"use strict";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c8c223adbedda7b9$var$createStyled;
module.exports.shouldForwardProp = $c8c223adbedda7b9$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $c8c223adbedda7b9$var$_extends2 = $Bx5pa((parcelRequire("5mb8k")));

var $c8c223adbedda7b9$var$_objectWithoutPropertiesLoose2 = $Bx5pa((parcelRequire("9MMlq")));

var $c8c223adbedda7b9$var$_styledEngine = $c8c223adbedda7b9$var$_interopRequireWildcard((parcelRequire("7P7g9")));

var $b4f8D = parcelRequire("b4f8D");

var $c8c223adbedda7b9$var$_capitalize = $Bx5pa((parcelRequire("23Jeg")));

var $c8c223adbedda7b9$var$_getDisplayName = $Bx5pa((parcelRequire("5RQIC")));

var $c8c223adbedda7b9$var$_createTheme = $Bx5pa((parcelRequire("9ZhGv")));

var $c8c223adbedda7b9$var$_styleFunctionSx = $Bx5pa((parcelRequire("fa0wV")));
const $c8c223adbedda7b9$var$_excluded = [
    "ownerState"
], $c8c223adbedda7b9$var$_excluded2 = [
    "variants"
], $c8c223adbedda7b9$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $c8c223adbedda7b9$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c8c223adbedda7b9$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $c8c223adbedda7b9$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $c8c223adbedda7b9$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $c8c223adbedda7b9$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $c8c223adbedda7b9$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $c8c223adbedda7b9$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $c8c223adbedda7b9$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
const $c8c223adbedda7b9$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $c8c223adbedda7b9$var$_createTheme.default)();
const $c8c223adbedda7b9$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $c8c223adbedda7b9$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $c8c223adbedda7b9$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $c8c223adbedda7b9$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $c8c223adbedda7b9$var$processStyleArg(callableStyle, _ref, layerName) {
    let { ownerState: ownerState } = _ref, props = (0, $c8c223adbedda7b9$var$_objectWithoutPropertiesLoose2.default)(_ref, $c8c223adbedda7b9$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $c8c223adbedda7b9$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$c8c223adbedda7b9$var$processStyleArg(resolvedStyle, (0, $c8c223adbedda7b9$var$_extends2.default)({
            ownerState: ownerState
        }, props), layerName));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $c8c223adbedda7b9$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $c8c223adbedda7b9$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $c8c223adbedda7b9$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                const variantStyle = typeof variant.style === 'function' ? variant.style((0, $c8c223adbedda7b9$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style;
                result.push(layerName ? $c8c223adbedda7b9$var$shallowLayer((0, $c8c223adbedda7b9$var$_styledEngine.internal_serializeStyles)(variantStyle), layerName) : variantStyle);
            }
        });
        return result;
    }
    return layerName ? $c8c223adbedda7b9$var$shallowLayer((0, $c8c223adbedda7b9$var$_styledEngine.internal_serializeStyles)(resolvedStylesArg), layerName) : resolvedStylesArg;
}
function $c8c223adbedda7b9$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $c8c223adbedda7b9$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $c8c223adbedda7b9$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $c8c223adbedda7b9$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $c8c223adbedda7b9$var$_styleFunctionSx.default)((0, $c8c223adbedda7b9$var$_extends2.default)({}, props, {
            theme: $c8c223adbedda7b9$var$resolveTheme((0, $c8c223adbedda7b9$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $c8c223adbedda7b9$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $c8c223adbedda7b9$var$defaultOverridesResolver($c8c223adbedda7b9$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $c8c223adbedda7b9$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $c8c223adbedda7b9$var$_excluded3);
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        if (componentName) // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        label = `${componentName}-${$c8c223adbedda7b9$var$lowercaseFirstLetter(componentSlot || 'Root')}`;
        let shouldForwardPropOption = $c8c223adbedda7b9$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($c8c223adbedda7b9$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $c8c223adbedda7b9$var$_styledEngine.default)(tag, (0, $c8c223adbedda7b9$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $b4f8D.isPlainObject)(stylesArg)) return (props)=>{
                const theme = $c8c223adbedda7b9$var$resolveTheme({
                    theme: props.theme,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
                return $c8c223adbedda7b9$var$processStyleArg(stylesArg, (0, $c8c223adbedda7b9$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? layerName : undefined);
            };
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $c8c223adbedda7b9$var$resolveTheme((0, $c8c223adbedda7b9$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $c8c223adbedda7b9$var$processStyleArg(slotStyle, (0, $c8c223adbedda7b9$var$_extends2.default)({}, props, {
                        theme: theme
                    }), theme.modularCssLayers ? 'theme' : undefined);
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $c8c223adbedda7b9$var$resolveTheme((0, $c8c223adbedda7b9$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $c8c223adbedda7b9$var$processStyleArg({
                    variants: themeVariants
                }, (0, $c8c223adbedda7b9$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            {
                let displayName;
                if (componentName) displayName = `${componentName}${(0, $c8c223adbedda7b9$var$_capitalize.default)(componentSlot || '')}`;
                if (displayName === undefined) displayName = `Styled(${(0, $c8c223adbedda7b9$var$_getDisplayName.default)(tag)})`;
                Component.displayName = displayName;
            }
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("Bx5pa", function(module, exports) {
function $070d1f0a9e000ec9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $070d1f0a9e000ec9$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("ehyEf", function(module, exports) {

$parcel$export(module.exports, "default", () => $a65d879fa78cebde$export$2e2bcd8739ae039);

var $cFPmV = parcelRequire("cFPmV");
'use client';
const $a65d879fa78cebde$var$defaultTheme = (0, $cFPmV.default)();
var $a65d879fa78cebde$export$2e2bcd8739ae039 = $a65d879fa78cebde$var$defaultTheme;

});
parcelRegister("cFPmV", function(module, exports) {

$parcel$export(module.exports, "default", () => $93a1291dfa87cdfc$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");


var $b4f8D = parcelRequire("b4f8D");

var $6VmXC = parcelRequire("6VmXC");
var $dbrxt = parcelRequire("dbrxt");

var $6IeW0 = parcelRequire("6IeW0");

var $kfTYv = parcelRequire("kfTYv");

var $byIJM = parcelRequire("byIJM");

var $2iUMc = parcelRequire("2iUMc");

var $6pMEW = parcelRequire("6pMEW");

var $7hRiF = parcelRequire("7hRiF");

var $3H2gO = parcelRequire("3H2gO");

var $4l8Q2 = parcelRequire("4l8Q2");
const $93a1291dfa87cdfc$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $93a1291dfa87cdfc$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $fAJB5.default)(options, $93a1291dfa87cdfc$var$_excluded);
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateCssVars` is the closest identifier for checking that the `options` is a result of `extendTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateCssVars === undefined) throw new Error(`MUI: \`vars\` is a private field used for CSS variables support.
Please use another name.`);
    const palette = (0, $2iUMc.default)(paletteInput);
    const systemTheme = (0, $6IeW0.default)(options);
    let muiTheme = (0, $b4f8D.default)(systemTheme, {
        mixins: (0, $byIJM.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $7hRiF.default).slice(),
        typography: (0, $6pMEW.default)(palette, typographyInput),
        transitions: (0, $3H2gO.default)(transitionsInput),
        zIndex: (0, $eJfrs.default)({}, (0, $4l8Q2.default))
    });
    muiTheme = (0, $b4f8D.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $b4f8D.default)(acc, argument), muiTheme);
    {
        // TODO v6: Refactor to use globalStateClassesMapping from @mui/utils once `readOnly` state class is used in Rating component.
        const stateClasses = [
            'active',
            'checked',
            'completed',
            'disabled',
            'error',
            'expanded',
            'focused',
            'focusVisible',
            'required',
            'selected'
        ];
        const traverse = (node, component)=>{
            let key;
            // eslint-disable-next-line guard-for-in, no-restricted-syntax
            for(key in node){
                const child = node[key];
                if (stateClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
                    {
                        const stateClass = (0, $kfTYv.default)('', key);
                        console.error([
                            `MUI: The \`${component}\` component increases ` + `the CSS specificity of the \`${key}\` internal state.`,
                            'You can not override it like this: ',
                            JSON.stringify(node, null, 2),
                            '',
                            `Instead, you need to use the '&.${stateClass}' syntax:`,
                            JSON.stringify({
                                root: {
                                    [`&.${stateClass}`]: child
                                }
                            }, null, 2),
                            '',
                            'https://mui.com/r/state-classes-guide'
                        ].join('\n'));
                    }
                    // Remove the style to prevent global conflicts.
                    node[key] = {};
                }
            }
        };
        Object.keys(muiTheme.components).forEach((component)=>{
            const styleOverrides = muiTheme.components[component].styleOverrides;
            if (styleOverrides && component.indexOf('Mui') === 0) traverse(styleOverrides, component);
        });
    }
    muiTheme.unstable_sxConfig = (0, $eJfrs.default)({}, (0, $dbrxt.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $6VmXC.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $93a1291dfa87cdfc$var$warnedOnce = false;
function $93a1291dfa87cdfc$export$c469355549431d9b(...args) {
    if (!$93a1291dfa87cdfc$var$warnedOnce) {
        $93a1291dfa87cdfc$var$warnedOnce = true;
        console.error([
            'MUI: the createMuiTheme function was renamed to createTheme.',
            '',
            "You should use `import { createTheme } from '@mui/material/styles'`"
        ].join('\n'));
    }
    return $93a1291dfa87cdfc$var$createTheme(...args);
}
var $93a1291dfa87cdfc$export$2e2bcd8739ae039 = $93a1291dfa87cdfc$var$createTheme;

});
parcelRegister("kfTYv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebf0a0cf46602268$export$2e2bcd8739ae039);

var $asIMr = parcelRequire("asIMr");
const $ebf0a0cf46602268$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $ebf0a0cf46602268$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $ebf0a0cf46602268$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $asIMr.default).generate(componentName)}-${slot}`;
}
function $ebf0a0cf46602268$export$34c0130b1f3e8ae3(slot) {
    return $ebf0a0cf46602268$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("asIMr", function(module, exports) {

$parcel$export(module.exports, "default", () => $79df41536c14a5dd$export$2e2bcd8739ae039);
const $79df41536c14a5dd$var$defaultGenerator = (componentName)=>componentName;
const $79df41536c14a5dd$var$createClassNameGenerator = ()=>{
    let generate = $79df41536c14a5dd$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $79df41536c14a5dd$var$defaultGenerator;
        }
    };
};
const $79df41536c14a5dd$var$ClassNameGenerator = $79df41536c14a5dd$var$createClassNameGenerator();
var $79df41536c14a5dd$export$2e2bcd8739ae039 = $79df41536c14a5dd$var$ClassNameGenerator;

});


parcelRegister("byIJM", function(module, exports) {

$parcel$export(module.exports, "default", () => $86a5929f54d55f06$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");
function $86a5929f54d55f06$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $eJfrs.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("2iUMc", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ad94dd107fc32f6$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");


var $b4f8D = parcelRequire("b4f8D");

var $aBrLz = parcelRequire("aBrLz");

var $baAA7 = parcelRequire("baAA7");

var $h2Ex0 = parcelRequire("h2Ex0");

var $9CHaL = parcelRequire("9CHaL");

var $jIfBO = parcelRequire("jIfBO");

var $8fwaQ = parcelRequire("8fwaQ");

var $9c9IA = parcelRequire("9c9IA");

var $h0Y2V = parcelRequire("h0Y2V");

var $abNM6 = parcelRequire("abNM6");
const $1ad94dd107fc32f6$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $1ad94dd107fc32f6$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.6)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $baAA7.default).white,
        default: (0, $baAA7.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $1ad94dd107fc32f6$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $baAA7.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#121212',
        default: '#121212'
    },
    action: {
        active: (0, $baAA7.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $1ad94dd107fc32f6$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $aBrLz.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $aBrLz.darken)(intent.main, tonalOffsetDark);
    }
}
function $1ad94dd107fc32f6$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $9c9IA.default)[200],
        light: (0, $9c9IA.default)[50],
        dark: (0, $9c9IA.default)[400]
    };
    return {
        main: (0, $9c9IA.default)[700],
        light: (0, $9c9IA.default)[400],
        dark: (0, $9c9IA.default)[800]
    };
}
function $1ad94dd107fc32f6$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $9CHaL.default)[200],
        light: (0, $9CHaL.default)[50],
        dark: (0, $9CHaL.default)[400]
    };
    return {
        main: (0, $9CHaL.default)[500],
        light: (0, $9CHaL.default)[300],
        dark: (0, $9CHaL.default)[700]
    };
}
function $1ad94dd107fc32f6$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $jIfBO.default)[500],
        light: (0, $jIfBO.default)[300],
        dark: (0, $jIfBO.default)[700]
    };
    return {
        main: (0, $jIfBO.default)[700],
        light: (0, $jIfBO.default)[400],
        dark: (0, $jIfBO.default)[800]
    };
}
function $1ad94dd107fc32f6$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $h0Y2V.default)[400],
        light: (0, $h0Y2V.default)[300],
        dark: (0, $h0Y2V.default)[700]
    };
    return {
        main: (0, $h0Y2V.default)[700],
        light: (0, $h0Y2V.default)[500],
        dark: (0, $h0Y2V.default)[900]
    };
}
function $1ad94dd107fc32f6$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $abNM6.default)[400],
        light: (0, $abNM6.default)[300],
        dark: (0, $abNM6.default)[700]
    };
    return {
        main: (0, $abNM6.default)[800],
        light: (0, $abNM6.default)[500],
        dark: (0, $abNM6.default)[900]
    };
}
function $1ad94dd107fc32f6$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $8fwaQ.default)[400],
        light: (0, $8fwaQ.default)[300],
        dark: (0, $8fwaQ.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $8fwaQ.default)[500],
        dark: (0, $8fwaQ.default)[900]
    };
}
function $1ad94dd107fc32f6$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $fAJB5.default)(palette, $1ad94dd107fc32f6$var$_excluded);
    const primary = palette.primary || $1ad94dd107fc32f6$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $1ad94dd107fc32f6$var$getDefaultSecondary(mode);
    const error = palette.error || $1ad94dd107fc32f6$var$getDefaultError(mode);
    const info = palette.info || $1ad94dd107fc32f6$var$getDefaultInfo(mode);
    const success = palette.success || $1ad94dd107fc32f6$var$getDefaultSuccess(mode);
    const warning = palette.warning || $1ad94dd107fc32f6$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $aBrLz.getContrastRatio)(background, $1ad94dd107fc32f6$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $1ad94dd107fc32f6$export$55ce6f3a06c59543.text.primary : $1ad94dd107fc32f6$export$a43af521ac8c3202.text.primary;
        {
            const contrast = (0, $aBrLz.getContrastRatio)(background, contrastText);
            if (contrast < 3) console.error([
                `MUI: The contrast ratio of ${contrast}:1 for ${contrastText} on ${background}`,
                'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.',
                'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'
            ].join('\n'));
        }
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $eJfrs.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error(`MUI: The color${name ? ` (${name})` : ''} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${mainShade}\` property.`);
        if (typeof color.main !== 'string') throw new Error(`MUI: The color${name ? ` (${name})` : ''} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(color.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });`);
        $1ad94dd107fc32f6$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $1ad94dd107fc32f6$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $1ad94dd107fc32f6$export$55ce6f3a06c59543,
        light: $1ad94dd107fc32f6$export$a43af521ac8c3202
    };
    if (!modes[mode]) console.error(`MUI: The palette mode \`${mode}\` is not supported.`);
    const paletteOutput = (0, $b4f8D.default)((0, $eJfrs.default)({
        // A collection of common colors.
        common: (0, $eJfrs.default)({}, (0, $baAA7.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $h2Ex0.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("aBrLz", function(module, exports) {
"use strict";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $7b82e5e521271161$var$alpha;
module.exports.blend = $7b82e5e521271161$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $7b82e5e521271161$var$darken;
module.exports.decomposeColor = $7b82e5e521271161$var$decomposeColor;
module.exports.emphasize = $7b82e5e521271161$var$emphasize;
module.exports.getContrastRatio = $7b82e5e521271161$var$getContrastRatio;
module.exports.getLuminance = $7b82e5e521271161$var$getLuminance;
module.exports.hexToRgb = $7b82e5e521271161$var$hexToRgb;
module.exports.hslToRgb = $7b82e5e521271161$var$hslToRgb;
module.exports.lighten = $7b82e5e521271161$var$lighten;
module.exports.private_safeAlpha = $7b82e5e521271161$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $7b82e5e521271161$var$private_safeDarken;
module.exports.private_safeEmphasize = $7b82e5e521271161$var$private_safeEmphasize;
module.exports.private_safeLighten = $7b82e5e521271161$var$private_safeLighten;
module.exports.recomposeColor = $7b82e5e521271161$var$recomposeColor;
module.exports.rgbToHex = $7b82e5e521271161$var$rgbToHex;

var $7b82e5e521271161$var$_formatMuiErrorMessage2 = $Bx5pa((parcelRequire("cYIhZ")));

var $7b82e5e521271161$var$_clamp = $Bx5pa((parcelRequire("9hqRN")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $7b82e5e521271161$var$clampWrapper(value, min = 0, max = 1) {
    if (value < min || value > max) console.error(`MUI: The value provided ${value} is out of range [${min}, ${max}].`);
    return (0, $7b82e5e521271161$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $7b82e5e521271161$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $7b82e5e521271161$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $7b82e5e521271161$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $7b82e5e521271161$var$decomposeColor($7b82e5e521271161$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error(`MUI: Unsupported \`${color}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().`);
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error(`MUI: unsupported \`${colorSpace}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.`);
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $7b82e5e521271161$var$colorChannel = (color)=>{
    const decomposedColor = $7b82e5e521271161$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
module.exports.colorChannel = $7b82e5e521271161$var$colorChannel;
const $7b82e5e521271161$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $7b82e5e521271161$var$colorChannel(color);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $7b82e5e521271161$var$private_safeColorChannel;
function $7b82e5e521271161$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $7b82e5e521271161$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $7b82e5e521271161$var$decomposeColor(color);
    return `#${values.map((n, i)=>$7b82e5e521271161$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $7b82e5e521271161$var$hslToRgb(color) {
    color = $7b82e5e521271161$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $7b82e5e521271161$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $7b82e5e521271161$var$getLuminance(color) {
    color = $7b82e5e521271161$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $7b82e5e521271161$var$decomposeColor($7b82e5e521271161$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $7b82e5e521271161$var$getContrastRatio(foreground, background) {
    const lumA = $7b82e5e521271161$var$getLuminance(foreground);
    const lumB = $7b82e5e521271161$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $7b82e5e521271161$var$alpha(color, value) {
    color = $7b82e5e521271161$var$decomposeColor(color);
    value = $7b82e5e521271161$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $7b82e5e521271161$var$recomposeColor(color);
}
function $7b82e5e521271161$var$private_safeAlpha(color, value, warning) {
    try {
        return $7b82e5e521271161$var$alpha(color, value);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $7b82e5e521271161$var$darken(color, coefficient) {
    color = $7b82e5e521271161$var$decomposeColor(color);
    coefficient = $7b82e5e521271161$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $7b82e5e521271161$var$recomposeColor(color);
}
function $7b82e5e521271161$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $7b82e5e521271161$var$darken(color, coefficient);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $7b82e5e521271161$var$lighten(color, coefficient) {
    color = $7b82e5e521271161$var$decomposeColor(color);
    coefficient = $7b82e5e521271161$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $7b82e5e521271161$var$recomposeColor(color);
}
function $7b82e5e521271161$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $7b82e5e521271161$var$lighten(color, coefficient);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $7b82e5e521271161$var$emphasize(color, coefficient = 0.15) {
    return $7b82e5e521271161$var$getLuminance(color) > 0.5 ? $7b82e5e521271161$var$darken(color, coefficient) : $7b82e5e521271161$var$lighten(color, coefficient);
}
function $7b82e5e521271161$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $7b82e5e521271161$var$emphasize(color, coefficient);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $7b82e5e521271161$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $7b82e5e521271161$var$decomposeColor(background);
    const overlayColor = $7b82e5e521271161$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $7b82e5e521271161$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

});

parcelRegister("baAA7", function(module, exports) {

$parcel$export(module.exports, "default", () => $821d013439903aa3$export$2e2bcd8739ae039);
const $821d013439903aa3$var$common = {
    black: '#000',
    white: '#fff'
};
var $821d013439903aa3$export$2e2bcd8739ae039 = $821d013439903aa3$var$common;

});

parcelRegister("h2Ex0", function(module, exports) {

$parcel$export(module.exports, "default", () => $c682103ec1169bd0$export$2e2bcd8739ae039);
const $c682103ec1169bd0$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $c682103ec1169bd0$export$2e2bcd8739ae039 = $c682103ec1169bd0$var$grey;

});

parcelRegister("9CHaL", function(module, exports) {

$parcel$export(module.exports, "default", () => $701926d4217a1df6$export$2e2bcd8739ae039);
const $701926d4217a1df6$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $701926d4217a1df6$export$2e2bcd8739ae039 = $701926d4217a1df6$var$purple;

});

parcelRegister("jIfBO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e59e3bf482112557$export$2e2bcd8739ae039);
const $e59e3bf482112557$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $e59e3bf482112557$export$2e2bcd8739ae039 = $e59e3bf482112557$var$red;

});

parcelRegister("8fwaQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6018ae7f7e8ad914$export$2e2bcd8739ae039);
const $6018ae7f7e8ad914$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $6018ae7f7e8ad914$export$2e2bcd8739ae039 = $6018ae7f7e8ad914$var$orange;

});

parcelRegister("9c9IA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b1cc5d70d7d49f3$export$2e2bcd8739ae039);
const $6b1cc5d70d7d49f3$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $6b1cc5d70d7d49f3$export$2e2bcd8739ae039 = $6b1cc5d70d7d49f3$var$blue;

});

parcelRegister("h0Y2V", function(module, exports) {

$parcel$export(module.exports, "default", () => $c63103ab7cf0c5a4$export$2e2bcd8739ae039);
const $c63103ab7cf0c5a4$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $c63103ab7cf0c5a4$export$2e2bcd8739ae039 = $c63103ab7cf0c5a4$var$lightBlue;

});

parcelRegister("abNM6", function(module, exports) {

$parcel$export(module.exports, "default", () => $76b18ab22037b65b$export$2e2bcd8739ae039);
const $76b18ab22037b65b$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $76b18ab22037b65b$export$2e2bcd8739ae039 = $76b18ab22037b65b$var$green;

});


parcelRegister("6pMEW", function(module, exports) {

$parcel$export(module.exports, "default", () => $4abad29c4746feef$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $b4f8D = parcelRequire("b4f8D");
const $4abad29c4746feef$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $4abad29c4746feef$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $4abad29c4746feef$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $4abad29c4746feef$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $4abad29c4746feef$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily: fontFamily = $4abad29c4746feef$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $fAJB5.default)(_ref, $4abad29c4746feef$var$_excluded);
    if (typeof fontSize !== 'number') console.error('MUI: `fontSize` is required to be a number.');
    if (typeof htmlFontSize !== 'number') console.error('MUI: `htmlFontSize` is required to be a number.');
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $eJfrs.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $4abad29c4746feef$var$defaultFontFamily ? {
            letterSpacing: `${$4abad29c4746feef$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $4abad29c4746feef$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $4abad29c4746feef$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $b4f8D.default)((0, $eJfrs.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("7hRiF", function(module, exports) {

$parcel$export(module.exports, "default", () => $54e3773c0e7d32a0$export$2e2bcd8739ae039);
const $54e3773c0e7d32a0$var$shadowKeyUmbraOpacity = 0.2;
const $54e3773c0e7d32a0$var$shadowKeyPenumbraOpacity = 0.14;
const $54e3773c0e7d32a0$var$shadowAmbientShadowOpacity = 0.12;
function $54e3773c0e7d32a0$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$54e3773c0e7d32a0$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$54e3773c0e7d32a0$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$54e3773c0e7d32a0$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $54e3773c0e7d32a0$var$shadows = [
    'none',
    $54e3773c0e7d32a0$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $54e3773c0e7d32a0$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $54e3773c0e7d32a0$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $54e3773c0e7d32a0$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $54e3773c0e7d32a0$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $54e3773c0e7d32a0$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $54e3773c0e7d32a0$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $54e3773c0e7d32a0$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $54e3773c0e7d32a0$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $54e3773c0e7d32a0$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $54e3773c0e7d32a0$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $54e3773c0e7d32a0$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $54e3773c0e7d32a0$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $54e3773c0e7d32a0$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $54e3773c0e7d32a0$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $54e3773c0e7d32a0$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $54e3773c0e7d32a0$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $54e3773c0e7d32a0$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $54e3773c0e7d32a0$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $54e3773c0e7d32a0$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $54e3773c0e7d32a0$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $54e3773c0e7d32a0$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $54e3773c0e7d32a0$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $54e3773c0e7d32a0$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $54e3773c0e7d32a0$export$2e2bcd8739ae039 = $54e3773c0e7d32a0$var$shadows;

});

parcelRegister("3H2gO", function(module, exports) {

$parcel$export(module.exports, "duration", () => $2b07260d1e56eb28$export$1f34108aa9eb96ab);
$parcel$export(module.exports, "default", () => $2b07260d1e56eb28$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");
const $2b07260d1e56eb28$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $2b07260d1e56eb28$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $2b07260d1e56eb28$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $2b07260d1e56eb28$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $2b07260d1e56eb28$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $2b07260d1e56eb28$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $eJfrs.default)({}, $2b07260d1e56eb28$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $eJfrs.default)({}, $2b07260d1e56eb28$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $fAJB5.default)(options, $2b07260d1e56eb28$var$_excluded);
        {
            const isString = (value)=>typeof value === 'string';
            // IE11 support, replace with Number.isNaN
            // eslint-disable-next-line no-restricted-globals
            const isNumber = (value)=>!isNaN(parseFloat(value));
            if (!isString(props) && !Array.isArray(props)) console.error('MUI: Argument "props" must be a string or Array.');
            if (!isNumber(durationOption) && !isString(durationOption)) console.error(`MUI: Argument "duration" must be a number or a string but found ${durationOption}.`);
            if (!isString(easingOption)) console.error('MUI: Argument "easing" must be a string.');
            if (!isNumber(delay) && !isString(delay)) console.error('MUI: Argument "delay" must be a number or a string.');
            if (typeof options !== 'object') console.error([
                'MUI: Secong argument of transition.create must be an object.',
                "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"
            ].join('\n'));
            if (Object.keys(other).length !== 0) console.error(`MUI: Unrecognized argument(s) [${Object.keys(other).join(',')}].`);
        }
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $2b07260d1e56eb28$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $2b07260d1e56eb28$var$formatMs(delay)}`).join(',');
    };
    return (0, $eJfrs.default)({
        getAutoHeightDuration: $2b07260d1e56eb28$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("4l8Q2", function(module, exports) {

$parcel$export(module.exports, "default", () => $328ffab1bfb20666$export$2e2bcd8739ae039);
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $328ffab1bfb20666$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $328ffab1bfb20666$export$2e2bcd8739ae039 = $328ffab1bfb20666$var$zIndex;

});



parcelRegister("kuBjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $eeb38d9003fb98e7$export$2e2bcd8739ae039);
var $eeb38d9003fb98e7$export$2e2bcd8739ae039 = '$$material';

});

parcelRegister("3dQcH", function(module, exports) {

$parcel$export(module.exports, "default", () => $258b1493304e39f7$export$2e2bcd8739ae039);

var $hxpHQ = parcelRequire("hxpHQ");
const $258b1493304e39f7$var$rootShouldForwardProp = (prop)=>(0, $hxpHQ.default)(prop) && prop !== 'classes';
var $258b1493304e39f7$export$2e2bcd8739ae039 = $258b1493304e39f7$var$rootShouldForwardProp;

});
parcelRegister("hxpHQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc49756c5e5a9a1b$export$2e2bcd8739ae039);
// copied from @mui/system/createStyled
function $cc49756c5e5a9a1b$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $cc49756c5e5a9a1b$export$2e2bcd8739ae039 = $cc49756c5e5a9a1b$var$slotShouldForwardProp;

});



parcelRegister("bPE0v", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", () => $89d37db4991cc626$export$c7c50641356bdfa5);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $89d37db4991cc626$export$c7c50641356bdfa5(slot) {
    return (0, $kfTYv.default)('MuiSvgIcon', slot);
}
const $89d37db4991cc626$var$svgIconClasses = (0, $jh2Zm.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $89d37db4991cc626$export$2e2bcd8739ae039 = $89d37db4991cc626$var$svgIconClasses;

});
parcelRegister("jh2Zm", function(module, exports) {

$parcel$export(module.exports, "default", () => $e081ec57467cc032$export$2e2bcd8739ae039);

var $kfTYv = parcelRequire("kfTYv");
function $e081ec57467cc032$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $kfTYv.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});





parcelRegister("8PZ7C", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $66f27fb5543ba154$export$bf730a2d8bf68b42, (v) => $66f27fb5543ba154$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $66f27fb5543ba154$export$bf730a2d8bf68b42;
"use strict";


(function() {
    function is(x, y) {
        return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React = (parcelRequire("8T3gX")), shim = (parcelRequire("jkHQD")), objectIs = "function" === typeof Object.is ? Object.is : is, useSyncExternalStore = shim.useSyncExternalStore, useRef = React.useRef, useEffect = React.useEffect, useMemo = React.useMemo, useDebugValue = React.useDebugValue;
    $66f27fb5543ba154$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
        var instRef = useRef(null);
        if (null === instRef.current) {
            var inst = {
                hasValue: !1,
                value: null
            };
            instRef.current = inst;
        } else inst = instRef.current;
        instRef = useMemo(function() {
            function memoizedSelector(nextSnapshot) {
                if (!hasMemo) {
                    hasMemo = !0;
                    memoizedSnapshot = nextSnapshot;
                    nextSnapshot = selector(nextSnapshot);
                    if (void 0 !== isEqual && inst.hasValue) {
                        var currentSelection = inst.value;
                        if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                    }
                    return memoizedSelection = nextSnapshot;
                }
                currentSelection = memoizedSelection;
                if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
                var nextSelection = selector(nextSnapshot);
                if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
                memoizedSnapshot = nextSnapshot;
                return memoizedSelection = nextSelection;
            }
            var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
            return [
                function() {
                    return memoizedSelector(getSnapshot());
                },
                null === maybeGetServerSnapshot ? void 0 : function() {
                    return memoizedSelector(maybeGetServerSnapshot());
                }
            ];
        }, [
            getSnapshot,
            getServerSnapshot,
            selector,
            isEqual
        ]);
        var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
        useEffect(function() {
            inst.hasValue = !0;
            inst.value = value;
        }, [
            value
        ]);
        useDebugValue(value);
        return value;
    };
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

});
parcelRegister("jkHQD", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ITf2Y"));

});
parcelRegister("ITf2Y", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $086ef6067a160ee0$export$306c0aa65ff9ec16, (v) => $086ef6067a160ee0$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $086ef6067a160ee0$export$306c0aa65ff9ec16;
"use strict";

(function() {
    function is(x, y) {
        return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
    }
    function useSyncExternalStore$2(subscribe, getSnapshot) {
        didWarnOld18Alpha || void 0 === React.startTransition || (didWarnOld18Alpha = !0, console.error("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
        var value = getSnapshot();
        if (!didWarnUncachedGetSnapshot) {
            var cachedValue = getSnapshot();
            objectIs(value, cachedValue) || (console.error("The result of getSnapshot should be cached to avoid an infinite loop"), didWarnUncachedGetSnapshot = !0);
        }
        cachedValue = useState({
            inst: {
                value: value,
                getSnapshot: getSnapshot
            }
        });
        var inst = cachedValue[0].inst, forceUpdate = cachedValue[1];
        useLayoutEffect(function() {
            inst.value = value;
            inst.getSnapshot = getSnapshot;
            checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        }, [
            subscribe,
            value,
            getSnapshot
        ]);
        useEffect(function() {
            checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
            return subscribe(function() {
                checkIfSnapshotChanged(inst) && forceUpdate({
                    inst: inst
                });
            });
        }, [
            subscribe
        ]);
        useDebugValue(value);
        return value;
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        inst = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(inst, nextValue);
        } catch (error) {
            return !0;
        }
    }
    function useSyncExternalStore$1(subscribe, getSnapshot) {
        return getSnapshot();
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React = (parcelRequire("8T3gX")), objectIs = "function" === typeof Object.is ? Object.is : is, useState = React.useState, useEffect = React.useEffect, useLayoutEffect = React.useLayoutEffect, useDebugValue = React.useDebugValue, didWarnOld18Alpha = !1, didWarnUncachedGetSnapshot = !1, shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
    $086ef6067a160ee0$export$306c0aa65ff9ec16 = void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

});



parcelRegister("ky7bB", function(module, exports) {
'use strict';

var $c12Z1 = parcelRequire("c12Z1");

var $gY8GO = parcelRequire("gY8GO");

var $lRacR = parcelRequire("lRacR");

var $1gt9b = parcelRequire("1gt9b");

var $crF0L = parcelRequire("crF0L");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $ef5c8ea58489a82b$var$createInstance(defaultConfig) {
    var context = new $lRacR(defaultConfig);
    var instance = $gY8GO($lRacR.prototype.request, context);
    // Copy axios.prototype to instance
    $c12Z1.extend(instance, $lRacR.prototype, context);
    // Copy context to instance
    $c12Z1.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $ef5c8ea58489a82b$var$createInstance($1gt9b(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $ef5c8ea58489a82b$var$axios = $ef5c8ea58489a82b$var$createInstance($crF0L);
// Expose Axios class to allow class inheritance
$ef5c8ea58489a82b$var$axios.Axios = $lRacR;

// Expose Cancel & CancelToken
$ef5c8ea58489a82b$var$axios.CanceledError = (parcelRequire("geYla"));

$ef5c8ea58489a82b$var$axios.CancelToken = (parcelRequire("44tM5"));

$ef5c8ea58489a82b$var$axios.isCancel = (parcelRequire("d0uo4"));

$ef5c8ea58489a82b$var$axios.VERSION = (parcelRequire("bGlWZ")).version;

$ef5c8ea58489a82b$var$axios.toFormData = (parcelRequire("17AEp"));

// Expose AxiosError class
$ef5c8ea58489a82b$var$axios.AxiosError = (parcelRequire("7cLzr"));
// alias for CanceledError for backward compatibility
$ef5c8ea58489a82b$var$axios.Cancel = $ef5c8ea58489a82b$var$axios.CanceledError;
// Expose all/spread
$ef5c8ea58489a82b$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$ef5c8ea58489a82b$var$axios.spread = (parcelRequire("ksbQV"));

// Expose isAxiosError
$ef5c8ea58489a82b$var$axios.isAxiosError = (parcelRequire("jHjFB"));
module.exports = $ef5c8ea58489a82b$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $ef5c8ea58489a82b$var$axios;

});
parcelRegister("c12Z1", function(module, exports) {
'use strict';

var $gY8GO = parcelRequire("gY8GO");
// utils is a library of generic helper functions non-specific to axios
var $0241ef09f74d1c01$var$toString = Object.prototype.toString;
// eslint-disable-next-line func-names
var $0241ef09f74d1c01$var$kindOf = function(cache) {
    // eslint-disable-next-line func-names
    return function(thing) {
        var str = $0241ef09f74d1c01$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
function $0241ef09f74d1c01$var$kindOfTest(type) {
    type = type.toLowerCase();
    return function isKindOf(thing) {
        return $0241ef09f74d1c01$var$kindOf(thing) === type;
    };
}
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $0241ef09f74d1c01$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $0241ef09f74d1c01$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $0241ef09f74d1c01$var$isBuffer(val) {
    return val !== null && !$0241ef09f74d1c01$var$isUndefined(val) && val.constructor !== null && !$0241ef09f74d1c01$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var $0241ef09f74d1c01$var$isArrayBuffer = $0241ef09f74d1c01$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $0241ef09f74d1c01$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $0241ef09f74d1c01$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $0241ef09f74d1c01$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $0241ef09f74d1c01$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $0241ef09f74d1c01$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $0241ef09f74d1c01$var$isPlainObject(val) {
    if ($0241ef09f74d1c01$var$kindOf(val) !== 'object') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ var $0241ef09f74d1c01$var$isDate = $0241ef09f74d1c01$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $0241ef09f74d1c01$var$isFile = $0241ef09f74d1c01$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var $0241ef09f74d1c01$var$isBlob = $0241ef09f74d1c01$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $0241ef09f74d1c01$var$isFileList = $0241ef09f74d1c01$var$kindOfTest('FileList');
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $0241ef09f74d1c01$var$isFunction(val) {
    return $0241ef09f74d1c01$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $0241ef09f74d1c01$var$isStream(val) {
    return $0241ef09f74d1c01$var$isObject(val) && $0241ef09f74d1c01$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $0241ef09f74d1c01$var$isFormData(thing) {
    var pattern = '[object FormData]';
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $0241ef09f74d1c01$var$toString.call(thing) === pattern || $0241ef09f74d1c01$var$isFunction(thing.toString) && thing.toString() === pattern);
}
/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var $0241ef09f74d1c01$var$isURLSearchParams = $0241ef09f74d1c01$var$kindOfTest('URLSearchParams');
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $0241ef09f74d1c01$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $0241ef09f74d1c01$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $0241ef09f74d1c01$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($0241ef09f74d1c01$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $0241ef09f74d1c01$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($0241ef09f74d1c01$var$isPlainObject(result[key]) && $0241ef09f74d1c01$var$isPlainObject(val)) result[key] = $0241ef09f74d1c01$var$merge(result[key], val);
        else if ($0241ef09f74d1c01$var$isPlainObject(val)) result[key] = $0241ef09f74d1c01$var$merge({}, val);
        else if ($0241ef09f74d1c01$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$0241ef09f74d1c01$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $0241ef09f74d1c01$var$extend(a, b, thisArg) {
    $0241ef09f74d1c01$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $gY8GO(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $0241ef09f74d1c01$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */ function $0241ef09f74d1c01$var$inherits(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    props && Object.assign(constructor.prototype, props);
}
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */ function $0241ef09f74d1c01$var$toFlatObject(sourceObj, destObj, filter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if (!merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = Object.getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
}
/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */ function $0241ef09f74d1c01$var$endsWith(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
}
/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */ function $0241ef09f74d1c01$var$toArray(thing) {
    if (!thing) return null;
    var i = thing.length;
    if ($0241ef09f74d1c01$var$isUndefined(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
}
// eslint-disable-next-line func-names
var $0241ef09f74d1c01$var$isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));
module.exports = {
    isArray: $0241ef09f74d1c01$var$isArray,
    isArrayBuffer: $0241ef09f74d1c01$var$isArrayBuffer,
    isBuffer: $0241ef09f74d1c01$var$isBuffer,
    isFormData: $0241ef09f74d1c01$var$isFormData,
    isArrayBufferView: $0241ef09f74d1c01$var$isArrayBufferView,
    isString: $0241ef09f74d1c01$var$isString,
    isNumber: $0241ef09f74d1c01$var$isNumber,
    isObject: $0241ef09f74d1c01$var$isObject,
    isPlainObject: $0241ef09f74d1c01$var$isPlainObject,
    isUndefined: $0241ef09f74d1c01$var$isUndefined,
    isDate: $0241ef09f74d1c01$var$isDate,
    isFile: $0241ef09f74d1c01$var$isFile,
    isBlob: $0241ef09f74d1c01$var$isBlob,
    isFunction: $0241ef09f74d1c01$var$isFunction,
    isStream: $0241ef09f74d1c01$var$isStream,
    isURLSearchParams: $0241ef09f74d1c01$var$isURLSearchParams,
    isStandardBrowserEnv: $0241ef09f74d1c01$var$isStandardBrowserEnv,
    forEach: $0241ef09f74d1c01$var$forEach,
    merge: $0241ef09f74d1c01$var$merge,
    extend: $0241ef09f74d1c01$var$extend,
    trim: $0241ef09f74d1c01$var$trim,
    stripBOM: $0241ef09f74d1c01$var$stripBOM,
    inherits: $0241ef09f74d1c01$var$inherits,
    toFlatObject: $0241ef09f74d1c01$var$toFlatObject,
    kindOf: $0241ef09f74d1c01$var$kindOf,
    kindOfTest: $0241ef09f74d1c01$var$kindOfTest,
    endsWith: $0241ef09f74d1c01$var$endsWith,
    toArray: $0241ef09f74d1c01$var$toArray,
    isTypedArray: $0241ef09f74d1c01$var$isTypedArray,
    isFileList: $0241ef09f74d1c01$var$isFileList
};

});
parcelRegister("gY8GO", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("lRacR", function(module, exports) {
'use strict';

var $c12Z1 = parcelRequire("c12Z1");

var $3gz4u = parcelRequire("3gz4u");

var $8rYM2 = parcelRequire("8rYM2");

var $acBoR = parcelRequire("acBoR");

var $1gt9b = parcelRequire("1gt9b");

var $dqWe2 = parcelRequire("dqWe2");

var $gLiiJ = parcelRequire("gLiiJ");
var $fe9676fa951866d9$var$validators = $gLiiJ.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $fe9676fa951866d9$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $8rYM2(),
        response: new $8rYM2()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $fe9676fa951866d9$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    config = $1gt9b(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    var transitional = config.transitional;
    if (transitional !== undefined) $gLiiJ.assertOptions(transitional, {
        silentJSONParsing: $fe9676fa951866d9$var$validators.transitional($fe9676fa951866d9$var$validators.boolean),
        forcedJSONParsing: $fe9676fa951866d9$var$validators.transitional($fe9676fa951866d9$var$validators.boolean),
        clarifyTimeoutError: $fe9676fa951866d9$var$validators.transitional($fe9676fa951866d9$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $acBoR,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $acBoR(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$fe9676fa951866d9$var$Axios.prototype.getUri = function getUri(config) {
    config = $1gt9b(this.defaults, config);
    var fullPath = $dqWe2(config.baseURL, config.url);
    return $3gz4u(fullPath, config.params, config.paramsSerializer);
};
// Provide aliases for supported request methods
$c12Z1.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $fe9676fa951866d9$var$Axios.prototype[method] = function(url, config) {
        return this.request($1gt9b(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$c12Z1.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request($1gt9b(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $fe9676fa951866d9$var$Axios.prototype[method] = generateHTTPMethod();
    $fe9676fa951866d9$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
module.exports = $fe9676fa951866d9$var$Axios;

});
parcelRegister("3gz4u", function(module, exports) {
'use strict';

var $c12Z1 = parcelRequire("c12Z1");
function $260e1231db7c94fa$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($c12Z1.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $c12Z1.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($c12Z1.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $c12Z1.forEach(val, function parseValue(v) {
                if ($c12Z1.isDate(v)) v = v.toISOString();
                else if ($c12Z1.isObject(v)) v = JSON.stringify(v);
                parts.push($260e1231db7c94fa$var$encode(key) + '=' + $260e1231db7c94fa$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
};

});

parcelRegister("8rYM2", function(module, exports) {
'use strict';

var $c12Z1 = parcelRequire("c12Z1");
function $626ffcbd95c0b97c$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $626ffcbd95c0b97c$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $626ffcbd95c0b97c$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $626ffcbd95c0b97c$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $c12Z1.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $626ffcbd95c0b97c$var$InterceptorManager;

});

parcelRegister("acBoR", function(module, exports) {
'use strict';

var $c12Z1 = parcelRequire("c12Z1");

var $kagZh = parcelRequire("kagZh");

var $d0uo4 = parcelRequire("d0uo4");

var $crF0L = parcelRequire("crF0L");

var $geYla = parcelRequire("geYla");
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ function $76d80934e8f189a0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $geYla();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $76d80934e8f189a0$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $kagZh.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $c12Z1.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $c12Z1.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $crF0L.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $76d80934e8f189a0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $kagZh.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$d0uo4(reason)) {
            $76d80934e8f189a0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $kagZh.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("kagZh", function(module, exports) {
'use strict';

var $c12Z1 = parcelRequire("c12Z1");

var $crF0L = parcelRequire("crF0L");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $crF0L;
    /*eslint no-param-reassign:0*/ $c12Z1.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("crF0L", function(module, exports) {
'use strict';

var $c12Z1 = parcelRequire("c12Z1");

var $djb7w = parcelRequire("djb7w");

var $7cLzr = parcelRequire("7cLzr");

var $3u3bM = parcelRequire("3u3bM");

var $17AEp = parcelRequire("17AEp");
var $90f7d1a094d68420$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $90f7d1a094d68420$var$setContentTypeIfUnset(headers, value) {
    if (!$c12Z1.isUndefined(headers) && $c12Z1.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $90f7d1a094d68420$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("lfNrH"));
    return adapter;
}
function $90f7d1a094d68420$var$stringifySafely(rawValue, parser, encoder) {
    if ($c12Z1.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $c12Z1.trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}

var $90f7d1a094d68420$var$defaults = {
    transitional: $3u3bM,
    adapter: $90f7d1a094d68420$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $djb7w(headers, 'Accept');
            $djb7w(headers, 'Content-Type');
            if ($c12Z1.isFormData(data) || $c12Z1.isArrayBuffer(data) || $c12Z1.isBuffer(data) || $c12Z1.isStream(data) || $c12Z1.isFile(data) || $c12Z1.isBlob(data)) return data;
            if ($c12Z1.isArrayBufferView(data)) return data.buffer;
            if ($c12Z1.isURLSearchParams(data)) {
                $90f7d1a094d68420$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            var isObjectPayload = $c12Z1.isObject(data);
            var contentType = headers && headers['Content-Type'];
            var isFileList;
            if ((isFileList = $c12Z1.isFileList(data)) || isObjectPayload && contentType === 'multipart/form-data') {
                var _FormData = this.env && this.env.FormData;
                return $17AEp(isFileList ? {
                    'files[]': data
                } : data, _FormData && new _FormData());
            } else if (isObjectPayload || contentType === 'application/json') {
                $90f7d1a094d68420$var$setContentTypeIfUnset(headers, 'application/json');
                return $90f7d1a094d68420$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $90f7d1a094d68420$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';
            if (strictJSONParsing || forcedJSONParsing && $c12Z1.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === 'SyntaxError') throw $7cLzr.from(e, $7cLzr.ERR_BAD_RESPONSE, this, null, this.response);
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (parcelRequire("kHWL2"))
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*'
        }
    }
};
$c12Z1.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $90f7d1a094d68420$var$defaults.headers[method] = {};
});
$c12Z1.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $90f7d1a094d68420$var$defaults.headers[method] = $c12Z1.merge($90f7d1a094d68420$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $90f7d1a094d68420$var$defaults;

});
parcelRegister("djb7w", function(module, exports) {
'use strict';

var $c12Z1 = parcelRequire("c12Z1");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $c12Z1.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("7cLzr", function(module, exports) {
'use strict';

var $c12Z1 = parcelRequire("c12Z1");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ function $53ee8defa7e87bbf$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
$c12Z1.inherits($53ee8defa7e87bbf$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
var $53ee8defa7e87bbf$var$prototype = $53ee8defa7e87bbf$var$AxiosError.prototype;
var $53ee8defa7e87bbf$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED'
].forEach(function(code) {
    $53ee8defa7e87bbf$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($53ee8defa7e87bbf$var$AxiosError, $53ee8defa7e87bbf$var$descriptors);
Object.defineProperty($53ee8defa7e87bbf$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$53ee8defa7e87bbf$var$AxiosError.from = function(error, code, config, request, response, customProps) {
    var axiosError = Object.create($53ee8defa7e87bbf$var$prototype);
    $c12Z1.toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    });
    $53ee8defa7e87bbf$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
module.exports = $53ee8defa7e87bbf$var$AxiosError;

});

parcelRegister("3u3bM", function(module, exports) {
'use strict';
module.exports = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("17AEp", function(module, exports) {

var $iSTPY = parcelRequire("iSTPY");
var $0d12dff350d1bca7$require$Buffer = $iSTPY.Buffer;
'use strict';

var $c12Z1 = parcelRequire("c12Z1");
/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/ function $0d12dff350d1bca7$var$toFormData(obj, formData) {
    // eslint-disable-next-line no-param-reassign
    formData = formData || new FormData();
    var stack = [];
    function convertValue(value) {
        if (value === null) return '';
        if ($c12Z1.isDate(value)) return value.toISOString();
        if ($c12Z1.isArrayBuffer(value) || $c12Z1.isTypedArray(value)) return typeof Blob === 'function' ? new Blob([
            value
        ]) : $0d12dff350d1bca7$require$Buffer.from(value);
        return value;
    }
    function build(data, parentKey) {
        if ($c12Z1.isPlainObject(data) || $c12Z1.isArray(data)) {
            if (stack.indexOf(data) !== -1) throw Error('Circular reference detected in ' + parentKey);
            stack.push(data);
            $c12Z1.forEach(data, function each(value, key) {
                if ($c12Z1.isUndefined(value)) return;
                var fullKey = parentKey ? parentKey + '.' + key : key;
                var arr;
                if (value && !parentKey && typeof value === 'object') {
                    if ($c12Z1.endsWith(key, '{}')) // eslint-disable-next-line no-param-reassign
                    value = JSON.stringify(value);
                    else if ($c12Z1.endsWith(key, '[]') && (arr = $c12Z1.toArray(value))) {
                        // eslint-disable-next-line func-names
                        arr.forEach(function(el) {
                            !$c12Z1.isUndefined(el) && formData.append(fullKey, convertValue(el));
                        });
                        return;
                    }
                }
                build(value, fullKey);
            });
            stack.pop();
        } else formData.append(parentKey, convertValue(data));
    }
    build(obj);
    return formData;
}
module.exports = $0d12dff350d1bca7$var$toFormData;

});
parcelRegister("iSTPY", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $dbf8953fbcbf8dc1$export$a143d493d941bafc, (v) => $dbf8953fbcbf8dc1$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $dbf8953fbcbf8dc1$export$f99ded8fe4b79145, (v) => $dbf8953fbcbf8dc1$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $dbf8953fbcbf8dc1$export$a143d493d941bafc;
var $dbf8953fbcbf8dc1$export$e4cf37d7f6fb9e0a;
var $dbf8953fbcbf8dc1$export$f99ded8fe4b79145;
var $dbf8953fbcbf8dc1$export$599f31c3813fae4d;
'use strict';

var $8QdDv = parcelRequire("8QdDv");

var $5IS0J = parcelRequire("5IS0J");
const $dbf8953fbcbf8dc1$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$dbf8953fbcbf8dc1$export$a143d493d941bafc = $dbf8953fbcbf8dc1$var$Buffer;
$dbf8953fbcbf8dc1$export$e4cf37d7f6fb9e0a = $dbf8953fbcbf8dc1$var$SlowBuffer;
$dbf8953fbcbf8dc1$export$f99ded8fe4b79145 = 50;
const $dbf8953fbcbf8dc1$var$K_MAX_LENGTH = 0x7fffffff;
$dbf8953fbcbf8dc1$export$599f31c3813fae4d = $dbf8953fbcbf8dc1$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $dbf8953fbcbf8dc1$var$Buffer.TYPED_ARRAY_SUPPORT = $dbf8953fbcbf8dc1$var$typedArraySupport();
if (!$dbf8953fbcbf8dc1$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $dbf8953fbcbf8dc1$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($dbf8953fbcbf8dc1$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$dbf8953fbcbf8dc1$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($dbf8953fbcbf8dc1$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$dbf8953fbcbf8dc1$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $dbf8953fbcbf8dc1$var$createBuffer(length) {
    if (length > $dbf8953fbcbf8dc1$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $dbf8953fbcbf8dc1$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $dbf8953fbcbf8dc1$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $dbf8953fbcbf8dc1$var$allocUnsafe(arg);
    }
    return $dbf8953fbcbf8dc1$var$from(arg, encodingOrOffset, length);
}
$dbf8953fbcbf8dc1$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $dbf8953fbcbf8dc1$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $dbf8953fbcbf8dc1$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $dbf8953fbcbf8dc1$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($dbf8953fbcbf8dc1$var$isInstance(value, ArrayBuffer) || value && $dbf8953fbcbf8dc1$var$isInstance(value.buffer, ArrayBuffer)) return $dbf8953fbcbf8dc1$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($dbf8953fbcbf8dc1$var$isInstance(value, SharedArrayBuffer) || value && $dbf8953fbcbf8dc1$var$isInstance(value.buffer, SharedArrayBuffer))) return $dbf8953fbcbf8dc1$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $dbf8953fbcbf8dc1$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $dbf8953fbcbf8dc1$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $dbf8953fbcbf8dc1$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $dbf8953fbcbf8dc1$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $dbf8953fbcbf8dc1$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($dbf8953fbcbf8dc1$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($dbf8953fbcbf8dc1$var$Buffer, Uint8Array);
function $dbf8953fbcbf8dc1$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $dbf8953fbcbf8dc1$var$alloc(size, fill, encoding) {
    $dbf8953fbcbf8dc1$var$assertSize(size);
    if (size <= 0) return $dbf8953fbcbf8dc1$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $dbf8953fbcbf8dc1$var$createBuffer(size).fill(fill, encoding) : $dbf8953fbcbf8dc1$var$createBuffer(size).fill(fill);
    return $dbf8953fbcbf8dc1$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $dbf8953fbcbf8dc1$var$Buffer.alloc = function(size, fill, encoding) {
    return $dbf8953fbcbf8dc1$var$alloc(size, fill, encoding);
};
function $dbf8953fbcbf8dc1$var$allocUnsafe(size) {
    $dbf8953fbcbf8dc1$var$assertSize(size);
    return $dbf8953fbcbf8dc1$var$createBuffer(size < 0 ? 0 : $dbf8953fbcbf8dc1$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $dbf8953fbcbf8dc1$var$Buffer.allocUnsafe = function(size) {
    return $dbf8953fbcbf8dc1$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $dbf8953fbcbf8dc1$var$Buffer.allocUnsafeSlow = function(size) {
    return $dbf8953fbcbf8dc1$var$allocUnsafe(size);
};
function $dbf8953fbcbf8dc1$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$dbf8953fbcbf8dc1$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $dbf8953fbcbf8dc1$var$byteLength(string, encoding) | 0;
    let buf = $dbf8953fbcbf8dc1$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $dbf8953fbcbf8dc1$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $dbf8953fbcbf8dc1$var$checked(array.length) | 0;
    const buf = $dbf8953fbcbf8dc1$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $dbf8953fbcbf8dc1$var$fromArrayView(arrayView) {
    if ($dbf8953fbcbf8dc1$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $dbf8953fbcbf8dc1$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $dbf8953fbcbf8dc1$var$fromArrayLike(arrayView);
}
function $dbf8953fbcbf8dc1$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $dbf8953fbcbf8dc1$var$Buffer.prototype);
    return buf;
}
function $dbf8953fbcbf8dc1$var$fromObject(obj) {
    if ($dbf8953fbcbf8dc1$var$Buffer.isBuffer(obj)) {
        const len = $dbf8953fbcbf8dc1$var$checked(obj.length) | 0;
        const buf = $dbf8953fbcbf8dc1$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $dbf8953fbcbf8dc1$var$numberIsNaN(obj.length)) return $dbf8953fbcbf8dc1$var$createBuffer(0);
        return $dbf8953fbcbf8dc1$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $dbf8953fbcbf8dc1$var$fromArrayLike(obj.data);
}
function $dbf8953fbcbf8dc1$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $dbf8953fbcbf8dc1$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $dbf8953fbcbf8dc1$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $dbf8953fbcbf8dc1$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $dbf8953fbcbf8dc1$var$Buffer.alloc(+length);
}
$dbf8953fbcbf8dc1$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $dbf8953fbcbf8dc1$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$dbf8953fbcbf8dc1$var$Buffer.compare = function compare(a, b) {
    if ($dbf8953fbcbf8dc1$var$isInstance(a, Uint8Array)) a = $dbf8953fbcbf8dc1$var$Buffer.from(a, a.offset, a.byteLength);
    if ($dbf8953fbcbf8dc1$var$isInstance(b, Uint8Array)) b = $dbf8953fbcbf8dc1$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$dbf8953fbcbf8dc1$var$Buffer.isBuffer(a) || !$dbf8953fbcbf8dc1$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$dbf8953fbcbf8dc1$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$dbf8953fbcbf8dc1$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $dbf8953fbcbf8dc1$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $dbf8953fbcbf8dc1$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($dbf8953fbcbf8dc1$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$dbf8953fbcbf8dc1$var$Buffer.isBuffer(buf)) buf = $dbf8953fbcbf8dc1$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$dbf8953fbcbf8dc1$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $dbf8953fbcbf8dc1$var$byteLength(string, encoding) {
    if ($dbf8953fbcbf8dc1$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $dbf8953fbcbf8dc1$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $dbf8953fbcbf8dc1$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $dbf8953fbcbf8dc1$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $dbf8953fbcbf8dc1$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$dbf8953fbcbf8dc1$var$Buffer.byteLength = $dbf8953fbcbf8dc1$var$byteLength;
function $dbf8953fbcbf8dc1$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $dbf8953fbcbf8dc1$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $dbf8953fbcbf8dc1$var$utf8Slice(this, start, end);
        case 'ascii':
            return $dbf8953fbcbf8dc1$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $dbf8953fbcbf8dc1$var$latin1Slice(this, start, end);
        case 'base64':
            return $dbf8953fbcbf8dc1$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $dbf8953fbcbf8dc1$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$dbf8953fbcbf8dc1$var$Buffer.prototype._isBuffer = true;
function $dbf8953fbcbf8dc1$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$dbf8953fbcbf8dc1$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$dbf8953fbcbf8dc1$var$swap(this, i, i + 1);
    return this;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $dbf8953fbcbf8dc1$var$swap(this, i, i + 3);
        $dbf8953fbcbf8dc1$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $dbf8953fbcbf8dc1$var$swap(this, i, i + 7);
        $dbf8953fbcbf8dc1$var$swap(this, i + 1, i + 6);
        $dbf8953fbcbf8dc1$var$swap(this, i + 2, i + 5);
        $dbf8953fbcbf8dc1$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $dbf8953fbcbf8dc1$var$utf8Slice(this, 0, length);
    return $dbf8953fbcbf8dc1$var$slowToString.apply(this, arguments);
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.toLocaleString = $dbf8953fbcbf8dc1$var$Buffer.prototype.toString;
$dbf8953fbcbf8dc1$var$Buffer.prototype.equals = function equals(b) {
    if (!$dbf8953fbcbf8dc1$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $dbf8953fbcbf8dc1$var$Buffer.compare(this, b) === 0;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $dbf8953fbcbf8dc1$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($dbf8953fbcbf8dc1$var$customInspectSymbol) $dbf8953fbcbf8dc1$var$Buffer.prototype[$dbf8953fbcbf8dc1$var$customInspectSymbol] = $dbf8953fbcbf8dc1$var$Buffer.prototype.inspect;
$dbf8953fbcbf8dc1$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($dbf8953fbcbf8dc1$var$isInstance(target, Uint8Array)) target = $dbf8953fbcbf8dc1$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$dbf8953fbcbf8dc1$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $dbf8953fbcbf8dc1$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($dbf8953fbcbf8dc1$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $dbf8953fbcbf8dc1$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($dbf8953fbcbf8dc1$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $dbf8953fbcbf8dc1$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $dbf8953fbcbf8dc1$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $dbf8953fbcbf8dc1$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$dbf8953fbcbf8dc1$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $dbf8953fbcbf8dc1$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $dbf8953fbcbf8dc1$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $dbf8953fbcbf8dc1$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($dbf8953fbcbf8dc1$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $dbf8953fbcbf8dc1$var$utf8Write(buf, string, offset, length) {
    return $dbf8953fbcbf8dc1$var$blitBuffer($dbf8953fbcbf8dc1$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $dbf8953fbcbf8dc1$var$asciiWrite(buf, string, offset, length) {
    return $dbf8953fbcbf8dc1$var$blitBuffer($dbf8953fbcbf8dc1$var$asciiToBytes(string), buf, offset, length);
}
function $dbf8953fbcbf8dc1$var$base64Write(buf, string, offset, length) {
    return $dbf8953fbcbf8dc1$var$blitBuffer($dbf8953fbcbf8dc1$var$base64ToBytes(string), buf, offset, length);
}
function $dbf8953fbcbf8dc1$var$ucs2Write(buf, string, offset, length) {
    return $dbf8953fbcbf8dc1$var$blitBuffer($dbf8953fbcbf8dc1$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$dbf8953fbcbf8dc1$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $dbf8953fbcbf8dc1$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $dbf8953fbcbf8dc1$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $dbf8953fbcbf8dc1$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $dbf8953fbcbf8dc1$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $dbf8953fbcbf8dc1$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $dbf8953fbcbf8dc1$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $8QdDv.fromByteArray(buf);
    else return $8QdDv.fromByteArray(buf.slice(start, end));
}
function $dbf8953fbcbf8dc1$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $dbf8953fbcbf8dc1$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $dbf8953fbcbf8dc1$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $dbf8953fbcbf8dc1$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $dbf8953fbcbf8dc1$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $dbf8953fbcbf8dc1$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $dbf8953fbcbf8dc1$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $dbf8953fbcbf8dc1$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $dbf8953fbcbf8dc1$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $dbf8953fbcbf8dc1$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $dbf8953fbcbf8dc1$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$dbf8953fbcbf8dc1$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $dbf8953fbcbf8dc1$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $dbf8953fbcbf8dc1$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$dbf8953fbcbf8dc1$var$Buffer.prototype.readUintLE = $dbf8953fbcbf8dc1$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.readUintBE = $dbf8953fbcbf8dc1$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.readUint8 = $dbf8953fbcbf8dc1$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.readUint16LE = $dbf8953fbcbf8dc1$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.readUint16BE = $dbf8953fbcbf8dc1$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.readUint32LE = $dbf8953fbcbf8dc1$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.readUint32BE = $dbf8953fbcbf8dc1$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.readBigUInt64LE = $dbf8953fbcbf8dc1$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $dbf8953fbcbf8dc1$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $dbf8953fbcbf8dc1$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$dbf8953fbcbf8dc1$var$Buffer.prototype.readBigUInt64BE = $dbf8953fbcbf8dc1$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $dbf8953fbcbf8dc1$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $dbf8953fbcbf8dc1$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$dbf8953fbcbf8dc1$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.readBigInt64LE = $dbf8953fbcbf8dc1$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $dbf8953fbcbf8dc1$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $dbf8953fbcbf8dc1$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$dbf8953fbcbf8dc1$var$Buffer.prototype.readBigInt64BE = $dbf8953fbcbf8dc1$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $dbf8953fbcbf8dc1$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $dbf8953fbcbf8dc1$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$dbf8953fbcbf8dc1$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkOffset(offset, 4, this.length);
    return $5IS0J.read(this, offset, true, 23, 4);
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkOffset(offset, 4, this.length);
    return $5IS0J.read(this, offset, false, 23, 4);
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkOffset(offset, 8, this.length);
    return $5IS0J.read(this, offset, true, 52, 8);
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkOffset(offset, 8, this.length);
    return $5IS0J.read(this, offset, false, 52, 8);
};
function $dbf8953fbcbf8dc1$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$dbf8953fbcbf8dc1$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$dbf8953fbcbf8dc1$var$Buffer.prototype.writeUintLE = $dbf8953fbcbf8dc1$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $dbf8953fbcbf8dc1$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.writeUintBE = $dbf8953fbcbf8dc1$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $dbf8953fbcbf8dc1$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.writeUint8 = $dbf8953fbcbf8dc1$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.writeUint16LE = $dbf8953fbcbf8dc1$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.writeUint16BE = $dbf8953fbcbf8dc1$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.writeUint32LE = $dbf8953fbcbf8dc1$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.writeUint32BE = $dbf8953fbcbf8dc1$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $dbf8953fbcbf8dc1$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $dbf8953fbcbf8dc1$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $dbf8953fbcbf8dc1$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $dbf8953fbcbf8dc1$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$dbf8953fbcbf8dc1$var$Buffer.prototype.writeBigUInt64LE = $dbf8953fbcbf8dc1$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $dbf8953fbcbf8dc1$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$dbf8953fbcbf8dc1$var$Buffer.prototype.writeBigUInt64BE = $dbf8953fbcbf8dc1$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $dbf8953fbcbf8dc1$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$dbf8953fbcbf8dc1$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $dbf8953fbcbf8dc1$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $dbf8953fbcbf8dc1$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.writeBigInt64LE = $dbf8953fbcbf8dc1$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $dbf8953fbcbf8dc1$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$dbf8953fbcbf8dc1$var$Buffer.prototype.writeBigInt64BE = $dbf8953fbcbf8dc1$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $dbf8953fbcbf8dc1$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $dbf8953fbcbf8dc1$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $dbf8953fbcbf8dc1$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $5IS0J.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$dbf8953fbcbf8dc1$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $dbf8953fbcbf8dc1$var$writeFloat(this, value, offset, true, noAssert);
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $dbf8953fbcbf8dc1$var$writeFloat(this, value, offset, false, noAssert);
};
function $dbf8953fbcbf8dc1$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dbf8953fbcbf8dc1$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $5IS0J.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$dbf8953fbcbf8dc1$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $dbf8953fbcbf8dc1$var$writeDouble(this, value, offset, true, noAssert);
};
$dbf8953fbcbf8dc1$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $dbf8953fbcbf8dc1$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$dbf8953fbcbf8dc1$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$dbf8953fbcbf8dc1$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$dbf8953fbcbf8dc1$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$dbf8953fbcbf8dc1$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $dbf8953fbcbf8dc1$var$Buffer.isBuffer(val) ? val : $dbf8953fbcbf8dc1$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $dbf8953fbcbf8dc1$var$errors = {};
function $dbf8953fbcbf8dc1$var$E(sym, getMessage, Base) {
    $dbf8953fbcbf8dc1$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$dbf8953fbcbf8dc1$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$dbf8953fbcbf8dc1$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$dbf8953fbcbf8dc1$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $dbf8953fbcbf8dc1$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $dbf8953fbcbf8dc1$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $dbf8953fbcbf8dc1$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $dbf8953fbcbf8dc1$var$checkBounds(buf, offset, byteLength) {
    $dbf8953fbcbf8dc1$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $dbf8953fbcbf8dc1$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $dbf8953fbcbf8dc1$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $dbf8953fbcbf8dc1$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $dbf8953fbcbf8dc1$var$checkBounds(buf, offset, byteLength);
}
function $dbf8953fbcbf8dc1$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $dbf8953fbcbf8dc1$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $dbf8953fbcbf8dc1$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $dbf8953fbcbf8dc1$var$validateNumber(value, type);
        throw new $dbf8953fbcbf8dc1$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $dbf8953fbcbf8dc1$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $dbf8953fbcbf8dc1$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $dbf8953fbcbf8dc1$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $dbf8953fbcbf8dc1$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($dbf8953fbcbf8dc1$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $dbf8953fbcbf8dc1$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $dbf8953fbcbf8dc1$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $dbf8953fbcbf8dc1$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $dbf8953fbcbf8dc1$var$base64ToBytes(str) {
    return $8QdDv.toByteArray($dbf8953fbcbf8dc1$var$base64clean(str));
}
function $dbf8953fbcbf8dc1$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $dbf8953fbcbf8dc1$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $dbf8953fbcbf8dc1$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $dbf8953fbcbf8dc1$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $dbf8953fbcbf8dc1$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $dbf8953fbcbf8dc1$var$BufferBigIntNotDefined : fn;
}
function $dbf8953fbcbf8dc1$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("8QdDv", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $66fdc1e6de481a02$export$d622b2ad8d90c771, (v) => $66fdc1e6de481a02$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $66fdc1e6de481a02$export$6100ba28696e12de, (v) => $66fdc1e6de481a02$export$6100ba28696e12de = v);
var $66fdc1e6de481a02$export$a48f0734ac7c2329;
var $66fdc1e6de481a02$export$d622b2ad8d90c771;
var $66fdc1e6de481a02$export$6100ba28696e12de;
'use strict';
$66fdc1e6de481a02$export$a48f0734ac7c2329 = $66fdc1e6de481a02$var$byteLength;
$66fdc1e6de481a02$export$d622b2ad8d90c771 = $66fdc1e6de481a02$var$toByteArray;
$66fdc1e6de481a02$export$6100ba28696e12de = $66fdc1e6de481a02$var$fromByteArray;
var $66fdc1e6de481a02$var$lookup = [];
var $66fdc1e6de481a02$var$revLookup = [];
var $66fdc1e6de481a02$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $66fdc1e6de481a02$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $66fdc1e6de481a02$var$i = 0, $66fdc1e6de481a02$var$len = $66fdc1e6de481a02$var$code.length; $66fdc1e6de481a02$var$i < $66fdc1e6de481a02$var$len; ++$66fdc1e6de481a02$var$i){
    $66fdc1e6de481a02$var$lookup[$66fdc1e6de481a02$var$i] = $66fdc1e6de481a02$var$code[$66fdc1e6de481a02$var$i];
    $66fdc1e6de481a02$var$revLookup[$66fdc1e6de481a02$var$code.charCodeAt($66fdc1e6de481a02$var$i)] = $66fdc1e6de481a02$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$66fdc1e6de481a02$var$revLookup['-'.charCodeAt(0)] = 62;
$66fdc1e6de481a02$var$revLookup['_'.charCodeAt(0)] = 63;
function $66fdc1e6de481a02$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $66fdc1e6de481a02$var$byteLength(b64) {
    var lens = $66fdc1e6de481a02$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $66fdc1e6de481a02$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $66fdc1e6de481a02$var$toByteArray(b64) {
    var tmp;
    var lens = $66fdc1e6de481a02$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $66fdc1e6de481a02$var$Arr($66fdc1e6de481a02$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $66fdc1e6de481a02$var$revLookup[b64.charCodeAt(i)] << 18 | $66fdc1e6de481a02$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $66fdc1e6de481a02$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $66fdc1e6de481a02$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $66fdc1e6de481a02$var$revLookup[b64.charCodeAt(i)] << 2 | $66fdc1e6de481a02$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $66fdc1e6de481a02$var$revLookup[b64.charCodeAt(i)] << 10 | $66fdc1e6de481a02$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $66fdc1e6de481a02$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $66fdc1e6de481a02$var$tripletToBase64(num) {
    return $66fdc1e6de481a02$var$lookup[num >> 18 & 0x3F] + $66fdc1e6de481a02$var$lookup[num >> 12 & 0x3F] + $66fdc1e6de481a02$var$lookup[num >> 6 & 0x3F] + $66fdc1e6de481a02$var$lookup[num & 0x3F];
}
function $66fdc1e6de481a02$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($66fdc1e6de481a02$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $66fdc1e6de481a02$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($66fdc1e6de481a02$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($66fdc1e6de481a02$var$lookup[tmp >> 2] + $66fdc1e6de481a02$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($66fdc1e6de481a02$var$lookup[tmp >> 10] + $66fdc1e6de481a02$var$lookup[tmp >> 4 & 0x3F] + $66fdc1e6de481a02$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("5IS0J", function(module, exports) {

$parcel$export(module.exports, "read", () => $42aaf53eb89c3420$export$aafa59e2e03f2942, (v) => $42aaf53eb89c3420$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $42aaf53eb89c3420$export$68d8715fc104d294, (v) => $42aaf53eb89c3420$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $42aaf53eb89c3420$export$aafa59e2e03f2942;
var $42aaf53eb89c3420$export$68d8715fc104d294;
$42aaf53eb89c3420$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$42aaf53eb89c3420$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("lfNrH", function(module, exports) {
'use strict';

var $c12Z1 = parcelRequire("c12Z1");

var $eOWOy = parcelRequire("eOWOy");

var $9F44H = parcelRequire("9F44H");

var $3gz4u = parcelRequire("3gz4u");

var $dqWe2 = parcelRequire("dqWe2");

var $fEiuj = parcelRequire("fEiuj");

var $cB1cv = parcelRequire("cB1cv");

var $3u3bM = parcelRequire("3u3bM");

var $7cLzr = parcelRequire("7cLzr");

var $geYla = parcelRequire("geYla");

var $2JhC1 = parcelRequire("2JhC1");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener('abort', onCanceled);
        }
        if ($c12Z1.isFormData(requestData) && $c12Z1.isStandardBrowserEnv()) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $dqWe2(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $3gz4u(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $fEiuj(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $eOWOy(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new $7cLzr('Request aborted', $7cLzr.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new $7cLzr('Network Error', $7cLzr.ERR_NETWORK, config, request, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
            var transitional = config.transitional || $3u3bM;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new $7cLzr(timeoutErrorMessage, transitional.clarifyTimeoutError ? $7cLzr.ETIMEDOUT : $7cLzr.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($c12Z1.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $cB1cv(fullPath)) && config.xsrfCookieName ? $9F44H.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $c12Z1.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$c12Z1.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $geYla() : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
        }
        if (!requestData) requestData = null;
        var protocol = $2JhC1(fullPath);
        if (protocol && [
            'http',
            'https',
            'file'
        ].indexOf(protocol) === -1) {
            reject(new $7cLzr('Unsupported protocol ' + protocol + ':', $7cLzr.ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("eOWOy", function(module, exports) {
'use strict';

var $7cLzr = parcelRequire("7cLzr");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new $7cLzr('Request failed with status code ' + response.status, [
        $7cLzr.ERR_BAD_REQUEST,
        $7cLzr.ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
};

});

parcelRegister("9F44H", function(module, exports) {
'use strict';

var $c12Z1 = parcelRequire("c12Z1");
module.exports = $c12Z1.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($c12Z1.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($c12Z1.isString(path)) cookie.push('path=' + path);
            if ($c12Z1.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("dqWe2", function(module, exports) {
'use strict';

var $eg9l8 = parcelRequire("eg9l8");

var $3wyWH = parcelRequire("3wyWH");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$eg9l8(requestedURL)) return $3wyWH(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("eg9l8", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRegister("3wyWH", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("fEiuj", function(module, exports) {
'use strict';

var $c12Z1 = parcelRequire("c12Z1");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $b648eebb373c2f5e$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $c12Z1.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $c12Z1.trim(line.substr(0, i)).toLowerCase();
        val = $c12Z1.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $b648eebb373c2f5e$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("cB1cv", function(module, exports) {
'use strict';

var $c12Z1 = parcelRequire("c12Z1");
module.exports = $c12Z1.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $c12Z1.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("geYla", function(module, exports) {
'use strict';

var $7cLzr = parcelRequire("7cLzr");

var $c12Z1 = parcelRequire("c12Z1");
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $bd2cc27f2ccf9603$var$CanceledError(message) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    $7cLzr.call(this, message == null ? 'canceled' : message, $7cLzr.ERR_CANCELED);
    this.name = 'CanceledError';
}
$c12Z1.inherits($bd2cc27f2ccf9603$var$CanceledError, $7cLzr, {
    __CANCEL__: true
});
module.exports = $bd2cc27f2ccf9603$var$CanceledError;

});

parcelRegister("2JhC1", function(module, exports) {
'use strict';
module.exports = function parseProtocol(url) {
    var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
};

});


parcelRegister("kHWL2", function(module, exports) {
// eslint-disable-next-line strict
module.exports = null;

});



parcelRegister("d0uo4", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("1gt9b", function(module, exports) {
'use strict';

var $c12Z1 = parcelRequire("c12Z1");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($c12Z1.isPlainObject(target) && $c12Z1.isPlainObject(source)) return $c12Z1.merge(target, source);
        else if ($c12Z1.isPlainObject(source)) return $c12Z1.merge({}, source);
        else if ($c12Z1.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$c12Z1.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$c12Z1.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$c12Z1.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$c12Z1.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$c12Z1.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        'url': valueFromConfig2,
        'method': valueFromConfig2,
        'data': valueFromConfig2,
        'baseURL': defaultToConfig2,
        'transformRequest': defaultToConfig2,
        'transformResponse': defaultToConfig2,
        'paramsSerializer': defaultToConfig2,
        'timeout': defaultToConfig2,
        'timeoutMessage': defaultToConfig2,
        'withCredentials': defaultToConfig2,
        'adapter': defaultToConfig2,
        'responseType': defaultToConfig2,
        'xsrfCookieName': defaultToConfig2,
        'xsrfHeaderName': defaultToConfig2,
        'onUploadProgress': defaultToConfig2,
        'onDownloadProgress': defaultToConfig2,
        'decompress': defaultToConfig2,
        'maxContentLength': defaultToConfig2,
        'maxBodyLength': defaultToConfig2,
        'beforeRedirect': defaultToConfig2,
        'transport': defaultToConfig2,
        'httpAgent': defaultToConfig2,
        'httpsAgent': defaultToConfig2,
        'cancelToken': defaultToConfig2,
        'socketPath': defaultToConfig2,
        'responseEncoding': defaultToConfig2,
        'validateStatus': mergeDirectKeys
    };
    $c12Z1.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $c12Z1.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("gLiiJ", function(module, exports) {
'use strict';

var $bGlWZ = parcelRequire("bGlWZ");
var $c33f3b5d18598911$require$VERSION = $bGlWZ.version;

var $7cLzr = parcelRequire("7cLzr");
var $c33f3b5d18598911$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    $c33f3b5d18598911$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var $c33f3b5d18598911$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $c33f3b5d18598911$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + $c33f3b5d18598911$require$VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new $7cLzr(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), $7cLzr.ERR_DEPRECATED);
        if (version && !$c33f3b5d18598911$var$deprecatedWarnings[opt]) {
            $c33f3b5d18598911$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $c33f3b5d18598911$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new $7cLzr('options must be an object', $7cLzr.ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new $7cLzr('option ' + opt + ' must be ' + result, $7cLzr.ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new $7cLzr('Unknown option ' + opt, $7cLzr.ERR_BAD_OPTION);
    }
}
module.exports = {
    assertOptions: $c33f3b5d18598911$var$assertOptions,
    validators: $c33f3b5d18598911$var$validators
};

});
parcelRegister("bGlWZ", function(module, exports) {
module.exports = {
    "version": "0.27.2"
};

});



parcelRegister("44tM5", function(module, exports) {
'use strict';

var $geYla = parcelRequire("geYla");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $2f6ea1c680244df8$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $geYla(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ $2f6ea1c680244df8$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $2f6ea1c680244df8$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $2f6ea1c680244df8$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $2f6ea1c680244df8$var$CancelToken.source = function source() {
    var cancel;
    var token = new $2f6ea1c680244df8$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $2f6ea1c680244df8$var$CancelToken;

});

parcelRegister("ksbQV", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("jHjFB", function(module, exports) {
'use strict';

var $c12Z1 = parcelRequire("c12Z1");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $c12Z1.isObject(payload) && payload.isAxiosError === true;
};

});


parcelRegister("1BWfV", function(module, exports) {

$parcel$export(module.exports, "authStateManager", () => $0b3ad3e4303764e7$export$caf979b6edae7c89);
/**
 * Centralized authentication state management to prevent cache-related login issues
 */ 
var $ebTQj = parcelRequire("ebTQj");

var $iJyAr = parcelRequire("iJyAr");
class $0b3ad3e4303764e7$export$98841555a7280e2b {
    constructor(){
        this.cookies = new (0, $iJyAr.default)();
    }
    static getInstance() {
        if (!$0b3ad3e4303764e7$export$98841555a7280e2b.instance) $0b3ad3e4303764e7$export$98841555a7280e2b.instance = new $0b3ad3e4303764e7$export$98841555a7280e2b();
        return $0b3ad3e4303764e7$export$98841555a7280e2b.instance;
    }
    /**
   * Get current authentication state
   */ getAuthState() {
        const token = this.cookies.get("token");
        const refreshToken = this.cookies.get("token_secret");
        return {
            isAuthenticated: !!(token || refreshToken),
            hasValidToken: !!token,
            hasValidRefreshToken: !!refreshToken,
            token: token,
            refreshToken: refreshToken
        };
    }
    /**
   * Set authentication state consistently across all storage mechanisms
   */ setAuthState(token, refreshToken) {
        try {
            // Set cookies with proper expiration
            this.cookies.set("token", token, {
                path: "/",
                maxAge: 3600,
                secure: window.location.protocol === "https:",
                sameSite: "lax"
            });
            this.cookies.set("token_secret", refreshToken, {
                path: "/",
                secure: window.location.protocol === "https:",
                sameSite: "lax"
            });
            // Note: Removed localStorage dependency - using cookies only for authentication
            (0, $ebTQj.logger).info("Authentication state set successfully");
        } catch (error) {
            (0, $ebTQj.logger).error("Failed to set authentication state:", error);
            throw error;
        }
    }
    /**
   * Clear authentication state from all storage mechanisms
   */ clearAuthState() {
        try {
            // Clear cookies
            this.cookies.remove("token", {
                path: "/"
            });
            this.cookies.remove("token_secret", {
                path: "/"
            });
            // Clear localStorage (keeping for backward compatibility)
            localStorage.removeItem("loggedIn");
            localStorage.removeItem("token");
            localStorage.removeItem("token_secret");
            localStorage.removeItem("tokenRefreshing");
            (0, $ebTQj.logger).info("Authentication state cleared successfully");
        } catch (error) {
            (0, $ebTQj.logger).error("Failed to clear authentication state:", error);
        }
    }
    /**
   * Validate authentication state consistency
   */ validateAuthState() {
        const state = this.getAuthState();
        const issues = [];
        // Check for inconsistent states
        if (state.isAuthenticated && !state.hasValidToken && !state.hasValidRefreshToken) issues.push("Authenticated but no valid tokens found");
        if (state.hasValidToken && !state.isAuthenticated) issues.push("Valid token but not marked as authenticated");
        if (state.hasValidRefreshToken && !state.isAuthenticated) issues.push("Valid refresh token but not marked as authenticated");
        // Note: Removed localStorage validation - using cookies only for authentication
        return {
            isValid: issues.length === 0,
            issues: issues
        };
    }
    /**
   * Fix authentication state inconsistencies
   */ fixAuthStateInconsistencies() {
        const validation = this.validateAuthState();
        if (validation.isValid) return true;
        (0, $ebTQj.logger).warn("Authentication state inconsistencies detected:", validation.issues);
        // If we have valid tokens but inconsistent state, fix it
        const state = this.getAuthState();
        if (state.hasValidToken || state.hasValidRefreshToken) // Re-sync the state
        {
            if (state.token && state.refreshToken) {
                this.setAuthState(state.token, state.refreshToken);
                return true;
            }
        }
        // If state is completely inconsistent, clear everything
        this.clearAuthState();
        return false;
    }
    /**
   * Check if user should be redirected to login
   */ shouldRedirectToLogin() {
        const state = this.getAuthState();
        // If we have no authentication at all, redirect to login
        if (!state.isAuthenticated && !state.hasValidToken && !state.hasValidRefreshToken) return true;
        // If we have inconsistent state, try to fix it first
        const validation = this.validateAuthState();
        if (!validation.isValid) {
            const fixed = this.fixAuthStateInconsistencies();
            if (!fixed) return true;
        }
        return false;
    }
}
const $0b3ad3e4303764e7$export$caf979b6edae7c89 = $0b3ad3e4303764e7$export$98841555a7280e2b.getInstance();

});
parcelRegister("ebTQj", function(module, exports) {

$parcel$export(module.exports, "logger", () => $ea10765675c607df$export$af88d00dbe7f521);
// Centralized logging utility that respects development environment
const $ea10765675c607df$export$af88d00dbe7f521 = {
    log: (message, data)=>{
        {
            if (data) console.log(message, data);
            else console.log(message);
        }
    },
    // Use this for expected errors (API errors, etc.) - won't trigger error overlay
    error: (message, error)=>{
        {
            if (error) console.warn(`[ERROR] ${message}`, error);
            else console.warn(`[ERROR] ${message}`);
        }
    },
    // Use this for critical unexpected errors - WILL trigger error overlay
    criticalError: (message, error)=>{
        {
            if (error) console.error(message, error);
            else console.error(message);
        }
    },
    warn: (message, data)=>{
        {
            if (data) console.warn(message, data);
            else console.warn(message);
        }
    },
    info: (message, data)=>{
        {
            if (data) console.info(message, data);
            else console.info(message);
        }
    },
    debug: (message, data)=>{
        {
            if (data) console.debug(message, data);
            else console.debug(message);
        }
    }
};

});

parcelRegister("iJyAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $da37422868b8383d$export$2e2bcd8739ae039);

var $bohJf = parcelRequire("bohJf");
var $da37422868b8383d$export$2e2bcd8739ae039 = (0, $bohJf.default);

});
parcelRegister("bohJf", function(module, exports) {

$parcel$export(module.exports, "default", () => $84afb030acf4c8e3$export$2e2bcd8739ae039);

var $cGYnd = parcelRequire("cGYnd");

var $5gema = parcelRequire("5gema");
var $84afb030acf4c8e3$var$__assign = undefined && undefined.__assign || function() {
    $84afb030acf4c8e3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $84afb030acf4c8e3$var$__assign.apply(this, arguments);
};
var $84afb030acf4c8e3$var$Cookies = /** @class */ function() {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = (0, $5gema.parseCookies)(cookies, options);
        new Promise(function() {
            _this.HAS_DOCUMENT_COOKIE = (0, $5gema.hasDocumentCookie)();
        }).catch(function() {});
    }
    Cookies.prototype._updateBrowserValues = function(parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) return;
        this.cookies = $cGYnd.parse(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function(params) {
        for(var i = 0; i < this.changeListeners.length; ++i)this.changeListeners[i](params);
    };
    Cookies.prototype.get = function(name, options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        return (0, $5gema.readCookie)(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function(options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        var result = {};
        for(var name_1 in this.cookies)result[name_1] = (0, $5gema.readCookie)(this.cookies[name_1], options);
        return result;
    };
    Cookies.prototype.set = function(name, value, options) {
        var _a;
        if (typeof value === 'object') value = JSON.stringify(value);
        this.cookies = $84afb030acf4c8e3$var$__assign($84afb030acf4c8e3$var$__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $cGYnd.serialize(name, value, options);
        this._emitChange({
            name: name,
            value: value,
            options: options
        });
    };
    Cookies.prototype.remove = function(name, options) {
        var finalOptions = options = $84afb030acf4c8e3$var$__assign($84afb030acf4c8e3$var$__assign({}, options), {
            expires: new Date(1970, 1, 1, 0, 0, 1),
            maxAge: 0
        });
        this.cookies = $84afb030acf4c8e3$var$__assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $cGYnd.serialize(name, '', finalOptions);
        this._emitChange({
            name: name,
            value: undefined,
            options: options
        });
    };
    Cookies.prototype.addChangeListener = function(callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function(callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) this.changeListeners.splice(idx, 1);
    };
    return Cookies;
}();
var $84afb030acf4c8e3$export$2e2bcd8739ae039 = $84afb030acf4c8e3$var$Cookies;

});
parcelRegister("cGYnd", function(module, exports) {

$parcel$export(module.exports, "parse", () => $93d83d2e86d94d71$export$98e6a39c04603d36, (v) => $93d83d2e86d94d71$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "serialize", () => $93d83d2e86d94d71$export$dfdc1655ccc5b9cb, (v) => $93d83d2e86d94d71$export$dfdc1655ccc5b9cb = v);
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $93d83d2e86d94d71$export$98e6a39c04603d36;
var $93d83d2e86d94d71$export$dfdc1655ccc5b9cb;
'use strict';
$93d83d2e86d94d71$export$98e6a39c04603d36 = $93d83d2e86d94d71$var$parse;
$93d83d2e86d94d71$export$dfdc1655ccc5b9cb = $93d83d2e86d94d71$var$serialize;
/**
 * Module variables.
 * @private
 */ var $93d83d2e86d94d71$var$decode = decodeURIComponent;
var $93d83d2e86d94d71$var$encode = encodeURIComponent;
/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */ var $93d83d2e86d94d71$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */ function $93d83d2e86d94d71$var$parse(str, options) {
    if (typeof str !== 'string') throw new TypeError('argument str must be a string');
    var obj = {};
    var opt = options || {};
    var pairs = str.split(';');
    var dec = opt.decode || $93d83d2e86d94d71$var$decode;
    for(var i = 0; i < pairs.length; i++){
        var pair = pairs[i];
        var index = pair.indexOf('=');
        // skip things that don't look like key=value
        if (index < 0) continue;
        var key = pair.substring(0, index).trim();
        // only assign once
        if (undefined == obj[key]) {
            var val = pair.substring(index + 1, pair.length).trim();
            // quoted values
            if (val[0] === '"') val = val.slice(1, -1);
            obj[key] = $93d83d2e86d94d71$var$tryDecode(val, dec);
        }
    }
    return obj;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */ function $93d83d2e86d94d71$var$serialize(name, val, options) {
    var opt = options || {};
    var enc = opt.encode || $93d83d2e86d94d71$var$encode;
    if (typeof enc !== 'function') throw new TypeError('option encode is invalid');
    if (!$93d83d2e86d94d71$var$fieldContentRegExp.test(name)) throw new TypeError('argument name is invalid');
    var value = enc(val);
    if (value && !$93d83d2e86d94d71$var$fieldContentRegExp.test(value)) throw new TypeError('argument val is invalid');
    var str = name + '=' + value;
    if (null != opt.maxAge) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge) || !isFinite(maxAge)) throw new TypeError('option maxAge is invalid');
        str += '; Max-Age=' + Math.floor(maxAge);
    }
    if (opt.domain) {
        if (!$93d83d2e86d94d71$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += '; Domain=' + opt.domain;
    }
    if (opt.path) {
        if (!$93d83d2e86d94d71$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += '; Path=' + opt.path;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += '; Expires=' + opt.expires.toUTCString();
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    return str;
}
/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */ function $93d83d2e86d94d71$var$tryDecode(str, decode) {
    try {
        return decode(str);
    } catch (e) {
        return str;
    }
}

});

parcelRegister("5gema", function(module, exports) {

$parcel$export(module.exports, "hasDocumentCookie", () => $3d499544a8b02c88$export$56232575010ba89);
$parcel$export(module.exports, "parseCookies", () => $3d499544a8b02c88$export$d2e637738f5e6ae8);
$parcel$export(module.exports, "readCookie", () => $3d499544a8b02c88$export$bead674655ff515d);

var $cGYnd = parcelRequire("cGYnd");
function $3d499544a8b02c88$export$56232575010ba89() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function $3d499544a8b02c88$export$bfce569af136abdc() {
    document.cookie.split(';').forEach(function(c) {
        document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function $3d499544a8b02c88$export$d2e637738f5e6ae8(cookies, options) {
    if (typeof cookies === 'string') return $cGYnd.parse(cookies, options);
    else if (typeof cookies === 'object' && cookies !== null) return cookies;
    else return {};
}
function $3d499544a8b02c88$export$9f55e081dbb22cd9(value, doNotParse) {
    if (typeof doNotParse === 'undefined') // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
    return !doNotParse;
}
function $3d499544a8b02c88$export$bead674655ff515d(value, options) {
    if (options === void 0) options = {};
    var cleanValue = $3d499544a8b02c88$var$cleanupCookieValue(value);
    if ($3d499544a8b02c88$export$9f55e081dbb22cd9(cleanValue, options.doNotParse)) try {
        return JSON.parse(cleanValue);
    } catch (e) {
    // At least we tried
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function $3d499544a8b02c88$var$cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') return value.substr(2);
    return value;
}

});




parcelRegister("hAe8M", function(module, exports) {

var $yRFSk = parcelRequire("yRFSk");

var $1L6TK = parcelRequire("1L6TK");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $yRFSk.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $1L6TK;
module.exports = isBuffer;

});
parcelRegister("yRFSk", function(module, exports) {

var $55VOZ = parcelRequire("55VOZ");
/** Detect free variable `self`. */ var $068ccfb5ba5f84f2$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $068ccfb5ba5f84f2$var$root = $55VOZ || $068ccfb5ba5f84f2$var$freeSelf || Function('return this')();
module.exports = $068ccfb5ba5f84f2$var$root;

});
parcelRegister("55VOZ", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $3b5a45856125f3a7$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $3b5a45856125f3a7$var$freeGlobal;

});


parcelRegister("1L6TK", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $147f880e19c4ccad$var$stubFalse() {
    return false;
}
module.exports = $147f880e19c4ccad$var$stubFalse;

});


parcelRegister("3TIQ3", function(module, exports) {

var $55VOZ = parcelRequire("55VOZ");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $55VOZ.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("1gEEb", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $0ec6d0c27d97bd2a$export$a7c73072b1a182ae, (v) => $0ec6d0c27d97bd2a$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $0ec6d0c27d97bd2a$export$9f27bc3417b4524d, (v) => $0ec6d0c27d97bd2a$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $0ec6d0c27d97bd2a$export$db77ccec0bb4ccac, (v) => $0ec6d0c27d97bd2a$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $0ec6d0c27d97bd2a$export$8392c0c9d3dcbd35, (v) => $0ec6d0c27d97bd2a$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $0ec6d0c27d97bd2a$export$ffb0004e005737fa, (v) => $0ec6d0c27d97bd2a$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $0ec6d0c27d97bd2a$export$b624eff549462981, (v) => $0ec6d0c27d97bd2a$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $0ec6d0c27d97bd2a$export$7897aa7841a5380c, (v) => $0ec6d0c27d97bd2a$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $0ec6d0c27d97bd2a$export$602eac185826482c, (v) => $0ec6d0c27d97bd2a$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $0ec6d0c27d97bd2a$export$e2c29f18771995cb, (v) => $0ec6d0c27d97bd2a$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $0ec6d0c27d97bd2a$export$5f8d39834fd61797, (v) => $0ec6d0c27d97bd2a$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $0ec6d0c27d97bd2a$export$74bf444e3cd11ea5, (v) => $0ec6d0c27d97bd2a$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $0ec6d0c27d97bd2a$export$998bcd577473dd93, (v) => $0ec6d0c27d97bd2a$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $0ec6d0c27d97bd2a$export$92387174baf9b227, (v) => $0ec6d0c27d97bd2a$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $0ec6d0c27d97bd2a$export$ec112efeb987d9c6, (v) => $0ec6d0c27d97bd2a$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $0ec6d0c27d97bd2a$export$b706b080d889d2c9, (v) => $0ec6d0c27d97bd2a$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $0ec6d0c27d97bd2a$export$5be5a87408f70ddc, (v) => $0ec6d0c27d97bd2a$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $0ec6d0c27d97bd2a$export$45a5e7f76e0caa8d, (v) => $0ec6d0c27d97bd2a$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $0ec6d0c27d97bd2a$export$455c2e768291efa6, (v) => $0ec6d0c27d97bd2a$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $0ec6d0c27d97bd2a$export$9522e17588c12572, (v) => $0ec6d0c27d97bd2a$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $0ec6d0c27d97bd2a$export$2110ac352bb060b9, (v) => $0ec6d0c27d97bd2a$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $0ec6d0c27d97bd2a$export$56885ab8b9c456ab, (v) => $0ec6d0c27d97bd2a$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $0ec6d0c27d97bd2a$export$d927fcb6adf8f9de, (v) => $0ec6d0c27d97bd2a$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $0ec6d0c27d97bd2a$export$b82d16f27459e05a, (v) => $0ec6d0c27d97bd2a$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $0ec6d0c27d97bd2a$export$522c17b4f5e123e8, (v) => $0ec6d0c27d97bd2a$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $0ec6d0c27d97bd2a$export$1aabd8a0274ecfd6, (v) => $0ec6d0c27d97bd2a$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $0ec6d0c27d97bd2a$export$3d6c20d97e46b957, (v) => $0ec6d0c27d97bd2a$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $0ec6d0c27d97bd2a$export$9b621391a187a31a, (v) => $0ec6d0c27d97bd2a$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $0ec6d0c27d97bd2a$export$f5bbd400c2f4426f, (v) => $0ec6d0c27d97bd2a$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0ec6d0c27d97bd2a$export$a7c73072b1a182ae;
var $0ec6d0c27d97bd2a$export$9f27bc3417b4524d;
var $0ec6d0c27d97bd2a$export$db77ccec0bb4ccac;
var $0ec6d0c27d97bd2a$export$8392c0c9d3dcbd35;
var $0ec6d0c27d97bd2a$export$ffb0004e005737fa;
var $0ec6d0c27d97bd2a$export$b624eff549462981;
var $0ec6d0c27d97bd2a$export$7897aa7841a5380c;
var $0ec6d0c27d97bd2a$export$602eac185826482c;
var $0ec6d0c27d97bd2a$export$e2c29f18771995cb;
var $0ec6d0c27d97bd2a$export$5f8d39834fd61797;
var $0ec6d0c27d97bd2a$export$74bf444e3cd11ea5;
var $0ec6d0c27d97bd2a$export$998bcd577473dd93;
var $0ec6d0c27d97bd2a$export$92387174baf9b227;
var $0ec6d0c27d97bd2a$export$ec112efeb987d9c6;
var $0ec6d0c27d97bd2a$export$b706b080d889d2c9;
var $0ec6d0c27d97bd2a$export$5be5a87408f70ddc;
var $0ec6d0c27d97bd2a$export$45a5e7f76e0caa8d;
var $0ec6d0c27d97bd2a$export$455c2e768291efa6;
var $0ec6d0c27d97bd2a$export$9522e17588c12572;
var $0ec6d0c27d97bd2a$export$2110ac352bb060b9;
var $0ec6d0c27d97bd2a$export$56885ab8b9c456ab;
var $0ec6d0c27d97bd2a$export$d927fcb6adf8f9de;
var $0ec6d0c27d97bd2a$export$b82d16f27459e05a;
var $0ec6d0c27d97bd2a$export$522c17b4f5e123e8;
var $0ec6d0c27d97bd2a$export$1aabd8a0274ecfd6;
var $0ec6d0c27d97bd2a$export$3d6c20d97e46b957;
var $0ec6d0c27d97bd2a$export$9b621391a187a31a;
var $0ec6d0c27d97bd2a$export$f5bbd400c2f4426f;
'use strict';
(function() {
    'use strict';
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for('react.element');
    var REACT_PORTAL_TYPE = Symbol.for('react.portal');
    var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
    var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
    var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
    var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
    var REACT_CONTEXT_TYPE = Symbol.for('react.context');
    var REACT_SERVER_CONTEXT_TYPE = Symbol.for('react.server_context');
    var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
    var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
    var REACT_MEMO_TYPE = Symbol.for('react.memo');
    var REACT_LAZY_TYPE = Symbol.for('react.lazy');
    var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
    function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === 'object' && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                        case REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_SERVER_CONTEXT_TYPE:
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    }
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false;
    var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console['warn']("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isConcurrentMode(object) {
        if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint
            console['warn']("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    function isSuspenseList(object) {
        return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
    }
    $0ec6d0c27d97bd2a$export$a7c73072b1a182ae = ContextConsumer;
    $0ec6d0c27d97bd2a$export$9f27bc3417b4524d = ContextProvider;
    $0ec6d0c27d97bd2a$export$db77ccec0bb4ccac = Element;
    $0ec6d0c27d97bd2a$export$8392c0c9d3dcbd35 = ForwardRef;
    $0ec6d0c27d97bd2a$export$ffb0004e005737fa = Fragment;
    $0ec6d0c27d97bd2a$export$b624eff549462981 = Lazy;
    $0ec6d0c27d97bd2a$export$7897aa7841a5380c = Memo;
    $0ec6d0c27d97bd2a$export$602eac185826482c = Portal;
    $0ec6d0c27d97bd2a$export$e2c29f18771995cb = Profiler;
    $0ec6d0c27d97bd2a$export$5f8d39834fd61797 = StrictMode;
    $0ec6d0c27d97bd2a$export$74bf444e3cd11ea5 = Suspense;
    $0ec6d0c27d97bd2a$export$998bcd577473dd93 = SuspenseList;
    $0ec6d0c27d97bd2a$export$92387174baf9b227 = isAsyncMode;
    $0ec6d0c27d97bd2a$export$ec112efeb987d9c6 = isConcurrentMode;
    $0ec6d0c27d97bd2a$export$b706b080d889d2c9 = isContextConsumer;
    $0ec6d0c27d97bd2a$export$5be5a87408f70ddc = isContextProvider;
    $0ec6d0c27d97bd2a$export$45a5e7f76e0caa8d = isElement;
    $0ec6d0c27d97bd2a$export$455c2e768291efa6 = isForwardRef;
    $0ec6d0c27d97bd2a$export$9522e17588c12572 = isFragment;
    $0ec6d0c27d97bd2a$export$2110ac352bb060b9 = isLazy;
    $0ec6d0c27d97bd2a$export$56885ab8b9c456ab = isMemo;
    $0ec6d0c27d97bd2a$export$d927fcb6adf8f9de = isPortal;
    $0ec6d0c27d97bd2a$export$b82d16f27459e05a = isProfiler;
    $0ec6d0c27d97bd2a$export$522c17b4f5e123e8 = isStrictMode;
    $0ec6d0c27d97bd2a$export$1aabd8a0274ecfd6 = isSuspense;
    $0ec6d0c27d97bd2a$export$3d6c20d97e46b957 = isSuspenseList;
    $0ec6d0c27d97bd2a$export$9b621391a187a31a = isValidElementType;
    $0ec6d0c27d97bd2a$export$f5bbd400c2f4426f = typeOf;
})();

});

parcelRegister("hK0qV", function(module, exports) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`

module.exports = (parcelRequire("hFb7y"));

});
parcelRegister("hFb7y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "scaleBand", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_band.default;
    }
});
Object.defineProperty(module.exports, "scaleDiverging", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "scaleDivergingLog", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_diverging.divergingLog;
    }
});
Object.defineProperty(module.exports, "scaleDivergingPow", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_diverging.divergingPow;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_diverging.divergingSqrt;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_diverging.divergingSymlog;
    }
});
Object.defineProperty(module.exports, "scaleIdentity", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_identity.default;
    }
});
Object.defineProperty(module.exports, "scaleImplicit", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_ordinal.implicit;
    }
});
Object.defineProperty(module.exports, "scaleLinear", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "scaleLog", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_log.default;
    }
});
Object.defineProperty(module.exports, "scaleOrdinal", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_ordinal.default;
    }
});
Object.defineProperty(module.exports, "scalePoint", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_band.point;
    }
});
Object.defineProperty(module.exports, "scalePow", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_pow.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantile", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantize", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_quantize.default;
    }
});
Object.defineProperty(module.exports, "scaleRadial", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_radial.default;
    }
});
Object.defineProperty(module.exports, "scaleSequential", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_sequential.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialLog", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_sequential.sequentialLog;
    }
});
Object.defineProperty(module.exports, "scaleSequentialPow", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_sequential.sequentialPow;
    }
});
Object.defineProperty(module.exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_sequentialQuantile.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_sequential.sequentialSqrt;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_sequential.sequentialSymlog;
    }
});
Object.defineProperty(module.exports, "scaleSqrt", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_pow.sqrt;
    }
});
Object.defineProperty(module.exports, "scaleSymlog", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_symlog.default;
    }
});
Object.defineProperty(module.exports, "scaleThreshold", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_threshold.default;
    }
});
Object.defineProperty(module.exports, "scaleTime", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_time.default;
    }
});
Object.defineProperty(module.exports, "scaleUtc", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_utcTime.default;
    }
});
Object.defineProperty(module.exports, "tickFormat", {
    enumerable: true,
    get: function() {
        return $cdbee463a1ef7488$var$_tickFormat.default;
    }
});

var $cdbee463a1ef7488$var$_band = $cdbee463a1ef7488$var$_interopRequireWildcard((parcelRequire("9JfWo")));

var $cdbee463a1ef7488$var$_identity = $cdbee463a1ef7488$var$_interopRequireDefault((parcelRequire("6kEZa")));

var $cdbee463a1ef7488$var$_linear = $cdbee463a1ef7488$var$_interopRequireDefault((parcelRequire("hHCkv")));

var $cdbee463a1ef7488$var$_log = $cdbee463a1ef7488$var$_interopRequireDefault((parcelRequire("jdUqB")));

var $cdbee463a1ef7488$var$_symlog = $cdbee463a1ef7488$var$_interopRequireDefault((parcelRequire("glCnt")));

var $cdbee463a1ef7488$var$_ordinal = $cdbee463a1ef7488$var$_interopRequireWildcard((parcelRequire("6Gt5K")));

var $cdbee463a1ef7488$var$_pow = $cdbee463a1ef7488$var$_interopRequireWildcard((parcelRequire("9R4Yk")));

var $cdbee463a1ef7488$var$_radial = $cdbee463a1ef7488$var$_interopRequireDefault((parcelRequire("iDRGP")));

var $cdbee463a1ef7488$var$_quantile = $cdbee463a1ef7488$var$_interopRequireDefault((parcelRequire("iYUPw")));

var $cdbee463a1ef7488$var$_quantize = $cdbee463a1ef7488$var$_interopRequireDefault((parcelRequire("c6un6")));

var $cdbee463a1ef7488$var$_threshold = $cdbee463a1ef7488$var$_interopRequireDefault((parcelRequire("oBu3L")));

var $cdbee463a1ef7488$var$_time = $cdbee463a1ef7488$var$_interopRequireDefault((parcelRequire("lze8j")));

var $cdbee463a1ef7488$var$_utcTime = $cdbee463a1ef7488$var$_interopRequireDefault((parcelRequire("3ZSjS")));

var $cdbee463a1ef7488$var$_sequential = $cdbee463a1ef7488$var$_interopRequireWildcard((parcelRequire("a9B8z")));

var $cdbee463a1ef7488$var$_sequentialQuantile = $cdbee463a1ef7488$var$_interopRequireDefault((parcelRequire("jatwg")));

var $cdbee463a1ef7488$var$_diverging = $cdbee463a1ef7488$var$_interopRequireWildcard((parcelRequire("5i1Ze")));

var $cdbee463a1ef7488$var$_tickFormat = $cdbee463a1ef7488$var$_interopRequireDefault((parcelRequire("kkpqj")));
function $cdbee463a1ef7488$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cdbee463a1ef7488$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($cdbee463a1ef7488$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $cdbee463a1ef7488$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $cdbee463a1ef7488$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("9JfWo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7154ae890f0acee1$var$band;
module.exports.point = $7154ae890f0acee1$var$point;

var $k5p7I = parcelRequire("k5p7I");

var $dVAcc = parcelRequire("dVAcc");

var $7154ae890f0acee1$var$_ordinal = $7154ae890f0acee1$var$_interopRequireDefault((parcelRequire("6Gt5K")));
function $7154ae890f0acee1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7154ae890f0acee1$var$band() {
    var scale = (0, $7154ae890f0acee1$var$_ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $k5p7I.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $7154ae890f0acee1$var$band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return $dVAcc.initRange.apply(rescale(), arguments);
}
function $7154ae890f0acee1$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $7154ae890f0acee1$var$pointish(copy());
    };
    return scale;
}
function $7154ae890f0acee1$var$point() {
    return $7154ae890f0acee1$var$pointish($7154ae890f0acee1$var$band.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("k5p7I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Adder", {
    enumerable: true,
    get: function() {
        return $gpt8f.Adder;
    }
});
Object.defineProperty(module.exports, "InternMap", {
    enumerable: true,
    get: function() {
        return $7I6G6.InternMap;
    }
});
Object.defineProperty(module.exports, "InternSet", {
    enumerable: true,
    get: function() {
        return $7I6G6.InternSet;
    }
});
Object.defineProperty(module.exports, "ascending", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "bin", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "bisect", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_bisect.default;
    }
});
Object.defineProperty(module.exports, "bisectCenter", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_bisect.bisectCenter;
    }
});
Object.defineProperty(module.exports, "bisectLeft", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_bisect.bisectLeft;
    }
});
Object.defineProperty(module.exports, "bisectRight", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_bisect.bisectRight;
    }
});
Object.defineProperty(module.exports, "bisector", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_bisector.default;
    }
});
Object.defineProperty(module.exports, "count", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_count.default;
    }
});
Object.defineProperty(module.exports, "cross", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "cumsum", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_cumsum.default;
    }
});
Object.defineProperty(module.exports, "descending", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "deviation", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_deviation.default;
    }
});
Object.defineProperty(module.exports, "difference", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_difference.default;
    }
});
Object.defineProperty(module.exports, "disjoint", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_disjoint.default;
    }
});
Object.defineProperty(module.exports, "every", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_every.default;
    }
});
Object.defineProperty(module.exports, "extent", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_extent.default;
    }
});
Object.defineProperty(module.exports, "fcumsum", {
    enumerable: true,
    get: function() {
        return $gpt8f.fcumsum;
    }
});
Object.defineProperty(module.exports, "filter", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_filter.default;
    }
});
Object.defineProperty(module.exports, "flatGroup", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_group.flatGroup;
    }
});
Object.defineProperty(module.exports, "flatRollup", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_group.flatRollup;
    }
});
Object.defineProperty(module.exports, "fsum", {
    enumerable: true,
    get: function() {
        return $gpt8f.fsum;
    }
});
Object.defineProperty(module.exports, "greatest", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_greatest.default;
    }
});
Object.defineProperty(module.exports, "greatestIndex", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_greatestIndex.default;
    }
});
Object.defineProperty(module.exports, "group", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_group.default;
    }
});
Object.defineProperty(module.exports, "groupSort", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_groupSort.default;
    }
});
Object.defineProperty(module.exports, "groups", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_group.groups;
    }
});
Object.defineProperty(module.exports, "histogram", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "index", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_group.index;
    }
});
Object.defineProperty(module.exports, "indexes", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_group.indexes;
    }
});
Object.defineProperty(module.exports, "intersection", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_intersection.default;
    }
});
Object.defineProperty(module.exports, "least", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_least.default;
    }
});
Object.defineProperty(module.exports, "leastIndex", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_leastIndex.default;
    }
});
Object.defineProperty(module.exports, "map", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_map.default;
    }
});
Object.defineProperty(module.exports, "max", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_max.default;
    }
});
Object.defineProperty(module.exports, "maxIndex", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_maxIndex.default;
    }
});
Object.defineProperty(module.exports, "mean", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_mean.default;
    }
});
Object.defineProperty(module.exports, "median", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_median.default;
    }
});
Object.defineProperty(module.exports, "merge", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_merge.default;
    }
});
Object.defineProperty(module.exports, "min", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_min.default;
    }
});
Object.defineProperty(module.exports, "minIndex", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_minIndex.default;
    }
});
Object.defineProperty(module.exports, "mode", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_mode.default;
    }
});
Object.defineProperty(module.exports, "nice", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_nice.default;
    }
});
Object.defineProperty(module.exports, "pairs", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_pairs.default;
    }
});
Object.defineProperty(module.exports, "permute", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_permute.default;
    }
});
Object.defineProperty(module.exports, "quantile", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "quantileSorted", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_quantile.quantileSorted;
    }
});
Object.defineProperty(module.exports, "quickselect", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_quickselect.default;
    }
});
Object.defineProperty(module.exports, "range", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_range.default;
    }
});
Object.defineProperty(module.exports, "rank", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_rank.default;
    }
});
Object.defineProperty(module.exports, "reduce", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_reduce.default;
    }
});
Object.defineProperty(module.exports, "reverse", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "rollup", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_group.rollup;
    }
});
Object.defineProperty(module.exports, "rollups", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_group.rollups;
    }
});
Object.defineProperty(module.exports, "scan", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_scan.default;
    }
});
Object.defineProperty(module.exports, "shuffle", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_shuffle.default;
    }
});
Object.defineProperty(module.exports, "shuffler", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_shuffle.shuffler;
    }
});
Object.defineProperty(module.exports, "some", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_some.default;
    }
});
Object.defineProperty(module.exports, "sort", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_sort.default;
    }
});
Object.defineProperty(module.exports, "subset", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_subset.default;
    }
});
Object.defineProperty(module.exports, "sum", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_sum.default;
    }
});
Object.defineProperty(module.exports, "superset", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_superset.default;
    }
});
Object.defineProperty(module.exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_freedmanDiaconis.default;
    }
});
Object.defineProperty(module.exports, "thresholdScott", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_scott.default;
    }
});
Object.defineProperty(module.exports, "thresholdSturges", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_sturges.default;
    }
});
Object.defineProperty(module.exports, "tickIncrement", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_ticks.tickIncrement;
    }
});
Object.defineProperty(module.exports, "tickStep", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_ticks.tickStep;
    }
});
Object.defineProperty(module.exports, "ticks", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_ticks.default;
    }
});
Object.defineProperty(module.exports, "transpose", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_transpose.default;
    }
});
Object.defineProperty(module.exports, "union", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_union.default;
    }
});
Object.defineProperty(module.exports, "variance", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_variance.default;
    }
});
Object.defineProperty(module.exports, "zip", {
    enumerable: true,
    get: function() {
        return $e9f7c34a33272be2$var$_zip.default;
    }
});

var $e9f7c34a33272be2$var$_bisect = $e9f7c34a33272be2$var$_interopRequireWildcard((parcelRequire("43yeO")));

var $e9f7c34a33272be2$var$_ascending = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("39Ini")));

var $e9f7c34a33272be2$var$_bisector = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("lGmGV")));

var $e9f7c34a33272be2$var$_count = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("l8jtH")));

var $e9f7c34a33272be2$var$_cross = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("hanMz")));

var $e9f7c34a33272be2$var$_cumsum = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("76RIn")));

var $e9f7c34a33272be2$var$_descending = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("9A73e")));

var $e9f7c34a33272be2$var$_deviation = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("j7SXB")));

var $e9f7c34a33272be2$var$_extent = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("lsEcM")));

var $gpt8f = parcelRequire("gpt8f");

var $e9f7c34a33272be2$var$_group = $e9f7c34a33272be2$var$_interopRequireWildcard((parcelRequire("1xyM5")));

var $e9f7c34a33272be2$var$_groupSort = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("6GPk3")));

var $e9f7c34a33272be2$var$_bin = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("bEkSl")));

var $e9f7c34a33272be2$var$_freedmanDiaconis = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("acyHX")));

var $e9f7c34a33272be2$var$_scott = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("hAOtB")));

var $e9f7c34a33272be2$var$_sturges = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("2KDlL")));

var $e9f7c34a33272be2$var$_max = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("16Hj2")));

var $e9f7c34a33272be2$var$_maxIndex = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("8HAZf")));

var $e9f7c34a33272be2$var$_mean = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("do0SF")));

var $e9f7c34a33272be2$var$_median = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("hTPcL")));

var $e9f7c34a33272be2$var$_merge = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("gspOS")));

var $e9f7c34a33272be2$var$_min = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("42F9U")));

var $e9f7c34a33272be2$var$_minIndex = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("ihqQu")));

var $e9f7c34a33272be2$var$_mode = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("igvuR")));

var $e9f7c34a33272be2$var$_nice = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("bGzLU")));

var $e9f7c34a33272be2$var$_pairs = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("bR440")));

var $e9f7c34a33272be2$var$_permute = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("1G2j3")));

var $e9f7c34a33272be2$var$_quantile = $e9f7c34a33272be2$var$_interopRequireWildcard((parcelRequire("lpFOV")));

var $e9f7c34a33272be2$var$_quickselect = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("axdrO")));

var $e9f7c34a33272be2$var$_range = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("iojua")));

var $e9f7c34a33272be2$var$_rank = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("3lynj")));

var $e9f7c34a33272be2$var$_least = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("8wDXM")));

var $e9f7c34a33272be2$var$_leastIndex = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("1Uixs")));

var $e9f7c34a33272be2$var$_greatest = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("ft5uT")));

var $e9f7c34a33272be2$var$_greatestIndex = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("dlgbV")));

var $e9f7c34a33272be2$var$_scan = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("d6Hkq")));

var $e9f7c34a33272be2$var$_shuffle = $e9f7c34a33272be2$var$_interopRequireWildcard((parcelRequire("ijGLX")));

var $e9f7c34a33272be2$var$_sum = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("lmtWS")));

var $e9f7c34a33272be2$var$_ticks = $e9f7c34a33272be2$var$_interopRequireWildcard((parcelRequire("yiH15")));

var $e9f7c34a33272be2$var$_transpose = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("007tl")));

var $e9f7c34a33272be2$var$_variance = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("eXBTy")));

var $e9f7c34a33272be2$var$_zip = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("8aP8p")));

var $e9f7c34a33272be2$var$_every = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("77fyv")));

var $e9f7c34a33272be2$var$_some = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("aO6H2")));

var $e9f7c34a33272be2$var$_filter = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("7ZpDD")));

var $e9f7c34a33272be2$var$_map = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("e5d2T")));

var $e9f7c34a33272be2$var$_reduce = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("3VQEL")));

var $e9f7c34a33272be2$var$_reverse = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("4jdv2")));

var $e9f7c34a33272be2$var$_sort = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("6iLdw")));

var $e9f7c34a33272be2$var$_difference = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("4yReJ")));

var $e9f7c34a33272be2$var$_disjoint = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("eDFdh")));

var $e9f7c34a33272be2$var$_intersection = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("c2YWQ")));

var $e9f7c34a33272be2$var$_subset = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("3euGV")));

var $e9f7c34a33272be2$var$_superset = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("dBs94")));

var $e9f7c34a33272be2$var$_union = $e9f7c34a33272be2$var$_interopRequireDefault((parcelRequire("fomCn")));

var $7I6G6 = parcelRequire("7I6G6");
function $e9f7c34a33272be2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e9f7c34a33272be2$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($e9f7c34a33272be2$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $e9f7c34a33272be2$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $e9f7c34a33272be2$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("43yeO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.bisectRight = module.exports.bisectLeft = module.exports.bisectCenter = void 0;

var $2f420026f0b5df06$var$_ascending = $2f420026f0b5df06$var$_interopRequireDefault((parcelRequire("39Ini")));

var $2f420026f0b5df06$var$_bisector = $2f420026f0b5df06$var$_interopRequireDefault((parcelRequire("lGmGV")));

var $2f420026f0b5df06$var$_number = $2f420026f0b5df06$var$_interopRequireDefault((parcelRequire("3J6uV")));
function $2f420026f0b5df06$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2f420026f0b5df06$var$ascendingBisect = (0, $2f420026f0b5df06$var$_bisector.default)($2f420026f0b5df06$var$_ascending.default);
const $2f420026f0b5df06$var$bisectRight = $2f420026f0b5df06$var$ascendingBisect.right;
module.exports.bisectRight = $2f420026f0b5df06$var$bisectRight;
const $2f420026f0b5df06$var$bisectLeft = $2f420026f0b5df06$var$ascendingBisect.left;
module.exports.bisectLeft = $2f420026f0b5df06$var$bisectLeft;
const $2f420026f0b5df06$var$bisectCenter = (0, $2f420026f0b5df06$var$_bisector.default)($2f420026f0b5df06$var$_number.default).center;
module.exports.bisectCenter = $2f420026f0b5df06$var$bisectCenter;
var $2f420026f0b5df06$var$_default = $2f420026f0b5df06$var$bisectRight;
module.exports.default = $2f420026f0b5df06$var$_default;

});
parcelRegister("39Ini", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $24c4a23eba981b5a$var$ascending;
function $24c4a23eba981b5a$var$ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("lGmGV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fc8f1f42fbec9319$var$bisector;

var $fc8f1f42fbec9319$var$_ascending = $fc8f1f42fbec9319$var$_interopRequireDefault((parcelRequire("39Ini")));

var $fc8f1f42fbec9319$var$_descending = $fc8f1f42fbec9319$var$_interopRequireDefault((parcelRequire("9A73e")));
function $fc8f1f42fbec9319$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fc8f1f42fbec9319$var$bisector(f) {
    let compare1, compare2, delta; // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = $fc8f1f42fbec9319$var$_ascending.default;
        compare2 = (d, x)=>(0, $fc8f1f42fbec9319$var$_ascending.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === $fc8f1f42fbec9319$var$_ascending.default || f === $fc8f1f42fbec9319$var$_descending.default ? f : $fc8f1f42fbec9319$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $fc8f1f42fbec9319$var$zero() {
    return 0;
}

});
parcelRegister("9A73e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6f9cf2144ff8ada8$var$descending;
function $6f9cf2144ff8ada8$var$descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRegister("3J6uV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2b6a9d5e6226de5e$var$number;
module.exports.numbers = $2b6a9d5e6226de5e$var$numbers;
function $2b6a9d5e6226de5e$var$number(x) {
    return x === null ? NaN : +x;
}
function* $2b6a9d5e6226de5e$var$numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("l8jtH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f62974484cee4b56$var$count;
function $f62974484cee4b56$var$count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

});

parcelRegister("hanMz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c7f5d186996ed1d4$var$cross;
function $c7f5d186996ed1d4$var$length(array) {
    return array.length | 0;
}
function $c7f5d186996ed1d4$var$empty(length) {
    return !(length > 0);
}
function $c7f5d186996ed1d4$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $c7f5d186996ed1d4$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $c7f5d186996ed1d4$var$cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $c7f5d186996ed1d4$var$reducer(values.pop());
    values = values.map($c7f5d186996ed1d4$var$arrayify);
    const lengths = values.map($c7f5d186996ed1d4$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($c7f5d186996ed1d4$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

});

parcelRegister("76RIn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $52d2c29036e05511$var$cumsum;
function $52d2c29036e05511$var$cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

});

parcelRegister("j7SXB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dec94dbe3b2ab56b$var$deviation;

var $dec94dbe3b2ab56b$var$_variance = $dec94dbe3b2ab56b$var$_interopRequireDefault((parcelRequire("eXBTy")));
function $dec94dbe3b2ab56b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dec94dbe3b2ab56b$var$deviation(values, valueof) {
    const v = (0, $dec94dbe3b2ab56b$var$_variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("eXBTy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ae43f88f121b97b0$var$variance;
function $ae43f88f121b97b0$var$variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

});


parcelRegister("lsEcM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f9fb66603451a4bb$var$extent;
function $f9fb66603451a4bb$var$extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("gpt8f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Adder = void 0;
module.exports.fcumsum = $bf259425590a864c$var$fcumsum;
module.exports.fsum = $bf259425590a864c$var$fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $bf259425590a864c$var$Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
module.exports.Adder = $bf259425590a864c$var$Adder;
function $bf259425590a864c$var$fsum(values, valueof) {
    const adder = new $bf259425590a864c$var$Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $bf259425590a864c$var$fcumsum(values, valueof) {
    const adder = new $bf259425590a864c$var$Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

});

parcelRegister("1xyM5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $11f3d904556acb08$var$group;
module.exports.flatGroup = $11f3d904556acb08$var$flatGroup;
module.exports.flatRollup = $11f3d904556acb08$var$flatRollup;
module.exports.groups = $11f3d904556acb08$var$groups;
module.exports.index = $11f3d904556acb08$var$index;
module.exports.indexes = $11f3d904556acb08$var$indexes;
module.exports.rollup = $11f3d904556acb08$var$rollup;
module.exports.rollups = $11f3d904556acb08$var$rollups;

var $7I6G6 = parcelRequire("7I6G6");

var $11f3d904556acb08$var$_identity = $11f3d904556acb08$var$_interopRequireDefault((parcelRequire("evjAl")));
function $11f3d904556acb08$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $11f3d904556acb08$var$group(values, ...keys) {
    return $11f3d904556acb08$var$nest(values, $11f3d904556acb08$var$_identity.default, $11f3d904556acb08$var$_identity.default, keys);
}
function $11f3d904556acb08$var$groups(values, ...keys) {
    return $11f3d904556acb08$var$nest(values, Array.from, $11f3d904556acb08$var$_identity.default, keys);
}
function $11f3d904556acb08$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $11f3d904556acb08$var$flatGroup(values, ...keys) {
    return $11f3d904556acb08$var$flatten($11f3d904556acb08$var$groups(values, ...keys), keys);
}
function $11f3d904556acb08$var$flatRollup(values, reduce, ...keys) {
    return $11f3d904556acb08$var$flatten($11f3d904556acb08$var$rollups(values, reduce, ...keys), keys);
}
function $11f3d904556acb08$var$rollup(values, reduce, ...keys) {
    return $11f3d904556acb08$var$nest(values, $11f3d904556acb08$var$_identity.default, reduce, keys);
}
function $11f3d904556acb08$var$rollups(values, reduce, ...keys) {
    return $11f3d904556acb08$var$nest(values, Array.from, reduce, keys);
}
function $11f3d904556acb08$var$index(values, ...keys) {
    return $11f3d904556acb08$var$nest(values, $11f3d904556acb08$var$_identity.default, $11f3d904556acb08$var$unique, keys);
}
function $11f3d904556acb08$var$indexes(values, ...keys) {
    return $11f3d904556acb08$var$nest(values, Array.from, $11f3d904556acb08$var$unique, keys);
}
function $11f3d904556acb08$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $11f3d904556acb08$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new $7I6G6.InternMap();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

});
parcelRegister("7I6G6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternSet = module.exports.InternMap = void 0;
class $59d1d29d433f1f05$var$InternMap extends Map {
    constructor(entries, key = $59d1d29d433f1f05$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($59d1d29d433f1f05$var$intern_get(this, key));
    }
    has(key) {
        return super.has($59d1d29d433f1f05$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($59d1d29d433f1f05$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($59d1d29d433f1f05$var$intern_delete(this, key));
    }
}
module.exports.InternMap = $59d1d29d433f1f05$var$InternMap;
class $59d1d29d433f1f05$var$InternSet extends Set {
    constructor(values, key = $59d1d29d433f1f05$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($59d1d29d433f1f05$var$intern_get(this, value));
    }
    add(value) {
        return super.add($59d1d29d433f1f05$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($59d1d29d433f1f05$var$intern_delete(this, value));
    }
}
module.exports.InternSet = $59d1d29d433f1f05$var$InternSet;
function $59d1d29d433f1f05$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $59d1d29d433f1f05$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $59d1d29d433f1f05$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $59d1d29d433f1f05$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});

parcelRegister("evjAl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a8f3272c1dc35fb8$var$identity;
function $a8f3272c1dc35fb8$var$identity(x) {
    return x;
}

});


parcelRegister("6GPk3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4dee79e32c8e62ca$var$groupSort;

var $4dee79e32c8e62ca$var$_ascending = $4dee79e32c8e62ca$var$_interopRequireDefault((parcelRequire("39Ini")));

var $4dee79e32c8e62ca$var$_group = $4dee79e32c8e62ca$var$_interopRequireWildcard((parcelRequire("1xyM5")));

var $4dee79e32c8e62ca$var$_sort = $4dee79e32c8e62ca$var$_interopRequireDefault((parcelRequire("6iLdw")));
function $4dee79e32c8e62ca$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($4dee79e32c8e62ca$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $4dee79e32c8e62ca$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $4dee79e32c8e62ca$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $4dee79e32c8e62ca$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4dee79e32c8e62ca$var$groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, $4dee79e32c8e62ca$var$_sort.default)((0, $4dee79e32c8e62ca$var$_group.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $4dee79e32c8e62ca$var$_ascending.default)(av, bv) || (0, $4dee79e32c8e62ca$var$_ascending.default)(ak, bk)) : (0, $4dee79e32c8e62ca$var$_sort.default)((0, $4dee79e32c8e62ca$var$_group.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $4dee79e32c8e62ca$var$_ascending.default)(ak, bk))).map(([key])=>key);
}

});
parcelRegister("6iLdw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ascendingDefined = $49690cd6da047ee5$var$ascendingDefined;
module.exports.compareDefined = $49690cd6da047ee5$var$compareDefined;
module.exports.default = $49690cd6da047ee5$var$sort;

var $49690cd6da047ee5$var$_ascending = $49690cd6da047ee5$var$_interopRequireDefault((parcelRequire("39Ini")));

var $49690cd6da047ee5$var$_permute = $49690cd6da047ee5$var$_interopRequireDefault((parcelRequire("1G2j3")));
function $49690cd6da047ee5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $49690cd6da047ee5$var$sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $49690cd6da047ee5$var$ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$49690cd6da047ee5$var$ascendingDefined(f[i], f[j]));
        }
        return (0, $49690cd6da047ee5$var$_permute.default)(values, index);
    }
    return values.sort($49690cd6da047ee5$var$compareDefined(f));
}
function $49690cd6da047ee5$var$compareDefined(compare = $49690cd6da047ee5$var$_ascending.default) {
    if (compare === $49690cd6da047ee5$var$_ascending.default) return $49690cd6da047ee5$var$ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $49690cd6da047ee5$var$ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

});
parcelRegister("1G2j3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $138b80b04d84d08a$var$permute;
function $138b80b04d84d08a$var$permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

});



parcelRegister("bEkSl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $87b39f8f1316f26e$var$bin;

var $g2fqu = parcelRequire("g2fqu");

var $87b39f8f1316f26e$var$_bisect = $87b39f8f1316f26e$var$_interopRequireDefault((parcelRequire("43yeO")));

var $87b39f8f1316f26e$var$_constant = $87b39f8f1316f26e$var$_interopRequireDefault((parcelRequire("kprME")));

var $87b39f8f1316f26e$var$_extent = $87b39f8f1316f26e$var$_interopRequireDefault((parcelRequire("lsEcM")));

var $87b39f8f1316f26e$var$_identity = $87b39f8f1316f26e$var$_interopRequireDefault((parcelRequire("evjAl")));

var $87b39f8f1316f26e$var$_nice = $87b39f8f1316f26e$var$_interopRequireDefault((parcelRequire("bGzLU")));

var $87b39f8f1316f26e$var$_ticks = $87b39f8f1316f26e$var$_interopRequireWildcard((parcelRequire("yiH15")));

var $87b39f8f1316f26e$var$_sturges = $87b39f8f1316f26e$var$_interopRequireDefault((parcelRequire("2KDlL")));
function $87b39f8f1316f26e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($87b39f8f1316f26e$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $87b39f8f1316f26e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $87b39f8f1316f26e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $87b39f8f1316f26e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $87b39f8f1316f26e$var$bin() {
    var value = $87b39f8f1316f26e$var$_identity.default, domain = $87b39f8f1316f26e$var$_extent.default, threshold = $87b39f8f1316f26e$var$_sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1); // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === $87b39f8f1316f26e$var$_extent.default) [x0, x1] = (0, $87b39f8f1316f26e$var$_nice.default)(x0, x1, tn);
            tz = (0, $87b39f8f1316f26e$var$_ticks.default)(x0, x1, tn); // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, $87b39f8f1316f26e$var$_ticks.tickIncrement)(x0, x1, tn); // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === $87b39f8f1316f26e$var$_extent.default) {
                    const step = (0, $87b39f8f1316f26e$var$_ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        } // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin; // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        } // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, $87b39f8f1316f26e$var$_bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $87b39f8f1316f26e$var$_constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $87b39f8f1316f26e$var$_constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $87b39f8f1316f26e$var$_constant.default)($g2fqu.slice.call(_)) : (0, $87b39f8f1316f26e$var$_constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("g2fqu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slice = module.exports.map = void 0;
var $bac8cc90bc9c1575$var$array = Array.prototype;
var $bac8cc90bc9c1575$var$slice = $bac8cc90bc9c1575$var$array.slice;
module.exports.slice = $bac8cc90bc9c1575$var$slice;
var $bac8cc90bc9c1575$var$map = $bac8cc90bc9c1575$var$array.map;
module.exports.map = $bac8cc90bc9c1575$var$map;

});

parcelRegister("kprME", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $edbbb1b3ee9e2bfe$var$constant;
function $edbbb1b3ee9e2bfe$var$constant(x) {
    return ()=>x;
}

});

parcelRegister("bGzLU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $881f5d72be009a6c$var$nice;

var $yiH15 = parcelRequire("yiH15");
function $881f5d72be009a6c$var$nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $yiH15.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

});
parcelRegister("yiH15", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0671ad1829c0816d$var$ticks;
module.exports.tickIncrement = $0671ad1829c0816d$var$tickIncrement;
module.exports.tickStep = $0671ad1829c0816d$var$tickStep;
var $0671ad1829c0816d$var$e10 = Math.sqrt(50), $0671ad1829c0816d$var$e5 = Math.sqrt(10), $0671ad1829c0816d$var$e2 = Math.sqrt(2);
function $0671ad1829c0816d$var$ticks(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $0671ad1829c0816d$var$tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $0671ad1829c0816d$var$tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $0671ad1829c0816d$var$e10 ? 10 : error >= $0671ad1829c0816d$var$e5 ? 5 : error >= $0671ad1829c0816d$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $0671ad1829c0816d$var$e10 ? 10 : error >= $0671ad1829c0816d$var$e5 ? 5 : error >= $0671ad1829c0816d$var$e2 ? 2 : 1);
}
function $0671ad1829c0816d$var$tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $0671ad1829c0816d$var$e10) step1 *= 10;
    else if (error >= $0671ad1829c0816d$var$e5) step1 *= 5;
    else if (error >= $0671ad1829c0816d$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});


parcelRegister("2KDlL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $200e66c047a151fe$var$thresholdSturges;

var $200e66c047a151fe$var$_count = $200e66c047a151fe$var$_interopRequireDefault((parcelRequire("l8jtH")));
function $200e66c047a151fe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $200e66c047a151fe$var$thresholdSturges(values) {
    return Math.ceil(Math.log((0, $200e66c047a151fe$var$_count.default)(values)) / Math.LN2) + 1;
}

});


parcelRegister("acyHX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $76d5f2a97bb94038$var$thresholdFreedmanDiaconis;

var $76d5f2a97bb94038$var$_count = $76d5f2a97bb94038$var$_interopRequireDefault((parcelRequire("l8jtH")));

var $76d5f2a97bb94038$var$_quantile = $76d5f2a97bb94038$var$_interopRequireDefault((parcelRequire("lpFOV")));
function $76d5f2a97bb94038$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $76d5f2a97bb94038$var$thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, $76d5f2a97bb94038$var$_quantile.default)(values, 0.75) - (0, $76d5f2a97bb94038$var$_quantile.default)(values, 0.25)) * Math.pow((0, $76d5f2a97bb94038$var$_count.default)(values), -1 / 3)));
}

});
parcelRegister("lpFOV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f96c5f6e49ea0733$var$quantile;
module.exports.quantileSorted = $f96c5f6e49ea0733$var$quantileSorted;

var $f96c5f6e49ea0733$var$_max = $f96c5f6e49ea0733$var$_interopRequireDefault((parcelRequire("16Hj2")));

var $f96c5f6e49ea0733$var$_min = $f96c5f6e49ea0733$var$_interopRequireDefault((parcelRequire("42F9U")));

var $f96c5f6e49ea0733$var$_quickselect = $f96c5f6e49ea0733$var$_interopRequireDefault((parcelRequire("axdrO")));

var $f96c5f6e49ea0733$var$_number = $f96c5f6e49ea0733$var$_interopRequireWildcard((parcelRequire("3J6uV")));
function $f96c5f6e49ea0733$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f96c5f6e49ea0733$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f96c5f6e49ea0733$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f96c5f6e49ea0733$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f96c5f6e49ea0733$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f96c5f6e49ea0733$var$quantile(values, p, valueof) {
    values = Float64Array.from((0, $f96c5f6e49ea0733$var$_number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $f96c5f6e49ea0733$var$_min.default)(values);
    if (p >= 1) return (0, $f96c5f6e49ea0733$var$_max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $f96c5f6e49ea0733$var$_max.default)((0, $f96c5f6e49ea0733$var$_quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $f96c5f6e49ea0733$var$_min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $f96c5f6e49ea0733$var$quantileSorted(values, p, valueof = $f96c5f6e49ea0733$var$_number.default) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});
parcelRegister("16Hj2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0ce7f1aed049e347$var$max;
function $0ce7f1aed049e347$var$max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRegister("42F9U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2f17469b425004be$var$min;
function $2f17469b425004be$var$min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRegister("axdrO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7ab76ad7e6f16842$var$quickselect;

var $6iLdw = parcelRequire("6iLdw");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function $7ab76ad7e6f16842$var$quickselect(array, k, left = 0, right = array.length - 1, compare) {
    compare = compare === undefined ? $6iLdw.ascendingDefined : (0, $6iLdw.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $7ab76ad7e6f16842$var$quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $7ab76ad7e6f16842$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $7ab76ad7e6f16842$var$swap(array, left, right);
        while(i < j){
            $7ab76ad7e6f16842$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $7ab76ad7e6f16842$var$swap(array, left, j);
        else ++j, $7ab76ad7e6f16842$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $7ab76ad7e6f16842$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});



parcelRegister("hAOtB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ccecf4085382ea07$var$thresholdScott;

var $ccecf4085382ea07$var$_count = $ccecf4085382ea07$var$_interopRequireDefault((parcelRequire("l8jtH")));

var $ccecf4085382ea07$var$_deviation = $ccecf4085382ea07$var$_interopRequireDefault((parcelRequire("j7SXB")));
function $ccecf4085382ea07$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ccecf4085382ea07$var$thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, $ccecf4085382ea07$var$_count.default)(values)) / (3.49 * (0, $ccecf4085382ea07$var$_deviation.default)(values)));
}

});

parcelRegister("8HAZf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $655f07b3eccfc9a9$var$maxIndex;
function $655f07b3eccfc9a9$var$maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

});

parcelRegister("do0SF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9bee331fb011122b$var$mean;
function $9bee331fb011122b$var$mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

});

parcelRegister("hTPcL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d07f4af01fcb554b$var$median;

var $d07f4af01fcb554b$var$_quantile = $d07f4af01fcb554b$var$_interopRequireDefault((parcelRequire("lpFOV")));
function $d07f4af01fcb554b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d07f4af01fcb554b$var$median(values, valueof) {
    return (0, $d07f4af01fcb554b$var$_quantile.default)(values, 0.5, valueof);
}

});

parcelRegister("gspOS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bfb34a1b1f2378dd$var$merge;
function* $bfb34a1b1f2378dd$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $bfb34a1b1f2378dd$var$merge(arrays) {
    return Array.from($bfb34a1b1f2378dd$var$flatten(arrays));
}

});

parcelRegister("ihqQu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d4eea380e0705f67$var$minIndex;
function $d4eea380e0705f67$var$minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

});

parcelRegister("igvuR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d4c22730f6c87526$var$mode;

var $7I6G6 = parcelRequire("7I6G6");
function $d4c22730f6c87526$var$mode(values, valueof) {
    const counts = new $7I6G6.InternMap();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

});

parcelRegister("bR440", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8a17cbe542601361$var$pairs;
module.exports.pair = $8a17cbe542601361$var$pair;
function $8a17cbe542601361$var$pairs(values, pairof = $8a17cbe542601361$var$pair) {
    const pairs1 = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs1.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs1;
}
function $8a17cbe542601361$var$pair(a, b) {
    return [
        a,
        b
    ];
}

});

parcelRegister("iojua", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d63995507c4c9b1e$var$range;
function $d63995507c4c9b1e$var$range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("3lynj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $26fdff6c1444b4ef$var$rank;

var $26fdff6c1444b4ef$var$_ascending = $26fdff6c1444b4ef$var$_interopRequireDefault((parcelRequire("39Ini")));

var $6iLdw = parcelRequire("6iLdw");
function $26fdff6c1444b4ef$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $26fdff6c1444b4ef$var$rank(values, valueof = $26fdff6c1444b4ef$var$_ascending.default) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = $26fdff6c1444b4ef$var$_ascending.default;
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    Uint32Array.from(V, (_, i)=>i).sort(valueof === $26fdff6c1444b4ef$var$_ascending.default ? (i, j)=>(0, $6iLdw.ascendingDefined)(V[i], V[j]) : (0, $6iLdw.compareDefined)(compareIndex)).forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

});

parcelRegister("8wDXM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $63504fbc0fced18c$var$least;

var $63504fbc0fced18c$var$_ascending = $63504fbc0fced18c$var$_interopRequireDefault((parcelRequire("39Ini")));
function $63504fbc0fced18c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $63504fbc0fced18c$var$least(values, compare = $63504fbc0fced18c$var$_ascending.default) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $63504fbc0fced18c$var$_ascending.default)(value, minValue) < 0 : (0, $63504fbc0fced18c$var$_ascending.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

});

parcelRegister("1Uixs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $163966ceed2dfabf$var$leastIndex;

var $163966ceed2dfabf$var$_ascending = $163966ceed2dfabf$var$_interopRequireDefault((parcelRequire("39Ini")));

var $163966ceed2dfabf$var$_minIndex = $163966ceed2dfabf$var$_interopRequireDefault((parcelRequire("ihqQu")));
function $163966ceed2dfabf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $163966ceed2dfabf$var$leastIndex(values, compare = $163966ceed2dfabf$var$_ascending.default) {
    if (compare.length === 1) return (0, $163966ceed2dfabf$var$_minIndex.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

});

parcelRegister("ft5uT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b42dd413fab8f9f3$var$greatest;

var $b42dd413fab8f9f3$var$_ascending = $b42dd413fab8f9f3$var$_interopRequireDefault((parcelRequire("39Ini")));
function $b42dd413fab8f9f3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b42dd413fab8f9f3$var$greatest(values, compare = $b42dd413fab8f9f3$var$_ascending.default) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $b42dd413fab8f9f3$var$_ascending.default)(value, maxValue) > 0 : (0, $b42dd413fab8f9f3$var$_ascending.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

});

parcelRegister("dlgbV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9b69cbcab3b4b555$var$greatestIndex;

var $9b69cbcab3b4b555$var$_ascending = $9b69cbcab3b4b555$var$_interopRequireDefault((parcelRequire("39Ini")));

var $9b69cbcab3b4b555$var$_maxIndex = $9b69cbcab3b4b555$var$_interopRequireDefault((parcelRequire("8HAZf")));
function $9b69cbcab3b4b555$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9b69cbcab3b4b555$var$greatestIndex(values, compare = $9b69cbcab3b4b555$var$_ascending.default) {
    if (compare.length === 1) return (0, $9b69cbcab3b4b555$var$_maxIndex.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

});

parcelRegister("d6Hkq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $98ad7203b0ae11ff$var$scan;

var $98ad7203b0ae11ff$var$_leastIndex = $98ad7203b0ae11ff$var$_interopRequireDefault((parcelRequire("1Uixs")));
function $98ad7203b0ae11ff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $98ad7203b0ae11ff$var$scan(values, compare) {
    const index = (0, $98ad7203b0ae11ff$var$_leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

});

parcelRegister("ijGLX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.shuffler = $d55b2e14c78999ed$var$shuffler;
var $d55b2e14c78999ed$var$_default = $d55b2e14c78999ed$var$shuffler(Math.random);
module.exports.default = $d55b2e14c78999ed$var$_default;
function $d55b2e14c78999ed$var$shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

});

parcelRegister("lmtWS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f8d2e23b8cf5374c$var$sum;
function $f8d2e23b8cf5374c$var$sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("007tl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $000017ef9ef15772$var$transpose;

var $000017ef9ef15772$var$_min = $000017ef9ef15772$var$_interopRequireDefault((parcelRequire("42F9U")));
function $000017ef9ef15772$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $000017ef9ef15772$var$transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $000017ef9ef15772$var$_min.default)(matrix, $000017ef9ef15772$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $000017ef9ef15772$var$length(d) {
    return d.length;
}

});

parcelRegister("8aP8p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5f36ec2a0ce9afb5$var$zip;

var $5f36ec2a0ce9afb5$var$_transpose = $5f36ec2a0ce9afb5$var$_interopRequireDefault((parcelRequire("007tl")));
function $5f36ec2a0ce9afb5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5f36ec2a0ce9afb5$var$zip() {
    return (0, $5f36ec2a0ce9afb5$var$_transpose.default)(arguments);
}

});

parcelRegister("77fyv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $52e540e022190437$var$every;
function $52e540e022190437$var$every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

});

parcelRegister("aO6H2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7de3c4068a3b6429$var$some;
function $7de3c4068a3b6429$var$some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

});

parcelRegister("7ZpDD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5d121e217c855b48$var$filter;
function $5d121e217c855b48$var$filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

});

parcelRegister("e5d2T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a40ba6eb8081c873$var$map;
function $a40ba6eb8081c873$var$map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

});

parcelRegister("3VQEL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2dcf8a7410cb5180$var$reduce;
function $2dcf8a7410cb5180$var$reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done: done, value: value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

});

parcelRegister("4jdv2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $323368893ca474f3$var$reverse;
function $323368893ca474f3$var$reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

});

parcelRegister("4yReJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3523a218fb8ad9df$var$difference;

var $7I6G6 = parcelRequire("7I6G6");
function $3523a218fb8ad9df$var$difference(values, ...others) {
    values = new $7I6G6.InternSet(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

});

parcelRegister("eDFdh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aa84ad4663c83148$var$disjoint;

var $7I6G6 = parcelRequire("7I6G6");
function $aa84ad4663c83148$var$disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new $7I6G6.InternSet();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

});

parcelRegister("c2YWQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c54f2f635050cc2$var$intersection;

var $7I6G6 = parcelRequire("7I6G6");
function $8c54f2f635050cc2$var$intersection(values, ...others) {
    values = new $7I6G6.InternSet(values);
    others = others.map($8c54f2f635050cc2$var$set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function $8c54f2f635050cc2$var$set(values) {
    return values instanceof $7I6G6.InternSet ? values : new $7I6G6.InternSet(values);
}

});

parcelRegister("3euGV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $25aa7c910c6a8d4e$var$subset;

var $25aa7c910c6a8d4e$var$_superset = $25aa7c910c6a8d4e$var$_interopRequireDefault((parcelRequire("dBs94")));
function $25aa7c910c6a8d4e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $25aa7c910c6a8d4e$var$subset(values, other) {
    return (0, $25aa7c910c6a8d4e$var$_superset.default)(other, values);
}

});
parcelRegister("dBs94", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9e74901da348be74$var$superset;
function $9e74901da348be74$var$superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = $9e74901da348be74$var$intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) return false;
            const ivalue = $9e74901da348be74$var$intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function $9e74901da348be74$var$intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});


parcelRegister("fomCn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b34aa459427165bb$var$union;

var $7I6G6 = parcelRequire("7I6G6");
function $b34aa459427165bb$var$union(...others) {
    const set = new $7I6G6.InternSet();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

});


parcelRegister("dVAcc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initInterpolator = $a23cacef886ea7a0$var$initInterpolator;
module.exports.initRange = $a23cacef886ea7a0$var$initRange;
function $a23cacef886ea7a0$var$initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $a23cacef886ea7a0$var$initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("6Gt5K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4ddd3b522464a8eb$var$ordinal;
module.exports.implicit = void 0;

var $k5p7I = parcelRequire("k5p7I");

var $dVAcc = parcelRequire("dVAcc");
const $4ddd3b522464a8eb$var$implicit = Symbol("implicit");
module.exports.implicit = $4ddd3b522464a8eb$var$implicit;
function $4ddd3b522464a8eb$var$ordinal() {
    var index = new $k5p7I.InternMap(), domain = [], range = [], unknown = $4ddd3b522464a8eb$var$implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $4ddd3b522464a8eb$var$implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new $k5p7I.InternMap();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $4ddd3b522464a8eb$var$ordinal(domain, range).unknown(unknown);
    };
    $dVAcc.initRange.apply(scale, arguments);
    return scale;
}

});


parcelRegister("6kEZa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $49c4673966f527a8$var$identity;

var $hHCkv = parcelRequire("hHCkv");

var $49c4673966f527a8$var$_number = $49c4673966f527a8$var$_interopRequireDefault((parcelRequire("66OMX")));
function $49c4673966f527a8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $49c4673966f527a8$var$identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, $49c4673966f527a8$var$_number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $49c4673966f527a8$var$identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, $49c4673966f527a8$var$_number.default) : [
        0,
        1
    ];
    return (0, $hHCkv.linearish)(scale);
}

});
parcelRegister("hHCkv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ce342f4f280b4073$var$linear;
module.exports.linearish = $ce342f4f280b4073$var$linearish;

var $k5p7I = parcelRequire("k5p7I");

var $ce342f4f280b4073$var$_continuous = $ce342f4f280b4073$var$_interopRequireWildcard((parcelRequire("aiVEG")));

var $dVAcc = parcelRequire("dVAcc");

var $ce342f4f280b4073$var$_tickFormat = $ce342f4f280b4073$var$_interopRequireDefault((parcelRequire("kkpqj")));
function $ce342f4f280b4073$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ce342f4f280b4073$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($ce342f4f280b4073$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $ce342f4f280b4073$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ce342f4f280b4073$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $ce342f4f280b4073$var$linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $k5p7I.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $ce342f4f280b4073$var$_tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $k5p7I.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $ce342f4f280b4073$var$linear() {
    var scale = (0, $ce342f4f280b4073$var$_continuous.default)();
    scale.copy = function() {
        return (0, $ce342f4f280b4073$var$_continuous.copy)(scale, $ce342f4f280b4073$var$linear());
    };
    $dVAcc.initRange.apply(scale, arguments);
    return $ce342f4f280b4073$var$linearish(scale);
}

});
parcelRegister("aiVEG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $78084eee6fcde26c$var$copy;
module.exports.default = $78084eee6fcde26c$var$continuous;
module.exports.identity = $78084eee6fcde26c$var$identity;
module.exports.transformer = $78084eee6fcde26c$var$transformer;

var $k5p7I = parcelRequire("k5p7I");

var $asL1O = parcelRequire("asL1O");

var $78084eee6fcde26c$var$_constant = $78084eee6fcde26c$var$_interopRequireDefault((parcelRequire("cqkH3")));

var $78084eee6fcde26c$var$_number = $78084eee6fcde26c$var$_interopRequireDefault((parcelRequire("66OMX")));
function $78084eee6fcde26c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $78084eee6fcde26c$var$unit = [
    0,
    1
];
function $78084eee6fcde26c$var$identity(x) {
    return x;
}
function $78084eee6fcde26c$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $78084eee6fcde26c$var$_constant.default)(isNaN(b) ? NaN : 0.5);
}
function $78084eee6fcde26c$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
} // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $78084eee6fcde26c$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $78084eee6fcde26c$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $78084eee6fcde26c$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $78084eee6fcde26c$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1; // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $78084eee6fcde26c$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $k5p7I.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $78084eee6fcde26c$var$copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $78084eee6fcde26c$var$transformer() {
    var domain = $78084eee6fcde26c$var$unit, range = $78084eee6fcde26c$var$unit, interpolate = $asL1O.interpolate, transform, untransform, unknown, clamp = $78084eee6fcde26c$var$identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $78084eee6fcde26c$var$identity) clamp = $78084eee6fcde26c$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $78084eee6fcde26c$var$polymap : $78084eee6fcde26c$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), $asL1O.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, $78084eee6fcde26c$var$_number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = $asL1O.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $78084eee6fcde26c$var$identity, rescale()) : clamp !== $78084eee6fcde26c$var$identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $78084eee6fcde26c$var$continuous() {
    return $78084eee6fcde26c$var$transformer()($78084eee6fcde26c$var$identity, $78084eee6fcde26c$var$identity);
}

});
parcelRegister("asL1O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "interpolate", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_value.default;
    }
});
Object.defineProperty(module.exports, "interpolateArray", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_array.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasis", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelix", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_cubehelix.cubehelixLong;
    }
});
Object.defineProperty(module.exports, "interpolateDate", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_date.default;
    }
});
Object.defineProperty(module.exports, "interpolateDiscrete", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_discrete.default;
    }
});
Object.defineProperty(module.exports, "interpolateHcl", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_hcl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHclLong", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_hcl.hclLong;
    }
});
Object.defineProperty(module.exports, "interpolateHsl", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_hsl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHslLong", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_hsl.hslLong;
    }
});
Object.defineProperty(module.exports, "interpolateHue", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_hue.default;
    }
});
Object.defineProperty(module.exports, "interpolateLab", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumber", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_number.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumberArray", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_numberArray.default;
    }
});
Object.defineProperty(module.exports, "interpolateObject", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_object.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgb", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_rgb.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_rgb.rgbBasis;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_rgb.rgbBasisClosed;
    }
});
Object.defineProperty(module.exports, "interpolateRound", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_round.default;
    }
});
Object.defineProperty(module.exports, "interpolateString", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_string.default;
    }
});
Object.defineProperty(module.exports, "interpolateTransformCss", {
    enumerable: true,
    get: function() {
        return $gQqF8.interpolateTransformCss;
    }
});
Object.defineProperty(module.exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function() {
        return $gQqF8.interpolateTransformSvg;
    }
});
Object.defineProperty(module.exports, "interpolateZoom", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_zoom.default;
    }
});
Object.defineProperty(module.exports, "piecewise", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_piecewise.default;
    }
});
Object.defineProperty(module.exports, "quantize", {
    enumerable: true,
    get: function() {
        return $79e0ffbad0c465ce$var$_quantize.default;
    }
});

var $79e0ffbad0c465ce$var$_value = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("aQYao")));

var $79e0ffbad0c465ce$var$_array = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("c4KMz")));

var $79e0ffbad0c465ce$var$_basis = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("ezZsL")));

var $79e0ffbad0c465ce$var$_basisClosed = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("d2lJY")));

var $79e0ffbad0c465ce$var$_date = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("iyq1R")));

var $79e0ffbad0c465ce$var$_discrete = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("7oUoq")));

var $79e0ffbad0c465ce$var$_hue = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("71uY5")));

var $79e0ffbad0c465ce$var$_number = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("6PTwm")));

var $79e0ffbad0c465ce$var$_numberArray = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("ioONj")));

var $79e0ffbad0c465ce$var$_object = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("7dlFo")));

var $79e0ffbad0c465ce$var$_round = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("4MvlC")));

var $79e0ffbad0c465ce$var$_string = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("8AKoU")));

var $gQqF8 = parcelRequire("gQqF8");

var $79e0ffbad0c465ce$var$_zoom = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("5SD24")));

var $79e0ffbad0c465ce$var$_rgb = $79e0ffbad0c465ce$var$_interopRequireWildcard((parcelRequire("1fggl")));

var $79e0ffbad0c465ce$var$_hsl = $79e0ffbad0c465ce$var$_interopRequireWildcard((parcelRequire("giUqz")));

var $79e0ffbad0c465ce$var$_lab = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("l2CY2")));

var $79e0ffbad0c465ce$var$_hcl = $79e0ffbad0c465ce$var$_interopRequireWildcard((parcelRequire("SKV88")));

var $79e0ffbad0c465ce$var$_cubehelix = $79e0ffbad0c465ce$var$_interopRequireWildcard((parcelRequire("frD9h")));

var $79e0ffbad0c465ce$var$_piecewise = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("6DVQq")));

var $79e0ffbad0c465ce$var$_quantize = $79e0ffbad0c465ce$var$_interopRequireDefault((parcelRequire("deK3z")));
function $79e0ffbad0c465ce$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($79e0ffbad0c465ce$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $79e0ffbad0c465ce$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $79e0ffbad0c465ce$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $79e0ffbad0c465ce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("aQYao", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7e6d6e89b3f8ba29$var$_default;

var $fqfF4 = parcelRequire("fqfF4");

var $7e6d6e89b3f8ba29$var$_rgb = $7e6d6e89b3f8ba29$var$_interopRequireDefault((parcelRequire("1fggl")));

var $c4KMz = parcelRequire("c4KMz");

var $7e6d6e89b3f8ba29$var$_date = $7e6d6e89b3f8ba29$var$_interopRequireDefault((parcelRequire("iyq1R")));

var $7e6d6e89b3f8ba29$var$_number = $7e6d6e89b3f8ba29$var$_interopRequireDefault((parcelRequire("6PTwm")));

var $7e6d6e89b3f8ba29$var$_object = $7e6d6e89b3f8ba29$var$_interopRequireDefault((parcelRequire("7dlFo")));

var $7e6d6e89b3f8ba29$var$_string = $7e6d6e89b3f8ba29$var$_interopRequireDefault((parcelRequire("8AKoU")));

var $7e6d6e89b3f8ba29$var$_constant = $7e6d6e89b3f8ba29$var$_interopRequireDefault((parcelRequire("fHinc")));

var $7e6d6e89b3f8ba29$var$_numberArray = $7e6d6e89b3f8ba29$var$_interopRequireWildcard((parcelRequire("ioONj")));
function $7e6d6e89b3f8ba29$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($7e6d6e89b3f8ba29$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $7e6d6e89b3f8ba29$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $7e6d6e89b3f8ba29$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $7e6d6e89b3f8ba29$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7e6d6e89b3f8ba29$var$_default(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $7e6d6e89b3f8ba29$var$_constant.default)(b) : (t === "number" ? $7e6d6e89b3f8ba29$var$_number.default : t === "string" ? (c = (0, $fqfF4.color)(b)) ? (b = c, $7e6d6e89b3f8ba29$var$_rgb.default) : $7e6d6e89b3f8ba29$var$_string.default : b instanceof $fqfF4.color ? $7e6d6e89b3f8ba29$var$_rgb.default : b instanceof Date ? $7e6d6e89b3f8ba29$var$_date.default : (0, $7e6d6e89b3f8ba29$var$_numberArray.isNumberArray)(b) ? $7e6d6e89b3f8ba29$var$_numberArray.default : Array.isArray(b) ? $c4KMz.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? $7e6d6e89b3f8ba29$var$_object.default : $7e6d6e89b3f8ba29$var$_number.default)(a, b);
}

});
parcelRegister("fqfF4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "color", {
    enumerable: true,
    get: function() {
        return $02e5c3d9c0e069ee$var$_color.default;
    }
});
Object.defineProperty(module.exports, "cubehelix", {
    enumerable: true,
    get: function() {
        return $02e5c3d9c0e069ee$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "gray", {
    enumerable: true,
    get: function() {
        return $02e5c3d9c0e069ee$var$_lab.gray;
    }
});
Object.defineProperty(module.exports, "hcl", {
    enumerable: true,
    get: function() {
        return $02e5c3d9c0e069ee$var$_lab.hcl;
    }
});
Object.defineProperty(module.exports, "hsl", {
    enumerable: true,
    get: function() {
        return $02e5c3d9c0e069ee$var$_color.hsl;
    }
});
Object.defineProperty(module.exports, "lab", {
    enumerable: true,
    get: function() {
        return $02e5c3d9c0e069ee$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "lch", {
    enumerable: true,
    get: function() {
        return $02e5c3d9c0e069ee$var$_lab.lch;
    }
});
Object.defineProperty(module.exports, "rgb", {
    enumerable: true,
    get: function() {
        return $02e5c3d9c0e069ee$var$_color.rgb;
    }
});

var $02e5c3d9c0e069ee$var$_color = $02e5c3d9c0e069ee$var$_interopRequireWildcard((parcelRequire("fBwMw")));

var $02e5c3d9c0e069ee$var$_lab = $02e5c3d9c0e069ee$var$_interopRequireWildcard((parcelRequire("8bmD3")));

var $02e5c3d9c0e069ee$var$_cubehelix = $02e5c3d9c0e069ee$var$_interopRequireDefault((parcelRequire("e7YcQ")));
function $02e5c3d9c0e069ee$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $02e5c3d9c0e069ee$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($02e5c3d9c0e069ee$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $02e5c3d9c0e069ee$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $02e5c3d9c0e069ee$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("fBwMw", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Color = Color;
exports.Rgb = Rgb;
exports.darker = exports.brighter = void 0;
exports.default = color;
exports.hsl = hsl;
exports.hslConvert = hslConvert;
exports.rgb = rgb;
exports.rgbConvert = rgbConvert;

var _define = _interopRequireWildcard((parcelRequire("4P4QL")));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function Color() {}
var darker = 0.7;
exports.darker = darker;
var brighter = 1 / darker;
exports.brighter = brighter;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _define.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb();
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Rgb, rgb, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl();
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Hsl, hsl, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("4P4QL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $382faff515c79b7a$var$_default;
module.exports.extend = $382faff515c79b7a$var$extend;
function $382faff515c79b7a$var$_default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $382faff515c79b7a$var$extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("8bmD3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hcl = $5f50e76ecb168c5d$var$Hcl;
module.exports.Lab = $5f50e76ecb168c5d$var$Lab;
module.exports.default = $5f50e76ecb168c5d$var$lab;
module.exports.gray = $5f50e76ecb168c5d$var$gray;
module.exports.hcl = $5f50e76ecb168c5d$var$hcl;
module.exports.lch = $5f50e76ecb168c5d$var$lch;

var $5f50e76ecb168c5d$var$_define = $5f50e76ecb168c5d$var$_interopRequireWildcard((parcelRequire("4P4QL")));

var $fBwMw = parcelRequire("fBwMw");

var $gvcbX = parcelRequire("gvcbX");
function $5f50e76ecb168c5d$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($5f50e76ecb168c5d$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $5f50e76ecb168c5d$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $5f50e76ecb168c5d$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// https://observablehq.com/@mbostock/lab-and-rgb
const $5f50e76ecb168c5d$var$K = 18, $5f50e76ecb168c5d$var$Xn = 0.96422, $5f50e76ecb168c5d$var$Yn = 1, $5f50e76ecb168c5d$var$Zn = 0.82521, $5f50e76ecb168c5d$var$t0 = 4 / 29, $5f50e76ecb168c5d$var$t1 = 6 / 29, $5f50e76ecb168c5d$var$t2 = 3 * $5f50e76ecb168c5d$var$t1 * $5f50e76ecb168c5d$var$t1, $5f50e76ecb168c5d$var$t3 = $5f50e76ecb168c5d$var$t1 * $5f50e76ecb168c5d$var$t1 * $5f50e76ecb168c5d$var$t1;
function $5f50e76ecb168c5d$var$labConvert(o) {
    if (o instanceof $5f50e76ecb168c5d$var$Lab) return new $5f50e76ecb168c5d$var$Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof $5f50e76ecb168c5d$var$Hcl) return $5f50e76ecb168c5d$var$hcl2lab(o);
    if (!(o instanceof $fBwMw.Rgb)) o = (0, $fBwMw.rgbConvert)(o);
    var r = $5f50e76ecb168c5d$var$rgb2lrgb(o.r), g = $5f50e76ecb168c5d$var$rgb2lrgb(o.g), b = $5f50e76ecb168c5d$var$rgb2lrgb(o.b), y = $5f50e76ecb168c5d$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $5f50e76ecb168c5d$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $5f50e76ecb168c5d$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $5f50e76ecb168c5d$var$Xn);
        z = $5f50e76ecb168c5d$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $5f50e76ecb168c5d$var$Zn);
    }
    return new $5f50e76ecb168c5d$var$Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $5f50e76ecb168c5d$var$gray(l, opacity) {
    return new $5f50e76ecb168c5d$var$Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function $5f50e76ecb168c5d$var$lab(l, a, b, opacity) {
    return arguments.length === 1 ? $5f50e76ecb168c5d$var$labConvert(l) : new $5f50e76ecb168c5d$var$Lab(l, a, b, opacity == null ? 1 : opacity);
}
function $5f50e76ecb168c5d$var$Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $5f50e76ecb168c5d$var$_define.default)($5f50e76ecb168c5d$var$Lab, $5f50e76ecb168c5d$var$lab, (0, $5f50e76ecb168c5d$var$_define.extend)($fBwMw.Color, {
    brighter (k) {
        return new $5f50e76ecb168c5d$var$Lab(this.l + $5f50e76ecb168c5d$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $5f50e76ecb168c5d$var$Lab(this.l - $5f50e76ecb168c5d$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $5f50e76ecb168c5d$var$Xn * $5f50e76ecb168c5d$var$lab2xyz(x);
        y = $5f50e76ecb168c5d$var$Yn * $5f50e76ecb168c5d$var$lab2xyz(y);
        z = $5f50e76ecb168c5d$var$Zn * $5f50e76ecb168c5d$var$lab2xyz(z);
        return new $fBwMw.Rgb($5f50e76ecb168c5d$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $5f50e76ecb168c5d$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $5f50e76ecb168c5d$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $5f50e76ecb168c5d$var$xyz2lab(t) {
    return t > $5f50e76ecb168c5d$var$t3 ? Math.pow(t, 1 / 3) : t / $5f50e76ecb168c5d$var$t2 + $5f50e76ecb168c5d$var$t0;
}
function $5f50e76ecb168c5d$var$lab2xyz(t) {
    return t > $5f50e76ecb168c5d$var$t1 ? t * t * t : $5f50e76ecb168c5d$var$t2 * (t - $5f50e76ecb168c5d$var$t0);
}
function $5f50e76ecb168c5d$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $5f50e76ecb168c5d$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $5f50e76ecb168c5d$var$hclConvert(o) {
    if (o instanceof $5f50e76ecb168c5d$var$Hcl) return new $5f50e76ecb168c5d$var$Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $5f50e76ecb168c5d$var$Lab)) o = $5f50e76ecb168c5d$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $5f50e76ecb168c5d$var$Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * $gvcbX.degrees;
    return new $5f50e76ecb168c5d$var$Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $5f50e76ecb168c5d$var$lch(l, c, h, opacity) {
    return arguments.length === 1 ? $5f50e76ecb168c5d$var$hclConvert(l) : new $5f50e76ecb168c5d$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $5f50e76ecb168c5d$var$hcl(h, c, l, opacity) {
    return arguments.length === 1 ? $5f50e76ecb168c5d$var$hclConvert(h) : new $5f50e76ecb168c5d$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $5f50e76ecb168c5d$var$Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $5f50e76ecb168c5d$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $5f50e76ecb168c5d$var$Lab(o.l, 0, 0, o.opacity);
    var h = o.h * $gvcbX.radians;
    return new $5f50e76ecb168c5d$var$Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $5f50e76ecb168c5d$var$_define.default)($5f50e76ecb168c5d$var$Hcl, $5f50e76ecb168c5d$var$hcl, (0, $5f50e76ecb168c5d$var$_define.extend)($fBwMw.Color, {
    brighter (k) {
        return new $5f50e76ecb168c5d$var$Hcl(this.h, this.c, this.l + $5f50e76ecb168c5d$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $5f50e76ecb168c5d$var$Hcl(this.h, this.c, this.l - $5f50e76ecb168c5d$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $5f50e76ecb168c5d$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("gvcbX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.radians = module.exports.degrees = void 0;
const $c038ffa20e550349$var$radians = Math.PI / 180;
module.exports.radians = $c038ffa20e550349$var$radians;
const $c038ffa20e550349$var$degrees = 180 / Math.PI;
module.exports.degrees = $c038ffa20e550349$var$degrees;

});


parcelRegister("e7YcQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cubehelix = $a4906bcfd69c68e6$var$Cubehelix;
module.exports.default = $a4906bcfd69c68e6$var$cubehelix;

var $a4906bcfd69c68e6$var$_define = $a4906bcfd69c68e6$var$_interopRequireWildcard((parcelRequire("4P4QL")));

var $fBwMw = parcelRequire("fBwMw");

var $gvcbX = parcelRequire("gvcbX");
function $a4906bcfd69c68e6$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($a4906bcfd69c68e6$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $a4906bcfd69c68e6$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $a4906bcfd69c68e6$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $a4906bcfd69c68e6$var$A = -0.14861, $a4906bcfd69c68e6$var$B = 1.78277, $a4906bcfd69c68e6$var$C = -0.29227, $a4906bcfd69c68e6$var$D = -0.90649, $a4906bcfd69c68e6$var$E = 1.97294, $a4906bcfd69c68e6$var$ED = $a4906bcfd69c68e6$var$E * $a4906bcfd69c68e6$var$D, $a4906bcfd69c68e6$var$EB = $a4906bcfd69c68e6$var$E * $a4906bcfd69c68e6$var$B, $a4906bcfd69c68e6$var$BC_DA = $a4906bcfd69c68e6$var$B * $a4906bcfd69c68e6$var$C - $a4906bcfd69c68e6$var$D * $a4906bcfd69c68e6$var$A;
function $a4906bcfd69c68e6$var$cubehelixConvert(o) {
    if (o instanceof $a4906bcfd69c68e6$var$Cubehelix) return new $a4906bcfd69c68e6$var$Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $fBwMw.Rgb)) o = (0, $fBwMw.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($a4906bcfd69c68e6$var$BC_DA * b + $a4906bcfd69c68e6$var$ED * r - $a4906bcfd69c68e6$var$EB * g) / ($a4906bcfd69c68e6$var$BC_DA + $a4906bcfd69c68e6$var$ED - $a4906bcfd69c68e6$var$EB), bl = b - l, k = ($a4906bcfd69c68e6$var$E * (g - l) - $a4906bcfd69c68e6$var$C * bl) / $a4906bcfd69c68e6$var$D, s = Math.sqrt(k * k + bl * bl) / ($a4906bcfd69c68e6$var$E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * $gvcbX.degrees - 120 : NaN;
    return new $a4906bcfd69c68e6$var$Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $a4906bcfd69c68e6$var$cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? $a4906bcfd69c68e6$var$cubehelixConvert(h) : new $a4906bcfd69c68e6$var$Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function $a4906bcfd69c68e6$var$Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $a4906bcfd69c68e6$var$_define.default)($a4906bcfd69c68e6$var$Cubehelix, $a4906bcfd69c68e6$var$cubehelix, (0, $a4906bcfd69c68e6$var$_define.extend)($fBwMw.Color, {
    brighter (k) {
        k = k == null ? $fBwMw.brighter : Math.pow($fBwMw.brighter, k);
        return new $a4906bcfd69c68e6$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $fBwMw.darker : Math.pow($fBwMw.darker, k);
        return new $a4906bcfd69c68e6$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * $gvcbX.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new $fBwMw.Rgb(255 * (l + a * ($a4906bcfd69c68e6$var$A * cosh + $a4906bcfd69c68e6$var$B * sinh)), 255 * (l + a * ($a4906bcfd69c68e6$var$C * cosh + $a4906bcfd69c68e6$var$D * sinh)), 255 * (l + a * ($a4906bcfd69c68e6$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("1fggl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rgbBasisClosed = module.exports.rgbBasis = module.exports.default = void 0;

var $fqfF4 = parcelRequire("fqfF4");

var $0e83ce9100e93721$var$_basis = $0e83ce9100e93721$var$_interopRequireDefault((parcelRequire("ezZsL")));

var $0e83ce9100e93721$var$_basisClosed = $0e83ce9100e93721$var$_interopRequireDefault((parcelRequire("d2lJY")));

var $0e83ce9100e93721$var$_color = $0e83ce9100e93721$var$_interopRequireWildcard((parcelRequire("a2qj8")));
function $0e83ce9100e93721$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($0e83ce9100e93721$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $0e83ce9100e93721$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $0e83ce9100e93721$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $0e83ce9100e93721$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0e83ce9100e93721$var$_default = function rgbGamma(y) {
    var color = (0, $0e83ce9100e93721$var$_color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $fqfF4.rgb)(start)).r, (end = (0, $fqfF4.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $0e83ce9100e93721$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
module.exports.default = $0e83ce9100e93721$var$_default;
function $0e83ce9100e93721$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $fqfF4.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $0e83ce9100e93721$var$rgbBasis = $0e83ce9100e93721$var$rgbSpline($0e83ce9100e93721$var$_basis.default);
module.exports.rgbBasis = $0e83ce9100e93721$var$rgbBasis;
var $0e83ce9100e93721$var$rgbBasisClosed = $0e83ce9100e93721$var$rgbSpline($0e83ce9100e93721$var$_basisClosed.default);
module.exports.rgbBasisClosed = $0e83ce9100e93721$var$rgbBasisClosed;

});
parcelRegister("ezZsL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.basis = $a9d402d3c456627a$var$basis;
module.exports.default = $a9d402d3c456627a$var$_default;
function $a9d402d3c456627a$var$basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $a9d402d3c456627a$var$_default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $a9d402d3c456627a$var$basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("d2lJY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $97dc537ab71e269f$var$_default;

var $ezZsL = parcelRequire("ezZsL");
function $97dc537ab71e269f$var$_default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $ezZsL.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("a2qj8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $74ee7f740b85be57$var$nogamma;
module.exports.gamma = $74ee7f740b85be57$var$gamma;
module.exports.hue = $74ee7f740b85be57$var$hue;

var $74ee7f740b85be57$var$_constant = $74ee7f740b85be57$var$_interopRequireDefault((parcelRequire("fHinc")));
function $74ee7f740b85be57$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $74ee7f740b85be57$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $74ee7f740b85be57$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $74ee7f740b85be57$var$hue(a, b) {
    var d = b - a;
    return d ? $74ee7f740b85be57$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $74ee7f740b85be57$var$_constant.default)(isNaN(a) ? b : a);
}
function $74ee7f740b85be57$var$gamma(y) {
    return (y = +y) === 1 ? $74ee7f740b85be57$var$nogamma : function(a, b) {
        return b - a ? $74ee7f740b85be57$var$exponential(a, b, y) : (0, $74ee7f740b85be57$var$_constant.default)(isNaN(a) ? b : a);
    };
}
function $74ee7f740b85be57$var$nogamma(a, b) {
    var d = b - a;
    return d ? $74ee7f740b85be57$var$linear(a, d) : (0, $74ee7f740b85be57$var$_constant.default)(isNaN(a) ? b : a);
}

});
parcelRegister("fHinc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $b6d91fb02510ebba$var$_default = (x)=>()=>x;
module.exports.default = $b6d91fb02510ebba$var$_default;

});



parcelRegister("c4KMz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8caa25ca1fb345f4$var$_default;
module.exports.genericArray = $8caa25ca1fb345f4$var$genericArray;

var $8caa25ca1fb345f4$var$_value = $8caa25ca1fb345f4$var$_interopRequireDefault((parcelRequire("aQYao")));

var $8caa25ca1fb345f4$var$_numberArray = $8caa25ca1fb345f4$var$_interopRequireWildcard((parcelRequire("ioONj")));
function $8caa25ca1fb345f4$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8caa25ca1fb345f4$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8caa25ca1fb345f4$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8caa25ca1fb345f4$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8caa25ca1fb345f4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8caa25ca1fb345f4$var$_default(a, b) {
    return ((0, $8caa25ca1fb345f4$var$_numberArray.isNumberArray)(b) ? $8caa25ca1fb345f4$var$_numberArray.default : $8caa25ca1fb345f4$var$genericArray)(a, b);
}
function $8caa25ca1fb345f4$var$genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $8caa25ca1fb345f4$var$_value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("ioONj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d651de931eb8616f$var$_default;
module.exports.isNumberArray = $d651de931eb8616f$var$isNumberArray;
function $d651de931eb8616f$var$_default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $d651de931eb8616f$var$isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("iyq1R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d81f97c4c18ce18a$var$_default;
function $d81f97c4c18ce18a$var$_default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("6PTwm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4fa292cfa1685f7a$var$_default;
function $4fa292cfa1685f7a$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("7dlFo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $540a8ddd0d79ad30$var$_default;

var $540a8ddd0d79ad30$var$_value = $540a8ddd0d79ad30$var$_interopRequireDefault((parcelRequire("aQYao")));
function $540a8ddd0d79ad30$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $540a8ddd0d79ad30$var$_default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $540a8ddd0d79ad30$var$_value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("8AKoU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6415adc11dbe5d5b$var$_default;

var $6415adc11dbe5d5b$var$_number = $6415adc11dbe5d5b$var$_interopRequireDefault((parcelRequire("6PTwm")));
function $6415adc11dbe5d5b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6415adc11dbe5d5b$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $6415adc11dbe5d5b$var$reB = new RegExp($6415adc11dbe5d5b$var$reA.source, "g");
function $6415adc11dbe5d5b$var$zero(b) {
    return function() {
        return b;
    };
}
function $6415adc11dbe5d5b$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $6415adc11dbe5d5b$var$_default(a, b) {
    var bi = $6415adc11dbe5d5b$var$reA.lastIndex = $6415adc11dbe5d5b$var$reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.
    while((am = $6415adc11dbe5d5b$var$reA.exec(a)) && (bm = $6415adc11dbe5d5b$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $6415adc11dbe5d5b$var$_number.default)(am, bm)
            });
        }
        bi = $6415adc11dbe5d5b$var$reB.lastIndex;
    } // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    } // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $6415adc11dbe5d5b$var$one(q[0].x) : $6415adc11dbe5d5b$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("7oUoq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $563684c591961a4d$var$_default;
function $563684c591961a4d$var$_default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRegister("71uY5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $51d0a601e41fca5c$var$_default;

var $a2qj8 = parcelRequire("a2qj8");
function $51d0a601e41fca5c$var$_default(a, b) {
    var i = (0, $a2qj8.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRegister("4MvlC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $37b3f61e3707e37c$var$_default;
function $37b3f61e3707e37c$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("gQqF8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTransformSvg = module.exports.interpolateTransformCss = void 0;

var $c4362f4b224bcba9$var$_number = $c4362f4b224bcba9$var$_interopRequireDefault((parcelRequire("6PTwm")));

var $hd2Dk = parcelRequire("hd2Dk");
function $c4362f4b224bcba9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c4362f4b224bcba9$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $c4362f4b224bcba9$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $c4362f4b224bcba9$var$_number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $c4362f4b224bcba9$var$_number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $c4362f4b224bcba9$var$_number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $c4362f4b224bcba9$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $c4362f4b224bcba9$var$_number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $c4362f4b224bcba9$var$interpolateTransformCss = $c4362f4b224bcba9$var$interpolateTransform($hd2Dk.parseCss, "px, ", "px)", "deg)");
module.exports.interpolateTransformCss = $c4362f4b224bcba9$var$interpolateTransformCss;
var $c4362f4b224bcba9$var$interpolateTransformSvg = $c4362f4b224bcba9$var$interpolateTransform($hd2Dk.parseSvg, ", ", ")", ")");
module.exports.interpolateTransformSvg = $c4362f4b224bcba9$var$interpolateTransformSvg;

});
parcelRegister("hd2Dk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCss = $c875b1824016711e$var$parseCss;
module.exports.parseSvg = $c875b1824016711e$var$parseSvg;

var $c875b1824016711e$var$_decompose = $c875b1824016711e$var$_interopRequireWildcard((parcelRequire("gepHo")));
function $c875b1824016711e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c875b1824016711e$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c875b1824016711e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c875b1824016711e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $c875b1824016711e$var$svgNode;
/* eslint-disable no-undef */ function $c875b1824016711e$var$parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? $c875b1824016711e$var$_decompose.identity : (0, $c875b1824016711e$var$_decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $c875b1824016711e$var$parseSvg(value) {
    if (value == null) return $c875b1824016711e$var$_decompose.identity;
    if (!$c875b1824016711e$var$svgNode) $c875b1824016711e$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $c875b1824016711e$var$svgNode.setAttribute("transform", value);
    if (!(value = $c875b1824016711e$var$svgNode.transform.baseVal.consolidate())) return $c875b1824016711e$var$_decompose.identity;
    value = value.matrix;
    return (0, $c875b1824016711e$var$_decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("gepHo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bd11e36d3ab0dc05$var$_default;
module.exports.identity = void 0;
var $bd11e36d3ab0dc05$var$degrees = 180 / Math.PI;
var $bd11e36d3ab0dc05$var$identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
module.exports.identity = $bd11e36d3ab0dc05$var$identity;
function $bd11e36d3ab0dc05$var$_default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $bd11e36d3ab0dc05$var$degrees,
        skewX: Math.atan(skewX) * $bd11e36d3ab0dc05$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("5SD24", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $448045e8872f9858$var$epsilon2 = 1e-12;
function $448045e8872f9858$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $448045e8872f9858$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $448045e8872f9858$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $448045e8872f9858$var$_default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S; // Special case for u0 ≅ u1.
        if (d2 < $448045e8872f9858$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $448045e8872f9858$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $448045e8872f9858$var$tanh(rho * s + r0) - $448045e8872f9858$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $448045e8872f9858$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);
module.exports.default = $448045e8872f9858$var$_default;

});

parcelRegister("giUqz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hslLong = module.exports.default = void 0;

var $fqfF4 = parcelRequire("fqfF4");

var $bdea191d5613e178$var$_color = $bdea191d5613e178$var$_interopRequireWildcard((parcelRequire("a2qj8")));
function $bdea191d5613e178$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($bdea191d5613e178$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $bdea191d5613e178$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $bdea191d5613e178$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $bdea191d5613e178$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $fqfF4.hsl)(start)).h, (end = (0, $fqfF4.hsl)(end)).h), s = (0, $bdea191d5613e178$var$_color.default)(start.s, end.s), l = (0, $bdea191d5613e178$var$_color.default)(start.l, end.l), opacity = (0, $bdea191d5613e178$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $bdea191d5613e178$var$_default = $bdea191d5613e178$var$hsl($bdea191d5613e178$var$_color.hue);
module.exports.default = $bdea191d5613e178$var$_default;
var $bdea191d5613e178$var$hslLong = $bdea191d5613e178$var$hsl($bdea191d5613e178$var$_color.default);
module.exports.hslLong = $bdea191d5613e178$var$hslLong;

});

parcelRegister("l2CY2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f51802fcabb23955$var$lab;

var $fqfF4 = parcelRequire("fqfF4");

var $f51802fcabb23955$var$_color = $f51802fcabb23955$var$_interopRequireDefault((parcelRequire("a2qj8")));
function $f51802fcabb23955$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f51802fcabb23955$var$lab(start, end) {
    var l = (0, $f51802fcabb23955$var$_color.default)((start = (0, $fqfF4.lab)(start)).l, (end = (0, $fqfF4.lab)(end)).l), a = (0, $f51802fcabb23955$var$_color.default)(start.a, end.a), b = (0, $f51802fcabb23955$var$_color.default)(start.b, end.b), opacity = (0, $f51802fcabb23955$var$_color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRegister("SKV88", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hclLong = module.exports.default = void 0;

var $fqfF4 = parcelRequire("fqfF4");

var $0a4970af5e834e88$var$_color = $0a4970af5e834e88$var$_interopRequireWildcard((parcelRequire("a2qj8")));
function $0a4970af5e834e88$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($0a4970af5e834e88$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $0a4970af5e834e88$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $0a4970af5e834e88$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $0a4970af5e834e88$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $fqfF4.hcl)(start)).h, (end = (0, $fqfF4.hcl)(end)).h), c = (0, $0a4970af5e834e88$var$_color.default)(start.c, end.c), l = (0, $0a4970af5e834e88$var$_color.default)(start.l, end.l), opacity = (0, $0a4970af5e834e88$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $0a4970af5e834e88$var$_default = $0a4970af5e834e88$var$hcl($0a4970af5e834e88$var$_color.hue);
module.exports.default = $0a4970af5e834e88$var$_default;
var $0a4970af5e834e88$var$hclLong = $0a4970af5e834e88$var$hcl($0a4970af5e834e88$var$_color.default);
module.exports.hclLong = $0a4970af5e834e88$var$hclLong;

});

parcelRegister("frD9h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.cubehelixLong = void 0;

var $fqfF4 = parcelRequire("fqfF4");

var $b3e7bebf07490885$var$_color = $b3e7bebf07490885$var$_interopRequireWildcard((parcelRequire("a2qj8")));
function $b3e7bebf07490885$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($b3e7bebf07490885$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $b3e7bebf07490885$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $b3e7bebf07490885$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $b3e7bebf07490885$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $fqfF4.cubehelix)(start)).h, (end = (0, $fqfF4.cubehelix)(end)).h), s = (0, $b3e7bebf07490885$var$_color.default)(start.s, end.s), l = (0, $b3e7bebf07490885$var$_color.default)(start.l, end.l), opacity = (0, $b3e7bebf07490885$var$_color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $b3e7bebf07490885$var$_default = $b3e7bebf07490885$var$cubehelix($b3e7bebf07490885$var$_color.hue);
module.exports.default = $b3e7bebf07490885$var$_default;
var $b3e7bebf07490885$var$cubehelixLong = $b3e7bebf07490885$var$cubehelix($b3e7bebf07490885$var$_color.default);
module.exports.cubehelixLong = $b3e7bebf07490885$var$cubehelixLong;

});

parcelRegister("6DVQq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4d634155e0f68c2c$var$piecewise;

var $4d634155e0f68c2c$var$_value = $4d634155e0f68c2c$var$_interopRequireDefault((parcelRequire("aQYao")));
function $4d634155e0f68c2c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4d634155e0f68c2c$var$piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = $4d634155e0f68c2c$var$_value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRegister("deK3z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9a304f0854fc30b1$var$_default;
function $9a304f0854fc30b1$var$_default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRegister("cqkH3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $90b7f705a2031463$var$constants;
function $90b7f705a2031463$var$constants(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("66OMX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $472ab334b6bbafb2$var$number;
function $472ab334b6bbafb2$var$number(x) {
    return +x;
}

});


parcelRegister("kkpqj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ecc9657ae29c5d96$var$tickFormat;

var $k5p7I = parcelRequire("k5p7I");

var $8IRyN = parcelRequire("8IRyN");
function $ecc9657ae29c5d96$var$tickFormat(start, stop, count, specifier) {
    var step = (0, $k5p7I.tickStep)(start, stop, count), precision;
    specifier = (0, $8IRyN.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $8IRyN.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, $8IRyN.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $8IRyN.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $8IRyN.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $8IRyN.format)(specifier);
}

});
parcelRegister("8IRyN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "FormatSpecifier", {
    enumerable: true,
    get: function() {
        return $659bfab6ed69b083$var$_formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(module.exports, "format", {
    enumerable: true,
    get: function() {
        return $659bfab6ed69b083$var$_defaultLocale.format;
    }
});
Object.defineProperty(module.exports, "formatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $659bfab6ed69b083$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "formatLocale", {
    enumerable: true,
    get: function() {
        return $659bfab6ed69b083$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "formatPrefix", {
    enumerable: true,
    get: function() {
        return $659bfab6ed69b083$var$_defaultLocale.formatPrefix;
    }
});
Object.defineProperty(module.exports, "formatSpecifier", {
    enumerable: true,
    get: function() {
        return $659bfab6ed69b083$var$_formatSpecifier.default;
    }
});
Object.defineProperty(module.exports, "precisionFixed", {
    enumerable: true,
    get: function() {
        return $659bfab6ed69b083$var$_precisionFixed.default;
    }
});
Object.defineProperty(module.exports, "precisionPrefix", {
    enumerable: true,
    get: function() {
        return $659bfab6ed69b083$var$_precisionPrefix.default;
    }
});
Object.defineProperty(module.exports, "precisionRound", {
    enumerable: true,
    get: function() {
        return $659bfab6ed69b083$var$_precisionRound.default;
    }
});

var $659bfab6ed69b083$var$_defaultLocale = $659bfab6ed69b083$var$_interopRequireWildcard((parcelRequire("fhPvr")));

var $659bfab6ed69b083$var$_locale = $659bfab6ed69b083$var$_interopRequireDefault((parcelRequire("6M7wL")));

var $659bfab6ed69b083$var$_formatSpecifier = $659bfab6ed69b083$var$_interopRequireWildcard((parcelRequire("l0Bnb")));

var $659bfab6ed69b083$var$_precisionFixed = $659bfab6ed69b083$var$_interopRequireDefault((parcelRequire("2vC31")));

var $659bfab6ed69b083$var$_precisionPrefix = $659bfab6ed69b083$var$_interopRequireDefault((parcelRequire("599TG")));

var $659bfab6ed69b083$var$_precisionRound = $659bfab6ed69b083$var$_interopRequireDefault((parcelRequire("9ldvR")));
function $659bfab6ed69b083$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $659bfab6ed69b083$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($659bfab6ed69b083$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $659bfab6ed69b083$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $659bfab6ed69b083$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("fhPvr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b21065954b90c70f$var$defaultLocale;
module.exports.formatPrefix = module.exports.format = void 0;

var $b21065954b90c70f$var$_locale = $b21065954b90c70f$var$_interopRequireDefault((parcelRequire("6M7wL")));
function $b21065954b90c70f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b21065954b90c70f$var$locale;
var $b21065954b90c70f$var$format;
module.exports.format = $b21065954b90c70f$var$format;
var $b21065954b90c70f$var$formatPrefix;
module.exports.formatPrefix = $b21065954b90c70f$var$formatPrefix;
$b21065954b90c70f$var$defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $b21065954b90c70f$var$defaultLocale(definition) {
    $b21065954b90c70f$var$locale = (0, $b21065954b90c70f$var$_locale.default)(definition);
    module.exports.format = $b21065954b90c70f$var$format = $b21065954b90c70f$var$locale.format;
    module.exports.formatPrefix = $b21065954b90c70f$var$formatPrefix = $b21065954b90c70f$var$locale.formatPrefix;
    return $b21065954b90c70f$var$locale;
}

});
parcelRegister("6M7wL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4eed10961416700f$var$_default;

var $4eed10961416700f$var$_exponent = $4eed10961416700f$var$_interopRequireDefault((parcelRequire("bCTYq")));

var $4eed10961416700f$var$_formatGroup = $4eed10961416700f$var$_interopRequireDefault((parcelRequire("afjzp")));

var $4eed10961416700f$var$_formatNumerals = $4eed10961416700f$var$_interopRequireDefault((parcelRequire("jcQm2")));

var $4eed10961416700f$var$_formatSpecifier = $4eed10961416700f$var$_interopRequireDefault((parcelRequire("l0Bnb")));

var $4eed10961416700f$var$_formatTrim = $4eed10961416700f$var$_interopRequireDefault((parcelRequire("2z1OO")));

var $4eed10961416700f$var$_formatTypes = $4eed10961416700f$var$_interopRequireDefault((parcelRequire("quRiu")));

var $2joex = parcelRequire("2joex");

var $4eed10961416700f$var$_identity = $4eed10961416700f$var$_interopRequireDefault((parcelRequire("5sMvb")));
function $4eed10961416700f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4eed10961416700f$var$map = Array.prototype.map, $4eed10961416700f$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $4eed10961416700f$var$_default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? $4eed10961416700f$var$_identity.default : (0, $4eed10961416700f$var$_formatGroup.default)($4eed10961416700f$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? $4eed10961416700f$var$_identity.default : (0, $4eed10961416700f$var$_formatNumerals.default)($4eed10961416700f$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $4eed10961416700f$var$_formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type; // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g"; // The "" type, and any invalid type, is an alias for ".12~g".
        else if (!$4eed10961416700f$var$_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g"; // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "="; // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : ""; // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = $4eed10961416700f$var$_formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type); // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value; // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0; // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision); // Trim insignificant zeros.
                if (trim) value = (0, $4eed10961416700f$var$_formatTrim.default)(value); // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false; // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $4eed10961416700f$var$prefixes[8 + $2joex.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : ""); // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            } // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity); // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : ""; // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = ""; // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $4eed10961416700f$var$_formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $4eed10961416700f$var$_exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $4eed10961416700f$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("bCTYq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $876ea97cfbf829c9$var$_default;

var $3pHAx = parcelRequire("3pHAx");
function $876ea97cfbf829c9$var$_default(x) {
    return x = (0, $3pHAx.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("3pHAx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $27c5849fd7d04816$var$_default;
module.exports.formatDecimalParts = $27c5849fd7d04816$var$formatDecimalParts;
function $27c5849fd7d04816$var$_default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
} // Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function $27c5849fd7d04816$var$formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i); // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("afjzp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $775a7c4f5d32743d$var$_default;
function $775a7c4f5d32743d$var$_default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("jcQm2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $039bbce674a387a9$var$_default;
function $039bbce674a387a9$var$_default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("l0Bnb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatSpecifier = $f4b6968f0048d612$var$FormatSpecifier;
module.exports.default = $f4b6968f0048d612$var$formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $f4b6968f0048d612$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $f4b6968f0048d612$var$formatSpecifier(specifier) {
    if (!(match = $f4b6968f0048d612$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $f4b6968f0048d612$var$FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$f4b6968f0048d612$var$formatSpecifier.prototype = $f4b6968f0048d612$var$FormatSpecifier.prototype; // instanceof
function $f4b6968f0048d612$var$FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$f4b6968f0048d612$var$FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("2z1OO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1de042cb5305a1fe$var$_default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $1de042cb5305a1fe$var$_default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("quRiu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04fa5db44b79c391$var$_formatDecimal = $04fa5db44b79c391$var$_interopRequireDefault((parcelRequire("3pHAx")));

var $04fa5db44b79c391$var$_formatPrefixAuto = $04fa5db44b79c391$var$_interopRequireDefault((parcelRequire("2joex")));

var $04fa5db44b79c391$var$_formatRounded = $04fa5db44b79c391$var$_interopRequireDefault((parcelRequire("6TuYM")));
function $04fa5db44b79c391$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $04fa5db44b79c391$var$_default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": $04fa5db44b79c391$var$_formatDecimal.default,
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $04fa5db44b79c391$var$_formatRounded.default)(x * 100, p),
    "r": $04fa5db44b79c391$var$_formatRounded.default,
    "s": $04fa5db44b79c391$var$_formatPrefixAuto.default,
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};
module.exports.default = $04fa5db44b79c391$var$_default;

});
parcelRegister("2joex", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1af027689f1bf4c5$var$_default;
module.exports.prefixExponent = void 0;

var $3pHAx = parcelRequire("3pHAx");
var $1af027689f1bf4c5$var$prefixExponent;
module.exports.prefixExponent = $1af027689f1bf4c5$var$prefixExponent;
function $1af027689f1bf4c5$var$_default(x, p) {
    var d = (0, $3pHAx.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (module.exports.prefixExponent = $1af027689f1bf4c5$var$prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $3pHAx.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("6TuYM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $504fe900bbbc2bc1$var$_default;

var $3pHAx = parcelRequire("3pHAx");
function $504fe900bbbc2bc1$var$_default(x, p) {
    var d = (0, $3pHAx.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("5sMvb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3fa530becec8abeb$var$_default;
function $3fa530becec8abeb$var$_default(x) {
    return x;
}

});



parcelRegister("2vC31", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1d3bfd7f25169481$var$_default;

var $1d3bfd7f25169481$var$_exponent = $1d3bfd7f25169481$var$_interopRequireDefault((parcelRequire("bCTYq")));
function $1d3bfd7f25169481$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1d3bfd7f25169481$var$_default(step) {
    return Math.max(0, -(0, $1d3bfd7f25169481$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("599TG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3bf5785eeadb41d3$var$_default;

var $3bf5785eeadb41d3$var$_exponent = $3bf5785eeadb41d3$var$_interopRequireDefault((parcelRequire("bCTYq")));
function $3bf5785eeadb41d3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3bf5785eeadb41d3$var$_default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $3bf5785eeadb41d3$var$_exponent.default)(value) / 3))) * 3 - (0, $3bf5785eeadb41d3$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("9ldvR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6cd08e97b56d36d7$var$_default;

var $6cd08e97b56d36d7$var$_exponent = $6cd08e97b56d36d7$var$_interopRequireDefault((parcelRequire("bCTYq")));
function $6cd08e97b56d36d7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6cd08e97b56d36d7$var$_default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $6cd08e97b56d36d7$var$_exponent.default)(max) - (0, $6cd08e97b56d36d7$var$_exponent.default)(step)) + 1;
}

});





parcelRegister("jdUqB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dfeb00a4a69ec5d6$var$log;
module.exports.loggish = $dfeb00a4a69ec5d6$var$loggish;

var $k5p7I = parcelRequire("k5p7I");

var $8IRyN = parcelRequire("8IRyN");

var $dfeb00a4a69ec5d6$var$_nice = $dfeb00a4a69ec5d6$var$_interopRequireDefault((parcelRequire("2xas7")));

var $aiVEG = parcelRequire("aiVEG");

var $dVAcc = parcelRequire("dVAcc");
function $dfeb00a4a69ec5d6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dfeb00a4a69ec5d6$var$transformLog(x) {
    return Math.log(x);
}
function $dfeb00a4a69ec5d6$var$transformExp(x) {
    return Math.exp(x);
}
function $dfeb00a4a69ec5d6$var$transformLogn(x) {
    return -Math.log(-x);
}
function $dfeb00a4a69ec5d6$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $dfeb00a4a69ec5d6$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $dfeb00a4a69ec5d6$var$powp(base) {
    return base === 10 ? $dfeb00a4a69ec5d6$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $dfeb00a4a69ec5d6$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $dfeb00a4a69ec5d6$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $dfeb00a4a69ec5d6$var$loggish(transform) {
    const scale = transform($dfeb00a4a69ec5d6$var$transformLog, $dfeb00a4a69ec5d6$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $dfeb00a4a69ec5d6$var$logp(base), pows = $dfeb00a4a69ec5d6$var$powp(base);
        if (domain()[0] < 0) {
            logs = $dfeb00a4a69ec5d6$var$reflect(logs), pows = $dfeb00a4a69ec5d6$var$reflect(pows);
            transform($dfeb00a4a69ec5d6$var$transformLogn, $dfeb00a4a69ec5d6$var$transformExpn);
        } else transform($dfeb00a4a69ec5d6$var$transformLog, $dfeb00a4a69ec5d6$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $k5p7I.ticks)(u, v, n);
        } else z = (0, $k5p7I.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $8IRyN.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $8IRyN.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $dfeb00a4a69ec5d6$var$_nice.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $dfeb00a4a69ec5d6$var$log() {
    const scale = $dfeb00a4a69ec5d6$var$loggish((0, $aiVEG.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $aiVEG.copy)(scale, $dfeb00a4a69ec5d6$var$log()).base(scale.base());
    $dVAcc.initRange.apply(scale, arguments);
    return scale;
}

});
parcelRegister("2xas7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1d86c57d8457bae5$var$nice;
function $1d86c57d8457bae5$var$nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("glCnt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $be6c607d03b65299$var$symlog;
module.exports.symlogish = $be6c607d03b65299$var$symlogish;

var $hHCkv = parcelRequire("hHCkv");

var $aiVEG = parcelRequire("aiVEG");

var $dVAcc = parcelRequire("dVAcc");
function $be6c607d03b65299$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $be6c607d03b65299$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $be6c607d03b65299$var$symlogish(transform) {
    var c = 1, scale = transform($be6c607d03b65299$var$transformSymlog(c), $be6c607d03b65299$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($be6c607d03b65299$var$transformSymlog(c = +_), $be6c607d03b65299$var$transformSymexp(c)) : c;
    };
    return (0, $hHCkv.linearish)(scale);
}
function $be6c607d03b65299$var$symlog() {
    var scale = $be6c607d03b65299$var$symlogish((0, $aiVEG.transformer)());
    scale.copy = function() {
        return (0, $aiVEG.copy)(scale, $be6c607d03b65299$var$symlog()).constant(scale.constant());
    };
    return $dVAcc.initRange.apply(scale, arguments);
}

});

parcelRegister("9R4Yk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $01da03ccd9a0cf94$var$pow;
module.exports.powish = $01da03ccd9a0cf94$var$powish;
module.exports.sqrt = $01da03ccd9a0cf94$var$sqrt;

var $hHCkv = parcelRequire("hHCkv");

var $aiVEG = parcelRequire("aiVEG");

var $dVAcc = parcelRequire("dVAcc");
function $01da03ccd9a0cf94$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $01da03ccd9a0cf94$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $01da03ccd9a0cf94$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $01da03ccd9a0cf94$var$powish(transform) {
    var scale = transform($aiVEG.identity, $aiVEG.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform($aiVEG.identity, $aiVEG.identity) : exponent === 0.5 ? transform($01da03ccd9a0cf94$var$transformSqrt, $01da03ccd9a0cf94$var$transformSquare) : transform($01da03ccd9a0cf94$var$transformPow(exponent), $01da03ccd9a0cf94$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $hHCkv.linearish)(scale);
}
function $01da03ccd9a0cf94$var$pow() {
    var scale = $01da03ccd9a0cf94$var$powish((0, $aiVEG.transformer)());
    scale.copy = function() {
        return (0, $aiVEG.copy)(scale, $01da03ccd9a0cf94$var$pow()).exponent(scale.exponent());
    };
    $dVAcc.initRange.apply(scale, arguments);
    return scale;
}
function $01da03ccd9a0cf94$var$sqrt() {
    return $01da03ccd9a0cf94$var$pow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("iDRGP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d9258432786682eb$var$radial;

var $d9258432786682eb$var$_continuous = $d9258432786682eb$var$_interopRequireDefault((parcelRequire("aiVEG")));

var $dVAcc = parcelRequire("dVAcc");

var $hHCkv = parcelRequire("hHCkv");

var $d9258432786682eb$var$_number = $d9258432786682eb$var$_interopRequireDefault((parcelRequire("66OMX")));
function $d9258432786682eb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d9258432786682eb$var$square(x) {
    return Math.sign(x) * x * x;
}
function $d9258432786682eb$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $d9258432786682eb$var$radial() {
    var squared = (0, $d9258432786682eb$var$_continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $d9258432786682eb$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($d9258432786682eb$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, $d9258432786682eb$var$_number.default)).map($d9258432786682eb$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $d9258432786682eb$var$radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    $dVAcc.initRange.apply(scale, arguments);
    return (0, $hHCkv.linearish)(scale);
}

});

parcelRegister("iYUPw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dd19e9db56024c62$var$quantile;

var $k5p7I = parcelRequire("k5p7I");

var $dVAcc = parcelRequire("dVAcc");
function $dd19e9db56024c62$var$quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $k5p7I.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $k5p7I.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($k5p7I.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $dd19e9db56024c62$var$quantile().domain(domain).range(range).unknown(unknown);
    };
    return $dVAcc.initRange.apply(scale, arguments);
}

});

parcelRegister("c6un6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8cfd9abe096a5b49$var$quantize;

var $k5p7I = parcelRequire("k5p7I");

var $hHCkv = parcelRequire("hHCkv");

var $dVAcc = parcelRequire("dVAcc");
function $8cfd9abe096a5b49$var$quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $k5p7I.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $8cfd9abe096a5b49$var$quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return $dVAcc.initRange.apply((0, $hHCkv.linearish)(scale), arguments);
}

});

parcelRegister("oBu3L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $049f51839723afd2$var$threshold;

var $k5p7I = parcelRequire("k5p7I");

var $dVAcc = parcelRequire("dVAcc");
function $049f51839723afd2$var$threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $k5p7I.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $049f51839723afd2$var$threshold().domain(domain).range(range).unknown(unknown);
    };
    return $dVAcc.initRange.apply(scale, arguments);
}

});

parcelRegister("lze8j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calendar = $fb37d469c84fee4a$var$calendar;
module.exports.default = $fb37d469c84fee4a$var$time;

var $a7jHS = parcelRequire("a7jHS");

var $abRJC = parcelRequire("abRJC");

var $fb37d469c84fee4a$var$_continuous = $fb37d469c84fee4a$var$_interopRequireWildcard((parcelRequire("aiVEG")));

var $dVAcc = parcelRequire("dVAcc");

var $fb37d469c84fee4a$var$_nice = $fb37d469c84fee4a$var$_interopRequireDefault((parcelRequire("2xas7")));
function $fb37d469c84fee4a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fb37d469c84fee4a$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($fb37d469c84fee4a$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $fb37d469c84fee4a$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $fb37d469c84fee4a$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $fb37d469c84fee4a$var$date(t) {
    return new Date(t);
}
function $fb37d469c84fee4a$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $fb37d469c84fee4a$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $fb37d469c84fee4a$var$_continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $fb37d469c84fee4a$var$number)) : domain().map($fb37d469c84fee4a$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $fb37d469c84fee4a$var$_nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $fb37d469c84fee4a$var$_continuous.copy)(scale, $fb37d469c84fee4a$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $fb37d469c84fee4a$var$time() {
    return $dVAcc.initRange.apply($fb37d469c84fee4a$var$calendar($a7jHS.timeTicks, $a7jHS.timeTickInterval, $a7jHS.timeYear, $a7jHS.timeMonth, $a7jHS.timeWeek, $a7jHS.timeDay, $a7jHS.timeHour, $a7jHS.timeMinute, $a7jHS.timeSecond, $abRJC.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("a7jHS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "timeDay", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_day.default;
    }
});
Object.defineProperty(module.exports, "timeDays", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_day.days;
    }
});
Object.defineProperty(module.exports, "timeFriday", {
    enumerable: true,
    get: function() {
        return $2K514.friday;
    }
});
Object.defineProperty(module.exports, "timeFridays", {
    enumerable: true,
    get: function() {
        return $2K514.fridays;
    }
});
Object.defineProperty(module.exports, "timeHour", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_hour.default;
    }
});
Object.defineProperty(module.exports, "timeHours", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_hour.hours;
    }
});
Object.defineProperty(module.exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_interval.default;
    }
});
Object.defineProperty(module.exports, "timeMillisecond", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "timeMilliseconds", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "timeMinute", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_minute.default;
    }
});
Object.defineProperty(module.exports, "timeMinutes", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_minute.minutes;
    }
});
Object.defineProperty(module.exports, "timeMonday", {
    enumerable: true,
    get: function() {
        return $2K514.monday;
    }
});
Object.defineProperty(module.exports, "timeMondays", {
    enumerable: true,
    get: function() {
        return $2K514.mondays;
    }
});
Object.defineProperty(module.exports, "timeMonth", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_month.default;
    }
});
Object.defineProperty(module.exports, "timeMonths", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_month.months;
    }
});
Object.defineProperty(module.exports, "timeSaturday", {
    enumerable: true,
    get: function() {
        return $2K514.saturday;
    }
});
Object.defineProperty(module.exports, "timeSaturdays", {
    enumerable: true,
    get: function() {
        return $2K514.saturdays;
    }
});
Object.defineProperty(module.exports, "timeSecond", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_second.default;
    }
});
Object.defineProperty(module.exports, "timeSeconds", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "timeSunday", {
    enumerable: true,
    get: function() {
        return $2K514.sunday;
    }
});
Object.defineProperty(module.exports, "timeSundays", {
    enumerable: true,
    get: function() {
        return $2K514.sundays;
    }
});
Object.defineProperty(module.exports, "timeThursday", {
    enumerable: true,
    get: function() {
        return $2K514.thursday;
    }
});
Object.defineProperty(module.exports, "timeThursdays", {
    enumerable: true,
    get: function() {
        return $2K514.thursdays;
    }
});
Object.defineProperty(module.exports, "timeTickInterval", {
    enumerable: true,
    get: function() {
        return $kEk4s.timeTickInterval;
    }
});
Object.defineProperty(module.exports, "timeTicks", {
    enumerable: true,
    get: function() {
        return $kEk4s.timeTicks;
    }
});
Object.defineProperty(module.exports, "timeTuesday", {
    enumerable: true,
    get: function() {
        return $2K514.tuesday;
    }
});
Object.defineProperty(module.exports, "timeTuesdays", {
    enumerable: true,
    get: function() {
        return $2K514.tuesdays;
    }
});
Object.defineProperty(module.exports, "timeWednesday", {
    enumerable: true,
    get: function() {
        return $2K514.wednesday;
    }
});
Object.defineProperty(module.exports, "timeWednesdays", {
    enumerable: true,
    get: function() {
        return $2K514.wednesdays;
    }
});
Object.defineProperty(module.exports, "timeWeek", {
    enumerable: true,
    get: function() {
        return $2K514.sunday;
    }
});
Object.defineProperty(module.exports, "timeWeeks", {
    enumerable: true,
    get: function() {
        return $2K514.sundays;
    }
});
Object.defineProperty(module.exports, "timeYear", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_year.default;
    }
});
Object.defineProperty(module.exports, "timeYears", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_year.years;
    }
});
Object.defineProperty(module.exports, "utcDay", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_utcDay.default;
    }
});
Object.defineProperty(module.exports, "utcDays", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_utcDay.utcDays;
    }
});
Object.defineProperty(module.exports, "utcFriday", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcFriday;
    }
});
Object.defineProperty(module.exports, "utcFridays", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcFridays;
    }
});
Object.defineProperty(module.exports, "utcHour", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_utcHour.default;
    }
});
Object.defineProperty(module.exports, "utcHours", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_utcHour.utcHours;
    }
});
Object.defineProperty(module.exports, "utcMillisecond", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "utcMilliseconds", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "utcMinute", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_utcMinute.default;
    }
});
Object.defineProperty(module.exports, "utcMinutes", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_utcMinute.utcMinutes;
    }
});
Object.defineProperty(module.exports, "utcMonday", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcMonday;
    }
});
Object.defineProperty(module.exports, "utcMondays", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcMondays;
    }
});
Object.defineProperty(module.exports, "utcMonth", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_utcMonth.default;
    }
});
Object.defineProperty(module.exports, "utcMonths", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_utcMonth.utcMonths;
    }
});
Object.defineProperty(module.exports, "utcSaturday", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcSaturday;
    }
});
Object.defineProperty(module.exports, "utcSaturdays", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcSaturdays;
    }
});
Object.defineProperty(module.exports, "utcSecond", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_second.default;
    }
});
Object.defineProperty(module.exports, "utcSeconds", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "utcSunday", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcSundays", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcThursday", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcThursday;
    }
});
Object.defineProperty(module.exports, "utcThursdays", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcThursdays;
    }
});
Object.defineProperty(module.exports, "utcTickInterval", {
    enumerable: true,
    get: function() {
        return $kEk4s.utcTickInterval;
    }
});
Object.defineProperty(module.exports, "utcTicks", {
    enumerable: true,
    get: function() {
        return $kEk4s.utcTicks;
    }
});
Object.defineProperty(module.exports, "utcTuesday", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcTuesday;
    }
});
Object.defineProperty(module.exports, "utcTuesdays", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcTuesdays;
    }
});
Object.defineProperty(module.exports, "utcWednesday", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcWednesday;
    }
});
Object.defineProperty(module.exports, "utcWednesdays", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcWednesdays;
    }
});
Object.defineProperty(module.exports, "utcWeek", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcWeeks", {
    enumerable: true,
    get: function() {
        return $gVQv0.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcYear", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_utcYear.default;
    }
});
Object.defineProperty(module.exports, "utcYears", {
    enumerable: true,
    get: function() {
        return $75d9d82d7313d446$var$_utcYear.utcYears;
    }
});

var $75d9d82d7313d446$var$_interval = $75d9d82d7313d446$var$_interopRequireDefault((parcelRequire("avnhx")));

var $75d9d82d7313d446$var$_millisecond = $75d9d82d7313d446$var$_interopRequireWildcard((parcelRequire("8VCua")));

var $75d9d82d7313d446$var$_second = $75d9d82d7313d446$var$_interopRequireWildcard((parcelRequire("aKEL2")));

var $75d9d82d7313d446$var$_minute = $75d9d82d7313d446$var$_interopRequireWildcard((parcelRequire("dnUab")));

var $75d9d82d7313d446$var$_hour = $75d9d82d7313d446$var$_interopRequireWildcard((parcelRequire("jfjWs")));

var $75d9d82d7313d446$var$_day = $75d9d82d7313d446$var$_interopRequireWildcard((parcelRequire("5Zobx")));

var $2K514 = parcelRequire("2K514");

var $75d9d82d7313d446$var$_month = $75d9d82d7313d446$var$_interopRequireWildcard((parcelRequire("hCn8d")));

var $75d9d82d7313d446$var$_year = $75d9d82d7313d446$var$_interopRequireWildcard((parcelRequire("iUukc")));

var $75d9d82d7313d446$var$_utcMinute = $75d9d82d7313d446$var$_interopRequireWildcard((parcelRequire("eIOju")));

var $75d9d82d7313d446$var$_utcHour = $75d9d82d7313d446$var$_interopRequireWildcard((parcelRequire("4edXK")));

var $75d9d82d7313d446$var$_utcDay = $75d9d82d7313d446$var$_interopRequireWildcard((parcelRequire("gfGMZ")));

var $gVQv0 = parcelRequire("gVQv0");

var $75d9d82d7313d446$var$_utcMonth = $75d9d82d7313d446$var$_interopRequireWildcard((parcelRequire("8IrcU")));

var $75d9d82d7313d446$var$_utcYear = $75d9d82d7313d446$var$_interopRequireWildcard((parcelRequire("cQP75")));

var $kEk4s = parcelRequire("kEk4s");
function $75d9d82d7313d446$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($75d9d82d7313d446$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $75d9d82d7313d446$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $75d9d82d7313d446$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $75d9d82d7313d446$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("avnhx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7a5edbe781297ef1$var$newInterval;
var $7a5edbe781297ef1$var$t0 = new Date(), $7a5edbe781297ef1$var$t1 = new Date();
function $7a5edbe781297ef1$var$newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $7a5edbe781297ef1$var$newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $7a5edbe781297ef1$var$t0.setTime(+start), $7a5edbe781297ef1$var$t1.setTime(+end);
            floori($7a5edbe781297ef1$var$t0), floori($7a5edbe781297ef1$var$t1);
            return Math.floor(count($7a5edbe781297ef1$var$t0, $7a5edbe781297ef1$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("8VCua", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.milliseconds = module.exports.default = void 0;

var $68018007151518ca$var$_interval = $68018007151518ca$var$_interopRequireDefault((parcelRequire("avnhx")));
function $68018007151518ca$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $68018007151518ca$var$millisecond = (0, $68018007151518ca$var$_interval.default)(function() {}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
}); // An optimized implementation for this simple case.
$68018007151518ca$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $68018007151518ca$var$millisecond;
    return (0, $68018007151518ca$var$_interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $68018007151518ca$var$_default = $68018007151518ca$var$millisecond;
module.exports.default = $68018007151518ca$var$_default;
var $68018007151518ca$var$milliseconds = $68018007151518ca$var$millisecond.range;
module.exports.milliseconds = $68018007151518ca$var$milliseconds;

});

parcelRegister("aKEL2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.seconds = module.exports.default = void 0;

var $7d3dd0e33d596a95$var$_interval = $7d3dd0e33d596a95$var$_interopRequireDefault((parcelRequire("avnhx")));

var $5fpF5 = parcelRequire("5fpF5");
function $7d3dd0e33d596a95$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7d3dd0e33d596a95$var$second = (0, $7d3dd0e33d596a95$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * $5fpF5.durationSecond);
}, function(start, end) {
    return (end - start) / $5fpF5.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var $7d3dd0e33d596a95$var$_default = $7d3dd0e33d596a95$var$second;
module.exports.default = $7d3dd0e33d596a95$var$_default;
var $7d3dd0e33d596a95$var$seconds = $7d3dd0e33d596a95$var$second.range;
module.exports.seconds = $7d3dd0e33d596a95$var$seconds;

});
parcelRegister("5fpF5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.durationYear = module.exports.durationWeek = module.exports.durationSecond = module.exports.durationMonth = module.exports.durationMinute = module.exports.durationHour = module.exports.durationDay = void 0;
const $3d224252ae19d98a$var$durationSecond = 1000;
module.exports.durationSecond = $3d224252ae19d98a$var$durationSecond;
const $3d224252ae19d98a$var$durationMinute = $3d224252ae19d98a$var$durationSecond * 60;
module.exports.durationMinute = $3d224252ae19d98a$var$durationMinute;
const $3d224252ae19d98a$var$durationHour = $3d224252ae19d98a$var$durationMinute * 60;
module.exports.durationHour = $3d224252ae19d98a$var$durationHour;
const $3d224252ae19d98a$var$durationDay = $3d224252ae19d98a$var$durationHour * 24;
module.exports.durationDay = $3d224252ae19d98a$var$durationDay;
const $3d224252ae19d98a$var$durationWeek = $3d224252ae19d98a$var$durationDay * 7;
module.exports.durationWeek = $3d224252ae19d98a$var$durationWeek;
const $3d224252ae19d98a$var$durationMonth = $3d224252ae19d98a$var$durationDay * 30;
module.exports.durationMonth = $3d224252ae19d98a$var$durationMonth;
const $3d224252ae19d98a$var$durationYear = $3d224252ae19d98a$var$durationDay * 365;
module.exports.durationYear = $3d224252ae19d98a$var$durationYear;

});


parcelRegister("dnUab", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.minutes = module.exports.default = void 0;

var $9be8fd311671f9cb$var$_interval = $9be8fd311671f9cb$var$_interopRequireDefault((parcelRequire("avnhx")));

var $5fpF5 = parcelRequire("5fpF5");
function $9be8fd311671f9cb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9be8fd311671f9cb$var$minute = (0, $9be8fd311671f9cb$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $5fpF5.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * $5fpF5.durationMinute);
}, function(start, end) {
    return (end - start) / $5fpF5.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var $9be8fd311671f9cb$var$_default = $9be8fd311671f9cb$var$minute;
module.exports.default = $9be8fd311671f9cb$var$_default;
var $9be8fd311671f9cb$var$minutes = $9be8fd311671f9cb$var$minute.range;
module.exports.minutes = $9be8fd311671f9cb$var$minutes;

});

parcelRegister("jfjWs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hours = module.exports.default = void 0;

var $e02ee30d1a5a72e7$var$_interval = $e02ee30d1a5a72e7$var$_interopRequireDefault((parcelRequire("avnhx")));

var $5fpF5 = parcelRequire("5fpF5");
function $e02ee30d1a5a72e7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e02ee30d1a5a72e7$var$hour = (0, $e02ee30d1a5a72e7$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $5fpF5.durationSecond - date.getMinutes() * $5fpF5.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * $5fpF5.durationHour);
}, function(start, end) {
    return (end - start) / $5fpF5.durationHour;
}, function(date) {
    return date.getHours();
});
var $e02ee30d1a5a72e7$var$_default = $e02ee30d1a5a72e7$var$hour;
module.exports.default = $e02ee30d1a5a72e7$var$_default;
var $e02ee30d1a5a72e7$var$hours = $e02ee30d1a5a72e7$var$hour.range;
module.exports.hours = $e02ee30d1a5a72e7$var$hours;

});

parcelRegister("5Zobx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.days = void 0;

var $45c568ea21f6963e$var$_interval = $45c568ea21f6963e$var$_interopRequireDefault((parcelRequire("avnhx")));

var $5fpF5 = parcelRequire("5fpF5");
function $45c568ea21f6963e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $45c568ea21f6963e$var$day = (0, $45c568ea21f6963e$var$_interval.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $5fpF5.durationMinute) / $5fpF5.durationDay, (date)=>date.getDate() - 1);
var $45c568ea21f6963e$var$_default = $45c568ea21f6963e$var$day;
module.exports.default = $45c568ea21f6963e$var$_default;
var $45c568ea21f6963e$var$days = $45c568ea21f6963e$var$day.range;
module.exports.days = $45c568ea21f6963e$var$days;

});

parcelRegister("2K514", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wednesdays = module.exports.wednesday = module.exports.tuesdays = module.exports.tuesday = module.exports.thursdays = module.exports.thursday = module.exports.sundays = module.exports.sunday = module.exports.saturdays = module.exports.saturday = module.exports.mondays = module.exports.monday = module.exports.fridays = module.exports.friday = void 0;

var $1ff3c4cab7f28ab7$var$_interval = $1ff3c4cab7f28ab7$var$_interopRequireDefault((parcelRequire("avnhx")));

var $5fpF5 = parcelRequire("5fpF5");
function $1ff3c4cab7f28ab7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1ff3c4cab7f28ab7$var$weekday(i) {
    return (0, $1ff3c4cab7f28ab7$var$_interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $5fpF5.durationMinute) / $5fpF5.durationWeek;
    });
}
var $1ff3c4cab7f28ab7$var$sunday = $1ff3c4cab7f28ab7$var$weekday(0);
module.exports.sunday = $1ff3c4cab7f28ab7$var$sunday;
var $1ff3c4cab7f28ab7$var$monday = $1ff3c4cab7f28ab7$var$weekday(1);
module.exports.monday = $1ff3c4cab7f28ab7$var$monday;
var $1ff3c4cab7f28ab7$var$tuesday = $1ff3c4cab7f28ab7$var$weekday(2);
module.exports.tuesday = $1ff3c4cab7f28ab7$var$tuesday;
var $1ff3c4cab7f28ab7$var$wednesday = $1ff3c4cab7f28ab7$var$weekday(3);
module.exports.wednesday = $1ff3c4cab7f28ab7$var$wednesday;
var $1ff3c4cab7f28ab7$var$thursday = $1ff3c4cab7f28ab7$var$weekday(4);
module.exports.thursday = $1ff3c4cab7f28ab7$var$thursday;
var $1ff3c4cab7f28ab7$var$friday = $1ff3c4cab7f28ab7$var$weekday(5);
module.exports.friday = $1ff3c4cab7f28ab7$var$friday;
var $1ff3c4cab7f28ab7$var$saturday = $1ff3c4cab7f28ab7$var$weekday(6);
module.exports.saturday = $1ff3c4cab7f28ab7$var$saturday;
var $1ff3c4cab7f28ab7$var$sundays = $1ff3c4cab7f28ab7$var$sunday.range;
module.exports.sundays = $1ff3c4cab7f28ab7$var$sundays;
var $1ff3c4cab7f28ab7$var$mondays = $1ff3c4cab7f28ab7$var$monday.range;
module.exports.mondays = $1ff3c4cab7f28ab7$var$mondays;
var $1ff3c4cab7f28ab7$var$tuesdays = $1ff3c4cab7f28ab7$var$tuesday.range;
module.exports.tuesdays = $1ff3c4cab7f28ab7$var$tuesdays;
var $1ff3c4cab7f28ab7$var$wednesdays = $1ff3c4cab7f28ab7$var$wednesday.range;
module.exports.wednesdays = $1ff3c4cab7f28ab7$var$wednesdays;
var $1ff3c4cab7f28ab7$var$thursdays = $1ff3c4cab7f28ab7$var$thursday.range;
module.exports.thursdays = $1ff3c4cab7f28ab7$var$thursdays;
var $1ff3c4cab7f28ab7$var$fridays = $1ff3c4cab7f28ab7$var$friday.range;
module.exports.fridays = $1ff3c4cab7f28ab7$var$fridays;
var $1ff3c4cab7f28ab7$var$saturdays = $1ff3c4cab7f28ab7$var$saturday.range;
module.exports.saturdays = $1ff3c4cab7f28ab7$var$saturdays;

});

parcelRegister("hCn8d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.months = module.exports.default = void 0;

var $cd37edb99cc629c8$var$_interval = $cd37edb99cc629c8$var$_interopRequireDefault((parcelRequire("avnhx")));
function $cd37edb99cc629c8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $cd37edb99cc629c8$var$month = (0, $cd37edb99cc629c8$var$_interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $cd37edb99cc629c8$var$_default = $cd37edb99cc629c8$var$month;
module.exports.default = $cd37edb99cc629c8$var$_default;
var $cd37edb99cc629c8$var$months = $cd37edb99cc629c8$var$month.range;
module.exports.months = $cd37edb99cc629c8$var$months;

});

parcelRegister("iUukc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.years = module.exports.default = void 0;

var $dc44fad24c185d66$var$_interval = $dc44fad24c185d66$var$_interopRequireDefault((parcelRequire("avnhx")));
function $dc44fad24c185d66$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $dc44fad24c185d66$var$year = (0, $dc44fad24c185d66$var$_interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
}); // An optimized implementation for this simple case.
$dc44fad24c185d66$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $dc44fad24c185d66$var$_interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $dc44fad24c185d66$var$_default = $dc44fad24c185d66$var$year;
module.exports.default = $dc44fad24c185d66$var$_default;
var $dc44fad24c185d66$var$years = $dc44fad24c185d66$var$year.range;
module.exports.years = $dc44fad24c185d66$var$years;

});

parcelRegister("eIOju", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMinutes = module.exports.default = void 0;

var $ab7c33f0c3895f25$var$_interval = $ab7c33f0c3895f25$var$_interopRequireDefault((parcelRequire("avnhx")));

var $5fpF5 = parcelRequire("5fpF5");
function $ab7c33f0c3895f25$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ab7c33f0c3895f25$var$utcMinute = (0, $ab7c33f0c3895f25$var$_interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * $5fpF5.durationMinute);
}, function(start, end) {
    return (end - start) / $5fpF5.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var $ab7c33f0c3895f25$var$_default = $ab7c33f0c3895f25$var$utcMinute;
module.exports.default = $ab7c33f0c3895f25$var$_default;
var $ab7c33f0c3895f25$var$utcMinutes = $ab7c33f0c3895f25$var$utcMinute.range;
module.exports.utcMinutes = $ab7c33f0c3895f25$var$utcMinutes;

});

parcelRegister("4edXK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcHours = module.exports.default = void 0;

var $31434ce923f6b039$var$_interval = $31434ce923f6b039$var$_interopRequireDefault((parcelRequire("avnhx")));

var $5fpF5 = parcelRequire("5fpF5");
function $31434ce923f6b039$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $31434ce923f6b039$var$utcHour = (0, $31434ce923f6b039$var$_interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * $5fpF5.durationHour);
}, function(start, end) {
    return (end - start) / $5fpF5.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var $31434ce923f6b039$var$_default = $31434ce923f6b039$var$utcHour;
module.exports.default = $31434ce923f6b039$var$_default;
var $31434ce923f6b039$var$utcHours = $31434ce923f6b039$var$utcHour.range;
module.exports.utcHours = $31434ce923f6b039$var$utcHours;

});

parcelRegister("gfGMZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcDays = module.exports.default = void 0;

var $bd4f3d18a1e6ab93$var$_interval = $bd4f3d18a1e6ab93$var$_interopRequireDefault((parcelRequire("avnhx")));

var $5fpF5 = parcelRequire("5fpF5");
function $bd4f3d18a1e6ab93$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $bd4f3d18a1e6ab93$var$utcDay = (0, $bd4f3d18a1e6ab93$var$_interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / $5fpF5.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var $bd4f3d18a1e6ab93$var$_default = $bd4f3d18a1e6ab93$var$utcDay;
module.exports.default = $bd4f3d18a1e6ab93$var$_default;
var $bd4f3d18a1e6ab93$var$utcDays = $bd4f3d18a1e6ab93$var$utcDay.range;
module.exports.utcDays = $bd4f3d18a1e6ab93$var$utcDays;

});

parcelRegister("gVQv0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcWednesdays = module.exports.utcWednesday = module.exports.utcTuesdays = module.exports.utcTuesday = module.exports.utcThursdays = module.exports.utcThursday = module.exports.utcSundays = module.exports.utcSunday = module.exports.utcSaturdays = module.exports.utcSaturday = module.exports.utcMondays = module.exports.utcMonday = module.exports.utcFridays = module.exports.utcFriday = void 0;

var $c53ab17541a5b5bc$var$_interval = $c53ab17541a5b5bc$var$_interopRequireDefault((parcelRequire("avnhx")));

var $5fpF5 = parcelRequire("5fpF5");
function $c53ab17541a5b5bc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c53ab17541a5b5bc$var$utcWeekday(i) {
    return (0, $c53ab17541a5b5bc$var$_interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / $5fpF5.durationWeek;
    });
}
var $c53ab17541a5b5bc$var$utcSunday = $c53ab17541a5b5bc$var$utcWeekday(0);
module.exports.utcSunday = $c53ab17541a5b5bc$var$utcSunday;
var $c53ab17541a5b5bc$var$utcMonday = $c53ab17541a5b5bc$var$utcWeekday(1);
module.exports.utcMonday = $c53ab17541a5b5bc$var$utcMonday;
var $c53ab17541a5b5bc$var$utcTuesday = $c53ab17541a5b5bc$var$utcWeekday(2);
module.exports.utcTuesday = $c53ab17541a5b5bc$var$utcTuesday;
var $c53ab17541a5b5bc$var$utcWednesday = $c53ab17541a5b5bc$var$utcWeekday(3);
module.exports.utcWednesday = $c53ab17541a5b5bc$var$utcWednesday;
var $c53ab17541a5b5bc$var$utcThursday = $c53ab17541a5b5bc$var$utcWeekday(4);
module.exports.utcThursday = $c53ab17541a5b5bc$var$utcThursday;
var $c53ab17541a5b5bc$var$utcFriday = $c53ab17541a5b5bc$var$utcWeekday(5);
module.exports.utcFriday = $c53ab17541a5b5bc$var$utcFriday;
var $c53ab17541a5b5bc$var$utcSaturday = $c53ab17541a5b5bc$var$utcWeekday(6);
module.exports.utcSaturday = $c53ab17541a5b5bc$var$utcSaturday;
var $c53ab17541a5b5bc$var$utcSundays = $c53ab17541a5b5bc$var$utcSunday.range;
module.exports.utcSundays = $c53ab17541a5b5bc$var$utcSundays;
var $c53ab17541a5b5bc$var$utcMondays = $c53ab17541a5b5bc$var$utcMonday.range;
module.exports.utcMondays = $c53ab17541a5b5bc$var$utcMondays;
var $c53ab17541a5b5bc$var$utcTuesdays = $c53ab17541a5b5bc$var$utcTuesday.range;
module.exports.utcTuesdays = $c53ab17541a5b5bc$var$utcTuesdays;
var $c53ab17541a5b5bc$var$utcWednesdays = $c53ab17541a5b5bc$var$utcWednesday.range;
module.exports.utcWednesdays = $c53ab17541a5b5bc$var$utcWednesdays;
var $c53ab17541a5b5bc$var$utcThursdays = $c53ab17541a5b5bc$var$utcThursday.range;
module.exports.utcThursdays = $c53ab17541a5b5bc$var$utcThursdays;
var $c53ab17541a5b5bc$var$utcFridays = $c53ab17541a5b5bc$var$utcFriday.range;
module.exports.utcFridays = $c53ab17541a5b5bc$var$utcFridays;
var $c53ab17541a5b5bc$var$utcSaturdays = $c53ab17541a5b5bc$var$utcSaturday.range;
module.exports.utcSaturdays = $c53ab17541a5b5bc$var$utcSaturdays;

});

parcelRegister("8IrcU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMonths = module.exports.default = void 0;

var $65878994030f3314$var$_interval = $65878994030f3314$var$_interopRequireDefault((parcelRequire("avnhx")));
function $65878994030f3314$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $65878994030f3314$var$utcMonth = (0, $65878994030f3314$var$_interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $65878994030f3314$var$_default = $65878994030f3314$var$utcMonth;
module.exports.default = $65878994030f3314$var$_default;
var $65878994030f3314$var$utcMonths = $65878994030f3314$var$utcMonth.range;
module.exports.utcMonths = $65878994030f3314$var$utcMonths;

});

parcelRegister("cQP75", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcYears = module.exports.default = void 0;

var $95b1fd66ff42ad48$var$_interval = $95b1fd66ff42ad48$var$_interopRequireDefault((parcelRequire("avnhx")));
function $95b1fd66ff42ad48$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $95b1fd66ff42ad48$var$utcYear = (0, $95b1fd66ff42ad48$var$_interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
}); // An optimized implementation for this simple case.
$95b1fd66ff42ad48$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $95b1fd66ff42ad48$var$_interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $95b1fd66ff42ad48$var$_default = $95b1fd66ff42ad48$var$utcYear;
module.exports.default = $95b1fd66ff42ad48$var$_default;
var $95b1fd66ff42ad48$var$utcYears = $95b1fd66ff42ad48$var$utcYear.range;
module.exports.utcYears = $95b1fd66ff42ad48$var$utcYears;

});

parcelRegister("kEk4s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcTicks = module.exports.utcTickInterval = module.exports.timeTicks = module.exports.timeTickInterval = void 0;

var $k5p7I = parcelRequire("k5p7I");

var $5fpF5 = parcelRequire("5fpF5");

var $f0871cb69aa37b20$var$_millisecond = $f0871cb69aa37b20$var$_interopRequireDefault((parcelRequire("8VCua")));

var $f0871cb69aa37b20$var$_second = $f0871cb69aa37b20$var$_interopRequireDefault((parcelRequire("aKEL2")));

var $f0871cb69aa37b20$var$_minute = $f0871cb69aa37b20$var$_interopRequireDefault((parcelRequire("dnUab")));

var $f0871cb69aa37b20$var$_hour = $f0871cb69aa37b20$var$_interopRequireDefault((parcelRequire("jfjWs")));

var $f0871cb69aa37b20$var$_day = $f0871cb69aa37b20$var$_interopRequireDefault((parcelRequire("5Zobx")));

var $2K514 = parcelRequire("2K514");

var $f0871cb69aa37b20$var$_month = $f0871cb69aa37b20$var$_interopRequireDefault((parcelRequire("hCn8d")));

var $f0871cb69aa37b20$var$_year = $f0871cb69aa37b20$var$_interopRequireDefault((parcelRequire("iUukc")));

var $f0871cb69aa37b20$var$_utcMinute = $f0871cb69aa37b20$var$_interopRequireDefault((parcelRequire("eIOju")));

var $f0871cb69aa37b20$var$_utcHour = $f0871cb69aa37b20$var$_interopRequireDefault((parcelRequire("4edXK")));

var $f0871cb69aa37b20$var$_utcDay = $f0871cb69aa37b20$var$_interopRequireDefault((parcelRequire("gfGMZ")));

var $gVQv0 = parcelRequire("gVQv0");

var $f0871cb69aa37b20$var$_utcMonth = $f0871cb69aa37b20$var$_interopRequireDefault((parcelRequire("8IrcU")));

var $f0871cb69aa37b20$var$_utcYear = $f0871cb69aa37b20$var$_interopRequireDefault((parcelRequire("cQP75")));
function $f0871cb69aa37b20$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f0871cb69aa37b20$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            $f0871cb69aa37b20$var$_second.default,
            1,
            $5fpF5.durationSecond
        ],
        [
            $f0871cb69aa37b20$var$_second.default,
            5,
            5 * $5fpF5.durationSecond
        ],
        [
            $f0871cb69aa37b20$var$_second.default,
            15,
            15 * $5fpF5.durationSecond
        ],
        [
            $f0871cb69aa37b20$var$_second.default,
            30,
            30 * $5fpF5.durationSecond
        ],
        [
            minute,
            1,
            $5fpF5.durationMinute
        ],
        [
            minute,
            5,
            5 * $5fpF5.durationMinute
        ],
        [
            minute,
            15,
            15 * $5fpF5.durationMinute
        ],
        [
            minute,
            30,
            30 * $5fpF5.durationMinute
        ],
        [
            hour,
            1,
            $5fpF5.durationHour
        ],
        [
            hour,
            3,
            3 * $5fpF5.durationHour
        ],
        [
            hour,
            6,
            6 * $5fpF5.durationHour
        ],
        [
            hour,
            12,
            12 * $5fpF5.durationHour
        ],
        [
            day,
            1,
            $5fpF5.durationDay
        ],
        [
            day,
            2,
            2 * $5fpF5.durationDay
        ],
        [
            week,
            1,
            $5fpF5.durationWeek
        ],
        [
            month,
            1,
            $5fpF5.durationMonth
        ],
        [
            month,
            3,
            3 * $5fpF5.durationMonth
        ],
        [
            year,
            1,
            $5fpF5.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $k5p7I.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $k5p7I.tickStep)(start / $5fpF5.durationYear, stop / $5fpF5.durationYear, count));
        if (i === 0) return $f0871cb69aa37b20$var$_millisecond.default.every(Math.max((0, $k5p7I.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$f0871cb69aa37b20$var$utcTicks, $f0871cb69aa37b20$var$utcTickInterval] = $f0871cb69aa37b20$var$ticker($f0871cb69aa37b20$var$_utcYear.default, $f0871cb69aa37b20$var$_utcMonth.default, $gVQv0.utcSunday, $f0871cb69aa37b20$var$_utcDay.default, $f0871cb69aa37b20$var$_utcHour.default, $f0871cb69aa37b20$var$_utcMinute.default);
module.exports.utcTickInterval = $f0871cb69aa37b20$var$utcTickInterval;
module.exports.utcTicks = $f0871cb69aa37b20$var$utcTicks;
const [$f0871cb69aa37b20$var$timeTicks, $f0871cb69aa37b20$var$timeTickInterval] = $f0871cb69aa37b20$var$ticker($f0871cb69aa37b20$var$_year.default, $f0871cb69aa37b20$var$_month.default, $2K514.sunday, $f0871cb69aa37b20$var$_day.default, $f0871cb69aa37b20$var$_hour.default, $f0871cb69aa37b20$var$_minute.default);
module.exports.timeTickInterval = $f0871cb69aa37b20$var$timeTickInterval;
module.exports.timeTicks = $f0871cb69aa37b20$var$timeTicks;

});


parcelRegister("abRJC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "isoFormat", {
    enumerable: true,
    get: function() {
        return $76b49d13e27da572$var$_isoFormat.default;
    }
});
Object.defineProperty(module.exports, "isoParse", {
    enumerable: true,
    get: function() {
        return $76b49d13e27da572$var$_isoParse.default;
    }
});
Object.defineProperty(module.exports, "timeFormat", {
    enumerable: true,
    get: function() {
        return $76b49d13e27da572$var$_defaultLocale.timeFormat;
    }
});
Object.defineProperty(module.exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $76b49d13e27da572$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "timeFormatLocale", {
    enumerable: true,
    get: function() {
        return $76b49d13e27da572$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "timeParse", {
    enumerable: true,
    get: function() {
        return $76b49d13e27da572$var$_defaultLocale.timeParse;
    }
});
Object.defineProperty(module.exports, "utcFormat", {
    enumerable: true,
    get: function() {
        return $76b49d13e27da572$var$_defaultLocale.utcFormat;
    }
});
Object.defineProperty(module.exports, "utcParse", {
    enumerable: true,
    get: function() {
        return $76b49d13e27da572$var$_defaultLocale.utcParse;
    }
});

var $76b49d13e27da572$var$_defaultLocale = $76b49d13e27da572$var$_interopRequireWildcard((parcelRequire("30er6")));

var $76b49d13e27da572$var$_locale = $76b49d13e27da572$var$_interopRequireDefault((parcelRequire("hB79x")));

var $76b49d13e27da572$var$_isoFormat = $76b49d13e27da572$var$_interopRequireDefault((parcelRequire("cX5Ls")));

var $76b49d13e27da572$var$_isoParse = $76b49d13e27da572$var$_interopRequireDefault((parcelRequire("e2YhZ")));
function $76b49d13e27da572$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $76b49d13e27da572$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($76b49d13e27da572$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $76b49d13e27da572$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $76b49d13e27da572$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("30er6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $22fc91e6254d1e2c$var$defaultLocale;
module.exports.utcParse = module.exports.utcFormat = module.exports.timeParse = module.exports.timeFormat = void 0;

var $22fc91e6254d1e2c$var$_locale = $22fc91e6254d1e2c$var$_interopRequireDefault((parcelRequire("hB79x")));
function $22fc91e6254d1e2c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $22fc91e6254d1e2c$var$locale;
var $22fc91e6254d1e2c$var$timeFormat;
module.exports.timeFormat = $22fc91e6254d1e2c$var$timeFormat;
var $22fc91e6254d1e2c$var$timeParse;
module.exports.timeParse = $22fc91e6254d1e2c$var$timeParse;
var $22fc91e6254d1e2c$var$utcFormat;
module.exports.utcFormat = $22fc91e6254d1e2c$var$utcFormat;
var $22fc91e6254d1e2c$var$utcParse;
module.exports.utcParse = $22fc91e6254d1e2c$var$utcParse;
$22fc91e6254d1e2c$var$defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $22fc91e6254d1e2c$var$defaultLocale(definition) {
    $22fc91e6254d1e2c$var$locale = (0, $22fc91e6254d1e2c$var$_locale.default)(definition);
    module.exports.timeFormat = $22fc91e6254d1e2c$var$timeFormat = $22fc91e6254d1e2c$var$locale.format;
    module.exports.timeParse = $22fc91e6254d1e2c$var$timeParse = $22fc91e6254d1e2c$var$locale.parse;
    module.exports.utcFormat = $22fc91e6254d1e2c$var$utcFormat = $22fc91e6254d1e2c$var$locale.utcFormat;
    module.exports.utcParse = $22fc91e6254d1e2c$var$utcParse = $22fc91e6254d1e2c$var$locale.utcParse;
    return $22fc91e6254d1e2c$var$locale;
}

});
parcelRegister("hB79x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ccfb70c24839d7ef$var$formatLocale;

var $a7jHS = parcelRequire("a7jHS");
function $ccfb70c24839d7ef$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $ccfb70c24839d7ef$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $ccfb70c24839d7ef$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $ccfb70c24839d7ef$var$formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $ccfb70c24839d7ef$var$formatRe(locale_periods), periodLookup = $ccfb70c24839d7ef$var$formatLookup(locale_periods), weekdayRe = $ccfb70c24839d7ef$var$formatRe(locale_weekdays), weekdayLookup = $ccfb70c24839d7ef$var$formatLookup(locale_weekdays), shortWeekdayRe = $ccfb70c24839d7ef$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $ccfb70c24839d7ef$var$formatLookup(locale_shortWeekdays), monthRe = $ccfb70c24839d7ef$var$formatRe(locale_months), monthLookup = $ccfb70c24839d7ef$var$formatLookup(locale_months), shortMonthRe = $ccfb70c24839d7ef$var$formatRe(locale_shortMonths), shortMonthLookup = $ccfb70c24839d7ef$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $ccfb70c24839d7ef$var$formatDayOfMonth,
        "e": $ccfb70c24839d7ef$var$formatDayOfMonth,
        "f": $ccfb70c24839d7ef$var$formatMicroseconds,
        "g": $ccfb70c24839d7ef$var$formatYearISO,
        "G": $ccfb70c24839d7ef$var$formatFullYearISO,
        "H": $ccfb70c24839d7ef$var$formatHour24,
        "I": $ccfb70c24839d7ef$var$formatHour12,
        "j": $ccfb70c24839d7ef$var$formatDayOfYear,
        "L": $ccfb70c24839d7ef$var$formatMilliseconds,
        "m": $ccfb70c24839d7ef$var$formatMonthNumber,
        "M": $ccfb70c24839d7ef$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $ccfb70c24839d7ef$var$formatUnixTimestamp,
        "s": $ccfb70c24839d7ef$var$formatUnixTimestampSeconds,
        "S": $ccfb70c24839d7ef$var$formatSeconds,
        "u": $ccfb70c24839d7ef$var$formatWeekdayNumberMonday,
        "U": $ccfb70c24839d7ef$var$formatWeekNumberSunday,
        "V": $ccfb70c24839d7ef$var$formatWeekNumberISO,
        "w": $ccfb70c24839d7ef$var$formatWeekdayNumberSunday,
        "W": $ccfb70c24839d7ef$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $ccfb70c24839d7ef$var$formatYear,
        "Y": $ccfb70c24839d7ef$var$formatFullYear,
        "Z": $ccfb70c24839d7ef$var$formatZone,
        "%": $ccfb70c24839d7ef$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $ccfb70c24839d7ef$var$formatUTCDayOfMonth,
        "e": $ccfb70c24839d7ef$var$formatUTCDayOfMonth,
        "f": $ccfb70c24839d7ef$var$formatUTCMicroseconds,
        "g": $ccfb70c24839d7ef$var$formatUTCYearISO,
        "G": $ccfb70c24839d7ef$var$formatUTCFullYearISO,
        "H": $ccfb70c24839d7ef$var$formatUTCHour24,
        "I": $ccfb70c24839d7ef$var$formatUTCHour12,
        "j": $ccfb70c24839d7ef$var$formatUTCDayOfYear,
        "L": $ccfb70c24839d7ef$var$formatUTCMilliseconds,
        "m": $ccfb70c24839d7ef$var$formatUTCMonthNumber,
        "M": $ccfb70c24839d7ef$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $ccfb70c24839d7ef$var$formatUnixTimestamp,
        "s": $ccfb70c24839d7ef$var$formatUnixTimestampSeconds,
        "S": $ccfb70c24839d7ef$var$formatUTCSeconds,
        "u": $ccfb70c24839d7ef$var$formatUTCWeekdayNumberMonday,
        "U": $ccfb70c24839d7ef$var$formatUTCWeekNumberSunday,
        "V": $ccfb70c24839d7ef$var$formatUTCWeekNumberISO,
        "w": $ccfb70c24839d7ef$var$formatUTCWeekdayNumberSunday,
        "W": $ccfb70c24839d7ef$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $ccfb70c24839d7ef$var$formatUTCYear,
        "Y": $ccfb70c24839d7ef$var$formatUTCFullYear,
        "Z": $ccfb70c24839d7ef$var$formatUTCZone,
        "%": $ccfb70c24839d7ef$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $ccfb70c24839d7ef$var$parseDayOfMonth,
        "e": $ccfb70c24839d7ef$var$parseDayOfMonth,
        "f": $ccfb70c24839d7ef$var$parseMicroseconds,
        "g": $ccfb70c24839d7ef$var$parseYear,
        "G": $ccfb70c24839d7ef$var$parseFullYear,
        "H": $ccfb70c24839d7ef$var$parseHour24,
        "I": $ccfb70c24839d7ef$var$parseHour24,
        "j": $ccfb70c24839d7ef$var$parseDayOfYear,
        "L": $ccfb70c24839d7ef$var$parseMilliseconds,
        "m": $ccfb70c24839d7ef$var$parseMonthNumber,
        "M": $ccfb70c24839d7ef$var$parseMinutes,
        "p": parsePeriod,
        "q": $ccfb70c24839d7ef$var$parseQuarter,
        "Q": $ccfb70c24839d7ef$var$parseUnixTimestamp,
        "s": $ccfb70c24839d7ef$var$parseUnixTimestampSeconds,
        "S": $ccfb70c24839d7ef$var$parseSeconds,
        "u": $ccfb70c24839d7ef$var$parseWeekdayNumberMonday,
        "U": $ccfb70c24839d7ef$var$parseWeekNumberSunday,
        "V": $ccfb70c24839d7ef$var$parseWeekNumberISO,
        "w": $ccfb70c24839d7ef$var$parseWeekdayNumberSunday,
        "W": $ccfb70c24839d7ef$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $ccfb70c24839d7ef$var$parseYear,
        "Y": $ccfb70c24839d7ef$var$parseFullYear,
        "Z": $ccfb70c24839d7ef$var$parseZone,
        "%": $ccfb70c24839d7ef$var$parseLiteralPercent
    }; // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $ccfb70c24839d7ef$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $ccfb70c24839d7ef$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null; // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0)); // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0; // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12; // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0; // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $ccfb70c24839d7ef$var$utcDate($ccfb70c24839d7ef$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? $a7jHS.utcMonday.ceil(week) : (0, $a7jHS.utcMonday)(week);
                    week = $a7jHS.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $ccfb70c24839d7ef$var$localDate($ccfb70c24839d7ef$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? $a7jHS.timeMonday.ceil(week) : (0, $a7jHS.timeMonday)(week);
                    week = $a7jHS.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $ccfb70c24839d7ef$var$utcDate($ccfb70c24839d7ef$var$newDate(d.y, 0, 1)).getUTCDay() : $ccfb70c24839d7ef$var$localDate($ccfb70c24839d7ef$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            } // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $ccfb70c24839d7ef$var$utcDate(d);
            } // Otherwise, all fields are in local time.
            return $ccfb70c24839d7ef$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $ccfb70c24839d7ef$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $ccfb70c24839d7ef$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $ccfb70c24839d7ef$var$numberRe = /^\s*\d+/, // note: ignores next directive
$ccfb70c24839d7ef$var$percentRe = /^%/, $ccfb70c24839d7ef$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $ccfb70c24839d7ef$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $ccfb70c24839d7ef$var$requote(s) {
    return s.replace($ccfb70c24839d7ef$var$requoteRe, "\\$&");
}
function $ccfb70c24839d7ef$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($ccfb70c24839d7ef$var$requote).join("|") + ")", "i");
}
function $ccfb70c24839d7ef$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $ccfb70c24839d7ef$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseWeekNumberSunday(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseWeekNumberISO(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseWeekNumberMonday(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseFullYear(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseYear(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseQuarter(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseMonthNumber(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseDayOfMonth(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseDayOfYear(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseHour24(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseMinutes(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseSeconds(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseMilliseconds(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseMicroseconds(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseLiteralPercent(d, string, i) {
    var n = $ccfb70c24839d7ef$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $ccfb70c24839d7ef$var$parseUnixTimestamp(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $ccfb70c24839d7ef$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $ccfb70c24839d7ef$var$formatDayOfMonth(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getDate(), p, 2);
}
function $ccfb70c24839d7ef$var$formatHour24(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getHours(), p, 2);
}
function $ccfb70c24839d7ef$var$formatHour12(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $ccfb70c24839d7ef$var$formatDayOfYear(d, p) {
    return $ccfb70c24839d7ef$var$pad(1 + $a7jHS.timeDay.count((0, $a7jHS.timeYear)(d), d), p, 3);
}
function $ccfb70c24839d7ef$var$formatMilliseconds(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getMilliseconds(), p, 3);
}
function $ccfb70c24839d7ef$var$formatMicroseconds(d, p) {
    return $ccfb70c24839d7ef$var$formatMilliseconds(d, p) + "000";
}
function $ccfb70c24839d7ef$var$formatMonthNumber(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getMonth() + 1, p, 2);
}
function $ccfb70c24839d7ef$var$formatMinutes(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getMinutes(), p, 2);
}
function $ccfb70c24839d7ef$var$formatSeconds(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getSeconds(), p, 2);
}
function $ccfb70c24839d7ef$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $ccfb70c24839d7ef$var$formatWeekNumberSunday(d, p) {
    return $ccfb70c24839d7ef$var$pad($a7jHS.timeSunday.count((0, $a7jHS.timeYear)(d) - 1, d), p, 2);
}
function $ccfb70c24839d7ef$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $a7jHS.timeThursday)(d) : $a7jHS.timeThursday.ceil(d);
}
function $ccfb70c24839d7ef$var$formatWeekNumberISO(d, p) {
    d = $ccfb70c24839d7ef$var$dISO(d);
    return $ccfb70c24839d7ef$var$pad($a7jHS.timeThursday.count((0, $a7jHS.timeYear)(d), d) + ((0, $a7jHS.timeYear)(d).getDay() === 4), p, 2);
}
function $ccfb70c24839d7ef$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $ccfb70c24839d7ef$var$formatWeekNumberMonday(d, p) {
    return $ccfb70c24839d7ef$var$pad($a7jHS.timeMonday.count((0, $a7jHS.timeYear)(d) - 1, d), p, 2);
}
function $ccfb70c24839d7ef$var$formatYear(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getFullYear() % 100, p, 2);
}
function $ccfb70c24839d7ef$var$formatYearISO(d, p) {
    d = $ccfb70c24839d7ef$var$dISO(d);
    return $ccfb70c24839d7ef$var$pad(d.getFullYear() % 100, p, 2);
}
function $ccfb70c24839d7ef$var$formatFullYear(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getFullYear() % 10000, p, 4);
}
function $ccfb70c24839d7ef$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $a7jHS.timeThursday)(d) : $a7jHS.timeThursday.ceil(d);
    return $ccfb70c24839d7ef$var$pad(d.getFullYear() % 10000, p, 4);
}
function $ccfb70c24839d7ef$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $ccfb70c24839d7ef$var$pad(z / 60 | 0, "0", 2) + $ccfb70c24839d7ef$var$pad(z % 60, "0", 2);
}
function $ccfb70c24839d7ef$var$formatUTCDayOfMonth(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getUTCDate(), p, 2);
}
function $ccfb70c24839d7ef$var$formatUTCHour24(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getUTCHours(), p, 2);
}
function $ccfb70c24839d7ef$var$formatUTCHour12(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $ccfb70c24839d7ef$var$formatUTCDayOfYear(d, p) {
    return $ccfb70c24839d7ef$var$pad(1 + $a7jHS.utcDay.count((0, $a7jHS.utcYear)(d), d), p, 3);
}
function $ccfb70c24839d7ef$var$formatUTCMilliseconds(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $ccfb70c24839d7ef$var$formatUTCMicroseconds(d, p) {
    return $ccfb70c24839d7ef$var$formatUTCMilliseconds(d, p) + "000";
}
function $ccfb70c24839d7ef$var$formatUTCMonthNumber(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $ccfb70c24839d7ef$var$formatUTCMinutes(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getUTCMinutes(), p, 2);
}
function $ccfb70c24839d7ef$var$formatUTCSeconds(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getUTCSeconds(), p, 2);
}
function $ccfb70c24839d7ef$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $ccfb70c24839d7ef$var$formatUTCWeekNumberSunday(d, p) {
    return $ccfb70c24839d7ef$var$pad($a7jHS.utcSunday.count((0, $a7jHS.utcYear)(d) - 1, d), p, 2);
}
function $ccfb70c24839d7ef$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $a7jHS.utcThursday)(d) : $a7jHS.utcThursday.ceil(d);
}
function $ccfb70c24839d7ef$var$formatUTCWeekNumberISO(d, p) {
    d = $ccfb70c24839d7ef$var$UTCdISO(d);
    return $ccfb70c24839d7ef$var$pad($a7jHS.utcThursday.count((0, $a7jHS.utcYear)(d), d) + ((0, $a7jHS.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $ccfb70c24839d7ef$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $ccfb70c24839d7ef$var$formatUTCWeekNumberMonday(d, p) {
    return $ccfb70c24839d7ef$var$pad($a7jHS.utcMonday.count((0, $a7jHS.utcYear)(d) - 1, d), p, 2);
}
function $ccfb70c24839d7ef$var$formatUTCYear(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $ccfb70c24839d7ef$var$formatUTCYearISO(d, p) {
    d = $ccfb70c24839d7ef$var$UTCdISO(d);
    return $ccfb70c24839d7ef$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $ccfb70c24839d7ef$var$formatUTCFullYear(d, p) {
    return $ccfb70c24839d7ef$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $ccfb70c24839d7ef$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $a7jHS.utcThursday)(d) : $a7jHS.utcThursday.ceil(d);
    return $ccfb70c24839d7ef$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $ccfb70c24839d7ef$var$formatUTCZone() {
    return "+0000";
}
function $ccfb70c24839d7ef$var$formatLiteralPercent() {
    return "%";
}
function $ccfb70c24839d7ef$var$formatUnixTimestamp(d) {
    return +d;
}
function $ccfb70c24839d7ef$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRegister("cX5Ls", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isoSpecifier = module.exports.default = void 0;

var $30er6 = parcelRequire("30er6");
var $96df776faae95ce0$var$isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
module.exports.isoSpecifier = $96df776faae95ce0$var$isoSpecifier;
function $96df776faae95ce0$var$formatIsoNative(date) {
    return date.toISOString();
}
var $96df776faae95ce0$var$formatIso = Date.prototype.toISOString ? $96df776faae95ce0$var$formatIsoNative : (0, $30er6.utcFormat)($96df776faae95ce0$var$isoSpecifier);
var $96df776faae95ce0$var$_default = $96df776faae95ce0$var$formatIso;
module.exports.default = $96df776faae95ce0$var$_default;

});

parcelRegister("e2YhZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cX5Ls = parcelRequire("cX5Ls");

var $30er6 = parcelRequire("30er6");
function $a3a004c04b263162$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $a3a004c04b263162$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $a3a004c04b263162$var$parseIsoNative : (0, $30er6.utcParse)($cX5Ls.isoSpecifier);
var $a3a004c04b263162$var$_default = $a3a004c04b263162$var$parseIso;
module.exports.default = $a3a004c04b263162$var$_default;

});



parcelRegister("3ZSjS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2e91345135b85899$var$utcTime;

var $a7jHS = parcelRequire("a7jHS");

var $abRJC = parcelRequire("abRJC");

var $lze8j = parcelRequire("lze8j");

var $dVAcc = parcelRequire("dVAcc");
function $2e91345135b85899$var$utcTime() {
    return $dVAcc.initRange.apply((0, $lze8j.calendar)($a7jHS.utcTicks, $a7jHS.utcTickInterval, $a7jHS.utcYear, $a7jHS.utcMonth, $a7jHS.utcWeek, $a7jHS.utcDay, $a7jHS.utcHour, $a7jHS.utcMinute, $a7jHS.utcSecond, $abRJC.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRegister("a9B8z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $76478d546f753609$var$copy;
module.exports.default = $76478d546f753609$var$sequential;
module.exports.sequentialLog = $76478d546f753609$var$sequentialLog;
module.exports.sequentialPow = $76478d546f753609$var$sequentialPow;
module.exports.sequentialSqrt = $76478d546f753609$var$sequentialSqrt;
module.exports.sequentialSymlog = $76478d546f753609$var$sequentialSymlog;

var $asL1O = parcelRequire("asL1O");

var $aiVEG = parcelRequire("aiVEG");

var $dVAcc = parcelRequire("dVAcc");

var $hHCkv = parcelRequire("hHCkv");

var $jdUqB = parcelRequire("jdUqB");

var $glCnt = parcelRequire("glCnt");

var $9R4Yk = parcelRequire("9R4Yk");
function $76478d546f753609$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = $aiVEG.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range($asL1O.interpolate);
    scale.rangeRound = range($asL1O.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $76478d546f753609$var$copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $76478d546f753609$var$sequential() {
    var scale = (0, $hHCkv.linearish)($76478d546f753609$var$transformer()($aiVEG.identity));
    scale.copy = function() {
        return $76478d546f753609$var$copy(scale, $76478d546f753609$var$sequential());
    };
    return $dVAcc.initInterpolator.apply(scale, arguments);
}
function $76478d546f753609$var$sequentialLog() {
    var scale = (0, $jdUqB.loggish)($76478d546f753609$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $76478d546f753609$var$copy(scale, $76478d546f753609$var$sequentialLog()).base(scale.base());
    };
    return $dVAcc.initInterpolator.apply(scale, arguments);
}
function $76478d546f753609$var$sequentialSymlog() {
    var scale = (0, $glCnt.symlogish)($76478d546f753609$var$transformer());
    scale.copy = function() {
        return $76478d546f753609$var$copy(scale, $76478d546f753609$var$sequentialSymlog()).constant(scale.constant());
    };
    return $dVAcc.initInterpolator.apply(scale, arguments);
}
function $76478d546f753609$var$sequentialPow() {
    var scale = (0, $9R4Yk.powish)($76478d546f753609$var$transformer());
    scale.copy = function() {
        return $76478d546f753609$var$copy(scale, $76478d546f753609$var$sequentialPow()).exponent(scale.exponent());
    };
    return $dVAcc.initInterpolator.apply(scale, arguments);
}
function $76478d546f753609$var$sequentialSqrt() {
    return $76478d546f753609$var$sequentialPow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("jatwg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $df45d96e9fe52c57$var$sequentialQuantile;

var $k5p7I = parcelRequire("k5p7I");

var $aiVEG = parcelRequire("aiVEG");

var $dVAcc = parcelRequire("dVAcc");
function $df45d96e9fe52c57$var$sequentialQuantile() {
    var domain = [], interpolator = $aiVEG.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $k5p7I.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($k5p7I.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $k5p7I.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return $df45d96e9fe52c57$var$sequentialQuantile(interpolator).domain(domain);
    };
    return $dVAcc.initInterpolator.apply(scale, arguments);
}

});

parcelRegister("5i1Ze", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3da02caf9c6b3ea1$var$diverging;
module.exports.divergingLog = $3da02caf9c6b3ea1$var$divergingLog;
module.exports.divergingPow = $3da02caf9c6b3ea1$var$divergingPow;
module.exports.divergingSqrt = $3da02caf9c6b3ea1$var$divergingSqrt;
module.exports.divergingSymlog = $3da02caf9c6b3ea1$var$divergingSymlog;

var $asL1O = parcelRequire("asL1O");

var $aiVEG = parcelRequire("aiVEG");

var $dVAcc = parcelRequire("dVAcc");

var $hHCkv = parcelRequire("hHCkv");

var $jdUqB = parcelRequire("jdUqB");

var $a9B8z = parcelRequire("a9B8z");

var $glCnt = parcelRequire("glCnt");

var $9R4Yk = parcelRequire("9R4Yk");
function $3da02caf9c6b3ea1$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = $aiVEG.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $asL1O.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range($asL1O.interpolate);
    scale.rangeRound = range($asL1O.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $3da02caf9c6b3ea1$var$diverging() {
    var scale = (0, $hHCkv.linearish)($3da02caf9c6b3ea1$var$transformer()($aiVEG.identity));
    scale.copy = function() {
        return (0, $a9B8z.copy)(scale, $3da02caf9c6b3ea1$var$diverging());
    };
    return $dVAcc.initInterpolator.apply(scale, arguments);
}
function $3da02caf9c6b3ea1$var$divergingLog() {
    var scale = (0, $jdUqB.loggish)($3da02caf9c6b3ea1$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $a9B8z.copy)(scale, $3da02caf9c6b3ea1$var$divergingLog()).base(scale.base());
    };
    return $dVAcc.initInterpolator.apply(scale, arguments);
}
function $3da02caf9c6b3ea1$var$divergingSymlog() {
    var scale = (0, $glCnt.symlogish)($3da02caf9c6b3ea1$var$transformer());
    scale.copy = function() {
        return (0, $a9B8z.copy)(scale, $3da02caf9c6b3ea1$var$divergingSymlog()).constant(scale.constant());
    };
    return $dVAcc.initInterpolator.apply(scale, arguments);
}
function $3da02caf9c6b3ea1$var$divergingPow() {
    var scale = (0, $9R4Yk.powish)($3da02caf9c6b3ea1$var$transformer());
    scale.copy = function() {
        return (0, $a9B8z.copy)(scale, $3da02caf9c6b3ea1$var$divergingPow()).exponent(scale.exponent());
    };
    return $dVAcc.initInterpolator.apply(scale, arguments);
}
function $3da02caf9c6b3ea1$var$divergingSqrt() {
    return $3da02caf9c6b3ea1$var$divergingPow.apply(null, arguments).exponent(0.5);
}

});



parcelRegister("3kTGk", function(module, exports) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`

module.exports = (parcelRequire("gfgOr"));

});
parcelRegister("gfgOr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "arc", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_arc.default;
    }
});
Object.defineProperty(module.exports, "area", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_area.default;
    }
});
Object.defineProperty(module.exports, "areaRadial", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "curveBasis", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "curveBasisClosed", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "curveBasisOpen", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_basisOpen.default;
    }
});
Object.defineProperty(module.exports, "curveBumpX", {
    enumerable: true,
    get: function() {
        return $2baBG.bumpX;
    }
});
Object.defineProperty(module.exports, "curveBumpY", {
    enumerable: true,
    get: function() {
        return $2baBG.bumpY;
    }
});
Object.defineProperty(module.exports, "curveBundle", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_bundle.default;
    }
});
Object.defineProperty(module.exports, "curveCardinal", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_cardinal.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalClosed", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_cardinalClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalOpen", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_cardinalOpen.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRom", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_catmullRom.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_catmullRomClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_catmullRomOpen.default;
    }
});
Object.defineProperty(module.exports, "curveLinear", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "curveLinearClosed", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_linearClosed.default;
    }
});
Object.defineProperty(module.exports, "curveMonotoneX", {
    enumerable: true,
    get: function() {
        return $cAgWu.monotoneX;
    }
});
Object.defineProperty(module.exports, "curveMonotoneY", {
    enumerable: true,
    get: function() {
        return $cAgWu.monotoneY;
    }
});
Object.defineProperty(module.exports, "curveNatural", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_natural.default;
    }
});
Object.defineProperty(module.exports, "curveStep", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_step.default;
    }
});
Object.defineProperty(module.exports, "curveStepAfter", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_step.stepAfter;
    }
});
Object.defineProperty(module.exports, "curveStepBefore", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_step.stepBefore;
    }
});
Object.defineProperty(module.exports, "line", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_line.default;
    }
});
Object.defineProperty(module.exports, "lineRadial", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "link", {
    enumerable: true,
    get: function() {
        return $iKlfq.link;
    }
});
Object.defineProperty(module.exports, "linkHorizontal", {
    enumerable: true,
    get: function() {
        return $iKlfq.linkHorizontal;
    }
});
Object.defineProperty(module.exports, "linkRadial", {
    enumerable: true,
    get: function() {
        return $iKlfq.linkRadial;
    }
});
Object.defineProperty(module.exports, "linkVertical", {
    enumerable: true,
    get: function() {
        return $iKlfq.linkVertical;
    }
});
Object.defineProperty(module.exports, "pie", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_pie.default;
    }
});
Object.defineProperty(module.exports, "pointRadial", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_pointRadial.default;
    }
});
Object.defineProperty(module.exports, "radialArea", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "radialLine", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "stack", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_stack.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetExpand", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_expand.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetNone", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_none.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_silhouette.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_wiggle.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAppearance", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_appearance.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAscending", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderDescending", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_insideOut.default;
    }
});
Object.defineProperty(module.exports, "stackOrderNone", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_none2.default;
    }
});
Object.defineProperty(module.exports, "stackOrderReverse", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "symbol", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_symbol.default;
    }
});
Object.defineProperty(module.exports, "symbolAsterisk", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_asterisk.default;
    }
});
Object.defineProperty(module.exports, "symbolCircle", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_circle.default;
    }
});
Object.defineProperty(module.exports, "symbolCross", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_diamond.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond2", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_diamond2.default;
    }
});
Object.defineProperty(module.exports, "symbolPlus", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_plus.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_square.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare2", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_square2.default;
    }
});
Object.defineProperty(module.exports, "symbolStar", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_star.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_triangle.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle2", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_triangle2.default;
    }
});
Object.defineProperty(module.exports, "symbolWye", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_wye.default;
    }
});
Object.defineProperty(module.exports, "symbolX", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_x.default;
    }
});
Object.defineProperty(module.exports, "symbols", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsFill", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsStroke", {
    enumerable: true,
    get: function() {
        return $bd3b16ab731a8bf0$var$_symbol.symbolsStroke;
    }
});

var $bd3b16ab731a8bf0$var$_arc = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("elRpZ")));

var $bd3b16ab731a8bf0$var$_area = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("gS2TC")));

var $bd3b16ab731a8bf0$var$_line = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("7N8XC")));

var $bd3b16ab731a8bf0$var$_pie = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("bgX8T")));

var $bd3b16ab731a8bf0$var$_areaRadial = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("9chv5")));

var $bd3b16ab731a8bf0$var$_lineRadial = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("6ZTS2")));

var $bd3b16ab731a8bf0$var$_pointRadial = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("ktVyl")));

var $iKlfq = parcelRequire("iKlfq");

var $bd3b16ab731a8bf0$var$_symbol = $bd3b16ab731a8bf0$var$_interopRequireWildcard((parcelRequire("kO7AZ")));

var $bd3b16ab731a8bf0$var$_asterisk = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("dbcns")));

var $bd3b16ab731a8bf0$var$_circle = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("hqkBb")));

var $bd3b16ab731a8bf0$var$_cross = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("l7oKy")));

var $bd3b16ab731a8bf0$var$_diamond = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("1vGBb")));

var $bd3b16ab731a8bf0$var$_diamond2 = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("d39kR")));

var $bd3b16ab731a8bf0$var$_plus = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("gHoIh")));

var $bd3b16ab731a8bf0$var$_square = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("jGx5Y")));

var $bd3b16ab731a8bf0$var$_square2 = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("h3HrK")));

var $bd3b16ab731a8bf0$var$_star = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("eItmn")));

var $bd3b16ab731a8bf0$var$_triangle = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("gRLO6")));

var $bd3b16ab731a8bf0$var$_triangle2 = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("5YgcO")));

var $bd3b16ab731a8bf0$var$_wye = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("jWKwo")));

var $bd3b16ab731a8bf0$var$_x = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("42j01")));

var $bd3b16ab731a8bf0$var$_basisClosed = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("4LqwK")));

var $bd3b16ab731a8bf0$var$_basisOpen = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("4ACCw")));

var $bd3b16ab731a8bf0$var$_basis = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("dqqOB")));

var $2baBG = parcelRequire("2baBG");

var $bd3b16ab731a8bf0$var$_bundle = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("8nEjr")));

var $bd3b16ab731a8bf0$var$_cardinalClosed = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("bzrZk")));

var $bd3b16ab731a8bf0$var$_cardinalOpen = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("fTXUm")));

var $bd3b16ab731a8bf0$var$_cardinal = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("1hE1S")));

var $bd3b16ab731a8bf0$var$_catmullRomClosed = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("35AdY")));

var $bd3b16ab731a8bf0$var$_catmullRomOpen = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("ls28s")));

var $bd3b16ab731a8bf0$var$_catmullRom = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("knKEk")));

var $bd3b16ab731a8bf0$var$_linearClosed = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("e53uY")));

var $bd3b16ab731a8bf0$var$_linear = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("63A84")));

var $cAgWu = parcelRequire("cAgWu");

var $bd3b16ab731a8bf0$var$_natural = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("kg6IS")));

var $bd3b16ab731a8bf0$var$_step = $bd3b16ab731a8bf0$var$_interopRequireWildcard((parcelRequire("hbQiR")));

var $bd3b16ab731a8bf0$var$_stack = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("10FpT")));

var $bd3b16ab731a8bf0$var$_expand = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("2fNxx")));

var $bd3b16ab731a8bf0$var$_diverging = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("6a5UN")));

var $bd3b16ab731a8bf0$var$_none = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("boWNO")));

var $bd3b16ab731a8bf0$var$_silhouette = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("9ehm8")));

var $bd3b16ab731a8bf0$var$_wiggle = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("306kH")));

var $bd3b16ab731a8bf0$var$_appearance = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("f5Lyt")));

var $bd3b16ab731a8bf0$var$_ascending = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("ffEmz")));

var $bd3b16ab731a8bf0$var$_descending = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("aQPCV")));

var $bd3b16ab731a8bf0$var$_insideOut = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("4aPb6")));

var $bd3b16ab731a8bf0$var$_none2 = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("kymiB")));

var $bd3b16ab731a8bf0$var$_reverse = $bd3b16ab731a8bf0$var$_interopRequireDefault((parcelRequire("4uoTs")));
function $bd3b16ab731a8bf0$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($bd3b16ab731a8bf0$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $bd3b16ab731a8bf0$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $bd3b16ab731a8bf0$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $bd3b16ab731a8bf0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("elRpZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a72c769c892a94c3$var$_default;

var $6ECsr = parcelRequire("6ECsr");

var $a72c769c892a94c3$var$_constant = $a72c769c892a94c3$var$_interopRequireDefault((parcelRequire("8jJxm")));

var $ig0Mq = parcelRequire("ig0Mq");
function $a72c769c892a94c3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a72c769c892a94c3$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $a72c769c892a94c3$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $a72c769c892a94c3$var$arcStartAngle(d) {
    return d.startAngle;
}
function $a72c769c892a94c3$var$arcEndAngle(d) {
    return d.endAngle;
}
function $a72c769c892a94c3$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $a72c769c892a94c3$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < $ig0Mq.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
} // Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $a72c769c892a94c3$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $ig0Mq.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $ig0Mq.sqrt)((0, $ig0Mq.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00; // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $a72c769c892a94c3$var$_default() {
    var innerRadius = $a72c769c892a94c3$var$arcInnerRadius, outerRadius = $a72c769c892a94c3$var$arcOuterRadius, cornerRadius = (0, $a72c769c892a94c3$var$_constant.default)(0), padRadius = null, startAngle = $a72c769c892a94c3$var$arcStartAngle, endAngle = $a72c769c892a94c3$var$arcEndAngle, padAngle = $a72c769c892a94c3$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - $ig0Mq.halfPi, a1 = endAngle.apply(this, arguments) - $ig0Mq.halfPi, da = (0, $ig0Mq.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $6ECsr.path)(); // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r; // Is it a point?
        if (!(r1 > $ig0Mq.epsilon)) context.moveTo(0, 0); // Or is it a circle or annulus?
        else if (da > $ig0Mq.tau - $ig0Mq.epsilon) {
            context.moveTo(r1 * (0, $ig0Mq.cos)(a0), r1 * (0, $ig0Mq.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > $ig0Mq.epsilon) {
                context.moveTo(r0 * (0, $ig0Mq.cos)(a1), r0 * (0, $ig0Mq.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > $ig0Mq.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, $ig0Mq.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $ig0Mq.min)((0, $ig0Mq.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1; // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > $ig0Mq.epsilon) {
                var p0 = (0, $ig0Mq.asin)(rp / r0 * (0, $ig0Mq.sin)(ap)), p1 = (0, $ig0Mq.asin)(rp / r1 * (0, $ig0Mq.sin)(ap));
                if ((da0 -= p0 * 2) > $ig0Mq.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > $ig0Mq.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $ig0Mq.cos)(a01), y01 = r1 * (0, $ig0Mq.sin)(a01), x10 = r0 * (0, $ig0Mq.cos)(a10), y10 = r0 * (0, $ig0Mq.sin)(a10); // Apply rounded corners?
            if (rc > $ig0Mq.epsilon) {
                var x11 = r1 * (0, $ig0Mq.cos)(a11), y11 = r1 * (0, $ig0Mq.sin)(a11), x00 = r0 * (0, $ig0Mq.cos)(a00), y00 = r0 * (0, $ig0Mq.sin)(a00), oc; // Restrict the corner radius according to the sector angle.
                if (da < $ig0Mq.pi && (oc = $a72c769c892a94c3$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $ig0Mq.sin)((0, $ig0Mq.acos)((ax * bx + ay * by) / ((0, $ig0Mq.sqrt)(ax * ax + ay * ay) * (0, $ig0Mq.sqrt)(bx * bx + by * by))) / 2), lc = (0, $ig0Mq.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $ig0Mq.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $ig0Mq.min)(rc, (r1 - lc) / (kc + 1));
                }
            } // Is the sector collapsed to a line?
            if (!(da1 > $ig0Mq.epsilon)) context.moveTo(x01, y01); // Does the sector’s outer ring have rounded corners?
            else if (rc1 > $ig0Mq.epsilon) {
                t0 = $a72c769c892a94c3$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $a72c769c892a94c3$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $ig0Mq.atan2)(t0.y01, t0.x01), (0, $ig0Mq.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $ig0Mq.atan2)(t0.y01, t0.x01), (0, $ig0Mq.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $ig0Mq.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $ig0Mq.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $ig0Mq.atan2)(t1.y11, t1.x11), (0, $ig0Mq.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw); // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > $ig0Mq.epsilon) || !(da0 > $ig0Mq.epsilon)) context.lineTo(x10, y10); // Does the sector’s inner ring (or point) have rounded corners?
            else if (rc0 > $ig0Mq.epsilon) {
                t0 = $a72c769c892a94c3$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $a72c769c892a94c3$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $ig0Mq.atan2)(t0.y01, t0.x01), (0, $ig0Mq.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $ig0Mq.atan2)(t0.y01, t0.x01), (0, $ig0Mq.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $ig0Mq.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $ig0Mq.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $ig0Mq.atan2)(t1.y11, t1.x11), (0, $ig0Mq.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - $ig0Mq.pi / 2;
        return [
            (0, $ig0Mq.cos)(a) * r,
            (0, $ig0Mq.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $a72c769c892a94c3$var$_constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $a72c769c892a94c3$var$_constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $a72c769c892a94c3$var$_constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $a72c769c892a94c3$var$_constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $a72c769c892a94c3$var$_constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $a72c769c892a94c3$var$_constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $a72c769c892a94c3$var$_constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("6ECsr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "path", {
    enumerable: true,
    get: function() {
        return $4d844f69f7836a64$var$_path.default;
    }
});

var $4d844f69f7836a64$var$_path = $4d844f69f7836a64$var$_interopRequireDefault((parcelRequire("1gkEM")));
function $4d844f69f7836a64$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("1gkEM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $0eb74f127941ed8e$var$pi = Math.PI, $0eb74f127941ed8e$var$tau = 2 * $0eb74f127941ed8e$var$pi, $0eb74f127941ed8e$var$epsilon = 1e-6, $0eb74f127941ed8e$var$tauEpsilon = $0eb74f127941ed8e$var$tau - $0eb74f127941ed8e$var$epsilon;
function $0eb74f127941ed8e$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $0eb74f127941ed8e$var$path() {
    return new $0eb74f127941ed8e$var$Path();
}
$0eb74f127941ed8e$var$Path.prototype = $0eb74f127941ed8e$var$path.prototype = {
    constructor: $0eb74f127941ed8e$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $0eb74f127941ed8e$var$epsilon)) ; // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $0eb74f127941ed8e$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($0eb74f127941ed8e$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21; // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $0eb74f127941ed8e$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $0eb74f127941ed8e$var$epsilon || Math.abs(this._y1 - y0) > $0eb74f127941ed8e$var$epsilon) this._ += "L" + x0 + "," + y0;
         // Is this arc empty? We’re done.
        if (!r) return; // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $0eb74f127941ed8e$var$tau + $0eb74f127941ed8e$var$tau; // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $0eb74f127941ed8e$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $0eb74f127941ed8e$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $0eb74f127941ed8e$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $0eb74f127941ed8e$var$_default = $0eb74f127941ed8e$var$path;
module.exports.default = $0eb74f127941ed8e$var$_default;

});


parcelRegister("8jJxm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $60e36bc81be26027$var$_default;
function $60e36bc81be26027$var$_default(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("ig0Mq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.abs = void 0;
module.exports.acos = $d4aa537edeb5204d$var$acos;
module.exports.asin = $d4aa537edeb5204d$var$asin;
module.exports.tau = module.exports.sqrt = module.exports.sin = module.exports.pi = module.exports.min = module.exports.max = module.exports.halfPi = module.exports.epsilon = module.exports.cos = module.exports.atan2 = void 0;
const $d4aa537edeb5204d$var$abs = Math.abs;
module.exports.abs = $d4aa537edeb5204d$var$abs;
const $d4aa537edeb5204d$var$atan2 = Math.atan2;
module.exports.atan2 = $d4aa537edeb5204d$var$atan2;
const $d4aa537edeb5204d$var$cos = Math.cos;
module.exports.cos = $d4aa537edeb5204d$var$cos;
const $d4aa537edeb5204d$var$max = Math.max;
module.exports.max = $d4aa537edeb5204d$var$max;
const $d4aa537edeb5204d$var$min = Math.min;
module.exports.min = $d4aa537edeb5204d$var$min;
const $d4aa537edeb5204d$var$sin = Math.sin;
module.exports.sin = $d4aa537edeb5204d$var$sin;
const $d4aa537edeb5204d$var$sqrt = Math.sqrt;
module.exports.sqrt = $d4aa537edeb5204d$var$sqrt;
const $d4aa537edeb5204d$var$epsilon = 1e-12;
module.exports.epsilon = $d4aa537edeb5204d$var$epsilon;
const $d4aa537edeb5204d$var$pi = Math.PI;
module.exports.pi = $d4aa537edeb5204d$var$pi;
const $d4aa537edeb5204d$var$halfPi = $d4aa537edeb5204d$var$pi / 2;
module.exports.halfPi = $d4aa537edeb5204d$var$halfPi;
const $d4aa537edeb5204d$var$tau = 2 * $d4aa537edeb5204d$var$pi;
module.exports.tau = $d4aa537edeb5204d$var$tau;
function $d4aa537edeb5204d$var$acos(x) {
    return x > 1 ? 0 : x < -1 ? $d4aa537edeb5204d$var$pi : Math.acos(x);
}
function $d4aa537edeb5204d$var$asin(x) {
    return x >= 1 ? $d4aa537edeb5204d$var$halfPi : x <= -1 ? -$d4aa537edeb5204d$var$halfPi : Math.asin(x);
}

});


parcelRegister("gS2TC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c483ef965bb9f52d$var$_default;

var $6ECsr = parcelRequire("6ECsr");

var $c483ef965bb9f52d$var$_array = $c483ef965bb9f52d$var$_interopRequireDefault((parcelRequire("1Joyq")));

var $c483ef965bb9f52d$var$_constant = $c483ef965bb9f52d$var$_interopRequireDefault((parcelRequire("8jJxm")));

var $c483ef965bb9f52d$var$_linear = $c483ef965bb9f52d$var$_interopRequireDefault((parcelRequire("63A84")));

var $c483ef965bb9f52d$var$_line = $c483ef965bb9f52d$var$_interopRequireDefault((parcelRequire("7N8XC")));

var $ht2xs = parcelRequire("ht2xs");
function $c483ef965bb9f52d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c483ef965bb9f52d$var$_default(x0, y0, y1) {
    var x1 = null, defined = (0, $c483ef965bb9f52d$var$_constant.default)(true), context = null, curve = $c483ef965bb9f52d$var$_linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? $ht2xs.x : (0, $c483ef965bb9f52d$var$_constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $c483ef965bb9f52d$var$_constant.default)(0) : (0, $c483ef965bb9f52d$var$_constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? $ht2xs.y : (0, $c483ef965bb9f52d$var$_constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $c483ef965bb9f52d$var$_array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $6ECsr.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $c483ef965bb9f52d$var$_line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $c483ef965bb9f52d$var$_constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $c483ef965bb9f52d$var$_constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $c483ef965bb9f52d$var$_constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $c483ef965bb9f52d$var$_constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $c483ef965bb9f52d$var$_constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $c483ef965bb9f52d$var$_constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $c483ef965bb9f52d$var$_constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("1Joyq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $142d0a6576e73134$var$_default;
module.exports.slice = void 0;
var $142d0a6576e73134$var$slice = Array.prototype.slice;
module.exports.slice = $142d0a6576e73134$var$slice;
function $142d0a6576e73134$var$_default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("63A84", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $468f0c69528eb9c3$var$_default;
function $468f0c69528eb9c3$var$Linear(context) {
    this._context = context;
}
$468f0c69528eb9c3$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $468f0c69528eb9c3$var$_default(context) {
    return new $468f0c69528eb9c3$var$Linear(context);
}

});

parcelRegister("7N8XC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5ac40f6641846b59$var$_default;

var $6ECsr = parcelRequire("6ECsr");

var $5ac40f6641846b59$var$_array = $5ac40f6641846b59$var$_interopRequireDefault((parcelRequire("1Joyq")));

var $5ac40f6641846b59$var$_constant = $5ac40f6641846b59$var$_interopRequireDefault((parcelRequire("8jJxm")));

var $5ac40f6641846b59$var$_linear = $5ac40f6641846b59$var$_interopRequireDefault((parcelRequire("63A84")));

var $ht2xs = parcelRequire("ht2xs");
function $5ac40f6641846b59$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5ac40f6641846b59$var$_default(x, y) {
    var defined = (0, $5ac40f6641846b59$var$_constant.default)(true), context = null, curve = $5ac40f6641846b59$var$_linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? $ht2xs.x : (0, $5ac40f6641846b59$var$_constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? $ht2xs.y : (0, $5ac40f6641846b59$var$_constant.default)(y);
    function line(data) {
        var i, n = (data = (0, $5ac40f6641846b59$var$_array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $6ECsr.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $5ac40f6641846b59$var$_constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $5ac40f6641846b59$var$_constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $5ac40f6641846b59$var$_constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("ht2xs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.x = $cb771d3dedd7df05$var$x;
module.exports.y = $cb771d3dedd7df05$var$y;
function $cb771d3dedd7df05$var$x(p) {
    return p[0];
}
function $cb771d3dedd7df05$var$y(p) {
    return p[1];
}

});



parcelRegister("bgX8T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $834f10cc0d12313a$var$_default;

var $834f10cc0d12313a$var$_array = $834f10cc0d12313a$var$_interopRequireDefault((parcelRequire("1Joyq")));

var $834f10cc0d12313a$var$_constant = $834f10cc0d12313a$var$_interopRequireDefault((parcelRequire("8jJxm")));

var $834f10cc0d12313a$var$_descending = $834f10cc0d12313a$var$_interopRequireDefault((parcelRequire("7kkzx")));

var $834f10cc0d12313a$var$_identity = $834f10cc0d12313a$var$_interopRequireDefault((parcelRequire("8aNJQ")));

var $ig0Mq = parcelRequire("ig0Mq");
function $834f10cc0d12313a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $834f10cc0d12313a$var$_default() {
    var value = $834f10cc0d12313a$var$_identity.default, sortValues = $834f10cc0d12313a$var$_descending.default, sort = null, startAngle = (0, $834f10cc0d12313a$var$_constant.default)(0), endAngle = (0, $834f10cc0d12313a$var$_constant.default)($ig0Mq.tau), padAngle = (0, $834f10cc0d12313a$var$_constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, $834f10cc0d12313a$var$_array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min($ig0Mq.tau, Math.max(-$ig0Mq.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
         // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        }); // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $834f10cc0d12313a$var$_constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $834f10cc0d12313a$var$_constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $834f10cc0d12313a$var$_constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $834f10cc0d12313a$var$_constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("7kkzx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $555a5bd86b7b72f6$var$_default;
function $555a5bd86b7b72f6$var$_default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("8aNJQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5f35d6e69eddef7c$var$_default;
function $5f35d6e69eddef7c$var$_default(d) {
    return d;
}

});


parcelRegister("9chv5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6b22cf482fefb72a$var$_default;

var $6b22cf482fefb72a$var$_radial = $6b22cf482fefb72a$var$_interopRequireWildcard((parcelRequire("1DlwC")));

var $6b22cf482fefb72a$var$_area = $6b22cf482fefb72a$var$_interopRequireDefault((parcelRequire("gS2TC")));

var $6ZTS2 = parcelRequire("6ZTS2");
function $6b22cf482fefb72a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6b22cf482fefb72a$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($6b22cf482fefb72a$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $6b22cf482fefb72a$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $6b22cf482fefb72a$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $6b22cf482fefb72a$var$_default() {
    var a = (0, $6b22cf482fefb72a$var$_area.default)().curve($6b22cf482fefb72a$var$_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $6ZTS2.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $6ZTS2.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $6ZTS2.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $6ZTS2.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $6b22cf482fefb72a$var$_radial.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRegister("1DlwC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.curveRadialLinear = void 0;
module.exports.default = $130a2162ff2e37e0$var$curveRadial;

var $130a2162ff2e37e0$var$_linear = $130a2162ff2e37e0$var$_interopRequireDefault((parcelRequire("63A84")));
function $130a2162ff2e37e0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $130a2162ff2e37e0$var$curveRadialLinear = $130a2162ff2e37e0$var$curveRadial($130a2162ff2e37e0$var$_linear.default);
module.exports.curveRadialLinear = $130a2162ff2e37e0$var$curveRadialLinear;
function $130a2162ff2e37e0$var$Radial(curve) {
    this._curve = curve;
}
$130a2162ff2e37e0$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $130a2162ff2e37e0$var$curveRadial(curve) {
    function radial(context) {
        return new $130a2162ff2e37e0$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRegister("6ZTS2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5183c74b00000e4c$var$_default;
module.exports.lineRadial = $5183c74b00000e4c$var$lineRadial;

var $5183c74b00000e4c$var$_radial = $5183c74b00000e4c$var$_interopRequireWildcard((parcelRequire("1DlwC")));

var $5183c74b00000e4c$var$_line = $5183c74b00000e4c$var$_interopRequireDefault((parcelRequire("7N8XC")));
function $5183c74b00000e4c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5183c74b00000e4c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($5183c74b00000e4c$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $5183c74b00000e4c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $5183c74b00000e4c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $5183c74b00000e4c$var$lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $5183c74b00000e4c$var$_radial.default)(_)) : c()._curve;
    };
    return l;
}
function $5183c74b00000e4c$var$_default() {
    return $5183c74b00000e4c$var$lineRadial((0, $5183c74b00000e4c$var$_line.default)().curve($5183c74b00000e4c$var$_radial.curveRadialLinear));
}

});


parcelRegister("ktVyl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ee9328eb446de5f7$var$_default;
function $ee9328eb446de5f7$var$_default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRegister("iKlfq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.link = $da5d0137600e9a35$var$link;
module.exports.linkHorizontal = $da5d0137600e9a35$var$linkHorizontal;
module.exports.linkRadial = $da5d0137600e9a35$var$linkRadial;
module.exports.linkVertical = $da5d0137600e9a35$var$linkVertical;

var $6ECsr = parcelRequire("6ECsr");

var $1Joyq = parcelRequire("1Joyq");

var $da5d0137600e9a35$var$_constant = $da5d0137600e9a35$var$_interopRequireDefault((parcelRequire("8jJxm")));

var $2baBG = parcelRequire("2baBG");

var $ht2xs = parcelRequire("ht2xs");
function $da5d0137600e9a35$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $da5d0137600e9a35$var$linkSource(d) {
    return d.source;
}
function $da5d0137600e9a35$var$linkTarget(d) {
    return d.target;
}
function $da5d0137600e9a35$var$link(curve) {
    let source = $da5d0137600e9a35$var$linkSource;
    let target = $da5d0137600e9a35$var$linkTarget;
    let x = $ht2xs.x;
    let y = $ht2xs.y;
    let context = null;
    let output = null;
    function link() {
        let buffer;
        const argv = $1Joyq.slice.call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, $6ECsr.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $da5d0137600e9a35$var$_constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $da5d0137600e9a35$var$_constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $da5d0137600e9a35$var$linkHorizontal() {
    return $da5d0137600e9a35$var$link($2baBG.bumpX);
}
function $da5d0137600e9a35$var$linkVertical() {
    return $da5d0137600e9a35$var$link($2baBG.bumpY);
}
function $da5d0137600e9a35$var$linkRadial() {
    const l = $da5d0137600e9a35$var$link($2baBG.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRegister("2baBG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bumpRadial = $1964d62a208e710a$var$bumpRadial;
module.exports.bumpX = $1964d62a208e710a$var$bumpX;
module.exports.bumpY = $1964d62a208e710a$var$bumpY;

var $1964d62a208e710a$var$_pointRadial = $1964d62a208e710a$var$_interopRequireDefault((parcelRequire("ktVyl")));
function $1964d62a208e710a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class $1964d62a208e710a$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $1964d62a208e710a$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point++ === 0) this._x0 = x, this._y0 = y;
        else {
            const p0 = (0, $1964d62a208e710a$var$_pointRadial.default)(this._x0, this._y0);
            const p1 = (0, $1964d62a208e710a$var$_pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $1964d62a208e710a$var$_pointRadial.default)(x, this._y0);
            const p3 = (0, $1964d62a208e710a$var$_pointRadial.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
    }
}
function $1964d62a208e710a$var$bumpX(context) {
    return new $1964d62a208e710a$var$Bump(context, true);
}
function $1964d62a208e710a$var$bumpY(context) {
    return new $1964d62a208e710a$var$Bump(context, false);
}
function $1964d62a208e710a$var$bumpRadial(context) {
    return new $1964d62a208e710a$var$BumpRadial(context);
}

});


parcelRegister("kO7AZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f25e5e7d622fb590$var$Symbol;
module.exports.symbolsStroke = module.exports.symbolsFill = void 0;

var $6ECsr = parcelRequire("6ECsr");

var $f25e5e7d622fb590$var$_constant = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("8jJxm")));

var $f25e5e7d622fb590$var$_asterisk = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("dbcns")));

var $f25e5e7d622fb590$var$_circle = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("hqkBb")));

var $f25e5e7d622fb590$var$_cross = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("l7oKy")));

var $f25e5e7d622fb590$var$_diamond = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("1vGBb")));

var $f25e5e7d622fb590$var$_diamond2 = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("d39kR")));

var $f25e5e7d622fb590$var$_plus = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("gHoIh")));

var $f25e5e7d622fb590$var$_square = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("jGx5Y")));

var $f25e5e7d622fb590$var$_square2 = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("h3HrK")));

var $f25e5e7d622fb590$var$_star = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("eItmn")));

var $f25e5e7d622fb590$var$_triangle = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("gRLO6")));

var $f25e5e7d622fb590$var$_triangle2 = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("5YgcO")));

var $f25e5e7d622fb590$var$_wye = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("jWKwo")));

var $f25e5e7d622fb590$var$_x = $f25e5e7d622fb590$var$_interopRequireDefault((parcelRequire("42j01")));
function $f25e5e7d622fb590$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
const $f25e5e7d622fb590$var$symbolsFill = [
    $f25e5e7d622fb590$var$_circle.default,
    $f25e5e7d622fb590$var$_cross.default,
    $f25e5e7d622fb590$var$_diamond.default,
    $f25e5e7d622fb590$var$_square.default,
    $f25e5e7d622fb590$var$_star.default,
    $f25e5e7d622fb590$var$_triangle.default,
    $f25e5e7d622fb590$var$_wye.default
]; // These symbols are designed to be stroked (with a width of 1.5px and round caps).
module.exports.symbolsFill = $f25e5e7d622fb590$var$symbolsFill;
const $f25e5e7d622fb590$var$symbolsStroke = [
    $f25e5e7d622fb590$var$_circle.default,
    $f25e5e7d622fb590$var$_plus.default,
    $f25e5e7d622fb590$var$_x.default,
    $f25e5e7d622fb590$var$_triangle2.default,
    $f25e5e7d622fb590$var$_asterisk.default,
    $f25e5e7d622fb590$var$_square2.default,
    $f25e5e7d622fb590$var$_diamond2.default
];
module.exports.symbolsStroke = $f25e5e7d622fb590$var$symbolsStroke;
function $f25e5e7d622fb590$var$Symbol(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, $f25e5e7d622fb590$var$_constant.default)(type || $f25e5e7d622fb590$var$_circle.default);
    size = typeof size === "function" ? size : (0, $f25e5e7d622fb590$var$_constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, $6ECsr.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $f25e5e7d622fb590$var$_constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $f25e5e7d622fb590$var$_constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRegister("dbcns", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ig0Mq = parcelRequire("ig0Mq");
const $9985e7557a3cd12a$var$sqrt3 = (0, $ig0Mq.sqrt)(3);
var $9985e7557a3cd12a$var$_default = {
    draw (context, size) {
        const r = (0, $ig0Mq.sqrt)(size + (0, $ig0Mq.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $9985e7557a3cd12a$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};
module.exports.default = $9985e7557a3cd12a$var$_default;

});

parcelRegister("hqkBb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ig0Mq = parcelRequire("ig0Mq");
var $caf4d7d747950d99$var$_default = {
    draw (context, size) {
        const r = (0, $ig0Mq.sqrt)(size / $ig0Mq.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, $ig0Mq.tau);
    }
};
module.exports.default = $caf4d7d747950d99$var$_default;

});

parcelRegister("l7oKy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ig0Mq = parcelRequire("ig0Mq");
var $f5fd733e8a665c56$var$_default = {
    draw (context, size) {
        const r = (0, $ig0Mq.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};
module.exports.default = $f5fd733e8a665c56$var$_default;

});

parcelRegister("1vGBb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ig0Mq = parcelRequire("ig0Mq");
const $1199bae444d0594d$var$tan30 = (0, $ig0Mq.sqrt)(1 / 3);
const $1199bae444d0594d$var$tan30_2 = $1199bae444d0594d$var$tan30 * 2;
var $1199bae444d0594d$var$_default = {
    draw (context, size) {
        const y = (0, $ig0Mq.sqrt)(size / $1199bae444d0594d$var$tan30_2);
        const x = y * $1199bae444d0594d$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};
module.exports.default = $1199bae444d0594d$var$_default;

});

parcelRegister("d39kR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ig0Mq = parcelRequire("ig0Mq");
var $9802cc06456a4377$var$_default = {
    draw (context, size) {
        const r = (0, $ig0Mq.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};
module.exports.default = $9802cc06456a4377$var$_default;

});

parcelRegister("gHoIh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ig0Mq = parcelRequire("ig0Mq");
var $c283d500c783ad5d$var$_default = {
    draw (context, size) {
        const r = (0, $ig0Mq.sqrt)(size - (0, $ig0Mq.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};
module.exports.default = $c283d500c783ad5d$var$_default;

});

parcelRegister("jGx5Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ig0Mq = parcelRequire("ig0Mq");
var $03b2c4972e6b8a1d$var$_default = {
    draw (context, size) {
        const w = (0, $ig0Mq.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};
module.exports.default = $03b2c4972e6b8a1d$var$_default;

});

parcelRegister("h3HrK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ig0Mq = parcelRequire("ig0Mq");
var $c6b46b0cdb9a482d$var$_default = {
    draw (context, size) {
        const r = (0, $ig0Mq.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};
module.exports.default = $c6b46b0cdb9a482d$var$_default;

});

parcelRegister("eItmn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ig0Mq = parcelRequire("ig0Mq");
const $ab6bf307a80a5bcb$var$ka = 0.89081309152928522810;
const $ab6bf307a80a5bcb$var$kr = (0, $ig0Mq.sin)($ig0Mq.pi / 10) / (0, $ig0Mq.sin)(7 * $ig0Mq.pi / 10);
const $ab6bf307a80a5bcb$var$kx = (0, $ig0Mq.sin)($ig0Mq.tau / 10) * $ab6bf307a80a5bcb$var$kr;
const $ab6bf307a80a5bcb$var$ky = -(0, $ig0Mq.cos)($ig0Mq.tau / 10) * $ab6bf307a80a5bcb$var$kr;
var $ab6bf307a80a5bcb$var$_default = {
    draw (context, size) {
        const r = (0, $ig0Mq.sqrt)(size * $ab6bf307a80a5bcb$var$ka);
        const x = $ab6bf307a80a5bcb$var$kx * r;
        const y = $ab6bf307a80a5bcb$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = $ig0Mq.tau * i / 5;
            const c = (0, $ig0Mq.cos)(a);
            const s = (0, $ig0Mq.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};
module.exports.default = $ab6bf307a80a5bcb$var$_default;

});

parcelRegister("gRLO6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ig0Mq = parcelRequire("ig0Mq");
const $032b345b1218b4bd$var$sqrt3 = (0, $ig0Mq.sqrt)(3);
var $032b345b1218b4bd$var$_default = {
    draw (context, size) {
        const y = -(0, $ig0Mq.sqrt)(size / ($032b345b1218b4bd$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$032b345b1218b4bd$var$sqrt3 * y, -y);
        context.lineTo($032b345b1218b4bd$var$sqrt3 * y, -y);
        context.closePath();
    }
};
module.exports.default = $032b345b1218b4bd$var$_default;

});

parcelRegister("5YgcO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ig0Mq = parcelRequire("ig0Mq");
const $458f206df33bed1b$var$sqrt3 = (0, $ig0Mq.sqrt)(3);
var $458f206df33bed1b$var$_default = {
    draw (context, size) {
        const s = (0, $ig0Mq.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $458f206df33bed1b$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};
module.exports.default = $458f206df33bed1b$var$_default;

});

parcelRegister("jWKwo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ig0Mq = parcelRequire("ig0Mq");
const $e8578548d922b436$var$c = -0.5;
const $e8578548d922b436$var$s = (0, $ig0Mq.sqrt)(3) / 2;
const $e8578548d922b436$var$k = 1 / (0, $ig0Mq.sqrt)(12);
const $e8578548d922b436$var$a = ($e8578548d922b436$var$k / 2 + 1) * 3;
var $e8578548d922b436$var$_default = {
    draw (context, size) {
        const r = (0, $ig0Mq.sqrt)(size / $e8578548d922b436$var$a);
        const x0 = r / 2, y0 = r * $e8578548d922b436$var$k;
        const x1 = x0, y1 = r * $e8578548d922b436$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($e8578548d922b436$var$c * x0 - $e8578548d922b436$var$s * y0, $e8578548d922b436$var$s * x0 + $e8578548d922b436$var$c * y0);
        context.lineTo($e8578548d922b436$var$c * x1 - $e8578548d922b436$var$s * y1, $e8578548d922b436$var$s * x1 + $e8578548d922b436$var$c * y1);
        context.lineTo($e8578548d922b436$var$c * x2 - $e8578548d922b436$var$s * y2, $e8578548d922b436$var$s * x2 + $e8578548d922b436$var$c * y2);
        context.lineTo($e8578548d922b436$var$c * x0 + $e8578548d922b436$var$s * y0, $e8578548d922b436$var$c * y0 - $e8578548d922b436$var$s * x0);
        context.lineTo($e8578548d922b436$var$c * x1 + $e8578548d922b436$var$s * y1, $e8578548d922b436$var$c * y1 - $e8578548d922b436$var$s * x1);
        context.lineTo($e8578548d922b436$var$c * x2 + $e8578548d922b436$var$s * y2, $e8578548d922b436$var$c * y2 - $e8578548d922b436$var$s * x2);
        context.closePath();
    }
};
module.exports.default = $e8578548d922b436$var$_default;

});

parcelRegister("42j01", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ig0Mq = parcelRequire("ig0Mq");
var $2f06163546352e5b$var$_default = {
    draw (context, size) {
        const r = (0, $ig0Mq.sqrt)(size - (0, $ig0Mq.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};
module.exports.default = $2f06163546352e5b$var$_default;

});


parcelRegister("4LqwK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $378020f90c7b265b$var$_default;

var $378020f90c7b265b$var$_noop = $378020f90c7b265b$var$_interopRequireDefault((parcelRequire("jNHOl")));

var $dqqOB = parcelRequire("dqqOB");
function $378020f90c7b265b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $378020f90c7b265b$var$BasisClosed(context) {
    this._context = context;
}
$378020f90c7b265b$var$BasisClosed.prototype = {
    areaStart: $378020f90c7b265b$var$_noop.default,
    areaEnd: $378020f90c7b265b$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $dqqOB.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $378020f90c7b265b$var$_default(context) {
    return new $378020f90c7b265b$var$BasisClosed(context);
}

});
parcelRegister("jNHOl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e6a493db9cca7bf8$var$_default;
function $e6a493db9cca7bf8$var$_default() {}

});

parcelRegister("dqqOB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Basis = $9c6280fd008771dd$var$Basis;
module.exports.default = $9c6280fd008771dd$var$_default;
module.exports.point = $9c6280fd008771dd$var$point;
function $9c6280fd008771dd$var$point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $9c6280fd008771dd$var$Basis(context) {
    this._context = context;
}
$9c6280fd008771dd$var$Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $9c6280fd008771dd$var$point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                $9c6280fd008771dd$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $9c6280fd008771dd$var$_default(context) {
    return new $9c6280fd008771dd$var$Basis(context);
}

});


parcelRegister("4ACCw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $35787b644e1095a6$var$_default;

var $dqqOB = parcelRequire("dqqOB");
function $35787b644e1095a6$var$BasisOpen(context) {
    this._context = context;
}
$35787b644e1095a6$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $dqqOB.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $35787b644e1095a6$var$_default(context) {
    return new $35787b644e1095a6$var$BasisOpen(context);
}

});

parcelRegister("8nEjr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dqqOB = parcelRequire("dqqOB");
function $619fbdf851b1b16d$var$Bundle(context, beta) {
    this._basis = new $dqqOB.Basis(context);
    this._beta = beta;
}
$619fbdf851b1b16d$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $619fbdf851b1b16d$var$_default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new $dqqOB.Basis(context) : new $619fbdf851b1b16d$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);
module.exports.default = $619fbdf851b1b16d$var$_default;

});

parcelRegister("bzrZk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalClosed = $86c8ac7c006d1147$var$CardinalClosed;
module.exports.default = void 0;

var $86c8ac7c006d1147$var$_noop = $86c8ac7c006d1147$var$_interopRequireDefault((parcelRequire("jNHOl")));

var $1hE1S = parcelRequire("1hE1S");
function $86c8ac7c006d1147$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $86c8ac7c006d1147$var$CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$86c8ac7c006d1147$var$CardinalClosed.prototype = {
    areaStart: $86c8ac7c006d1147$var$_noop.default,
    areaEnd: $86c8ac7c006d1147$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $1hE1S.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $86c8ac7c006d1147$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $86c8ac7c006d1147$var$CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $86c8ac7c006d1147$var$_default;

});
parcelRegister("1hE1S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cardinal = $0ef66df2c76a6789$var$Cardinal;
module.exports.default = void 0;
module.exports.point = $0ef66df2c76a6789$var$point;
function $0ef66df2c76a6789$var$point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $0ef66df2c76a6789$var$Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$0ef66df2c76a6789$var$Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $0ef66df2c76a6789$var$point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $0ef66df2c76a6789$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $0ef66df2c76a6789$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $0ef66df2c76a6789$var$Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $0ef66df2c76a6789$var$_default;

});


parcelRegister("fTXUm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalOpen = $b93a7691033ea5b7$var$CardinalOpen;
module.exports.default = void 0;

var $1hE1S = parcelRequire("1hE1S");
function $b93a7691033ea5b7$var$CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$b93a7691033ea5b7$var$CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $1hE1S.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $b93a7691033ea5b7$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $b93a7691033ea5b7$var$CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $b93a7691033ea5b7$var$_default;

});

parcelRegister("35AdY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bzrZk = parcelRequire("bzrZk");

var $23fdf0240a80ea26$var$_noop = $23fdf0240a80ea26$var$_interopRequireDefault((parcelRequire("jNHOl")));

var $knKEk = parcelRequire("knKEk");
function $23fdf0240a80ea26$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $23fdf0240a80ea26$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$23fdf0240a80ea26$var$CatmullRomClosed.prototype = {
    areaStart: $23fdf0240a80ea26$var$_noop.default,
    areaEnd: $23fdf0240a80ea26$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $knKEk.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $23fdf0240a80ea26$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $23fdf0240a80ea26$var$CatmullRomClosed(context, alpha) : new $bzrZk.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $23fdf0240a80ea26$var$_default;

});
parcelRegister("knKEk", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.point = point;

var $ig0Mq = parcelRequire("ig0Mq");

var $1hE1S = parcelRequire("1hE1S");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > $ig0Mq.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > $ig0Mq.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new $1hE1S.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

});


parcelRegister("ls28s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fTXUm = parcelRequire("fTXUm");

var $knKEk = parcelRequire("knKEk");
function $f9ddde88534ec720$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$f9ddde88534ec720$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $knKEk.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $f9ddde88534ec720$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $f9ddde88534ec720$var$CatmullRomOpen(context, alpha) : new $fTXUm.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $f9ddde88534ec720$var$_default;

});

parcelRegister("e53uY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a4043f15171fb5ea$var$_default;

var $a4043f15171fb5ea$var$_noop = $a4043f15171fb5ea$var$_interopRequireDefault((parcelRequire("jNHOl")));
function $a4043f15171fb5ea$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a4043f15171fb5ea$var$LinearClosed(context) {
    this._context = context;
}
$a4043f15171fb5ea$var$LinearClosed.prototype = {
    areaStart: $a4043f15171fb5ea$var$_noop.default,
    areaEnd: $a4043f15171fb5ea$var$_noop.default,
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $a4043f15171fb5ea$var$_default(context) {
    return new $a4043f15171fb5ea$var$LinearClosed(context);
}

});

parcelRegister("cAgWu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.monotoneX = $9295fd3fa69f33ec$var$monotoneX;
module.exports.monotoneY = $9295fd3fa69f33ec$var$monotoneY;
function $9295fd3fa69f33ec$var$sign(x) {
    return x < 0 ? -1 : 1;
} // Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $9295fd3fa69f33ec$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($9295fd3fa69f33ec$var$sign(s0) + $9295fd3fa69f33ec$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
} // Calculate a one-sided slope.
function $9295fd3fa69f33ec$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
} // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $9295fd3fa69f33ec$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $9295fd3fa69f33ec$var$MonotoneX(context) {
    this._context = context;
}
$9295fd3fa69f33ec$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $9295fd3fa69f33ec$var$point(this, this._t0, $9295fd3fa69f33ec$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $9295fd3fa69f33ec$var$point(this, $9295fd3fa69f33ec$var$slope2(this, t1 = $9295fd3fa69f33ec$var$slope3(this, x, y)), t1);
                break;
            default:
                $9295fd3fa69f33ec$var$point(this, this._t0, t1 = $9295fd3fa69f33ec$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $9295fd3fa69f33ec$var$MonotoneY(context) {
    this._context = new $9295fd3fa69f33ec$var$ReflectContext(context);
}
($9295fd3fa69f33ec$var$MonotoneY.prototype = Object.create($9295fd3fa69f33ec$var$MonotoneX.prototype)).point = function(x, y) {
    $9295fd3fa69f33ec$var$MonotoneX.prototype.point.call(this, y, x);
};
function $9295fd3fa69f33ec$var$ReflectContext(context) {
    this._context = context;
}
$9295fd3fa69f33ec$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $9295fd3fa69f33ec$var$monotoneX(context) {
    return new $9295fd3fa69f33ec$var$MonotoneX(context);
}
function $9295fd3fa69f33ec$var$monotoneY(context) {
    return new $9295fd3fa69f33ec$var$MonotoneY(context);
}

});

parcelRegister("kg6IS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ebfa84454e967b93$var$_default;
function $ebfa84454e967b93$var$Natural(context) {
    this._context = context;
}
$ebfa84454e967b93$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $ebfa84454e967b93$var$controlPoints(x), py = $ebfa84454e967b93$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
}; // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $ebfa84454e967b93$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $ebfa84454e967b93$var$_default(context) {
    return new $ebfa84454e967b93$var$Natural(context);
}

});

parcelRegister("hbQiR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c83c090d7aba40ae$var$_default;
module.exports.stepAfter = $c83c090d7aba40ae$var$stepAfter;
module.exports.stepBefore = $c83c090d7aba40ae$var$stepBefore;
function $c83c090d7aba40ae$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$c83c090d7aba40ae$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $c83c090d7aba40ae$var$_default(context) {
    return new $c83c090d7aba40ae$var$Step(context, 0.5);
}
function $c83c090d7aba40ae$var$stepBefore(context) {
    return new $c83c090d7aba40ae$var$Step(context, 0);
}
function $c83c090d7aba40ae$var$stepAfter(context) {
    return new $c83c090d7aba40ae$var$Step(context, 1);
}

});

parcelRegister("10FpT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0bc5eafd8e57918e$var$_default;

var $0bc5eafd8e57918e$var$_array = $0bc5eafd8e57918e$var$_interopRequireDefault((parcelRequire("1Joyq")));

var $0bc5eafd8e57918e$var$_constant = $0bc5eafd8e57918e$var$_interopRequireDefault((parcelRequire("8jJxm")));

var $0bc5eafd8e57918e$var$_none = $0bc5eafd8e57918e$var$_interopRequireDefault((parcelRequire("boWNO")));

var $0bc5eafd8e57918e$var$_none2 = $0bc5eafd8e57918e$var$_interopRequireDefault((parcelRequire("kymiB")));
function $0bc5eafd8e57918e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0bc5eafd8e57918e$var$stackValue(d, key) {
    return d[key];
}
function $0bc5eafd8e57918e$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $0bc5eafd8e57918e$var$_default() {
    var keys = (0, $0bc5eafd8e57918e$var$_constant.default)([]), order = $0bc5eafd8e57918e$var$_none2.default, offset = $0bc5eafd8e57918e$var$_none.default, value = $0bc5eafd8e57918e$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $0bc5eafd8e57918e$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $0bc5eafd8e57918e$var$_array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $0bc5eafd8e57918e$var$_constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $0bc5eafd8e57918e$var$_constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? $0bc5eafd8e57918e$var$_none2.default : typeof _ === "function" ? _ : (0, $0bc5eafd8e57918e$var$_constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? $0bc5eafd8e57918e$var$_none.default : _, stack) : offset;
    };
    return stack;
}

});
parcelRegister("boWNO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $84cf8c88b974edba$var$_default;
function $84cf8c88b974edba$var$_default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRegister("kymiB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ef6847c538260f10$var$_default;
function $ef6847c538260f10$var$_default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("2fNxx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1a4369187fee9a84$var$_default;

var $1a4369187fee9a84$var$_none = $1a4369187fee9a84$var$_interopRequireDefault((parcelRequire("boWNO")));
function $1a4369187fee9a84$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1a4369187fee9a84$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $1a4369187fee9a84$var$_none.default)(series, order);
}

});

parcelRegister("6a5UN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $47c843dc0711c2e3$var$_default;
function $47c843dc0711c2e3$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRegister("9ehm8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6b82e262e5b77959$var$_default;

var $6b82e262e5b77959$var$_none = $6b82e262e5b77959$var$_interopRequireDefault((parcelRequire("boWNO")));
function $6b82e262e5b77959$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6b82e262e5b77959$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $6b82e262e5b77959$var$_none.default)(series, order);
}

});

parcelRegister("306kH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $22f648bcd88c806c$var$_default;

var $22f648bcd88c806c$var$_none = $22f648bcd88c806c$var$_interopRequireDefault((parcelRequire("boWNO")));
function $22f648bcd88c806c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $22f648bcd88c806c$var$_default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $22f648bcd88c806c$var$_none.default)(series, order);
}

});

parcelRegister("f5Lyt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $afcc3618ba3d6d0a$var$_default;

var $afcc3618ba3d6d0a$var$_none = $afcc3618ba3d6d0a$var$_interopRequireDefault((parcelRequire("kymiB")));
function $afcc3618ba3d6d0a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $afcc3618ba3d6d0a$var$_default(series) {
    var peaks = series.map($afcc3618ba3d6d0a$var$peak);
    return (0, $afcc3618ba3d6d0a$var$_none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $afcc3618ba3d6d0a$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRegister("ffEmz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b1a790f74abf04ef$var$_default;
module.exports.sum = $b1a790f74abf04ef$var$sum;

var $b1a790f74abf04ef$var$_none = $b1a790f74abf04ef$var$_interopRequireDefault((parcelRequire("kymiB")));
function $b1a790f74abf04ef$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b1a790f74abf04ef$var$_default(series) {
    var sums = series.map($b1a790f74abf04ef$var$sum);
    return (0, $b1a790f74abf04ef$var$_none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $b1a790f74abf04ef$var$sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRegister("aQPCV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7e66cebbcfb08699$var$_default;

var $7e66cebbcfb08699$var$_ascending = $7e66cebbcfb08699$var$_interopRequireDefault((parcelRequire("ffEmz")));
function $7e66cebbcfb08699$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7e66cebbcfb08699$var$_default(series) {
    return (0, $7e66cebbcfb08699$var$_ascending.default)(series).reverse();
}

});

parcelRegister("4aPb6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $309fcb837cf8d70d$var$_default;

var $309fcb837cf8d70d$var$_appearance = $309fcb837cf8d70d$var$_interopRequireDefault((parcelRequire("f5Lyt")));

var $ffEmz = parcelRequire("ffEmz");
function $309fcb837cf8d70d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $309fcb837cf8d70d$var$_default(series) {
    var n = series.length, i, j, sums = series.map($ffEmz.sum), order = (0, $309fcb837cf8d70d$var$_appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRegister("4uoTs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $344d46126eba1748$var$_default;

var $344d46126eba1748$var$_none = $344d46126eba1748$var$_interopRequireDefault((parcelRequire("kymiB")));
function $344d46126eba1748$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $344d46126eba1748$var$_default(series) {
    return (0, $344d46126eba1748$var$_none.default)(series).reverse();
}

});



parcelRegister("2uwzz", function(module, exports) {

$parcel$export(module.exports, "safeSetItem", () => $36b38dce589c94db$export$d5a3bb3beb05c423);
$parcel$export(module.exports, "clearNonEssentialData", () => $36b38dce589c94db$export$765201d52b6313f6);
$parcel$export(module.exports, "getLocalStorageUsage", () => $36b38dce589c94db$export$be1626590ef81b9f);
$parcel$export(module.exports, "isLocalStorageGettingFull", () => $36b38dce589c94db$export$f7a872fedd89c96a);
/**
 * Utility functions for managing localStorage with quota handling
 */ 
var $ebTQj = parcelRequire("ebTQj");
/**
 * Simple compression function to reduce storage size
 */ const $36b38dce589c94db$var$compressData = (data)=>{
    try {
        // Simple compression: remove unnecessary whitespace and use shorter property names
        const parsed = JSON.parse(data);
        return JSON.stringify(parsed);
    } catch  {
        return data;
    }
};
const $36b38dce589c94db$export$d5a3bb3beb05c423 = (key, value, options = {})=>{
    const { maxRetries: maxRetries = 1, clearOnQuotaExceeded: clearOnQuotaExceeded = true, compress: compress = false } = options;
    let dataToStore = typeof value === "string" ? value : JSON.stringify(value);
    // Apply compression if requested
    if (compress) dataToStore = $36b38dce589c94db$var$compressData(dataToStore);
    for(let attempt = 0; attempt <= maxRetries; attempt++)try {
        localStorage.setItem(key, dataToStore);
        return true;
    } catch (error) {
        if (error instanceof Error && error.name === "QuotaExceededError") {
            (0, $ebTQj.logger).warn(`localStorage quota exceeded for key: ${key}, attempt: ${attempt + 1}`);
            if (attempt < maxRetries && clearOnQuotaExceeded) {
                // Clear some non-essential data and retry
                $36b38dce589c94db$export$765201d52b6313f6();
                continue;
            }
        }
        (0, $ebTQj.logger).error(`Failed to store ${key} in localStorage:`, error);
        return false;
    }
    return false;
};
const $36b38dce589c94db$export$765201d52b6313f6 = ()=>{
    const nonEssentialKeys = [
        "alertsAllData",
        "alertsErrorsData",
        "alertsWarningsData",
        "alertsResolvedData",
        "alertsPendingData",
        "sortedHMAlertsRows",
        "backupHealthCheckMetricsData",
        "percetageOfMotionData",
        "top5DataUsage",
        "storedExpandedObject",
        "shiftedObj",
        "shapesObject",
        "backupProductsData",
        "backUpSiteSchedule",
        "backUpFlexSchedule"
    ];
    nonEssentialKeys.forEach((key)=>{
        try {
            localStorage.removeItem(key);
        } catch (error) {
            (0, $ebTQj.logger).warn(`Failed to remove ${key} from localStorage:`, error);
        }
    });
};
const $36b38dce589c94db$export$be1626590ef81b9f = ()=>{
    let used = 0;
    let available = 0;
    try {
        // Calculate used space
        for(let key in localStorage)if (localStorage.hasOwnProperty(key)) used += localStorage[key].length + key.length;
        // Estimate available space (most browsers have ~5-10MB limit)
        // This is a rough estimate
        available = 5242880; // 5MB estimate
        // Try to get actual available space by testing storage
        const testKey = "__storage_test__";
        const testValue = "x".repeat(1024); // 1KB test
        for(let i = 0; i < 1000; i++)// Try to store up to 1MB
        try {
            localStorage.setItem(testKey + i, testValue);
        } catch (e) {
            available = (i + 1) * 1024;
            break;
        }
        // Clean up test data
        for(let i = 0; i < 1000; i++)try {
            localStorage.removeItem(testKey + i);
        } catch (e) {
            break;
        }
    } catch (error) {
        (0, $ebTQj.logger).warn("Could not calculate localStorage usage:", error);
    }
    const percentage = available > 0 ? used / available * 100 : 0;
    return {
        used: used,
        available: available,
        percentage: percentage
    };
};
const $36b38dce589c94db$export$f7a872fedd89c96a = (threshold = 80)=>{
    const { percentage: percentage } = $36b38dce589c94db$export$be1626590ef81b9f();
    return percentage > threshold;
};

});

parcelRegister("g2LMr", function(module, exports) {

$parcel$export(module.exports, "useFormikContext", () => useFormikContext);
$parcel$export(module.exports, "Formik", () => Formik);
$parcel$export(module.exports, "Field", () => Field);
$parcel$export(module.exports, "Form", () => Form);

var $avebA = parcelRequire("avebA");

var $eFtJI = parcelRequire("eFtJI");

var $4QPLv = parcelRequire("4QPLv");

var $8T3gX = parcelRequire("8T3gX");

var $1NPkl = parcelRequire("1NPkl");

var $1uokg = parcelRequire("1uokg");

var $e01SD = parcelRequire("e01SD");

var $iCzw1 = parcelRequire("iCzw1");

var $2k72C = parcelRequire("2k72C");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var FormikContext = /*#__PURE__*/ (0, $8T3gX.createContext)(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $8T3gX.useContext)(FormikContext);
    !!!formik && (0, $1uokg.default)(false, "Formik context is undefined, please verify you are calling useFormikContext() as child of a <Formik> component.");
    return formik;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === 'function';
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, $8T3gX.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== 'undefined' ? document : undefined);
    if (typeof doc === 'undefined') return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $iCzw1.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
     // check if path is not in the end
    if (p !== path.length && !obj) return def;
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, $e01SD.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $iCzw1.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $e01SD.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case 'SET_VALUES':
            return _extends({}, state, {
                values: msg.payload
            });
        case 'SET_TOUCHED':
            return _extends({}, state, {
                touched: msg.payload
            });
        case 'SET_ERRORS':
            if ((0, (/*@__PURE__*/$parcel$interopDefault($1NPkl)))(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case 'SET_STATUS':
            return _extends({}, state, {
                status: msg.payload
            });
        case 'SET_ISSUBMITTING':
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case 'SET_ISVALIDATING':
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case 'SET_FIELD_VALUE':
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_TOUCHED':
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_ERROR':
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case 'RESET_FORM':
            return _extends({}, state, msg.payload);
        case 'SET_FORMIK_STATE':
            return msg.payload(state);
        case 'SUBMIT_ATTEMPT':
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case 'SUBMIT_FAILURE':
            return _extends({}, state, {
                isSubmitting: false
            });
        case 'SUBMIT_SUCCESS':
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $8T3gX.useRef)(props.initialValues);
    var initialErrors = (0, $8T3gX.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, $8T3gX.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, $8T3gX.useRef)(props.initialStatus);
    var isMounted = (0, $8T3gX.useRef)(false);
    var fieldRegistry = (0, $8T3gX.useRef)({});
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $8T3gX.useEffect)(function() {
        !(typeof isInitialValid === 'undefined') && (0, $1uokg.default)(false, 'isInitialValid has been deprecated and will be removed in future versions of Formik. Please use initialErrors or validateOnMount instead.'); // eslint-disable-next-line
    }, []);
    (0, $8T3gX.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useState = (0, $8T3gX.useState)(0), setIteration = _React$useState[1];
    var stateRef = (0, $8T3gX.useRef)({
        values: (0, $4QPLv.default)(props.initialValues),
        errors: (0, $4QPLv.default)(props.initialErrors) || emptyErrors,
        touched: (0, $4QPLv.default)(props.initialTouched) || emptyTouched,
        status: (0, $4QPLv.default)(props.initialStatus),
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    });
    var state = stateRef.current;
    var dispatch = (0, $8T3gX.useCallback)(function(action) {
        var prev = stateRef.current;
        stateRef.current = formikReducer(prev, action); // force rerender
        if (prev !== stateRef.current) setIteration(function(x) {
            return x + 1;
        });
    }, []);
    var runValidateHandler = (0, $8T3gX.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                console.warn("Warning: An unhandled error was caught during validation in <Formik validate />", actualException);
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $8T3gX.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === 'ValidationError') resolve(yupToFormErrors(err));
                else {
                    console.warn("Warning: An unhandled error was caught during validation in <Formik validationSchema />", err);
                    reject(err);
                }
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $8T3gX.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $8T3gX.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $8T3gX.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $avebA.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: 'SET_ISVALIDATING',
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
                dispatch({
                    type: 'SET_ERRORS',
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $8T3gX.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($1NPkl)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $8T3gX.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: 'RESET_FORM',
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched,
        props.onReset
    ]);
    (0, $8T3gX.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($1NPkl)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
                if (validateOnMount) validateFormWithHighPriority(initialValues.current);
            }
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $8T3gX.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($1NPkl)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: 'SET_ERRORS',
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $8T3gX.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($1NPkl)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: 'SET_TOUCHED',
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $8T3gX.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($1NPkl)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: 'SET_STATUS',
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: 'SET_FIELD_ERROR',
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: 'SET_ISVALIDATING',
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: 'SET_ISVALIDATING',
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: getIn(error, name)
                    }
                });
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $8T3gX.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $8T3gX.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: 'SET_TOUCHED',
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $8T3gX.useCallback)(function(errors) {
        dispatch({
            type: 'SET_ERRORS',
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: 'SET_VALUES',
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $8T3gX.useCallback)(function(field, value) {
        dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        var resolvedValue = isFunction(value) ? value(getIn(state.values, field)) : value;
        dispatch({
            type: 'SET_FIELD_VALUE',
            payload: {
                field: field,
                value: resolvedValue
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, resolvedValue)) : Promise.resolve();
    });
    var executeChange = (0, $8T3gX.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            if (!field && true) warnAboutMissingIdentifier({
                htmlContent: outerHTML,
                documentationAnchorLink: 'handlechange-e-reactchangeeventany--void',
                handlerName: 'handleChange'
            });
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: 'SET_FIELD_TOUCHED',
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $8T3gX.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        if (!field && true) warnAboutMissingIdentifier({
            htmlContent: outerHTML,
            documentationAnchorLink: 'handleblur-e-any--void',
            handlerName: 'handleBlur'
        });
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $8T3gX.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: 'SET_FORMIK_STATE',
            payload: stateOrCb
        });
        else dispatch({
            type: 'SET_FORMIK_STATE',
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $8T3gX.useCallback)(function(status) {
        dispatch({
            type: 'SET_STATUS',
            payload: status
        });
    }, []);
    var setSubmitting = (0, $8T3gX.useCallback)(function(isSubmitting) {
        dispatch({
            type: 'SET_ISSUBMITTING',
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: 'SUBMIT_ATTEMPT'
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: 'SUBMIT_SUCCESS'
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: 'SUBMIT_FAILURE'
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: 'SUBMIT_FAILURE'
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        // specified `type` attribute during development. This mitigates
        // a common gotcha in forms with both reset and submit buttons,
        // where the dev forgets to add type="button" to the reset button.
        if (typeof document !== 'undefined') {
            // Safely get the active element (works with IE)
            var activeElement = getActiveElement();
            if (activeElement !== null && activeElement instanceof HTMLButtonElement) !(activeElement.attributes && activeElement.attributes.getNamedItem('type')) && (0, $1uokg.default)(false, 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.');
        }
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $8T3gX.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $8T3gX.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $8T3gX.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === 'checkbox') {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === 'radio') {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === 'select' && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $8T3gX.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($1NPkl)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $8T3gX.useMemo)(function() {
        return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $8T3gX.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $8T3gX.useEffect)(function() {
        !!props.render && (0, $1uokg.default)(false, "<Formik render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Formik render={(props) => ...} /> with <Formik>{(props) => ...}</Formik>"); // eslint-disable-next-line
    }, []);
    return (0, $8T3gX.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, $8T3gX.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, $8T3gX.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    var normalizedValues = prepareDataForValidation(values);
    return schema[sync ? 'validateSync' : 'validate'](normalizedValues, {
        abortEarly: false,
        context: context || normalizedValues
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $eFtJI.default)(value)) return prepareDataForValidation(value);
            else return value !== '' ? value : undefined;
        });
        else if ((0, $eFtJI.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== '' ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === 'undefined') {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $avebA.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $avebA.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === 'boolean') return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == 'true' || valueProp == 'false') return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $8T3gX.useLayoutEffect) : (0, $8T3gX.useEffect);
function useEventCallback(fn) {
    var ref = (0, $8T3gX.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $8T3gX.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $8T3gX.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !formik && (0, $1uokg.default)(false, 'useField() / <Field /> must be used underneath a <Formik> component or withFormik() higher order component');
    !fieldName && (0, $1uokg.default)(false, 'Invalid field name. Either pass `useField` a string or an object containing a `name` key.');
    var fieldHelpers = (0, $8T3gX.useMemo)(function() {
        return getFieldHelpers(fieldName);
    }, [
        getFieldHelpers,
        fieldName
    ]);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        fieldHelpers
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, className = _ref.className, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component",
        "className"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $8T3gX.useEffect)(function() {
        !!render && (0, $1uokg.default)(false, "<Field render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Field name=\"" + name + "\" render={({field, form}) => ...} /> with <Field name=\"" + name + "\">{({field, form, meta}) => ...}</Field>");
        !!(is && children && isFunction(children)) && (0, $1uokg.default)(false, 'You should not use <Field as> and <Field children> as a function in the same <Field> component; <Field as> will be ignored.');
        !!(component && children && isFunction(children)) && (0, $1uokg.default)(false, 'You should not use <Field component> and <Field children> as a function in the same <Field> component; <Field component> will be ignored.');
        !!(render && children && !isEmptyChildren(children)) && (0, $1uokg.default)(false, 'You should not use <Field render> and <Field children> in the same <Field> component; <Field children> will be ignored'); // eslint-disable-next-line
    }, []);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $8T3gX.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === 'string') {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $8T3gX.createElement)(component, _extends({
                ref: innerRef
            }, field, rest, {
                className: className
            }), children);
        } // We don't pass `meta` for backwards compat
        return (0, $8T3gX.createElement)(component, _extends({
            field: field,
            form: formik
        }, props, {
            className: className
        }), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || 'input';
    if (typeof asElement === 'string') {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $8T3gX.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest, {
            className: className
        }), children);
    }
    return (0, $8T3gX.createElement)(asElement, _extends({}, field, props, {
        className: className
    }), children);
}
var Form = /*#__PURE__*/ (0, $8T3gX.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : '#';
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $8T3gX.createElement)("form", _extends({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = 'Form';
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== 'function') // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || 'Component';
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _React$Component.call.apply(_React$Component, [
                    this
                ].concat(args)) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                _this.renderFormComponent = function(formikProps) {
                    return (0, $8T3gX.createElement)(Component$1, _extends({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $8T3gX.createElement)(Formik, _extends({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $8T3gX.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($2k72C)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, $8T3gX.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, $1uokg.default)(false, "Formik context is undefined, please verify you are rendering <Form>, <Field>, <FastField>, <FieldArray>, or your custom context-using component as a child of a <Formik> component. Component name: " + Comp.name);
            return (0, $8T3gX.createElement)(Comp, _extends({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component'; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($2k72C)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
    var fn = typeof alteration === 'function' ? alteration : defaultFunction;
    return function(data) {
        if (Array.isArray(data) || isObject(data)) {
            var clone = copyArrayLike(data);
            return fn(clone);
        } // This can be assumed to be a primitive, which
        // is a case for top level validation errors
        return data;
    };
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = createAlterationHandler(alterErrors, fn);
                var updateTouched = createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, $4QPLv.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                length = arr.length;
                return arr;
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        };
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($1NPkl)))(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
             // if the array only includes undefined values we have to return an empty array
            return isFunction(copy.every) ? copy.every(function(v) {
                return v === undefined;
            }) ? [] : copy : copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array.slice();
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $8T3gX.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? (0, $8T3gX.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $8T3gX.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, $8T3gX.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $8T3gX.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $1uokg.default)(false, "<FastField render> has been deprecated. Please use a child callback function instead: <FastField name={" + name + "}>{props => ...}</FastField> instead.");
        !!(component && render) && (0, $1uokg.default)(false, 'You should not use <FastField component> and <FastField render> in the same <FastField> component; <FastField component> will be ignored');
        !!(is && children && isFunction(children)) && (0, $1uokg.default)(false, 'You should not use <FastField as> and <FastField children> as a function in the same <FastField> component; <FastField as> will be ignored.');
        !!(component && children && isFunction(children)) && (0, $1uokg.default)(false, 'You should not use <FastField component> and <FastField children> as a function in the same <FastField> component; <FastField component> will be ignored.');
        !!(render && children && !isEmptyChildren(children)) && (0, $1uokg.default)(false, 'You should not use <FastField render> and <FastField children> in the same <FastField> component; <FastField children> will be ignored');
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === 'string') {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $8T3gX.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $8T3gX.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || 'input';
        if (typeof asElement === 'string') {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $8T3gX.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $8T3gX.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $8T3gX.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

});
parcelRegister("avebA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a57cda61ad7a0f0$export$2e2bcd8739ae039);
var $7a57cda61ad7a0f0$var$isMergeableObject = function isMergeableObject(value) {
    return $7a57cda61ad7a0f0$var$isNonNullObject(value) && !$7a57cda61ad7a0f0$var$isSpecial(value);
};
function $7a57cda61ad7a0f0$var$isNonNullObject(value) {
    return !!value && typeof value === 'object';
}
function $7a57cda61ad7a0f0$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || $7a57cda61ad7a0f0$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $7a57cda61ad7a0f0$var$canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var $7a57cda61ad7a0f0$var$REACT_ELEMENT_TYPE = $7a57cda61ad7a0f0$var$canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function $7a57cda61ad7a0f0$var$isReactElement(value) {
    return value.$$typeof === $7a57cda61ad7a0f0$var$REACT_ELEMENT_TYPE;
}
function $7a57cda61ad7a0f0$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $7a57cda61ad7a0f0$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $7a57cda61ad7a0f0$var$deepmerge($7a57cda61ad7a0f0$var$emptyTarget(value), value, options) : value;
}
function $7a57cda61ad7a0f0$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $7a57cda61ad7a0f0$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $7a57cda61ad7a0f0$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $7a57cda61ad7a0f0$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $7a57cda61ad7a0f0$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $7a57cda61ad7a0f0$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $7a57cda61ad7a0f0$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $7a57cda61ad7a0f0$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $7a57cda61ad7a0f0$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $7a57cda61ad7a0f0$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $7a57cda61ad7a0f0$var$mergeObject(target, source, options);
}
$7a57cda61ad7a0f0$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error('first argument should be an array');
    return array.reduce(function(prev, next) {
        return $7a57cda61ad7a0f0$var$deepmerge(prev, next, options);
    }, {});
};
var $7a57cda61ad7a0f0$var$deepmerge_1 = $7a57cda61ad7a0f0$var$deepmerge;
var $7a57cda61ad7a0f0$export$2e2bcd8739ae039 = $7a57cda61ad7a0f0$var$deepmerge_1;

});

parcelRegister("eFtJI", function(module, exports) {

$parcel$export(module.exports, "default", () => $aadbf608b6a8b963$export$2e2bcd8739ae039);

var $b6jap = parcelRequire("b6jap");

var $izG6C = parcelRequire("izG6C");

var $goIau = parcelRequire("goIau");
/** `Object#toString` result references. */ var $aadbf608b6a8b963$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $aadbf608b6a8b963$var$funcProto = Function.prototype, $aadbf608b6a8b963$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $aadbf608b6a8b963$var$funcToString = $aadbf608b6a8b963$var$funcProto.toString;
/** Used to check objects for own properties. */ var $aadbf608b6a8b963$var$hasOwnProperty = $aadbf608b6a8b963$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $aadbf608b6a8b963$var$objectCtorString = $aadbf608b6a8b963$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $aadbf608b6a8b963$var$isPlainObject(value) {
    if (!(0, $goIau.default)(value) || (0, $b6jap.default)(value) != $aadbf608b6a8b963$var$objectTag) return false;
    var proto = (0, $izG6C.default)(value);
    if (proto === null) return true;
    var Ctor = $aadbf608b6a8b963$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $aadbf608b6a8b963$var$funcToString.call(Ctor) == $aadbf608b6a8b963$var$objectCtorString;
}
var $aadbf608b6a8b963$export$2e2bcd8739ae039 = $aadbf608b6a8b963$var$isPlainObject;

});
parcelRegister("b6jap", function(module, exports) {

$parcel$export(module.exports, "default", () => $814f1f60162ecb83$export$2e2bcd8739ae039);

var $6rPfl = parcelRequire("6rPfl");

var $cQHN4 = parcelRequire("cQHN4");

var $7aE3V = parcelRequire("7aE3V");
/** `Object#toString` result references. */ var $814f1f60162ecb83$var$nullTag = '[object Null]', $814f1f60162ecb83$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $814f1f60162ecb83$var$symToStringTag = (0, $6rPfl.default) ? (0, $6rPfl.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $814f1f60162ecb83$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $814f1f60162ecb83$var$undefinedTag : $814f1f60162ecb83$var$nullTag;
    return $814f1f60162ecb83$var$symToStringTag && $814f1f60162ecb83$var$symToStringTag in Object(value) ? (0, $cQHN4.default)(value) : (0, $7aE3V.default)(value);
}
var $814f1f60162ecb83$export$2e2bcd8739ae039 = $814f1f60162ecb83$var$baseGetTag;

});
parcelRegister("6rPfl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b1d042dfd98c518$export$2e2bcd8739ae039);

var $1CjO7 = parcelRequire("1CjO7");
/** Built-in value references. */ var $4b1d042dfd98c518$var$Symbol = (0, $1CjO7.default).Symbol;
var $4b1d042dfd98c518$export$2e2bcd8739ae039 = $4b1d042dfd98c518$var$Symbol;

});
parcelRegister("1CjO7", function(module, exports) {

$parcel$export(module.exports, "default", () => $12d8b4682550299f$export$2e2bcd8739ae039);

var $lpbkP = parcelRequire("lpbkP");
/** Detect free variable `self`. */ var $12d8b4682550299f$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $12d8b4682550299f$var$root = (0, $lpbkP.default) || $12d8b4682550299f$var$freeSelf || Function('return this')();
var $12d8b4682550299f$export$2e2bcd8739ae039 = $12d8b4682550299f$var$root;

});
parcelRegister("lpbkP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f954b9ac3a3e5f92$export$2e2bcd8739ae039);
/** Detect free variable `global` from Node.js. */ var $f954b9ac3a3e5f92$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $f954b9ac3a3e5f92$export$2e2bcd8739ae039 = $f954b9ac3a3e5f92$var$freeGlobal;

});



parcelRegister("cQHN4", function(module, exports) {

$parcel$export(module.exports, "default", () => $95ac4f3e3ecf64b1$export$2e2bcd8739ae039);

var $6rPfl = parcelRequire("6rPfl");
/** Used for built-in method references. */ var $95ac4f3e3ecf64b1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $95ac4f3e3ecf64b1$var$hasOwnProperty = $95ac4f3e3ecf64b1$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $95ac4f3e3ecf64b1$var$nativeObjectToString = $95ac4f3e3ecf64b1$var$objectProto.toString;
/** Built-in value references. */ var $95ac4f3e3ecf64b1$var$symToStringTag = (0, $6rPfl.default) ? (0, $6rPfl.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $95ac4f3e3ecf64b1$var$getRawTag(value) {
    var isOwn = $95ac4f3e3ecf64b1$var$hasOwnProperty.call(value, $95ac4f3e3ecf64b1$var$symToStringTag), tag = value[$95ac4f3e3ecf64b1$var$symToStringTag];
    try {
        value[$95ac4f3e3ecf64b1$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $95ac4f3e3ecf64b1$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$95ac4f3e3ecf64b1$var$symToStringTag] = tag;
        else delete value[$95ac4f3e3ecf64b1$var$symToStringTag];
    }
    return result;
}
var $95ac4f3e3ecf64b1$export$2e2bcd8739ae039 = $95ac4f3e3ecf64b1$var$getRawTag;

});

parcelRegister("7aE3V", function(module, exports) {

$parcel$export(module.exports, "default", () => $53888b1ad0e27aca$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $53888b1ad0e27aca$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $53888b1ad0e27aca$var$nativeObjectToString = $53888b1ad0e27aca$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $53888b1ad0e27aca$var$objectToString(value) {
    return $53888b1ad0e27aca$var$nativeObjectToString.call(value);
}
var $53888b1ad0e27aca$export$2e2bcd8739ae039 = $53888b1ad0e27aca$var$objectToString;

});


parcelRegister("izG6C", function(module, exports) {

$parcel$export(module.exports, "default", () => $d85c283804a69b89$export$2e2bcd8739ae039);

var $bh6lW = parcelRequire("bh6lW");
/** Built-in value references. */ var $d85c283804a69b89$var$getPrototype = (0, $bh6lW.default)(Object.getPrototypeOf, Object);
var $d85c283804a69b89$export$2e2bcd8739ae039 = $d85c283804a69b89$var$getPrototype;

});
parcelRegister("bh6lW", function(module, exports) {

$parcel$export(module.exports, "default", () => $835635cc4fb61b02$export$2e2bcd8739ae039);
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $835635cc4fb61b02$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $835635cc4fb61b02$export$2e2bcd8739ae039 = $835635cc4fb61b02$var$overArg;

});


parcelRegister("goIau", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf01261e79e0e12e$export$2e2bcd8739ae039);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $bf01261e79e0e12e$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $bf01261e79e0e12e$export$2e2bcd8739ae039 = $bf01261e79e0e12e$var$isObjectLike;

});


parcelRegister("4QPLv", function(module, exports) {

$parcel$export(module.exports, "default", () => $38842c3c2190b13e$export$2e2bcd8739ae039);

var $4PVoT = parcelRequire("4PVoT");
/** Used to compose bitmasks for cloning. */ var $38842c3c2190b13e$var$CLONE_DEEP_FLAG = 1, $38842c3c2190b13e$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $38842c3c2190b13e$var$cloneDeep(value) {
    return (0, $4PVoT.default)(value, $38842c3c2190b13e$var$CLONE_DEEP_FLAG | $38842c3c2190b13e$var$CLONE_SYMBOLS_FLAG);
}
var $38842c3c2190b13e$export$2e2bcd8739ae039 = $38842c3c2190b13e$var$cloneDeep;

});
parcelRegister("4PVoT", function(module, exports) {

$parcel$export(module.exports, "default", () => $3858736258c73653$export$2e2bcd8739ae039);

var $9ivKC = parcelRequire("9ivKC");

var $aAcMv = parcelRequire("aAcMv");

var $3sQPX = parcelRequire("3sQPX");

var $gwZyQ = parcelRequire("gwZyQ");

var $9n0Mp = parcelRequire("9n0Mp");

var $6OXlT = parcelRequire("6OXlT");

var $kDF23 = parcelRequire("kDF23");

var $8XILR = parcelRequire("8XILR");

var $hXT3Z = parcelRequire("hXT3Z");

var $jqco9 = parcelRequire("jqco9");

var $ixgr6 = parcelRequire("ixgr6");

var $29CVg = parcelRequire("29CVg");

var $bmltf = parcelRequire("bmltf");

var $UrB4T = parcelRequire("UrB4T");

var $6upji = parcelRequire("6upji");

var $h9u6R = parcelRequire("h9u6R");

var $eYlEu = parcelRequire("eYlEu");

var $iifvl = parcelRequire("iifvl");

var $deYtR = parcelRequire("deYtR");

var $lpJyH = parcelRequire("lpJyH");

var $aJJw9 = parcelRequire("aJJw9");

var $b4AUN = parcelRequire("b4AUN");
/** Used to compose bitmasks for cloning. */ var $3858736258c73653$var$CLONE_DEEP_FLAG = 1, $3858736258c73653$var$CLONE_FLAT_FLAG = 2, $3858736258c73653$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $3858736258c73653$var$argsTag = '[object Arguments]', $3858736258c73653$var$arrayTag = '[object Array]', $3858736258c73653$var$boolTag = '[object Boolean]', $3858736258c73653$var$dateTag = '[object Date]', $3858736258c73653$var$errorTag = '[object Error]', $3858736258c73653$var$funcTag = '[object Function]', $3858736258c73653$var$genTag = '[object GeneratorFunction]', $3858736258c73653$var$mapTag = '[object Map]', $3858736258c73653$var$numberTag = '[object Number]', $3858736258c73653$var$objectTag = '[object Object]', $3858736258c73653$var$regexpTag = '[object RegExp]', $3858736258c73653$var$setTag = '[object Set]', $3858736258c73653$var$stringTag = '[object String]', $3858736258c73653$var$symbolTag = '[object Symbol]', $3858736258c73653$var$weakMapTag = '[object WeakMap]';
var $3858736258c73653$var$arrayBufferTag = '[object ArrayBuffer]', $3858736258c73653$var$dataViewTag = '[object DataView]', $3858736258c73653$var$float32Tag = '[object Float32Array]', $3858736258c73653$var$float64Tag = '[object Float64Array]', $3858736258c73653$var$int8Tag = '[object Int8Array]', $3858736258c73653$var$int16Tag = '[object Int16Array]', $3858736258c73653$var$int32Tag = '[object Int32Array]', $3858736258c73653$var$uint8Tag = '[object Uint8Array]', $3858736258c73653$var$uint8ClampedTag = '[object Uint8ClampedArray]', $3858736258c73653$var$uint16Tag = '[object Uint16Array]', $3858736258c73653$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $3858736258c73653$var$cloneableTags = {};
$3858736258c73653$var$cloneableTags[$3858736258c73653$var$argsTag] = $3858736258c73653$var$cloneableTags[$3858736258c73653$var$arrayTag] = $3858736258c73653$var$cloneableTags[$3858736258c73653$var$arrayBufferTag] = $3858736258c73653$var$cloneableTags[$3858736258c73653$var$dataViewTag] = $3858736258c73653$var$cloneableTags[$3858736258c73653$var$boolTag] = $3858736258c73653$var$cloneableTags[$3858736258c73653$var$dateTag] = $3858736258c73653$var$cloneableTags[$3858736258c73653$var$float32Tag] = $3858736258c73653$var$cloneableTags[$3858736258c73653$var$float64Tag] = $3858736258c73653$var$cloneableTags[$3858736258c73653$var$int8Tag] = $3858736258c73653$var$cloneableTags[$3858736258c73653$var$int16Tag] = $3858736258c73653$var$cloneableTags[$3858736258c73653$var$int32Tag] = $3858736258c73653$var$cloneableTags[$3858736258c73653$var$mapTag] = $3858736258c73653$var$cloneableTags[$3858736258c73653$var$numberTag] = $3858736258c73653$var$cloneableTags[$3858736258c73653$var$objectTag] = $3858736258c73653$var$cloneableTags[$3858736258c73653$var$regexpTag] = $3858736258c73653$var$cloneableTags[$3858736258c73653$var$setTag] = $3858736258c73653$var$cloneableTags[$3858736258c73653$var$stringTag] = $3858736258c73653$var$cloneableTags[$3858736258c73653$var$symbolTag] = $3858736258c73653$var$cloneableTags[$3858736258c73653$var$uint8Tag] = $3858736258c73653$var$cloneableTags[$3858736258c73653$var$uint8ClampedTag] = $3858736258c73653$var$cloneableTags[$3858736258c73653$var$uint16Tag] = $3858736258c73653$var$cloneableTags[$3858736258c73653$var$uint32Tag] = true;
$3858736258c73653$var$cloneableTags[$3858736258c73653$var$errorTag] = $3858736258c73653$var$cloneableTags[$3858736258c73653$var$funcTag] = $3858736258c73653$var$cloneableTags[$3858736258c73653$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $3858736258c73653$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $3858736258c73653$var$CLONE_DEEP_FLAG, isFlat = bitmask & $3858736258c73653$var$CLONE_FLAT_FLAG, isFull = bitmask & $3858736258c73653$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $deYtR.default)(value)) return value;
    var isArr = (0, $h9u6R.default)(value);
    if (isArr) {
        result = (0, $bmltf.default)(value);
        if (!isDeep) return (0, $kDF23.default)(value, result);
    } else {
        var tag = (0, $29CVg.default)(value), isFunc = tag == $3858736258c73653$var$funcTag || tag == $3858736258c73653$var$genTag;
        if ((0, $eYlEu.default)(value)) return (0, $6OXlT.default)(value, isDeep);
        if (tag == $3858736258c73653$var$objectTag || tag == $3858736258c73653$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $6upji.default)(value);
            if (!isDeep) return isFlat ? (0, $hXT3Z.default)(value, (0, $9n0Mp.default)(result, value)) : (0, $8XILR.default)(value, (0, $gwZyQ.default)(result, value));
        } else {
            if (!$3858736258c73653$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $UrB4T.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $9ivKC.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $lpJyH.default)(value)) value.forEach(function(subValue) {
        result.add($3858736258c73653$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $iifvl.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $3858736258c73653$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $ixgr6.default) : (0, $jqco9.default) : isFlat ? (0, $b4AUN.default) : (0, $aJJw9.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $aAcMv.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $3sQPX.default)(result, key, $3858736258c73653$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $3858736258c73653$export$2e2bcd8739ae039 = $3858736258c73653$var$baseClone;

});
parcelRegister("9ivKC", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c4e6c8e4bb5b34a$export$2e2bcd8739ae039);

var $1kVTl = parcelRequire("1kVTl");

var $djy4x = parcelRequire("djy4x");

var $lUHn3 = parcelRequire("lUHn3");

var $8OYGY = parcelRequire("8OYGY");

var $utQpq = parcelRequire("utQpq");

var $9clZj = parcelRequire("9clZj");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $6c4e6c8e4bb5b34a$var$Stack(entries) {
    var data = this.__data__ = new (0, $1kVTl.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$6c4e6c8e4bb5b34a$var$Stack.prototype.clear = (0, $djy4x.default);
$6c4e6c8e4bb5b34a$var$Stack.prototype['delete'] = (0, $lUHn3.default);
$6c4e6c8e4bb5b34a$var$Stack.prototype.get = (0, $8OYGY.default);
$6c4e6c8e4bb5b34a$var$Stack.prototype.has = (0, $utQpq.default);
$6c4e6c8e4bb5b34a$var$Stack.prototype.set = (0, $9clZj.default);
var $6c4e6c8e4bb5b34a$export$2e2bcd8739ae039 = $6c4e6c8e4bb5b34a$var$Stack;

});
parcelRegister("1kVTl", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f9490c2bb35bfec$export$2e2bcd8739ae039);

var $gw6hC = parcelRequire("gw6hC");

var $hZJJy = parcelRequire("hZJJy");

var $iltmb = parcelRequire("iltmb");

var $0ZW47 = parcelRequire("0ZW47");

var $fcSbM = parcelRequire("fcSbM");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $0f9490c2bb35bfec$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$0f9490c2bb35bfec$var$ListCache.prototype.clear = (0, $gw6hC.default);
$0f9490c2bb35bfec$var$ListCache.prototype['delete'] = (0, $hZJJy.default);
$0f9490c2bb35bfec$var$ListCache.prototype.get = (0, $iltmb.default);
$0f9490c2bb35bfec$var$ListCache.prototype.has = (0, $0ZW47.default);
$0f9490c2bb35bfec$var$ListCache.prototype.set = (0, $fcSbM.default);
var $0f9490c2bb35bfec$export$2e2bcd8739ae039 = $0f9490c2bb35bfec$var$ListCache;

});
parcelRegister("gw6hC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c064822f52eefd89$export$2e2bcd8739ae039);
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $c064822f52eefd89$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $c064822f52eefd89$export$2e2bcd8739ae039 = $c064822f52eefd89$var$listCacheClear;

});

parcelRegister("hZJJy", function(module, exports) {

$parcel$export(module.exports, "default", () => $d19b9bf147994071$export$2e2bcd8739ae039);

var $4w1iT = parcelRequire("4w1iT");
/** Used for built-in method references. */ var $d19b9bf147994071$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d19b9bf147994071$var$splice = $d19b9bf147994071$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d19b9bf147994071$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $4w1iT.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d19b9bf147994071$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $d19b9bf147994071$export$2e2bcd8739ae039 = $d19b9bf147994071$var$listCacheDelete;

});
parcelRegister("4w1iT", function(module, exports) {

$parcel$export(module.exports, "default", () => $349b297e624d250e$export$2e2bcd8739ae039);

var $7KYX4 = parcelRequire("7KYX4");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $349b297e624d250e$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $7KYX4.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $349b297e624d250e$export$2e2bcd8739ae039 = $349b297e624d250e$var$assocIndexOf;

});
parcelRegister("7KYX4", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a5c1c00fce40b27$export$2e2bcd8739ae039);
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $5a5c1c00fce40b27$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $5a5c1c00fce40b27$export$2e2bcd8739ae039 = $5a5c1c00fce40b27$var$eq;

});



parcelRegister("iltmb", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5b0f5cad79d5454$export$2e2bcd8739ae039);

var $4w1iT = parcelRequire("4w1iT");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d5b0f5cad79d5454$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $4w1iT.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $d5b0f5cad79d5454$export$2e2bcd8739ae039 = $d5b0f5cad79d5454$var$listCacheGet;

});

parcelRegister("0ZW47", function(module, exports) {

$parcel$export(module.exports, "default", () => $00300b4f66e113c0$export$2e2bcd8739ae039);

var $4w1iT = parcelRequire("4w1iT");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $00300b4f66e113c0$var$listCacheHas(key) {
    return (0, $4w1iT.default)(this.__data__, key) > -1;
}
var $00300b4f66e113c0$export$2e2bcd8739ae039 = $00300b4f66e113c0$var$listCacheHas;

});

parcelRegister("fcSbM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b12202d39baeabbe$export$2e2bcd8739ae039);

var $4w1iT = parcelRequire("4w1iT");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $b12202d39baeabbe$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $4w1iT.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $b12202d39baeabbe$export$2e2bcd8739ae039 = $b12202d39baeabbe$var$listCacheSet;

});


parcelRegister("djy4x", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b177ab846218ca0$export$2e2bcd8739ae039);

var $1kVTl = parcelRequire("1kVTl");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $9b177ab846218ca0$var$stackClear() {
    this.__data__ = new (0, $1kVTl.default);
    this.size = 0;
}
var $9b177ab846218ca0$export$2e2bcd8739ae039 = $9b177ab846218ca0$var$stackClear;

});

parcelRegister("lUHn3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff40788090a2258d$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ff40788090a2258d$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $ff40788090a2258d$export$2e2bcd8739ae039 = $ff40788090a2258d$var$stackDelete;

});

parcelRegister("8OYGY", function(module, exports) {

$parcel$export(module.exports, "default", () => $66c2126e6d1e3dc1$export$2e2bcd8739ae039);
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $66c2126e6d1e3dc1$var$stackGet(key) {
    return this.__data__.get(key);
}
var $66c2126e6d1e3dc1$export$2e2bcd8739ae039 = $66c2126e6d1e3dc1$var$stackGet;

});

parcelRegister("utQpq", function(module, exports) {

$parcel$export(module.exports, "default", () => $05b9f3ea29839a95$export$2e2bcd8739ae039);
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $05b9f3ea29839a95$var$stackHas(key) {
    return this.__data__.has(key);
}
var $05b9f3ea29839a95$export$2e2bcd8739ae039 = $05b9f3ea29839a95$var$stackHas;

});

parcelRegister("9clZj", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b264a6764db404a$export$2e2bcd8739ae039);

var $1kVTl = parcelRequire("1kVTl");

var $anyXd = parcelRequire("anyXd");

var $6gEw5 = parcelRequire("6gEw5");
/** Used as the size to enable large array optimizations. */ var $6b264a6764db404a$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $6b264a6764db404a$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $1kVTl.default)) {
        var pairs = data.__data__;
        if (!(0, $anyXd.default) || pairs.length < $6b264a6764db404a$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $6gEw5.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $6b264a6764db404a$export$2e2bcd8739ae039 = $6b264a6764db404a$var$stackSet;

});
parcelRegister("anyXd", function(module, exports) {

$parcel$export(module.exports, "default", () => $78e72a8188ff8722$export$2e2bcd8739ae039);

var $8ekTP = parcelRequire("8ekTP");

var $1CjO7 = parcelRequire("1CjO7");
/* Built-in method references that are verified to be native. */ var $78e72a8188ff8722$var$Map = (0, $8ekTP.default)((0, $1CjO7.default), 'Map');
var $78e72a8188ff8722$export$2e2bcd8739ae039 = $78e72a8188ff8722$var$Map;

});
parcelRegister("8ekTP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fdfd7be9c6bace7$export$2e2bcd8739ae039);

var $iwDtm = parcelRequire("iwDtm");

var $5TuPM = parcelRequire("5TuPM");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5fdfd7be9c6bace7$var$getNative(object, key) {
    var value = (0, $5TuPM.default)(object, key);
    return (0, $iwDtm.default)(value) ? value : undefined;
}
var $5fdfd7be9c6bace7$export$2e2bcd8739ae039 = $5fdfd7be9c6bace7$var$getNative;

});
parcelRegister("iwDtm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7c9d5987ef46fd7$export$2e2bcd8739ae039);

var $4YzFW = parcelRequire("4YzFW");

var $cyq7m = parcelRequire("cyq7m");

var $deYtR = parcelRequire("deYtR");

var $3cgXA = parcelRequire("3cgXA");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $d7c9d5987ef46fd7$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $d7c9d5987ef46fd7$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $d7c9d5987ef46fd7$var$funcProto = Function.prototype, $d7c9d5987ef46fd7$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $d7c9d5987ef46fd7$var$funcToString = $d7c9d5987ef46fd7$var$funcProto.toString;
/** Used to check objects for own properties. */ var $d7c9d5987ef46fd7$var$hasOwnProperty = $d7c9d5987ef46fd7$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $d7c9d5987ef46fd7$var$reIsNative = RegExp('^' + $d7c9d5987ef46fd7$var$funcToString.call($d7c9d5987ef46fd7$var$hasOwnProperty).replace($d7c9d5987ef46fd7$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $d7c9d5987ef46fd7$var$baseIsNative(value) {
    if (!(0, $deYtR.default)(value) || (0, $cyq7m.default)(value)) return false;
    var pattern = (0, $4YzFW.default)(value) ? $d7c9d5987ef46fd7$var$reIsNative : $d7c9d5987ef46fd7$var$reIsHostCtor;
    return pattern.test((0, $3cgXA.default)(value));
}
var $d7c9d5987ef46fd7$export$2e2bcd8739ae039 = $d7c9d5987ef46fd7$var$baseIsNative;

});
parcelRegister("4YzFW", function(module, exports) {

$parcel$export(module.exports, "default", () => $39f8706c37b52ebc$export$2e2bcd8739ae039);

var $b6jap = parcelRequire("b6jap");

var $deYtR = parcelRequire("deYtR");
/** `Object#toString` result references. */ var $39f8706c37b52ebc$var$asyncTag = '[object AsyncFunction]', $39f8706c37b52ebc$var$funcTag = '[object Function]', $39f8706c37b52ebc$var$genTag = '[object GeneratorFunction]', $39f8706c37b52ebc$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $39f8706c37b52ebc$var$isFunction(value) {
    if (!(0, $deYtR.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $b6jap.default)(value);
    return tag == $39f8706c37b52ebc$var$funcTag || tag == $39f8706c37b52ebc$var$genTag || tag == $39f8706c37b52ebc$var$asyncTag || tag == $39f8706c37b52ebc$var$proxyTag;
}
var $39f8706c37b52ebc$export$2e2bcd8739ae039 = $39f8706c37b52ebc$var$isFunction;

});
parcelRegister("deYtR", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a3b7f5dbc313899$export$2e2bcd8739ae039);
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $9a3b7f5dbc313899$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $9a3b7f5dbc313899$export$2e2bcd8739ae039 = $9a3b7f5dbc313899$var$isObject;

});


parcelRegister("cyq7m", function(module, exports) {

$parcel$export(module.exports, "default", () => $923ceb72b7966d6a$export$2e2bcd8739ae039);

var $3hV2z = parcelRequire("3hV2z");
/** Used to detect methods masquerading as native. */ var $923ceb72b7966d6a$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $3hV2z.default) && (0, $3hV2z.default).keys && (0, $3hV2z.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $923ceb72b7966d6a$var$isMasked(func) {
    return !!$923ceb72b7966d6a$var$maskSrcKey && $923ceb72b7966d6a$var$maskSrcKey in func;
}
var $923ceb72b7966d6a$export$2e2bcd8739ae039 = $923ceb72b7966d6a$var$isMasked;

});
parcelRegister("3hV2z", function(module, exports) {

$parcel$export(module.exports, "default", () => $264f34ac65518ce4$export$2e2bcd8739ae039);

var $1CjO7 = parcelRequire("1CjO7");
/** Used to detect overreaching core-js shims. */ var $264f34ac65518ce4$var$coreJsData = (0, $1CjO7.default)['__core-js_shared__'];
var $264f34ac65518ce4$export$2e2bcd8739ae039 = $264f34ac65518ce4$var$coreJsData;

});


parcelRegister("3cgXA", function(module, exports) {

$parcel$export(module.exports, "default", () => $253fa5fad2f7d3f8$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $253fa5fad2f7d3f8$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $253fa5fad2f7d3f8$var$funcToString = $253fa5fad2f7d3f8$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $253fa5fad2f7d3f8$var$toSource(func) {
    if (func != null) {
        try {
            return $253fa5fad2f7d3f8$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $253fa5fad2f7d3f8$export$2e2bcd8739ae039 = $253fa5fad2f7d3f8$var$toSource;

});


parcelRegister("5TuPM", function(module, exports) {

$parcel$export(module.exports, "default", () => $44aa01cd3d3b026f$export$2e2bcd8739ae039);
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $44aa01cd3d3b026f$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $44aa01cd3d3b026f$export$2e2bcd8739ae039 = $44aa01cd3d3b026f$var$getValue;

});



parcelRegister("6gEw5", function(module, exports) {

$parcel$export(module.exports, "default", () => $4903aa703df9040d$export$2e2bcd8739ae039);

var $drWAm = parcelRequire("drWAm");

var $jm84E = parcelRequire("jm84E");

var $9cBe0 = parcelRequire("9cBe0");

var $6L3e9 = parcelRequire("6L3e9");

var $5Sues = parcelRequire("5Sues");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4903aa703df9040d$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$4903aa703df9040d$var$MapCache.prototype.clear = (0, $drWAm.default);
$4903aa703df9040d$var$MapCache.prototype['delete'] = (0, $jm84E.default);
$4903aa703df9040d$var$MapCache.prototype.get = (0, $9cBe0.default);
$4903aa703df9040d$var$MapCache.prototype.has = (0, $6L3e9.default);
$4903aa703df9040d$var$MapCache.prototype.set = (0, $5Sues.default);
var $4903aa703df9040d$export$2e2bcd8739ae039 = $4903aa703df9040d$var$MapCache;

});
parcelRegister("drWAm", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cab3dd0965e6571$export$2e2bcd8739ae039);

var $3BJXf = parcelRequire("3BJXf");

var $1kVTl = parcelRequire("1kVTl");

var $anyXd = parcelRequire("anyXd");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $9cab3dd0965e6571$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $3BJXf.default),
        'map': new ((0, $anyXd.default) || (0, $1kVTl.default)),
        'string': new (0, $3BJXf.default)
    };
}
var $9cab3dd0965e6571$export$2e2bcd8739ae039 = $9cab3dd0965e6571$var$mapCacheClear;

});
parcelRegister("3BJXf", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a08796a46e1072e$export$2e2bcd8739ae039);

var $h9CzD = parcelRequire("h9CzD");

var $dVBO5 = parcelRequire("dVBO5");

var $hXtAp = parcelRequire("hXtAp");

var $49e5A = parcelRequire("49e5A");

var $lNHpz = parcelRequire("lNHpz");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $2a08796a46e1072e$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$2a08796a46e1072e$var$Hash.prototype.clear = (0, $h9CzD.default);
$2a08796a46e1072e$var$Hash.prototype['delete'] = (0, $dVBO5.default);
$2a08796a46e1072e$var$Hash.prototype.get = (0, $hXtAp.default);
$2a08796a46e1072e$var$Hash.prototype.has = (0, $49e5A.default);
$2a08796a46e1072e$var$Hash.prototype.set = (0, $lNHpz.default);
var $2a08796a46e1072e$export$2e2bcd8739ae039 = $2a08796a46e1072e$var$Hash;

});
parcelRegister("h9CzD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7d132db72e80a04$export$2e2bcd8739ae039);

var $8VmwQ = parcelRequire("8VmwQ");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $c7d132db72e80a04$var$hashClear() {
    this.__data__ = (0, $8VmwQ.default) ? (0, $8VmwQ.default)(null) : {};
    this.size = 0;
}
var $c7d132db72e80a04$export$2e2bcd8739ae039 = $c7d132db72e80a04$var$hashClear;

});
parcelRegister("8VmwQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $67f51f5241999e99$export$2e2bcd8739ae039);

var $8ekTP = parcelRequire("8ekTP");
/* Built-in method references that are verified to be native. */ var $67f51f5241999e99$var$nativeCreate = (0, $8ekTP.default)(Object, 'create');
var $67f51f5241999e99$export$2e2bcd8739ae039 = $67f51f5241999e99$var$nativeCreate;

});


parcelRegister("dVBO5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a23decdf489eebd6$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $a23decdf489eebd6$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $a23decdf489eebd6$export$2e2bcd8739ae039 = $a23decdf489eebd6$var$hashDelete;

});

parcelRegister("hXtAp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d12ee594ad245c4c$export$2e2bcd8739ae039);

var $8VmwQ = parcelRequire("8VmwQ");
/** Used to stand-in for `undefined` hash values. */ var $d12ee594ad245c4c$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $d12ee594ad245c4c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d12ee594ad245c4c$var$hasOwnProperty = $d12ee594ad245c4c$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d12ee594ad245c4c$var$hashGet(key) {
    var data = this.__data__;
    if (0, $8VmwQ.default) {
        var result = data[key];
        return result === $d12ee594ad245c4c$var$HASH_UNDEFINED ? undefined : result;
    }
    return $d12ee594ad245c4c$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $d12ee594ad245c4c$export$2e2bcd8739ae039 = $d12ee594ad245c4c$var$hashGet;

});

parcelRegister("49e5A", function(module, exports) {

$parcel$export(module.exports, "default", () => $3052ee7ea65dc01d$export$2e2bcd8739ae039);

var $8VmwQ = parcelRequire("8VmwQ");
/** Used for built-in method references. */ var $3052ee7ea65dc01d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3052ee7ea65dc01d$var$hasOwnProperty = $3052ee7ea65dc01d$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $3052ee7ea65dc01d$var$hashHas(key) {
    var data = this.__data__;
    return (0, $8VmwQ.default) ? data[key] !== undefined : $3052ee7ea65dc01d$var$hasOwnProperty.call(data, key);
}
var $3052ee7ea65dc01d$export$2e2bcd8739ae039 = $3052ee7ea65dc01d$var$hashHas;

});

parcelRegister("lNHpz", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdefd9310d2f2bf5$export$2e2bcd8739ae039);

var $8VmwQ = parcelRequire("8VmwQ");
/** Used to stand-in for `undefined` hash values. */ var $fdefd9310d2f2bf5$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $fdefd9310d2f2bf5$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $8VmwQ.default) && value === undefined ? $fdefd9310d2f2bf5$var$HASH_UNDEFINED : value;
    return this;
}
var $fdefd9310d2f2bf5$export$2e2bcd8739ae039 = $fdefd9310d2f2bf5$var$hashSet;

});



parcelRegister("jm84E", function(module, exports) {

$parcel$export(module.exports, "default", () => $e17655b65c18bced$export$2e2bcd8739ae039);

var $em33D = parcelRequire("em33D");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $e17655b65c18bced$var$mapCacheDelete(key) {
    var result = (0, $em33D.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $e17655b65c18bced$export$2e2bcd8739ae039 = $e17655b65c18bced$var$mapCacheDelete;

});
parcelRegister("em33D", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7357defbe87b60d$export$2e2bcd8739ae039);

var $2mTTJ = parcelRequire("2mTTJ");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $a7357defbe87b60d$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $2mTTJ.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $a7357defbe87b60d$export$2e2bcd8739ae039 = $a7357defbe87b60d$var$getMapData;

});
parcelRegister("2mTTJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b98fefce44bd201$export$2e2bcd8739ae039);
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $1b98fefce44bd201$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $1b98fefce44bd201$export$2e2bcd8739ae039 = $1b98fefce44bd201$var$isKeyable;

});



parcelRegister("9cBe0", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b321c1eef2981cb$export$2e2bcd8739ae039);

var $em33D = parcelRequire("em33D");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6b321c1eef2981cb$var$mapCacheGet(key) {
    return (0, $em33D.default)(this, key).get(key);
}
var $6b321c1eef2981cb$export$2e2bcd8739ae039 = $6b321c1eef2981cb$var$mapCacheGet;

});

parcelRegister("6L3e9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4eb9a2ba2e078d5a$export$2e2bcd8739ae039);

var $em33D = parcelRequire("em33D");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $4eb9a2ba2e078d5a$var$mapCacheHas(key) {
    return (0, $em33D.default)(this, key).has(key);
}
var $4eb9a2ba2e078d5a$export$2e2bcd8739ae039 = $4eb9a2ba2e078d5a$var$mapCacheHas;

});

parcelRegister("5Sues", function(module, exports) {

$parcel$export(module.exports, "default", () => $447972606e02aa9b$export$2e2bcd8739ae039);

var $em33D = parcelRequire("em33D");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $447972606e02aa9b$var$mapCacheSet(key, value) {
    var data = (0, $em33D.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $447972606e02aa9b$export$2e2bcd8739ae039 = $447972606e02aa9b$var$mapCacheSet;

});




parcelRegister("aAcMv", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b472e48feb89fa1$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $7b472e48feb89fa1$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $7b472e48feb89fa1$export$2e2bcd8739ae039 = $7b472e48feb89fa1$var$arrayEach;

});

parcelRegister("3sQPX", function(module, exports) {

$parcel$export(module.exports, "default", () => $285cf8f27cd19e22$export$2e2bcd8739ae039);

var $cyokB = parcelRequire("cyokB");

var $7KYX4 = parcelRequire("7KYX4");
/** Used for built-in method references. */ var $285cf8f27cd19e22$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $285cf8f27cd19e22$var$hasOwnProperty = $285cf8f27cd19e22$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $285cf8f27cd19e22$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($285cf8f27cd19e22$var$hasOwnProperty.call(object, key) && (0, $7KYX4.default)(objValue, value)) || value === undefined && !(key in object)) (0, $cyokB.default)(object, key, value);
}
var $285cf8f27cd19e22$export$2e2bcd8739ae039 = $285cf8f27cd19e22$var$assignValue;

});
parcelRegister("cyokB", function(module, exports) {

$parcel$export(module.exports, "default", () => $923b88b5f71bd3f2$export$2e2bcd8739ae039);

var $34MaK = parcelRequire("34MaK");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $923b88b5f71bd3f2$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $34MaK.default)) (0, $34MaK.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $923b88b5f71bd3f2$export$2e2bcd8739ae039 = $923b88b5f71bd3f2$var$baseAssignValue;

});
parcelRegister("34MaK", function(module, exports) {

$parcel$export(module.exports, "default", () => $23d71cd3a41623ba$export$2e2bcd8739ae039);

var $8ekTP = parcelRequire("8ekTP");
var $23d71cd3a41623ba$var$defineProperty = function() {
    try {
        var func = (0, $8ekTP.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $23d71cd3a41623ba$export$2e2bcd8739ae039 = $23d71cd3a41623ba$var$defineProperty;

});



parcelRegister("gwZyQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c08f6336a045da63$export$2e2bcd8739ae039);

var $3VltY = parcelRequire("3VltY");

var $aJJw9 = parcelRequire("aJJw9");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $c08f6336a045da63$var$baseAssign(object, source) {
    return object && (0, $3VltY.default)(source, (0, $aJJw9.default)(source), object);
}
var $c08f6336a045da63$export$2e2bcd8739ae039 = $c08f6336a045da63$var$baseAssign;

});
parcelRegister("3VltY", function(module, exports) {

$parcel$export(module.exports, "default", () => $2db75bee1daba9d7$export$2e2bcd8739ae039);

var $3sQPX = parcelRequire("3sQPX");

var $cyokB = parcelRequire("cyokB");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $2db75bee1daba9d7$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $cyokB.default)(object, key, newValue);
        else (0, $3sQPX.default)(object, key, newValue);
    }
    return object;
}
var $2db75bee1daba9d7$export$2e2bcd8739ae039 = $2db75bee1daba9d7$var$copyObject;

});

parcelRegister("aJJw9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d116a3012d14a8f$export$2e2bcd8739ae039);

var $c5RVa = parcelRequire("c5RVa");

var $ilK2d = parcelRequire("ilK2d");

var $4XMe9 = parcelRequire("4XMe9");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $7d116a3012d14a8f$var$keys(object) {
    return (0, $4XMe9.default)(object) ? (0, $c5RVa.default)(object) : (0, $ilK2d.default)(object);
}
var $7d116a3012d14a8f$export$2e2bcd8739ae039 = $7d116a3012d14a8f$var$keys;

});
parcelRegister("c5RVa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cdfc7497de3ac14$export$2e2bcd8739ae039);

var $02uUy = parcelRequire("02uUy");

var $2lgsn = parcelRequire("2lgsn");

var $h9u6R = parcelRequire("h9u6R");

var $eYlEu = parcelRequire("eYlEu");

var $ebs2M = parcelRequire("ebs2M");

var $kdJ4U = parcelRequire("kdJ4U");
/** Used for built-in method references. */ var $8cdfc7497de3ac14$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8cdfc7497de3ac14$var$hasOwnProperty = $8cdfc7497de3ac14$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $8cdfc7497de3ac14$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $h9u6R.default)(value), isArg = !isArr && (0, $2lgsn.default)(value), isBuff = !isArr && !isArg && (0, $eYlEu.default)(value), isType = !isArr && !isArg && !isBuff && (0, $kdJ4U.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $02uUy.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $8cdfc7497de3ac14$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $ebs2M.default)(key, length)))) result.push(key);
    return result;
}
var $8cdfc7497de3ac14$export$2e2bcd8739ae039 = $8cdfc7497de3ac14$var$arrayLikeKeys;

});
parcelRegister("02uUy", function(module, exports) {

$parcel$export(module.exports, "default", () => $00782a5a9cfa1d2c$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $00782a5a9cfa1d2c$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $00782a5a9cfa1d2c$export$2e2bcd8739ae039 = $00782a5a9cfa1d2c$var$baseTimes;

});

parcelRegister("2lgsn", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b4a4ede89a99490$export$2e2bcd8739ae039);

var $jeTWS = parcelRequire("jeTWS");

var $goIau = parcelRequire("goIau");
/** Used for built-in method references. */ var $1b4a4ede89a99490$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1b4a4ede89a99490$var$hasOwnProperty = $1b4a4ede89a99490$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $1b4a4ede89a99490$var$propertyIsEnumerable = $1b4a4ede89a99490$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $1b4a4ede89a99490$var$isArguments = (0, $jeTWS.default)(function() {
    return arguments;
}()) ? (0, $jeTWS.default) : function(value) {
    return (0, $goIau.default)(value) && $1b4a4ede89a99490$var$hasOwnProperty.call(value, 'callee') && !$1b4a4ede89a99490$var$propertyIsEnumerable.call(value, 'callee');
};
var $1b4a4ede89a99490$export$2e2bcd8739ae039 = $1b4a4ede89a99490$var$isArguments;

});
parcelRegister("jeTWS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e01ab95f9c754fad$export$2e2bcd8739ae039);

var $b6jap = parcelRequire("b6jap");

var $goIau = parcelRequire("goIau");
/** `Object#toString` result references. */ var $e01ab95f9c754fad$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $e01ab95f9c754fad$var$baseIsArguments(value) {
    return (0, $goIau.default)(value) && (0, $b6jap.default)(value) == $e01ab95f9c754fad$var$argsTag;
}
var $e01ab95f9c754fad$export$2e2bcd8739ae039 = $e01ab95f9c754fad$var$baseIsArguments;

});


parcelRegister("h9u6R", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7caa21603bdb95a$export$2e2bcd8739ae039);
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $c7caa21603bdb95a$var$isArray = Array.isArray;
var $c7caa21603bdb95a$export$2e2bcd8739ae039 = $c7caa21603bdb95a$var$isArray;

});

parcelRegister("eYlEu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae6776ec0b67bea7$export$2e2bcd8739ae039);

var $1CjO7 = parcelRequire("1CjO7");

var $8pjhF = parcelRequire("8pjhF");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $1CjO7.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $8pjhF.default);
var $ae6776ec0b67bea7$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("8pjhF", function(module, exports) {

$parcel$export(module.exports, "default", () => $61ef9ded1d15b031$export$2e2bcd8739ae039);
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $61ef9ded1d15b031$var$stubFalse() {
    return false;
}
var $61ef9ded1d15b031$export$2e2bcd8739ae039 = $61ef9ded1d15b031$var$stubFalse;

});


parcelRegister("ebs2M", function(module, exports) {

$parcel$export(module.exports, "default", () => $a537d8ae0a0e1070$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $a537d8ae0a0e1070$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $a537d8ae0a0e1070$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $a537d8ae0a0e1070$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $a537d8ae0a0e1070$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $a537d8ae0a0e1070$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $a537d8ae0a0e1070$export$2e2bcd8739ae039 = $a537d8ae0a0e1070$var$isIndex;

});

parcelRegister("kdJ4U", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb87fd285fdb37b4$export$2e2bcd8739ae039);

var $1o3ln = parcelRequire("1o3ln");

var $fmnL9 = parcelRequire("fmnL9");

var $8gAK4 = parcelRequire("8gAK4");
/* Node.js helper references. */ var $eb87fd285fdb37b4$var$nodeIsTypedArray = (0, $8gAK4.default) && (0, $8gAK4.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $eb87fd285fdb37b4$var$isTypedArray = $eb87fd285fdb37b4$var$nodeIsTypedArray ? (0, $fmnL9.default)($eb87fd285fdb37b4$var$nodeIsTypedArray) : (0, $1o3ln.default);
var $eb87fd285fdb37b4$export$2e2bcd8739ae039 = $eb87fd285fdb37b4$var$isTypedArray;

});
parcelRegister("1o3ln", function(module, exports) {

$parcel$export(module.exports, "default", () => $102aa0578498236d$export$2e2bcd8739ae039);

var $b6jap = parcelRequire("b6jap");

var $7S8vk = parcelRequire("7S8vk");

var $goIau = parcelRequire("goIau");
/** `Object#toString` result references. */ var $102aa0578498236d$var$argsTag = '[object Arguments]', $102aa0578498236d$var$arrayTag = '[object Array]', $102aa0578498236d$var$boolTag = '[object Boolean]', $102aa0578498236d$var$dateTag = '[object Date]', $102aa0578498236d$var$errorTag = '[object Error]', $102aa0578498236d$var$funcTag = '[object Function]', $102aa0578498236d$var$mapTag = '[object Map]', $102aa0578498236d$var$numberTag = '[object Number]', $102aa0578498236d$var$objectTag = '[object Object]', $102aa0578498236d$var$regexpTag = '[object RegExp]', $102aa0578498236d$var$setTag = '[object Set]', $102aa0578498236d$var$stringTag = '[object String]', $102aa0578498236d$var$weakMapTag = '[object WeakMap]';
var $102aa0578498236d$var$arrayBufferTag = '[object ArrayBuffer]', $102aa0578498236d$var$dataViewTag = '[object DataView]', $102aa0578498236d$var$float32Tag = '[object Float32Array]', $102aa0578498236d$var$float64Tag = '[object Float64Array]', $102aa0578498236d$var$int8Tag = '[object Int8Array]', $102aa0578498236d$var$int16Tag = '[object Int16Array]', $102aa0578498236d$var$int32Tag = '[object Int32Array]', $102aa0578498236d$var$uint8Tag = '[object Uint8Array]', $102aa0578498236d$var$uint8ClampedTag = '[object Uint8ClampedArray]', $102aa0578498236d$var$uint16Tag = '[object Uint16Array]', $102aa0578498236d$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $102aa0578498236d$var$typedArrayTags = {};
$102aa0578498236d$var$typedArrayTags[$102aa0578498236d$var$float32Tag] = $102aa0578498236d$var$typedArrayTags[$102aa0578498236d$var$float64Tag] = $102aa0578498236d$var$typedArrayTags[$102aa0578498236d$var$int8Tag] = $102aa0578498236d$var$typedArrayTags[$102aa0578498236d$var$int16Tag] = $102aa0578498236d$var$typedArrayTags[$102aa0578498236d$var$int32Tag] = $102aa0578498236d$var$typedArrayTags[$102aa0578498236d$var$uint8Tag] = $102aa0578498236d$var$typedArrayTags[$102aa0578498236d$var$uint8ClampedTag] = $102aa0578498236d$var$typedArrayTags[$102aa0578498236d$var$uint16Tag] = $102aa0578498236d$var$typedArrayTags[$102aa0578498236d$var$uint32Tag] = true;
$102aa0578498236d$var$typedArrayTags[$102aa0578498236d$var$argsTag] = $102aa0578498236d$var$typedArrayTags[$102aa0578498236d$var$arrayTag] = $102aa0578498236d$var$typedArrayTags[$102aa0578498236d$var$arrayBufferTag] = $102aa0578498236d$var$typedArrayTags[$102aa0578498236d$var$boolTag] = $102aa0578498236d$var$typedArrayTags[$102aa0578498236d$var$dataViewTag] = $102aa0578498236d$var$typedArrayTags[$102aa0578498236d$var$dateTag] = $102aa0578498236d$var$typedArrayTags[$102aa0578498236d$var$errorTag] = $102aa0578498236d$var$typedArrayTags[$102aa0578498236d$var$funcTag] = $102aa0578498236d$var$typedArrayTags[$102aa0578498236d$var$mapTag] = $102aa0578498236d$var$typedArrayTags[$102aa0578498236d$var$numberTag] = $102aa0578498236d$var$typedArrayTags[$102aa0578498236d$var$objectTag] = $102aa0578498236d$var$typedArrayTags[$102aa0578498236d$var$regexpTag] = $102aa0578498236d$var$typedArrayTags[$102aa0578498236d$var$setTag] = $102aa0578498236d$var$typedArrayTags[$102aa0578498236d$var$stringTag] = $102aa0578498236d$var$typedArrayTags[$102aa0578498236d$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $102aa0578498236d$var$baseIsTypedArray(value) {
    return (0, $goIau.default)(value) && (0, $7S8vk.default)(value.length) && !!$102aa0578498236d$var$typedArrayTags[(0, $b6jap.default)(value)];
}
var $102aa0578498236d$export$2e2bcd8739ae039 = $102aa0578498236d$var$baseIsTypedArray;

});
parcelRegister("7S8vk", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bb42c51b05fca8d$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $5bb42c51b05fca8d$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $5bb42c51b05fca8d$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $5bb42c51b05fca8d$var$MAX_SAFE_INTEGER;
}
var $5bb42c51b05fca8d$export$2e2bcd8739ae039 = $5bb42c51b05fca8d$var$isLength;

});


parcelRegister("fmnL9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2eb573bdeb9dee3$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $b2eb573bdeb9dee3$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $b2eb573bdeb9dee3$export$2e2bcd8739ae039 = $b2eb573bdeb9dee3$var$baseUnary;

});

parcelRegister("8gAK4", function(module, exports) {

$parcel$export(module.exports, "default", () => $604c518cf7786281$export$2e2bcd8739ae039);

var $lpbkP = parcelRequire("lpbkP");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $lpbkP.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $604c518cf7786281$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("ilK2d", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5bde5b0dd56e8b3$export$2e2bcd8739ae039);

var $ghAEJ = parcelRequire("ghAEJ");

var $58eM3 = parcelRequire("58eM3");
/** Used for built-in method references. */ var $d5bde5b0dd56e8b3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d5bde5b0dd56e8b3$var$hasOwnProperty = $d5bde5b0dd56e8b3$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $d5bde5b0dd56e8b3$var$baseKeys(object) {
    if (!(0, $ghAEJ.default)(object)) return (0, $58eM3.default)(object);
    var result = [];
    for(var key in Object(object))if ($d5bde5b0dd56e8b3$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $d5bde5b0dd56e8b3$export$2e2bcd8739ae039 = $d5bde5b0dd56e8b3$var$baseKeys;

});
parcelRegister("ghAEJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdaaaafda76b49b4$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $bdaaaafda76b49b4$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $bdaaaafda76b49b4$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $bdaaaafda76b49b4$var$objectProto;
    return value === proto;
}
var $bdaaaafda76b49b4$export$2e2bcd8739ae039 = $bdaaaafda76b49b4$var$isPrototype;

});

parcelRegister("58eM3", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bc928f267b61011$export$2e2bcd8739ae039);

var $bh6lW = parcelRequire("bh6lW");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3bc928f267b61011$var$nativeKeys = (0, $bh6lW.default)(Object.keys, Object);
var $3bc928f267b61011$export$2e2bcd8739ae039 = $3bc928f267b61011$var$nativeKeys;

});


parcelRegister("4XMe9", function(module, exports) {

$parcel$export(module.exports, "default", () => $39d2150371954148$export$2e2bcd8739ae039);

var $4YzFW = parcelRequire("4YzFW");

var $7S8vk = parcelRequire("7S8vk");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $39d2150371954148$var$isArrayLike(value) {
    return value != null && (0, $7S8vk.default)(value.length) && !(0, $4YzFW.default)(value);
}
var $39d2150371954148$export$2e2bcd8739ae039 = $39d2150371954148$var$isArrayLike;

});



parcelRegister("9n0Mp", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d26dde8c6045e98$export$2e2bcd8739ae039);

var $3VltY = parcelRequire("3VltY");

var $b4AUN = parcelRequire("b4AUN");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $6d26dde8c6045e98$var$baseAssignIn(object, source) {
    return object && (0, $3VltY.default)(source, (0, $b4AUN.default)(source), object);
}
var $6d26dde8c6045e98$export$2e2bcd8739ae039 = $6d26dde8c6045e98$var$baseAssignIn;

});
parcelRegister("b4AUN", function(module, exports) {

$parcel$export(module.exports, "default", () => $80fcb3f7e4a7682e$export$2e2bcd8739ae039);

var $c5RVa = parcelRequire("c5RVa");

var $iw5sS = parcelRequire("iw5sS");

var $4XMe9 = parcelRequire("4XMe9");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $80fcb3f7e4a7682e$var$keysIn(object) {
    return (0, $4XMe9.default)(object) ? (0, $c5RVa.default)(object, true) : (0, $iw5sS.default)(object);
}
var $80fcb3f7e4a7682e$export$2e2bcd8739ae039 = $80fcb3f7e4a7682e$var$keysIn;

});
parcelRegister("iw5sS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7af74574ef8af72$export$2e2bcd8739ae039);

var $deYtR = parcelRequire("deYtR");

var $ghAEJ = parcelRequire("ghAEJ");

var $gKUPG = parcelRequire("gKUPG");
/** Used for built-in method references. */ var $d7af74574ef8af72$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d7af74574ef8af72$var$hasOwnProperty = $d7af74574ef8af72$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $d7af74574ef8af72$var$baseKeysIn(object) {
    if (!(0, $deYtR.default)(object)) return (0, $gKUPG.default)(object);
    var isProto = (0, $ghAEJ.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$d7af74574ef8af72$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $d7af74574ef8af72$export$2e2bcd8739ae039 = $d7af74574ef8af72$var$baseKeysIn;

});
parcelRegister("gKUPG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c32d06fb0807456d$export$2e2bcd8739ae039);
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $c32d06fb0807456d$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $c32d06fb0807456d$export$2e2bcd8739ae039 = $c32d06fb0807456d$var$nativeKeysIn;

});




parcelRegister("6OXlT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f7573abd26b0f33$export$2e2bcd8739ae039);

var $1CjO7 = parcelRequire("1CjO7");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $1CjO7.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $4f7573abd26b0f33$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("kDF23", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0674751443491ae$export$2e2bcd8739ae039);
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $f0674751443491ae$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $f0674751443491ae$export$2e2bcd8739ae039 = $f0674751443491ae$var$copyArray;

});

parcelRegister("8XILR", function(module, exports) {

$parcel$export(module.exports, "default", () => $68668fff3a839d36$export$2e2bcd8739ae039);

var $3VltY = parcelRequire("3VltY");

var $hRPzB = parcelRequire("hRPzB");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $68668fff3a839d36$var$copySymbols(source, object) {
    return (0, $3VltY.default)(source, (0, $hRPzB.default)(source), object);
}
var $68668fff3a839d36$export$2e2bcd8739ae039 = $68668fff3a839d36$var$copySymbols;

});
parcelRegister("hRPzB", function(module, exports) {

$parcel$export(module.exports, "default", () => $d01f64434d7b7e2b$export$2e2bcd8739ae039);

var $lxsEC = parcelRequire("lxsEC");

var $gCDhF = parcelRequire("gCDhF");
/** Used for built-in method references. */ var $d01f64434d7b7e2b$var$objectProto = Object.prototype;
/** Built-in value references. */ var $d01f64434d7b7e2b$var$propertyIsEnumerable = $d01f64434d7b7e2b$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d01f64434d7b7e2b$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $d01f64434d7b7e2b$var$getSymbols = !$d01f64434d7b7e2b$var$nativeGetSymbols ? (0, $gCDhF.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $lxsEC.default)($d01f64434d7b7e2b$var$nativeGetSymbols(object), function(symbol) {
        return $d01f64434d7b7e2b$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $d01f64434d7b7e2b$export$2e2bcd8739ae039 = $d01f64434d7b7e2b$var$getSymbols;

});
parcelRegister("lxsEC", function(module, exports) {

$parcel$export(module.exports, "default", () => $fae2e82c3264fee9$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $fae2e82c3264fee9$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $fae2e82c3264fee9$export$2e2bcd8739ae039 = $fae2e82c3264fee9$var$arrayFilter;

});

parcelRegister("gCDhF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c19eaaf2d235a71b$export$2e2bcd8739ae039);
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $c19eaaf2d235a71b$var$stubArray() {
    return [];
}
var $c19eaaf2d235a71b$export$2e2bcd8739ae039 = $c19eaaf2d235a71b$var$stubArray;

});



parcelRegister("hXT3Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $d142a8ca459567db$export$2e2bcd8739ae039);

var $3VltY = parcelRequire("3VltY");

var $imSZz = parcelRequire("imSZz");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $d142a8ca459567db$var$copySymbolsIn(source, object) {
    return (0, $3VltY.default)(source, (0, $imSZz.default)(source), object);
}
var $d142a8ca459567db$export$2e2bcd8739ae039 = $d142a8ca459567db$var$copySymbolsIn;

});
parcelRegister("imSZz", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5f4f05bec0084a3$export$2e2bcd8739ae039);

var $fSs4K = parcelRequire("fSs4K");

var $izG6C = parcelRequire("izG6C");

var $hRPzB = parcelRequire("hRPzB");

var $gCDhF = parcelRequire("gCDhF");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d5f4f05bec0084a3$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $d5f4f05bec0084a3$var$getSymbolsIn = !$d5f4f05bec0084a3$var$nativeGetSymbols ? (0, $gCDhF.default) : function(object) {
    var result = [];
    while(object){
        (0, $fSs4K.default)(result, (0, $hRPzB.default)(object));
        object = (0, $izG6C.default)(object);
    }
    return result;
};
var $d5f4f05bec0084a3$export$2e2bcd8739ae039 = $d5f4f05bec0084a3$var$getSymbolsIn;

});
parcelRegister("fSs4K", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8f1ad5c95f24d23$export$2e2bcd8739ae039);
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $b8f1ad5c95f24d23$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $b8f1ad5c95f24d23$export$2e2bcd8739ae039 = $b8f1ad5c95f24d23$var$arrayPush;

});



parcelRegister("jqco9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e23a0e25bf4dc1a0$export$2e2bcd8739ae039);

var $1KwTC = parcelRequire("1KwTC");

var $hRPzB = parcelRequire("hRPzB");

var $aJJw9 = parcelRequire("aJJw9");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $e23a0e25bf4dc1a0$var$getAllKeys(object) {
    return (0, $1KwTC.default)(object, (0, $aJJw9.default), (0, $hRPzB.default));
}
var $e23a0e25bf4dc1a0$export$2e2bcd8739ae039 = $e23a0e25bf4dc1a0$var$getAllKeys;

});
parcelRegister("1KwTC", function(module, exports) {

$parcel$export(module.exports, "default", () => $14639aca90e99729$export$2e2bcd8739ae039);

var $fSs4K = parcelRequire("fSs4K");

var $h9u6R = parcelRequire("h9u6R");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $14639aca90e99729$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $h9u6R.default)(object) ? result : (0, $fSs4K.default)(result, symbolsFunc(object));
}
var $14639aca90e99729$export$2e2bcd8739ae039 = $14639aca90e99729$var$baseGetAllKeys;

});


parcelRegister("ixgr6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7e80eebd8b68d68$export$2e2bcd8739ae039);

var $1KwTC = parcelRequire("1KwTC");

var $imSZz = parcelRequire("imSZz");

var $b4AUN = parcelRequire("b4AUN");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $d7e80eebd8b68d68$var$getAllKeysIn(object) {
    return (0, $1KwTC.default)(object, (0, $b4AUN.default), (0, $imSZz.default));
}
var $d7e80eebd8b68d68$export$2e2bcd8739ae039 = $d7e80eebd8b68d68$var$getAllKeysIn;

});

parcelRegister("29CVg", function(module, exports) {

$parcel$export(module.exports, "default", () => $191a9d42f3762e56$export$2e2bcd8739ae039);

var $6oS93 = parcelRequire("6oS93");

var $anyXd = parcelRequire("anyXd");

var $5tNk1 = parcelRequire("5tNk1");

var $9J2ps = parcelRequire("9J2ps");

var $4tRAM = parcelRequire("4tRAM");

var $b6jap = parcelRequire("b6jap");

var $3cgXA = parcelRequire("3cgXA");
/** `Object#toString` result references. */ var $191a9d42f3762e56$var$mapTag = '[object Map]', $191a9d42f3762e56$var$objectTag = '[object Object]', $191a9d42f3762e56$var$promiseTag = '[object Promise]', $191a9d42f3762e56$var$setTag = '[object Set]', $191a9d42f3762e56$var$weakMapTag = '[object WeakMap]';
var $191a9d42f3762e56$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $191a9d42f3762e56$var$dataViewCtorString = (0, $3cgXA.default)((0, $6oS93.default)), $191a9d42f3762e56$var$mapCtorString = (0, $3cgXA.default)((0, $anyXd.default)), $191a9d42f3762e56$var$promiseCtorString = (0, $3cgXA.default)((0, $5tNk1.default)), $191a9d42f3762e56$var$setCtorString = (0, $3cgXA.default)((0, $9J2ps.default)), $191a9d42f3762e56$var$weakMapCtorString = (0, $3cgXA.default)((0, $4tRAM.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $191a9d42f3762e56$var$getTag = (0, $b6jap.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $6oS93.default) && $191a9d42f3762e56$var$getTag(new (0, $6oS93.default)(new ArrayBuffer(1))) != $191a9d42f3762e56$var$dataViewTag || (0, $anyXd.default) && $191a9d42f3762e56$var$getTag(new (0, $anyXd.default)) != $191a9d42f3762e56$var$mapTag || (0, $5tNk1.default) && $191a9d42f3762e56$var$getTag((0, $5tNk1.default).resolve()) != $191a9d42f3762e56$var$promiseTag || (0, $9J2ps.default) && $191a9d42f3762e56$var$getTag(new (0, $9J2ps.default)) != $191a9d42f3762e56$var$setTag || (0, $4tRAM.default) && $191a9d42f3762e56$var$getTag(new (0, $4tRAM.default)) != $191a9d42f3762e56$var$weakMapTag) $191a9d42f3762e56$var$getTag = function(value) {
    var result = (0, $b6jap.default)(value), Ctor = result == $191a9d42f3762e56$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $3cgXA.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $191a9d42f3762e56$var$dataViewCtorString:
            return $191a9d42f3762e56$var$dataViewTag;
        case $191a9d42f3762e56$var$mapCtorString:
            return $191a9d42f3762e56$var$mapTag;
        case $191a9d42f3762e56$var$promiseCtorString:
            return $191a9d42f3762e56$var$promiseTag;
        case $191a9d42f3762e56$var$setCtorString:
            return $191a9d42f3762e56$var$setTag;
        case $191a9d42f3762e56$var$weakMapCtorString:
            return $191a9d42f3762e56$var$weakMapTag;
    }
    return result;
};
var $191a9d42f3762e56$export$2e2bcd8739ae039 = $191a9d42f3762e56$var$getTag;

});
parcelRegister("6oS93", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a8efc0eeb92ef0c$export$2e2bcd8739ae039);

var $8ekTP = parcelRequire("8ekTP");

var $1CjO7 = parcelRequire("1CjO7");
/* Built-in method references that are verified to be native. */ var $4a8efc0eeb92ef0c$var$DataView = (0, $8ekTP.default)((0, $1CjO7.default), 'DataView');
var $4a8efc0eeb92ef0c$export$2e2bcd8739ae039 = $4a8efc0eeb92ef0c$var$DataView;

});

parcelRegister("5tNk1", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fd5eb83aa0bc74a$export$2e2bcd8739ae039);

var $8ekTP = parcelRequire("8ekTP");

var $1CjO7 = parcelRequire("1CjO7");
/* Built-in method references that are verified to be native. */ var $3fd5eb83aa0bc74a$var$Promise = (0, $8ekTP.default)((0, $1CjO7.default), 'Promise');
var $3fd5eb83aa0bc74a$export$2e2bcd8739ae039 = $3fd5eb83aa0bc74a$var$Promise;

});

parcelRegister("9J2ps", function(module, exports) {

$parcel$export(module.exports, "default", () => $714a2f80dad77e2c$export$2e2bcd8739ae039);

var $8ekTP = parcelRequire("8ekTP");

var $1CjO7 = parcelRequire("1CjO7");
/* Built-in method references that are verified to be native. */ var $714a2f80dad77e2c$var$Set = (0, $8ekTP.default)((0, $1CjO7.default), 'Set');
var $714a2f80dad77e2c$export$2e2bcd8739ae039 = $714a2f80dad77e2c$var$Set;

});

parcelRegister("4tRAM", function(module, exports) {

$parcel$export(module.exports, "default", () => $343371282d93c324$export$2e2bcd8739ae039);

var $8ekTP = parcelRequire("8ekTP");

var $1CjO7 = parcelRequire("1CjO7");
/* Built-in method references that are verified to be native. */ var $343371282d93c324$var$WeakMap = (0, $8ekTP.default)((0, $1CjO7.default), 'WeakMap');
var $343371282d93c324$export$2e2bcd8739ae039 = $343371282d93c324$var$WeakMap;

});


parcelRegister("bmltf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8452676e05d68b64$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $8452676e05d68b64$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8452676e05d68b64$var$hasOwnProperty = $8452676e05d68b64$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $8452676e05d68b64$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $8452676e05d68b64$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $8452676e05d68b64$export$2e2bcd8739ae039 = $8452676e05d68b64$var$initCloneArray;

});

parcelRegister("UrB4T", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a9aa345eabb9284$export$2e2bcd8739ae039);

var $9sMkM = parcelRequire("9sMkM");

var $buRSZ = parcelRequire("buRSZ");

var $gDiD7 = parcelRequire("gDiD7");

var $jGqXg = parcelRequire("jGqXg");

var $dvVrh = parcelRequire("dvVrh");
/** `Object#toString` result references. */ var $0a9aa345eabb9284$var$boolTag = '[object Boolean]', $0a9aa345eabb9284$var$dateTag = '[object Date]', $0a9aa345eabb9284$var$mapTag = '[object Map]', $0a9aa345eabb9284$var$numberTag = '[object Number]', $0a9aa345eabb9284$var$regexpTag = '[object RegExp]', $0a9aa345eabb9284$var$setTag = '[object Set]', $0a9aa345eabb9284$var$stringTag = '[object String]', $0a9aa345eabb9284$var$symbolTag = '[object Symbol]';
var $0a9aa345eabb9284$var$arrayBufferTag = '[object ArrayBuffer]', $0a9aa345eabb9284$var$dataViewTag = '[object DataView]', $0a9aa345eabb9284$var$float32Tag = '[object Float32Array]', $0a9aa345eabb9284$var$float64Tag = '[object Float64Array]', $0a9aa345eabb9284$var$int8Tag = '[object Int8Array]', $0a9aa345eabb9284$var$int16Tag = '[object Int16Array]', $0a9aa345eabb9284$var$int32Tag = '[object Int32Array]', $0a9aa345eabb9284$var$uint8Tag = '[object Uint8Array]', $0a9aa345eabb9284$var$uint8ClampedTag = '[object Uint8ClampedArray]', $0a9aa345eabb9284$var$uint16Tag = '[object Uint16Array]', $0a9aa345eabb9284$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $0a9aa345eabb9284$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $0a9aa345eabb9284$var$arrayBufferTag:
            return (0, $9sMkM.default)(object);
        case $0a9aa345eabb9284$var$boolTag:
        case $0a9aa345eabb9284$var$dateTag:
            return new Ctor(+object);
        case $0a9aa345eabb9284$var$dataViewTag:
            return (0, $buRSZ.default)(object, isDeep);
        case $0a9aa345eabb9284$var$float32Tag:
        case $0a9aa345eabb9284$var$float64Tag:
        case $0a9aa345eabb9284$var$int8Tag:
        case $0a9aa345eabb9284$var$int16Tag:
        case $0a9aa345eabb9284$var$int32Tag:
        case $0a9aa345eabb9284$var$uint8Tag:
        case $0a9aa345eabb9284$var$uint8ClampedTag:
        case $0a9aa345eabb9284$var$uint16Tag:
        case $0a9aa345eabb9284$var$uint32Tag:
            return (0, $dvVrh.default)(object, isDeep);
        case $0a9aa345eabb9284$var$mapTag:
            return new Ctor;
        case $0a9aa345eabb9284$var$numberTag:
        case $0a9aa345eabb9284$var$stringTag:
            return new Ctor(object);
        case $0a9aa345eabb9284$var$regexpTag:
            return (0, $gDiD7.default)(object);
        case $0a9aa345eabb9284$var$setTag:
            return new Ctor;
        case $0a9aa345eabb9284$var$symbolTag:
            return (0, $jGqXg.default)(object);
    }
}
var $0a9aa345eabb9284$export$2e2bcd8739ae039 = $0a9aa345eabb9284$var$initCloneByTag;

});
parcelRegister("9sMkM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e3c38b8ac8d8704$export$2e2bcd8739ae039);

var $fRPgY = parcelRequire("fRPgY");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $6e3c38b8ac8d8704$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $fRPgY.default)(result).set(new (0, $fRPgY.default)(arrayBuffer));
    return result;
}
var $6e3c38b8ac8d8704$export$2e2bcd8739ae039 = $6e3c38b8ac8d8704$var$cloneArrayBuffer;

});
parcelRegister("fRPgY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8d393f274904ade$export$2e2bcd8739ae039);

var $1CjO7 = parcelRequire("1CjO7");
/** Built-in value references. */ var $b8d393f274904ade$var$Uint8Array = (0, $1CjO7.default).Uint8Array;
var $b8d393f274904ade$export$2e2bcd8739ae039 = $b8d393f274904ade$var$Uint8Array;

});


parcelRegister("buRSZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $85ec4ba6ed18d3bb$export$2e2bcd8739ae039);

var $9sMkM = parcelRequire("9sMkM");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $85ec4ba6ed18d3bb$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $9sMkM.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $85ec4ba6ed18d3bb$export$2e2bcd8739ae039 = $85ec4ba6ed18d3bb$var$cloneDataView;

});

parcelRegister("gDiD7", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1bebd5de99fa7a4$export$2e2bcd8739ae039);
/** Used to match `RegExp` flags from their coerced string values. */ var $c1bebd5de99fa7a4$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $c1bebd5de99fa7a4$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $c1bebd5de99fa7a4$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $c1bebd5de99fa7a4$export$2e2bcd8739ae039 = $c1bebd5de99fa7a4$var$cloneRegExp;

});

parcelRegister("jGqXg", function(module, exports) {

$parcel$export(module.exports, "default", () => $e546d94385afa2ba$export$2e2bcd8739ae039);

var $6rPfl = parcelRequire("6rPfl");
/** Used to convert symbols to primitives and strings. */ var $e546d94385afa2ba$var$symbolProto = (0, $6rPfl.default) ? (0, $6rPfl.default).prototype : undefined, $e546d94385afa2ba$var$symbolValueOf = $e546d94385afa2ba$var$symbolProto ? $e546d94385afa2ba$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $e546d94385afa2ba$var$cloneSymbol(symbol) {
    return $e546d94385afa2ba$var$symbolValueOf ? Object($e546d94385afa2ba$var$symbolValueOf.call(symbol)) : {};
}
var $e546d94385afa2ba$export$2e2bcd8739ae039 = $e546d94385afa2ba$var$cloneSymbol;

});

parcelRegister("dvVrh", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d6ab9cbed780792$export$2e2bcd8739ae039);

var $9sMkM = parcelRequire("9sMkM");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $9d6ab9cbed780792$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $9sMkM.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $9d6ab9cbed780792$export$2e2bcd8739ae039 = $9d6ab9cbed780792$var$cloneTypedArray;

});


parcelRegister("6upji", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b992d81f45dc5f3$export$2e2bcd8739ae039);

var $7rjBq = parcelRequire("7rjBq");

var $izG6C = parcelRequire("izG6C");

var $ghAEJ = parcelRequire("ghAEJ");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $4b992d81f45dc5f3$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $ghAEJ.default)(object) ? (0, $7rjBq.default)((0, $izG6C.default)(object)) : {};
}
var $4b992d81f45dc5f3$export$2e2bcd8739ae039 = $4b992d81f45dc5f3$var$initCloneObject;

});
parcelRegister("7rjBq", function(module, exports) {

$parcel$export(module.exports, "default", () => $56aa42b0344e991c$export$2e2bcd8739ae039);

var $deYtR = parcelRequire("deYtR");
/** Built-in value references. */ var $56aa42b0344e991c$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $56aa42b0344e991c$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $deYtR.default)(proto)) return {};
        if ($56aa42b0344e991c$var$objectCreate) return $56aa42b0344e991c$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $56aa42b0344e991c$export$2e2bcd8739ae039 = $56aa42b0344e991c$var$baseCreate;

});


parcelRegister("iifvl", function(module, exports) {

$parcel$export(module.exports, "default", () => $d515ef564b9ffe64$export$2e2bcd8739ae039);

var $77Tnh = parcelRequire("77Tnh");

var $fmnL9 = parcelRequire("fmnL9");

var $8gAK4 = parcelRequire("8gAK4");
/* Node.js helper references. */ var $d515ef564b9ffe64$var$nodeIsMap = (0, $8gAK4.default) && (0, $8gAK4.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $d515ef564b9ffe64$var$isMap = $d515ef564b9ffe64$var$nodeIsMap ? (0, $fmnL9.default)($d515ef564b9ffe64$var$nodeIsMap) : (0, $77Tnh.default);
var $d515ef564b9ffe64$export$2e2bcd8739ae039 = $d515ef564b9ffe64$var$isMap;

});
parcelRegister("77Tnh", function(module, exports) {

$parcel$export(module.exports, "default", () => $53042416d177c2dd$export$2e2bcd8739ae039);

var $29CVg = parcelRequire("29CVg");

var $goIau = parcelRequire("goIau");
/** `Object#toString` result references. */ var $53042416d177c2dd$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $53042416d177c2dd$var$baseIsMap(value) {
    return (0, $goIau.default)(value) && (0, $29CVg.default)(value) == $53042416d177c2dd$var$mapTag;
}
var $53042416d177c2dd$export$2e2bcd8739ae039 = $53042416d177c2dd$var$baseIsMap;

});


parcelRegister("lpJyH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f96f45c143cacce3$export$2e2bcd8739ae039);

var $goGOS = parcelRequire("goGOS");

var $fmnL9 = parcelRequire("fmnL9");

var $8gAK4 = parcelRequire("8gAK4");
/* Node.js helper references. */ var $f96f45c143cacce3$var$nodeIsSet = (0, $8gAK4.default) && (0, $8gAK4.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $f96f45c143cacce3$var$isSet = $f96f45c143cacce3$var$nodeIsSet ? (0, $fmnL9.default)($f96f45c143cacce3$var$nodeIsSet) : (0, $goGOS.default);
var $f96f45c143cacce3$export$2e2bcd8739ae039 = $f96f45c143cacce3$var$isSet;

});
parcelRegister("goGOS", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf001a49dc4a63fb$export$2e2bcd8739ae039);

var $29CVg = parcelRequire("29CVg");

var $goIau = parcelRequire("goIau");
/** `Object#toString` result references. */ var $bf001a49dc4a63fb$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $bf001a49dc4a63fb$var$baseIsSet(value) {
    return (0, $goIau.default)(value) && (0, $29CVg.default)(value) == $bf001a49dc4a63fb$var$setTag;
}
var $bf001a49dc4a63fb$export$2e2bcd8739ae039 = $bf001a49dc4a63fb$var$baseIsSet;

});




parcelRegister("1NPkl", function(module, exports) {
'use strict';
var $15022e88a09b93ad$var$isArray = Array.isArray;
var $15022e88a09b93ad$var$keyList = Object.keys;
var $15022e88a09b93ad$var$hasProp = Object.prototype.hasOwnProperty;
var $15022e88a09b93ad$var$hasElementType = typeof Element !== 'undefined';
function $15022e88a09b93ad$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = $15022e88a09b93ad$var$isArray(a), arrB = $15022e88a09b93ad$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$15022e88a09b93ad$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $15022e88a09b93ad$var$keyList(a);
        length = keys.length;
        if (length !== $15022e88a09b93ad$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$15022e88a09b93ad$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($15022e88a09b93ad$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$15022e88a09b93ad$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $15022e88a09b93ad$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("1uokg", function(module, exports) {

$parcel$export(module.exports, "default", () => $115b7665995f98c4$export$2e2bcd8739ae039);
var $115b7665995f98c4$var$isProduction = false;
function $115b7665995f98c4$var$warning(condition, message) {
    if (!$115b7665995f98c4$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $115b7665995f98c4$export$2e2bcd8739ae039 = $115b7665995f98c4$var$warning;

});

parcelRegister("e01SD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a312861f2e5843ca$export$2e2bcd8739ae039);

var $4PVoT = parcelRequire("4PVoT");
/** Used to compose bitmasks for cloning. */ var $a312861f2e5843ca$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $a312861f2e5843ca$var$clone(value) {
    return (0, $4PVoT.default)(value, $a312861f2e5843ca$var$CLONE_SYMBOLS_FLAG);
}
var $a312861f2e5843ca$export$2e2bcd8739ae039 = $a312861f2e5843ca$var$clone;

});

parcelRegister("iCzw1", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8e75342a8591053$export$2e2bcd8739ae039);

var $1WKIP = parcelRequire("1WKIP");

var $kDF23 = parcelRequire("kDF23");

var $h9u6R = parcelRequire("h9u6R");

var $2dcIZ = parcelRequire("2dcIZ");

var $c9YXn = parcelRequire("c9YXn");

var $gTd9M = parcelRequire("gTd9M");

var $7nC9f = parcelRequire("7nC9f");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $d8e75342a8591053$var$toPath(value) {
    if ((0, $h9u6R.default)(value)) return (0, $1WKIP.default)(value, (0, $gTd9M.default));
    return (0, $2dcIZ.default)(value) ? [
        value
    ] : (0, $kDF23.default)((0, $c9YXn.default)((0, $7nC9f.default)(value)));
}
var $d8e75342a8591053$export$2e2bcd8739ae039 = $d8e75342a8591053$var$toPath;

});
parcelRegister("1WKIP", function(module, exports) {

$parcel$export(module.exports, "default", () => $16af733f56108264$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $16af733f56108264$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $16af733f56108264$export$2e2bcd8739ae039 = $16af733f56108264$var$arrayMap;

});

parcelRegister("2dcIZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $19c6aa82ef77b5e8$export$2e2bcd8739ae039);

var $b6jap = parcelRequire("b6jap");

var $goIau = parcelRequire("goIau");
/** `Object#toString` result references. */ var $19c6aa82ef77b5e8$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $19c6aa82ef77b5e8$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $goIau.default)(value) && (0, $b6jap.default)(value) == $19c6aa82ef77b5e8$var$symbolTag;
}
var $19c6aa82ef77b5e8$export$2e2bcd8739ae039 = $19c6aa82ef77b5e8$var$isSymbol;

});

parcelRegister("c9YXn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8da59c0469c57fe6$export$2e2bcd8739ae039);

var $lXHLF = parcelRequire("lXHLF");
/** Used to match property names within property paths. */ var $8da59c0469c57fe6$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $8da59c0469c57fe6$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $8da59c0469c57fe6$var$stringToPath = (0, $lXHLF.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($8da59c0469c57fe6$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($8da59c0469c57fe6$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $8da59c0469c57fe6$export$2e2bcd8739ae039 = $8da59c0469c57fe6$var$stringToPath;

});
parcelRegister("lXHLF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffd10f0b092e4b5b$export$2e2bcd8739ae039);

var $56Ron = parcelRequire("56Ron");
/** Used as the maximum memoize cache size. */ var $ffd10f0b092e4b5b$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $ffd10f0b092e4b5b$var$memoizeCapped(func) {
    var result = (0, $56Ron.default)(func, function(key) {
        if (cache.size === $ffd10f0b092e4b5b$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $ffd10f0b092e4b5b$export$2e2bcd8739ae039 = $ffd10f0b092e4b5b$var$memoizeCapped;

});
parcelRegister("56Ron", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b86eddd9c07b3fe$export$2e2bcd8739ae039);

var $6gEw5 = parcelRequire("6gEw5");
/** Error message constants. */ var $3b86eddd9c07b3fe$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $3b86eddd9c07b3fe$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($3b86eddd9c07b3fe$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($3b86eddd9c07b3fe$var$memoize.Cache || (0, $6gEw5.default));
    return memoized;
}
// Expose `MapCache`.
$3b86eddd9c07b3fe$var$memoize.Cache = (0, $6gEw5.default);
var $3b86eddd9c07b3fe$export$2e2bcd8739ae039 = $3b86eddd9c07b3fe$var$memoize;

});



parcelRegister("gTd9M", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4bbfd0d94687f32$export$2e2bcd8739ae039);

var $2dcIZ = parcelRequire("2dcIZ");
/** Used as references for various `Number` constants. */ var $c4bbfd0d94687f32$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $c4bbfd0d94687f32$var$toKey(value) {
    if (typeof value == 'string' || (0, $2dcIZ.default)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$c4bbfd0d94687f32$var$INFINITY ? '-0' : result;
}
var $c4bbfd0d94687f32$export$2e2bcd8739ae039 = $c4bbfd0d94687f32$var$toKey;

});

parcelRegister("7nC9f", function(module, exports) {

$parcel$export(module.exports, "default", () => $55f845d1f62e780c$export$2e2bcd8739ae039);

var $heB7h = parcelRequire("heB7h");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $55f845d1f62e780c$var$toString(value) {
    return value == null ? '' : (0, $heB7h.default)(value);
}
var $55f845d1f62e780c$export$2e2bcd8739ae039 = $55f845d1f62e780c$var$toString;

});
parcelRegister("heB7h", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8c0890aa5885e51$export$2e2bcd8739ae039);

var $6rPfl = parcelRequire("6rPfl");

var $1WKIP = parcelRequire("1WKIP");

var $h9u6R = parcelRequire("h9u6R");

var $2dcIZ = parcelRequire("2dcIZ");
/** Used as references for various `Number` constants. */ var $c8c0890aa5885e51$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $c8c0890aa5885e51$var$symbolProto = (0, $6rPfl.default) ? (0, $6rPfl.default).prototype : undefined, $c8c0890aa5885e51$var$symbolToString = $c8c0890aa5885e51$var$symbolProto ? $c8c0890aa5885e51$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $c8c0890aa5885e51$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $h9u6R.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $1WKIP.default)(value, $c8c0890aa5885e51$var$baseToString) + '';
    if ((0, $2dcIZ.default)(value)) return $c8c0890aa5885e51$var$symbolToString ? $c8c0890aa5885e51$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$c8c0890aa5885e51$var$INFINITY ? '-0' : result;
}
var $c8c0890aa5885e51$export$2e2bcd8739ae039 = $c8c0890aa5885e51$var$baseToString;

});




parcelRegister("eYzFO", function(module, exports) {

$parcel$export(module.exports, "useFlexIgnoreZonesOnboardingStore", () => $3c3d6b96e6551cfe$export$fa3f75da127f33a6);

var $9OjAn = parcelRequire("9OjAn");

var $195EM = parcelRequire("195EM");

var $815yO = parcelRequire("815yO");

var $83bsI = parcelRequire("83bsI");

var $3FJ79 = parcelRequire("3FJ79");

var $7ulPk = parcelRequire("7ulPk");

var $9s9JO = parcelRequire("9s9JO");

var $6JE7U = parcelRequire("6JE7U");

var $5P5Ui = parcelRequire("5P5Ui");

var $9hVqI = parcelRequire("9hVqI");
const $3c3d6b96e6551cfe$var$formatAdjustedDimensions = (dimensions)=>{
    const [width, height] = dimensions.split(" x ").map(Number);
    if (!width || !height) return {
        x: 720,
        y: 405
    };
    const ratio = height / width;
    return {
        x: 720,
        y: Math.round(720 * ratio)
    };
};
const $3c3d6b96e6551cfe$var$scheduleCameraKey = (scheduleId, cameraId)=>`${scheduleId}:${cameraId}`;
const $3c3d6b96e6551cfe$var$buildDefaultPresetName = (cameraName)=>{
    const normalizedCameraName = (cameraName || "").trim();
    return normalizedCameraName.length > 0 ? `Default Preset ${normalizedCameraName}` : "Default Preset";
};
const $3c3d6b96e6551cfe$var$isDefaultPresetName = (presetName, expectedName)=>presetName === expectedName || presetName === "Default Preset" || presetName === "Default Preset 1";
const $3c3d6b96e6551cfe$var$nextPresetName = (presets)=>{
    let index = 2;
    while(presets.some((preset)=>preset.name === `Preset ${index}`))index += 1;
    return `Preset ${index}`;
};
const $3c3d6b96e6551cfe$var$cloneIgnoreZones = (zones)=>zones.map((zone)=>({
            ...zone,
            coordinates: zone.coordinates.map((coordinateGroup)=>coordinateGroup.map((coordinate)=>coordinate))
        }));
const $3c3d6b96e6551cfe$var$parsePresetListFromResponse = (data)=>{
    if (data && typeof data === "object" && Array.isArray(data.results)) return data.results;
    if (Array.isArray(data)) return data;
    return [];
};
/** `id → name` for every row of `GET preset/?camera=` (missing names become "Preset #<id>"). */ const $3c3d6b96e6551cfe$var$presetNamesFromList = (rows)=>{
    const names = {};
    rows.forEach((row)=>{
        const id = Number(row?.id);
        if (!Number.isFinite(id)) return;
        const name = String(row?.name ?? "").trim();
        names[id] = name.length > 0 ? name : `Preset #${id}`;
    });
    return names;
};
/**
 * Site About overlays expect each zone's `coordinates` to be a list of polygons
 * (`number[][][]`). Camera ignore-zone APIs and preset-zone payloads sometimes
 * return a single polygon as `number[][]`; normalize so polygons render.
 */ const $3c3d6b96e6551cfe$var$coerceCoordinatesToPolygonList = (raw)=>{
    if (!Array.isArray(raw) || raw.length === 0) return [];
    const first = raw[0];
    if (!Array.isArray(first)) return [];
    const firstFirst = first[0];
    if (typeof firstFirst === "number") return [
        raw
    ];
    if (Array.isArray(firstFirst) && typeof firstFirst[0] === "number") return raw;
    return [];
};
const $3c3d6b96e6551cfe$var$presetZoneLabelDisplayName = (zone)=>{
    const raw = (zone.name || "").trim();
    if (!raw) return "Preset zone";
    return raw.replace(/\s*#\d+\s*$/u, "").trim() || raw;
};
const $3c3d6b96e6551cfe$var$normalizeZoneName = (value)=>value.trim().toLowerCase().replace(/^ignore[_\s]+/, "").replace(/\s+/g, " ");
const $3c3d6b96e6551cfe$var$pickDefaultZoneTemplate = (defaultZones, candidateName, metricId)=>{
    const byMetric = typeof metricId === "number" && Number.isFinite(metricId) ? defaultZones.find((zone)=>Number(zone.metric_id) === metricId) : undefined;
    if (byMetric) return byMetric;
    const normalizedCandidate = $3c3d6b96e6551cfe$var$normalizeZoneName(candidateName || "");
    if (!normalizedCandidate) return undefined;
    return defaultZones.find((zone)=>{
        const displayName = $3c3d6b96e6551cfe$var$normalizeZoneName(zone.label_display_name || "");
        const labelName = $3c3d6b96e6551cfe$var$normalizeZoneName(zone.label || "");
        return displayName === normalizedCandidate || labelName === normalizedCandidate;
    });
};
const $3c3d6b96e6551cfe$var$pickIgnoreAllTemplate = (defaultZones)=>defaultZones.find((zone)=>Number(zone.metric_id) === 0) || defaultZones.find((zone)=>Number(zone.zone_type) === 0) || defaultZones.find((zone)=>$3c3d6b96e6551cfe$var$normalizeZoneName(zone.label || "") === "all") || defaultZones.find((zone)=>$3c3d6b96e6551cfe$var$normalizeZoneName(zone.label_display_name || "") === "all") || defaultZones.find((zone)=>$3c3d6b96e6551cfe$var$normalizeZoneName(zone.label || "") === "motion") || defaultZones.find((zone)=>$3c3d6b96e6551cfe$var$normalizeZoneName(zone.label_display_name || "") === "motion");
const $3c3d6b96e6551cfe$var$polygonSignature = (polygon)=>JSON.stringify(polygon || []);
const $3c3d6b96e6551cfe$var$initialState = {
    enabledBySite: {},
    flexIgnoreZonesEnabledSyncLoadingBySite: {},
    flexIgnoreZonesEnabledSyncErrorBySite: {},
    isOpen: false,
    siteId: null,
    schedules: [],
    cameras: [],
    step: "scheduleSelection",
    activeScheduleIndex: 0,
    activeCameraIndex: 0,
    selectedCameraIdsBySchedule: {},
    selectedPresetByScheduleCamera: {},
    cameraContexts: {},
    presetsByCamera: {},
    presetNamesByCamera: {},
    cameraFirstResolvedPresetByCamera: {},
    hideDefaultPresetForCamera: {},
    pendingEditorContext: null,
    submitLoading: false,
    submitError: null,
    backendContractNotes: []
};
const $3c3d6b96e6551cfe$export$fa3f75da127f33a6 = (0, $9OjAn.create)((set, get)=>({
        ...$3c3d6b96e6551cfe$var$initialState,
        setEnabledForSite: (siteId, enabled)=>{
            set((state)=>({
                    enabledBySite: {
                        ...state.enabledBySite,
                        [siteId]: enabled
                    }
                }));
        },
        syncFlexIgnoreZonesEnabledFromApi: async (siteId, cameras, flexSchedules, flexIgnoreZonesFeatureEnabled = true)=>{
            if (!flexIgnoreZonesFeatureEnabled) return;
            try {
                localStorage.removeItem(`flexIgnoreZonesEnabled_${siteId}`);
                set((state)=>({
                        flexIgnoreZonesEnabledSyncLoadingBySite: {
                            ...state.flexIgnoreZonesEnabledSyncLoadingBySite,
                            [siteId]: true
                        },
                        flexIgnoreZonesEnabledSyncErrorBySite: {
                            ...state.flexIgnoreZonesEnabledSyncErrorBySite,
                            [siteId]: undefined
                        }
                    }));
                const AxiosUI = (0, $195EM.createApi)("");
                const cameraIds = cameras.map((c)=>c.id);
                let hasAnyPresets = false;
                for (const cameraId of cameraIds){
                    const res = await AxiosUI.get(`preset/?camera=${cameraId}`);
                    const list = $3c3d6b96e6551cfe$var$parsePresetListFromResponse(res.data);
                    if (list.length > 0) {
                        hasAnyPresets = true;
                        break;
                    }
                }
                get().setEnabledForSite(siteId, hasAnyPresets);
                if (hasAnyPresets) {
                    const fallbackStoreSchedulesRaw = (0, $3FJ79.useSiteAboutStore).getState().siteSchedules;
                    const fallbackStoreSchedules = Array.isArray(fallbackStoreSchedulesRaw) ? fallbackStoreSchedulesRaw.map((s, idx)=>({
                            id: Number(s?.id ?? idx + 1),
                            display_name: s?.display_name || `Schedule ${idx + 1}`
                        })).filter((s)=>Number.isFinite(s.id)) : [];
                    const schedules = flexSchedules?.length ? flexSchedules : fallbackStoreSchedules.length > 0 ? fallbackStoreSchedules : [];
                    const cameraIdList = cameras.map((c)=>c.id);
                    const selectedCameraIdsBySchedule = schedules.length > 0 ? schedules.reduce((acc, sch)=>({
                            ...acc,
                            [sch.id]: cameraIdList
                        }), {}) : undefined;
                    set((state)=>({
                            siteId: siteId,
                            cameras: cameras,
                            ...schedules.length > 0 ? {
                                schedules: schedules,
                                selectedCameraIdsBySchedule: selectedCameraIdsBySchedule
                            } : {}
                        }));
                    await Promise.all(cameraIds.map((id)=>get().loadCameraContext(id, true)));
                    if (schedules.length > 0) {
                        const selectedPresetByScheduleCamera = {};
                        for (const schedule of schedules)for (const camera of cameras){
                            const key = $3c3d6b96e6551cfe$var$scheduleCameraKey(schedule.id, camera.id);
                            // No row, or a row with `preset: null`, means the camera runs its
                            // own zones/lines under this schedule ("Default") — never a
                            // synthesized preset name (ENG-1610).
                            let presetLocalId = (0, $9s9JO.FLEX_IZ_DEFAULT_CAMERA_CONFIG_OPTION);
                            try {
                                const assignRes = await AxiosUI.get("camera-schedule-preset/", {
                                    params: {
                                        camera: camera.id,
                                        flex_schedule: schedule.id
                                    }
                                });
                                const rows = $3c3d6b96e6551cfe$var$parsePresetListFromResponse(assignRes.data);
                                const firstRow = rows[0];
                                const presetsForCam = get().presetsByCamera[camera.id] || [];
                                const matchedRowByCameraPreset = rows.find((row)=>{
                                    const presetId = Number(row?.preset);
                                    if (!Number.isFinite(presetId)) return false;
                                    return presetsForCam.some((preset)=>preset.persistedId === presetId);
                                });
                                const assignmentRow = matchedRowByCameraPreset || firstRow;
                                if (assignmentRow && assignmentRow.preset != null) {
                                    const pid = Number(assignmentRow.preset);
                                    const match = presetsForCam.find((p)=>p.persistedId === pid);
                                    presetLocalId = match ? match.localId : `server-${pid}`;
                                    if (!match) // Not in the zone-bundle list: make sure its real name is
                                    // known so the schedule summary can label it.
                                    await get().ensurePresetNamesLoaded(camera.id, pid);
                                }
                            } catch  {
                            // Keep Default if list endpoint or row is unavailable.
                            }
                            selectedPresetByScheduleCamera[key] = presetLocalId;
                        }
                        set((state)=>({
                                selectedPresetByScheduleCamera: {
                                    ...state.selectedPresetByScheduleCamera,
                                    ...selectedPresetByScheduleCamera
                                }
                            }));
                    }
                } else set((state)=>{
                    const nextPresets = {
                        ...state.presetsByCamera
                    };
                    cameraIds.forEach((id)=>{
                        delete nextPresets[id];
                    });
                    return {
                        presetsByCamera: nextPresets
                    };
                });
            } catch (error) {
                set((state)=>({
                        flexIgnoreZonesEnabledSyncErrorBySite: {
                            ...state.flexIgnoreZonesEnabledSyncErrorBySite,
                            [siteId]: error?.message || "Unable to sync Flex Ignore Zones state from the API."
                        },
                        enabledBySite: {
                            ...state.enabledBySite,
                            [siteId]: false
                        }
                    }));
            } finally{
                set((state)=>({
                        flexIgnoreZonesEnabledSyncLoadingBySite: {
                            ...state.flexIgnoreZonesEnabledSyncLoadingBySite,
                            [siteId]: false
                        }
                    }));
            }
        },
        initializeFromSite: ({ siteId: siteId, schedules: schedules, cameras: cameras })=>{
            const allCameraIds = cameras.map((camera)=>camera.id);
            const selectedCameraIdsBySchedule = schedules.reduce((acc, schedule)=>({
                    ...acc,
                    [schedule.id]: allCameraIds
                }), {});
            const selectedPresetByScheduleCamera = schedules.reduce((acc, schedule)=>{
                cameras.forEach((camera)=>{
                    acc[$3c3d6b96e6551cfe$var$scheduleCameraKey(schedule.id, camera.id)] = `default-${camera.id}`;
                });
                return acc;
            }, {});
            set((state)=>({
                    ...$3c3d6b96e6551cfe$var$initialState,
                    enabledBySite: {
                        ...state.enabledBySite,
                        [siteId]: state.enabledBySite[siteId] ?? true
                    },
                    flexIgnoreZonesEnabledSyncLoadingBySite: state.flexIgnoreZonesEnabledSyncLoadingBySite,
                    flexIgnoreZonesEnabledSyncErrorBySite: state.flexIgnoreZonesEnabledSyncErrorBySite,
                    isOpen: true,
                    siteId: siteId,
                    schedules: schedules,
                    cameras: cameras,
                    selectedCameraIdsBySchedule: selectedCameraIdsBySchedule,
                    selectedPresetByScheduleCamera: selectedPresetByScheduleCamera
                }));
        },
        closeDialog: ()=>set((state)=>({
                    ...state,
                    isOpen: false,
                    step: "scheduleSelection",
                    pendingEditorContext: null,
                    submitError: null
                })),
        setStep: (step)=>set({
                step: step
            }),
        setActiveScheduleIndex: (activeScheduleIndex)=>set({
                activeScheduleIndex: activeScheduleIndex
            }),
        setActiveCameraIndex: (activeCameraIndex)=>set({
                activeCameraIndex: activeCameraIndex
            }),
        setSelectedCamerasForSchedule: (scheduleId, cameraIds)=>set((state)=>({
                    selectedCameraIdsBySchedule: {
                        ...state.selectedCameraIdsBySchedule,
                        [scheduleId]: cameraIds
                    }
                })),
        setSelectedPresetForScheduleCamera: (scheduleId, cameraId, presetLocalId)=>set((state)=>{
                (0, $3FJ79.useSiteAboutStore).getState().setScheduleChangesMade(true);
                return {
                    selectedPresetByScheduleCamera: {
                        ...state.selectedPresetByScheduleCamera,
                        [$3c3d6b96e6551cfe$var$scheduleCameraKey(scheduleId, cameraId)]: presetLocalId
                    }
                };
            }),
        ensurePresetNamesLoaded: async (cameraId, presetId)=>{
            if (get().presetNamesByCamera[cameraId]?.[presetId] != null) return;
            try {
                const AxiosUI = (0, $195EM.createApi)("");
                const res = await AxiosUI.get(`preset/?camera=${cameraId}`);
                const names = $3c3d6b96e6551cfe$var$presetNamesFromList($3c3d6b96e6551cfe$var$parsePresetListFromResponse(res.data));
                set((state)=>({
                        presetNamesByCamera: {
                            ...state.presetNamesByCamera,
                            [cameraId]: {
                                ...state.presetNamesByCamera[cameraId] || {},
                                ...names
                            }
                        }
                    }));
            } catch  {
            // Summary falls back to "Preset #<id>" when the name stays unknown.
            }
        },
        loadCameraContext: async (cameraId, forceRefresh = false)=>{
            const currentContext = get().cameraContexts[cameraId];
            if (!forceRefresh && (currentContext?.loaded || currentContext?.loading)) return;
            const cameraFromSiteState = get().cameras.find((camera)=>camera.id === cameraId);
            const fallbackDefaultZones = (0, $83bsI.addIgnoreLabel)(cameraFromSiteState?.ignore_zones || []);
            const fallbackPreviewUrl = cameraFromSiteState?.preview_url || "";
            set((state)=>({
                    cameraContexts: {
                        ...state.cameraContexts,
                        [cameraId]: {
                            loaded: false,
                            loading: true,
                            error: null,
                            preview: fallbackPreviewUrl ? {
                                previewUrl: fallbackPreviewUrl,
                                adjustedDimensions: {
                                    x: 720,
                                    y: 405
                                }
                            } : null,
                            defaultZones: $3c3d6b96e6551cfe$var$cloneIgnoreZones(fallbackDefaultZones)
                        }
                    }
                }));
            try {
                const AxiosUI = (0, $195EM.createApi)("");
                const [statusResponse, ignoreZonesResponse, presetsResponse] = await Promise.all([
                    AxiosUI.get(`/camera/${cameraId}/status/`),
                    AxiosUI.get(`/camera/${cameraId}/ignore_zones/`),
                    AxiosUI.get(`preset/?camera=${cameraId}`)
                ]);
                const defaultZones = (0, $83bsI.addIgnoreLabel)(ignoreZonesResponse.data || []);
                const existingPresetsRaw = $3c3d6b96e6551cfe$var$parsePresetListFromResponse(presetsResponse.data);
                const existingPresets = await Promise.all(existingPresetsRaw.map(async (preset)=>{
                    let mappedPresetZones = [];
                    try {
                        const presetZonesResponse = await AxiosUI.get(`preset-zone/?camera=${cameraId}&preset=${preset.id}`);
                        const presetZonesRaw = Array.isArray(presetZonesResponse.data?.results) ? presetZonesResponse.data.results : Array.isArray(presetZonesResponse.data) ? presetZonesResponse.data : [];
                        mappedPresetZones = presetZonesRaw.map((zone, zoneIndex)=>{
                            const nestedLabels = Array.isArray(zone?.labels) ? zone.labels.filter((labelEntry)=>labelEntry && typeof labelEntry === "object") : [];
                            if (nestedLabels.length > 0) {
                                const nestedLabelCoordinateLists = nestedLabels.map((labelEntry)=>$3c3d6b96e6551cfe$var$coerceCoordinatesToPolygonList(labelEntry.coordinates ?? zone.coordinates));
                                const coordinateSignatures = nestedLabels.map((labelEntry)=>JSON.stringify($3c3d6b96e6551cfe$var$coerceCoordinatesToPolygonList(labelEntry.coordinates ?? zone.coordinates)));
                                const uniqueCoordinateSignatures = new Set(coordinateSignatures);
                                const polygonFrequency = new Map();
                                const polygonBySignature = new Map();
                                nestedLabelCoordinateLists.forEach((polygonList)=>{
                                    const uniqueInLabel = new Set();
                                    polygonList.forEach((polygon)=>{
                                        const sig = $3c3d6b96e6551cfe$var$polygonSignature(polygon);
                                        polygonBySignature.set(sig, polygon);
                                        uniqueInLabel.add(sig);
                                    });
                                    uniqueInLabel.forEach((sig)=>{
                                        polygonFrequency.set(sig, (polygonFrequency.get(sig) || 0) + 1);
                                    });
                                });
                                const sharedPolygonThreshold = Math.max(2, Math.ceil(nestedLabels.length / 2));
                                const sharedPolygonSignatures = Array.from(polygonFrequency.entries()).filter(([, count])=>count >= sharedPolygonThreshold).map(([sig])=>sig);
                                const sharedPolygons = sharedPolygonSignatures.map((sig)=>polygonBySignature.get(sig)).filter((polygon)=>Array.isArray(polygon));
                                let nestedMappedZones = nestedLabels.map((labelEntry, labelIndex)=>{
                                    const labelName = labelEntry.name || labelEntry.label_name || zone.name || "preset_zone";
                                    const labelMetricId = Number(labelEntry.label ?? labelEntry.label_id ?? zone.metric_id ?? 0);
                                    const baseTemplate = $3c3d6b96e6551cfe$var$pickDefaultZoneTemplate(defaultZones, labelName, Number.isFinite(labelMetricId) ? labelMetricId : undefined);
                                    const coords = $3c3d6b96e6551cfe$var$coerceCoordinatesToPolygonList(labelEntry.coordinates ?? zone.coordinates);
                                    const rawId = zone.id;
                                    const presetZoneId = rawId != null && Number.isFinite(Number(rawId)) ? Number(rawId) : undefined;
                                    const resolvedZoneType = zone.zone_type ?? baseTemplate?.zone_type ?? 0;
                                    const resolvedLineColor = zone.line_color || baseTemplate?.line_color || "#FF8400";
                                    return {
                                        zone_type: resolvedZoneType,
                                        stream_id: zone.stream_id ?? baseTemplate?.stream_id ?? 0,
                                        stream_name: zone.stream_name ?? baseTemplate?.stream_name ?? "",
                                        metric_id: Number.isFinite(labelMetricId) ? labelMetricId : baseTemplate?.metric_id || 0,
                                        label: `${labelName}-${zoneIndex}-${labelIndex}`,
                                        label_display_name: baseTemplate?.label_display_name || $3c3d6b96e6551cfe$var$presetZoneLabelDisplayName({
                                            name: labelName
                                        }),
                                        line_color: resolvedLineColor,
                                        coordinates: coords,
                                        ...presetZoneId !== undefined ? {
                                            preset_zone_id: presetZoneId
                                        } : {}
                                    };
                                }).flat();
                                if (uniqueCoordinateSignatures.size > 1 && sharedPolygons.length > 0 && nestedMappedZones.length > 0) {
                                    const ignoreAllTemplate = $3c3d6b96e6551cfe$var$pickIgnoreAllTemplate(defaultZones);
                                    const sharedPolygonSignatureSet = new Set(sharedPolygons.map((polygon)=>$3c3d6b96e6551cfe$var$polygonSignature(polygon)));
                                    const hasIgnoreAll = nestedMappedZones.some((zoneEntry)=>Number(zoneEntry.zone_type) === 0);
                                    if (!hasIgnoreAll) nestedMappedZones.unshift({
                                        zone_type: 0,
                                        stream_id: zone.stream_id ?? ignoreAllTemplate?.stream_id ?? 0,
                                        stream_name: zone.stream_name ?? ignoreAllTemplate?.stream_name ?? "",
                                        metric_id: ignoreAllTemplate?.metric_id ?? 0,
                                        label: "ignore_all_inferred",
                                        label_display_name: ignoreAllTemplate?.label_display_name || "Ignore All",
                                        line_color: ignoreAllTemplate?.line_color || "#ffff00",
                                        coordinates: sharedPolygons,
                                        ...zone.id != null && Number.isFinite(Number(zone.id)) ? {
                                            preset_zone_id: Number(zone.id)
                                        } : {}
                                    });
                                    nestedMappedZones = nestedMappedZones.map((zoneEntry)=>{
                                        if (Number(zoneEntry.zone_type) === 0) return {
                                            ...zoneEntry,
                                            zone_type: 0,
                                            metric_id: ignoreAllTemplate?.metric_id ?? zoneEntry.metric_id,
                                            label: "ignore_all_inferred",
                                            label_display_name: ignoreAllTemplate?.label_display_name || "Ignore All",
                                            line_color: ignoreAllTemplate?.line_color || zoneEntry.line_color || "#ffff00",
                                            coordinates: sharedPolygons
                                        };
                                        const filteredCoordinates = zoneEntry.coordinates.filter((polygon)=>!sharedPolygonSignatureSet.has($3c3d6b96e6551cfe$var$polygonSignature(polygon)));
                                        return {
                                            ...zoneEntry,
                                            coordinates: filteredCoordinates
                                        };
                                    }).filter((zoneEntry)=>zoneEntry.coordinates.length > 0);
                                }
                                if (uniqueCoordinateSignatures.size === 1 && nestedMappedZones.length > 0) {
                                    const ignoreAllTemplate = $3c3d6b96e6551cfe$var$pickIgnoreAllTemplate(defaultZones);
                                    const hasIgnoreAll = nestedMappedZones.some((zoneEntry)=>Number(zoneEntry.zone_type) === 0);
                                    const inferredCoordinates = $3c3d6b96e6551cfe$var$coerceCoordinatesToPolygonList(nestedLabels[0]?.coordinates ?? zone.coordinates);
                                    if (!hasIgnoreAll) nestedMappedZones.unshift({
                                        zone_type: 0,
                                        stream_id: zone.stream_id ?? ignoreAllTemplate?.stream_id ?? 0,
                                        stream_name: zone.stream_name ?? ignoreAllTemplate?.stream_name ?? "",
                                        metric_id: ignoreAllTemplate?.metric_id ?? 0,
                                        label: "ignore_all_inferred",
                                        label_display_name: ignoreAllTemplate?.label_display_name || "Ignore All",
                                        line_color: ignoreAllTemplate?.line_color || "#FF8400",
                                        coordinates: inferredCoordinates,
                                        ...zone.id != null && Number.isFinite(Number(zone.id)) ? {
                                            preset_zone_id: Number(zone.id)
                                        } : {}
                                    });
                                    const ignoreAllZone = nestedMappedZones.find((zoneEntry)=>Number(zoneEntry.zone_type) === 0) || nestedMappedZones[0];
                                    nestedMappedZones = [
                                        {
                                            ...ignoreAllZone,
                                            zone_type: 0,
                                            label: "ignore_all_inferred",
                                            label_display_name: ignoreAllTemplate?.label_display_name || "Ignore All",
                                            line_color: ignoreAllZone.line_color || ignoreAllTemplate?.line_color || "#FF8400",
                                            coordinates: inferredCoordinates
                                        }
                                    ];
                                }
                                return nestedMappedZones;
                            }
                            const rawId = zone.id;
                            const presetZoneId = rawId != null && Number.isFinite(Number(rawId)) ? Number(rawId) : undefined;
                            const baseName = zone.name || "preset_zone";
                            return {
                                zone_type: zone.zone_type || 0,
                                stream_id: zone.stream_id || 0,
                                stream_name: zone.stream_name || "",
                                metric_id: Array.isArray(zone.labels) ? zone.labels[0] || 0 : 0,
                                label: `${baseName}-${zoneIndex}`,
                                label_display_name: $3c3d6b96e6551cfe$var$presetZoneLabelDisplayName(zone),
                                line_color: zone.line_color || "#FF8400",
                                coordinates: $3c3d6b96e6551cfe$var$coerceCoordinatesToPolygonList(zone.coordinates),
                                ...presetZoneId !== undefined ? {
                                    preset_zone_id: presetZoneId
                                } : {}
                            };
                        }).flat();
                    } catch (_error) {
                        mappedPresetZones = [];
                    }
                    const presetName = preset.name || "Unnamed Preset";
                    const filteredPresetZones = (0, $6JE7U.filterBundleTitleZones)(presetName, mappedPresetZones);
                    return {
                        localId: `server-${preset.id}`,
                        cameraId: cameraId,
                        name: presetName,
                        zones: filteredPresetZones,
                        persistedId: preset.id,
                        source: "custom",
                        userNamed: true
                    };
                }));
                const defaultPresetName = $3c3d6b96e6551cfe$var$buildDefaultPresetName(cameraFromSiteState?.camera_name || statusResponse.data?.camera_name);
                const priorDefaultSlot = (get().presetsByCamera[cameraId] || []).find((p)=>p.localId === `default-${cameraId}`);
                const priorDefaultPersistedIdNum = priorDefaultSlot?.persistedId != null && Number.isFinite(Number(priorDefaultSlot.persistedId)) ? Number(priorDefaultSlot.persistedId) : undefined;
                let existingDefaultPreset;
                if (priorDefaultPersistedIdNum != null) existingDefaultPreset = existingPresets.find((preset)=>Number(preset.persistedId) === priorDefaultPersistedIdNum);
                if (existingDefaultPreset == null) existingDefaultPreset = existingPresets.find((preset)=>$3c3d6b96e6551cfe$var$isDefaultPresetName(preset.name, defaultPresetName));
                const existingCustomPresets = existingPresets.filter((preset)=>{
                    if (!existingDefaultPreset) return true;
                    // Keep the canonical API `server-*` row for the default preset. The synthetic
                    // `default-${cameraId}` slot is excluded from API-only dropdowns; without this row,
                    // the real preset (e.g. "Default Preset …" from GET preset/?camera=) disappears.
                    if (preset.localId === existingDefaultPreset.localId) return true;
                    if (existingDefaultPreset.persistedId != null && preset.persistedId != null && Number(preset.persistedId) === Number(existingDefaultPreset.persistedId)) return false;
                    return true;
                });
                /** Default preset row on server uses `preset-zone/`; camera `ignore_zones/` can lag after PATCH — prefer API preset zones when present. */ const defaultPresetZones = existingDefaultPreset != null ? $3c3d6b96e6551cfe$var$cloneIgnoreZones(existingDefaultPreset.zones || []) : $3c3d6b96e6551cfe$var$cloneIgnoreZones(defaultZones);
                const resolvedPresetName = existingDefaultPreset?.name ?? priorDefaultSlot?.name ?? defaultPresetName;
                const resolvedPersistedId = existingDefaultPreset != null ? existingDefaultPreset.persistedId : null;
                const defaultPreset = {
                    localId: `default-${cameraId}`,
                    cameraId: cameraId,
                    name: resolvedPresetName,
                    zones: defaultPresetZones,
                    persistedId: resolvedPersistedId,
                    source: "default",
                    userNamed: Boolean(priorDefaultSlot?.userNamed) || existingDefaultPreset != null && !$3c3d6b96e6551cfe$var$isDefaultPresetName(existingDefaultPreset.name, defaultPresetName)
                };
                const adjustedDimensions = $3c3d6b96e6551cfe$var$formatAdjustedDimensions(statusResponse.data?.frame_dimensions || "16 x 9");
                const presetsByCamera = get().presetsByCamera[cameraId] || [];
                const mergedPresets = [
                    ...presetsByCamera
                ];
                const priorNoIgnoreSlot = mergedPresets.find((p)=>p.localId === (0, $9s9JO.FLEX_IZ_NO_IGNORE_ZONES_OPTION));
                const priorNoIgnorePersistedId = priorNoIgnoreSlot?.persistedId != null && Number.isFinite(Number(priorNoIgnoreSlot.persistedId)) ? Number(priorNoIgnoreSlot.persistedId) : null;
                const noIgnoreZonesPreset = {
                    localId: (0, $9s9JO.FLEX_IZ_NO_IGNORE_ZONES_OPTION),
                    cameraId: cameraId,
                    name: "No Ignore Zones",
                    zones: [],
                    persistedId: priorNoIgnorePersistedId,
                    source: "custom",
                    userNamed: true
                };
                [
                    defaultPreset,
                    ...existingCustomPresets,
                    noIgnoreZonesPreset
                ].forEach((preset)=>{
                    const idx = mergedPresets.findIndex((item)=>item.localId === preset.localId);
                    if (idx === -1) mergedPresets.push(preset);
                    else mergedPresets[idx] = preset;
                });
                const finalPresets = (0, $6JE7U.dedupeFlexPresetsByDisplayName)(cameraId, mergedPresets);
                set((state)=>{
                    const nextSelected = {
                        ...state.selectedPresetByScheduleCamera
                    };
                    let selectedChanged = false;
                    for (const key of Object.keys(nextSelected)){
                        if (!key.endsWith(`:${cameraId}`)) continue;
                        const cur = nextSelected[key];
                        const normalized = (0, $6JE7U.normalizeFlexPresetSelectionToApiBackedMenuValue)(cameraId, finalPresets, cur);
                        if (normalized !== cur) {
                            nextSelected[key] = normalized;
                            selectedChanged = true;
                        }
                    }
                    return {
                        cameraContexts: {
                            ...state.cameraContexts,
                            [cameraId]: {
                                loaded: true,
                                loading: false,
                                error: null,
                                preview: {
                                    previewUrl: statusResponse.data?.preview_url || fallbackPreviewUrl || "",
                                    adjustedDimensions: adjustedDimensions
                                },
                                defaultZones: $3c3d6b96e6551cfe$var$cloneIgnoreZones(defaultZones.length ? defaultZones : fallbackDefaultZones)
                            }
                        },
                        presetsByCamera: {
                            ...state.presetsByCamera,
                            [cameraId]: finalPresets
                        },
                        presetNamesByCamera: {
                            ...state.presetNamesByCamera,
                            [cameraId]: $3c3d6b96e6551cfe$var$presetNamesFromList(existingPresetsRaw)
                        },
                        ...selectedChanged ? {
                            selectedPresetByScheduleCamera: nextSelected
                        } : {}
                    };
                });
            } catch (error) {
                set((state)=>({
                        cameraContexts: {
                            ...state.cameraContexts,
                            [cameraId]: {
                                loaded: false,
                                loading: false,
                                error: error?.message || "Unable to load camera preview and ignore zones for onboarding.",
                                preview: null,
                                defaultZones: []
                            }
                        }
                    }));
            }
        },
        persistFlexPresetDraftToApi: async (cameraId, presetLocalId)=>{
            const preset = (get().presetsByCamera[cameraId] || []).find((p)=>p.localId === presetLocalId);
            if (!preset) return {
                ok: false,
                error: "Preset not found."
            };
            if (preset.persistedId != null) return {
                ok: false,
                error: "This preset is already saved."
            };
            const trimmedName = preset.name?.trim() || "";
            if (!trimmedName) return {
                ok: false,
                error: "Preset name is required."
            };
            const flexSiteId = get().siteId;
            const siteStore = (0, $3FJ79.useSiteAboutStore).getState();
            const customerId = flexSiteId != null && Number.isFinite(Number(flexSiteId)) ? Number(flexSiteId) : siteStore.siteMetricsSimplifiedCustomerId;
            if (customerId == null || !Number.isFinite(Number(customerId))) return {
                ok: false,
                error: "Site metrics are not loaded. Open this site on Site About and try again."
            };
            const customerIdNum = Number(customerId);
            const AxiosUI = (0, $195EM.createApi)("");
            try {
                let metricRows = siteStore.siteMetricsSimplifiedCustomerId === customerIdNum ? siteStore.siteMetricsSimplified : [];
                if (metricRows.length === 0) {
                    const metricSimplifiedResponse = await AxiosUI.get("metric/simplified/", {
                        params: {
                            customer: customerIdNum
                        }
                    });
                    if (Array.isArray(metricSimplifiedResponse.data?.results)) metricRows = metricSimplifiedResponse.data.results;
                    else if (Array.isArray(metricSimplifiedResponse.data)) metricRows = metricSimplifiedResponse.data;
                    else metricRows = [];
                    siteStore.setSiteMetricsSimplifiedData(metricRows, customerIdNum);
                }
                const presetBody = {
                    camera: cameraId,
                    name: trimmedName
                };
                const createdPresetResponse = await AxiosUI.post("preset/", presetBody);
                const createdPresetId = Number(createdPresetResponse.data?.id);
                if (!Number.isFinite(createdPresetId)) return {
                    ok: false,
                    error: "Server did not return a preset id. Try again."
                };
                const presetZoneApiName = `${trimmedName} #${createdPresetId}`;
                const presetZonePayload = (0, $7ulPk.buildPresetZonePayload)({
                    cameraId: cameraId,
                    presetId: createdPresetId,
                    presetName: presetZoneApiName,
                    zones: preset.zones || [],
                    metricRows: metricRows
                });
                await AxiosUI.post("preset-zone/", presetZonePayload);
                const newLocalId = `server-${createdPresetId}`;
                set((state)=>{
                    const presets = state.presetsByCamera[cameraId] || [];
                    const nextPresets = presets.map((p)=>p.localId === presetLocalId ? {
                            ...p,
                            localId: newLocalId,
                            name: trimmedName,
                            persistedId: createdPresetId,
                            userNamed: true
                        } : p);
                    return {
                        presetsByCamera: {
                            ...state.presetsByCamera,
                            [cameraId]: (0, $6JE7U.dedupeFlexPresetsByDisplayName)(cameraId, nextPresets)
                        }
                    };
                });
                return {
                    ok: true,
                    newLocalId: newLocalId
                };
            } catch (error) {
                return {
                    ok: false,
                    error: error?.message || "Unable to save flex ignore zones preset to the server."
                };
            }
        },
        createCustomPresetDraft: (cameraId, defaultZones)=>{
            const presets = get().presetsByCamera[cameraId] || [];
            const presetName = $3c3d6b96e6551cfe$var$nextPresetName(presets);
            const localId = `custom-${cameraId}-${Date.now()}-${Math.random()}`;
            const nextPreset = {
                localId: localId,
                cameraId: cameraId,
                name: presetName,
                zones: $3c3d6b96e6551cfe$var$cloneIgnoreZones(defaultZones),
                persistedId: null,
                source: "custom",
                userNamed: false
            };
            set((state)=>({
                    presetsByCamera: {
                        ...state.presetsByCamera,
                        [cameraId]: [
                            ...presets,
                            nextPreset
                        ]
                    }
                }));
            return localId;
        },
        removeLocalPresetDraft: (cameraId, presetLocalId)=>set((state)=>{
                const presets = state.presetsByCamera[cameraId] || [];
                const target = presets.find((p)=>p.localId === presetLocalId);
                if (!target || target.persistedId != null || target.source !== "custom") return {};
                return {
                    presetsByCamera: {
                        ...state.presetsByCamera,
                        [cameraId]: presets.filter((p)=>p.localId !== presetLocalId)
                    }
                };
            }),
        updatePresetName: (cameraId, presetLocalId, name, markAsUserNamed = true)=>set((state)=>{
                const presets = state.presetsByCamera[cameraId] || [];
                return {
                    presetsByCamera: {
                        ...state.presetsByCamera,
                        [cameraId]: presets.map((preset)=>preset.localId === presetLocalId ? {
                                ...preset,
                                name: name,
                                userNamed: markAsUserNamed ? true : preset.userNamed
                            } : preset)
                    }
                };
            }),
        updatePresetZones: (cameraId, presetLocalId, zones)=>set((state)=>{
                const presets = state.presetsByCamera[cameraId] || [];
                return {
                    presetsByCamera: {
                        ...state.presetsByCamera,
                        [cameraId]: presets.map((preset)=>preset.localId === presetLocalId ? {
                                ...preset,
                                zones: $3c3d6b96e6551cfe$var$cloneIgnoreZones(zones)
                            } : preset)
                    }
                };
            }),
        setPendingEditorContext: (pendingEditorContext)=>set({
                pendingEditorContext: pendingEditorContext
            }),
        finalizePresetDecisionForCamera: (cameraId, presetLocalId, firstTimeDefaultOnly)=>set((state)=>{
                if (state.cameraFirstResolvedPresetByCamera[cameraId]) return {};
                const selectedPreset = (state.presetsByCamera[cameraId] || []).find((preset)=>preset.localId === presetLocalId);
                const shouldHideDefault = firstTimeDefaultOnly && selectedPreset?.source === "custom";
                return {
                    cameraFirstResolvedPresetByCamera: {
                        ...state.cameraFirstResolvedPresetByCamera,
                        [cameraId]: presetLocalId
                    },
                    hideDefaultPresetForCamera: shouldHideDefault ? {
                        ...state.hideDefaultPresetForCamera,
                        [cameraId]: true
                    } : state.hideDefaultPresetForCamera
                };
            }),
        getCurrentSchedule: ()=>{
            const { schedules: schedules, activeScheduleIndex: activeScheduleIndex } = get();
            return schedules[activeScheduleIndex];
        },
        getSelectedCamerasForSchedule: (scheduleId)=>get().selectedCameraIdsBySchedule[scheduleId] || [],
        getPresetsForCamera: (cameraId)=>get().presetsByCamera[cameraId] || [],
        getSelectedPresetForScheduleCamera: (scheduleId, cameraId)=>{
            const selectedPresetLocalId = get().selectedPresetByScheduleCamera[$3c3d6b96e6551cfe$var$scheduleCameraKey(scheduleId, cameraId)];
            if (!selectedPresetLocalId) return undefined;
            return get().getPresetsForCamera(cameraId).find((preset)=>preset.localId === selectedPresetLocalId);
        },
        submitAll: async ()=>{
            const { siteId: siteId, submitLoading: submitLoading, setEnabledForSite: setEnabledForSite, schedules: schedules, selectedPresetByScheduleCamera: selectedPresetByScheduleCamera, presetsByCamera: presetsByCamera } = get();
            if (!siteId || submitLoading) return false;
            set({
                submitLoading: true,
                submitError: null
            });
            const AxiosUI = (0, $195EM.createApi)("");
            try {
                const siteStore = (0, $3FJ79.useSiteAboutStore).getState();
                let metricRows = siteStore.siteMetricsSimplifiedCustomerId === siteId ? siteStore.siteMetricsSimplified : [];
                if (metricRows.length === 0) {
                    const metricSimplifiedResponse = await AxiosUI.get("metric/simplified/", {
                        params: {
                            customer: siteId
                        }
                    });
                    if (Array.isArray(metricSimplifiedResponse.data?.results)) metricRows = metricSimplifiedResponse.data.results;
                    else if (Array.isArray(metricSimplifiedResponse.data)) metricRows = metricSimplifiedResponse.data;
                    else metricRows = [];
                    siteStore.setSiteMetricsSimplifiedData(metricRows, siteId);
                }
                const scheduleOrder = schedules.map((schedule)=>schedule.id);
                const cameraOrder = get().cameras.map((camera)=>camera.id);
                const presetDedupeKey = (cameraId, presetLocalId)=>`${cameraId}:${presetLocalId}`;
                const submitCells = [];
                cameraOrder.forEach((cameraId)=>{
                    scheduleOrder.forEach((scheduleId)=>{
                        const selectedPresetLocalId = selectedPresetByScheduleCamera[$3c3d6b96e6551cfe$var$scheduleCameraKey(scheduleId, cameraId)];
                        if (!selectedPresetLocalId) throw new Error(`Missing preset selection for camera ${cameraId} on schedule ${scheduleId}.`);
                        if (selectedPresetLocalId === (0, $9s9JO.FLEX_IZ_DEFAULT_CAMERA_CONFIG_OPTION)) {
                            // Default: no preset to create; the assignment row is written
                            // with `preset: null` in phase 3.
                            submitCells.push({
                                scheduleId: scheduleId,
                                cameraId: cameraId,
                                presetLocalId: selectedPresetLocalId,
                                presetName: "Default",
                                zones: []
                            });
                            return;
                        }
                        const selectedPreset = (presetsByCamera[cameraId] || []).find((preset)=>preset.localId === selectedPresetLocalId);
                        if (!selectedPreset) throw new Error(`Preset "${selectedPresetLocalId}" was not found for camera ${cameraId}.`);
                        submitCells.push({
                            scheduleId: scheduleId,
                            cameraId: cameraId,
                            presetLocalId: selectedPresetLocalId,
                            presetName: selectedPreset.name?.trim() || "Flex Ignore Zones Preset",
                            zones: selectedPreset.zones || []
                        });
                    });
                });
                const uniquePresetKeys = [];
                const uniquePresetByKey = new Map();
                submitCells.forEach((cell)=>{
                    if (cell.presetLocalId === (0, $9s9JO.FLEX_IZ_DEFAULT_CAMERA_CONFIG_OPTION)) return;
                    const dk = presetDedupeKey(cell.cameraId, cell.presetLocalId);
                    if (!uniquePresetByKey.has(dk)) {
                        uniquePresetByKey.set(dk, {
                            cameraId: cell.cameraId,
                            presetLocalId: cell.presetLocalId,
                            presetName: cell.presetName,
                            zones: cell.zones
                        });
                        uniquePresetKeys.push(dk);
                    }
                });
                const createdPresetIdByDedupeKey = new Map();
                // Phase 1: create each distinct (camera, preset) once.
                for (const dk of uniquePresetKeys){
                    const meta = uniquePresetByKey.get(dk);
                    if (!meta) continue;
                    const presetBody = {
                        camera: meta.cameraId,
                        name: meta.presetName
                    };
                    const createdPresetResponse = await AxiosUI.post("preset/", presetBody);
                    const createdPresetId = Number(createdPresetResponse.data?.id);
                    if (!Number.isFinite(createdPresetId)) throw new Error(`Failed to create preset for camera ${meta.cameraId}; missing preset id in response.`);
                    createdPresetIdByDedupeKey.set(dk, createdPresetId);
                }
                // Phase 2: assign zones once per distinct (camera, preset).
                for (const dk of uniquePresetKeys){
                    const meta = uniquePresetByKey.get(dk);
                    const createdPresetId = createdPresetIdByDedupeKey.get(dk);
                    if (!meta || !createdPresetId) continue;
                    if (meta.presetLocalId === (0, $9s9JO.FLEX_IZ_NO_IGNORE_ZONES_OPTION) || (meta.zones || []).length === 0) continue;
                    const presetZoneApiName = `${meta.presetName.trim()} #${createdPresetId}`;
                    const presetZonePayload = (0, $7ulPk.buildPresetZonePayload)({
                        cameraId: meta.cameraId,
                        presetId: createdPresetId,
                        presetName: presetZoneApiName,
                        zones: meta.zones,
                        metricRows: metricRows
                    });
                    await AxiosUI.post("preset-zone/", presetZonePayload);
                }
                // Phase 3: map each schedule-camera selection to the shared preset id (skip no-ignore only).
                for (const cell of submitCells){
                    if (cell.presetLocalId === (0, $9s9JO.FLEX_IZ_DEFAULT_CAMERA_CONFIG_OPTION)) {
                        await AxiosUI.post("camera-schedule-preset/", {
                            camera: cell.cameraId,
                            preset: null,
                            flex_schedule: cell.scheduleId
                        });
                        continue;
                    }
                    const dk = presetDedupeKey(cell.cameraId, cell.presetLocalId);
                    const createdPresetId = createdPresetIdByDedupeKey.get(dk);
                    if (!createdPresetId) continue;
                    const assignBody = {
                        camera: cell.cameraId,
                        preset: createdPresetId,
                        flex_schedule: cell.scheduleId
                    };
                    await AxiosUI.post("camera-schedule-preset/", assignBody);
                }
                // Presets and assignments are saved, but the connector only reads them
                // on the next settings deploy — surface the Sync control.
                (0, $815yO.markSiteUnsynced)(String(siteId));
                set((state)=>{
                    const nextPresetsByCamera = {
                        ...state.presetsByCamera
                    };
                    createdPresetIdByDedupeKey.forEach((createdPresetId, dedupeKey)=>{
                        const meta = uniquePresetByKey.get(dedupeKey);
                        if (!meta) return;
                        const cameraPresets = nextPresetsByCamera[meta.cameraId] || [];
                        nextPresetsByCamera[meta.cameraId] = cameraPresets.map((preset)=>preset.localId === meta.presetLocalId ? {
                                ...preset,
                                persistedId: createdPresetId
                            } : preset);
                    });
                    return {
                        presetsByCamera: nextPresetsByCamera
                    };
                });
                const refreshResults = await Promise.allSettled(cameraOrder.map((cameraId)=>get().loadCameraContext(cameraId, true)));
                refreshResults.forEach((result, index)=>{
                    if (result.status === "rejected") {
                        const failedCameraId = cameraOrder[index];
                        console.error(`Flex Ignore Zones onboarding: failed to refresh presets for camera ${failedCameraId} after submit.`, result.reason);
                    }
                });
                setEnabledForSite(siteId, true);
                set({
                    submitLoading: false,
                    submitError: null,
                    isOpen: false,
                    step: "scheduleSelection",
                    pendingEditorContext: null
                });
                return true;
            } catch (error) {
                const conflictMessages = (0, $5P5Ui.presetConflictMessagesFromError)(error);
                set({
                    submitLoading: false,
                    submitError: conflictMessages ? conflictMessages.join("\n") : error?.message || "Unable to save Flex Ignore Zones presets and schedule assignments."
                });
                return false;
            }
        },
        persistFlexSchedulePresetAssignments: async (siteId, flexSchedules)=>{
            const enabledForSite = get().enabledBySite[siteId] === true;
            if (!enabledForSite) return {
                ok: true
            };
            const camerasFromStore = get().cameras;
            const cameras = camerasFromStore.length > 0 ? camerasFromStore : (()=>{
                try {
                    const raw = JSON.parse(localStorage.getItem("siteCameras") || '{"results":[]}');
                    const results = Array.isArray(raw.results) ? raw.results : [];
                    return results.map((camera)=>({
                            id: Number(camera.id),
                            camera_name: camera.camera_name,
                            preview_url: camera.preview_url,
                            ignore_zones: camera.ignore_zones
                        }));
                } catch  {
                    return [];
                }
            })();
            if (cameras.length === 0) return {
                ok: true
            };
            const { selectedPresetByScheduleCamera: selectedPresetByScheduleCamera, presetsByCamera: presetsByCamera } = get();
            const AxiosUI = (0, $195EM.createApi)("");
            let wroteAssignment = false;
            for (const schedule of flexSchedules){
                const scheduleId = Number(schedule?.id);
                if (!Number.isFinite(scheduleId)) continue;
                for (const camera of cameras){
                    const key = $3c3d6b96e6551cfe$var$scheduleCameraKey(scheduleId, camera.id);
                    const presetLocalId = selectedPresetByScheduleCamera[key];
                    if (!presetLocalId) continue;
                    if (presetLocalId === (0, $9s9JO.FLEX_IZ_DEFAULT_CAMERA_CONFIG_OPTION)) {
                        // "Default": the row records that no preset applies, so the settings
                        // generator falls back to the camera's own zones and default lines.
                        try {
                            await AxiosUI.post("camera-schedule-preset/", {
                                camera: camera.id,
                                preset: null,
                                flex_schedule: scheduleId
                            });
                            wroteAssignment = true;
                        } catch (error) {
                            if (wroteAssignment) (0, $815yO.markSiteUnsynced)(String(siteId));
                            return {
                                ok: false,
                                error: (0, $5P5Ui.presetConflictMessagesFromError)(error)?.join("\n") || error?.message || "Unable to update flex ignore zone preset assignments for this site."
                            };
                        }
                        continue;
                    }
                    const preset = (presetsByCamera[camera.id] || []).find((p)=>p.localId === presetLocalId);
                    if (!preset) return {
                        ok: false,
                        error: `Could not find flex ignore zone preset for camera ${camera.camera_name || camera.id}. Refresh the page and try again.`
                    };
                    if (preset.persistedId == null) return {
                        ok: false,
                        error: `Save preset "${preset.name}" for camera ${camera.camera_name || camera.id} before saving schedule changes.`
                    };
                    try {
                        await AxiosUI.post("camera-schedule-preset/", {
                            camera: camera.id,
                            preset: preset.persistedId,
                            flex_schedule: scheduleId
                        });
                        wroteAssignment = true;
                    } catch (error) {
                        if (wroteAssignment) (0, $815yO.markSiteUnsynced)(String(siteId));
                        return {
                            ok: false,
                            error: (0, $5P5Ui.presetConflictMessagesFromError)(error)?.join("\n") || error?.message || "Unable to update flex ignore zone preset assignments for this site."
                        };
                    }
                }
            }
            if (wroteAssignment) // Assignments (Default included) only reach the connector on the next
            // settings deploy — turn the Sync control red.
            (0, $815yO.markSiteUnsynced)(String(siteId));
            return {
                ok: true
            };
        },
        getPresetConflictsForSite: (siteId, flexSchedules)=>{
            const state = get();
            if (state.enabledBySite[siteId] !== true || state.siteId !== siteId) return [];
            return (0, $5P5Ui.findPresetConflicts)({
                schedules: flexSchedules,
                cameras: state.cameras,
                selectedPresetByScheduleCamera: state.selectedPresetByScheduleCamera,
                presetsByCamera: state.presetsByCamera,
                presetNamesByCamera: state.presetNamesByCamera,
                identity: "persisted"
            });
        },
        resetAll: ()=>set((state)=>({
                    ...$3c3d6b96e6551cfe$var$initialState,
                    enabledBySite: state.enabledBySite,
                    flexIgnoreZonesEnabledSyncLoadingBySite: state.flexIgnoreZonesEnabledSyncLoadingBySite,
                    flexIgnoreZonesEnabledSyncErrorBySite: state.flexIgnoreZonesEnabledSyncErrorBySite
                }))
    }));

});
parcelRegister("9OjAn", function(module, exports) {
'use strict';

var $6Ryml = parcelRequire("6Ryml");

var $8T3gX = parcelRequire("8T3gX");

var $l6Hyk = parcelRequire("l6Hyk");
var $7247f9e526b1f0d9$var$useDebugValue = $8T3gX.useDebugValue;
var $7247f9e526b1f0d9$var$useSyncExternalStoreWithSelector = $l6Hyk.useSyncExternalStoreWithSelector;
var $7247f9e526b1f0d9$var$didWarnAboutEqualityFn = false;
var $7247f9e526b1f0d9$var$identity = function identity(arg) {
    return arg;
};
function $7247f9e526b1f0d9$var$useStore(api, selector, equalityFn) {
    if (selector === void 0) selector = $7247f9e526b1f0d9$var$identity;
    if (equalityFn && !$7247f9e526b1f0d9$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $7247f9e526b1f0d9$var$didWarnAboutEqualityFn = true;
    }
    var slice = $7247f9e526b1f0d9$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $7247f9e526b1f0d9$var$useDebugValue(slice);
    return slice;
}
var $7247f9e526b1f0d9$var$createImpl = function createImpl(createState) {
    if (typeof createState !== 'function') console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    var api = typeof createState === 'function' ? $6Ryml.createStore(createState) : createState;
    var useBoundStore = function useBoundStore(selector, equalityFn) {
        return $7247f9e526b1f0d9$var$useStore(api, selector, equalityFn);
    };
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
var $7247f9e526b1f0d9$var$create = function create(createState) {
    return createState ? $7247f9e526b1f0d9$var$createImpl(createState) : $7247f9e526b1f0d9$var$createImpl;
};
var $7247f9e526b1f0d9$var$react = function(createState) {
    console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $7247f9e526b1f0d9$var$create(createState);
};
module.exports.create = $7247f9e526b1f0d9$var$create;
module.exports.default = $7247f9e526b1f0d9$var$react;
module.exports.useStore = $7247f9e526b1f0d9$var$useStore;
Object.keys($6Ryml).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call(module.exports, k)) Object.defineProperty(module.exports, k, {
        enumerable: true,
        get: function() {
            return $6Ryml[k];
        }
    });
});
module.exports = $7247f9e526b1f0d9$var$react;
module.exports.create = $7247f9e526b1f0d9$var$create;
module.exports.useStore = $7247f9e526b1f0d9$var$useStore;
module.exports.createStore = $6Ryml.createStore;
module.exports.default = module.exports;

});
parcelRegister("6Ryml", function(module, exports) {
'use strict';
var $4ff2585aebd7e5bc$var$createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === 'function' ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== 'object' || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var getInitialState = function getInitialState() {
        return initialState;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        console.warn('[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.');
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    var initialState = state = createState(setState, getState, api);
    return api;
};
var $4ff2585aebd7e5bc$var$createStore = function createStore(createState) {
    return createState ? $4ff2585aebd7e5bc$var$createStoreImpl(createState) : $4ff2585aebd7e5bc$var$createStoreImpl;
};
var $4ff2585aebd7e5bc$var$vanilla = function(createState) {
    console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $4ff2585aebd7e5bc$var$createStore(createState);
};
module.exports.createStore = $4ff2585aebd7e5bc$var$createStore;
module.exports.default = $4ff2585aebd7e5bc$var$vanilla;
module.exports = $4ff2585aebd7e5bc$var$vanilla;
module.exports.createStore = $4ff2585aebd7e5bc$var$createStore;
module.exports.default = module.exports;

});

parcelRegister("l6Hyk", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8PZ7C"));

});


parcelRegister("195EM", function(module, exports) {

$parcel$export(module.exports, "createApi", () => $7e4e5324da33cc50$export$9cdc2b9a8d94c842);

var $7pFvC = parcelRequire("7pFvC");

var $5BK6w = parcelRequire("5BK6w");

var $2LUuS = parcelRequire("2LUuS");
const $7e4e5324da33cc50$export$9cdc2b9a8d94c842 = (path)=>{
    const baseURL = (0, $2LUuS.getApiUrl)();
    const token = (0, $5BK6w.getCookie)("token");
    const instance = (0, (/*@__PURE__*/$parcel$interopDefault($7pFvC))).create({
        baseURL: `${baseURL}api/${path}`,
        headers: {
            "Content-Type": "application/json",
            // Only when there is a token. The literal "Bearer undefined" that an
            // expired cookie used to produce is rejected at the load balancer with
            // an HTML 403 carrying no CORS headers, so every call surfaced as
            // "Network Error" and no handler could tell it was an auth problem.
            // Without the header the API answers a JSON 403 the app can act on.
            ...token ? {
                Authorization: `Bearer ${token}`
            } : {}
        }
    });
    return instance;
};

});
parcelRegister("7pFvC", function(module, exports) {

module.exports = (parcelRequire("ky7bB"));

});

parcelRegister("5BK6w", function(module, exports) {

$parcel$export(module.exports, "getCookie", () => $c2ab035f081c7dcc$export$4be65e66cfa2648a);
const $c2ab035f081c7dcc$export$4be65e66cfa2648a = (cName)=>{
    const name = cName + "=";
    const cDecoded = decodeURIComponent(document.cookie);
    const cArr = cDecoded.split("; ");
    let res;
    cArr.forEach((val)=>{
        if (val.indexOf(name) === 0) res = val.substring(name.length);
    });
    return res;
};

});

parcelRegister("2LUuS", function(module, exports) {

$parcel$export(module.exports, "getApiUrl", () => $53ad8296de4bd731$export$1b98eaf73d37f034);

var $8sbJd = parcelRequire("8sbJd");
const $53ad8296de4bd731$export$1b98eaf73d37f034 = ()=>{
    return (0, $8sbJd.isProductionModeOn)() ? (0, $8sbJd.PROD_API_URL) : "https://staging.actuateui.net/";
};

});
parcelRegister("8sbJd", function(module, exports) {

$parcel$export(module.exports, "PROD_API_URL", () => $a22a1c2be81ae635$export$1fa3a3f35864c16f);
$parcel$export(module.exports, "isNonProdBuild", () => $a22a1c2be81ae635$export$9cdbcadf731235d5);
$parcel$export(module.exports, "isProductionModeOn", () => $a22a1c2be81ae635$export$ddb8d67a0a584104);
$parcel$export(module.exports, "liveMediaNeedsProductionMode", () => $a22a1c2be81ae635$export$d01b09b951d27296);
$parcel$export(module.exports, "setProductionMode", () => $a22a1c2be81ae635$export$d744501286183009);
/**
 * "Use production" on non-prod builds (ENG-2040, ENG-2297).
 *
 * redesign and dev are built against staging, whose database is a frozen copy
 * (ENG-1665). Staff can switch a non-prod build to the production API to test
 * the unreleased UI on live data. Since ENG-2297 (Jacob, 2026-10-08) that is
 * real production: every request goes to prod and admin / monitoring-api
 * permissions are the only gate, exactly as on the prod build. There is no
 * browser-side read-only guard any more; the earlier allowlist (ENG-2040) is
 * gone because QA needs to sync, arm and save on test sites from dev.
 *
 * Switching signs out and back in, because each environment's admin issues
 * its own session. Cognito is shared, so the round trip does not ask for a
 * password while the Cognito session is live. This module must not import
 * getApiUrl (getApiUrl imports it).
 */ const $a22a1c2be81ae635$export$1fa3a3f35864c16f = "https://admin.actuateui.net/";
const $a22a1c2be81ae635$export$97cb6c3578377a23 = "apiEnvironmentOverride";
// Both production APIs: US (.net) and EU (.eu). Missing the EU host made the
// EU prod build show the "Use production" pill, point it at the US API, and
// block live media as if it were a staging build.
const $a22a1c2be81ae635$var$PROD_HOST = /(^|\/\/)admin\.actuateui\.(net|eu)(\/|$)/;
const $a22a1c2be81ae635$export$9cdbcadf731235d5 = ()=>!$a22a1c2be81ae635$var$PROD_HOST.test("https://staging.actuateui.net/" ?? "");
const $a22a1c2be81ae635$export$ddb8d67a0a584104 = ()=>{
    if (!$a22a1c2be81ae635$export$9cdbcadf731235d5()) return false;
    try {
        return localStorage.getItem($a22a1c2be81ae635$export$97cb6c3578377a23) === "prod";
    } catch  {
        return false;
    }
};
const $a22a1c2be81ae635$export$d01b09b951d27296 = ()=>Boolean("https://staging.actuateui.net/") && $a22a1c2be81ae635$export$9cdbcadf731235d5() && !$a22a1c2be81ae635$export$ddb8d67a0a584104();
const $a22a1c2be81ae635$export$d744501286183009 = (on)=>{
    try {
        if (on) localStorage.setItem($a22a1c2be81ae635$export$97cb6c3578377a23, "prod");
        else localStorage.removeItem($a22a1c2be81ae635$export$97cb6c3578377a23);
    } catch  {
    // Storage blocked: the switch simply does not stick.
    }
};

});



parcelRegister("815yO", function(module, exports) {

$parcel$export(module.exports, "getSiteIdFromUrl", () => $2b693f84b91bc95c$export$81b305feb3522039);
$parcel$export(module.exports, "useSyncStore", () => $2b693f84b91bc95c$export$e78a16ab542078e0);
$parcel$export(module.exports, "markSiteUnsynced", () => $2b693f84b91bc95c$export$32940b0e672cb731);
$parcel$export(module.exports, "markSiteSynced", () => $2b693f84b91bc95c$export$f3d19791363815c3);
$parcel$export(module.exports, "useCurrentSiteSyncNeeded", () => $2b693f84b91bc95c$export$fce7db463d164f84);
$parcel$export(module.exports, "dismissSyncBannerForCurrentSite", () => $2b693f84b91bc95c$export$186c47275d2cb34a);
$parcel$export(module.exports, "useCurrentSiteBannerDismissed", () => $2b693f84b91bc95c$export$fda7698df5c05d6b);

var $9OjAn = parcelRequire("9OjAn");
/**
 * Shared "does this site have unsynced changes?" state, scoped per site.
 *
 * Every save flow that changes connector settings (edit camera, products,
 * ignore zones, line crossings, bulk updates, add camera, …) marks the site
 * unsynced here, and every sync flow marks it synced. All sync indicators
 * (the About-page SyncSiteButton, the edit-view EditViewSyncButton, and the
 * SyncNeededBanner) subscribe to this store, so they can never disagree —
 * and because the state is keyed by site id, editing one site never shows a
 * false "sync needed" on another.
 *
 * localStorage ("unsyncedSiteIds" = JSON array) is kept as a mirror only —
 * it preserves the flags across full page reloads. In-memory store state is
 * the source of truth; components must subscribe to the store.
 */ const $2b693f84b91bc95c$var$STORAGE_KEY = "unsyncedSiteIds";
const $2b693f84b91bc95c$export$81b305feb3522039 = ()=>{
    const match = location.href.match(/\/sites\/(?:aboutsite\/)?(\d+)/);
    return match ? match[1] : "";
};
const $2b693f84b91bc95c$var$readMirror = ()=>{
    try {
        const stored = JSON.parse(localStorage.getItem($2b693f84b91bc95c$var$STORAGE_KEY) || "[]");
        return Array.isArray(stored) ? stored.map(String) : [];
    } catch  {
        return [];
    }
};
const $2b693f84b91bc95c$var$without = (ids, siteId)=>ids.filter((id)=>id !== siteId);
const $2b693f84b91bc95c$export$e78a16ab542078e0 = (0, $9OjAn.create)((set, get)=>({
        unsyncedSiteIds: $2b693f84b91bc95c$var$readMirror(),
        bannerDismissedSiteIds: [],
        markUnsynced: (siteId)=>{
            if (!siteId) return;
            // A fresh save always re-surfaces a dismissed banner, even when the site
            // was already unsynced — same cadence as the About-page alert.
            const bannerDismissedSiteIds = $2b693f84b91bc95c$var$without(get().bannerDismissedSiteIds, siteId);
            const ids = get().unsyncedSiteIds;
            if (ids.includes(siteId)) {
                set({
                    bannerDismissedSiteIds: bannerDismissedSiteIds
                });
                return;
            }
            const next = [
                ...ids,
                siteId
            ];
            localStorage.setItem($2b693f84b91bc95c$var$STORAGE_KEY, JSON.stringify(next));
            set({
                unsyncedSiteIds: next,
                bannerDismissedSiteIds: bannerDismissedSiteIds
            });
        },
        markSynced: (siteId)=>{
            const next = $2b693f84b91bc95c$var$without(get().unsyncedSiteIds, siteId);
            localStorage.setItem($2b693f84b91bc95c$var$STORAGE_KEY, JSON.stringify(next));
            set({
                unsyncedSiteIds: next,
                bannerDismissedSiteIds: $2b693f84b91bc95c$var$without(get().bannerDismissedSiteIds, siteId)
            });
        },
        clearAllUnsynced: ()=>{
            localStorage.setItem($2b693f84b91bc95c$var$STORAGE_KEY, "[]");
            set({
                unsyncedSiteIds: [],
                bannerDismissedSiteIds: []
            });
        },
        dismissBanner: (siteId)=>{
            if (!siteId) return;
            const ids = get().bannerDismissedSiteIds;
            if (ids.includes(siteId)) return;
            set({
                bannerDismissedSiteIds: [
                    ...ids,
                    siteId
                ]
            });
        }
    }));
const $2b693f84b91bc95c$export$32940b0e672cb731 = (siteId = $2b693f84b91bc95c$export$81b305feb3522039())=>$2b693f84b91bc95c$export$e78a16ab542078e0.getState().markUnsynced(siteId);
const $2b693f84b91bc95c$export$f3d19791363815c3 = (siteId = $2b693f84b91bc95c$export$81b305feb3522039())=>$2b693f84b91bc95c$export$e78a16ab542078e0.getState().markSynced(siteId);
const $2b693f84b91bc95c$export$fce7db463d164f84 = ()=>$2b693f84b91bc95c$export$e78a16ab542078e0((s)=>s.unsyncedSiteIds.includes($2b693f84b91bc95c$export$81b305feb3522039()));
const $2b693f84b91bc95c$export$186c47275d2cb34a = (siteId = $2b693f84b91bc95c$export$81b305feb3522039())=>$2b693f84b91bc95c$export$e78a16ab542078e0.getState().dismissBanner(siteId);
const $2b693f84b91bc95c$export$fda7698df5c05d6b = ()=>$2b693f84b91bc95c$export$e78a16ab542078e0((s)=>s.bannerDismissedSiteIds.includes($2b693f84b91bc95c$export$81b305feb3522039()));

});

parcelRegister("83bsI", function(module, exports) {

$parcel$export(module.exports, "addIgnoreLabel", () => $1b9fe2449a629f10$export$9612bcc716ca4c0e);
const $1b9fe2449a629f10$export$9612bcc716ca4c0e = (inputArray)=>{
    return inputArray.map((item)=>({
            ...item,
            label_display_name: item.label_display_name.startsWith("Ignore") ? item.label_display_name === "Ignore Motion" ? "Ignore All" : item.label_display_name : `Ignore ${item.label_display_name}`
        }));
};

});

parcelRegister("3FJ79", function(module, exports) {

$parcel$export(module.exports, "useSiteAboutStore", () => $05b20e7d3e25d0ab$export$521bb43ab7d44e57);

var $k4ank = parcelRequire("k4ank");

var $9OjAn = parcelRequire("9OjAn");

var $195EM = parcelRequire("195EM");

var $dIPZj = parcelRequire("dIPZj");

var $h5bv8 = parcelRequire("h5bv8");

var $aYdit = parcelRequire("aYdit");

var $3Zv1D = parcelRequire("3Zv1D");

var $k1C5l = parcelRequire("k1C5l");

var $2Mk2P = parcelRequire("2Mk2P");

var $axLUl = parcelRequire("axLUl");

var $bILSL = parcelRequire("bILSL");

var $7Gmex = parcelRequire("7Gmex");

var $3uHoa = parcelRequire("3uHoa");

var $jspVg = parcelRequire("jspVg");

var $2uQ4j = parcelRequire("2uQ4j");

var $bitEk = parcelRequire("bitEk");

var $feyZu = parcelRequire("feyZu");

var $ebTQj = parcelRequire("ebTQj");

var $aqMJ2 = parcelRequire("aqMJ2");

var $a8BPe = parcelRequire("a8BPe");

var $iMum1 = parcelRequire("iMum1");

var $1Xths = parcelRequire("1Xths");

var $2wOL1 = parcelRequire("2wOL1");

var $jUxHc = parcelRequire("jUxHc");

var $gTuv9 = parcelRequire("gTuv9");

var $jK0A2 = parcelRequire("jK0A2");

var $innfN = parcelRequire("innfN");

var $7z9u9 = parcelRequire("7z9u9");

var $7ZVeh = parcelRequire("7ZVeh");
const $05b20e7d3e25d0ab$var$returnHealthCheckName = (key)=>{
    switch(key){
        case "connectivity_check":
            return "Connectivity";
        case "motion_status_check":
            return "Motion Status";
        case "recording_check":
            return "Recording";
        case "scene_change_check":
            return "Scene Change";
        case "stream_quality_check":
            return "Stream Quality";
        case "image_quality_check":
            return "Image Quality";
    }
};
const $05b20e7d3e25d0ab$var$sortHealthCheckMetricsData = (healthCheckMetricsData)=>{
    const returnedData = {};
    const dataArray = Array.isArray(healthCheckMetricsData) ? healthCheckMetricsData : [];
    dataArray.forEach((item)=>{
        returnedData[item.metric_type.value] = {
            id: item.id,
            enabled: item.enabled,
            alert_emails: item.alert_emails
        };
    });
    return returnedData;
};
const $05b20e7d3e25d0ab$var$readyAllSchedules = (schedules)=>{
    const returnSchedules = schedules;
    returnSchedules.forEach((schedule, index)=>{
        if (schedule.start_time !== null) {
            if (schedule.start_time === ":00" || schedule.start_time === " - :00") returnSchedules[index].start_time = null;
        }
        if (schedule.end_time !== null) {
            if (schedule.end_time === ":00" || schedule.end_time === " - :00") returnSchedules[index].end_time = null;
        }
    });
    //remove any schedule object that has a null start_time and end_time and false value for "always_on"
    for(let i = 0; i < returnSchedules.length; i++)if (returnSchedules[i].start_time === null && returnSchedules[i].end_time === null && returnSchedules[i].always_on === false) returnSchedules.splice(i, 1);
    return returnSchedules;
};
/** Camera+preset keys with a preset line fetch in progress (dedupes concurrent row renders). */ const $05b20e7d3e25d0ab$var$presetLineCrossingsInFlight = new Set();
const $05b20e7d3e25d0ab$export$65f078c9509696a0 = (data)=>{
    const rows = Array.isArray(data?.results) ? data.results : Array.isArray(data) ? data : [];
    return rows.map((line, index)=>{
        let frontendDirection;
        if ((0, $iMum1.isLegacyDirectionFormat)(line.direction || "")) frontendDirection = line.direction || "Both";
        else frontendDirection = (0, $iMum1.backendToFrontendDirection)(line.direction || "both", line.coordinates);
        return {
            id: line.id,
            camera: line.camera,
            metric_labels: line.metric_labels || [],
            coordinates: line.coordinates,
            direction: frontendDirection,
            preset: line.preset ?? null,
            color: (0, $1Xths.LINE_COLORS)[index % (0, $1Xths.LINE_COLORS).length]
        };
    });
};
const $05b20e7d3e25d0ab$export$521bb43ab7d44e57 = (0, $9OjAn.create)((set, get)=>({
        siteInfo: {},
        setSiteInfo: (siteInfo)=>set({
                siteInfo: siteInfo
            }),
        getSiteInfo: async (retryFunction, navigate)=>{
            const { setSiteInfo: setSiteInfo } = get();
            // Get the setter from useAppStore
            const AxiosUI = (0, $195EM.createApi)(``);
            // const retryFunction = () => {
            //     get().getSiteInfo(navigate);
            // };
            try {
                const response = await AxiosUI.get(`customer/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}/about/`);
                const siteInfo = response.data;
                setSiteInfo(siteInfo);
            } catch (reason) {
                (0, $dIPZj.concurrentAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setSiteInfo({});
                });
            }
        },
        // General Info Tab state for AutoPatrol
        vmsVariables: [],
        setVmsVariables: (vmsVariables)=>set({
                vmsVariables: vmsVariables
            }),
        generalInfoTabPatchObject: {},
        setGeneralInfoTabPatchObject: (generalInfoTabPatchObject)=>set({
                generalInfoTabPatchObject: generalInfoTabPatchObject
            }),
        generalInfoTabChangesMade: false,
        setGeneralInfoTabChangesMade: (generalInfoTabChangesMade)=>set({
                generalInfoTabChangesMade: generalInfoTabChangesMade
            }),
        backdropLoadingScreenOnEditingSchedule: false,
        setBackdropLoadingScreenOnEditingSchedule: (backdropLoadingScreenOnEditingSchedule)=>set({
                backdropLoadingScreenOnEditingSchedule: backdropLoadingScreenOnEditingSchedule
            }),
        vCHOnlySchedules: false,
        setvCHOnlySchedules: (vCHOnlySchedules)=>set({
                vCHOnlySchedules: vCHOnlySchedules
            }),
        smtpInstructions: "",
        setSmtpInstructions: (smtpInstructions)=>set({
                smtpInstructions: smtpInstructions
            }),
        getSMTPIntructions: async (retryFunction, navigate)=>{
            const { setSmtpInstructions: setSmtpInstructions } = get();
            // Get the setter from useAppStore
            const AxiosUI = (0, $195EM.createApi)(``);
            try {
                const response = await AxiosUI.get(`customer/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}/instructions/`);
                const smtpInstructions = response.data;
                setSmtpInstructions(smtpInstructions);
            } catch (reason) {
                (0, $dIPZj.concurrentAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setSmtpInstructions("");
                });
            }
        },
        // New function that loads all data concurrently
        loadAllData: async (navigate)=>{
            const { getSiteInfo: getSiteInfo, getSMTPIntructions: getSMTPIntructions } = get();
            const retryLoadAllData = ()=>get().loadAllData(navigate);
            try {
                // Run both API calls concurrently and wait for both to settle
                await Promise.allSettled([
                    getSiteInfo(retryLoadAllData, navigate),
                    getSMTPIntructions(retryLoadAllData, navigate)
                ]);
            } catch (error) {
                // Catch any unexpected errors during the allSettled process itself (unlikely)
                (0, $ebTQj.logger).error("Unexpected error during loadAllData:", error);
                // Define the retry function
                (0, $dIPZj.concurrentAPIErrorHandler)(error, navigate, retryLoadAllData, ()=>{});
            } finally{
                // This block will always execute after the try (and catch, if an error occurred)
                // ensuring the loading screen is turned off regardless of success or failure.
                const refreshingToken = (0, $aYdit.useAppStore).getState().refreshingToken;
                const setBackdropLoadingScreenRefreshTokenOn = (0, $aYdit.useAppStore).getState().setBackdropLoadingScreenRefreshTokenOn;
                if (!refreshingToken) setBackdropLoadingScreenRefreshTokenOn(false);
            }
        },
        hideUseMotion: false,
        setHideUseMotion: (hideUseMotion)=>set({
                hideUseMotion: hideUseMotion
            }),
        siteAboutAlerts: {
            scheduleSubmittedAndSiteSynced: false
        },
        allIgnoreZones: [],
        setAllIgnoreZones: (allIgnoreZones)=>set({
                allIgnoreZones: allIgnoreZones
            }),
        visibleIgnoreZones: [],
        setVisibleIgnoreZones: (visibleIgnoreZones)=>set({
                visibleIgnoreZones: visibleIgnoreZones
            }),
        cameraStatusById: {},
        setCameraStatusById: (cameraStatusById)=>set({
                cameraStatusById: cameraStatusById
            }),
        setCameraStatusForCamera: (cameraId, status)=>{
            const { cameraStatusById: cameraStatusById, setCameraStatusById: setCameraStatusById } = get();
            setCameraStatusById({
                ...cameraStatusById,
                [cameraId]: status
            });
        },
        ignoreZonesByCamera: {},
        setIgnoreZonesByCamera: (ignoreZonesByCamera)=>set({
                ignoreZonesByCamera: ignoreZonesByCamera
            }),
        setIgnoreZonesForCamera: (cameraId, ignoreZones)=>{
            const { ignoreZonesByCamera: ignoreZonesByCamera, setIgnoreZonesByCamera: setIgnoreZonesByCamera } = get();
            setIgnoreZonesByCamera({
                ...ignoreZonesByCamera,
                [cameraId]: ignoreZones
            });
        },
        metadataTagZonesByCamera: {},
        setMetadataTagZonesByCamera: (metadataTagZonesByCamera)=>set({
                metadataTagZonesByCamera: metadataTagZonesByCamera
            }),
        setMetadataTagZonesForCamera: (cameraId, metadataTagZones)=>{
            const { metadataTagZonesByCamera: metadataTagZonesByCamera, setMetadataTagZonesByCamera: setMetadataTagZonesByCamera } = get();
            setMetadataTagZonesByCamera({
                ...metadataTagZonesByCamera,
                [cameraId]: metadataTagZones
            });
        },
        rowPrefetchStateByCamera: {},
        setRowPrefetchStateByCamera: (rowPrefetchStateByCamera)=>set({
                rowPrefetchStateByCamera: rowPrefetchStateByCamera
            }),
        setRowPrefetchStateForCamera: (cameraId, state)=>{
            const { rowPrefetchStateByCamera: rowPrefetchStateByCamera, setRowPrefetchStateByCamera: setRowPrefetchStateByCamera } = get();
            setRowPrefetchStateByCamera({
                ...rowPrefetchStateByCamera,
                [cameraId]: state
            });
        },
        setSiteAboutAlerts: (siteAboutAlerts)=>set({
                siteAboutAlerts: siteAboutAlerts
            }),
        healthCheckMetricsData: {
            connectivity_check: {
                id: 0,
                enabled: false,
                alert_emails: ""
            },
            motion_status_check: {
                id: 0,
                enabled: false,
                alert_emails: ""
            },
            recording_check: {
                id: 0,
                enabled: false,
                alert_emails: ""
            },
            scene_change_check: {
                id: 0,
                enabled: false,
                alert_emails: ""
            },
            stream_quality_check: {
                id: 0,
                enabled: false,
                alert_emails: ""
            },
            image_quality_check: {
                id: 0,
                enabled: false,
                alert_emails: ""
            }
        },
        // Method to set healthCheckMetricsData
        setHealthCheckMetricsData: (healthCheckMetricsData)=>set({
                healthCheckMetricsData: healthCheckMetricsData
            }),
        getHealthCheckMetricsData: async (navigate, siteId)=>{
            const { setHealthCheckMetricsData: setHealthCheckMetricsData } = get();
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().getHealthCheckMetricsData(navigate, siteId);
            };
            const defaultHealthCheckMetrics = {
                connectivity_check: {
                    id: 0,
                    enabled: false,
                    alert_emails: ""
                },
                motion_status_check: {
                    id: 0,
                    enabled: false,
                    alert_emails: ""
                },
                recording_check: {
                    id: 0,
                    enabled: false,
                    alert_emails: ""
                },
                scene_change_check: {
                    id: 0,
                    enabled: false,
                    alert_emails: ""
                },
                stream_quality_check: {
                    id: 0,
                    enabled: false,
                    alert_emails: ""
                },
                image_quality_check: {
                    id: 0,
                    enabled: false,
                    alert_emails: ""
                }
            };
            try {
                const response = await AxiosUI.get(`metric_healthcheck/by_customer/${siteId}`);
                const rawData = response.data;
                const dataArray = Array.isArray(rawData) ? rawData : [];
                const sortedData = dataArray.length > 0 ? $05b20e7d3e25d0ab$var$sortHealthCheckMetricsData(dataArray) : defaultHealthCheckMetrics;
                setHealthCheckMetricsData(sortedData);
                localStorage.setItem("backupHealthCheckMetricsData", JSON.stringify(sortedData));
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setHealthCheckMetricsData(defaultHealthCheckMetrics);
                });
            }
        },
        patchHealthCheckMetricsData: async (navigate, id, patchObject, key)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().patchHealthCheckMetricsData(navigate, id, patchObject, key);
            };
            try {
                await AxiosUI.patch(`metric_healthcheck/${id}/`, patchObject);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    alert(`Trouble updating ${$05b20e7d3e25d0ab$var$returnHealthCheckName(key)} data. Please try again.`);
                });
            }
        },
        healthCheckMetricsUpdated: {
            connectivity_check: false,
            motion_status_check: false,
            recording_check: false,
            scene_change_check: false,
            stream_quality_check: false,
            image_quality_check: false
        },
        setHealthCheckMetricsUpdated: (healthCheckMetricsUpdated)=>set({
                healthCheckMetricsUpdated: healthCheckMetricsUpdated
            }),
        siteSchedules: [],
        setSiteSchedules: (siteSchedules)=>set({
                siteSchedules: siteSchedules
            }),
        backupSiteSchedules: [],
        setBackupSiteSchedules: (backupSiteSchedules)=>set({
                backupSiteSchedules: backupSiteSchedules
            }),
        handleFilterCameras: (cameras)=>{
            const { autoPatrolSchedules: autoPatrolSchedules, selectedAutoPatrolScheduleIndex: selectedAutoPatrolScheduleIndex } = get();
            const activeCameraIds = autoPatrolSchedules[selectedAutoPatrolScheduleIndex]?.devices.map((schedule)=>schedule.id);
            return cameras.filter((camera)=>activeCameraIds?.includes(camera.id));
        },
        getNonFlexSchedules: async (siteCameraCount, setAlertState, getHealthCheckData, navigate)=>{
            const { setSiteSchedules: setSiteSchedules, setVisibleSchedules: setVisibleSchedules, setTimeRanges: setTimeRanges, setGrid: setGrid, setDuskToDawn: setDuskToDawn, setDuskToDawnLocation: setDuskToDawnLocation, setBackupSiteSchedules: setBackupSiteSchedules, setFlexSchedulesOn: setFlexSchedulesOn } = get();
            const AxiosUI = (0, $195EM.createApi)(``);
            setFlexSchedulesOn(false);
            const retryFunction = ()=>{
                get().getNonFlexSchedules(siteCameraCount, setAlertState, getHealthCheckData, navigate);
            };
            try {
                const response = await AxiosUI.get(`schedule/by_customer/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}/`);
                const temporaryUpdatedScheduleData = (0, $k1C5l.temporaryUpdateScheduleData)(response.data);
                setTimeRanges((0, $2Mk2P.handleCreateInitialTimeSchedules)(temporaryUpdatedScheduleData[0].schedule));
                setGrid((0, $axLUl.handleConvertSchedulesToBooleanArrays)(temporaryUpdatedScheduleData[0].schedule));
                setDuskToDawn((0, $bILSL.handleCreateDuskToDawn)(temporaryUpdatedScheduleData[0].schedule));
                setDuskToDawnLocation((0, $7Gmex.handleCreateDuskToDawnLocationPlusBuffer)(temporaryUpdatedScheduleData[0].schedule));
                setVisibleSchedules({
                    one: true,
                    two: false,
                    three: false
                });
                setSiteSchedules(temporaryUpdatedScheduleData);
                setBackupSiteSchedules(temporaryUpdatedScheduleData);
                localStorage.setItem("backUpStandardSchedule", JSON.stringify(temporaryUpdatedScheduleData));
                if (siteCameraCount === 0 && response.data.length === 0) setAlertState((previousState)=>{
                    return {
                        ...previousState,
                        noCameraOrSchedule: true
                    };
                });
                if (siteCameraCount > 0 && response.data.length === 0) setAlertState((previousState)=>{
                    return {
                        ...previousState,
                        noSchedule: true
                    };
                });
                getHealthCheckData();
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setSiteSchedules([]);
                    setBackupSiteSchedules([]);
                    getHealthCheckData();
                });
            }
        },
        getFlexSchedules: async (siteCameraCount, setAlertState, getHealthCheckData, navigate)=>{
            const { setSiteSchedules: setSiteSchedules, setVisibleSchedules: setVisibleSchedules, setTimeRanges: setTimeRanges, setGrid: setGrid, setDuskToDawn: setDuskToDawn, setDuskToDawnLocation: setDuskToDawnLocation, schedulesIndex: schedulesIndex, setFlexSchedulesOn: setFlexSchedulesOn, setSelectedDayInfo: setSelectedDayInfo, setBackupSiteSchedules: setBackupSiteSchedules } = get();
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().getFlexSchedules(siteCameraCount, setAlertState, getHealthCheckData, navigate);
            };
            setFlexSchedulesOn(true);
            try {
                const response = await AxiosUI.get(`flex_schedule/by_customer/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}/`);
                setTimeRanges((0, $2Mk2P.handleCreateInitialTimeSchedules)(response.data[schedulesIndex].schedule));
                setGrid((0, $axLUl.handleConvertSchedulesToBooleanArrays)(response.data[schedulesIndex].schedule));
                setDuskToDawn((0, $bILSL.handleCreateDuskToDawn)(response.data[schedulesIndex].schedule));
                setDuskToDawnLocation((0, $7Gmex.handleCreateDuskToDawnLocationPlusBuffer)(response.data[schedulesIndex].schedule));
                setSelectedDayInfo(response.data[schedulesIndex]);
                setSiteSchedules(response.data);
                setBackupSiteSchedules(response.data);
                localStorage.setItem("backUpFlexSchedule", JSON.stringify(response.data));
                if (response.data.length === 1) setVisibleSchedules({
                    one: true,
                    two: false,
                    three: false
                });
                if (response.data.length === 2) setVisibleSchedules({
                    one: true,
                    two: true,
                    three: false
                });
                if (response.data.length === 3) setVisibleSchedules({
                    one: true,
                    two: true,
                    three: true
                });
                getHealthCheckData();
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setSiteSchedules([]);
                    setBackupSiteSchedules([]);
                    getHealthCheckData();
                });
            }
        },
        patchSchedules: async (setEditMode, setActiveTab, siteInfo, navigate)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const { flexSchedulesOn: flexSchedulesOn, siteSchedules: siteSchedules, setSiteSchedules: setSiteSchedules, setVisibleSchedules: setVisibleSchedules, setTimeRanges: setTimeRanges, setGrid: setGrid, setDuskToDawn: setDuskToDawn, setDuskToDawnLocation: setDuskToDawnLocation, setBackupSiteSchedules: setBackupSiteSchedules, setScheduleGridEditable: setScheduleGridEditable, setBackdropLoadingScreenOnEditingSchedule: setBackdropLoadingScreenOnEditingSchedule, schedulesIndex: schedulesIndex, setSelectedDayInfo: setSelectedDayInfo, setDeactivateSiteInsteadDialogOpen: setDeactivateSiteInsteadDialogOpen, checkIfSyncNeeded: checkIfSyncNeeded } = get();
            // setBackdropLoadingScreenOnEditingSchedule(false)
            const retryFunction = ()=>{
                get().patchSchedules(setEditMode, setActiveTab, siteInfo, navigate);
            };
            if (!flexSchedulesOn) {
                const patchObject = (0, $3uHoa.handleReadySchedulesForPatching)(siteSchedules[0].schedule);
                if (patchObject.length === 0) {
                    setDeactivateSiteInsteadDialogOpen(true);
                    return;
                }
                setBackdropLoadingScreenOnEditingSchedule(true);
                try {
                    const response = await AxiosUI.patch(`schedule/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}/`, patchObject);
                    checkIfSyncNeeded(navigate);
                    const temporaryUpdatedScheduleData = (0, $k1C5l.temporaryUpdateScheduleData)(response.data);
                    setTimeRanges((0, $2Mk2P.handleCreateInitialTimeSchedules)(temporaryUpdatedScheduleData[0].schedule));
                    setGrid((0, $axLUl.handleConvertSchedulesToBooleanArrays)(temporaryUpdatedScheduleData[0].schedule));
                    setDuskToDawn((0, $bILSL.handleCreateDuskToDawn)(temporaryUpdatedScheduleData[0].schedule));
                    setDuskToDawnLocation((0, $7Gmex.handleCreateDuskToDawnLocationPlusBuffer)(temporaryUpdatedScheduleData[0].schedule));
                    setSiteSchedules(temporaryUpdatedScheduleData);
                    localStorage.setItem("backUpStandardSchedule", JSON.stringify(temporaryUpdatedScheduleData));
                    setBackupSiteSchedules(temporaryUpdatedScheduleData);
                    setEditMode(false);
                    setScheduleGridEditable(false);
                    setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $2uQ4j.SchedulesTab), {
                        siteInfo: siteInfo
                    }));
                    setBackdropLoadingScreenOnEditingSchedule(false);
                } catch (error) {
                    (0, $3Zv1D.universalAPIErrorHandler)(error, navigate, retryFunction, ()=>{
                        alert("Trouble updating schedule. Please try again.");
                        const backupSchedules = JSON.parse(localStorage.getItem("backUpStandardSchedule") || "[]");
                        setSiteSchedules(backupSchedules);
                        setGrid((0, $axLUl.handleConvertSchedulesToBooleanArrays)(backupSchedules[0].schedule));
                        setDuskToDawn((0, $bILSL.handleCreateDuskToDawn)(backupSchedules[0].schedule));
                        setDuskToDawnLocation((0, $7Gmex.handleCreateDuskToDawnLocationPlusBuffer)(backupSchedules[0].schedule));
                        setTimeRanges((0, $2Mk2P.handleCreateInitialTimeSchedules)(backupSchedules[0].schedule));
                        setVisibleSchedules({
                            one: true,
                            two: false,
                            three: false
                        });
                        localStorage.setItem("siteSchedule", JSON.stringify(backupSchedules));
                        setEditMode(false);
                        setScheduleGridEditable(false);
                        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $2uQ4j.SchedulesTab), {
                            siteInfo: siteInfo
                        }));
                        setBackdropLoadingScreenOnEditingSchedule(false);
                    });
                }
            } else {
                const submittedSchedules = siteSchedules;
                siteSchedules.forEach((schedule, index)=>{
                    submittedSchedules[index].schedule = $05b20e7d3e25d0ab$var$readyAllSchedules(schedule.schedule);
                });
                let allSchedulesHaveProducts = true;
                submittedSchedules.forEach((schedule)=>{
                    if (schedule?.product.length === 0) allSchedulesHaveProducts = false;
                });
                if (!allSchedulesHaveProducts) {
                    alert("All schedules must have products in order to submit changes.");
                    setBackdropLoadingScreenOnEditingSchedule(false);
                    return;
                }
                const overlappingProducts = (0, $bitEk.handleCheckOverlappingSchedulesForSharedProducts)(submittedSchedules);
                if (overlappingProducts) {
                    alert("Schedules cannot be submitted with overlapping products.  Please update the schedules to remove the overlapping products and resubmit.");
                    setBackdropLoadingScreenOnEditingSchedule(false);
                    return;
                }
                // Overlaps only through the after-midnight half of an overnight window
                // are allowed (existing sites are saved that way) but duplicate alerts,
                // so say so and let the user decide (ENG-1970).
                const overnightOnly = (0, $bitEk.findOvernightOnlySharedProductOverlaps)(submittedSchedules);
                if (overnightOnly.length > 0 && !window.confirm((0, $feyZu.overnightOverlapWarning)(overnightOnly))) {
                    setBackdropLoadingScreenOnEditingSchedule(false);
                    return;
                }
                if (await (0, $7ZVeh.blockOnFlexPresetConflicts)(siteInfo, submittedSchedules)) {
                    setBackdropLoadingScreenOnEditingSchedule(false);
                    return;
                }
                try {
                    const response = await AxiosUI.patch(`/flex_schedule/by_customer/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}/`, submittedSchedules);
                    await (0, $7z9u9.persistFlexSchedulePresetAssignmentsAfterPatch)(siteInfo.id, response.data);
                    checkIfSyncNeeded(navigate);
                    setTimeRanges((0, $2Mk2P.handleCreateInitialTimeSchedules)(response.data[schedulesIndex].schedule));
                    setGrid((0, $axLUl.handleConvertSchedulesToBooleanArrays)(response.data[schedulesIndex].schedule));
                    setDuskToDawn((0, $bILSL.handleCreateDuskToDawn)(response.data[schedulesIndex].schedule));
                    setDuskToDawnLocation((0, $7Gmex.handleCreateDuskToDawnLocationPlusBuffer)(response.data[schedulesIndex].schedule));
                    setSelectedDayInfo(response.data[schedulesIndex]);
                    setSiteSchedules(response.data);
                    setBackupSiteSchedules(response.data);
                    localStorage.setItem("backUpFlexSchedule", JSON.stringify(response.data));
                    setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $2uQ4j.SchedulesTab), {
                        siteInfo: siteInfo
                    }));
                    setEditMode(false);
                    setScheduleGridEditable(false);
                    setBackdropLoadingScreenOnEditingSchedule(false);
                } catch (error) {
                    (0, $3Zv1D.universalAPIErrorHandler)(error, navigate, retryFunction, ()=>{
                        const backupFlexSchedules = JSON.parse(localStorage.getItem("backUpFlexSchedule") || "[]");
                        setSiteSchedules(backupFlexSchedules);
                        setGrid((0, $axLUl.handleConvertSchedulesToBooleanArrays)(backupFlexSchedules[schedulesIndex].schedule));
                        setDuskToDawn((0, $bILSL.handleCreateDuskToDawn)(backupFlexSchedules[schedulesIndex].schedule));
                        setDuskToDawnLocation((0, $7Gmex.handleCreateDuskToDawnLocationPlusBuffer)(backupFlexSchedules[schedulesIndex].schedule));
                        setTimeRanges((0, $2Mk2P.handleCreateInitialTimeSchedules)(backupFlexSchedules[schedulesIndex].schedule));
                        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $2uQ4j.SchedulesTab), {
                            siteInfo: siteInfo
                        }));
                        setEditMode(false);
                        setScheduleGridEditable(false);
                        setBackdropLoadingScreenOnEditingSchedule(false);
                    });
                }
            }
        },
        patchDetailedSchedule: async (patchObject, setEditMode, setActiveTab, siteInfo, navigate)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const { setSiteSchedules: setSiteSchedules, setTimeRanges: setTimeRanges, setGrid: setGrid, setDuskToDawn: setDuskToDawn, setDuskToDawnLocation: setDuskToDawnLocation, setBackupSiteSchedules: setBackupSiteSchedules, setScheduleGridEditable: setScheduleGridEditable, setBackdropLoadingScreenOnEditingSchedule: setBackdropLoadingScreenOnEditingSchedule, siteSchedules: siteSchedules, flexSchedulesOn: flexSchedulesOn, schedulesIndex: schedulesIndex, setSelectedDayInfo: setSelectedDayInfo, checkIfSyncNeeded: checkIfSyncNeeded } = get();
            const retryFunction = ()=>{
                get().patchDetailedSchedule(patchObject, setEditMode, setActiveTab, siteInfo, navigate);
            };
            patchObject.forEach((schedule, index)=>{
                if (schedule.start_time === "") patchObject[index].start_time = null;
                if (schedule.end_time === "") patchObject[index].end_time = null;
            });
            if (!flexSchedulesOn) try {
                const response = await AxiosUI.patch(`schedule/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}/`, patchObject);
                const temporaryUpdatedScheduleData = (0, $k1C5l.temporaryUpdateScheduleData)(response.data);
                checkIfSyncNeeded(navigate);
                setTimeRanges((0, $2Mk2P.handleCreateInitialTimeSchedules)(temporaryUpdatedScheduleData[0].schedule));
                setGrid((0, $axLUl.handleConvertSchedulesToBooleanArrays)(temporaryUpdatedScheduleData[0].schedule));
                setDuskToDawn((0, $bILSL.handleCreateDuskToDawn)(temporaryUpdatedScheduleData[0].schedule));
                setDuskToDawnLocation((0, $7Gmex.handleCreateDuskToDawnLocationPlusBuffer)(temporaryUpdatedScheduleData[0].schedule));
                setSiteSchedules(temporaryUpdatedScheduleData);
                setBackupSiteSchedules(temporaryUpdatedScheduleData);
                localStorage.setItem("backUpStandardSchedule", JSON.stringify(temporaryUpdatedScheduleData));
                setEditMode(false);
                setScheduleGridEditable(false);
                const updatedSiteInfo = {
                    ...siteInfo,
                    has_flex_schedule: false
                };
                setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $2uQ4j.SchedulesTab), {
                    siteInfo: updatedSiteInfo
                }));
                setBackdropLoadingScreenOnEditingSchedule(false);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    alert("Trouble updating schedule. Please try again.");
                    setBackdropLoadingScreenOnEditingSchedule(false);
                });
            }
            else {
                const postObjectFlex = siteSchedules;
                postObjectFlex[schedulesIndex].schedule = patchObject;
                if (await (0, $7ZVeh.blockOnFlexPresetConflicts)(siteInfo, postObjectFlex)) {
                    setBackdropLoadingScreenOnEditingSchedule(false);
                    return;
                }
                try {
                    const response = await AxiosUI.patch(`/flex_schedule/by_customer/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}/`, postObjectFlex);
                    await (0, $7z9u9.persistFlexSchedulePresetAssignmentsAfterPatch)(siteInfo.id, response.data);
                    checkIfSyncNeeded(navigate);
                    setTimeRanges((0, $2Mk2P.handleCreateInitialTimeSchedules)(response.data[schedulesIndex].schedule));
                    setGrid((0, $axLUl.handleConvertSchedulesToBooleanArrays)(response.data[schedulesIndex].schedule));
                    setDuskToDawn((0, $bILSL.handleCreateDuskToDawn)(response.data[schedulesIndex].schedule));
                    setDuskToDawnLocation((0, $7Gmex.handleCreateDuskToDawnLocationPlusBuffer)(response.data[schedulesIndex].schedule));
                    setSelectedDayInfo(response.data[schedulesIndex]);
                    setBackdropLoadingScreenOnEditingSchedule(false);
                    setSiteSchedules(response.data);
                    setBackupSiteSchedules(response.data);
                    localStorage.setItem("backUpFlexSchedule", JSON.stringify(response.data));
                    setEditMode(false);
                    setScheduleGridEditable(false);
                    const updatedSiteInfo = {
                        ...siteInfo,
                        has_flex_schedule: true
                    };
                    setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $2uQ4j.SchedulesTab), {
                        siteInfo: updatedSiteInfo
                    }));
                } catch (reason) {
                    (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                        alert("Trouble updating schedule. Please try again.");
                        setBackdropLoadingScreenOnEditingSchedule(false);
                    });
                }
            }
        },
        handleSubmitEmptySchedule: async (setEditMode, setActiveTab, siteInfo, navigate)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().handleSubmitEmptySchedule(setEditMode, setActiveTab, siteInfo, navigate);
            };
            const { setTimeRanges: setTimeRanges, setGrid: setGrid, setDuskToDawn: setDuskToDawn, setDuskToDawnLocation: setDuskToDawnLocation, setVisibleSchedules: setVisibleSchedules, setSiteSchedules: setSiteSchedules, setBackupSiteSchedules: setBackupSiteSchedules, setBackdropLoadingScreenOnEditingSchedule: setBackdropLoadingScreenOnEditingSchedule, setScheduleGridEditable: setScheduleGridEditable, checkIfSyncNeeded: checkIfSyncNeeded } = get();
            const emptySchedule = [
                {
                    customer: (0, $h5bv8.getNumbersAfterAboutSite)(location.href),
                    start_time: null,
                    end_time: "00:00:00",
                    always_on: false,
                    day_of_week: [
                        "5",
                        "6",
                        "2",
                        "4",
                        "3",
                        "1",
                        "0"
                    ],
                    schedule_status: true,
                    is_override: false,
                    location_dusk_dawn: null,
                    enabled: true,
                    override_start_date: null,
                    override_end_date: null,
                    buffer_time: null
                }
            ];
            setBackdropLoadingScreenOnEditingSchedule(true);
            try {
                const response = await AxiosUI.patch(`schedule/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}/`, emptySchedule);
                checkIfSyncNeeded(navigate);
                const temporaryUpdatedScheduleData = (0, $k1C5l.temporaryUpdateScheduleData)(response.data);
                setTimeRanges((0, $2Mk2P.handleCreateInitialTimeSchedules)(temporaryUpdatedScheduleData[0].schedule));
                setGrid((0, $axLUl.handleConvertSchedulesToBooleanArrays)(temporaryUpdatedScheduleData[0].schedule));
                setDuskToDawn((0, $bILSL.handleCreateDuskToDawn)(temporaryUpdatedScheduleData[0].schedule));
                setDuskToDawnLocation((0, $7Gmex.handleCreateDuskToDawnLocationPlusBuffer)(temporaryUpdatedScheduleData[0].schedule));
                setVisibleSchedules({
                    one: true,
                    two: false,
                    three: false
                });
                localStorage.setItem("siteSchedule", JSON.stringify(temporaryUpdatedScheduleData));
                setSiteSchedules(temporaryUpdatedScheduleData);
                localStorage.setItem("backUpStandardSchedule", JSON.stringify(temporaryUpdatedScheduleData));
                setBackupSiteSchedules(temporaryUpdatedScheduleData);
                setBackdropLoadingScreenOnEditingSchedule(false);
                setEditMode(false);
                setScheduleGridEditable(false);
                setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $2uQ4j.SchedulesTab), {
                    siteInfo: siteInfo
                }));
            } catch (error) {
                (0, $3Zv1D.universalAPIErrorHandler)(error, navigate, retryFunction, ()=>{
                    alert("Trouble updating schedule. Please try again.");
                    const backupSchedules = JSON.parse(localStorage.getItem("backUpStandardSchedule") || "[]");
                    setSiteSchedules(backupSchedules);
                    setGrid((0, $axLUl.handleConvertSchedulesToBooleanArrays)(backupSchedules[0].schedule));
                    setDuskToDawn((0, $bILSL.handleCreateDuskToDawn)(backupSchedules[0].schedule));
                    setDuskToDawnLocation((0, $7Gmex.handleCreateDuskToDawnLocationPlusBuffer)(backupSchedules[0].schedule));
                    setTimeRanges((0, $2Mk2P.handleCreateInitialTimeSchedules)(backupSchedules[0].schedule));
                    setVisibleSchedules({
                        one: true,
                        two: false,
                        three: false
                    });
                    localStorage.setItem("siteSchedule", JSON.stringify(backupSchedules));
                    setEditMode(false);
                    setScheduleGridEditable(false);
                    setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $2uQ4j.SchedulesTab), {
                        siteInfo: siteInfo
                    }));
                    setBackdropLoadingScreenOnEditingSchedule(false);
                });
            }
        },
        handleFlexSchedulingToggle: async (enabled, setSiteInfo, setEditMode, setActiveTab, siteInfo, navigate)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().handleFlexSchedulingToggle(enabled, setSiteInfo, setEditMode, setActiveTab, siteInfo, navigate);
            };
            const { setTimeRanges: setTimeRanges, setGrid: setGrid, setDuskToDawn: setDuskToDawn, setDuskToDawnLocation: setDuskToDawnLocation, setSelectedDayInfo: setSelectedDayInfo, setVisibleSchedules: setVisibleSchedules, setSiteSchedules: setSiteSchedules, setBackupSiteSchedules: setBackupSiteSchedules, schedulesIndex: schedulesIndex, setSchedulesIndex: setSchedulesIndex, setFlexSchedulesOn: setFlexSchedulesOn, setBackdropLoadingScreenOnEditingSchedule: setBackdropLoadingScreenOnEditingSchedule, getNonFlexSchedules: getNonFlexSchedules, setScheduleGridEditable: setScheduleGridEditable, checkIfSyncNeeded: checkIfSyncNeeded } = get();
            setBackdropLoadingScreenOnEditingSchedule(true);
            try {
                if (enabled) {
                    const response = await AxiosUI.post(`flex_schedule/enable/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}/`);
                    localStorage.setItem("siteSchedule", JSON.stringify(response.data));
                    setTimeRanges((0, $2Mk2P.handleCreateInitialTimeSchedules)(response.data[schedulesIndex].schedule));
                    setGrid((0, $axLUl.handleConvertSchedulesToBooleanArrays)(response.data[schedulesIndex].schedule));
                    setDuskToDawn((0, $bILSL.handleCreateDuskToDawn)(response.data[schedulesIndex].schedule));
                    setDuskToDawnLocation((0, $7Gmex.handleCreateDuskToDawnLocationPlusBuffer)(response.data[schedulesIndex].schedule));
                    setSelectedDayInfo(response.data[schedulesIndex]);
                    setVisibleSchedules({
                        one: true,
                        two: false,
                        three: false
                    });
                    setSiteSchedules(response.data);
                    setBackupSiteSchedules(response.data);
                    localStorage.setItem("backUpFlexSchedule", JSON.stringify(response.data));
                    if (response.data.length === 1) setVisibleSchedules({
                        one: true,
                        two: false,
                        three: false
                    });
                    if (response.data.length === 2) setVisibleSchedules({
                        one: true,
                        two: true,
                        three: false
                    });
                    if (response.data.length === 3) setVisibleSchedules({
                        one: true,
                        two: true,
                        three: true
                    });
                    setSiteInfo((prev)=>{
                        return {
                            ...prev,
                            has_flex_schedule: true
                        };
                    });
                    setFlexSchedulesOn(true);
                    setEditMode(false);
                    setScheduleGridEditable(false);
                } else {
                    await AxiosUI.post(`flex_schedule/disable/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}/`);
                    setFlexSchedulesOn(false);
                    setSiteInfo((prev)=>{
                        return {
                            ...prev,
                            has_flex_schedule: false
                        };
                    });
                    setEditMode(false);
                    setScheduleGridEditable(false);
                    setSchedulesIndex(0); // Reset to first schedule
                    await getNonFlexSchedules(0, ()=>{}, ()=>{}, navigate);
                    checkIfSyncNeeded(navigate);
                    // Get the updated siteInfo from the store and set active tab after non-flex schedules are loaded
                    const updatedSiteInfo = {
                        ...siteInfo,
                        has_flex_schedule: false
                    };
                    setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $2uQ4j.SchedulesTab), {
                        siteInfo: updatedSiteInfo
                    }));
                }
                // Turn off loading screen after both operations complete
                if (enabled) {
                    checkIfSyncNeeded(navigate);
                    const updatedSiteInfo = {
                        ...siteInfo,
                        has_flex_schedule: true
                    };
                    setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $2uQ4j.SchedulesTab), {
                        siteInfo: updatedSiteInfo
                    }));
                }
                setBackdropLoadingScreenOnEditingSchedule(false);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    alert(`Problem ${enabled ? "enabling" : "disabling"} flex scheduling.`);
                    setBackdropLoadingScreenOnEditingSchedule(false);
                });
            }
        },
        handleAddSchedule: async (navigate)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().handleAddSchedule(navigate);
            };
            const { setSiteSchedules: setSiteSchedules, setBackupSiteSchedules: setBackupSiteSchedules, siteSchedules: siteSchedules, setSchedulesIndex: setSchedulesIndex, setTimeRanges: setTimeRanges, setGrid: setGrid, setDuskToDawn: setDuskToDawn, setDuskToDawnLocation: setDuskToDawnLocation, setSelectedDayInfo: setSelectedDayInfo, setClickedSchedulesTab: setClickedSchedulesTab, setBackdropLoadingScreenOnEditingSchedule: setBackdropLoadingScreenOnEditingSchedule, checkIfSyncNeeded: checkIfSyncNeeded } = get();
            setBackdropLoadingScreenOnEditingSchedule(true);
            try {
                const response = await AxiosUI.post(`flex_schedule/add/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}/`);
                const newScheduleIndex = (0, $jspVg.findNewScheduleIndex)(siteSchedules, response.data);
                setSchedulesIndex(newScheduleIndex);
                setTimeRanges((0, $2Mk2P.handleCreateInitialTimeSchedules)(response.data[newScheduleIndex].schedule));
                setGrid((0, $axLUl.handleConvertSchedulesToBooleanArrays)(response.data[newScheduleIndex].schedule));
                setDuskToDawn((0, $bILSL.handleCreateDuskToDawn)(response.data[newScheduleIndex].schedule));
                setDuskToDawnLocation((0, $7Gmex.handleCreateDuskToDawnLocationPlusBuffer)(response.data[newScheduleIndex].schedule));
                setSelectedDayInfo(response.data[newScheduleIndex]);
                if (newScheduleIndex === 0) setClickedSchedulesTab("one");
                if (newScheduleIndex === 1) setClickedSchedulesTab("two");
                if (newScheduleIndex === 2) setClickedSchedulesTab("three");
                const updatedSiteSchedules = siteSchedules;
                updatedSiteSchedules.push(response.data[response.data.length - 1]);
                const updatedBackupFlexSchedule = JSON.parse(localStorage.backUpFlexSchedule);
                updatedBackupFlexSchedule.push(response.data[response.data.length - 1]);
                setSiteSchedules(updatedSiteSchedules);
                localStorage.setItem("backUpFlexSchedule", JSON.stringify(updatedBackupFlexSchedule));
                setBackdropLoadingScreenOnEditingSchedule(false);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    alert("Problem adding schedule. Please try again.");
                    setBackdropLoadingScreenOnEditingSchedule(false);
                });
            }
        },
        handleDeleteSchedule: async (scheduleId, navigate)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().handleDeleteSchedule(scheduleId, navigate);
            };
            const { siteSchedules: siteSchedules, setSiteSchedules: setSiteSchedules, setBackupSiteSchedules: setBackupSiteSchedules, setSchedulesIndex: setSchedulesIndex, setClickedSchedulesTab: setClickedSchedulesTab, setBackdropLoadingScreenOnEditingSchedule: setBackdropLoadingScreenOnEditingSchedule, setTimeRanges: setTimeRanges, setGrid: setGrid, setDuskToDawn: setDuskToDawn, setDuskToDawnLocation: setDuskToDawnLocation, setSelectedDayInfo: setSelectedDayInfo } = get();
            setBackdropLoadingScreenOnEditingSchedule(true);
            try {
                await AxiosUI.delete(`flex_schedule/${scheduleId}/`);
                const filteredSiteSchedules = siteSchedules.filter((schedule)=>schedule.id !== scheduleId);
                setSchedulesIndex(0);
                setClickedSchedulesTab("one");
                setTimeRanges((0, $2Mk2P.handleCreateInitialTimeSchedules)(siteSchedules[0].schedule));
                setGrid((0, $axLUl.handleConvertSchedulesToBooleanArrays)(siteSchedules[0].schedule));
                setDuskToDawn((0, $bILSL.handleCreateDuskToDawn)(siteSchedules[0].schedule));
                setDuskToDawnLocation((0, $7Gmex.handleCreateDuskToDawnLocationPlusBuffer)(siteSchedules[0].schedule));
                setSelectedDayInfo(siteSchedules[0]);
                setSiteSchedules(filteredSiteSchedules);
                setBackupSiteSchedules(filteredSiteSchedules);
                localStorage.setItem("backUpFlexSchedule", JSON.stringify(filteredSiteSchedules));
                setBackdropLoadingScreenOnEditingSchedule(false);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    alert("Problem deleting schedule. Please try again.");
                    setBackdropLoadingScreenOnEditingSchedule(false);
                });
            }
        },
        schedulesIndex: 0,
        setSchedulesIndex: (schedulesIndex)=>set({
                schedulesIndex: schedulesIndex
            }),
        timeRanges: [],
        setTimeRanges: (timeRanges)=>set({
                timeRanges: timeRanges
            }),
        grid: [],
        setGrid: (grid)=>set({
                grid: grid
            }),
        duskToDawn: [],
        setDuskToDawn: (duskToDawn)=>set({
                duskToDawn: duskToDawn
            }),
        duskToDawnLocation: [],
        setDuskToDawnLocation: (duskToDawnLocation)=>set({
                duskToDawnLocation: duskToDawnLocation
            }),
        clickedSchedulesTab: "one",
        setClickedSchedulesTab: (clickedSchedulesTab)=>set({
                clickedSchedulesTab: clickedSchedulesTab
            }),
        visibleSchedules: [],
        setVisibleSchedules: (visibleSchedules)=>set({
                visibleSchedules: visibleSchedules
            }),
        scheduleGridEditable: true,
        setScheduleGridEditable: (scheduleGridEditable)=>set({
                scheduleGridEditable: scheduleGridEditable
            }),
        scheduleChangesMade: false,
        setScheduleChangesMade: (scheduleChangesMade)=>set({
                scheduleChangesMade: scheduleChangesMade
            }),
        selectedDayInfo: {},
        setSelectedDayInfo: (selectedDayInfo)=>set({
                selectedDayInfo: selectedDayInfo
            }),
        matchingSchedules: [],
        setMatchingSchedules: (matchingSchedules)=>set({
                matchingSchedules: matchingSchedules
            }),
        flexSchedulesOn: false,
        setFlexSchedulesOn: (flexSchedulesOn)=>set({
                flexSchedulesOn: flexSchedulesOn
            }),
        editTimeScheduleDialogOpen: false,
        setEditTimeScheduleDialogOpen: (editTimeScheduleDialogOpen)=>set({
                editTimeScheduleDialogOpen: editTimeScheduleDialogOpen
            }),
        editActiveProductsDialogOpen: false,
        setEditActiveProductsDialogOpen: (editActiveProductsDialogOpen)=>set({
                editActiveProductsDialogOpen: editActiveProductsDialogOpen
            }),
        editScheduleNameDialogOpen: false,
        setEditScheduleNameDialogOpen: (editScheduleNameDialogOpen)=>set({
                editScheduleNameDialogOpen: editScheduleNameDialogOpen
            }),
        deleteScheduleDialogOpen: false,
        setDeleteScheduleDialogOpen: (deleteScheduleDialogOpen)=>set({
                deleteScheduleDialogOpen: deleteScheduleDialogOpen
            }),
        deactivateSiteInsteadDialogOpen: false,
        setDeactivateSiteInsteadDialogOpen: (deactivateSiteInsteadDialogOpen)=>set({
                deactivateSiteInsteadDialogOpen: deactivateSiteInsteadDialogOpen
            }),
        schedulesBackdropLoadingScreenOn: false,
        setSchedulesBackdropLoadingScreenOn: (schedulesBackdropLoadingScreenOn)=>set({
                schedulesBackdropLoadingScreenOn: schedulesBackdropLoadingScreenOn
            }),
        healthCheckDataZustand: {},
        setHealthCheckDataZustand: (healthCheckDataZustand)=>set({
                healthCheckDataZustand: healthCheckDataZustand
            }),
        autoPatrolSchedules: [],
        setAutoPatrolSchedules: (autoPatrolSchedules)=>set({
                autoPatrolSchedules: autoPatrolSchedules
            }),
        selectedAutoPatrolScheduleIndex: 0,
        setSelectedAutoPatrolScheduleIndex: (selectedAutoPatrolScheduleIndex)=>set({
                selectedAutoPatrolScheduleIndex: selectedAutoPatrolScheduleIndex
            }),
        autoPatrolFlexIgnoreZonesEnabledBySite: {},
        setAutoPatrolFlexIgnoreZonesEnabledForSite: (siteId, enabled)=>set((state)=>({
                    autoPatrolFlexIgnoreZonesEnabledBySite: {
                        ...state.autoPatrolFlexIgnoreZonesEnabledBySite,
                        [siteId]: enabled
                    }
                })),
        autoPatrolFlexIgnoreZonesWizardOpenBySite: {},
        setAutoPatrolFlexIgnoreZonesWizardOpenForSite: (siteId, open)=>set((state)=>({
                    autoPatrolFlexIgnoreZonesWizardOpenBySite: {
                        ...state.autoPatrolFlexIgnoreZonesWizardOpenBySite,
                        [siteId]: open
                    }
                })),
        autoPatrolFlexIgnoreZonesActiveScheduleIndexBySite: {},
        setAutoPatrolFlexIgnoreZonesActiveScheduleIndexForSite: (siteId, index)=>set((state)=>({
                    autoPatrolFlexIgnoreZonesActiveScheduleIndexBySite: {
                        ...state.autoPatrolFlexIgnoreZonesActiveScheduleIndexBySite,
                        [siteId]: index
                    }
                })),
        autoPatrolFlexIgnoreZonesPresetsByCamera: {},
        setAutoPatrolFlexIgnoreZonesPresetsForCamera: (cameraId, presets)=>set((state)=>({
                    autoPatrolFlexIgnoreZonesPresetsByCamera: {
                        ...state.autoPatrolFlexIgnoreZonesPresetsByCamera,
                        [cameraId]: presets
                    }
                })),
        autoPatrolFlexIgnoreZonesSelectedPresetByScheduleCamera: {},
        setAutoPatrolFlexIgnoreZonesSelectedPresetForScheduleCamera: (scheduleId, cameraId, presetLocalId)=>set((state)=>({
                    autoPatrolFlexIgnoreZonesSelectedPresetByScheduleCamera: {
                        ...state.autoPatrolFlexIgnoreZonesSelectedPresetByScheduleCamera,
                        [`${scheduleId}:${cameraId}`]: presetLocalId
                    }
                })),
        autoPatrolFlexIgnoreZonesSelectedCameraIdsBySchedule: {},
        setAutoPatrolFlexIgnoreZonesSelectedCameraIdsBySchedule: (scheduleId, cameraIds)=>set((state)=>({
                    autoPatrolFlexIgnoreZonesSelectedCameraIdsBySchedule: {
                        ...state.autoPatrolFlexIgnoreZonesSelectedCameraIdsBySchedule,
                        [scheduleId]: cameraIds
                    }
                })),
        initializeAutoPatrolFlexIgnoreZonesForSite: ({ siteId: siteId, scheduleIds: scheduleIds, cameraIdsBySchedule: cameraIdsBySchedule })=>set((state)=>{
                const selectedPresetByScheduleCamera = {
                    ...state.autoPatrolFlexIgnoreZonesSelectedPresetByScheduleCamera
                };
                scheduleIds.forEach((scheduleId)=>{
                    const cameraIds = cameraIdsBySchedule[scheduleId] || [];
                    cameraIds.forEach((cameraId)=>{
                        const key = `${scheduleId}:${cameraId}`;
                        if (!selectedPresetByScheduleCamera[key]) selectedPresetByScheduleCamera[key] = `default-${cameraId}`;
                    });
                });
                return {
                    autoPatrolFlexIgnoreZonesEnabledBySite: {
                        ...state.autoPatrolFlexIgnoreZonesEnabledBySite,
                        [siteId]: state.autoPatrolFlexIgnoreZonesEnabledBySite[siteId] ?? false
                    },
                    autoPatrolFlexIgnoreZonesSelectedCameraIdsBySchedule: {
                        ...state.autoPatrolFlexIgnoreZonesSelectedCameraIdsBySchedule,
                        ...cameraIdsBySchedule
                    },
                    autoPatrolFlexIgnoreZonesSelectedPresetByScheduleCamera: selectedPresetByScheduleCamera
                };
            }),
        resetAutoPatrolFlexIgnoreZonesForSite: (siteId)=>set((state)=>{
                const nextEnabled = {
                    ...state.autoPatrolFlexIgnoreZonesEnabledBySite
                };
                const nextOpen = {
                    ...state.autoPatrolFlexIgnoreZonesWizardOpenBySite
                };
                const nextActiveIndex = {
                    ...state.autoPatrolFlexIgnoreZonesActiveScheduleIndexBySite
                };
                delete nextEnabled[siteId];
                delete nextOpen[siteId];
                delete nextActiveIndex[siteId];
                return {
                    autoPatrolFlexIgnoreZonesEnabledBySite: nextEnabled,
                    autoPatrolFlexIgnoreZonesWizardOpenBySite: nextOpen,
                    autoPatrolFlexIgnoreZonesActiveScheduleIndexBySite: nextActiveIndex,
                    autoPatrolFlexIgnoreZonesPresetsByCamera: {},
                    autoPatrolFlexIgnoreZonesSelectedPresetByScheduleCamera: {},
                    autoPatrolFlexIgnoreZonesSelectedCameraIdsBySchedule: {}
                };
            }),
        autopatrolCamerasTablePage: 0,
        setAutopatrolCamerasTablePage: (autopatrolCamerasTablePage)=>set({
                autopatrolCamerasTablePage: autopatrolCamerasTablePage
            }),
        autopatrolCamerasTableRowsPerPage: 5,
        setAutopatrolCamerasTableRowsPerPage: (autopatrolCamerasTableRowsPerPage)=>set({
                autopatrolCamerasTableRowsPerPage: autopatrolCamerasTableRowsPerPage
            }),
        autoPatrolSchedulesUpdatedBoolean: false,
        setAutoPatrolSchedulesUpdatedBoolean: (autoPatrolSchedulesUpdatedBoolean)=>set({
                autoPatrolSchedulesUpdatedBoolean: autoPatrolSchedulesUpdatedBoolean
            }),
        updatedAutoPatrolScheduleIndexes: [],
        setUpdatedAutoPatrolScheduleIndexes: (updatedAutoPatrolScheduleIndexes)=>set({
                updatedAutoPatrolScheduleIndexes: updatedAutoPatrolScheduleIndexes
            }),
        autoPatrolScheduleHealthchckMetrics: {},
        setAutoPatrolScheduleHealthchckMetrics: (autoPatrolScheduleHealthchckMetrics)=>set({
                autoPatrolScheduleHealthchckMetrics: autoPatrolScheduleHealthchckMetrics
            }),
        autoPatrolScheduleHealthchckMetricsUpdatedBoolean: false,
        setAutoPatrolScheduleHealthchckMetricsUpdatedBoolean: (autoPatrolScheduleHealthchckMetricsUpdatedBoolean)=>set({
                autoPatrolScheduleHealthchckMetricsUpdatedBoolean: autoPatrolScheduleHealthchckMetricsUpdatedBoolean
            }),
        updatedAutoPatrolScheduleHealthchckMetricsIds: [],
        setUpdatedAutoPatrolScheduleHealthchckMetricsIds: (updatedAutoPatrolScheduleHealthchckMetricsIds)=>set({
                updatedAutoPatrolScheduleHealthchckMetricsIds: updatedAutoPatrolScheduleHealthchckMetricsIds
            }),
        getAutoPatrolScheduleHealthchckMetrics: async (navigate, scheduleId, finalIndex)=>{
            const { setAutoPatrolScheduleHealthchckMetrics: setAutoPatrolScheduleHealthchckMetrics, autoPatrolScheduleHealthchckMetrics: autoPatrolScheduleHealthchckMetrics } = get();
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().getAutoPatrolScheduleHealthchckMetrics(navigate, scheduleId, finalIndex);
            };
            try {
                const response = await AxiosUI.get(`auto_patrol_metric_healthcheck/by_schedule/${scheduleId}/`);
                const arranged = (0, $aqMJ2.arrangeScheduleHealthMetricsAutopatrol)(response.data);
                const updatedMetrics = {
                    ...autoPatrolScheduleHealthchckMetrics,
                    [scheduleId]: arranged
                };
                // vCHOnlySchedules is now determined in getAutoPatrolSchedules using patrolType
                setAutoPatrolScheduleHealthchckMetrics(updatedMetrics);
                localStorage.setItem("backupAutoPatrolScheduleHealthchckMetrics", JSON.stringify(updatedMetrics));
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
            }
        },
        patchAutoPatrolScheduleHealthchckMetrics: async (navigate, id, activeBoolean, finalIndex, minimumResolutionHeight)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().patchAutoPatrolScheduleHealthchckMetrics(navigate, id, activeBoolean, finalIndex, minimumResolutionHeight);
            };
            const { setBackdropLoadingScreenOnEditingSchedule: setBackdropLoadingScreenOnEditingSchedule, setAutoPatrolScheduleHealthchckMetricsUpdatedBoolean: setAutoPatrolScheduleHealthchckMetricsUpdatedBoolean, setUpdatedAutoPatrolScheduleHealthchckMetricsIds: setUpdatedAutoPatrolScheduleHealthchckMetricsIds, setAutoPatrolScheduleHealthchckMetrics: setAutoPatrolScheduleHealthchckMetrics } = get();
            setBackdropLoadingScreenOnEditingSchedule(true);
            try {
                await AxiosUI.patch(`auto_patrol_metric_healthcheck/${id}/`, {
                    enabled: activeBoolean,
                    minimum_resolution_height: minimumResolutionHeight
                });
                if (finalIndex) {
                    setBackdropLoadingScreenOnEditingSchedule(false);
                    setAutoPatrolScheduleHealthchckMetricsUpdatedBoolean(false);
                    setUpdatedAutoPatrolScheduleHealthchckMetricsIds([]);
                }
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    alert("Problem updating auto patrol schedule health check metrics. Please try again.");
                    setAutoPatrolScheduleHealthchckMetricsUpdatedBoolean(false);
                    setUpdatedAutoPatrolScheduleHealthchckMetricsIds([]);
                    setAutoPatrolScheduleHealthchckMetrics(JSON.parse(localStorage.backupAutoPatrolScheduleHealthchckMetrics));
                    setBackdropLoadingScreenOnEditingSchedule(false);
                });
            }
        },
        getAutoPatrolSchedules: async (navigate, siteId)=>{
            const { setAutoPatrolSchedules: setAutoPatrolSchedules, getAutoPatrolScheduleHealthchckMetrics: getAutoPatrolScheduleHealthchckMetrics, getAutoPatrolCameraProducts: getAutoPatrolCameraProducts } = get();
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().getAutoPatrolSchedules(navigate, siteId);
            };
            try {
                const response = await AxiosUI.get(`auto_patrol_schedule/by_customer/${siteId}/`);
                // Normalize: API may return an array or { results: [...] }
                const rawData = response.data;
                const schedulesArray = Array.isArray(rawData) ? rawData : rawData?.results ?? [];
                // Filter out deleted schedules
                const activeSchedules = schedulesArray.filter((schedule)=>schedule.scheduleStatus !== "Deleted");
                setAutoPatrolSchedules(activeSchedules);
                localStorage.setItem("backupAutoPatrolSchedules", JSON.stringify(activeSchedules));
                // Determine if this is a VCH-only site (no AutoPatrol schedules)
                const hasAPSchedules = activeSchedules.some((schedule)=>schedule.patrolType === "AutoPatrol");
                get().setvCHOnlySchedules(!hasAPSchedules);
                activeSchedules.forEach((schedule, index)=>{
                    getAutoPatrolScheduleHealthchckMetrics(navigate, schedule.id.toString(), activeSchedules.length - 1 === index);
                    if (schedule.patrolType === "AutoPatrol") getAutoPatrolCameraProducts(navigate, schedule.id);
                });
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setAutoPatrolSchedules([]); // Reset to empty array on error
                });
            }
        },
        patchAutoPatrolSchedules: async (navigate, index)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().patchAutoPatrolSchedules(navigate, index);
            };
            const { autoPatrolSchedules: autoPatrolSchedules, setAutoPatrolSchedules: setAutoPatrolSchedules, setBackdropLoadingScreenOnEditingSchedule: setBackdropLoadingScreenOnEditingSchedule, updatedAutoPatrolScheduleIndexes: updatedAutoPatrolScheduleIndexes, setAutoPatrolSchedulesUpdatedBoolean: setAutoPatrolSchedulesUpdatedBoolean, setUpdatedAutoPatrolScheduleIndexes: setUpdatedAutoPatrolScheduleIndexes } = get();
            setBackdropLoadingScreenOnEditingSchedule(true);
            const submittedAutoPatrolSchedule = autoPatrolSchedules[index];
            try {
                await AxiosUI.patch(`auto_patrol_schedule/${submittedAutoPatrolSchedule.id}/`, {
                    sensitivityLevel: submittedAutoPatrolSchedule.sensitivityLevel
                });
                setAutoPatrolSchedulesUpdatedBoolean(false);
                setUpdatedAutoPatrolScheduleIndexes([]);
                if (Number(index) === updatedAutoPatrolScheduleIndexes.length - 1) setBackdropLoadingScreenOnEditingSchedule(false);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    alert("Problem updating auto patrol schedule sensitivity. Please try again.");
                    setAutoPatrolSchedules(JSON.parse(localStorage.backupAutoPatrolSchedules));
                    setAutoPatrolSchedulesUpdatedBoolean(false);
                    setUpdatedAutoPatrolScheduleIndexes([]);
                    setBackdropLoadingScreenOnEditingSchedule(false);
                });
            }
        },
        syncSiteNeeded: false,
        setSyncSiteNeeded: (syncSiteNeeded)=>set({
                syncSiteNeeded: syncSiteNeeded
            }),
        syncPending: false,
        setSyncPending: (syncPending)=>set({
                syncPending: syncPending
            }),
        syncSiteNeededAlertOpen: false,
        setSyncSiteNeededAlertOpen: (syncSiteNeededAlertOpen)=>set({
                syncSiteNeededAlertOpen: syncSiteNeededAlertOpen
            }),
        checkIfSyncNeeded: async (navigate)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const { setSyncSiteNeeded: setSyncSiteNeeded, setSyncSiteNeededAlertOpen: setSyncSiteNeededAlertOpen } = get();
            const retryFunction = ()=>{
                get().checkIfSyncNeeded(navigate);
            };
            try {
                const response = await AxiosUI.get(`customer/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}/about/`);
                if (response.data.settings_deployed === false && response.data.integration_type_name !== "clips") {
                    setSyncSiteNeeded(true);
                    setSyncSiteNeededAlertOpen(true);
                }
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
            }
        },
        resetSiteAboutState: ()=>set({
                siteInfo: {},
                smtpInstructions: "",
                hideUseMotion: false,
                siteAboutAlerts: {
                    scheduleSubmittedAndSiteSynced: false
                },
                healthCheckMetricsData: {
                    connectivity_check: {
                        id: 0,
                        enabled: false,
                        alert_emails: ""
                    },
                    motion_status_check: {
                        id: 0,
                        enabled: false,
                        alert_emails: ""
                    },
                    recording_check: {
                        id: 0,
                        enabled: false,
                        alert_emails: ""
                    },
                    scene_change_check: {
                        id: 0,
                        enabled: false,
                        alert_emails: ""
                    },
                    stream_quality_check: {
                        id: 0,
                        enabled: false,
                        alert_emails: ""
                    },
                    image_quality_check: {
                        id: 0,
                        enabled: false,
                        alert_emails: ""
                    }
                },
                siteSchedules: [],
                schedulesIndex: 0,
                timeRanges: [],
                grid: [],
                duskToDawn: [],
                duskToDawnLocation: [],
                clickedSchedulesTab: "one",
                visibleSchedules: [],
                scheduleGridEditable: false,
                autoPatrolSchedules: [],
                selectedAutoPatrolScheduleIndex: 0,
                autoPatrolFlexIgnoreZonesEnabledBySite: {},
                autoPatrolFlexIgnoreZonesWizardOpenBySite: {},
                autoPatrolFlexIgnoreZonesActiveScheduleIndexBySite: {},
                autoPatrolFlexIgnoreZonesPresetsByCamera: {},
                autoPatrolFlexIgnoreZonesSelectedPresetByScheduleCamera: {},
                autoPatrolFlexIgnoreZonesSelectedCameraIdsBySchedule: {},
                autopatrolCamerasTablePage: 0,
                autopatrolCamerasTableRowsPerPage: 5,
                vmsVariables: [],
                generalInfoTabPatchObject: {},
                generalInfoTabChangesMade: false,
                backdropLoadingScreenOnEditingSchedule: false,
                syncSiteNeeded: false,
                syncPending: false,
                autoPatrolScheduleHealthchckMetrics: {},
                autoPatrolCameraProducts: {},
                updatedProductMetricsIds: {},
                productMetricsWereUpdated: false,
                lineCrossingsData: {},
                presetLineCrossingsData: {},
                lineCrossingsMetricLabels: [],
                activeCameraProducts: {},
                chmOnlyIgnoreZonesByCamera: {},
                cameraStatusById: {},
                ignoreZonesByCamera: {},
                metadataTagZonesByCamera: {},
                rowPrefetchStateByCamera: {},
                activeCameraProductsLoading: {},
                cameraSlice: {},
                cameraIdToStreamIds: {},
                siteMetricsSimplified: [],
                siteMetricsSimplifiedCustomerId: null
            }),
        handleUpdateTimeSchedulesForAddSchedule: (dayOfWeekArray, startTime, endTime, alwaysOn, duskToDawn, bufferTime, duskToDawnLocation)=>{
            const { siteSchedules: siteSchedules, timeRanges: timeRanges, selectedDayInfo: selectedDayInfo, duskToDawnLocation: currentDuskToDawnLocation, setSiteSchedules: setSiteSchedules, setTimeRanges: setTimeRanges, setGrid: setGrid, setMatchingSchedules: setMatchingSchedules, setSelectedDayInfo: setSelectedDayInfo, setDuskToDawnLocation: setDuskToDawnLocation } = get();
            const filterArrays = (arr1, arr2)=>{
                // Add null checks to prevent the filter error
                if (!arr1 || !Array.isArray(arr1)) return [];
                if (!arr2 || !Array.isArray(arr2)) return arr1;
                return arr1.filter((num)=>!arr2.includes(num));
            };
            const updatedStartTime = duskToDawn ? "17:00:00" : startTime;
            const updatedEndTime = duskToDawn ? "08:00:00" : endTime;
            let timeRangeString = "";
            if (!duskToDawn && !alwaysOn) timeRangeString = `${updatedStartTime.slice(0, 5)} - ${updatedEndTime.slice(0, 5)}`;
            if (duskToDawn) timeRangeString = "Dusk to Dawn";
            if (alwaysOn) timeRangeString = "Always On";
            const newSiteScheduleObject = {
                always_on: alwaysOn,
                buffer_time: Number(bufferTime),
                customer: Number((0, $h5bv8.getNumbersAfterAboutSite)(location.href)),
                day_of_week: dayOfWeekArray,
                enabled: true,
                end_time: updatedEndTime,
                is_overide: false,
                location_dusk_dawn: duskToDawn,
                start_time: updatedStartTime
            };
            const updatedSiteSchedules = [
                ...siteSchedules || []
            ];
            // Only process existing schedules if they have the expected structure
            updatedSiteSchedules.forEach((siteSchedule, index)=>{
                if (siteSchedule && siteSchedule.day_of_week && Array.isArray(siteSchedule.day_of_week)) updatedSiteSchedules[index].day_of_week = filterArrays(siteSchedule.day_of_week, dayOfWeekArray);
                else // If the schedule doesn't have the expected structure, remove it
                updatedSiteSchedules.splice(index, 1);
            });
            updatedSiteSchedules.push(newSiteScheduleObject);
            const updatedTimeRanges = [
                ...timeRanges || []
            ];
            updatedTimeRanges.forEach((timeRange, index)=>{
                if (dayOfWeekArray.includes(index)) updatedTimeRanges[index] = timeRangeString;
            });
            // Update duskToDawnLocation array for the affected days
            const updatedDuskToDawnLocation = [
                ...currentDuskToDawnLocation || []
            ];
            dayOfWeekArray.forEach((day)=>{
                if (updatedDuskToDawnLocation[day]) updatedDuskToDawnLocation[day] = [
                    duskToDawn,
                    bufferTime
                ];
            });
            const updatedMatchingSchedules = [];
            updatedSiteSchedules.forEach((siteSchedule)=>{
                if (siteSchedule && siteSchedule.day_of_week && Array.isArray(siteSchedule.day_of_week)) updatedMatchingSchedules.push(siteSchedule.day_of_week);
            });
            // Check the number arrays in updatedMatchingSchedules, and if between all of them any of the numbers 0 through 6 are missing, create a new array with those numbers and push it to updatedMatchingSchedules
            const missingDays = [];
            for(let i = 0; i < 7; i++){
                let found = false;
                updatedMatchingSchedules.forEach((arr)=>{
                    if (arr && arr.includes(i)) found = true;
                });
                if (!found) missingDays.push(i);
            }
            if (missingDays.length > 0) updatedMatchingSchedules.push(missingDays);
            const finalSiteSchedulesArray = [];
            updatedSiteSchedules.forEach((siteSchedule)=>{
                if (siteSchedule && siteSchedule.day_of_week && Array.isArray(siteSchedule.day_of_week) && siteSchedule.day_of_week.length > 0) finalSiteSchedulesArray.push(siteSchedule);
            });
            // Update selectedDayInfo with the new values
            const updatedSelectedDayInfo = {
                ...selectedDayInfo,
                timeRanges: timeRangeString,
                duskToDawn: duskToDawn,
                bufferTime: bufferTime,
                day: selectedDayInfo.day
            };
            setMatchingSchedules(updatedMatchingSchedules);
            setSiteSchedules(finalSiteSchedulesArray);
            setTimeRanges(updatedTimeRanges);
            setDuskToDawnLocation(updatedDuskToDawnLocation);
            setGrid((0, $axLUl.handleConvertSchedulesToBooleanArrays)(finalSiteSchedulesArray));
            setSelectedDayInfo(updatedSelectedDayInfo);
        },
        addSiteWebhookDialogOpen: false,
        setAddSiteWebhookDialogOpen: (addSiteWebhookDialogOpen)=>set({
                addSiteWebhookDialogOpen: addSiteWebhookDialogOpen
            }),
        backupWebhookData: [],
        setBackupWebhookData: (backupWebhookData)=>set({
                backupWebhookData: backupWebhookData
            }),
        metadataTagZones: [],
        setMetadataTagZones: (metadataTagZones)=>set({
                metadataTagZones: metadataTagZones
            }),
        getMetadataTagZones: async (navigate)=>{
            const { setMetadataTagZones: setMetadataTagZones, getMetadataTagZones: getMetadataTagZones } = get();
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                getMetadataTagZones(navigate);
            };
            try {
                const response = await AxiosUI.get(`tagzone/?camera=${(0, $a8BPe.getNumbersAfterEditCamera)(location.href)}`);
                setMetadataTagZones(response.data.results);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
            }
        },
        autoPatrolCameraProducts: {},
        setAutoPatrolCameraProducts: (autoPatrolCameraProducts)=>set({
                autoPatrolCameraProducts: autoPatrolCameraProducts
            }),
        getAutoPatrolCameraProducts: async (navigate, scheduleId)=>{
            const { setAutoPatrolCameraProducts: setAutoPatrolCameraProducts } = get();
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().getAutoPatrolCameraProducts(navigate, scheduleId);
            };
            try {
                const response = await AxiosUI.get(`auto_patrol_product_metric/?schedule=${scheduleId}`);
                // Read the latest state right before updating to avoid race conditions
                const currentState = get().autoPatrolCameraProducts;
                setAutoPatrolCameraProducts({
                    ...currentState,
                    [scheduleId]: response.data.results
                });
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
            }
        },
        activeCameraProducts: {},
        setActiveCameraProducts: (activeCameraProducts)=>set({
                activeCameraProducts: activeCameraProducts
            }),
        activeCameraProductsLoading: {},
        setActiveCameraProductsLoading: (loading)=>set({
                activeCameraProductsLoading: loading
            }),
        setActiveCameraProductsForCamera: (cameraId, products)=>{
            const { activeCameraProducts: activeCameraProducts, setActiveCameraProducts: setActiveCameraProducts } = get();
            setActiveCameraProducts({
                ...activeCameraProducts,
                [cameraId]: products
            });
        },
        chmOnlyIgnoreZonesByCamera: {},
        setChmOnlyIgnoreZonesByCamera: (map)=>set({
                chmOnlyIgnoreZonesByCamera: map
            }),
        setChmOnlyIgnoreZonesForCamera: (cameraId, isChmOnly)=>{
            const { chmOnlyIgnoreZonesByCamera: chmOnlyIgnoreZonesByCamera, setChmOnlyIgnoreZonesByCamera: setChmOnlyIgnoreZonesByCamera } = get();
            setChmOnlyIgnoreZonesByCamera({
                ...chmOnlyIgnoreZonesByCamera,
                [cameraId]: isChmOnly
            });
        },
        getActiveCameraProductsForCamera: async (navigate, cameraId)=>{
            const state = get();
            if (state.activeCameraProducts[cameraId] !== undefined) return;
            if (state.activeCameraProductsLoading[cameraId]) return;
            state.setActiveCameraProductsLoading({
                ...state.activeCameraProductsLoading,
                [cameraId]: true
            });
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().getActiveCameraProductsForCamera(navigate, cameraId);
            };
            try {
                const response = await AxiosUI.get(`/camera/${cameraId}/general_info/`);
                const streams = response.data?.streams;
                const derived = (0, $jUxHc.deriveActiveProductsFromGeneralInfo)(streams);
                get().setActiveCameraProductsForCamera(cameraId, derived);
                const slice = Array.isArray(streams) && streams.some((s)=>s.slice === true);
                get().setCameraSliceForCamera(cameraId, !!slice);
                if (Array.isArray(streams)) {
                    const ids = streams.map((s)=>s.id).filter((id)=>typeof id === "number");
                    get().setCameraStreamIdsForCamera(cameraId, ids);
                }
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
            } finally{
                const s = get();
                const next = {
                    ...s.activeCameraProductsLoading
                };
                delete next[cameraId];
                s.setActiveCameraProductsLoading(next);
            }
        },
        getActiveCameraProductsForAllCameras: async (navigate, cameraIds)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const state = get();
            const toFetch = cameraIds.filter((id)=>state.activeCameraProducts[id] === undefined);
            if (toFetch.length === 0) return;
            const firstId = toFetch[0];
            const loadingEntries = Object.fromEntries(toFetch.map((id)=>[
                    id,
                    true
                ]));
            state.setActiveCameraProductsLoading({
                ...state.activeCameraProductsLoading,
                ...loadingEntries
            });
            for (const cameraId of toFetch)try {
                const response = await AxiosUI.get(`/camera/${cameraId}/general_info/`);
                const streams = response.data?.streams;
                const derived = (0, $jUxHc.deriveActiveProductsFromGeneralInfo)(streams);
                get().setActiveCameraProductsForCamera(cameraId, derived);
                const slice = Array.isArray(streams) && streams.some((s)=>s.slice === true);
                get().setCameraSliceForCamera(cameraId, !!slice);
                if (Array.isArray(streams)) {
                    const ids = streams.map((s)=>s.id).filter((id)=>typeof id === "number");
                    get().setCameraStreamIdsForCamera(cameraId, ids);
                }
                if (cameraId === firstId) (0, $gTuv9.applyImmixSureviewSentinelFromGeneralInfoResponse)(response.data);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, ()=>{
                    get().getActiveCameraProductsForAllCameras(navigate, toFetch);
                }, ()=>{});
            } finally{
                const s = get();
                const next = {
                    ...s.activeCameraProductsLoading
                };
                delete next[cameraId];
                s.setActiveCameraProductsLoading(next);
            }
        },
        cameraIdToStreamIds: {},
        setCameraStreamIdsForCamera: (cameraId, streamIds)=>{
            const { cameraIdToStreamIds: cameraIdToStreamIds } = get();
            set({
                cameraIdToStreamIds: {
                    ...cameraIdToStreamIds,
                    [cameraId]: streamIds
                }
            });
        },
        clearBulkCameraCachesForCameras: (cameraIds)=>{
            const { activeCameraProducts: activeCameraProducts, cameraSlice: cameraSlice, cameraIdToStreamIds: cameraIdToStreamIds, setActiveCameraProducts: setActiveCameraProducts, setCameraSlice: setCameraSlice } = get();
            const nextProducts = {
                ...activeCameraProducts
            };
            const nextSlice = {
                ...cameraSlice
            };
            const nextStreams = {
                ...cameraIdToStreamIds
            };
            cameraIds.forEach((id)=>{
                delete nextProducts[id];
                delete nextSlice[id];
                delete nextStreams[id];
            });
            setActiveCameraProducts(nextProducts);
            setCameraSlice(nextSlice);
            set({
                cameraIdToStreamIds: nextStreams
            });
        },
        siteMetricsSimplified: [],
        siteMetricsSimplifiedCustomerId: null,
        setSiteMetricsSimplifiedData: (rows, customerId)=>set({
                siteMetricsSimplified: rows,
                siteMetricsSimplifiedCustomerId: customerId
            }),
        prefetchSiteMetricsSimplified: async (navigate, customerId)=>{
            if (customerId === null || customerId === undefined) return;
            const parsedCustomerId = typeof customerId === "number" ? customerId : parseInt(String(customerId), 10);
            if (!Number.isFinite(parsedCustomerId)) return;
            const state = get();
            if (state.siteMetricsSimplifiedCustomerId === parsedCustomerId && state.siteMetricsSimplified.length > 0) return;
            try {
                const rows = await (0, $jK0A2.fetchMetricSimplified)(navigate, parsedCustomerId);
                set({
                    siteMetricsSimplified: rows,
                    siteMetricsSimplifiedCustomerId: parsedCustomerId
                });
            } catch  {
            // Bulk and onboarding flows have their own fallbacks if this prefetch fails.
            }
        },
        refreshActiveCameraProductsFromSimplifiedEndpoint: async (navigate, customerId, cameraIds)=>{
            const rows = await (0, $jK0A2.fetchMetricSimplified)(navigate, customerId);
            const parsedCustomerId = typeof customerId === "number" ? customerId : parseInt(String(customerId), 10);
            set({
                siteMetricsSimplified: rows,
                siteMetricsSimplifiedCustomerId: Number.isFinite(parsedCustomerId) ? parsedCustomerId : null
            });
            cameraIds.forEach((id)=>{
                get().setActiveCameraProductsForCamera(id, (0, $innfN.activeProductsDisplayRecordFromSimplifiedRows)(rows, id));
            });
        },
        prefetchBulkDialogActiveCameraProducts: async (navigate, customerId, cameraIds)=>{
            if (cameraIds.length === 0) return;
            const loadingEntries = Object.fromEntries(cameraIds.map((id)=>[
                    id,
                    true
                ]));
            const state = get();
            state.setActiveCameraProductsLoading({
                ...state.activeCameraProductsLoading,
                ...loadingEntries
            });
            if (customerId !== undefined && customerId !== null) try {
                const rows = await (0, $jK0A2.fetchMetricSimplified)(navigate, customerId);
                set({
                    siteMetricsSimplified: rows,
                    siteMetricsSimplifiedCustomerId: customerId
                });
                cameraIds.forEach((camId)=>{
                    const hasRow = rows.some((r)=>Number(r.camera?.id) === camId);
                    if (hasRow) {
                        get().setActiveCameraProductsForCamera(camId, (0, $innfN.activeProductsDisplayRecordFromSimplifiedRows)(rows, camId));
                        const nextLoading = {
                            ...get().activeCameraProductsLoading
                        };
                        delete nextLoading[camId];
                        get().setActiveCameraProductsLoading(nextLoading);
                    }
                });
            } catch  {
            // Fall through: general_info for cameras still missing below.
            }
            const stillNeed = cameraIds.filter((id)=>get().activeCameraProducts[id] === undefined);
            if (stillNeed.length > 0) await get().getActiveCameraProductsForAllCameras(navigate, stillNeed);
        },
        cameraSlice: {},
        setCameraSlice: (cameraSlice)=>set({
                cameraSlice: cameraSlice
            }),
        setCameraSliceForCamera: (cameraId, slice)=>{
            const { cameraSlice: cameraSlice, setCameraSlice: setCameraSlice } = get();
            setCameraSlice({
                ...cameraSlice,
                [cameraId]: slice
            });
        },
        updatedProductMetricsIds: {},
        setUpdatedProductMetricsIds: (updatedProductMetricsIds)=>set({
                updatedProductMetricsIds: updatedProductMetricsIds
            }),
        productMetricsWereUpdated: false,
        setProductMetricsWereUpdated: (productMetricsWereUpdated)=>set({
                productMetricsWereUpdated: productMetricsWereUpdated
            }),
        updateScheduleProducts: async (productId, enabled, scheduleId, navigate)=>{
            const { autoPatrolCameraProducts: autoPatrolCameraProducts, setAutoPatrolCameraProducts: setAutoPatrolCameraProducts } = get();
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().updateScheduleProducts(productId, enabled, scheduleId, navigate);
            };
            try {
                await AxiosUI.patch(`auto_patrol_product_metric/${productId}/`, {
                    enabled: enabled
                });
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    // Revert the enabled value in autoPatrolCameraProducts on failure
                    const scheduleProducts = autoPatrolCameraProducts[scheduleId] || [];
                    const revertedProducts = scheduleProducts.map((p)=>p.id === productId ? {
                            ...p,
                            enabled: !enabled
                        } : p);
                    setAutoPatrolCameraProducts({
                        ...autoPatrolCameraProducts,
                        [scheduleId]: revertedProducts
                    });
                    alert("Problem updating schedule products for auto patrol schedule. Please try again.");
                });
            }
        },
        lineCrossingsData: {},
        setLineCrossingsData: (lineCrossingsData)=>set({
                lineCrossingsData: lineCrossingsData
            }),
        lineCrossingsMetricLabels: [],
        setLineCrossingsMetricLabels: (lineCrossingsMetricLabels)=>set({
                lineCrossingsMetricLabels: lineCrossingsMetricLabels
            }),
        getLineCrossingsData: async (navigate, cameraId)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const { setLineCrossingsData: setLineCrossingsData, setLineCrossingsMetricLabels: setLineCrossingsMetricLabels, getLineCrossingsData: getLineCrossingsData } = get();
            const retryFunction = ()=>{
                getLineCrossingsData(navigate, cameraId);
            };
            try {
                // Fetch line crossings and metrics concurrently; use allSettled so metrics
                // failure doesn't prevent showing line crossings (e.g. /metric/ can fail or
                // return a different shape while /line_crossing/ still returns data).
                // Default (camera-wide) lines only: `preset__isnull=true` keeps
                // preset-scoped lines out of the camera-wide preview (ENG-1610).
                const [lineCrossingsSettled, metricsSettled] = await Promise.allSettled([
                    AxiosUI.get((0, $2wOL1.buildLineCrossingsListPath)(cameraId)),
                    AxiosUI.get(`/metric/?camera_id=${cameraId}`)
                ]);
                if (lineCrossingsSettled.status === "rejected") {
                    (0, $3Zv1D.universalAPIErrorHandler)(lineCrossingsSettled.reason, navigate, retryFunction, ()=>{
                        console.warn("Failed to load line crossings data");
                    });
                    return;
                }
                const lineCrossingsResponse = lineCrossingsSettled.value;
                // Set metric labels only if metrics request succeeded and has expected shape
                const allowedLabels = [
                    "intruder_line_crossing",
                    "vehicle_line_crossing",
                    "bike_line_crossing"
                ];
                let filteredMetrics = [];
                if (metricsSettled.status === "fulfilled") {
                    const results = metricsSettled.value?.data?.results;
                    if (Array.isArray(results)) filteredMetrics = results.filter((metric)=>allowedLabels.includes(metric.label_name)).map((metric)=>({
                            id: metric.label,
                            name: metric.label_name,
                            display_name: metric.label_name,
                            order: 0
                        }));
                }
                setLineCrossingsMetricLabels(filteredMetrics);
                // Process line crossings - assign colors to each line
                const processedLines = $05b20e7d3e25d0ab$export$65f078c9509696a0(lineCrossingsResponse.data);
                // Merge this camera's data into existing state so other cameras' data is preserved
                const current = get().lineCrossingsData;
                setLineCrossingsData({
                    ...current,
                    [cameraId]: processedLines
                });
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    console.warn("Failed to load line crossings data");
                });
            }
        },
        presetLineCrossingsData: {},
        getPresetLineCrossingsData: async (navigate, cameraId, presetId)=>{
            if (get().presetLineCrossingsData[cameraId]?.[presetId]) return; // cached per camera+preset; the row re-renders often
            const inFlightKey = `${cameraId}:${presetId}`;
            if ($05b20e7d3e25d0ab$var$presetLineCrossingsInFlight.has(inFlightKey)) return;
            $05b20e7d3e25d0ab$var$presetLineCrossingsInFlight.add(inFlightKey);
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().getPresetLineCrossingsData(navigate, cameraId, presetId);
            };
            try {
                const response = await AxiosUI.get((0, $2wOL1.buildLineCrossingsListPath)(cameraId, presetId));
                const processedLines = $05b20e7d3e25d0ab$export$65f078c9509696a0(response.data);
                set((state)=>({
                        presetLineCrossingsData: {
                            ...state.presetLineCrossingsData,
                            [cameraId]: {
                                ...state.presetLineCrossingsData[cameraId] || {},
                                [presetId]: processedLines
                            }
                        }
                    }));
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    console.warn("Failed to load preset line crossings data");
                });
            } finally{
                $05b20e7d3e25d0ab$var$presetLineCrossingsInFlight.delete(inFlightKey);
            }
        },
        checkForEvalinkSiteId: async (siteId, navigate)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const { setEvalinkSiteId: setEvalinkSiteId, checkForEvalinkSiteId: checkForEvalinkSiteId, setEvalinkSite: setEvalinkSite, getEvalinkData: getEvalinkData } = get();
            const retryFunction = ()=>{
                checkForEvalinkSiteId(siteId, navigate);
            };
            setEvalinkSite(false);
            try {
                const response = await AxiosUI.get(`customer/${siteId}/`);
                const customer = response.data;
                if (customer.evalinksite) {
                    setEvalinkSite(true);
                    setEvalinkSiteId(customer.evalinksite);
                    getEvalinkData(navigate);
                }
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
            }
        },
        evalinkSite: false,
        setEvalinkSite: (evalinkSite)=>set({
                evalinkSite: evalinkSite
            }),
        evalinkData: {},
        setEvalinkData: (evalinkData)=>set({
                evalinkData: evalinkData
            }),
        getEvalinkData: async (navigate)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const { setEvalinkData: setEvalinkData, getEvalinkData: getEvalinkData, setEvalinkPatchObject: setEvalinkPatchObject, evalinkSiteId: evalinkSiteId } = get();
            const retryFunction = ()=>{
                getEvalinkData(navigate);
            };
            try {
                const response = await AxiosUI.get(`evalink-site/${evalinkSiteId}/`);
                setEvalinkData(response.data);
                setEvalinkPatchObject({
                    evalink_token: response.data.evalink_token,
                    evalink_device_id: response.data.evalink_device_id,
                    evalink_company_id: response.data.evalink_company_id
                });
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
            }
        },
        evalinkChangesMade: false,
        setEvalinkChangesMade: (evalinkChangesMade)=>set({
                evalinkChangesMade: evalinkChangesMade
            }),
        evalinkPatchObject: {
            evalink_token: "",
            evalink_device_id: "",
            evalink_company_id: ""
        },
        setEvalinkPatchObject: (evalinkPatchObject)=>set({
                evalinkPatchObject: evalinkPatchObject
            }),
        evalinkSiteId: 0,
        setEvalinkSiteId: (evalinkSiteId)=>set({
                evalinkSiteId: evalinkSiteId
            }),
        handlePatchEvalink: async (navigate, setBackdropLoadingScreenOn, setEditMode, onSuccess)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const { evalinkPatchObject: evalinkPatchObject, setEvalinkPatchObject: setEvalinkPatchObject, setEvalinkChangesMade: setEvalinkChangesMade, evalinkSiteId: evalinkSiteId, handlePatchEvalink: handlePatchEvalink, setEvalinkData: setEvalinkData, evalinkData: evalinkData } = get();
            const retryFunction = ()=>{
                handlePatchEvalink(navigate, setBackdropLoadingScreenOn, setEditMode, onSuccess);
            };
            try {
                const response = await AxiosUI.patch(`evalink-site/${evalinkSiteId}/`, evalinkPatchObject);
                // PATCH returns the single updated resource in response.data (no .results wrapper)
                const updated = response.data;
                setEvalinkPatchObject({
                    evalink_token: updated.evalink_token,
                    evalink_device_id: updated.evalink_device_id,
                    evalink_company_id: updated.evalink_company_id
                });
                setEvalinkData(updated);
                setEvalinkChangesMade(false);
                setBackdropLoadingScreenOn(false);
                setEditMode(false);
                onSuccess?.();
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setEvalinkPatchObject({
                        evalink_token: evalinkData.evalink_token,
                        evalink_device_id: evalinkData.evalink_device_id,
                        evalink_company_id: evalinkData.evalink_company_id
                    });
                    alert("Problem updating evalink data. Please try again.");
                    setBackdropLoadingScreenOn(false);
                });
            }
        }
    }));

});
parcelRegister("dIPZj", function(module, exports) {

$parcel$export(module.exports, "concurrentAPIErrorHandler", () => $cf815debe15e9314$export$4938fa64d5f43f02);
/* eslint-disable no-console */ 
var $5BK6w = parcelRequire("5BK6w");

var $jfsqs = parcelRequire("jfsqs");

var $aYdit = parcelRequire("aYdit");

var $ebTQj = parcelRequire("ebTQj");
// Safety timeout duration for clearing the refresh flag (in milliseconds)
const $cf815debe15e9314$var$REFRESH_FLAG_TIMEOUT = 15000; // 15 seconds
// Delay before retrying if another refresh is in progress (in milliseconds)
const $cf815debe15e9314$var$RETRY_DELAY_MS = 1500; // 1.5 seconds
/** Returns the response body as a string for safe .includes() checks. */ function $cf815debe15e9314$var$getResponseBodyString(reason) {
    try {
        const data = reason.response?.data;
        if (data !== undefined && data !== null) return typeof data === "string" ? data : JSON.stringify(data);
        const req = reason.request;
        return req?.response ?? "";
    } catch  {
        return "";
    }
}
const $cf815debe15e9314$export$4938fa64d5f43f02 = (reason, navigate, retryFunction, errorHandlingFunction)=>{
    const token = (0, $5BK6w.getCookie)("token");
    const refreshToken = (0, $5BK6w.getCookie)("token_secret");
    // Get store state and actions
    const refreshingToken = (0, $aYdit.useAppStore).getState().refreshingToken;
    const setRefreshingToken = (0, $aYdit.useAppStore).getState().setRefreshingToken;
    // Log the error for debugging
    (0, $ebTQj.logger).error("API Error:", reason.message);
    // --- Handle 403 token errors BEFORE offline check ---
    if (reason.response?.status === 403) {
        const body = $cf815debe15e9314$var$getResponseBodyString(reason);
        const isTokenErrorBody = body.includes("SocialToken matching query does not exist") || body.includes("Returned invalid token from cache") || body.includes("Token is expired") || body.includes("Token not found") || Boolean(!token && refreshToken) === true;
        if (isTokenErrorBody) {
            if (refreshingToken) {
                (0, $ebTQj.logger).log("Token refresh already in progress...");
                return;
            }
            (0, $ebTQj.logger).log("Initiating token refresh (403)...");
            setRefreshingToken(true);
            (0, $jfsqs.getRefreshTokenWhenConcurrentAPICalls)(navigate, retryFunction);
            setTimeout(()=>{
                if ((0, $aYdit.useAppStore).getState().refreshingToken) {
                    (0, $ebTQj.logger).warn("Token refresh flag (403) cleanup timeout reached.");
                    setRefreshingToken(false);
                }
            }, $cf815debe15e9314$var$REFRESH_FLAG_TIMEOUT);
            return;
        }
    }
    // --- Check browser online status (after 403 token handling) ---
    if (!navigator.onLine) {
        (0, $ebTQj.logger).log("Browser is offline. Redirecting to /no-internet");
        if (window.location.pathname !== "/no-internet") navigate("/no-internet", {
            replace: true
        });
        if (errorHandlingFunction) errorHandlingFunction();
        return;
    }
    if (reason.response) {
        const status = reason.response.status;
        if (status === 403) {
            (0, $ebTQj.logger).log("Network Error - Connection issue detected");
            // --- Specific Token Error Handling ---
            const body = $cf815debe15e9314$var$getResponseBodyString(reason);
            if (body.includes("SocialToken matching query does not exist") || body.includes("Returned invalid token from cache") || body.includes("Token is expired") || body.includes("Token not found") || Boolean(!token && refreshToken) === true) {
                // Check if refresh is already in progress
                if (refreshingToken) {
                    (0, $ebTQj.logger).log("Token refresh already in progress...");
                    // setTimeout(retryFunction, RETRY_DELAY_MS); // Wait and retry
                    return;
                }
                // Initiate refresh
                (0, $ebTQj.logger).log("Initiating token refresh (403)...");
                setRefreshingToken(true);
                (0, $jfsqs.getRefreshTokenWhenConcurrentAPICalls)(navigate, retryFunction);
                // Safety timeout to clear the flag
                setTimeout(()=>{
                    if ((0, $aYdit.useAppStore).getState().refreshingToken) {
                        (0, $ebTQj.logger).warn("Token refresh flag (403) cleanup timeout reached.");
                        setRefreshingToken(false);
                    }
                }, $cf815debe15e9314$var$REFRESH_FLAG_TIMEOUT);
                return; // Stop processing this error further in this handler
            }
            // --- End Specific Token Error Handling ---
            // Implement retry logic for transient network issues (non-token 403s)
            const retryCount = parseInt(localStorage.getItem("networkErrorRetryCount") || "0");
            if (retryCount < 3) {
                localStorage.setItem("networkErrorRetryCount", (retryCount + 1).toString());
                (0, $ebTQj.logger).log(`Retrying request (${retryCount + 1}/3)...`);
                setTimeout(()=>{
                    retryFunction();
                }, 1000 * Math.pow(2, retryCount));
                return;
            }
            // Reset retry counter after max attempts
            localStorage.setItem("networkErrorRetryCount", "0");
            // Only redirect to no-internet when the browser is actually offline (!navigator.onLine).
            // Do not redirect for 403 or empty response — those are auth/server issues, not connectivity.
            if (errorHandlingFunction) errorHandlingFunction();
        } else if (status === 401) {
            // Unauthorized - token issues
            // Check if refresh is already in progress
            if (refreshingToken) {
                (0, $ebTQj.logger).log("Token refresh already in progress, retrying shortly...");
                setTimeout(retryFunction, $cf815debe15e9314$var$RETRY_DELAY_MS); // Wait and retry
                return;
            }
            // Initiate refresh
            (0, $ebTQj.logger).log("Initiating token refresh (401)...");
            setRefreshingToken(true);
            (0, $jfsqs.getRefreshTokenWhenConcurrentAPICalls)(navigate, retryFunction);
            // Safety timeout to clear the flag
            setTimeout(()=>{
                if ((0, $aYdit.useAppStore).getState().refreshingToken) {
                    (0, $ebTQj.logger).warn("Token refresh flag (401) cleanup timeout reached.");
                    setRefreshingToken(false);
                }
            }, $cf815debe15e9314$var$REFRESH_FLAG_TIMEOUT);
            return; // Stop processing this error further in this handler
        } else if (status >= 500) {
            // Server errors - don't retry, just handle the error
            if (errorHandlingFunction) errorHandlingFunction();
            return;
        } else if (status === 404) // Resource not found
        {
            if (errorHandlingFunction) errorHandlingFunction();
        } else if (status === 429) {
            // Rate limiting
            (0, $ebTQj.logger).log("429 - Too many requests. Retrying after: 30 seconds");
            setTimeout(()=>{
                retryFunction();
            }, 30000);
            if (errorHandlingFunction) errorHandlingFunction();
        } else {
            // Handle other status codes
            if (reason.response?.data && typeof reason.response.data === "object" && "group" in reason.response.data) (0, $ebTQj.logger).log(`Error: ${reason.response.data.group?.[0]}`);
            else (0, $ebTQj.logger).log("Error: Unable to retrieve specific error details. Running error handling functionality.");
            if (errorHandlingFunction) errorHandlingFunction();
        }
    } else {
        // Fallback for non-response errors (e.g., request setup, network timeout before response)
        (0, $ebTQj.logger).log(`Unhandled Error: ${reason}`);
        if (errorHandlingFunction) errorHandlingFunction();
    }
};

});
parcelRegister("jfsqs", function(module, exports) {

$parcel$export(module.exports, "getRefreshTokenWhenConcurrentAPICalls", () => $d43dd86e2e0e07ee$export$17111e28fb774e1d);

var $5BK6w = parcelRequire("5BK6w");

var $iJyAr = parcelRequire("iJyAr");

var $9BnvG = parcelRequire("9BnvG");

var $aYdit = parcelRequire("aYdit");

var $ebTQj = parcelRequire("ebTQj");


const $d43dd86e2e0e07ee$export$17111e28fb774e1d = async (navigate, retryFunction)=>{
    const ActuateUI = (0, $9BnvG.createRefreshApi)(``);
    const refreshToken = (0, $5BK6w.getCookie)("token_secret");
    const cookies = new (0, $iJyAr.default)();
    const article = {
        refresh_token: refreshToken
    };
    if (refreshToken) {
        const setRefreshingToken = (0, $aYdit.useAppStore).getState().setRefreshingToken;
        await ActuateUI.post(`/auth/refresh/`, article).then(async (response)=>{
            const apiResponse = response.data;
            cookies.set("token", apiResponse.token, {
                path: "/",
                maxAge: 3600
            });
            localStorage.setItem(`token`, apiResponse.token);
            cookies.set("token_secret", apiResponse.token_secret, {
                path: "/"
            });
            localStorage.setItem(`token_secret`, apiResponse.token_secret);
            localStorage.setItem("tokenRefreshing", "false");
            setRefreshingToken(false);
            if (retryFunction) retryFunction();
        }).catch((err)=>{
            (0, $ebTQj.logger).log(err);
            localStorage.removeItem("loggedIn");
            localStorage.setItem("tokenRefreshing", "false");
            setRefreshingToken(false);
            // Redirect to Cognito instead of /login
            Promise.resolve((parcelRequire("ax3yI"))).then(({ handleRedirect: handleRedirect })=>{
                handleRedirect();
            });
        });
    } else {
        localStorage.setItem("tokenRefreshing", "false");
        localStorage.removeItem("loggedIn");
        // Redirect to Cognito instead of /login
        Promise.resolve((parcelRequire("ax3yI"))).then(({ handleRedirect: handleRedirect })=>{
            handleRedirect();
        });
    }
};

});
parcelRegister("9BnvG", function(module, exports) {

$parcel$export(module.exports, "createRefreshApi", () => $9d2b50839fbe1d8c$export$87f4790a6b130659);

var $7pFvC = parcelRequire("7pFvC");

var $5BK6w = parcelRequire("5BK6w");

var $2LUuS = parcelRequire("2LUuS");
const $9d2b50839fbe1d8c$export$87f4790a6b130659 = (path)=>{
    const baseURL = (0, $2LUuS.getApiUrl)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($7pFvC))).create({
        baseURL: `${baseURL}api/${path}`,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${(0, $5BK6w.getCookie)("token_secret")}`
        }
    });
};

});

parcelRegister("aYdit", function(module, exports) {

$parcel$export(module.exports, "useAppStore", () => $7fa24e31f0169544$export$35cd30506bcba883);

var $9OjAn = parcelRequire("9OjAn");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");

var $ebTQj = parcelRequire("ebTQj");
// Get the initial date format preference from localStorage or default to true (MM/DD/YYYY)
const $7fa24e31f0169544$var$getInitialDateFormat = ()=>{
    const userStorage = JSON.parse(localStorage.getItem("userStorage") || "{}");
    if (userStorage?.data?.alert_date_format) {
        if (userStorage.data.alert_date_format === "DD/MM/YYYY") return false;
        if (userStorage.data.alert_date_format === "MM/DD/YYYY") return true;
        return true;
    } else return true;
};
const $7fa24e31f0169544$export$35cd30506bcba883 = (0, $9OjAn.create)((set, get)=>({
        refreshingToken: false,
        setRefreshingToken: (refreshingToken)=>set({
                refreshingToken: refreshingToken
            }),
        backdropLoadingScreenRefreshTokenOn: false,
        setBackdropLoadingScreenRefreshTokenOn: (backdropLoadingScreenRefreshTokenOn)=>set({
                backdropLoadingScreenRefreshTokenOn: backdropLoadingScreenRefreshTokenOn
            }),
        updateUserStorageDateFormat: async (navigate, formatBoolean)=>{
            const AxiosUI = (0, $195EM.createApi)("");
            const retryFunction = ()=>{
                get().updateUserStorageDateFormat(navigate, formatBoolean);
            };
            const newDateFormat = formatBoolean ? "MM/DD/YYYY" : "DD/MM/YYYY";
            try {
                const response = await AxiosUI.patch("storage/user/", {
                    data: {
                        alert_date_format: newDateFormat
                    }
                });
                localStorage.setItem("userStorage", JSON.stringify(response.data));
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
            }
        },
        dateMMDDYYYY: $7fa24e31f0169544$var$getInitialDateFormat(),
        setDateMMDDYYYY: (dateMMDDYYYY)=>{
            set({
                dateMMDDYYYY: dateMMDDYYYY
            });
        },
        userPermissions: {
            ailink: false,
            ailink_index: false,
            sentinel: false,
            smtp: false,
            chm: false,
            arm_disarm: false,
            add_cameras: false,
            edit_cameras: false,
            delete_cameras: false,
            manage_users: false,
            product_requirements: false,
            flex_schedule: false,
            view_empty_group: false,
            super_user: false,
            view_analytics: false,
            view_alerts: false,
            view_passwords: false,
            // Genetec direct video source: per-camera connection fields. Declared
            // from /user/info/; no route is gated on it yet.
            direct_camera_access: false,
            alert_muting: false,
            live_streaming: false,
            create_wireguard_tunnels: false,
            patrol_only: false,
            // ENG-1816: View Only screen list from /user/info/; empty = View All.
            visible_screens: []
        },
        setUserPermissions: (userPermissions)=>set({
                userPermissions: userPermissions
            }),
        navigatedToAlertsFromAnalytics: false,
        setNavigatedToAlertsFromAnalytics: (navigatedToAlertsFromAnalytics)=>set({
                navigatedToAlertsFromAnalytics: navigatedToAlertsFromAnalytics
            }),
        wireGuardOptions: [],
        setWireGuardOptions: (wireGuardOptions)=>set({
                wireGuardOptions: wireGuardOptions
            }),
        getWireGuardOptions: async (navigate)=>{
            const AxiosUI = (0, $195EM.createApi)("");
            try {
                const response = await AxiosUI.get("wireguard/");
                set({
                    wireGuardOptions: response.data.results
                });
            } catch (reason) {
                // WireGuard options are non-critical (used only for Site About). Do not
                // call universalAPIErrorHandler here—it can redirect to /no-internet
                // and would incorrectly send users there on login when this runs before
                // auth is ready or when the request fails transiently.
                (0, $ebTQj.logger).warn("Failed to load WireGuard options, leaving list empty:", reason);
            }
        },
        groupTrees: undefined,
        setGroupTrees: (groupTrees)=>set({
                groupTrees: groupTrees
            }),
        groupTreesPatrolOnly: undefined,
        setGroupTreesPatrolOnly: (groupTreesPatrolOnly)=>set({
                groupTreesPatrolOnly: groupTreesPatrolOnly
            })
    }));

});
parcelRegister("3Zv1D", function(module, exports) {

$parcel$export(module.exports, "universalAPIErrorHandler", () => $4980b9e799534519$export$7ee2461cb75cec46);
/* eslint-disable no-console */ 
var $aK4Bb = parcelRequire("aK4Bb");

var $5BK6w = parcelRequire("5BK6w");

var $ebTQj = parcelRequire("ebTQj");

var $1BWfV = parcelRequire("1BWfV");

var $ax3yI = parcelRequire("ax3yI");
// Helper function to debounce alerts - Keep this for non-network errors
const $4980b9e799534519$var$showDebouncedAlert = (message, alertType, debounceTime = 5000)=>{
    const now = Date.now();
    const lastAlertTime = parseInt(localStorage.getItem(`lastAlert_${alertType}`) || "0");
    // Only show alert if enough time has passed since the last one of this type
    if (now - lastAlertTime > debounceTime) {
        localStorage.setItem(`lastAlert_${alertType}`, now.toString());
        alert(message);
    }
};
/** Returns the response body as a string for safe .includes() checks. Prefers reason.response.data, fallback to reason.request.response. */ function $4980b9e799534519$var$getResponseBodyString(reason) {
    try {
        if (reason.response?.data != null) return typeof reason.response.data === "string" ? reason.response.data : JSON.stringify(reason.response.data);
        const req = reason.request;
        if (req?.response != null && typeof req.response === "string") return req.response;
    } catch  {
    // ignore
    }
    return "";
}
const $4980b9e799534519$export$5a50d563d76d42e5 = {
    "View Only users can view but not make changes.": "Your account is view only, so this change wasn't saved. Ask your administrator if you need to make changes.",
    "You do not have permission to perform this action.": "You don't have permission to do this. Ask your administrator if you need access.",
    // actuate_admin's group-user grant guard (ENG-1326): shown as written.
    "You can only grant permissions and access levels that you hold yourself, and cannot edit your own account": "You can only grant permissions and access levels that you hold yourself, and you can't edit your own account. Ask another administrator to make this change."
};
/**
 * Only a denied WRITE gets the dialog. Pages fire many reads on open (Edit
 * Camera alone makes a dozen) and a level that may not read one of them is
 * routine, not something the user can act on; before ENG-1975 those denials
 * were silent and the page still worked (SUP-688, ENG-2014). GET 403s take the
 * old path below: retry, then the caller's own handler.
 */ const $4980b9e799534519$var$isReadRequest = (reason)=>String(reason.config?.method ?? "").toLowerCase() === "get";
const $4980b9e799534519$var$permissionDeniedMessage = (reason)=>{
    if ($4980b9e799534519$var$isReadRequest(reason)) return null;
    const data = reason.response?.data;
    const detail = typeof data?.detail === "string" ? data.detail : null;
    return detail && $4980b9e799534519$export$5a50d563d76d42e5[detail] || null;
};
const $4980b9e799534519$export$7ee2461cb75cec46 = (reason, navigate, retryFunction, errorHandlingFunction)=>{
    const token = (0, $5BK6w.getCookie)("token");
    const refreshToken = (0, $5BK6w.getCookie)("token_secret");
    // Log the error for debugging
    (0, $ebTQj.logger).error("API Error:", reason.message);
    // --- Handle 403 token errors BEFORE offline check so we always refresh when we can ---
    if (reason.response?.status === 403) {
        // A permission denial is final: tell the user once and stop.
        const denied = $4980b9e799534519$var$permissionDeniedMessage(reason);
        if (denied) {
            $4980b9e799534519$var$showDebouncedAlert(denied, "permission_denied");
            if (errorHandlingFunction) errorHandlingFunction();
            return;
        }
        const body = $4980b9e799534519$var$getResponseBodyString(reason);
        if (body.includes("Invalid token")) {
            const refreshTokenForInvalid = (0, $5BK6w.getCookie)("token_secret");
            if (refreshTokenForInvalid) {
                (0, $ebTQj.logger).info("Attempting token refresh in background");
                localStorage.setItem("tokenRefreshing", "true");
                (0, $aK4Bb.getRefreshToken)(navigate, ()=>{
                    (0, $ebTQj.logger).info("Token refresh successful, retrying original request");
                    localStorage.setItem("tokenRefreshing", "false");
                    if (retryFunction) retryFunction();
                });
                return;
            }
            (0, $ebTQj.logger).warn("No refresh token available, redirecting to Cognito");
            (0, $1BWfV.authStateManager).clearAuthState();
            const currentPath = window.location.pathname + window.location.search + window.location.hash;
            localStorage.setItem("redirectURL", currentPath);
            (0, $ax3yI.handleRedirect)();
            return;
        }
        const isTokenErrorBody = body.includes("SocialToken matching query does not exist") || body.includes("Returned invalid token from cache") || body.includes("Token is expired") || body.includes("Token not found") || Boolean(!token && refreshToken) === true;
        if (isTokenErrorBody) {
            const isInAuthFlow = window.location.pathname.includes("/callback");
            if (isInAuthFlow) {
                (0, $ebTQj.logger).info("In authentication flow, skipping token refresh");
                return;
            }
            if (refreshToken) {
                (0, $ebTQj.logger).info("Token refresh needed, attempting refresh");
                localStorage.setItem("tokenRefreshing", "true");
                (0, $aK4Bb.getRefreshToken)(navigate, retryFunction);
                return;
            }
            (0, $ebTQj.logger).warn("No refresh token available, redirecting to Cognito");
            (0, $1BWfV.authStateManager).clearAuthState();
            const currentPath = window.location.pathname + window.location.search + window.location.hash;
            localStorage.setItem("redirectURL", currentPath);
            (0, $ax3yI.handleRedirect)();
            return;
        }
    }
    // --- Check browser online status (after 403 token handling) ---
    if (!navigator.onLine) {
        (0, $ebTQj.logger).log("Browser is offline. Redirecting to /no-internet");
        if (window.location.pathname !== "/no-internet") navigate("/no-internet", {
            replace: true
        });
        if (errorHandlingFunction) errorHandlingFunction({
            offline: true
        });
        return;
    }
    if (reason.response) {
        // Handle specific HTTP error status codes
        const status = reason.response.status;
        if (status === 403) {
            (0, $ebTQj.logger).log("Network Error - Connection issue detected");
            const body = $4980b9e799534519$var$getResponseBodyString(reason);
            if (body.includes("Invalid token")) {
                // Check if we have a refresh token available
                const refreshToken = (0, $5BK6w.getCookie)("token_secret");
                if (refreshToken) {
                    (0, $ebTQj.logger).info("Attempting token refresh in background");
                    localStorage.setItem("tokenRefreshing", "true");
                    // Try to refresh the token
                    (0, $aK4Bb.getRefreshToken)(navigate, ()=>{
                        (0, $ebTQj.logger).info("Token refresh successful, retrying original request");
                        localStorage.setItem("tokenRefreshing", "false");
                        if (retryFunction) retryFunction();
                    });
                    return;
                } else {
                    (0, $ebTQj.logger).warn("No refresh token available, redirecting to Cognito");
                    // Clear all auth state and redirect to Cognito
                    (0, $1BWfV.authStateManager).clearAuthState();
                    // Store only the path portion for security and proper handling
                    const currentPath = window.location.pathname + window.location.search + window.location.hash;
                    localStorage.setItem("redirectURL", currentPath);
                    (0, $ax3yI.handleRedirect)();
                    return;
                }
            }
            if (body.includes("SocialToken matching query does not exist") || body.includes("Returned invalid token from cache") || body.includes("Token is expired") || body.includes("Token not found") || Boolean(!token && refreshToken) === true) {
                // Check if we're in the middle of authentication flow (Callback)
                const isInAuthFlow = window.location.pathname.includes("/callback");
                if (isInAuthFlow) {
                    (0, $ebTQj.logger).info("In authentication flow, skipping token refresh");
                    return;
                }
                if (refreshToken) {
                    (0, $ebTQj.logger).info("Token refresh needed, attempting refresh");
                    localStorage.setItem("tokenRefreshing", "true");
                    (0, $aK4Bb.getRefreshToken)(navigate, retryFunction);
                    return;
                } else {
                    (0, $ebTQj.logger).warn("No refresh token available, redirecting to Cognito");
                    (0, $1BWfV.authStateManager).clearAuthState();
                    // Store only the path portion for security and proper handling
                    const currentPath = window.location.pathname + window.location.search + window.location.hash;
                    localStorage.setItem("redirectURL", currentPath);
                    (0, $ax3yI.handleRedirect)();
                    return;
                }
            }
            // Implement retry logic for transient network issues
            const retryCount = parseInt(localStorage.getItem("networkErrorRetryCount") || "0");
            if (retryCount < 3) {
                localStorage.setItem("networkErrorRetryCount", (retryCount + 1).toString());
                (0, $ebTQj.logger).log(`Retrying request (${retryCount + 1}/3)...`);
                // Wait before retrying (exponential backoff)
                setTimeout(()=>{
                    retryFunction();
                    (0, $ebTQj.logger).log("power of 2", 1000 * Math.pow(2, retryCount));
                }, 1000 * Math.pow(2, retryCount));
                return;
            }
            // Reset retry counter after max attempts
            localStorage.setItem("networkErrorRetryCount", "0");
            // Only redirect to no-internet when the browser is actually offline (!navigator.onLine).
            // Do not redirect for 403 or empty response — those are auth/server issues, not connectivity.
            if (errorHandlingFunction) errorHandlingFunction();
        } else if (status === 401) {
            // Unauthorized - token issues
            localStorage.setItem("tokenRefreshing", "true");
            (0, $aK4Bb.getRefreshToken)(navigate, retryFunction);
        } else if (status >= 500) {
            // Server errors
            // Server errors - don't retry, just handle the error
            // showDebouncedAlert(
            //   "The server encountered an error. Our team has been notified.",
            //   "server_error"
            // );
            if (errorHandlingFunction) errorHandlingFunction();
            // Explicitly return to prevent any retry logic from executing
            return;
        } else if (status === 404) // Resource not found
        // showDebouncedAlert("The requested resource was not found", "not_found_error");
        {
            if (errorHandlingFunction) errorHandlingFunction();
        } else if (status === 429) {
            // Rate limiting
            (0, $ebTQj.logger).log("429 - Too many requests. Retrying after: 30 seconds");
            setTimeout(()=>{
                retryFunction();
            }, 30000);
            // showDebouncedAlert(
            //   `Too many requests. Please try again in ${retryAfter} seconds.`,
            //   "rate_limit_error"
            // );
            if (errorHandlingFunction) errorHandlingFunction({
                willRetry: true
            });
        } else {
            // Handle other status codes
            if (reason.response?.data && typeof reason.response.data === "object" && "group" in reason.response.data) (0, $ebTQj.logger).log(`Error: ${reason.response.data.group?.[0]}`); // Log specific error if available
            else (0, $ebTQj.logger).log("Error: Unable to retrieve specific error details. Running error handling functionality for this API call."); // Fallback log
            if (errorHandlingFunction) errorHandlingFunction();
        }
    } else {
        // Fallback for other errors (e.g., request setup errors)
        (0, $ebTQj.logger).log(`Unhandled Error: ${reason}`);
        // showDebouncedAlert("An unexpected error occurred", "unexpected_error");
        if (errorHandlingFunction) errorHandlingFunction();
    }
};

});
parcelRegister("aK4Bb", function(module, exports) {

$parcel$export(module.exports, "getRefreshToken", () => $31d7bee3ad17b663$export$1c3df4d50873ab4b);

var $5BK6w = parcelRequire("5BK6w");

var $9BnvG = parcelRequire("9BnvG");

var $ebTQj = parcelRequire("ebTQj");





const $31d7bee3ad17b663$export$1c3df4d50873ab4b = async (navigate, retryFunction)=>{
    const ActuateUI = (0, $9BnvG.createRefreshApi)(``);
    const refreshToken = (0, $5BK6w.getCookie)("token_secret");
    const article = {
        refresh_token: refreshToken
    };
    if (refreshToken) await ActuateUI.post(`/auth/refresh/`, article).then(async (response)=>{
        const apiResponse = response.data;
        // Use centralized auth state management
        const { authStateManager: authStateManager } = await Promise.resolve((parcelRequire("1BWfV")));
        authStateManager.setAuthState(apiResponse.token, apiResponse.token_secret);
        localStorage.setItem("tokenRefreshing", "false");
        if (retryFunction) retryFunction();
    }).catch((err)=>{
        (0, $ebTQj.logger).log(err);
        // Use centralized auth state management for clearing
        Promise.resolve((parcelRequire("1BWfV"))).then(({ authStateManager: authStateManager })=>{
            authStateManager.clearAuthState();
        });
        localStorage.setItem("tokenRefreshing", "false");
        // Redirect to Cognito instead of /login
        Promise.resolve((parcelRequire("ax3yI"))).then(({ handleRedirect: handleRedirect })=>{
            handleRedirect();
        });
    });
    else {
        localStorage.setItem("tokenRefreshing", "false");
        // Use centralized auth state management for clearing
        Promise.resolve((parcelRequire("1BWfV"))).then(({ authStateManager: authStateManager })=>{
            authStateManager.clearAuthState();
        });
        // Redirect to Cognito instead of /login
        Promise.resolve((parcelRequire("ax3yI"))).then(({ handleRedirect: handleRedirect })=>{
            handleRedirect();
        });
    }
};

});





parcelRegister("h5bv8", function(module, exports) {

$parcel$export(module.exports, "getNumbersAfterAboutSite", () => $6380125217b49791$export$f5172043e17f66eb);
const $6380125217b49791$export$f5172043e17f66eb = (url)=>{
    if (typeof window !== "undefined" && window.location.href.includes("aboutsitesecret")) {
        const match = url.match(/\/aboutsitesecret\/(\d+)/);
        if (match) return match[1];
        else return "";
    } else {
        const match = url.match(/\/aboutsite\/(\d+)/);
        if (match) return match[1];
        else return "";
    }
};

});

parcelRegister("k1C5l", function(module, exports) {

$parcel$export(module.exports, "temporaryUpdateScheduleData", () => $684c3d745e749289$export$9f9b9cf7576d0a8d);
parcelRequire("8T3gX");
const $684c3d745e749289$export$9f9b9cf7576d0a8d = (oldData)=>{
    const addCameraInfo = JSON.parse(localStorage.addCameraInfo);
    const returnData = [
        {
            display_name: "Schedule 1",
            id: 1,
            product: [
                ...addCameraInfo.initial_data.products
            ],
            schedule: oldData
        }
    ];
    return returnData;
};

});

parcelRegister("2Mk2P", function(module, exports) {

$parcel$export(module.exports, "handleCreateInitialTimeSchedules", () => $9b2c7e24d663d5d4$export$f41b63734d09e3b7);
parcelRequire("8T3gX");
const $9b2c7e24d663d5d4$export$f41b63734d09e3b7 = (siteSchedules)=>{
    const returnedSiteSchedules = [
        "",
        "",
        "",
        "",
        "",
        "",
        ""
    ];
    siteSchedules.forEach((object)=>{
        object.day_of_week.forEach((day)=>{
            const dayIndex = Number(day);
            if ((!object.start_time || !object.end_time) && !object.always_on && !object.location_dusk_dawn) returnedSiteSchedules[dayIndex] = "";
            else if (object.always_on) returnedSiteSchedules[dayIndex] = "Always On";
            else if (object.location_dusk_dawn) returnedSiteSchedules[dayIndex] = "Dusk to Dawn";
            else returnedSiteSchedules[dayIndex] = `${object.start_time.slice(0, -3)} - ${object.end_time.slice(0, -3)}`;
        });
    });
    return returnedSiteSchedules;
};

});

parcelRegister("axLUl", function(module, exports) {

$parcel$export(module.exports, "handleConvertSchedulesToBooleanArrays", () => $207b33f682bd9219$export$2eafaafe35772309);
parcelRequire("8T3gX");
function $207b33f682bd9219$var$generateBooleanArray(startTime, endTime) {
    const totalIntervals = 96;
    const intervals = new Array(totalIntervals).fill(false);
    if (!startTime || !endTime) return intervals;
    // Parse the start and end times
    const [startHours, startMinutes] = startTime.split(":").map(Number);
    const [endHours, endMinutes] = endTime.split(":").map(Number);
    // Convert start time to interval index
    const startIndex = Math.floor((startHours * 60 + startMinutes) / 15);
    // Convert end time to interval index
    let endIndex = Math.ceil((endHours * 60 + endMinutes) / 15);
    if (endIndex === totalIntervals) endIndex = 0; // Wrap around if end time is exactly 24:00
    // Fill the intervals array with true between startIndex and endIndex
    if (startIndex < endIndex) for(let i = startIndex; i < endIndex; i++)intervals[i] = true;
    else {
        for(let i = startIndex; i < totalIntervals; i++)intervals[i] = true;
        for(let i = 0; i < endIndex; i++)intervals[i] = true;
    }
    return intervals;
}
const $207b33f682bd9219$export$2eafaafe35772309 = (siteSchedules)=>{
    const width = 96; // 24 hours * 4 (15 minutes each)
    const height = 7; // Days of the week
    const booleanScheduleGrid = Array.from({
        length: height
    }, ()=>Array.from({
            length: width
        }, ()=>false));
    siteSchedules.forEach((object)=>{
        object.day_of_week.forEach((day)=>{
            const dayIndex = Number(day);
            if (!object.start_time || !object.end_time) booleanScheduleGrid[dayIndex] = new Array(width).fill(false);
            else if (object.always_on) booleanScheduleGrid[dayIndex] = new Array(width).fill(true);
            else if (object.start_time < object.end_time) booleanScheduleGrid[dayIndex] = $207b33f682bd9219$var$generateBooleanArray(object.start_time, object.end_time);
            else {
                const reversedArray = $207b33f682bd9219$var$generateBooleanArray(object.end_time, object.start_time);
                //take every value in the reversed array and swap it for the opposite boolean value, so each true becomes and false and each false becomes a true
                booleanScheduleGrid[dayIndex] = reversedArray.map((value)=>!value);
            }
            if (object.always_on) booleanScheduleGrid[dayIndex] = new Array(width).fill(true);
        });
    });
    return booleanScheduleGrid;
};

});

parcelRegister("bILSL", function(module, exports) {

$parcel$export(module.exports, "handleCreateDuskToDawn", () => $bc953ec61e9f3958$export$281dcdcf86a1f8a8);
parcelRequire("8T3gX");
const $bc953ec61e9f3958$export$281dcdcf86a1f8a8 = (siteSchedules)=>{
    const returnArray = [
        false,
        false,
        false,
        false,
        false,
        false,
        false
    ];
    siteSchedules.forEach((object)=>{
        object.day_of_week.forEach((day)=>{
            const dayIndex = Number(day);
            if (object.location_dusk_dawn) returnArray[dayIndex] = true;
        });
    });
    return returnArray;
};

});

parcelRegister("7Gmex", function(module, exports) {

$parcel$export(module.exports, "handleCreateDuskToDawnLocationPlusBuffer", () => $4c714c2a072862a3$export$eec15a6e7251b8f3);
parcelRequire("8T3gX");
const $4c714c2a072862a3$export$eec15a6e7251b8f3 = (siteSchedules)=>{
    const returnArray = [
        [
            "",
            ""
        ],
        [
            "",
            ""
        ],
        [
            "",
            ""
        ],
        [
            "",
            ""
        ],
        [
            "",
            ""
        ],
        [
            "",
            ""
        ],
        [
            "",
            ""
        ]
    ];
    siteSchedules.forEach((object)=>{
        object.day_of_week.forEach((day)=>{
            const dayIndex = Number(day);
            if (object.location_dusk_dawn) returnArray[dayIndex] = [
                object.location_dusk_dawn,
                object.buffer_time
            ];
        });
    });
    return returnArray;
};

});

parcelRegister("3uHoa", function(module, exports) {

$parcel$export(module.exports, "handleReadySchedulesForPatching", () => $eb41f1adf44102df$export$31a8c4217dcb8684);
const $eb41f1adf44102df$export$31a8c4217dcb8684 = (schedules)=>{
    const returnSchedules = schedules;
    returnSchedules.forEach((schedule, index)=>{
        if (schedule.start_time !== null) {
            if (schedule.start_time === ":00" || schedule.start_time === " - :00") returnSchedules[index].start_time = null;
        }
        if (schedule.end_time !== null) {
            if (schedule.end_time === ":00" || schedule.end_time === " - :00") returnSchedules[index].end_time = null;
        }
    });
    //remove any schedule object that has a null start_time and end_time and false value for "always_on"
    for(let i = 0; i < returnSchedules.length; i++)if (returnSchedules[i].start_time === null && returnSchedules[i].end_time === null && returnSchedules[i].always_on === false) returnSchedules.splice(i, 1);
    return returnSchedules;
};

});

parcelRegister("jspVg", function(module, exports) {

$parcel$export(module.exports, "findNewScheduleIndex", () => $db9dbffaacc8ec26$export$df2e4320e118a121);
parcelRequire("8T3gX");
const $db9dbffaacc8ec26$export$df2e4320e118a121 = (siteSchedules, responseData)=>{
    //check each schedule in response data to see which is the new schedule
    //this will be the schedule whose id is not one of the ids in siteSchedules
    let newScheduleIndex = 0;
    for(let i = 0; i < responseData.length; i++)if (!siteSchedules.some((schedule)=>schedule.id === responseData[i].id)) {
        newScheduleIndex = i;
        break;
    }
    return newScheduleIndex;
};

});

parcelRegister("2uQ4j", function(module, exports) {

$parcel$export(module.exports, "SchedulesTab", () => $04c40ac55bb00b4b$export$e6b6f5a72a6fc069);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $idDbD = parcelRequire("idDbD");

var $3baw3 = parcelRequire("3baw3");
var $ddLR4 = parcelRequire("ddLR4");
var $cVCJe = parcelRequire("cVCJe");

var $ePwXE = parcelRequire("ePwXE");

var $abNiM = parcelRequire("abNiM");

var $3FJ79 = parcelRequire("3FJ79");

var $5zfN2 = parcelRequire("5zfN2");

var $eYzFO = parcelRequire("eYzFO");

var $9mFrR = parcelRequire("9mFrR");

var $eVSHG = parcelRequire("eVSHG");

var $hpMHQ = parcelRequire("hpMHQ");

var $4PFLW = parcelRequire("4PFLW");

var $aNeNX = parcelRequire("aNeNX");

var $f0C6U = parcelRequire("f0C6U");
const $04c40ac55bb00b4b$export$e6b6f5a72a6fc069 = ({ siteInfo: siteInfo })=>{
    const { siteSchedules: siteSchedules, schedulesIndex: schedulesIndex } = (0, $3FJ79.useSiteAboutStore)();
    const { isFeatureEnabled: isFeatureEnabled } = (0, $4PFLW.useFeatureFlag)();
    const showFlexIgnoreZones = isFeatureEnabled("showFlexIgnoreZones", false);
    const enabledBySite = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((state)=>showFlexIgnoreZones ? state.enabledBySite : (0, $9mFrR.FLEX_IZ_LD_EMPTY_ENABLED_BY_SITE));
    const cameraContexts = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((state)=>showFlexIgnoreZones ? state.cameraContexts : (0, $9mFrR.FLEX_IZ_LD_EMPTY_CAMERA_CONTEXTS));
    const loadCameraContext = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((state)=>showFlexIgnoreZones ? state.loadCameraContext : async (_cameraId, _forceRefresh)=>{});
    const flexIgnoreZonesEnabledSyncLoadingBySite = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((state)=>showFlexIgnoreZones ? state.flexIgnoreZonesEnabledSyncLoadingBySite : (0, $9mFrR.FLEX_IZ_LD_EMPTY_SYNC_LOADING));
    const userInfo = JSON.parse(localStorage.userInfo);
    const permissions = userInfo.permission;
    const isSuperUser = userInfo.username.includes("@aegissystems") || userInfo.username.includes("@actuate") || userInfo.email.includes("@aegissystems") || userInfo.email.includes("@actuate");
    const flexIgnoreZonesSyncLoading = flexIgnoreZonesEnabledSyncLoadingBySite[siteInfo.id] === true;
    const flexIgnoreZonesEnabled = enabledBySite[siteInfo.id] === true;
    const flexIzScheduleSummary = (0, $hpMHQ.useFlexIzScheduleSummary)(siteInfo, {
        showFlexIgnoreZones: showFlexIgnoreZones,
        flexScheduleActive: !!siteInfo.has_flex_schedule,
        flexIgnoreZonesEnabled: flexIgnoreZonesEnabled
    });
    // ENG-2631: holiday-calendar / one-off overrides replace the weekly grid
    // on their dates; list them and mark this week's affected days.
    const { overrides: overrides, todayIso: todayIso } = (0, $aNeNX.useScheduleOverrides)(siteInfo.id, siteInfo.timezone);
    const overrideDays = $8T3gX.useMemo(()=>(0, $f0C6U.overrideWeekdaysWithinWeek)(overrides, todayIso), [
        overrides,
        todayIso
    ]);
    const products = JSON.parse(localStorage.products);
    const productIds = new Map();
    products.forEach((product)=>{
        productIds.set(product.id, product.name);
    });
    if (siteInfo.integration_type_name === "autopatrol") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $5zfN2.SchedulesTabAutopatrol), {
        editMode: false
    });
    const fullSchedulesTab = /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "pb-[10px]",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "border-t border-gray-200"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aNeNX.ScheduleOverridesNotice), {
                overrides: overrides,
                todayIso: todayIso
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: `relative top-[0px] ${!siteInfo.has_flex_schedule ? "h-[440px]" : siteSchedules.length >= 2 ? "h-[510px]" : "h-[480px]"} bg-white overflow-scroll`,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                className: "font-black font-mulish text-[20px] p-3 indent-4",
                                children: [
                                    "Schedule Overview \xa0",
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                        title: `Scheduled arming time ranges are highlighted in green.`,
                                        placement: "top",
                                        sx: {
                                            fontSize: "15px",
                                            fontFamily: "mulish"
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                            fontSize: "small"
                                        })
                                    })
                                ]
                            }),
                            permissions.flex_schedule && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "pl-[30px] pt-[10px] flex",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                        sx: {
                                            fontFamily: "Mulish"
                                        },
                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                            color: "warning",
                                            checked: siteInfo.has_flex_schedule,
                                            disabled: true
                                        }),
                                        label: "Flex Scheduling"
                                    }),
                                    showFlexIgnoreZones && siteInfo.has_flex_schedule && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                        sx: {
                                            fontFamily: "Mulish"
                                        },
                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                            color: "warning",
                                            checked: !!flexIgnoreZonesEnabled,
                                            disabled: true,
                                            inputProps: {
                                                "aria-busy": flexIgnoreZonesSyncLoading
                                            }
                                        }),
                                        label: "Flex Ignore Zones"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "pb-[10px]",
                        children: siteSchedules.length > 1 && permissions.flex_schedule && /*#__PURE__*/ (0, $k4ank.jsx)((0, $abNiM.SchedulesTabs), {})
                    }),
                    siteInfo.has_flex_schedule && siteSchedules[schedulesIndex] && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "flex",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "pl-[30px] pb-[10px] overflow-scroll flex",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "font-black font-mulish text-[20px] flex items-center",
                                    children: [
                                        siteSchedules[schedulesIndex].display_name,
                                        isSuperUser && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "pl-[10px] pb-[px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                title: `${siteSchedules[schedulesIndex].log_name}`,
                                                placement: "top",
                                                sx: {
                                                    fontSize: "15px",
                                                    fontFamily: "mulish"
                                                },
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                                    fontSize: "small"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "font-black font-mulish text-[16px] pl-[30px] pt-[5px]",
                                    children: `Active Products: `
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "pl-[6px] text-[16px] pt-[5px]",
                                    children: `${siteSchedules[schedulesIndex].product.map((product)=>{
                                        return `${productIds.get(product)}`;
                                    }).join(", ")}`
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "relative top-[0px] left-[15px] w-[1500px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $idDbD.ScheduleGrid), {
                            overrideDays: overrideDays
                        })
                    })
                ]
            }),
            flexIzScheduleSummary && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "pl-[15px] pr-[20px] pt-[16px] pb-[24px] bg-white",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-mulish text-[18px] font-black pb-[12px]",
                        children: "Selected Cameras / Flex Schedule Presets"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-[12px] justify-items-start max-w-[1500px]",
                        children: flexIzScheduleSummary.rows.map(({ camera: camera, preset: preset })=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eVSHG.FlexIgnoreZonesCameraPresetCard), {
                                scheduleId: flexIzScheduleSummary.resolvedScheduleId,
                                camera: camera,
                                preset: preset,
                                cameraContext: cameraContexts[camera.id],
                                onPreviewImageError: ()=>{
                                    loadCameraContext(camera.id, true);
                                }
                            }, `${flexIzScheduleSummary.resolvedScheduleId}-${camera.id}`))
                    })
                ]
            })
        ]
    });
    const remoteLinkSchedulesTab = /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "pb-[10px]",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "border-t border-gray-200"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "relative top-[0px] h-[60px] bg-white overflow-scroll",
                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "flex",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-mulish text-[18px] p-3 text-center w-full",
                        children: "Remote Link enabled. See IMMIX for site schedule."
                    })
                })
            })
        ]
    });
    return siteInfo.has_remote_link ? remoteLinkSchedulesTab : fullSchedulesTab;
};

});
parcelRegister("idDbD", function(module, exports) {

$parcel$export(module.exports, "ScheduleGrid", () => $751cf867462afe16$export$e54621f7ee74009b);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");


var $8jTCz = parcelRequire("8jTCz");

var $a65wX = parcelRequire("a65wX");
var $cVCJe = parcelRequire("cVCJe");

var $6pdiI = parcelRequire("6pdiI");

var $dyZ1V = parcelRequire("dyZ1V");

var $gEbE4 = parcelRequire("gEbE4");

var $3FJ79 = parcelRequire("3FJ79");

var $jjo0k = parcelRequire("jjo0k");
parcelRequire("elyck");
var $h5bv8 = parcelRequire("h5bv8");
const $751cf867462afe16$var$daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
const $751cf867462afe16$var$hoursOfDay = Array.from({
    length: 24
}, (_, i)=>`${i.toString().padStart(2, "0")}:00`);
const $751cf867462afe16$export$e54621f7ee74009b = ({ overrideDays: overrideDays = {} } = {})=>{
    const width = 96; // 24 hours * 4 (15 minutes each)
    const height = 7; // Days of the week
    // Initialize grid state
    const initialGrid = Array.from({
        length: height
    }, ()=>Array.from({
            length: width
        }, ()=>false));
    const { scheduleGridEditable: scheduleGridEditable, setScheduleChangesMade: setScheduleChangesMade, grid: grid, setGrid: setGrid, duskToDawn: duskToDawn, setDuskToDawn: setDuskToDawn, duskToDawnLocation: duskToDawnLocation, setDuskToDawnLocation: setDuskToDawnLocation, timeRanges: timeRanges, setTimeRanges: setTimeRanges, setMatchingSchedules: setMatchingSchedules, setSiteSchedules: setSiteSchedules, setSelectedDayInfo: setSelectedDayInfo, setEditTimeScheduleDialogOpen: setEditTimeScheduleDialogOpen, siteSchedules: siteSchedules, schedulesIndex: schedulesIndex } = (0, $3FJ79.useSiteAboutStore)();
    const [isMouseDown, setIsMouseDown] = (0, $8T3gX.useState)(false);
    const [startTile, setStartTile] = (0, $8T3gX.useState)(null);
    const [selectedTiles, setSelectedTiles] = (0, $8T3gX.useState)([]);
    const handleMouseDown = (0, $8T3gX.useCallback)((x, y)=>{
        setIsMouseDown(true);
        setStartTile({
            x: x,
            y: y
        });
        setSelectedTiles([
            {
                x: x,
                y: y
            }
        ]);
    }, []);
    const handleMouseUp = (0, $8T3gX.useCallback)((x, y)=>{
        if (startTile) changeTileColors(startTile, {
            x: x,
            y: y
        });
        setIsMouseDown(false);
        setStartTile(null);
        setSelectedTiles([]);
    }, [
        startTile
    ]);
    const handleMouseOverOrFocus = (0, $8T3gX.useCallback)((x, y)=>{
        if (isMouseDown && startTile) {
            const newSelectedTiles = calculateSelectedTiles(startTile, {
                x: x,
                y: y
            });
            setSelectedTiles(newSelectedTiles);
        }
    }, [
        isMouseDown,
        startTile
    ]);
    const handleKeyDown = (0, $8T3gX.useCallback)((event, x, y)=>{
        if (event.key === "Enter" || event.key === " ") changeTileColors({
            x: x,
            y: y
        }, {
            x: x,
            y: y
        });
    }, []);
    const calculateSelectedTiles = (start, end)=>{
        const selected = [];
        const xMin = Math.min(start.x, end.x);
        const xMax = Math.max(start.x, end.x);
        const yMin = Math.min(start.y, end.y);
        const yMax = Math.max(start.y, end.y);
        for(let y = yMin; y <= yMax; y++)for(let x = xMin; x <= xMax; x++)selected.push({
            x: x,
            y: y
        });
        return selected;
    };
    const changeTileColors = (start, end)=>{
        const newGrid = grid.map((row)=>[
                ...row
            ]); // Creates a deep copy
        const selected = calculateSelectedTiles(start, end);
        selected.forEach(({ x: x, y: y })=>{
            newGrid[y][x] = !newGrid[y][x]; // Toggle the value
        });
        if (checkInvalidTimeRanges(newGrid[start.y])) {
            alert("Only one start and end time are supported.");
            return;
        }
        // Calculate the proper row range using min/max like we do for the grid selection
        const yMin = Math.min(start.y, end.y);
        const yMax = Math.max(start.y, end.y);
        //update dawn-to-dusk to be false if any of the tiles in the row have changed
        const newDawnToDusk = [
            ...duskToDawn
        ];
        for(let i = yMin; i <= yMax; i++)newDawnToDusk[i] = false;
        //update dawn-to-dusk-location to be false if any of the tiles in the row have changed
        const newDawnToDuskLocation = [
            ...duskToDawnLocation
        ];
        for(let i = yMin; i <= yMax; i++)newDawnToDuskLocation[i] = [
            "",
            ""
        ];
        // update the timeRanges for only rows that were changed
        const newTimeRanges = [
            ...timeRanges
        ];
        for(let i = yMin; i <= yMax; i++)newTimeRanges[i] = getTimeRanges(newGrid[i]);
        // check each array in the new grid to see if they match, create an array of arrays with each subarray containing all of the matching schedules index numbers, so for example if only the time ranges from 0 and 1 match, the array would look like [[0, 1], [2], [3], [4], [5], [6]] also each number can only appear once in the array of arrays
        const newMatchingSchedules = [];
        for(let i = 0; i < newGrid.length; i++){
            const matchingScheduleIndexes = [];
            for(let j = 0; j < newGrid.length; j++)if (newGrid[i].toString() === newGrid[j].toString()) matchingScheduleIndexes.push(j);
            newMatchingSchedules.push(matchingScheduleIndexes);
        }
        // check the newMatchingSchedules to see if any subarrays are the same, if they are, remove the duplicate subarray
        for(let i = 0; i < newMatchingSchedules.length; i++){
            for(let j = i + 1; j < newMatchingSchedules.length; j++)if (newMatchingSchedules[i].toString() === newMatchingSchedules[j].toString()) newMatchingSchedules.splice(j, 1);
        }
        for(let i = 0; i < newMatchingSchedules.length; i++){
            for(let j = i + 1; j < newMatchingSchedules.length; j++)if (newMatchingSchedules[i].toString() === newMatchingSchedules[j].toString()) newMatchingSchedules.splice(j, 1);
        }
        if (newMatchingSchedules.length === 2) {
            if (newMatchingSchedules[0].toString() === newMatchingSchedules[1].toString()) newMatchingSchedules.pop();
        }
        if ((0, $jjo0k.handleCheckForOverlappingSchedulesWithShareProducts)(newTimeRanges, newDawnToDuskLocation, newMatchingSchedules, siteSchedules, schedulesIndex)) {
            alert("There are overlapping schedules for shared products. Please check the schedule times and active products for each schedule.");
            return;
        } else {
            setDuskToDawn(newDawnToDusk);
            setDuskToDawnLocation(newDawnToDuskLocation);
            setTimeRanges(newTimeRanges);
            setMatchingSchedules(newMatchingSchedules);
            (0, $gEbE4.handleUpdateSiteSchedules)(newTimeRanges, newDawnToDuskLocation, newMatchingSchedules, setSiteSchedules, siteSchedules, schedulesIndex);
            setScheduleChangesMade(true);
            setGrid(newGrid);
        }
    };
    function checkInvalidTimeRanges(selected) {
        if (selected.length !== 96) throw new Error("The input array must contain exactly 96 boolean values.");
        const ranges = []; // Stores start and end indexes
        let startIndex = null;
        for(let i = 0; i < selected.length; i++){
            if (selected[i] && startIndex === null) startIndex = i;
            else if (!selected[i] && startIndex !== null) {
                ranges.push([
                    startIndex,
                    i
                ]);
                startIndex = null;
            }
        }
        // Handle case where selection goes until the end
        if (startIndex !== null) ranges.push([
            startIndex,
            selected.length
        ]);
        // Return true if the invalid condition is met
        return ranges.length > 2 || ranges.length === 2 && (ranges[0][0] !== 0 || ranges[1][1] !== 96);
    }
    function getTimeRanges(selected) {
        if (selected.length !== 96) throw new Error("The input array must contain exactly 96 boolean values.");
        const ranges = [];
        let startIndex = null;
        for(let i = 0; i < selected.length; i++){
            if (selected[i] && startIndex === null) startIndex = i;
            else if (!selected[i] && startIndex !== null) {
                ranges.push(`${formatTime(startIndex)} - ${formatTime(i)}`);
                startIndex = null;
            }
        }
        // Handle case where the selection goes until the end of the array
        if (startIndex !== null) ranges.push(`${formatTime(startIndex)} - ${formatTime(selected.length)}`);
        if (ranges[0] === "00:00 - 24:00") return "Always On";
        else if (ranges.length > 2) return "Only one start and end time are supported.";
        else if (ranges.length === 2 && (ranges[0].substring(0, 5) !== "00:00" || ranges[1].substring(8, 13) !== "24:00")) return "Only one start and end time are supported.";
        else if (ranges.length === 2 && // check the first five charcters of ranges[0] to see if they are 00:00
        ranges[0].substring(0, 5) === "00:00" && // check the last five charcters of ranges[1] to see if they are 24:00
        ranges[1].substring(8, 13) === "24:00") return `${ranges[1].substring(0, 5)} - ${ranges[0].substring(8, 13)}`;
        else return ranges.join(", ");
    }
    function formatTime(index) {
        const totalMinutes = index * 15;
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        return `${padZero(hours)}:${padZero(minutes)}`;
    }
    function padZero(num) {
        return num.toString().padStart(2, "0");
    }
    const siteInfo = JSON.parse(localStorage.getItem("siteInfo") || "{}");
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setMatchingSchedules((0, $dyZ1V.handleCreateMatchingSchedules)(grid));
    }, [
        grid
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "schedule-grid-container",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("table", {
                className: "schedule-grid-table",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("thead", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("th", {
                                        rowSpan: 2
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("th", {
                                        colSpan: 48,
                                        className: "time-label",
                                        children: [
                                            "AM",
                                            !window.location.href.includes("addschedule") && /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                                                className: "text-[12px]",
                                                children: [
                                                    "(",
                                                    siteInfo?.timezone,
                                                    ")"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("th", {
                                        colSpan: 48,
                                        className: "time-label",
                                        children: [
                                            "PM",
                                            !window.location.href.includes("addschedule") && /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                                                className: "text-[12px]",
                                                children: [
                                                    "(",
                                                    siteInfo?.timezone,
                                                    ")"
                                                ]
                                            }),
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("th", {
                                        className: "time-range-label",
                                        rowSpan: 2,
                                        children: "ARM START-ARM END"
                                    }),
                                    scheduleGridEditable && /*#__PURE__*/ (0, $k4ank.jsx)("th", {
                                        className: "edit-label",
                                        rowSpan: 2,
                                        children: "EDIT"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("tr", {
                                children: $751cf867462afe16$var$hoursOfDay.map((hour, index)=>/*#__PURE__*/ (0, $k4ank.jsx)("th", {
                                        colSpan: 4,
                                        className: "hour-label",
                                        children: hour
                                    }, index))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("tbody", {
                        children: grid.map((row, rowIndex)=>/*#__PURE__*/ (0, $k4ank.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("th", {
                                        className: "day-label",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                                disabled: true,
                                                sx: {
                                                    "&.Mui-disabled": {
                                                        color: "black"
                                                    }
                                                },
                                                children: $751cf867462afe16$var$daysOfWeek[rowIndex]
                                            }),
                                            overrideDays[rowIndex] && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                title: `Holiday override on ${overrideDays[rowIndex]} replaces this day's schedule. See the note above.`,
                                                placement: "right",
                                                children: /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                                                    className: "block font-mulish text-[11px] font-bold text-[#b45309]",
                                                    "data-testid": `override-day-${rowIndex}`,
                                                    children: [
                                                        "Override ",
                                                        overrideDays[rowIndex]
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    row.map((isActive, colIndex)=>{
                                        const isSelected = selectedTiles.some((tile)=>tile.x === colIndex && tile.y === rowIndex);
                                        return scheduleGridEditable ? /*#__PURE__*/ (0, $k4ank.jsx)("td", {
                                            className: `tile ${isActive ? "active" : ""} ${isSelected ? "selected" : ""}`,
                                            onMouseDown: ()=>{
                                                scheduleGridEditable && handleMouseDown(colIndex, rowIndex);
                                            },
                                            onMouseUp: ()=>{
                                                scheduleGridEditable && handleMouseUp(colIndex, rowIndex);
                                            },
                                            onMouseOver: ()=>{
                                                scheduleGridEditable && handleMouseOverOrFocus(colIndex, rowIndex);
                                            },
                                            onFocus: ()=>{
                                                scheduleGridEditable && handleMouseOverOrFocus(colIndex, rowIndex);
                                            },
                                            onKeyDown: (e)=>{
                                                scheduleGridEditable && handleKeyDown(e, colIndex, rowIndex);
                                            },
                                            role: "button",
                                            "aria-pressed": isActive,
                                            tabIndex: 0
                                        }, `${rowIndex}-${colIndex}`) : /*#__PURE__*/ (0, $k4ank.jsx)("td", {
                                            className: `inactive-tile ${isActive ? "active" : ""}`
                                        }, `${rowIndex}-${colIndex}`);
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("th", {
                                        className: "time-range-label",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                            disabled: true,
                                            sx: {
                                                "&.Mui-disabled": {
                                                    color: "black"
                                                }
                                            },
                                            children: timeRanges[rowIndex]
                                        })
                                    }),
                                    scheduleGridEditable && /*#__PURE__*/ (0, $k4ank.jsx)("th", {
                                        className: "edit-label",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                            text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {
                                                fontSize: "small"
                                            }),
                                            onClick: ()=>{
                                                setSelectedDayInfo({
                                                    day: rowIndex,
                                                    timeRanges: timeRanges[rowIndex],
                                                    duskToDawn: duskToDawnLocation[rowIndex][0],
                                                    bufferTime: duskToDawnLocation[rowIndex][1]
                                                });
                                                setEditTimeScheduleDialogOpen(true);
                                            },
                                            disabled: false
                                        })
                                    })
                                ]
                            }, rowIndex))
                    })
                ]
            }),
            scheduleGridEditable && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                        className: "pt-[13px] text-[14px]",
                        children: [
                            `To create a new schedule, click and drag over the desired arming
  time blocks. To manually edit your schedule times, click the `,
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {
                                fontSize: "small"
                            }),
                            ` icon next to Arm Start-Arm End column.`
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "relative pl-[190px] pt-1",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            text: "Clear Table",
                            onClick: ()=>{
                                setGrid(initialGrid);
                                setScheduleChangesMade(true);
                                const newSchedules = [
                                    ...siteSchedules
                                ];
                                if (newSchedules[schedulesIndex]) {
                                    newSchedules[schedulesIndex].schedule = [
                                        {
                                            always_on: false,
                                            buffer_time: 0,
                                            customer: Number((0, $h5bv8.getNumbersAfterAboutSite)(location.href)),
                                            day_of_week: [
                                                0,
                                                1,
                                                2,
                                                3,
                                                4,
                                                5,
                                                6
                                            ],
                                            enabled: true,
                                            end_time: null,
                                            is_overide: false,
                                            location_dusk_dawn: "",
                                            start_time: null
                                        }
                                    ];
                                    setSiteSchedules(newSchedules);
                                }
                                setMatchingSchedules((0, $dyZ1V.handleCreateMatchingSchedules)(initialGrid));
                                setTimeRanges(Array.from({
                                    length: height
                                }, ()=>""));
                                setDuskToDawn(Array.from({
                                    length: height
                                }, ()=>false));
                                setDuskToDawnLocation(Array.from({
                                    length: height
                                }, ()=>[
                                        "",
                                        ""
                                    ]));
                            },
                            disabled: false
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("8jTCz", function(module, exports) {

$parcel$export(module.exports, "OrangeTextButton", () => $2d0828b31e316c69$export$bc354acfbc08399c);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

var $a65wX = parcelRequire("a65wX");
const $2d0828b31e316c69$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $2d0828b31e316c69$export$bc354acfbc08399c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).forwardRef(({ onClick: onClick, text: text, disabled: disabled, className: className, sx: sx, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
        theme: $2d0828b31e316c69$var$theme,
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
            ref: ref,
            type: "button",
            color: "primary",
            onClick: onClick,
            disabled: disabled,
            className: className ?? "hover:bg-[#E67300]",
            sx: sx,
            ...props,
            children: text
        })
    });
});
$2d0828b31e316c69$export$bc354acfbc08399c.displayName = "OrangeTextButton";

});
parcelRegister("b9p11", function(module, exports) {

$parcel$export(module.exports, "default", () => $81e3f082cfec8e16$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");
parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $1VcTO = parcelRequire("1VcTO");

var $kuBjs = parcelRequire("kuBjs");

var $k4ank = parcelRequire("k4ank");
'use client';
const $81e3f082cfec8e16$var$_excluded = [
    "theme"
];
function $81e3f082cfec8e16$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $fAJB5.default)(_ref, $81e3f082cfec8e16$var$_excluded);
    const scopedTheme = themeInput[0, $kuBjs.default];
    let finalTheme = scopedTheme || themeInput;
    if (typeof themeInput !== 'function') {
        if (scopedTheme && !scopedTheme.vars) finalTheme = (0, $eJfrs.default)({}, scopedTheme, {
            vars: null
        });
        else if (themeInput && !themeInput.vars) finalTheme = (0, $eJfrs.default)({}, themeInput, {
            vars: null
        });
    }
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $1VcTO.default), (0, $eJfrs.default)({}, props, {
        themeId: scopedTheme ? (0, $kuBjs.default) : undefined,
        theme: finalTheme
    }));
}
$81e3f082cfec8e16$export$2e2bcd8739ae039.propTypes = {
    /**
   * Your component tree.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * A theme object. You can provide a function to extend the outer theme.
   */ theme: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]).isRequired
};

});
parcelRegister("1VcTO", function(module, exports) {

$parcel$export(module.exports, "default", () => $16651ed3e1a3fb97$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iJzlo = parcelRequire("iJzlo");
var $gfq0H = parcelRequire("gfq0H");

var $bNVvr = parcelRequire("bNVvr");
parcelRequire("3JV9M");
var $iHk77 = parcelRequire("iHk77");

var $f7wb5 = parcelRequire("f7wb5");

var $yILjC = parcelRequire("yILjC");

var $1inFE = parcelRequire("1inFE");

var $85N2d = parcelRequire("85N2d");

var $k4ank = parcelRequire("k4ank");
'use client';
const $16651ed3e1a3fb97$var$EMPTY_THEME = {};
function $16651ed3e1a3fb97$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $8T3gX.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $eJfrs.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $eJfrs.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $eJfrs.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $16651ed3e1a3fb97$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $f7wb5.default)($16651ed3e1a3fb97$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $gfq0H.default)() || $16651ed3e1a3fb97$var$EMPTY_THEME;
    if (upperTheme === null && typeof localTheme === 'function' || themeId && upperTheme && !upperTheme[themeId] && typeof localTheme === 'function') console.error([
        'MUI: You are providing a theme function prop to the ThemeProvider component:',
        '<ThemeProvider theme={outerTheme => outerTheme} />',
        '',
        'However, no outer theme is present.',
        "Make sure a theme is already injected higher in the React tree or provide a theme object."
    ].join('\n'));
    const engineTheme = $16651ed3e1a3fb97$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $16651ed3e1a3fb97$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === 'rtl';
    const layerOrder = (0, $85N2d.default)(engineTheme);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $iJzlo.default), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iHk77.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $yILjC.default), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1inFE.default), {
                    value: engineTheme == null ? void 0 : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
$16651ed3e1a3fb97$var$ThemeProvider.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Your component tree.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * A theme object. You can provide a function to extend the outer theme.
   */ theme: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]).isRequired,
    /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */ themeId: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
};
$16651ed3e1a3fb97$var$ThemeProvider.propTypes = (0, $bNVvr.default)($16651ed3e1a3fb97$var$ThemeProvider.propTypes);
var $16651ed3e1a3fb97$export$2e2bcd8739ae039 = $16651ed3e1a3fb97$var$ThemeProvider;

});
parcelRegister("iJzlo", function(module, exports) {

$parcel$export(module.exports, "default", () => $da37d88d4e00d60f$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $bNVvr = parcelRequire("bNVvr");

var $8Zyzq = parcelRequire("8Zyzq");

var $gfq0H = parcelRequire("gfq0H");

var $87TQt = parcelRequire("87TQt");

var $k4ank = parcelRequire("k4ank");
function $da37d88d4e00d60f$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        if (!mergedTheme) console.error([
            'MUI: You should return an object from your theme function, i.e.',
            '<ThemeProvider theme={() => ({})} />'
        ].join('\n'));
        return mergedTheme;
    }
    return (0, $eJfrs.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $da37d88d4e00d60f$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $gfq0H.default)();
    if (outerTheme === null && typeof localTheme === 'function') console.error([
        'MUI: You are providing a theme function prop to the ThemeProvider component:',
        '<ThemeProvider theme={outerTheme => outerTheme} />',
        '',
        'However, no outer theme is present.',
        "Make sure a theme is already injected higher in the React tree or provide a theme object."
    ].join('\n'));
    const theme = $8T3gX.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $da37d88d4e00d60f$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $87TQt.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $8Zyzq.default).Provider, {
        value: theme,
        children: children
    });
}
$da37d88d4e00d60f$var$ThemeProvider.propTypes = {
    /**
   * Your component tree.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * A theme object. You can provide a function to extend the outer theme.
   */ theme: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]).isRequired
};
$da37d88d4e00d60f$var$ThemeProvider.propTypes = (0, $bNVvr.default)($da37d88d4e00d60f$var$ThemeProvider.propTypes);
var $da37d88d4e00d60f$export$2e2bcd8739ae039 = $da37d88d4e00d60f$var$ThemeProvider;

});
parcelRegister("bNVvr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8980e0d4d747dd33$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");
// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
const $8980e0d4d747dd33$var$specialProperty = 'exact-prop: \u200b';
function $8980e0d4d747dd33$export$2e2bcd8739ae039(propTypes) {
    return (0, $eJfrs.default)({}, propTypes, {
        [$8980e0d4d747dd33$var$specialProperty]: (props)=>{
            const unsupportedProps = Object.keys(props).filter((prop)=>!propTypes.hasOwnProperty(prop));
            if (unsupportedProps.length > 0) return new Error(`The following props are not supported: ${unsupportedProps.map((prop)=>`\`${prop}\``).join(', ')}. Please remove them.`);
            return null;
        }
    });
}

});

parcelRegister("8Zyzq", function(module, exports) {

$parcel$export(module.exports, "default", () => $68bed62b060f94be$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");
const $68bed62b060f94be$var$ThemeContext = /*#__PURE__*/ $8T3gX.createContext(null);
$68bed62b060f94be$var$ThemeContext.displayName = 'ThemeContext';
var $68bed62b060f94be$export$2e2bcd8739ae039 = $68bed62b060f94be$var$ThemeContext;

});

parcelRegister("gfq0H", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd423921a8a08aa5$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");

var $8Zyzq = parcelRequire("8Zyzq");
function $bd423921a8a08aa5$export$2e2bcd8739ae039() {
    const theme = $8T3gX.useContext((0, $8Zyzq.default));
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8T3gX.useDebugValue(theme);
    return theme;
}

});

parcelRegister("87TQt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eaa4be1f7a00629$export$2e2bcd8739ae039);
const $5eaa4be1f7a00629$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $5eaa4be1f7a00629$export$2e2bcd8739ae039 = $5eaa4be1f7a00629$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

});


parcelRegister("f7wb5", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0207850948335fd$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");
parcelRequire("3JV9M");
var $iHk77 = parcelRequire("iHk77");
'use client';
function $b0207850948335fd$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $b0207850948335fd$var$useTheme(defaultTheme = null) {
    const contextTheme = $8T3gX.useContext((0, $iHk77.T));
    return !contextTheme || $b0207850948335fd$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $b0207850948335fd$export$2e2bcd8739ae039 = $b0207850948335fd$var$useTheme;

});

parcelRegister("yILjC", function(module, exports) {

$parcel$export(module.exports, "useRtl", () => $0685e5ebd4a5e754$export$b2dd014b6c321cb);
$parcel$export(module.exports, "default", () => $0685e5ebd4a5e754$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $k4ank = parcelRequire("k4ank");
const $0685e5ebd4a5e754$var$_excluded = [
    "value"
];
const $0685e5ebd4a5e754$var$RtlContext = /*#__PURE__*/ $8T3gX.createContext();
function $0685e5ebd4a5e754$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $fAJB5.default)(_ref, $0685e5ebd4a5e754$var$_excluded);
    return /*#__PURE__*/ (0, $k4ank.jsx)($0685e5ebd4a5e754$var$RtlContext.Provider, (0, $eJfrs.default)({
        value: value != null ? value : true
    }, props));
}
$0685e5ebd4a5e754$var$RtlProvider.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
};
const $0685e5ebd4a5e754$export$b2dd014b6c321cb = ()=>{
    const value = $8T3gX.useContext($0685e5ebd4a5e754$var$RtlContext);
    return value != null ? value : false;
};
var $0685e5ebd4a5e754$export$2e2bcd8739ae039 = $0685e5ebd4a5e754$var$RtlProvider;

});

parcelRegister("85N2d", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e44d39f4d1ff607$export$2e2bcd8739ae039);
parcelRequire("8T3gX");

var $5IwAt = parcelRequire("5IwAt");

var $h47Cb = parcelRequire("h47Cb");

var $ecQnZ = parcelRequire("ecQnZ");

var $f7wb5 = parcelRequire("f7wb5");

var $k4ank = parcelRequire("k4ank");
'use client';
function $5e44d39f4d1ff607$export$2e2bcd8739ae039(theme) {
    const upperTheme = (0, $f7wb5.default)();
    const id = (0, $h47Cb.default)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $5IwAt.default)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            var _firstChild$hasAttrib;
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && (_firstChild$hasAttrib = firstChild.hasAttribute) != null && _firstChild$hasAttrib.call(firstChild, 'data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else {
            var _head$querySelector;
            (_head$querySelector = head.querySelector(`style[data-mui-layer-order="${id}"]`)) == null || _head$querySelector.remove();
        }
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $ecQnZ.default), {
        styles: layerOrder
    });
}

});
parcelRegister("5IwAt", function(module, exports) {

$parcel$export(module.exports, "default", () => $429a56fd25b82bde$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $429a56fd25b82bde$var$useEnhancedEffect = typeof window !== 'undefined' ? $8T3gX.useLayoutEffect : $8T3gX.useEffect;
var $429a56fd25b82bde$export$2e2bcd8739ae039 = $429a56fd25b82bde$var$useEnhancedEffect;

});

parcelRegister("h47Cb", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6c8b78b1b1774ea$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");
'use client';
let $c6c8b78b1b1774ea$var$globalId = 0;
function $c6c8b78b1b1774ea$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $8T3gX.useState(idOverride);
    const id = idOverride || defaultId;
    $8T3gX.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $c6c8b78b1b1774ea$var$globalId += 1;
            setDefaultId(`mui-${$c6c8b78b1b1774ea$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $c6c8b78b1b1774ea$var$maybeReactUseId = $8T3gX['useId'.toString()];
function $c6c8b78b1b1774ea$export$2e2bcd8739ae039(idOverride) {
    if ($c6c8b78b1b1774ea$var$maybeReactUseId !== undefined) {
        const reactId = $c6c8b78b1b1774ea$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $c6c8b78b1b1774ea$var$useGlobalId(idOverride);
}

});

parcelRegister("ecQnZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a57ad2746734c977$export$2e2bcd8739ae039);
parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $lMsz6 = parcelRequire("lMsz6");
var $7P7g9 = parcelRequire("7P7g9");

var $a4EsH = parcelRequire("a4EsH");

var $k4ank = parcelRequire("k4ank");
'use client';
function $a57ad2746734c977$var$wrapGlobalLayer(styles) {
    const serialized = (0, $7P7g9.internal_serializeStyles)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $a57ad2746734c977$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $a4EsH.default)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $a57ad2746734c977$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $a57ad2746734c977$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $a57ad2746734c977$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $lMsz6.default), {
        styles: globalStyles
    });
}
$a57ad2746734c977$var$GlobalStyles.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ defaultTheme: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ styles: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
    ]),
    /**
   * @ignore
   */ themeId: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
};
var $a57ad2746734c977$export$2e2bcd8739ae039 = $a57ad2746734c977$var$GlobalStyles;

});
parcelRegister("a4EsH", function(module, exports) {

$parcel$export(module.exports, "default", () => $7559a9f9899ee661$export$2e2bcd8739ae039);

var $6IeW0 = parcelRequire("6IeW0");

var $f7wb5 = parcelRequire("f7wb5");
'use client';
const $7559a9f9899ee661$export$35e57303dbd8a66 = (0, $6IeW0.default)();
function $7559a9f9899ee661$var$useTheme(defaultTheme = $7559a9f9899ee661$export$35e57303dbd8a66) {
    return (0, $f7wb5.default)(defaultTheme);
}
var $7559a9f9899ee661$export$2e2bcd8739ae039 = $7559a9f9899ee661$var$useTheme;

});





parcelRegister("a65wX", function(module, exports) {

$parcel$export(module.exports, "default", () => $759ec131354195ac$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $cA45A = parcelRequire("cA45A");

var $aYNpO = parcelRequire("aYNpO");

var $aBrLz = parcelRequire("aBrLz");

var $anJSP = parcelRequire("anJSP");
var $3dQcH = parcelRequire("3dQcH");

var $7AQZl = parcelRequire("7AQZl");

var $hhKOZ = parcelRequire("hhKOZ");

var $iMOmE = parcelRequire("iMOmE");

var $8ANQF = parcelRequire("8ANQF");

var $1qvgV = parcelRequire("1qvgV");

var $ixWGs = parcelRequire("ixWGs");

var $k4ank = parcelRequire("k4ank");
'use client';
const $759ec131354195ac$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $759ec131354195ac$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `${variant}${(0, $iMOmE.default)(color)}`,
            `size${(0, $iMOmE.default)(size)}`,
            `${variant}Size${(0, $iMOmE.default)(size)}`,
            `color${(0, $iMOmE.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth'
        ],
        label: [
            'label'
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $iMOmE.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $iMOmE.default)(size)}`
        ]
    };
    const composedClasses = (0, $aYNpO.default)(slots, (0, $8ANQF.getButtonUtilityClass), classes);
    return (0, $eJfrs.default)({}, classes, composedClasses);
};
const $759ec131354195ac$var$commonIconStyles = (ownerState)=>(0, $eJfrs.default)({}, ownerState.size === 'small' && {
        '& > *:nth-of-type(1)': {
            fontSize: 18
        }
    }, ownerState.size === 'medium' && {
        '& > *:nth-of-type(1)': {
            fontSize: 20
        }
    }, ownerState.size === 'large' && {
        '& > *:nth-of-type(1)': {
            fontSize: 22
        }
    });
const $759ec131354195ac$var$ButtonRoot = (0, $anJSP.default)((0, $hhKOZ.default), {
    shouldForwardProp: (prop)=>(0, $3dQcH.default)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $iMOmE.default)(ownerState.color)}`],
            styles[`size${(0, $iMOmE.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $iMOmE.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $eJfrs.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': (0, $eJfrs.default)({
            textDecoration: 'none',
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aBrLz.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aBrLz.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aBrLz.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'contained' && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        '&:active': (0, $eJfrs.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $8ANQF.default).focusVisible}`]: (0, $eJfrs.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $8ANQF.default).disabled}`]: (0, $eJfrs.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === 'outlined' && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === 'contained' && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === 'text' && {
        padding: '6px 8px'
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === 'outlined' && {
        padding: '5px 15px',
        border: '1px solid currentColor'
    }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $aBrLz.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === 'contained' && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === 'inherit' && {
        color: 'inherit',
        borderColor: 'currentColor'
    }, ownerState.size === 'small' && ownerState.variant === 'text' && {
        padding: '4px 5px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'text' && {
        padding: '8px 11px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        padding: '3px 9px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
        padding: '7px 21px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'contained' && {
        padding: '4px 10px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'contained' && {
        padding: '8px 22px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: '100%'
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none'
        },
        [`&.${(0, $8ANQF.default).focusVisible}`]: {
            boxShadow: 'none'
        },
        '&:active': {
            boxShadow: 'none'
        },
        [`&.${(0, $8ANQF.default).disabled}`]: {
            boxShadow: 'none'
        }
    });
const $759ec131354195ac$var$ButtonStartIcon = (0, $anJSP.default)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $iMOmE.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === 'small' && {
        marginLeft: -2
    }, $759ec131354195ac$var$commonIconStyles(ownerState)));
const $759ec131354195ac$var$ButtonEndIcon = (0, $anJSP.default)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $iMOmE.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === 'small' && {
        marginRight: -2
    }, $759ec131354195ac$var$commonIconStyles(ownerState)));
const $759ec131354195ac$var$Button = /*#__PURE__*/ $8T3gX.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $8T3gX.useContext((0, $1qvgV.default));
    const buttonGroupButtonContextPositionClassName = $8T3gX.useContext((0, $ixWGs.default));
    const resolvedProps = (0, $cA45A.default)(contextProps, inProps);
    const props = (0, $7AQZl.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text' } = props, other = (0, $fAJB5.default)(props, $759ec131354195ac$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $759ec131354195ac$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $k4ank.jsx)($759ec131354195ac$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $k4ank.jsx)($759ec131354195ac$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $k4ank.jsxs)($759ec131354195ac$var$ButtonRoot, (0, $eJfrs.default)({
        ownerState: ownerState,
        className: (0, $iVyaN.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $iVyaN.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
$759ec131354195ac$var$Button.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'inherit',
            'primary',
            'secondary',
            'success',
            'error',
            'info',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, no elevation is used.
   * @default false
   */ disableElevation: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */ disableFocusRipple: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Element placed after the children.
   */ endIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * @ignore
   */ focusVisibleClassName: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */ href: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'small',
            'medium',
            'large'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * Element placed before the children.
   */ startIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * @ignore
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'button',
            'reset',
            'submit'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The variant to use.
   * @default 'text'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'contained',
            'outlined',
            'text'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ])
};
var $759ec131354195ac$export$2e2bcd8739ae039 = $759ec131354195ac$var$Button;

});
parcelRegister("hhKOZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c95857f13ff88f9d$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $dSmkj = parcelRequire("dSmkj");

var $26cdd = parcelRequire("26cdd");

var $aYNpO = parcelRequire("aYNpO");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $11ydL = parcelRequire("11ydL");

var $7F3bH = parcelRequire("7F3bH");

var $4J28n = parcelRequire("4J28n");

var $kN5wq = parcelRequire("kN5wq");

var $9eccS = parcelRequire("9eccS");

var $k4ank = parcelRequire("k4ank");
'use client';
const $c95857f13ff88f9d$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $c95857f13ff88f9d$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $aYNpO.default)(slots, (0, $9eccS.getButtonBaseUtilityClass), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $c95857f13ff88f9d$export$7ec0dcc5e3cdcd36 = (0, $anJSP.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $9eccS.default).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $c95857f13ff88f9d$var$ButtonBase = /*#__PURE__*/ $8T3gX.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $fAJB5.default)(props, $c95857f13ff88f9d$var$_excluded);
    const buttonRef = $8T3gX.useRef(null);
    const rippleRef = $8T3gX.useRef(null);
    const handleRippleRef = (0, $11ydL.default)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $4J28n.default)();
    const [focusVisible, setFocusVisible] = $8T3gX.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $8T3gX.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $8T3gX.useState(false);
    $8T3gX.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $8T3gX.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $7F3bH.default)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler('start', onMouseDown);
    const handleContextMenu = useRippleHandler('stop', onContextMenu);
    const handleDragLeave = useRippleHandler('stop', onDragLeave);
    const handleMouseUp = useRippleHandler('stop', onMouseUp);
    const handleMouseLeave = useRippleHandler('stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler('start', onTouchStart);
    const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    const handleTouchMove = useRippleHandler('stop', onTouchMove);
    const handleBlur = useRippleHandler('stop', (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $7F3bH.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $8T3gX.useRef(false);
    const handleKeyDown = (0, $7F3bH.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $7F3bH.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $11ydL.default)(ref, focusVisibleRef, buttonRef);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8T3gX.useEffect(()=>{
        if (enableTouchRipple && !rippleRef.current) console.error([
            'MUI: The `component` prop provided to ButtonBase is invalid.',
            'Please make sure the children prop is rendered in this custom component.'
        ].join('\n'));
    }, [
        enableTouchRipple
    ]);
    const ownerState = (0, $eJfrs.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $c95857f13ff88f9d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsxs)($c95857f13ff88f9d$export$7ec0dcc5e3cdcd36, (0, $eJfrs.default)({
        as: ComponentProp,
        className: (0, $iVyaN.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $k4ank.jsx)((0, $kN5wq.default), (0, $eJfrs.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
$c95857f13ff88f9d$var$ButtonBase.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */ action: (0, $dSmkj.default),
    /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */ centerRipple: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, $26cdd.default),
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */ disableTouchRipple: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */ focusRipple: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */ focusVisibleClassName: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * @ignore
   */ href: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).any,
    /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */ LinkComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * @ignore
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onContextMenu: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */ onFocusVisible: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onKeyUp: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onMouseDown: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onMouseUp: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onTouchEnd: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onTouchMove: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onTouchStart: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * @default 0
   */ tabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    /**
   * Props applied to the `TouchRipple` element.
   */ TouchRippleProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * A ref that points to the `TouchRipple` element.
   */ touchRippleRef: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
                pulsate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired,
                start: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired,
                stop: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired
            })
        })
    ]),
    /**
   * @ignore
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'button',
            'reset',
            'submit'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ])
};
var $c95857f13ff88f9d$export$2e2bcd8739ae039 = $c95857f13ff88f9d$var$ButtonBase;

});
parcelRegister("dSmkj", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1a1a31b5af865bc$export$2e2bcd8739ae039);

var $fdGrT = parcelRequire("fdGrT");
const $a1a1a31b5af865bc$var$refType = (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
]);
var $a1a1a31b5af865bc$export$2e2bcd8739ae039 = $a1a1a31b5af865bc$var$refType;

});

parcelRegister("26cdd", function(module, exports) {

$parcel$export(module.exports, "default", () => $18759d67aef8f83d$export$2e2bcd8739ae039);

var $fdGrT = parcelRequire("fdGrT");

var $bPpmJ = parcelRequire("bPpmJ");
function $18759d67aef8f83d$var$isClassComponent(elementType) {
    // elementType.prototype?.isReactComponent
    const { prototype: prototype = {} } = elementType;
    return Boolean(prototype.isReactComponent);
}
function $18759d67aef8f83d$var$elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
    const propValue = props[propName];
    const safePropName = propFullName || propName;
    if (propValue == null || // When server-side rendering React doesn't warn either.
    // This is not an accurate check for SSR.
    // This is only in place for emotion compat.
    // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
    typeof window === 'undefined') return null;
    let warningHint;
    /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */ if (typeof propValue === 'function' && !$18759d67aef8f83d$var$isClassComponent(propValue)) warningHint = 'Did you accidentally provide a plain function component instead?';
    if (warningHint !== undefined) return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element type that can hold a ref. ${warningHint} ` + 'For more information see https://mui.com/r/caveat-with-refs-guide');
    return null;
}
var $18759d67aef8f83d$export$2e2bcd8739ae039 = (0, $bPpmJ.default)((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType, $18759d67aef8f83d$var$elementTypeAcceptingRef);

});
parcelRegister("bPpmJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $89c8223d558382a6$export$2e2bcd8739ae039);
function $89c8223d558382a6$export$2e2bcd8739ae039(propType1, propType2) {
    return function validate(...args) {
        return propType1(...args) || propType2(...args);
    };
}

});


parcelRegister("11ydL", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bf06e02960254d8$export$2e2bcd8739ae039);

var $ktSDD = parcelRequire("ktSDD");
'use client';
var $0bf06e02960254d8$export$2e2bcd8739ae039 = (0, $ktSDD.default);

});
parcelRegister("ktSDD", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee90e61e22500e20$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");

var $jmWnJ = parcelRequire("jmWnJ");
'use client';
function $ee90e61e22500e20$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $8T3gX.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $jmWnJ.default)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});
parcelRegister("jmWnJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e19d5bc67e64588e$export$2e2bcd8739ae039);
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $e19d5bc67e64588e$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}

});



parcelRegister("7F3bH", function(module, exports) {

$parcel$export(module.exports, "default", () => $593ed5bf85d2d12c$export$2e2bcd8739ae039);

var $fPAwT = parcelRequire("fPAwT");
'use client';
var $593ed5bf85d2d12c$export$2e2bcd8739ae039 = (0, $fPAwT.default);

});
parcelRegister("fPAwT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b867f46f3848f0d0$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");

var $5IwAt = parcelRequire("5IwAt");
'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $b867f46f3848f0d0$var$useEventCallback(fn) {
    const ref = $8T3gX.useRef(fn);
    (0, $5IwAt.default)(()=>{
        ref.current = fn;
    });
    return $8T3gX.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $b867f46f3848f0d0$export$2e2bcd8739ae039 = $b867f46f3848f0d0$var$useEventCallback;

});


parcelRegister("4J28n", function(module, exports) {

$parcel$export(module.exports, "default", () => $370d052d24517f20$export$2e2bcd8739ae039);

var $1fH8P = parcelRequire("1fH8P");
'use client';
var $370d052d24517f20$export$2e2bcd8739ae039 = (0, $1fH8P.default);

});
parcelRegister("1fH8P", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e98a81eb1831c09$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");

var $efgnF = parcelRequire("efgnF");
'use client';
let $0e98a81eb1831c09$var$hadKeyboardEvent = true;
let $0e98a81eb1831c09$var$hadFocusVisibleRecently = false;
const $0e98a81eb1831c09$var$hadFocusVisibleRecentlyTimeout = new (0, $efgnF.Timeout)();
const $0e98a81eb1831c09$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $0e98a81eb1831c09$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === 'INPUT' && $0e98a81eb1831c09$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $0e98a81eb1831c09$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $0e98a81eb1831c09$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $0e98a81eb1831c09$var$handlePointerDown() {
    $0e98a81eb1831c09$var$hadKeyboardEvent = false;
}
function $0e98a81eb1831c09$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($0e98a81eb1831c09$var$hadFocusVisibleRecently) $0e98a81eb1831c09$var$hadKeyboardEvent = true;
    }
}
function $0e98a81eb1831c09$var$prepare(doc) {
    doc.addEventListener('keydown', $0e98a81eb1831c09$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $0e98a81eb1831c09$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $0e98a81eb1831c09$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $0e98a81eb1831c09$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $0e98a81eb1831c09$var$handleVisibilityChange, true);
}
function $0e98a81eb1831c09$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $0e98a81eb1831c09$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $0e98a81eb1831c09$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $0e98a81eb1831c09$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $0e98a81eb1831c09$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $0e98a81eb1831c09$var$handleVisibilityChange, true);
}
function $0e98a81eb1831c09$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(':focus-visible');
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $0e98a81eb1831c09$var$hadKeyboardEvent || $0e98a81eb1831c09$var$focusTriggersKeyboardModality(target);
}
function $0e98a81eb1831c09$export$2e2bcd8739ae039() {
    const ref = $8T3gX.useCallback((node)=>{
        if (node != null) $0e98a81eb1831c09$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $8T3gX.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $0e98a81eb1831c09$var$hadFocusVisibleRecently = true;
            $0e98a81eb1831c09$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $0e98a81eb1831c09$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($0e98a81eb1831c09$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}

});
parcelRegister("efgnF", function(module, exports) {

$parcel$export(module.exports, "Timeout", () => $a5ef2c41e7919893$export$786b4da70f00938b);
$parcel$export(module.exports, "default", () => $a5ef2c41e7919893$export$2e2bcd8739ae039);

var $96eQw = parcelRequire("96eQw");

var $frbhR = parcelRequire("frbhR");
'use client';
class $a5ef2c41e7919893$export$786b4da70f00938b {
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $a5ef2c41e7919893$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
}
function $a5ef2c41e7919893$export$2e2bcd8739ae039() {
    const timeout = (0, $96eQw.default)($a5ef2c41e7919893$export$786b4da70f00938b.create).current;
    (0, $frbhR.default)(timeout.disposeEffect);
    return timeout;
}

});
parcelRegister("96eQw", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a0030bf7a42427b$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");
'use client';
const $6a0030bf7a42427b$var$UNINITIALIZED = {};
function $6a0030bf7a42427b$export$2e2bcd8739ae039(init, initArg) {
    const ref = $8T3gX.useRef($6a0030bf7a42427b$var$UNINITIALIZED);
    if (ref.current === $6a0030bf7a42427b$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

});

parcelRegister("frbhR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3d222046793fcf3$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");
'use client';
const $b3d222046793fcf3$var$EMPTY = [];
function $b3d222046793fcf3$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $8T3gX.useEffect(fn, $b3d222046793fcf3$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

});




parcelRegister("kN5wq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f22caac8b0813474$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $d07hW = parcelRequire("d07hW");

var $iVyaN = parcelRequire("iVyaN");

var $3JV9M = parcelRequire("3JV9M");

var $efgnF = parcelRequire("efgnF");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $ehAg4 = parcelRequire("ehAg4");

var $aUKLU = parcelRequire("aUKLU");

var $k4ank = parcelRequire("k4ank");
'use client';
const $f22caac8b0813474$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $f22caac8b0813474$var$_ = (t)=>t, $f22caac8b0813474$var$_t, $f22caac8b0813474$var$_t2, $f22caac8b0813474$var$_t3, $f22caac8b0813474$var$_t4;
const $f22caac8b0813474$var$DURATION = 550;
const $f22caac8b0813474$export$95d0c9356b2231a3 = 80;
const $f22caac8b0813474$var$enterKeyframe = (0, $3JV9M.keyframes)($f22caac8b0813474$var$_t || ($f22caac8b0813474$var$_t = $f22caac8b0813474$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $f22caac8b0813474$var$exitKeyframe = (0, $3JV9M.keyframes)($f22caac8b0813474$var$_t2 || ($f22caac8b0813474$var$_t2 = $f22caac8b0813474$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $f22caac8b0813474$var$pulsateKeyframe = (0, $3JV9M.keyframes)($f22caac8b0813474$var$_t3 || ($f22caac8b0813474$var$_t3 = $f22caac8b0813474$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $f22caac8b0813474$export$f6b7418508c72c25 = (0, $anJSP.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $f22caac8b0813474$export$676cfe7b12693c4b = (0, $anJSP.default)((0, $ehAg4.default), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})($f22caac8b0813474$var$_t4 || ($f22caac8b0813474$var$_t4 = $f22caac8b0813474$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $aUKLU.default).rippleVisible, $f22caac8b0813474$var$enterKeyframe, $f22caac8b0813474$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $aUKLU.default).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $aUKLU.default).child, (0, $aUKLU.default).childLeaving, $f22caac8b0813474$var$exitKeyframe, $f22caac8b0813474$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $aUKLU.default).childPulsate, $f22caac8b0813474$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $f22caac8b0813474$var$TouchRipple = /*#__PURE__*/ $8T3gX.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $fAJB5.default)(props, $f22caac8b0813474$var$_excluded);
    const [ripples, setRipples] = $8T3gX.useState([]);
    const nextKey = $8T3gX.useRef(0);
    const rippleCallback = $8T3gX.useRef(null);
    $8T3gX.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $8T3gX.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $efgnF.default)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $8T3gX.useRef(null);
    const container = $8T3gX.useRef(null);
    const startCommit = $8T3gX.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $k4ank.jsx)($f22caac8b0813474$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $iVyaN.default)(classes.ripple, (0, $aUKLU.default).ripple),
                        rippleVisible: (0, $iVyaN.default)(classes.rippleVisible, (0, $aUKLU.default).rippleVisible),
                        ripplePulsate: (0, $iVyaN.default)(classes.ripplePulsate, (0, $aUKLU.default).ripplePulsate),
                        child: (0, $iVyaN.default)(classes.child, (0, $aUKLU.default).child),
                        childLeaving: (0, $iVyaN.default)(classes.childLeaving, (0, $aUKLU.default).childLeaving),
                        childPulsate: (0, $iVyaN.default)(classes.childPulsate, (0, $aUKLU.default).childPulsate)
                    },
                    timeout: $f22caac8b0813474$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $8T3gX.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($f22caac8b0813474$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $8T3gX.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $8T3gX.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $8T3gX.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsx)($f22caac8b0813474$export$f6b7418508c72c25, (0, $eJfrs.default)({
        className: (0, $iVyaN.default)((0, $aUKLU.default).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $d07hW.default), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
$f22caac8b0813474$var$TouchRipple.propTypes = {
    /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */ center: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
};
var $f22caac8b0813474$export$2e2bcd8739ae039 = $f22caac8b0813474$var$TouchRipple;

});
parcelRegister("d07hW", function(module, exports) {

$parcel$export(module.exports, "default", () => $9770edc3abc17a04$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $lVo1d = parcelRequire("lVo1d");

var $8pync = parcelRequire("8pync");

var $fdGrT = parcelRequire("fdGrT");

var $8T3gX = parcelRequire("8T3gX");

var $7y2hj = parcelRequire("7y2hj");

var $l3d5y = parcelRequire("l3d5y");
var $9770edc3abc17a04$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $9770edc3abc17a04$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $9770edc3abc17a04$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $8pync.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $lVo1d.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $l3d5y.getInitialChildMapping)(nextProps, handleExited) : (0, $l3d5y.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $l3d5y.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $eJfrs.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $fAJB5.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $9770edc3abc17a04$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $7y2hj.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $7y2hj.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Component);
$9770edc3abc17a04$var$TransitionGroup.propTypes = {
    /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */ appear: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */ enter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */ exit: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */ childFactory: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
};
$9770edc3abc17a04$var$TransitionGroup.defaultProps = $9770edc3abc17a04$var$defaultProps;
var $9770edc3abc17a04$export$2e2bcd8739ae039 = $9770edc3abc17a04$var$TransitionGroup;

});
parcelRegister("lVo1d", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff618d729f28a1ab$export$2e2bcd8739ae039);
function $ff618d729f28a1ab$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("8pync", function(module, exports) {

$parcel$export(module.exports, "default", () => $61fb52508441c2fd$export$2e2bcd8739ae039);

var $kafOy = parcelRequire("kafOy");
function $61fb52508441c2fd$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $kafOy.default)(t, o);
}

});
parcelRegister("kafOy", function(module, exports) {

$parcel$export(module.exports, "default", () => $eae1023a9d0c6269$export$2e2bcd8739ae039);
function $eae1023a9d0c6269$export$2e2bcd8739ae039(t, e) {
    return $eae1023a9d0c6269$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $eae1023a9d0c6269$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("7y2hj", function(module, exports) {

$parcel$export(module.exports, "default", () => $57ed79c62785b036$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");
var $57ed79c62785b036$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createContext(null);

});

parcelRegister("l3d5y", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", () => $f53407e7fc473e5c$export$bbc8a025727ea824);
$parcel$export(module.exports, "getInitialChildMapping", () => $f53407e7fc473e5c$export$fa71e2345c31d7a2);
$parcel$export(module.exports, "getNextChildMapping", () => $f53407e7fc473e5c$export$36fd1af28d383ec0);

var $8T3gX = parcelRequire("8T3gX");
function $f53407e7fc473e5c$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $8T3gX.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $8T3gX.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $f53407e7fc473e5c$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $f53407e7fc473e5c$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $f53407e7fc473e5c$export$fa71e2345c31d7a2(props, onExited) {
    return $f53407e7fc473e5c$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $8T3gX.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $f53407e7fc473e5c$var$getProp(child, 'appear', props),
            enter: $f53407e7fc473e5c$var$getProp(child, 'enter', props),
            exit: $f53407e7fc473e5c$var$getProp(child, 'exit', props)
        });
    });
}
function $f53407e7fc473e5c$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $f53407e7fc473e5c$export$bbc8a025727ea824(nextProps.children);
    var children = $f53407e7fc473e5c$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $8T3gX.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $8T3gX.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $8T3gX.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $f53407e7fc473e5c$var$getProp(child, 'exit', nextProps),
            enter: $f53407e7fc473e5c$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $8T3gX.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $8T3gX.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $8T3gX.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $f53407e7fc473e5c$var$getProp(child, 'exit', nextProps),
            enter: $f53407e7fc473e5c$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

});


parcelRegister("ehAg4", function(module, exports) {

$parcel$export(module.exports, "default", () => $a65ec75b500d7ec8$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $k4ank = parcelRequire("k4ank");
'use client';
function $a65ec75b500d7ec8$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $8T3gX.useState(false);
    const rippleClassName = (0, $iVyaN.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $iVyaN.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $8T3gX.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
            className: childClassName
        })
    });
}
$a65ec75b500d7ec8$var$Ripple.propTypes = {
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object.isRequired,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * @ignore - injected from TransitionGroup
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * @ignore - injected from TransitionGroup
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */ pulsate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Diameter of the ripple.
   */ rippleSize: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    /**
   * Horizontal position of the ripple center.
   */ rippleX: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    /**
   * Vertical position of the ripple center.
   */ rippleY: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    /**
   * exit delay
   */ timeout: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number.isRequired
};
var $a65ec75b500d7ec8$export$2e2bcd8739ae039 = $a65ec75b500d7ec8$var$Ripple;

});

parcelRegister("aUKLU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f236a3cb770f5d3$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $7f236a3cb770f5d3$export$b464606f735ab902(slot) {
    return (0, $kfTYv.default)('MuiTouchRipple', slot);
}
const $7f236a3cb770f5d3$var$touchRippleClasses = (0, $jh2Zm.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $7f236a3cb770f5d3$export$2e2bcd8739ae039 = $7f236a3cb770f5d3$var$touchRippleClasses;

});


parcelRegister("9eccS", function(module, exports) {

$parcel$export(module.exports, "getButtonBaseUtilityClass", () => $6b7ee3df9d3d4a3e$export$fccb0498dcd99783);
$parcel$export(module.exports, "default", () => $6b7ee3df9d3d4a3e$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $6b7ee3df9d3d4a3e$export$fccb0498dcd99783(slot) {
    return (0, $kfTYv.default)('MuiButtonBase', slot);
}
const $6b7ee3df9d3d4a3e$var$buttonBaseClasses = (0, $jh2Zm.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $6b7ee3df9d3d4a3e$export$2e2bcd8739ae039 = $6b7ee3df9d3d4a3e$var$buttonBaseClasses;

});


parcelRegister("8ANQF", function(module, exports) {

$parcel$export(module.exports, "getButtonUtilityClass", () => $64185a6a5235da13$export$5a6f9035944c8119);
$parcel$export(module.exports, "default", () => $64185a6a5235da13$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $64185a6a5235da13$export$5a6f9035944c8119(slot) {
    return (0, $kfTYv.default)('MuiButton', slot);
}
const $64185a6a5235da13$var$buttonClasses = (0, $jh2Zm.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge'
]);
var $64185a6a5235da13$export$2e2bcd8739ae039 = $64185a6a5235da13$var$buttonClasses;

});

parcelRegister("1qvgV", function(module, exports) {

$parcel$export(module.exports, "default", () => $10a07a1abb0cfc03$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");
/**
 * @ignore - internal component.
 */ const $10a07a1abb0cfc03$var$ButtonGroupContext = /*#__PURE__*/ $8T3gX.createContext({});
$10a07a1abb0cfc03$var$ButtonGroupContext.displayName = 'ButtonGroupContext';
var $10a07a1abb0cfc03$export$2e2bcd8739ae039 = $10a07a1abb0cfc03$var$ButtonGroupContext;

});

parcelRegister("ixWGs", function(module, exports) {

$parcel$export(module.exports, "default", () => $d808d477a7a11f9e$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");
/**
 * @ignore - internal component.
 */ const $d808d477a7a11f9e$var$ButtonGroupButtonContext = /*#__PURE__*/ $8T3gX.createContext(undefined);
$d808d477a7a11f9e$var$ButtonGroupButtonContext.displayName = 'ButtonGroupButtonContext';
var $d808d477a7a11f9e$export$2e2bcd8739ae039 = $d808d477a7a11f9e$var$ButtonGroupButtonContext;

});



parcelRegister("cVCJe", function(module, exports) {

$parcel$export(module.exports, "default", () => $9698d998622c3ed6$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $efgnF = parcelRequire("efgnF");

var $evygD = parcelRequire("evygD");

var $aYNpO = parcelRequire("aYNpO");

var $aBrLz = parcelRequire("aBrLz");

var $yILjC = parcelRequire("yILjC");

var $3s57T = parcelRequire("3s57T");

var $jphfx = parcelRequire("jphfx");

var $anJSP = parcelRequire("anJSP");
var $4nWZ9 = parcelRequire("4nWZ9");

var $7AQZl = parcelRequire("7AQZl");

var $iMOmE = parcelRequire("iMOmE");

var $6CjWJ = parcelRequire("6CjWJ");

var $cWqfz = parcelRequire("cWqfz");

var $7F3bH = parcelRequire("7F3bH");

var $11ydL = parcelRequire("11ydL");

var $1xq4a = parcelRequire("1xq4a");

var $4J28n = parcelRequire("4J28n");

var $7Wcl5 = parcelRequire("7Wcl5");

var $gD0A5 = parcelRequire("gD0A5");

var $k4ank = parcelRequire("k4ank");
'use client';
const $9698d998622c3ed6$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $9698d998622c3ed6$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $9698d998622c3ed6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $iMOmE.default)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $gD0A5.getTooltipUtilityClass), classes);
};
const $9698d998622c3ed6$var$TooltipPopper = (0, $anJSP.default)((0, $cWqfz.default), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $eJfrs.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none'
    }, !ownerState.disableInteractive && {
        pointerEvents: 'auto'
    }, !open && {
        pointerEvents: 'none'
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $gD0A5.default).arrow}`]: {
            top: 0,
            marginTop: '-0.71em',
            '&::before': {
                transformOrigin: '0 100%'
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $gD0A5.default).arrow}`]: {
            bottom: 0,
            marginBottom: '-0.71em',
            '&::before': {
                transformOrigin: '100% 0'
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $gD0A5.default).arrow}`]: (0, $eJfrs.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: '-0.71em'
        } : {
            right: 0,
            marginRight: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '100% 100%'
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $gD0A5.default).arrow}`]: (0, $eJfrs.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: '-0.71em'
        } : {
            left: 0,
            marginLeft: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '0 0'
            }
        })
    }));
const $9698d998622c3ed6$var$TooltipTooltip = (0, $anJSP.default)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $iMOmE.default)(ownerState.placement.split('-')[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $aBrLz.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: 'relative',
        margin: 0
    }, ownerState.touch && {
        padding: '8px 16px',
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$9698d998622c3ed6$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $gD0A5.default).popper}[data-popper-placement*="left"] &`]: (0, $eJfrs.default)({
            transformOrigin: 'right center'
        }, !ownerState.isRtl ? (0, $eJfrs.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        }) : (0, $eJfrs.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        })),
        [`.${(0, $gD0A5.default).popper}[data-popper-placement*="right"] &`]: (0, $eJfrs.default)({
            transformOrigin: 'left center'
        }, !ownerState.isRtl ? (0, $eJfrs.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        }) : (0, $eJfrs.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        })),
        [`.${(0, $gD0A5.default).popper}[data-popper-placement*="top"] &`]: (0, $eJfrs.default)({
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        }, ownerState.touch && {
            marginBottom: '24px'
        }),
        [`.${(0, $gD0A5.default).popper}[data-popper-placement*="bottom"] &`]: (0, $eJfrs.default)({
            transformOrigin: 'center top',
            marginTop: '14px'
        }, ownerState.touch && {
            marginTop: '24px'
        })
    }));
const $9698d998622c3ed6$var$TooltipArrow = (0, $anJSP.default)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow',
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $aBrLz.alpha)(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    }));
let $9698d998622c3ed6$var$hystersisOpen = false;
const $9698d998622c3ed6$var$hystersisTimer = new (0, $efgnF.Timeout)();
let $9698d998622c3ed6$var$cursorPosition = {
    x: 0,
    y: 0
};
function $9698d998622c3ed6$export$b9ee5a7ace0541f8() {
    $9698d998622c3ed6$var$hystersisOpen = false;
    $9698d998622c3ed6$var$hystersisTimer.clear();
}
function $9698d998622c3ed6$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $9698d998622c3ed6$var$Tooltip = /*#__PURE__*/ $8T3gX.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $6CjWJ.default), TransitionProps: TransitionProps } = props, other = (0, $fAJB5.default)(props, $9698d998622c3ed6$var$_excluded);
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $8T3gX.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $k4ank.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $4nWZ9.default)();
    const isRtl = (0, $yILjC.useRtl)();
    const [childNode, setChildNode] = $8T3gX.useState();
    const [arrowRef, setArrowRef] = $8T3gX.useState(null);
    const ignoreNonTouchEvents = $8T3gX.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $efgnF.default)();
    const enterTimer = (0, $efgnF.default)();
    const leaveTimer = (0, $efgnF.default)();
    const touchTimer = (0, $efgnF.default)();
    const [openState, setOpenState] = (0, $7Wcl5.default)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { current: isControlled } = $8T3gX.useRef(openProp !== undefined);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8T3gX.useEffect(()=>{
            if (childNode && childNode.disabled && !isControlled && title !== '' && childNode.tagName.toLowerCase() === 'button') console.error([
                'MUI: You are providing a disabled `button` child to the Tooltip component.',
                'A disabled element does not fire events.',
                "Tooltip needs to listen to the child element's events to display the title.",
                '',
                'Add a simple wrapper element, such as a `span`.'
            ].join('\n'));
        }, [
            title,
            childNode,
            isControlled
        ]);
    }
    const id = (0, $1xq4a.default)(idProp);
    const prevUserSelect = $8T3gX.useRef();
    const stopTouchInteraction = (0, $7F3bH.default)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $8T3gX.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $9698d998622c3ed6$var$hystersisTimer.clear();
        $9698d998622c3ed6$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $7F3bH.default)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $9698d998622c3ed6$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $9698d998622c3ed6$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $9698d998622c3ed6$var$hystersisOpen && enterNextDelay) enterTimer.start($9698d998622c3ed6$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $4J28n.default)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $8T3gX.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $8T3gX.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $11ydL.default)((0, $jphfx.default)(children), focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $8T3gX.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $9698d998622c3ed6$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $eJfrs.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $iVyaN.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    childrenProps['data-mui-internal-clone-element'] = true;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8T3gX.useEffect(()=>{
        if (childNode && !childNode.getAttribute('data-mui-internal-clone-element')) console.error([
            'MUI: The `children` component of the Tooltip is not forwarding its props correctly.',
            'Please make sure that props are spread on the same element that the ref is applied to.'
        ].join('\n'));
    }, [
        childNode
    ]);
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $9698d998622c3ed6$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $9698d998622c3ed6$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $9698d998622c3ed6$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $9698d998622c3ed6$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    if (children.props.title) console.error([
        'MUI: You have provided a `title` prop to the child of <Tooltip />.',
        `Remove this title prop \`${children.props.title}\` or the Tooltip component.`
    ].join('\n'));
    const popperOptions = $8T3gX.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $eJfrs.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $eJfrs.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $9698d998622c3ed6$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $9698d998622c3ed6$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $6CjWJ.default);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $9698d998622c3ed6$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $9698d998622c3ed6$var$TooltipArrow;
    const popperProps = (0, $3s57T.default)(PopperComponent, (0, $eJfrs.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $iVyaN.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $3s57T.default)(TransitionComponent, (0, $eJfrs.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $3s57T.default)(TooltipComponent, (0, $eJfrs.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $iVyaN.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $3s57T.default)(ArrowComponent, (0, $eJfrs.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $iVyaN.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsxs)($8T3gX.Fragment, {
        children: [
            /*#__PURE__*/ $8T3gX.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $k4ank.jsx)(PopperComponent, (0, $eJfrs.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $cWqfz.default),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $9698d998622c3ed6$var$cursorPosition.y,
                            left: $9698d998622c3ed6$var$cursorPosition.x,
                            right: $9698d998622c3ed6$var$cursorPosition.x,
                            bottom: $9698d998622c3ed6$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $k4ank.jsx)(TransitionComponent, (0, $eJfrs.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)(TooltipComponent, (0, $eJfrs.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $k4ank.jsx)(ArrowComponent, (0, $eJfrs.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
$9698d998622c3ed6$var$Tooltip.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */ arrow: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Tooltip reference element.
   */ children: (0, $evygD.default).isRequired,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        Arrow: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        Popper: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        Tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        Transition: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        arrow: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        popper: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        transition: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    }),
    /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */ describeChild: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Do not respond to focus-visible events.
   * @default false
   */ disableFocusListener: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Do not respond to hover events.
   * @default false
   */ disableHoverListener: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */ disableInteractive: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Do not respond to long press touch events.
   * @default false
   */ disableTouchListener: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */ enterDelay: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */ enterNextDelay: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */ enterTouchDelay: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */ followCursor: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */ leaveDelay: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */ leaveTouchDelay: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Tooltip placement.
   * @default 'bottom'
   */ placement: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'bottom-end',
        'bottom-start',
        'bottom',
        'left-end',
        'left-start',
        'left',
        'right-end',
        'right-start',
        'right',
        'top-end',
        'top-start',
        'top'
    ]),
    /**
   * The component used for the popper.
   * @default Popper
   */ PopperComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * Props applied to the [`Popper`](/material-ui/api/popper/) element.
   * @default {}
   */ PopperProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        arrow: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        popper: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        transition: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    }),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        arrow: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        popper: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        transition: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */ title: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */ TransitionComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   */ TransitionProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
};
var $9698d998622c3ed6$export$2e2bcd8739ae039 = $9698d998622c3ed6$var$Tooltip;

});
parcelRegister("evygD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8fe8ab579f01886$export$2e2bcd8739ae039);

var $fdGrT = parcelRequire("fdGrT");

var $bPpmJ = parcelRequire("bPpmJ");
function $a8fe8ab579f01886$var$isClassComponent(elementType) {
    // elementType.prototype?.isReactComponent
    const { prototype: prototype = {} } = elementType;
    return Boolean(prototype.isReactComponent);
}
function $a8fe8ab579f01886$var$acceptingRef(props, propName, componentName, location, propFullName) {
    const element = props[propName];
    const safePropName = propFullName || propName;
    if (element == null || // When server-side rendering React doesn't warn either.
    // This is not an accurate check for SSR.
    // This is only in place for Emotion compat.
    // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
    typeof window === 'undefined') return null;
    let warningHint;
    const elementType = element.type;
    /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */ if (typeof elementType === 'function' && !$a8fe8ab579f01886$var$isClassComponent(elementType)) warningHint = 'Did you accidentally use a plain function component for an element instead?';
    if (warningHint !== undefined) return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element that can hold a ref. ${warningHint} ` + 'For more information see https://mui.com/r/caveat-with-refs-guide');
    return null;
}
const $a8fe8ab579f01886$var$elementAcceptingRef = (0, $bPpmJ.default)((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element, $a8fe8ab579f01886$var$acceptingRef);
$a8fe8ab579f01886$var$elementAcceptingRef.isRequired = (0, $bPpmJ.default)((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element.isRequired, $a8fe8ab579f01886$var$acceptingRef);
var $a8fe8ab579f01886$export$2e2bcd8739ae039 = $a8fe8ab579f01886$var$elementAcceptingRef;

});

parcelRegister("3s57T", function(module, exports) {

$parcel$export(module.exports, "default", () => $2837f69add685faf$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $lkMit = parcelRequire("lkMit");
/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $2837f69add685faf$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $lkMit.default)(elementType)) return otherProps;
    return (0, $eJfrs.default)({}, otherProps, {
        ownerState: (0, $eJfrs.default)({}, otherProps.ownerState, ownerState)
    });
}
var $2837f69add685faf$export$2e2bcd8739ae039 = $2837f69add685faf$var$appendOwnerState;

});
parcelRegister("lkMit", function(module, exports) {

$parcel$export(module.exports, "default", () => $f880edfdbb39a874$export$2e2bcd8739ae039);
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $f880edfdbb39a874$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $f880edfdbb39a874$export$2e2bcd8739ae039 = $f880edfdbb39a874$var$isHostComponent;

});


parcelRegister("jphfx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e20dbb8f61514c02$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");
function $e20dbb8f61514c02$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($8T3gX.version, 10) >= 19) {
        var _element$props;
        return (element == null || (_element$props = element.props) == null ? void 0 : _element$props.ref) || null;
    }
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return (element == null ? void 0 : element.ref) || null;
}

});

parcelRegister("4nWZ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $331710ae8155a219$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");

var $a4EsH = parcelRequire("a4EsH");

var $ehyEf = parcelRequire("ehyEf");

var $kuBjs = parcelRequire("kuBjs");
'use client';
function $331710ae8155a219$export$2e2bcd8739ae039() {
    const theme = (0, $a4EsH.default)((0, $ehyEf.default));
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8T3gX.useDebugValue(theme);
    return theme[0, $kuBjs.default] || theme;
}

});

parcelRegister("6CjWJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d15c39d5cd9f9d3$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $efgnF = parcelRequire("efgnF");

var $evygD = parcelRequire("evygD");

var $jphfx = parcelRequire("jphfx");

var $8zaeI = parcelRequire("8zaeI");

var $4nWZ9 = parcelRequire("4nWZ9");

var $9Pc8j = parcelRequire("9Pc8j");

var $11ydL = parcelRequire("11ydL");

var $k4ank = parcelRequire("k4ank");
'use client';
const $4d15c39d5cd9f9d3$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $4d15c39d5cd9f9d3$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $4d15c39d5cd9f9d3$var$styles = {
    entering: {
        opacity: 1,
        transform: $4d15c39d5cd9f9d3$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $4d15c39d5cd9f9d3$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $4d15c39d5cd9f9d3$var$Grow = /*#__PURE__*/ $8T3gX.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $8zaeI.default) } = props, other = (0, $fAJB5.default)(props, $4d15c39d5cd9f9d3$var$_excluded);
    const timer = (0, $efgnF.default)();
    const autoTimeout = $8T3gX.useRef();
    const theme = (0, $4nWZ9.default)();
    const nodeRef = $8T3gX.useRef(null);
    const handleRef = (0, $11ydL.default)(nodeRef, (0, $jphfx.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $9Pc8j.reflow)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $9Pc8j.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $4d15c39d5cd9f9d3$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $9Pc8j.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $4d15c39d5cd9f9d3$var$isWebKit154 ? duration : duration * 0.666,
                delay: $4d15c39d5cd9f9d3$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $4d15c39d5cd9f9d3$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)(TransitionComponent, (0, $eJfrs.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $8T3gX.cloneElement(children, (0, $eJfrs.default)({
                style: (0, $eJfrs.default)({
                    opacity: 0,
                    transform: $4d15c39d5cd9f9d3$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $4d15c39d5cd9f9d3$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$4d15c39d5cd9f9d3$var$Grow.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */ addEndListener: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */ appear: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * A single child content element.
   */ children: (0, $evygD.default).isRequired,
    /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */ easing: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * If `true`, the component will transition in.
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * @ignore
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */ timeout: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'auto'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number
        })
    ])
};
$4d15c39d5cd9f9d3$var$Grow.muiSupportAuto = true;
var $4d15c39d5cd9f9d3$export$2e2bcd8739ae039 = $4d15c39d5cd9f9d3$var$Grow;

});
parcelRegister("8zaeI", function(module, exports) {

$parcel$export(module.exports, "default", () => $63c98853081657d7$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $8pync = parcelRequire("8pync");

var $fdGrT = parcelRequire("fdGrT");

var $8T3gX = parcelRequire("8T3gX");

var $8VQWA = parcelRequire("8VQWA");

var $jm68S = parcelRequire("jm68S");

var $9eunv = parcelRequire("9eunv");

var $7y2hj = parcelRequire("7y2hj");

var $hLM6y = parcelRequire("hLM6y");
var $63c98853081657d7$export$bb38bb9a1161268 = 'unmounted';
var $63c98853081657d7$export$84cbff306f539230 = 'exited';
var $63c98853081657d7$export$df38205c966be359 = 'entering';
var $63c98853081657d7$export$78e9e6e3e014d60a = 'entered';
var $63c98853081657d7$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $63c98853081657d7$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $8pync.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $63c98853081657d7$export$84cbff306f539230;
                _this.appearStatus = $63c98853081657d7$export$df38205c966be359;
            } else initialStatus = $63c98853081657d7$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $63c98853081657d7$export$bb38bb9a1161268;
        else initialStatus = $63c98853081657d7$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $63c98853081657d7$export$bb38bb9a1161268) return {
            status: $63c98853081657d7$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $63c98853081657d7$export$df38205c966be359 && status !== $63c98853081657d7$export$78e9e6e3e014d60a) nextStatus = $63c98853081657d7$export$df38205c966be359;
            } else if (status === $63c98853081657d7$export$df38205c966be359 || status === $63c98853081657d7$export$78e9e6e3e014d60a) nextStatus = $63c98853081657d7$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $63c98853081657d7$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($8VQWA))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $hLM6y.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $63c98853081657d7$export$84cbff306f539230) this.setState({
            status: $63c98853081657d7$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($8VQWA))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $jm68S.default).disabled) {
            this.safeSetState({
                status: $63c98853081657d7$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $63c98853081657d7$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $63c98853081657d7$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($8VQWA))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $jm68S.default).disabled) {
            this.safeSetState({
                status: $63c98853081657d7$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $63c98853081657d7$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $63c98853081657d7$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($8VQWA))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $63c98853081657d7$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $fAJB5.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $7y2hj.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Component);
$63c98853081657d7$var$Transition.contextType = (0, $7y2hj.default);
$63c98853081657d7$var$Transition.propTypes = {
    /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */ nodeRef: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        current: typeof Element === 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any : function(propValue, key, componentName, location, propFullName, secret) {
            var value = propValue[key];
            return (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
        }
    }),
    /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element.isRequired
    ]).isRequired,
    /**
   * Show the component; triggers the enter or exit states
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */ mountOnEnter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */ unmountOnExit: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */ appear: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Enable or disable enter transitions.
   */ enter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Enable or disable exit transitions.
   */ exit: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */ timeout: function timeout(props) {
        var pt = (0, $9eunv.timeoutsShape);
        if (!props.addEndListener) pt = pt.isRequired;
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return pt.apply(void 0, [
            props
        ].concat(args));
    },
    /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */ addEndListener: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
}; // Name the function so it is clearer in the documentation
function $63c98853081657d7$var$noop() {}
$63c98853081657d7$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $63c98853081657d7$var$noop,
    onEntering: $63c98853081657d7$var$noop,
    onEntered: $63c98853081657d7$var$noop,
    onExit: $63c98853081657d7$var$noop,
    onExiting: $63c98853081657d7$var$noop,
    onExited: $63c98853081657d7$var$noop
};
$63c98853081657d7$var$Transition.UNMOUNTED = $63c98853081657d7$export$bb38bb9a1161268;
$63c98853081657d7$var$Transition.EXITED = $63c98853081657d7$export$84cbff306f539230;
$63c98853081657d7$var$Transition.ENTERING = $63c98853081657d7$export$df38205c966be359;
$63c98853081657d7$var$Transition.ENTERED = $63c98853081657d7$export$78e9e6e3e014d60a;
$63c98853081657d7$var$Transition.EXITING = $63c98853081657d7$export$4aacc83d4d59139f;
var $63c98853081657d7$export$2e2bcd8739ae039 = $63c98853081657d7$var$Transition;

});
parcelRegister("8VQWA", function(module, exports) {
'use strict';
function $680cb73086b60533$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
}

module.exports = (parcelRequire("dSyRI"));

});

parcelRegister("jm68S", function(module, exports) {

$parcel$export(module.exports, "default", () => $e174d6163163820e$export$2e2bcd8739ae039);
var $e174d6163163820e$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("9eunv", function(module, exports) {

$parcel$export(module.exports, "timeoutsShape", () => $6b8cfc50032e9d65$export$3458ee1082941f5e);
$parcel$export(module.exports, "classNamesShape", () => $6b8cfc50032e9d65$export$d61341ca8ef7c732);

var $fdGrT = parcelRequire("fdGrT");
var $6b8cfc50032e9d65$export$3458ee1082941f5e = (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        appear: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number
    }).isRequired
]);
var $6b8cfc50032e9d65$export$d61341ca8ef7c732 = (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        active: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        enterDone: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        enterActive: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        exitDone: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        exitActive: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    })
]);

});

parcelRegister("hLM6y", function(module, exports) {

$parcel$export(module.exports, "forceReflow", () => $cefc240922d198a6$export$7d26bbb1236dafd6);
var $cefc240922d198a6$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("9Pc8j", function(module, exports) {

$parcel$export(module.exports, "reflow", () => $727249da511f347f$export$b7a864e1eaef9de5);
$parcel$export(module.exports, "getTransitionProps", () => $727249da511f347f$export$8cb1e9b404609ae9);
const $727249da511f347f$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $727249da511f347f$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}

});


parcelRegister("cWqfz", function(module, exports) {

$parcel$export(module.exports, "default", () => $96bf438eda3fce5b$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $b9uf0 = parcelRequire("b9uf0");

var $dSmkj = parcelRequire("dSmkj");

var $535LO = parcelRequire("535LO");

var $fdGrT = parcelRequire("fdGrT");

var $8T3gX = parcelRequire("8T3gX");

var $90QT1 = parcelRequire("90QT1");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $k4ank = parcelRequire("k4ank");
'use client';
const $96bf438eda3fce5b$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $96bf438eda3fce5b$var$PopperRoot = (0, $anJSP.default)((0, $90QT1.default), {
    name: 'MuiPopper',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $96bf438eda3fce5b$var$Popper = /*#__PURE__*/ $8T3gX.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, (/*@__PURE__*/$parcel$interopDefault($b9uf0)))();
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $fAJB5.default)(props, $96bf438eda3fce5b$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $eJfrs.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $k4ank.jsx)($96bf438eda3fce5b$var$PopperRoot, (0, $eJfrs.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
$96bf438eda3fce5b$var$Popper.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */ anchorEl: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, $535LO.default),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    /**
   * Popper render function or node.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        Root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * The props used for each slot inside the Popper.
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        ])
    }),
    /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, $535LO.default),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */ disablePortal: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */ keepMounted: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */ modifiers: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        data: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        effect: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        enabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
        fn: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        name: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
        options: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        phase: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'afterMain',
            'afterRead',
            'afterWrite',
            'beforeMain',
            'beforeRead',
            'beforeWrite',
            'main',
            'read',
            'write'
        ]),
        requires: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string),
        requiresIfExists: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string)
    })),
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool.isRequired,
    /**
   * Popper placement.
   * @default 'bottom'
   */ placement: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'auto-end',
        'auto-start',
        'auto',
        'bottom-end',
        'bottom-start',
        'bottom',
        'left-end',
        'left-start',
        'left',
        'right-end',
        'right-start',
        'right',
        'top-end',
        'top-start',
        'top'
    ]),
    /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */ popperOptions: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        modifiers: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array,
        onFirstUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        placement: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'auto-end',
            'auto-start',
            'auto',
            'bottom-end',
            'bottom-start',
            'bottom',
            'left-end',
            'left-start',
            'left',
            'right-end',
            'right-start',
            'right',
            'top-end',
            'top-start',
            'top'
        ]),
        strategy: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'absolute',
            'fixed'
        ])
    }),
    /**
   * A ref that points to the used popper instance.
   */ popperRef: (0, $dSmkj.default),
    /**
   * The props used for each slot inside the Popper.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        ])
    }),
    /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */ transition: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
};
var $96bf438eda3fce5b$export$2e2bcd8739ae039 = $96bf438eda3fce5b$var$Popper;

});
parcelRegister("b9uf0", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81e7fe31b4cde8d4$var$React = $81e7fe31b4cde8d4$var$_interopRequireWildcard((parcelRequire("8T3gX")));
parcelRequire("3JV9M");
var $iHk77 = parcelRequire("iHk77");
function $81e7fe31b4cde8d4$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($81e7fe31b4cde8d4$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $81e7fe31b4cde8d4$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $81e7fe31b4cde8d4$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $81e7fe31b4cde8d4$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $81e7fe31b4cde8d4$var$useTheme(defaultTheme = null) {
    const contextTheme = $81e7fe31b4cde8d4$var$React.useContext($iHk77.T);
    return !contextTheme || $81e7fe31b4cde8d4$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $81e7fe31b4cde8d4$var$_default = module.exports.default = $81e7fe31b4cde8d4$var$useTheme;

});

parcelRegister("535LO", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ad1b5694f3ef562$export$2e2bcd8739ae039);
function $3ad1b5694f3ef562$export$2e2bcd8739ae039(props, propName, componentName, location, propFullName) {
    const propValue = props[propName];
    const safePropName = propFullName || propName;
    if (propValue == null) return null;
    if (propValue && propValue.nodeType !== 1) return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an HTMLElement.`);
    return null;
}

});

parcelRegister("90QT1", function(module, exports) {

$parcel$export(module.exports, "default", () => $68fd2345e031421b$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $bPpmJ = parcelRequire("bPpmJ");
var $535LO = parcelRequire("535LO");
var $dSmkj = parcelRequire("dSmkj");
var $iYkpH = parcelRequire("iYkpH");
var $5IwAt = parcelRequire("5IwAt");
var $ktSDD = parcelRequire("ktSDD");

var $iyO3v = parcelRequire("iyO3v");

var $fdGrT = parcelRequire("fdGrT");

var $aYNpO = parcelRequire("aYNpO");

var $6zZUJ = parcelRequire("6zZUJ");

var $gVgDF = parcelRequire("gVgDF");

var $9Jk1k = parcelRequire("9Jk1k");

var $k4ank = parcelRequire("k4ank");
'use client';
const $68fd2345e031421b$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $68fd2345e031421b$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $68fd2345e031421b$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $68fd2345e031421b$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $68fd2345e031421b$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $68fd2345e031421b$var$isVirtualElement(element) {
    return !$68fd2345e031421b$var$isHTMLElement(element);
}
const $68fd2345e031421b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $9Jk1k.getPopperUtilityClass), classes);
};
const $68fd2345e031421b$var$defaultPopperOptions = {};
const $68fd2345e031421b$var$PopperTooltip = /*#__PURE__*/ $8T3gX.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $fAJB5.default)(props, $68fd2345e031421b$var$_excluded);
    const tooltipRef = $8T3gX.useRef(null);
    const ownRef = (0, $ktSDD.default)(tooltipRef, forwardedRef);
    const popperRef = $8T3gX.useRef(null);
    const handlePopperRef = (0, $ktSDD.default)(popperRef, popperRefProp);
    const handlePopperRefRef = $8T3gX.useRef(handlePopperRef);
    (0, $5IwAt.default)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $8T3gX.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $68fd2345e031421b$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $8T3gX.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $8T3gX.useState($68fd2345e031421b$var$resolveAnchorEl(anchorEl));
    $8T3gX.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $8T3gX.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($68fd2345e031421b$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $5IwAt.default)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        if (resolvedAnchorElement && $68fd2345e031421b$var$isHTMLElement(resolvedAnchorElement) && resolvedAnchorElement.nodeType === 1) {
            const box = resolvedAnchorElement.getBoundingClientRect();
            if (box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) console.warn([
                'MUI: The `anchorEl` prop provided to the component is invalid.',
                'The anchor element should be part of the document layout.',
                "Make sure the element is present in the document or that it's not display none."
            ].join('\n'));
        }
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $iyO3v.createPopper)(resolvedAnchorElement, tooltipRef.current, (0, $eJfrs.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $68fd2345e031421b$var$useUtilityClasses(props);
    const Root = (_slots$root = slots.root) != null ? _slots$root : 'div';
    const rootProps = (0, $6zZUJ.default)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)(Root, (0, $eJfrs.default)({}, rootProps, {
        children: typeof children === 'function' ? children(childProps) : children
    }));
});
/**
 * @ignore - internal component.
 */ const $68fd2345e031421b$var$Popper = /*#__PURE__*/ $8T3gX.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $68fd2345e031421b$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $fAJB5.default)(props, $68fd2345e031421b$var$_excluded2);
    const [exited, setExited] = $8T3gX.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $68fd2345e031421b$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $68fd2345e031421b$var$isHTMLElement(resolvedAnchorEl) ? (0, $iYkpH.default)(resolvedAnchorEl).body : (0, $iYkpH.default)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $gVgDF.default), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $k4ank.jsx)($68fd2345e031421b$var$PopperTooltip, (0, $eJfrs.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $eJfrs.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});
$68fd2345e031421b$var$Popper.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */ anchorEl: (0, $bPpmJ.default)((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, $535LO.default),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]), (props)=>{
        if (props.open) {
            const resolvedAnchorEl = $68fd2345e031421b$var$resolveAnchorEl(props.anchorEl);
            if (resolvedAnchorEl && $68fd2345e031421b$var$isHTMLElement(resolvedAnchorEl) && resolvedAnchorEl.nodeType === 1) {
                const box = resolvedAnchorEl.getBoundingClientRect();
                if (box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) return new Error([
                    'MUI: The `anchorEl` prop provided to the component is invalid.',
                    'The anchor element should be part of the document layout.',
                    "Make sure the element is present in the document or that it's not display none."
                ].join('\n'));
            } else if (!resolvedAnchorEl || typeof resolvedAnchorEl.getBoundingClientRect !== 'function' || $68fd2345e031421b$var$isVirtualElement(resolvedAnchorEl) && resolvedAnchorEl.contextElement != null && resolvedAnchorEl.contextElement.nodeType !== 1) return new Error([
                'MUI: The `anchorEl` prop provided to the component is invalid.',
                'It should be an HTML element instance or a virtualElement ',
                '(https://popper.js.org/docs/v2/virtual-elements/).'
            ].join('\n'));
        }
        return null;
    }),
    /**
   * Popper render function or node.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, $535LO.default),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    /**
   * Direction of the text.
   * @default 'ltr'
   */ direction: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'ltr',
        'rtl'
    ]),
    /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */ disablePortal: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */ keepMounted: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */ modifiers: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        data: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        effect: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        enabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
        fn: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        name: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
        options: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        phase: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'afterMain',
            'afterRead',
            'afterWrite',
            'beforeMain',
            'beforeRead',
            'beforeWrite',
            'main',
            'read',
            'write'
        ]),
        requires: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string),
        requiresIfExists: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string)
    })),
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool.isRequired,
    /**
   * Popper placement.
   * @default 'bottom'
   */ placement: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'auto-end',
        'auto-start',
        'auto',
        'bottom-end',
        'bottom-start',
        'bottom',
        'left-end',
        'left-start',
        'left',
        'right-end',
        'right-start',
        'right',
        'top-end',
        'top-start',
        'top'
    ]),
    /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */ popperOptions: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        modifiers: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array,
        onFirstUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        placement: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'auto-end',
            'auto-start',
            'auto',
            'bottom-end',
            'bottom-start',
            'bottom',
            'left-end',
            'left-start',
            'left',
            'right-end',
            'right-start',
            'right',
            'top-end',
            'top-start',
            'top'
        ]),
        strategy: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'absolute',
            'fixed'
        ])
    }),
    /**
   * A ref that points to the used popper instance.
   */ popperRef: (0, $dSmkj.default),
    /**
   * The props used for each slot inside the Popper.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        ])
    }),
    /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */ transition: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
};
var $68fd2345e031421b$export$2e2bcd8739ae039 = $68fd2345e031421b$var$Popper;

});
parcelRegister("iYkpH", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcfdaa4653b45dad$export$2e2bcd8739ae039);
function $dcfdaa4653b45dad$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});

parcelRegister("iyO3v", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $d8323af70d652c87$export$8f7491d57c8f97a9);

var $3avKL = parcelRequire("3avKL");

var $eAk6p = parcelRequire("eAk6p");

var $imfes = parcelRequire("imfes");

var $a8Ch2 = parcelRequire("a8Ch2");

var $4ph1f = parcelRequire("4ph1f");

var $35meK = parcelRequire("35meK");

var $lOMKQ = parcelRequire("lOMKQ");

var $l20yc = parcelRequire("l20yc");

var $3L6o9 = parcelRequire("3L6o9");

var $9UuMu = parcelRequire("9UuMu");


var $d8323af70d652c87$export$d34966752335dd47 = [
    (0, $eAk6p.default),
    (0, $imfes.default),
    (0, $a8Ch2.default),
    (0, $4ph1f.default),
    (0, $35meK.default),
    (0, $lOMKQ.default),
    (0, $l20yc.default),
    (0, $3L6o9.default),
    (0, $9UuMu.default)
];
var $d8323af70d652c87$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $3avKL.popperGenerator)({
    defaultModifiers: $d8323af70d652c87$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("3avKL", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $24eaefd2719d2aa6$export$ed5e13716264f202);

var $12bsl = parcelRequire("12bsl");

var $iPNbb = parcelRequire("iPNbb");

var $l6GL7 = parcelRequire("l6GL7");

var $anj20 = parcelRequire("anj20");

var $3lcfq = parcelRequire("3lcfq");

var $kUpj1 = parcelRequire("kUpj1");

var $3x4ly = parcelRequire("3x4ly");


var $hJxNX = parcelRequire("hJxNX");
var $24eaefd2719d2aa6$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $24eaefd2719d2aa6$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $24eaefd2719d2aa6$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $24eaefd2719d2aa6$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $24eaefd2719d2aa6$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $hJxNX.isElement)(reference) ? (0, $l6GL7.default)(reference) : reference.contextElement ? (0, $l6GL7.default)(reference.contextElement) : [],
                    popper: (0, $l6GL7.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $3lcfq.default)((0, $3x4ly.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$24eaefd2719d2aa6$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $12bsl.default)(reference, (0, $anj20.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $iPNbb.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $kUpj1.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$24eaefd2719d2aa6$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $24eaefd2719d2aa6$export$8f7491d57c8f97a9 = /*#__PURE__*/ $24eaefd2719d2aa6$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("12bsl", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c0edd5357dd8095$export$2e2bcd8739ae039);

var $gGOR7 = parcelRequire("gGOR7");

var $9vgAv = parcelRequire("9vgAv");

var $382rv = parcelRequire("382rv");

var $hJxNX = parcelRequire("hJxNX");

var $aaJpK = parcelRequire("aaJpK");

var $aTyuP = parcelRequire("aTyuP");

var $kOIiL = parcelRequire("kOIiL");

var $4T2Xk = parcelRequire("4T2Xk");
function $0c0edd5357dd8095$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $4T2Xk.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $4T2Xk.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $0c0edd5357dd8095$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $hJxNX.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $hJxNX.isHTMLElement)(offsetParent) && $0c0edd5357dd8095$var$isElementScaled(offsetParent);
    var documentElement = (0, $aTyuP.default)(offsetParent);
    var rect = (0, $gGOR7.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $382rv.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $kOIiL.default)(documentElement)) scroll = (0, $9vgAv.default)(offsetParent);
        if ((0, $hJxNX.isHTMLElement)(offsetParent)) {
            offsets = (0, $gGOR7.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $aaJpK.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("gGOR7", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2680477c37fb5a3$export$2e2bcd8739ae039);

var $hJxNX = parcelRequire("hJxNX");

var $4T2Xk = parcelRequire("4T2Xk");

var $l9iRk = parcelRequire("l9iRk");

var $hcuEh = parcelRequire("hcuEh");
function $c2680477c37fb5a3$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $hJxNX.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $4T2Xk.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $4T2Xk.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $hJxNX.isElement)(element) ? (0, $l9iRk.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $hcuEh.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("hJxNX", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $ce90dc91d0bd7dc4$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $ce90dc91d0bd7dc4$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $ce90dc91d0bd7dc4$export$af51f0f06c0f328a);

var $l9iRk = parcelRequire("l9iRk");
function $ce90dc91d0bd7dc4$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $l9iRk.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $ce90dc91d0bd7dc4$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $l9iRk.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $ce90dc91d0bd7dc4$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $l9iRk.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("l9iRk", function(module, exports) {

$parcel$export(module.exports, "default", () => $f659113f03b12fca$export$2e2bcd8739ae039);
function $f659113f03b12fca$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("4T2Xk", function(module, exports) {

$parcel$export(module.exports, "max", () => $38ee9771f559a928$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $38ee9771f559a928$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $38ee9771f559a928$export$2077e0241d6afd3c);
var $38ee9771f559a928$export$8960430cfd85939f = Math.max;
var $38ee9771f559a928$export$96ec731ed4dcb222 = Math.min;
var $38ee9771f559a928$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("hcuEh", function(module, exports) {

$parcel$export(module.exports, "default", () => $c85b54d3842b7dda$export$2e2bcd8739ae039);

var $gd62m = parcelRequire("gd62m");
function $c85b54d3842b7dda$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $gd62m.default)());
}

});
parcelRegister("gd62m", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcd28b18f47ab544$export$2e2bcd8739ae039);
function $bcd28b18f47ab544$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("9vgAv", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eb3e04ca87eb825$export$2e2bcd8739ae039);

var $lcUfq = parcelRequire("lcUfq");

var $l9iRk = parcelRequire("l9iRk");

var $hJxNX = parcelRequire("hJxNX");

var $d4Vj6 = parcelRequire("d4Vj6");
function $6eb3e04ca87eb825$export$2e2bcd8739ae039(node) {
    if (node === (0, $l9iRk.default)(node) || !(0, $hJxNX.isHTMLElement)(node)) return (0, $lcUfq.default)(node);
    else return (0, $d4Vj6.default)(node);
}

});
parcelRegister("lcUfq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f70659975ac8a06d$export$2e2bcd8739ae039);

var $l9iRk = parcelRequire("l9iRk");
function $f70659975ac8a06d$export$2e2bcd8739ae039(node) {
    var win = (0, $l9iRk.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("d4Vj6", function(module, exports) {

$parcel$export(module.exports, "default", () => $98581a16bb58dc5d$export$2e2bcd8739ae039);
function $98581a16bb58dc5d$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("382rv", function(module, exports) {

$parcel$export(module.exports, "default", () => $24740385c875974f$export$2e2bcd8739ae039);
function $24740385c875974f$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("aaJpK", function(module, exports) {

$parcel$export(module.exports, "default", () => $767e10e1574f5eb8$export$2e2bcd8739ae039);

var $gGOR7 = parcelRequire("gGOR7");

var $aTyuP = parcelRequire("aTyuP");

var $lcUfq = parcelRequire("lcUfq");
function $767e10e1574f5eb8$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $gGOR7.default)((0, $aTyuP.default)(element)).left + (0, $lcUfq.default)(element).scrollLeft;
}

});
parcelRegister("aTyuP", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ee9ccafe5320d9e$export$2e2bcd8739ae039);

var $hJxNX = parcelRequire("hJxNX");
function $7ee9ccafe5320d9e$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $hJxNX.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("kOIiL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f27ad787c953381c$export$2e2bcd8739ae039);

var $uFCwd = parcelRequire("uFCwd");
function $f27ad787c953381c$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $uFCwd.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("uFCwd", function(module, exports) {

$parcel$export(module.exports, "default", () => $05c3165ff04cf6f6$export$2e2bcd8739ae039);

var $l9iRk = parcelRequire("l9iRk");
function $05c3165ff04cf6f6$export$2e2bcd8739ae039(element) {
    return (0, $l9iRk.default)(element).getComputedStyle(element);
}

});



parcelRegister("iPNbb", function(module, exports) {

$parcel$export(module.exports, "default", () => $db63236a7c9cec33$export$2e2bcd8739ae039);

var $gGOR7 = parcelRequire("gGOR7");
function $db63236a7c9cec33$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $gGOR7.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("l6GL7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5db538d8a482d28$export$2e2bcd8739ae039);

var $gDdUl = parcelRequire("gDdUl");

var $bMGbz = parcelRequire("bMGbz");

var $l9iRk = parcelRequire("l9iRk");

var $kOIiL = parcelRequire("kOIiL");
function $f5db538d8a482d28$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $gDdUl.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $l9iRk.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $kOIiL.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($f5db538d8a482d28$export$2e2bcd8739ae039((0, $bMGbz.default)(target)));
}

});
parcelRegister("gDdUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1bb13ae531d65ad$export$2e2bcd8739ae039);

var $bMGbz = parcelRequire("bMGbz");

var $kOIiL = parcelRequire("kOIiL");

var $382rv = parcelRequire("382rv");

var $hJxNX = parcelRequire("hJxNX");
function $c1bb13ae531d65ad$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $382rv.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $hJxNX.isHTMLElement)(node) && (0, $kOIiL.default)(node)) return node;
    return $c1bb13ae531d65ad$export$2e2bcd8739ae039((0, $bMGbz.default)(node));
}

});
parcelRegister("bMGbz", function(module, exports) {

$parcel$export(module.exports, "default", () => $8944e6967e5326fc$export$2e2bcd8739ae039);

var $382rv = parcelRequire("382rv");

var $aTyuP = parcelRequire("aTyuP");

var $hJxNX = parcelRequire("hJxNX");
function $8944e6967e5326fc$export$2e2bcd8739ae039(element) {
    if ((0, $382rv.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $hJxNX.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $aTyuP.default)(element) // fallback
    );
}

});



parcelRegister("anj20", function(module, exports) {

$parcel$export(module.exports, "default", () => $78dad09516d7bf62$export$2e2bcd8739ae039);

var $l9iRk = parcelRequire("l9iRk");

var $382rv = parcelRequire("382rv");

var $uFCwd = parcelRequire("uFCwd");

var $hJxNX = parcelRequire("hJxNX");

var $4Y6Yk = parcelRequire("4Y6Yk");

var $bMGbz = parcelRequire("bMGbz");

var $gd62m = parcelRequire("gd62m");
function $78dad09516d7bf62$var$getTrueOffsetParent(element) {
    if (!(0, $hJxNX.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $uFCwd.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $78dad09516d7bf62$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $gd62m.default)());
    var isIE = /Trident/i.test((0, $gd62m.default)());
    if (isIE && (0, $hJxNX.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $uFCwd.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $bMGbz.default)(element);
    if ((0, $hJxNX.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $hJxNX.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $382rv.default)(currentNode)) < 0){
        var css = (0, $uFCwd.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $78dad09516d7bf62$export$2e2bcd8739ae039(element) {
    var window = (0, $l9iRk.default)(element);
    var offsetParent = $78dad09516d7bf62$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $4Y6Yk.default)(offsetParent) && (0, $uFCwd.default)(offsetParent).position === 'static')offsetParent = $78dad09516d7bf62$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $382rv.default)(offsetParent) === 'html' || (0, $382rv.default)(offsetParent) === 'body' && (0, $uFCwd.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $78dad09516d7bf62$var$getContainingBlock(element) || window;
}

});
parcelRegister("4Y6Yk", function(module, exports) {

$parcel$export(module.exports, "default", () => $39e22c82a93b5ee1$export$2e2bcd8739ae039);

var $382rv = parcelRequire("382rv");
function $39e22c82a93b5ee1$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $382rv.default)(element)) >= 0;
}

});


parcelRegister("3lcfq", function(module, exports) {

$parcel$export(module.exports, "default", () => $26ecd565ffaac6c2$export$2e2bcd8739ae039);

var $5gGWS = parcelRequire("5gGWS");
function $26ecd565ffaac6c2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $26ecd565ffaac6c2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $26ecd565ffaac6c2$var$order(modifiers); // order based on phase
    return (0, $5gGWS.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("5gGWS", function(module, exports) {

$parcel$export(module.exports, "top", () => $3d5fc3194c7a1a7a$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $3d5fc3194c7a1a7a$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $3d5fc3194c7a1a7a$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $3d5fc3194c7a1a7a$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $3d5fc3194c7a1a7a$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $3d5fc3194c7a1a7a$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $3d5fc3194c7a1a7a$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $3d5fc3194c7a1a7a$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $3d5fc3194c7a1a7a$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $3d5fc3194c7a1a7a$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $3d5fc3194c7a1a7a$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $3d5fc3194c7a1a7a$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $3d5fc3194c7a1a7a$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $3d5fc3194c7a1a7a$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $3d5fc3194c7a1a7a$export$d087d3878fdf71d5);
var $3d5fc3194c7a1a7a$export$1e95b668f3b82d = 'top';
var $3d5fc3194c7a1a7a$export$40e543e69a8b3fbb = 'bottom';
var $3d5fc3194c7a1a7a$export$79ffe56a765070d2 = 'right';
var $3d5fc3194c7a1a7a$export$eabcd2c8791e7bf4 = 'left';
var $3d5fc3194c7a1a7a$export$dfb5619354ba860 = 'auto';
var $3d5fc3194c7a1a7a$export$aec2ce47c367b8c3 = [
    $3d5fc3194c7a1a7a$export$1e95b668f3b82d,
    $3d5fc3194c7a1a7a$export$40e543e69a8b3fbb,
    $3d5fc3194c7a1a7a$export$79ffe56a765070d2,
    $3d5fc3194c7a1a7a$export$eabcd2c8791e7bf4
];
var $3d5fc3194c7a1a7a$export$b3571188c770cc5a = 'start';
var $3d5fc3194c7a1a7a$export$bd5df0f255a350f8 = 'end';
var $3d5fc3194c7a1a7a$export$390fd549c5303b4d = 'clippingParents';
var $3d5fc3194c7a1a7a$export$d7b7311ec04a3e8f = 'viewport';
var $3d5fc3194c7a1a7a$export$ae5ab1c730825774 = 'popper';
var $3d5fc3194c7a1a7a$export$ca50aac9f3ba507f = 'reference';
var $3d5fc3194c7a1a7a$export$368f9a87e87fa4e1 = /*#__PURE__*/ $3d5fc3194c7a1a7a$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $3d5fc3194c7a1a7a$export$b3571188c770cc5a,
        placement + "-" + $3d5fc3194c7a1a7a$export$bd5df0f255a350f8
    ]);
}, []);
var $3d5fc3194c7a1a7a$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($3d5fc3194c7a1a7a$export$aec2ce47c367b8c3, [
    $3d5fc3194c7a1a7a$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $3d5fc3194c7a1a7a$export$b3571188c770cc5a,
        placement + "-" + $3d5fc3194c7a1a7a$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $3d5fc3194c7a1a7a$export$421679a7c3d56e = 'beforeRead';
var $3d5fc3194c7a1a7a$export$aafa59e2e03f2942 = 'read';
var $3d5fc3194c7a1a7a$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $3d5fc3194c7a1a7a$export$c65e99957a05207c = 'beforeMain';
var $3d5fc3194c7a1a7a$export$f22da7240b7add18 = 'main';
var $3d5fc3194c7a1a7a$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $3d5fc3194c7a1a7a$export$8d4d2d70e7d46032 = 'beforeWrite';
var $3d5fc3194c7a1a7a$export$68d8715fc104d294 = 'write';
var $3d5fc3194c7a1a7a$export$70a6e5159acce2e6 = 'afterWrite';
var $3d5fc3194c7a1a7a$export$d087d3878fdf71d5 = [
    $3d5fc3194c7a1a7a$export$421679a7c3d56e,
    $3d5fc3194c7a1a7a$export$aafa59e2e03f2942,
    $3d5fc3194c7a1a7a$export$6964f6c886723980,
    $3d5fc3194c7a1a7a$export$c65e99957a05207c,
    $3d5fc3194c7a1a7a$export$f22da7240b7add18,
    $3d5fc3194c7a1a7a$export$bab79516f2d662fe,
    $3d5fc3194c7a1a7a$export$8d4d2d70e7d46032,
    $3d5fc3194c7a1a7a$export$68d8715fc104d294,
    $3d5fc3194c7a1a7a$export$70a6e5159acce2e6
];

});


parcelRegister("kUpj1", function(module, exports) {

$parcel$export(module.exports, "default", () => $f38caace0759de67$export$2e2bcd8739ae039);
function $f38caace0759de67$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("3x4ly", function(module, exports) {

$parcel$export(module.exports, "default", () => $2927d3554fd5dde7$export$2e2bcd8739ae039);
function $2927d3554fd5dde7$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("eAk6p", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9e4055f59e15790$export$2e2bcd8739ae039);

var $l9iRk = parcelRequire("l9iRk");
var $a9e4055f59e15790$var$passive = {
    passive: true
};
function $a9e4055f59e15790$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $l9iRk.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $a9e4055f59e15790$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $a9e4055f59e15790$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $a9e4055f59e15790$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $a9e4055f59e15790$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $a9e4055f59e15790$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $a9e4055f59e15790$var$effect,
    data: {}
};

});

parcelRegister("imfes", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5d618dfea069889$export$2e2bcd8739ae039);

var $2n8dd = parcelRequire("2n8dd");
function $d5d618dfea069889$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $2n8dd.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $d5d618dfea069889$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $d5d618dfea069889$var$popperOffsets,
    data: {}
};

});
parcelRegister("2n8dd", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ba4198637de5691$export$2e2bcd8739ae039);

var $iKq8w = parcelRequire("iKq8w");

var $fk5Bu = parcelRequire("fk5Bu");

var $2A4nf = parcelRequire("2A4nf");

var $5gGWS = parcelRequire("5gGWS");
function $1ba4198637de5691$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $iKq8w.default)(placement) : null;
    var variation = placement ? (0, $fk5Bu.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $5gGWS.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $5gGWS.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $5gGWS.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $5gGWS.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $2A4nf.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $5gGWS.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $5gGWS.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("iKq8w", function(module, exports) {

$parcel$export(module.exports, "default", () => $da60cc05724b5390$export$2e2bcd8739ae039);

function $da60cc05724b5390$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("fk5Bu", function(module, exports) {

$parcel$export(module.exports, "default", () => $b27d120592cd8415$export$2e2bcd8739ae039);
function $b27d120592cd8415$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("2A4nf", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e12562069765758$export$2e2bcd8739ae039);
function $1e12562069765758$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("a8Ch2", function(module, exports) {

$parcel$export(module.exports, "default", () => $7618572090d46bb5$export$2e2bcd8739ae039);

var $5gGWS = parcelRequire("5gGWS");

var $anj20 = parcelRequire("anj20");

var $l9iRk = parcelRequire("l9iRk");

var $aTyuP = parcelRequire("aTyuP");

var $uFCwd = parcelRequire("uFCwd");

var $iKq8w = parcelRequire("iKq8w");

var $fk5Bu = parcelRequire("fk5Bu");

var $4T2Xk = parcelRequire("4T2Xk");
var $7618572090d46bb5$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $7618572090d46bb5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $4T2Xk.round)(x * dpr) / dpr || 0,
        y: (0, $4T2Xk.round)(y * dpr) / dpr || 0
    };
}
function $7618572090d46bb5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $5gGWS.left);
    var sideY = (0, $5gGWS.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $anj20.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $l9iRk.default)(popper)) {
            offsetParent = (0, $aTyuP.default)(popper);
            if ((0, $uFCwd.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $5gGWS.top) || (placement === (0, $5gGWS.left) || placement === (0, $5gGWS.right)) && variation === (0, $5gGWS.end)) {
            sideY = (0, $5gGWS.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $5gGWS.left) || (placement === (0, $5gGWS.top) || placement === (0, $5gGWS.bottom)) && variation === (0, $5gGWS.end)) {
            sideX = (0, $5gGWS.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $7618572090d46bb5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $7618572090d46bb5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $l9iRk.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $7618572090d46bb5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $iKq8w.default)(state.placement),
        variation: (0, $fk5Bu.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $7618572090d46bb5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $7618572090d46bb5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $7618572090d46bb5$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $7618572090d46bb5$var$computeStyles,
    data: {}
};

});

parcelRegister("4ph1f", function(module, exports) {

$parcel$export(module.exports, "default", () => $3356b2dd2d268fa9$export$2e2bcd8739ae039);

var $382rv = parcelRequire("382rv");

var $hJxNX = parcelRequire("hJxNX");
// and applies them to the HTMLElements such as popper and arrow
function $3356b2dd2d268fa9$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $hJxNX.isHTMLElement)(element) || !(0, $382rv.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $3356b2dd2d268fa9$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $hJxNX.isHTMLElement)(element) || !(0, $382rv.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $3356b2dd2d268fa9$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $3356b2dd2d268fa9$var$applyStyles,
    effect: $3356b2dd2d268fa9$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("35meK", function(module, exports) {

$parcel$export(module.exports, "default", () => $23f3168782c4e142$export$2e2bcd8739ae039);

var $iKq8w = parcelRequire("iKq8w");

var $5gGWS = parcelRequire("5gGWS");
function $23f3168782c4e142$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $iKq8w.default)(placement);
    var invertDistance = [
        (0, $5gGWS.left),
        (0, $5gGWS.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $5gGWS.left),
        (0, $5gGWS.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $23f3168782c4e142$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $5gGWS.placements).reduce(function(acc, placement) {
        acc[placement] = $23f3168782c4e142$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $23f3168782c4e142$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $23f3168782c4e142$var$offset
};

});

parcelRegister("lOMKQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe24161ffcb062c4$export$2e2bcd8739ae039);

var $aMD6r = parcelRequire("aMD6r");

var $iKq8w = parcelRequire("iKq8w");

var $eFvKC = parcelRequire("eFvKC");

var $60wJ6 = parcelRequire("60wJ6");

var $7zKIN = parcelRequire("7zKIN");

var $5gGWS = parcelRequire("5gGWS");

var $fk5Bu = parcelRequire("fk5Bu");
function $fe24161ffcb062c4$var$getExpandedFallbackPlacements(placement) {
    if ((0, $iKq8w.default)(placement) === (0, $5gGWS.auto)) return [];
    var oppositePlacement = (0, $aMD6r.default)(placement);
    return [
        (0, $eFvKC.default)(placement),
        oppositePlacement,
        (0, $eFvKC.default)(oppositePlacement)
    ];
}
function $fe24161ffcb062c4$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $iKq8w.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aMD6r.default)(preferredPlacement)
    ] : $fe24161ffcb062c4$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $iKq8w.default)(placement) === (0, $5gGWS.auto) ? (0, $7zKIN.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $iKq8w.default)(placement);
        var isStartVariation = (0, $fk5Bu.default)(placement) === (0, $5gGWS.start);
        var isVertical = [
            (0, $5gGWS.top),
            (0, $5gGWS.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $60wJ6.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $5gGWS.right) : (0, $5gGWS.left) : isStartVariation ? (0, $5gGWS.bottom) : (0, $5gGWS.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aMD6r.default)(mainVariationSide);
        var altVariationSide = (0, $aMD6r.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $fe24161ffcb062c4$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $fe24161ffcb062c4$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("aMD6r", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d9cb813775d7249$export$2e2bcd8739ae039);
var $7d9cb813775d7249$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $7d9cb813775d7249$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $7d9cb813775d7249$var$hash[matched];
    });
}

});

parcelRegister("eFvKC", function(module, exports) {

$parcel$export(module.exports, "default", () => $aadd861e3c08a82e$export$2e2bcd8739ae039);
var $aadd861e3c08a82e$var$hash = {
    start: 'end',
    end: 'start'
};
function $aadd861e3c08a82e$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $aadd861e3c08a82e$var$hash[matched];
    });
}

});

parcelRegister("60wJ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $45fc20f044616735$export$2e2bcd8739ae039);

var $j5ZEV = parcelRequire("j5ZEV");

var $aTyuP = parcelRequire("aTyuP");

var $gGOR7 = parcelRequire("gGOR7");

var $2n8dd = parcelRequire("2n8dd");

var $lVn8B = parcelRequire("lVn8B");

var $5gGWS = parcelRequire("5gGWS");

var $hJxNX = parcelRequire("hJxNX");

var $iyNXX = parcelRequire("iyNXX");

var $jwyGW = parcelRequire("jwyGW");
function $45fc20f044616735$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $5gGWS.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $5gGWS.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $5gGWS.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $iyNXX.default)(typeof padding !== 'number' ? padding : (0, $jwyGW.default)(padding, (0, $5gGWS.basePlacements)));
    var altContext = elementContext === (0, $5gGWS.popper) ? (0, $5gGWS.reference) : (0, $5gGWS.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $j5ZEV.default)((0, $hJxNX.isElement)(element) ? element : element.contextElement || (0, $aTyuP.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $gGOR7.default)(state.elements.reference);
    var popperOffsets = (0, $2n8dd.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $lVn8B.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $5gGWS.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $5gGWS.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $5gGWS.right),
                (0, $5gGWS.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $5gGWS.top),
                (0, $5gGWS.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("j5ZEV", function(module, exports) {

$parcel$export(module.exports, "default", () => $de6e502a98c279b4$export$2e2bcd8739ae039);

var $5gGWS = parcelRequire("5gGWS");

var $jRl0d = parcelRequire("jRl0d");

var $d1aEa = parcelRequire("d1aEa");

var $l6GL7 = parcelRequire("l6GL7");

var $anj20 = parcelRequire("anj20");

var $aTyuP = parcelRequire("aTyuP");

var $uFCwd = parcelRequire("uFCwd");

var $hJxNX = parcelRequire("hJxNX");

var $gGOR7 = parcelRequire("gGOR7");

var $bMGbz = parcelRequire("bMGbz");

var $iefdd = parcelRequire("iefdd");

var $382rv = parcelRequire("382rv");

var $lVn8B = parcelRequire("lVn8B");

var $4T2Xk = parcelRequire("4T2Xk");
function $de6e502a98c279b4$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $gGOR7.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $de6e502a98c279b4$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $5gGWS.viewport) ? (0, $lVn8B.default)((0, $jRl0d.default)(element, strategy)) : (0, $hJxNX.isElement)(clippingParent) ? $de6e502a98c279b4$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $lVn8B.default)((0, $d1aEa.default)((0, $aTyuP.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $de6e502a98c279b4$var$getClippingParents(element) {
    var clippingParents = (0, $l6GL7.default)((0, $bMGbz.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $uFCwd.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $hJxNX.isHTMLElement)(element) ? (0, $anj20.default)(element) : element;
    if (!(0, $hJxNX.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $hJxNX.isElement)(clippingParent) && (0, $iefdd.default)(clippingParent, clipperElement) && (0, $382rv.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $de6e502a98c279b4$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $de6e502a98c279b4$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $de6e502a98c279b4$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $4T2Xk.max)(rect.top, accRect.top);
        accRect.right = (0, $4T2Xk.min)(rect.right, accRect.right);
        accRect.bottom = (0, $4T2Xk.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $4T2Xk.max)(rect.left, accRect.left);
        return accRect;
    }, $de6e502a98c279b4$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("jRl0d", function(module, exports) {

$parcel$export(module.exports, "default", () => $e753423699d3c6ed$export$2e2bcd8739ae039);

var $l9iRk = parcelRequire("l9iRk");

var $aTyuP = parcelRequire("aTyuP");

var $aaJpK = parcelRequire("aaJpK");

var $hcuEh = parcelRequire("hcuEh");
function $e753423699d3c6ed$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $l9iRk.default)(element);
    var html = (0, $aTyuP.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $hcuEh.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $aaJpK.default)(element),
        y: y
    };
}

});

parcelRegister("d1aEa", function(module, exports) {

$parcel$export(module.exports, "default", () => $97a3a0978b6a24aa$export$2e2bcd8739ae039);

var $aTyuP = parcelRequire("aTyuP");

var $uFCwd = parcelRequire("uFCwd");

var $aaJpK = parcelRequire("aaJpK");

var $lcUfq = parcelRequire("lcUfq");

var $4T2Xk = parcelRequire("4T2Xk");
function $97a3a0978b6a24aa$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $aTyuP.default)(element);
    var winScroll = (0, $lcUfq.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $4T2Xk.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $4T2Xk.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $aaJpK.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $uFCwd.default)(body || html).direction === 'rtl') x += (0, $4T2Xk.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("iefdd", function(module, exports) {

$parcel$export(module.exports, "default", () => $d455559d6643e3e6$export$2e2bcd8739ae039);

var $hJxNX = parcelRequire("hJxNX");
function $d455559d6643e3e6$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $hJxNX.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("lVn8B", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff60de83a7912eae$export$2e2bcd8739ae039);
function $ff60de83a7912eae$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("iyNXX", function(module, exports) {

$parcel$export(module.exports, "default", () => $d832292d4a7e030e$export$2e2bcd8739ae039);

var $8BsrV = parcelRequire("8BsrV");
function $d832292d4a7e030e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $8BsrV.default)(), paddingObject);
}

});
parcelRegister("8BsrV", function(module, exports) {

$parcel$export(module.exports, "default", () => $6437d8ea07d7fdb3$export$2e2bcd8739ae039);
function $6437d8ea07d7fdb3$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("jwyGW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e36bea857700f981$export$2e2bcd8739ae039);
function $e36bea857700f981$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("7zKIN", function(module, exports) {

$parcel$export(module.exports, "default", () => $58400b38ff262f97$export$2e2bcd8739ae039);

var $fk5Bu = parcelRequire("fk5Bu");

var $5gGWS = parcelRequire("5gGWS");

var $60wJ6 = parcelRequire("60wJ6");

var $iKq8w = parcelRequire("iKq8w");
function $58400b38ff262f97$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $5gGWS.placements) : _options$allowedAutoP;
    var variation = (0, $fk5Bu.default)(placement);
    var placements = variation ? flipVariations ? (0, $5gGWS.variationPlacements) : (0, $5gGWS.variationPlacements).filter(function(placement) {
        return (0, $fk5Bu.default)(placement) === variation;
    }) : (0, $5gGWS.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $60wJ6.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $iKq8w.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("l20yc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4fa363648893b6c$export$2e2bcd8739ae039);

var $5gGWS = parcelRequire("5gGWS");

var $iKq8w = parcelRequire("iKq8w");

var $2A4nf = parcelRequire("2A4nf");

var $i2mTZ = parcelRequire("i2mTZ");

var $i5055 = parcelRequire("i5055");

var $iPNbb = parcelRequire("iPNbb");

var $anj20 = parcelRequire("anj20");

var $60wJ6 = parcelRequire("60wJ6");

var $fk5Bu = parcelRequire("fk5Bu");

var $8BsrV = parcelRequire("8BsrV");

var $4T2Xk = parcelRequire("4T2Xk");
function $f4fa363648893b6c$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $60wJ6.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $iKq8w.default)(state.placement);
    var variation = (0, $fk5Bu.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $2A4nf.default)(basePlacement);
    var altAxis = (0, $i2mTZ.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $5gGWS.top) : (0, $5gGWS.left);
        var altSide = mainAxis === 'y' ? (0, $5gGWS.bottom) : (0, $5gGWS.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $5gGWS.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $5gGWS.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $iPNbb.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $8BsrV.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $i5055.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $anj20.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $i5055.within)(tether ? (0, $4T2Xk.min)(min, tetherMin) : min, offset, tether ? (0, $4T2Xk.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $5gGWS.top) : (0, $5gGWS.left);
        var _altSide = mainAxis === 'x' ? (0, $5gGWS.bottom) : (0, $5gGWS.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $5gGWS.top),
            (0, $5gGWS.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $i5055.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $i5055.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $f4fa363648893b6c$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $f4fa363648893b6c$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("i2mTZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d21a2dc4a69b9e71$export$2e2bcd8739ae039);
function $d21a2dc4a69b9e71$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("i5055", function(module, exports) {

$parcel$export(module.exports, "within", () => $d298c1b6590d74af$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $d298c1b6590d74af$export$86c8af6d3ef0b4a);

var $4T2Xk = parcelRequire("4T2Xk");
function $d298c1b6590d74af$export$f28d906d67a997f3(min, value, max) {
    return (0, $4T2Xk.max)(min, (0, $4T2Xk.min)(value, max));
}
function $d298c1b6590d74af$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $d298c1b6590d74af$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("3L6o9", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bcab77e97f5aceb$export$2e2bcd8739ae039);

var $iKq8w = parcelRequire("iKq8w");

var $iPNbb = parcelRequire("iPNbb");

var $iefdd = parcelRequire("iefdd");

var $anj20 = parcelRequire("anj20");

var $2A4nf = parcelRequire("2A4nf");

var $i5055 = parcelRequire("i5055");

var $iyNXX = parcelRequire("iyNXX");

var $jwyGW = parcelRequire("jwyGW");

var $5gGWS = parcelRequire("5gGWS");
var $2bcab77e97f5aceb$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $iyNXX.default)(typeof padding !== 'number' ? padding : (0, $jwyGW.default)(padding, (0, $5gGWS.basePlacements)));
};
function $2bcab77e97f5aceb$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $iKq8w.default)(state.placement);
    var axis = (0, $2A4nf.default)(basePlacement);
    var isVertical = [
        (0, $5gGWS.left),
        (0, $5gGWS.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $2bcab77e97f5aceb$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $iPNbb.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $5gGWS.top) : (0, $5gGWS.left);
    var maxProp = axis === 'y' ? (0, $5gGWS.bottom) : (0, $5gGWS.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $anj20.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $i5055.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $2bcab77e97f5aceb$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $iefdd.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $2bcab77e97f5aceb$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $2bcab77e97f5aceb$var$arrow,
    effect: $2bcab77e97f5aceb$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("9UuMu", function(module, exports) {

$parcel$export(module.exports, "default", () => $7371387ed66e3f89$export$2e2bcd8739ae039);

var $5gGWS = parcelRequire("5gGWS");

var $60wJ6 = parcelRequire("60wJ6");
function $7371387ed66e3f89$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $7371387ed66e3f89$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $5gGWS.top),
        (0, $5gGWS.right),
        (0, $5gGWS.bottom),
        (0, $5gGWS.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $7371387ed66e3f89$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $60wJ6.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $60wJ6.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $7371387ed66e3f89$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $7371387ed66e3f89$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $7371387ed66e3f89$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $7371387ed66e3f89$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $7371387ed66e3f89$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $7371387ed66e3f89$var$hide
};

});


parcelRegister("6zZUJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ca609c68b786d65$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $ktSDD = parcelRequire("ktSDD");

var $3s57T = parcelRequire("3s57T");

var $dkv3t = parcelRequire("dkv3t");

var $doXjE = parcelRequire("doXjE");
'use client';
const $4ca609c68b786d65$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $4ca609c68b786d65$var$useSlotProps(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $fAJB5.default)(parameters, $4ca609c68b786d65$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $doXjE.default)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $dkv3t.default)((0, $eJfrs.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $ktSDD.default)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $3s57T.default)(elementType, (0, $eJfrs.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}
var $4ca609c68b786d65$export$2e2bcd8739ae039 = $4ca609c68b786d65$var$useSlotProps;

});
parcelRegister("dkv3t", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b453b82e85eac61$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $iVyaN = parcelRequire("iVyaN");

var $kV4HD = parcelRequire("kV4HD");

var $lKyjg = parcelRequire("lKyjg");
/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $9b453b82e85eac61$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $iVyaN.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $eJfrs.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $eJfrs.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $kV4HD.default)((0, $eJfrs.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $lKyjg.default)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $lKyjg.default)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $iVyaN.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $eJfrs.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $eJfrs.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $9b453b82e85eac61$export$2e2bcd8739ae039 = $9b453b82e85eac61$var$mergeSlotProps;

});
parcelRegister("kV4HD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3acc75efc2a662c$export$2e2bcd8739ae039);
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $f3acc75efc2a662c$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $f3acc75efc2a662c$export$2e2bcd8739ae039 = $f3acc75efc2a662c$var$extractEventHandlers;

});

parcelRegister("lKyjg", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd58820d22dd606d$export$2e2bcd8739ae039);
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $fd58820d22dd606d$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $fd58820d22dd606d$export$2e2bcd8739ae039 = $fd58820d22dd606d$var$omitEventHandlers;

});


parcelRegister("doXjE", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c1b872fc52ab2b4$export$2e2bcd8739ae039);
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $9c1b872fc52ab2b4$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $9c1b872fc52ab2b4$export$2e2bcd8739ae039 = $9c1b872fc52ab2b4$var$resolveComponentProps;

});


parcelRegister("gVgDF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c51ee051b75e7c88$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");

var $8VQWA = parcelRequire("8VQWA");

var $fdGrT = parcelRequire("fdGrT");

var $bNVvr = parcelRequire("bNVvr");
var $535LO = parcelRequire("535LO");
var $jphfx = parcelRequire("jphfx");
var $jmWnJ = parcelRequire("jmWnJ");
var $5IwAt = parcelRequire("5IwAt");
var $ktSDD = parcelRequire("ktSDD");

var $k4ank = parcelRequire("k4ank");
'use client';
function $c51ee051b75e7c88$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $c51ee051b75e7c88$var$Portal = /*#__PURE__*/ $8T3gX.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $8T3gX.useState(null);
    const handleRef = (0, $ktSDD.default)(/*#__PURE__*/ $8T3gX.isValidElement(children) ? (0, $jphfx.default)(children) : null, forwardedRef);
    (0, $5IwAt.default)(()=>{
        if (!disablePortal) setMountNode($c51ee051b75e7c88$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $5IwAt.default)(()=>{
        if (mountNode && !disablePortal) {
            (0, $jmWnJ.default)(forwardedRef, mountNode);
            return ()=>{
                (0, $jmWnJ.default)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $8T3gX.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $8T3gX.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $k4ank.jsx)($8T3gX.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $k4ank.jsx)($8T3gX.Fragment, {
        children: mountNode ? /*#__PURE__*/ $8VQWA.createPortal(children, mountNode) : mountNode
    });
});
$c51ee051b75e7c88$var$Portal.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The children to render into the `container`.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, $535LO.default),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */ disablePortal: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
};
// eslint-disable-next-line
$c51ee051b75e7c88$var$Portal["propTypes"] = (0, $bNVvr.default)($c51ee051b75e7c88$var$Portal.propTypes);
var $c51ee051b75e7c88$export$2e2bcd8739ae039 = $c51ee051b75e7c88$var$Portal;

});

parcelRegister("9Jk1k", function(module, exports) {

$parcel$export(module.exports, "getPopperUtilityClass", () => $7157d8acbf4a3429$export$1b69b6cd0fa638a1);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $7157d8acbf4a3429$export$1b69b6cd0fa638a1(slot) {
    return (0, $kfTYv.default)('MuiPopper', slot);
}
const $7157d8acbf4a3429$var$popperClasses = (0, $jh2Zm.default)('MuiPopper', [
    'root'
]);
var $7157d8acbf4a3429$export$2e2bcd8739ae039 = $7157d8acbf4a3429$var$popperClasses;

});



parcelRegister("1xq4a", function(module, exports) {

$parcel$export(module.exports, "default", () => $11ed17b3aa4d389f$export$2e2bcd8739ae039);

var $h47Cb = parcelRequire("h47Cb");
'use client';
var $11ed17b3aa4d389f$export$2e2bcd8739ae039 = (0, $h47Cb.default);

});

parcelRegister("7Wcl5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c77857490eafbc9$export$2e2bcd8739ae039);

var $it0qC = parcelRequire("it0qC");
'use client';
var $5c77857490eafbc9$export$2e2bcd8739ae039 = (0, $it0qC.default);

});
parcelRegister("it0qC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d71b447d88518b63$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");
'use client';
function $d71b447d88518b63$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $8T3gX.useRef(controlled !== undefined);
    const [valueState, setValue] = $8T3gX.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    {
        $8T3gX.useEffect(()=>{
            if (isControlled !== (controlled !== undefined)) console.error([
                `MUI: A component is changing the ${isControlled ? '' : 'un'}controlled ${state} state of ${name} to be ${isControlled ? 'un' : ''}controlled.`,
                'Elements should not switch from uncontrolled to controlled (or vice versa).',
                `Decide between using a controlled or uncontrolled ${name} ` + 'element for the lifetime of the component.',
                "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.",
                'More info: https://fb.me/react-controlled-components'
            ].join('\n'));
        }, [
            state,
            name,
            controlled
        ]);
        const { current: defaultValue } = $8T3gX.useRef(defaultProp);
        $8T3gX.useEffect(()=>{
            if (!isControlled && !Object.is(defaultValue, defaultProp)) console.error([
                `MUI: A component is changing the default ${state} state of an uncontrolled ${name} after being initialized. ` + `To suppress this warning opt to use a controlled ${name}.`
            ].join('\n'));
        }, [
            JSON.stringify(defaultProp)
        ]);
    }
    const setValueIfUncontrolled = $8T3gX.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});


parcelRegister("gD0A5", function(module, exports) {

$parcel$export(module.exports, "getTooltipUtilityClass", () => $c1b0bd3f90230306$export$837848f5f6cee923);
$parcel$export(module.exports, "default", () => $c1b0bd3f90230306$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $c1b0bd3f90230306$export$837848f5f6cee923(slot) {
    return (0, $kfTYv.default)('MuiTooltip', slot);
}
const $c1b0bd3f90230306$var$tooltipClasses = (0, $jh2Zm.default)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $c1b0bd3f90230306$export$2e2bcd8739ae039 = $c1b0bd3f90230306$var$tooltipClasses;

});


parcelRegister("6pdiI", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a9f6527348a1e9a$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $4a9f6527348a1e9a$var$_default = module.exports.default = (0, $4a9f6527348a1e9a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), 'Edit');

});

parcelRegister("dyZ1V", function(module, exports) {

$parcel$export(module.exports, "handleCreateMatchingSchedules", () => $ca896a74f5e0086f$export$a16f8fe0256c8625);
parcelRequire("8T3gX");
const $ca896a74f5e0086f$export$a16f8fe0256c8625 = (grid)=>{
    const newMatchingSchedules = [];
    for(let i = 0; i < grid.length; i++){
        const matchingScheduleIndexes = [];
        for(let j = 0; j < grid.length; j++)if (grid[i].toString() === grid[j].toString()) matchingScheduleIndexes.push(j);
        newMatchingSchedules.push(matchingScheduleIndexes);
    }
    // check the newMatchingSchedules to see if any subarrays are the same, if they are, remove the duplicate subarray
    for(let i = 0; i < newMatchingSchedules.length; i++){
        for(let j = i + 1; j < newMatchingSchedules.length; j++)if (newMatchingSchedules[i].toString() === newMatchingSchedules[j].toString()) newMatchingSchedules.splice(j, 1);
    }
    for(let i = 0; i < newMatchingSchedules.length; i++){
        for(let j = i + 1; j < newMatchingSchedules.length; j++)if (newMatchingSchedules[i].toString() === newMatchingSchedules[j].toString()) newMatchingSchedules.splice(j, 1);
    }
    return newMatchingSchedules;
};

});

parcelRegister("gEbE4", function(module, exports) {

$parcel$export(module.exports, "handleUpdateSiteSchedules", () => $7c7a64cf2f452473$export$c12ac1a97cd718c1);
parcelRequire("8T3gX");
parcelRequire("elyck");
var $h5bv8 = parcelRequire("h5bv8");
const $7c7a64cf2f452473$export$c12ac1a97cd718c1 = (timeRanges, duskToDawnLocation, matchingSchedules, setSiteSchedules, siteSchedules, schedulesIndex)=>{
    // Create a deep copy instead of a reference
    const previousSiteSchedules = JSON.parse(JSON.stringify(siteSchedules));
    if (previousSiteSchedules.length === 0 && !window.location.pathname.includes("addschedule")) return;
    const returnArray = [];
    let duskToDawnStartTime;
    let duskToDawnEndTime;
    if (!window.location.pathname.includes("addschedule")) {
        if (previousSiteSchedules[schedulesIndex]) {
            const currentSchedule = previousSiteSchedules[schedulesIndex].schedule;
            currentSchedule.forEach((schedule)=>{
                if (schedule.location_dusk_dawn) {
                    duskToDawnStartTime = schedule.start_time;
                    duskToDawnEndTime = schedule.end_time;
                }
            });
        }
    }
    matchingSchedules.forEach((array)=>{
        const alwaysOn = timeRanges[array[0]] === "Always On";
        const duskToDawn = duskToDawnLocation[array[0]][0];
        const bufferTime = duskToDawnLocation[array[0]][1];
        const endTime = timeRanges[array[0]] === "Always On" ? // timeRanges[array[0]] === "Dusk to Dawn"
        "23:59:59" : timeRanges[array[0]] === "Dusk to Dawn" ? duskToDawnEndTime : `${timeRanges[array[0]].slice(8, 13)}:00`;
        const startTime = timeRanges[array[0]] === "Always On" ? // timeRanges[array[0]] === "Dusk to Dawn"
        "00:00:00" : timeRanges[array[0]] === "Dusk to Dawn" ? duskToDawnStartTime : `${timeRanges[array[0]].slice(0, 5)}:00`;
        returnArray.push({
            always_on: alwaysOn,
            buffer_time: bufferTime ? bufferTime : 0,
            customer: Number((0, $h5bv8.getNumbersAfterAboutSite)(location.href)),
            day_of_week: array,
            enabled: true,
            end_time: endTime === "24:00:00" ? "23:59:59" : endTime,
            is_overide: false,
            location_dusk_dawn: duskToDawn,
            start_time: startTime
        });
    });
    if (previousSiteSchedules[schedulesIndex]) previousSiteSchedules[schedulesIndex].schedule = returnArray;
    window.location.pathname.includes("addschedule") ? setSiteSchedules(returnArray) : setSiteSchedules(previousSiteSchedules);
};

});
parcelRegister("elyck", function(module, exports) {

$parcel$export(module.exports, "SiteAbout", () => $69549cb98739a5b8$export$fdd80ea96550515);
$parcel$export(module.exports, "getNumbersAfterAboutSite", () => (parcelRequire("h5bv8")).getNumbersAfterAboutSite);
/* eslint-disable react-hooks/exhaustive-deps */ 
var $k4ank = parcelRequire("k4ank");

var $jVN1H = parcelRequire("jVN1H");

var $8T3gX = parcelRequire("8T3gX");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $hlJ5Q = parcelRequire("hlJ5Q");

var $lFMkK = parcelRequire("lFMkK");

var $hlCsX = parcelRequire("hlCsX");

var $bPE00 = parcelRequire("bPE00");

var $kHsF1 = parcelRequire("kHsF1");

var $5Q799 = parcelRequire("5Q799");

var $77F6P = parcelRequire("77F6P");

var $dHtmK = parcelRequire("dHtmK");

var $8jTCz = parcelRequire("8jTCz");

var $740m5 = parcelRequire("740m5");

var $6wUjC = parcelRequire("6wUjC");

var $3baw3 = parcelRequire("3baw3");

var $7FIuT = parcelRequire("7FIuT");

var $2erCI = parcelRequire("2erCI");

var $iXV9W = parcelRequire("iXV9W");

var $7l43O = parcelRequire("7l43O");

var $9OjJ7 = parcelRequire("9OjJ7");

var $crpct = parcelRequire("crpct");

var $cVCJe = parcelRequire("cVCJe");

var $5bO6h = parcelRequire("5bO6h");

var $h5NlZ = parcelRequire("h5NlZ");

var $c6iZU = parcelRequire("c6iZU");

var $4k3Fk = parcelRequire("4k3Fk");

var $aMH8L = parcelRequire("aMH8L");

var $3QMQN = parcelRequire("3QMQN");

var $4wo2Y = parcelRequire("4wo2Y");

var $3FJ79 = parcelRequire("3FJ79");

var $815yO = parcelRequire("815yO");

var $jiOBG = parcelRequire("jiOBG");

var $deJMp = parcelRequire("deJMp");

var $agMWc = parcelRequire("agMWc");

var $2aMB5 = parcelRequire("2aMB5");

var $lWchQ = parcelRequire("lWchQ");

var $5QFok = parcelRequire("5QFok");

var $2uQ4j = parcelRequire("2uQ4j");

var $bjLOU = parcelRequire("bjLOU");

var $jKvMX = parcelRequire("jKvMX");

var $8ISah = parcelRequire("8ISah");

var $h5bv8 = parcelRequire("h5bv8");

var $195EM = parcelRequire("195EM");

var $4PFLW = parcelRequire("4PFLW");

var $eYzFO = parcelRequire("eYzFO");

var $c4ZfI = parcelRequire("c4ZfI");

var $4ysU8 = parcelRequire("4ysU8");

var $a0tnU = parcelRequire("a0tnU");

var $2bi6M = parcelRequire("2bi6M");
const $69549cb98739a5b8$export$fdd80ea96550515 = ({ permissions: permissions, navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed })=>{
    const navigate = (0, $3T949.useNavigate)();
    const { pathname: pathname } = (0, $3T949.useLocation)();
    const siteIdFromUrl = $8T3gX.useMemo(()=>(0, $h5bv8.getNumbersAfterAboutSite)(pathname), [
        pathname
    ]);
    const [dataLoaded, setDataLoaded] = $8T3gX.useState(false);
    const [initialFlexPresetSyncComplete, setInitialFlexPresetSyncComplete] = $8T3gX.useState(false);
    const [loadProgressPercent, setLoadProgressPercent] = $8T3gX.useState(5);
    const [loadProgressMessage, setLoadProgressMessage] = $8T3gX.useState("Loading site data...");
    const [clickedTab, setClickedTab] = $8T3gX.useState("one");
    const [editMode, setEditMode] = $8T3gX.useState(false);
    const [siteInfo, setSiteInfo] = $8T3gX.useState({});
    const [siteInfoBackup, setSiteInfoBackup] = $8T3gX.useState({});
    const [webhooksInfo, setWebhooksInfo] = $8T3gX.useState([]);
    const [activeTab, setActiveTab] = $8T3gX.useState(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
    const [vmsVariables, setVmsVariables] = $8T3gX.useState([]);
    const [vmsVariablesBackup, setVmsVariablesBackup] = $8T3gX.useState([]);
    const [patchObject, setPatchObject] = $8T3gX.useState({
        name: ""
    });
    const [schedulesTabActive, setSchedulesTabActive] = $8T3gX.useState(false);
    const [siteSchedules, setSiteSchedules] = $8T3gX.useState([]);
    const [allSiteSchedules, setAllSiteSchedules] = $8T3gX.useState([]);
    // Pending Webhooks-tab edits, keyed by webhook id (ENG-2233).
    const [webhooksPatchObject, setWebhooksPatchObject] = $8T3gX.useState({});
    const [webhooksChangesMade, setWebhooksChangesMade] = $8T3gX.useState(false);
    // Leaving edit mode (Save or Cancel) drops any pending webhook edits so a
    // later Save on another tab can't replay them.
    $8T3gX.useEffect(()=>{
        if (!editMode) {
            setWebhooksPatchObject({});
            setWebhooksChangesMade(false);
        }
    }, [
        editMode
    ]);
    const [wireguardTunnels, setWireguardTunnels] = $8T3gX.useState([]);
    const [wireguardTunnelsLoading, setWireguardTunnelsLoading] = $8T3gX.useState(false);
    const [selectedWireguardTunnelId, setSelectedWireguardTunnelId] = $8T3gX.useState(null);
    const [wireguardChangesMade, setWireguardChangesMade] = $8T3gX.useState(false);
    const wireGuardEditSessionRef = $8T3gX.useRef(null);
    const { width: width } = (0, $crpct.default)();
    const [alertState, setAlertState] = $8T3gX.useState({
        changeSuccess: false,
        noCameraOrSchedule: false,
        noSchedule: false,
        activateSuccess: false,
        deactivateSuccess: false,
        disarmSuccess: false,
        armSuccess: false,
        armFail: false,
        syncSuccess: false,
        cameraDeleteSuccess: false,
        configureMotion: (0, $5bO6h.IDLE_CONFIGURE_MOTION),
        refreshCameraSuccess: false,
        refreshCameraFail: false,
        webhookChangesFail: false
    });
    const [camerasNotDeployed, setCamerasNotDeployed] = $8T3gX.useState(false);
    const [backdropLoadingScreenOn, setBackdropLoadingScreenOn] = $8T3gX.useState(true);
    // Sync state lives in the shared per-site sync store — the same source the
    // edit-view Sync controls subscribe to, so site-level and camera-level
    // indicators can never disagree, and another site's pending changes never
    // show here. The setter adapter keeps the React.Dispatch signature the
    // downstream utils (handleGetAllData, handleSyncSite, dialogs, …) expect.
    const syncNeeded = (0, $815yO.useCurrentSiteSyncNeeded)();
    const setSyncNeeded = $8T3gX.useCallback((value)=>{
        const siteId = (0, $815yO.getSiteIdFromUrl)();
        const next = typeof value === "function" ? value((0, $815yO.useSyncStore).getState().unsyncedSiteIds.includes(siteId)) : value;
        if (next) (0, $815yO.markSiteUnsynced)(siteId);
        else (0, $815yO.markSiteSynced)(siteId);
    }, []);
    const [deleteSiteDialogOpen, setDeleteSiteDialogOpen] = $8T3gX.useState(false);
    const [deleteScheduleDialogOpen, setDeleteScheduleDialogOpen] = $8T3gX.useState(false);
    const [siteInfoChangesMade, setSiteInfoChangesMade] = $8T3gX.useState(false);
    const [scheduleChangesMade, setScheduleChangesMade] = $8T3gX.useState(false);
    const [siteCameras, setSiteCameras] = $8T3gX.useState(localStorage.siteCameras ? JSON.parse(localStorage.siteCameras) : []);
    const [disarmDialogOpen, setDisarmDialogOpen] = $8T3gX.useState(false);
    const [armDialogOpen, setArmDialogOpen] = $8T3gX.useState(false);
    const [rebootDialogOpen, setRebootDialogOpen] = $8T3gX.useState(false);
    const [activateSiteDialogOpen, setActivateSiteDialogOpen] = $8T3gX.useState(false);
    const [deactivateSiteDialogOpen, setDeactivateSiteDialogOpen] = $8T3gX.useState(false);
    const [deativateInquiryDialogOpen, setDeativateInquiryDialogOpen] = $8T3gX.useState(false);
    const [noAutoAddCamerasDialogOpen, setNoAutoAddCamerasDialogOpen] = $8T3gX.useState(false);
    const [siteDeployed, setSiteDeployed] = $8T3gX.useState(true);
    const [aiLinkSite, setAiLinkSite] = $8T3gX.useState(false);
    const [toolTipTitle, setToolTipTitle] = $8T3gX.useState("");
    const [configureMotion, setConfigureMotion] = $8T3gX.useState(false);
    const ref = $8T3gX.useRef(null);
    const isMountedRef = $8T3gX.useRef(true);
    const [armedStatus, setArmedStatus] = $8T3gX.useState(false);
    const [armButtonDisabled, setArmButtonDisabled] = $8T3gX.useState(false);
    const [recordingServerData, setRecordingServerData] = $8T3gX.useState({});
    const [recordingServerPatchObject, setRecordingServerPatchObject] = $8T3gX.useState({});
    const [recordingServerChangesMade, setRecordingServerChangesMade] = $8T3gX.useState(false);
    const [recordingServerVisible, setRecordingServerVisible] = $8T3gX.useState(false);
    const [healthCheckData, setHealthCheckData] = $8T3gX.useState({});
    const [cameraHealthPatchObject, setCameraHealthPatchObject] = $8T3gX.useState({});
    const [cameraHealthChangesMade, setCameraHealthChangesMade] = $8T3gX.useState(false);
    const [camerasRefreshing, setCamerasRefreshing] = $8T3gX.useState(false);
    const [addCameraHealthDialogOpen, setAddCameraHealthDialogOpen] = $8T3gX.useState(false);
    const [turnOffHealthDialogOpen, setTurnOffHealthDialogOpen] = $8T3gX.useState(false);
    const [cameraCheckAlertOpen, setCameraCheckAlertOpen] = $8T3gX.useState(localStorage.cameraCheckAlertOpen === "true");
    const [deactivateSiteInsteadDialogOpen, setDeactivateSiteInsteadDialogOpen] = $8T3gX.useState(false);
    const [activateSiteWithScheduleDialogOpen, setActivateSiteWithScheduleDialogOpen] = $8T3gX.useState(false);
    const [siteSchedulesBackup, setSiteSchedulesBackup] = $8T3gX.useState([]);
    const [flexScheduleOnEditButtonClick, setFlexScheduleOnEditButtonClick] = $8T3gX.useState(false);
    const [armSiteFlexScheduleDialogOpen, setArmSiteFlexScheduleDialogOpen] = $8T3gX.useState(false);
    // Which flavor the flex schedule picker should send: "arm" from the Arm
    // toggle, "reboot" when reached from a reboot-to-apply flow (RebootDialog
    // handoff) so the action log reads "Manual Reboot" (ENG-1404 / SUP-433).
    const [armSiteFlexScheduleDialogAction, setArmSiteFlexScheduleDialogAction] = $8T3gX.useState("arm");
    const [disarmSiteFlexScheduleDialogOpen, setDisarmSiteFlexScheduleDialogOpen] = $8T3gX.useState(false);
    const { resetSiteAboutState: resetSiteAboutState, getHealthCheckMetricsData: getHealthCheckMetricsData, prefetchSiteMetricsSimplified: prefetchSiteMetricsSimplified, backdropLoadingScreenOnEditingSchedule: backdropLoadingScreenOnEditingSchedule, vCHOnlySchedules: vCHOnlySchedules, autoPatrolSchedules: autoPatrolSchedules } = (0, $3FJ79.useSiteAboutStore)();
    const syncFlexIgnoreZonesEnabledFromApi = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((state)=>state.syncFlexIgnoreZonesEnabledFromApi);
    const resetFlexIgnoreZonesOnboardingState = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((state)=>state.resetAll);
    const { isFeatureEnabled: isFeatureEnabled } = (0, $4PFLW.useFeatureFlag)();
    const showFlexIgnoreZonesFlag = isFeatureEnabled("showFlexIgnoreZones", false);
    const showWireguard = isFeatureEnabled("showWireguard", false);
    const showWireguardTab = showWireguard && Boolean(siteInfo?.display_wireguard);
    const isStaff = (0, $4ysU8.useIsStaffUser)();
    // A customer without group access who turns DoubleTake off would otherwise
    // lose the tab they're standing on; keep it until they leave the site.
    const [keepDoubleTakeTab, setKeepDoubleTakeTab] = $8T3gX.useState(false);
    $8T3gX.useEffect(()=>setKeepDoubleTakeTab(false), [
        siteIdFromUrl
    ]);
    const showDoubleTakeTab = keepDoubleTakeTab && isFeatureEnabled("showVlmFilters", false) || (0, $2bi6M.shouldShowDoubleTakeTab)(isFeatureEnabled("showVlmFilters", false), siteInfo, isStaff);
    const doubleTakeTabOpen = clickedTab === (0, $2bi6M.DOUBLE_TAKE_TAB) && showDoubleTakeTab;
    // Edit Information only shows on the DoubleTake tab when there's something
    // this user may change there (ENG-2611).
    const doubleTakeEditable = (0, $2bi6M.canToggleDoubleTake)(Boolean(siteInfo?.vlm_enabled), siteInfo, isStaff);
    const doubleTakeSaveRef = $8T3gX.useRef(null);
    const handleSaveDoubleTake = async ()=>{
        setBackdropLoadingScreenOn(true);
        const result = await doubleTakeSaveRef.current?.() ?? "unchanged";
        setBackdropLoadingScreenOn(false);
        if (result === "failed") return;
        if (result === "saved") {
            setAlertState((previousState)=>({
                    ...previousState,
                    changeSuccess: true,
                    activateSuccess: false,
                    deactivateSuccess: false,
                    disarmSuccess: false,
                    armSuccess: false,
                    syncSuccess: false,
                    cameraDeleteSuccess: false
                }));
            setSyncNeeded(true);
        }
        setEditMode(false);
    };
    const onWireGuardSessionUpdate = $8T3gX.useCallback((session)=>{
        wireGuardEditSessionRef.current = session;
    }, []);
    const clearWireGuardEditSession = $8T3gX.useCallback(()=>{
        wireGuardEditSessionRef.current = null;
    }, []);
    const clearSiteAboutTransientState = $8T3gX.useCallback(()=>{
        [
            "siteCameraSelectionsBySiteId",
            "siteCamerasTablePagePreferences",
            "storedExpandedObject",
            "expandedObjectSaved",
            "siteAboutScrollTop",
            "siteCameras",
            "allSiteSchedulesBackup",
            "siteSchedule",
            "backUpSiteSchedule",
            "backUpStandardSchedule",
            "backUpFlexSchedule",
            "schedulesIndex",
            "clickedSchedulesTab",
            "cameraCheckAlertOpen",
            "groupNameChange",
            "flexSchedulingChanged",
            "flexSchedulesOn",
            "scheduleChangeError",
            "scheduleSubmitError",
            "backupHealthCheckMetrics",
            "backupAutoPatrolSchedules",
            "backupAutoPatrolScheduleHealthchckMetrics",
            "backupCameraProductsByScheduleId",
            "backupProductMetricsIdsByScheduleId",
            "armButtonCheckURL"
        ].forEach((key)=>localStorage.removeItem(key));
    }, []);
    const handleSiteLoadPhase = $8T3gX.useCallback((phase, progress)=>{
        if (phase === "site-metadata") {
            setLoadProgressPercent(25);
            setLoadProgressMessage("Loading site fields...");
            return;
        }
        if (phase === "site-extra-fields") {
            setLoadProgressPercent(45);
            setLoadProgressMessage("Loading cameras...");
            return;
        }
        if (phase === "site-cameras") {
            setLoadProgressPercent(70);
            setLoadProgressMessage("Loading camera details...");
            return;
        }
        if (phase === "camera-row-prefetch-start") {
            const total = progress?.total ?? 0;
            setLoadProgressPercent(74);
            setLoadProgressMessage(total > 0 ? `Loading camera details (0/${total})...` : "Loading camera details...");
            return;
        }
        if (phase === "camera-row-prefetch-progress") {
            const completed = progress?.completed ?? 0;
            const total = progress?.total ?? 0;
            const ratio = total > 0 ? completed / total : 1;
            const clampedRatio = Math.max(0, Math.min(1, ratio));
            const percent = 74 + Math.round(clampedRatio * 8);
            setLoadProgressPercent(percent);
            setLoadProgressMessage(total > 0 ? `Loading camera details (${completed}/${total})...` : "Saving camera details...");
            return;
        }
        if (phase === "camera-row-prefetch-complete") {
            setLoadProgressPercent(82);
            setLoadProgressMessage("Loaded per-camera details...");
            return;
        }
        setLoadProgressPercent(85);
        setLoadProgressMessage("Loaded schedules and health data...");
    }, []);
    const siteCameraIdsKey = $8T3gX.useMemo(()=>{
        const results = siteCameras?.results;
        if (!Array.isArray(results)) return "";
        return results.map((camera)=>Number(camera.id)).filter((id)=>Number.isFinite(id)).sort((a, b)=>a - b).join(",");
    }, [
        siteCameras
    ]);
    const flexSchedulesForSync = $8T3gX.useMemo(()=>{
        if (!Array.isArray(siteSchedules) || siteSchedules.length === 0) return [];
        return siteSchedules.map((s, idx)=>{
            const row = s;
            return {
                id: Number(row.id ?? idx + 1),
                display_name: row.display_name || `Schedule ${idx + 1}`
            };
        });
    }, [
        siteSchedules
    ]);
    const siteScheduleIdsKey = $8T3gX.useMemo(()=>flexSchedulesForSync.map((s)=>s.id).join(","), [
        flexSchedulesForSync
    ]);
    $8T3gX.useEffect(()=>{
        isMountedRef.current = true;
        setInitialFlexPresetSyncComplete(false);
        setLoadProgressPercent(5);
        setLoadProgressMessage("Loading site data...");
        clearSiteAboutTransientState();
        resetSiteAboutState();
        resetFlexIgnoreZonesOnboardingState();
        (0, $aMH8L.handleGetAllData)(siteIdFromUrl, navigate, setSiteInfo, setSiteSchedules, setSiteCameras, setActiveTab, setDataLoaded, setBackdropLoadingScreenOn, setAllSiteSchedules, setVmsVariables, setNoAutoAddCamerasDialogOpen, setArmedStatus, setAiLinkSite, setSiteDeployed, setSyncNeeded, setAlertState, setCamerasNotDeployed, setToolTipTitle, setConfigureMotion, setPatchObject, setArmButtonDisabled, setRecordingServerData, setRecordingServerPatchObject, setRecordingServerVisible, setHealthCheckData, setWebhooksInfo, setWebhooksPatchObject, ()=>isMountedRef.current, handleSiteLoadPhase);
        getHealthCheckMetricsData(navigate, siteIdFromUrl);
        prefetchSiteMetricsSimplified?.(navigate, siteIdFromUrl);
        localStorage.setItem("schedulesIndex", "0");
        localStorage.setItem("clickedSchedulesTab", "one");
        let cameraCheckTimerId;
        if (localStorage.cameraCheckAlertOpen === "true") cameraCheckTimerId = setTimeout(()=>{
            if (isMountedRef.current) {
                setCameraCheckAlertOpen(false);
                localStorage.setItem("cameraCheckAlertOpen", "false");
            }
        }, 10000);
        return ()=>{
            isMountedRef.current = false;
            if (cameraCheckTimerId !== undefined) clearTimeout(cameraCheckTimerId);
            resetSiteAboutState();
            resetFlexIgnoreZonesOnboardingState();
            clearSiteAboutTransientState();
        };
    }, [
        clearSiteAboutTransientState,
        handleSiteLoadPhase,
        navigate,
        prefetchSiteMetricsSimplified,
        resetFlexIgnoreZonesOnboardingState,
        resetSiteAboutState,
        getHealthCheckMetricsData,
        siteIdFromUrl
    ]);
    // Reconnect the reboot prompt. The settings-editing flows (edit camera,
    // ignore zones, metadata tags, line crossings) sync changes to the cloud
    // and set a one-shot `rebootSite` flag, but nothing ever consumed it, so
    // the customer was never asked whether to reboot to apply their changes.
    // When the operator lands back on the About page with pending changes,
    // surface the existing RebootDialog so they choose whether to reboot now —
    // but only if the site is currently armed. If it's disarmed, the changes
    // are picked up automatically the next time it arms, so no prompt is needed.
    $8T3gX.useEffect(()=>{
        if (!dataLoaded || !siteInfo?.id) return;
        if (localStorage.getItem("rebootSite") !== "true") return;
        // Consume the one-shot flag so it can't re-trigger on a later load.
        localStorage.setItem("rebootSite", "false");
        // Reboot = arm. Only offer it when the site is also MEANT to be armed
        // now — schedule or manual arm (ENG-811 — `armed` alone lags a stop).
        if ((0, $c4ZfI.shouldOfferRebootToApply)(siteInfo)) setRebootDialogOpen(true);
    }, [
        dataLoaded,
        siteInfo?.id,
        siteInfo?.armed,
        siteInfo?.arm_intended
    ]);
    $8T3gX.useEffect(()=>{
        const handleRefreshSiteCamerasTable = ()=>{
            const AxiosUI = (0, $195EM.createApi)("");
            AxiosUI.get(`camera/site/?customer__id=${siteIdFromUrl}`).then((response)=>{
                localStorage.setItem("siteCameras", JSON.stringify(response.data));
                setSiteCameras(response.data);
            });
        };
        window.addEventListener("refreshSiteCamerasTable", handleRefreshSiteCamerasTable);
        return ()=>{
            window.removeEventListener("refreshSiteCamerasTable", handleRefreshSiteCamerasTable);
        };
    }, [
        siteIdFromUrl
    ]);
    $8T3gX.useEffect(()=>{
        if (!showWireguard || !siteInfo?.display_wireguard || !siteIdFromUrl) return;
        let cancelled = false;
        (async ()=>{
            setWireguardTunnelsLoading(true);
            try {
                const list = await (0, $h5NlZ.fetchWireguardTunnelsForCustomer)(siteIdFromUrl);
                if (!cancelled) setWireguardTunnels(list);
            } catch  {
                if (!cancelled) setWireguardTunnels([]);
            } finally{
                if (!cancelled) setWireguardTunnelsLoading(false);
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        showWireguard,
        siteInfo?.display_wireguard,
        siteIdFromUrl
    ]);
    $8T3gX.useEffect(()=>{
        if (wireguardTunnels.length === 0) {
            setSelectedWireguardTunnelId(null);
            return;
        }
        setSelectedWireguardTunnelId((prev)=>{
            if (prev != null && wireguardTunnels.some((t)=>t.id === prev)) return prev;
            return wireguardTunnels[0].id;
        });
    }, [
        wireguardTunnels
    ]);
    const setScrollTop = (event)=>{
        localStorage.setItem("siteAboutScrollTop", event.target.scrollTop);
    };
    $8T3gX.useEffect(()=>{
        if (ref) setTimeout(()=>{
            if (ref.current !== null) ref.current.scrollTop = localStorage.siteAboutScrollTop;
        }, 500);
    }, [
        backdropLoadingScreenOn
    ]);
    $8T3gX.useEffect(()=>{
        localStorage.setItem("navigatedFromSitesAboutPage", "true");
        localStorage.setItem("allSiteSchedulesBackup", JSON.stringify(siteSchedules));
    }, []);
    // Set Schedules tab as default for autopatrol sites (vCH-only path)
    $8T3gX.useEffect(()=>{
        if (siteInfo?.integration_type_name === "autopatrol") {
            setClickedTab("three");
            setSchedulesTabActive(true);
            setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $2uQ4j.SchedulesTab), {
                siteInfo: siteInfo
            }));
        }
    }, [
        siteInfo?.integration_type_name
    ]);
    $8T3gX.useEffect(()=>{
        if (!dataLoaded) {
            setInitialFlexPresetSyncComplete(false);
            return;
        }
        if (!siteInfo?.id || !siteInfo?.has_flex_schedule || !showFlexIgnoreZonesFlag) {
            setInitialFlexPresetSyncComplete(true);
            setLoadProgressPercent(100);
            setLoadProgressMessage("Finalizing...");
            return;
        }
        const results = siteCameras?.results;
        if (!Array.isArray(results)) return;
        const flexCameras = results.map((camera)=>({
                id: Number(camera.id),
                camera_name: camera.camera_name,
                preview_url: camera.preview_url,
                ignore_zones: camera.ignore_zones
            }));
        let cancelled = false;
        const shouldCompleteInitialLoad = !initialFlexPresetSyncComplete;
        if (shouldCompleteInitialLoad) {
            setLoadProgressPercent(90);
            setLoadProgressMessage("Loading flex schedule presets...");
        }
        (async ()=>{
            try {
                await syncFlexIgnoreZonesEnabledFromApi(Number(siteInfo.id), flexCameras, flexSchedulesForSync.length > 0 ? flexSchedulesForSync : undefined, showFlexIgnoreZonesFlag);
            } finally{
                if (!cancelled && shouldCompleteInitialLoad) {
                    setLoadProgressPercent(100);
                    setLoadProgressMessage("Finalizing...");
                    setInitialFlexPresetSyncComplete(true);
                }
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        dataLoaded,
        siteInfo?.id,
        siteInfo?.has_flex_schedule,
        siteCameraIdsKey,
        siteScheduleIdsKey,
        flexSchedulesForSync,
        initialFlexPresetSyncComplete,
        syncFlexIgnoreZonesEnabledFromApi,
        showFlexIgnoreZonesFlag
    ]);
    const waitForFlexPresetHydration = dataLoaded && showFlexIgnoreZonesFlag && Boolean(siteInfo?.has_flex_schedule) && !initialFlexPresetSyncComplete;
    //on Unmount
    // React.useEffect(
    //   () => () => {
    //   },
    //   []
    // )
    const handleSiteBreadcrumbClick = (event)=>{
        event.preventDefault();
        localStorage.setItem("siteAboutScrollTop", "0");
        localStorage.setItem("expandedObjectSaved", "false");
        localStorage.setItem("navigatedFromSitesAboutPage", "true");
        localStorage.setItem("level0Click", "true");
        localStorage.setItem("sitesTablePage", "0");
        localStorage.setItem("storedSelectedIndex", JSON.stringify({
            level1: [],
            level2: [],
            level3: [],
            level4: [],
            level5: [],
            level6: []
        }));
        siteInfo?.integration_type_name === "autopatrol" ? navigate("/sites_patrol") : navigate("/sites");
    };
    // const {
    //   getSiteInfo,
    //   loadAllData
    // } = useSiteAboutStore();
    //  React.useEffect(() => {
    //    getSiteInfo(() => { getSiteInfo }, navigate);
    //   }, []);
    // Conditionally render SiteAboutAutoPatrol only when autopatrol has at least one AutoPatrol schedule; vCH-only uses main layout below
    if (siteInfo?.integration_type_name === "autopatrol" && !vCHOnlySchedules) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $bjLOU.SiteAboutAutoPatrol), {
        permissions: permissions,
        navBarCollapsed: navBarCollapsed,
        setNavBarCollapsed: setNavBarCollapsed
    });
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                children: [
                    cameraCheckAlertOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                        severity: "info",
                        onClose: ()=>{
                            setCameraCheckAlertOpen(false);
                            localStorage.setItem("cameraCheckAlertOpen", "false");
                        },
                        children: "Camera check is running in the background. This may take a few minutes. You will be alerted when it is complete. Please do not close your window or refresh any page until the check has been completed."
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $2erCI.AddSiteWebhookDialog), {
                        siteId: Number((0, $h5bv8.getNumbersAfterAboutSite)(location.href)),
                        navigate: navigate,
                        onCreated: (webhook)=>{
                            const nextWebhooks = (0, $7l43O.mergeWebhookById)(webhooksInfo, webhook);
                            setWebhooksInfo(nextWebhooks);
                            (0, $3FJ79.useSiteAboutStore).getState().setBackupWebhookData(nextWebhooks);
                            if (clickedTab === "seven" && !editMode) setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $iXV9W.WebhooksTab), {
                                webhooksInfo: nextWebhooks
                            }));
                            setAlertState((previousState)=>({
                                    ...previousState,
                                    changeSuccess: true
                                }));
                        }
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $7FIuT.SiteAboutDialogs), {
                        setDeleteScheduleDialogOpen: setDeleteScheduleDialogOpen,
                        setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                        setAllSiteSchedules: setAllSiteSchedules,
                        setSiteInfo: setSiteInfo,
                        editMode: editMode,
                        setActiveTab: setActiveTab,
                        siteInfo: siteInfo,
                        setScheduleChangesMade: setScheduleChangesMade,
                        rebootDialogOpen: rebootDialogOpen,
                        setRebootDialogOpen: setRebootDialogOpen,
                        setAlertState: setAlertState,
                        activateSiteDialogOpen: activateSiteDialogOpen,
                        setActivateSiteDialogOpen: setActivateSiteDialogOpen,
                        setPatchObject: setPatchObject,
                        patchObject: patchObject,
                        deactivateSiteDialogOpen: deactivateSiteDialogOpen,
                        setDeactivateSiteDialogOpen: setDeactivateSiteDialogOpen,
                        deativateInquiryDialogOpen: deativateInquiryDialogOpen,
                        setDeativateInquiryDialogOpen: setDeativateInquiryDialogOpen,
                        disarmDialogOpen: disarmDialogOpen,
                        setDisarmDialogOpen: setDisarmDialogOpen,
                        armDialogOpen: armDialogOpen,
                        setArmDialogOpen: setArmDialogOpen,
                        deleteSiteDialogOpen: deleteSiteDialogOpen,
                        setDeleteSiteDialogOpen: setDeleteSiteDialogOpen,
                        navigate: navigate,
                        setSyncNeeded: setSyncNeeded,
                        noAutoAddCamerasDialogOpen: noAutoAddCamerasDialogOpen,
                        setNoAutoAddCamerasDialogOpen: setNoAutoAddCamerasDialogOpen,
                        setArmedStatus: setArmedStatus,
                        setArmButtonDisabled: setArmButtonDisabled,
                        setEditMode: setEditMode,
                        clickedTab: clickedTab,
                        vmsVariables: vmsVariables,
                        siteSchedules: siteSchedules,
                        setSiteSchedules: setSiteSchedules,
                        addCameraHealthDialogOpen: addCameraHealthDialogOpen,
                        setAddCameraHealthDialogOpen: setAddCameraHealthDialogOpen,
                        healthCheckData: healthCheckData,
                        setCameraHealthPatchObject: setCameraHealthPatchObject,
                        setCameraHealthChangesMade: setCameraHealthChangesMade,
                        setHealthCheckData: setHealthCheckData,
                        turnOffHealthDialogOpen: turnOffHealthDialogOpen,
                        setTurnOffHealthDialogOpen: setTurnOffHealthDialogOpen,
                        permissions: permissions,
                        activateSiteWithScheduleDialogOpen: activateSiteWithScheduleDialogOpen,
                        setActivateSiteWithScheduleDialogOpen: setActivateSiteWithScheduleDialogOpen,
                        armSiteFlexScheduleDialogOpen: armSiteFlexScheduleDialogOpen,
                        setArmSiteFlexScheduleDialogOpen: setArmSiteFlexScheduleDialogOpen,
                        armSiteFlexScheduleDialogAction: armSiteFlexScheduleDialogAction,
                        setArmSiteFlexScheduleDialogAction: setArmSiteFlexScheduleDialogAction,
                        disarmSiteFlexScheduleDialogOpen: disarmSiteFlexScheduleDialogOpen,
                        setDisarmSiteFlexScheduleDialogOpen: setDisarmSiteFlexScheduleDialogOpen,
                        setToolTipTitle: setToolTipTitle
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $9OjJ7.SiteAboutAlerts), {
                        siteDeployed: siteDeployed,
                        aiLinkSite: aiLinkSite,
                        setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                        setSyncNeeded: setSyncNeeded,
                        setAlertState: setAlertState,
                        siteInfo: siteInfo,
                        setSiteInfo: setSiteInfo,
                        setAllSiteSchedules: setAllSiteSchedules,
                        setActiveTab: setActiveTab,
                        vmsVariables: vmsVariables,
                        setSiteDeployed: setSiteDeployed,
                        setDeativateInquiryDialogOpen: setDeativateInquiryDialogOpen,
                        setSiteCameras: setSiteCameras,
                        camerasNotDeployed: camerasNotDeployed,
                        setCamerasNotDeployed: setCamerasNotDeployed,
                        navigate: navigate,
                        setVmsVariables: setVmsVariables,
                        alertState: alertState,
                        setEditMode: setEditMode,
                        setClickedTab: setClickedTab,
                        setArmButtonDisabled: setArmButtonDisabled,
                        setArmedStatus: setArmedStatus,
                        setRebootDialogOpen: setRebootDialogOpen
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                        openState: backdropLoadingScreenOn || waitForFlexPresetHydration,
                        progressPercent: loadProgressPercent,
                        message: loadProgressMessage
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                        openState: backdropLoadingScreenOnEditingSchedule
                    }),
                    dataLoaded && !waitForFlexPresetHydration && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "bg-actuate-grey absolute w-full h-full overflow-scroll",
                        onScroll: setScrollTop,
                        ref: ref,
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: !navBarCollapsed ? "absolute top-[15px] left-[150px] right-0 h-[59px] bg-white min-w-[1440px]" : "absolute top-[15px] left-[75px] right-0 h-[59px] bg-white min-w-[1440px]",
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "flex items-center justify-between h-full pl-[30px] pr-3 gap-4",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                className: "flex items-center min-w-0 flex-1 gap-2 overflow-x-auto whitespace-nowrap",
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $77F6P.BreadCrumbsComponet), {
                                                        linksArray: (0, $6wUjC.createLinksArray)(siteInfo.breadcrumb_info),
                                                        handleClick: handleSiteBreadcrumbClick,
                                                        styling: "",
                                                        breadcrumb_info: siteInfo.breadcrumb_info,
                                                        siteInfo: siteInfo
                                                    }),
                                                    siteInfo.integration_type_name === "autopatrol" && autoPatrolSchedules !== null && autoPatrolSchedules.length > 0 && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                        className: "text-actuate-blue font-mulish font-bold text-[16px] whitespace-nowrap shrink-0",
                                                        children: "Selected Schedule:"
                                                    }),
                                                    siteInfo.integration_type_name === "autopatrol" && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "shrink-0",
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $5QFok.default), {})
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                className: "flex items-center gap-6 shrink-0",
                                                children: [
                                                    permissions.edit_cameras && siteInfo.integration_type_name !== "autopatrol" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jiOBG.GreenRedSwitch), {
                                                            checked: siteInfo.active,
                                                            color: "warning",
                                                            onChange: (event)=>{
                                                                if (event.target.checked) {
                                                                    setPatchObject((previousState)=>{
                                                                        return {
                                                                            ...previousState,
                                                                            active: true
                                                                        };
                                                                    });
                                                                    setActivateSiteDialogOpen(true);
                                                                } else {
                                                                    setPatchObject((previousState)=>{
                                                                        return {
                                                                            ...previousState,
                                                                            active: false
                                                                        };
                                                                    });
                                                                    setDeactivateSiteDialogOpen(true);
                                                                }
                                                            }
                                                        }),
                                                        label: "Active"
                                                    }),
                                                    (siteInfo.integration_type_name === "autopatrol" || !permissions.edit_cameras) && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                        className: "flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                className: "text-[16px] font-mulish",
                                                                children: "Active"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                className: "ml-2",
                                                                children: siteInfo.active ? (0, $lWchQ.checkedCircleIcon) : (0, $2aMB5.cancelIconRed)
                                                            })
                                                        ]
                                                    }),
                                                    !aiLinkSite && permissions.arm_disarm && siteInfo.integration_type_name !== "autopatrol" && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                        className: "flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                                title: (0, $agMWc.getArmedStatusPresentation)(siteInfo.armed_status, siteInfo.armed, siteInfo.active).description,
                                                                placement: "top",
                                                                sx: {
                                                                    fontSize: "15px",
                                                                    fontFamily: "mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jiOBG.GreenRedSwitch), {
                                                                        checked: armedStatus,
                                                                        disabled: armButtonDisabled || !siteInfo.active,
                                                                        onChange: (event)=>{
                                                                            if (event.target.checked) {
                                                                                if (siteInfo.has_flex_schedule) {
                                                                                    setArmSiteFlexScheduleDialogAction("arm");
                                                                                    setArmSiteFlexScheduleDialogOpen(true);
                                                                                } else setArmDialogOpen(true);
                                                                            } else if (siteInfo.has_flex_schedule) setDisarmSiteFlexScheduleDialogOpen(true);
                                                                            else setDisarmDialogOpen(true);
                                                                        }
                                                                    }),
                                                                    label: "Armed"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $deJMp.ArmedStatusChip), {
                                                                armedStatus: siteInfo.armed_status,
                                                                armed: siteInfo.armed,
                                                                active: siteInfo.active
                                                            })
                                                        ]
                                                    }),
                                                    siteInfo.integration_type_name === "autopatrol" && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                        className: "flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                className: "text-[16px] font-mulish",
                                                                children: "Armed"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                className: "ml-2",
                                                                children: armedStatus ? (0, $lWchQ.checkedCircleIcon) : (0, $2aMB5.cancelIconRed)
                                                            })
                                                        ]
                                                    }),
                                                    permissions.edit_cameras && siteInfo.integration_type_name !== "autopatrol" && siteInfo.integration_type_name !== "clips" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $740m5.SyncSiteButton), {
                                                        syncNeeded: syncNeeded,
                                                        setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                                                        setSyncNeeded: setSyncNeeded,
                                                        setAlertState: setAlertState,
                                                        siteInfo: siteInfo,
                                                        setSiteInfo: setSiteInfo,
                                                        setAllSiteSchedules: setAllSiteSchedules,
                                                        setActiveTab: setActiveTab,
                                                        vmsVariables: vmsVariables,
                                                        setSiteDeployed: setSiteDeployed,
                                                        setDeativateInquiryDialogOpen: setDeativateInquiryDialogOpen,
                                                        setSiteCameras: setSiteCameras,
                                                        camerasNotDeployed: camerasNotDeployed,
                                                        setCamerasNotDeployed: setCamerasNotDeployed,
                                                        navigate: navigate,
                                                        setVmsVariables: setVmsVariables,
                                                        setClickedTab: setClickedTab,
                                                        setArmButtonDisabled: setArmButtonDisabled,
                                                        setArmedStatus: setArmedStatus,
                                                        setRebootDialogOpen: setRebootDialogOpen
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $jKvMX.SiteAboutActionsMenu), {
                                                        siteInfo: siteInfo,
                                                        permissions: permissions,
                                                        configureMotion: configureMotion,
                                                        setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                                                        setAlertState: setAlertState,
                                                        setDeleteSiteDialogOpen: setDeleteSiteDialogOpen,
                                                        navigate: navigate
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: !navBarCollapsed ? "absolute top-[87px] left-[150px] right-[1px] h-[60px] min-w-[1440px] bg-white" : "absolute top-[87px] left-[75px] right-[1px] h-[60px] min-w-[1440px] bg-white",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $hlCsX.TabsComponet), {
                                            clickedTab: clickedTab,
                                            setClickedTab: setClickedTab,
                                            editMode: editMode,
                                            setActiveTab: setActiveTab,
                                            setPatchObject: setPatchObject,
                                            setSiteInfo: setSiteInfo,
                                            vmsVariables: vmsVariables,
                                            setVmsVariables: setVmsVariables,
                                            siteSchedules: siteSchedules,
                                            siteInfo: siteInfo,
                                            setSiteSchedules: setSiteSchedules,
                                            setSchedulesTabActive: setSchedulesTabActive,
                                            setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                                            setAlertState: setAlertState,
                                            setSyncNeeded: setSyncNeeded,
                                            setSiteInfoChangesMade: setSiteInfoChangesMade,
                                            setScheduleChangesMade: setScheduleChangesMade,
                                            setDeleteScheduleDialogOpen: setDeleteScheduleDialogOpen,
                                            recordingServerData: recordingServerData,
                                            recordingServerPatchObject: recordingServerPatchObject,
                                            setRecordingServerPatchObject: setRecordingServerPatchObject,
                                            setRecordingServerChangesMade: setRecordingServerChangesMade,
                                            recordingServerVisible: recordingServerVisible,
                                            healthCheckData: healthCheckData,
                                            setCameraHealthPatchObject: setCameraHealthPatchObject,
                                            setCameraHealthChangesMade: setCameraHealthChangesMade,
                                            setAddCameraHealthDialogOpen: setAddCameraHealthDialogOpen,
                                            setTurnOffHealthDialogOpen: setTurnOffHealthDialogOpen,
                                            webhooksInfo: webhooksInfo,
                                            setWebhooksPatchObject: setWebhooksPatchObject,
                                            setWebhooksChangesMade: setWebhooksChangesMade,
                                            setEditMode: setEditMode,
                                            showWireguardTab: showWireguardTab,
                                            wireguardTunnels: wireguardTunnels,
                                            wireguardTunnelsLoading: wireguardTunnelsLoading,
                                            selectedWireguardTunnelId: selectedWireguardTunnelId,
                                            setSelectedWireguardTunnelId: setSelectedWireguardTunnelId,
                                            onWireGuardSessionUpdate: onWireGuardSessionUpdate,
                                            setWireguardChangesMade: setWireguardChangesMade,
                                            showDoubleTakeTab: showDoubleTakeTab
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "absolute top-[13px] right-[20px]",
                                            children: !editMode && (!doubleTakeTabOpen || doubleTakeEditable) && (permissions.add_cameras || permissions.edit_cameras) && /*#__PURE__*/ (0, $k4ank.jsx)((0, $5Q799.EditInformationButton), {
                                                clickedTab: clickedTab,
                                                setEditMode: setEditMode,
                                                setActiveTab: setActiveTab,
                                                setPatchObject: setPatchObject,
                                                setSiteInfo: setSiteInfo,
                                                vmsVariables: vmsVariables,
                                                setVmsVariables: setVmsVariables,
                                                siteSchedules: siteSchedules,
                                                siteInfo: siteInfo,
                                                setSiteSchedules: setSiteSchedules,
                                                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                                                editMode: editMode,
                                                setSchedulesTabActive: setSchedulesTabActive,
                                                setClickedTab: setClickedTab,
                                                setAlertState: setAlertState,
                                                setSyncNeeded: setSyncNeeded,
                                                setSiteInfoChangesMade: setSiteInfoChangesMade,
                                                setScheduleChangesMade: setScheduleChangesMade,
                                                setDeleteScheduleDialogOpen: setDeleteScheduleDialogOpen,
                                                recordingServerData: recordingServerData,
                                                recordingServerPatchObject: recordingServerPatchObject,
                                                setRecordingServerPatchObject: setRecordingServerPatchObject,
                                                setRecordingServerChangesMade: setRecordingServerChangesMade,
                                                healthCheckData: healthCheckData,
                                                setCameraHealthPatchObject: setCameraHealthPatchObject,
                                                setCameraHealthChangesMade: setCameraHealthChangesMade,
                                                setAddCameraHealthDialogOpen: setAddCameraHealthDialogOpen,
                                                setTurnOffHealthDialogOpen: setTurnOffHealthDialogOpen,
                                                webhooksInfo: webhooksInfo,
                                                setWebhooksPatchObject: setWebhooksPatchObject,
                                                setWebhooksChangesMade: setWebhooksChangesMade,
                                                setSiteInfoBackup: setSiteInfoBackup,
                                                setVmsVariablesBackup: setVmsVariablesBackup,
                                                setSiteSchedulesBackup: setSiteSchedulesBackup,
                                                setFlexScheduleOnEditButtonClick: setFlexScheduleOnEditButtonClick,
                                                showWireguardTab: showWireguardTab,
                                                wireguardTunnels: wireguardTunnels,
                                                selectedWireguardTunnelId: selectedWireguardTunnelId,
                                                setSelectedWireguardTunnelId: setSelectedWireguardTunnelId,
                                                onWireGuardSessionUpdate: onWireGuardSessionUpdate,
                                                setWireguardChangesMade: setWireguardChangesMade
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: width > 1300 ? "absolute top-[12px] right-[200px]" : "absolute top-[12px] left-[747px]",
                                            children: [
                                                " ",
                                                schedulesTabActive && !editMode && siteInfo.integration_type_name !== "ailink" && siteInfo.integration_type_name !== "autopatrol" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                    onClick: ()=>{
                                                        navigate("/calendars");
                                                    },
                                                    disabled: false,
                                                    text: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lFMkK))), {
                                                                fontSize: "small"
                                                            }),
                                                            "\xa0View Calendars"
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: width > 1300 ? "absolute top-[12px] right-[200px]" : "absolute top-[12px] left-[747px]"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: width > 1300 ? "absolute top-[12px] right-[20px]" : "absolute top-[12px] left-[1008px]",
                                            children: [
                                                editMode && doubleTakeTabOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                    onClick: handleSaveDoubleTake,
                                                    text: "SAVE CHANGES",
                                                    disabled: false
                                                }),
                                                editMode && !doubleTakeTabOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $kHsF1.SaveChangesButton), {
                                                    patchObject: patchObject,
                                                    setEditMode: setEditMode,
                                                    setSiteInfo: setSiteInfo,
                                                    setPatchObject: setPatchObject,
                                                    siteInfo: siteInfo,
                                                    clickedTab: clickedTab,
                                                    setActiveTab: setActiveTab,
                                                    vmsVariables: vmsVariables,
                                                    allSiteSchedules: allSiteSchedules,
                                                    siteSchedules: siteSchedules,
                                                    setAllSiteSchedules: setAllSiteSchedules,
                                                    setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                                                    setAlertState: setAlertState,
                                                    setSyncNeeded: setSyncNeeded,
                                                    editMode: editMode,
                                                    setSchedulesTabActive: setSchedulesTabActive,
                                                    setClickedTab: setClickedTab,
                                                    siteInfoChangesMade: siteInfoChangesMade,
                                                    setSiteInfoChangesMade: setSiteInfoChangesMade,
                                                    scheduleChangesMade: scheduleChangesMade,
                                                    setScheduleChangesMade: setScheduleChangesMade,
                                                    setDeleteScheduleDialogOpen: setDeleteScheduleDialogOpen,
                                                    setSiteSchedules: setSiteSchedules,
                                                    setArmButtonDisabled: setArmButtonDisabled,
                                                    recordingServerChangesMade: recordingServerChangesMade,
                                                    recordingServerData: recordingServerData,
                                                    recordingServerPatchObject: recordingServerPatchObject,
                                                    setRecordingServerData: setRecordingServerData,
                                                    setRecordingServerPatchObject: setRecordingServerPatchObject,
                                                    setRecordingServerChangesMade: setRecordingServerChangesMade,
                                                    cameraHealthChangesMade: cameraHealthChangesMade,
                                                    healthCheckData: healthCheckData,
                                                    setHealthCheckData: setHealthCheckData,
                                                    cameraHealthPatchObject: cameraHealthPatchObject,
                                                    setCameraHealthPatchObject: setCameraHealthPatchObject,
                                                    setCameraHealthChangesMade: setCameraHealthChangesMade,
                                                    setArmedStatus: setArmedStatus,
                                                    webhooksChangesMade: webhooksChangesMade,
                                                    webhooksInfo: webhooksInfo,
                                                    setWebhooksInfo: setWebhooksInfo,
                                                    webhooksPatchObject: webhooksPatchObject,
                                                    setWebhooksPatchObject: setWebhooksPatchObject,
                                                    setWebhooksChangesMade: setWebhooksChangesMade,
                                                    setDeactivateSiteInsteadDialogOpen: setDeactivateSiteInsteadDialogOpen,
                                                    setActivateSiteWithScheduleDialogOpen: setActivateSiteWithScheduleDialogOpen,
                                                    wireguardChangesMade: wireguardChangesMade,
                                                    wireGuardEditSessionRef: wireGuardEditSessionRef,
                                                    setWireguardTunnels: setWireguardTunnels,
                                                    setWireguardChangesMade: setWireguardChangesMade,
                                                    wireguardTunnels: wireguardTunnels,
                                                    wireguardTunnelsLoading: wireguardTunnelsLoading,
                                                    selectedWireguardTunnelId: selectedWireguardTunnelId,
                                                    setSelectedWireguardTunnelId: setSelectedWireguardTunnelId
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: width > 1300 ? "absolute top-[12px] right-[200px]" : "absolute top-[12px] left-[878px]",
                                            children: editMode && /*#__PURE__*/ (0, $k4ank.jsx)((0, $bPE00.CancelButton), {
                                                setEditMode: setEditMode,
                                                clickedTab: clickedTab,
                                                setActiveTab: setActiveTab,
                                                siteInfo: siteInfo,
                                                setRecordingServerPatchObject: setRecordingServerPatchObject,
                                                healthCheckData: healthCheckData,
                                                webhooksInfo: webhooksInfo,
                                                siteInfoBackup: siteInfoBackup,
                                                setSiteInfo: setSiteInfo,
                                                vmsVariablesBackup: vmsVariablesBackup,
                                                setVmsVariables: setVmsVariables,
                                                wireguardTunnels: wireguardTunnels,
                                                wireguardTunnelsLoading: wireguardTunnelsLoading,
                                                selectedWireguardTunnelId: selectedWireguardTunnelId,
                                                setSelectedWireguardTunnelId: setSelectedWireguardTunnelId,
                                                clearWireGuardEditSession: clearWireGuardEditSession,
                                                setWireguardChangesMade: setWireguardChangesMade
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: !navBarCollapsed ? "absolute top-[148px] left-[150px] right-[1px] h-[17vh] min-w-[1440px]" : "absolute top-[148px] left-[75px] right-[1px] h-[17vh] min-w-[1440px]",
                                    children: [
                                        doubleTakeTabOpen ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $a0tnU.DoubleTakeTab), {
                                            siteId: siteIdFromUrl,
                                            siteInfo: siteInfo,
                                            isStaff: isStaff,
                                            editMode: editMode,
                                            saveRef: doubleTakeSaveRef,
                                            onSiteInfoSaved: (fields)=>{
                                                setKeepDoubleTakeTab(true);
                                                setSiteInfo((previous)=>({
                                                        ...previous,
                                                        ...fields
                                                    }));
                                            }
                                        }, siteIdFromUrl) : clickedTab === "nine" && showWireguardTab ? editMode ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $c6iZU.WireGuardTabEditMode), {
                                            wireguardTunnels: wireguardTunnels,
                                            selectedTunnelId: selectedWireguardTunnelId,
                                            onSelectTunnelId: setSelectedWireguardTunnelId,
                                            onSessionUpdate: onWireGuardSessionUpdate,
                                            setWireguardChangesMade: setWireguardChangesMade
                                        }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $4k3Fk.WireGuardTab), {
                                            wireguardTunnels: wireguardTunnels,
                                            wireguardTunnelsLoading: wireguardTunnelsLoading,
                                            selectedTunnelId: selectedWireguardTunnelId,
                                            onSelectTunnelId: setSelectedWireguardTunnelId,
                                            siteId: siteIdFromUrl,
                                            site: siteInfo
                                        }) : activeTab,
                                        !camerasRefreshing && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "pt-[5px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $hlJ5Q.SiteCamerasTable), {
                                                setAlertState: setAlertState,
                                                setSyncNeeded: setSyncNeeded,
                                                setDeativateInquiryDialogOpen: setDeativateInquiryDialogOpen,
                                                siteCameras: siteCameras,
                                                setSiteCameras: setSiteCameras,
                                                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                                                setNoAutoAddCamerasDialogOpen: setNoAutoAddCamerasDialogOpen,
                                                siteInfo: siteInfo,
                                                setSiteInfo: setSiteInfo,
                                                setSiteSchedules: setSiteSchedules,
                                                setActiveTab: setActiveTab,
                                                setDataLoaded: setDataLoaded,
                                                setAllSiteSchedules: setAllSiteSchedules,
                                                setVmsVariables: setVmsVariables,
                                                setArmedStatus: setArmedStatus,
                                                setAiLinkSite: setAiLinkSite,
                                                setSiteDeployed: setSiteDeployed,
                                                setCamerasNotDeployed: setCamerasNotDeployed,
                                                setToolTipTitle: setToolTipTitle,
                                                setConfigureMotion: setConfigureMotion,
                                                setPatchObject: setPatchObject,
                                                setArmButtonDisabled: setArmButtonDisabled,
                                                setRecordingServerData: setRecordingServerData,
                                                setRecordingServerPatchObject: setRecordingServerPatchObject,
                                                setRecordingServerVisible: setRecordingServerVisible,
                                                setHealthCheckData: setHealthCheckData,
                                                setCamerasRefreshing: setCamerasRefreshing,
                                                permissions: permissions,
                                                setWebhooksInfo: setWebhooksInfo,
                                                setWebhooksPatchObject: setWebhooksPatchObject,
                                                siteSchedules: siteSchedules
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "justify-start",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jVN1H.NavBar), {
                    navBarCollapsed: navBarCollapsed,
                    setNavBarCollapsed: setNavBarCollapsed,
                    props: {}
                })
            })
        ]
    });
};

});
parcelRegister("jVN1H", function(module, exports) {

$parcel$export(module.exports, "NavBar", () => $2268aa795fd290d3$export$ef8da11641c635de);

var $k4ank = parcelRequire("k4ank");

var $fIsAN = parcelRequire("fIsAN");

var $8T3gX = parcelRequire("8T3gX");

var $90baQ = parcelRequire("90baQ");

var $9tlSj = parcelRequire("9tlSj");

var $axLMO = parcelRequire("axLMO");

var $gDSfc = parcelRequire("gDSfc");

var $3qyII = parcelRequire("3qyII");

var $g0plP = parcelRequire("g0plP");

var $e9rQm = parcelRequire("e9rQm");

var $9BLod = parcelRequire("9BLod");

var $iCVw8 = parcelRequire("iCVw8");

var $5PzPz = parcelRequire("5PzPz");

var $fzSk5 = parcelRequire("fzSk5");

var $gouAT = parcelRequire("gouAT");

var $hXXs8 = parcelRequire("hXXs8");

var $aYwkU = parcelRequire("aYwkU");

var $cVCJe = parcelRequire("cVCJe");

var $crpct = parcelRequire("crpct");

var $4kUZY = parcelRequire("4kUZY");

var $8utdm = parcelRequire("8utdm");

var $b1uoD = parcelRequire("b1uoD");

var $ctA22 = parcelRequire("ctA22");

var $aTISx = parcelRequire("aTISx");

var $ckl92 = parcelRequire("ckl92");

var $4PFLW = parcelRequire("4PFLW");

var $4G44R = parcelRequire("4G44R");

var $lcmJi = parcelRequire("lcmJi");
const $2268aa795fd290d3$export$ef8da11641c635de = ({ navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed, ...props })=>{
    const appVersion = localStorage.packageJsonVersion;
    const isEuHost = window.location.hostname.includes("actuateui.eu");
    const navLinkStyles = ({ isActive: isActive })=>{
        return {
            fontWeight: isActive ? "bold" : "normal"
        };
    };
    const [alertsIconOpen, setAlertsIconOpen] = $8T3gX.useState(localStorage.alertsIconOpen);
    const [patrolsIconOpen, setPatrolsIconOpen] = $8T3gX.useState(localStorage.patrolsIconOpen);
    const [alertsPagesVisible, setAlertPagesVisible] = $8T3gX.useState(false);
    const [cameraHealthVisible, setCameraHealthVisible] = $8T3gX.useState(false);
    const { flags: flags } = (0, $4PFLW.useFeatureFlag)();
    const showPatrolsPage = flags.showPatrolsPage;
    const showWireguardTunnelsPage = flags.showWireguardTunnelsPage;
    const { showFrontelTab: showFrontelTab } = (0, $4G44R.useClipsStore)();
    const defaultPermissions = {
        view_alerts: false,
        view_analytics: false,
        chm: false,
        ailink: false,
        sentinel: false,
        smtp: false,
        patrol_only: false
    };
    const defaultUserInfo = {
        permission: defaultPermissions,
        group_logo: undefined
    };
    let userInfo = defaultUserInfo;
    try {
        const raw = localStorage.getItem("userInfo");
        if (raw) {
            const parsed = JSON.parse(raw);
            userInfo = {
                ...defaultUserInfo,
                ...parsed,
                permission: {
                    ...defaultPermissions,
                    ...parsed?.permission || {}
                }
            };
        }
    } catch  {
        userInfo = defaultUserInfo;
    }
    const showClipsLink = userInfo.permission.ailink || userInfo.permission.sentinel || userInfo.permission.smtp || showFrontelTab;
    const { height: height } = (0, $crpct.default)();
    $8T3gX.useEffect(()=>{
        if (localStorage.alertsIconOpen) setAlertsIconOpen(false);
        if (localStorage.alertsIconOpen === "true") setAlertsIconOpen(true);
        if (localStorage.patrolsIconOpen) setPatrolsIconOpen(false);
        if (localStorage.patrolsIconOpen === "true") setPatrolsIconOpen(true);
        if (userInfo.permission.chm) setCameraHealthVisible(true);
        if (userInfo.permission.ailink || userInfo.permission.sentinel || userInfo.permission.smtp || showFrontelTab) setAlertPagesVisible(true);
    }, [
        showFrontelTab
    ]);
    $8T3gX.useEffect(()=>{
        if (userInfo.permission.chm) setCameraHealthVisible(true);
    }, []);
    // ENG-1816 / ENG-2000: a View Only user's saved screen list narrows the nav.
    // Each tab keeps its existing gate AND must be in the list (empty list =
    // View All, which is every existing user today). Both nav layouts read
    // these same flags.
    const visibleScreens = (0, $lcmJi.readVisibleScreens)(userInfo.permission);
    const showSitesScreen = (0, $lcmJi.isScreenVisible)(visibleScreens, "sites");
    const showAlertsScreen = Boolean(userInfo.permission?.view_alerts) && (0, $lcmJi.isScreenVisible)(visibleScreens, "alerts");
    // Clips belongs to the Alerts screen: it keeps its own clips-source gate
    // and follows the Alerts entry in the list (hidden for a Health-only user,
    // kept for Alerts-only and View All). The Alerts entry is only a dropdown
    // when Clips actually shows beneath it.
    const showClipsScreen = Boolean(showClipsLink) && (0, $lcmJi.isScreenVisible)(visibleScreens, "alerts");
    const alertsDropdown = alertsPagesVisible && showClipsScreen;
    const showAnalyticsScreen = Boolean(userInfo.permission.view_analytics) && (0, $lcmJi.isScreenVisible)(visibleScreens, "analytics");
    const showHealthScreen = cameraHealthVisible && (0, $lcmJi.isScreenVisible)(visibleScreens, "health");
    const showPatrolsScreen = Boolean(userInfo.permission.view_patrol) && !userInfo.permission.patrol_only && (0, $lcmJi.isScreenVisible)(visibleScreens, "patrols");
    const showWireguardScreen = Boolean(showWireguardTunnelsPage) && (0, $lcmJi.isScreenVisible)(visibleScreens, "wireguard");
    const fullNavBarScreen = /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)("nav", {
            className: "bg-actuate-blue text-white absolute w-[150px] h-full z-20",
            children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "pl-4 pt-5",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.NavLink), {
                            to: "/",
                            style: navLinkStyles,
                            children: /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                                className: "w-24",
                                src: userInfo.group_logo ? userInfo.group_logo : (0, (/*@__PURE__*/$parcel$interopDefault($90baQ))),
                                alt: "actuate logo"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute left-[120px] top-4",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                            onClick: ()=>{
                                setNavBarCollapsed(!navBarCollapsed);
                                localStorage.setItem("navBarCollapsed", JSON.stringify(!navBarCollapsed));
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9BLod))), {})
                        })
                    }),
                    !userInfo.permission.patrol_only && showSitesScreen && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "py-1.5 indent-3 font-mulish text-[14.5px] text-base font-normal ",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $fIsAN.NavLink), {
                            to: "/dashboard",
                            style: navLinkStyles,
                            onClick: ()=>{
                                (0, $3qyII.handleLocalStorageChangesOnNavBarClick)();
                            },
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                                    ...props,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                                        fill: "currentColor",
                                        d: "M3 13h1v7c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7h1a1 1 0 0 0 .707-1.707l-9-9a.999.999 0 0 0-1.414 0l-9 9A1 1 0 0 0 3 13zm7 7v-5h4v5h-4zm2-15.586l6 6V15l.001 5H16v-5c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v5H6v-9.586l6-6z"
                                    })
                                }),
                                "\xa0 Dashboard"
                            ]
                        })
                    }),
                    (userInfo.permission.patrol_only || showSitesScreen) && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "py-1.5 indent-3 font-mulish text-[14.5px] text-base font-normal ",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $fIsAN.NavLink), {
                            to: userInfo.permission.patrol_only ? "/sites_patrol" : "/sites",
                            style: navLinkStyles,
                            onClick: ()=>{
                                localStorage.setItem("storedSelectedIndex", JSON.stringify({
                                    level1: [],
                                    level2: [],
                                    level3: [],
                                    level4: [],
                                    level5: [],
                                    level6: []
                                }));
                            },
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                                    ...props,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                                        fill: "currentColor",
                                        d: "M20.916 9.564a.998.998 0 0 0-.513-1.316L7.328 2.492c-.995-.438-2.22.051-2.645 1.042l-2.21 5.154a2.001 2.001 0 0 0 1.052 2.624L9.563 13.9L8.323 17H4v-3H2v8h2v-3h4.323c.823 0 1.552-.494 1.856-1.258l1.222-3.054l5.205 2.23a1 1 0 0 0 1.31-.517l.312-.71l1.701.68l2-5l-1.536-.613l.523-1.194zm-4.434 5.126L4.313 9.475l2.208-5.152l12.162 5.354l-2.201 5.013z"
                                    })
                                }),
                                "\xa0 Sites"
                            ]
                        })
                    }),
                    showAlertsScreen && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "py-1.5 indent-3 font-mulish text-base text-[14.5px] font-normal ",
                        children: [
                            !alertsDropdown && /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $fIsAN.NavLink), {
                                    to: "/alerts",
                                    style: navLinkStyles,
                                    onClick: ()=>{
                                        (0, $3qyII.handleLocalStorageChangesOnNavBarClick)();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                                            ...props,
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                                                fill: "currentColor",
                                                d: "M11.99 22C6.468 21.994 1.996 17.515 2 11.993C2.004 6.472 6.482 1.998 12.003 2C17.525 2.002 22 6.478 22 12c-.003 5.525-4.485 10.002-10.01 10ZM4 12.172A8 8 0 1 0 4 12v.172ZM13 17h-2v-2h2v2Zm0-4h-2V7h2v6Z"
                                            })
                                        }),
                                        "\xa0 Alerts"
                                    ]
                                })
                            }),
                            alertsDropdown && /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
                                onClick: ()=>{
                                    setAlertsIconOpen(!alertsIconOpen);
                                    localStorage.setItem("alertsIconOpen", JSON.stringify(!alertsIconOpen));
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                                        ...props,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                                            fill: "currentColor",
                                            d: "M11.99 22C6.468 21.994 1.996 17.515 2 11.993C2.004 6.472 6.482 1.998 12.003 2C17.525 2.002 22 6.478 22 12c-.003 5.525-4.485 10.002-10.01 10ZM4 12.172A8 8 0 1 0 4 12v.172ZM13 17h-2v-2h2v2Zm0-4h-2V7h2v6Z"
                                        })
                                    }),
                                    "\xa0 Alerts \xa0\xa0\xa0",
                                    !alertsIconOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9rQm))), {}),
                                    alertsIconOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g0plP))), {})
                                ]
                            }),
                            alertsIconOpen && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "relative left-[6px] text-[14.5px]  p-[5px] pt-[10px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $fIsAN.NavLink), {
                                    to: "/alerts",
                                    style: navLinkStyles,
                                    onClick: ()=>{
                                        (0, $3qyII.handleLocalStorageChangesOnNavBarClick)();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gouAT))), {}),
                                        "\xa0 Live Alerts"
                                    ]
                                })
                            }),
                            alertsIconOpen && showClipsScreen && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "relative left-[6px] text-[14.5px] p-[5px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $fIsAN.NavLink), {
                                    to: "/clips",
                                    style: navLinkStyles,
                                    onClick: ()=>{
                                        (0, $3qyII.handleLocalStorageChangesOnNavBarClick)();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iCVw8))), {}),
                                        "\xa0 Clips"
                                    ]
                                })
                            })
                        ]
                    }),
                    !showAlertsScreen && showClipsScreen && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "py-1.5 indent-3 font-mulish text-base text-[14.5px] font-normal ",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $fIsAN.NavLink), {
                            to: "/clips",
                            style: navLinkStyles,
                            onClick: ()=>{
                                (0, $3qyII.handleLocalStorageChangesOnNavBarClick)();
                            },
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iCVw8))), {}),
                                "\xa0 Clips"
                            ]
                        })
                    }),
                    showPatrolsScreen && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "py-1.5 indent-3 font-mulish text-base text-[14.5px] font-normal ",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
                                onClick: ()=>{
                                    setPatrolsIconOpen(!patrolsIconOpen);
                                    localStorage.setItem("patrolsIconOpen", JSON.stringify(!patrolsIconOpen));
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                                        ...props,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aTISx))), {})
                                    }),
                                    "\xa0 Patrols \xa0",
                                    !patrolsIconOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9rQm))), {}),
                                    patrolsIconOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g0plP))), {})
                                ]
                            }),
                            patrolsIconOpen && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "relative left-[6px] text-[14.5px]  p-[5px] pt-[10px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $fIsAN.NavLink), {
                                    to: "/sites_patrol",
                                    style: navLinkStyles,
                                    onClick: ()=>{
                                        (0, $3qyII.handleLocalStorageChangesOnNavBarClick)();
                                        localStorage.setItem("storedSelectedIndex", JSON.stringify({
                                            level1: [],
                                            level2: [],
                                            level3: [],
                                            level4: [],
                                            level5: [],
                                            level6: []
                                        }));
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                                            ...props,
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                                                fill: "currentColor",
                                                d: "M20.916 9.564a.998.998 0 0 0-.513-1.316L7.328 2.492c-.995-.438-2.22.051-2.645 1.042l-2.21 5.154a2.001 2.001 0 0 0 1.052 2.624L9.563 13.9L8.323 17H4v-3H2v8h2v-3h4.323c.823 0 1.552-.494 1.856-1.258l1.222-3.054l5.205 2.23a1 1 0 0 0 1.31-.517l.312-.71l1.701.68l2-5l-1.536-.613l.523-1.194zm-4.434 5.126L4.313 9.475l2.208-5.152l12.162 5.354l-2.201 5.013z"
                                            })
                                        }),
                                        "\xa0 Patrol Sites"
                                    ]
                                })
                            }),
                            patrolsIconOpen && showPatrolsPage && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "relative left-[6px] text-[14.5px] p-[5px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $fIsAN.NavLink), {
                                    to: "/patrols",
                                    style: navLinkStyles,
                                    onClick: ()=>{
                                        (0, $3qyII.handleLocalStorageChangesOnNavBarClick)();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ckl92))), {}),
                                        "\xa0 Past Patrols"
                                    ]
                                })
                            })
                        ]
                    }),
                    userInfo.permission.patrol_only && userInfo.permission.patrol_only && showPatrolsPage && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "py-1.5 indent-3 font-mulish text-base text-[14.5px] font-normal ",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $fIsAN.NavLink), {
                            to: "/patrols",
                            style: navLinkStyles,
                            onClick: ()=>{
                                (0, $3qyII.handleLocalStorageChangesOnNavBarClick)();
                            },
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                                    ...props,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                                        fill: "currentColor",
                                        d: "M11.99 22C6.468 21.994 1.996 17.515 2 11.993C2.004 6.472 6.482 1.998 12.003 2C17.525 2.002 22 6.478 22 12c-.003 5.525-4.485 10.002-10.01 10ZM4 12.172A8 8 0 1 0 4 12v.172ZM13 17h-2v-2h2v2Zm0-4h-2V7h2v6Z"
                                    })
                                }),
                                "\xa0 Patrols"
                            ]
                        })
                    }),
                    showAnalyticsScreen && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "py-1.5 indent-3 font-mulish text-[14.5px] text-base font-normal ",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $fIsAN.NavLink), {
                            to: "/analytics",
                            style: navLinkStyles,
                            onClick: ()=>{
                                (0, $3qyII.handleLocalStorageChangesOnNavBarClick)();
                            },
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $axLMO.default), {
                                    ...props,
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                                            fill: "currentColor",
                                            d: "M3 3v17a1 1 0 0 0 1 1h17v-2H5V3H3z"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                                            fill: "currentColor",
                                            d: "M15.293 14.707a.999.999 0 0 0 1.414 0l5-5l-1.414-1.414L16 12.586l-2.293-2.293a.999.999 0 0 0-1.414 0l-5 5l1.414 1.414L13 12.414l2.293 2.293z"
                                        })
                                    ]
                                }),
                                "\xa0 Analytics"
                            ]
                        })
                    }),
                    showHealthScreen && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "py-1.5 indent-3 font-mulish text-[14.5px] text-base font-normal ",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $fIsAN.NavLink), {
                            to: "/health",
                            style: navLinkStyles,
                            onClick: ()=>{
                                (0, $3qyII.handleLocalStorageChangesOnNavBarClick)();
                            },
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                                    ...props,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fzSk5))), {})
                                }),
                                "\xa0 Health"
                            ]
                        })
                    }),
                    showWireguardScreen && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "py-1.5 indent-3 font-mulish text-[14.5px] text-base font-normal ",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $fIsAN.NavLink), {
                            to: "/wireguardtunnels",
                            style: navLinkStyles,
                            onClick: ()=>{
                                (0, $3qyII.handleLocalStorageChangesOnNavBarClick)();
                            },
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                                    ...props,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aYwkU))), {})
                                }),
                                "\xa0 WireGuard"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: height > 630 ? "absolute bottom-[140px] indent-3 w-[150px]" : "absolute top-[464px] indent-3 w-[150px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
                            onClick: ()=>{
                                window.open(`https://actuate.status.io/`);
                            },
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                                    ...props,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ctA22))), {})
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "absolute top-[1px] text-white text-[14.5px] font-mulish indent-[29px] font-normal",
                                    children: "System Status"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: height > 630 ? "absolute bottom-[105px] indent-3 w-[150px]" : "absolute top-[499px] indent-3 w-[150px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
                            onClick: ()=>{
                                (0, $8utdm.showReleaseNotesBanner)();
                            // window.open(`https://releasenotes.actuateui.net/`);
                            },
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                                    ...props,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4kUZY))), {})
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "absolute top-[1px] text-white text-[14.5px] font-mulish indent-[29px] font-normal",
                                    children: "Release Notes"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: height > 630 ? "absolute bottom-[70px] indent-3" : "absolute top-[534px] indent-3",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
                            onClick: ()=>{
                                window.open((0, $b1uoD.getSupportBaseUrl)());
                            },
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                                    ...props,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hXXs8))), {})
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "absolute top-[1px] text-white text-[14.5px] font-mulish indent-[29px] font-normal",
                                    children: "Support"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.NavLink), {
                        to: "/",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $gDSfc.UserLink), {})
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                        className: height > 630 ? "absolute bottom-[5px] text-white text-[12px] font-mulish indent-3 font-normal flex items-center gap-1" : "absolute top-[604px] text-white text-[12px] font-mulish indent-3 font-normal flex items-center gap-1",
                        children: [
                            isEuHost && /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                "aria-label": "European Union",
                                className: "text-[11px] leading-none",
                                children: "\uD83C\uDDEA\uD83C\uDDFA"
                            }),
                            "Version ",
                            appVersion
                        ]
                    })
                ]
            })
        })
    });
    const collapsedNavBarScreen = /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)("nav", {
            className: "bg-actuate-blue text-white absolute w-[75px] h-full z-20",
            children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "pl-4 pt-5",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                            title: "Home",
                            placement: "right",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.NavLink), {
                                to: "/",
                                style: navLinkStyles,
                                children: /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                                    className: "w-5",
                                    src: userInfo.group_logo ? userInfo.group_logo : (0, (/*@__PURE__*/$parcel$interopDefault($9tlSj))),
                                    alt: "actuate logo"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute left-10 top-4",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                            onClick: ()=>{
                                setNavBarCollapsed(!navBarCollapsed);
                                localStorage.setItem("navBarCollapsed", JSON.stringify(!navBarCollapsed));
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5PzPz))), {})
                        })
                    }),
                    !userInfo.permission.patrol_only && showSitesScreen && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "py-1.5 indent-3 font-mulish text-[14.5px] text-base font-normal ",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.NavLink), {
                            to: "/dashboard",
                            style: navLinkStyles,
                            onClick: ()=>{
                                (0, $3qyII.handleLocalStorageChangesOnNavBarClick)();
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                title: "Dashboard",
                                placement: "right",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                                    ...props,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                                        fill: "currentColor",
                                        d: "M3 13h1v7c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7h1a1 1 0 0 0 .707-1.707l-9-9a.999.999 0 0 0-1.414 0l-9 9A1 1 0 0 0 3 13zm7 7v-5h4v5h-4zm2-15.586l6 6V15l.001 5H16v-5c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v5H6v-9.586l6-6z"
                                    })
                                })
                            })
                        })
                    }),
                    (userInfo.permission.patrol_only || showSitesScreen) && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "py-1.5 indent-3 font-mulish text-[14.5px] text-base font-normal ",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.NavLink), {
                            to: userInfo.permission.patrol_only ? "/sites_patrol" : "/sites",
                            style: navLinkStyles,
                            onClick: ()=>{
                                localStorage.setItem("storedSelectedIndex", JSON.stringify({
                                    level1: [],
                                    level2: [],
                                    level3: [],
                                    level4: [],
                                    level5: [],
                                    level6: []
                                }));
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                title: "Sites",
                                placement: "right",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                                    ...props,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                                        fill: "currentColor",
                                        d: "M20.916 9.564a.998.998 0 0 0-.513-1.316L7.328 2.492c-.995-.438-2.22.051-2.645 1.042l-2.21 5.154a2.001 2.001 0 0 0 1.052 2.624L9.563 13.9L8.323 17H4v-3H2v8h2v-3h4.323c.823 0 1.552-.494 1.856-1.258l1.222-3.054l5.205 2.23a1 1 0 0 0 1.31-.517l.312-.71l1.701.68l2-5l-1.536-.613l.523-1.194zm-4.434 5.126L4.313 9.475l2.208-5.152l12.162 5.354l-2.201 5.013z"
                                    })
                                })
                            })
                        })
                    }),
                    showAlertsScreen && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "py-1.5 indent-3 font-mulish text-base text-[14.5px] font-normal ",
                        children: [
                            !alertsDropdown && /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.NavLink), {
                                to: "/alerts",
                                style: navLinkStyles,
                                onClick: ()=>{
                                    (0, $3qyII.handleLocalStorageChangesOnNavBarClick)();
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                    title: "Alerts",
                                    placement: "right",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                                        ...props,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                                            fill: "currentColor",
                                            d: "M11.99 22C6.468 21.994 1.996 17.515 2 11.993C2.004 6.472 6.482 1.998 12.003 2C17.525 2.002 22 6.478 22 12c-.003 5.525-4.485 10.002-10.01 10ZM4 12.172A8 8 0 1 0 4 12v.172ZM13 17h-2v-2h2v2Zm0-4h-2V7h2v6Z"
                                        })
                                    })
                                })
                            }),
                            alertsDropdown && /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
                                onClick: ()=>{
                                    setAlertsIconOpen(!alertsIconOpen);
                                    localStorage.setItem("alertsIconOpen", JSON.stringify(!alertsIconOpen));
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                        title: "Alerts",
                                        placement: "right",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                                            ...props,
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                                                fill: "currentColor",
                                                d: "M11.99 22C6.468 21.994 1.996 17.515 2 11.993C2.004 6.472 6.482 1.998 12.003 2C17.525 2.002 22 6.478 22 12c-.003 5.525-4.485 10.002-10.01 10ZM4 12.172A8 8 0 1 0 4 12v.172ZM13 17h-2v-2h2v2Zm0-4h-2V7h2v6Z"
                                            })
                                        })
                                    }),
                                    !alertsIconOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9rQm))), {}),
                                    alertsIconOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g0plP))), {})
                                ]
                            }),
                            alertsIconOpen && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "relative left-[6px] p-[5px] pt-[10px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.NavLink), {
                                    to: "/alerts",
                                    style: navLinkStyles,
                                    onClick: ()=>{
                                        (0, $3qyII.handleLocalStorageChangesOnNavBarClick)();
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                        title: "Live Alerts",
                                        placement: "right",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gouAT))), {})
                                    })
                                })
                            }),
                            alertsIconOpen && showClipsScreen && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "relative left-[6px] p-[5px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.NavLink), {
                                    to: "/clips",
                                    style: navLinkStyles,
                                    onClick: ()=>{
                                        (0, $3qyII.handleLocalStorageChangesOnNavBarClick)();
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                        title: "Clips",
                                        placement: "right",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iCVw8))), {})
                                    })
                                })
                            })
                        ]
                    }),
                    !showAlertsScreen && showClipsScreen && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "py-1.5 indent-3 font-mulish text-[14.5px] text-base font-normal ",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.NavLink), {
                            to: "/clips",
                            style: navLinkStyles,
                            onClick: ()=>{
                                (0, $3qyII.handleLocalStorageChangesOnNavBarClick)();
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                title: "Clips",
                                placement: "right",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iCVw8))), {})
                            })
                        })
                    }),
                    showPatrolsScreen && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "py-1.5 indent-3 font-mulish text-base text-[14.5px] font-normal ",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
                                onClick: ()=>{
                                    setPatrolsIconOpen(!patrolsIconOpen);
                                    localStorage.setItem("patrolsIconOpen", JSON.stringify(!patrolsIconOpen));
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                        title: "Patrols",
                                        placement: "right",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                                            ...props,
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aTISx))), {})
                                        })
                                    }),
                                    !patrolsIconOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9rQm))), {}),
                                    patrolsIconOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g0plP))), {})
                                ]
                            }),
                            patrolsIconOpen && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "relative left-[6px] text-[14.5px]  p-[5px] pt-[10px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.NavLink), {
                                    to: "/sites_patrol",
                                    style: navLinkStyles,
                                    onClick: ()=>{
                                        localStorage.setItem("storedSelectedIndex", JSON.stringify({
                                            level1: [],
                                            level2: [],
                                            level3: [],
                                            level4: [],
                                            level5: [],
                                            level6: []
                                        }));
                                        (0, $3qyII.handleLocalStorageChangesOnNavBarClick)();
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                        title: "Patrol Sites",
                                        placement: "right",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                                            ...props,
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                                                fill: "currentColor",
                                                d: "M20.916 9.564a.998.998 0 0 0-.513-1.316L7.328 2.492c-.995-.438-2.22.051-2.645 1.042l-2.21 5.154a2.001 2.001 0 0 0 1.052 2.624L9.563 13.9L8.323 17H4v-3H2v8h2v-3h4.323c.823 0 1.552-.494 1.856-1.258l1.222-3.054l5.205 2.23a1 1 0 0 0 1.31-.517l.312-.71l1.701.68l2-5l-1.536-.613l.523-1.194zm-4.434 5.126L4.313 9.475l2.208-5.152l12.162 5.354l-2.201 5.013z"
                                            })
                                        })
                                    })
                                })
                            }),
                            patrolsIconOpen && showPatrolsPage && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "relative left-[6px] text-[14.5px] p-[5px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.NavLink), {
                                    to: "/patrols",
                                    style: navLinkStyles,
                                    onClick: ()=>{
                                        (0, $3qyII.handleLocalStorageChangesOnNavBarClick)();
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                        title: "Past Patrols",
                                        placement: "right",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ckl92))), {})
                                    })
                                })
                            })
                        ]
                    }),
                    userInfo.permission.patrol_only && showPatrolsPage && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "py-1.5 indent-3 font-mulish text-base text-[14.5px] font-normal ",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.NavLink), {
                            to: "/patrols",
                            style: navLinkStyles,
                            onClick: ()=>{
                                (0, $3qyII.handleLocalStorageChangesOnNavBarClick)();
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                title: "Patrols",
                                placement: "right",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                                    ...props,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                                        fill: "currentColor",
                                        d: "M11.99 22C6.468 21.994 1.996 17.515 2 11.993C2.004 6.472 6.482 1.998 12.003 2C17.525 2.002 22 6.478 22 12c-.003 5.525-4.485 10.002-10.01 10ZM4 12.172A8 8 0 1 0 4 12v.172ZM13 17h-2v-2h2v2Zm0-4h-2V7h2v6Z"
                                    })
                                })
                            })
                        })
                    }),
                    showAnalyticsScreen && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "py-1.5 indent-3 font-mulish text-[14.5px] text-base font-normal ",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.NavLink), {
                            to: "/analytics",
                            style: navLinkStyles,
                            onClick: ()=>{
                                (0, $3qyII.handleLocalStorageChangesOnNavBarClick)();
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                title: "Analytics",
                                placement: "right",
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $axLMO.default), {
                                    ...props,
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                                            fill: "currentColor",
                                            d: "M3 3v17a1 1 0 0 0 1 1h17v-2H5V3H3z"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                                            fill: "currentColor",
                                            d: "M15.293 14.707a.999.999 0 0 0 1.414 0l5-5l-1.414-1.414L16 12.586l-2.293-2.293a.999.999 0 0 0-1.414 0l-5 5l1.414 1.414L13 12.414l2.293 2.293z"
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    showHealthScreen && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "py-1.5 indent-3 font-mulish text-[14.5px] text-base font-normal ",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $fIsAN.NavLink), {
                            to: "/health",
                            style: navLinkStyles,
                            onClick: ()=>{
                                (0, $3qyII.handleLocalStorageChangesOnNavBarClick)();
                            },
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                    title: "Health",
                                    placement: "right",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                                        ...props,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fzSk5))), {})
                                    })
                                }),
                                "\xa0"
                            ]
                        })
                    }),
                    showWireguardScreen && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "py-1.5 indent-3 font-mulish text-[14.5px] text-base font-normal ",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $fIsAN.NavLink), {
                            to: "/wireguardtunnels",
                            style: navLinkStyles,
                            onClick: ()=>{
                                (0, $3qyII.handleLocalStorageChangesOnNavBarClick)();
                            },
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                    title: "WireGuard",
                                    placement: "right",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aYwkU))), {})
                                }),
                                "\xa0"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: height > 630 ? "absolute bottom-[140px] indent-3 w-[150px]" : "absolute top-[464px] indent-3 w-[150px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                            onClick: ()=>{
                                window.open(`https://actuate.status.io/`);
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                title: "System Status",
                                placement: "right",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                                    ...props,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ctA22))), {})
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: height > 630 ? "absolute bottom-[105px] indent-3" : "absolute top-[499px] indent-3",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                            onClick: ()=>{
                                (0, $8utdm.showReleaseNotesBanner)();
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                title: "Release Notes",
                                placement: "right",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                                    ...props,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4kUZY))), {})
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: height > 630 ? "absolute bottom-[70px] indent-3" : "absolute top-[534px] indent-3",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                            onClick: ()=>{
                                window.open((0, $b1uoD.getSupportBaseUrl)());
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                title: "Support",
                                placement: "right",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                                    ...props,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hXXs8))), {})
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.NavLink), {
                        to: "/",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: height > 630 ? "absolute bottom-[35px] text-white text-[16px] font-mulish indent-3 font-normal" : "absolute top-[569px] text-white text-[16px] font-mulish indent-3 font-normal",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                title: "User",
                                placement: "right",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                                    ...props,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                                        fill: "currentColor",
                                        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88a9.947 9.947 0 0 1 12.28 0C16.43 19.18 14.03 20 12 20z"
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
        children: navBarCollapsed ? collapsedNavBarScreen : fullNavBarScreen
    });
};

});
parcelRegister("fIsAN", function(module, exports) {

$parcel$export(module.exports, "unstable_HistoryRouter", () => $b71124f85d4fc180$export$eefb0c834599897e);
$parcel$export(module.exports, "Link", () => $b71124f85d4fc180$export$a6c7ac8248d6e38a);
$parcel$export(module.exports, "NavLink", () => $b71124f85d4fc180$export$b0d92dbee9b5b60d);
$parcel$export(module.exports, "useSearchParams", () => $b71124f85d4fc180$export$f1a78c17382fe22a);
$parcel$export(module.exports, "useLocation", () => (parcelRequire("3T949")).useLocation);
$parcel$export(module.exports, "useNavigate", () => (parcelRequire("3T949")).useNavigate);
/**
 * React Router DOM v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8T3gX = parcelRequire("8T3gX");

var $8VQWA = parcelRequire("8VQWA");

var $bnQ5y = parcelRequire("bnQ5y");
var $3T949 = parcelRequire("3T949");

var $bnQ5y = parcelRequire("bnQ5y");
function $b71124f85d4fc180$var$_extends() {
    $b71124f85d4fc180$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b71124f85d4fc180$var$_extends.apply(this, arguments);
}
function $b71124f85d4fc180$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $b71124f85d4fc180$var$defaultMethod = "get";
const $b71124f85d4fc180$var$defaultEncType = "application/x-www-form-urlencoded";
function $b71124f85d4fc180$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $b71124f85d4fc180$var$isButtonElement(object) {
    return $b71124f85d4fc180$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $b71124f85d4fc180$var$isFormElement(object) {
    return $b71124f85d4fc180$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $b71124f85d4fc180$var$isInputElement(object) {
    return $b71124f85d4fc180$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $b71124f85d4fc180$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $b71124f85d4fc180$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$b71124f85d4fc180$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $b71124f85d4fc180$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $b71124f85d4fc180$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $b71124f85d4fc180$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $b71124f85d4fc180$var$_formDataSupportsSubmitter = null;
function $b71124f85d4fc180$var$isFormDataSubmitterSupported() {
    if ($b71124f85d4fc180$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $b71124f85d4fc180$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $b71124f85d4fc180$var$_formDataSupportsSubmitter = true;
    }
    return $b71124f85d4fc180$var$_formDataSupportsSubmitter;
}
const $b71124f85d4fc180$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $b71124f85d4fc180$var$getFormEncType(encType) {
    if (encType != null && !$b71124f85d4fc180$var$supportedFormEncTypes.has(encType)) {
        (0, $bnQ5y.UNSAFE_warning)(false, "\"" + encType + "\" is not a valid `encType` for `<Form>`/`<fetcher.Form>` " + ("and will default to \"" + $b71124f85d4fc180$var$defaultEncType + "\""));
        return null;
    }
    return encType;
}
function $b71124f85d4fc180$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($b71124f85d4fc180$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $bnQ5y.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $b71124f85d4fc180$var$defaultMethod;
        encType = $b71124f85d4fc180$var$getFormEncType(target.getAttribute("enctype")) || $b71124f85d4fc180$var$defaultEncType;
        formData = new FormData(target);
    } else if ($b71124f85d4fc180$var$isButtonElement(target) || $b71124f85d4fc180$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $bnQ5y.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $b71124f85d4fc180$var$defaultMethod;
        encType = $b71124f85d4fc180$var$getFormEncType(target.getAttribute("formenctype")) || $b71124f85d4fc180$var$getFormEncType(form.getAttribute("enctype")) || $b71124f85d4fc180$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$b71124f85d4fc180$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($b71124f85d4fc180$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $b71124f85d4fc180$var$defaultMethod;
        action = null;
        encType = $b71124f85d4fc180$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $b71124f85d4fc180$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $b71124f85d4fc180$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $b71124f85d4fc180$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $b71124f85d4fc180$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $b71124f85d4fc180$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $b71124f85d4fc180$export$1f3f55432a00e06d(routes, opts) {
    return (0, $bnQ5y.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $b71124f85d4fc180$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $bnQ5y.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $b71124f85d4fc180$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $3T949.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $b71124f85d4fc180$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $bnQ5y.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $b71124f85d4fc180$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $bnQ5y.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $b71124f85d4fc180$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $3T949.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $b71124f85d4fc180$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $b71124f85d4fc180$var$_extends({}, state, {
        errors: $b71124f85d4fc180$var$deserializeErrors(state.errors)
    });
    return state;
}
function $b71124f85d4fc180$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $bnQ5y.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $b71124f85d4fc180$export$7ad602f0e94e62d1 = /*#__PURE__*/ $8T3gX.createContext({
    isTransitioning: false
});
$b71124f85d4fc180$export$7ad602f0e94e62d1.displayName = "ViewTransition";
const $b71124f85d4fc180$export$148fd98d095596d4 = /*#__PURE__*/ $8T3gX.createContext(new Map());
$b71124f85d4fc180$export$148fd98d095596d4.displayName = "Fetchers";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $b71124f85d4fc180$var$START_TRANSITION = "startTransition";
const $b71124f85d4fc180$var$startTransitionImpl = $8T3gX[$b71124f85d4fc180$var$START_TRANSITION];
const $b71124f85d4fc180$var$FLUSH_SYNC = "flushSync";
const $b71124f85d4fc180$var$flushSyncImpl = $8VQWA[$b71124f85d4fc180$var$FLUSH_SYNC];
const $b71124f85d4fc180$var$USE_ID = "useId";
const $b71124f85d4fc180$var$useIdImpl = $8T3gX[$b71124f85d4fc180$var$USE_ID];
function $b71124f85d4fc180$var$startTransitionSafe(cb) {
    if ($b71124f85d4fc180$var$startTransitionImpl) $b71124f85d4fc180$var$startTransitionImpl(cb);
    else cb();
}
function $b71124f85d4fc180$var$flushSyncSafe(cb) {
    if ($b71124f85d4fc180$var$flushSyncImpl) $b71124f85d4fc180$var$flushSyncImpl(cb);
    else cb();
}
class $b71124f85d4fc180$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $b71124f85d4fc180$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8T3gX.useState(router.state);
    let [pendingState, setPendingState] = $8T3gX.useState();
    let [vtContext, setVtContext] = $8T3gX.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $8T3gX.useState();
    let [transition, setTransition] = $8T3gX.useState();
    let [interruption, setInterruption] = $8T3gX.useState();
    let fetcherData = $8T3gX.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $8T3gX.useCallback((cb)=>{
        if (v7_startTransition) $b71124f85d4fc180$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $8T3gX.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $b71124f85d4fc180$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $b71124f85d4fc180$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $b71124f85d4fc180$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $b71124f85d4fc180$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $b71124f85d4fc180$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8T3gX.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $8T3gX.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $b71124f85d4fc180$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $8T3gX.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $8T3gX.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $8T3gX.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $8T3gX.useEffect(()=>{
        (0, $bnQ5y.UNSAFE_warning)(fallbackElement == null || !router.future.v7_partialHydration, "`<RouterProvider fallbackElement>` is deprecated when using `v7_partialHydration`, use a `HydrateFallback` component instead");
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8T3gX.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8T3gX.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $8T3gX.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $8T3gX.useEffect(()=>(0, $3T949.UNSAFE_logV6DeprecationWarnings)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8T3gX.createElement($8T3gX.Fragment, null, /*#__PURE__*/ $8T3gX.createElement((0, $3T949.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8T3gX.createElement((0, $3T949.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $8T3gX.createElement($b71124f85d4fc180$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $8T3gX.createElement($b71124f85d4fc180$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $8T3gX.createElement((0, $3T949.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8T3gX.createElement($b71124f85d4fc180$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $b71124f85d4fc180$var$MemoizedDataRoutes = /*#__PURE__*/ $8T3gX.memo($b71124f85d4fc180$var$DataRoutes);
function $b71124f85d4fc180$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $3T949.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $b71124f85d4fc180$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $8T3gX.useRef();
    if (historyRef.current == null) historyRef.current = (0, $bnQ5y.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8T3gX.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8T3gX.useCallback((newState)=>{
        v7_startTransition && $b71124f85d4fc180$var$startTransitionImpl ? $b71124f85d4fc180$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8T3gX.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8T3gX.useEffect(()=>(0, $3T949.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $8T3gX.createElement((0, $3T949.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $b71124f85d4fc180$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $8T3gX.useRef();
    if (historyRef.current == null) historyRef.current = (0, $bnQ5y.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8T3gX.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8T3gX.useCallback((newState)=>{
        v7_startTransition && $b71124f85d4fc180$var$startTransitionImpl ? $b71124f85d4fc180$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8T3gX.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8T3gX.useEffect(()=>(0, $3T949.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $8T3gX.createElement((0, $3T949.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $b71124f85d4fc180$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $8T3gX.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8T3gX.useCallback((newState)=>{
        v7_startTransition && $b71124f85d4fc180$var$startTransitionImpl ? $b71124f85d4fc180$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8T3gX.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8T3gX.useEffect(()=>(0, $3T949.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $8T3gX.createElement((0, $3T949.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
$b71124f85d4fc180$export$eefb0c834599897e.displayName = "unstable_HistoryRouter";
const $b71124f85d4fc180$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $b71124f85d4fc180$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $b71124f85d4fc180$export$a6c7ac8248d6e38a = /*#__PURE__*/ $8T3gX.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $b71124f85d4fc180$var$_objectWithoutPropertiesLoose(_ref7, $b71124f85d4fc180$var$_excluded);
    let { basename: basename } = $8T3gX.useContext((0, $3T949.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $b71124f85d4fc180$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($b71124f85d4fc180$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $bnQ5y.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            // We can't do external URL detection without a valid URL
            (0, $bnQ5y.UNSAFE_warning)(false, "<Link to=\"" + to + "\"> contains an invalid URL which will probably break " + "when clicked - please update to a valid URL path.");
        }
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $3T949.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $b71124f85d4fc180$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $8T3gX.createElement("a", $b71124f85d4fc180$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
$b71124f85d4fc180$export$a6c7ac8248d6e38a.displayName = "Link";
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $b71124f85d4fc180$export$b0d92dbee9b5b60d = /*#__PURE__*/ $8T3gX.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $b71124f85d4fc180$var$_objectWithoutPropertiesLoose(_ref8, $b71124f85d4fc180$var$_excluded2);
    let path = (0, $3T949.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $3T949.useLocation)();
    let routerState = $8T3gX.useContext((0, $3T949.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $8T3gX.useContext((0, $3T949.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $b71124f85d4fc180$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $bnQ5y.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $8T3gX.createElement($b71124f85d4fc180$export$a6c7ac8248d6e38a, $b71124f85d4fc180$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
$b71124f85d4fc180$export$b0d92dbee9b5b60d.displayName = "NavLink";
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $b71124f85d4fc180$export$a7fed597f4b8afd8 = /*#__PURE__*/ $8T3gX.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $b71124f85d4fc180$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $b71124f85d4fc180$var$_objectWithoutPropertiesLoose(_ref9, $b71124f85d4fc180$var$_excluded3);
    let submit = $b71124f85d4fc180$export$47c85c6e3a081d3();
    let formAction = $b71124f85d4fc180$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $8T3gX.createElement("form", $b71124f85d4fc180$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
$b71124f85d4fc180$export$a7fed597f4b8afd8.displayName = "Form";
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $b71124f85d4fc180$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $b71124f85d4fc180$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
$b71124f85d4fc180$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $b71124f85d4fc180$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($b71124f85d4fc180$var$DataRouterHook || ($b71124f85d4fc180$var$DataRouterHook = {}));
var $b71124f85d4fc180$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($b71124f85d4fc180$var$DataRouterStateHook || ($b71124f85d4fc180$var$DataRouterStateHook = {}));
// Internal hooks
function $b71124f85d4fc180$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $b71124f85d4fc180$var$useDataRouterContext(hookName) {
    let ctx = $8T3gX.useContext((0, $3T949.UNSAFE_DataRouterContext));
    !ctx && (0, $bnQ5y.UNSAFE_invariant)(false, $b71124f85d4fc180$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $b71124f85d4fc180$var$useDataRouterState(hookName) {
    let state = $8T3gX.useContext((0, $3T949.UNSAFE_DataRouterStateContext));
    !state && (0, $bnQ5y.UNSAFE_invariant)(false, $b71124f85d4fc180$var$getDataRouterConsoleError(hookName));
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $b71124f85d4fc180$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $3T949.useNavigate)();
    let location = (0, $3T949.useLocation)();
    let path = (0, $3T949.useResolvedPath)(to, {
        relative: relative
    });
    return $8T3gX.useCallback((event)=>{
        if ($b71124f85d4fc180$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $bnQ5y.createPath)(location) === (0, $bnQ5y.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $b71124f85d4fc180$export$f1a78c17382fe22a(defaultInit) {
    (0, $bnQ5y.UNSAFE_warning)(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
    let defaultSearchParamsRef = $8T3gX.useRef($b71124f85d4fc180$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $8T3gX.useRef(false);
    let location = (0, $3T949.useLocation)();
    let searchParams = $8T3gX.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $b71124f85d4fc180$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $3T949.useNavigate)();
    let setSearchParams = $8T3gX.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $b71124f85d4fc180$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $b71124f85d4fc180$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $b71124f85d4fc180$var$fetcherId = 0;
let $b71124f85d4fc180$var$getUniqueFetcherId = ()=>"__" + String(++$b71124f85d4fc180$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $b71124f85d4fc180$export$47c85c6e3a081d3() {
    let { router: router } = $b71124f85d4fc180$var$useDataRouterContext($b71124f85d4fc180$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $8T3gX.useContext((0, $3T949.UNSAFE_NavigationContext));
    let currentRouteId = (0, $3T949.UNSAFE_useRouteId)();
    return $8T3gX.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $b71124f85d4fc180$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $b71124f85d4fc180$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $b71124f85d4fc180$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $b71124f85d4fc180$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $8T3gX.useContext((0, $3T949.UNSAFE_NavigationContext));
    let routeContext = $8T3gX.useContext((0, $3T949.UNSAFE_RouteContext));
    !routeContext && (0, $bnQ5y.UNSAFE_invariant)(false, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $b71124f85d4fc180$var$_extends({}, (0, $3T949.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $3T949.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $bnQ5y.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $bnQ5y.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $b71124f85d4fc180$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $b71124f85d4fc180$var$useDataRouterContext($b71124f85d4fc180$var$DataRouterHook.UseFetcher);
    let state = $b71124f85d4fc180$var$useDataRouterState($b71124f85d4fc180$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $8T3gX.useContext($b71124f85d4fc180$export$148fd98d095596d4);
    let route = $8T3gX.useContext((0, $3T949.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $bnQ5y.UNSAFE_invariant)(false, "useFetcher must be used inside a FetchersContext");
    !route && (0, $bnQ5y.UNSAFE_invariant)(false, "useFetcher must be used inside a RouteContext");
    !(routeId != null) && (0, $bnQ5y.UNSAFE_invariant)(false, "useFetcher can only be used on routes that contain a unique \"id\"");
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $b71124f85d4fc180$var$useIdImpl ? $b71124f85d4fc180$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $8T3gX.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($b71124f85d4fc180$var$getUniqueFetcherId());
    // Registration/cleanup
    $8T3gX.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $8T3gX.useCallback((href, opts)=>{
        !routeId && (0, $bnQ5y.UNSAFE_invariant)(false, "No routeId available for fetcher.load()");
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $b71124f85d4fc180$export$47c85c6e3a081d3();
    let submit = $8T3gX.useCallback((target, opts)=>{
        submitImpl(target, $b71124f85d4fc180$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $8T3gX.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $8T3gX.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $8T3gX.createElement($b71124f85d4fc180$export$a7fed597f4b8afd8, $b71124f85d4fc180$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        FetcherForm.displayName = "fetcher.Form";
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $bnQ5y.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $8T3gX.useMemo(()=>$b71124f85d4fc180$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $b71124f85d4fc180$export$fa996778a3a31087() {
    let state = $b71124f85d4fc180$var$useDataRouterState($b71124f85d4fc180$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $b71124f85d4fc180$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $b71124f85d4fc180$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $b71124f85d4fc180$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $b71124f85d4fc180$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $b71124f85d4fc180$var$useDataRouterContext($b71124f85d4fc180$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $b71124f85d4fc180$var$useDataRouterState($b71124f85d4fc180$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $8T3gX.useContext((0, $3T949.UNSAFE_NavigationContext));
    let location = (0, $3T949.useLocation)();
    let matches = (0, $3T949.useMatches)();
    let navigation = (0, $3T949.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $8T3gX.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $b71124f85d4fc180$var$usePageHide($8T3gX.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $b71124f85d4fc180$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $b71124f85d4fc180$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($b71124f85d4fc180$var$savedScrollPositions));
        } catch (error) {
            (0, $bnQ5y.UNSAFE_warning)(false, "Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (" + error + ").");
        }
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8T3gX.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $b71124f85d4fc180$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $b71124f85d4fc180$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8T3gX.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($b71124f85d4fc180$var$_extends({}, location, {
                    pathname: (0, $bnQ5y.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($b71124f85d4fc180$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8T3gX.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $b71124f85d4fc180$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $8T3gX.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $b71124f85d4fc180$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $8T3gX.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $b71124f85d4fc180$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $3T949.useBlocker)(when);
    $8T3gX.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $8T3gX.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $b71124f85d4fc180$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $8T3gX.useContext($b71124f85d4fc180$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $bnQ5y.UNSAFE_invariant)(false, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $b71124f85d4fc180$var$useDataRouterContext($b71124f85d4fc180$var$DataRouterHook.useViewTransitionState);
    let path = (0, $3T949.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $bnQ5y.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $bnQ5y.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $bnQ5y.matchPath)(path.pathname, nextPath) != null || (0, $bnQ5y.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("bnQ5y", function(module, exports) {

$parcel$export(module.exports, "Action", () => $849a3f667a98fd57$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "createMemoryHistory", () => $849a3f667a98fd57$export$2b76ad033c6e6d08);
$parcel$export(module.exports, "UNSAFE_warning", () => $849a3f667a98fd57$export$c0e02632e14916fd);
$parcel$export(module.exports, "createPath", () => $849a3f667a98fd57$export$fe53371bee54353d);
$parcel$export(module.exports, "parsePath", () => $849a3f667a98fd57$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createBrowserHistory", () => $849a3f667a98fd57$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $849a3f667a98fd57$export$b71fdd3798280242);
$parcel$export(module.exports, "UNSAFE_invariant", () => $849a3f667a98fd57$export$3e9cee6b33872309);
$parcel$export(module.exports, "matchRoutes", () => $849a3f667a98fd57$export$2708184779ceb39d);
$parcel$export(module.exports, "stripBasename", () => $849a3f667a98fd57$export$b69e3301ce081aa3);
$parcel$export(module.exports, "UNSAFE_decodePath", () => $849a3f667a98fd57$export$30d21fd6d7295f52);
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", () => $849a3f667a98fd57$export$b3fac024fad9e8ff);
$parcel$export(module.exports, "joinPaths", () => $849a3f667a98fd57$export$86d9a7913e44197e);
$parcel$export(module.exports, "matchPath", () => $849a3f667a98fd57$export$81336c211d5ff295);
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", () => $849a3f667a98fd57$export$a5784978eca585fa);
$parcel$export(module.exports, "resolveTo", () => $849a3f667a98fd57$export$cae722b0cc860f13);
$parcel$export(module.exports, "AbortedDeferredError", () => $849a3f667a98fd57$export$42a99a7a4bc0e76a);
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", () => $849a3f667a98fd57$export$6c6580e81da25755);
$parcel$export(module.exports, "isRouteErrorResponse", () => $849a3f667a98fd57$export$972111febbeef05b);
$parcel$export(module.exports, "IDLE_FETCHER", () => $849a3f667a98fd57$export$52eace9c284d3585);
$parcel$export(module.exports, "IDLE_BLOCKER", () => $849a3f667a98fd57$export$386d57f03f0b2883);
$parcel$export(module.exports, "createRouter", () => $849a3f667a98fd57$export$baddd0131ee8c05b);
/**
 * @remix-run/router v1.23.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $849a3f667a98fd57$var$_extends() {
    $849a3f667a98fd57$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $849a3f667a98fd57$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $849a3f667a98fd57$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($849a3f667a98fd57$export$e19cd5f9376f8cee || ($849a3f667a98fd57$export$e19cd5f9376f8cee = {}));
const $849a3f667a98fd57$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $849a3f667a98fd57$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $849a3f667a98fd57$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $849a3f667a98fd57$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $849a3f667a98fd57$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $849a3f667a98fd57$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $849a3f667a98fd57$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $849a3f667a98fd57$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $849a3f667a98fd57$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $849a3f667a98fd57$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $849a3f667a98fd57$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $849a3f667a98fd57$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $849a3f667a98fd57$export$fe53371bee54353d(to);
    }
    return $849a3f667a98fd57$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $849a3f667a98fd57$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $849a3f667a98fd57$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $849a3f667a98fd57$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $849a3f667a98fd57$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $849a3f667a98fd57$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $849a3f667a98fd57$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $849a3f667a98fd57$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $849a3f667a98fd57$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $849a3f667a98fd57$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $849a3f667a98fd57$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $849a3f667a98fd57$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $849a3f667a98fd57$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $849a3f667a98fd57$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $849a3f667a98fd57$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $849a3f667a98fd57$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $849a3f667a98fd57$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $849a3f667a98fd57$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $849a3f667a98fd57$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($849a3f667a98fd57$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $849a3f667a98fd57$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $849a3f667a98fd57$export$e19cd5f9376f8cee.Push;
        let location = $849a3f667a98fd57$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $849a3f667a98fd57$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $849a3f667a98fd57$export$e19cd5f9376f8cee.Replace;
        let location = $849a3f667a98fd57$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $849a3f667a98fd57$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $849a3f667a98fd57$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $849a3f667a98fd57$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($849a3f667a98fd57$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($849a3f667a98fd57$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $849a3f667a98fd57$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($849a3f667a98fd57$var$ResultType || ($849a3f667a98fd57$var$ResultType = {}));
const $849a3f667a98fd57$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $849a3f667a98fd57$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $849a3f667a98fd57$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $849a3f667a98fd57$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $849a3f667a98fd57$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($849a3f667a98fd57$var$isIndexRoute(route)) {
            let indexRoute = $849a3f667a98fd57$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $849a3f667a98fd57$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $849a3f667a98fd57$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $849a3f667a98fd57$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $849a3f667a98fd57$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $849a3f667a98fd57$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $849a3f667a98fd57$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $849a3f667a98fd57$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $849a3f667a98fd57$var$flattenRoutes(routes);
    $849a3f667a98fd57$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $849a3f667a98fd57$export$30d21fd6d7295f52(pathname);
        matches = $849a3f667a98fd57$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $849a3f667a98fd57$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $849a3f667a98fd57$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $849a3f667a98fd57$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $849a3f667a98fd57$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $849a3f667a98fd57$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $849a3f667a98fd57$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $849a3f667a98fd57$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $849a3f667a98fd57$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $849a3f667a98fd57$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $849a3f667a98fd57$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $849a3f667a98fd57$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $849a3f667a98fd57$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $849a3f667a98fd57$var$paramRe = /^:[\w-]+$/;
const $849a3f667a98fd57$var$dynamicSegmentValue = 3;
const $849a3f667a98fd57$var$indexRouteValue = 2;
const $849a3f667a98fd57$var$emptySegmentValue = 1;
const $849a3f667a98fd57$var$staticSegmentValue = 10;
const $849a3f667a98fd57$var$splatPenalty = -2;
const $849a3f667a98fd57$var$isSplat = (s)=>s === "*";
function $849a3f667a98fd57$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($849a3f667a98fd57$var$isSplat)) initialScore += $849a3f667a98fd57$var$splatPenalty;
    if (index) initialScore += $849a3f667a98fd57$var$indexRouteValue;
    return segments.filter((s)=>!$849a3f667a98fd57$var$isSplat(s)).reduce((score, segment)=>score + ($849a3f667a98fd57$var$paramRe.test(segment) ? $849a3f667a98fd57$var$dynamicSegmentValue : segment === "" ? $849a3f667a98fd57$var$emptySegmentValue : $849a3f667a98fd57$var$staticSegmentValue), initialScore);
}
function $849a3f667a98fd57$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $849a3f667a98fd57$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $849a3f667a98fd57$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $849a3f667a98fd57$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $849a3f667a98fd57$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $849a3f667a98fd57$export$a5c6d149b50c1d86($849a3f667a98fd57$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $849a3f667a98fd57$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $849a3f667a98fd57$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $849a3f667a98fd57$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $849a3f667a98fd57$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $849a3f667a98fd57$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $849a3f667a98fd57$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $849a3f667a98fd57$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $849a3f667a98fd57$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $849a3f667a98fd57$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $849a3f667a98fd57$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $849a3f667a98fd57$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $849a3f667a98fd57$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $849a3f667a98fd57$var$isAbsoluteUrl = (url)=>$849a3f667a98fd57$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $849a3f667a98fd57$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $849a3f667a98fd57$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($849a3f667a98fd57$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $849a3f667a98fd57$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $849a3f667a98fd57$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $849a3f667a98fd57$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $849a3f667a98fd57$var$normalizeSearch(search),
        hash: $849a3f667a98fd57$var$normalizeHash(hash)
    };
}
function $849a3f667a98fd57$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $849a3f667a98fd57$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $849a3f667a98fd57$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $849a3f667a98fd57$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $849a3f667a98fd57$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $849a3f667a98fd57$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $849a3f667a98fd57$export$8ccf933b0513f8d0(toArg);
    else {
        to = $849a3f667a98fd57$var$_extends({}, toArg);
        $849a3f667a98fd57$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $849a3f667a98fd57$var$getInvalidPathError("?", "pathname", "search", to));
        $849a3f667a98fd57$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $849a3f667a98fd57$var$getInvalidPathError("#", "pathname", "hash", to));
        $849a3f667a98fd57$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $849a3f667a98fd57$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $849a3f667a98fd57$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $849a3f667a98fd57$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $849a3f667a98fd57$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $849a3f667a98fd57$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $849a3f667a98fd57$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $849a3f667a98fd57$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $849a3f667a98fd57$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $849a3f667a98fd57$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $849a3f667a98fd57$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $849a3f667a98fd57$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $849a3f667a98fd57$export$4051a07651545597(data, init) {
    return new $849a3f667a98fd57$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $849a3f667a98fd57$export$42a99a7a4bc0e76a extends Error {
}
class $849a3f667a98fd57$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $849a3f667a98fd57$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $849a3f667a98fd57$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $849a3f667a98fd57$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $849a3f667a98fd57$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $849a3f667a98fd57$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $849a3f667a98fd57$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $849a3f667a98fd57$var$unwrapTrackedPromise(value) {
    if (!$849a3f667a98fd57$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $849a3f667a98fd57$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $849a3f667a98fd57$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $849a3f667a98fd57$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $849a3f667a98fd57$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $849a3f667a98fd57$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $849a3f667a98fd57$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $849a3f667a98fd57$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $849a3f667a98fd57$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $849a3f667a98fd57$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $849a3f667a98fd57$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $849a3f667a98fd57$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $849a3f667a98fd57$var$validMutationMethods = new Set($849a3f667a98fd57$var$validMutationMethodsArr);
const $849a3f667a98fd57$var$validRequestMethodsArr = [
    "get",
    ...$849a3f667a98fd57$var$validMutationMethodsArr
];
const $849a3f667a98fd57$var$validRequestMethods = new Set($849a3f667a98fd57$var$validRequestMethodsArr);
const $849a3f667a98fd57$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $849a3f667a98fd57$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $849a3f667a98fd57$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $849a3f667a98fd57$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $849a3f667a98fd57$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $849a3f667a98fd57$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $849a3f667a98fd57$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $849a3f667a98fd57$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $849a3f667a98fd57$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $849a3f667a98fd57$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $849a3f667a98fd57$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $849a3f667a98fd57$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $849a3f667a98fd57$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $849a3f667a98fd57$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $849a3f667a98fd57$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $849a3f667a98fd57$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $849a3f667a98fd57$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$849a3f667a98fd57$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$849a3f667a98fd57$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $849a3f667a98fd57$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $849a3f667a98fd57$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $849a3f667a98fd57$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $849a3f667a98fd57$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $849a3f667a98fd57$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$849a3f667a98fd57$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($849a3f667a98fd57$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $849a3f667a98fd57$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $849a3f667a98fd57$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $849a3f667a98fd57$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $849a3f667a98fd57$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $849a3f667a98fd57$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $849a3f667a98fd57$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $849a3f667a98fd57$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $849a3f667a98fd57$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $849a3f667a98fd57$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($849a3f667a98fd57$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $849a3f667a98fd57$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $849a3f667a98fd57$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $849a3f667a98fd57$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $849a3f667a98fd57$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $849a3f667a98fd57$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $849a3f667a98fd57$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $849a3f667a98fd57$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $849a3f667a98fd57$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $849a3f667a98fd57$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $849a3f667a98fd57$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $849a3f667a98fd57$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $849a3f667a98fd57$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $849a3f667a98fd57$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $849a3f667a98fd57$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $849a3f667a98fd57$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $849a3f667a98fd57$var$findNearestBoundary(matches).route.id,
            {
                type: $849a3f667a98fd57$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $849a3f667a98fd57$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($849a3f667a98fd57$var$isErrorResult(result) && $849a3f667a98fd57$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $849a3f667a98fd57$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $849a3f667a98fd57$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $849a3f667a98fd57$var$_extends({
            matches: updatedMatches || matches
        }, $849a3f667a98fd57$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $849a3f667a98fd57$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $849a3f667a98fd57$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $849a3f667a98fd57$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $849a3f667a98fd57$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $849a3f667a98fd57$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $849a3f667a98fd57$var$ResultType.error,
            error: $849a3f667a98fd57$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($849a3f667a98fd57$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $849a3f667a98fd57$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($849a3f667a98fd57$var$isDeferredResult(result)) throw $849a3f667a98fd57$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($849a3f667a98fd57$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $849a3f667a98fd57$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $849a3f667a98fd57$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $849a3f667a98fd57$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $849a3f667a98fd57$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($849a3f667a98fd57$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $849a3f667a98fd57$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $849a3f667a98fd57$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $849a3f667a98fd57$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $849a3f667a98fd57$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $849a3f667a98fd57$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $849a3f667a98fd57$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $849a3f667a98fd57$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $849a3f667a98fd57$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $849a3f667a98fd57$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $849a3f667a98fd57$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$849a3f667a98fd57$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $849a3f667a98fd57$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $849a3f667a98fd57$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $849a3f667a98fd57$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $849a3f667a98fd57$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $849a3f667a98fd57$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $849a3f667a98fd57$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $849a3f667a98fd57$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $849a3f667a98fd57$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $849a3f667a98fd57$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $849a3f667a98fd57$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $849a3f667a98fd57$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $849a3f667a98fd57$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($849a3f667a98fd57$var$isRedirectResult(actionResult) || $849a3f667a98fd57$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $849a3f667a98fd57$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($849a3f667a98fd57$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $849a3f667a98fd57$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $849a3f667a98fd57$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($849a3f667a98fd57$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($849a3f667a98fd57$var$isDeferredResult(actionResult)) throw $849a3f667a98fd57$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $849a3f667a98fd57$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $849a3f667a98fd57$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $849a3f667a98fd57$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $849a3f667a98fd57$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $849a3f667a98fd57$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $849a3f667a98fd57$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $849a3f667a98fd57$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $849a3f667a98fd57$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $849a3f667a98fd57$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $849a3f667a98fd57$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $849a3f667a98fd57$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $849a3f667a98fd57$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $849a3f667a98fd57$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $849a3f667a98fd57$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $849a3f667a98fd57$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $849a3f667a98fd57$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($849a3f667a98fd57$var$isDeferredResult(result)) result = await $849a3f667a98fd57$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $849a3f667a98fd57$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($849a3f667a98fd57$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $849a3f667a98fd57$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($849a3f667a98fd57$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $849a3f667a98fd57$export$3e9cee6b33872309(!$849a3f667a98fd57$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $849a3f667a98fd57$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $849a3f667a98fd57$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $849a3f667a98fd57$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $849a3f667a98fd57$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($849a3f667a98fd57$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $849a3f667a98fd57$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $849a3f667a98fd57$export$e19cd5f9376f8cee.Replace : $849a3f667a98fd57$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $849a3f667a98fd57$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($849a3f667a98fd57$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $849a3f667a98fd57$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $849a3f667a98fd57$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $849a3f667a98fd57$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $849a3f667a98fd57$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $849a3f667a98fd57$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($849a3f667a98fd57$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $849a3f667a98fd57$var$ResultType.redirect,
                response: $849a3f667a98fd57$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $849a3f667a98fd57$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $849a3f667a98fd57$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $849a3f667a98fd57$var$ResultType.error,
                    error: $849a3f667a98fd57$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $849a3f667a98fd57$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $849a3f667a98fd57$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $849a3f667a98fd57$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $849a3f667a98fd57$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $849a3f667a98fd57$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $849a3f667a98fd57$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $849a3f667a98fd57$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $849a3f667a98fd57$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $849a3f667a98fd57$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $849a3f667a98fd57$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $849a3f667a98fd57$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $849a3f667a98fd57$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $849a3f667a98fd57$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $849a3f667a98fd57$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$849a3f667a98fd57$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $849a3f667a98fd57$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $849a3f667a98fd57$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $849a3f667a98fd57$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $849a3f667a98fd57$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $849a3f667a98fd57$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $849a3f667a98fd57$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $849a3f667a98fd57$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $849a3f667a98fd57$export$4d0306f8f6a4585b = Symbol("deferred");
function $849a3f667a98fd57$export$3336b097a6fbc59a(routes, opts) {
    $849a3f667a98fd57$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $849a3f667a98fd57$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $849a3f667a98fd57$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $849a3f667a98fd57$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $849a3f667a98fd57$var$createLocation("", $849a3f667a98fd57$export$fe53371bee54353d(url), null, "default");
        let matches = $849a3f667a98fd57$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$849a3f667a98fd57$var$isValidMethod(method) && method !== "HEAD") {
            let error = $849a3f667a98fd57$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $849a3f667a98fd57$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $849a3f667a98fd57$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $849a3f667a98fd57$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($849a3f667a98fd57$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $849a3f667a98fd57$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $849a3f667a98fd57$var$createLocation("", $849a3f667a98fd57$export$fe53371bee54353d(url), null, "default");
        let matches = $849a3f667a98fd57$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$849a3f667a98fd57$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $849a3f667a98fd57$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $849a3f667a98fd57$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $849a3f667a98fd57$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $849a3f667a98fd57$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $849a3f667a98fd57$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($849a3f667a98fd57$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$849a3f667a98fd57$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $849a3f667a98fd57$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($849a3f667a98fd57$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $849a3f667a98fd57$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $849a3f667a98fd57$var$isResponse(result) ? result : $849a3f667a98fd57$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($849a3f667a98fd57$var$isDataStrategyResult(e) && $849a3f667a98fd57$var$isResponse(e.result)) {
                if (e.type === $849a3f667a98fd57$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($849a3f667a98fd57$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $849a3f667a98fd57$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $849a3f667a98fd57$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $849a3f667a98fd57$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($849a3f667a98fd57$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($849a3f667a98fd57$var$isDeferredResult(result)) {
            let error = $849a3f667a98fd57$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $849a3f667a98fd57$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($849a3f667a98fd57$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($849a3f667a98fd57$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $849a3f667a98fd57$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $849a3f667a98fd57$var$_extends({}, context, {
                statusCode: $849a3f667a98fd57$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $849a3f667a98fd57$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $849a3f667a98fd57$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $849a3f667a98fd57$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $849a3f667a98fd57$var$isErrorResult(pendingActionResult[1]) ? $849a3f667a98fd57$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $849a3f667a98fd57$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $849a3f667a98fd57$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $849a3f667a98fd57$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $849a3f667a98fd57$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $849a3f667a98fd57$var$callDataStrategyImpl(dataStrategy || $849a3f667a98fd57$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($849a3f667a98fd57$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $849a3f667a98fd57$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($849a3f667a98fd57$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $849a3f667a98fd57$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $849a3f667a98fd57$export$fec11da027c70692(routes, context, error) {
    let newContext = $849a3f667a98fd57$var$_extends({}, context, {
        statusCode: $849a3f667a98fd57$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $849a3f667a98fd57$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $849a3f667a98fd57$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $849a3f667a98fd57$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $849a3f667a98fd57$export$cae722b0cc860f13(to ? to : ".", $849a3f667a98fd57$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $849a3f667a98fd57$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $849a3f667a98fd57$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $849a3f667a98fd57$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $849a3f667a98fd57$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $849a3f667a98fd57$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$849a3f667a98fd57$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$849a3f667a98fd57$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $849a3f667a98fd57$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $849a3f667a98fd57$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $849a3f667a98fd57$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$849a3f667a98fd57$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$849a3f667a98fd57$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $849a3f667a98fd57$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $849a3f667a98fd57$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $849a3f667a98fd57$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $849a3f667a98fd57$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $849a3f667a98fd57$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($849a3f667a98fd57$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $849a3f667a98fd57$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $849a3f667a98fd57$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $849a3f667a98fd57$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $849a3f667a98fd57$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $849a3f667a98fd57$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $849a3f667a98fd57$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $849a3f667a98fd57$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $849a3f667a98fd57$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $849a3f667a98fd57$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $849a3f667a98fd57$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($849a3f667a98fd57$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $849a3f667a98fd57$var$shouldRevalidateLoader(match, $849a3f667a98fd57$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $849a3f667a98fd57$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $849a3f667a98fd57$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $849a3f667a98fd57$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $849a3f667a98fd57$var$shouldRevalidateLoader(fetcherMatch, $849a3f667a98fd57$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $849a3f667a98fd57$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $849a3f667a98fd57$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $849a3f667a98fd57$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $849a3f667a98fd57$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $849a3f667a98fd57$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $849a3f667a98fd57$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$849a3f667a98fd57$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $849a3f667a98fd57$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $849a3f667a98fd57$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$849a3f667a98fd57$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $849a3f667a98fd57$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $849a3f667a98fd57$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $849a3f667a98fd57$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$849a3f667a98fd57$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $849a3f667a98fd57$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $849a3f667a98fd57$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $849a3f667a98fd57$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $849a3f667a98fd57$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $849a3f667a98fd57$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $849a3f667a98fd57$var$ResultType.data,
                result: undefined
            });
        };
        return $849a3f667a98fd57$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $849a3f667a98fd57$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $849a3f667a98fd57$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $849a3f667a98fd57$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $849a3f667a98fd57$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $849a3f667a98fd57$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $849a3f667a98fd57$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $849a3f667a98fd57$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($849a3f667a98fd57$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $849a3f667a98fd57$var$ResultType.error,
                error: e
            };
        }
        if (type === $849a3f667a98fd57$var$ResultType.error) return {
            type: $849a3f667a98fd57$var$ResultType.error,
            error: new $849a3f667a98fd57$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $849a3f667a98fd57$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $849a3f667a98fd57$var$ResultType.error) {
        if ($849a3f667a98fd57$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $849a3f667a98fd57$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $849a3f667a98fd57$var$ResultType.error,
                error: new $849a3f667a98fd57$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $849a3f667a98fd57$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $849a3f667a98fd57$var$ResultType.error,
            error: result,
            statusCode: $849a3f667a98fd57$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($849a3f667a98fd57$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $849a3f667a98fd57$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($849a3f667a98fd57$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $849a3f667a98fd57$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $849a3f667a98fd57$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $849a3f667a98fd57$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $849a3f667a98fd57$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$849a3f667a98fd57$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $849a3f667a98fd57$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $849a3f667a98fd57$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($849a3f667a98fd57$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $849a3f667a98fd57$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $849a3f667a98fd57$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($849a3f667a98fd57$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $849a3f667a98fd57$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $849a3f667a98fd57$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $849a3f667a98fd57$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $849a3f667a98fd57$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $849a3f667a98fd57$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $849a3f667a98fd57$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $849a3f667a98fd57$export$3e9cee6b33872309(!$849a3f667a98fd57$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($849a3f667a98fd57$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $849a3f667a98fd57$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $849a3f667a98fd57$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($849a3f667a98fd57$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $849a3f667a98fd57$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $849a3f667a98fd57$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $849a3f667a98fd57$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($849a3f667a98fd57$var$isErrorResult(result)) {
            let boundaryMatch = $849a3f667a98fd57$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $849a3f667a98fd57$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($849a3f667a98fd57$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $849a3f667a98fd57$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($849a3f667a98fd57$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $849a3f667a98fd57$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $849a3f667a98fd57$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $849a3f667a98fd57$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $849a3f667a98fd57$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $849a3f667a98fd57$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $849a3f667a98fd57$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $849a3f667a98fd57$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $849a3f667a98fd57$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $849a3f667a98fd57$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $849a3f667a98fd57$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $849a3f667a98fd57$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($849a3f667a98fd57$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $849a3f667a98fd57$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $849a3f667a98fd57$export$8ccf933b0513f8d0(path) : path;
    return $849a3f667a98fd57$export$fe53371bee54353d($849a3f667a98fd57$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $849a3f667a98fd57$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $849a3f667a98fd57$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $849a3f667a98fd57$var$ResultType.data || result.type === $849a3f667a98fd57$var$ResultType.error);
}
function $849a3f667a98fd57$var$isRedirectDataStrategyResultResult(result) {
    return $849a3f667a98fd57$var$isResponse(result.result) && $849a3f667a98fd57$var$redirectStatusCodes.has(result.result.status);
}
function $849a3f667a98fd57$var$isDeferredResult(result) {
    return result.type === $849a3f667a98fd57$var$ResultType.deferred;
}
function $849a3f667a98fd57$var$isErrorResult(result) {
    return result.type === $849a3f667a98fd57$var$ResultType.error;
}
function $849a3f667a98fd57$var$isRedirectResult(result) {
    return (result && result.type) === $849a3f667a98fd57$var$ResultType.redirect;
}
function $849a3f667a98fd57$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $849a3f667a98fd57$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $849a3f667a98fd57$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $849a3f667a98fd57$var$isRedirectResponse(result) {
    if (!$849a3f667a98fd57$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $849a3f667a98fd57$var$isValidMethod(method) {
    return $849a3f667a98fd57$var$validRequestMethods.has(method.toLowerCase());
}
function $849a3f667a98fd57$var$isMutationMethod(method) {
    return $849a3f667a98fd57$var$validMutationMethods.has(method.toLowerCase());
}
async function $849a3f667a98fd57$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$849a3f667a98fd57$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($849a3f667a98fd57$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $849a3f667a98fd57$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $849a3f667a98fd57$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($849a3f667a98fd57$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $849a3f667a98fd57$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $849a3f667a98fd57$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $849a3f667a98fd57$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $849a3f667a98fd57$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $849a3f667a98fd57$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $849a3f667a98fd57$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $849a3f667a98fd57$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $849a3f667a98fd57$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $849a3f667a98fd57$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $849a3f667a98fd57$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $849a3f667a98fd57$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $849a3f667a98fd57$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $849a3f667a98fd57$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $849a3f667a98fd57$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $849a3f667a98fd57$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $849a3f667a98fd57$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $849a3f667a98fd57$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $849a3f667a98fd57$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($849a3f667a98fd57$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $849a3f667a98fd57$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($849a3f667a98fd57$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $849a3f667a98fd57$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("3T949", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", () => $2d4d8a77428439fe$export$3add0d5dce533e2e);
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", () => $2d4d8a77428439fe$export$145dfa71566a64dc);
$parcel$export(module.exports, "UNSAFE_NavigationContext", () => $2d4d8a77428439fe$export$26749e8557646306);
$parcel$export(module.exports, "UNSAFE_RouteContext", () => $2d4d8a77428439fe$export$9072aa6dd1f93057);
$parcel$export(module.exports, "useHref", () => $2d4d8a77428439fe$export$b66bb29c5006f12f);
$parcel$export(module.exports, "useResolvedPath", () => $2d4d8a77428439fe$export$e75d2a2d1b3c245b);
$parcel$export(module.exports, "useLocation", () => $2d4d8a77428439fe$export$45d76561a5302f2b);
$parcel$export(module.exports, "useNavigate", () => $2d4d8a77428439fe$export$9770f232ac06a008);
$parcel$export(module.exports, "useParams", () => $2d4d8a77428439fe$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", () => $2d4d8a77428439fe$export$5fcee62552a12fbf);
$parcel$export(module.exports, "UNSAFE_useRouteId", () => $2d4d8a77428439fe$export$5fc8298006ad9e58);
$parcel$export(module.exports, "useNavigation", () => $2d4d8a77428439fe$export$d0fd4b7106de2769);
$parcel$export(module.exports, "useMatches", () => $2d4d8a77428439fe$export$2378eb7f5ff86053);
$parcel$export(module.exports, "useBlocker", () => $2d4d8a77428439fe$export$b273b3273281a049);
$parcel$export(module.exports, "UNSAFE_logV6DeprecationWarnings", () => $2d4d8a77428439fe$export$db5148ec97d6af7a);
$parcel$export(module.exports, "Router", () => $2d4d8a77428439fe$export$55185c17a0fcbe46);
$parcel$export(module.exports, "Navigate", () => $2d4d8a77428439fe$export$444b3ab0cb9aec40);
$parcel$export(module.exports, "Route", () => $2d4d8a77428439fe$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Routes", () => $2d4d8a77428439fe$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", () => $2d4d8a77428439fe$export$52b333d321859367);
/**
 * React Router v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8T3gX = parcelRequire("8T3gX");

var $bnQ5y = parcelRequire("bnQ5y");
function $2d4d8a77428439fe$var$_extends() {
    $2d4d8a77428439fe$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2d4d8a77428439fe$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $2d4d8a77428439fe$export$3add0d5dce533e2e = /*#__PURE__*/ $8T3gX.createContext(null);
$2d4d8a77428439fe$export$3add0d5dce533e2e.displayName = "DataRouter";
const $2d4d8a77428439fe$export$145dfa71566a64dc = /*#__PURE__*/ $8T3gX.createContext(null);
$2d4d8a77428439fe$export$145dfa71566a64dc.displayName = "DataRouterState";
const $2d4d8a77428439fe$var$AwaitContext = /*#__PURE__*/ $8T3gX.createContext(null);
$2d4d8a77428439fe$var$AwaitContext.displayName = "Await";
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $2d4d8a77428439fe$export$26749e8557646306 = /*#__PURE__*/ $8T3gX.createContext(null);
$2d4d8a77428439fe$export$26749e8557646306.displayName = "Navigation";
const $2d4d8a77428439fe$export$c7914228fb69b0f5 = /*#__PURE__*/ $8T3gX.createContext(null);
$2d4d8a77428439fe$export$c7914228fb69b0f5.displayName = "Location";
const $2d4d8a77428439fe$export$9072aa6dd1f93057 = /*#__PURE__*/ $8T3gX.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$2d4d8a77428439fe$export$9072aa6dd1f93057.displayName = "Route";
const $2d4d8a77428439fe$var$RouteErrorContext = /*#__PURE__*/ $8T3gX.createContext(null);
$2d4d8a77428439fe$var$RouteErrorContext.displayName = "RouteError";
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $2d4d8a77428439fe$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$2d4d8a77428439fe$export$9c954a9d03d32f4a() && (0, $bnQ5y.UNSAFE_invariant)(false, // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component.");
    let { basename: basename, navigator: navigator } = $8T3gX.useContext($2d4d8a77428439fe$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $2d4d8a77428439fe$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $bnQ5y.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $2d4d8a77428439fe$export$9c954a9d03d32f4a() {
    return $8T3gX.useContext($2d4d8a77428439fe$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $2d4d8a77428439fe$export$45d76561a5302f2b() {
    !$2d4d8a77428439fe$export$9c954a9d03d32f4a() && (0, $bnQ5y.UNSAFE_invariant)(false, // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component.");
    return $8T3gX.useContext($2d4d8a77428439fe$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $2d4d8a77428439fe$export$1b3f31771c5d07c() {
    return $8T3gX.useContext($2d4d8a77428439fe$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $2d4d8a77428439fe$export$6c330e8992e8a295(pattern) {
    !$2d4d8a77428439fe$export$9c954a9d03d32f4a() && (0, $bnQ5y.UNSAFE_invariant)(false, // router loaded. We can help them understand how to avoid that.
    "useMatch() may be used only in the context of a <Router> component.");
    let { pathname: pathname } = $2d4d8a77428439fe$export$45d76561a5302f2b();
    return $8T3gX.useMemo(()=>(0, $bnQ5y.matchPath)(pattern, (0, $bnQ5y.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $2d4d8a77428439fe$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $2d4d8a77428439fe$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $8T3gX.useContext($2d4d8a77428439fe$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8T3gX.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $2d4d8a77428439fe$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $8T3gX.useContext($2d4d8a77428439fe$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $2d4d8a77428439fe$var$useNavigateStable() : $2d4d8a77428439fe$var$useNavigateUnstable();
}
function $2d4d8a77428439fe$var$useNavigateUnstable() {
    !$2d4d8a77428439fe$export$9c954a9d03d32f4a() && (0, $bnQ5y.UNSAFE_invariant)(false, // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component.");
    let dataRouterContext = $8T3gX.useContext($2d4d8a77428439fe$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $8T3gX.useContext($2d4d8a77428439fe$export$26749e8557646306);
    let { matches: matches } = $8T3gX.useContext($2d4d8a77428439fe$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2d4d8a77428439fe$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $bnQ5y.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $8T3gX.useRef(false);
    $2d4d8a77428439fe$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8T3gX.useCallback(function(to, options) {
        if (options === void 0) options = {};
        (0, $bnQ5y.UNSAFE_warning)(activeRef.current, $2d4d8a77428439fe$var$navigateEffectWarning);
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $bnQ5y.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $bnQ5y.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $2d4d8a77428439fe$var$OutletContext = /*#__PURE__*/ $8T3gX.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $2d4d8a77428439fe$export$4138103a3ae699cc() {
    return $8T3gX.useContext($2d4d8a77428439fe$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $2d4d8a77428439fe$export$a3be3530d8e40d0b(context) {
    let outlet = $8T3gX.useContext($2d4d8a77428439fe$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $2d4d8a77428439fe$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $8T3gX.useContext($2d4d8a77428439fe$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $2d4d8a77428439fe$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $8T3gX.useContext($2d4d8a77428439fe$export$26749e8557646306);
    let { matches: matches } = $8T3gX.useContext($2d4d8a77428439fe$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2d4d8a77428439fe$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $bnQ5y.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $8T3gX.useMemo(()=>(0, $bnQ5y.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $2d4d8a77428439fe$export$5d3fca4a98652595(routes, locationArg) {
    return $2d4d8a77428439fe$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $2d4d8a77428439fe$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$2d4d8a77428439fe$export$9c954a9d03d32f4a() && (0, $bnQ5y.UNSAFE_invariant)(false, // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component.");
    let { navigator: navigator } = $8T3gX.useContext($2d4d8a77428439fe$export$26749e8557646306);
    let { matches: parentMatches } = $8T3gX.useContext($2d4d8a77428439fe$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    {
        // You won't get a warning about 2 different <Routes> under a <Route>
        // without a trailing *, but this is a best-effort warning anyway since we
        // cannot even give the warning unless they land at the parent route.
        //
        // Example:
        //
        // <Routes>
        //   {/* This route path MUST end with /* because otherwise
        //       it will never match /blog/post/123 */}
        //   <Route path="blog" element={<Blog />} />
        //   <Route path="blog/feed" element={<BlogFeed />} />
        // </Routes>
        //
        // function Blog() {
        //   return (
        //     <Routes>
        //       <Route path="post/:id" element={<Post />} />
        //     </Routes>
        //   );
        // }
        let parentPath = parentRoute && parentRoute.path || "";
        $2d4d8a77428439fe$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*"), "You rendered descendant <Routes> (or called `useRoutes()`) at " + ("\"" + parentPathname + "\" (under <Route path=\"" + parentPath + "\">) but the ") + "parent route path has no trailing \"*\". This means if you navigate " + "deeper, the parent won't match anymore and therefore the child " + "routes will never render.\n\n" + ("Please change the parent <Route path=\"" + parentPath + "\"> to <Route ") + ("path=\"" + (parentPath === "/" ? "*" : parentPath + "/*") + "\">."));
    }
    let locationFromContext = $2d4d8a77428439fe$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $bnQ5y.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $bnQ5y.UNSAFE_invariant)(false, "When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, the location pathname must begin with the portion of the URL pathname that was " + ("matched by all parent routes. The current pathname base is \"" + parentPathnameBase + "\" ") + ("but pathname \"" + parsedLocationArg.pathname + "\" was given in the `location` prop."));
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $bnQ5y.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    (0, $bnQ5y.UNSAFE_warning)(parentRoute || matches != null, "No routes matched location \"" + location.pathname + location.search + location.hash + "\" ");
    (0, $bnQ5y.UNSAFE_warning)(matches == null || matches[matches.length - 1].route.element !== undefined || matches[matches.length - 1].route.Component !== undefined || matches[matches.length - 1].route.lazy !== undefined, "Matched leaf route at location \"" + location.pathname + location.search + location.hash + "\" " + "does not have an element or Component. This means it will render an <Outlet /> with a " + "null value by default resulting in an \"empty\" page.");
    let renderedMatches = $2d4d8a77428439fe$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $bnQ5y.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $bnQ5y.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $2d4d8a77428439fe$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $bnQ5y.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $2d4d8a77428439fe$var$DefaultErrorComponent() {
    let error = $2d4d8a77428439fe$export$ed527bf60f6e05f2();
    let message = (0, $bnQ5y.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    console.error("Error handled by React Router default ErrorBoundary:", error);
    devInfo = /*#__PURE__*/ $8T3gX.createElement($8T3gX.Fragment, null, /*#__PURE__*/ $8T3gX.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /*#__PURE__*/ $8T3gX.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /*#__PURE__*/ $8T3gX.createElement("code", {
        style: codeStyles
    }, "ErrorBoundary"), " or", " ", /*#__PURE__*/ $8T3gX.createElement("code", {
        style: codeStyles
    }, "errorElement"), " prop on your route."));
    return /*#__PURE__*/ $8T3gX.createElement($8T3gX.Fragment, null, /*#__PURE__*/ $8T3gX.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $8T3gX.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $8T3gX.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $2d4d8a77428439fe$var$defaultErrorElement = /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$DefaultErrorComponent, null);
class $2d4d8a77428439fe$var$RenderErrorBoundary extends $8T3gX.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $2d4d8a77428439fe$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $8T3gX.useContext($2d4d8a77428439fe$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $2d4d8a77428439fe$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $bnQ5y.UNSAFE_invariant)(false, "Could not find a matching route for errors on route IDs: " + Object.keys(errors).join(","));
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $2d4d8a77428439fe$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $2d4d8a77428439fe$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $8T3gX.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $2d4d8a77428439fe$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($2d4d8a77428439fe$var$DataRouterHook || {});
var $2d4d8a77428439fe$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($2d4d8a77428439fe$var$DataRouterStateHook || {});
function $2d4d8a77428439fe$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $2d4d8a77428439fe$var$useDataRouterContext(hookName) {
    let ctx = $8T3gX.useContext($2d4d8a77428439fe$export$3add0d5dce533e2e);
    !ctx && (0, $bnQ5y.UNSAFE_invariant)(false, $2d4d8a77428439fe$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $2d4d8a77428439fe$var$useDataRouterState(hookName) {
    let state = $8T3gX.useContext($2d4d8a77428439fe$export$145dfa71566a64dc);
    !state && (0, $bnQ5y.UNSAFE_invariant)(false, $2d4d8a77428439fe$var$getDataRouterConsoleError(hookName));
    return state;
}
function $2d4d8a77428439fe$var$useRouteContext(hookName) {
    let route = $8T3gX.useContext($2d4d8a77428439fe$export$9072aa6dd1f93057);
    !route && (0, $bnQ5y.UNSAFE_invariant)(false, $2d4d8a77428439fe$var$getDataRouterConsoleError(hookName));
    return route;
}
// Internal version with hookName-aware debugging
function $2d4d8a77428439fe$var$useCurrentRouteId(hookName) {
    let route = $2d4d8a77428439fe$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $bnQ5y.UNSAFE_invariant)(false, hookName + " can only be used on routes that contain a unique \"id\"");
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $2d4d8a77428439fe$export$5fc8298006ad9e58() {
    return $2d4d8a77428439fe$var$useCurrentRouteId($2d4d8a77428439fe$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $2d4d8a77428439fe$export$d0fd4b7106de2769() {
    let state = $2d4d8a77428439fe$var$useDataRouterState($2d4d8a77428439fe$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $2d4d8a77428439fe$export$600dc272ed516c15() {
    let dataRouterContext = $2d4d8a77428439fe$var$useDataRouterContext($2d4d8a77428439fe$var$DataRouterHook.UseRevalidator);
    let state = $2d4d8a77428439fe$var$useDataRouterState($2d4d8a77428439fe$var$DataRouterStateHook.UseRevalidator);
    return $8T3gX.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $2d4d8a77428439fe$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $2d4d8a77428439fe$var$useDataRouterState($2d4d8a77428439fe$var$DataRouterStateHook.UseMatches);
    return $8T3gX.useMemo(()=>matches.map((m)=>(0, $bnQ5y.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $2d4d8a77428439fe$export$1448a5050d252c4d() {
    let state = $2d4d8a77428439fe$var$useDataRouterState($2d4d8a77428439fe$var$DataRouterStateHook.UseLoaderData);
    let routeId = $2d4d8a77428439fe$var$useCurrentRouteId($2d4d8a77428439fe$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $2d4d8a77428439fe$export$fd5d37484eab868d(routeId) {
    let state = $2d4d8a77428439fe$var$useDataRouterState($2d4d8a77428439fe$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $2d4d8a77428439fe$export$fdc00f3f26066d5e() {
    let state = $2d4d8a77428439fe$var$useDataRouterState($2d4d8a77428439fe$var$DataRouterStateHook.UseActionData);
    let routeId = $2d4d8a77428439fe$var$useCurrentRouteId($2d4d8a77428439fe$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $2d4d8a77428439fe$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $8T3gX.useContext($2d4d8a77428439fe$var$RouteErrorContext);
    let state = $2d4d8a77428439fe$var$useDataRouterState($2d4d8a77428439fe$var$DataRouterStateHook.UseRouteError);
    let routeId = $2d4d8a77428439fe$var$useCurrentRouteId($2d4d8a77428439fe$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $2d4d8a77428439fe$export$78a72ddb39bdd145() {
    let value = $8T3gX.useContext($2d4d8a77428439fe$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $2d4d8a77428439fe$export$17f53340677d5831() {
    let value = $8T3gX.useContext($2d4d8a77428439fe$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $2d4d8a77428439fe$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $2d4d8a77428439fe$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $2d4d8a77428439fe$var$useDataRouterContext($2d4d8a77428439fe$var$DataRouterHook.UseBlocker);
    let state = $2d4d8a77428439fe$var$useDataRouterState($2d4d8a77428439fe$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $8T3gX.useState("");
    let blockerFunction = $8T3gX.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $2d4d8a77428439fe$var$_extends({}, currentLocation, {
                pathname: (0, $bnQ5y.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $2d4d8a77428439fe$var$_extends({}, nextLocation, {
                pathname: (0, $bnQ5y.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $8T3gX.useEffect(()=>{
        let key = String(++$2d4d8a77428439fe$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $8T3gX.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $bnQ5y.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $2d4d8a77428439fe$var$useNavigateStable() {
    let { router: router } = $2d4d8a77428439fe$var$useDataRouterContext($2d4d8a77428439fe$var$DataRouterHook.UseNavigateStable);
    let id = $2d4d8a77428439fe$var$useCurrentRouteId($2d4d8a77428439fe$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $8T3gX.useRef(false);
    $2d4d8a77428439fe$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8T3gX.useCallback(function(to, options) {
        if (options === void 0) options = {};
        (0, $bnQ5y.UNSAFE_warning)(activeRef.current, $2d4d8a77428439fe$var$navigateEffectWarning);
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $2d4d8a77428439fe$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $2d4d8a77428439fe$var$alreadyWarned$1 = {};
function $2d4d8a77428439fe$var$warningOnce(key, cond, message) {
    if (!cond && !$2d4d8a77428439fe$var$alreadyWarned$1[key]) {
        $2d4d8a77428439fe$var$alreadyWarned$1[key] = true;
        (0, $bnQ5y.UNSAFE_warning)(false, message);
    }
}
const $2d4d8a77428439fe$var$alreadyWarned = {};
function $2d4d8a77428439fe$var$warnOnce(key, message) {
    if (!$2d4d8a77428439fe$var$alreadyWarned[message]) {
        $2d4d8a77428439fe$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}
const $2d4d8a77428439fe$var$logDeprecation = (flag, msg, link)=>$2d4d8a77428439fe$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $2d4d8a77428439fe$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $2d4d8a77428439fe$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $2d4d8a77428439fe$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $2d4d8a77428439fe$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $2d4d8a77428439fe$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $2d4d8a77428439fe$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $2d4d8a77428439fe$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $2d4d8a77428439fe$var$START_TRANSITION = "startTransition";
const $2d4d8a77428439fe$var$startTransitionImpl = $8T3gX[$2d4d8a77428439fe$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $2d4d8a77428439fe$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8T3gX.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8T3gX.useCallback((newState)=>{
        if (v7_startTransition && $2d4d8a77428439fe$var$startTransitionImpl) $2d4d8a77428439fe$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8T3gX.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $8T3gX.useEffect(()=>{
        (0, $bnQ5y.UNSAFE_warning)(fallbackElement == null || !router.future.v7_partialHydration, "`<RouterProvider fallbackElement>` is deprecated when using `v7_partialHydration`, use a `HydrateFallback` component instead");
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8T3gX.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8T3gX.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $8T3gX.useEffect(()=>$2d4d8a77428439fe$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8T3gX.createElement($8T3gX.Fragment, null, /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $2d4d8a77428439fe$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $2d4d8a77428439fe$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $2d4d8a77428439fe$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $8T3gX.useRef();
    if (historyRef.current == null) historyRef.current = (0, $bnQ5y.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8T3gX.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8T3gX.useCallback((newState)=>{
        v7_startTransition && $2d4d8a77428439fe$var$startTransitionImpl ? $2d4d8a77428439fe$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8T3gX.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8T3gX.useEffect(()=>$2d4d8a77428439fe$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $2d4d8a77428439fe$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$2d4d8a77428439fe$export$9c954a9d03d32f4a() && (0, $bnQ5y.UNSAFE_invariant)(false, // the router loaded. We can help them understand how to avoid that.
    "<Navigate> may be used only in the context of a <Router> component.");
    let { future: future, static: isStatic } = $8T3gX.useContext($2d4d8a77428439fe$export$26749e8557646306);
    (0, $bnQ5y.UNSAFE_warning)(!isStatic, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    let { matches: matches } = $8T3gX.useContext($2d4d8a77428439fe$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $2d4d8a77428439fe$export$45d76561a5302f2b();
    let navigate = $2d4d8a77428439fe$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $bnQ5y.resolveTo)(to, (0, $bnQ5y.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $8T3gX.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $2d4d8a77428439fe$export$910ae8079b2c2852(props) {
    return $2d4d8a77428439fe$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $2d4d8a77428439fe$export$e7b0ac011bb776c6(_props) {
    (0, $bnQ5y.UNSAFE_invariant)(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $2d4d8a77428439fe$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $bnQ5y.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$2d4d8a77428439fe$export$9c954a9d03d32f4a() && (0, $bnQ5y.UNSAFE_invariant)(false, "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $8T3gX.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $2d4d8a77428439fe$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $bnQ5y.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $8T3gX.useMemo(()=>{
        let trailingPathname = (0, $bnQ5y.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    (0, $bnQ5y.UNSAFE_warning)(locationContext != null, "<Router basename=\"" + basename + "\"> is not able to match the URL " + ("\"" + pathname + search + hash + "\" because it does not start with the ") + "basename, so the <Router> won't render anything.");
    if (locationContext == null) return null;
    return /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $2d4d8a77428439fe$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $2d4d8a77428439fe$export$5d3fca4a98652595($2d4d8a77428439fe$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $2d4d8a77428439fe$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$ResolveAwait, null, children));
}
var $2d4d8a77428439fe$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($2d4d8a77428439fe$var$AwaitRenderStatus || {});
const $2d4d8a77428439fe$var$neverSettledPromise = new Promise(()=>{});
class $2d4d8a77428439fe$var$AwaitErrorBoundary extends $8T3gX.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $2d4d8a77428439fe$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $2d4d8a77428439fe$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $2d4d8a77428439fe$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $2d4d8a77428439fe$var$AwaitRenderStatus.error : "_data" in promise ? $2d4d8a77428439fe$var$AwaitRenderStatus.success : $2d4d8a77428439fe$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $2d4d8a77428439fe$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $2d4d8a77428439fe$var$AwaitRenderStatus.error && promise._error instanceof (0, $bnQ5y.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $2d4d8a77428439fe$var$neverSettledPromise;
        if (status === $2d4d8a77428439fe$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $2d4d8a77428439fe$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $2d4d8a77428439fe$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $8T3gX.createElement($2d4d8a77428439fe$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $2d4d8a77428439fe$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $2d4d8a77428439fe$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $8T3gX.createElement($8T3gX.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $2d4d8a77428439fe$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $8T3gX.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $8T3gX.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $8T3gX.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $2d4d8a77428439fe$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $2d4d8a77428439fe$export$e7b0ac011bb776c6) && (0, $bnQ5y.UNSAFE_invariant)(false, "[" + (typeof element.type === "string" ? element.type : element.type.name) + "] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>");
        !(!element.props.index || !element.props.children) && (0, $bnQ5y.UNSAFE_invariant)(false, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $2d4d8a77428439fe$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $2d4d8a77428439fe$export$daf73786167a7f72(matches) {
    return $2d4d8a77428439fe$var$_renderMatches(matches);
}
function $2d4d8a77428439fe$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if (route.element) (0, $bnQ5y.UNSAFE_warning)(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        Object.assign(updates, {
            element: /*#__PURE__*/ $8T3gX.createElement(route.Component),
            Component: undefined
        });
    }
    if (route.HydrateFallback) {
        if (route.hydrateFallbackElement) (0, $bnQ5y.UNSAFE_warning)(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        Object.assign(updates, {
            hydrateFallbackElement: /*#__PURE__*/ $8T3gX.createElement(route.HydrateFallback),
            HydrateFallback: undefined
        });
    }
    if (route.ErrorBoundary) {
        if (route.errorElement) (0, $bnQ5y.UNSAFE_warning)(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        Object.assign(updates, {
            errorElement: /*#__PURE__*/ $8T3gX.createElement(route.ErrorBoundary),
            ErrorBoundary: undefined
        });
    }
    return updates;
}
function $2d4d8a77428439fe$export$f30f7e456d254e83(routes, opts) {
    return (0, $bnQ5y.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $2d4d8a77428439fe$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $bnQ5y.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $2d4d8a77428439fe$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});


parcelRegister("90baQ", function(module, exports) {
module.exports = import.meta.resolve("6V8mu");

});

parcelRegister("9tlSj", function(module, exports) {
module.exports = import.meta.resolve("iRP1W");

});

parcelRegister("gDSfc", function(module, exports) {

$parcel$export(module.exports, "UserLink", () => $3a54eddbeec6c1e1$export$3190eb749eccd0ee);

var $k4ank = parcelRequire("k4ank");

var $axLMO = parcelRequire("axLMO");

var $crpct = parcelRequire("crpct");

var $cVCJe = parcelRequire("cVCJe");
const $3a54eddbeec6c1e1$export$3190eb749eccd0ee = (props)=>{
    const userName = localStorage.username;
    const firstName = localStorage.first_name;
    const lastName = localStorage.last_name;
    const fullName = `${firstName} ${lastName}`;
    let userLink;
    let displayName;
    if (firstName && lastName) displayName = `${firstName} ${lastName}`;
    else if (userName) displayName = userName;
    else displayName = "User";
    const { height: height } = (0, $crpct.default)();
    if (displayName.length < 13) userLink = /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
        className: height > 630 ? "absolute bottom-[35px] text-white text-[14.5px] font-mulish indent-3 font-normal" : "absolute top-[569px] text-white text-[14.5px] font-mulish indent-3 font-normal",
        children: [
            " ",
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                ...props,
                children: /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                    fill: "currentColor",
                    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88a9.947 9.947 0 0 1 12.28 0C16.43 19.18 14.03 20 12 20z"
                })
            }),
            "\xa0",
            displayName
        ]
    });
    else userLink = /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
        className: height > 630 ? "absolute bottom-[35px] text-white text-[14.5px] font-mulish indent-3 font-normal" : "absolute top-[569px] text-white text-[14.5px] font-mulish indent-3 font-normal",
        children: [
            " ",
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                ...props,
                children: /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                    fill: "currentColor",
                    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88a9.947 9.947 0 0 1 12.28 0C16.43 19.18 14.03 20 12 20z"
                })
            }),
            "\xa0",
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                title: displayName,
                placement: "right",
                children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                    children: `${displayName.slice(0, 11)}...`
                })
            })
        ]
    });
    return userLink;
};

});
parcelRegister("crpct", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3959d766491db47$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");
function $e3959d766491db47$var$getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width: width,
        height: height
    };
}
function $e3959d766491db47$export$2e2bcd8739ae039() {
    const [windowDimensions, setWindowDimensions] = (0, $8T3gX.useState)($e3959d766491db47$var$getWindowDimensions());
    (0, $8T3gX.useEffect)(()=>{
        function handleResize() {
            setWindowDimensions($e3959d766491db47$var$getWindowDimensions());
        }
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    return windowDimensions;
}

});


parcelRegister("3qyII", function(module, exports) {

$parcel$export(module.exports, "handleLocalStorageChangesOnNavBarClick", () => $db6e4c69b193ea88$export$1493354d29372237);
const $db6e4c69b193ea88$export$1493354d29372237 = ()=>{
    localStorage.setItem("currentSiteBreadcrumbs", JSON.stringify([]));
};

});

parcelRegister("g0plP", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba704fa0ed863fe8$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $ba704fa0ed863fe8$var$_default = module.exports.default = (0, $ba704fa0ed863fe8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z"
}), 'KeyboardArrowUp');

});

parcelRegister("e9rQm", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a4d7811e63312738$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $a4d7811e63312738$var$_default = module.exports.default = (0, $a4d7811e63312738$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"
}), 'KeyboardArrowDown');

});

parcelRegister("9BLod", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6fec5455e8bfaa2a$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $6fec5455e8bfaa2a$var$_default = module.exports.default = (0, $6fec5455e8bfaa2a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M3 18h13v-2H3zm0-5h10v-2H3zm0-7v2h13V6zm18 9.59L17.42 12 21 8.41 19.59 7l-5 5 5 5z"
}), 'MenuOpenOutlined');

});

parcelRegister("iCVw8", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d8f864529c19f1f8$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $d8f864529c19f1f8$var$_default = module.exports.default = (0, $d8f864529c19f1f8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M14 2H6.01c-1.1 0-2 .89-2 2L4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8zm-1 7V3.5L18.5 9zm1 5 2-1.06v4.12L14 16v1c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h4c.55 0 1 .45 1 1z"
}), 'VideoFile');

});

parcelRegister("5PzPz", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $43ed826cbc65ebc2$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $43ed826cbc65ebc2$var$_default = module.exports.default = (0, $43ed826cbc65ebc2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z"
}), 'MenuOutlined');

});

parcelRegister("fzSk5", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b574434e11098fdb$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $b574434e11098fdb$var$_default = module.exports.default = (0, $b574434e11098fdb$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M19.88 18.47c.44-.7.7-1.51.7-2.39 0-2.49-2.01-4.5-4.5-4.5s-4.5 2.01-4.5 4.5 2.01 4.5 4.49 4.5c.88 0 1.7-.26 2.39-.7L21.58 23 23 21.58zm-3.8.11c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5m-.36-8.5c-.74.02-1.45.18-2.1.45l-.55-.83-3.8 6.18-3.01-3.52-3.63 5.81L1 17l5-8 3 3.5L13 6zm2.59.5c-.64-.28-1.33-.45-2.05-.49L21.38 2 23 3.18z"
}), 'QueryStats');

});

parcelRegister("gouAT", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bef69e8fff286764$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $bef69e8fff286764$var$_default = module.exports.default = (0, $bef69e8fff286764$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-2h2zm0-4h-2V7h2z"
}), 'Error');

});

parcelRegister("hXXs8", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d146107316f9d8a8$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $d146107316f9d8a8$var$_default = module.exports.default = (0, $d146107316f9d8a8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M11 18h2v-2h-2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4"
}), 'HelpOutline');

});

parcelRegister("aYwkU", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7fd897498201589f$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $7fd897498201589f$var$_default = module.exports.default = (0, $7fd897498201589f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M22 4v-.5C22 2.12 20.88 1 19.5 1S17 2.12 17 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1m-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7zm-2.28 8c.04.33.08.66.08 1 0 2.08-.8 3.97-2.1 5.39-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H7v-2h2c.55 0 1-.45 1-1V8h2c1.1 0 2-.9 2-2V3.46c-.95-.3-1.95-.46-3-.46C5.48 3 1 7.48 1 13s4.48 10 10 10 10-4.48 10-10c0-.34-.02-.67-.05-1zM10 20.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L8 16v1c0 1.1.9 2 2 2z"
}), 'VpnLock');

});

parcelRegister("4kUZY", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32853e672a3411e4$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $32853e672a3411e4$var$_default = module.exports.default = (0, $32853e672a3411e4$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "m20.41 8.41-4.83-4.83c-.37-.37-.88-.58-1.41-.58H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9.83c0-.53-.21-1.04-.59-1.42M7 7h7v2H7zm10 10H7v-2h10zm0-4H7v-2h10z"
}), 'TextSnippet');

});

parcelRegister("8utdm", function(module, exports) {

$parcel$export(module.exports, "showReleaseNotesBanner", () => $0f2db522f3d8c92f$export$1559e9f8f180934c);
$parcel$export(module.exports, "ReleaseNotesBanner", () => $0f2db522f3d8c92f$export$e27c2129bb5d7061);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");
const $0f2db522f3d8c92f$export$1559e9f8f180934c = ()=>{
    rnw("show");
};
const $0f2db522f3d8c92f$export$e27c2129bb5d7061 = ()=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)("rn-banner", {
        type: "feature",
        "background-color": "#1F72E3",
        "button-text": "Learn More",
        "border-radius": "0",
        "font-family": "Mulish",
        margin: "0",
        prefix: "Latest Release",
        "prefix-background-color": "#FF8400",
        shadow: "none"
    });
};

});

parcelRegister("b1uoD", function(module, exports) {

$parcel$export(module.exports, "getSupportBaseUrl", () => $f23a96be45fc2970$export$61d78cf54c5cd115);
$parcel$export(module.exports, "getSupportUrl", () => $f23a96be45fc2970$export$97e087f2d305db71);
// The support wiki is deployed per region: EU customers authenticate against
// the EU Cognito pool, which only the EU wiki accepts (ENG-356/ENG-366).
const $f23a96be45fc2970$export$61d78cf54c5cd115 = ()=>window.location.hostname.includes("actuateui.eu") ? "https://support.actuateui.eu" : "https://support.actuateui.net";
const $f23a96be45fc2970$export$97e087f2d305db71 = (path = "")=>`${$f23a96be45fc2970$export$61d78cf54c5cd115()}${path}`;

});

parcelRegister("ctA22", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $915424a1b8e5a165$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $915424a1b8e5a165$var$_default = module.exports.default = (0, $915424a1b8e5a165$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M12 3C6.95 3 3.15 4.85 0 7.23L12 22 24 7.25C20.85 4.87 17.05 3 12 3m1 13h-2v-6h2zm-2-8V6h2v2z"
}), 'PermScanWifi');

});

parcelRegister("aTISx", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ef1da6330446a15$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $7ef1da6330446a15$var$_default = module.exports.default = (0, $7ef1da6330446a15$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M18 10.48V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4.48l4 3.98v-11zM10 8c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m4 8H6v-.57c0-.81.48-1.53 1.22-1.85.85-.37 1.79-.58 2.78-.58.99 0 1.93.21 2.78.58.74.32 1.22 1.04 1.22 1.85z"
}), 'VideoCameraFront');

});

parcelRegister("ckl92", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8f97c139bad57066$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $8f97c139bad57066$var$_default = module.exports.default = (0, $8f97c139bad57066$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9m-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8z"
}), 'History');

});

parcelRegister("4PFLW", function(module, exports) {

$parcel$export(module.exports, "useFeatureFlag", () => $e8468d6c4c6eea02$export$61acb772777ef35d);

var $9mVTu = parcelRequire("9mVTu");

var $ebTQj = parcelRequire("ebTQj");
const $e8468d6c4c6eea02$export$61acb772777ef35d = ()=>{
    // Get all flags
    const flags = (0, $9mVTu.useFlags)();
    // Get the LaunchDarkly client
    const ldClient = (0, $9mVTu.useLDClient)();
    /**
   * Check if a feature flag is enabled
   * @param flagKey - The key of the feature flag
   * @param defaultValue - Default value if flag is not found
   */ const isFeatureEnabled = (flagKey, defaultValue = false)=>{
        // If the flag exists, return its value, otherwise return the default value
        return typeof flags[flagKey] === "boolean" ? flags[flagKey] : defaultValue;
    };
    /**
   * Get the variation of a feature flag
   * @param flagKey - The key of the feature flag
   * @param defaultValue - Default value if flag is not found
   */ const getFeatureVariation = (flagKey, defaultValue)=>{
        return flags[flagKey] !== undefined ? flags[flagKey] : defaultValue;
    };
    /**
   * Update the user context for LaunchDarkly
   * @param user - The user object to set
   */ const updateUserContext = async (user)=>{
        if (ldClient) try {
            await ldClient.identify(user);
            return true;
        } catch (error) {
            (0, $ebTQj.logger).error("Error updating LaunchDarkly user context:", error);
            return false;
        }
        return false;
    };
    return {
        flags: flags,
        isFeatureEnabled: isFeatureEnabled,
        getFeatureVariation: getFeatureVariation,
        updateUserContext: updateUserContext,
        ldClient: ldClient
    };
};

});
parcelRegister("9mVTu", function(module, exports) {
"use strict";

var $8T3gX = parcelRequire("8T3gX");

var $eLJ04 = parcelRequire("eLJ04");

var $j7JJt = parcelRequire("j7JJt");

var $2k72C = parcelRequire("2k72C");
function $6d2313b071907948$var$o(e) {
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function(r) {
        if ("default" !== r) {
            var n = Object.getOwnPropertyDescriptor(e, r);
            Object.defineProperty(t, r, n.get ? n : {
                enumerable: !0,
                get: function() {
                    return e[r];
                }
            });
        }
    }), t.default = e, Object.freeze(t);
}
var $6d2313b071907948$var$s = $6d2313b071907948$var$o($8T3gX);
const $6d2313b071907948$var$i = ()=>$8T3gX.createContext({
        flags: {},
        flagKeyMap: {},
        ldClient: void 0
    }), $6d2313b071907948$var$a = $6d2313b071907948$var$i(), { Provider: $6d2313b071907948$var$l, Consumer: $6d2313b071907948$var$c } = $6d2313b071907948$var$a, $6d2313b071907948$var$u = {
    useCamelCaseFlagKeys: !0,
    sendEventsOnFlagRead: !0,
    reactContext: $6d2313b071907948$var$a
}, $6d2313b071907948$var$p = (e)=>{
    var t;
    return null != (t = e.context) ? t : e.user;
}, $6d2313b071907948$var$f = (e)=>{
    const t = {};
    for(const n in e)0 !== n.indexOf("$") && (t[$j7JJt(n)] = e[n]);
    return t;
}, $6d2313b071907948$var$d = (e, t)=>{
    const r = {};
    for(const n in e)t && void 0 === t[n] || (r[n] = e[n].current);
    return r;
}, $6d2313b071907948$var$y = (e, t)=>{
    const r = e.allFlags();
    return t ? Object.keys(t).reduce((e, n)=>(e[n] = Object.prototype.hasOwnProperty.call(r, n) ? r[n] : t[n], e), {}) : r;
};
function $6d2313b071907948$var$h(e, t, n = $6d2313b071907948$var$u, o) {
    const s = function(e, t) {
        if (void 0 === t) return e;
        return Object.keys(t).reduce((t, r)=>($6d2313b071907948$var$O(e, r) && (t[r] = e[r]), t), {});
    }(t, o), { useCamelCaseFlagKeys: i = !0 } = n, [a, l = {}] = i ? function(e) {
        const t = {}, n = {};
        for(const o in e){
            if (0 === o.indexOf("$")) continue;
            const s = $j7JJt(o);
            t[s] = e[o], n[s] = o;
        }
        return [
            t,
            n
        ];
    }(s) : [
        s
    ];
    return {
        flags: n.sendEventsOnFlagRead ? $6d2313b071907948$var$g(e, a, l, i) : a,
        flagKeyMap: l
    };
}
function $6d2313b071907948$var$O(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
}
function $6d2313b071907948$var$g(e, t, r, n) {
    return new Proxy(t, {
        get (t, o, s) {
            const i = Reflect.get(t, o, s), a = n && $6d2313b071907948$var$O(r, o) || $6d2313b071907948$var$O(t, o);
            if ("symbol" == typeof o || !a) return i;
            if (void 0 === i) return;
            const l = n ? r[o] : o;
            return e.variation(l, i);
        }
    });
}
$6d2313b071907948$var$f.camelCaseKeys = $6d2313b071907948$var$f;
const $6d2313b071907948$var$b = {
    wrapperName: "react-client-sdk",
    wrapperVersion: "3.9.0",
    sendEventsOnlyForVariation: !0
};
var $6d2313b071907948$var$v = Object.defineProperty, $6d2313b071907948$var$x = Object.defineProperties, $6d2313b071907948$var$m = Object.getOwnPropertyDescriptors, $6d2313b071907948$var$C = Object.getOwnPropertySymbols, $6d2313b071907948$var$j = Object.prototype.hasOwnProperty, $6d2313b071907948$var$P = Object.prototype.propertyIsEnumerable, $6d2313b071907948$var$w = (e, t, r)=>t in e ? $6d2313b071907948$var$v(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r, $6d2313b071907948$var$F = (e, t)=>{
    for(var r in t || (t = {}))$6d2313b071907948$var$j.call(t, r) && $6d2313b071907948$var$w(e, r, t[r]);
    if ($6d2313b071907948$var$C) for (var r of $6d2313b071907948$var$C(t))$6d2313b071907948$var$P.call(t, r) && $6d2313b071907948$var$w(e, r, t[r]);
    return e;
}, $6d2313b071907948$var$E = (e, t)=>$6d2313b071907948$var$x(e, $6d2313b071907948$var$m(t)), $6d2313b071907948$var$D = (e, t, r)=>new Promise((n, o)=>{
        var s = (e)=>{
            try {
                a(r.next(e));
            } catch (e) {
                o(e);
            }
        }, i = (e)=>{
            try {
                a(r.throw(e));
            } catch (e) {
                o(e);
            }
        }, a = (e)=>e.done ? n(e.value) : Promise.resolve(e.value).then(s, i);
        a((r = r.apply(e, t)).next());
    });
class $6d2313b071907948$var$S extends $8T3gX.Component {
    constructor(e){
        super(e), this.getReactOptions = ()=>$6d2313b071907948$var$F($6d2313b071907948$var$F({}, $6d2313b071907948$var$u), this.props.reactOptions), this.subscribeToChanges = (e)=>{
            const { flags: t } = this.props;
            e.on("change", (r)=>{
                const n = this.getReactOptions(), o = $6d2313b071907948$var$d(r, t);
                Object.keys(o).length > 0 && this.setState((r)=>{
                    const s = $6d2313b071907948$var$F($6d2313b071907948$var$F({}, r.unproxiedFlags), o);
                    return $6d2313b071907948$var$F($6d2313b071907948$var$E($6d2313b071907948$var$F({}, r), {
                        unproxiedFlags: s
                    }), $6d2313b071907948$var$h(e, s, n, t));
                });
            });
        }, this.onFailed = (e, t)=>{
            this.setState((e)=>$6d2313b071907948$var$E($6d2313b071907948$var$F({}, e), {
                    error: t
                }));
        }, this.onReady = (e, t, r)=>{
            const n = $6d2313b071907948$var$y(e, r);
            this.setState((o)=>$6d2313b071907948$var$F($6d2313b071907948$var$E($6d2313b071907948$var$F({}, o), {
                    unproxiedFlags: n
                }), $6d2313b071907948$var$h(e, n, t, r)));
        }, this.prepareLDClient = ()=>$6d2313b071907948$var$D(this, null, function*() {
                var e;
                const { clientSideID: r, flags: n, options: o } = this.props;
                let s = yield this.props.ldClient;
                const i = this.getReactOptions();
                let a, l = this.state.unproxiedFlags;
                if (s) l = $6d2313b071907948$var$y(s, n);
                else {
                    const c = null != (e = $6d2313b071907948$var$p(this.props)) ? e : {
                        anonymous: !0,
                        kind: "user"
                    };
                    s = $eLJ04.initialize(r, c, $6d2313b071907948$var$F($6d2313b071907948$var$F({}, $6d2313b071907948$var$b), o));
                    try {
                        yield s.waitForInitialization(this.props.timeout), l = $6d2313b071907948$var$y(s, n);
                    } catch (e) {
                        a = e, (null == a ? void 0 : a.name.toLowerCase().includes("timeout")) && (s.on("failed", this.onFailed), s.on("ready", ()=>{
                            this.onReady(s, i, n);
                        }));
                    }
                }
                this.setState((e)=>$6d2313b071907948$var$E($6d2313b071907948$var$F($6d2313b071907948$var$E($6d2313b071907948$var$F({}, e), {
                        unproxiedFlags: l
                    }), $6d2313b071907948$var$h(s, l, i, n)), {
                        ldClient: s,
                        error: a
                    })), this.subscribeToChanges(s);
            });
        const { options: r } = e;
        if (this.state = {
            flags: {},
            unproxiedFlags: {},
            flagKeyMap: {}
        }, r) {
            const { bootstrap: e } = r;
            if (e && "localStorage" !== e) {
                const { useCamelCaseFlagKeys: t } = this.getReactOptions();
                this.state = {
                    flags: t ? $6d2313b071907948$var$f(e) : e,
                    unproxiedFlags: e,
                    flagKeyMap: {}
                };
            }
        }
    }
    componentDidMount() {
        return $6d2313b071907948$var$D(this, null, function*() {
            const { deferInitialization: e } = this.props;
            e && !$6d2313b071907948$var$p(this.props) || (yield this.prepareLDClient());
        });
    }
    componentDidUpdate(e) {
        return $6d2313b071907948$var$D(this, null, function*() {
            const { deferInitialization: t } = this.props, r = !$6d2313b071907948$var$p(e) && $6d2313b071907948$var$p(this.props);
            t && r && (yield this.prepareLDClient());
        });
    }
    render() {
        const { flags: t, flagKeyMap: r, ldClient: n, error: o } = this.state, { reactContext: s } = this.getReactOptions();
        return $8T3gX.createElement(s.Provider, {
            value: {
                flags: t,
                flagKeyMap: r,
                ldClient: n,
                error: o
            }
        }, this.props.children);
    }
}
var $6d2313b071907948$var$k = Object.defineProperty, $6d2313b071907948$var$K = Object.defineProperties, $6d2313b071907948$var$L = Object.getOwnPropertyDescriptors, $6d2313b071907948$var$R = Object.getOwnPropertySymbols, $6d2313b071907948$var$I = Object.prototype.hasOwnProperty, $6d2313b071907948$var$z = Object.prototype.propertyIsEnumerable, $6d2313b071907948$var$M = (e, t, r)=>t in e ? $6d2313b071907948$var$k(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r, $6d2313b071907948$var$q = (e, t)=>{
    for(var r in t || (t = {}))$6d2313b071907948$var$I.call(t, r) && $6d2313b071907948$var$M(e, r, t[r]);
    if ($6d2313b071907948$var$R) for (var r of $6d2313b071907948$var$R(t))$6d2313b071907948$var$z.call(t, r) && $6d2313b071907948$var$M(e, r, t[r]);
    return e;
};
var $6d2313b071907948$var$T = Object.defineProperty, $6d2313b071907948$var$V = Object.defineProperties, $6d2313b071907948$var$$ = Object.getOwnPropertyDescriptors, $6d2313b071907948$var$N = Object.getOwnPropertySymbols, $6d2313b071907948$var$U = Object.prototype.hasOwnProperty, $6d2313b071907948$var$W = Object.prototype.propertyIsEnumerable, $6d2313b071907948$var$A = (e, t, r)=>t in e ? $6d2313b071907948$var$T(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r, $6d2313b071907948$var$B = (e, t)=>{
    for(var r in t || (t = {}))$6d2313b071907948$var$U.call(t, r) && $6d2313b071907948$var$A(e, r, t[r]);
    if ($6d2313b071907948$var$N) for (var r of $6d2313b071907948$var$N(t))$6d2313b071907948$var$W.call(t, r) && $6d2313b071907948$var$A(e, r, t[r]);
    return e;
}, $6d2313b071907948$var$G = (e, t)=>$6d2313b071907948$var$V(e, $6d2313b071907948$var$$(t));
var $6d2313b071907948$var$H = Object.defineProperty, $6d2313b071907948$var$J = Object.getOwnPropertySymbols, $6d2313b071907948$var$Q = Object.prototype.hasOwnProperty, $6d2313b071907948$var$X = Object.prototype.propertyIsEnumerable, $6d2313b071907948$var$Y = (e, t, r)=>t in e ? $6d2313b071907948$var$H(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r, $6d2313b071907948$var$Z = (e, t)=>{
    for(var r in t || (t = {}))$6d2313b071907948$var$Q.call(t, r) && $6d2313b071907948$var$Y(e, r, t[r]);
    if ($6d2313b071907948$var$J) for (var r of $6d2313b071907948$var$J(t))$6d2313b071907948$var$X.call(t, r) && $6d2313b071907948$var$Y(e, r, t[r]);
    return e;
};
module.exports.LDProvider = $6d2313b071907948$var$S, module.exports.asyncWithLDProvider = function(r) {
    var n, o, s;
    return n = this, o = null, s = function*() {
        var n, o;
        const { clientSideID: s, flags: i, options: a, reactOptions: l } = r, c = $6d2313b071907948$var$B($6d2313b071907948$var$B({}, $6d2313b071907948$var$u), l), f = null != (n = $6d2313b071907948$var$p(r)) ? n : {
            anonymous: !0,
            kind: "user"
        };
        let O, g = {};
        const v = null != (o = yield r.ldClient) ? o : $eLJ04.initialize(s, f, $6d2313b071907948$var$B($6d2313b071907948$var$B({}, $6d2313b071907948$var$b), a));
        try {
            yield v.waitForInitialization(r.timeout), g = $6d2313b071907948$var$y(v, i);
        } catch (e) {
            O = e;
        }
        const x = (null == a ? void 0 : a.bootstrap) && "localStorage" !== a.bootstrap ? a.bootstrap : g;
        return ({ children: t })=>{
            const [r, n] = $8T3gX.useState(()=>$6d2313b071907948$var$G($6d2313b071907948$var$B({
                    unproxiedFlags: x
                }, $6d2313b071907948$var$h(v, x, c, i)), {
                    ldClient: v,
                    error: O
                }));
            $8T3gX.useEffect(()=>{
                function e(e) {
                    const t = $6d2313b071907948$var$d(e, i);
                    Object.keys(t).length > 0 && n((e)=>{
                        const r = $6d2313b071907948$var$B($6d2313b071907948$var$B({}, e.unproxiedFlags), t);
                        return $6d2313b071907948$var$B($6d2313b071907948$var$G($6d2313b071907948$var$B({}, e), {
                            unproxiedFlags: r
                        }), $6d2313b071907948$var$h(v, r, c, i));
                    });
                }
                function t() {
                    const e = $6d2313b071907948$var$y(v, i);
                    n((t)=>$6d2313b071907948$var$B($6d2313b071907948$var$G($6d2313b071907948$var$B({}, t), {
                            unproxiedFlags: e
                        }), $6d2313b071907948$var$h(v, e, c, i)));
                }
                function r(e) {
                    n((t)=>$6d2313b071907948$var$G($6d2313b071907948$var$B({}, t), {
                            error: e
                        }));
                }
                return v.on("change", e), (null == O ? void 0 : O.name.toLowerCase().includes("timeout")) && (v.on("failed", r), v.on("ready", t)), function() {
                    v.off("change", e), v.off("failed", r), v.off("ready", t);
                };
            }, []);
            const o = r, { unproxiedFlags: s } = o, a = ((e, t)=>{
                var r = {};
                for(var n in e)$6d2313b071907948$var$U.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
                if (null != e && $6d2313b071907948$var$N) for (var n of $6d2313b071907948$var$N(e))t.indexOf(n) < 0 && $6d2313b071907948$var$W.call(e, n) && (r[n] = e[n]);
                return r;
            })(o, [
                "unproxiedFlags"
            ]), { reactContext: l } = c;
            return $8T3gX.createElement(l.Provider, {
                value: a
            }, t);
        };
    }, new Promise((e, t)=>{
        var r = (e)=>{
            try {
                a(s.next(e));
            } catch (e) {
                t(e);
            }
        }, i = (e)=>{
            try {
                a(s.throw(e));
            } catch (e) {
                t(e);
            }
        }, a = (t)=>t.done ? e(t.value) : Promise.resolve(t.value).then(r, i);
        a((s = s.apply(n, o)).next());
    });
}, module.exports.camelCaseKeys = $6d2313b071907948$var$f, module.exports.defaultReactOptions = $6d2313b071907948$var$u, module.exports.reactSdkContextFactory = $6d2313b071907948$var$i, module.exports.useFlags = (t)=>{
    const { flags: r } = $8T3gX.useContext(null != t ? t : $6d2313b071907948$var$u.reactContext);
    return r;
}, module.exports.useLDClient = (t)=>{
    const { ldClient: r } = $8T3gX.useContext(null != t ? t : $6d2313b071907948$var$u.reactContext);
    return r;
}, module.exports.useLDClientError = function(t) {
    const { error: r } = $8T3gX.useContext(null != t ? t : $6d2313b071907948$var$u.reactContext);
    return r;
}, module.exports.withLDConsumer = function(e = {
    clientOnly: !1
}) {
    return function(t) {
        var r;
        const n = null != (r = e.reactContext) ? r : $6d2313b071907948$var$u.reactContext;
        return (r)=>$6d2313b071907948$var$s.createElement(n.Consumer, null, ({ flags: n, ldClient: o })=>e.clientOnly ? $6d2313b071907948$var$s.createElement(t, $6d2313b071907948$var$Z({
                    ldClient: o
                }, r)) : $6d2313b071907948$var$s.createElement(t, $6d2313b071907948$var$Z({
                    flags: n,
                    ldClient: o
                }, r)));
    };
}, module.exports.withLDProvider = function(e) {
    return function(t) {
        const { reactOptions: r } = e, o = $6d2313b071907948$var$q($6d2313b071907948$var$q({}, $6d2313b071907948$var$u), r), i = (a = $6d2313b071907948$var$q({}, e), $6d2313b071907948$var$K(a, $6d2313b071907948$var$L({
            reactOptions: o
        })));
        var a;
        function l(e) {
            return $6d2313b071907948$var$s.createElement($6d2313b071907948$var$S, $6d2313b071907948$var$q({}, i), $6d2313b071907948$var$s.createElement(t, $6d2313b071907948$var$q({}, e)));
        }
        return $2k72C(l, t), l;
    };
}, Object.keys($eLJ04).forEach(function(e) {
    "default" === e || Object.prototype.hasOwnProperty.call(module.exports, e) || Object.defineProperty(module.exports, e, {
        enumerable: !0,
        get: function() {
            return $eLJ04[e];
        }
    });
});

});
parcelRegister("eLJ04", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "initialize", () => $ac085c90a16a552d$export$2a47f398eeff8b01);
$parcel$export(module.exports, "basicLogger", () => $ac085c90a16a552d$export$b66aba0a73c7dec6);
$parcel$export(module.exports, "createConsoleLogger", () => $ac085c90a16a552d$export$297abbbd7d012370);
$parcel$export(module.exports, "version", () => $ac085c90a16a552d$export$83d89fbfd8236492);
$parcel$export(module.exports, "default", () => $ac085c90a16a552d$export$2e2bcd8739ae039);
function $ac085c90a16a552d$var$e(e) {
    function t(e, t) {
        Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.message = e, this.code = t;
    }
    return t.prototype = new Error, t.prototype.name = e, t.prototype.constructor = t, t;
}
const $ac085c90a16a552d$var$t = $ac085c90a16a552d$var$e("LaunchDarklyUnexpectedResponseError"), $ac085c90a16a552d$var$n = $ac085c90a16a552d$var$e("LaunchDarklyInvalidEnvironmentIdError"), $ac085c90a16a552d$var$r = $ac085c90a16a552d$var$e("LaunchDarklyInvalidUserError"), $ac085c90a16a552d$var$o = $ac085c90a16a552d$var$e("LaunchDarklyInvalidEventKeyError"), $ac085c90a16a552d$var$i = $ac085c90a16a552d$var$e("LaunchDarklyInvalidArgumentError"), $ac085c90a16a552d$var$a = $ac085c90a16a552d$var$e("LaunchDarklyFlagFetchError");
for(var $ac085c90a16a552d$var$s = {
    LDUnexpectedResponseError: $ac085c90a16a552d$var$t,
    LDInvalidEnvironmentIdError: $ac085c90a16a552d$var$n,
    LDInvalidUserError: $ac085c90a16a552d$var$r,
    LDInvalidEventKeyError: $ac085c90a16a552d$var$o,
    LDInvalidArgumentError: $ac085c90a16a552d$var$i,
    LDInvalidDataError: $ac085c90a16a552d$var$e("LaunchDarklyInvalidDataError"),
    LDFlagFetchError: $ac085c90a16a552d$var$a,
    LDTimeoutError: $ac085c90a16a552d$var$e("LaunchDarklyTimeoutError"),
    isHttpErrorRecoverable: function(e) {
        return !(e >= 400 && e < 500) || 400 === e || 408 === e || 429 === e;
    }
}, $ac085c90a16a552d$var$c = function(e) {
    var t = $ac085c90a16a552d$var$m(e), n = t[0], r = t[1];
    return 3 * (n + r) / 4 - r;
}, $ac085c90a16a552d$var$u = function(e) {
    var t, n, r = $ac085c90a16a552d$var$m(e), o = r[0], i = r[1], a = new $ac085c90a16a552d$var$g(function(e, t, n) {
        return 3 * (t + n) / 4 - n;
    }(0, o, i)), s = 0, c = i > 0 ? o - 4 : o;
    for(n = 0; n < c; n += 4)t = $ac085c90a16a552d$var$f[e.charCodeAt(n)] << 18 | $ac085c90a16a552d$var$f[e.charCodeAt(n + 1)] << 12 | $ac085c90a16a552d$var$f[e.charCodeAt(n + 2)] << 6 | $ac085c90a16a552d$var$f[e.charCodeAt(n + 3)], a[s++] = t >> 16 & 255, a[s++] = t >> 8 & 255, a[s++] = 255 & t;
    2 === i && (t = $ac085c90a16a552d$var$f[e.charCodeAt(n)] << 2 | $ac085c90a16a552d$var$f[e.charCodeAt(n + 1)] >> 4, a[s++] = 255 & t);
    1 === i && (t = $ac085c90a16a552d$var$f[e.charCodeAt(n)] << 10 | $ac085c90a16a552d$var$f[e.charCodeAt(n + 1)] << 4 | $ac085c90a16a552d$var$f[e.charCodeAt(n + 2)] >> 2, a[s++] = t >> 8 & 255, a[s++] = 255 & t);
    return a;
}, $ac085c90a16a552d$var$l = function(e) {
    for(var t, n = e.length, r = n % 3, o = [], i = 16383, a = 0, s = n - r; a < s; a += i)o.push($ac085c90a16a552d$var$y(e, a, a + i > s ? s : a + i));
    1 === r ? (t = e[n - 1], o.push($ac085c90a16a552d$var$d[t >> 2] + $ac085c90a16a552d$var$d[t << 4 & 63] + "==")) : 2 === r && (t = (e[n - 2] << 8) + e[n - 1], o.push($ac085c90a16a552d$var$d[t >> 10] + $ac085c90a16a552d$var$d[t >> 4 & 63] + $ac085c90a16a552d$var$d[t << 2 & 63] + "="));
    return o.join("");
}, $ac085c90a16a552d$var$d = [], $ac085c90a16a552d$var$f = [], $ac085c90a16a552d$var$g = "undefined" != typeof Uint8Array ? Uint8Array : Array, $ac085c90a16a552d$var$v = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", $ac085c90a16a552d$var$p = 0; $ac085c90a16a552d$var$p < 64; ++$ac085c90a16a552d$var$p)$ac085c90a16a552d$var$d[$ac085c90a16a552d$var$p] = $ac085c90a16a552d$var$v[$ac085c90a16a552d$var$p], $ac085c90a16a552d$var$f[$ac085c90a16a552d$var$v.charCodeAt($ac085c90a16a552d$var$p)] = $ac085c90a16a552d$var$p;
function $ac085c90a16a552d$var$m(e) {
    var t = e.length;
    if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    var n = e.indexOf("=");
    return -1 === n && (n = t), [
        n,
        n === t ? 0 : 4 - n % 4
    ];
}
function $ac085c90a16a552d$var$h(e) {
    return $ac085c90a16a552d$var$d[e >> 18 & 63] + $ac085c90a16a552d$var$d[e >> 12 & 63] + $ac085c90a16a552d$var$d[e >> 6 & 63] + $ac085c90a16a552d$var$d[63 & e];
}
function $ac085c90a16a552d$var$y(e, t, n) {
    for(var r, o = [], i = t; i < n; i += 3)r = (e[i] << 16 & 16711680) + (e[i + 1] << 8 & 65280) + (255 & e[i + 2]), o.push($ac085c90a16a552d$var$h(r));
    return o.join("");
}
$ac085c90a16a552d$var$f["-".charCodeAt(0)] = 62, $ac085c90a16a552d$var$f["_".charCodeAt(0)] = 63;
var $ac085c90a16a552d$var$w = {
    byteLength: $ac085c90a16a552d$var$c,
    toByteArray: $ac085c90a16a552d$var$u,
    fromByteArray: $ac085c90a16a552d$var$l
}, $ac085c90a16a552d$var$b = Array.isArray, $ac085c90a16a552d$var$k = Object.keys, $ac085c90a16a552d$var$E = Object.prototype.hasOwnProperty, $ac085c90a16a552d$var$D = function e(t, n) {
    if (t === n) return !0;
    if (t && n && "object" == typeof t && "object" == typeof n) {
        var r, o, i, a = $ac085c90a16a552d$var$b(t), s = $ac085c90a16a552d$var$b(n);
        if (a && s) {
            if ((o = t.length) != n.length) return !1;
            for(r = o; 0 !== r--;)if (!e(t[r], n[r])) return !1;
            return !0;
        }
        if (a != s) return !1;
        var c = t instanceof Date, u = n instanceof Date;
        if (c != u) return !1;
        if (c && u) return t.getTime() == n.getTime();
        var l = t instanceof RegExp, d = n instanceof RegExp;
        if (l != d) return !1;
        if (l && d) return t.toString() == n.toString();
        var f = $ac085c90a16a552d$var$k(t);
        if ((o = f.length) !== $ac085c90a16a552d$var$k(n).length) return !1;
        for(r = o; 0 !== r--;)if (!$ac085c90a16a552d$var$E.call(n, f[r])) return !1;
        for(r = o; 0 !== r--;)if (!e(t[i = f[r]], n[i])) return !1;
        return !0;
    }
    return t != t && n != n;
};
const $ac085c90a16a552d$var$x = [
    "key",
    "ip",
    "country",
    "email",
    "firstName",
    "lastName",
    "avatar",
    "name"
];
function $ac085c90a16a552d$var$O(e) {
    const t = unescape(encodeURIComponent(e));
    return $ac085c90a16a552d$var$w.fromByteArray(function(e) {
        const t = [];
        for(let n = 0; n < e.length; n++)t.push(e.charCodeAt(n));
        return t;
    }(t));
}
function $ac085c90a16a552d$var$C(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
}
var $ac085c90a16a552d$var$P, $ac085c90a16a552d$var$S = {
    appendUrlPath: function(e, t) {
        return (e.endsWith("/") ? e.substring(0, e.length - 1) : e) + (t.startsWith("/") ? "" : "/") + t;
    },
    base64URLEncode: function(e) {
        return $ac085c90a16a552d$var$O(e).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    },
    btoa: $ac085c90a16a552d$var$O,
    clone: function(e) {
        return JSON.parse(JSON.stringify(e));
    },
    deepEquals: function(e, t) {
        return $ac085c90a16a552d$var$D(e, t);
    },
    extend: function(...e) {
        return e.reduce((e, t)=>({
                ...e,
                ...t
            }), {});
    },
    getLDUserAgentString: function(e) {
        const t = e.version || "?";
        return e.userAgent + "/" + t;
    },
    objectHasOwnProperty: $ac085c90a16a552d$var$C,
    onNextTick: function(e) {
        setTimeout(e, 0);
    },
    sanitizeContext: function(e) {
        if (!e) return e;
        let t;
        return null !== e.kind && void 0 !== e.kind || $ac085c90a16a552d$var$x.forEach((n)=>{
            const r = e[n];
            void 0 !== r && "string" != typeof r && (t = t || {
                ...e
            }, t[n] = String(r));
        }), t || e;
    },
    transformValuesToVersionedValues: function(e) {
        const t = {};
        for(const n in e)$ac085c90a16a552d$var$C(e, n) && (t[n] = {
            value: e[n],
            version: 0
        });
        return t;
    },
    transformVersionedValuesToValues: function(e) {
        const t = {};
        for(const n in e)$ac085c90a16a552d$var$C(e, n) && (t[n] = e[n].value);
        return t;
    },
    wrapPromiseCallback: function(e, t) {
        const n = e.then((e)=>(t && setTimeout(()=>{
                t(null, e);
            }, 0), e), (e)=>{
            if (!t) return Promise.reject(e);
            setTimeout(()=>{
                t(e, null);
            }, 0);
        });
        return t ? void 0 : n;
    },
    once: function(e) {
        let t, n = !1;
        return function(...r) {
            return n || (n = !0, t = e.apply(this, r)), t;
        };
    }
}, $ac085c90a16a552d$var$I = new Uint8Array(16);
function $ac085c90a16a552d$var$T() {
    if (!$ac085c90a16a552d$var$P && !($ac085c90a16a552d$var$P = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto))) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return $ac085c90a16a552d$var$P($ac085c90a16a552d$var$I);
}
var $ac085c90a16a552d$var$F = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function $ac085c90a16a552d$var$L(e) {
    return "string" == typeof e && $ac085c90a16a552d$var$F.test(e);
}
for(var $ac085c90a16a552d$var$U, $ac085c90a16a552d$var$A, $ac085c90a16a552d$var$j = [], $ac085c90a16a552d$var$R = 0; $ac085c90a16a552d$var$R < 256; ++$ac085c90a16a552d$var$R)$ac085c90a16a552d$var$j.push(($ac085c90a16a552d$var$R + 256).toString(16).substr(1));
function $ac085c90a16a552d$var$N(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = ($ac085c90a16a552d$var$j[e[t + 0]] + $ac085c90a16a552d$var$j[e[t + 1]] + $ac085c90a16a552d$var$j[e[t + 2]] + $ac085c90a16a552d$var$j[e[t + 3]] + "-" + $ac085c90a16a552d$var$j[e[t + 4]] + $ac085c90a16a552d$var$j[e[t + 5]] + "-" + $ac085c90a16a552d$var$j[e[t + 6]] + $ac085c90a16a552d$var$j[e[t + 7]] + "-" + $ac085c90a16a552d$var$j[e[t + 8]] + $ac085c90a16a552d$var$j[e[t + 9]] + "-" + $ac085c90a16a552d$var$j[e[t + 10]] + $ac085c90a16a552d$var$j[e[t + 11]] + $ac085c90a16a552d$var$j[e[t + 12]] + $ac085c90a16a552d$var$j[e[t + 13]] + $ac085c90a16a552d$var$j[e[t + 14]] + $ac085c90a16a552d$var$j[e[t + 15]]).toLowerCase();
    if (!$ac085c90a16a552d$var$L(n)) throw TypeError("Stringified UUID is invalid");
    return n;
}
var $ac085c90a16a552d$var$$ = 0, $ac085c90a16a552d$var$V = 0;
function $ac085c90a16a552d$var$H(e) {
    if (!$ac085c90a16a552d$var$L(e)) throw TypeError("Invalid UUID");
    var t, n = new Uint8Array(16);
    return n[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24, n[1] = t >>> 16 & 255, n[2] = t >>> 8 & 255, n[3] = 255 & t, n[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8, n[5] = 255 & t, n[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8, n[7] = 255 & t, n[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8, n[9] = 255 & t, n[10] = (t = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, n[11] = t / 4294967296 & 255, n[12] = t >>> 24 & 255, n[13] = t >>> 16 & 255, n[14] = t >>> 8 & 255, n[15] = 255 & t, n;
}
function $ac085c90a16a552d$var$M(e, t, n) {
    function r(e, r, o, i) {
        if ("string" == typeof e && (e = function(e) {
            e = unescape(encodeURIComponent(e));
            for(var t = [], n = 0; n < e.length; ++n)t.push(e.charCodeAt(n));
            return t;
        }(e)), "string" == typeof r && (r = $ac085c90a16a552d$var$H(r)), 16 !== r.length) throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
        var a = new Uint8Array(16 + e.length);
        if (a.set(r), a.set(e, r.length), (a = n(a))[6] = 15 & a[6] | t, a[8] = 63 & a[8] | 128, o) {
            i = i || 0;
            for(var s = 0; s < 16; ++s)o[i + s] = a[s];
            return o;
        }
        return $ac085c90a16a552d$var$N(a);
    }
    try {
        r.name = e;
    } catch (e) {}
    return r.DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", r.URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8", r;
}
function $ac085c90a16a552d$var$q(e) {
    return 14 + (e + 64 >>> 9 << 4) + 1;
}
function $ac085c90a16a552d$var$z(e, t) {
    var n = (65535 & e) + (65535 & t);
    return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
}
function $ac085c90a16a552d$var$K(e, t, n, r, o, i) {
    var a, s;
    return $ac085c90a16a552d$var$z((a = $ac085c90a16a552d$var$z($ac085c90a16a552d$var$z(t, e), $ac085c90a16a552d$var$z(r, i))) << (s = o) | a >>> 32 - s, n);
}
function $ac085c90a16a552d$var$_(e, t, n, r, o, i, a) {
    return $ac085c90a16a552d$var$K(t & n | ~t & r, e, t, o, i, a);
}
function $ac085c90a16a552d$var$J(e, t, n, r, o, i, a) {
    return $ac085c90a16a552d$var$K(t & r | n & ~r, e, t, o, i, a);
}
function $ac085c90a16a552d$var$B(e, t, n, r, o, i, a) {
    return $ac085c90a16a552d$var$K(t ^ n ^ r, e, t, o, i, a);
}
function $ac085c90a16a552d$var$W(e, t, n, r, o, i, a) {
    return $ac085c90a16a552d$var$K(n ^ (t | ~r), e, t, o, i, a);
}
var $ac085c90a16a552d$var$G = $ac085c90a16a552d$var$M("v3", 48, function(e) {
    if ("string" == typeof e) {
        var t = unescape(encodeURIComponent(e));
        e = new Uint8Array(t.length);
        for(var n = 0; n < t.length; ++n)e[n] = t.charCodeAt(n);
    }
    return function(e) {
        for(var t = [], n = 32 * e.length, r = "0123456789abcdef", o = 0; o < n; o += 8){
            var i = e[o >> 5] >>> o % 32 & 255, a = parseInt(r.charAt(i >>> 4 & 15) + r.charAt(15 & i), 16);
            t.push(a);
        }
        return t;
    }(function(e, t) {
        e[t >> 5] |= 128 << t % 32, e[$ac085c90a16a552d$var$q(t) - 1] = t;
        for(var n = 1732584193, r = -271733879, o = -1732584194, i = 271733878, a = 0; a < e.length; a += 16){
            var s = n, c = r, u = o, l = i;
            n = $ac085c90a16a552d$var$_(n, r, o, i, e[a], 7, -680876936), i = $ac085c90a16a552d$var$_(i, n, r, o, e[a + 1], 12, -389564586), o = $ac085c90a16a552d$var$_(o, i, n, r, e[a + 2], 17, 606105819), r = $ac085c90a16a552d$var$_(r, o, i, n, e[a + 3], 22, -1044525330), n = $ac085c90a16a552d$var$_(n, r, o, i, e[a + 4], 7, -176418897), i = $ac085c90a16a552d$var$_(i, n, r, o, e[a + 5], 12, 1200080426), o = $ac085c90a16a552d$var$_(o, i, n, r, e[a + 6], 17, -1473231341), r = $ac085c90a16a552d$var$_(r, o, i, n, e[a + 7], 22, -45705983), n = $ac085c90a16a552d$var$_(n, r, o, i, e[a + 8], 7, 1770035416), i = $ac085c90a16a552d$var$_(i, n, r, o, e[a + 9], 12, -1958414417), o = $ac085c90a16a552d$var$_(o, i, n, r, e[a + 10], 17, -42063), r = $ac085c90a16a552d$var$_(r, o, i, n, e[a + 11], 22, -1990404162), n = $ac085c90a16a552d$var$_(n, r, o, i, e[a + 12], 7, 1804603682), i = $ac085c90a16a552d$var$_(i, n, r, o, e[a + 13], 12, -40341101), o = $ac085c90a16a552d$var$_(o, i, n, r, e[a + 14], 17, -1502002290), n = $ac085c90a16a552d$var$J(n, r = $ac085c90a16a552d$var$_(r, o, i, n, e[a + 15], 22, 1236535329), o, i, e[a + 1], 5, -165796510), i = $ac085c90a16a552d$var$J(i, n, r, o, e[a + 6], 9, -1069501632), o = $ac085c90a16a552d$var$J(o, i, n, r, e[a + 11], 14, 643717713), r = $ac085c90a16a552d$var$J(r, o, i, n, e[a], 20, -373897302), n = $ac085c90a16a552d$var$J(n, r, o, i, e[a + 5], 5, -701558691), i = $ac085c90a16a552d$var$J(i, n, r, o, e[a + 10], 9, 38016083), o = $ac085c90a16a552d$var$J(o, i, n, r, e[a + 15], 14, -660478335), r = $ac085c90a16a552d$var$J(r, o, i, n, e[a + 4], 20, -405537848), n = $ac085c90a16a552d$var$J(n, r, o, i, e[a + 9], 5, 568446438), i = $ac085c90a16a552d$var$J(i, n, r, o, e[a + 14], 9, -1019803690), o = $ac085c90a16a552d$var$J(o, i, n, r, e[a + 3], 14, -187363961), r = $ac085c90a16a552d$var$J(r, o, i, n, e[a + 8], 20, 1163531501), n = $ac085c90a16a552d$var$J(n, r, o, i, e[a + 13], 5, -1444681467), i = $ac085c90a16a552d$var$J(i, n, r, o, e[a + 2], 9, -51403784), o = $ac085c90a16a552d$var$J(o, i, n, r, e[a + 7], 14, 1735328473), n = $ac085c90a16a552d$var$B(n, r = $ac085c90a16a552d$var$J(r, o, i, n, e[a + 12], 20, -1926607734), o, i, e[a + 5], 4, -378558), i = $ac085c90a16a552d$var$B(i, n, r, o, e[a + 8], 11, -2022574463), o = $ac085c90a16a552d$var$B(o, i, n, r, e[a + 11], 16, 1839030562), r = $ac085c90a16a552d$var$B(r, o, i, n, e[a + 14], 23, -35309556), n = $ac085c90a16a552d$var$B(n, r, o, i, e[a + 1], 4, -1530992060), i = $ac085c90a16a552d$var$B(i, n, r, o, e[a + 4], 11, 1272893353), o = $ac085c90a16a552d$var$B(o, i, n, r, e[a + 7], 16, -155497632), r = $ac085c90a16a552d$var$B(r, o, i, n, e[a + 10], 23, -1094730640), n = $ac085c90a16a552d$var$B(n, r, o, i, e[a + 13], 4, 681279174), i = $ac085c90a16a552d$var$B(i, n, r, o, e[a], 11, -358537222), o = $ac085c90a16a552d$var$B(o, i, n, r, e[a + 3], 16, -722521979), r = $ac085c90a16a552d$var$B(r, o, i, n, e[a + 6], 23, 76029189), n = $ac085c90a16a552d$var$B(n, r, o, i, e[a + 9], 4, -640364487), i = $ac085c90a16a552d$var$B(i, n, r, o, e[a + 12], 11, -421815835), o = $ac085c90a16a552d$var$B(o, i, n, r, e[a + 15], 16, 530742520), n = $ac085c90a16a552d$var$W(n, r = $ac085c90a16a552d$var$B(r, o, i, n, e[a + 2], 23, -995338651), o, i, e[a], 6, -198630844), i = $ac085c90a16a552d$var$W(i, n, r, o, e[a + 7], 10, 1126891415), o = $ac085c90a16a552d$var$W(o, i, n, r, e[a + 14], 15, -1416354905), r = $ac085c90a16a552d$var$W(r, o, i, n, e[a + 5], 21, -57434055), n = $ac085c90a16a552d$var$W(n, r, o, i, e[a + 12], 6, 1700485571), i = $ac085c90a16a552d$var$W(i, n, r, o, e[a + 3], 10, -1894986606), o = $ac085c90a16a552d$var$W(o, i, n, r, e[a + 10], 15, -1051523), r = $ac085c90a16a552d$var$W(r, o, i, n, e[a + 1], 21, -2054922799), n = $ac085c90a16a552d$var$W(n, r, o, i, e[a + 8], 6, 1873313359), i = $ac085c90a16a552d$var$W(i, n, r, o, e[a + 15], 10, -30611744), o = $ac085c90a16a552d$var$W(o, i, n, r, e[a + 6], 15, -1560198380), r = $ac085c90a16a552d$var$W(r, o, i, n, e[a + 13], 21, 1309151649), n = $ac085c90a16a552d$var$W(n, r, o, i, e[a + 4], 6, -145523070), i = $ac085c90a16a552d$var$W(i, n, r, o, e[a + 11], 10, -1120210379), o = $ac085c90a16a552d$var$W(o, i, n, r, e[a + 2], 15, 718787259), r = $ac085c90a16a552d$var$W(r, o, i, n, e[a + 9], 21, -343485551), n = $ac085c90a16a552d$var$z(n, s), r = $ac085c90a16a552d$var$z(r, c), o = $ac085c90a16a552d$var$z(o, u), i = $ac085c90a16a552d$var$z(i, l);
        }
        return [
            n,
            r,
            o,
            i
        ];
    }(function(e) {
        if (0 === e.length) return [];
        for(var t = 8 * e.length, n = new Uint32Array($ac085c90a16a552d$var$q(t)), r = 0; r < t; r += 8)n[r >> 5] |= (255 & e[r / 8]) << r % 32;
        return n;
    }(e), 8 * e.length));
}), $ac085c90a16a552d$var$X = $ac085c90a16a552d$var$G;
function $ac085c90a16a552d$var$Q(e, t, n, r) {
    switch(e){
        case 0:
            return t & n ^ ~t & r;
        case 1:
        case 3:
            return t ^ n ^ r;
        case 2:
            return t & n ^ t & r ^ n & r;
    }
}
function $ac085c90a16a552d$var$Y(e, t) {
    return e << t | e >>> 32 - t;
}
var $ac085c90a16a552d$var$Z = $ac085c90a16a552d$var$M("v5", 80, function(e) {
    var t = [
        1518500249,
        1859775393,
        2400959708,
        3395469782
    ], n = [
        1732584193,
        4023233417,
        2562383102,
        271733878,
        3285377520
    ];
    if ("string" == typeof e) {
        var r = unescape(encodeURIComponent(e));
        e = [];
        for(var o = 0; o < r.length; ++o)e.push(r.charCodeAt(o));
    } else Array.isArray(e) || (e = Array.prototype.slice.call(e));
    e.push(128);
    for(var i = e.length / 4 + 2, a = Math.ceil(i / 16), s = new Array(a), c = 0; c < a; ++c){
        for(var u = new Uint32Array(16), l = 0; l < 16; ++l)u[l] = e[64 * c + 4 * l] << 24 | e[64 * c + 4 * l + 1] << 16 | e[64 * c + 4 * l + 2] << 8 | e[64 * c + 4 * l + 3];
        s[c] = u;
    }
    s[a - 1][14] = 8 * (e.length - 1) / Math.pow(2, 32), s[a - 1][14] = Math.floor(s[a - 1][14]), s[a - 1][15] = 8 * (e.length - 1) & 4294967295;
    for(var d = 0; d < a; ++d){
        for(var f = new Uint32Array(80), g = 0; g < 16; ++g)f[g] = s[d][g];
        for(var v = 16; v < 80; ++v)f[v] = $ac085c90a16a552d$var$Y(f[v - 3] ^ f[v - 8] ^ f[v - 14] ^ f[v - 16], 1);
        for(var p = n[0], m = n[1], h = n[2], y = n[3], w = n[4], b = 0; b < 80; ++b){
            var k = Math.floor(b / 20), E = $ac085c90a16a552d$var$Y(p, 5) + $ac085c90a16a552d$var$Q(k, m, h, y) + w + t[k] + f[b] >>> 0;
            w = y, y = h, h = $ac085c90a16a552d$var$Y(m, 30) >>> 0, m = p, p = E;
        }
        n[0] = n[0] + p >>> 0, n[1] = n[1] + m >>> 0, n[2] = n[2] + h >>> 0, n[3] = n[3] + y >>> 0, n[4] = n[4] + w >>> 0;
    }
    return [
        n[0] >> 24 & 255,
        n[0] >> 16 & 255,
        n[0] >> 8 & 255,
        255 & n[0],
        n[1] >> 24 & 255,
        n[1] >> 16 & 255,
        n[1] >> 8 & 255,
        255 & n[1],
        n[2] >> 24 & 255,
        n[2] >> 16 & 255,
        n[2] >> 8 & 255,
        255 & n[2],
        n[3] >> 24 & 255,
        n[3] >> 16 & 255,
        n[3] >> 8 & 255,
        255 & n[3],
        n[4] >> 24 & 255,
        n[4] >> 16 & 255,
        n[4] >> 8 & 255,
        255 & n[4]
    ];
}), $ac085c90a16a552d$var$ee = $ac085c90a16a552d$var$Z;
var $ac085c90a16a552d$var$te = Object.freeze({
    __proto__: null,
    v1: function(e, t, n) {
        var r = t && n || 0, o = t || new Array(16), i = (e = e || {}).node || $ac085c90a16a552d$var$U, a = void 0 !== e.clockseq ? e.clockseq : $ac085c90a16a552d$var$A;
        if (null == i || null == a) {
            var s = e.random || (e.rng || $ac085c90a16a552d$var$T)();
            null == i && (i = $ac085c90a16a552d$var$U = [
                1 | s[0],
                s[1],
                s[2],
                s[3],
                s[4],
                s[5]
            ]), null == a && (a = $ac085c90a16a552d$var$A = 16383 & (s[6] << 8 | s[7]));
        }
        var c = void 0 !== e.msecs ? e.msecs : Date.now(), u = void 0 !== e.nsecs ? e.nsecs : $ac085c90a16a552d$var$V + 1, l = c - $ac085c90a16a552d$var$$ + (u - $ac085c90a16a552d$var$V) / 1e4;
        if (l < 0 && void 0 === e.clockseq && (a = a + 1 & 16383), (l < 0 || c > $ac085c90a16a552d$var$$) && void 0 === e.nsecs && (u = 0), u >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
        $ac085c90a16a552d$var$$ = c, $ac085c90a16a552d$var$V = u, $ac085c90a16a552d$var$A = a;
        var d = (1e4 * (268435455 & (c += 122192928e5)) + u) % 4294967296;
        o[r++] = d >>> 24 & 255, o[r++] = d >>> 16 & 255, o[r++] = d >>> 8 & 255, o[r++] = 255 & d;
        var f = c / 4294967296 * 1e4 & 268435455;
        o[r++] = f >>> 8 & 255, o[r++] = 255 & f, o[r++] = f >>> 24 & 15 | 16, o[r++] = f >>> 16 & 255, o[r++] = a >>> 8 | 128, o[r++] = 255 & a;
        for(var g = 0; g < 6; ++g)o[r + g] = i[g];
        return t || $ac085c90a16a552d$var$N(o);
    },
    v3: $ac085c90a16a552d$var$X,
    v4: function(e, t, n) {
        var r = (e = e || {}).random || (e.rng || $ac085c90a16a552d$var$T)();
        if (r[6] = 15 & r[6] | 64, r[8] = 63 & r[8] | 128, t) {
            n = n || 0;
            for(var o = 0; o < 16; ++o)t[n + o] = r[o];
            return t;
        }
        return $ac085c90a16a552d$var$N(r);
    },
    v5: $ac085c90a16a552d$var$ee,
    NIL: "00000000-0000-0000-0000-000000000000",
    version: function(e) {
        if (!$ac085c90a16a552d$var$L(e)) throw TypeError("Invalid UUID");
        return parseInt(e.substr(14, 1), 16);
    },
    validate: $ac085c90a16a552d$var$L,
    stringify: $ac085c90a16a552d$var$N,
    parse: $ac085c90a16a552d$var$H
});
const $ac085c90a16a552d$var$ne = [
    "debug",
    "info",
    "warn",
    "error",
    "none"
];
var $ac085c90a16a552d$var$re = {
    commonBasicLogger: function(e, t) {
        if (e && e.destination && "function" != typeof e.destination) throw new Error("destination for basicLogger was set to a non-function");
        function n(e) {
            return function(t) {
                console && console[e] && console[e].call(console, t);
            };
        }
        const r = e && e.destination ? [
            e.destination,
            e.destination,
            e.destination,
            e.destination
        ] : [
            n("log"),
            n("info"),
            n("warn"),
            n("error")
        ], o = !(!e || !e.destination), i = e && void 0 !== e.prefix && null !== e.prefix ? e.prefix : "[LaunchDarkly] ";
        let a = 1;
        if (e && e.level) for(let t = 0; t < $ac085c90a16a552d$var$ne.length; t++)$ac085c90a16a552d$var$ne[t] === e.level && (a = t);
        function s(e, n, a) {
            if (a.length < 1) return;
            let s;
            const c = o ? n + ": " + i : i;
            if (1 !== a.length && t) {
                const e = [
                    ...a
                ];
                e[0] = c + e[0], s = t(...e);
            } else s = c + a[0];
            try {
                r[e](s);
            } catch (e) {
                console && console.log && console.log("[LaunchDarkly] Configured logger's " + n + " method threw an exception: " + e);
            }
        }
        const c = {};
        for(let e = 0; e < $ac085c90a16a552d$var$ne.length; e++){
            const t = $ac085c90a16a552d$var$ne[e];
            if ("none" !== t) {
                if (e < a) c[t] = ()=>{};
                else {
                    const n = e;
                    c[t] = function() {
                        s(n, t, arguments);
                    };
                }
            }
        }
        return c;
    },
    validateLogger: function(e) {
        $ac085c90a16a552d$var$ne.forEach((t)=>{
            if ("none" !== t && (!e[t] || "function" != typeof e[t])) throw new Error("Provided logger instance must support logger." + t + "(...) method");
        });
    }
};
function $ac085c90a16a552d$var$oe(e) {
    return e && e.message ? e.message : "string" == typeof e || e instanceof String ? e : JSON.stringify(e);
}
const $ac085c90a16a552d$var$ie = " Please see https://docs.launchdarkly.com/sdk/client-side/javascript#initialize-the-client for instructions on SDK initialization.";
var $ac085c90a16a552d$var$ae = {
    bootstrapInvalid: function() {
        return "LaunchDarkly bootstrap data is not available because the back end could not read the flags.";
    },
    bootstrapOldFormat: function() {
        return "LaunchDarkly client was initialized with bootstrap data that did not include flag metadata. Events may not be sent correctly." + $ac085c90a16a552d$var$ie;
    },
    clientInitialized: function() {
        return "LaunchDarkly client initialized";
    },
    clientNotReady: function() {
        return "LaunchDarkly client is not ready";
    },
    debugEnqueueingEvent: function(e) {
        return 'enqueueing "' + e + '" event';
    },
    debugPostingDiagnosticEvent: function(e) {
        return "sending diagnostic event (" + e.kind + ")";
    },
    debugPostingEvents: function(e) {
        return "sending " + e + " events";
    },
    debugStreamDelete: function(e) {
        return 'received streaming deletion for flag "' + e + '"';
    },
    debugStreamDeleteIgnored: function(e) {
        return 'received streaming deletion for flag "' + e + '" but ignored due to version check';
    },
    debugStreamPatch: function(e) {
        return 'received streaming update for flag "' + e + '"';
    },
    debugStreamPatchIgnored: function(e) {
        return 'received streaming update for flag "' + e + '" but ignored due to version check';
    },
    debugStreamPing: function() {
        return "received ping message from stream";
    },
    debugPolling: function(e) {
        return "polling for feature flags at " + e;
    },
    debugStreamPut: function() {
        return "received streaming update for all flags";
    },
    deprecated: function(e, t) {
        return t ? '"' + e + '" is deprecated, please use "' + t + '"' : '"' + e + '" is deprecated';
    },
    environmentNotFound: function() {
        return "Environment not found. Double check that you specified a valid environment/client-side ID." + $ac085c90a16a552d$var$ie;
    },
    environmentNotSpecified: function() {
        return "No environment/client-side ID was specified." + $ac085c90a16a552d$var$ie;
    },
    errorFetchingFlags: function(e) {
        return "Error fetching flag settings: " + $ac085c90a16a552d$var$oe(e);
    },
    eventCapacityExceeded: function() {
        return "Exceeded event queue capacity. Increase capacity to avoid dropping events.";
    },
    eventWithoutContext: function() {
        return "Be sure to call `identify` in the LaunchDarkly client: https://docs.launchdarkly.com/sdk/features/identify#javascript";
    },
    httpErrorMessage: function(e, t, n) {
        return "Received error " + e + (401 === e ? " (invalid SDK key)" : "") + " for " + t + " - " + ($ac085c90a16a552d$var$s.isHttpErrorRecoverable(e) ? n : "giving up permanently");
    },
    httpUnavailable: function() {
        return "Cannot make HTTP requests in this environment." + $ac085c90a16a552d$var$ie;
    },
    identifyDisabled: function() {
        return "identify() has no effect here; it must be called on the main client instance";
    },
    inspectorMethodError: (e, t)=>`an inspector: "${t}" of type: "${e}" generated an exception`,
    invalidContentType: function(e) {
        return 'Expected application/json content type but got "' + e + '"';
    },
    invalidData: function() {
        return "Invalid data received from LaunchDarkly; connection may have been interrupted";
    },
    invalidInspector: (e, t)=>`an inspector: "${t}" of an invalid type (${e}) was configured`,
    invalidKey: function() {
        return "Event key must be a string";
    },
    invalidMetricValue: (e)=>`The track function was called with a non-numeric "metricValue" (${e}), only numeric metric values are supported.`,
    invalidContext: function() {
        return "Invalid context specified." + $ac085c90a16a552d$var$ie;
    },
    invalidTagValue: (e)=>`Config option "${e}" must only contain letters, numbers, ., _ or -.`,
    localStorageUnavailable: function(e) {
        return "local storage is unavailable: " + $ac085c90a16a552d$var$oe(e);
    },
    networkError: (e)=>"network error" + (e ? " (" + e + ")" : ""),
    optionBelowMinimum: (e, t, n)=>'Config option "' + e + '" was set to ' + t + ", changing to minimum value of " + n,
    streamClosing: function() {
        return "Closing stream connection";
    },
    streamConnecting: function(e) {
        return "Opening stream connection to " + e;
    },
    streamError: function(e, t) {
        return "Error on stream connection: " + $ac085c90a16a552d$var$oe(e) + ", will continue retrying after " + t + " milliseconds.";
    },
    tagValueTooLong: (e)=>`Value of "${e}" was longer than 64 characters and was discarded.`,
    unknownCustomEventKey: function(e) {
        return 'Custom event "' + e + '" does not exist';
    },
    unknownOption: (e)=>'Ignoring unknown config option "' + e + '"',
    contextNotSpecified: function() {
        return "No context specified." + $ac085c90a16a552d$var$ie;
    },
    unrecoverableStreamError: (e)=>`Error on stream connection ${$ac085c90a16a552d$var$oe(e)}, giving up permanently`,
    wrongOptionType: (e, t, n)=>'Config option "' + e + '" should be of type ' + t + ", got " + n + ", using default value",
    wrongOptionTypeBoolean: (e, t)=>'Config option "' + e + '" should be a boolean, got ' + t + ", converting to boolean"
};
const { validateLogger: $ac085c90a16a552d$var$se } = $ac085c90a16a552d$var$re, $ac085c90a16a552d$var$ce = {
    baseUrl: {
        default: "https://app.launchdarkly.com"
    },
    streamUrl: {
        default: "https://clientstream.launchdarkly.com"
    },
    eventsUrl: {
        default: "https://events.launchdarkly.com"
    },
    sendEvents: {
        default: !0
    },
    streaming: {
        type: "boolean"
    },
    sendLDHeaders: {
        default: !0
    },
    requestHeaderTransform: {
        type: "function"
    },
    sendEventsOnlyForVariation: {
        default: !1
    },
    useReport: {
        default: !1
    },
    evaluationReasons: {
        default: !1
    },
    eventCapacity: {
        default: 100,
        minimum: 1
    },
    flushInterval: {
        default: 2e3,
        minimum: 2e3
    },
    samplingInterval: {
        default: 0,
        minimum: 0
    },
    streamReconnectDelay: {
        default: 1e3,
        minimum: 0
    },
    allAttributesPrivate: {
        default: !1
    },
    privateAttributes: {
        default: []
    },
    bootstrap: {
        type: "string|object"
    },
    diagnosticRecordingInterval: {
        default: 9e5,
        minimum: 2e3
    },
    diagnosticOptOut: {
        default: !1
    },
    wrapperName: {
        type: "string"
    },
    wrapperVersion: {
        type: "string"
    },
    stateProvider: {
        type: "object"
    },
    application: {
        validator: function(e, t, n) {
            const r = {};
            t.id && (r.id = $ac085c90a16a552d$var$de(`${e}.id`, t.id, n));
            t.version && (r.version = $ac085c90a16a552d$var$de(`${e}.version`, t.version, n));
            return r;
        }
    },
    inspectors: {
        default: []
    },
    hooks: {
        default: []
    },
    plugins: {
        default: []
    }
}, $ac085c90a16a552d$var$ue = /^(\w|\.|-)+$/;
function $ac085c90a16a552d$var$le(e) {
    return e && e.replace(/\/+$/, "");
}
function $ac085c90a16a552d$var$de(e, t, n) {
    if ("string" == typeof t && t.match($ac085c90a16a552d$var$ue)) {
        if (!(t.length > 64)) return t;
        n.warn($ac085c90a16a552d$var$ae.tagValueTooLong(e));
    } else n.warn($ac085c90a16a552d$var$ae.invalidTagValue(e));
}
var $ac085c90a16a552d$var$fe = {
    baseOptionDefs: $ac085c90a16a552d$var$ce,
    validate: function(e, t, n, r) {
        const o = $ac085c90a16a552d$var$S.extend({
            logger: {
                default: r
            }
        }, $ac085c90a16a552d$var$ce, n), i = {};
        function a(e) {
            $ac085c90a16a552d$var$S.onNextTick(()=>{
                t && t.maybeReportError(new $ac085c90a16a552d$var$s.LDInvalidArgumentError(e));
            });
        }
        let c = $ac085c90a16a552d$var$S.extend({}, e || {});
        return function(e) {
            const t = e;
            Object.keys(i).forEach((e)=>{
                if (void 0 !== t[e]) {
                    const n = i[e];
                    r && r.warn($ac085c90a16a552d$var$ae.deprecated(e, n)), n && (void 0 === t[n] && (t[n] = t[e]), delete t[e]);
                }
            });
        }(c), c = function(e) {
            const t = $ac085c90a16a552d$var$S.extend({}, e);
            return Object.keys(o).forEach((e)=>{
                void 0 !== t[e] && null !== t[e] || (t[e] = o[e] && o[e].default);
            }), t;
        }(c), c = function(e) {
            const t = $ac085c90a16a552d$var$S.extend({}, e), n = (e)=>{
                if (null === e) return "any";
                if (void 0 === e) return;
                if (Array.isArray(e)) return "array";
                const t = typeof e;
                return "boolean" === t || "string" === t || "number" === t || "function" === t ? t : "object";
            };
            return Object.keys(e).forEach((i)=>{
                const s = e[i];
                if (null != s) {
                    const c = o[i];
                    if (void 0 === c) a($ac085c90a16a552d$var$ae.unknownOption(i));
                    else {
                        const o = c.type || n(c.default), u = c.validator;
                        if (u) {
                            const n = u(i, e[i], r);
                            void 0 !== n ? t[i] = n : delete t[i];
                        } else if ("any" !== o) {
                            const e = o.split("|"), r = n(s);
                            e.indexOf(r) < 0 ? "boolean" === o ? (t[i] = !!s, a($ac085c90a16a552d$var$ae.wrongOptionTypeBoolean(i, r))) : (a($ac085c90a16a552d$var$ae.wrongOptionType(i, o, r)), t[i] = c.default) : "number" === r && void 0 !== c.minimum && s < c.minimum && (a($ac085c90a16a552d$var$ae.optionBelowMinimum(i, s, c.minimum)), t[i] = c.minimum);
                        }
                    }
                }
            }), t.baseUrl = $ac085c90a16a552d$var$le(t.baseUrl), t.streamUrl = $ac085c90a16a552d$var$le(t.streamUrl), t.eventsUrl = $ac085c90a16a552d$var$le(t.eventsUrl), t;
        }(c), $ac085c90a16a552d$var$se(c.logger), c;
    },
    getTags: function(e) {
        const t = {};
        return e && (e.application && void 0 !== e.application.id && null !== e.application.id && (t["application-id"] = [
            e.application.id
        ]), e.application && void 0 !== e.application.version && null !== e.application.id && (t["application-version"] = [
            e.application.version
        ])), t;
    }
};
const { getLDUserAgentString: $ac085c90a16a552d$var$ge } = $ac085c90a16a552d$var$S;
var $ac085c90a16a552d$var$ve = {
    getLDHeaders: function(e, t) {
        if (t && !t.sendLDHeaders) return {};
        const n = {};
        n[e.userAgentHeaderName || "User-Agent"] = $ac085c90a16a552d$var$ge(e), t && t.wrapperName && (n["X-LaunchDarkly-Wrapper"] = t.wrapperVersion ? t.wrapperName + "/" + t.wrapperVersion : t.wrapperName);
        const r = $ac085c90a16a552d$var$fe.getTags(t), o = Object.keys(r);
        return o.length && (n["x-launchdarkly-tags"] = o.sort().map((e)=>Array.isArray(r[e]) ? r[e].sort().map((t)=>`${e}/${t}`) : [
                `${e}/${r[e]}`
            ]).reduce((e, t)=>e.concat(t), []).join(" ")), n;
    },
    transformHeaders: function(e, t) {
        return t && t.requestHeaderTransform ? t.requestHeaderTransform({
            ...e
        }) : e;
    }
};
const { v1: $ac085c90a16a552d$var$pe } = $ac085c90a16a552d$var$te, { getLDHeaders: $ac085c90a16a552d$var$me, transformHeaders: $ac085c90a16a552d$var$he } = $ac085c90a16a552d$var$ve;
var $ac085c90a16a552d$var$ye = function(e, t, n) {
    const r = $ac085c90a16a552d$var$S.extend({
        "Content-Type": "application/json"
    }, $ac085c90a16a552d$var$me(e, n)), o = {};
    return o.sendEvents = (t, o, i)=>{
        if (!e.httpRequest) return Promise.resolve();
        const a = JSON.stringify(t), c = i ? null : $ac085c90a16a552d$var$pe();
        return (function t(u) {
            const l = i ? r : $ac085c90a16a552d$var$S.extend({}, r, {
                "X-LaunchDarkly-Event-Schema": "4",
                "X-LaunchDarkly-Payload-ID": c
            });
            return e.httpRequest("POST", o, $ac085c90a16a552d$var$he(l, n), a).promise.then((e)=>{
                if (e) return e.status >= 400 && $ac085c90a16a552d$var$s.isHttpErrorRecoverable(e.status) && u ? t(!1) : function(e) {
                    const t = {
                        status: e.status
                    }, n = e.header("date");
                    if (n) {
                        const e = Date.parse(n);
                        e && (t.serverTime = e);
                    }
                    return t;
                }(e);
            }).catch(()=>u ? t(!1) : Promise.reject());
        })(!0).catch(()=>{});
    }, o;
};
var $ac085c90a16a552d$var$we = function e(t, n = []) {
    if (null === t || "object" != typeof t) return JSON.stringify(t);
    if (n.includes(t)) throw new Error("Cycle detected");
    if (Array.isArray(t)) return `[${t.map((r)=>e(r, [
            ...n,
            t
        ])).map((e)=>void 0 === e ? "null" : e).join(",")}]`;
    return `{${Object.keys(t).sort().map((r)=>{
        const o = e(t[r], [
            ...n,
            t
        ]);
        if (void 0 !== o) return `${JSON.stringify(r)}:${o}`;
    }).filter((e)=>void 0 !== e).join(",")}}`;
};
const { commonBasicLogger: $ac085c90a16a552d$var$be } = $ac085c90a16a552d$var$re;
function $ac085c90a16a552d$var$ke(e) {
    return "string" == typeof e && "kind" !== e && e.match(/^(\w|\.|-)+$/);
}
function $ac085c90a16a552d$var$Ee(e) {
    return e.includes("%") || e.includes(":") ? e.replace(/%/g, "%25").replace(/:/g, "%3A") : e;
}
var $ac085c90a16a552d$var$De = {
    checkContext: function(e, t) {
        if (e) {
            if (t && (void 0 === e.kind || null === e.kind)) return void 0 !== e.key && null !== e.key;
            const n = e.key, r = void 0 === e.kind ? "user" : e.kind, o = $ac085c90a16a552d$var$ke(r), i = "multi" === r || null != n && "" !== n;
            if ("multi" === r) {
                const t = Object.keys(e).filter((e)=>"kind" !== e);
                return i && t.every((e)=>$ac085c90a16a552d$var$ke(e)) && t.every((t)=>{
                    const n = e[t].key;
                    return null != n && "" !== n;
                });
            }
            return i && o;
        }
        return !1;
    },
    getContextKeys: function(e, t = $ac085c90a16a552d$var$be()) {
        if (!e) return;
        const n = {}, { kind: r, key: o } = e;
        switch(r){
            case void 0:
                n.user = `${o}`;
                break;
            case "multi":
                Object.entries(e).filter(([e])=>"kind" !== e).forEach(([e, t])=>{
                    t && t.key && (n[e] = t.key);
                });
                break;
            case null:
                t.warn(`null is not a valid context kind: ${e}`);
                break;
            case "":
                t.warn(`'' is not a valid context kind: ${e}`);
                break;
            default:
                n[r] = `${o}`;
        }
        return n;
    },
    getContextKinds: function(e) {
        return e ? null === e.kind || void 0 === e.kind ? [
            "user"
        ] : "multi" !== e.kind ? [
            e.kind
        ] : Object.keys(e).filter((e)=>"kind" !== e) : [];
    },
    getCanonicalKey: function(e) {
        if (e) {
            if ((void 0 === e.kind || null === e.kind || "user" === e.kind) && e.key) return e.key;
            if ("multi" !== e.kind && e.key) return `${e.kind}:${$ac085c90a16a552d$var$Ee(e.key)}`;
            if ("multi" === e.kind) return Object.keys(e).sort().filter((e)=>"kind" !== e).map((t)=>`${t}:${$ac085c90a16a552d$var$Ee(e[t].key)}`).join(":");
        }
    }
};
const { getContextKinds: $ac085c90a16a552d$var$xe } = $ac085c90a16a552d$var$De;
var $ac085c90a16a552d$var$Oe = function() {
    const e = {};
    let t = 0, n = 0, r = {}, o = {};
    return e.summarizeEvent = (e)=>{
        if ("feature" === e.kind) {
            const i = e.key + ":" + (null !== e.variation && void 0 !== e.variation ? e.variation : "") + ":" + (null !== e.version && void 0 !== e.version ? e.version : ""), a = r[i];
            let s = o[e.key];
            s || (s = new Set, o[e.key] = s), (function(e) {
                return e.context ? $ac085c90a16a552d$var$xe(e.context) : e.contextKeys ? Object.keys(e.contextKeys) : [];
            })(e).forEach((e)=>s.add(e)), a ? a.count = a.count + 1 : r[i] = {
                count: 1,
                key: e.key,
                version: e.version,
                variation: e.variation,
                value: e.value,
                default: e.default
            }, (0 === t || e.creationDate < t) && (t = e.creationDate), e.creationDate > n && (n = e.creationDate);
        }
    }, e.getSummary = ()=>{
        const e = {};
        let i = !0;
        for (const t of Object.values(r)){
            let n = e[t.key];
            n || (n = {
                default: t.default,
                counters: [],
                contextKinds: [
                    ...o[t.key]
                ]
            }, e[t.key] = n);
            const r = {
                value: t.value,
                count: t.count
            };
            void 0 !== t.variation && null !== t.variation && (r.variation = t.variation), void 0 !== t.version && null !== t.version ? r.version = t.version : r.unknown = !0, n.counters.push(r), i = !1;
        }
        return i ? null : {
            startDate: t,
            endDate: n,
            features: e,
            kind: "summary"
        };
    }, e.clearSummary = ()=>{
        t = 0, n = 0, r = {}, o = {};
    }, e;
};
var $ac085c90a16a552d$var$Ce = function(e) {
    let t = {}, n = {};
    return {
        summarizeEvent: function(e) {
            if ("feature" === e.kind) {
                const r = $ac085c90a16a552d$var$we(e.context);
                if (!r) return;
                let o = t[r];
                o || (t[r] = $ac085c90a16a552d$var$Oe(), o = t[r], n[r] = e.context), o.summarizeEvent(e);
            }
        },
        getSummaries: function() {
            const r = t, o = n;
            return t = {}, n = {}, Object.entries(r).map(([t, n])=>{
                const r = n.getSummary();
                return r.context = e.filter(o[t]), r;
            });
        }
    };
};
function $ac085c90a16a552d$var$Pe(e) {
    return e.replace(/~/g, "~0").replace(/\//g, "~1");
}
function $ac085c90a16a552d$var$Se(e) {
    return (e.startsWith("/") ? e.substring(1) : e).split("/").map((e)=>e.indexOf("~") >= 0 ? e.replace(/~1/g, "/").replace(/~0/g, "~") : e);
}
function $ac085c90a16a552d$var$Ie(e) {
    return !e.startsWith("/");
}
function $ac085c90a16a552d$var$Te(e, t) {
    const n = $ac085c90a16a552d$var$Ie(e), r = $ac085c90a16a552d$var$Ie(t);
    if (n && r) return e === t;
    if (n) {
        const n = $ac085c90a16a552d$var$Se(t);
        return 1 === n.length && e === n[0];
    }
    if (r) {
        const n = $ac085c90a16a552d$var$Se(e);
        return 1 === n.length && t === n[0];
    }
    return e === t;
}
function $ac085c90a16a552d$var$Fe(e) {
    return `/${$ac085c90a16a552d$var$Pe(e)}`;
}
var $ac085c90a16a552d$var$Le = {
    cloneExcluding: function(e, t) {
        const n = [], r = {}, o = [];
        for(n.push(...Object.keys(e).map((t)=>({
                key: t,
                ptr: $ac085c90a16a552d$var$Fe(t),
                source: e,
                parent: r,
                visited: [
                    e
                ]
            }))); n.length;){
            const e = n.pop();
            if (t.some((t)=>$ac085c90a16a552d$var$Te(t, e.ptr))) o.push(e.ptr);
            else {
                const t = e.source[e.key];
                if (null === t) e.parent[e.key] = t;
                else if (Array.isArray(t)) e.parent[e.key] = [
                    ...t
                ];
                else if ("object" == typeof t) {
                    if (e.visited.includes(t)) continue;
                    e.parent[e.key] = {}, n.push(...Object.keys(t).map((n)=>{
                        var r, o;
                        return {
                            key: n,
                            ptr: (r = e.ptr, o = $ac085c90a16a552d$var$Pe(n), `${r}/${o}`),
                            source: t,
                            parent: e.parent[e.key],
                            visited: [
                                ...e.visited,
                                t
                            ]
                        };
                    }));
                } else e.parent[e.key] = t;
            }
        }
        return {
            cloned: r,
            excluded: o.sort()
        };
    },
    compare: $ac085c90a16a552d$var$Te,
    literalToReference: $ac085c90a16a552d$var$Fe
};
var $ac085c90a16a552d$var$Ue = function(e) {
    const t = {}, n = e.allAttributesPrivate, r = e.privateAttributes || [], o = [
        "key",
        "kind",
        "_meta",
        "anonymous"
    ], i = [
        "name",
        "ip",
        "firstName",
        "lastName",
        "email",
        "avatar",
        "country"
    ], a = (e, t)=>{
        if ("object" != typeof e || null === e || Array.isArray(e)) return;
        const { cloned: i, excluded: a } = $ac085c90a16a552d$var$Le.cloneExcluding(e, ((e, t)=>(n || t && e.anonymous ? Object.keys(e) : [
                ...r,
                ...e._meta && e._meta.privateAttributes || []
            ]).filter((e)=>!o.some((t)=>$ac085c90a16a552d$var$Le.compare(e, t))))(e, t));
        return i.key = String(i.key), a.length && (i._meta || (i._meta = {}), i._meta.redactedAttributes = a), i._meta && (delete i._meta.privateAttributes, 0 === Object.keys(i._meta).length && delete i._meta), void 0 !== i.anonymous && (i.anonymous = !!i.anonymous), i;
    };
    return t.filter = (e, t = !1)=>void 0 === e.kind || null === e.kind ? a(((e)=>{
            const t = {
                ...e.custom || {},
                kind: "user",
                key: e.key
            };
            void 0 !== e.anonymous && (t.anonymous = !!e.anonymous);
            for (const n of i)delete t[n], void 0 !== e[n] && null !== e[n] && (t[n] = String(e[n]));
            return void 0 !== e.privateAttributeNames && null !== e.privateAttributeNames && (t._meta = t._meta || {}, t._meta.privateAttributes = e.privateAttributeNames.map((e)=>e.startsWith("/") ? $ac085c90a16a552d$var$Le.literalToReference(e) : e)), t;
        })(e), t) : "multi" === e.kind ? ((e, t)=>{
            const n = {
                kind: e.kind
            }, r = Object.keys(e);
            for (const o of r)if ("kind" !== o) {
                const r = a(e[o], t);
                r && (n[o] = r);
            }
            return n;
        })(e, t) : a(e, t), t;
};
const { getContextKeys: $ac085c90a16a552d$var$Ae } = $ac085c90a16a552d$var$De;
var $ac085c90a16a552d$var$je = function(e, t, n, r = null, o = null, i = null) {
    const a = {}, c = i || $ac085c90a16a552d$var$ye(e, n, t), u = $ac085c90a16a552d$var$S.appendUrlPath(t.eventsUrl, "/events/bulk/" + n), l = $ac085c90a16a552d$var$Ue(t), d = $ac085c90a16a552d$var$Ce(l), f = t.samplingInterval, g = t.eventCapacity, v = t.flushInterval, p = t.logger;
    let m, h = [], y = 0, w = !1, b = !1;
    function k() {
        return 0 === f || 0 === Math.floor(Math.random() * f);
    }
    function E(e) {
        const t = $ac085c90a16a552d$var$S.extend({}, e);
        return "identify" === e.kind || "feature" === e.kind || "custom" === e.kind ? t.context = l.filter(e.context) : (t.contextKeys = $ac085c90a16a552d$var$Ae(e.context, p), delete t.context), "feature" === e.kind && (delete t.trackEvents, delete t.debugEventsUntilDate), t;
    }
    function D(e) {
        h.length < g ? (h.push(e), b = !1) : (b || (b = !0, p.warn($ac085c90a16a552d$var$ae.eventCapacityExceeded())), r && r.incrementDroppedEvents());
    }
    return a.enqueue = function(e) {
        if (w) return;
        let t = !1, n = !1;
        var r;
        if (d.summarizeEvent(e), "feature" === e.kind ? k() && (t = !!e.trackEvents, n = !!(r = e).debugEventsUntilDate && r.debugEventsUntilDate > y && r.debugEventsUntilDate > (new Date).getTime()) : t = k(), t && D(E(e)), n) {
            const t = $ac085c90a16a552d$var$S.extend({}, e, {
                kind: "debug"
            });
            t.context = l.filter(t.context), delete t.trackEvents, delete t.debugEventsUntilDate, D(t);
        }
    }, a.flush = async function() {
        if (w) return Promise.resolve();
        const e = h;
        return d.getSummaries().forEach((t)=>{
            Object.keys(t.features).length && e.push(t);
        }), r && r.setEventsInLastBatch(e.length), 0 === e.length ? Promise.resolve() : (h = [], p.debug($ac085c90a16a552d$var$ae.debugPostingEvents(e.length)), c.sendEvents(e, u).then((e)=>{
            e && (e.serverTime && (y = e.serverTime), $ac085c90a16a552d$var$s.isHttpErrorRecoverable(e.status) || (w = !0), e.status >= 400 && $ac085c90a16a552d$var$S.onNextTick(()=>{
                o.maybeReportError(new $ac085c90a16a552d$var$s.LDUnexpectedResponseError($ac085c90a16a552d$var$ae.httpErrorMessage(e.status, "event posting", "some events were dropped")));
            }));
        }));
    }, a.start = function() {
        const e = ()=>{
            a.flush(), m = setTimeout(e, v);
        };
        m = setTimeout(e, v);
    }, a.stop = function() {
        clearTimeout(m);
    }, a;
};
var $ac085c90a16a552d$var$Re = function(e) {
    const t = {}, n = {};
    return t.on = function(e, t, r) {
        n[e] = n[e] || [], n[e] = n[e].concat({
            handler: t,
            context: r
        });
    }, t.off = function(e, t, r) {
        if (n[e]) for(let o = 0; o < n[e].length; o++)n[e][o].handler === t && n[e][o].context === r && (n[e] = n[e].slice(0, o).concat(n[e].slice(o + 1)));
    }, t.emit = function(e) {
        if (!n[e]) return;
        const t = n[e].slice(0);
        for(let e = 0; e < t.length; e++)t[e].handler.apply(t[e].context, Array.prototype.slice.call(arguments, 1));
    }, t.getEvents = function() {
        return Object.keys(n);
    }, t.getEventListenerCount = function(e) {
        return n[e] ? n[e].length : 0;
    }, t.maybeReportError = function(t) {
        t && (n["error"] ? this.emit("error", t) : (e || console).error(t.message));
    }, t;
};
const $ac085c90a16a552d$var$Ne = "ready", $ac085c90a16a552d$var$$e = "initialized", $ac085c90a16a552d$var$Ve = "failed";
var $ac085c90a16a552d$var$He = function(e) {
    let t = !1, n = !1, r = null, o = null;
    const i = new Promise((t)=>{
        const n = ()=>{
            e.off($ac085c90a16a552d$var$Ne, n), t();
        };
        e.on($ac085c90a16a552d$var$Ne, n);
    }).catch(()=>{});
    return {
        getInitializationPromise: ()=>o || (t ? Promise.resolve() : n ? Promise.reject(r) : (o = new Promise((t, n)=>{
                const r = ()=>{
                    e.off($ac085c90a16a552d$var$$e, r), t();
                }, o = (t)=>{
                    e.off($ac085c90a16a552d$var$Ve, o), n(t);
                };
                e.on($ac085c90a16a552d$var$$e, r), e.on($ac085c90a16a552d$var$Ve, o);
            }), o)),
        getReadyPromise: ()=>i,
        signalSuccess: ()=>{
            t || n || (t = !0, e.emit($ac085c90a16a552d$var$$e), e.emit($ac085c90a16a552d$var$Ne));
        },
        signalFailure: (o)=>{
            t || n || (n = !0, r = o, e.emit($ac085c90a16a552d$var$Ve, o), e.emit($ac085c90a16a552d$var$Ne)), e.maybeReportError(o);
        }
    };
};
var $ac085c90a16a552d$var$Me = function(e, t, n, r) {
    const o = {};
    function i() {
        let e = "";
        const o = r.getContext();
        return o && (e = n || $ac085c90a16a552d$var$S.btoa(JSON.stringify(o))), "ld:" + t + ":" + e;
    }
    return o.loadFlags = ()=>e.get(i()).then((e)=>{
            if (null == e) return null;
            try {
                let t = JSON.parse(e);
                if (t) {
                    const e = t.$schema;
                    void 0 === e || e < 1 ? t = $ac085c90a16a552d$var$S.transformValuesToVersionedValues(t) : delete t.$schema;
                }
                return t;
            } catch (e) {
                return o.clearFlags().then(()=>null);
            }
        }), o.saveFlags = (t)=>{
        const n = $ac085c90a16a552d$var$S.extend({}, t, {
            $schema: 1
        });
        return e.set(i(), JSON.stringify(n));
    }, o.clearFlags = ()=>e.clear(i()), o;
};
var $ac085c90a16a552d$var$qe = function(e, t) {
    const n = {};
    let r = !1;
    const o = (e)=>{
        r || (r = !0, t.warn($ac085c90a16a552d$var$ae.localStorageUnavailable(e)));
    };
    return n.isEnabled = ()=>!!e, n.get = (t)=>new Promise((n)=>{
            e ? e.get(t).then(n).catch((e)=>{
                o(e), n(void 0);
            }) : n(void 0);
        }), n.set = (t, n)=>new Promise((r)=>{
            e ? e.set(t, n).then(()=>r(!0)).catch((e)=>{
                o(e), r(!1);
            }) : r(!1);
        }), n.clear = (t)=>new Promise((n)=>{
            e ? e.clear(t).then(()=>n(!0)).catch((e)=>{
                o(e), n(!1);
            }) : n(!1);
        }), n;
};
const { appendUrlPath: $ac085c90a16a552d$var$ze, base64URLEncode: $ac085c90a16a552d$var$Ke, objectHasOwnProperty: $ac085c90a16a552d$var$_e } = $ac085c90a16a552d$var$S, { getLDHeaders: $ac085c90a16a552d$var$Je, transformHeaders: $ac085c90a16a552d$var$Be } = $ac085c90a16a552d$var$ve, { isHttpErrorRecoverable: $ac085c90a16a552d$var$We } = $ac085c90a16a552d$var$s;
var $ac085c90a16a552d$var$Ge = function(e, t, n, r) {
    const o = t.streamUrl, i = t.logger, a = {}, s = $ac085c90a16a552d$var$ze(o, "/eval/" + n), c = t.useReport, u = t.evaluationReasons, l = t.streamReconnectDelay, d = $ac085c90a16a552d$var$Je(e, t);
    let f, g = !1, v = null, p = null, m = null, h = null, y = null, w = 0;
    function b() {
        const e = (t = function() {
            const e = l * Math.pow(2, w);
            return e > 3e4 ? 3e4 : e;
        }(), t - Math.trunc(.5 * Math.random() * t));
        var t;
        return w += 1, e;
    }
    function k(e) {
        if (e.status && "number" == typeof e.status && !$ac085c90a16a552d$var$We(e.status)) return x(), i.error($ac085c90a16a552d$var$ae.unrecoverableStreamError(e)), void (p && (clearTimeout(p), p = null));
        const t = b();
        g || (i.warn($ac085c90a16a552d$var$ae.streamError(e, t)), g = !0), O(!1), x(), E(t);
    }
    function E(e) {
        p || (e ? p = setTimeout(D, e) : D());
    }
    function D() {
        let r;
        p = null;
        let a = "";
        const l = {
            headers: d,
            readTimeoutMillis: 3e5
        };
        if (e.eventSourceFactory) {
            null != h && (a = "h=" + h), c ? e.eventSourceAllowsReport ? (r = s, l.method = "REPORT", l.headers["Content-Type"] = "application/json", l.body = JSON.stringify(m)) : (r = $ac085c90a16a552d$var$ze(o, "/ping/" + n), a = "") : r = s + "/" + $ac085c90a16a552d$var$Ke(JSON.stringify(m)), l.headers = $ac085c90a16a552d$var$Be(l.headers, t), u && (a = a + (a ? "&" : "") + "withReasons=true"), r = r + (a ? "?" : "") + a, x(), i.info($ac085c90a16a552d$var$ae.streamConnecting(r)), f = (new Date).getTime(), v = e.eventSourceFactory(r, l);
            for(const e in y)$ac085c90a16a552d$var$_e(y, e) && v.addEventListener(e, y[e]);
            v.onerror = k, v.onopen = ()=>{
                w = 0;
            };
        }
    }
    function x() {
        v && (i.info($ac085c90a16a552d$var$ae.streamClosing()), v.close(), v = null);
    }
    function O(e) {
        f && r && r.recordStreamInit(f, !e, (new Date).getTime() - f), f = null;
    }
    return a.connect = function(e, t, n) {
        m = e, h = t, y = {};
        for(const e in n || {})y[e] = function(t) {
            g = !1, O(!0), n[e] && n[e](t);
        };
        E();
    }, a.disconnect = function() {
        clearTimeout(p), p = null, x();
    }, a.isConnected = function() {
        return !!(v && e.eventSourceIsActive && e.eventSourceIsActive(v));
    }, a;
};
var $ac085c90a16a552d$var$Xe = function(e) {
    let t, n, r, o;
    const i = {
        addPromise: (i, a)=>{
            t = i, n && n(), n = a, i.then((n)=>{
                t === i && (r(n), e && e());
            }, (n)=>{
                t === i && (o(n), e && e());
            });
        }
    };
    return i.resultPromise = new Promise((e, t)=>{
        r = e, o = t;
    }), i;
};
const { transformHeaders: $ac085c90a16a552d$var$Qe, getLDHeaders: $ac085c90a16a552d$var$Ye } = $ac085c90a16a552d$var$ve, $ac085c90a16a552d$var$Ze = "application/json";
var $ac085c90a16a552d$var$et = function(e, t, n) {
    const r = t.baseUrl, o = t.useReport, i = t.evaluationReasons, a = t.logger, c = {}, u = {};
    function l(n, r) {
        if (!e.httpRequest) return new Promise((e, t)=>{
            t(new $ac085c90a16a552d$var$s.LDFlagFetchError($ac085c90a16a552d$var$ae.httpUnavailable()));
        });
        const o = r ? "REPORT" : "GET", i = $ac085c90a16a552d$var$Ye(e, t);
        r && (i["Content-Type"] = $ac085c90a16a552d$var$Ze);
        let a = u[n];
        a || (a = $ac085c90a16a552d$var$Xe(()=>{
            delete u[n];
        }), u[n] = a);
        const c = e.httpRequest(o, n, $ac085c90a16a552d$var$Qe(i, t), r), l = c.promise.then((e)=>{
            if (200 === e.status) {
                if (e.header("content-type") && e.header("content-type").substring(0, 16) === $ac085c90a16a552d$var$Ze) return JSON.parse(e.body);
                {
                    const t = $ac085c90a16a552d$var$ae.invalidContentType(e.header("content-type") || "");
                    return Promise.reject(new $ac085c90a16a552d$var$s.LDFlagFetchError(t));
                }
            }
            return Promise.reject(function(e) {
                return 404 === e.status ? new $ac085c90a16a552d$var$s.LDInvalidEnvironmentIdError($ac085c90a16a552d$var$ae.environmentNotFound()) : new $ac085c90a16a552d$var$s.LDFlagFetchError($ac085c90a16a552d$var$ae.errorFetchingFlags(e.statusText || String(e.status)));
            }(e));
        }, (e)=>Promise.reject(new $ac085c90a16a552d$var$s.LDFlagFetchError($ac085c90a16a552d$var$ae.networkError(e))));
        return a.addPromise(l, ()=>{
            c.cancel && c.cancel();
        }), a.resultPromise;
    }
    return c.fetchJSON = function(e) {
        return l($ac085c90a16a552d$var$S.appendUrlPath(r, e), null);
    }, c.fetchFlagSettings = function(e, t) {
        let s, c, u, d = "";
        return o ? (c = [
            r,
            "/sdk/evalx/",
            n,
            "/context"
        ].join(""), u = JSON.stringify(e)) : (s = $ac085c90a16a552d$var$S.base64URLEncode(JSON.stringify(e)), c = [
            r,
            "/sdk/evalx/",
            n,
            "/contexts/",
            s
        ].join("")), t && (d = "h=" + t), i && (d = d + (d ? "&" : "") + "withReasons=true"), c = c + (d ? "?" : "") + d, a.debug($ac085c90a16a552d$var$ae.debugPolling(c)), l(c, u);
    }, c;
};
var $ac085c90a16a552d$var$tt = function(e, t) {
    const n = {};
    let r;
    return n.setContext = function(e) {
        r = $ac085c90a16a552d$var$S.sanitizeContext(e), r && t && t($ac085c90a16a552d$var$S.clone(r));
    }, n.getContext = function() {
        return r ? $ac085c90a16a552d$var$S.clone(r) : null;
    }, e && n.setContext(e), n;
};
const { v1: $ac085c90a16a552d$var$nt } = $ac085c90a16a552d$var$te, { getContextKinds: $ac085c90a16a552d$var$rt } = $ac085c90a16a552d$var$De;
var $ac085c90a16a552d$var$ot = function(e) {
    function t(e) {
        return null == e || "user" === e ? "ld:$anonUserId" : `ld:$contextKey:${e}`;
    }
    function n(n, r) {
        return null !== r.key && void 0 !== r.key ? (r.key = r.key.toString(), Promise.resolve(r)) : r.anonymous ? (function(n) {
            return e.get(t(n));
        })(n).then((o)=>{
            if (o) return r.key = o, r;
            {
                const o = $ac085c90a16a552d$var$nt();
                return r.key = o, (function(n, r) {
                    return e.set(t(r), n);
                })(o, n).then(()=>r);
            }
        }) : Promise.reject(new $ac085c90a16a552d$var$s.LDInvalidUserError($ac085c90a16a552d$var$ae.invalidContext()));
    }
    this.processContext = (e)=>{
        if (!e) return Promise.reject(new $ac085c90a16a552d$var$s.LDInvalidUserError($ac085c90a16a552d$var$ae.contextNotSpecified()));
        const t = $ac085c90a16a552d$var$S.clone(e);
        if ("multi" === e.kind) {
            const e = $ac085c90a16a552d$var$rt(t);
            return Promise.all(e.map((e)=>n(e, t[e]))).then(()=>t);
        }
        return n(e.kind, t);
    };
};
const { v1: $ac085c90a16a552d$var$it } = $ac085c90a16a552d$var$te, { baseOptionDefs: $ac085c90a16a552d$var$at } = $ac085c90a16a552d$var$fe, { appendUrlPath: $ac085c90a16a552d$var$st } = $ac085c90a16a552d$var$S;
var $ac085c90a16a552d$var$ct = {
    DiagnosticId: function(e) {
        const t = {
            diagnosticId: $ac085c90a16a552d$var$it()
        };
        return e && (t.sdkKeySuffix = e.length > 6 ? e.substring(e.length - 6) : e), t;
    },
    DiagnosticsAccumulator: function(e) {
        let t, n, r, o;
        function i(e) {
            t = e, n = 0, r = 0, o = [];
        }
        return i(e), {
            getProps: ()=>({
                    dataSinceDate: t,
                    droppedEvents: n,
                    eventsInLastBatch: r,
                    streamInits: o
                }),
            setProps: (e)=>{
                t = e.dataSinceDate, n = e.droppedEvents || 0, r = e.eventsInLastBatch || 0, o = e.streamInits || [];
            },
            incrementDroppedEvents: ()=>{
                n++;
            },
            setEventsInLastBatch: (e)=>{
                r = e;
            },
            recordStreamInit: (e, t, n)=>{
                const r = {
                    timestamp: e,
                    failed: t,
                    durationMillis: n
                };
                o.push(r);
            },
            reset: i
        };
    },
    DiagnosticsManager: function(e, t, n, r, o, i, a) {
        const s = !!e.diagnosticUseCombinedEvent, c = "ld:" + o + ":$diagnostics", u = $ac085c90a16a552d$var$st(i.eventsUrl, "/events/diagnostic/" + o), l = i.diagnosticRecordingInterval, d = n;
        let f, g, v = !!i.streaming;
        const p = {};
        function m() {
            return {
                sdk: w(),
                configuration: b(),
                platform: e.diagnosticPlatformData
            };
        }
        function h(e) {
            i.logger && i.logger.debug($ac085c90a16a552d$var$ae.debugPostingDiagnosticEvent(e)), r.sendEvents(e, u, !0).then(()=>{}).catch(()=>{});
        }
        function y() {
            h(function() {
                const e = (new Date).getTime();
                let t = {
                    kind: s ? "diagnostic-combined" : "diagnostic",
                    id: a,
                    creationDate: e,
                    ...d.getProps()
                };
                return s && (t = {
                    ...t,
                    ...m()
                }), d.reset(e), t;
            }()), g = setTimeout(y, l), f = (new Date).getTime(), s && function() {
                if (t.isEnabled()) {
                    const e = {
                        ...d.getProps()
                    };
                    t.set(c, JSON.stringify(e));
                }
            }();
        }
        function w() {
            const t = {
                ...e.diagnosticSdkData
            };
            return i.wrapperName && (t.wrapperName = i.wrapperName), i.wrapperVersion && (t.wrapperVersion = i.wrapperVersion), t;
        }
        function b() {
            return {
                customBaseURI: i.baseUrl !== $ac085c90a16a552d$var$at.baseUrl.default,
                customStreamURI: i.streamUrl !== $ac085c90a16a552d$var$at.streamUrl.default,
                customEventsURI: i.eventsUrl !== $ac085c90a16a552d$var$at.eventsUrl.default,
                eventsCapacity: i.eventCapacity,
                eventsFlushIntervalMillis: i.flushInterval,
                reconnectTimeMillis: i.streamReconnectDelay,
                streamingDisabled: !v,
                allAttributesPrivate: !!i.allAttributesPrivate,
                diagnosticRecordingIntervalMillis: i.diagnosticRecordingInterval,
                usingSecureMode: !!i.hash,
                bootstrapMode: !!i.bootstrap,
                fetchGoalsDisabled: !i.fetchGoals,
                sendEventsOnlyForVariation: !!i.sendEventsOnlyForVariation
            };
        }
        return p.start = ()=>{
            s ? function(e) {
                if (!t.isEnabled()) return e(!1);
                t.get(c).then((t)=>{
                    if (t) try {
                        const e = JSON.parse(t);
                        d.setProps(e), f = e.dataSinceDate;
                    } catch (e) {}
                    e(!0);
                }).catch(()=>{
                    e(!1);
                });
            }((e)=>{
                if (e) {
                    const e = (f || 0) + l, t = (new Date).getTime();
                    t >= e ? y() : g = setTimeout(y, e - t);
                } else 0 === Math.floor(4 * Math.random()) ? y() : g = setTimeout(y, l);
            }) : (h({
                kind: "diagnostic-init",
                id: a,
                creationDate: d.getProps().dataSinceDate,
                ...m()
            }), g = setTimeout(y, l));
        }, p.stop = ()=>{
            g && clearTimeout(g);
        }, p.setStreaming = (e)=>{
            v = e;
        }, p;
    }
};
var $ac085c90a16a552d$var$ut = function(e, t) {
    let n = !1;
    const r = {
        type: e.type,
        name: e.name,
        synchronous: e.synchronous,
        method: (...o)=>{
            try {
                e.method(...o);
            } catch  {
                n || (n = !0, t.warn($ac085c90a16a552d$var$ae.inspectorMethodError(r.type, r.name)));
            }
        }
    };
    return r;
};
const { onNextTick: $ac085c90a16a552d$var$lt } = $ac085c90a16a552d$var$S, $ac085c90a16a552d$var$dt = {
    flagUsed: "flag-used",
    flagDetailsChanged: "flag-details-changed",
    flagDetailChanged: "flag-detail-changed",
    clientIdentityChanged: "client-identity-changed"
};
Object.freeze($ac085c90a16a552d$var$dt);
var $ac085c90a16a552d$var$ft = {
    InspectorTypes: $ac085c90a16a552d$var$dt,
    InspectorManager: function(e, t) {
        const n = {}, r = {
            [$ac085c90a16a552d$var$dt.flagUsed]: [],
            [$ac085c90a16a552d$var$dt.flagDetailsChanged]: [],
            [$ac085c90a16a552d$var$dt.flagDetailChanged]: [],
            [$ac085c90a16a552d$var$dt.clientIdentityChanged]: []
        }, o = {
            [$ac085c90a16a552d$var$dt.flagUsed]: [],
            [$ac085c90a16a552d$var$dt.flagDetailsChanged]: [],
            [$ac085c90a16a552d$var$dt.flagDetailChanged]: [],
            [$ac085c90a16a552d$var$dt.clientIdentityChanged]: []
        }, i = e && e.map((e)=>$ac085c90a16a552d$var$ut(e, t));
        return i && i.forEach((e)=>{
            Object.prototype.hasOwnProperty.call(r, e.type) && !e.synchronous ? r[e.type].push(e) : Object.prototype.hasOwnProperty.call(o, e.type) && e.synchronous ? o[e.type].push(e) : t.warn($ac085c90a16a552d$var$ae.invalidInspector(e.type, e.name));
        }), n.hasListeners = (e)=>r[e] && r[e].length || o[e] && o[e].length, n.onFlagUsed = (e, t, n)=>{
            const i = $ac085c90a16a552d$var$dt.flagUsed;
            o[i].length && o[i].forEach((r)=>r.method(e, t, n)), r[i].length && $ac085c90a16a552d$var$lt(()=>{
                r[i].forEach((r)=>r.method(e, t, n));
            });
        }, n.onFlags = (e)=>{
            const t = $ac085c90a16a552d$var$dt.flagDetailsChanged;
            o[t].length && o[t].forEach((t)=>t.method(e)), r[t].length && $ac085c90a16a552d$var$lt(()=>{
                r[t].forEach((t)=>t.method(e));
            });
        }, n.onFlagChanged = (e, t)=>{
            const n = $ac085c90a16a552d$var$dt.flagDetailChanged;
            o[n].length && o[n].forEach((n)=>n.method(e, t)), r[n].length && $ac085c90a16a552d$var$lt(()=>{
                r[n].forEach((n)=>n.method(e, t));
            });
        }, n.onIdentityChanged = (e)=>{
            const t = $ac085c90a16a552d$var$dt.clientIdentityChanged;
            o[t].length && o[t].forEach((t)=>t.method(e)), r[t].length && $ac085c90a16a552d$var$lt(()=>{
                r[t].forEach((t)=>t.method(e));
            });
        }, n;
    }
};
const { LDTimeoutError: $ac085c90a16a552d$var$gt } = $ac085c90a16a552d$var$s;
var $ac085c90a16a552d$var$vt = function(e, t) {
    return new Promise((n, r)=>{
        setTimeout(()=>{
            r(new $ac085c90a16a552d$var$gt(`${t} timed out after ${e} seconds.`));
        }, 1e3 * e);
    });
};
const $ac085c90a16a552d$var$pt = "unknown hook";
function $ac085c90a16a552d$var$mt(e, t, n, r, o) {
    try {
        return r();
    } catch (r) {
        return e?.error(`An error was encountered in "${t}" of the "${n}" hook: ${r}`), o;
    }
}
function $ac085c90a16a552d$var$ht(e, t) {
    try {
        return t.getMetadata().name || $ac085c90a16a552d$var$pt;
    } catch  {
        return e.error("Exception thrown getting metadata for hook. Unable to get hook name."), $ac085c90a16a552d$var$pt;
    }
}
var $ac085c90a16a552d$var$yt = function(e, t) {
    const n = t ? [
        ...t
    ] : [];
    return {
        withEvaluation: function(t, r, o, i) {
            if (0 === n.length) return i();
            const a = [
                ...n
            ], s = {
                flagKey: t,
                context: r,
                defaultValue: o
            }, c = function(e, t, n) {
                return t.map((t)=>$ac085c90a16a552d$var$mt(e, "beforeEvaluation", $ac085c90a16a552d$var$ht(e, t), ()=>t?.beforeEvaluation?.(n, {}) ?? {}, {}));
            }(e, a, s), u = i();
            return function(e, t, n, r, o) {
                for(let i = t.length - 1; i >= 0; i -= 1){
                    const a = t[i], s = r[i];
                    $ac085c90a16a552d$var$mt(e, "afterEvaluation", $ac085c90a16a552d$var$ht(e, a), ()=>a?.afterEvaluation?.(n, s, o) ?? {}, {});
                }
            }(e, a, s, c, u), u;
        },
        identify: function(t, r) {
            const o = [
                ...n
            ], i = {
                context: t,
                timeout: r
            }, a = function(e, t, n) {
                return t.map((t)=>$ac085c90a16a552d$var$mt(e, "beforeIdentify", $ac085c90a16a552d$var$ht(e, t), ()=>t?.beforeIdentify?.(n, {}) ?? {}, {}));
            }(e, o, i);
            return (t)=>{
                !function(e, t, n, r, o) {
                    for(let i = t.length - 1; i >= 0; i -= 1){
                        const a = t[i], s = r[i];
                        $ac085c90a16a552d$var$mt(e, "afterIdentify", $ac085c90a16a552d$var$ht(e, a), ()=>a?.afterIdentify?.(n, s, o) ?? {}, {});
                    }
                }(e, o, i, a, t);
            };
        },
        addHook: function(e) {
            n.push(e);
        },
        afterTrack: function(t) {
            if (0 === n.length) return;
            const r = [
                ...n
            ];
            !function(e, t, n) {
                for(let r = t.length - 1; r >= 0; r -= 1){
                    const o = t[r];
                    $ac085c90a16a552d$var$mt(e, "afterTrack", $ac085c90a16a552d$var$ht(e, o), ()=>o?.afterTrack?.(n), void 0);
                }
            }(e, r, t);
        }
    };
};
var $ac085c90a16a552d$var$wt = function() {
    let e, t = {};
    function n(n) {
        return e && $ac085c90a16a552d$var$S.objectHasOwnProperty(e, n) && e[n] ? e[n] : t && $ac085c90a16a552d$var$S.objectHasOwnProperty(t, n) && t[n] && !t[n].deleted ? t[n] : null;
    }
    return {
        clearAllOverrides: function() {
            if (!e) return {};
            const t = {
                ...e
            };
            return e = void 0, t;
        },
        get: n,
        getFlagOverrides: function() {
            return e || {};
        },
        getFlags: function() {
            return t;
        },
        getFlagsWithOverrides: function() {
            const r = {};
            for(const e in t){
                const t = n(e);
                t && (r[e] = t);
            }
            if (e) for(const t in e){
                const e = n(t);
                e && (r[t] = e);
            }
            return r;
        },
        removeOverride: function(t) {
            e && e[t] && (delete e[t], 0 === Object.keys(e).length && (e = void 0));
        },
        setFlags: function(e) {
            t = {
                ...e
            };
        },
        setOverride: function(t, n) {
            e || (e = {}), e[t] = {
                value: n
            };
        }
    };
};
const $ac085c90a16a552d$var$bt = "unknown plugin";
function $ac085c90a16a552d$var$kt(e, t) {
    try {
        return t.getMetadata().name || $ac085c90a16a552d$var$bt;
    } catch (t) {
        return e.error("Exception thrown getting metadata for plugin. Unable to get plugin name."), $ac085c90a16a552d$var$bt;
    }
}
var $ac085c90a16a552d$var$Et = {
    getPluginHooks: function(e, t, n) {
        const r = [];
        return n.forEach((n)=>{
            try {
                const o = n.getHooks?.(t);
                void 0 === o ? e.error(`Plugin ${$ac085c90a16a552d$var$kt(e, n)} returned undefined from getHooks.`) : o && o.length > 0 && r.push(...o);
            } catch (t) {
                e.error(`Exception thrown getting hooks for plugin ${$ac085c90a16a552d$var$kt(e, n)}. Unable to get hooks.`);
            }
        }), r;
    },
    registerPlugins: function(e, t, n, r) {
        r.forEach((r)=>{
            try {
                r.register(n, t);
            } catch (t) {
                e.error(`Exception thrown registering plugin ${$ac085c90a16a552d$var$kt(e, r)}.`);
            }
        });
    },
    registerPluginsForDebugOverride: function(e, t, n) {
        n.forEach((n)=>{
            try {
                n.registerDebug?.(t);
            } catch (t) {
                e.error(`Exception thrown registering debug override with plugin ${$ac085c90a16a552d$var$kt(e, n)}.`);
            }
        });
    },
    createPluginEnvironment: function(e, t, n) {
        const r = {};
        e.userAgent && (r.name = e.userAgent), e.version && (r.version = e.version), n.wrapperName && (r.wrapperName = n.wrapperName), n.wrapperVersion && (r.wrapperVersion = n.wrapperVersion);
        const o = {};
        n.application && (n.application.name && (o.name = n.application.name), n.application.version && (o.version = n.application.version));
        const i = {
            sdk: r,
            clientSideId: t
        };
        return Object.keys(o).length > 0 && (i.application = o), i;
    }
};
const { commonBasicLogger: $ac085c90a16a552d$var$Dt } = $ac085c90a16a552d$var$re, { checkContext: $ac085c90a16a552d$var$xt, getContextKeys: $ac085c90a16a552d$var$Ot } = $ac085c90a16a552d$var$De, { InspectorTypes: $ac085c90a16a552d$var$Ct, InspectorManager: $ac085c90a16a552d$var$Pt } = $ac085c90a16a552d$var$ft, { getPluginHooks: $ac085c90a16a552d$var$St, registerPlugins: $ac085c90a16a552d$var$It, registerPluginsForDebugOverride: $ac085c90a16a552d$var$Tt, createPluginEnvironment: $ac085c90a16a552d$var$Ft } = $ac085c90a16a552d$var$Et, $ac085c90a16a552d$var$Lt = "change", $ac085c90a16a552d$var$Ut = "internal-change";
var $ac085c90a16a552d$var$At = {
    initialize: function(e, t, n, r, o) {
        const i = function() {
            if (n && n.logger) return n.logger;
            return o && o.logger && o.logger.default || $ac085c90a16a552d$var$Dt("warn");
        }(), a = $ac085c90a16a552d$var$Re(i), c = $ac085c90a16a552d$var$He(a), u = $ac085c90a16a552d$var$fe.validate(n, a, o, i), l = $ac085c90a16a552d$var$Pt(u.inspectors, i), d = u.sendEvents;
        let f = e, g = u.hash;
        const v = [
            ...u.plugins
        ], p = $ac085c90a16a552d$var$Ft(r, e, u), m = $ac085c90a16a552d$var$St(i, p, v), h = $ac085c90a16a552d$var$yt(i, [
            ...u.hooks,
            ...m
        ]), y = $ac085c90a16a552d$var$qe(r.localStorage, i), w = $ac085c90a16a552d$var$ye(r, f, u), b = u.sendEvents && !u.diagnosticOptOut, k = b ? $ac085c90a16a552d$var$ct.DiagnosticId(f) : null, E = b ? $ac085c90a16a552d$var$ct.DiagnosticsAccumulator((new Date).getTime()) : null, D = b ? $ac085c90a16a552d$var$ct.DiagnosticsManager(r, y, E, w, f, u, k) : null, x = $ac085c90a16a552d$var$Ge(r, u, f, E), O = u.eventProcessor || $ac085c90a16a552d$var$je(r, u, f, E, a, w), C = $ac085c90a16a552d$var$et(r, u, f), P = $ac085c90a16a552d$var$wt();
        let I, T, F, L = u.streaming, U = !1, A = !1, j = !0;
        const R = u.stateProvider, N = $ac085c90a16a552d$var$tt(null, function(e) {
            (function(e) {
                if (R) return;
                e && H({
                    kind: "identify",
                    context: e,
                    creationDate: (new Date).getTime()
                });
            })(e), l.hasListeners($ac085c90a16a552d$var$Ct.clientIdentityChanged) && l.onIdentityChanged(N.getContext());
        }), $ = new $ac085c90a16a552d$var$ot(y), V = y.isEnabled() ? $ac085c90a16a552d$var$Me(y, f, g, N) : null;
        function H(e) {
            f && (R && R.enqueueEvent && R.enqueueEvent(e) || (e.context ? (j = !1, !d || A || r.isDoNotTrack() || (i.debug($ac085c90a16a552d$var$ae.debugEnqueueingEvent(e.kind)), O.enqueue(e))) : j && (i.warn($ac085c90a16a552d$var$ae.eventWithoutContext()), j = !1)));
        }
        function M(e, t) {
            l.hasListeners($ac085c90a16a552d$var$Ct.flagDetailChanged) && l.onFlagChanged(e.key, J(t));
        }
        function q() {
            l.hasListeners($ac085c90a16a552d$var$Ct.flagDetailsChanged) && l.onFlags(Object.entries(P.getFlagsWithOverrides()).map(([e, t])=>({
                    key: e,
                    detail: J(t)
                })).reduce((e, t)=>(e[t.key] = t.detail, e), {}));
        }
        function z(e, t, n, r) {
            const o = N.getContext(), i = new Date, a = {
                kind: "feature",
                key: e,
                context: o,
                value: t ? t.value : null,
                variation: t ? t.variationIndex : null,
                default: n,
                creationDate: i.getTime()
            }, s = P.getFlags()[e];
            s && (a.version = s.flagVersion ? s.flagVersion : s.version, a.trackEvents = s.trackEvents, a.debugEventsUntilDate = s.debugEventsUntilDate), (r || s && s.trackReason) && t && (a.reason = t.reason), H(a);
        }
        function K(e) {
            return $ac085c90a16a552d$var$xt(e, !1) ? Promise.resolve(e) : Promise.reject(new $ac085c90a16a552d$var$s.LDInvalidUserError($ac085c90a16a552d$var$ae.invalidContext()));
        }
        function _(e, t, n, r, o, i) {
            let a;
            const s = P.get(e);
            return s ? (a = J(s), null !== s.value && void 0 !== s.value || (a.value = t)) : a = {
                value: t,
                variationIndex: null,
                reason: {
                    kind: "ERROR",
                    errorKind: "FLAG_NOT_FOUND"
                }
            }, n && (o || s?.prerequisites?.forEach((e)=>{
                _(e, void 0, n, !1, !1, !1);
            }), z(e, a, t, r)), !o && i && function(e, t) {
                l.hasListeners($ac085c90a16a552d$var$Ct.flagUsed) && l.onFlagUsed(e, t, N.getContext());
            }(e, a), a;
        }
        function J(e) {
            return {
                value: e.value,
                variationIndex: void 0 === e.variation ? null : e.variation,
                reason: e.reason || null
            };
        }
        function B() {
            if (T = !0, !N.getContext()) return;
            const e = (e)=>{
                try {
                    return JSON.parse(e);
                } catch (e) {
                    return void a.maybeReportError(new $ac085c90a16a552d$var$s.LDInvalidDataError($ac085c90a16a552d$var$ae.invalidData()));
                }
            };
            x.connect(N.getContext(), g, {
                ping: function() {
                    i.debug($ac085c90a16a552d$var$ae.debugStreamPing());
                    const e = N.getContext();
                    C.fetchFlagSettings(e, g).then((t)=>{
                        $ac085c90a16a552d$var$S.deepEquals(e, N.getContext()) && G(t || {});
                    }).catch((e)=>{
                        a.maybeReportError(new $ac085c90a16a552d$var$s.LDFlagFetchError($ac085c90a16a552d$var$ae.errorFetchingFlags(e)));
                    });
                },
                put: function(t) {
                    const n = e(t.data);
                    n && (i.debug($ac085c90a16a552d$var$ae.debugStreamPut()), G(n));
                },
                patch: function(t) {
                    const n = e(t.data);
                    if (!n) return;
                    const r = P.getFlags(), o = r[n.key];
                    if (!o || !o.version || !n.version || o.version < n.version) {
                        i.debug($ac085c90a16a552d$var$ae.debugStreamPatch(n.key));
                        const e = {}, t = $ac085c90a16a552d$var$S.extend({}, n);
                        delete t.key, r[n.key] = t, P.setFlags(r);
                        const a = J(t);
                        e[n.key] = o ? {
                            previous: o.value,
                            current: a
                        } : {
                            current: a
                        }, M(n, t), X(e);
                    } else i.debug($ac085c90a16a552d$var$ae.debugStreamPatchIgnored(n.key));
                },
                delete: function(t) {
                    const n = e(t.data);
                    if (!n) return;
                    const r = P.getFlags();
                    if (!r[n.key] || r[n.key].version < n.version) {
                        i.debug($ac085c90a16a552d$var$ae.debugStreamDelete(n.key));
                        const e = {};
                        r[n.key] && !r[n.key].deleted && (e[n.key] = {
                            previous: r[n.key].value
                        }), r[n.key] = {
                            version: n.version,
                            deleted: !0
                        }, P.setFlags(r), M(n, r[n.key]), X(e);
                    } else i.debug($ac085c90a16a552d$var$ae.debugStreamDeleteIgnored(n.key));
                }
            });
        }
        function W() {
            T && (x.disconnect(), T = !1);
        }
        function G(e) {
            const t = {};
            if (!e) return Promise.resolve();
            const n = P.getFlags();
            for(const r in n)$ac085c90a16a552d$var$S.objectHasOwnProperty(n, r) && n[r] && (e[r] && !$ac085c90a16a552d$var$S.deepEquals(e[r].value, n[r].value) ? t[r] = {
                previous: n[r].value,
                current: J(e[r])
            } : e[r] && !e[r].deleted || (t[r] = {
                previous: n[r].value
            }));
            for(const r in e)$ac085c90a16a552d$var$S.objectHasOwnProperty(e, r) && e[r] && (!n[r] || n[r].deleted) && (t[r] = {
                current: J(e[r])
            });
            return P.setFlags({
                ...e
            }), q(), X(t).catch(()=>{});
        }
        function X(e) {
            const t = Object.keys(e);
            if (t.length > 0) {
                const n = {};
                t.forEach((t)=>{
                    const r = e[t].current, o = r ? r.value : void 0, i = e[t].previous;
                    a.emit($ac085c90a16a552d$var$Lt + ":" + t, o, i), n[t] = r ? {
                        current: o,
                        previous: i
                    } : {
                        previous: i
                    };
                }), a.emit($ac085c90a16a552d$var$Lt, n), a.emit($ac085c90a16a552d$var$Ut, P.getFlagsWithOverrides()), u.sendEventsOnlyForVariation || R || t.forEach((t)=>{
                    z(t, e[t].current);
                });
            }
            return I && V ? V.saveFlags(P.getFlags()) : Promise.resolve();
        }
        function Q() {
            const e = L || F && void 0 === L;
            e && !T ? B() : !e && T && W(), D && D.setStreaming(e);
        }
        function Y(e) {
            return e === $ac085c90a16a552d$var$Lt || e.substr(0, 7) === $ac085c90a16a552d$var$Lt + ":";
        }
        if ("string" == typeof u.bootstrap && "LOCALSTORAGE" === u.bootstrap.toUpperCase() && (V ? I = !0 : i.warn($ac085c90a16a552d$var$ae.localStorageUnavailable())), "object" == typeof u.bootstrap && P.setFlags(function(e) {
            const t = Object.keys(e), n = "$flagsState", r = "$valid", o = e[n];
            !o && t.length && i.warn($ac085c90a16a552d$var$ae.bootstrapOldFormat()), !1 === e[r] && i.warn($ac085c90a16a552d$var$ae.bootstrapInvalid());
            const a = {};
            return t.forEach((t)=>{
                if (t !== n && t !== r) {
                    let n = {
                        value: e[t]
                    };
                    o && o[t] ? n = $ac085c90a16a552d$var$S.extend(n, o[t]) : n.version = 0, a[t] = n;
                }
            }), a;
        }(u.bootstrap)), R) {
            const e = R.getInitialState();
            e ? Z(e) : R.on("init", Z), R.on("update", function(e) {
                e.context && N.setContext(e.context);
                e.flags && G(e.flags);
            });
        } else (function() {
            if (!e) return Promise.reject(new $ac085c90a16a552d$var$s.LDInvalidEnvironmentIdError($ac085c90a16a552d$var$ae.environmentNotSpecified()));
            let n;
            return $.processContext(t).then(K).then((e)=>(n = $ac085c90a16a552d$var$S.once(h.identify(e, void 0)), e)).then((e)=>(n?.({
                    status: "completed"
                }), N.setContext(e), "object" == typeof u.bootstrap ? ee() : I ? V.loadFlags().then((e)=>null == e ? (P.setFlags({}), C.fetchFlagSettings(N.getContext(), g).then((e)=>G(e || {})).then(ee).catch((e)=>{
                        te(new $ac085c90a16a552d$var$s.LDFlagFetchError($ac085c90a16a552d$var$ae.errorFetchingFlags(e)));
                    })) : (P.setFlags(e), $ac085c90a16a552d$var$S.onNextTick(ee), C.fetchFlagSettings(N.getContext(), g).then((e)=>G(e)).catch((e)=>a.maybeReportError(e)))) : C.fetchFlagSettings(N.getContext(), g).then((e)=>{
                    P.setFlags(e || {}), q(), ee();
                }).catch((e)=>{
                    P.setFlags({}), te(e);
                }))).catch((e)=>{
                throw n?.({
                    status: "error"
                }), e;
            });
        })().catch(te);
        function Z(e) {
            f = e.environment, N.setContext(e.context), P.setFlags({
                ...e.flags
            }), $ac085c90a16a552d$var$S.onNextTick(ee);
        }
        function ee() {
            i.info($ac085c90a16a552d$var$ae.clientInitialized()), U = !0, Q(), c.signalSuccess();
        }
        function te(e) {
            c.signalFailure(e);
        }
        const ne = {
            waitForInitialization: function(e) {
                if (null != e) {
                    if ("number" == typeof e) return function(e) {
                        e > 5 && i.warn("The waitForInitialization function was called with a timeout greater than 5 seconds. We recommend a timeout of 5 seconds or less.");
                        const t = c.getInitializationPromise(), n = $ac085c90a16a552d$var$vt(e, "waitForInitialization");
                        return Promise.race([
                            n,
                            t
                        ]).catch((e)=>{
                            throw e instanceof $ac085c90a16a552d$var$s.LDTimeoutError && i.error(`waitForInitialization error: ${e}`), e;
                        });
                    }(e);
                    i.warn("The waitForInitialization method was provided with a non-numeric timeout.");
                }
                return i.warn("The waitForInitialization function was called without a timeout specified. In a future version a default timeout will be applied."), c.getInitializationPromise();
            },
            waitUntilReady: ()=>c.getReadyPromise(),
            identify: function(e, t, n) {
                if (A) return $ac085c90a16a552d$var$S.wrapPromiseCallback(Promise.resolve({}), n);
                if (R) return i.warn($ac085c90a16a552d$var$ae.identifyDisabled()), $ac085c90a16a552d$var$S.wrapPromiseCallback(Promise.resolve($ac085c90a16a552d$var$S.transformVersionedValuesToValues(P.getFlagsWithOverrides())), n);
                let r;
                const o = I && V ? V.clearFlags() : Promise.resolve();
                return $ac085c90a16a552d$var$S.wrapPromiseCallback(o.then(()=>$.processContext(e)).then(K).then((e)=>(r = $ac085c90a16a552d$var$S.once(h.identify(e, void 0)), e)).then((e)=>C.fetchFlagSettings(e, t).then((n)=>{
                        const r = $ac085c90a16a552d$var$S.transformVersionedValuesToValues(n);
                        return N.setContext(e), g = t, n ? G(n).then(()=>r) : r;
                    })).then((e)=>(r?.({
                        status: "completed"
                    }), T && B(), e)).catch((e)=>(r?.({
                        status: "error"
                    }), a.maybeReportError(e), Promise.reject(e))), n);
            },
            getContext: function() {
                return N.getContext();
            },
            variation: function(e, t) {
                const { value: n } = h.withEvaluation(e, N.getContext(), t, ()=>_(e, t, !0, !1, !1, !0));
                return n;
            },
            variationDetail: function(e, t) {
                return h.withEvaluation(e, N.getContext(), t, ()=>_(e, t, !0, !0, !1, !0));
            },
            track: function(e, t, n) {
                if ("string" != typeof e) return void a.maybeReportError(new $ac085c90a16a552d$var$s.LDInvalidEventKeyError($ac085c90a16a552d$var$ae.unknownCustomEventKey(e)));
                void 0 !== n && "number" != typeof n && i.warn($ac085c90a16a552d$var$ae.invalidMetricValue(typeof n)), r.customEventFilter && !r.customEventFilter(e) && i.warn($ac085c90a16a552d$var$ae.unknownCustomEventKey(e));
                const o = N.getContext(), c = {
                    kind: "custom",
                    key: e,
                    context: o,
                    url: r.getCurrentUrl(),
                    creationDate: (new Date).getTime()
                };
                o && o.anonymous && (c.contextKind = o.anonymous ? "anonymousUser" : "user"), null != t && (c.data = t), null != n && (c.metricValue = n), H(c), h.afterTrack({
                    context: o,
                    key: e,
                    data: t,
                    metricValue: n
                });
            },
            on: function(e, t, n) {
                Y(e) ? (F = !0, U && Q(), a.on(e, t, n)) : a.on(...arguments);
            },
            off: function(e) {
                if (a.off(...arguments), Y(e)) {
                    let e = !1;
                    a.getEvents().forEach((t)=>{
                        Y(t) && a.getEventListenerCount(t) > 0 && (e = !0);
                    }), e || (F = !1, T && void 0 === L && W());
                }
            },
            setStreaming: function(e) {
                const t = null === e ? void 0 : e;
                t !== L && (L = t, Q());
            },
            flush: function(e) {
                return $ac085c90a16a552d$var$S.wrapPromiseCallback(d ? O.flush() : Promise.resolve(), e);
            },
            allFlags: function() {
                const e = {}, t = P.getFlagsWithOverrides();
                if (!t) return e;
                for(const n in t)e[n] = _(n, null, !u.sendEventsOnlyForVariation, !1, !0, !1).value;
                return e;
            },
            close: function(e) {
                if (A) return $ac085c90a16a552d$var$S.wrapPromiseCallback(Promise.resolve(), e);
                const t = ()=>{
                    A = !0, P.setFlags({});
                }, n = Promise.resolve().then(()=>{
                    if (W(), D && D.stop(), d) return O.stop(), O.flush();
                }).then(t).catch(t);
                return $ac085c90a16a552d$var$S.wrapPromiseCallback(n, e);
            },
            addHook: function(e) {
                h.addHook(e);
            }
        };
        $ac085c90a16a552d$var$It(i, p, ne, v);
        const re = {
            setOverride: function(e, t) {
                const n = {}, r = P.get(e), o = r ? r.value : null;
                if (o === t) return void i.debug(`setOverride: No change needed for ${e}, value already ${t}`);
                P.setOverride(e, t);
                const a = P.get(e), s = J(a);
                n[e] = {
                    previous: o,
                    current: s
                }, M({
                    key: e
                }, a), X(n);
            },
            removeOverride: function(e) {
                const t = P.getFlagOverrides();
                if (!t[e]) return;
                const n = {}, r = t[e], o = P.getFlags()[e];
                n[e] = {
                    previous: r.value,
                    current: o ? J(o) : void 0
                }, P.removeOverride(e), M({
                    key: e
                }, o), X(n);
            },
            clearAllOverrides: function() {
                const e = P.getFlagOverrides();
                if (0 === Object.keys(e).length) return;
                const t = {}, n = P.getFlags();
                Object.keys(e).forEach((r)=>{
                    const o = e[r], i = n[r];
                    t[r] = {
                        previous: o.value,
                        current: i ? J(i) : void 0
                    };
                }), P.clearAllOverrides(), Object.keys(t).length > 0 && X(t);
            },
            getAllOverrides: function() {
                const e = P.getFlagOverrides();
                if (!e) return {};
                const t = {};
                return Object.keys(e).forEach((n)=>{
                    const r = e[n];
                    r && (t[n] = r.value);
                }), t;
            }
        };
        return $ac085c90a16a552d$var$Tt(i, re, v), {
            client: ne,
            options: u,
            emitter: a,
            ident: N,
            logger: i,
            requestor: C,
            start: function() {
                d && (D && D.start(), O.start());
            },
            enqueueEvent: H,
            getFlagsInternal: function() {
                return P.getFlagsWithOverrides();
            },
            getEnvironmentId: ()=>f,
            internalChangeEventName: $ac085c90a16a552d$var$Ut
        };
    },
    commonBasicLogger: $ac085c90a16a552d$var$Dt,
    errors: $ac085c90a16a552d$var$s,
    messages: $ac085c90a16a552d$var$ae,
    utils: $ac085c90a16a552d$var$S,
    getContextKeys: $ac085c90a16a552d$var$Ot
}, $ac085c90a16a552d$var$jt = $ac085c90a16a552d$var$At.initialize, $ac085c90a16a552d$var$Rt = $ac085c90a16a552d$var$At.errors, $ac085c90a16a552d$var$Nt = $ac085c90a16a552d$var$At.messages;
function $ac085c90a16a552d$var$$t(e, t, n) {
    return (t = function(e) {
        var t = function(e, t) {
            if ("object" != typeof e || !e) return e;
            var n = e[Symbol.toPrimitive];
            if (void 0 !== n) {
                var r = n.call(e, t || "default");
                if ("object" != typeof r) return r;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" == typeof t ? t : t + "";
    }(t)) in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
function $ac085c90a16a552d$var$Vt(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function(t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
    }
    return n;
}
function $ac085c90a16a552d$var$Ht(e) {
    for(var t = 1; t < arguments.length; t++){
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? $ac085c90a16a552d$var$Vt(Object(n), !0).forEach(function(t) {
            $ac085c90a16a552d$var$$t(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $ac085c90a16a552d$var$Vt(Object(n)).forEach(function(t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
    }
    return e;
}
var $ac085c90a16a552d$var$Mt = $ac085c90a16a552d$var$At.commonBasicLogger;
var $ac085c90a16a552d$var$qt = function(e) {
    return $ac085c90a16a552d$var$Mt($ac085c90a16a552d$var$Ht({
        destination: console.log
    }, e));
};
var $ac085c90a16a552d$var$zt = {
    promise: Promise.resolve({
        status: 200,
        header: function() {
            return null;
        },
        body: null
    })
};
function $ac085c90a16a552d$var$Kt(e, t, n, r, o) {
    if (o && !function() {
        var e = window.navigator && window.navigator.userAgent;
        if (e) {
            var t = e.match(/Chrom(e|ium)\/([0-9]+)\./);
            if (t) return parseInt(t[2], 10) < 73;
        }
        return !0;
    }()) return $ac085c90a16a552d$var$zt;
    var i = new window.XMLHttpRequest;
    for(var a in i.open(e, t, !o), n || {})Object.prototype.hasOwnProperty.call(n, a) && i.setRequestHeader(a, n[a]);
    if (o) {
        try {
            i.send(r);
        } catch (e) {}
        return $ac085c90a16a552d$var$zt;
    }
    var s, c = new Promise(function(e, t) {
        i.addEventListener("load", function() {
            s || e({
                status: i.status,
                header: function(e) {
                    return i.getResponseHeader(e);
                },
                body: i.responseText
            });
        }), i.addEventListener("error", function() {
            s || t(new Error);
        }), i.send(r);
    });
    return {
        promise: c,
        cancel: function() {
            s = !0, i.abort();
        }
    };
}
var $ac085c90a16a552d$var$_t = (e)=>{
    if ("string" != typeof e) throw new TypeError("Expected a string");
    return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};
function $ac085c90a16a552d$var$Jt(e, t, n, r) {
    var o, i, a = (("substring" === e.kind || "regex" === e.kind) && r.includes("/") ? t : t.replace(r, "")).replace(n, "");
    switch(e.kind){
        case "exact":
            i = t, o = new RegExp("^" + $ac085c90a16a552d$var$_t(e.url) + "/?$");
            break;
        case "canonical":
            i = a, o = new RegExp("^" + $ac085c90a16a552d$var$_t(e.url) + "/?$");
            break;
        case "substring":
            i = a, o = new RegExp(".*" + $ac085c90a16a552d$var$_t(e.substring) + ".*$");
            break;
        case "regex":
            i = a, o = new RegExp(e.pattern);
            break;
        default:
            return !1;
    }
    return o.test(i);
}
function $ac085c90a16a552d$var$Bt(e, t) {
    for(var n = {}, r = null, o = [], i = 0; i < e.length; i++)for(var a = e[i], s = a.urls || [], c = 0; c < s.length; c++)if ($ac085c90a16a552d$var$Jt(s[c], window.location.href, window.location.search, window.location.hash)) {
        "pageview" === a.kind ? t("pageview", a) : (o.push(a), t("click_pageview", a));
        break;
    }
    return o.length > 0 && (r = function(e) {
        for(var n = function(e, t) {
            for(var n = [], r = 0; r < t.length; r++)for(var o = e.target, i = t[r], a = i.selector, s = document.querySelectorAll(a); o && s.length > 0;){
                for(var c = 0; c < s.length; c++)o === s[c] && n.push(i);
                o = o.parentNode;
            }
            return n;
        }(e, o), r = 0; r < n.length; r++)t("click", n[r]);
    }, document.addEventListener("click", r)), n.dispose = function() {
        document.removeEventListener("click", r);
    }, n;
}
function $ac085c90a16a552d$var$Wt(e, t) {
    var n, r;
    function o() {
        r && r.dispose(), n && n.length && (r = $ac085c90a16a552d$var$Bt(n, i));
    }
    function i(t, n) {
        var r = e.ident.getContext(), o = {
            kind: t,
            key: n.key,
            data: null,
            url: window.location.href,
            creationDate: (new Date).getTime(),
            context: r
        };
        return "click" === t && (o.selector = n.selector), e.enqueueEvent(o);
    }
    return e.requestor.fetchJSON("/sdk/goals/" + e.getEnvironmentId()).then(function(e) {
        e && e.length > 0 && (r = $ac085c90a16a552d$var$Bt(n = e, i), function(e, t) {
            var n, r = window.location.href;
            function o() {
                (n = window.location.href) !== r && (r = n, t());
            }
            !function e(t, n) {
                t(), setTimeout(function() {
                    e(t, n);
                }, n);
            }(o, e), window.history && window.history.pushState ? window.addEventListener("popstate", o) : window.addEventListener("hashchange", o);
        }(300, o)), t();
    }).catch(function(n) {
        e.emitter.maybeReportError(new $ac085c90a16a552d$var$Rt.LDUnexpectedResponseError((n && n.message, n.message))), t();
    }), {};
}
var $ac085c90a16a552d$var$Gt = "goalsReady", $ac085c90a16a552d$var$Xt = {
    fetchGoals: {
        default: !0
    },
    hash: {
        type: "string"
    },
    eventProcessor: {
        type: "object"
    },
    eventUrlTransformer: {
        type: "function"
    },
    disableSyncEventPost: {
        default: !1
    }
};
function $ac085c90a16a552d$export$2a47f398eeff8b01(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = function(e) {
        var t, n = {
            userAgentHeaderName: "X-LaunchDarkly-User-Agent",
            synchronousFlush: !1
        };
        if (window.XMLHttpRequest) {
            var r = e && e.disableSyncEventPost;
            n.httpRequest = function(e, t, o, i) {
                var a = n.synchronousFlush & !r;
                return n.synchronousFlush = !1, $ac085c90a16a552d$var$Kt(e, t, o, i, a);
            };
        }
        n.httpAllowsPost = function() {
            return void 0 === t && (t = !!window.XMLHttpRequest && "withCredentials" in new window.XMLHttpRequest), t;
        }, n.httpFallbackPing = function(e) {
            (new window.Image).src = e;
        };
        var o, i = e && e.eventUrlTransformer;
        n.getCurrentUrl = function() {
            return i ? i(window.location.href) : window.location.href;
        }, n.isDoNotTrack = function() {
            var e;
            return 1 === (e = window.navigator && void 0 !== window.navigator.doNotTrack ? window.navigator.doNotTrack : window.navigator && void 0 !== window.navigator.msDoNotTrack ? window.navigator.msDoNotTrack : window.doNotTrack) || !0 === e || "1" === e || "yes" === e;
        };
        try {
            window.localStorage && (n.localStorage = {
                get: function(e) {
                    return new Promise(function(t) {
                        t(window.localStorage.getItem(e));
                    });
                },
                set: function(e, t) {
                    return new Promise(function(n) {
                        window.localStorage.setItem(e, t), n();
                    });
                },
                clear: function(e) {
                    return new Promise(function(t) {
                        window.localStorage.removeItem(e), t();
                    });
                }
            });
        } catch (e) {
            n.localStorage = null;
        }
        if (e && e.useReport && "function" == typeof window.EventSourcePolyfill && window.EventSourcePolyfill.supportedOptions && window.EventSourcePolyfill.supportedOptions.method ? (n.eventSourceAllowsReport = !0, o = window.EventSourcePolyfill) : (n.eventSourceAllowsReport = !1, o = window.EventSource), window.EventSource) {
            var a = 3e5;
            n.eventSourceFactory = function(e, t) {
                var n = $ac085c90a16a552d$var$Ht($ac085c90a16a552d$var$Ht({}, {
                    heartbeatTimeout: a,
                    silentTimeout: a,
                    skipDefaultHeaders: !0
                }), t);
                return new o(e, n);
            }, n.eventSourceIsActive = function(e) {
                return e.readyState === window.EventSource.OPEN || e.readyState === window.EventSource.CONNECTING;
            };
        }
        return n.userAgent = "JSClient", n.version = "3.9.0", n.diagnosticSdkData = {
            name: "js-client-sdk",
            version: "3.9.0"
        }, n.diagnosticPlatformData = {
            name: "JS"
        }, n.diagnosticUseCombinedEvent = !0, n;
    }(n), o = $ac085c90a16a552d$var$jt(e, t, n, r, $ac085c90a16a552d$var$Xt), i = o.client, a = o.options, s = o.emitter, c = new Promise(function(e) {
        var t = s.on($ac085c90a16a552d$var$Gt, function() {
            s.off($ac085c90a16a552d$var$Gt, t), e();
        });
    });
    i.waitUntilGoalsReady = function() {
        return c;
    }, a.fetchGoals ? $ac085c90a16a552d$var$Wt(o, function() {
        return s.emit($ac085c90a16a552d$var$Gt);
    }) : s.emit($ac085c90a16a552d$var$Gt), "complete" !== document.readyState ? window.addEventListener("load", o.start) : o.start();
    var u = function() {
        r.synchronousFlush = !0, i.flush().catch(function() {}), r.synchronousFlush = !1;
    };
    return document.addEventListener("visibilitychange", function() {
        "hidden" === document.visibilityState && u();
    }), window.addEventListener("pagehide", u), i;
}
var $ac085c90a16a552d$export$b66aba0a73c7dec6 = $ac085c90a16a552d$var$qt, $ac085c90a16a552d$export$297abbbd7d012370 = void 0, $ac085c90a16a552d$export$83d89fbfd8236492 = "3.9.0";
var $ac085c90a16a552d$export$2e2bcd8739ae039 = {
    initialize: function(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        return console && console.warn && console.warn($ac085c90a16a552d$var$Nt.deprecated("default export", "named LDClient export")), $ac085c90a16a552d$export$2a47f398eeff8b01(e, t, n);
    },
    version: $ac085c90a16a552d$export$83d89fbfd8236492
};

});

parcelRegister("j7JJt", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $dec22549d5201051$var$INFINITY = 1 / 0;
/** `Object#toString` result references. */ var $dec22549d5201051$var$symbolTag = '[object Symbol]';
/** Used to match words composed of alphanumeric characters. */ var $dec22549d5201051$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $dec22549d5201051$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $dec22549d5201051$var$rsAstralRange = '\\ud800-\\udfff', $dec22549d5201051$var$rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23', $dec22549d5201051$var$rsComboSymbolsRange = '\\u20d0-\\u20f0', $dec22549d5201051$var$rsDingbatRange = '\\u2700-\\u27bf', $dec22549d5201051$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $dec22549d5201051$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $dec22549d5201051$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $dec22549d5201051$var$rsPunctuationRange = '\\u2000-\\u206f', $dec22549d5201051$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $dec22549d5201051$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $dec22549d5201051$var$rsVarRange = '\\ufe0e\\ufe0f', $dec22549d5201051$var$rsBreakRange = $dec22549d5201051$var$rsMathOpRange + $dec22549d5201051$var$rsNonCharRange + $dec22549d5201051$var$rsPunctuationRange + $dec22549d5201051$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $dec22549d5201051$var$rsApos = "['\u2019]", $dec22549d5201051$var$rsAstral = '[' + $dec22549d5201051$var$rsAstralRange + ']', $dec22549d5201051$var$rsBreak = '[' + $dec22549d5201051$var$rsBreakRange + ']', $dec22549d5201051$var$rsCombo = '[' + $dec22549d5201051$var$rsComboMarksRange + $dec22549d5201051$var$rsComboSymbolsRange + ']', $dec22549d5201051$var$rsDigits = '\\d+', $dec22549d5201051$var$rsDingbat = '[' + $dec22549d5201051$var$rsDingbatRange + ']', $dec22549d5201051$var$rsLower = '[' + $dec22549d5201051$var$rsLowerRange + ']', $dec22549d5201051$var$rsMisc = '[^' + $dec22549d5201051$var$rsAstralRange + $dec22549d5201051$var$rsBreakRange + $dec22549d5201051$var$rsDigits + $dec22549d5201051$var$rsDingbatRange + $dec22549d5201051$var$rsLowerRange + $dec22549d5201051$var$rsUpperRange + ']', $dec22549d5201051$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $dec22549d5201051$var$rsModifier = '(?:' + $dec22549d5201051$var$rsCombo + '|' + $dec22549d5201051$var$rsFitz + ')', $dec22549d5201051$var$rsNonAstral = '[^' + $dec22549d5201051$var$rsAstralRange + ']', $dec22549d5201051$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $dec22549d5201051$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $dec22549d5201051$var$rsUpper = '[' + $dec22549d5201051$var$rsUpperRange + ']', $dec22549d5201051$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $dec22549d5201051$var$rsLowerMisc = '(?:' + $dec22549d5201051$var$rsLower + '|' + $dec22549d5201051$var$rsMisc + ')', $dec22549d5201051$var$rsUpperMisc = '(?:' + $dec22549d5201051$var$rsUpper + '|' + $dec22549d5201051$var$rsMisc + ')', $dec22549d5201051$var$rsOptLowerContr = '(?:' + $dec22549d5201051$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $dec22549d5201051$var$rsOptUpperContr = '(?:' + $dec22549d5201051$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $dec22549d5201051$var$reOptMod = $dec22549d5201051$var$rsModifier + '?', $dec22549d5201051$var$rsOptVar = '[' + $dec22549d5201051$var$rsVarRange + ']?', $dec22549d5201051$var$rsOptJoin = '(?:' + $dec22549d5201051$var$rsZWJ + '(?:' + [
    $dec22549d5201051$var$rsNonAstral,
    $dec22549d5201051$var$rsRegional,
    $dec22549d5201051$var$rsSurrPair
].join('|') + ')' + $dec22549d5201051$var$rsOptVar + $dec22549d5201051$var$reOptMod + ')*', $dec22549d5201051$var$rsSeq = $dec22549d5201051$var$rsOptVar + $dec22549d5201051$var$reOptMod + $dec22549d5201051$var$rsOptJoin, $dec22549d5201051$var$rsEmoji = '(?:' + [
    $dec22549d5201051$var$rsDingbat,
    $dec22549d5201051$var$rsRegional,
    $dec22549d5201051$var$rsSurrPair
].join('|') + ')' + $dec22549d5201051$var$rsSeq, $dec22549d5201051$var$rsSymbol = '(?:' + [
    $dec22549d5201051$var$rsNonAstral + $dec22549d5201051$var$rsCombo + '?',
    $dec22549d5201051$var$rsCombo,
    $dec22549d5201051$var$rsRegional,
    $dec22549d5201051$var$rsSurrPair,
    $dec22549d5201051$var$rsAstral
].join('|') + ')';
/** Used to match apostrophes. */ var $dec22549d5201051$var$reApos = RegExp($dec22549d5201051$var$rsApos, 'g');
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $dec22549d5201051$var$reComboMark = RegExp($dec22549d5201051$var$rsCombo, 'g');
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $dec22549d5201051$var$reUnicode = RegExp($dec22549d5201051$var$rsFitz + '(?=' + $dec22549d5201051$var$rsFitz + ')|' + $dec22549d5201051$var$rsSymbol + $dec22549d5201051$var$rsSeq, 'g');
/** Used to match complex or compound words. */ var $dec22549d5201051$var$reUnicodeWord = RegExp([
    $dec22549d5201051$var$rsUpper + '?' + $dec22549d5201051$var$rsLower + '+' + $dec22549d5201051$var$rsOptLowerContr + '(?=' + [
        $dec22549d5201051$var$rsBreak,
        $dec22549d5201051$var$rsUpper,
        '$'
    ].join('|') + ')',
    $dec22549d5201051$var$rsUpperMisc + '+' + $dec22549d5201051$var$rsOptUpperContr + '(?=' + [
        $dec22549d5201051$var$rsBreak,
        $dec22549d5201051$var$rsUpper + $dec22549d5201051$var$rsLowerMisc,
        '$'
    ].join('|') + ')',
    $dec22549d5201051$var$rsUpper + '?' + $dec22549d5201051$var$rsLowerMisc + '+' + $dec22549d5201051$var$rsOptLowerContr,
    $dec22549d5201051$var$rsUpper + '+' + $dec22549d5201051$var$rsOptUpperContr,
    $dec22549d5201051$var$rsDigits,
    $dec22549d5201051$var$rsEmoji
].join('|'), 'g');
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $dec22549d5201051$var$reHasUnicode = RegExp('[' + $dec22549d5201051$var$rsZWJ + $dec22549d5201051$var$rsAstralRange + $dec22549d5201051$var$rsComboMarksRange + $dec22549d5201051$var$rsComboSymbolsRange + $dec22549d5201051$var$rsVarRange + ']');
/** Used to detect strings that need a more robust regexp to match words. */ var $dec22549d5201051$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/** Used to map Latin Unicode letters to basic Latin letters. */ var $dec22549d5201051$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 'ss'
};
/** Detect free variable `global` from Node.js. */ var $dec22549d5201051$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $dec22549d5201051$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $dec22549d5201051$var$root = $dec22549d5201051$var$freeGlobal || $dec22549d5201051$var$freeSelf || Function('return this')();
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $dec22549d5201051$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $dec22549d5201051$var$asciiToArray(string) {
    return string.split('');
}
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $dec22549d5201051$var$asciiWords(string) {
    return string.match($dec22549d5201051$var$reAsciiWord) || [];
}
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $dec22549d5201051$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $dec22549d5201051$var$deburrLetter = $dec22549d5201051$var$basePropertyOf($dec22549d5201051$var$deburredLetters);
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $dec22549d5201051$var$hasUnicode(string) {
    return $dec22549d5201051$var$reHasUnicode.test(string);
}
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $dec22549d5201051$var$hasUnicodeWord(string) {
    return $dec22549d5201051$var$reHasUnicodeWord.test(string);
}
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $dec22549d5201051$var$stringToArray(string) {
    return $dec22549d5201051$var$hasUnicode(string) ? $dec22549d5201051$var$unicodeToArray(string) : $dec22549d5201051$var$asciiToArray(string);
}
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $dec22549d5201051$var$unicodeToArray(string) {
    return string.match($dec22549d5201051$var$reUnicode) || [];
}
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $dec22549d5201051$var$unicodeWords(string) {
    return string.match($dec22549d5201051$var$reUnicodeWord) || [];
}
/** Used for built-in method references. */ var $dec22549d5201051$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dec22549d5201051$var$objectToString = $dec22549d5201051$var$objectProto.toString;
/** Built-in value references. */ var $dec22549d5201051$var$Symbol = $dec22549d5201051$var$root.Symbol;
/** Used to convert symbols to primitives and strings. */ var $dec22549d5201051$var$symbolProto = $dec22549d5201051$var$Symbol ? $dec22549d5201051$var$Symbol.prototype : undefined, $dec22549d5201051$var$symbolToString = $dec22549d5201051$var$symbolProto ? $dec22549d5201051$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $dec22549d5201051$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $dec22549d5201051$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($dec22549d5201051$var$isSymbol(value)) return $dec22549d5201051$var$symbolToString ? $dec22549d5201051$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$dec22549d5201051$var$INFINITY ? '-0' : result;
}
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $dec22549d5201051$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $dec22549d5201051$var$baseSlice(array, start, end);
}
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $dec22549d5201051$var$createCaseFirst(methodName) {
    return function(string) {
        string = $dec22549d5201051$var$toString(string);
        var strSymbols = $dec22549d5201051$var$hasUnicode(string) ? $dec22549d5201051$var$stringToArray(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $dec22549d5201051$var$castSlice(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $dec22549d5201051$var$createCompounder(callback) {
    return function(string) {
        return $dec22549d5201051$var$arrayReduce($dec22549d5201051$var$words($dec22549d5201051$var$deburr(string).replace($dec22549d5201051$var$reApos, '')), callback, '');
    };
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $dec22549d5201051$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $dec22549d5201051$var$isSymbol(value) {
    return typeof value == 'symbol' || $dec22549d5201051$var$isObjectLike(value) && $dec22549d5201051$var$objectToString.call(value) == $dec22549d5201051$var$symbolTag;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $dec22549d5201051$var$toString(value) {
    return value == null ? '' : $dec22549d5201051$var$baseToString(value);
}
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $dec22549d5201051$var$camelCase = $dec22549d5201051$var$createCompounder(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $dec22549d5201051$var$capitalize(word) : word);
});
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $dec22549d5201051$var$capitalize(string) {
    return $dec22549d5201051$var$upperFirst($dec22549d5201051$var$toString(string).toLowerCase());
}
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $dec22549d5201051$var$deburr(string) {
    string = $dec22549d5201051$var$toString(string);
    return string && string.replace($dec22549d5201051$var$reLatin, $dec22549d5201051$var$deburrLetter).replace($dec22549d5201051$var$reComboMark, '');
}
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $dec22549d5201051$var$upperFirst = $dec22549d5201051$var$createCaseFirst('toUpperCase');
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $dec22549d5201051$var$words(string, pattern, guard) {
    string = $dec22549d5201051$var$toString(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $dec22549d5201051$var$hasUnicodeWord(string) ? $dec22549d5201051$var$unicodeWords(string) : $dec22549d5201051$var$asciiWords(string);
    return string.match(pattern) || [];
}
module.exports = $dec22549d5201051$var$camelCase;

});



parcelRegister("4G44R", function(module, exports) {

$parcel$export(module.exports, "useClipsStore", () => $bdc5f018aa3d200e$export$271651e9fca3a182);

var $9OjAn = parcelRequire("9OjAn");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");

var $64bXP = parcelRequire("64bXP");

var $6Bo1T = parcelRequire("6Bo1T");

var $bdLns = parcelRequire("bdLns");

var $4JjIi = parcelRequire("4JjIi");
const $bdc5f018aa3d200e$var$startDate = new Date();
const $bdc5f018aa3d200e$var$endDate = new Date();
let $bdc5f018aa3d200e$var$activeSMTPRequestToken = "";
const $bdc5f018aa3d200e$export$ef0c922ba1a90e13 = (existing, incoming)=>{
    const merged = (existing || []).map((row)=>({
            ...row
        }));
    (incoming || []).forEach((row)=>{
        const existingRow = merged.find((item)=>item.date_str === row.date_str);
        if (!existingRow) {
            merged.push({
                ...row
            });
            return;
        }
        existingRow.true_positives += row.true_positives;
        existingRow.false_positives += row.false_positives;
        existingRow.false_negatives += row.false_negatives;
        existingRow.true_negatives += row.true_negatives;
        existingRow.unclassified += row.unclassified;
        existingRow.total_clips += row.total_clips;
        existingRow.precision = existingRow.true_positives + existingRow.false_positives > 0 ? existingRow.true_positives / (existingRow.true_positives + existingRow.false_positives) : null;
        existingRow.recall = existingRow.true_positives + existingRow.false_negatives > 0 ? existingRow.true_positives / (existingRow.true_positives + existingRow.false_negatives) : null;
    });
    return merged;
};
/** Sequence numbers of the latest report-link request per tab; see getDownloadURLSentinel. */ const $bdc5f018aa3d200e$var$reportRequestIds = {
    Sentinel: 0,
    AILink: 0
};
const $bdc5f018aa3d200e$export$271651e9fca3a182 = (0, $9OjAn.create)((set, get)=>({
        smtpData: [],
        setSmtpData: (smtpData)=>set({
                smtpData: smtpData
            }),
        precisionRecallDataSMTP: {},
        setPrecisionRecallDataSMTP: (precisionRecallDataSMTP)=>set({
                precisionRecallDataSMTP: precisionRecallDataSMTP
            }),
        selectedRowSMTP: {},
        setSelectedRowSMTP: (selectedRowSMTP)=>set({
                selectedRowSMTP: selectedRowSMTP
            }),
        selectedClipSMTPMedia: [],
        setSelectedClipSMTPMedia: (selectedClipSMTPMedia)=>set({
                selectedClipSMTPMedia: selectedClipSMTPMedia
            }),
        activeClipsTab: "",
        setActiveClipsTab: (activeClipsTab)=>set({
                activeClipsTab: activeClipsTab
            }),
        noDataToDisplaySMTP: true,
        setNoDataToDisplaySMTP: (noDataToDisplaySMTP)=>set({
                noDataToDisplaySMTP: noDataToDisplaySMTP
            }),
        filtersAppliedSMTP: false,
        setFiltersAppliedSMTP: (filtersAppliedSMTP)=>set({
                filtersAppliedSMTP: filtersAppliedSMTP
            }),
        fetchingFilteredDataSMTP: false,
        setFetchingFilteredDataSMTP: (fetchingFilteredDataSMTP)=>set({
                fetchingFilteredDataSMTP: fetchingFilteredDataSMTP
            }),
        userDropDownValueSMTP: null,
        setUserDropDownValueSMTP: (userDropDownValueSMTP)=>set({
                userDropDownValueSMTP: userDropDownValueSMTP
            }),
        cameraDropDownValueSMTP: null,
        setCameraDropDownValueSMTP: (cameraDropDownValueSMTP)=>set({
                cameraDropDownValueSMTP: cameraDropDownValueSMTP
            }),
        groupIDSMTP: null,
        setGroupIDSMTP: (groupIDSMTP)=>set({
                groupIDSMTP: groupIDSMTP
            }),
        groupOptionsSMTP: localStorage.parentGroups ? JSON.parse(localStorage.parentGroups) : [],
        setGroupOptionsSMTP: (groupOptionsSMTP)=>set({
                groupOptionsSMTP: groupOptionsSMTP
            }),
        loadingGroupsSMTP: false,
        setLoadingGroupsSMTP: (loadingGroupsSMTP)=>set({
                loadingGroupsSMTP: loadingGroupsSMTP
            }),
        siteDropDownValueSMTP: null,
        setSiteDropDownValueSMTP: (siteDropDownValueSMTP)=>set({
                siteDropDownValueSMTP: siteDropDownValueSMTP
            }),
        siteOptionsSMTP: [],
        setSiteOptionsSMTP: (siteOptionsSMTP)=>set({
                siteOptionsSMTP: siteOptionsSMTP
            }),
        loadingSitesSMTP: false,
        setLoadingSitesSMTP: (loadingSitesSMTP)=>set({
                loadingSitesSMTP: loadingSitesSMTP
            }),
        smtpSite: {
            site_id: "",
            site_name: ""
        },
        setSmtpSite: (smtpSite)=>set({
                smtpSite: smtpSite
            }),
        selectedRowAlertsSMTP: [],
        setSelectedRowAlertsSMTP: (selectedRowAlertsSMTP)=>set({
                selectedRowAlertsSMTP: selectedRowAlertsSMTP
            }),
        loadingCamerasSMTP: false,
        setLoadingCamerasSMTP: (loadingCamerasSMTP)=>set({
                loadingCamerasSMTP: loadingCamerasSMTP
            }),
        userFiltersSMTP: {
            user: "",
            group_id: null,
            start_date: $bdc5f018aa3d200e$var$startDate,
            end_date: $bdc5f018aa3d200e$var$endDate,
            start_time: null,
            end_time: null,
            site_ids: [],
            camera_ids: []
        },
        setUserFiltersSMTP: (userFiltersSMTP)=>set((state)=>({
                    userFiltersSMTP: typeof userFiltersSMTP === "function" ? userFiltersSMTP(state.userFiltersSMTP) : userFiltersSMTP
                })),
        cameraOptionsSMTP: [],
        setCameraOptionsSMTP: (cameraOptionsSMTP)=>set({
                cameraOptionsSMTP: cameraOptionsSMTP
            }),
        timeFiltersDisabledSMTP: false,
        setTimeFiltersDisabledSMTP: (timeFiltersDisabledSMTP)=>set({
                timeFiltersDisabledSMTP: timeFiltersDisabledSMTP
            }),
        pageLoadingSMTP: false,
        setPageLoadingSMTP: (pageLoadingSMTP)=>set({
                pageLoadingSMTP: pageLoadingSMTP
            }),
        pageSMTP: 0,
        setPageSMTP: (pageSMTP)=>set({
                pageSMTP: pageSMTP
            }),
        videoClipLoadingSMTP: false,
        setVideoClipLoadingSMTP: (videoClipLoadingSMTP)=>set({
                videoClipLoadingSMTP: videoClipLoadingSMTP
            }),
        loadingAdditionalDataSMTP: false,
        setLoadingAdditionalDataSMTP: (loadingAdditionalDataSMTP)=>set({
                loadingAdditionalDataSMTP: loadingAdditionalDataSMTP
            }),
        clipsIndexOrderSMTP: {},
        setClipsIndexOrderSMTP: (clipsIndexOrderSMTP)=>set({
                clipsIndexOrderSMTP: clipsIndexOrderSMTP
            }),
        allAlertsDialogOpen: false,
        setAllAlertsDialogOpen: (allAlertsDialogOpen)=>set({
                allAlertsDialogOpen: allAlertsDialogOpen
            }),
        falsePositiveReductionDialogOpen: false,
        setFalsePositiveReductionDialogOpen: (falsePositiveReductionDialogOpen)=>set({
                falsePositiveReductionDialogOpen: falsePositiveReductionDialogOpen
            }),
        requestCounterSMTP: 0,
        setRequestCounterSMTP: (requestCounterSMTP)=>set({
                requestCounterSMTP: requestCounterSMTP
            }),
        downloadURLSMTP: "",
        setDownloadURLSMTP: (downloadURLSMTP)=>set({
                downloadURLSMTP: downloadURLSMTP
            }),
        fetchingDownloadURLSMTP: false,
        setFetchingDownloadURLSMTP: (fetchingDownloadURLSMTP)=>set({
                fetchingDownloadURLSMTP: fetchingDownloadURLSMTP
            }),
        downloadURLAILink: "",
        setDownloadURLAILink: (downloadURLAILink)=>set({
                downloadURLAILink: downloadURLAILink
            }),
        fetchingDownloadURLAILink: false,
        setFetchingDownloadURLAILink: (fetchingDownloadURLAILink)=>set({
                fetchingDownloadURLAILink: fetchingDownloadURLAILink
            }),
        downloadURLSentinel: "",
        setDownloadURLSentinel: (downloadURLSentinel)=>set({
                downloadURLSentinel: downloadURLSentinel
            }),
        fetchingDownloadURLSentinel: false,
        setFetchingDownloadURLSentinel: (fetchingDownloadURLSentinel)=>set({
                fetchingDownloadURLSentinel: fetchingDownloadURLSentinel
            }),
        smtpTableFilter: "all",
        setSmtpTableFilter: (smtpTableFilter)=>set({
                smtpTableFilter: smtpTableFilter
            }),
        siteTimeZoneSMTP: "",
        setSiteTimeZoneSMTP: (siteTimeZoneSMTP)=>set({
                siteTimeZoneSMTP: siteTimeZoneSMTP
            }),
        getUserGroupsSMTP: async (navigate)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().getUserGroupsSMTP(navigate);
            };
            const { setGroupOptionsSMTP: setGroupOptionsSMTP, setLoadingGroupsSMTP: setLoadingGroupsSMTP } = get();
            setLoadingGroupsSMTP(true);
            const allGroups = [];
            // Recursive function to handle pagination
            const recursiveFunction = (apiURL)=>{
                const AxiosNextUI = (0, $64bXP.createAPIwithNextValue)(apiURL);
                AxiosNextUI.get(``).then((response)=>{
                    // Add results to the accumulated data
                    allGroups.push(...response.data.results);
                    // Check if there's a next page
                    if (response.data.next) // Continue with the next page
                    recursiveFunction(response.data.next);
                    else {
                        // No more pages, set the final data and stop loading
                        setGroupOptionsSMTP(allGroups);
                        setLoadingGroupsSMTP(false);
                    }
                }).catch((reason)=>{
                    (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                        setGroupOptionsSMTP([]);
                        setLoadingGroupsSMTP(false);
                    });
                });
            };
            try {
                const response = await AxiosUI.get(`group/?group_type=smtp`);
                // Add first page results
                allGroups.push(...response.data.results);
                // Check if there are more pages
                if (response.data.next) // Continue with pagination
                recursiveFunction(response.data.next);
                else {
                    // No pagination needed, set data and stop loading
                    setGroupOptionsSMTP(allGroups);
                    setLoadingGroupsSMTP(false);
                }
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setGroupOptionsSMTP([]);
                    setLoadingGroupsSMTP(false);
                });
            }
        },
        getAllSitesClipsSMTP: async (groupID, navigate)=>{
            if (!groupID) return;
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().getAllSitesClipsSMTP(groupID, navigate);
            };
            const { setSiteOptionsSMTP: setSiteOptionsSMTP, setLoadingSitesSMTP: setLoadingSitesSMTP } = get();
            setSiteOptionsSMTP([]);
            setLoadingSitesSMTP(true);
            try {
                const response = await AxiosUI.get(`customer/names/${groupID}/?group_type=smtp`);
                setSiteOptionsSMTP(response.data);
                setLoadingSitesSMTP(false);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setLoadingSitesSMTP(false);
                });
            }
        },
        getCamerasBySiteSMTP: async (siteIds, navigate)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().getCamerasBySiteSMTP(siteIds, navigate);
            };
            const { setCameraOptionsSMTP: setCameraOptionsSMTP, setLoadingCamerasSMTP: setLoadingCamerasSMTP } = get();
            setLoadingCamerasSMTP(true);
            let idString = "";
            if (siteIds.length === 1) idString = `${siteIds[0]}`;
            if (siteIds.length > 1) {
                idString = `${siteIds[0]}`;
                siteIds.forEach((id, index)=>{
                    if (index > 0) idString += `,${id}`;
                });
            }
            let allSiteCameras;
            const getSiteCameras = (pageNumber)=>{
                AxiosUI.get(`camera/site/?customers=${idString}&page=${pageNumber}`).then((response)=>{
                    if (response.data.count > 0) {
                        if (pageNumber === 1) allSiteCameras = response.data.results;
                        if (pageNumber > 1) allSiteCameras.push(...response.data.results);
                        if (response.data.next) getSiteCameras(pageNumber + 1);
                        else {
                            setCameraOptionsSMTP(allSiteCameras);
                            setLoadingCamerasSMTP(false);
                        }
                    } else {
                        setCameraOptionsSMTP([]);
                        setLoadingCamerasSMTP(false);
                    }
                }, (reason)=>{
                    (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                        setLoadingCamerasSMTP(false);
                    });
                });
            };
            siteIds.length === 0 ? setCameraOptionsSMTP([]) : getSiteCameras(1);
        },
        getSMTPData: async (navigate)=>{
            const { userFiltersSMTP: userFiltersSMTP, setSmtpData: setSmtpData, getSMTPData: getSMTPData, setLoadingAdditionalDataSMTP: setLoadingAdditionalDataSMTP, setSelectedRowSMTP: setSelectedRowSMTP, getVideoURLSMTP: getVideoURLSMTP, setNoDataToDisplaySMTP: setNoDataToDisplaySMTP, setFetchingFilteredDataSMTP: setFetchingFilteredDataSMTP, requestCounterSMTP: requestCounterSMTP, setRequestCounterSMTP: setRequestCounterSMTP, setSmtpSite: setSmtpSite } = get();
            const currentRequestId = requestCounterSMTP + 1;
            setRequestCounterSMTP(currentRequestId);
            const currentRequestToken = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
            $bdc5f018aa3d200e$var$activeSMTPRequestToken = currentRequestToken;
            const urlClipId = new URLSearchParams(window.location.search).get("clip_id");
            const hasUrlClipSelection = window.location.pathname.includes("clips") && !!urlClipId;
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                getSMTPData(navigate);
            };
            // Helper function to format date for API parameter
            const formatDateForAPI = (date)=>{
                if (!date) return null;
                return date.toISOString().split("T")[0]; // Get YYYY-MM-DD format
            };
            // Helper function to format time for API parameter
            const formatTimeForAPI = (time)=>{
                if (!time) return null;
                return time.toTimeString().split(" ")[0].substring(0, 5); // Get HH:MM format
            };
            let searchString = "";
            // if (userFiltersSMTP.user) {
            //   searchString += `&user=${userFiltersSMTP.user}`;
            // }
            if (userFiltersSMTP.site_ids[0] && !userFiltersSMTP.camera_ids[0]) searchString += `customer_id=${userFiltersSMTP.site_ids[0]}`;
            else if (userFiltersSMTP.camera_ids[0]) searchString += `camera_id=${userFiltersSMTP.camera_ids[0]}`;
            const allData = [];
            setLoadingAdditionalDataSMTP(true);
            // Add date and time parameters
            const startDate = formatDateForAPI(userFiltersSMTP.start_date);
            const endDate = formatDateForAPI(userFiltersSMTP.end_date);
            const startTime = formatTimeForAPI(userFiltersSMTP.start_time);
            const endTime = formatTimeForAPI(userFiltersSMTP.end_time);
            if (startDate) searchString += searchString ? `&start_date=${startDate}` : `start_date=${startDate}`;
            if (endDate) searchString += searchString ? `&end_date=${endDate}` : `end_date=${endDate}`;
            if (startTime) searchString += searchString ? `&start_time=${startTime}` : `start_time=${startTime}`;
            if (endTime) searchString += searchString ? `&end_time=${endTime}` : `end_time=${endTime}`;
            // Add direction parameter
            searchString += searchString ? `&direction=next` : `direction=next`;
            const recursiveFunction = (apiURL)=>{
                const AxiosNextUI = (0, $64bXP.createAPIwithNextValue)(apiURL);
                AxiosNextUI.get(``).then((response)=>{
                    if ($bdc5f018aa3d200e$var$activeSMTPRequestToken !== currentRequestToken) return;
                    // Check if this is still the most recent request
                    const { requestCounterSMTP: requestCounterSMTP } = get();
                    if (requestCounterSMTP !== currentRequestId) // This is an outdated request, ignore the response
                    return;
                    // Add selected property to each item as we receive it (only first item of first batch is selected)
                    const resultsWithSelection = response.data.results.map((item)=>({
                            ...item,
                            selected: false
                        }));
                    allData.push(...resultsWithSelection);
                    // Check if we should continue pagination
                    // Stop pagination if:
                    // 1. No next URL
                    // 2. Not a full page (less than 100 results)
                    // 3. Not on clips page
                    // 4. No results in this batch
                    const shouldContinuePagination = response.data.next && response.data.count === 100 && window.location.href.includes("clips") && response.data.results.length > 0;
                    if (shouldContinuePagination) {
                        // Preserve current selection when adding new data
                        const currentSmtpData = get().smtpData;
                        const currentlySelectedClipId = currentSmtpData.find((item)=>item.selected)?.clip_id;
                        // Update allData to preserve the current selection
                        const updatedAllData = allData.map((item)=>({
                                ...item,
                                selected: item.clip_id === currentlySelectedClipId
                            }));
                        setSmtpData(updatedAllData);
                        recursiveFunction(response.data.next);
                        setNoDataToDisplaySMTP(false);
                        setFetchingFilteredDataSMTP(false);
                    } else {
                        const currentSmtpData = get().smtpData;
                        const currentlySelectedClipId = currentSmtpData.find((item)=>item.selected)?.clip_id;
                        const updatedAllData = allData.map((item)=>({
                                ...item,
                                selected: item.clip_id === currentlySelectedClipId
                            }));
                        setSmtpData(updatedAllData);
                        setLoadingAdditionalDataSMTP(false);
                        setNoDataToDisplaySMTP(false);
                        setFetchingFilteredDataSMTP(false);
                    }
                });
            };
            try {
                const response = await AxiosUI.get(`smtp/?${searchString}`);
                if ($bdc5f018aa3d200e$var$activeSMTPRequestToken !== currentRequestToken) return;
                // Check if this is still the most recent request
                const { requestCounterSMTP: currentCounter } = get();
                if (currentCounter !== currentRequestId) // This is an outdated request, ignore the response
                return;
                // Add selected property to each item as we receive it
                const resultsWithSelection = response.data.results.map((item, index)=>({
                        ...item,
                        selected: allData.length === 0 && index === 0
                    }));
                allData.push(...resultsWithSelection);
                if (response.data.customer) setSmtpSite({
                    site_id: response.data.customer.id,
                    site_name: response.data.customer.name
                });
                if (response.data.count === 0 || allData.length === 0) {
                    setNoDataToDisplaySMTP(true);
                    setLoadingAdditionalDataSMTP(false);
                    setFetchingFilteredDataSMTP(false);
                } else if (response.data.next && response.data.count === 100) {
                    if (response.data.results.length > 0) {
                        const currentSelectedClipId = get().smtpData.find((item)=>item.selected)?.clip_id;
                        const selectedClipId = currentSelectedClipId ? currentSelectedClipId : hasUrlClipSelection ? null : allData[0]?.clip_id;
                        const updatedAllData = allData.map((item)=>({
                                ...item,
                                selected: selectedClipId ? item.clip_id === selectedClipId : false
                            }));
                        setSmtpData(updatedAllData);
                        if (!hasUrlClipSelection && selectedClipId && allData.length > 0) {
                            const selectedRow = allData.find((item)=>item.clip_id === selectedClipId);
                            if (selectedRow) {
                                setSelectedRowSMTP(selectedRow);
                                getVideoURLSMTP(selectedRow.clip_id, navigate);
                            }
                        }
                        recursiveFunction(response.data.next);
                    } else {
                        // No results, stop pagination
                        setNoDataToDisplaySMTP(false);
                        const currentSelectedClipId = get().smtpData.find((item)=>item.selected)?.clip_id;
                        const selectedClipId = currentSelectedClipId ? currentSelectedClipId : hasUrlClipSelection ? null : allData[0]?.clip_id;
                        const updatedAllData = allData.map((item)=>({
                                ...item,
                                selected: selectedClipId ? item.clip_id === selectedClipId : false
                            }));
                        setSmtpData(updatedAllData);
                        if (!hasUrlClipSelection && selectedClipId && allData.length > 0) {
                            const selectedRow = allData.find((item)=>item.clip_id === selectedClipId);
                            if (selectedRow) {
                                setSelectedRowSMTP(selectedRow);
                                getVideoURLSMTP(selectedRow.clip_id, navigate);
                            }
                        }
                        setLoadingAdditionalDataSMTP(false);
                        setFetchingFilteredDataSMTP(false);
                    }
                } else {
                    setNoDataToDisplaySMTP(false);
                    const currentSelectedClipId = get().smtpData.find((item)=>item.selected)?.clip_id;
                    const selectedClipId = currentSelectedClipId ? currentSelectedClipId : hasUrlClipSelection ? null : allData[0]?.clip_id;
                    const updatedAllData = allData.map((item)=>({
                            ...item,
                            selected: selectedClipId ? item.clip_id === selectedClipId : false
                        }));
                    setSmtpData(updatedAllData);
                    if (!hasUrlClipSelection && selectedClipId && allData.length > 0) {
                        const selectedRow = allData.find((item)=>item.clip_id === selectedClipId);
                        if (selectedRow) {
                            setSelectedRowSMTP(selectedRow);
                            getVideoURLSMTP(selectedRow.clip_id, navigate);
                        }
                    }
                    setLoadingAdditionalDataSMTP(false);
                    setFetchingFilteredDataSMTP(false);
                }
            } catch (reason) {
                if ($bdc5f018aa3d200e$var$activeSMTPRequestToken !== currentRequestToken) return;
                // Check if this is still the most recent request before handling error
                const { requestCounterSMTP: currentCounter } = get();
                if (currentCounter !== currentRequestId) // This is an outdated request, ignore the error
                return;
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setSmtpData(allData);
                    setFetchingFilteredDataSMTP(false);
                });
            }
        },
        getVideoURLSMTP: async (clip_id, navigate)=>{
            const { getVideoURLSMTP: getVideoURLSMTP, setVideoClipLoadingSMTP: setVideoClipLoadingSMTP, setSelectedRowAlertsSMTP: setSelectedRowAlertsSMTP, setSelectedClipSMTPMedia: setSelectedClipSMTPMedia } = get();
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                getVideoURLSMTP(clip_id, navigate);
            };
            setVideoClipLoadingSMTP(true);
            try {
                const response = await AxiosUI.get(`smtp/clip/${clip_id}`);
                if (response.data.clip.alerts) {
                    if (response.data.clip.alerts.length > 0) setSelectedRowAlertsSMTP(response.data.clip.alerts);
                    else setSelectedRowAlertsSMTP([]);
                } else setSelectedRowAlertsSMTP([]);
                if (response.data.clip.filenames) setSelectedClipSMTPMedia(response.data.clip.filenames);
                setVideoClipLoadingSMTP(false);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setVideoClipLoadingSMTP(false);
                });
            }
        },
        getDownloadURLSMTP: async (navigate)=>{
            const { setDownloadURLSMTP: setDownloadURLSMTP, getDownloadURLSMTP: getDownloadURLSMTP, setFetchingDownloadURLSMTP: setFetchingDownloadURLSMTP } = get();
            setDownloadURLSMTP("");
            setFetchingDownloadURLSMTP(true);
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                getDownloadURLSMTP(navigate);
            };
            const searchParamsString = (0, $6Bo1T.generateDownloadString)();
            try {
                const response = await AxiosUI.get(`smtp/download/${searchParamsString}`);
                setDownloadURLSMTP(response.data.url);
                setFetchingDownloadURLSMTP(false);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setDownloadURLSMTP("");
                    setFetchingDownloadURLSMTP(false);
                });
            }
        },
        getDownloadURLAILink: async (navigate, userFilters, forceRefresh = false, groupID = null)=>{
            const { setDownloadURLAILink: setDownloadURLAILink, getDownloadURLAILink: getDownloadURLAILink, setFetchingDownloadURLAILink: setFetchingDownloadURLAILink } = get();
            setDownloadURLAILink("");
            setFetchingDownloadURLAILink(true);
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                getDownloadURLAILink(navigate, userFilters, forceRefresh, groupID);
            };
            let searchParamsString = (0, $bdLns.generateDownloadStringAILink)(userFilters, groupID);
            if (forceRefresh) // skip the backend's cached report, eg. when today's report should
            // include clips received since the cache was generated
            searchParamsString += `&force_refresh=true`;
            // Every filter change prefetches a new report, and a filtered report is
            // generated rather than served from cache, so requests overlap. Only the
            // newest request may set or clear the link: an older one finishing (or
            // failing) late must not blank the report for the filters now shown.
            const requestId = ++$bdc5f018aa3d200e$var$reportRequestIds.AILink;
            const isLatest = ()=>requestId === $bdc5f018aa3d200e$var$reportRequestIds.AILink;
            try {
                const response = await AxiosUI.get(`clip/report/${searchParamsString}`);
                if (!isLatest()) return;
                setDownloadURLAILink(response.data.url);
                setFetchingDownloadURLAILink(false);
            } catch (reason) {
                if (!isLatest()) return;
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setDownloadURLAILink("");
                    setFetchingDownloadURLAILink(false);
                });
            }
        },
        getDownloadURLSentinel: async (navigate, userFiltersSentinel, forceRefresh = false)=>{
            const { setDownloadURLSentinel: setDownloadURLSentinel, getDownloadURLSentinel: getDownloadURLSentinel, setFetchingDownloadURLSentinel: setFetchingDownloadURLSentinel } = get();
            setDownloadURLSentinel("");
            setFetchingDownloadURLSentinel(true);
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                getDownloadURLSentinel(navigate, userFiltersSentinel, forceRefresh);
            };
            let searchParamsString = (0, $4JjIi.generateDownloadStringSentinel)(userFiltersSentinel);
            if (forceRefresh) // skip the backend's cached report, eg. when today's report should
            // include clips received since the cache was generated
            searchParamsString += `&force_refresh=true`;
            // Every filter change prefetches a new report, and a filtered report is
            // generated rather than served from cache, so requests overlap. Only the
            // newest request may set or clear the link: an older one finishing (or
            // failing) late must not blank the report for the filters now shown.
            const requestId = ++$bdc5f018aa3d200e$var$reportRequestIds.Sentinel;
            const isLatest = ()=>requestId === $bdc5f018aa3d200e$var$reportRequestIds.Sentinel;
            try {
                const response = await AxiosUI.get(`clip/report/${searchParamsString}`);
                if (!isLatest()) return;
                setDownloadURLSentinel(response.data.url);
                setFetchingDownloadURLSentinel(false);
            } catch (reason) {
                if (!isLatest()) return;
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setDownloadURLSentinel("");
                    setFetchingDownloadURLSentinel(false);
                });
            }
        },
        showFrontelTab: false,
        setShowFrontelTab: (showFrontelTab)=>set({
                showFrontelTab: showFrontelTab
            }),
        frontelData: [],
        setFrontelData: (frontelData)=>set({
                frontelData: frontelData
            }),
        precisionRecallDataFrontel: [],
        setPrecisionRecallDataFrontel: (precisionRecallDataFrontel)=>set({
                precisionRecallDataFrontel: precisionRecallDataFrontel
            }),
        selectedRowFrontel: {},
        setSelectedRowFrontel: (selectedRowFrontel)=>set({
                selectedRowFrontel: selectedRowFrontel
            }),
        selectedClipFrontelMedia: [],
        setSelectedClipFrontelMedia: (selectedClipFrontelMedia)=>set({
                selectedClipFrontelMedia: selectedClipFrontelMedia
            }),
        noDataToDisplayFrontel: true,
        setNoDataToDisplayFrontel: (noDataToDisplayFrontel)=>set({
                noDataToDisplayFrontel: noDataToDisplayFrontel
            }),
        showMoreDialogOpenFrontel: false,
        setShowMoreDialogOpenFrontel: (showMoreDialogOpenFrontel)=>set({
                showMoreDialogOpenFrontel: showMoreDialogOpenFrontel
            }),
        verifiedClickedFrontel: false,
        setVerifiedClickedFrontel: (verifiedClickedFrontel)=>set({
                verifiedClickedFrontel: verifiedClickedFrontel
            }),
        unverifiedClickedFrontel: false,
        setUnverifiedClickedFrontel: (unverifiedClickedFrontel)=>set({
                unverifiedClickedFrontel: unverifiedClickedFrontel
            }),
        filtersAppliedFrontel: false,
        setFiltersAppliedFrontel: (filtersAppliedFrontel)=>set({
                filtersAppliedFrontel: filtersAppliedFrontel
            }),
        fetchingFilteredDataFrontel: false,
        setFetchingFilteredDataFrontel: (fetchingFilteredDataFrontel)=>set({
                fetchingFilteredDataFrontel: fetchingFilteredDataFrontel
            }),
        userDropDownValueFrontel: null,
        setUserDropDownValueFrontel: (userDropDownValueFrontel)=>set({
                userDropDownValueFrontel: userDropDownValueFrontel
            }),
        cameraDropDownValueFrontel: null,
        setCameraDropDownValueFrontel: (cameraDropDownValueFrontel)=>set({
                cameraDropDownValueFrontel: cameraDropDownValueFrontel
            }),
        groupIDFrontel: null,
        setGroupIDFrontel: (groupIDFrontel)=>set({
                groupIDFrontel: groupIDFrontel
            }),
        frontelUsername: "",
        setFrontelUsername: (frontelUsername)=>set({
                frontelUsername: frontelUsername
            }),
        groupOptionsFrontel: localStorage.parentGroups ? JSON.parse(localStorage.parentGroups) : [],
        setGroupOptionsFrontel: (groupOptionsFrontel)=>set({
                groupOptionsFrontel: groupOptionsFrontel
            }),
        loadingGroupsFrontel: false,
        setLoadingGroupsFrontel: (loadingGroupsFrontel)=>set({
                loadingGroupsFrontel: loadingGroupsFrontel
            }),
        siteDropDownValueFrontel: null,
        setSiteDropDownValueFrontel: (siteDropDownValueFrontel)=>set({
                siteDropDownValueFrontel: siteDropDownValueFrontel
            }),
        siteOptionsFrontel: [],
        setSiteOptionsFrontel: (siteOptionsFrontel)=>set({
                siteOptionsFrontel: siteOptionsFrontel
            }),
        loadingSitesFrontel: false,
        setLoadingSitesFrontel: (loadingSitesFrontel)=>set({
                loadingSitesFrontel: loadingSitesFrontel
            }),
        frontelSite: {
            site_id: "",
            site_name: ""
        },
        setFrontelSite: (frontelSite)=>set({
                frontelSite: frontelSite
            }),
        selectedRowAlertsFrontel: [],
        setSelectedRowAlertsFrontel: (selectedRowAlertsFrontel)=>set({
                selectedRowAlertsFrontel: selectedRowAlertsFrontel
            }),
        loadingCamerasFrontel: false,
        setLoadingCamerasFrontel: (loadingCamerasFrontel)=>set({
                loadingCamerasFrontel: loadingCamerasFrontel
            }),
        userFiltersFrontel: {
            user: "",
            start_date: $bdc5f018aa3d200e$var$startDate,
            end_date: $bdc5f018aa3d200e$var$endDate,
            start_time: null,
            end_time: null,
            site_ids: [],
            camera_ids: []
        },
        setUserFiltersFrontel: (userFiltersFrontel)=>set((state)=>({
                    userFiltersFrontel: typeof userFiltersFrontel === "function" ? userFiltersFrontel(state.userFiltersFrontel) : userFiltersFrontel
                })),
        cameraOptionsFrontel: [],
        setCameraOptionsFrontel: (cameraOptionsFrontel)=>set({
                cameraOptionsFrontel: cameraOptionsFrontel
            }),
        timeFiltersDisabledFrontel: false,
        setTimeFiltersDisabledFrontel: (timeFiltersDisabledFrontel)=>set({
                timeFiltersDisabledFrontel: timeFiltersDisabledFrontel
            }),
        pageLoadingFrontel: false,
        setPageLoadingFrontel: (pageLoadingFrontel)=>set({
                pageLoadingFrontel: pageLoadingFrontel
            }),
        pageFrontel: 0,
        setPageFrontel: (pageFrontel)=>set({
                pageFrontel: pageFrontel
            }),
        videoClipLoadingFrontel: false,
        setVideoClipLoadingFrontel: (videoClipLoadingFrontel)=>set({
                videoClipLoadingFrontel: videoClipLoadingFrontel
            }),
        videoURLFrontel: "",
        setVideoURLFrontel: (videoURLFrontel)=>set({
                videoURLFrontel: videoURLFrontel
            }),
        loadingAdditionalDataFrontel: false,
        setLoadingAdditionalDataFrontel: (loadingAdditionalDataFrontel)=>set({
                loadingAdditionalDataFrontel: loadingAdditionalDataFrontel
            }),
        clipsIndexOrderFrontel: {},
        setClipsIndexOrderFrontel: (clipsIndexOrderFrontel)=>set({
                clipsIndexOrderFrontel: clipsIndexOrderFrontel
            }),
        requestCounterFrontel: 0,
        setRequestCounterFrontel: (requestCounterFrontel)=>set({
                requestCounterFrontel: requestCounterFrontel
            }),
        getUserGroupsFrontel: async (navigate)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().getUserGroupsFrontel(navigate);
            };
            const { setGroupOptionsFrontel: setGroupOptionsFrontel, setLoadingGroupsFrontel: setLoadingGroupsFrontel, setShowFrontelTab: setShowFrontelTab } = get();
            setLoadingGroupsFrontel(true);
            try {
                const response = await AxiosUI.get(`immix_credential/?user_type=frontel`);
                if (response.data.length > 0) setShowFrontelTab(true);
                setGroupOptionsFrontel(response.data);
                setLoadingGroupsFrontel(false);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setGroupOptionsFrontel([]);
                    setLoadingGroupsFrontel(false);
                });
            }
        },
        getAllSitesFrontel: async (groupID, navigate)=>{
            if (!groupID) return;
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().getAllSitesFrontel(groupID, navigate);
            };
            const { setSiteOptionsFrontel: setSiteOptionsFrontel, setLoadingSitesFrontel: setLoadingSitesFrontel } = get();
            setSiteOptionsFrontel([]);
            setLoadingSitesFrontel(true);
            const allSites = [];
            // Recursive function to handle pagination
            const recursiveFunction = (apiURL)=>{
                const AxiosNextUI = (0, $64bXP.createAPIwithNextValue)(apiURL);
                AxiosNextUI.get(``).then((response)=>{
                    // Add results to the accumulated data
                    allSites.push(...response.data.results);
                    // Check if there's a next page
                    if (response.data.next) // Continue with the next page
                    recursiveFunction(response.data.next);
                    else {
                        // No more pages, set the final data and stop loading
                        setSiteOptionsFrontel(allSites);
                        setLoadingSitesFrontel(false);
                    }
                }).catch((reason)=>{
                    (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                        setSiteOptionsFrontel([]);
                        setLoadingSitesFrontel(false);
                    });
                });
            };
            try {
                const response = await AxiosUI.get(`customer/names/${groupID}/`);
                // Check if response has results array (paginated) or is the data directly
                if (response.data.results) {
                    // Add first page results
                    allSites.push(...response.data.results);
                    // Check if there are more pages
                    if (response.data.next) // Continue with pagination
                    recursiveFunction(response.data.next);
                    else {
                        // No pagination needed, set data and stop loading
                        setSiteOptionsFrontel(allSites);
                        setLoadingSitesFrontel(false);
                    }
                } else {
                    // Response is not paginated, use directly
                    setSiteOptionsFrontel(response.data);
                    setLoadingSitesFrontel(false);
                }
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setSiteOptionsFrontel([]);
                    setLoadingSitesFrontel(false);
                });
            }
        },
        getCamerasBySiteFrontel: async (siteIds, navigate)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().getCamerasBySiteFrontel(siteIds, navigate);
            };
            const { setCameraOptionsFrontel: setCameraOptionsFrontel, setLoadingCamerasFrontel: setLoadingCamerasFrontel } = get();
            setLoadingCamerasFrontel(true);
            let idString = "";
            if (siteIds.length === 1) idString = `${siteIds[0]}`;
            if (siteIds.length > 1) {
                idString = `${siteIds[0]}`;
                siteIds.forEach((id, index)=>{
                    if (index > 0) idString += `,${id}`;
                });
            }
            let allSiteCameras;
            const getSiteCamerasFrontel = (pageNumber)=>{
                AxiosUI.get(`camera/site/?customers=${idString}&page=${pageNumber}`).then((response)=>{
                    if (response.data.count > 0) {
                        if (pageNumber === 1) allSiteCameras = response.data.results;
                        if (pageNumber > 1) allSiteCameras.push(...response.data.results);
                        if (response.data.next) getSiteCamerasFrontel(pageNumber + 1);
                        else {
                            setCameraOptionsFrontel(allSiteCameras);
                            setLoadingCamerasFrontel(false);
                        }
                    } else {
                        setCameraOptionsFrontel([]);
                        setLoadingCamerasFrontel(false);
                    }
                }, (reason)=>{
                    (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                        setLoadingCamerasFrontel(false);
                    });
                });
            };
            siteIds.length === 0 ? setCameraOptionsFrontel([]) : getSiteCamerasFrontel(1);
        },
        getFrontelData: async (navigate)=>{
            const { userFiltersFrontel: userFiltersFrontel, setFrontelData: setFrontelData, getFrontelData: getFrontelData, setLoadingAdditionalDataFrontel: setLoadingAdditionalDataFrontel, setSelectedRowFrontel: setSelectedRowFrontel, getClipInfoFrontel: getClipInfoFrontel, getVideoURLFrontel: getVideoURLFrontel, setNoDataToDisplayFrontel: setNoDataToDisplayFrontel, setFetchingFilteredDataFrontel: setFetchingFilteredDataFrontel, requestCounterFrontel: requestCounterFrontel, setRequestCounterFrontel: setRequestCounterFrontel, setFrontelSite: setFrontelSite, frontelUsername: frontelUsername, setPrecisionRecallDataFrontel: setPrecisionRecallDataFrontel } = get();
            // Increment the request counter for this call
            const currentRequestId = requestCounterFrontel + 1;
            setRequestCounterFrontel(currentRequestId);
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                getFrontelData(navigate);
            };
            // Helper function to format date for API parameter
            const formatDateForAPI = (date)=>{
                if (!date) return null;
                return date.toISOString().split("T")[0]; // Get YYYY-MM-DD format
            };
            // Helper function to format time for API parameter
            const formatTimeForAPI = (time)=>{
                if (!time) return null;
                return time.toTimeString().split(" ")[0].substring(0, 5); // Get HH:MM format
            };
            let searchString = "";
            if (userFiltersFrontel.site_ids[0] && !userFiltersFrontel.camera_ids[0]) searchString += `customer_id=${userFiltersFrontel.site_ids[0]}`;
            else if (userFiltersFrontel.camera_ids[0]) searchString += `camera_id=${userFiltersFrontel.camera_ids[0]}`;
            const allData = [];
            setLoadingAdditionalDataFrontel(true);
            // Add date and time parameters
            const startDate = formatDateForAPI(userFiltersFrontel.start_date);
            const endDate = formatDateForAPI(userFiltersFrontel.end_date);
            const startTime = formatTimeForAPI(userFiltersFrontel.start_time);
            const endTime = formatTimeForAPI(userFiltersFrontel.end_time);
            if (startDate) searchString += searchString ? `&start_date=${startDate}` : `start_date=${startDate}`;
            if (endDate) searchString += searchString ? `&end_date=${endDate}` : `end_date=${endDate}`;
            if (startTime) searchString += searchString ? `&start_time=${startTime}` : `start_time=${startTime}`;
            if (endTime) searchString += searchString ? `&end_time=${endTime}` : `end_time=${endTime}`;
            // The clip list endpoint does not return a DRF-style `next` URL — it
            // returns cursor keys (`last_timestamp` / `last_file_id`) and `count` is
            // the number of results in THIS page (page_size defaults to 100). A full
            // page (count === 100) with cursor keys means there may be more data.
            const recursiveFunction = (lastTimestamp, lastFileId)=>{
                AxiosUI.get(`clip/?username=${frontelUsername}&${searchString}` + `&last_timestamp=${encodeURIComponent(lastTimestamp)}` + `&last_file_id=${encodeURIComponent(lastFileId)}`).then((response)=>{
                    // Check if this is still the most recent request
                    const { requestCounterFrontel: requestCounterFrontel } = get();
                    if (requestCounterFrontel !== currentRequestId) // This is an outdated request, ignore the response
                    return;
                    // Add selected property to each item as we receive it (only first item of first batch is selected)
                    const resultsWithSelection = response.data.results.map((item)=>({
                            ...item,
                            selected: false
                        }));
                    allData.push(...resultsWithSelection);
                    // Fold this page's per-day summary into the accumulated totals
                    if (response.data.summary && response.data.summary.length > 0) setPrecisionRecallDataFrontel($bdc5f018aa3d200e$export$ef0c922ba1a90e13(get().precisionRecallDataFrontel, response.data.summary));
                    // Preserve current selection when adding new data
                    const currentFrontelData = get().frontelData;
                    const currentlySelectedClipId = currentFrontelData.find((item)=>item.selected)?.file_id;
                    // Update allData to preserve the current selection
                    const updatedAllData = allData.map((item)=>({
                            ...item,
                            selected: item.file_id === currentlySelectedClipId
                        }));
                    // Check if we should continue pagination
                    const shouldContinuePagination = response.data.count === 100 && response.data.last_timestamp && response.data.last_file_id && window.location.href.includes("clips") && response.data.results.length > 0;
                    if (shouldContinuePagination) {
                        setFrontelData(updatedAllData);
                        recursiveFunction(response.data.last_timestamp, response.data.last_file_id);
                        setNoDataToDisplayFrontel(false);
                        setFetchingFilteredDataFrontel(false);
                    } else {
                        setFrontelData(updatedAllData);
                        setLoadingAdditionalDataFrontel(false);
                        setNoDataToDisplayFrontel(false);
                        setFetchingFilteredDataFrontel(false);
                    }
                }, ()=>{
                    // A failed additional page should not strand the loading spinner —
                    // keep whatever data was already accumulated.
                    const { requestCounterFrontel: requestCounterFrontel } = get();
                    if (requestCounterFrontel !== currentRequestId) return;
                    setLoadingAdditionalDataFrontel(false);
                    setFetchingFilteredDataFrontel(false);
                });
            };
            try {
                const response = await AxiosUI.get(`clip/?username=${frontelUsername}&${searchString}`);
                // Check if this is still the most recent request
                const { requestCounterFrontel: currentCounter } = get();
                if (currentCounter !== currentRequestId) // This is an outdated request, ignore the response
                return;
                // Add selected property to each item as we receive it
                const resultsWithSelection = response.data.results.map((item, index)=>({
                        ...item,
                        selected: allData.length === 0 && index === 0
                    }));
                allData.push(...resultsWithSelection);
                if (response.data.customer) setFrontelSite({
                    site_id: response.data.customer.id,
                    site_name: response.data.customer.name
                });
                // Set precision and recall data from response summary (raw array for
                // daily breakdown). Always reset here so a new request never merges
                // additional pages into a previous request's totals.
                setPrecisionRecallDataFrontel(response.data.summary || []);
                if (response.data.count === 0 || allData.length === 0) {
                    setNoDataToDisplayFrontel(true);
                    setLoadingAdditionalDataFrontel(false);
                    setFetchingFilteredDataFrontel(false);
                } else if (response.data.count === 100 && response.data.last_timestamp && response.data.last_file_id) {
                    // Full page — continue fetching with the cursor keys the endpoint
                    // returns (it has no DRF-style `next` URL).
                    setNoDataToDisplayFrontel(false);
                    setFrontelData(allData);
                    if (allData.length > 0) {
                        setSelectedRowFrontel(allData[0]);
                        getClipInfoFrontel(allData[0].file_id, navigate);
                        getVideoURLFrontel(allData[0].file_id, navigate);
                    }
                    recursiveFunction(response.data.last_timestamp, response.data.last_file_id);
                } else {
                    setNoDataToDisplayFrontel(false);
                    setFrontelData(allData);
                    if (allData.length > 0) {
                        setSelectedRowFrontel(allData[0]);
                        getClipInfoFrontel(allData[0].file_id, navigate);
                        getVideoURLFrontel(allData[0].file_id, navigate);
                    }
                    setLoadingAdditionalDataFrontel(false);
                    setFetchingFilteredDataFrontel(false);
                }
            } catch (reason) {
                // Check if this is still the most recent request before handling error
                const { requestCounterFrontel: currentCounter } = get();
                if (currentCounter !== currentRequestId) // This is an outdated request, ignore the error
                return;
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setFrontelData(allData);
                    setFetchingFilteredDataFrontel(false);
                });
            }
        },
        getClipInfoFrontel: async (file_id, navigate)=>{
            // The clip list endpoint only returns summary fields — detail fields such
            // as internal_id (Internal Log ID), fps, slice and stationary_filter only
            // come back from clip/info/. Fetch them and merge into the selected row,
            // matching how the AILink and Sentinel tabs enrich their selection.
            const { getClipInfoFrontel: getClipInfoFrontel, frontelUsername: frontelUsername } = get();
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                getClipInfoFrontel(file_id, navigate);
            };
            try {
                const response = await AxiosUI.get(`clip/info/?username=${frontelUsername}&file_id=${file_id}`);
                if (response.data && response.data.file_id) {
                    const { selectedRowFrontel: selectedRowFrontel, setSelectedRowFrontel: setSelectedRowFrontel } = get();
                    // Only merge if this clip is still the selected one (the user may
                    // have clicked another row while the request was in flight)
                    if (selectedRowFrontel?.file_id === response.data.file_id) {
                        const updatedRow = {
                            ...selectedRowFrontel,
                            ...response.data
                        };
                        setSelectedRowFrontel(updatedRow);
                        localStorage.setItem("clipsSelectedRow", JSON.stringify(updatedRow));
                    }
                }
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                // Keep the list-row data if the detail fetch fails
                });
            }
        },
        getVideoURLFrontel: async (file_id, navigate)=>{
            const { getVideoURLFrontel: getVideoURLFrontel, setVideoClipLoadingFrontel: setVideoClipLoadingFrontel, setVideoURLFrontel: setVideoURLFrontel, frontelUsername: frontelUsername } = get();
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                getVideoURLFrontel(file_id, navigate);
            };
            setVideoClipLoadingFrontel(true);
            try {
                const response = await AxiosUI.get(`clip/url/?username=${frontelUsername}&file_id=${file_id}`);
                setVideoURLFrontel(response.data);
                setVideoClipLoadingFrontel(false);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setVideoClipLoadingFrontel(false);
                });
            }
        },
        getSiteTimeZone: async (site_id, navigate)=>{
            const { getSiteTimeZone: getSiteTimeZone, setSiteTimeZoneSMTP: setSiteTimeZoneSMTP } = get();
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                getSiteTimeZone(site_id, navigate);
            };
            try {
                const response = await AxiosUI.get(`customer/${site_id}/about`);
                setSiteTimeZoneSMTP(response.data.timezone);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setSiteTimeZoneSMTP("");
                });
            }
        },
        resetState: ()=>set({
                // SMTP state
                smtpData: [],
                precisionRecallDataSMTP: {},
                selectedRowSMTP: {},
                selectedClipSMTPMedia: [],
                activeClipsTab: "",
                noDataToDisplaySMTP: true,
                filtersAppliedSMTP: false,
                fetchingFilteredDataSMTP: false,
                userDropDownValueSMTP: null,
                cameraDropDownValueSMTP: null,
                groupIDSMTP: null,
                groupOptionsSMTP: [],
                loadingGroupsSMTP: false,
                siteDropDownValueSMTP: null,
                siteOptionsSMTP: [],
                loadingSitesSMTP: false,
                loadingCamerasSMTP: false,
                userFiltersSMTP: {
                    user: "",
                    group_id: null,
                    start_date: $bdc5f018aa3d200e$var$startDate,
                    end_date: $bdc5f018aa3d200e$var$endDate,
                    start_time: null,
                    end_time: null,
                    site_ids: [],
                    camera_ids: []
                },
                cameraOptionsSMTP: [],
                timeFiltersDisabledSMTP: false,
                pageLoadingSMTP: false,
                pageSMTP: 0,
                videoClipLoadingSMTP: false,
                loadingAdditionalDataSMTP: false,
                clipsIndexOrderSMTP: {},
                allAlertsDialogOpen: false,
                falsePositiveReductionDialogOpen: false,
                requestCounterSMTP: 0,
                downloadURLSMTP: "",
                downloadURLAILink: "",
                downloadURLSentinel: "",
                smtpTableFilter: "all",
                siteTimeZoneSMTP: "",
                // Frontel state
                frontelData: [],
                precisionRecallDataFrontel: [],
                selectedRowFrontel: {},
                selectedClipFrontelMedia: [],
                noDataToDisplayFrontel: true,
                showMoreDialogOpenFrontel: false,
                verifiedClickedFrontel: false,
                unverifiedClickedFrontel: false,
                filtersAppliedFrontel: false,
                fetchingFilteredDataFrontel: false,
                userDropDownValueFrontel: null,
                cameraDropDownValueFrontel: null,
                groupIDFrontel: null,
                frontelUsername: "",
                // do not reset groupOptionsFrontel - it is loaded at login and must persist when opening Clips
                loadingGroupsFrontel: false,
                siteDropDownValueFrontel: null,
                siteOptionsFrontel: [],
                loadingSitesFrontel: false,
                loadingCamerasFrontel: false,
                frontelSite: {
                    site_id: "",
                    site_name: ""
                },
                selectedRowAlertsFrontel: [],
                userFiltersFrontel: {
                    user: "",
                    start_date: $bdc5f018aa3d200e$var$startDate,
                    end_date: $bdc5f018aa3d200e$var$endDate,
                    start_time: null,
                    end_time: null,
                    site_ids: [],
                    camera_ids: []
                },
                cameraOptionsFrontel: [],
                timeFiltersDisabledFrontel: false,
                pageLoadingFrontel: false,
                pageFrontel: 0,
                videoClipLoadingFrontel: false,
                videoURLFrontel: "",
                loadingAdditionalDataFrontel: false,
                clipsIndexOrderFrontel: {},
                requestCounterFrontel: 0
            })
    }));

});
parcelRegister("64bXP", function(module, exports) {

$parcel$export(module.exports, "createAPIwithNextValue", () => $0a40dbe8d87b1252$export$342352fae54160f9);

var $7pFvC = parcelRequire("7pFvC");

var $5BK6w = parcelRequire("5BK6w");
const $0a40dbe8d87b1252$export$342352fae54160f9 = (path)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($7pFvC))).create({
        baseURL: `${path}`,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${(0, $5BK6w.getCookie)("token")}`
        }
    });
};

});

parcelRegister("6Bo1T", function(module, exports) {

$parcel$export(module.exports, "generateDownloadString", () => $aead4e54e4a9a362$export$49366e261893928e);

var $4G44R = parcelRequire("4G44R");

var $5L5iJ = parcelRequire("5L5iJ");
const $aead4e54e4a9a362$export$49366e261893928e = ()=>{
    const { userFiltersSMTP: userFiltersSMTP } = (0, $4G44R.useClipsStore).getState();
    // Get customer_id from site_ids (first site ID)
    const customer_id = userFiltersSMTP.site_ids && userFiltersSMTP.site_ids.length > 0 ? parseInt(userFiltersSMTP.site_ids[0]) : null;
    // Get camera_id from camera_ids (first camera ID)
    const camera_id = userFiltersSMTP.camera_ids && userFiltersSMTP.camera_ids.length > 0 ? parseInt(userFiltersSMTP.camera_ids[0]) : null;
    // Format dates to YYYY-MM-DD
    const start_date = userFiltersSMTP.start_date ? (0, $5L5iJ.yyyymmddGenerator)(userFiltersSMTP.start_date) : "";
    const end_date = userFiltersSMTP.end_date ? (0, $5L5iJ.yyyymmddGenerator)(userFiltersSMTP.end_date) : "";
    // Format times to HH:MM
    const formatTimeForAPI = (time)=>{
        if (!time) return "";
        return time.toTimeString().split(" ")[0].substring(0, 5); // Get HH:MM format
    };
    const start_time = formatTimeForAPI(userFiltersSMTP.start_time);
    const end_time = formatTimeForAPI(userFiltersSMTP.end_time);
    // Build query parameters
    const params = [];
    // Prefer the narrowest scope the user has selected: a specific camera, then
    // a specific site, otherwise the whole group. Previously an empty
    // customer_id was always sent when no site was picked, which could never
    // resolve to a group-wide report.
    if (userFiltersSMTP.camera_ids.length !== 0) params.push(`camera_id=${camera_id || ""}`);
    else if (userFiltersSMTP.site_ids.length !== 0) params.push(`customer_id=${customer_id}`);
    else if (userFiltersSMTP.group_id) params.push(`group_id=${userFiltersSMTP.group_id}`);
    if (start_date) params.push(`start_date=${start_date}`);
    if (end_date) params.push(`end_date=${end_date}`);
    if (start_time) params.push(`start_time=${start_time}`);
    if (end_time) params.push(`end_time=${end_time}`);
    return `?${params.join("&")}`;
};

});
parcelRegister("5L5iJ", function(module, exports) {

$parcel$export(module.exports, "yyyymmddGenerator", () => $a0149f1c7bbf70d7$export$732b5204593a9bfe);
const $a0149f1c7bbf70d7$export$732b5204593a9bfe = (inputDate)=>{
    if (!inputDate) return "";
    if (inputDate.toString().length < 25) return inputDate.toString().slice(0, 10);
    const year = inputDate.getFullYear();
    let month = "0";
    let date = "0";
    if (inputDate.getMonth() < 9) month = `0${inputDate.getMonth() + 1}`;
    if (inputDate.getMonth() > 8) month = `${inputDate.getMonth() + 1}`;
    if (inputDate.getDate() < 10) date = `0${inputDate.getDate()}`;
    if (inputDate.getDate() > 9) date = `${inputDate.getDate()}`;
    return `${year}-${month}-${date}`;
};

});


parcelRegister("bdLns", function(module, exports) {

$parcel$export(module.exports, "generateDownloadStringAILink", () => $6576f07aba6113f0$export$4088db09a953acc6);

var $5L5iJ = parcelRequire("5L5iJ");

var $gk2F6 = parcelRequire("gk2F6");

var $9OM1a = parcelRequire("9OM1a");
const $6576f07aba6113f0$export$4088db09a953acc6 = (userFilters, groupID)=>{
    const convertTimeToUTCFormat = (time)=>{
        const [hours, minutes] = time.split(":");
        return encodeURIComponent(`${hours}:${minutes}`);
    };
    const sameDay = userFilters.start_date !== null && userFilters.end_date !== null && userFilters.start_date.toString() === userFilters.end_date.toString();
    let searchParamsString = `?username=${userFilters.user}&start_date=${(0, $5L5iJ.yyyymmddGenerator)(userFilters.start_date)}&end_date=${(0, $5L5iJ.yyyymmddGenerator)(userFilters.end_date)}`;
    if (sameDay && userFilters.start_time !== null) searchParamsString += `&start_time=${convertTimeToUTCFormat((0, $gk2F6.timeSlicer)(userFilters.start_time))}`;
    if (sameDay && userFilters.end_time !== null) searchParamsString += `&end_time=${convertTimeToUTCFormat((0, $gk2F6.timeSlicer)(userFilters.end_time))}`;
    if (userFilters.ground_truth) searchParamsString += `&ground_truth=${userFilters.ground_truth}`;
    searchParamsString += (0, $9OM1a.clipResultParam)(userFilters.clip_result);
    if (userFilters.site_ids[0]) searchParamsString += `&site_ids=${userFilters.site_ids[0]}`;
    if (userFilters.camera_ids[0]) searchParamsString += `&camera_ids=${userFilters.camera_ids[0]}`;
    // Scope the report to the selected group rather than the whole parent
    // account (username), which can span multiple groups.
    if (groupID) searchParamsString += `&group_id=${groupID}`;
    return searchParamsString;
};

});
parcelRegister("gk2F6", function(module, exports) {

$parcel$export(module.exports, "timeSlicer", () => $589648adafc4d1ad$export$c5cd67fd93565ebb);
parcelRequire("8T3gX");
const $589648adafc4d1ad$export$c5cd67fd93565ebb = (time)=>{
    if (time !== null) return time.toString().slice(16, 24);
    else return "";
};

});

parcelRegister("9OM1a", function(module, exports) {

$parcel$export(module.exports, "clipResultParam", () => $f9eab1109fb00e1e$export$347d9ba65af6d667);
/**
 * The `&clip_result=` query fragment for a Clip Result filter value, or ""
 * when the filter should not narrow the request.
 *
 * The Clip Result dropdown offers "All", but the clip list and report
 * endpoints only accept Verified, Unverified, Faulted and Unprocessed
 * (actuate_admin `ClipParamSerializer.clip_result`); `clip_result=All` is a
 * 400. "All" therefore means "no filter", the same as a blank dropdown.
 */ const $f9eab1109fb00e1e$export$347d9ba65af6d667 = (clipResult)=>{
    if (!clipResult || clipResult === "All") return "";
    return `&clip_result=${encodeURIComponent(clipResult)}`;
};

});


parcelRegister("4JjIi", function(module, exports) {

$parcel$export(module.exports, "generateDownloadStringSentinel", () => $c428b7e4fed92689$export$4306993cbad8c6c8);

var $gk2F6 = parcelRequire("gk2F6");

var $88GbJ = parcelRequire("88GbJ");

var $9OM1a = parcelRequire("9OM1a");
const $c428b7e4fed92689$export$4306993cbad8c6c8 = (userFiltersSentinel)=>{
    const convertTimeToUTCFormat = (time)=>{
        const [hours, minutes] = time.split(":");
        return encodeURIComponent(`${hours}:${minutes}`);
    };
    const sameDay = userFiltersSentinel.start_date !== null && userFiltersSentinel.end_date !== null && userFiltersSentinel.start_date.toString() === userFiltersSentinel.end_date.toString();
    let searchParamsString = `?username=${userFiltersSentinel.user}`;
    if (userFiltersSentinel.site_ids[0]) searchParamsString += `&site_ids=${userFiltersSentinel.site_ids[0]}`;
    if (userFiltersSentinel.camera_ids[0]) searchParamsString += `&camera_ids=${userFiltersSentinel.camera_ids[0]}`;
    if (userFiltersSentinel.start_date) searchParamsString += `&start_date=${(0, $88GbJ.formatSentinalDate)(userFiltersSentinel.start_date)}`;
    if (userFiltersSentinel.end_date) searchParamsString += `&end_date=${(0, $88GbJ.formatSentinalDate)(userFiltersSentinel.end_date)}`;
    if (sameDay && userFiltersSentinel.start_time !== null) searchParamsString += `&start_time=${convertTimeToUTCFormat((0, $gk2F6.timeSlicer)(userFiltersSentinel.start_time))}`;
    if (sameDay && userFiltersSentinel.end_time !== null) searchParamsString += `&end_time=${convertTimeToUTCFormat((0, $gk2F6.timeSlicer)(userFiltersSentinel.end_time))}`;
    searchParamsString += (0, $9OM1a.clipResultParam)(userFiltersSentinel.clip_result);
    // Scope the report to the selected group rather than the whole parent
    // account (username), which can span multiple groups.
    if (userFiltersSentinel.group_id) searchParamsString += `&group_id=${userFiltersSentinel.group_id}`;
    return searchParamsString;
};

});
parcelRegister("88GbJ", function(module, exports) {

$parcel$export(module.exports, "formatSentinalDate", () => $6afe9954eb90d987$export$40a2e198e1ea9605);
$parcel$export(module.exports, "getSentinelClipsWithQuerry", () => $6afe9954eb90d987$export$4739d1665e450890);
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $6II5K = parcelRequire("6II5K");

var $3Zv1D = parcelRequire("3Zv1D");

var $w8ml8 = parcelRequire("w8ml8");

var $gk2F6 = parcelRequire("gk2F6");

var $9OM1a = parcelRequire("9OM1a");
let $6afe9954eb90d987$var$activeSentinelQueryId = "";
// The page-1 request currently in flight, keyed by its URL. On a cold load
// LaunchDarklyProvider re-parents the app once it initializes, which remounts
// <Clips> and launches a second, identical fetch chain (BT-1070). The second
// chain wins the `activeSentinelQueryId` race and used to fire its own copy of
// a 10–20s request, so the user always waited for the slower of the two.
// Sharing the in-flight promise lets the surviving chain consume the response
// the first chain already paid for (ENG-1502).
let $6afe9954eb90d987$var$inFlightInitialSentinelRequest = null;
// Returns the subset of `results` whose file_id is not already present in
// `previousState`. Guards against duplicate rows — and the inflated clip
// counts / precision-recall totals they cause — when more than one paginator
// chain accumulates through the same state setters (see BT-1070 above).
//
// Callers assign this helper's return value to a local from INSIDE a
// setSentinelData updater and branch on it right after. That relies on React
// 17 running the updater synchronously when setState is called outside event
// handlers. Under React 18 automatic batching the updater is deferred, the
// local would still be empty at the branch, and the precision/recall summary
// would silently never be folded — restructure this pattern before upgrading.
const $6afe9954eb90d987$var$dedupeNewSentinelResults = (previousState, results)=>{
    const existingFileIds = new Set((previousState || []).map((clip)=>clip && clip.file_id));
    return (results || []).filter((clip)=>clip && clip.file_id && !existingFileIds.has(clip.file_id));
};
const $6afe9954eb90d987$export$40a2e198e1ea9605 = (dateStr)=>{
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // getMonth() returns 0-11, +1 to make it 1-12
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
};
const $6afe9954eb90d987$var$storeSentinelCursor = (lastFileId, lastTimeStamp)=>{
    localStorage.setItem("last_file_id_sentinal", JSON.stringify(lastFileId));
    localStorage.setItem("last_timestamp_sentinal", JSON.stringify(lastTimeStamp));
};
const $6afe9954eb90d987$export$4739d1665e450890 = (setSentinelData, setPageLoadingSentinel, setSelectedRowSentinel, setPrecisionRecallDataSentinel, setVideoURLSentinel, setVideoClipLoadingSentinel, setClipsIndexOrderSentinel, selectedRowSentinel, setNoDataToDisplaySentinel, setSiteOptionsSentinel, setLoadingSitesSentinel, userFiltersSentinel, setFetchingFilteredDataSentinel, setPageSentinel, lastTimeStamp, lastFileId, moreThan100, setLoadingAdditionalData, navigate, queryId)=>{
    const isInitialQuery = !moreThan100 && !lastTimeStamp && !lastFileId;
    if (queryId && queryId !== $6afe9954eb90d987$var$activeSentinelQueryId) // A retry or next page from a chain that has been superseded — by the
    // LaunchDarkly remount or by the user applying new filters. Letting it
    // run again used to re-activate it below, so a token-refresh retry from
    // the unmounted instance could win the race and the live instance's own
    // response was then discarded, leaving the spinner up forever (ENG-1528).
    return;
    const effectiveQueryId = queryId ?? (isInitialQuery ? `${Date.now()}-${Math.random().toString(36).slice(2)}` : $6afe9954eb90d987$var$activeSentinelQueryId);
    if (isInitialQuery && !queryId) {
        // Only a brand-new initial query becomes the active chain; a retry keeps
        // whatever id it was given and must not re-activate it.
        $6afe9954eb90d987$var$activeSentinelQueryId = effectiveQueryId;
        setPageSentinel(0);
    }
    const convertTimeToUTCFormat = (time)=>{
        const [hours, minutes, seconds] = time.split(":");
        return encodeURIComponent(`${hours}:${minutes}`);
    };
    const shouldDeferInitialSelectionForUrlFileId = (()=>{
        if (typeof window === "undefined") return false;
        if (!window.location.pathname.includes("/clips")) return false;
        const params = new URLSearchParams(window.location.search);
        return params.get("tab") === "sentinel" && !!params.get("file_id");
    })();
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $6afe9954eb90d987$export$4739d1665e450890(setSentinelData, setPageLoadingSentinel, setSelectedRowSentinel, setPrecisionRecallDataSentinel, setVideoURLSentinel, setVideoClipLoadingSentinel, setClipsIndexOrderSentinel, selectedRowSentinel, setNoDataToDisplaySentinel, setSiteOptionsSentinel, setLoadingSitesSentinel, userFiltersSentinel, setFetchingFilteredDataSentinel, setPageSentinel, lastTimeStamp, lastFileId, moreThan100, setLoadingAdditionalData, navigate, effectiveQueryId);
    };
    const fetchNextPage = (nextTimeStamp, nextFileId)=>{
        $6afe9954eb90d987$export$4739d1665e450890(setSentinelData, setPageLoadingSentinel, setSelectedRowSentinel, setPrecisionRecallDataSentinel, setVideoURLSentinel, setVideoClipLoadingSentinel, setClipsIndexOrderSentinel, selectedRowSentinel, setNoDataToDisplaySentinel, setSiteOptionsSentinel, setLoadingSitesSentinel, userFiltersSentinel, setFetchingFilteredDataSentinel, setPageSentinel, nextTimeStamp, nextFileId, true, setLoadingAdditionalData, navigate, effectiveQueryId);
    };
    let searchParamsString = ``;
    if (userFiltersSentinel.site_ids[0]) searchParamsString += `&site_ids=${userFiltersSentinel.site_ids[0]}`;
    if (userFiltersSentinel.camera_ids[0]) searchParamsString += `&camera_ids=${userFiltersSentinel.camera_ids[0]}`;
    if (userFiltersSentinel.start_date) searchParamsString += `&start_date=${$6afe9954eb90d987$export$40a2e198e1ea9605(userFiltersSentinel.start_date)}`;
    if (userFiltersSentinel.end_date) searchParamsString += `&end_date=${$6afe9954eb90d987$export$40a2e198e1ea9605(userFiltersSentinel.end_date)}`;
    if (userFiltersSentinel.start_date.toString() === userFiltersSentinel.end_date.toString() && userFiltersSentinel.start_time !== null) searchParamsString += `&start_time=${convertTimeToUTCFormat((0, $gk2F6.timeSlicer)(userFiltersSentinel.start_time))}`;
    if (userFiltersSentinel.start_date.toString() === userFiltersSentinel.end_date.toString() && userFiltersSentinel.end_time !== null) searchParamsString += `&end_time=${convertTimeToUTCFormat((0, $gk2F6.timeSlicer)(userFiltersSentinel.end_time))}`;
    searchParamsString += (0, $9OM1a.clipResultParam)(userFiltersSentinel.clip_result);
    if (lastTimeStamp) searchParamsString += `&last_timestamp=${lastTimeStamp}`;
    if (lastFileId) searchParamsString += `&last_file_id=${lastFileId}`;
    searchParamsString += `&page_size=100`;
    const requestUrl = `clip/?username=${userFiltersSentinel.user}${searchParamsString}`;
    const stillOnClipsPage = ()=>window.location.href.includes("clips");
    // Every chain ends here: nothing more to fetch (or nothing more we can fetch).
    const finishPagination = ()=>{
        setFetchingFilteredDataSentinel(false);
        setLoadingAdditionalData(false);
    };
    // Merge this page's rows into state and fold its summary into the running
    // precision/recall totals — only when the page actually contributed new
    // clips, so a duplicate page fetched by a racing chain can't inflate them.
    const appendPage = (results, summary)=>{
        setNoDataToDisplaySentinel(false);
        let freshResults = [];
        setSentinelData((previousState)=>{
            freshResults = $6afe9954eb90d987$var$dedupeNewSentinelResults(previousState, results);
            return (0, $6II5K.addSelectedParam)([
                ...previousState,
                ...freshResults
            ], setClipsIndexOrderSentinel, lastFileId);
        });
        if (freshResults.length > 0) {
            const responsePrecisionRecall = (0, $w8ml8.totalUpPrecisionRecallData)(summary);
            setPrecisionRecallDataSentinel((previousState)=>{
                return {
                    date: responsePrecisionRecall.date,
                    date_str: responsePrecisionRecall.date_str,
                    true_positives: responsePrecisionRecall.true_positives + previousState.true_positives,
                    false_positives: responsePrecisionRecall.false_positives + previousState.false_positives,
                    false_negatives: responsePrecisionRecall.false_negatives + previousState.false_negatives,
                    true_negatives: responsePrecisionRecall.true_negatives + previousState.true_negatives,
                    unclassified: responsePrecisionRecall.unclassified + previousState.unclassified,
                    total_clips: responsePrecisionRecall.total_clips + previousState.total_clips,
                    precision: previousState.precision || responsePrecisionRecall.precision,
                    recall: previousState.recall || responsePrecisionRecall.recall
                };
            });
        }
    };
    // A full page means there may be more. Prefer the cursor the API hands back.
    // Older admin builds answer `count == page_size` with a null cursor (the
    // DynamoDB key was dropped while accumulating filtered pages, ENG-1501); in
    // that case derive one from the OLDEST row of this page so the next request
    // starts where this one ended. The old fallback keyed off `results[0]`, the
    // NEWEST row, which re-fetched the same page shifted by a single clip —
    // one 8–12s request per additional clip.
    const continuePagination = (results, data)=>{
        if (!stillOnClipsPage()) {
            finishPagination();
            return;
        }
        if (data.last_timestamp && data.last_file_id) {
            $6afe9954eb90d987$var$storeSentinelCursor(data.last_file_id, data.last_timestamp);
            fetchNextPage(data.last_timestamp, data.last_file_id);
            return;
        }
        const oldestRow = results[results.length - 1];
        if (!oldestRow || !oldestRow.file_id) {
            finishPagination();
            return;
        }
        AxiosUI.get(`clip/info/?username=${userFiltersSentinel.user}&file_id=${oldestRow.file_id}`).then((infoResponse)=>{
            if (infoResponse.data.event_timestamp && infoResponse.data.file_id && stillOnClipsPage()) {
                $6afe9954eb90d987$var$storeSentinelCursor(infoResponse.data.file_id, infoResponse.data.event_timestamp);
                fetchNextPage(infoResponse.data.event_timestamp, infoResponse.data.file_id);
            } else finishPagination();
        }, ()=>finishPagination());
    };
    // Select the first clip of a fresh result set and load its video, then
    // hand off to `onVideoReady` (continue paging, or finish).
    const selectFirstRow = (results, onVideoReady)=>{
        setSelectedRowSentinel(results[0]);
        AxiosUI.get(`clip/info/?username=${userFiltersSentinel.user}&file_id=${results[0].file_id}`).then((infoResponse)=>{
            if (!infoResponse.data.file_id) {
                setFetchingFilteredDataSentinel(false);
                setPageLoadingSentinel(false);
                onVideoReady();
                return;
            }
            // One merged update. A setState per field re-rendered <Clips> once per
            // field (React 17 does not batch outside event handlers) — a multi-second
            // main-thread stall between clip/info and clip/url (ENG-1508).
            setSelectedRowSentinel((previousState)=>({
                    ...previousState,
                    ...infoResponse.data
                }));
            localStorage.setItem("investigationSelectedRow", JSON.stringify(selectedRowSentinel));
            AxiosUI.get(`clip/url/?username=${userFiltersSentinel.user}&file_id=${infoResponse.data.file_id}`).then((urlResponse)=>{
                setVideoURLSentinel(urlResponse.data);
                setVideoClipLoadingSentinel(false);
                setFetchingFilteredDataSentinel(false);
                setPageLoadingSentinel(false);
                onVideoReady();
            }, (reason)=>{
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setNoDataToDisplaySentinel(false);
                    setVideoClipLoadingSentinel(false);
                    setFetchingFilteredDataSentinel(false);
                    setLoadingAdditionalData(false);
                });
            });
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                setVideoClipLoadingSentinel(false);
                setFetchingFilteredDataSentinel(false);
                setPageLoadingSentinel(false);
                setLoadingAdditionalData(false);
            });
        });
    };
    let request;
    if (isInitialQuery && $6afe9954eb90d987$var$inFlightInitialSentinelRequest && $6afe9954eb90d987$var$inFlightInitialSentinelRequest.url === requestUrl) request = $6afe9954eb90d987$var$inFlightInitialSentinelRequest.promise;
    else {
        request = AxiosUI.get(requestUrl);
        if (isInitialQuery) {
            const entry = {
                url: requestUrl,
                promise: request
            };
            $6afe9954eb90d987$var$inFlightInitialSentinelRequest = entry;
            const release = ()=>{
                if ($6afe9954eb90d987$var$inFlightInitialSentinelRequest === entry) $6afe9954eb90d987$var$inFlightInitialSentinelRequest = null;
            };
            request.then(release, release);
        }
    }
    request.then((response)=>{
        if (!effectiveQueryId || effectiveQueryId !== $6afe9954eb90d987$var$activeSentinelQueryId) return;
        let lastFileIdSentinal = "";
        if (localStorage.last_file_id_sentinal) lastFileIdSentinal = JSON.parse(localStorage.last_file_id_sentinal);
        let lastTimeStampSentinal = "";
        if (localStorage.last_timestamp_sentinal) lastTimeStampSentinal = JSON.parse(localStorage.last_timestamp_sentinal);
        const isCurrentCursor = lastFileIdSentinal === lastFileId && lastTimeStampSentinal === lastTimeStamp || !lastFileId || !lastTimeStamp;
        if (!isCurrentCursor) return;
        const results = response.data.results || [];
        const hasResults = !!results[0];
        if (!hasResults) {
            if (!moreThan100) setNoDataToDisplaySentinel(true);
            finishPagination();
            return;
        }
        appendPage(results, response.data.summary);
        if (!moreThan100) {
            // The rows are what the user is waiting for; the video pane shows its
            // own loading state until clip/url resolves (ENG-1508).
            setFetchingFilteredDataSentinel(false);
            setPageLoadingSentinel(false);
        }
        const isFullPage = response.data.count === 100;
        const shouldSelectFirstRow = !moreThan100 && !shouldDeferInitialSelectionForUrlFileId;
        if (isFullPage) {
            if (shouldSelectFirstRow) selectFirstRow(results, ()=>continuePagination(results, response.data));
            else continuePagination(results, response.data);
            return;
        }
        // Short page: this is the last one.
        if (shouldSelectFirstRow) selectFirstRow(results, finishPagination);
        else {
            if (!moreThan100) setPageLoadingSentinel(false);
            finishPagination();
        }
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setFetchingFilteredDataSentinel(false);
            setPageLoadingSentinel(false);
            setLoadingAdditionalData(false);
        });
    });
};

});
parcelRegister("6II5K", function(module, exports) {

$parcel$export(module.exports, "addSelectedParam", () => $41ead1034173dc89$export$757e1f3622a319eb);
parcelRequire("8T3gX");
const $41ead1034173dc89$export$757e1f3622a319eb = (data, setClipsIndexOrder, lastFileId)=>{
    const newData = [];
    const indexOrder = [];
    data.forEach((object, index)=>{
        indexOrder.push(index);
        const newObject = object;
        if (!object.selected) {
            if (index === 0 && !lastFileId) {
                newObject.selected = true;
                newObject.index = index;
            } else {
                newObject.selected = false;
                newObject.index = index;
            }
        }
        newData.push(newObject);
    });
    setClipsIndexOrder(indexOrder);
    return newData;
};

});

parcelRegister("w8ml8", function(module, exports) {

$parcel$export(module.exports, "createEmptyPrecisionRecallData", () => $1c25662803cb8f79$export$58bf7bc44f3318b2);
$parcel$export(module.exports, "totalUpPrecisionRecallData", () => $1c25662803cb8f79$export$2c0c8ff0a97ba9c6);
parcelRequire("8T3gX");
const $1c25662803cb8f79$export$58bf7bc44f3318b2 = ()=>({
        date: "",
        date_str: "",
        true_positives: 0,
        false_positives: 0,
        false_negatives: 0,
        true_negatives: 0,
        unclassified: 0,
        total_clips: 0,
        precision: null,
        recall: null
    });
const $1c25662803cb8f79$export$2c0c8ff0a97ba9c6 = (precisionRecallData)=>{
    const returnedData = {
        date: "",
        date_str: precisionRecallData[0].date_str,
        true_positives: 0,
        false_positives: 0,
        false_negatives: 0,
        true_negatives: 0,
        unclassified: 0,
        total_clips: 0,
        precision: null,
        recall: null
    };
    if (precisionRecallData.length > 1) returnedData.date_str = `${precisionRecallData[precisionRecallData.length - 1].date_str} - ${returnedData.date_str}`;
    precisionRecallData.forEach((object)=>{
        returnedData.true_positives = returnedData.true_positives + object.true_positives;
        returnedData.false_positives = returnedData.false_positives + object.false_positives;
        returnedData.false_negatives = returnedData.false_negatives + object.false_negatives;
        returnedData.true_negatives = returnedData.true_negatives + object.true_negatives;
        returnedData.unclassified = returnedData.unclassified + object.unclassified;
        returnedData.total_clips = returnedData.total_clips + object.total_clips;
        if (object.precision) returnedData.precision = object.precision;
        if (object.recall) returnedData.recall = object.recall;
    });
    return returnedData;
};

});




parcelRegister("lcmJi", function(module, exports) {

$parcel$export(module.exports, "VIEW_ONLY_ACCESS_LEVEL", () => $285fc91cb8618c47$export$392986e538463834);
$parcel$export(module.exports, "ALARM_REVIEW_ACCESS_LEVEL", () => $285fc91cb8618c47$export$51eab887334cdc6c);
$parcel$export(module.exports, "VISIBLE_SCREENS_FIELD", () => $285fc91cb8618c47$export$e9cf0ac95e4c5aa3);
$parcel$export(module.exports, "VIEW_ALL_OPTION", () => $285fc91cb8618c47$export$f951863f3c4fbede);
$parcel$export(module.exports, "isViewOnly", () => $285fc91cb8618c47$export$90b7254668bbe9c8);
$parcel$export(module.exports, "readVisibleScreens", () => $285fc91cb8618c47$export$6dedf5fc48507030);
$parcel$export(module.exports, "isScreenVisible", () => $285fc91cb8618c47$export$6623acba25626e0d);
$parcel$export(module.exports, "selectableScreens", () => $285fc91cb8618c47$export$2dbff74b77c75e61);
$parcel$export(module.exports, "applyScreenSelection", () => $285fc91cb8618c47$export$97d2f1e1b273852f);
$parcel$export(module.exports, "withVisibleScreensForLevel", () => $285fc91cb8618c47$export$c8c381bec6c6c291);
$parcel$export(module.exports, "fetchScreenVocabulary", () => $285fc91cb8618c47$export$b18c895d85ba6340);
$parcel$export(module.exports, "describeVocabularyError", () => $285fc91cb8618c47$export$ebc387a237b838ae);
$parcel$export(module.exports, "landingRouteFor", () => $285fc91cb8618c47$export$6645a2db5352fa69);
/**
 * View Only screen visibility (ENG-1810 → ENG-1815 / ENG-1816 / ENG-2000).
 *
 * This is the ONE place camera-ui names the backend fields and endpoint
 * behind the View Only screen picker. The names below are the contract
 * confirmed by actuate_admin #2959 (ENG-1814), plus the Patrols / WireGuard
 * extension proposed on ENG-1999; if one ever changes, change the constant
 * and nothing else has to move.
 *
 * Reading these values in the SPA only decides what to draw. What a user may
 * actually read or write is decided by actuate_admin and the monitoring API.
 */ 
var $195EM = parcelRequire("195EM");
const $285fc91cb8618c47$export$392986e538463834 = 5;
const $285fc91cb8618c47$export$51eab887334cdc6c = 6;
const $285fc91cb8618c47$export$e9cf0ac95e4c5aa3 = "visible_screens";
const $285fc91cb8618c47$export$13284681ebdfa5f9 = "chm";
const $285fc91cb8618c47$export$d163cebd2eca8fdd = "patrol";
const $285fc91cb8618c47$export$ae08831dbe6210c6 = "wireguard";
const $285fc91cb8618c47$export$ee76f35c0c317882 = {
    health: $285fc91cb8618c47$export$13284681ebdfa5f9,
    patrols: $285fc91cb8618c47$export$d163cebd2eca8fdd,
    wireguard: $285fc91cb8618c47$export$ae08831dbe6210c6
};
const $285fc91cb8618c47$export$4d82dee01accd6a3 = "group_user/visible_screens/";
const $285fc91cb8618c47$export$f951863f3c4fbede = {
    key: "__view_all__",
    label: "View All"
};
const $285fc91cb8618c47$export$90b7254668bbe9c8 = (accessLevel)=>Number(accessLevel) === $285fc91cb8618c47$export$392986e538463834 || Number(accessLevel) === $285fc91cb8618c47$export$51eab887334cdc6c;
const $285fc91cb8618c47$export$6dedf5fc48507030 = (source)=>{
    const raw = source?.[$285fc91cb8618c47$export$e9cf0ac95e4c5aa3];
    if (!Array.isArray(raw)) return [];
    return raw.filter((key)=>typeof key === "string" && key.length > 0);
};
const $285fc91cb8618c47$export$6623acba25626e0d = (visibleScreens, screen)=>visibleScreens.length === 0 || visibleScreens.includes(screen);
const $285fc91cb8618c47$export$f92d14cbfcbf079f = (groupUserRow)=>$285fc91cb8618c47$export$85c13757cdefde8e(groupUserRow, "health");
const $285fc91cb8618c47$export$85c13757cdefde8e = (groupUserRow, screen)=>{
    const field = $285fc91cb8618c47$export$ee76f35c0c317882[screen];
    if (field === undefined) return true;
    return groupUserRow?.[field] === true;
};
const $285fc91cb8618c47$export$2dbff74b77c75e61 = (vocabulary, groupUserRow)=>vocabulary.filter((option)=>$285fc91cb8618c47$export$85c13757cdefde8e(groupUserRow, option.key));
const $285fc91cb8618c47$export$97d2f1e1b273852f = (previous, nextKeys)=>{
    const wasViewAll = previous.length === 0;
    const pickedViewAll = nextKeys.includes($285fc91cb8618c47$export$f951863f3c4fbede.key);
    const specific = nextKeys.filter((key)=>key !== $285fc91cb8618c47$export$f951863f3c4fbede.key);
    if (pickedViewAll && !wasViewAll) return [];
    return specific;
};
const $285fc91cb8618c47$export$c8c381bec6c6c291 = (payload, accessLevel)=>{
    if ($285fc91cb8618c47$export$90b7254668bbe9c8(accessLevel)) return payload;
    if (!($285fc91cb8618c47$export$e9cf0ac95e4c5aa3 in payload)) return payload;
    const rest = {
        ...payload
    };
    delete rest[$285fc91cb8618c47$export$e9cf0ac95e4c5aa3];
    return rest;
};
const $285fc91cb8618c47$export$ee8ef5ace3bd01fe = (data)=>{
    const rows = Array.isArray(data) ? data : Array.isArray(data?.results) ? data.results : [];
    const options = [];
    rows.forEach((row)=>{
        if (typeof row === "string") {
            if (row) options.push({
                key: row,
                label: row
            });
            return;
        }
        const record = row ?? {};
        const key = record.key ?? record.id ?? record.value;
        if (typeof key !== "string" || !key) return;
        const label = record.label ?? record.name ?? record.display_name ?? key;
        options.push({
            key: key,
            label: String(label)
        });
    });
    return options;
};
const $285fc91cb8618c47$export$b18c895d85ba6340 = async ()=>{
    const response = await (0, $195EM.createApi)("").get($285fc91cb8618c47$export$4d82dee01accd6a3);
    return $285fc91cb8618c47$export$ee8ef5ace3bd01fe(response.data);
};
const $285fc91cb8618c47$export$ebc387a237b838ae = (reason)=>{
    const status = reason?.response?.status;
    if (typeof status === "number") return `HTTP ${status}`;
    const message = reason?.message;
    return typeof message === "string" && message ? message : "network error";
};
const $285fc91cb8618c47$export$6645a2db5352fa69 = (permission, options = {})=>{
    const flags = permission ?? {};
    if (flags.patrol_only) return "/sites_patrol";
    const screens = $285fc91cb8618c47$export$6dedf5fc48507030(flags);
    if ($285fc91cb8618c47$export$6623acba25626e0d(screens, "sites")) return "/dashboard";
    if (flags.view_alerts && $285fc91cb8618c47$export$6623acba25626e0d(screens, "alerts")) return "/alerts";
    // Clips rides the Alerts screen; it is the landing only when the user has a
    // clips source but not the alerts permission itself.
    if ((flags.ailink || flags.sentinel || flags.smtp) && $285fc91cb8618c47$export$6623acba25626e0d(screens, "alerts")) return "/clips";
    if (flags.view_analytics && $285fc91cb8618c47$export$6623acba25626e0d(screens, "analytics")) return "/analytics";
    if (flags.chm && $285fc91cb8618c47$export$6623acba25626e0d(screens, "health")) return "/health";
    if (flags.view_patrol && $285fc91cb8618c47$export$6623acba25626e0d(screens, "patrols")) return "/sites_patrol";
    if (options.wireguardPageEnabled && $285fc91cb8618c47$export$6623acba25626e0d(screens, "wireguard")) return "/wireguardtunnels";
    return null;
};

});


parcelRegister("hlJ5Q", function(module, exports) {

$parcel$export(module.exports, "SiteCamerasTable", () => $2072306e0e0cd842$export$41b0b6a1d0c4f70f);
/* eslint-disable react-hooks/exhaustive-deps */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $aVDw9 = parcelRequire("aVDw9");

var $ha39s = parcelRequire("ha39s");

var $4o6Cs = parcelRequire("4o6Cs");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $dBDyu = parcelRequire("dBDyu");

var $hYduw = parcelRequire("hYduw");

var $j7HO3 = parcelRequire("j7HO3");

var $kbChx = parcelRequire("kbChx");

var $ePwXE = parcelRequire("ePwXE");

var $cVCJe = parcelRequire("cVCJe");

var $8jTCz = parcelRequire("8jTCz");
function $2072306e0e0cd842$var$EnhancedTableHead(props) {
    const { onSelectAllClick: onSelectAllClick, allExpanded: allExpanded, setAllExpanded: setAllExpanded } = props;
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    padding: "checkbox",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                        color: "primary",
                        onChange: onSelectAllClick
                    })
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                    align: "left",
                    sx: {
                        fontFamily: "Mulish",
                        fontWeight: "Bold",
                        fontSize: "15px",
                        minWidth: 150
                    },
                    children: [
                        "Camera Name \xa0",
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                            title: "Hover over camera name to see sample image from camera feed.",
                            placement: "top",
                            sx: {
                                fontSize: "15px",
                                fontFamily: "mulish"
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                fontSize: "small"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                    align: "left",
                    sx: {
                        fontFamily: "Mulish",
                        fontWeight: "Bold",
                        fontSize: "15px",
                        minWidth: 150
                    },
                    children: [
                        "Active \xa0",
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                            title: "A green checkmark indicates a camera is running. A red X indicates it is not.",
                            placement: "top",
                            sx: {
                                fontSize: "15px",
                                fontFamily: "mulish"
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                fontSize: "small"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                    align: "left",
                    sx: {
                        fontFamily: "Mulish",
                        fontWeight: "Bold",
                        fontSize: "15px",
                        minWidth: 150
                    },
                    children: [
                        "Synced \xa0",
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                            title: "An indication of whether the camera has been edited since its last deployment. A green checkmark will show if the most current version of the camera is running and a red x will show if the changes to the camera have not been synced - in which case it should be re-synced",
                            placement: "top",
                            sx: {
                                fontSize: "15px",
                                fontFamily: "mulish"
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                fontSize: "small"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    align: "left",
                    sx: {
                        fontFamily: "Mulish",
                        fontWeight: "Bold",
                        fontSize: "15px",
                        minWidth: 150
                    },
                    children: "Use\xa0Motion"
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                    align: "left",
                    sx: {
                        fontFamily: "Mulish",
                        fontWeight: "Bold",
                        fontSize: "15px",
                        minWidth: 150
                    },
                    children: [
                        "Ignore\xa0Zones \xa0",
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                            title: "A green checkmark indicates the site has active ignore zones. A red X indicates no ignore zones have been created.",
                            placement: "top",
                            sx: {
                                fontSize: "15px",
                                fontFamily: "mulish"
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                fontSize: "small"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                    align: "left",
                    sx: {
                        fontFamily: "Mulish",
                        fontWeight: "Bold",
                        fontSize: "15px",
                        minWidth: 150
                    },
                    children: [
                        "Health \xa0",
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                            title: "A green checkmark indicates a camera is running without issue. A red X indicates there is an issue(s) with the camera. Hovering over the X will display the issue(s).",
                            placement: "top",
                            sx: {
                                fontSize: "15px",
                                fontFamily: "mulish"
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                fontSize: "small"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    align: "left",
                    sx: {
                        fontFamily: "Mulish",
                        fontWeight: "Bold",
                        fontSize: "15px",
                        minWidth: 150
                    },
                    children: allExpanded ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setAllExpanded(false);
                        },
                        text: "+ Expand All",
                        disabled: false
                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setAllExpanded(true);
                        },
                        text: "- Collapse All",
                        disabled: false
                    })
                })
            ]
        })
    });
}
const $2072306e0e0cd842$export$41b0b6a1d0c4f70f = ({ setAlertState: setAlertState, setSyncNeeded: setSyncNeeded, setDeativateInquiryDialogOpen: setDeativateInquiryDialogOpen, siteCameras: siteCameras, setSiteCameras: setSiteCameras, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setNoAutoAddCamerasDialogOpen: setNoAutoAddCamerasDialogOpen, siteInfo: siteInfo, setSiteInfo: setSiteInfo, setSiteSchedules: setSiteSchedules, setActiveTab: setActiveTab, setDataLoaded: setDataLoaded, setAllSiteSchedules: setAllSiteSchedules, setVmsVariables: setVmsVariables, setArmedStatus: setArmedStatus, setAiLinkSite: setAiLinkSite, setSiteDeployed: setSiteDeployed, setCamerasNotDeployed: setCamerasNotDeployed, setToolTipTitle: setToolTipTitle, setConfigureMotion: setConfigureMotion, setPatchObject: setPatchObject, setArmButtonDisabled: setArmButtonDisabled, setRecordingServerData: setRecordingServerData, setRecordingServerPatchObject: setRecordingServerPatchObject, setRecordingServerVisible: setRecordingServerVisible, setHealthCheckData: setHealthCheckData, setCamerasRefreshing: setCamerasRefreshing, permissions: permissions, setWebhooksInfo: setWebhooksInfo, setWebhooksPatchObject: setWebhooksPatchObject, siteSchedules: siteSchedules })=>{
    const [selected, setSelected] = $8T3gX.useState([]);
    const [page, setPage] = $8T3gX.useState(0);
    const [rowsPerPage, setRowsPerPage] = $8T3gX.useState(5);
    const [deleteDialogOpen, setDeleteDialogOpen] = $8T3gX.useState(false);
    const siteId = siteInfo?.id;
    const handleSelectAllClick = (event)=>{
        if (event.target.checked) {
            const newSelecteds = siteCameras.results.map((obj)=>obj.id.toString());
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };
    const navigate = (0, $3T949.useNavigate)();
    $8T3gX.useEffect(()=>{
        const validIds = new Set(siteCameras.results.map((camera)=>String(camera.id)));
        const filteredSelection = selected.filter((id)=>validIds.has(id));
        if (filteredSelection.length !== selected.length) setSelected(filteredSelection);
    }, [
        siteCameras.results,
        selected
    ]);
    $8T3gX.useEffect(()=>{
        setSelected([]);
        setPage(0);
        setRowsPerPage(5);
    }, [
        siteId
    ]);
    const handleSingleCheckboxClick = (event, id)=>{
        const idStr = String(id);
        const selectedIndex = selected.indexOf(idStr);
        let newSelected = [];
        if (selectedIndex === -1) newSelected = newSelected.concat(selected, idStr);
        else if (selectedIndex === 0) newSelected = newSelected.concat(selected.slice(1));
        else if (selectedIndex === selected.length - 1) newSelected = newSelected.concat(selected.slice(0, -1));
        else if (selectedIndex > 0) newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        setSelected(newSelected);
    };
    const isSelected = (id)=>selected.indexOf(String(id)) !== -1;
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                children: deleteDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $j7HO3.DeleteCameraCheckDialog), {
                    selected: selected,
                    deleteDialogOpen: deleteDialogOpen,
                    setDeleteDialogOpen: setDeleteDialogOpen,
                    setSiteCameras: setSiteCameras,
                    setAlertState: setAlertState,
                    setSelected: setSelected,
                    setSyncNeeded: setSyncNeeded,
                    setBackdropLoadingScreenOn: setBackdropLoadingScreenOn
                })
            }),
            siteCameras.results[0] && /*#__PURE__*/ (0, $k4ank.jsx)((0, $hYduw.CamerasTable), {
                navigate: navigate,
                EnhancedTableHead: $2072306e0e0cd842$var$EnhancedTableHead,
                siteCameras: siteCameras,
                page: page,
                rowsPerPage: rowsPerPage,
                isSelected: isSelected,
                setPage: setPage,
                setRowsPerPage: setRowsPerPage,
                handleSelectAllClick: handleSelectAllClick,
                handleSingleCheckboxClick: handleSingleCheckboxClick,
                selected: selected,
                setSiteCameras: setSiteCameras,
                setDeleteDialogOpen: setDeleteDialogOpen,
                setAlertState: setAlertState,
                setSelected: setSelected,
                setSyncNeeded: setSyncNeeded,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setNoAutoAddCamerasDialogOpen: setNoAutoAddCamerasDialogOpen,
                siteInfo: siteInfo,
                setSiteInfo: setSiteInfo,
                setSiteSchedules: setSiteSchedules,
                setActiveTab: setActiveTab,
                setDataLoaded: setDataLoaded,
                setAllSiteSchedules: setAllSiteSchedules,
                setVmsVariables: setVmsVariables,
                setArmedStatus: setArmedStatus,
                setAiLinkSite: setAiLinkSite,
                setSiteDeployed: setSiteDeployed,
                setCamerasNotDeployed: setCamerasNotDeployed,
                setToolTipTitle: setToolTipTitle,
                setConfigureMotion: setConfigureMotion,
                setPatchObject: setPatchObject,
                setArmButtonDisabled: setArmButtonDisabled,
                setRecordingServerData: setRecordingServerData,
                setRecordingServerPatchObject: setRecordingServerPatchObject,
                setRecordingServerVisible: setRecordingServerVisible,
                setHealthCheckData: setHealthCheckData,
                setCamerasRefreshing: setCamerasRefreshing,
                permissions: permissions,
                setWebhooksInfo: setWebhooksInfo,
                setWebhooksPatchObject: setWebhooksPatchObject,
                siteSchedules: siteSchedules
            }),
            !siteCameras.results[0] && /*#__PURE__*/ (0, $k4ank.jsx)((0, $dBDyu.NoCameras), {
                navigate: navigate,
                setNoAutoAddCamerasDialogOpen: setNoAutoAddCamerasDialogOpen,
                siteInfo: siteInfo,
                permissions: permissions
            })
        ]
    });
};

});
parcelRegister("aVDw9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f4de19b077e8180$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $aBrLz = parcelRequire("aBrLz");

var $iMOmE = parcelRequire("iMOmE");

var $f5lDx = parcelRequire("f5lDx");

var $g2g0C = parcelRequire("g2g0C");

var $7AQZl = parcelRequire("7AQZl");

var $anJSP = parcelRequire("anJSP");

var $3WqGS = parcelRequire("3WqGS");

var $k4ank = parcelRequire("k4ank");
'use client';
const $7f4de19b077e8180$var$_excluded = [
    "align",
    "className",
    "component",
    "padding",
    "scope",
    "size",
    "sortDirection",
    "variant"
];
const $7f4de19b077e8180$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            stickyHeader && 'stickyHeader',
            align !== 'inherit' && `align${(0, $iMOmE.default)(align)}`,
            padding !== 'normal' && `padding${(0, $iMOmE.default)(padding)}`,
            `size${(0, $iMOmE.default)(size)}`
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $3WqGS.getTableCellUtilityClass), classes);
};
const $7f4de19b077e8180$var$TableCellRoot = (0, $anJSP.default)('td', {
    name: 'MuiTableCell',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $iMOmE.default)(ownerState.size)}`],
            ownerState.padding !== 'normal' && styles[`padding${(0, $iMOmE.default)(ownerState.padding)}`],
            ownerState.align !== 'inherit' && styles[`align${(0, $iMOmE.default)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({}, theme.typography.body2, {
        display: 'table-cell',
        verticalAlign: 'inherit',
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? (0, $aBrLz.lighten)((0, $aBrLz.alpha)(theme.palette.divider, 1), 0.88) : (0, $aBrLz.darken)((0, $aBrLz.alpha)(theme.palette.divider, 1), 0.68)}`,
        textAlign: 'left',
        padding: 16
    }, ownerState.variant === 'head' && {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.variant === 'body' && {
        color: (theme.vars || theme).palette.text.primary
    }, ownerState.variant === 'footer' && {
        color: (theme.vars || theme).palette.text.secondary,
        lineHeight: theme.typography.pxToRem(21),
        fontSize: theme.typography.pxToRem(12)
    }, ownerState.size === 'small' && {
        padding: '6px 16px',
        [`&.${(0, $3WqGS.default).paddingCheckbox}`]: {
            width: 24,
            // prevent the checkbox column from growing
            padding: '0 12px 0 16px',
            '& > *': {
                padding: 0
            }
        }
    }, ownerState.padding === 'checkbox' && {
        width: 48,
        // prevent the checkbox column from growing
        padding: '0 0 0 4px'
    }, ownerState.padding === 'none' && {
        padding: 0
    }, ownerState.align === 'left' && {
        textAlign: 'left'
    }, ownerState.align === 'center' && {
        textAlign: 'center'
    }, ownerState.align === 'right' && {
        textAlign: 'right',
        flexDirection: 'row-reverse'
    }, ownerState.align === 'justify' && {
        textAlign: 'justify'
    }, ownerState.stickyHeader && {
        position: 'sticky',
        top: 0,
        zIndex: 2,
        backgroundColor: (theme.vars || theme).palette.background.default
    }));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $7f4de19b077e8180$var$TableCell = /*#__PURE__*/ $8T3gX.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiTableCell'
    });
    const { align: align = 'inherit', className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp } = props, other = (0, $fAJB5.default)(props, $7f4de19b077e8180$var$_excluded);
    const table = $8T3gX.useContext((0, $f5lDx.default));
    const tablelvl2 = $8T3gX.useContext((0, $g2g0C.default));
    const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? 'th' : 'td';
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === 'td') scope = undefined;
    else if (!scope && isHeadCell) scope = 'col';
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = (0, $eJfrs.default)({}, props, {
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
        size: sizeProp || (table && table.size ? table.size : 'medium'),
        sortDirection: sortDirection,
        stickyHeader: variant === 'head' && table && table.stickyHeader,
        variant: variant
    });
    const classes = $7f4de19b077e8180$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, $k4ank.jsx)($7f4de19b077e8180$var$TableCellRoot, (0, $eJfrs.default)({
        as: component,
        ref: ref,
        className: (0, $iVyaN.default)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState
    }, other));
});
$7f4de19b077e8180$var$TableCell.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   * @default 'inherit'
   */ align: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'center',
        'inherit',
        'justify',
        'left',
        'right'
    ]),
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * Sets the padding applied to the cell.
   * The prop defaults to the value (`'default'`) inherited from the parent Table component.
   */ padding: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'checkbox',
        'none',
        'normal'
    ]),
    /**
   * Set scope attribute.
   */ scope: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Specify the size of the cell.
   * The prop defaults to the value (`'medium'`) inherited from the parent Table component.
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'medium',
            'small'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * Set aria-sort direction.
   */ sortDirection: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'asc',
        'desc',
        false
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * Specify the cell type.
   * The prop defaults to the value inherited from the parent TableHead, TableBody, or TableFooter components.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'body',
            'footer',
            'head'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ])
};
var $7f4de19b077e8180$export$2e2bcd8739ae039 = $7f4de19b077e8180$var$TableCell;

});
parcelRegister("f5lDx", function(module, exports) {

$parcel$export(module.exports, "default", () => $afb81b3dd60594f8$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");
'use client';
/**
 * @ignore - internal component.
 */ const $afb81b3dd60594f8$var$TableContext = /*#__PURE__*/ $8T3gX.createContext();
$afb81b3dd60594f8$var$TableContext.displayName = 'TableContext';
var $afb81b3dd60594f8$export$2e2bcd8739ae039 = $afb81b3dd60594f8$var$TableContext;

});

parcelRegister("g2g0C", function(module, exports) {

$parcel$export(module.exports, "default", () => $bac9404fae867b74$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");
/**
 * @ignore - internal component.
 */ const $bac9404fae867b74$var$Tablelvl2Context = /*#__PURE__*/ $8T3gX.createContext();
$bac9404fae867b74$var$Tablelvl2Context.displayName = 'Tablelvl2Context';
var $bac9404fae867b74$export$2e2bcd8739ae039 = $bac9404fae867b74$var$Tablelvl2Context;

});

parcelRegister("3WqGS", function(module, exports) {

$parcel$export(module.exports, "getTableCellUtilityClass", () => $2deb7e121f1c5ee5$export$33a0f07a16a10b1b);
$parcel$export(module.exports, "default", () => $2deb7e121f1c5ee5$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $2deb7e121f1c5ee5$export$33a0f07a16a10b1b(slot) {
    return (0, $kfTYv.default)('MuiTableCell', slot);
}
const $2deb7e121f1c5ee5$var$tableCellClasses = (0, $jh2Zm.default)('MuiTableCell', [
    'root',
    'head',
    'body',
    'footer',
    'sizeSmall',
    'sizeMedium',
    'paddingCheckbox',
    'paddingNone',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    'stickyHeader'
]);
var $2deb7e121f1c5ee5$export$2e2bcd8739ae039 = $2deb7e121f1c5ee5$var$tableCellClasses;

});


parcelRegister("ha39s", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7e5d0afbdf40ef3$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $g2g0C = parcelRequire("g2g0C");

var $7AQZl = parcelRequire("7AQZl");

var $anJSP = parcelRequire("anJSP");

var $AgK2x = parcelRequire("AgK2x");

var $k4ank = parcelRequire("k4ank");
'use client';
const $c7e5d0afbdf40ef3$var$_excluded = [
    "className",
    "component"
];
const $c7e5d0afbdf40ef3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $AgK2x.getTableHeadUtilityClass), classes);
};
const $c7e5d0afbdf40ef3$var$TableHeadRoot = (0, $anJSP.default)('thead', {
    name: 'MuiTableHead',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-header-group'
});
const $c7e5d0afbdf40ef3$var$tablelvl2 = {
    variant: 'head'
};
const $c7e5d0afbdf40ef3$var$defaultComponent = 'thead';
const $c7e5d0afbdf40ef3$var$TableHead = /*#__PURE__*/ $8T3gX.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiTableHead'
    });
    const { className: className, component: component = $c7e5d0afbdf40ef3$var$defaultComponent } = props, other = (0, $fAJB5.default)(props, $c7e5d0afbdf40ef3$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        component: component
    });
    const classes = $c7e5d0afbdf40ef3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $g2g0C.default).Provider, {
        value: $c7e5d0afbdf40ef3$var$tablelvl2,
        children: /*#__PURE__*/ (0, $k4ank.jsx)($c7e5d0afbdf40ef3$var$TableHeadRoot, (0, $eJfrs.default)({
            as: component,
            className: (0, $iVyaN.default)(classes.root, className),
            ref: ref,
            role: component === $c7e5d0afbdf40ef3$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
$c7e5d0afbdf40ef3$var$TableHead.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component, normally `TableRow`.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $c7e5d0afbdf40ef3$export$2e2bcd8739ae039 = $c7e5d0afbdf40ef3$var$TableHead;

});
parcelRegister("AgK2x", function(module, exports) {

$parcel$export(module.exports, "getTableHeadUtilityClass", () => $06d0596fc87296e6$export$2e731cea2d1c2392);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $06d0596fc87296e6$export$2e731cea2d1c2392(slot) {
    return (0, $kfTYv.default)('MuiTableHead', slot);
}
const $06d0596fc87296e6$var$tableHeadClasses = (0, $jh2Zm.default)('MuiTableHead', [
    'root'
]);
var $06d0596fc87296e6$export$2e2bcd8739ae039 = $06d0596fc87296e6$var$tableHeadClasses;

});


parcelRegister("4o6Cs", function(module, exports) {

$parcel$export(module.exports, "default", () => $331e89c3f35305fc$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $aBrLz = parcelRequire("aBrLz");

var $g2g0C = parcelRequire("g2g0C");

var $7AQZl = parcelRequire("7AQZl");

var $anJSP = parcelRequire("anJSP");

var $bQKx6 = parcelRequire("bQKx6");

var $k4ank = parcelRequire("k4ank");
'use client';
const $331e89c3f35305fc$var$_excluded = [
    "className",
    "component",
    "hover",
    "selected"
];
const $331e89c3f35305fc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            hover && 'hover',
            head && 'head',
            footer && 'footer'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $bQKx6.getTableRowUtilityClass), classes);
};
const $331e89c3f35305fc$var$TableRowRoot = (0, $anJSP.default)('tr', {
    name: 'MuiTableRow',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})(({ theme: theme })=>({
        color: 'inherit',
        display: 'table-row',
        verticalAlign: 'middle',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $bQKx6.default).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $bQKx6.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $aBrLz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $aBrLz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
            }
        }
    }));
const $331e89c3f35305fc$var$defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $331e89c3f35305fc$var$TableRow = /*#__PURE__*/ $8T3gX.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiTableRow'
    });
    const { className: className, component: component = $331e89c3f35305fc$var$defaultComponent, hover: hover = false, selected: selected = false } = props, other = (0, $fAJB5.default)(props, $331e89c3f35305fc$var$_excluded);
    const tablelvl2 = $8T3gX.useContext((0, $g2g0C.default));
    const ownerState = (0, $eJfrs.default)({}, props, {
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === 'head',
        footer: tablelvl2 && tablelvl2.variant === 'footer'
    });
    const classes = $331e89c3f35305fc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsx)($331e89c3f35305fc$var$TableRowRoot, (0, $eJfrs.default)({
        as: component,
        ref: ref,
        className: (0, $iVyaN.default)(classes.root, className),
        role: component === $331e89c3f35305fc$var$defaultComponent ? null : 'row',
        ownerState: ownerState
    }, other));
});
$331e89c3f35305fc$var$TableRow.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Should be valid `<tr>` children such as `TableCell`.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * If `true`, the table row will shade on hover.
   * @default false
   */ hover: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the table row will have the selected shading.
   * @default false
   */ selected: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $331e89c3f35305fc$export$2e2bcd8739ae039 = $331e89c3f35305fc$var$TableRow;

});
parcelRegister("bQKx6", function(module, exports) {

$parcel$export(module.exports, "getTableRowUtilityClass", () => $8a08a58516156853$export$ba0a6d6c28940107);
$parcel$export(module.exports, "default", () => $8a08a58516156853$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $8a08a58516156853$export$ba0a6d6c28940107(slot) {
    return (0, $kfTYv.default)('MuiTableRow', slot);
}
const $8a08a58516156853$var$tableRowClasses = (0, $jh2Zm.default)('MuiTableRow', [
    'root',
    'selected',
    'hover',
    'head',
    'footer'
]);
var $8a08a58516156853$export$2e2bcd8739ae039 = $8a08a58516156853$var$tableRowClasses;

});


parcelRegister("dBDyu", function(module, exports) {

$parcel$export(module.exports, "NoCameras", () => $085e5bce77b2a666$export$485e0e16f4415049);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $jYCat = parcelRequire("jYCat");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4reBM = parcelRequire("4reBM");

var $f3puC = parcelRequire("f3puC");

var $a65wX = parcelRequire("a65wX");

var $8sQrk = parcelRequire("8sQrk");

var $bHNwu = parcelRequire("bHNwu");
const $085e5bce77b2a666$export$485e0e16f4415049 = ({ navigate: navigate, setNoAutoAddCamerasDialogOpen: setNoAutoAddCamerasDialogOpen, siteInfo: siteInfo, permissions: permissions })=>{
    // ONVIF scan is how you add the FIRST cameras to an empty site, so it must be
    // available here too — not only once cameras already exist (CamerasTable).
    const showOnvifScan = (0, $jYCat.canShowOnvifScan)(permissions, siteInfo?.integration_type_name);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $4reBM.default), {
        sx: {
            width: "100%",
            overflow: "hidden"
        },
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3Nm8Z.default), {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                    sx: {
                        fontFamily: "Mulish",
                        fontWeight: "Bold",
                        textIndent: "33px",
                        paddingTop: "10px"
                    },
                    variant: "h6",
                    id: "tableTitle",
                    component: "div",
                    children: "Site Cameras"
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "w-[88vw] h-[27.5vh] bg-white",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "flex items-center justify-center font-black",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $bHNwu.CameraIcon), {})
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "flex items-center justify-center font-black font-mulish text-xl",
                            children: "This Site doesn't have any cameras yet."
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "flex items-center justify-center gap-4 font-black font-mulish text-xl",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $8sQrk.AddCameraButton), {
                                    navigate: navigate,
                                    setNoAutoAddCamerasDialogOpen: setNoAutoAddCamerasDialogOpen,
                                    siteInfo: siteInfo
                                }),
                                showOnvifScan && /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                    type: "button",
                                    variant: "contained",
                                    sx: {
                                        fontFamily: "Mulish",
                                        textTransform: "none",
                                        backgroundColor: "#283E6D",
                                        color: "#FFFFFF",
                                        "&:hover": {
                                            backgroundColor: "#1f2f54"
                                        }
                                    },
                                    onClick: ()=>{
                                        localStorage.setItem("addAdditionalCamera", "true");
                                        navigate(`/sites/${siteInfo.id}/onvifscan`);
                                    },
                                    children: "ONVIF Scan"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("jYCat", function(module, exports) {

$parcel$export(module.exports, "canUseOnvifScan", () => $7a1e04b39b8150e9$export$6295149581f89071);
$parcel$export(module.exports, "canShowOnvifScan", () => $7a1e04b39b8150e9$export$5ab1df2a05b6f306);
$parcel$export(module.exports, "canUseCameraUnitScan", () => $7a1e04b39b8150e9$export$b74ba3149d8db441);
$parcel$export(module.exports, "canShowCameraUnitScan", () => $7a1e04b39b8150e9$export$b6484cacc63e54d0);

var $lT6uY = parcelRequire("lT6uY");
const $7a1e04b39b8150e9$export$d8cf3ed741f7a175 = [
    "rtsp",
    "onvif_wireguard"
];
const $7a1e04b39b8150e9$export$6295149581f89071 = (permissions)=>Boolean(permissions?.add_cameras) && Boolean(permissions?.configure_wireguard_cameras || permissions?.super_user);
const $7a1e04b39b8150e9$export$5ab1df2a05b6f306 = (permissions, integrationTypeName)=>$7a1e04b39b8150e9$export$6295149581f89071(permissions) && $7a1e04b39b8150e9$export$d8cf3ed741f7a175.includes(String(integrationTypeName ?? ""));
const $7a1e04b39b8150e9$export$b74ba3149d8db441 = (permissions)=>Boolean(permissions?.edit_cameras) && Boolean(permissions?.direct_camera_access || permissions?.super_user);
const $7a1e04b39b8150e9$export$b6484cacc63e54d0 = (permissions, siteInfo)=>$7a1e04b39b8150e9$export$b74ba3149d8db441(permissions) && ((0, $lT6uY.isGenetecDirectSite)(siteInfo) || $7a1e04b39b8150e9$export$d8cf3ed741f7a175.includes(String(siteInfo?.integration_type_name ?? "")));

});
parcelRegister("lT6uY", function(module, exports) {

$parcel$export(module.exports, "VIDEO_SOURCE_COLUMN_TITLE", () => $98ae1139d67ad9d3$export$4a1f5047ddc3e90);
$parcel$export(module.exports, "isGenetecSite", () => $98ae1139d67ad9d3$export$84eb33d1f11ee26f);
$parcel$export(module.exports, "isGenetecDirectSite", () => $98ae1139d67ad9d3$export$c0c375dd4b5f7dd);
$parcel$export(module.exports, "getCameraVideoSourceLabel", () => $98ae1139d67ad9d3$export$bc8ff814299dfd9d);
$parcel$export(module.exports, "GENETEC_DIRECT_PLACEHOLDERS", () => $98ae1139d67ad9d3$export$5cd62b43475e547a);
/**
 * Genetec "Video source" (Camera Admin, site level). A Genetec site streams
 * through the Media Gateway by default; set to `direct` the connector dials
 * each camera unit itself (host, RTSP port, stream path, camera login), so
 * those per-camera connection fields must be editable even while empty.
 *
 * The site About payload (`customer/{id}/about/`) carries the setting as an
 * `extra_fields` entry with `id: "genetec_video_source"`. Site About reads
 * extra-field values off the top level of the payload (`siteInfo[field.id]`),
 * so both shapes are accepted here: a `value` on the entry, or the top-level
 * key.
 *
 * `camera/{id}/general_info/` adds two read-only fields per camera:
 * `video_source` (the effective source for this camera) and
 * `video_source_reason` (why it fell back, e.g. no host set).
 */ const $98ae1139d67ad9d3$export$92a9b443380dd49 = "genetec_video_source";
const $98ae1139d67ad9d3$export$a5655f00b52031c1 = {
    media_gateway: "Media Gateway",
    direct: "Direct"
};
const $98ae1139d67ad9d3$export$4a1f5047ddc3e90 = "Video source";
const $98ae1139d67ad9d3$export$84eb33d1f11ee26f = (siteInfo)=>String(siteInfo?.integration_type_name ?? "").toLowerCase() === "genetec";
const $98ae1139d67ad9d3$export$b96ce6c3ec102d35 = (raw)=>{
    const value = String(raw ?? "").trim().toLowerCase();
    if (value === "direct" || value === "media_gateway") return value;
    return null;
};
const $98ae1139d67ad9d3$export$3738bc9a1461c5ed = (siteInfo)=>{
    if (!$98ae1139d67ad9d3$export$84eb33d1f11ee26f(siteInfo)) return null;
    const entry = (siteInfo?.extra_fields ?? []).find((field)=>String(field?.id) === $98ae1139d67ad9d3$export$92a9b443380dd49);
    return $98ae1139d67ad9d3$export$b96ce6c3ec102d35(entry?.value) ?? $98ae1139d67ad9d3$export$b96ce6c3ec102d35(siteInfo?.[$98ae1139d67ad9d3$export$92a9b443380dd49]) ?? "media_gateway";
};
const $98ae1139d67ad9d3$export$c0c375dd4b5f7dd = (siteInfo)=>$98ae1139d67ad9d3$export$3738bc9a1461c5ed(siteInfo) === "direct";
const $98ae1139d67ad9d3$export$463feb66bcca7d0c = (raw)=>{
    const source = $98ae1139d67ad9d3$export$b96ce6c3ec102d35(raw);
    return source ? $98ae1139d67ad9d3$export$a5655f00b52031c1[source] : "--";
};
const $98ae1139d67ad9d3$export$bc8ff814299dfd9d = (cameraObject, siteInfo)=>$98ae1139d67ad9d3$export$463feb66bcca7d0c(cameraObject?.video_source ?? $98ae1139d67ad9d3$export$3738bc9a1461c5ed(siteInfo));
const $98ae1139d67ad9d3$export$5cd62b43475e547a = {
    host: "10.0.0.5",
    rtsp: "554",
    stream_parameters: "/media/video2"
};

});


parcelRegister("3Nm8Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c37200328c62065$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $7AQZl = parcelRequire("7AQZl");

var $anJSP = parcelRequire("anJSP");

var $3lc5k = parcelRequire("3lc5k");

var $k4ank = parcelRequire("k4ank");
'use client';
const $2c37200328c62065$var$_excluded = [
    "className",
    "component"
];
const $2c37200328c62065$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $3lc5k.getTableContainerUtilityClass), classes);
};
const $2c37200328c62065$var$TableContainerRoot = (0, $anJSP.default)('div', {
    name: 'MuiTableContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    width: '100%',
    overflowX: 'auto'
});
const $2c37200328c62065$var$TableContainer = /*#__PURE__*/ $8T3gX.forwardRef(function TableContainer(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiTableContainer'
    });
    const { className: className, component: component = 'div' } = props, other = (0, $fAJB5.default)(props, $2c37200328c62065$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        component: component
    });
    const classes = $2c37200328c62065$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsx)($2c37200328c62065$var$TableContainerRoot, (0, $eJfrs.default)({
        ref: ref,
        as: component,
        className: (0, $iVyaN.default)(classes.root, className),
        ownerState: ownerState
    }, other));
});
$2c37200328c62065$var$TableContainer.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component, normally `Table`.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $2c37200328c62065$export$2e2bcd8739ae039 = $2c37200328c62065$var$TableContainer;

});
parcelRegister("3lc5k", function(module, exports) {

$parcel$export(module.exports, "getTableContainerUtilityClass", () => $26ecb50e9ba8aa01$export$eed427986a7abdf9);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $26ecb50e9ba8aa01$export$eed427986a7abdf9(slot) {
    return (0, $kfTYv.default)('MuiTableContainer', slot);
}
const $26ecb50e9ba8aa01$var$tableContainerClasses = (0, $jh2Zm.default)('MuiTableContainer', [
    'root'
]);
var $26ecb50e9ba8aa01$export$2e2bcd8739ae039 = $26ecb50e9ba8aa01$var$tableContainerClasses;

});


parcelRegister("4reBM", function(module, exports) {

$parcel$export(module.exports, "default", () => $33b503ee4f0d790b$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $97LlG = parcelRequire("97LlG");

var $bPpmJ = parcelRequire("bPpmJ");

var $aYNpO = parcelRequire("aYNpO");

var $aBrLz = parcelRequire("aBrLz");

var $anJSP = parcelRequire("anJSP");

var $lbKkL = parcelRequire("lbKkL");

var $7AQZl = parcelRequire("7AQZl");

var $4nWZ9 = parcelRequire("4nWZ9");

var $iw3qM = parcelRequire("iw3qM");

var $k4ank = parcelRequire("k4ank");
'use client';
const $33b503ee4f0d790b$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $33b503ee4f0d790b$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $iw3qM.getPaperUtilityClass), classes);
};
const $33b503ee4f0d790b$var$PaperRoot = (0, $anJSP.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $eJfrs.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow')
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === 'outlined' && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === 'elevation' && (0, $eJfrs.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === 'dark' && {
        backgroundImage: `linear-gradient(${(0, $aBrLz.alpha)('#fff', (0, $lbKkL.default)(ownerState.elevation))}, ${(0, $aBrLz.alpha)('#fff', (0, $lbKkL.default)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $33b503ee4f0d790b$var$Paper = /*#__PURE__*/ $8T3gX.forwardRef(function Paper(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation' } = props, other = (0, $fAJB5.default)(props, $33b503ee4f0d790b$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $33b503ee4f0d790b$var$useUtilityClasses(ownerState);
    {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const theme = (0, $4nWZ9.default)();
        if (theme.shadows[elevation] === undefined) console.error([
            `MUI: The elevation provided <Paper elevation={${elevation}}> is not available in the theme.`,
            `Please make sure that \`theme.shadows[${elevation}]\` is defined.`
        ].join('\n'));
    }
    return /*#__PURE__*/ (0, $k4ank.jsx)($33b503ee4f0d790b$var$PaperRoot, (0, $eJfrs.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $iVyaN.default)(classes.root, className),
        ref: ref
    }, other));
});
$33b503ee4f0d790b$var$Paper.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */ elevation: (0, $bPpmJ.default)((0, $97LlG.default), (props)=>{
        const { elevation: elevation, variant: variant } = props;
        if (elevation > 0 && variant === 'outlined') return new Error(`MUI: Combining \`elevation={${elevation}}\` with \`variant="${variant}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`);
        return null;
    }),
    /**
   * If `true`, rounded corners are disabled.
   * @default false
   */ square: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * The variant to use.
   * @default 'elevation'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'elevation',
            'outlined'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ])
};
var $33b503ee4f0d790b$export$2e2bcd8739ae039 = $33b503ee4f0d790b$var$Paper;

});
parcelRegister("97LlG", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a497efe6bd03adc$export$2e2bcd8739ae039);
function $6a497efe6bd03adc$export$9fd44dd81470cadd(value) {
    const valueType = typeof value;
    switch(valueType){
        case 'number':
            if (Number.isNaN(value)) return 'NaN';
            if (!Number.isFinite(value)) return 'Infinity';
            if (value !== Math.floor(value)) return 'float';
            return 'number';
        case 'object':
            if (value === null) return 'null';
            return value.constructor.name;
        default:
            return valueType;
    }
}
// IE 11 support
function $6a497efe6bd03adc$var$ponyfillIsInteger(x) {
    // eslint-disable-next-line no-restricted-globals
    return typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
}
const $6a497efe6bd03adc$var$isInteger = Number.isInteger || $6a497efe6bd03adc$var$ponyfillIsInteger;
function $6a497efe6bd03adc$var$requiredInteger(props, propName, componentName, location) {
    const propValue = props[propName];
    if (propValue == null || !$6a497efe6bd03adc$var$isInteger(propValue)) {
        const propType = $6a497efe6bd03adc$export$9fd44dd81470cadd(propValue);
        return new RangeError(`Invalid ${location} \`${propName}\` of type \`${propType}\` supplied to \`${componentName}\`, expected \`integer\`.`);
    }
    return null;
}
function $6a497efe6bd03adc$var$validator(props, propName, ...other) {
    const propValue = props[propName];
    if (propValue === undefined) return null;
    return $6a497efe6bd03adc$var$requiredInteger(props, propName, ...other);
}
function $6a497efe6bd03adc$var$validatorNoop() {
    return null;
}
$6a497efe6bd03adc$var$validator.isRequired = $6a497efe6bd03adc$var$requiredInteger;
$6a497efe6bd03adc$var$validatorNoop.isRequired = $6a497efe6bd03adc$var$validatorNoop;
var $6a497efe6bd03adc$export$2e2bcd8739ae039 = $6a497efe6bd03adc$var$validator;

});

parcelRegister("lbKkL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6ce90fec4932717$export$2e2bcd8739ae039);
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $f6ce90fec4932717$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $f6ce90fec4932717$export$2e2bcd8739ae039 = $f6ce90fec4932717$var$getOverlayAlpha;

});

parcelRegister("iw3qM", function(module, exports) {

$parcel$export(module.exports, "getPaperUtilityClass", () => $d7ade075a98810c5$export$29cdb466b9b6f20b);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $d7ade075a98810c5$export$29cdb466b9b6f20b(slot) {
    return (0, $kfTYv.default)('MuiPaper', slot);
}
const $d7ade075a98810c5$var$paperClasses = (0, $jh2Zm.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $d7ade075a98810c5$export$2e2bcd8739ae039 = $d7ade075a98810c5$var$paperClasses;

});


parcelRegister("f3puC", function(module, exports) {

$parcel$export(module.exports, "default", () => $af5ae92bc6a15a8c$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $bmcE0 = parcelRequire("bmcE0");

var $aYNpO = parcelRequire("aYNpO");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $iMOmE = parcelRequire("iMOmE");

var $b8rKZ = parcelRequire("b8rKZ");

var $k4ank = parcelRequire("k4ank");
'use client';
const $af5ae92bc6a15a8c$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $af5ae92bc6a15a8c$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $iMOmE.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $b8rKZ.getTypographyUtilityClass), classes);
};
const $af5ae92bc6a15a8c$export$140e2f5526d3cad8 = (0, $anJSP.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $iMOmE.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        margin: 0
    }, ownerState.variant === 'inherit' && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: 'inherit'
    }, ownerState.variant !== 'inherit' && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, ownerState.gutterBottom && {
        marginBottom: '0.35em'
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $af5ae92bc6a15a8c$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $af5ae92bc6a15a8c$var$colorTransformations = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $af5ae92bc6a15a8c$var$transformDeprecatedColors = (color)=>{
    return $af5ae92bc6a15a8c$var$colorTransformations[color] || color;
};
const $af5ae92bc6a15a8c$var$Typography = /*#__PURE__*/ $8T3gX.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const color = $af5ae92bc6a15a8c$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $bmcE0.default)((0, $eJfrs.default)({}, themeProps, {
        color: color
    }));
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $af5ae92bc6a15a8c$var$defaultVariantMapping } = props, other = (0, $fAJB5.default)(props, $af5ae92bc6a15a8c$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $af5ae92bc6a15a8c$var$defaultVariantMapping[variant]) || 'span';
    const classes = $af5ae92bc6a15a8c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsx)($af5ae92bc6a15a8c$export$140e2f5526d3cad8, (0, $eJfrs.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $iVyaN.default)(classes.root, className)
    }, other));
});
$af5ae92bc6a15a8c$var$Typography.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Set the text-align on the component.
   * @default 'inherit'
   */ align: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'center',
        'inherit',
        'justify',
        'left',
        'right'
    ]),
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */ gutterBottom: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */ noWrap: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the element will be a paragraph element.
   * @default false
   */ paragraph: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * Applies the theme typography styles.
   * @default 'body1'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'body1',
            'body2',
            'button',
            'caption',
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            'inherit',
            'overline',
            'subtitle1',
            'subtitle2'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */ variantMapping: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).object
};
var $af5ae92bc6a15a8c$export$2e2bcd8739ae039 = $af5ae92bc6a15a8c$var$Typography;

});
parcelRegister("b8rKZ", function(module, exports) {

$parcel$export(module.exports, "getTypographyUtilityClass", () => $81b5f8fb455f6330$export$24c1f8f60cbac79e);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $81b5f8fb455f6330$export$24c1f8f60cbac79e(slot) {
    return (0, $kfTYv.default)('MuiTypography', slot);
}
const $81b5f8fb455f6330$var$typographyClasses = (0, $jh2Zm.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $81b5f8fb455f6330$export$2e2bcd8739ae039 = $81b5f8fb455f6330$var$typographyClasses;

});


parcelRegister("8sQrk", function(module, exports) {

$parcel$export(module.exports, "AddCameraButton", () => $689cca6419c0b97a$export$4e6e31e76bab5d5a);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $cpJfj = parcelRequire("cpJfj");
const $689cca6419c0b97a$export$4e6e31e76bab5d5a = ({ navigate: navigate, setNoAutoAddCamerasDialogOpen: setNoAutoAddCamerasDialogOpen, siteInfo: siteInfo })=>{
    localStorage.setItem("clickedFromSiteAboutPage", "true");
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cpJfj.ActuateButton), {
            onClick: ()=>{
                localStorage.setItem("firstCameraAdded", "true");
                localStorage.setItem("copyValues", "true");
                localStorage.setItem("addAdditionalCamera", "true");
                localStorage.setItem("clickedFromSiteAboutPage", "true");
                localStorage.setItem("navigatedFromSitesAboutPage", "true");
                // Route on the site's own auto_add (reliable), matching the populated
                // CamerasTable — not the stale localStorage.autoAdd, which is only set
                // during onboarding and misroutes non-auto-add sites (e.g. RTSP /
                // ONVIF-over-WireGuard) to the NVR auto-add page.
                const isAutoAdd = siteInfo ? Boolean(siteInfo.auto_add) : localStorage.autoAdd !== "false";
                if (isAutoAdd) navigate("/sites/autoaddcamera");
                else navigate("/sites/addcamera");
            },
            text: "Add Camera",
            disabled: false
        })
    });
};

});
parcelRegister("cpJfj", function(module, exports) {

$parcel$export(module.exports, "ActuateButton", () => $2b58d1d1e3bcf54c$export$9f8385091262cde9);

var $k4ank = parcelRequire("k4ank");
const $2b58d1d1e3bcf54c$export$9f8385091262cde9 = ({ onClick: onClick, text: text, disabled: disabled })=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)("button", {
        className: disabled ? "shadow-button bg-[#A9A9A9] rounded font-mulish text-white text-base	p-1.5" : "shadow-button bg-actuate-orange rounded font-mulish text-white text-base	p-1.5 hover:bg-[#E67300]",
        onClick: onClick,
        disabled: disabled,
        children: text
    });
};

});


parcelRegister("bHNwu", function(module, exports) {

$parcel$export(module.exports, "CameraIcon", () => $0ca6349f9e45cdb3$export$1bd12807c2fea239);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");

var $a7uO0 = parcelRequire("a7uO0");
const $0ca6349f9e45cdb3$var$CreateCameraIcon = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M20.916 9.564a.998.998 0 0 0-.513-1.316L7.328 2.492c-.995-.438-2.22.051-2.645 1.042l-2.21 5.154a2.001 2.001 0 0 0 1.052 2.624L9.563 13.9L8.323 17H4v-3H2v8h2v-3h4.323c.823 0 1.552-.494 1.856-1.258l1.222-3.054l5.205 2.23a1 1 0 0 0 1.31-.517l.312-.71l1.701.68l2-5l-1.536-.613l.523-1.194zm-4.434 5.126L4.313 9.475l2.208-5.152l12.162 5.354l-2.201 5.013z",
    fontSize: "small"
}), "Home");
const $0ca6349f9e45cdb3$export$1bd12807c2fea239 = ()=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
        sx: {
            "& > :not(style)": {
                m: 2
            }
        },
        children: /*#__PURE__*/ (0, $k4ank.jsx)($0ca6349f9e45cdb3$var$CreateCameraIcon, {})
    });
};

});
parcelRegister("eDfvp", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa70bc4e4dc96662$export$2e2bcd8739ae039);

var $6Yl8a = parcelRequire("6Yl8a");

var $fdGrT = parcelRequire("fdGrT");

var $asIMr = parcelRequire("asIMr");

var $cFPmV = parcelRequire("cFPmV");

var $kuBjs = parcelRequire("kuBjs");

var $4Bc5l = parcelRequire("4Bc5l");
'use client';
const $aa70bc4e4dc96662$var$defaultTheme = (0, $cFPmV.default)();
const $aa70bc4e4dc96662$var$Box = (0, $6Yl8a.default)({
    themeId: (0, $kuBjs.default),
    defaultTheme: $aa70bc4e4dc96662$var$defaultTheme,
    defaultClassName: (0, $4Bc5l.default).root,
    generateClassName: (0, $asIMr.default).generate
});
$aa70bc4e4dc96662$var$Box.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $aa70bc4e4dc96662$export$2e2bcd8739ae039 = $aa70bc4e4dc96662$var$Box;

});
parcelRegister("6Yl8a", function(module, exports) {

$parcel$export(module.exports, "default", () => $5138bcca88464df0$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $iVyaN = parcelRequire("iVyaN");

var $7P7g9 = parcelRequire("7P7g9");

var $6VmXC = parcelRequire("6VmXC");
var $bmcE0 = parcelRequire("bmcE0");

var $a4EsH = parcelRequire("a4EsH");

var $k4ank = parcelRequire("k4ank");
'use client';
const $5138bcca88464df0$var$_excluded = [
    "className",
    "component"
];
function $5138bcca88464df0$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $7P7g9.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $6VmXC.default));
    const Box = /*#__PURE__*/ $8T3gX.forwardRef(function Box(inProps, ref) {
        const theme = (0, $a4EsH.default)(defaultTheme);
        const _extendSxProp = (0, $bmcE0.default)(inProps), { className: className, component: component = 'div' } = _extendSxProp, other = (0, $fAJB5.default)(_extendSxProp, $5138bcca88464df0$var$_excluded);
        return /*#__PURE__*/ (0, $k4ank.jsx)(BoxRoot, (0, $eJfrs.default)({
            as: component,
            ref: ref,
            className: (0, $iVyaN.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}

});

parcelRegister("4Bc5l", function(module, exports) {

$parcel$export(module.exports, "default", () => $3593fdfe8fa3ce49$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");
const $3593fdfe8fa3ce49$var$boxClasses = (0, $jh2Zm.default)('MuiBox', [
    'root'
]);
var $3593fdfe8fa3ce49$export$2e2bcd8739ae039 = $3593fdfe8fa3ce49$var$boxClasses;

});




parcelRegister("hYduw", function(module, exports) {

$parcel$export(module.exports, "CamerasTable", () => $f1c4e95f42a29b6b$export$a18fa6d5d21a6a62);

var $k4ank = parcelRequire("k4ank");

var $jYCat = parcelRequire("jYCat");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $1wcxl = parcelRequire("1wcxl");

var $4reBM = parcelRequire("4reBM");

var $f3puC = parcelRequire("f3puC");

var $b9p11 = parcelRequire("b9p11");

var $faP87 = parcelRequire("faP87");

var $a65wX = parcelRequire("a65wX");

var $lWchQ = parcelRequire("lWchQ");

var $2aMB5 = parcelRequire("2aMB5");

var $iKAtE = parcelRequire("iKAtE");

var $e9rQm = parcelRequire("e9rQm");

var $g0plP = parcelRequire("g0plP");

var $hkpxe = parcelRequire("hkpxe");

var $hN0t7 = parcelRequire("hN0t7");

var $kbChx = parcelRequire("kbChx");

var $7m6K6 = parcelRequire("7m6K6");

var $8Uywj = parcelRequire("8Uywj");

var $cpwsh = parcelRequire("cpwsh");

var $697MX = parcelRequire("697MX");

var $i6PP0 = parcelRequire("i6PP0");

var $icq7G = parcelRequire("icq7G");

var $6uwmD = parcelRequire("6uwmD");

var $lugOn = parcelRequire("lugOn");

var $l8TQ5 = parcelRequire("l8TQ5");

var $crpct = parcelRequire("crpct");

var $6MI6A = parcelRequire("6MI6A");

var $cVCJe = parcelRequire("cVCJe");

var $2mUkt = parcelRequire("2mUkt");

var $j1Imp = parcelRequire("j1Imp");

var $gt8Ee = parcelRequire("gt8Ee");

var $cye0Y = parcelRequire("cye0Y");

var $gouAT = parcelRequire("gouAT");

var $fIsAN = parcelRequire("fIsAN");

var $8kfqT = parcelRequire("8kfqT");

var $fWsn7 = parcelRequire("fWsn7");

var $cIfQ5 = parcelRequire("cIfQ5");

var $3f8Bb = parcelRequire("3f8Bb");

var $hGi2P = parcelRequire("hGi2P");

var $3FJ79 = parcelRequire("3FJ79");

var $eka8d = parcelRequire("eka8d");

var $4PFLW = parcelRequire("4PFLW");

var $kfeuh = parcelRequire("kfeuh");
const $f1c4e95f42a29b6b$export$a18fa6d5d21a6a62 = ({ navigate: navigate, EnhancedTableHead: EnhancedTableHead, siteCameras: siteCameras, page: page, rowsPerPage: rowsPerPage, isSelected: isSelected, setPage: setPage, setRowsPerPage: setRowsPerPage, handleSelectAllClick: handleSelectAllClick, handleSingleCheckboxClick: handleSingleCheckboxClick, selected: selected, setSiteCameras: setSiteCameras, setDeleteDialogOpen: setDeleteDialogOpen, setAlertState: setAlertState, setSelected: setSelected, setSyncNeeded: setSyncNeeded, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setNoAutoAddCamerasDialogOpen: setNoAutoAddCamerasDialogOpen, siteInfo: siteInfo, setSiteInfo: setSiteInfo, setSiteSchedules: setSiteSchedules, setActiveTab: setActiveTab, setDataLoaded: setDataLoaded, setAllSiteSchedules: setAllSiteSchedules, setVmsVariables: setVmsVariables, setArmedStatus: setArmedStatus, setAiLinkSite: setAiLinkSite, setSiteDeployed: setSiteDeployed, setCamerasNotDeployed: setCamerasNotDeployed, setToolTipTitle: setToolTipTitle, setConfigureMotion: setConfigureMotion, setPatchObject: setPatchObject, setArmButtonDisabled: setArmButtonDisabled, setRecordingServerData: setRecordingServerData, setRecordingServerPatchObject: setRecordingServerPatchObject, setRecordingServerVisible: setRecordingServerVisible, setHealthCheckData: setHealthCheckData, setCamerasRefreshing: setCamerasRefreshing, permissions: permissions, setWebhooksInfo: setWebhooksInfo, setWebhooksPatchObject: setWebhooksPatchObject, siteSchedules: siteSchedules })=>{
    const [expandedObject, setExpandedObject] = $8T3gX.useState({});
    const { width: width } = (0, $crpct.default)();
    const [srcImages, setSrcImages] = $8T3gX.useState({});
    const [order, setOrder] = $8T3gX.useState("asc");
    const [orderBy, setOrderBy] = $8T3gX.useState("formatted_date");
    const [renderedRows, setRenderedRows] = $8T3gX.useState(siteCameras.results);
    // Keep camera status fresh until every camera has reported (ENG-2853).
    (0, $hN0t7.useCameraStatusPolling)($8T3gX.useMemo(()=>siteCameras.results.map((camera)=>Number(camera.id)), [
        siteCameras.results
    ]));
    const [allExpanded, setAllExpanded] = $8T3gX.useState(false);
    const [count, setCount] = $8T3gX.useState(0);
    const [bulkUpdateDialogOpen, setBulkUpdateDialogOpen] = $8T3gX.useState(false);
    const { isFeatureEnabled: isFeatureEnabled } = (0, $4PFLW.useFeatureFlag)();
    const showBulkUpdating = isFeatureEnabled("showBulkUpdating", false);
    const { hideUseMotion: hideUseMotion, activeCameraProducts: activeCameraProducts, activeCameraProductsLoading: activeCameraProductsLoading, prefetchBulkDialogActiveCameraProducts: prefetchBulkDialogActiveCameraProducts } = (0, $3FJ79.useSiteAboutStore)();
    const hideIgnoreZonesColumn = false;
    // The camera list's use_motion is a label: "Actuate"/"Milestone" when the
    // camera's resolved value is on, "" or "Native Camera" when it's off.
    const showBulkMotion = (0, $l8TQ5.motionSettingVisible)({
        integrationTypeName: siteInfo?.integration_type_name,
        siteUseMotion: siteInfo?.use_motion,
        cameraUsesMotion: siteCameras.results.some((camera)=>camera.use_motion === true || camera.use_motion === "Actuate" || camera.use_motion === "Milestone"),
        overrideMatters: siteCameras.results.some((camera)=>(0, $l8TQ5.overrideMayMatter)({
                integrationTypeName: siteInfo?.integration_type_name,
                override: camera.use_motion_override
            }))
    });
    const { handleFilterCameras: handleFilterCameras, selectedAutoPatrolScheduleIndex: selectedAutoPatrolScheduleIndex } = (0, $3FJ79.useSiteAboutStore)();
    const selectedCameras = $8T3gX.useMemo(()=>siteCameras.results.filter((camera)=>selected.includes(String(camera.id))).map((camera)=>({
                id: camera.id,
                camera_name: camera.camera_name
            })), [
        siteCameras.results,
        selected
    ]);
    const openBulkUpdateDialog = ()=>{
        const selectedCameraIds = selected.map(Number);
        if (selectedCameraIds.length === 0) return;
        setBulkUpdateDialogOpen(true);
        prefetchBulkDialogActiveCameraProducts(navigate, siteInfo?.id, selectedCameraIds);
    };
    const handleRequestSort = (event, property)=>{
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };
    const saveExpandedObject = (objectId)=>{
        setExpandedObject((previousState)=>({
                ...previousState,
                [objectId]: !previousState[objectId]
            }));
    };
    const saveExpandedObjectAllTrue = ()=>{
        setExpandedObject((previousState)=>{
            const nextState = {
                ...previousState
            };
            Object.keys(nextState).forEach((key)=>{
                nextState[key] = true;
            });
            return nextState;
        });
    };
    const saveExpandedObjectAllFalse = ()=>{
        setExpandedObject((previousState)=>{
            const nextState = {
                ...previousState
            };
            Object.keys(nextState).forEach((key)=>{
                nextState[key] = false;
            });
            return nextState;
        });
    };
    const handleChangePage = (event, newPage)=>{
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event)=>{
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    $8T3gX.useEffect(()=>{
        siteCameras.results.forEach((object)=>{
            setExpandedObject((previousState)=>{
                return {
                    ...previousState,
                    [object.id]: false
                };
            });
        });
    }, []);
    $8T3gX.useEffect(()=>{
        let filteredCameras = siteCameras.results;
        if (siteInfo.integration_type_name === "autopatrol") filteredCameras = handleFilterCameras(siteCameras.results);
        setCount(filteredCameras.length);
        setRenderedRows(filteredCameras);
    }, [
        siteCameras,
        expandedObject,
        selectedAutoPatrolScheduleIndex
    ]);
    const cameraIdsSignature = $8T3gX.useMemo(()=>siteCameras?.results?.map((c)=>c.id).join(",") ?? "", [
        siteCameras?.results
    ]);
    const siteCamerasRef = $8T3gX.useRef(siteCameras);
    siteCamerasRef.current = siteCameras;
    $8T3gX.useEffect(()=>{
        if (!cameraIdsSignature) return;
        (0, $2mUkt.getAndSaveSiteImages)(siteCamerasRef.current, setSrcImages, navigate);
    }, [
        cameraIdsSignature,
        navigate
    ]);
    const nA = `N/A`;
    const autopatrolSite = siteInfo.integration_type_name === "autopatrol";
    const visibleRows = $8T3gX.useMemo(()=>(0, $fWsn7.stableSort)(renderedRows, (0, $fWsn7.getComparator)(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        order,
        orderBy,
        page,
        rowsPerPage,
        renderedRows
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4reBM.default), {
        sx: {
            width: "100%",
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3Nm8Z.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "relative",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                            sx: {
                                fontFamily: "Mulish",
                                fontWeight: "Bold",
                                textIndent: "33px",
                                paddingTop: "10px"
                            },
                            variant: "h6",
                            id: "tableTitle",
                            component: "div",
                            children: [
                                "Site Cameras",
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "absolute right-9 top-[12px] flex items-center gap-3",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                                            theme: (0, $faP87.theme),
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                                type: "button",
                                                color: "primary",
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    textTransform: "none"
                                                },
                                                onClick: ()=>{
                                                    (0, $j1Imp.downloadCameraOverview)(siteInfo.id).catch(()=>{
                                                        alert("Failed to download the camera overview. Please try again.");
                                                    });
                                                },
                                                children: "Download Camera Overview"
                                            })
                                        }),
                                        (0, $jYCat.canShowOnvifScan)(permissions, siteInfo.integration_type_name) && /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                            type: "button",
                                            variant: "contained",
                                            onClick: ()=>{
                                                localStorage.setItem("addAdditionalCamera", "true");
                                                navigate(`/sites/${siteInfo.id}/onvifscan`);
                                            },
                                            sx: {
                                                fontFamily: "Mulish",
                                                textTransform: "none",
                                                backgroundColor: "#283E6D",
                                                color: "#FFFFFF",
                                                "&:hover": {
                                                    backgroundColor: "#1f2f54"
                                                }
                                            },
                                            children: "ONVIF Scan"
                                        }),
                                        (0, $jYCat.canShowCameraUnitScan)(permissions, siteInfo) && /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                            type: "button",
                                            variant: "contained",
                                            onClick: ()=>navigate(`/sites/${siteInfo.id}/unitscan`),
                                            sx: {
                                                fontFamily: "Mulish",
                                                textTransform: "none",
                                                backgroundColor: "#283E6D",
                                                color: "#FFFFFF",
                                                "&:hover": {
                                                    backgroundColor: "#1f2f54"
                                                }
                                            },
                                            children: "Refresh camera streams"
                                        }),
                                        siteInfo.integration_type_name !== "ailink" && siteInfo.integration_type_name !== "autopatrol" && permissions.add_cameras && /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                                            theme: (0, $faP87.theme),
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                                type: "button",
                                                color: "primary",
                                                onClick: ()=>{
                                                    localStorage.setItem("addAdditionalCamera", "true");
                                                    localStorage.setItem("clickedFromSiteAboutPage", "true");
                                                    localStorage.setItem("navigatedFromSitesAboutPage", "true");
                                                    if (siteInfo.auto_add) navigate("/sites/autoaddcamera");
                                                    else {
                                                        localStorage.setItem("firstCameraAdded", "true");
                                                        localStorage.setItem("copyValues", "true");
                                                        navigate("/sites/addcamera");
                                                    }
                                                },
                                                children: "+ Add Camera"
                                            })
                                        })
                                    ]
                                }),
                                siteInfo.display_refresh && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "absolute left-[160px] top-[12px]",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                                        theme: (0, $faP87.theme),
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $a65wX.default), {
                                            type: "button",
                                            color: "primary",
                                            onClick: ()=>{
                                                setBackdropLoadingScreenOn(true);
                                                setExpandedObject({});
                                                setCamerasRefreshing(true);
                                                (0, $3f8Bb.handleRefreshCameras)(navigate, setSiteInfo, setSiteSchedules, setSiteCameras, setActiveTab, setDataLoaded, setBackdropLoadingScreenOn, setAllSiteSchedules, setVmsVariables, setNoAutoAddCamerasDialogOpen, setArmedStatus, setAiLinkSite, setSiteDeployed, setSyncNeeded, setAlertState, setCamerasNotDeployed, setToolTipTitle, setConfigureMotion, setPatchObject, setArmButtonDisabled, setRecordingServerData, setRecordingServerPatchObject, setRecordingServerVisible, setHealthCheckData, setCamerasRefreshing, setWebhooksInfo, setWebhooksPatchObject);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cIfQ5))), {
                                                    fontSize: "small"
                                                }),
                                                " \xa0 Refresh Camera Previews"
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    siteInfo.integration_type_name !== "autopatrol" && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "pt-2",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                            className: "relative left-6",
                            children: [
                                permissions.add_cameras && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $7m6K6.DuplicateCameraSiteButton), {
                                            selected: selected,
                                            setSiteCameras: setSiteCameras,
                                            setAlertState: setAlertState,
                                            setSelected: setSelected,
                                            setSyncNeeded: setSyncNeeded
                                        }),
                                        "\xa0\xa0\xa0\xa0"
                                    ]
                                }),
                                permissions.edit_cameras && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $8Uywj.ActivateButton), {
                                            selected: selected,
                                            setSiteCameras: setSiteCameras,
                                            setAlertState: setAlertState,
                                            setSelected: setSelected,
                                            setSyncNeeded: setSyncNeeded,
                                            setBackdropLoadingScreenOn: setBackdropLoadingScreenOn
                                        }),
                                        "\xa0\xa0\xa0\xa0",
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $cpwsh.DeactivateButton), {
                                            selected: selected,
                                            setSiteCameras: setSiteCameras,
                                            setAlertState: setAlertState,
                                            setSelected: setSelected,
                                            setSyncNeeded: setSyncNeeded,
                                            setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                                            setSiteInfo: setSiteInfo
                                        }),
                                        "\xa0\xa0\xa0\xa0"
                                    ]
                                }),
                                permissions.delete_cameras && /*#__PURE__*/ (0, $k4ank.jsx)((0, $697MX.DeleteCameraButton), {
                                    selected: selected,
                                    setDeleteDialogOpen: setDeleteDialogOpen
                                }),
                                "\xa0\xa0\xa0\xa0",
                                permissions.edit_cameras && (0, $i6PP0.showMilestoneMotionButton)(siteInfo.integration_type_name) && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $i6PP0.MilestoneMotionButton), {
                                            selected: selected,
                                            siteInfo: siteInfo,
                                            setSiteCameras: setSiteCameras,
                                            setAlertState: setAlertState,
                                            setSelected: setSelected,
                                            setSyncNeeded: setSyncNeeded,
                                            setBackdropLoadingScreenOn: setBackdropLoadingScreenOn
                                        }),
                                        "\xa0\xa0\xa0\xa0"
                                    ]
                                }),
                                permissions.edit_cameras && showBulkMotion && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $icq7G.BulkMotionButton), {
                                            selected: selected,
                                            siteCameras: siteCameras,
                                            siteInfo: siteInfo,
                                            setSiteCameras: setSiteCameras,
                                            setSelected: setSelected,
                                            setSyncNeeded: setSyncNeeded
                                        }),
                                        "\xa0\xa0\xa0\xa0"
                                    ]
                                }),
                                permissions.edit_cameras && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $6uwmD.BulkEmailRecipientsButton), {
                                            siteCameras: siteCameras,
                                            siteInfo: siteInfo,
                                            setSiteCameras: setSiteCameras,
                                            setSyncNeeded: setSyncNeeded
                                        }),
                                        "\xa0\xa0\xa0\xa0"
                                    ]
                                }),
                                permissions.edit_cameras && showBulkUpdating && /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                                    theme: (0, $faP87.theme),
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                        type: "button",
                                        color: "primary",
                                        onClick: openBulkUpdateDialog,
                                        disabled: selected.length === 0,
                                        sx: {
                                            fontFamily: "Mulish"
                                        },
                                        children: "Bulk Update"
                                    })
                                })
                            ]
                        })
                    }),
                    siteInfo.integration_type_name !== "autopatrol" && showBulkUpdating && /*#__PURE__*/ (0, $k4ank.jsx)((0, $eka8d.BulkUpdateProductsDialog), {
                        open: bulkUpdateDialogOpen,
                        selectedCameras: selectedCameras,
                        activeCameraProducts: activeCameraProducts,
                        activeCameraProductsLoading: activeCameraProductsLoading,
                        siteInfo: siteInfo,
                        navigate: navigate,
                        onClose: ()=>{
                            setBulkUpdateDialogOpen(false);
                        },
                        onApply: ()=>{
                            setBulkUpdateDialogOpen(false);
                        }
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                        sx: {
                            minWidth: 1000,
                            fontFamily: "Mulish"
                        },
                        "aria-label": "simple table",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8kfqT.EnhancedCameraTableHead), {
                                onSelectAllClick: handleSelectAllClick,
                                numSelected: selected.length,
                                rowCount: siteCameras.results.length,
                                onRequestSort: handleRequestSort,
                                orderBy: orderBy,
                                order: order,
                                permissions: permissions,
                                allExpanded: allExpanded,
                                setAllExpanded: setAllExpanded,
                                setExpandedObject: setExpandedObject,
                                saveExpandedObjectAllTrue: saveExpandedObjectAllTrue,
                                saveExpandedObjectAllFalse: saveExpandedObjectAllFalse,
                                siteInfo: siteInfo
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                children: visibleRows.map((obj)=>{
                                    // const srcImageString = `${obj.id}full`;
                                    const isItemSelected = isSelected(obj.id);
                                    return /*#__PURE__*/ (0, $k4ank.jsxs)($8T3gX.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                role: "checkbox",
                                                "aria-checked": isItemSelected,
                                                tabIndex: -1,
                                                selected: isItemSelected,
                                                children: [
                                                    permissions.edit_cameras && siteInfo.integration_type_name !== "autopatrol" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        padding: "checkbox",
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                            color: "primary",
                                                            checked: isItemSelected,
                                                            onClick: (event)=>handleSingleCheckboxClick(event, obj.id)
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                        title: /*#__PURE__*/ (0, $k4ank.jsx)($8T3gX.Fragment, {
                                                            children: srcImages[obj.id]
                                                        }),
                                                        placement: "right-start",
                                                        sx: {
                                                            fontSize: "15px",
                                                            fontFamily: "mulish"
                                                        },
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            sx: {
                                                                width: 300,
                                                                fontFamily: "Mulish"
                                                            },
                                                            align: "left",
                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                                                                to: `/sites/${siteInfo.id}/editcamera/${obj.id}`,
                                                                style: {
                                                                    color: "#0d47a1",
                                                                    textDecoration: "none",
                                                                    cursor: "pointer"
                                                                },
                                                                onMouseEnter: (e)=>{
                                                                    e.currentTarget.style.color = "#002171";
                                                                    e.currentTarget.style.textDecoration = "underline";
                                                                },
                                                                onMouseLeave: (e)=>{
                                                                    e.currentTarget.style.color = "#0d47a1";
                                                                    e.currentTarget.style.textDecoration = "none";
                                                                },
                                                                children: obj.camera_name
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        children: obj.active ? (0, $lWchQ.checkedCircleIcon) : (0, $2aMB5.cancelIconRed)
                                                    }),
                                                    !hideUseMotion && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish",
                                                            width: 150
                                                        },
                                                        children: [
                                                            obj.use_motion ? obj.use_motion : nA,
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $lugOn.MotionOverrideMarker), {
                                                                override: obj.use_motion_override
                                                            })
                                                        ]
                                                    }),
                                                    !hideIgnoreZonesColumn && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish",
                                                            width: 180
                                                        },
                                                        children: obj.has_ignore_zones ? (0, $lWchQ.checkedCircleIcon) : (0, $2aMB5.cancelIconRed)
                                                    }),
                                                    siteInfo.integration_type_name !== "ailink" && !autopatrolSite ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish"
                                                        },
                                                        children: [
                                                            obj.health_status === "healthy" && (0, $lWchQ.checkedCircleIcon),
                                                            obj.health_status === "error" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                                title: obj.camera_health_comment ? obj.camera_health_comment : "Unable to connect to the camera or no frame since launch",
                                                                placement: "top",
                                                                sx: {
                                                                    fontSize: "24px",
                                                                    fontFamily: "mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cye0Y))), {
                                                                    color: "error"
                                                                })
                                                            }),
                                                            (obj.health_status === "unknown" || obj.health_status === null) && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                                title: obj.camera_health_comment ? obj.camera_health_comment : "Unable to determine the health status of this camera",
                                                                placement: "top",
                                                                sx: {
                                                                    fontSize: "24px",
                                                                    fontFamily: "mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gt8Ee))), {
                                                                    sx: {
                                                                        color: "#b4b4b4"
                                                                    }
                                                                })
                                                            }),
                                                            obj.health_status === "warning" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                                title: obj.camera_health_comment ? obj.camera_health_comment : "Broken frames since launch or blurry view",
                                                                placement: "top",
                                                                sx: {
                                                                    fontSize: "15px",
                                                                    fontFamily: "mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gouAT))), {
                                                                    sx: {
                                                                        color: "#F57C00"
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    }) : !autopatrolSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish"
                                                        },
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                            title: "Health can not be measured on a camera on this type of site (AI Link)",
                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gt8Ee))), {
                                                                sx: {
                                                                    color: "#b4b4b4"
                                                                }
                                                            })
                                                        })
                                                    }),
                                                    !autopatrolSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish",
                                                            width: 200
                                                        },
                                                        children: (0, $hGi2P.createOptimalSettingsIcon)(srcImages, obj)
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "right",
                                                        sx: {
                                                            position: "sticky",
                                                            right: 0,
                                                            backgroundColor: "white",
                                                            zIndex: 1,
                                                            fontFamily: "Mulish",
                                                            fontWeight: "Bold",
                                                            fontSize: "15px",
                                                            minWidth: 150,
                                                            paddingRight: "40px"
                                                        },
                                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                            className: "flex items-center justify-end gap-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $kfeuh.TalkDownButton), {
                                                                    cameraId: obj.id,
                                                                    cameraName: obj.camera_name ?? "",
                                                                    integrationTypeName: siteInfo.integration_type_name,
                                                                    talkDownCapable: obj.talk_down_capable
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                                                    "aria-label": "expand row",
                                                                    size: "small",
                                                                    onClick: ()=>{
                                                                        saveExpandedObject(obj.id);
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                                                                        theme: (0, $faP87.theme),
                                                                        children: expandedObject[obj.id] ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $6MI6A.default), {
                                                                            icon: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g0plP))), {}),
                                                                            label: "Show Less",
                                                                            color: "secondary",
                                                                            sx: {
                                                                                fontFamily: "Mulish"
                                                                            }
                                                                        }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $6MI6A.default), {
                                                                            icon: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9rQm))), {}),
                                                                            label: "Show More",
                                                                            color: "secondary",
                                                                            sx: {
                                                                                fontFamily: "Mulish"
                                                                            }
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $hkpxe.CameraInfoRow), {
                                                obj: obj,
                                                expanded: expandedObject[obj.id],
                                                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                                                siteInfo: siteInfo,
                                                permissions: permissions,
                                                srcImages: srcImages
                                            })
                                        ]
                                    }, obj.id);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wcxl.default), {
                rowsPerPageOptions: [
                    5,
                    10,
                    25
                ],
                component: "div",
                count: count,
                rowsPerPage: rowsPerPage,
                page: page,
                onPageChange: handleChangePage,
                onRowsPerPageChange: handleChangeRowsPerPage
            })
        ]
    });
};

});
parcelRegister("k8Qy8", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea9d5143c6cca3b1$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $f5lDx = parcelRequire("f5lDx");

var $7AQZl = parcelRequire("7AQZl");

var $anJSP = parcelRequire("anJSP");

var $3p0gp = parcelRequire("3p0gp");

var $k4ank = parcelRequire("k4ank");
'use client';
const $ea9d5143c6cca3b1$var$_excluded = [
    "className",
    "component",
    "padding",
    "size",
    "stickyHeader"
];
const $ea9d5143c6cca3b1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            stickyHeader && 'stickyHeader'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $3p0gp.getTableUtilityClass), classes);
};
const $ea9d5143c6cca3b1$var$TableRoot = (0, $anJSP.default)('table', {
    name: 'MuiTable',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        display: 'table',
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        '& caption': (0, $eJfrs.default)({}, theme.typography.body2, {
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: 'left',
            captionSide: 'bottom'
        })
    }, ownerState.stickyHeader && {
        borderCollapse: 'separate'
    }));
const $ea9d5143c6cca3b1$var$defaultComponent = 'table';
const $ea9d5143c6cca3b1$var$Table = /*#__PURE__*/ $8T3gX.forwardRef(function Table(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiTable'
    });
    const { className: className, component: component = $ea9d5143c6cca3b1$var$defaultComponent, padding: padding = 'normal', size: size = 'medium', stickyHeader: stickyHeader = false } = props, other = (0, $fAJB5.default)(props, $ea9d5143c6cca3b1$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    });
    const classes = $ea9d5143c6cca3b1$var$useUtilityClasses(ownerState);
    const table = $8T3gX.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $f5lDx.default).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $k4ank.jsx)($ea9d5143c6cca3b1$var$TableRoot, (0, $eJfrs.default)({
            as: component,
            role: component === $ea9d5143c6cca3b1$var$defaultComponent ? null : 'table',
            ref: ref,
            className: (0, $iVyaN.default)(classes.root, className),
            ownerState: ownerState
        }, other))
    });
});
$ea9d5143c6cca3b1$var$Table.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * Allows TableCells to inherit padding of the Table.
   * @default 'normal'
   */ padding: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'checkbox',
        'none',
        'normal'
    ]),
    /**
   * Allows TableCells to inherit size of the Table.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'medium',
            'small'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * Set the header sticky.
   *
   * ⚠️ It doesn't work with IE11.
   * @default false
   */ stickyHeader: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $ea9d5143c6cca3b1$export$2e2bcd8739ae039 = $ea9d5143c6cca3b1$var$Table;

});
parcelRegister("3p0gp", function(module, exports) {

$parcel$export(module.exports, "getTableUtilityClass", () => $27a3e9477fe210b5$export$315cb19215f77ce0);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $27a3e9477fe210b5$export$315cb19215f77ce0(slot) {
    return (0, $kfTYv.default)('MuiTable', slot);
}
const $27a3e9477fe210b5$var$tableClasses = (0, $jh2Zm.default)('MuiTable', [
    'root',
    'stickyHeader'
]);
var $27a3e9477fe210b5$export$2e2bcd8739ae039 = $27a3e9477fe210b5$var$tableClasses;

});


parcelRegister("gXvgZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c58a6a34677e69ec$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $g2g0C = parcelRequire("g2g0C");

var $7AQZl = parcelRequire("7AQZl");

var $anJSP = parcelRequire("anJSP");

var $2juZb = parcelRequire("2juZb");

var $k4ank = parcelRequire("k4ank");
'use client';
const $c58a6a34677e69ec$var$_excluded = [
    "className",
    "component"
];
const $c58a6a34677e69ec$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $2juZb.getTableBodyUtilityClass), classes);
};
const $c58a6a34677e69ec$var$TableBodyRoot = (0, $anJSP.default)('tbody', {
    name: 'MuiTableBody',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'table-row-group'
});
const $c58a6a34677e69ec$var$tablelvl2 = {
    variant: 'body'
};
const $c58a6a34677e69ec$var$defaultComponent = 'tbody';
const $c58a6a34677e69ec$var$TableBody = /*#__PURE__*/ $8T3gX.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiTableBody'
    });
    const { className: className, component: component = $c58a6a34677e69ec$var$defaultComponent } = props, other = (0, $fAJB5.default)(props, $c58a6a34677e69ec$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        component: component
    });
    const classes = $c58a6a34677e69ec$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $g2g0C.default).Provider, {
        value: $c58a6a34677e69ec$var$tablelvl2,
        children: /*#__PURE__*/ (0, $k4ank.jsx)($c58a6a34677e69ec$var$TableBodyRoot, (0, $eJfrs.default)({
            className: (0, $iVyaN.default)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $c58a6a34677e69ec$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState
        }, other))
    });
});
$c58a6a34677e69ec$var$TableBody.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component, normally `TableRow`.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $c58a6a34677e69ec$export$2e2bcd8739ae039 = $c58a6a34677e69ec$var$TableBody;

});
parcelRegister("2juZb", function(module, exports) {

$parcel$export(module.exports, "getTableBodyUtilityClass", () => $1af5643ebcb40515$export$98bd2a9b566ec665);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $1af5643ebcb40515$export$98bd2a9b566ec665(slot) {
    return (0, $kfTYv.default)('MuiTableBody', slot);
}
const $1af5643ebcb40515$var$tableBodyClasses = (0, $jh2Zm.default)('MuiTableBody', [
    'root'
]);
var $1af5643ebcb40515$export$2e2bcd8739ae039 = $1af5643ebcb40515$var$tableBodyClasses;

});


parcelRegister("1wcxl", function(module, exports) {

$parcel$export(module.exports, "default", () => $11b281262ce9c181$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $97LlG = parcelRequire("97LlG");

var $bPpmJ = parcelRequire("bPpmJ");

var $aYNpO = parcelRequire("aYNpO");

var $lkMit = parcelRequire("lkMit");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $iFXjq = parcelRequire("iFXjq");

var $cxknk = parcelRequire("cxknk");

var $2eEqG = parcelRequire("2eEqG");

var $aVDw9 = parcelRequire("aVDw9");

var $kRZvb = parcelRequire("kRZvb");

var $9ztLz = parcelRequire("9ztLz");

var $1xq4a = parcelRequire("1xq4a");

var $1zmeQ = parcelRequire("1zmeQ");

var $k4ank = parcelRequire("k4ank");
'use client';
var $11b281262ce9c181$var$_InputBase;
const $11b281262ce9c181$var$_excluded = [
    "ActionsComponent",
    "backIconButtonProps",
    "className",
    "colSpan",
    "component",
    "count",
    "disabled",
    "getItemAriaLabel",
    "labelDisplayedRows",
    "labelRowsPerPage",
    "nextIconButtonProps",
    "onPageChange",
    "onRowsPerPageChange",
    "page",
    "rowsPerPage",
    "rowsPerPageOptions",
    "SelectProps",
    "showFirstButton",
    "showLastButton",
    "slotProps",
    "slots"
];
const $11b281262ce9c181$var$TablePaginationRoot = (0, $anJSP.default)((0, $aVDw9.default), {
    name: 'MuiTablePagination',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        overflow: 'auto',
        color: (theme.vars || theme).palette.text.primary,
        fontSize: theme.typography.pxToRem(14),
        // Increase the specificity to override TableCell.
        '&:last-child': {
            padding: 0
        }
    }));
const $11b281262ce9c181$var$TablePaginationToolbar = (0, $anJSP.default)((0, $kRZvb.default), {
    name: 'MuiTablePagination',
    slot: 'Toolbar',
    overridesResolver: (props, styles)=>(0, $eJfrs.default)({
            [`& .${(0, $1zmeQ.default).actions}`]: styles.actions
        }, styles.toolbar)
})(({ theme: theme })=>({
        minHeight: 52,
        paddingRight: 2,
        [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
            minHeight: 52
        },
        [theme.breakpoints.up('sm')]: {
            minHeight: 52,
            paddingRight: 2
        },
        [`& .${(0, $1zmeQ.default).actions}`]: {
            flexShrink: 0,
            marginLeft: 20
        }
    }));
const $11b281262ce9c181$var$TablePaginationSpacer = (0, $anJSP.default)('div', {
    name: 'MuiTablePagination',
    slot: 'Spacer',
    overridesResolver: (props, styles)=>styles.spacer
})({
    flex: '1 1 100%'
});
const $11b281262ce9c181$var$TablePaginationSelectLabel = (0, $anJSP.default)('p', {
    name: 'MuiTablePagination',
    slot: 'SelectLabel',
    overridesResolver: (props, styles)=>styles.selectLabel
})(({ theme: theme })=>(0, $eJfrs.default)({}, theme.typography.body2, {
        flexShrink: 0
    }));
const $11b281262ce9c181$var$TablePaginationSelect = (0, $anJSP.default)((0, $2eEqG.default), {
    name: 'MuiTablePagination',
    slot: 'Select',
    overridesResolver: (props, styles)=>(0, $eJfrs.default)({
            [`& .${(0, $1zmeQ.default).selectIcon}`]: styles.selectIcon,
            [`& .${(0, $1zmeQ.default).select}`]: styles.select
        }, styles.input, styles.selectRoot)
})({
    color: 'inherit',
    fontSize: 'inherit',
    flexShrink: 0,
    marginRight: 32,
    marginLeft: 8,
    [`& .${(0, $1zmeQ.default).select}`]: {
        paddingLeft: 8,
        paddingRight: 24,
        textAlign: 'right',
        textAlignLast: 'right' // Align <select> on Chrome.
    }
});
const $11b281262ce9c181$var$TablePaginationMenuItem = (0, $anJSP.default)((0, $cxknk.default), {
    name: 'MuiTablePagination',
    slot: 'MenuItem',
    overridesResolver: (props, styles)=>styles.menuItem
})({});
const $11b281262ce9c181$var$TablePaginationDisplayedRows = (0, $anJSP.default)('p', {
    name: 'MuiTablePagination',
    slot: 'DisplayedRows',
    overridesResolver: (props, styles)=>styles.displayedRows
})(({ theme: theme })=>(0, $eJfrs.default)({}, theme.typography.body2, {
        flexShrink: 0
    }));
function $11b281262ce9c181$var$defaultLabelDisplayedRows({ from: from, to: to, count: count }) {
    return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${to}`}`;
}
function $11b281262ce9c181$var$defaultGetAriaLabel(type) {
    return `Go to ${type} page`;
}
const $11b281262ce9c181$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        toolbar: [
            'toolbar'
        ],
        spacer: [
            'spacer'
        ],
        selectLabel: [
            'selectLabel'
        ],
        select: [
            'select'
        ],
        input: [
            'input'
        ],
        selectIcon: [
            'selectIcon'
        ],
        menuItem: [
            'menuItem'
        ],
        displayedRows: [
            'displayedRows'
        ],
        actions: [
            'actions'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $1zmeQ.getTablePaginationUtilityClass), classes);
};
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */ const $11b281262ce9c181$var$TablePagination = /*#__PURE__*/ $8T3gX.forwardRef(function TablePagination(inProps, ref) {
    var _slotProps$select;
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiTablePagination'
    });
    const { ActionsComponent: ActionsComponent = (0, $9ztLz.default), backIconButtonProps: backIconButtonProps, className: className, colSpan: colSpanProp, component: component = (0, $aVDw9.default), count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $11b281262ce9c181$var$defaultGetAriaLabel, labelDisplayedRows: labelDisplayedRows = $11b281262ce9c181$var$defaultLabelDisplayedRows, labelRowsPerPage: labelRowsPerPage = 'Rows per page:', nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, page: page, rowsPerPage: rowsPerPage, rowsPerPageOptions: rowsPerPageOptions = [
        10,
        25,
        50,
        100
    ], SelectProps: SelectProps = {}, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $fAJB5.default)(props, $11b281262ce9c181$var$_excluded);
    const ownerState = props;
    const classes = $11b281262ce9c181$var$useUtilityClasses(ownerState);
    const selectProps = (_slotProps$select = slotProps == null ? void 0 : slotProps.select) != null ? _slotProps$select : SelectProps;
    const MenuItemComponent = selectProps.native ? 'option' : $11b281262ce9c181$var$TablePaginationMenuItem;
    let colSpan;
    if (component === (0, $aVDw9.default) || component === 'td') colSpan = colSpanProp || 1000; // col-span over everything
    const selectId = (0, $1xq4a.default)(selectProps.id);
    const labelId = (0, $1xq4a.default)(selectProps.labelId);
    const getLabelDisplayedRowsTo = ()=>{
        if (count === -1) return (page + 1) * rowsPerPage;
        return rowsPerPage === -1 ? count : Math.min(count, (page + 1) * rowsPerPage);
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)($11b281262ce9c181$var$TablePaginationRoot, (0, $eJfrs.default)({
        colSpan: colSpan,
        ref: ref,
        as: component,
        ownerState: ownerState,
        className: (0, $iVyaN.default)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)($11b281262ce9c181$var$TablePaginationToolbar, {
            className: classes.toolbar,
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)($11b281262ce9c181$var$TablePaginationSpacer, {
                    className: classes.spacer
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $k4ank.jsx)($11b281262ce9c181$var$TablePaginationSelectLabel, {
                    className: classes.selectLabel,
                    id: labelId,
                    children: labelRowsPerPage
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $k4ank.jsx)($11b281262ce9c181$var$TablePaginationSelect, (0, $eJfrs.default)({
                    variant: "standard"
                }, !selectProps.variant && {
                    input: $11b281262ce9c181$var$_InputBase || ($11b281262ce9c181$var$_InputBase = /*#__PURE__*/ (0, $k4ank.jsx)((0, $iFXjq.default), {}))
                }, {
                    value: rowsPerPage,
                    onChange: onRowsPerPageChange,
                    id: selectId,
                    labelId: labelId
                }, selectProps, {
                    classes: (0, $eJfrs.default)({}, selectProps.classes, {
                        // TODO v5 remove `classes.input`
                        root: (0, $iVyaN.default)(classes.input, classes.selectRoot, (selectProps.classes || {}).root),
                        select: (0, $iVyaN.default)(classes.select, (selectProps.classes || {}).select),
                        // TODO v5 remove `selectIcon`
                        icon: (0, $iVyaN.default)(classes.selectIcon, (selectProps.classes || {}).icon)
                    }),
                    disabled: disabled,
                    children: rowsPerPageOptions.map((rowsPerPageOption)=>/*#__PURE__*/ (0, $8T3gX.createElement)(MenuItemComponent, (0, $eJfrs.default)({}, !(0, $lkMit.default)(MenuItemComponent) && {
                            ownerState: ownerState
                        }, {
                            className: classes.menuItem,
                            key: rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption,
                            value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
                        }), rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption))
                })),
                /*#__PURE__*/ (0, $k4ank.jsx)($11b281262ce9c181$var$TablePaginationDisplayedRows, {
                    className: classes.displayedRows,
                    children: labelDisplayedRows({
                        from: count === 0 ? 0 : page * rowsPerPage + 1,
                        to: getLabelDisplayedRowsTo(),
                        count: count === -1 ? -1 : count,
                        page: page
                    })
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)(ActionsComponent, {
                    className: classes.actions,
                    backIconButtonProps: backIconButtonProps,
                    count: count,
                    nextIconButtonProps: nextIconButtonProps,
                    onPageChange: onPageChange,
                    page: page,
                    rowsPerPage: rowsPerPage,
                    showFirstButton: showFirstButton,
                    showLastButton: showLastButton,
                    slotProps: slotProps.actions,
                    slots: slots.actions,
                    getItemAriaLabel: getItemAriaLabel,
                    disabled: disabled
                })
            ]
        })
    }));
});
$11b281262ce9c181$var$TablePagination.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The component used for displaying the actions.
   * Either a string to use a HTML element or a component.
   * @default TablePaginationActions
   */ ActionsComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * Props applied to the back arrow [`IconButton`](/material-ui/api/icon-button/) component.
   *
   * This prop is an alias for `slotProps.actions.previousButton` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.actions.previousButton` instead.
   */ backIconButtonProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * @ignore
   */ colSpan: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * The total number of rows.
   *
   * To enable server side pagination for an unknown number of items, provide -1.
   */ count: (0, $97LlG.default).isRequired,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('first' | 'last' | 'next' | 'previous').
   * @returns {string}
   * @default function defaultGetAriaLabel(type) {
   *   return `Go to ${type} page`;
   * }
   */ getItemAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Customize the displayed rows label. Invoked with a `{ from, to, count, page }`
   * object.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default function defaultLabelDisplayedRows({ from, to, count }) {
   *   return `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`;
   * }
   */ labelDisplayedRows: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Customize the rows per page label.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Rows per page:'
   */ labelRowsPerPage: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Props applied to the next arrow [`IconButton`](/material-ui/api/icon-button/) element.
   *
   * This prop is an alias for `slotProps.actions.nextButton` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.actions.nextButton` instead.
   */ nextIconButtonProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Callback fired when the page is changed.
   *
   * @param {React.MouseEvent<HTMLButtonElement> | null} event The event source of the callback.
   * @param {number} page The page selected.
   */ onPageChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired,
    /**
   * Callback fired when the number of rows per page is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   */ onRowsPerPageChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * The zero-based index of the current page.
   */ page: (0, $bPpmJ.default)((0, $97LlG.default).isRequired, (props)=>{
        const { count: count, page: page, rowsPerPage: rowsPerPage } = props;
        if (count === -1) return null;
        const newLastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);
        if (page < 0 || page > newLastPage) return new Error('MUI: The page prop of a TablePagination is out of range ' + `(0 to ${newLastPage}, but page is ${page}).`);
        return null;
    }),
    /**
   * The number of rows per page.
   *
   * Set -1 to display all the rows.
   */ rowsPerPage: (0, $97LlG.default).isRequired,
    /**
   * Customizes the options of the rows per page select field. If less than two options are
   * available, no select field will be displayed.
   * Use -1 for the value with a custom label to show all the rows.
   * @default [10, 25, 50, 100]
   */ rowsPerPageOptions: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            label: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string.isRequired,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number.isRequired
        })
    ]).isRequired),
    /**
   * Props applied to the rows per page [`Select`](/material-ui/api/select/) element.
   *
   * This prop is an alias for `slotProps.select` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.select` instead.
   *
   * @default {}
   */ SelectProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * If `true`, show the first-page button.
   * @default false
   */ showFirstButton: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, show the last-page button.
   * @default false
   */ showLastButton: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The props used for each slot inside the TablePagination.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        actions: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            firstButton: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            firstButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            lastButton: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            lastButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            nextButton: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            nextButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            previousButton: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            previousButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        }),
        select: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    }),
    /**
   * The components used for each slot inside the TablePagination.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        actions: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            firstButton: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
            firstButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
            lastButton: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
            lastButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
            nextButton: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
            nextButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
            previousButton: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
            previousButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
        })
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $11b281262ce9c181$export$2e2bcd8739ae039 = $11b281262ce9c181$var$TablePagination;

});
parcelRegister("iFXjq", function(module, exports) {

$parcel$export(module.exports, "rootOverridesResolver", () => $d98a108b00824ef4$export$965edad20a84fa75);
$parcel$export(module.exports, "inputOverridesResolver", () => $d98a108b00824ef4$export$cf507b112810e72d);
$parcel$export(module.exports, "InputBaseRoot", () => $d98a108b00824ef4$export$298a043133d72a38);
$parcel$export(module.exports, "InputBaseComponent", () => $d98a108b00824ef4$export$a1ad29c901026019);
$parcel$export(module.exports, "default", () => $d98a108b00824ef4$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");


var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $26cdd = parcelRequire("26cdd");

var $dSmkj = parcelRequire("dSmkj");

var $aYNpO = parcelRequire("aYNpO");

var $lkMit = parcelRequire("lkMit");

var $cicun = parcelRequire("cicun");

var $k1SKW = parcelRequire("k1SKW");

var $680s3 = parcelRequire("680s3");

var $c8JM8 = parcelRequire("c8JM8");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $iMOmE = parcelRequire("iMOmE");

var $11ydL = parcelRequire("11ydL");

var $a9NOs = parcelRequire("a9NOs");

var $kzvFs = parcelRequire("kzvFs");

var $g0gie = parcelRequire("g0gie");

var $5aFhN = parcelRequire("5aFhN");

var $k4ank = parcelRequire("k4ank");
'use client';
const $d98a108b00824ef4$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $d98a108b00824ef4$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $iMOmE.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $d98a108b00824ef4$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $d98a108b00824ef4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $iMOmE.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $iMOmE.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $5aFhN.getInputBaseUtilityClass), classes);
};
const $d98a108b00824ef4$export$298a043133d72a38 = (0, $anJSP.default)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $d98a108b00824ef4$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $5aFhN.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        }
    }, ownerState.multiline && (0, $eJfrs.default)({
        padding: '4px 0 5px'
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: '100%'
    }));
const $d98a108b00824ef4$export$a1ad29c901026019 = (0, $anJSP.default)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $d98a108b00824ef4$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = (0, $eJfrs.default)({
        color: 'currentColor'
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $eJfrs.default)({
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        // Fix IE11 width issue
        animationName: 'mui-auto-fill-cancel',
        animationDuration: '10ms',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholder,
        // IE11
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $5aFhN.default).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&:-ms-input-placeholder': placeholderHidden,
            // IE11
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus:-ms-input-placeholder': placeholderVisible,
            // IE11
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $5aFhN.default).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        '&:-webkit-autofill': {
            animationDuration: '5000s',
            animationName: 'mui-auto-fill'
        }
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: 'auto',
        resize: 'none',
        padding: 0,
        paddingTop: 0
    }, ownerState.type === 'search' && {
        // Improve type search style.
        MozAppearance: 'textfield'
    });
});
const $d98a108b00824ef4$var$inputGlobalStyles = /*#__PURE__*/ (0, $k4ank.jsx)((0, $kzvFs.default), {
    styles: {
        '@keyframes mui-auto-fill': {
            from: {
                display: 'block'
            }
        },
        '@keyframes mui-auto-fill-cancel': {
            from: {
                display: 'block'
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $d98a108b00824ef4$var$InputBase = /*#__PURE__*/ $8T3gX.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp } = props, other = (0, $fAJB5.default)(props, $d98a108b00824ef4$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $8T3gX.useRef(value != null);
    const inputRef = $8T3gX.useRef();
    const handleInputRefWarning = $8T3gX.useCallback((instance)=>{
        if (instance && instance.nodeName !== 'INPUT' && !instance.focus) console.error([
            'MUI: You have provided a `inputComponent` to the input component',
            'that does not correctly handle the `ref` prop.',
            'Make sure the `ref` prop is called with a HTMLInputElement.'
        ].join('\n'));
    }, []);
    const handleInputRef = (0, $11ydL.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $8T3gX.useState(false);
    const muiFormControl = (0, $c8JM8.default)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8T3gX.useEffect(()=>{
        if (muiFormControl) return muiFormControl.registerEffect();
        return undefined;
    }, [
        muiFormControl
    ]);
    const fcs = (0, $k1SKW.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $8T3gX.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $8T3gX.useCallback((obj)=>{
        if ((0, $g0gie.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $a9NOs.default)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error(`MUI: Expected valid input target. Did you use a custom \`inputComponent\` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info.`);
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $8T3gX.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) {
            if (minRows || maxRows) console.warn('MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set.');
            inputProps = (0, $eJfrs.default)({
                type: undefined,
                minRows: rows,
                maxRows: rows
            }, inputProps);
        } else inputProps = (0, $eJfrs.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $cicun.default);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $8T3gX.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $eJfrs.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $d98a108b00824ef4$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $d98a108b00824ef4$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $d98a108b00824ef4$export$a1ad29c901026019;
    inputProps = (0, $eJfrs.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $k4ank.jsxs)($8T3gX.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $d98a108b00824ef4$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $k4ank.jsxs)(Root, (0, $eJfrs.default)({}, rootProps, !(0, $lkMit.default)(Root) && {
                ownerState: (0, $eJfrs.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $iVyaN.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $680s3.default).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $k4ank.jsx)(Input, (0, $eJfrs.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $lkMit.default)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $eJfrs.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $iVyaN.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $eJfrs.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
$d98a108b00824ef4$var$InputBase.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ 'aria-describedby': (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true`, the `input` element is focused during the first mount.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        Input: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        Root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    }),
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */ disableInjectingGlobalStyles: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * End `InputAdornment` for this component.
   */ endAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */ inputComponent: (0, $26cdd.default),
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $dSmkj.default),
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'dense',
        'none'
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * Minimum number of rows to display when multiline option is set to true.
   */ minRows: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */ multiline: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Name attribute of the `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */ onInvalid: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onKeyUp: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * The short hint displayed in the `input` before the user enters a value.
   */ placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * @ignore
   */ renderSuffix: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Number of rows to display when multiline option is set to true.
   */ rows: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The size of the component.
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'medium',
            'small'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    }),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * Start `InputAdornment` for this component.
   */ startAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any
};
var $d98a108b00824ef4$export$2e2bcd8739ae039 = $d98a108b00824ef4$var$InputBase;

});
parcelRegister("cicun", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f30da85f2824602$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $844bI = parcelRequire("844bI");
var $6LMzY = parcelRequire("6LMzY");
var $5IwAt = parcelRequire("5IwAt");
var $fPAwT = parcelRequire("fPAwT");
var $ktSDD = parcelRequire("ktSDD");

var $k4ank = parcelRequire("k4ank");
'use client';
const $8f30da85f2824602$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $8f30da85f2824602$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $8f30da85f2824602$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $8f30da85f2824602$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $8f30da85f2824602$var$isEmpty(obj) {
    return $8f30da85f2824602$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $8f30da85f2824602$var$TextareaAutosize = /*#__PURE__*/ $8T3gX.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $fAJB5.default)(props, $8f30da85f2824602$var$_excluded);
    const { current: isControlled } = $8T3gX.useRef(value != null);
    const textareaRef = $8T3gX.useRef(null);
    const handleRef = (0, $ktSDD.default)(forwardedRef, textareaRef);
    const heightRef = $8T3gX.useRef(null);
    const hiddenTextareaRef = $8T3gX.useRef(null);
    const calculateTextareaStyles = $8T3gX.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, $6LMzY.default)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $8f30da85f2824602$var$getStyleValue(computedStyle.paddingBottom) + $8f30da85f2824602$var$getStyleValue(computedStyle.paddingTop);
        const border = $8f30da85f2824602$var$getStyleValue(computedStyle.borderBottomWidth) + $8f30da85f2824602$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, $fPAwT.default)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $8f30da85f2824602$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $8T3gX.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $8f30da85f2824602$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $8T3gX.useRef(-1);
    (0, $5IwAt.default)(()=>{
        const debouncedHandleResize = (0, $844bI.default)(syncHeight);
        const textarea = textareaRef == null ? void 0 : textareaRef.current;
        if (!textarea) return undefined;
        const containerWindow = (0, $6LMzY.default)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, $5IwAt.default)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)($8T3gX.Fragment, {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("textarea", (0, $eJfrs.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style
            }, other)),
            /*#__PURE__*/ (0, $k4ank.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: (0, $eJfrs.default)({}, $8f30da85f2824602$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});
$8f30da85f2824602$var$TextareaAutosize.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Maximum number of rows to display.
   */ maxRows: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * Minimum number of rows to display.
   * @default 1
   */ minRows: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * @ignore
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * @ignore
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ])
};
var $8f30da85f2824602$export$2e2bcd8739ae039 = $8f30da85f2824602$var$TextareaAutosize;

});
parcelRegister("844bI", function(module, exports) {

$parcel$export(module.exports, "default", () => $5df1f215e517b94d$export$2e2bcd8739ae039);
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $5df1f215e517b94d$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

});

parcelRegister("6LMzY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4edcd0ac369bf6b0$export$2e2bcd8739ae039);

var $iYkpH = parcelRequire("iYkpH");
function $4edcd0ac369bf6b0$export$2e2bcd8739ae039(node) {
    const doc = (0, $iYkpH.default)(node);
    return doc.defaultView || window;
}

});


parcelRegister("k1SKW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e94e601423ac94cf$export$2e2bcd8739ae039);
function $e94e601423ac94cf$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

});

parcelRegister("680s3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4763d71184f01d86$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");
/**
 * @ignore - internal component.
 */ const $4763d71184f01d86$var$FormControlContext = /*#__PURE__*/ $8T3gX.createContext(undefined);
$4763d71184f01d86$var$FormControlContext.displayName = 'FormControlContext';
var $4763d71184f01d86$export$2e2bcd8739ae039 = $4763d71184f01d86$var$FormControlContext;

});

parcelRegister("c8JM8", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d69bd66ba727159$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");

var $680s3 = parcelRequire("680s3");
'use client';
function $8d69bd66ba727159$export$2e2bcd8739ae039() {
    return $8T3gX.useContext((0, $680s3.default));
}

});

parcelRegister("a9NOs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7651627448648a56$export$2e2bcd8739ae039);

var $5IwAt = parcelRequire("5IwAt");
'use client';
var $7651627448648a56$export$2e2bcd8739ae039 = (0, $5IwAt.default);

});

parcelRegister("kzvFs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef9fa40bf4a721ca$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");
parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $ecQnZ = parcelRequire("ecQnZ");

var $ehyEf = parcelRequire("ehyEf");

var $kuBjs = parcelRequire("kuBjs");

var $k4ank = parcelRequire("k4ank");
'use client';
function $ef9fa40bf4a721ca$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $ecQnZ.default), (0, $eJfrs.default)({}, props, {
        defaultTheme: (0, $ehyEf.default),
        themeId: (0, $kuBjs.default)
    }));
}
$ef9fa40bf4a721ca$var$GlobalStyles.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The styles you want to apply globally.
   */ styles: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
    ])
};
var $ef9fa40bf4a721ca$export$2e2bcd8739ae039 = $ef9fa40bf4a721ca$var$GlobalStyles;

});

parcelRegister("g0gie", function(module, exports) {

$parcel$export(module.exports, "isFilled", () => $ba6948e659e8fbd0$export$d652b828d7fdeff8);
$parcel$export(module.exports, "isAdornedStart", () => $ba6948e659e8fbd0$export$1b68bdfa56faeb5d);
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $ba6948e659e8fbd0$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $ba6948e659e8fbd0$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($ba6948e659e8fbd0$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $ba6948e659e8fbd0$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $ba6948e659e8fbd0$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}

});

parcelRegister("5aFhN", function(module, exports) {

$parcel$export(module.exports, "getInputBaseUtilityClass", () => $3c3de977704da1e7$export$ef57d5c8ca2278f6);
$parcel$export(module.exports, "default", () => $3c3de977704da1e7$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $3c3de977704da1e7$export$ef57d5c8ca2278f6(slot) {
    return (0, $kfTYv.default)('MuiInputBase', slot);
}
const $3c3de977704da1e7$var$inputBaseClasses = (0, $jh2Zm.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $3c3de977704da1e7$export$2e2bcd8739ae039 = $3c3de977704da1e7$var$inputBaseClasses;

});


parcelRegister("cxknk", function(module, exports) {

$parcel$export(module.exports, "default", () => $92085f3188231753$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $aBrLz = parcelRequire("aBrLz");

var $anJSP = parcelRequire("anJSP");
var $3dQcH = parcelRequire("3dQcH");

var $7AQZl = parcelRequire("7AQZl");

var $dZfqJ = parcelRequire("dZfqJ");

var $hhKOZ = parcelRequire("hhKOZ");

var $a9NOs = parcelRequire("a9NOs");

var $11ydL = parcelRequire("11ydL");

var $d1ZPE = parcelRequire("d1ZPE");

var $j9hJf = parcelRequire("j9hJf");

var $d6MXx = parcelRequire("d6MXx");

var $kyXlL = parcelRequire("kyXlL");

var $k4ank = parcelRequire("k4ank");
'use client';
const $92085f3188231753$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $92085f3188231753$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $92085f3188231753$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $aYNpO.default)(slots, (0, $kyXlL.getMenuItemUtilityClass), classes);
    return (0, $eJfrs.default)({}, classes, composedClasses);
};
const $92085f3188231753$var$MenuItemRoot = (0, $anJSP.default)((0, $hhKOZ.default), {
    shouldForwardProp: (prop)=>(0, $3dQcH.default)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $92085f3188231753$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({}, theme.typography.body1, {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, {
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $kyXlL.default).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $aBrLz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $kyXlL.default).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $aBrLz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $kyXlL.default).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $aBrLz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $aBrLz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $kyXlL.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $kyXlL.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $d1ZPE.default).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $d1ZPE.default).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $d6MXx.default).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $d6MXx.default).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $j9hJf.default).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up('sm')]: {
            minHeight: 'auto'
        }
    }, ownerState.dense && (0, $eJfrs.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $j9hJf.default).root} svg`]: {
            fontSize: '1.25rem'
        }
    })));
const $92085f3188231753$var$MenuItem = /*#__PURE__*/ $8T3gX.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className } = props, other = (0, $fAJB5.default)(props, $92085f3188231753$var$_excluded);
    const context = $8T3gX.useContext((0, $dZfqJ.default));
    const childContext = $8T3gX.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $8T3gX.useRef(null);
    (0, $a9NOs.default)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
            else console.error('MUI: Unable to set focus to a MenuItem whose component has not been rendered.');
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $eJfrs.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $92085f3188231753$var$useUtilityClasses(props);
    const handleRef = (0, $11ydL.default)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $dZfqJ.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $k4ank.jsx)($92085f3188231753$var$MenuItemRoot, (0, $eJfrs.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $iVyaN.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $iVyaN.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
$92085f3188231753$var$MenuItem.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */ dense: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * @ignore
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the left and right padding is removed.
   * @default false
   */ disableGutters: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */ divider: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */ focusVisibleClassName: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * @ignore
   */ role: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).string,
    /**
   * If `true`, the component is selected.
   * @default false
   */ selected: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * @default 0
   */ tabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number
};
var $92085f3188231753$export$2e2bcd8739ae039 = $92085f3188231753$var$MenuItem;

});
parcelRegister("dZfqJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2ecf0f7c48b03e3$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");
'use client';
/**
 * @ignore - internal component.
 */ const $a2ecf0f7c48b03e3$var$ListContext = /*#__PURE__*/ $8T3gX.createContext({});
$a2ecf0f7c48b03e3$var$ListContext.displayName = 'ListContext';
var $a2ecf0f7c48b03e3$export$2e2bcd8739ae039 = $a2ecf0f7c48b03e3$var$ListContext;

});

parcelRegister("d1ZPE", function(module, exports) {

$parcel$export(module.exports, "getDividerUtilityClass", () => $97cb54e99a9b9484$export$46f01d01378ec5a2);
$parcel$export(module.exports, "default", () => $97cb54e99a9b9484$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $97cb54e99a9b9484$export$46f01d01378ec5a2(slot) {
    return (0, $kfTYv.default)('MuiDivider', slot);
}
const $97cb54e99a9b9484$var$dividerClasses = (0, $jh2Zm.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $97cb54e99a9b9484$export$2e2bcd8739ae039 = $97cb54e99a9b9484$var$dividerClasses;

});

parcelRegister("j9hJf", function(module, exports) {

$parcel$export(module.exports, "getListItemIconUtilityClass", () => $0398fa42cb0d7c79$export$81478e24460c57f2);
$parcel$export(module.exports, "default", () => $0398fa42cb0d7c79$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $0398fa42cb0d7c79$export$81478e24460c57f2(slot) {
    return (0, $kfTYv.default)('MuiListItemIcon', slot);
}
const $0398fa42cb0d7c79$var$listItemIconClasses = (0, $jh2Zm.default)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $0398fa42cb0d7c79$export$2e2bcd8739ae039 = $0398fa42cb0d7c79$var$listItemIconClasses;

});

parcelRegister("d6MXx", function(module, exports) {

$parcel$export(module.exports, "getListItemTextUtilityClass", () => $98b1d036d1bb287c$export$1061006a0db3aeb5);
$parcel$export(module.exports, "default", () => $98b1d036d1bb287c$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $98b1d036d1bb287c$export$1061006a0db3aeb5(slot) {
    return (0, $kfTYv.default)('MuiListItemText', slot);
}
const $98b1d036d1bb287c$var$listItemTextClasses = (0, $jh2Zm.default)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $98b1d036d1bb287c$export$2e2bcd8739ae039 = $98b1d036d1bb287c$var$listItemTextClasses;

});

parcelRegister("kyXlL", function(module, exports) {

$parcel$export(module.exports, "getMenuItemUtilityClass", () => $ef85054bfdcbb3fe$export$515f8c67b5305377);
$parcel$export(module.exports, "default", () => $ef85054bfdcbb3fe$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $ef85054bfdcbb3fe$export$515f8c67b5305377(slot) {
    return (0, $kfTYv.default)('MuiMenuItem', slot);
}
const $ef85054bfdcbb3fe$var$menuItemClasses = (0, $jh2Zm.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $ef85054bfdcbb3fe$export$2e2bcd8739ae039 = $ef85054bfdcbb3fe$var$menuItemClasses;

});


parcelRegister("2eEqG", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a0c4007cb063b73$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $b4f8D = parcelRequire("b4f8D");

var $jphfx = parcelRequire("jphfx");

var $88c49 = parcelRequire("88c49");

var $k1SKW = parcelRequire("k1SKW");

var $c8JM8 = parcelRequire("c8JM8");

var $e0WBI = parcelRequire("e0WBI");

var $fN7FV = parcelRequire("fN7FV");

var $9HxVr = parcelRequire("9HxVr");

var $4ZTSw = parcelRequire("4ZTSw");

var $kdEYK = parcelRequire("kdEYK");

var $7AQZl = parcelRequire("7AQZl");

var $11ydL = parcelRequire("11ydL");

var $anJSP = parcelRequire("anJSP");
var $3dQcH = parcelRequire("3dQcH");

var $k4ank = parcelRequire("k4ank");
'use client';
const $1a0c4007cb063b73$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $1a0c4007cb063b73$var$_excluded2 = [
    "root"
];
const $1a0c4007cb063b73$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $1a0c4007cb063b73$var$styledRootConfig = {
    name: 'MuiSelect',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $3dQcH.default)(prop) && prop !== 'variant',
    slot: 'Root'
};
const $1a0c4007cb063b73$var$StyledInput = (0, $anJSP.default)((0, $fN7FV.default), $1a0c4007cb063b73$var$styledRootConfig)('');
const $1a0c4007cb063b73$var$StyledOutlinedInput = (0, $anJSP.default)((0, $kdEYK.default), $1a0c4007cb063b73$var$styledRootConfig)('');
const $1a0c4007cb063b73$var$StyledFilledInput = (0, $anJSP.default)((0, $4ZTSw.default), $1a0c4007cb063b73$var$styledRootConfig)('');
const $1a0c4007cb063b73$var$Select = /*#__PURE__*/ $8T3gX.forwardRef(function Select(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $e0WBI.default), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined' } = props, other = (0, $fAJB5.default)(props, $1a0c4007cb063b73$var$_excluded);
    const inputComponent = native ? (0, $9HxVr.default) : (0, $88c49.default);
    const muiFormControl = (0, $c8JM8.default)();
    const fcs = (0, $k1SKW.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $eJfrs.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $1a0c4007cb063b73$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $fAJB5.default)(classes, $1a0c4007cb063b73$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $k4ank.jsx)($1a0c4007cb063b73$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $k4ank.jsx)($1a0c4007cb063b73$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $k4ank.jsx)($1a0c4007cb063b73$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $11ydL.default)(ref, (0, $jphfx.default)(InputComponent));
    return /*#__PURE__*/ (0, $k4ank.jsx)($8T3gX.Fragment, {
        children: /*#__PURE__*/ $8T3gX.cloneElement(InputComponent, (0, $eJfrs.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $eJfrs.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $eJfrs.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $b4f8D.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === 'outlined' ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $iVyaN.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$1a0c4007cb063b73$var$Select.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */ autoWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   * @default {}
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */ defaultOpen: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */ displayEmpty: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */ IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */ input: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * See [OutlinedInput#label](/material-ui/api/outlined-input/#props)
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */ labelId: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */ MenuProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */ native: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */ renderValue: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Props applied to the clickable div element.
   */ SelectDisplayProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            ''
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any
    ]),
    /**
   * The variant to use.
   * @default 'outlined'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'filled',
        'outlined',
        'standard'
    ])
};
$1a0c4007cb063b73$var$Select.muiName = 'Select';
var $1a0c4007cb063b73$export$2e2bcd8739ae039 = $1a0c4007cb063b73$var$Select;

});
parcelRegister("88c49", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eb86e1bdde30a54$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");


var $8T3gX = parcelRequire("8T3gX");

var $7Se60 = parcelRequire("7Se60");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $h47Cb = parcelRequire("h47Cb");

var $dSmkj = parcelRequire("dSmkj");

var $lAhWb = parcelRequire("lAhWb");

var $iMOmE = parcelRequire("iMOmE");

var $1fWBE = parcelRequire("1fWBE");

var $9HxVr = parcelRequire("9HxVr");

var $g0gie = parcelRequire("g0gie");

var $anJSP = parcelRequire("anJSP");
var $hxpHQ = parcelRequire("hxpHQ");

var $11ydL = parcelRequire("11ydL");

var $7Wcl5 = parcelRequire("7Wcl5");

var $1gyTG = parcelRequire("1gyTG");

var $k4ank = parcelRequire("k4ank");
'use client';
var $5eb86e1bdde30a54$var$_span;
const $5eb86e1bdde30a54$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $5eb86e1bdde30a54$var$SelectSelect = (0, $anJSP.default)('div', {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $1gyTG.default).select}`]: styles.select
            },
            {
                [`&.${(0, $1gyTG.default).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $1gyTG.default).error}`]: styles.error
            },
            {
                [`&.${(0, $1gyTG.default).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $9HxVr.nativeSelectSelectStyles), {
    // Win specificity over the input base
    [`&.${(0, $1gyTG.default).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $5eb86e1bdde30a54$var$SelectIcon = (0, $anJSP.default)('svg', {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $iMOmE.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $9HxVr.nativeSelectIconStyles));
const $5eb86e1bdde30a54$var$SelectNativeInput = (0, $anJSP.default)('input', {
    shouldForwardProp: (prop)=>(0, $hxpHQ.default)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput',
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $5eb86e1bdde30a54$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $5eb86e1bdde30a54$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $5eb86e1bdde30a54$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $iMOmE.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $1gyTG.getSelectUtilityClasses), classes);
};
/**
 * @ignore - internal component.
 */ const $5eb86e1bdde30a54$var$SelectInput = /*#__PURE__*/ $8T3gX.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = 'standard' } = props, other = (0, $fAJB5.default)(props, $5eb86e1bdde30a54$var$_excluded);
    const [value, setValueState] = (0, $7Wcl5.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $7Wcl5.default)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $8T3gX.useRef(null);
    const displayRef = $8T3gX.useRef(null);
    const [displayNode, setDisplayNode] = $8T3gX.useState(null);
    const { current: isOpenControlled } = $8T3gX.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $8T3gX.useState();
    const handleRef = (0, $11ydL.default)(ref, inputRefProp);
    const handleDisplayRef = $8T3gX.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $8T3gX.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $8T3gX.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $8T3gX.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $8T3gX.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $lAhWb.default)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $8T3gX.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $g0gie.isFilled)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $8T3gX.isValidElement(child)) return null;
        if ((0, $7Se60.isFragment)(child)) console.error([
            "MUI: The Select component doesn't accept a Fragment as a child.",
            'Consider providing an array instead.'
        ].join('\n'));
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error(`MUI: The \`value\` prop must be an array when using the \`Select\` component with \`multiple\`.`);
            selected = value.some((v)=>$5eb86e1bdde30a54$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $5eb86e1bdde30a54$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $8T3gX.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8T3gX.useEffect(()=>{
        if (!foundMatch && !multiple && value !== '') {
            const values = childrenArray.map((child)=>child.props.value);
            console.warn([
                `MUI: You have provided an out-of-range value \`${value}\` for the select ${name ? `(name="${name}") ` : ''}component.`,
                "Consider providing a value that matches one of the available options or ''.",
                `The available values are ${values.filter((x)=>x != null).map((x)=>`\`${x}\``).join(', ') || '""'}.`
            ].join('\n'));
        }
    }, [
        foundMatch,
        childrenArray,
        multiple,
        name,
        value
    ]);
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $eJfrs.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $5eb86e1bdde30a54$var$useUtilityClasses(ownerState);
    const paperProps = (0, $eJfrs.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $h47Cb.default)();
    return /*#__PURE__*/ (0, $k4ank.jsxs)($8T3gX.Fragment, {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)($5eb86e1bdde30a54$var$SelectSelect, (0, $eJfrs.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $iVyaN.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $5eb86e1bdde30a54$var$isEmpty(display) ? $5eb86e1bdde30a54$var$_span || ($5eb86e1bdde30a54$var$_span = /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $k4ank.jsx)($5eb86e1bdde30a54$var$SelectNativeInput, (0, $eJfrs.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $k4ank.jsx)($5eb86e1bdde30a54$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1fWBE.default), (0, $eJfrs.default)({
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            }, MenuProps, {
                MenuListProps: (0, $eJfrs.default)({
                    'aria-labelledby': labelId,
                    role: 'listbox',
                    'aria-multiselectable': multiple ? 'true' : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $eJfrs.default)({}, MenuProps.slotProps, {
                    paper: (0, $eJfrs.default)({}, paperProps, {
                        style: (0, $eJfrs.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
$5eb86e1bdde30a54$var$SelectInput.propTypes = {
    /**
   * @ignore
   */ 'aria-describedby': (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * @ignore
   */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * @ignore
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */ autoWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The CSS class name of the select element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */ defaultOpen: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * If `true`, the select is disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the selected item is displayed even if its value is empty.
   */ displayEmpty: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the `select input` will indicate an error.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The icon that displays the arrow.
   */ IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType.isRequired,
    /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */ inputRef: (0, $dSmkj.default),
    /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */ labelId: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */ MenuProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Name attribute of the `select` or hidden `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * @ignore
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * @ignore
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */ renderValue: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Props applied to the clickable div element.
   */ SelectDisplayProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ tabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * @ignore
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * The input value.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * The variant to use.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'standard',
        'outlined',
        'filled'
    ])
};
var $5eb86e1bdde30a54$export$2e2bcd8739ae039 = $5eb86e1bdde30a54$var$SelectInput;

});
parcelRegister("lAhWb", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb6adfc28a8f9b8e$export$2e2bcd8739ae039);

var $iYkpH = parcelRequire("iYkpH");
var $fb6adfc28a8f9b8e$export$2e2bcd8739ae039 = (0, $iYkpH.default);

});

parcelRegister("1fWBE", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ea4a72611565e5a$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $7Se60 = parcelRequire("7Se60");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $535LO = parcelRequire("535LO");

var $yILjC = parcelRequire("yILjC");

var $6zZUJ = parcelRequire("6zZUJ");

var $eJK3E = parcelRequire("eJK3E");

var $jftqf = parcelRequire("jftqf");

var $anJSP = parcelRequire("anJSP");
var $3dQcH = parcelRequire("3dQcH");

var $7AQZl = parcelRequire("7AQZl");

var $6Vaxm = parcelRequire("6Vaxm");

var $k4ank = parcelRequire("k4ank");
'use client';
const $0ea4a72611565e5a$var$_excluded = [
    "onEntering"
], $0ea4a72611565e5a$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $0ea4a72611565e5a$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $0ea4a72611565e5a$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $0ea4a72611565e5a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $6Vaxm.getMenuUtilityClass), classes);
};
const $0ea4a72611565e5a$var$MenuRoot = (0, $anJSP.default)((0, $jftqf.default), {
    shouldForwardProp: (prop)=>(0, $3dQcH.default)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $0ea4a72611565e5a$export$4f7c51a5920c9f33 = (0, $anJSP.default)((0, $jftqf.PopoverPaper), {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $0ea4a72611565e5a$var$MenuMenuList = (0, $anJSP.default)((0, $eJK3E.default), {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $0ea4a72611565e5a$var$Menu = /*#__PURE__*/ $8T3gX.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $fAJB5.default)(props.TransitionProps, $0ea4a72611565e5a$var$_excluded), other = (0, $fAJB5.default)(props, $0ea4a72611565e5a$var$_excluded2);
    const isRtl = (0, $yILjC.useRtl)();
    const ownerState = (0, $eJfrs.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $0ea4a72611565e5a$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $8T3gX.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $8T3gX.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $8T3gX.isValidElement(child)) return;
        if ((0, $7Se60.isFragment)(child)) console.error([
            "MUI: The Menu component doesn't accept a Fragment as a child.",
            'Consider providing an array instead.'
        ].join('\n'));
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $0ea4a72611565e5a$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $6zZUJ.default)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $6zZUJ.default)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)($0ea4a72611565e5a$var$MenuRoot, (0, $eJfrs.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $0ea4a72611565e5a$var$RTL_ORIGIN : $0ea4a72611565e5a$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $eJfrs.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $k4ank.jsx)($0ea4a72611565e5a$var$MenuMenuList, (0, $eJfrs.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $iVyaN.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
$0ea4a72611565e5a$var$Menu.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */ anchorEl: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, $535LO.default),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Menu contents, normally `MenuItem`s.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */ disableAutoFocusItem: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Props applied to the [`MenuList`](/material-ui/api/menu-list/) element.
   * @default {}
   */ MenuListProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool.isRequired,
    /**
   * @ignore
   */ PaperProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * `classes` prop applied to the [`Popover`](/material-ui/api/popover/) element.
   */ PopoverClasses: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        paper: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        ]),
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        ])
    }),
    /**
   * The components used for each slot inside.
   *
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        paper: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */ transitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'auto'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number
        })
    ]),
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */ TransitionProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'menu',
        'selectedMenu'
    ])
};
var $0ea4a72611565e5a$export$2e2bcd8739ae039 = $0ea4a72611565e5a$var$Menu;

});
parcelRegister("eJK3E", function(module, exports) {

$parcel$export(module.exports, "default", () => $aba8fecb1261dabe$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $7Se60 = parcelRequire("7Se60");

var $fdGrT = parcelRequire("fdGrT");

var $lAhWb = parcelRequire("lAhWb");

var $kCUgG = parcelRequire("kCUgG");

var $jrutS = parcelRequire("jrutS");

var $11ydL = parcelRequire("11ydL");

var $a9NOs = parcelRequire("a9NOs");

var $k4ank = parcelRequire("k4ank");
'use client';
const $aba8fecb1261dabe$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $aba8fecb1261dabe$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $aba8fecb1261dabe$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $aba8fecb1261dabe$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join('')) === 0;
}
function $aba8fecb1261dabe$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$aba8fecb1261dabe$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $aba8fecb1261dabe$var$MenuList = /*#__PURE__*/ $8T3gX.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu' } = props, other = (0, $fAJB5.default)(props, $aba8fecb1261dabe$var$_excluded);
    const listRef = $8T3gX.useRef(null);
    const textCriteriaRef = $8T3gX.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $a9NOs.default)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $8T3gX.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $jrutS.default)((0, $lAhWb.default)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $lAhWb.default)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $aba8fecb1261dabe$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $aba8fecb1261dabe$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $aba8fecb1261dabe$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $aba8fecb1261dabe$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $aba8fecb1261dabe$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $aba8fecb1261dabe$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $aba8fecb1261dabe$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $aba8fecb1261dabe$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $aba8fecb1261dabe$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $aba8fecb1261dabe$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $aba8fecb1261dabe$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $11ydL.default)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $8T3gX.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $8T3gX.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if ((0, $7Se60.isFragment)(child)) console.error([
            "MUI: The Menu component doesn't accept a Fragment as a child.",
            'Consider providing an array instead.'
        ].join('\n'));
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $8T3gX.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $8T3gX.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $kCUgG.default), (0, $eJfrs.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
$aba8fecb1261dabe$var$MenuList.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */ autoFocusItem: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * MenuList contents, normally `MenuItem`s.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */ disabledItemsFocusable: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */ disableListWrap: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * @ignore
   */ onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'menu',
        'selectedMenu'
    ])
};
var $aba8fecb1261dabe$export$2e2bcd8739ae039 = $aba8fecb1261dabe$var$MenuList;

});
parcelRegister("kCUgG", function(module, exports) {

$parcel$export(module.exports, "default", () => $f04300ed6cb1c010$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $dZfqJ = parcelRequire("dZfqJ");

var $7wAKL = parcelRequire("7wAKL");

var $k4ank = parcelRequire("k4ank");
'use client';
const $f04300ed6cb1c010$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $f04300ed6cb1c010$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $7wAKL.getListUtilityClass), classes);
};
const $f04300ed6cb1c010$var$ListRoot = (0, $anJSP.default)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({
        listStyle: 'none',
        margin: 0,
        padding: 0,
        position: 'relative'
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $f04300ed6cb1c010$var$List = /*#__PURE__*/ $8T3gX.forwardRef(function List(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $fAJB5.default)(props, $f04300ed6cb1c010$var$_excluded);
    const context = $8T3gX.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $eJfrs.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $f04300ed6cb1c010$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $dZfqJ.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $k4ank.jsxs)($f04300ed6cb1c010$var$ListRoot, (0, $eJfrs.default)({
            as: component,
            className: (0, $iVyaN.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
$f04300ed6cb1c010$var$List.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */ dense: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */ disablePadding: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The content of the subheader, normally `ListSubheader`.
   */ subheader: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $f04300ed6cb1c010$export$2e2bcd8739ae039 = $f04300ed6cb1c010$var$List;

});
parcelRegister("7wAKL", function(module, exports) {

$parcel$export(module.exports, "getListUtilityClass", () => $57a807fbd6aa74e5$export$c6bd6795ed6e3203);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $57a807fbd6aa74e5$export$c6bd6795ed6e3203(slot) {
    return (0, $kfTYv.default)('MuiList', slot);
}
const $57a807fbd6aa74e5$var$listClasses = (0, $jh2Zm.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $57a807fbd6aa74e5$export$2e2bcd8739ae039 = $57a807fbd6aa74e5$var$listClasses;

});


parcelRegister("jrutS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2782ed0044aaa18$export$2e2bcd8739ae039);

var $lVRl2 = parcelRequire("lVRl2");
var $e2782ed0044aaa18$export$2e2bcd8739ae039 = (0, $lVRl2.default);

});
parcelRegister("lVRl2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff784bbde10c4a1d$export$2e2bcd8739ae039);
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $ff784bbde10c4a1d$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}

});



parcelRegister("jftqf", function(module, exports) {

$parcel$export(module.exports, "PopoverPaper", () => $e0363db6e505727e$export$821346c38a2d9390);
$parcel$export(module.exports, "default", () => $e0363db6e505727e$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $535LO = parcelRequire("535LO");

var $dSmkj = parcelRequire("dSmkj");

var $26cdd = parcelRequire("26cdd");

var $97LlG = parcelRequire("97LlG");

var $bPpmJ = parcelRequire("bPpmJ");

var $6zZUJ = parcelRequire("6zZUJ");

var $lkMit = parcelRequire("lkMit");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $7dYD9 = parcelRequire("7dYD9");

var $lAhWb = parcelRequire("lAhWb");

var $6aDoo = parcelRequire("6aDoo");

var $11ydL = parcelRequire("11ydL");

var $6CjWJ = parcelRequire("6CjWJ");

var $kE1sg = parcelRequire("kE1sg");

var $4reBM = parcelRequire("4reBM");

var $eI090 = parcelRequire("eI090");

var $k4ank = parcelRequire("k4ank");
'use client';
const $e0363db6e505727e$var$_excluded = [
    "onEntering"
], $e0363db6e505727e$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $e0363db6e505727e$var$_excluded3 = [
    "slotProps"
];
function $e0363db6e505727e$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $e0363db6e505727e$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $e0363db6e505727e$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $e0363db6e505727e$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $e0363db6e505727e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $eI090.getPopoverUtilityClass), classes);
};
const $e0363db6e505727e$export$bcce13685275fc99 = (0, $anJSP.default)((0, $kE1sg.default), {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $e0363db6e505727e$export$821346c38a2d9390 = (0, $anJSP.default)((0, $4reBM.default), {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $e0363db6e505727e$var$Popover = /*#__PURE__*/ $8T3gX.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent = (0, $6CjWJ.default), transitionDuration: transitionDurationProp = 'auto', TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $fAJB5.default)(props.TransitionProps, $e0363db6e505727e$var$_excluded), other = (0, $fAJB5.default)(props, $e0363db6e505727e$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $8T3gX.useRef();
    const handlePaperRef = (0, $11ydL.default)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $eJfrs.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $e0363db6e505727e$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $8T3gX.useCallback(()=>{
        if (anchorReference === 'anchorPosition') {
            if (!anchorPosition) console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.');
            return anchorPosition;
        }
        const resolvedAnchorEl = $e0363db6e505727e$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $lAhWb.default)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        {
            const box = anchorElement.getBoundingClientRect();
            if (box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) console.warn([
                'MUI: The `anchorEl` prop provided to the component is invalid.',
                'The anchor element should be part of the document layout.',
                "Make sure the element is present in the document or that it's not display none."
            ].join('\n'));
        }
        return {
            top: anchorRect.top + $e0363db6e505727e$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $e0363db6e505727e$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $8T3gX.useCallback((elemRect)=>{
        return {
            vertical: $e0363db6e505727e$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $e0363db6e505727e$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $8T3gX.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $e0363db6e505727e$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $6aDoo.default)($e0363db6e505727e$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        if (elemRect.height > heightThreshold && elemRect.height && heightThreshold) console.error([
            'MUI: The popover component is too tall.',
            `Some part of it can not be seen on the screen (${elemRect.height - heightThreshold}px).`,
            'Please consider adding a `max-height` to improve the user-experience.'
        ].join('\n'));
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $e0363db6e505727e$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $8T3gX.useState(open);
    const setPositioningStyles = $8T3gX.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $8T3gX.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $8T3gX.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $8T3gX.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $8T3gX.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $7dYD9.default)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $6aDoo.default)(anchorEl);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $lAhWb.default)($e0363db6e505727e$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $e0363db6e505727e$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $e0363db6e505727e$export$821346c38a2d9390;
    const paperProps = (0, $6zZUJ.default)({
        elementType: PaperSlot,
        externalSlotProps: (0, $eJfrs.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $eJfrs.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $iVyaN.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $6zZUJ.default)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $iVyaN.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $fAJB5.default)(_useSlotProps, $e0363db6e505727e$var$_excluded3);
    return /*#__PURE__*/ (0, $k4ank.jsx)(RootSlot, (0, $eJfrs.default)({}, rootProps, !(0, $lkMit.default)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $k4ank.jsx)(TransitionComponent, (0, $eJfrs.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $k4ank.jsx)(PaperSlot, (0, $eJfrs.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
$e0363db6e505727e$var$Popover.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */ action: (0, $dSmkj.default),
    /**
   * An HTML element, [PopoverVirtualElement](/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */ anchorEl: (0, $bPpmJ.default)((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, $535LO.default),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]), (props)=>{
        if (props.open && (!props.anchorReference || props.anchorReference === 'anchorEl')) {
            const resolvedAnchorEl = $e0363db6e505727e$var$resolveAnchorEl(props.anchorEl);
            if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
                const box = resolvedAnchorEl.getBoundingClientRect();
                if (box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) return new Error([
                    'MUI: The `anchorEl` prop provided to the component is invalid.',
                    'The anchor element should be part of the document layout.',
                    "Make sure the element is present in the document or that it's not display none."
                ].join('\n'));
            } else return new Error([
                'MUI: The `anchorEl` prop provided to the component is invalid.',
                `It should be an Element or PopoverVirtualElement instance but it's \`${resolvedAnchorEl}\` instead.`
            ].join('\n'));
        }
        return null;
    }),
    /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */ anchorOrigin: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
                'center',
                'left',
                'right'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number
        ]).isRequired,
        vertical: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
                'bottom',
                'center',
                'top'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number
        ]).isRequired
    }),
    /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */ anchorPosition: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        left: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number.isRequired,
        top: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number.isRequired
    }),
    /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */ anchorReference: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'anchorEl',
        'anchorPosition',
        'none'
    ]),
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, $535LO.default),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    /**
   * Disable the scroll lock behavior.
   * @default false
   */ disableScrollLock: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The elevation of the popover.
   * @default 8
   */ elevation: (0, $97LlG.default),
    /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */ marginThreshold: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool.isRequired,
    /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */ PaperProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).shape({
        component: (0, $26cdd.default)
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        paper: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        ]),
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        ])
    }),
    /**
   * The components used for each slot inside.
   *
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        paper: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */ transformOrigin: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
                'center',
                'left',
                'right'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number
        ]).isRequired,
        vertical: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
                'bottom',
                'center',
                'top'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number
        ]).isRequired
    }),
    /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */ TransitionComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */ transitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'auto'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number
        })
    ]),
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */ TransitionProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
};
var $e0363db6e505727e$export$2e2bcd8739ae039 = $e0363db6e505727e$var$Popover;

});
parcelRegister("7dYD9", function(module, exports) {

$parcel$export(module.exports, "default", () => $5428c73e8c1f1415$export$2e2bcd8739ae039);

var $844bI = parcelRequire("844bI");
var $5428c73e8c1f1415$export$2e2bcd8739ae039 = (0, $844bI.default);

});

parcelRegister("6aDoo", function(module, exports) {

$parcel$export(module.exports, "default", () => $47e23bc7821dc404$export$2e2bcd8739ae039);

var $6LMzY = parcelRequire("6LMzY");
var $47e23bc7821dc404$export$2e2bcd8739ae039 = (0, $6LMzY.default);

});

parcelRegister("kE1sg", function(module, exports) {

$parcel$export(module.exports, "default", () => $f078abf7e4d7428b$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $535LO = parcelRequire("535LO");

var $evygD = parcelRequire("evygD");

var $aYNpO = parcelRequire("aYNpO");

var $6zZUJ = parcelRequire("6zZUJ");

var $72B8o = parcelRequire("72B8o");

var $gVgDF = parcelRequire("gVgDF");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $djxj8 = parcelRequire("djxj8");

var $5gG0G = parcelRequire("5gG0G");

var $92EL2 = parcelRequire("92EL2");

var $k4ank = parcelRequire("k4ank");
'use client';
const $f078abf7e4d7428b$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $f078abf7e4d7428b$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $92EL2.getModalUtilityClass), classes);
};
const $f078abf7e4d7428b$var$ModalRoot = (0, $anJSP.default)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: 'hidden'
    }));
const $f078abf7e4d7428b$var$ModalBackdrop = (0, $anJSP.default)((0, $djxj8.default), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $f078abf7e4d7428b$var$Modal = /*#__PURE__*/ $8T3gX.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $7AQZl.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $f078abf7e4d7428b$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $fAJB5.default)(props, $f078abf7e4d7428b$var$_excluded);
    const propsWithDefaults = (0, $eJfrs.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $5gG0G.default)((0, $eJfrs.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $eJfrs.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $f078abf7e4d7428b$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $f078abf7e4d7428b$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $6zZUJ.default)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $iVyaN.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $6zZUJ.default)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $eJfrs.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $iVyaN.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $gVgDF.default), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $k4ank.jsxs)(RootSlot, (0, $eJfrs.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $k4ank.jsx)(BackdropSlot, (0, $eJfrs.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $72B8o.default), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $8T3gX.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
$f078abf7e4d7428b$var$Modal.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */ BackdropComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */ BackdropProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * A single child content element.
   */ children: (0, $evygD.default).isRequired,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */ closeAfterTransition: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        Backdrop: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        Root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        backdrop: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        ]),
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        ])
    }),
    /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, $535LO.default),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */ disableAutoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */ disableEnforceFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */ disableEscapeKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */ disablePortal: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */ disableRestoreFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Disable the scroll lock behavior.
   * @default false
   */ disableScrollLock: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */ hideBackdrop: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */ keepMounted: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */ onBackdropClick: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * A function called when a transition enters.
   */ onTransitionEnter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * A function called when a transition has exited.
   */ onTransitionExited: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool.isRequired,
    /**
   * The props used for each slot inside the Modal.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        backdrop: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        ]),
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        ])
    }),
    /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        backdrop: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $f078abf7e4d7428b$export$2e2bcd8739ae039 = $f078abf7e4d7428b$var$Modal;

});
parcelRegister("72B8o", function(module, exports) {

$parcel$export(module.exports, "default", () => $5205866602f01d96$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $evygD = parcelRequire("evygD");
var $bNVvr = parcelRequire("bNVvr");
var $jphfx = parcelRequire("jphfx");
var $iYkpH = parcelRequire("iYkpH");
var $ktSDD = parcelRequire("ktSDD");

var $k4ank = parcelRequire("k4ank");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $5205866602f01d96$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $5205866602f01d96$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $5205866602f01d96$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $5205866602f01d96$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $5205866602f01d96$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $5205866602f01d96$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($5205866602f01d96$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $5205866602f01d96$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$5205866602f01d96$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $5205866602f01d96$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $5205866602f01d96$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $5205866602f01d96$var$defaultGetTabbable, isEnabled: isEnabled = $5205866602f01d96$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $8T3gX.useRef(false);
    const sentinelStart = $8T3gX.useRef(null);
    const sentinelEnd = $8T3gX.useRef(null);
    const nodeToRestore = $8T3gX.useRef(null);
    const reactFocusEventTarget = $8T3gX.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $8T3gX.useRef(false);
    const rootRef = $8T3gX.useRef(null);
    const handleRef = (0, $ktSDD.default)((0, $jphfx.default)(children), rootRef);
    const lastKeydown = $8T3gX.useRef(null);
    $8T3gX.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $8T3gX.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $iYkpH.default)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) {
                console.error([
                    'MUI: The modal content node does not accept focus.',
                    'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'
                ].join('\n'));
                rootRef.current.setAttribute('tabIndex', '-1');
            }
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $8T3gX.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $iYkpH.default)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)($8T3gX.Fragment, {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $8T3gX.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
$5205866602f01d96$var$FocusTrap.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * A single child content element.
   */ children: (0, $evygD.default),
    /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */ disableAutoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */ disableEnforceFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */ disableRestoreFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */ getTabbable: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */ isEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, focus is locked.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool.isRequired
};
// eslint-disable-next-line
$5205866602f01d96$var$FocusTrap["propTypes"] = (0, $bNVvr.default)($5205866602f01d96$var$FocusTrap.propTypes);
var $5205866602f01d96$export$2e2bcd8739ae039 = $5205866602f01d96$var$FocusTrap;

});

parcelRegister("djxj8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b16e2f00c4ed955$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $lHoGT = parcelRequire("lHoGT");

var $SFtPF = parcelRequire("SFtPF");

var $k4ank = parcelRequire("k4ank");
'use client';
const $9b16e2f00c4ed955$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $9b16e2f00c4ed955$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $SFtPF.getBackdropUtilityClass), classes);
};
const $9b16e2f00c4ed955$var$BackdropRoot = (0, $anJSP.default)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    }, ownerState.invisible && {
        backgroundColor: 'transparent'
    }));
const $9b16e2f00c4ed955$var$Backdrop = /*#__PURE__*/ $8T3gX.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $lHoGT.default), transitionDuration: transitionDuration } = props, other = (0, $fAJB5.default)(props, $9b16e2f00c4ed955$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $9b16e2f00c4ed955$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $k4ank.jsx)(TransitionComponent, (0, $eJfrs.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $k4ank.jsx)($9b16e2f00c4ed955$var$BackdropRoot, (0, $eJfrs.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $iVyaN.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $eJfrs.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
$9b16e2f00c4ed955$var$Backdrop.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        Root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    }),
    /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */ invisible: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool.isRequired,
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    }),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */ TransitionComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */ transitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number
        })
    ])
};
var $9b16e2f00c4ed955$export$2e2bcd8739ae039 = $9b16e2f00c4ed955$var$Backdrop;

});
parcelRegister("lHoGT", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcc0c4391de721bb$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $8zaeI = parcelRequire("8zaeI");

var $evygD = parcelRequire("evygD");

var $jphfx = parcelRequire("jphfx");

var $4nWZ9 = parcelRequire("4nWZ9");

var $9Pc8j = parcelRequire("9Pc8j");

var $11ydL = parcelRequire("11ydL");

var $k4ank = parcelRequire("k4ank");
'use client';
const $fcc0c4391de721bb$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $fcc0c4391de721bb$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $fcc0c4391de721bb$var$Fade = /*#__PURE__*/ $8T3gX.forwardRef(function Fade(props, ref) {
    const theme = (0, $4nWZ9.default)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $8zaeI.default) } = props, other = (0, $fAJB5.default)(props, $fcc0c4391de721bb$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $8T3gX.useRef(null);
    const handleRef = (0, $11ydL.default)(nodeRef, (0, $jphfx.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $9Pc8j.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, $9Pc8j.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $9Pc8j.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)(TransitionComponent, (0, $eJfrs.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $8T3gX.cloneElement(children, (0, $eJfrs.default)({
                style: (0, $eJfrs.default)({
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $fcc0c4391de721bb$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$fcc0c4391de721bb$var$Fade.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */ addEndListener: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */ appear: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * A single child content element.
   */ children: (0, $evygD.default).isRequired,
    /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */ easing: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * If `true`, the component will transition in.
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * @ignore
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */ timeout: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number
        })
    ])
};
var $fcc0c4391de721bb$export$2e2bcd8739ae039 = $fcc0c4391de721bb$var$Fade;

});

parcelRegister("SFtPF", function(module, exports) {

$parcel$export(module.exports, "getBackdropUtilityClass", () => $0a45385b77ce4b47$export$9927a91fd93152bd);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $0a45385b77ce4b47$export$9927a91fd93152bd(slot) {
    return (0, $kfTYv.default)('MuiBackdrop', slot);
}
const $0a45385b77ce4b47$var$backdropClasses = (0, $jh2Zm.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $0a45385b77ce4b47$export$2e2bcd8739ae039 = $0a45385b77ce4b47$var$backdropClasses;

});


parcelRegister("5gG0G", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d5f08ab57b1b040$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $lEMz9 = parcelRequire("lEMz9");
var $iYkpH = parcelRequire("iYkpH");
var $fPAwT = parcelRequire("fPAwT");
var $ktSDD = parcelRequire("ktSDD");

var $kV4HD = parcelRequire("kV4HD");

var $eiFqo = parcelRequire("eiFqo");
'use client';
function $3d5f08ab57b1b040$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $3d5f08ab57b1b040$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $3d5f08ab57b1b040$var$defaultManager = new (0, $eiFqo.ModalManager)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $3d5f08ab57b1b040$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $3d5f08ab57b1b040$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $8T3gX.useRef({});
    const mountNodeRef = $8T3gX.useRef(null);
    const modalRef = $8T3gX.useRef(null);
    const handleRef = (0, $ktSDD.default)(modalRef, rootRef);
    const [exited, setExited] = $8T3gX.useState(!open);
    const hasTransition = $3d5f08ab57b1b040$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $iYkpH.default)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $fPAwT.default)(()=>{
        const resolvedContainer = $3d5f08ab57b1b040$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $8T3gX.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $fPAwT.default)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $eiFqo.ariaHidden)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $8T3gX.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $8T3gX.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $8T3gX.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $kV4HD.default)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $eJfrs.default)({}, propsEventHandlers, otherHandlers);
        return (0, $eJfrs.default)({
            role: 'presentation'
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $eJfrs.default)({
            'aria-hidden': true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $lEMz9.default)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $lEMz9.default)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $3d5f08ab57b1b040$export$2e2bcd8739ae039 = $3d5f08ab57b1b040$var$useModal;

});
parcelRegister("lEMz9", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc43019b5c90472a$export$2e2bcd8739ae039);
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $fc43019b5c90472a$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

});

parcelRegister("eiFqo", function(module, exports) {

$parcel$export(module.exports, "ariaHidden", () => $a692e13085811a4a$export$e1bd0c6150f13d96);
$parcel$export(module.exports, "ModalManager", () => $a692e13085811a4a$export$ce11c4ecd08cea67);

var $lVRl2 = parcelRequire("lVRl2");
var $iYkpH = parcelRequire("iYkpH");
var $6LMzY = parcelRequire("6LMzY");
// Is a vertical scrollbar displayed?
function $a692e13085811a4a$var$isOverflowing(container) {
    const doc = (0, $iYkpH.default)(container);
    if (doc.body === container) return (0, $6LMzY.default)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $a692e13085811a4a$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $a692e13085811a4a$var$getPaddingRight(element) {
    return parseInt((0, $6LMzY.default)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $a692e13085811a4a$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $a692e13085811a4a$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$a692e13085811a4a$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $a692e13085811a4a$export$e1bd0c6150f13d96(element, show);
    });
}
function $a692e13085811a4a$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $a692e13085811a4a$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($a692e13085811a4a$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $lVRl2.default)((0, $iYkpH.default)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$a692e13085811a4a$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $iYkpH.default)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$a692e13085811a4a$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $iYkpH.default)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $6LMzY.default)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $a692e13085811a4a$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $a692e13085811a4a$export$ce11c4ecd08cea67 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $a692e13085811a4a$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $a692e13085811a4a$var$getHiddenSiblings(container);
        $a692e13085811a4a$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $a692e13085811a4a$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $a692e13085811a4a$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $a692e13085811a4a$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $a692e13085811a4a$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $a692e13085811a4a$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $a692e13085811a4a$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $a692e13085811a4a$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}

});


parcelRegister("92EL2", function(module, exports) {

$parcel$export(module.exports, "getModalUtilityClass", () => $6953ea997913c9c7$export$67960e22b12a638d);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $6953ea997913c9c7$export$67960e22b12a638d(slot) {
    return (0, $kfTYv.default)('MuiModal', slot);
}
const $6953ea997913c9c7$var$modalClasses = (0, $jh2Zm.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $6953ea997913c9c7$export$2e2bcd8739ae039 = $6953ea997913c9c7$var$modalClasses;

});


parcelRegister("eI090", function(module, exports) {

$parcel$export(module.exports, "getPopoverUtilityClass", () => $ab55496697a1b6aa$export$88f455dd56c95edb);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $ab55496697a1b6aa$export$88f455dd56c95edb(slot) {
    return (0, $kfTYv.default)('MuiPopover', slot);
}
const $ab55496697a1b6aa$var$popoverClasses = (0, $jh2Zm.default)('MuiPopover', [
    'root',
    'paper'
]);
var $ab55496697a1b6aa$export$2e2bcd8739ae039 = $ab55496697a1b6aa$var$popoverClasses;

});


parcelRegister("6Vaxm", function(module, exports) {

$parcel$export(module.exports, "getMenuUtilityClass", () => $50a03d69b832d0ec$export$2cf86a63a84fe23d);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $50a03d69b832d0ec$export$2cf86a63a84fe23d(slot) {
    return (0, $kfTYv.default)('MuiMenu', slot);
}
const $50a03d69b832d0ec$var$menuClasses = (0, $jh2Zm.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $50a03d69b832d0ec$export$2e2bcd8739ae039 = $50a03d69b832d0ec$var$menuClasses;

});


parcelRegister("9HxVr", function(module, exports) {

$parcel$export(module.exports, "nativeSelectSelectStyles", () => $7102721b9d6067be$export$c1eccd1617458c87);
$parcel$export(module.exports, "nativeSelectIconStyles", () => $7102721b9d6067be$export$e7a817afd12a40d0);
$parcel$export(module.exports, "default", () => $7102721b9d6067be$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $dSmkj = parcelRequire("dSmkj");

var $aYNpO = parcelRequire("aYNpO");

var $iMOmE = parcelRequire("iMOmE");

var $77Pk1 = parcelRequire("77Pk1");

var $anJSP = parcelRequire("anJSP");
var $3dQcH = parcelRequire("3dQcH");

var $k4ank = parcelRequire("k4ank");
'use client';
const $7102721b9d6067be$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $7102721b9d6067be$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $iMOmE.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $77Pk1.getNativeSelectUtilityClasses), classes);
};
const $7102721b9d6067be$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $eJfrs.default)({
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        borderRadius: 0,
        // Reset
        cursor: 'pointer',
        '&:focus': (0, $eJfrs.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)'
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        '&::-ms-expand': {
            display: 'none'
        },
        [`&.${(0, $77Pk1.default).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        '&&&': {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === 'filled' && {
        '&&&': {
            paddingRight: 32
        }
    }, ownerState.variant === 'outlined' && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        '&:focus': {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        '&&&': {
            paddingRight: 32
        }
    });
const $7102721b9d6067be$var$NativeSelectSelect = (0, $anJSP.default)('select', {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $3dQcH.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $77Pk1.default).multiple}`]: styles.multiple
            }
        ];
    }
})($7102721b9d6067be$export$c1eccd1617458c87);
const $7102721b9d6067be$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $eJfrs.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        top: 'calc(50% - .5em)',
        // Center vertically, height is 1em
        pointerEvents: 'none',
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $77Pk1.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: 'rotate(180deg)'
    }, ownerState.variant === 'filled' && {
        right: 7
    }, ownerState.variant === 'outlined' && {
        right: 7
    });
const $7102721b9d6067be$var$NativeSelectIcon = (0, $anJSP.default)('svg', {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $iMOmE.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($7102721b9d6067be$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $7102721b9d6067be$var$NativeSelectInput = /*#__PURE__*/ $8T3gX.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard' } = props, other = (0, $fAJB5.default)(props, $7102721b9d6067be$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $7102721b9d6067be$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsxs)($8T3gX.Fragment, {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)($7102721b9d6067be$var$NativeSelectSelect, (0, $eJfrs.default)({
                ownerState: ownerState,
                className: (0, $iVyaN.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $k4ank.jsx)($7102721b9d6067be$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
$7102721b9d6067be$var$NativeSelectInput.propTypes = {
    /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The CSS class name of the select element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true`, the select is disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the `select input` will indicate an error.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The icon that displays the arrow.
   */ IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType.isRequired,
    /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */ inputRef: (0, $dSmkj.default),
    /**
   * @ignore
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Name attribute of the `select` or hidden `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * The input value.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * The variant to use.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'standard',
        'outlined',
        'filled'
    ])
};
var $7102721b9d6067be$export$2e2bcd8739ae039 = $7102721b9d6067be$var$NativeSelectInput;

});
parcelRegister("77Pk1", function(module, exports) {

$parcel$export(module.exports, "getNativeSelectUtilityClasses", () => $5300ff535f32f31d$export$1ee13051fd9e2ab5);
$parcel$export(module.exports, "default", () => $5300ff535f32f31d$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $5300ff535f32f31d$export$1ee13051fd9e2ab5(slot) {
    return (0, $kfTYv.default)('MuiNativeSelect', slot);
}
const $5300ff535f32f31d$var$nativeSelectClasses = (0, $jh2Zm.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $5300ff535f32f31d$export$2e2bcd8739ae039 = $5300ff535f32f31d$var$nativeSelectClasses;

});


parcelRegister("1gyTG", function(module, exports) {

$parcel$export(module.exports, "getSelectUtilityClasses", () => $0ec25aec9cfbc105$export$2c0c1ee5a3392e);
$parcel$export(module.exports, "default", () => $0ec25aec9cfbc105$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $0ec25aec9cfbc105$export$2c0c1ee5a3392e(slot) {
    return (0, $kfTYv.default)('MuiSelect', slot);
}
const $0ec25aec9cfbc105$var$selectClasses = (0, $jh2Zm.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $0ec25aec9cfbc105$export$2e2bcd8739ae039 = $0ec25aec9cfbc105$var$selectClasses;

});


parcelRegister("e0WBI", function(module, exports) {

$parcel$export(module.exports, "default", () => $a33e86faa65aeaa9$export$2e2bcd8739ae039);
parcelRequire("8T3gX");

var $a7uO0 = parcelRequire("a7uO0");

var $k4ank = parcelRequire("k4ank");
'use client';
var $a33e86faa65aeaa9$export$2e2bcd8739ae039 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

});

parcelRegister("fN7FV", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7f162bf80298a28$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $aYNpO = parcelRequire("aYNpO");

var $b4f8D = parcelRequire("b4f8D");

var $dSmkj = parcelRequire("dSmkj");

var $iFXjq = parcelRequire("iFXjq");

var $anJSP = parcelRequire("anJSP");
var $3dQcH = parcelRequire("3dQcH");

var $7AQZl = parcelRequire("7AQZl");

var $kSPDA = parcelRequire("kSPDA");

var $iFXjq = parcelRequire("iFXjq");

var $k4ank = parcelRequire("k4ank");
'use client';
const $b7f162bf80298a28$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $b7f162bf80298a28$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $aYNpO.default)(slots, (0, $kSPDA.getInputUtilityClass), classes);
    return (0, $eJfrs.default)({}, classes, composedClasses);
};
const $b7f162bf80298a28$var$InputRoot = (0, $anJSP.default)((0, $iFXjq.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $3dQcH.default)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $iFXjq.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $eJfrs.default)({
        position: 'relative'
    }, ownerState.formControl && {
        'label + &': {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $kSPDA.default).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $kSPDA.default).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $kSPDA.default).disabled}, .${(0, $kSPDA.default).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $kSPDA.default).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    });
});
const $b7f162bf80298a28$var$InputInput = (0, $anJSP.default)((0, $iFXjq.InputBaseComponent), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $iFXjq.inputOverridesResolver)
})({});
const $b7f162bf80298a28$var$Input = /*#__PURE__*/ $8T3gX.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $fAJB5.default)(props, $b7f162bf80298a28$var$_excluded);
    const classes = $b7f162bf80298a28$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $b4f8D.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $b7f162bf80298a28$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $b7f162bf80298a28$var$InputInput;
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $iFXjq.default), (0, $eJfrs.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$b7f162bf80298a28$var$Input.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true`, the `input` element is focused during the first mount.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'primary',
            'secondary'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        Input: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        Root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    }),
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the `input` will not have an underline.
   */ disableUnderline: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * End `InputAdornment` for this component.
   */ endAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */ inputComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $dSmkj.default),
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'dense',
        'none'
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * Minimum number of rows to display when multiline option is set to true.
   */ minRows: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */ multiline: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Name attribute of the `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * The short hint displayed in the `input` before the user enters a value.
   */ placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Number of rows to display when multiline option is set to true.
   */ rows: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    }),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * Start `InputAdornment` for this component.
   */ startAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any
};
$b7f162bf80298a28$var$Input.muiName = 'Input';
var $b7f162bf80298a28$export$2e2bcd8739ae039 = $b7f162bf80298a28$var$Input;

});
parcelRegister("kSPDA", function(module, exports) {

$parcel$export(module.exports, "getInputUtilityClass", () => $f340e7f189580244$export$cdb270390122322b);
$parcel$export(module.exports, "default", () => $f340e7f189580244$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");

var $5aFhN = parcelRequire("5aFhN");
function $f340e7f189580244$export$cdb270390122322b(slot) {
    return (0, $kfTYv.default)('MuiInput', slot);
}
const $f340e7f189580244$var$inputClasses = (0, $eJfrs.default)({}, (0, $5aFhN.default), (0, $jh2Zm.default)('MuiInput', [
    'root',
    'underline',
    'input'
]));
var $f340e7f189580244$export$2e2bcd8739ae039 = $f340e7f189580244$var$inputClasses;

});


parcelRegister("4ZTSw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a38343bd721d25f$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $b4f8D = parcelRequire("b4f8D");

var $dSmkj = parcelRequire("dSmkj");

var $fdGrT = parcelRequire("fdGrT");

var $aYNpO = parcelRequire("aYNpO");

var $iFXjq = parcelRequire("iFXjq");

var $anJSP = parcelRequire("anJSP");
var $3dQcH = parcelRequire("3dQcH");

var $7AQZl = parcelRequire("7AQZl");

var $dxJLt = parcelRequire("dxJLt");

var $iFXjq = parcelRequire("iFXjq");

var $k4ank = parcelRequire("k4ank");
'use client';
const $3a38343bd721d25f$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $3a38343bd721d25f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $aYNpO.default)(slots, (0, $dxJLt.getFilledInputUtilityClass), classes);
    return (0, $eJfrs.default)({}, classes, composedClasses);
};
const $3a38343bd721d25f$var$FilledInputRoot = (0, $anJSP.default)((0, $iFXjq.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $3dQcH.default)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $iFXjq.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return (0, $eJfrs.default)({
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $dxJLt.default).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $dxJLt.default).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || 'primary']) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $dxJLt.default).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $dxJLt.default).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $dxJLt.default).disabled}, .${(0, $dxJLt.default).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $dxJLt.default).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $eJfrs.default)({
        padding: '25px 12px 8px'
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const $3a38343bd721d25f$var$FilledInputInput = (0, $anJSP.default)((0, $iFXjq.InputBaseComponent), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $iFXjq.inputOverridesResolver)
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const $3a38343bd721d25f$var$FilledInput = /*#__PURE__*/ $8T3gX.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $fAJB5.default)(props, $3a38343bd721d25f$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $3a38343bd721d25f$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $b4f8D.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $3a38343bd721d25f$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $3a38343bd721d25f$var$FilledInputInput;
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $iFXjq.default), (0, $eJfrs.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$3a38343bd721d25f$var$FilledInput.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true`, the `input` element is focused during the first mount.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'primary',
            'secondary'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        Input: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        Root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    }),
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the input will not have an underline.
   */ disableUnderline: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * End `InputAdornment` for this component.
   */ endAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */ hiddenLabel: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */ inputComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $dSmkj.default),
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'dense',
        'none'
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * Minimum number of rows to display when multiline option is set to true.
   */ minRows: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */ multiline: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Name attribute of the `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * The short hint displayed in the `input` before the user enters a value.
   */ placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Number of rows to display when multiline option is set to true.
   */ rows: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    }),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * Start `InputAdornment` for this component.
   */ startAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any
};
$3a38343bd721d25f$var$FilledInput.muiName = 'Input';
var $3a38343bd721d25f$export$2e2bcd8739ae039 = $3a38343bd721d25f$var$FilledInput;

});
parcelRegister("dxJLt", function(module, exports) {

$parcel$export(module.exports, "getFilledInputUtilityClass", () => $9dc1db591d906555$export$3331e419f1a48437);
$parcel$export(module.exports, "default", () => $9dc1db591d906555$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");

var $5aFhN = parcelRequire("5aFhN");
function $9dc1db591d906555$export$3331e419f1a48437(slot) {
    return (0, $kfTYv.default)('MuiFilledInput', slot);
}
const $9dc1db591d906555$var$filledInputClasses = (0, $eJfrs.default)({}, (0, $5aFhN.default), (0, $jh2Zm.default)('MuiFilledInput', [
    'root',
    'underline',
    'input'
]));
var $9dc1db591d906555$export$2e2bcd8739ae039 = $9dc1db591d906555$var$filledInputClasses;

});


parcelRegister("kdEYK", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb84cf1ad5128d58$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $dSmkj = parcelRequire("dSmkj");

var $aYNpO = parcelRequire("aYNpO");

var $cqu2d = parcelRequire("cqu2d");

var $c8JM8 = parcelRequire("c8JM8");

var $k1SKW = parcelRequire("k1SKW");

var $anJSP = parcelRequire("anJSP");
var $3dQcH = parcelRequire("3dQcH");

var $jYErz = parcelRequire("jYErz");

var $iFXjq = parcelRequire("iFXjq");

var $7AQZl = parcelRequire("7AQZl");

var $k4ank = parcelRequire("k4ank");
'use client';
const $eb84cf1ad5128d58$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $eb84cf1ad5128d58$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $aYNpO.default)(slots, (0, $jYErz.getOutlinedInputUtilityClass), classes);
    return (0, $eJfrs.default)({}, classes, composedClasses);
};
const $eb84cf1ad5128d58$var$OutlinedInputRoot = (0, $anJSP.default)((0, $iFXjq.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $3dQcH.default)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $iFXjq.rootOverridesResolver)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return (0, $eJfrs.default)({
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $jYErz.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $jYErz.default).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $jYErz.default).focused} .${(0, $jYErz.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $jYErz.default).error} .${(0, $jYErz.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $jYErz.default).disabled} .${(0, $jYErz.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $eJfrs.default)({
        padding: '16.5px 14px'
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }));
});
const $eb84cf1ad5128d58$var$NotchedOutlineRoot = (0, $anJSP.default)((0, $cqu2d.default), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $eb84cf1ad5128d58$var$OutlinedInputInput = (0, $anJSP.default)((0, $iFXjq.InputBaseComponent), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $iFXjq.inputOverridesResolver)
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        padding: '16.5px 14px'
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $eb84cf1ad5128d58$var$OutlinedInput = /*#__PURE__*/ $8T3gX.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = 'text' } = props, other = (0, $fAJB5.default)(props, $eb84cf1ad5128d58$var$_excluded);
    const classes = $eb84cf1ad5128d58$var$useUtilityClasses(props);
    const muiFormControl = (0, $c8JM8.default)();
    const fcs = (0, $k1SKW.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = (0, $eJfrs.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $eb84cf1ad5128d58$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $eb84cf1ad5128d58$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $iFXjq.default), (0, $eJfrs.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $k4ank.jsx)($eb84cf1ad5128d58$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== '' && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $k4ank.jsxs)($8T3gX.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                })) : label,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $eJfrs.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$eb84cf1ad5128d58$var$OutlinedInput.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true`, the `input` element is focused during the first mount.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'primary',
            'secondary'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        Input: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        Root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * End `InputAdornment` for this component.
   */ endAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */ inputComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $dSmkj.default),
    /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'dense',
        'none'
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * Minimum number of rows to display when multiline option is set to true.
   */ minRows: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */ multiline: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Name attribute of the `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true`, the outline is notched to accommodate the label.
   */ notched: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * The short hint displayed in the `input` before the user enters a value.
   */ placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Number of rows to display when multiline option is set to true.
   */ rows: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        input: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * Start `InputAdornment` for this component.
   */ startAdornment: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any
};
$eb84cf1ad5128d58$var$OutlinedInput.muiName = 'Input';
var $eb84cf1ad5128d58$export$2e2bcd8739ae039 = $eb84cf1ad5128d58$var$OutlinedInput;

});
parcelRegister("cqu2d", function(module, exports) {

$parcel$export(module.exports, "default", () => $90bf360268399e88$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");
parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $anJSP = parcelRequire("anJSP");
var $3dQcH = parcelRequire("3dQcH");

var $k4ank = parcelRequire("k4ank");
'use client';
var $90bf360268399e88$var$_span;
const $90bf360268399e88$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $90bf360268399e88$var$NotchedOutlineRoot = (0, $anJSP.default)('fieldset', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $3dQcH.default)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $90bf360268399e88$var$NotchedOutlineLegend = (0, $anJSP.default)('legend', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $3dQcH.default)
})(({ ownerState: ownerState, theme: theme })=>(0, $eJfrs.default)({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden'
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: '11px',
        // sync with `height` in `legend` styles
        transition: theme.transitions.create('width', {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $eJfrs.default)({
        display: 'block',
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: '0.75em',
        visibility: 'hidden',
        maxWidth: 0.01,
        transition: theme.transitions.create('max-width', {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: 'nowrap',
        '& > span': {
            paddingLeft: 5,
            paddingRight: 5,
            display: 'inline-block',
            opacity: 0,
            visibility: 'visible'
        }
    }, ownerState.notched && {
        maxWidth: '100%',
        transition: theme.transitions.create('max-width', {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $90bf360268399e88$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $fAJB5.default)(props, $90bf360268399e88$var$_excluded);
    const withLabel = label != null && label !== '';
    const ownerState = (0, $eJfrs.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)($90bf360268399e88$var$NotchedOutlineRoot, (0, $eJfrs.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $k4ank.jsx)($90bf360268399e88$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                children: label
            }) : $90bf360268399e88$var$_span || ($90bf360268399e88$var$_span = /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}
$90bf360268399e88$export$2e2bcd8739ae039.propTypes = {
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The label.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * If `true`, the outline is notched to accommodate the label.
   */ notched: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool.isRequired,
    /**
   * @ignore
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
};

});

parcelRegister("jYErz", function(module, exports) {

$parcel$export(module.exports, "getOutlinedInputUtilityClass", () => $e8b2fe2dffb3bb26$export$89922944c7227687);
$parcel$export(module.exports, "default", () => $e8b2fe2dffb3bb26$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");

var $5aFhN = parcelRequire("5aFhN");
function $e8b2fe2dffb3bb26$export$89922944c7227687(slot) {
    return (0, $kfTYv.default)('MuiOutlinedInput', slot);
}
const $e8b2fe2dffb3bb26$var$outlinedInputClasses = (0, $eJfrs.default)({}, (0, $5aFhN.default), (0, $jh2Zm.default)('MuiOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));
var $e8b2fe2dffb3bb26$export$2e2bcd8739ae039 = $e8b2fe2dffb3bb26$var$outlinedInputClasses;

});



parcelRegister("kRZvb", function(module, exports) {

$parcel$export(module.exports, "default", () => $f31876e3acbfdb61$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $7AQZl = parcelRequire("7AQZl");

var $anJSP = parcelRequire("anJSP");

var $iAa6x = parcelRequire("iAa6x");

var $k4ank = parcelRequire("k4ank");
'use client';
const $f31876e3acbfdb61$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "variant"
];
const $f31876e3acbfdb61$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            !disableGutters && 'gutters',
            variant
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $iAa6x.getToolbarUtilityClass), classes);
};
const $f31876e3acbfdb61$var$ToolbarRoot = (0, $anJSP.default)('div', {
    name: 'MuiToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        position: 'relative',
        display: 'flex',
        alignItems: 'center'
    }, !ownerState.disableGutters && {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3)
        }
    }, ownerState.variant === 'dense' && {
        minHeight: 48
    }), ({ theme: theme, ownerState: ownerState })=>ownerState.variant === 'regular' && theme.mixins.toolbar);
const $f31876e3acbfdb61$var$Toolbar = /*#__PURE__*/ $8T3gX.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiToolbar'
    });
    const { className: className, component: component = 'div', disableGutters: disableGutters = false, variant: variant = 'regular' } = props, other = (0, $fAJB5.default)(props, $f31876e3acbfdb61$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        component: component,
        disableGutters: disableGutters,
        variant: variant
    });
    const classes = $f31876e3acbfdb61$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsx)($f31876e3acbfdb61$var$ToolbarRoot, (0, $eJfrs.default)({
        as: component,
        className: (0, $iVyaN.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$f31876e3acbfdb61$var$Toolbar.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   * The Toolbar is a flex container, allowing flex item properties to be used to lay out the children.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * If `true`, disables gutter padding.
   * @default false
   */ disableGutters: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * The variant to use.
   * @default 'regular'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'dense',
            'regular'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ])
};
var $f31876e3acbfdb61$export$2e2bcd8739ae039 = $f31876e3acbfdb61$var$Toolbar;

});
parcelRegister("iAa6x", function(module, exports) {

$parcel$export(module.exports, "getToolbarUtilityClass", () => $d8736d500b52059a$export$b12cb262231eef32);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $d8736d500b52059a$export$b12cb262231eef32(slot) {
    return (0, $kfTYv.default)('MuiToolbar', slot);
}
const $d8736d500b52059a$var$toolbarClasses = (0, $jh2Zm.default)('MuiToolbar', [
    'root',
    'gutters',
    'regular',
    'dense'
]);
var $d8736d500b52059a$export$2e2bcd8739ae039 = $d8736d500b52059a$var$toolbarClasses;

});


parcelRegister("9ztLz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f7e78e9dbf030a0$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $yILjC = parcelRequire("yILjC");

var $ihzIl = parcelRequire("ihzIl");

var $1irQ8 = parcelRequire("1irQ8");

var $iKAtE = parcelRequire("iKAtE");

var $4jNEA = parcelRequire("4jNEA");

var $iWYNk = parcelRequire("iWYNk");

var $k4ank = parcelRequire("k4ank");
'use client';
const $6f7e78e9dbf030a0$var$_excluded = [
    "backIconButtonProps",
    "count",
    "disabled",
    "getItemAriaLabel",
    "nextIconButtonProps",
    "onPageChange",
    "page",
    "rowsPerPage",
    "showFirstButton",
    "showLastButton",
    "slots",
    "slotProps"
];
const $6f7e78e9dbf030a0$var$TablePaginationActions = /*#__PURE__*/ $8T3gX.forwardRef(function TablePaginationActions(props, ref) {
    var _slots$firstButton, _slots$lastButton, _slots$nextButton, _slots$previousButton, _slots$firstButtonIco, _slots$lastButtonIcon, _slots$nextButtonIcon, _slots$previousButton2;
    const { backIconButtonProps: backIconButtonProps, count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel, nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, page: page, rowsPerPage: rowsPerPage, showFirstButton: showFirstButton, showLastButton: showLastButton, slots: slots = {}, slotProps: slotProps = {} } = props, other = (0, $fAJB5.default)(props, $6f7e78e9dbf030a0$var$_excluded);
    const isRtl = (0, $yILjC.useRtl)();
    const handleFirstPageButtonClick = (event)=>{
        onPageChange(event, 0);
    };
    const handleBackButtonClick = (event)=>{
        onPageChange(event, page - 1);
    };
    const handleNextButtonClick = (event)=>{
        onPageChange(event, page + 1);
    };
    const handleLastPageButtonClick = (event)=>{
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    const FirstButton = (_slots$firstButton = slots.firstButton) != null ? _slots$firstButton : (0, $iKAtE.default);
    const LastButton = (_slots$lastButton = slots.lastButton) != null ? _slots$lastButton : (0, $iKAtE.default);
    const NextButton = (_slots$nextButton = slots.nextButton) != null ? _slots$nextButton : (0, $iKAtE.default);
    const PreviousButton = (_slots$previousButton = slots.previousButton) != null ? _slots$previousButton : (0, $iKAtE.default);
    const FirstButtonIcon = (_slots$firstButtonIco = slots.firstButtonIcon) != null ? _slots$firstButtonIco : (0, $iWYNk.default);
    const LastButtonIcon = (_slots$lastButtonIcon = slots.lastButtonIcon) != null ? _slots$lastButtonIcon : (0, $4jNEA.default);
    const NextButtonIcon = (_slots$nextButtonIcon = slots.nextButtonIcon) != null ? _slots$nextButtonIcon : (0, $1irQ8.default);
    const PreviousButtonIcon = (_slots$previousButton2 = slots.previousButtonIcon) != null ? _slots$previousButton2 : (0, $ihzIl.default);
    const FirstButtonSlot = isRtl ? LastButton : FirstButton;
    const PreviousButtonSlot = isRtl ? NextButton : PreviousButton;
    const NextButtonSlot = isRtl ? PreviousButton : NextButton;
    const LastButtonSlot = isRtl ? FirstButton : LastButton;
    const firstButtonSlotProps = isRtl ? slotProps.lastButton : slotProps.firstButton;
    const previousButtonSlotProps = isRtl ? slotProps.nextButton : slotProps.previousButton;
    const nextButtonSlotProps = isRtl ? slotProps.previousButton : slotProps.nextButton;
    const lastButtonSlotProps = isRtl ? slotProps.firstButton : slotProps.lastButton;
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", (0, $eJfrs.default)({
        ref: ref
    }, other, {
        children: [
            showFirstButton && /*#__PURE__*/ (0, $k4ank.jsx)(FirstButtonSlot, (0, $eJfrs.default)({
                onClick: handleFirstPageButtonClick,
                disabled: disabled || page === 0,
                "aria-label": getItemAriaLabel('first', page),
                title: getItemAriaLabel('first', page)
            }, firstButtonSlotProps, {
                children: isRtl ? /*#__PURE__*/ (0, $k4ank.jsx)(LastButtonIcon, (0, $eJfrs.default)({}, slotProps.lastButtonIcon)) : /*#__PURE__*/ (0, $k4ank.jsx)(FirstButtonIcon, (0, $eJfrs.default)({}, slotProps.firstButtonIcon))
            })),
            /*#__PURE__*/ (0, $k4ank.jsx)(PreviousButtonSlot, (0, $eJfrs.default)({
                onClick: handleBackButtonClick,
                disabled: disabled || page === 0,
                color: "inherit",
                "aria-label": getItemAriaLabel('previous', page),
                title: getItemAriaLabel('previous', page)
            }, previousButtonSlotProps != null ? previousButtonSlotProps : backIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $k4ank.jsx)(NextButtonIcon, (0, $eJfrs.default)({}, slotProps.nextButtonIcon)) : /*#__PURE__*/ (0, $k4ank.jsx)(PreviousButtonIcon, (0, $eJfrs.default)({}, slotProps.previousButtonIcon))
            })),
            /*#__PURE__*/ (0, $k4ank.jsx)(NextButtonSlot, (0, $eJfrs.default)({
                onClick: handleNextButtonClick,
                disabled: disabled || (count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false),
                color: "inherit",
                "aria-label": getItemAriaLabel('next', page),
                title: getItemAriaLabel('next', page)
            }, nextButtonSlotProps != null ? nextButtonSlotProps : nextIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $k4ank.jsx)(PreviousButtonIcon, (0, $eJfrs.default)({}, slotProps.previousButtonIcon)) : /*#__PURE__*/ (0, $k4ank.jsx)(NextButtonIcon, (0, $eJfrs.default)({}, slotProps.nextButtonIcon))
            })),
            showLastButton && /*#__PURE__*/ (0, $k4ank.jsx)(LastButtonSlot, (0, $eJfrs.default)({
                onClick: handleLastPageButtonClick,
                disabled: disabled || page >= Math.ceil(count / rowsPerPage) - 1,
                "aria-label": getItemAriaLabel('last', page),
                title: getItemAriaLabel('last', page)
            }, lastButtonSlotProps, {
                children: isRtl ? /*#__PURE__*/ (0, $k4ank.jsx)(FirstButtonIcon, (0, $eJfrs.default)({}, slotProps.firstButtonIcon)) : /*#__PURE__*/ (0, $k4ank.jsx)(LastButtonIcon, (0, $eJfrs.default)({}, slotProps.lastButtonIcon))
            }))
        ]
    }));
});
$6f7e78e9dbf030a0$var$TablePaginationActions.propTypes = {
    /**
   * Props applied to the back arrow [`IconButton`](/material-ui/api/icon-button/) element.
   */ backIconButtonProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The total number of rows.
   */ count: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number.isRequired,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   *
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous'). Defaults to 'page'.
   * @param {number} page The page number to format.
   * @returns {string}
   */ getItemAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired,
    /**
   * Props applied to the next arrow [`IconButton`](/material-ui/api/icon-button/) element.
   */ nextIconButtonProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */ onPageChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired,
    /**
   * The zero-based index of the current page.
   */ page: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number.isRequired,
    /**
   * The number of rows per page.
   */ rowsPerPage: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number.isRequired,
    /**
   * If `true`, show the first-page button.
   */ showFirstButton: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool.isRequired,
    /**
   * If `true`, show the last-page button.
   */ showLastButton: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool.isRequired,
    /**
   * The props used for each slot inside the TablePaginationActions.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        firstButton: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        firstButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        lastButton: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        lastButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        nextButton: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        nextButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        previousButton: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        previousButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    }),
    /**
   * The components used for each slot inside the TablePaginationActions.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        firstButton: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        firstButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        lastButton: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        lastButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        nextButton: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        nextButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        previousButton: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        previousButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    })
};
var $6f7e78e9dbf030a0$export$2e2bcd8739ae039 = $6f7e78e9dbf030a0$var$TablePaginationActions;

});
parcelRegister("ihzIl", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4f5849d15e3b319$export$2e2bcd8739ae039);
parcelRequire("8T3gX");

var $a7uO0 = parcelRequire("a7uO0");

var $k4ank = parcelRequire("k4ank");
'use client';
var $d4f5849d15e3b319$export$2e2bcd8739ae039 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');

});

parcelRegister("1irQ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f1d1149045932e0$export$2e2bcd8739ae039);
parcelRequire("8T3gX");

var $a7uO0 = parcelRequire("a7uO0");

var $k4ank = parcelRequire("k4ank");
'use client';
var $0f1d1149045932e0$export$2e2bcd8739ae039 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');

});

parcelRegister("iKAtE", function(module, exports) {

$parcel$export(module.exports, "default", () => $da68d17925d267dd$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $bPpmJ = parcelRequire("bPpmJ");

var $aYNpO = parcelRequire("aYNpO");

var $aBrLz = parcelRequire("aBrLz");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $hhKOZ = parcelRequire("hhKOZ");

var $iMOmE = parcelRequire("iMOmE");

var $4Y8uf = parcelRequire("4Y8uf");

var $k4ank = parcelRequire("k4ank");
'use client';
const $da68d17925d267dd$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $da68d17925d267dd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $iMOmE.default)(color)}`,
            edge && `edge${(0, $iMOmE.default)(edge)}`,
            `size${(0, $iMOmE.default)(size)}`
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $4Y8uf.getIconButtonUtilityClass), classes);
};
const $da68d17925d267dd$var$IconButtonRoot = (0, $anJSP.default)((0, $hhKOZ.default), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $iMOmE.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $iMOmE.default)(ownerState.edge)}`],
            styles[`size${(0, $iMOmE.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        overflow: 'visible',
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aBrLz.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $eJfrs.default)({}, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (0, $eJfrs.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        '&:hover': (0, $eJfrs.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aBrLz.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        })
    }), ownerState.size === 'small' && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $4Y8uf.default).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $da68d17925d267dd$var$IconButton = /*#__PURE__*/ $8T3gX.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium' } = props, other = (0, $fAJB5.default)(props, $da68d17925d267dd$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $da68d17925d267dd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsx)($da68d17925d267dd$var$IconButtonRoot, (0, $eJfrs.default)({
        className: (0, $iVyaN.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
$da68d17925d267dd$var$IconButton.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The icon to display.
   */ children: (0, $bPpmJ.default)((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node, (props)=>{
        const found = $8T3gX.Children.toArray(props.children).some((child)=>/*#__PURE__*/ $8T3gX.isValidElement(child) && child.props.onClick);
        if (found) return new Error([
            'MUI: You are providing an onClick event listener to a child of a button element.',
            'Prefer applying it to the IconButton directly.',
            'This guarantees that the whole <button> will be responsive to click events.'
        ].join('\n'));
        return null;
    }),
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'inherit',
            'default',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */ disableFocusRipple: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */ edge: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'end',
        'start',
        false
    ]),
    /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'small',
            'medium',
            'large'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $da68d17925d267dd$export$2e2bcd8739ae039 = $da68d17925d267dd$var$IconButton;

});
parcelRegister("4Y8uf", function(module, exports) {

$parcel$export(module.exports, "getIconButtonUtilityClass", () => $39e35952eedd711b$export$5e8702d71474f093);
$parcel$export(module.exports, "default", () => $39e35952eedd711b$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $39e35952eedd711b$export$5e8702d71474f093(slot) {
    return (0, $kfTYv.default)('MuiIconButton', slot);
}
const $39e35952eedd711b$var$iconButtonClasses = (0, $jh2Zm.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge'
]);
var $39e35952eedd711b$export$2e2bcd8739ae039 = $39e35952eedd711b$var$iconButtonClasses;

});


parcelRegister("4jNEA", function(module, exports) {

$parcel$export(module.exports, "default", () => $324f73f31175a29d$export$2e2bcd8739ae039);
parcelRequire("8T3gX");

var $a7uO0 = parcelRequire("a7uO0");

var $k4ank = parcelRequire("k4ank");
'use client';
var $324f73f31175a29d$export$2e2bcd8739ae039 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');

});

parcelRegister("iWYNk", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcbccd52cf534776$export$2e2bcd8739ae039);
parcelRequire("8T3gX");

var $a7uO0 = parcelRequire("a7uO0");

var $k4ank = parcelRequire("k4ank");
'use client';
var $dcbccd52cf534776$export$2e2bcd8739ae039 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), 'FirstPage');

});


parcelRegister("1zmeQ", function(module, exports) {

$parcel$export(module.exports, "getTablePaginationUtilityClass", () => $124a4f6d3862461d$export$909e637b22246f4c);
$parcel$export(module.exports, "default", () => $124a4f6d3862461d$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $124a4f6d3862461d$export$909e637b22246f4c(slot) {
    return (0, $kfTYv.default)('MuiTablePagination', slot);
}
const $124a4f6d3862461d$var$tablePaginationClasses = (0, $jh2Zm.default)('MuiTablePagination', [
    'root',
    'toolbar',
    'spacer',
    'selectLabel',
    'selectRoot',
    'select',
    'selectIcon',
    'input',
    'menuItem',
    'displayedRows',
    'actions'
]);
var $124a4f6d3862461d$export$2e2bcd8739ae039 = $124a4f6d3862461d$var$tablePaginationClasses;

});


parcelRegister("faP87", function(module, exports) {

$parcel$export(module.exports, "theme", () => $26df694f98739171$export$bca14c5b3b88a9c9);

var $cFPmV = parcelRequire("cFPmV");
const $26df694f98739171$export$bca14c5b3b88a9c9 = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        },
        secondary: {
            main: "#FFFFFF"
        }
    }
});

});

parcelRegister("lWchQ", function(module, exports) {

$parcel$export(module.exports, "checkedCircleIcon", () => $d5e39c9b59bfcff2$export$a683169f74035f6f);
$parcel$export(module.exports, "checkedCircleIconSmall", () => $d5e39c9b59bfcff2$export$dad642a6d0dc042d);
$parcel$export(module.exports, "checkedCircleIconGrey", () => $d5e39c9b59bfcff2$export$cbf7c3e7364b7a51);
$parcel$export(module.exports, "checkedCircleIconGreySmall", () => $d5e39c9b59bfcff2$export$51f742636500ff1b);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $5Ibhh = parcelRequire("5Ibhh");

var $g1D4J = parcelRequire("g1D4J");
const $d5e39c9b59bfcff2$export$a683169f74035f6f = /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5Ibhh))), {
    color: "success"
});
const $d5e39c9b59bfcff2$export$dad642a6d0dc042d = /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5Ibhh))), {
    color: "success",
    fontSize: "small"
});
const $d5e39c9b59bfcff2$export$cbf7c3e7364b7a51 = /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g1D4J))), {
    color: "disabled"
});
const $d5e39c9b59bfcff2$export$51f742636500ff1b = /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g1D4J))), {
    color: "disabled",
    fontSize: "small"
});

});
parcelRegister("5Ibhh", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4289cf53617b948d$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $4289cf53617b948d$var$_default = module.exports.default = (0, $4289cf53617b948d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
}), 'CheckCircle');

});

parcelRegister("g1D4J", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $baab0ce779ccae67$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $baab0ce779ccae67$var$_default = module.exports.default = (0, $baab0ce779ccae67$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m5 11H7v-2h10z"
}), 'RemoveCircle');

});


parcelRegister("2aMB5", function(module, exports) {

$parcel$export(module.exports, "cancelIconRed", () => $61e2896b76aa9787$export$f0e6d60b6f12d3e6);
$parcel$export(module.exports, "cancelIconRedSmall", () => $61e2896b76aa9787$export$1702600ac43f47d);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $cye0Y = parcelRequire("cye0Y");
const $61e2896b76aa9787$export$f0e6d60b6f12d3e6 = /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cye0Y))), {
    color: "error"
});
const $61e2896b76aa9787$export$1702600ac43f47d = /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cye0Y))), {
    color: "error",
    fontSize: "small"
});

});
parcelRegister("cye0Y", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9233880fbf4c50c3$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $9233880fbf4c50c3$var$_default = module.exports.default = (0, $9233880fbf4c50c3$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12z"
}), 'Cancel');

});


parcelRegister("hkpxe", function(module, exports) {

$parcel$export(module.exports, "CameraInfoRow", () => $d0ab838c5ba01dab$export$cbd52354bae583e3);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $aVDw9 = parcelRequire("aVDw9");

var $4o6Cs = parcelRequire("4o6Cs");

var $lWchQ = parcelRequire("lWchQ");

var $65sov = parcelRequire("65sov");

var $g41iy = parcelRequire("g41iy");

var $eDfvp = parcelRequire("eDfvp");

var $yndCB = parcelRequire("yndCB");

var $195EM = parcelRequire("195EM");

var $jDisJ = parcelRequire("jDisJ");

var $64WJh = parcelRequire("64WJh");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $6pdiI = parcelRequire("6pdiI");

var $3n3uW = parcelRequire("3n3uW");

var $2suvB = parcelRequire("2suvB");

var $hHKnQ = parcelRequire("hHKnQ");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

var $kqFN9 = parcelRequire("kqFN9");

var $gBR2p = parcelRequire("gBR2p");

var $kPQrn = parcelRequire("kPQrn");

var $cVCJe = parcelRequire("cVCJe");

var $3mOKt = parcelRequire("3mOKt");

var $83bsI = parcelRequire("83bsI");

var $aOOQP = parcelRequire("aOOQP");

var $3FJ79 = parcelRequire("3FJ79");

var $glcO0 = parcelRequire("glcO0");

var $7Ep9S = parcelRequire("7Ep9S");

var $4PFLW = parcelRequire("4PFLW");

var $2uwzz = parcelRequire("2uwzz");

var $5axmO = parcelRequire("5axmO");

var $dXEa5 = parcelRequire("dXEa5");

var $2wOL1 = parcelRequire("2wOL1");

var $a2fXs = parcelRequire("a2fXs");

var $bjrAt = parcelRequire("bjrAt");
const $d0ab838c5ba01dab$export$cbd52354bae583e3 = ({ obj: obj, expanded: expanded, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, siteInfo: siteInfo, permissions: permissions, srcImages: srcImages })=>{
    const { getLineCrossingsData: getLineCrossingsData, lineCrossingsData: lineCrossingsData, presetLineCrossingsData: presetLineCrossingsData, getPresetLineCrossingsData: getPresetLineCrossingsData, lineCrossingsMetricLabels: lineCrossingsMetricLabels, chmOnlyIgnoreZonesByCamera: chmOnlyIgnoreZonesByCamera, cameraStatusById: cameraStatusById, ignoreZonesByCamera: ignoreZonesByCamera, metadataTagZonesByCamera: metadataTagZonesByCamera, rowPrefetchStateByCamera: rowPrefetchStateByCamera, setCameraStatusForCamera: setCameraStatusForCamera, setIgnoreZonesForCamera: setIgnoreZonesForCamera, setMetadataTagZonesForCamera: setMetadataTagZonesForCamera, setRowPrefetchStateForCamera: setRowPrefetchStateForCamera, setChmOnlyIgnoreZonesForCamera: setChmOnlyIgnoreZonesForCamera } = (0, $3FJ79.useSiteAboutStore)();
    const autopatrolSite = siteInfo.integration_type_name === "autopatrol";
    const hideCameraIgnoreZonesPanel = Boolean(chmOnlyIgnoreZonesByCamera[obj.id]);
    const [metadataTagZones, setMetadataTagZones] = $8T3gX.useState([]);
    const sentinelVerifierSite = (0, $3mOKt.integrationsMatcher)("Name", siteInfo.integration_type) === "Sentinel Verifier" ? true : false;
    const aiLinkSite = (0, $3mOKt.integrationsMatcher)("Name", siteInfo.integration_type) === "AI Link" ? true : false;
    const [allIgnoreZones, setAllIgnoreZones] = $8T3gX.useState([]);
    const [visibleIgnoreZones, setVisibleIgnoreZones] = $8T3gX.useState([]);
    const editCameraText = /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
        children: permissions.edit_cameras ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {
                    fontSize: "small"
                }),
                "\xa0Edit Camera"
            ]
        }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
            children: "Full Camera Info"
        })
    });
    const theme = (0, $cFPmV.default)({
        palette: {
            primary: {
                main: "#FF8400"
            }
        }
    });
    const shrinkLineCrossingsTabs = (0, $hHKnQ.default)("(max-width:1575px)");
    const lineCrossingsTabsWidth = shrinkLineCrossingsTabs ? "305px" : "375px";
    const navigate = (0, $3T949.useNavigate)();
    const [clickedTab, setClickedTab] = $8T3gX.useState("one");
    const [responseObject, setResponseObject] = $8T3gX.useState({
        // null until /camera/{id}/status/ answers, so an unloaded or failed row
        // shows "No data yet" and not a green tick it never earned (ENG-1782)
        connected: null,
        frame_since_launch: null,
        good_frame: null,
        blur_metric: 0,
        native_frame_rate: 0,
        frame_dimensions: "",
        last_motion: 0,
        preview_url: "",
        health_status: "",
        is_blurry: null,
        aspect_ratio: "",
        comments: "",
        camera_view: "",
        aspect_ratio_status: "unknown",
        frame_rate_status: "unknown",
        resolution_status: "unknown",
        camera_health_comments: "",
        camera_name: "",
        camera_start_time: 0,
        camera_view_comments: "",
        camera_view_status: "unknown",
        codec_status: "unknown",
        display_frame_since_launch: true,
        dynamic_slicing: false,
        id: 0,
        overall_status: "unknown"
    });
    $8T3gX.useEffect(()=>{
        if (!obj.id) return;
        const status = cameraStatusById[obj.id];
        if (status) {
            setResponseObject(status);
            localStorage.setItem("preview_url", JSON.stringify(status.preview_url || ""));
        }
        const ignoreZones = ignoreZonesByCamera[obj.id];
        if (ignoreZones) {
            setAllIgnoreZones(ignoreZones);
            setVisibleIgnoreZones(ignoreZones);
            localStorage.setItem("ignoreZones", JSON.stringify(ignoreZones));
        }
        const cameraTagZones = metadataTagZonesByCamera[obj.id];
        if (cameraTagZones) setMetadataTagZones(cameraTagZones);
    }, [
        obj.id,
        cameraStatusById,
        ignoreZonesByCamera,
        metadataTagZonesByCamera
    ]);
    const [dimensions, setDimensions] = $8T3gX.useState(null);
    const [previewLoadFailed, setPreviewLoadFailed] = $8T3gX.useState(false);
    const [previewRefreshRequested, setPreviewRefreshRequested] = $8T3gX.useState(false);
    const retryAttemptedForCameraRef = $8T3gX.useRef({});
    const handleImageLoad = (event)=>{
        const { naturalWidth: naturalWidth, naturalHeight: naturalHeight } = event.currentTarget;
        setDimensions((0, $kPQrn.resizeImage)(naturalWidth, naturalHeight));
    };
    const resolvedPreviewUrl = (responseObject.preview_url || obj.preview_url || "").trim();
    $8T3gX.useEffect(()=>{
        setPreviewLoadFailed(false);
        setPreviewRefreshRequested(false);
    }, [
        resolvedPreviewUrl,
        expanded,
        obj.id
    ]);
    $8T3gX.useEffect(()=>{
        if (!obj.id || expanded) return;
        retryAttemptedForCameraRef.current[obj.id] = false;
    }, [
        expanded,
        obj.id
    ]);
    $8T3gX.useEffect(()=>{
        if (!expanded || !obj.id) return;
        const prefetchState = rowPrefetchStateByCamera[obj.id];
        if (!prefetchState) return;
        const needsRetry = prefetchState.statusFailed || prefetchState.ignoreZonesFailed || prefetchState.tagZonesFailed || prefetchState.lineCrossingsFailed;
        if (!needsRetry || retryAttemptedForCameraRef.current[obj.id]) return;
        retryAttemptedForCameraRef.current[obj.id] = true;
        const retryMissingData = async ()=>{
            const AxiosUI = (0, $195EM.createApi)("");
            const nextState = {
                ...prefetchState
            };
            if (prefetchState.statusFailed) try {
                const statusResponse = await AxiosUI.get(`/camera/${obj.id}/status/`);
                setCameraStatusForCamera(obj.id, statusResponse.data);
                setResponseObject(statusResponse.data);
                nextState.statusLoaded = true;
                nextState.statusFailed = false;
            } catch (_error) {
            // Keep failed status for this camera; user can retry by collapsing/re-expanding.
            }
            if (prefetchState.ignoreZonesFailed) try {
                const ignoreZonesResponse = await AxiosUI.get(`/camera/${obj.id}/ignore_zones/`);
                const zones = (0, $83bsI.addIgnoreLabel)(ignoreZonesResponse.data || []);
                setIgnoreZonesForCamera(obj.id, zones);
                setChmOnlyIgnoreZonesForCamera(obj.id, (0, $aOOQP.isChmOnlyIgnoreZones)(ignoreZonesResponse.data || []));
                setAllIgnoreZones(zones);
                setVisibleIgnoreZones(zones);
                nextState.ignoreZonesLoaded = true;
                nextState.ignoreZonesFailed = false;
            } catch (_error) {
            // Keep failed status for this camera; user can retry by collapsing/re-expanding.
            }
            if (prefetchState.tagZonesFailed) try {
                const tagZonesResponse = await AxiosUI.get(`tagzone/?camera=${obj.id}`);
                const zones = tagZonesResponse.data?.results || [];
                setMetadataTagZonesForCamera(obj.id, zones);
                setMetadataTagZones(zones);
                nextState.tagZonesLoaded = true;
                nextState.tagZonesFailed = false;
            } catch (_error) {
            // Keep failed status for this camera; user can retry by collapsing/re-expanding.
            }
            if (prefetchState.lineCrossingsFailed && obj.has_line_crossing) {
                await getLineCrossingsData(navigate, obj.id);
                const currentLineCrossings = (0, $3FJ79.useSiteAboutStore).getState().lineCrossingsData;
                if (Object.prototype.hasOwnProperty.call(currentLineCrossings, obj.id)) {
                    nextState.lineCrossingsLoaded = true;
                    nextState.lineCrossingsFailed = false;
                }
            }
            setRowPrefetchStateForCamera(obj.id, nextState);
        };
        retryMissingData();
    }, [
        expanded,
        obj.id,
        obj.has_line_crossing,
        rowPrefetchStateByCamera,
        getLineCrossingsData,
        navigate,
        setCameraStatusForCamera,
        setIgnoreZonesForCamera,
        setMetadataTagZonesForCamera,
        setRowPrefetchStateForCamera,
        setChmOnlyIgnoreZonesForCamera
    ]);
    const refreshPreviewFromApi = $8T3gX.useCallback(()=>{
        if (!obj.id || previewRefreshRequested) return;
        setPreviewRefreshRequested(true);
        const AxiosUI = (0, $195EM.createApi)("");
        AxiosUI.get(`/camera/${obj.id}/status/`).then((response)=>{
            const nextPreview = (response.data?.preview_url || "").trim();
            setResponseObject((previousState)=>({
                    ...previousState,
                    ...response.data,
                    preview_url: nextPreview || previousState.preview_url
                }));
            if (nextPreview) setPreviewLoadFailed(false);
        }).catch(()=>{});
    }, [
        obj.id,
        previewRefreshRequested
    ]);
    const { flags: flags } = (0, $4PFLW.useFeatureFlag)();
    const viewEditMetadataTagZonesPage = flags.viewEditMetadataTagZonesPage;
    const showLineCrossings = flags.showLineCrossings;
    const { flexIzActive: flexIzActive, zonesForPreview: zonesForPreview, zonesForColorSidebar: zonesForColorSidebar, ignoreZonesTitleText: ignoreZonesTitleText, ignoreZonesHeadingClassName: ignoreZonesHeadingClassName, flexPresetSelectControl: flexPresetSelectControl, flexPresetDialog: flexPresetDialog, selectedFlexPresetId: selectedFlexPresetId } = (0, $dXEa5.useFlexIgnoreZonesCameraRow)({
        siteInfo: siteInfo,
        obj: obj,
        expanded: expanded,
        visibleIgnoreZones: visibleIgnoreZones,
        allIgnoreZones: allIgnoreZones
    });
    // Line crossings follow the flex preset picker (ENG-1610): a named preset shows
    // that preset's lines (`?camera=&preset=`), Default shows the camera-wide lines.
    const presetLineCrossingsForSelection = selectedFlexPresetId != null ? presetLineCrossingsData[obj.id]?.[selectedFlexPresetId] : undefined;
    const displayedLineCrossings = $8T3gX.useMemo(()=>selectedFlexPresetId != null ? presetLineCrossingsForSelection ?? [] : lineCrossingsData[obj.id] ?? [], [
        selectedFlexPresetId,
        presetLineCrossingsForSelection,
        lineCrossingsData,
        obj.id
    ]);
    $8T3gX.useEffect(()=>{
        if (!expanded || !obj.has_line_crossing || selectedFlexPresetId == null || presetLineCrossingsForSelection) return;
        getPresetLineCrossingsData(navigate, obj.id, selectedFlexPresetId);
    }, [
        expanded,
        obj.has_line_crossing,
        obj.id,
        selectedFlexPresetId,
        presetLineCrossingsForSelection,
        getPresetLineCrossingsData,
        navigate
    ]);
    const editLineCrossingsPath = `/sites/${siteInfo.id}/editcamera/${obj.id}/editlinecrossings${(0, $2wOL1.lineCrossingsPresetSearch)(selectedFlexPresetId)}`;
    const ignoreZoneHoverEnabled = !hideCameraIgnoreZonesPanel && !previewLoadFailed && !!resolvedPreviewUrl && zonesForPreview.length > 0 && (!autopatrolSite && clickedTab !== "four" || autopatrolSite && clickedTab === "one");
    const ignoreZoneHoverEnabledAilink = !hideCameraIgnoreZonesPanel && !previewLoadFailed && !!resolvedPreviewUrl && zonesForPreview.length > 0;
    const cameraTimingSummaryRow = !autopatrolSite ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "mt-[8px] flex flex-col gap-y-2 pt-[8px]",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "h-px w-[200px] max-w-full shrink-0 bg-gray-200",
                "aria-hidden": true
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "w-full min-w-0",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "font-mulish font-bold text-[11px] leading-tight text-black",
                        children: "Last Motion Time"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "font-mulish text-[11px] leading-snug text-black",
                        children: responseObject.last_motion ? (0, $jDisJ.timeSinceConvertor)(Number(responseObject.last_motion)) : "--"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "w-full min-w-0",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "font-mulish font-bold text-[11px] leading-tight text-black",
                        children: "Camera Start Time"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "font-mulish text-[11px] leading-snug text-black",
                        children: responseObject.camera_start_time ? (0, $jDisJ.timeSinceConvertor)(Number(responseObject.camera_start_time)) : "--"
                    })
                ]
            }),
            srcImages ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "w-full min-w-0",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "font-mulish font-bold text-[11px] leading-tight text-black",
                        children: "Camera View"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "font-mulish text-[11px] leading-snug text-black",
                        children: (0, $gBR2p.createCameraViewIcon)(responseObject, srcImages)
                    })
                ]
            }) : null,
            !hideCameraIgnoreZonesPanel && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "h-px w-[200px] max-w-full shrink-0 bg-gray-200",
                "aria-hidden": true
            })
        ]
    }) : null;
    const cameraSettingsBlock = !autopatrolSite ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "font-mulish text-[16px] text-actuate-blue pt-[16px]",
                children: "Camera Settings"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "font-mulish text-[12px] text-black pt-[10px] flex",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            (0, $kqFN9.createCameraSettingsIcon)(responseObject.aspect_ratio_status, "Aspect Ratio", responseObject.comments, responseObject.camera_view, responseObject),
                            "\xa0\xa0Aspect Ratio"
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "font-mulish font-bold text-[12px] text-black pl-[28px]",
                        children: responseObject.aspect_ratio ? responseObject.aspect_ratio : "N/A"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "font-mulish text-[12px] text-black pt-[10px] flex",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            (0, $kqFN9.createCameraSettingsIcon)(responseObject.resolution_status, "Resolution", responseObject.comments, responseObject.camera_view, responseObject),
                            "\xa0\xa0Resolution"
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "font-mulish font-bold text-[12px] text-black pl-[36px]",
                        children: responseObject.frame_dimensions ? responseObject.frame_dimensions : "N/A"
                    })
                ]
            }),
            !sentinelVerifierSite && !aiLinkSite && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "font-mulish text-[12px] text-black pt-[10px] flex",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            children: [
                                (0, $kqFN9.createCameraSettingsIcon)(responseObject.frame_rate_status, "Frame Rate", responseObject.comments, responseObject.camera_view, responseObject),
                                "\xa0\xa0Frame Rate"
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "font-mulish font-bold text-[12px] text-black pl-[32px]",
                            children: (0, $bjrAt.formatFrameRate)(responseObject.native_frame_rate)
                        })
                    ]
                })
            })
        ]
    }) : null;
    $8T3gX.useEffect(()=>{
        if (hideCameraIgnoreZonesPanel && obj.has_line_crossing && showLineCrossings) setClickedTab("four");
    }, [
        hideCameraIgnoreZonesPanel,
        obj.has_line_crossing,
        showLineCrossings
    ]);
    return obj.id ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
            style: {
                paddingBottom: 0,
                paddingTop: 0
            },
            colSpan: 9,
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $yndCB.default), {
                in: expanded,
                timeout: "auto",
                unmountOnExit: true,
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                    sx: {
                        margin: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "relative h-[500px]",
                            children: [
                                !window.location.href.includes("editcamera") && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "absolute top-[10px] right-[0px] w-[160px]",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                        onClick: ()=>{
                                            setBackdropLoadingScreenOn(true);
                                            localStorage.setItem("currentCameraId", JSON.stringify(obj.id));
                                            localStorage.setItem("currentCamera", obj.camera_name);
                                            // Store only essential camera info to avoid localStorage quota issues
                                            (0, $2uwzz.safeSetItem)("currentCameraInfo", {
                                                id: obj.id,
                                                camera_name: obj.camera_name
                                            });
                                            localStorage.setItem("preview_url", JSON.stringify(responseObject.preview_url));
                                            localStorage.setItem("ignoreZones", JSON.stringify(allIgnoreZones));
                                            navigate(`/sites/${siteInfo.id}/editcamera/${obj.id}`);
                                        },
                                        text: editCameraText,
                                        disabled: false
                                    })
                                }),
                                siteInfo.integration_type_name !== "ailink" && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "absolute top-[20px] left-[575px] w-[380px]",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "font-mulish text-[16px] text-actuate-blue",
                                            children: "General Information"
                                        }),
                                        siteInfo.integration_type_name !== "SMTP_per_camera" && !autopatrolSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $65sov.VideoFlowStatusLine), {
                                            siteId: siteInfo.id,
                                            cameraId: obj.id,
                                            connected: responseObject.connected
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "w-full font-mulish text-[12px] text-actuate-blue pt-[10px]",
                                            children: [
                                                (0, $g41iy.triStateIcon)(responseObject.is_blurry === null ? null : !responseObject.is_blurry),
                                                "\xa0\xa0Blur Metric"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "w-full font-mulish text-[12px] text-actuate-blue pt-[10px]",
                                            children: [
                                                (0, $g41iy.triStateIcon)(responseObject.good_frame),
                                                "\xa0\xa0Stream Stability"
                                            ]
                                        }),
                                        !autopatrolSite && responseObject.display_frame_since_launch && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "w-full font-mulish text-[12px] text-actuate-blue pt-[10px]",
                                            children: [
                                                (0, $g41iy.triStateIcon)(responseObject.frame_since_launch),
                                                "\xa0\xa0Frame Since Launch"
                                            ]
                                        }),
                                        responseObject.dynamic_slicing && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "w-full font-mulish text-[12px] text-actuate-blue pt-[10px]",
                                            children: [
                                                (0, $lWchQ.checkedCircleIconSmall),
                                                "\xa0\xa0Dynamic Slicing"
                                            ]
                                        }),
                                        cameraTimingSummaryRow,
                                        !hideCameraIgnoreZonesPanel && cameraSettingsBlock
                                    ]
                                }),
                                siteInfo.integration_type_name === "ailink" && cameraTimingSummaryRow && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "absolute top-[20px] left-[595px] w-[380px]",
                                    children: cameraTimingSummaryRow
                                }),
                                !autopatrolSite && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "absolute top-[4px] left-[820px] min-h-[300px] w-[375px]",
                                    children: hideCameraIgnoreZonesPanel && cameraSettingsBlock
                                }),
                                !autopatrolSite && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "absolute top-[20px] left-[820px] min-h-[300px] w-[375px]",
                                    children: [
                                        hideCameraIgnoreZonesPanel && obj.has_line_crossing && showLineCrossings && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "w-[375px] pt-[12px]",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "font-mulish text-[18px] text-actuate-blue",
                                                    children: "Line Crossings"
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "pt-[8px]",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                        onClick: ()=>{
                                                            setBackdropLoadingScreenOn(true);
                                                            navigate(editLineCrossingsPath);
                                                        },
                                                        text: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {
                                                                    fontSize: "small"
                                                                }),
                                                                "\xa0Edit Line Crossings"
                                                            ]
                                                        }),
                                                        disabled: false
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "relative mt-[8px] w-[375px] max-h-[220px] overflow-auto",
                                                    children: displayedLineCrossings.length > 0 ? displayedLineCrossings.map((line, index)=>{
                                                        const displayLabels = [];
                                                        const hasIntruder = line.metric_labels.some((id)=>lineCrossingsMetricLabels.find((m)=>m.id === id)?.name === "intruder_line_crossing");
                                                        const hasVehicle = line.metric_labels.some((id)=>lineCrossingsMetricLabels.find((m)=>m.id === id)?.name === "vehicle_line_crossing");
                                                        const hasBike = line.metric_labels.some((id)=>lineCrossingsMetricLabels.find((m)=>m.id === id)?.name === "bike_line_crossing");
                                                        if (hasIntruder) displayLabels.push("Intruder");
                                                        if (hasVehicle || hasBike) displayLabels.push("Vehicle/Bike");
                                                        const metricsText = displayLabels.length > 0 ? displayLabels.join(", ") : "No metrics";
                                                        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    style: {
                                                                        height: 20,
                                                                        width: 6,
                                                                        background: `${line.color}`
                                                                    },
                                                                    className: "absolute"
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                                    className: "font-mulish text-[14px] indent-5",
                                                                    children: metricsText
                                                                }),
                                                                "\xa0"
                                                            ]
                                                        }, `line-lc-${line.id || index}`);
                                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                        className: "font-mulish text-[14px] text-gray-500",
                                                        children: "No line crossings configured"
                                                    })
                                                })
                                            ]
                                        }),
                                        !hideCameraIgnoreZonesPanel && (!obj.has_line_crossing || !showLineCrossings) && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "flex w-[375px] flex-col",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                    className: "flex items-start gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                            className: ignoreZonesHeadingClassName,
                                                            children: ignoreZonesTitleText
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                            className: "shrink-0",
                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                                onClick: ()=>{
                                                                    setBackdropLoadingScreenOn(true);
                                                                    localStorage.setItem("currentCameraId", JSON.stringify(obj.id));
                                                                    localStorage.setItem("currentCamera", obj.camera_name);
                                                                    (0, $2uwzz.safeSetItem)("currentCameraInfo", {
                                                                        id: obj.id,
                                                                        camera_name: obj.camera_name
                                                                    });
                                                                    localStorage.setItem("preview_url", JSON.stringify(responseObject.preview_url));
                                                                    localStorage.setItem("ignoreZones", JSON.stringify(allIgnoreZones));
                                                                    navigate(`/sites/${siteInfo.id}/editcamera/${obj.id}/editignorezones`);
                                                                },
                                                                text: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                                    title: "Edit Ignore Zones",
                                                                    placement: "top",
                                                                    sx: {
                                                                        fontSize: "20px",
                                                                        fontFamily: "mulish"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {})
                                                                }),
                                                                disabled: false
                                                            })
                                                        })
                                                    ]
                                                }),
                                                flexPresetSelectControl,
                                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "mt-[4px] max-h-[220px] min-h-[150px] w-full overflow-auto",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "w-full",
                                                        children: zonesForColorSidebar.map((object)=>/*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                className: "relative",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                        style: {
                                                                            height: 20,
                                                                            width: 6,
                                                                            background: `${object.line_color}`
                                                                        },
                                                                        className: "absolute"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                                        className: "font-mulish text-[14px] indent-5",
                                                                        children: object.label_display_name
                                                                    }),
                                                                    "\xa0"
                                                                ]
                                                            }, object.label))
                                                    })
                                                })
                                            ]
                                        }),
                                        !hideCameraIgnoreZonesPanel && obj.has_line_crossing && showLineCrossings && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "relative w-[375px]",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "font-mulish text-[18px] text-actuate-blue flex",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                                        sx: {
                                                            borderBottom: 1,
                                                            borderColor: "divider"
                                                        },
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                                                            theme: theme,
                                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3n3uW.default), {
                                                                value: clickedTab,
                                                                onChange: (event, tabValue)=>{
                                                                    setClickedTab(tabValue);
                                                                },
                                                                "aria-label": "intestigation_tabs",
                                                                color: "primary",
                                                                sx: {
                                                                    width: lineCrossingsTabsWidth
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                                                                        value: "one",
                                                                        label: ignoreZonesTitleText,
                                                                        sx: {
                                                                            fontFamily: "Mulish",
                                                                            fontWeight: "Bold",
                                                                            color: "primary",
                                                                            fontSize: "16px"
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                                                                        value: "four",
                                                                        label: `Line Crossings`,
                                                                        sx: {
                                                                            fontFamily: "Mulish",
                                                                            fontWeight: "Bold",
                                                                            color: "primary",
                                                                            fontSize: "16px"
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                }),
                                                clickedTab === "one" && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "absolute pt-[5px]",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                        onClick: ()=>{
                                                            setBackdropLoadingScreenOn(true);
                                                            navigate(`/sites/${siteInfo.id}/editcamera/${obj.id}/editignorezones`);
                                                        },
                                                        text: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {
                                                                    fontSize: "small"
                                                                }),
                                                                "\xa0Edit Ignore Zones"
                                                            ]
                                                        }),
                                                        disabled: false
                                                    })
                                                }),
                                                clickedTab === "one" && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                    className: "relative left-[0px] top-[50px] w-[375px]",
                                                    children: [
                                                        flexPresetSelectControl,
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                            className: "h-[250px] w-full overflow-auto pt-[10px]",
                                                            children: zonesForColorSidebar.map((object)=>/*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                    className: "relative",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                            style: {
                                                                                height: 20,
                                                                                width: 6,
                                                                                background: `${object.line_color}`
                                                                            },
                                                                            className: "absolute"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                                            className: "font-mulish text-[14px] indent-5",
                                                                            children: object.label_display_name
                                                                        }),
                                                                        "\xa0"
                                                                    ]
                                                                }, object.label))
                                                        })
                                                    ]
                                                }),
                                                clickedTab === "four" && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "absolute pt-[5px]",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                        onClick: ()=>{
                                                            setBackdropLoadingScreenOn(true);
                                                            navigate(editLineCrossingsPath);
                                                        },
                                                        text: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {
                                                                    fontSize: "small"
                                                                }),
                                                                "\xa0Edit Line Crossings"
                                                            ]
                                                        }),
                                                        disabled: false
                                                    })
                                                }),
                                                clickedTab === "four" && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "relative left-[0px] top-[50px] w-[375px] h-[130px] overflow-auto",
                                                    children: displayedLineCrossings.length > 0 ? displayedLineCrossings.map((line, index)=>{
                                                        const displayLabels = [];
                                                        const hasIntruder = line.metric_labels.some((id)=>lineCrossingsMetricLabels.find((m)=>m.id === id)?.name === "intruder_line_crossing");
                                                        const hasVehicle = line.metric_labels.some((id)=>lineCrossingsMetricLabels.find((m)=>m.id === id)?.name === "vehicle_line_crossing");
                                                        const hasBike = line.metric_labels.some((id)=>lineCrossingsMetricLabels.find((m)=>m.id === id)?.name === "bike_line_crossing");
                                                        if (hasIntruder) displayLabels.push("Intruder");
                                                        if (hasVehicle || hasBike) displayLabels.push("Vehicle/Bike");
                                                        const metricsText = displayLabels.length > 0 ? displayLabels.join(", ") : "No metrics";
                                                        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    style: {
                                                                        height: 20,
                                                                        width: 6,
                                                                        background: `${line.color}`
                                                                    },
                                                                    className: "absolute"
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                                    className: "font-mulish text-[14px] indent-5",
                                                                    children: metricsText
                                                                }),
                                                                "\xa0"
                                                            ]
                                                        }, `line-${line.id || index}`);
                                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                        className: "font-mulish text-[14px] text-gray-500",
                                                        children: "No line crossings configured"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                autopatrolSite && viewEditMetadataTagZonesPage && !hideCameraIgnoreZonesPanel && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "absolute top-[5px] left-[800px] w-[400px] h-[300px]",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "font-mulish text-[18px] text-actuate-blue flex",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                                sx: {
                                                    borderBottom: 1,
                                                    borderColor: "divider"
                                                },
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                                                    theme: theme,
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3n3uW.default), {
                                                        value: clickedTab,
                                                        onChange: (event, tabValue)=>{
                                                            setClickedTab(tabValue);
                                                        },
                                                        "aria-label": "intestigation_tabs",
                                                        color: "primary",
                                                        sx: {
                                                            width: "345px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                                                                value: "one",
                                                                label: ignoreZonesTitleText,
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    fontWeight: "Bold",
                                                                    color: "primary",
                                                                    fontSize: "16px"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                                                                value: "two",
                                                                label: `Metadata Tag Zones`,
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    fontWeight: "Bold",
                                                                    color: "primary",
                                                                    fontSize: "16px"
                                                                }
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            children: [
                                                clickedTab === "one" && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                                    children: [
                                                        flexPresetSelectControl,
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $glcO0.IgnoreZonesTable), {
                                                            visibleIgnoreZones: flexIzActive ? zonesForPreview : visibleIgnoreZones,
                                                            onEditClick: ()=>{
                                                                setBackdropLoadingScreenOn(true);
                                                                navigate(`/sites/${siteInfo.id}/editcamera/${obj.id}/editignorezones`);
                                                            }
                                                        })
                                                    ]
                                                }),
                                                clickedTab === "two" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $7Ep9S.MetadataTagZonesTable), {
                                                    metadataTagZones: metadataTagZones,
                                                    onEditClick: ()=>{
                                                        setBackdropLoadingScreenOn(true);
                                                        navigate(`/sites/${siteInfo.id}/editcamera/${obj.id}/editmetadatatagzones`);
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                !autopatrolSite || !viewEditMetadataTagZonesPage && !hideCameraIgnoreZonesPanel && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "absolute top-[20px] left-[825px] flex min-h-[300px] w-[320px] flex-col",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "flex items-start gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                    className: ignoreZonesHeadingClassName,
                                                    children: ignoreZonesTitleText
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "shrink-0",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                        onClick: ()=>{
                                                            setBackdropLoadingScreenOn(true);
                                                            localStorage.setItem("currentCameraId", JSON.stringify(obj.id));
                                                            localStorage.setItem("currentCamera", obj.camera_name);
                                                            // Store only essential camera info to avoid localStorage quota issues
                                                            (0, $2uwzz.safeSetItem)("currentCameraInfo", {
                                                                id: obj.id,
                                                                camera_name: obj.camera_name
                                                            });
                                                            localStorage.setItem("preview_url", JSON.stringify(responseObject.preview_url));
                                                            localStorage.setItem("ignoreZones", JSON.stringify(allIgnoreZones));
                                                            navigate(`/sites/${siteInfo.id}/editcamera/${obj.id}/editignorezones`);
                                                        },
                                                        text: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                            title: "Edit Ignore Zones",
                                                            placement: "top",
                                                            sx: {
                                                                fontSize: "20px",
                                                                fontFamily: "mulish"
                                                            },
                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {})
                                                        }),
                                                        disabled: false
                                                    })
                                                })
                                            ]
                                        }),
                                        flexPresetSelectControl,
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "mt-[4px] max-h-[200px] min-h-[150px] w-[305px] overflow-auto",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "w-[275px]",
                                                children: zonesForColorSidebar.map((object, zi)=>/*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                        className: "relative",
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                style: {
                                                                    height: 20,
                                                                    width: 6,
                                                                    background: `${object.line_color}`
                                                                },
                                                                className: "absolute"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                                className: "font-mulish text-[14px] indent-5",
                                                                children: object.label_display_name
                                                            }),
                                                            "\xa0"
                                                        ]
                                                    }, `${obj.id}-sidebar-${zi}-${object.metric_id}-${object.preset_zone_id ?? object.label}`))
                                            })
                                        })
                                    ]
                                }),
                                siteInfo.integration_type_name !== "ailink" ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $a2fXs.IgnoreZonePreviewHoverLayer), {
                                    className: "absolute top-[20px]",
                                    zones: zonesForPreview,
                                    enabled: ignoreZoneHoverEnabled,
                                    children: [
                                        !previewLoadFailed && resolvedPreviewUrl && /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                                            src: resolvedPreviewUrl,
                                            style: {
                                                width: dimensions ? `${dimensions.width}px` : "auto",
                                                height: dimensions ? `${dimensions.height}px` : "auto"
                                            },
                                            onLoad: handleImageLoad,
                                            onError: ()=>{
                                                setPreviewLoadFailed(true);
                                                refreshPreviewFromApi();
                                            },
                                            alt: "TestCameraPhoto"
                                        }),
                                        (previewLoadFailed || !resolvedPreviewUrl) && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "font-mulish text-[14px] text-gray-600",
                                            children: "Camera preview unavailable."
                                        }),
                                        !autopatrolSite && !hideCameraIgnoreZonesPanel && clickedTab !== "four" && !previewLoadFailed && !!resolvedPreviewUrl && zonesForPreview.map((object, zi)=>{
                                            return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "absolute top-[0px]",
                                                children: object.coordinates.map((array, index)=>/*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                                                        className: "absolute top-[0px]",
                                                        style: {
                                                            width: dimensions ? `${dimensions.width}px` : "auto",
                                                            height: dimensions ? `${dimensions.height}px` : "auto"
                                                        },
                                                        children: dimensions && /*#__PURE__*/ (0, $k4ank.jsx)("polygon", {
                                                            points: (0, $64WJh.pointsCreator)(object.coordinates[index], dimensions.height, dimensions.width),
                                                            stroke: object.line_color,
                                                            strokeWidth: "5",
                                                            fill: object.line_color,
                                                            fillOpacity: "50%"
                                                        })
                                                    }, index))
                                            }, `${obj.id}-iz-${zi}-${object.metric_id}-${object.preset_zone_id ?? object.label}`);
                                        }),
                                        !autopatrolSite && dimensions && displayedLineCrossings.length > 0 && (clickedTab === "four" || hideCameraIgnoreZonesPanel && obj.has_line_crossing && showLineCrossings) && /*#__PURE__*/ (0, $k4ank.jsx)((0, $5axmO.LineCrossingsOverlay), {
                                            lines: displayedLineCrossings,
                                            width: dimensions.width,
                                            height: dimensions.height,
                                            frameDimensions: responseObject.frame_dimensions
                                        }),
                                        autopatrolSite && !hideCameraIgnoreZonesPanel && clickedTab === "one" && zonesForPreview.map((object, zi)=>{
                                            return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "absolute top-[0px]",
                                                children: object.coordinates.map((array, index)=>/*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                                                        className: "absolute top-[0px]",
                                                        style: {
                                                            width: dimensions ? `${dimensions.width}px` : "auto",
                                                            height: dimensions ? `${dimensions.height}px` : "auto"
                                                        },
                                                        children: dimensions && /*#__PURE__*/ (0, $k4ank.jsx)("polygon", {
                                                            points: (0, $64WJh.pointsCreator)(object.coordinates[index], dimensions.height, dimensions.width),
                                                            stroke: object.line_color,
                                                            strokeWidth: "5",
                                                            fill: object.line_color,
                                                            fillOpacity: "50%"
                                                        })
                                                    }, index))
                                            }, `${obj.id}-iz-ap-${zi}-${object.metric_id}-${object.preset_zone_id ?? object.label}`);
                                        }),
                                        autopatrolSite && clickedTab === "two" && metadataTagZones.map((object)=>{
                                            return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "absolute top-[0px]",
                                                children: object.coordinates.map((array, index)=>/*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                                                        className: "absolute top-[0px]",
                                                        style: {
                                                            width: dimensions ? `${dimensions.width}px` : "auto",
                                                            height: dimensions ? `${dimensions.height}px` : "auto"
                                                        },
                                                        children: dimensions && /*#__PURE__*/ (0, $k4ank.jsx)("polygon", {
                                                            points: (0, $64WJh.pointsCreator)(object.coordinates[index], dimensions.height, dimensions.width),
                                                            stroke: object.line_color,
                                                            strokeWidth: "5",
                                                            fill: object.line_color,
                                                            fillOpacity: "50%"
                                                        })
                                                    }, index))
                                            }, object.label);
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $k4ank.jsxs)((0, $a2fXs.IgnoreZonePreviewHoverLayer), {
                                    className: "absolute top-[20px]",
                                    zones: zonesForPreview,
                                    enabled: ignoreZoneHoverEnabledAilink,
                                    children: [
                                        !previewLoadFailed && resolvedPreviewUrl && /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                                            src: resolvedPreviewUrl,
                                            onLoad: handleImageLoad,
                                            onError: ()=>{
                                                setPreviewLoadFailed(true);
                                                refreshPreviewFromApi();
                                            },
                                            style: {
                                                width: dimensions ? `${dimensions.width}px` : "auto",
                                                height: dimensions ? `${dimensions.height}px` : "auto"
                                            },
                                            alt: "TestCameraPhoto"
                                        }),
                                        (previewLoadFailed || !resolvedPreviewUrl) && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "font-mulish text-[14px] text-gray-600",
                                            children: "Camera preview unavailable."
                                        }),
                                        !hideCameraIgnoreZonesPanel && !previewLoadFailed && !!resolvedPreviewUrl && zonesForPreview.map((object, zi)=>{
                                            return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "absolute top-[0px]",
                                                children: object.coordinates.map((array, index)=>{
                                                    return /*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                                                        className: "absolute top-[0px]",
                                                        style: {
                                                            width: dimensions ? `${dimensions.width}px` : "auto",
                                                            height: dimensions ? `${dimensions.height}px` : "auto"
                                                        },
                                                        children: dimensions && /*#__PURE__*/ (0, $k4ank.jsx)("polygon", {
                                                            points: (0, $64WJh.pointsCreator)(object.coordinates[index], dimensions.height, dimensions.width),
                                                            stroke: object.line_color,
                                                            strokeWidth: "5",
                                                            fill: object.line_color,
                                                            fillOpacity: "50%"
                                                        })
                                                    }, `${zi}-${index}-${array[0]}`);
                                                })
                                            }, `${obj.id}-iz-al-${zi}-${object.metric_id}-${object.preset_zone_id ?? object.label}`);
                                        })
                                    ]
                                })
                            ]
                        }),
                        !hideCameraIgnoreZonesPanel && flexPresetDialog
                    ]
                })
            })
        })
    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {});
};

});
parcelRegister("65sov", function(module, exports) {

$parcel$export(module.exports, "VideoFlowStatusLine", () => $840b087ee150024b$export$d15a22b63abe5988);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $cVCJe = parcelRequire("cVCJe");

var $jQzIN = parcelRequire("jQzIN");

var $ePwXE = parcelRequire("ePwXE");

var $8hOgG = parcelRequire("8hOgG");

var $lWchQ = parcelRequire("lWchQ");

var $g41iy = parcelRequire("g41iy");

var $jDisJ = parcelRequire("jDisJ");

var $bFa41 = parcelRequire("bFa41");

var $aXzHi = parcelRequire("aXzHi");
// The camera row's connection line (ENG-2068). "Connected" (admin `connected`
// = able_to_connect_on_launch) only says the server answered at launch, so
// where camera_liveness/ has evidence the line says whether VIDEO is arriving.
// Without liveness (loading, failed, 404) it is exactly today's line.
const $840b087ee150024b$var$LINE_CLASS = "w-full font-mulish text-[12px] text-actuate-blue pt-[10px]";
const $840b087ee150024b$var$ago = (iso)=>iso ? (0, $jDisJ.timeSinceConvertor)(Date.parse(iso) / 1000) : null;
const $840b087ee150024b$var$withTooltip = (title, content)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: title,
        placement: "top-start",
        children: content
    });
const $840b087ee150024b$export$d15a22b63abe5988 = ({ siteId: siteId, cameraId: cameraId, connected: connected })=>{
    const liveness = (0, $bFa41.useCameraLiveness)(siteId ? Number(siteId) : null);
    const status = (0, $aXzHi.videoFlowStatus)(liveness, cameraId, liveness ? (0, $aXzHi.livenessNowMs)(liveness) : Date.now());
    const lastVideo = $840b087ee150024b$var$ago(status.lastVideoAt);
    switch(status.state){
        case "receiving":
            return $840b087ee150024b$var$withTooltip(lastVideo ? `Last video ${lastVideo}.` : "Video is arriving from this camera.", /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: $840b087ee150024b$var$LINE_CLASS,
                "data-testid": "video-flow-status",
                children: [
                    (0, $lWchQ.checkedCircleIconSmall),
                    "\xa0\xa0Receiving video"
                ]
            }));
        case "not_receiving":
            return $840b087ee150024b$var$withTooltip(status.zeroBandwidth ? "The site is running, but this camera's stream is at 0 kbps. The server answering does not mean video is arriving." : `The site is running, but no video has arrived from this camera ${lastVideo ? `since ${lastVideo}` : "recently"} (expected within ${0, $aXzHi.VIDEO_FRESH_MINUTES} minutes). The server answering does not mean video is arriving.`, /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: $840b087ee150024b$var$LINE_CLASS,
                "data-testid": "video-flow-status",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jQzIN))), {
                        color: "warning",
                        fontSize: "small"
                    }),
                    "\xa0\xa0Not receiving video"
                ]
            }));
        case "not_checked":
            return $840b087ee150024b$var$withTooltip("Video is only checked while the site's connector is running.", /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: $840b087ee150024b$var$LINE_CLASS,
                "data-testid": "video-flow-status",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8hOgG))), {
                        color: "disabled",
                        fontSize: "small"
                    }),
                    "\xa0\xa0Not checked (site not armed)"
                ]
            }));
        case "no_data":
            if (connected === true) return $840b087ee150024b$var$withTooltip("The camera's server answered when the connector launched. There is no live video reading for this camera (it may only send video on motion), so this is the launch check only.", /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: $840b087ee150024b$var$LINE_CLASS,
                "data-testid": "video-flow-status",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                        color: "disabled",
                        fontSize: "small"
                    }),
                    "\xa0\xa0Server reachable at launch"
                ]
            }));
            break;
        default:
            break;
    }
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: $840b087ee150024b$var$LINE_CLASS,
        children: [
            (0, $g41iy.triStateIcon)(connected),
            "\xa0\xa0Connected"
        ]
    });
};

});
parcelRegister("jQzIN", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e72e9535e51c2c66$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $e72e9535e51c2c66$var$_default = module.exports.default = (0, $e72e9535e51c2c66$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M12 5.99 19.53 19H4.47zM2.74 18c-.77 1.33.19 3 1.73 3h15.06c1.54 0 2.5-1.67 1.73-3L13.73 4.99c-.77-1.33-2.69-1.33-3.46 0zM11 11v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1m0 5h2v2h-2z"
}), 'WarningAmberRounded');

});

parcelRegister("ePwXE", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acbf65819a14595d$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $acbf65819a14595d$var$_default = module.exports.default = (0, $acbf65819a14595d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'InfoOutlined');

});

parcelRegister("8hOgG", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6086e778a5de0572$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $6086e778a5de0572$var$_default = module.exports.default = (0, $6086e778a5de0572$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M7 11v2h10v-2zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8"
}), 'RemoveCircleOutline');

});

parcelRegister("g41iy", function(module, exports) {

$parcel$export(module.exports, "triStateIcon", () => $556044106deb62ae$export$afd2e9c0a1a7a791);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $8hOgG = parcelRequire("8hOgG");

var $lWchQ = parcelRequire("lWchQ");

var $2aMB5 = parcelRequire("2aMB5");
const $556044106deb62ae$export$36f4d1acf7c14951 = /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8hOgG))), {
    color: "disabled",
    fontSize: "small",
    titleAccess: "No data yet"
});
const $556044106deb62ae$export$afd2e9c0a1a7a791 = (value)=>value === null || value === undefined ? $556044106deb62ae$export$36f4d1acf7c14951 : value ? (0, $lWchQ.checkedCircleIconSmall) : (0, $2aMB5.cancelIconRedSmall);

});

parcelRegister("jDisJ", function(module, exports) {

$parcel$export(module.exports, "timeSinceConvertor", () => $1d3dcf85e47cde90$export$2e8a7709267b4177);
// Relative "time ago" string that matches the v1 admin UI. v1 formats the same
// `last_motion` / `camera_start_time` epoch with Django's `django.utils.timesince`,
// so this is a direct port of that function (calendar-aware years/months,
// two-unit depth, e.g. "1 hour, 55 minutes ago"). Using a fixed average month
// length here instead diverges from v1 near month boundaries (e.g. 182 days is
// 6 calendar months but only 5.98 average months).
//
// Django computes with naive datetimes in the server timezone (UTC), so we use
// UTC calendar components to get the same month/year boundaries regardless of
// the viewer's timezone.
// Django's MONTHS uses a flat 28 for February (no leap-year handling); mirror it.
const $1d3dcf85e47cde90$var$MONTH_DAYS = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
// Sub-month chunks, in seconds, in Django's order.
const $1d3dcf85e47cde90$var$CHUNKS = [
    [
        604800,
        "week"
    ],
    [
        86400,
        "day"
    ],
    [
        3600,
        "hour"
    ],
    [
        60,
        "minute"
    ]
];
const $1d3dcf85e47cde90$var$DEPTH = 2;
const $1d3dcf85e47cde90$var$label = (value, name)=>`${value} ${name}${value === 1 ? "" : "s"}`;
const $1d3dcf85e47cde90$export$2e8a7709267b4177 = (epochNum)=>{
    const d = new Date(Math.floor(epochNum) * 1000);
    const now = new Date();
    const since = Math.floor((now.getTime() - d.getTime()) / 1000);
    if (since <= 0) return "0 minutes ago";
    // Whole calendar years + months between the two dates.
    let totalMonths = (now.getUTCFullYear() - d.getUTCFullYear()) * 12 + (now.getUTCMonth() - d.getUTCMonth());
    const dMsOfDay = (d.getTime() % 86400000 + 86400000) % 86400000;
    const nowMsOfDay = (now.getTime() % 86400000 + 86400000) % 86400000;
    if (d.getUTCDate() > now.getUTCDate() || d.getUTCDate() === now.getUTCDate() && dMsOfDay > nowMsOfDay) totalMonths -= 1;
    const years = Math.floor(totalMonths / 12);
    const months = totalMonths % 12;
    // Pivot: shift d forward by the whole years+months, then measure the rest.
    let pivotMs;
    if (years || months) {
        let pivotYear = d.getUTCFullYear() + years;
        let pivotMonth = d.getUTCMonth() + months; // 0-indexed
        if (pivotMonth > 11) {
            pivotMonth -= 12;
            pivotYear += 1;
        }
        const pivotDay = Math.min($1d3dcf85e47cde90$var$MONTH_DAYS[pivotMonth], d.getUTCDate());
        pivotMs = Date.UTC(pivotYear, pivotMonth, pivotDay, d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds());
    } else pivotMs = d.getTime();
    let remaining = Math.floor((now.getTime() - pivotMs) / 1000);
    const partials = [
        [
            years,
            "year"
        ],
        [
            months,
            "month"
        ]
    ];
    for (const [chunk, name] of $1d3dcf85e47cde90$var$CHUNKS){
        const count = Math.floor(remaining / chunk);
        partials.push([
            count,
            name
        ]);
        remaining -= chunk * count;
    }
    // Start at the first non-zero unit, then take up to DEPTH adjacent units,
    // stopping at the first zero (matches Django).
    const parts = [];
    let started = false;
    for (const [value, name] of partials){
        if (!started) {
            if (value === 0) continue;
            started = true;
        } else if (value === 0) break;
        parts.push($1d3dcf85e47cde90$var$label(value, name));
        if (parts.length >= $1d3dcf85e47cde90$var$DEPTH) break;
    }
    if (parts.length === 0) return "0 minutes ago";
    return `${parts.join(", ")} ago`;
};

});

parcelRegister("bFa41", function(module, exports) {

$parcel$export(module.exports, "useCameraLiveness", () => $a91526df54865969$export$4ac6d7035e1ce45);

var $8T3gX = parcelRequire("8T3gX");

var $9OjAn = parcelRequire("9OjAn");

var $195EM = parcelRequire("195EM");

var $aXzHi = parcelRequire("aXzHi");
const $a91526df54865969$export$3c3e5fd57a3b775f = 120000;
const $a91526df54865969$export$81e5c08a13d2fa15 = (0, $9OjAn.create)((set, get)=>({
        bySite: {},
        ensureCameraLiveness: (siteId)=>{
            if (!siteId) return;
            const existing = get().bySite[siteId];
            const now = Date.now();
            if (existing && (existing.status === "loading" || now - existing.fetchedAt < $a91526df54865969$export$3c3e5fd57a3b775f)) return;
            const setEntry = (entry)=>set((state)=>({
                        bySite: {
                            ...state.bySite,
                            [siteId]: entry
                        }
                    }));
            setEntry({
                status: "loading",
                data: existing?.data ?? null,
                fetchedAt: now
            });
            (0, $195EM.createApi)("").get(`customer/${siteId}/camera_liveness/`, {
                timeout: 30000
            }).then((response)=>setEntry({
                    status: "ready",
                    data: (0, $aXzHi.mapCameraLiveness)(response.data),
                    fetchedAt: Date.now()
                })).catch(()=>setEntry({
                    status: "failed",
                    data: null,
                    fetchedAt: Date.now()
                }));
        }
    }));
const $a91526df54865969$export$4ac6d7035e1ce45 = (siteId)=>{
    const ensure = $a91526df54865969$export$81e5c08a13d2fa15((state)=>state.ensureCameraLiveness);
    const entry = $a91526df54865969$export$81e5c08a13d2fa15((state)=>siteId ? state.bySite[siteId] : undefined);
    $8T3gX.useEffect(()=>{
        if (siteId) ensure(siteId);
    }, [
        siteId,
        ensure
    ]);
    return entry?.data && entry.data.siteId === siteId ? entry.data : null;
};

});
parcelRegister("aXzHi", function(module, exports) {

$parcel$export(module.exports, "VIDEO_FRESH_MINUTES", () => $6a0b0fe4e2e9de28$export$208651c1cd3f9b36);
$parcel$export(module.exports, "mapCameraLiveness", () => $6a0b0fe4e2e9de28$export$51aacb030a4fa9ad);
$parcel$export(module.exports, "livenessNowMs", () => $6a0b0fe4e2e9de28$export$9bde9002aba35b55);
$parcel$export(module.exports, "videoFlowStatus", () => $6a0b0fe4e2e9de28$export$c479891f867e7f6e);
// Is video arriving from this camera right now? (ENG-2068, SUP-713)
//
// The camera status "connected" flag is CameraStatus able_to_connect_on_launch:
// for Milestone and other VMS integrations it only says the SERVER answered
// when the connector launched. A camera behind a reachable server can send no
// video at all and still read "Connected". The live per-camera signals come
// from actuate_admin `GET customer/{site_id}/camera_liveness/` (ENG-2046).
//
// Rules (Jacob, ENG-2068):
// - The signal is whether video is arriving, never motion. Plenty of healthy
//   cameras rarely see motion, so last-motion age is never a warning.
// - Only judged while the connector is running: fresh heartbeat AND either in
//   schedule or seen running by the census (a manual arm outside the schedule
//   is running; SUP-744).
// - A fresh bandwidth reading decides for any camera: > 0 kbps is receiving,
//   0 kbps is not receiving (Milestone JPEG pullers stream even with
//   milestone_motion, SUP-713).
// - Without one, continuous cameras are judged by the last frame's age.
//   Motion-gated cameras (`continuous: false`: site use_motion, Milestone
//   milestone_motion, SMTP/AutoPatrol/clips) legitimately stop reading between
//   motion, so stale evidence is never a warning for them.
// - No frame/bandwidth data for the camera: no inference at all.
/** Heartbeat cadence is ~5 min (site-status poller); two missed = stale.
 * Same threshold as the Troubleshooter (CONNECTOR_STALE_MINUTES). */ const $6a0b0fe4e2e9de28$export$2fc2a16a7cff2156 = 10;
const $6a0b0fe4e2e9de28$export$208651c1cd3f9b36 = 15;
const $6a0b0fe4e2e9de28$export$51aacb030a4fa9ad = (body)=>({
        siteId: body.site_id,
        checkedAt: body.checked_at ?? null,
        connector: body.connector ? {
            lastSeenAt: body.connector.last_seen_at ?? null,
            inSchedule: body.connector.in_schedule ?? null,
            censusRunning: body.connector.census_running ?? null
        } : null,
        cameras: (body.cameras ?? []).map((camera)=>({
                cameraId: camera.camera_id,
                cameraName: camera.camera_name,
                continuous: Boolean(camera.continuous),
                lastFrameAt: camera.last_frame_at ?? null,
                bandwidthUpdatedAt: camera.bandwidth_updated_at ?? null,
                inboundKbps: camera.inbound_bandwidth_kbps ?? null
            })),
        errors: body.errors ?? []
    });
const $6a0b0fe4e2e9de28$var$ageMinutes = (iso, nowMs)=>{
    if (!iso) return null;
    const ms = Date.parse(iso);
    if (Number.isNaN(ms)) return null;
    return (nowMs - ms) / 60000;
};
const $6a0b0fe4e2e9de28$var$newest = (a, b)=>{
    if (!a) return b;
    if (!b) return a;
    return Date.parse(a) >= Date.parse(b) ? a : b;
};
const $6a0b0fe4e2e9de28$export$9bde9002aba35b55 = (liveness, fallbackMs = Date.now())=>{
    const checked = liveness.checkedAt ? Date.parse(liveness.checkedAt) : NaN;
    return Number.isNaN(checked) ? fallbackMs : checked;
};
const $6a0b0fe4e2e9de28$export$c479891f867e7f6e = (liveness, cameraId, nowMs)=>{
    const unavailable = {
        state: "unavailable",
        lastVideoAt: null,
        zeroBandwidth: false
    };
    if (!liveness) return unavailable;
    const camera = liveness.cameras.find((row)=>row.cameraId === cameraId);
    if (!camera) return unavailable;
    const lastVideoAt = $6a0b0fe4e2e9de28$var$newest(camera.lastFrameAt, camera.bandwidthUpdatedAt);
    const hasData = camera.lastFrameAt != null || camera.bandwidthUpdatedAt != null || camera.inboundKbps != null;
    if (!hasData) return {
        state: "no_data",
        lastVideoAt: null,
        zeroBandwidth: false
    };
    // Connector running? A heartbeat read that failed is "can't tell", not
    // "not armed": fall back to today's display.
    const lastSeenAt = liveness.connector?.lastSeenAt ?? null;
    if (!lastSeenAt) {
        const heartbeatFailed = liveness.errors.some((error)=>error.source === "heartbeat");
        if (heartbeatFailed) return unavailable;
        return {
            state: "not_checked",
            lastVideoAt: lastVideoAt,
            zeroBandwidth: false
        };
    }
    const connectorAge = $6a0b0fe4e2e9de28$var$ageMinutes(lastSeenAt, nowMs);
    // Honor manual arms: the schedule alone says "off" for a site an operator
    // armed by hand, while the census sees the connector running (SUP-744).
    const runningBySchedule = liveness.connector?.inSchedule !== false;
    const runningByCensus = liveness.connector?.censusRunning === true;
    const connectorRunning = connectorAge != null && connectorAge <= $6a0b0fe4e2e9de28$export$2fc2a16a7cff2156 && (runningBySchedule || runningByCensus);
    if (!connectorRunning) return {
        state: "not_checked",
        lastVideoAt: lastVideoAt,
        zeroBandwidth: false
    };
    const bandwidthAge = $6a0b0fe4e2e9de28$var$ageMinutes(camera.bandwidthUpdatedAt, nowMs);
    const bandwidthFresh = bandwidthAge != null && bandwidthAge <= $6a0b0fe4e2e9de28$export$208651c1cd3f9b36;
    const frameAge = $6a0b0fe4e2e9de28$var$ageMinutes(camera.lastFrameAt, nowMs);
    const frameFresh = frameAge != null && frameAge <= $6a0b0fe4e2e9de28$export$208651c1cd3f9b36;
    // A fresh bandwidth reading decides for ANY camera, motion-gated or not:
    // the Milestone JPEG puller streams all the time even with milestone_motion
    // and writes 0 kbps when the camera sends nothing (SUP-713, Lagoon Farm).
    if (bandwidthFresh && camera.inboundKbps != null) return camera.inboundKbps > 0 ? {
        state: "receiving",
        lastVideoAt: lastVideoAt,
        zeroBandwidth: false
    } : {
        state: "not_receiving",
        lastVideoAt: camera.lastFrameAt,
        zeroBandwidth: true
    };
    if (frameFresh) return {
        state: "receiving",
        lastVideoAt: lastVideoAt,
        zeroBandwidth: false
    };
    // Nothing fresh. Only a continuous camera is expected to send all the time.
    return camera.continuous ? {
        state: "not_receiving",
        lastVideoAt: lastVideoAt,
        zeroBandwidth: false
    } : {
        state: "no_data",
        lastVideoAt: lastVideoAt,
        zeroBandwidth: false
    };
};

});



parcelRegister("yndCB", function(module, exports) {

$parcel$export(module.exports, "default", () => $06752fd754d8523a$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $iVyaN = parcelRequire("iVyaN");

var $fdGrT = parcelRequire("fdGrT");

var $8zaeI = parcelRequire("8zaeI");

var $efgnF = parcelRequire("efgnF");

var $26cdd = parcelRequire("26cdd");

var $aYNpO = parcelRequire("aYNpO");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $3H2gO = parcelRequire("3H2gO");

var $9Pc8j = parcelRequire("9Pc8j");

var $4nWZ9 = parcelRequire("4nWZ9");

var $11ydL = parcelRequire("11ydL");

var $8nZdd = parcelRequire("8nZdd");

var $k4ank = parcelRequire("k4ank");
'use client';
const $06752fd754d8523a$var$_excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const $06752fd754d8523a$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `${orientation}`
        ],
        entered: [
            'entered'
        ],
        hidden: [
            'hidden'
        ],
        wrapper: [
            'wrapper',
            `${orientation}`
        ],
        wrapperInner: [
            'wrapperInner',
            `${orientation}`
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $8nZdd.getCollapseUtilityClass), classes);
};
const $06752fd754d8523a$var$CollapseRoot = (0, $anJSP.default)('div', {
    name: 'MuiCollapse',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === 'entered' && styles.entered,
            ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        height: 0,
        overflow: 'hidden',
        transition: theme.transitions.create('height')
    }, ownerState.orientation === 'horizontal' && {
        height: 'auto',
        width: 0,
        transition: theme.transitions.create('width')
    }, ownerState.state === 'entered' && (0, $eJfrs.default)({
        height: 'auto',
        overflow: 'visible'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto'
    }), ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && {
        visibility: 'hidden'
    }));
const $06752fd754d8523a$var$CollapseWrapper = (0, $anJSP.default)('div', {
    name: 'MuiCollapse',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: 'flex',
        width: '100%'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto',
        height: '100%'
    }));
const $06752fd754d8523a$var$CollapseWrapperInner = (0, $anJSP.default)('div', {
    name: 'MuiCollapse',
    slot: 'WrapperInner',
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({
        width: '100%'
    }, ownerState.orientation === 'horizontal' && {
        width: 'auto',
        height: '100%'
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $06752fd754d8523a$var$Collapse = /*#__PURE__*/ $8T3gX.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiCollapse'
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = '0px', component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = 'vertical', style: style, timeout: timeout = (0, $3H2gO.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $8zaeI.default) } = props, other = (0, $fAJB5.default)(props, $06752fd754d8523a$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = $06752fd754d8523a$var$useUtilityClasses(ownerState);
    const theme = (0, $4nWZ9.default)();
    const timer = (0, $efgnF.default)();
    const wrapperRef = $8T3gX.useRef(null);
    const autoTransitionDuration = $8T3gX.useRef();
    const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === 'horizontal';
    const size = isHorizontal ? 'width' : 'height';
    const nodeRef = $8T3gX.useRef(null);
    const handleRef = (0, $11ydL.default)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = 'absolute';
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = '';
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $9Pc8j.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        if (timeout === 'auto') {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $9Pc8j.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        if (timeout === 'auto') {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)(TransitionComponent, (0, $eJfrs.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, $k4ank.jsx)($06752fd754d8523a$var$CollapseRoot, (0, $eJfrs.default)({
                as: component,
                className: (0, $iVyaN.default)(classes.root, className, {
                    'entered': classes.entered,
                    'exited': !inProp && collapsedSize === '0px' && classes.hidden
                }[state]),
                style: (0, $eJfrs.default)({
                    [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize
                }, style),
                ref: handleRef
            }, childProps, {
                // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
                // that might have been forwarded from the Transition component.
                ownerState: (0, $eJfrs.default)({}, ownerState, {
                    state: state
                }),
                children: /*#__PURE__*/ (0, $k4ank.jsx)($06752fd754d8523a$var$CollapseWrapper, {
                    ownerState: (0, $eJfrs.default)({}, ownerState, {
                        state: state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $k4ank.jsx)($06752fd754d8523a$var$CollapseWrapperInner, {
                        ownerState: (0, $eJfrs.default)({}, ownerState, {
                            state: state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
$06752fd754d8523a$var$Collapse.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */ addEndListener: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * The content node to be collapsed.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */ collapsedSize: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, $26cdd.default),
    /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */ easing: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * If `true`, the component will transition in.
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * @ignore
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * The transition orientation.
   * @default 'vertical'
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'horizontal',
        'vertical'
    ]),
    /**
   * @ignore
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */ timeout: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'auto'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number
        })
    ])
};
$06752fd754d8523a$var$Collapse.muiSupportAuto = true;
var $06752fd754d8523a$export$2e2bcd8739ae039 = $06752fd754d8523a$var$Collapse;

});
parcelRegister("8nZdd", function(module, exports) {

$parcel$export(module.exports, "getCollapseUtilityClass", () => $61aff4294ef153a0$export$5162da8f798e0959);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $61aff4294ef153a0$export$5162da8f798e0959(slot) {
    return (0, $kfTYv.default)('MuiCollapse', slot);
}
const $61aff4294ef153a0$var$collapseClasses = (0, $jh2Zm.default)('MuiCollapse', [
    'root',
    'horizontal',
    'vertical',
    'entered',
    'hidden',
    'wrapper',
    'wrapperInner'
]);
var $61aff4294ef153a0$export$2e2bcd8739ae039 = $61aff4294ef153a0$var$collapseClasses;

});


parcelRegister("64WJh", function(module, exports) {

$parcel$export(module.exports, "pointsCreator", () => $8f8b945d24cabcd0$export$c2c757e9d9431ca3);
const $8f8b945d24cabcd0$export$c2c757e9d9431ca3 = (array, height, width)=>{
    let returnString = "";
    array.forEach((point)=>{
        returnString += `${point[0] * width},${point[1] * height} `;
    });
    return returnString.trim();
};

});

parcelRegister("3n3uW", function(module, exports) {

$parcel$export(module.exports, "default", () => $27463bb95febbc23$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $7Se60 = parcelRequire("7Se60");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $dSmkj = parcelRequire("dSmkj");

var $aYNpO = parcelRequire("aYNpO");

var $yILjC = parcelRequire("yILjC");

var $6zZUJ = parcelRequire("6zZUJ");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $4nWZ9 = parcelRequire("4nWZ9");

var $7dYD9 = parcelRequire("7dYD9");

var $h6xn0 = parcelRequire("h6xn0");

var $bxCAF = parcelRequire("bxCAF");

var $8xLwg = parcelRequire("8xLwg");

var $2JEyb = parcelRequire("2JEyb");

var $7F3bH = parcelRequire("7F3bH");

var $KFodh = parcelRequire("KFodh");

var $lAhWb = parcelRequire("lAhWb");

var $6aDoo = parcelRequire("6aDoo");

var $k4ank = parcelRequire("k4ank");
'use client';
const $27463bb95febbc23$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "action",
    "centered",
    "children",
    "className",
    "component",
    "allowScrollButtonsMobile",
    "indicatorColor",
    "onChange",
    "orientation",
    "ScrollButtonComponent",
    "scrollButtons",
    "selectionFollowsFocus",
    "slots",
    "slotProps",
    "TabIndicatorProps",
    "TabScrollButtonProps",
    "textColor",
    "value",
    "variant",
    "visibleScrollbar"
];
const $27463bb95febbc23$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $27463bb95febbc23$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $27463bb95febbc23$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $27463bb95febbc23$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            vertical && 'vertical'
        ],
        scroller: [
            'scroller',
            fixed && 'fixed',
            hideScrollbar && 'hideScrollbar',
            scrollableX && 'scrollableX',
            scrollableY && 'scrollableY'
        ],
        flexContainer: [
            'flexContainer',
            vertical && 'flexContainerVertical',
            centered && 'centered'
        ],
        indicator: [
            'indicator'
        ],
        scrollButtons: [
            'scrollButtons',
            scrollButtonsHideMobile && 'scrollButtonsHideMobile'
        ],
        scrollableX: [
            scrollableX && 'scrollableX'
        ],
        hideScrollbar: [
            hideScrollbar && 'hideScrollbar'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $KFodh.getTabsUtilityClass), classes);
};
const $27463bb95febbc23$var$TabsRoot = (0, $anJSP.default)('div', {
    name: 'MuiTabs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $KFodh.default).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $KFodh.default).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $eJfrs.default)({
        overflow: 'hidden',
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        display: 'flex'
    }, ownerState.vertical && {
        flexDirection: 'column'
    }, ownerState.scrollButtonsHideMobile && {
        [`& .${(0, $KFodh.default).scrollButtons}`]: {
            [theme.breakpoints.down('sm')]: {
                display: 'none'
            }
        }
    }));
const $27463bb95febbc23$var$TabsScroller = (0, $anJSP.default)('div', {
    name: 'MuiTabs',
    slot: 'Scroller',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({
        position: 'relative',
        display: 'inline-block',
        flex: '1 1 auto',
        whiteSpace: 'nowrap'
    }, ownerState.fixed && {
        overflowX: 'hidden',
        width: '100%'
    }, ownerState.hideScrollbar && {
        // Hide dimensionless scrollbar on macOS
        scrollbarWidth: 'none',
        // Firefox
        '&::-webkit-scrollbar': {
            display: 'none' // Safari + Chrome
        }
    }, ownerState.scrollableX && {
        overflowX: 'auto',
        overflowY: 'hidden'
    }, ownerState.scrollableY && {
        overflowY: 'auto',
        overflowX: 'hidden'
    }));
const $27463bb95febbc23$var$FlexContainer = (0, $anJSP.default)('div', {
    name: 'MuiTabs',
    slot: 'FlexContainer',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({
        display: 'flex'
    }, ownerState.vertical && {
        flexDirection: 'column'
    }, ownerState.centered && {
        justifyContent: 'center'
    }));
const $27463bb95febbc23$var$TabsIndicator = (0, $anJSP.default)('span', {
    name: 'MuiTabs',
    slot: 'Indicator',
    overridesResolver: (props, styles)=>styles.indicator
})(({ ownerState: ownerState, theme: theme })=>(0, $eJfrs.default)({
        position: 'absolute',
        height: 2,
        bottom: 0,
        width: '100%',
        transition: theme.transitions.create()
    }, ownerState.indicatorColor === 'primary' && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    }, ownerState.indicatorColor === 'secondary' && {
        backgroundColor: (theme.vars || theme).palette.secondary.main
    }, ownerState.vertical && {
        height: '100%',
        width: 2,
        right: 0
    }));
const $27463bb95febbc23$var$TabsScrollbarSize = (0, $anJSP.default)((0, $8xLwg.default))({
    overflowX: 'auto',
    overflowY: 'hidden',
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: 'none',
    // Firefox
    '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome
    }
});
const $27463bb95febbc23$var$defaultIndicatorStyle = {};
let $27463bb95febbc23$var$warnedOnceTabPresent = false;
const $27463bb95febbc23$var$Tabs = /*#__PURE__*/ $8T3gX.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiTabs'
    });
    const theme = (0, $4nWZ9.default)();
    const isRtl = (0, $yILjC.useRtl)();
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = 'div', allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = 'primary', onChange: onChange, orientation: orientation = 'horizontal', ScrollButtonComponent: ScrollButtonComponent = (0, $2JEyb.default), scrollButtons: scrollButtons = 'auto', selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: TabScrollButtonProps = {}, textColor: textColor = 'primary', value: value, variant: variant = 'standard', visibleScrollbar: visibleScrollbar = false } = props, other = (0, $fAJB5.default)(props, $27463bb95febbc23$var$_excluded);
    const scrollable = variant === 'scrollable';
    const vertical = orientation === 'vertical';
    const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
    const start = vertical ? 'top' : 'left';
    const end = vertical ? 'bottom' : 'right';
    const clientSize = vertical ? 'clientHeight' : 'clientWidth';
    const size = vertical ? 'height' : 'width';
    const ownerState = (0, $eJfrs.default)({}, props, {
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    });
    const classes = $27463bb95febbc23$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $6zZUJ.default)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $6zZUJ.default)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    if (centered && scrollable) console.error('MUI: You can not use the `centered={true}` and `variant="scrollable"` properties at the same time on a `Tabs` component.');
    const [mounted, setMounted] = $8T3gX.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $8T3gX.useState($27463bb95febbc23$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $8T3gX.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $8T3gX.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $8T3gX.useState(false);
    const [scrollerStyle, setScrollerStyle] = $8T3gX.useState({
        overflow: 'hidden',
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $8T3gX.useRef(null);
    const tabListRef = $8T3gX.useRef(null);
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollLeftNormalized: (0, $h6xn0.getNormalizedScrollLeft)(tabsNode, isRtl ? 'rtl' : 'ltr'),
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                if (!tab) console.error([
                    `MUI: The \`value\` provided to the Tabs component is invalid.`,
                    `None of the Tabs' children match with "${value}".`,
                    valueToIndex.keys ? `You can provide one of the following values: ${Array.from(valueToIndex.keys()).join(', ')}.` : null
                ].join('\n'));
                tabMeta = tab ? tab.getBoundingClientRect() : null;
                if (!$27463bb95febbc23$var$warnedOnceTabPresent && tabMeta && tabMeta.width === 0 && tabMeta.height === 0 && // if the whole Tabs component is hidden, don't warn
                tabsMeta.clientWidth !== 0) {
                    tabsMeta = null;
                    console.error([
                        'MUI: The `value` provided to the Tabs component is invalid.',
                        `The Tab with this \`value\` ("${value}") is not part of the document layout.`,
                        "Make sure the tab item is present in the document or that it's not `display: none`."
                    ].join('\n'));
                    $27463bb95febbc23$var$warnedOnceTabPresent = true;
                }
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $7F3bH.default)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = 'top';
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? 'right' : 'left';
            if (tabMeta && tabsMeta) {
                const correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
                startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + correction);
            }
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        // IE11 support, replace with Number.isNaN
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(indicatorStyle[startIndicator]) || isNaN(indicatorStyle[size])) setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $bxCAF.default)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else {
            scrollValue += delta * (isRtl ? -1 : 1);
            // Fix for Edge
            scrollValue *= isRtl && (0, $h6xn0.detectScrollType)() === 'reverse' ? -1 : 1;
        }
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $8T3gX.useCallback((scrollbarWidth)=>{
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, []);
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $k4ank.jsx)($27463bb95febbc23$var$TabsScrollbarSize, {
            onChange: handleScrollbarSizeChange,
            className: (0, $iVyaN.default)(classes.scrollableX, classes.hideScrollbar)
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $k4ank.jsx)(ScrollButtonComponent, (0, $eJfrs.default)({
            slots: {
                StartScrollButtonIcon: slots.StartScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? 'right' : 'left',
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll
        }, TabScrollButtonProps, {
            className: (0, $iVyaN.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $k4ank.jsx)(ScrollButtonComponent, (0, $eJfrs.default)({
            slots: {
                EndScrollButtonIcon: slots.EndScrollButtonIcon
            },
            slotProps: {
                endScrollButtonIcon: endScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? 'left' : 'right',
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll
        }, TabScrollButtonProps, {
            className: (0, $iVyaN.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $7F3bH.default)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $7F3bH.default)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $8T3gX.useEffect(()=>{
        const handleResize = (0, $7dYD9.default)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    var _resizeObserver2;
                    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, $6aDoo.default)(tabsRef.current);
        win.addEventListener('resize', handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== 'undefined') {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            var _mutationObserver, _resizeObserver3;
            handleResize.clear();
            win.removeEventListener('resize', handleResize);
            (_mutationObserver = mutationObserver) == null || _mutationObserver.disconnect();
            (_resizeObserver3 = resizeObserver) == null || _resizeObserver3.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $8T3gX.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== 'undefined' && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp == null ? void 0 : childrenProp.length
    ]);
    $8T3gX.useEffect(()=>{
        setMounted(true);
    }, []);
    $8T3gX.useEffect(()=>{
        updateIndicatorState();
    });
    $8T3gX.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($27463bb95febbc23$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $8T3gX.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const indicator = /*#__PURE__*/ (0, $k4ank.jsx)($27463bb95febbc23$var$TabsIndicator, (0, $eJfrs.default)({}, TabIndicatorProps, {
        className: (0, $iVyaN.default)(classes.indicator, TabIndicatorProps.className),
        ownerState: ownerState,
        style: (0, $eJfrs.default)({}, indicatorStyle, TabIndicatorProps.style)
    }));
    let childIndex = 0;
    const children = $8T3gX.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $8T3gX.isValidElement(child)) return null;
        if ((0, $7Se60.isFragment)(child)) console.error([
            "MUI: The Tabs component doesn't accept a Fragment as a child.",
            'Consider providing an array instead.'
        ].join('\n'));
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $8T3gX.cloneElement(child, (0, $eJfrs.default)({
            fullWidth: variant === 'fullWidth',
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue
        }, childIndex === 1 && value === false && !child.props.tabIndex ? {
            tabIndex: 0
        } : {}));
    });
    const handleKeyDown = (event)=>{
        const list = tabListRef.current;
        const currentFocus = (0, $lAhWb.default)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute('role');
        if (role !== 'tab') return;
        let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
        let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
        if (orientation === 'horizontal' && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = 'ArrowRight';
            nextItemKey = 'ArrowLeft';
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $27463bb95febbc23$var$moveFocus(list, currentFocus, $27463bb95febbc23$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $27463bb95febbc23$var$moveFocus(list, currentFocus, $27463bb95febbc23$var$nextItem);
                break;
            case 'Home':
                event.preventDefault();
                $27463bb95febbc23$var$moveFocus(list, null, $27463bb95febbc23$var$nextItem);
                break;
            case 'End':
                event.preventDefault();
                $27463bb95febbc23$var$moveFocus(list, null, $27463bb95febbc23$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    return /*#__PURE__*/ (0, $k4ank.jsxs)($27463bb95febbc23$var$TabsRoot, (0, $eJfrs.default)({
        className: (0, $iVyaN.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        as: component
    }, other, {
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $k4ank.jsxs)($27463bb95febbc23$var$TabsScroller, {
                className: classes.scroller,
                ownerState: ownerState,
                style: {
                    overflow: scrollerStyle.overflow,
                    [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
                },
                ref: tabsRef,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)($27463bb95febbc23$var$FlexContainer, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
                        className: classes.flexContainer,
                        ownerState: ownerState,
                        onKeyDown: handleKeyDown,
                        ref: tabListRef,
                        role: "tablist",
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    }));
});
$27463bb95febbc23$var$Tabs.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */ action: (0, $dSmkj.default),
    /**
   * If `true`, the scroll buttons aren't forced hidden on mobile.
   * By default the scroll buttons are hidden on mobile and takes precedence over `scrollButtons`.
   * @default false
   */ allowScrollButtonsMobile: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The label for the Tabs as a string.
   */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * An id or list of ids separated by a space that label the Tabs.
   */ 'aria-labelledby': (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true`, the tabs are centered.
   * This prop is intended for large views.
   * @default false
   */ centered: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * Determines the color of the indicator.
   * @default 'primary'
   */ indicatorColor: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'primary',
            'secondary'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {any} value We default to the index of the child (number)
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'horizontal',
        'vertical'
    ]),
    /**
   * The component used to render the scroll buttons.
   * @default TabScrollButton
   */ ScrollButtonComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * Determine behavior of scroll buttons when tabs are set to scroll:
   *
   * - `auto` will only present them when not all the items are visible.
   * - `true` will always present them.
   * - `false` will never present them.
   *
   * By default the scroll buttons are hidden on mobile.
   * This behavior can be disabled with `allowScrollButtonsMobile`.
   * @default 'auto'
   */ scrollButtons: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOf([
        'auto',
        false,
        true
    ]),
    /**
   * If `true` the selected tab changes on focus. Otherwise it only
   * changes on activation.
   */ selectionFollowsFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        endScrollButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        ]),
        startScrollButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        EndScrollButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        StartScrollButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * Props applied to the tab indicator element.
   * @default  {}
   */ TabIndicatorProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Props applied to the [`TabScrollButton`](/material-ui/api/tab-scroll-button/) element.
   * @default {}
   */ TabScrollButtonProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Determines the color of the `Tab`.
   * @default 'primary'
   */ textColor: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'inherit',
        'primary',
        'secondary'
    ]),
    /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this prop to `false`.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Determines additional display behavior of the tabs:
   *
   *  - `scrollable` will invoke scrolling properties and allow for horizontally
   *  scrolling (or swiping) of the tab bar.
   *  - `fullWidth` will make the tabs grow to use all the available space,
   *  which should be used for small views, like on mobile.
   *  - `standard` will render the default state.
   * @default 'standard'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'fullWidth',
        'scrollable',
        'standard'
    ]),
    /**
   * If `true`, the scrollbar is visible. It can be useful when displaying
   * a long vertical list of tabs.
   * @default false
   */ visibleScrollbar: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
};
var $27463bb95febbc23$export$2e2bcd8739ae039 = $27463bb95febbc23$var$Tabs;

});
parcelRegister("h6xn0", function(module, exports) {

$parcel$export(module.exports, "detectScrollType", () => $c73ce1c873404e18$export$a10970ffb6510128);
$parcel$export(module.exports, "getNormalizedScrollLeft", () => $c73ce1c873404e18$export$3c615b88e5d7e4f6);
// Source from https://github.com/alitaheri/normalize-scroll-left
let $c73ce1c873404e18$var$cachedType;
function $c73ce1c873404e18$export$a10970ffb6510128() {
    if ($c73ce1c873404e18$var$cachedType) return $c73ce1c873404e18$var$cachedType;
    const dummy = document.createElement('div');
    const container = document.createElement('div');
    container.style.width = '10px';
    container.style.height = '1px';
    dummy.appendChild(container);
    dummy.dir = 'rtl';
    dummy.style.fontSize = '14px';
    dummy.style.width = '4px';
    dummy.style.height = '1px';
    dummy.style.position = 'absolute';
    dummy.style.top = '-1000px';
    dummy.style.overflow = 'scroll';
    document.body.appendChild(dummy);
    $c73ce1c873404e18$var$cachedType = 'reverse';
    if (dummy.scrollLeft > 0) $c73ce1c873404e18$var$cachedType = 'default';
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) $c73ce1c873404e18$var$cachedType = 'negative';
    }
    document.body.removeChild(dummy);
    return $c73ce1c873404e18$var$cachedType;
}
function $c73ce1c873404e18$export$3c615b88e5d7e4f6(element, direction) {
    const scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior
    if (direction !== 'rtl') return scrollLeft;
    const type = $c73ce1c873404e18$export$a10970ffb6510128();
    switch(type){
        case 'negative':
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case 'reverse':
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}

});

parcelRegister("bxCAF", function(module, exports) {

$parcel$export(module.exports, "default", () => $8670b60341cf3050$export$2e2bcd8739ae039);
function $8670b60341cf3050$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $8670b60341cf3050$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $8670b60341cf3050$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error('Animation cancelled'));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error('Element already at target position'));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}

});

parcelRegister("8xLwg", function(module, exports) {

$parcel$export(module.exports, "default", () => $6386442b48d44f60$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $7dYD9 = parcelRequire("7dYD9");

var $6aDoo = parcelRequire("6aDoo");
var $a9NOs = parcelRequire("a9NOs");

var $k4ank = parcelRequire("k4ank");
'use client';
const $6386442b48d44f60$var$_excluded = [
    "onChange"
];
const $6386442b48d44f60$var$styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll'
};
function $6386442b48d44f60$export$2e2bcd8739ae039(props) {
    const { onChange: onChange } = props, other = (0, $fAJB5.default)(props, $6386442b48d44f60$var$_excluded);
    const scrollbarHeight = $8T3gX.useRef();
    const nodeRef = $8T3gX.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $a9NOs.default)(()=>{
        const handleResize = (0, $7dYD9.default)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $6aDoo.default)(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    $8T3gX.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", (0, $eJfrs.default)({
        style: $6386442b48d44f60$var$styles
    }, other, {
        ref: nodeRef
    }));
}
$6386442b48d44f60$export$2e2bcd8739ae039.propTypes = {
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired
};

});

parcelRegister("2JEyb", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fdf3d2bfc779759$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $yILjC = parcelRequire("yILjC");

var $6zZUJ = parcelRequire("6zZUJ");

var $ihzIl = parcelRequire("ihzIl");

var $1irQ8 = parcelRequire("1irQ8");

var $hhKOZ = parcelRequire("hhKOZ");

var $7AQZl = parcelRequire("7AQZl");

var $anJSP = parcelRequire("anJSP");

var $ddzrL = parcelRequire("ddzrL");

var $k4ank = parcelRequire("k4ank");
'use client';
const $1fdf3d2bfc779759$var$_excluded = [
    "className",
    "slots",
    "slotProps",
    "direction",
    "orientation",
    "disabled"
];
const $1fdf3d2bfc779759$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            disabled && 'disabled'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $ddzrL.getTabScrollButtonUtilityClass), classes);
};
const $1fdf3d2bfc779759$var$TabScrollButtonRoot = (0, $anJSP.default)((0, $hhKOZ.default), {
    name: 'MuiTabScrollButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({
        width: 40,
        flexShrink: 0,
        opacity: 0.8,
        [`&.${(0, $ddzrL.default).disabled}`]: {
            opacity: 0
        }
    }, ownerState.orientation === 'vertical' && {
        width: '100%',
        height: 40,
        '& svg': {
            transform: `rotate(${ownerState.isRtl ? -90 : 90}deg)`
        }
    }));
const $1fdf3d2bfc779759$var$TabScrollButton = /*#__PURE__*/ $8T3gX.forwardRef(function TabScrollButton(inProps, ref) {
    var _slots$StartScrollBut, _slots$EndScrollButto;
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiTabScrollButton'
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction } = props, other = (0, $fAJB5.default)(props, $1fdf3d2bfc779759$var$_excluded);
    const isRtl = (0, $yILjC.useRtl)();
    const ownerState = (0, $eJfrs.default)({
        isRtl: isRtl
    }, props);
    const classes = $1fdf3d2bfc779759$var$useUtilityClasses(ownerState);
    const StartButtonIcon = (_slots$StartScrollBut = slots.StartScrollButtonIcon) != null ? _slots$StartScrollBut : (0, $ihzIl.default);
    const EndButtonIcon = (_slots$EndScrollButto = slots.EndScrollButtonIcon) != null ? _slots$EndScrollButto : (0, $1irQ8.default);
    const startButtonIconProps = (0, $6zZUJ.default)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $6zZUJ.default)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)($1fdf3d2bfc779759$var$TabScrollButtonRoot, (0, $eJfrs.default)({
        component: "div",
        className: (0, $iVyaN.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null
    }, other, {
        children: direction === 'left' ? /*#__PURE__*/ (0, $k4ank.jsx)(StartButtonIcon, (0, $eJfrs.default)({}, startButtonIconProps)) : /*#__PURE__*/ (0, $k4ank.jsx)(EndButtonIcon, (0, $eJfrs.default)({}, endButtonIconProps))
    }));
});
$1fdf3d2bfc779759$var$TabScrollButton.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The direction the button should indicate.
   */ direction: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'left',
        'right'
    ]).isRequired,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The component orientation (layout flow direction).
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'horizontal',
        'vertical'
    ]).isRequired,
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        endScrollButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        ]),
        startScrollButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        EndScrollButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        StartScrollButtonIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $1fdf3d2bfc779759$export$2e2bcd8739ae039 = $1fdf3d2bfc779759$var$TabScrollButton;

});
parcelRegister("ddzrL", function(module, exports) {

$parcel$export(module.exports, "getTabScrollButtonUtilityClass", () => $99f7fc42f4f44092$export$34861783d3c2eef8);
$parcel$export(module.exports, "default", () => $99f7fc42f4f44092$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $99f7fc42f4f44092$export$34861783d3c2eef8(slot) {
    return (0, $kfTYv.default)('MuiTabScrollButton', slot);
}
const $99f7fc42f4f44092$var$tabScrollButtonClasses = (0, $jh2Zm.default)('MuiTabScrollButton', [
    'root',
    'vertical',
    'horizontal',
    'disabled'
]);
var $99f7fc42f4f44092$export$2e2bcd8739ae039 = $99f7fc42f4f44092$var$tabScrollButtonClasses;

});


parcelRegister("KFodh", function(module, exports) {

$parcel$export(module.exports, "getTabsUtilityClass", () => $08c4671777c079eb$export$cdd93bd054dec359);
$parcel$export(module.exports, "default", () => $08c4671777c079eb$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $08c4671777c079eb$export$cdd93bd054dec359(slot) {
    return (0, $kfTYv.default)('MuiTabs', slot);
}
const $08c4671777c079eb$var$tabsClasses = (0, $jh2Zm.default)('MuiTabs', [
    'root',
    'vertical',
    'flexContainer',
    'flexContainerVertical',
    'centered',
    'scroller',
    'fixed',
    'scrollableX',
    'scrollableY',
    'hideScrollbar',
    'scrollButtons',
    'scrollButtonsHideMobile',
    'indicator'
]);
var $08c4671777c079eb$export$2e2bcd8739ae039 = $08c4671777c079eb$var$tabsClasses;

});


parcelRegister("2suvB", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ca5dcafd6cef69b$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $hhKOZ = parcelRequire("hhKOZ");

var $iMOmE = parcelRequire("iMOmE");

var $7AQZl = parcelRequire("7AQZl");

var $anJSP = parcelRequire("anJSP");

var $i4juz = parcelRequire("i4juz");

var $3QNfz = parcelRequire("3QNfz");

var $k4ank = parcelRequire("k4ank");
'use client';
const $1ca5dcafd6cef69b$var$_excluded = [
    "className",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "icon",
    "iconPosition",
    "indicator",
    "label",
    "onChange",
    "onClick",
    "onFocus",
    "selected",
    "selectionFollowsFocus",
    "textColor",
    "value",
    "wrapped"
];
const $1ca5dcafd6cef69b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            icon && label && 'labelIcon',
            `textColor${(0, $iMOmE.default)(textColor)}`,
            fullWidth && 'fullWidth',
            wrapped && 'wrapped',
            selected && 'selected',
            disabled && 'disabled'
        ],
        iconWrapper: [
            'iconWrapper'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $3QNfz.getTabUtilityClass), classes);
};
const $1ca5dcafd6cef69b$var$TabRoot = (0, $anJSP.default)((0, $hhKOZ.default), {
    name: 'MuiTab',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $iMOmE.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped,
            {
                [`& .${(0, $3QNfz.default).iconWrapper}`]: styles.iconWrapper
            }
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({}, theme.typography.button, {
        maxWidth: 360,
        minWidth: 90,
        position: 'relative',
        minHeight: 48,
        flexShrink: 0,
        padding: '12px 16px',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textAlign: 'center'
    }, ownerState.label && {
        flexDirection: ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom' ? 'column' : 'row'
    }, {
        lineHeight: 1.25
    }, ownerState.icon && ownerState.label && {
        minHeight: 72,
        paddingTop: 9,
        paddingBottom: 9,
        [`& > .${(0, $3QNfz.default).iconWrapper}`]: (0, $eJfrs.default)({}, ownerState.iconPosition === 'top' && {
            marginBottom: 6
        }, ownerState.iconPosition === 'bottom' && {
            marginTop: 6
        }, ownerState.iconPosition === 'start' && {
            marginRight: theme.spacing(1)
        }, ownerState.iconPosition === 'end' && {
            marginLeft: theme.spacing(1)
        })
    }, ownerState.textColor === 'inherit' && {
        color: 'inherit',
        opacity: 0.6,
        // same opacity as theme.palette.text.secondary
        [`&.${(0, $3QNfz.default).selected}`]: {
            opacity: 1
        },
        [`&.${(0, $3QNfz.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.textColor === 'primary' && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $3QNfz.default).selected}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $3QNfz.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.textColor === 'secondary' && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $3QNfz.default).selected}`]: {
            color: (theme.vars || theme).palette.secondary.main
        },
        [`&.${(0, $3QNfz.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.fullWidth && {
        flexShrink: 1,
        flexGrow: 1,
        flexBasis: 0,
        maxWidth: 'none'
    }, ownerState.wrapped && {
        fontSize: theme.typography.pxToRem(12)
    }));
const $1ca5dcafd6cef69b$var$Tab = /*#__PURE__*/ $8T3gX.forwardRef(function Tab(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiTab'
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = 'top', indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = 'inherit', value: value, wrapped: wrapped = false } = props, other = (0, $fAJB5.default)(props, $1ca5dcafd6cef69b$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    });
    const classes = $1ca5dcafd6cef69b$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $8T3gX.isValidElement(iconProp) ? /*#__PURE__*/ $8T3gX.cloneElement(iconProp, {
        className: (0, $iVyaN.default)(classes.iconWrapper, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)($1ca5dcafd6cef69b$var$TabRoot, (0, $eJfrs.default)({
        focusRipple: !disableFocusRipple,
        className: (0, $iVyaN.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1
    }, other, {
        children: [
            iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/ (0, $k4ank.jsxs)($8T3gX.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $k4ank.jsxs)($8T3gX.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    }));
});
$1ca5dcafd6cef69b$var$Tab.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */ children: (0, $i4juz.default),
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */ disableFocusRipple: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The icon to display.
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The position of the icon relative to the label.
   * @default 'top'
   */ iconPosition: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'bottom',
        'end',
        'start',
        'top'
    ]),
    /**
   * The label element.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * @ignore
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Tab labels appear in a single row.
   * They can use a second line if needed.
   * @default false
   */ wrapped: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
};
var $1ca5dcafd6cef69b$export$2e2bcd8739ae039 = $1ca5dcafd6cef69b$var$Tab;

});
parcelRegister("i4juz", function(module, exports) {

$parcel$export(module.exports, "default", () => $d277b868e1c0a3e5$export$2e2bcd8739ae039);

var $9m6pu = parcelRequire("9m6pu");
var $d277b868e1c0a3e5$export$2e2bcd8739ae039 = (0, $9m6pu.default);

});
parcelRegister("9m6pu", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cfb240c3168faab$export$2e2bcd8739ae039);
function $6cfb240c3168faab$export$2e2bcd8739ae039(props, propName, componentName, location, propFullName) {
    const propFullNameSafe = propFullName || propName;
    if (typeof props[propName] !== 'undefined') return new Error(`The prop \`${propFullNameSafe}\` is not supported. Please remove it.`);
    return null;
}

});


parcelRegister("3QNfz", function(module, exports) {

$parcel$export(module.exports, "getTabUtilityClass", () => $2cdc6e79fede3338$export$72aef224d6115253);
$parcel$export(module.exports, "default", () => $2cdc6e79fede3338$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $2cdc6e79fede3338$export$72aef224d6115253(slot) {
    return (0, $kfTYv.default)('MuiTab', slot);
}
const $2cdc6e79fede3338$var$tabClasses = (0, $jh2Zm.default)('MuiTab', [
    'root',
    'labelIcon',
    'textColorInherit',
    'textColorPrimary',
    'textColorSecondary',
    'selected',
    'disabled',
    'fullWidth',
    'wrapped',
    'iconWrapper'
]);
var $2cdc6e79fede3338$export$2e2bcd8739ae039 = $2cdc6e79fede3338$var$tabClasses;

});


parcelRegister("hHKnQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce3a6e9c5039b103$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");

var $5IwAt = parcelRequire("5IwAt");

var $4qo8D = parcelRequire("4qo8D");

var $f7wb5 = parcelRequire("f7wb5");
'use client';
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function $ce3a6e9c5039b103$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $8T3gX.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $5IwAt.default)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $ce3a6e9c5039b103$var$maybeReactUseSyncExternalStore = $8T3gX.useSyncExternalStore;
function $ce3a6e9c5039b103$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $8T3gX.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $8T3gX.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $8T3gX.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $ce3a6e9c5039b103$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $ce3a6e9c5039b103$export$2e2bcd8739ae039(queryInput, options = {}) {
    const theme = (0, $f7wb5.default)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
    const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $4qo8D.default)({
        name: 'MuiUseMediaQuery',
        props: options,
        theme: theme
    });
    if (typeof queryInput === 'function' && theme === null) console.error([
        'MUI: The `query` argument provided is invalid.',
        'You are providing a function without a theme in the context.',
        'One of the parent elements needs to use a ThemeProvider.'
    ].join('\n'));
    let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, '');
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = $ce3a6e9c5039b103$var$maybeReactUseSyncExternalStore !== undefined ? $ce3a6e9c5039b103$var$useMediaQueryNew : $ce3a6e9c5039b103$var$useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8T3gX.useDebugValue({
        query: query,
        match: match
    });
    return match;
}

});
parcelRegister("4qo8D", function(module, exports) {

$parcel$export(module.exports, "default", () => $338c507cdf62c56a$export$2e2bcd8739ae039);

var $cA45A = parcelRequire("cA45A");
function $338c507cdf62c56a$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $cA45A.default)(theme.components[name].defaultProps, props);
}

});


parcelRegister("kqFN9", function(module, exports) {

$parcel$export(module.exports, "createCameraSettingsIcon", () => $8a8fd5a8946b880e$export$e422c923edf60618);

var $k4ank = parcelRequire("k4ank");

var $cVCJe = parcelRequire("cVCJe");

var $gt8Ee = parcelRequire("gt8Ee");
parcelRequire("8T3gX");

var $lWchQ = parcelRequire("lWchQ");

var $2aMB5 = parcelRequire("2aMB5");

var $lMDu1 = parcelRequire("lMDu1");

var $elUFI = parcelRequire("elUFI");

var $4FKEc = parcelRequire("4FKEc");
const $8a8fd5a8946b880e$export$e422c923edf60618 = (statusString, settingString, commentString, cameraView, responseObject)=>{
    if (settingString === "Frame Rate") {
        if (cameraView === "thermal" || cameraView === "fisheye") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
            title: `Product requirements have been overriden due to camera view type.`,
            placement: "top",
            sx: {
                fontFamily: "mulish"
            },
            children: (0, $lWchQ.checkedCircleIconGreySmall)
        });
        else if (commentString && commentString.includes("Dynamic slicing is enabled")) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
            title: `Product requirements have been overriden due to dynamic slicing.`,
            placement: "top",
            sx: {
                fontFamily: "mulish"
            },
            children: (0, $lWchQ.checkedCircleIconGreySmall)
        });
        else {
            const frameRateCommentString = (0, $lMDu1.extractFrameRateInfo)(commentString);
            if (statusString === "unknown") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                title: `Unable to determine, camera information is still not available.`,
                placement: "top",
                sx: {
                    fontFamily: "mulish"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gt8Ee))), {
                    sx: {
                        color: "#9e9e9e"
                    },
                    fontSize: "small"
                })
            });
            if (statusString === "optimal" || statusString === "good") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                title: frameRateCommentString,
                placement: "top",
                sx: {
                    fontFamily: "mulish"
                },
                children: (0, $lWchQ.checkedCircleIconSmall)
            });
            if (statusString === "warning" || statusString === "bad") {
                if (frameRateCommentString && frameRateCommentString.includes("above")) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                    title: frameRateCommentString,
                    placement: "top",
                    sx: {
                        fontFamily: "mulish"
                    },
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gt8Ee))), {
                        sx: {
                            color: "#FF8400"
                        },
                        fontSize: "small"
                    })
                });
                else return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                    title: frameRateCommentString,
                    placement: "top",
                    sx: {
                        fontFamily: "mulish"
                    },
                    children: (0, $2aMB5.cancelIconRedSmall)
                });
            }
        }
    }
    if (settingString === "Resolution") {
        if (cameraView === "thermal" || cameraView === "fisheye") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
            title: `Product requirements have been overriden due to camera view type.`,
            placement: "top",
            sx: {
                fontFamily: "mulish"
            },
            children: (0, $lWchQ.checkedCircleIconGreySmall)
        });
        else if (commentString && commentString.includes("Dynamic slicing is enabled")) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
            title: `Product requirements have been overriden due to dynamic slicing.`,
            placement: "top",
            sx: {
                fontFamily: "mulish"
            },
            children: (0, $lWchQ.checkedCircleIconGreySmall)
        });
        else {
            const resolutionCommentString = (0, $elUFI.extractResolutionInfo)(commentString);
            if (statusString === "unknown") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                title: `Unable to determine, camera information is still not available.`,
                placement: "top",
                sx: {
                    fontFamily: "mulish"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gt8Ee))), {
                    sx: {
                        color: "#9e9e9e"
                    },
                    fontSize: "small"
                })
            });
            if (statusString === "optimal" || statusString === "good") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                title: resolutionCommentString,
                placement: "top",
                sx: {
                    fontFamily: "mulish"
                },
                children: (0, $lWchQ.checkedCircleIconSmall)
            });
            if (statusString === "warning" || statusString === "bad") {
                if (resolutionCommentString && resolutionCommentString.includes("above")) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                    title: resolutionCommentString,
                    placement: "top",
                    sx: {
                        fontFamily: "mulish"
                    },
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gt8Ee))), {
                        sx: {
                            color: "#FF8400"
                        },
                        fontSize: "small"
                    })
                });
                else return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                    title: resolutionCommentString,
                    placement: "top",
                    sx: {
                        fontFamily: "mulish"
                    },
                    children: (0, $2aMB5.cancelIconRedSmall)
                });
            }
        }
    }
    if (settingString === "Aspect Ratio") {
        if (cameraView === "thermal" || cameraView === "fisheye") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
            title: `Product requirements have been overriden due to camera view type.`,
            placement: "top",
            sx: {
                fontFamily: "mulish"
            },
            children: (0, $lWchQ.checkedCircleIconGreySmall)
        });
        else if (commentString && commentString.includes("Dynamic slicing is enabled")) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
            title: `Product requirements have been overriden due to dynamic slicing.`,
            placement: "top",
            sx: {
                fontFamily: "mulish"
            },
            children: (0, $lWchQ.checkedCircleIconGreySmall)
        });
        else {
            const aspectRatioCommentString = (0, $4FKEc.extractAspectRationInfo)(commentString);
            if (statusString === "unknown") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                title: `Unable to determine, camera information is still not available.`,
                placement: "top",
                sx: {
                    fontFamily: "mulish"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gt8Ee))), {
                    sx: {
                        color: "#9e9e9e"
                    },
                    fontSize: "small"
                })
            });
            if (statusString === "optimal" || statusString === "good") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                title: aspectRatioCommentString,
                placement: "top",
                sx: {
                    fontFamily: "mulish"
                },
                children: (0, $lWchQ.checkedCircleIconSmall)
            });
            if (statusString === "warning" || statusString === "bad") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                title: aspectRatioCommentString,
                placement: "top",
                sx: {
                    fontFamily: "mulish"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gt8Ee))), {
                    sx: {
                        color: "#FF8400"
                    },
                    fontSize: "small"
                })
            });
        }
    }
//   switch (statusString) {
//     case "unknown":
//       return (
//         <Tooltip
//           title={`Unable to determine, camera information is still not available.`}
//           placement="top"
//           sx={{ fontFamily: "mulish" }}
//         >
//           <WarningIcon sx={{ color: "#9e9e9e" }} fontSize="small" />
//         </Tooltip>
//       );
//     case "optimal":
//       return (
//         <Tooltip
//           title={`${extractFrameRateInfo(commentString)}`}
//           placement="top"
//           sx={{ fontFamily: "mulish" }}
//         >
//           {checkedCircleIconSmall}
//         </Tooltip>
//       );
//     case "good":
//       return (
//         <Tooltip
//           title={`${extractFrameRateInfo(commentString)}`}
//           placement="top"
//           sx={{ fontFamily: "mulish" }}
//         >
//           {checkedCircleIconSmall}
//         </Tooltip>
//       );
//     case "warning":
//       return (
//         <Tooltip
//           title={`${extractFrameRateInfo(commentString)}`}
//           placement="top"
//           sx={{ fontFamily: "mulish" }}
//         >
//           <WarningIcon sx={{ color: "#FF8400" }} fontSize="small" />
//         </Tooltip>
//       );
//     case "bad":
//       return (
//         <Tooltip
//           title={`${extractFrameRateInfo(commentString)}`}
//           placement="top"
//           sx={{ fontFamily: "mulish" }}
//         >
//           {cancelIconRedSmall}
//         </Tooltip>
//       );
//   }
};

});
parcelRegister("gt8Ee", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfd61014d8d65554$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $bfd61014d8d65554$var$_default = module.exports.default = (0, $bfd61014d8d65554$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M1 21h22L12 2zm12-3h-2v-2h2zm0-4h-2v-4h2z"
}), 'Warning');

});

parcelRegister("lMDu1", function(module, exports) {

$parcel$export(module.exports, "extractFrameRateInfo", () => $6c3535ab98e01f62$export$db30b77687c0897e);
parcelRequire("8T3gX");
const $6c3535ab98e01f62$export$db30b77687c0897e = (inputString)=>{
    if (inputString) {
        const pattern = /Aspect[\s\S]*$/;
        const match = inputString.match(pattern);
        return match ? match[0] : null; // Return the matched substring or null if no match is found
    } else return "";
};

});

parcelRegister("elUFI", function(module, exports) {

$parcel$export(module.exports, "extractResolutionInfo", () => $23f4c20ca99e6161$export$2cef8cc6618743b5);
parcelRequire("8T3gX");
const $23f4c20ca99e6161$var$extractWidthInfo = (inputString)=>{
    // Define the pattern to match the desired substring
    const pattern = /Width.*?\)/;
    // Use regex to find the matching substring
    const match = inputString.match(pattern);
    return match ? match[0] : null; // Return the matched substring or null if no match is found
};
const $23f4c20ca99e6161$var$extractHeightInfo = (inputString)=>{
    // Define the pattern to match the desired substring
    const pattern = /Height.*?\)/;
    // Use regex to find the matching substring
    const match = inputString.match(pattern);
    return match ? match[0] : null; // Return the matched substring or null if no match is found
};
const $23f4c20ca99e6161$export$2cef8cc6618743b5 = (inputString)=>{
    if (inputString) return `${$23f4c20ca99e6161$var$extractWidthInfo(inputString)} ${$23f4c20ca99e6161$var$extractHeightInfo(inputString)}`;
    else return "";
};

});

parcelRegister("4FKEc", function(module, exports) {

$parcel$export(module.exports, "extractAspectRationInfo", () => $714211db3bca24a1$export$6cc30ccba30c80b4);
parcelRequire("8T3gX");
const $714211db3bca24a1$var$findAspectLocation = (inputString)=>{
    // Find the index of the first occurrence of "A" in "Aspect" in the input string
    const aspectIndex = inputString.indexOf("Aspect");
    // Return the index of "A" in "Aspect"
    return aspectIndex !== -1 ? aspectIndex + 1 : -1; // Adding 1 to get the index of "A"
};
const $714211db3bca24a1$export$6cc30ccba30c80b4 = (inputString)=>{
    if (inputString) {
        const aspectLocation = $714211db3bca24a1$var$findAspectLocation(inputString);
        return inputString.slice(aspectLocation - 1);
    } else return "";
// const pattern = /Aspect.*?padding\)/;
// const match: RegExpMatchArray | null = inputString.match(pattern);
// return match ? match[0] : null; // Return the matched substring or null if no match is found
};

});


parcelRegister("gBR2p", function(module, exports) {

$parcel$export(module.exports, "createCameraViewIcon", () => $bf9098ebce5a2131$export$d5f7d4826edcf78f);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $cVCJe = parcelRequire("cVCJe");

var $gt8Ee = parcelRequire("gt8Ee");

var $lWchQ = parcelRequire("lWchQ");
const $bf9098ebce5a2131$var$fishEyeWarningMessage = `Your camera has been flagged as fisheye. For cameras with exclusively intruder(person or vehicle detection), we recommend fisheye dewarping. If interested, please contact support@actuate.ai.`;
const $bf9098ebce5a2131$var$thermalWarningMessage = `Your camera has been flagged as thermal. We recommend our thermal model to improve detection performance. If interested, please contact support@actuate.ai.`;
const $bf9098ebce5a2131$export$d5f7d4826edcf78f = (obj, srcImages)=>{
    const cameraViewOptions = localStorage.cameraViewOptions ? JSON.parse(localStorage.cameraViewOptions) : [];
    const cameraViewOptionNames = new Map();
    if (cameraViewOptions) cameraViewOptions.forEach((option)=>{
        cameraViewOptionNames.set(option.value, option.name);
    });
    if (!cameraViewOptions) return;
    if (!obj.camera_view) return "--";
    const srcImageString = `${obj.id}full`;
    if (srcImages[srcImageString]) {
        const object = srcImages[srcImageString];
        if (obj.camera_view === "normal") return "Normal";
        else {
            let warningMessage = object.camera_view_comments;
            if ((object.camera_view_status === "warning" || !object.camera_view_status) && (obj.camera_view === "180_fisheye" || obj.camera_view === "360_fisheye")) warningMessage = $bf9098ebce5a2131$var$fishEyeWarningMessage;
            if ((object.camera_view_status === "warning" || !object.camera_view_status) && object.camera_view === "thermal") warningMessage = $bf9098ebce5a2131$var$thermalWarningMessage;
            return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                title: warningMessage,
                placement: "top",
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    children: [
                        cameraViewOptionNames.get(obj.camera_view),
                        "\xa0",
                        object.camera_view_status !== "unknown" && (object.camera_view_status === "healthy" ? (0, $lWchQ.checkedCircleIconSmall) : /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gt8Ee))), {
                            sx: {
                                color: "#F57C00"
                            },
                            fontSize: "small"
                        }))
                    ]
                })
            });
        }
    } else return "--";
};

});

parcelRegister("kPQrn", function(module, exports) {

$parcel$export(module.exports, "resizeImage", () => $2ffb84b8b3144ba3$export$b423874dd89ac031);
parcelRequire("8T3gX");
const $2ffb84b8b3144ba3$export$b423874dd89ac031 = (inputWidth, inputHeight)=>{
    if (inputWidth && inputHeight) {
        const widthStr = inputWidth;
        const heightStr = inputHeight;
        const aspectRatio = widthStr / heightStr;
        let adjustedWidth = widthStr;
        let adjustedHeight = heightStr;
        if (adjustedWidth / aspectRatio > 420) {
            adjustedWidth = 560;
            adjustedHeight = adjustedWidth / aspectRatio;
        } else {
            adjustedHeight = 420;
            adjustedWidth = adjustedHeight * aspectRatio;
        }
        if (adjustedWidth > 560) {
            adjustedWidth = 560;
            adjustedHeight = adjustedWidth / aspectRatio;
        }
        if (adjustedHeight > 420) {
            adjustedHeight = 420;
            adjustedWidth = adjustedHeight * aspectRatio;
        }
        return {
            width: adjustedWidth,
            height: adjustedHeight
        };
    } else return {
        height: 420,
        width: 560
    };
};

});

parcelRegister("3mOKt", function(module, exports) {

$parcel$export(module.exports, "integrationsMatcher", () => $ea4872cf56d7bec7$export$49ddf75a72242045);

var $3JJWq = parcelRequire("3JJWq");
const $ea4872cf56d7bec7$export$49ddf75a72242045 = (type, input)=>{
    const integrationTypes = (0, $3JJWq.safeGetItem)("integrationTypesNonOnboarding", []) ?? [];
    const integrationIds = new Map();
    const integrationNames = new Map();
    const integrationFullNames = new Map();
    integrationTypes.forEach((element)=>{
        integrationNames.set(`${element.display_name}`, element.id);
        integrationIds.set(element.id, `${element.display_name}`);
        integrationFullNames.set(`${element.name}`, `${element.display_name}`);
    });
    if (type === "Id") return integrationNames.get(input);
    else if (type === "Name") return integrationIds.get(input);
    else if (type === "FullName") return integrationFullNames.get(input);
};

});
parcelRegister("3JJWq", function(module, exports) {

$parcel$export(module.exports, "safeGetItem", () => $242097dd1cbf8937$export$9ff6d2a3beda0ecb);
/**
 * Utility functions for localStorage operations with error handling
 */ 
var $ebTQj = parcelRequire("ebTQj");
const $242097dd1cbf8937$export$d5a3bb3beb05c423 = (key, value, fallback)=>{
    try {
        const stringValue = JSON.stringify(value);
        // Check if the data is too large (localStorage typically has 5-10MB limit)
        if (stringValue.length > 4194304) {
            // 4MB limit
            (0, $ebTQj.logger).warn(`Data for key "${key}" is too large (${(stringValue.length / 1024 / 1024).toFixed(2)}MB). Skipping localStorage storage.`);
            if (fallback) fallback();
            return false;
        }
        localStorage.setItem(key, stringValue);
        return true;
    } catch (error) {
        (0, $ebTQj.logger).warn(`Failed to store data for key "${key}" in localStorage:`, error);
        if (fallback) fallback();
        return false;
    }
};
const $242097dd1cbf8937$export$9ff6d2a3beda0ecb = (key, defaultValue)=>{
    try {
        const item = localStorage.getItem(key);
        if (item === null) return defaultValue || null;
        return JSON.parse(item);
    } catch (error) {
        (0, $ebTQj.logger).warn(`Failed to retrieve data for key "${key}" from localStorage:`, error);
        return defaultValue || null;
    }
};
const $242097dd1cbf8937$export$69429c3dabd808a6 = ()=>{
    try {
        localStorage.clear();
        return true;
    } catch (error) {
        (0, $ebTQj.logger).warn("Failed to clear localStorage:", error);
        return false;
    }
};
const $242097dd1cbf8937$export$9a961999750f4343 = (key)=>{
    try {
        localStorage.removeItem(key);
        return true;
    } catch (error) {
        (0, $ebTQj.logger).warn(`Failed to remove key "${key}" from localStorage:`, error);
        return false;
    }
};

});


parcelRegister("aOOQP", function(module, exports) {

$parcel$export(module.exports, "isChmOnlyIgnoreZones", () => $fd3c3df5316001d4$export$f526581b83881d9);
const $fd3c3df5316001d4$var$IGNORE_MOTION_LABEL = "ignore motion";
const $fd3c3df5316001d4$var$CAMERA_HEALTH_MONITORING_LABEL = "camera health monitoring";
const $fd3c3df5316001d4$export$f526581b83881d9 = (zones)=>{
    if (!Array.isArray(zones) || zones.length !== 2) return false;
    const labels = zones.map((zone)=>(zone?.label_display_name || "").trim().toLowerCase()).filter((label)=>label.length > 0);
    if (labels.length !== 2) return false;
    const uniqueLabels = new Set(labels);
    return uniqueLabels.size === 2 && uniqueLabels.has($fd3c3df5316001d4$var$IGNORE_MOTION_LABEL) && uniqueLabels.has($fd3c3df5316001d4$var$CAMERA_HEALTH_MONITORING_LABEL);
};

});

parcelRegister("glcO0", function(module, exports) {

$parcel$export(module.exports, "IgnoreZonesTable", () => $bdc79ed7e7e91d9d$export$12c7612902168568);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $aVDw9 = parcelRequire("aVDw9");

var $4o6Cs = parcelRequire("4o6Cs");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $8jTCz = parcelRequire("8jTCz");

var $6pdiI = parcelRequire("6pdiI");
const $bdc79ed7e7e91d9d$export$12c7612902168568 = ({ visibleIgnoreZones: visibleIgnoreZones, onEditClick: onEditClick })=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "w-[300px] pt-[10px] z-10",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                    onClick: onEditClick,
                    text: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {
                                fontSize: "small"
                            }),
                            "\xa0Edit Ignore Zones"
                        ]
                    }),
                    disabled: false
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "pl-[5px] pt-[10px]",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                    sx: {
                        width: 300,
                        maxHeight: 320,
                        overflow: "auto"
                    },
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k8Qy8.default), {
                        sx: {
                            fontFamily: "Mulish"
                        },
                        stickyHeader: true,
                        size: "small",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                            children: visibleIgnoreZones.map((object, index)=>{
                                return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                    sx: {
                                        height: 40,
                                        borderBottom: "none"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            sx: {
                                                padding: "8px 8px",
                                                height: 40,
                                                borderBottom: "none"
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                style: {
                                                    height: 25,
                                                    width: 25,
                                                    background: `${object.line_color}`,
                                                    borderRadius: 4,
                                                    margin: "0 auto"
                                                }
                                            }, object.label)
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            sx: {
                                                fontFamily: "Mulish",
                                                padding: "8px 8px",
                                                height: 40,
                                                borderBottom: "none"
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                children: object.label_display_name
                                            })
                                        })
                                    ]
                                }, object.id);
                            })
                        })
                    })
                })
            })
        ]
    });
};

});

parcelRegister("7Ep9S", function(module, exports) {

$parcel$export(module.exports, "MetadataTagZonesTable", () => $1aaf9a3a57680de1$export$dbc2eed19b851786);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $aVDw9 = parcelRequire("aVDw9");

var $4o6Cs = parcelRequire("4o6Cs");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $8jTCz = parcelRequire("8jTCz");

var $6pdiI = parcelRequire("6pdiI");

var $cVCJe = parcelRequire("cVCJe");

var $ePwXE = parcelRequire("ePwXE");
const $1aaf9a3a57680de1$export$dbc2eed19b851786 = ({ metadataTagZones: metadataTagZones, onEditClick: onEditClick })=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "pt-[10px] w-[320px]z-10",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                    onClick: onEditClick,
                    text: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {
                                fontSize: "small"
                            }),
                            "\xa0Edit Tag Zones"
                        ]
                    }),
                    disabled: false
                })
            }),
            metadataTagZones.length > 0 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "pl-[5px] pt-[10px]",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                    sx: {
                        width: 320,
                        height: 320
                    },
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k8Qy8.default), {
                        sx: {
                            fontFamily: "Mulish"
                        },
                        stickyHeader: true,
                        size: "small",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                            children: metadataTagZones.map((object, index)=>{
                                return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                    sx: {
                                        height: 40,
                                        borderBottom: "none"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            sx: {
                                                padding: "8px 8px",
                                                height: 40,
                                                borderBottom: "none"
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                style: {
                                                    height: 25,
                                                    width: 25,
                                                    background: `${object.line_color}`,
                                                    borderRadius: 4,
                                                    margin: "0 auto"
                                                }
                                            }, object.label)
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            sx: {
                                                padding: "8px 8px",
                                                height: 40,
                                                borderBottom: "none"
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                children: [
                                                    object.name,
                                                    "\xa0",
                                                    object.description && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                        title: object.description,
                                                        placement: "top",
                                                        sx: {
                                                            fontSize: "15px",
                                                            fontFamily: "mulish"
                                                        },
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                                            fontSize: "small"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, object.id);
                            })
                        })
                    })
                })
            }),
            metadataTagZones.length === 0 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "pl-[45px] pt-[62px]",
                children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "font-mulish text-[16px]",
                    children: "No Metadata Tag Zones added"
                })
            })
        ]
    });
};

});

parcelRegister("5axmO", function(module, exports) {

$parcel$export(module.exports, "LineCrossingsOverlay", () => $f361e397d35ceed1$export$aafaf7a483d9ebe8);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");
// Calculate arrow path for a given direction
const $f361e397d35ceed1$var$getArrowPath = (centerX, centerY, perpDx, perpDy, sideMultiplier, fromCenter)=>{
    const crossingLineLength = 50;
    const halfLength = crossingLineLength / 2;
    const arrowLength = 12;
    const arrowWidth = 2 * arrowLength / Math.sqrt(3);
    // Calculate the perpendicular offset
    const offsetX = perpDx * halfLength * sideMultiplier;
    const offsetY = perpDy * halfLength * sideMultiplier;
    // Calculate the arrow tip position
    const arrowTipX = centerX + offsetX;
    const arrowTipY = centerY + offsetY;
    // Calculate where the line should end (arrowhead base)
    const arrowBaseOffsetX = perpDx * arrowLength * sideMultiplier;
    const arrowBaseOffsetY = perpDy * arrowLength * sideMultiplier;
    const lineEndX = arrowTipX - arrowBaseOffsetX;
    const lineEndY = arrowTipY - arrowBaseOffsetY;
    // Start point of the crossing line
    const crossStartX = fromCenter ? centerX : centerX - offsetX;
    const crossStartY = fromCenter ? centerY : centerY - offsetY;
    // Line path
    const linePath = `M ${crossStartX} ${crossStartY} L ${lineEndX} ${lineEndY}`;
    // Arrow head path (triangle)
    // Calculate the two base corners of the arrow
    const arrowAngle = Math.atan2(offsetY, offsetX);
    const cos = Math.cos(arrowAngle);
    const sin = Math.sin(arrowAngle);
    // Arrow base corners (perpendicular to arrow direction)
    const baseCorner1X = arrowTipX - arrowLength * cos + arrowWidth / 2 * sin;
    const baseCorner1Y = arrowTipY - arrowLength * sin - arrowWidth / 2 * cos;
    const baseCorner2X = arrowTipX - arrowLength * cos - arrowWidth / 2 * sin;
    const baseCorner2Y = arrowTipY - arrowLength * sin + arrowWidth / 2 * cos;
    const arrowPath = `M ${arrowTipX} ${arrowTipY} L ${baseCorner1X} ${baseCorner1Y} L ${baseCorner2X} ${baseCorner2Y} Z`;
    return {
        linePath: linePath,
        arrowPath: arrowPath
    };
};
const $f361e397d35ceed1$var$renderDirectionArrow = (line, index, scaledCoordinates)=>{
    const start = scaledCoordinates[0];
    const end = scaledCoordinates[1];
    const centerX = (start[0] + end[0]) / 2;
    const centerY = (start[1] + end[1]) / 2;
    const dx = end[0] - start[0];
    const dy = end[1] - start[1];
    const lineLength = Math.sqrt(dx * dx + dy * dy);
    if (lineLength === 0) return [];
    const perpDx = -dy / lineLength;
    const perpDy = dx / lineLength;
    const arrowColor = "#FF1744"; // Neon red
    const elements = [];
    if (line.direction === "AtoB") {
        const { linePath: linePath, arrowPath: arrowPath } = $f361e397d35ceed1$var$getArrowPath(centerX, centerY, perpDx, perpDy, 1, false);
        elements.push(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
            d: linePath,
            stroke: arrowColor,
            strokeWidth: 2,
            fill: "none"
        }, `line-${index}-arrow-line`), /*#__PURE__*/ (0, $k4ank.jsx)("path", {
            d: arrowPath,
            fill: arrowColor
        }, `line-${index}-arrow-head`));
    } else if (line.direction === "BtoA") {
        const { linePath: linePath, arrowPath: arrowPath } = $f361e397d35ceed1$var$getArrowPath(centerX, centerY, perpDx, perpDy, -1, false);
        elements.push(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
            d: linePath,
            stroke: arrowColor,
            strokeWidth: 2,
            fill: "none"
        }, `line-${index}-arrow-line`), /*#__PURE__*/ (0, $k4ank.jsx)("path", {
            d: arrowPath,
            fill: arrowColor
        }, `line-${index}-arrow-head`));
    } else if (line.direction === "Both") {
        const arrow1 = $f361e397d35ceed1$var$getArrowPath(centerX, centerY, perpDx, perpDy, -1, true);
        const arrow2 = $f361e397d35ceed1$var$getArrowPath(centerX, centerY, perpDx, perpDy, 1, true);
        elements.push(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
            d: arrow1.linePath,
            stroke: arrowColor,
            strokeWidth: 2,
            fill: "none"
        }, `line-${index}-arrow-line-1`), /*#__PURE__*/ (0, $k4ank.jsx)("path", {
            d: arrow1.arrowPath,
            fill: arrowColor
        }, `line-${index}-arrow-head-1`), /*#__PURE__*/ (0, $k4ank.jsx)("path", {
            d: arrow2.linePath,
            stroke: arrowColor,
            strokeWidth: 2,
            fill: "none"
        }, `line-${index}-arrow-line-2`), /*#__PURE__*/ (0, $k4ank.jsx)("path", {
            d: arrow2.arrowPath,
            fill: arrowColor
        }, `line-${index}-arrow-head-2`));
    }
    return elements;
};
const $f361e397d35ceed1$export$aafaf7a483d9ebe8 = ({ lines: lines, width: width, height: height })=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)("svg", {
        width: width,
        height: height,
        style: {
            position: "absolute",
            top: 0,
            left: 0,
            pointerEvents: "none"
        },
        children: lines.map((line, index)=>{
            // Convert percentage coordinates (0-1) to pixel coordinates
            const scaledCoordinates = [
                [
                    line.coordinates[0][0] * width,
                    line.coordinates[0][1] * height
                ],
                [
                    line.coordinates[1][0] * width,
                    line.coordinates[1][1] * height
                ]
            ];
            const x1 = scaledCoordinates[0][0];
            const y1 = scaledCoordinates[0][1];
            const x2 = scaledCoordinates[1][0];
            const y2 = scaledCoordinates[1][1];
            return /*#__PURE__*/ (0, $k4ank.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("line", {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2,
                        stroke: line.color,
                        strokeWidth: 2
                    }),
                    $f361e397d35ceed1$var$renderDirectionArrow(line, index, scaledCoordinates)
                ]
            }, `line-group-${index}`);
        })
    });
};

});

parcelRegister("dXEa5", function(module, exports) {

$parcel$export(module.exports, "useFlexIgnoreZonesCameraRow", () => $88a65f745fcb711f$export$23c38972603de205);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $7UDCh = parcelRequire("7UDCh");
var $9qNow = parcelRequire("9qNow");
var $6gU8O = parcelRequire("6gU8O");
var $cxknk = parcelRequire("cxknk");
var $2eEqG = parcelRequire("2eEqG");

var $4PFLW = parcelRequire("4PFLW");

var $eYzFO = parcelRequire("eYzFO");

var $9mFrR = parcelRequire("9mFrR");

var $qyGZG = parcelRequire("qyGZG");

var $9s9JO = parcelRequire("9s9JO");

var $6JE7U = parcelRequire("6JE7U");
function $88a65f745fcb711f$export$23c38972603de205({ siteInfo: siteInfo, obj: obj, expanded: expanded, visibleIgnoreZones: visibleIgnoreZones, allIgnoreZones: allIgnoreZones }) {
    const { isFeatureEnabled: isFeatureEnabled } = (0, $4PFLW.useFeatureFlag)();
    const showFlexIgnoreZones = isFeatureEnabled("showFlexIgnoreZones", false);
    const siteIdNum = $8T3gX.useMemo(()=>{
        const raw = siteInfo?.id;
        if (raw === undefined || raw === null || raw === "") return NaN;
        const n = Number(raw);
        return Number.isFinite(n) ? n : NaN;
    }, [
        siteInfo?.id
    ]);
    const flexIgnoreZonesEnabledForSite = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((state)=>showFlexIgnoreZones && Number.isFinite(siteIdNum) && state.enabledBySite[siteIdNum] === true);
    const hasFlexSchedule = !!siteInfo?.has_flex_schedule;
    // Require flex scheduling on the site; onboarding sync (`enabledBySite`) alone is not enough.
    const flexIgnoreZonesEnabled = flexIgnoreZonesEnabledForSite && hasFlexSchedule;
    const flexIzActive = flexIgnoreZonesEnabled;
    const loadCameraContext = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((state)=>showFlexIgnoreZones ? state.loadCameraContext : (0, $9mFrR.flexIgnoreZonesNoopLoadCameraContext));
    const presetsByCamera = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((state)=>showFlexIgnoreZones ? state.presetsByCamera : (0, $9mFrR.FLEX_IZ_LD_EMPTY_PRESETS));
    const cameraContexts = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((state)=>showFlexIgnoreZones ? state.cameraContexts : (0, $9mFrR.FLEX_IZ_LD_EMPTY_CAMERA_CONTEXTS));
    const createCustomPresetDraft = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((state)=>state.createCustomPresetDraft);
    const removeLocalPresetDraft = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((state)=>state.removeLocalPresetDraft);
    const [selectedFlexPresetLocalId, setSelectedFlexPresetLocalId] = $8T3gX.useState("");
    const [newPresetDialog, setNewPresetDialog] = $8T3gX.useState(null);
    $8T3gX.useEffect(()=>{
        if (!expanded || !flexIzActive || !obj.id) return;
        loadCameraContext(obj.id);
    }, [
        expanded,
        flexIzActive,
        obj.id,
        loadCameraContext
    ]);
    const flexPresetOptionsForCamera = $8T3gX.useMemo(()=>{
        const all = presetsByCamera[obj.id] ?? (0, $9mFrR.EMPTY_FLEX_PRESETS_LIST);
        return (0, $6JE7U.collapseNoIgnoreZonesPresetOptions)((0, $6JE7U.filterFlexPresetsForApiPresetDropdown)(all), selectedFlexPresetLocalId);
    }, [
        obj.id,
        presetsByCamera,
        selectedFlexPresetLocalId
    ]);
    $8T3gX.useEffect(()=>{
        if (!flexIzActive) {
            setSelectedFlexPresetLocalId((prev)=>prev === "" ? prev : "");
            return;
        }
        // "Default" (camera-level zones + default lines) is always available and is
        // the initial preview selection — never a preset the operator did not pick.
        if (selectedFlexPresetLocalId === "" || selectedFlexPresetLocalId === (0, $9s9JO.FLEX_IZ_DEFAULT_CAMERA_CONFIG_OPTION)) {
            if (selectedFlexPresetLocalId === "") setSelectedFlexPresetLocalId((0, $9s9JO.FLEX_IZ_DEFAULT_CAMERA_CONFIG_OPTION));
            return;
        }
        const all = presetsByCamera[obj.id] ?? (0, $9mFrR.EMPTY_FLEX_PRESETS_LIST);
        const options = flexPresetOptionsForCamera;
        const normalized = (0, $6JE7U.normalizeFlexPresetSelectionToApiBackedMenuValue)(obj.id, all, selectedFlexPresetLocalId);
        if (normalized !== selectedFlexPresetLocalId && options.some((p)=>p.localId === normalized)) {
            setSelectedFlexPresetLocalId((prev)=>prev === normalized ? prev : normalized);
            return;
        }
        const valid = options.some((p)=>p.localId === selectedFlexPresetLocalId);
        if (!valid) // A stale selection (deleted preset, discarded draft) falls back to Default,
        // not to whichever preset happens to be first in the list.
        setSelectedFlexPresetLocalId((0, $9s9JO.FLEX_IZ_DEFAULT_CAMERA_CONFIG_OPTION));
    }, [
        flexIzActive,
        obj.id,
        presetsByCamera,
        selectedFlexPresetLocalId,
        flexPresetOptionsForCamera
    ]);
    const zonesForPreview = $8T3gX.useMemo(()=>{
        if (!flexIzActive || !selectedFlexPresetLocalId) return visibleIgnoreZones;
        const presets = presetsByCamera[obj.id] ?? (0, $9mFrR.EMPTY_FLEX_PRESETS_LIST);
        const preset = selectedFlexPresetLocalId === (0, $9s9JO.FLEX_IZ_DEFAULT_CAMERA_CONFIG_OPTION) ? undefined : presets.find((p)=>p.localId === selectedFlexPresetLocalId);
        const defaultZones = cameraContexts[obj.id]?.defaultZones ?? [];
        if (!preset) // Default: the camera's own zones.
        return defaultZones.length > 0 ? defaultZones : visibleIgnoreZones;
        if (preset.localId === (0, $9s9JO.FLEX_IZ_NO_IGNORE_ZONES_OPTION)) return [];
        if (preset.zones && preset.zones.length > 0) return preset.zones;
        return [];
    }, [
        flexIzActive,
        selectedFlexPresetLocalId,
        presetsByCamera,
        cameraContexts,
        obj.id,
        visibleIgnoreZones
    ]);
    const zonesForColorSidebar = $8T3gX.useMemo(()=>{
        if (!flexIzActive) return allIgnoreZones;
        const defaultZones = cameraContexts[obj.id]?.defaultZones ?? [];
        if (defaultZones.length > 0) return defaultZones;
        return allIgnoreZones;
    }, [
        flexIzActive,
        allIgnoreZones,
        cameraContexts,
        obj.id
    ]);
    /**
   * Persisted id of the preset the picker shows, or null for Default / a draft
   * that is not saved yet. Drives which line crossings the row previews
   * (`?camera=&preset=` vs `preset__isnull=true`) and which configuration the
   * "Edit Line Crossings" link opens (ENG-1610).
   */ const selectedFlexPresetId = $8T3gX.useMemo(()=>{
        if (!flexIzActive || !selectedFlexPresetLocalId || selectedFlexPresetLocalId === (0, $9s9JO.FLEX_IZ_DEFAULT_CAMERA_CONFIG_OPTION) || selectedFlexPresetLocalId === (0, $9s9JO.FLEX_IZ_NO_IGNORE_ZONES_OPTION)) return null;
        const presets = presetsByCamera[obj.id] ?? (0, $9mFrR.EMPTY_FLEX_PRESETS_LIST);
        const preset = presets.find((p)=>p.localId === selectedFlexPresetLocalId);
        const persistedId = preset?.persistedId;
        return persistedId != null && Number.isFinite(Number(persistedId)) ? Number(persistedId) : null;
    }, [
        flexIzActive,
        selectedFlexPresetLocalId,
        presetsByCamera,
        obj.id
    ]);
    /** Name of the named preset the picker shows (null for Default / none). */ const selectedFlexPresetName = $8T3gX.useMemo(()=>{
        if (!flexIzActive || !selectedFlexPresetLocalId || selectedFlexPresetLocalId === (0, $9s9JO.FLEX_IZ_DEFAULT_CAMERA_CONFIG_OPTION)) return null;
        const presets = presetsByCamera[obj.id] ?? (0, $9mFrR.EMPTY_FLEX_PRESETS_LIST);
        return presets.find((p)=>p.localId === selectedFlexPresetLocalId)?.name ?? null;
    }, [
        flexIzActive,
        selectedFlexPresetLocalId,
        presetsByCamera,
        obj.id
    ]);
    const ignoreZonesTitleText = flexIzActive ? "Flex Ignore Zones" : "Ignore Zones";
    const ignoreZonesHeadingClassName = "font-mulish text-[16px] text-actuate-blue";
    const flexPresetsForCamera = flexPresetOptionsForCamera;
    const flexCameraCtx = cameraContexts[obj.id];
    const flexPresetSelectControl = flexIzActive && flexCameraCtx?.loading ? /*#__PURE__*/ (0, $k4ank.jsx)("p", {
        className: "font-mulish text-[12px] text-gray-600 py-[4px]",
        children: "Loading presets\u2026"
    }) : flexIzActive ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
        fullWidth: true,
        size: "small",
        sx: {
            maxWidth: 360,
            mt: "4px",
            mb: "8px"
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $6gU8O.default), {
                id: `flex-iz-preset-label-${obj.id}`,
                sx: {
                    fontFamily: "Mulish"
                },
                children: "Preset"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $2eEqG.default), {
                labelId: `flex-iz-preset-label-${obj.id}`,
                label: "Preset",
                value: selectedFlexPresetLocalId || "",
                onChange: (event)=>{
                    const nextValue = String(event.target.value);
                    if (nextValue === (0, $9s9JO.FLEX_IZ_CREATE_NEW_PRESET_OPTION)) {
                        const ctxZones = cameraContexts[obj.id]?.defaultZones;
                        const zones = ctxZones && ctxZones.length > 0 ? ctxZones : allIgnoreZones;
                        const localId = createCustomPresetDraft(obj.id, zones);
                        setNewPresetDialog({
                            cameraId: obj.id,
                            presetLocalId: localId,
                            cameraName: obj.camera_name
                        });
                        loadCameraContext(obj.id);
                        return;
                    }
                    setSelectedFlexPresetLocalId(nextValue);
                },
                sx: {
                    fontFamily: "Mulish"
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                        value: (0, $9s9JO.FLEX_IZ_DEFAULT_CAMERA_CONFIG_OPTION),
                        sx: {
                            fontFamily: "Mulish"
                        },
                        children: (0, $9s9JO.FLEX_IZ_DEFAULT_CAMERA_CONFIG_LABEL)
                    }),
                    flexPresetsForCamera.map((preset)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                            value: preset.localId,
                            sx: {
                                fontFamily: "Mulish"
                            },
                            children: preset.name
                        }, preset.localId)),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                        value: (0, $9s9JO.FLEX_IZ_CREATE_NEW_PRESET_OPTION),
                        sx: {
                            color: "#FF8400",
                            fontFamily: "Mulish",
                            fontWeight: 700
                        },
                        children: "+ CREATE NEW PRESET"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                sx: {
                    fontFamily: "Mulish",
                    mx: 0
                },
                "data-testid": `flex-iz-preset-helper-${obj.id}`,
                children: selectedFlexPresetName != null ? `Showing the zones and line crossings of \u{201C}${selectedFlexPresetName}\u{201D}. Lines and zones from other configurations are not shown.` : "Showing the camera's own zones and default line crossings."
            })
        ]
    }) : null;
    const flexPresetDialog = showFlexIgnoreZones ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $qyGZG.FlexIgnoreZonesNewPresetDialog), {
        open: newPresetDialog != null,
        cameraId: newPresetDialog?.cameraId ?? 0,
        presetLocalId: newPresetDialog?.presetLocalId ?? null,
        cameraName: newPresetDialog?.cameraName ?? "",
        assignToSchedule: false,
        onClose: (reason, meta)=>{
            if (reason === "submitted" && newPresetDialog) setSelectedFlexPresetLocalId(meta?.presetLocalId ?? newPresetDialog.presetLocalId);
            if (reason === "cancelled" && newPresetDialog) removeLocalPresetDraft(newPresetDialog.cameraId, newPresetDialog.presetLocalId);
            setNewPresetDialog(null);
        }
    }) : null;
    return {
        flexIzActive: flexIzActive,
        zonesForPreview: zonesForPreview,
        zonesForColorSidebar: zonesForColorSidebar,
        ignoreZonesTitleText: ignoreZonesTitleText,
        ignoreZonesHeadingClassName: ignoreZonesHeadingClassName,
        flexPresetSelectControl: flexPresetSelectControl,
        flexPresetDialog: flexPresetDialog,
        showFlexIgnoreZones: showFlexIgnoreZones,
        selectedFlexPresetId: selectedFlexPresetId
    };
}

});
parcelRegister("7UDCh", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c2c7e57944fe650$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $7AQZl = parcelRequire("7AQZl");

var $anJSP = parcelRequire("anJSP");

var $g0gie = parcelRequire("g0gie");

var $iMOmE = parcelRequire("iMOmE");

var $9ogDZ = parcelRequire("9ogDZ");

var $680s3 = parcelRequire("680s3");

var $4cO2q = parcelRequire("4cO2q");

var $k4ank = parcelRequire("k4ank");
'use client';
const $5c2c7e57944fe650$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $5c2c7e57944fe650$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $iMOmE.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $4cO2q.getFormControlUtilityClasses), classes);
};
const $5c2c7e57944fe650$var$FormControlRoot = (0, $anJSP.default)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $eJfrs.default)({}, styles.root, styles[`margin${(0, $iMOmE.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({
        display: 'inline-flex',
        flexDirection: 'column',
        position: 'relative',
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: 'top'
    }, ownerState.margin === 'normal' && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === 'dense' && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: '100%'
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $5c2c7e57944fe650$var$FormControl = /*#__PURE__*/ $8T3gX.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined' } = props, other = (0, $fAJB5.default)(props, $5c2c7e57944fe650$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $5c2c7e57944fe650$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $8T3gX.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $8T3gX.Children.forEach(children, (child)=>{
            if (!(0, $9ogDZ.default)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $9ogDZ.default)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $g0gie.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $8T3gX.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $8T3gX.Children.forEach(children, (child)=>{
            if (!(0, $9ogDZ.default)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $g0gie.isFilled)(child.props, true) || (0, $g0gie.isFilled)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $8T3gX.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const registeredInput = $8T3gX.useRef(false);
        registerEffect = ()=>{
            if (registeredInput.current) console.error([
                'MUI: There are multiple `InputBase` components inside a FormControl.',
                'This creates visual inconsistencies, only use one `InputBase`.'
            ].join('\n'));
            registeredInput.current = true;
            return ()=>{
                registeredInput.current = false;
            };
        };
    }
    const childContext = $8T3gX.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $680s3.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $k4ank.jsx)($5c2c7e57944fe650$var$FormControlRoot, (0, $eJfrs.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $iVyaN.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
$5c2c7e57944fe650$var$FormControl.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the component is displayed in focused state.
   */ focused: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */ hiddenLabel: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'dense',
        'none',
        'normal'
    ]),
    /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The size of the component.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'medium',
            'small'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * The variant to use.
   * @default 'outlined'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'filled',
        'outlined',
        'standard'
    ])
};
var $5c2c7e57944fe650$export$2e2bcd8739ae039 = $5c2c7e57944fe650$var$FormControl;

});
parcelRegister("9ogDZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d634417aa457ef0$export$2e2bcd8739ae039);

var $9Bcdd = parcelRequire("9Bcdd");
var $6d634417aa457ef0$export$2e2bcd8739ae039 = (0, $9Bcdd.default);

});
parcelRegister("9Bcdd", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fd10ad6c630ce64$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");
function $6fd10ad6c630ce64$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $8T3gX.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}

});


parcelRegister("4cO2q", function(module, exports) {

$parcel$export(module.exports, "getFormControlUtilityClasses", () => $30ff18ecd4cd02de$export$149c8b8bab2289d1);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $30ff18ecd4cd02de$export$149c8b8bab2289d1(slot) {
    return (0, $kfTYv.default)('MuiFormControl', slot);
}
const $30ff18ecd4cd02de$var$formControlClasses = (0, $jh2Zm.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $30ff18ecd4cd02de$export$2e2bcd8739ae039 = $30ff18ecd4cd02de$var$formControlClasses;

});


parcelRegister("9qNow", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ddcdb799ac84643$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $k1SKW = parcelRequire("k1SKW");

var $c8JM8 = parcelRequire("c8JM8");

var $anJSP = parcelRequire("anJSP");

var $iMOmE = parcelRequire("iMOmE");

var $bmAWy = parcelRequire("bmAWy");

var $7AQZl = parcelRequire("7AQZl");

var $k4ank = parcelRequire("k4ank");
'use client';
var $6ddcdb799ac84643$var$_span;
const $6ddcdb799ac84643$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $6ddcdb799ac84643$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $iMOmE.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $bmAWy.getFormHelperTextUtilityClasses), classes);
};
const $6ddcdb799ac84643$var$FormHelperTextRoot = (0, $anJSP.default)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $iMOmE.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $bmAWy.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $bmAWy.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === 'small' && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $6ddcdb799ac84643$var$FormHelperText = /*#__PURE__*/ $8T3gX.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p' } = props, other = (0, $fAJB5.default)(props, $6ddcdb799ac84643$var$_excluded);
    const muiFormControl = (0, $c8JM8.default)();
    const fcs = (0, $k1SKW.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = (0, $eJfrs.default)({}, props, {
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $6ddcdb799ac84643$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsx)($6ddcdb799ac84643$var$FormHelperTextRoot, (0, $eJfrs.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $iVyaN.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === ' ' ? $6ddcdb799ac84643$var$_span || ($6ddcdb799ac84643$var$_span = /*#__PURE__*/ (0, $k4ank.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
$6ddcdb799ac84643$var$FormHelperText.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * If `true`, the helper text should be displayed in a disabled state.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, helper text should be displayed in an error state.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the helper text should use filled classes key.
   */ filled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the helper text should use focused classes key.
   */ focused: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'dense'
    ]),
    /**
   * If `true`, the helper text should use required classes key.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * The variant to use.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'filled',
            'outlined',
            'standard'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ])
};
var $6ddcdb799ac84643$export$2e2bcd8739ae039 = $6ddcdb799ac84643$var$FormHelperText;

});
parcelRegister("bmAWy", function(module, exports) {

$parcel$export(module.exports, "getFormHelperTextUtilityClasses", () => $845e67f9a5ba45db$export$a394fa61b1d583a9);
$parcel$export(module.exports, "default", () => $845e67f9a5ba45db$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $845e67f9a5ba45db$export$a394fa61b1d583a9(slot) {
    return (0, $kfTYv.default)('MuiFormHelperText', slot);
}
const $845e67f9a5ba45db$var$formHelperTextClasses = (0, $jh2Zm.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $845e67f9a5ba45db$export$2e2bcd8739ae039 = $845e67f9a5ba45db$var$formHelperTextClasses;

});


parcelRegister("6gU8O", function(module, exports) {

$parcel$export(module.exports, "default", () => $490fc92709bd71e4$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $aYNpO = parcelRequire("aYNpO");

var $iVyaN = parcelRequire("iVyaN");

var $k1SKW = parcelRequire("k1SKW");

var $c8JM8 = parcelRequire("c8JM8");

var $lk6eW = parcelRequire("lk6eW");
var $gZlup = parcelRequire("gZlup");

var $7AQZl = parcelRequire("7AQZl");

var $iMOmE = parcelRequire("iMOmE");

var $anJSP = parcelRequire("anJSP");
var $3dQcH = parcelRequire("3dQcH");

var $jrbzU = parcelRequire("jrbzU");

var $k4ank = parcelRequire("k4ank");
'use client';
const $490fc92709bd71e4$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $490fc92709bd71e4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'normal' && `size${(0, $iMOmE.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $aYNpO.default)(slots, (0, $jrbzU.getInputLabelUtilityClasses), classes);
    return (0, $eJfrs.default)({}, classes, composedClasses);
};
const $490fc92709bd71e4$var$InputLabelRoot = (0, $anJSP.default)((0, $lk6eW.default), {
    shouldForwardProp: (prop)=>(0, $3dQcH.default)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $gZlup.default).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%'
    }, ownerState.formControl && {
        position: 'absolute',
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: 'translate(0, 20px) scale(1)'
    }, ownerState.size === 'small' && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: 'translate(0, 17px) scale(1)'
    }, ownerState.shrink && {
        transform: 'translate(0, -1.5px) scale(0.75)',
        transformOrigin: 'top left',
        maxWidth: '133%'
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            'color',
            'transform',
            'max-width'
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === 'filled' && (0, $eJfrs.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(12px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 13px) scale(1)'
    }, ownerState.shrink && (0, $eJfrs.default)({
        userSelect: 'none',
        pointerEvents: 'auto',
        transform: 'translate(12px, 7px) scale(0.75)',
        maxWidth: 'calc(133% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 4px) scale(0.75)'
    })), ownerState.variant === 'outlined' && (0, $eJfrs.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(14px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(14px, 9px) scale(1)'
    }, ownerState.shrink && {
        userSelect: 'none',
        pointerEvents: 'auto',
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: 'calc(133% - 32px)',
        transform: 'translate(14px, -9px) scale(0.75)'
    })));
const $490fc92709bd71e4$var$InputLabel = /*#__PURE__*/ $8T3gX.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $fAJB5.default)(props, $490fc92709bd71e4$var$_excluded);
    const muiFormControl = (0, $c8JM8.default)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $k1SKW.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = (0, $eJfrs.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $490fc92709bd71e4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsx)($490fc92709bd71e4$var$InputLabelRoot, (0, $eJfrs.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $iVyaN.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
$490fc92709bd71e4$var$InputLabel.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'error',
            'info',
            'primary',
            'secondary',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * If `true`, the transition animation is disabled.
   * @default false
   */ disableAnimation: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the component is disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the label is displayed in an error state.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the `input` of this label is focused.
   */ focused: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'dense'
    ]),
    /**
   * if `true`, the label will indicate that the `input` is required.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the label is shrunk.
   */ shrink: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The size of the component.
   * @default 'normal'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'normal',
            'small'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * The variant to use.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'filled',
        'outlined',
        'standard'
    ])
};
var $490fc92709bd71e4$export$2e2bcd8739ae039 = $490fc92709bd71e4$var$InputLabel;

});
parcelRegister("lk6eW", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8604e566975b7a9$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $k1SKW = parcelRequire("k1SKW");

var $c8JM8 = parcelRequire("c8JM8");

var $iMOmE = parcelRequire("iMOmE");

var $7AQZl = parcelRequire("7AQZl");

var $anJSP = parcelRequire("anJSP");

var $gZlup = parcelRequire("gZlup");

var $k4ank = parcelRequire("k4ank");
'use client';
const $f8604e566975b7a9$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $f8604e566975b7a9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $iMOmE.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $gZlup.getFormLabelUtilityClasses), classes);
};
const $f8604e566975b7a9$export$aa5bc7f8a4705b27 = (0, $anJSP.default)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $eJfrs.default)({}, styles.root, ownerState.color === 'secondary' && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        [`&.${(0, $gZlup.default).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $gZlup.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $gZlup.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $f8604e566975b7a9$var$AsteriskComponent = (0, $anJSP.default)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $gZlup.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $f8604e566975b7a9$var$FormLabel = /*#__PURE__*/ $8T3gX.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, component: component = 'label' } = props, other = (0, $fAJB5.default)(props, $f8604e566975b7a9$var$_excluded);
    const muiFormControl = (0, $c8JM8.default)();
    const fcs = (0, $k1SKW.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = (0, $eJfrs.default)({}, props, {
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $f8604e566975b7a9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsxs)($f8604e566975b7a9$export$aa5bc7f8a4705b27, (0, $eJfrs.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $iVyaN.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $k4ank.jsxs)($f8604e566975b7a9$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    }));
});
$f8604e566975b7a9$var$FormLabel.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'error',
            'info',
            'primary',
            'secondary',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * If `true`, the label should be displayed in a disabled state.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the label is displayed in an error state.
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the label should use filled classes key.
   */ filled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */ focused: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the label will indicate that the `input` is required.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $f8604e566975b7a9$export$2e2bcd8739ae039 = $f8604e566975b7a9$var$FormLabel;

});
parcelRegister("gZlup", function(module, exports) {

$parcel$export(module.exports, "getFormLabelUtilityClasses", () => $c5e3033b2de9eede$export$f7d501e40371cd17);
$parcel$export(module.exports, "default", () => $c5e3033b2de9eede$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $c5e3033b2de9eede$export$f7d501e40371cd17(slot) {
    return (0, $kfTYv.default)('MuiFormLabel', slot);
}
const $c5e3033b2de9eede$var$formLabelClasses = (0, $jh2Zm.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $c5e3033b2de9eede$export$2e2bcd8739ae039 = $c5e3033b2de9eede$var$formLabelClasses;

});


parcelRegister("jrbzU", function(module, exports) {

$parcel$export(module.exports, "getInputLabelUtilityClasses", () => $e269851ed618da6f$export$c1c4b4545ad2ea5f);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $e269851ed618da6f$export$c1c4b4545ad2ea5f(slot) {
    return (0, $kfTYv.default)('MuiInputLabel', slot);
}
const $e269851ed618da6f$var$inputLabelClasses = (0, $jh2Zm.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $e269851ed618da6f$export$2e2bcd8739ae039 = $e269851ed618da6f$var$inputLabelClasses;

});


parcelRegister("9mFrR", function(module, exports) {

$parcel$export(module.exports, "FLEX_IZ_LD_EMPTY_ENABLED_BY_SITE", () => $feeb0c1584034a00$export$8e07306f8ca23e7b);
$parcel$export(module.exports, "FLEX_IZ_LD_EMPTY_SYNC_LOADING", () => $feeb0c1584034a00$export$1f3750a80f74d8ea);
$parcel$export(module.exports, "FLEX_IZ_LD_EMPTY_PRESETS", () => $feeb0c1584034a00$export$f1e650f0ae0394b);
$parcel$export(module.exports, "FLEX_IZ_LD_EMPTY_PRESET_NAMES", () => $feeb0c1584034a00$export$c3a95bc5f791af38);
$parcel$export(module.exports, "FLEX_IZ_LD_EMPTY_CAMERA_CONTEXTS", () => $feeb0c1584034a00$export$d9701d0604e73bc7);
$parcel$export(module.exports, "FLEX_IZ_LD_EMPTY_SELECTED_CAMERAS", () => $feeb0c1584034a00$export$9771a24ee7126fc7);
$parcel$export(module.exports, "FLEX_IZ_LD_EMPTY_PRESET_ASSIGNMENTS", () => $feeb0c1584034a00$export$8765bb2c6a668738);
$parcel$export(module.exports, "FLEX_IZ_LD_EMPTY_CAMERAS", () => $feeb0c1584034a00$export$27538ccdade629ab);
$parcel$export(module.exports, "FLEX_IZ_LD_EMPTY_SCHEDULES", () => $feeb0c1584034a00$export$156988c1108c0e8c);
$parcel$export(module.exports, "EMPTY_FLEX_PRESETS_LIST", () => $feeb0c1584034a00$export$93ec6ef106ff7af8);
$parcel$export(module.exports, "flexIgnoreZonesNoopLoadCameraContext", () => $feeb0c1584034a00$export$81f0a07abba4ba97);
const $feeb0c1584034a00$export$8e07306f8ca23e7b = {};
const $feeb0c1584034a00$export$1f3750a80f74d8ea = {};
const $feeb0c1584034a00$export$f1e650f0ae0394b = {};
const $feeb0c1584034a00$export$c3a95bc5f791af38 = {};
const $feeb0c1584034a00$export$d9701d0604e73bc7 = {};
const $feeb0c1584034a00$export$9771a24ee7126fc7 = {};
const $feeb0c1584034a00$export$8765bb2c6a668738 = {};
const $feeb0c1584034a00$export$27538ccdade629ab = [];
const $feeb0c1584034a00$export$156988c1108c0e8c = [];
const $feeb0c1584034a00$export$93ec6ef106ff7af8 = [];
async function $feeb0c1584034a00$export$81f0a07abba4ba97() {}

});

parcelRegister("qyGZG", function(module, exports) {

$parcel$export(module.exports, "FlexIgnoreZonesNewPresetDialog", () => $5b969841adbb8c07$export$45758abb961a7f1d);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");
var $887xF = parcelRequire("887xF");
var $1TOOV = parcelRequire("1TOOV");

var $8jTCz = parcelRequire("8jTCz");

var $eYzFO = parcelRequire("eYzFO");

var $2OZNn = parcelRequire("2OZNn");
const $5b969841adbb8c07$export$45758abb961a7f1d = ({ open: open, scheduleId: scheduleId, cameraId: cameraId, presetLocalId: presetLocalId, cameraName: cameraName, assignToSchedule: assignToSchedule = true, showPresetNameField: showPresetNameField = true, onClose: onClose })=>{
    const { presetsByCamera: presetsByCamera, cameras: cameras, cameraContexts: cameraContexts, loadCameraContext: loadCameraContext, updatePresetName: updatePresetName, updatePresetZones: updatePresetZones, setSelectedPresetForScheduleCamera: setSelectedPresetForScheduleCamera, removeLocalPresetDraft: removeLocalPresetDraft, persistFlexPresetDraftToApi: persistFlexPresetDraftToApi } = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)();
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const preset = presetLocalId != null ? (presetsByCamera[cameraId] || []).find((p)=>p.localId === presetLocalId) : undefined;
    const cameraContext = cameraContexts[cameraId];
    const cameraSummary = cameras.find((camera)=>camera.id === cameraId);
    const fallbackPreviewUrl = (cameraSummary?.preview_url || "").trim();
    const resolvedPreviewUrl = (cameraContext?.preview?.previewUrl || fallbackPreviewUrl).trim();
    const resolvedCameraContext = resolvedPreviewUrl.length > 0 ? {
        ...cameraContext,
        preview: {
            previewUrl: resolvedPreviewUrl,
            adjustedDimensions: cameraContext?.preview?.adjustedDimensions || {
                x: 720,
                y: 405
            }
        }
    } : cameraContext;
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!open || !cameraId) return;
        loadCameraContext(cameraId, true);
    }, [
        open,
        cameraId,
        loadCameraContext
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!open) setSaving(false);
    }, [
        open
    ]);
    const handleCancel = ()=>{
        if (presetLocalId) removeLocalPresetDraft(cameraId, presetLocalId);
        onClose("cancelled");
    };
    const handleSubmit = async ()=>{
        if (showPresetNameField && !preset?.name?.trim()) {
            alert("Preset name is required.");
            return;
        }
        if (!presetLocalId) return;
        if (preset?.name?.trim()) updatePresetName(cameraId, presetLocalId, preset.name.trim());
        if (assignToSchedule && typeof scheduleId === "number") {
            setSelectedPresetForScheduleCamera(scheduleId, cameraId, presetLocalId);
            onClose("submitted", {
                presetLocalId: presetLocalId
            });
            return;
        }
        setSaving(true);
        try {
            const result = await persistFlexPresetDraftToApi(cameraId, presetLocalId);
            if (!result.ok) {
                alert(result.error);
                return;
            }
            await loadCameraContext(cameraId, true);
            onClose("submitted", {
                presetLocalId: result.newLocalId
            });
        } finally{
            setSaving(false);
        }
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: open,
        onClose: (_, reason)=>{
            if (reason === "backdropClick") handleCancel();
        },
        fullWidth: true,
        maxWidth: "xl",
        PaperProps: {
            sx: {
                fontFamily: "Mulish",
                maxHeight: "90vh"
            }
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                dividers: true,
                sx: {
                    overflow: "auto"
                },
                children: preset && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2OZNn.PresetEditorStep), {
                    cameraName: cameraName,
                    cameraContext: resolvedCameraContext,
                    preset: preset,
                    onPresetNameChange: (value)=>updatePresetName(cameraId, preset.localId, value),
                    onPresetZonesChange: (zones)=>updatePresetZones(cameraId, preset.localId, zones),
                    showPresetMeta: showPresetNameField
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                sx: {
                    fontFamily: "Mulish",
                    px: 3,
                    pb: 2
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: handleCancel,
                        text: "Cancel",
                        disabled: saving
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>void handleSubmit(),
                        text: saving ? "Saving\u2026" : "Submit",
                        disabled: !preset || saving
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("kUcVg", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3830fc9a7cead80$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $h47Cb = parcelRequire("h47Cb");

var $iMOmE = parcelRequire("iMOmE");

var $kE1sg = parcelRequire("kE1sg");

var $lHoGT = parcelRequire("lHoGT");

var $4reBM = parcelRequire("4reBM");

var $7AQZl = parcelRequire("7AQZl");

var $anJSP = parcelRequire("anJSP");

var $3ZnLf = parcelRequire("3ZnLf");

var $c5uDx = parcelRequire("c5uDx");

var $djxj8 = parcelRequire("djxj8");

var $4nWZ9 = parcelRequire("4nWZ9");

var $k4ank = parcelRequire("k4ank");
'use client';
const $f3830fc9a7cead80$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $f3830fc9a7cead80$var$DialogBackdrop = (0, $anJSP.default)((0, $djxj8.default), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $f3830fc9a7cead80$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, $iMOmE.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $iMOmE.default)(scroll)}`,
            `paperWidth${(0, $iMOmE.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $3ZnLf.getDialogUtilityClass), classes);
};
const $f3830fc9a7cead80$var$DialogRoot = (0, $anJSP.default)((0, $kE1sg.default), {
    name: 'MuiDialog',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $f3830fc9a7cead80$var$DialogContainer = (0, $anJSP.default)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $iMOmE.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({
        height: '100%',
        '@media print': {
            height: 'auto'
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.scroll === 'body' && {
        overflowY: 'auto',
        overflowX: 'hidden',
        textAlign: 'center',
        '&::after': {
            content: '""',
            display: 'inline-block',
            verticalAlign: 'middle',
            height: '100%',
            width: '0'
        }
    }));
const $f3830fc9a7cead80$var$DialogPaper = (0, $anJSP.default)((0, $4reBM.default), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $iMOmE.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $iMOmE.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        // Fix IE11 issue, to remove at some point.
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        }
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 'calc(100% - 64px)'
    }, ownerState.scroll === 'body' && {
        display: 'inline-block',
        verticalAlign: 'middle',
        textAlign: 'left' // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: 'calc(100% - 64px)'
    }, ownerState.maxWidth === 'xs' && {
        maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $3ZnLf.default).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== 'xs' && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $3ZnLf.default).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.fullWidth && {
        width: 'calc(100% - 64px)'
    }, ownerState.fullScreen && {
        margin: 0,
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        maxHeight: 'none',
        borderRadius: 0,
        [`&.${(0, $3ZnLf.default).paperScrollBody}`]: {
            margin: 0,
            maxWidth: '100%'
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $f3830fc9a7cead80$var$Dialog = /*#__PURE__*/ $8T3gX.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $4nWZ9.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onBackdropClick: onBackdropClick, onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $4reBM.default), PaperProps: PaperProps = {}, scroll: scroll = 'paper', TransitionComponent: TransitionComponent = (0, $lHoGT.default), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $fAJB5.default)(props, $f3830fc9a7cead80$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $f3830fc9a7cead80$var$useUtilityClasses(ownerState);
    const backdropClick = $8T3gX.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $h47Cb.default)(ariaLabelledbyProp);
    const dialogContextValue = $8T3gX.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsx)($f3830fc9a7cead80$var$DialogRoot, (0, $eJfrs.default)({
        className: (0, $iVyaN.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $f3830fc9a7cead80$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $eJfrs.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $k4ank.jsx)(TransitionComponent, (0, $eJfrs.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $k4ank.jsx)($f3830fc9a7cead80$var$DialogContainer, {
                className: (0, $iVyaN.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $k4ank.jsx)($f3830fc9a7cead80$var$DialogPaper, (0, $eJfrs.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $iVyaN.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $c5uDx.default).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
$f3830fc9a7cead80$var$Dialog.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The id(s) of the element(s) that describe the dialog.
   */ 'aria-describedby': (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The id(s) of the element(s) that label the dialog.
   */ 'aria-labelledby': (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */ BackdropComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * @ignore
   */ BackdropProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Dialog children, usually the included sub-components.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */ disableEscapeKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the dialog is full-screen.
   * @default false
   */ fullScreen: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'sm'
   */ maxWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'xs',
            'sm',
            'md',
            'lg',
            'xl',
            false
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */ onBackdropClick: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool.isRequired,
    /**
   * The component used to render the body of the dialog.
   * @default Paper
   */ PaperComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   * @default {}
   */ PaperProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Determine the container for scrolling the dialog.
   * @default 'paper'
   */ scroll: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'body',
        'paper'
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */ TransitionComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */ transitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number
        })
    ]),
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   */ TransitionProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
};
var $f3830fc9a7cead80$export$2e2bcd8739ae039 = $f3830fc9a7cead80$var$Dialog;

});
parcelRegister("3ZnLf", function(module, exports) {

$parcel$export(module.exports, "getDialogUtilityClass", () => $2e79800cde347498$export$2177af0aa15c34c2);
$parcel$export(module.exports, "default", () => $2e79800cde347498$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $2e79800cde347498$export$2177af0aa15c34c2(slot) {
    return (0, $kfTYv.default)('MuiDialog', slot);
}
const $2e79800cde347498$var$dialogClasses = (0, $jh2Zm.default)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $2e79800cde347498$export$2e2bcd8739ae039 = $2e79800cde347498$var$dialogClasses;

});

parcelRegister("c5uDx", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ccdb77b916ef9d0$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");
const $8ccdb77b916ef9d0$var$DialogContext = /*#__PURE__*/ $8T3gX.createContext({});
$8ccdb77b916ef9d0$var$DialogContext.displayName = 'DialogContext';
var $8ccdb77b916ef9d0$export$2e2bcd8739ae039 = $8ccdb77b916ef9d0$var$DialogContext;

});


parcelRegister("887xF", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eb4ebc7277a380d$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $9i90r = parcelRequire("9i90r");

var $k4ank = parcelRequire("k4ank");
'use client';
const $5eb4ebc7277a380d$var$_excluded = [
    "className",
    "disableSpacing"
];
const $5eb4ebc7277a380d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $9i90r.getDialogActionsUtilityClass), classes);
};
const $5eb4ebc7277a380d$var$DialogActionsRoot = (0, $anJSP.default)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({
        display: 'flex',
        alignItems: 'center',
        padding: 8,
        justifyContent: 'flex-end',
        flex: '0 0 auto'
    }, !ownerState.disableSpacing && {
        '& > :not(style) ~ :not(style)': {
            marginLeft: 8
        }
    }));
const $5eb4ebc7277a380d$var$DialogActions = /*#__PURE__*/ $8T3gX.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $fAJB5.default)(props, $5eb4ebc7277a380d$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $5eb4ebc7277a380d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsx)($5eb4ebc7277a380d$var$DialogActionsRoot, (0, $eJfrs.default)({
        className: (0, $iVyaN.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$5eb4ebc7277a380d$var$DialogActions.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */ disableSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $5eb4ebc7277a380d$export$2e2bcd8739ae039 = $5eb4ebc7277a380d$var$DialogActions;

});
parcelRegister("9i90r", function(module, exports) {

$parcel$export(module.exports, "getDialogActionsUtilityClass", () => $6c3cc7f17f70c522$export$5e57a444791c63be);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $6c3cc7f17f70c522$export$5e57a444791c63be(slot) {
    return (0, $kfTYv.default)('MuiDialogActions', slot);
}
const $6c3cc7f17f70c522$var$dialogActionsClasses = (0, $jh2Zm.default)('MuiDialogActions', [
    'root',
    'spacing'
]);
var $6c3cc7f17f70c522$export$2e2bcd8739ae039 = $6c3cc7f17f70c522$var$dialogActionsClasses;

});


parcelRegister("1TOOV", function(module, exports) {

$parcel$export(module.exports, "default", () => $162259636d7c1e17$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $eFjen = parcelRequire("eFjen");

var $6IViO = parcelRequire("6IViO");

var $k4ank = parcelRequire("k4ank");
'use client';
const $162259636d7c1e17$var$_excluded = [
    "className",
    "dividers"
];
const $162259636d7c1e17$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $eFjen.getDialogContentUtilityClass), classes);
};
const $162259636d7c1e17$var$DialogContentRoot = (0, $anJSP.default)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px'
    }, ownerState.dividers ? {
        padding: '16px 24px',
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $6IViO.default).root} + &`]: {
            paddingTop: 0
        }
    }));
const $162259636d7c1e17$var$DialogContent = /*#__PURE__*/ $8T3gX.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $fAJB5.default)(props, $162259636d7c1e17$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        dividers: dividers
    });
    const classes = $162259636d7c1e17$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsx)($162259636d7c1e17$var$DialogContentRoot, (0, $eJfrs.default)({
        className: (0, $iVyaN.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$162259636d7c1e17$var$DialogContent.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Display the top and bottom dividers.
   * @default false
   */ dividers: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $162259636d7c1e17$export$2e2bcd8739ae039 = $162259636d7c1e17$var$DialogContent;

});
parcelRegister("eFjen", function(module, exports) {

$parcel$export(module.exports, "getDialogContentUtilityClass", () => $aad3cfe173839e7d$export$61b0ee1f05fb344e);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $aad3cfe173839e7d$export$61b0ee1f05fb344e(slot) {
    return (0, $kfTYv.default)('MuiDialogContent', slot);
}
const $aad3cfe173839e7d$var$dialogContentClasses = (0, $jh2Zm.default)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $aad3cfe173839e7d$export$2e2bcd8739ae039 = $aad3cfe173839e7d$var$dialogContentClasses;

});

parcelRegister("6IViO", function(module, exports) {

$parcel$export(module.exports, "getDialogTitleUtilityClass", () => $01436878970a9b0d$export$f5d2ec7e4c47e088);
$parcel$export(module.exports, "default", () => $01436878970a9b0d$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $01436878970a9b0d$export$f5d2ec7e4c47e088(slot) {
    return (0, $kfTYv.default)('MuiDialogTitle', slot);
}
const $01436878970a9b0d$var$dialogTitleClasses = (0, $jh2Zm.default)('MuiDialogTitle', [
    'root'
]);
var $01436878970a9b0d$export$2e2bcd8739ae039 = $01436878970a9b0d$var$dialogTitleClasses;

});


parcelRegister("2OZNn", function(module, exports) {

$parcel$export(module.exports, "PresetEditorStep", () => $b16d0c32069d699a$export$73fe7ee0e89933c8);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $eejVe = parcelRequire("eejVe");

var $1o017 = parcelRequire("1o017");

var $QUu0n = parcelRequire("QUu0n");
const $b16d0c32069d699a$var$createEditableZones = (zones)=>{
    if (zones.length > 0) return zones;
    return [
        {
            zone_type: 0,
            stream_id: 0,
            stream_name: "",
            metric_id: 0,
            label: "ignore_motion",
            label_display_name: "Ignore All",
            line_color: "#FF8400",
            coordinates: []
        }
    ];
};
const $b16d0c32069d699a$var$transformCoordinates = (coords, adjustedDimensions)=>{
    return coords.map((group)=>group.map(([x, y])=>[
                x * adjustedDimensions.x,
                y * adjustedDimensions.y
            ]));
};
const $b16d0c32069d699a$export$73fe7ee0e89933c8 = ({ cameraName: cameraName, cameraContext: cameraContext, preset: preset, onPresetNameChange: onPresetNameChange, onPresetZonesChange: onPresetZonesChange, showPresetMeta: showPresetMeta = true })=>{
    const [visibleIgnoreZones, setVisibleIgnoreZones] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState($b16d0c32069d699a$var$createEditableZones(preset.zones));
    const [selectedIgnoreZone, setSelectedIgnoreZone] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState($b16d0c32069d699a$var$createEditableZones(preset.zones)[0]?.label || "");
    const visibleZonesLiveRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef([]);
    const selectedZoneLiveRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef("");
    visibleZonesLiveRef.current = visibleIgnoreZones;
    selectedZoneLiveRef.current = selectedIgnoreZone;
    const [ignorezoneEditorVisible, setIgnorezoneEditorVisible] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [, setEditsMade] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [largerMode, setLargerMode] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [iZBuilder, setIZBuilder] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
    const [previewLoadFailed, setPreviewLoadFailed] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const onPresetZonesChangeRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(onPresetZonesChange);
    const lastSyncedZonesRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef("");
    const presetNameLocked = ignorezoneEditorVisible;
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        const zones = $b16d0c32069d699a$var$createEditableZones(preset.zones);
        setVisibleIgnoreZones(zones);
        setSelectedIgnoreZone(zones[0]?.label || "");
        setIgnorezoneEditorVisible(false);
        setLargerMode(false);
    }, [
        preset.localId,
        preset.zones
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        onPresetZonesChangeRef.current = onPresetZonesChange;
    }, [
        onPresetZonesChange
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setPreviewLoadFailed(false);
    }, [
        cameraContext?.preview?.previewUrl,
        preset.localId
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        const serializedZones = JSON.stringify(visibleIgnoreZones);
        if (serializedZones === lastSyncedZonesRef.current) return;
        lastSyncedZonesRef.current = serializedZones;
        onPresetZonesChangeRef.current(visibleIgnoreZones);
    }, [
        visibleIgnoreZones
    ]);
    const handleIgnoreZoneClick = (object)=>{
        setIgnorezoneEditorVisible(true);
        localStorage.setItem("ignoreZoneColor", object.line_color);
        localStorage.setItem("ignoreZones", JSON.stringify(object.coordinates));
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!cameraContext?.preview) return;
        if (ignorezoneEditorVisible) setIZBuilder(/*#__PURE__*/ (0, $k4ank.jsx)((0, $1o017.default), {
            shapeColor: localStorage.ignoreZoneColor || "#FF8400",
            height: cameraContext.preview.adjustedDimensions.y,
            width: cameraContext.preview.adjustedDimensions.x,
            imageURL: cameraContext.preview.previewUrl,
            shapesArray: $b16d0c32069d699a$var$transformCoordinates(JSON.parse(localStorage.ignoreZones || "[]"), cameraContext.preview.adjustedDimensions),
            setIgnorezoneEditorVisible: setIgnorezoneEditorVisible,
            setEditsMade: setEditsMade,
            visibleIgnoreZones: visibleIgnoreZones,
            selectedIgnoreZone: selectedIgnoreZone,
            setVisibleIgnoreZones: setVisibleIgnoreZones,
            largerMode: largerMode,
            setLargerMode: setLargerMode,
            dimensions: cameraContext.preview.adjustedDimensions,
            setIZBuilder: setIZBuilder,
            allIgnoreZonesShown: false,
            siteSchedules: [],
            visibleIgnoreZonesLiveRef: visibleZonesLiveRef,
            selectedIgnoreZoneLiveRef: selectedZoneLiveRef
        }));
        else setIZBuilder(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
    }, [
        ignorezoneEditorVisible
    ]);
    const previewUrl = (cameraContext?.preview?.previewUrl || "").trim();
    const adjustedDimensions = cameraContext?.preview?.adjustedDimensions;
    const previewUnavailable = !cameraContext?.preview || !adjustedDimensions || previewUrl.length === 0 || previewLoadFailed;
    if (previewUnavailable) return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            showPresetMeta && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                        className: "font-mulish text-[18px] font-black pb-[10px]",
                        children: [
                            "Create Preset for ",
                            cameraName
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        fullWidth: true,
                        label: "Preset Name",
                        variant: "standard",
                        sx: {
                            width: 360
                        },
                        value: preset.name,
                        disabled: presetNameLocked,
                        onChange: (event)=>{
                            if (presetNameLocked) return;
                            onPresetNameChange(event.target.value);
                        },
                        inputProps: {
                            style: {
                                fontFamily: "Mulish"
                            }
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "font-mulish text-[14px] pt-[12px]",
                children: "Camera preview unavailable."
            })
        ]
    });
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            showPresetMeta && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                        className: "font-mulish text-[18px] font-black pb-[10px] pl-[25px]",
                        children: [
                            "Create Preset for ",
                            cameraName
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "pt-[12px] pl-[25px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                            fullWidth: true,
                            label: "Preset Name",
                            variant: "standard",
                            sx: {
                                width: 360
                            },
                            value: preset.name,
                            disabled: presetNameLocked,
                            onChange: (event)=>{
                                if (presetNameLocked) return;
                                onPresetNameChange(event.target.value);
                            },
                            inputProps: {
                                style: {
                                    fontFamily: "Mulish"
                                }
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "relative min-h-[640px] w-full",
                children: [
                    !ignorezoneEditorVisible && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "flex w-full flex-row items-start gap-6",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "shrink-0 pl-[20px] pt-[78px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "relative",
                                    style: {
                                        width: adjustedDimensions.x,
                                        height: adjustedDimensions.y
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                                            src: previewUrl,
                                            onError: ()=>setPreviewLoadFailed(true),
                                            className: "block",
                                            style: {
                                                width: `${adjustedDimensions.x}px`,
                                                height: `${adjustedDimensions.y}px`
                                            },
                                            alt: cameraName
                                        }),
                                        visibleIgnoreZones.map((object)=>/*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "absolute top-[0px] left-[0px]",
                                                children: object.coordinates[0] && object.coordinates.map((coordinates, index)=>/*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                                                        className: "absolute top-[0px] left-[0px]",
                                                        style: {
                                                            width: `${adjustedDimensions.x}px`,
                                                            height: `${adjustedDimensions.y}px`
                                                        },
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("polygon", {
                                                            points: (0, $QUu0n.pointsCreator)(coordinates, adjustedDimensions.y, adjustedDimensions.x),
                                                            stroke: object.line_color,
                                                            strokeWidth: "5",
                                                            fill: object.line_color,
                                                            fillOpacity: "50%"
                                                        })
                                                    }, `${object.label}-${index}`))
                                            }, object.label))
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "min-w-0 flex-1 pt-[70px] pl-[40px]",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "font-mulish text-[18px] font-black text-actuate-blue pb-[14px] pr-2 leading-snug",
                                        children: "Click the Ignore Zone below you'd like to edit."
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "min-h-[360px] w-full overflow-auto pr-2 pt-[20px]",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "w-full",
                                            children: visibleIgnoreZones.map((object)=>/*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                    role: "button",
                                                    tabIndex: 0,
                                                    className: "relative",
                                                    onClick: ()=>{
                                                        setSelectedIgnoreZone(object.label);
                                                        handleIgnoreZoneClick(object);
                                                        setLargerMode(false);
                                                    },
                                                    onKeyDown: (event)=>{
                                                        if (event.key === "Enter" || event.key === " ") {
                                                            setSelectedIgnoreZone(object.label);
                                                            handleIgnoreZoneClick(object);
                                                            setLargerMode(false);
                                                        }
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                            style: {
                                                                height: 25,
                                                                width: 6,
                                                                background: `${object.line_color}`
                                                            },
                                                            className: "absolute"
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                            className: "font-mulish text-[16px] indent-5",
                                                            children: object.label_display_name
                                                        }),
                                                        "\xa0"
                                                    ]
                                                }, object.label))
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "player absolute top-[25px] left-[17px] h-[200px] w-[775px]",
                        role: "button",
                        tabIndex: 0,
                        children: iZBuilder
                    })
                ]
            }),
            ignorezoneEditorVisible && !largerMode && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "relative left-[850px] top-[-555px] w-[570px] max-w-[calc(100vw-120px)] font-mulish text-[15px] text-actuate-blue pr-[20px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-bold text-[15px]",
                        children: "INSTRUCTIONS:"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-normal text-[15px] ",
                        children: "To begin creating a shape click anywhere on the image to start adding points."
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-normal text-[15px]",
                        children: "To finish creating a shape, click on the first point created."
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-normal text-[15px]",
                        children: "To modify the shape click and drag the points to the desired location."
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-normal text-[15px]",
                        children: "To add additional points to the shape, click on the line between two points."
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-normal text-[15px]",
                        children: "To create an additional shape, click anywhere on the image to start adding points."
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-normal text-[15px]",
                        children: "To delete a shape hover anywhere over the shape and click to select. Then press the delete key on your keyboard."
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-normal text-[15px]",
                        children: "To delete a single point double click on the point. This action will only work if the remaining shape will have at least 3 points."
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("eejVe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5c1d39797e3140a$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $h47Cb = parcelRequire("h47Cb");

var $dSmkj = parcelRequire("dSmkj");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $fN7FV = parcelRequire("fN7FV");

var $4ZTSw = parcelRequire("4ZTSw");

var $kdEYK = parcelRequire("kdEYK");

var $6gU8O = parcelRequire("6gU8O");

var $7UDCh = parcelRequire("7UDCh");

var $9qNow = parcelRequire("9qNow");

var $2eEqG = parcelRequire("2eEqG");

var $3iHy7 = parcelRequire("3iHy7");

var $k4ank = parcelRequire("k4ank");
'use client';
const $a5c1d39797e3140a$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $a5c1d39797e3140a$var$variantComponent = {
    standard: (0, $fN7FV.default),
    filled: (0, $4ZTSw.default),
    outlined: (0, $kdEYK.default)
};
const $a5c1d39797e3140a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $3iHy7.getTextFieldUtilityClass), classes);
};
const $a5c1d39797e3140a$var$TextFieldRoot = (0, $anJSP.default)((0, $7UDCh.default), {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $a5c1d39797e3140a$var$TextField = /*#__PURE__*/ $8T3gX.forwardRef(function TextField(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = 'outlined' } = props, other = (0, $fAJB5.default)(props, $a5c1d39797e3140a$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $a5c1d39797e3140a$var$useUtilityClasses(ownerState);
    if (select && !children) console.error('MUI: `children` must be passed when using the `TextField` component with `select`.');
    const InputMore = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore['aria-describedby'] = undefined;
    }
    const id = (0, $h47Cb.default)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $a5c1d39797e3140a$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $k4ank.jsx)(InputComponent, (0, $eJfrs.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $k4ank.jsxs)($a5c1d39797e3140a$var$TextFieldRoot, (0, $eJfrs.default)({
        className: (0, $iVyaN.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $k4ank.jsx)((0, $6gU8O.default), (0, $eJfrs.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $2eEqG.default), (0, $eJfrs.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), (0, $eJfrs.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
$a5c1d39797e3140a$var$TextField.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */ autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * @ignore
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */ FormHelperTextProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The helper text content.
   */ helperText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */ InputLabelProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */ InputProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $dSmkj.default),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */ margin: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'dense',
        'none',
        'normal'
    ]),
    /**
   * Maximum number of rows to display when multiline option is set to true.
   */ maxRows: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * Minimum number of rows to display when multiline option is set to true.
   */ minRows: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */ multiline: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Name attribute of the `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * @ignore
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * The short hint displayed in the `input` before the user enters a value.
   */ placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Number of rows to display when multiline option is set to true.
   */ rows: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * Render a [`Select`](/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */ select: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Props applied to the [`Select`](/material-ui/api/select/) element.
   */ SelectProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The size of the component.
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'medium',
            'small'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).string,
    /**
   * The value of the `input` element, required for a controlled component.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * The variant to use.
   * @default 'outlined'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'filled',
        'outlined',
        'standard'
    ])
};
var $a5c1d39797e3140a$export$2e2bcd8739ae039 = $a5c1d39797e3140a$var$TextField;

});
parcelRegister("3iHy7", function(module, exports) {

$parcel$export(module.exports, "getTextFieldUtilityClass", () => $2674d58882c3d606$export$c1bdcbaf0596aeda);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $2674d58882c3d606$export$c1bdcbaf0596aeda(slot) {
    return (0, $kfTYv.default)('MuiTextField', slot);
}
const $2674d58882c3d606$var$textFieldClasses = (0, $jh2Zm.default)('MuiTextField', [
    'root'
]);
var $2674d58882c3d606$export$2e2bcd8739ae039 = $2674d58882c3d606$var$textFieldClasses;

});


parcelRegister("1o017", function(module, exports) {

$parcel$export(module.exports, "default", () => $1998cf010d75306a$export$2e2bcd8739ae039);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $dPkR1 = parcelRequire("dPkR1");

var $8jTCz = parcelRequire("8jTCz");

var $cpJfj = parcelRequire("cpJfj");

var $3baw3 = parcelRequire("3baw3");

var $ddLR4 = parcelRequire("ddLR4");

var $kbChx = parcelRequire("kbChx");

var $QUu0n = parcelRequire("QUu0n");

var $83bsI = parcelRequire("83bsI");

var $eAYze = parcelRequire("eAYze");

var $6NUqI = parcelRequire("6NUqI");
const $1998cf010d75306a$var$IgnoreZoneBuilder = ({ shapeColor: shapeColor, shapesArray: shapesArray = [], height: height, width: width, imageURL: imageURL, setIgnorezoneEditorVisible: setIgnorezoneEditorVisible, setEditsMade: setEditsMade, visibleIgnoreZones: visibleIgnoreZones, selectedIgnoreZone: selectedIgnoreZone, setVisibleIgnoreZones: setVisibleIgnoreZones, largerMode: largerMode, setLargerMode: setLargerMode, dimensions: dimensions, setIZBuilder: setIZBuilder, allIgnoreZonesShown: allIgnoreZonesShown, siteSchedules: siteSchedules, hideActionButtons: hideActionButtons = false, externalSaveSignal: externalSaveSignal, externalCancelSignal: externalCancelSignal, visibleIgnoreZonesLiveRef: visibleIgnoreZonesLiveRef, selectedIgnoreZoneLiveRef: selectedIgnoreZoneLiveRef })=>{
    const zonesForSave = ()=>visibleIgnoreZonesLiveRef?.current ?? visibleIgnoreZones;
    const selectedZoneForSave = ()=>selectedIgnoreZoneLiveRef?.current ?? selectedIgnoreZone;
    const [shapes, setShapes] = (0, $8T3gX.useState)(shapesArray || []);
    const [selectedShapeIndex, setSelectedShapeIndex] = (0, $8T3gX.useState)(null);
    const [polygonDrawer, setPolygonDrawer] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
    const [imageHeight, setImageHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(height);
    const [imageWidth, setImageWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(width);
    const [iZpolygonPoints, setIZPolygonPoints] = (0, $8T3gX.useState)([]);
    const [showAllIgnoreZones, setShowAllIgnoreZones] = (0, $8T3gX.useState)(allIgnoreZonesShown);
    const [clickedSchedulesTab, setClickedSchedulesTab] = (0, $8T3gX.useState)("one");
    const shapesSizeIncreaser = (shapes)=>{
        // Increase the size of the shapes by 1.5
        return shapes.map((shape)=>{
            return shape.map((point)=>{
                return point.map((coord)=>coord * 1.5);
            });
        });
    };
    const polygonPointsShapesIncreaser = (polygonPoints)=>{
        // Increase the size of the shapes by 1.5
        setIZPolygonPoints(polygonPoints.map((point)=>{
            return point.map((coord)=>coord * 1.5);
        }));
        return polygonPoints.map((point)=>{
            return point.map((coord)=>coord * 1.5);
        });
    };
    const polygonPointsShapesDecreaser = (polygonPoints)=>{
        setIZPolygonPoints(polygonPoints.map((point)=>{
            return point.map((coord)=>coord / 1.5);
        }));
        return polygonPoints.map((point)=>{
            return point.map((coord)=>coord / 1.5);
        });
    };
    const apiPointsCreator = (points)=>{
        return points.map((polygon)=>polygon.map(([x, y])=>[
                    x / width,
                    y / height
                ]));
    };
    // const apiPointsCreatorLarger = (points: number[][][]) => {
    //   return points.map((polygon) =>
    //     polygon.map(([x, y]) => [x / 1.5 / width, y / 1.5 / height])
    //   );
    // };
    const shapesSizeDecreaser = (shapes)=>{
        // Decrease the size of the shapes by 1.5
        return shapes.map((shape)=>{
            return shape.map((point)=>{
                return point.map((coord)=>coord / 1.5);
            });
        });
    };
    (0, $8T3gX.useEffect)(()=>{
        if (shapesArray && shapesArray.length > 0) setShapes(shapesArray);
    }, [
        shapesArray
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setPolygonDrawer(/*#__PURE__*/ (0, $k4ank.jsx)((0, $dPkR1.PolygonDrawer), {
            initialPoints: [],
            shapes: (0, $eAYze.handleIncrementPointsBy30)(shapes),
            shapeColor: shapeColor,
            setShapes: setShapes,
            imageHeight: imageHeight,
            imageWidth: imageWidth,
            setIZPolygonPoints: setIZPolygonPoints
        }));
    }, []);
    const handleMakeLarger = ()=>{
        setPolygonDrawer(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
        setIZBuilder(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
        setLargerMode(true);
        setTimeout(()=>{
            setIZBuilder(/*#__PURE__*/ (0, $k4ank.jsx)($1998cf010d75306a$var$IgnoreZoneBuilder, {
                shapeColor: localStorage.ignoreZoneColor,
                height: imageHeight * 1.5,
                width: imageWidth * 1.5,
                imageURL: imageURL,
                shapesArray: shapesSizeIncreaser([
                    ...shapes,
                    iZpolygonPoints.map((numArray)=>numArray.map((num)=>num - 30))
                ]),
                setIgnorezoneEditorVisible: setIgnorezoneEditorVisible,
                setEditsMade: setEditsMade,
                visibleIgnoreZones: zonesForSave(),
                selectedIgnoreZone: selectedZoneForSave(),
                setVisibleIgnoreZones: setVisibleIgnoreZones,
                largerMode: true,
                setLargerMode: setLargerMode,
                dimensions: dimensions,
                setIZBuilder: setIZBuilder,
                allIgnoreZonesShown: showAllIgnoreZones,
                siteSchedules: siteSchedules,
                visibleIgnoreZonesLiveRef: visibleIgnoreZonesLiveRef,
                selectedIgnoreZoneLiveRef: selectedIgnoreZoneLiveRef
            }));
        }, 100);
    };
    const handleMakeSmaller = ()=>{
        setPolygonDrawer(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
        setIZBuilder(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
        setLargerMode(false);
        setTimeout(()=>{
            setIZBuilder(/*#__PURE__*/ (0, $k4ank.jsx)($1998cf010d75306a$var$IgnoreZoneBuilder, {
                shapeColor: localStorage.ignoreZoneColor,
                height: imageHeight / 1.5,
                width: imageWidth / 1.5,
                imageURL: imageURL,
                shapesArray: shapesSizeDecreaser([
                    ...shapes,
                    iZpolygonPoints.map((numArray)=>numArray.map((num)=>num - 30))
                ]),
                setIgnorezoneEditorVisible: setIgnorezoneEditorVisible,
                setEditsMade: setEditsMade,
                visibleIgnoreZones: zonesForSave(),
                selectedIgnoreZone: selectedZoneForSave(),
                setVisibleIgnoreZones: setVisibleIgnoreZones,
                largerMode: false,
                setLargerMode: setLargerMode,
                dimensions: dimensions,
                setIZBuilder: setIZBuilder,
                allIgnoreZonesShown: showAllIgnoreZones,
                siteSchedules: siteSchedules,
                visibleIgnoreZonesLiveRef: visibleIgnoreZonesLiveRef,
                selectedIgnoreZoneLiveRef: selectedIgnoreZoneLiveRef
            }));
        }, 100);
    };
    const handleClearAll = ()=>{
        setPolygonDrawer(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
        setShapes([]);
        setSelectedShapeIndex(null);
        setIZPolygonPoints([]);
        setIZBuilder(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
        setTimeout(()=>{
            setIZBuilder(/*#__PURE__*/ (0, $k4ank.jsx)($1998cf010d75306a$var$IgnoreZoneBuilder, {
                shapeColor: localStorage.ignoreZoneColor,
                height: imageHeight,
                width: imageWidth,
                imageURL: imageURL,
                shapesArray: [],
                setIgnorezoneEditorVisible: setIgnorezoneEditorVisible,
                setEditsMade: setEditsMade,
                visibleIgnoreZones: zonesForSave(),
                selectedIgnoreZone: selectedZoneForSave(),
                setVisibleIgnoreZones: setVisibleIgnoreZones,
                largerMode: largerMode,
                setLargerMode: setLargerMode,
                dimensions: dimensions,
                setIZBuilder: setIZBuilder,
                allIgnoreZonesShown: showAllIgnoreZones,
                siteSchedules: siteSchedules,
                visibleIgnoreZonesLiveRef: visibleIgnoreZonesLiveRef,
                selectedIgnoreZoneLiveRef: selectedIgnoreZoneLiveRef
            }));
        }, 1);
    };
    const handleCancel = ()=>{
        setIgnorezoneEditorVisible(false);
    };
    const handleSaveEdits = ()=>{
        setIgnorezoneEditorVisible(false);
        setEditsMade(true);
        const updatedVisibleIgnoreZones = [];
        const updatedIZPolygonPoints = iZpolygonPoints.map((array)=>{
            return array.map((num)=>num - 30);
        });
        const updatedShapes = [
            ...shapes,
            updatedIZPolygonPoints
        ];
        const shapesObject = apiPointsCreator(updatedShapes);
        zonesForSave().forEach((object)=>{
            if (object.label === selectedZoneForSave() && shapesObject) {
                const updatedCoordinates = [];
                for(const key in shapesObject)updatedCoordinates.push(shapesObject[key]);
                object.coordinates = (0, $6NUqI.dedupePolygons)(updatedCoordinates);
                updatedVisibleIgnoreZones.push(object);
            } else if (object.label !== selectedZoneForSave() && shapesObject) updatedVisibleIgnoreZones.push(object);
        });
        setVisibleIgnoreZones((0, $83bsI.addIgnoreLabel)(updatedVisibleIgnoreZones));
    };
    const previousExternalSaveSignal = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(externalSaveSignal);
    const previousExternalCancelSignal = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(externalCancelSignal);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (externalSaveSignal !== undefined && previousExternalSaveSignal.current !== undefined && externalSaveSignal !== previousExternalSaveSignal.current) handleSaveEdits();
        previousExternalSaveSignal.current = externalSaveSignal;
    }, [
        externalSaveSignal
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (externalCancelSignal !== undefined && previousExternalCancelSignal.current !== undefined && externalCancelSignal !== previousExternalCancelSignal.current) handleCancel();
        previousExternalCancelSignal.current = externalCancelSignal;
    }, [
        externalCancelSignal
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "font-mulish",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                        sx: {
                            fontFamily: "Mulish"
                        },
                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                            color: "warning",
                            defaultChecked: largerMode,
                            disabled: false,
                            onChange: (event)=>{
                                if (event.target.checked) {
                                    handleMakeLarger();
                                    setLargerMode(true);
                                } else {
                                    handleMakeSmaller();
                                    setLargerMode(false);
                                }
                            }
                        }),
                        label: "Larger Mode"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                        sx: {
                            fontFamily: "Mulish",
                            color: "#001943"
                        },
                        label: "Show All Ignore Zones",
                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                            checked: showAllIgnoreZones,
                            color: "primary",
                            onChange: (event, result)=>{
                                if (result === true) setShowAllIgnoreZones(true);
                                else setShowAllIgnoreZones(false);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                style: {
                    marginBottom: "10px"
                }
            }),
            showAllIgnoreZones && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "absolute top-[60px] left-[10px]",
                children: visibleIgnoreZones.filter((object)=>object.line_color !== shapeColor).map((object)=>{
                    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-[0px]",
                        children: object.coordinates[0] && object.coordinates.map((array, index)=>{
                            return /*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                                className: "absolute top-[0px]",
                                style: {
                                    width: `${imageWidth + 30}px`,
                                    height: `${imageHeight + 30}px`
                                },
                                children: dimensions && /*#__PURE__*/ (0, $k4ank.jsx)("polygon", {
                                    points: (0, $QUu0n.pointsCreatorPlus30)(object.coordinates[index], imageHeight, imageWidth),
                                    stroke: object.line_color,
                                    strokeWidth: "5",
                                    fill: object.line_color,
                                    fillOpacity: "50%"
                                })
                            }, index);
                        })
                    }, object.label);
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                style: {
                    padding: "8px",
                    borderRadius: "4px",
                    backgroundColor: "white",
                    display: "inline-block"
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute",
                        children: polygonDrawer
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "pt-[30px] pl-[30px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                            width: imageWidth,
                            height: imageHeight,
                            style: {
                                backgroundImage: `url(${imageURL})`,
                                backgroundSize: `${imageWidth}px ${imageHeight}px`
                            },
                            children: shapes.map((shape, i)=>/*#__PURE__*/ (0, $k4ank.jsx)("polygon", {
                                    points: shape.map((point)=>point.join(",")).join(" "),
                                    fill: i === selectedShapeIndex ? shapeColor : `${shapeColor}40`,
                                    stroke: shapeColor,
                                    strokeWidth: 2
                                }, i))
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "pt-[40px] pl-[20px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            onClick: handleClearAll,
                            text: "Clear All",
                            disabled: false
                        })
                    }),
                    showAllIgnoreZones && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute pt-[20px] flex w-[1200px] overflow-scroll",
                        children: visibleIgnoreZones.map((object)=>{
                            return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "pr-[35px] cursor-default min-w-[100px]",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        style: {
                                            height: 25,
                                            width: 6,
                                            background: `${object.line_color}`,
                                            cursor: "default"
                                        },
                                        className: "absolute cursor-default"
                                    }, object.label),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "font-mulish text-[14px] indent-5 cursor-default",
                                        children: object.label_display_name
                                    }),
                                    "\xa0"
                                ]
                            }, object.label);
                        })
                    })
                ]
            }),
            !hideActionButtons && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: `absolute top-[0px] right-[200px]`,
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            onClick: handleCancel,
                            text: "Cancel",
                            disabled: false
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: `absolute top-[0px] right-[40px]`,
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cpJfj.ActuateButton), {
                            onClick: handleSaveEdits,
                            text: "Save Edits",
                            disabled: false
                        })
                    })
                ]
            })
        ]
    });
};
var $1998cf010d75306a$export$2e2bcd8739ae039 = $1998cf010d75306a$var$IgnoreZoneBuilder;

});
parcelRegister("dPkR1", function(module, exports) {

$parcel$export(module.exports, "PolygonDrawer", () => $77ed830ea585e61d$export$e19799e6d95a4459);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $eAYze = parcelRequire("eAYze");
/** Preset / API zones may include empty or malformed coordinate pairs; skip them safely. */ function $77ed830ea585e61d$var$isValidPolygonVertex(p) {
    return Array.isArray(p) && p.length >= 2 && typeof p[0] === "number" && typeof p[1] === "number" && Number.isFinite(p[0]) && Number.isFinite(p[1]);
}
const $77ed830ea585e61d$export$e19799e6d95a4459 = ({ initialPoints: initialPoints, shapes: shapes, shapeColor: shapeColor, setShapes: setShapes, imageHeight: imageHeight, imageWidth: imageWidth, setIZPolygonPoints: setIZPolygonPoints })=>{
    const canvasRef = (0, $8T3gX.useRef)(null);
    const [polygonPoints, setPolygonPoints] = (0, $8T3gX.useState)(initialPoints[0] ? initialPoints : []);
    const [drawing, setDrawing] = (0, $8T3gX.useState)(false);
    const [closed, setClosed] = (0, $8T3gX.useState)(initialPoints[0] ? true : false);
    const [dragging, setDragging] = (0, $8T3gX.useState)(false);
    const [selectedPointIndex, setSelectedPointIndex] = (0, $8T3gX.useState)(null);
    const [hoveredPointIndex, setHoveredPointIndex] = (0, $8T3gX.useState)(null);
    const [hoveredLineIndex, setHoveredLineIndex] = (0, $8T3gX.useState)(null);
    const [hoveredShapeIndex, setHoveredShapeIndex] = (0, $8T3gX.useState)(null);
    const [cursorType, setCursorType] = (0, $8T3gX.useState)("crosshair");
    const [shapesArray, setShapesArray] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(shapes);
    const [mousePosition, setMousePosition] = (0, $8T3gX.useState)(null);
    const padding = 20;
    const isPointInPolygon = (polygonPoints, point, index)=>{
        const [x, y] = point;
        let isInside = false;
        let j = polygonPoints.length - 1;
        // const updatedPolygonPoints = polygonPoints.map(([x, y]) => [x + 172, y + 110]);
        for(let i = 0; i < polygonPoints.length; i++){
            const pi = polygonPoints[i];
            const pj = polygonPoints[j];
            if (!$77ed830ea585e61d$var$isValidPolygonVertex(pi) || !$77ed830ea585e61d$var$isValidPolygonVertex(pj)) {
                j = i;
                continue;
            }
            const [xi, yi] = pi;
            const [xj, yj] = pj;
            const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
            if (intersect) isInside = !isInside;
            j = i;
        }
        if (!dragging && isInside && hoveredShapeIndex !== index) setHoveredShapeIndex(index);
        if (!isInside && hoveredShapeIndex === index && !dragging && !hoveredPointIndex) setHoveredShapeIndex(null);
    };
    (0, $8T3gX.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Backspace") {
                if (closed) {
                    //delete the the polygon that is currently displaying the polygonPoints
                    setPolygonPoints([]);
                    setIZPolygonPoints([]);
                    const updatedShapes = [
                        ...shapesArray.filter((shape)=>shape !== polygonPoints)
                    ];
                    setShapes((0, $eAYze.handleDecreasePointsBy30)(updatedShapes));
                    setShapesArray([
                        ...shapesArray.filter((shape)=>shape !== polygonPoints)
                    ]);
                    setHoveredShapeIndex(null);
                    setHoveredLineIndex(null);
                    setHoveredPointIndex(null);
                    setClosed(false);
                }
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return ()=>{
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        selectedPointIndex,
        hoveredShapeIndex,
        polygonPoints,
        shapesArray,
        setShapes
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (hoveredPointIndex === null && hoveredLineIndex === null && hoveredShapeIndex === null) setCursorType("crosshair");
        else setCursorType("pointer");
    }, [
        hoveredLineIndex,
        hoveredPointIndex,
        hoveredShapeIndex
    ]);
    (0, $8T3gX.useEffect)(()=>{
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext("2d");
        if (!ctx) return;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        if (polygonPoints && polygonPoints.length > 0) {
            const validForPath = polygonPoints.filter($77ed830ea585e61d$var$isValidPolygonVertex);
            if (closed && validForPath.length >= 2) {
                if (hoveredShapeIndex !== null) {
                    const shapesArrayToUpdate = shapesArray;
                    shapesArrayToUpdate[hoveredShapeIndex] = polygonPoints;
                    setShapesArray(shapesArrayToUpdate);
                }
                ctx.fillStyle = `${shapeColor}50`;
                ctx.beginPath();
                ctx.moveTo(validForPath[0][0], validForPath[0][1]);
                for(let i = 1; i < validForPath.length; i++)ctx.lineTo(validForPath[i][0], validForPath[i][1]);
                ctx.closePath();
                ctx.fill();
            }
            ctx.strokeStyle = shapeColor;
            ctx.lineWidth = 2;
            ctx.beginPath();
            if (validForPath.length > 1) {
                ctx.moveTo(validForPath[0][0], validForPath[0][1]);
                for(let i = 1; i < validForPath.length; i++)ctx.lineTo(validForPath[i][0], validForPath[i][1]);
                if (closed) ctx.closePath();
            }
            ctx.stroke();
            for(let i = 0; i < polygonPoints.length; i++){
                const pt = polygonPoints[i];
                if (!$77ed830ea585e61d$var$isValidPolygonVertex(pt)) continue;
                const [x, y] = pt;
                ctx.beginPath();
                ctx.arc(x, y, 5, 0, Math.PI * 2);
                ctx.fillStyle = selectedPointIndex === i ? "red" : hoveredPointIndex === i ? "#001943" : "#FF8400";
                ctx.fill();
            }
            if (closed && hoveredLineIndex !== null && !dragging && polygonPoints.length > 0) {
                const start = polygonPoints[hoveredLineIndex];
                const end = polygonPoints[(hoveredLineIndex + 1) % polygonPoints.length];
                if ($77ed830ea585e61d$var$isValidPolygonVertex(start) && $77ed830ea585e61d$var$isValidPolygonVertex(end)) {
                    const [startX, startY] = start;
                    const [endX, endY] = end;
                    ctx.beginPath();
                    ctx.moveTo(startX, startY);
                    ctx.lineTo(endX, endY);
                    ctx.strokeStyle = "red";
                    ctx.stroke();
                }
            }
            if (!closed && mousePosition && polygonPoints.length > 0 && !drawing) {
                const last = polygonPoints[polygonPoints.length - 1];
                if (!$77ed830ea585e61d$var$isValidPolygonVertex(last)) ;
                else {
                    const [lastX, lastY] = last;
                    let [mouseX, mouseY] = mousePosition;
                    if (mouseX < 30) mouseX = 30;
                    if (mouseX > imageWidth + 30) mouseX = imageWidth + 30;
                    if (mouseY < 30) mouseY = 30;
                    if (mouseY > imageHeight + 30) mouseY = imageHeight + 30;
                    ctx.beginPath();
                    ctx.moveTo(lastX, lastY);
                    ctx.lineTo(mouseX, mouseY);
                    ctx.strokeStyle = shapeColor;
                    ctx.lineWidth = 1;
                    ctx.stroke();
                }
            }
        }
    }, [
        polygonPoints,
        closed,
        selectedPointIndex,
        hoveredLineIndex,
        dragging,
        hoveredPointIndex,
        mousePosition
    ]);
    const handleMouseDown = (e)=>{
        const canvas = canvasRef.current;
        if (!canvas) return;
        const rect = canvas.getBoundingClientRect();
        let mouseX = e.clientX - rect.left;
        let mouseY = e.clientY - rect.top;
        if (mouseX < 30) mouseX = 30;
        if (mouseX > imageWidth + 30) mouseX = imageWidth + 30;
        if (mouseY < 30) mouseY = 30;
        if (mouseY > imageHeight + 30) mouseY = imageHeight + 30;
        const firstPoint = polygonPoints[0];
        if (!closed) {
            if (hoveredShapeIndex !== null) {
                setPolygonPoints(shapesArray[hoveredShapeIndex]);
                setIZPolygonPoints(shapesArray[hoveredShapeIndex]);
                const updatedShapes = [
                    ...shapesArray.filter((shape, index)=>index !== hoveredShapeIndex)
                ];
                setShapes((0, $eAYze.handleDecreasePointsBy30)(updatedShapes));
                setHoveredShapeIndex(null);
                setClosed(true);
                return;
            }
            if (!drawing && polygonPoints.length > 2 && $77ed830ea585e61d$var$isValidPolygonVertex(firstPoint) && Math.abs(firstPoint[0] - mouseX) < 5 && Math.abs(firstPoint[1] - mouseY) < 5) {
                setHoveredShapeIndex(shapesArray.length);
                setShapesArray([
                    ...shapesArray,
                    polygonPoints
                ]);
                setClosed(true);
                return;
            }
            if (!drawing) {
                setDrawing(true);
                setPolygonPoints([
                    ...polygonPoints,
                    [
                        mouseX,
                        mouseY
                    ]
                ]);
                setIZPolygonPoints([
                    ...polygonPoints,
                    [
                        mouseX,
                        mouseY
                    ]
                ]);
            }
        } else {
            if (hoveredShapeIndex !== null && hoveredLineIndex === null && hoveredPointIndex === null) {
                if (polygonPoints === shapesArray[hoveredShapeIndex]) return;
            }
            const clickedPointIndex = polygonPoints.findIndex((pt)=>$77ed830ea585e61d$var$isValidPolygonVertex(pt) && Math.abs(pt[0] - mouseX) < 5 && Math.abs(pt[1] - mouseY) < 5);
            if (clickedPointIndex !== -1) {
                setDragging(true);
                setSelectedPointIndex(clickedPointIndex);
                setHoveredLineIndex(null); // Clear the hovered line index when a point is clicked
                //set the hoveredShapeIndex to the index of the shape from the shapesArray that is closest to the clicked point
                setHoveredShapeIndex(shapesArray.findIndex((shape)=>shape === polygonPoints));
            }
            if (hoveredShapeIndex !== null) {
                if (polygonPoints === shapesArray[hoveredShapeIndex]) return;
                const updatedShapes = [
                    ...shapesArray.filter((shape, index)=>index !== hoveredShapeIndex),
                    polygonPoints
                ];
                setShapes((0, $eAYze.handleDecreasePointsBy30)(updatedShapes));
                setPolygonPoints(shapesArray[hoveredShapeIndex]);
                setIZPolygonPoints(shapesArray[hoveredShapeIndex]);
            }
            if (hoveredShapeIndex === null && hoveredLineIndex === null && hoveredPointIndex === null) {
                setShapes((0, $eAYze.handleDecreasePointsBy30)(shapesArray));
                setPolygonPoints([]);
                setIZPolygonPoints([]);
                setClosed(false);
                setDrawing(true);
                setPolygonPoints([
                    [
                        mouseX,
                        mouseY
                    ]
                ]);
                setIZPolygonPoints([
                    [
                        mouseX,
                        mouseY
                    ]
                ]);
            }
        }
    };
    const handleMouseMove = (e)=>{
        const canvas = canvasRef.current;
        if (canvas) {
            const rect1 = canvas.getBoundingClientRect();
            let mouseX1 = e.clientX - rect1.left;
            let mouseY1 = e.clientY - rect1.top;
            if (mouseX1 < 30) mouseX1 = 30;
            if (mouseX1 > imageWidth + 30) mouseX1 = imageWidth + 30;
            if (mouseY1 < 30) mouseY1 = 30;
            if (mouseY1 > imageHeight + 30) mouseY1 = imageHeight + 30;
            shapesArray.forEach((shape, index)=>{
                isPointInPolygon(shape, [
                    mouseX1,
                    mouseY1
                ], index);
            });
            if (!closed && !dragging) setMousePosition([
                mouseX1,
                mouseY1
            ]);
        }
        if (drawing && !closed && !dragging) {
            if (!canvas) return;
            const rect = canvas.getBoundingClientRect();
            let mouseX = e.clientX - rect.left;
            let mouseY = e.clientY - rect.top;
            if (mouseX < 30) mouseX = 30;
            if (mouseX > imageWidth + 30) mouseX = imageWidth + 30;
            if (mouseY < 30) mouseY = 30;
            if (mouseY > imageHeight + 30) mouseY = imageHeight + 30;
            setPolygonPoints([
                ...polygonPoints.slice(0, -1),
                [
                    mouseX,
                    mouseY
                ]
            ]);
            setIZPolygonPoints([
                ...polygonPoints.slice(0, -1),
                [
                    mouseX,
                    mouseY
                ]
            ]);
        } else if (dragging) {
            const canvas = canvasRef.current;
            if (!canvas) return;
            const rect = canvas.getBoundingClientRect();
            let mouseX = e.clientX - rect.left;
            let mouseY = e.clientY - rect.top;
            if (mouseX < 30) mouseX = 30;
            if (mouseX > imageWidth + 30) mouseX = imageWidth + 30;
            if (mouseY < 30) mouseY = 30;
            if (mouseY > imageHeight + 30) mouseY = imageHeight + 30;
            const updatedPoints = [
                ...polygonPoints
            ];
            updatedPoints[selectedPointIndex] = [
                mouseX,
                mouseY
            ];
            setPolygonPoints(updatedPoints);
            setIZPolygonPoints(updatedPoints);
            if (hoveredShapeIndex !== null) {
                const shapesArrayToUpdate = shapesArray;
                shapesArrayToUpdate[hoveredShapeIndex] = updatedPoints;
                setShapesArray(shapesArrayToUpdate);
            }
        } else if (closed && polygonPoints.length > 0) {
            const canvas = canvasRef.current;
            if (!canvas) return;
            const rect = canvas.getBoundingClientRect();
            let mouseX = e.clientX - rect.left;
            let mouseY = e.clientY - rect.top;
            if (mouseX < 30) mouseX = 30;
            if (mouseX > imageWidth + 30) mouseX = imageWidth + 30;
            if (mouseY < 30) mouseY = 30;
            if (mouseY > imageHeight + 30) mouseY = imageHeight;
            const lineIndex = polygonPoints.findIndex((_, index)=>{
                const p1 = polygonPoints[index];
                const p2 = polygonPoints[(index + 1) % polygonPoints.length];
                if (!$77ed830ea585e61d$var$isValidPolygonVertex(p1) || !$77ed830ea585e61d$var$isValidPolygonVertex(p2)) return false;
                const [x1, y1] = p1;
                const [x2, y2] = p2;
                // Vector from first point of the line to the second
                const dx = x2 - x1;
                const dy = y2 - y1;
                const segmentLengthSquared = dx * dx + dy * dy;
                // If the segment is a point (both endpoints are the same)
                if (segmentLengthSquared === 0) return false;
                // Calculate the projection of the mouse onto the line segment
                const t = ((mouseX - x1) * dx + (mouseY - y1) * dy) / segmentLengthSquared;
                // Clamp the projection to stay within the segment bounds (0 <= t <= 1)
                const clampedT = Math.max(0, Math.min(1, t));
                // Compute the closest point on the line segment
                const closestX = x1 + clampedT * dx;
                const closestY = y1 + clampedT * dy;
                // Calculate the distance between the mouse and the closest point on the line
                const distanceToLine = Math.hypot(mouseX - closestX, mouseY - closestY);
                // Return true if the mouse is within 5px of the line segment
                return distanceToLine < 5;
            });
            const pointIndex = polygonPoints.findIndex((pt)=>$77ed830ea585e61d$var$isValidPolygonVertex(pt) && Math.abs(pt[0] - mouseX) < 5 && Math.abs(pt[1] - mouseY) < 5);
            if (lineIndex !== -1) {
                if (pointIndex !== -1) {
                    setHoveredLineIndex(null);
                    setHoveredPointIndex(pointIndex);
                } else {
                    setHoveredLineIndex(lineIndex);
                    setHoveredPointIndex(null);
                }
            } else {
                setHoveredLineIndex(null); // Clear the hovered line index when no line is hovered
                setHoveredPointIndex(null);
            }
        }
    };
    const handleMouseUp = ()=>{
        if (drawing && !closed) setDrawing(false);
        else if (dragging) {
            if (hoveredShapeIndex !== null) {
                const shapesArrayToUpdate = shapesArray;
                shapesArrayToUpdate[hoveredShapeIndex] = polygonPoints;
                setShapesArray(shapesArrayToUpdate);
            }
            setDragging(false);
            setSelectedPointIndex(null);
        }
    };
    const insertPointBetween = (lineIndex)=>{
        const p1 = polygonPoints[lineIndex];
        const p2 = polygonPoints[(lineIndex + 1) % polygonPoints.length];
        if (!$77ed830ea585e61d$var$isValidPolygonVertex(p1) || !$77ed830ea585e61d$var$isValidPolygonVertex(p2)) return;
        const [x1, y1] = p1;
        const [x2, y2] = p2;
        const newPointX = (x1 + x2) / 2;
        const newPointY = (y1 + y2) / 2;
        const updatedPoints = [
            ...polygonPoints.slice(0, lineIndex + 1),
            [
                newPointX,
                newPointY
            ],
            ...polygonPoints.slice(lineIndex + 1)
        ];
        setPolygonPoints(updatedPoints);
        setIZPolygonPoints(updatedPoints);
    };
    const handleRemovePoint = (pointIndex)=>{
        if (polygonPoints.length > 3) {
            const updatedPoints = [
                ...polygonPoints.slice(0, pointIndex),
                ...polygonPoints.slice(pointIndex + 1)
            ];
            setPolygonPoints(updatedPoints);
            setIZPolygonPoints(updatedPoints);
        }
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)("canvas", {
        ref: canvasRef,
        width: imageWidth + padding * 3,
        height: imageHeight + padding * 3,
        onMouseDown: handleMouseDown,
        onMouseMove: handleMouseMove,
        onMouseUp: handleMouseUp,
        onClick: ()=>closed && hoveredLineIndex !== null && !dragging && insertPointBetween(hoveredLineIndex),
        onDoubleClick: ()=>hoveredPointIndex !== null && handleRemovePoint(hoveredPointIndex),
        style: {
            cursor: cursorType,
            border: "2px solid black"
        }
    });
};

});
parcelRegister("eAYze", function(module, exports) {

$parcel$export(module.exports, "handleDecreasePointsBy30", () => $3b521fb869fc4a9d$export$20d02e2cb1b23d75);
$parcel$export(module.exports, "handleIncrementPointsBy30", () => $3b521fb869fc4a9d$export$a9cab48816615acd);
parcelRequire("8T3gX");
const $3b521fb869fc4a9d$export$20d02e2cb1b23d75 = (array)=>{
    return array.map((subArray)=>subArray.map((numberArray)=>numberArray.map((num)=>num - 30)));
};
const $3b521fb869fc4a9d$export$a9cab48816615acd = (array)=>{
    return array.map((subArray)=>subArray.map((numberArray)=>numberArray.map((num)=>num + 30)));
};

});


parcelRegister("3baw3", function(module, exports) {

$parcel$export(module.exports, "default", () => $250a8e7426d8d91e$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $dSmkj = parcelRequire("dSmkj");

var $aYNpO = parcelRequire("aYNpO");

var $c8JM8 = parcelRequire("c8JM8");

var $3IuQ3 = parcelRequire("3IuQ3");

var $f3puC = parcelRequire("f3puC");

var $iMOmE = parcelRequire("iMOmE");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $cmPoG = parcelRequire("cmPoG");

var $k1SKW = parcelRequire("k1SKW");

var $k4ank = parcelRequire("k4ank");
'use client';
const $250a8e7426d8d91e$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const $250a8e7426d8d91e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $iMOmE.default)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $cmPoG.getFormControlLabelUtilityClasses), classes);
};
const $250a8e7426d8d91e$export$1b479270917a5676 = (0, $anJSP.default)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $cmPoG.default).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $iMOmE.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $cmPoG.default).disabled}`]: {
            cursor: 'default'
        }
    }, ownerState.labelPlacement === 'start' && {
        flexDirection: 'row-reverse',
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === 'top' && {
        flexDirection: 'column-reverse',
        marginLeft: 16
    }, ownerState.labelPlacement === 'bottom' && {
        flexDirection: 'column',
        marginLeft: 16
    }, {
        [`& .${(0, $cmPoG.default).label}`]: {
            [`&.${(0, $cmPoG.default).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const $250a8e7426d8d91e$var$AsteriskComponent = (0, $anJSP.default)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $cmPoG.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $250a8e7426d8d91e$var$FormControlLabel = /*#__PURE__*/ $8T3gX.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = 'end', required: requiredProp, slotProps: slotProps = {} } = props, other = (0, $fAJB5.default)(props, $250a8e7426d8d91e$var$_excluded);
    const muiFormControl = (0, $c8JM8.default)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $k1SKW.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = (0, $eJfrs.default)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $250a8e7426d8d91e$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $f3puC.default) && !disableTypography) label = /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), (0, $eJfrs.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $iVyaN.default)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $k4ank.jsxs)($250a8e7426d8d91e$export$1b479270917a5676, (0, $eJfrs.default)({
        className: (0, $iVyaN.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $8T3gX.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3IuQ3.default), {
                display: "block",
                children: [
                    label,
                    /*#__PURE__*/ (0, $k4ank.jsxs)($250a8e7426d8d91e$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
$250a8e7426d8d91e$var$FormControlLabel.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the component appears selected.
   */ checked: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The props used for each slot inside.
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        typography: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    }),
    /**
   * A control element. For instance, it can be a `Radio`, a `Switch` or a `Checkbox`.
   */ control: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element.isRequired,
    /**
   * If `true`, the control is disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the label is rendered as it is passed without an additional typography node.
   */ disableTypography: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $dSmkj.default),
    /**
   * A text or an element to be used in an enclosing label element.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * The position of the label.
   * @default 'end'
   */ labelPlacement: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'bottom',
        'end',
        'start',
        'top'
    ]),
    /**
   * @ignore
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Callback fired when the state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, the label will indicate that the `input` is required.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        typography: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * The value of the component.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any
};
var $250a8e7426d8d91e$export$2e2bcd8739ae039 = $250a8e7426d8d91e$var$FormControlLabel;

});
parcelRegister("3IuQ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b4d6708ea179454$export$2e2bcd8739ae039);

var $fdGrT = parcelRequire("fdGrT");

var $iMkow = parcelRequire("iMkow");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");
'use client';
const $2b4d6708ea179454$var$Stack = (0, $iMkow.default)({
    createStyledComponent: (0, $anJSP.default)('div', {
        name: 'MuiStack',
        slot: 'Root',
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $7AQZl.useDefaultProps)({
            props: inProps,
            name: 'MuiStack'
        })
});
$2b4d6708ea179454$var$Stack.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */ direction: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'column-reverse',
            'column',
            'row-reverse',
            'row'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'column-reverse',
            'column',
            'row-reverse',
            'row'
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * Add an element between each child.
   */ divider: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Defines the space between immediate children.
   * @default 0
   */ spacing: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the [theme's default props](https://mui.com/material-ui/customization/theme-components/#default-props) configuration.
   * @default false
   */ useFlexGap: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
};
var $2b4d6708ea179454$export$2e2bcd8739ae039 = $2b4d6708ea179454$var$Stack;

});
parcelRegister("iMkow", function(module, exports) {

$parcel$export(module.exports, "default", () => $dabc8797f4ccaff6$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $b4f8D = parcelRequire("b4f8D");

var $kfTYv = parcelRequire("kfTYv");

var $aYNpO = parcelRequire("aYNpO");

var $7bVdH = parcelRequire("7bVdH");

var $ihMsk = parcelRequire("ihMsk");

var $bmcE0 = parcelRequire("bmcE0");

var $6IeW0 = parcelRequire("6IeW0");

var $o68UK = parcelRequire("o68UK");

var $eOD94 = parcelRequire("eOD94");

var $k4ank = parcelRequire("k4ank");
const $dabc8797f4ccaff6$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $dabc8797f4ccaff6$var$defaultTheme = (0, $6IeW0.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $dabc8797f4ccaff6$var$defaultCreateStyledComponent = (0, $7bVdH.default)('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
});
function $dabc8797f4ccaff6$var$useThemePropsDefault(props) {
    return (0, $ihMsk.default)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $dabc8797f4ccaff6$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $dabc8797f4ccaff6$var$joinChildren(children, separator) {
    const childrenArray = $8T3gX.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $8T3gX.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $dabc8797f4ccaff6$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $dabc8797f4ccaff6$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $eJfrs.default)({
        display: 'flex',
        flexDirection: 'column'
    }, (0, $o68UK.handleBreakpoints)({
        theme: theme
    }, (0, $o68UK.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $eOD94.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $o68UK.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $o68UK.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $eOD94.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$dabc8797f4ccaff6$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $eOD94.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $b4f8D.default)(styles, (0, $o68UK.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $o68UK.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $dabc8797f4ccaff6$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $dabc8797f4ccaff6$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $dabc8797f4ccaff6$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $aYNpO.default)(slots, (slot)=>(0, $kfTYv.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($dabc8797f4ccaff6$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $8T3gX.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $bmcE0.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $fAJB5.default)(props, $dabc8797f4ccaff6$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $k4ank.jsx)(StackRoot, (0, $eJfrs.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $iVyaN.default)(classes.root, className)
        }, other, {
            children: divider ? $dabc8797f4ccaff6$var$joinChildren(children, divider) : children
        }));
    });
    Stack.propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
        direction: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
                'column-reverse',
                'column',
                'row-reverse',
                'row'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
                'column-reverse',
                'column',
                'row-reverse',
                'row'
            ])),
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        ]),
        divider: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
        spacing: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
            ])),
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
        ]),
        sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
                (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
            ])),
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        ])
    };
    return Stack;
}

});
parcelRegister("7bVdH", function(module, exports) {

$parcel$export(module.exports, "default", () => $53c5f22a4c09d9cf$export$2e2bcd8739ae039);

var $5b4Kt = parcelRequire("5b4Kt");
const $53c5f22a4c09d9cf$var$styled = (0, $5b4Kt.default)();
var $53c5f22a4c09d9cf$export$2e2bcd8739ae039 = $53c5f22a4c09d9cf$var$styled;

});
parcelRegister("5b4Kt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c51a9d0d7e5d1ae$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $7P7g9 = parcelRequire("7P7g9");

var $b4f8D = parcelRequire("b4f8D");

var $flLLM = parcelRequire("flLLM");

var $7xMeJ = parcelRequire("7xMeJ");

var $6IeW0 = parcelRequire("6IeW0");

var $6VmXC = parcelRequire("6VmXC");
const $3c51a9d0d7e5d1ae$var$_excluded = [
    "ownerState"
], $3c51a9d0d7e5d1ae$var$_excluded2 = [
    "variants"
], $3c51a9d0d7e5d1ae$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $3c51a9d0d7e5d1ae$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $3c51a9d0d7e5d1ae$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $3c51a9d0d7e5d1ae$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $3c51a9d0d7e5d1ae$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
const $3c51a9d0d7e5d1ae$export$35e57303dbd8a66 = (0, $6IeW0.default)();
const $3c51a9d0d7e5d1ae$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $3c51a9d0d7e5d1ae$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $3c51a9d0d7e5d1ae$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $3c51a9d0d7e5d1ae$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $3c51a9d0d7e5d1ae$var$processStyleArg(callableStyle, _ref, layerName) {
    let { ownerState: ownerState } = _ref, props = (0, $fAJB5.default)(_ref, $3c51a9d0d7e5d1ae$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $eJfrs.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$3c51a9d0d7e5d1ae$var$processStyleArg(resolvedStyle, (0, $eJfrs.default)({
            ownerState: ownerState
        }, props), layerName));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $fAJB5.default)(resolvedStylesArg, $3c51a9d0d7e5d1ae$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $eJfrs.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                const variantStyle = typeof variant.style === 'function' ? variant.style((0, $eJfrs.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style;
                result.push(layerName ? $3c51a9d0d7e5d1ae$var$shallowLayer((0, $7P7g9.internal_serializeStyles)(variantStyle), layerName) : variantStyle);
            }
        });
        return result;
    }
    return layerName ? $3c51a9d0d7e5d1ae$var$shallowLayer((0, $7P7g9.internal_serializeStyles)(resolvedStylesArg), layerName) : resolvedStylesArg;
}
function $3c51a9d0d7e5d1ae$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $3c51a9d0d7e5d1ae$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $3c51a9d0d7e5d1ae$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $3c51a9d0d7e5d1ae$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $6VmXC.default)((0, $eJfrs.default)({}, props, {
            theme: $3c51a9d0d7e5d1ae$var$resolveTheme((0, $eJfrs.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $7P7g9.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $3c51a9d0d7e5d1ae$var$defaultOverridesResolver($3c51a9d0d7e5d1ae$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $fAJB5.default)(inputOptions, $3c51a9d0d7e5d1ae$var$_excluded3);
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        if (componentName) // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        label = `${componentName}-${$3c51a9d0d7e5d1ae$var$lowercaseFirstLetter(componentSlot || 'Root')}`;
        let shouldForwardPropOption = $3c51a9d0d7e5d1ae$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($3c51a9d0d7e5d1ae$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $7P7g9.default)(tag, (0, $eJfrs.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $b4f8D.isPlainObject)(stylesArg)) return (props)=>{
                const theme = $3c51a9d0d7e5d1ae$var$resolveTheme({
                    theme: props.theme,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
                return $3c51a9d0d7e5d1ae$var$processStyleArg(stylesArg, (0, $eJfrs.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? layerName : undefined);
            };
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $3c51a9d0d7e5d1ae$var$resolveTheme((0, $eJfrs.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $3c51a9d0d7e5d1ae$var$processStyleArg(slotStyle, (0, $eJfrs.default)({}, props, {
                        theme: theme
                    }), theme.modularCssLayers ? 'theme' : undefined);
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $3c51a9d0d7e5d1ae$var$resolveTheme((0, $eJfrs.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $3c51a9d0d7e5d1ae$var$processStyleArg({
                    variants: themeVariants
                }, (0, $eJfrs.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            {
                let displayName;
                if (componentName) displayName = `${componentName}${(0, $flLLM.default)(componentSlot || '')}`;
                if (displayName === undefined) displayName = `Styled(${(0, $7xMeJ.default)(tag)})`;
                Component.displayName = displayName;
            }
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});


parcelRegister("ihMsk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4ff66da347fa681$export$2e2bcd8739ae039);

var $4qo8D = parcelRequire("4qo8D");

var $a4EsH = parcelRequire("a4EsH");
'use client';
function $d4ff66da347fa681$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $a4EsH.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $4qo8D.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});



parcelRegister("cmPoG", function(module, exports) {

$parcel$export(module.exports, "getFormControlLabelUtilityClasses", () => $900f68850f5d4f9d$export$717666c39ec07e12);
$parcel$export(module.exports, "default", () => $900f68850f5d4f9d$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $900f68850f5d4f9d$export$717666c39ec07e12(slot) {
    return (0, $kfTYv.default)('MuiFormControlLabel', slot);
}
const $900f68850f5d4f9d$var$formControlLabelClasses = (0, $jh2Zm.default)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $900f68850f5d4f9d$export$2e2bcd8739ae039 = $900f68850f5d4f9d$var$formControlLabelClasses;

});


parcelRegister("ddLR4", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a019c49143d5fbb$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $dSmkj = parcelRequire("dSmkj");

var $aYNpO = parcelRequire("aYNpO");

var $aBrLz = parcelRequire("aBrLz");

var $iMOmE = parcelRequire("iMOmE");

var $aclWg = parcelRequire("aclWg");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $3vNkj = parcelRequire("3vNkj");

var $k4ank = parcelRequire("k4ank");
'use client';
const $9a019c49143d5fbb$var$_excluded = [
    "className",
    "color",
    "edge",
    "size",
    "sx"
];
const $9a019c49143d5fbb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            edge && `edge${(0, $iMOmE.default)(edge)}`,
            `size${(0, $iMOmE.default)(size)}`
        ],
        switchBase: [
            'switchBase',
            `color${(0, $iMOmE.default)(color)}`,
            checked && 'checked',
            disabled && 'disabled'
        ],
        thumb: [
            'thumb'
        ],
        track: [
            'track'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $aYNpO.default)(slots, (0, $3vNkj.getSwitchUtilityClass), classes);
    return (0, $eJfrs.default)({}, classes, composedClasses);
};
const $9a019c49143d5fbb$var$SwitchRoot = (0, $anJSP.default)('span', {
    name: 'MuiSwitch',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $iMOmE.default)(ownerState.edge)}`],
            styles[`size${(0, $iMOmE.default)(ownerState.size)}`]
        ];
    }
})({
    display: 'inline-flex',
    width: 58,
    height: 38,
    overflow: 'hidden',
    padding: 12,
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: 'middle',
    // For correct alignment with the text.
    '@media print': {
        colorAdjust: 'exact'
    },
    variants: [
        {
            props: {
                edge: 'start'
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: 'end'
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                width: 40,
                height: 24,
                padding: 7,
                [`& .${(0, $3vNkj.default).thumb}`]: {
                    width: 16,
                    height: 16
                },
                [`& .${(0, $3vNkj.default).switchBase}`]: {
                    padding: 4,
                    [`&.${(0, $3vNkj.default).checked}`]: {
                        transform: 'translateX(16px)'
                    }
                }
            }
        }
    ]
});
const $9a019c49143d5fbb$var$SwitchSwitchBase = (0, $anJSP.default)((0, $aclWg.default), {
    name: 'MuiSwitch',
    slot: 'SwitchBase',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $3vNkj.default).input}`]: styles.input
            },
            ownerState.color !== 'default' && styles[`color${(0, $iMOmE.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme })=>({
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            'left',
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $3vNkj.default).checked}`]: {
            transform: 'translateX(20px)'
        },
        [`&.${(0, $3vNkj.default).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $3vNkj.default).checked} + .${(0, $3vNkj.default).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $3vNkj.default).disabled} + .${(0, $3vNkj.default).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
        },
        [`& .${(0, $3vNkj.default).input}`]: {
            left: '-100%',
            width: '300%'
        }
    }), ({ theme: theme })=>({
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aBrLz.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $3vNkj.default).checked}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            '&:hover': {
                                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aBrLz.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            [`&.${(0, $3vNkj.default).disabled}`]: {
                                color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === 'light' ? (0, $aBrLz.lighten)(theme.palette[color].main, 0.62) : (0, $aBrLz.darken)(theme.palette[color].main, 0.55)}`
                            }
                        },
                        [`&.${(0, $3vNkj.default).checked} + .${(0, $3vNkj.default).track}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }))
        ]
    }));
const $9a019c49143d5fbb$var$SwitchTrack = (0, $anJSP.default)('span', {
    name: 'MuiSwitch',
    slot: 'Track',
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>({
        height: '100%',
        width: '100%',
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            'opacity',
            'background-color'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
    }));
const $9a019c49143d5fbb$var$SwitchThumb = (0, $anJSP.default)('span', {
    name: 'MuiSwitch',
    slot: 'Thumb',
    overridesResolver: (props, styles)=>styles.thumb
})(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: 'currentColor',
        width: 20,
        height: 20,
        borderRadius: '50%'
    }));
const $9a019c49143d5fbb$var$Switch = /*#__PURE__*/ $8T3gX.forwardRef(function Switch(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiSwitch'
    });
    const { className: className, color: color = 'primary', edge: edge = false, size: size = 'medium', sx: sx } = props, other = (0, $fAJB5.default)(props, $9a019c49143d5fbb$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        color: color,
        edge: edge,
        size: size
    });
    const classes = $9a019c49143d5fbb$var$useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, $k4ank.jsx)($9a019c49143d5fbb$var$SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $k4ank.jsxs)($9a019c49143d5fbb$var$SwitchRoot, {
        className: (0, $iVyaN.default)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)($9a019c49143d5fbb$var$SwitchSwitchBase, (0, $eJfrs.default)({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other, {
                classes: (0, $eJfrs.default)({}, classes, {
                    root: classes.switchBase
                })
            })),
            /*#__PURE__*/ (0, $k4ank.jsx)($9a019c49143d5fbb$var$SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
$9a019c49143d5fbb$var$Switch.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the component is checked.
   */ checked: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The icon to display when the component is checked.
   */ checkedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'default',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The default checked state. Use when the component is not controlled.
   */ defaultChecked: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the component is disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */ edge: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'end',
        'start',
        false
    ]),
    /**
   * The icon to display when the component is unchecked.
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $dSmkj.default),
    /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, the `input` element is required.
   * @default false
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The size of the component.
   * `small` is equivalent to the dense switch styling.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'medium',
            'small'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any
};
var $9a019c49143d5fbb$export$2e2bcd8739ae039 = $9a019c49143d5fbb$var$Switch;

});
parcelRegister("aclWg", function(module, exports) {

$parcel$export(module.exports, "default", () => $76cc0af4480458ef$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $dSmkj = parcelRequire("dSmkj");

var $aYNpO = parcelRequire("aYNpO");

var $iMOmE = parcelRequire("iMOmE");

var $anJSP = parcelRequire("anJSP");
var $3dQcH = parcelRequire("3dQcH");

var $7Wcl5 = parcelRequire("7Wcl5");

var $c8JM8 = parcelRequire("c8JM8");

var $hhKOZ = parcelRequire("hhKOZ");

var $hyxPa = parcelRequire("hyxPa");

var $k4ank = parcelRequire("k4ank");
'use client';
const $76cc0af4480458ef$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $76cc0af4480458ef$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $iMOmE.default)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $hyxPa.getSwitchBaseUtilityClass), classes);
};
const $76cc0af4480458ef$var$SwitchBaseRoot = (0, $anJSP.default)((0, $hhKOZ.default), {
    name: 'MuiSwitchBase'
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({
        padding: 9,
        borderRadius: '50%'
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }));
const $76cc0af4480458ef$var$SwitchBaseInput = (0, $anJSP.default)('input', {
    name: 'MuiSwitchBase',
    shouldForwardProp: (0, $3dQcH.default)
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $76cc0af4480458ef$var$SwitchBase = /*#__PURE__*/ $8T3gX.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $fAJB5.default)(props, $76cc0af4480458ef$var$_excluded);
    const [checked, setCheckedState] = (0, $7Wcl5.default)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $c8JM8.default)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = (0, $eJfrs.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $76cc0af4480458ef$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsxs)($76cc0af4480458ef$var$SwitchBaseRoot, (0, $eJfrs.default)({
        component: "span",
        className: (0, $iVyaN.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)($76cc0af4480458ef$var$SwitchBaseInput, (0, $eJfrs.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === 'checkbox' && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
// NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.
$76cc0af4480458ef$var$SwitchBase.propTypes = {
    /**
   * If `true`, the `input` element is focused during the first mount.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the component is checked.
   */ checked: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The icon to display when the component is checked.
   */ checkedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node.isRequired,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * @ignore
   */ defaultChecked: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the component is disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */ disableFocusRipple: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */ edge: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'end',
        'start',
        false
    ]),
    /**
   * The icon to display when the component is unchecked.
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node.isRequired,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $dSmkj.default),
    /*
   * @ignore
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * @ignore
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the `input` element is required.
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ tabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The input component prop `type`.
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string.isRequired,
    /**
   * The value of the component.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any
};
var $76cc0af4480458ef$export$2e2bcd8739ae039 = $76cc0af4480458ef$var$SwitchBase;

});
parcelRegister("hyxPa", function(module, exports) {

$parcel$export(module.exports, "getSwitchBaseUtilityClass", () => $cc7fd96a6aeb6f5b$export$baa0faa0c7ad8085);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $cc7fd96a6aeb6f5b$export$baa0faa0c7ad8085(slot) {
    return (0, $kfTYv.default)('PrivateSwitchBase', slot);
}
const $cc7fd96a6aeb6f5b$var$switchBaseClasses = (0, $jh2Zm.default)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $cc7fd96a6aeb6f5b$export$2e2bcd8739ae039 = $cc7fd96a6aeb6f5b$var$switchBaseClasses;

});


parcelRegister("3vNkj", function(module, exports) {

$parcel$export(module.exports, "getSwitchUtilityClass", () => $28ea8793d89d23e5$export$39f6debbec19b3ba);
$parcel$export(module.exports, "default", () => $28ea8793d89d23e5$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $28ea8793d89d23e5$export$39f6debbec19b3ba(slot) {
    return (0, $kfTYv.default)('MuiSwitch', slot);
}
const $28ea8793d89d23e5$var$switchClasses = (0, $jh2Zm.default)('MuiSwitch', [
    'root',
    'edgeStart',
    'edgeEnd',
    'switchBase',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium',
    'checked',
    'disabled',
    'input',
    'thumb',
    'track'
]);
var $28ea8793d89d23e5$export$2e2bcd8739ae039 = $28ea8793d89d23e5$var$switchClasses;

});


parcelRegister("kbChx", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb2287b354f3a87f$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $dSmkj = parcelRequire("dSmkj");

var $aYNpO = parcelRequire("aYNpO");

var $aBrLz = parcelRequire("aBrLz");

var $aclWg = parcelRequire("aclWg");

var $fYPRH = parcelRequire("fYPRH");

var $cZaKK = parcelRequire("cZaKK");

var $8Xr4Y = parcelRequire("8Xr4Y");

var $iMOmE = parcelRequire("iMOmE");

var $7AQZl = parcelRequire("7AQZl");

var $anJSP = parcelRequire("anJSP");
var $3dQcH = parcelRequire("3dQcH");

var $3R4US = parcelRequire("3R4US");

var $k4ank = parcelRequire("k4ank");
'use client';
const $eb2287b354f3a87f$var$_excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size",
    "className"
];
const $eb2287b354f3a87f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, $iMOmE.default)(color)}`,
            `size${(0, $iMOmE.default)(size)}`
        ]
    };
    const composedClasses = (0, $aYNpO.default)(slots, (0, $3R4US.getCheckboxUtilityClass), classes);
    return (0, $eJfrs.default)({}, classes, composedClasses);
};
const $eb2287b354f3a87f$var$CheckboxRoot = (0, $anJSP.default)((0, $aclWg.default), {
    shouldForwardProp: (prop)=>(0, $3dQcH.default)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $iMOmE.default)(ownerState.size)}`],
            ownerState.color !== 'default' && styles[`color${(0, $iMOmE.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aBrLz.alpha)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.color !== 'default' && {
        [`&.${(0, $3R4US.default).checked}, &.${(0, $3R4US.default).indeterminate}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $3R4US.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
const $eb2287b354f3a87f$var$defaultCheckedIcon = /*#__PURE__*/ (0, $k4ank.jsx)((0, $cZaKK.default), {});
const $eb2287b354f3a87f$var$defaultIcon = /*#__PURE__*/ (0, $k4ank.jsx)((0, $fYPRH.default), {});
const $eb2287b354f3a87f$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $k4ank.jsx)((0, $8Xr4Y.default), {});
const $eb2287b354f3a87f$var$Checkbox = /*#__PURE__*/ $8T3gX.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon: checkedIcon = $eb2287b354f3a87f$var$defaultCheckedIcon, color: color = 'primary', icon: iconProp = $eb2287b354f3a87f$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $eb2287b354f3a87f$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = 'medium', className: className } = props, other = (0, $fAJB5.default)(props, $eb2287b354f3a87f$var$_excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, $eJfrs.default)({}, props, {
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    const classes = $eb2287b354f3a87f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsx)($eb2287b354f3a87f$var$CheckboxRoot, (0, $eJfrs.default)({
        type: "checkbox",
        inputProps: (0, $eJfrs.default)({
            'data-indeterminate': indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $8T3gX.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $8T3gX.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref,
        className: (0, $iVyaN.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
$eb2287b354f3a87f$var$Checkbox.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the component is checked.
   */ checked: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */ checkedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'default',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The default checked state. Use when the component is not controlled.
   */ defaultChecked: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */ indeterminate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */ indeterminateIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $dSmkj.default),
    /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, the `input` element is required.
   * @default false
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'medium',
            'small'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any
};
var $eb2287b354f3a87f$export$2e2bcd8739ae039 = $eb2287b354f3a87f$var$Checkbox;

});
parcelRegister("fYPRH", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba24b0f1cd845a6c$export$2e2bcd8739ae039);
parcelRequire("8T3gX");

var $a7uO0 = parcelRequire("a7uO0");

var $k4ank = parcelRequire("k4ank");
'use client';
var $ba24b0f1cd845a6c$export$2e2bcd8739ae039 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');

});

parcelRegister("cZaKK", function(module, exports) {

$parcel$export(module.exports, "default", () => $974385d71e42643f$export$2e2bcd8739ae039);
parcelRequire("8T3gX");

var $a7uO0 = parcelRequire("a7uO0");

var $k4ank = parcelRequire("k4ank");
'use client';
var $974385d71e42643f$export$2e2bcd8739ae039 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');

});

parcelRegister("8Xr4Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $6858d6c3ce62ee39$export$2e2bcd8739ae039);
parcelRequire("8T3gX");

var $a7uO0 = parcelRequire("a7uO0");

var $k4ank = parcelRequire("k4ank");
'use client';
var $6858d6c3ce62ee39$export$2e2bcd8739ae039 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');

});

parcelRegister("3R4US", function(module, exports) {

$parcel$export(module.exports, "getCheckboxUtilityClass", () => $2cea229be9b17302$export$6c57c6e16b4063b);
$parcel$export(module.exports, "default", () => $2cea229be9b17302$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $2cea229be9b17302$export$6c57c6e16b4063b(slot) {
    return (0, $kfTYv.default)('MuiCheckbox', slot);
}
const $2cea229be9b17302$var$checkboxClasses = (0, $jh2Zm.default)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var $2cea229be9b17302$export$2e2bcd8739ae039 = $2cea229be9b17302$var$checkboxClasses;

});


parcelRegister("QUu0n", function(module, exports) {

$parcel$export(module.exports, "pointsCreator", () => $6c6f2b1df84f3f7c$export$c2c757e9d9431ca3);
$parcel$export(module.exports, "pointsCreatorPlus30", () => $6c6f2b1df84f3f7c$export$3eae1676999df59c);
const $6c6f2b1df84f3f7c$export$c2c757e9d9431ca3 = (array, height, width)=>{
    let returnString = ``;
    array.forEach((array)=>{
        returnString += `${array[0] * width},${array[1] * height} `;
    });
    return returnString;
};
const $6c6f2b1df84f3f7c$export$3eae1676999df59c = (array, height, width)=>{
    let returnString = ``;
    array.forEach((array)=>{
        returnString += `${array[0] * width + 30},${array[1] * height + 30} `;
    });
    return returnString;
};

});

parcelRegister("6NUqI", function(module, exports) {

$parcel$export(module.exports, "dedupePolygons", () => $9531b12c88e8fe10$export$e79db79d5340e33e);
/**
 * Remove duplicate (and empty) polygons from an ignore-zone `coordinates` array.
 *
 * Why: the polygon editor reassembles a zone's polygons at save time as
 * `[...shapes, activePolygon]` (IgnoreZoneBuilder.handleSaveEdits). When an
 * *existing* polygon is edited, PolygonDrawer's edit branch leaves that polygon
 * in BOTH `shapes` and `iZpolygonPoints`, so the concat lists it twice and the
 * zone is written to the API with the same polygon doubled. Customers saw this
 * as "doubled up" masking (BT-1092: two identical Vehicle polygons stacked).
 *
 * Two polygons are considered identical when their vertex lists match after
 * rounding each coordinate to 4 decimals (tolerates float noise; safe for both
 * pixel-space and normalized 0-1 coordinates). Identical polygons are
 * functionally redundant in a zone, so dropping the extras never changes intent.
 */ const $9531b12c88e8fe10$export$e79db79d5340e33e = (coordinates)=>{
    if (!Array.isArray(coordinates)) return coordinates;
    const seen = new Set();
    const result = [];
    for (const polygon of coordinates){
        if (!Array.isArray(polygon) || polygon.length === 0) continue;
        const key = JSON.stringify(polygon.map((point)=>Array.isArray(point) ? point.map((n)=>Math.round(n * 1e4) / 1e4) : point));
        if (seen.has(key)) continue;
        seen.add(key);
        result.push(polygon);
    }
    return result;
};

});




parcelRegister("9s9JO", function(module, exports) {

$parcel$export(module.exports, "FLEX_IZ_CREATE_NEW_PRESET_OPTION", () => $47b0245c145e9e42$export$ebf3771ac1798eda);
$parcel$export(module.exports, "FLEX_IZ_NO_IGNORE_ZONES_OPTION", () => $47b0245c145e9e42$export$e3b91f3d986deec4);
$parcel$export(module.exports, "FLEX_IZ_DEFAULT_CAMERA_CONFIG_OPTION", () => $47b0245c145e9e42$export$6a9b35c7c4baa772);
$parcel$export(module.exports, "FLEX_IZ_DEFAULT_CAMERA_CONFIG_LABEL", () => $47b0245c145e9e42$export$4590b546088f987d);
/** Select `value` for "+ CREATE NEW PRESET"; must not collide with preset `localId`. */ const $47b0245c145e9e42$export$ebf3771ac1798eda = "__create_new_preset__";
const $47b0245c145e9e42$export$e3b91f3d986deec4 = "__no_ignore_zones__";
const $47b0245c145e9e42$export$6a9b35c7c4baa772 = "__default_camera_config__";
const $47b0245c145e9e42$export$4590b546088f987d = "Default";

});

parcelRegister("6JE7U", function(module, exports) {

$parcel$export(module.exports, "filterFlexPresetsForApiPresetDropdown", () => $3ec12fd2cf8edd56$export$5375420331cbebf4);
$parcel$export(module.exports, "normalizeFlexPresetSelectionToApiBackedMenuValue", () => $3ec12fd2cf8edd56$export$a52fa254d6761adb);
$parcel$export(module.exports, "filterBundleTitleZones", () => $3ec12fd2cf8edd56$export$6735eb3fbfa0f317);
$parcel$export(module.exports, "dedupeFlexPresetsByDisplayName", () => $3ec12fd2cf8edd56$export$268fbe45d33d3fb3);
$parcel$export(module.exports, "isNoIgnorePreset", () => $3ec12fd2cf8edd56$export$a2122629c1310b9d);
$parcel$export(module.exports, "collapseNoIgnoreZonesPresetOptions", () => $3ec12fd2cf8edd56$export$5659796a9c22f8d1);

var $9s9JO = parcelRequire("9s9JO");
const $3ec12fd2cf8edd56$var$zoneHasDrawableCoordinates = (zone)=>{
    const walk = (node, depth)=>{
        if (depth > 6 || node == null) return false;
        if (Array.isArray(node)) {
            if (node.length >= 2 && typeof node[0] === "number" && typeof node[1] === "number" && Number.isFinite(node[0]) && Number.isFinite(node[1])) return true;
            return node.some((child)=>walk(child, depth + 1));
        }
        return false;
    };
    return walk(zone.coordinates, 0);
};
const $3ec12fd2cf8edd56$export$9d57beb2dfb81285 = (p)=>{
    const id = p.localId || "";
    return id.startsWith("server-") || id.startsWith("custom-");
};
const $3ec12fd2cf8edd56$export$5375420331cbebf4 = (presets)=>presets.filter((p)=>$3ec12fd2cf8edd56$export$9d57beb2dfb81285(p) && p.localId !== (0, $9s9JO.FLEX_IZ_NO_IGNORE_ZONES_OPTION));
const $3ec12fd2cf8edd56$export$a52fa254d6761adb = (cameraId, allPresets, selectedLocalId)=>{
    if (!selectedLocalId || selectedLocalId === (0, $9s9JO.FLEX_IZ_NO_IGNORE_ZONES_OPTION)) return selectedLocalId;
    const defaultLid = `default-${cameraId}`;
    if (selectedLocalId !== defaultLid) return selectedLocalId;
    const slot = allPresets.find((p)=>p.localId === defaultLid);
    if (slot?.persistedId == null || !Number.isFinite(Number(slot.persistedId))) return selectedLocalId;
    const pid = Number(slot.persistedId);
    const server = allPresets.find((p)=>typeof p.localId === "string" && p.localId.startsWith("server-") && p.persistedId != null && Number(p.persistedId) === pid);
    return server?.localId ?? selectedLocalId;
};
const $3ec12fd2cf8edd56$export$6735eb3fbfa0f317 = (presetName, zones)=>{
    const pn = presetName.trim().toLowerCase();
    if (!pn) return zones;
    return zones.filter((zone)=>{
        const dn = (zone.label_display_name || "").trim().toLowerCase();
        if (dn !== pn) return true;
        return $3ec12fd2cf8edd56$var$zoneHasDrawableCoordinates(zone);
    });
};
const $3ec12fd2cf8edd56$export$268fbe45d33d3fb3 = (cameraId, presets)=>{
    const defaultLocalId = `default-${cameraId}`;
    const defaultEntry = presets.find((p)=>p.localId === defaultLocalId);
    const noIgnoreEntry = presets.find((p)=>p.localId === (0, $9s9JO.FLEX_IZ_NO_IGNORE_ZONES_OPTION));
    /** Keep API `server-*` rows even when they share `persistedId` with the synthetic default; dropdowns filter `default-*` out and need the real preset row. */ const rest = presets.filter((p)=>p.localId !== defaultLocalId && p.localId !== (0, $9s9JO.FLEX_IZ_NO_IGNORE_ZONES_OPTION));
    const indexByLocalId = new Map(rest.map((p, i)=>[
            p.localId,
            i
        ]));
    const nameBuckets = new Map();
    for (const p of rest){
        const key = (p.name || "").trim().toLowerCase();
        const bucketKey = key.length > 0 ? key : `__id:${p.localId}`;
        const arr = nameBuckets.get(bucketKey) || [];
        arr.push(p);
        nameBuckets.set(bucketKey, arr);
    }
    const picked = [];
    for (const group of nameBuckets.values()){
        if (group.length === 1) {
            picked.push(group[0]);
            continue;
        }
        const best = group.reduce((a, b)=>{
            const za = a.zones?.length ?? 0;
            const zb = b.zones?.length ?? 0;
            if (zb !== za) return zb > za ? b : a;
            const ia = indexByLocalId.get(a.localId) ?? 0;
            const ib = indexByLocalId.get(b.localId) ?? 0;
            return ia <= ib ? a : b;
        });
        picked.push(best);
    }
    picked.sort((a, b)=>(indexByLocalId.get(a.localId) ?? 0) - (indexByLocalId.get(b.localId) ?? 0));
    return [
        ...defaultEntry ? [
            defaultEntry
        ] : [],
        ...picked,
        ...noIgnoreEntry ? [
            noIgnoreEntry
        ] : []
    ];
};
const $3ec12fd2cf8edd56$export$a2122629c1310b9d = (preset)=>preset.localId === (0, $9s9JO.FLEX_IZ_NO_IGNORE_ZONES_OPTION) || (preset.name || "").trim().toLowerCase() === "no ignore zones";
const $3ec12fd2cf8edd56$export$5659796a9c22f8d1 = (presets, preferredLocalId)=>{
    const noIgnoreOptions = presets.filter($3ec12fd2cf8edd56$export$a2122629c1310b9d);
    if (noIgnoreOptions.length <= 1) return presets;
    const preferred = preferredLocalId ? noIgnoreOptions.find((preset)=>preset.localId === preferredLocalId) : undefined;
    const persisted = noIgnoreOptions.find((preset)=>preset.persistedId != null && preset.localId !== (0, $9s9JO.FLEX_IZ_NO_IGNORE_ZONES_OPTION));
    const keep = preferred || persisted || noIgnoreOptions[0];
    return presets.filter((preset)=>!$3ec12fd2cf8edd56$export$a2122629c1310b9d(preset) || preset.localId === keep.localId);
};

});


parcelRegister("2wOL1", function(module, exports) {

$parcel$export(module.exports, "buildLineCrossingsListPath", () => $647acef70836d16c$export$1186fc7342c4480);
$parcel$export(module.exports, "parseLineCrossingsPresetIdFromHref", () => $647acef70836d16c$export$8a3754aa94ecc7f8);
$parcel$export(module.exports, "lineCrossingsPresetSearch", () => $647acef70836d16c$export$e577b475599c62f1);
/**
 * Line-crossing list URLs, preset-aware (ENG-1610).
 *
 * `LineCrossing.preset` is a nullable FK in actuate_admin: `null` means a
 * camera-wide "Default" line, anything else means the line belongs to a named
 * preset ("configuration"). A bare `GET /line_crossing/?camera=<id>` returns
 * EVERY line for the camera, preset-scoped ones included, so camera-wide
 * surfaces must ask for `preset__isnull=true` and preset surfaces for exactly
 * their preset (`preset=<id>`) — otherwise preset lines leak into the
 * camera-wide preview and editor, where they can be deleted or rewritten as
 * default lines. Both filters exist since actuate_admin PR #2894
 * (`LineCrossingViewSet.filterset_fields = {"preset": ["exact", "isnull"]}`).
 */ const $647acef70836d16c$export$1186fc7342c4480 = (cameraId, presetId)=>{
    const numericPresetId = presetId == null ? NaN : Number(presetId);
    if (Number.isFinite(numericPresetId)) return `/line_crossing/?camera=${cameraId}&preset=${numericPresetId}`;
    return `/line_crossing/?camera=${cameraId}&preset__isnull=true`;
};
const $647acef70836d16c$export$8a3754aa94ecc7f8 = (href)=>{
    try {
        const search = new URL(href, "http://localhost").search;
        const raw = new URLSearchParams(search).get("preset");
        if (raw == null || raw.trim() === "") return null;
        const parsed = Number(raw);
        return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
    } catch  {
        return null;
    }
};
const $647acef70836d16c$export$e577b475599c62f1 = (presetId)=>presetId != null && Number.isFinite(Number(presetId)) ? `?preset=${presetId}` : "";

});

parcelRegister("a2fXs", function(module, exports) {

$parcel$export(module.exports, "IgnoreZonePreviewHoverLayer", () => $4d09f99057a33440$export$8b5ed8fe05e557b1);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $cVCJe = parcelRequire("cVCJe");

var $4PFLW = parcelRequire("4PFLW");

var $evb6u = parcelRequire("evb6u");
const $4d09f99057a33440$export$8b5ed8fe05e557b1 = ({ zones: zones, enabled: enabled = true, className: className, children: children })=>{
    const { isFeatureEnabled: isFeatureEnabled } = (0, $4PFLW.useFeatureFlag)();
    const showIgnoreZoneHover = isFeatureEnabled("showIgnoreZoneHover", false);
    const hoverEnabled = enabled && showIgnoreZoneHover;
    const containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const [hoverLabels, setHoverLabels] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const handleMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback((event)=>{
        if (!hoverEnabled || zones.length === 0) {
            setHoverLabels([]);
            return;
        }
        const container = containerRef.current;
        if (!container) return;
        const img = container.querySelector("img");
        if (!img) {
            setHoverLabels([]);
            return;
        }
        const rect = img.getBoundingClientRect();
        if (rect.width <= 0 || rect.height <= 0) {
            setHoverLabels([]);
            return;
        }
        const x = (event.clientX - rect.left) / rect.width;
        const y = (event.clientY - rect.top) / rect.height;
        if (x < 0 || x > 1 || y < 0 || y > 1) {
            setHoverLabels([]);
            return;
        }
        setHoverLabels((0, $evb6u.getIgnoreZoneLabelsAtPoint)([
            x,
            y
        ], zones));
    }, [
        hoverEnabled,
        zones
    ]);
    const handleMouseLeave = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback(()=>{
        setHoverLabels([]);
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!hoverEnabled) setHoverLabels([]);
    }, [
        hoverEnabled
    ]);
    const tooltipTitle = hoverLabels.length > 0 ? hoverLabels.join("\n") : "";
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        open: hoverEnabled && hoverLabels.length > 0,
        followCursor: true,
        title: tooltipTitle,
        placement: "top",
        disableHoverListener: true,
        disableFocusListener: true,
        disableTouchListener: true,
        componentsProps: {
            tooltip: {
                sx: {
                    fontFamily: "Mulish",
                    whiteSpace: "pre-line"
                }
            }
        },
        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
            ref: containerRef,
            className: className,
            onMouseMove: handleMouseMove,
            onMouseLeave: handleMouseLeave,
            children: children
        })
    });
};

});
parcelRegister("evb6u", function(module, exports) {

$parcel$export(module.exports, "getIgnoreZoneLabelsAtPoint", () => $9c9ab62eeee8dc99$export$1a94a564077fdfb1);

var $4y2HK = parcelRequire("4y2HK");

var $7xxaD = parcelRequire("7xxaD");
const $9c9ab62eeee8dc99$export$1a94a564077fdfb1 = (point, zones)=>{
    const labels = [];
    for (const zone of zones){
        const polygons = (0, $7xxaD.normalizeZonePolygons)(zone.coordinates);
        const isInside = polygons.some((polygon)=>(0, $4y2HK.isPointInNormalizedPolygon)(polygon, point));
        if (isInside && zone.label_display_name) labels.push(zone.label_display_name);
    }
    return labels;
};

});
parcelRegister("4y2HK", function(module, exports) {

$parcel$export(module.exports, "isPointInNormalizedPolygon", () => $e557544c93363aa9$export$100d3614ab91f111);
const $e557544c93363aa9$var$isValidVertex = (vertex)=>Array.isArray(vertex) && vertex.length >= 2 && typeof vertex[0] === "number" && typeof vertex[1] === "number";
const $e557544c93363aa9$export$100d3614ab91f111 = (polygon, point)=>{
    const [x, y] = point;
    let isInside = false;
    let j = polygon.length - 1;
    for(let i = 0; i < polygon.length; i++){
        const pi = polygon[i];
        const pj = polygon[j];
        if (!$e557544c93363aa9$var$isValidVertex(pi) || !$e557544c93363aa9$var$isValidVertex(pj)) {
            j = i;
            continue;
        }
        const [xi, yi] = pi;
        const [xj, yj] = pj;
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
        j = i;
    }
    return isInside;
};

});

parcelRegister("7xxaD", function(module, exports) {

$parcel$export(module.exports, "normalizeZonePolygons", () => $c2fe7256a071a608$export$8761bd123cfa7819);
/**
 * Normalizes zone coordinates to an array of polygons.
 * API may return either a single polygon (number[][]) or many polygons (number[][][]).
 */ const $c2fe7256a071a608$export$8761bd123cfa7819 = (coordinates)=>{
    if (!Array.isArray(coordinates) || coordinates.length === 0) return [];
    if (Array.isArray(coordinates[0]) && typeof coordinates[0][0] === "number") return [
        coordinates
    ];
    return coordinates;
};

});



parcelRegister("bjrAt", function(module, exports) {

$parcel$export(module.exports, "formatFrameRate", () => $173a26e848d71962$export$66aba9a70bc64fe2);
/**
 * Frame Rate cell on the Site About and Edit Camera rows.
 *
 * `native_frame_rate` from `camera/{id}/status/` is plain frames per second:
 * the RTSP pullers store frames / seconds, AI Link stores the clip's fps, and
 * the health report and V1 show it unscaled. Round to two decimals and show
 * "N/A" until the camera has been sampled.
 *
 * The previous rendering was `roundToHundredth(value / 100)`, which only
 * looked like a unit conversion: `roundToHundredth` multiplies by 100 (it
 * turns a 0–1 fraction into a percentage), so the two cancelled out. This
 * helper says the same thing without the detour (ENG-2123).
 */ const $173a26e848d71962$export$66aba9a70bc64fe2 = (value)=>{
    const fps = Number(value);
    if (!fps || !Number.isFinite(fps)) return "N/A";
    return Number(fps.toFixed(2));
};

});


parcelRegister("hN0t7", function(module, exports) {

$parcel$export(module.exports, "requestCameraStatusRefresh", () => $44f6b6f6daff55b4$export$dcf4c1d25cbbfd00);
$parcel$export(module.exports, "useCameraStatusPolling", () => $44f6b6f6daff55b4$export$11a441b063bb8468);
/**
 * Keep Site About's camera status fresh until cameras report (ENG-2853).
 *
 * Status reaches admin within ~10 s of a connector's first frame, but the page
 * fetched `camera/{id}/status/` once per load, so anyone who opened it before
 * the first frame kept seeing the poster and "No data yet" until a reload
 * (EyeQ: "up to ~10 min after onboarding or arming").
 *
 * Two modes, both capped at ten minutes:
 * - pending: on load, re-fetch only the cameras with no status yet, every
 *   15 s, and stop once they have all reported;
 * - all: after an Arm / Reboot from this page, re-fetch every camera every
 *   30 s, since a restart replaces previews and connection results that were
 *   already there.
 */ 
var $8T3gX = parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3FJ79 = parcelRequire("3FJ79");
const $44f6b6f6daff55b4$export$68cf044ff2f8ab3c = 15000;
const $44f6b6f6daff55b4$export$330ada973b9c80f6 = 30000;
const $44f6b6f6daff55b4$export$e58a031831eed7af = 600000;
const $44f6b6f6daff55b4$export$78c1ca5a4b6e0729 = "siteAboutCameraStatusRefresh";
const $44f6b6f6daff55b4$export$dcf4c1d25cbbfd00 = ()=>{
    window.dispatchEvent(new CustomEvent($44f6b6f6daff55b4$export$78c1ca5a4b6e0729));
};
const $44f6b6f6daff55b4$export$1cdebd372dc3dc4e = (status)=>!status || status.connected === null || status.connected === undefined || status.frame_since_launch === null || status.frame_since_launch === undefined || !String(status.preview_url ?? "").trim();
const $44f6b6f6daff55b4$export$6a49f49143ef1b2b = (mode, cameraIds, statusById)=>mode === "all" ? cameraIds : cameraIds.filter((id)=>$44f6b6f6daff55b4$export$1cdebd372dc3dc4e(statusById[id]));
const $44f6b6f6daff55b4$export$263072a921b30ca7 = async (cameraIds)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    await Promise.allSettled(cameraIds.map(async (id)=>{
        const response = await AxiosUI.get(`/camera/${id}/status/`);
        const store = (0, $3FJ79.useSiteAboutStore).getState();
        store.setCameraStatusForCamera(id, response.data);
        const prefetch = store.rowPrefetchStateByCamera[id];
        if (prefetch && !prefetch.statusLoaded) store.setRowPrefetchStateForCamera(id, {
            ...prefetch,
            statusLoaded: true,
            statusFailed: false
        });
    }));
};
const $44f6b6f6daff55b4$export$11a441b063bb8468 = (cameraIds)=>{
    const idsKey = cameraIds.join(",");
    const idsRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(cameraIds);
    idsRef.current = cameraIds;
    const modeRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef("pending");
    const deadlineRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(0);
    const timerRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const schedule = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback(()=>{
        if (timerRef.current) clearTimeout(timerRef.current);
        const delay = modeRef.current === "all" ? $44f6b6f6daff55b4$export$330ada973b9c80f6 : $44f6b6f6daff55b4$export$68cf044ff2f8ab3c;
        timerRef.current = setTimeout(async ()=>{
            timerRef.current = null;
            if (Date.now() > deadlineRef.current) return;
            const ids = $44f6b6f6daff55b4$export$6a49f49143ef1b2b(modeRef.current, idsRef.current, (0, $3FJ79.useSiteAboutStore).getState().cameraStatusById);
            if (ids.length === 0) return;
            if (!document.hidden) await $44f6b6f6daff55b4$export$263072a921b30ca7(ids);
            schedule();
        }, delay);
    }, []);
    const start = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback((mode)=>{
        // A page-load restart must not cut short an after-action window.
        if (mode === "pending" && modeRef.current === "all" && timerRef.current) return;
        modeRef.current = mode;
        deadlineRef.current = Date.now() + $44f6b6f6daff55b4$export$e58a031831eed7af;
        schedule();
    }, [
        schedule
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (idsKey) start("pending");
    }, [
        idsKey,
        start
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        const onRefresh = ()=>start("all");
        window.addEventListener($44f6b6f6daff55b4$export$78c1ca5a4b6e0729, onRefresh);
        return ()=>{
            window.removeEventListener($44f6b6f6daff55b4$export$78c1ca5a4b6e0729, onRefresh);
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, [
        start
    ]);
};

});

parcelRegister("7m6K6", function(module, exports) {

$parcel$export(module.exports, "DuplicateCameraSiteButton", () => $43c93413167f4a94$export$f8bb54cf9c65b960);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $8jTCz = parcelRequire("8jTCz");

var $8iD8e = parcelRequire("8iD8e");

var $dGZDu = parcelRequire("dGZDu");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $43c93413167f4a94$export$f8bb54cf9c65b960 = ({ selected: selected, setSiteCameras: setSiteCameras, setAlertState: setAlertState, setSelected: setSelected, setSyncNeeded: setSyncNeeded })=>{
    const text = /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8iD8e))), {
                fontSize: "small"
            }),
            "\xa0DUPLICATE CAMERA"
        ]
    });
    const submittedObject = {
        camera_ids: selected
    };
    const navigate = (0, $3T949.useNavigate)();
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
        disabled: !selected[0],
        onClick: ()=>{
            (0, $dGZDu.handleDuplicateCamera)(submittedObject, navigate, setSiteCameras, setAlertState, setSelected, setSyncNeeded);
        },
        text: text
    });
};

});
parcelRegister("8iD8e", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $60ae5be918136ddf$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $60ae5be918136ddf$var$_default = module.exports.default = (0, $60ae5be918136ddf$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"
}), 'ContentCopy');

});

parcelRegister("dGZDu", function(module, exports) {

$parcel$export(module.exports, "handleDuplicateCamera", () => $d6cb9e9532c2bb5a$export$11d150d451ded625);

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("elyck");
var $h5bv8 = parcelRequire("h5bv8");
const $d6cb9e9532c2bb5a$export$11d150d451ded625 = async (submittedObject, navigate, setSiteCameras, setAlertState, setSelected, setSyncNeeded)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $d6cb9e9532c2bb5a$export$11d150d451ded625(submittedObject, navigate, setSiteCameras, setAlertState, setSelected, setSyncNeeded);
    };
    let cameraDuplicateFail = false;
    await AxiosUI.post(`camera/action/duplicate_cameras/`, submittedObject).then(()=>{
        cameraDuplicateFail = false;
    }, (reason)=>{
        cameraDuplicateFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Error duplicating camera, please try again.");
        });
    });
    !cameraDuplicateFail && await AxiosUI.get(`camera/site/?customer__id=${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}`).then((response)=>{
        localStorage.setItem("siteCameras", JSON.stringify(response.data));
        setSiteCameras(response.data);
        setAlertState((previousState)=>{
            return {
                ...previousState,
                changeSuccess: true,
                activateSuccess: false,
                deactivateSuccess: false,
                disarmSuccess: false,
                armSuccess: false,
                syncSuccess: false,
                cameraDeleteSuccess: false
            };
        });
        setSelected([]);
        setSyncNeeded(true);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
    });
};

});


parcelRegister("8Uywj", function(module, exports) {

$parcel$export(module.exports, "ActivateButton", () => $93522142c8fe2cc4$export$9ae2c42103017d76);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $8jTCz = parcelRequire("8jTCz");

var $58Z1D = parcelRequire("58Z1D");

var $514rq = parcelRequire("514rq");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $93522142c8fe2cc4$export$9ae2c42103017d76 = ({ selected: selected, setSiteCameras: setSiteCameras, setAlertState: setAlertState, setSelected: setSelected, setSyncNeeded: setSyncNeeded, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn })=>{
    const text = /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($58Z1D))), {
                fontSize: "small"
            }),
            "\xa0ACTIVATE"
        ]
    });
    const submittedObject = {
        camera_ids: selected
    };
    const navigate = (0, $3T949.useNavigate)();
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
        disabled: !selected[0],
        onClick: ()=>{
            setBackdropLoadingScreenOn(true);
            (0, $514rq.handleActivateCamera)(submittedObject, navigate, setSiteCameras, setAlertState, setSelected, setSyncNeeded, setBackdropLoadingScreenOn);
        },
        text: text
    });
};

});
parcelRegister("58Z1D", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3bed0977c57d7b25$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $3bed0977c57d7b25$var$_default = module.exports.default = (0, $3bed0977c57d7b25$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');

});

parcelRegister("514rq", function(module, exports) {

$parcel$export(module.exports, "handleActivateCamera", () => $2cb0f91c5fc49255$export$95de1180f369ab48);

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("elyck");
var $h5bv8 = parcelRequire("h5bv8");
const $2cb0f91c5fc49255$export$95de1180f369ab48 = async (submittedObject, navigate, setSiteCameras, setAlertState, setSelected, setSyncNeeded, setBackdropLoadingScreenOn)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $2cb0f91c5fc49255$export$95de1180f369ab48(submittedObject, navigate, setSiteCameras, setAlertState, setSelected, setSyncNeeded, setBackdropLoadingScreenOn);
    };
    let cameraActivateFail = false;
    await AxiosUI.post(`camera/action/activate/`, submittedObject).then(()=>{
        cameraActivateFail = false;
    }, (reason)=>{
        cameraActivateFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Camera activation failed, please try again.");
            setBackdropLoadingScreenOn(false);
        });
    });
    !cameraActivateFail && await AxiosUI.get(`camera/site/?customer__id=${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}`).then((response)=>{
        localStorage.setItem("siteCameras", JSON.stringify(response.data));
        setSiteCameras(response.data);
        setAlertState((previousState)=>{
            return {
                ...previousState,
                changeSuccess: true,
                activateSuccess: false,
                deactivateSuccess: false,
                disarmSuccess: false,
                armSuccess: false,
                syncSuccess: false,
                cameraDeleteSuccess: false
            };
        });
        setSelected([]);
        setSyncNeeded(true);
        setBackdropLoadingScreenOn(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
        });
    });
};

});


parcelRegister("cpwsh", function(module, exports) {

$parcel$export(module.exports, "DeactivateButton", () => $92417305baa8b2d8$export$f1a39c7292105984);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $8jTCz = parcelRequire("8jTCz");

var $433j1 = parcelRequire("433j1");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $7QcnD = parcelRequire("7QcnD");
const $92417305baa8b2d8$export$f1a39c7292105984 = ({ selected: selected, setSiteCameras: setSiteCameras, setAlertState: setAlertState, setSelected: setSelected, setSyncNeeded: setSyncNeeded, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setSiteInfo: setSiteInfo })=>{
    const text = /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {
                fontSize: "small"
            }),
            "\xa0DEACTIVATE"
        ]
    });
    const submittedObject = {
        camera_ids: selected
    };
    const navigate = (0, $3T949.useNavigate)();
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
        disabled: !selected[0],
        onClick: ()=>{
            setBackdropLoadingScreenOn(true);
            (0, $7QcnD.handleDeactivateCamera)(submittedObject, navigate, setSiteCameras, setAlertState, setSelected, setSyncNeeded, setBackdropLoadingScreenOn, setSiteInfo);
        },
        text: text
    });
};

});
parcelRegister("433j1", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f2a01b28242b02d$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $2f2a01b28242b02d$var$_default = module.exports.default = (0, $2f2a01b28242b02d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

});

parcelRegister("7QcnD", function(module, exports) {

$parcel$export(module.exports, "handleDeactivateCamera", () => $eae46790524e71f3$export$c4b4949a7d9658e1);

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("elyck");
var $h5bv8 = parcelRequire("h5bv8");

var $ebTQj = parcelRequire("ebTQj");
const $eae46790524e71f3$export$c4b4949a7d9658e1 = async (submittedObject, navigate, setSiteCameras, setAlertState, setSelected, setSyncNeeded, setBackdropLoadingScreenOn, setSiteInfo)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $eae46790524e71f3$export$c4b4949a7d9658e1(submittedObject, navigate, setSiteCameras, setAlertState, setSelected, setSyncNeeded, setBackdropLoadingScreenOn, setSiteInfo);
    };
    let cameraDeactivateFail = false;
    await AxiosUI.post(`camera/action/deactivate/`, submittedObject).then((response)=>{
        (0, $ebTQj.logger).log(JSON.stringify(response.data));
        cameraDeactivateFail = false;
    }, (reason)=>{
        cameraDeactivateFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Camera deactivation failed, please try again.");
            setBackdropLoadingScreenOn(false);
        });
    });
    !cameraDeactivateFail && await AxiosUI.get(`camera/site/?customer__id=${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}`).then((response)=>{
        localStorage.setItem("siteCameras", JSON.stringify(response.data));
        setSiteCameras(response.data);
        let allFalse = true;
        response.data.results.forEach((item)=>{
            if (item.active) allFalse = false;
        });
        if (allFalse) setSiteInfo((previousState)=>{
            return {
                ...previousState,
                active: false
            };
        });
        setAlertState((previousState)=>{
            return {
                ...previousState,
                changeSuccess: true,
                activateSuccess: false,
                deactivateSuccess: false,
                disarmSuccess: false,
                armSuccess: false,
                syncSuccess: false,
                cameraDeleteSuccess: false
            };
        });
        setSelected([]);
        setSyncNeeded(true);
        setBackdropLoadingScreenOn(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
        });
    });
};

});


parcelRegister("697MX", function(module, exports) {

$parcel$export(module.exports, "DeleteCameraButton", () => $8a9c873744369f3e$export$2c441e980e3951f5);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $8jTCz = parcelRequire("8jTCz");

var $cye0Y = parcelRequire("cye0Y");
const $8a9c873744369f3e$export$2c441e980e3951f5 = ({ selected: selected, setDeleteDialogOpen: setDeleteDialogOpen })=>{
    const text = /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cye0Y))), {
                fontSize: "small"
            }),
            "\xa0DELETE"
        ]
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
        disabled: !selected[0],
        onClick: ()=>{
            setDeleteDialogOpen(true);
        },
        text: text
    });
};

});

parcelRegister("i6PP0", function(module, exports) {

$parcel$export(module.exports, "showMilestoneMotionButton", () => $971dce8fde2f55d1$export$286944001367eb94);
$parcel$export(module.exports, "MilestoneMotionButton", () => $971dce8fde2f55d1$export$5b2bfcd6ba41d80e);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $ce8iU = parcelRequire("ce8iU");

var $1TOOV = parcelRequire("1TOOV");

var $iLEpm = parcelRequire("iLEpm");

var $887xF = parcelRequire("887xF");

var $7UDCh = parcelRequire("7UDCh");

var $3baw3 = parcelRequire("3baw3");

var $k1BHZ = parcelRequire("k1BHZ");

var $imWqP = parcelRequire("imWqP");

var $9lwly = parcelRequire("9lwly");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $8jTCz = parcelRequire("8jTCz");

var $4C5NH = parcelRequire("4C5NH");
const $971dce8fde2f55d1$export$286944001367eb94 = (integrationTypeName)=>integrationTypeName === "milestone";
const $971dce8fde2f55d1$export$5b2bfcd6ba41d80e = ({ selected: selected, siteInfo: siteInfo, setSiteCameras: setSiteCameras, setAlertState: setAlertState, setSelected: setSelected, setSyncNeeded: setSyncNeeded, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn })=>{
    const navigate = (0, $3T949.useNavigate)();
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [scope, setScope] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("site");
    const selectedCount = selected.length;
    const openDialog = ()=>{
        setScope(selectedCount > 0 ? "selected" : "site");
        setOpen(true);
    };
    const apply = (enabled)=>{
        setOpen(false);
        setBackdropLoadingScreenOn(true);
        (0, $4C5NH.handleSetMilestoneMotion)({
            siteId: siteInfo.id,
            enabled: enabled,
            cameraIds: scope === "selected" ? selected.map((id)=>Number(id)) : undefined,
            navigate: navigate,
            setSiteCameras: setSiteCameras,
            setAlertState: setAlertState,
            setSelected: setSelected,
            setSyncNeeded: setSyncNeeded,
            setBackdropLoadingScreenOn: setBackdropLoadingScreenOn
        });
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                disabled: false,
                onClick: openDialog,
                text: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9lwly))), {
                            fontSize: "small"
                        }),
                        "\xa0MILESTONE MOTION"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                open: open,
                onClose: ()=>setOpen(false),
                "aria-labelledby": "milestone-motion-dialog-title",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                        id: "milestone-motion-dialog-title",
                        sx: {
                            fontFamily: "Mulish"
                        },
                        children: "Milestone motion"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: "When on, frames are pulled from Milestone only while it reports motion. That cuts bandwidth and load substantially, but detection then depends on Milestone's motion: if it is tuned too tightly, events reach us late or not at all \u2014 and that shows up as a missed detection. It can also add load to the recording server, depending on whether Milestone analyses the video itself or reads the cameras' own motion events. Best used where Milestone motion is known to be well configured."
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                                sx: {
                                    fontFamily: "Mulish",
                                    mt: 2
                                },
                                children: "When off, frames are pulled continuously. New cameras added to this site will follow whichever setting most cameras have. The change is applied on the next Sync."
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $7UDCh.default), {
                                sx: {
                                    mt: 2
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $imWqP.default), {
                                    "aria-label": "Apply to",
                                    value: scope,
                                    onChange: (event)=>setScope(event.target.value),
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                            value: "site",
                                            control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {}),
                                            label: "All cameras on this site"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                            value: "selected",
                                            control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {}),
                                            disabled: selectedCount === 0,
                                            label: `Selected cameras (${selectedCount})`
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                disabled: false,
                                onClick: ()=>setOpen(false),
                                text: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                disabled: false,
                                onClick: ()=>apply(false),
                                text: "Turn off"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                disabled: false,
                                onClick: ()=>apply(true),
                                text: "Turn on"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("ce8iU", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e6d3bd0bfcd0372$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $f3puC = parcelRequire("f3puC");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $6IViO = parcelRequire("6IViO");

var $c5uDx = parcelRequire("c5uDx");

var $k4ank = parcelRequire("k4ank");
'use client';
const $8e6d3bd0bfcd0372$var$_excluded = [
    "className",
    "id"
];
const $8e6d3bd0bfcd0372$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $6IViO.getDialogTitleUtilityClass), classes);
};
const $8e6d3bd0bfcd0372$var$DialogTitleRoot = (0, $anJSP.default)((0, $f3puC.default), {
    name: 'MuiDialogTitle',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const $8e6d3bd0bfcd0372$var$DialogTitle = /*#__PURE__*/ $8T3gX.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className: className, id: idProp } = props, other = (0, $fAJB5.default)(props, $8e6d3bd0bfcd0372$var$_excluded);
    const ownerState = props;
    const classes = $8e6d3bd0bfcd0372$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $8T3gX.useContext((0, $c5uDx.default));
    return /*#__PURE__*/ (0, $k4ank.jsx)($8e6d3bd0bfcd0372$var$DialogTitleRoot, (0, $eJfrs.default)({
        component: "h2",
        className: (0, $iVyaN.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
$8e6d3bd0bfcd0372$var$DialogTitle.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * @ignore
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $8e6d3bd0bfcd0372$export$2e2bcd8739ae039 = $8e6d3bd0bfcd0372$var$DialogTitle;

});

parcelRegister("iLEpm", function(module, exports) {

$parcel$export(module.exports, "default", () => $da9bf5fcbe011118$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $anJSP = parcelRequire("anJSP");
var $3dQcH = parcelRequire("3dQcH");

var $7AQZl = parcelRequire("7AQZl");

var $f3puC = parcelRequire("f3puC");

var $1lR2P = parcelRequire("1lR2P");

var $k4ank = parcelRequire("k4ank");
'use client';
const $da9bf5fcbe011118$var$_excluded = [
    "children",
    "className"
];
const $da9bf5fcbe011118$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $aYNpO.default)(slots, (0, $1lR2P.getDialogContentTextUtilityClass), classes);
    return (0, $eJfrs.default)({}, classes, composedClasses);
};
const $da9bf5fcbe011118$var$DialogContentTextRoot = (0, $anJSP.default)((0, $f3puC.default), {
    shouldForwardProp: (prop)=>(0, $3dQcH.default)(prop) || prop === 'classes',
    name: 'MuiDialogContentText',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $da9bf5fcbe011118$var$DialogContentText = /*#__PURE__*/ $8T3gX.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContentText'
    });
    const { className: className } = props, ownerState = (0, $fAJB5.default)(props, $da9bf5fcbe011118$var$_excluded);
    const classes = $da9bf5fcbe011118$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsx)($da9bf5fcbe011118$var$DialogContentTextRoot, (0, $eJfrs.default)({
        component: "p",
        variant: "body1",
        color: "text.secondary",
        ref: ref,
        ownerState: ownerState,
        className: (0, $iVyaN.default)(classes.root, className)
    }, props, {
        classes: classes
    }));
});
$da9bf5fcbe011118$var$DialogContentText.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $da9bf5fcbe011118$export$2e2bcd8739ae039 = $da9bf5fcbe011118$var$DialogContentText;

});
parcelRegister("1lR2P", function(module, exports) {

$parcel$export(module.exports, "getDialogContentTextUtilityClass", () => $0fc0e6291574624c$export$d9c6dc45f75b0e4f);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $0fc0e6291574624c$export$d9c6dc45f75b0e4f(slot) {
    return (0, $kfTYv.default)('MuiDialogContentText', slot);
}
const $0fc0e6291574624c$var$dialogContentTextClasses = (0, $jh2Zm.default)('MuiDialogContentText', [
    'root'
]);
var $0fc0e6291574624c$export$2e2bcd8739ae039 = $0fc0e6291574624c$var$dialogContentTextClasses;

});


parcelRegister("k1BHZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e94126c99e9423b5$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $dSmkj = parcelRequire("dSmkj");

var $aYNpO = parcelRequire("aYNpO");

var $aBrLz = parcelRequire("aBrLz");

var $aclWg = parcelRequire("aclWg");

var $7AQZl = parcelRequire("7AQZl");

var $dIcna = parcelRequire("dIcna");

var $iMOmE = parcelRequire("iMOmE");

var $1TLb6 = parcelRequire("1TLb6");

var $14t6m = parcelRequire("14t6m");

var $4IU5Y = parcelRequire("4IU5Y");

var $anJSP = parcelRequire("anJSP");
var $3dQcH = parcelRequire("3dQcH");

var $k4ank = parcelRequire("k4ank");
'use client';
const $e94126c99e9423b5$var$_excluded = [
    "checked",
    "checkedIcon",
    "color",
    "icon",
    "name",
    "onChange",
    "size",
    "className"
];
const $e94126c99e9423b5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $iMOmE.default)(color)}`,
            size !== 'medium' && `size${(0, $iMOmE.default)(size)}`
        ]
    };
    return (0, $eJfrs.default)({}, classes, (0, $aYNpO.default)(slots, (0, $4IU5Y.getRadioUtilityClass), classes));
};
const $e94126c99e9423b5$var$RadioRoot = (0, $anJSP.default)((0, $aclWg.default), {
    shouldForwardProp: (prop)=>(0, $3dQcH.default)(prop) || prop === 'classes',
    name: 'MuiRadio',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size !== 'medium' && styles[`size${(0, $iMOmE.default)(ownerState.size)}`],
            styles[`color${(0, $iMOmE.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aBrLz.alpha)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.color !== 'default' && {
        [`&.${(0, $4IU5Y.default).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        }
    }, {
        [`&.${(0, $4IU5Y.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
function $e94126c99e9423b5$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $e94126c99e9423b5$var$defaultCheckedIcon = /*#__PURE__*/ (0, $k4ank.jsx)((0, $dIcna.default), {
    checked: true
});
const $e94126c99e9423b5$var$defaultIcon = /*#__PURE__*/ (0, $k4ank.jsx)((0, $dIcna.default), {});
const $e94126c99e9423b5$var$Radio = /*#__PURE__*/ $8T3gX.forwardRef(function Radio(inProps, ref) {
    var _defaultIcon$props$fo, _defaultCheckedIcon$p;
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiRadio'
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $e94126c99e9423b5$var$defaultCheckedIcon, color: color = 'primary', icon: icon = $e94126c99e9423b5$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = 'medium', className: className } = props, other = (0, $fAJB5.default)(props, $e94126c99e9423b5$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        color: color,
        size: size
    });
    const classes = $e94126c99e9423b5$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $14t6m.default)();
    let checked = checkedProp;
    const onChange = (0, $1TLb6.default)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === 'undefined') checked = $e94126c99e9423b5$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === 'undefined') name = radioGroup.name;
    }
    return /*#__PURE__*/ (0, $k4ank.jsx)($e94126c99e9423b5$var$RadioRoot, (0, $eJfrs.default)({
        type: "radio",
        icon: /*#__PURE__*/ $8T3gX.cloneElement(icon, {
            fontSize: (_defaultIcon$props$fo = $e94126c99e9423b5$var$defaultIcon.props.fontSize) != null ? _defaultIcon$props$fo : size
        }),
        checkedIcon: /*#__PURE__*/ $8T3gX.cloneElement(checkedIcon, {
            fontSize: (_defaultCheckedIcon$p = $e94126c99e9423b5$var$defaultCheckedIcon.props.fontSize) != null ? _defaultCheckedIcon$p : size
        }),
        ownerState: ownerState,
        classes: classes,
        name: name,
        checked: checked,
        onChange: onChange,
        ref: ref,
        className: (0, $iVyaN.default)(classes.root, className)
    }, other));
});
$e94126c99e9423b5$var$Radio.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the component is checked.
   */ checked: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The icon to display when the component is checked.
   * @default <RadioButtonIcon checked />
   */ checkedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'default',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * If `true`, the component is disabled.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The icon to display when the component is unchecked.
   * @default <RadioButtonIcon />
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * The id of the `input` element.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */ inputProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $dSmkj.default),
    /**
   * Name attribute of the `input` element.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, the `input` element is required.
   * @default false
   */ required: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'medium',
            'small'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * The value of the component. The DOM API casts this to a string.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any
};
var $e94126c99e9423b5$export$2e2bcd8739ae039 = $e94126c99e9423b5$var$Radio;

});
parcelRegister("dIcna", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fb8fb65c93e9e67$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");
parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $2go4t = parcelRequire("2go4t");

var $62uri = parcelRequire("62uri");

var $anJSP = parcelRequire("anJSP");
var $3dQcH = parcelRequire("3dQcH");

var $k4ank = parcelRequire("k4ank");
'use client';
const $9fb8fb65c93e9e67$var$RadioButtonIconRoot = (0, $anJSP.default)('span', {
    name: 'MuiRadioButtonIcon',
    shouldForwardProp: (0, $3dQcH.default)
})({
    position: 'relative',
    display: 'flex'
});
const $9fb8fb65c93e9e67$var$RadioButtonIconBackground = (0, $anJSP.default)((0, $2go4t.default), {
    name: 'MuiRadioButtonIcon'
})({
    // Scale applied to prevent dot misalignment in Safari
    transform: 'scale(1)'
});
const $9fb8fb65c93e9e67$var$RadioButtonIconDot = (0, $anJSP.default)((0, $62uri.default), {
    name: 'MuiRadioButtonIcon'
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        left: 0,
        position: 'absolute',
        transform: 'scale(0)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        })
    }, ownerState.checked && {
        transform: 'scale(1)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.shortest
        })
    }));
/**
 * @ignore - internal component.
 */ function $9fb8fb65c93e9e67$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = (0, $eJfrs.default)({}, props, {
        checked: checked
    });
    return /*#__PURE__*/ (0, $k4ank.jsxs)($9fb8fb65c93e9e67$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)($9fb8fb65c93e9e67$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)($9fb8fb65c93e9e67$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
$9fb8fb65c93e9e67$var$RadioButtonIcon.propTypes = {
    /**
   * If `true`, the component is checked.
   */ checked: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   */ fontSize: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'small',
        'medium'
    ])
};
var $9fb8fb65c93e9e67$export$2e2bcd8739ae039 = $9fb8fb65c93e9e67$var$RadioButtonIcon;

});
parcelRegister("2go4t", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a5fbf6c4df9a8fb$export$2e2bcd8739ae039);
parcelRequire("8T3gX");

var $a7uO0 = parcelRequire("a7uO0");

var $k4ank = parcelRequire("k4ank");
'use client';
var $1a5fbf6c4df9a8fb$export$2e2bcd8739ae039 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');

});

parcelRegister("62uri", function(module, exports) {

$parcel$export(module.exports, "default", () => $465a8a9151b352de$export$2e2bcd8739ae039);
parcelRequire("8T3gX");

var $a7uO0 = parcelRequire("a7uO0");

var $k4ank = parcelRequire("k4ank");
'use client';
var $465a8a9151b352de$export$2e2bcd8739ae039 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked');

});


parcelRegister("1TLb6", function(module, exports) {

$parcel$export(module.exports, "default", () => $161f861592163f32$export$2e2bcd8739ae039);

var $lEMz9 = parcelRequire("lEMz9");
var $161f861592163f32$export$2e2bcd8739ae039 = (0, $lEMz9.default);

});

parcelRegister("14t6m", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c7cbd22e6d7593e$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");

var $8MWXv = parcelRequire("8MWXv");
'use client';
function $0c7cbd22e6d7593e$export$2e2bcd8739ae039() {
    return $8T3gX.useContext((0, $8MWXv.default));
}

});
parcelRegister("8MWXv", function(module, exports) {

$parcel$export(module.exports, "default", () => $66608a63851008b5$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");
/**
 * @ignore - internal component.
 */ const $66608a63851008b5$var$RadioGroupContext = /*#__PURE__*/ $8T3gX.createContext(undefined);
$66608a63851008b5$var$RadioGroupContext.displayName = 'RadioGroupContext';
var $66608a63851008b5$export$2e2bcd8739ae039 = $66608a63851008b5$var$RadioGroupContext;

});


parcelRegister("4IU5Y", function(module, exports) {

$parcel$export(module.exports, "getRadioUtilityClass", () => $3706c8d43b669a3f$export$192f7b2363c77155);
$parcel$export(module.exports, "default", () => $3706c8d43b669a3f$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $3706c8d43b669a3f$export$192f7b2363c77155(slot) {
    return (0, $kfTYv.default)('MuiRadio', slot);
}
const $3706c8d43b669a3f$var$radioClasses = (0, $jh2Zm.default)('MuiRadio', [
    'root',
    'checked',
    'disabled',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall'
]);
var $3706c8d43b669a3f$export$2e2bcd8739ae039 = $3706c8d43b669a3f$var$radioClasses;

});


parcelRegister("imWqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5f79b5fcc446b25$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $2SHRA = parcelRequire("2SHRA");

var $4ufw0 = parcelRequire("4ufw0");

var $11ydL = parcelRequire("11ydL");

var $7Wcl5 = parcelRequire("7Wcl5");

var $8MWXv = parcelRequire("8MWXv");

var $1xq4a = parcelRequire("1xq4a");

var $k4ank = parcelRequire("k4ank");
'use client';
const $d5f79b5fcc446b25$var$_excluded = [
    "actions",
    "children",
    "className",
    "defaultValue",
    "name",
    "onChange",
    "value"
];
const $d5f79b5fcc446b25$var$useUtilityClasses = (props)=>{
    const { classes: classes, row: row, error: error } = props;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $4ufw0.getRadioGroupUtilityClass), classes);
};
const $d5f79b5fcc446b25$var$RadioGroup = /*#__PURE__*/ $8T3gX.forwardRef(function RadioGroup(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, children: children, className: className, defaultValue: defaultValue, name: nameProp, onChange: onChange, value: valueProp } = props, other = (0, $fAJB5.default)(props, $d5f79b5fcc446b25$var$_excluded);
    const rootRef = $8T3gX.useRef(null);
    const classes = $d5f79b5fcc446b25$var$useUtilityClasses(props);
    const [value, setValueState] = (0, $7Wcl5.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'RadioGroup'
    });
    $8T3gX.useImperativeHandle(actions, ()=>({
            focus: ()=>{
                let input = rootRef.current.querySelector('input:not(:disabled):checked');
                if (!input) input = rootRef.current.querySelector('input:not(:disabled)');
                if (input) input.focus();
            }
        }), []);
    const handleRef = (0, $11ydL.default)(ref, rootRef);
    const name = (0, $1xq4a.default)(nameProp);
    const contextValue = $8T3gX.useMemo(()=>({
            name: name,
            onChange (event) {
                setValueState(event.target.value);
                if (onChange) onChange(event, event.target.value);
            },
            value: value
        }), [
        name,
        onChange,
        setValueState,
        value
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $8MWXv.default).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $2SHRA.default), (0, $eJfrs.default)({
            role: "radiogroup",
            ref: handleRef,
            className: (0, $iVyaN.default)(classes.root, className)
        }, other, {
            children: children
        }))
    });
});
$d5f79b5fcc446b25$var$RadioGroup.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The default value. Use when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * The name used to reference the value of the control.
   * If you don't provide this prop, it falls back to a randomly generated name.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Callback fired when a radio button is selected.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {string} value The value of the selected radio button.
   * You can pull out the new value by accessing `event.target.value` (string).
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Value of the selected radio button. The DOM API casts this to a string.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any
};
var $d5f79b5fcc446b25$export$2e2bcd8739ae039 = $d5f79b5fcc446b25$var$RadioGroup;

});
parcelRegister("2SHRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2192a644256e0bfc$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $4CNky = parcelRequire("4CNky");

var $c8JM8 = parcelRequire("c8JM8");

var $k1SKW = parcelRequire("k1SKW");

var $k4ank = parcelRequire("k4ank");
'use client';
const $2192a644256e0bfc$var$_excluded = [
    "className",
    "row"
];
const $2192a644256e0bfc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $4CNky.getFormGroupUtilityClass), classes);
};
const $2192a644256e0bfc$var$FormGroupRoot = (0, $anJSP.default)('div', {
    name: 'MuiFormGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap'
    }, ownerState.row && {
        flexDirection: 'row'
    }));
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $2192a644256e0bfc$var$FormGroup = /*#__PURE__*/ $8T3gX.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiFormGroup'
    });
    const { className: className, row: row = false } = props, other = (0, $fAJB5.default)(props, $2192a644256e0bfc$var$_excluded);
    const muiFormControl = (0, $c8JM8.default)();
    const fcs = (0, $k1SKW.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = (0, $eJfrs.default)({}, props, {
        row: row,
        error: fcs.error
    });
    const classes = $2192a644256e0bfc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsx)($2192a644256e0bfc$var$FormGroupRoot, (0, $eJfrs.default)({
        className: (0, $iVyaN.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$2192a644256e0bfc$var$FormGroup.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Display group of elements in a compact row.
   * @default false
   */ row: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $2192a644256e0bfc$export$2e2bcd8739ae039 = $2192a644256e0bfc$var$FormGroup;

});
parcelRegister("4CNky", function(module, exports) {

$parcel$export(module.exports, "getFormGroupUtilityClass", () => $35e0fa0d344647a4$export$d72d4cbdc30b331f);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $35e0fa0d344647a4$export$d72d4cbdc30b331f(slot) {
    return (0, $kfTYv.default)('MuiFormGroup', slot);
}
const $35e0fa0d344647a4$var$formGroupClasses = (0, $jh2Zm.default)('MuiFormGroup', [
    'root',
    'row',
    'error'
]);
var $35e0fa0d344647a4$export$2e2bcd8739ae039 = $35e0fa0d344647a4$var$formGroupClasses;

});


parcelRegister("4ufw0", function(module, exports) {

$parcel$export(module.exports, "getRadioGroupUtilityClass", () => $3445ffc37e7d0236$export$c4cff3a43f7cabb6);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $3445ffc37e7d0236$export$c4cff3a43f7cabb6(slot) {
    return (0, $kfTYv.default)('MuiRadioGroup', slot);
}
const $3445ffc37e7d0236$var$radioGroupClasses = (0, $jh2Zm.default)('MuiRadioGroup', [
    'root',
    'row',
    'error'
]);
var $3445ffc37e7d0236$export$2e2bcd8739ae039 = $3445ffc37e7d0236$var$radioGroupClasses;

});


parcelRegister("9lwly", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6cdf2a998f889db5$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $6cdf2a998f889db5$var$_default = module.exports.default = (0, $6cdf2a998f889db5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "m2.88 7.88 1.54 1.54C4.15 10.23 4 11.1 4 12c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8c-.9 0-1.77.15-2.58.42L7.89 2.89C9.15 2.32 10.54 2 12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12c0-1.47.32-2.86.88-4.12M7 5.5C7 6.33 6.33 7 5.5 7S4 6.33 4 5.5 4.67 4 5.5 4 7 4.67 7 5.5m5.03 3.49h-.07L10.8 12.3h2.39zM12 18c3.31 0 6-2.69 6-6s-2.69-6-6-6-6 2.69-6 6 2.69 6 6 6m-.71-10.5h1.43l3.01 8h-1.39l-.72-2.04h-3.23l-.73 2.04H8.28z"
}), 'MotionPhotosAuto');

});

parcelRegister("4C5NH", function(module, exports) {

$parcel$export(module.exports, "fetchAllSiteCameras", () => $1f4bb10c4e92af22$export$ad1dab49ae1c91bc);
$parcel$export(module.exports, "handleSetMilestoneMotion", () => $1f4bb10c4e92af22$export$6b7156d1645dd1ad);

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");

var $815yO = parcelRequire("815yO");
const $1f4bb10c4e92af22$export$ad1dab49ae1c91bc = async (siteId)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    let page = 1;
    let all = null;
    // eslint-disable-next-line no-constant-condition
    while(true){
        const response = await AxiosUI.get(`camera/site/?customer__id=${siteId}&page=${page}`);
        if (!all) all = response.data;
        else all.results.push(...response.data.results);
        if (!response.data.next) break;
        page += 1;
    }
    return all;
};
const $1f4bb10c4e92af22$export$6b7156d1645dd1ad = async ({ siteId: siteId, enabled: enabled, cameraIds: cameraIds, navigate: navigate, setSiteCameras: setSiteCameras, setAlertState: setAlertState, setSelected: setSelected, setSyncNeeded: setSyncNeeded, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn })=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $1f4bb10c4e92af22$export$6b7156d1645dd1ad({
            siteId: siteId,
            enabled: enabled,
            cameraIds: cameraIds,
            navigate: navigate,
            setSiteCameras: setSiteCameras,
            setAlertState: setAlertState,
            setSelected: setSelected,
            setSyncNeeded: setSyncNeeded,
            setBackdropLoadingScreenOn: setBackdropLoadingScreenOn
        });
    };
    const payload = {
        enabled: enabled
    };
    if (cameraIds && cameraIds.length > 0) payload.camera_ids = cameraIds;
    let failed = false;
    await AxiosUI.post(`customer/${siteId}/milestone_motion/`, payload).then(()=>{
        failed = false;
    }, (reason)=>{
        failed = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            const detail = reason.response?.data?.detail;
            alert(detail ? `Milestone motion update failed: ${detail}` : "Milestone motion update failed, please try again.");
            setBackdropLoadingScreenOn(false);
        });
    });
    if (failed) return;
    await $1f4bb10c4e92af22$export$ad1dab49ae1c91bc(siteId).then((siteCameras)=>{
        localStorage.setItem("siteCameras", JSON.stringify(siteCameras));
        setSiteCameras(siteCameras);
        (0, $815yO.markSiteUnsynced)();
        setSyncNeeded(true);
        setAlertState((previousState)=>({
                ...previousState,
                changeSuccess: true,
                activateSuccess: false,
                deactivateSuccess: false,
                disarmSuccess: false,
                armSuccess: false,
                syncSuccess: false,
                cameraDeleteSuccess: false
            }));
        setSelected([]);
        setBackdropLoadingScreenOn(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            // The update itself succeeded — still flag the sync even if the
            // table refresh failed.
            (0, $815yO.markSiteUnsynced)();
            setSyncNeeded(true);
            setBackdropLoadingScreenOn(false);
        });
    });
};

});


parcelRegister("icq7G", function(module, exports) {

$parcel$export(module.exports, "BulkMotionButton", () => $1acf04748a277c90$export$c82467a95e2ae41e);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $ce8iU = parcelRequire("ce8iU");

var $1TOOV = parcelRequire("1TOOV");

var $887xF = parcelRequire("887xF");

var $3baw3 = parcelRequire("3baw3");

var $2CHqP = parcelRequire("2CHqP");

var $k1BHZ = parcelRequire("k1BHZ");

var $imWqP = parcelRequire("imWqP");

var $9lwly = parcelRequire("9lwly");

var $8jTCz = parcelRequire("8jTCz");

var $815yO = parcelRequire("815yO");

var $l8TQ5 = parcelRequire("l8TQ5");

var $4C5NH = parcelRequire("4C5NH");

var $5DVXN = parcelRequire("5DVXN");
const $1acf04748a277c90$export$3dbb1a3acdebcbee = "SET MOTION\u2026";
const $1acf04748a277c90$export$8e1ff70b4a6cf619 = "Sync the site to apply. If the site is armed, accept the restart when you sync \u2014 re-arming alone won't apply it.";
const $1acf04748a277c90$export$c82467a95e2ae41e = ({ selected: selected, siteCameras: siteCameras, siteInfo: siteInfo, setSiteCameras: setSiteCameras, setSelected: setSelected, setSyncNeeded: setSyncNeeded })=>{
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [choice, setChoice] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("inherit");
    const [running, setRunning] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [progress, setProgress] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        done: 0,
        total: 0
    });
    const [result, setResult] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [refreshFailed, setRefreshFailed] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const selectedCameras = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>selected.map((id)=>{
            const match = siteCameras?.results?.find((camera)=>String(camera.id) === String(id));
            return {
                id: id,
                camera_name: match?.camera_name ?? `Camera ${id}`
            };
        }), [
        selected,
        siteCameras
    ]);
    // The site's own value; on Milestone XProtect "inherit" means each camera's
    // milestone_motion instead, which differs per camera, so no "currently".
    const siteInherited = siteInfo?.integration_type_name === "milestone" ? null : typeof siteInfo?.use_motion === "boolean" ? siteInfo.use_motion : null;
    const openDialog = ()=>{
        setChoice("inherit");
        setResult(null);
        setRefreshFailed(false);
        setProgress({
            done: 0,
            total: 0
        });
        setOpen(true);
    };
    const close = ()=>{
        if (running) return;
        setOpen(false);
        if (result && result.succeeded.length > 0) setSelected([]);
    };
    const apply = async ()=>{
        const cameras = selectedCameras;
        if (cameras.length === 0 || running) return;
        setRunning(true);
        setResult(null);
        setProgress({
            done: 0,
            total: cameras.length
        });
        const outcome = await (0, $l8TQ5.bulkSetMotionOverride)(cameras, (0, $l8TQ5.choiceToOverride)(choice), {
            onProgress: (done, total)=>setProgress({
                    done: done,
                    total: total
                })
        });
        if (outcome.succeeded.length > 0) {
            (0, $815yO.markSiteUnsynced)(String(siteInfo.id));
            setSyncNeeded(true);
            try {
                const refreshed = await (0, $4C5NH.fetchAllSiteCameras)(siteInfo.id);
                localStorage.setItem("siteCameras", JSON.stringify(refreshed));
                setSiteCameras(refreshed);
                (0, $5DVXN.checkForUseMotion)(refreshed?.results ?? []);
            } catch  {
                setRefreshFailed(true);
            }
        }
        setResult(outcome);
        setRunning(false);
    };
    const optionLabel = (option)=>option === "inherit" ? (0, $l8TQ5.inheritLabel)(siteInherited) : (0, $l8TQ5.MOTION_CHOICE_LABELS)[option];
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                disabled: selected.length === 0,
                onClick: openDialog,
                text: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9lwly))), {
                            fontSize: "small"
                        }),
                        "\xa0",
                        $1acf04748a277c90$export$3dbb1a3acdebcbee
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                open: open,
                onClose: close,
                "aria-labelledby": "bulk-motion-dialog-title",
                maxWidth: "sm",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $ce8iU.default), {
                        id: "bulk-motion-dialog-title",
                        sx: {
                            fontFamily: "Mulish"
                        },
                        children: [
                            "Set motion for ",
                            selectedCameras.length,
                            " camera",
                            selectedCameras.length === 1 ? "" : "s"
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                        children: [
                            !result && /*#__PURE__*/ (0, $k4ank.jsx)((0, $imWqP.default), {
                                "aria-label": "Motion setting",
                                name: "bulk-motion-choice",
                                value: choice,
                                onChange: (event)=>{
                                    // Capture eagerly (see CLAUDE.md's setState-updater gotcha).
                                    const next = event.target.value;
                                    setChoice(next);
                                },
                                children: (0, $l8TQ5.MOTION_CHOICES).map((option)=>/*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "mt-1",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                value: option,
                                                disabled: running,
                                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {
                                                    size: "small",
                                                    color: "warning"
                                                }),
                                                label: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                    className: "font-mulish text-[14px] font-semibold",
                                                    children: optionLabel(option)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "ml-[30px] -mt-1 font-mulish text-[13px] text-[#5B6B86]",
                                                children: (0, $l8TQ5.MOTION_CHOICE_DESCRIPTIONS)[option]
                                            })
                                        ]
                                    }, option))
                            }),
                            running && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "mt-3 font-mulish text-[13px]",
                                role: "status",
                                children: [
                                    "Updating ",
                                    progress.done,
                                    " of ",
                                    progress.total,
                                    "\u2026",
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $2CHqP.default), {
                                        variant: "determinate",
                                        color: "warning",
                                        value: progress.total ? progress.done / progress.total * 100 : 0,
                                        sx: {
                                            mt: 1
                                        }
                                    })
                                ]
                            }),
                            result && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "font-mulish text-[14px] text-actuate-blue",
                                "data-testid": "bulk-motion-summary",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                        className: "font-bold",
                                        children: [
                                            "Updated ",
                                            result.succeeded.length,
                                            " of",
                                            " ",
                                            result.succeeded.length + result.failed.length,
                                            " cameras."
                                        ]
                                    }),
                                    result.failed.length > 0 && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        role: "alert",
                                        className: "mt-2",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                                className: "text-[#D93636]",
                                                children: [
                                                    result.failed.length,
                                                    " camera",
                                                    result.failed.length === 1 ? "" : "s",
                                                    " failed:"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("ul", {
                                                className: "ml-5 mt-1 list-disc text-[13px]",
                                                children: result.failed.map(({ camera: camera, error: error })=>/*#__PURE__*/ (0, $k4ank.jsxs)("li", {
                                                        children: [
                                                            camera.camera_name,
                                                            ": ",
                                                            error
                                                        ]
                                                    }, camera.id))
                                            })
                                        ]
                                    }),
                                    result.succeeded.length > 0 && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "mt-2 rounded border-l-4 border-actuate-orange bg-[#FFF4E5] px-3 py-2 text-[13px]",
                                        children: $1acf04748a277c90$export$8e1ff70b4a6cf619
                                    }),
                                    refreshFailed && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "mt-2 text-[13px] text-[#5B6B86]",
                                        children: "The camera list couldn't be refreshed; reload the page to see the updated Use Motion column."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), {
                        children: result ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            disabled: false,
                            onClick: close,
                            text: "Close"
                        }) : /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    disabled: running,
                                    onClick: close,
                                    text: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    disabled: running || selectedCameras.length === 0,
                                    onClick: apply,
                                    text: running ? "Applying\u2026" : "Apply"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("2CHqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e90d1ff3fd03304$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $3JV9M = parcelRequire("3JV9M");

var $aBrLz = parcelRequire("aBrLz");

var $yILjC = parcelRequire("yILjC");

var $iMOmE = parcelRequire("iMOmE");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $88Rr0 = parcelRequire("88Rr0");

var $k4ank = parcelRequire("k4ank");
'use client';
const $1e90d1ff3fd03304$var$_excluded = [
    "className",
    "color",
    "value",
    "valueBuffer",
    "variant"
];
let $1e90d1ff3fd03304$var$_ = (t)=>t, $1e90d1ff3fd03304$var$_t, $1e90d1ff3fd03304$var$_t2, $1e90d1ff3fd03304$var$_t3, $1e90d1ff3fd03304$var$_t4, $1e90d1ff3fd03304$var$_t5, $1e90d1ff3fd03304$var$_t6;
const $1e90d1ff3fd03304$var$TRANSITION_DURATION = 4; // seconds
const $1e90d1ff3fd03304$var$indeterminate1Keyframe = (0, $3JV9M.keyframes)($1e90d1ff3fd03304$var$_t || ($1e90d1ff3fd03304$var$_t = $1e90d1ff3fd03304$var$_`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`));
const $1e90d1ff3fd03304$var$indeterminate2Keyframe = (0, $3JV9M.keyframes)($1e90d1ff3fd03304$var$_t2 || ($1e90d1ff3fd03304$var$_t2 = $1e90d1ff3fd03304$var$_`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`));
const $1e90d1ff3fd03304$var$bufferKeyframe = (0, $3JV9M.keyframes)($1e90d1ff3fd03304$var$_t3 || ($1e90d1ff3fd03304$var$_t3 = $1e90d1ff3fd03304$var$_`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`));
const $1e90d1ff3fd03304$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $iMOmE.default)(color)}`,
            variant
        ],
        dashed: [
            'dashed',
            `dashedColor${(0, $iMOmE.default)(color)}`
        ],
        bar1: [
            'bar',
            `barColor${(0, $iMOmE.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar1Indeterminate',
            variant === 'determinate' && 'bar1Determinate',
            variant === 'buffer' && 'bar1Buffer'
        ],
        bar2: [
            'bar',
            variant !== 'buffer' && `barColor${(0, $iMOmE.default)(color)}`,
            variant === 'buffer' && `color${(0, $iMOmE.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar2Indeterminate',
            variant === 'buffer' && 'bar2Buffer'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $88Rr0.getLinearProgressUtilityClass), classes);
};
const $1e90d1ff3fd03304$var$getColorShade = (theme, color)=>{
    if (color === 'inherit') return 'currentColor';
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === 'light' ? (0, $aBrLz.lighten)(theme.palette[color].main, 0.62) : (0, $aBrLz.darken)(theme.palette[color].main, 0.5);
};
const $1e90d1ff3fd03304$var$LinearProgressRoot = (0, $anJSP.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $iMOmE.default)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $eJfrs.default)({
        position: 'relative',
        overflow: 'hidden',
        display: 'block',
        height: 4,
        zIndex: 0,
        // Fix Safari's bug during composition of different paint.
        '@media print': {
            colorAdjust: 'exact'
        },
        backgroundColor: $1e90d1ff3fd03304$var$getColorShade(theme, ownerState.color)
    }, ownerState.color === 'inherit' && ownerState.variant !== 'buffer' && {
        backgroundColor: 'none',
        '&::before': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'currentColor',
            opacity: 0.3
        }
    }, ownerState.variant === 'buffer' && {
        backgroundColor: 'transparent'
    }, ownerState.variant === 'query' && {
        transform: 'rotate(180deg)'
    }));
const $1e90d1ff3fd03304$var$LinearProgressDashed = (0, $anJSP.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Dashed',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, $iMOmE.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>{
    const backgroundColor = $1e90d1ff3fd03304$var$getColorShade(theme, ownerState.color);
    return (0, $eJfrs.default)({
        position: 'absolute',
        marginTop: 0,
        height: '100%',
        width: '100%'
    }, ownerState.color === 'inherit' && {
        opacity: 0.3
    }, {
        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`,
        backgroundSize: '10px 10px',
        backgroundPosition: '0 -23px'
    });
}, (0, $3JV9M.css)($1e90d1ff3fd03304$var$_t4 || ($1e90d1ff3fd03304$var$_t4 = $1e90d1ff3fd03304$var$_`
    animation: ${0} 3s infinite linear;
  `), $1e90d1ff3fd03304$var$bufferKeyframe));
const $1e90d1ff3fd03304$var$LinearProgressBar1 = (0, $anJSP.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar1',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $iMOmE.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar1Indeterminate,
            ownerState.variant === 'determinate' && styles.bar1Determinate,
            ownerState.variant === 'buffer' && styles.bar1Buffer
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $eJfrs.default)({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        backgroundColor: ownerState.color === 'inherit' ? 'currentColor' : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === 'determinate' && {
        transition: `transform .${$1e90d1ff3fd03304$var$TRANSITION_DURATION}s linear`
    }, ownerState.variant === 'buffer' && {
        zIndex: 1,
        transition: `transform .${$1e90d1ff3fd03304$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState })=>(ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && (0, $3JV9M.css)($1e90d1ff3fd03304$var$_t5 || ($1e90d1ff3fd03304$var$_t5 = $1e90d1ff3fd03304$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), $1e90d1ff3fd03304$var$indeterminate1Keyframe));
const $1e90d1ff3fd03304$var$LinearProgressBar2 = (0, $anJSP.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar2',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles[`barColor${(0, $iMOmE.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar2Indeterminate,
            ownerState.variant === 'buffer' && styles.bar2Buffer
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $eJfrs.default)({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left'
    }, ownerState.variant !== 'buffer' && {
        backgroundColor: ownerState.color === 'inherit' ? 'currentColor' : (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === 'inherit' && {
        opacity: 0.3
    }, ownerState.variant === 'buffer' && {
        backgroundColor: $1e90d1ff3fd03304$var$getColorShade(theme, ownerState.color),
        transition: `transform .${$1e90d1ff3fd03304$var$TRANSITION_DURATION}s linear`
    }), ({ ownerState: ownerState })=>(ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && (0, $3JV9M.css)($1e90d1ff3fd03304$var$_t6 || ($1e90d1ff3fd03304$var$_t6 = $1e90d1ff3fd03304$var$_`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), $1e90d1ff3fd03304$var$indeterminate2Keyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $1e90d1ff3fd03304$var$LinearProgress = /*#__PURE__*/ $8T3gX.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiLinearProgress'
    });
    const { className: className, color: color = 'primary', value: value, valueBuffer: valueBuffer, variant: variant = 'indeterminate' } = props, other = (0, $fAJB5.default)(props, $1e90d1ff3fd03304$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        color: color,
        variant: variant
    });
    const classes = $1e90d1ff3fd03304$var$useUtilityClasses(ownerState);
    const isRtl = (0, $yILjC.useRtl)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === 'determinate' || variant === 'buffer') {
        if (value !== undefined) {
            rootProps['aria-valuenow'] = Math.round(value);
            rootProps['aria-valuemin'] = 0;
            rootProps['aria-valuemax'] = 100;
            let transform = value - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        } else console.error("MUI: You need to provide a value prop when using the determinate or buffer variant of LinearProgress .");
    }
    if (variant === 'buffer') {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        } else console.error("MUI: You need to provide a valueBuffer prop when using the buffer variant of LinearProgress.");
    }
    return /*#__PURE__*/ (0, $k4ank.jsxs)($1e90d1ff3fd03304$var$LinearProgressRoot, (0, $eJfrs.default)({
        className: (0, $iVyaN.default)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar"
    }, rootProps, {
        ref: ref
    }, other, {
        children: [
            variant === 'buffer' ? /*#__PURE__*/ (0, $k4ank.jsx)($1e90d1ff3fd03304$var$LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, $k4ank.jsx)($1e90d1ff3fd03304$var$LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === 'determinate' ? null : /*#__PURE__*/ (0, $k4ank.jsx)($1e90d1ff3fd03304$var$LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    }));
});
$1e90d1ff3fd03304$var$LinearProgress.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'inherit',
            'primary',
            'secondary'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */ valueBuffer: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   * @default 'indeterminate'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'buffer',
        'determinate',
        'indeterminate',
        'query'
    ])
};
var $1e90d1ff3fd03304$export$2e2bcd8739ae039 = $1e90d1ff3fd03304$var$LinearProgress;

});
parcelRegister("88Rr0", function(module, exports) {

$parcel$export(module.exports, "getLinearProgressUtilityClass", () => $5ed8850fedb3f576$export$bc8a6ea1eb17d7c6);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $5ed8850fedb3f576$export$bc8a6ea1eb17d7c6(slot) {
    return (0, $kfTYv.default)('MuiLinearProgress', slot);
}
const $5ed8850fedb3f576$var$linearProgressClasses = (0, $jh2Zm.default)('MuiLinearProgress', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'determinate',
    'indeterminate',
    'buffer',
    'query',
    'dashed',
    'dashedColorPrimary',
    'dashedColorSecondary',
    'bar',
    'barColorPrimary',
    'barColorSecondary',
    'bar1Indeterminate',
    'bar1Determinate',
    'bar1Buffer',
    'bar2Indeterminate',
    'bar2Buffer'
]);
var $5ed8850fedb3f576$export$2e2bcd8739ae039 = $5ed8850fedb3f576$var$linearProgressClasses;

});


parcelRegister("l8TQ5", function(module, exports) {

$parcel$export(module.exports, "MOTION_CHOICES", () => $02eb2b3038625195$export$b94ead73d003e398);
$parcel$export(module.exports, "MOTION_SETTING_LABEL", () => $02eb2b3038625195$export$c5fa9d70a7306f5e);
$parcel$export(module.exports, "MOTION_CHOICE_LABELS", () => $02eb2b3038625195$export$b0537bfa694a07a);
$parcel$export(module.exports, "MOTION_CHOICE_DESCRIPTIONS", () => $02eb2b3038625195$export$a4f63c6297c2fe6b);
$parcel$export(module.exports, "MOTION_SAVED_NOTE", () => $02eb2b3038625195$export$c6f82d8c7547c77c);
$parcel$export(module.exports, "MOTION_SAVE_FAILED", () => $02eb2b3038625195$export$e3ca9bc3ba5bd252);
$parcel$export(module.exports, "inheritLabel", () => $02eb2b3038625195$export$232d999ec61c826f);
$parcel$export(module.exports, "overrideToChoice", () => $02eb2b3038625195$export$c01bcfc292c4b554);
$parcel$export(module.exports, "choiceToOverride", () => $02eb2b3038625195$export$d43e28b426139eae);
$parcel$export(module.exports, "motionSettingVisible", () => $02eb2b3038625195$export$7795c61264343887);
$parcel$export(module.exports, "overrideMayMatter", () => $02eb2b3038625195$export$b3699f18c8256575);
$parcel$export(module.exports, "inheritedMotionValue", () => $02eb2b3038625195$export$f6f31d8182d525dd);
$parcel$export(module.exports, "cameraMotionFromGeneralInfo", () => $02eb2b3038625195$export$b50be911deda0223);
$parcel$export(module.exports, "useCameraMotionStore", () => $02eb2b3038625195$export$542dc775d835b253);
$parcel$export(module.exports, "recordCameraMotionFromGeneralInfo", () => $02eb2b3038625195$export$9d7b720bfbd7e59);
$parcel$export(module.exports, "patchCameraMotionOverride", () => $02eb2b3038625195$export$3260218ffae9baf);
$parcel$export(module.exports, "bulkSetMotionOverride", () => $02eb2b3038625195$export$d867dfb999b73253);
/**
 * Per-camera motion setting (ENG-2242, backend ENG-2067 / admin v2.54.0).
 *
 * `GET/PATCH camera/{id}/general_info/` carries:
 * - `use_motion_override` (read/write, normal camera-edit permission):
 *   `null` = inherit the site, `true` = use motion, `false` = always stream.
 * - `use_motion` (read-only): the resolved value. Precedence is
 *   override > Milestone's per-camera `milestone_motion` > the site's
 *   `Customer.use_motion`.
 *
 * Every PATCH marks the site undeployed server-side, and the value reaches the
 * connector through the settings file, so callers must `markSiteUnsynced()`
 * and tell the operator to Sync.
 */ 
var $9OjAn = parcelRequire("9OjAn");

var $195EM = parcelRequire("195EM");

var $lF8zF = parcelRequire("lF8zF");
const $02eb2b3038625195$export$6eda40a590483f55 = "use_motion_override";
const $02eb2b3038625195$export$b94ead73d003e398 = [
    "inherit",
    "motion",
    "stream"
];
const $02eb2b3038625195$export$c5fa9d70a7306f5e = "Motion";
const $02eb2b3038625195$export$b0537bfa694a07a = {
    motion: "Use motion",
    stream: "Always stream"
};
const $02eb2b3038625195$export$a4f63c6297c2fe6b = {
    inherit: "Follow the site's motion setting.",
    motion: "Use motion: we pull this camera only while your VMS or camera reports motion. Lower load, but if the camera's motion detection isn't set up or never fires, we won't see anything until it does. For Genetec, a camera with no motion events waits for motion and is not pulled until it raises one. Choose Always stream for cameras whose motion detection isn't configured.",
    stream: "Always stream: we pull this camera continuously. Most reliable detection, but more bandwidth and processing for this camera."
};
const $02eb2b3038625195$export$c6f82d8c7547c77c = "Saved. Sync the site to apply. If the site is armed, accept the restart when you sync \u2014 re-arming alone won't apply it.";
const $02eb2b3038625195$export$e3ca9bc3ba5bd252 = "Couldn't save the motion setting. Try again.";
const $02eb2b3038625195$export$76acbf08c77fc922 = (value)=>value ? "On" : "Off";
const $02eb2b3038625195$export$232d999ec61c826f = (inherited)=>typeof inherited === "boolean" ? `Inherit site setting (currently: ${$02eb2b3038625195$export$76acbf08c77fc922(inherited)})` : "Inherit site setting";
const $02eb2b3038625195$export$c01bcfc292c4b554 = (override)=>override === true ? "motion" : override === false ? "stream" : "inherit";
const $02eb2b3038625195$export$d43e28b426139eae = (choice)=>choice === "motion" ? true : choice === "stream" ? false : null;
const $02eb2b3038625195$export$fcd9076908c621c3 = [
    "SMTP_per_camera",
    "speco_smtp",
    "autopatrol"
];
const $02eb2b3038625195$export$54b4b1e9c1fcbdf4 = (integrationTypeName)=>!!integrationTypeName && !$02eb2b3038625195$export$fcd9076908c621c3.includes(integrationTypeName) && (0, $lF8zF.readsSettingsFile)(integrationTypeName);
const $02eb2b3038625195$export$7795c61264343887 = ({ integrationTypeName: integrationTypeName, siteUseMotion: siteUseMotion, cameraUsesMotion: cameraUsesMotion, overrideMatters: overrideMatters })=>$02eb2b3038625195$export$54b4b1e9c1fcbdf4(integrationTypeName) && (siteUseMotion === true || !!cameraUsesMotion || !!overrideMatters);
const $02eb2b3038625195$export$b3699f18c8256575 = ({ integrationTypeName: integrationTypeName, override: override })=>integrationTypeName === "milestone" && typeof override === "boolean";
const $02eb2b3038625195$export$f6f31d8182d525dd = ({ override: override, effective: effective, integrationTypeName: integrationTypeName, siteUseMotion: siteUseMotion, milestoneMotion: milestoneMotion })=>{
    if (override === null || override === undefined) return typeof effective === "boolean" ? effective : null;
    if (integrationTypeName === "milestone") return typeof milestoneMotion === "boolean" ? milestoneMotion : null;
    return typeof siteUseMotion === "boolean" ? siteUseMotion : null;
};
const $02eb2b3038625195$export$b50be911deda0223 = (data)=>{
    if (!data || !Object.prototype.hasOwnProperty.call(data, $02eb2b3038625195$export$6eda40a590483f55)) return null;
    const override = data[$02eb2b3038625195$export$6eda40a590483f55];
    return {
        override: typeof override === "boolean" ? override : null,
        effective: typeof data.use_motion === "boolean" ? data.use_motion : null
    };
};
const $02eb2b3038625195$export$542dc775d835b253 = (0, $9OjAn.create)((set)=>({
        byCamera: {},
        setCameraMotion: (cameraId, state)=>set((current)=>({
                    byCamera: {
                        ...current.byCamera,
                        [String(cameraId)]: state
                    }
                }))
    }));
const $02eb2b3038625195$export$9d7b720bfbd7e59 = (data)=>{
    const state = $02eb2b3038625195$export$b50be911deda0223(data);
    if (state && data?.id != null) $02eb2b3038625195$export$542dc775d835b253.getState().setCameraMotion(data.id, state);
};
const $02eb2b3038625195$export$3260218ffae9baf = async (cameraId, override)=>{
    const response = await (0, $195EM.createApi)("").patch(`/camera/${cameraId}/general_info/`, {
        [$02eb2b3038625195$export$6eda40a590483f55]: override
    });
    return $02eb2b3038625195$export$b50be911deda0223(response?.data) ?? {
        override: override,
        effective: null
    };
};
const $02eb2b3038625195$export$d31664c11703da78 = (reason)=>{
    const data = reason?.response?.data;
    const fieldError = data?.[$02eb2b3038625195$export$6eda40a590483f55];
    if (Array.isArray(fieldError) && fieldError.length > 0) return String(fieldError[0]);
    if (typeof fieldError === "string") return fieldError;
    if (typeof data?.detail === "string") return data.detail;
    const status = reason?.response?.status;
    if (status) return `Request failed (${status})`;
    return reason?.message ? String(reason.message) : "Request failed";
};
const $02eb2b3038625195$export$fa078760dc2672f3 = 4;
const $02eb2b3038625195$export$d867dfb999b73253 = async (cameras, override, { concurrency: concurrency = $02eb2b3038625195$export$fa078760dc2672f3, onProgress: onProgress } = {})=>{
    const result = {
        succeeded: [],
        failed: []
    };
    let next = 0;
    let done = 0;
    const worker = async ()=>{
        while(next < cameras.length){
            const camera = cameras[next];
            next += 1;
            try {
                await $02eb2b3038625195$export$3260218ffae9baf(camera.id, override);
                result.succeeded.push(camera);
            } catch (reason) {
                result.failed.push({
                    camera: camera,
                    error: $02eb2b3038625195$export$d31664c11703da78(reason)
                });
            }
            done += 1;
            onProgress?.(done, cameras.length);
        }
    };
    const workers = Array.from({
        length: Math.max(1, Math.min(concurrency, cameras.length))
    }, worker);
    await Promise.all(workers);
    return result;
};

});
parcelRegister("lF8zF", function(module, exports) {

$parcel$export(module.exports, "readsSettingsFile", () => $96bd9320737431f2$export$1515c635e69cac90);
// Integration types whose sites do NOT read from the connector settings file.
// For these, the site's "Last Synchronized" timestamp (and the "Synced" status
// derived from the same deployment) is meaningless, so it is hidden from site
// views. AI Link, Sentinel Verifier and Clips-based sites all fall into this
// group.
const $96bd9320737431f2$export$47cc1862bfc4693a = [
    "ailink",
    "sentinel-verifier",
    "clips"
];
const $96bd9320737431f2$export$1515c635e69cac90 = (integrationTypeName)=>!$96bd9320737431f2$export$47cc1862bfc4693a.includes(integrationTypeName ?? "");

});


parcelRegister("5DVXN", function(module, exports) {

$parcel$export(module.exports, "checkForUseMotion", () => $221d249a4d8910a5$export$6f213b8d1c3d48e9);

var $3FJ79 = parcelRequire("3FJ79");
const $221d249a4d8910a5$export$6f213b8d1c3d48e9 = (siteCameras)=>{
    const setHideUseMotion = (0, $3FJ79.useSiteAboutStore).getState().setHideUseMotion;
    // Check if any camera has a valid value for use_motion (not undefined, null,
    // or empty string), or a per-camera override (the label can be blank while
    // an override is set, and the column carries the override marker).
    const hasUseMotionValue = siteCameras.some((camera)=>camera?.use_motion !== undefined && camera?.use_motion !== null && camera?.use_motion !== "" || typeof camera?.use_motion_override === "boolean");
    // If no cameras have a valid use_motion value, set hideUseMotion to true
    if (!hasUseMotionValue) setHideUseMotion(true);
    else setHideUseMotion(false);
};

});


parcelRegister("6uwmD", function(module, exports) {

$parcel$export(module.exports, "BulkEmailRecipientsButton", () => $785f95d466aab8a4$export$15d7e76ebe3b92ae);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $ce8iU = parcelRequire("ce8iU");

var $1TOOV = parcelRequire("1TOOV");

var $887xF = parcelRequire("887xF");

var $3baw3 = parcelRequire("3baw3");

var $k1BHZ = parcelRequire("k1BHZ");

var $imWqP = parcelRequire("imWqP");

var $kbChx = parcelRequire("kbChx");

var $6MI6A = parcelRequire("6MI6A");

var $eejVe = parcelRequire("eejVe");

var $2CHqP = parcelRequire("2CHqP");

var $5QW7l = parcelRequire("5QW7l");

var $8jTCz = parcelRequire("8jTCz");

var $815yO = parcelRequire("815yO");

var $4C5NH = parcelRequire("4C5NH");

var $iqWBF = parcelRequire("iqWBF");
const $785f95d466aab8a4$export$e700a8ab82cd4fbf = "Email alert recipients";
const $785f95d466aab8a4$export$18749b95f02d7d1e = "Sync the site to apply. If the site is armed, accept the restart when you sync.";
const $785f95d466aab8a4$var$SEPARATOR = /[\s,;]/;
const $785f95d466aab8a4$var$formatList = (emails)=>emails.length ? emails.join(", ") : "None";
const $785f95d466aab8a4$export$15d7e76ebe3b92ae = ({ siteCameras: siteCameras, siteInfo: siteInfo, setSiteCameras: setSiteCameras, setSyncNeeded: setSyncNeeded })=>{
    const cameras = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>siteCameras?.results ?? [], [
        siteCameras
    ]);
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [mode, setMode] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("add");
    const [emails, setEmails] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [selectedIds, setSelectedIds] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [busy, setBusy] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [preview, setPreview] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [applied, setApplied] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [refreshFailed, setRefreshFailed] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    // What would be sent right now: the chips plus anything still being typed.
    const effectiveEmails = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>(0, $iqWBF.mergeEmails)(emails, (0, $iqWBF.parseEmailInput)(draft)), [
        emails,
        draft
    ]);
    const invalidEmails = effectiveEmails.filter((email)=>!(0, $iqWBF.isValidEmail)(email));
    const allSelected = cameras.length > 0 && selectedIds.length === cameras.length;
    const canSubmit = !busy && effectiveEmails.length > 0 && invalidEmails.length === 0 && selectedIds.length > 0;
    // Any edit makes a shown preview stale.
    const previewKey = `${mode}|${effectiveEmails.join(",")}|${selectedIds.join(",")}`;
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setPreview(null);
    }, [
        previewKey
    ]);
    const openDialog = ()=>{
        setMode("add");
        setEmails([]);
        setDraft("");
        setSelectedIds(cameras.map((camera)=>camera.id));
        setPreview(null);
        setApplied(null);
        setError(null);
        setRefreshFailed(false);
        setOpen(true);
    };
    const close = ()=>{
        if (busy) return;
        setOpen(false);
    };
    const commitDraft = ()=>{
        if (!draft.trim()) return;
        setEmails((prev)=>(0, $iqWBF.mergeEmails)(prev, (0, $iqWBF.parseEmailInput)(draft)));
        setDraft("");
    };
    const handleDraftChange = (value)=>{
        // Typing a separator turns everything before it into chips.
        if ($785f95d466aab8a4$var$SEPARATOR.test(value)) {
            const parts = value.split($785f95d466aab8a4$var$SEPARATOR);
            const remainder = parts.pop() ?? "";
            const complete = (0, $iqWBF.parseEmailInput)(parts.join(","));
            setEmails((prev)=>(0, $iqWBF.mergeEmails)(prev, complete));
            setDraft(remainder);
        } else setDraft(value);
    };
    const handlePaste = (event)=>{
        // A single-line input drops pasted newlines (joining the addresses), so
        // take the clipboard text ourselves.
        const text = event.clipboardData.getData("text");
        if (!text) return;
        event.preventDefault();
        const pasted = (0, $iqWBF.parseEmailInput)(`${draft} ${text}`);
        setEmails((prev)=>(0, $iqWBF.mergeEmails)(prev, pasted));
        setDraft("");
    };
    const removeEmail = (email)=>setEmails((prev)=>prev.filter((existing)=>existing !== email));
    const toggleCamera = (id)=>setSelectedIds((prev)=>prev.includes(id) ? prev.filter((x)=>x !== id) : [
                ...prev,
                id
            ]);
    const run = async (dryRun)=>{
        if (!canSubmit) return;
        commitDraft();
        setBusy(dryRun ? "preview" : "apply");
        setError(null);
        try {
            const response = await (0, $iqWBF.postBulkEmailRecipients)({
                siteId: Number(siteInfo.id),
                // Omit for "all" so the server covers every camera on the site.
                cameraIds: allSelected ? undefined : selectedIds,
                mode: mode,
                emails: effectiveEmails,
                dryRun: dryRun
            });
            if (dryRun) setPreview(response);
            else {
                if (response.changed_count > 0) {
                    (0, $815yO.markSiteUnsynced)(String(siteInfo.id));
                    setSyncNeeded(true);
                    try {
                        const refreshed = await (0, $4C5NH.fetchAllSiteCameras)(siteInfo.id);
                        localStorage.setItem("siteCameras", JSON.stringify(refreshed));
                        setSiteCameras(refreshed);
                    } catch  {
                        setRefreshFailed(true);
                    }
                }
                setApplied(response);
            }
        } catch (err) {
            setError((0, $iqWBF.bulkEmailErrorMessage)(err));
        } finally{
            setBusy(null);
        }
    };
    const unchangedCount = preview ? preview.results.filter((row)=>!row.changed).length : 0;
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                disabled: cameras.length === 0,
                onClick: openDialog,
                text: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5QW7l))), {
                            fontSize: "small"
                        }),
                        "\xa0",
                        $785f95d466aab8a4$export$e700a8ab82cd4fbf
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                open: open,
                onClose: close,
                "aria-labelledby": "bulk-email-dialog-title",
                maxWidth: "md",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                        id: "bulk-email-dialog-title",
                        sx: {
                            fontFamily: "Mulish"
                        },
                        children: "Email alert recipients"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                        children: [
                            applied ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "font-mulish text-[14px] text-actuate-blue",
                                "data-testid": "bulk-email-summary",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                        className: "font-bold",
                                        children: [
                                            "Updated ",
                                            applied.changed_count,
                                            " camera",
                                            applied.changed_count === 1 ? "" : "s",
                                            "."
                                        ]
                                    }),
                                    applied.changed_count === 0 && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "mt-2 text-[13px] text-[#5B6B86]",
                                        children: "Every selected camera already had these recipients."
                                    }),
                                    applied.changed_count > 0 && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "mt-2 rounded border-l-4 border-actuate-orange bg-[#FFF4E5] px-3 py-2 text-[13px]",
                                        children: $785f95d466aab8a4$export$18749b95f02d7d1e
                                    }),
                                    refreshFailed && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "mt-2 text-[13px] text-[#5B6B86]",
                                        children: "The camera list couldn't be refreshed; reload the page to see the latest camera details."
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "font-mulish text-[14px] text-actuate-blue",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $imWqP.default), {
                                        row: true,
                                        "aria-label": "Change type",
                                        name: "bulk-email-mode",
                                        value: mode,
                                        onChange: (event)=>{
                                            // Capture eagerly (see CLAUDE.md's setState-updater gotcha).
                                            const next = event.target.value;
                                            setMode(next);
                                        },
                                        children: (0, $iqWBF.BULK_EMAIL_MODES).map((option)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                value: option,
                                                disabled: !!busy,
                                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {
                                                    size: "small",
                                                    color: "warning"
                                                }),
                                                label: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                    className: "font-mulish text-[14px] font-semibold",
                                                    children: (0, $iqWBF.BULK_EMAIL_MODE_LABELS)[option]
                                                })
                                            }, option))
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "mb-3 text-[13px] text-[#5B6B86]",
                                        children: (0, $iqWBF.BULK_EMAIL_MODE_DESCRIPTIONS)[mode]
                                    }),
                                    emails.length > 0 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "mb-2 flex flex-wrap gap-1",
                                        "data-testid": "bulk-email-chips",
                                        children: emails.map((email)=>{
                                            const valid = (0, $iqWBF.isValidEmail)(email);
                                            return /*#__PURE__*/ (0, $k4ank.jsx)((0, $6MI6A.default), {
                                                label: email,
                                                size: "small",
                                                color: valid ? "default" : "error",
                                                variant: valid ? "filled" : "outlined",
                                                title: valid ? undefined : "Not a valid email address",
                                                "data-invalid": valid ? undefined : "true",
                                                onDelete: busy ? undefined : ()=>removeEmail(email)
                                            }, email);
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        id: "bulk-email-input",
                                        fullWidth: true,
                                        size: "small",
                                        label: "Emails",
                                        placeholder: "Type or paste emails, separated by commas, spaces or new lines",
                                        value: draft,
                                        disabled: !!busy,
                                        onChange: (event)=>{
                                            const value = event.target.value;
                                            handleDraftChange(value);
                                        },
                                        onPaste: handlePaste,
                                        onBlur: commitDraft,
                                        onKeyDown: (event)=>{
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                commitDraft();
                                            }
                                        },
                                        error: invalidEmails.length > 0,
                                        helperText: invalidEmails.length > 0 ? `Not valid: ${invalidEmails.join(", ")}. Fix or remove ${invalidEmails.length === 1 ? "it" : "them"} to continue.` : " "
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "mt-3 flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                                                className: "font-semibold",
                                                children: [
                                                    "Cameras (",
                                                    selectedIds.length,
                                                    " of ",
                                                    cameras.length,
                                                    " selected)"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                        disabled: !!busy || allSelected,
                                                        onClick: ()=>setSelectedIds(cameras.map((camera)=>camera.id)),
                                                        text: "Select all"
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                        disabled: !!busy || selectedIds.length === 0,
                                                        onClick: ()=>setSelectedIds([]),
                                                        text: "Select none"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "max-h-[180px] overflow-y-auto rounded border border-actuate-grey px-2",
                                        children: cameras.map((camera)=>/*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                    disabled: !!busy,
                                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                        size: "small",
                                                        color: "warning",
                                                        checked: selectedIds.includes(camera.id),
                                                        onChange: ()=>toggleCamera(camera.id)
                                                    }),
                                                    label: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                        className: "font-mulish text-[13px]",
                                                        children: camera.camera_name
                                                    })
                                                })
                                            }, camera.id))
                                    }),
                                    busy && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2CHqP.default), {
                                        color: "warning",
                                        sx: {
                                            mt: 2
                                        },
                                        role: "status"
                                    }),
                                    preview && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "mt-3",
                                        "data-testid": "bulk-email-preview",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                                className: "font-semibold",
                                                children: [
                                                    preview.changed_count,
                                                    " camera",
                                                    preview.changed_count === 1 ? "" : "s",
                                                    " will change",
                                                    unchangedCount > 0 && ` \xb7 ${unchangedCount} no change`
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "mt-1 max-h-[220px] overflow-y-auto",
                                                children: /*#__PURE__*/ (0, $k4ank.jsxs)("table", {
                                                    className: "w-full border-collapse text-left text-[13px]",
                                                    children: [
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("thead", {
                                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)("tr", {
                                                                className: "border-b border-actuate-grey",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)("th", {
                                                                        className: "py-1 pr-2",
                                                                        children: "Camera"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)("th", {
                                                                        className: "py-1 pr-2",
                                                                        children: "Current"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)("th", {
                                                                        className: "py-1",
                                                                        children: "New"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("tbody", {
                                                            children: preview.results.map((row)=>/*#__PURE__*/ (0, $k4ank.jsxs)("tr", {
                                                                    "data-testid": `bulk-email-row-${row.camera_id}`,
                                                                    "data-changed": row.changed ? "true" : "false",
                                                                    className: row.changed ? "border-b border-actuate-grey bg-[#FFF4E5]" : "border-b border-actuate-grey text-[#5B6B86]",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)("td", {
                                                                            className: "py-1 pr-2 align-top",
                                                                            children: row.camera_name
                                                                        }),
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)("td", {
                                                                            className: "break-all py-1 pr-2 align-top",
                                                                            children: $785f95d466aab8a4$var$formatList(row.before)
                                                                        }),
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)("td", {
                                                                            className: "break-all py-1 align-top",
                                                                            children: row.changed ? /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                                                className: "font-semibold",
                                                                                children: $785f95d466aab8a4$var$formatList(row.after)
                                                                            }) : "No change"
                                                                        })
                                                                    ]
                                                                }, row.camera_id))
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            error && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                role: "alert",
                                className: "mt-3 font-mulish text-[13px] text-[#D93636]",
                                children: error
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), {
                        children: applied ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            disabled: false,
                            onClick: close,
                            text: "Close"
                        }) : /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    disabled: !!busy,
                                    onClick: close,
                                    text: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    disabled: !canSubmit,
                                    onClick: ()=>run(true),
                                    text: busy === "preview" ? "Previewing\u2026" : "Preview"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    disabled: !canSubmit,
                                    onClick: ()=>run(false),
                                    text: busy === "apply" ? "Applying\u2026" : "Apply"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("6MI6A", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f0970217cdd19e9$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $aBrLz = parcelRequire("aBrLz");

var $jU9PZ = parcelRequire("jU9PZ");

var $11ydL = parcelRequire("11ydL");

var $i4juz = parcelRequire("i4juz");

var $iMOmE = parcelRequire("iMOmE");

var $hhKOZ = parcelRequire("hhKOZ");

var $7AQZl = parcelRequire("7AQZl");

var $anJSP = parcelRequire("anJSP");

var $fa8SY = parcelRequire("fa8SY");

var $k4ank = parcelRequire("k4ank");
'use client';
const $4f0970217cdd19e9$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const $4f0970217cdd19e9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, $iMOmE.default)(size)}`,
            `color${(0, $iMOmE.default)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, $iMOmE.default)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, $iMOmE.default)(color)}`,
            `${variant}${(0, $iMOmE.default)(color)}`
        ],
        label: [
            'label',
            `label${(0, $iMOmE.default)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, $iMOmE.default)(size)}`,
            `avatarColor${(0, $iMOmE.default)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, $iMOmE.default)(size)}`,
            `iconColor${(0, $iMOmE.default)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, $iMOmE.default)(size)}`,
            `deleteIconColor${(0, $iMOmE.default)(color)}`,
            `deleteIcon${(0, $iMOmE.default)(variant)}Color${(0, $iMOmE.default)(color)}`
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $fa8SY.getChipUtilityClass), classes);
};
const $4f0970217cdd19e9$var$ChipRoot = (0, $anJSP.default)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $fa8SY.default).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $fa8SY.default).avatar}`]: styles[`avatar${(0, $iMOmE.default)(size)}`]
            },
            {
                [`& .${(0, $fa8SY.default).avatar}`]: styles[`avatarColor${(0, $iMOmE.default)(color)}`]
            },
            {
                [`& .${(0, $fa8SY.default).icon}`]: styles.icon
            },
            {
                [`& .${(0, $fa8SY.default).icon}`]: styles[`icon${(0, $iMOmE.default)(size)}`]
            },
            {
                [`& .${(0, $fa8SY.default).icon}`]: styles[`iconColor${(0, $iMOmE.default)(iconColor)}`]
            },
            {
                [`& .${(0, $fa8SY.default).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $fa8SY.default).deleteIcon}`]: styles[`deleteIcon${(0, $iMOmE.default)(size)}`]
            },
            {
                [`& .${(0, $fa8SY.default).deleteIcon}`]: styles[`deleteIconColor${(0, $iMOmE.default)(color)}`]
            },
            {
                [`& .${(0, $fa8SY.default).deleteIcon}`]: styles[`deleteIcon${(0, $iMOmE.default)(variant)}Color${(0, $iMOmE.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $iMOmE.default)(size)}`],
            styles[`color${(0, $iMOmE.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, $iMOmE.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, $iMOmE.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $iMOmE.default)(color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $eJfrs.default)({
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${(0, $fa8SY.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${(0, $fa8SY.default).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $fa8SY.default).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $fa8SY.default).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $fa8SY.default).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $fa8SY.default).icon}`]: (0, $eJfrs.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === 'small' && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, $eJfrs.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== 'default' && {
            color: 'inherit'
        })),
        [`& .${(0, $fa8SY.default).deleteIcon}`]: (0, $eJfrs.default)({
            WebkitTapHighlightColor: 'transparent',
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $aBrLz.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $aBrLz.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === 'small' && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== 'default' && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, $aBrLz.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === 'small' && {
        height: 24
    }, ownerState.color !== 'default' && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $fa8SY.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $aBrLz.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== 'default' && {
        [`&.${(0, $fa8SY.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({}, ownerState.clickable && {
        userSelect: 'none',
        WebkitTapHighlightColor: 'transparent',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $aBrLz.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $fa8SY.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $aBrLz.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        '&:active': {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== 'default' && {
        [`&:hover, &.${(0, $fa8SY.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({}, ownerState.variant === 'outlined' && {
        backgroundColor: 'transparent',
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $fa8SY.default).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $fa8SY.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, $fa8SY.default).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $fa8SY.default).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $fa8SY.default).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $fa8SY.default).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $fa8SY.default).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $fa8SY.default).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === 'outlined' && ownerState.color !== 'default' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $aBrLz.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $fa8SY.default).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $aBrLz.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $fa8SY.default).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $aBrLz.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $fa8SY.default).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $aBrLz.alpha)(theme.palette[ownerState.color].main, 0.7),
            '&:hover, &:active': {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const $4f0970217cdd19e9$var$ChipLabel = (0, $anJSP.default)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $iMOmE.default)(size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: 'nowrap'
    }, ownerState.variant === 'outlined' && {
        paddingLeft: 11,
        paddingRight: 11
    }, ownerState.size === 'small' && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        paddingLeft: 7,
        paddingRight: 7
    }));
function $4f0970217cdd19e9$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $4f0970217cdd19e9$var$Chip = /*#__PURE__*/ $8T3gX.forwardRef(function Chip(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = 'medium', variant: variant = 'filled', tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, $fAJB5.default)(props, $4f0970217cdd19e9$var$_excluded);
    const chipRef = $8T3gX.useRef(null);
    const handleRef = (0, $11ydL.default)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $4f0970217cdd19e9$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $4f0970217cdd19e9$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === 'Escape' && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $hhKOZ.default) : ComponentProp || 'div';
    const ownerState = (0, $eJfrs.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $8T3gX.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $4f0970217cdd19e9$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $hhKOZ.default) ? (0, $eJfrs.default)({
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $8T3gX.isValidElement(deleteIconProp) ? /*#__PURE__*/ $8T3gX.cloneElement(deleteIconProp, {
        className: (0, $iVyaN.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $jU9PZ.default), {
        className: (0, $iVyaN.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $8T3gX.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $8T3gX.cloneElement(avatarProp, {
        className: (0, $iVyaN.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $8T3gX.isValidElement(iconProp)) icon = /*#__PURE__*/ $8T3gX.cloneElement(iconProp, {
        className: (0, $iVyaN.default)(classes.icon, iconProp.props.className)
    });
    if (avatar && icon) console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one.");
    return /*#__PURE__*/ (0, $k4ank.jsxs)($4f0970217cdd19e9$var$ChipRoot, (0, $eJfrs.default)({
        as: component,
        className: (0, $iVyaN.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $k4ank.jsx)($4f0970217cdd19e9$var$ChipLabel, {
                className: (0, $iVyaN.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
$4f0970217cdd19e9$var$Chip.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The Avatar element to display.
   */ avatar: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */ children: (0, $i4juz.default),
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */ clickable: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'default',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */ deleteIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Icon element.
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    /**
   * The content of the component.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * @ignore
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */ onDelete: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onKeyUp: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * The size of the component.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'medium',
            'small'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */ skipFocusWhenDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * @ignore
   */ tabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    /**
   * The variant to use.
   * @default 'filled'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'filled',
            'outlined'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ])
};
var $4f0970217cdd19e9$export$2e2bcd8739ae039 = $4f0970217cdd19e9$var$Chip;

});
parcelRegister("jU9PZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7dae0d0171ef1f0$export$2e2bcd8739ae039);
parcelRequire("8T3gX");

var $a7uO0 = parcelRequire("a7uO0");

var $k4ank = parcelRequire("k4ank");
'use client';
var $e7dae0d0171ef1f0$export$2e2bcd8739ae039 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');

});

parcelRegister("fa8SY", function(module, exports) {

$parcel$export(module.exports, "getChipUtilityClass", () => $b09eaeac2122a8f8$export$31444911e4ee6fdd);
$parcel$export(module.exports, "default", () => $b09eaeac2122a8f8$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $b09eaeac2122a8f8$export$31444911e4ee6fdd(slot) {
    return (0, $kfTYv.default)('MuiChip', slot);
}
const $b09eaeac2122a8f8$var$chipClasses = (0, $jh2Zm.default)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
var $b09eaeac2122a8f8$export$2e2bcd8739ae039 = $b09eaeac2122a8f8$var$chipClasses;

});


parcelRegister("5QW7l", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $442ee3fbaf73176d$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $442ee3fbaf73176d$var$_default = module.exports.default = (0, $442ee3fbaf73176d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 14H4V8l8 5 8-5zm-8-7L4 6h16z"
}), 'MailOutline');

});

parcelRegister("iqWBF", function(module, exports) {

$parcel$export(module.exports, "BULK_EMAIL_MODES", () => $b05f8924e1d4cd8c$export$785ef93a374f0a4d);
$parcel$export(module.exports, "BULK_EMAIL_MODE_LABELS", () => $b05f8924e1d4cd8c$export$9a637bfa870b3987);
$parcel$export(module.exports, "BULK_EMAIL_MODE_DESCRIPTIONS", () => $b05f8924e1d4cd8c$export$4b3ef6f9288cbf1f);
$parcel$export(module.exports, "isValidEmail", () => $b05f8924e1d4cd8c$export$371e338370561054);
$parcel$export(module.exports, "parseEmailInput", () => $b05f8924e1d4cd8c$export$69f1bcd085cf4ed2);
$parcel$export(module.exports, "mergeEmails", () => $b05f8924e1d4cd8c$export$ab4cc6c5726dec23);
$parcel$export(module.exports, "postBulkEmailRecipients", () => $b05f8924e1d4cd8c$export$4503268e438545be);
$parcel$export(module.exports, "bulkEmailErrorMessage", () => $b05f8924e1d4cd8c$export$a643363bcd9378f1);

var $195EM = parcelRequire("195EM");
const $b05f8924e1d4cd8c$export$785ef93a374f0a4d = [
    "add",
    "remove",
    "replace"
];
const $b05f8924e1d4cd8c$export$9a637bfa870b3987 = {
    add: "Add",
    remove: "Remove",
    replace: "Replace"
};
const $b05f8924e1d4cd8c$export$4b3ef6f9288cbf1f = {
    add: "Add these emails to each camera, keeping its current recipients.",
    remove: "Remove these emails from each camera; other recipients stay.",
    replace: "Replace each camera's recipients with exactly these emails."
};
// Deliberately simple: one @, no spaces, a dot in the domain. The backend is
// the authority (it answers `invalid_emails`); this only catches typos early.
const $b05f8924e1d4cd8c$var$EMAIL_PATTERN = /^[^\s@,;]+@[^\s@,;]+\.[^\s@,;]+$/;
const $b05f8924e1d4cd8c$export$371e338370561054 = (email)=>$b05f8924e1d4cd8c$var$EMAIL_PATTERN.test(email.trim());
const $b05f8924e1d4cd8c$export$69f1bcd085cf4ed2 = (text)=>{
    const seen = new Set();
    const out = [];
    text.split(/[\s,;]+/).map((token)=>token.trim()).filter(Boolean).forEach((token)=>{
        const key = token.toLowerCase();
        if (!seen.has(key)) {
            seen.add(key);
            out.push(token);
        }
    });
    return out;
};
const $b05f8924e1d4cd8c$export$ab4cc6c5726dec23 = (existing, incoming)=>{
    const seen = new Set(existing.map((email)=>email.toLowerCase()));
    const merged = [
        ...existing
    ];
    incoming.forEach((email)=>{
        const key = email.toLowerCase();
        if (!seen.has(key)) {
            seen.add(key);
            merged.push(email);
        }
    });
    return merged;
};
const $b05f8924e1d4cd8c$export$4503268e438545be = async ({ siteId: siteId, cameraIds: cameraIds, mode: mode, emails: emails, dryRun: dryRun })=>{
    const body = {
        site_id: siteId,
        mode: mode,
        emails: emails,
        dry_run: dryRun
    };
    if (cameraIds) body.camera_ids = cameraIds;
    const response = await (0, $195EM.createApi)("").post("cameras/bulk_ses_recipients/", body);
    return response.data;
};
const $b05f8924e1d4cd8c$export$54a2ea44374f8a0a = "You don't have permission to edit cameras on this site.";
const $b05f8924e1d4cd8c$export$451b07f4d0dd89f9 = "This site couldn't be found.";
const $b05f8924e1d4cd8c$export$a643363bcd9378f1 = (error)=>{
    const axiosError = error;
    const status = axiosError?.response?.status;
    const data = axiosError?.response?.data;
    if (status === 403) return $b05f8924e1d4cd8c$export$54a2ea44374f8a0a;
    if (status === 404) return $b05f8924e1d4cd8c$export$451b07f4d0dd89f9;
    if (status === 400 && data && typeof data === "object") switch(data.code){
        case "invalid_emails":
            {
                const invalid = Array.isArray(data.invalid) ? data.invalid : [];
                return invalid.length ? `These emails aren't valid: ${invalid.join(", ")}` : "One or more emails aren't valid.";
            }
        case "no_emails":
            return "Enter at least one email address.";
        case "unknown_cameras":
            return "Some of the selected cameras are no longer on this site. Reload the page and try again.";
        case "bad_mode":
            return "Choose Add, Remove or Replace and try again.";
        default:
            break;
    }
    return "Something went wrong updating email alert recipients. Please try again.";
};

});


parcelRegister("lugOn", function(module, exports) {

$parcel$export(module.exports, "MotionOverrideMarker", () => $d022fa93421236c8$export$d5cde2bcdf96c36b);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $6MI6A = parcelRequire("6MI6A");

var $cVCJe = parcelRequire("cVCJe");
const $d022fa93421236c8$export$b3f0b2705a6d53bd = "Set on this camera; overrides the site's motion setting. Change it in Edit Camera \u2192 Motion.";
const $d022fa93421236c8$export$d5cde2bcdf96c36b = ({ override: override })=>{
    if (typeof override !== "boolean") return null;
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: $d022fa93421236c8$export$b3f0b2705a6d53bd,
        placement: "top",
        sx: {
            fontSize: "15px",
            fontFamily: "mulish"
        },
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $6MI6A.default), {
            "data-testid": "motion-override-marker",
            label: override ? "Motion (camera)" : "Always stream",
            size: "small",
            variant: "outlined",
            sx: {
                fontFamily: "Mulish",
                ml: 1,
                fontSize: "11px",
                height: 20
            }
        })
    });
};

});

parcelRegister("2mUkt", function(module, exports) {

$parcel$export(module.exports, "getAndSaveSiteImages", () => $1a3fba6039f79458$export$589f65bc2c6a7f28);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $1a3fba6039f79458$export$589f65bc2c6a7f28 = async (siteCameras, setSrcImages, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $1a3fba6039f79458$export$589f65bc2c6a7f28(siteCameras, setSrcImages, navigate);
    };
    const setCameraPreview = (cameraObj, statusData)=>{
        setSrcImages((previousState)=>{
            const name = `${cameraObj.id}full`;
            const previewSrc = (statusData?.preview_url || cameraObj.preview_url || "").trim();
            return {
                ...previousState,
                [cameraObj.id]: /*#__PURE__*/ (0, $k4ank.jsx)($1a3fba6039f79458$var$TooltipPreviewImageWithRetry, {
                    src: previewSrc,
                    onRetry: ()=>{
                        refreshSingleCameraPreview(cameraObj);
                    }
                }),
                [name]: statusData
            };
        });
    };
    const refreshSingleCameraPreview = (cameraObj)=>{
        AxiosUI.get(`/camera/${cameraObj.id}/status/`).then((response)=>{
            setCameraPreview(cameraObj, response.data);
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
        });
    };
    siteCameras.results.forEach((obj)=>{
        refreshSingleCameraPreview(obj);
    });
};
const $1a3fba6039f79458$var$TooltipPreviewImageWithRetry = ({ src: src, onRetry: onRetry })=>{
    const [loadFailed, setLoadFailed] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [retryTriggered, setRetryTriggered] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const normalizedSrc = (src || "").trim();
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setLoadFailed(false);
        setRetryTriggered(false);
    }, [
        normalizedSrc
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if ((!normalizedSrc || loadFailed) && !retryTriggered) {
            setRetryTriggered(true);
            onRetry();
        }
    }, [
        normalizedSrc,
        loadFailed,
        retryTriggered,
        onRetry
    ]);
    if ((!normalizedSrc || loadFailed) && retryTriggered) return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "font-mulish text-[12px] text-gray-600 px-[8px] py-[6px]",
        children: "Camera preview unavailable."
    });
    if (!normalizedSrc || loadFailed) return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "font-mulish text-[12px] text-gray-600 px-[8px] py-[6px]",
        children: "Refreshing camera preview..."
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)("img", {
        src: normalizedSrc,
        alt: "site_image",
        onError: ()=>setLoadFailed(true),
        style: {
            maxWidth: "360px",
            maxHeight: "220px",
            display: "block"
        }
    });
};

});

parcelRegister("j1Imp", function(module, exports) {

$parcel$export(module.exports, "downloadCameraOverview", () => $670d58c38a200e40$export$6672f4618658add0);

var $195EM = parcelRequire("195EM");

var $iIAML = parcelRequire("iIAML");
const $670d58c38a200e40$export$6672f4618658add0 = async (siteId)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const response = await AxiosUI.get(`site_settings_report/${siteId}/cameras_csv/`, {
        responseType: "blob"
    });
    const blob = new Blob([
        response.data
    ], {
        type: "text/csv"
    });
    (0, $iIAML.saveAs)(blob, `camera_overview_site_${siteId}.csv`);
};

});
parcelRegister("iIAML", function(module, exports) {
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})(module.exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, module.exports = g;
});

});


parcelRegister("8kfqT", function(module, exports) {

$parcel$export(module.exports, "EnhancedCameraTableHead", () => $5f761aaed30f618d$export$221337b8c9b62855);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");
var $aVDw9 = parcelRequire("aVDw9");
var $ha39s = parcelRequire("ha39s");
var $4o6Cs = parcelRequire("4o6Cs");
var $kLvBh = parcelRequire("kLvBh");
var $cVCJe = parcelRequire("cVCJe");

var $kbChx = parcelRequire("kbChx");

var $ePwXE = parcelRequire("ePwXE");

var $9lVTU = parcelRequire("9lVTU");

var $8jTCz = parcelRequire("8jTCz");

var $e9rQm = parcelRequire("e9rQm");

var $g0plP = parcelRequire("g0plP");

var $3FJ79 = parcelRequire("3FJ79");
const $5f761aaed30f618d$var$headCells = [
    {
        id: "camera_name",
        numeric: false,
        label: "Camera Name",
        text: "Hover over camera name to see sample image from camera feed."
    },
    {
        id: "active",
        numeric: false,
        label: "Active",
        text: "A green checkmark indicates a camera is running. A red X indicates it is not."
    },
    {
        id: "use_motion",
        numeric: false,
        label: "Use Motion"
    },
    {
        id: "has_ignore_zones",
        numeric: false,
        label: "Ignore Zones",
        text: "A green checkmark indicates the site has active ignore zones. A red X indicates no ignore zones have been created."
    },
    {
        id: "health_status",
        numeric: false,
        label: "Health",
        text: "A green checkmark indicates a camera is running without issue. A red X indicates there is an issue(s) with the camera. Hovering over the X will display the issue(s)."
    },
    {
        id: "optimal_settings",
        numeric: false,
        label: "Optimal Settings",
        text: "A green checkmark indicates this camera has optimal settings.  A warning symbol indicate this camera has acceptable but not optimal settings that may result in performance issues. A red X indicates this camera has bad settings that will likely result in performance issues."
    }
];
const $5f761aaed30f618d$export$221337b8c9b62855 = (props)=>{
    const { onSelectAllClick: onSelectAllClick, numSelected: numSelected = 0, rowCount: rowCount = 0, onRequestSort: onRequestSort, orderBy: orderBy, order: order, permissions: permissions, allExpanded: allExpanded, setAllExpanded: setAllExpanded, setExpandedObject: setExpandedObject, saveExpandedObjectAllTrue: saveExpandedObjectAllTrue, saveExpandedObjectAllFalse: saveExpandedObjectAllFalse, siteInfo: siteInfo } = props;
    const createSortHandler = (property)=>(event)=>{
            onRequestSort(event, property);
        };
    const { hideUseMotion: hideUseMotion } = (0, $3FJ79.useSiteAboutStore)();
    const autopatrolSite = siteInfo.integration_type_name === "autopatrol";
    const hideIgnoreZonesColumn = false;
    const filteredHeadCells = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>{
        let filtered = $5f761aaed30f618d$var$headCells;
        if (hideUseMotion) filtered = filtered.filter((cell)=>cell.id !== "use_motion");
        if (autopatrolSite) filtered = filtered.filter((cell)=>cell.id !== "health_status" && cell.id !== "optimal_settings");
        if (hideIgnoreZonesColumn) filtered = filtered.filter((cell)=>cell.id !== "has_ignore_zones");
        return filtered;
    }, [
        hideUseMotion,
        autopatrolSite,
        hideIgnoreZonesColumn
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
            children: [
                permissions.edit_cameras && siteInfo.integration_type_name !== "autopatrol" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    padding: "checkbox",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                        color: "primary",
                        indeterminate: numSelected > 0 && numSelected < rowCount,
                        checked: rowCount > 0 && numSelected === rowCount,
                        onChange: onSelectAllClick
                    })
                }),
                filteredHeadCells.map((headCell)=>{
                    if (headCell.text) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                        sx: {
                            fontSize: "15px",
                            fontFamily: "mulish",
                            fontWeight: "Bold",
                            maxWidth: 50
                        },
                        style: {
                            minWidth: 110
                        },
                        align: "left",
                        sortDirection: orderBy === headCell.id ? order : false,
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kLvBh.default), {
                            active: orderBy === headCell.id,
                            direction: orderBy === headCell.id ? order : "asc",
                            onClick: createSortHandler(headCell.id),
                            children: [
                                headCell.label,
                                "\xa0",
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                    title: headCell.text,
                                    placement: "top",
                                    sx: {
                                        fontSize: "15px",
                                        fontFamily: "mulish"
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                        fontSize: "small"
                                    })
                                }),
                                orderBy === headCell.id ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                    component: "span",
                                    sx: (0, $9lVTU.default),
                                    children: order === "desc" ? "sorted descending" : "sorted ascending"
                                }) : null
                            ]
                        })
                    }, headCell.id);
                    else return /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                        sx: {
                            fontSize: "15px",
                            fontFamily: "mulish",
                            fontWeight: "Bold"
                        },
                        style: {
                            maxWidth: 100
                        },
                        align: "left",
                        sortDirection: orderBy === headCell.id ? order : false,
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kLvBh.default), {
                            active: orderBy === headCell.id,
                            direction: orderBy === headCell.id ? order : "asc",
                            onClick: createSortHandler(headCell.id),
                            children: [
                                headCell.label,
                                orderBy === headCell.id ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                    component: "span",
                                    sx: (0, $9lVTU.default),
                                    children: order === "desc" ? "sorted descending" : "sorted ascending"
                                }) : null
                            ]
                        })
                    }, headCell.id);
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                    align: "right",
                    sx: {
                        fontFamily: "Mulish",
                        fontWeight: "Bold",
                        fontSize: "15px",
                        minWidth: 150,
                        position: "sticky",
                        right: 0,
                        backgroundColor: "white",
                        zIndex: 1,
                        paddingRight: "40px"
                    },
                    children: [
                        !allExpanded ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            onClick: ()=>{
                                setAllExpanded(true);
                                setExpandedObject((previousState)=>{
                                    //set all items in previous object to true
                                    const newState = {
                                        ...previousState
                                    };
                                    for(const key in newState)newState[key] = true;
                                    return newState;
                                });
                                saveExpandedObjectAllTrue();
                            },
                            text: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "flex flex-row",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9rQm))), {}),
                                    "Expand All"
                                ]
                            }),
                            disabled: false
                        }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            onClick: ()=>{
                                setAllExpanded(false);
                                setExpandedObject((previousState)=>{
                                    //set all items in previous object to false
                                    const newState = {
                                        ...previousState
                                    };
                                    for(const key in newState)newState[key] = false;
                                    return newState;
                                });
                                saveExpandedObjectAllFalse();
                            },
                            text: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "flex flex-row",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g0plP))), {}),
                                    "Collapse All"
                                ]
                            }),
                            disabled: false
                        }),
                        " "
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("kLvBh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1e0b592eb72c127$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $aYNpO = parcelRequire("aYNpO");

var $iVyaN = parcelRequire("iVyaN");

var $fdGrT = parcelRequire("fdGrT");

var $8T3gX = parcelRequire("8T3gX");

var $hhKOZ = parcelRequire("hhKOZ");

var $gfnHo = parcelRequire("gfnHo");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $iMOmE = parcelRequire("iMOmE");

var $2VbjN = parcelRequire("2VbjN");

var $k4ank = parcelRequire("k4ank");
'use client';
const $f1e0b592eb72c127$var$_excluded = [
    "active",
    "children",
    "className",
    "direction",
    "hideSortIcon",
    "IconComponent"
];
const $f1e0b592eb72c127$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, direction: direction, active: active } = ownerState;
    const slots = {
        root: [
            'root',
            active && 'active'
        ],
        icon: [
            'icon',
            `iconDirection${(0, $iMOmE.default)(direction)}`
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $2VbjN.getTableSortLabelUtilityClass), classes);
};
const $f1e0b592eb72c127$var$TableSortLabelRoot = (0, $anJSP.default)((0, $hhKOZ.default), {
    name: 'MuiTableSortLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.active && styles.active
        ];
    }
})(({ theme: theme })=>({
        cursor: 'pointer',
        display: 'inline-flex',
        justifyContent: 'flex-start',
        flexDirection: 'inherit',
        alignItems: 'center',
        '&:focus': {
            color: (theme.vars || theme).palette.text.secondary
        },
        '&:hover': {
            color: (theme.vars || theme).palette.text.secondary,
            [`& .${(0, $2VbjN.default).icon}`]: {
                opacity: 0.5
            }
        },
        [`&.${(0, $2VbjN.default).active}`]: {
            color: (theme.vars || theme).palette.text.primary,
            [`& .${(0, $2VbjN.default).icon}`]: {
                opacity: 1,
                color: (theme.vars || theme).palette.text.secondary
            }
        }
    }));
const $f1e0b592eb72c127$var$TableSortLabelIcon = (0, $anJSP.default)('span', {
    name: 'MuiTableSortLabel',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            styles[`iconDirection${(0, $iMOmE.default)(ownerState.direction)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        fontSize: 18,
        marginRight: 4,
        marginLeft: 4,
        opacity: 0,
        transition: theme.transitions.create([
            'opacity',
            'transform'
        ], {
            duration: theme.transitions.duration.shorter
        }),
        userSelect: 'none'
    }, ownerState.direction === 'desc' && {
        transform: 'rotate(0deg)'
    }, ownerState.direction === 'asc' && {
        transform: 'rotate(180deg)'
    }));
/**
 * A button based label for placing inside `TableCell` for column sorting.
 */ const $f1e0b592eb72c127$var$TableSortLabel = /*#__PURE__*/ $8T3gX.forwardRef(function TableSortLabel(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiTableSortLabel'
    });
    const { active: active = false, children: children, className: className, direction: direction = 'asc', hideSortIcon: hideSortIcon = false, IconComponent: IconComponent = (0, $gfnHo.default) } = props, other = (0, $fAJB5.default)(props, $f1e0b592eb72c127$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        active: active,
        direction: direction,
        hideSortIcon: hideSortIcon,
        IconComponent: IconComponent
    });
    const classes = $f1e0b592eb72c127$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsxs)($f1e0b592eb72c127$var$TableSortLabelRoot, (0, $eJfrs.default)({
        className: (0, $iVyaN.default)(classes.root, className),
        component: "span",
        disableRipple: true,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            children,
            hideSortIcon && !active ? null : /*#__PURE__*/ (0, $k4ank.jsx)($f1e0b592eb72c127$var$TableSortLabelIcon, {
                as: IconComponent,
                className: (0, $iVyaN.default)(classes.icon),
                ownerState: ownerState
            })
        ]
    }));
});
$f1e0b592eb72c127$var$TableSortLabel.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the label will have the active styling (should be true for the sorted column).
   * @default false
   */ active: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Label contents, the arrow will be appended automatically.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The current sort direction.
   * @default 'asc'
   */ direction: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'asc',
        'desc'
    ]),
    /**
   * Hide sort icon when active is false.
   * @default false
   */ hideSortIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Sort icon to use.
   * @default ArrowDownwardIcon
   */ IconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $f1e0b592eb72c127$export$2e2bcd8739ae039 = $f1e0b592eb72c127$var$TableSortLabel;

});
parcelRegister("gfnHo", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd406e2b5ffe09ee$export$2e2bcd8739ae039);
parcelRequire("8T3gX");

var $a7uO0 = parcelRequire("a7uO0");

var $k4ank = parcelRequire("k4ank");
'use client';
var $bd406e2b5ffe09ee$export$2e2bcd8739ae039 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');

});

parcelRegister("2VbjN", function(module, exports) {

$parcel$export(module.exports, "getTableSortLabelUtilityClass", () => $2209af3384c6291b$export$645d356c89a51794);
$parcel$export(module.exports, "default", () => $2209af3384c6291b$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $2209af3384c6291b$export$645d356c89a51794(slot) {
    return (0, $kfTYv.default)('MuiTableSortLabel', slot);
}
const $2209af3384c6291b$var$tableSortLabelClasses = (0, $jh2Zm.default)('MuiTableSortLabel', [
    'root',
    'active',
    'icon',
    'iconDirectionDesc',
    'iconDirectionAsc'
]);
var $2209af3384c6291b$export$2e2bcd8739ae039 = $2209af3384c6291b$var$tableSortLabelClasses;

});


parcelRegister("9lVTU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cf2fd215c7586ad$export$2e2bcd8739ae039);
const $6cf2fd215c7586ad$var$visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
};
var $6cf2fd215c7586ad$export$2e2bcd8739ae039 = $6cf2fd215c7586ad$var$visuallyHidden;

});


parcelRegister("fWsn7", function(module, exports) {

$parcel$export(module.exports, "setDetectionTypeLower", () => $ad73a8df2e316a26$export$26dc0d6789bcf78f);
$parcel$export(module.exports, "descendingComparator", () => $ad73a8df2e316a26$export$2e4529abbf7f89ac);
$parcel$export(module.exports, "getComparator", () => $ad73a8df2e316a26$export$1f14d6e84ea4650a);
$parcel$export(module.exports, "stableSort", () => $ad73a8df2e316a26$export$c7d3d1f96a700512);

var $biDrR = parcelRequire("biDrR");
const $ad73a8df2e316a26$export$26dc0d6789bcf78f = (detectionType)=>{
    let detectionTypeLower = detectionType.slice(0, 1).toLowerCase() + detectionType.slice(1);
    if (detectionTypeLower.includes(" ")) detectionTypeLower = detectionTypeLower.replace(/ /g, "_");
    return detectionTypeLower;
};
function $ad73a8df2e316a26$export$2e4529abbf7f89ac(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
}
function $ad73a8df2e316a26$export$1f14d6e84ea4650a(order, orderBy) {
    let thisOrderBy = orderBy;
    if (orderBy === "utc_time") thisOrderBy = "clip_header_received";
    if (orderBy === "time") thisOrderBy = "clip_received_local";
    if (orderBy === "site") thisOrderBy = "customer_name";
    if (orderBy === "formatted_date") thisOrderBy = "approx_capture_timestamp";
    if (thisOrderBy === "vlm_verdict") {
        const compareDesc = (a, b)=>{
            const rankA = (0, $biDrR.vlmVerdictSortRank)(a);
            const rankB = (0, $biDrR.vlmVerdictSortRank)(b);
            if (rankB < rankA) return -1;
            if (rankB > rankA) return 1;
            return 0;
        };
        return order === "desc" ? compareDesc : (a, b)=>-compareDesc(a, b);
    }
    return order === "desc" ? (a, b)=>$ad73a8df2e316a26$export$2e4529abbf7f89ac(a, b, thisOrderBy) : (a, b)=>-$ad73a8df2e316a26$export$2e4529abbf7f89ac(a, b, thisOrderBy);
}
function $ad73a8df2e316a26$export$c7d3d1f96a700512(array, comparator) {
    const stabilizedThis = array.map((el, index)=>[
            el,
            index
        ]);
    stabilizedThis.sort((a, b)=>{
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el)=>el[0]);
}
const $ad73a8df2e316a26$export$e4d153b3e021fb47 = (name, selected)=>selected.indexOf(name) !== -1;
const $ad73a8df2e316a26$export$903c7efd8f42ee6d = (event, alertData, setAlertData)=>{
    const newAlertData = [];
    if (event.target.checked) alertData.forEach((alert)=>{
        const newAlert = alert;
        newAlert.checked = true;
        newAlertData.push(newAlert);
    });
    else alertData.forEach((alert)=>{
        const newAlert = alert;
        newAlert.checked = false;
        newAlertData.push(newAlert);
    });
    setAlertData(newAlertData);
};
const $ad73a8df2e316a26$export$17410191a3010f2f = (event, alertData, selectedTimeStamp, setAlertData)=>{
    const updatedAlertData = [];
    alertData.forEach((alert)=>{
        const newAlert = alert;
        if (alert.approx_capture_timestamp === selectedTimeStamp) newAlert.checked = event.target.checked;
        updatedAlertData.push(newAlert);
    });
    setAlertData(updatedAlertData);
};

});
parcelRegister("biDrR", function(module, exports) {

$parcel$export(module.exports, "VLM_FILTER_ORDER", () => $07288a9c17ce62ff$export$99c97ef532cf6539);
$parcel$export(module.exports, "VLM_FILTER_LABELS", () => $07288a9c17ce62ff$export$99c26feb379d19af);
$parcel$export(module.exports, "isAlertWithheldFromReceiver", () => $07288a9c17ce62ff$export$e8897b91ac4c82d5);
$parcel$export(module.exports, "getAlertVlmVerdict", () => $07288a9c17ce62ff$export$bd5d7a67d6f6026);
$parcel$export(module.exports, "vlmVerdictSortRank", () => $07288a9c17ce62ff$export$a9277c933b6f36bc);
$parcel$export(module.exports, "hasAlertVlmClassification", () => $07288a9c17ce62ff$export$a34d487fdf9b958b);
$parcel$export(module.exports, "applyVlmFilter", () => $07288a9c17ce62ff$export$e8b60618c32d442b);
$parcel$export(module.exports, "getVlmQueueCounts", () => $07288a9c17ce62ff$export$872305d258f380cf);
$parcel$export(module.exports, "getVlmFilterCount", () => $07288a9c17ce62ff$export$acc52061229af4f6);
$parcel$export(module.exports, "getVlmStatusMessage", () => $07288a9c17ce62ff$export$a41a0fa7f53e9854);
$parcel$export(module.exports, "resolveSelectionOutsideVlmFilter", () => $07288a9c17ce62ff$export$2218259276e85840);
$parcel$export(module.exports, "hasDoubleTakeInAlerts", () => $07288a9c17ce62ff$export$77383ddb38cf02a5);
/**
 * DoubleTake queue buckets (ENG-1756).
 *
 * "Filtered Queue" is the working queue: everything except the alerts
 * DoubleTake thinks are false positives, so unsorted alerts stay visible.
 * "All" adds the likely FPs back. The two verdict buckets show one class each.
 */ const $07288a9c17ce62ff$export$99c97ef532cf6539 = [
    "Filtered Queue",
    "All",
    "Likely TP",
    "Likely FP",
    "Withheld"
];
const $07288a9c17ce62ff$export$99c26feb379d19af = {
    "Filtered Queue": "Filtered Queue",
    All: "All",
    "Likely TP": "Likely TP",
    "Likely FP": "Likely FP",
    Withheld: "Withheld"
};
const $07288a9c17ce62ff$export$e8897b91ac4c82d5 = (row)=>typeof row?.dispatch_suppressed_by === "string" && row.dispatch_suppressed_by.trim().toLowerCase() === "doubletake";
const $07288a9c17ce62ff$var$normalizeVerdict = (verdict)=>{
    if (typeof verdict !== "string") return null;
    return verdict.trim().toLowerCase().replace(/\s+/g, " ");
};
const $07288a9c17ce62ff$var$getVlmClassification = (row)=>{
    if (!row) return null;
    // Prefer backend verdict when present (including explicit nulls).
    if ("vlm_verdict" in row) {
        const normalizedVerdict = $07288a9c17ce62ff$var$normalizeVerdict(row.vlm_verdict);
        if (normalizedVerdict === "passed") return "passed";
        if (normalizedVerdict === "suppressed") return "filtered";
        return null;
    }
    if (typeof row.vlm_filtered === "boolean") return row.vlm_filtered ? "filtered" : "passed";
    if (typeof row.vlm_passed === "boolean") return row.vlm_passed ? "passed" : "filtered";
    if (row.vlm_result === "filtered" || row.vlm_result === "passed") return row.vlm_result;
    return null;
};
const $07288a9c17ce62ff$export$bd5d7a67d6f6026 = (row)=>$07288a9c17ce62ff$var$getVlmClassification(row);
const $07288a9c17ce62ff$export$a9277c933b6f36bc = (row)=>{
    const verdict = $07288a9c17ce62ff$export$bd5d7a67d6f6026(row);
    if (verdict === "passed") return 0;
    if (verdict === "filtered") return 1;
    return 2;
};
const $07288a9c17ce62ff$export$c38e7d4bbe6f327a = (row)=>{
    return $07288a9c17ce62ff$var$getVlmClassification(row) === "filtered";
};
const $07288a9c17ce62ff$export$a34d487fdf9b958b = (row)=>{
    return $07288a9c17ce62ff$var$getVlmClassification(row) !== null;
};
const $07288a9c17ce62ff$export$e8b60618c32d442b = (rows, vlmFilterType = "All")=>{
    if (vlmFilterType === "Filtered Queue") // Everything DoubleTake did not call a false positive — unsorted included.
    return rows.filter((row)=>$07288a9c17ce62ff$var$getVlmClassification(row) !== "filtered");
    if (vlmFilterType === "Likely FP") return rows.filter((row)=>$07288a9c17ce62ff$var$getVlmClassification(row) === "filtered");
    if (vlmFilterType === "Likely TP") return rows.filter((row)=>$07288a9c17ce62ff$var$getVlmClassification(row) === "passed");
    if (vlmFilterType === "Withheld") return rows.filter($07288a9c17ce62ff$export$e8897b91ac4c82d5);
    return rows;
};
const $07288a9c17ce62ff$export$872305d258f380cf = (rows)=>{
    const vlmFiltered = rows.filter((row)=>$07288a9c17ce62ff$var$getVlmClassification(row) === "filtered").length;
    const passed = rows.filter((row)=>$07288a9c17ce62ff$var$getVlmClassification(row) === "passed").length;
    const unresolved = rows.filter((row)=>!row?.detection_type).length;
    const withheld = rows.filter($07288a9c17ce62ff$export$e8897b91ac4c82d5).length;
    return {
        unresolved: unresolved,
        passed: passed,
        vlmFiltered: vlmFiltered,
        withheld: withheld,
        // The working queue: everything except the likely false positives.
        filteredQueue: rows.length - vlmFiltered,
        total: rows.length
    };
};
const $07288a9c17ce62ff$export$acc52061229af4f6 = (counts, filter)=>{
    if (filter === "Filtered Queue") return counts.filteredQueue;
    if (filter === "Likely TP") return counts.passed;
    if (filter === "Likely FP") return counts.vlmFiltered;
    if (filter === "Withheld") return counts.withheld;
    return counts.total;
};
// Detection classes DoubleTake evaluates today. Mirrors _PERSON_CLASSES and
// _VEHICLE_CLASSES in ds-smart-alert-supervisor/lambda/handler.py (vehicle DT
// went to production in AI-1005); every other metric (loiterer, gun, ...)
// bypasses the verifier.
const $07288a9c17ce62ff$var$DOUBLETAKE_SUPPORTED_LABELS = new Set([
    "person",
    "intruder",
    "vehicle",
    "car",
    "truck",
    "bus",
    "machinery"
]);
const $07288a9c17ce62ff$export$94a8d5fc34bd98b3 = (row)=>{
    const label = row?.alert_labels;
    const first = Array.isArray(label) ? label[0] : label;
    if (typeof first !== "string" || first.trim() === "") return true;
    return $07288a9c17ce62ff$var$DOUBLETAKE_SUPPORTED_LABELS.has(first.trim().toLowerCase());
};
const $07288a9c17ce62ff$export$b26882389157489d = (row)=>{
    return row?.vlm_site_enabled === false || row?.vlm_camera_enabled === false;
};
const $07288a9c17ce62ff$export$eeff04a1d226b2c9 = 600000;
const $07288a9c17ce62ff$var$getAlertAgeMs = (row, now)=>{
    const raw = row?.approx_capture_timestamp;
    const seconds = typeof raw === "number" ? raw : parseFloat(raw);
    if (!Number.isFinite(seconds)) return null;
    return now - seconds * 1000;
};
const $07288a9c17ce62ff$export$a41a0fa7f53e9854 = (row, now = Date.now())=>{
    const classification = $07288a9c17ce62ff$var$getVlmClassification(row);
    if (classification === "filtered") {
        if ($07288a9c17ce62ff$export$e8897b91ac4c82d5(row)) return "DOUBLETAKE identified this as a likely false positive \u2014 not sent to the monitoring center";
        return "DOUBLETAKE identified this as a likely false positive";
    }
    if (classification === "passed") return "DOUBLETAKE identified this as a likely true positive";
    const verdict = $07288a9c17ce62ff$var$normalizeVerdict(row?.vlm_verdict);
    if (verdict) return "Alert could not be sorted by DOUBLETAKE";
    if (!$07288a9c17ce62ff$export$94a8d5fc34bd98b3(row)) return "DOUBLETAKE unavailable for this alert metric";
    if ($07288a9c17ce62ff$export$b26882389157489d(row)) return "DOUBLETAKE disabled on this camera";
    const ageMs = $07288a9c17ce62ff$var$getAlertAgeMs(row, now);
    if (ageMs !== null && ageMs <= $07288a9c17ce62ff$export$eeff04a1d226b2c9) return "DOUBLETAKE verdict still pending";
    return "DOUBLETAKE verdict unavailable for this alert";
};
const $07288a9c17ce62ff$export$2218259276e85840 = ({ selectionChanged: selectionChanged, filterChanged: filterChanged, filteredCount: filteredCount })=>{
    if (filteredCount <= 0) return "keep";
    return selectionChanged || filterChanged ? "select-first" : "keep-and-allow-forward";
};
const $07288a9c17ce62ff$export$77383ddb38cf02a5 = (rows)=>{
    if (!Array.isArray(rows) || rows.length === 0) return false;
    let sawFlag = false;
    for (const row of rows){
        if (row?.vlm_camera_enabled === true || row?.vlm_site_enabled === true) return true;
        if ($07288a9c17ce62ff$var$getVlmClassification(row) !== null) return true;
        // ENG-1599/ENG-2272: the receiver gate's stamp is DoubleTake evidence too,
        // so the Withheld tile is never hidden while a withheld badge is showing.
        if ($07288a9c17ce62ff$export$e8897b91ac4c82d5(row)) return true;
        if (typeof row?.vlm_camera_enabled === "boolean" || typeof row?.vlm_site_enabled === "boolean") sawFlag = true;
    }
    return !sawFlag;
};

});


parcelRegister("cIfQ5", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9415e16d70be08fe$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $9415e16d70be08fe$var$_default = module.exports.default = (0, $9415e16d70be08fe$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8m0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4z"
}), 'Sync');

});

parcelRegister("3f8Bb", function(module, exports) {

$parcel$export(module.exports, "handleRefreshCameras", () => $6958cd71db127cab$export$152565802f5135e1);
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $aK4Bb = parcelRequire("aK4Bb");

var $aMH8L = parcelRequire("aMH8L");
parcelRequire("elyck");
var $h5bv8 = parcelRequire("h5bv8");

var $ebTQj = parcelRequire("ebTQj");
const $6958cd71db127cab$export$152565802f5135e1 = (navigate, setSiteInfo, setSiteSchedules, setSiteCameras, setActiveTab, setDataLoaded, setBackdropLoadingScreenOn, setAllSiteSchedules, setVmsVariables, setNoAutoAddCamerasDialogOpen, setArmedStatus, setAiLinkSite, setSiteDeployed, setSyncNeeded, setAlertState, setCamerasNotDeployed, setToolTipTitle, setConfigureMotion, setPatchObject, setArmButtonDisabled, setRecordingServerData, setRecordingServerPatchObject, setRecordingServerVisible, setHealthCheckData, setCamerasRefreshing, setWebhooksInfo, setWebhooksPatchObject)=>{
    const returnFunction = ()=>{
        $6958cd71db127cab$export$152565802f5135e1(navigate, setSiteInfo, setSiteSchedules, setSiteCameras, setActiveTab, setDataLoaded, setBackdropLoadingScreenOn, setAllSiteSchedules, setVmsVariables, setNoAutoAddCamerasDialogOpen, setArmedStatus, setAiLinkSite, setSiteDeployed, setSyncNeeded, setAlertState, setCamerasNotDeployed, setToolTipTitle, setConfigureMotion, setPatchObject, setArmButtonDisabled, setRecordingServerData, setRecordingServerPatchObject, setRecordingServerVisible, setHealthCheckData, setCamerasRefreshing, setWebhooksInfo, setWebhooksPatchObject);
    };
    const AxiosUI = (0, $195EM.createApi)(``);
    AxiosUI.post(`/customer/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}/action/refresh_preview/`).then(()=>{
        setAlertState((previousState)=>{
            return {
                ...previousState,
                refreshCameraSuccess: true
            };
        });
        (0, $aMH8L.handleGetAllData)(Number((0, $h5bv8.getNumbersAfterAboutSite)(location.href)), navigate, setSiteInfo, setSiteSchedules, setSiteCameras, setActiveTab, setDataLoaded, setBackdropLoadingScreenOn, setAllSiteSchedules, setVmsVariables, setNoAutoAddCamerasDialogOpen, setArmedStatus, setAiLinkSite, setSiteDeployed, setSyncNeeded, setAlertState, setCamerasNotDeployed, setToolTipTitle, setConfigureMotion, setPatchObject, setArmButtonDisabled, setRecordingServerData, setRecordingServerPatchObject, setRecordingServerVisible, setHealthCheckData, setWebhooksInfo, setWebhooksPatchObject);
        setCamerasRefreshing(false);
    }, (reason)=>{
        if (reason.request.response.slice(11, 53) === "SocialToken matching query does not exist." || reason.request.response.includes("Returned invalid token from cache") || reason.request.response.slice(11, 53) === "Token is expired") (0, $aK4Bb.getRefreshToken)(navigate, returnFunction);
        else {
            setAlertState((previousState)=>{
                return {
                    ...previousState,
                    refreshCameraFail: true
                };
            });
            setBackdropLoadingScreenOn(false);
            setCamerasRefreshing(false);
            (0, $ebTQj.logger).log(`${reason}`);
        }
    });
};

});
parcelRegister("aMH8L", function(module, exports) {

$parcel$export(module.exports, "handleGetAllData", () => $59bb54b9cf82308c$export$cd392b46a7447457);

var $k4ank = parcelRequire("k4ank");

var $195EM = parcelRequire("195EM");

var $gTuv9 = parcelRequire("gTuv9");

var $7kQyB = parcelRequire("7kQyB");

var $1Ah5f = parcelRequire("1Ah5f");

var $2uQ4j = parcelRequire("2uQ4j");

var $F8wri = parcelRequire("F8wri");

var $iAGEB = parcelRequire("iAGEB");

var $3Zv1D = parcelRequire("3Zv1D");

var $igqrx = parcelRequire("igqrx");

var $3mOKt = parcelRequire("3mOKt");

var $5DVXN = parcelRequire("5DVXN");

var $3FJ79 = parcelRequire("3FJ79");

var $aOOQP = parcelRequire("aOOQP");

var $83bsI = parcelRequire("83bsI");
const $59bb54b9cf82308c$export$cd392b46a7447457 = async (siteId, navigate, setSiteInfo, setSiteSchedules, setSiteCameras, setActiveTab, setDataLoaded, setBackdropLoadingScreenOn, setAllSiteSchedules, setVmsVariables, setNoAutoAddCamerasDialogOpen, setArmedStatus, setAiLinkSite, setSiteDeployed, setSyncNeeded, setAlertState, setCamerasNotDeployed, setToolTipTitle, setConfigureMotion, setPatchObject, setArmButtonDisabled, setRecordingServerData, setRecordingServerPatchObject, setRecordingServerVisible, setHealthCheckData, setWebhooksInfo, setWebhooksPatchObject, getIsMounted, onLoadingPhaseChange)=>{
    const emitLoadingPhase = (phase, progress, _location = "handleGetAllData")=>{
        onLoadingPhaseChange?.(phase, progress);
    };
    localStorage.setItem("siteId", siteId);
    let autoAdd = true;
    // let noAutoAddCamerasDialogOpen = true;
    let siteCameraCount = 0;
    let siteInfoSettingsDeployed = true;
    const AxiosUI = (0, $195EM.createApi)(``);
    const { getFlexSchedules: getFlexSchedules, getNonFlexSchedules: getNonFlexSchedules, setFlexSchedulesOn: setFlexSchedulesOn, setHealthCheckDataZustand: setHealthCheckDataZustand, setBackupWebhookData: setBackupWebhookData, getAutoPatrolCameraProducts: getAutoPatrolCameraProducts, getActiveCameraProductsForAllCameras: getActiveCameraProductsForAllCameras, getLineCrossingsData: getLineCrossingsData, setChmOnlyIgnoreZonesByCamera: setChmOnlyIgnoreZonesByCamera, setCameraStatusById: setCameraStatusById, setIgnoreZonesByCamera: setIgnoreZonesByCamera, setMetadataTagZonesByCamera: setMetadataTagZonesByCamera, setRowPrefetchStateByCamera: setRowPrefetchStateByCamera } = (0, $3FJ79.useSiteAboutStore).getState();
    setChmOnlyIgnoreZonesByCamera({});
    setCameraStatusById({});
    setIgnoreZonesByCamera({});
    setMetadataTagZonesByCamera({});
    setRowPrefetchStateByCamera({});
    const retryFunction = ()=>{
        $59bb54b9cf82308c$export$cd392b46a7447457(siteId, navigate, setSiteInfo, setSiteSchedules, setSiteCameras, setActiveTab, setDataLoaded, setBackdropLoadingScreenOn, setAllSiteSchedules, setVmsVariables, setNoAutoAddCamerasDialogOpen, setArmedStatus, setAiLinkSite, setSiteDeployed, setSyncNeeded, setAlertState, setCamerasNotDeployed, setToolTipTitle, setConfigureMotion, setPatchObject, setArmButtonDisabled, setRecordingServerData, setRecordingServerPatchObject, setRecordingServerVisible, setHealthCheckData, setWebhooksInfo, setWebhooksPatchObject, getIsMounted, onLoadingPhaseChange);
    };
    let getSiteInfoFail = true;
    // let getNVRCamerasFail = true;
    let getExtraFieldsFail = true;
    localStorage.setItem("noAutoAddCamerasDialogOpen", "true");
    let allSiteCameras;
    let hasFlexSchedule = false;
    let autoPatrolSite = false;
    const getSMTPIntructions = ()=>{
        AxiosUI.get(`customer/${siteId}/instructions/`).then((response)=>{
            if (response.data.show_instructions === true) {
                localStorage.setItem("SMTPSite", "true");
                localStorage.setItem("SMTPInstructions", JSON.stringify(response.data));
                setBackdropLoadingScreenOn(false);
            } else {
                localStorage.setItem("SMTPSite", "false");
                setBackdropLoadingScreenOn(false);
            }
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                setBackdropLoadingScreenOn(false);
            });
        });
    };
    const getHealthCheckData = ()=>{
        AxiosUI.get(`healthcheck/by_customer/${siteId}/`).then((response)=>{
            setHealthCheckData(response.data);
            setHealthCheckDataZustand(response.data);
            AxiosUI.get(`webhook_customer/?customer=${siteId}`).then((response)=>{
                if (response.data[0]) {
                    setWebhooksInfo(response.data);
                    setBackupWebhookData(response.data);
                }
                emitLoadingPhase("site-schedules-and-health", undefined, "handleGetAllData:getHealthCheckData-success");
                setDataLoaded(true);
                if (localStorage.selectedIntegrationType === "SMTP per Camera") getSMTPIntructions();
                else setBackdropLoadingScreenOn(false);
            }, (reason)=>{
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    // Fallback: ensure page loads even if webhook API fails
                    emitLoadingPhase("site-schedules-and-health", undefined, "handleGetAllData:getHealthCheckData-webhook-fallback");
                    setDataLoaded(true);
                    if (localStorage.selectedIntegrationType === "SMTP per Camera") getSMTPIntructions();
                    else setBackdropLoadingScreenOn(false);
                });
            });
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                // Fallback: ensure page loads even if health check API fails
                // Try to get webhooks anyway, but if that fails too, still load the page
                AxiosUI.get(`webhook_customer/?customer=${siteId}`).then((response)=>{
                    if (response.data[0]) {
                        setWebhooksInfo(response.data);
                        setBackupWebhookData(response.data);
                    }
                    emitLoadingPhase("site-schedules-and-health", undefined, "handleGetAllData:getHealthCheckData-error-webhook-success");
                    setDataLoaded(true);
                    if (localStorage.selectedIntegrationType === "SMTP per Camera") getSMTPIntructions();
                    else setBackdropLoadingScreenOn(false);
                }, ()=>{
                    // Even if webhook also fails, still load the page
                    emitLoadingPhase("site-schedules-and-health", undefined, "handleGetAllData:getHealthCheckData-error-webhook-error");
                    setDataLoaded(true);
                    if (localStorage.selectedIntegrationType === "SMTP per Camera") getSMTPIntructions();
                    else setBackdropLoadingScreenOn(false);
                });
            });
        });
    };
    const allTheRestOfCalls = ()=>{
        (0, $3FJ79.useSiteAboutStore).getState().checkForEvalinkSiteId(siteId, navigate);
        if (hasFlexSchedule) {
            setFlexSchedulesOn(true);
            getFlexSchedules(siteCameraCount, setAlertState, getHealthCheckData, navigate);
        }
        if (!hasFlexSchedule) {
            setFlexSchedulesOn(false);
            getNonFlexSchedules(siteCameraCount, setAlertState, getHealthCheckData, navigate);
        }
    };
    const prefetchCameraRowData = async (cameras, skipForAutoPatrol)=>{
        if (skipForAutoPatrol || !Array.isArray(cameras) || cameras.length === 0) {
            setCameraStatusById({});
            setIgnoreZonesByCamera({});
            setMetadataTagZonesByCamera({});
            setChmOnlyIgnoreZonesByCamera({});
            setRowPrefetchStateByCamera({});
            emitLoadingPhase("camera-row-prefetch-complete", {
                completed: 0,
                total: 0
            }, "handleGetAllData:prefetch-empty");
            return;
        }
        emitLoadingPhase("camera-row-prefetch-start", {
            completed: 0,
            total: cameras.length
        }, "handleGetAllData:prefetch-start");
        const cameraStatusMap = {};
        const ignoreZonesMap = {};
        const metadataTagZonesMap = {};
        const chmOnlyMap = {};
        const rowPrefetchStateMap = {};
        let completed = 0;
        cameras.forEach((camera)=>{
            rowPrefetchStateMap[camera.id] = {
                statusLoaded: false,
                statusFailed: false,
                ignoreZonesLoaded: false,
                ignoreZonesFailed: false,
                tagZonesLoaded: false,
                tagZonesFailed: false,
                lineCrossingsLoaded: !camera.has_line_crossing,
                lineCrossingsFailed: false
            };
            chmOnlyMap[camera.id] = false;
        });
        await Promise.allSettled(cameras.map(async (camera)=>{
            try {
                const cameraState = rowPrefetchStateMap[camera.id];
                try {
                    const statusResponse = await AxiosUI.get(`/camera/${camera.id}/status/`);
                    cameraStatusMap[camera.id] = statusResponse.data;
                    cameraState.statusLoaded = true;
                } catch (_error) {
                    cameraState.statusFailed = true;
                }
                try {
                    const ignoreZonesResponse = await AxiosUI.get(`/camera/${camera.id}/ignore_zones/`);
                    const normalizedIgnoreZones = (0, $83bsI.addIgnoreLabel)(ignoreZonesResponse.data || []);
                    ignoreZonesMap[camera.id] = normalizedIgnoreZones;
                    chmOnlyMap[camera.id] = (0, $aOOQP.isChmOnlyIgnoreZones)(ignoreZonesResponse.data || []);
                    cameraState.ignoreZonesLoaded = true;
                } catch (_error) {
                    cameraState.ignoreZonesFailed = true;
                }
                try {
                    const tagZonesResponse = await AxiosUI.get(`tagzone/?camera=${camera.id}`);
                    metadataTagZonesMap[camera.id] = tagZonesResponse.data?.results || [];
                    cameraState.tagZonesLoaded = true;
                } catch (_error) {
                    cameraState.tagZonesFailed = true;
                }
                if (camera.has_line_crossing) {
                    await getLineCrossingsData(navigate, camera.id);
                    const lineCrossingsData = (0, $3FJ79.useSiteAboutStore).getState().lineCrossingsData;
                    if (Object.prototype.hasOwnProperty.call(lineCrossingsData, camera.id)) cameraState.lineCrossingsLoaded = true;
                    else cameraState.lineCrossingsFailed = true;
                }
            } finally{
                completed += 1;
                emitLoadingPhase("camera-row-prefetch-progress", {
                    completed: completed,
                    total: cameras.length
                }, "handleGetAllData:prefetch-progress");
            }
        }));
        setCameraStatusById(cameraStatusMap);
        setIgnoreZonesByCamera(ignoreZonesMap);
        setMetadataTagZonesByCamera(metadataTagZonesMap);
        setChmOnlyIgnoreZonesByCamera(chmOnlyMap);
        setRowPrefetchStateByCamera(rowPrefetchStateMap);
        emitLoadingPhase("camera-row-prefetch-complete", {
            completed: cameras.length,
            total: cameras.length
        }, "handleGetAllData:prefetch-complete");
    };
    const getSiteCameras = async (pageNumber, autoPatrolSite)=>{
        await AxiosUI.get(`camera/site/?customer__id=${siteId}&page=${pageNumber}`).then(async (response)=>{
            if (getIsMounted && !getIsMounted()) return;
            if (response.data.count > 0) {
                // response.data.results.forEach((cameraObj: SiteCamerasResult) => {
                //   if (autoPatrolSite) {
                //     getAutoPatrolCameraProducts(navigate, Number(cameraObj.id));
                //   }
                // });
                if (pageNumber === 1) {
                    allSiteCameras = response.data;
                    siteCameraCount = response.data.count;
                }
                if (pageNumber > 1) allSiteCameras.results.push(...response.data.results);
                if (response.data.next) return getSiteCameras(pageNumber + 1, autoPatrolSite);
                else {
                    localStorage.setItem("siteCameras", JSON.stringify(allSiteCameras));
                    setSiteCameras(allSiteCameras);
                    emitLoadingPhase("site-cameras", undefined, "handleGetAllData:getSiteCameras-pre-prefetch");
                    await prefetchCameraRowData(allSiteCameras.results, autoPatrolSite);
                    (0, $5DVXN.checkForUseMotion)(allSiteCameras.results);
                    allTheRestOfCalls();
                    if (autoPatrolSite && allSiteCameras.results?.length > 0) getActiveCameraProductsForAllCameras(navigate, allSiteCameras.results.map((c)=>c.id));
                    else if (allSiteCameras.results?.length > 0) (0, $gTuv9.checkForImmixOrSureviewOrSentinel)(response.data.results[0].id, navigate);
                    if (siteInfoSettingsDeployed && localStorage.navigatedFromEditCameraPage !== "true") response.data.results.forEach((cameraObj)=>{
                        if (!cameraObj.deployed) {
                            setCamerasNotDeployed(true);
                            setSyncNeeded(true);
                        }
                    });
                    else if (siteInfoSettingsDeployed && localStorage.navigatedFromEditCameraPage === "true") localStorage.removeItem("navigatedFromEditCameraPage");
                }
            } else {
                setSiteCameras(response.data);
                await prefetchCameraRowData([], autoPatrolSite);
                emitLoadingPhase("site-cameras", undefined, "handleGetAllData:getSiteCameras-empty");
                allTheRestOfCalls();
                localStorage.setItem("siteCameras", JSON.stringify(response.data));
            }
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                alert("Error loading site data");
                navigate(`/sites`);
            });
        });
    };
    await AxiosUI.get(`customer/${siteId}/about/`).then(async (response)=>{
        if (getIsMounted && !getIsMounted()) return;
        getSiteInfoFail = false;
        if (response.data?.has_flex_schedule) {
            hasFlexSchedule = true;
            localStorage.setItem("flexSchedulesOn", "true");
        }
        (0, $7kQyB.fetchAddCameraInfo)(siteId, navigate, {
            silent: true
        });
        if (response.data.integration_type_name === "autopatrol") autoPatrolSite = true;
        localStorage.setItem("selectedIntegrationType", (0, $3mOKt.integrationsMatcher)("FullName", response.data.integration_type_name));
        if (response.data.integration_type_name === "autopatrol") await (0, $3FJ79.useSiteAboutStore).getState().getAutoPatrolSchedules(navigate, siteId);
        if (response.data.integration_type_name === "milestone") {
            setRecordingServerVisible(true);
            (0, $iAGEB.getRecordingServerData)(response.data.id, setRecordingServerData, setRecordingServerPatchObject, navigate);
        }
        localStorage.setItem("siteInfo", JSON.stringify(response.data));
        const siteInfo = response.data;
        setSiteInfo(response.data);
        // For AutoPatrol sites, also set siteInfo in Zustand store
        if (response.data.integration_type_name === "autopatrol") (0, $3FJ79.useSiteAboutStore).getState().setSiteInfo(response.data);
        (0, $F8wri.checkArmedStatus)(response.data, setArmButtonDisabled, navigate, setSiteInfo, setArmedStatus, getIsMounted);
        setPatchObject({
            name: siteInfo.name
        });
        const newVMSVariables = [];
        siteInfo.extra_fields.forEach((object)=>{
            const newArray = [
                `${object.label}`,
                `${siteInfo[object.id]}`,
                `${object.id}`,
                `${object.type}`,
                object.choices
            ];
            object.choices ? newArray[4] = object.choices : newArray[4] = object.options;
            // ENG-2535: [5] = visible_when display rule (absent = always shown)
            newArray[5] = object.visible_when;
            newVMSVariables.push(newArray);
        });
        setVmsVariables(newVMSVariables);
        // For AutoPatrol sites, also set vmsVariables in Zustand store
        if (siteInfo.integration_type_name === "autopatrol") (0, $3FJ79.useSiteAboutStore).getState().setVmsVariables(newVMSVariables);
        localStorage.setItem("siteInfo", JSON.stringify(siteInfo));
        localStorage.setItem("integrationType", siteInfo.onboarding_integration);
        if (siteInfo.auto_add) {
            localStorage.setItem("autoAdd", "true");
            autoAdd = true;
        } else {
            localStorage.setItem("autoAdd", "false");
            autoAdd = false;
        }
        if (siteInfo.armed) setArmedStatus(true);
        if (!siteInfo.armed) setArmedStatus(false);
        if (siteInfo.armed_status === "DISARMING" || siteInfo.armed_status === "NOT_RUNNING") setArmedStatus(false);
        if (siteInfo.armed_status === "WARNING" || siteInfo.armed_status === "ERROR" || siteInfo.armed_status === "ARMED_OUTSIDE_SCHEDULE" || siteInfo.armed_status === "ARMING") setArmedStatus(true);
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
        // For autopatrol sites: vCH-only shows SchedulesTab; has AutoPatrol schedule shows empty (SiteAboutAutoPatrol mounts and manages its own tabs)
        if (siteInfo.integration_type_name === "autopatrol") {
            const vCHOnly = (0, $3FJ79.useSiteAboutStore).getState().vCHOnlySchedules;
            if (vCHOnly) setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $2uQ4j.SchedulesTab), {
                siteInfo: siteInfo
            }));
            else setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
        } else setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $1Ah5f.GeneralInfoTab), {
            siteInfo: siteInfo,
            setSiteInfo: setSiteInfo,
            setActiveTab: setActiveTab,
            vmsVariables: newVMSVariables
        }));
        localStorage.setItem("integrationType", siteInfo.onboarding_integration);
        if (siteInfo.auto_add) {
            localStorage.setItem("autoAdd", "true");
            autoAdd = true;
        } else {
            localStorage.setItem("autoAdd", "false");
            autoAdd = false;
        }
        if (siteInfo.integration_type_name === "ailink") setAiLinkSite(true);
        if (!siteInfo.settings_deployed && siteInfo.integration_type_name !== "ailink") {
            setSiteDeployed(false);
            setSyncNeeded(true);
        }
        if (siteInfo.settings_deployed) siteInfoSettingsDeployed = true;
        if (!siteInfo.settings_deployed) siteInfoSettingsDeployed = false;
        if (siteInfo.armed_status === "DISARMING") setToolTipTitle("Disarm command received. Site is in the process of disarming.  It may take a few moments for arm status to update.");
        if (siteInfo.armed_status === "ARMING") setToolTipTitle("Arm command received. Site is in the process of arming. It may take a few moments for arm status to update.");
        if (siteInfo.show_configure_motion) setConfigureMotion(true);
        else setConfigureMotion(false);
        emitLoadingPhase("site-metadata", undefined, "handleGetAllData:site-metadata");
    }, (reason)=>{
        getSiteInfoFail = true;
        if ((0, $igqrx.isResourceNotFoundError)(reason)) {
            setBackdropLoadingScreenOn(false);
            (0, $igqrx.navigateToResourceNotFound)(navigate, "site", siteId);
            return;
        }
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
            if (localStorage.siteInfo) try {
                const cachedSiteInfo = JSON.parse(localStorage.siteInfo);
                if (String(cachedSiteInfo?.id) === String(siteId)) {
                    setSiteInfo(cachedSiteInfo);
                    setDataLoaded(true);
                }
            } catch  {
            // Ignore invalid cached site info.
            }
            localStorage.setItem("autoAdd", "true");
            autoAdd = true;
        });
    });
    !getSiteInfoFail && await AxiosUI.get(`nvr_camera/extra_fields/?customer__id=${siteId}`).then((response)=>{
        getExtraFieldsFail = false;
        localStorage.setItem("additionalFieldNamesArray", JSON.stringify(response.data));
        emitLoadingPhase("site-extra-fields", undefined, "handleGetAllData:site-extra-fields");
    }, (reason)=>{
        getExtraFieldsFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
    });
    if (!getSiteInfoFail && !getExtraFieldsFail) await getSiteCameras(1, autoPatrolSite);
};

});
parcelRegister("gTuv9", function(module, exports) {

$parcel$export(module.exports, "applyImmixSureviewSentinelFromGeneralInfoResponse", () => $f29aa8eb77ffef10$export$3189bb70abb3e908);
$parcel$export(module.exports, "checkForImmixOrSureviewOrSentinel", () => $f29aa8eb77ffef10$export$ca8e5a2c2c4e4478);

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $f29aa8eb77ffef10$export$3189bb70abb3e908 = (data)=>{
    if (!data?.streams?.[0]) return;
    data.streams.forEach((obj)=>{
        if (obj.sureview_alerts?.[0]) {
            localStorage.setItem("immixAlertsSite", "false");
            localStorage.setItem("sureviewAlertsSite", "true");
            localStorage.setItem("sentinelAlertsSite", "false");
            localStorage.setItem("diceAlertsSite", "false");
        }
        if (obj.immix_alerts?.[0]) {
            localStorage.setItem("immixAlertsSite", "true");
            localStorage.setItem("sentinelAlertsSite", "false");
            localStorage.setItem("sureviewAlertsSite", "false");
            localStorage.setItem("diceAlertsSite", "false");
            localStorage.setItem("immixAlertPostObject", JSON.stringify({
                id: obj.immix_alerts[0].id,
                immix_server: obj.immix_alerts[0].immix_server,
                immix_port: obj.immix_alerts[0].immix_port
            }));
        }
        if (obj.dice_alerts?.[0]) {
            localStorage.setItem("diceAlertsSite", "true");
            localStorage.setItem("immixAlertsSite", "false");
            localStorage.setItem("sentinelAlertsSite", "false");
            localStorage.setItem("sureviewAlertsSite", "false");
            localStorage.setItem("diceAlertPostObject", JSON.stringify({
                id: obj.dice_alerts[0].id,
                dice_server: obj.dice_alerts[0].dice_server,
                dice_port: obj.dice_alerts[0].dice_port
            }));
        }
        if (obj.sentinel_alerts?.[0]) {
            localStorage.setItem("immixAlertsSite", "false");
            localStorage.setItem("sentinelAlertsSite", "true");
            localStorage.setItem("sureviewAlertsSite", "false");
            localStorage.setItem("diceAlertsSite", "false");
            localStorage.setItem("sentinelAlertPostObject", JSON.stringify({
                sentinel_server: obj.sentinel_alerts[0].sentinel_server,
                sentinel_site_id: obj.sentinel_alerts[0].sentinel_site_id,
                sentinel_device_address: obj.sentinel_alerts[0].sentinel_device_address,
                draw_ignore_zones: obj.sentinel_alerts[0].draw_ignore_zones
            }));
        }
        if (!obj.sureview_alerts?.[0] && !obj.immix_alerts?.[0] && !obj.sentinel_alerts?.[0] && !obj.dice_alerts?.[0]) {
            localStorage.setItem("immixAlertsSite", "false");
            localStorage.setItem("sureviewAlertsSite", "false");
            localStorage.setItem("sentinelAlertsSite", "false");
            localStorage.setItem("diceAlertsSite", "false");
            localStorage.setItem("immixAlertPostObject", JSON.stringify({
                id: -1,
                immix_server: "",
                immix_port: ""
            }));
            localStorage.setItem("diceAlertPostObject", JSON.stringify({
                id: -1,
                dice_server: "",
                dice_port: ""
            }));
            localStorage.setItem("sentinelAlertPostObject", JSON.stringify({
                sentinel_server: "",
                sentinel_site_id: "",
                sentinel_device_address: "",
                draw_ignore_zones: false
            }));
        }
    });
};
const $f29aa8eb77ffef10$export$ca8e5a2c2c4e4478 = async (id, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $f29aa8eb77ffef10$export$ca8e5a2c2c4e4478(id, navigate);
    };
    await AxiosUI.get(`/camera/${id}/general_info/`).then((response)=>{
        $f29aa8eb77ffef10$export$3189bb70abb3e908(response.data);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
    });
};

});

parcelRegister("7kQyB", function(module, exports) {

$parcel$export(module.exports, "fetchAddCameraInfo", () => $f24ce5f614c76d90$export$11989d36ca85991f);

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $f24ce5f614c76d90$export$11989d36ca85991f = async (id, navigate, options)=>{
    const AxiosUI = (0, $195EM.createApi)(`customer/${id}/camera_onboarding_forms/`);
    const retryFunction = ()=>{
        $f24ce5f614c76d90$export$11989d36ca85991f(id, navigate, options);
    };
    return new Promise((resolve)=>{
        AxiosUI.get("").then((response)=>{
            // handleAddImmixToAddCameraForm(response.data);
            localStorage.setItem("addCameraInfo", JSON.stringify(response.data));
            localStorage.setItem("selectedProducts", JSON.stringify(response.data.initial_data.products));
            resolve(response.data);
        }, (reason)=>{
            if (options?.silent) {
                resolve(undefined);
                return;
            }
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                alert(`${reason}`);
            });
            resolve(undefined);
        });
    });
};

});

parcelRegister("1Ah5f", function(module, exports) {

$parcel$export(module.exports, "GeneralInfoTab", () => $b4a449a1f9610112$export$8d080cf40ced162c);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $3mOKt = parcelRequire("3mOKt");

var $3QMQN = parcelRequire("3QMQN");
var $iKAtE = parcelRequire("iKAtE");
var $1SPe4 = parcelRequire("1SPe4");
var $ddLR4 = parcelRequire("ddLR4");
var $ha39s = parcelRequire("ha39s");
var $f3puC = parcelRequire("f3puC");

var $8jTCz = parcelRequire("8jTCz");

var $5jwbk = parcelRequire("5jwbk");

var $ehkIG = parcelRequire("ehkIG");

var $cVCJe = parcelRequire("cVCJe");

var $ePwXE = parcelRequire("ePwXE");

var $6PfL8 = parcelRequire("6PfL8");

var $jDisJ = parcelRequire("jDisJ");

var $5Vost = parcelRequire("5Vost");

var $aKVKq = parcelRequire("aKVKq");

var $lWchQ = parcelRequire("lWchQ");

var $2aMB5 = parcelRequire("2aMB5");

var $aYdit = parcelRequire("aYdit");

var $2yNMw = parcelRequire("2yNMw");
var $4m1S6 = parcelRequire("4m1S6");

var $7t6MD = parcelRequire("7t6MD");

var $4PFLW = parcelRequire("4PFLW");

var $6HkuM = parcelRequire("6HkuM");

var $di6AF = parcelRequire("di6AF");

var $lF8zF = parcelRequire("lF8zF");

var $9VM4t = parcelRequire("9VM4t");
const $b4a449a1f9610112$var$COLUMN_COUNT = 7;
const $b4a449a1f9610112$var$CELL_WIDTH = `${100 / $b4a449a1f9610112$var$COLUMN_COUNT}%`;
const $b4a449a1f9610112$var$padTitlesToColumnCount = (titles)=>{
    const padded = [
        ...titles
    ];
    while(padded.length < $b4a449a1f9610112$var$COLUMN_COUNT)padded.push("");
    return padded.slice(0, $b4a449a1f9610112$var$COLUMN_COUNT);
};
const $b4a449a1f9610112$var$renderBlankCells = (count, keyPrefix)=>Array.from({
        length: Math.max(0, count)
    }).map((_, index)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
            align: "left",
            sx: {
                fontFamily: "Mulish",
                width: $b4a449a1f9610112$var$CELL_WIDTH
            }
        }, `${keyPrefix}-${index}`));
const $b4a449a1f9610112$export$8d080cf40ced162c = ({ siteInfo: siteInfo, setSiteInfo: setSiteInfo, setActiveTab: setActiveTab, vmsVariables: vmsVariables })=>{
    const { userPermissions: userPermissions, wireGuardOptions: wireGuardOptions } = (0, $aYdit.useAppStore)();
    const { isFeatureEnabled: isFeatureEnabled } = (0, $4PFLW.useFeatureFlag)();
    const showWireguard = isFeatureEnabled("showWireguard", false);
    const shouldShowWireguardAvailabilityZone = showWireguard && Boolean(siteInfo.display_wireguard);
    const autopatrolSite = siteInfo.integration_type_name === "autopatrol";
    // AI Link / Sentinel Verifier / Clips sites don't read from the settings
    // file, so "Last Synchronized" is meaningless for them — hide it.
    const showLastSynchronized = (0, $lF8zF.readsSettingsFile)(siteInfo.integration_type_name);
    const alarmOptions = JSON.parse(localStorage.alarmOptions);
    const alarmIds = new Map();
    alarmOptions.forEach((object)=>{
        alarmIds.set(object.value, object.name);
    });
    // RTSP + motion: recommend HTTP streaming (ENG-2828). Server-decided.
    const motionStreamingAdvice = (0, $9VM4t.siteMotionStreamingAdvice)(siteInfo);
    const noVMS = siteInfo.integration_type_name === "rtsp" && siteInfo.onboarding_integration === 1;
    const titlesArray = !autopatrolSite ? [
        "Site Name",
        "Timezone",
        "Autoadd",
        "Integration Type",
        "Alarm Type",
        "Parent Group"
    ] : [
        "Site Name",
        "Timezone",
        "Integration Type",
        "Parent Group"
    ];
    if (siteInfo.show_ecs_nat_instance) titlesArray.push("Whitelisting");
    const paddedTitlesArray = $b4a449a1f9610112$var$padTitlesToColumnCount(titlesArray);
    const statsTitles = !autopatrolSite ? [
        ...showLastSynchronized ? [
            "Last Synchronized"
        ] : [],
        "Last Restart",
        "Last Motion",
        "Last Alert",
        "Next Schedule",
        "Motion %",
        "Notes"
    ] : [
        ...showLastSynchronized ? [
            "Last Synchronized"
        ] : [],
        "Last Restart",
        "Last Alert",
        "Next Schedule",
        "Notes"
    ];
    const paddedStatsTitles = $b4a449a1f9610112$var$padTitlesToColumnCount(statsTitles);
    const [seeNotesDialogOpen, setSeeNotesDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [showPassword, setShowPassword] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const handleClickShowPassword = (inputString)=>setShowPassword((previousState)=>({
                ...previousState,
                [inputString]: !previousState[inputString]
            }));
    const handleMouseDownPassword = (event)=>{
        event.preventDefault();
    };
    const handleMouseUpPassword = (event)=>{
        event.preventDefault();
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        vmsVariables.forEach((array)=>{
            if (array[3] === "password") setShowPassword((show)=>({
                    ...show,
                    [array[2]]: false
                }));
        });
    }, [
        vmsVariables
    ]);
    const renderVMSCell = (array)=>{
        if (array[3] === "checkbox") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
            align: "left",
            sx: {
                fontFamily: "Mulish",
                width: $b4a449a1f9610112$var$CELL_WIDTH
            },
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                disabled: true,
                checked: array[1] === "true",
                color: "warning"
            })
        }, array[2]);
        if (array[3] === "password") return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
            align: "left",
            sx: {
                fontFamily: "Mulish",
                width: $b4a449a1f9610112$var$CELL_WIDTH
            },
            children: [
                userPermissions.view_passwords && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "flex items-center",
                    children: [
                        showPassword[array[2]] ? siteInfo[array[2]] : (0, $7t6MD.createDots)(siteInfo[array[2]]?.toString() || ""),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $1SPe4.default), {
                            position: "end",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                "aria-label": showPassword[array[2]] ? "hide the password" : "display the password",
                                onClick: ()=>{
                                    handleClickShowPassword(array[2]);
                                },
                                onMouseDown: handleMouseDownPassword,
                                onMouseUp: handleMouseUpPassword,
                                edge: "end",
                                size: "small",
                                children: showPassword[array[2]] ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $4m1S6.default), {
                                    fontSize: "small"
                                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $2yNMw.default), {
                                    fontSize: "small"
                                })
                            })
                        })
                    ]
                }),
                !userPermissions.view_passwords && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "flex items-center",
                    children: (0, $7t6MD.createDots)(siteInfo[array[2]]?.toString() || "")
                })
            ]
        }, array[2]);
        return /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
            align: "left",
            sx: {
                fontFamily: "Mulish",
                width: $b4a449a1f9610112$var$CELL_WIDTH,
                // Multi-line values (textarea fields) keep one entry per line.
                ...array[3] === "textarea" ? {
                    whiteSpace: "pre-line"
                } : {}
            },
            children: siteInfo[array[2]] ? siteInfo[array[2]] : "--"
        }, array[2]);
    };
    const renderVMSTable = ()=>{
        if (noVMS) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    colSpan: $b4a449a1f9610112$var$COLUMN_COUNT,
                    align: "left",
                    sx: {
                        fontFamily: "Mulish"
                    },
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        variant: "body1",
                        sx: {
                            fontFamily: "Mulish"
                        },
                        children: "To view connection details for specific cameras, find the camera below, then > Show More > Edit Camera > Camera Information > Connection."
                    })
                })
            })
        });
        // ENG-2535: fields whose visible_when rule fails are not shown.
        const shownVariables = (0, $di6AF.visibleVmsVariables)(vmsVariables, siteInfo).map(({ array: array })=>array);
        const totalRows = Math.ceil(shownVariables.length / $b4a449a1f9610112$var$COLUMN_COUNT);
        const rows = [];
        for(let rowIndex = 0; rowIndex < totalRows; rowIndex++){
            const startIndex = rowIndex * $b4a449a1f9610112$var$COLUMN_COUNT;
            const endIndex = Math.min(startIndex + $b4a449a1f9610112$var$COLUMN_COUNT, shownVariables.length);
            const rowVariables = shownVariables.slice(startIndex, endIndex);
            const emptyCells = $b4a449a1f9610112$var$COLUMN_COUNT - rowVariables.length;
            rows.push(/*#__PURE__*/ (0, $k4ank.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                rowVariables.map((array)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: {
                                            width: $b4a449a1f9610112$var$CELL_WIDTH,
                                            fontFamily: "Mulish",
                                            fontWeight: "Bold"
                                        },
                                        children: (0, $6HkuM.getVmsDisplayLabel)(array[0], siteInfo.integration_type_name)
                                    }, array[2] || array[0])),
                                $b4a449a1f9610112$var$renderBlankCells(emptyCells, `vms-header-empty-${rowIndex}`)
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                rowVariables.map((array)=>renderVMSCell(array)),
                                $b4a449a1f9610112$var$renderBlankCells(emptyCells, `vms-body-empty-${rowIndex}`)
                            ]
                        }, `${siteInfo.id}-vms-data-row-${rowIndex}`)
                    })
                ]
            }, `vms-row-${rowIndex}`));
        }
        return rows;
    };
    const siteInfoBodyCellCount = (!autopatrolSite ? 6 : 4) + (siteInfo.show_ecs_nat_instance ? 1 : 0);
    const statsBodyCellCount = (showLastSynchronized ? 1 : 0) + 1 + // Last Restart
    (!autopatrolSite ? 1 : 0) + // Last Motion
    1 + // Last Alert
    1 + // Next Schedule
    (!autopatrolSite ? 1 : 0) + // Motion %
    1; // Notes
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            seeNotesDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $5jwbk.SeeNotesDialog), {
                seeNotesDialogOpen: seeNotesDialogOpen,
                setSeeNotesDialogOpen: setSeeNotesDialogOpen,
                defaultText: siteInfo.notes
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3Nm8Z.default), {
                component: (0, $4reBM.default),
                sx: {
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                        sx: {
                            width: "100%",
                            fontFamily: "Mulish",
                            tableLayout: "fixed"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                titlesArray: paddedTitlesArray
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish",
                                                width: $b4a449a1f9610112$var$CELL_WIDTH
                                            },
                                            children: siteInfo.name
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish",
                                                width: $b4a449a1f9610112$var$CELL_WIDTH
                                            },
                                            children: siteInfo.timezone
                                        }),
                                        !autopatrolSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish",
                                                width: $b4a449a1f9610112$var$CELL_WIDTH
                                            },
                                            children: siteInfo.auto_add ? userPermissions.super_user ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                title: siteInfo.auto_add.toString(),
                                                placement: "top",
                                                children: (0, $lWchQ.checkedCircleIcon)
                                            }) : (0, $lWchQ.checkedCircleIcon) : (0, $2aMB5.cancelIconRed)
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish",
                                                width: $b4a449a1f9610112$var$CELL_WIDTH
                                            },
                                            children: (0, $3mOKt.integrationsMatcher)("Name", siteInfo.integration_type)
                                        }),
                                        !autopatrolSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish",
                                                width: $b4a449a1f9610112$var$CELL_WIDTH
                                            },
                                            children: alarmIds.get(siteInfo.default_alarm)
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish",
                                                width: $b4a449a1f9610112$var$CELL_WIDTH
                                            },
                                            children: siteInfo.parent_group.name
                                        }),
                                        siteInfo.show_ecs_nat_instance && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish",
                                                width: $b4a449a1f9610112$var$CELL_WIDTH
                                            },
                                            children: siteInfo.ecs_nat_instance ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                defaultChecked: true,
                                                disabled: true,
                                                color: "warning"
                                            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                checked: false,
                                                disabled: true,
                                                color: "warning"
                                            })
                                        }),
                                        $b4a449a1f9610112$var$renderBlankCells($b4a449a1f9610112$var$COLUMN_COUNT - siteInfoBodyCellCount, "site-info-empty")
                                    ]
                                }, siteInfo.id)
                            })
                        ]
                    }),
                    shouldShowWireguardAvailabilityZone && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                        sx: {
                            width: "100%",
                            fontFamily: "Mulish",
                            tableLayout: "fixed"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                titlesArray: $b4a449a1f9610112$var$padTitlesToColumnCount([
                                    "WireGuard Availability Zone"
                                ])
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish",
                                                width: $b4a449a1f9610112$var$CELL_WIDTH
                                            },
                                            children: wireGuardOptions.find((option)=>option.id === siteInfo.wireguard)?.name || "--"
                                        }),
                                        $b4a449a1f9610112$var$renderBlankCells($b4a449a1f9610112$var$COLUMN_COUNT - 1, "wireguard-empty")
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                        sx: {
                            width: "100%",
                            fontFamily: "Mulish",
                            tableLayout: "fixed"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aKVKq.AboutTableHead), {
                                titlesArray: paddedStatsTitles,
                                cellWidth: $b4a449a1f9610112$var$CELL_WIDTH
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                    children: [
                                        showLastSynchronized && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish",
                                                width: $b4a449a1f9610112$var$CELL_WIDTH
                                            },
                                            children: [
                                                siteInfo.deployed_date ? (0, $ehkIG.epochToUPCCovertor)(siteInfo.deployed_date, siteInfo.timezone).toString() : "--",
                                                "\xa0",
                                                siteInfo.deployed_date && siteInfo.timezone ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                    title: siteInfo.timezone,
                                                    placement: "top",
                                                    sx: {
                                                        fontSize: "15px",
                                                        fontFamily: "mulish"
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                                        fontSize: "small"
                                                    })
                                                }) : ""
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish",
                                                width: $b4a449a1f9610112$var$CELL_WIDTH
                                            },
                                            children: [
                                                siteInfo.pod_boot_time ? (0, $ehkIG.epochToUPCCovertor)(siteInfo.pod_boot_time, siteInfo.timezone).toString() : "--",
                                                "\xa0",
                                                siteInfo.pod_boot_time && siteInfo.timezone ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                    title: siteInfo.timezone,
                                                    placement: "top",
                                                    sx: {
                                                        fontSize: "15px",
                                                        fontFamily: "mulish"
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                                        fontSize: "small"
                                                    })
                                                }) : "",
                                                siteInfo.pod_boot_time && siteInfo.deployed_date && siteInfo.deployed_date > siteInfo.pod_boot_time ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                    title: "Settings synced after last restart \u2014 rearm site to restart and apply changes.",
                                                    placement: "top",
                                                    sx: {
                                                        fontSize: "15px",
                                                        fontFamily: "mulish"
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6PfL8))), {
                                                        fontSize: "small",
                                                        sx: {
                                                            color: "#ed6c02",
                                                            verticalAlign: "middle"
                                                        }
                                                    })
                                                }) : ""
                                            ]
                                        }),
                                        !autopatrolSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish",
                                                width: $b4a449a1f9610112$var$CELL_WIDTH
                                            },
                                            children: siteInfo.last_motion ? (0, $jDisJ.timeSinceConvertor)(siteInfo.last_motion) : "--"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish",
                                                width: $b4a449a1f9610112$var$CELL_WIDTH
                                            },
                                            children: siteInfo.last_alert ? (0, $jDisJ.timeSinceConvertor)(siteInfo.last_alert) : "--"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish",
                                                width: $b4a449a1f9610112$var$CELL_WIDTH
                                            },
                                            children: siteInfo.next_schedule ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                                children: [
                                                    (0, $ehkIG.epochToUPCCovertor)(siteInfo.next_schedule, siteInfo.timezone).toString(),
                                                    "\xa0",
                                                    siteInfo.next_schedule && siteInfo.timezone ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                        title: siteInfo.timezone,
                                                        placement: "top",
                                                        sx: {
                                                            fontSize: "15px",
                                                            fontFamily: "mulish"
                                                        },
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                                            fontSize: "small"
                                                        })
                                                    }) : ""
                                                ]
                                            }) : "--"
                                        }),
                                        !autopatrolSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish",
                                                width: $b4a449a1f9610112$var$CELL_WIDTH
                                            },
                                            children: siteInfo.motion_percentage ? `${(0, $5Vost.roundToHundredth)(siteInfo.motion_percentage)}%` : "--"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish",
                                                width: $b4a449a1f9610112$var$CELL_WIDTH
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                text: "See Notes",
                                                onClick: ()=>{
                                                    setSeeNotesDialogOpen(true);
                                                },
                                                disabled: false
                                            })
                                        }),
                                        $b4a449a1f9610112$var$renderBlankCells($b4a449a1f9610112$var$COLUMN_COUNT - statsBodyCellCount, "stats-empty")
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                        sx: {
                            width: "100%",
                            fontFamily: "Mulish",
                            tableLayout: "fixed"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        colSpan: $b4a449a1f9610112$var$COLUMN_COUNT,
                                        sx: {
                                            fontFamily: "Mulish",
                                            fontWeight: "bold",
                                            fontSize: "16px"
                                        },
                                        children: "VMS"
                                    })
                                })
                            }),
                            renderVMSTable()
                        ]
                    }),
                    motionStreamingAdvice && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                        severity: "info",
                        "data-testid": "motion-streaming-advice",
                        sx: {
                            fontFamily: "Mulish",
                            m: 2
                        },
                        children: motionStreamingAdvice
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("gfzcx", function(module, exports) {

$parcel$export(module.exports, "TableHeadComponent", () => $ee9dc893e27b5570$export$e2ed25320a10bd68);
$parcel$export(module.exports, "TooltipTableHeadComponent", () => $ee9dc893e27b5570$export$86b781efb13ccbf4);
$parcel$export(module.exports, "TableHeadComponentSmallerText", () => $ee9dc893e27b5570$export$9013cdc9b611252c);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $aVDw9 = parcelRequire("aVDw9");

var $ha39s = parcelRequire("ha39s");

var $4o6Cs = parcelRequire("4o6Cs");

var $ePwXE = parcelRequire("ePwXE");

var $cVCJe = parcelRequire("cVCJe");

var $3JJWq = parcelRequire("3JJWq");
const $ee9dc893e27b5570$export$e2ed25320a10bd68 = ({ titlesArray: titlesArray, backgroundColor: backgroundColor })=>{
    const siteInfo = (0, $3JJWq.safeGetItem)("siteInfo", null);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
        sx: {
            backgroundColor: `${backgroundColor} !important`,
            "& .MuiTableCell-head": {
                backgroundColor: `${backgroundColor} !important`,
                position: "sticky",
                top: 0,
                zIndex: 1
            }
        },
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
            sx: {
                backgroundColor: backgroundColor
            },
            children: titlesArray.map((title, index)=>{
                return /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                        align: "left",
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold",
                            backgroundColor: `${backgroundColor} !important`
                        },
                        children: [
                            title,
                            "\xa0",
                            title === "Arm Time" || title === "Disarm Time" ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                title: siteInfo?.timezone ?? "",
                                placement: "top",
                                sx: {
                                    fontSize: "15px",
                                    fontFamily: "mulish"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                    fontSize: "small"
                                })
                            }) : "",
                            title === "Bold Alarm Type" ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                title: "Alarm type for alert, default is BA (Burglary alarm).",
                                placement: "top",
                                sx: {
                                    fontSize: "15px",
                                    fontFamily: "mulish"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                    fontSize: "small"
                                })
                            }) : "",
                            title === "LOITERING TIME" ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                title: "The number of seconds an object must be continuously tracked before it is considered a loiterer. An alert will only be triggered once this loitering duration is met.",
                                placement: "top",
                                sx: {
                                    fontSize: "15px",
                                    fontFamily: "mulish"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                    fontSize: "small"
                                })
                            }) : "",
                            title === "All Metric Emails" || title === "All Metric Notifications" ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                title: "Receives instant alerts for all enabled metrics below.",
                                placement: "top",
                                sx: {
                                    fontSize: "15px",
                                    fontFamily: "mulish"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                    fontSize: "small"
                                })
                            }) : ""
                        ]
                    })
                }, `${title}-${index}`);
            })
        })
    });
};
const $ee9dc893e27b5570$export$86b781efb13ccbf4 = ({ titlesArray: titlesArray, toolTipText: toolTipText })=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
            children: titlesArray.map((array, index)=>{
                return /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                        align: "left",
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold"
                        },
                        children: [
                            array[0],
                            "\xa0",
                            toolTipText[array[1]] && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                title: toolTipText[array[1]],
                                placement: "top",
                                sx: {
                                    fontSize: "15px",
                                    fontFamily: "mulish"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                    fontSize: "small"
                                })
                            })
                        ]
                    })
                }, `${array[1]}-${index}`);
            })
        })
    });
};
const $ee9dc893e27b5570$export$9013cdc9b611252c = ({ titlesArray: titlesArray })=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
            children: titlesArray.map((title, index)=>{
                return /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                        align: "left",
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold",
                            fontSize: "12px"
                        },
                        children: title
                    })
                }, `${title}-${index}`);
            })
        })
    });
};

});

parcelRegister("3QMQN", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cdc1f1b32b4194a$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $aBrLz = parcelRequire("aBrLz");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $eDtj5 = parcelRequire("eDtj5");

var $iMOmE = parcelRequire("iMOmE");

var $4reBM = parcelRequire("4reBM");

var $bIxS3 = parcelRequire("bIxS3");

var $iKAtE = parcelRequire("iKAtE");

var $2EnC4 = parcelRequire("2EnC4");

var $8QER8 = parcelRequire("8QER8");

var $bhGcs = parcelRequire("bhGcs");

var $gNBGY = parcelRequire("gNBGY");

var $4LmmI = parcelRequire("4LmmI");

var $k4ank = parcelRequire("k4ank");
'use client';
const $2cdc1f1b32b4194a$var$_excluded = [
    "action",
    "children",
    "className",
    "closeText",
    "color",
    "components",
    "componentsProps",
    "icon",
    "iconMapping",
    "onClose",
    "role",
    "severity",
    "slotProps",
    "slots",
    "variant"
];
const $2cdc1f1b32b4194a$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $iMOmE.default)(color || severity)}`,
            `${variant}${(0, $iMOmE.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            'icon'
        ],
        message: [
            'message'
        ],
        action: [
            'action'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $bIxS3.getAlertUtilityClass), classes);
};
const $2cdc1f1b32b4194a$var$AlertRoot = (0, $anJSP.default)((0, $4reBM.default), {
    name: 'MuiAlert',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $iMOmE.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})(({ theme: theme })=>{
    const getColor = theme.palette.mode === 'light' ? (0, $aBrLz.darken) : (0, $aBrLz.lighten);
    const getBackgroundColor = theme.palette.mode === 'light' ? (0, $aBrLz.lighten) : (0, $aBrLz.darken);
    return (0, $eJfrs.default)({}, theme.typography.body2, {
        backgroundColor: 'transparent',
        display: 'flex',
        padding: '6px 16px',
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'standard'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${(0, $bIxS3.default).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'outlined'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${(0, $bIxS3.default).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.dark).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'filled'
                    },
                    style: (0, $eJfrs.default)({
                        fontWeight: theme.typography.fontWeightMedium
                    }, theme.vars ? {
                        color: theme.vars.palette.Alert[`${color}FilledColor`],
                        backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                    } : {
                        backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
                        color: theme.palette.getContrastText(theme.palette[color].main)
                    })
                }))
        ]
    });
});
const $2cdc1f1b32b4194a$var$AlertIcon = (0, $anJSP.default)('div', {
    name: 'MuiAlert',
    slot: 'Icon',
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: '7px 0',
    display: 'flex',
    fontSize: 22,
    opacity: 0.9
});
const $2cdc1f1b32b4194a$var$AlertMessage = (0, $anJSP.default)('div', {
    name: 'MuiAlert',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0',
    minWidth: 0,
    overflow: 'auto'
});
const $2cdc1f1b32b4194a$var$AlertAction = (0, $anJSP.default)('div', {
    name: 'MuiAlert',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'flex-start',
    padding: '4px 0 0 16px',
    marginLeft: 'auto',
    marginRight: -8
});
const $2cdc1f1b32b4194a$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $k4ank.jsx)((0, $2EnC4.default), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8QER8.default), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $k4ank.jsx)((0, $bhGcs.default), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $k4ank.jsx)((0, $gNBGY.default), {
        fontSize: "inherit"
    })
};
const $2cdc1f1b32b4194a$var$Alert = /*#__PURE__*/ $8T3gX.forwardRef(function Alert(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiAlert'
    });
    const { action: action, children: children, className: className, closeText: closeText = 'Close', color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $2cdc1f1b32b4194a$var$defaultIconMapping, onClose: onClose, role: role = 'alert', severity: severity = 'success', slotProps: slotProps = {}, slots: slots = {}, variant: variant = 'standard' } = props, other = (0, $fAJB5.default)(props, $2cdc1f1b32b4194a$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    });
    const classes = $2cdc1f1b32b4194a$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: (0, $eJfrs.default)({
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon
        }, slots),
        slotProps: (0, $eJfrs.default)({}, componentsProps, slotProps)
    };
    const [CloseButtonSlot, closeButtonProps] = (0, $eDtj5.default)('closeButton', {
        elementType: (0, $iKAtE.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $eDtj5.default)('closeIcon', {
        elementType: (0, $4LmmI.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $k4ank.jsxs)($2cdc1f1b32b4194a$var$AlertRoot, (0, $eJfrs.default)({
        role: role,
        elevation: 0,
        ownerState: ownerState,
        className: (0, $iVyaN.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            icon !== false ? /*#__PURE__*/ (0, $k4ank.jsx)($2cdc1f1b32b4194a$var$AlertIcon, {
                ownerState: ownerState,
                className: classes.icon,
                children: icon || iconMapping[severity] || $2cdc1f1b32b4194a$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $k4ank.jsx)($2cdc1f1b32b4194a$var$AlertMessage, {
                ownerState: ownerState,
                className: classes.message,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $k4ank.jsx)($2cdc1f1b32b4194a$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $k4ank.jsx)($2cdc1f1b32b4194a$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: /*#__PURE__*/ (0, $k4ank.jsx)(CloseButtonSlot, (0, $eJfrs.default)({
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose
                }, closeButtonProps, {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)(CloseIconSlot, (0, $eJfrs.default)({
                        fontSize: "small"
                    }, closeIconProps))
                }))
            }) : null
        ]
    }));
});
$2cdc1f1b32b4194a$var$Alert.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The action to display. It renders after the message, at the end of the alert.
   */ action: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Override the default label for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Close'
   */ closeText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The color of the component. Unless provided, the value is taken from the `severity` prop.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'error',
            'info',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   *
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        CloseButton: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        CloseIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   *
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        closeButton: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        closeIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    }),
    /**
   * Override the icon displayed before the children.
   * Unless provided, the icon is mapped to the value of the `severity` prop.
   * Set to `false` to remove the `icon`.
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * The component maps the `severity` prop to a range of different icons,
   * for instance success to `<SuccessOutlined>`.
   * If you wish to change this mapping, you can provide your own.
   * Alternatively, you can use the `icon` prop to override the icon displayed.
   */ iconMapping: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        error: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
        info: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
        success: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
        warning: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node
    }),
    /**
   * Callback fired when the component requests to be closed.
   * When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
   * @param {React.SyntheticEvent} event The event source of the callback.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */ role: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The severity of the alert. This defines the color and icon used.
   * @default 'success'
   */ severity: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'error',
            'info',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        closeButton: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        ]),
        closeIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        closeButton: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
        closeIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * The variant to use.
   * @default 'standard'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'filled',
            'outlined',
            'standard'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ])
};
var $2cdc1f1b32b4194a$export$2e2bcd8739ae039 = $2cdc1f1b32b4194a$var$Alert;

});
parcelRegister("eDtj5", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa7b70f2392e5305$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $ktSDD = parcelRequire("ktSDD");

var $3s57T = parcelRequire("3s57T");

var $doXjE = parcelRequire("doXjE");

var $dkv3t = parcelRequire("dkv3t");
'use client';
const $aa7b70f2392e5305$var$_excluded = [
    "className",
    "elementType",
    "ownerState",
    "externalForwardedProps",
    "getSlotOwnerState",
    "internalForwardedProps"
], $aa7b70f2392e5305$var$_excluded2 = [
    "component",
    "slots",
    "slotProps"
], $aa7b70f2392e5305$var$_excluded3 = [
    "component"
];
function $aa7b70f2392e5305$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, getSlotOwnerState: getSlotOwnerState, internalForwardedProps: internalForwardedProps } = parameters, useSlotPropsParams = (0, $fAJB5.default)(parameters, $aa7b70f2392e5305$var$_excluded);
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, $fAJB5.default)(externalForwardedProps, $aa7b70f2392e5305$var$_excluded2);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $doXjE.default)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, $dkv3t.default)((0, $eJfrs.default)({
        className: className
    }, useSlotPropsParams, {
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef: internalRef } = _mergeSlotProps, mergedProps = (0, $fAJB5.default)(_mergeSlotProps.props, $aa7b70f2392e5305$var$_excluded3);
    const ref = (0, $ktSDD.default)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
    const finalOwnerState = (0, $eJfrs.default)({}, ownerState, slotOwnerState);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $3s57T.default)(elementType, (0, $eJfrs.default)({}, name === 'root' && !rootComponent && !slots[name] && internalForwardedProps, name !== 'root' && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
        as: LeafComponent
    }, {
        ref: ref
    }), finalOwnerState);
    Object.keys(slotOwnerState).forEach((propName)=>{
        delete props[propName];
    });
    return [
        elementType,
        props
    ];
}

});

parcelRegister("bIxS3", function(module, exports) {

$parcel$export(module.exports, "getAlertUtilityClass", () => $887e13d69ae2ec1b$export$69aecd24bc2cf7e3);
$parcel$export(module.exports, "default", () => $887e13d69ae2ec1b$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $887e13d69ae2ec1b$export$69aecd24bc2cf7e3(slot) {
    return (0, $kfTYv.default)('MuiAlert', slot);
}
const $887e13d69ae2ec1b$var$alertClasses = (0, $jh2Zm.default)('MuiAlert', [
    'root',
    'action',
    'icon',
    'message',
    'filled',
    'colorSuccess',
    'colorInfo',
    'colorWarning',
    'colorError',
    'filledSuccess',
    'filledInfo',
    'filledWarning',
    'filledError',
    'outlined',
    'outlinedSuccess',
    'outlinedInfo',
    'outlinedWarning',
    'outlinedError',
    'standard',
    'standardSuccess',
    'standardInfo',
    'standardWarning',
    'standardError'
]);
var $887e13d69ae2ec1b$export$2e2bcd8739ae039 = $887e13d69ae2ec1b$var$alertClasses;

});

parcelRegister("2EnC4", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ee1a2401eb9205c$export$2e2bcd8739ae039);
parcelRequire("8T3gX");

var $a7uO0 = parcelRequire("a7uO0");

var $k4ank = parcelRequire("k4ank");
'use client';
var $1ee1a2401eb9205c$export$2e2bcd8739ae039 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');

});

parcelRegister("8QER8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6712df375c407285$export$2e2bcd8739ae039);
parcelRequire("8T3gX");

var $a7uO0 = parcelRequire("a7uO0");

var $k4ank = parcelRequire("k4ank");
'use client';
var $6712df375c407285$export$2e2bcd8739ae039 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');

});

parcelRegister("bhGcs", function(module, exports) {

$parcel$export(module.exports, "default", () => $837204466df6fa2c$export$2e2bcd8739ae039);
parcelRequire("8T3gX");

var $a7uO0 = parcelRequire("a7uO0");

var $k4ank = parcelRequire("k4ank");
'use client';
var $837204466df6fa2c$export$2e2bcd8739ae039 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');

});

parcelRegister("gNBGY", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3ae75cffa90a571$export$2e2bcd8739ae039);
parcelRequire("8T3gX");

var $a7uO0 = parcelRequire("a7uO0");

var $k4ank = parcelRequire("k4ank");
'use client';
var $c3ae75cffa90a571$export$2e2bcd8739ae039 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');

});

parcelRegister("4LmmI", function(module, exports) {

$parcel$export(module.exports, "default", () => $377ce68372de41ef$export$2e2bcd8739ae039);
parcelRequire("8T3gX");

var $a7uO0 = parcelRequire("a7uO0");

var $k4ank = parcelRequire("k4ank");
'use client';
var $377ce68372de41ef$export$2e2bcd8739ae039 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

});


parcelRegister("1SPe4", function(module, exports) {

$parcel$export(module.exports, "default", () => $15f2920087d11922$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $iMOmE = parcelRequire("iMOmE");

var $f3puC = parcelRequire("f3puC");

var $680s3 = parcelRequire("680s3");

var $c8JM8 = parcelRequire("c8JM8");

var $anJSP = parcelRequire("anJSP");

var $kcLvB = parcelRequire("kcLvB");

var $7AQZl = parcelRequire("7AQZl");

var $k4ank = parcelRequire("k4ank");
'use client';
var $15f2920087d11922$var$_span;
const $15f2920087d11922$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $15f2920087d11922$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $iMOmE.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $15f2920087d11922$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, $iMOmE.default)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, $iMOmE.default)(size)}`
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $kcLvB.getInputAdornmentUtilityClass), classes);
};
const $15f2920087d11922$var$InputAdornmentRoot = (0, $anJSP.default)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: $15f2920087d11922$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        display: 'flex',
        height: '0.01em',
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === 'filled' && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $kcLvB.default).positionStart}&:not(.${(0, $kcLvB.default).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === 'start' && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === 'end' && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: 'none'
    }));
const $15f2920087d11922$var$InputAdornment = /*#__PURE__*/ $8T3gX.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children: children, className: className, component: component = 'div', disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $fAJB5.default)(props, $15f2920087d11922$var$_excluded);
    const muiFormControl = (0, $c8JM8.default)() || {};
    let variant = variantProp;
    if (variantProp && muiFormControl.variant) {
        if (variantProp === muiFormControl.variant) console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one.");
    }
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $eJfrs.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $15f2920087d11922$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $680s3.default).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $k4ank.jsx)($15f2920087d11922$var$InputAdornmentRoot, (0, $eJfrs.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $iVyaN.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $k4ank.jsxs)($8T3gX.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $15f2920087d11922$var$_span || ($15f2920087d11922$var$_span = /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
$15f2920087d11922$var$InputAdornment.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component, normally an `IconButton` or string.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */ disablePointerEvents: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */ disableTypography: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The position this adornment should appear relative to the `Input`.
   */ position: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'end',
        'start'
    ]).isRequired,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'filled',
        'outlined',
        'standard'
    ])
};
var $15f2920087d11922$export$2e2bcd8739ae039 = $15f2920087d11922$var$InputAdornment;

});
parcelRegister("kcLvB", function(module, exports) {

$parcel$export(module.exports, "getInputAdornmentUtilityClass", () => $eb59c7e2762184f5$export$4b135a4b3a6c4550);
$parcel$export(module.exports, "default", () => $eb59c7e2762184f5$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $eb59c7e2762184f5$export$4b135a4b3a6c4550(slot) {
    return (0, $kfTYv.default)('MuiInputAdornment', slot);
}
const $eb59c7e2762184f5$var$inputAdornmentClasses = (0, $jh2Zm.default)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var $eb59c7e2762184f5$export$2e2bcd8739ae039 = $eb59c7e2762184f5$var$inputAdornmentClasses;

});


parcelRegister("5jwbk", function(module, exports) {

$parcel$export(module.exports, "SeeNotesDialog", () => $d725cf16fe0e29b4$export$467c2c91107e2422);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $iLEpm = parcelRequire("iLEpm");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");

var $eDfvp = parcelRequire("eDfvp");
var $iKAtE = parcelRequire("iKAtE");
var $eejVe = parcelRequire("eejVe");

var $433j1 = parcelRequire("433j1");

var $6pdiI = parcelRequire("6pdiI");
const $d725cf16fe0e29b4$export$467c2c91107e2422 = ({ seeNotesDialogOpen: seeNotesDialogOpen, setSeeNotesDialogOpen: setSeeNotesDialogOpen, defaultText: defaultText, onSubmitNotes: onSubmitNotes })=>{
    const [isEditMode, setIsEditMode] = $8T3gX.useState(false);
    const [editText, setEditText] = $8T3gX.useState(defaultText ?? "");
    const [isSubmitting, setIsSubmitting] = $8T3gX.useState(false);
    const initialDefaultTextRef = $8T3gX.useRef(defaultText ?? "");
    const prevOpenRef = $8T3gX.useRef(false);
    $8T3gX.useEffect(()=>{
        const justOpened = seeNotesDialogOpen && !prevOpenRef.current;
        prevOpenRef.current = seeNotesDialogOpen;
        if (justOpened) {
            const text = defaultText ?? "";
            initialDefaultTextRef.current = text;
            setEditText(text);
            setIsEditMode(false);
        }
    }, [
        seeNotesDialogOpen,
        defaultText
    ]);
    const hasUnsavedChanges = isEditMode && editText !== initialDefaultTextRef.current;
    const handleClose = ()=>{
        setSeeNotesDialogOpen(false);
    };
    const handleCancel = ()=>{
        setSeeNotesDialogOpen(false);
    };
    const handleSubmitNotes = async ()=>{
        if (!onSubmitNotes) return;
        setIsSubmitting(true);
        try {
            await onSubmitNotes(editText);
            setSeeNotesDialogOpen(false);
        } finally{
            setIsSubmitting(false);
        }
    };
    const showCloseButton = !hasUnsavedChanges;
    const showEditInHeader = onSubmitNotes && !isEditMode;
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: seeNotesDialogOpen,
        fullWidth: true,
        maxWidth: "xs",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                    component: "span",
                    sx: {
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 0.5,
                        fontFamily: "Mulish"
                    },
                    children: [
                        "Notes",
                        showEditInHeader && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            "aria-label": "edit notes",
                            text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {
                                fontSize: "small"
                            }),
                            onClick: ()=>setIsEditMode(true),
                            disabled: false
                        })
                    ]
                })
            }),
            showCloseButton && /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                "aria-label": "close",
                onClick: handleClose,
                sx: {
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme)=>theme.palette.grey[500]
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                children: isEditMode && onSubmitNotes ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    value: editText,
                    onChange: (e)=>setEditText(e.target.value),
                    variant: "outlined",
                    multiline: true,
                    rows: 6,
                    fullWidth: true,
                    sx: {
                        fontFamily: "Mulish"
                    }
                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                    sx: {
                        whiteSpace: "pre-line"
                    },
                    children: defaultText ?? ""
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), {
                children: isEditMode && onSubmitNotes ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            text: "Cancel",
                            onClick: handleCancel,
                            disabled: false
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            text: "Submit Notes",
                            onClick: handleSubmitNotes,
                            disabled: isSubmitting
                        })
                    ]
                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                    onClick: handleClose,
                    text: "Ok",
                    disabled: false
                })
            })
        ]
    });
};

});

parcelRegister("ehkIG", function(module, exports) {

$parcel$export(module.exports, "epochToUPCCovertor", () => $dbda8e566a522b09$export$6a0c9f6675908853);
const $dbda8e566a522b09$export$6a0c9f6675908853 = (epochNum, timeZone)=>{
    const deployedEpoch = epochNum;
    const date = new Date(0);
    date.setUTCSeconds(deployedEpoch);
    const options = timeZone ? {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: timeZone
    } : {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
    };
    // Format the date with locale options
    const formattedDate = new Intl.DateTimeFormat("en-US", options).format(date);
    // Remove the "at" and the time zone abbreviation if present
    const cleanDate = formattedDate.replace(/,? at /, " ");
    return cleanDate;
};

});

parcelRegister("6PfL8", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f83baf0e6080dea$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $4f83baf0e6080dea$var$_default = module.exports.default = (0, $4f83baf0e6080dea$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $k4ank.jsx)("path", {
        d: "M12 5.99 19.53 19H4.47zM12 2 1 21h22z"
    }, "0"),
    /*#__PURE__*/ (0, $k4ank.jsx)("path", {
        d: "M13 16h-2v2h2zm0-6h-2v5h2z"
    }, "1")
], 'WarningAmber');

});

parcelRegister("5Vost", function(module, exports) {

$parcel$export(module.exports, "roundToHundredth", () => $29e3ee4880e3ba2e$export$87c40269ccb4639d);
const $29e3ee4880e3ba2e$export$87c40269ccb4639d = (value)=>{
    const valueTimes100 = value * 100;
    return Number(valueTimes100.toFixed(2));
};

});

parcelRegister("aKVKq", function(module, exports) {

$parcel$export(module.exports, "AboutTableHead", () => $e7c5cede735735c0$export$cd5f62f9f6ccdbd7);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $aVDw9 = parcelRequire("aVDw9");

var $ha39s = parcelRequire("ha39s");

var $4o6Cs = parcelRequire("4o6Cs");

var $ldGXy = parcelRequire("ldGXy");
const $e7c5cede735735c0$export$cd5f62f9f6ccdbd7 = ({ titlesArray: titlesArray, cellWidth: cellWidth })=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
            children: titlesArray.map((title, index)=>{
                if (title === "Armed" || title === "Synced" || title === "Motion %") return /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                    children: (0, $ldGXy.createAboutTableInfoLabel)(title)
                }, `${title}-${index}`);
                else return /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    align: "left",
                    sx: {
                        fontFamily: "Mulish",
                        fontWeight: "Bold",
                        ...cellWidth ? {
                            width: cellWidth
                        } : {}
                    },
                    children: title
                }, `${title}-${index}`);
            })
        })
    });
};

});
parcelRegister("ldGXy", function(module, exports) {

$parcel$export(module.exports, "createAboutTableInfoLabel", () => $81ffe02b6f12a8a9$export$7fbe19a3c4e9f6f6);

var $k4ank = parcelRequire("k4ank");

var $aVDw9 = parcelRequire("aVDw9");

var $ePwXE = parcelRequire("ePwXE");

var $cVCJe = parcelRequire("cVCJe");
const $81ffe02b6f12a8a9$var$armedText = "A metric that shares if the site is scheduled to send alerts at the time of viewing or not. If the icon is a yellow or grey alert symbol, hovering over it will specify any issues that are present. A green check indicates the site is scheduled to send alerts at the time of viewing. A red X indicates the site is disarmed.";
const $81ffe02b6f12a8a9$var$deployedText = "An indication of whether the site has been edited since its last deployment. A green checkmark will show if the most current version of the site is running and a red x will show if the changes to the site have not been synced - in which case it should be re-synced";
const $81ffe02b6f12a8a9$var$motionPercentageText = "The percentage of the time Actuate receives motion from the site across all it's cameras. Normal numbers are between 1% and 10%.";
const $81ffe02b6f12a8a9$export$7fbe19a3c4e9f6f6 = (labelString)=>{
    let itemText = "";
    if (labelString === "Armed") itemText = $81ffe02b6f12a8a9$var$armedText;
    else if (labelString === "Motion %") itemText = $81ffe02b6f12a8a9$var$motionPercentageText;
    else if (labelString === "Synced") itemText = $81ffe02b6f12a8a9$var$deployedText;
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
        align: "left",
        sx: {
            fontFamily: "Mulish",
            fontWeight: "Bold",
            fontSize: "15px"
        },
        children: [
            labelString,
            "\xa0",
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                title: itemText,
                placement: "top",
                sx: {
                    fontSize: "15px",
                    fontFamily: "mulish"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                    fontSize: "small"
                })
            })
        ]
    }, labelString === "Motion %" ? "motion_percentage" : labelString);
};

});


parcelRegister("2yNMw", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dd55f53651579a6$export$2e2bcd8739ae039);

var $a7uO0 = parcelRequire("a7uO0");

var $k4ank = parcelRequire("k4ank");
"use client";
var $1dd55f53651579a6$export$2e2bcd8739ae039 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"
}), 'Visibility');

});

parcelRegister("4m1S6", function(module, exports) {

$parcel$export(module.exports, "default", () => $32baab25532be0cf$export$2e2bcd8739ae039);

var $a7uO0 = parcelRequire("a7uO0");

var $k4ank = parcelRequire("k4ank");
"use client";
var $32baab25532be0cf$export$2e2bcd8739ae039 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7M2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2m4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3z"
}), 'VisibilityOff');

});

parcelRegister("7t6MD", function(module, exports) {

$parcel$export(module.exports, "createDots", () => $8b79c257fe5c0c7c$export$55c9d25c3b4d1755);
const $8b79c257fe5c0c7c$export$55c9d25c3b4d1755 = (inputString)=>{
    if (!inputString) return "";
    let dots = "";
    for(let i = 0; i < inputString.length; i++)dots += "\u2022";
    return dots;
};

});

parcelRegister("6HkuM", function(module, exports) {

$parcel$export(module.exports, "getVmsDisplayLabel", () => $57c83b70e23336e0$export$ffd631cf7d0f674c);
/**
 * Display label for a site-level VMS field on Site About. The label comes
 * from the API's `extra_fields` entry (admin's own wording) and is normally
 * shown as-is; the cases below patch older admin labels per integration.
 */ const $57c83b70e23336e0$export$ffd631cf7d0f674c = (label, integrationTypeName)=>{
    const integration = integrationTypeName?.toLowerCase();
    if (label === "Server ID" && integration === "exacq") return "Exacq Server ID";
    // Genetec's event_server_ip is the Media Gateway host; admin labels it
    // that way, the legacy label (vMSvariablesArray) still says Event Server IP.
    if (label === "Event Server IP" && integration === "genetec") return "Media Gateway Host";
    return label;
};

});

parcelRegister("di6AF", function(module, exports) {

$parcel$export(module.exports, "visibleVmsVariables", () => $c0969ee38b6c7a56$export$baea896d23b41092);

var $7U8Fx = parcelRequire("7U8Fx");
const $c0969ee38b6c7a56$export$baea896d23b41092 = (vmsVariables, siteInfo)=>(vmsVariables || []).map((array, index)=>({
            array: array,
            index: index
        })).filter(({ array: array })=>(0, $7U8Fx.isFieldVisible)(array?.[5], siteInfo));

});
parcelRegister("7U8Fx", function(module, exports) {

$parcel$export(module.exports, "isFieldVisible", () => $c0e205dae69aaba6$export$73eb8eb476d24642);
/**
 * Field display rules from admin's onboarding field contract (ENG-2535).
 *
 * A field may carry `visible_when: { <other field>: [allowed values] }`: it
 * shows only while every named field's current value is one of its allowed
 * values. Visibility is display only: a hidden field keeps its value and is
 * still submitted as-is (never cleared or sent blank). Fields without a rule
 * always show.
 */ const $c0e205dae69aaba6$export$e54dcd4df23ba04b = (value)=>{
    if (value === null || value === undefined) return "";
    const text = String(value);
    return text === "null" || text === "undefined" ? "" : text;
};
const $c0e205dae69aaba6$export$73eb8eb476d24642 = (rule, values)=>{
    if (!rule || typeof rule !== "object") return true;
    const current = values ?? {};
    return Object.entries(rule).every(([name, allowed])=>{
        if (!Array.isArray(allowed)) return true;
        const value = $c0e205dae69aaba6$export$e54dcd4df23ba04b(current[name]);
        return allowed.some((option)=>$c0e205dae69aaba6$export$e54dcd4df23ba04b(option) === value);
    });
};

});


parcelRegister("9VM4t", function(module, exports) {

$parcel$export(module.exports, "siteMotionStreamingAdvice", () => $b2639beaa590ecfe$export$c15e7c31d9ac954f);
$parcel$export(module.exports, "cameraMotionStreamingAdvice", () => $b2639beaa590ecfe$export$5593557e846dd64b);
$parcel$export(module.exports, "withSavedMotionStreamingAdvice", () => $b2639beaa590ecfe$export$2598011722aedf7b);
/**
 * RTSP + motion advice (ENG-2828, admin PR #3274).
 *
 * Motion signals start a pull from the camera, and on a site that streams
 * over RTSP that pull connects slower than HTTP streaming, so motion works
 * but loses the first moments. Advisory only: it never blocks a save.
 *
 * The site About payload (`GET/PATCH customer/{id}/about/`) carries
 * `motion_streaming_advice`: the recommendation text when the site's stream
 * `protocol` is rtsp and the site's `use_motion` is on, null otherwise. A
 * camera's "Use motion" override is ignored while the site's use_motion is
 * off (admin `Camera.effective_motion_override`), so it never counts. Always show the server's
 * string; the constant below is only the fallback for the camera page, where
 * the operator is choosing "Use motion" before the server has seen it.
 */ const $b2639beaa590ecfe$export$e499fa4c47ddf1e7 = "motion_streaming_advice";
const $b2639beaa590ecfe$export$4c0b9d564b3c69f8 = "Motion is on while this site streams over RTSP. We recommend switching streaming to HTTP: it connects faster when motion starts a pull.";
const $b2639beaa590ecfe$export$c15e7c31d9ac954f = (siteInfo)=>{
    const advice = siteInfo?.[$b2639beaa590ecfe$export$e499fa4c47ddf1e7];
    return typeof advice === "string" && advice.trim() !== "" ? advice : null;
};
const $b2639beaa590ecfe$export$e515f547c498ef14 = (protocol)=>typeof protocol === "string" && protocol.trim().toLowerCase() === "rtsp";
const $b2639beaa590ecfe$export$5593557e846dd64b = (siteInfo, usesMotionOverride)=>{
    if (!usesMotionOverride) return null;
    return $b2639beaa590ecfe$export$c15e7c31d9ac954f(siteInfo) ?? (siteInfo?.use_motion === true && $b2639beaa590ecfe$export$e515f547c498ef14(siteInfo?.protocol) ? $b2639beaa590ecfe$export$4c0b9d564b3c69f8 : null);
};
const $b2639beaa590ecfe$export$2598011722aedf7b = (siteInfo, responseData)=>{
    if (!responseData || typeof responseData !== "object" || !Object.prototype.hasOwnProperty.call(responseData, $b2639beaa590ecfe$export$e499fa4c47ddf1e7)) return siteInfo;
    return {
        ...siteInfo,
        [$b2639beaa590ecfe$export$e499fa4c47ddf1e7]: responseData[$b2639beaa590ecfe$export$e499fa4c47ddf1e7]
    };
};

});


parcelRegister("F8wri", function(module, exports) {

$parcel$export(module.exports, "checkArmedStatus", () => $04d72fc3dddaa81f$export$de2ef94265fa8be0);
parcelRequire("8T3gX");

var $fLXcH = parcelRequire("fLXcH");

var $agMWc = parcelRequire("agMWc");
const $04d72fc3dddaa81f$export$de2ef94265fa8be0 = (siteInfo, setArmButtonDisabled, navigate, setSiteInfo, setArmedStatus, getIsMounted)=>{
    setArmButtonDisabled(false);
    if (siteInfo.active && (0, $agMWc.isTransitionalArmedStatus)(siteInfo.armed_status)) {
        localStorage.setItem("armButtonCheckURL", window.location.pathname);
        (0, $fLXcH.siteArmButtonDisableCheckRefresh)(siteInfo.id, setArmButtonDisabled, navigate, setSiteInfo, setArmedStatus, getIsMounted);
    }
};

});
parcelRegister("fLXcH", function(module, exports) {

$parcel$export(module.exports, "siteArmButtonDisableCheckRefresh", () => $6e22cb64803703ee$export$4fbc9139898dce10);
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");

var $agMWc = parcelRequire("agMWc");
const $6e22cb64803703ee$export$4fbc9139898dce10 = (siteId, setArmButtonDisabled, navigate, setSiteInfo, setArmedStatus, getIsMounted)=>{
    const retryFunction = ()=>{
        if (getIsMounted && !getIsMounted()) return;
        $6e22cb64803703ee$export$4fbc9139898dce10(siteId, setArmButtonDisabled, navigate, setSiteInfo, setArmedStatus, getIsMounted);
    };
    const AxiosUI = (0, $195EM.createApi)(``);
    AxiosUI.get(`customer/${siteId}/about/`).then((response)=>{
        if (getIsMounted && !getIsMounted()) return;
        const armed = response.data.armed_status === "ARMED_OUTSIDE_SCHEDULE" ? true : response.data.armed;
        setArmedStatus(armed);
        setArmButtonDisabled(false);
        setSiteInfo((previousState)=>{
            return {
                ...previousState,
                armed: armed,
                armed_status: response.data.armed_status
            };
        });
        if ((0, $agMWc.isTransitionalArmedStatus)(response.data.armed_status)) setTimeout(()=>{
            if (getIsMounted && !getIsMounted()) return;
            if (localStorage.armButtonCheckURL === window.location.pathname) $6e22cb64803703ee$export$4fbc9139898dce10(siteId, setArmButtonDisabled, navigate, setSiteInfo, setArmedStatus, getIsMounted);
            else localStorage.setItem("armButtonCheckURL", "");
        }, 5000);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
    });
};

});
parcelRegister("agMWc", function(module, exports) {

$parcel$export(module.exports, "isTransitionalArmedStatus", () => $eed88a6d1aca2a19$export$bc403ae00040a56c);
$parcel$export(module.exports, "getArmedStatusPresentation", () => $eed88a6d1aca2a19$export$1fa22cf054d59a4d);
/**
 * One place that says what each `armed_status` value from
 * `GET /customer/{id}/about/` MEANS to an operator (SUP-515).
 *
 * The backend statuses (actuate_admin `MotionStatus`) are a mix of health
 * and transition states. Before this file the UI mapped them to a coloured
 * icon (sites list) and a locked toggle (site page) with hover-only
 * tooltips, so a site that reported DISARMING for half an hour while it was
 * running and alerting looked like "a greyed-out red switch" and nothing
 * else — the customer read it as "stuck armed" and could not disarm it.
 *
 * Every surface that shows arm state (site page toggle tooltip, About table
 * chip, sites list icon) reads from here so the wording stays consistent.
 */ const $eed88a6d1aca2a19$export$990ae4c6ff1e85e3 = "This normally settles within a couple of minutes, and at most 10 while the connector restarts.";
const $eed88a6d1aca2a19$export$dee9db541d969332 = [
    "ARMING",
    "DISARMING"
];
const $eed88a6d1aca2a19$export$bc403ae00040a56c = (armedStatus)=>$eed88a6d1aca2a19$export$dee9db541d969332.includes((armedStatus || "").toUpperCase());
const $eed88a6d1aca2a19$export$1fa22cf054d59a4d = (armedStatus, armed, active = true)=>{
    const status = (armedStatus || "").toUpperCase();
    if (!active) return {
        status: status,
        label: "Inactive",
        tone: "disarmed",
        description: "This site is inactive. It will not arm from its schedule until it is activated.",
        transitional: false
    };
    switch(status){
        case "OK":
            return {
                status: status,
                label: "Armed",
                tone: "armed",
                description: "Armed on schedule and receiving motion from its cameras.",
                transitional: false
            };
        case "ARMED_OUTSIDE_SCHEDULE":
            return {
                status: status,
                label: "Armed (manual)",
                tone: "manual",
                description: "Armed manually outside its schedule and generating alerts. It will disarm at the next scheduled disarm time, or as soon as you disarm it.",
                transitional: false
            };
        case "WARNING":
            return {
                status: status,
                label: "Armed \u2013 no motion",
                tone: "warning",
                description: "Armed on schedule, but no motion has been seen in the last 10 minutes. The cameras may not be reachable.",
                transitional: false
            };
        case "ERROR":
            return {
                status: status,
                label: "Armed \u2013 not running",
                tone: "error",
                description: "The schedule says this site should be armed, but no connector is running for it, so no alerts are being generated. Toggle it off and on to restart it, or contact support.",
                transitional: false
            };
        case "ARMING":
            return {
                status: status,
                label: "Arming\u2026",
                tone: "transitional",
                description: `Arm command received and the connector is restarting. Alerts resume once it is back up. ${$eed88a6d1aca2a19$export$990ae4c6ff1e85e3} You can still disarm the site while it arms.`,
                transitional: true
            };
        case "DISARMING":
            return {
                status: status,
                label: "Disarming\u2026",
                tone: "transitional",
                description: `Disarm command received and the connector is being stopped. ${$eed88a6d1aca2a19$export$990ae4c6ff1e85e3} If alerts keep arriving after that, arm and disarm the site again or contact support.`,
                transitional: true
            };
        case "DISARMED_DURING_SCHEDULE":
            return {
                status: status,
                label: "Disarmed (manual)",
                tone: "disarmed",
                description: "Disarmed manually during its schedule. It will re-arm at the next scheduled arm time, or as soon as you arm it.",
                transitional: false
            };
        case "NOT_RUNNING":
            if (armed) // The list API sets `armed` for clips-style sites whose schedule is
            // the only signal; keep the old wording for that combination.
            return {
                status: status,
                label: "Armed \u2013 not running",
                tone: "warning",
                description: "This site is meant to be armed but is not currently running.",
                transitional: false
            };
            return {
                status: status,
                label: "Disarmed",
                tone: "disarmed",
                description: "Not armed. It will arm at the next scheduled arm time, or as soon as you arm it.",
                transitional: false
            };
        case "UNKNOWN":
            return {
                status: status,
                label: "Unknown",
                tone: "unknown",
                description: "Armed status is unknown, or does not apply to this type of site (for example AI Link).",
                transitional: false
            };
        default:
            return armed ? {
                status: status,
                label: "Armed",
                tone: "armed",
                description: "Armed.",
                transitional: false
            } : {
                status: status,
                label: "Disarmed",
                tone: "disarmed",
                description: "Not armed. It will arm at the next scheduled arm time, or as soon as you arm it.",
                transitional: false
            };
    }
};

});



parcelRegister("iAGEB", function(module, exports) {

$parcel$export(module.exports, "getRecordingServerData", () => $08d7be088d7c8b35$export$186d693ee8d8a33a);
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $08d7be088d7c8b35$export$186d693ee8d8a33a = (customerID, setRecordingServerData, setRecordingServerPatchObject, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $08d7be088d7c8b35$export$186d693ee8d8a33a(customerID, setRecordingServerData, setRecordingServerPatchObject, navigate);
    };
    AxiosUI.get(`recording_server/?customer=${customerID}`).then((response)=>{
        setRecordingServerData(response.data);
        setRecordingServerPatchObject(response.data);
        localStorage.setItem("recordingServerBackup", JSON.stringify(response.data));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
    });
};

});

parcelRegister("igqrx", function(module, exports) {

$parcel$export(module.exports, "isResourceNotFoundError", () => $90d71d0e70116544$export$98ec558799a14a12);
$parcel$export(module.exports, "navigateToResourceNotFound", () => $90d71d0e70116544$export$b9afa9a361a7cdc5);
const $90d71d0e70116544$export$98ec558799a14a12 = (reason)=>{
    const status = reason?.response?.status ?? reason?.request?.status;
    return status === 404;
};
const $90d71d0e70116544$export$b9afa9a361a7cdc5 = (navigate, resource, id)=>{
    navigate("/not-found", {
        replace: true,
        state: {
            resource: resource,
            id: id
        }
    });
};

});



parcelRegister("hGi2P", function(module, exports) {

$parcel$export(module.exports, "createOptimalSettingsIcon", () => $290023fb17f9b418$export$e20667e62845fc5b);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $2aMB5 = parcelRequire("2aMB5");

var $gt8Ee = parcelRequire("gt8Ee");

var $lWchQ = parcelRequire("lWchQ");

var $cVCJe = parcelRequire("cVCJe");
const $290023fb17f9b418$export$e20667e62845fc5b = (srcImages, object)=>{
    const optimal_settings = object.optimal_settings;
    const optimal_settings_note = object.optimal_settings_note;
    const srcImageString = `${object.id}full`;
    let cameraViewString = "";
    let dynamicSlicing = false;
    if (srcImages[srcImageString]) {
        cameraViewString = srcImages[srcImageString].camera_view;
        if (srcImages[srcImageString].comments) {
            if (srcImages[srcImageString].comments.includes("Dynamic slicing is enabled")) dynamicSlicing = true;
        }
    }
    if (cameraViewString === "fisheye" || cameraViewString === "thermal") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: "Optimal settings can not be properly determined due to camera view type or enabled slicing.",
        children: (0, $lWchQ.checkedCircleIconGrey)
    });
    if (dynamicSlicing) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: "Optimal settings can not be properly determined due to dynamic slicing.",
        children: (0, $lWchQ.checkedCircleIconGrey)
    });
    if (optimal_settings === "warning") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: optimal_settings_note,
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gt8Ee))), {
            sx: {
                color: "#FF8400"
            }
        })
    });
    if (optimal_settings === "bad") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: optimal_settings_note,
        children: (0, $2aMB5.cancelIconRed)
    });
    if (optimal_settings === "good") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: optimal_settings_note,
        children: (0, $lWchQ.checkedCircleIcon)
    });
    if (optimal_settings === "unknown") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: "Unable to determine or camera information is still not available",
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gt8Ee))), {
            sx: {
                color: "#9e9e9e"
            }
        })
    });
};

});

parcelRegister("eka8d", function(module, exports) {

$parcel$export(module.exports, "BulkUpdateProductsDialog", () => $5c66ad482007884f$export$7da866f0f0ba2d4c);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $3QMQN = parcelRequire("3QMQN");
var $eDfvp = parcelRequire("eDfvp");
var $a65wX = parcelRequire("a65wX");
var $kbChx = parcelRequire("kbChx");
var $60vL1 = parcelRequire("60vL1");
var $kUcVg = parcelRequire("kUcVg");
var $887xF = parcelRequire("887xF");
var $1TOOV = parcelRequire("1TOOV");
var $ce8iU = parcelRequire("ce8iU");
var $iKAtE = parcelRequire("iKAtE");
var $k8Qy8 = parcelRequire("k8Qy8");
var $gXvgZ = parcelRequire("gXvgZ");
var $aVDw9 = parcelRequire("aVDw9");
var $3Nm8Z = parcelRequire("3Nm8Z");
var $ha39s = parcelRequire("ha39s");
var $4o6Cs = parcelRequire("4o6Cs");
var $eejVe = parcelRequire("eejVe");
var $f3puC = parcelRequire("f3puC");

var $8E01L = parcelRequire("8E01L");

var $3QMQN = parcelRequire("3QMQN");

var $gVgDF = parcelRequire("gVgDF");

var $433j1 = parcelRequire("433j1");

var $dHtmK = parcelRequire("dHtmK");

var $3Zv1D = parcelRequire("3Zv1D");

var $815yO = parcelRequire("815yO");

var $3FJ79 = parcelRequire("3FJ79");

var $kKBBF = parcelRequire("kKBBF");

var $jK0A2 = parcelRequire("jK0A2");

var $iUWjS = parcelRequire("iUWjS");

var $kcocJ = parcelRequire("kcocJ");
const $5c66ad482007884f$var$STEP_LABELS = [
    "Update Type",
    "Configure",
    "Review"
];
const $5c66ad482007884f$var$buildProductNameMap = (rows)=>rows.reduce((accumulator, row)=>{
        accumulator[row.key] = row.label;
        return accumulator;
    }, {});
const $5c66ad482007884f$var$formatEnableValue = (value)=>{
    if (value === "enable") return "Enable";
    if (value === "disable") return "Disable";
    return "\u2014";
};
const $5c66ad482007884f$var$formatSensitivityValue = (value)=>{
    if (value === "low") return "Low";
    if (value === "medium") return "Medium";
    if (value === "medium_high") return "Medium-High";
    if (value === "high") return "High";
    return "\u2014";
};
const $5c66ad482007884f$export$7da866f0f0ba2d4c = ({ open: open, selectedCameras: selectedCameras, activeCameraProducts: activeCameraProducts, activeCameraProductsLoading: activeCameraProductsLoading, siteInfo: siteInfo, navigate: navigate, onClose: onClose, onApply: onApply, productRows: productRows = (0, $kKBBF.PRODUCT_BULK_ROWS) })=>{
    const clearBulkCameraCachesForCameras = (0, $3FJ79.useSiteAboutStore)((s)=>s.clearBulkCameraCachesForCameras);
    const refreshActiveCameraProductsFromSimplifiedEndpoint = (0, $3FJ79.useSiteAboutStore)((s)=>s.refreshActiveCameraProductsFromSimplifiedEndpoint);
    const productNameMap = $8T3gX.useMemo(()=>$5c66ad482007884f$var$buildProductNameMap(productRows), [
        productRows
    ]);
    const orangeTextButtonSx = {
        fontFamily: "Mulish",
        color: "#FF8400",
        fontWeight: 700,
        "&:hover": {
            backgroundColor: "#FFF3E6",
            color: "#E67600"
        }
    };
    const orangeContainedButtonSx = {
        fontFamily: "Mulish",
        backgroundColor: "#FF8400",
        color: "white",
        fontWeight: 700,
        "&:hover": {
            backgroundColor: "#E67600"
        }
    };
    const [step, setStep] = $8T3gX.useState(0);
    const [selectedUpdateType, setSelectedUpdateType] = $8T3gX.useState("products");
    const [formState, setFormState] = $8T3gX.useState(()=>(0, $kKBBF.createInitialProductBulkFormState)(productRows));
    const [fieldErrors, setFieldErrors] = $8T3gX.useState({});
    const [slicingMergedRows, setSlicingMergedRows] = $8T3gX.useState([]);
    const [slicingRowsLoading, setSlicingRowsLoading] = $8T3gX.useState(false);
    const [slicingRowsError, setSlicingRowsError] = $8T3gX.useState(null);
    const [slicingDesiredByStreamId, setSlicingDesiredByStreamId] = $8T3gX.useState({});
    const [applyLoading, setApplyLoading] = $8T3gX.useState(false);
    const [applyError, setApplyError] = $8T3gX.useState(null);
    const [bulkResultSnackbar, setBulkResultSnackbar] = $8T3gX.useState({
        open: false,
        message: ""
    });
    const selectedCameraIds = $8T3gX.useMemo(()=>selectedCameras.map((camera)=>Number(camera.id)), [
        selectedCameras
    ]);
    const selectedCameraIdsKey = selectedCameraIds.join(",");
    const slicingMergedRowsRef = $8T3gX.useRef(slicingMergedRows);
    $8T3gX.useEffect(()=>{
        slicingMergedRowsRef.current = slicingMergedRows;
    }, [
        slicingMergedRows
    ]);
    const setAllSlicingDesired = (slice)=>{
        setSlicingDesiredByStreamId((previous)=>{
            const next = {
                ...previous
            };
            slicingMergedRowsRef.current.forEach((row)=>{
                next[row.streamId] = slice;
            });
            return next;
        });
    };
    const setSlicingDesiredForStream = (streamId, slice)=>{
        setSlicingDesiredByStreamId((previous)=>({
                ...previous,
                [streamId]: slice
            }));
    };
    $8T3gX.useEffect(()=>{
        if (!open) {
            setStep(0);
            setSelectedUpdateType("products");
            setFormState((0, $kKBBF.createInitialProductBulkFormState)(productRows));
            setFieldErrors({});
            setApplyError(null);
            setApplyLoading(false);
            setSlicingMergedRows([]);
            setSlicingRowsLoading(false);
            setSlicingRowsError(null);
            setSlicingDesiredByStreamId({});
        } else setBulkResultSnackbar({
            open: false,
            message: ""
        });
    }, [
        open,
        productRows
    ]);
    $8T3gX.useEffect(()=>{
        if (!open || step !== 1 || selectedUpdateType !== "slicing") return;
        const customerId = siteInfo?.id;
        if (customerId === undefined || customerId === null) {
            setSlicingRowsError("Missing site id for stream lookup.");
            setSlicingMergedRows([]);
            setSlicingDesiredByStreamId({});
            return;
        }
        let cancelled = false;
        setSlicingRowsLoading(true);
        setSlicingRowsError(null);
        (async ()=>{
            try {
                const [simpleRows, ...productLists] = await Promise.all([
                    (0, $jK0A2.fetchStreamsSimple)(navigate, customerId),
                    ...selectedCameraIds.map((id)=>(0, $jK0A2.fetchStreamProductsForCamera)(navigate, id))
                ]);
                if (cancelled) return;
                const productByCamera = new Map();
                selectedCameraIds.forEach((id, index)=>{
                    productByCamera.set(id, productLists[index] ?? []);
                });
                const streamIdToLabel = (0, $iUWjS.buildStreamIdToProductLabelMap)(productByCamera);
                const nameMap = new Map(selectedCameras.map((c)=>[
                        Number(c.id),
                        c.camera_name
                    ]));
                const merged = (0, $iUWjS.mergeBulkSlicingRows)(simpleRows, streamIdToLabel, selectedCameraIds, nameMap);
                if (cancelled) return;
                setSlicingMergedRows(merged);
                setSlicingDesiredByStreamId(Object.fromEntries(merged.map((row)=>[
                        row.streamId,
                        row.currentSlice
                    ])));
            } catch  {
                if (!cancelled) {
                    setSlicingRowsError("Could not load slicing data. Try again.");
                    setSlicingMergedRows([]);
                    setSlicingDesiredByStreamId({});
                }
            } finally{
                if (!cancelled) setSlicingRowsLoading(false);
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        open,
        step,
        selectedUpdateType,
        siteInfo?.id,
        selectedCameraIdsKey,
        navigate,
        selectedCameras,
        selectedCameraIds
    ]);
    $8T3gX.useEffect(()=>{
        if (!open || selectedUpdateType !== "products") return;
        setFormState((previousState)=>{
            let next = null;
            const ensureNext = ()=>{
                if (!next) next = {
                    ...previousState
                };
                return next;
            };
            productRows.forEach((row)=>{
                if (!(0, $kKBBF.getMutuallyExclusiveBulkGroupForKey)(row.key)) return;
                if (!(0, $kKBBF.isBulkRowRestrictedByPeerEnableSelection)(row.key, previousState)) return;
                const rowState = previousState[row.key];
                if (!rowState) return;
                const loiterTrim = row.supportsLoiteringSeconds && rowState.loiteringSeconds ? rowState.loiteringSeconds.trim() : "";
                const needsClear = rowState.enable === "enable" || rowState.sensitivity !== "no_change" || loiterTrim.length > 0;
                if (!needsClear) return;
                const draft = ensureNext();
                draft[row.key] = {
                    ...rowState,
                    enable: rowState.enable === "enable" ? "no_change" : rowState.enable,
                    sensitivity: "no_change",
                    loiteringSeconds: row.supportsLoiteringSeconds ? "" : rowState.loiteringSeconds
                };
            });
            return next ?? previousState;
        });
    }, [
        open,
        selectedUpdateType,
        formState,
        productRows
    ]);
    const loadingCount = selectedCameraIds.filter((cameraId)=>activeCameraProductsLoading[cameraId]).length;
    const payloadPreview = (0, $kKBBF.buildBulkProductChangePayload)(productRows, formState);
    const setFieldState = (key, update)=>{
        setFormState((previousState)=>({
                ...previousState,
                [key]: {
                    ...previousState[key],
                    ...update
                }
            }));
    };
    const handleNext = ()=>{
        if (step === 1 && selectedUpdateType === "products") {
            const errors = (0, $kKBBF.validateLoiteringSeconds)(productRows, formState);
            setFieldErrors(errors);
            if (Object.keys(errors).length > 0) return;
            const exclusiveError = (0, $kKBBF.validateMutuallyExclusiveProductGroupsForCameras)(selectedCameraIds, formState, activeCameraProducts);
            if (exclusiveError) {
                setApplyError(exclusiveError);
                return;
            }
            setApplyError(null);
        }
        if (step === 1 && selectedUpdateType === "slicing") {
            if (slicingRowsLoading) return;
            if (slicingRowsError) return;
            if (slicingMergedRows.length === 0) {
                setApplyError("No stream products found for the selected cameras.");
                return;
            }
            setApplyError(null);
        }
        setStep((previousStep)=>Math.min(previousStep + 1, $5c66ad482007884f$var$STEP_LABELS.length - 1));
    };
    const handleApply = async ()=>{
        setApplyError(null);
        if (selectedUpdateType === "products") {
            const errors = (0, $kKBBF.validateLoiteringSeconds)(productRows, formState);
            setFieldErrors(errors);
            if (Object.keys(errors).length > 0) {
                setStep(1);
                return;
            }
            if (loadingCount > 0) {
                setApplyError("Still loading product status for some cameras. Please wait.");
                return;
            }
            const exclusiveError = (0, $kKBBF.validateMutuallyExclusiveProductGroupsForCameras)(selectedCameraIds, formState, activeCameraProducts);
            if (exclusiveError) {
                setApplyError(exclusiveError);
                setStep(1);
                return;
            }
        }
        setApplyLoading(true);
        try {
            if (selectedUpdateType === "products") {
                const referenceCameraId = selectedCameraIds[0];
                let sensitivityMap = await (0, $jK0A2.fetchMetricSensitivityMap)(navigate, referenceCameraId);
                let missingLabels = (0, $kKBBF.findMissingSensitivityIds)(productRows, formState, sensitivityMap);
                if (missingLabels.length > 0) // /metric/?camera_id= only lists metrics that exist — disabling a
                // product hard-deletes its row — so enabling a currently-disabled
                // product with a sensitivity can't resolve from it (SUP-287).
                // general_info includes options for every available product (the
                // same source Edit Camera uses), so fill the gaps from there.
                try {
                    const generalInfoMap = await (0, $jK0A2.fetchGeneralInfoSensitivityMap)(navigate, referenceCameraId);
                    sensitivityMap = (0, $jK0A2.mergeSensitivityMaps)(sensitivityMap, generalInfoMap);
                    missingLabels = (0, $kKBBF.findMissingSensitivityIds)(productRows, formState, sensitivityMap);
                } catch  {
                // Fall through to the unresolved-sensitivity error below.
                }
                if (missingLabels.length > 0) {
                    setApplyError(`Could not resolve sensitivity options for: ${missingLabels.join(", ")}. Try again or update those products from Edit Camera.`);
                    return;
                }
                const bulkItems = (0, $kKBBF.mergeImplicitExclusiveGroupDisablesIntoBulkPayload)(formState, (0, $kKBBF.buildMetricBulkUpdateApiPayload)(productRows, formState, sensitivityMap));
                if (bulkItems.length === 0) {
                    setApplyError("No product changes to apply. Adjust the form or choose No Change.");
                    return;
                }
                const mergeSnapshot = {};
                selectedCameraIds.forEach((id)=>{
                    mergeSnapshot[id] = {
                        ...activeCameraProducts[id] ?? {}
                    };
                });
                const data = await (0, $jK0A2.postMetricBulkUpdate)(navigate, selectedCameraIds, bulkItems);
                clearBulkCameraCachesForCameras(selectedCameraIds);
                // Product changes ride settings.json to the connector — mark the site
                // unsynced so the Sync Site button turns red and directs the operator
                // to sync (then restart) rather than leaving the change silent.
                (0, $815yO.markSiteUnsynced)();
                const queued = data.cameras_queued ?? selectedCameraIds.length;
                const customerId = siteInfo?.id;
                if (data.status === "queued" && customerId !== undefined && customerId !== null) {
                    const matched = await (0, $kcocJ.pollMetricSimplifiedUntilBulkExpectationsMet)(navigate, customerId, selectedCameraIds, formState, mergeSnapshot, {
                        productRows: productRows
                    });
                    if (matched) {
                        await refreshActiveCameraProductsFromSimplifiedEndpoint(navigate, customerId, selectedCameraIds);
                        setBulkResultSnackbar({
                            open: true,
                            message: `Bulk product update completed for ${queued} camera(s).`
                        });
                    } else setBulkResultSnackbar({
                        open: true,
                        message: `Bulk product update has been queued for ${queued} camera(s). Updates may take some time to complete.`
                    });
                } else if (data.status === "queued") setBulkResultSnackbar({
                    open: true,
                    message: `Bulk product update has been queued for ${queued} camera(s). Updates may take some time to complete.`
                });
                else setBulkResultSnackbar({
                    open: true,
                    message: `Bulk product update submitted for ${queued} camera(s).`
                });
                onApply();
                return;
            }
            const { enableIds: enableIds, disableIds: disableIds } = (0, $iUWjS.partitionStreamIdsForSliceUpdate)(slicingMergedRows, slicingDesiredByStreamId);
            if (enableIds.length === 0 && disableIds.length === 0) {
                setApplyError("No slice changes to apply.");
                return;
            }
            if (enableIds.length > 0) await (0, $jK0A2.postStreamBulkUpdate)(navigate, {
                stream_ids: enableIds,
                slice: true
            });
            if (disableIds.length > 0) await (0, $jK0A2.postStreamBulkUpdate)(navigate, {
                stream_ids: disableIds,
                slice: false
            });
            clearBulkCameraCachesForCameras(selectedCameraIds);
            // Slicing also rides settings.json — same unsynced marking as products.
            (0, $815yO.markSiteUnsynced)();
            setBulkResultSnackbar({
                open: true,
                message: "Slicing has been updated for the selected cameras."
            });
            onApply();
        } catch (reason) {
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, ()=>{}, ()=>{});
        } finally{
            setApplyLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                openState: applyLoading,
                stackAboveModal: true,
                message: "Applying bulk update\u2026"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                open: open,
                onClose: ()=>{
                    if (applyLoading) return;
                    onClose();
                },
                disableEscapeKeyDown: applyLoading,
                maxWidth: step === 1 && (selectedUpdateType === "products" || selectedUpdateType === "slicing") || step === 2 && selectedUpdateType === "slicing" ? "lg" : "sm",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $ce8iU.default), {
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: 700,
                            bgcolor: "#1B2A4A",
                            color: "white",
                            py: 2.25,
                            pr: 6
                        },
                        children: [
                            "Bulk Update",
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                onClick: onClose,
                                disabled: applyLoading,
                                "aria-label": "close bulk update dialog",
                                sx: {
                                    position: "absolute",
                                    right: 12,
                                    top: 12,
                                    color: "white",
                                    "&:hover": {
                                        backgroundColor: "rgba(255, 255, 255, 0.12)"
                                    }
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                        dividers: true,
                        sx: {
                            p: 3
                        },
                        children: [
                            applyError ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                                severity: "error",
                                sx: {
                                    mb: 2,
                                    fontFamily: "Mulish"
                                },
                                onClose: ()=>setApplyError(null),
                                children: applyError
                            }) : null,
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                                sx: {
                                    mb: 3,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    gap: 2,
                                    flexWrap: "wrap"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                        sx: {
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1.25,
                                            flexWrap: "wrap"
                                        },
                                        children: $5c66ad482007884f$var$STEP_LABELS.map((label, index)=>/*#__PURE__*/ (0, $k4ank.jsxs)($8T3gX.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                                                        sx: {
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            gap: 0.75
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                                                sx: {
                                                                    width: 24,
                                                                    height: 24,
                                                                    borderRadius: "50%",
                                                                    display: "inline-flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    fontFamily: "Mulish",
                                                                    fontSize: "12px",
                                                                    fontWeight: 700,
                                                                    color: index <= step ? "white" : "#9E9E9E",
                                                                    bgcolor: index <= step ? "#E8871E" : "#EEEEEE"
                                                                },
                                                                children: index < step ? "\u2713" : index + 1
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    fontSize: "13px",
                                                                    fontWeight: index === step ? 700 : 600,
                                                                    color: index === step ? "#212121" : "#757575"
                                                                },
                                                                children: label
                                                            })
                                                        ]
                                                    }),
                                                    index < $5c66ad482007884f$var$STEP_LABELS.length - 1 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                                        sx: {
                                                            width: 18,
                                                            height: 2,
                                                            bgcolor: "#E0E0E0"
                                                        }
                                                    })
                                                ]
                                            }, label))
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                        sx: {
                                            fontFamily: "Mulish",
                                            fontSize: "12px",
                                            color: "#757575"
                                        },
                                        children: [
                                            "Applying to ",
                                            selectedCameras.length,
                                            " camera",
                                            selectedCameras.length === 1 ? "" : "s"
                                        ]
                                    })
                                ]
                            }),
                            step === 0 && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                        sx: {
                                            fontFamily: "Mulish",
                                            fontWeight: 700,
                                            mb: 1
                                        },
                                        children: "Update Type"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                        sx: {
                                            fontFamily: "Mulish",
                                            mb: 2,
                                            color: "#616161"
                                        },
                                        children: "Choose what to bulk update."
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                                        sx: {
                                            border: "1px solid #E8871E",
                                            borderRadius: 2,
                                            bgcolor: selectedUpdateType === "products" ? "#FFF3E6" : "transparent",
                                            p: 1.5,
                                            mb: 2,
                                            cursor: "pointer"
                                        },
                                        onClick: ()=>setSelectedUpdateType("products"),
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    fontWeight: 700,
                                                    color: "#E8871E"
                                                },
                                                children: "Products"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    fontSize: "13px",
                                                    color: "#616161"
                                                },
                                                children: "Enable/Disable products, update sensitivity, and optionally set loitering times."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                                        sx: {
                                            border: "1px solid #E8871E",
                                            borderRadius: 2,
                                            bgcolor: selectedUpdateType === "slicing" ? "#FFF3E6" : "transparent",
                                            p: 1.5,
                                            mb: 2,
                                            cursor: "pointer"
                                        },
                                        onClick: ()=>setSelectedUpdateType("slicing"),
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    fontWeight: 700,
                                                    color: "#E8871E"
                                                },
                                                children: "Slicing"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    fontSize: "13px",
                                                    color: "#616161"
                                                },
                                                children: "Enable or disable slicing per stream product for the selected cameras."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                        sx: {
                                            fontFamily: "Mulish",
                                            fontWeight: 700,
                                            mb: 1
                                        },
                                        children: [
                                            "Selected Cameras (",
                                            selectedCameras.length,
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                        sx: {
                                            display: "flex",
                                            gap: 1,
                                            flexWrap: "wrap"
                                        },
                                        children: selectedCameras.map((camera)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                                sx: {
                                                    px: 1.25,
                                                    py: 0.5,
                                                    borderRadius: 99,
                                                    fontSize: "12px",
                                                    color: "#E8871E",
                                                    backgroundColor: "#FFF3E6",
                                                    fontFamily: "Mulish",
                                                    fontWeight: 700
                                                },
                                                children: camera.camera_name
                                            }, camera.id))
                                    })
                                ]
                            }),
                            step === 1 && selectedUpdateType === "products" && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                        sx: {
                                            fontFamily: "Mulish",
                                            fontWeight: 700,
                                            mb: 1
                                        },
                                        children: "Current Products"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                        sx: {
                                            border: "1px solid #E0E0E0",
                                            borderRadius: 1,
                                            mb: 2
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                            size: "small",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    fontWeight: 700
                                                                },
                                                                children: "Camera"
                                                            }),
                                                            productRows.map((row)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    sx: {
                                                                        fontFamily: "Mulish",
                                                                        fontWeight: 700
                                                                    },
                                                                    children: row.label
                                                                }, row.key))
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                    children: selectedCameras.map((camera)=>{
                                                        const cameraId = Number(camera.id);
                                                        const loading = activeCameraProductsLoading[cameraId];
                                                        const productStates = activeCameraProducts[cameraId] || {};
                                                        return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: camera.camera_name
                                                                }),
                                                                productRows.map((row)=>{
                                                                    if (loading) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                                                            size: 14
                                                                        })
                                                                    }, row.key);
                                                                    const enabled = productStates[productNameMap[row.key]] === true || productStates[row.label] === true;
                                                                    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                                                            sx: {
                                                                                width: 12,
                                                                                height: 12,
                                                                                borderRadius: "50%",
                                                                                bgcolor: enabled ? "#2E8B3C" : "#D94040",
                                                                                mx: "auto"
                                                                            }
                                                                        })
                                                                    }, row.key);
                                                                })
                                                            ]
                                                        }, camera.id);
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                        sx: {
                                            fontFamily: "Mulish",
                                            fontWeight: 700,
                                            mb: 1,
                                            paddingBottom: 1
                                        },
                                        children: "Updated Products"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                        sx: {
                                            fontFamily: "Mulish",
                                            mb: 2,
                                            color: "#616161"
                                        },
                                        children: "Configure No Change, Enable, Disable, sensitivity, and optional loitering time fields."
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                        sx: {
                                            border: "1px solid #E0E0E0",
                                            borderRadius: 1
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                            size: "small",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    fontWeight: 700
                                                                },
                                                                children: "Product"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    fontWeight: 700
                                                                },
                                                                children: "Enable"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    fontWeight: 700
                                                                },
                                                                children: "Sensitivity"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    fontWeight: 700
                                                                },
                                                                children: "Loitering Time (sec)"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                    children: productRows.map((row)=>{
                                                        const peerRestricted = (0, $kKBBF.isBulkRowRestrictedByPeerEnableSelection)(row.key, formState);
                                                        return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: row.label
                                                                }),
                                                                peerRestricted ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    colSpan: 3,
                                                                    sx: {
                                                                        maxWidth: 520,
                                                                        verticalAlign: "top"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                                                        sx: {
                                                                            fontFamily: "Mulish",
                                                                            fontSize: "12px",
                                                                            lineHeight: 1.45,
                                                                            color: "#616161"
                                                                        },
                                                                        children: (0, $kKBBF.getBulkPeerEnableBlockedExplanation)(row.key, formState)
                                                                    })
                                                                }) : /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                            sx: {
                                                                                verticalAlign: "top"
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eejVe.default), {
                                                                                select: true,
                                                                                size: "small",
                                                                                SelectProps: {
                                                                                    native: true
                                                                                },
                                                                                value: formState[row.key].enable,
                                                                                inputProps: {
                                                                                    "data-testid": `bulk-enable-${row.key}`
                                                                                },
                                                                                onChange: (event)=>setFieldState(row.key, {
                                                                                        enable: event.target.value
                                                                                    }),
                                                                                sx: {
                                                                                    minWidth: 130
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $k4ank.jsx)("option", {
                                                                                        value: "no_change",
                                                                                        children: "No Change"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $k4ank.jsx)("option", {
                                                                                        value: "enable",
                                                                                        children: "Enable All"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $k4ank.jsx)("option", {
                                                                                        value: "disable",
                                                                                        children: "Disable All"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                            sx: {
                                                                                verticalAlign: "top"
                                                                            },
                                                                            children: row.supportsSensitivity ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eejVe.default), {
                                                                                select: true,
                                                                                size: "small",
                                                                                SelectProps: {
                                                                                    native: true
                                                                                },
                                                                                value: formState[row.key].sensitivity,
                                                                                inputProps: {
                                                                                    "data-testid": `bulk-sensitivity-${row.key}`
                                                                                },
                                                                                onChange: (event)=>setFieldState(row.key, {
                                                                                        sensitivity: event.target.value
                                                                                    }),
                                                                                sx: {
                                                                                    minWidth: 130
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $k4ank.jsx)("option", {
                                                                                        value: "no_change",
                                                                                        children: "No Change"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $k4ank.jsx)("option", {
                                                                                        value: "low",
                                                                                        children: "Low"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $k4ank.jsx)("option", {
                                                                                        value: "medium",
                                                                                        children: "Medium"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $k4ank.jsx)("option", {
                                                                                        value: "medium_high",
                                                                                        children: "Medium-High"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $k4ank.jsx)("option", {
                                                                                        value: "high",
                                                                                        children: "High"
                                                                                    })
                                                                                ]
                                                                            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                                                                sx: {
                                                                                    fontFamily: "Mulish",
                                                                                    color: "#9E9E9E"
                                                                                },
                                                                                children: "N/A"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                            sx: {
                                                                                verticalAlign: "top"
                                                                            },
                                                                            children: row.supportsLoiteringSeconds ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                                size: "small",
                                                                                value: formState[row.key].loiteringSeconds,
                                                                                onChange: (event)=>setFieldState(row.key, {
                                                                                        loiteringSeconds: event.target.value
                                                                                    }),
                                                                                error: Boolean(fieldErrors[row.key]),
                                                                                helperText: fieldErrors[row.key] ?? "Optional",
                                                                                inputProps: {
                                                                                    inputMode: "numeric",
                                                                                    pattern: "[0-9]*",
                                                                                    "data-testid": `bulk-loitering-${row.key}`
                                                                                }
                                                                            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                                                                sx: {
                                                                                    fontFamily: "Mulish",
                                                                                    color: "#9E9E9E"
                                                                                },
                                                                                children: "\u2014"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }, row.key);
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    loadingCount > 0 && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                        sx: {
                                            fontFamily: "Mulish",
                                            mt: 1,
                                            color: "#616161"
                                        },
                                        children: [
                                            "Loading camera product status for ",
                                            loadingCount,
                                            " selected camera",
                                            loadingCount === 1 ? "" : "s",
                                            "..."
                                        ]
                                    })
                                ]
                            }),
                            step === 1 && selectedUpdateType === "slicing" && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                                children: [
                                    slicingRowsError ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                                        severity: "error",
                                        sx: {
                                            mb: 2,
                                            fontFamily: "Mulish"
                                        },
                                        children: slicingRowsError
                                    }) : null,
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                        sx: {
                                            fontFamily: "Mulish",
                                            fontWeight: 700,
                                            mb: 1
                                        },
                                        children: "Current Slicing"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                        sx: {
                                            border: "1px solid #E0E0E0",
                                            borderRadius: 1,
                                            mb: 2
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                            size: "small",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    fontWeight: 700
                                                                },
                                                                children: "Camera"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    fontWeight: 700
                                                                },
                                                                children: "Products"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    fontWeight: 700
                                                                },
                                                                children: "Slicing"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                    children: slicingRowsLoading ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            colSpan: 3,
                                                            sx: {
                                                                fontFamily: "Mulish"
                                                            },
                                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                                                                sx: {
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: 1,
                                                                    py: 1
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                                                        size: 18
                                                                    }),
                                                                    "Loading stream products and slicing status\u2026"
                                                                ]
                                                            })
                                                        })
                                                    }) : slicingMergedRows.length === 0 ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            colSpan: 3,
                                                            sx: {
                                                                fontFamily: "Mulish",
                                                                color: "#616161"
                                                            },
                                                            children: "No stream products found for the selected cameras."
                                                        })
                                                    }) : slicingMergedRows.map((row)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: row.cameraName || `Camera ${row.cameraId}`
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: row.productLabel
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                                                        sx: {
                                                                            width: 12,
                                                                            height: 12,
                                                                            borderRadius: "50%",
                                                                            bgcolor: row.currentSlice ? "#2E8B3C" : "#D94040"
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        }, row.streamId))
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                        sx: {
                                            fontFamily: "Mulish",
                                            fontWeight: 700,
                                            mb: 1,
                                            paddingBottom: 1
                                        },
                                        children: "Updated Slicing"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                        sx: {
                                            border: "1px solid #E0E0E0",
                                            borderRadius: 1
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                            size: "small",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    fontWeight: 700
                                                                },
                                                                children: "Camera"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    fontWeight: 700
                                                                },
                                                                children: "Products"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    fontWeight: 700
                                                                },
                                                                align: "center",
                                                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                                                                    sx: {
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        alignItems: "center"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                                                            sx: {
                                                                                fontFamily: "Mulish",
                                                                                fontWeight: 700,
                                                                                fontSize: "12px"
                                                                            },
                                                                            children: "Enable"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                                            size: "small",
                                                                            disabled: slicingRowsLoading || slicingMergedRows.length === 0,
                                                                            checked: slicingMergedRows.length > 0 && slicingMergedRows.every((r)=>slicingDesiredByStreamId[r.streamId] === true),
                                                                            indeterminate: slicingMergedRows.some((r)=>slicingDesiredByStreamId[r.streamId] === true) && !slicingMergedRows.every((r)=>slicingDesiredByStreamId[r.streamId] === true),
                                                                            onChange: ()=>setAllSlicingDesired(true),
                                                                            inputProps: {
                                                                                "aria-label": "Select enable slicing for all rows"
                                                                            },
                                                                            "data-testid": "bulk-slicing-select-all-enable"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    fontWeight: 700
                                                                },
                                                                align: "center",
                                                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                                                                    sx: {
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                        alignItems: "center"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                                                            sx: {
                                                                                fontFamily: "Mulish",
                                                                                fontWeight: 700,
                                                                                fontSize: "12px"
                                                                            },
                                                                            children: "Disable"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                                            size: "small",
                                                                            disabled: slicingRowsLoading || slicingMergedRows.length === 0,
                                                                            checked: slicingMergedRows.length > 0 && slicingMergedRows.every((r)=>slicingDesiredByStreamId[r.streamId] === false),
                                                                            indeterminate: slicingMergedRows.some((r)=>slicingDesiredByStreamId[r.streamId] === false) && !slicingMergedRows.every((r)=>slicingDesiredByStreamId[r.streamId] === false),
                                                                            onChange: ()=>setAllSlicingDesired(false),
                                                                            inputProps: {
                                                                                "aria-label": "Select disable slicing for all rows"
                                                                            },
                                                                            "data-testid": "bulk-slicing-select-all-disable"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                    children: slicingRowsLoading ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            colSpan: 4,
                                                            sx: {
                                                                fontFamily: "Mulish"
                                                            },
                                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                                                                sx: {
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: 1,
                                                                    py: 1
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                                                        size: 18
                                                                    }),
                                                                    "Loading\u2026"
                                                                ]
                                                            })
                                                        })
                                                    }) : slicingMergedRows.length === 0 ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            colSpan: 4,
                                                            sx: {
                                                                fontFamily: "Mulish",
                                                                color: "#616161"
                                                            },
                                                            children: "No rows to update."
                                                        })
                                                    }) : slicingMergedRows.map((row)=>{
                                                        const desired = slicingDesiredByStreamId[row.streamId];
                                                        const enableChecked = desired === true;
                                                        const disableChecked = desired === false;
                                                        return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: row.cameraName || `Camera ${row.cameraId}`
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: row.productLabel
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "center",
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                                        size: "small",
                                                                        checked: enableChecked,
                                                                        onChange: ()=>setSlicingDesiredForStream(row.streamId, true),
                                                                        inputProps: {
                                                                            "aria-label": `Enable slicing for ${row.productLabel}`
                                                                        },
                                                                        "data-testid": `bulk-slicing-enable-${row.streamId}`
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "center",
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                                        size: "small",
                                                                        checked: disableChecked,
                                                                        onChange: ()=>setSlicingDesiredForStream(row.streamId, false),
                                                                        inputProps: {
                                                                            "aria-label": `Disable slicing for ${row.productLabel}`
                                                                        },
                                                                        "data-testid": `bulk-slicing-disable-${row.streamId}`
                                                                    })
                                                                })
                                                            ]
                                                        }, `edit-${row.streamId}`);
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            step === 2 && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                        sx: {
                                            fontFamily: "Mulish",
                                            fontWeight: 700,
                                            mb: 1
                                        },
                                        children: "Review Changes"
                                    }),
                                    selectedUpdateType === "products" && payloadPreview.length === 0 ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                        sx: {
                                            fontFamily: "Mulish",
                                            color: "#9E9E9E"
                                        },
                                        children: "No changes selected yet."
                                    }) : null,
                                    selectedUpdateType === "products" && payloadPreview.length > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                        sx: {
                                            border: "1px solid #E0E0E0",
                                            borderRadius: 1
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                            size: "small",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    fontWeight: 700
                                                                },
                                                                children: "Product"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    fontWeight: 700
                                                                },
                                                                children: "Enable/Disable"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    fontWeight: 700
                                                                },
                                                                children: "Sensitivity"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    fontWeight: 700
                                                                },
                                                                children: "Loitering (sec)"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                    children: payloadPreview.map((item)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: productNameMap[item.product] ?? item.product
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: $5c66ad482007884f$var$formatEnableValue(item.enable)
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: $5c66ad482007884f$var$formatSensitivityValue(item.sensitivity)
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: item.loitering_seconds ?? "\u2014"
                                                                })
                                                            ]
                                                        }, item.product))
                                                })
                                            ]
                                        })
                                    }),
                                    selectedUpdateType === "slicing" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                        sx: {
                                            border: "1px solid #E0E0E0",
                                            borderRadius: 1
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                            size: "small",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    fontWeight: 700
                                                                },
                                                                children: "Camera"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    fontWeight: 700
                                                                },
                                                                children: "Products"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    fontWeight: 700
                                                                },
                                                                children: "Slicing"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                    children: slicingMergedRows.map((row)=>{
                                                        const proposed = slicingDesiredByStreamId[row.streamId] === true;
                                                        return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: row.cameraName || `Camera ${row.cameraId}`
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: row.productLabel
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                                                        sx: {
                                                                            width: 12,
                                                                            height: 12,
                                                                            borderRadius: "50%",
                                                                            bgcolor: proposed ? "#2E8B3C" : "#D94040"
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        }, `review-${row.streamId}`);
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    selectedUpdateType === "products" ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                        sx: {
                                            mt: 2,
                                            border: "1px solid #FFE082",
                                            backgroundColor: "#FFF8E1",
                                            borderRadius: 1,
                                            p: 1.5
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontSize: "13px",
                                                color: "#8D6E00"
                                            },
                                            children: "Only products set to Enable or Disable will change. Products left as No Change keep current settings."
                                        })
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                        sx: {
                            px: 3,
                            py: 2
                        },
                        children: [
                            step > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                onClick: ()=>setStep((previousStep)=>previousStep - 1),
                                sx: orangeTextButtonSx,
                                children: "Back"
                            }),
                            step < 2 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                variant: "contained",
                                onClick: handleNext,
                                disabled: applyLoading || step === 1 && selectedUpdateType === "slicing" && (slicingRowsLoading || Boolean(slicingRowsError) || slicingMergedRows.length === 0),
                                sx: orangeContainedButtonSx,
                                children: "Next"
                            }),
                            step === 2 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                variant: "contained",
                                onClick: ()=>void handleApply(),
                                disabled: applyLoading,
                                sx: orangeContainedButtonSx,
                                children: applyLoading ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                    size: 22,
                                    sx: {
                                        color: "white"
                                    }
                                }) : "Apply Update"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gVgDF.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8E01L.default), {
                    open: bulkResultSnackbar.open,
                    autoHideDuration: 6000,
                    onClose: ()=>setBulkResultSnackbar({
                            open: false,
                            message: ""
                        }),
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center"
                    },
                    sx: {
                        zIndex: (theme)=>theme.zIndex.modal + 1
                    },
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                        elevation: 6,
                        variant: "filled",
                        severity: "success",
                        onClose: ()=>setBulkResultSnackbar({
                                open: false,
                                message: ""
                            }),
                        sx: {
                            width: "100%",
                            fontFamily: "Mulish"
                        },
                        children: bulkResultSnackbar.message
                    })
                })
            })
        ]
    });
};

});
parcelRegister("60vL1", function(module, exports) {

$parcel$export(module.exports, "default", () => $45fb6085c0e1a9e9$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $bPpmJ = parcelRequire("bPpmJ");

var $aYNpO = parcelRequire("aYNpO");

var $3JV9M = parcelRequire("3JV9M");

var $iMOmE = parcelRequire("iMOmE");

var $7AQZl = parcelRequire("7AQZl");

var $anJSP = parcelRequire("anJSP");

var $lG8Zt = parcelRequire("lG8Zt");

var $k4ank = parcelRequire("k4ank");
'use client';
const $45fb6085c0e1a9e9$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $45fb6085c0e1a9e9$var$_ = (t)=>t, $45fb6085c0e1a9e9$var$_t, $45fb6085c0e1a9e9$var$_t2, $45fb6085c0e1a9e9$var$_t3, $45fb6085c0e1a9e9$var$_t4;
const $45fb6085c0e1a9e9$var$SIZE = 44;
const $45fb6085c0e1a9e9$var$circularRotateKeyframe = (0, $3JV9M.keyframes)($45fb6085c0e1a9e9$var$_t || ($45fb6085c0e1a9e9$var$_t = $45fb6085c0e1a9e9$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $45fb6085c0e1a9e9$var$circularDashKeyframe = (0, $3JV9M.keyframes)($45fb6085c0e1a9e9$var$_t2 || ($45fb6085c0e1a9e9$var$_t2 = $45fb6085c0e1a9e9$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $45fb6085c0e1a9e9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $iMOmE.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $iMOmE.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $lG8Zt.getCircularProgressUtilityClass), classes);
};
const $45fb6085c0e1a9e9$var$CircularProgressRoot = (0, $anJSP.default)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $iMOmE.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $eJfrs.default)({
        display: 'inline-block'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('transform')
    }, ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && (0, $3JV9M.css)($45fb6085c0e1a9e9$var$_t3 || ($45fb6085c0e1a9e9$var$_t3 = $45fb6085c0e1a9e9$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $45fb6085c0e1a9e9$var$circularRotateKeyframe));
const $45fb6085c0e1a9e9$var$CircularProgressSVG = (0, $anJSP.default)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $45fb6085c0e1a9e9$var$CircularProgressCircle = (0, $anJSP.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $iMOmE.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $eJfrs.default)({
        stroke: 'currentColor'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('stroke-dashoffset')
    }, ownerState.variant === 'indeterminate' && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: '80px, 200px',
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink && (0, $3JV9M.css)($45fb6085c0e1a9e9$var$_t4 || ($45fb6085c0e1a9e9$var$_t4 = $45fb6085c0e1a9e9$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $45fb6085c0e1a9e9$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $45fb6085c0e1a9e9$var$CircularProgress = /*#__PURE__*/ $8T3gX.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate' } = props, other = (0, $fAJB5.default)(props, $45fb6085c0e1a9e9$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $45fb6085c0e1a9e9$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($45fb6085c0e1a9e9$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $k4ank.jsx)($45fb6085c0e1a9e9$var$CircularProgressRoot, (0, $eJfrs.default)({
        className: (0, $iVyaN.default)(classes.root, className),
        style: (0, $eJfrs.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $k4ank.jsx)($45fb6085c0e1a9e9$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$45fb6085c0e1a9e9$var$SIZE / 2} ${$45fb6085c0e1a9e9$var$SIZE / 2} ${$45fb6085c0e1a9e9$var$SIZE} ${$45fb6085c0e1a9e9$var$SIZE}`,
            children: /*#__PURE__*/ (0, $k4ank.jsx)($45fb6085c0e1a9e9$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $45fb6085c0e1a9e9$var$SIZE,
                cy: $45fb6085c0e1a9e9$var$SIZE,
                r: ($45fb6085c0e1a9e9$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
$45fb6085c0e1a9e9$var$CircularProgress.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'inherit',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */ disableShrink: (0, $bPpmJ.default)((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool, (props)=>{
        if (props.disableShrink && props.variant && props.variant !== 'indeterminate') return new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.");
        return null;
    }),
    /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * @ignore
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * The thickness of the circle.
   * @default 3.6
   */ thickness: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'determinate',
        'indeterminate'
    ])
};
var $45fb6085c0e1a9e9$export$2e2bcd8739ae039 = $45fb6085c0e1a9e9$var$CircularProgress;

});
parcelRegister("lG8Zt", function(module, exports) {

$parcel$export(module.exports, "getCircularProgressUtilityClass", () => $fc847e881c68f8ff$export$29cad1383b3f235d);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $fc847e881c68f8ff$export$29cad1383b3f235d(slot) {
    return (0, $kfTYv.default)('MuiCircularProgress', slot);
}
const $fc847e881c68f8ff$var$circularProgressClasses = (0, $jh2Zm.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $fc847e881c68f8ff$export$2e2bcd8739ae039 = $fc847e881c68f8ff$var$circularProgressClasses;

});


parcelRegister("8E01L", function(module, exports) {

$parcel$export(module.exports, "default", () => $64b2149fe034fa4e$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $aYNpO = parcelRequire("aYNpO");

var $6zZUJ = parcelRequire("6zZUJ");

var $gxWvx = parcelRequire("gxWvx");

var $eg2OC = parcelRequire("eg2OC");

var $anJSP = parcelRequire("anJSP");
var $4nWZ9 = parcelRequire("4nWZ9");

var $7AQZl = parcelRequire("7AQZl");

var $iMOmE = parcelRequire("iMOmE");

var $6CjWJ = parcelRequire("6CjWJ");

var $kUjql = parcelRequire("kUjql");

var $hTdcM = parcelRequire("hTdcM");

var $k4ank = parcelRequire("k4ank");
'use client';
const $64b2149fe034fa4e$var$_excluded = [
    "onEnter",
    "onExited"
], $64b2149fe034fa4e$var$_excluded2 = [
    "action",
    "anchorOrigin",
    "autoHideDuration",
    "children",
    "className",
    "ClickAwayListenerProps",
    "ContentProps",
    "disableWindowBlurListener",
    "message",
    "onBlur",
    "onClose",
    "onFocus",
    "onMouseEnter",
    "onMouseLeave",
    "open",
    "resumeHideDuration",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $64b2149fe034fa4e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchorOrigin: anchorOrigin } = ownerState;
    const slots = {
        root: [
            'root',
            `anchorOrigin${(0, $iMOmE.default)(anchorOrigin.vertical)}${(0, $iMOmE.default)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $hTdcM.getSnackbarUtilityClass), classes);
};
const $64b2149fe034fa4e$var$SnackbarRoot = (0, $anJSP.default)('div', {
    name: 'MuiSnackbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $iMOmE.default)(ownerState.anchorOrigin.vertical)}${(0, $iMOmE.default)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const center = {
        left: '50%',
        right: 'auto',
        transform: 'translateX(-50%)'
    };
    return (0, $eJfrs.default)({
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: 'fixed',
        display: 'flex',
        left: 8,
        right: 8,
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.anchorOrigin.vertical === 'top' ? {
        top: 8
    } : {
        bottom: 8
    }, ownerState.anchorOrigin.horizontal === 'left' && {
        justifyContent: 'flex-start'
    }, ownerState.anchorOrigin.horizontal === 'right' && {
        justifyContent: 'flex-end'
    }, {
        [theme.breakpoints.up('sm')]: (0, $eJfrs.default)({}, ownerState.anchorOrigin.vertical === 'top' ? {
            top: 24
        } : {
            bottom: 24
        }, ownerState.anchorOrigin.horizontal === 'center' && center, ownerState.anchorOrigin.horizontal === 'left' && {
            left: 24,
            right: 'auto'
        }, ownerState.anchorOrigin.horizontal === 'right' && {
            right: 24,
            left: 'auto'
        })
    });
});
const $64b2149fe034fa4e$var$Snackbar = /*#__PURE__*/ $8T3gX.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiSnackbar'
    });
    const theme = (0, $4nWZ9.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action, anchorOrigin: { vertical: vertical, horizontal: horizontal } = {
        vertical: 'bottom',
        horizontal: 'left'
    }, autoHideDuration: autoHideDuration = null, children: children, className: className, ClickAwayListenerProps: ClickAwayListenerProps, ContentProps: ContentProps, disableWindowBlurListener: disableWindowBlurListener = false, message: message, open: open, TransitionComponent: TransitionComponent = (0, $6CjWJ.default), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: { onEnter: onEnter, onExited: onExited } = {} } = props, TransitionProps = (0, $fAJB5.default)(props.TransitionProps, $64b2149fe034fa4e$var$_excluded), other = (0, $fAJB5.default)(props, $64b2149fe034fa4e$var$_excluded2);
    const ownerState = (0, $eJfrs.default)({}, props, {
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDuration
    });
    const classes = $64b2149fe034fa4e$var$useUtilityClasses(ownerState);
    const { getRootProps: getRootProps, onClickAway: onClickAway } = (0, $gxWvx.default)((0, $eJfrs.default)({}, ownerState));
    const [exited, setExited] = $8T3gX.useState(true);
    const rootProps = (0, $6zZUJ.default)({
        elementType: $64b2149fe034fa4e$var$SnackbarRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: other,
        ownerState: ownerState,
        additionalProps: {
            ref: ref
        },
        className: [
            classes.root,
            className
        ]
    });
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $eg2OC.ClickAwayListener), (0, $eJfrs.default)({
        onClickAway: onClickAway
    }, ClickAwayListenerProps, {
        children: /*#__PURE__*/ (0, $k4ank.jsx)($64b2149fe034fa4e$var$SnackbarRoot, (0, $eJfrs.default)({}, rootProps, {
            children: /*#__PURE__*/ (0, $k4ank.jsx)(TransitionComponent, (0, $eJfrs.default)({
                appear: true,
                in: open,
                timeout: transitionDuration,
                direction: vertical === 'top' ? 'down' : 'up',
                onEnter: handleEnter,
                onExited: handleExited
            }, TransitionProps, {
                children: children || /*#__PURE__*/ (0, $k4ank.jsx)((0, $kUjql.default), (0, $eJfrs.default)({
                    message: message,
                    action: action
                }, ContentProps))
            }))
        }))
    }));
});
$64b2149fe034fa4e$var$Snackbar.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */ action: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * The anchor of the `Snackbar`.
   * On smaller screens, the component grows to occupy all the available width,
   * the horizontal alignment is ignored.
   * @default { vertical: 'bottom', horizontal: 'left' }
   */ anchorOrigin: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'center',
            'left',
            'right'
        ]).isRequired,
        vertical: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'bottom',
            'top'
        ]).isRequired
    }),
    /**
   * The number of milliseconds to wait before automatically calling the
   * `onClose` function. `onClose` should then set the state of the `open`
   * prop to hide the Snackbar. This behavior is disabled by default with
   * the `null` value.
   * @default null
   */ autoHideDuration: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    /**
   * Replace the `SnackbarContent` component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Props applied to the `ClickAwayListener` element.
   */ ClickAwayListenerProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Props applied to the [`SnackbarContent`](/material-ui/api/snackbar-content/) element.
   */ ContentProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
   * @default false
   */ disableWindowBlurListener: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * When displaying multiple consecutive snackbars using a single parent-rendered
   * `<Snackbar/>`, add the `key` prop to ensure independent treatment of each message.
   * For instance, use `<Snackbar key={message} />`. Otherwise, messages might update
   * in place, and features like `autoHideDuration` could be affected.
   */ key: ()=>null,
    /**
   * The message to display.
   */ message: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * @ignore
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the component requests to be closed.
   * Typically `onClose` is used to set state in the parent component,
   * which is used to control the `Snackbar` `open` prop.
   * The `reason` parameter can optionally be used to control the response to `onClose`,
   * for example ignoring `clickaway`.
   *
   * @param {React.SyntheticEvent<any> | Event} event The event source of the callback.
   * @param {string} reason Can be: `"timeout"` (`autoHideDuration` expired), `"clickaway"`, or `"escapeKeyDown"`.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onMouseLeave: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The number of milliseconds to wait before dismissing after user interaction.
   * If `autoHideDuration` prop isn't specified, it does nothing.
   * If `autoHideDuration` prop is specified but `resumeHideDuration` isn't,
   * we default to `autoHideDuration / 2` ms.
   */ resumeHideDuration: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */ TransitionComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */ transitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number
        })
    ]),
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */ TransitionProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
};
var $64b2149fe034fa4e$export$2e2bcd8739ae039 = $64b2149fe034fa4e$var$Snackbar;

});
parcelRegister("gxWvx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0bd1cd3923983a7$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fPAwT = parcelRequire("fPAwT");
var $efgnF = parcelRequire("efgnF");

var $kV4HD = parcelRequire("kV4HD");
'use client';
/**
 * The basic building block for creating custom snackbar.
 *
 * Demos:
 *
 * - [Snackbar](https://mui.com/base-ui/react-snackbar/#hook)
 *
 * API:
 *
 * - [useSnackbar API](https://mui.com/base-ui/react-snackbar/hooks-api/#use-snackbar)
 */ function $c0bd1cd3923983a7$var$useSnackbar(parameters = {}) {
    const { autoHideDuration: autoHideDuration = null, disableWindowBlurListener: disableWindowBlurListener = false, onClose: onClose, open: open, resumeHideDuration: resumeHideDuration } = parameters;
    const timerAutoHide = (0, $efgnF.default)();
    $8T3gX.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) // IE11, Edge (prior to using Blink?) use 'Esc'
            {
                if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                onClose == null || onClose(nativeEvent, 'escapeKeyDown');
            }
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    const handleClose = (0, $fPAwT.default)((event, reason)=>{
        onClose == null || onClose(event, reason);
    });
    const setAutoHideTimer = (0, $fPAwT.default)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        timerAutoHide.start(autoHideDurationParam, ()=>{
            handleClose(null, 'timeout');
        });
    });
    $8T3gX.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return timerAutoHide.clear;
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer,
        timerAutoHide
    ]);
    const handleClickAway = (event)=>{
        onClose == null || onClose(event, 'clickaway');
    };
    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = timerAutoHide.clear;
    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $8T3gX.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const createHandleBlur = (otherHandlers)=>(event)=>{
            const onBlurCallback = otherHandlers.onBlur;
            onBlurCallback == null || onBlurCallback(event);
            handleResume();
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            const onFocusCallback = otherHandlers.onFocus;
            onFocusCallback == null || onFocusCallback(event);
            handlePause();
        };
    const createMouseEnter = (otherHandlers)=>(event)=>{
            const onMouseEnterCallback = otherHandlers.onMouseEnter;
            onMouseEnterCallback == null || onMouseEnterCallback(event);
            handlePause();
        };
    const createMouseLeave = (otherHandlers)=>(event)=>{
            const onMouseLeaveCallback = otherHandlers.onMouseLeave;
            onMouseLeaveCallback == null || onMouseLeaveCallback(event);
            handleResume();
        };
    $8T3gX.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener('focus', handleResume);
            window.addEventListener('blur', handlePause);
            return ()=>{
                window.removeEventListener('focus', handleResume);
                window.removeEventListener('blur', handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        open,
        handleResume,
        handlePause
    ]);
    const getRootProps = (externalProps = {})=>{
        const externalEventHandlers = (0, $eJfrs.default)({}, (0, $kV4HD.default)(parameters), (0, $kV4HD.default)(externalProps));
        return (0, $eJfrs.default)({
            // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            // See https://github.com/mui/material-ui/issues/29080
            role: 'presentation'
        }, externalProps, externalEventHandlers, {
            onBlur: createHandleBlur(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onMouseEnter: createMouseEnter(externalEventHandlers),
            onMouseLeave: createMouseLeave(externalEventHandlers)
        });
    };
    return {
        getRootProps: getRootProps,
        onClickAway: handleClickAway
    };
}
var $c0bd1cd3923983a7$export$2e2bcd8739ae039 = $c0bd1cd3923983a7$var$useSnackbar;

});

parcelRegister("eg2OC", function(module, exports) {

$parcel$export(module.exports, "ClickAwayListener", () => $a614be64e7434566$export$58385c17fee43f89);

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $evygD = parcelRequire("evygD");
var $bNVvr = parcelRequire("bNVvr");
var $iYkpH = parcelRequire("iYkpH");
var $fPAwT = parcelRequire("fPAwT");
var $ktSDD = parcelRequire("ktSDD");

var $jphfx = parcelRequire("jphfx");

var $k4ank = parcelRequire("k4ank");
'use client';
function $a614be64e7434566$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $a614be64e7434566$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/material-ui/react-click-away-listener/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/material-ui/api/click-away-listener/)
 */ function $a614be64e7434566$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = 'onClick', onClickAway: onClickAway, touchEvent: touchEvent = 'onTouchEnd' } = props;
    const movedRef = $8T3gX.useRef(false);
    const nodeRef = $8T3gX.useRef(null);
    const activatedRef = $8T3gX.useRef(false);
    const syntheticEventRef = $8T3gX.useRef(false);
    $8T3gX.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $ktSDD.default)((0, $jphfx.default)(children), nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $fPAwT.default)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $iYkpH.default)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || 'clientX' in event && $a614be64e7434566$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $8T3gX.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $a614be64e7434566$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $iYkpH.default)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $8T3gX.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $a614be64e7434566$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $iYkpH.default)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsx)($8T3gX.Fragment, {
        children: /*#__PURE__*/ $8T3gX.cloneElement(children, childrenProps)
    });
}
$a614be64e7434566$export$58385c17fee43f89.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The wrapped element.
   */ children: (0, $evygD.default).isRequired,
    /**
   * If `true`, the React tree is ignored and only the DOM tree is considered.
   * This prop changes how portaled elements are handled.
   * @default false
   */ disableReactTree: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   * @default 'onClick'
   */ mouseEvent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'onClick',
        'onMouseDown',
        'onMouseUp',
        'onPointerDown',
        'onPointerUp',
        false
    ]),
    /**
   * Callback fired when a "click away" event is detected.
   */ onClickAway: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired,
    /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   * @default 'onTouchEnd'
   */ touchEvent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'onTouchEnd',
        'onTouchStart',
        false
    ])
};
// eslint-disable-next-line
$a614be64e7434566$export$58385c17fee43f89["propTypes"] = (0, $bNVvr.default)($a614be64e7434566$export$58385c17fee43f89.propTypes);

});

parcelRegister("kUjql", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3881ac749ba7fe7$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $aBrLz = parcelRequire("aBrLz");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $4reBM = parcelRequire("4reBM");

var $bnqoT = parcelRequire("bnqoT");

var $k4ank = parcelRequire("k4ank");
'use client';
const $f3881ac749ba7fe7$var$_excluded = [
    "action",
    "className",
    "message",
    "role"
];
const $f3881ac749ba7fe7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        action: [
            'action'
        ],
        message: [
            'message'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $bnqoT.getSnackbarContentUtilityClass), classes);
};
const $f3881ac749ba7fe7$var$SnackbarContentRoot = (0, $anJSP.default)((0, $4reBM.default), {
    name: 'MuiSnackbarContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const emphasis = theme.palette.mode === 'light' ? 0.8 : 0.98;
    const backgroundColor = (0, $aBrLz.emphasize)(theme.palette.background.default, emphasis);
    return (0, $eJfrs.default)({}, theme.typography.body2, {
        color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText(backgroundColor),
        backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : backgroundColor,
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        flexGrow: 1,
        [theme.breakpoints.up('sm')]: {
            flexGrow: 'initial',
            minWidth: 288
        }
    });
});
const $f3881ac749ba7fe7$var$SnackbarContentMessage = (0, $anJSP.default)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0'
});
const $f3881ac749ba7fe7$var$SnackbarContentAction = (0, $anJSP.default)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: 16,
    marginRight: -8
});
const $f3881ac749ba7fe7$var$SnackbarContent = /*#__PURE__*/ $8T3gX.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiSnackbarContent'
    });
    const { action: action, className: className, message: message, role: role = 'alert' } = props, other = (0, $fAJB5.default)(props, $f3881ac749ba7fe7$var$_excluded);
    const ownerState = props;
    const classes = $f3881ac749ba7fe7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsxs)($f3881ac749ba7fe7$var$SnackbarContentRoot, (0, $eJfrs.default)({
        role: role,
        square: true,
        elevation: 6,
        className: (0, $iVyaN.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)($f3881ac749ba7fe7$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $k4ank.jsx)($f3881ac749ba7fe7$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    }));
});
$f3881ac749ba7fe7$var$SnackbarContent.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */ action: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The message to display.
   */ message: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */ role: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $f3881ac749ba7fe7$export$2e2bcd8739ae039 = $f3881ac749ba7fe7$var$SnackbarContent;

});
parcelRegister("bnqoT", function(module, exports) {

$parcel$export(module.exports, "getSnackbarContentUtilityClass", () => $8486524d8621b85e$export$def81488db1a3216);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $8486524d8621b85e$export$def81488db1a3216(slot) {
    return (0, $kfTYv.default)('MuiSnackbarContent', slot);
}
const $8486524d8621b85e$var$snackbarContentClasses = (0, $jh2Zm.default)('MuiSnackbarContent', [
    'root',
    'message',
    'action'
]);
var $8486524d8621b85e$export$2e2bcd8739ae039 = $8486524d8621b85e$var$snackbarContentClasses;

});


parcelRegister("hTdcM", function(module, exports) {

$parcel$export(module.exports, "getSnackbarUtilityClass", () => $d061d0f8025c6e42$export$6cb096457f5926f4);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $d061d0f8025c6e42$export$6cb096457f5926f4(slot) {
    return (0, $kfTYv.default)('MuiSnackbar', slot);
}
const $d061d0f8025c6e42$var$snackbarClasses = (0, $jh2Zm.default)('MuiSnackbar', [
    'root',
    'anchorOriginTopCenter',
    'anchorOriginBottomCenter',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft'
]);
var $d061d0f8025c6e42$export$2e2bcd8739ae039 = $d061d0f8025c6e42$var$snackbarClasses;

});


parcelRegister("dHtmK", function(module, exports) {

$parcel$export(module.exports, "default", () => $07ab797c72396bbf$export$2e2bcd8739ae039);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $djxj8 = parcelRequire("djxj8");

var $60vL1 = parcelRequire("60vL1");

var $2CHqP = parcelRequire("2CHqP");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");
const $07ab797c72396bbf$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
function $07ab797c72396bbf$export$2e2bcd8739ae039({ openState: openState, message: message, progressPercent: progressPercent, stackAboveModal: /** When true, stacks above MUI Modal/Dialog (default Backdrop sits below them). */ stackAboveModal = false }) {
    const clampedProgress = typeof progressPercent === "number" ? Math.max(0, Math.min(100, progressPercent)) : undefined;
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
        theme: $07ab797c72396bbf$var$theme,
        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $djxj8.default), {
                sx: {
                    color: "#fff",
                    zIndex: (t)=>stackAboveModal ? t.zIndex.modal + 1 : t.zIndex.drawer + 1
                },
                open: openState,
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 16
                    },
                    children: [
                        clampedProgress === undefined ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                            color: "primary"
                        }) : /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            style: {
                                width: 280
                            },
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $2CHqP.default), {
                                    color: "primary",
                                    variant: "determinate",
                                    value: clampedProgress
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                                    style: {
                                        fontFamily: "Mulish, sans-serif",
                                        fontSize: 12,
                                        display: "block",
                                        marginTop: 6,
                                        textAlign: "center"
                                    },
                                    children: [
                                        Math.round(clampedProgress),
                                        "%"
                                    ]
                                })
                            ]
                        }),
                        message && /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                            style: {
                                fontFamily: "Mulish, sans-serif"
                            },
                            children: message
                        })
                    ]
                })
            })
        })
    });
}

});

parcelRegister("kKBBF", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_BULK_ROWS", () => $9ee6c27488925341$export$b3d40aa4cf482df9);
$parcel$export(module.exports, "AUTOPATROL_UNAVAILABLE_BULK_PRODUCT_LABELS", () => $9ee6c27488925341$export$aad167932fe68857);
$parcel$export(module.exports, "AUTOPATROL_PRODUCT_BULK_ROWS", () => $9ee6c27488925341$export$78d8bebe70a39860);
$parcel$export(module.exports, "createInitialProductBulkFormState", () => $9ee6c27488925341$export$869309d5872b025);
$parcel$export(module.exports, "validateLoiteringSeconds", () => $9ee6c27488925341$export$c72ef414cbe4bcf3);
$parcel$export(module.exports, "buildBulkProductChangePayload", () => $9ee6c27488925341$export$1c203796a1e8bf66);
$parcel$export(module.exports, "getMutuallyExclusiveBulkGroupForKey", () => $9ee6c27488925341$export$2223741fc755b24a);
$parcel$export(module.exports, "isBulkRowRestrictedByPeerEnableSelection", () => $9ee6c27488925341$export$65a71a1f03581410);
$parcel$export(module.exports, "getBulkPeerEnableBlockedExplanation", () => $9ee6c27488925341$export$a841efadcefac529);
$parcel$export(module.exports, "validateMutuallyExclusiveProductGroupsForCameras", () => $9ee6c27488925341$export$dc4cdc89b7a934ef);
$parcel$export(module.exports, "findMissingSensitivityIds", () => $9ee6c27488925341$export$3d441e26fca64e92);
$parcel$export(module.exports, "buildMetricBulkUpdateApiPayload", () => $9ee6c27488925341$export$eb30b16ca8600c68);
$parcel$export(module.exports, "mergeImplicitExclusiveGroupDisablesIntoBulkPayload", () => $9ee6c27488925341$export$414e3c1c3c1b3a71);
$parcel$export(module.exports, "simplifiedMetricRowsMatchBulkFormExpectations", () => $9ee6c27488925341$export$d41011971ae8f6f3);

var $innfN = parcelRequire("innfN");
const $9ee6c27488925341$export$b3d40aa4cf482df9 = [
    {
        key: "intruder",
        label: "Intruder",
        supportsSensitivity: true
    },
    {
        key: "bike",
        label: "Bike",
        supportsSensitivity: true
    },
    {
        key: "vehicle",
        label: "Vehicle",
        supportsSensitivity: true
    },
    {
        key: "intruder_motion",
        label: "Intruder Motion",
        supportsSensitivity: true
    },
    {
        key: "vehicle_motion",
        label: "Vehicle Motion",
        supportsSensitivity: true
    },
    {
        key: "bike_motion",
        label: "Bike Motion",
        supportsSensitivity: true
    },
    {
        key: "gun",
        label: "Gun",
        supportsSensitivity: true
    },
    {
        key: "pistol",
        label: "Pistol",
        supportsSensitivity: true
    },
    {
        key: "crowd",
        label: "Crowd",
        supportsSensitivity: true
    },
    {
        key: "loiterer",
        label: "Loiterer",
        supportsSensitivity: true,
        supportsLoiteringSeconds: true
    },
    {
        key: "vehicle_loiterer",
        label: "Vehicle Loiterer",
        supportsSensitivity: true,
        supportsLoiteringSeconds: true
    },
    {
        key: "no_hard_hat",
        label: "No Hard Hat",
        supportsSensitivity: true
    },
    {
        key: "fire",
        label: "Fire",
        supportsSensitivity: true
    },
    {
        key: "smoke",
        label: "Smoke",
        supportsSensitivity: true
    },
    {
        key: "intruder_line_crossing",
        label: "Intruder Line Crossing",
        supportsSensitivity: true
    },
    {
        key: "vehicle_line_crossing",
        label: "Vehicle Line Crossing",
        supportsSensitivity: true
    },
    {
        key: "amazon",
        label: "Amazon",
        supportsSensitivity: true
    },
    {
        key: "dhl",
        label: "DHL",
        supportsSensitivity: true
    },
    {
        key: "fedex",
        label: "Fedex",
        supportsSensitivity: true
    },
    {
        key: "school_bus",
        label: "School Bus",
        supportsSensitivity: true
    },
    {
        key: "ups",
        label: "UPS",
        supportsSensitivity: true
    },
    {
        key: "usps",
        label: "USPS",
        supportsSensitivity: true
    },
    {
        key: "envera",
        label: "Envera",
        supportsSensitivity: true
    },
    {
        key: "fire_truck",
        label: "Fire Truck",
        supportsSensitivity: true
    },
    {
        key: "non_ups",
        label: "Non-UPS",
        supportsSensitivity: true
    }
];
const $9ee6c27488925341$export$a195fd67759d0823 = [
    "intruder_motion",
    "vehicle_motion",
    "bike_motion",
    "gun",
    "pistol",
    "loiterer",
    "vehicle_loiterer",
    "no_hard_hat",
    "intruder_line_crossing",
    "vehicle_line_crossing"
];
const $9ee6c27488925341$var$AUTOPATROL_UNAVAILABLE_BULK_PRODUCT_KEY_SET = new Set($9ee6c27488925341$export$a195fd67759d0823);
const $9ee6c27488925341$export$aad167932fe68857 = $9ee6c27488925341$export$b3d40aa4cf482df9.filter((row)=>$9ee6c27488925341$var$AUTOPATROL_UNAVAILABLE_BULK_PRODUCT_KEY_SET.has(row.key)).map((row)=>row.label);
const $9ee6c27488925341$export$78d8bebe70a39860 = $9ee6c27488925341$export$b3d40aa4cf482df9.filter((row)=>!$9ee6c27488925341$var$AUTOPATROL_UNAVAILABLE_BULK_PRODUCT_KEY_SET.has(row.key));
const $9ee6c27488925341$export$869309d5872b025 = (rows = $9ee6c27488925341$export$b3d40aa4cf482df9)=>rows.reduce((accumulator, row)=>{
        accumulator[row.key] = {
            enable: "no_change",
            sensitivity: "no_change",
            loiteringSeconds: ""
        };
        return accumulator;
    }, {});
const $9ee6c27488925341$var$POSITIVE_INTEGER_PATTERN = /^[1-9]\d*$/;
const $9ee6c27488925341$export$c72ef414cbe4bcf3 = (rows, state)=>{
    const errors = {};
    rows.forEach((row)=>{
        if (!row.supportsLoiteringSeconds) return;
        const value = state[row.key]?.loiteringSeconds?.trim() ?? "";
        if (!value) return;
        if (!$9ee6c27488925341$var$POSITIVE_INTEGER_PATTERN.test(value)) errors[row.key] = "Enter a positive whole number";
    });
    return errors;
};
const $9ee6c27488925341$export$1c203796a1e8bf66 = (rows, state)=>{
    const payload = [];
    rows.forEach((row)=>{
        const rowState = state[row.key];
        if (!rowState) return;
        const entry = {
            product: row.key
        };
        if (rowState.enable !== "no_change") entry.enable = rowState.enable;
        if (row.supportsSensitivity && rowState.sensitivity !== "no_change") entry.sensitivity = rowState.sensitivity;
        if (row.supportsLoiteringSeconds) {
            const value = rowState.loiteringSeconds.trim();
            if (value && $9ee6c27488925341$var$POSITIVE_INTEGER_PATTERN.test(value)) entry.loitering_seconds = Number(value);
        }
        if (entry.enable !== undefined || entry.sensitivity !== undefined || entry.loitering_seconds !== undefined) payload.push(entry);
    });
    return payload;
};
const $9ee6c27488925341$export$5f14091380a4739 = [
    "intruder",
    "bike",
    "vehicle"
];
const $9ee6c27488925341$export$750faa5cbccba68f = [
    "intruder_motion",
    "vehicle_motion",
    "bike_motion"
];
const $9ee6c27488925341$export$80507fdce67c8ae3 = [
    "intruder_line_crossing",
    "vehicle_line_crossing"
];
const $9ee6c27488925341$var$KEY_TO_EXCLUSIVE_GROUP = Object.fromEntries([
    ...$9ee6c27488925341$export$5f14091380a4739.map((k)=>[
            k,
            "intruder"
        ]),
    ...$9ee6c27488925341$export$750faa5cbccba68f.map((k)=>[
            k,
            "motionPlus"
        ]),
    ...$9ee6c27488925341$export$80507fdce67c8ae3.map((k)=>[
            k,
            "lineCrossing"
        ])
]);
const $9ee6c27488925341$export$2223741fc755b24a = (labelKey)=>$9ee6c27488925341$var$KEY_TO_EXCLUSIVE_GROUP[labelKey] ?? null;
const $9ee6c27488925341$var$rowByKey = new Map($9ee6c27488925341$export$b3d40aa4cf482df9.map((row)=>[
        row.key,
        row
    ]));
const $9ee6c27488925341$export$6e311ba0257bfab4 = (labelKey, cameraId, state, activeCameraProducts)=>{
    const row = $9ee6c27488925341$var$rowByKey.get(labelKey);
    if (!row) return false;
    const rowState = state[labelKey];
    if (!rowState) return false;
    if (rowState.enable === "enable") return true;
    if (rowState.enable === "disable") return false;
    return activeCameraProducts[cameraId]?.[row.label] === true;
};
const $9ee6c27488925341$export$4be76285f7f20084 = (cameraId, state, activeCameraProducts)=>({
        intruderGroup: $9ee6c27488925341$export$5f14091380a4739.some((key)=>$9ee6c27488925341$export$6e311ba0257bfab4(key, cameraId, state, activeCameraProducts)),
        motionPlus: $9ee6c27488925341$export$750faa5cbccba68f.some((key)=>$9ee6c27488925341$export$6e311ba0257bfab4(key, cameraId, state, activeCameraProducts)),
        lineCrossing: $9ee6c27488925341$export$80507fdce67c8ae3.some((key)=>$9ee6c27488925341$export$6e311ba0257bfab4(key, cameraId, state, activeCameraProducts))
    });
const $9ee6c27488925341$export$e7b51690f8749c1a = (state)=>$9ee6c27488925341$export$5f14091380a4739.some((key)=>state[key]?.enable === "enable");
const $9ee6c27488925341$export$9ff92ce4e6518f59 = (state)=>$9ee6c27488925341$export$750faa5cbccba68f.some((key)=>state[key]?.enable === "enable");
const $9ee6c27488925341$export$5b61c82f3c301840 = (state)=>$9ee6c27488925341$export$80507fdce67c8ae3.some((key)=>state[key]?.enable === "enable");
const $9ee6c27488925341$export$65a71a1f03581410 = (labelKey, state)=>{
    const group = $9ee6c27488925341$export$2223741fc755b24a(labelKey);
    if (!group) return false;
    const ui = $9ee6c27488925341$export$e7b51690f8749c1a(state);
    const um = $9ee6c27488925341$export$9ff92ce4e6518f59(state);
    const ul = $9ee6c27488925341$export$5b61c82f3c301840(state);
    if (group === "intruder") {
        if (ui) return false;
        return um || ul;
    }
    if (group === "motionPlus") {
        if (um) return false;
        return ui || ul;
    }
    if (ul) return false;
    return ui || um;
};
const $9ee6c27488925341$export$a841efadcefac529 = (labelKey, state)=>{
    if (!$9ee6c27488925341$export$65a71a1f03581410(labelKey, state)) return null;
    const group = $9ee6c27488925341$export$2223741fc755b24a(labelKey);
    if (!group) return null;
    const ui = $9ee6c27488925341$export$e7b51690f8749c1a(state);
    const um = $9ee6c27488925341$export$9ff92ce4e6518f59(state);
    const ul = $9ee6c27488925341$export$5b61c82f3c301840(state);
    if (group === "motionPlus") {
        if (ui && ul) return "You selected Enable for Intruder (Intruder, Bike, or Vehicle) and for Line Crossing in this bulk update. Motion Plus cannot run with either. Set those rows to No Change or Disable to configure Motion Plus here.";
        if (ui) return "You selected Enable for Intruder (Intruder, Bike, or Vehicle) in this bulk update. Intruder and Motion Plus cannot run together. Set Intruder group rows to No Change or Disable to configure Motion Plus here.";
        return "You selected Enable for Line Crossing in this bulk update. Line Crossing and Motion Plus cannot run together. Set Line Crossing rows to No Change or Disable to configure Motion Plus here.";
    }
    if (group === "lineCrossing") {
        if (ui && um) return "You selected Enable for Intruder and for Motion Plus in this bulk update. Line Crossing cannot run with either. Set those rows to No Change or Disable to configure Line Crossing here.";
        if (ui) return "You selected Enable for Intruder (Intruder, Bike, or Vehicle) in this bulk update. Intruder and Line Crossing cannot run together. Set Intruder group rows to No Change or Disable to configure Line Crossing here.";
        return "You selected Enable for Motion Plus in this bulk update. Motion Plus and Line Crossing cannot run together. Set Motion Plus rows to No Change or Disable to configure Line Crossing here.";
    }
    if (um && ul) return "You selected Enable for Motion Plus and for Line Crossing in this bulk update. Intruder (person / vehicle / bike detection) cannot run with either. Set those rows to No Change or Disable to configure Intruder, Bike, or Vehicle here.";
    if (um) return "You selected Enable for Motion Plus in this bulk update. Motion Plus and Intruder cannot run together. Set Motion Plus rows to No Change or Disable to configure Intruder, Bike, or Vehicle here.";
    return "You selected Enable for Line Crossing in this bulk update. Line Crossing and Intruder cannot run together. Set Line Crossing rows to No Change or Disable to configure Intruder, Bike, or Vehicle here.";
};
const $9ee6c27488925341$export$dc4cdc89b7a934ef = (selectedCameraIds, state, activeCameraProducts)=>{
    const uiSel = $9ee6c27488925341$export$e7b51690f8749c1a(state);
    const umSel = $9ee6c27488925341$export$9ff92ce4e6518f59(state);
    const ulSel = $9ee6c27488925341$export$5b61c82f3c301840(state);
    const exclusiveConflictMessage = "Intruder (Intruder, Bike, Vehicle), Motion Plus (Intruder Motion, Vehicle Motion, Bike Motion), and Line Crossing (Intruder Line Crossing, Vehicle Line Crossing) cannot be enabled at the same time on a camera. Adjust enable settings or disable one group first (same rules as the Edit Camera products tab).";
    if ([
        uiSel,
        umSel,
        ulSel
    ].filter(Boolean).length > 1) return exclusiveConflictMessage;
    for (const cameraId of selectedCameraIds){
        let intruderGroupActive = $9ee6c27488925341$export$5f14091380a4739.some((key)=>$9ee6c27488925341$export$6e311ba0257bfab4(key, cameraId, state, activeCameraProducts));
        let motionPlusActive = $9ee6c27488925341$export$750faa5cbccba68f.some((key)=>$9ee6c27488925341$export$6e311ba0257bfab4(key, cameraId, state, activeCameraProducts));
        let lineCrossingActive = $9ee6c27488925341$export$80507fdce67c8ae3.some((key)=>$9ee6c27488925341$export$6e311ba0257bfab4(key, cameraId, state, activeCameraProducts));
        /** Match `mergeImplicitExclusiveGroupDisablesIntoBulkPayload`: chosen Enable group turns conflicting groups off in the API. */ if (uiSel) {
            motionPlusActive = false;
            lineCrossingActive = false;
        } else if (umSel) {
            intruderGroupActive = false;
            lineCrossingActive = false;
        } else if (ulSel) {
            intruderGroupActive = false;
            motionPlusActive = false;
        }
        const activeCount = [
            intruderGroupActive,
            motionPlusActive,
            lineCrossingActive
        ].filter(Boolean).length;
        if (activeCount > 1) return exclusiveConflictMessage;
    }
    return null;
};
const $9ee6c27488925341$export$3d441e26fca64e92 = (rows, state, sensitivityMap)=>{
    const missing = [];
    rows.forEach((row)=>{
        const rowState = state[row.key];
        if (!row.supportsSensitivity || !rowState || rowState.sensitivity === "no_change") return;
        const levels = sensitivityMap.get(row.key);
        const id = levels?.[rowState.sensitivity];
        if (id === undefined || id === null) missing.push(row.label);
    });
    return missing;
};
const $9ee6c27488925341$export$eb30b16ca8600c68 = (rows, state, sensitivityMap)=>{
    const items = [];
    rows.forEach((row)=>{
        const rowState = state[row.key];
        if (!rowState) return;
        let active = null;
        if (rowState.enable === "enable") active = true;
        else if (rowState.enable === "disable") active = false;
        let sensitivity_id = null;
        if (row.supportsSensitivity && rowState.sensitivity !== "no_change") {
            const levels = sensitivityMap.get(row.key);
            const resolved = levels?.[rowState.sensitivity];
            if (resolved !== undefined && resolved !== null) sensitivity_id = resolved;
        }
        let frame_thresh = null;
        const min_crowd_size = null;
        if (row.supportsLoiteringSeconds) {
            const value = rowState.loiteringSeconds.trim();
            if (value && $9ee6c27488925341$var$POSITIVE_INTEGER_PATTERN.test(value)) frame_thresh = Number(value);
        }
        const hasChange = active !== null || sensitivity_id !== null || frame_thresh !== null || min_crowd_size !== null;
        if (!hasChange) return;
        items.push({
            label_name: row.key,
            active: active,
            sensitivity_id: sensitivity_id,
            frame_thresh: frame_thresh,
            min_crowd_size: min_crowd_size
        });
    });
    return items;
};
const $9ee6c27488925341$var$IMPLICIT_DISABLE_ITEM = (labelKey)=>({
        label_name: labelKey,
        active: false,
        sensitivity_id: null,
        frame_thresh: null,
        min_crowd_size: null
    });
const $9ee6c27488925341$export$414e3c1c3c1b3a71 = (state, items)=>{
    const byLabel = new Map();
    items.forEach((item)=>{
        byLabel.set(item.label_name, {
            ...item
        });
    });
    const forceDisableKeys = (keys)=>{
        keys.forEach((key)=>{
            byLabel.set(key, $9ee6c27488925341$var$IMPLICIT_DISABLE_ITEM(key));
        });
    };
    if ($9ee6c27488925341$export$e7b51690f8749c1a(state)) forceDisableKeys([
        ...$9ee6c27488925341$export$750faa5cbccba68f,
        ...$9ee6c27488925341$export$80507fdce67c8ae3
    ]);
    if ($9ee6c27488925341$export$9ff92ce4e6518f59(state)) forceDisableKeys([
        ...$9ee6c27488925341$export$5f14091380a4739,
        ...$9ee6c27488925341$export$80507fdce67c8ae3
    ]);
    if ($9ee6c27488925341$export$5b61c82f3c301840(state)) forceDisableKeys([
        ...$9ee6c27488925341$export$5f14091380a4739,
        ...$9ee6c27488925341$export$750faa5cbccba68f
    ]);
    const ordered = [];
    const seen = new Set();
    $9ee6c27488925341$export$b3d40aa4cf482df9.forEach((row)=>{
        const item = byLabel.get(row.key);
        if (item) {
            ordered.push(item);
            seen.add(row.key);
        }
    });
    byLabel.forEach((item, key)=>{
        if (!seen.has(key)) ordered.push(item);
    });
    return ordered;
};
const $9ee6c27488925341$export$e4cf02a9e9aeef50 = (labelKey, cameraId, state, mergeSnapshot)=>{
    const ui = $9ee6c27488925341$export$e7b51690f8749c1a(state);
    const um = $9ee6c27488925341$export$9ff92ce4e6518f59(state);
    const ul = $9ee6c27488925341$export$5b61c82f3c301840(state);
    if (ui) {
        if ($9ee6c27488925341$export$750faa5cbccba68f.includes(labelKey) || $9ee6c27488925341$export$80507fdce67c8ae3.includes(labelKey)) return false;
    }
    if (um) {
        if ($9ee6c27488925341$export$5f14091380a4739.includes(labelKey) || $9ee6c27488925341$export$80507fdce67c8ae3.includes(labelKey)) return false;
    }
    if (ul) {
        if ($9ee6c27488925341$export$5f14091380a4739.includes(labelKey) || $9ee6c27488925341$export$750faa5cbccba68f.includes(labelKey)) return false;
    }
    return $9ee6c27488925341$export$6e311ba0257bfab4(labelKey, cameraId, state, mergeSnapshot);
};
const $9ee6c27488925341$export$d41011971ae8f6f3 = (rows, selectedCameraIds, state, mergeSnapshot, productRows = $9ee6c27488925341$export$b3d40aa4cf482df9)=>{
    for (const cameraId of selectedCameraIds){
        const labelMap = (0, $innfN.getLabelNameActiveMapForCameraFromSimplifiedRows)(rows, cameraId);
        for (const row of productRows){
            const expected = $9ee6c27488925341$export$e4cf02a9e9aeef50(row.key, cameraId, state, mergeSnapshot);
            const actual = labelMap.get(row.key) === true;
            if (expected !== actual) return false;
        }
    }
    return true;
};

});
parcelRegister("innfN", function(module, exports) {

$parcel$export(module.exports, "getLabelNameActiveMapForCameraFromSimplifiedRows", () => $d8bc22491d10d67f$export$a02198982edc8ef7);
$parcel$export(module.exports, "activeProductsDisplayRecordFromSimplifiedRows", () => $d8bc22491d10d67f$export$4e2f31bf40e06f86);

var $jUxHc = parcelRequire("jUxHc");
const $d8bc22491d10d67f$export$a02198982edc8ef7 = (rows, cameraId)=>{
    const map = new Map();
    rows.forEach((r)=>{
        if (Number(r.camera?.id) !== cameraId) return;
        const prev = map.get(r.label_name);
        if (prev === undefined || r.active) map.set(r.label_name, r.active);
    });
    return map;
};
const $d8bc22491d10d67f$export$4e2f31bf40e06f86 = (rows, cameraId)=>{
    const labelMap = $d8bc22491d10d67f$export$a02198982edc8ef7(rows, cameraId);
    const result = {};
    (0, $jUxHc.ACTIVE_PRODUCTS_DISPLAY_NAMES).forEach((displayName)=>{
        const candidates = (0, $jUxHc.DISPLAY_NAME_TO_LABEL_NAMES)[displayName] || [];
        result[displayName] = candidates.some((ln)=>labelMap.get(ln) === true);
    });
    return result;
};

});
parcelRegister("jUxHc", function(module, exports) {

$parcel$export(module.exports, "DISPLAY_NAME_TO_LABEL_NAMES", () => $2ae5d0d7b5a95900$export$946017214e5349e1);
$parcel$export(module.exports, "ACTIVE_PRODUCTS_DISPLAY_NAMES", () => $2ae5d0d7b5a95900$export$5a3713edda633318);
$parcel$export(module.exports, "deriveActiveProductsFromGeneralInfo", () => $2ae5d0d7b5a95900$export$62ad6eb3a045ee);
/**
 * Derives active product booleans from general_info streams (same logic as EditCamera generateActiveProducts).
 * Used for autopatrol Site About camera rows only.
 */ /** Maps bulk / UI display names to API `label_name` keys (shared with metric simplified). */ const $2ae5d0d7b5a95900$export$946017214e5349e1 = {
    Intruder: [
        "intruder"
    ],
    Vehicle: [
        "vehicle"
    ],
    Bike: [
        "bike"
    ],
    "Intruder Motion": [
        "intruder_motion"
    ],
    "Vehicle Motion": [
        "vehicle_motion"
    ],
    "Bike Motion": [
        "bike_motion"
    ],
    Crowd: [
        "crowd"
    ],
    Fire: [
        "fire"
    ],
    Smoke: [
        "smoke"
    ],
    Amazon: [
        "amazon"
    ],
    DHL: [
        "dhl"
    ],
    Fedex: [
        "fedex"
    ],
    "School Bus": [
        "school_bus"
    ],
    UPS: [
        "ups"
    ],
    USPS: [
        "usps"
    ],
    "Fire Truck": [
        "fire_truck"
    ],
    "Non-UPS": [
        "non_ups"
    ],
    Envera: [
        "envera"
    ],
    Gun: [
        "gun"
    ],
    Pistol: [
        "pistol"
    ],
    Loiterer: [
        "loiterer"
    ],
    "Vehicle Loiterer": [
        "vehicle_loiterer"
    ],
    "No Hard Hat": [
        "no_hard_hat"
    ],
    "Intruder Line Crossing": [
        "intruder_line_crossing"
    ],
    "Vehicle Line Crossing": [
        "vehicle_line_crossing"
    ]
};
const $2ae5d0d7b5a95900$export$5a3713edda633318 = [
    "Intruder",
    "Vehicle",
    "Bike",
    "Intruder Motion",
    "Vehicle Motion",
    "Bike Motion",
    "Crowd",
    "Gun",
    "Pistol",
    "Loiterer",
    "Vehicle Loiterer",
    "No Hard Hat",
    "Fire",
    "Smoke",
    "Intruder Line Crossing",
    "Vehicle Line Crossing",
    "Amazon",
    "DHL",
    "Fedex",
    "School Bus",
    "UPS",
    "USPS",
    "Envera",
    "Fire Truck",
    "Non-UPS"
];
function $2ae5d0d7b5a95900$export$62ad6eb3a045ee(streams) {
    const productsMap = new Map();
    if (streams && Array.isArray(streams)) streams.forEach((stream)=>{
        (stream.stream_metrics || []).forEach((metric)=>{
            if (!productsMap.has(metric.label_name) || metric.active) productsMap.set(metric.label_name, metric.active);
        });
    });
    const result = {};
    $2ae5d0d7b5a95900$export$5a3713edda633318.forEach((displayName)=>{
        const candidateLabelNames = $2ae5d0d7b5a95900$export$946017214e5349e1[displayName] || [];
        result[displayName] = candidateLabelNames.some((labelName)=>productsMap.get(labelName) === true);
    });
    return result;
}

});



parcelRegister("jK0A2", function(module, exports) {

$parcel$export(module.exports, "fetchMetricSensitivityMap", () => $7e8b0ec530658322$export$39c217022562a6e2);
$parcel$export(module.exports, "fetchGeneralInfoSensitivityMap", () => $7e8b0ec530658322$export$e36288b7b1aa3c47);
$parcel$export(module.exports, "mergeSensitivityMaps", () => $7e8b0ec530658322$export$9876cc5a81a2928d);
$parcel$export(module.exports, "postMetricBulkUpdate", () => $7e8b0ec530658322$export$c03abb0c4fb5a3b9);
$parcel$export(module.exports, "fetchStreamProductsForCamera", () => $7e8b0ec530658322$export$6fbdfc1543f995);
$parcel$export(module.exports, "fetchStreamsSimple", () => $7e8b0ec530658322$export$7b8f851e587fefee);
$parcel$export(module.exports, "postStreamBulkUpdate", () => $7e8b0ec530658322$export$7f8160f035af5fbd);
$parcel$export(module.exports, "fetchMetricSimplified", () => $7e8b0ec530658322$export$c20ee8582bfa83a6);

var $195EM = parcelRequire("195EM");
const $7e8b0ec530658322$export$4f8b703a3d2b9156 = (rawName)=>{
    const name = rawName.toLowerCase();
    if (name.includes("medium-high") || name.includes("medium high")) return "medium_high";
    // Strip parenthetical qualifiers: "High (more sensitive)" → "high".
    const base = name.replace(/\(.*?\)/g, "").trim();
    if (base === "low") return "low";
    if (base === "medium") return "medium";
    if (base === "high") return "high";
    return null;
};
const $7e8b0ec530658322$export$cd9cfc08c3097c9a = (results)=>{
    const map = new Map();
    for (const raw of results){
        const metric = raw;
        const label = metric.label_name;
        if (!label || !Array.isArray(metric.options)) continue;
        const entry = {};
        for (const opt of metric.options){
            if (!Array.isArray(opt) || opt.length < 2) continue;
            const level = $7e8b0ec530658322$export$4f8b703a3d2b9156(String(opt[0]));
            if (level !== null) entry[level] = opt[1];
        }
        if (Object.keys(entry).length > 0) map.set(label, entry);
    }
    return map;
};
const $7e8b0ec530658322$export$39c217022562a6e2 = async (navigate, cameraId)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const response = await AxiosUI.get(`/metric/?camera_id=${cameraId}`);
    return $7e8b0ec530658322$export$cd9cfc08c3097c9a(response.data?.results || []);
};
const $7e8b0ec530658322$export$927be50d4925e65 = (generalInfo)=>{
    const streams = generalInfo?.streams;
    if (!Array.isArray(streams)) return new Map();
    const metrics = streams.flatMap((stream)=>{
        const streamMetrics = stream?.stream_metrics;
        return Array.isArray(streamMetrics) ? streamMetrics : [];
    });
    return $7e8b0ec530658322$export$cd9cfc08c3097c9a(metrics);
};
const $7e8b0ec530658322$export$e36288b7b1aa3c47 = async (navigate, cameraId)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const response = await AxiosUI.get(`/camera/${cameraId}/general_info/`);
    return $7e8b0ec530658322$export$927be50d4925e65(response.data);
};
const $7e8b0ec530658322$export$9876cc5a81a2928d = (primary, fallback)=>{
    const merged = new Map(primary);
    fallback.forEach((levels, label)=>{
        merged.set(label, {
            ...levels,
            ...merged.get(label) ?? {}
        });
    });
    return merged;
};
const $7e8b0ec530658322$export$c03abb0c4fb5a3b9 = async (navigate, cameraIds, bulkUpdate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const response = await AxiosUI.post(`/metric/bulk_update/`, {
        camera_ids: cameraIds,
        bulk_update: bulkUpdate
    });
    return response.data ?? {};
};
const $7e8b0ec530658322$export$6fbdfc1543f995 = async (navigate, cameraId)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const response = await AxiosUI.get(`/stream/product/?camera_id=${cameraId}`);
    const data = response.data;
    if (Array.isArray(data)) return data;
    return [];
};
const $7e8b0ec530658322$export$7b8f851e587fefee = async (navigate, customerId)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const response = await AxiosUI.get(`/stream/simple/`, {
        params: {
            customer: customerId
        }
    });
    const data = response.data;
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.results)) return data.results;
    return [];
};
const $7e8b0ec530658322$export$7f8160f035af5fbd = async (navigate, payload)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const body = {
        stream_ids: payload.stream_ids,
        slice: payload.slice
    };
    if (payload.max_slices !== undefined) body.max_slices = payload.max_slices;
    const response = await AxiosUI.post(`/stream/bulk_update/`, body);
    return response.data;
};
const $7e8b0ec530658322$export$c20ee8582bfa83a6 = async (navigate, customerId)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const response = await AxiosUI.get(`/metric/simplified/`, {
        params: {
            customer: customerId
        }
    });
    const data = response.data;
    if (Array.isArray(data?.results)) return data.results;
    if (Array.isArray(data)) return data;
    return [];
};

});

parcelRegister("iUWjS", function(module, exports) {

$parcel$export(module.exports, "mergeBulkSlicingRows", () => $5fd14dca0ff7774f$export$4cd97e8119a42910);
$parcel$export(module.exports, "buildStreamIdToProductLabelMap", () => $5fd14dca0ff7774f$export$ee8a08d1cbf8568b);
$parcel$export(module.exports, "partitionStreamIdsForSliceUpdate", () => $5fd14dca0ff7774f$export$9b6bbae6787f5ab);
const $5fd14dca0ff7774f$export$cd016f7b1d01cd95 = (row)=>{
    const cam = row.camera;
    if (typeof cam === "number" && Number.isFinite(cam)) return cam;
    if (cam && typeof cam === "object" && "id" in cam) {
        const id = cam.id;
        if (typeof id === "number" && Number.isFinite(id)) return id;
    }
    return undefined;
};
const $5fd14dca0ff7774f$export$3d2a4f8e25d51151 = (row)=>{
    const cam = row.camera;
    if (cam && typeof cam === "object" && "camera_name" in cam) {
        const name = cam.camera_name;
        if (typeof name === "string" && name.length > 0) return name;
    }
    return "";
};
const $5fd14dca0ff7774f$export$4cd97e8119a42910 = (simpleRows, streamIdToProductLabel, selectedCameraIds, cameraIdToName)=>{
    const selected = new Set(selectedCameraIds);
    const out = [];
    for (const row of simpleRows){
        const cameraId = $5fd14dca0ff7774f$export$cd016f7b1d01cd95(row);
        if (cameraId === undefined || !selected.has(cameraId)) continue;
        let cameraName = $5fd14dca0ff7774f$export$3d2a4f8e25d51151(row);
        if (!cameraName && cameraIdToName?.has(cameraId)) cameraName = cameraIdToName.get(cameraId) ?? "";
        const productLabel = streamIdToProductLabel.get(row.id) ?? (typeof row.name === "string" && row.name.length > 0 ? row.name : "\u2014");
        const currentSlice = row.slice === true;
        out.push({
            streamId: row.id,
            cameraId: cameraId,
            cameraName: cameraName,
            productLabel: productLabel,
            currentSlice: currentSlice
        });
    }
    out.sort((a, b)=>{
        const nameCmp = a.cameraName.localeCompare(b.cameraName);
        if (nameCmp !== 0) return nameCmp;
        return a.productLabel.localeCompare(b.productLabel);
    });
    return out;
};
const $5fd14dca0ff7774f$export$ee8a08d1cbf8568b = (productRowsByCamera)=>{
    const map = new Map();
    productRowsByCamera.forEach((rows)=>{
        for (const r of rows)if (typeof r.product === "string" && r.product.length > 0) map.set(r.id, r.product);
    });
    return map;
};
const $5fd14dca0ff7774f$export$9b6bbae6787f5ab = (rows, desiredSliceByStreamId)=>{
    const enableIds = [];
    const disableIds = [];
    for (const row of rows){
        const desired = desiredSliceByStreamId[row.streamId];
        if (desired === undefined || desired === row.currentSlice) continue;
        if (desired) enableIds.push(row.streamId);
        else disableIds.push(row.streamId);
    }
    return {
        enableIds: enableIds,
        disableIds: disableIds
    };
};

});

parcelRegister("kcocJ", function(module, exports) {

$parcel$export(module.exports, "pollMetricSimplifiedUntilBulkExpectationsMet", () => $4853458395768dd4$export$59110874bddf0c01);

var $jK0A2 = parcelRequire("jK0A2");

var $kKBBF = parcelRequire("kKBBF");
const $4853458395768dd4$export$5caf68a46a0a4161 = 60000;
const $4853458395768dd4$export$705bd9ce60f7d91c = 2000;
const $4853458395768dd4$export$59110874bddf0c01 = async (navigate, customerId, selectedCameraIds, formState, mergeSnapshot, options)=>{
    const timeoutMs = options?.timeoutMs ?? $4853458395768dd4$export$5caf68a46a0a4161;
    const intervalMs = options?.intervalMs ?? $4853458395768dd4$export$705bd9ce60f7d91c;
    const deadline = Date.now() + timeoutMs;
    while(Date.now() < deadline){
        const rows = await (0, $jK0A2.fetchMetricSimplified)(navigate, customerId);
        if ((0, $kKBBF.simplifiedMetricRowsMatchBulkFormExpectations)(rows, selectedCameraIds, formState, mergeSnapshot, options?.productRows)) return true;
        await new Promise((resolve)=>setTimeout(resolve, intervalMs));
    }
    return false;
};

});


parcelRegister("kfeuh", function(module, exports) {

$parcel$export(module.exports, "TalkDownButton", () => $943726358ca2cf2e$export$9452279faf669311);
/**
 * Talk-down control. Self-contained so it can be dropped next to any camera:
 * it gates itself (flag + permission + site type) and renders nothing when
 * the operator cannot use it.
 *
 * Two transports behind one look:
 * - "clip" (v1, ENG-2135): hold to record up to 30 s, release to send, then
 *   a plain-words outcome. Audio input is useAudioRecorder, transport is
 *   useTalkDown.
 * - "live" (ENG-1721, behind `showLiveTalkDown`): hold to talk live over
 *   WHIP; transport is useLiveTalkDown, which never uses the recorder.
 * Without `showLiveTalkDown` the control is exactly v1.
 */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $ftZKa = parcelRequire("ftZKa");

var $8kxcc = parcelRequire("8kxcc");

var $1Fe8C = parcelRequire("1Fe8C");

var $jboFg = parcelRequire("jboFg");

var $8jTKl = parcelRequire("8jTKl");

var $8sbJd = parcelRequire("8sbJd");

var $4ysU8 = parcelRequire("4ysU8");

var $9sPDj = parcelRequire("9sPDj");

var $kggiO = parcelRequire("kggiO");
const $943726358ca2cf2e$export$ec858fff2788db9a = "Hold to talk down";
const $943726358ca2cf2e$export$5ebaaa04098de09d = `Release to send (up to ${(0, $8jTKl.TALK_DOWN_MAX_SECONDS)} s)`;
const $943726358ca2cf2e$var$isActivationKey = (key)=>key === " " || key === "Enter";
const $943726358ca2cf2e$var$TalkDownControlView = ({ variant: variant, label: label, status: status, statusTone: statusTone, detail: detail, active: active, pending: pending = false, disabled: disabled, title: title, onPress: onPress, onRelease: onRelease })=>{
    const heldKeyRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(false);
    const staff = (0, $4ysU8.useIsStaffUser)();
    const showDetail = Boolean(staff && detail && status);
    const overlay = variant === "overlay";
    const buttonTone = active ? "bg-[#D93636] text-white" : disabled || pending ? "bg-[#9CA3AF] text-white" : "bg-actuate-orange text-white hover:bg-[#e67700]";
    const statusColor = statusTone === "error" ? overlay ? "text-[#FFB4B4]" : "text-[#B3261E]" : statusTone === "ok" ? overlay ? "text-[#A7F3D0]" : "text-[#1B7F3B]" : overlay ? "text-white/90" : "text-actuate-blue";
    const holding = active || pending;
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: `flex items-center gap-2 font-mulish ${overlay ? "rounded bg-black/60 px-2 py-1.5" : ""}`,
        "data-testid": "talk-down",
        children: [
            status && /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                className: "flex max-w-[260px] flex-col",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                        role: "status",
                        className: `text-[12px] leading-tight ${statusColor}`,
                        children: status
                    }),
                    showDetail && /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                        "data-testid": "talk-down-detail",
                        className: `mt-0.5 break-all font-mono text-[10px] leading-tight ${overlay ? "text-white/50" : "text-gray-500"}`,
                        children: detail
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
                type: "button",
                "aria-label": $943726358ca2cf2e$export$ec858fff2788db9a,
                "aria-pressed": active,
                disabled: disabled,
                title: title,
                onPointerDown: (event)=>{
                    if (event.button !== undefined && event.button !== 0) return;
                    event.preventDefault();
                    onPress();
                },
                onPointerUp: onRelease,
                onPointerLeave: ()=>{
                    if (holding) onRelease();
                },
                onPointerCancel: onRelease,
                onKeyDown: (event)=>{
                    if (!$943726358ca2cf2e$var$isActivationKey(event.key) || event.repeat) return;
                    event.preventDefault();
                    heldKeyRef.current = true;
                    onPress();
                },
                onKeyUp: (event)=>{
                    if (!$943726358ca2cf2e$var$isActivationKey(event.key) || !heldKeyRef.current) return;
                    heldKeyRef.current = false;
                    onRelease();
                },
                onBlur: ()=>{
                    if (holding) onRelease();
                },
                onContextMenu: (event)=>event.preventDefault(),
                style: {
                    touchAction: "none",
                    userSelect: "none"
                },
                className: `inline-flex h-9 select-none items-center gap-1 whitespace-nowrap rounded px-3 text-[13px] font-bold disabled:cursor-default ${buttonTone}`,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ftZKa))), {
                        sx: {
                            fontSize: 18
                        }
                    }),
                    label
                ]
            })
        ]
    });
};
/** v1: record a clip, send it, report the outcome. */ const $943726358ca2cf2e$var$ClipTalkDown = ({ cameraId: cameraId, cameraName: cameraName, variant: variant, pollOptions: pollOptions })=>{
    const talkDown = (0, $1Fe8C.useTalkDown)({
        cameraId: cameraId,
        cameraName: cameraName,
        poll: pollOptions
    });
    const recorder = (0, $8kxcc.useAudioRecorder)({
        maxSeconds: (0, $8jTKl.TALK_DOWN_MAX_SECONDS),
        onRecorded: talkDown.submit
    });
    const { recording: recording, elapsedSeconds: elapsedSeconds } = recorder;
    const { busy: busy, state: state } = talkDown;
    const label = recording ? `Recording ${elapsedSeconds}s` : state.phase === "sending" ? "Sending..." : state.phase === "waiting" ? "Waiting..." : "Hold to talk";
    const status = recording ? $943726358ca2cf2e$export$5ebaaa04098de09d : recorder.error ?? (state.phase === "idle" ? "" : state.message);
    const statusTone = recorder.error || state.phase === "error" || state.phase === "failed" ? "error" : state.phase === "played" ? "ok" : "neutral";
    return /*#__PURE__*/ (0, $k4ank.jsx)($943726358ca2cf2e$var$TalkDownControlView, {
        variant: variant,
        label: label,
        status: status,
        statusTone: statusTone,
        detail: recording || recorder.error ? undefined : state.detail,
        active: recording,
        disabled: busy,
        title: "Hold to record, release to send",
        onPress: ()=>{
            if (busy) return;
            recorder.clearError();
            recorder.start();
        },
        onRelease: ()=>recorder.stop()
    });
};
/** ENG-1721: hold to talk live; the session stays open between holds. */ const $943726358ca2cf2e$var$LiveTalkDown = ({ cameraId: cameraId, cameraName: cameraName, variant: variant, liveOptions: liveOptions })=>{
    const live = (0, $9sPDj.useLiveTalkDown)({
        cameraId: cameraId,
        cameraName: cameraName,
        statusPoll: liveOptions?.statusPoll,
        idleMs: liveOptions?.idleMs,
        whipDeps: liveOptions?.whipDeps
    });
    const { state: state, elapsedSeconds: elapsedSeconds, busy: busy } = live;
    const label = state.phase === "live" ? `Live \u{2014} ${(0, $9sPDj.formatLiveElapsed)(elapsedSeconds)}` : state.phase === "connecting" ? "Connecting..." : state.phase === "waiting" ? "Ending..." : state.phase === "closing" ? "Closing..." : "Hold to talk";
    const status = state.phase === "idle" ? "" : state.message;
    const statusTone = state.phase === "error" || state.phase === "failed" ? "error" : state.phase === "ended" ? "ok" : "neutral";
    return /*#__PURE__*/ (0, $k4ank.jsx)($943726358ca2cf2e$var$TalkDownControlView, {
        variant: variant,
        label: label,
        status: status,
        statusTone: statusTone,
        detail: state.detail,
        active: state.phase === "live",
        pending: state.phase === "connecting",
        disabled: busy,
        title: "Hold to talk live, release to stop",
        onPress: live.press,
        onRelease: live.release
    });
};
const $943726358ca2cf2e$export$9452279faf669311 = ({ cameraId: cameraId, cameraName: cameraName, integrationTypeName: integrationTypeName, skipSiteTypeGate: skipSiteTypeGate, talkDownCapable: talkDownCapable, variant: variant = "inline", mode: mode, pollOptions: pollOptions, liveOptions: liveOptions })=>{
    const enabled = (0, $jboFg.useTalkDownEnabled)({
        integrationTypeName: integrationTypeName,
        skipSiteTypeGate: skipSiteTypeGate,
        talkDownCapable: talkDownCapable
    });
    const effectiveMode = (0, $jboFg.useTalkDownMode)(mode);
    const learnedIncapable = (0, $kggiO.useTalkDownLearnedIncapable)(cameraId);
    const staff = (0, $4ysU8.useIsStaffUser)();
    if (!enabled || cameraId == null || cameraId === "") return null;
    // dev/redesign on the staging API with Use production off: there are no
    // real cameras to talk to, so a start can only fail. Show the control
    // disabled with the reason and never mount a transport (no mic prompt, no
    // POST). Prod-config builds never take this path.
    if ((0, $8sbJd.liveMediaNeedsProductionMode)()) return /*#__PURE__*/ (0, $k4ank.jsx)($943726358ca2cf2e$var$TalkDownControlView, {
        variant: variant,
        label: "Hold to talk",
        status: staff ? (0, $8jTKl.TALK_DOWN_NEEDS_PRODUCTION_MODE_STAFF_MESSAGE) : (0, $8jTKl.TALK_DOWN_NEEDS_PRODUCTION_MODE_MESSAGE),
        statusTone: "neutral",
        detail: "staging API \xb7 Use production is off",
        active: false,
        disabled: true,
        title: "Talk-down needs real cameras",
        onPress: ()=>undefined,
        onRelease: ()=>undefined
    });
    // ENG-1721: a talk-down on this camera came back no_backchannel /
    // unsupported_camera this page session. Replace the button with a note
    // until reload (not persisted; the backend flag is the durable answer).
    if (learnedIncapable) return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: `flex items-center font-mulish ${variant === "overlay" ? "rounded bg-black/60 px-2 py-1.5" : ""}`,
        "data-testid": "talk-down-no-speaker",
        children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
            role: "status",
            className: `text-[12px] leading-tight ${variant === "overlay" ? "text-white/90" : "text-actuate-blue"}`,
            children: (0, $kggiO.TALK_DOWN_NO_SPEAKER_NOTE)
        })
    });
    return effectiveMode === "live" ? /*#__PURE__*/ (0, $k4ank.jsx)($943726358ca2cf2e$var$LiveTalkDown, {
        cameraId: cameraId,
        cameraName: cameraName,
        variant: variant,
        liveOptions: liveOptions
    }, `live-${cameraId}`) : /*#__PURE__*/ (0, $k4ank.jsx)($943726358ca2cf2e$var$ClipTalkDown, {
        cameraId: cameraId,
        cameraName: cameraName,
        variant: variant,
        pollOptions: pollOptions
    });
};

});
parcelRegister("ftZKa", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b459756d2f7918b0$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $b459756d2f7918b0$var$_default = module.exports.default = (0, $b459756d2f7918b0$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3m5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72z"
}), 'Mic');

});

parcelRegister("8kxcc", function(module, exports) {

$parcel$export(module.exports, "MIC_DENIED_MESSAGE", () => $d4721dd3116dffe7$export$6ffc8ceb64b42a23);
$parcel$export(module.exports, "MIC_NOT_FOUND_MESSAGE", () => $d4721dd3116dffe7$export$aa862426d3b8313a);
$parcel$export(module.exports, "MIC_FAILED_MESSAGE", () => $d4721dd3116dffe7$export$c9b38d3689c3da8d);
$parcel$export(module.exports, "useAudioRecorder", () => $d4721dd3116dffe7$export$ab3a6e7bee26294f);
/**
 * Hold-to-record audio input (ENG-2135). Yields a Blob when the recording
 * stops; it knows nothing about where the Blob goes. `start()` while a
 * button is held, `stop()` on release; the hook also stops itself at
 * `maxSeconds`. Mic permission problems surface as a plain `error` string.
 */ 
var $8T3gX = parcelRequire("8T3gX");
const $d4721dd3116dffe7$var$PREFERRED_MIME_TYPE = "audio/webm;codecs=opus";
const $d4721dd3116dffe7$var$TICK_MS = 250;
const $d4721dd3116dffe7$export$58dc8b43ef5555c6 = "Recording isn't supported in this browser.";
const $d4721dd3116dffe7$export$6ffc8ceb64b42a23 = "Microphone access was blocked. Allow the microphone for this site in your browser and try again.";
const $d4721dd3116dffe7$export$aa862426d3b8313a = "No microphone was found.";
const $d4721dd3116dffe7$export$c9b38d3689c3da8d = "Couldn't start the microphone.";
const $d4721dd3116dffe7$var$isSupported = ()=>typeof window !== "undefined" && typeof window.MediaRecorder === "function" && Boolean(navigator.mediaDevices?.getUserMedia);
const $d4721dd3116dffe7$var$pickMimeType = ()=>{
    const Recorder = window.MediaRecorder;
    if (Recorder?.isTypeSupported?.($d4721dd3116dffe7$var$PREFERRED_MIME_TYPE)) return $d4721dd3116dffe7$var$PREFERRED_MIME_TYPE;
    return undefined;
};
const $d4721dd3116dffe7$var$describeMicError = (reason)=>{
    const name = reason?.name ?? "";
    if (name === "NotAllowedError" || name === "SecurityError") return $d4721dd3116dffe7$export$6ffc8ceb64b42a23;
    if (name === "NotFoundError" || name === "OverconstrainedError") return $d4721dd3116dffe7$export$aa862426d3b8313a;
    return $d4721dd3116dffe7$export$c9b38d3689c3da8d;
};
const $d4721dd3116dffe7$export$ab3a6e7bee26294f = ({ onRecorded: onRecorded, maxSeconds: maxSeconds })=>{
    const [recording, setRecording] = (0, $8T3gX.useState)(false);
    const [elapsedSeconds, setElapsedSeconds] = (0, $8T3gX.useState)(0);
    const [error, setError] = (0, $8T3gX.useState)(null);
    const recorderRef = (0, $8T3gX.useRef)(null);
    const streamRef = (0, $8T3gX.useRef)(null);
    const chunksRef = (0, $8T3gX.useRef)([]);
    const tickRef = (0, $8T3gX.useRef)(null);
    // True between start() and stop(); a release before getUserMedia resolves
    // must not start a recording nobody is holding.
    const wantRecordingRef = (0, $8T3gX.useRef)(false);
    const onRecordedRef = (0, $8T3gX.useRef)(onRecorded);
    onRecordedRef.current = onRecorded;
    const releaseStream = (0, $8T3gX.useCallback)(()=>{
        streamRef.current?.getTracks().forEach((track)=>track.stop());
        streamRef.current = null;
    }, []);
    const stopTicking = (0, $8T3gX.useCallback)(()=>{
        if (tickRef.current) {
            clearInterval(tickRef.current);
            tickRef.current = null;
        }
    }, []);
    const stop = (0, $8T3gX.useCallback)(()=>{
        wantRecordingRef.current = false;
        const recorder = recorderRef.current;
        if (recorder && recorder.state !== "inactive") {
            recorder.stop();
            return;
        }
        // Not recording (yet): nothing to flush, just tidy up.
        stopTicking();
        releaseStream();
        setRecording(false);
    }, [
        releaseStream,
        stopTicking
    ]);
    const start = (0, $8T3gX.useCallback)(()=>{
        if (wantRecordingRef.current || recorderRef.current) return;
        setError(null);
        if (!$d4721dd3116dffe7$var$isSupported()) {
            setError($d4721dd3116dffe7$export$58dc8b43ef5555c6);
            return;
        }
        wantRecordingRef.current = true;
        navigator.mediaDevices.getUserMedia({
            audio: true
        }).then((stream)=>{
            if (!wantRecordingRef.current) {
                // Released before the mic came up.
                stream.getTracks().forEach((track)=>track.stop());
                return;
            }
            streamRef.current = stream;
            chunksRef.current = [];
            const mimeType = $d4721dd3116dffe7$var$pickMimeType();
            let recorder;
            try {
                recorder = mimeType ? new MediaRecorder(stream, {
                    mimeType: mimeType
                }) : new MediaRecorder(stream);
            } catch (reason) {
                wantRecordingRef.current = false;
                releaseStream();
                setError($d4721dd3116dffe7$var$describeMicError(reason));
                return;
            }
            recorder.ondataavailable = (event)=>{
                if (event.data && event.data.size > 0) chunksRef.current.push(event.data);
            };
            recorder.onstop = ()=>{
                const type = recorder.mimeType || mimeType || "audio/webm";
                const audio = new Blob(chunksRef.current, {
                    type: type
                });
                chunksRef.current = [];
                recorderRef.current = null;
                stopTicking();
                releaseStream();
                setRecording(false);
                onRecordedRef.current(audio);
            };
            recorder.onerror = ()=>{
                setError($d4721dd3116dffe7$export$c9b38d3689c3da8d);
                stop();
            };
            recorderRef.current = recorder;
            recorder.start();
            const startedAt = Date.now();
            setElapsedSeconds(0);
            setRecording(true);
            stopTicking();
            tickRef.current = setInterval(()=>{
                const elapsed = Math.floor((Date.now() - startedAt) / 1000);
                setElapsedSeconds(elapsed);
                if (elapsed >= maxSeconds) stop();
            }, $d4721dd3116dffe7$var$TICK_MS);
        }, (reason)=>{
            wantRecordingRef.current = false;
            setError($d4721dd3116dffe7$var$describeMicError(reason));
        });
    }, [
        maxSeconds,
        releaseStream,
        stop,
        stopTicking
    ]);
    (0, $8T3gX.useEffect)(()=>()=>{
            // Unmount mid-hold: drop the recording rather than send it.
            wantRecordingRef.current = false;
            const recorder = recorderRef.current;
            recorderRef.current = null;
            if (recorder && recorder.state !== "inactive") {
                recorder.onstop = null;
                try {
                    recorder.stop();
                } catch  {
                // Already stopped.
                }
            }
            stopTicking();
            releaseStream();
        }, [
        releaseStream,
        stopTicking
    ]);
    const clearError = (0, $8T3gX.useCallback)(()=>setError(null), []);
    return {
        recording: recording,
        elapsedSeconds: elapsedSeconds,
        error: error,
        start: start,
        stop: stop,
        clearError: clearError
    };
};

});

parcelRegister("1Fe8C", function(module, exports) {

$parcel$export(module.exports, "useTalkDown", () => $186322457a9a332c$export$2fab1fe5600ef4a0);
/**
 * Talk-down transport state (ENG-2135): takes a recorded Blob, uploads it,
 * then polls for the camera's outcome. The recorder is separate on purpose
 * (see useAudioRecorder); a live push-to-talk swaps this hook for a relay
 * publish and keeps the same control.
 */ 
var $8T3gX = parcelRequire("8T3gX");

var $8jTKl = parcelRequire("8jTKl");

var $kggiO = parcelRequire("kggiO");
const $186322457a9a332c$export$f9865af79038ade0 = {
    phase: "idle",
    message: ""
};
const $186322457a9a332c$export$2fab1fe5600ef4a0 = ({ cameraId: cameraId, cameraName: cameraName, poll: poll })=>{
    const [state, setState] = (0, $8T3gX.useState)($186322457a9a332c$export$f9865af79038ade0);
    const abortRef = (0, $8T3gX.useRef)(null);
    const pollRef = (0, $8T3gX.useRef)(poll);
    pollRef.current = poll;
    const cancel = (0, $8T3gX.useCallback)(()=>{
        abortRef.current?.abort();
        abortRef.current = null;
    }, []);
    (0, $8T3gX.useEffect)(()=>cancel, [
        cancel
    ]);
    // A new camera means any in-flight outcome belongs to the old one.
    (0, $8T3gX.useEffect)(()=>{
        cancel();
        setState($186322457a9a332c$export$f9865af79038ade0);
    }, [
        cameraId,
        cancel
    ]);
    const submit = (0, $8T3gX.useCallback)((audio)=>{
        if (cameraId == null || cameraId === "") return;
        if (audio.size > (0, $8jTKl.TALK_DOWN_MAX_BYTES)) {
            setState({
                phase: "error",
                message: (0, $8jTKl.TALK_DOWN_TOO_LARGE_MESSAGE)
            });
            return;
        }
        cancel();
        const controller = new AbortController();
        abortRef.current = controller;
        const live = ()=>abortRef.current === controller && !controller.signal.aborted;
        setState({
            phase: "sending",
            message: "Sending..."
        });
        (0, $8jTKl.sendTalkDown)(cameraId, audio).then(async (dispatch)=>{
            if (!live()) return;
            setState({
                phase: "waiting",
                message: (0, $8jTKl.TALK_DOWN_SENT_MESSAGE)
            });
            const result = await (0, $8jTKl.pollTalkDownOutcome)(dispatch.site_id, dispatch.command_id, {
                ...pollRef.current,
                signal: controller.signal
            });
            if (!live() || result.kind === "aborted") return;
            if (result.kind === "not_received") {
                setState({
                    phase: "failed",
                    message: (0, $8jTKl.TALK_DOWN_NOT_RECEIVED_MESSAGE),
                    detail: `job command_id=${dispatch.command_id} \xb7 no status row`
                });
                return;
            }
            const row = result.kind === "done" ? result.row : null;
            const outcome = (0, $8jTKl.describeTalkDownOutcome)(row, cameraName);
            setState({
                phase: row == null ? "timeout" : outcome.ok ? "played" : "failed",
                message: outcome.message,
                detail: outcome.ok ? undefined : (0, $8jTKl.describeTalkDownOutcomeDetail)(row)
            });
            // ENG-1721: a camera without a speaker hides its button for the
            // rest of the page session. Last: it can unmount this control.
            (0, $kggiO.noteTalkDownErrorCode)(cameraId, row?.result?.error_code);
        }, (reason)=>{
            if (!live()) return;
            setState({
                phase: "error",
                message: (0, $8jTKl.describeTalkDownSendError)(reason),
                detail: (0, $8jTKl.describeTalkDownErrorDetail)(reason)
            });
        });
    }, [
        cameraId,
        cameraName,
        cancel
    ]);
    const reset = (0, $8T3gX.useCallback)(()=>{
        cancel();
        setState($186322457a9a332c$export$f9865af79038ade0);
    }, [
        cancel
    ]);
    return {
        state: state,
        busy: state.phase === "sending" || state.phase === "waiting",
        submit: submit,
        reset: reset
    };
};

});
parcelRegister("8jTKl", function(module, exports) {

$parcel$export(module.exports, "TALK_DOWN_MAX_BYTES", () => $fc0700cf65cbc162$export$cf15ce2ac942073f);
$parcel$export(module.exports, "TALK_DOWN_MAX_SECONDS", () => $fc0700cf65cbc162$export$531529ba3f9ddd53);
$parcel$export(module.exports, "TALK_DOWN_TOO_LARGE_MESSAGE", () => $fc0700cf65cbc162$export$68c3efdf6e12ef1);
$parcel$export(module.exports, "TALK_DOWN_SENT_MESSAGE", () => $fc0700cf65cbc162$export$5ecdf2cc35ecf9b8);
$parcel$export(module.exports, "TALK_DOWN_NOT_RECEIVED_MESSAGE", () => $fc0700cf65cbc162$export$5948bf2da9c0ad2e);
$parcel$export(module.exports, "TALK_DOWN_NEEDS_PRODUCTION_MODE_STAFF_MESSAGE", () => $fc0700cf65cbc162$export$c395133473b45f3b);
$parcel$export(module.exports, "TALK_DOWN_NEEDS_PRODUCTION_MODE_MESSAGE", () => $fc0700cf65cbc162$export$85f5566cace1adc7);
$parcel$export(module.exports, "TALK_DOWN_LIVE_ENDPOINT_LABEL", () => $fc0700cf65cbc162$export$2897ac9b25028455);
$parcel$export(module.exports, "describeTalkDownErrorDetail", () => $fc0700cf65cbc162$export$b8c3fcd2b20a6226);
$parcel$export(module.exports, "describeTalkDownOutcomeDetail", () => $fc0700cf65cbc162$export$7be6c208e47e8268);
$parcel$export(module.exports, "describeLiveTalkDownOutcomeDetail", () => $fc0700cf65cbc162$export$dda343b63a2e161e);
$parcel$export(module.exports, "sendTalkDown", () => $fc0700cf65cbc162$export$304cdc0e4a008f3a);
$parcel$export(module.exports, "pollTalkDownOutcome", () => $fc0700cf65cbc162$export$ed0c443b5358e6cd);
$parcel$export(module.exports, "describeTalkDownOutcome", () => $fc0700cf65cbc162$export$df590ee2876b019d);
$parcel$export(module.exports, "describeTalkDownSendError", () => $fc0700cf65cbc162$export$9e23f50d60408a19);
$parcel$export(module.exports, "LIVE_TALK_DOWN_MAX_SECONDS", () => $fc0700cf65cbc162$export$5126cd9173e29e70);
$parcel$export(module.exports, "LIVE_TALK_DOWN_IDLE_MS", () => $fc0700cf65cbc162$export$711eef936f15469);
$parcel$export(module.exports, "LIVE_TALK_DOWN_READY_INTERVAL_MS", () => $fc0700cf65cbc162$export$e7147e830305719c);
$parcel$export(module.exports, "LIVE_TALK_DOWN_OPEN_INTERVAL_MS", () => $fc0700cf65cbc162$export$4d57af7d00874f9a);
$parcel$export(module.exports, "LIVE_TALK_DOWN_READY_TIMEOUT_MS", () => $fc0700cf65cbc162$export$66b3fa93aa2f54d5);
$parcel$export(module.exports, "LIVE_TALK_DOWN_OUTCOME_INTERVAL_MS", () => $fc0700cf65cbc162$export$40734b6cc49e1e05);
$parcel$export(module.exports, "LIVE_TALK_DOWN_OUTCOME_TIMEOUT_MS", () => $fc0700cf65cbc162$export$4d3f829ce2c8763b);
$parcel$export(module.exports, "LIVE_TALK_DOWN_RECENT_SESSION_MS", () => $fc0700cf65cbc162$export$557afbde48f779ff);
$parcel$export(module.exports, "LIVE_TALK_DOWN_ENDED_MESSAGE", () => $fc0700cf65cbc162$export$587a7a73e857a984);
$parcel$export(module.exports, "describeLiveTalkDownOutcome", () => $fc0700cf65cbc162$export$4a8bdc0bcc8cc39c);
$parcel$export(module.exports, "isTalkDownInProgress", () => $fc0700cf65cbc162$export$3dbc5f27fb2dfcbb);
$parcel$export(module.exports, "describeLiveTalkDownStartError", () => $fc0700cf65cbc162$export$bc2a1c41dd6fb2c7);
$parcel$export(module.exports, "startLiveTalkDown", () => $fc0700cf65cbc162$export$d877cd5d6664e588);
$parcel$export(module.exports, "stopLiveTalkDown", () => $fc0700cf65cbc162$export$75d9bc18043507e4);
$parcel$export(module.exports, "fetchLiveTalkDownStatus", () => $fc0700cf65cbc162$export$31353425eb296c82);
$parcel$export(module.exports, "isLiveTalkDownFinished", () => $fc0700cf65cbc162$export$60b1c7009c875dda);
$parcel$export(module.exports, "pollLiveTalkDownOutcome", () => $fc0700cf65cbc162$export$9f319666d78cce0d);
/**
 * Talk-down v1 transport (ENG-2135): upload a short recording to admin, which
 * dispatches it to the site's connector as a Command, then poll the site's
 * action_status until that Command reports whether the camera played it.
 *
 * Only this module knows the wire format. The hold-to-record control
 * (useAudioRecorder) just yields a Blob, so a later live push-to-talk can
 * swap this transport for a relay publish without touching the control.
 */ 
var $195EM = parcelRequire("195EM");

var $hAnMZ = parcelRequire("hAnMZ");
const $fc0700cf65cbc162$export$911df58e0dfa5c92 = "talk_down";
const $fc0700cf65cbc162$export$cf15ce2ac942073f = 1048576;
const $fc0700cf65cbc162$export$531529ba3f9ddd53 = 30;
const $fc0700cf65cbc162$export$d0c5b5d46d511e16 = 1000;
const $fc0700cf65cbc162$export$19e3ac8f3dc769eb = 30000;
const $fc0700cf65cbc162$export$68c3efdf6e12ef1 = "That recording is too large to send (1 MB limit). Try a shorter message.";
const $fc0700cf65cbc162$export$5ecdf2cc35ecf9b8 = "Sent. Waiting for the camera...";
const $fc0700cf65cbc162$export$5948bf2da9c0ad2e = "Couldn't confirm the talk-down was received";
const $fc0700cf65cbc162$export$5c0b6bb8d5c95553 = "No result yet, the camera may still play it";
const $fc0700cf65cbc162$export$1f15851783435a25 = "Another talk-down is playing on this camera";
const $fc0700cf65cbc162$export$60df408d0192c323 = "Talk-down failed";
const $fc0700cf65cbc162$export$51342b4c76df103f = "Talk-down isn't available right now. Try again in a moment.";
const $fc0700cf65cbc162$export$5c9814a6ecf0560e = "This site isn't active";
const $fc0700cf65cbc162$export$df2c795e2880d067 = "Couldn't start talk-down, try again";
const $fc0700cf65cbc162$export$dc1166adb2c42138 = "Couldn't reach the talk-down service. Check your connection and try again.";
const $fc0700cf65cbc162$export$4eba4d5a4351a1c0 = "The talk-down service had a problem (server error). Try again in a moment.";
const $fc0700cf65cbc162$export$7709bc4e80b95822 = "Couldn't start talk-down (request refused).";
const $fc0700cf65cbc162$export$725b5f3be20e3916 = "The camera didn't play the talk-down.";
const $fc0700cf65cbc162$export$c395133473b45f3b = "Talk-down uses real cameras. Switch on Use production to try it.";
const $fc0700cf65cbc162$export$85f5566cace1adc7 = "Talk-down isn't available on this test site.";
const $fc0700cf65cbc162$export$2cec02c702468aa0 = "talk_down";
const $fc0700cf65cbc162$export$2897ac9b25028455 = "talk-down live";
const $fc0700cf65cbc162$export$b8c3fcd2b20a6226 = (reason, endpoint = $fc0700cf65cbc162$export$2cec02c702468aa0)=>{
    const err = reason;
    if (err?.isProductionModeBlock) return `${endpoint} POST blocked (read-only)`;
    const status = err?.response?.status;
    const code = err?.response?.data?.error ?? err?.response?.data?.error_code;
    if (status) return [
        `${endpoint} POST ${status}`,
        code
    ].filter(Boolean).join(" ");
    const errCode = reason?.code;
    const isAxios = Boolean(reason?.isAxiosError);
    if (isAxios || errCode) return `${endpoint} POST \xb7 no response${errCode ? ` ${errCode}` : ""}`;
    return undefined;
};
const $fc0700cf65cbc162$export$7be6c208e47e8268 = (row)=>{
    if (!row) return "job \xb7 no result before timeout";
    const result = row.result ?? {};
    return [
        `job status=${result.status ?? row.status ?? "?"}`,
        result.error_code ? `error_code=${result.error_code}` : ""
    ].filter(Boolean).join(" ");
};
const $fc0700cf65cbc162$export$dda343b63a2e161e = (status)=>{
    if (!status) return undefined;
    return [
        `session status=${status.status}`,
        status.error_code ? `error_code=${status.error_code}` : ""
    ].filter(Boolean).join(" ");
};
const $fc0700cf65cbc162$var$fileNameFor = (mimeType)=>{
    const type = mimeType.toLowerCase();
    if (type.includes("ogg")) return "talk-down.ogg";
    if (type.includes("mp4") || type.includes("aac")) return "talk-down.m4a";
    if (type.includes("wav")) return "talk-down.wav";
    return "talk-down.webm";
};
const $fc0700cf65cbc162$export$304cdc0e4a008f3a = async (cameraId, audio)=>{
    if (audio.size > $fc0700cf65cbc162$export$cf15ce2ac942073f) throw new Error($fc0700cf65cbc162$export$68c3efdf6e12ef1);
    const form = new FormData();
    form.append("audio", audio, $fc0700cf65cbc162$var$fileNameFor(audio.type));
    // createApi defaults Content-Type to application/json; axios drops that
    // header for a FormData body in the browser so the boundary gets set.
    const response = await (0, $195EM.createApi)("").post(`camera/${cameraId}/talk_down/`, form);
    return response.data;
};
const $fc0700cf65cbc162$var$toRows = (data)=>{
    if (Array.isArray(data)) return data;
    if (data && typeof data === "object") {
        const results = data.results;
        if (Array.isArray(results)) return results;
        return [
            data
        ];
    }
    return [];
};
const $fc0700cf65cbc162$export$c26400d6408834b3 = async (siteId, signal)=>{
    const response = await (0, $195EM.createApi)("").get(`customer/${siteId}/action_status/?action=${$fc0700cf65cbc162$export$911df58e0dfa5c92}`, {
        signal: signal
    });
    return $fc0700cf65cbc162$var$toRows(response.data);
};
// Resolves after `ms`, or immediately once `signal` aborts.
const $fc0700cf65cbc162$var$wait = (ms, signal)=>new Promise((resolve)=>{
        if (signal?.aborted) {
            resolve();
            return;
        }
        const done = ()=>{
            clearTimeout(timer);
            signal?.removeEventListener("abort", done);
            resolve();
        };
        const timer = setTimeout(done, ms);
        signal?.addEventListener("abort", done);
    });
const $fc0700cf65cbc162$export$568db25fe2b1de7f = 3000;
const $fc0700cf65cbc162$export$9eb7c300b24c7b63 = (row, ids)=>{
    if (row?.id == null) return false;
    const wanted = (Array.isArray(ids) ? ids : [
        ids
    ]).filter((id)=>id != null && id !== "").map(String);
    return wanted.includes(String(row.id));
};
const $fc0700cf65cbc162$var$isNotFound = (reason)=>reason?.response?.status === 404;
const $fc0700cf65cbc162$export$ed0c443b5358e6cd = async (siteId, commandId, options = {})=>{
    const intervalMs = options.intervalMs ?? $fc0700cf65cbc162$export$d0c5b5d46d511e16;
    const timeoutMs = options.timeoutMs ?? $fc0700cf65cbc162$export$19e3ac8f3dc769eb;
    const notFoundGraceMs = options.notFoundGraceMs ?? $fc0700cf65cbc162$export$568db25fe2b1de7f;
    const signal = options.signal;
    const attempts = Math.max(1, Math.ceil(timeoutMs / Math.max(1, intervalMs)));
    for(let attempt = 0; attempt < attempts; attempt++){
        await $fc0700cf65cbc162$var$wait(intervalMs, signal);
        if (signal?.aborted) return {
            kind: "aborted"
        };
        const elapsedMs = (attempt + 1) * intervalMs;
        try {
            const rows = await $fc0700cf65cbc162$export$c26400d6408834b3(siteId, signal);
            if (signal?.aborted) return {
                kind: "aborted"
            };
            const row = rows.find((r)=>$fc0700cf65cbc162$export$9eb7c300b24c7b63(r, commandId));
            if (row && row.status && row.status !== "pending") return {
                kind: "done",
                row: row
            };
        } catch (reason) {
            if (signal?.aborted) return {
                kind: "aborted"
            };
            if ($fc0700cf65cbc162$var$isNotFound(reason) && elapsedMs >= notFoundGraceMs) return {
                kind: "not_received"
            };
        // No row yet (within grace) or a transient error: keep polling.
        }
    }
    return {
        kind: "timeout"
    };
};
const $fc0700cf65cbc162$var$ERROR_CODE_COPY = {
    no_audio_output: "Camera has no speaker output",
    unreachable: "Couldn't reach the camera"
};
const $fc0700cf65cbc162$export$df590ee2876b019d = (row, cameraName)=>{
    if (!row) return {
        ok: false,
        message: $fc0700cf65cbc162$export$5c0b6bb8d5c95553
    };
    const result = row.result ?? {};
    const played = row.status === "success" && result.status !== "failed";
    if (played) {
        const seconds = typeof result.seconds_sent === "number" && isFinite(result.seconds_sent) ? Math.round(result.seconds_sent * 10) / 10 : null;
        const where = cameraName ? ` on ${cameraName}` : "";
        return {
            ok: true,
            message: seconds == null ? `Played${where}` : `Played ${seconds} s${where}`
        };
    }
    const code = result.error_code ? String(result.error_code) : "";
    if (code && $fc0700cf65cbc162$var$ERROR_CODE_COPY[code]) return {
        ok: false,
        message: $fc0700cf65cbc162$var$ERROR_CODE_COPY[code]
    };
    const detail = result.detail ? String(result.detail).trim() : "";
    return {
        ok: false,
        message: detail || $fc0700cf65cbc162$export$725b5f3be20e3916
    };
};
const $fc0700cf65cbc162$export$9e23f50d60408a19 = (reason)=>{
    const err = reason;
    if (err?.isProductionModeBlock) return err.response?.data?.detail || $fc0700cf65cbc162$export$60df408d0192c323;
    if (reason instanceof Error && reason.message === $fc0700cf65cbc162$export$68c3efdf6e12ef1) return $fc0700cf65cbc162$export$68c3efdf6e12ef1;
    const status = err?.response?.status;
    const code = err?.response?.data?.error;
    if (code === "talkdown_in_progress" || status === 409) return $fc0700cf65cbc162$export$1f15851783435a25;
    if (code === "invalid_audio" || status === 400) return "The recording couldn't be used. Try recording again.";
    if (code === "site_inactive") return $fc0700cf65cbc162$export$5c9814a6ecf0560e;
    if (code === "talk_down_not_permitted" || status === 403) return "You don't have permission to talk down on this camera.";
    if (code === "talkdown_dispatch_failed") return $fc0700cf65cbc162$export$df2c795e2880d067;
    if (code === "talkdown_relay_unavailable" || status === 503) return $fc0700cf65cbc162$export$51342b4c76df103f;
    if (code === "dispatch_failed" || status === 502) return "Couldn't send the talk-down to the site. Try again in a moment.";
    if (status === 413) return $fc0700cf65cbc162$export$68c3efdf6e12ef1;
    if (status === 401) return "Your session has expired. Reload the page and try again.";
    if (!status) return $fc0700cf65cbc162$export$dc1166adb2c42138;
    if (status >= 500) return $fc0700cf65cbc162$export$4eba4d5a4351a1c0;
    return $fc0700cf65cbc162$export$7709bc4e80b95822;
};
const $fc0700cf65cbc162$export$5126cd9173e29e70 = 60;
const $fc0700cf65cbc162$export$711eef936f15469 = 60000;
const $fc0700cf65cbc162$export$e7147e830305719c = 1000;
const $fc0700cf65cbc162$export$4d57af7d00874f9a = 5000;
const $fc0700cf65cbc162$export$66b3fa93aa2f54d5 = 40000;
const $fc0700cf65cbc162$export$40734b6cc49e1e05 = 1000;
const $fc0700cf65cbc162$export$4d3f829ce2c8763b = 25000;
const $fc0700cf65cbc162$export$557afbde48f779ff = 30000;
const $fc0700cf65cbc162$export$587a7a73e857a984 = "Live talk-down ended";
const $fc0700cf65cbc162$export$1b0bd66baf13d89d = "Talk-down stopped unexpectedly";
const $fc0700cf65cbc162$export$263cd63200e834c5 = "This camera wasn't found or isn't available to you.";
const $fc0700cf65cbc162$var$LIVE_ERROR_CODE_COPY = {
    camera_unreachable: "Couldn't reach the camera",
    auth_failed: "Camera rejected the login",
    no_backchannel: "This camera doesn't support talk-down",
    unsupported_camera: "This camera doesn't support talk-down",
    unsupported_codec: "Camera audio format isn't supported",
    no_audio: "No audio reached the camera (check your microphone)",
    job_lost: $fc0700cf65cbc162$export$1b0bd66baf13d89d,
    session_unavailable: $fc0700cf65cbc162$export$1b0bd66baf13d89d,
    error: $fc0700cf65cbc162$export$1b0bd66baf13d89d
};
const $fc0700cf65cbc162$export$4a8bdc0bcc8cc39c = (status, cameraName)=>{
    if (!status) return {
        ok: true,
        message: $fc0700cf65cbc162$export$587a7a73e857a984
    };
    const code = status.error_code ? String(status.error_code) : "";
    if (status.status === "failed" || code) {
        if (code && $fc0700cf65cbc162$var$LIVE_ERROR_CODE_COPY[code]) return {
            ok: false,
            message: $fc0700cf65cbc162$var$LIVE_ERROR_CODE_COPY[code]
        };
        return {
            ok: false,
            message: $fc0700cf65cbc162$export$1b0bd66baf13d89d
        };
    }
    const seconds = typeof status.seconds_sent === "number" && isFinite(status.seconds_sent) ? Math.round(status.seconds_sent) : null;
    if (seconds == null) return {
        ok: true,
        message: $fc0700cf65cbc162$export$587a7a73e857a984
    };
    const where = cameraName ? ` on ${cameraName}` : "";
    return {
        ok: true,
        message: `Session ended after ${seconds} s${where}`
    };
};
const $fc0700cf65cbc162$export$3dbc5f27fb2dfcbb = (reason)=>{
    const err = reason;
    return err?.response?.data?.error === "talkdown_in_progress" || err?.response?.status === 409;
};
const $fc0700cf65cbc162$export$bc2a1c41dd6fb2c7 = (reason)=>{
    const status = reason?.response?.status;
    if (status === 404) return $fc0700cf65cbc162$export$263cd63200e834c5;
    return $fc0700cf65cbc162$export$9e23f50d60408a19(reason);
};
const $fc0700cf65cbc162$export$6c6f57c724bbabc8 = {
    client: "monitoring",
    start: (cameraId)=>`streaming/talk-down/${cameraId}/`,
    /** STATUS (GET) and STOP (DELETE) share this URL. */ session: (cameraId, sessionId)=>`streaming/talk-down/${cameraId}/${sessionId}/`
};
const $fc0700cf65cbc162$var$liveClient = ()=>$fc0700cf65cbc162$export$6c6f57c724bbabc8.client === "admin" ? (0, $195EM.createApi)("") : (0, $hAnMZ.createMonitoringAPICall)("");
const $fc0700cf65cbc162$export$d877cd5d6664e588 = async (cameraId)=>{
    const response = await $fc0700cf65cbc162$var$liveClient().post($fc0700cf65cbc162$export$6c6f57c724bbabc8.start(cameraId));
    return response.data;
};
const $fc0700cf65cbc162$export$75d9bc18043507e4 = async (cameraId, sessionId)=>{
    await $fc0700cf65cbc162$var$liveClient().delete($fc0700cf65cbc162$export$6c6f57c724bbabc8.session(cameraId, sessionId));
};
const $fc0700cf65cbc162$export$31353425eb296c82 = async (cameraId, sessionId, signal)=>{
    try {
        const response = await $fc0700cf65cbc162$var$liveClient().get($fc0700cf65cbc162$export$6c6f57c724bbabc8.session(cameraId, sessionId), {
            signal: signal
        });
        return response.data;
    } catch (reason) {
        if ($fc0700cf65cbc162$var$isNotFound(reason)) return null;
        throw reason;
    }
};
const $fc0700cf65cbc162$export$60b1c7009c875dda = (status)=>status == null || status.status === "ended" || status.status === "failed";
const $fc0700cf65cbc162$export$9f319666d78cce0d = async (cameraId, sessionId, options = {})=>{
    const intervalMs = options.intervalMs ?? $fc0700cf65cbc162$export$40734b6cc49e1e05;
    const timeoutMs = options.timeoutMs ?? $fc0700cf65cbc162$export$4d3f829ce2c8763b;
    const signal = options.signal;
    const attempts = Math.max(1, Math.ceil(timeoutMs / Math.max(1, intervalMs)));
    for(let attempt = 0; attempt < attempts; attempt++){
        if (signal?.aborted) return {
            kind: "aborted"
        };
        try {
            const status = await $fc0700cf65cbc162$export$31353425eb296c82(cameraId, sessionId, signal);
            if (signal?.aborted) return {
                kind: "aborted"
            };
            if ($fc0700cf65cbc162$export$60b1c7009c875dda(status)) return {
                kind: "done",
                status: status
            };
        } catch  {
            if (signal?.aborted) return {
                kind: "aborted"
            };
        }
        await $fc0700cf65cbc162$var$wait(intervalMs, signal);
    }
    return signal?.aborted ? {
        kind: "aborted"
    } : {
        kind: "timeout"
    };
};

});
parcelRegister("hAnMZ", function(module, exports) {

$parcel$export(module.exports, "createMonitoringAPICall", () => $643c6f7b79576869$export$bc2a92cf29f6191e);

var $7pFvC = parcelRequire("7pFvC");

var $5BK6w = parcelRequire("5BK6w");

var $2LUuS = parcelRequire("2LUuS");
const $643c6f7b79576869$export$bc2a92cf29f6191e = (path)=>{
    const baseURL = (0, $2LUuS.getApiUrl)();
    const instance = (0, (/*@__PURE__*/$parcel$interopDefault($7pFvC))).create({
        baseURL: `${baseURL}monitoring-api/${path}`,
        headers: {
            "Content-Type": "application/json"
        }
    });
    // Add a request interceptor
    instance.interceptors.request.use((config)=>{
        // Get the token *before* the request is sent
        const token = (0, $5BK6w.getCookie)("token");
        if (token) {
            // Ensure headers object exists before assigning to it
            if (!config.headers) config.headers = {};
            // Set the Authorization header dynamically
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config; // Return the modified config
    }, (error)=>{
        // Handle request error
        return Promise.reject(error);
    });
    return instance; // Return the instance with the interceptor attached
};

});


parcelRegister("kggiO", function(module, exports) {

$parcel$export(module.exports, "TALK_DOWN_NO_SPEAKER_NOTE", () => $850e6ccc00129b91$export$460516620888ff2c);
$parcel$export(module.exports, "noteTalkDownErrorCode", () => $850e6ccc00129b91$export$5bafb68d3790e775);
$parcel$export(module.exports, "useTalkDownLearnedIncapable", () => $850e6ccc00129b91$export$1cbcff46cbe0dbb5);
/**
 * Cameras this page session has learned cannot play talk-down audio
 * (ENG-1721). A talk-down outcome with error_code no_backchannel,
 * unsupported_camera or no_audio_output (clip or live) means the camera has
 * no speaker /
 * backchannel, so the button is hidden for that camera and replaced by a
 * short note until reload.
 *
 * Module-level and deliberately NOT persisted: the backend's per-camera
 * `talk_down_capable` is the durable answer; this only stops an operator
 * from retrying a camera that just told us it can't play audio.
 */ 
var $9OjAn = parcelRequire("9OjAn");
const $850e6ccc00129b91$export$b9b882c1fa5a1040 = new Set([
    "no_backchannel",
    "unsupported_camera",
    "no_audio_output"
]);
const $850e6ccc00129b91$export$1f8849ac8d23af37 = (code)=>typeof code === "string" && $850e6ccc00129b91$export$b9b882c1fa5a1040.has(code);
const $850e6ccc00129b91$export$460516620888ff2c = "This camera has no speaker";
const $850e6ccc00129b91$export$1a184b141dd7b96 = (0, $9OjAn.create)((set)=>({
        incapable: {},
        markIncapable: (cameraId)=>set((state)=>{
                const key = String(cameraId);
                if (state.incapable[key]) return state;
                return {
                    incapable: {
                        ...state.incapable,
                        [key]: true
                    }
                };
            }),
        reset: ()=>set({
                incapable: {}
            })
    }));
const $850e6ccc00129b91$export$5bafb68d3790e775 = (cameraId, code)=>{
    if (cameraId == null || cameraId === "" || !$850e6ccc00129b91$export$1f8849ac8d23af37(code)) return;
    $850e6ccc00129b91$export$1a184b141dd7b96.getState().markIncapable(cameraId);
};
const $850e6ccc00129b91$export$1cbcff46cbe0dbb5 = (cameraId)=>$850e6ccc00129b91$export$1a184b141dd7b96((state)=>cameraId == null || cameraId === "" ? false : Boolean(state.incapable[String(cameraId)]));

});


parcelRegister("jboFg", function(module, exports) {

$parcel$export(module.exports, "TALK_DOWN_FLAG", () => $6dc8d2af67b437a5$export$aeb759b95d3ab109);
$parcel$export(module.exports, "useTalkDownMode", () => $6dc8d2af67b437a5$export$ef893da9711362b9);
$parcel$export(module.exports, "useTalkDownEnabled", () => $6dc8d2af67b437a5$export$1dd740a090fff674);
/**
 * Who sees the talk-down control (ENG-2135): the LaunchDarkly flag
 * `showTalkDown` AND the login-time `permission.talk_down` from /user/info/
 * (copied key-by-key into appStore.userPermissions by handleSetPermissions
 * and dataFetchers, so a new permission needs no plumbing beyond its default)
 * AND, for v1, a site whose cameras are reached over RTSP/ONVIF. Admin
 * enforces the permission again on the POST; this only hides the button.
 */ 
var $4PFLW = parcelRequire("4PFLW");

var $aYdit = parcelRequire("aYdit");

var $78vay = parcelRequire("78vay");
const $6dc8d2af67b437a5$export$aeb759b95d3ab109 = "showTalkDown";
const $6dc8d2af67b437a5$export$fd2c4c0dc14722c1 = "talk_down";
const $6dc8d2af67b437a5$export$6689bcc475cd7f49 = (integrationTypeName)=>(0, $78vay.siteFamily)(integrationTypeName) === "rtsp-pull";
const $6dc8d2af67b437a5$export$d94ca9261c14ca9e = "showLiveTalkDown";
const $6dc8d2af67b437a5$export$ef893da9711362b9 = (requested)=>{
    const { flags: flags } = (0, $4PFLW.useFeatureFlag)();
    const liveOn = Boolean(flags?.[$6dc8d2af67b437a5$export$d94ca9261c14ca9e]);
    if (requested === "clip") return "clip";
    return liveOn ? "live" : "clip";
};
const $6dc8d2af67b437a5$export$1dd740a090fff674 = ({ integrationTypeName: integrationTypeName, skipSiteTypeGate: skipSiteTypeGate = false, talkDownCapable: talkDownCapable } = {})=>{
    const { flags: flags } = (0, $4PFLW.useFeatureFlag)();
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    const flagOn = Boolean(flags?.[$6dc8d2af67b437a5$export$aeb759b95d3ab109]);
    const permitted = Boolean(userPermissions?.[$6dc8d2af67b437a5$export$fd2c4c0dc14722c1]);
    const siteOk = skipSiteTypeGate || $6dc8d2af67b437a5$export$6689bcc475cd7f49(integrationTypeName);
    const cameraOk = talkDownCapable !== false;
    return flagOn && permitted && siteOk && cameraOk;
};

});
parcelRegister("78vay", function(module, exports) {

$parcel$export(module.exports, "siteFamily", () => $7b43ec776e0fe0d0$export$3791f69b4943680c);
/**
 * What kind of site this is, from `integration_type_name` (reconciled with
 * redesign-be's audit of the connector factory and admin's integration flags,
 * 2026-09-27; reference: ENG-2046). The family decides which signals can say
 * "working right now" and whether silence is normal. How the site is reached
 * (direct / WireGuard / site-to-site) is separate: see `connectionKindForSite`.
 */ /** Admin collapses every is_rtsp integration (hikvision, axis, …) to "rtsp". */ const $7b43ec776e0fe0d0$var$RTSP_PULL = [
    "rtsp",
    "onvif_wireguard",
    "alibi",
    "orchid",
    "wisenet",
    "lightapi",
    "milestone_rtsp",
    "adpro"
];
const $7b43ec776e0fe0d0$var$VMS_PULL = [
    "avigilon",
    "digital_watchdog",
    "genetec",
    "exacq",
    "openeye",
    "video_insight",
    "salient",
    "luxriot",
    "cortrol",
    "hikcentral"
];
const $7b43ec776e0fe0d0$var$CLOUD_PULL = [
    "eagle_eye",
    "eagle_eye_v3",
    "star4live",
    "ezcloud",
    "kvs",
    "ajax_video"
];
const $7b43ec776e0fe0d0$var$SMTP_PUSH = [
    "smtp_per_camera",
    "hikvision_smtp",
    "speco_smtp",
    "ajax"
];
const $7b43ec776e0fe0d0$var$CLIPS_PUSH = [
    "ailink",
    "sentinel-verifier",
    "clips"
];
const $7b43ec776e0fe0d0$var$PATROL = [
    "autopatrol",
    "vch"
];
const $7b43ec776e0fe0d0$export$3791f69b4943680c = (integrationTypeName)=>{
    const name = String(integrationTypeName ?? "").toLowerCase();
    if ($7b43ec776e0fe0d0$var$SMTP_PUSH.includes(name) || name.includes("smtp")) return "smtp-push";
    if (name === "milestone") return "milestone";
    if ($7b43ec776e0fe0d0$var$RTSP_PULL.includes(name)) return "rtsp-pull";
    if ($7b43ec776e0fe0d0$var$VMS_PULL.includes(name)) return "vms-pull";
    if ($7b43ec776e0fe0d0$var$CLOUD_PULL.includes(name)) return "cloud-pull";
    if ($7b43ec776e0fe0d0$var$CLIPS_PUSH.includes(name)) return "clips-push";
    if ($7b43ec776e0fe0d0$var$PATROL.includes(name)) return "patrol";
    return "other";
};
const $7b43ec776e0fe0d0$export$28975b1a11f3280f = (family)=>family !== "clips-push" && family !== "patrol" && family !== "other";
const $7b43ec776e0fe0d0$export$64a2234c6534f7e9 = {
    "rtsp-pull": "RTSP",
    "vms-pull": "VMS",
    milestone: "Milestone",
    "cloud-pull": "cloud VMS",
    "smtp-push": "SMTP",
    "clips-push": "clips",
    patrol: "AutoPatrol",
    other: "other"
};

});


parcelRegister("4ysU8", function(module, exports) {

$parcel$export(module.exports, "useIsStaffUser", () => $7c2283acf216a845$export$547fdb1a73f7815f);

var $aYdit = parcelRequire("aYdit");
const $7c2283acf216a845$export$10a3cd79d19fc4b5 = (permissions)=>{
    const p = permissions;
    return Boolean(p?.internal_user ?? p?.super_user);
};
const $7c2283acf216a845$export$547fdb1a73f7815f = ()=>$7c2283acf216a845$export$10a3cd79d19fc4b5((0, $aYdit.useAppStore)((s)=>s.userPermissions));

});

parcelRegister("9sPDj", function(module, exports) {

$parcel$export(module.exports, "formatLiveElapsed", () => $b69f93af511d9822$export$40d6ebdf3953ae7d);
$parcel$export(module.exports, "useLiveTalkDown", () => $b69f93af511d9822$export$6b0912a4b804092f);
/**
 * Live push-to-talk transport (ENG-1721), the second talk-down transport
 * next to the clip upload (useTalkDown). Only reachable behind the
 * `showLiveTalkDown` flag. Talks to monitoring-api talk-down sessions:
 * START (POST), STATUS (GET) and STOP (DELETE) on
 * `streaming/talk-down/{camera_id}/[{session_id}/]`.
 *
 * Session model: the first press opens a session (mic, START, then WHIP
 * publish immediately, since the publish token is short-lived) and the
 * PeerConnection then stays open across holds. Between holds the mic track
 * is disabled (`enabled = false`): the sender keeps flowing silence frames,
 * which is what keeps the server-side Job alive (it ends a session after
 * 30 s with no frames). The sender is never stopped or removed between
 * holds. Each hold is capped at 60 s client-side.
 *
 * The client tears the session down at the earliest of: 60 s idle since the
 * last hold, unmount, camera change, page hide, or STATUS reporting
 * ended/failed (or 404, the session is gone).
 *
 * Closing: DELETE only sets stop_requested, and the Job can hold the camera
 * for up to ~20 s after it (a Job waiting for a publisher). So after any
 * teardown we initiate (errors, drops, idle, page hide) the hook polls
 * STATUS every second until ended/failed/404 (max ~25 s) and the button
 * stays disabled meanwhile. START is never retried automatically: a new
 * START only follows a new press once closing is over (ENG-1721 prod test,
 * where re-presses after a WHIP failure hit 409 three times in ~2 s).
 *
 * STATUS drives everything else: polled every second until `ready`, then
 * every ~5 s while open, then until a final state after our STOP. Audio
 * only flows once `ready`, so the first words are not lost.
 *
 * Audio input here is getUserMedia straight into the PeerConnection; this
 * hook does not use useAudioRecorder (that is the clip transport's input).
 */ 
var $8T3gX = parcelRequire("8T3gX");

var $8jTKl = parcelRequire("8jTKl");

var $8kxcc = parcelRequire("8kxcc");

var $3YgiS = parcelRequire("3YgiS");

var $iMovf = parcelRequire("iMovf");

var $kggiO = parcelRequire("kggiO");
const $b69f93af511d9822$export$602b81123731767e = {
    phase: "idle",
    message: ""
};
const $b69f93af511d9822$export$4cd18bd9aed94ee2 = "Connecting...";
const $b69f93af511d9822$export$4a0b0a133499367d = "Ready. Hold to talk.";
const $b69f93af511d9822$export$2310f13c27ed8ce5 = "Live talk-down isn't supported in this browser.";
const $b69f93af511d9822$export$f8912001dc56f5ab = "Couldn't open the live audio connection. Try again in a moment.";
const $b69f93af511d9822$export$8a22ae34495e8fad = "The camera didn't get ready to listen. Try again in a moment.";
const $b69f93af511d9822$export$74d9bd7d9ed69104 = "The live audio connection dropped. Hold to try again.";
const $b69f93af511d9822$export$73c0485a2fb46956 = "Ending...";
const $b69f93af511d9822$export$39299c5eb7fd44ab = "Still closing the last session\u2026";
const $b69f93af511d9822$export$88bfb4ec9a8d0568 = (maxSeconds)=>`Release to stop (up to ${maxSeconds} s)`;
const $b69f93af511d9822$export$a38169556544b0ca = (maxSeconds)=>`Reached the ${maxSeconds} s limit. Release, then hold to keep talking.`;
const $b69f93af511d9822$export$40d6ebdf3953ae7d = (seconds)=>{
    const s = Math.max(0, Math.floor(seconds));
    return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
};
const $b69f93af511d9822$var$MIC_CONSTRAINTS = {
    audio: {
        echoCancellation: true,
        noiseSuppression: true,
        autoGainControl: true
    }
};
const $b69f93af511d9822$var$TICK_MS = 250;
const $b69f93af511d9822$var$describeMicError = (reason)=>{
    const name = reason?.name ?? "";
    if (name === "NotAllowedError" || name === "SecurityError") return 0, $8kxcc.MIC_DENIED_MESSAGE;
    if (name === "NotFoundError" || name === "OverconstrainedError") return 0, $8kxcc.MIC_NOT_FOUND_MESSAGE;
    if (name === "NotReadableError" || name === "AbortError") return 0, $8kxcc.MIC_FAILED_MESSAGE;
    return null;
};
const $b69f93af511d9822$var$stopTracks = (stream)=>{
    stream?.getTracks().forEach((track)=>{
        try {
            track.stop();
        } catch  {
        // Already stopped.
        }
    });
};
/** Mute/unmute without touching the sender: muted still sends silence. */ const $b69f93af511d9822$var$setMicOn = (ctx, on)=>{
    ctx.stream?.getAudioTracks().forEach((track)=>{
        track.enabled = on;
    });
};
// Resolves after `ms`, or immediately once `signal` aborts.
const $b69f93af511d9822$var$wait = (ms, signal)=>new Promise((resolve)=>{
        if (signal.aborted) {
            resolve();
            return;
        }
        const done = ()=>{
            clearTimeout(timer);
            signal.removeEventListener("abort", done);
            resolve();
        };
        const timer = setTimeout(done, ms);
        signal.addEventListener("abort", done);
    });
const $b69f93af511d9822$export$6b0912a4b804092f = ({ cameraId: cameraId, cameraName: cameraName, statusPoll: statusPoll, idleMs: idleMs = (0, $8jTKl.LIVE_TALK_DOWN_IDLE_MS), whipDeps: whipDeps })=>{
    const [state, setState] = (0, $8T3gX.useState)($b69f93af511d9822$export$602b81123731767e);
    const [elapsedSeconds, setElapsedSeconds] = (0, $8T3gX.useState)(0);
    const [maxSeconds, setMaxSeconds] = (0, $8T3gX.useState)((0, $8jTKl.LIVE_TALK_DOWN_MAX_SECONDS));
    // Inputs read from timers and async continuations.
    const inputsRef = (0, $8T3gX.useRef)({
        cameraId: cameraId,
        cameraName: cameraName,
        statusPoll: statusPoll,
        idleMs: idleMs,
        whipDeps: whipDeps
    });
    inputsRef.current = {
        cameraId: cameraId,
        cameraName: cameraName,
        statusPoll: statusPoll,
        idleMs: idleMs,
        whipDeps: whipDeps
    };
    const ctxRef = (0, $8T3gX.useRef)(null);
    const heldRef = (0, $8T3gX.useRef)(false);
    const capHitRef = (0, $8T3gX.useRef)(false);
    const maxSecondsRef = (0, $8T3gX.useRef)((0, $8jTKl.LIVE_TALK_DOWN_MAX_SECONDS));
    const tickRef = (0, $8T3gX.useRef)(null);
    const idleRef = (0, $8T3gX.useRef)(null);
    const outcomeAbortRef = (0, $8T3gX.useRef)(null);
    const unmountedRef = (0, $8T3gX.useRef)(false);
    /** Our last session on this camera, and when it was last known alive. */ const lastSessionRef = (0, $8T3gX.useRef)();
    const clearTick = ()=>{
        if (tickRef.current) clearInterval(tickRef.current);
        tickRef.current = null;
    };
    const clearIdle = ()=>{
        if (idleRef.current) clearTimeout(idleRef.current);
        idleRef.current = null;
    };
    const cancelOutcome = ()=>{
        outcomeAbortRef.current?.abort();
        outcomeAbortRef.current = null;
    };
    const showOutcome = (camId, status)=>{
        const outcome = (0, $8jTKl.describeLiveTalkDownOutcome)(status, inputsRef.current.cameraName);
        setState({
            phase: outcome.ok ? "ended" : "failed",
            message: outcome.message,
            detail: outcome.ok ? undefined : (0, $8jTKl.describeLiveTalkDownOutcomeDetail)(status)
        });
        // ENG-1721: a camera without a speaker hides its button for the rest
        // of the page session. Last: it can unmount this control.
        (0, $kggiO.noteTalkDownErrorCode)(camId, status?.error_code);
    };
    const noteSession = (camId)=>{
        lastSessionRef.current = {
            cameraId: camId,
            at: Date.now()
        };
    };
    /**
   * After our STOP: poll STATUS (every ~1 s, up to ~25 s) until the session
   * is ended/failed/gone, showing `pending` meanwhile. While this runs
   * `outcomeAbortRef` is set, which blocks press(). Never starts anything.
   */ const closeOut = (camId, sessionId, pending, finish)=>{
        cancelOutcome();
        const controller = new AbortController();
        outcomeAbortRef.current = controller;
        const current = ()=>outcomeAbortRef.current === controller && !controller.signal.aborted;
        const opts = inputsRef.current.statusPoll;
        setState(pending);
        (0, $8jTKl.pollLiveTalkDownOutcome)(camId, sessionId, {
            intervalMs: opts?.outcomeIntervalMs ?? (0, $8jTKl.LIVE_TALK_DOWN_OUTCOME_INTERVAL_MS),
            timeoutMs: opts?.outcomeTimeoutMs ?? (0, $8jTKl.LIVE_TALK_DOWN_OUTCOME_TIMEOUT_MS),
            signal: controller.signal
        }).then((result)=>{
            if (!current() || result.kind === "aborted") return;
            outcomeAbortRef.current = null;
            noteSession(camId);
            finish(result);
        });
    };
    /** After our STOP of a session that was used: show its final state. */ const fetchOutcome = (camId, sessionId)=>{
        closeOut(camId, sessionId, {
            phase: "waiting",
            message: $b69f93af511d9822$export$73c0485a2fb46956
        }, (result)=>{
            if (result.kind === "timeout") {
                setState({
                    phase: "ended",
                    message: (0, $8jTKl.LIVE_TALK_DOWN_ENDED_MESSAGE)
                });
                return;
            }
            showOutcome(camId, result.status);
        });
    };
    /** After our STOP: show "Still closing…" until it is gone, then `after`. */ const waitForClose = (camId, sessionId, after)=>{
        closeOut(camId, sessionId, {
            phase: "closing",
            message: $b69f93af511d9822$export$39299c5eb7fd44ab
        }, ()=>setState(after));
    };
    const teardown = (reason, detail = {})=>{
        const ctx = ctxRef.current;
        if (!ctx || ctx.closed) return;
        ctx.closed = true;
        ctxRef.current = null;
        clearTick();
        clearIdle();
        ctx.abort.abort();
        $b69f93af511d9822$var$stopTracks(ctx.stream);
        try {
            ctx.pc?.close();
        } catch  {
        // Already closed.
        }
        if (ctx.resourceUrl) (0, $3YgiS.whipDelete)(ctx.resourceUrl, inputsRef.current.whipDeps);
        if (ctx.session) noteSession(ctx.cameraId);
        // The server already ended a "server" session; everything else asks it.
        // On unmount the DELETEs are all we do: nobody is left to poll for.
        if (ctx.session && reason !== "server") (0, $8jTKl.stopLiveTalkDown)(ctx.cameraId, ctx.session.session_id).catch(()=>{
        // Best effort: the Job also ends when the WHIP session ends.
        });
        if (reason === "unmount" || unmountedRef.current) return;
        setElapsedSeconds(0);
        // Sessions we asked to stop still hold the camera for a while: wait
        // for them to finish before another START is allowed.
        const sessionId = ctx.session && reason !== "server" ? ctx.session.session_id : null;
        const settle = (after)=>{
            if (sessionId) waitForClose(ctx.cameraId, sessionId, after);
            else setState(after);
        };
        switch(reason){
            case "server":
                showOutcome(ctx.cameraId, detail.status ?? null);
                return;
            case "error":
                settle({
                    phase: "error",
                    message: detail.message ?? $b69f93af511d9822$export$f8912001dc56f5ab,
                    detail: detail.detail
                });
                return;
            case "dropped":
                settle({
                    phase: "error",
                    message: ctx.ready ? $b69f93af511d9822$export$74d9bd7d9ed69104 : $b69f93af511d9822$export$f8912001dc56f5ab
                });
                return;
            case "idle":
            case "hidden":
                if (ctx.everLive && sessionId) {
                    fetchOutcome(ctx.cameraId, sessionId);
                    return;
                }
                settle($b69f93af511d9822$export$602b81123731767e);
                return;
            default:
                // "camera" / "reset": the caller resets the state itself.
                setState($b69f93af511d9822$export$602b81123731767e);
        }
    };
    const armIdle = ()=>{
        clearIdle();
        idleRef.current = setTimeout(()=>{
            idleRef.current = null;
            fnRef.current.teardown("idle");
        }, inputsRef.current.idleMs);
    };
    const beginHold = (ctx)=>{
        clearIdle();
        clearTick();
        ctx.everLive = true;
        $b69f93af511d9822$var$setMicOn(ctx, true);
        const max = maxSecondsRef.current;
        const startedAt = Date.now();
        setElapsedSeconds(0);
        setState({
            phase: "live",
            message: $b69f93af511d9822$export$88bfb4ec9a8d0568(max)
        });
        tickRef.current = setInterval(()=>{
            const elapsed = Math.floor((Date.now() - startedAt) / 1000);
            setElapsedSeconds(elapsed);
            if (elapsed >= max) {
                capHitRef.current = true;
                fnRef.current.endHold($b69f93af511d9822$export$a38169556544b0ca(max));
            }
        }, $b69f93af511d9822$var$TICK_MS);
    };
    const endHold = (message = $b69f93af511d9822$export$4a0b0a133499367d)=>{
        clearTick();
        const ctx = ctxRef.current;
        if (!ctx) return;
        $b69f93af511d9822$var$setMicOn(ctx, false);
        setElapsedSeconds(0);
        setState({
            phase: "open",
            message: message
        });
        armIdle();
    };
    const markReady = (ctx)=>{
        if (ctx.ready || ctx.closed) return;
        ctx.ready = true;
        if (heldRef.current && !capHitRef.current) beginHold(ctx);
        else {
            setState({
                phase: "open",
                message: $b69f93af511d9822$export$4a0b0a133499367d
            });
            armIdle();
        }
    };
    const onPcState = (ctx, pcState)=>{
        if (ctxRef.current !== ctx || ctx.closed) return;
        if (pcState === "failed" || pcState === "closed") teardown("dropped");
    };
    /**
   * STATUS loop for an open session: every second until ready, then every
   * ~5 s. Ends the session when the server reports ended/failed or 404.
   * Transient errors keep polling.
   */ const statusLoop = async (ctx, session)=>{
        const alive = ()=>ctxRef.current === ctx && !ctx.closed;
        const opts = inputsRef.current.statusPoll;
        const readyIntervalMs = opts?.readyIntervalMs ?? (0, $8jTKl.LIVE_TALK_DOWN_READY_INTERVAL_MS);
        const openIntervalMs = opts?.openIntervalMs ?? (0, $8jTKl.LIVE_TALK_DOWN_OPEN_INTERVAL_MS);
        const readyTimeoutMs = opts?.readyTimeoutMs ?? (0, $8jTKl.LIVE_TALK_DOWN_READY_TIMEOUT_MS);
        const startedAt = Date.now();
        while(alive()){
            let status;
            try {
                status = await (0, $8jTKl.fetchLiveTalkDownStatus)(ctx.cameraId, session.session_id, ctx.abort.signal);
            } catch  {
                status = undefined; // transient: try again
            }
            if (!alive()) return;
            if (status !== undefined && (0, $8jTKl.isLiveTalkDownFinished)(status)) {
                fnRef.current.teardown("server", {
                    status: status
                });
                return;
            }
            if (status && (status.ready || status.status === "ready")) fnRef.current.markReady(ctx);
            if (!ctx.ready && Date.now() - startedAt >= readyTimeoutMs) {
                fnRef.current.teardown("error", {
                    message: $b69f93af511d9822$export$8a22ae34495e8fad
                });
                return;
            }
            await $b69f93af511d9822$var$wait(ctx.ready ? openIntervalMs : readyIntervalMs, ctx.abort.signal);
        }
    };
    const openSession = async (camId)=>{
        const ctx = {
            cameraId: camId,
            session: null,
            stream: null,
            pc: null,
            resourceUrl: null,
            ready: false,
            everLive: false,
            closed: false,
            abort: new AbortController()
        };
        ctxRef.current = ctx;
        const alive = ()=>ctxRef.current === ctx && !ctx.closed;
        setState({
            phase: "connecting",
            message: $b69f93af511d9822$export$4cd18bd9aed94ee2
        });
        try {
            const hasWebRtc = typeof window !== "undefined" && (typeof window.RTCPeerConnection === "function" || Boolean(inputsRef.current.whipDeps?.createPeerConnection));
            if (!navigator.mediaDevices?.getUserMedia || !hasWebRtc) {
                teardown("error", {
                    message: $b69f93af511d9822$export$2310f13c27ed8ce5
                });
                return;
            }
            // Mic first: a denied mic should not open a session on the camera.
            const stream = await navigator.mediaDevices.getUserMedia($b69f93af511d9822$var$MIC_CONSTRAINTS);
            if (!alive()) {
                $b69f93af511d9822$var$stopTracks(stream);
                return;
            }
            ctx.stream = stream;
            $b69f93af511d9822$var$setMicOn(ctx, false);
            const session = await (0, $8jTKl.startLiveTalkDown)(camId);
            if (!alive()) {
                (0, $8jTKl.stopLiveTalkDown)(camId, session.session_id).catch(()=>{});
                return;
            }
            ctx.session = session;
            // Client per-hold cap; the server's max_seconds is the whole session.
            const max = typeof session.max_seconds === "number" && session.max_seconds > 0 ? Math.min((0, $8jTKl.LIVE_TALK_DOWN_MAX_SECONDS), session.max_seconds) : (0, $8jTKl.LIVE_TALK_DOWN_MAX_SECONDS);
            maxSecondsRef.current = max;
            setMaxSeconds(max);
            // Publish straight away: the WHIP token lives 120 s.
            const publication = await (0, $3YgiS.whipPublish)({
                whipUrl: session.whip_url,
                stream: stream,
                onConnectionStateChange: (s)=>fnRef.current.onPcState(ctx, s),
                signal: ctx.abort.signal
            }, inputsRef.current.whipDeps);
            if (!alive()) {
                publication.pc.close();
                if (publication.resourceUrl) (0, $3YgiS.whipDelete)(publication.resourceUrl, inputsRef.current.whipDeps);
                return;
            }
            ctx.pc = publication.pc;
            ctx.resourceUrl = publication.resourceUrl;
            statusLoop(ctx, session);
        } catch (reason) {
            if (!alive() || reason instanceof (0, $3YgiS.WhipAbortedError)) return;
            // 409 right after our own session on this camera: that session is
            // still shutting down. Say so; never retry START on our own.
            const recent = lastSessionRef.current;
            if (!ctx.session && (0, $8jTKl.isTalkDownInProgress)(reason) && recent && String(recent.cameraId) === String(camId) && Date.now() - recent.at < (0, $8jTKl.LIVE_TALK_DOWN_RECENT_SESSION_MS)) {
                teardown("error", {
                    message: $b69f93af511d9822$export$39299c5eb7fd44ab
                });
                return;
            }
            const message = $b69f93af511d9822$var$describeMicError(reason) ?? (reason instanceof (0, $3YgiS.WhipError) ? reason.stage === "unsupported" ? $b69f93af511d9822$export$2310f13c27ed8ce5 : $b69f93af511d9822$export$f8912001dc56f5ab : (0, $8jTKl.describeLiveTalkDownStartError)(reason));
            const detail = reason instanceof (0, $3YgiS.WhipError) ? `WHIP ${reason.stage}${reason.status ? ` ${reason.status}` : ""}` : $b69f93af511d9822$var$describeMicError(reason) ? `getUserMedia ${reason?.name ?? "error"}` : (0, $8jTKl.describeTalkDownErrorDetail)(reason, (0, $8jTKl.TALK_DOWN_LIVE_ENDPOINT_LABEL));
            teardown("error", {
                message: message,
                detail: detail
            });
        }
    };
    const press = ()=>{
        const camId = inputsRef.current.cameraId;
        if (camId == null || camId === "") return;
        // Outcome still being fetched / last session still closing.
        if (outcomeAbortRef.current) return;
        heldRef.current = true;
        capHitRef.current = false;
        clearIdle();
        const ctx = ctxRef.current;
        if (ctx && !ctx.closed) {
            if (ctx.ready) beginHold(ctx);
            else setState({
                phase: "connecting",
                message: $b69f93af511d9822$export$4cd18bd9aed94ee2
            });
            return;
        }
        openSession(camId);
    };
    const release = ()=>{
        if (!heldRef.current) return;
        heldRef.current = false;
        const wasCapped = capHitRef.current;
        capHitRef.current = false;
        const ctx = ctxRef.current;
        if (!ctx || ctx.closed) return;
        if (ctx.ready) {
            if (wasCapped) {
                // Already silenced at the cap; the idle clock is already running.
                setState({
                    phase: "open",
                    message: $b69f93af511d9822$export$4a0b0a133499367d
                });
                return;
            }
            endHold();
        } else // Still connecting: keep going so the next hold is instant, but the
        // idle clock starts now.
        armIdle();
    };
    const reset = ()=>{
        cancelOutcome();
        heldRef.current = false;
        teardown("reset");
        setState($b69f93af511d9822$export$602b81123731767e);
    };
    // Timers, effects and async continuations call through this ref so they
    // always reach the latest closures.
    const fnRef = (0, $8T3gX.useRef)({
        teardown: teardown,
        endHold: endHold,
        markReady: markReady,
        onPcState: onPcState,
        press: press,
        release: release,
        reset: reset
    });
    fnRef.current = {
        teardown: teardown,
        endHold: endHold,
        markReady: markReady,
        onPcState: onPcState,
        press: press,
        release: release,
        reset: reset
    };
    // A new camera ends any session (and outcome) that belongs to the old one.
    (0, $8T3gX.useEffect)(()=>{
        fnRef.current.teardown("camera");
        outcomeAbortRef.current?.abort();
        outcomeAbortRef.current = null;
        heldRef.current = false;
        setState($b69f93af511d9822$export$602b81123731767e);
        setElapsedSeconds(0);
    }, [
        cameraId
    ]);
    // Half-duplex with listen-in (ENG-2136): while the operator holds to talk
    // (or has pressed and the session is still connecting), tell the live
    // players to mute this camera's audio so the mic doesn't hear itself back.
    const holdKeyRef = (0, $8T3gX.useRef)();
    if (!holdKeyRef.current) holdKeyRef.current = `talk-${Math.random().toString(36).slice(2)}`;
    const talking = state.phase === "live" || state.phase === "connecting";
    (0, $8T3gX.useEffect)(()=>{
        const key = holdKeyRef.current;
        const { setHold: setHold } = (0, $iMovf.useTalkingCamerasStore).getState();
        setHold(key, talking && cameraId != null && cameraId !== "" ? String(cameraId) : null);
    }, [
        talking,
        cameraId
    ]);
    (0, $8T3gX.useEffect)(()=>()=>{
            (0, $iMovf.useTalkingCamerasStore).getState().setHold(holdKeyRef.current, null);
        }, []);
    // Page hidden (tab switch, minimise, navigation away): end the session.
    (0, $8T3gX.useEffect)(()=>{
        const onVisibility = ()=>{
            if (document.visibilityState === "hidden") fnRef.current.teardown("hidden");
        };
        const onPageHide = ()=>fnRef.current.teardown("hidden");
        document.addEventListener("visibilitychange", onVisibility);
        window.addEventListener("pagehide", onPageHide);
        return ()=>{
            document.removeEventListener("visibilitychange", onVisibility);
            window.removeEventListener("pagehide", onPageHide);
        };
    }, []);
    (0, $8T3gX.useEffect)(()=>{
        unmountedRef.current = false;
        return ()=>{
            unmountedRef.current = true;
            outcomeAbortRef.current?.abort();
            outcomeAbortRef.current = null;
            fnRef.current.teardown("unmount");
        };
    }, []);
    return {
        state: state,
        elapsedSeconds: elapsedSeconds,
        maxSeconds: maxSeconds,
        busy: state.phase === "waiting" || state.phase === "closing",
        press: (0, $8T3gX.useCallback)(()=>fnRef.current.press(), []),
        release: (0, $8T3gX.useCallback)(()=>fnRef.current.release(), []),
        reset: (0, $8T3gX.useCallback)(()=>fnRef.current.reset(), [])
    };
};

});
parcelRegister("3YgiS", function(module, exports) {

$parcel$export(module.exports, "WhipError", () => $bf2658c70ef7a719$export$e9f14527d7573628);
$parcel$export(module.exports, "WhipAbortedError", () => $bf2658c70ef7a719$export$112ea8cc78d95441);
$parcel$export(module.exports, "whipPublish", () => $bf2658c70ef7a719$export$39f75d6a25cdb0aa);
$parcel$export(module.exports, "whipDelete", () => $bf2658c70ef7a719$export$d608947546dfd7de);
/**
 * Pure WHIP publish helper for live talk-down (ENG-1721). Mirrors the live
 * player's WHEP exchange (useWhepLiveStream.playWhep): one offer, wait for
 * ICE gathering (no trickle), POST the SDP, apply the answer. Differences:
 * one sendonly audio transceiver (Opus preferred), no 404 cold-start retry
 * (the browser is the publisher, so there is nothing to wait for), and the
 * `Location` header is kept so the resource can be DELETEd.
 *
 * `fetch` and the RTCPeerConnection constructor are injectable for tests.
 * The WHIP URL already carries `?jwt=<token>` (same as the WHEP player), so
 * no Authorization header is sent.
 */ class $bf2658c70ef7a719$export$e9f14527d7573628 extends Error {
    constructor(stage, message, status){
        super(message);
        this.name = "WhipError";
        this.stage = stage;
        this.status = status;
    }
}
class $bf2658c70ef7a719$export$112ea8cc78d95441 extends Error {
    constructor(){
        super("WHIP publish aborted");
        this.name = "WhipAbortedError";
    }
}
// Resolved per call, so a test (or a polyfill) can install it late.
const $bf2658c70ef7a719$var$globalFetch = (input, init)=>fetch(input, init);
const $bf2658c70ef7a719$var$defaultCreatePeerConnection = (config)=>{
    const Ctor = typeof window !== "undefined" ? window.RTCPeerConnection : undefined;
    if (!Ctor) throw new $bf2658c70ef7a719$export$e9f14527d7573628("unsupported", "WebRTC is not supported");
    return new Ctor(config);
};
const $bf2658c70ef7a719$export$c0be70a43d20bc7b = (pc, timeoutMs = 3000)=>new Promise((resolve)=>{
        if (pc.iceGatheringState === "complete") {
            resolve();
            return;
        }
        let timer = null;
        const onState = ()=>{
            if (pc.iceGatheringState === "complete") done();
        };
        const done = ()=>{
            if (timer) clearTimeout(timer);
            pc.removeEventListener("icegatheringstatechange", onState);
            resolve();
        };
        pc.addEventListener("icegatheringstatechange", onState);
        timer = setTimeout(done, timeoutMs);
    });
const $bf2658c70ef7a719$export$5366bc12cbb5543c = (transceiver)=>{
    try {
        const Sender = typeof window !== "undefined" ? window.RTCRtpSender : undefined;
        const codecs = Sender?.getCapabilities?.("audio")?.codecs;
        if (!codecs?.length || !transceiver.setCodecPreferences) return;
        const isOpus = (c)=>c.mimeType.toLowerCase() === "audio/opus";
        const ordered = [
            ...codecs.filter(isOpus),
            ...codecs.filter((c)=>!isOpus(c))
        ];
        transceiver.setCodecPreferences(ordered);
    } catch  {
    // Codec ordering is a preference; MediaMTX negotiates Opus anyway.
    }
};
const $bf2658c70ef7a719$var$resolveLocation = (location, base)=>{
    if (!location) return null;
    try {
        return new URL(location, base).toString();
    } catch  {
        return location;
    }
};
const $bf2658c70ef7a719$export$39f75d6a25cdb0aa = async (options, deps = {})=>{
    const fetchImpl = deps.fetch ?? $bf2658c70ef7a719$var$globalFetch;
    const createPc = deps.createPeerConnection ?? $bf2658c70ef7a719$var$defaultCreatePeerConnection;
    const { whipUrl: whipUrl, stream: stream, iceServers: iceServers, onConnectionStateChange: onConnectionStateChange, signal: signal } = options;
    const pc = createPc(iceServers?.length ? {
        iceServers: iceServers
    } : undefined);
    const fail = (error)=>{
        try {
            pc.close();
        } catch  {
        // Already closed.
        }
        throw error;
    };
    const checkAborted = ()=>{
        if (signal?.aborted) fail(new $bf2658c70ef7a719$export$112ea8cc78d95441());
    };
    pc.onconnectionstatechange = ()=>{
        onConnectionStateChange?.(pc.connectionState);
    };
    let offerSdp;
    try {
        const track = stream.getAudioTracks()[0];
        if (!track) throw new Error("No audio track");
        const transceiver = pc.addTransceiver(track, {
            direction: "sendonly",
            streams: [
                stream
            ]
        });
        $bf2658c70ef7a719$export$5366bc12cbb5543c(transceiver);
        const offer = await pc.createOffer();
        checkAborted();
        await pc.setLocalDescription(offer);
        await $bf2658c70ef7a719$export$c0be70a43d20bc7b(pc, deps.iceGatheringTimeoutMs ?? 3000);
        checkAborted();
        offerSdp = pc.localDescription?.sdp ?? offer.sdp ?? "";
    } catch (reason) {
        if (reason instanceof $bf2658c70ef7a719$export$112ea8cc78d95441) throw reason;
        return fail(new $bf2658c70ef7a719$export$e9f14527d7573628("offer", "Couldn't create the audio offer"));
    }
    let response;
    try {
        response = await fetchImpl(whipUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/sdp"
            },
            body: offerSdp,
            signal: signal
        });
    } catch  {
        checkAborted();
        return fail(new $bf2658c70ef7a719$export$e9f14527d7573628("post", "Couldn't reach the audio relay"));
    }
    checkAborted();
    if (!response.ok) return fail(new $bf2658c70ef7a719$export$e9f14527d7573628("post", `The audio relay refused the stream (${response.status})`, response.status));
    const resourceUrl = $bf2658c70ef7a719$var$resolveLocation(response.headers?.get?.("Location") ?? null, whipUrl);
    try {
        const answerSdp = await response.text();
        checkAborted();
        await pc.setRemoteDescription({
            type: "answer",
            sdp: answerSdp
        });
    } catch (reason) {
        if (reason instanceof $bf2658c70ef7a719$export$112ea8cc78d95441) {
            // The relay already holds a resource for this offer: free it.
            if (resourceUrl) $bf2658c70ef7a719$export$d608947546dfd7de(resourceUrl, deps);
            throw reason;
        }
        if (resourceUrl) $bf2658c70ef7a719$export$d608947546dfd7de(resourceUrl, deps);
        return fail(new $bf2658c70ef7a719$export$e9f14527d7573628("answer", "The audio relay's answer was bad"));
    }
    return {
        pc: pc,
        resourceUrl: resourceUrl
    };
};
const $bf2658c70ef7a719$export$d608947546dfd7de = async (resourceUrl, deps = {})=>{
    const fetchImpl = deps.fetch ?? $bf2658c70ef7a719$var$globalFetch;
    try {
        await fetchImpl(resourceUrl, {
            method: "DELETE"
        });
    } catch  {
    // The relay reaps the session when the peer connection closes anyway.
    }
};

});

parcelRegister("iMovf", function(module, exports) {

$parcel$export(module.exports, "useTalkingCamerasStore", () => $643ba239eb997d32$export$151c17a9a6aacc37);
$parcel$export(module.exports, "useIsTalkingToCamera", () => $643ba239eb997d32$export$d0641e2dd21b31ee);
/**
 * Which cameras an operator is talking to right now (ENG-2136 half-duplex).
 *
 * The live talk-down hook (useLiveTalkDown) registers a hold here while the
 * push-to-talk button is pressed; the live players read it to force that
 * camera's audio muted so the operator never hears themselves back through
 * the camera's microphone. Keyed by hook instance so two talk-down controls
 * can never clear each other's hold.
 */ 
var $9OjAn = parcelRequire("9OjAn");
const $643ba239eb997d32$export$151c17a9a6aacc37 = (0, $9OjAn.create)((set)=>({
        holds: {},
        setHold: (key, cameraId)=>set((state)=>{
                if (cameraId == null) {
                    if (!(key in state.holds)) return state;
                    const next = {
                        ...state.holds
                    };
                    delete next[key];
                    return {
                        holds: next
                    };
                }
                if (state.holds[key] === cameraId) return state;
                return {
                    holds: {
                        ...state.holds,
                        [key]: cameraId
                    }
                };
            })
    }));
const $643ba239eb997d32$export$d0641e2dd21b31ee = (cameraId)=>$643ba239eb997d32$export$151c17a9a6aacc37((state)=>cameraId == null || cameraId === "" ? false : Object.values(state.holds).includes(String(cameraId)));

});




parcelRegister("j7HO3", function(module, exports) {

$parcel$export(module.exports, "DeleteCameraCheckDialog", () => $197d0095bbee1668$export$e78290c9db264939);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $iLEpm = parcelRequire("iLEpm");

var $ce8iU = parcelRequire("ce8iU");

var $c2hgk = parcelRequire("c2hgk");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $197d0095bbee1668$export$e78290c9db264939 = ({ selected: selected, deleteDialogOpen: deleteDialogOpen, setDeleteDialogOpen: setDeleteDialogOpen, setSiteCameras: setSiteCameras, setAlertState: setAlertState, setSelected: setSelected, setSyncNeeded: setSyncNeeded, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn })=>{
    const navigate = (0, $3T949.useNavigate)();
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: deleteDialogOpen,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: [
            selected.length <= 1 ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                sx: {
                    fontFamily: "mulish"
                },
                children: " Are you sure you want to delete this camera?"
            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                sx: {
                    fontFamily: "mulish"
                },
                children: " Are you sure you want to delete these cameras?"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                        sx: {
                            fontFamily: "mulish"
                        },
                        children: "Once deleted this action can't be undone."
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $iLEpm.default), {
                        sx: {
                            fontFamily: "mulish"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("strong", {
                                children: "PLEASE NOTE:"
                            }),
                            " cameras that are deleted from Actuate's systems and then re-added may result in unwanted discrepancies in Actuate's billing records. To avoid this, please follow the troubleshooting procedures on our support page and contact support@actuate.ai for additional assistance."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setDeleteDialogOpen(false);
                            setSyncNeeded(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setBackdropLoadingScreenOn(true);
                            setDeleteDialogOpen(false);
                            (0, $c2hgk.handleDeleteCamera)(selected, setSiteCameras, setAlertState, setSelected, setSyncNeeded, navigate, setBackdropLoadingScreenOn);
                        },
                        text: "Delete",
                        disabled: false
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("c2hgk", function(module, exports) {

$parcel$export(module.exports, "handleDeleteCamera", () => $763962754b66d04b$export$db93c9646c6eb51e);

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("elyck");
var $h5bv8 = parcelRequire("h5bv8");
const $763962754b66d04b$export$db93c9646c6eb51e = async (selected, setSiteCameras, setAlertState, setSelected, setSyncNeeded, navigate, setBackdropLoadingScreenOn)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $763962754b66d04b$export$db93c9646c6eb51e(selected, setSiteCameras, setAlertState, setSelected, setSyncNeeded, navigate, setBackdropLoadingScreenOn);
    };
    await selected.forEach(async (id)=>{
        let deleteCameraFail = false;
        await AxiosUI.delete(`camera/${id}`).then(()=>{
            deleteCameraFail = false;
        }, (reason)=>{
            deleteCameraFail = true;
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
        });
        !deleteCameraFail && await AxiosUI.get(`camera/site/?customer__id=${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}`).then((response)=>{
            localStorage.setItem("siteCameras", JSON.stringify(response.data));
            setSiteCameras(response.data);
            setAlertState((previousState)=>{
                return {
                    ...previousState,
                    changeSuccess: false,
                    activateSuccess: false,
                    deactivateSuccess: false,
                    disarmSuccess: false,
                    armSuccess: false,
                    syncSuccess: false,
                    cameraDeleteSuccess: true,
                    armFail: false
                };
            });
            setSelected([]);
            setSyncNeeded(true);
            setBackdropLoadingScreenOn(false);
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
        });
    });
};

});



parcelRegister("lFMkK", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc72eb609dd2da96$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $fc72eb609dd2da96$var$_default = module.exports.default = (0, $fc72eb609dd2da96$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 16H5V10h14zM9 14H7v-2h2zm4 0h-2v-2h2zm4 0h-2v-2h2zm-8 4H7v-2h2zm4 0h-2v-2h2zm4 0h-2v-2h2z"
}), 'CalendarMonth');

});

parcelRegister("hlCsX", function(module, exports) {

$parcel$export(module.exports, "TabsComponet", () => $9c99dbaaa61dc0cf$export$a19b00dd6aeb027f);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");

var $3n3uW = parcelRequire("3n3uW");

var $2suvB = parcelRequire("2suvB");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

var $8DcvM = parcelRequire("8DcvM");

var $3FJ79 = parcelRequire("3FJ79");

var $7l43O = parcelRequire("7l43O");

var $2bi6M = parcelRequire("2bi6M");
const $9c99dbaaa61dc0cf$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $9c99dbaaa61dc0cf$export$a19b00dd6aeb027f = ({ clickedTab: clickedTab, setClickedTab: setClickedTab, editMode: editMode, setActiveTab: setActiveTab, setPatchObject: setPatchObject, setSiteInfo: setSiteInfo, vmsVariables: vmsVariables, setVmsVariables: setVmsVariables, siteSchedules: siteSchedules, siteInfo: siteInfo, setSiteSchedules: setSiteSchedules, setSchedulesTabActive: setSchedulesTabActive, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setAlertState: setAlertState, setSyncNeeded: setSyncNeeded, setSiteInfoChangesMade: setSiteInfoChangesMade, setScheduleChangesMade: setScheduleChangesMade, setDeleteScheduleDialogOpen: setDeleteScheduleDialogOpen, recordingServerData: recordingServerData, recordingServerPatchObject: recordingServerPatchObject, setRecordingServerPatchObject: setRecordingServerPatchObject, setRecordingServerChangesMade: setRecordingServerChangesMade, recordingServerVisible: recordingServerVisible, healthCheckData: healthCheckData, setCameraHealthPatchObject: setCameraHealthPatchObject, setCameraHealthChangesMade: setCameraHealthChangesMade, setAddCameraHealthDialogOpen: setAddCameraHealthDialogOpen, setTurnOffHealthDialogOpen: setTurnOffHealthDialogOpen, webhooksInfo: webhooksInfo, setWebhooksPatchObject: setWebhooksPatchObject, setWebhooksChangesMade: setWebhooksChangesMade, setEditMode: setEditMode, showWireguardTab: showWireguardTab, wireguardTunnels: wireguardTunnels, wireguardTunnelsLoading: wireguardTunnelsLoading, selectedWireguardTunnelId: selectedWireguardTunnelId, setSelectedWireguardTunnelId: setSelectedWireguardTunnelId, onWireGuardSessionUpdate: onWireGuardSessionUpdate, setWireguardChangesMade: setWireguardChangesMade, showDoubleTakeTab: showDoubleTakeTab = false })=>{
    const { evalinkSite: evalinkSite } = (0, $3FJ79.useSiteAboutStore)();
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
        sx: {
            width: "100%"
        },
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
            theme: $9c99dbaaa61dc0cf$var$theme,
            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3n3uW.default), {
                value: clickedTab,
                onChange: (event, newValue)=>(0, $8DcvM.handleClickedTabChange)(event, newValue, setClickedTab, editMode, setActiveTab, setPatchObject, setSiteInfo, vmsVariables, setVmsVariables, siteSchedules, siteInfo, setSiteSchedules, setSchedulesTabActive, setBackdropLoadingScreenOn, setAlertState, setSyncNeeded, setSiteInfoChangesMade, setScheduleChangesMade, setDeleteScheduleDialogOpen, recordingServerData, recordingServerPatchObject, setRecordingServerPatchObject, setRecordingServerChangesMade, healthCheckData, setCameraHealthPatchObject, setCameraHealthChangesMade, setAddCameraHealthDialogOpen, setTurnOffHealthDialogOpen, webhooksInfo, setWebhooksPatchObject, setWebhooksChangesMade, setEditMode, showWireguardTab, wireguardTunnels, wireguardTunnelsLoading, selectedWireguardTunnelId, setSelectedWireguardTunnelId, onWireGuardSessionUpdate, setWireguardChangesMade),
                "aria-label": "tabs",
                color: "primary",
                children: [
                    siteInfo.integration_type_name === "autopatrol" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                        value: "three",
                        label: "Schedule Info",
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold",
                            color: "primary"
                        }
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                        value: "one",
                        label: siteInfo.integration_type_name === "autopatrol" ? "General Site Info" : "General Info",
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold",
                            color: "primary"
                        }
                    }),
                    Boolean(siteInfo.display_schedule) === true && siteInfo.integration_type_name !== "autopatrol" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                        value: "three",
                        label: "Schedules",
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold",
                            color: "primary"
                        }
                    }),
                    localStorage.SMTPSite === "true" && siteInfo.integration_type_name === "SMTP_per_camera" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                        value: "four",
                        label: "SMTP Settings",
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold",
                            color: "primary"
                        }
                    }),
                    recordingServerVisible && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                        value: "five",
                        label: "Recording Servers",
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold",
                            color: "primary"
                        }
                    }),
                    siteInfo.chm && siteInfo.integration_type_name !== "autopatrol" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                        value: "six",
                        label: "Camera Health",
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold",
                            color: "primary"
                        }
                    }),
                    (0, $7l43O.shouldShowWebhooksTab)(siteInfo, webhooksInfo) && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                        value: "seven",
                        label: "Webhooks",
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold",
                            color: "primary"
                        }
                    }),
                    evalinkSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                        value: "eight",
                        label: "Evalink",
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold",
                            color: "primary"
                        }
                    }),
                    showWireguardTab && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                        value: "nine",
                        label: "WireGuard",
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold",
                            color: "primary"
                        }
                    }),
                    showDoubleTakeTab && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                        value: (0, $2bi6M.DOUBLE_TAKE_TAB),
                        label: "DoubleTake",
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold",
                            color: "primary"
                        }
                    })
                ]
            })
        })
    });
};

});
parcelRegister("8DcvM", function(module, exports) {

$parcel$export(module.exports, "handleClickedTabChange", () => $606c201fd11f569d$export$61689cf494306943);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $1Ah5f = parcelRequire("1Ah5f");

var $kMcJt = parcelRequire("kMcJt");

var $1W2ma = parcelRequire("1W2ma");

var $2uQ4j = parcelRequire("2uQ4j");

var $iTHZG = parcelRequire("iTHZG");

var $7isVd = parcelRequire("7isVd");

var $4ajRU = parcelRequire("4ajRU");

var $ivt1T = parcelRequire("ivt1T");

var $islbW = parcelRequire("islbW");

var $iE9hz = parcelRequire("iE9hz");

var $iXV9W = parcelRequire("iXV9W");

var $lbXkF = parcelRequire("lbXkF");

var $f7Odp = parcelRequire("f7Odp");

var $2wmRq = parcelRequire("2wmRq");

var $4k3Fk = parcelRequire("4k3Fk");

var $c6iZU = parcelRequire("c6iZU");

var $2bi6M = parcelRequire("2bi6M");
const $606c201fd11f569d$export$61689cf494306943 = (event, newValue, setClickedTab, editMode, setActiveTab, setPatchObject, setSiteInfo, vmsVariables, setVmsVariables, siteSchedules, siteInfo, setSiteSchedules, setSchedulesTabActive, setBackdropLoadingScreenOn, setAlertState, setSyncNeeded, setSiteInfoChangesMade, setScheduleChangesMade, setDeleteScheduleDialogOpen, recordingServerData, recordingServerPatchObject, setRecordingServerPatchObject, setRecordingServerChangesMade, healthCheckData, setCameraHealthPatchObject, setCameraHealthChangesMade, setAddCameraHealthDialogOpen, setTurnOffHealthDialogOpen, webhooksInfo, setWebhooksPatchObject, setWebhooksChangesMade, setEditMode, showWireguardTab, wireguardTunnels, wireguardTunnelsLoading, selectedWireguardTunnelId, setSelectedWireguardTunnelId, onWireGuardSessionUpdate, setWireguardChangesMade)=>{
    setClickedTab(newValue);
    const isAutoPatrol = siteInfo?.integration_type_name === "autopatrol";
    if (newValue === "one" && !editMode) {
        if (isAutoPatrol) setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $1W2ma.GeneralInfoTabAutoPatrol), {
            editMode: false
        }));
        else setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $1Ah5f.GeneralInfoTab), {
            siteInfo: siteInfo,
            setSiteInfo: setSiteInfo,
            setActiveTab: setActiveTab,
            vmsVariables: vmsVariables
        }));
        setSchedulesTabActive(false);
    } else if (newValue === "one" && editMode) {
        if (isAutoPatrol) setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $1W2ma.GeneralInfoTabAutoPatrol), {
            editMode: true
        }));
        else setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $kMcJt.GeneralInfoTabEditMode), {
            setPatchObject: setPatchObject,
            setSiteInfo: setSiteInfo,
            siteInfo: siteInfo,
            setSiteInfoChangesMade: setSiteInfoChangesMade,
            vmsVariables: vmsVariables,
            setVmsVariables: setVmsVariables
        }));
        setSchedulesTabActive(false);
    } else if (newValue === "three" && !editMode) {
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $2uQ4j.SchedulesTab), {
            siteInfo: siteInfo
        }));
        setSchedulesTabActive(true);
    } else if (newValue === "three" && editMode) {
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $iTHZG.SchedulesTabEditMode), {
            siteInfo: siteInfo,
            setEditMode: setEditMode,
            setSiteInfo: setSiteInfo,
            setActiveTab: setActiveTab
        }));
        setSchedulesTabActive(true);
    } else if (newValue === "four") {
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $7isVd.SMTPTab), {}));
        setSchedulesTabActive(false);
    } else if (newValue === "five" && !editMode) {
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4ajRU.RecordingServerTab), {
            recordingServerData: recordingServerData
        }));
        setSchedulesTabActive(false);
    } else if (newValue === "five" && editMode) {
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $ivt1T.RecordingServerTabEditMode), {
            recordingServerData: recordingServerData,
            recordingServerPatchObject: recordingServerPatchObject,
            setRecordingServerPatchObject: setRecordingServerPatchObject,
            setRecordingServerChangesMade: setRecordingServerChangesMade
        }));
        setSchedulesTabActive(false);
    } else if (newValue === "six" && !editMode) {
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $islbW.CameraHealthTab), {
            healthCheckData: healthCheckData,
            siteInfo: siteInfo
        }));
        setSchedulesTabActive(false);
    } else if (newValue === "six" && editMode) {
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $iE9hz.CameraHealthTabEditMode), {
            healthCheckData: healthCheckData,
            setCameraHealthPatchObject: setCameraHealthPatchObject,
            setCameraHealthChangesMade: setCameraHealthChangesMade,
            siteInfo: siteInfo,
            setAddCameraHealthDialogOpen: setAddCameraHealthDialogOpen,
            setTurnOffHealthDialogOpen: setTurnOffHealthDialogOpen
        }));
        setSchedulesTabActive(false);
    } else if (newValue === "seven" && !editMode) {
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $iXV9W.WebhooksTab), {
            webhooksInfo: webhooksInfo
        }));
        setSchedulesTabActive(false);
    } else if (newValue === "seven" && editMode) {
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $lbXkF.default), {
            webhooksInfo: webhooksInfo,
            setWebhooksPatchObject: setWebhooksPatchObject,
            setWebhooksChangesMade: setWebhooksChangesMade
        }));
        setSchedulesTabActive(false);
    } else if (newValue === (0, $2bi6M.DOUBLE_TAKE_TAB)) // SiteAbout renders the DoubleTake tab itself, with its own Save, like
    // WireGuard; only the schedule-only header buttons need clearing here.
    setSchedulesTabActive(false);
    else if (newValue === "eight" && !editMode) {
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $f7Odp.EvalinkTab), {}));
        setSchedulesTabActive(false);
    } else if (newValue === "eight" && editMode) {
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $2wmRq.EvalinkTabEditMode), {}));
        setSchedulesTabActive(false);
    } else if (newValue === "nine" && showWireguardTab && !editMode) {
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4k3Fk.WireGuardTab), {
            wireguardTunnels: wireguardTunnels,
            wireguardTunnelsLoading: wireguardTunnelsLoading,
            selectedTunnelId: selectedWireguardTunnelId,
            onSelectTunnelId: (id)=>setSelectedWireguardTunnelId(id)
        }));
        setSchedulesTabActive(false);
    } else if (newValue === "nine" && showWireguardTab && editMode) {
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $c6iZU.WireGuardTabEditMode), {
            wireguardTunnels: wireguardTunnels,
            selectedTunnelId: selectedWireguardTunnelId,
            onSelectTunnelId: (id)=>setSelectedWireguardTunnelId(id),
            onSessionUpdate: onWireGuardSessionUpdate,
            setWireguardChangesMade: setWireguardChangesMade
        }));
        setSchedulesTabActive(false);
    }
};

});
parcelRegister("kMcJt", function(module, exports) {

$parcel$export(module.exports, "GeneralInfoTabEditMode", () => $d735ffc0d647f949$export$74d3a89e0b626259);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $3mOKt = parcelRequire("3mOKt");

var $8B8vg = parcelRequire("8B8vg");
var $ddLR4 = parcelRequire("ddLR4");
var $ha39s = parcelRequire("ha39s");
var $eejVe = parcelRequire("eejVe");
var $cVCJe = parcelRequire("cVCJe");
var $f3puC = parcelRequire("f3puC");

var $lWchQ = parcelRequire("lWchQ");

var $2aMB5 = parcelRequire("2aMB5");

var $3V7Ks = parcelRequire("3V7Ks");

var $aYdit = parcelRequire("aYdit");

var $4PFLW = parcelRequire("4PFLW");

var $3JJWq = parcelRequire("3JJWq");

var $6HkuM = parcelRequire("6HkuM");

var $di6AF = parcelRequire("di6AF");

var $2dCK7 = parcelRequire("2dCK7");

var $SkEiS = parcelRequire("SkEiS");
const $d735ffc0d647f949$export$74d3a89e0b626259 = ({ setPatchObject: setPatchObject, setSiteInfo: setSiteInfo, siteInfo: siteInfo, setSiteInfoChangesMade: setSiteInfoChangesMade, vmsVariables: vmsVariables, setVmsVariables: setVmsVariables })=>{
    const { userPermissions: userPermissions, wireGuardOptions: wireGuardOptions } = (0, $aYdit.useAppStore)();
    const { isFeatureEnabled: isFeatureEnabled } = (0, $4PFLW.useFeatureFlag)();
    const showWireguard = isFeatureEnabled("showWireguard", false);
    // Only WireGuard-enabled sites (display_wireguard) show the AZ selector.
    // ONVIF-over-WireGuard sites qualify because save_site enables the WireGuard
    // AdminFeature for them on onboard.
    const shouldShowWireguardAvailabilityZone = showWireguard && Boolean(siteInfo.display_wireguard);
    const { ecsNatInstance: ecsNatInstance, wireguard: wireguardId, wireguardAutocompleteKey: wireguardAutocompleteKey, handleWireguardSelection: handleWireguardSelection, handleNatToggle: handleNatToggle, conflictDialogProps: conflictDialogProps } = (0, $SkEiS.useNatWireguardConflictDialog)({
        siteInfo: siteInfo,
        showWireguardFlag: showWireguard,
        setSiteInfo: setSiteInfo,
        setPatchObject: setPatchObject,
        setChangesMade: setSiteInfoChangesMade
    });
    const selectedWireguardName = wireGuardOptions.find((option)=>option.id === wireguardId)?.name ?? null;
    const [noteText, setNoteText] = $8T3gX.useState(siteInfo.notes ?? "");
    // This tab is created once as an element (setActiveTab), so its siteInfo
    // prop does not follow edits. The connection fields' visible_when rules
    // (ENG-2535) need the edited values, so keep a live copy that every VMS
    // field edit updates alongside the page's siteInfo.
    const [liveSiteInfo, setLiveSiteInfo] = $8T3gX.useState(siteInfo);
    $8T3gX.useEffect(()=>{
        setLiveSiteInfo(siteInfo);
    }, [
        siteInfo
    ]);
    const setSiteInfoAndLive = $8T3gX.useCallback((update)=>{
        setSiteInfo(update);
        setLiveSiteInfo(update);
    }, [
        setSiteInfo
    ]);
    const groupOptions = ((0, $3JJWq.safeGetItem)("parentGroups", []) ?? []).filter((group)=>group.parent_account === true);
    const groupOptionsIds = new Map();
    const groupOptionsNames = new Map();
    const groupStandardNames = new Map();
    groupOptions.forEach((option)=>{
        groupOptionsIds.set(option.id, `${option.name} (group id: ${option.id})`);
    });
    groupOptions.forEach((option)=>{
        groupOptionsNames.set(`${option.name} (group id: ${option.id})`, option.id);
    });
    groupOptions.forEach((option)=>{
        groupStandardNames.set(`${option.name} (group id: ${option.id})`, option.name);
    });
    const alarmOptions = (0, $3JJWq.safeGetItem)("alarmOptions", []) ?? [];
    const alarmIds = new Map();
    alarmOptions.forEach((object)=>{
        alarmIds.set(object.value, object.name);
    });
    const alarmNames = new Map();
    alarmOptions.forEach((object)=>{
        alarmNames.set(object.name, object.value);
    });
    const noVMS = siteInfo.integration_type_name === "rtsp" && siteInfo.onboarding_integration === 1;
    const autopatrolSite = siteInfo.integration_type_name === "autopatrol";
    const titlesArray = [
        "Site Name",
        "Timezone",
        ...autopatrolSite ? [] : [
            "Autoadd"
        ],
        "Integration Type",
        ...autopatrolSite ? [] : [
            "Alarm Type"
        ],
        "Parent Group"
    ];
    if (siteInfo.show_ecs_nat_instance) titlesArray.push("Whitelisting");
    const [showPassword, setShowPassword] = $8T3gX.useState({});
    const handleClickShowPassword = (inputString)=>setShowPassword((previousState)=>({
                ...previousState,
                [inputString]: !previousState[inputString]
            }));
    const handleMouseDownPassword = (event)=>{
        event.preventDefault();
    };
    const handleMouseUpPassword = (event)=>{
        event.preventDefault();
    };
    $8T3gX.useEffect(()=>{
        vmsVariables.forEach((array)=>{
            if (array[3] === "password") setShowPassword((show)=>({
                    ...show,
                    [array[2]]: false
                }));
        });
    }, []);
    const renderVMSTable = ()=>{
        if (noVMS) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    colSpan: 6,
                    align: "left",
                    sx: {
                        fontFamily: "Mulish"
                    },
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        variant: "body1",
                        sx: {
                            fontFamily: "Mulish"
                        },
                        children: "To view connection details for specific cameras, find the camera below, then > Show More > Edit Camera > Camera Information > Connection."
                    })
                })
            })
        });
        const cellsPerRow = 6;
        // ENG-2535: fields whose visible_when rule fails against the edited
        // values are not shown; they keep their values and are never patched.
        // Each entry keeps its vmsVariables index for vmsBuilder's write-back.
        const shownEntries = (0, $di6AF.visibleVmsVariables)(vmsVariables, liveSiteInfo);
        const totalRows = Math.ceil(shownEntries.length / cellsPerRow);
        const rows = [];
        for(let rowIndex = 0; rowIndex < totalRows; rowIndex++){
            const startIndex = rowIndex * cellsPerRow;
            const endIndex = Math.min(startIndex + cellsPerRow, shownEntries.length);
            const rowEntries = shownEntries.slice(startIndex, endIndex);
            const rowVariables = rowEntries.map(({ array: array })=>array);
            const emptyCells = cellsPerRow - rowVariables.length;
            rows.push(/*#__PURE__*/ (0, $k4ank.jsxs)($8T3gX.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                rowVariables.map((array)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: {
                                            width: "16.66%",
                                            fontFamily: "Mulish",
                                            fontWeight: "Bold"
                                        },
                                        children: (0, $6HkuM.getVmsDisplayLabel)(array[0], siteInfo.integration_type_name)
                                    }, array[0])),
                                emptyCells > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    colSpan: emptyCells
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                rowEntries.map(({ array: array, index: vmsIndex })=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: {
                                            width: "16.66%",
                                            fontFamily: "Mulish"
                                        },
                                        children: (0, $3V7Ks.vmsBuilder)(array, vmsVariables, setVmsVariables, setPatchObject, setSiteInfoAndLive, liveSiteInfo, setSiteInfoChangesMade, showPassword, handleClickShowPassword, handleMouseDownPassword, handleMouseUpPassword, vmsIndex, userPermissions)
                                    }, array[0])),
                                emptyCells > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    colSpan: emptyCells
                                })
                            ]
                        }, `${siteInfo.id}-vms-data-row-${rowIndex}`)
                    })
                ]
            }, `vms-row-${rowIndex}`));
        }
        return rows;
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "pb-[10px]",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $2dCK7.NatWireguardConflictDialog), {
                ...conflictDialogProps
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3Nm8Z.default), {
                component: (0, $4reBM.default),
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                        sx: {
                            minWidth: 1000,
                            fontFamily: "Mulish"
                        },
                        "aria-label": "simple table",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                titlesArray: titlesArray
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                    defaultValue: siteInfo.name,
                                                    variant: "standard",
                                                    sx: {
                                                        width: 200
                                                    },
                                                    type: "string",
                                                    onChange: (event)=>{
                                                        setPatchObject((previousState)=>{
                                                            return {
                                                                ...previousState,
                                                                name: event.target.value
                                                            };
                                                        });
                                                        setSiteInfo((previousState)=>{
                                                            return {
                                                                ...previousState,
                                                                name: event.target.value
                                                            };
                                                        });
                                                        setSiteInfoChangesMade(true);
                                                    }
                                                })
                                            }, siteInfo.name)
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                                    disablePortal: true,
                                                    options: (0, $3JJWq.safeGetItem)("timeZoneArray", []) ?? [],
                                                    defaultValue: siteInfo.timezone,
                                                    sx: {
                                                        width: 200
                                                    },
                                                    onInputChange: (event, newInputValue)=>{
                                                        setPatchObject((previousState)=>{
                                                            return {
                                                                ...previousState,
                                                                timezone: newInputValue
                                                            };
                                                        });
                                                        setSiteInfo((previousState)=>{
                                                            return {
                                                                ...previousState,
                                                                timezone: newInputValue
                                                            };
                                                        });
                                                        setSiteInfoChangesMade(true);
                                                    },
                                                    renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                            ...params,
                                                            variant: "standard",
                                                            autoComplete: "off"
                                                        })
                                                })
                                            }, siteInfo.timezone)
                                        }),
                                        !autopatrolSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            children: siteInfo.auto_add ? userPermissions.super_user ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                title: siteInfo.auto_add,
                                                placement: "top",
                                                children: (0, $lWchQ.checkedCircleIcon)
                                            }) : (0, $lWchQ.checkedCircleIcon) : (0, $2aMB5.cancelIconRed)
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            children: (0, $3mOKt.integrationsMatcher)("Name", siteInfo.integration_type)
                                        }),
                                        !autopatrolSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                                    disablePortal: true,
                                                    options: alarmOptions.map((option)=>{
                                                        return option.name;
                                                    }),
                                                    defaultValue: alarmIds.get(siteInfo.default_alarm),
                                                    sx: {
                                                        width: 150
                                                    },
                                                    onInputChange: (event, newInputValue)=>{
                                                        setPatchObject((previousState)=>{
                                                            return {
                                                                ...previousState,
                                                                default_alarm: alarmNames.get(newInputValue)
                                                            };
                                                        });
                                                        setSiteInfo((previousState)=>{
                                                            return {
                                                                ...previousState,
                                                                default_alarm: alarmNames.get(newInputValue)
                                                            };
                                                        });
                                                        setSiteInfoChangesMade(true);
                                                    },
                                                    renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                            ...params,
                                                            variant: "standard",
                                                            autoComplete: "off"
                                                        })
                                                })
                                            }, siteInfo.default_alarm)
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                                    disablePortal: true,
                                                    options: groupOptions.map((option)=>{
                                                        return `${option.name} (group id: ${option.id})`;
                                                    }),
                                                    defaultValue: siteInfo.breadcrumbs[siteInfo.breadcrumbs.length - 2],
                                                    sx: {
                                                        width: 150
                                                    },
                                                    onInputChange: (event, newInputValue)=>{
                                                        setPatchObject((previousState)=>{
                                                            return {
                                                                ...previousState,
                                                                parent_group: {
                                                                    parent: groupOptionsNames.get(newInputValue)
                                                                }
                                                            };
                                                        });
                                                        setSiteInfo((previousState)=>{
                                                            return {
                                                                ...previousState,
                                                                parent_group: {
                                                                    name: groupStandardNames.get(newInputValue)
                                                                }
                                                            };
                                                        });
                                                        localStorage.setItem("groupNameChange", "true");
                                                    },
                                                    renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                            ...params,
                                                            variant: "standard",
                                                            autoComplete: "off"
                                                        })
                                                })
                                            }, siteInfo.breadcrumbs[0])
                                        }),
                                        siteInfo.show_ecs_nat_instance && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                checked: ecsNatInstance,
                                                disabled: false,
                                                color: "warning",
                                                onChange: (event)=>{
                                                    handleNatToggle(event.target.checked);
                                                }
                                            })
                                        })
                                    ]
                                }, siteInfo.id)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                        sx: {
                            minWidth: 1000,
                            fontFamily: "Mulish"
                        },
                        "aria-label": "simple table",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                titlesArray: shouldShowWireguardAvailabilityZone ? [
                                    "WireGuard Availability Zone",
                                    "Notes",
                                    "",
                                    "",
                                    "",
                                    ""
                                ] : [
                                    "Notes",
                                    "",
                                    "",
                                    "",
                                    "",
                                    ""
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                    children: [
                                        shouldShowWireguardAvailabilityZone && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish",
                                                verticalAlign: "top"
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                                disablePortal: true,
                                                options: wireGuardOptions.map((option)=>option.name),
                                                value: selectedWireguardName,
                                                sx: {
                                                    width: 300
                                                },
                                                onChange: (_event, newValue)=>{
                                                    if (!newValue) return;
                                                    const selectedOption = wireGuardOptions.find((option)=>option.name === newValue);
                                                    if (selectedOption) handleWireguardSelection(selectedOption.id);
                                                },
                                                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                        ...params,
                                                        variant: "standard",
                                                        autoComplete: "off"
                                                    })
                                            }, wireguardAutocompleteKey)
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                onChange: (event)=>{
                                                    setPatchObject((previousState)=>{
                                                        return {
                                                            ...previousState,
                                                            notes: event.target.value
                                                        };
                                                    });
                                                    setSiteInfo((previousState)=>{
                                                        return {
                                                            ...previousState,
                                                            notes: event.target.value
                                                        };
                                                    });
                                                    setNoteText(event.target.value);
                                                    setSiteInfoChangesMade(true);
                                                },
                                                value: noteText,
                                                variant: "outlined",
                                                multiline: true,
                                                rows: 6,
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    width: 400
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {}),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {}),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {}),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {}),
                                        !shouldShowWireguardAvailabilityZone && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {})
                                    ]
                                }, siteInfo.id)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                        sx: {
                            width: "100%",
                            fontFamily: "Mulish",
                            tableLayout: "fixed",
                            mt: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        colSpan: 6,
                                        sx: {
                                            fontFamily: "Mulish",
                                            fontWeight: "bold",
                                            fontSize: "16px"
                                        },
                                        children: "VMS"
                                    })
                                })
                            }),
                            renderVMSTable()
                        ]
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("8B8vg", function(module, exports) {

$parcel$export(module.exports, "default", () => $64285ffbd416390e$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $97LlG = parcelRequire("97LlG");

var $bPpmJ = parcelRequire("bPpmJ");

var $aYNpO = parcelRequire("aYNpO");

var $aBrLz = parcelRequire("aBrLz");

var $9pphU = parcelRequire("9pphU");

var $cWqfz = parcelRequire("cWqfz");

var $bAwA3 = parcelRequire("bAwA3");

var $4reBM = parcelRequire("4reBM");

var $iKAtE = parcelRequire("iKAtE");

var $6MI6A = parcelRequire("6MI6A");

var $kSPDA = parcelRequire("kSPDA");

var $5aFhN = parcelRequire("5aFhN");

var $jYErz = parcelRequire("jYErz");

var $dxJLt = parcelRequire("dxJLt");

var $4LmmI = parcelRequire("4LmmI");

var $e0WBI = parcelRequire("e0WBI");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $luPXG = parcelRequire("luPXG");

var $iMOmE = parcelRequire("iMOmE");

var $11ydL = parcelRequire("11ydL");

var $k4ank = parcelRequire("k4ank");
'use client';
var $64285ffbd416390e$var$_ClearIcon, $64285ffbd416390e$var$_ArrowDropDownIcon;
const $64285ffbd416390e$var$_excluded = [
    "autoComplete",
    "autoHighlight",
    "autoSelect",
    "blurOnSelect",
    "ChipProps",
    "className",
    "clearIcon",
    "clearOnBlur",
    "clearOnEscape",
    "clearText",
    "closeText",
    "componentsProps",
    "defaultValue",
    "disableClearable",
    "disableCloseOnSelect",
    "disabled",
    "disabledItemsFocusable",
    "disableListWrap",
    "disablePortal",
    "filterOptions",
    "filterSelectedOptions",
    "forcePopupIcon",
    "freeSolo",
    "fullWidth",
    "getLimitTagsText",
    "getOptionDisabled",
    "getOptionKey",
    "getOptionLabel",
    "isOptionEqualToValue",
    "groupBy",
    "handleHomeEndKeys",
    "id",
    "includeInputInList",
    "inputValue",
    "limitTags",
    "ListboxComponent",
    "ListboxProps",
    "loading",
    "loadingText",
    "multiple",
    "noOptionsText",
    "onChange",
    "onClose",
    "onHighlightChange",
    "onInputChange",
    "onOpen",
    "open",
    "openOnFocus",
    "openText",
    "options",
    "PaperComponent",
    "PopperComponent",
    "popupIcon",
    "readOnly",
    "renderGroup",
    "renderInput",
    "renderOption",
    "renderTags",
    "selectOnFocus",
    "size",
    "slotProps",
    "value"
], $64285ffbd416390e$var$_excluded2 = [
    "ref"
], $64285ffbd416390e$var$_excluded3 = [
    "key"
], $64285ffbd416390e$var$_excluded4 = [
    "key"
];
const $64285ffbd416390e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            focused && 'focused',
            fullWidth && 'fullWidth',
            hasClearIcon && 'hasClearIcon',
            hasPopupIcon && 'hasPopupIcon'
        ],
        inputRoot: [
            'inputRoot'
        ],
        input: [
            'input',
            inputFocused && 'inputFocused'
        ],
        tag: [
            'tag',
            `tagSize${(0, $iMOmE.default)(size)}`
        ],
        endAdornment: [
            'endAdornment'
        ],
        clearIndicator: [
            'clearIndicator'
        ],
        popupIndicator: [
            'popupIndicator',
            popupOpen && 'popupIndicatorOpen'
        ],
        popper: [
            'popper',
            disablePortal && 'popperDisablePortal'
        ],
        paper: [
            'paper'
        ],
        listbox: [
            'listbox'
        ],
        loading: [
            'loading'
        ],
        noOptions: [
            'noOptions'
        ],
        option: [
            'option'
        ],
        groupLabel: [
            'groupLabel'
        ],
        groupUl: [
            'groupUl'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $luPXG.getAutocompleteUtilityClass), classes);
};
const $64285ffbd416390e$var$AutocompleteRoot = (0, $anJSP.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $luPXG.default).tag}`]: styles.tag
            },
            {
                [`& .${(0, $luPXG.default).tag}`]: styles[`tagSize${(0, $iMOmE.default)(size)}`]
            },
            {
                [`& .${(0, $luPXG.default).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $luPXG.default).input}`]: styles.input
            },
            {
                [`& .${(0, $luPXG.default).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})({
    [`&.${(0, $luPXG.default).focused} .${(0, $luPXG.default).clearIndicator}`]: {
        visibility: 'visible'
    },
    /* Avoid double tap issue on iOS */ '@media (pointer: fine)': {
        [`&:hover .${(0, $luPXG.default).clearIndicator}`]: {
            visibility: 'visible'
        }
    },
    [`& .${(0, $luPXG.default).tag}`]: {
        margin: 3,
        maxWidth: 'calc(100% - 6px)'
    },
    [`& .${(0, $luPXG.default).inputRoot}`]: {
        [`.${(0, $luPXG.default).hasPopupIcon}&, .${(0, $luPXG.default).hasClearIcon}&`]: {
            paddingRight: 30
        },
        [`.${(0, $luPXG.default).hasPopupIcon}.${(0, $luPXG.default).hasClearIcon}&`]: {
            paddingRight: 56
        },
        [`& .${(0, $luPXG.default).input}`]: {
            width: 0,
            minWidth: 30
        }
    },
    [`& .${(0, $kSPDA.default).root}`]: {
        paddingBottom: 1,
        '& .MuiInput-input': {
            padding: '4px 4px 4px 0px'
        }
    },
    [`& .${(0, $kSPDA.default).root}.${(0, $5aFhN.default).sizeSmall}`]: {
        [`& .${(0, $kSPDA.default).input}`]: {
            padding: '2px 4px 3px 0'
        }
    },
    [`& .${(0, $jYErz.default).root}`]: {
        padding: 9,
        [`.${(0, $luPXG.default).hasPopupIcon}&, .${(0, $luPXG.default).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $luPXG.default).hasPopupIcon}.${(0, $luPXG.default).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $luPXG.default).input}`]: {
            padding: '7.5px 4px 7.5px 5px'
        },
        [`& .${(0, $luPXG.default).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $jYErz.default).root}.${(0, $5aFhN.default).sizeSmall}`]: {
        // Don't specify paddingRight, as it overrides the default value set when there is only
        // one of the popup or clear icon as the specificity is equal so the latter one wins
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 6,
        [`& .${(0, $luPXG.default).input}`]: {
            padding: '2.5px 4px 2.5px 8px'
        }
    },
    [`& .${(0, $dxJLt.default).root}`]: {
        paddingTop: 19,
        paddingLeft: 8,
        [`.${(0, $luPXG.default).hasPopupIcon}&, .${(0, $luPXG.default).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $luPXG.default).hasPopupIcon}.${(0, $luPXG.default).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $dxJLt.default).input}`]: {
            padding: '7px 4px'
        },
        [`& .${(0, $luPXG.default).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $dxJLt.default).root}.${(0, $5aFhN.default).sizeSmall}`]: {
        paddingBottom: 1,
        [`& .${(0, $dxJLt.default).input}`]: {
            padding: '2.5px 4px'
        }
    },
    [`& .${(0, $5aFhN.default).hiddenLabel}`]: {
        paddingTop: 8
    },
    [`& .${(0, $dxJLt.default).root}.${(0, $5aFhN.default).hiddenLabel}`]: {
        paddingTop: 0,
        paddingBottom: 0,
        [`& .${(0, $luPXG.default).input}`]: {
            paddingTop: 16,
            paddingBottom: 17
        }
    },
    [`& .${(0, $dxJLt.default).root}.${(0, $5aFhN.default).hiddenLabel}.${(0, $5aFhN.default).sizeSmall}`]: {
        [`& .${(0, $luPXG.default).input}`]: {
            paddingTop: 8,
            paddingBottom: 9
        }
    },
    [`& .${(0, $luPXG.default).input}`]: {
        flexGrow: 1,
        textOverflow: 'ellipsis',
        opacity: 0
    },
    variants: [
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                [`& .${(0, $luPXG.default).tag}`]: {
                    margin: 2,
                    maxWidth: 'calc(100% - 4px)'
                }
            }
        },
        {
            props: {
                inputFocused: true
            },
            style: {
                [`& .${(0, $luPXG.default).input}`]: {
                    opacity: 1
                }
            }
        },
        {
            props: {
                multiple: true
            },
            style: {
                [`& .${(0, $luPXG.default).inputRoot}`]: {
                    flexWrap: 'wrap'
                }
            }
        }
    ]
});
const $64285ffbd416390e$var$AutocompleteEndAdornment = (0, $anJSP.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'EndAdornment',
    overridesResolver: (props, styles)=>styles.endAdornment
})({
    // We use a position absolute to support wrapping tags.
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translate(0, -50%)'
});
const $64285ffbd416390e$var$AutocompleteClearIndicator = (0, $anJSP.default)((0, $iKAtE.default), {
    name: 'MuiAutocomplete',
    slot: 'ClearIndicator',
    overridesResolver: (props, styles)=>styles.clearIndicator
})({
    marginRight: -2,
    padding: 4,
    visibility: 'hidden'
});
const $64285ffbd416390e$var$AutocompletePopupIndicator = (0, $anJSP.default)((0, $iKAtE.default), {
    name: 'MuiAutocomplete',
    slot: 'PopupIndicator',
    overridesResolver: ({ ownerState: ownerState }, styles)=>(0, $eJfrs.default)({}, styles.popupIndicator, ownerState.popupOpen && styles.popupIndicatorOpen)
})({
    padding: 2,
    marginRight: -2,
    variants: [
        {
            props: {
                popupOpen: true
            },
            style: {
                transform: 'rotate(180deg)'
            }
        }
    ]
});
const $64285ffbd416390e$var$AutocompletePopper = (0, $anJSP.default)((0, $cWqfz.default), {
    name: 'MuiAutocomplete',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $luPXG.default).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.modal,
        variants: [
            {
                props: {
                    disablePortal: true
                },
                style: {
                    position: 'absolute'
                }
            }
        ]
    }));
const $64285ffbd416390e$var$AutocompletePaper = (0, $anJSP.default)((0, $4reBM.default), {
    name: 'MuiAutocomplete',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})(({ theme: theme })=>(0, $eJfrs.default)({}, theme.typography.body1, {
        overflow: 'auto'
    }));
const $64285ffbd416390e$var$AutocompleteLoading = (0, $anJSP.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Loading',
    overridesResolver: (props, styles)=>styles.loading
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    }));
const $64285ffbd416390e$var$AutocompleteNoOptions = (0, $anJSP.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'NoOptions',
    overridesResolver: (props, styles)=>styles.noOptions
})(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    }));
const $64285ffbd416390e$var$AutocompleteListbox = (0, $anJSP.default)('div', {
    name: 'MuiAutocomplete',
    slot: 'Listbox',
    overridesResolver: (props, styles)=>styles.listbox
})(({ theme: theme })=>({
        listStyle: 'none',
        margin: 0,
        padding: '8px 0',
        maxHeight: '40vh',
        overflow: 'auto',
        position: 'relative',
        [`& .${(0, $luPXG.default).option}`]: {
            minHeight: 48,
            display: 'flex',
            overflow: 'hidden',
            justifyContent: 'flex-start',
            alignItems: 'center',
            cursor: 'pointer',
            paddingTop: 6,
            boxSizing: 'border-box',
            outline: '0',
            WebkitTapHighlightColor: 'transparent',
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up('sm')]: {
                minHeight: 'auto'
            },
            [`&.${(0, $luPXG.default).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: 'none'
            },
            [`&.${(0, $luPXG.default).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $aBrLz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
                [`&.${(0, $luPXG.default).focused}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $aBrLz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $luPXG.default).focusVisible}`]: {
                    backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $aBrLz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
                }
            }
        }
    }));
const $64285ffbd416390e$var$AutocompleteGroupLabel = (0, $anJSP.default)((0, $bAwA3.default), {
    name: 'MuiAutocomplete',
    slot: 'GroupLabel',
    overridesResolver: (props, styles)=>styles.groupLabel
})(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    }));
const $64285ffbd416390e$var$AutocompleteGroupUl = (0, $anJSP.default)('ul', {
    name: 'MuiAutocomplete',
    slot: 'GroupUl',
    overridesResolver: (props, styles)=>styles.groupUl
})({
    padding: 0,
    [`& .${(0, $luPXG.default).option}`]: {
        paddingLeft: 24
    }
});
const $64285ffbd416390e$var$Autocomplete = /*#__PURE__*/ $8T3gX.forwardRef(function Autocomplete(inProps, ref) {
    var _slotProps$clearIndic, _slotProps$paper, _slotProps$popper, _slotProps$popupIndic;
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiAutocomplete'
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipProps, className: className, clearIcon: clearIcon = $64285ffbd416390e$var$_ClearIcon || ($64285ffbd416390e$var$_ClearIcon = /*#__PURE__*/ (0, $k4ank.jsx)((0, $4LmmI.default), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = 'Clear', closeText: closeText = 'Close', componentsProps: componentsProps = {}, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = 'auto', freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionLabel: getOptionLabelProp, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, includeInputInList: includeInputInList = false, limitTags: limitTags = -1, ListboxComponent: ListboxComponent = 'ul', ListboxProps: ListboxProps, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = 'No options', openOnFocus: openOnFocus = false, openText: openText = 'Open', PaperComponent: PaperComponent = (0, $4reBM.default), PopperComponent: PopperComponent = (0, $cWqfz.default), popupIcon: popupIcon = $64285ffbd416390e$var$_ArrowDropDownIcon || ($64285ffbd416390e$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $k4ank.jsx)((0, $e0WBI.default), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = 'medium', slotProps: slotProps = {} } = props, other = (0, $fAJB5.default)(props, $64285ffbd416390e$var$_excluded);
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getTagProps: getTagProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedTag: focusedTag, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $9pphU.default)((0, $eJfrs.default)({}, props, {
        componentName: 'Autocomplete'
    }));
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: externalListboxRef } = ListboxProps != null ? ListboxProps : {};
    const _getListboxProps = getListboxProps(), { ref: listboxRef } = _getListboxProps, otherListboxProps = (0, $fAJB5.default)(_getListboxProps, $64285ffbd416390e$var$_excluded2);
    const combinedListboxRef = (0, $11ydL.default)(listboxRef, externalListboxRef);
    const defaultGetOptionLabel = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    };
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = (0, $eJfrs.default)({}, props, {
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedTag === -1,
        popupOpen: popupOpen,
        size: size
    });
    const classes = $64285ffbd416390e$var$useUtilityClasses(ownerState);
    let startAdornment;
    if (multiple && value.length > 0) {
        const getCustomizedTagProps = (params)=>(0, $eJfrs.default)({
                className: classes.tag,
                disabled: disabled
            }, getTagProps(params));
        if (renderTags) startAdornment = renderTags(value, getCustomizedTagProps, ownerState);
        else startAdornment = value.map((option, index)=>{
            const _getCustomizedTagProp = getCustomizedTagProps({
                index: index
            }), { key: key } = _getCustomizedTagProp, customTagProps = (0, $fAJB5.default)(_getCustomizedTagProp, $64285ffbd416390e$var$_excluded3);
            return /*#__PURE__*/ (0, $k4ank.jsx)((0, $6MI6A.default), (0, $eJfrs.default)({
                label: getOptionLabel(option),
                size: size
            }, customTagProps, ChipProps), key);
        });
    }
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $k4ank.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $k4ank.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)($64285ffbd416390e$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)($64285ffbd416390e$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
        const { key: key } = props2, otherProps = (0, $fAJB5.default)(props2, $64285ffbd416390e$var$_excluded4);
        return /*#__PURE__*/ (0, $k4ank.jsx)("li", (0, $eJfrs.default)({}, otherProps, {
            children: getOptionLabel(option)
        }), key);
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption((0, $eJfrs.default)({}, optionProps, {
            className: classes.option
        }), option, {
            selected: optionProps['aria-selected'],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = (_slotProps$clearIndic = slotProps.clearIndicator) != null ? _slotProps$clearIndic : componentsProps.clearIndicator;
    const paperSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : componentsProps.paper;
    const popperSlotProps = (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper;
    const popupIndicatorSlotProps = (_slotProps$popupIndic = slotProps.popupIndicator) != null ? _slotProps$popupIndic : componentsProps.popupIndicator;
    return /*#__PURE__*/ (0, $k4ank.jsxs)($8T3gX.Fragment, {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)($64285ffbd416390e$var$AutocompleteRoot, (0, $eJfrs.default)({
                ref: ref,
                className: (0, $iVyaN.default)(classes.root, className),
                ownerState: ownerState
            }, getRootProps(other), {
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === 'small' ? 'small' : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: (0, $eJfrs.default)({
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onClick: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        }
                    }, (hasClearIcon || hasPopupIcon) && {
                        endAdornment: /*#__PURE__*/ (0, $k4ank.jsxs)($64285ffbd416390e$var$AutocompleteEndAdornment, {
                            className: classes.endAdornment,
                            ownerState: ownerState,
                            children: [
                                hasClearIcon ? /*#__PURE__*/ (0, $k4ank.jsx)($64285ffbd416390e$var$AutocompleteClearIndicator, (0, $eJfrs.default)({}, getClearProps(), {
                                    "aria-label": clearText,
                                    title: clearText,
                                    ownerState: ownerState
                                }, clearIndicatorSlotProps, {
                                    className: (0, $iVyaN.default)(classes.clearIndicator, clearIndicatorSlotProps == null ? void 0 : clearIndicatorSlotProps.className),
                                    children: clearIcon
                                })) : null,
                                hasPopupIcon ? /*#__PURE__*/ (0, $k4ank.jsx)($64285ffbd416390e$var$AutocompletePopupIndicator, (0, $eJfrs.default)({}, getPopupIndicatorProps(), {
                                    disabled: disabled,
                                    "aria-label": popupOpen ? closeText : openText,
                                    title: popupOpen ? closeText : openText,
                                    ownerState: ownerState
                                }, popupIndicatorSlotProps, {
                                    className: (0, $iVyaN.default)(classes.popupIndicator, popupIndicatorSlotProps == null ? void 0 : popupIndicatorSlotProps.className),
                                    children: popupIcon
                                })) : null
                            ]
                        })
                    }),
                    inputProps: (0, $eJfrs.default)({
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly
                    }, getInputProps())
                })
            })),
            anchorEl ? /*#__PURE__*/ (0, $k4ank.jsx)($64285ffbd416390e$var$AutocompletePopper, (0, $eJfrs.default)({
                as: PopperComponent,
                disablePortal: disablePortal,
                style: {
                    width: anchorEl ? anchorEl.clientWidth : null
                },
                ownerState: ownerState,
                role: "presentation",
                anchorEl: anchorEl,
                open: popupOpen
            }, popperSlotProps, {
                className: (0, $iVyaN.default)(classes.popper, popperSlotProps == null ? void 0 : popperSlotProps.className),
                children: /*#__PURE__*/ (0, $k4ank.jsxs)($64285ffbd416390e$var$AutocompletePaper, (0, $eJfrs.default)({
                    ownerState: ownerState,
                    as: PaperComponent
                }, paperSlotProps, {
                    className: (0, $iVyaN.default)(classes.paper, paperSlotProps == null ? void 0 : paperSlotProps.className),
                    children: [
                        loading && groupedOptions.length === 0 ? /*#__PURE__*/ (0, $k4ank.jsx)($64285ffbd416390e$var$AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, $k4ank.jsx)($64285ffbd416390e$var$AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        groupedOptions.length > 0 ? /*#__PURE__*/ (0, $k4ank.jsx)($64285ffbd416390e$var$AutocompleteListbox, (0, $eJfrs.default)({
                            as: ListboxComponent,
                            className: classes.listbox,
                            ownerState: ownerState
                        }, otherListboxProps, ListboxProps, {
                            ref: combinedListboxRef,
                            children: groupedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        })) : null
                    ]
                }))
            })) : null
        ]
    });
});
$64285ffbd416390e$var$Autocomplete.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the portion of the selected suggestion that the user hasn't typed,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   * @default false
   */ autoComplete: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the first option is automatically highlighted.
   * @default false
   */ autoHighlight: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   *
   * When using the `freeSolo` mode, the typed value will be the input value
   * if the Autocomplete loses focus without highlighting an option.
   * @default false
   */ autoSelect: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   * @default false
   */ blurOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'mouse',
            'touch'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
    ]),
    /**
   * Props applied to the [`Chip`](/material-ui/api/chip/) element.
   */ ChipProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The icon to display in place of the default clear icon.
   * @default <ClearIcon fontSize="small" />
   */ clearIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * If `true`, the input's text is cleared on blur if no value is selected.
   *
   * Set it to `true` if you want to help the user enter a new value.
   * Set it to `false` if you want to help the user resume their search.
   * @default !props.freeSolo
   */ clearOnBlur: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   * @default false
   */ clearOnEscape: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Clear'
   */ clearText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Close'
   */ closeText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The props used for each slot inside.
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        clearIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        paper: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        popper: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        popupIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    }),
    /**
   * The default value. Use when the component is not controlled.
   * @default props.multiple ? [] : null
   */ defaultValue: (0, $bPpmJ.default)((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any, (props)=>{
        if (props.multiple && props.defaultValue !== undefined && !Array.isArray(props.defaultValue)) return new Error([
            'MUI: The Autocomplete expects the `defaultValue` prop to be an array when `multiple={true}` or undefined.',
            `However, ${props.defaultValue} was provided.`
        ].join('\n'));
        return null;
    }),
    /**
   * If `true`, the input can't be cleared.
   * @default false
   */ disableClearable: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the popup won't close when a value is selected.
   * @default false
   */ disableCloseOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */ disabledItemsFocusable: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the list box in the popup will not wrap focus.
   * @default false
   */ disableListWrap: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the `Popper` content will be under the DOM hierarchy of the parent component.
   * @default false
   */ disablePortal: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * A function that determines the filtered options to be rendered on search.
   *
   * @default createFilterOptions()
   * @param {Value[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {Value[]}
   */ filterOptions: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, hide the selected options from the list box.
   * @default false
   */ filterSelectedOptions: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Force the visibility display of the popup icon.
   * @default 'auto'
   */ forcePopupIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'auto'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
    ]),
    /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   * @default false
   */ freeSolo: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   * @default (more) => `+${more}`
   */ getLimitTagsText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Used to determine the disabled state for a given option.
   *
   * @param {Value} option The option to test.
   * @returns {boolean}
   */ getOptionDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Used to determine the key for a given option.
   * This can be useful when the labels of options are not unique (since labels are used as keys by default).
   *
   * @param {Value} option The option to get the key for.
   * @returns {string | number}
   */ getOptionKey: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * If used in free solo mode, it must accept both the type of the options and a string.
   *
   * @param {Value} option
   * @returns {string}
   * @default (option) => option.label ?? option
   */ getOptionLabel: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {Value} options The options to group.
   * @returns {string}
   */ groupBy: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   * @default !props.freeSolo
   */ handleHomeEndKeys: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide an id it will fall back to a randomly generated one.
   */ id: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true`, the highlight can move to the input.
   * @default false
   */ includeInputInList: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The input value.
   */ inputValue: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Used to determine if the option represents the given value.
   * Uses strict equality by default.
   * ⚠️ Both arguments need to be handled, an option can only match with one value.
   *
   * @param {Value} option The option to test.
   * @param {Value} value The value to test against.
   * @returns {boolean}
   */ isOptionEqualToValue: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   * @default -1
   */ limitTags: (0, $97LlG.default),
    /**
   * The component used to render the listbox.
   * @default 'ul'
   */ ListboxComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * Props applied to the Listbox element.
   */ ListboxProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * If `true`, the component is in a loading state.
   * This shows the `loadingText` in place of suggestions (only if there are no suggestions to show, for example `options` are empty).
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Loading…'
   */ loadingText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'No options'
   */ noOptionsText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value|Value[]} value The new value of the component.
   * @param {string} reason One of "createOption", "selectOption", "removeOption", "blur" or "clear".
   * @param {string} [details]
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"selectOption"`, `"removeOption"`, `"blur"`.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the highlight option changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"auto"`, `"mouse"`, `"touch"`.
   */ onHighlightChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the input value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`.
   */ onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, the component is shown.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the popup will open on input focus.
   * @default false
   */ openOnFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Open'
   */ openText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Array of options.
   */ options: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).array.isRequired,
    /**
   * The component used to render the body of the popup.
   * @default Paper
   */ PaperComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * The component used to position the popup.
   * @default Popper
   */ PopperComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * The icon to display in place of the default popup icon.
   * @default <ArrowDropDownIcon />
   */ popupIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * If `true`, the component becomes readonly. It is also supported for multiple tags where the tag cannot be deleted.
   * @default false
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Render the group.
   *
   * @param {AutocompleteRenderGroupParams} params The group to render.
   * @returns {ReactNode}
   */ renderGroup: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */ renderInput: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired,
    /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {object} props The props to apply on the li element.
   * @param {Value} option The option to render.
   * @param {object} state The state of each option.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */ renderOption: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Render the selected value.
   *
   * @param {Value[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */ renderTags: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, the input's text is selected on focus.
   * It helps the user clear the selected value.
   * @default !props.freeSolo
   */ selectOnFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The size of the component.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'small',
            'medium'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        clearIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        paper: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        popper: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        popupIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `isOptionEqualToValue` prop.
   */ value: (0, $bPpmJ.default)((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any, (props)=>{
        if (props.multiple && props.value !== undefined && !Array.isArray(props.value)) return new Error([
            'MUI: The Autocomplete expects the `value` prop to be an array when `multiple={true}` or undefined.',
            `However, ${props.value} was provided.`
        ].join('\n'));
        return null;
    })
};
var $64285ffbd416390e$export$2e2bcd8739ae039 = $64285ffbd416390e$var$Autocomplete;

});
parcelRegister("9pphU", function(module, exports) {

$parcel$export(module.exports, "createFilterOptions", () => $6d9a1082824f26e4$export$f76f94b238d946d8);
$parcel$export(module.exports, "default", () => $6d9a1082824f26e4$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $jmWnJ = parcelRequire("jmWnJ");
var $it0qC = parcelRequire("it0qC");
var $fPAwT = parcelRequire("fPAwT");
var $h47Cb = parcelRequire("h47Cb");
var $366s7 = parcelRequire("366s7");
'use client';
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Give up on IE11 support for this feature
function $6d9a1082824f26e4$var$stripDiacritics(string) {
    return typeof string.normalize !== 'undefined' ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : string;
}
function $6d9a1082824f26e4$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = 'any', stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $6d9a1082824f26e4$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $6d9a1082824f26e4$var$stripDiacritics(candidate);
            return matchFrom === 'start' ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
        });
        return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
// To replace with .findIndex() once we stop IE11 support.
function $6d9a1082824f26e4$var$findIndex(array, comp) {
    for(let i = 0; i < array.length; i += 1){
        if (comp(array[i])) return i;
    }
    return -1;
}
const $6d9a1082824f26e4$var$defaultFilterOptions = $6d9a1082824f26e4$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $6d9a1082824f26e4$var$pageSize = 5;
const $6d9a1082824f26e4$var$defaultIsActiveElementInListbox = (listboxRef)=>{
    var _listboxRef$current$p;
    return listboxRef.current !== null && ((_listboxRef$current$p = listboxRef.current.parentElement) == null ? void 0 : _listboxRef$current$p.contains(document.activeElement));
};
const $6d9a1082824f26e4$var$MULTIPLE_DEFAULT_VALUE = [];
function $6d9a1082824f26e4$var$useAutocomplete(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $6d9a1082824f26e4$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = 'Mui', autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = 'useAutocomplete', defaultValue: defaultValue = props.multiple ? $6d9a1082824f26e4$var$MULTIPLE_DEFAULT_VALUE : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $6d9a1082824f26e4$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>{
        var _option$label;
        return (_option$label = option.label) != null ? _option$label : option;
    }, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $h47Cb.default)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== 'string') {
            {
                const erroneousReturn = optionLabel === undefined ? 'undefined' : `${typeof optionLabel} (${optionLabel})`;
                console.error(`MUI: The \`getOptionLabel\` method of ${componentName} returned ${erroneousReturn} instead of a string for ${JSON.stringify(option)}.`);
            }
            return String(optionLabel);
        }
        return optionLabel;
    };
    const ignoreFocus = $8T3gX.useRef(false);
    const firstFocus = $8T3gX.useRef(true);
    const inputRef = $8T3gX.useRef(null);
    const listboxRef = $8T3gX.useRef(null);
    const [anchorEl, setAnchorEl] = $8T3gX.useState(null);
    const [focusedTag, setFocusedTag] = $8T3gX.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $8T3gX.useRef(defaultHighlighted);
    const [value, setValueState] = (0, $it0qC.default)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $it0qC.default)({
        controlled: inputValueProp,
        default: '',
        name: componentName,
        state: 'inputValue'
    });
    const [focused, setFocused] = $8T3gX.useState(false);
    const resetInputValue = $8T3gX.useCallback((event, newValue)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        let newInputValue;
        if (multiple) newInputValue = '';
        else if (newValue == null) newInputValue = '';
        else {
            const optionLabel = getOptionLabel(newValue);
            newInputValue = typeof optionLabel === 'string' ? optionLabel : '';
        }
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, 'reset');
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value
    ]);
    const [open, setOpenState] = (0, $it0qC.default)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: 'open'
    });
    const [inputPristine, setInputPristine] = $8T3gX.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? '' : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $366s7.default)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $8T3gX.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value);
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    if (value !== null && !freeSolo && options.length > 0) {
        const missingValue = (multiple ? value : [
            value
        ]).filter((value2)=>!options.some((option)=>isOptionEqualToValue(option, value2)));
        if (missingValue.length > 0) console.warn([
            `MUI: The value provided to ${componentName} is invalid.`,
            `None of the options match with \`${missingValue.length > 1 ? JSON.stringify(missingValue) : JSON.stringify(missingValue[0])}\`.`,
            'You can use the `isOptionEqualToValue` prop to customize the equality test.'
        ].join('\n'));
    }
    const focusTag = (0, $fPAwT.default)((tagToFocus)=>{
        if (tagToFocus === -1) inputRef.current.focus();
        else anchorEl.querySelector(`[data-tag-index="${tagToFocus}"]`).focus();
    });
    // Ensure the focusedTag is never inconsistent
    $8T3gX.useEffect(()=>{
        if (multiple && focusedTag > value.length - 1) {
            setFocusedTag(-1);
            focusTag(-1);
        }
    }, [
        value,
        multiple,
        focusedTag,
        focusTag
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute('aria-disabled') === 'true';
            if (option && option.hasAttribute('tabindex') && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === 'next') nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const setHighlightedIndex = (0, $fPAwT.default)(({ event: event, index: index, reason: reason = 'auto' })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute('aria-activedescendant');
        else inputRef.current.setAttribute('aria-activedescendant', `${id}-option-${index}`);
        if (onHighlightChange) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute('role') !== 'listbox') listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === 'keyboard') option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse' && reason !== 'touch') {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $fPAwT.default)(({ event: event, diff: diff, direction: direction = 'next', reason: reason = 'auto' })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === 'reset') return defaultHighlighted;
            if (diff === 'start') return 0;
            if (diff === 'end') return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== 'reset') {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const getPreviousHighlightedOptionIndex = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : '';
            const label2 = value2 ? getOptionLabel(value2) : '';
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && previousProps.filteredOptions && previousProps.filteredOptions.length !== filteredOptions.length && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) return $6d9a1082824f26e4$var$findIndex(filteredOptions, (option)=>{
                return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
            });
        }
        return -1;
    };
    const syncHighlightedIndex = $8T3gX.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
        const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
        if (previousHighlightedOptionIndex !== -1) {
            highlightedIndexRef.current = previousHighlightedOptionIndex;
            return;
        }
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: 'reset'
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && $6d9a1082824f26e4$var$findIndex(value, (val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = $6d9a1082824f26e4$var$findIndex(filteredOptions, (optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: 'reset'
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $fPAwT.default)((node)=>{
        (0, $jmWnJ.default)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8T3gX.useEffect(()=>{
        if (!inputRef.current || inputRef.current.nodeName !== 'INPUT') {
            if (inputRef.current && inputRef.current.nodeName === 'TEXTAREA') console.warn([
                `A textarea element was provided to ${componentName} where input was expected.`,
                `This is not a supported scenario but it may work under certain conditions.`,
                `A textarea keyboard navigation may conflict with Autocomplete controls (for example enter and arrow keys).`,
                `Make sure to test keyboard navigation and add custom event handlers if necessary.`
            ].join('\n'));
            else console.error([
                `MUI: Unable to find the input element. It was resolved to ${inputRef.current} while an HTMLInputElement was expected.`,
                `Instead, ${componentName} expects an input element.`,
                '',
                componentName === 'useAutocomplete' ? 'Make sure you have bound getInputProps correctly and that the normal ref/effect resolutions order is guaranteed.' : 'Make sure you have customized the input component correctly.'
            ].join('\n'));
        }
    }, [
        componentName
    ]);
    $8T3gX.useEffect(()=>{
        syncHighlightedIndex();
    }, [
        syncHighlightedIndex
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $8T3gX.useRef(false);
    const selectNewValue = (event, option, reasonProp = 'selectOption', origin = 'options')=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            {
                const matches = newValue.filter((val)=>isOptionEqualToValue(option, val));
                if (matches.length > 1) console.error([
                    `MUI: The \`isOptionEqualToValue\` method of ${componentName} does not handle the arguments correctly.`,
                    `The component expects a single value to match a given option but found ${matches.length} matches.`
                ].join('\n'));
            }
            const itemIndex = $6d9a1082824f26e4$var$findIndex(newValue, (valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== 'freeSolo') {
                newValue.splice(itemIndex, 1);
                reason = 'removeOption';
            }
        }
        resetInputValue(event, newValue);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) inputRef.current.blur();
    };
    function validTagIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) return -1;
            const option = anchorEl.querySelector(`[data-tag-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true') nextFocus += direction === 'next' ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusTag = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === '') handleClose(event, 'toggleInput');
        let nextTag = focusedTag;
        if (focusedTag === -1) {
            if (inputValue === '' && direction === 'previous') nextTag = value.length - 1;
        } else {
            nextTag += direction === 'next' ? 1 : -1;
            if (nextTag < 0) nextTag = 0;
            if (nextTag === value.length) nextTag = -1;
        }
        nextTag = validTagIndex(nextTag, direction);
        setFocusedTag(nextTag);
        focusTag(nextTag);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState('');
        if (onInputChange) onInputChange(event, '', 'clear');
        handleValue(event, multiple ? [] : null, 'clear');
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedTag !== -1 && [
                'ArrowLeft',
                'ArrowRight'
            ].indexOf(event.key) === -1) {
                setFocusedTag(-1);
                focusTag(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case 'Home':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'start',
                            direction: 'next',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'End':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'end',
                            direction: 'previous',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'PageUp':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$6d9a1082824f26e4$var$pageSize,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'PageDown':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $6d9a1082824f26e4$var$pageSize,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowDown':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowUp':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowLeft':
                    handleFocusTag(event, 'previous');
                    break;
                case 'ArrowRight':
                    handleFocusTag(event, 'next');
                    break;
                case 'Enter':
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, 'selectOption');
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, 'createOption', 'freeSolo');
                    }
                    break;
                case 'Escape':
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, 'escape');
                    } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case 'Backspace':
                    // Remove the value on the left of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0) {
                        const index = focusedTag === -1 ? value.length - 1 : focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    break;
                case 'Delete':
                    // Remove the value on the right of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0 && focusedTag !== -1) {
                        const index = focusedTag;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
        else if (autoSelect && freeSolo && inputValue !== '') selectNewValue(event, inputValue, 'blur', 'freeSolo');
        else if (clearOnBlur) resetInputValue(event, value);
        handleClose(event, 'blur');
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, 'input');
        }
        if (newValue === '') {
            if (!disableClearable && !multiple) handleValue(event, null, 'clear');
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: 'mouse'
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute('data-option-index')),
            reason: 'touch'
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        selectNewValue(event, filteredOptions[index], 'selectOption');
        isTouch.current = false;
    };
    const handleTagDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'removeOption', {
                option: value[index]
            });
        };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, 'toggleInput');
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute('id') !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === '' || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else {
                if (indexBy.get(group) && !warn) {
                    console.warn(`MUI: The options provided combined with the \`groupBy\` method of ${componentName} returns duplicated headers.`, 'You can solve the issue by sorting the options with the output of `groupBy`.');
                    warn = true;
                }
                indexBy.set(group, true);
                acc.push({
                    key: index,
                    index: index,
                    group: group,
                    options: [
                        option
                    ]
                });
            }
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>(0, $eJfrs.default)({
                'aria-owns': listboxAvailable ? `${id}-listbox` : null
            }, other, {
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                'aria-activedescendant': popupOpen ? '' : null,
                'aria-autocomplete': autoComplete ? 'both' : 'list',
                'aria-controls': listboxAvailable ? `${id}-listbox` : undefined,
                'aria-expanded': listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: 'off',
                ref: inputRef,
                autoCapitalize: 'none',
                spellCheck: 'false',
                role: 'combobox',
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handleClear
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handlePopupIndicator
            }),
        getTagProps: ({ index: index })=>(0, $eJfrs.default)({
                key: index,
                'data-tag-index': index,
                tabIndex: -1
            }, !readOnly && {
                onDelete: handleTagDelete(index)
            }),
        getListboxProps: ()=>({
                role: 'listbox',
                id: `${id}-listbox`,
                'aria-labelledby': `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            var _getOptionKey;
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: (_getOptionKey = getOptionKey == null ? void 0 : getOptionKey(option)) != null ? _getOptionKey : getOptionLabel(option),
                tabIndex: -1,
                role: 'option',
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                'data-option-index': index,
                'aria-disabled': disabled,
                'aria-selected': selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedTag !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedTag: focusedTag,
        groupedOptions: groupedOptions
    };
}
var $6d9a1082824f26e4$export$2e2bcd8739ae039 = $6d9a1082824f26e4$var$useAutocomplete;

});
parcelRegister("366s7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2416efff47a4ddbe$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");
'use client';
const $2416efff47a4ddbe$var$usePreviousProps = (value)=>{
    const ref = $8T3gX.useRef({});
    $8T3gX.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $2416efff47a4ddbe$export$2e2bcd8739ae039 = $2416efff47a4ddbe$var$usePreviousProps;

});


parcelRegister("bAwA3", function(module, exports) {

$parcel$export(module.exports, "default", () => $86fc544f221d4b57$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $iMOmE = parcelRequire("iMOmE");

var $lnzFj = parcelRequire("lnzFj");

var $k4ank = parcelRequire("k4ank");
'use client';
const $86fc544f221d4b57$var$_excluded = [
    "className",
    "color",
    "component",
    "disableGutters",
    "disableSticky",
    "inset"
];
const $86fc544f221d4b57$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'default' && `color${(0, $iMOmE.default)(color)}`,
            !disableGutters && 'gutters',
            inset && 'inset',
            !disableSticky && 'sticky'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $lnzFj.getListSubheaderUtilityClass), classes);
};
const $86fc544f221d4b57$var$ListSubheaderRoot = (0, $anJSP.default)('li', {
    name: 'MuiListSubheader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $iMOmE.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        boxSizing: 'border-box',
        lineHeight: '48px',
        listStyle: 'none',
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14)
    }, ownerState.color === 'primary' && {
        color: (theme.vars || theme).palette.primary.main
    }, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.inset && {
        paddingLeft: 72
    }, !ownerState.disableSticky && {
        position: 'sticky',
        top: 0,
        zIndex: 1,
        backgroundColor: (theme.vars || theme).palette.background.paper
    }));
const $86fc544f221d4b57$var$ListSubheader = /*#__PURE__*/ $8T3gX.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiListSubheader'
    });
    const { className: className, color: color = 'default', component: component = 'li', disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false } = props, other = (0, $fAJB5.default)(props, $86fc544f221d4b57$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    });
    const classes = $86fc544f221d4b57$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsx)($86fc544f221d4b57$var$ListSubheaderRoot, (0, $eJfrs.default)({
        as: component,
        className: (0, $iVyaN.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$86fc544f221d4b57$var$ListSubheader.muiSkipListHighlight = true;
$86fc544f221d4b57$var$ListSubheader.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'default'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'default',
        'inherit',
        'primary'
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * If `true`, the List Subheader will not have gutters.
   * @default false
   */ disableGutters: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   * @default false
   */ disableSticky: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the List Subheader is indented.
   * @default false
   */ inset: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $86fc544f221d4b57$export$2e2bcd8739ae039 = $86fc544f221d4b57$var$ListSubheader;

});
parcelRegister("lnzFj", function(module, exports) {

$parcel$export(module.exports, "getListSubheaderUtilityClass", () => $f907695cd2063945$export$6816d4fc0981ec7);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $f907695cd2063945$export$6816d4fc0981ec7(slot) {
    return (0, $kfTYv.default)('MuiListSubheader', slot);
}
const $f907695cd2063945$var$listSubheaderClasses = (0, $jh2Zm.default)('MuiListSubheader', [
    'root',
    'colorPrimary',
    'colorInherit',
    'gutters',
    'inset',
    'sticky'
]);
var $f907695cd2063945$export$2e2bcd8739ae039 = $f907695cd2063945$var$listSubheaderClasses;

});


parcelRegister("luPXG", function(module, exports) {

$parcel$export(module.exports, "getAutocompleteUtilityClass", () => $fa64b4caf8fe95e7$export$8ee01529667e66d9);
$parcel$export(module.exports, "default", () => $fa64b4caf8fe95e7$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $fa64b4caf8fe95e7$export$8ee01529667e66d9(slot) {
    return (0, $kfTYv.default)('MuiAutocomplete', slot);
}
const $fa64b4caf8fe95e7$var$autocompleteClasses = (0, $jh2Zm.default)('MuiAutocomplete', [
    'root',
    'expanded',
    'fullWidth',
    'focused',
    'focusVisible',
    'tag',
    'tagSizeSmall',
    'tagSizeMedium',
    'hasPopupIcon',
    'hasClearIcon',
    'inputRoot',
    'input',
    'inputFocused',
    'endAdornment',
    'clearIndicator',
    'popupIndicator',
    'popupIndicatorOpen',
    'popper',
    'popperDisablePortal',
    'paper',
    'listbox',
    'loading',
    'noOptions',
    'option',
    'groupLabel',
    'groupUl'
]);
var $fa64b4caf8fe95e7$export$2e2bcd8739ae039 = $fa64b4caf8fe95e7$var$autocompleteClasses;

});


parcelRegister("3V7Ks", function(module, exports) {

$parcel$export(module.exports, "vmsBuilder", () => $9674e34682913a69$export$421d6c3ffeb409f9);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $7UDCh = parcelRequire("7UDCh");
var $iKAtE = parcelRequire("iKAtE");
var $1SPe4 = parcelRequire("1SPe4");
var $6gU8O = parcelRequire("6gU8O");
var $eejVe = parcelRequire("eejVe");

var $dJISD = parcelRequire("dJISD");

var $ddLR4 = parcelRequire("ddLR4");

var $fN7FV = parcelRequire("fN7FV");

var $2yNMw = parcelRequire("2yNMw");
var $4m1S6 = parcelRequire("4m1S6");

var $6HkuM = parcelRequire("6HkuM");
const $9674e34682913a69$export$421d6c3ffeb409f9 = (array, vmsVariables, setVmsVariables, setPatchObject, setSiteInfo, siteInfo, setSiteInfoChangesMade, showPassword, handleClickShowPassword, handleMouseDownPassword, handleMouseUpPassword, index, userPermissions)=>{
    const options = array[4];
    const displayLabel = (0, $6HkuM.getVmsDisplayLabel)(array[0], siteInfo.integration_type_name);
    const optionsIds = new Map();
    const optionNames = new Map();
    if ((array[3] === "choices" || array[3] === "choice") && options) {
        options.forEach((option)=>{
            optionsIds.set(option[0], option[1]);
        });
        options.forEach((option)=>{
            optionNames.set(option[1], option[0]);
        });
    }
    const expr = array[3];
    switch(expr){
        case "string":
            return /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: array[2],
                        defaultValue: siteInfo[array[2]] === "null" ? "" : siteInfo[array[2]],
                        label: displayLabel,
                        variant: "standard",
                        sx: {
                            width: 200
                        },
                        type: "string",
                        onChange: (event)=>{
                            setPatchObject((previousState)=>{
                                return {
                                    ...previousState,
                                    [array[2]]: event.target.value
                                };
                            });
                            setSiteInfo((previousState)=>{
                                return {
                                    ...previousState,
                                    [array[2]]: event.target.value
                                };
                            });
                            const newVMSVariables = vmsVariables;
                            newVMSVariables[index][1] = event.target.value;
                            setVmsVariables(newVMSVariables);
                            setSiteInfoChangesMade(true);
                        }
                    })
                }, array[2])
            });
        case "textarea":
            // Multi-line values, e.g. a Salient site's DVR addresses (one
            // host:port per line). admin validates and normalises the lines.
            return /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: array[2],
                        defaultValue: siteInfo[array[2]] === "null" ? "" : siteInfo[array[2]],
                        label: displayLabel,
                        variant: "standard",
                        sx: {
                            width: 280
                        },
                        multiline: true,
                        minRows: 3,
                        onChange: (event)=>{
                            const nextValue = event.target.value;
                            setPatchObject((previousState)=>{
                                return {
                                    ...previousState,
                                    [array[2]]: nextValue
                                };
                            });
                            setSiteInfo((previousState)=>{
                                return {
                                    ...previousState,
                                    [array[2]]: nextValue
                                };
                            });
                            const newVMSVariables = vmsVariables;
                            newVMSVariables[index][1] = nextValue;
                            setVmsVariables(newVMSVariables);
                            setSiteInfoChangesMade(true);
                        }
                    })
                }, array[2])
            });
        case "integer":
            return /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        error: siteInfo[array[2]] && !(0, $dJISD.numbersOnly).test(siteInfo[array[2]]),
                        id: array[2],
                        defaultValue: array[1] === "null" ? "" : array[1],
                        label: displayLabel,
                        autoComplete: "off",
                        variant: "standard",
                        sx: {
                            width: 200
                        },
                        type: "string",
                        helperText: siteInfo[array[2]] && !(0, $dJISD.numbersOnly).test(siteInfo[array[2]]) ? "Must be a number" : "",
                        onChange: (event)=>{
                            setPatchObject((previousState)=>{
                                return {
                                    ...previousState,
                                    [array[2]]: event.target.value
                                };
                            });
                            setSiteInfo((previousState)=>{
                                return {
                                    ...previousState,
                                    [array[2]]: event.target.value
                                };
                            });
                            const newVMSVariables = vmsVariables;
                            newVMSVariables[index][1] = event.target.value;
                            setVmsVariables(newVMSVariables);
                            setSiteInfoChangesMade(true);
                        }
                    })
                }, array[2])
            });
        case "password":
            return /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                        sx: {
                            width: 200
                        },
                        variant: "standard",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $6gU8O.default), {
                                htmlFor: "standard-adornment-password",
                                children: displayLabel
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $fN7FV.default), {
                                id: "standard-adornment-password",
                                type: showPassword[array[2]] ? "text" : "password",
                                defaultValue: array[1] === "null" ? "" : array[1],
                                onChange: (event)=>{
                                    setPatchObject((previousState)=>{
                                        return {
                                            ...previousState,
                                            [array[2]]: event.target.value
                                        };
                                    });
                                    setSiteInfo((previousState)=>{
                                        return {
                                            ...previousState,
                                            [array[2]]: event.target.value
                                        };
                                    });
                                    const newVMSVariables = vmsVariables;
                                    newVMSVariables[index][1] = event.target.value;
                                    setVmsVariables(newVMSVariables);
                                    setSiteInfoChangesMade(true);
                                },
                                endAdornment: userPermissions.view_passwords ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $1SPe4.default), {
                                    position: "end",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                        "aria-label": showPassword ? "hide the password" : "display the password",
                                        onClick: ()=>{
                                            handleClickShowPassword(array[2]);
                                        },
                                        onMouseDown: handleMouseDownPassword,
                                        onMouseUp: handleMouseUpPassword,
                                        edge: "end",
                                        children: showPassword[array[2]] ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $4m1S6.default), {}) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $2yNMw.default), {})
                                    })
                                }) : null
                            })
                        ]
                    })
                }, array[2])
            });
        case "checkbox":
            return /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                    color: "warning",
                    defaultChecked: array[1] === "true",
                    onChange: (event)=>{
                        setPatchObject((previousState)=>{
                            return {
                                ...previousState,
                                [array[2]]: event.target.checked
                            };
                        });
                        setSiteInfo((previousState)=>{
                            return {
                                ...previousState,
                                [array[2]]: event.target.checked
                            };
                        });
                        const newVMSVariables = vmsVariables;
                        newVMSVariables[index][1] = `${event.target.checked}`;
                        setVmsVariables(newVMSVariables);
                        setSiteInfoChangesMade(true);
                    }
                })
            });
        case "choice":
            return !options ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                children: "No Options"
            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                        disablePortal: true,
                        id: array[2],
                        options: options.map((option)=>{
                            return option[0];
                        }),
                        defaultValue: array[1] === "null" ? "" : optionNames.get(array[1]),
                        onChange: (event, newInputValue)=>{
                            setPatchObject((previousState)=>{
                                return {
                                    ...previousState,
                                    [array[2]]: optionsIds.get(newInputValue)
                                };
                            });
                            setSiteInfo((previousState)=>{
                                return {
                                    ...previousState,
                                    [array[2]]: optionsIds.get(newInputValue)
                                };
                            });
                            const newVMSVariables = vmsVariables;
                            newVMSVariables[index][1] = optionsIds.get(newInputValue);
                            setVmsVariables(newVMSVariables);
                            setSiteInfoChangesMade(true);
                        },
                        sx: {
                            width: 250
                        },
                        renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                ...params,
                                variant: "standard",
                                label: displayLabel,
                                autoComplete: "off",
                                id: array[2],
                                name: displayLabel
                            })
                    })
                }, array[2])
            });
        default:
            return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                children: "Unsupported field"
            });
    }
};

});
parcelRegister("dJISD", function(module, exports) {

$parcel$export(module.exports, "numbersOnly", () => $fd0c624619b90e5f$export$f5730c8fdb1ddaeb);
const $fd0c624619b90e5f$export$f5730c8fdb1ddaeb = /^[0-9]+$/;

});


parcelRegister("2dCK7", function(module, exports) {

$parcel$export(module.exports, "NatWireguardConflictDialog", () => $7c96292e98f226ca$export$a21d8393926f6112);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");
const $7c96292e98f226ca$export$a21d8393926f6112 = ({ open: open, message: message, onConfirm: onConfirm, onCancel: onCancel })=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: open,
        "aria-labelledby": "nat-wireguard-conflict-dialog-title",
        "aria-describedby": "nat-wireguard-conflict-dialog-description",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "nat-wireguard-conflict-dialog-title",
                sx: {
                    fontFamily: "Mulish"
                },
                children: message
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: onCancel,
                        text: "No",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: onConfirm,
                        text: "Yes",
                        disabled: false
                    })
                ]
            })
        ]
    });

});

parcelRegister("SkEiS", function(module, exports) {

$parcel$export(module.exports, "useNatWireguardConflictDialog", () => $ccc38dbfb3e733ad$export$1fdf74641fed5757);

var $8T3gX = parcelRequire("8T3gX");

var $3P4Kr = parcelRequire("3P4Kr");
const $ccc38dbfb3e733ad$export$1fdf74641fed5757 = ({ siteInfo: siteInfo, showWireguardFlag: showWireguardFlag, enabled: enabled = true, setSiteInfo: setSiteInfo, setPatchObject: setPatchObject, setChangesMade: setChangesMade })=>{
    const [ecsNatInstance, setEcsNatInstance] = $8T3gX.useState(siteInfo.ecs_nat_instance);
    const [wireguard, setWireguard] = $8T3gX.useState(siteInfo.wireguard);
    const [dialogOpen, setDialogOpen] = $8T3gX.useState(false);
    const [dialogMessage, setDialogMessage] = $8T3gX.useState("");
    const [pendingAction, setPendingAction] = $8T3gX.useState(null);
    const pendingActionRef = $8T3gX.useRef(null);
    const [wireguardAutocompleteKey, setWireguardAutocompleteKey] = $8T3gX.useState(0);
    $8T3gX.useEffect(()=>{
        setEcsNatInstance(siteInfo.ecs_nat_instance);
        setWireguard(siteInfo.wireguard);
    }, [
        siteInfo.id
    ]);
    $8T3gX.useEffect(()=>{
        pendingActionRef.current = pendingAction;
    }, [
        pendingAction
    ]);
    const effectiveSiteInfo = $8T3gX.useMemo(()=>({
            ...siteInfo,
            ecs_nat_instance: ecsNatInstance,
            wireguard: wireguard
        }), [
        siteInfo,
        ecsNatInstance,
        wireguard
    ]);
    const bothFieldsVisible = (0, $3P4Kr.areNatAndWireguardFieldsVisible)(effectiveSiteInfo, showWireguardFlag);
    const applyFieldUpdates = $8T3gX.useCallback((updates)=>{
        if (Object.prototype.hasOwnProperty.call(updates, "ecs_nat_instance")) setEcsNatInstance(updates.ecs_nat_instance);
        if (Object.prototype.hasOwnProperty.call(updates, "wireguard")) setWireguard(updates.wireguard ?? null);
        setPatchObject((previousState)=>({
                ...previousState,
                ...updates
            }));
        setSiteInfo((previousState)=>({
                ...previousState,
                ...updates
            }));
        setChangesMade(true);
    }, [
        setChangesMade,
        setPatchObject,
        setSiteInfo
    ]);
    const handleWireguardSelection = $8T3gX.useCallback((wireguardId)=>{
        if (enabled && bothFieldsVisible && (0, $3P4Kr.shouldPromptWireguardOverNat)(effectiveSiteInfo)) {
            const action = {
                type: "wireguard",
                wireguardId: wireguardId
            };
            pendingActionRef.current = action;
            setPendingAction(action);
            setDialogMessage((0, $3P4Kr.WIREGUARD_OVER_NAT_MESSAGE));
            setDialogOpen(true);
            return;
        }
        applyFieldUpdates({
            wireguard: wireguardId
        });
    }, [
        applyFieldUpdates,
        bothFieldsVisible,
        effectiveSiteInfo,
        enabled
    ]);
    const handleNatToggle = $8T3gX.useCallback((checked)=>{
        if (enabled && bothFieldsVisible && (0, $3P4Kr.shouldPromptNatOverWireguard)(effectiveSiteInfo, checked)) {
            const action = {
                type: "nat"
            };
            pendingActionRef.current = action;
            setPendingAction(action);
            setDialogMessage((0, $3P4Kr.NAT_OVER_WIREGUARD_MESSAGE));
            setDialogOpen(true);
            return;
        }
        applyFieldUpdates({
            ecs_nat_instance: checked
        });
    }, [
        applyFieldUpdates,
        bothFieldsVisible,
        effectiveSiteInfo,
        enabled
    ]);
    const handleConfirm = $8T3gX.useCallback(()=>{
        const action = pendingActionRef.current;
        if (!action) {
            setDialogOpen(false);
            return;
        }
        if (action.type === "wireguard") applyFieldUpdates((0, $3P4Kr.applyWireguardOverNat)(action.wireguardId));
        else applyFieldUpdates((0, $3P4Kr.applyNatOverWireguard)());
        pendingActionRef.current = null;
        setPendingAction(null);
        setDialogOpen(false);
    }, [
        applyFieldUpdates
    ]);
    const handleCancel = $8T3gX.useCallback(()=>{
        if (pendingActionRef.current?.type === "wireguard") setWireguardAutocompleteKey((key)=>key + 1);
        pendingActionRef.current = null;
        setPendingAction(null);
        setDialogOpen(false);
    }, []);
    return {
        ecsNatInstance: ecsNatInstance,
        wireguard: wireguard,
        wireguardAutocompleteKey: wireguardAutocompleteKey,
        handleWireguardSelection: handleWireguardSelection,
        handleNatToggle: handleNatToggle,
        conflictDialogProps: {
            open: dialogOpen,
            message: dialogMessage,
            onConfirm: handleConfirm,
            onCancel: handleCancel
        }
    };
};

});
parcelRegister("3P4Kr", function(module, exports) {

$parcel$export(module.exports, "WIREGUARD_OVER_NAT_MESSAGE", () => $6d715a58ee980ccf$export$8d849730f9495d51);
$parcel$export(module.exports, "NAT_OVER_WIREGUARD_MESSAGE", () => $6d715a58ee980ccf$export$e0598e4282d6af3c);
$parcel$export(module.exports, "areNatAndWireguardFieldsVisible", () => $6d715a58ee980ccf$export$b7cc1ae1443bb230);
$parcel$export(module.exports, "shouldPromptWireguardOverNat", () => $6d715a58ee980ccf$export$3afe0447c92444ad);
$parcel$export(module.exports, "shouldPromptNatOverWireguard", () => $6d715a58ee980ccf$export$86ef4ad49a72dc9b);
$parcel$export(module.exports, "applyWireguardOverNat", () => $6d715a58ee980ccf$export$854a08d0b6cac8a6);
$parcel$export(module.exports, "applyNatOverWireguard", () => $6d715a58ee980ccf$export$5bced56397547204);
const $6d715a58ee980ccf$export$8d849730f9495d51 = "Enabling WireGuard will DISABLE the NAT (Whitelisting) for this site and cameras will need to be edited accordingly to connect through WireGuard. Do you wish to proceed?";
const $6d715a58ee980ccf$export$e0598e4282d6af3c = "Enabling NAT whitelisting will DISABLE WireGuard for this site and cameras will need to be edited accordingly to connect through NAT. Do you wish to proceed?";
const $6d715a58ee980ccf$export$b7cc1ae1443bb230 = (siteInfo, showWireguardFlag)=>Boolean(siteInfo.show_ecs_nat_instance) && showWireguardFlag && Boolean(siteInfo.display_wireguard);
const $6d715a58ee980ccf$export$3afe0447c92444ad = (siteInfo)=>siteInfo.ecs_nat_instance === true && siteInfo.wireguard == null;
const $6d715a58ee980ccf$export$86ef4ad49a72dc9b = (siteInfo, natChecked)=>natChecked === true && siteInfo.ecs_nat_instance === false && siteInfo.wireguard != null;
const $6d715a58ee980ccf$export$854a08d0b6cac8a6 = (wireguardId)=>({
        wireguard: wireguardId,
        ecs_nat_instance: false
    });
const $6d715a58ee980ccf$export$5bced56397547204 = ()=>({
        ecs_nat_instance: true,
        wireguard: null
    });

});



parcelRegister("1W2ma", function(module, exports) {

$parcel$export(module.exports, "GeneralInfoTabAutoPatrol", () => $c08f74be0f466e1f$export$885d65a8b1c0532f);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $8B8vg = parcelRequire("8B8vg");
var $ddLR4 = parcelRequire("ddLR4");
var $eejVe = parcelRequire("eejVe");
var $cVCJe = parcelRequire("cVCJe");

var $gfzcx = parcelRequire("gfzcx");

var $3mOKt = parcelRequire("3mOKt");

var $aYdit = parcelRequire("aYdit");

var $4PFLW = parcelRequire("4PFLW");

var $8jTCz = parcelRequire("8jTCz");

var $5jwbk = parcelRequire("5jwbk");

var $ehkIG = parcelRequire("ehkIG");

var $ePwXE = parcelRequire("ePwXE");

var $6PfL8 = parcelRequire("6PfL8");

var $jDisJ = parcelRequire("jDisJ");

var $3FJ79 = parcelRequire("3FJ79");

var $3JJWq = parcelRequire("3JJWq");

var $OrEsi = parcelRequire("OrEsi");

var $2dCK7 = parcelRequire("2dCK7");

var $SkEiS = parcelRequire("SkEiS");
const $c08f74be0f466e1f$export$885d65a8b1c0532f = ({ editMode: editMode })=>{
    const navigate = (0, $3T949.useNavigate)();
    const { wireGuardOptions: wireGuardOptions } = (0, $aYdit.useAppStore)();
    const { isFeatureEnabled: isFeatureEnabled } = (0, $4PFLW.useFeatureFlag)();
    const showWireguard = isFeatureEnabled("showWireguard", false);
    const { siteInfo: siteInfo, setSiteInfo: setSiteInfo, generalInfoTabPatchObject: generalInfoTabPatchObject, setGeneralInfoTabPatchObject: setGeneralInfoTabPatchObject, setGeneralInfoTabChangesMade: setGeneralInfoTabChangesMade, vCHOnlySchedules: vCHOnlySchedules } = (0, $3FJ79.useSiteAboutStore)();
    const shouldShowWireguardAvailabilityZone = showWireguard && Boolean(siteInfo.display_wireguard);
    const setSiteInfoCompat = $8T3gX.useCallback((update)=>{
        const current = (0, $3FJ79.useSiteAboutStore).getState().siteInfo;
        const next = typeof update === "function" ? update(current) : update;
        setSiteInfo(next);
    }, [
        setSiteInfo
    ]);
    const setPatchObjectCompat = $8T3gX.useCallback((update)=>{
        const current = (0, $3FJ79.useSiteAboutStore).getState().generalInfoTabPatchObject;
        const next = typeof update === "function" ? update(current) : update;
        setGeneralInfoTabPatchObject(next);
    }, [
        setGeneralInfoTabPatchObject
    ]);
    const { ecsNatInstance: ecsNatInstance, wireguard: wireguardId, wireguardAutocompleteKey: wireguardAutocompleteKey, handleWireguardSelection: handleWireguardSelection, handleNatToggle: handleNatToggle, conflictDialogProps: conflictDialogProps } = (0, $SkEiS.useNatWireguardConflictDialog)({
        siteInfo: siteInfo,
        showWireguardFlag: showWireguard,
        enabled: editMode && !vCHOnlySchedules,
        setSiteInfo: setSiteInfoCompat,
        setPatchObject: setPatchObjectCompat,
        setChangesMade: setGeneralInfoTabChangesMade
    });
    const selectedWireguardName = wireGuardOptions.find((option)=>option.id === wireguardId)?.name ?? null;
    const [seeNotesDialogOpen, setSeeNotesDialogOpen] = $8T3gX.useState(false);
    const [noteText, setNoteText] = $8T3gX.useState(siteInfo.notes ?? "");
    const groupOptions = ((0, $3JJWq.safeGetItem)("parentGroups", []) ?? []).filter((group)=>group.parent_account === true);
    const groupOptionsIds = new Map();
    const groupOptionsNames = new Map();
    const groupStandardNames = new Map();
    groupOptions.forEach((option)=>{
        groupOptionsIds.set(option.id, `${option.name} (group id: ${option.id})`);
    });
    groupOptions.forEach((option)=>{
        groupOptionsNames.set(`${option.name} (group id: ${option.id})`, option.id);
    });
    groupOptions.forEach((option)=>{
        groupStandardNames.set(`${option.name} (group id: ${option.id})`, option.name);
    });
    const alarmOptions = (0, $3JJWq.safeGetItem)("alarmOptions", []) ?? [];
    const alarmIds = new Map();
    alarmOptions.forEach((object)=>{
        alarmIds.set(object.value, object.name);
    });
    const alarmNames = new Map();
    alarmOptions.forEach((object)=>{
        alarmNames.set(object.name, object.value);
    });
    const titlesArray = [
        "Site Name",
        "Timezone",
        "Integration Type",
        "Parent Group"
    ];
    if (siteInfo.show_ecs_nat_instance) titlesArray.push("Whitelisting");
    // Single row titles for General Site Info (standard view)
    const generalInfoTitlesSingleRow = (()=>{
        const base = [
            "Site Name",
            "Timezone",
            "Integration Type",
            "Parent Group"
        ];
        if (siteInfo.show_ecs_nat_instance) base.push("Whitelisting");
        if (shouldShowWireguardAvailabilityZone) base.push("WireGuard Availability Zone");
        base.push("Last Synchronized", "Last Restart", "Last Alert", "Notes");
        return base;
    })();
    // Standard view (non-edit mode) — one table, one row
    const generalInfoTabAutoPatrol = /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            seeNotesDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $5jwbk.SeeNotesDialog), {
                seeNotesDialogOpen: seeNotesDialogOpen,
                setSeeNotesDialogOpen: setSeeNotesDialogOpen,
                defaultText: siteInfo.notes,
                onSubmitNotes: async (newNotes)=>{
                    const setSiteInfoCompat = (update)=>{
                        const current = (0, $3FJ79.useSiteAboutStore).getState().siteInfo;
                        const next = typeof update === "function" ? update(current) : update;
                        (0, $3FJ79.useSiteAboutStore).setState({
                            siteInfo: next
                        });
                    };
                    await (0, $OrEsi.handleSubmitUpdatedNotes)(newNotes, siteInfo.notes ?? "", setSiteInfoCompat, undefined, navigate);
                }
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                component: (0, $4reBM.default),
                sx: {
                    width: "100%",
                    mb: 2,
                    "& .MuiTableHead-root .MuiTableCell-root": {
                        borderBottom: "none"
                    }
                },
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                    sx: {
                        width: "100%",
                        fontFamily: "Mulish",
                        tableLayout: "fixed"
                    },
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                            titlesArray: generalInfoTitlesSingleRow
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: {
                                            fontFamily: "Mulish"
                                        },
                                        children: siteInfo.name
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: {
                                            fontFamily: "Mulish"
                                        },
                                        children: siteInfo.timezone
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: {
                                            fontFamily: "Mulish"
                                        },
                                        children: (0, $3mOKt.integrationsMatcher)("Name", siteInfo.integration_type)
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: {
                                            fontFamily: "Mulish"
                                        },
                                        children: siteInfo.breadcrumbs?.[siteInfo.breadcrumbs.length - 2] || siteInfo.parent_group?.name || "--"
                                    }),
                                    siteInfo.show_ecs_nat_instance && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: {
                                            fontFamily: "Mulish"
                                        },
                                        children: siteInfo.ecs_nat_instance ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                            defaultChecked: true,
                                            disabled: true,
                                            color: "warning"
                                        }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                            checked: false,
                                            disabled: true,
                                            color: "warning"
                                        })
                                    }),
                                    shouldShowWireguardAvailabilityZone && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: {
                                            fontFamily: "Mulish"
                                        },
                                        children: wireGuardOptions.find((option)=>option.id === siteInfo.wireguard)?.name || "--"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: {
                                            fontFamily: "Mulish"
                                        },
                                        children: [
                                            siteInfo.deployed_date ? (0, $ehkIG.epochToUPCCovertor)(siteInfo.deployed_date, siteInfo.timezone).toString() : "--",
                                            "\xa0",
                                            siteInfo.deployed_date && siteInfo.timezone ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                title: siteInfo.timezone,
                                                placement: "top",
                                                sx: {
                                                    fontSize: "15px",
                                                    fontFamily: "mulish"
                                                },
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                                    fontSize: "small"
                                                })
                                            }) : ""
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: {
                                            fontFamily: "Mulish"
                                        },
                                        children: [
                                            siteInfo.pod_boot_time ? (0, $ehkIG.epochToUPCCovertor)(siteInfo.pod_boot_time, siteInfo.timezone).toString() : "--",
                                            "\xa0",
                                            siteInfo.pod_boot_time && siteInfo.timezone ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                title: siteInfo.timezone,
                                                placement: "top",
                                                sx: {
                                                    fontSize: "15px",
                                                    fontFamily: "mulish"
                                                },
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                                    fontSize: "small"
                                                })
                                            }) : "",
                                            siteInfo.pod_boot_time && siteInfo.deployed_date && siteInfo.deployed_date > siteInfo.pod_boot_time ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                title: "Settings synced after last restart \u2014 rearm site to restart and apply changes.",
                                                placement: "top",
                                                sx: {
                                                    fontSize: "15px",
                                                    fontFamily: "mulish"
                                                },
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6PfL8))), {
                                                    fontSize: "small",
                                                    sx: {
                                                        color: "#ed6c02",
                                                        verticalAlign: "middle"
                                                    }
                                                })
                                            }) : ""
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: {
                                            fontFamily: "Mulish"
                                        },
                                        children: siteInfo.last_alert ? (0, $jDisJ.timeSinceConvertor)(siteInfo.last_alert) : "--"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: {
                                            fontFamily: "Mulish"
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                            text: "See Notes",
                                            onClick: ()=>{
                                                setSeeNotesDialogOpen(true);
                                            },
                                            disabled: false
                                        })
                                    })
                                ]
                            }, siteInfo.id)
                        })
                    ]
                })
            })
        ]
    });
    // Edit mode view
    const generalInfoTabAutoPatrolEditMode = /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "pb-[10px]",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $2dCK7.NatWireguardConflictDialog), {
                ...conflictDialogProps
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3Nm8Z.default), {
                component: (0, $4reBM.default),
                sx: {
                    "& .MuiTableHead-root .MuiTableCell-root": {
                        borderBottom: "none"
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                        sx: {
                            minWidth: 1000,
                            fontFamily: "Mulish"
                        },
                        "aria-label": "simple table",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                titlesArray: titlesArray
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            children: vCHOnlySchedules ? siteInfo.name : /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                    defaultValue: siteInfo.name,
                                                    variant: "standard",
                                                    sx: {
                                                        width: 200
                                                    },
                                                    type: "string",
                                                    onChange: (event)=>{
                                                        setGeneralInfoTabPatchObject({
                                                            ...generalInfoTabPatchObject,
                                                            name: event.target.value
                                                        });
                                                        setSiteInfo({
                                                            ...siteInfo,
                                                            name: event.target.value
                                                        });
                                                        setGeneralInfoTabChangesMade(true);
                                                    }
                                                })
                                            }, siteInfo.name)
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            children: vCHOnlySchedules ? siteInfo.timezone : /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                                    disablePortal: true,
                                                    options: (0, $3JJWq.safeGetItem)("timeZoneArray", []) ?? [],
                                                    defaultValue: siteInfo.timezone,
                                                    sx: {
                                                        width: 200
                                                    },
                                                    onInputChange: (event, newInputValue)=>{
                                                        setGeneralInfoTabPatchObject({
                                                            ...generalInfoTabPatchObject,
                                                            timezone: newInputValue
                                                        });
                                                        setSiteInfo({
                                                            ...siteInfo,
                                                            timezone: newInputValue
                                                        });
                                                        setGeneralInfoTabChangesMade(true);
                                                    },
                                                    renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                            ...params,
                                                            variant: "standard",
                                                            autoComplete: "off"
                                                        })
                                                })
                                            }, siteInfo.timezone)
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            children: (0, $3mOKt.integrationsMatcher)("Name", siteInfo.integration_type)
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            children: vCHOnlySchedules ? siteInfo.breadcrumbs?.[siteInfo.breadcrumbs.length - 2] || siteInfo.parent_group?.name || "--" : /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                                    disablePortal: true,
                                                    options: groupOptions.map((option)=>{
                                                        return `${option.name} (group id: ${option.id})`;
                                                    }),
                                                    defaultValue: siteInfo.breadcrumbs?.[siteInfo.breadcrumbs.length - 2],
                                                    sx: {
                                                        width: 150
                                                    },
                                                    onInputChange: (event, newInputValue)=>{
                                                        setGeneralInfoTabPatchObject({
                                                            ...generalInfoTabPatchObject,
                                                            parent_group: {
                                                                parent: groupOptionsNames.get(newInputValue)
                                                            }
                                                        });
                                                        setSiteInfo({
                                                            ...siteInfo,
                                                            parent_group: {
                                                                name: groupStandardNames.get(newInputValue)
                                                            }
                                                        });
                                                        localStorage.setItem("groupNameChange", "true");
                                                    },
                                                    renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                            ...params,
                                                            variant: "standard",
                                                            autoComplete: "off"
                                                        })
                                                })
                                            }, siteInfo.breadcrumbs?.[0])
                                        }),
                                        siteInfo.show_ecs_nat_instance && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            children: vCHOnlySchedules ? siteInfo.ecs_nat_instance ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                defaultChecked: true,
                                                disabled: true,
                                                color: "warning"
                                            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                checked: false,
                                                disabled: true,
                                                color: "warning"
                                            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                checked: ecsNatInstance,
                                                disabled: false,
                                                color: "warning",
                                                onChange: (event)=>{
                                                    handleNatToggle(event.target.checked);
                                                }
                                            })
                                        })
                                    ]
                                }, siteInfo.id)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                        sx: {
                            minWidth: 1000,
                            fontFamily: "Mulish"
                        },
                        "aria-label": "simple table",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                titlesArray: shouldShowWireguardAvailabilityZone ? [
                                    "WireGuard Availability Zone",
                                    "Notes",
                                    "",
                                    "",
                                    "",
                                    ""
                                ] : [
                                    "Notes",
                                    "",
                                    "",
                                    "",
                                    "",
                                    ""
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                    children: [
                                        shouldShowWireguardAvailabilityZone && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish",
                                                verticalAlign: "top"
                                            },
                                            children: vCHOnlySchedules ? wireGuardOptions.find((option)=>option.id === siteInfo.wireguard)?.name || "--" : /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                                disablePortal: true,
                                                options: wireGuardOptions.map((option)=>option.name),
                                                value: selectedWireguardName,
                                                sx: {
                                                    width: 300
                                                },
                                                onChange: (_event, newValue)=>{
                                                    if (!newValue) return;
                                                    const selectedOption = wireGuardOptions.find((option)=>option.name === newValue);
                                                    if (selectedOption) handleWireguardSelection(selectedOption.id);
                                                },
                                                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                        ...params,
                                                        variant: "standard",
                                                        autoComplete: "off"
                                                    })
                                            }, wireguardAutocompleteKey)
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                onChange: (event)=>{
                                                    setGeneralInfoTabPatchObject({
                                                        ...generalInfoTabPatchObject,
                                                        notes: event.target.value
                                                    });
                                                    setSiteInfo({
                                                        ...siteInfo,
                                                        notes: event.target.value
                                                    });
                                                    setNoteText(event.target.value);
                                                    setGeneralInfoTabChangesMade(true);
                                                },
                                                value: noteText,
                                                variant: "outlined",
                                                multiline: true,
                                                rows: 6,
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    width: 400
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {}),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {}),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {}),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {}),
                                        !shouldShowWireguardAvailabilityZone && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {})
                                    ]
                                }, siteInfo.id)
                            })
                        ]
                    })
                ]
            })
        ]
    });
    return editMode ? generalInfoTabAutoPatrolEditMode : generalInfoTabAutoPatrol;
};

});
parcelRegister("OrEsi", function(module, exports) {

$parcel$export(module.exports, "handleSubmitUpdatedNotes", () => $1e12a84c382d9c15$export$7eb57273d0661385);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("elyck");
var $h5bv8 = parcelRequire("h5bv8");

var $1Ah5f = parcelRequire("1Ah5f");
const $1e12a84c382d9c15$export$7eb57273d0661385 = (newNotes, backupNotes, setSiteInfo, setActiveTab, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $1e12a84c382d9c15$export$7eb57273d0661385(newNotes, backupNotes, setSiteInfo, setActiveTab, navigate);
    };
    return AxiosUI.patch(`customer/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}/about/`, {
        notes: newNotes
    }).then((response)=>{
        const siteInfo = response.data;
        setSiteInfo((previousState)=>({
                ...previousState,
                ...siteInfo,
                notes: newNotes
            }));
        if (setActiveTab) {
            setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
            const newVMSVariables = [];
            siteInfo.extra_fields?.forEach((object)=>{
                const newArray = [
                    `${object.label}`,
                    `${siteInfo[object.id]}`,
                    `${object.id}`,
                    `${object.type}`,
                    object.choices
                ];
                object.choices ? newArray[4] = object.choices : newArray[4] = object.options;
                // ENG-2535: [5] = visible_when display rule (absent = always shown)
                newArray[5] = object.visible_when;
                newVMSVariables.push(newArray);
            });
            setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $1Ah5f.GeneralInfoTab), {
                siteInfo: siteInfo,
                setSiteInfo: setSiteInfo,
                setActiveTab: setActiveTab,
                vmsVariables: newVMSVariables
            }));
        }
    }).catch((reason)=>{
        return new Promise((_, reject)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                setSiteInfo((previousState)=>({
                        ...previousState,
                        notes: backupNotes
                    }));
                alert("Notes could not be updated. Please try again.");
                reject(reason);
            });
        });
    });
};

});


parcelRegister("iTHZG", function(module, exports) {

$parcel$export(module.exports, "SchedulesTabEditMode", () => $d9cc14389c62ce6a$export$7d579652369b13da);
/* eslint-disable @typescript-eslint/no-non-null-assertion */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $3baw3 = parcelRequire("3baw3");
var $ddLR4 = parcelRequire("ddLR4");
var $cVCJe = parcelRequire("cVCJe");

var $ePwXE = parcelRequire("ePwXE");

var $idDbD = parcelRequire("idDbD");

var $aNeNX = parcelRequire("aNeNX");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $8jTCz = parcelRequire("8jTCz");

var $abNiM = parcelRequire("abNiM");

var $2uQ4j = parcelRequire("2uQ4j");

var $6pdiI = parcelRequire("6pdiI");

var $22eoh = parcelRequire("22eoh");

var $74XHu = parcelRequire("74XHu");

var $dHtmK = parcelRequire("dHtmK");

var $cye0Y = parcelRequire("cye0Y");

var $kDhtU = parcelRequire("kDhtU");

var $3FJ79 = parcelRequire("3FJ79");

var $5zfN2 = parcelRequire("5zfN2");

var $cREnW = parcelRequire("cREnW");

var $jY59N = parcelRequire("jY59N");

var $eYzFO = parcelRequire("eYzFO");

var $9mFrR = parcelRequire("9mFrR");

var $16Em8 = parcelRequire("16Em8");

var $4PFLW = parcelRequire("4PFLW");

var $5P5Ui = parcelRequire("5P5Ui");
const $d9cc14389c62ce6a$export$7d579652369b13da = ({ siteInfo: siteInfo, setEditMode: setEditMode, setSiteInfo: setSiteInfo, setActiveTab: setActiveTab })=>{
    const navigate = (0, $3T949.useNavigate)();
    const { siteSchedules: siteSchedules, schedulesIndex: schedulesIndex, editActiveProductsDialogOpen: editActiveProductsDialogOpen, setEditActiveProductsDialogOpen: setEditActiveProductsDialogOpen, editScheduleNameDialogOpen: editScheduleNameDialogOpen, setEditScheduleNameDialogOpen: setEditScheduleNameDialogOpen, flexSchedulesOn: flexSchedulesOn, deleteScheduleDialogOpen: deleteScheduleDialogOpen, setDeleteScheduleDialogOpen: setDeleteScheduleDialogOpen, schedulesBackdropLoadingScreenOn: schedulesBackdropLoadingScreenOn, handleFlexSchedulingToggle: handleFlexSchedulingToggle, handleAddSchedule: handleAddSchedule } = (0, $3FJ79.useSiteAboutStore)();
    const { isFeatureEnabled: isFeatureEnabled } = (0, $4PFLW.useFeatureFlag)();
    const showFlexIgnoreZones = isFeatureEnabled("showFlexIgnoreZones", false);
    const enabledBySite = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((state)=>showFlexIgnoreZones ? state.enabledBySite : (0, $9mFrR.FLEX_IZ_LD_EMPTY_ENABLED_BY_SITE));
    const setEnabledForSite = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((state)=>state.setEnabledForSite);
    const initializeFromSite = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((state)=>state.initializeFromSite);
    const flexIgnoreZonesEnabledSyncLoadingBySite = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((state)=>showFlexIgnoreZones ? state.flexIgnoreZonesEnabledSyncLoadingBySite : (0, $9mFrR.FLEX_IZ_LD_EMPTY_SYNC_LOADING));
    const [offboardingDialogOpen, setOffboardingDialogOpen] = $8T3gX.useState(false);
    const handleCloseOffboardingDialog = ()=>{
        setOffboardingDialogOpen(false);
        window.dispatchEvent(new CustomEvent("refreshSiteCamerasTable"));
    };
    const userInfo = JSON.parse(localStorage.userInfo);
    const permissions = userInfo.permission;
    const isSuperUser = userInfo.username.includes("@aegissystems") || userInfo.username.includes("@actuate") || userInfo.email.includes("@aegissystems") || userInfo.email.includes("@actuate");
    const siteCameras = JSON.parse(localStorage.siteCameras || '{"results": []}');
    const flexIgnoreZonesSyncLoading = flexIgnoreZonesEnabledSyncLoadingBySite[siteInfo.id] === true;
    const flexIgnoreZonesEnabled = enabledBySite[siteInfo.id] === true;
    const products = JSON.parse(localStorage.products);
    const productIds = new Map();
    products.forEach((product)=>{
        productIds.set(product.id, product.name);
    });
    // ENG-2631: show overrides while editing too, so a holiday that replaces
    // the week being edited isn't a surprise.
    const { overrides: overrides, todayIso: todayIso } = (0, $aNeNX.useScheduleOverrides)(siteInfo.id, siteInfo.timezone);
    if (siteInfo.integration_type_name === "autopatrol") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $5zfN2.SchedulesTabAutopatrol), {
        editMode: true
    });
    const fullSchedulesTab = /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "pb-[10px]",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                openState: schedulesBackdropLoadingScreenOn
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "border-t border-gray-200"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aNeNX.ScheduleOverridesNotice), {
                overrides: overrides,
                todayIso: todayIso
            }),
            editActiveProductsDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $22eoh.EditActiveProductsDialog), {}),
            editScheduleNameDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $74XHu.EditScheduleNameDialog), {}),
            showFlexIgnoreZones && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cREnW.FlexIgnoreZonesOnboardingDialog), {
                isFleetSite: (0, $5P5Ui.isFleetSite)(siteInfo),
                onClose: ()=>{
                // Intentionally no-op, dialog store handles close lifecycle.
                },
                onSuccessfulSubmit: ()=>{
                    setEditMode(false);
                    setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $2uQ4j.SchedulesTab), {
                        siteInfo: siteInfo
                    }));
                }
            }),
            showFlexIgnoreZones && /*#__PURE__*/ (0, $k4ank.jsx)((0, $jY59N.FlexIgnoreZonesOffboardingDialog), {
                open: offboardingDialogOpen,
                siteId: siteInfo.id,
                currentScheduleId: siteSchedules[schedulesIndex]?.id,
                cameras: (siteCameras.results || []).map((camera)=>({
                        id: Number(camera.id),
                        camera_name: camera.camera_name,
                        preview_url: camera.preview_url,
                        ignore_zones: camera.ignore_zones
                    })),
                onClose: handleCloseOffboardingDialog,
                onSubmitted: ()=>{
                    setEnabledForSite(siteInfo.id, false);
                    setEditMode(false);
                    setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $2uQ4j.SchedulesTab), {
                        siteInfo: siteInfo
                    }));
                }
            }),
            deleteScheduleDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $kDhtU.DeleteScheduleDialog), {
                scheduleName: siteSchedules[schedulesIndex]?.display_name,
                scheduleId: siteSchedules[schedulesIndex]?.id
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: `relative top-[0px] ${!flexSchedulesOn ? "h-[460]" : siteSchedules.length >= 2 ? "h-[560px]" : "h-[540px]"} bg-white overflow-scroll`,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "flex w-full items-center justify-between pr-3",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "flex items-center flex-wrap",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                        className: "font-black font-mulish text-[20px] p-3 indent-4",
                                        children: [
                                            "Schedule Overview \xa0",
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                title: `Scheduled arming time ranges are highlighted in green.`,
                                                placement: "top",
                                                sx: {
                                                    fontSize: "15px",
                                                    fontFamily: "mulish"
                                                },
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                                    fontSize: "small"
                                                })
                                            })
                                        ]
                                    }),
                                    permissions.flex_schedule && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "pl-[30px] pt-[10px] flex flex-wrap",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                    color: "warning",
                                                    checked: flexSchedulesOn,
                                                    disabled: false,
                                                    onChange: (event)=>{
                                                        handleFlexSchedulingToggle(event.target.checked, setSiteInfo, setEditMode, setActiveTab, siteInfo, navigate);
                                                    }
                                                }),
                                                label: "Flex Scheduling"
                                            }),
                                            showFlexIgnoreZones && flexSchedulesOn && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                    color: "warning",
                                                    checked: flexIgnoreZonesEnabled,
                                                    disabled: flexIgnoreZonesSyncLoading,
                                                    onChange: (event)=>{
                                                        const enabled = event.target.checked;
                                                        if (enabled) {
                                                            setEnabledForSite(siteInfo.id, true);
                                                            initializeFromSite({
                                                                siteId: siteInfo.id,
                                                                schedules: siteSchedules.map((schedule, index)=>({
                                                                        id: Number(schedule.id ?? index + 1),
                                                                        display_name: schedule.display_name || `Schedule ${index + 1}`
                                                                    })),
                                                                cameras: (siteCameras.results || []).map((camera)=>({
                                                                        id: Number(camera.id),
                                                                        camera_name: camera.camera_name,
                                                                        preview_url: camera.preview_url,
                                                                        ignore_zones: camera.ignore_zones
                                                                    }))
                                                            });
                                                        } else setOffboardingDialogOpen(true);
                                                    }
                                                }),
                                                label: "Flex Ignore Zones"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            siteSchedules.length < 3 && flexSchedulesOn && permissions.flex_schedule && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "shrink-0 pt-[15px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    onClick: ()=>{
                                        handleAddSchedule(navigate);
                                    },
                                    text: "+ Add Schedule",
                                    disabled: false
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "pb-[10px]",
                        children: siteSchedules.length >= 2 && flexSchedulesOn && permissions.flex_schedule && /*#__PURE__*/ (0, $k4ank.jsx)((0, $abNiM.SchedulesTabs), {})
                    }),
                    flexSchedulesOn && permissions.flex_schedule && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "flex",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "pl-[30px] pb-[10px] overflow-scroll flex",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "font-black font-mulish text-[20px] flex items-center",
                                    children: [
                                        siteSchedules[schedulesIndex]?.display_name ? siteSchedules[schedulesIndex]?.display_name : `Schedule ${schedulesIndex + 1}`,
                                        isSuperUser && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "pl-[10px] pb-[px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                title: siteSchedules[schedulesIndex]?.log_name ? `${siteSchedules[schedulesIndex].log_name}` : "",
                                                placement: "top",
                                                sx: {
                                                    fontSize: "15px",
                                                    fontFamily: "mulish"
                                                },
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                                    fontSize: "small"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "relative top-[-5px]",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                        onClick: ()=>{
                                            setEditScheduleNameDialogOpen(true);
                                        },
                                        text: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                            title: "Edit Schedule Name",
                                            placement: "top",
                                            sx: {
                                                fontSize: "20px",
                                                fontFamily: "mulish"
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {})
                                        }),
                                        disabled: false
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "font-black font-mulish text-[16px] pl-[30px] pt-[5px]",
                                            children: `Active Products: `
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "pl-[6px] text-[16px] pt-[5px]",
                                            children: siteSchedules[schedulesIndex]?.product ? `${siteSchedules[schedulesIndex].product.map((product)=>{
                                                return `${productIds.get(product)}`;
                                            }).join(", ")}` : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {})
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "relative top-[-5px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                onClick: ()=>{
                                                    setEditActiveProductsDialogOpen(true);
                                                },
                                                text: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                    title: "Edit Active Products",
                                                    placement: "top",
                                                    sx: {
                                                        fontSize: "20px",
                                                        fontFamily: "mulish"
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {})
                                                }),
                                                disabled: false
                                            })
                                        }),
                                        siteSchedules.length > 1 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "pl-[30px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                onClick: ()=>setDeleteScheduleDialogOpen(true),
                                                text: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cye0Y))), {
                                                            fontSize: "small"
                                                        }),
                                                        "\xa0Delete Schedule"
                                                    ]
                                                }),
                                                disabled: false
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "relative top-[0px] left-[15px] w-[1500px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $idDbD.ScheduleGrid), {})
                    })
                ]
            }),
            showFlexIgnoreZones && flexSchedulesOn && flexIgnoreZonesEnabled && /*#__PURE__*/ (0, $k4ank.jsx)((0, $16Em8.FlexIgnoreZonesScheduleEditPresetSection), {
                siteInfo: siteInfo,
                showFlexIgnoreZones: showFlexIgnoreZones,
                flexIgnoreZonesEnabled: flexIgnoreZonesEnabled,
                flexSchedulesOn: flexSchedulesOn
            })
        ]
    });
    const remoteLinkSchedulesTab = /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "pb-[10px]",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "border-t border-gray-200"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "relative top-[0px] h-[60px] bg-white overflow-scroll",
                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "flex",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-mulish text-[18px] p-3 text-center w-full",
                        children: "Remote Link enabled. See IMMIX for site schedule."
                    })
                })
            })
        ]
    });
    return siteInfo.has_remote_link ? remoteLinkSchedulesTab : fullSchedulesTab;
};

});
parcelRegister("aNeNX", function(module, exports) {

$parcel$export(module.exports, "useScheduleOverrides", () => $be25bdc8bf623b24$export$7781175dbad2448d);
$parcel$export(module.exports, "ScheduleOverridesNotice", () => $be25bdc8bf623b24$export$2d1f8cab34fb3214);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $3QMQN = parcelRequire("3QMQN");
var $a65wX = parcelRequire("a65wX");

var $195EM = parcelRequire("195EM");

var $ebTQj = parcelRequire("ebTQj");

var $f0C6U = parcelRequire("f0C6U");
const $be25bdc8bf623b24$export$7781175dbad2448d = (siteId, timezone)=>{
    const [rows, setRows] = $8T3gX.useState([]);
    const todayIso = (0, $f0C6U.todayInTimezone)(timezone);
    $8T3gX.useEffect(()=>{
        if (!siteId) return;
        let cancelled = false;
        (0, $195EM.createApi)(``).get(`schedule/by_customer/${siteId}/`, {
            // Capitalised on purpose: by_customer hands these straight to the ORM
            // on admin before #3206, and Django's BooleanField accepts "True" but
            // 500s on "true". "True" also works after #3206 (DRF-style parsing).
            params: {
                is_override: "True",
                enabled: "True"
            }
        }).then((response)=>{
            if (!cancelled) setRows(Array.isArray(response.data) ? response.data : []);
        }).catch((error)=>{
            (0, $ebTQj.logger).error("schedule override lookup failed", error);
            if (!cancelled) setRows([]);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        siteId
    ]);
    const overrides = $8T3gX.useMemo(()=>(0, $f0C6U.activeAndUpcomingOverrides)(rows, todayIso), [
        rows,
        todayIso
    ]);
    return {
        overrides: overrides,
        todayIso: todayIso
    };
};
const $be25bdc8bf623b24$export$5b510f84edc2f3a5 = 5;
const $be25bdc8bf623b24$export$2d1f8cab34fb3214 = ({ overrides: overrides, todayIso: todayIso })=>{
    const [showAll, setShowAll] = $8T3gX.useState(false);
    if (overrides.length === 0) return null;
    const described = overrides.map((row)=>(0, $f0C6U.describeOverride)(row, todayIso));
    const anyToday = described.some((d)=>d.inEffectToday);
    // Earliest first, so anything in effect today is always in the short list.
    const shown = showAll ? described : described.slice(0, $be25bdc8bf623b24$export$5b510f84edc2f3a5);
    const hidden = described.length - shown.length;
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3QMQN.default), {
        severity: anyToday ? "warning" : "info",
        sx: {
            fontFamily: "Mulish",
            mx: "15px",
            mt: "10px"
        },
        "data-testid": "schedule-overrides-notice",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "font-bold",
                children: anyToday ? "Holiday schedule in effect today" : "Upcoming holiday schedule"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "pb-[4px]",
                children: "On these dates the override replaces the regular schedule below: the site arms and disarms only as listed."
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("ul", {
                className: "list-disc pl-[20px]",
                children: shown.map((d)=>/*#__PURE__*/ (0, $k4ank.jsxs)("li", {
                        children: [
                            "Holiday override \xb7 ",
                            d.dateLabel,
                            " \xb7 ",
                            d.windowLabel,
                            " \xb7 replaces the regular schedule"
                        ]
                    }, d.id))
            }),
            described.length > $be25bdc8bf623b24$export$5b510f84edc2f3a5 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                size: "small",
                color: "inherit",
                onClick: ()=>setShowAll((value)=>!value),
                sx: {
                    textTransform: "none",
                    fontFamily: "Mulish",
                    px: 0,
                    mt: 0.5
                },
                "data-testid": "schedule-overrides-toggle",
                children: showAll ? "Show fewer" : `and ${hidden} more \u{2014} show all ${described.length}`
            })
        ]
    });
};

});
parcelRegister("f0C6U", function(module, exports) {

$parcel$export(module.exports, "todayInTimezone", () => $ea412f16dd8843da$export$1a75120707ea7282);
$parcel$export(module.exports, "activeAndUpcomingOverrides", () => $ea412f16dd8843da$export$f04f259ebec2ca87);
$parcel$export(module.exports, "describeOverride", () => $ea412f16dd8843da$export$8528e75e0ea44932);
$parcel$export(module.exports, "overrideWeekdaysWithinWeek", () => $ea412f16dd8843da$export$f01cc375d006123b);
$parcel$export(module.exports, "overrideBannerText", () => $ea412f16dd8843da$export$ad8867a1f60efbd6);
/**
 * Schedule overrides (holiday calendar events and one-off override rows),
 * ENG-2631.
 *
 * An override replaces the site's regular weekly schedule on its dates: on
 * NZ Labour Day an all-day override armed Crosbies 52592 00:00–23:59, so the
 * regular Mon 19:00 arm never happened (SUP-954). The Schedules tab showed
 * only the weekly grid, so nobody could see that coming.
 *
 * Override rows always carry all seven weekdays (admin sets ALL_WEEK_VALS),
 * so the dates come from override_start_date / override_end_date only, never
 * from day_of_week. always_on means an all-day event; otherwise the site is
 * armed start_time–end_time on those dates.
 */ const $ea412f16dd8843da$var$ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;
const $ea412f16dd8843da$export$1a75120707ea7282 = (timezone, now = new Date())=>{
    try {
        // en-CA formats as YYYY-MM-DD.
        return new Intl.DateTimeFormat("en-CA", {
            timeZone: timezone || undefined,
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        }).format(now);
    } catch  {
        return new Intl.DateTimeFormat("en-CA", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        }).format(now);
    }
};
const $ea412f16dd8843da$var$asUtcDate = (iso)=>new Date(`${iso}T00:00:00Z`);
const $ea412f16dd8843da$var$addDays = (iso, days)=>{
    const date = $ea412f16dd8843da$var$asUtcDate(iso);
    date.setUTCDate(date.getUTCDate() + days);
    return date.toISOString().slice(0, 10);
};
const $ea412f16dd8843da$export$679c06884af23111 = (iso, todayIso)=>$ea412f16dd8843da$var$asUtcDate(iso).toLocaleDateString("en-GB", {
        weekday: "short",
        day: "numeric",
        month: "short",
        ...todayIso && iso.slice(0, 4) !== todayIso.slice(0, 4) ? {
            year: "numeric"
        } : {},
        timeZone: "UTC"
    }).replace(",", "");
const $ea412f16dd8843da$var$hhmm = (time)=>time ? time.slice(0, 5) : "";
const $ea412f16dd8843da$export$f04f259ebec2ca87 = (rows, todayIso)=>rows.filter((row)=>row.is_override && row.enabled && !!row.override_start_date && !!row.override_end_date && $ea412f16dd8843da$var$ISO_DATE.test(row.override_start_date) && $ea412f16dd8843da$var$ISO_DATE.test(row.override_end_date) && row.override_end_date >= todayIso).sort((a, b)=>a.override_start_date.localeCompare(b.override_start_date));
const $ea412f16dd8843da$export$8528e75e0ea44932 = (row, todayIso)=>{
    const start = row.override_start_date;
    const end = row.override_end_date;
    const inEffectToday = start <= todayIso && todayIso <= end;
    let dateLabel = start === end ? $ea412f16dd8843da$export$679c06884af23111(start, todayIso) : `${$ea412f16dd8843da$export$679c06884af23111(start, todayIso)} \u{2013} ${$ea412f16dd8843da$export$679c06884af23111(end, todayIso)}`;
    if (start === end && start === todayIso) dateLabel += " (today)";
    else if (inEffectToday) dateLabel += " (in effect now)";
    const windowLabel = row.always_on || !row.start_time || !row.end_time ? "armed all day (00:00\u201323:59)" : `armed ${$ea412f16dd8843da$var$hhmm(row.start_time)}\u{2013}${$ea412f16dd8843da$var$hhmm(row.end_time)}`;
    return {
        id: row.id,
        dateLabel: dateLabel,
        windowLabel: windowLabel,
        inEffectToday: inEffectToday
    };
};
const $ea412f16dd8843da$export$f01cc375d006123b = (rows, todayIso)=>{
    const marked = {};
    for(let offset = 0; offset < 7; offset += 1){
        const day = $ea412f16dd8843da$var$addDays(todayIso, offset);
        const hit = rows.some((row)=>row.override_start_date <= day && day <= row.override_end_date);
        if (hit) marked[$ea412f16dd8843da$var$asUtcDate(day).getUTCDay()] = $ea412f16dd8843da$export$679c06884af23111(day);
    }
    return marked;
};
const $ea412f16dd8843da$export$ad8867a1f60efbd6 = (site, todayIso = $ea412f16dd8843da$export$1a75120707ea7282(site.timezone))=>{
    const start = site.current_schedule_override_start;
    const end = site.current_schedule_override_end;
    if (!start || !end || !$ea412f16dd8843da$var$ISO_DATE.test(start) || !$ea412f16dd8843da$var$ISO_DATE.test(end)) return null;
    if (todayIso < start || todayIso > end) return null;
    const name = site.current_schedule_override_name?.trim();
    return name ? `${name}: holiday schedule in effect today` : "Holiday schedule in effect today";
};

});


parcelRegister("abNiM", function(module, exports) {

$parcel$export(module.exports, "SchedulesTabs", () => $d0cef9d8db68aaf5$export$65ee4b9f3d47a496);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");

var $3n3uW = parcelRequire("3n3uW");

var $2suvB = parcelRequire("2suvB");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

var $3FJ79 = parcelRequire("3FJ79");

var $2Mk2P = parcelRequire("2Mk2P");

var $axLUl = parcelRequire("axLUl");

var $bILSL = parcelRequire("bILSL");

var $7Gmex = parcelRequire("7Gmex");
const $d0cef9d8db68aaf5$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $d0cef9d8db68aaf5$export$65ee4b9f3d47a496 = ()=>//   {
//   clickedSchedulesTab,
//   setClickedSchedulesTab,
//   siteSchedules,
//   visibleSchedules,
//   setScheduleGrid,
//   setTimeRanges,
//   setGrid,
//   setDuskToDawn,
//   setDuskToDawnLocation,
//   setSelectedDayInfo,
//   setEditTimeScheduleDialogOpen,
//   setMatchingSchedules,
//   setScheduleChangesMade,
//   setSiteSchedules,
//   editMode,
//   setSchedulesIndex,
//   setEditModeTabSiteSchedules,
// }: {
//   clickedSchedulesTab: string;
//   setClickedSchedulesTab: Dispatcher<string>;
//   siteSchedules: any;
//   visibleSchedules: any;
//   setScheduleGrid: Dispatcher<any>;
//   setTimeRanges: Dispatcher<any>;
//   setGrid: Dispatcher<any>;
//   setDuskToDawn: Dispatcher<any>;
//   setDuskToDawnLocation: Dispatcher<any>;
//   setSelectedDayInfo: Dispatcher<any>;
//   setEditTimeScheduleDialogOpen: any;
//   setMatchingSchedules: Dispatcher<any>;
//   setScheduleChangesMade: any;
//   setSiteSchedules: Dispatcher<any>;
//   editMode: boolean;
//   setSchedulesIndex: Dispatcher<number>;
//   setEditModeTabSiteSchedules: any;
// }
{
    const { clickedSchedulesTab: clickedSchedulesTab, setClickedSchedulesTab: setClickedSchedulesTab, siteSchedules: siteSchedules, setTimeRanges: // visibleSchedules,
    setTimeRanges, setGrid: setGrid, setDuskToDawn: setDuskToDawn, setDuskToDawnLocation: setDuskToDawnLocation, setSelectedDayInfo: setSelectedDayInfo, setSchedulesIndex: setSchedulesIndex } = (0, $3FJ79.useSiteAboutStore)();
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{}, [
        clickedSchedulesTab
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
        sx: {
            maxWidth: {
                xs: 1320,
                sm: 1480
            },
            bgcolor: "background.paper"
        },
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
            theme: $d0cef9d8db68aaf5$var$theme,
            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3n3uW.default), {
                value: clickedSchedulesTab,
                onChange: (event, newValue)=>{
                    if (newValue === "one") {
                        localStorage.setItem("schedulesIndex", "0");
                        setClickedSchedulesTab("one");
                        setSchedulesIndex(0);
                        setTimeRanges((0, $2Mk2P.handleCreateInitialTimeSchedules)(siteSchedules[0].schedule));
                        setGrid((0, $axLUl.handleConvertSchedulesToBooleanArrays)(siteSchedules[0].schedule));
                        setDuskToDawn((0, $bILSL.handleCreateDuskToDawn)(siteSchedules[0].schedule));
                        setDuskToDawnLocation((0, $7Gmex.handleCreateDuskToDawnLocationPlusBuffer)(siteSchedules[0].schedule));
                        setSelectedDayInfo(siteSchedules[0]);
                    } else if (newValue === "two") {
                        localStorage.setItem("schedulesIndex", "1");
                        setClickedSchedulesTab("two");
                        setSchedulesIndex(1);
                        setTimeRanges((0, $2Mk2P.handleCreateInitialTimeSchedules)(siteSchedules[1].schedule));
                        setGrid((0, $axLUl.handleConvertSchedulesToBooleanArrays)(siteSchedules[1].schedule));
                        setDuskToDawn((0, $bILSL.handleCreateDuskToDawn)(siteSchedules[1].schedule));
                        setDuskToDawnLocation((0, $7Gmex.handleCreateDuskToDawnLocationPlusBuffer)(siteSchedules[1].schedule));
                        setSelectedDayInfo(siteSchedules[1]);
                    } else if (newValue === "three") {
                        localStorage.setItem("schedulesIndex", "2");
                        setClickedSchedulesTab("three");
                        setSchedulesIndex(2);
                        setTimeRanges((0, $2Mk2P.handleCreateInitialTimeSchedules)(siteSchedules[2].schedule));
                        setGrid((0, $axLUl.handleConvertSchedulesToBooleanArrays)(siteSchedules[2].schedule));
                        setDuskToDawn((0, $bILSL.handleCreateDuskToDawn)(siteSchedules[2].schedule));
                        setDuskToDawnLocation((0, $7Gmex.handleCreateDuskToDawnLocationPlusBuffer)(siteSchedules[2].schedule));
                        setSelectedDayInfo(siteSchedules[2]);
                    }
                },
                variant: "scrollable",
                scrollButtons: "auto",
                children: [
                    siteSchedules.length >= 1 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                        label: siteSchedules[0] ? `${siteSchedules[0].display_name}` : "Schedule 1",
                        value: "one"
                    }),
                    siteSchedules.length >= 2 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                        label: siteSchedules[1] ? `${siteSchedules[1].display_name}` : "Schedule 2",
                        value: "two"
                    }),
                    siteSchedules.length >= 3 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                        label: siteSchedules[2] ? `${siteSchedules[2].display_name}` : "Schedule 3",
                        value: "three"
                    })
                ]
            })
        })
    });
};

});

parcelRegister("22eoh", function(module, exports) {

$parcel$export(module.exports, "EditActiveProductsDialog", () => $ea51f4965e0a64d0$export$b546a153703dd1bd);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $8B8vg = parcelRequire("8B8vg");
var $kUcVg = parcelRequire("kUcVg");
var $eejVe = parcelRequire("eejVe");

var $gus0k = parcelRequire("gus0k");

var $kRZvb = parcelRequire("kRZvb");

var $f3puC = parcelRequire("f3puC");

var $8jTCz = parcelRequire("8jTCz");

var $1TOOV = parcelRequire("1TOOV");

var $887xF = parcelRequire("887xF");

var $bitEk = parcelRequire("bitEk");

var $3FJ79 = parcelRequire("3FJ79");

var $h5bv8 = parcelRequire("h5bv8");

var $7kQyB = parcelRequire("7kQyB");
const $ea51f4965e0a64d0$export$b546a153703dd1bd = ()=>{
    const navigate = (0, $3T949.useNavigate)();
    const { siteSchedules: siteSchedules, editActiveProductsDialogOpen: editActiveProductsDialogOpen, setEditActiveProductsDialogOpen: setEditActiveProductsDialogOpen, setSiteSchedules: setSiteSchedules, setScheduleChangesMade: setScheduleChangesMade, schedulesIndex: schedulesIndex } = (0, $3FJ79.useSiteAboutStore)();
    const [selectedProducts, setSelectedProducts] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [productOptions, setProductOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [isLoading, setIsLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    // Memoize the localStorage data to prevent infinite re-renders
    const products = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>{
        try {
            const productsData = localStorage.getItem("products");
            if (!productsData) return [];
            return JSON.parse(productsData);
        } catch (error) {
            return [];
        }
    }, []);
    const productIds = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>{
        const map = new Map();
        if (products && Array.isArray(products)) products.forEach((element)=>{
            if (element && element.name && element.id) map.set(element.id, `${element.name}`);
        });
        return map;
    }, [
        products
    ]);
    const productNames = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>{
        const map = new Map();
        if (products && Array.isArray(products)) products.forEach((element)=>{
            if (element && element.name && element.id) map.set(`${element.name}`, element.id);
        });
        return map;
    }, [
        products
    ]);
    // When dialog opens, fetch current site's products so we always show the correct list
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!editActiveProductsDialogOpen) return;
        let cancelled = false;
        setIsLoading(true);
        const siteId = (0, $h5bv8.getNumbersAfterAboutSite)(typeof window !== "undefined" ? window.location.href : "");
        if (!siteId) {
            // No site context (e.g. unexpected URL); fall back to localStorage
            try {
                const selectedData = localStorage.getItem("selectedProducts");
                const selectedProductsFromStorage = selectedData ? JSON.parse(selectedData) : [];
                if (Array.isArray(selectedProductsFromStorage) && selectedProductsFromStorage.length > 0) {
                    const options = selectedProductsFromStorage.map((id)=>productIds.get(id)).filter(Boolean);
                    if (!cancelled) {
                        setProductOptions(options);
                        if (siteSchedules?.[schedulesIndex]?.product) setSelectedProducts(siteSchedules[schedulesIndex].product.map((id)=>productIds.get(id)).filter(Boolean));
                    }
                } else if (!cancelled) setProductOptions([]);
            } catch  {
                if (!cancelled) setProductOptions([]);
            }
            if (!cancelled) setIsLoading(false);
            return;
        }
        (0, $7kQyB.fetchAddCameraInfo)(siteId, navigate).then((data)=>{
            if (cancelled) return;
            try {
                if (!products || !Array.isArray(products) || products.length === 0) {
                    setProductOptions([]);
                    setIsLoading(false);
                    return;
                }
                const siteProductIds = data?.initial_data?.products && Array.isArray(data.initial_data.products) ? data.initial_data.products : [];
                const options = siteProductIds.map((id)=>productIds.get(id)).filter(Boolean);
                setProductOptions(options);
                if (siteSchedules && siteSchedules[schedulesIndex] && siteSchedules[schedulesIndex].product) {
                    const initialSelected = siteSchedules[schedulesIndex].product.map((id)=>productIds.get(id)).filter(Boolean);
                    setSelectedProducts(initialSelected);
                } else setSelectedProducts([]);
            } catch  {
                setProductOptions([]);
                setSelectedProducts([]);
            }
            setIsLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        editActiveProductsDialogOpen,
        products,
        productIds,
        siteSchedules,
        schedulesIndex,
        navigate
    ]);
    // Don't render if still loading or if we don't have valid products list
    if (isLoading || !products || products.length === 0) return null;
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: editActiveProductsDialogOpen,
        onClose: ()=>setEditActiveProductsDialogOpen(false),
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gus0k.default), {
                sx: {
                    position: "relative"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kRZvb.default), {
                    sx: {
                        background: "#001943"
                    },
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            ml: 2,
                            flex: 1
                        },
                        variant: "h6",
                        component: "div",
                        children: "Edit Active Products"
                    })
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "h-[200px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: " bg-white",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "pt-[20px] pb-[30px]",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                        multiple: true,
                                        value: selectedProducts,
                                        disablePortal: true,
                                        options: productOptions,
                                        onChange: (event, value)=>{
                                            setSelectedProducts(value);
                                        },
                                        renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                ...params,
                                                label: "Product(s)",
                                                autoComplete: "off",
                                                sx: {
                                                    width: 400
                                                }
                                            })
                                    })
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "flex pr-[20px] pt-[20px]",
                    style: {
                        display: "flex"
                    },
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            style: {
                                marginLeft: "auto"
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    setEditActiveProductsDialogOpen(false);
                                },
                                text: "Cancel",
                                disabled: false
                            })
                        }),
                        "\xa0\xa0\xa0",
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    try {
                                        const newSiteSchedules = siteSchedules;
                                        newSiteSchedules[schedulesIndex].product = selectedProducts.map((name)=>productNames.get(name)).filter(Boolean); // Remove any undefined values
                                        setSiteSchedules(newSiteSchedules);
                                        setScheduleChangesMade(true);
                                        setEditActiveProductsDialogOpen(false);
                                        (0, $bitEk.handleCheckOverlappingSchedulesForSharedProducts)(newSiteSchedules);
                                    } catch (error) {
                                    // Error handling - you might want to show an error message to the user here
                                    }
                                },
                                text: "Ok",
                                disabled: false
                            })
                        })
                    ]
                })
            })
        ]
    });
};

});
parcelRegister("gus0k", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0152bc103df43f2$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $iMOmE = parcelRequire("iMOmE");

var $4reBM = parcelRequire("4reBM");

var $hamQF = parcelRequire("hamQF");

var $k4ank = parcelRequire("k4ank");
'use client';
const $c0152bc103df43f2$var$_excluded = [
    "className",
    "color",
    "enableColorOnDark",
    "position"
];
const $c0152bc103df43f2$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $iMOmE.default)(color)}`,
            `position${(0, $iMOmE.default)(position)}`
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $hamQF.getAppBarUtilityClass), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $c0152bc103df43f2$var$joinVars = (var1, var2)=>var1 ? `${var1 == null ? void 0 : var1.replace(')', '')}, ${var2})` : var2;
const $c0152bc103df43f2$var$AppBarRoot = (0, $anJSP.default)((0, $4reBM.default), {
    name: 'MuiAppBar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $iMOmE.default)(ownerState.position)}`],
            styles[`color${(0, $iMOmE.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const backgroundColorDefault = theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
    return (0, $eJfrs.default)({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0
    }, ownerState.position === 'fixed' && {
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0,
        '@media print': {
            // Prevent the app bar to be visible on each printed page.
            position: 'absolute'
        }
    }, ownerState.position === 'absolute' && {
        position: 'absolute',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0
    }, ownerState.position === 'sticky' && {
        // ⚠️ sticky is not supported by IE11.
        position: 'sticky',
        zIndex: (theme.vars || theme).zIndex.appBar,
        top: 0,
        left: 'auto',
        right: 0
    }, ownerState.position === 'static' && {
        position: 'static'
    }, ownerState.position === 'relative' && {
        position: 'relative'
    }, !theme.vars && (0, $eJfrs.default)({}, ownerState.color === 'default' && {
        backgroundColor: backgroundColorDefault,
        color: theme.palette.getContrastText(backgroundColorDefault)
    }, ownerState.color && ownerState.color !== 'default' && ownerState.color !== 'inherit' && ownerState.color !== 'transparent' && {
        backgroundColor: theme.palette[ownerState.color].main,
        color: theme.palette[ownerState.color].contrastText
    }, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, theme.palette.mode === 'dark' && !ownerState.enableColorOnDark && {
        backgroundColor: null,
        color: null
    }, ownerState.color === 'transparent' && (0, $eJfrs.default)({
        backgroundColor: 'transparent',
        color: 'inherit'
    }, theme.palette.mode === 'dark' && {
        backgroundImage: 'none'
    })), theme.vars && (0, $eJfrs.default)({}, ownerState.color === 'default' && {
        '--AppBar-background': ownerState.enableColorOnDark ? theme.vars.palette.AppBar.defaultBg : $c0152bc103df43f2$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette.AppBar.defaultBg),
        '--AppBar-color': ownerState.enableColorOnDark ? theme.vars.palette.text.primary : $c0152bc103df43f2$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette.text.primary)
    }, ownerState.color && !ownerState.color.match(/^(default|inherit|transparent)$/) && {
        '--AppBar-background': ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].main : $c0152bc103df43f2$var$joinVars(theme.vars.palette.AppBar.darkBg, theme.vars.palette[ownerState.color].main),
        '--AppBar-color': ownerState.enableColorOnDark ? theme.vars.palette[ownerState.color].contrastText : $c0152bc103df43f2$var$joinVars(theme.vars.palette.AppBar.darkColor, theme.vars.palette[ownerState.color].contrastText)
    }, ![
        'inherit',
        'transparent'
    ].includes(ownerState.color) && {
        backgroundColor: 'var(--AppBar-background)'
    }, {
        color: ownerState.color === 'inherit' ? 'inherit' : 'var(--AppBar-color)'
    }, ownerState.color === 'transparent' && {
        backgroundImage: 'none',
        backgroundColor: 'transparent',
        color: 'inherit'
    }));
});
const $c0152bc103df43f2$var$AppBar = /*#__PURE__*/ $8T3gX.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiAppBar'
    });
    const { className: className, color: color = 'primary', enableColorOnDark: enableColorOnDark = false, position: position = 'fixed' } = props, other = (0, $fAJB5.default)(props, $c0152bc103df43f2$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    });
    const classes = $c0152bc103df43f2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsx)($c0152bc103df43f2$var$AppBarRoot, (0, $eJfrs.default)({
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $iVyaN.default)(classes.root, className, position === 'fixed' && 'mui-fixed'),
        ref: ref
    }, other));
});
$c0152bc103df43f2$var$AppBar.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'default',
            'inherit',
            'primary',
            'secondary',
            'transparent',
            'error',
            'info',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * If true, the `color` prop is applied in dark mode.
   * @default false
   */ enableColorOnDark: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The positioning type. The behavior of the different options is described
   * [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   * @default 'fixed'
   */ position: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'absolute',
        'fixed',
        'relative',
        'static',
        'sticky'
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $c0152bc103df43f2$export$2e2bcd8739ae039 = $c0152bc103df43f2$var$AppBar;

});
parcelRegister("hamQF", function(module, exports) {

$parcel$export(module.exports, "getAppBarUtilityClass", () => $c7f5181787081e29$export$47a2da616e55e8e9);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $c7f5181787081e29$export$47a2da616e55e8e9(slot) {
    return (0, $kfTYv.default)('MuiAppBar', slot);
}
const $c7f5181787081e29$var$appBarClasses = (0, $jh2Zm.default)('MuiAppBar', [
    'root',
    'positionFixed',
    'positionAbsolute',
    'positionSticky',
    'positionStatic',
    'positionRelative',
    'colorDefault',
    'colorPrimary',
    'colorSecondary',
    'colorInherit',
    'colorTransparent',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning'
]);
var $c7f5181787081e29$export$2e2bcd8739ae039 = $c7f5181787081e29$var$appBarClasses;

});


parcelRegister("bitEk", function(module, exports) {

$parcel$export(module.exports, "handleCheckOverlappingSchedulesForSharedProducts", () => $52e405ef62f379b2$export$9d4af5304e5425b5);
$parcel$export(module.exports, "findOvernightOnlySharedProductOverlaps", () => $52e405ef62f379b2$export$32266c8148a27328);
const $52e405ef62f379b2$var$isValidTime = (time)=>{
    return time !== null && time !== ":00" && !time.includes("-");
};
const $52e405ef62f379b2$var$timeToMinutes = (time)=>{
    const [hours, minutes] = time.split(":".slice(0, 2)).map(Number);
    return hours * 60 + minutes;
};
/**
 * The rule the editor has always blocked on: rows sharing a weekday whose
 * windows overlap on that day (an overnight end just gets +24h). It never
 * looks at the after-midnight half landing on the next day.
 */ const $52e405ef62f379b2$var$sameDayOverlap = (a, b)=>{
    const daysB = b.day_of_week.map(String);
    if (!a.day_of_week.map(String).some((day)=>daysB.includes(day))) return false;
    const startA = $52e405ef62f379b2$var$timeToMinutes(a.start_time);
    let endA = $52e405ef62f379b2$var$timeToMinutes(a.end_time);
    const startB = $52e405ef62f379b2$var$timeToMinutes(b.start_time);
    let endB = $52e405ef62f379b2$var$timeToMinutes(b.end_time);
    if (endA < startA) endA += 1440;
    if (endB < startB) endB += 1440;
    return !(endA <= startB || endB <= startA);
};
const $52e405ef62f379b2$var$WEEK = 10080;
/**
 * Week-timeline intervals [start, end) for one schedule row: each selected
 * weekday ("0" = Sunday) places the window on that day, and a window whose
 * end is not after its start runs into the next day (Saturday wraps to
 * Sunday via the ±WEEK shift below).
 */ const $52e405ef62f379b2$var$weekIntervals = (schedule)=>{
    const start = $52e405ef62f379b2$var$timeToMinutes(schedule.start_time);
    const end = $52e405ef62f379b2$var$timeToMinutes(schedule.end_time);
    return schedule.day_of_week.map((day)=>{
        const dayStart = Number(day) * 1440;
        return [
            dayStart + start,
            dayStart + (end > start ? end : end + 1440)
        ];
    });
};
const $52e405ef62f379b2$export$50bbf88dff017be2 = (a, b)=>$52e405ef62f379b2$var$weekIntervals(a).some(([startA, endA])=>$52e405ef62f379b2$var$weekIntervals(b).some(([startB, endB])=>[
                -$52e405ef62f379b2$var$WEEK,
                0,
                $52e405ef62f379b2$var$WEEK
            ].some((shift)=>startA < endB + shift && startB + shift < endA)));
const $52e405ef62f379b2$var$hasValidTimes = (schedule)=>$52e405ef62f379b2$var$isValidTime(schedule.start_time) && $52e405ef62f379b2$var$isValidTime(schedule.end_time);
/** Pairs of flex schedules that share a product, with the shared products. */ const $52e405ef62f379b2$var$sharedProductPairs = (data)=>{
    const valid = (data ?? []).filter((entry)=>entry && Array.isArray(entry.product));
    const pairs = [];
    for(let i = 0; i < valid.length; i++)for(let j = i + 1; j < valid.length; j++){
        const shared = valid[i].product.filter((product)=>valid[j].product.includes(product));
        if (shared.length) pairs.push({
            a: valid[i],
            b: valid[j],
            shared: shared
        });
    }
    return pairs;
};
const $52e405ef62f379b2$var$anyRows = (a, b, test)=>(a.schedule ?? []).some((rowA)=>$52e405ef62f379b2$var$hasValidTimes(rowA) && (b.schedule ?? []).some((rowB)=>$52e405ef62f379b2$var$hasValidTimes(rowB) && test(rowA, rowB)));
const $52e405ef62f379b2$export$9d4af5304e5425b5 = (data)=>{
    if (!data || !Array.isArray(data) || data.length === 0) return false;
    return $52e405ef62f379b2$var$sharedProductPairs(data).some(({ a: a, b: b })=>$52e405ef62f379b2$var$anyRows(a, b, $52e405ef62f379b2$var$sameDayOverlap));
};
const $52e405ef62f379b2$export$32266c8148a27328 = (data)=>{
    const products = new Set();
    $52e405ef62f379b2$var$sharedProductPairs(data).forEach(({ a: a, b: b, shared: shared })=>{
        if ($52e405ef62f379b2$var$anyRows(a, b, $52e405ef62f379b2$var$sameDayOverlap)) return;
        if ($52e405ef62f379b2$var$anyRows(a, b, $52e405ef62f379b2$export$50bbf88dff017be2)) shared.forEach((product)=>products.add(product));
    });
    return [
        ...products
    ];
};

});


parcelRegister("74XHu", function(module, exports) {

$parcel$export(module.exports, "EditScheduleNameDialog", () => $166df15b396ab470$export$1e9a054cd60a6065);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");
var $eejVe = parcelRequire("eejVe");

var $gus0k = parcelRequire("gus0k");

var $kRZvb = parcelRequire("kRZvb");

var $f3puC = parcelRequire("f3puC");

var $8jTCz = parcelRequire("8jTCz");

var $1TOOV = parcelRequire("1TOOV");

var $887xF = parcelRequire("887xF");

var $3FJ79 = parcelRequire("3FJ79");
const $166df15b396ab470$export$1e9a054cd60a6065 = ()=>{
    const { siteSchedules: siteSchedules, editScheduleNameDialogOpen: editScheduleNameDialogOpen, setEditScheduleNameDialogOpen: setEditScheduleNameDialogOpen, setSiteSchedules: setSiteSchedules, setScheduleChangesMade: setScheduleChangesMade, schedulesIndex: schedulesIndex } = (0, $3FJ79.useSiteAboutStore)();
    const [scheduleName, setScheduleName] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(siteSchedules[schedulesIndex].display_name);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: editScheduleNameDialogOpen,
        onClose: ()=>setEditScheduleNameDialogOpen(false),
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gus0k.default), {
                sx: {
                    position: "relative"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kRZvb.default), {
                    sx: {
                        background: "#001943"
                    },
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            ml: 2,
                            flex: 1
                        },
                        variant: "h6",
                        component: "div",
                        children: "Edit Schedule Name"
                    })
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: " bg-white",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "pt-[20px]",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        label: "Schedule Name",
                                        autoComplete: "off",
                                        value: scheduleName,
                                        onChange: (newValue)=>{
                                            setScheduleName(newValue.target.value);
                                        },
                                        disabled: false,
                                        sx: {
                                            width: 400
                                        },
                                        variant: "standard"
                                    })
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "flex pr-[20px] pt-[20px]",
                    style: {
                        display: "flex"
                    },
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            style: {
                                marginLeft: "auto"
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    setEditScheduleNameDialogOpen(false);
                                },
                                text: "Cancel",
                                disabled: false
                            })
                        }),
                        "\xa0\xa0\xa0",
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    const newSiteSchedules = siteSchedules;
                                    newSiteSchedules[schedulesIndex].display_name = scheduleName;
                                    setSiteSchedules(newSiteSchedules);
                                    setScheduleChangesMade(true);
                                    setEditScheduleNameDialogOpen(false);
                                },
                                text: "Ok",
                                disabled: false
                            })
                        })
                    ]
                })
            })
        ]
    });
};

});

parcelRegister("kDhtU", function(module, exports) {

$parcel$export(module.exports, "DeleteScheduleDialog", () => $7c6fc24a2affa5cb$export$f1c2792be1a59176);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $iLEpm = parcelRequire("iLEpm");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $3FJ79 = parcelRequire("3FJ79");
const $7c6fc24a2affa5cb$export$f1c2792be1a59176 = ({ scheduleId: scheduleId, scheduleName: scheduleName })=>{
    const navigate = (0, $3T949.useNavigate)();
    const { deleteScheduleDialogOpen: deleteScheduleDialogOpen, setDeleteScheduleDialogOpen: setDeleteScheduleDialogOpen, handleDeleteSchedule: handleDeleteSchedule } = (0, $3FJ79.useSiteAboutStore)();
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: deleteScheduleDialogOpen,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: ` Are you sure you want to delete ${scheduleName} ?`
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                    id: "alert-dialog-description",
                    children: "Once deleted this action can't be undone."
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setDeleteScheduleDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setDeleteScheduleDialogOpen(false);
                            handleDeleteSchedule(scheduleId, navigate);
                        },
                        text: "Delete",
                        disabled: false
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("5zfN2", function(module, exports) {

$parcel$export(module.exports, "SchedulesTabAutopatrol", () => $1146d353d59f597e$export$3cf1178c071c9d44);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $cVCJe = parcelRequire("cVCJe");

var $ePwXE = parcelRequire("ePwXE");

var $3FJ79 = parcelRequire("3FJ79");

var $iOw9a = parcelRequire("iOw9a");

var $8B8vg = parcelRequire("8B8vg");
var $eDfvp = parcelRequire("eDfvp");
var $kbChx = parcelRequire("kbChx");
var $3baw3 = parcelRequire("3baw3");
var $ddLR4 = parcelRequire("ddLR4");
var $ha39s = parcelRequire("ha39s");
var $eejVe = parcelRequire("eejVe");

var $2SHRA = parcelRequire("2SHRA");

var $4PFLW = parcelRequire("4PFLW");

var $8jTCz = parcelRequire("8jTCz");

var $6pdiI = parcelRequire("6pdiI");

var $5QFok = parcelRequire("5QFok");

var $8UhTy = parcelRequire("8UhTy");

var $enwJW = parcelRequire("enwJW");
const $1146d353d59f597e$var$capitalizeWords = (str)=>{
    return str.replace(/\b\w/g, (char)=>char.toUpperCase());
};
const $1146d353d59f597e$var$lowerCaseWords = (str)=>{
    return str.replace(/\b\w/g, (char)=>char.toLowerCase());
};
const $1146d353d59f597e$export$3cf1178c071c9d44 = ({ editMode: editMode, permissions: permissions, onEditSchedulesClick: onEditSchedulesClick, onSaveSchedulesClick: onSaveSchedulesClick, onCancelSchedulesClick: onCancelSchedulesClick })=>{
    const { flags: flags } = (0, $4PFLW.useFeatureFlag)();
    const showProductsCheckboxesApSchedulesTab = flags.showProductsCheckboxesApSchedulesTab;
    const showAutoPatrolFlexIgnoreZones = flags.showAutoPatrolFlexIgnoreZones === true;
    const showApProductBulkUpdate = flags.showApProductBulkUpdate === true;
    const navigate = (0, $3T949.useNavigate)();
    const { autoPatrolSchedules: autoPatrolSchedules, selectedAutoPatrolScheduleIndex: selectedAutoPatrolScheduleIndex, healthCheckDataZustand: healthCheckDataZustand, healthCheckMetricsData: healthCheckMetricsData, autoPatrolScheduleHealthchckMetrics: autoPatrolScheduleHealthchckMetrics, setAutoPatrolSchedules: setAutoPatrolSchedules, setAutoPatrolScheduleHealthchckMetrics: setAutoPatrolScheduleHealthchckMetrics, setAutoPatrolSchedulesUpdatedBoolean: setAutoPatrolSchedulesUpdatedBoolean, updatedAutoPatrolScheduleIndexes: updatedAutoPatrolScheduleIndexes, setUpdatedAutoPatrolScheduleIndexes: setUpdatedAutoPatrolScheduleIndexes, setAutoPatrolScheduleHealthchckMetricsUpdatedBoolean: setAutoPatrolScheduleHealthchckMetricsUpdatedBoolean, updatedAutoPatrolScheduleHealthchckMetricsIds: updatedAutoPatrolScheduleHealthchckMetricsIds, setUpdatedAutoPatrolScheduleHealthchckMetricsIds: setUpdatedAutoPatrolScheduleHealthchckMetricsIds, autoPatrolCameraProducts: autoPatrolCameraProducts, setAutoPatrolCameraProducts: setAutoPatrolCameraProducts, updatedProductMetricsIds: updatedProductMetricsIds, setUpdatedProductMetricsIds: setUpdatedProductMetricsIds, setProductMetricsWereUpdated: setProductMetricsWereUpdated, getAutoPatrolScheduleHealthchckMetrics: getAutoPatrolScheduleHealthchckMetrics, vCHOnlySchedules: vCHOnlySchedules, autoPatrolFlexIgnoreZonesEnabledBySite: autoPatrolFlexIgnoreZonesEnabledBySite, setAutoPatrolFlexIgnoreZonesEnabledForSite: setAutoPatrolFlexIgnoreZonesEnabledForSite, autoPatrolFlexIgnoreZonesWizardOpenBySite: autoPatrolFlexIgnoreZonesWizardOpenBySite, setAutoPatrolFlexIgnoreZonesWizardOpenForSite: setAutoPatrolFlexIgnoreZonesWizardOpenForSite, resetAutoPatrolFlexIgnoreZonesForSite: resetAutoPatrolFlexIgnoreZonesForSite } = (0, $3FJ79.useSiteAboutStore)();
    const [offboardingDialogOpen, setOffboardingDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [productBulkUpdateDialogOpen, setProductBulkUpdateDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const titlesArray = [
        "Status",
        "Patrol Type",
        "Cadence",
        "Updated Date"
    ];
    const sensitivityOptions = [
        "low",
        "medium",
        "high"
    ];
    // Add safety check for selectedAutoPatrolScheduleIndex
    const currentSchedule = autoPatrolSchedules[selectedAutoPatrolScheduleIndex];
    const scheduleId = currentSchedule?.id;
    const siteId = Number(currentSchedule?.customer?.id || JSON.parse(localStorage.getItem("siteInfo") || "{}")?.id || 0);
    const autoPatrolOnlySchedules = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>autoPatrolSchedules.filter((schedule)=>schedule?.patrolType === "AutoPatrol"), [
        autoPatrolSchedules
    ]);
    const flexIgnoreZonesEnabled = autoPatrolFlexIgnoreZonesEnabledBySite[siteId] === true;
    const flexWizardOpen = autoPatrolFlexIgnoreZonesWizardOpenBySite[siteId] === true;
    const isAutoPatrolSchedule = currentSchedule?.patrolType === "AutoPatrol";
    const scheduleMetrics = autoPatrolScheduleHealthchckMetrics[scheduleId] || [];
    const getMetricByType = (metricType)=>scheduleMetrics.find((metric)=>metric?.metric_type?.value === metricType);
    const sceneChangeMetric = getMetricByType("scene_change_check");
    const imageQualityMetric = getMetricByType("image_quality_check");
    const vchMetricTypes = [
        "connectivity_check",
        "scene_change_check",
        "motion_status_check",
        "recording_check",
        "stream_quality_check",
        "image_quality_check"
    ];
    const metricLabelMap = {
        connectivity_check: "Connectivity",
        scene_change_check: "Scene Change",
        motion_status_check: "Motion Status",
        recording_check: "Recording",
        stream_quality_check: "Stream Quality",
        image_quality_check: "Image Quality"
    };
    const vchMetrics = vchMetricTypes.map((metricType)=>getMetricByType(metricType)).filter(Boolean);
    // Get products for the current schedule
    const scheduleProducts = autoPatrolCameraProducts[scheduleId] || [];
    const markScheduleHealthMetricsUpdated = ()=>{
        setAutoPatrolScheduleHealthchckMetricsUpdatedBoolean(true);
        const nextUpdatedIds = updatedAutoPatrolScheduleHealthchckMetricsIds.includes(scheduleId) ? updatedAutoPatrolScheduleHealthchckMetricsIds : [
            ...updatedAutoPatrolScheduleHealthchckMetricsIds,
            scheduleId
        ];
        setUpdatedAutoPatrolScheduleHealthchckMetricsIds(nextUpdatedIds);
    };
    const updateMetricEnabled = (metricType, enabled)=>{
        const updatedScheduleMetrics = scheduleMetrics.map((metric)=>{
            if (metric?.metric_type?.value === metricType) return {
                ...metric,
                enabled: enabled
            };
            return metric;
        });
        setAutoPatrolScheduleHealthchckMetrics({
            ...autoPatrolScheduleHealthchckMetrics,
            [scheduleId]: updatedScheduleMetrics
        });
        markScheduleHealthMetricsUpdated();
    };
    // Helper to find if a product is enabled by its display_name
    const isProductEnabled = (displayName)=>{
        const product = scheduleProducts.find((p)=>p.metric_label.display_name === displayName);
        return product?.enabled || false;
    };
    const areAllChildrenEnabled = (group)=>group.children.length > 0 && group.children.every((displayName)=>isProductEnabled(displayName));
    const isSomeButNotAllChildrenEnabled = (group)=>{
        const enabledCount = group.children.filter((displayName)=>isProductEnabled(displayName)).length;
        return enabledCount > 0 && enabledCount < group.children.length;
    };
    const handleMasterCheckboxChange = (group)=>{
        if (!scheduleId) return;
        const allEnabled = areAllChildrenEnabled(group);
        const newEnabled = !allEnabled;
        const childDisplayNames = new Set(group.children);
        const updatedProducts = scheduleProducts.map((p)=>{
            if (childDisplayNames.has(p.metric_label.display_name)) return {
                ...p,
                enabled: newEnabled
            };
            return p;
        });
        setAutoPatrolCameraProducts({
            ...autoPatrolCameraProducts,
            [scheduleId]: updatedProducts
        });
        const currentIds = updatedProductMetricsIds[scheduleId] || [];
        let newIds = [
            ...currentIds
        ];
        for (const displayName of group.children){
            const product = scheduleProducts.find((p)=>p.metric_label.display_name === displayName);
            if (!product) continue;
            const wasEnabled = product.enabled;
            if (wasEnabled === newEnabled) continue;
            if (newIds.includes(product.id)) newIds = newIds.filter((id)=>id !== product.id);
            else newIds = [
                ...newIds,
                product.id
            ];
        }
        setUpdatedProductMetricsIds({
            ...updatedProductMetricsIds,
            [scheduleId]: newIds
        });
        setProductMetricsWereUpdated(true);
    };
    // Product groups with parent names, children, and colors
    const productGroups = [
        {
            parentName: "Intruder",
            color: "#FF8400",
            children: [
                "Intruder",
                "Vehicle (grouped car, truck, bus)",
                "Bike (grouped bicycle, motorcycle)"
            ]
        },
        {
            parentName: "Crowd",
            color: "#2196F3",
            children: [
                "Crowd"
            ]
        },
        {
            parentName: "Fire",
            color: "#F44336",
            children: [
                "Fire",
                "Smoke"
            ]
        },
        {
            parentName: "Non-UPS Vehicle ID",
            color: "#03A9F4",
            children: [
                "Non-UPS"
            ]
        },
        {
            parentName: "Vehicle ID",
            color: "#4CAF50",
            children: [
                "Amazon",
                "DHL",
                "Fedex",
                "School Bus",
                "UPS",
                "USPS",
                "Fire Truck"
            ]
        }
    ];
    // Shorter labels for display
    const getShortLabel = (displayName)=>{
        const labelMap = {
            "Vehicle (grouped car, truck, bus)": "Vehicle",
            "Bike (grouped bicycle, motorcycle)": "Bike"
        };
        return labelMap[displayName] || displayName;
    };
    // Handler for product checkbox changes in edit mode
    const handleProductCheckboxChange = (displayName)=>{
        const product = scheduleProducts.find((p)=>p.metric_label.display_name === displayName);
        if (!product || !scheduleId) return;
        // 1. Update autoPatrolCameraProducts - toggle the enabled value
        const updatedProducts = scheduleProducts.map((p)=>p.id === product.id ? {
                ...p,
                enabled: !p.enabled
            } : p);
        setAutoPatrolCameraProducts({
            ...autoPatrolCameraProducts,
            [scheduleId]: updatedProducts
        });
        // 2. Update updatedProductMetricsIds - track which metrics were changed
        const currentIds = updatedProductMetricsIds[scheduleId] || [];
        let newIds;
        if (currentIds.includes(product.id)) // If already in the list, remove it (toggle back to original state)
        newIds = currentIds.filter((id)=>id !== product.id);
        else // Add to the list
        newIds = [
            ...currentIds,
            product.id
        ];
        setUpdatedProductMetricsIds({
            ...updatedProductMetricsIds,
            [scheduleId]: newIds
        });
        // 3. Set productMetricsWereUpdated to true
        setProductMetricsWereUpdated(true);
    };
    const titlesArray2 = imageQualityMetric?.enabled ? sceneChangeMetric?.display ? isAutoPatrolSchedule ? [
        "Sensitivity",
        "Min Image Height",
        "Linked Number of Cameras"
    ] : [
        "Sensitivity",
        "Health Metrics",
        "Min Image Height",
        "Linked Number of Cameras"
    ] : isAutoPatrolSchedule ? [
        "Min Image Height",
        "Linked Number of Cameras"
    ] : [
        "Health Metrics",
        "Min Image Height",
        "Linked Number of Cameras"
    ] : sceneChangeMetric?.display ? isAutoPatrolSchedule ? [
        "Sensitivity",
        "Linked Number of Cameras"
    ] : [
        "Sensitivity",
        "Health Metrics",
        "Linked Number of Cameras"
    ] : isAutoPatrolSchedule ? [
        "Linked Number of Cameras"
    ] : [
        "Health Metrics",
        "Linked Number of Cameras"
    ];
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        localStorage.setItem("backupHealthCheckMetricsData", JSON.stringify(healthCheckMetricsData));
    }, [
        healthCheckMetricsData
    ]);
    // Ensure health check metrics are loaded for the current schedule when missing.
    // Runs on mount/tab view and when entering edit mode (in case getAutoPatrolSchedules
    // didn't fire or the per-schedule API hadn't completed).
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (scheduleId != null && autoPatrolScheduleHealthchckMetrics[scheduleId] == null) getAutoPatrolScheduleHealthchckMetrics(navigate, String(scheduleId), true);
    }, [
        scheduleId,
        autoPatrolScheduleHealthchckMetrics,
        getAutoPatrolScheduleHealthchckMetrics,
        navigate
    ]);
    const schedulesHeader = /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "relative flex w-full items-center justify-between",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex items-center gap-4",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-black font-mulish text-[20px] pt-3 indent-4",
                        children: "Schedules"
                    }),
                    showAutoPatrolFlexIgnoreZones && !vCHOnlySchedules && siteId > 0 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "pt-3 pl-3",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                            control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                checked: flexIgnoreZonesEnabled,
                                onChange: (event)=>{
                                    const enabled = event.target.checked;
                                    if (enabled) {
                                        setAutoPatrolFlexIgnoreZonesEnabledForSite(siteId, true);
                                        setAutoPatrolFlexIgnoreZonesWizardOpenForSite(siteId, true);
                                        return;
                                    }
                                    setOffboardingDialogOpen(true);
                                },
                                color: "primary"
                            }),
                            label: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                className: "font-mulish font-bold text-[14px]",
                                children: "Flex Ignore Zones"
                            })
                        })
                    })
                ]
            }),
            (showApProductBulkUpdate && autoPatrolOnlySchedules.length >= 2 && !editMode || onEditSchedulesClick != null && onSaveSchedulesClick != null && onCancelSchedulesClick != null && permissions != null) && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex shrink-0 items-center gap-2 pt-3 pr-3",
                children: [
                    !editMode && showApProductBulkUpdate && autoPatrolOnlySchedules.length >= 2 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>setProductBulkUpdateDialogOpen(true),
                        text: "Product Bulk Update",
                        disabled: false
                    }),
                    !editMode ? onEditSchedulesClick != null && onSaveSchedulesClick != null && onCancelSchedulesClick != null && permissions != null && (permissions.add_cameras || permissions.edit_cameras) && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: onEditSchedulesClick,
                        text: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {
                                    fontSize: "small"
                                }),
                                "\xa0Edit Schedules"
                            ]
                        }),
                        disabled: false
                    }) : onSaveSchedulesClick != null && onCancelSchedulesClick != null && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: onSaveSchedulesClick,
                                text: "SAVE CHANGES",
                                disabled: false
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: onCancelSchedulesClick,
                                text: "CANCEL",
                                disabled: false
                            })
                        ]
                    })
                ]
            })
        ]
    });
    const selectedScheduleRow = autoPatrolSchedules !== null && autoPatrolSchedules.length > 0 ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "flex items-center gap-3 pl-4 pt-2 pb-2",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "text-actuate-blue font-mulish font-bold text-[16px]",
                children: "Selected Schedule:"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $5QFok.default), {})
        ]
    }) : null;
    const noSchedules = /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3Nm8Z.default), {
            component: (0, $4reBM.default),
            sx: {
                width: "100%",
                mb: 2,
                height: "50px"
            },
            children: [
                schedulesHeader,
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "text-center text-gray-500 pt-3",
                    children: "No schedules found"
                })
            ]
        })
    });
    // Early return if no schedules exist
    if (!autoPatrolSchedules.length || !currentSchedule) return noSchedules;
    const scheduleTabAutoPatrol = /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3Nm8Z.default), {
                component: (0, $4reBM.default),
                sx: {
                    width: "100%",
                    mb: 2,
                    "& .MuiTableHead-root .MuiTableCell-root": {
                        borderBottom: "none !important"
                    },
                    "& .MuiTableCell-head": {
                        borderBottom: "none !important"
                    }
                },
                children: [
                    schedulesHeader,
                    selectedScheduleRow,
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                        sx: {
                            width: "100%",
                            fontFamily: "Mulish",
                            tableLayout: "fixed"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                    sx: {
                                        height: "50px"
                                    },
                                    children: titlesArray.map((title)=>{
                                        return /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: "Bold"
                                            },
                                            children: title
                                        }, title);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                    sx: {
                                        height: "50px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            children: currentSchedule.scheduleStatus ? currentSchedule.scheduleStatus : "--"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            children: currentSchedule.patrolType ? currentSchedule.patrolType : "--"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            children: currentSchedule.cadence ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        children: `${currentSchedule.cadence} ${currentSchedule?.cadenceUnit}`
                                                    }),
                                                    currentSchedule.checksPerDay && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "text-gray-400",
                                                        children: `${currentSchedule.checksPerDay} checks per day`
                                                    })
                                                ]
                                            }) : currentSchedule.cronDescription ? currentSchedule.cronDescription : "--"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            children: [
                                                currentSchedule.updatedDate ? (0, $iOw9a.isoDateToUPCCovertor)(currentSchedule.updatedDate, currentSchedule.olsonTimeZoneId).toString() : "--",
                                                "\xa0",
                                                currentSchedule.updatedDate && currentSchedule.olsonTimeZoneId ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                    title: currentSchedule.olsonTimeZoneId,
                                                    placement: "top",
                                                    sx: {
                                                        fontSize: "15px",
                                                        fontFamily: "mulish"
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                                        fontSize: "small"
                                                    })
                                                }) : ""
                                            ]
                                        })
                                    ]
                                })
                            }, currentSchedule.id || currentSchedule.title)
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                        sx: {
                            width: "100%",
                            fontFamily: "Mulish",
                            tableLayout: "fixed"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                    sx: {
                                        height: "50px"
                                    },
                                    children: titlesArray2.map((title)=>{
                                        return /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: "Bold"
                                            },
                                            children: title
                                        }, title);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                    children: [
                                        sceneChangeMetric?.display && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            children: $1146d353d59f597e$var$capitalizeWords(currentSchedule.sensitivityLevel)
                                        }),
                                        !isAutoPatrolSchedule && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            sx: {
                                                textAlign: "left"
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $2SHRA.default), {
                                                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                    className: "flex",
                                                    children: [
                                                        vchMetrics.map((metric)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                                sx: {
                                                                    marginLeft: "1px",
                                                                    "& .MuiFormControlLabel-label": {
                                                                        fontSize: "14px",
                                                                        fontFamily: "Mulish"
                                                                    }
                                                                },
                                                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                                    checked: Boolean(metric.enabled),
                                                                    disabled: true,
                                                                    name: metric?.metric_type?.value
                                                                }),
                                                                label: metricLabelMap[metric?.metric_type?.value] || metric?.metric_type?.name || metric?.metric_type?.value || "Metric",
                                                                labelPlacement: "top"
                                                            }, metric.id)),
                                                        vchMetrics.length === 0 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                            children: "--"
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        imageQualityMetric?.enabled && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            children: imageQualityMetric?.minimum_resolution_height ? /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                children: `${imageQualityMetric?.minimum_resolution_height} px`
                                            }) : /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "pl-[50px]",
                                                children: "--"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            children: `${currentSchedule.scheduleCameraCount} of ${currentSchedule.siteCameraCount} cameras`
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    showProductsCheckboxesApSchedulesTab && currentSchedule?.patrolType === "AutoPatrol" && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                        sx: {
                            width: "100%",
                            fontFamily: "Mulish",
                            tableLayout: "fixed"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: {
                                            fontFamily: "Mulish",
                                            fontWeight: "Bold"
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                                            component: "span",
                                            sx: {
                                                display: "inline-flex",
                                                alignItems: "center",
                                                gap: 0.5
                                            },
                                            children: [
                                                "Products",
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                    title: "Control which products generate alerts for this schedule. Only products that are enabled at the camera level AND checked here will raise alerts. Uncheck a product here to stop alerts during this schedule.",
                                                    placement: "top",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                                        fontSize: "small"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        sx: {
                                            textAlign: "left"
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $2SHRA.default), {
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "flex flex-wrap",
                                                style: {
                                                    gap: "20px",
                                                    alignItems: "stretch"
                                                },
                                                children: productGroups.map((group, index)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    alignItems: "center"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                        style: {
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            gap: "5px",
                                                                            fontWeight: 900,
                                                                            fontSize: "14px",
                                                                            fontFamily: "Mulish",
                                                                            marginBottom: "8px"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                                                children: group.parentName
                                                                            }),
                                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                                                "data-testid": `master-select-all-${group.parentName}`,
                                                                                checked: areAllChildrenEnabled(group),
                                                                                indeterminate: isSomeButNotAllChildrenEnabled(group),
                                                                                disabled: true,
                                                                                size: "small"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                        style: {
                                                                            display: "flex",
                                                                            gap: "10px",
                                                                            justifyContent: "center"
                                                                        },
                                                                        children: group.children.map((displayName)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                                                sx: {
                                                                                    "& .MuiFormControlLabel-label": {
                                                                                        fontSize: "14px",
                                                                                        fontFamily: "Mulish"
                                                                                    }
                                                                                },
                                                                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                                                    checked: isProductEnabled(displayName),
                                                                                    disabled: true,
                                                                                    name: displayName.toLowerCase().replace(/\s+/g, "_")
                                                                                }),
                                                                                label: getShortLabel(displayName),
                                                                                labelPlacement: "top"
                                                                            }, displayName))
                                                                    })
                                                                ]
                                                            }),
                                                            index < productGroups.length - 1 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                style: {
                                                                    width: "1px",
                                                                    backgroundColor: "#ccc",
                                                                    alignSelf: "stretch",
                                                                    marginTop: "8px",
                                                                    marginBottom: "8px"
                                                                }
                                                            })
                                                        ]
                                                    }, group.parentName))
                                            })
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    showAutoPatrolFlexIgnoreZones && !vCHOnlySchedules && siteId > 0 && flexIgnoreZonesEnabled && currentSchedule?.patrolType === "AutoPatrol" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8UhTy.AutoPatrolFlexIgnoreZonesScheduleSection), {
                        schedule: currentSchedule,
                        editMode: false
                    })
                ]
            }),
            showAutoPatrolFlexIgnoreZones && siteId > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8UhTy.AutoPatrolFlexIgnoreZonesOnboardingDialog), {
                siteId: siteId,
                schedules: autoPatrolOnlySchedules,
                open: flexWizardOpen,
                onClose: ()=>setAutoPatrolFlexIgnoreZonesWizardOpenForSite(siteId, false)
            }),
            showAutoPatrolFlexIgnoreZones && siteId > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8UhTy.AutoPatrolFlexIgnoreZonesOffboardingDialog), {
                open: offboardingDialogOpen,
                siteId: siteId,
                schedules: autoPatrolOnlySchedules,
                onClose: ()=>{
                    setOffboardingDialogOpen(false);
                    window.dispatchEvent(new CustomEvent("refreshSiteCamerasTable"));
                },
                onSubmitted: ()=>{
                    setAutoPatrolFlexIgnoreZonesEnabledForSite(siteId, false);
                    resetAutoPatrolFlexIgnoreZonesForSite(siteId);
                    window.dispatchEvent(new CustomEvent("refreshSiteCamerasTable"));
                }
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $enwJW.ProductBulkUpdateDialog), {
                open: productBulkUpdateDialogOpen,
                schedules: autoPatrolOnlySchedules,
                autoPatrolCameraProducts: autoPatrolCameraProducts,
                onClose: ()=>setProductBulkUpdateDialogOpen(false)
            })
        ]
    });
    const scheduleTabAutoPatrolEditMode = /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3Nm8Z.default), {
                component: (0, $4reBM.default),
                sx: {
                    width: "100%",
                    mb: 2,
                    "& .MuiTableHead-root .MuiTableCell-root": {
                        borderBottom: "none !important"
                    },
                    "& .MuiTableCell-head": {
                        borderBottom: "none !important"
                    }
                },
                children: [
                    schedulesHeader,
                    selectedScheduleRow,
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                        sx: {
                            width: "100%",
                            fontFamily: "Mulish",
                            tableLayout: "fixed"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                    children: titlesArray.map((title)=>{
                                        return /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: "Bold"
                                            },
                                            children: title
                                        }, title);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                    sx: {
                                        height: "70px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            children: currentSchedule.scheduleStatus ? currentSchedule.scheduleStatus : "--"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            children: currentSchedule.patrolType ? currentSchedule.patrolType : "--"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            children: currentSchedule.cadence ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        children: `${currentSchedule.cadence} ${currentSchedule?.cadenceUnit}`
                                                    }),
                                                    currentSchedule.checksPerDay && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "text-gray-400",
                                                        children: `${currentSchedule.checksPerDay} checks per day`
                                                    })
                                                ]
                                            }) : currentSchedule.cronDescription ? currentSchedule.cronDescription : "--"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            children: [
                                                currentSchedule.updatedDate ? (0, $iOw9a.isoDateToUPCCovertor)(currentSchedule.updatedDate, currentSchedule.olsonTimeZoneId).toString() : "--",
                                                "\xa0",
                                                currentSchedule.updatedDate && currentSchedule.olsonTimeZoneId ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                    title: currentSchedule.olsonTimeZoneId,
                                                    placement: "top",
                                                    sx: {
                                                        fontSize: "15px",
                                                        fontFamily: "mulish"
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                                        fontSize: "small"
                                                    })
                                                }) : ""
                                            ]
                                        })
                                    ]
                                })
                            }, currentSchedule.id || currentSchedule.title)
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                        sx: {
                            width: "100%",
                            fontFamily: "Mulish",
                            tableLayout: "fixed"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                    children: titlesArray2.map((title)=>{
                                        return /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: "Bold"
                                            },
                                            children: title
                                        }, title);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                    children: [
                                        sceneChangeMetric?.display && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                                disablePortal: true,
                                                options: sensitivityOptions.map((option)=>{
                                                    return $1146d353d59f597e$var$capitalizeWords(option);
                                                }),
                                                value: $1146d353d59f597e$var$capitalizeWords(currentSchedule.sensitivityLevel),
                                                onChange: (event, newInputValue)=>{
                                                    const updatedAutoPatrolSchedules = autoPatrolSchedules;
                                                    updatedAutoPatrolSchedules[selectedAutoPatrolScheduleIndex].sensitivityLevel = $1146d353d59f597e$var$lowerCaseWords(newInputValue);
                                                    setAutoPatrolSchedules(updatedAutoPatrolSchedules);
                                                    setAutoPatrolSchedulesUpdatedBoolean(true);
                                                    const newUpdatedAutoPatrolScheduleIndexes = updatedAutoPatrolScheduleIndexes;
                                                    if (!newUpdatedAutoPatrolScheduleIndexes.includes(selectedAutoPatrolScheduleIndex.toString())) {
                                                        newUpdatedAutoPatrolScheduleIndexes.push(selectedAutoPatrolScheduleIndex.toString());
                                                        setUpdatedAutoPatrolScheduleIndexes(newUpdatedAutoPatrolScheduleIndexes);
                                                    }
                                                },
                                                sx: {
                                                    width: 150
                                                },
                                                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                        ...params,
                                                        variant: "standard",
                                                        label: "Sensitivity"
                                                    })
                                            })
                                        }),
                                        !isAutoPatrolSchedule && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            sx: {
                                                textAlign: "left"
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $2SHRA.default), {
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "flex",
                                                    children: vchMetrics.map((metric)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                            sx: {
                                                                marginLeft: "1px",
                                                                "& .MuiFormControlLabel-label": {
                                                                    fontSize: "14px",
                                                                    fontFamily: "Mulish"
                                                                }
                                                            },
                                                            control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                                checked: Boolean(metric.enabled),
                                                                onChange: (event)=>updateMetricEnabled(metric?.metric_type?.value, event.target.checked)
                                                            }),
                                                            labelPlacement: "top",
                                                            label: metricLabelMap[metric?.metric_type?.value] || metric?.metric_type?.name || metric?.metric_type?.value || "Metric"
                                                        }, metric.id))
                                                })
                                            })
                                        }),
                                        imageQualityMetric?.enabled && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                value: imageQualityMetric?.minimum_resolution_height,
                                                onChange: (event)=>{
                                                    const updatedScheduleMetrics = scheduleMetrics.map((metric)=>{
                                                        if (metric?.metric_type?.value === "image_quality_check") return {
                                                            ...metric,
                                                            minimum_resolution_height: event.target.value
                                                        };
                                                        return metric;
                                                    });
                                                    setAutoPatrolScheduleHealthchckMetrics({
                                                        ...autoPatrolScheduleHealthchckMetrics,
                                                        [scheduleId]: updatedScheduleMetrics
                                                    });
                                                    markScheduleHealthMetricsUpdated();
                                                },
                                                error: imageQualityMetric?.minimum_resolution_height < 360,
                                                helperText: imageQualityMetric?.minimum_resolution_height < 360 ? "Any resolution below 360 px may experience poor scene change performance." : "",
                                                variant: "standard",
                                                sx: {
                                                    width: 150
                                                },
                                                type: "number",
                                                inputProps: {
                                                    min: 0
                                                },
                                                InputLabelProps: {
                                                    shrink: true
                                                },
                                                autoComplete: "off"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            children: `${currentSchedule.scheduleCameraCount} of ${currentSchedule.siteCameraCount} cameras`
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    showProductsCheckboxesApSchedulesTab && currentSchedule?.patrolType === "AutoPatrol" && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                        sx: {
                            width: "100%",
                            fontFamily: "Mulish",
                            tableLayout: "fixed"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: {
                                            fontFamily: "Mulish",
                                            fontWeight: "Bold"
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                                            component: "span",
                                            sx: {
                                                display: "inline-flex",
                                                alignItems: "center",
                                                gap: 0.5
                                            },
                                            children: [
                                                "Products",
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                    title: "Control which products generate alerts for this schedule. Only products that are enabled at the camera level AND checked here will raise alerts. Uncheck a product here to stop alerts during this schedule.",
                                                    placement: "top",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                                        fontSize: "small"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        sx: {
                                            textAlign: "left"
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $2SHRA.default), {
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "flex flex-wrap",
                                                style: {
                                                    gap: "20px",
                                                    alignItems: "stretch"
                                                },
                                                children: productGroups.map((group, index)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    alignItems: "center"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                        style: {
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            gap: "5px",
                                                                            fontWeight: 900,
                                                                            fontSize: "14px",
                                                                            fontFamily: "Mulish",
                                                                            marginBottom: "8px",
                                                                            color: group.color
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                                                children: group.parentName
                                                                            }),
                                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                                                "data-testid": `master-select-all-${group.parentName}`,
                                                                                checked: areAllChildrenEnabled(group),
                                                                                indeterminate: isSomeButNotAllChildrenEnabled(group),
                                                                                disabled: false,
                                                                                size: "small",
                                                                                onChange: ()=>handleMasterCheckboxChange(group),
                                                                                sx: {
                                                                                    color: group.color,
                                                                                    "&.Mui-checked": {
                                                                                        color: group.color
                                                                                    },
                                                                                    "&.MuiCheckbox-indeterminate": {
                                                                                        color: group.color
                                                                                    }
                                                                                }
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                        style: {
                                                                            display: "flex",
                                                                            gap: "10px",
                                                                            justifyContent: "center"
                                                                        },
                                                                        children: group.children.map((displayName)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                                                sx: {
                                                                                    "& .MuiFormControlLabel-label": {
                                                                                        fontSize: "14px",
                                                                                        fontFamily: "Mulish"
                                                                                    }
                                                                                },
                                                                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                                                    checked: isProductEnabled(displayName),
                                                                                    disabled: false,
                                                                                    onChange: ()=>handleProductCheckboxChange(displayName),
                                                                                    name: displayName.toLowerCase().replace(/\s+/g, "_"),
                                                                                    sx: {
                                                                                        color: group.color,
                                                                                        "&.Mui-checked": {
                                                                                            color: group.color
                                                                                        }
                                                                                    }
                                                                                }),
                                                                                label: getShortLabel(displayName),
                                                                                labelPlacement: "top"
                                                                            }, displayName))
                                                                    })
                                                                ]
                                                            }),
                                                            index < productGroups.length - 1 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                style: {
                                                                    width: "1px",
                                                                    backgroundColor: "#ccc",
                                                                    alignSelf: "stretch",
                                                                    marginTop: "8px",
                                                                    marginBottom: "8px"
                                                                }
                                                            })
                                                        ]
                                                    }, group.parentName))
                                            })
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    showAutoPatrolFlexIgnoreZones && !vCHOnlySchedules && siteId > 0 && flexIgnoreZonesEnabled && currentSchedule?.patrolType === "AutoPatrol" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8UhTy.AutoPatrolFlexIgnoreZonesScheduleSection), {
                        schedule: currentSchedule,
                        editMode: true
                    })
                ]
            }),
            showAutoPatrolFlexIgnoreZones && siteId > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8UhTy.AutoPatrolFlexIgnoreZonesOnboardingDialog), {
                siteId: siteId,
                schedules: autoPatrolOnlySchedules,
                open: flexWizardOpen,
                onClose: ()=>setAutoPatrolFlexIgnoreZonesWizardOpenForSite(siteId, false)
            }),
            showAutoPatrolFlexIgnoreZones && siteId > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8UhTy.AutoPatrolFlexIgnoreZonesOffboardingDialog), {
                open: offboardingDialogOpen,
                siteId: siteId,
                schedules: autoPatrolOnlySchedules,
                onClose: ()=>{
                    setOffboardingDialogOpen(false);
                    window.dispatchEvent(new CustomEvent("refreshSiteCamerasTable"));
                },
                onSubmitted: ()=>{
                    setAutoPatrolFlexIgnoreZonesEnabledForSite(siteId, false);
                    resetAutoPatrolFlexIgnoreZonesForSite(siteId);
                    window.dispatchEvent(new CustomEvent("refreshSiteCamerasTable"));
                }
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $enwJW.ProductBulkUpdateDialog), {
                open: productBulkUpdateDialogOpen,
                schedules: autoPatrolOnlySchedules,
                autoPatrolCameraProducts: autoPatrolCameraProducts,
                onClose: ()=>setProductBulkUpdateDialogOpen(false)
            })
        ]
    });
    return autoPatrolSchedules.length > 0 ? editMode ? scheduleTabAutoPatrolEditMode : scheduleTabAutoPatrol : noSchedules;
};

});
parcelRegister("iOw9a", function(module, exports) {

$parcel$export(module.exports, "isoDateToUPCCovertor", () => $caafdc339f682dda$export$a5b8c92ca9b650e1);
const $caafdc339f682dda$export$a5b8c92ca9b650e1 = (isoDateString, timeZone)=>{
    // Parse the ISO date string
    const date = new Date(isoDateString);
    const options = timeZone ? {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: timeZone
    } : {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
    };
    // Format the date with locale options
    const formattedDate = new Intl.DateTimeFormat("en-US", options).format(date);
    // Remove the "at" and the time zone abbreviation if present
    const cleanDate = formattedDate.replace(/,? at /, " ");
    return cleanDate;
};

});

parcelRegister("5QFok", function(module, exports) {

$parcel$export(module.exports, "default", () => $d057e1c2dd9ac52c$export$2e2bcd8739ae039);

var $k4ank = parcelRequire("k4ank");

var $a65wX = parcelRequire("a65wX");
var $1fWBE = parcelRequire("1fWBE");
var $cxknk = parcelRequire("cxknk");

var $8T3gX = parcelRequire("8T3gX");

var $3FJ79 = parcelRequire("3FJ79");
const $d057e1c2dd9ac52c$var$AutoPatrolScheduleDropDown = ()=>{
    const { autoPatrolSchedules: autoPatrolSchedules, selectedAutoPatrolScheduleIndex: selectedAutoPatrolScheduleIndex, setSelectedAutoPatrolScheduleIndex: setSelectedAutoPatrolScheduleIndex } = (0, $3FJ79.useSiteAboutStore)();
    const [anchorEl, setAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    if (autoPatrolSchedules !== null && autoPatrolSchedules.length > 0) return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "text-actuate-blue font-mulish text-[16px]",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                id: "schedule-selector",
                "aria-controls": open ? "schedule-menu" : undefined,
                "aria-haspopup": "true",
                "aria-expanded": open ? "true" : undefined,
                onClick: handleClick,
                children: autoPatrolSchedules[selectedAutoPatrolScheduleIndex]?.title
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1fWBE.default), {
                id: "schedule-menu",
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                MenuListProps: {
                    "aria-labelledby": "schedule-selector"
                },
                children: autoPatrolSchedules.map((schedule, index)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                        onClick: ()=>{
                            setSelectedAutoPatrolScheduleIndex(index);
                            handleClose();
                        },
                        children: schedule.title
                    }, schedule.title))
            })
        ]
    });
    return null;
};
var $d057e1c2dd9ac52c$export$2e2bcd8739ae039 = $d057e1c2dd9ac52c$var$AutoPatrolScheduleDropDown;

});

parcelRegister("8UhTy", function(module, exports) {

$parcel$export(module.exports, "syncAutoPatrolFlexIgnoreZonesFromApi", () => $80c82a1c4eff2a21$export$f06acc30ff528f8b);
$parcel$export(module.exports, "AutoPatrolFlexIgnoreZonesOnboardingDialog", () => $80c82a1c4eff2a21$export$3b52c88849ebeb49);
$parcel$export(module.exports, "AutoPatrolFlexIgnoreZonesScheduleSection", () => $80c82a1c4eff2a21$export$7a0601423a954793);
$parcel$export(module.exports, "AutoPatrolFlexPresetSelectForCameraRow", () => $80c82a1c4eff2a21$export$68b17dd5be03cb77);
$parcel$export(module.exports, "AutoPatrolFlexIgnoreZonesOffboardingDialog", () => $80c82a1c4eff2a21$export$3ba423ec6f9ad502);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");
var $887xF = parcelRequire("887xF");
var $1TOOV = parcelRequire("1TOOV");
var $ce8iU = parcelRequire("ce8iU");
var $7UDCh = parcelRequire("7UDCh");
var $iKAtE = parcelRequire("iKAtE");
var $6gU8O = parcelRequire("6gU8O");
var $cxknk = parcelRequire("cxknk");
var $2eEqG = parcelRequire("2eEqG");

var $433j1 = parcelRequire("433j1");

var $8jTCz = parcelRequire("8jTCz");

var $dHtmK = parcelRequire("dHtmK");

var $195EM = parcelRequire("195EM");

var $83bsI = parcelRequire("83bsI");

var $3FJ79 = parcelRequire("3FJ79");

var $eVSHG = parcelRequire("eVSHG");

var $87t0c = parcelRequire("87t0c");

var $2OZNn = parcelRequire("2OZNn");

var $6JE7U = parcelRequire("6JE7U");

var $2RrZf = parcelRequire("2RrZf");

var $7ulPk = parcelRequire("7ulPk");

var $9hVqI = parcelRequire("9hVqI");

var $dfiY5 = parcelRequire("dfiY5");
const $80c82a1c4eff2a21$export$6f9ccc0121d8e3dd = "ap-no-ignore-zones";
const $80c82a1c4eff2a21$var$AP_FLEX_CREATE_NEW_PRESET_OPTION = "ap-create-new-preset";
/** Stable empty list for `presetsByCamera[cameraId] ?? …` (avoids new `[]` each render). */ const $80c82a1c4eff2a21$var$EMPTY_AUTOPATROL_FLEX_PRESETS = [];
const $80c82a1c4eff2a21$var$toCadenceText = (schedule)=>{
    if (schedule.cadence != null && schedule.cadenceUnit) {
        const cadenceText = `${schedule.cadence} ${schedule.cadenceUnit}`;
        if (schedule.checksPerDay != null) return `${cadenceText} (${schedule.checksPerDay} checks/day)`;
        return cadenceText;
    }
    return schedule.cronDescription || "--";
};
const $80c82a1c4eff2a21$var$getSiteCameraMapFromStorage = ()=>{
    try {
        const raw = JSON.parse(localStorage.getItem("siteCameras") || '{"results":[]}');
        const results = Array.isArray(raw?.results) ? raw.results : [];
        return new Map(results.map((camera)=>[
                Number(camera.id),
                camera
            ]).filter(([id])=>Number.isFinite(id)));
    } catch  {
        return new Map();
    }
};
const $80c82a1c4eff2a21$var$toScheduleCameras = (schedule, siteCameraMap)=>(schedule.devices || []).map((device)=>{
        const fromSite = siteCameraMap.get(Number(device.id));
        return {
            id: Number(device.id),
            camera_name: fromSite?.camera_name || device.deviceName || `Camera ${device.id}`,
            preview_url: fromSite?.preview_url || "",
            ignore_zones: (0, $83bsI.addIgnoreLabel)(fromSite?.ignore_zones || [])
        };
    });
const $80c82a1c4eff2a21$var$ensureCameraPresets = (camera, presetsByCamera, setPresetsForCamera)=>{
    const cameraZones = (0, $83bsI.addIgnoreLabel)(camera.ignore_zones || []);
    const existing = presetsByCamera[camera.id] || [];
    if (existing.length > 0) {
        const defaultPresetId = `default-${camera.id}`;
        const defaultPresetIndex = existing.findIndex((preset)=>preset.localId === defaultPresetId);
        if (defaultPresetIndex >= 0) {
            const defaultPreset = existing[defaultPresetIndex];
            const hasNewZones = cameraZones.length > 0 && (defaultPreset.zones || []).length === 0;
            if (hasNewZones) {
                const next = [
                    ...existing
                ];
                next[defaultPresetIndex] = {
                    ...defaultPreset,
                    zones: cameraZones
                };
                setPresetsForCamera(camera.id, next);
            }
        }
        return;
    }
    const defaultPreset = {
        localId: `default-${camera.id}`,
        cameraId: camera.id,
        name: "Default Preset",
        zones: cameraZones,
        persistedId: null,
        source: "default",
        userNamed: false
    };
    const noIgnoreZonesPreset = {
        localId: $80c82a1c4eff2a21$export$6f9ccc0121d8e3dd,
        cameraId: camera.id,
        name: "No Ignore Zones",
        zones: [],
        persistedId: null,
        source: "custom",
        userNamed: true
    };
    setPresetsForCamera(camera.id, [
        defaultPreset,
        noIgnoreZonesPreset
    ]);
};
const $80c82a1c4eff2a21$var$buildCameraContext = (camera)=>({
        loaded: true,
        loading: false,
        error: null,
        preview: camera.preview_url ? {
            previewUrl: camera.preview_url,
            adjustedDimensions: {
                x: 720,
                y: 405
            }
        } : null,
        defaultZones: (0, $83bsI.addIgnoreLabel)(camera.ignore_zones || [])
    });
const $80c82a1c4eff2a21$var$replaceNegativeWithZero = (data)=>data.map((polygon)=>polygon.map((coordinates)=>coordinates.map((num)=>num < 0 ? 0 : num)));
const $80c82a1c4eff2a21$var$buildNextPresetName = (cameraId, presetsByCamera)=>{
    const presets = presetsByCamera[cameraId] || [];
    let index = 2;
    while(presets.some((preset)=>preset.name === `Preset ${index}`))index += 1;
    return `Preset ${index}`;
};
const $80c82a1c4eff2a21$var$parseListResponse = (data)=>{
    if (data && typeof data === "object" && Array.isArray(data.results)) return data.results;
    if (Array.isArray(data)) return data;
    return [];
};
const $80c82a1c4eff2a21$var$toNumericId = (value)=>{
    const next = Number(value);
    return Number.isFinite(next) ? next : null;
};
const $80c82a1c4eff2a21$var$coerceCoordinatesToPolygonList = (raw)=>{
    if (!Array.isArray(raw) || raw.length === 0) return [];
    const first = raw[0];
    if (!Array.isArray(first)) return [];
    const firstFirst = first[0];
    if (typeof firstFirst === "number") return [
        raw
    ];
    if (Array.isArray(firstFirst) && typeof firstFirst[0] === "number") return raw;
    return [];
};
const $80c82a1c4eff2a21$var$normalizeZoneName = (value)=>value.trim().toLowerCase().replace(/^ignore[_\s]+/, "").replace(/\s+/g, " ");
const $80c82a1c4eff2a21$var$presetZoneLabelDisplayName = (zone)=>{
    const raw = (zone.name || "").trim();
    if (!raw) return "Preset zone";
    return raw.replace(/\s*#\d+\s*$/u, "").trim() || raw;
};
const $80c82a1c4eff2a21$var$pickDefaultZoneTemplate = (defaultZones, candidateName, metricId)=>{
    const byMetric = typeof metricId === "number" && Number.isFinite(metricId) ? defaultZones.find((zone)=>Number(zone.metric_id) === metricId) : undefined;
    if (byMetric) return byMetric;
    const normalizedCandidate = $80c82a1c4eff2a21$var$normalizeZoneName(candidateName || "");
    if (!normalizedCandidate) return undefined;
    return defaultZones.find((zone)=>{
        const displayName = $80c82a1c4eff2a21$var$normalizeZoneName(zone.label_display_name || "");
        const labelName = $80c82a1c4eff2a21$var$normalizeZoneName(zone.label || "");
        return displayName === normalizedCandidate || labelName === normalizedCandidate;
    });
};
const $80c82a1c4eff2a21$var$pickIgnoreAllTemplate = (defaultZones)=>defaultZones.find((zone)=>Number(zone.metric_id) === 0) || defaultZones.find((zone)=>Number(zone.zone_type) === 0) || defaultZones.find((zone)=>$80c82a1c4eff2a21$var$normalizeZoneName(zone.label || "") === "all") || defaultZones.find((zone)=>$80c82a1c4eff2a21$var$normalizeZoneName(zone.label_display_name || "") === "all") || defaultZones.find((zone)=>$80c82a1c4eff2a21$var$normalizeZoneName(zone.label || "") === "motion") || defaultZones.find((zone)=>$80c82a1c4eff2a21$var$normalizeZoneName(zone.label_display_name || "") === "motion");
const $80c82a1c4eff2a21$var$polygonSignature = (polygon)=>JSON.stringify(polygon || []);
const $80c82a1c4eff2a21$var$toMappedPresetZones = (presetName, presetZonesRaw, defaultZones)=>presetZonesRaw.map((zone, zoneIndex)=>{
        const labels = Array.isArray(zone?.labels) ? zone.labels.filter((labelEntry)=>labelEntry && typeof labelEntry === "object") : [];
        if (labels.length > 0) {
            const nestedLabelCoordinateLists = labels.map((labelEntry)=>$80c82a1c4eff2a21$var$coerceCoordinatesToPolygonList(labelEntry.coordinates ?? zone.coordinates));
            const coordinateSignatures = labels.map((labelEntry)=>JSON.stringify($80c82a1c4eff2a21$var$coerceCoordinatesToPolygonList(labelEntry.coordinates ?? zone.coordinates)));
            const uniqueCoordinateSignatures = new Set(coordinateSignatures);
            const polygonFrequency = new Map();
            const polygonBySignature = new Map();
            nestedLabelCoordinateLists.forEach((polygonList)=>{
                const uniqueInLabel = new Set();
                polygonList.forEach((polygon)=>{
                    const sig = $80c82a1c4eff2a21$var$polygonSignature(polygon);
                    polygonBySignature.set(sig, polygon);
                    uniqueInLabel.add(sig);
                });
                uniqueInLabel.forEach((sig)=>{
                    polygonFrequency.set(sig, (polygonFrequency.get(sig) || 0) + 1);
                });
            });
            const sharedPolygonThreshold = Math.max(2, Math.ceil(labels.length / 2));
            const sharedPolygonSignatures = Array.from(polygonFrequency.entries()).filter(([, count])=>count >= sharedPolygonThreshold).map(([sig])=>sig);
            const sharedPolygons = sharedPolygonSignatures.map((sig)=>polygonBySignature.get(sig)).filter((polygon)=>Array.isArray(polygon));
            let nestedMappedZones = labels.map((labelEntry, labelIndex)=>{
                const labelName = String(labelEntry.name || labelEntry.label_name || zone.name || "preset_zone");
                const labelMetricId = Number(labelEntry.label ?? labelEntry.label_id ?? zone.metric_id ?? 0);
                const baseTemplate = $80c82a1c4eff2a21$var$pickDefaultZoneTemplate(defaultZones, labelName, Number.isFinite(labelMetricId) ? labelMetricId : undefined);
                const presetZoneId = $80c82a1c4eff2a21$var$toNumericId(zone.id);
                const resolvedLineColor = zone.line_color || baseTemplate?.line_color || "#FF8400";
                return {
                    zone_type: zone.zone_type ?? baseTemplate?.zone_type ?? (Number.isFinite(labelMetricId) && labelMetricId > 0 ? 1 : 0),
                    stream_id: zone.stream_id ?? baseTemplate?.stream_id ?? 0,
                    stream_name: zone.stream_name ?? baseTemplate?.stream_name ?? "",
                    metric_id: Number.isFinite(labelMetricId) ? labelMetricId : baseTemplate?.metric_id || 0,
                    label: `${labelName}-${zoneIndex}-${labelIndex}`,
                    label_display_name: baseTemplate?.label_display_name || $80c82a1c4eff2a21$var$presetZoneLabelDisplayName({
                        name: labelName
                    }),
                    line_color: resolvedLineColor,
                    coordinates: $80c82a1c4eff2a21$var$coerceCoordinatesToPolygonList(labelEntry.coordinates ?? zone.coordinates),
                    ...presetZoneId != null ? {
                        preset_zone_id: presetZoneId
                    } : {}
                };
            }).filter((zoneEntry)=>zoneEntry.coordinates.length > 0);
            if (uniqueCoordinateSignatures.size > 1 && sharedPolygons.length > 0 && nestedMappedZones.length > 0) {
                const ignoreAllTemplate = $80c82a1c4eff2a21$var$pickIgnoreAllTemplate(defaultZones);
                const sharedPolygonSignatureSet = new Set(sharedPolygons.map((polygon)=>$80c82a1c4eff2a21$var$polygonSignature(polygon)));
                const hasIgnoreAll = nestedMappedZones.some((zoneEntry)=>Number(zoneEntry.zone_type) === 0);
                if (!hasIgnoreAll) nestedMappedZones.unshift({
                    zone_type: 0,
                    stream_id: zone.stream_id ?? ignoreAllTemplate?.stream_id ?? 0,
                    stream_name: zone.stream_name ?? ignoreAllTemplate?.stream_name ?? "",
                    metric_id: ignoreAllTemplate?.metric_id ?? 0,
                    label: "ignore_all_inferred",
                    label_display_name: ignoreAllTemplate?.label_display_name || "Ignore All",
                    line_color: ignoreAllTemplate?.line_color || "#ffff00",
                    coordinates: sharedPolygons,
                    ...zone.id != null && Number.isFinite(Number(zone.id)) ? {
                        preset_zone_id: Number(zone.id)
                    } : {}
                });
                nestedMappedZones = nestedMappedZones.map((zoneEntry)=>{
                    if (Number(zoneEntry.zone_type) === 0) return {
                        ...zoneEntry,
                        zone_type: 0,
                        metric_id: ignoreAllTemplate?.metric_id ?? zoneEntry.metric_id,
                        label: "ignore_all_inferred",
                        label_display_name: ignoreAllTemplate?.label_display_name || "Ignore All",
                        line_color: ignoreAllTemplate?.line_color || zoneEntry.line_color || "#ffff00",
                        coordinates: sharedPolygons
                    };
                    const filteredCoordinates = zoneEntry.coordinates.filter((polygon)=>!sharedPolygonSignatureSet.has($80c82a1c4eff2a21$var$polygonSignature(polygon)));
                    return {
                        ...zoneEntry,
                        coordinates: filteredCoordinates
                    };
                }).filter((zoneEntry)=>zoneEntry.coordinates.length > 0);
            }
            if (uniqueCoordinateSignatures.size === 1 && nestedMappedZones.length > 0) {
                const ignoreAllTemplate = $80c82a1c4eff2a21$var$pickIgnoreAllTemplate(defaultZones);
                const hasIgnoreAll = nestedMappedZones.some((zoneEntry)=>Number(zoneEntry.zone_type) === 0);
                const inferredCoordinates = $80c82a1c4eff2a21$var$coerceCoordinatesToPolygonList(labels[0]?.coordinates ?? zone.coordinates);
                if (!hasIgnoreAll) nestedMappedZones.unshift({
                    zone_type: 0,
                    stream_id: zone.stream_id ?? ignoreAllTemplate?.stream_id ?? 0,
                    stream_name: zone.stream_name ?? ignoreAllTemplate?.stream_name ?? "",
                    metric_id: ignoreAllTemplate?.metric_id ?? 0,
                    label: "ignore_all_inferred",
                    label_display_name: ignoreAllTemplate?.label_display_name || "Ignore All",
                    line_color: ignoreAllTemplate?.line_color || "#FF8400",
                    coordinates: inferredCoordinates,
                    ...zone.id != null && Number.isFinite(Number(zone.id)) ? {
                        preset_zone_id: Number(zone.id)
                    } : {}
                });
                const ignoreAllZone = nestedMappedZones.find((zoneEntry)=>Number(zoneEntry.zone_type) === 0) || nestedMappedZones[0];
                nestedMappedZones = [
                    {
                        ...ignoreAllZone,
                        zone_type: 0,
                        label: "ignore_all_inferred",
                        label_display_name: ignoreAllTemplate?.label_display_name || "Ignore All",
                        line_color: ignoreAllZone.line_color || ignoreAllTemplate?.line_color || "#FF8400",
                        coordinates: inferredCoordinates
                    }
                ];
            }
            return nestedMappedZones;
        }
        const metricId = $80c82a1c4eff2a21$var$toNumericId(zone.metric_id) ?? 0;
        const presetZoneId = $80c82a1c4eff2a21$var$toNumericId(zone.id);
        const baseName = zone.name || "preset_zone";
        return {
            zone_type: zone.zone_type || 0,
            stream_id: zone.stream_id || 0,
            stream_name: zone.stream_name || "",
            metric_id: metricId,
            label: `${baseName}-${zoneIndex}`,
            label_display_name: $80c82a1c4eff2a21$var$presetZoneLabelDisplayName(zone),
            line_color: zone.line_color || "#FF8400",
            coordinates: $80c82a1c4eff2a21$var$coerceCoordinatesToPolygonList(zone.coordinates),
            ...presetZoneId != null ? {
                preset_zone_id: presetZoneId
            } : {}
        };
    }).flat();
const $80c82a1c4eff2a21$export$f06acc30ff528f8b = async ({ siteId: siteId, schedules: schedules, existingPresetsByCamera: existingPresetsByCamera, setEnabledForSite: setEnabledForSite, setPresetsForCamera: setPresetsForCamera, setSelectedPresetForScheduleCamera: setSelectedPresetForScheduleCamera })=>{
    if (!siteId || schedules.length === 0) return;
    const AxiosUI = (0, $195EM.createApi)("");
    const siteCameraMap = $80c82a1c4eff2a21$var$getSiteCameraMapFromStorage();
    const camerasByScheduleId = {};
    schedules.forEach((schedule)=>{
        camerasByScheduleId[schedule.id] = $80c82a1c4eff2a21$var$toScheduleCameras(schedule, siteCameraMap);
    });
    const cameraDefaultZonesById = new Map();
    Object.values(camerasByScheduleId).flat().forEach((camera)=>{
        if (!cameraDefaultZonesById.has(camera.id)) cameraDefaultZonesById.set(camera.id, (0, $83bsI.addIgnoreLabel)(camera.ignore_zones || []));
    });
    const uniqueCameraIds = Array.from(new Set(Object.values(camerasByScheduleId).flat().map((camera)=>camera.id)));
    if (uniqueCameraIds.length === 0) {
        setEnabledForSite(siteId, false);
        return;
    }
    try {
        const presetsByCameraFromApi = new Map();
        const ignoreZonesByCameraFromApi = new Map();
        await Promise.all(uniqueCameraIds.map(async (cameraId)=>{
            try {
                const presetsResponse = await AxiosUI.get(`preset/?camera=${cameraId}`);
                presetsByCameraFromApi.set(cameraId, $80c82a1c4eff2a21$var$parseListResponse(presetsResponse.data));
            } catch  {
                presetsByCameraFromApi.set(cameraId, []);
            }
            try {
                const ignoreZonesResponse = await AxiosUI.get(`camera/${cameraId}/ignore_zones/`);
                ignoreZonesByCameraFromApi.set(cameraId, (0, $83bsI.addIgnoreLabel)($80c82a1c4eff2a21$var$parseListResponse(ignoreZonesResponse.data)));
            } catch  {
                ignoreZonesByCameraFromApi.set(cameraId, []);
            }
        }));
        ignoreZonesByCameraFromApi.forEach((ignoreZones, cameraId)=>{
            if (ignoreZones.length > 0) cameraDefaultZonesById.set(cameraId, ignoreZones);
        });
        const assignmentRowsByScheduleId = await Promise.all(schedules.map(async (schedule)=>{
            try {
                const response = await AxiosUI.get(`auto-patrol-schedule-preset/?auto_patrol_schedule=${schedule.id}`);
                return [
                    schedule.id,
                    $80c82a1c4eff2a21$var$parseListResponse(response.data)
                ];
            } catch  {
                return [
                    schedule.id,
                    []
                ];
            }
        }));
        const hasAnyPresets = Array.from(presetsByCameraFromApi.values()).some((presets)=>presets.length > 0);
        const hasAnyAssignments = assignmentRowsByScheduleId.some(([, rows])=>rows.length > 0);
        setEnabledForSite(siteId, hasAnyPresets || hasAnyAssignments);
        const nextPresetsByCamera = {};
        uniqueCameraIds.forEach((cameraId)=>{
            nextPresetsByCamera[cameraId] = [
                ...existingPresetsByCamera[cameraId] || []
            ];
        });
        const presetIdToCameraId = new Map();
        presetsByCameraFromApi.forEach((presets, cameraId)=>{
            presets.forEach((presetRow)=>{
                const presetId = $80c82a1c4eff2a21$var$toNumericId(presetRow?.id);
                if (presetId != null) presetIdToCameraId.set(presetId, cameraId);
            });
        });
        await Promise.all(uniqueCameraIds.map(async (cameraId)=>{
            const cameraPresets = nextPresetsByCamera[cameraId];
            const defaults = cameraPresets.find((preset)=>preset.localId === `default-${cameraId}`);
            const defaultZonesFromPreset = (0, $83bsI.addIgnoreLabel)(defaults?.zones || []);
            const defaultZonesFromCameraState = cameraDefaultZonesById.get(cameraId) || [];
            const defaultZones = defaultZonesFromPreset.length > 0 ? defaultZonesFromPreset : defaultZonesFromCameraState;
            const cameraApiPresets = presetsByCameraFromApi.get(cameraId) || [];
            await Promise.all(cameraApiPresets.map(async (presetRow)=>{
                const presetId = $80c82a1c4eff2a21$var$toNumericId(presetRow?.id);
                if (presetId == null) return;
                const localId = `server-${presetId}`;
                const exists = cameraPresets.some((preset)=>preset.localId === localId || preset.persistedId === presetId);
                if (exists) return;
                const presetName = String(presetRow?.name || `Preset ${presetId}`);
                let mappedZones = [];
                try {
                    const presetZoneResponse = await AxiosUI.get(`preset-zone/?camera=${cameraId}&preset=${presetId}`);
                    mappedZones = $80c82a1c4eff2a21$var$toMappedPresetZones(presetName, $80c82a1c4eff2a21$var$parseListResponse(presetZoneResponse.data), defaultZones);
                } catch  {
                    mappedZones = [];
                }
                cameraPresets.push({
                    localId: localId,
                    cameraId: cameraId,
                    name: presetName,
                    zones: (0, $83bsI.addIgnoreLabel)(mappedZones),
                    persistedId: presetId,
                    source: "custom",
                    userNamed: true
                });
            }));
        }));
        Object.entries(nextPresetsByCamera).forEach(([cameraId, presets])=>{
            if (presets.length > 0) setPresetsForCamera(Number(cameraId), presets);
        });
        assignmentRowsByScheduleId.forEach(([scheduleId, rows])=>{
            rows.forEach((row)=>{
                const presetId = $80c82a1c4eff2a21$var$toNumericId(row?.preset?.id ?? row?.preset);
                if (presetId == null) return;
                const cameraId = $80c82a1c4eff2a21$var$toNumericId(row?.camera?.id ?? row?.camera) ?? presetIdToCameraId.get(presetId);
                if (cameraId == null) // TODO(api): confirm expected mapping source when assignment rows omit camera ids.
                return;
                const localId = `server-${presetId}`;
                const presets = nextPresetsByCamera[cameraId] || [];
                const hasPreset = presets.some((preset)=>preset.localId === localId || preset.persistedId === presetId);
                setSelectedPresetForScheduleCamera(scheduleId, cameraId, hasPreset ? localId : `default-${cameraId}`);
            });
        });
    } catch  {
    // Leave current state unchanged when sync fails.
    }
};
const $80c82a1c4eff2a21$export$3b52c88849ebeb49 = ({ siteId: siteId, schedules: schedules, open: open, onClose: onClose })=>{
    const { autoPatrolFlexIgnoreZonesActiveScheduleIndexBySite: autoPatrolFlexIgnoreZonesActiveScheduleIndexBySite, setAutoPatrolFlexIgnoreZonesActiveScheduleIndexForSite: setAutoPatrolFlexIgnoreZonesActiveScheduleIndexForSite, autoPatrolFlexIgnoreZonesPresetsByCamera: autoPatrolFlexIgnoreZonesPresetsByCamera, setAutoPatrolFlexIgnoreZonesPresetsForCamera: setAutoPatrolFlexIgnoreZonesPresetsForCamera, autoPatrolFlexIgnoreZonesSelectedPresetByScheduleCamera: autoPatrolFlexIgnoreZonesSelectedPresetByScheduleCamera, setAutoPatrolFlexIgnoreZonesSelectedPresetForScheduleCamera: setAutoPatrolFlexIgnoreZonesSelectedPresetForScheduleCamera, initializeAutoPatrolFlexIgnoreZonesForSite: initializeAutoPatrolFlexIgnoreZonesForSite, setScheduleChangesMade: setScheduleChangesMade } = (0, $3FJ79.useSiteAboutStore)();
    const [newPresetDialog, setNewPresetDialog] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [editorPresetName, setEditorPresetName] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [wizardStep, setWizardStep] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("scheduleSelection");
    const [liveCameraDataById, setLiveCameraDataById] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [submitLoading, setSubmitLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const inFlightCameraIdsRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(new Set());
    const initializedConfigKeyRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef("");
    const assignmentsHydratedKeyRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef("");
    const assignmentsHydrationInFlightRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(false);
    const apSchedules = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>schedules.filter((schedule)=>schedule.patrolType === "AutoPatrol"), [
        schedules
    ]);
    const siteCameraMap = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>$80c82a1c4eff2a21$var$getSiteCameraMapFromStorage(), [
        open
    ]);
    const camerasByScheduleId = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>{
        const map = {};
        apSchedules.forEach((schedule)=>{
            map[schedule.id] = $80c82a1c4eff2a21$var$toScheduleCameras(schedule, siteCameraMap).map((camera)=>{
                const live = liveCameraDataById[camera.id];
                return {
                    ...camera,
                    preview_url: live?.preview_url || camera.preview_url || "",
                    ignore_zones: (0, $83bsI.addIgnoreLabel)(live?.ignore_zones || camera.ignore_zones || [])
                };
            });
        });
        return map;
    }, [
        apSchedules,
        siteCameraMap,
        liveCameraDataById
    ]);
    const dialogConfigKey = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>JSON.stringify(apSchedules.map((schedule)=>({
                scheduleId: schedule.id,
                cameraIds: (camerasByScheduleId[schedule.id] || []).map((camera)=>camera.id)
            }))), [
        apSchedules,
        camerasByScheduleId
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!open) {
            initializedConfigKeyRef.current = "";
            setWizardStep((previous)=>previous === "scheduleSelection" ? previous : "scheduleSelection");
            return;
        }
        if (initializedConfigKeyRef.current === dialogConfigKey) return;
        const scheduleIds = apSchedules.map((schedule)=>schedule.id);
        const cameraIdsBySchedule = Object.fromEntries(apSchedules.map((schedule)=>[
                schedule.id,
                (camerasByScheduleId[schedule.id] || []).map((camera)=>camera.id)
            ]));
        initializeAutoPatrolFlexIgnoreZonesForSite({
            siteId: siteId,
            scheduleIds: scheduleIds,
            cameraIdsBySchedule: cameraIdsBySchedule
        });
        setAutoPatrolFlexIgnoreZonesActiveScheduleIndexForSite(siteId, 0);
        setWizardStep("scheduleSelection");
        initializedConfigKeyRef.current = dialogConfigKey;
    }, [
        open,
        dialogConfigKey,
        apSchedules,
        camerasByScheduleId,
        siteId,
        initializeAutoPatrolFlexIgnoreZonesForSite,
        setAutoPatrolFlexIgnoreZonesActiveScheduleIndexForSite
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!open) {
            setLiveCameraDataById((previous)=>Object.keys(previous).length === 0 ? previous : {});
            assignmentsHydratedKeyRef.current = "";
            assignmentsHydrationInFlightRef.current = false;
            if (inFlightCameraIdsRef.current.size > 0) inFlightCameraIdsRef.current = new Set();
            return;
        }
        const AxiosUI = (0, $195EM.createApi)("");
        const uniqueCameraIds = Array.from(new Set(Object.values(camerasByScheduleId).flat().map((camera)=>camera.id)));
        const toFetch = uniqueCameraIds.filter((cameraId)=>{
            const alreadyLoaded = liveCameraDataById[cameraId] != null;
            const inFlight = inFlightCameraIdsRef.current.has(cameraId);
            return !alreadyLoaded && !inFlight;
        });
        if (toFetch.length === 0) return;
        toFetch.forEach((cameraId)=>inFlightCameraIdsRef.current.add(cameraId));
        Promise.all(toFetch.map(async (cameraId)=>{
            try {
                const [statusResponse, zonesResponse] = await Promise.all([
                    AxiosUI.get(`/camera/${cameraId}/status/`, {
                        timeout: 8000
                    }),
                    AxiosUI.get(`/camera/${cameraId}/ignore_zones/`, {
                        timeout: 8000
                    })
                ]);
                setLiveCameraDataById((previous)=>({
                        ...previous,
                        [cameraId]: {
                            preview_url: String(statusResponse.data?.preview_url || "").trim(),
                            ignore_zones: (0, $83bsI.addIgnoreLabel)(zonesResponse.data || [])
                        }
                    }));
            } catch (error) {
            // Keep fallback data from cached site cameras when live endpoints fail.
            }
            inFlightCameraIdsRef.current.delete(cameraId);
        }));
    }, [
        open,
        camerasByScheduleId,
        liveCameraDataById
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!open) return;
        Object.values(camerasByScheduleId).flat().forEach((camera)=>{
            $80c82a1c4eff2a21$var$ensureCameraPresets(camera, autoPatrolFlexIgnoreZonesPresetsByCamera, setAutoPatrolFlexIgnoreZonesPresetsForCamera);
        });
    }, [
        open,
        camerasByScheduleId,
        autoPatrolFlexIgnoreZonesPresetsByCamera,
        setAutoPatrolFlexIgnoreZonesPresetsForCamera
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!open || apSchedules.length === 0) return;
        const hydrationKey = `${siteId}:${apSchedules.map((schedule)=>schedule.id).join(",")}`;
        if (assignmentsHydratedKeyRef.current === hydrationKey || assignmentsHydrationInFlightRef.current) return;
        assignmentsHydrationInFlightRef.current = true;
        const AxiosUI = (0, $195EM.createApi)("");
        (async ()=>{
            try {
                const uniqueCameraIds = Array.from(new Set(apSchedules.flatMap((schedule)=>(camerasByScheduleId[schedule.id] || []).map((camera)=>camera.id))));
                const presetsByCameraFromApi = new Map();
                await Promise.all(uniqueCameraIds.map(async (cameraId)=>{
                    try {
                        const presetsResponse = await AxiosUI.get(`preset/?camera=${cameraId}`);
                        presetsByCameraFromApi.set(cameraId, $80c82a1c4eff2a21$var$parseListResponse(presetsResponse.data));
                    } catch  {
                        presetsByCameraFromApi.set(cameraId, []);
                    }
                }));
                const presetIdToCameraId = new Map();
                presetsByCameraFromApi.forEach((presets, cameraId)=>{
                    presets.forEach((presetRow)=>{
                        const presetId = $80c82a1c4eff2a21$var$toNumericId(presetRow?.id);
                        if (presetId != null) presetIdToCameraId.set(presetId, cameraId);
                    });
                });
                const nextPresetsByCamera = {};
                uniqueCameraIds.forEach((cameraId)=>{
                    nextPresetsByCamera[cameraId] = [
                        ...autoPatrolFlexIgnoreZonesPresetsByCamera[cameraId] || []
                    ];
                });
                const assignmentRowsByScheduleId = await Promise.all(apSchedules.map(async (schedule)=>{
                    try {
                        const response = await AxiosUI.get(`auto-patrol-schedule-preset/?auto_patrol_schedule=${schedule.id}`);
                        return [
                            schedule.id,
                            $80c82a1c4eff2a21$var$parseListResponse(response.data)
                        ];
                    } catch  {
                        return [
                            schedule.id,
                            []
                        ];
                    }
                }));
                assignmentRowsByScheduleId.forEach(([scheduleId, rows])=>{
                    rows.forEach((row)=>{
                        const presetId = $80c82a1c4eff2a21$var$toNumericId(row?.preset?.id ?? row?.preset);
                        if (presetId == null) return;
                        const cameraIdFromAssignment = $80c82a1c4eff2a21$var$toNumericId(row?.camera?.id ?? row?.camera);
                        const cameraId = cameraIdFromAssignment ?? presetIdToCameraId.get(presetId);
                        if (cameraId == null) return;
                        const existingForCamera = nextPresetsByCamera[cameraId] || [];
                        const localId = `server-${presetId}`;
                        const hasPreset = existingForCamera.some((preset)=>preset.localId === localId || preset.persistedId === presetId);
                        if (!hasPreset) {
                            const presetMeta = (presetsByCameraFromApi.get(cameraId) || []).find((presetRow)=>$80c82a1c4eff2a21$var$toNumericId(presetRow?.id) === presetId);
                            const defaultPreset = existingForCamera.find((preset)=>preset.localId === `default-${cameraId}`);
                            const defaultZones = (0, $83bsI.addIgnoreLabel)(defaultPreset?.zones || []);
                            const appendPreset = (zones)=>{
                                existingForCamera.push({
                                    localId: localId,
                                    cameraId: cameraId,
                                    name: String(presetMeta?.name || `Preset ${presetId}`),
                                    zones: (0, $83bsI.addIgnoreLabel)(zones),
                                    persistedId: presetId,
                                    source: "custom",
                                    userNamed: true
                                });
                            };
                            AxiosUI.get(`preset-zone/?camera=${cameraId}&preset=${presetId}`).then((presetZoneResponse)=>{
                                appendPreset($80c82a1c4eff2a21$var$toMappedPresetZones(String(presetMeta?.name || `Preset ${presetId}`), $80c82a1c4eff2a21$var$parseListResponse(presetZoneResponse.data), defaultZones));
                                setAutoPatrolFlexIgnoreZonesPresetsForCamera(cameraId, [
                                    ...existingForCamera
                                ]);
                            }).catch(()=>{
                                appendPreset([]);
                                setAutoPatrolFlexIgnoreZonesPresetsForCamera(cameraId, [
                                    ...existingForCamera
                                ]);
                            });
                        }
                        setAutoPatrolFlexIgnoreZonesSelectedPresetForScheduleCamera(scheduleId, cameraId, localId);
                    });
                });
                Object.entries(nextPresetsByCamera).forEach(([cameraId, presets])=>{
                    if (presets.length > 0) setAutoPatrolFlexIgnoreZonesPresetsForCamera(Number(cameraId), presets);
                });
                assignmentsHydratedKeyRef.current = hydrationKey;
            } finally{
                assignmentsHydrationInFlightRef.current = false;
            }
        })();
    }, [
        open,
        siteId,
        apSchedules,
        camerasByScheduleId,
        autoPatrolFlexIgnoreZonesPresetsByCamera,
        setAutoPatrolFlexIgnoreZonesPresetsForCamera,
        setAutoPatrolFlexIgnoreZonesSelectedPresetForScheduleCamera
    ]);
    const activeScheduleIndex = Math.min(autoPatrolFlexIgnoreZonesActiveScheduleIndexBySite[siteId] || 0, Math.max(apSchedules.length - 1, 0));
    const currentSchedule = apSchedules[activeScheduleIndex];
    const currentScheduleCameras = currentSchedule ? camerasByScheduleId[currentSchedule.id] || [] : [];
    const handleSubmit = async ()=>{
        const AxiosUI = (0, $195EM.createApi)("");
        setSubmitLoading(true);
        try {
            const submitCells = [];
            apSchedules.forEach((schedule)=>{
                const cameras = camerasByScheduleId[schedule.id] || [];
                cameras.forEach((camera)=>{
                    const presetLocalId = autoPatrolFlexIgnoreZonesSelectedPresetByScheduleCamera[`${schedule.id}:${camera.id}`] || `default-${camera.id}`;
                    const preset = (autoPatrolFlexIgnoreZonesPresetsByCamera[camera.id] || []).find((item)=>item.localId === presetLocalId);
                    if (!preset) return;
                    submitCells.push({
                        scheduleId: schedule.id,
                        cameraId: camera.id,
                        presetLocalId: presetLocalId,
                        preset: preset
                    });
                });
            });
            if (submitCells.length === 0) {
                setScheduleChangesMade(true);
                onClose();
                return;
            }
            const uniqueByCameraPreset = new Map();
            submitCells.forEach((cell)=>{
                const key = `${cell.cameraId}:${cell.presetLocalId}`;
                if (!uniqueByCameraPreset.has(key)) uniqueByCameraPreset.set(key, {
                    cameraId: cell.cameraId,
                    presetLocalId: cell.presetLocalId,
                    preset: cell.preset
                });
            });
            let metricRows = [];
            const needsMetricRows = Array.from(uniqueByCameraPreset.values()).some((entry)=>entry.preset.persistedId == null && (entry.preset.zones || []).length > 0);
            if (needsMetricRows) {
                const siteStore = (0, $3FJ79.useSiteAboutStore).getState();
                if (siteStore.siteMetricsSimplifiedCustomerId === siteId && siteStore.siteMetricsSimplified.length > 0) metricRows = siteStore.siteMetricsSimplified;
                else {
                    const metricResponse = await AxiosUI.get("metric/simplified/", {
                        params: {
                            customer: siteId
                        }
                    });
                    metricRows = $80c82a1c4eff2a21$var$parseListResponse(metricResponse.data);
                    siteStore.setSiteMetricsSimplifiedData(metricRows, siteId);
                }
            }
            const persistedIdByCameraPreset = new Map();
            const nextPresetsByCamera = {};
            Object.keys(autoPatrolFlexIgnoreZonesPresetsByCamera).forEach((cameraId)=>{
                nextPresetsByCamera[Number(cameraId)] = [
                    ...autoPatrolFlexIgnoreZonesPresetsByCamera[Number(cameraId)]
                ];
            });
            for (const [cameraPresetKey, meta] of uniqueByCameraPreset.entries()){
                const presetName = (meta.preset.name || "").trim() || "Preset";
                if (meta.preset.persistedId != null && Number.isFinite(Number(meta.preset.persistedId))) {
                    persistedIdByCameraPreset.set(cameraPresetKey, Number(meta.preset.persistedId));
                    continue;
                }
                const createdPresetResponse = await AxiosUI.post("preset/", {
                    camera: meta.cameraId,
                    name: presetName
                });
                const createdPresetId = $80c82a1c4eff2a21$var$toNumericId(createdPresetResponse.data?.id);
                if (createdPresetId == null) throw new Error(`Unable to create preset for camera ${meta.cameraId}.`);
                if ((meta.preset.zones || []).length > 0) {
                    const presetZonePayload = (0, $7ulPk.buildPresetZonePayload)({
                        cameraId: meta.cameraId,
                        presetId: createdPresetId,
                        presetName: `${presetName} #${createdPresetId}`,
                        zones: meta.preset.zones || [],
                        metricRows: metricRows
                    });
                    await AxiosUI.post("preset-zone/", presetZonePayload);
                }
                persistedIdByCameraPreset.set(cameraPresetKey, createdPresetId);
                const current = nextPresetsByCamera[meta.cameraId] || [];
                nextPresetsByCamera[meta.cameraId] = current.map((preset)=>preset.localId === meta.presetLocalId ? {
                        ...preset,
                        persistedId: createdPresetId,
                        name: presetName
                    } : preset);
            }
            Object.entries(nextPresetsByCamera).forEach(([cameraId, presets])=>{
                setAutoPatrolFlexIgnoreZonesPresetsForCamera(Number(cameraId), presets);
            });
            const existingAssignmentByScheduleCamera = new Map();
            const persistedPresetIdToCameraId = new Map();
            Object.entries(nextPresetsByCamera).forEach(([cameraId, presets])=>{
                presets.forEach((preset)=>{
                    if (preset.persistedId != null && Number.isFinite(Number(preset.persistedId))) persistedPresetIdToCameraId.set(Number(preset.persistedId), Number(cameraId));
                });
            });
            const assignmentRowsByScheduleId = await Promise.all(apSchedules.map(async (schedule)=>{
                try {
                    const response = await AxiosUI.get(`auto-patrol-schedule-preset/?auto_patrol_schedule=${schedule.id}`);
                    return [
                        schedule.id,
                        $80c82a1c4eff2a21$var$parseListResponse(response.data)
                    ];
                } catch  {
                    return [
                        schedule.id,
                        []
                    ];
                }
            }));
            assignmentRowsByScheduleId.forEach(([scheduleId, rows])=>{
                rows.forEach((row)=>{
                    const presetId = $80c82a1c4eff2a21$var$toNumericId(row?.preset?.id ?? row?.preset);
                    if (presetId == null) return;
                    const cameraId = $80c82a1c4eff2a21$var$toNumericId(row?.camera?.id ?? row?.camera) ?? persistedPresetIdToCameraId.get(presetId);
                    if (cameraId == null) return;
                    existingAssignmentByScheduleCamera.set(`${scheduleId}:${cameraId}`, presetId);
                });
            });
            for (const cell of submitCells){
                const desiredPresetId = persistedIdByCameraPreset.get(`${cell.cameraId}:${cell.presetLocalId}`);
                if (desiredPresetId == null) continue;
                const existingPresetId = existingAssignmentByScheduleCamera.get(`${cell.scheduleId}:${cell.cameraId}`);
                if (existingPresetId === desiredPresetId) continue;
                // TODO(api): confirm whether backend expects stale assignments to be explicitly deleted.
                await AxiosUI.post("auto-patrol-schedule-preset/", {
                    auto_patrol_schedule: cell.scheduleId,
                    preset: desiredPresetId
                });
            }
            setScheduleChangesMade(true);
            setSubmitLoading(false);
            onClose();
        } catch (error) {
            setSubmitLoading(false);
            alert(error?.message || "Unable to save AutoPatrol Flex Ignore Zones. Please try again.");
        }
    };
    const assignments = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>{
        return Object.entries(autoPatrolFlexIgnoreZonesSelectedPresetByScheduleCamera).map(([key, presetLocalId])=>{
            const [scheduleId, cameraId] = key.split(":").map(Number);
            const scheduleIndex = apSchedules.findIndex((item)=>item.id === scheduleId);
            const schedule = apSchedules[scheduleIndex];
            const camera = (camerasByScheduleId[scheduleId] || []).find((item)=>item.id === cameraId);
            const preset = (autoPatrolFlexIgnoreZonesPresetsByCamera[cameraId] || []).find((item)=>item.localId === presetLocalId);
            if (!schedule || !camera || !preset) return null;
            return {
                schedule: {
                    id: schedule.id,
                    display_name: schedule.title || `Schedule ${scheduleIndex >= 0 ? scheduleIndex + 1 : ""}`
                },
                camera: camera,
                preset: preset,
                cameraContext: $80c82a1c4eff2a21$var$buildCameraContext(camera)
            };
        }).filter(Boolean);
    }, [
        autoPatrolFlexIgnoreZonesSelectedPresetByScheduleCamera,
        apSchedules,
        camerasByScheduleId,
        autoPatrolFlexIgnoreZonesPresetsByCamera
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                openState: submitLoading,
                message: "Saving AutoPatrol Flex Ignore Zones...",
                stackAboveModal: true
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                open: open,
                onClose: (_, reason)=>{
                    if (!submitLoading && reason !== "backdropClick") onClose();
                },
                fullWidth: true,
                maxWidth: "xl",
                PaperProps: {
                    sx: {
                        fontFamily: "Mulish",
                        minHeight: "85vh"
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $ce8iU.default), {
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: 700,
                            bgcolor: "#1B2A4A",
                            color: "white",
                            py: 2.25,
                            pr: 6
                        },
                        children: [
                            "Flex Ignore Zones Onboarding",
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                onClick: onClose,
                                "aria-label": "close autopatrol flex ignore zones onboarding dialog",
                                disabled: submitLoading,
                                sx: {
                                    position: "absolute",
                                    right: 12,
                                    top: 12,
                                    color: "white",
                                    "&:hover": {
                                        backgroundColor: "rgba(255, 255, 255, 0.12)"
                                    }
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                        dividers: true,
                        children: wizardStep === "scheduleSelection" && currentSchedule ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "font-mulish text-[20px] font-black",
                                    children: currentSchedule.title || `Schedule ${activeScheduleIndex + 1}`
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                    className: "font-mulish text-[16px] pt-[4px] pb-[12px]",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                            className: "font-bold",
                                            children: "Cadence:"
                                        }),
                                        " ",
                                        $80c82a1c4eff2a21$var$toCadenceText(currentSchedule)
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "font-mulish text-[14px] pb-[12px] pt-[4px]",
                                    children: "Select an ignore zones preset for each camera in this schedule."
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-[12px] justify-items-start",
                                    children: currentScheduleCameras.map((camera)=>{
                                        const allPresets = autoPatrolFlexIgnoreZonesPresetsByCamera[camera.id] || [];
                                        const selectedLocalId = autoPatrolFlexIgnoreZonesSelectedPresetByScheduleCamera[`${currentSchedule.id}:${camera.id}`] || `default-${camera.id}`;
                                        const selectablePresets = (0, $6JE7U.collapseNoIgnoreZonesPresetOptions)(allPresets, selectedLocalId);
                                        const selectedPreset = selectablePresets.find((preset)=>preset.localId === selectedLocalId) || selectablePresets[0];
                                        if (!selectedPreset) return null;
                                        return /*#__PURE__*/ (0, $k4ank.jsx)((0, $87t0c.FlexIgnoreZonesEditPresetCard), {
                                            scheduleId: currentSchedule.id,
                                            camera: camera,
                                            preset: selectedPreset,
                                            cameraContext: $80c82a1c4eff2a21$var$buildCameraContext(camera),
                                            selectablePresets: selectablePresets,
                                            selectedPresetLocalId: selectedLocalId,
                                            onSelectPreset: (presetLocalId)=>{
                                                setAutoPatrolFlexIgnoreZonesSelectedPresetForScheduleCamera(currentSchedule.id, camera.id, presetLocalId);
                                                setScheduleChangesMade(true);
                                            },
                                            onCreateNewPreset: ()=>{
                                                const newLocalId = `ap-custom-${camera.id}-${Date.now()}`;
                                                const defaultPresetZones = allPresets.find((preset)=>preset.localId === `default-${camera.id}`)?.zones || [];
                                                const nextPreset = {
                                                    localId: newLocalId,
                                                    cameraId: camera.id,
                                                    name: $80c82a1c4eff2a21$var$buildNextPresetName(camera.id, autoPatrolFlexIgnoreZonesPresetsByCamera),
                                                    zones: (0, $83bsI.addIgnoreLabel)(defaultPresetZones.length > 0 ? defaultPresetZones : camera.ignore_zones || []),
                                                    persistedId: null,
                                                    source: "custom",
                                                    userNamed: false
                                                };
                                                setAutoPatrolFlexIgnoreZonesPresetsForCamera(camera.id, [
                                                    ...allPresets,
                                                    nextPreset
                                                ]);
                                                setAutoPatrolFlexIgnoreZonesSelectedPresetForScheduleCamera(currentSchedule.id, camera.id, nextPreset.localId);
                                                setEditorPresetName(nextPreset.name);
                                                setNewPresetDialog({
                                                    scheduleId: currentSchedule.id,
                                                    cameraId: camera.id,
                                                    cameraName: camera.camera_name,
                                                    presetLocalId: nextPreset.localId
                                                });
                                                setScheduleChangesMade(true);
                                            },
                                            onPreviewImageError: ()=>{},
                                            showNoIgnoreZonesOption: true
                                        }, `${currentSchedule.id}-${camera.id}`);
                                    })
                                })
                            ]
                        }) : wizardStep === "summary" ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $2RrZf.SummaryStep), {
                            assignments: assignments
                        }) : /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "font-mulish text-[14px]",
                            children: "No AutoPatrol schedules available."
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                        children: [
                            (wizardStep === "summary" || activeScheduleIndex > 0) && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    if (wizardStep === "summary") {
                                        setAutoPatrolFlexIgnoreZonesActiveScheduleIndexForSite(siteId, Math.max(apSchedules.length - 1, 0));
                                        setWizardStep("scheduleSelection");
                                        return;
                                    }
                                    setAutoPatrolFlexIgnoreZonesActiveScheduleIndexForSite(siteId, activeScheduleIndex - 1);
                                },
                                text: "Back",
                                disabled: submitLoading
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    if (wizardStep === "summary") {
                                        handleSubmit();
                                        return;
                                    }
                                    if (activeScheduleIndex < apSchedules.length - 1) {
                                        setAutoPatrolFlexIgnoreZonesActiveScheduleIndexForSite(siteId, activeScheduleIndex + 1);
                                        return;
                                    }
                                    setWizardStep("summary");
                                },
                                text: wizardStep === "summary" ? "Submit" : "Next",
                                disabled: apSchedules.length === 0 || submitLoading
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                open: newPresetDialog != null,
                onClose: ()=>setNewPresetDialog(null),
                fullWidth: true,
                maxWidth: "xl",
                PaperProps: {
                    sx: {
                        fontFamily: "Mulish",
                        maxHeight: "90vh"
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                        dividers: true,
                        sx: {
                            overflow: "auto"
                        },
                        children: newPresetDialog && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2OZNn.PresetEditorStep), {
                            cameraName: newPresetDialog.cameraName,
                            cameraContext: $80c82a1c4eff2a21$var$buildCameraContext(Object.values(camerasByScheduleId).flat().find((camera)=>camera.id === newPresetDialog.cameraId) || {
                                id: newPresetDialog.cameraId,
                                camera_name: newPresetDialog.cameraName,
                                preview_url: liveCameraDataById[newPresetDialog.cameraId]?.preview_url || "",
                                ignore_zones: liveCameraDataById[newPresetDialog.cameraId]?.ignore_zones || []
                            }),
                            preset: (autoPatrolFlexIgnoreZonesPresetsByCamera[newPresetDialog.cameraId] || []).find((preset)=>preset.localId === newPresetDialog.presetLocalId) || {
                                localId: newPresetDialog.presetLocalId,
                                cameraId: newPresetDialog.cameraId,
                                name: editorPresetName,
                                zones: [],
                                persistedId: null,
                                source: "custom",
                                userNamed: false
                            },
                            onPresetNameChange: (value)=>{
                                setEditorPresetName(value);
                                const current = autoPatrolFlexIgnoreZonesPresetsByCamera[newPresetDialog.cameraId] || [];
                                setAutoPatrolFlexIgnoreZonesPresetsForCamera(newPresetDialog.cameraId, current.map((preset)=>preset.localId === newPresetDialog.presetLocalId ? {
                                        ...preset,
                                        name: value,
                                        userNamed: true
                                    } : preset));
                            },
                            onPresetZonesChange: (zones)=>{
                                const current = autoPatrolFlexIgnoreZonesPresetsByCamera[newPresetDialog.cameraId] || [];
                                setAutoPatrolFlexIgnoreZonesPresetsForCamera(newPresetDialog.cameraId, current.map((preset)=>preset.localId === newPresetDialog.presetLocalId ? {
                                        ...preset,
                                        zones: (0, $83bsI.addIgnoreLabel)(zones)
                                    } : preset));
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                        sx: {
                            px: 3,
                            pb: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    if (!newPresetDialog) return;
                                    const current = autoPatrolFlexIgnoreZonesPresetsByCamera[newPresetDialog.cameraId] || [];
                                    setAutoPatrolFlexIgnoreZonesPresetsForCamera(newPresetDialog.cameraId, current.filter((preset)=>preset.localId !== newPresetDialog.presetLocalId || preset.persistedId != null));
                                    setNewPresetDialog(null);
                                },
                                text: "Cancel",
                                disabled: false
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>setNewPresetDialog(null),
                                text: "Submit",
                                disabled: false
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $80c82a1c4eff2a21$export$7a0601423a954793 = ({ schedule: schedule, editMode: editMode })=>{
    const { autoPatrolFlexIgnoreZonesPresetsByCamera: autoPatrolFlexIgnoreZonesPresetsByCamera, autoPatrolFlexIgnoreZonesSelectedPresetByScheduleCamera: autoPatrolFlexIgnoreZonesSelectedPresetByScheduleCamera, setAutoPatrolFlexIgnoreZonesSelectedPresetForScheduleCamera: setAutoPatrolFlexIgnoreZonesSelectedPresetForScheduleCamera, setAutoPatrolFlexIgnoreZonesPresetsForCamera: setAutoPatrolFlexIgnoreZonesPresetsForCamera, setScheduleChangesMade: setScheduleChangesMade } = (0, $3FJ79.useSiteAboutStore)();
    const [liveCameraDataById, setLiveCameraDataById] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const inFlightCameraIdsRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(new Set());
    const baseCameras = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>{
        const siteCameraMap = $80c82a1c4eff2a21$var$getSiteCameraMapFromStorage();
        return $80c82a1c4eff2a21$var$toScheduleCameras(schedule, siteCameraMap);
    }, [
        schedule
    ]);
    const cameras = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>baseCameras.map((camera)=>{
            const live = liveCameraDataById[camera.id];
            return {
                ...camera,
                preview_url: live?.preview_url || camera.preview_url || "",
                ignore_zones: (0, $83bsI.addIgnoreLabel)(live?.ignore_zones || camera.ignore_zones || [])
            };
        }), [
        baseCameras,
        liveCameraDataById
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        const AxiosUI = (0, $195EM.createApi)("");
        const uniqueCameraIds = Array.from(new Set(baseCameras.map((camera)=>camera.id)));
        const toFetch = uniqueCameraIds.filter((cameraId)=>{
            const alreadyLoaded = liveCameraDataById[cameraId] != null;
            const inFlight = inFlightCameraIdsRef.current.has(cameraId);
            return !alreadyLoaded && !inFlight;
        });
        if (toFetch.length === 0) return;
        toFetch.forEach((cameraId)=>inFlightCameraIdsRef.current.add(cameraId));
        Promise.all(toFetch.map(async (cameraId)=>{
            try {
                const [statusResponse, zonesResponse] = await Promise.all([
                    AxiosUI.get(`/camera/${cameraId}/status/`, {
                        timeout: 8000
                    }),
                    AxiosUI.get(`/camera/${cameraId}/ignore_zones/`, {
                        timeout: 8000
                    })
                ]);
                setLiveCameraDataById((previous)=>({
                        ...previous,
                        [cameraId]: {
                            preview_url: String(statusResponse.data?.preview_url || "").trim(),
                            ignore_zones: (0, $83bsI.addIgnoreLabel)(zonesResponse.data || [])
                        }
                    }));
            } catch  {
            // Keep fallback values from local cache for this camera.
            } finally{
                inFlightCameraIdsRef.current.delete(cameraId);
            }
        }));
    }, [
        schedule.id,
        baseCameras,
        liveCameraDataById
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        cameras.forEach((camera)=>$80c82a1c4eff2a21$var$ensureCameraPresets(camera, autoPatrolFlexIgnoreZonesPresetsByCamera, setAutoPatrolFlexIgnoreZonesPresetsForCamera));
    }, [
        cameras,
        autoPatrolFlexIgnoreZonesPresetsByCamera,
        setAutoPatrolFlexIgnoreZonesPresetsForCamera
    ]);
    if (cameras.length === 0) return null;
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "pl-[15px] pr-[20px] pt-[16px] pb-[24px] bg-white",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "font-mulish text-[18px] font-black pb-[12px]",
                children: "Selected Cameras / Flex Schedule Presets"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-[12px] justify-items-start max-w-[1500px]",
                children: cameras.map((camera)=>{
                    const allPresets = autoPatrolFlexIgnoreZonesPresetsByCamera[camera.id] || [];
                    const selectedLocalId = autoPatrolFlexIgnoreZonesSelectedPresetByScheduleCamera[`${schedule.id}:${camera.id}`] || `default-${camera.id}`;
                    const selectablePresets = (0, $6JE7U.collapseNoIgnoreZonesPresetOptions)(allPresets, selectedLocalId);
                    const selectedPreset = selectablePresets.find((preset)=>preset.localId === selectedLocalId) || selectablePresets[0];
                    if (!selectedPreset) return null;
                    if (!editMode) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $eVSHG.FlexIgnoreZonesCameraPresetCard), {
                        scheduleId: schedule.id,
                        camera: camera,
                        preset: selectedPreset,
                        cameraContext: $80c82a1c4eff2a21$var$buildCameraContext(camera)
                    }, `${schedule.id}-${camera.id}`);
                    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $87t0c.FlexIgnoreZonesEditPresetCard), {
                        scheduleId: schedule.id,
                        camera: camera,
                        preset: selectedPreset,
                        cameraContext: $80c82a1c4eff2a21$var$buildCameraContext(camera),
                        selectablePresets: selectablePresets,
                        selectedPresetLocalId: selectedLocalId,
                        onSelectPreset: (presetLocalId)=>{
                            if (presetLocalId === $80c82a1c4eff2a21$var$AP_FLEX_CREATE_NEW_PRESET_OPTION) return;
                            setAutoPatrolFlexIgnoreZonesSelectedPresetForScheduleCamera(schedule.id, camera.id, presetLocalId);
                            setScheduleChangesMade(true);
                        },
                        onCreateNewPreset: ()=>{
                            const defaultPresetZones = allPresets.find((preset)=>preset.localId === `default-${camera.id}`)?.zones || [];
                            const newPreset = {
                                localId: `ap-custom-${camera.id}-${Date.now()}`,
                                cameraId: camera.id,
                                name: $80c82a1c4eff2a21$var$buildNextPresetName(camera.id, autoPatrolFlexIgnoreZonesPresetsByCamera),
                                zones: (0, $83bsI.addIgnoreLabel)(defaultPresetZones.length > 0 ? defaultPresetZones : camera.ignore_zones || []),
                                persistedId: null,
                                source: "custom",
                                userNamed: false
                            };
                            setAutoPatrolFlexIgnoreZonesPresetsForCamera(camera.id, [
                                ...allPresets,
                                newPreset
                            ]);
                            setAutoPatrolFlexIgnoreZonesSelectedPresetForScheduleCamera(schedule.id, camera.id, newPreset.localId);
                            setScheduleChangesMade(true);
                        },
                        onPreviewImageError: ()=>{},
                        showNoIgnoreZonesOption: true
                    }, `${schedule.id}-${camera.id}`);
                })
            })
        ]
    });
};
const $80c82a1c4eff2a21$export$68b17dd5be03cb77 = ({ siteId: siteId, scheduleId: scheduleId, cameraId: cameraId, cameraName: cameraName, previewUrl: previewUrl, defaultZones: defaultZones, onZonesChange: onZonesChange })=>{
    const { autoPatrolFlexIgnoreZonesEnabledBySite: autoPatrolFlexIgnoreZonesEnabledBySite, autoPatrolFlexIgnoreZonesPresetsByCamera: autoPatrolFlexIgnoreZonesPresetsByCamera, autoPatrolFlexIgnoreZonesSelectedPresetByScheduleCamera: autoPatrolFlexIgnoreZonesSelectedPresetByScheduleCamera, setAutoPatrolFlexIgnoreZonesPresetsForCamera: setAutoPatrolFlexIgnoreZonesPresetsForCamera } = (0, $3FJ79.useSiteAboutStore)();
    const enabled = autoPatrolFlexIgnoreZonesEnabledBySite[siteId] === true;
    const presets = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>autoPatrolFlexIgnoreZonesPresetsByCamera[cameraId] ?? $80c82a1c4eff2a21$var$EMPTY_AUTOPATROL_FLEX_PRESETS, [
        autoPatrolFlexIgnoreZonesPresetsByCamera,
        cameraId
    ]);
    const lastZonesHashRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef("");
    const onZonesChangeRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(onZonesChange);
    const [newPresetDialog, setNewPresetDialog] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        onZonesChangeRef.current = onZonesChange;
    }, [
        onZonesChange
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!enabled) return;
        if (presets.length === 0) {
            const defaultPreset = {
                localId: `default-${cameraId}`,
                cameraId: cameraId,
                name: "Default Preset",
                zones: (0, $83bsI.addIgnoreLabel)(defaultZones),
                persistedId: null,
                source: "default",
                userNamed: false
            };
            const noIgnoreZonesPreset = {
                localId: $80c82a1c4eff2a21$export$6f9ccc0121d8e3dd,
                cameraId: cameraId,
                name: "No Ignore Zones",
                zones: [],
                persistedId: null,
                source: "custom",
                userNamed: true
            };
            setAutoPatrolFlexIgnoreZonesPresetsForCamera(cameraId, [
                defaultPreset,
                noIgnoreZonesPreset
            ]);
        }
    }, [
        enabled,
        presets.length,
        cameraId,
        defaultZones,
        setAutoPatrolFlexIgnoreZonesPresetsForCamera
    ]);
    const assignedLocalId = autoPatrolFlexIgnoreZonesSelectedPresetByScheduleCamera[`${scheduleId}:${cameraId}`] || `default-${cameraId}`;
    const [rowSelectedLocalId, setRowSelectedLocalId] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const selectedLocalId = rowSelectedLocalId || assignedLocalId;
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!enabled) {
            setRowSelectedLocalId((prev)=>prev === "" ? prev : "");
            return;
        }
        if (!rowSelectedLocalId) return;
        const stillExists = presets.some((preset)=>preset.localId === rowSelectedLocalId);
        if (!stillExists) setRowSelectedLocalId((prev)=>prev === "" ? prev : "");
    }, [
        enabled,
        rowSelectedLocalId,
        presets
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!enabled) return;
        const selected = (autoPatrolFlexIgnoreZonesPresetsByCamera[cameraId] ?? $80c82a1c4eff2a21$var$EMPTY_AUTOPATROL_FLEX_PRESETS).find((preset)=>preset.localId === selectedLocalId);
        const selectedZones = (0, $83bsI.addIgnoreLabel)(selected?.zones || []);
        const zonesHash = JSON.stringify(selectedZones);
        if (selected) {
            if (zonesHash === lastZonesHashRef.current) return;
            lastZonesHashRef.current = zonesHash;
            onZonesChangeRef.current(selectedZones);
        }
    }, [
        enabled,
        cameraId,
        selectedLocalId,
        autoPatrolFlexIgnoreZonesPresetsByCamera,
        onZonesChange
    ]);
    if (!enabled) return null;
    const selectablePresets = (0, $6JE7U.collapseNoIgnoreZonesPresetOptions)(presets, selectedLocalId);
    const hasSelectedPreset = selectablePresets.some((preset)=>preset.localId === selectedLocalId);
    const selectedValue = hasSelectedPreset ? selectedLocalId : "";
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
        fullWidth: true,
        size: "small",
        sx: {
            maxWidth: 360,
            mt: "4px",
            mb: "8px"
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $6gU8O.default), {
                id: `ap-flex-iz-preset-label-${cameraId}`,
                sx: {
                    fontFamily: "Mulish"
                },
                children: "Preset"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $2eEqG.default), {
                labelId: `ap-flex-iz-preset-label-${cameraId}`,
                label: "Preset",
                value: selectedValue,
                onChange: (event)=>{
                    const nextValue = String(event.target.value);
                    if (nextValue === $80c82a1c4eff2a21$var$AP_FLEX_CREATE_NEW_PRESET_OPTION) {
                        const newPreset = {
                            localId: `ap-custom-${cameraId}-${Date.now()}`,
                            cameraId: cameraId,
                            name: $80c82a1c4eff2a21$var$buildNextPresetName(cameraId, autoPatrolFlexIgnoreZonesPresetsByCamera),
                            zones: (0, $83bsI.addIgnoreLabel)(defaultZones),
                            persistedId: null,
                            source: "custom",
                            userNamed: false
                        };
                        setAutoPatrolFlexIgnoreZonesPresetsForCamera(cameraId, [
                            ...presets,
                            newPreset
                        ]);
                        setNewPresetDialog({
                            presetLocalId: newPreset.localId
                        });
                        return;
                    }
                    setRowSelectedLocalId(nextValue);
                },
                sx: {
                    fontFamily: "Mulish"
                },
                children: [
                    !hasSelectedPreset && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                        disabled: true,
                        value: "",
                        sx: {
                            fontFamily: "Mulish"
                        },
                        children: "Loading presets..."
                    }),
                    selectablePresets.map((preset)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                            value: preset.localId,
                            sx: {
                                fontFamily: "Mulish"
                            },
                            children: preset.name
                        }, preset.localId)),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                        value: $80c82a1c4eff2a21$var$AP_FLEX_CREATE_NEW_PRESET_OPTION,
                        sx: {
                            color: "#FF8400",
                            fontFamily: "Mulish",
                            fontWeight: 700
                        },
                        children: "+ CREATE NEW PRESET"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                open: newPresetDialog != null,
                onClose: ()=>setNewPresetDialog(null),
                fullWidth: true,
                maxWidth: "xl",
                PaperProps: {
                    sx: {
                        fontFamily: "Mulish",
                        maxHeight: "90vh"
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                        dividers: true,
                        sx: {
                            overflow: "auto"
                        },
                        children: newPresetDialog && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2OZNn.PresetEditorStep), {
                            cameraName: cameraName,
                            cameraContext: $80c82a1c4eff2a21$var$buildCameraContext({
                                id: cameraId,
                                camera_name: cameraName,
                                preview_url: previewUrl || "",
                                ignore_zones: (0, $83bsI.addIgnoreLabel)(defaultZones)
                            }),
                            preset: (autoPatrolFlexIgnoreZonesPresetsByCamera[cameraId] || []).find((preset)=>preset.localId === newPresetDialog.presetLocalId) || {
                                localId: newPresetDialog.presetLocalId,
                                cameraId: cameraId,
                                name: "",
                                zones: (0, $83bsI.addIgnoreLabel)(defaultZones),
                                persistedId: null,
                                source: "custom",
                                userNamed: false
                            },
                            onPresetNameChange: (value)=>{
                                const current = autoPatrolFlexIgnoreZonesPresetsByCamera[cameraId] || [];
                                setAutoPatrolFlexIgnoreZonesPresetsForCamera(cameraId, current.map((preset)=>preset.localId === newPresetDialog.presetLocalId ? {
                                        ...preset,
                                        name: value,
                                        userNamed: true
                                    } : preset));
                            },
                            onPresetZonesChange: (zones)=>{
                                const current = autoPatrolFlexIgnoreZonesPresetsByCamera[cameraId] || [];
                                setAutoPatrolFlexIgnoreZonesPresetsForCamera(cameraId, current.map((preset)=>preset.localId === newPresetDialog.presetLocalId ? {
                                        ...preset,
                                        zones: (0, $83bsI.addIgnoreLabel)(zones)
                                    } : preset));
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                        sx: {
                            px: 3,
                            pb: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    if (!newPresetDialog) return;
                                    const current = autoPatrolFlexIgnoreZonesPresetsByCamera[cameraId] || [];
                                    setAutoPatrolFlexIgnoreZonesPresetsForCamera(cameraId, current.filter((preset)=>preset.localId !== newPresetDialog.presetLocalId || preset.persistedId != null));
                                    setNewPresetDialog(null);
                                },
                                text: "Cancel",
                                disabled: false
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    if (!newPresetDialog) return;
                                    setRowSelectedLocalId(newPresetDialog.presetLocalId);
                                    setNewPresetDialog(null);
                                },
                                text: "Submit",
                                disabled: false
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $80c82a1c4eff2a21$export$3ba423ec6f9ad502 = ({ open: open, siteId: siteId, schedules: schedules, onClose: onClose, onSubmitted: onSubmitted })=>{
    const { autoPatrolFlexIgnoreZonesPresetsByCamera: autoPatrolFlexIgnoreZonesPresetsByCamera, autoPatrolFlexIgnoreZonesSelectedPresetByScheduleCamera: autoPatrolFlexIgnoreZonesSelectedPresetByScheduleCamera, setAutoPatrolFlexIgnoreZonesPresetsForCamera: setAutoPatrolFlexIgnoreZonesPresetsForCamera } = (0, $3FJ79.useSiteAboutStore)();
    const siteCameraMap = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>$80c82a1c4eff2a21$var$getSiteCameraMapFromStorage(), []);
    const cameras = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>{
        const byId = new Map();
        schedules.forEach((schedule)=>{
            $80c82a1c4eff2a21$var$toScheduleCameras(schedule, siteCameraMap).forEach((camera)=>{
                if (!byId.has(camera.id)) byId.set(camera.id, camera);
            });
        });
        return Array.from(byId.values());
    }, [
        schedules,
        siteCameraMap
    ]);
    const [liveCameraDataById, setLiveCameraDataById] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [choiceByCameraId, setChoiceByCameraId] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const inFlightCameraIdsRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(new Set());
    const enrichedCameras = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>cameras.map((camera)=>{
            const live = liveCameraDataById[camera.id];
            return {
                ...camera,
                preview_url: live?.preview_url || camera.preview_url || "",
                ignore_zones: (0, $83bsI.addIgnoreLabel)(live?.ignore_zones || camera.ignore_zones || [])
            };
        }), [
        cameras,
        liveCameraDataById
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!open) return;
        setError(null);
        setLoading(false);
        setChoiceByCameraId({});
    }, [
        open
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!open) return;
        const AxiosUI = (0, $195EM.createApi)("");
        const cameraIds = cameras.map((camera)=>camera.id);
        const toFetch = cameraIds.filter((cameraId)=>{
            const alreadyLoaded = liveCameraDataById[cameraId] != null;
            const inFlight = inFlightCameraIdsRef.current.has(cameraId);
            return !alreadyLoaded && !inFlight;
        });
        if (toFetch.length === 0) return;
        toFetch.forEach((cameraId)=>inFlightCameraIdsRef.current.add(cameraId));
        Promise.all(toFetch.map(async (cameraId)=>{
            const baseCamera = cameras.find((camera)=>camera.id === cameraId);
            try {
                const [statusResponse, zonesResponse] = await Promise.all([
                    AxiosUI.get(`/camera/${cameraId}/status/`, {
                        timeout: 8000
                    }),
                    AxiosUI.get(`/camera/${cameraId}/ignore_zones/`, {
                        timeout: 8000
                    })
                ]);
                const preview_url = statusResponse?.data?.preview_url || baseCamera?.preview_url || "";
                const ignore_zones = (0, $83bsI.addIgnoreLabel)($80c82a1c4eff2a21$var$parseListResponse(zonesResponse.data));
                setLiveCameraDataById((previous)=>({
                        ...previous,
                        [cameraId]: {
                            preview_url: preview_url,
                            ignore_zones: ignore_zones
                        }
                    }));
            } catch  {
                setLiveCameraDataById((previous)=>({
                        ...previous,
                        [cameraId]: {
                            preview_url: baseCamera?.preview_url || "",
                            ignore_zones: (0, $83bsI.addIgnoreLabel)(baseCamera?.ignore_zones || [])
                        }
                    }));
            } finally{
                inFlightCameraIdsRef.current.delete(cameraId);
            }
        }));
    }, [
        open,
        cameras,
        liveCameraDataById
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!open) return;
        enrichedCameras.forEach((camera)=>{
            $80c82a1c4eff2a21$var$ensureCameraPresets(camera, autoPatrolFlexIgnoreZonesPresetsByCamera, setAutoPatrolFlexIgnoreZonesPresetsForCamera);
        });
    }, [
        open,
        enrichedCameras,
        autoPatrolFlexIgnoreZonesPresetsByCamera,
        setAutoPatrolFlexIgnoreZonesPresetsForCamera
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!open || cameras.length === 0) return;
        setChoiceByCameraId((previous)=>{
            const next = {
                ...previous
            };
            cameras.forEach((camera)=>{
                if (next[camera.id]) return;
                const selectedFromAnySchedule = Object.entries(autoPatrolFlexIgnoreZonesSelectedPresetByScheduleCamera).find(([key, presetLocalId])=>key.endsWith(`:${camera.id}`) && !!presetLocalId)?.[1];
                const presets = (0, $6JE7U.collapseNoIgnoreZonesPresetOptions)(autoPatrolFlexIgnoreZonesPresetsByCamera[camera.id] || [], selectedFromAnySchedule || undefined);
                next[camera.id] = selectedFromAnySchedule || presets[0]?.localId || $80c82a1c4eff2a21$export$6f9ccc0121d8e3dd;
            });
            return next;
        });
    }, [
        open,
        cameras,
        autoPatrolFlexIgnoreZonesSelectedPresetByScheduleCamera,
        autoPatrolFlexIgnoreZonesPresetsByCamera
    ]);
    const selectionComplete = cameras.every((camera)=>Boolean(choiceByCameraId[camera.id]));
    const handleSubmit = async ()=>{
        if (!selectionComplete) {
            alert("Please make a choice for every camera before submitting.");
            return;
        }
        setLoading(true);
        setError(null);
        const AxiosUI = (0, $195EM.createApi)("");
        try {
            for (const camera of enrichedCameras){
                const selectedLocalId = choiceByCameraId[camera.id];
                if (selectedLocalId === $80c82a1c4eff2a21$export$6f9ccc0121d8e3dd) {
                    const payload = await (0, $dfiY5.buildNoIgnoreZonesPostPayload)(camera, (0, $83bsI.addIgnoreLabel)(camera.ignore_zones || []), AxiosUI);
                    await AxiosUI.post(`/camera/${camera.id}/ignore_zones/`, payload);
                    continue;
                }
                const selectedPreset = (autoPatrolFlexIgnoreZonesPresetsByCamera[camera.id] || []).find((preset)=>preset.localId === selectedLocalId);
                let zonesToApply = (0, $83bsI.addIgnoreLabel)(selectedPreset?.zones || []);
                if (zonesToApply.length === 0 && selectedPreset?.persistedId != null && Number.isFinite(Number(selectedPreset.persistedId))) try {
                    const presetZonesResponse = await AxiosUI.get(`preset-zone/?camera=${camera.id}&preset=${selectedPreset.persistedId}`);
                    zonesToApply = (0, $83bsI.addIgnoreLabel)($80c82a1c4eff2a21$var$toMappedPresetZones(selectedPreset?.name || `Preset ${selectedPreset?.persistedId}`, $80c82a1c4eff2a21$var$parseListResponse(presetZonesResponse.data), (0, $83bsI.addIgnoreLabel)(camera.ignore_zones || [])));
                } catch  {
                    zonesToApply = (0, $83bsI.addIgnoreLabel)(selectedPreset?.zones || []);
                }
                const payload = zonesToApply.map((zone)=>({
                        zone_type: zone.zone_type,
                        stream_id: zone.stream_id,
                        stream_name: (0, $dfiY5.ignoreZoneStreamNameForCameraApi)(zone),
                        metric_id: zone.metric_id,
                        label: zone.label,
                        label_display_name: zone.label_display_name,
                        line_color: zone.line_color,
                        coordinates: $80c82a1c4eff2a21$var$replaceNegativeWithZero((zone.coordinates || []).filter((arr)=>{
                            return Array.isArray(arr) && arr.length > 0;
                        }))
                    }));
                await AxiosUI.post(`/camera/${camera.id}/ignore_zones/`, payload);
            }
            for (const schedule of schedules)try {
                const response = await AxiosUI.get(`auto-patrol-schedule-preset/?auto_patrol_schedule=${schedule.id}`);
                const rows = $80c82a1c4eff2a21$var$parseListResponse(response.data);
                for (const row of rows){
                    const assignmentId = $80c82a1c4eff2a21$var$toNumericId(row?.id);
                    if (assignmentId != null) await AxiosUI.delete(`auto-patrol-schedule-preset/${assignmentId}/`);
                }
            } catch  {
            // Best effort cleanup; continue with remaining schedules.
            }
            await (0, $9hVqI.deletePersistedFlexPresetRecordsAfterIgnoreZonesSave)(AxiosUI, autoPatrolFlexIgnoreZonesPresetsByCamera, enrichedCameras.map((camera)=>({
                    id: camera.id
                })), async ()=>{});
            setLoading(false);
            onSubmitted();
            onClose();
        } catch (submitError) {
            setLoading(false);
            setError(submitError?.message || "Failed to complete AutoPatrol Flex Ignore Zones offboarding.");
        }
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                openState: loading,
                message: "Applying camera ignore zones selections...",
                stackAboveModal: true
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                open: open,
                onClose: (_, reason)=>{
                    if (!loading && reason !== "backdropClick") onClose();
                },
                fullWidth: true,
                maxWidth: "xl",
                PaperProps: {
                    sx: {
                        fontFamily: "Mulish",
                        minHeight: "80vh"
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: 700
                        },
                        children: "AutoPatrol Flex Ignore Zones Offboarding"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                        dividers: true,
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "font-mulish text-[14px] pb-[12px]",
                                children: "Choose what each camera should keep after turning Flex Ignore Zones off."
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-[12px] justify-items-start max-w-[1500px]",
                                children: enrichedCameras.map((camera)=>{
                                    const selectedLocalId = choiceByCameraId[camera.id] || $80c82a1c4eff2a21$export$6f9ccc0121d8e3dd;
                                    const availablePresets = (0, $6JE7U.collapseNoIgnoreZonesPresetOptions)(autoPatrolFlexIgnoreZonesPresetsByCamera[camera.id] || [], selectedLocalId);
                                    const selectedPreset = availablePresets.find((preset)=>preset.localId === selectedLocalId) || {
                                        localId: $80c82a1c4eff2a21$export$6f9ccc0121d8e3dd,
                                        cameraId: camera.id,
                                        name: "No Ignore Zones",
                                        zones: [],
                                        persistedId: null,
                                        source: "custom",
                                        userNamed: true
                                    };
                                    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $eVSHG.FlexIgnoreZonesCameraPresetCard), {
                                        scheduleId: siteId,
                                        camera: camera,
                                        preset: selectedPreset,
                                        cameraContext: $80c82a1c4eff2a21$var$buildCameraContext(camera),
                                        presetLineReplacement: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                                            size: "small",
                                            fullWidth: true,
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $6gU8O.default), {
                                                    id: `ap-offboarding-select-${camera.id}`,
                                                    children: "Preset"
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $2eEqG.default), {
                                                    labelId: `ap-offboarding-select-${camera.id}`,
                                                    value: selectedLocalId,
                                                    label: "Preset",
                                                    sx: {
                                                        fontFamily: "Mulish",
                                                        minWidth: 220
                                                    },
                                                    onChange: (event)=>{
                                                        setChoiceByCameraId((previous)=>({
                                                                ...previous,
                                                                [camera.id]: String(event.target.value)
                                                            }));
                                                    },
                                                    children: [
                                                        availablePresets.map((preset)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                                value: preset.localId,
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: preset.name
                                                            }, preset.localId)),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                            value: $80c82a1c4eff2a21$export$6f9ccc0121d8e3dd,
                                                            sx: {
                                                                fontFamily: "Mulish"
                                                            },
                                                            children: "No Ignore Zones"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, `ap-offboarding-${camera.id}`);
                                })
                            }),
                            error && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "font-mulish text-[13px] text-red-600 mt-3",
                                children: error
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: onClose,
                                text: "Cancel",
                                disabled: loading
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>void handleSubmit(),
                                text: "Submit",
                                disabled: !selectionComplete || loading
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("eVSHG", function(module, exports) {

$parcel$export(module.exports, "FlexIgnoreZonesCameraPresetCard", () => $f67097f4e67b0a16$export$83185849dfb37d06);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $QUu0n = parcelRequire("QUu0n");
const $f67097f4e67b0a16$export$83185849dfb37d06 = ({ scheduleId: scheduleId, camera: camera, preset: preset, cameraContext: cameraContext, maxPreviewWidth: maxPreviewWidth = 236, presetLineReplacement: presetLineReplacement, onPreviewImageError: onPreviewImageError })=>{
    const previewUrl = cameraContext?.preview?.previewUrl || camera.preview_url || "";
    const dimensions = cameraContext?.preview?.adjustedDimensions || {
        x: 720,
        y: 405
    };
    const scale = Math.min(1, maxPreviewWidth / dimensions.x);
    const displayWidth = Math.round(dimensions.x * scale);
    const displayHeight = Math.round(dimensions.y * scale);
    const zoneStroke = displayWidth < 300 ? 2 : 3;
    const [previewLoadFailed, setPreviewLoadFailed] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setPreviewLoadFailed(false);
    }, [
        previewUrl
    ]);
    const displayedZones = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>(preset.zones || []).filter((zone)=>(zone.coordinates?.length ?? 0) > 0), [
        preset.zones
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "w-fit max-w-full border border-gray-200 bg-gray-100 rounded-[6px] p-[8px]",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "font-mulish text-[13px] font-black leading-tight",
                children: camera.camera_name
            }),
            presetLineReplacement != null ? /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "w-full min-w-0 pt-[12px] pb-[14px]",
                children: presetLineReplacement
            }) : /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                className: "font-mulish text-[12px] pb-[6px] leading-snug",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                        className: "font-black",
                        children: "Preset:"
                    }),
                    " ",
                    preset.name
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex items-start gap-[8px] flex-wrap w-fit max-w-full",
                children: [
                    previewUrl && !previewLoadFailed ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "relative inline-block border border-gray-200 rounded-[4px] overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                                src: previewUrl,
                                alt: camera.camera_name,
                                onError: ()=>{
                                    setPreviewLoadFailed(true);
                                    onPreviewImageError?.();
                                },
                                style: {
                                    width: `${displayWidth}px`,
                                    height: `${displayHeight}px`
                                }
                            }),
                            displayedZones.map((zone, zIdx)=>/*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "absolute top-0 left-0",
                                    children: zone.coordinates.map((coordinates, index)=>/*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                                            style: {
                                                width: `${displayWidth}px`,
                                                height: `${displayHeight}px`
                                            },
                                            className: "absolute top-0 left-0",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("polygon", {
                                                points: (0, $QUu0n.pointsCreator)(coordinates, displayHeight, displayWidth),
                                                stroke: zone.line_color,
                                                strokeWidth: zoneStroke,
                                                fill: zone.line_color,
                                                fillOpacity: "50%"
                                            })
                                        }, `${zone.label}-${index}`))
                                }, `${scheduleId}-${camera.id}-${zIdx}-${zone.metric_id}-${zone.preset_zone_id ?? zone.label}`))
                        ]
                    }) : /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-mulish text-[13px] text-gray-600",
                        children: "Camera preview unavailable."
                    }),
                    displayedZones.length > 0 && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "shrink-0 w-max max-w-[min(132px,100%)]",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "font-mulish text-[11px] font-black pb-[4px]",
                                children: "Preset zones"
                            }),
                            displayedZones.map((zone, zIdx)=>/*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "flex items-center gap-[5px] pb-[3px]",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                            style: {
                                                background: zone.line_color,
                                                width: "4px",
                                                height: "14px",
                                                display: "inline-block"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "font-mulish text-[11px] leading-[13px]",
                                            children: zone.label_display_name
                                        })
                                    ]
                                }, `${scheduleId}-${camera.id}-legend-${zIdx}-${zone.metric_id}-${zone.preset_zone_id ?? zone.label}`))
                        ]
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("87t0c", function(module, exports) {

$parcel$export(module.exports, "FlexIgnoreZonesEditPresetCard", () => $9929a988054b9018$export$a8619d3a16f7406d);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $7UDCh = parcelRequire("7UDCh");
var $6gU8O = parcelRequire("6gU8O");
var $cxknk = parcelRequire("cxknk");
var $2eEqG = parcelRequire("2eEqG");

var $eVSHG = parcelRequire("eVSHG");

var $9s9JO = parcelRequire("9s9JO");
const $9929a988054b9018$export$a8619d3a16f7406d = ({ scheduleId: scheduleId, camera: camera, preset: preset, cameraContext: cameraContext, selectablePresets: selectablePresets, selectedPresetLocalId: selectedPresetLocalId, onSelectPreset: onSelectPreset, onCreateNewPreset: onCreateNewPreset, onPreviewImageError: onPreviewImageError, showNoIgnoreZonesOption: showNoIgnoreZonesOption = true, showDefaultCameraConfigOption: showDefaultCameraConfigOption = false })=>{
    const labelId = `flex-iz-edit-preset-${scheduleId}-${camera.id}`;
    const hasNoIgnoreZonesOption = selectablePresets.some((preset)=>preset.localId === (0, $9s9JO.FLEX_IZ_NO_IGNORE_ZONES_OPTION) || (preset.name || "").trim().toLowerCase() === "no ignore zones");
    const presetDropdown = /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
        fullWidth: true,
        size: "small",
        sx: {
            fontFamily: "Mulish"
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $6gU8O.default), {
                id: labelId,
                sx: {
                    fontFamily: "Mulish"
                },
                children: "Ignore Zones Preset"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $2eEqG.default), {
                labelId: labelId,
                label: "Ignore Zones Preset",
                value: selectedPresetLocalId,
                onChange: (event)=>{
                    const nextValue = event.target.value;
                    if (nextValue === (0, $9s9JO.FLEX_IZ_CREATE_NEW_PRESET_OPTION)) {
                        onCreateNewPreset();
                        return;
                    }
                    onSelectPreset(nextValue);
                },
                MenuProps: {
                    PaperProps: {
                        sx: {
                            bgcolor: "#fff",
                            fontFamily: "Mulish"
                        }
                    }
                },
                sx: {
                    fontFamily: "Mulish",
                    bgcolor: "#fff",
                    borderRadius: "6px",
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(0, 0, 0, 0.18)"
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(0, 0, 0, 0.35)"
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#001943",
                        borderWidth: "1px"
                    },
                    "& .MuiSelect-select": {
                        py: 1.25
                    }
                },
                children: [
                    showDefaultCameraConfigOption && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                        value: (0, $9s9JO.FLEX_IZ_DEFAULT_CAMERA_CONFIG_OPTION),
                        children: (0, $9s9JO.FLEX_IZ_DEFAULT_CAMERA_CONFIG_LABEL)
                    }),
                    selectablePresets.map((p)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                            value: p.localId,
                            children: p.name
                        }, p.localId)),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                        value: (0, $9s9JO.FLEX_IZ_CREATE_NEW_PRESET_OPTION),
                        sx: {
                            color: "#FF8400",
                            fontFamily: "Mulish",
                            fontWeight: 700
                        },
                        children: "+ CREATE NEW PRESET"
                    }),
                    showNoIgnoreZonesOption && !hasNoIgnoreZonesOption && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                        value: (0, $9s9JO.FLEX_IZ_NO_IGNORE_ZONES_OPTION),
                        children: "No Ignore Zones"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $eVSHG.FlexIgnoreZonesCameraPresetCard), {
        scheduleId: scheduleId,
        camera: camera,
        preset: preset,
        cameraContext: cameraContext,
        presetLineReplacement: presetDropdown,
        onPreviewImageError: onPreviewImageError
    });
};

});

parcelRegister("2RrZf", function(module, exports) {

$parcel$export(module.exports, "SummaryStep", () => $79833f983520c6b4$export$a9efd057ccbc1d85);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eVSHG = parcelRequire("eVSHG");

var $1pR5m = parcelRequire("1pR5m");
const $79833f983520c6b4$export$a9efd057ccbc1d85 = ({ assignments: assignments, conflicts: conflicts = [] })=>{
    const grouped = assignments.reduce((acc, assignment)=>{
        const scheduleId = assignment.schedule.id;
        if (!acc[scheduleId]) acc[scheduleId] = {
            schedule: assignment.schedule,
            rows: []
        };
        acc[scheduleId].rows.push(assignment);
        return acc;
    }, {});
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "pr-[8px]",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "font-mulish text-[20px] font-black pb-[10px]",
                children: "Flex Ignore Zones Summary"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1pR5m.FlexPresetConflictsNotice), {
                conflicts: conflicts
            }),
            Object.values(grouped).map((group)=>/*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "border border-gray-300 bg-gray-200 rounded-[6px] p-[12px] mb-[32px]",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "font-mulish text-[17px] font-black pb-[10px]",
                            children: group.schedule.display_name
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-[12px] justify-items-start",
                            children: group.rows.map((row)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eVSHG.FlexIgnoreZonesCameraPresetCard), {
                                    scheduleId: row.schedule.id,
                                    camera: row.camera,
                                    preset: row.preset,
                                    cameraContext: row.cameraContext
                                }, `${row.schedule.id}-${row.camera.id}`))
                        })
                    ]
                }, group.schedule.id))
        ]
    });
};

});
parcelRegister("1pR5m", function(module, exports) {

$parcel$export(module.exports, "FlexPresetConflictsNotice", () => $18df6c8cde01be4f$export$d435a1b2e6b235df);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $5P5Ui = parcelRequire("5P5Ui");
const $18df6c8cde01be4f$export$d435a1b2e6b235df = ({ conflicts: conflicts })=>{
    if (conflicts.length === 0) return null;
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        role: "alert",
        "data-testid": "flex-preset-conflicts",
        className: "border border-red-300 bg-red-50 rounded-[6px] p-[12px] mb-[16px] max-w-[1500px]",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "font-mulish text-[15px] font-black text-red-700 pb-[6px]",
                children: "A camera can only run one preset at a time on this site"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("ul", {
                className: "list-disc pl-[20px] font-mulish text-[14px] text-red-700",
                children: conflicts.map((conflict)=>/*#__PURE__*/ (0, $k4ank.jsx)("li", {
                        children: (0, $5P5Ui.presetConflictMessage)(conflict)
                    }, `${conflict.cameraId}-${conflict.scheduleId}-${conflict.otherScheduleId}`))
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "font-mulish text-[14px] text-red-700 pt-[6px]",
                children: (0, $5P5Ui.PRESET_CONFLICT_FIX_HINT)
            })
        ]
    });
};

});
parcelRegister("5P5Ui", function(module, exports) {

$parcel$export(module.exports, "isFleetSite", () => $41f5c90aa593b08f$export$134afbd9f7bcf494);
$parcel$export(module.exports, "findPresetConflicts", () => $41f5c90aa593b08f$export$a251e8ffd0faa207);
$parcel$export(module.exports, "presetConflictMessage", () => $41f5c90aa593b08f$export$def6a799db399a70);
$parcel$export(module.exports, "PRESET_CONFLICT_FIX_HINT", () => $41f5c90aa593b08f$export$b1e4f175bb7aed);
$parcel$export(module.exports, "presetConflictsAlertText", () => $41f5c90aa593b08f$export$4206b638303e38f4);
$parcel$export(module.exports, "presetConflictMessagesFromError", () => $41f5c90aa593b08f$export$db1e0cfad5541812);

var $9s9JO = parcelRequire("9s9JO");
/**
 * ENG-1927: client-side twin of actuate_admin's ENG-1914 guard
 * (`inframap/scheduler/flex_schedule/preset_conflicts.py`).
 *
 * On a fleet site one worker holds one zone config per camera, so a camera
 * cannot run two different presets at the same moment. Admin refuses a
 * `camera-schedule-preset` write that gives a camera a non-null preset on one
 * flex schedule while another enabled schedule of the site gives it a
 * different non-null preset in overlapping hours. camera-ui writes those rows
 * one at a time, so a refusal on row N would leave rows 1..N-1 saved: catch
 * it before the first write.
 *
 * Time semantics copy admin's `schedule_intervals`: every enabled,
 * non-override row becomes week-minute intervals per selected weekday;
 * `end <= start` runs overnight into the next day (Saturday wraps to Sunday);
 * `always_on` is the whole day; a row without a start time is a no-op.
 * "Default" (no preset) never conflicts; the same preset never conflicts.
 * Legacy sites run each schedule in its own deployment and are never checked.
 */ const $41f5c90aa593b08f$var$WEEK_MINUTES = 10080;
const $41f5c90aa593b08f$export$70e3f556de513e62 = "watchman_fleet";
const $41f5c90aa593b08f$export$134afbd9f7bcf494 = (site)=>site?.is_fleet_site === true || site?.deployment_target === $41f5c90aa593b08f$export$70e3f556de513e62;
const $41f5c90aa593b08f$var$parseMinutes = (time)=>{
    if (!time) return null;
    const match = /^\s*(\d{1,2}):(\d{2})/.exec(time);
    if (!match) return null;
    return Number(match[1]) * 60 + Number(match[2]);
};
const $41f5c90aa593b08f$var$weekdays = (value)=>{
    if (!value) return [];
    const items = typeof value === "string" ? value.split(",") : value;
    return items.map((day)=>String(day).trim()).filter((day)=>day !== "").map(Number).filter((day)=>Number.isInteger(day) && day >= 0 && day <= 6);
};
const $41f5c90aa593b08f$export$a71210bf9ddb2f3f = (row)=>{
    const days = $41f5c90aa593b08f$var$weekdays(row.day_of_week);
    if (row.always_on) return days.map((d)=>[
            d * 1440,
            d * 1440 + 1440
        ]);
    const start = $41f5c90aa593b08f$var$parseMinutes(row.start_time);
    if (start == null) return [];
    const parsedEnd = $41f5c90aa593b08f$var$parseMinutes(row.end_time);
    let end = parsedEnd == null ? 1440 : parsedEnd;
    if (end <= start) end += 1440; // overnight: spills into the next weekday
    const out = [];
    days.forEach((d)=>{
        const a = d * 1440 + start;
        const b = d * 1440 + end;
        if (b <= $41f5c90aa593b08f$var$WEEK_MINUTES) out.push([
            a,
            b
        ]);
        else {
            // Saturday night wraps into Sunday
            out.push([
                a,
                $41f5c90aa593b08f$var$WEEK_MINUTES
            ]);
            out.push([
                0,
                b - $41f5c90aa593b08f$var$WEEK_MINUTES
            ]);
        }
    });
    return out;
};
const $41f5c90aa593b08f$export$73681b691b3bb984 = (schedule)=>(schedule.schedule ?? []).filter((row)=>row && row.enabled !== false && row.is_override !== true).flatMap($41f5c90aa593b08f$export$a71210bf9ddb2f3f);
const $41f5c90aa593b08f$export$8699442a7917afc0 = (a, b)=>{
    let total = 0;
    a.forEach(([a1, b1])=>{
        b.forEach(([a2, b2])=>{
            const lo = Math.max(a1, a2);
            const hi = Math.min(b1, b2);
            if (hi > lo) total += hi - lo;
        });
    });
    return total;
};
const $41f5c90aa593b08f$var$serverPresetId = (localId)=>{
    const match = /^server-(\d+)$/.exec(localId);
    return match ? Number(match[1]) : null;
};
/**
 * What the selection will be saved as: `null` for Default (a `preset: null`
 * row), otherwise an identity key and a display name.
 *
 * - `"persisted"` (Schedules edit): rows are written with the preset's
 *   `persistedId`, so two local ids of the same saved preset are the same.
 * - `"local"` (onboarding submit): every distinct `(camera, localId)` becomes
 *   its own new preset, so distinct local ids are different presets.
 */ const $41f5c90aa593b08f$var$resolveSelection = (cameraId, localId, presetsByCamera, presetNamesByCamera, identity)=>{
    if (!localId || localId === (0, $9s9JO.FLEX_IZ_DEFAULT_CAMERA_CONFIG_OPTION)) return null;
    const preset = (presetsByCamera[cameraId] || []).find((candidate)=>candidate.localId === localId);
    const persistedId = preset?.persistedId ?? $41f5c90aa593b08f$var$serverPresetId(localId);
    const name = preset?.name?.trim() || (persistedId != null ? presetNamesByCamera[cameraId]?.[persistedId] : undefined) || (localId === (0, $9s9JO.FLEX_IZ_NO_IGNORE_ZONES_OPTION) ? "No Ignore Zones" : persistedId != null ? `Preset #${persistedId}` : "Unsaved preset");
    const key = identity === "persisted" && persistedId != null ? `id:${persistedId}` : `local:${localId}`;
    return {
        key: key,
        name: name
    };
};
const $41f5c90aa593b08f$export$a251e8ffd0faa207 = ({ schedules: schedules, cameras: cameras, selectedPresetByScheduleCamera: selectedPresetByScheduleCamera, presetsByCamera: presetsByCamera, presetNamesByCamera: presetNamesByCamera = {}, identity: identity = "persisted" })=>{
    const usable = (schedules ?? []).filter((schedule)=>schedule && schedule.enabled !== false).map((schedule, index)=>({
            id: Number(schedule.id),
            name: schedule.display_name || `Schedule ${index + 1}`,
            intervals: $41f5c90aa593b08f$export$73681b691b3bb984(schedule)
        })).filter((schedule)=>Number.isFinite(schedule.id));
    const conflicts = [];
    cameras.forEach((camera)=>{
        for(let i = 0; i < usable.length; i++)for(let j = i + 1; j < usable.length; j++){
            const a = usable[i];
            const b = usable[j];
            const presetA = $41f5c90aa593b08f$var$resolveSelection(camera.id, selectedPresetByScheduleCamera[`${a.id}:${camera.id}`], presetsByCamera, presetNamesByCamera, identity);
            const presetB = $41f5c90aa593b08f$var$resolveSelection(camera.id, selectedPresetByScheduleCamera[`${b.id}:${camera.id}`], presetsByCamera, presetNamesByCamera, identity);
            if (!presetA || !presetB || presetA.key === presetB.key) continue;
            const minutes = $41f5c90aa593b08f$export$8699442a7917afc0(a.intervals, b.intervals);
            if (minutes > 0) conflicts.push({
                cameraId: camera.id,
                cameraName: camera.camera_name || `Camera ${camera.id}`,
                scheduleId: a.id,
                scheduleName: a.name,
                presetName: presetA.name,
                otherScheduleId: b.id,
                otherScheduleName: b.name,
                otherPresetName: presetB.name,
                overlapMinutes: minutes
            });
        }
    });
    return conflicts;
};
const $41f5c90aa593b08f$var$formatOverlap = (minutes)=>{
    const hours = Math.floor(minutes / 60);
    const rest = minutes % 60;
    if (hours === 0) return `${rest} min`;
    return rest === 0 ? `${hours} h` : `${hours} h ${rest} min`;
};
const $41f5c90aa593b08f$export$def6a799db399a70 = (conflict)=>`Camera "${conflict.cameraName}" would run preset "${conflict.presetName}" on ` + `"${conflict.scheduleName}" and preset "${conflict.otherPresetName}" on ` + `"${conflict.otherScheduleName}" at the same time ` + `(${$41f5c90aa593b08f$var$formatOverlap(conflict.overlapMinutes)}/week overlap). On a fleet site a ` + `camera can only run one preset at a time.`;
const $41f5c90aa593b08f$export$b1e4f175bb7aed = "Pick the same preset (or Default) on both schedules for that camera, or change the schedule times so they don't overlap.";
const $41f5c90aa593b08f$export$4206b638303e38f4 = (conflicts)=>[
        ...conflicts.map($41f5c90aa593b08f$export$def6a799db399a70),
        "",
        $41f5c90aa593b08f$export$b1e4f175bb7aed
    ].join("\n");
const $41f5c90aa593b08f$export$db1e0cfad5541812 = (error)=>{
    const response = error?.response;
    if (response?.status !== 400) return null;
    const cameras = response.data?.cameras;
    const list = Array.isArray(cameras) ? cameras : cameras != null ? [
        cameras
    ] : [];
    const messages = list.map((item)=>String(item)).filter((message)=>message.includes("one preset at a time"));
    return messages.length > 0 ? messages : null;
};

});



parcelRegister("7ulPk", function(module, exports) {

$parcel$export(module.exports, "buildPresetZonePayload", () => $e16670577fefdf7b$export$aec0df26d48720a3);
$parcel$export(module.exports, "buildPresetZonePatchBodyFromZones", () => $e16670577fefdf7b$export$695cb5297b330ed6);
const $e16670577fefdf7b$var$normalizeLabelName = (value)=>value.trim().toLowerCase().replace(/^ignore[_\s]+/, "").replace(/^ignore\s+/, "").replace(/\s+/g, " ");
const $e16670577fefdf7b$var$isIgnoreAllZone = (zone)=>{
    const normalizedLabel = $e16670577fefdf7b$var$normalizeLabelName(zone.label || "");
    const normalizedDisplay = $e16670577fefdf7b$var$normalizeLabelName(zone.label_display_name || "");
    return zone.zone_type === 0 || normalizedLabel === "motion" || normalizedLabel === "ignore motion" || normalizedLabel === "ignore all" || normalizedDisplay === "motion" || normalizedDisplay === "ignore motion" || normalizedDisplay === "ignore all";
};
const $e16670577fefdf7b$var$clampCoordinate = (value)=>{
    if (typeof value !== "number" || !Number.isFinite(value)) return null;
    return value < 0 ? 0 : value;
};
/**
 * Accepts either coordinates as a single polygon (number[][]) or a list of polygons (number[][][]).
 */ const $e16670577fefdf7b$var$sanitizeCoordinates = (coordinates)=>{
    if (!Array.isArray(coordinates)) return [];
    const first = coordinates[0];
    if (!Array.isArray(first)) return [];
    const looksLikePointPair = first.length >= 2 && typeof first[0] === "number" && typeof first[1] === "number";
    const polygonGroups = looksLikePointPair ? [
        coordinates
    ] : coordinates;
    const cleaned = polygonGroups.map((polygon)=>{
        if (!Array.isArray(polygon)) return [];
        return polygon.map((point)=>{
            if (!Array.isArray(point) || point.length < 2) return null;
            const x = $e16670577fefdf7b$var$clampCoordinate(point[0]);
            const y = $e16670577fefdf7b$var$clampCoordinate(point[1]);
            if (x === null || y === null) return null;
            return [
                x,
                y
            ];
        }).filter((point)=>Array.isArray(point));
    }).filter((polygon)=>polygon.length > 0);
    return cleaned;
};
const $e16670577fefdf7b$var$candidateNamesForZone = (zone)=>{
    const candidates = [
        zone.label,
        zone.label_display_name
    ].filter((value)=>typeof value === "string" && value.length > 0).map($e16670577fefdf7b$var$normalizeLabelName);
    return Array.from(new Set(candidates));
};
const $e16670577fefdf7b$var$resolveLabelForZone = (cameraId, zone, rows)=>{
    const forCamera = rows.filter((row)=>Number(row.camera?.id) === cameraId);
    const zoneCandidates = $e16670577fefdf7b$var$candidateNamesForZone(zone);
    const matchedByName = forCamera.find((row)=>zoneCandidates.includes($e16670577fefdf7b$var$normalizeLabelName(row.label_name || "")));
    if (matchedByName) return {
        labelId: Number(matchedByName.label_id),
        labelName: matchedByName.label_name
    };
    if (typeof zone.metric_id === "number") {
        const matchedByMetric = forCamera.find((row)=>Number(row.metric_id) === zone.metric_id);
        if (matchedByMetric) return {
            labelId: Number(matchedByMetric.label_id),
            labelName: matchedByMetric.label_name
        };
        // Preset / ignore-zone payloads sometimes store `label_id` in `metric_id`
        // while metric/simplified uses a distinct API `metric_id` per row.
        const matchedByLabelId = forCamera.find((row)=>Number(row.label_id) === zone.metric_id);
        if (matchedByLabelId) return {
            labelId: Number(matchedByLabelId.label_id),
            labelName: matchedByLabelId.label_name
        };
    }
    throw new Error(`Missing label mapping for camera ${cameraId} zone "${zone.label_display_name || zone.label}".`);
};
const $e16670577fefdf7b$export$aec0df26d48720a3 = ({ cameraId: cameraId, presetId: presetId, presetName: presetName, zones: zones, metricRows: metricRows })=>{
    const forCamera = metricRows.filter((row)=>Number(row.camera?.id) === cameraId);
    const activeLabels = forCamera.filter((row)=>row.active !== false);
    const labelsById = new Map(activeLabels.map((row)=>[
            Number(row.label_id),
            {
                label: Number(row.label_id),
                name: row.label_name,
                coordinates: []
            }
        ]));
    const ignoreAllPolygons = zones.filter((zone)=>$e16670577fefdf7b$var$isIgnoreAllZone(zone)).flatMap((zone)=>$e16670577fefdf7b$var$sanitizeCoordinates(zone.coordinates));
    zones.filter((zone)=>!$e16670577fefdf7b$var$isIgnoreAllZone(zone)).forEach((zone)=>{
        const { labelId: labelId, labelName: labelName } = $e16670577fefdf7b$var$resolveLabelForZone(cameraId, zone, metricRows);
        const coordinates = $e16670577fefdf7b$var$sanitizeCoordinates(zone.coordinates);
        const existing = labelsById.get(labelId);
        if (existing) {
            labelsById.set(labelId, {
                ...existing,
                coordinates: [
                    ...existing.coordinates,
                    ...coordinates
                ]
            });
            return;
        }
        labelsById.set(labelId, {
            label: labelId,
            name: labelName,
            coordinates: coordinates
        });
    });
    if (ignoreAllPolygons.length > 0) labelsById.forEach((entry, labelId)=>{
        labelsById.set(labelId, {
            ...entry,
            coordinates: [
                ...ignoreAllPolygons,
                ...entry.coordinates
            ]
        });
    });
    return {
        camera: cameraId,
        preset: presetId,
        name: presetName,
        labels: Array.from(labelsById.values())
    };
};
const $e16670577fefdf7b$export$695cb5297b330ed6 = ({ cameraId: cameraId, presetId: presetId, presetApiName: presetApiName, zones: zones, metricRows: metricRows })=>{
    const full = $e16670577fefdf7b$export$aec0df26d48720a3({
        cameraId: cameraId,
        presetId: presetId,
        presetName: presetApiName,
        zones: zones,
        metricRows: metricRows
    });
    return {
        name: full.name,
        labels: full.labels
    };
};

});

parcelRegister("9hVqI", function(module, exports) {

$parcel$export(module.exports, "deletePersistedFlexPresetRecordsAfterIgnoreZonesSave", () => $44467066ad54192f$export$ea372c679cf31397);
const $44467066ad54192f$var$parsePresetZoneList = (data)=>{
    if (data && typeof data === "object" && Array.isArray(data.results)) return data.results;
    if (Array.isArray(data)) return data;
    return [];
};
const $44467066ad54192f$export$ff65247a60eefb6f = (presetsByCamera, cameraIds)=>{
    const ids = new Set();
    cameraIds.forEach((cameraId)=>{
        (presetsByCamera[cameraId] || []).forEach((preset)=>{
            if (preset.persistedId != null && Number.isFinite(Number(preset.persistedId))) ids.add(Number(preset.persistedId));
        });
    });
    return Array.from(ids);
};
const $44467066ad54192f$export$5e133224203369a = (presetsByCamera, cameraIds)=>{
    const ids = new Set();
    cameraIds.forEach((cameraId)=>{
        (presetsByCamera[cameraId] || []).forEach((preset)=>{
            if (preset.persistedId == null) return;
            (preset.zones || []).forEach((zone)=>{
                if (typeof zone.preset_zone_id === "number" && Number.isFinite(zone.preset_zone_id)) ids.add(zone.preset_zone_id);
            });
        });
    });
    return Array.from(ids);
};
async function $44467066ad54192f$export$ea372c679cf31397(AxiosUI, presetsByCamera, cameras, loadCameraContext) {
    const cameraIds = cameras.map((c)=>c.id);
    let presetZoneIds = $44467066ad54192f$export$5e133224203369a(presetsByCamera, cameraIds);
    const presetIds = $44467066ad54192f$export$ff65247a60eefb6f(presetsByCamera, cameraIds);
    if (presetZoneIds.length === 0 && presetIds.length > 0) {
        const fetched = new Set();
        for (const camera of cameras){
            const camPresets = presetsByCamera[camera.id] || [];
            for (const preset of camPresets){
                if (preset.persistedId == null) continue;
                const pzRes = await AxiosUI.get(`preset-zone/?camera=${camera.id}&preset=${preset.persistedId}`);
                $44467066ad54192f$var$parsePresetZoneList(pzRes.data).forEach((row)=>{
                    if (row.id != null && Number.isFinite(Number(row.id))) fetched.add(Number(row.id));
                });
            }
        }
        presetZoneIds = Array.from(fetched);
    }
    for (const zoneId of presetZoneIds)await AxiosUI.delete(`preset-zone/${zoneId}/`);
    for (const presetId of presetIds)await AxiosUI.delete(`preset/${presetId}/`);
    await Promise.all(cameras.map((camera)=>loadCameraContext(camera.id, true)));
}

});

parcelRegister("dfiY5", function(module, exports) {

$parcel$export(module.exports, "ignoreZoneStreamNameForCameraApi", () => $f0c7aa8fbc37b31f$export$d683bf22f4114429);
$parcel$export(module.exports, "buildNoIgnoreZonesPostPayload", () => $f0c7aa8fbc37b31f$export$f52036e5a1b0787e);

var $83bsI = parcelRequire("83bsI");
const $f0c7aa8fbc37b31f$export$d683bf22f4114429 = (zone)=>{
    const raw = zone.stream_name;
    if (typeof raw === "string" && raw.trim() !== "") return raw;
    return `stream_${zone.stream_id}`;
};
const $f0c7aa8fbc37b31f$export$1e6311e32a6981af = (zones)=>zones.map((zone)=>({
            ...zone,
            coordinates: [],
            stream_name: $f0c7aa8fbc37b31f$export$d683bf22f4114429(zone)
        }));
async function $f0c7aa8fbc37b31f$export$f52036e5a1b0787e(camera, defaultZonesFromContext, axiosInstance) {
    let template = [];
    if (defaultZonesFromContext && defaultZonesFromContext.length > 0) template = defaultZonesFromContext;
    else template = (0, $83bsI.addIgnoreLabel)(camera.ignore_zones || []);
    if (template.length === 0) {
        const response = await axiosInstance.get(`/camera/${camera.id}/ignore_zones/`);
        template = (0, $83bsI.addIgnoreLabel)(response.data || []);
    }
    return $f0c7aa8fbc37b31f$export$1e6311e32a6981af(template);
}

});


parcelRegister("enwJW", function(module, exports) {

$parcel$export(module.exports, "ProductBulkUpdateDialog", () => $5f6ebcea024ec989$export$9ed45b033ad7de4);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kbChx = parcelRequire("kbChx");
var $kUcVg = parcelRequire("kUcVg");
var $887xF = parcelRequire("887xF");
var $1TOOV = parcelRequire("1TOOV");
var $ce8iU = parcelRequire("ce8iU");
var $4reBM = parcelRequire("4reBM");
var $k8Qy8 = parcelRequire("k8Qy8");
var $gXvgZ = parcelRequire("gXvgZ");
var $aVDw9 = parcelRequire("aVDw9");
var $3Nm8Z = parcelRequire("3Nm8Z");
var $ha39s = parcelRequire("ha39s");
var $4o6Cs = parcelRequire("4o6Cs");

var $8E01L = parcelRequire("8E01L");

var $3QMQN = parcelRequire("3QMQN");

var $gVgDF = parcelRequire("gVgDF");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $dHtmK = parcelRequire("dHtmK");

var $8jTCz = parcelRequire("8jTCz");

var $3FJ79 = parcelRequire("3FJ79");

var $kKBBF = parcelRequire("kKBBF");
const $5f6ebcea024ec989$var$EDIT_MODE_PRODUCT_GROUPS = [
    {
        color: "#FF8400",
        children: [
            "Intruder",
            "Vehicle (grouped car, truck, bus)",
            "Bike (grouped bicycle, motorcycle)"
        ]
    },
    {
        color: "#2196F3",
        children: [
            "Crowd"
        ]
    },
    {
        color: "#F44336",
        children: [
            "Fire",
            "Smoke"
        ]
    },
    {
        color: "#03A9F4",
        children: [
            "Non-UPS"
        ]
    },
    {
        color: "#4CAF50",
        children: [
            "Amazon",
            "DHL",
            "Fedex",
            "School Bus",
            "UPS",
            "USPS",
            "Fire Truck"
        ]
    }
];
const $5f6ebcea024ec989$var$ORDERED_EDIT_MODE_PRODUCTS = $5f6ebcea024ec989$var$EDIT_MODE_PRODUCT_GROUPS.flatMap((group)=>group.children);
const $5f6ebcea024ec989$var$AUTOPATROL_UNAVAILABLE_PRODUCT_LABEL_SET = new Set((0, $kKBBF.AUTOPATROL_UNAVAILABLE_BULK_PRODUCT_LABELS));
const $5f6ebcea024ec989$var$isAutopatrolUnavailableProduct = (productName)=>$5f6ebcea024ec989$var$AUTOPATROL_UNAVAILABLE_PRODUCT_LABEL_SET.has(productName);
const $5f6ebcea024ec989$var$EDIT_MODE_COLOR_BY_PRODUCT = $5f6ebcea024ec989$var$EDIT_MODE_PRODUCT_GROUPS.reduce((accumulator, group)=>{
    group.children.forEach((productName)=>{
        accumulator[productName] = group.color;
    });
    return accumulator;
}, {});
const $5f6ebcea024ec989$var$toCheckboxKey = (value)=>value.toLowerCase().replace(/[^a-z0-9]+/g, "_");
const $5f6ebcea024ec989$var$getProductDisplayLabel = (productName)=>{
    if (productName === "Vehicle (grouped car, truck, bus)") return "Vehicle";
    if (productName === "Bike (grouped bicycle, motorcycle)") return "Bike";
    return productName;
};
const $5f6ebcea024ec989$var$createInitialDraft = (schedules, autoPatrolCameraProducts)=>{
    const draft = {};
    schedules.forEach((schedule)=>{
        const products = autoPatrolCameraProducts[schedule.id] || [];
        draft[schedule.id] = products.reduce((accumulator, product)=>{
            const displayName = product?.metric_label?.display_name;
            if (!displayName || $5f6ebcea024ec989$var$isAutopatrolUnavailableProduct(displayName)) return accumulator;
            accumulator[displayName] = Boolean(product.enabled);
            return accumulator;
        }, {});
    });
    return draft;
};
const $5f6ebcea024ec989$export$9ed45b033ad7de4 = ({ open: open, schedules: schedules, autoPatrolCameraProducts: autoPatrolCameraProducts, onClose: onClose })=>{
    const navigate = (0, $3T949.useNavigate)();
    const { updateScheduleProducts: updateScheduleProducts, setAutoPatrolCameraProducts: setAutoPatrolCameraProducts, prefetchBulkDialogActiveCameraProducts: prefetchBulkDialogActiveCameraProducts } = (0, $3FJ79.useSiteAboutStore)();
    const customerId = $8T3gX.useMemo(()=>{
        const scheduleCustomerId = schedules[0]?.customer?.id;
        if (scheduleCustomerId != null) return Number(scheduleCustomerId);
        const siteInfoFromStorage = JSON.parse(localStorage.getItem("siteInfo") || "{}");
        return Number(siteInfoFromStorage?.id || 0);
    }, [
        schedules
    ]);
    const affectedCameraIds = $8T3gX.useMemo(()=>{
        const ids = new Set();
        schedules.forEach((schedule)=>{
            (schedule.devices || []).forEach((device)=>{
                const parsed = Number(device.deviceId ?? device.id);
                if (Number.isFinite(parsed) && parsed > 0) ids.add(parsed);
            });
        });
        return Array.from(ids);
    }, [
        schedules
    ]);
    const products = $8T3gX.useMemo(()=>{
        const productSet = new Set();
        schedules.forEach((schedule)=>{
            (autoPatrolCameraProducts[schedule.id] || []).forEach((product)=>{
                const displayName = product?.metric_label?.display_name;
                if (displayName && !$5f6ebcea024ec989$var$isAutopatrolUnavailableProduct(displayName)) productSet.add(displayName);
            });
        });
        const discoveredProducts = Array.from(productSet);
        const discoveredProductSet = new Set(discoveredProducts);
        const orderedKnownProducts = $5f6ebcea024ec989$var$ORDERED_EDIT_MODE_PRODUCTS.filter((productName)=>discoveredProductSet.has(productName));
        const unknownProducts = discoveredProducts.filter((productName)=>!$5f6ebcea024ec989$var$ORDERED_EDIT_MODE_PRODUCTS.includes(productName)).sort((a, b)=>a.localeCompare(b));
        return [
            ...orderedKnownProducts,
            ...unknownProducts
        ];
    }, [
        schedules,
        autoPatrolCameraProducts
    ]);
    const [draftSelections, setDraftSelections] = $8T3gX.useState({});
    const [isSubmitting, setIsSubmitting] = $8T3gX.useState(false);
    const [bulkResultSnackbar, setBulkResultSnackbar] = $8T3gX.useState({
        open: false,
        message: ""
    });
    $8T3gX.useEffect(()=>{
        if (!open) return;
        setDraftSelections($5f6ebcea024ec989$var$createInitialDraft(schedules, autoPatrolCameraProducts));
    }, [
        open,
        schedules,
        autoPatrolCameraProducts
    ]);
    const isColumnChecked = (productName)=>schedules.length > 0 && schedules.every((schedule)=>draftSelections[schedule.id]?.[productName] === true);
    const isColumnIndeterminate = (productName)=>{
        const selectedCount = schedules.filter((schedule)=>draftSelections[schedule.id]?.[productName] === true).length;
        return selectedCount > 0 && selectedCount < schedules.length;
    };
    const handleToggleCell = (scheduleId, productName)=>{
        setDraftSelections((previous)=>({
                ...previous,
                [scheduleId]: {
                    ...previous[scheduleId] || {},
                    [productName]: previous[scheduleId]?.[productName] !== true
                }
            }));
    };
    const handleToggleColumn = (productName)=>{
        const enableColumn = !isColumnChecked(productName);
        setDraftSelections((previous)=>{
            const next = {
                ...previous
            };
            schedules.forEach((schedule)=>{
                next[schedule.id] = {
                    ...next[schedule.id] || {},
                    [productName]: enableColumn
                };
            });
            return next;
        });
    };
    const handleSubmit = async ()=>{
        if (isSubmitting) return;
        setIsSubmitting(true);
        const updates = [];
        const nextProductsBySchedule = {
            ...autoPatrolCameraProducts
        };
        schedules.forEach((schedule)=>{
            const scheduleProducts = autoPatrolCameraProducts[schedule.id] || [];
            const updatedScheduleProducts = scheduleProducts.map((product)=>{
                const displayName = product.metric_label?.display_name;
                if (!displayName || $5f6ebcea024ec989$var$isAutopatrolUnavailableProduct(displayName)) return product;
                const nextEnabled = Boolean(draftSelections[schedule.id]?.[displayName]);
                if (nextEnabled !== Boolean(product.enabled)) updates.push({
                    scheduleId: schedule.id,
                    productId: product.id,
                    enabled: nextEnabled
                });
                return {
                    ...product,
                    enabled: nextEnabled
                };
            });
            nextProductsBySchedule[schedule.id] = updatedScheduleProducts;
        });
        const siteCamerasFromStorage = JSON.parse(localStorage.getItem("siteCameras") || "{}");
        const siteCameraRowIds = Array.isArray(siteCamerasFromStorage?.results) ? siteCamerasFromStorage.results.map((camera)=>Number(camera?.id)).filter((id)=>Number.isFinite(id)) : [];
        const affectedInSiteRows = affectedCameraIds.filter((id)=>siteCameraRowIds.includes(id));
        const refreshCameraIds = affectedInSiteRows.length > 0 ? affectedInSiteRows : siteCameraRowIds.length > 0 ? siteCameraRowIds : affectedCameraIds;
        if (updates.length === 0) {
            setIsSubmitting(false);
            onClose();
            return;
        }
        const submitUpdatesRecursively = async (index)=>{
            if (index >= updates.length) return;
            const update = updates[index];
            await updateScheduleProducts(update.productId, update.enabled, update.scheduleId, navigate);
            await submitUpdatesRecursively(index + 1);
        };
        try {
            await submitUpdatesRecursively(0);
            setAutoPatrolCameraProducts(nextProductsBySchedule);
            if (customerId > 0 && refreshCameraIds.length > 0) try {
                await prefetchBulkDialogActiveCameraProducts(navigate, customerId, refreshCameraIds);
            } catch  {
            // Preserve successful submit UX even if camera-row refresh endpoint fails.
            }
            window.dispatchEvent(new CustomEvent("refreshSiteCamerasTable"));
            setBulkResultSnackbar({
                open: true,
                message: `Bulk product update completed for ${updates.length} product update${updates.length === 1 ? "" : "s"}.`
            });
            onClose();
        } finally{
            setIsSubmitting(false);
        }
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                openState: isSubmitting,
                stackAboveModal: true,
                message: "Applying bulk update..."
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                open: open,
                onClose: ()=>{
                    if (!isSubmitting) onClose();
                },
                disableEscapeKeyDown: isSubmitting,
                fullWidth: true,
                maxWidth: "lg",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: 700
                        },
                        children: "Product Bulk Update"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                            component: (0, $4reBM.default),
                            sx: {
                                mt: 1
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                size: "small",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    sx: {
                                                        fontFamily: "Mulish",
                                                        fontWeight: 700,
                                                        minWidth: 200,
                                                        width: 200
                                                    }
                                                }),
                                                products.map((productName)=>{
                                                    const checkboxKey = $5f6ebcea024ec989$var$toCheckboxKey(productName);
                                                    const productColor = $5f6ebcea024ec989$var$EDIT_MODE_COLOR_BY_PRODUCT[productName] ?? "#616161";
                                                    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "center",
                                                        sx: {
                                                            fontFamily: "Mulish",
                                                            fontWeight: 700,
                                                            verticalAlign: "bottom",
                                                            pb: "5px",
                                                            px: 2.5,
                                                            whiteSpace: "nowrap"
                                                        },
                                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                            className: "flex min-h-[76px] flex-col items-center justify-end",
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                                    style: {
                                                                        color: "#000000",
                                                                        whiteSpace: "nowrap"
                                                                    },
                                                                    children: $5f6ebcea024ec989$var$getProductDisplayLabel(productName)
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                                    checked: isColumnChecked(productName),
                                                                    indeterminate: isColumnIndeterminate(productName),
                                                                    onChange: ()=>handleToggleColumn(productName),
                                                                    "data-testid": `product-bulk-column-${checkboxKey}`,
                                                                    sx: {
                                                                        px: 1.5,
                                                                        color: productColor,
                                                                        "&.Mui-checked": {
                                                                            color: productColor
                                                                        },
                                                                        "&.MuiCheckbox-indeterminate": {
                                                                            color: productColor
                                                                        }
                                                                    },
                                                                    inputProps: {
                                                                        "aria-label": `Toggle ${productName} for all schedules`
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    }, productName);
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                        children: schedules.map((schedule)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        sx: {
                                                            fontFamily: "Mulish",
                                                            fontWeight: 600,
                                                            minWidth: 200,
                                                            width: 320
                                                        },
                                                        children: schedule.title?.trim() || `Schedule ${schedule.id}`
                                                    }),
                                                    products.map((productName)=>{
                                                        const checkboxKey = $5f6ebcea024ec989$var$toCheckboxKey(productName);
                                                        const productColor = $5f6ebcea024ec989$var$EDIT_MODE_COLOR_BY_PRODUCT[productName] ?? "#616161";
                                                        return /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            align: "center",
                                                            sx: {
                                                                px: 2.5
                                                            },
                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                                checked: Boolean(draftSelections[schedule.id]?.[productName]),
                                                                onChange: ()=>handleToggleCell(schedule.id, productName),
                                                                "data-testid": `product-bulk-cell-${schedule.id}-${checkboxKey}`,
                                                                sx: {
                                                                    px: 1.5,
                                                                    color: productColor,
                                                                    "&.Mui-checked": {
                                                                        color: productColor
                                                                    }
                                                                },
                                                                inputProps: {
                                                                    "aria-label": `Toggle ${productName} for ${schedule.title || `Schedule ${schedule.id}`}`
                                                                }
                                                            })
                                                        }, `${schedule.id}-${productName}`);
                                                    })
                                                ]
                                            }, schedule.id))
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                        sx: {
                            px: 3,
                            pb: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: onClose,
                                text: "CANCEL",
                                disabled: isSubmitting
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>void handleSubmit(),
                                text: isSubmitting ? "SUBMITTING..." : "SUBMIT",
                                disabled: isSubmitting
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gVgDF.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8E01L.default), {
                    open: bulkResultSnackbar.open,
                    autoHideDuration: 6000,
                    onClose: ()=>setBulkResultSnackbar({
                            open: false,
                            message: ""
                        }),
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center"
                    },
                    sx: {
                        zIndex: (theme)=>theme.zIndex.modal + 1
                    },
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                        elevation: 6,
                        variant: "filled",
                        severity: "success",
                        onClose: ()=>setBulkResultSnackbar({
                                open: false,
                                message: ""
                            }),
                        sx: {
                            width: "100%",
                            fontFamily: "Mulish"
                        },
                        children: bulkResultSnackbar.message
                    })
                })
            })
        ]
    });
};

});


parcelRegister("cREnW", function(module, exports) {

$parcel$export(module.exports, "FlexIgnoreZonesOnboardingDialog", () => $f7706f3cd4a9939e$export$7103537072a2be87);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");
var $887xF = parcelRequire("887xF");
var $1TOOV = parcelRequire("1TOOV");
var $ce8iU = parcelRequire("ce8iU");
var $iKAtE = parcelRequire("iKAtE");
var $cVCJe = parcelRequire("cVCJe");

var $433j1 = parcelRequire("433j1");

var $ePwXE = parcelRequire("ePwXE");

var $8jTCz = parcelRequire("8jTCz");

var $dHtmK = parcelRequire("dHtmK");

var $3FJ79 = parcelRequire("3FJ79");

var $idDbD = parcelRequire("idDbD");

var $83bsI = parcelRequire("83bsI");

var $axLUl = parcelRequire("axLUl");

var $2Mk2P = parcelRequire("2Mk2P");

var $bILSL = parcelRequire("bILSL");

var $7Gmex = parcelRequire("7Gmex");

var $eYzFO = parcelRequire("eYzFO");

var $87t0c = parcelRequire("87t0c");

var $qyGZG = parcelRequire("qyGZG");

var $6JE7U = parcelRequire("6JE7U");

var $2RrZf = parcelRequire("2RrZf");

var $9s9JO = parcelRequire("9s9JO");

var $5P5Ui = parcelRequire("5P5Ui");
/** Must match `SchedulesTabs` Tab `value`s ("one" | "two" | "three"). */ const $f7706f3cd4a9939e$var$scheduleTabValueForIndex = (index)=>{
    if (index <= 0) return "one";
    if (index === 1) return "two";
    return "three";
};
const $f7706f3cd4a9939e$export$7103537072a2be87 = ({ onClose: onClose, onSuccessfulSubmit: onSuccessfulSubmit, isFleetSite: isFleetSite = false })=>{
    const { isOpen: isOpen, step: step, schedules: schedules, cameras: cameras, activeScheduleIndex: activeScheduleIndex, selectedPresetByScheduleCamera: selectedPresetByScheduleCamera, cameraContexts: cameraContexts, presetsByCamera: presetsByCamera, presetNamesByCamera: presetNamesByCamera, submitLoading: submitLoading, submitError: submitError, closeDialog: closeDialog, setStep: setStep, setActiveScheduleIndex: setActiveScheduleIndex, setSelectedPresetForScheduleCamera: setSelectedPresetForScheduleCamera, loadCameraContext: loadCameraContext, createCustomPresetDraft: createCustomPresetDraft, submitAll: submitAll } = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)();
    const { scheduleGridEditable: scheduleGridEditable, setScheduleGridEditable: setScheduleGridEditable, setSchedulesIndex: setSchedulesIndex, setClickedSchedulesTab: setClickedSchedulesTab, siteSchedules: siteSchedules, setGrid: setGrid, setTimeRanges: setTimeRanges, setDuskToDawn: setDuskToDawn, setDuskToDawnLocation: setDuskToDawnLocation } = (0, $3FJ79.useSiteAboutStore)();
    const currentSchedule = schedules[activeScheduleIndex];
    const [newPresetDialog, setNewPresetDialog] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!isOpen) return;
        setScheduleGridEditable(false);
        return ()=>{
            setScheduleGridEditable(scheduleGridEditable);
        };
    }, [
        isOpen
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!isOpen || !currentSchedule) return;
        setSchedulesIndex(activeScheduleIndex);
        setClickedSchedulesTab($f7706f3cd4a9939e$var$scheduleTabValueForIndex(activeScheduleIndex));
        localStorage.setItem("schedulesIndex", String(activeScheduleIndex));
        const selectedSchedule = siteSchedules[activeScheduleIndex];
        if (!selectedSchedule?.schedule) return;
        setTimeRanges((0, $2Mk2P.handleCreateInitialTimeSchedules)(selectedSchedule.schedule));
        setGrid((0, $axLUl.handleConvertSchedulesToBooleanArrays)(selectedSchedule.schedule));
        setDuskToDawn((0, $bILSL.handleCreateDuskToDawn)(selectedSchedule.schedule));
        setDuskToDawnLocation((0, $7Gmex.handleCreateDuskToDawnLocationPlusBuffer)(selectedSchedule.schedule));
    }, [
        isOpen,
        activeScheduleIndex,
        currentSchedule
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!isOpen || !currentSchedule || step !== "scheduleSelection") return;
        cameras.forEach((camera)=>{
            loadCameraContext(camera.id);
        });
    }, [
        isOpen,
        step,
        currentSchedule?.id,
        cameras
    ]);
    // ENG-1927: submit writes one camera-schedule-preset row at a time, so a
    // server refusal part-way would leave the site half-configured. Each
    // distinct selection becomes its own new preset on submit ("local" identity).
    const presetConflicts = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>{
        if (!isFleetSite) return [];
        const timesById = new Map((siteSchedules || []).map((schedule)=>[
                Number(schedule?.id),
                schedule
            ]));
        return (0, $5P5Ui.findPresetConflicts)({
            schedules: schedules.map((schedule)=>({
                    ...timesById.get(schedule.id),
                    id: schedule.id,
                    display_name: schedule.display_name
                })),
            cameras: cameras,
            selectedPresetByScheduleCamera: selectedPresetByScheduleCamera,
            presetsByCamera: presetsByCamera,
            presetNamesByCamera: presetNamesByCamera,
            identity: "local"
        });
    }, [
        isFleetSite,
        siteSchedules,
        schedules,
        cameras,
        selectedPresetByScheduleCamera,
        presetsByCamera,
        presetNamesByCamera
    ]);
    const handleCloseDialog = ()=>{
        closeDialog();
        onClose();
    };
    const handleNext = async ()=>{
        if (!currentSchedule && step !== "summary") return;
        if (step === "scheduleSelection" && currentSchedule) {
            const missingSelection = cameras.find((camera)=>{
                const selectedLocalId = selectedPresetByScheduleCamera[`${currentSchedule.id}:${camera.id}`];
                return !selectedLocalId;
            });
            if (missingSelection) {
                alert(`Choose an ignore zones preset for ${missingSelection.camera_name}.`);
                return;
            }
            const unnamedSelection = cameras.find((camera)=>{
                const selectedLocalId = selectedPresetByScheduleCamera[`${currentSchedule.id}:${camera.id}`];
                if (!selectedLocalId || selectedLocalId === (0, $9s9JO.FLEX_IZ_NO_IGNORE_ZONES_OPTION)) return false;
                const selectedPreset = (presetsByCamera[camera.id] || []).find((preset)=>preset.localId === selectedLocalId);
                return !selectedPreset?.name?.trim();
            });
            if (unnamedSelection) {
                alert(`Preset name is required for ${unnamedSelection.camera_name}.`);
                return;
            }
            if (activeScheduleIndex < schedules.length - 1) {
                setActiveScheduleIndex(activeScheduleIndex + 1);
                return;
            }
            setStep("summary");
            return;
        }
        if (step === "summary") {
            if (presetConflicts.length > 0) return;
            const success = await submitAll();
            if (success) {
                onSuccessfulSubmit?.();
                onClose();
            }
        }
    };
    const handleBack = ()=>{
        if (step === "scheduleSelection") {
            if (activeScheduleIndex === 0) {
                handleCloseDialog();
                return;
            }
            setActiveScheduleIndex(activeScheduleIndex - 1);
            return;
        }
        if (step === "summary") {
            setActiveScheduleIndex(Math.max(schedules.length - 1, 0));
            setStep("scheduleSelection");
        }
    };
    const assignments = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>{
        return Object.entries(selectedPresetByScheduleCamera).map(([key, presetLocalId])=>{
            const [scheduleId, cameraId] = key.split(":").map(Number);
            const schedule = schedules.find((item)=>item.id === scheduleId);
            const camera = cameras.find((item)=>item.id === cameraId);
            const cameraContext = cameraContexts[cameraId];
            const preset = (presetsByCamera[cameraId] || []).find((item)=>item.localId === presetLocalId);
            if (!schedule || !camera || !preset) return null;
            return {
                schedule: schedule,
                camera: camera,
                preset: preset,
                cameraContext: cameraContext
            };
        }).filter(Boolean);
    }, [
        selectedPresetByScheduleCamera,
        schedules,
        cameras,
        presetsByCamera,
        cameraContexts
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                openState: submitLoading,
                message: "Submitting Flex Ignore Zones configuration...",
                stackAboveModal: true
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                open: isOpen,
                onClose: handleCloseDialog,
                fullWidth: true,
                maxWidth: "xl",
                PaperProps: {
                    sx: {
                        fontFamily: "Mulish",
                        minHeight: "85vh"
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $ce8iU.default), {
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: 700,
                            bgcolor: "#1B2A4A",
                            color: "white",
                            py: 2.25,
                            pr: 6
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "flex items-center gap-[8px]",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "font-mulish text-[20px] font-black text-white",
                                        children: "Flex Ignore Zones Onboarding"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                        title: "Only the final submit saves presets, zones, and schedule assignments.",
                                        sx: {
                                            fontSize: "14px",
                                            fontFamily: "Mulish"
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                            fontSize: "small",
                                            sx: {
                                                color: "white"
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                onClick: handleCloseDialog,
                                "aria-label": "close flex ignore zones onboarding dialog",
                                sx: {
                                    position: "absolute",
                                    right: 12,
                                    top: 12,
                                    color: "white",
                                    "&:hover": {
                                        backgroundColor: "rgba(255, 255, 255, 0.12)"
                                    }
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                        dividers: true,
                        children: [
                            step === "scheduleSelection" && currentSchedule && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "font-mulish text-[20px] font-black pb-[10px]",
                                        children: currentSchedule.display_name || "Schedule"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "pointer-events-none opacity-80 border border-gray-200 rounded-[6px] p-[8px]",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $idDbD.ScheduleGrid), {})
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "font-mulish text-[14px] pt-[12px] pb-[10px]",
                                        children: "Select an ignore zones preset for each camera in this schedule."
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-[12px] justify-items-start",
                                        children: cameras.map((camera)=>{
                                            const cameraPresets = presetsByCamera[camera.id] || [];
                                            const selectedPresetLocalId = selectedPresetByScheduleCamera[`${currentSchedule.id}:${camera.id}`] || `default-${camera.id}`;
                                            const selectablePresets = (0, $6JE7U.collapseNoIgnoreZonesPresetOptions)(cameraPresets, selectedPresetLocalId);
                                            const selectedPreset = selectablePresets.find((preset)=>preset.localId === selectedPresetLocalId) || selectablePresets.find((preset)=>preset.localId === `default-${camera.id}`) || selectablePresets[0] || {
                                                localId: (0, $9s9JO.FLEX_IZ_NO_IGNORE_ZONES_OPTION),
                                                cameraId: camera.id,
                                                name: "No Ignore Zones",
                                                zones: [],
                                                persistedId: null,
                                                source: "custom",
                                                userNamed: true
                                            };
                                            return /*#__PURE__*/ (0, $k4ank.jsx)((0, $87t0c.FlexIgnoreZonesEditPresetCard), {
                                                scheduleId: currentSchedule.id,
                                                camera: camera,
                                                preset: selectedPreset,
                                                cameraContext: cameraContexts[camera.id],
                                                selectablePresets: selectablePresets,
                                                selectedPresetLocalId: selectedPresetLocalId,
                                                onSelectPreset: (presetLocalId)=>{
                                                    setSelectedPresetForScheduleCamera(currentSchedule.id, camera.id, presetLocalId);
                                                },
                                                onCreateNewPreset: ()=>{
                                                    const ctxZones = cameraContexts[camera.id]?.defaultZones;
                                                    const zones = ctxZones && ctxZones.length > 0 ? ctxZones : (0, $83bsI.addIgnoreLabel)(camera.ignore_zones || []);
                                                    const localId = createCustomPresetDraft(camera.id, zones);
                                                    setSelectedPresetForScheduleCamera(currentSchedule.id, camera.id, localId);
                                                    setNewPresetDialog({
                                                        scheduleId: currentSchedule.id,
                                                        cameraId: camera.id,
                                                        presetLocalId: localId,
                                                        cameraName: camera.camera_name
                                                    });
                                                },
                                                onPreviewImageError: ()=>{
                                                    loadCameraContext(camera.id, true);
                                                }
                                            }, `${currentSchedule.id}-${camera.id}`);
                                        })
                                    })
                                ]
                            }),
                            step === "summary" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2RrZf.SummaryStep), {
                                assignments: assignments,
                                conflicts: presetConflicts
                            }),
                            submitError && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "pt-[12px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "text-red-600 font-mulish text-[14px] whitespace-pre-line",
                                    children: submitError
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: handleBack,
                                text: "Back",
                                disabled: submitLoading
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: handleNext,
                                text: step === "summary" ? "Submit" : "Next",
                                disabled: submitLoading || step === "summary" && presetConflicts.length > 0
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $qyGZG.FlexIgnoreZonesNewPresetDialog), {
                open: newPresetDialog != null,
                scheduleId: newPresetDialog?.scheduleId ?? 0,
                cameraId: newPresetDialog?.cameraId ?? 0,
                presetLocalId: newPresetDialog?.presetLocalId ?? null,
                cameraName: newPresetDialog?.cameraName ?? "",
                onClose: (reason)=>{
                    if (reason === "submitted" && newPresetDialog) loadCameraContext(newPresetDialog.cameraId, true);
                    setNewPresetDialog(null);
                }
            })
        ]
    });
};

});

parcelRegister("jY59N", function(module, exports) {

$parcel$export(module.exports, "FlexIgnoreZonesOffboardingDialog", () => $2ab03d5830b8f29a$export$a2234b5fe6616fd3);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8VQWA = parcelRequire("8VQWA");

var $kUcVg = parcelRequire("kUcVg");
var $887xF = parcelRequire("887xF");
var $1TOOV = parcelRequire("1TOOV");
var $ce8iU = parcelRequire("ce8iU");
var $7UDCh = parcelRequire("7UDCh");
var $6gU8O = parcelRequire("6gU8O");
var $cxknk = parcelRequire("cxknk");
var $2eEqG = parcelRequire("2eEqG");

var $195EM = parcelRequire("195EM");

var $8jTCz = parcelRequire("8jTCz");

var $dHtmK = parcelRequire("dHtmK");

var $83bsI = parcelRequire("83bsI");

var $eVSHG = parcelRequire("eVSHG");

var $9hVqI = parcelRequire("9hVqI");

var $eYzFO = parcelRequire("eYzFO");

var $9s9JO = parcelRequire("9s9JO");

var $qyGZG = parcelRequire("qyGZG");

var $6JE7U = parcelRequire("6JE7U");

var $dfiY5 = parcelRequire("dfiY5");
const $2ab03d5830b8f29a$var$replaceNegativeWithZero = (data)=>{
    const cloned = data.map((polygon)=>polygon.map((coordinates)=>coordinates.map((num)=>num < 0 ? 0 : num)));
    return cloned;
};
const $2ab03d5830b8f29a$export$a2234b5fe6616fd3 = ({ open: open, siteId: siteId, currentScheduleId: currentScheduleId, cameras: cameras, onClose: onClose, onSubmitted: onSubmitted })=>{
    const { loadCameraContext: loadCameraContext, presetsByCamera: presetsByCamera, cameraContexts: cameraContexts, selectedPresetByScheduleCamera: selectedPresetByScheduleCamera, createCustomPresetDraft: createCustomPresetDraft, removeLocalPresetDraft: removeLocalPresetDraft } = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)();
    const [choicesByCamera, setChoicesByCamera] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [newPresetDialog, setNewPresetDialog] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [submitLoading, setSubmitLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [submitError, setSubmitError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [previewRetryTriggeredByCamera, setPreviewRetryTriggeredByCamera] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const resolvePreferredPreset = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback((cameraId)=>{
        // "Default" (no preset assigned) is not a preset to keep after offboarding.
        const isPresetSelection = (presetLocalId)=>!!presetLocalId && presetLocalId !== (0, $9s9JO.FLEX_IZ_DEFAULT_CAMERA_CONFIG_OPTION);
        if (typeof currentScheduleId === "number") {
            const fromCurrentSchedule = selectedPresetByScheduleCamera[`${currentScheduleId}:${cameraId}`];
            if (isPresetSelection(fromCurrentSchedule)) return fromCurrentSchedule;
        }
        const fromAnySchedule = Object.entries(selectedPresetByScheduleCamera).find(([key, presetLocalId])=>key.endsWith(`:${cameraId}`) && isPresetSelection(presetLocalId));
        if (fromAnySchedule?.[1]) return fromAnySchedule[1];
        const presets = (0, $6JE7U.collapseNoIgnoreZonesPresetOptions)((0, $6JE7U.filterFlexPresetsForApiPresetDropdown)(presetsByCamera[cameraId] || []), undefined);
        if (presets.length > 0) return presets[0].localId;
        return null;
    }, [
        currentScheduleId,
        selectedPresetByScheduleCamera,
        presetsByCamera
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!open) return;
        setSubmitError(null);
        setSubmitLoading(false);
        setPreviewRetryTriggeredByCamera({});
        cameras.forEach((camera)=>{
            loadCameraContext(camera.id);
        });
    }, [
        open,
        cameras,
        loadCameraContext
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!open) return;
        setChoicesByCamera((previous)=>{
            const next = {
                ...previous
            };
            cameras.forEach((camera)=>{
                const existingChoice = next[camera.id];
                if (existingChoice) {
                    if (existingChoice.mode === "preset") {
                        const all = presetsByCamera[camera.id] || [];
                        const apiOnly = (0, $6JE7U.filterFlexPresetsForApiPresetDropdown)(all);
                        const normalized = (0, $6JE7U.normalizeFlexPresetSelectionToApiBackedMenuValue)(camera.id, all, existingChoice.presetLocalId);
                        const stillExists = apiOnly.some((preset)=>preset.localId === normalized) || apiOnly.some((preset)=>preset.localId === existingChoice.presetLocalId);
                        if (!stillExists) {
                            const fallback = resolvePreferredPreset(camera.id);
                            next[camera.id] = fallback ? {
                                mode: "preset",
                                presetLocalId: fallback
                            } : {
                                mode: "none",
                                presetLocalId: ""
                            };
                        }
                    } else if (existingChoice.mode === "none") {
                        const apiOnly = (0, $6JE7U.filterFlexPresetsForApiPresetDropdown)(presetsByCamera[camera.id] || []);
                        const collapsed = (0, $6JE7U.collapseNoIgnoreZonesPresetOptions)(apiOnly, undefined);
                        const persistedNoIgnore = collapsed.find((0, $6JE7U.isNoIgnorePreset));
                        if (persistedNoIgnore) next[camera.id] = {
                            mode: "preset",
                            presetLocalId: persistedNoIgnore.localId
                        };
                    }
                    return;
                }
                const preferred = resolvePreferredPreset(camera.id);
                next[camera.id] = preferred ? {
                    mode: "preset",
                    presetLocalId: preferred
                } : {
                    mode: "none",
                    presetLocalId: ""
                };
            });
            return next;
        });
    }, [
        open,
        cameras,
        presetsByCamera,
        resolvePreferredPreset
    ]);
    const selectionComplete = cameras.every((camera)=>{
        const choice = choicesByCamera[camera.id];
        if (!choice) return false;
        if (choice.mode === "none") return true;
        return !!choice.presetLocalId;
    });
    const getPresetForCameraChoice = (camera)=>{
        const choice = choicesByCamera[camera.id];
        const selectedPreset = choice?.mode === "preset" ? (presetsByCamera[camera.id] || []).find((preset)=>preset.localId === choice.presetLocalId) : undefined;
        return selectedPreset || {
            localId: `none-${camera.id}`,
            cameraId: camera.id,
            name: "No Ignore Zones",
            zones: [],
            persistedId: null,
            source: "custom",
            userNamed: true
        };
    };
    const handleSelectValue = (camera, value)=>{
        if (value === (0, $9s9JO.FLEX_IZ_CREATE_NEW_PRESET_OPTION)) {
            const contextDefaultZones = cameraContexts[camera.id]?.defaultZones;
            const fallbackZones = contextDefaultZones && contextDefaultZones.length > 0 ? contextDefaultZones : (0, $83bsI.addIgnoreLabel)(camera.ignore_zones || []);
            const localId = createCustomPresetDraft(camera.id, fallbackZones);
            setNewPresetDialog({
                cameraId: camera.id,
                presetLocalId: localId,
                cameraName: camera.camera_name
            });
            return;
        }
        if (value === (0, $9s9JO.FLEX_IZ_NO_IGNORE_ZONES_OPTION)) {
            setChoicesByCamera((previous)=>({
                    ...previous,
                    [camera.id]: {
                        mode: "none",
                        presetLocalId: ""
                    }
                }));
            return;
        }
        setChoicesByCamera((previous)=>({
                ...previous,
                [camera.id]: {
                    mode: "preset",
                    presetLocalId: value
                }
            }));
    };
    const handleSubmit = async ()=>{
        if (!selectionComplete) {
            alert("Please make a choice for every camera before submitting.");
            return;
        }
        (0, $8VQWA.flushSync)(()=>{
            setSubmitLoading(true);
            setSubmitError(null);
        });
        const AxiosUI = (0, $195EM.createApi)("");
        try {
            for (const camera of cameras){
                const choice = choicesByCamera[camera.id];
                if (choice.mode === "none") {
                    const payload = await (0, $dfiY5.buildNoIgnoreZonesPostPayload)(camera, cameraContexts[camera.id]?.defaultZones, AxiosUI);
                    await AxiosUI.post(`/camera/${camera.id}/ignore_zones/`, payload);
                    continue;
                }
                const selectedPreset = (presetsByCamera[camera.id] || []).find((preset)=>preset.localId === choice.presetLocalId) || null;
                const payload = (selectedPreset?.zones || []).map((zone)=>({
                        zone_type: zone.zone_type,
                        stream_id: zone.stream_id,
                        stream_name: (0, $dfiY5.ignoreZoneStreamNameForCameraApi)(zone),
                        metric_id: zone.metric_id,
                        label: zone.label,
                        label_display_name: zone.label_display_name,
                        line_color: zone.line_color,
                        coordinates: $2ab03d5830b8f29a$var$replaceNegativeWithZero((zone.coordinates || []).filter((arr)=>arr.length > 0))
                    }));
                await AxiosUI.post(`/camera/${camera.id}/ignore_zones/`, payload);
            }
            await (0, $9hVqI.deletePersistedFlexPresetRecordsAfterIgnoreZonesSave)(AxiosUI, presetsByCamera, cameras, loadCameraContext);
            setSubmitLoading(false);
            onSubmitted();
            onClose();
        } catch (error) {
            setSubmitLoading(false);
            setSubmitError(error?.message || "Failed to apply ignore zones selections.");
        }
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                openState: submitLoading,
                message: "Applying camera ignore zones selections...",
                stackAboveModal: true
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                open: open,
                onClose: (_, reason)=>{
                    if (!submitLoading && reason !== "backdropClick") onClose();
                },
                fullWidth: true,
                maxWidth: "xl",
                PaperProps: {
                    sx: {
                        fontFamily: "Mulish",
                        minHeight: "80vh"
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: 700
                        },
                        children: "Flex Ignore Zones Offboarding"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                        dividers: true,
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "font-mulish text-[14px] pb-[12px]",
                                        children: "Choose what each camera should keep after turning Flex Ignore Zones off. The preview shows the currently selected zones for each camera."
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-[12px] justify-items-start max-w-[1500px]",
                                        children: cameras.map((camera)=>{
                                            const choice = choicesByCamera[camera.id];
                                            const apiOnly = (0, $6JE7U.filterFlexPresetsForApiPresetDropdown)(presetsByCamera[camera.id] || []);
                                            const menuPresets = (0, $6JE7U.collapseNoIgnoreZonesPresetOptions)(apiOnly, choice?.mode === "preset" ? choice.presetLocalId : undefined);
                                            const showSyntheticNoIgnoreOption = !menuPresets.some((0, $6JE7U.isNoIgnorePreset));
                                            const selectedValue = choice?.mode === "none" ? (0, $9s9JO.FLEX_IZ_NO_IGNORE_ZONES_OPTION) : choice?.presetLocalId || "";
                                            const presetSelector = /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                                                fullWidth: true,
                                                size: "small",
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $6gU8O.default), {
                                                        id: `offboarding-preset-select-${siteId}-${camera.id}`,
                                                        sx: {
                                                            fontFamily: "Mulish"
                                                        },
                                                        children: "Ignore Zones Selection"
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $2eEqG.default), {
                                                        labelId: `offboarding-preset-select-${siteId}-${camera.id}`,
                                                        label: "Ignore Zones Selection",
                                                        value: selectedValue,
                                                        onChange: (event)=>handleSelectValue(camera, String(event.target.value)),
                                                        sx: {
                                                            fontFamily: "Mulish"
                                                        },
                                                        children: [
                                                            menuPresets.length === 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                                disabled: true,
                                                                value: "",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: "No presets available"
                                                            }),
                                                            menuPresets.map((preset)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                                    value: preset.localId,
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: preset.name
                                                                }, preset.localId)),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                                value: (0, $9s9JO.FLEX_IZ_CREATE_NEW_PRESET_OPTION),
                                                                sx: {
                                                                    color: "#FF8400",
                                                                    fontFamily: "Mulish",
                                                                    fontWeight: 700
                                                                },
                                                                children: "+ CREATE NEW IGNORE ZONES"
                                                            }),
                                                            showSyntheticNoIgnoreOption && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                                value: (0, $9s9JO.FLEX_IZ_NO_IGNORE_ZONES_OPTION),
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: "No Ignore Zones"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            });
                                            return /*#__PURE__*/ (0, $k4ank.jsx)((0, $eVSHG.FlexIgnoreZonesCameraPresetCard), {
                                                scheduleId: 0,
                                                camera: camera,
                                                preset: getPresetForCameraChoice(camera),
                                                cameraContext: cameraContexts[camera.id],
                                                presetLineReplacement: presetSelector,
                                                onPreviewImageError: ()=>{
                                                    if (previewRetryTriggeredByCamera[camera.id]) return;
                                                    setPreviewRetryTriggeredByCamera((previous)=>({
                                                            ...previous,
                                                            [camera.id]: true
                                                        }));
                                                    loadCameraContext(camera.id, true);
                                                }
                                            }, `offboarding-camera-${camera.id}`);
                                        })
                                    })
                                ]
                            }),
                            submitError && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "font-mulish text-[14px] text-red-600 pt-[12px]",
                                children: submitError
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: onClose,
                                text: "Cancel",
                                disabled: submitLoading
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: handleSubmit,
                                text: "Submit",
                                disabled: !selectionComplete || submitLoading
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $qyGZG.FlexIgnoreZonesNewPresetDialog), {
                open: newPresetDialog != null,
                cameraId: newPresetDialog?.cameraId ?? 0,
                presetLocalId: newPresetDialog?.presetLocalId ?? null,
                cameraName: newPresetDialog?.cameraName ?? "",
                assignToSchedule: false,
                onClose: (reason, meta)=>{
                    if (reason === "submitted" && newPresetDialog) {
                        const nextLocalId = meta?.presetLocalId ?? newPresetDialog.presetLocalId;
                        setChoicesByCamera((previous)=>({
                                ...previous,
                                [newPresetDialog.cameraId]: {
                                    mode: "preset",
                                    presetLocalId: nextLocalId
                                }
                            }));
                    }
                    if (reason === "cancelled" && newPresetDialog) removeLocalPresetDraft(newPresetDialog.cameraId, newPresetDialog.presetLocalId);
                    setNewPresetDialog(null);
                }
            })
        ]
    });
};

});

parcelRegister("16Em8", function(module, exports) {

$parcel$export(module.exports, "FlexIgnoreZonesScheduleEditPresetSection", () => $d93062e52e3f85fb$export$41a17192e6f1e95a);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $83bsI = parcelRequire("83bsI");

var $eYzFO = parcelRequire("eYzFO");

var $hpMHQ = parcelRequire("hpMHQ");

var $87t0c = parcelRequire("87t0c");

var $qyGZG = parcelRequire("qyGZG");

var $6JE7U = parcelRequire("6JE7U");

var $9s9JO = parcelRequire("9s9JO");

var $3FJ79 = parcelRequire("3FJ79");

var $5P5Ui = parcelRequire("5P5Ui");

var $1pR5m = parcelRequire("1pR5m");
const $d93062e52e3f85fb$export$41a17192e6f1e95a = ({ siteInfo: siteInfo, showFlexIgnoreZones: showFlexIgnoreZones, flexIgnoreZonesEnabled: flexIgnoreZonesEnabled, flexSchedulesOn: flexSchedulesOn })=>{
    const userInfo = JSON.parse(localStorage.userInfo);
    const permissions = userInfo.permission;
    const { presetsByCamera: presetsByCamera, setSelectedPresetForScheduleCamera: setSelectedPresetForScheduleCamera, createCustomPresetDraft: createCustomPresetDraft, loadCameraContext: loadCameraContext, cameraContexts: cameraContexts, selectedPresetByScheduleCamera: selectedPresetByScheduleCamera } = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)();
    const { siteSchedules: siteSchedules } = (0, $3FJ79.useSiteAboutStore)();
    const presetNamesByCamera = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((state)=>state.presetNamesByCamera);
    const storeCameras = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((state)=>state.cameras);
    const fleetSite = (0, $5P5Ui.isFleetSite)(siteInfo);
    // ENG-1927: on a fleet site a camera can run one preset at a time. Save
    // Changes refuses these (blockOnFlexPresetConflicts); list them here so the
    // user can fix them before saving.
    const presetConflicts = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>fleetSite ? (0, $5P5Ui.findPresetConflicts)({
            schedules: siteSchedules || [],
            cameras: storeCameras,
            selectedPresetByScheduleCamera: selectedPresetByScheduleCamera,
            presetsByCamera: presetsByCamera,
            presetNamesByCamera: presetNamesByCamera,
            identity: "persisted"
        }) : [], [
        fleetSite,
        siteSchedules,
        storeCameras,
        selectedPresetByScheduleCamera,
        presetsByCamera,
        presetNamesByCamera
    ]);
    const summary = (0, $hpMHQ.useFlexIzScheduleSummary)(siteInfo, {
        showFlexIgnoreZones: showFlexIgnoreZones,
        flexScheduleActive: flexSchedulesOn && permissions.flex_schedule,
        flexIgnoreZonesEnabled: flexIgnoreZonesEnabled
    });
    const [newPresetDialog, setNewPresetDialog] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    if (!summary) return null;
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "pl-[15px] pr-[20px] pt-[16px] pb-[24px] bg-white",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-mulish text-[18px] font-black pb-[12px]",
                        children: "Selected Cameras / Flex Schedule Presets"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $1pR5m.FlexPresetConflictsNotice), {
                        conflicts: presetConflicts
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-[12px] justify-items-start max-w-[1500px]",
                        children: summary.rows.map(({ cameraId: cameraId, camera: camera, preset: preset })=>{
                            const allPresets = presetsByCamera[cameraId] || [];
                            const rawSelectedId = selectedPresetByScheduleCamera[`${summary.resolvedScheduleId}:${cameraId}`] || preset.localId;
                            const selectedLocalId = (0, $6JE7U.normalizeFlexPresetSelectionToApiBackedMenuValue)(cameraId, allPresets, rawSelectedId);
                            const menuPresets = (0, $6JE7U.collapseNoIgnoreZonesPresetOptions)((0, $6JE7U.filterFlexPresetsForApiPresetDropdown)(allPresets), selectedLocalId);
                            // An assignment the zone-bundle list does not carry still shows up
                            // (with its real name) instead of leaving the select out of range.
                            const selectablePresets = preset.localId !== (0, $9s9JO.FLEX_IZ_DEFAULT_CAMERA_CONFIG_OPTION) && !menuPresets.some((p)=>p.localId === preset.localId) ? [
                                ...menuPresets,
                                preset
                            ] : menuPresets;
                            const cameraContext = cameraContexts[cameraId];
                            // "Default" previews the camera's own zones (the loaded context is
                            // fresher than the site camera list's `ignore_zones`).
                            const presetForCard = preset.localId === (0, $9s9JO.FLEX_IZ_DEFAULT_CAMERA_CONFIG_OPTION) && (cameraContext?.defaultZones?.length ?? 0) > 0 ? {
                                ...preset,
                                zones: cameraContext.defaultZones
                            } : preset;
                            return /*#__PURE__*/ (0, $k4ank.jsx)((0, $87t0c.FlexIgnoreZonesEditPresetCard), {
                                scheduleId: summary.resolvedScheduleId,
                                camera: camera,
                                preset: presetForCard,
                                cameraContext: cameraContext,
                                selectablePresets: selectablePresets,
                                selectedPresetLocalId: selectedLocalId,
                                onSelectPreset: (presetLocalId)=>{
                                    setSelectedPresetForScheduleCamera(summary.resolvedScheduleId, cameraId, presetLocalId);
                                    loadCameraContext(cameraId);
                                },
                                onCreateNewPreset: ()=>{
                                    const ctxZones = cameraContexts[cameraId]?.defaultZones;
                                    const zones = ctxZones && ctxZones.length > 0 ? ctxZones : (0, $83bsI.addIgnoreLabel)(camera.ignore_zones || []);
                                    const localId = createCustomPresetDraft(cameraId, zones);
                                    setNewPresetDialog({
                                        scheduleId: summary.resolvedScheduleId,
                                        cameraId: cameraId,
                                        presetLocalId: localId,
                                        cameraName: camera.camera_name
                                    });
                                    loadCameraContext(cameraId);
                                },
                                onPreviewImageError: ()=>{
                                    loadCameraContext(cameraId, true);
                                },
                                showNoIgnoreZonesOption: false,
                                showDefaultCameraConfigOption: true
                            }, `${summary.resolvedScheduleId}-${cameraId}`);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $qyGZG.FlexIgnoreZonesNewPresetDialog), {
                open: newPresetDialog != null,
                scheduleId: newPresetDialog?.scheduleId ?? 0,
                cameraId: newPresetDialog?.cameraId ?? 0,
                presetLocalId: newPresetDialog?.presetLocalId ?? null,
                cameraName: newPresetDialog?.cameraName ?? "",
                assignToSchedule: false,
                onClose: (reason, meta)=>{
                    if (reason === "submitted" && newPresetDialog) {
                        loadCameraContext(newPresetDialog.cameraId, true);
                        if (meta?.presetLocalId) setSelectedPresetForScheduleCamera(newPresetDialog.scheduleId, newPresetDialog.cameraId, meta.presetLocalId);
                    }
                    setNewPresetDialog(null);
                }
            })
        ]
    });
};

});
parcelRegister("hpMHQ", function(module, exports) {

$parcel$export(module.exports, "useFlexIzScheduleSummary", () => $cc8fdc80c1c3c7fe$export$1c0fdaa009529f2d);

var $8T3gX = parcelRequire("8T3gX");

var $3FJ79 = parcelRequire("3FJ79");

var $eYzFO = parcelRequire("eYzFO");

var $ki0ZH = parcelRequire("ki0ZH");

var $9mFrR = parcelRequire("9mFrR");
function $cc8fdc80c1c3c7fe$export$1c0fdaa009529f2d(siteInfo, options) {
    const { siteSchedules: siteSchedules, schedulesIndex: schedulesIndex } = (0, $3FJ79.useSiteAboutStore)();
    const ldFlexIz = options.showFlexIgnoreZones;
    const siteId = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((state)=>ldFlexIz ? state.siteId : null);
    const wizardSchedules = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((state)=>ldFlexIz ? state.schedules : (0, $9mFrR.FLEX_IZ_LD_EMPTY_SCHEDULES));
    const cameras = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((state)=>ldFlexIz ? state.cameras : (0, $9mFrR.FLEX_IZ_LD_EMPTY_CAMERAS));
    const selectedCameraIdsBySchedule = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((state)=>ldFlexIz ? state.selectedCameraIdsBySchedule : (0, $9mFrR.FLEX_IZ_LD_EMPTY_SELECTED_CAMERAS));
    const selectedPresetByScheduleCamera = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((state)=>ldFlexIz ? state.selectedPresetByScheduleCamera : (0, $9mFrR.FLEX_IZ_LD_EMPTY_PRESET_ASSIGNMENTS));
    const presetsByCamera = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((state)=>ldFlexIz ? state.presetsByCamera : (0, $9mFrR.FLEX_IZ_LD_EMPTY_PRESETS));
    const presetNamesByCamera = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((state)=>ldFlexIz ? state.presetNamesByCamera : (0, $9mFrR.FLEX_IZ_LD_EMPTY_PRESET_NAMES));
    const loadCameraContext = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((state)=>ldFlexIz ? state.loadCameraContext : (0, $9mFrR.flexIgnoreZonesNoopLoadCameraContext));
    const summary = $8T3gX.useMemo(()=>(0, $ki0ZH.buildFlexIzScheduleSummary)({
            showFlexIgnoreZones: options.showFlexIgnoreZones,
            flexScheduleActive: options.flexScheduleActive,
            flexIgnoreZonesEnabled: options.flexIgnoreZonesEnabled,
            siteId: siteId,
            siteInfoId: siteInfo.id,
            siteSchedules: siteSchedules,
            schedulesIndex: schedulesIndex,
            wizardSchedules: wizardSchedules,
            selectedCameraIdsBySchedule: selectedCameraIdsBySchedule,
            selectedPresetByScheduleCamera: selectedPresetByScheduleCamera,
            cameras: cameras,
            presetsByCamera: presetsByCamera,
            presetNamesByCamera: presetNamesByCamera
        }), [
        options.showFlexIgnoreZones,
        options.flexScheduleActive,
        options.flexIgnoreZonesEnabled,
        siteId,
        siteInfo.id,
        siteSchedules,
        schedulesIndex,
        wizardSchedules,
        selectedCameraIdsBySchedule,
        selectedPresetByScheduleCamera,
        cameras,
        presetsByCamera,
        presetNamesByCamera
    ]);
    $8T3gX.useEffect(()=>{
        if (!summary) return;
        summary.rows.forEach((row)=>{
            loadCameraContext(row.cameraId);
        });
    }, [
        summary,
        loadCameraContext
    ]);
    return summary;
}

});
parcelRegister("ki0ZH", function(module, exports) {

$parcel$export(module.exports, "buildFlexIzScheduleSummary", () => $74bfa64908a689a2$export$a92615b67fb8f7a5);

var $6JE7U = parcelRequire("6JE7U");

var $9s9JO = parcelRequire("9s9JO");
const $74bfa64908a689a2$export$4e5c530bebc73379 = (camera)=>({
        localId: (0, $9s9JO.FLEX_IZ_DEFAULT_CAMERA_CONFIG_OPTION),
        cameraId: camera.id,
        name: (0, $9s9JO.FLEX_IZ_DEFAULT_CAMERA_CONFIG_LABEL),
        zones: camera.ignore_zones || [],
        persistedId: null,
        source: "default",
        userNamed: false
    });
const $74bfa64908a689a2$var$serverPresetIdFromLocalId = (localId)=>{
    const match = /^server-(\d+)$/.exec(localId);
    if (!match) return null;
    const id = Number(match[1]);
    return Number.isFinite(id) ? id : null;
};
/**
 * Resolve the preset row to show for a camera under a schedule (ENG-1610):
 * - no / empty / Default selection → "Default" (camera-wide zones and lines);
 * - a selection present in the camera's preset list → that preset;
 * - a `server-<id>` selection missing from the list (e.g. collapsed by
 *   display-name dedupe) → a placeholder carrying the real name from
 *   `GET preset/?camera=` (`presetNamesByCamera`), never `presets[0]`.
 */ const $74bfa64908a689a2$var$resolvePresetForCamera = (camera, resolvedScheduleId, selectedPresetByScheduleCamera, presetsByCamera, presetNamesByCamera)=>{
    const presets = presetsByCamera[camera.id] || [];
    const rawPresetLocalId = selectedPresetByScheduleCamera[`${resolvedScheduleId}:${camera.id}`];
    if (rawPresetLocalId == null || rawPresetLocalId === "" || rawPresetLocalId === (0, $9s9JO.FLEX_IZ_DEFAULT_CAMERA_CONFIG_OPTION)) return $74bfa64908a689a2$export$4e5c530bebc73379(camera);
    const presetLocalId = (0, $6JE7U.normalizeFlexPresetSelectionToApiBackedMenuValue)(camera.id, presets, rawPresetLocalId);
    const found = presets.find((preset)=>preset.localId === presetLocalId) || presets.find((preset)=>preset.localId === rawPresetLocalId);
    if (found) return found;
    const serverPresetId = $74bfa64908a689a2$var$serverPresetIdFromLocalId(rawPresetLocalId);
    if (serverPresetId != null) {
        const realName = presetNamesByCamera[camera.id]?.[serverPresetId];
        return {
            localId: rawPresetLocalId,
            cameraId: camera.id,
            name: realName ?? `Preset #${serverPresetId}`,
            zones: [],
            persistedId: serverPresetId,
            source: "custom",
            userNamed: true
        };
    }
    // A stale local id (discarded draft, wizard `default-*` slot that was never
    // loaded) has nothing real to show; render Default rather than guess.
    return $74bfa64908a689a2$export$4e5c530bebc73379(camera);
};
function $74bfa64908a689a2$export$a92615b67fb8f7a5(params) {
    const { showFlexIgnoreZones: showFlexIgnoreZones, flexScheduleActive: flexScheduleActive, flexIgnoreZonesEnabled: flexIgnoreZonesEnabled, siteId: siteId, siteInfoId: siteInfoId, siteSchedules: siteSchedules, schedulesIndex: schedulesIndex, wizardSchedules: wizardSchedules, selectedCameraIdsBySchedule: selectedCameraIdsBySchedule, selectedPresetByScheduleCamera: selectedPresetByScheduleCamera, cameras: cameras, presetsByCamera: presetsByCamera, presetNamesByCamera: presetNamesByCamera = {} } = params;
    const storeHydratedForSite = siteId != null && siteId === siteInfoId && cameras.length > 0;
    if (!showFlexIgnoreZones || !flexScheduleActive || !flexIgnoreZonesEnabled || !storeHydratedForSite) return null;
    const siteSchedule = siteSchedules[schedulesIndex];
    const wizardSchedule = wizardSchedules[schedulesIndex];
    let resolvedScheduleId;
    if (siteSchedule?.id != null && Number.isFinite(Number(siteSchedule.id))) resolvedScheduleId = Number(siteSchedule.id);
    if (resolvedScheduleId == null && wizardSchedule?.id != null) resolvedScheduleId = Number(wizardSchedule.id);
    if (resolvedScheduleId == null) return null;
    // Flex schedules apply to every camera on the site. Union the live camera
    // list with any previously selected IDs so a camera added after onboarding
    // still appears under Flex Schedule Presets.
    const cameraIds = [];
    const seen = new Set();
    for (const camera of cameras){
        if (!Number.isFinite(camera.id) || seen.has(camera.id)) continue;
        seen.add(camera.id);
        cameraIds.push(camera.id);
    }
    for (const cameraId of selectedCameraIdsBySchedule[resolvedScheduleId] ?? []){
        if (!Number.isFinite(cameraId) || seen.has(cameraId)) continue;
        seen.add(cameraId);
        cameraIds.push(cameraId);
    }
    if (cameraIds.length === 0) return null;
    const rows = [];
    for (const cameraId of cameraIds){
        const camera = cameras.find((candidate)=>candidate.id === cameraId);
        if (!camera) continue;
        rows.push({
            cameraId: cameraId,
            camera: camera,
            preset: $74bfa64908a689a2$var$resolvePresetForCamera(camera, resolvedScheduleId, selectedPresetByScheduleCamera, presetsByCamera, presetNamesByCamera)
        });
    }
    if (rows.length === 0) return null;
    return {
        resolvedScheduleId: resolvedScheduleId,
        rows: rows
    };
}

});




parcelRegister("7isVd", function(module, exports) {

$parcel$export(module.exports, "SMTPTab", () => $4cdae33651d8fe6b$export$91fa97cc40700815);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kusYR = parcelRequire("kusYR");

var $k8Qy8 = parcelRequire("k8Qy8");

var $ha39s = parcelRequire("ha39s");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $4o6Cs = parcelRequire("4o6Cs");

var $oEvrA = parcelRequire("oEvrA");
const $4cdae33651d8fe6b$export$91fa97cc40700815 = ()=>{
    const SMTPInstructions = JSON.parse(localStorage.SMTPInstructions);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "bg-white font-mulish",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "space-y-3 space-x-6",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("h2", {
                        className: "indent-6 font-bold",
                        children: "SMTP Camera Configuration"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("h3", {
                        className: "font-bold",
                        children: "Follow These Directions to Configure Each of your Cameras"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        children: "1. Ensure that Motion Detection is activated on the device. This is usually found under \u201CAnalytics\u201D or a similar option."
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        children: "2. Adjust Motion Detection sensitivity and masking as appropriate."
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        children: "3. Navigate to SMTP/Email settings on the device. This is usually found under \u201CEvent,\u201D \u201CFTP/Email,\u201D \u201CNetwork,\u201D \u201CEmail,\u201D or similar options."
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                        children: [
                            "4. Under Email/SMTP configuration on the device, input the following information:",
                            " ",
                            /*#__PURE__*/ (0, $k4ank.jsxs)("ul", {
                                className: "list-disc list-inside",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("li", {
                                        children: [
                                            "Server address: ",
                                            /*#__PURE__*/ (0, $k4ank.jsx)("strong", {
                                                children: SMTPInstructions.server_address
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("li", {
                                        children: [
                                            "Port: ",
                                            /*#__PURE__*/ (0, $k4ank.jsx)("strong", {
                                                children: SMTPInstructions.server_port
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("h4", {
                                children: "If you can specify a different sender per camera"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)("ol", {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("li", {
                                        children: [
                                            "Subject: ",
                                            /*#__PURE__*/ (0, $k4ank.jsx)("strong", {
                                                children: "Actuate"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("li", {
                                        children: [
                                            "Per camera:",
                                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                                sx: {
                                                    width: 500,
                                                    fontFamily: "Mulish"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    children: "Camera"
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    children: "Sender / Recipient"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                        children: SMTPInstructions.cameras.map((object)=>{
                                                            return /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                                                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                            children: object.camera_name
                                                                        }),
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                            children: object.recipient
                                                                        })
                                                                    ]
                                                                })
                                                            });
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("h4", {
                                children: "If you can specify only one sender for the entire site"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)("ol", {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("li", {
                                        children: [
                                            "Subject: ",
                                            /*#__PURE__*/ (0, $k4ank.jsx)("strong", {
                                                children: "Actuate"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("li", {
                                        children: [
                                            "Sender / Recipient: ",
                                            /*#__PURE__*/ (0, $k4ank.jsx)("strong", {
                                                children: SMTPInstructions.recipient
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                        children: [
                            "5. Leave authentication blank or select \u201Cnone\u201D if it is not required by the device. If it is, please enter:",
                            " ",
                            /*#__PURE__*/ (0, $k4ank.jsxs)("ol", {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("li", {
                                        children: [
                                            "Username: ",
                                            /*#__PURE__*/ (0, $k4ank.jsx)("strong", {
                                                children: "actuate"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("li", {
                                        children: [
                                            "Password: ",
                                            /*#__PURE__*/ (0, $k4ank.jsx)("strong", {
                                                children: "actuate"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                        children: [
                            "6. If there is an option to \u201Cinclude attachment,\u201D select that option.",
                            " ",
                            /*#__PURE__*/ (0, $k4ank.jsx)("ol", {
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)("li", {
                                    children: [
                                        "NOTE: Clicking \u201CTEST\u201D on the Email/SMTP page may not work at this time. If you're having issues come back and click \u201CTEST\u201D once you",
                                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                        "have fully created the site within Actuate to ensure the device is working with Actuate."
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                        children: [
                            " ",
                            "7. Go into Event Setup or similar on your device, and ensure that motion detection is selected, and that it routes alerts to \u201CEmail\u201D or SMTP\u201D",
                            " ",
                            /*#__PURE__*/ (0, $k4ank.jsx)("ol", {
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)("li", {
                                    children: [
                                        "Here is an example of what that looks like on a Wisenet camera:",
                                        /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($kusYR))),
                                            alt: "Wisenet SMTP"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                        children: [
                            "Now SMTP setup is complete. Send a test message or wait a few minutes to confirm that images are being sent to Actuate and validate",
                            " ",
                            /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                            "that on the \u201CCustomer Sites\u201D page."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $oEvrA.SMTPFilenameDistribution), {})
        ]
    });
};

});
parcelRegister("kusYR", function(module, exports) {
module.exports = import.meta.resolve("3Q7an");

});

parcelRegister("oEvrA", function(module, exports) {

$parcel$export(module.exports, "SMTPFilenameDistribution", () => $1187043db95f17cc$export$b228c02747d8f6c6);
/*
 * SMTP Filename Distribution helper
 * ---------------------------------
 * Customer-facing, self-service tool for site-level SMTP integrations.
 *
 * When every camera at a site emails us from a single site address, the only
 * way to tell the cameras apart is the attachment FILENAME. The backend
 * (frame_receiver_smtp_v2) runs a regular expression against each filename and
 * uses the FIRST capture group as the camera name:
 *
 *     re.search(read_filename_expression, filename).groups()[0]
 *
 * That extracted string must match a camera name registered at the site exactly,
 * or the frame is dropped as UNIDENTIFIED_CAMERA. Support currently sets this up
 * by hand: they read the smtp-frame-receiver logs to find the real filename
 * format, tweak the expression, and confirm it lands on a real camera name.
 * This component automates all three steps so customers can self-serve:
 *   1. surfaces the filenames we've actually received for this site,
 *   2. lets them build/test the expression with live extraction, and
 *   3. validates the extracted value against the site's real camera names.
 *
 * Fields saved (on the `customer` object, via PATCH customer/{id}/):
 *   - read_filename            (bool)  – master on/off
 *   - read_filename_expression (regex) – the pattern
 *
 * NOTE FOR FRONTEND REVIEW: styling here is functional and uses Tailwind + MUI
 * to stay close to the existing SMTP tab, but it has NOT been reconciled with
 * the app's component library / spacing system. Please align to current styling
 * before this ships to customers.
 *
 * BACKEND DEPENDENCY (not in this repo): the "recent filenames" list is fetched
 * from GET customer/{id}/smtp_filenames/, which does not exist yet. It needs to
 * be added to actuate_admin, querying New Relic logs for this site. Contract and
 * suggested NRQL are in the PR description. Until it exists, this component
 * degrades gracefully: the recent-filenames panel shows an explanation and the
 * "test a filename" box still works for manual entry.
 */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $ddLR4 = parcelRequire("ddLR4");

var $eejVe = parcelRequire("eejVe");

var $a65wX = parcelRequire("a65wX");

var $60vL1 = parcelRequire("60vL1");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $1187043db95f17cc$var$PRESETS = [
    {
        label: "Channel + underscore",
        expression: "^(ch\\d+)_"
    },
    {
        label: "Text before first _",
        expression: "^([^_]+)_"
    },
    {
        label: "Text before the date",
        expression: "^(.+?)_\\d{8}"
    },
    {
        label: "Whole name, without extension",
        expression: "^(.+)\\.[a-z0-9]+$"
    }
];
/** The camera/site response is either a bare array or a paginated { results: [...] } wrapper. */ const $1187043db95f17cc$var$extractCamerasArray = (parsed)=>{
    if (Array.isArray(parsed)) return parsed;
    if (Array.isArray(parsed?.results)) return parsed.results;
    return null;
};
/** localStorage.siteCameras holds the paginated camera/site response ({ results: [...] }), not a bare array. */ const $1187043db95f17cc$var$getSiteCamerasArray = ()=>{
    try {
        const parsed = JSON.parse(localStorage.siteCameras || "[]");
        return $1187043db95f17cc$var$extractCamerasArray(parsed) ?? [];
    } catch  {
        return [];
    }
};
/** Read the site's registered camera names from localStorage (set by camera/site fetch). */ const $1187043db95f17cc$var$getSiteCameraNames = ()=>{
    const cameras = $1187043db95f17cc$var$getSiteCamerasArray();
    return cameras.map((camera)=>camera?.camera_name).filter((name)=>Boolean(name));
};
/** Seed the current saved values from the camera list customer object, if present. */ const $1187043db95f17cc$var$getSavedExpressionSeed = ()=>{
    const cameras = $1187043db95f17cc$var$getSiteCamerasArray();
    const customer = cameras?.find((camera)=>camera.customer)?.customer;
    return {
        read_filename: Boolean(customer?.read_filename),
        read_filename_expression: customer?.read_filename_expression || ""
    };
};
const $1187043db95f17cc$var$getSiteInfo = ()=>{
    try {
        const siteInfo = JSON.parse(localStorage.siteInfo || "{}");
        return {
            id: siteInfo?.id ?? null,
            name: siteInfo?.name || "this site"
        };
    } catch  {
        return {
            id: null,
            name: "this site"
        };
    }
};
const $1187043db95f17cc$export$b228c02747d8f6c6 = ()=>{
    const navigate = (0, $3T949.useNavigate)();
    const site = (0, $8T3gX.useMemo)($1187043db95f17cc$var$getSiteInfo, []);
    const cameraNames = (0, $8T3gX.useMemo)($1187043db95f17cc$var$getSiteCameraNames, []);
    const cameraNameSet = (0, $8T3gX.useMemo)(()=>new Set(cameraNames), [
        cameraNames
    ]);
    const seed = (0, $8T3gX.useMemo)($1187043db95f17cc$var$getSavedExpressionSeed, []);
    const [enabled, setEnabled] = (0, $8T3gX.useState)(seed.read_filename);
    const [expression, setExpression] = (0, $8T3gX.useState)(seed.read_filename_expression);
    const [samples, setSamples] = (0, $8T3gX.useState)([]);
    const [loadingSamples, setLoadingSamples] = (0, $8T3gX.useState)(true);
    const [samplesError, setSamplesError] = (0, $8T3gX.useState)(false);
    const [manualSamples, setManualSamples] = (0, $8T3gX.useState)([]);
    const [manualInput, setManualInput] = (0, $8T3gX.useState)("");
    const [saving, setSaving] = (0, $8T3gX.useState)(false);
    const [saved, setSaved] = (0, $8T3gX.useState)(false);
    const [suggestedExpression, setSuggestedExpression] = (0, $8T3gX.useState)("");
    // Fetch the filenames we've actually received for this site.
    (0, $8T3gX.useEffect)(()=>{
        setSuggestedExpression("");
        if (site.id == null) {
            setLoadingSamples(false);
            setSamplesError(true);
            return;
        }
        let cancelled = false;
        const AxiosUI = (0, $195EM.createApi)(``);
        AxiosUI.get(`customer/${site.id}/smtp_filenames/`).then((response)=>{
            if (cancelled) return;
            const data = response.data || {};
            setSamples(Array.isArray(data.samples) ? data.samples : []);
            // Prefer the authoritative saved values from the endpoint when present.
            if (typeof data.read_filename === "boolean") setEnabled(data.read_filename);
            if (typeof data.read_filename_expression === "string") setExpression(data.read_filename_expression);
            if (typeof data.suggested_expression === "string" && data.suggested_expression) {
                setSuggestedExpression(data.suggested_expression);
                // Prefill only when no rule is saved or typed yet.
                if (typeof data.read_filename_expression !== "string" || !data.read_filename_expression) setExpression((previous)=>previous || data.suggested_expression);
            }
            setLoadingSamples(false);
        }, ()=>{
            if (cancelled) return;
            // Graceful degradation: endpoint not available yet. Manual testing still works.
            setSamplesError(true);
            setLoadingSamples(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        site.id
    ]);
    const sampleByFilename = (0, $8T3gX.useMemo)(()=>{
        const map = new Map();
        samples.forEach((sample)=>map.set(sample.filename, sample));
        return map;
    }, [
        samples
    ]);
    const nearestCamera = (extracted)=>{
        const lower = extracted.toLowerCase();
        const collapse = (value)=>value.toLowerCase().replace(/[\s_-]/g, "");
        for (const name of cameraNames){
            if (name.toLowerCase() === lower) return name;
        }
        for (const name of cameraNames){
            if (collapse(name) === collapse(extracted)) return name;
        }
        return null;
    };
    // Compile once per keystroke; "d" flag gives capture-group indices for highlighting.
    const compiled = (0, $8T3gX.useMemo)(()=>{
        if (!expression) return {
            regex: null,
            error: null
        };
        try {
            return {
                regex: new RegExp(expression, "d"),
                error: null
            };
        } catch (error) {
            return {
                regex: null,
                error: error.message
            };
        }
    }, [
        expression
    ]);
    const evaluate = (filename)=>{
        const sample = sampleByFilename.get(filename);
        const suggestion = sample?.suggested_camera_name && sample?.suggested_matches_existing_camera_id != null ? sample.suggested_camera_name : null;
        if (compiled.error || !compiled.regex) return {
            filename: filename,
            extracted: null,
            span: null,
            state: "invalid",
            nearest: null,
            suggestion: null
        };
        const match = compiled.regex.exec(filename);
        if (!match || match[1] === undefined) return {
            filename: filename,
            extracted: null,
            span: null,
            state: "nomatch",
            nearest: null,
            suggestion: suggestion
        };
        const extracted = match[1];
        // indices is available with the "d" flag on modern browsers.
        const indices = match.indices;
        const span = indices && indices[1] ? indices[1] : null;
        if (cameraNameSet.has(extracted)) return {
            filename: filename,
            extracted: extracted,
            span: span,
            state: "ok",
            nearest: null,
            suggestion: null
        };
        // No cached camera list to validate against, so fall back to the backend's
        // own match — server-confirmed only, not cross-checked against the local roster.
        if (cameraNameSet.size === 0 && sample?.extracted_matches_existing_camera_id != null && sample?.extracted_camera_name === extracted) return {
            filename: filename,
            extracted: extracted,
            span: span,
            state: "ok",
            nearest: null,
            suggestion: null
        };
        return {
            filename: filename,
            extracted: extracted,
            span: span,
            state: "unknown",
            nearest: nearestCamera(extracted),
            suggestion: suggestion
        };
    };
    const testFilenames = (0, $8T3gX.useMemo)(()=>{
        const fromSamples = samples.map((sample)=>sample.filename);
        // manual entries first so they're easy to see, then de-dupe.
        return Array.from(new Set([
            ...manualSamples,
            ...fromSamples
        ]));
    }, [
        samples,
        manualSamples
    ]);
    const rows = (0, $8T3gX.useMemo)(()=>testFilenames.map(evaluate), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        testFilenames,
        compiled,
        cameraNameSet,
        sampleByFilename
    ]);
    const expressionChips = (0, $8T3gX.useMemo)(()=>{
        if (!suggestedExpression) return $1187043db95f17cc$var$PRESETS;
        return [
            {
                label: "Suggested for this site",
                expression: suggestedExpression
            },
            ...$1187043db95f17cc$var$PRESETS.filter((preset)=>preset.expression !== suggestedExpression)
        ];
    }, [
        suggestedExpression
    ]);
    const counts = (0, $8T3gX.useMemo)(()=>{
        let ok = 0;
        let unknown = 0;
        let unmatched = 0;
        rows.forEach((row)=>{
            if (row.state === "ok") ok += 1;
            else if (row.state === "unknown") unknown += 1;
            else unmatched += 1;
        });
        return {
            ok: ok,
            unknown: unknown,
            unmatched: unmatched,
            total: rows.length
        };
    }, [
        rows
    ]);
    const addManualFilename = ()=>{
        const value = manualInput.trim();
        if (!value) return;
        setManualSamples((previous)=>[
                value,
                ...previous
            ]);
        setManualInput("");
    };
    const handleSave = ()=>{
        if (site.id == null || compiled.error) return;
        setSaving(true);
        setSaved(false);
        const AxiosUI = (0, $195EM.createApi)(``);
        const patchBody = {
            read_filename: enabled,
            read_filename_expression: enabled ? expression : ""
        };
        const retryFunction = ()=>handleSave();
        AxiosUI.patch(`customer/${site.id}/`, patchBody).then(()=>{
            setSaving(false);
            setSaved(true);
            // best-effort: keep the cached camera list in sync so a re-open reflects the save.
            try {
                const parsed = JSON.parse(localStorage.siteCameras || "[]");
                const cameras = $1187043db95f17cc$var$extractCamerasArray(parsed);
                if (cameras?.some((camera)=>camera.customer)) {
                    cameras.forEach((camera)=>{
                        if (camera.customer) {
                            camera.customer.read_filename = patchBody.read_filename;
                            camera.customer.read_filename_expression = patchBody.read_filename_expression;
                        }
                    });
                    const container = Array.isArray(parsed) ? cameras : {
                        ...parsed,
                        results: cameras
                    };
                    localStorage.setItem("siteCameras", JSON.stringify(container));
                }
            } catch  {
            // ignore cache-sync failures
            }
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                setSaving(false);
                alert("Could not save the filename rule. Please try again.");
            });
        });
    };
    const highlightFilename = (filename, span)=>{
        if (!span) return filename;
        const [start, end] = span;
        return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
            children: [
                filename.slice(0, start),
                /*#__PURE__*/ (0, $k4ank.jsx)("mark", {
                    className: "bg-actuate-orange/20 rounded-sm px-0.5 font-bold text-actuate-blue",
                    children: filename.slice(start, end)
                }),
                filename.slice(end)
            ]
        });
    };
    const statusLabel = (row)=>{
        if (row.state === "ok") return /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
            className: "text-green-700",
            children: [
                "\u2713 Matches ",
                row.extracted
            ]
        });
        if (row.state === "unknown") return /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
            className: "text-yellow-700",
            children: [
                "\u26A0 No camera named \u201C",
                row.extracted,
                "\u201D",
                row.nearest ? ` \u{2014} did you mean ${row.nearest}?` : " at this site",
                row.suggestion && row.suggestion !== row.extracted ? /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                    className: "text-gray-500",
                    children: [
                        " ",
                        "\u2014 the suggested rule reads \u201C",
                        row.suggestion,
                        "\u201D"
                    ]
                }) : null
            ]
        });
        if (row.state === "invalid") return /*#__PURE__*/ (0, $k4ank.jsx)("span", {
            className: "text-red-700",
            children: "Fix the rule"
        });
        return /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
            className: "text-red-700",
            children: [
                "\u2717 No camera identified",
                row.suggestion ? /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                    className: "text-gray-500",
                    children: [
                        " ",
                        "\u2014 the suggested rule reads \u201C",
                        row.suggestion,
                        "\u201D"
                    ]
                }) : null
            ]
        });
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "mx-6 mt-8 pb-6 border-t border-gray-200 pt-6 font-mulish",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("h3", {
                className: "font-bold text-lg text-actuate-blue",
                children: "Reading camera names from email filenames"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                className: "mt-2 max-w-2xl text-sm text-gray-600",
                children: [
                    "If all of your cameras email us from a single site address, we use each image\u2019s ",
                    /*#__PURE__*/ (0, $k4ank.jsx)("strong", {
                        children: "filename"
                    }),
                    " to tell which camera it came from. Set a rule that pulls the camera name out of the filename, then check it against filenames we\u2019ve actually received. The highlighted part is what we\u2019ll use as the camera name \u2014 it must match one of your cameras exactly."
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "mt-4 flex items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                        checked: enabled,
                        onChange: (event)=>{
                            setEnabled(event.target.checked);
                            setSaved(false);
                        }
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "font-bold text-sm",
                                children: "Identify cameras from the filename"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "text-xs text-gray-500",
                                children: "When off, images from this site arrive unlabeled and can\u2019t be routed to a camera."
                            })
                        ]
                    })
                ]
            }),
            enabled && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "mt-5",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "block text-xs font-bold uppercase tracking-wide text-gray-500",
                        children: "Filename rule"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        fullWidth: true,
                        value: expression,
                        onChange: (event)=>{
                            setExpression(event.target.value);
                            setSaved(false);
                        },
                        error: Boolean(compiled.error),
                        helperText: compiled.error ? `That's not a valid pattern yet: ${compiled.error}` : "The text captured by the first ( ) group becomes the camera name.",
                        placeholder: "e.g. ^(ch\\\\d+)_",
                        inputProps: {
                            style: {
                                fontFamily: "monospace"
                            },
                            spellCheck: false
                        },
                        sx: {
                            mt: 1,
                            maxWidth: 520
                        },
                        size: "small"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "mt-2 flex flex-wrap gap-2",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                className: "text-xs text-gray-500 self-center",
                                children: "Not sure? Start from:"
                            }),
                            expressionChips.map((chip)=>{
                                const isSuggested = chip.expression === suggestedExpression;
                                const isSelected = expression === chip.expression;
                                return /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
                                    type: "button",
                                    onClick: ()=>{
                                        setExpression(chip.expression);
                                        setSaved(false);
                                    },
                                    className: `rounded-full border px-3 py-1 text-xs font-mono transition ${isSelected ? "border-actuate-blue bg-actuate-blue/10 text-actuate-blue" : isSuggested ? "border-actuate-orange text-actuate-orange hover:border-actuate-blue" : "border-gray-300 text-gray-600 hover:border-actuate-blue"}`,
                                    title: chip.expression,
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                            className: "font-mulish font-bold mr-2",
                                            children: chip.label
                                        }),
                                        chip.expression
                                    ]
                                }, chip.expression);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "mt-5 flex gap-6 rounded-lg border border-gray-200 p-3 text-center",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "flex-1",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "text-2xl font-bold text-green-700",
                                        children: [
                                            counts.ok,
                                            /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                                                className: "text-sm font-semibold text-gray-400",
                                                children: [
                                                    "/",
                                                    counts.total
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "text-xs text-gray-500",
                                        children: "route to a camera"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "flex-1",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: `text-2xl font-bold ${counts.unknown ? "text-yellow-700" : "text-gray-400"}`,
                                        children: counts.unknown
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "text-xs text-gray-500",
                                        children: "unknown camera name"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "flex-1",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: `text-2xl font-bold ${counts.unmatched ? "text-red-700" : "text-gray-400"}`,
                                        children: counts.unmatched
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "text-xs text-gray-500",
                                        children: "no name found"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "mt-5",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "flex items-baseline justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "block text-xs font-bold uppercase tracking-wide text-gray-500",
                                        children: "Recent filenames received"
                                    }),
                                    !loadingSamples && !samplesError && /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                        className: "text-xs text-gray-400",
                                        children: "Last seen by the mail receiver"
                                    })
                                ]
                            }),
                            loadingSamples && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "mt-3 flex items-center gap-2 text-sm text-gray-500",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                        size: 16
                                    }),
                                    " Looking up recent filenames\u2026"
                                ]
                            }),
                            samplesError && !loadingSamples && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "mt-2 rounded-md bg-gray-50 p-3 text-sm text-gray-600",
                                children: "We couldn\u2019t load recent filenames for this site right now. You can still paste a filename below to test your rule."
                            }),
                            !loadingSamples && !samplesError && samples.length === 0 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "mt-2 rounded-md bg-gray-50 p-3 text-sm text-gray-600",
                                children: "No recent filenames received yet. Once your cameras start emailing us, they\u2019ll appear here. You can paste a filename below to test your rule in the meantime."
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "mt-3 flex gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        value: manualInput,
                                        onChange: (event)=>setManualInput(event.target.value),
                                        onKeyDown: (event)=>{
                                            if (event.key === "Enter") addManualFilename();
                                        },
                                        placeholder: "Paste a filename to test, e.g. ch03_20260713_2227_E.jpg",
                                        size: "small",
                                        sx: {
                                            flex: 1,
                                            maxWidth: 520
                                        },
                                        inputProps: {
                                            style: {
                                                fontFamily: "monospace"
                                            }
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                        variant: "outlined",
                                        onClick: addManualFilename,
                                        children: "Test"
                                    })
                                ]
                            }),
                            rows.length > 0 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "mt-3 overflow-x-auto rounded-lg border border-gray-200",
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)("table", {
                                    className: "w-full text-sm",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("thead", {
                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)("tr", {
                                                className: "bg-gray-50 text-left text-xs uppercase tracking-wide text-gray-500",
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("th", {
                                                        className: "px-3 py-2 font-bold",
                                                        children: "Filename received"
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("th", {
                                                        className: "px-3 py-2 font-bold",
                                                        children: "Camera name we\u2019d read"
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("th", {
                                                        className: "px-3 py-2 font-bold",
                                                        children: "Match"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("tbody", {
                                            children: rows.map((row, index)=>/*#__PURE__*/ (0, $k4ank.jsxs)("tr", {
                                                    className: "border-t border-gray-100",
                                                    children: [
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("td", {
                                                            className: "px-3 py-2 font-mono text-xs text-gray-600 break-all",
                                                            children: highlightFilename(row.filename, row.span)
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("td", {
                                                            className: "px-3 py-2 font-mono text-xs font-bold",
                                                            children: row.extracted ?? /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                                className: "font-sans font-normal italic text-gray-400",
                                                                children: "nothing matched"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("td", {
                                                            className: "px-3 py-2 text-xs font-semibold",
                                                            children: statusLabel(row)
                                                        })
                                                    ]
                                                }, `${row.filename}-${index}`))
                                        })
                                    ]
                                })
                            }),
                            cameraNames.length > 0 && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "mt-4",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "text-xs font-bold uppercase tracking-wide text-gray-500",
                                        children: "Cameras registered at this site"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "mt-1 flex flex-wrap gap-1.5",
                                        children: cameraNames.map((name)=>/*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                className: "rounded border border-gray-200 bg-gray-50 px-2 py-0.5 font-mono text-xs text-gray-600",
                                                children: name
                                            }, name))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "mt-6 flex items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                        variant: "contained",
                        onClick: handleSave,
                        disabled: saving || Boolean(compiled.error) || site.id == null,
                        sx: {
                            backgroundColor: "#FF8400",
                            "&:hover": {
                                backgroundColor: "#e67700"
                            }
                        },
                        children: saving ? "Saving\u2026" : "Save rule"
                    }),
                    saved && /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                        className: "text-sm text-green-700",
                        children: "Saved."
                    }),
                    enabled && !compiled.error && counts.total > 0 && counts.ok < counts.total && /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                        className: "text-sm text-gray-500",
                        children: [
                            counts.total - counts.ok,
                            " recent filename",
                            counts.total - counts.ok > 1 ? "s" : "",
                            " won\u2019t route yet."
                        ]
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("4ajRU", function(module, exports) {

$parcel$export(module.exports, "RecordingServerTab", () => $214a80c41b305517$export$59167bd681b7027c);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");
const $214a80c41b305517$export$59167bd681b7027c = ({ recordingServerData: recordingServerData })=>{
    const titlesArray = [
        "Name",
        "Server IP",
        "Camera Count"
    ];
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        sx: {
            width: "screen"
        },
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
            sx: {
                postion: "absolute",
                width: "screen",
                fontFamily: "Mulish"
            },
            "aria-label": "simple table",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                    titlesArray: titlesArray
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                    children: recordingServerData.map((row)=>{
                        return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: row.name
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: row.server_ip
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: row.cameras
                                })
                            ]
                        }, row.id);
                    })
                })
            ]
        })
    });
};

});

parcelRegister("ivt1T", function(module, exports) {

$parcel$export(module.exports, "RecordingServerTabEditMode", () => $cf3911a8da792005$export$1e4f0bf3c35d1c1d);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $eejVe = parcelRequire("eejVe");
const $cf3911a8da792005$export$1e4f0bf3c35d1c1d = ({ recordingServerData: recordingServerData, recordingServerPatchObject: recordingServerPatchObject, setRecordingServerPatchObject: setRecordingServerPatchObject, setRecordingServerChangesMade: setRecordingServerChangesMade })=>{
    const titlesArray = [
        "Name",
        "Server IP",
        "Camera Count"
    ];
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        sx: {
            width: "screen"
        },
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
            sx: {
                postion: "absolute",
                width: "screen",
                fontFamily: "Mulish"
            },
            "aria-label": "simple table",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                    titlesArray: titlesArray
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                    children: recordingServerPatchObject.map((row, index)=>{
                        return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        id: row.name,
                                        defaultValue: row.name,
                                        variant: "standard",
                                        sx: {
                                            width: 200
                                        },
                                        type: "string",
                                        onChange: (event)=>{
                                            const newRecordingServerPatchObject = recordingServerPatchObject;
                                            newRecordingServerPatchObject[index].name = event.target.value;
                                            setRecordingServerPatchObject(newRecordingServerPatchObject);
                                            setRecordingServerChangesMade(true);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        id: row.server_ip,
                                        defaultValue: row.server_ip,
                                        variant: "standard",
                                        sx: {
                                            width: 200
                                        },
                                        type: "string",
                                        onChange: (event)=>{
                                            const newRecordingServerPatchObject = recordingServerPatchObject;
                                            newRecordingServerPatchObject[index].server_ip = event.target.value;
                                            setRecordingServerPatchObject(newRecordingServerPatchObject);
                                            setRecordingServerChangesMade(true);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: row.cameras
                                })
                            ]
                        }, row.id);
                    })
                })
            ]
        })
    });
};

});

parcelRegister("islbW", function(module, exports) {

$parcel$export(module.exports, "CameraHealthTab", () => $e7b7a7851276a117$export$582efee6842d3926);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $kbChx = parcelRequire("kbChx");
var $3baw3 = parcelRequire("3baw3");
var $ddLR4 = parcelRequire("ddLR4");
var $ha39s = parcelRequire("ha39s");
var $cVCJe = parcelRequire("cVCJe");

var $2SHRA = parcelRequire("2SHRA");

var $3FJ79 = parcelRequire("3FJ79");

var $31W4Z = parcelRequire("31W4Z");

var $2aMB5 = parcelRequire("2aMB5");

var $ePwXE = parcelRequire("ePwXE");

var $bqbzv = parcelRequire("bqbzv");

var $5uHpU = parcelRequire("5uHpU");
const $e7b7a7851276a117$var$capitalizeWords = (str)=>{
    return str.replace(/\b\w/g, (char)=>char.toUpperCase());
};
const $e7b7a7851276a117$export$582efee6842d3926 = ({ healthCheckData: healthCheckData, siteInfo: siteInfo })=>{
    const titlesArray = [
        "Camera Health Monitoring On",
        "Reports enabled",
        "Report Cadence",
        "Sensitivity",
        "Cadence"
    ];
    const titlesArray2 = [
        "All Metric Notifications",
        "All Metric Emails",
        "Report emails",
        "Cell Numbers",
        ""
    ];
    const { healthCheckMetricsData: healthCheckMetricsData } = (0, $3FJ79.useSiteAboutStore)();
    // If integration type is autopatrol, render the autopatrol component
    if (siteInfo.integration_type_name === "autopatrol") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $31W4Z.CameraHealthTabAutopatrol), {
        healthCheckData: healthCheckData
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3Nm8Z.default), {
            component: (0, $4reBM.default),
            sx: {
                width: "screen"
            },
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $k8Qy8.default), {
                    sx: {
                        postion: "absolute",
                        width: "screen",
                        fontFamily: "Mulish"
                    },
                    children: healthCheckData.deployment === 0 ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $ha39s.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: "Camera Health Monitoring On"
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: {
                                            fontFamily: "Mulish"
                                        },
                                        children: siteInfo.integration_type_name === "autopatrol" ? (0, $2aMB5.cancelIconRed) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                            checked: false,
                                            disabled: true,
                                            color: "warning"
                                        })
                                    })
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                        titlesArray: titlesArray
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    sx: {
                                                        fontFamily: "Mulish"
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                        checked: healthCheckData.deployment === 3,
                                                        disabled: true,
                                                        color: "warning"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    sx: {
                                                        fontFamily: "Mulish"
                                                    },
                                                    children: healthCheckData.report_emails_enabled ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                        defaultChecked: true,
                                                        disabled: true,
                                                        color: "warning"
                                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                        checked: false,
                                                        disabled: true,
                                                        color: "warning"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    sx: {
                                                        fontFamily: "Mulish"
                                                    },
                                                    children: (0, $5uHpU.formatReportCadenceForDisplay)(healthCheckData.report_cadence)
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    sx: {
                                                        fontFamily: "Mulish"
                                                    },
                                                    children: $e7b7a7851276a117$var$capitalizeWords(healthCheckData.sensitivity_level)
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    sx: {
                                                        fontFamily: "Mulish"
                                                    },
                                                    children: (0, $bqbzv.formatCadenceForDisplay)(healthCheckData.cadence)
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                        titlesArray: titlesArray2
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    sx: {
                                                        fontFamily: "Mulish"
                                                    },
                                                    children: healthCheckData.alert_emails_enabled ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                        defaultChecked: true,
                                                        disabled: true,
                                                        color: "warning"
                                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                        checked: false,
                                                        disabled: true,
                                                        color: "warning"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    component: "th",
                                                    scope: "row",
                                                    sx: {
                                                        fontFamily: "Mulish",
                                                        maxWidth: "300px",
                                                        overflow: "hidden",
                                                        wordWrap: "break-word",
                                                        wordBreak: "break-word"
                                                    },
                                                    children: healthCheckData.alert_emails
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    component: "th",
                                                    scope: "row",
                                                    sx: {
                                                        fontFamily: "Mulish",
                                                        maxWidth: "300px",
                                                        overflow: "hidden",
                                                        wordWrap: "break-word",
                                                        wordBreak: "break-word"
                                                    },
                                                    children: healthCheckData.report_emails
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    children: healthCheckData.cell_numbers
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {})
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                healthCheckData.deployment !== 0 && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                    sx: {
                        postion: "absolute",
                        width: "screen",
                        fontFamily: "Mulish"
                    },
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: {
                                            fontFamily: "Mulish",
                                            fontWeight: "Bold"
                                        },
                                        children: [
                                            "Health Metrics \xa0 \xa0",
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                title: "Select metrics in addition to connectivity to monitor. Use fields below to send instant alerts for specific metrics to different recipients.",
                                                placement: "top",
                                                sx: {
                                                    fontSize: "15px",
                                                    fontFamily: "mulish"
                                                },
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                                    fontSize: "small"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {}),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {}),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {})
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $2SHRA.default), {
                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                className: "flex",
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                            checked: healthCheckMetricsData.scene_change_check.enabled && healthCheckMetricsData.motion_status_check.enabled && healthCheckMetricsData.recording_check.enabled && healthCheckMetricsData.stream_quality_check.enabled,
                                                            disabled: true,
                                                            name: "all_metrics"
                                                        }),
                                                        label: "All Metrics"
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                        sx: {
                                                            marginLeft: "20px"
                                                        },
                                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                            checked: healthCheckMetricsData.scene_change_check.enabled,
                                                            disabled: true,
                                                            name: "scene_change_check"
                                                        }),
                                                        label: "Scene Change"
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                        sx: {
                                                            marginLeft: "20px"
                                                        },
                                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                            checked: healthCheckMetricsData.motion_status_check.enabled,
                                                            disabled: true,
                                                            name: "motion_status_check"
                                                        }),
                                                        label: "Motion Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                        sx: {
                                                            marginLeft: "20px"
                                                        },
                                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                            checked: healthCheckMetricsData.recording_check.enabled,
                                                            disabled: true,
                                                            name: "recording_check"
                                                        }),
                                                        label: "Recording Status"
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                        sx: {
                                                            marginLeft: "20px"
                                                        },
                                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                            checked: healthCheckMetricsData.stream_quality_check.enabled,
                                                            disabled: true,
                                                            name: "stream_quality_check"
                                                        }),
                                                        label: "Stream Quality"
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                        sx: {
                                                            marginLeft: "20px"
                                                        },
                                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                            checked: healthCheckMetricsData.image_quality_check.enabled,
                                                            disabled: true,
                                                            name: "image_quality_check"
                                                        }),
                                                        label: "Image Quality"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {}),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {}),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {})
                                ]
                            })
                        })
                    ]
                }),
                healthCheckData.deployment !== 0 && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                    sx: {
                        postion: "absolute",
                        width: "screen",
                        fontFamily: "Mulish"
                    },
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                            titlesArray: [
                                "Scene Change Emails",
                                "Motion Status Emails",
                                "Recording Status Emails",
                                "Stream Quality Emails"
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        component: "th",
                                        scope: "row",
                                        sx: {
                                            fontFamily: "Mulish",
                                            maxWidth: "300px",
                                            overflow: "hidden",
                                            wordWrap: "break-word",
                                            wordBreak: "break-word"
                                        },
                                        children: healthCheckMetricsData.scene_change_check.alert_emails ? healthCheckMetricsData.scene_change_check.alert_emails : ""
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        component: "th",
                                        scope: "row",
                                        sx: {
                                            fontFamily: "Mulish",
                                            maxWidth: "300px",
                                            overflow: "hidden",
                                            wordWrap: "break-word",
                                            wordBreak: "break-word"
                                        },
                                        children: healthCheckMetricsData.motion_status_check.alert_emails ? healthCheckMetricsData.motion_status_check.alert_emails : ""
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        component: "th",
                                        scope: "row",
                                        sx: {
                                            fontFamily: "Mulish",
                                            maxWidth: "300px",
                                            overflow: "hidden",
                                            wordWrap: "break-word",
                                            wordBreak: "break-word"
                                        },
                                        children: healthCheckMetricsData.recording_check.alert_emails ? healthCheckMetricsData.recording_check.alert_emails : ""
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        component: "th",
                                        scope: "row",
                                        sx: {
                                            fontFamily: "Mulish",
                                            maxWidth: "300px",
                                            overflow: "hidden",
                                            wordWrap: "break-word",
                                            wordBreak: "break-word"
                                        },
                                        children: healthCheckMetricsData.stream_quality_check.alert_emails ? healthCheckMetricsData.stream_quality_check.alert_emails : ""
                                    })
                                ]
                            })
                        })
                    ]
                }),
                healthCheckData.deployment !== 0 && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                    sx: {
                        postion: "absolute",
                        width: "screen",
                        fontFamily: "Mulish"
                    },
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                            titlesArray: [
                                "Image Quality Emails",
                                "Connectivity Status Emails"
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        component: "th",
                                        scope: "row",
                                        sx: {
                                            fontFamily: "Mulish",
                                            maxWidth: "300px",
                                            overflow: "hidden",
                                            wordWrap: "break-word",
                                            wordBreak: "break-word"
                                        },
                                        children: healthCheckMetricsData.image_quality_check.alert_emails ? healthCheckMetricsData.image_quality_check.alert_emails : ""
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        component: "th",
                                        scope: "row",
                                        sx: {
                                            fontFamily: "Mulish",
                                            maxWidth: "300px",
                                            overflow: "hidden",
                                            wordWrap: "break-word",
                                            wordBreak: "break-word"
                                        },
                                        children: healthCheckMetricsData.connectivity_check.alert_emails ? healthCheckMetricsData.connectivity_check.alert_emails : ""
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("31W4Z", function(module, exports) {

$parcel$export(module.exports, "CameraHealthTabAutopatrol", () => $253880817e5873b2$export$d925da97fbe4f7c2);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $kbChx = parcelRequire("kbChx");
var $3baw3 = parcelRequire("3baw3");
var $ha39s = parcelRequire("ha39s");

var $2SHRA = parcelRequire("2SHRA");

var $3FJ79 = parcelRequire("3FJ79");

var $2aMB5 = parcelRequire("2aMB5");

var $lWchQ = parcelRequire("lWchQ");
const $253880817e5873b2$var$capitalizeWords = (str)=>{
    return str.replace(/\b\w/g, (char)=>char.toUpperCase());
};
const $253880817e5873b2$export$d925da97fbe4f7c2 = ({ healthCheckData: healthCheckData })=>{
    const titlesArray = [
        "Camera Health Monitoring On",
        "Sensitivity",
        "Health Metrics"
    ];
    const { healthCheckMetricsData: healthCheckMetricsData } = (0, $3FJ79.useSiteAboutStore)();
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
            component: (0, $4reBM.default),
            sx: {
                width: "screen"
            },
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k8Qy8.default), {
                sx: {
                    postion: "absolute",
                    width: "screen",
                    fontFamily: "Mulish"
                },
                children: healthCheckData.deployment === 0 ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $ha39s.default), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: "Camera Health Monitoring On"
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: (0, $2aMB5.cancelIconRed)
                                })
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                titlesArray: titlesArray
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            children: healthCheckData.deployment === 3 ? (0, $lWchQ.checkedCircleIcon) : (0, $2aMB5.cancelIconRed)
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            children: $253880817e5873b2$var$capitalizeWords(healthCheckData.sensitivity_level)
                                        }),
                                        healthCheckData.deployment !== 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $2SHRA.default), {
                                                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                    className: "flex",
                                                    children: [
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                            control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                                checked: healthCheckMetricsData.scene_change_check.enabled && healthCheckMetricsData.motion_status_check.enabled && healthCheckMetricsData.recording_check.enabled && healthCheckMetricsData.stream_quality_check.enabled,
                                                                disabled: true,
                                                                name: "all_metrics"
                                                            }),
                                                            label: "All Metrics"
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                            sx: {
                                                                marginLeft: "20px"
                                                            },
                                                            control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                                checked: healthCheckMetricsData.scene_change_check.enabled,
                                                                disabled: true,
                                                                name: "scene_change_check"
                                                            }),
                                                            label: "Scene Change"
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                            sx: {
                                                                marginLeft: "20px"
                                                            },
                                                            control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                                checked: healthCheckMetricsData.stream_quality_check.enabled,
                                                                disabled: true,
                                                                name: "stream_quality_check"
                                                            }),
                                                            label: "Stream Quality"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};

});

parcelRegister("bqbzv", function(module, exports) {

$parcel$export(module.exports, "cadenceOptions", () => $bc83ee7050b6c3eb$export$c146047e5f6d2ab0);
$parcel$export(module.exports, "formatCadenceForDisplay", () => $bc83ee7050b6c3eb$export$8a77e0fdb2aedf3c);
$parcel$export(module.exports, "cadenceLabelToMinutes", () => $bc83ee7050b6c3eb$export$1490a5b46f373044);
$parcel$export(module.exports, "cadenceMinutesToLabel", () => $bc83ee7050b6c3eb$export$eb80aeb70b22195d);
const $bc83ee7050b6c3eb$var$HOUR_CADENCE_LABELS = {
    "24 Hours": 24,
    "12 Hours": 12,
    "6 Hours": 6,
    "4 Hours": 4
};
const $bc83ee7050b6c3eb$var$HOUR_CADENCE_VALUES = {
    24: "24 Hours",
    12: "12 Hours",
    6: "6 Hours",
    4: "4 Hours"
};
const $bc83ee7050b6c3eb$export$c146047e5f6d2ab0 = [
    "24 Hours",
    "12 Hours",
    "6 Hours",
    "4 Hours",
    "120",
    "60",
    "30",
    "15"
];
const $bc83ee7050b6c3eb$export$8a77e0fdb2aedf3c = (cadence)=>{
    if (cadence == null || cadence === "") return "";
    const value = Number(cadence);
    if (!Number.isNaN(value) && $bc83ee7050b6c3eb$var$HOUR_CADENCE_VALUES[value]) return $bc83ee7050b6c3eb$var$HOUR_CADENCE_VALUES[value];
    return String(cadence);
};
const $bc83ee7050b6c3eb$export$1490a5b46f373044 = (label)=>{
    if ($bc83ee7050b6c3eb$var$HOUR_CADENCE_LABELS[label] != null) return String($bc83ee7050b6c3eb$var$HOUR_CADENCE_LABELS[label]);
    return label;
};
const $bc83ee7050b6c3eb$export$eb80aeb70b22195d = (cadence)=>{
    return $bc83ee7050b6c3eb$export$8a77e0fdb2aedf3c(cadence);
};

});

parcelRegister("5uHpU", function(module, exports) {

$parcel$export(module.exports, "reportCadenceOptions", () => $12056cbd2c25c2c4$export$1e4594215e7670c0);
$parcel$export(module.exports, "formatReportCadenceForDisplay", () => $12056cbd2c25c2c4$export$cd4619e2b55f8e1f);
$parcel$export(module.exports, "reportCadenceLabelToValue", () => $12056cbd2c25c2c4$export$6e9e862420f8cd9b);
const $12056cbd2c25c2c4$export$1e4594215e7670c0 = [
    "daily",
    "weekly",
    "monthly"
];
const $12056cbd2c25c2c4$export$cd4619e2b55f8e1f = (reportCadence)=>{
    if (reportCadence == null || reportCadence === "") return "Daily";
    return reportCadence.replace(/\b\w/g, (char)=>char.toUpperCase());
};
const $12056cbd2c25c2c4$export$6e9e862420f8cd9b = (label)=>{
    if (label == null || label === "") return "daily";
    return label.replace(/\b\w/g, (char)=>char.toLowerCase());
};

});


parcelRegister("iE9hz", function(module, exports) {

$parcel$export(module.exports, "CameraHealthTabEditMode", () => $3b56f45bb81e4d34$export$b73a8adf067f539);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $8B8vg = parcelRequire("8B8vg");
var $kbChx = parcelRequire("kbChx");
var $3baw3 = parcelRequire("3baw3");
var $ddLR4 = parcelRequire("ddLR4");
var $ha39s = parcelRequire("ha39s");
var $eejVe = parcelRequire("eejVe");
var $cVCJe = parcelRequire("cVCJe");

var $2SHRA = parcelRequire("2SHRA");

var $3FJ79 = parcelRequire("3FJ79");

var $9CozC = parcelRequire("9CozC");

var $hu7Mb = parcelRequire("hu7Mb");

var $ePwXE = parcelRequire("ePwXE");

var $bqbzv = parcelRequire("bqbzv");

var $5uHpU = parcelRequire("5uHpU");
const $3b56f45bb81e4d34$var$capitalizeWords = (str)=>{
    return str.replace(/\b\w/g, (char)=>char.toUpperCase());
};
const $3b56f45bb81e4d34$var$lowerCaseWords = (str)=>{
    return str.replace(/\b\w/g, (char)=>char.toLowerCase());
};
const $3b56f45bb81e4d34$export$b73a8adf067f539 = ({ healthCheckData: healthCheckData, setCameraHealthPatchObject: setCameraHealthPatchObject, setCameraHealthChangesMade: setCameraHealthChangesMade, siteInfo: siteInfo, setAddCameraHealthDialogOpen: setAddCameraHealthDialogOpen, setTurnOffHealthDialogOpen: setTurnOffHealthDialogOpen })=>{
    const titlesArray = [
        "Camera Health Monitoring On",
        "Reports enabled",
        "Report Cadence",
        "Sensitivity",
        "Cadence"
    ];
    const titlesArray2 = [
        "All Metric Notifications",
        "All Metric Emails",
        "Report emails",
        "Cell Numbers",
        ""
    ];
    const sensitivityOptions = [
        "low",
        "medium",
        "high"
    ];
    const { healthCheckMetricsData: healthCheckMetricsData, setHealthCheckMetricsUpdated: setHealthCheckMetricsUpdated, setHealthCheckMetricsData: setHealthCheckMetricsData, healthCheckMetricsUpdated: healthCheckMetricsUpdated } = (0, $3FJ79.useSiteAboutStore)();
    const [allMetricsChecked, setAllMetricsChecked] = $8T3gX.useState(healthCheckMetricsData.scene_change_check.enabled && healthCheckMetricsData.motion_status_check.enabled && healthCheckMetricsData.recording_check.enabled && healthCheckMetricsData.stream_quality_check.enabled && healthCheckMetricsData.image_quality_check.enabled);
    const [currentCheckboxValues, setCurrentCheckboxValues] = $8T3gX.useState({
        scene_change_check: healthCheckMetricsData.scene_change_check.enabled,
        motion_status_check: healthCheckMetricsData.motion_status_check.enabled,
        recording_check: healthCheckMetricsData.recording_check.enabled,
        stream_quality_check: healthCheckMetricsData.stream_quality_check.enabled,
        image_quality_check: healthCheckMetricsData.image_quality_check.enabled
    });
    const [currentEmailsValues, setCurrentEmailsValues] = $8T3gX.useState({
        connectivity_check: healthCheckMetricsData.connectivity_check.alert_emails || "",
        scene_change_check: healthCheckMetricsData.scene_change_check.alert_emails || "",
        motion_status_check: healthCheckMetricsData.motion_status_check.alert_emails || "",
        recording_check: healthCheckMetricsData.recording_check.alert_emails || "",
        stream_quality_check: healthCheckMetricsData.stream_quality_check.alert_emails || "",
        image_quality_check: healthCheckMetricsData.image_quality_check.alert_emails || ""
    });
    $8T3gX.useEffect(()=>{
        if (currentCheckboxValues.scene_change_check && currentCheckboxValues.motion_status_check && currentCheckboxValues.recording_check && currentCheckboxValues.stream_quality_check && currentCheckboxValues.image_quality_check) setAllMetricsChecked(true);
        else setAllMetricsChecked(false);
    }, [
        currentCheckboxValues
    ]);
    $8T3gX.useEffect(()=>{
        localStorage.setItem("backupHealthCheckMetricsData", JSON.stringify(healthCheckMetricsData));
    }, []);
    if (siteInfo.integration_type_name === "autopatrol") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $hu7Mb.CameraHealthTabAuopatrolEditMode), {
        healthCheckData: healthCheckData,
        setCameraHealthPatchObject: setCameraHealthPatchObject,
        setCameraHealthChangesMade: setCameraHealthChangesMade,
        setAddCameraHealthDialogOpen: setAddCameraHealthDialogOpen,
        setTurnOffHealthDialogOpen: setTurnOffHealthDialogOpen
    });
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $k8Qy8.default), {
                sx: {
                    postion: "absolute",
                    width: "screen",
                    fontFamily: "Mulish"
                },
                children: healthCheckData.deployment === 0 ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $ha39s.default), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: "Camera Health Monitoring On"
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                        checked: healthCheckData.deployment === 3,
                                        disabled: false,
                                        color: "warning",
                                        onChange: ()=>{
                                            setAddCameraHealthDialogOpen(true);
                                        }
                                    })
                                })
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                    titlesArray: titlesArray
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                    checked: healthCheckData.deployment === 3,
                                                    disabled: false,
                                                    color: "warning",
                                                    onChange: ()=>{
                                                        setTurnOffHealthDialogOpen(true);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: healthCheckData.report_emails_enabled ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                    defaultChecked: true,
                                                    disabled: false,
                                                    color: "warning",
                                                    onChange: (event, value)=>{
                                                        setCameraHealthPatchObject((previousState)=>{
                                                            return {
                                                                ...previousState,
                                                                report_emails_enabled: value
                                                            };
                                                        });
                                                        setCameraHealthChangesMade(true);
                                                    }
                                                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                    disabled: false,
                                                    color: "warning",
                                                    onChange: (event, value)=>{
                                                        setCameraHealthPatchObject((previousState)=>{
                                                            return {
                                                                ...previousState,
                                                                report_emails_enabled: value
                                                            };
                                                        });
                                                        setCameraHealthChangesMade(true);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                                    disablePortal: true,
                                                    disableClearable: true,
                                                    options: (0, $5uHpU.reportCadenceOptions).map((option)=>{
                                                        return (0, $5uHpU.formatReportCadenceForDisplay)(option);
                                                    }),
                                                    defaultValue: (0, $5uHpU.formatReportCadenceForDisplay)(healthCheckData.report_cadence || "daily"),
                                                    onChange: (event, newInputValue)=>{
                                                        if (newInputValue == null) return;
                                                        setCameraHealthPatchObject((previousState)=>{
                                                            return {
                                                                ...previousState,
                                                                report_cadence: (0, $5uHpU.reportCadenceLabelToValue)(newInputValue)
                                                            };
                                                        });
                                                        setCameraHealthChangesMade(true);
                                                    },
                                                    sx: {
                                                        width: 150
                                                    },
                                                    renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                            ...params,
                                                            variant: "standard",
                                                            label: "Report Cadence"
                                                        })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                                    disablePortal: true,
                                                    disableClearable: true,
                                                    options: sensitivityOptions.map((option)=>{
                                                        return $3b56f45bb81e4d34$var$capitalizeWords(option);
                                                    }),
                                                    defaultValue: $3b56f45bb81e4d34$var$capitalizeWords(healthCheckData.sensitivity_level),
                                                    onChange: (event, newInputValue)=>{
                                                        if (newInputValue == null) return;
                                                        setCameraHealthPatchObject((previousState)=>{
                                                            return {
                                                                ...previousState,
                                                                sensitivity_level: $3b56f45bb81e4d34$var$lowerCaseWords(newInputValue)
                                                            };
                                                        });
                                                        setCameraHealthChangesMade(true);
                                                    },
                                                    sx: {
                                                        width: 150
                                                    },
                                                    renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                            ...params,
                                                            variant: "standard",
                                                            label: "Sensitivity"
                                                        })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                                    disablePortal: true,
                                                    disableClearable: true,
                                                    options: (0, $bqbzv.cadenceOptions),
                                                    defaultValue: (0, $bqbzv.cadenceMinutesToLabel)(healthCheckData.cadence),
                                                    onChange: (event, newInputValue)=>{
                                                        if (newInputValue == null) return;
                                                        setCameraHealthPatchObject((previousState)=>{
                                                            return {
                                                                ...previousState,
                                                                cadence: (0, $bqbzv.cadenceLabelToMinutes)(newInputValue)
                                                            };
                                                        });
                                                        setCameraHealthChangesMade(true);
                                                    },
                                                    sx: {
                                                        width: 150
                                                    },
                                                    renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                            ...params,
                                                            variant: "standard",
                                                            label: "Cadence"
                                                        })
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                    titlesArray: titlesArray2
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: healthCheckData.alert_emails_enabled ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                    defaultChecked: true,
                                                    disabled: false,
                                                    color: "warning",
                                                    onChange: (event, value)=>{
                                                        setCameraHealthPatchObject((previousState)=>{
                                                            return {
                                                                ...previousState,
                                                                alert_emails_enabled: value
                                                            };
                                                        });
                                                        setCameraHealthChangesMade(true);
                                                    }
                                                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                    disabled: false,
                                                    color: "warning",
                                                    onChange: (event, value)=>{
                                                        setCameraHealthPatchObject((previousState)=>{
                                                            return {
                                                                ...previousState,
                                                                alert_emails_enabled: value
                                                            };
                                                        });
                                                        setCameraHealthChangesMade(true);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                    defaultValue: healthCheckData.alert_emails,
                                                    variant: "standard",
                                                    sx: {
                                                        width: 300
                                                    },
                                                    type: "string",
                                                    onChange: (event)=>{
                                                        setCameraHealthPatchObject((previousState)=>{
                                                            return {
                                                                ...previousState,
                                                                alert_emails: event.target.value
                                                            };
                                                        });
                                                        setCameraHealthChangesMade(true);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                    defaultValue: healthCheckData.report_emails,
                                                    variant: "standard",
                                                    type: "string",
                                                    sx: {
                                                        width: 300
                                                    },
                                                    onChange: (event)=>{
                                                        setCameraHealthPatchObject((previousState)=>{
                                                            return {
                                                                ...previousState,
                                                                report_emails: event.target.value
                                                            };
                                                        });
                                                        setCameraHealthChangesMade(true);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $9CozC.PhoneListTextField), {
                                                    fieldKey: "camera-health-cell-numbers",
                                                    storedValue: healthCheckData.cell_numbers,
                                                    onValueChange: (value)=>{
                                                        setCameraHealthPatchObject((previousState)=>{
                                                            return {
                                                                ...previousState,
                                                                cell_numbers: value
                                                            };
                                                        });
                                                        setCameraHealthChangesMade(true);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {})
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            healthCheckData.deployment !== 0 && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                sx: {
                    postion: "absolute",
                    width: "screen",
                    fontFamily: "Mulish"
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        fontWeight: "Bold"
                                    },
                                    children: [
                                        "Health Metrics \xa0 \xa0",
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                            title: "Select metrics in addition to connectivity to monitor. Use fields below to send instant alerts for specific metrics to different recipients.",
                                            placement: "top",
                                            sx: {
                                                fontSize: "15px",
                                                fontFamily: "mulish"
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                                fontSize: "small"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {}),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {}),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $2SHRA.default), {
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "flex",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                        checked: allMetricsChecked,
                                                        onChange: (event)=>{
                                                            setHealthCheckMetricsUpdated({
                                                                connectivity_check: true,
                                                                scene_change_check: true,
                                                                motion_status_check: true,
                                                                recording_check: true,
                                                                stream_quality_check: true,
                                                                image_quality_check: true
                                                            });
                                                            setCurrentCheckboxValues((prevState)=>{
                                                                return {
                                                                    ...prevState,
                                                                    scene_change_check: event.target.checked,
                                                                    motion_status_check: event.target.checked,
                                                                    recording_check: event.target.checked,
                                                                    stream_quality_check: event.target.checked,
                                                                    image_quality_check: event.target.checked
                                                                };
                                                            });
                                                            setHealthCheckMetricsData({
                                                                ...healthCheckMetricsData,
                                                                scene_change_check: {
                                                                    ...healthCheckMetricsData.scene_change_check,
                                                                    enabled: event.target.checked
                                                                },
                                                                motion_status_check: {
                                                                    ...healthCheckMetricsData.motion_status_check,
                                                                    enabled: event.target.checked
                                                                },
                                                                recording_check: {
                                                                    ...healthCheckMetricsData.recording_check,
                                                                    enabled: event.target.checked
                                                                },
                                                                stream_quality_check: {
                                                                    ...healthCheckMetricsData.stream_quality_check,
                                                                    enabled: event.target.checked
                                                                },
                                                                image_quality_check: {
                                                                    ...healthCheckMetricsData.image_quality_check,
                                                                    enabled: event.target.checked
                                                                }
                                                            });
                                                        },
                                                        name: "all_metrics"
                                                    }),
                                                    label: "All Metrics"
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                        sx: {
                                                            marginLeft: "20px"
                                                        },
                                                        checked: currentCheckboxValues.scene_change_check,
                                                        onChange: (event)=>{
                                                            const isChecked = event.target.checked;
                                                            setCurrentCheckboxValues((prevState)=>({
                                                                    ...prevState,
                                                                    scene_change_check: isChecked
                                                                }));
                                                            setHealthCheckMetricsData({
                                                                ...healthCheckMetricsData,
                                                                scene_change_check: {
                                                                    ...healthCheckMetricsData.scene_change_check,
                                                                    enabled: isChecked
                                                                }
                                                            });
                                                            setHealthCheckMetricsUpdated({
                                                                ...healthCheckMetricsUpdated,
                                                                scene_change_check: true
                                                            });
                                                        },
                                                        name: "scene_change_check"
                                                    }),
                                                    label: "Scene Change"
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                    sx: {
                                                        marginLeft: "20px"
                                                    },
                                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                        checked: currentCheckboxValues.motion_status_check,
                                                        onChange: (event)=>{
                                                            const isChecked = event.target.checked;
                                                            setCurrentCheckboxValues((prevState)=>({
                                                                    ...prevState,
                                                                    motion_status_check: isChecked
                                                                }));
                                                            setHealthCheckMetricsData({
                                                                ...healthCheckMetricsData,
                                                                motion_status_check: {
                                                                    ...healthCheckMetricsData.motion_status_check,
                                                                    enabled: isChecked
                                                                }
                                                            });
                                                            setHealthCheckMetricsUpdated({
                                                                ...healthCheckMetricsUpdated,
                                                                motion_status_check: true
                                                            });
                                                        },
                                                        name: "motion_status_check"
                                                    }),
                                                    label: "Motion Status"
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                    sx: {
                                                        marginLeft: "20px"
                                                    },
                                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                        checked: currentCheckboxValues.recording_check,
                                                        onChange: (event)=>{
                                                            const isChecked = event.target.checked;
                                                            setCurrentCheckboxValues((prevState)=>({
                                                                    ...prevState,
                                                                    recording_check: isChecked
                                                                }));
                                                            setHealthCheckMetricsData({
                                                                ...healthCheckMetricsData,
                                                                recording_check: {
                                                                    ...healthCheckMetricsData.recording_check,
                                                                    enabled: isChecked
                                                                }
                                                            });
                                                            setHealthCheckMetricsUpdated({
                                                                ...healthCheckMetricsUpdated,
                                                                recording_check: true
                                                            });
                                                        },
                                                        name: "recording_check"
                                                    }),
                                                    label: "Recording Status"
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                    sx: {
                                                        marginLeft: "20px"
                                                    },
                                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                        checked: currentCheckboxValues.stream_quality_check,
                                                        onChange: (event)=>{
                                                            const isChecked = event.target.checked;
                                                            setCurrentCheckboxValues((prevState)=>({
                                                                    ...prevState,
                                                                    stream_quality_check: isChecked
                                                                }));
                                                            setHealthCheckMetricsData({
                                                                ...healthCheckMetricsData,
                                                                stream_quality_check: {
                                                                    ...healthCheckMetricsData.stream_quality_check,
                                                                    enabled: isChecked
                                                                }
                                                            });
                                                            setHealthCheckMetricsUpdated({
                                                                ...healthCheckMetricsUpdated,
                                                                stream_quality_check: true
                                                            });
                                                        },
                                                        name: "stream_quality_check"
                                                    }),
                                                    label: "Stream Quality"
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                    sx: {
                                                        marginLeft: "20px"
                                                    },
                                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                        checked: currentCheckboxValues.image_quality_check,
                                                        onChange: (event)=>{
                                                            const isChecked = event.target.checked;
                                                            setCurrentCheckboxValues((prevState)=>({
                                                                    ...prevState,
                                                                    image_quality_check: isChecked
                                                                }));
                                                            setHealthCheckMetricsData({
                                                                ...healthCheckMetricsData,
                                                                image_quality_check: {
                                                                    ...healthCheckMetricsData.image_quality_check,
                                                                    enabled: isChecked
                                                                }
                                                            });
                                                            setHealthCheckMetricsUpdated({
                                                                ...healthCheckMetricsUpdated,
                                                                image_quality_check: true
                                                            });
                                                        },
                                                        name: "image_quality_check"
                                                    }),
                                                    label: "Image Quality"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {}),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {})
                            ]
                        })
                    })
                ]
            }),
            healthCheckData.deployment !== 0 && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                sx: {
                    postion: "absolute",
                    width: "screen",
                    fontFamily: "Mulish"
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                        titlesArray: [
                            "Scene Change Emails",
                            "Motion Status Emails",
                            "Recording Status Emails",
                            "Stream Quality Emails"
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        value: currentEmailsValues.scene_change_check,
                                        variant: "standard",
                                        sx: {
                                            width: 300
                                        },
                                        type: "string",
                                        onChange: (event)=>{
                                            const newValue = event.target.value;
                                            setCurrentEmailsValues((prevState)=>({
                                                    ...prevState,
                                                    scene_change_check: newValue
                                                }));
                                            setHealthCheckMetricsData({
                                                ...healthCheckMetricsData,
                                                scene_change_check: {
                                                    ...healthCheckMetricsData.scene_change_check,
                                                    alert_emails: newValue
                                                }
                                            });
                                            setHealthCheckMetricsUpdated({
                                                ...healthCheckMetricsUpdated,
                                                scene_change_check: true
                                            });
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        value: currentEmailsValues.motion_status_check,
                                        variant: "standard",
                                        sx: {
                                            width: 300
                                        },
                                        type: "string",
                                        onChange: (event)=>{
                                            const newValue = event.target.value;
                                            setCurrentEmailsValues((prevState)=>({
                                                    ...prevState,
                                                    motion_status_check: newValue
                                                }));
                                            setHealthCheckMetricsData({
                                                ...healthCheckMetricsData,
                                                motion_status_check: {
                                                    ...healthCheckMetricsData.motion_status_check,
                                                    alert_emails: newValue
                                                }
                                            });
                                            setHealthCheckMetricsUpdated({
                                                ...healthCheckMetricsUpdated,
                                                motion_status_check: true
                                            });
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        value: currentEmailsValues.recording_check,
                                        variant: "standard",
                                        sx: {
                                            width: 300
                                        },
                                        type: "string",
                                        onChange: (event)=>{
                                            const newValue = event.target.value;
                                            setCurrentEmailsValues((prevState)=>({
                                                    ...prevState,
                                                    recording_check: newValue
                                                }));
                                            setHealthCheckMetricsData({
                                                ...healthCheckMetricsData,
                                                recording_check: {
                                                    ...healthCheckMetricsData.recording_check,
                                                    alert_emails: newValue
                                                }
                                            });
                                            setHealthCheckMetricsUpdated({
                                                ...healthCheckMetricsUpdated,
                                                recording_check: true
                                            });
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        value: currentEmailsValues.stream_quality_check,
                                        variant: "standard",
                                        sx: {
                                            width: 300
                                        },
                                        type: "string",
                                        onChange: (event)=>{
                                            const newValue = event.target.value;
                                            setCurrentEmailsValues((prevState)=>({
                                                    ...prevState,
                                                    stream_quality_check: newValue
                                                }));
                                            setHealthCheckMetricsData({
                                                ...healthCheckMetricsData,
                                                stream_quality_check: {
                                                    ...healthCheckMetricsData.stream_quality_check,
                                                    alert_emails: newValue
                                                }
                                            });
                                            setHealthCheckMetricsUpdated({
                                                ...healthCheckMetricsUpdated,
                                                stream_quality_check: true
                                            });
                                        }
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            healthCheckData.deployment !== 0 && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                sx: {
                    postion: "absolute",
                    width: "screen",
                    fontFamily: "Mulish"
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                        titlesArray: [
                            "Image Quality Emails",
                            "Connectivity Status Emails"
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        value: currentEmailsValues.image_quality_check,
                                        variant: "standard",
                                        sx: {
                                            width: 300
                                        },
                                        type: "string",
                                        onChange: (event)=>{
                                            const newValue = event.target.value;
                                            setCurrentEmailsValues((prevState)=>({
                                                    ...prevState,
                                                    image_quality_check: newValue
                                                }));
                                            setHealthCheckMetricsData({
                                                ...healthCheckMetricsData,
                                                image_quality_check: {
                                                    ...healthCheckMetricsData.image_quality_check,
                                                    alert_emails: newValue
                                                }
                                            });
                                            setHealthCheckMetricsUpdated({
                                                ...healthCheckMetricsUpdated,
                                                image_quality_check: true
                                            });
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        value: currentEmailsValues.connectivity_check,
                                        variant: "standard",
                                        sx: {
                                            width: 300
                                        },
                                        type: "string",
                                        onChange: (event)=>{
                                            const newValue = event.target.value;
                                            setCurrentEmailsValues((prevState)=>({
                                                    ...prevState,
                                                    connectivity_check: newValue
                                                }));
                                            setHealthCheckMetricsData({
                                                ...healthCheckMetricsData,
                                                connectivity_check: {
                                                    ...healthCheckMetricsData.connectivity_check,
                                                    alert_emails: newValue
                                                }
                                            });
                                            setHealthCheckMetricsUpdated({
                                                ...healthCheckMetricsUpdated,
                                                connectivity_check: true
                                            });
                                        }
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("9CozC", function(module, exports) {

$parcel$export(module.exports, "PhoneListTextField", () => $4df648c443916b0d$export$bb71330226ae200a);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $eejVe = parcelRequire("eejVe");

var $3EhHS = parcelRequire("3EhHS");

var $bIAiw = parcelRequire("bIAiw");
const $4df648c443916b0d$export$bb71330226ae200a = ({ fieldKey: fieldKey, storedValue: storedValue, onValueChange: onValueChange, width: width = 300 })=>{
    const initial = storedValue ?? "";
    const separator = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>(0, $3EhHS.detectListSeparator)(initial), []); // eslint-disable-line react-hooks/exhaustive-deps
    const [text, setText] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(initial);
    const setFieldInvalid = (0, $bIAiw.usePhoneValidationStore)((state)=>state.setFieldInvalid);
    const list = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>(0, $3EhHS.parsePhoneList)(text), [
        text
    ]);
    const serialized = list.valid.join(separator);
    const storedNeedsFix = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>{
        const storedEntries = (0, $3EhHS.splitPhoneList)(initial);
        const storedList = (0, $3EhHS.parsePhoneList)(initial);
        return storedEntries.length > 0 && (storedList.hasInvalid || storedList.valid.join(separator) !== storedEntries.join(separator));
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setFieldInvalid(fieldKey, list.hasInvalid);
    }, [
        fieldKey,
        list.hasInvalid,
        setFieldInvalid
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>()=>setFieldInvalid(fieldKey, false), [
        fieldKey
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // Stage the normalized form of a stored-but-not-E.164 value so Save fixes it.
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (storedNeedsFix && !list.hasInvalid) onValueChange(serialized);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    const unchangedSinceOpen = text === initial;
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
        value: text,
        variant: "standard",
        type: "text",
        sx: {
            width: width
        },
        error: list.hasInvalid,
        inputProps: {
            "aria-label": "Cell numbers"
        },
        onChange: (event)=>{
            // Capture eagerly (see CLAUDE.md: event.target.value inside updaters).
            const nextValue = event.target.value;
            setText(nextValue);
            onValueChange((0, $3EhHS.parsePhoneList)(nextValue).valid.join(separator));
        },
        helperText: /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
            "data-testid": `${fieldKey}-helper`,
            children: [
                unchangedSinceOpen && storedNeedsFix && /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                    className: "block text-[#B45309]",
                    children: list.hasInvalid ? "Saved numbers include entries SMS can't deliver to. Fix them before saving." : `Saved as "${initial}", which SMS would misdial. Save to store the corrected numbers.`
                }),
                list.invalid.map(({ raw: raw, result: result }, index)=>/*#__PURE__*/ (0, $k4ank.jsx)("span", {
                        className: "block",
                        children: `"${raw}": ${result.ok ? "" : result.reason}`
                    }, `${index}-${raw}`)),
                list.valid.length > 0 && /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                    className: "block",
                    children: (0, $3EhHS.describePhoneList)(list)
                }),
                list.entries.length === 0 && /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                    className: "block",
                    children: "Include the country code, e.g. +1 225 465 9357. Separate numbers with commas."
                })
            ]
        })
    });
};

});
parcelRegister("3EhHS", function(module, exports) {

$parcel$export(module.exports, "normalizePhone", () => $5e2e2d21ac3b905e$export$e9b617754cf28d84);
$parcel$export(module.exports, "splitPhoneList", () => $5e2e2d21ac3b905e$export$c3abfc23b72507e0);
$parcel$export(module.exports, "parsePhoneList", () => $5e2e2d21ac3b905e$export$2116ab3253b25f6d);
$parcel$export(module.exports, "detectListSeparator", () => $5e2e2d21ac3b905e$export$ed0a5f10cdcf6ede);
$parcel$export(module.exports, "describePhoneList", () => $5e2e2d21ac3b905e$export$57b7cfd41af4875d);
/**
 * E.164 validation for SMS recipient numbers (ENG-2302).
 *
 * AWS SNS reads a number without a leading "+" as if it already carried a
 * country code: a bare US `2254659357` was dialled as +225 (Côte d'Ivoire),
 * failed every time and was still billed. So every field that collects an SMS
 * recipient normalizes through here before save:
 *
 * - `+` followed by 8–15 digits (first digit 1–9) is accepted as-is.
 * - A bare 10-digit NANP number (or 11 digits with a leading 1), with any
 *   spaces/dashes/dots/parens, becomes +1XXXXXXXXXX (US/Canada default).
 * - Any other bare number is rejected. A foreign number is never guessed;
 *   at most we suggest the "+" form for the operator to confirm.
 * - Emails and free text are rejected.
 */ const $5e2e2d21ac3b905e$export$dc6b5c2c9c1915da = "Add the country code, e.g. +44 20 7946 0958";
const $5e2e2d21ac3b905e$export$633757f19fe4e259 = "That's an email address; enter a phone number like +1 225 465 9357";
const $5e2e2d21ac3b905e$export$bad122175df6e097 = "That isn't a phone number; enter one like +1 225 465 9357";
// Formatting characters people type inside phone numbers.
const $5e2e2d21ac3b905e$var$FORMATTING_CHARS = /[\s\-.()]/g;
const $5e2e2d21ac3b905e$export$7dc7829bfb979bdb = (e164)=>{
    const nanp = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(e164);
    if (nanp) return `+1 ${nanp[1]} ${nanp[2]} ${nanp[3]}`;
    return e164;
};
const $5e2e2d21ac3b905e$var$ok = (e164)=>({
        ok: true,
        e164: e164,
        display: $5e2e2d21ac3b905e$export$7dc7829bfb979bdb(e164)
    });
const $5e2e2d21ac3b905e$var$fail = (reason)=>({
        ok: false,
        reason: reason
    });
// NANP area codes start 2–9; a 10-digit string starting 0/1 is not US/Canada.
const $5e2e2d21ac3b905e$var$isNanpNational = (digits)=>/^[2-9]\d{9}$/.test(digits);
// Digits that could already be a full international number (E.164 shape).
const $5e2e2d21ac3b905e$var$looksInternational = (digits)=>/^[1-9]\d{7,14}$/.test(digits);
const $5e2e2d21ac3b905e$var$missingPlusHint = (digits)=>$5e2e2d21ac3b905e$var$looksInternational(digits) ? `${$5e2e2d21ac3b905e$export$dc6b5c2c9c1915da}. If ${digits} already includes it, did you mean +${digits}?` : $5e2e2d21ac3b905e$export$dc6b5c2c9c1915da;
const $5e2e2d21ac3b905e$export$e9b617754cf28d84 = (raw)=>{
    const value = (raw ?? "").trim();
    if (!value) return $5e2e2d21ac3b905e$var$fail("Enter a phone number");
    // Emails can contain "+" (product+tag@example.com), so check them first.
    if (value.includes("@")) return $5e2e2d21ac3b905e$var$fail($5e2e2d21ac3b905e$export$633757f19fe4e259);
    const compact = value.replace($5e2e2d21ac3b905e$var$FORMATTING_CHARS, "");
    if (!/^\+?\d+$/.test(compact)) return $5e2e2d21ac3b905e$var$fail($5e2e2d21ac3b905e$export$bad122175df6e097);
    if (compact.startsWith("+")) {
        const digits = compact.slice(1);
        if (digits.startsWith("0")) return $5e2e2d21ac3b905e$var$fail("Country codes don't start with 0, e.g. +44 20 7946 0958");
        if (digits.length < 8) return $5e2e2d21ac3b905e$var$fail("Too short: + and 8\u201315 digits");
        if (digits.length > 15) return $5e2e2d21ac3b905e$var$fail("Too long: + and 8\u201315 digits");
        return $5e2e2d21ac3b905e$var$ok(`+${digits}`);
    }
    const digits = compact;
    if (digits.startsWith("00")) {
        const rest = digits.slice(2);
        return $5e2e2d21ac3b905e$var$fail($5e2e2d21ac3b905e$var$looksInternational(rest) ? `Use + instead of 00: did you mean +${rest}?` : $5e2e2d21ac3b905e$export$dc6b5c2c9c1915da);
    }
    if (digits.length === 10 && $5e2e2d21ac3b905e$var$isNanpNational(digits)) return $5e2e2d21ac3b905e$var$ok(`+1${digits}`);
    if (digits.length === 11 && digits.startsWith("1")) {
        const national = digits.slice(1);
        if ($5e2e2d21ac3b905e$var$isNanpNational(national)) return $5e2e2d21ac3b905e$var$ok(`+1${national}`);
    }
    if (digits.length < 10) return $5e2e2d21ac3b905e$var$fail("Too short: enter 10 digits for US/Canada, or + and the country code");
    return $5e2e2d21ac3b905e$var$fail($5e2e2d21ac3b905e$var$missingPlusHint(digits));
};
const $5e2e2d21ac3b905e$export$c3abfc23b72507e0 = (raw)=>{
    const parts = Array.isArray(raw) ? raw : String(raw ?? "").split(/[,;\n]/);
    return parts.map((part)=>String(part ?? "").trim()).filter(Boolean);
};
const $5e2e2d21ac3b905e$export$2116ab3253b25f6d = (raw)=>{
    const entries = $5e2e2d21ac3b905e$export$c3abfc23b72507e0(raw).map((part)=>({
            raw: part,
            result: $5e2e2d21ac3b905e$export$e9b617754cf28d84(part)
        }));
    const valid = [];
    entries.forEach(({ result: result })=>{
        if (result.ok && !valid.includes(result.e164)) valid.push(result.e164);
    });
    const invalid = entries.filter(({ result: result })=>!result.ok);
    return {
        entries: entries,
        valid: valid,
        invalid: invalid,
        hasInvalid: invalid.length > 0
    };
};
const $5e2e2d21ac3b905e$export$ed0a5f10cdcf6ede = (raw)=>/,\s/.test(String(raw ?? "")) ? ", " : ",";
const $5e2e2d21ac3b905e$export$57b7cfd41af4875d = (list)=>list.valid.length ? `Will text ${list.valid.map($5e2e2d21ac3b905e$export$7dc7829bfb979bdb).join(", ")}` : "";

});

parcelRegister("bIAiw", function(module, exports) {

$parcel$export(module.exports, "usePhoneValidationStore", () => $867ab77b81e9db9f$export$bdfc17aac2407fbd);
$parcel$export(module.exports, "selectAnyPhoneFieldInvalid", () => $867ab77b81e9db9f$export$cceb7a791584e3f6);

var $9OjAn = parcelRequire("9OjAn");
const $867ab77b81e9db9f$export$bdfc17aac2407fbd = (0, $9OjAn.create)((set)=>({
        invalidFields: {},
        setFieldInvalid: (key, invalid)=>set((state)=>{
                if (Boolean(state.invalidFields[key]) === invalid) return state;
                const invalidFields = {
                    ...state.invalidFields
                };
                if (invalid) invalidFields[key] = true;
                else delete invalidFields[key];
                return {
                    invalidFields: invalidFields
                };
            })
    }));
const $867ab77b81e9db9f$export$cceb7a791584e3f6 = (state)=>Object.keys(state.invalidFields).length > 0;

});


parcelRegister("hu7Mb", function(module, exports) {

$parcel$export(module.exports, "CameraHealthTabAuopatrolEditMode", () => $d981dd999f5dc507$export$b95bfc1618e57e0d);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $8B8vg = parcelRequire("8B8vg");
var $kbChx = parcelRequire("kbChx");
var $3baw3 = parcelRequire("3baw3");
var $ha39s = parcelRequire("ha39s");
var $eejVe = parcelRequire("eejVe");

var $2SHRA = parcelRequire("2SHRA");

var $3FJ79 = parcelRequire("3FJ79");

var $2aMB5 = parcelRequire("2aMB5");

var $lWchQ = parcelRequire("lWchQ");
const $d981dd999f5dc507$var$capitalizeWords = (str)=>{
    return str.replace(/\b\w/g, (char)=>char.toUpperCase());
};
const $d981dd999f5dc507$var$lowerCaseWords = (str)=>{
    return str.replace(/\b\w/g, (char)=>char.toLowerCase());
};
const $d981dd999f5dc507$export$b95bfc1618e57e0d = ({ healthCheckData: healthCheckData, setCameraHealthPatchObject: setCameraHealthPatchObject, setCameraHealthChangesMade: setCameraHealthChangesMade, setAddCameraHealthDialogOpen: setAddCameraHealthDialogOpen, setTurnOffHealthDialogOpen: setTurnOffHealthDialogOpen })=>{
    const titlesArray = [
        "Camera Health Monitoring On",
        "Sensitivity"
    ];
    const sensitivityOptions = [
        "low",
        "medium",
        "high"
    ];
    const { healthCheckMetricsData: healthCheckMetricsData, setHealthCheckMetricsUpdated: setHealthCheckMetricsUpdated, setHealthCheckMetricsData: setHealthCheckMetricsData, healthCheckMetricsUpdated: healthCheckMetricsUpdated } = (0, $3FJ79.useSiteAboutStore)();
    const [allMetricsChecked, setAllMetricsChecked] = $8T3gX.useState(healthCheckMetricsData.scene_change_check.enabled && healthCheckMetricsData.stream_quality_check.enabled);
    const [currentCheckboxValues, setCurrentCheckboxValues] = $8T3gX.useState({
        scene_change_check: healthCheckMetricsData.scene_change_check.enabled,
        stream_quality_check: healthCheckMetricsData.stream_quality_check.enabled
    });
    $8T3gX.useEffect(()=>{
        if (currentCheckboxValues.scene_change_check && currentCheckboxValues.stream_quality_check) setAllMetricsChecked(true);
        else setAllMetricsChecked(false);
    }, [
        currentCheckboxValues
    ]);
    $8T3gX.useEffect(()=>{
        localStorage.setItem("backupHealthCheckMetricsData", JSON.stringify(healthCheckMetricsData));
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k8Qy8.default), {
            sx: {
                postion: "absolute",
                width: "screen",
                fontFamily: "Mulish"
            },
            children: healthCheckData.deployment === 0 ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $ha39s.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                            align: "left",
                            sx: {
                                fontFamily: "Mulish"
                            },
                            children: "Camera Health Monitoring On"
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: (0, $2aMB5.cancelIconRed)
                            })
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                            titlesArray: titlesArray
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: {
                                            fontFamily: "Mulish"
                                        },
                                        children: healthCheckData.deployment === 3 ? (0, $lWchQ.checkedCircleIcon) : (0, $2aMB5.cancelIconRed)
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: {
                                            fontFamily: "Mulish"
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                            disablePortal: true,
                                            options: sensitivityOptions.map((option)=>{
                                                return $d981dd999f5dc507$var$capitalizeWords(option);
                                            }),
                                            defaultValue: $d981dd999f5dc507$var$capitalizeWords(healthCheckData.sensitivity_level),
                                            onChange: (event, newInputValue)=>{
                                                setCameraHealthPatchObject((previousState)=>{
                                                    return {
                                                        ...previousState,
                                                        sensitivity_level: $d981dd999f5dc507$var$lowerCaseWords(newInputValue)
                                                    };
                                                });
                                                setCameraHealthChangesMade(true);
                                            },
                                            sx: {
                                                width: 250
                                            },
                                            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                    ...params,
                                                    variant: "standard",
                                                    label: "Sensitivity"
                                                })
                                        })
                                    }),
                                    healthCheckData.deployment !== 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $2SHRA.default), {
                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                className: "flex",
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                            checked: allMetricsChecked,
                                                            onChange: (event)=>{
                                                                setHealthCheckMetricsUpdated({
                                                                    connectivity_check: true,
                                                                    scene_change_check: true,
                                                                    motion_status_check: true,
                                                                    recording_check: true,
                                                                    stream_quality_check: true,
                                                                    image_quality_check: true
                                                                });
                                                                setCurrentCheckboxValues((prevState)=>{
                                                                    return {
                                                                        ...prevState,
                                                                        scene_change_check: event.target.checked,
                                                                        motion_status_check: event.target.checked,
                                                                        recording_check: event.target.checked,
                                                                        stream_quality_check: event.target.checked
                                                                    };
                                                                });
                                                                setHealthCheckMetricsData({
                                                                    ...healthCheckMetricsData,
                                                                    scene_change_check: {
                                                                        ...healthCheckMetricsData.scene_change_check,
                                                                        enabled: event.target.checked
                                                                    },
                                                                    motion_status_check: {
                                                                        ...healthCheckMetricsData.motion_status_check,
                                                                        enabled: event.target.checked
                                                                    },
                                                                    recording_check: {
                                                                        ...healthCheckMetricsData.recording_check,
                                                                        enabled: event.target.checked
                                                                    },
                                                                    stream_quality_check: {
                                                                        ...healthCheckMetricsData.stream_quality_check,
                                                                        enabled: event.target.checked
                                                                    }
                                                                });
                                                            },
                                                            name: "all_metrics"
                                                        }),
                                                        label: "All Metrics"
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                            sx: {
                                                                marginLeft: "20px"
                                                            },
                                                            checked: currentCheckboxValues.scene_change_check,
                                                            onChange: (event)=>{
                                                                const isChecked = event.target.checked;
                                                                setCurrentCheckboxValues((prevState)=>({
                                                                        ...prevState,
                                                                        scene_change_check: isChecked
                                                                    }));
                                                                setHealthCheckMetricsData({
                                                                    ...healthCheckMetricsData,
                                                                    scene_change_check: {
                                                                        ...healthCheckMetricsData.scene_change_check,
                                                                        enabled: isChecked
                                                                    }
                                                                });
                                                                setHealthCheckMetricsUpdated({
                                                                    ...healthCheckMetricsUpdated,
                                                                    scene_change_check: true
                                                                });
                                                            },
                                                            name: "scene_change_check"
                                                        }),
                                                        label: "Scene Change"
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                        sx: {
                                                            marginLeft: "20px"
                                                        },
                                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                            checked: currentCheckboxValues.stream_quality_check,
                                                            onChange: (event)=>{
                                                                const isChecked = event.target.checked;
                                                                setCurrentCheckboxValues((prevState)=>({
                                                                        ...prevState,
                                                                        stream_quality_check: isChecked
                                                                    }));
                                                                setHealthCheckMetricsData({
                                                                    ...healthCheckMetricsData,
                                                                    stream_quality_check: {
                                                                        ...healthCheckMetricsData.stream_quality_check,
                                                                        enabled: isChecked
                                                                    }
                                                                });
                                                                setHealthCheckMetricsUpdated({
                                                                    ...healthCheckMetricsUpdated,
                                                                    stream_quality_check: true
                                                                });
                                                            },
                                                            name: "stream_quality_check"
                                                        }),
                                                        label: "Stream Quality"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};

});


parcelRegister("iXV9W", function(module, exports) {

$parcel$export(module.exports, "WEBHOOKS_TAB_TITLES", () => $7c06c562607e6e4e$export$ede02fd9a2b03cb5);
$parcel$export(module.exports, "WebhooksTab", () => $7c06c562607e6e4e$export$f342ab56605b2546);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $aRSHn = parcelRequire("aRSHn");

var $8jTCz = parcelRequire("8jTCz");

var $3FJ79 = parcelRequire("3FJ79");

var $7l43O = parcelRequire("7l43O");
const $7c06c562607e6e4e$export$ede02fd9a2b03cb5 = [
    "Display Name",
    "Webhook Type",
    "Method",
    "Target URL",
    "Message Body",
    "Authentication"
];
const $7c06c562607e6e4e$var$capitalize = (value)=>value ? value.charAt(0).toUpperCase() + value.slice(1) : "";
const $7c06c562607e6e4e$export$f342ab56605b2546 = ({ webhooksInfo: webhooksInfo })=>{
    const setAddSiteWebhookDialogOpen = (0, $3FJ79.useSiteAboutStore)((state)=>state.setAddSiteWebhookDialogOpen);
    const webhooks = Array.isArray(webhooksInfo) ? webhooksInfo : [];
    const canAdd = (0, $7l43O.canEditSiteWebhooks)();
    const addButton = /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
        onClick: ()=>setAddSiteWebhookDialogOpen(true),
        text: "+ Add Webhook",
        disabled: false
    });
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        sx: {
            width: "screen"
        },
        children: [
            webhooks.length > 0 && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                children: [
                    canAdd && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "flex justify-end pr-[10px] pt-[6px]",
                        "data-testid": "webhooks-tab-actions",
                        children: addButton
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                        sx: {
                            postion: "absolute",
                            width: "screen",
                            fontFamily: "Mulish"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                titlesArray: $7c06c562607e6e4e$export$ede02fd9a2b03cb5
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                children: webhooks.map((webhook)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                        "data-testid": `site-webhook-row-${webhook.id}`,
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: webhook.display_name
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: $7c06c562607e6e4e$var$capitalize(webhook.webhook_type)
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: webhook.method
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: webhook.target_url
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: webhook.message_body
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aRSHn.WebhookAuthSummary), {
                                                    webhook: webhook
                                                })
                                            })
                                        ]
                                    }, webhook.id))
                            })
                        ]
                    })
                ]
            }),
            webhooks.length === 0 && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex flex-col items-center gap-3 py-10",
                "data-testid": "webhooks-tab-empty",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-mulish text-[#283E6D] text-[20px] text-center m-0",
                        children: "No webhooks configured for this site."
                    }),
                    canAdd && addButton
                ]
            })
        ]
    });
};

});
parcelRegister("aRSHn", function(module, exports) {

$parcel$export(module.exports, "WebhookAuthFields", () => $496ec6605150c375$export$aa8e0e966e9d29dc);
$parcel$export(module.exports, "WebhookAuthSummary", () => $496ec6605150c375$export$44dca250e1174035);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eejVe = parcelRequire("eejVe");

var $9vEj4 = parcelRequire("9vEj4");
const $496ec6605150c375$export$6ca3f257b16fc18f = "How the webhook authenticates. Basic and Digest read the credentials from Auth Body; Bearer posts Auth Body to the Auth Endpoint to fetch a token. Leave unset to send unauthenticated.";
const $496ec6605150c375$export$46503681465eab5d = "Leave unset to send unauthenticated.";
const $496ec6605150c375$export$b7ada1bce3483f94 = "Authentication endpoint URL for bearer token requests.";
const $496ec6605150c375$export$1881653f44e2f564 = "JSON path to extract bearer token from auth response (e.g. 'token', 'access_token', 'data.token').";
const $496ec6605150c375$export$482fa57bdf4c22b0 = 'The credentials, as JSON: {"username": "...", "password": "..."}.';
const $496ec6605150c375$export$f4241f24187156a = "JSON body posted to the Auth Endpoint to request a token.";
const $496ec6605150c375$export$a5d26d27ad613e9e = "Saved value hidden. Type to replace it; leave it to keep the current value.";
const $496ec6605150c375$export$aa8e0e966e9d29dc = ({ values: values, onFieldChange: onFieldChange, errors: errors = {}, width: width = 350, compact: compact = false })=>{
    const authType = (0, $9vEj4.normalizeAuthType)(values.auth_type);
    const bearer = (0, $9vEj4.isBearer)(authType);
    const bodyMasked = (0, $9vEj4.isMaskedSecret)(values.auth_body);
    const tokenPathMasked = (0, $9vEj4.isMaskedSecret)(values.auth_token_path);
    const bodyError = errors.auth_body || (0, $9vEj4.authBodyJsonError)(values.auth_body);
    // Focusing a masked secret selects it, so typing replaces the dots.
    const selectIfMasked = (event)=>{
        if ((0, $9vEj4.isMaskedSecret)(event.target.value)) event.target.select();
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "flex flex-col gap-4",
        "data-testid": "webhook-auth-fields",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                select: true,
                SelectProps: {
                    native: true
                },
                label: "Auth Type",
                variant: "standard",
                value: authType,
                onChange: (event)=>{
                    const nextValue = event.target.value;
                    onFieldChange("auth_type", nextValue || null);
                },
                error: Boolean(errors.auth_type),
                helperText: errors.auth_type || (compact ? $496ec6605150c375$export$46503681465eab5d : $496ec6605150c375$export$6ca3f257b16fc18f),
                title: compact ? $496ec6605150c375$export$6ca3f257b16fc18f : undefined,
                InputLabelProps: {
                    shrink: true
                },
                inputProps: {
                    "aria-label": "Auth Type"
                },
                sx: {
                    fontFamily: "Mulish",
                    width: width
                },
                children: (0, $9vEj4.WEBHOOK_AUTH_TYPE_OPTIONS).map((option)=>/*#__PURE__*/ (0, $k4ank.jsx)("option", {
                        value: option.value,
                        children: option.label
                    }, option.value || "none"))
            }),
            bearer && /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                label: "Auth Endpoint",
                variant: "standard",
                type: "url",
                placeholder: "https://host/api/v2/login",
                value: values.auth_endpoint ?? "",
                onChange: (event)=>{
                    const nextValue = event.target.value;
                    onFieldChange("auth_endpoint", nextValue);
                },
                error: Boolean(errors.auth_endpoint),
                helperText: errors.auth_endpoint || $496ec6605150c375$export$b7ada1bce3483f94,
                inputProps: {
                    "aria-label": "Auth Endpoint"
                },
                sx: {
                    fontFamily: "Mulish",
                    width: width
                }
            }),
            authType && /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                label: "Auth Body",
                variant: "outlined",
                multiline: true,
                rows: 4,
                autoComplete: "off",
                value: values.auth_body ?? "",
                onFocus: selectIfMasked,
                onChange: (event)=>{
                    const nextValue = event.target.value;
                    onFieldChange("auth_body", nextValue);
                },
                error: Boolean(bodyError),
                helperText: bodyError || (bodyMasked ? $496ec6605150c375$export$a5d26d27ad613e9e : bearer ? $496ec6605150c375$export$f4241f24187156a : $496ec6605150c375$export$482fa57bdf4c22b0),
                inputProps: {
                    "aria-label": "Auth Body",
                    spellCheck: false
                },
                sx: {
                    fontFamily: "Mulish",
                    width: width
                }
            }),
            bearer && /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                label: "Auth Token Path",
                variant: "standard",
                autoComplete: "off",
                value: values.auth_token_path ?? "",
                onFocus: selectIfMasked,
                onChange: (event)=>{
                    const nextValue = event.target.value;
                    onFieldChange("auth_token_path", nextValue);
                },
                error: Boolean(errors.auth_token_path),
                helperText: errors.auth_token_path || (tokenPathMasked ? $496ec6605150c375$export$a5d26d27ad613e9e : $496ec6605150c375$export$1881653f44e2f564),
                inputProps: {
                    "aria-label": "Auth Token Path"
                },
                sx: {
                    fontFamily: "Mulish",
                    width: width
                }
            })
        ]
    });
};
const $496ec6605150c375$export$44dca250e1174035 = ({ webhook: webhook })=>{
    const authType = (0, $9vEj4.normalizeAuthType)(webhook?.auth_type);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "flex flex-col gap-1",
        "data-testid": "webhook-auth-summary",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                children: (0, $9vEj4.authTypeLabel)(webhook?.auth_type)
            }),
            (0, $9vEj4.isBearer)(authType) && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                        children: [
                            "Endpoint: ",
                            webhook?.auth_endpoint || "\u2014"
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                        children: [
                            "Token path: ",
                            webhook?.auth_token_path || "\u2014"
                        ]
                    })
                ]
            }),
            authType && webhook?.auth_body && /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                className: "whitespace-pre-wrap break-all",
                children: [
                    "Body: ",
                    webhook.auth_body
                ]
            })
        ]
    });
};

});
parcelRegister("9vEj4", function(module, exports) {

$parcel$export(module.exports, "WEBHOOK_AUTH_TYPE_OPTIONS", () => $ab89750a9422e21c$export$eb468178f35d3be1);
$parcel$export(module.exports, "EMPTY_WEBHOOK_AUTH_VALUES", () => $ab89750a9422e21c$export$71ebdae1eba8fe49);
$parcel$export(module.exports, "normalizeAuthType", () => $ab89750a9422e21c$export$7848c38d1c6aae10);
$parcel$export(module.exports, "authTypeLabel", () => $ab89750a9422e21c$export$699a284402d7e2c4);
$parcel$export(module.exports, "isBearer", () => $ab89750a9422e21c$export$e74bb6867a710f22);
$parcel$export(module.exports, "isMaskedSecret", () => $ab89750a9422e21c$export$4e9c5f45a7adb305);
$parcel$export(module.exports, "pickWebhookAuthValues", () => $ab89750a9422e21c$export$a15352a895af0232);
$parcel$export(module.exports, "authBodyJsonError", () => $ab89750a9422e21c$export$bb4ebde48a4e439c);
$parcel$export(module.exports, "applyWebhookAuthFieldToPatch", () => $ab89750a9422e21c$export$7bb9c87ca6009e5c);
$parcel$export(module.exports, "buildWebhookAuthCreatePayload", () => $ab89750a9422e21c$export$23b915aef94a6209);
$parcel$export(module.exports, "extractWebhookFieldErrors", () => $ab89750a9422e21c$export$c3bc0cc97911d2fc);
/**
 * Webhook authentication fields (ENG-1737).
 *
 * Mirrors actuate_admin's WebhookCustomer auth fields
 * (api/serializers/webhook/webhook_customer_base_serializer.py):
 * auth_type, auth_endpoint, auth_body, auth_token_path.
 *
 * auth_body and auth_token_path are credentials: a reader without
 * view_passwords gets them back as WEBHOOK_SECRET_MASK. The server treats an
 * echoed auth_body mask as "unchanged", but NOT an echoed auth_token_path mask
 * (it would save the dots), so the forms only ever send a secret the user
 * actually edited.
 */ const $ab89750a9422e21c$export$421af6fa00b8b274 = "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022";
const $ab89750a9422e21c$export$eb468178f35d3be1 = [
    {
        value: "",
        label: "None"
    },
    {
        value: "basic",
        label: "Basic"
    },
    {
        value: "digest",
        label: "Digest"
    },
    {
        value: "bearer",
        label: "Bearer Token"
    }
];
const $ab89750a9422e21c$export$71ebdae1eba8fe49 = {
    auth_type: null,
    auth_endpoint: null,
    auth_body: null,
    auth_token_path: null
};
const $ab89750a9422e21c$export$7848c38d1c6aae10 = (authType)=>authType ? authType.trim().toLowerCase() : "";
const $ab89750a9422e21c$export$699a284402d7e2c4 = (authType)=>{
    const normalized = $ab89750a9422e21c$export$7848c38d1c6aae10(authType);
    const option = $ab89750a9422e21c$export$eb468178f35d3be1.find((candidate)=>candidate.value === normalized);
    return option ? option.label : authType || "None";
};
const $ab89750a9422e21c$export$e74bb6867a710f22 = (authType)=>$ab89750a9422e21c$export$7848c38d1c6aae10(authType) === "bearer";
const $ab89750a9422e21c$export$4e9c5f45a7adb305 = (value)=>value === $ab89750a9422e21c$export$421af6fa00b8b274;
const $ab89750a9422e21c$export$a15352a895af0232 = (webhook)=>({
        auth_type: webhook?.auth_type ?? null,
        auth_endpoint: webhook?.auth_endpoint ?? null,
        auth_body: webhook?.auth_body ?? null,
        auth_token_path: webhook?.auth_token_path ?? null
    });
/** Blank form values map to null; auth_body "" would fail the server's JSON parse. */ const $ab89750a9422e21c$var$toWireValue = (field, value)=>{
    if (value === null || value === undefined) return null;
    if (field === "auth_type") return $ab89750a9422e21c$export$7848c38d1c6aae10(value) || null;
    if (field === "auth_endpoint") return value.trim() || null;
    return value.trim() === "" ? null : value;
};
const $ab89750a9422e21c$export$bb4ebde48a4e439c = (value)=>{
    if (!value || !value.trim() || $ab89750a9422e21c$export$4e9c5f45a7adb305(value)) return null;
    try {
        JSON.parse(value);
        return null;
    } catch  {
        return "Auth Body must be valid JSON.";
    }
};
const $ab89750a9422e21c$export$7bb9c87ca6009e5c = (patch, field, value, initialValue)=>{
    const next = {
        ...patch
    };
    const wireValue = $ab89750a9422e21c$var$toWireValue(field, value);
    if (wireValue === $ab89750a9422e21c$var$toWireValue(field, initialValue) || $ab89750a9422e21c$export$4e9c5f45a7adb305(value)) delete next[field];
    else next[field] = wireValue;
    return next;
};
const $ab89750a9422e21c$export$23b915aef94a6209 = (values)=>{
    const authType = $ab89750a9422e21c$export$7848c38d1c6aae10(values.auth_type);
    if (!authType) return {
        auth_type: null
    };
    const payload = {
        auth_type: authType,
        auth_body: $ab89750a9422e21c$var$toWireValue("auth_body", values.auth_body)
    };
    if (authType === "bearer") {
        payload.auth_endpoint = $ab89750a9422e21c$var$toWireValue("auth_endpoint", values.auth_endpoint);
        payload.auth_token_path = $ab89750a9422e21c$var$toWireValue("auth_token_path", values.auth_token_path);
    }
    return payload;
};
const $ab89750a9422e21c$export$c3bc0cc97911d2fc = (reason)=>{
    if (reason?.response?.status !== 400) return {};
    const data = reason.response.data;
    if (!data || typeof data !== "object" || Array.isArray(data)) return {};
    const errors = {};
    Object.entries(data).forEach(([field, messages])=>{
        if (Array.isArray(messages) && messages.length > 0) errors[field] = String(messages[0]);
        else if (typeof messages === "string" && messages) errors[field] = messages;
    });
    return errors;
};

});


parcelRegister("7l43O", function(module, exports) {

$parcel$export(module.exports, "shouldShowWebhooksTab", () => $4cedcc9a2af2ece2$export$1e09d1d5b6ceea2e);
$parcel$export(module.exports, "canEditSiteWebhooks", () => $4cedcc9a2af2ece2$export$36aafca11e198bd4);
$parcel$export(module.exports, "mergeWebhookById", () => $4cedcc9a2af2ece2$export$8823984162baabbd);
$parcel$export(module.exports, "pendingWebhookPatches", () => $4cedcc9a2af2ece2$export$1e883f8a1f15143c);
$parcel$export(module.exports, "jsonTextError", () => $4cedcc9a2af2ece2$export$3b2b9e3ea75a64fe);
/**
 * Site-level webhook helpers (ENG-2233 / SUP-757).
 *
 * A site can own any number of WebhookCustomer rows; `GET
 * webhook_customer/?customer=<id>` returns all of them unpaginated. The Site
 * About tab shows one row per webhook and edits them independently, so the
 * pending edits are kept per webhook id rather than as one flat patch.
 */ 
var $7IAhZ = parcelRequire("7IAhZ");
const $4cedcc9a2af2ece2$export$f0b54207f480064c = "Webhooks";
const $4cedcc9a2af2ece2$export$1e09d1d5b6ceea2e = (siteInfo, webhooksInfo)=>{
    if (siteInfo?.webhooks) return true;
    if ((0, $7IAhZ.getDefaultAlarmName)(siteInfo?.default_alarm) === $4cedcc9a2af2ece2$export$f0b54207f480064c) return true;
    return Array.isArray(webhooksInfo) && webhooksInfo.length > 0;
};
const $4cedcc9a2af2ece2$export$36aafca11e198bd4 = ()=>{
    try {
        const userInfo = JSON.parse(localStorage.userInfo ?? "null");
        return Boolean(userInfo?.permission?.edit_cameras);
    } catch  {
        return false;
    }
};
const $4cedcc9a2af2ece2$export$8823984162baabbd = (webhooks, webhook)=>{
    const index = webhooks.findIndex((candidate)=>candidate.id === webhook.id);
    if (index === -1) return [
        ...webhooks,
        webhook
    ];
    const next = [
        ...webhooks
    ];
    next[index] = webhook;
    return next;
};
const $4cedcc9a2af2ece2$export$1e883f8a1f15143c = (patchMap)=>Object.entries(patchMap ?? {}).filter(([, patch])=>patch && Object.keys(patch).length > 0).map(([id, patch])=>[
            Number(id),
            patch
        ]);
const $4cedcc9a2af2ece2$export$3b2b9e3ea75a64fe = (value, label)=>{
    if (!value || !value.trim()) return null;
    try {
        JSON.parse(value);
        return null;
    } catch  {
        return `${label} must be valid JSON.`;
    }
};

});
parcelRegister("7IAhZ", function(module, exports) {

$parcel$export(module.exports, "getDefaultAlarmName", () => $176c1361ea1d571c$export$12fcfca5a5ca6d36);
const $176c1361ea1d571c$var$buildAlarmNamesMap = ()=>{
    const alarmNames = new Map();
    if (!localStorage.alarmOptions) return alarmNames;
    const alarmOptions = JSON.parse(localStorage.alarmOptions);
    alarmOptions.forEach((object)=>{
        alarmNames.set(object.value, object.name);
        alarmNames.set(String(object.value), object.name);
        const numericValue = Number(object.value);
        if (!Number.isNaN(numericValue)) alarmNames.set(numericValue, object.name);
    });
    return alarmNames;
};
const $176c1361ea1d571c$export$12fcfca5a5ca6d36 = (defaultAlarmId)=>{
    if (defaultAlarmId === null || defaultAlarmId === undefined) return undefined;
    const alarmNames = $176c1361ea1d571c$var$buildAlarmNamesMap();
    return alarmNames.get(defaultAlarmId) ?? alarmNames.get(String(defaultAlarmId)) ?? (typeof defaultAlarmId === "string" ? alarmNames.get(Number(defaultAlarmId)) : undefined);
};

});



parcelRegister("lbXkF", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd5ea549b3698647$export$2e2bcd8739ae039);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");

var $aRSHn = parcelRequire("aRSHn");

var $9vEj4 = parcelRequire("9vEj4");

var $iXV9W = parcelRequire("iXV9W");
const $fd5ea549b3698647$var$capitalize = (value)=>value ? value.charAt(0).toUpperCase() + value.slice(1) : "";
/** One editable row. Its edits land under its own id in the patch map. */ const $fd5ea549b3698647$var$WebhookEditRow = ({ webhook: webhook, setWebhooksPatchObject: setWebhooksPatchObject, setWebhooksChangesMade: setWebhooksChangesMade, fieldErrors: fieldErrors = {} })=>{
    const [method, setMethod] = $8T3gX.useState(webhook.method);
    // What the server returned (secrets possibly masked). Only fields that differ
    // from this go into the PATCH, so an untouched mask is never sent back.
    const savedAuthValues = $8T3gX.useMemo(()=>(0, $9vEj4.pickWebhookAuthValues)(webhook), [
        webhook
    ]);
    const [authValues, setAuthValues] = $8T3gX.useState(savedAuthValues);
    const patchField = (field, value)=>{
        setWebhooksPatchObject((previousState)=>({
                ...previousState,
                [webhook.id]: {
                    ...previousState?.[webhook.id] ?? {},
                    [field]: value
                }
            }));
        setWebhooksChangesMade(true);
    };
    const handleAuthFieldChange = (field, value)=>{
        setAuthValues((previousState)=>({
                ...previousState,
                [field]: value
            }));
        setWebhooksPatchObject((previousState)=>({
                ...previousState,
                [webhook.id]: (0, $9vEj4.applyWebhookAuthFieldToPatch)(previousState?.[webhook.id] ?? {}, field, value, savedAuthValues[field])
            }));
        setWebhooksChangesMade(true);
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
        "data-testid": `site-webhook-edit-row-${webhook.id}`,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                align: "left",
                sx: {
                    fontFamily: "Mulish"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    defaultValue: webhook.display_name,
                    variant: "standard",
                    sx: {
                        width: 200
                    },
                    type: "string",
                    error: Boolean(fieldErrors.display_name),
                    helperText: fieldErrors.display_name,
                    inputProps: {
                        "aria-label": "Display Name"
                    },
                    onChange: (event)=>{
                        const nextValue = event.target.value;
                        patchField("display_name", nextValue);
                    }
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                align: "left",
                sx: {
                    fontFamily: "Mulish"
                },
                children: $fd5ea549b3698647$var$capitalize(webhook.webhook_type)
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                align: "left",
                sx: {
                    fontFamily: "Mulish"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                    value: method,
                    options: [
                        "GET",
                        "POST"
                    ],
                    slotProps: {
                        popper: {
                            placement: "bottom-start"
                        }
                    },
                    onChange: (event, value)=>{
                        setMethod(value);
                        patchField("method", value);
                    },
                    renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                            ...params,
                            label: "Method",
                            autoComplete: "off",
                            variant: "standard",
                            sx: {
                                width: 120
                            }
                        })
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                align: "left",
                sx: {
                    fontFamily: "Mulish"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    defaultValue: webhook.target_url,
                    variant: "standard",
                    sx: {
                        width: 350
                    },
                    type: "string",
                    error: Boolean(fieldErrors.target_url),
                    helperText: fieldErrors.target_url,
                    inputProps: {
                        "aria-label": "Target URL"
                    },
                    onChange: (event)=>{
                        const nextValue = event.target.value;
                        patchField("target_url", nextValue);
                    }
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                align: "left",
                sx: {
                    fontFamily: "Mulish"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    multiline: true,
                    rows: 4,
                    defaultValue: webhook.message_body,
                    variant: "outlined",
                    sx: {
                        width: 400
                    },
                    type: "string",
                    error: Boolean(fieldErrors.message_body),
                    helperText: fieldErrors.message_body || "*optional",
                    inputProps: {
                        "aria-label": "Message Body"
                    },
                    onChange: (event)=>{
                        const nextValue = event.target.value;
                        patchField("message_body", nextValue);
                    }
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                align: "left",
                sx: {
                    fontFamily: "Mulish"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aRSHn.WebhookAuthFields), {
                    values: authValues,
                    errors: fieldErrors,
                    onFieldChange: handleAuthFieldChange,
                    width: 320,
                    compact: true
                })
            })
        ]
    });
};
/**
 * Site About → Webhooks in edit mode: one editable row per site webhook
 * (ENG-2233). Pending edits are keyed by webhook id so Save Changes can
 * PATCH each changed webhook on its own.
 */ const $fd5ea549b3698647$var$WebhooksTabEditMode = ({ webhooksInfo: webhooksInfo, setWebhooksPatchObject: setWebhooksPatchObject, setWebhooksChangesMade: setWebhooksChangesMade, fieldErrorsById: fieldErrorsById = {} })=>{
    const webhooks = Array.isArray(webhooksInfo) ? webhooksInfo : [];
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
            sx: {
                minWidth: 1000,
                fontFamily: "Mulish"
            },
            "aria-label": "simple table",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                    titlesArray: (0, $iXV9W.WEBHOOKS_TAB_TITLES)
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                    children: webhooks.map((webhook)=>/*#__PURE__*/ (0, $k4ank.jsx)($fd5ea549b3698647$var$WebhookEditRow, {
                            webhook: webhook,
                            setWebhooksPatchObject: setWebhooksPatchObject,
                            setWebhooksChangesMade: setWebhooksChangesMade,
                            fieldErrors: fieldErrorsById[webhook.id]
                        }, webhook.id))
                })
            ]
        })
    });
};
var $fd5ea549b3698647$export$2e2bcd8739ae039 = $fd5ea549b3698647$var$WebhooksTabEditMode;

});

parcelRegister("f7Odp", function(module, exports) {

$parcel$export(module.exports, "EvalinkTab", () => $8a09d271375a6e46$export$e21c411b778901dd);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $3FJ79 = parcelRequire("3FJ79");
const $8a09d271375a6e46$export$e21c411b778901dd = ()=>{
    const { evalinkData: evalinkData } = (0, $3FJ79.useSiteAboutStore)();
    const titlesArray = [
        "Evalink Company ID",
        "Evalink Token",
        "Evalink Device ID"
    ];
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        sx: {
            width: "screen"
        },
        children: [
            evalinkData && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                sx: {
                    postion: "absolute",
                    width: "screen",
                    fontFamily: "Mulish"
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                        titlesArray: titlesArray
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: evalinkData.evalink_company_id
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: evalinkData.evalink_token
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: evalinkData.evalink_device_id
                                })
                            ]
                        })
                    })
                ]
            }),
            !evalinkData && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "font-mulish text-[#283E6D] text-[20px] text-center",
                children: "No Evalink info added."
            })
        ]
    });
};

});

parcelRegister("2wmRq", function(module, exports) {

$parcel$export(module.exports, "EvalinkTabEditMode", () => $8bba3becbddc697e$export$be1c44c19d8d9437);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $3FJ79 = parcelRequire("3FJ79");

var $eejVe = parcelRequire("eejVe");
const $8bba3becbddc697e$export$be1c44c19d8d9437 = ()=>{
    const { evalinkData: evalinkData, evalinkPatchObject: evalinkPatchObject, setEvalinkPatchObject: setEvalinkPatchObject, setEvalinkChangesMade: setEvalinkChangesMade } = (0, $3FJ79.useSiteAboutStore)();
    const titlesArray = [
        "Evalink Company ID",
        "Evalink Token",
        "Evalink Device ID"
    ];
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        sx: {
            width: "screen"
        },
        children: [
            evalinkData && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                sx: {
                    postion: "absolute",
                    width: "screen",
                    fontFamily: "Mulish"
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                        titlesArray: titlesArray
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        defaultValue: evalinkData.evalink_company_id,
                                        variant: "standard",
                                        sx: {
                                            width: 400
                                        },
                                        type: "string",
                                        onChange: (event)=>{
                                            setEvalinkPatchObject({
                                                ...evalinkPatchObject,
                                                evalink_company_id: event.target.value
                                            });
                                            setEvalinkChangesMade(true);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        defaultValue: evalinkData.evalink_token,
                                        variant: "standard",
                                        sx: {
                                            width: 400
                                        },
                                        type: "string",
                                        onChange: (event)=>{
                                            setEvalinkPatchObject({
                                                ...evalinkPatchObject,
                                                evalink_token: event.target.value
                                            });
                                            setEvalinkChangesMade(true);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        defaultValue: evalinkData.evalink_device_id,
                                        variant: "standard",
                                        sx: {
                                            width: 400
                                        },
                                        type: "string",
                                        onChange: (event)=>{
                                            setEvalinkPatchObject({
                                                ...evalinkPatchObject,
                                                evalink_device_id: event.target.value
                                            });
                                            setEvalinkChangesMade(true);
                                        }
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            !evalinkData && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "font-mulish text-[#283E6D] text-[20px] text-center",
                children: "No Evalink info added."
            })
        ]
    });
};

});

parcelRegister("4k3Fk", function(module, exports) {

$parcel$export(module.exports, "WireGuardTab", () => $32fb898fa0dfd462$export$e582a5cf0a4876f2);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $3QMQN = parcelRequire("3QMQN");

var $kPQvK = parcelRequire("kPQvK");

var $avFl2 = parcelRequire("avFl2");

var $1X9Ds = parcelRequire("1X9Ds");

var $5gr4N = parcelRequire("5gr4N");

var $lWchQ = parcelRequire("lWchQ");

var $2aMB5 = parcelRequire("2aMB5");

var $aYdit = parcelRequire("aYdit");

var $6DsZ5 = parcelRequire("6DsZ5");

var $eiVsn = parcelRequire("eiVsn");

var $qUQ1f = parcelRequire("qUQ1f");

var $6oM0Y = parcelRequire("6oM0Y");
const $32fb898fa0dfd462$var$headCellSx = {
    fontFamily: "Mulish",
    fontWeight: "bold"
};
const $32fb898fa0dfd462$var$formatHost = (host)=>`${host.label} ${host.address}`;
const $32fb898fa0dfd462$var$TunnelDetailsTable = ({ tunnel: tunnel, wireGuardOptions: wireGuardOptions })=>{
    const endpoint = tunnel.server == null ? "\u2014" : (0, $eiVsn.resolveWireguardServerEndpoint)(tunnel.server, wireGuardOptions);
    const serverPk = tunnel.server == null ? "\u2014" : (0, $eiVsn.resolveWireguardServerPublicKey)(tunnel.server, wireGuardOptions);
    const subnetsText = tunnel.subnets?.length ? tunnel.subnets.join(", ") : "\u2014";
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $k8Qy8.default), {
        sx: {
            fontFamily: "Mulish"
        },
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $gXvgZ.default), {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                            sx: $32fb898fa0dfd462$var$headCellSx,
                            children: "Name"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                            sx: $32fb898fa0dfd462$var$headCellSx,
                            children: "WireGuard server endpoint"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                            sx: $32fb898fa0dfd462$var$headCellSx,
                            children: "Server Public Key"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                            sx: $32fb898fa0dfd462$var$headCellSx,
                            children: "Client Public Key"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                            sx: $32fb898fa0dfd462$var$headCellSx,
                            children: "Client tunnel IP"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                            align: "left",
                            sx: {
                                fontFamily: "Mulish"
                            },
                            children: tunnel.name
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                            align: "left",
                            sx: {
                                fontFamily: "Mulish"
                            },
                            children: endpoint
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                            align: "left",
                            sx: {
                                fontFamily: "Mulish",
                                wordBreak: "break-all"
                            },
                            children: serverPk
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                            align: "left",
                            sx: {
                                fontFamily: "Mulish",
                                wordBreak: "break-all"
                            },
                            children: tunnel.client_public_key
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                            align: "left",
                            sx: {
                                fontFamily: "Mulish"
                            },
                            children: tunnel.client_tunnel_ip || "\u2014"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                            colSpan: 2,
                            sx: $32fb898fa0dfd462$var$headCellSx,
                            children: "Subnets"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                            sx: $32fb898fa0dfd462$var$headCellSx,
                            children: "Subnets are virtually assigned"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                            sx: $32fb898fa0dfd462$var$headCellSx,
                            children: "Tunnel status"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                            sx: $32fb898fa0dfd462$var$headCellSx,
                            children: "Last handshake"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                            colSpan: 2,
                            align: "left",
                            sx: {
                                fontFamily: "Mulish",
                                wordBreak: "break-all"
                            },
                            children: subnetsText
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                            align: "left",
                            sx: {
                                fontFamily: "Mulish"
                            },
                            children: tunnel.subnets_are_virtually_assigned ? (0, $lWchQ.checkedCircleIcon) : (0, $2aMB5.cancelIconRed)
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                            align: "left",
                            sx: {
                                fontFamily: "Mulish"
                            },
                            children: tunnel.tunnel_status ?? "\u2014"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                            align: "left",
                            sx: {
                                fontFamily: "Mulish"
                            },
                            children: (0, $eiVsn.formatWireguardLastHandshake)(tunnel.last_handshake)
                        })
                    ]
                })
            ]
        })
    });
};
/**
 * Resolve the tunnels this site uses from its addresses (ENG-2056). Needs
 * `siteId` and `site`; without them (legacy callers) nothing is resolved.
 */ const $32fb898fa0dfd462$var$useSiteTunnelUsage = (siteId, site, wireGuardOptions)=>{
    const [data, setData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        status: "idle"
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (siteId == null || siteId === "" || !site) {
            setData({
                status: "idle"
            });
            return;
        }
        let cancelled = false;
        setData({
            status: "loading"
        });
        (0, $qUQ1f.fetchSiteTunnelUsageData)(siteId).then(({ cameras: cameras, tunnels: tunnels })=>{
            if (!cancelled) setData({
                status: "ok",
                cameras: cameras,
                tunnels: tunnels
            });
        }).catch(()=>{
            if (!cancelled) setData({
                status: "error"
            });
        });
        return ()=>{
            cancelled = true;
        };
    // Refetch per site, not on every edit of the site record.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        siteId,
        Boolean(site)
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>{
        if (data.status !== "ok") return data;
        const hosts = (0, $6oM0Y.siteHosts)(site, data.cameras);
        const siteGateway = site?.wireguard ?? null;
        const usage = (0, $6oM0Y.resolveSiteTunnelUsage)(hosts, data.tunnels, (server)=>(0, $6oM0Y.gatewaysShareZone)(siteGateway, server, wireGuardOptions));
        return {
            status: "ok",
            usage: usage,
            hostCount: hosts.length
        };
    }, [
        data,
        site,
        wireGuardOptions
    ]);
};
const $32fb898fa0dfd462$var$SiteTunnelUsageSection = ({ state: state, siteGatewayLabel: siteGatewayLabel, wireGuardOptions: wireGuardOptions })=>{
    if (state.status === "idle") return null;
    if (state.status === "loading") return /*#__PURE__*/ (0, $k4ank.jsx)("p", {
        className: "font-mulish text-[#283E6D] text-[16px] px-[15px] py-[10px]",
        "data-testid": "site-tunnel-usage-loading",
        children: "Working out which tunnels this site uses\u2026"
    });
    if (state.status === "error") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
        severity: "warning",
        sx: {
            fontFamily: "Mulish",
            m: "10px 15px"
        },
        "data-testid": "site-tunnel-usage-error",
        children: "Couldn't work out which tunnels this site uses."
    });
    const { usage: usage, hostCount: hostCount } = state;
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        "data-testid": "site-tunnel-usage",
        className: "px-[15px] py-[10px]",
        children: [
            usage.used.length === 0 && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "font-mulish text-[#283E6D] text-[16px]",
                "data-testid": "site-tunnel-usage-none",
                children: hostCount === 0 ? "This site has no camera or server addresses to match to a tunnel." : usage.hostnames.length === hostCount ? "This site's addresses are hostnames, which can't be matched to a tunnel." : "No tunnel routes this site's addresses."
            }),
            usage.used.map(({ tunnel: tunnel, hosts: hosts, otherZone: otherZone })=>/*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "mb-4",
                    "data-testid": `site-tunnel-used-${tunnel.id}`,
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                            className: "font-mulish text-[14px] font-bold text-[#001943] mb-1",
                            children: [
                                "USED BY THIS SITE (",
                                hosts.length,
                                " ",
                                hosts.length === 1 ? "address" : "addresses",
                                "): ",
                                tunnel.name
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                            className: "font-mulish text-[14px] text-[#283E6D] mb-1",
                            children: [
                                "Routes ",
                                hosts.map($32fb898fa0dfd462$var$formatHost).join("; "),
                                tunnel.subnets_are_virtually_assigned ? " (these addresses are in the tunnel's virtual range)" : ""
                            ]
                        }),
                        otherZone && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                            severity: "warning",
                            sx: {
                                fontFamily: "Mulish",
                                mb: 1
                            },
                            "data-testid": `site-tunnel-other-zone-${tunnel.id}`,
                            children: siteGatewayLabel ? `This tunnel routes these addresses but is in a different zone from this site's connector (${siteGatewayLabel}), so the connector can't reach them through it.` : "This tunnel routes these addresses, but this site has no WireGuard gateway set, so its connector can't reach them through it."
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                            component: (0, $4reBM.default),
                            variant: "outlined",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)($32fb898fa0dfd462$var$TunnelDetailsTable, {
                                tunnel: tunnel,
                                wireGuardOptions: wireGuardOptions
                            })
                        })
                    ]
                }, tunnel.id)),
            usage.used.length > 0 && usage.notOnWireGuard.length > 0 && /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                className: "font-mulish text-[14px] text-[#283E6D] mb-1",
                "data-testid": "site-tunnel-not-on-wireguard",
                children: [
                    "Not on WireGuard: ",
                    usage.notOnWireGuard.map($32fb898fa0dfd462$var$formatHost).join("; ")
                ]
            }),
            usage.used.length > 0 && usage.hostnames.length > 0 && /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                className: "font-mulish text-[14px] text-[#283E6D] mb-1",
                "data-testid": "site-tunnel-hostnames",
                children: [
                    "Hostnames can't be matched to a tunnel:",
                    " ",
                    usage.hostnames.map($32fb898fa0dfd462$var$formatHost).join("; ")
                ]
            })
        ]
    });
};
const $32fb898fa0dfd462$export$e582a5cf0a4876f2 = ({ wireguardTunnels: wireguardTunnels, wireguardTunnelsLoading: wireguardTunnelsLoading, selectedTunnelId: selectedTunnelId, onSelectTunnelId: onSelectTunnelId, siteId: siteId, site: site })=>{
    const wireGuardOptions = (0, $aYdit.useAppStore)((s)=>s.wireGuardOptions);
    const usageState = $32fb898fa0dfd462$var$useSiteTunnelUsage(siteId, site, wireGuardOptions);
    const usedIds = new Set(usageState.status === "ok" ? usageState.usage.used.map(({ tunnel: tunnel })=>tunnel.id) : []);
    const otherTunnels = wireguardTunnels.filter((t)=>!usedIds.has(t.id));
    const tunnel = (0, $eiVsn.getSelectedWireguardTunnel)(otherTunnels, selectedTunnelId);
    const resolving = usageState.status !== "idle";
    const siteGateway = site?.wireguard ?? null;
    const siteGatewayLabel = siteGateway == null ? null : (0, $eiVsn.resolveWireguardServerEndpoint)(siteGateway, wireGuardOptions);
    if (wireguardTunnelsLoading) return /*#__PURE__*/ (0, $k4ank.jsx)("p", {
        className: "font-mulish text-[#283E6D] text-[16px]",
        children: "Loading WireGuard tunnels\u2026"
    });
    if (!resolving && !tunnel) return /*#__PURE__*/ (0, $k4ank.jsx)("p", {
        className: "font-mulish text-[#283E6D] text-[20px] text-center",
        children: "No WireGuard tunnel data"
    });
    const otherList = tunnel ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $6DsZ5.WireGuardTunnelSelect), {
                tunnels: otherTunnels,
                selectedTunnelId: selectedTunnelId,
                onSelectTunnelId: onSelectTunnelId
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)($32fb898fa0dfd462$var$TunnelDetailsTable, {
                tunnel: tunnel,
                wireGuardOptions: wireGuardOptions
            })
        ]
    }) : null;
    if (!resolving) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        sx: {
            width: "100%",
            maxWidth: "100%"
        },
        children: otherList
    });
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4reBM.default), {
        sx: {
            width: "100%",
            maxWidth: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)($32fb898fa0dfd462$var$SiteTunnelUsageSection, {
                state: usageState,
                siteGatewayLabel: siteGatewayLabel,
                wireGuardOptions: wireGuardOptions
            }),
            otherTunnels.length > 0 && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kPQvK.default), {
                disableGutters: true,
                elevation: 0,
                defaultExpanded: usageState.status === "error",
                "data-testid": "other-account-tunnels",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $avFl2.default), {
                        expandIcon: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5gr4N))), {}),
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                            className: "font-mulish text-[14px] font-bold text-[#001943]",
                            children: [
                                "Other tunnels in this account (",
                                otherTunnels.length,
                                ")"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1X9Ds.default), {
                        sx: {
                            p: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                className: "font-mulish text-[13px] text-[#283E6D] px-[15px]",
                                children: [
                                    "A site uses whichever tunnel routes its camera addresses",
                                    usageState.status === "ok" ? ", so these tunnels don't carry this site." : "."
                                ]
                            }),
                            otherList
                        ]
                    })
                ]
            }, usageState.status)
        ]
    });
};

});
parcelRegister("kPQvK", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2b14dab7232ad9e$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $7Se60 = parcelRequire("7Se60");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $bPpmJ = parcelRequire("bPpmJ");

var $aYNpO = parcelRequire("aYNpO");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $yndCB = parcelRequire("yndCB");

var $4reBM = parcelRequire("4reBM");

var $a4qEb = parcelRequire("a4qEb");

var $7Wcl5 = parcelRequire("7Wcl5");

var $eDtj5 = parcelRequire("eDtj5");

var $blblS = parcelRequire("blblS");

var $k4ank = parcelRequire("k4ank");
'use client';
const $f2b14dab7232ad9e$var$_excluded = [
    "children",
    "className",
    "defaultExpanded",
    "disabled",
    "disableGutters",
    "expanded",
    "onChange",
    "square",
    "slots",
    "slotProps",
    "TransitionComponent",
    "TransitionProps"
];
const $f2b14dab7232ad9e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, square: square, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            !square && 'rounded',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        region: [
            'region'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $blblS.getAccordionUtilityClass), classes);
};
const $f2b14dab7232ad9e$var$AccordionRoot = (0, $anJSP.default)((0, $4reBM.default), {
    name: 'MuiAccordion',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $blblS.default).region}`]: styles.region
            },
            styles.root,
            !ownerState.square && styles.rounded,
            !ownerState.disableGutters && styles.gutters
        ];
    }
})(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        position: 'relative',
        transition: theme.transitions.create([
            'margin'
        ], transition),
        overflowAnchor: 'none',
        // Keep the same scrolling position
        '&::before': {
            position: 'absolute',
            left: 0,
            top: -1,
            right: 0,
            height: 1,
            content: '""',
            opacity: 1,
            backgroundColor: (theme.vars || theme).palette.divider,
            transition: theme.transitions.create([
                'opacity',
                'background-color'
            ], transition)
        },
        '&:first-of-type': {
            '&::before': {
                display: 'none'
            }
        },
        [`&.${(0, $blblS.default).expanded}`]: {
            '&::before': {
                opacity: 0
            },
            '&:first-of-type': {
                marginTop: 0
            },
            '&:last-of-type': {
                marginBottom: 0
            },
            '& + &': {
                '&::before': {
                    display: 'none'
                }
            }
        },
        [`&.${(0, $blblS.default).disabled}`]: {
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    };
}, ({ theme: theme })=>({
        variants: [
            {
                props: (props)=>!props.square,
                style: {
                    borderRadius: 0,
                    '&:first-of-type': {
                        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderTopRightRadius: (theme.vars || theme).shape.borderRadius
                    },
                    '&:last-of-type': {
                        borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
                        // Fix a rendering issue on Edge
                        '@supports (-ms-ime-align: auto)': {
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0
                        }
                    }
                }
            },
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $blblS.default).expanded}`]: {
                        margin: '16px 0'
                    }
                }
            }
        ]
    }));
const $f2b14dab7232ad9e$var$Accordion = /*#__PURE__*/ $8T3gX.forwardRef(function Accordion(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordion'
    });
    const { children: childrenProp, className: className, defaultExpanded: defaultExpanded = false, disabled: disabled = false, disableGutters: disableGutters = false, expanded: expandedProp, onChange: onChange, square: square = false, slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionPropsProp } = props, other = (0, $fAJB5.default)(props, $f2b14dab7232ad9e$var$_excluded);
    const [expanded, setExpandedState] = (0, $7Wcl5.default)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: 'Accordion',
        state: 'expanded'
    });
    const handleChange = $8T3gX.useCallback((event)=>{
        setExpandedState(!expanded);
        if (onChange) onChange(event, !expanded);
    }, [
        expanded,
        onChange,
        setExpandedState
    ]);
    const [summary, ...children] = $8T3gX.Children.toArray(childrenProp);
    const contextValue = $8T3gX.useMemo(()=>({
            expanded: expanded,
            disabled: disabled,
            disableGutters: disableGutters,
            toggle: handleChange
        }), [
        expanded,
        disabled,
        disableGutters,
        handleChange
    ]);
    const ownerState = (0, $eJfrs.default)({}, props, {
        square: square,
        disabled: disabled,
        disableGutters: disableGutters,
        expanded: expanded
    });
    const classes = $f2b14dab7232ad9e$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = (0, $eJfrs.default)({
        transition: TransitionComponentProp
    }, slots);
    const backwardCompatibleSlotProps = (0, $eJfrs.default)({
        transition: TransitionPropsProp
    }, slotProps);
    const [TransitionSlot, transitionProps] = (0, $eDtj5.default)('transition', {
        elementType: (0, $yndCB.default),
        externalForwardedProps: {
            slots: backwardCompatibleSlots,
            slotProps: backwardCompatibleSlotProps
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $k4ank.jsxs)($f2b14dab7232ad9e$var$AccordionRoot, (0, $eJfrs.default)({
        className: (0, $iVyaN.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        square: square
    }, other, {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $a4qEb.default).Provider, {
                value: contextValue,
                children: summary
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)(TransitionSlot, (0, $eJfrs.default)({
                in: expanded,
                timeout: "auto"
            }, transitionProps, {
                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    "aria-labelledby": summary.props.id,
                    id: summary.props['aria-controls'],
                    role: "region",
                    className: classes.region,
                    children: children
                })
            }))
        ]
    }));
});
$f2b14dab7232ad9e$var$Accordion.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, $bPpmJ.default)((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node.isRequired, (props)=>{
        const summary = $8T3gX.Children.toArray(props.children)[0];
        if ((0, $7Se60.isFragment)(summary)) return new Error("MUI: The Accordion doesn't accept a Fragment as a child. Consider providing an array instead.");
        if (!/*#__PURE__*/ $8T3gX.isValidElement(summary)) return new Error('MUI: Expected the first child of Accordion to be a valid element.');
        return null;
    }),
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true`, expands the accordion by default.
   * @default false
   */ defaultExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, it removes the margin between two expanded accordion items and the increase of height.
   * @default false
   */ disableGutters: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, expands the accordion, otherwise collapse it.
   * Setting this prop enables control over the accordion.
   */ expanded: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {boolean} expanded The `expanded` state of the accordion.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        transition: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        transition: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * If `true`, rounded corners are disabled.
   * @default false
   */ square: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   */ TransitionComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   */ TransitionProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
};
var $f2b14dab7232ad9e$export$2e2bcd8739ae039 = $f2b14dab7232ad9e$var$Accordion;

});
parcelRegister("a4qEb", function(module, exports) {

$parcel$export(module.exports, "default", () => $754ef2ab101004d6$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");
'use client';
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const $754ef2ab101004d6$var$AccordionContext = /*#__PURE__*/ $8T3gX.createContext({});
$754ef2ab101004d6$var$AccordionContext.displayName = 'AccordionContext';
var $754ef2ab101004d6$export$2e2bcd8739ae039 = $754ef2ab101004d6$var$AccordionContext;

});

parcelRegister("blblS", function(module, exports) {

$parcel$export(module.exports, "getAccordionUtilityClass", () => $841a761bca582752$export$80fb6a2cb3f13b8b);
$parcel$export(module.exports, "default", () => $841a761bca582752$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $841a761bca582752$export$80fb6a2cb3f13b8b(slot) {
    return (0, $kfTYv.default)('MuiAccordion', slot);
}
const $841a761bca582752$var$accordionClasses = (0, $jh2Zm.default)('MuiAccordion', [
    'root',
    'rounded',
    'expanded',
    'disabled',
    'gutters',
    'region'
]);
var $841a761bca582752$export$2e2bcd8739ae039 = $841a761bca582752$var$accordionClasses;

});


parcelRegister("avFl2", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a6cdd8f8ee60b59$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $hhKOZ = parcelRequire("hhKOZ");

var $a4qEb = parcelRequire("a4qEb");

var $7N6Wx = parcelRequire("7N6Wx");

var $k4ank = parcelRequire("k4ank");
'use client';
const $7a6cdd8f8ee60b59$var$_excluded = [
    "children",
    "className",
    "expandIcon",
    "focusVisibleClassName",
    "onClick"
];
const $7a6cdd8f8ee60b59$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        focusVisible: [
            'focusVisible'
        ],
        content: [
            'content',
            expanded && 'expanded',
            !disableGutters && 'contentGutters'
        ],
        expandIconWrapper: [
            'expandIconWrapper',
            expanded && 'expanded'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $7N6Wx.getAccordionSummaryUtilityClass), classes);
};
const $7a6cdd8f8ee60b59$var$AccordionSummaryRoot = (0, $anJSP.default)((0, $hhKOZ.default), {
    name: 'MuiAccordionSummary',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        display: 'flex',
        minHeight: 48,
        padding: theme.spacing(0, 2),
        transition: theme.transitions.create([
            'min-height',
            'background-color'
        ], transition),
        [`&.${(0, $7N6Wx.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $7N6Wx.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`&:hover:not(.${(0, $7N6Wx.default).disabled})`]: {
            cursor: 'pointer'
        },
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $7N6Wx.default).expanded}`]: {
                        minHeight: 64
                    }
                }
            }
        ]
    };
});
const $7a6cdd8f8ee60b59$var$AccordionSummaryContent = (0, $anJSP.default)('div', {
    name: 'MuiAccordionSummary',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})(({ theme: theme })=>({
        display: 'flex',
        flexGrow: 1,
        margin: '12px 0',
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    transition: theme.transitions.create([
                        'margin'
                    ], {
                        duration: theme.transitions.duration.shortest
                    }),
                    [`&.${(0, $7N6Wx.default).expanded}`]: {
                        margin: '20px 0'
                    }
                }
            }
        ]
    }));
const $7a6cdd8f8ee60b59$var$AccordionSummaryExpandIconWrapper = (0, $anJSP.default)('div', {
    name: 'MuiAccordionSummary',
    slot: 'ExpandIconWrapper',
    overridesResolver: (props, styles)=>styles.expandIconWrapper
})(({ theme: theme })=>({
        display: 'flex',
        color: (theme.vars || theme).palette.action.active,
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $7N6Wx.default).expanded}`]: {
            transform: 'rotate(180deg)'
        }
    }));
const $7a6cdd8f8ee60b59$var$AccordionSummary = /*#__PURE__*/ $8T3gX.forwardRef(function AccordionSummary(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionSummary'
    });
    const { children: children, className: className, expandIcon: expandIcon, focusVisibleClassName: focusVisibleClassName, onClick: onClick } = props, other = (0, $fAJB5.default)(props, $7a6cdd8f8ee60b59$var$_excluded);
    const { disabled: disabled = false, disableGutters: disableGutters, expanded: expanded, toggle: toggle } = $8T3gX.useContext((0, $a4qEb.default));
    const handleChange = (event)=>{
        if (toggle) toggle(event);
        if (onClick) onClick(event);
    };
    const ownerState = (0, $eJfrs.default)({}, props, {
        expanded: expanded,
        disabled: disabled,
        disableGutters: disableGutters
    });
    const classes = $7a6cdd8f8ee60b59$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsxs)($7a6cdd8f8ee60b59$var$AccordionSummaryRoot, (0, $eJfrs.default)({
        focusRipple: false,
        disableRipple: true,
        disabled: disabled,
        component: "div",
        "aria-expanded": expanded,
        className: (0, $iVyaN.default)(classes.root, className),
        focusVisibleClassName: (0, $iVyaN.default)(classes.focusVisible, focusVisibleClassName),
        onClick: handleChange,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)($7a6cdd8f8ee60b59$var$AccordionSummaryContent, {
                className: classes.content,
                ownerState: ownerState,
                children: children
            }),
            expandIcon && /*#__PURE__*/ (0, $k4ank.jsx)($7a6cdd8f8ee60b59$var$AccordionSummaryExpandIconWrapper, {
                className: classes.expandIconWrapper,
                ownerState: ownerState,
                children: expandIcon
            })
        ]
    }));
});
$7a6cdd8f8ee60b59$var$AccordionSummary.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The icon to display as the expand indicator.
   */ expandIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */ focusVisibleClassName: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * @ignore
   */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $7a6cdd8f8ee60b59$export$2e2bcd8739ae039 = $7a6cdd8f8ee60b59$var$AccordionSummary;

});
parcelRegister("7N6Wx", function(module, exports) {

$parcel$export(module.exports, "getAccordionSummaryUtilityClass", () => $5ac27ec731670137$export$282216ad123d6580);
$parcel$export(module.exports, "default", () => $5ac27ec731670137$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $5ac27ec731670137$export$282216ad123d6580(slot) {
    return (0, $kfTYv.default)('MuiAccordionSummary', slot);
}
const $5ac27ec731670137$var$accordionSummaryClasses = (0, $jh2Zm.default)('MuiAccordionSummary', [
    'root',
    'expanded',
    'focusVisible',
    'disabled',
    'gutters',
    'contentGutters',
    'content',
    'expandIconWrapper'
]);
var $5ac27ec731670137$export$2e2bcd8739ae039 = $5ac27ec731670137$var$accordionSummaryClasses;

});


parcelRegister("1X9Ds", function(module, exports) {

$parcel$export(module.exports, "default", () => $16c2c6837c27da12$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $kaHnI = parcelRequire("kaHnI");

var $k4ank = parcelRequire("k4ank");
'use client';
const $16c2c6837c27da12$var$_excluded = [
    "className"
];
const $16c2c6837c27da12$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $kaHnI.getAccordionDetailsUtilityClass), classes);
};
const $16c2c6837c27da12$var$AccordionDetailsRoot = (0, $anJSP.default)('div', {
    name: 'MuiAccordionDetails',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        padding: theme.spacing(1, 2, 2)
    }));
const $16c2c6837c27da12$var$AccordionDetails = /*#__PURE__*/ $8T3gX.forwardRef(function AccordionDetails(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiAccordionDetails'
    });
    const { className: className } = props, other = (0, $fAJB5.default)(props, $16c2c6837c27da12$var$_excluded);
    const ownerState = props;
    const classes = $16c2c6837c27da12$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsx)($16c2c6837c27da12$var$AccordionDetailsRoot, (0, $eJfrs.default)({
        className: (0, $iVyaN.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$16c2c6837c27da12$var$AccordionDetails.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $16c2c6837c27da12$export$2e2bcd8739ae039 = $16c2c6837c27da12$var$AccordionDetails;

});
parcelRegister("kaHnI", function(module, exports) {

$parcel$export(module.exports, "getAccordionDetailsUtilityClass", () => $eaf6647badc169e5$export$a6afb527becfac26);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $eaf6647badc169e5$export$a6afb527becfac26(slot) {
    return (0, $kfTYv.default)('MuiAccordionDetails', slot);
}
const $eaf6647badc169e5$var$accordionDetailsClasses = (0, $jh2Zm.default)('MuiAccordionDetails', [
    'root'
]);
var $eaf6647badc169e5$export$2e2bcd8739ae039 = $eaf6647badc169e5$var$accordionDetailsClasses;

});


parcelRegister("5gr4N", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3d537333148e13d1$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $3d537333148e13d1$var$_default = module.exports.default = (0, $3d537333148e13d1$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');

});

parcelRegister("6DsZ5", function(module, exports) {

$parcel$export(module.exports, "WireGuardTunnelSelect", () => $efc28fc0b854fbb4$export$cc5df10da7cd31aa);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $a65wX = parcelRequire("a65wX");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");
const $efc28fc0b854fbb4$export$cc5df10da7cd31aa = ({ tunnels: tunnels, selectedTunnelId: selectedTunnelId, onSelectTunnelId: onSelectTunnelId })=>{
    const [anchorEl, setAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const open = Boolean(anchorEl);
    const selected = tunnels.find((t)=>t.id === selectedTunnelId) ?? tunnels[0] ?? null;
    const label = selected?.name ?? "\u2014";
    if (tunnels.length <= 1) return null;
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "mb-4",
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: "text-[14px] font-mulish pl-[15px] pt-[10px]",
            children: [
                "AVAILABLE WIREGUARD TUNNELS:",
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                    id: "wireguard-tunnel-filter-button",
                    "aria-controls": open ? "wireguard-tunnel-filter-menu" : undefined,
                    "aria-haspopup": "true",
                    "aria-expanded": open ? "true" : undefined,
                    onClick: (e)=>setAnchorEl(e.currentTarget),
                    sx: {
                        paddingBottom: "8px",
                        fontSize: "14px",
                        fontFamily: "Mulish"
                    },
                    children: label
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $1fWBE.default), {
                    id: "wireguard-tunnel-filter-menu",
                    anchorEl: anchorEl,
                    open: open,
                    onClose: ()=>setAnchorEl(null),
                    MenuListProps: {
                        "aria-labelledby": "wireguard-tunnel-filter-button"
                    },
                    children: tunnels.map((t)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                            onClick: ()=>{
                                onSelectTunnelId(t.id);
                                setAnchorEl(null);
                            },
                            sx: {
                                fontFamily: "Mulish"
                            },
                            children: t.name
                        }, t.id))
                })
            ]
        })
    });
};

});

parcelRegister("eiVsn", function(module, exports) {

$parcel$export(module.exports, "resolveWireguardServerEndpoint", () => $8463ebbefdea0fd8$export$1e721b91db7ef3aa);
$parcel$export(module.exports, "resolveWireguardServerPublicKey", () => $8463ebbefdea0fd8$export$105c70233a1a3cf4);
$parcel$export(module.exports, "formatWireguardLastHandshake", () => $8463ebbefdea0fd8$export$29df9030e2b7fc8c);
$parcel$export(module.exports, "getSelectedWireguardTunnel", () => $8463ebbefdea0fd8$export$3e0b77095dc16f4b);
const $8463ebbefdea0fd8$export$1e721b91db7ef3aa = (serverId, options)=>{
    const match = options.find((o)=>o.id === serverId);
    if (!match) return "\u2014";
    return match.zone ? `${match.name} (${match.zone})` : match.name;
};
const $8463ebbefdea0fd8$export$105c70233a1a3cf4 = (serverId, options)=>{
    const match = options.find((o)=>o.id === serverId);
    return match?.server_public_key || "\u2014";
};
const $8463ebbefdea0fd8$export$29df9030e2b7fc8c = (iso)=>{
    if (iso == null || iso === "") return "\u2014";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleString();
};
const $8463ebbefdea0fd8$export$3e0b77095dc16f4b = (tunnels, selectedId)=>{
    if (tunnels.length === 0) return null;
    if (selectedId != null) {
        const found = tunnels.find((t)=>t.id === selectedId);
        if (found) return found;
    }
    return tunnels[0];
};

});

parcelRegister("qUQ1f", function(module, exports) {

$parcel$export(module.exports, "fetchSiteTunnelUsageData", () => $c30819d506b49834$export$85b8c3ffe4291d2c);

var $195EM = parcelRequire("195EM");

var $jBpii = parcelRequire("jBpii");
const $c30819d506b49834$export$44dbed5eaea3d6a4 = async (siteId)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const cameras = [];
    // Hard stop so a misbehaving `next` can never loop forever.
    for(let page = 1; page <= 20; page += 1){
        const response = await AxiosUI.get(`camera/site/?customer__id=${siteId}&page=${page}`);
        (response.data?.results ?? []).forEach((camera)=>{
            cameras.push({
                camera_name: camera.camera_name ?? "",
                ip: camera.ip ?? null
            });
        });
        if (!response.data?.next) break;
    }
    return cameras;
};
const $c30819d506b49834$export$85b8c3ffe4291d2c = async (siteId)=>{
    const [cameras, tunnels] = await Promise.all([
        $c30819d506b49834$export$44dbed5eaea3d6a4(siteId),
        (0, $jBpii.fetchAllWireGuardTunnels)()
    ]);
    return {
        cameras: cameras,
        tunnels: tunnels
    };
};

});
parcelRegister("jBpii", function(module, exports) {

$parcel$export(module.exports, "fetchAllWireGuardTunnels", () => $e014283a64d737d7$export$e6e41d48b2efc284);

var $195EM = parcelRequire("195EM");
const $e014283a64d737d7$var$getRelativeApiPath = (nextUrl)=>{
    if (!nextUrl.startsWith("http")) return nextUrl;
    try {
        const parsedUrl = new URL(nextUrl);
        const apiSplit = parsedUrl.pathname.split("/api/");
        const relativePath = apiSplit[1] || "";
        return `${relativePath}${parsedUrl.search}`;
    } catch  {
        return nextUrl;
    }
};
const $e014283a64d737d7$export$e6e41d48b2efc284 = async ()=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const allTunnels = [];
    const visitedUrls = new Set();
    let nextUrl = "wireguard_tunnel/?all_levels=true";
    while(nextUrl){
        const relativeUrl = $e014283a64d737d7$var$getRelativeApiPath(nextUrl);
        if (visitedUrls.has(relativeUrl)) break;
        visitedUrls.add(relativeUrl);
        const response = await AxiosUI.get(relativeUrl);
        allTunnels.push(...response.data?.results ?? []);
        nextUrl = response.data?.next ?? null;
    }
    return allTunnels;
};

});


parcelRegister("6oM0Y", function(module, exports) {

$parcel$export(module.exports, "siteHosts", () => $11098c49011e5fcd$export$97cd8acd6dcb95ff);
$parcel$export(module.exports, "resolveSiteTunnelUsage", () => $11098c49011e5fcd$export$77987549a6e615c9);
$parcel$export(module.exports, "gatewaysShareZone", () => $11098c49011e5fcd$export$c2536bd4eec51d86);
/**
 * Which WireGuard tunnels carry a site (ENG-2056).
 *
 * Admin stores no site-to-tunnel link. A site's `Customer.wireguard` is its
 * WireGuard GATEWAY (availability zone), not a tunnel. The connector runs on
 * a node in that zone, whose route manager routes every one of the zone's
 * tunnels by destination subnet, so the tunnel carrying an address is the one
 * whose routed range contains it, whatever group owns it. WireGuard subnets
 * are unique among WireGuard tunnels, so each address matches at most one.
 *
 * Ported from the redesign branch's Troubleshooter (`siteTunnel.ts`) so the
 * Site About page can share the rule without depending on redesign-only code.
 */ /** The fields tunnel resolution reads; both tunnel interfaces satisfy it. */ const $11098c49011e5fcd$export$c5fdb33955bd3d8e = (value)=>{
    const match = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/.exec(value.trim());
    if (!match) return null;
    const parts = match.slice(1).map(Number);
    if (parts.some((part)=>part > 255)) return null;
    return (parts[0] << 24 >>> 0) + (parts[1] << 16) + (parts[2] << 8) + parts[3];
};
const $11098c49011e5fcd$export$5c3f858437754ffe = (cidr, address)=>{
    const [base, bitsText] = cidr.trim().split("/");
    const baseValue = $11098c49011e5fcd$export$c5fdb33955bd3d8e(base);
    const target = $11098c49011e5fcd$export$c5fdb33955bd3d8e(address);
    if (baseValue == null || target == null) return false;
    const bits = bitsText == null ? 32 : Number(bitsText);
    if (!Number.isInteger(bits) || bits < 0 || bits > 32) return false;
    const mask = bits === 0 ? 0 : 0xffffffff << 32 - bits >>> 0;
    return (baseValue & mask) >>> 0 === (target & mask) >>> 0;
};
const $11098c49011e5fcd$export$da1227b36acc8816 = (tunnel)=>{
    const subnets = (tunnel.subnets ?? []).filter((cidr)=>typeof cidr === "string" && cidr.trim());
    if (subnets.length) return subnets;
    const own = (tunnel.client_tunnel_ip ?? "").trim();
    return own ? [
        own
    ] : [];
};
const $11098c49011e5fcd$export$97cd8acd6dcb95ff = (site, cameras = [])=>{
    const entries = [
        {
            address: site?.server_ip ?? "",
            label: "Server"
        },
        {
            address: site?.management_server_ip ?? "",
            label: "Management server"
        },
        {
            address: site?.event_server_ip ?? "",
            label: "Event server"
        },
        ...cameras.map((camera)=>({
                address: camera.ip ?? "",
                label: camera.camera_name || "Camera"
            }))
    ];
    const byAddress = new Map();
    entries.forEach(({ address: address, label: label })=>{
        const trimmed = String(address ?? "").trim();
        if (!trimmed) return;
        const existing = byAddress.get(trimmed);
        if (!existing) byAddress.set(trimmed, {
            address: trimmed,
            label: label
        });
        else if (!existing.label.split(", ").includes(label)) existing.label = `${existing.label}, ${label}`;
    });
    return Array.from(byAddress.values());
};
const $11098c49011e5fcd$export$77987549a6e615c9 = (hosts, tunnels, sameZone)=>{
    const used = new Map();
    const notOnWireGuard = [];
    const hostnames = [];
    hosts.forEach((host)=>{
        if ($11098c49011e5fcd$export$c5fdb33955bd3d8e(host.address) == null) {
            hostnames.push(host);
            return;
        }
        const tunnel = tunnels.find((t)=>$11098c49011e5fcd$export$da1227b36acc8816(t).some((cidr)=>$11098c49011e5fcd$export$5c3f858437754ffe(cidr, host.address)));
        if (!tunnel) {
            notOnWireGuard.push(host);
            return;
        }
        const entry = used.get(tunnel.id);
        if (entry) entry.hosts.push(host);
        else used.set(tunnel.id, {
            tunnel: tunnel,
            hosts: [
                host
            ],
            otherZone: !sameZone(tunnel.server)
        });
    });
    return {
        used: Array.from(used.values()),
        notOnWireGuard: notOnWireGuard,
        hostnames: hostnames
    };
};
const $11098c49011e5fcd$export$c2536bd4eec51d86 = (a, b, gateways)=>{
    if (a == null || b == null) return false;
    if (a === b) return true;
    const zoneA = gateways.find((g)=>g.id === a)?.zone;
    const zoneB = gateways.find((g)=>g.id === b)?.zone;
    return Boolean(zoneA && zoneB && zoneA === zoneB);
};

});


parcelRegister("c6iZU", function(module, exports) {

$parcel$export(module.exports, "WireGuardTabEditMode", () => $cac87d20f27e7f6d$export$ad5174b2ea34f9df);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $eejVe = parcelRequire("eejVe");

var $kUcVg = parcelRequire("kUcVg");

var $ce8iU = parcelRequire("ce8iU");

var $1TOOV = parcelRequire("1TOOV");

var $887xF = parcelRequire("887xF");

var $a65wX = parcelRequire("a65wX");

var $lWchQ = parcelRequire("lWchQ");

var $2aMB5 = parcelRequire("2aMB5");

var $aYdit = parcelRequire("aYdit");

var $6DsZ5 = parcelRequire("6DsZ5");

var $eiVsn = parcelRequire("eiVsn");
const $cac87d20f27e7f6d$var$headCellSx = {
    fontFamily: "Mulish",
    fontWeight: "bold"
};
const $cac87d20f27e7f6d$var$MULTI_SITE_WARNING = "Please note that submitting changes to a Wireguard Tunnel applies these changes to all sites which use this tunnel";
const $cac87d20f27e7f6d$var$computeAnyDirty = (drafts, snapshot)=>{
    if (!drafts || !snapshot?.length) return false;
    return snapshot.some((s)=>{
        const d = drafts[s.id];
        if (!d) return false;
        return d.name !== s.name || d.client_public_key !== s.client_public_key;
    });
};
const $cac87d20f27e7f6d$export$ad5174b2ea34f9df = ({ wireguardTunnels: wireguardTunnels, selectedTunnelId: selectedTunnelId, onSelectTunnelId: onSelectTunnelId, onSessionUpdate: onSessionUpdate, setWireguardChangesMade: setWireguardChangesMade })=>{
    const wireGuardOptions = (0, $aYdit.useAppStore)((s)=>s.wireGuardOptions);
    const snapshotRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    if (snapshotRef.current === null) snapshotRef.current = JSON.parse(JSON.stringify(wireguardTunnels));
    const [draftsById, setDraftsById] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(()=>Object.fromEntries(wireguardTunnels.map((t)=>[
                t.id,
                {
                    name: t.name,
                    client_public_key: t.client_public_key
                }
            ])));
    const multiSiteWarningAcknowledgedRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(false);
    const [multiSiteWarningOpen, setMultiSiteWarningOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [pendingEdit, setPendingEdit] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const tunnel = (0, $eiVsn.getSelectedWireguardTunnel)(wireguardTunnels, selectedTunnelId);
    const applyDraftUpdate = (tunnelId, next)=>{
        setDraftsById((prev)=>{
            const cur = prev[tunnelId];
            if (!cur) return prev;
            const merged = {
                ...cur,
                ...next
            };
            return {
                ...prev,
                [tunnelId]: merged
            };
        });
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (snapshotRef.current) onSessionUpdate({
            drafts: draftsById,
            snapshot: snapshotRef.current
        });
    }, [
        draftsById,
        onSessionUpdate
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setWireguardChangesMade($cac87d20f27e7f6d$var$computeAnyDirty(draftsById, snapshotRef.current));
    }, [
        draftsById,
        setWireguardChangesMade
    ]);
    const flushPendingEdit = ()=>{
        if (!pendingEdit) return;
        if (pendingEdit.kind === "name") applyDraftUpdate(pendingEdit.tunnelId, {
            name: pendingEdit.value
        });
        else applyDraftUpdate(pendingEdit.tunnelId, {
            client_public_key: pendingEdit.value
        });
        setPendingEdit(null);
    };
    const requestNameChange = (tunnelId, value)=>{
        if (!multiSiteWarningAcknowledgedRef.current) {
            setPendingEdit({
                kind: "name",
                tunnelId: tunnelId,
                value: value
            });
            setMultiSiteWarningOpen(true);
            return;
        }
        applyDraftUpdate(tunnelId, {
            name: value
        });
    };
    const requestKeyChange = (tunnelId, value)=>{
        if (!multiSiteWarningAcknowledgedRef.current) {
            setPendingEdit({
                kind: "key",
                tunnelId: tunnelId,
                value: value
            });
            setMultiSiteWarningOpen(true);
            return;
        }
        applyDraftUpdate(tunnelId, {
            client_public_key: value
        });
    };
    const handleWarningConfirm = ()=>{
        multiSiteWarningAcknowledgedRef.current = true;
        setMultiSiteWarningOpen(false);
        flushPendingEdit();
    };
    const handleWarningClose = ()=>{
        setMultiSiteWarningOpen(false);
        setPendingEdit(null);
    };
    const draft = tunnel ? draftsById[tunnel.id] : null;
    if (!tunnel || !draft) return /*#__PURE__*/ (0, $k4ank.jsx)("p", {
        className: "font-mulish text-[#283E6D] text-[20px] text-center",
        children: "No WireGuard tunnel data"
    });
    const snapTunnel = snapshotRef.current?.find((t)=>t.id === tunnel.id) ?? tunnel;
    const endpoint = (0, $eiVsn.resolveWireguardServerEndpoint)(snapTunnel.server, wireGuardOptions);
    const serverPk = (0, $eiVsn.resolveWireguardServerPublicKey)(snapTunnel.server, wireGuardOptions);
    const subnetsText = snapTunnel.subnets?.length > 0 ? snapTunnel.subnets.join(", ") : "\u2014";
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        sx: {
            width: "100%",
            maxWidth: "100%"
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                open: multiSiteWarningOpen,
                onClose: handleWarningClose,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                        sx: {
                            fontFamily: "Mulish"
                        },
                        children: "WireGuard tunnel"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                        sx: {
                            fontFamily: "Mulish"
                        },
                        children: $cac87d20f27e7f6d$var$MULTI_SITE_WARNING
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                onClick: handleWarningClose,
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                onClick: handleWarningConfirm,
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: "OK"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $6DsZ5.WireGuardTunnelSelect), {
                tunnels: wireguardTunnels,
                selectedTunnelId: selectedTunnelId,
                onSelectTunnelId: onSelectTunnelId
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $k8Qy8.default), {
                sx: {
                    fontFamily: "Mulish"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $gXvgZ.default), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: $cac87d20f27e7f6d$var$headCellSx,
                                    children: "Name"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: $cac87d20f27e7f6d$var$headCellSx,
                                    children: "WireGuard server endpoint"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: $cac87d20f27e7f6d$var$headCellSx,
                                    children: "Server Public Key"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: $cac87d20f27e7f6d$var$headCellSx,
                                    children: "Client Public Key"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: $cac87d20f27e7f6d$var$headCellSx,
                                    children: "Client tunnel IP"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        value: draft.name,
                                        variant: "standard",
                                        fullWidth: true,
                                        sx: {
                                            minWidth: 120,
                                            fontFamily: "Mulish"
                                        },
                                        onChange: (e)=>requestNameChange(tunnel.id, e.target.value)
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: endpoint
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        wordBreak: "break-all"
                                    },
                                    children: serverPk
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        wordBreak: "break-all"
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        value: draft.client_public_key,
                                        variant: "standard",
                                        fullWidth: true,
                                        sx: {
                                            minWidth: 160,
                                            fontFamily: "Mulish"
                                        },
                                        onChange: (e)=>requestKeyChange(tunnel.id, e.target.value)
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: snapTunnel.client_tunnel_ip || "\u2014"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    colSpan: 2,
                                    sx: $cac87d20f27e7f6d$var$headCellSx,
                                    children: "Subnets"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: $cac87d20f27e7f6d$var$headCellSx,
                                    children: "Subnets are virtually assigned"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: $cac87d20f27e7f6d$var$headCellSx,
                                    children: "Tunnel status"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: $cac87d20f27e7f6d$var$headCellSx,
                                    children: "Last handshake"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    colSpan: 2,
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        wordBreak: "break-all"
                                    },
                                    children: subnetsText
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: snapTunnel.subnets_are_virtually_assigned ? (0, $lWchQ.checkedCircleIcon) : (0, $2aMB5.cancelIconRed)
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: snapTunnel.tunnel_status ?? "\u2014"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: (0, $eiVsn.formatWireguardLastHandshake)(snapTunnel.last_handshake)
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

});

parcelRegister("2bi6M", function(module, exports) {

$parcel$export(module.exports, "DOUBLE_TAKE_TAB", () => $3fd1b55303ee16f6$export$28b7aa8d53c1fb7b);
$parcel$export(module.exports, "shouldShowDoubleTakeTab", () => $3fd1b55303ee16f6$export$a73e1d0f17f6fc0f);
$parcel$export(module.exports, "canToggleDoubleTake", () => $3fd1b55303ee16f6$export$9cfa93cbed8995ac);
$parcel$export(module.exports, "buildDoubleTakePatches", () => $3fd1b55303ee16f6$export$974df1d12109d816);
/**
 * Site About → DoubleTake tab (ENG-2611).
 *
 * Who can do what, mirroring admin (ENG-2708):
 * - Staff can turn site DoubleTake (`vlm_enabled`) on and off on any site.
 * - Customers can turn it on only when a group above the site has DoubleTake
 *   available (`doubletake_available` on `customer/{id}/about/`), and can
 *   always turn it off.
 * - The FP (receiver) gate (`vlm_gate_enabled`) is staff-only. It is written
 *   through `PATCH customer/{id}/`, not About, and customers see it read-only
 *   (ENG-2728 decides whether that changes).
 */ /** `clickedTab` value for the DoubleTake tab; "one"–"nine" are taken. */ const $3fd1b55303ee16f6$export$28b7aa8d53c1fb7b = "ten";
const $3fd1b55303ee16f6$export$a73e1d0f17f6fc0f = (showVlmFilters, siteInfo, isStaff)=>showVlmFilters && (isStaff || Boolean(siteInfo?.doubletake_available) || Boolean(siteInfo?.vlm_enabled));
const $3fd1b55303ee16f6$export$9cfa93cbed8995ac = (savedVlmEnabled, siteInfo, isStaff)=>isStaff || savedVlmEnabled || Boolean(siteInfo?.doubletake_available);
const $3fd1b55303ee16f6$export$974df1d12109d816 = (saved, draft, isStaff)=>({
        about: draft.vlmEnabled !== saved.vlmEnabled ? {
            vlm_enabled: draft.vlmEnabled
        } : null,
        gate: isStaff && draft.gateEnabled !== saved.gateEnabled ? {
            vlm_gate_enabled: draft.gateEnabled
        } : null
    });

});



parcelRegister("bPE00", function(module, exports) {

$parcel$export(module.exports, "CancelButton", () => $8988df8e5936cbd0$export$488fee190faedb43);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $8jTCz = parcelRequire("8jTCz");

var $74e7A = parcelRequire("74e7A");

var $3FJ79 = parcelRequire("3FJ79");
const $8988df8e5936cbd0$export$488fee190faedb43 = ({ setEditMode: setEditMode, clickedTab: clickedTab, setActiveTab: setActiveTab, siteInfo: siteInfo, setRecordingServerPatchObject: setRecordingServerPatchObject, healthCheckData: healthCheckData, webhooksInfo: webhooksInfo, siteInfoBackup: siteInfoBackup, setSiteInfo: setSiteInfo, vmsVariablesBackup: vmsVariablesBackup, setVmsVariables: setVmsVariables, wireguardTunnels: wireguardTunnels, wireguardTunnelsLoading: wireguardTunnelsLoading, selectedWireguardTunnelId: selectedWireguardTunnelId, setSelectedWireguardTunnelId: setSelectedWireguardTunnelId, clearWireGuardEditSession: clearWireGuardEditSession, setWireguardChangesMade: setWireguardChangesMade })=>{
    const { backupSiteSchedules: backupSiteSchedules, setSiteSchedules: setSiteSchedules } = (0, $3FJ79.useSiteAboutStore).getState();
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
            onClick: ()=>(0, $74e7A.handleCancelButtonClick)(setEditMode, clickedTab, setActiveTab, backupSiteSchedules, siteInfo, setRecordingServerPatchObject, healthCheckData, webhooksInfo, siteInfoBackup, setSiteInfo, vmsVariablesBackup, setVmsVariables, setSiteSchedules, wireguardTunnels, wireguardTunnelsLoading, selectedWireguardTunnelId, setSelectedWireguardTunnelId, clearWireGuardEditSession, setWireguardChangesMade),
            text: "CANCEL",
            disabled: false
        })
    });
};

});
parcelRegister("74e7A", function(module, exports) {

$parcel$export(module.exports, "handleCancelButtonClick", () => $a87fdb2d8d269c5b$export$7c1445a094ba70b4);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $1Ah5f = parcelRequire("1Ah5f");

var $1W2ma = parcelRequire("1W2ma");

var $2uQ4j = parcelRequire("2uQ4j");

var $7isVd = parcelRequire("7isVd");

var $4ajRU = parcelRequire("4ajRU");

var $islbW = parcelRequire("islbW");

var $iXV9W = parcelRequire("iXV9W");

var $3FJ79 = parcelRequire("3FJ79");

var $2Mk2P = parcelRequire("2Mk2P");

var $axLUl = parcelRequire("axLUl");

var $bILSL = parcelRequire("bILSL");

var $7Gmex = parcelRequire("7Gmex");

var $f7Odp = parcelRequire("f7Odp");

var $4k3Fk = parcelRequire("4k3Fk");
const $a87fdb2d8d269c5b$export$7c1445a094ba70b4 = (setEditMode, clickedTab, setActiveTab, backupSiteSchedules, siteInfo, setRecordingServerPatchObject, healthCheckData, webhooksInfo, siteInfoBackup, setSiteInfo, vmsVariablesBackup, setVmsVariables, setSiteSchedules, wireguardTunnels, wireguardTunnelsLoading, selectedWireguardTunnelId, setSelectedWireguardTunnelId, clearWireGuardEditSession, setWireguardChangesMade)=>{
    const { setHealthCheckMetricsData: setHealthCheckMetricsData, setScheduleGridEditable: setScheduleGridEditable, setTimeRanges: setTimeRanges, setGrid: setGrid, setDuskToDawn: setDuskToDawn, setDuskToDawnLocation: setDuskToDawnLocation, schedulesIndex: schedulesIndex, setAutoPatrolScheduleHealthchckMetrics: setAutoPatrolScheduleHealthchckMetrics, setAutoPatrolSchedules: setAutoPatrolSchedules, resetAutoPatrolFlexIgnoreZonesForSite: resetAutoPatrolFlexIgnoreZonesForSite, flexSchedulesOn: flexSchedulesOn, setEvalinkPatchObject: setEvalinkPatchObject, evalinkData: evalinkData } = (0, $3FJ79.useSiteAboutStore).getState();
    const backupSiteInfo = siteInfoBackup;
    const backupHealthCheckMetrics = localStorage.getItem("backupHealthCheckMetricsData");
    if (backupHealthCheckMetrics) setHealthCheckMetricsData(JSON.parse(backupHealthCheckMetrics));
    setSiteInfo(backupSiteInfo);
    setVmsVariables(vmsVariablesBackup);
    setEditMode(false);
    setScheduleGridEditable(false);
    if (evalinkData) setEvalinkPatchObject({
        evalink_token: evalinkData.evalink_token,
        evalink_device_id: evalinkData.evalink_device_id,
        evalink_company_id: evalinkData.evalink_company_id
    });
    if (backupSiteInfo?.integration_type_name === "milestone") {
        const recordingServerBackup = localStorage.getItem("recordingServerBackup");
        if (recordingServerBackup) setRecordingServerPatchObject(JSON.parse(recordingServerBackup));
    }
    const flexScheduleBackup = localStorage.getItem("backUpFlexSchedule");
    const standardScheduleBackup = localStorage.getItem("backUpStandardSchedule");
    if (flexSchedulesOn && flexScheduleBackup) setSiteSchedules(JSON.parse(flexScheduleBackup));
    else if (!flexSchedulesOn && standardScheduleBackup) setSiteSchedules(JSON.parse(standardScheduleBackup));
    if (backupSiteSchedules?.length > 0 && backupSiteSchedules[schedulesIndex]?.schedule) {
        setTimeRanges((0, $2Mk2P.handleCreateInitialTimeSchedules)(backupSiteSchedules[schedulesIndex].schedule));
        setGrid((0, $axLUl.handleConvertSchedulesToBooleanArrays)(backupSiteSchedules[schedulesIndex].schedule));
        setDuskToDawn((0, $bILSL.handleCreateDuskToDawn)(backupSiteSchedules[schedulesIndex].schedule));
        setDuskToDawnLocation((0, $7Gmex.handleCreateDuskToDawnLocationPlusBuffer)(backupSiteSchedules[schedulesIndex].schedule));
    }
    const backupAutoPatrolMetrics = localStorage.getItem("backupAutoPatrolScheduleHealthchckMetrics");
    if (backupAutoPatrolMetrics) setAutoPatrolScheduleHealthchckMetrics(JSON.parse(backupAutoPatrolMetrics));
    const backupAutoPatrol = localStorage.getItem("backupAutoPatrolSchedules");
    if (backupAutoPatrol) setAutoPatrolSchedules(JSON.parse(backupAutoPatrol));
    if (backupSiteInfo?.id) resetAutoPatrolFlexIgnoreZonesForSite(Number(backupSiteInfo.id));
    const isAutoPatrol = siteInfo?.integration_type_name === "autopatrol";
    if (clickedTab === "one") {
        if (isAutoPatrol) {
            // For AutoPatrol sites, restore Zustand store state
            const { setSiteInfo: setZustandSiteInfo, setVmsVariables: setZustandVmsVariables, setGeneralInfoTabPatchObject: setGeneralInfoTabPatchObject, setGeneralInfoTabChangesMade: setGeneralInfoTabChangesMade } = (0, $3FJ79.useSiteAboutStore).getState();
            setZustandSiteInfo(backupSiteInfo);
            setZustandVmsVariables(vmsVariablesBackup);
            setGeneralInfoTabPatchObject({});
            setGeneralInfoTabChangesMade(false);
            setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $1W2ma.GeneralInfoTabAutoPatrol), {
                editMode: false
            }));
        } else setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $1Ah5f.GeneralInfoTab), {
            siteInfo: backupSiteInfo,
            setSiteInfo: setSiteInfo,
            setActiveTab: setActiveTab,
            vmsVariables: vmsVariablesBackup
        }));
    } else if (clickedTab === "three") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $2uQ4j.SchedulesTab), {
        siteInfo: backupSiteInfo
    }));
    else if (clickedTab === "four") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $7isVd.SMTPTab), {}));
    else if (clickedTab === "five") {
        const recordingServerBackup = localStorage.getItem("recordingServerBackup");
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4ajRU.RecordingServerTab), {
            recordingServerData: recordingServerBackup ? JSON.parse(recordingServerBackup) : undefined
        }));
    } else if (clickedTab === "six") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $islbW.CameraHealthTab), {
        healthCheckData: healthCheckData,
        siteInfo: backupSiteInfo
    }));
    else if (clickedTab === "seven") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $iXV9W.WebhooksTab), {
        webhooksInfo: webhooksInfo
    }));
    else if (clickedTab === "eight") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $f7Odp.EvalinkTab), {}));
    else if (clickedTab === "nine") {
        clearWireGuardEditSession();
        setWireguardChangesMade(false);
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4k3Fk.WireGuardTab), {
            wireguardTunnels: wireguardTunnels,
            wireguardTunnelsLoading: wireguardTunnelsLoading,
            selectedTunnelId: selectedWireguardTunnelId,
            onSelectTunnelId: (id)=>setSelectedWireguardTunnelId(id)
        }));
    }
};

});


parcelRegister("kHsF1", function(module, exports) {

$parcel$export(module.exports, "SaveChangesButton", () => $3cd865a057a86d12$export$9ea4a3c0de98bcdb);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $8jTCz = parcelRequire("8jTCz");

var $hTYVM = parcelRequire("hTYVM");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $bIAiw = parcelRequire("bIAiw");
const $3cd865a057a86d12$export$9ea4a3c0de98bcdb = ({ patchObject: patchObject, setEditMode: setEditMode, setSiteInfo: setSiteInfo, setPatchObject: setPatchObject, siteInfo: siteInfo, clickedTab: clickedTab, setActiveTab: setActiveTab, vmsVariables: vmsVariables, allSiteSchedules: allSiteSchedules, siteSchedules: siteSchedules, setAllSiteSchedules: setAllSiteSchedules, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setAlertState: setAlertState, setSyncNeeded: setSyncNeeded, editMode: editMode, setSchedulesTabActive: setSchedulesTabActive, setClickedTab: setClickedTab, siteInfoChangesMade: siteInfoChangesMade, setSiteInfoChangesMade: setSiteInfoChangesMade, scheduleChangesMade: scheduleChangesMade, setScheduleChangesMade: setScheduleChangesMade, setDeleteScheduleDialogOpen: setDeleteScheduleDialogOpen, setSiteSchedules: setSiteSchedules, setArmButtonDisabled: setArmButtonDisabled, recordingServerChangesMade: recordingServerChangesMade, recordingServerData: recordingServerData, recordingServerPatchObject: recordingServerPatchObject, setRecordingServerData: setRecordingServerData, setRecordingServerPatchObject: setRecordingServerPatchObject, setRecordingServerChangesMade: setRecordingServerChangesMade, cameraHealthChangesMade: cameraHealthChangesMade, healthCheckData: healthCheckData, setHealthCheckData: setHealthCheckData, cameraHealthPatchObject: cameraHealthPatchObject, setCameraHealthPatchObject: setCameraHealthPatchObject, setCameraHealthChangesMade: setCameraHealthChangesMade, setArmedStatus: setArmedStatus, webhooksChangesMade: webhooksChangesMade, webhooksInfo: webhooksInfo, setWebhooksInfo: setWebhooksInfo, webhooksPatchObject: webhooksPatchObject, setWebhooksPatchObject: setWebhooksPatchObject, setWebhooksChangesMade: setWebhooksChangesMade, setDeactivateSiteInsteadDialogOpen: setDeactivateSiteInsteadDialogOpen, setActivateSiteWithScheduleDialogOpen: setActivateSiteWithScheduleDialogOpen, wireguardChangesMade: wireguardChangesMade, wireGuardEditSessionRef: wireGuardEditSessionRef, setWireguardTunnels: setWireguardTunnels, setWireguardChangesMade: setWireguardChangesMade, wireguardTunnels: wireguardTunnels, wireguardTunnelsLoading: wireguardTunnelsLoading, selectedWireguardTunnelId: selectedWireguardTunnelId, setSelectedWireguardTunnelId: setSelectedWireguardTunnelId })=>{
    const navigate = (0, $3T949.useNavigate)();
    // ENG-2302: never save an SMS recipient SNS would misdial.
    const phoneFieldInvalid = (0, $bIAiw.usePhoneValidationStore)((0, $bIAiw.selectAnyPhoneFieldInvalid));
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
            onClick: ()=>(0, $hTYVM.handleSaveChangesButtonClick)(patchObject, setEditMode, setSiteInfo, setPatchObject, siteInfo, clickedTab, setActiveTab, vmsVariables, siteSchedules, setAllSiteSchedules, setBackdropLoadingScreenOn, setAlertState, setSyncNeeded, editMode, setSchedulesTabActive, setClickedTab, siteInfoChangesMade, setSiteInfoChangesMade, // scheduleChangesMade,
                setScheduleChangesMade, setDeleteScheduleDialogOpen, navigate, setSiteSchedules, setArmButtonDisabled, recordingServerChangesMade, recordingServerData, recordingServerPatchObject, setRecordingServerData, setRecordingServerPatchObject, setRecordingServerChangesMade, cameraHealthChangesMade, healthCheckData, setHealthCheckData, cameraHealthPatchObject, setCameraHealthPatchObject, setCameraHealthChangesMade, setArmedStatus, webhooksChangesMade, webhooksInfo, setWebhooksInfo, webhooksPatchObject, setWebhooksPatchObject, setWebhooksChangesMade, setDeactivateSiteInsteadDialogOpen, setActivateSiteWithScheduleDialogOpen, wireguardChangesMade, wireGuardEditSessionRef, setWireguardTunnels, setWireguardChangesMade, wireguardTunnels, wireguardTunnelsLoading, selectedWireguardTunnelId, setSelectedWireguardTunnelId),
            text: "SAVE CHANGES",
            disabled: phoneFieldInvalid
        })
    });
};

});
parcelRegister("hTYVM", function(module, exports) {

$parcel$export(module.exports, "saveAutoPatrolSchedulesOnly", () => $d53993f5eda43e7e$export$19a38fc43bf8419e);
$parcel$export(module.exports, "handleSaveChangesButtonClick", () => $d53993f5eda43e7e$export$5db1123427ed8440);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $1Ah5f = parcelRequire("1Ah5f");

var $2uQ4j = parcelRequire("2uQ4j");

var $bfBpo = parcelRequire("bfBpo");

var $F8wri = parcelRequire("F8wri");

var $8Lqzk = parcelRequire("8Lqzk");

var $7isVd = parcelRequire("7isVd");

var $4ajRU = parcelRequire("4ajRU");

var $fArAG = parcelRequire("fArAG");

var $3Zv1D = parcelRequire("3Zv1D");

var $gDmTd = parcelRequire("gDmTd");

var $islbW = parcelRequire("islbW");

var $iXV9W = parcelRequire("iXV9W");

var $h5bv8 = parcelRequire("h5bv8");

var $3FJ79 = parcelRequire("3FJ79");

var $f7Odp = parcelRequire("f7Odp");

var $4k3Fk = parcelRequire("4k3Fk");

var $kTzGL = parcelRequire("kTzGL");

var $7kQyB = parcelRequire("7kQyB");

var $9VM4t = parcelRequire("9VM4t");
const $d53993f5eda43e7e$export$6832a39c15fc3cfd = (patchObject)=>Object.prototype.hasOwnProperty.call(patchObject, "default_alarm");
const $d53993f5eda43e7e$export$19a38fc43bf8419e = async (navigate, onComplete)=>{
    const { autoPatrolSchedulesUpdatedBoolean: autoPatrolSchedulesUpdatedBoolean, updatedAutoPatrolScheduleIndexes: updatedAutoPatrolScheduleIndexes, patchAutoPatrolSchedules: patchAutoPatrolSchedules, autoPatrolScheduleHealthchckMetricsUpdatedBoolean: autoPatrolScheduleHealthchckMetricsUpdatedBoolean, updatedAutoPatrolScheduleHealthchckMetricsIds: updatedAutoPatrolScheduleHealthchckMetricsIds, autoPatrolScheduleHealthchckMetrics: autoPatrolScheduleHealthchckMetrics, patchAutoPatrolScheduleHealthchckMetrics: patchAutoPatrolScheduleHealthchckMetrics, productMetricsWereUpdated: productMetricsWereUpdated, updatedProductMetricsIds: updatedProductMetricsIds, updateScheduleProducts: updateScheduleProducts, autoPatrolCameraProducts: autoPatrolCameraProducts, setProductMetricsWereUpdated: setProductMetricsWereUpdated, setUpdatedProductMetricsIds: setUpdatedProductMetricsIds } = (0, $3FJ79.useSiteAboutStore).getState();
    const promises = [];
    if (autoPatrolSchedulesUpdatedBoolean) updatedAutoPatrolScheduleIndexes.forEach((index)=>{
        promises.push(patchAutoPatrolSchedules(navigate, index));
    });
    if (autoPatrolScheduleHealthchckMetricsUpdatedBoolean) {
        const arraysToPatch = [];
        updatedAutoPatrolScheduleHealthchckMetricsIds.forEach((id)=>{
            const metricsForSchedule = autoPatrolScheduleHealthchckMetrics[id] || [];
            metricsForSchedule.forEach((metric)=>{
                if (!metric?.id) return;
                arraysToPatch.push({
                    id: metric.id,
                    enabled: metric.enabled,
                    finalIndex: false,
                    minimum_resolution_height: metric?.metric_type?.value === "image_quality_check" ? metric.minimum_resolution_height : null
                });
            });
        });
        if (arraysToPatch.length > 0) arraysToPatch[arraysToPatch.length - 1].finalIndex = true;
        arraysToPatch.forEach((array)=>{
            promises.push(patchAutoPatrolScheduleHealthchckMetrics(navigate, array.id, array.enabled, array.finalIndex, array.minimum_resolution_height));
        });
    }
    if (productMetricsWereUpdated) Object.entries(updatedProductMetricsIds).forEach(([scheduleIdStr, productIds])=>{
        const scheduleId = Number(scheduleIdStr);
        const scheduleProducts = autoPatrolCameraProducts[scheduleId] || [];
        productIds.forEach((productId)=>{
            const product = scheduleProducts.find((p)=>p.id === productId);
            if (product) promises.push(updateScheduleProducts(productId, product.enabled, scheduleId, navigate));
        });
    });
    if (promises.length > 0) Promise.all(promises).finally(()=>{
        setProductMetricsWereUpdated(false);
        setUpdatedProductMetricsIds({});
        onComplete?.();
    });
    else onComplete?.();
};
const $d53993f5eda43e7e$export$5db1123427ed8440 = async (patchObject, setEditMode, setSiteInfo, setPatchObject, siteInfo, clickedTab, setActiveTab, vmsVariables, siteSchedules, setAllSiteSchedules, setBackdropLoadingScreenOn, setAlertState, setSyncNeeded, editMode, setSchedulesTabActive, setClickedTab, siteInfoChangesMade, setSiteInfoChangesMade, // scheduleChangesMade: any,
setScheduleChangesMade, setDeleteScheduleDialogOpen, navigate, setSiteSchedules, setArmButtonDisabled, recordingServerChangesMade, recordingServerData, recordingServerPatchObject, setRecordingServerData, setRecordingServerPatchObject, setRecordingServerChangesMade, cameraHealthChangesMade, healthCheckData, setHealthCheckData, cameraHealthPatchObject, setCameraHealthPatchObject, setCameraHealthChangesMade, setArmedStatus, webhooksChangesMade, webhooksInfo, setWebhooksInfo, webhooksPatchObject, setWebhooksPatchObject, setWebhooksChangesMade, setDeactivateSiteInsteadDialogOpen, setActivateSiteWithScheduleDialogOpen, wireguardChangesMade, wireGuardEditSessionRef, setWireguardTunnels, setWireguardChangesMade, wireguardTunnels, wireguardTunnelsLoading, selectedWireguardTunnelId, setSelectedWireguardTunnelId)=>{
    const { healthCheckMetricsUpdated: healthCheckMetricsUpdated, healthCheckMetricsData: healthCheckMetricsData, patchHealthCheckMetricsData: patchHealthCheckMetricsData, getHealthCheckMetricsData: getHealthCheckMetricsData, setScheduleGridEditable: setScheduleGridEditable, scheduleChangesMade: scheduleChangesMade, patchSchedules: patchSchedules, setBackdropLoadingScreenOnEditingSchedule: setBackdropLoadingScreenOnEditingSchedule, evalinkChangesMade: evalinkChangesMade, handlePatchEvalink: handlePatchEvalink } = (0, $3FJ79.useSiteAboutStore).getState();
    //create a value anyHealthChceckMetricsUpdated that is true if any of the healthCheckMetricsUpdated values have a true value
    const anyHealthCheckMetricsUpdated = Object.values(healthCheckMetricsUpdated).some((value)=>value === true);
    const AxiosUI = (0, $195EM.createApi)(``);
    setBackdropLoadingScreenOn(true);
    const retryFunction = ()=>{
        $d53993f5eda43e7e$export$5db1123427ed8440(patchObject, setEditMode, setSiteInfo, setPatchObject, siteInfo, clickedTab, setActiveTab, vmsVariables, siteSchedules, setAllSiteSchedules, setBackdropLoadingScreenOn, setAlertState, setSyncNeeded, editMode, setSchedulesTabActive, setClickedTab, siteInfoChangesMade, setSiteInfoChangesMade, // scheduleChangesMade,
        setScheduleChangesMade, setDeleteScheduleDialogOpen, navigate, setSiteSchedules, setArmButtonDisabled, recordingServerChangesMade, recordingServerData, recordingServerPatchObject, setRecordingServerData, setRecordingServerPatchObject, setRecordingServerChangesMade, cameraHealthChangesMade, healthCheckData, setHealthCheckData, cameraHealthPatchObject, setCameraHealthPatchObject, setCameraHealthChangesMade, setArmedStatus, webhooksChangesMade, webhooksInfo, setWebhooksInfo, webhooksPatchObject, setWebhooksPatchObject, setWebhooksChangesMade, setDeactivateSiteInsteadDialogOpen, setActivateSiteWithScheduleDialogOpen, wireguardChangesMade, wireGuardEditSessionRef, setWireguardTunnels, setWireguardChangesMade, wireguardTunnels, wireguardTunnelsLoading, selectedWireguardTunnelId, setSelectedWireguardTunnelId);
    };
    $d53993f5eda43e7e$export$19a38fc43bf8419e(navigate);
    if (siteInfoChangesMade) await AxiosUI.patch(`customer/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}/about/`, patchObject).then((response)=>{
        // The RTSP + motion advice (ENG-2828) depends on the saved protocol /
        // use_motion, so take it from the response rather than the draft.
        const savedSiteInfo = (0, $9VM4t.withSavedMotionStreamingAdvice)(siteInfo, response?.data);
        if (savedSiteInfo !== siteInfo) setSiteInfo(savedSiteInfo);
        setSiteInfoChangesMade(false);
        setPatchObject({
            name: siteInfo.name
        });
        setAlertState((previousState)=>{
            return {
                ...previousState,
                changeSuccess: true,
                activateSuccess: false,
                deactivateSuccess: false,
                disarmSuccess: false,
                armSuccess: false,
                syncSuccess: false,
                cameraDeleteSuccess: false
            };
        });
        setScheduleGridEditable(false);
        setEditMode(false);
        setSyncNeeded(true);
        setBackdropLoadingScreenOn(false);
        if ($d53993f5eda43e7e$export$6832a39c15fc3cfd(patchObject)) (0, $7kQyB.fetchAddCameraInfo)(String((0, $h5bv8.getNumbersAfterAboutSite)(location.href)), navigate, {
            silent: true
        });
        if (localStorage.groupNameChange === "true") {
            localStorage.setItem("groupNameChange", "false");
            AxiosUI.get(`customer/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}/about/`).then((response)=>{
                setSiteInfo(response.data);
                (0, $F8wri.checkArmedStatus)(response.data, setArmButtonDisabled, navigate, setSiteInfo, setArmedStatus);
                localStorage.setItem("siteInfo", JSON.stringify(response.data));
            }, (reason)=>{
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    if (clickedTab === "one") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $1Ah5f.GeneralInfoTab), {
                        siteInfo: siteInfo,
                        setSiteInfo: setSiteInfo,
                        setActiveTab: setActiveTab,
                        vmsVariables: vmsVariables
                    }));
                    else if (clickedTab === "three") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $2uQ4j.SchedulesTab), {
                        siteInfo: siteInfo
                    }));
                });
            });
            (0, $bfBpo.getUpdatedSitesPageInfo)();
        }
        if (clickedTab === "one") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $1Ah5f.GeneralInfoTab), {
            siteInfo: savedSiteInfo,
            setSiteInfo: setSiteInfo,
            setActiveTab: setActiveTab,
            vmsVariables: vmsVariables
        }));
        else if (clickedTab === "three") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $2uQ4j.SchedulesTab), {
            siteInfo: siteInfo
        }));
        else if (clickedTab === "five") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4ajRU.RecordingServerTab), {
            recordingServerData: recordingServerData
        }));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setSiteInfo(JSON.parse(localStorage.siteInfo));
            setScheduleGridEditable(false);
            setEditMode(false);
            setBackdropLoadingScreenOn(false);
            if (clickedTab === "one") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $1Ah5f.GeneralInfoTab), {
                siteInfo: siteInfo,
                setSiteInfo: setSiteInfo,
                setActiveTab: setActiveTab,
                vmsVariables: vmsVariables
            }));
            else if (clickedTab === "three") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $2uQ4j.SchedulesTab), {
                siteInfo: siteInfo
            }));
        });
    });
    if (scheduleChangesMade && clickedTab === "three") {
        setBackdropLoadingScreenOn(false);
        setBackdropLoadingScreenOnEditingSchedule(true);
        patchSchedules(setEditMode, setActiveTab, siteInfo, navigate);
    // if (handleCheckOverlappingSchedulesForSharedProducts(siteSchedules)) {
    //   alert(
    //     "Can not submit schedule changes due to overlapping products on flex schedules.  Please update the flex schdules so that no two schedules have the same product running simultaneously."
    //   );
    //   setBackdropLoadingScreenOn(false);
    // } else
    //   await submitScheduleChanges(
    //     siteSchedules,
    //     setAllSiteSchedules,
    //     setEditMode,
    //     setBackdropLoadingScreenOn,
    //     clickedTab,
    //     setActiveTab,
    //     siteInfo,
    //     vmsVariables,
    //     setDeleteScheduleDialogOpen,
    //     navigate,
    //     patchObject,
    //     setSiteInfo,
    //     setPatchObject,
    //     setAlertState,
    //     setSyncNeeded,
    //     editMode,
    //     setSchedulesTabActive,
    //     setClickedTab,
    //     siteInfoChangesMade,
    //     setSiteInfoChangesMade,
    //     scheduleChangesMade,
    //     setScheduleChangesMade,
    //     setSiteSchedules,
    //     setArmedStatus,
    //     setDeactivateSiteInsteadDialogOpen,
    //     setArmButtonDisabled,
    //     recordingServerChangesMade,
    //     recordingServerData,
    //     recordingServerPatchObject,
    //     setRecordingServerData,
    //     setRecordingServerPatchObject,
    //     setRecordingServerChangesMade,
    //     cameraHealthChangesMade,
    //     healthCheckData,
    //     setHealthCheckData,
    //     cameraHealthPatchObject,
    //     setCameraHealthPatchObject,
    //     setCameraHealthChangesMade,
    //     webhooksChangesMade,
    //     webhooksInfo,
    //     setWebhooksInfo,
    //     webhooksPatchObject,
    //     setWebhooksPatchObject,
    //     setWebhooksChangesMade,
    //     setActivateSiteWithScheduleDialogOpen
    //   );
    }
    if (recordingServerChangesMade) (0, $8Lqzk.default)(recordingServerData, recordingServerPatchObject, setRecordingServerData, setRecordingServerPatchObject, setRecordingServerChangesMade, setBackdropLoadingScreenOn, setEditMode, setActiveTab, setAlertState, navigate);
    if (cameraHealthChangesMade) (0, $fArAG.handlePatchCameraHealthData)(healthCheckData, setHealthCheckData, cameraHealthPatchObject, setCameraHealthPatchObject, setCameraHealthChangesMade, setActiveTab, setAlertState, setBackdropLoadingScreenOn, setEditMode, siteInfo, navigate);
    if (webhooksChangesMade) (0, $gDmTd.handlePatchWebhooksData)(webhooksInfo, setWebhooksInfo, webhooksPatchObject, setWebhooksPatchObject, setWebhooksChangesMade, setActiveTab, setAlertState, setBackdropLoadingScreenOn, setEditMode, navigate);
    if (evalinkChangesMade) {
        setBackdropLoadingScreenOn(true);
        handlePatchEvalink(navigate, setBackdropLoadingScreenOn, setEditMode, ()=>{
            setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $f7Odp.EvalinkTab), {}));
        });
    }
    if (wireguardChangesMade && clickedTab === "nine") {
        try {
            await (0, $kTzGL.handlePatchWireguardTunnels)(wireGuardEditSessionRef.current, String((0, $h5bv8.getNumbersAfterAboutSite)(location.href)), setWireguardTunnels, setWireguardChangesMade, setEditMode, setActiveTab, setBackdropLoadingScreenOn, navigate, selectedWireguardTunnelId, setSelectedWireguardTunnelId);
        } finally{
            // WireGuard-only saves skip the aggregate branch below that clears the backdrop.
            // Always reset here so the main loader cannot stay open (e.g. after token-refresh
            // paths that return before the patch error callback runs).
            setBackdropLoadingScreenOn(false);
        }
        wireGuardEditSessionRef.current = null;
    }
    if (!siteInfoChangesMade && !scheduleChangesMade && !recordingServerChangesMade && !cameraHealthChangesMade && !webhooksChangesMade && !anyHealthCheckMetricsUpdated && !evalinkChangesMade && !(wireguardChangesMade && clickedTab === "nine")) {
        setBackdropLoadingScreenOn(false);
        if (clickedTab === "one") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $1Ah5f.GeneralInfoTab), {
            siteInfo: siteInfo,
            setSiteInfo: setSiteInfo,
            setActiveTab: setActiveTab,
            vmsVariables: vmsVariables
        }));
        else if (clickedTab === "three") {
            setScheduleGridEditable(false);
            setEditMode(false);
            setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $2uQ4j.SchedulesTab), {
                siteInfo: siteInfo
            }));
        } else if (clickedTab === "four") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $7isVd.SMTPTab), {}));
        else if (clickedTab === "five") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4ajRU.RecordingServerTab), {
            recordingServerData: recordingServerData
        }));
        else if (clickedTab === "six") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $islbW.CameraHealthTab), {
            healthCheckData: healthCheckData,
            siteInfo: siteInfo
        }));
        else if (clickedTab === "seven") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $iXV9W.WebhooksTab), {
            webhooksInfo: webhooksInfo
        }));
        else if (clickedTab === "eight") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $f7Odp.EvalinkTab), {}));
        else if (clickedTab === "nine") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4k3Fk.WireGuardTab), {
            wireguardTunnels: wireguardTunnels,
            wireguardTunnelsLoading: wireguardTunnelsLoading,
            selectedTunnelId: selectedWireguardTunnelId,
            onSelectTunnelId: (id)=>setSelectedWireguardTunnelId(id)
        }));
    }
    if (anyHealthCheckMetricsUpdated) {
        const patchPromises = Object.keys(healthCheckMetricsUpdated).filter((key)=>healthCheckMetricsUpdated[key] === true).map((key)=>{
            return patchHealthCheckMetricsData(navigate, healthCheckMetricsData[key].id, {
                enabled: healthCheckMetricsData[key].enabled,
                alert_emails: healthCheckMetricsData[key].alert_emails
            }, key);
        });
        try {
            await Promise.allSettled(patchPromises);
            await getHealthCheckMetricsData(navigate, (0, $h5bv8.getNumbersAfterAboutSite)(location.href));
            setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $islbW.CameraHealthTab), {
                healthCheckData: healthCheckData,
                siteInfo: siteInfo
            }));
            setBackdropLoadingScreenOn(false);
            setEditMode(false);
            setScheduleGridEditable(false);
        } catch (error) {
            setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $islbW.CameraHealthTab), {
                healthCheckData: healthCheckData,
                siteInfo: siteInfo
            }));
            setBackdropLoadingScreenOn(false);
            setEditMode(true);
            setScheduleGridEditable(false);
        }
    }
};

});
parcelRegister("bfBpo", function(module, exports) {

$parcel$export(module.exports, "getUpdatedSitesPageInfo", () => $d90e97b053260093$export$cd0352ed0571ec39);

var $195EM = parcelRequire("195EM");

var $aYdit = parcelRequire("aYdit");
const $d90e97b053260093$var$apiResources = [
    [
        `group/?page_size=2027`,
        "groupArray"
    ],
    [
        `group/tree/?group_type=connector&page_size=1000`,
        "groupTrees"
    ],
    [
        `group/?page_size=10000`,
        "parentGroups"
    ]
];
async function $d90e97b053260093$var$getResource(resource) {
    const AxiosUI = (0, $195EM.createApi)(``);
    const { data: data } = await AxiosUI.get(resource[0]);
    if (resource[1] === "groupTrees") (0, $aYdit.useAppStore).getState().setGroupTrees(data.results);
    else localStorage.setItem(`${resource[1]}`, JSON.stringify(data.results));
}
async function $d90e97b053260093$export$cd0352ed0571ec39() {
    const apiPromises = $d90e97b053260093$var$apiResources.map($d90e97b053260093$var$getResource);
    await Promise.all(apiPromises);
}

});

parcelRegister("8Lqzk", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f7876095e3ab3d0$export$2e2bcd8739ae039);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $4ajRU = parcelRequire("4ajRU");

var $3Zv1D = parcelRequire("3Zv1D");

var $3FJ79 = parcelRequire("3FJ79");
const $3f7876095e3ab3d0$var$handlePatchRecordingServerData = (recordingServerData, recordingServerPatchObject, setRecordingServerData, setRecordingServerPatchObject, setRecordingServerChangesMade, setBackdropLoadingScreenOn, setEditMode, setActiveTab, setAlertState, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const { setScheduleGridEditable: setScheduleGridEditable } = (0, $3FJ79.useSiteAboutStore).getState();
    const retryFunction = ()=>{
        $3f7876095e3ab3d0$var$handlePatchRecordingServerData(recordingServerData, recordingServerPatchObject, setRecordingServerData, setRecordingServerPatchObject, setRecordingServerChangesMade, setBackdropLoadingScreenOn, setEditMode, setActiveTab, setAlertState, navigate);
    };
    const updatedRecordingServerData = [];
    let errorNumber = 0;
    recordingServerPatchObject.map((object)=>{
        AxiosUI.patch(`recording_server/${object.id}/`, object).then((response)=>{
            updatedRecordingServerData.push(response.data);
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                errorNumber += 1;
            });
        });
    });
    if (errorNumber === 0) {
        localStorage.setItem("recordingServerBackup", JSON.stringify(updatedRecordingServerData));
        setRecordingServerData(updatedRecordingServerData);
        setRecordingServerPatchObject(updatedRecordingServerData);
        setRecordingServerChangesMade(false);
        setScheduleGridEditable(false);
        setEditMode(false);
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4ajRU.RecordingServerTab), {
            recordingServerData: recordingServerData
        }));
        setBackdropLoadingScreenOn(false);
        setAlertState((previousState)=>{
            return {
                ...previousState,
                changeSuccess: true
            };
        });
    }
    if (errorNumber > 0) {
        setRecordingServerData(JSON.parse(localStorage.recordingServerBackup));
        setRecordingServerPatchObject(JSON.parse(localStorage.recordingServerBackup));
        setScheduleGridEditable(false);
        setEditMode(false);
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4ajRU.RecordingServerTab), {
            recordingServerData: JSON.parse(localStorage.recordingServerBackup)
        }));
        setRecordingServerChangesMade(false);
        setBackdropLoadingScreenOn(false);
        alert("Changes to one ore more recording servers not saved. Please check and try again.");
    }
};
var $3f7876095e3ab3d0$export$2e2bcd8739ae039 = $3f7876095e3ab3d0$var$handlePatchRecordingServerData;

});

parcelRegister("fArAG", function(module, exports) {

$parcel$export(module.exports, "handlePatchCameraHealthData", () => $69e45bfb6bd512a0$export$8945619d5b2164bf);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $islbW = parcelRequire("islbW");

var $3Zv1D = parcelRequire("3Zv1D");

var $3FJ79 = parcelRequire("3FJ79");
const $69e45bfb6bd512a0$export$8945619d5b2164bf = (healthCheckData, setHealthCheckData, cameraHealthPatchObject, setCameraHealthPatchObject, setCameraHealthChangesMade, setActiveTab, setAlertState, setBackdropLoadingScreenOn, setEditMode, siteInfo, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const { setScheduleGridEditable: setScheduleGridEditable, setHealthCheckDataZustand: setHealthCheckDataZustand, checkIfSyncNeeded: checkIfSyncNeeded } = (0, $3FJ79.useSiteAboutStore).getState();
    const retryFunction = ()=>{
        $69e45bfb6bd512a0$export$8945619d5b2164bf(healthCheckData, setHealthCheckData, cameraHealthPatchObject, setCameraHealthPatchObject, setCameraHealthChangesMade, setActiveTab, setAlertState, setBackdropLoadingScreenOn, setEditMode, siteInfo, navigate);
    };
    AxiosUI.patch(`/healthcheck/${healthCheckData.id}/`, cameraHealthPatchObject).then((response)=>{
        checkIfSyncNeeded(navigate);
        setHealthCheckData(response.data);
        setHealthCheckDataZustand(response.data);
        setCameraHealthPatchObject({});
        setCameraHealthChangesMade(false);
        setScheduleGridEditable(false);
        setEditMode(false);
        setAlertState((previousState)=>{
            return {
                ...previousState,
                healthCheckUpdateSuccess: true
            };
        });
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $islbW.CameraHealthTab), {
            healthCheckData: response.data,
            siteInfo: siteInfo
        }));
        setBackdropLoadingScreenOn(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setCameraHealthPatchObject({});
            setCameraHealthChangesMade(false);
            setScheduleGridEditable(false);
            setEditMode(false);
            setAlertState((previousState)=>{
                return {
                    ...previousState,
                    healthCheckUpdateFail: true
                };
            });
            setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $islbW.CameraHealthTab), {
                healthCheckData: healthCheckData,
                siteInfo: siteInfo
            }));
            setBackdropLoadingScreenOn(false);
        });
    });
};

});

parcelRegister("gDmTd", function(module, exports) {

$parcel$export(module.exports, "handlePatchWebhooksData", () => $50f9efc1e93a0833$export$34e53ee35259b74a);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");

var $iXV9W = parcelRequire("iXV9W");

var $lbXkF = parcelRequire("lbXkF");

var $9vEj4 = parcelRequire("9vEj4");

var $3FJ79 = parcelRequire("3FJ79");

var $7l43O = parcelRequire("7l43O");
const $50f9efc1e93a0833$export$34e53ee35259b74a = (webhooksInfo, setWebhooksInfo, webhooksPatchObject, setWebhooksPatchObject, setWebhooksChangesMade, setActiveTab, setAlertState, setBackdropLoadingScreenOn, setEditMode, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $50f9efc1e93a0833$export$34e53ee35259b74a(webhooksInfo, setWebhooksInfo, webhooksPatchObject, setWebhooksPatchObject, setWebhooksChangesMade, setActiveTab, setAlertState, setBackdropLoadingScreenOn, setEditMode, navigate);
    };
    const { setScheduleGridEditable: setScheduleGridEditable, setBackupWebhookData: setBackupWebhookData } = (0, $3FJ79.useSiteAboutStore).getState();
    const finishSaved = (webhooks)=>{
        setWebhooksPatchObject({});
        setWebhooksChangesMade(false);
        setScheduleGridEditable(false);
        setEditMode(false);
        setAlertState((previousState)=>{
            return {
                ...previousState,
                changeSuccess: true
            };
        });
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $iXV9W.WebhooksTab), {
            webhooksInfo: webhooks
        }));
        setBackdropLoadingScreenOn(false);
    };
    const pending = (0, $7l43O.pendingWebhookPatches)(webhooksPatchObject);
    if (pending.length === 0) {
        finishSaved(webhooksInfo);
        return;
    }
    Promise.all(pending.map(([id, patch])=>AxiosUI.patch(`/webhook_customer/${id}/`, patch).then((response)=>({
                id: id,
                ok: true,
                data: response.data
            }), (reason)=>({
                id: id,
                ok: false,
                reason: reason
            })))).then((outcomes)=>{
        let updated = Array.isArray(webhooksInfo) ? webhooksInfo : [];
        const fieldErrorsById = {};
        const otherFailures = [];
        outcomes.forEach((outcome)=>{
            if (outcome.ok) {
                updated = (0, $7l43O.mergeWebhookById)(updated, outcome.data);
                return;
            }
            // A 400 names the rejected fields (auth_endpoint SSRF refusal, an
            // auth_body that can't authenticate, ...).
            const fieldErrors = (0, $9vEj4.extractWebhookFieldErrors)(outcome.reason);
            if (Object.keys(fieldErrors).length > 0) fieldErrorsById[outcome.id] = fieldErrors;
            else otherFailures.push(outcome.reason);
        });
        // Whatever saved is saved, whatever the other rows did.
        setWebhooksInfo(updated);
        setBackupWebhookData(updated);
        if (otherFailures.length > 0) {
            (0, $3Zv1D.universalAPIErrorHandler)(otherFailures[0], navigate, retryFunction, ()=>{
                setWebhooksPatchObject({});
                setWebhooksChangesMade(false);
            });
            setEditMode(false);
            setAlertState((previousState)=>{
                return {
                    ...previousState,
                    webhookChangesFail: true
                };
            });
            setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $iXV9W.WebhooksTab), {
                webhooksInfo: updated
            }));
            setBackdropLoadingScreenOn(false);
            return;
        }
        if (Object.keys(fieldErrorsById).length > 0) {
            // Stay in edit mode with the rejected rows' pending changes intact and
            // show the messages on those fields.
            const remaining = {};
            pending.forEach(([id, patch])=>{
                if (fieldErrorsById[id]) remaining[id] = patch;
            });
            setWebhooksPatchObject(remaining);
            setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $lbXkF.default), {
                webhooksInfo: updated,
                setWebhooksPatchObject: setWebhooksPatchObject,
                setWebhooksChangesMade: setWebhooksChangesMade,
                fieldErrorsById: fieldErrorsById
            }));
            setBackdropLoadingScreenOn(false);
            return;
        }
        finishSaved(updated);
    });
};

});

parcelRegister("kTzGL", function(module, exports) {

$parcel$export(module.exports, "handlePatchWireguardTunnels", () => $427b9a9a5e100b6f$export$5ef02406606460ad);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");

var $h5NlZ = parcelRequire("h5NlZ");

var $4k3Fk = parcelRequire("4k3Fk");

var $3FJ79 = parcelRequire("3FJ79");
const $427b9a9a5e100b6f$export$5ef02406606460ad = async (session, customerId, setWireguardTunnels, setWireguardChangesMade, setEditMode, setActiveTab, setBackdropLoadingScreenOn, navigate, selectedWireguardTunnelId, setSelectedWireguardTunnelId)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const { setScheduleGridEditable: setScheduleGridEditable } = (0, $3FJ79.useSiteAboutStore).getState();
    const retry = ()=>{
        $427b9a9a5e100b6f$export$5ef02406606460ad(session, customerId, setWireguardTunnels, setWireguardChangesMade, setEditMode, setActiveTab, setBackdropLoadingScreenOn, navigate, selectedWireguardTunnelId, setSelectedWireguardTunnelId);
    };
    if (!session?.snapshot?.length || !session.drafts || !customerId) {
        setBackdropLoadingScreenOn(false);
        return;
    }
    const { snapshot: wireguardTunnelsEditSnapshot, drafts: wireguardDraftsById } = session;
    const dirtyIds = wireguardTunnelsEditSnapshot.filter((snap)=>{
        const d = wireguardDraftsById[snap.id];
        if (!d) return false;
        return d.name !== snap.name || d.client_public_key !== snap.client_public_key;
    }).map((t)=>t.id);
    if (dirtyIds.length === 0) {
        setWireguardChangesMade(false);
        setScheduleGridEditable(false);
        setEditMode(false);
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4k3Fk.WireGuardTab), {
            wireguardTunnels: wireguardTunnelsEditSnapshot,
            wireguardTunnelsLoading: false,
            selectedTunnelId: selectedWireguardTunnelId,
            onSelectTunnelId: (id)=>setSelectedWireguardTunnelId(id)
        }));
        setBackdropLoadingScreenOn(false);
        return;
    }
    try {
        for (const id of dirtyIds){
            const draft = wireguardDraftsById[id];
            await AxiosUI.patch(`wireguard_tunnel/${id}/`, {
                name: draft.name,
                client_public_key: draft.client_public_key
            });
        }
        const fresh = await (0, $h5NlZ.fetchWireguardTunnelsForCustomer)(customerId);
        setWireguardTunnels(fresh);
        setWireguardChangesMade(false);
        setScheduleGridEditable(false);
        setEditMode(false);
        const nextSelected = selectedWireguardTunnelId != null && fresh.some((t)=>t.id === selectedWireguardTunnelId) ? selectedWireguardTunnelId : fresh[0]?.id ?? null;
        if (nextSelected !== selectedWireguardTunnelId) setSelectedWireguardTunnelId(nextSelected);
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4k3Fk.WireGuardTab), {
            wireguardTunnels: fresh,
            wireguardTunnelsLoading: false,
            selectedTunnelId: nextSelected,
            onSelectTunnelId: (id)=>setSelectedWireguardTunnelId(id)
        }));
        setBackdropLoadingScreenOn(false);
    } catch (reason) {
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retry, ()=>{
            setWireguardChangesMade(false);
            setEditMode(false);
            setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4k3Fk.WireGuardTab), {
                wireguardTunnels: wireguardTunnelsEditSnapshot,
                wireguardTunnelsLoading: false,
                selectedTunnelId: selectedWireguardTunnelId,
                onSelectTunnelId: (id)=>setSelectedWireguardTunnelId(id)
            }));
            setBackdropLoadingScreenOn(false);
        });
    }
};

});
parcelRegister("h5NlZ", function(module, exports) {

$parcel$export(module.exports, "fetchWireguardTunnelsForCustomer", () => $c5644d25c5f3a867$export$b2acc6ba7cd7e2f8);

var $195EM = parcelRequire("195EM");
const $c5644d25c5f3a867$export$b2acc6ba7cd7e2f8 = async (customerId)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const allTunnels = [];
    const visitedUrls = new Set();
    let nextUrl = `wireguard_tunnel/?customer=${customerId}&all_levels=true`;
    while(nextUrl){
        if (visitedUrls.has(nextUrl)) break;
        visitedUrls.add(nextUrl);
        const response = await AxiosUI.get(nextUrl);
        allTunnels.push(...response.data?.results ?? []);
        nextUrl = response.data?.next ?? null;
    }
    return allTunnels;
};

});




parcelRegister("5Q799", function(module, exports) {

$parcel$export(module.exports, "EditInformationButton", () => $3d05129d5ae4ab5b$export$a2640635a254c128);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $8jTCz = parcelRequire("8jTCz");

var $4poUD = parcelRequire("4poUD");

var $6pdiI = parcelRequire("6pdiI");

var $3FJ79 = parcelRequire("3FJ79");
const $3d05129d5ae4ab5b$export$a2640635a254c128 = ({ clickedTab: clickedTab, setEditMode: setEditMode, setActiveTab: setActiveTab, setPatchObject: setPatchObject, setSiteInfo: setSiteInfo, vmsVariables: vmsVariables, setVmsVariables: setVmsVariables, siteSchedules: siteSchedules, siteInfo: siteInfo, setSiteSchedules: setSiteSchedules, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, editMode: editMode, setSchedulesTabActive: setSchedulesTabActive, setClickedTab: setClickedTab, setAlertState: setAlertState, setSyncNeeded: setSyncNeeded, setSiteInfoChangesMade: setSiteInfoChangesMade, setScheduleChangesMade: setScheduleChangesMade, setDeleteScheduleDialogOpen: setDeleteScheduleDialogOpen, recordingServerData: recordingServerData, recordingServerPatchObject: recordingServerPatchObject, setRecordingServerPatchObject: setRecordingServerPatchObject, setRecordingServerChangesMade: setRecordingServerChangesMade, healthCheckData: healthCheckData, setCameraHealthPatchObject: setCameraHealthPatchObject, setCameraHealthChangesMade: setCameraHealthChangesMade, setAddCameraHealthDialogOpen: setAddCameraHealthDialogOpen, setTurnOffHealthDialogOpen: setTurnOffHealthDialogOpen, webhooksInfo: webhooksInfo, setWebhooksPatchObject: setWebhooksPatchObject, setWebhooksChangesMade: setWebhooksChangesMade, setSiteInfoBackup: setSiteInfoBackup, setVmsVariablesBackup: setVmsVariablesBackup, setSiteSchedulesBackup: setSiteSchedulesBackup, setFlexScheduleOnEditButtonClick: setFlexScheduleOnEditButtonClick, showWireguardTab: showWireguardTab, wireguardTunnels: wireguardTunnels, selectedWireguardTunnelId: selectedWireguardTunnelId, setSelectedWireguardTunnelId: setSelectedWireguardTunnelId, onWireGuardSessionUpdate: onWireGuardSessionUpdate, setWireguardChangesMade: setWireguardChangesMade })=>{
    const editInformationText = /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {
                fontSize: "small"
            }),
            "\xa0Edit Information"
        ]
    });
    const { setScheduleGridEditable: setScheduleGridEditable } = (0, $3FJ79.useSiteAboutStore)();
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: clickedTab !== "four" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
            onClick: ()=>{
                setScheduleGridEditable(true);
                (0, $4poUD.handleEditInformationButtonClick)(clickedTab, setEditMode, setActiveTab, setPatchObject, setSiteInfo, vmsVariables, setVmsVariables, siteSchedules, siteInfo, setSiteSchedules, setBackdropLoadingScreenOn, editMode, setSchedulesTabActive, setClickedTab, setAlertState, setSyncNeeded, setSiteInfoChangesMade, setScheduleChangesMade, setDeleteScheduleDialogOpen, recordingServerData, recordingServerPatchObject, setRecordingServerPatchObject, setRecordingServerChangesMade, healthCheckData, setCameraHealthPatchObject, setCameraHealthChangesMade, setAddCameraHealthDialogOpen, setTurnOffHealthDialogOpen, webhooksInfo, setWebhooksPatchObject, setWebhooksChangesMade, setSiteInfoBackup, setVmsVariablesBackup, setSiteSchedulesBackup, setFlexScheduleOnEditButtonClick, showWireguardTab, wireguardTunnels, selectedWireguardTunnelId, setSelectedWireguardTunnelId, onWireGuardSessionUpdate, setWireguardChangesMade);
            },
            text: editInformationText,
            disabled: false
        })
    });
};

});
parcelRegister("4poUD", function(module, exports) {

$parcel$export(module.exports, "handleEditInformationButtonClick", () => $05cd7132ef9620bf$export$7edb839b07118179);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kMcJt = parcelRequire("kMcJt");

var $1W2ma = parcelRequire("1W2ma");

var $iTHZG = parcelRequire("iTHZG");

var $ivt1T = parcelRequire("ivt1T");

var $iE9hz = parcelRequire("iE9hz");

var $lbXkF = parcelRequire("lbXkF");

var $3FJ79 = parcelRequire("3FJ79");

var $2wmRq = parcelRequire("2wmRq");

var $c6iZU = parcelRequire("c6iZU");

var $2bi6M = parcelRequire("2bi6M");
const $05cd7132ef9620bf$export$7edb839b07118179 = (clickedTab, setEditMode, setActiveTab, setPatchObject, setSiteInfo, vmsVariables, setVmsVariables, siteSchedules, siteInfo, setSiteSchedules, setBackdropLoadingScreenOn, editMode, setSchedulesTabActive, setClickedTab, setAlertState, setSyncNeeded, setSiteInfoChangesMade, setScheduleChangesMade, setDeleteScheduleDialogOpen, recordingServerData, recordingServerPatchObject, setRecordingServerPatchObject, setRecordingServerChangesMade, healthCheckData, setCameraHealthPatchObject, setCameraHealthChangesMade, setAddCameraHealthDialogOpen, setTurnOffHealthDialogOpen, webhooksInfo, setWebhooksPatchObject, setWebhooksChangesMade, setSiteInfoBackup, setVmsVariablesBackup, setSiteSchedulesBackup, setFlexScheduleOnEditButtonClick, showWireguardTab, wireguardTunnels, selectedWireguardTunnelId, setSelectedWireguardTunnelId, onWireGuardSessionUpdate, setWireguardChangesMade)=>{
    localStorage.setItem("flexSchedulingChanged", "false");
    const { autoPatrolScheduleHealthchckMetrics: autoPatrolScheduleHealthchckMetrics, autoPatrolSchedules: autoPatrolSchedules } = (0, $3FJ79.useSiteAboutStore).getState();
    setSiteInfoBackup(siteInfo);
    setVmsVariablesBackup(vmsVariables);
    setSiteSchedulesBackup(siteSchedules);
    if (siteInfo.has_flex_schedule) setFlexScheduleOnEditButtonClick(true);
    if (!siteInfo.has_flex_schedule) setFlexScheduleOnEditButtonClick(false);
    localStorage.setItem("backUpSiteSchedule", JSON.stringify(siteSchedules));
    localStorage.setItem("backupAutoPatrolScheduleHealthchckMetrics", JSON.stringify(autoPatrolScheduleHealthchckMetrics));
    localStorage.setItem("backupAutoPatrolSchedules", JSON.stringify(autoPatrolSchedules));
    const isAutoPatrol = siteInfo?.integration_type_name === "autopatrol";
    if (clickedTab === "one") {
        setEditMode(true);
        if (isAutoPatrol) // For AutoPatrol sites, backup is already in Zustand store
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $1W2ma.GeneralInfoTabAutoPatrol), {
            editMode: true
        }));
        else setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $kMcJt.GeneralInfoTabEditMode), {
            setPatchObject: setPatchObject,
            setSiteInfo: setSiteInfo,
            siteInfo: siteInfo,
            setSiteInfoChangesMade: setSiteInfoChangesMade,
            vmsVariables: vmsVariables,
            setVmsVariables: setVmsVariables
        }));
    } else if (clickedTab === "three") {
        setEditMode(true);
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $iTHZG.SchedulesTabEditMode), {
            siteInfo: siteInfo,
            setEditMode: setEditMode,
            setSiteInfo: setSiteInfo,
            setActiveTab: setActiveTab
        }));
    } else if (clickedTab === "five") {
        setEditMode(true);
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $ivt1T.RecordingServerTabEditMode), {
            recordingServerData: recordingServerData,
            recordingServerPatchObject: recordingServerPatchObject,
            setRecordingServerPatchObject: setRecordingServerPatchObject,
            setRecordingServerChangesMade: setRecordingServerChangesMade
        }));
    } else if (clickedTab === "six") {
        setEditMode(true);
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $iE9hz.CameraHealthTabEditMode), {
            healthCheckData: healthCheckData,
            setCameraHealthPatchObject: setCameraHealthPatchObject,
            setCameraHealthChangesMade: setCameraHealthChangesMade,
            siteInfo: siteInfo,
            setAddCameraHealthDialogOpen: setAddCameraHealthDialogOpen,
            setTurnOffHealthDialogOpen: setTurnOffHealthDialogOpen
        }));
    } else if (clickedTab === "seven") {
        // Pending edits are keyed by webhook id (ENG-2233); start clean.
        setWebhooksPatchObject({});
        setWebhooksChangesMade(false);
        setEditMode(true);
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $lbXkF.default), {
            webhooksInfo: webhooksInfo,
            setWebhooksPatchObject: setWebhooksPatchObject,
            setWebhooksChangesMade: setWebhooksChangesMade
        }));
    } else if (clickedTab === "eight") {
        setEditMode(true);
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $2wmRq.EvalinkTabEditMode), {}));
    } else if (clickedTab === "nine" && showWireguardTab) {
        setEditMode(true);
        setWireguardChangesMade(false);
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $c6iZU.WireGuardTabEditMode), {
            wireguardTunnels: wireguardTunnels,
            selectedTunnelId: selectedWireguardTunnelId,
            onSelectTunnelId: (id)=>setSelectedWireguardTunnelId(id),
            onSessionUpdate: onWireGuardSessionUpdate,
            setWireguardChangesMade: setWireguardChangesMade
        }));
    } else if (clickedTab === (0, $2bi6M.DOUBLE_TAKE_TAB)) // SiteAbout renders the DoubleTake tab itself and passes editMode down.
    setEditMode(true);
    setSchedulesTabActive(false);
};

});


parcelRegister("77F6P", function(module, exports) {

$parcel$export(module.exports, "BreadCrumbsComponet", () => $ccf0949281cc2ad5$export$da92ee94a67d4f90);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $j0ZEU = parcelRequire("j0ZEU");

var $3IuQ3 = parcelRequire("3IuQ3");

var $f3puC = parcelRequire("f3puC");

var $5GP2e = parcelRequire("5GP2e");

var $eXOoR = parcelRequire("eXOoR");

var $cVCJe = parcelRequire("cVCJe");

var $fHwDV = parcelRequire("fHwDV");

var $2RkVu = parcelRequire("2RkVu");

var $91a6D = parcelRequire("91a6D");

var $hoX7M = parcelRequire("hoX7M");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $bKFKn = parcelRequire("bKFKn");
const $ccf0949281cc2ad5$export$da92ee94a67d4f90 = ({ linksArray: linksArray, handleClick: handleClick, styling: styling, breadcrumb_info: breadcrumb_info, siteInfo: siteInfo })=>{
    const navigate = (0, $3T949.useNavigate)();
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        localStorage.setItem("parentGroupId", breadcrumb_info[0].id);
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3IuQ3.default), {
        spacing: 2,
        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
            className: styling,
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $j0ZEU.default), {
                separator: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXOoR))), {
                    fontSize: "medium"
                }),
                "aria-label": "breadcrumb",
                children: linksArray.map((object, index)=>{
                    if (index === 0) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                        title: object.name,
                        placement: "top",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                            underline: "hover",
                            color: "inherit",
                            href: "/sites",
                            sx: {
                                fontSize: "17px",
                                fontFamily: "Mulish",
                                fontWeight: "bold"
                            },
                            variant: "h5",
                            onClick: handleClick,
                            children: (0, $bKFKn.nameSlicer)(object.name)
                        }, index)
                    }, index);
                    else if (index === 1 && linksArray.length > 2 && siteInfo?.integration_type_name !== "autopatrol") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                        title: object.name,
                        placement: "top",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                            underline: "hover",
                            color: "inherit",
                            href: "#",
                            sx: {
                                fontSize: "17px",
                                fontFamily: "Mulish",
                                fontWeight: "bold"
                            },
                            variant: "h5",
                            onClick: ()=>{
                                (0, $fHwDV.handleLevel1IndexClick)(breadcrumb_info[0].id, navigate);
                            },
                            children: (0, $bKFKn.nameSlicer)(object.name)
                        }, index)
                    }, index);
                    else if (index === 2 && linksArray.length > 3) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                        title: object.name,
                        placement: "top",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                            underline: "hover",
                            color: "inherit",
                            href: "#",
                            sx: {
                                fontSize: "17px",
                                fontFamily: "Mulish",
                                fontWeight: "bold"
                            },
                            variant: "h5",
                            onClick: ()=>{
                                (0, $2RkVu.handleLevel2IndexClick)(breadcrumb_info, siteInfo, navigate);
                            },
                            children: (0, $bKFKn.nameSlicer)(object.name)
                        }, index)
                    }, index);
                    else if (index === 3 && linksArray.length > 4) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                        title: object.name,
                        placement: "top",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                            underline: "hover",
                            color: "inherit",
                            href: "#",
                            sx: {
                                fontSize: "17px",
                                fontFamily: "Mulish",
                                fontWeight: "bold"
                            },
                            variant: "h5",
                            onClick: ()=>{
                                (0, $91a6D.handleLevel3IndexClick)(breadcrumb_info, siteInfo, navigate);
                            },
                            children: (0, $bKFKn.nameSlicer)(object.name)
                        }, index)
                    }, index);
                    else if (index === 4 && linksArray.length > 5) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                        title: object.name,
                        placement: "top",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                            underline: "hover",
                            color: "inherit",
                            href: "#",
                            sx: {
                                fontSize: "17px",
                                fontFamily: "Mulish",
                                fontWeight: "bold"
                            },
                            variant: "h5",
                            onClick: ()=>{
                                (0, $hoX7M.handleLevel4IndexClick)(breadcrumb_info, siteInfo, navigate);
                            },
                            children: (0, $bKFKn.nameSlicer)(object.name)
                        }, index)
                    }, index);
                    else if (!(index === 1 && siteInfo.integration_type_name === "autopatrol")) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        color: "text.primary",
                        fontSize: "17px",
                        fontFamily: "Mulish",
                        fontWeight: "bold",
                        children: object.name
                    }, index);
                })
            })
        })
    });
};

});
parcelRegister("j0ZEU", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd7dd88ef526d681$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $7Se60 = parcelRequire("7Se60");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $97LlG = parcelRequire("97LlG");

var $aYNpO = parcelRequire("aYNpO");

var $6zZUJ = parcelRequire("6zZUJ");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $f3puC = parcelRequire("f3puC");

var $gdo8m = parcelRequire("gdo8m");

var $8VP2v = parcelRequire("8VP2v");

var $k4ank = parcelRequire("k4ank");
'use client';
const $dd7dd88ef526d681$var$_excluded = [
    "children",
    "className",
    "component",
    "slots",
    "slotProps",
    "expandText",
    "itemsAfterCollapse",
    "itemsBeforeCollapse",
    "maxItems",
    "separator"
];
const $dd7dd88ef526d681$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        li: [
            'li'
        ],
        ol: [
            'ol'
        ],
        separator: [
            'separator'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $8VP2v.getBreadcrumbsUtilityClass), classes);
};
const $dd7dd88ef526d681$var$BreadcrumbsRoot = (0, $anJSP.default)((0, $f3puC.default), {
    name: 'MuiBreadcrumbs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        return [
            {
                [`& .${(0, $8VP2v.default).li}`]: styles.li
            },
            styles.root
        ];
    }
})({});
const $dd7dd88ef526d681$var$BreadcrumbsOl = (0, $anJSP.default)('ol', {
    name: 'MuiBreadcrumbs',
    slot: 'Ol',
    overridesResolver: (props, styles)=>styles.ol
})({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
});
const $dd7dd88ef526d681$var$BreadcrumbsSeparator = (0, $anJSP.default)('li', {
    name: 'MuiBreadcrumbs',
    slot: 'Separator',
    overridesResolver: (props, styles)=>styles.separator
})({
    display: 'flex',
    userSelect: 'none',
    marginLeft: 8,
    marginRight: 8
});
function $dd7dd88ef526d681$var$insertSeparators(items, className, separator, ownerState) {
    return items.reduce((acc, current, index)=>{
        if (index < items.length - 1) acc = acc.concat(current, /*#__PURE__*/ (0, $k4ank.jsx)($dd7dd88ef526d681$var$BreadcrumbsSeparator, {
            "aria-hidden": true,
            className: className,
            ownerState: ownerState,
            children: separator
        }, `separator-${index}`));
        else acc.push(current);
        return acc;
    }, []);
}
const $dd7dd88ef526d681$var$Breadcrumbs = /*#__PURE__*/ $8T3gX.forwardRef(function Breadcrumbs(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiBreadcrumbs'
    });
    const { children: children, className: className, component: component = 'nav', slots: slots = {}, slotProps: slotProps = {}, expandText: expandText = 'Show path', itemsAfterCollapse: itemsAfterCollapse = 1, itemsBeforeCollapse: itemsBeforeCollapse = 1, maxItems: maxItems = 8, separator: separator = '/' } = props, other = (0, $fAJB5.default)(props, $dd7dd88ef526d681$var$_excluded);
    const [expanded, setExpanded] = $8T3gX.useState(false);
    const ownerState = (0, $eJfrs.default)({}, props, {
        component: component,
        expanded: expanded,
        expandText: expandText,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        maxItems: maxItems,
        separator: separator
    });
    const classes = $dd7dd88ef526d681$var$useUtilityClasses(ownerState);
    const collapsedIconSlotProps = (0, $6zZUJ.default)({
        elementType: slots.CollapsedIcon,
        externalSlotProps: slotProps.collapsedIcon,
        ownerState: ownerState
    });
    const listRef = $8T3gX.useRef(null);
    const renderItemsBeforeAndAfter = (allItems)=>{
        const handleClickExpand = ()=>{
            setExpanded(true);
            // The clicked element received the focus but gets removed from the DOM.
            // Let's keep the focus in the component after expanding.
            // Moving it to the <ol> or <nav> does not cause any announcement in NVDA.
            // By moving it to some link/button at least we have some announcement.
            const focusable = listRef.current.querySelector('a[href],button,[tabindex]');
            if (focusable) focusable.focus();
        };
        // This defends against someone passing weird input, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
            console.error([
                'MUI: You have provided an invalid combination of props to the Breadcrumbs.',
                `itemsAfterCollapse={${itemsAfterCollapse}} + itemsBeforeCollapse={${itemsBeforeCollapse}} >= maxItems={${maxItems}}`
            ].join('\n'));
            return allItems;
        }
        return [
            ...allItems.slice(0, itemsBeforeCollapse),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gdo8m.default), {
                "aria-label": expandText,
                slots: {
                    CollapsedIcon: slots.CollapsedIcon
                },
                slotProps: {
                    collapsedIcon: collapsedIconSlotProps
                },
                onClick: handleClickExpand
            }, "ellipsis"),
            ...allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)
        ];
    };
    const allItems = $8T3gX.Children.toArray(children).filter((child)=>{
        if ((0, $7Se60.isFragment)(child)) console.error([
            "MUI: The Breadcrumbs component doesn't accept a Fragment as a child.",
            'Consider providing an array instead.'
        ].join('\n'));
        return /*#__PURE__*/ $8T3gX.isValidElement(child);
    }).map((child, index)=>/*#__PURE__*/ (0, $k4ank.jsx)("li", {
            className: classes.li,
            children: child
        }, `child-${index}`));
    return /*#__PURE__*/ (0, $k4ank.jsx)($dd7dd88ef526d681$var$BreadcrumbsRoot, (0, $eJfrs.default)({
        ref: ref,
        component: component,
        color: "text.secondary",
        className: (0, $iVyaN.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $k4ank.jsx)($dd7dd88ef526d681$var$BreadcrumbsOl, {
            className: classes.ol,
            ref: listRef,
            ownerState: ownerState,
            children: $dd7dd88ef526d681$var$insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator, ownerState)
        })
    }));
});
$dd7dd88ef526d681$var$Breadcrumbs.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * Override the default label for the expand button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Show path'
   */ expandText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If max items is exceeded, the number of items to show after the ellipsis.
   * @default 1
   */ itemsAfterCollapse: (0, $97LlG.default),
    /**
   * If max items is exceeded, the number of items to show before the ellipsis.
   * @default 1
   */ itemsBeforeCollapse: (0, $97LlG.default),
    /**
   * Specifies the maximum number of breadcrumbs to display. When there are more
   * than the maximum number, only the first `itemsBeforeCollapse` and last `itemsAfterCollapse`
   * will be shown, with an ellipsis in between.
   * @default 8
   */ maxItems: (0, $97LlG.default),
    /**
   * Custom separator node.
   * @default '/'
   */ separator: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * The props used for each slot inside the Breadcumb.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        collapsedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        ])
    }),
    /**
   * The components used for each slot inside the Breadcumb.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        CollapsedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $dd7dd88ef526d681$export$2e2bcd8739ae039 = $dd7dd88ef526d681$var$Breadcrumbs;

});
parcelRegister("gdo8m", function(module, exports) {

$parcel$export(module.exports, "default", () => $bce094b6ba558a61$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");
parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $aBrLz = parcelRequire("aBrLz");

var $anJSP = parcelRequire("anJSP");

var $fRJI0 = parcelRequire("fRJI0");

var $hhKOZ = parcelRequire("hhKOZ");

var $k4ank = parcelRequire("k4ank");
'use client';
const $bce094b6ba558a61$var$_excluded = [
    "slots",
    "slotProps"
];
const $bce094b6ba558a61$var$BreadcrumbCollapsedButton = (0, $anJSP.default)((0, $hhKOZ.default), {
    name: 'MuiBreadcrumbCollapsed'
})(({ theme: theme })=>(0, $eJfrs.default)({
        display: 'flex',
        marginLeft: `calc(${theme.spacing(1)} * 0.5)`,
        marginRight: `calc(${theme.spacing(1)} * 0.5)`
    }, theme.palette.mode === 'light' ? {
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.grey[700]
    } : {
        backgroundColor: theme.palette.grey[700],
        color: theme.palette.grey[100]
    }, {
        borderRadius: 2,
        '&:hover, &:focus': (0, $eJfrs.default)({}, theme.palette.mode === 'light' ? {
            backgroundColor: theme.palette.grey[200]
        } : {
            backgroundColor: theme.palette.grey[600]
        }),
        '&:active': (0, $eJfrs.default)({
            boxShadow: theme.shadows[0]
        }, theme.palette.mode === 'light' ? {
            backgroundColor: (0, $aBrLz.emphasize)(theme.palette.grey[200], 0.12)
        } : {
            backgroundColor: (0, $aBrLz.emphasize)(theme.palette.grey[600], 0.12)
        })
    }));
const $bce094b6ba558a61$var$BreadcrumbCollapsedIcon = (0, $anJSP.default)((0, $fRJI0.default))({
    width: 24,
    height: 16
});
/**
 * @ignore - internal component.
 */ function $bce094b6ba558a61$var$BreadcrumbCollapsed(props) {
    const { slots: slots = {}, slotProps: slotProps = {} } = props, otherProps = (0, $fAJB5.default)(props, $bce094b6ba558a61$var$_excluded);
    const ownerState = props;
    return /*#__PURE__*/ (0, $k4ank.jsx)("li", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)($bce094b6ba558a61$var$BreadcrumbCollapsedButton, (0, $eJfrs.default)({
            focusRipple: true
        }, otherProps, {
            ownerState: ownerState,
            children: /*#__PURE__*/ (0, $k4ank.jsx)($bce094b6ba558a61$var$BreadcrumbCollapsedIcon, (0, $eJfrs.default)({
                as: slots.CollapsedIcon,
                ownerState: ownerState
            }, slotProps.collapsedIcon))
        }))
    });
}
$bce094b6ba558a61$var$BreadcrumbCollapsed.propTypes = {
    /**
   * The props used for the CollapsedIcon slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        collapsedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        ])
    }),
    /**
   * The components used for each slot inside the BreadcumbCollapsed.
   * Either a string to use a HTML element or a component.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        CollapsedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
};
var $bce094b6ba558a61$export$2e2bcd8739ae039 = $bce094b6ba558a61$var$BreadcrumbCollapsed;

});
parcelRegister("fRJI0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8cf430ad76a1a22$export$2e2bcd8739ae039);
parcelRequire("8T3gX");

var $a7uO0 = parcelRequire("a7uO0");

var $k4ank = parcelRequire("k4ank");
'use client';
var $b8cf430ad76a1a22$export$2e2bcd8739ae039 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz');

});


parcelRegister("8VP2v", function(module, exports) {

$parcel$export(module.exports, "getBreadcrumbsUtilityClass", () => $680b3cf39c033407$export$17261110b18c8084);
$parcel$export(module.exports, "default", () => $680b3cf39c033407$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $680b3cf39c033407$export$17261110b18c8084(slot) {
    return (0, $kfTYv.default)('MuiBreadcrumbs', slot);
}
const $680b3cf39c033407$var$breadcrumbsClasses = (0, $jh2Zm.default)('MuiBreadcrumbs', [
    'root',
    'ol',
    'li',
    'separator'
]);
var $680b3cf39c033407$export$2e2bcd8739ae039 = $680b3cf39c033407$var$breadcrumbsClasses;

});


parcelRegister("5GP2e", function(module, exports) {

$parcel$export(module.exports, "default", () => $42487679735e8730$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $26cdd = parcelRequire("26cdd");

var $aYNpO = parcelRequire("aYNpO");

var $iMOmE = parcelRequire("iMOmE");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $4J28n = parcelRequire("4J28n");

var $11ydL = parcelRequire("11ydL");

var $f3puC = parcelRequire("f3puC");

var $gc5a1 = parcelRequire("gc5a1");

var $6aUD2 = parcelRequire("6aUD2");

var $k4ank = parcelRequire("k4ank");
'use client';
const $42487679735e8730$var$_excluded = [
    "className",
    "color",
    "component",
    "onBlur",
    "onFocus",
    "TypographyClasses",
    "underline",
    "variant",
    "sx"
];
const $42487679735e8730$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            'root',
            `underline${(0, $iMOmE.default)(underline)}`,
            component === 'button' && 'button',
            focusVisible && 'focusVisible'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $gc5a1.getLinkUtilityClass), classes);
};
const $42487679735e8730$var$LinkRoot = (0, $anJSP.default)((0, $f3puC.default), {
    name: 'MuiLink',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $iMOmE.default)(ownerState.underline)}`],
            ownerState.component === 'button' && styles.button
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    return (0, $eJfrs.default)({}, ownerState.underline === 'none' && {
        textDecoration: 'none'
    }, ownerState.underline === 'hover' && {
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline'
        }
    }, ownerState.underline === 'always' && (0, $eJfrs.default)({
        textDecoration: 'underline'
    }, ownerState.color !== 'inherit' && {
        textDecorationColor: (0, $6aUD2.default)({
            theme: theme,
            ownerState: ownerState
        })
    }, {
        '&:hover': {
            textDecorationColor: 'inherit'
        }
    }), ownerState.component === 'button' && {
        position: 'relative',
        WebkitTapHighlightColor: 'transparent',
        backgroundColor: 'transparent',
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: 'pointer',
        userSelect: 'none',
        verticalAlign: 'middle',
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        '&::-moz-focus-inner': {
            borderStyle: 'none' // Remove Firefox dotted outline.
        },
        [`&.${(0, $gc5a1.default).focusVisible}`]: {
            outline: 'auto'
        }
    });
});
const $42487679735e8730$var$Link = /*#__PURE__*/ $8T3gX.forwardRef(function Link(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiLink'
    });
    const { className: className, color: color = 'primary', component: component = 'a', onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = 'always', variant: variant = 'inherit', sx: sx } = props, other = (0, $fAJB5.default)(props, $42487679735e8730$var$_excluded);
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $4J28n.default)();
    const [focusVisible, setFocusVisible] = $8T3gX.useState(false);
    const handlerRef = (0, $11ydL.default)(ref, focusVisibleRef);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = (0, $eJfrs.default)({}, props, {
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    const classes = $42487679735e8730$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsx)($42487679735e8730$var$LinkRoot, (0, $eJfrs.default)({
        color: color,
        className: (0, $iVyaN.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: handlerRef,
        ownerState: ownerState,
        variant: variant,
        sx: [
            ...!Object.keys((0, $6aUD2.colorTransformations)).includes(color) ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ]
    }, other));
});
$42487679735e8730$var$Link.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The color of the link.
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).any,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, $26cdd.default),
    /**
   * @ignore
   */ onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * `classes` prop applied to the [`Typography`](/material-ui/api/typography/) element.
   */ TypographyClasses: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Controls when the link should have an underline.
   * @default 'always'
   */ underline: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'always',
        'hover',
        'none'
    ]),
    /**
   * Applies the theme typography styles.
   * @default 'inherit'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'body1',
            'body2',
            'button',
            'caption',
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            'inherit',
            'overline',
            'subtitle1',
            'subtitle2'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ])
};
var $42487679735e8730$export$2e2bcd8739ae039 = $42487679735e8730$var$Link;

});
parcelRegister("gc5a1", function(module, exports) {

$parcel$export(module.exports, "getLinkUtilityClass", () => $bca1c520ec246c8e$export$d6efab9620b78fec);
$parcel$export(module.exports, "default", () => $bca1c520ec246c8e$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $bca1c520ec246c8e$export$d6efab9620b78fec(slot) {
    return (0, $kfTYv.default)('MuiLink', slot);
}
const $bca1c520ec246c8e$var$linkClasses = (0, $jh2Zm.default)('MuiLink', [
    'root',
    'underlineNone',
    'underlineHover',
    'underlineAlways',
    'button',
    'focusVisible'
]);
var $bca1c520ec246c8e$export$2e2bcd8739ae039 = $bca1c520ec246c8e$var$linkClasses;

});

parcelRegister("6aUD2", function(module, exports) {

$parcel$export(module.exports, "colorTransformations", () => $47ef9a7fe1c58240$export$c4e140d5d351182b);
$parcel$export(module.exports, "default", () => $47ef9a7fe1c58240$export$2e2bcd8739ae039);

var $8QOpa = parcelRequire("8QOpa");

var $aBrLz = parcelRequire("aBrLz");
const $47ef9a7fe1c58240$export$c4e140d5d351182b = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $47ef9a7fe1c58240$var$transformDeprecatedColors = (color)=>{
    return $47ef9a7fe1c58240$export$c4e140d5d351182b[color] || color;
};
const $47ef9a7fe1c58240$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = $47ef9a7fe1c58240$var$transformDeprecatedColors(ownerState.color);
    const color = (0, $8QOpa.getPath)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $8QOpa.getPath)(theme, `palette.${transformedColor}Channel`);
    if ('vars' in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $aBrLz.alpha)(color, 0.4);
};
var $47ef9a7fe1c58240$export$2e2bcd8739ae039 = $47ef9a7fe1c58240$var$getTextDecoration;

});


parcelRegister("eXOoR", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ae4dabc2324cac42$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $ae4dabc2324cac42$var$_default = module.exports.default = (0, $ae4dabc2324cac42$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');

});

parcelRegister("fHwDV", function(module, exports) {

$parcel$export(module.exports, "handleLevel1IndexClick", () => $fb25f82467564178$export$f4c8867b10d418a6);
const $fb25f82467564178$export$f4c8867b10d418a6 = (id, navigate)=>{
    if (id !== Number(localStorage.clickedId)) localStorage.setItem("sitesTablePage", "0");
    localStorage.setItem("storedSelectedIndex", JSON.stringify({
        level1: "",
        level2: "",
        level3: "",
        level4: "",
        level5: "",
        level6: ""
    }));
    localStorage.setItem("siteAboutScrollTop", "0");
    localStorage.setItem("expandedObjectSaved", "false");
    localStorage.setItem("navigatedFromSitesAboutPage", "true");
    localStorage.setItem("clickedId", JSON.stringify(id));
    localStorage.setItem("level1Click", "true");
    localStorage.setItem("level1Id", JSON.stringify(id));
    navigate("/sites");
};

});

parcelRegister("2RkVu", function(module, exports) {

$parcel$export(module.exports, "handleLevel2IndexClick", () => $588db74ce7666609$export$64cba7090cada80c);
const $588db74ce7666609$export$64cba7090cada80c = async (breadcrumb_info, siteInfo, navigate)=>{
    if (breadcrumb_info[1].id !== Number(localStorage.clickedId)) localStorage.setItem("sitesTablePage", "0");
    if (siteInfo?.integration_type_name !== "autopatrol") localStorage.setItem("storedSelectedIndex", JSON.stringify({
        level1: [
            Number(breadcrumb_info[0].id)
        ],
        level2: [
            Number(breadcrumb_info[1].id)
        ],
        level3: [],
        level4: [],
        level5: [],
        level6: []
    }));
    else localStorage.setItem("storedSelectedIndex", JSON.stringify({
        level1: [
            Number(breadcrumb_info[1].id)
        ],
        level2: [],
        level3: [],
        level4: [],
        level5: [],
        level6: []
    }));
    localStorage.setItem("siteAboutScrollTop", "0");
    localStorage.setItem("expandedObjectSaved", "false");
    localStorage.setItem("navigatedFromSitesAboutPage", "true");
    localStorage.setItem("level2Click", "true");
    localStorage.setItem("clickedId", JSON.stringify(breadcrumb_info[1].id));
    localStorage.setItem("level1Id", JSON.stringify(breadcrumb_info[0].id));
    localStorage.setItem("level2Id", JSON.stringify(breadcrumb_info[1].id));
    siteInfo?.integration_type_name === "autopatrol" ? navigate("/sites_patrol") : navigate("/sites");
};

});

parcelRegister("91a6D", function(module, exports) {

$parcel$export(module.exports, "handleLevel3IndexClick", () => $eb7eebc80a81352c$export$3fba543cd694432e);
const $eb7eebc80a81352c$export$3fba543cd694432e = async (breadcrumb_info, siteInfo, navigate)=>{
    if (breadcrumb_info[2].id !== Number(localStorage.clickedId)) localStorage.setItem("sitesTablePage", "0");
    localStorage.setItem("storedSelectedIndex", JSON.stringify({
        level1: "",
        level2: "",
        level3: "",
        level4: "",
        level5: "",
        level6: ""
    }));
    localStorage.setItem("siteAboutScrollTop", "0");
    localStorage.setItem("expandedObjectSaved", "false");
    localStorage.setItem("navigatedFromSitesAboutPage", "true");
    localStorage.setItem("clickedId", JSON.stringify(breadcrumb_info[2].id));
    localStorage.setItem("level1Id", JSON.stringify(breadcrumb_info[0].id));
    localStorage.setItem("level2Id", JSON.stringify(breadcrumb_info[1].id));
    localStorage.setItem("level3Id", JSON.stringify(breadcrumb_info[2].id));
    localStorage.setItem("level3Click", "true");
    siteInfo?.integration_type_name === "autopatrol" ? navigate("/sites_patrol") : navigate("/sites");
};

});

parcelRegister("hoX7M", function(module, exports) {

$parcel$export(module.exports, "handleLevel4IndexClick", () => $ccf71839e2e51d5a$export$ac164fdf601fdcef);
const $ccf71839e2e51d5a$export$ac164fdf601fdcef = async (breadcrumb_info, siteInfo, navigate)=>{
    if (breadcrumb_info[3].id !== Number(localStorage.clickedId)) localStorage.setItem("sitesTablePage", "0");
    localStorage.setItem("storedSelectedIndex", JSON.stringify({
        level1: "",
        level2: "",
        level3: "",
        level4: "",
        level5: "",
        level6: ""
    }));
    localStorage.setItem("siteAboutScrollTop", "0");
    localStorage.setItem("expandedObjectSaved", "false");
    localStorage.setItem("navigatedFromSitesAboutPage", "true");
    localStorage.setItem("clickedId", JSON.stringify(breadcrumb_info[3].id));
    localStorage.setItem("level1Id", JSON.stringify(breadcrumb_info[0].id));
    localStorage.setItem("level2Id", JSON.stringify(breadcrumb_info[1].id));
    localStorage.setItem("level3Id", JSON.stringify(breadcrumb_info[2].id));
    localStorage.setItem("level4Id", JSON.stringify(breadcrumb_info[3].id));
    localStorage.setItem("level4Click", "true");
    siteInfo?.integration_type_name === "autopatrol" ? navigate("/sites_patrol") : navigate("/sites");
};

});

parcelRegister("bKFKn", function(module, exports) {

$parcel$export(module.exports, "nameSlicer", () => $de2953021f19e01e$export$9d14de80ddf2af7f);
const $de2953021f19e01e$export$9d14de80ddf2af7f = (name)=>{
    if (name.length < 25) return name;
    else return `${name.slice(0, 10)}...`;
};

});


parcelRegister("740m5", function(module, exports) {

$parcel$export(module.exports, "SyncSiteButton", () => $0457a22e2689b427$export$e9c70894ce8c089a);

var $k4ank = parcelRequire("k4ank");

var $cIfQ5 = parcelRequire("cIfQ5");

var $8T3gX = parcelRequire("8T3gX");

var $2kGAP = parcelRequire("2kGAP");

var $kUcVg = parcelRequire("kUcVg");
var $887xF = parcelRequire("887xF");
var $1TOOV = parcelRequire("1TOOV");
var $iLEpm = parcelRequire("iLEpm");
var $cVCJe = parcelRequire("cVCJe");

var $8d0Hr = parcelRequire("8d0Hr");

var $3FJ79 = parcelRequire("3FJ79");

var $8jTCz = parcelRequire("8jTCz");
const $0457a22e2689b427$export$e9c70894ce8c089a = ({ syncNeeded: syncNeeded, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setSyncNeeded: setSyncNeeded, setAlertState: setAlertState, siteInfo: siteInfo, setSiteInfo: setSiteInfo, setAllSiteSchedules: setAllSiteSchedules, setActiveTab: setActiveTab, vmsVariables: vmsVariables, setSiteDeployed: setSiteDeployed, setDeativateInquiryDialogOpen: setDeativateInquiryDialogOpen, setSiteCameras: setSiteCameras, camerasNotDeployed: camerasNotDeployed, setCamerasNotDeployed: setCamerasNotDeployed, navigate: navigate, setVmsVariables: setVmsVariables, setClickedTab: setClickedTab, setArmButtonDisabled: setArmButtonDisabled, setArmedStatus: setArmedStatus, setRebootDialogOpen: setRebootDialogOpen })=>{
    // State to hold the formatted time string
    const [timeString, setTimeString] = (0, $8T3gX.useState)((0, $8d0Hr.timeSinceLastSync)(siteInfo.deployed_date));
    const [syncSiteButtonDialogOpen, setSyncSiteButtonDialogOpen] = (0, $8T3gX.useState)(false);
    const { syncSiteNeeded: syncSiteNeeded, syncPending: syncPending, setSyncSiteNeededAlertOpen: setSyncSiteNeededAlertOpen } = (0, $3FJ79.useSiteAboutStore)();
    // Effect to update the time string every minute
    (0, $8T3gX.useEffect)(()=>{
        // Update immediately when deployed_date changes
        setTimeString((0, $8d0Hr.timeSinceLastSync)(siteInfo.deployed_date));
        // Set up interval to update every minute
        const intervalId = setInterval(()=>{
            setTimeString((0, $8d0Hr.timeSinceLastSync)(siteInfo.deployed_date));
        }, 60000); // 60000 ms = 1 minute
        // Clean up interval on component unmount
        return ()=>clearInterval(intervalId);
    }, [
        siteInfo.deployed_date
    ]); // Re-run effect when deployed_date changes
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $kUcVg.default), {
                open: syncSiteButtonDialogOpen,
                onClose: ()=>setSyncSiteButtonDialogOpen(false),
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                            children: "All site settings have been synced. Syncing not needed."
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                            children: "Would you like to sync anyways?"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    onClick: ()=>setSyncSiteButtonDialogOpen(false),
                                    text: "Cancel",
                                    disabled: false
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    onClick: ()=>{
                                        setSyncSiteButtonDialogOpen(false);
                                        setSiteDeployed(true);
                                        setBackdropLoadingScreenOn(true);
                                        setSyncSiteNeededAlertOpen(false);
                                        (0, $2kGAP.handleSyncSite)(setBackdropLoadingScreenOn, setAlertState, siteInfo, setSiteInfo, setSyncNeeded, setAllSiteSchedules, setActiveTab, vmsVariables, setSiteDeployed, setDeativateInquiryDialogOpen, setSiteCameras, camerasNotDeployed, setCamerasNotDeployed, navigate, setVmsVariables, setClickedTab, setArmButtonDisabled, setArmedStatus, setRebootDialogOpen);
                                    },
                                    text: "Sync",
                                    disabled: false
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                title: syncPending ? "Sync requested \u2014 waiting for the site to confirm the deploy." : syncNeeded ? "" : `All site settings have been synced. Syncing not needed.  Last synced ${timeString}.`,
                placement: "top",
                sx: {
                    fontSize: "15px",
                    fontFamily: "mulish"
                },
                children: syncPending ? /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
                    className: "shadow-button bg-[#ed6c02] rounded font-mulish text-white text-base p-1.5 cursor-wait",
                    disabled: true,
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cIfQ5))), {
                            fontSize: "small",
                            className: "animate-spin"
                        }),
                        "\xa0 Syncing... \xa0"
                    ]
                }) : !syncNeeded && !syncSiteNeeded ? // <span>
                //   <button
                //     className="shadow-button bg-actuate-grey rounded font-mulish text-white text-base	p-1.5"
                //     disabled={true}
                //   >
                //     <SyncIcon fontSize="small" />
                //     &nbsp; Sync Site &nbsp;
                //   </button>
                // </span>
                /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
                    className: "shadow-button bg-[#2e7d32] rounded font-mulish text-white text-base p-1.5 hover:bg-[#1b5e20]",
                    onClick: ()=>{
                        setSyncSiteButtonDialogOpen(true);
                    // setBackdropLoadingScreenOn(true);
                    // setSyncNeeded(false);
                    // setSyncSiteNeeded(false);
                    // setSyncSiteNeededAlertOpen(false);
                    // handleSyncSite(
                    //   setBackdropLoadingScreenOn,
                    //   setAlertState,
                    //   siteInfo,
                    //   setSiteInfo,
                    //   setSyncNeeded,
                    //   setAllSiteSchedules,
                    //   setActiveTab,
                    //   vmsVariables,
                    //   setSiteDeployed,
                    //   setDeativateInquiryDialogOpen,
                    //   setSiteCameras,
                    //   camerasNotDeployed,
                    //   setCamerasNotDeployed,
                    //   navigate,
                    //   setVmsVariables,
                    //   setClickedTab,
                    //   setArmButtonDisabled,
                    //   setArmedStatus
                    // );
                    },
                    disabled: false,
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cIfQ5))), {
                            fontSize: "small"
                        }),
                        "\xa0 Sync Site \xa0"
                    ]
                }) : /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
                    className: "shadow-button bg-[#d32f2f] rounded font-mulish text-white text-base p-1.5 hover:bg-[#c62828]",
                    onClick: ()=>{
                        setSiteDeployed(true);
                        setBackdropLoadingScreenOn(true);
                        setSyncSiteNeededAlertOpen(false);
                        (0, $2kGAP.handleSyncSite)(setBackdropLoadingScreenOn, setAlertState, siteInfo, setSiteInfo, setSyncNeeded, setAllSiteSchedules, setActiveTab, vmsVariables, setSiteDeployed, setDeativateInquiryDialogOpen, setSiteCameras, camerasNotDeployed, setCamerasNotDeployed, navigate, setVmsVariables, setClickedTab, setArmButtonDisabled, setArmedStatus, setRebootDialogOpen);
                    },
                    disabled: false,
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cIfQ5))), {
                            fontSize: "small"
                        }),
                        "\xa0 Sync Site \xa0"
                    ]
                })
            })
        ]
    });
};

});
parcelRegister("2kGAP", function(module, exports) {

$parcel$export(module.exports, "handleSyncSite", () => $ceda631c0a58c620$export$80b62b112a7e36c6);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $815yO = parcelRequire("815yO");

var $1Ah5f = parcelRequire("1Ah5f");

var $F8wri = parcelRequire("F8wri");

var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("elyck");
var $h5bv8 = parcelRequire("h5bv8");

var $gOe74 = parcelRequire("gOe74");

var $3FJ79 = parcelRequire("3FJ79");

var $c4ZfI = parcelRequire("c4ZfI");
const $ceda631c0a58c620$export$80b62b112a7e36c6 = async (setBackdropLoadingScreenOn, setAlertState, siteInfo, setSiteInfo, setSyncNeeded, setAllSiteSchedules, setActiveTab, vmsVariables, setSiteDeployed, setDeativateInquiryDialogOpen, setSiteCameras, camerasNotDeployed, setCamerasNotDeployed, navigate, setVmsVariables, setClickedTab, setArmButtonDisabled, setArmedStatus, setRebootDialogOpen)=>{
    // Deploys run async in django-q: deploy_next's 200 only means "queued", so
    // don't flip the synced state optimistically — wait for settings_deployed.
    const { setSyncPending: setSyncPending, setSyncSiteNeeded: setSyncSiteNeeded } = (0, $3FJ79.useSiteAboutStore).getState();
    const AxiosUI = (0, $195EM.createApi)(``);
    // siteDeployed only drives the "Site not deployed" banner — close it as
    // soon as sync is requested (including from the About Sync Site button).
    // Failure paths below set it back to false so the banner can reappear.
    setSiteDeployed(true);
    setBackdropLoadingScreenOn(true);
    const retryFunction = ()=>{
        $ceda631c0a58c620$export$80b62b112a7e36c6(setBackdropLoadingScreenOn, setAlertState, siteInfo, setSiteInfo, setSyncNeeded, setAllSiteSchedules, setActiveTab, vmsVariables, setSiteDeployed, setDeativateInquiryDialogOpen, setSiteCameras, camerasNotDeployed, setCamerasNotDeployed, navigate, setVmsVariables, setClickedTab, setArmButtonDisabled, setArmedStatus);
    };
    let deployNextFail = false;
    let getSiteInfoFail = false;
    let getSiteScheduleFail = false;
    let getSiteCamerasFail = false;
    let getNVRCamerasFail = false;
    localStorage.setItem("noAutoAddCamerasDialogOpen", "true");
    await AxiosUI.post(`customer/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}/action/deploy_next/`).then(()=>{
        deployNextFail = false;
        if (camerasNotDeployed) setCamerasNotDeployed(false);
        // Free the page while the queued deploy runs; the Sync Site button
        // shows the pending state until settings_deployed confirms.
        setBackdropLoadingScreenOn(false);
        setSyncPending(true);
    }, (reason)=>{
        deployNextFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
            setSyncNeeded(true);
            setSiteDeployed(false);
            alert(`Error Syncing site, please try again.`);
        });
    });
    if (!deployNextFail) {
        const { deployed: deployed } = await (0, $gOe74.waitForSettingsDeployed)(AxiosUI, (0, $h5bv8.getNumbersAfterAboutSite)(location.href));
        setSyncPending(false);
        if (!deployed) {
            setSyncNeeded(true);
            setSiteDeployed(false);
            alert("The sync was accepted but the site still reports undeployed settings. It may finish shortly \u2014 refresh the page to check, or click Sync Site to retry.");
            return;
        }
        setSyncNeeded(false);
        setSyncSiteNeeded(false);
        setSiteDeployed(true);
        (0, $815yO.markSiteSynced)();
    }
    !deployNextFail && await AxiosUI.get(`customer/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}/about/`).then((response)=>{
        getSiteInfoFail = false;
        localStorage.setItem("siteInfo", JSON.stringify(response.data));
        localStorage.setItem("integrationType", response.data.integration_type);
        setSiteInfo(response.data);
        (0, $F8wri.checkArmedStatus)(response.data, setArmButtonDisabled, navigate, setSiteInfo, setArmedStatus);
        setClickedTab("one");
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
            children: " Loading..."
        }));
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $1Ah5f.GeneralInfoTab), {
            siteInfo: response.data,
            setSiteInfo: setSiteInfo,
            setActiveTab: setActiveTab,
            vmsVariables: vmsVariables
        }));
        if (response.data.auto_add) localStorage.setItem("autoAdd", "true");
        else localStorage.setItem("autoAdd", "false");
        // The settings are now synced to the cloud but the running connector
        // hasn't picked them up yet. On armed sites that are MEANT to be armed
        // (schedule or manual arm), offer to reboot now to apply; otherwise
        // the changes apply on the next scheduled arm. Reboot = arm, and
        // `armed` lags a stop, so gate on intent too (ENG-811 / SUP-311).
        if ((0, $c4ZfI.shouldOfferRebootToApply)(response.data)) {
            if (setRebootDialogOpen) setRebootDialogOpen(true);
            else // Caller can't open the dialog from here — arm the one-shot flag
            // so the About page offers the reboot on the next landing instead
            // of silently leaving the connector on stale settings.
            localStorage.setItem("rebootSite", "true");
        }
    }, (reason)=>{
        getSiteInfoFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
        });
    });
    !deployNextFail && !getSiteInfoFail && await AxiosUI.get(`schedule/by_customer/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}/`).then((response)=>{
        getSiteScheduleFail = false;
        localStorage.setItem("siteSchedule", JSON.stringify(response.data));
        localStorage.setItem("siteId", localStorage.siteId);
        setAllSiteSchedules(response.data);
        setAlertState((previousState)=>{
            return {
                ...previousState,
                changeSuccess: false,
                activateSuccess: false,
                deactivateSuccess: false,
                disarmSuccess: false,
                armSuccess: false,
                syncSuccess: true,
                cameraDeleteSuccess: false,
                armFail: false
            };
        });
    }, (reason)=>{
        getSiteScheduleFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
        });
    });
    !deployNextFail && !getSiteInfoFail && !getSiteScheduleFail && await AxiosUI.get(`camera/site/?customer__id=${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}`).then((response)=>{
        getSiteCamerasFail = false;
        localStorage.setItem("siteCameras", JSON.stringify(response.data));
        setSiteCameras(response.data);
    // checkIfAllCamerasDecativated(
    //   response.data,
    //   setDeativateInquiryDialogOpen
    // );
    }, (reason)=>{
        getSiteCamerasFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
        });
    });
    !deployNextFail && !getSiteInfoFail && !getSiteScheduleFail && !getSiteCamerasFail && await AxiosUI.get(`nvr_camera/?customer__id=${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}`).then((response)=>{
        if (response.data.count === 0) localStorage.setItem("noAutoAddCamerasDialogOpen", "true");
        if (response.data.count > 0) localStorage.setItem("noAutoAddCamerasDialogOpen", "false");
        getNVRCamerasFail = false;
    }, (reason)=>{
        getNVRCamerasFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
    });
    !deployNextFail && !getSiteInfoFail && !getSiteScheduleFail && !getSiteCamerasFail && !getNVRCamerasFail && await AxiosUI.get(`nvr_camera/extra_fields/?customer__id=${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}`).then((response)=>{
        // setBackdropLoadingScreenOn(false);
        localStorage.setItem("additionalFieldNamesArray", JSON.stringify(response.data));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
        });
    });
};

});
parcelRegister("gOe74", function(module, exports) {

$parcel$export(module.exports, "waitForSettingsDeployed", () => $fc2e7512c3d369c3$export$6567fa0c736ac16c);
/**
 * Polls the site's /about/ endpoint until the backend reports
 * settings_deployed, or the attempt budget runs out.
 *
 * deploy_next returns 200 when the sync task is *queued* (django-q), not when
 * the deploy has happened — settings_deployed only flips once the worker has
 * generated and uploaded the settings (typically ~15s). Callers should treat
 * `deployed: false` as "not confirmed", not as a hard failure: the deploy may
 * still land after the budget.
 */ const $fc2e7512c3d369c3$export$6567fa0c736ac16c = async (AxiosUI, siteId, maxAttempts = 18, intervalMs = 5000)=>{
    for(let attempt = 0; attempt < maxAttempts; attempt++){
        if (attempt > 0) await new Promise((resolve)=>setTimeout(resolve, intervalMs));
        try {
            const response = await AxiosUI.get(`customer/${siteId}/about/`);
            if (response.data?.settings_deployed) return {
                deployed: true,
                siteInfo: response.data
            };
        } catch  {
        // Transient poll failure — keep polling; terminal errors surface via the
        // caller's own requests afterwards.
        }
    }
    return {
        deployed: false
    };
};

});

parcelRegister("c4ZfI", function(module, exports) {

$parcel$export(module.exports, "shouldOfferRebootToApply", () => $7a98bd98e5c91e20$export$d85d3515edaeb1cb);
/**
 * Single gate for the post-sync "reboot now to apply?" prompt (used by the
 * About-page landing effect, the About-page Sync handler, and the edit-view
 * sync flow, so they can't drift).
 *
 * A "reboot" on this prompt is `customer/{id}/action/arm` — it ARMS the site.
 * That is only the right offer when the site is armed AND it is *meant* to be
 * armed right now. After a schedule save disarms a site, `armed` still reads
 * true for up to a poller cycle (it derives from lagging motion status), so
 * gating on `armed` alone offered a "reboot" on a site the operator's own
 * schedule had just turned off — and clicking Yes armed it outside its
 * schedule as a manual_start the reconciler correctly leaves alone
 * (SUP-311 / ENG-811: 43 such re-arms across 39 sites in 14 days).
 *
 * `arm_intended` is admin's intent flag: schedule in-window OR an active
 * manual arm. The manual-arm half matters — a site the operator deliberately
 * armed off-schedule and then edited settings on must still be offered the
 * reboot, or it silently runs stale settings until a boundary hours away.
 * When the field is absent (older admin), fall back to `armed` — the
 * pre-existing behavior — rather than suppressing the prompt everywhere.
 */ const $7a98bd98e5c91e20$export$d85d3515edaeb1cb = (site)=>{
    if (!site?.armed) return false;
    if (typeof site.arm_intended === "boolean") return site.arm_intended;
    return true;
};

});


parcelRegister("8d0Hr", function(module, exports) {

$parcel$export(module.exports, "timeSinceLastSync", () => $8ca251248dda4eca$export$da3e64b86e8021e5);
/**
 * Calculates and formats the time elapsed since a given timestamp
 * @param timestamp Unix timestamp in seconds
 * @returns Formatted string representing elapsed time
 */ const $8ca251248dda4eca$export$da3e64b86e8021e5 = (timestamp)=>{
    if (!timestamp) return "--";
    // Convert timestamp to milliseconds and calculate difference
    const now = Math.floor(Date.now() / 1000);
    const diffInSeconds = now - timestamp;
    // Less than a minute
    if (diffInSeconds < 60) return "just now";
    // Minutes (less than an hour)
    if (diffInSeconds < 3600) {
        const minutes = Math.floor(diffInSeconds / 60);
        return `${minutes} ${minutes === 1 ? "minute" : "minutes"} ago`;
    }
    // Hours (less than a day)
    if (diffInSeconds < 86400) {
        const hours = Math.floor(diffInSeconds / 3600);
        return `${hours} ${hours === 1 ? "hour" : "hours"} ago`;
    }
    // Days (less than a month - approximated as 30 days)
    if (diffInSeconds < 2592000) {
        const days = Math.floor(diffInSeconds / 86400);
        return `${days} ${days === 1 ? "day" : "days"} ago`;
    }
    // Months (less than a year)
    if (diffInSeconds < 31536000) {
        const months = Math.floor(diffInSeconds / 2592000);
        return `${months} ${months === 1 ? "month" : "months"} ago`;
    }
    // Years
    const years = Math.floor(diffInSeconds / 31536000);
    return `${years} ${years === 1 ? "year" : "years"} ago`;
};

});


parcelRegister("6wUjC", function(module, exports) {

$parcel$export(module.exports, "createLinksArray", () => $c22baf746a44223a$export$1582d21c5682f821);
const $c22baf746a44223a$export$1582d21c5682f821 = (pushedArray)=>{
    if (pushedArray === undefined) return;
    const linksArray = [
        {
            name: "Sites"
        }
    ];
    if (pushedArray[0]) pushedArray.forEach((object)=>{
        linksArray.push({
            name: object.name
        });
    });
    return linksArray;
};

});

parcelRegister("7FIuT", function(module, exports) {

$parcel$export(module.exports, "SiteAboutDialogs", () => $0e4fb63b7febe2b8$export$3e734e50e8197c4e);

var $k4ank = parcelRequire("k4ank");

var $lN6I5 = parcelRequire("lN6I5");

var $1CTVz = parcelRequire("1CTVz");

var $i7Bke = parcelRequire("i7Bke");

var $8Ihou = parcelRequire("8Ihou");

var $8t4Ug = parcelRequire("8t4Ug");

var $8wn4O = parcelRequire("8wn4O");

var $gjjrR = parcelRequire("gjjrR");

var $a6GfA = parcelRequire("a6GfA");

var $c1bMf = parcelRequire("c1bMf");

var $fZhbM = parcelRequire("fZhbM");

var $4ewTz = parcelRequire("4ewTz");

var $hYdU9 = parcelRequire("hYdU9");

var $9HSmY = parcelRequire("9HSmY");

var $krt5P = parcelRequire("krt5P");

var $3FJ79 = parcelRequire("3FJ79");

var $2JO2V = parcelRequire("2JO2V");
const $0e4fb63b7febe2b8$export$3e734e50e8197c4e = ({ setDeleteScheduleDialogOpen: setDeleteScheduleDialogOpen, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setAllSiteSchedules: setAllSiteSchedules, setSiteInfo: setSiteInfo, setActiveTab: setActiveTab, siteInfo: siteInfo, setScheduleChangesMade: setScheduleChangesMade, rebootDialogOpen: rebootDialogOpen, setRebootDialogOpen: setRebootDialogOpen, setAlertState: setAlertState, activateSiteDialogOpen: activateSiteDialogOpen, setActivateSiteDialogOpen: setActivateSiteDialogOpen, setPatchObject: setPatchObject, patchObject: patchObject, deactivateSiteDialogOpen: deactivateSiteDialogOpen, setDeactivateSiteDialogOpen: setDeactivateSiteDialogOpen, deativateInquiryDialogOpen: deativateInquiryDialogOpen, setDeativateInquiryDialogOpen: setDeativateInquiryDialogOpen, disarmDialogOpen: disarmDialogOpen, setDisarmDialogOpen: setDisarmDialogOpen, armDialogOpen: armDialogOpen, setArmDialogOpen: setArmDialogOpen, deleteSiteDialogOpen: deleteSiteDialogOpen, setDeleteSiteDialogOpen: setDeleteSiteDialogOpen, navigate: navigate, setSyncNeeded: setSyncNeeded, noAutoAddCamerasDialogOpen: noAutoAddCamerasDialogOpen, setNoAutoAddCamerasDialogOpen: setNoAutoAddCamerasDialogOpen, setArmedStatus: setArmedStatus, setArmButtonDisabled: setArmButtonDisabled, setEditMode: setEditMode, clickedTab: clickedTab, vmsVariables: vmsVariables, siteSchedules: siteSchedules, setSiteSchedules: setSiteSchedules, addCameraHealthDialogOpen: addCameraHealthDialogOpen, setAddCameraHealthDialogOpen: setAddCameraHealthDialogOpen, healthCheckData: healthCheckData, setCameraHealthPatchObject: setCameraHealthPatchObject, setCameraHealthChangesMade: setCameraHealthChangesMade, setHealthCheckData: setHealthCheckData, turnOffHealthDialogOpen: turnOffHealthDialogOpen, setTurnOffHealthDialogOpen: setTurnOffHealthDialogOpen, permissions: permissions, activateSiteWithScheduleDialogOpen: activateSiteWithScheduleDialogOpen, setActivateSiteWithScheduleDialogOpen: setActivateSiteWithScheduleDialogOpen, armSiteFlexScheduleDialogOpen: armSiteFlexScheduleDialogOpen, setArmSiteFlexScheduleDialogOpen: setArmSiteFlexScheduleDialogOpen, armSiteFlexScheduleDialogAction: armSiteFlexScheduleDialogAction, setArmSiteFlexScheduleDialogAction: setArmSiteFlexScheduleDialogAction, disarmSiteFlexScheduleDialogOpen: disarmSiteFlexScheduleDialogOpen, setDisarmSiteFlexScheduleDialogOpen: setDisarmSiteFlexScheduleDialogOpen, setToolTipTitle: setToolTipTitle })=>{
    const { deactivateSiteInsteadDialogOpen: deactivateSiteInsteadDialogOpen, editTimeScheduleDialogOpen: editTimeScheduleDialogOpen } = (0, $3FJ79.useSiteAboutStore)();
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            armSiteFlexScheduleDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $9HSmY.ArmSiteFlexScheduleDialog), {
                armSiteFlexScheduleDialogOpen: armSiteFlexScheduleDialogOpen,
                setArmSiteFlexScheduleDialogOpen: setArmSiteFlexScheduleDialogOpen,
                endpointAction: armSiteFlexScheduleDialogAction,
                siteTimezone: siteInfo?.timezone,
                setSiteInfo: setSiteInfo,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setAlertState: setAlertState,
                setSyncNeeded: setSyncNeeded,
                setArmedStatus: setArmedStatus,
                setArmButtonDisabled: setArmButtonDisabled,
                // siteSchedules={siteSchedules}
                setToolTipTitle: setToolTipTitle
            }),
            disarmSiteFlexScheduleDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $krt5P.DisarmSiteFlexScheduleDialog), {
                disarmSiteFlexScheduleDialogOpen: disarmSiteFlexScheduleDialogOpen,
                setDisarmSiteFlexScheduleDialogOpen: setDisarmSiteFlexScheduleDialogOpen,
                setSiteInfo: setSiteInfo,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setAlertState: setAlertState,
                setSyncNeeded: setSyncNeeded,
                setArmedStatus: setArmedStatus,
                setArmButtonDisabled: setArmButtonDisabled,
                setToolTipTitle: setToolTipTitle
            }),
            rebootDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $lN6I5.RebootDialog), {
                rebootDialogOpen: rebootDialogOpen,
                setRebootDialogOpen: setRebootDialogOpen,
                setSiteInfo: setSiteInfo,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setAlertState: setAlertState,
                setSyncNeeded: setSyncNeeded,
                setArmedStatus: setArmedStatus,
                setArmButtonDisabled: setArmButtonDisabled,
                hasFlexSchedule: Boolean(siteInfo.has_flex_schedule),
                setArmSiteFlexScheduleDialogOpen: setArmSiteFlexScheduleDialogOpen,
                setArmSiteFlexScheduleDialogAction: setArmSiteFlexScheduleDialogAction
            }),
            activateSiteDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $1CTVz.ActivateSiteDialog), {
                activateSiteDialogOpen: activateSiteDialogOpen,
                setActivateSiteDialogOpen: setActivateSiteDialogOpen,
                setSiteInfo: setSiteInfo,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setAlertState: setAlertState,
                setPatchObject: setPatchObject,
                patchObject: patchObject,
                setSiteSchedules: setSiteSchedules,
                setAllSiteSchedules: setAllSiteSchedules,
                clickedTab: clickedTab,
                setActiveTab: setActiveTab,
                setDeleteScheduleDialogOpen: setDeleteScheduleDialogOpen,
                siteInfo: siteInfo
            }),
            deactivateSiteDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $i7Bke.DeactivateSiteDialog), {
                deactivateSiteDialogOpen: deactivateSiteDialogOpen,
                setDeactivateSiteDialogOpen: setDeactivateSiteDialogOpen,
                setSiteInfo: setSiteInfo,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setAlertState: setAlertState,
                setPatchObject: setPatchObject,
                patchObject: patchObject,
                siteInfo: siteInfo,
                setArmButtonDisabled: setArmButtonDisabled,
                setArmedStatus: setArmedStatus,
                setSiteSchedules: setSiteSchedules,
                setAllSiteSchedules: setAllSiteSchedules,
                clickedTab: clickedTab,
                setActiveTab: setActiveTab,
                setDeleteScheduleDialogOpen: setDeleteScheduleDialogOpen
            }),
            deativateInquiryDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8Ihou.DeactivateInquiryDialog), {
                deativateInquiryDialogOpen: deativateInquiryDialogOpen,
                setDeativateInquiryDialogOpen: setDeativateInquiryDialogOpen,
                setSiteInfo: setSiteInfo,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setAlertState: setAlertState,
                setPatchObject: setPatchObject,
                patchObject: patchObject,
                setArmButtonDisabled: setArmButtonDisabled,
                setArmedStatus: setArmedStatus,
                setSiteSchedules: setSiteSchedules,
                setAllSiteSchedules: setAllSiteSchedules,
                clickedTab: clickedTab,
                setActiveTab: setActiveTab,
                setDeleteScheduleDialogOpen: setDeleteScheduleDialogOpen,
                siteInfo: siteInfo
            }),
            disarmDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8t4Ug.DisarmSiteDialog), {
                disarmDialogOpen: disarmDialogOpen,
                setDisarmDialogOpen: setDisarmDialogOpen,
                setSiteInfo: setSiteInfo,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setAlertState: setAlertState,
                setArmedStatus: setArmedStatus,
                setArmButtonDisabled: setArmButtonDisabled
            }),
            armDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8wn4O.ArmSiteDialog), {
                armDialogOpen: armDialogOpen,
                setArmDialogOpen: setArmDialogOpen,
                setSiteInfo: setSiteInfo,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setAlertState: setAlertState,
                setSyncNeeded: setSyncNeeded,
                setArmedStatus: setArmedStatus,
                setArmButtonDisabled: setArmButtonDisabled
            }),
            deleteSiteDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $gjjrR.DeleteSiteCheckDialog), {
                deleteSiteDialogOpen: deleteSiteDialogOpen,
                setDeleteSiteDialogOpen: setDeleteSiteDialogOpen,
                navigate: navigate,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setSyncNeeded: setSyncNeeded
            }),
            noAutoAddCamerasDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $a6GfA.NoAutoAddCamerasDialog), {
                noAutoAddCamerasDialogOpen: noAutoAddCamerasDialogOpen,
                setNoAutoAddCamerasDialogOpen: setNoAutoAddCamerasDialogOpen
            }),
            addCameraHealthDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $c1bMf.default), {
                addCameraHealthDialogOpen: addCameraHealthDialogOpen,
                setAddCameraHealthDialogOpen: setAddCameraHealthDialogOpen,
                setSiteInfo: setSiteInfo,
                setActiveTab: setActiveTab,
                healthCheckData: healthCheckData,
                setCameraHealthPatchObject: setCameraHealthPatchObject,
                setCameraHealthChangesMade: setCameraHealthChangesMade,
                siteInfo: siteInfo,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setHealthCheckData: setHealthCheckData,
                setEditMode: setEditMode,
                setTurnOffHealthDialogOpen: setTurnOffHealthDialogOpen,
                permissions: permissions,
                navigate: navigate
            }),
            turnOffHealthDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $fZhbM.TurnOffCameraHealthDialog), {
                turnOffHealthDialogOpen: turnOffHealthDialogOpen,
                healthCheckData: healthCheckData,
                cameraHealthPatchObject: healthCheckData,
                setCameraHealthPatchObject: setCameraHealthPatchObject,
                setCameraHealthChangesMade: setCameraHealthChangesMade,
                setActiveTab: setActiveTab,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                siteInfo: siteInfo,
                setAddCameraHealthDialogOpen: setAddCameraHealthDialogOpen,
                setSiteInfo: setSiteInfo,
                setTurnOffHealthDialogOpen: setTurnOffHealthDialogOpen,
                setEditMode: setEditMode,
                setHealthCheckData: setHealthCheckData,
                navigate: navigate
            }),
            deactivateSiteInsteadDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $4ewTz.DeactivateSiteInsteadDialog), {
                setSiteInfo: setSiteInfo,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setAlertState: setAlertState,
                setPatchObject: setPatchObject,
                patchObject: patchObject,
                setArmButtonDisabled: setArmButtonDisabled,
                setArmedStatus: setArmedStatus,
                siteInfo: siteInfo,
                setScheduleChangesMade: setScheduleChangesMade,
                setSiteSchedules: setSiteSchedules,
                setAllSiteSchedules: setAllSiteSchedules,
                setEditMode: setEditMode,
                clickedTab: clickedTab,
                setActiveTab: setActiveTab,
                vmsVariables: vmsVariables,
                setDeleteScheduleDialogOpen: setDeleteScheduleDialogOpen,
                siteSchedules: siteSchedules
            }),
            activateSiteWithScheduleDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $hYdU9.ActivateSiteWithScheduleDialog), {
                activateSiteWithScheduleDialogOpen: activateSiteWithScheduleDialogOpen,
                setActivateSiteWithScheduleDialogOpen: setActivateSiteWithScheduleDialogOpen,
                setSiteInfo: setSiteInfo,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setAlertState: setAlertState,
                setPatchObject: setPatchObject,
                patchObject: patchObject,
                setSiteSchedules: setSiteSchedules,
                setAllSiteSchedules: setAllSiteSchedules,
                clickedTab: clickedTab,
                setActiveTab: setActiveTab,
                setDeleteScheduleDialogOpen: setDeleteScheduleDialogOpen,
                siteInfo: siteInfo
            }),
            editTimeScheduleDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2JO2V.EditScheduleTimesDialog), {
                setActiveTab: setActiveTab,
                setEditMode: setEditMode
            })
        ]
    });
};

});
parcelRegister("lN6I5", function(module, exports) {

$parcel$export(module.exports, "RebootDialog", () => $793f2b5eb8e85140$export$ec9153bda0dac78c);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $iLEpm = parcelRequire("iLEpm");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");

var $919dZ = parcelRequire("919dZ");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $793f2b5eb8e85140$export$ec9153bda0dac78c = ({ rebootDialogOpen: rebootDialogOpen, setRebootDialogOpen: setRebootDialogOpen, setSiteInfo: setSiteInfo, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setAlertState: setAlertState, setSyncNeeded: setSyncNeeded, setArmedStatus: setArmedStatus, setArmButtonDisabled: setArmButtonDisabled, hasFlexSchedule: hasFlexSchedule, setArmSiteFlexScheduleDialogOpen: setArmSiteFlexScheduleDialogOpen, setArmSiteFlexScheduleDialogAction: setArmSiteFlexScheduleDialogAction })=>{
    const navigate = (0, $3T949.useNavigate)();
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: rebootDialogOpen,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: "Reboot Site?"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                    id: "alert-dialog-description",
                    children: "Camera changes have been saved, and will deploy on next site arm. Would you like to reboot the site now and immediately deploy changes?"
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            // Declining a reboot must not change the arming state — the site
                            // stays armed and keeps running its previous settings until the
                            // next scheduled arm. (Previously this optimistically set
                            // armed:false, which misreported an armed site as disarmed.)
                            setRebootDialogOpen(false);
                            localStorage.setItem("rebootSite", "false");
                        },
                        text: "No",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            localStorage.setItem("rebootSite", "false");
                            if (hasFlexSchedule) {
                                // Flex-schedule sites can't be armed site-wide: the backend
                                // rejects customer/{id}/action/arm for them (silently — the
                                // Max Security incident, ENG-389). Hand off to the flex
                                // schedule picker, whose arm is a manual reboot of the
                                // selected schedules — flagged as the reboot flavor so the
                                // action log reads "Manual Reboot" (ENG-1404).
                                setRebootDialogOpen(false);
                                setArmSiteFlexScheduleDialogAction("reboot");
                                setArmSiteFlexScheduleDialogOpen(true);
                                return;
                            }
                            (0, $919dZ.handleArmSite)(setBackdropLoadingScreenOn, setSiteInfo, setAlertState, setSyncNeeded, setArmedStatus, navigate, setArmButtonDisabled, // Logged as "Manual Reboot", not "Manual Arm" (ENG-1380)
                            "reboot");
                            setSiteInfo((previousState)=>{
                                return {
                                    ...previousState,
                                    armed: true
                                };
                            });
                            setRebootDialogOpen(false);
                        },
                        text: "Reboot",
                        disabled: false
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("919dZ", function(module, exports) {

$parcel$export(module.exports, "handleArmSite", () => $bc881e585005b347$export$62d8c25962de1fed);

var $195EM = parcelRequire("195EM");

var $F8wri = parcelRequire("F8wri");

var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("elyck");
var $h5bv8 = parcelRequire("h5bv8");

var $ebTQj = parcelRequire("ebTQj");

var $hN0t7 = parcelRequire("hN0t7");
const $bc881e585005b347$export$62d8c25962de1fed = async (setBackdropLoadingScreenOn, setSiteInfo, setAlertState, setSyncNeeded, setArmedStatus, navigate, setArmButtonDisabled, // "arm" for the Arm button; "reboot" for the restart-to-apply-settings
// flows. Both dispatch identically backend-side, but reboot logs a
// "Manual Reboot" action instead of a "Manual Arm" the operator never
// performed (ENG-1380 / SUP-433).
endpointAction = "arm")=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    setBackdropLoadingScreenOn(true);
    const retryFunction = ()=>{
        $bc881e585005b347$export$62d8c25962de1fed(setBackdropLoadingScreenOn, setSiteInfo, setAlertState, setSyncNeeded, setArmedStatus, navigate, setArmButtonDisabled, endpointAction);
    };
    let siteArmFail = false;
    await AxiosUI.post(`customer/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}/action/${endpointAction}/`).then(()=>{
        siteArmFail = false;
        // The connector restarts: refresh every camera's status (ENG-2853).
        (0, $hN0t7.requestCameraStatusRefresh)();
    }, (reason)=>{
        siteArmFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
            setSiteInfo((previousState)=>{
                return {
                    ...previousState,
                    armed: false
                };
            });
        });
    });
    !siteArmFail && await AxiosUI.get(`customer/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}/about/`).then((response)=>{
        (0, $F8wri.checkArmedStatus)(response.data, setArmButtonDisabled, navigate, setSiteInfo, setArmedStatus);
        setSiteInfo(response.data);
        if (response.data.settings_deployed !== true) setSyncNeeded(true);
        if (response.data.armed_status === "ARMING" || response.data.armed_status === "ARMED_OUTSIDE_SCHEDULE") setAlertState((previousState)=>{
            return {
                ...previousState,
                changeSuccess: false,
                activateSuccess: false,
                deactivateSuccess: false,
                disarmSuccess: false,
                armSuccess: true,
                syncSuccess: false,
                cameraDeleteSuccess: false,
                armFail: false
            };
        });
        setArmedStatus(true);
        setBackdropLoadingScreenOn(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setAlertState((previousState)=>{
                return {
                    ...previousState,
                    changeSuccess: false,
                    activateSuccess: false,
                    deactivateSuccess: false,
                    disarmSuccess: false,
                    armSuccess: false,
                    syncSuccess: false,
                    cameraDeleteSuccess: false,
                    armFail: true
                };
            });
            setBackdropLoadingScreenOn(false);
            (0, $ebTQj.logger).log(JSON.stringify(reason.message));
        });
    });
};

});


parcelRegister("1CTVz", function(module, exports) {

$parcel$export(module.exports, "ActivateSiteDialog", () => $a4307254ac35ef7d$export$397abc50e4acccfc);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");

var $iPk2h = parcelRequire("iPk2h");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $a4307254ac35ef7d$export$397abc50e4acccfc = ({ activateSiteDialogOpen: activateSiteDialogOpen, setActivateSiteDialogOpen: setActivateSiteDialogOpen, setSiteInfo: setSiteInfo, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setAlertState: setAlertState, setPatchObject: setPatchObject, patchObject: patchObject, setSiteSchedules: setSiteSchedules, setAllSiteSchedules: setAllSiteSchedules, clickedTab: clickedTab, setActiveTab: setActiveTab, setDeleteScheduleDialogOpen: setDeleteScheduleDialogOpen, siteInfo: siteInfo })=>{
    const navigate = (0, $3T949.useNavigate)();
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: activateSiteDialogOpen,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: " Are you sure you want to activate this site?"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setSiteInfo((previousState)=>{
                                return {
                                    ...previousState,
                                    active: false
                                };
                            });
                            setActivateSiteDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setActivateSiteDialogOpen(false);
                            setPatchObject((previousState)=>{
                                return {
                                    ...previousState,
                                    active: true
                                };
                            });
                            setSiteInfo((previousState)=>{
                                return {
                                    ...previousState,
                                    active: true
                                };
                            });
                            (0, $iPk2h.handleActivateSite)(setBackdropLoadingScreenOn, patchObject, setSiteInfo, setAlertState, setPatchObject, siteInfo, setSiteSchedules, setAllSiteSchedules, clickedTab, setActiveTab, setDeleteScheduleDialogOpen, navigate);
                        },
                        text: "Activate",
                        disabled: false
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("iPk2h", function(module, exports) {

$parcel$export(module.exports, "handleActivateSite", () => $ade03f52c35305d5$export$b42c8b8c314b55c6);

var $k4ank = parcelRequire("k4ank");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");

var $2uQ4j = parcelRequire("2uQ4j");

var $k1C5l = parcelRequire("k1C5l");
const $ade03f52c35305d5$export$b42c8b8c314b55c6 = async (setBackdropLoadingScreenOn, patchObject, setSiteInfo, setAlertState, setPatchObject, siteInfo, setSiteSchedules, setAllSiteSchedules, clickedTab, setActiveTab, setDeleteScheduleDialogOpen, navigate)=>{
    setBackdropLoadingScreenOn(true);
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $ade03f52c35305d5$export$b42c8b8c314b55c6(setBackdropLoadingScreenOn, patchObject, setSiteInfo, setAlertState, setPatchObject, siteInfo, setSiteSchedules, setAllSiteSchedules, clickedTab, setActiveTab, setDeleteScheduleDialogOpen, navigate);
    };
    await AxiosUI.patch(`customer/${siteInfo.id}/about/`, {
        active: true
    }).then(()=>{
        AxiosUI.get(`schedule/by_customer/${siteInfo.id}/`).then((response)=>{
            const temporaryUpdatedScheduleData = (0, $k1C5l.temporaryUpdateScheduleData)(response.data);
            localStorage.setItem("siteSchedule", JSON.stringify(temporaryUpdatedScheduleData));
            setSiteSchedules(temporaryUpdatedScheduleData);
            localStorage.setItem("allSiteSchedulesBackup", JSON.stringify(temporaryUpdatedScheduleData));
            if (clickedTab === "three") {
                setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
                setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $2uQ4j.SchedulesTab), {
                    siteInfo: siteInfo
                }));
            }
            setPatchObject({
                name: siteInfo.name
            });
            setBackdropLoadingScreenOn(false);
            const siteCamerasCount = JSON.parse(localStorage.siteCameras)?.count || 0;
            if (siteCamerasCount === 0 && !response.data[0] && siteInfo.chm && siteInfo.display_schedule) setAlertState((previousState)=>{
                return {
                    ...previousState,
                    noCameraOrSchedule: true
                };
            });
            else if (siteInfo.chm && siteInfo.display_schedule && siteCamerasCount > 0) setAlertState((previousState)=>{
                return {
                    ...previousState,
                    noSchedule: true
                };
            });
            setAlertState((previousState)=>{
                return {
                    ...previousState,
                    changeSuccess: false,
                    activateSuccess: true,
                    deactivateSuccess: false,
                    disarmSuccess: false,
                    armSuccess: false,
                    syncSuccess: false,
                    cameraDeleteSuccess: false,
                    armFail: false
                };
            });
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                setPatchObject({
                    name: siteInfo.name
                });
                setBackdropLoadingScreenOn(false);
                setAlertState((previousState)=>{
                    return {
                        ...previousState,
                        changeSuccess: false,
                        activateSuccess: true,
                        deactivateSuccess: false,
                        disarmSuccess: false,
                        armSuccess: false,
                        syncSuccess: false,
                        cameraDeleteSuccess: false,
                        armFail: false,
                        noCameraOrSchedule: false,
                        noSchedule: false
                    };
                });
            });
        });
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Error activating site, please try again");
            setSiteInfo(JSON.parse(localStorage.siteInfo));
            setBackdropLoadingScreenOn(false);
            setPatchObject({
                name: siteInfo.name
            });
        });
    });
};

});


parcelRegister("i7Bke", function(module, exports) {

$parcel$export(module.exports, "DeactivateSiteDialog", () => $5dbd866339b5d2f8$export$a96f29a74d383dd0);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");

var $9j9r6 = parcelRequire("9j9r6");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $5dbd866339b5d2f8$export$a96f29a74d383dd0 = ({ deactivateSiteDialogOpen: deactivateSiteDialogOpen, setDeactivateSiteDialogOpen: setDeactivateSiteDialogOpen, setSiteInfo: setSiteInfo, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setAlertState: setAlertState, setPatchObject: setPatchObject, patchObject: patchObject, siteInfo: siteInfo, setArmButtonDisabled: setArmButtonDisabled, setArmedStatus: setArmedStatus, setSiteSchedules: setSiteSchedules, setAllSiteSchedules: setAllSiteSchedules, clickedTab: clickedTab, setActiveTab: setActiveTab, setDeleteScheduleDialogOpen: setDeleteScheduleDialogOpen })=>{
    const navigate = (0, $3T949.useNavigate)();
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: deactivateSiteDialogOpen,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: " Are you sure you want to deactivate this site?"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setSiteInfo((previousState)=>{
                                return {
                                    ...previousState,
                                    active: true
                                };
                            });
                            setDeactivateSiteDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setDeactivateSiteDialogOpen(false);
                            setPatchObject((previousState)=>{
                                return {
                                    ...previousState,
                                    active: false
                                };
                            });
                            setSiteInfo((previousState)=>{
                                return {
                                    ...previousState,
                                    active: false
                                };
                            });
                            (0, $9j9r6.handleDeactivateSite)(setBackdropLoadingScreenOn, patchObject, setSiteInfo, setAlertState, setPatchObject, siteInfo, setArmButtonDisabled, setArmedStatus, setSiteSchedules, setAllSiteSchedules, clickedTab, setActiveTab, setDeleteScheduleDialogOpen, navigate);
                        },
                        text: "Deactivate",
                        disabled: false
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("9j9r6", function(module, exports) {

$parcel$export(module.exports, "handleDeactivateSite", () => $8dd1369a2b9c1693$export$374367fa3b90cee6);

var $k4ank = parcelRequire("k4ank");

var $195EM = parcelRequire("195EM");

var $F8wri = parcelRequire("F8wri");

var $3Zv1D = parcelRequire("3Zv1D");

var $2uQ4j = parcelRequire("2uQ4j");

var $k1C5l = parcelRequire("k1C5l");
const $8dd1369a2b9c1693$export$374367fa3b90cee6 = async (setBackdropLoadingScreenOn, patchObject, setSiteInfo, setAlertState, setPatchObject, siteInfo, setArmButtonDisabled, setArmedStatus, setSiteSchedules, setAllSiteSchedules, clickedTab, setActiveTab, setDeleteScheduleDialogOpen, navigate)=>{
    setBackdropLoadingScreenOn(true);
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $8dd1369a2b9c1693$export$374367fa3b90cee6(setBackdropLoadingScreenOn, patchObject, setSiteInfo, setAlertState, setPatchObject, siteInfo, setArmButtonDisabled, setArmedStatus, setSiteSchedules, setAllSiteSchedules, clickedTab, setActiveTab, setDeleteScheduleDialogOpen, navigate);
    };
    await AxiosUI.patch(`customer/${siteInfo.id}/about/`, {
        active: false
    }).then((response)=>{
        setPatchObject({
            name: siteInfo.name
        });
        (0, $F8wri.checkArmedStatus)(response.data, setArmButtonDisabled, navigate, setSiteInfo, setArmedStatus);
        if (response.data.armed) setArmedStatus(true);
        if (!response.data.armed) setArmedStatus(false);
        setSiteInfo(response.data);
        AxiosUI.get(`schedule/by_customer/${siteInfo.id}/`).then((resp)=>{
            const temporaryUpdatedScheduleData = (0, $k1C5l.temporaryUpdateScheduleData)(resp.data);
            localStorage.setItem("siteSchedule", JSON.stringify(temporaryUpdatedScheduleData));
            setSiteSchedules(temporaryUpdatedScheduleData);
            localStorage.setItem("allSiteSchedulesBackup", JSON.stringify(temporaryUpdatedScheduleData));
            if (clickedTab === "three") {
                setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
                setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $2uQ4j.SchedulesTab), {
                    siteInfo: response.data
                }));
            }
            setPatchObject({
                name: siteInfo.name
            });
            setBackdropLoadingScreenOn(false);
            setAlertState((previousState)=>{
                return {
                    ...previousState,
                    changeSuccess: false,
                    activateSuccess: false,
                    deactivateSuccess: true,
                    disarmSuccess: false,
                    armSuccess: false,
                    syncSuccess: false,
                    cameraDeleteSuccess: false,
                    noCameraOrSchedule: false,
                    noSchedule: false,
                    armFail: false
                };
            });
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                setPatchObject({
                    name: siteInfo.name
                });
                setBackdropLoadingScreenOn(false);
                setAlertState((previousState)=>{
                    return {
                        ...previousState,
                        changeSuccess: false,
                        activateSuccess: true,
                        deactivateSuccess: false,
                        disarmSuccess: false,
                        armSuccess: false,
                        syncSuccess: false,
                        cameraDeleteSuccess: false,
                        armFail: false,
                        noCameraOrSchedule: false,
                        noSchedule: false
                    };
                });
            });
        });
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Error activating site, please try again");
            setSiteInfo(JSON.parse(localStorage.siteInfo));
            setBackdropLoadingScreenOn(false);
            setPatchObject({
                name: siteInfo.name
            });
        });
    });
};

});


parcelRegister("8Ihou", function(module, exports) {

$parcel$export(module.exports, "DeactivateInquiryDialog", () => $1d478fe1741ea37f$export$a379cf09e0b3d70b);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");

var $9j9r6 = parcelRequire("9j9r6");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $1d478fe1741ea37f$export$a379cf09e0b3d70b = ({ deativateInquiryDialogOpen: deativateInquiryDialogOpen, setDeativateInquiryDialogOpen: setDeativateInquiryDialogOpen, setSiteInfo: setSiteInfo, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setAlertState: setAlertState, setPatchObject: setPatchObject, patchObject: patchObject, setArmButtonDisabled: setArmButtonDisabled, setArmedStatus: setArmedStatus, setSiteSchedules: setSiteSchedules, setAllSiteSchedules: setAllSiteSchedules, clickedTab: clickedTab, setActiveTab: setActiveTab, setDeleteScheduleDialogOpen: setDeleteScheduleDialogOpen, siteInfo: siteInfo })=>{
    const navigate = (0, $3T949.useNavigate)();
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: deativateInquiryDialogOpen,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: "All Cameras are currently deactivated.  Do you want deactivate this site?"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setSiteInfo((previousState)=>{
                                return {
                                    ...previousState,
                                    active: true
                                };
                            });
                            setDeativateInquiryDialogOpen(false);
                        },
                        text: "No",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setDeativateInquiryDialogOpen(false);
                            setPatchObject((previousState)=>{
                                return {
                                    ...previousState,
                                    active: false
                                };
                            });
                            setSiteInfo((previousState)=>{
                                return {
                                    ...previousState,
                                    active: false
                                };
                            });
                            (0, $9j9r6.handleDeactivateSite)(setBackdropLoadingScreenOn, patchObject, setSiteInfo, setAlertState, setPatchObject, siteInfo, setArmButtonDisabled, setArmedStatus, setSiteSchedules, setAllSiteSchedules, clickedTab, setActiveTab, setDeleteScheduleDialogOpen, navigate);
                        },
                        text: "Deactivate",
                        disabled: false
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("8t4Ug", function(module, exports) {

$parcel$export(module.exports, "DisarmSiteDialog", () => $bffe8d9ea48d972f$export$73e1883419cf72d3);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $iLEpm = parcelRequire("iLEpm");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");

var $9v9j3 = parcelRequire("9v9j3");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $eedS6 = parcelRequire("eedS6");

var $3FJ79 = parcelRequire("3FJ79");

var $5P5Ui = parcelRequire("5P5Ui");

var $h5bv8 = parcelRequire("h5bv8");
const $bffe8d9ea48d972f$export$73e1883419cf72d3 = ({ disarmDialogOpen: disarmDialogOpen, setDisarmDialogOpen: setDisarmDialogOpen, setSiteInfo: setSiteInfo, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setAlertState: setAlertState, setArmedStatus: setArmedStatus, setArmButtonDisabled: setArmButtonDisabled })=>{
    const navigate = (0, $3T949.useNavigate)();
    // When the site will arm again on its own (ENG-2632). Until it loads, or if
    // admin can't say, the dialog keeps its old text.
    // Fleet sites' schedules live in the fleet worker, which next_arm can't
    // see, so they keep the old text (no false "won't re-arm").
    const fleetSite = (0, $5P5Ui.isFleetSite)((0, $3FJ79.useSiteAboutStore)((state)=>state.siteInfo));
    const nextArm = (0, $eedS6.useNextArm)((0, $h5bv8.getNumbersAfterAboutSite)(window.location.href), disarmDialogOpen && !fleetSite);
    const nextArmText = nextArm ? (0, $eedS6.nextArmLine)(nextArm.next_arm_at, nextArm.supported, nextArm.timezone, nextArm.horizon_days) : null;
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: disarmDialogOpen,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: " Are you sure you want to disarm this site?"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                    id: "alert-dialog-description",
                    "data-testid": "disarm-next-arm",
                    children: nextArmText ?? "Site will rearm that the next scheduled arm time."
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setSiteInfo((previousState)=>{
                                return {
                                    ...previousState,
                                    armed: true
                                };
                            });
                            setDisarmDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setDisarmDialogOpen(false);
                            (0, $9v9j3.handleDisarmSite)(setBackdropLoadingScreenOn, setSiteInfo, setAlertState, setArmedStatus, navigate, setArmButtonDisabled);
                            setSiteInfo((previousState)=>{
                                return {
                                    ...previousState,
                                    armed: false
                                };
                            });
                        },
                        text: "Disarm",
                        disabled: false
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("9v9j3", function(module, exports) {

$parcel$export(module.exports, "handleDisarmSite", () => $f9a7daf40a0361a1$export$8569c2ac0e64a9f7);

var $195EM = parcelRequire("195EM");

var $F8wri = parcelRequire("F8wri");

var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("elyck");
var $h5bv8 = parcelRequire("h5bv8");
const $f9a7daf40a0361a1$export$8569c2ac0e64a9f7 = async (setBackdropLoadingScreenOn, setSiteInfo, setAlertState, setArmedStatus, navigate, setArmButtonDisabled)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    setBackdropLoadingScreenOn(true);
    const retryFunction = ()=>{
        $f9a7daf40a0361a1$export$8569c2ac0e64a9f7(setBackdropLoadingScreenOn, setSiteInfo, setAlertState, setArmedStatus, navigate, setArmButtonDisabled);
    };
    let disarmSiteFail = false;
    await AxiosUI.post(`customer/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}/action/disarm/`).then(()=>{
        disarmSiteFail = false;
        setAlertState((previousState)=>{
            return {
                ...previousState,
                changeSuccess: false,
                activateSuccess: false,
                deactivateSuccess: false,
                disarmSuccess: true,
                armSuccess: false,
                syncSuccess: false,
                cameraDeleteSuccess: false,
                armFail: false
            };
        });
    }, (reason)=>{
        disarmSiteFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setSiteInfo((previousState)=>{
                return {
                    ...previousState,
                    armed: true
                };
            });
            setBackdropLoadingScreenOn(false);
            alert(`Error disarming site, please try again.`);
        });
    });
    !disarmSiteFail && await AxiosUI.get(`customer/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}/about/`).then((response)=>{
        setArmedStatus(false);
        setSiteInfo(response.data);
        (0, $F8wri.checkArmedStatus)(response.data, setArmButtonDisabled, navigate, setSiteInfo, setArmedStatus);
        setBackdropLoadingScreenOn(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
    });
};

});

parcelRegister("eedS6", function(module, exports) {

$parcel$export(module.exports, "nextArmLine", () => $98dfb8739c6d41ab$export$4fe2d04e4a337e84);
$parcel$export(module.exports, "useNextArm", () => $98dfb8739c6d41ab$export$aad173582770fb09);

var $8T3gX = parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $ebTQj = parcelRequire("ebTQj");
const $98dfb8739c6d41ab$export$4837573d6316e7a0 = (iso, timezone)=>{
    const date = new Date(iso);
    const options = {
        weekday: "short",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        timeZoneName: "short"
    };
    try {
        return date.toLocaleString("en-US", {
            ...options,
            timeZone: timezone || undefined
        });
    } catch  {
        return date.toLocaleString("en-US", options);
    }
};
const $98dfb8739c6d41ab$export$4fe2d04e4a337e84 = (nextArmAt, supported, timezone, horizonDays, subject = "This site")=>{
    if (supported === false) return null;
    if (nextArmAt) return $98dfb8739c6d41ab$export$964eca3f1ed0d114(nextArmAt, timezone, horizonDays, subject);
    return supported === true ? $98dfb8739c6d41ab$export$964eca3f1ed0d114(null, timezone, horizonDays, subject) : null;
};
const $98dfb8739c6d41ab$var$supportedFrom = (data)=>{
    if (data.source === "unsupported") return false;
    return typeof data.supported === "boolean" ? data.supported : null;
};
const $98dfb8739c6d41ab$export$964eca3f1ed0d114 = (nextArmAt, timezone, horizonDays, subject = "This site")=>nextArmAt ? `${subject} will next arm automatically at ${$98dfb8739c6d41ab$export$4837573d6316e7a0(nextArmAt, timezone)}.` : `${subject} won't re-arm automatically within the next ${horizonDays} days. Arm it manually when you're ready.`;
const $98dfb8739c6d41ab$export$89db8499675821be = async (siteId)=>{
    const response = await (0, $195EM.createApi)(``).get(`customer/${siteId}/next_arm/`);
    const data = response.data ?? {};
    return {
        supported: $98dfb8739c6d41ab$var$supportedFrom(data),
        next_arm_at: data.next_arm_at ?? null,
        timezone: data.timezone ?? null,
        source: data.source ?? null,
        note: data.note ?? null,
        horizon_days: Number(data.horizon_days) || 7,
        flex_schedules: Array.isArray(data.flex_schedules) ? data.flex_schedules.map((row)=>({
                ...row,
                supported: $98dfb8739c6d41ab$var$supportedFrom(row)
            })) : []
    };
};
const $98dfb8739c6d41ab$export$aad173582770fb09 = (siteId, open)=>{
    const [nextArm, setNextArm] = $8T3gX.useState(null);
    $8T3gX.useEffect(()=>{
        if (!open || !siteId) {
            setNextArm(null);
            return undefined;
        }
        let cancelled = false;
        $98dfb8739c6d41ab$export$89db8499675821be(siteId).then((data)=>{
            if (!cancelled) setNextArm(data);
        }).catch((error)=>{
            // 404 on an admin without the endpoint, 403 without access: keep the
            // dialog as it was.
            (0, $ebTQj.logger).warn("next_arm lookup failed; disarm dialog keeps its old text", error);
            if (!cancelled) setNextArm(null);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        siteId,
        open
    ]);
    return nextArm;
};

});


parcelRegister("8wn4O", function(module, exports) {

$parcel$export(module.exports, "ArmSiteDialog", () => $b951686fd59497f4$export$eb925d9b97dd2083);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $iLEpm = parcelRequire("iLEpm");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");

var $919dZ = parcelRequire("919dZ");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $b951686fd59497f4$export$eb925d9b97dd2083 = ({ armDialogOpen: armDialogOpen, setArmDialogOpen: setArmDialogOpen, setSiteInfo: setSiteInfo, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setAlertState: setAlertState, setSyncNeeded: setSyncNeeded, setArmedStatus: setArmedStatus, setArmButtonDisabled: setArmButtonDisabled })=>{
    const navigate = (0, $3T949.useNavigate)();
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: armDialogOpen,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: " Are you sure you want to arm this site?"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                    id: "alert-dialog-description",
                    children: "Site will disarm at next scheduled disarm time."
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setArmDialogOpen(false);
                            setSiteInfo((previousState)=>{
                                return {
                                    ...previousState,
                                    armed: false
                                };
                            });
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            (0, $919dZ.handleArmSite)(setBackdropLoadingScreenOn, setSiteInfo, setAlertState, setSyncNeeded, setArmedStatus, navigate, setArmButtonDisabled);
                            setSiteInfo((previousState)=>{
                                return {
                                    ...previousState,
                                    armed: true
                                };
                            });
                            setArmDialogOpen(false);
                        },
                        text: "Arm Site",
                        disabled: false
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("gjjrR", function(module, exports) {

$parcel$export(module.exports, "DeleteSiteCheckDialog", () => $71a10775c5c8986e$export$31d52af4bf64b941);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $iLEpm = parcelRequire("iLEpm");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");

var $cRcEo = parcelRequire("cRcEo");
parcelRequire("elyck");
var $h5bv8 = parcelRequire("h5bv8");
const $71a10775c5c8986e$export$31d52af4bf64b941 = ({ deleteSiteDialogOpen: deleteSiteDialogOpen, setDeleteSiteDialogOpen: setDeleteSiteDialogOpen, navigate: navigate, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setSyncNeeded: setSyncNeeded })=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: deleteSiteDialogOpen,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: " Are you sure you want to delete this site?"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                    id: "alert-dialog-description",
                    children: "Once deleted this action can't be undone."
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setDeleteSiteDialogOpen(false);
                            setSyncNeeded(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setDeleteSiteDialogOpen(false);
                            (0, $cRcEo.handleDeleteSite)(Number((0, $h5bv8.getNumbersAfterAboutSite)(location.href)), navigate, setBackdropLoadingScreenOn);
                        },
                        text: "Delete",
                        disabled: false
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("cRcEo", function(module, exports) {

$parcel$export(module.exports, "handleDeleteSite", () => $5b9d82743fe5a41c$export$fe910911b7a8c136);

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");

var $aYdit = parcelRequire("aYdit");
const $5b9d82743fe5a41c$export$fe910911b7a8c136 = async (id, navigate, setBackdropLoadingScreenOn)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    setBackdropLoadingScreenOn(true);
    const retryFunction = ()=>{
        $5b9d82743fe5a41c$export$fe910911b7a8c136(id, navigate, setBackdropLoadingScreenOn);
    };
    // Get site info to determine if it's an autopatrol site
    let isAutopatrolSite = false;
    try {
        const siteInfoStr = localStorage.getItem("siteInfo");
        if (siteInfoStr) {
            const siteInfo = JSON.parse(siteInfoStr);
            isAutopatrolSite = siteInfo?.integration_type_name === "autopatrol";
        }
    } catch (e) {
    // If we can't parse siteInfo, default to false
    }
    await AxiosUI.delete(`customer/${id}/`).then(async ()=>{
        // Set alert flags before attempting to refresh group trees
        localStorage.setItem("siteDeletedAlert", "true");
        localStorage.setItem("siteJustDeleted", "true");
        // Try to refresh group trees, but navigate regardless of success/failure
        await AxiosUI.get("group/tree/?group_type=connector&page_size=1000").then((response)=>{
            (0, $aYdit.useAppStore).getState().setGroupTrees(response.data.results);
        }, (reason)=>{
            // Log error but don't prevent navigation
            console.error("Failed to refresh group trees after delete:", reason);
        });
        // Always navigate after successful delete
        setBackdropLoadingScreenOn(false);
        const targetRoute = isAutopatrolSite ? "/sites_patrol" : "/sites";
        navigate(targetRoute);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
            alert(`Error deleting site, please try again.`);
        });
    });
};

});


parcelRegister("a6GfA", function(module, exports) {

$parcel$export(module.exports, "NoAutoAddCamerasDialog", () => $cbfe0fd423595b4c$export$6eb4b62f752e71d8);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $iLEpm = parcelRequire("iLEpm");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");
const $cbfe0fd423595b4c$export$6eb4b62f752e71d8 = ({ noAutoAddCamerasDialogOpen: noAutoAddCamerasDialogOpen, setNoAutoAddCamerasDialogOpen: setNoAutoAddCamerasDialogOpen })=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: noAutoAddCamerasDialogOpen,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: "No Auto-Add Cameras Found"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                    id: "alert-dialog-description",
                    children: "Check that information in VMS settings is accurate. Then try again."
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                    onClick: ()=>{
                        setNoAutoAddCamerasDialogOpen(false);
                    },
                    text: "OK",
                    disabled: false
                })
            })
        ]
    });
};

});

parcelRegister("c1bMf", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a62b4e22125dcc7$export$2e2bcd8739ae039);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $iLEpm = parcelRequire("iLEpm");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");

var $eejVe = parcelRequire("eejVe");

var $kDyL1 = parcelRequire("kDyL1");

var $3FJ79 = parcelRequire("3FJ79");
const $1a62b4e22125dcc7$var$AddCameraHealthDialog = ({ addCameraHealthDialogOpen: addCameraHealthDialogOpen, setAddCameraHealthDialogOpen: setAddCameraHealthDialogOpen, setSiteInfo: setSiteInfo, setActiveTab: setActiveTab, healthCheckData: healthCheckData, setCameraHealthPatchObject: setCameraHealthPatchObject, setCameraHealthChangesMade: setCameraHealthChangesMade, siteInfo: siteInfo, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setHealthCheckData: setHealthCheckData, setEditMode: setEditMode, setTurnOffHealthDialogOpen: setTurnOffHealthDialogOpen, permissions: permissions, navigate: navigate })=>{
    const { checkIfSyncNeeded: checkIfSyncNeeded } = (0, $3FJ79.useSiteAboutStore)();
    const [step2, setStep2] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [submitObject, setSubmitObject] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(healthCheckData);
    const userInfo = JSON.parse(localStorage.userInfo);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (userInfo.permission.chm) setStep2(true);
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: addCameraHealthDialogOpen,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: "Add Camera Health Monitoring"
            }),
            !step2 ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                        children: "Actuate's Camera Health Monitoring product is now available."
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                        children: "If interested, please contact your account manager at am@actuate.ai to learn more and to access the product."
                    })
                ]
            }) : /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        multiline: true,
                        defaultValue: healthCheckData.alert_emails,
                        onChange: (event)=>{
                            setSubmitObject((previousState)=>{
                                return {
                                    ...previousState,
                                    alert_emails: event.target.value
                                };
                            });
                        },
                        label: "Alert Emails",
                        sx: {
                            width: 500
                        },
                        helperText: "Emails to receive health check notifications, separated by comma.",
                        rows: 3
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        multiline: true,
                        defaultValue: healthCheckData.report_emails,
                        onChange: (event)=>{
                            setSubmitObject((previousState)=>{
                                return {
                                    ...previousState,
                                    report_emails: event.target.value
                                };
                            });
                        },
                        label: "Report Emails",
                        sx: {
                            width: 500
                        },
                        helperText: "Emails to receive health check reports, separated by comma.",
                        rows: 3
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setAddCameraHealthDialogOpen(false);
                        },
                        text: step2 ? "Cancel" : "OK",
                        disabled: false
                    }),
                    step2 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setBackdropLoadingScreenOn(true);
                            setAddCameraHealthDialogOpen(false);
                            (0, $kDyL1.handleSubmitCameraHealthData)(healthCheckData, setHealthCheckData, submitObject, setCameraHealthPatchObject, setCameraHealthChangesMade, setActiveTab, setBackdropLoadingScreenOn, siteInfo, setAddCameraHealthDialogOpen, addCameraHealthDialogOpen, setSiteInfo, setEditMode, setTurnOffHealthDialogOpen, checkIfSyncNeeded, navigate);
                        },
                        text: "Submit",
                        disabled: false
                    })
                ]
            })
        ]
    });
};
var $1a62b4e22125dcc7$export$2e2bcd8739ae039 = $1a62b4e22125dcc7$var$AddCameraHealthDialog;

});
parcelRegister("kDyL1", function(module, exports) {

$parcel$export(module.exports, "handleSubmitCameraHealthData", () => $2a3df09c2d359c64$export$2e15eb081310636b);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $iE9hz = parcelRequire("iE9hz");

var $islbW = parcelRequire("islbW");

var $3Zv1D = parcelRequire("3Zv1D");

var $3FJ79 = parcelRequire("3FJ79");
const $2a3df09c2d359c64$export$2e15eb081310636b = (healthCheckData, setHealthCheckData, cameraHealthPatchObject, setCameraHealthPatchObject, setCameraHealthChangesMade, setActiveTab, setBackdropLoadingScreenOn, siteInfo, setAddCameraHealthDialogOpen, addCameraHealthDialogOpen, setSiteInfo, setEditMode, setTurnOffHealthDialogOpen, checkIfSyncNeeded, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const { setHealthCheckDataZustand: setHealthCheckDataZustand, getHealthCheckMetricsData: getHealthCheckMetricsData } = (0, $3FJ79.useSiteAboutStore).getState();
    const retryFunction = ()=>{
        $2a3df09c2d359c64$export$2e15eb081310636b(healthCheckData, setHealthCheckData, cameraHealthPatchObject, setCameraHealthPatchObject, setCameraHealthChangesMade, setActiveTab, setBackdropLoadingScreenOn, siteInfo, setAddCameraHealthDialogOpen, addCameraHealthDialogOpen, setSiteInfo, setEditMode, setTurnOffHealthDialogOpen, checkIfSyncNeeded, navigate);
    };
    const updatedPatchObject = {};
    for(const key in cameraHealthPatchObject)if (key !== "deployment") updatedPatchObject[key] = cameraHealthPatchObject[key];
    updatedPatchObject.deployment = 3;
    AxiosUI.patch(`/healthcheck/${healthCheckData.id}/`, updatedPatchObject).then((response)=>{
        setHealthCheckData({
            ...response.data,
            deployment: 3
        });
        setHealthCheckDataZustand({
            ...response.data,
            deployment: 3
        });
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
        setEditMode(false);
        setTimeout(()=>{
            setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $islbW.CameraHealthTab), {
                healthCheckData: {
                    ...cameraHealthPatchObject,
                    deployment: 3
                },
                siteInfo: siteInfo
            }));
        }, 1);
        getHealthCheckMetricsData(navigate, siteInfo.id);
        checkIfSyncNeeded();
        setBackdropLoadingScreenOn(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
            setTimeout(()=>{
                setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $iE9hz.CameraHealthTabEditMode), {
                    healthCheckData: healthCheckData,
                    setCameraHealthPatchObject: setCameraHealthPatchObject,
                    setCameraHealthChangesMade: setCameraHealthChangesMade,
                    siteInfo: siteInfo,
                    setAddCameraHealthDialogOpen: setAddCameraHealthDialogOpen,
                    setTurnOffHealthDialogOpen: setTurnOffHealthDialogOpen
                }));
            }, 1);
            alert("Error adding Camera Health, please try again.");
            setBackdropLoadingScreenOn(false);
        });
    });
};

});


parcelRegister("fZhbM", function(module, exports) {

$parcel$export(module.exports, "TurnOffCameraHealthDialog", () => $f9a41e7971181473$export$a8531aebf71f2e72);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $iLEpm = parcelRequire("iLEpm");

var $8jTCz = parcelRequire("8jTCz");

var $6CgUC = parcelRequire("6CgUC");

var $3FJ79 = parcelRequire("3FJ79");
const $f9a41e7971181473$export$a8531aebf71f2e72 = ({ turnOffHealthDialogOpen: turnOffHealthDialogOpen, healthCheckData: healthCheckData, cameraHealthPatchObject: cameraHealthPatchObject, setCameraHealthPatchObject: setCameraHealthPatchObject, setCameraHealthChangesMade: setCameraHealthChangesMade, setActiveTab: setActiveTab, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, siteInfo: siteInfo, setAddCameraHealthDialogOpen: setAddCameraHealthDialogOpen, setSiteInfo: setSiteInfo, setTurnOffHealthDialogOpen: setTurnOffHealthDialogOpen, setEditMode: setEditMode, setHealthCheckData: setHealthCheckData, navigate: navigate })=>{
    const { checkIfSyncNeeded: checkIfSyncNeeded } = (0, $3FJ79.useSiteAboutStore)();
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: turnOffHealthDialogOpen,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                    children: "Are you sure you'd like to turn off Camera Health Monitoring for this site?"
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setTurnOffHealthDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setTurnOffHealthDialogOpen(false);
                            setBackdropLoadingScreenOn(true);
                            (0, $6CgUC.handleTurnOffCameraHealth)(healthCheckData, cameraHealthPatchObject, setCameraHealthPatchObject, setCameraHealthChangesMade, setActiveTab, setBackdropLoadingScreenOn, siteInfo, setAddCameraHealthDialogOpen, setSiteInfo, setTurnOffHealthDialogOpen, setEditMode, setHealthCheckData, checkIfSyncNeeded, navigate);
                        },
                        text: "Yes turn off",
                        disabled: false
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("6CgUC", function(module, exports) {

$parcel$export(module.exports, "handleTurnOffCameraHealth", () => $c06ee54c62e1a535$export$eb9a9b135f7163d7);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $iE9hz = parcelRequire("iE9hz");

var $islbW = parcelRequire("islbW");

var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("elyck");
var $h5bv8 = parcelRequire("h5bv8");

var $3FJ79 = parcelRequire("3FJ79");
const $c06ee54c62e1a535$export$eb9a9b135f7163d7 = (healthCheckData, cameraHealthPatchObject, setCameraHealthPatchObject, setCameraHealthChangesMade, setActiveTab, setBackdropLoadingScreenOn, siteInfo, setAddCameraHealthDialogOpen, setSiteInfo, setTurnOffHealthDialogOpen, setEditMode, setHealthCheckData, checkIfSyncNeeded, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const { setScheduleGridEditable: setScheduleGridEditable, setHealthCheckDataZustand: setHealthCheckDataZustand } = (0, $3FJ79.useSiteAboutStore).getState();
    const retryFunction = ()=>{
        $c06ee54c62e1a535$export$eb9a9b135f7163d7(healthCheckData, cameraHealthPatchObject, setCameraHealthPatchObject, setCameraHealthChangesMade, setActiveTab, setBackdropLoadingScreenOn, siteInfo, setAddCameraHealthDialogOpen, setSiteInfo, setTurnOffHealthDialogOpen, setEditMode, setHealthCheckData, checkIfSyncNeeded, navigate);
    };
    AxiosUI.patch(`/healthcheck/by_customer/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}/`, {
        deployment: 0
    }).then(()=>{
        setScheduleGridEditable(false);
        setEditMode(false);
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
        setHealthCheckData((prev)=>{
            return {
                ...prev,
                deployment: 0
            };
        });
        setHealthCheckDataZustand((prev)=>{
            return {
                ...prev,
                deployment: 0
            };
        });
        checkIfSyncNeeded();
        setTimeout(()=>{
            setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $islbW.CameraHealthTab), {
                healthCheckData: {
                    ...cameraHealthPatchObject,
                    deployment: 0
                },
                siteInfo: {
                    ...siteInfo,
                    chm: true
                }
            }));
        }, 1);
        setBackdropLoadingScreenOn(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
            setTimeout(()=>{
                setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $iE9hz.CameraHealthTabEditMode), {
                    healthCheckData: healthCheckData,
                    setCameraHealthPatchObject: setCameraHealthPatchObject,
                    setCameraHealthChangesMade: setCameraHealthChangesMade,
                    siteInfo: siteInfo,
                    setAddCameraHealthDialogOpen: setAddCameraHealthDialogOpen,
                    setTurnOffHealthDialogOpen: setTurnOffHealthDialogOpen
                }));
            }, 1);
            alert("Error turning off Camera Health, please try again.");
            setBackdropLoadingScreenOn(false);
        });
    });
};

});


parcelRegister("4ewTz", function(module, exports) {

$parcel$export(module.exports, "DeactivateSiteInsteadDialog", () => $8003d5cb95a5c257$export$dad11a55ce361421);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");

var $9j9r6 = parcelRequire("9j9r6");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $iTHZG = parcelRequire("iTHZG");

var $3FJ79 = parcelRequire("3FJ79");
const $8003d5cb95a5c257$export$dad11a55ce361421 = ({ setSiteInfo: setSiteInfo, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setAlertState: setAlertState, setPatchObject: setPatchObject, patchObject: patchObject, setArmButtonDisabled: setArmButtonDisabled, setArmedStatus: setArmedStatus, siteInfo: siteInfo, setScheduleChangesMade: setScheduleChangesMade, setSiteSchedules: setSiteSchedules, setAllSiteSchedules: setAllSiteSchedules, setEditMode: setEditMode, clickedTab: clickedTab, setActiveTab: setActiveTab, vmsVariables: vmsVariables, setDeleteScheduleDialogOpen: setDeleteScheduleDialogOpen, siteSchedules: siteSchedules })=>{
    const navigate = (0, $3T949.useNavigate)();
    const { deactivateSiteInsteadDialogOpen: deactivateSiteInsteadDialogOpen, setDeactivateSiteInsteadDialogOpen: setDeactivateSiteInsteadDialogOpen, setBackdropLoadingScreenOnEditingSchedule: setBackdropLoadingScreenOnEditingSchedule, handleSubmitEmptySchedule: handleSubmitEmptySchedule } = (0, $3FJ79.useSiteAboutStore)();
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: deactivateSiteInsteadDialogOpen,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: "Setting an empty schedule will leave the site inactive. Do you want to deactivate this site as well?"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setDeactivateSiteInsteadDialogOpen(false);
                            setBackdropLoadingScreenOnEditingSchedule(false);
                            setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $iTHZG.SchedulesTabEditMode), {
                                siteInfo: siteInfo,
                                setEditMode: setEditMode,
                                setSiteInfo: setSiteInfo,
                                setActiveTab: setActiveTab
                            }));
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setDeactivateSiteInsteadDialogOpen(false);
                            handleSubmitEmptySchedule(setEditMode, setActiveTab, siteInfo, navigate);
                        },
                        text: "Only Submit Empty Schedule",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setDeactivateSiteInsteadDialogOpen(false);
                            setPatchObject((previousState)=>{
                                return {
                                    ...previousState,
                                    active: false
                                };
                            });
                            setSiteInfo((previousState)=>{
                                return {
                                    ...previousState,
                                    active: false
                                };
                            });
                            setSiteSchedules([]);
                            (0, $9j9r6.handleDeactivateSite)(setBackdropLoadingScreenOn, patchObject, setSiteInfo, setAlertState, setPatchObject, siteInfo, setArmButtonDisabled, setArmedStatus, setSiteSchedules, setAllSiteSchedules, clickedTab, setActiveTab, setDeleteScheduleDialogOpen, navigate);
                        },
                        text: "Yes Deactivate",
                        disabled: false
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("hYdU9", function(module, exports) {

$parcel$export(module.exports, "ActivateSiteWithScheduleDialog", () => $9007fab6bc8219ea$export$6b5cec7e544cfc38);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");

var $iPk2h = parcelRequire("iPk2h");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $9007fab6bc8219ea$export$6b5cec7e544cfc38 = ({ activateSiteWithScheduleDialogOpen: activateSiteWithScheduleDialogOpen, setActivateSiteWithScheduleDialogOpen: setActivateSiteWithScheduleDialogOpen, setSiteInfo: setSiteInfo, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setAlertState: setAlertState, setPatchObject: setPatchObject, patchObject: patchObject, setSiteSchedules: setSiteSchedules, setAllSiteSchedules: setAllSiteSchedules, clickedTab: clickedTab, setActiveTab: setActiveTab, setDeleteScheduleDialogOpen: setDeleteScheduleDialogOpen, siteInfo: siteInfo })=>{
    const navigate = (0, $3T949.useNavigate)();
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: activateSiteWithScheduleDialogOpen,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: "You have added a schedule to a site which isn't active. Schedules will not run until the site is activated. Would you like to activate this site?"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setSiteInfo((previousState)=>{
                                return {
                                    ...previousState,
                                    active: false
                                };
                            });
                            setActivateSiteWithScheduleDialogOpen(false);
                        },
                        text: "No",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setActivateSiteWithScheduleDialogOpen(false);
                            setPatchObject((previousState)=>{
                                return {
                                    ...previousState,
                                    active: true
                                };
                            });
                            setSiteInfo((previousState)=>{
                                return {
                                    ...previousState,
                                    active: true
                                };
                            });
                            (0, $iPk2h.handleActivateSite)(setBackdropLoadingScreenOn, patchObject, setSiteInfo, setAlertState, setPatchObject, siteInfo, setSiteSchedules, setAllSiteSchedules, clickedTab, setActiveTab, setDeleteScheduleDialogOpen, navigate);
                        },
                        text: "Yes, Activate",
                        disabled: false
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("9HSmY", function(module, exports) {

$parcel$export(module.exports, "ArmSiteFlexScheduleDialog", () => $b523d9cb2ab09b61$export$d3dd0c758092cd3d);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $iLEpm = parcelRequire("iLEpm");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $gus0k = parcelRequire("gus0k");

var $kRZvb = parcelRequire("kRZvb");

var $f3puC = parcelRequire("f3puC");

var $kbChx = parcelRequire("kbChx");

var $3baw3 = parcelRequire("3baw3");

var $2SHRA = parcelRequire("2SHRA");

var $9qNow = parcelRequire("9qNow");

var $bOLX1 = parcelRequire("bOLX1");

var $eIysU = parcelRequire("eIysU");

var $3FJ79 = parcelRequire("3FJ79");

var $dX4iy = parcelRequire("dX4iy");
const $b523d9cb2ab09b61$export$d3dd0c758092cd3d = ({ armSiteFlexScheduleDialogOpen: armSiteFlexScheduleDialogOpen, setArmSiteFlexScheduleDialogOpen: setArmSiteFlexScheduleDialogOpen, setSiteInfo: setSiteInfo, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setAlertState: setAlertState, setSyncNeeded: setSyncNeeded, setArmedStatus: setArmedStatus, setArmButtonDisabled: setArmButtonDisabled, setToolTipTitle: // siteSchedules,
setToolTipTitle, endpointAction: // "reboot" when the picker was opened from a reboot-to-apply flow
// (RebootDialog handoff) — logs "Manual Reboot" instead of "Manual Arm"
// (ENG-1404).
endpointAction = "arm", siteTimezone: // The site's timezone, for telling which schedules are inside their
// window right now (ENG-1968).
siteTimezone })=>{
    const { siteSchedules: siteSchedules } = (0, $3FJ79.useSiteAboutStore)();
    const navigate = (0, $3T949.useNavigate)();
    // A manual arm or reboot sticks until the schedule's next scheduled
    // disarm, so restarting a schedule outside its window arms its products
    // right away, e.g. a 22:00–06:00 schedule restarted at 10:00 stays armed
    // until 06:00 tomorrow (SUP-669). Show each window, and when applying
    // settings, pre-select only the schedules that are running now.
    const windows = [
        0,
        1,
        2
    ].map((index)=>(0, $dX4iy.flexScheduleWindow)(siteSchedules[index]?.schedule, siteTimezone));
    const [selectedValue, setSelectedValue] = $8T3gX.useState(()=>{
        const preselect = (index)=>endpointAction === "reboot" && windows[index].inWindow === true;
        return {
            one: preselect(0),
            two: preselect(1),
            three: preselect(2)
        };
    });
    const productNames = (index)=>(siteSchedules[index]?.product ?? []).map((product)=>`${productIds.get(product)}`).join(", ");
    const checkedFlags = [
        selectedValue.one,
        selectedValue.two,
        selectedValue.three
    ];
    // Starting a schedule outside its window while another schedule that
    // shares a product is running runs that product twice, so every alert
    // arrives twice (ENG-1970). Only the running schedules left unticked count:
    // ticked ones are covered by the duplicate-products warning below.
    const runningDuplicates = (index)=>{
        const mine = siteSchedules[index]?.product ?? [];
        return [
            0,
            1,
            2
        ].flatMap((other)=>{
            if (other === index || checkedFlags[other]) return [];
            if (windows[other].inWindow !== true || !siteSchedules[other]) return [];
            const shared = (siteSchedules[other].product ?? []).filter((product)=>mine.includes(product));
            return shared.length ? [
                {
                    name: siteSchedules[other].display_name,
                    products: shared.map((product)=>`${productIds.get(product)}`).join(", ")
                }
            ] : [];
        });
    };
    const scheduleLabel = (index, checked)=>{
        const window = windows[index];
        const outside = window.inWindow === false;
        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    children: `${siteSchedules[index]?.display_name} (Active Products: ${productNames(index)})`
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "text-sm text-gray-600",
                    "data-testid": `flex-window-${index}`,
                    children: [
                        window.label,
                        window.inWindow === true && " \xb7 running now",
                        outside && " \xb7 outside its window"
                    ]
                }),
                checked && outside && /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                    error: true,
                    "data-testid": `flex-window-warning-${index}`,
                    children: `${endpointAction === "reboot" ? "Restarting" : "Arming"} it now arms ${productNames(index)} right away. It stays armed until ${window.endsAt ? `its next scheduled disarm at ${window.endsAt}` : "its next scheduled disarm"}.`
                }),
                checked && outside && runningDuplicates(index).map((duplicate)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                        error: true,
                        "data-testid": `flex-running-duplicate-${index}`,
                        children: `${duplicate.name} is running ${duplicate.products} now. ${endpointAction === "reboot" ? "Restarting" : "Arming"} ${siteSchedules[index]?.display_name} would run ${duplicate.products} twice and duplicate alerts.`
                    }, duplicate.name))
            ]
        });
    };
    const [duplicateProducts, setDuplicateProducts] = $8T3gX.useState(false);
    const products = JSON.parse(localStorage.products);
    const productIds = new Map();
    products.forEach((product)=>{
        productIds.set(product.id, product.name);
    });
    const handleCheckForSameProducts = ()=>{
        const selectedProducts = [];
        if (selectedValue.one) siteSchedules[0].product.forEach((product)=>{
            selectedProducts.push(product);
        });
        if (selectedValue.two) siteSchedules[1].product.forEach((product)=>{
            selectedProducts.push(product);
        });
        if (selectedValue.three) siteSchedules[2].product.forEach((product)=>{
            selectedProducts.push(product);
        });
        //check selectedProducts for duplicates
        const duplicates = selectedProducts.filter((item, index)=>selectedProducts.indexOf(item) != index);
        if (duplicates.length > 0) setDuplicateProducts(true);
        else setDuplicateProducts(false);
    };
    $8T3gX.useEffect(()=>{
        handleCheckForSameProducts();
    }, [
        selectedValue
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: armSiteFlexScheduleDialogOpen,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gus0k.default), {
                sx: {
                    position: "relative"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kRZvb.default), {
                    sx: {
                        background: "#001943"
                    },
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            ml: 2,
                            flex: 1
                        },
                        variant: "h6",
                        component: "div",
                        children: endpointAction === "reboot" ? "Restart Site" : "Arm Site"
                    })
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                        id: "alert-dialog-description",
                        children: endpointAction === "reboot" ? "Flex scheduling is enabled. Select the schedules to restart so they pick up the new settings. Schedules that are running now are selected. Schedules outside their window pick up the new settings at their next scheduled arm, so they don't need a restart." : "Flex scheduling is enabled. Select the schedules you would like to arm. Each stays armed until its next scheduled disarm."
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $2SHRA.default), {
                        className: "pt-[20px]",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                    checked: selectedValue.one,
                                    onChange: (event)=>setSelectedValue({
                                            ...selectedValue,
                                            one: event.target.checked
                                        })
                                }),
                                label: scheduleLabel(0, selectedValue.one)
                            }),
                            siteSchedules[1] && siteSchedules[1]?.product?.length > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                    checked: selectedValue.two,
                                    onChange: (event)=>setSelectedValue({
                                            ...selectedValue,
                                            two: event.target.checked
                                        })
                                }),
                                label: scheduleLabel(1, selectedValue.two)
                            }),
                            siteSchedules[2] && siteSchedules[2].product.length > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                    checked: selectedValue.three,
                                    onChange: (event)=>setSelectedValue({
                                            ...selectedValue,
                                            three: event.target.checked
                                        })
                                }),
                                label: scheduleLabel(2, selectedValue.three)
                            })
                        ]
                    }),
                    duplicateProducts && /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                        error: true,
                        children: "Schedules have been selected that contain the same products. Please note that this could result in duplicate alerts."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setArmSiteFlexScheduleDialogOpen(false);
                            setSiteInfo((previousState)=>{
                                return {
                                    ...previousState,
                                    armed: false
                                };
                            });
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            (0, $bOLX1.handleArmSiteFlexSchedules)(setBackdropLoadingScreenOn, setSiteInfo, setAlertState, setSyncNeeded, setArmedStatus, navigate, setArmButtonDisabled, (0, $eIysU.handleCreateSelectedSchedulesArrays)(selectedValue, siteSchedules), setToolTipTitle, endpointAction);
                            setSiteInfo((previousState)=>{
                                return {
                                    ...previousState,
                                    armed: true
                                };
                            });
                            setArmSiteFlexScheduleDialogOpen(false);
                        },
                        text: endpointAction === "reboot" ? "Restart" : "Arm Site",
                        disabled: !selectedValue.one && !selectedValue.two && !selectedValue.three
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("bOLX1", function(module, exports) {

$parcel$export(module.exports, "handleArmSiteFlexSchedules", () => $da9b28f7f60d2da8$export$522e1038bfa8a357);

var $195EM = parcelRequire("195EM");

var $F8wri = parcelRequire("F8wri");

var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("elyck");
var $h5bv8 = parcelRequire("h5bv8");

var $ebTQj = parcelRequire("ebTQj");

var $c6Nur = parcelRequire("c6Nur");

var $hN0t7 = parcelRequire("hN0t7");
const $da9b28f7f60d2da8$export$522e1038bfa8a357 = (setBackdropLoadingScreenOn, setSiteInfo, setAlertState, setSyncNeeded, setArmedStatus, navigate, setArmButtonDisabled, selectedSchedulesArrays, setToolTipTitle, // "arm" for the Arm toggle's schedule picker; "reboot" when the picker was
// reached from a reboot-to-apply flow, so the action log records
// "Manual Reboot" instead of "Manual Arm" (ENG-1404 / SUP-433). Since
// ENG-1969, a reboot of a schedule that isn't running only deploys
// settings; the response says which schedules were restarted.
endpointAction = "arm")=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    setBackdropLoadingScreenOn(true);
    const retryFunction = ()=>{
        $da9b28f7f60d2da8$export$522e1038bfa8a357(setBackdropLoadingScreenOn, setSiteInfo, setAlertState, setSyncNeeded, setArmedStatus, navigate, setArmButtonDisabled, selectedSchedulesArrays, setToolTipTitle, endpointAction);
    };
    AxiosUI.post(`flex_schedule/action/${endpointAction}/`, {
        flex_schedule_ids: selectedSchedulesArrays.ids
    }).then((actionResponse)=>{
        // The connector restarts: refresh every camera's status (ENG-2853).
        (0, $hN0t7.requestCameraStatusRefresh)();
        AxiosUI.get(`customer/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}/about/`).then((response)=>{
            (0, $F8wri.checkArmedStatus)(response.data, setArmButtonDisabled, navigate, setSiteInfo, setArmedStatus);
            setSiteInfo(response.data);
            if (response.data.settings_deployed !== true) setSyncNeeded(true);
            alert((0, $c6Nur.summarizeFlexActionResults)(actionResponse?.data, selectedSchedulesArrays, endpointAction));
            setArmedStatus(true);
            setBackdropLoadingScreenOn(false);
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                setAlertState((previousState)=>{
                    return {
                        ...previousState,
                        changeSuccess: false,
                        activateSuccess: false,
                        deactivateSuccess: false,
                        disarmSuccess: false,
                        armSuccess: false,
                        syncSuccess: false,
                        cameraDeleteSuccess: false,
                        armFail: true
                    };
                });
                setBackdropLoadingScreenOn(false);
                (0, $ebTQj.logger).log(JSON.stringify(reason.message));
            });
        });
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
            setSiteInfo((previousState)=>{
                return {
                    ...previousState,
                    armed: false
                };
            });
        });
    });
};

});
parcelRegister("c6Nur", function(module, exports) {

$parcel$export(module.exports, "summarizeFlexActionResults", () => $e591d683d6f2a490$export$2ff8401f9475975f);
/**
 * What actually happened to each schedule after flex_schedule/action/arm/ or
 * /reboot/ (ENG-1968 / ENG-1969).
 *
 * The response is a list of messages. Since actuate_admin #2963, messages
 * about a flex schedule carry `flex_schedule_id` and `outcome`
 * (restarted | settings_only | armed | failed), and a reboot of a schedule
 * that isn't running only deploys settings. Items come back in the
 * serializer's order, not the request's, so match by id. Messages with no
 * flex_schedule_id (settings deploy, a refused reboot) are ignored; a selected
 * schedule with no outcome item wasn't done.
 *
 * Before #2963 there are no outcomes, so the old one-line message stands.
 */ const $e591d683d6f2a490$var$LINES = {
    armed: "Armed",
    restarted: "Restarted",
    settings_only: "Not running, so not restarted. The new settings apply at its next scheduled start",
    failed: "Failed. Please try again",
    missing: "Not done. Please check the schedule and try again"
};
const $e591d683d6f2a490$export$2ff8401f9475975f = (responseData, selected, endpointAction)=>{
    const outcomes = new Map();
    if (Array.isArray(responseData)) responseData.forEach((item)=>{
        if (item?.flex_schedule_id != null && item.outcome) outcomes.set(Number(item.flex_schedule_id), item.outcome);
    });
    if (outcomes.size === 0) return `The following schedules have been successfully ${endpointAction === "reboot" ? "restarted" : "armed"}: ${selected.names.join(", ")}`;
    return selected.ids.map((id, index)=>`${selected.names[index]}: ${$e591d683d6f2a490$var$LINES[outcomes.get(Number(id)) ?? "missing"]}.`).join("\n");
};

});


parcelRegister("eIysU", function(module, exports) {

$parcel$export(module.exports, "handleCreateSelectedSchedulesArrays", () => $f2997c4eeea61803$export$f79b8df3348a94fc);
parcelRequire("8T3gX");
const $f2997c4eeea61803$export$f79b8df3348a94fc = (selectedValueObject, siteSchedules)=>{
    const selectedSchedulesIds = [];
    const selectedSchedulesNames = [];
    if (selectedValueObject.one) {
        selectedSchedulesIds.push(siteSchedules[0].id);
        selectedSchedulesNames.push(siteSchedules[0].display_name);
    }
    if (selectedValueObject.two) {
        selectedSchedulesIds.push(siteSchedules[1].id);
        selectedSchedulesNames.push(siteSchedules[1].display_name);
    }
    if (selectedValueObject.three) {
        selectedSchedulesIds.push(siteSchedules[2].id);
        selectedSchedulesNames.push(siteSchedules[2].display_name);
    }
    return {
        ids: selectedSchedulesIds,
        names: selectedSchedulesNames
    };
};

});

parcelRegister("dX4iy", function(module, exports) {

$parcel$export(module.exports, "flexScheduleWindow", () => $8085a52e7e9b91a2$export$4c038d1cd91346d6);
/**
 * Is a flex schedule inside its arming window right now? (ENG-1968)
 *
 * The Arm / restart-to-apply schedule picker used to list flex schedules with
 * no times, so a user applying settings ticked every schedule and armed the
 * night one at 10 am: a manual reboot sticks until the schedule's next
 * boundary, which for a 22:00–06:00 schedule is the next morning (SUP-669).
 *
 * Mirrors actuate_admin's ScheduleV2.is_running: today's enabled,
 * non-override row in the site's timezone; `[start, end)`; a window whose end
 * is not after its start wraps past midnight. Day values are "0" = Sunday …
 * "6" = Saturday, like JavaScript's getDay().
 */ const $8085a52e7e9b91a2$var$toMinutes = (time)=>{
    const [hours, minutes] = time.split(":").map(Number);
    return hours * 60 + minutes;
};
const $8085a52e7e9b91a2$var$hhmm = (time)=>time.slice(0, 5);
const $8085a52e7e9b91a2$export$d18c0f4f9c3492b3 = (timeZone, now = new Date())=>{
    try {
        const parts = new Intl.DateTimeFormat("en-US", {
            timeZone: timeZone || undefined,
            weekday: "short",
            hour: "2-digit",
            minute: "2-digit",
            hourCycle: "h23"
        }).formatToParts(now);
        const get = (type)=>parts.find((part)=>part.type === type)?.value ?? "";
        const day = [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ].indexOf(get("weekday"));
        const minutes = Number(get("hour")) * 60 + Number(get("minute"));
        if (day >= 0 && !Number.isNaN(minutes)) return {
            day: day,
            minutes: minutes
        };
    } catch  {
    // Unknown timezone string: fall through to the browser's clock.
    }
    return {
        day: now.getDay(),
        minutes: now.getHours() * 60 + now.getMinutes()
    };
};
const $8085a52e7e9b91a2$var$rowWindow = (row, minutes)=>{
    if (row.always_on) return {
        inWindow: true,
        label: "Always on",
        endsAt: null
    };
    if (row.location_dusk_dawn) return {
        inWindow: null,
        label: "Dusk to dawn",
        endsAt: null
    };
    if (!row.start_time || !row.end_time) return {
        inWindow: null,
        label: "No times set",
        endsAt: null
    };
    const start = $8085a52e7e9b91a2$var$toMinutes(row.start_time);
    const end = $8085a52e7e9b91a2$var$toMinutes(row.end_time);
    const inWindow = end > start ? start <= minutes && minutes < end : minutes < end || start <= minutes;
    return {
        inWindow: inWindow,
        label: `${$8085a52e7e9b91a2$var$hhmm(row.start_time)}\u{2013}${$8085a52e7e9b91a2$var$hhmm(row.end_time)}`,
        endsAt: $8085a52e7e9b91a2$var$hhmm(row.end_time)
    };
};
const $8085a52e7e9b91a2$export$4c038d1cd91346d6 = (rows, timeZone, now = new Date())=>{
    const { day: day, minutes: minutes } = $8085a52e7e9b91a2$export$d18c0f4f9c3492b3(timeZone, now);
    // A schedule can hold more than one row for the same weekday (two windows
    // in a day), so evaluate them all: running if any row is.
    const today = (rows ?? []).filter((row)=>row.enabled !== false && !row.is_override && (row.day_of_week ?? []).includes(String(day))).map((row)=>$8085a52e7e9b91a2$var$rowWindow(row, minutes));
    if (today.length === 0) return {
        inWindow: false,
        label: "Not scheduled today",
        endsAt: null
    };
    const running = today.find((window)=>window.inWindow === true);
    if (running) return running;
    const label = today.map((window)=>window.label).join(", ");
    const unknown = today.find((window)=>window.inWindow === null);
    if (unknown) return {
        inWindow: null,
        label: label,
        endsAt: null
    };
    return {
        inWindow: false,
        label: label,
        endsAt: today[0].endsAt
    };
};

});


parcelRegister("krt5P", function(module, exports) {

$parcel$export(module.exports, "DisarmSiteFlexScheduleDialog", () => $8e74df390e4cf2e9$export$a8b7d312d2154e4e);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $iLEpm = parcelRequire("iLEpm");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $gus0k = parcelRequire("gus0k");

var $kRZvb = parcelRequire("kRZvb");

var $f3puC = parcelRequire("f3puC");

var $kbChx = parcelRequire("kbChx");

var $3baw3 = parcelRequire("3baw3");

var $2SHRA = parcelRequire("2SHRA");

var $16sDS = parcelRequire("16sDS");

var $eIysU = parcelRequire("eIysU");

var $3FJ79 = parcelRequire("3FJ79");

var $eedS6 = parcelRequire("eedS6");

var $5P5Ui = parcelRequire("5P5Ui");

var $h5bv8 = parcelRequire("h5bv8");
const $8e74df390e4cf2e9$export$3bf5b4760f0d20e0 = ({ nextArm: nextArm, flexScheduleId: flexScheduleId })=>{
    const row = nextArm?.flex_schedules.find((item)=>item.flex_schedule_id === flexScheduleId);
    if (!nextArm || !row) return null;
    const text = (0, $eedS6.nextArmLine)(row.next_arm_at, row.supported === false ? false : row.supported ?? nextArm.supported, nextArm.timezone, nextArm.horizon_days, "If disarmed, it");
    if (!text) return null;
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "text-[13px] text-[#4c5257]",
        "data-testid": `flex-next-arm-${flexScheduleId}`,
        children: text
    });
};
const $8e74df390e4cf2e9$export$a8b7d312d2154e4e = ({ disarmSiteFlexScheduleDialogOpen: disarmSiteFlexScheduleDialogOpen, setDisarmSiteFlexScheduleDialogOpen: setDisarmSiteFlexScheduleDialogOpen, setSiteInfo: setSiteInfo, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setAlertState: setAlertState, setSyncNeeded: setSyncNeeded, setArmedStatus: setArmedStatus, setArmButtonDisabled: setArmButtonDisabled, setToolTipTitle: setToolTipTitle })=>{
    const { siteSchedules: siteSchedules } = (0, $3FJ79.useSiteAboutStore)();
    const navigate = (0, $3T949.useNavigate)();
    // Fleet sites: next_arm can't see the fleet worker's schedules (see
    // DisarmSiteDialog), so no per-schedule line.
    const fleetSite = (0, $5P5Ui.isFleetSite)((0, $3FJ79.useSiteAboutStore)((state)=>state.siteInfo));
    const nextArm = (0, $eedS6.useNextArm)((0, $h5bv8.getNumbersAfterAboutSite)(window.location.href), disarmSiteFlexScheduleDialogOpen && !fleetSite);
    // All schedules are pre-checked by default so a full site disarm stays one
    // click; the user unchecks any schedules they want to keep running.
    const [selectedValue, setSelectedValue] = $8T3gX.useState({
        one: Boolean(siteSchedules[0]),
        two: Boolean(siteSchedules[1] && siteSchedules[1]?.product?.length > 0),
        three: Boolean(siteSchedules[2] && siteSchedules[2]?.product?.length > 0)
    });
    const products = JSON.parse(localStorage.products);
    const productIds = new Map();
    products.forEach((product)=>{
        productIds.set(product.id, product.name);
    });
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: disarmSiteFlexScheduleDialogOpen,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gus0k.default), {
                sx: {
                    position: "relative"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kRZvb.default), {
                    sx: {
                        background: "#001943"
                    },
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            ml: 2,
                            flex: 1
                        },
                        variant: "h6",
                        component: "div",
                        children: "Disarm Site"
                    })
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                        id: "alert-dialog-description",
                        children: "Flex scheduling is currently enabled. Please select which schedules you would like to disarm. Any schedules left unselected will keep running and will still follow their schedule."
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $2SHRA.default), {
                        className: "pt-[20px]",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                    checked: selectedValue.one,
                                    onChange: (event)=>setSelectedValue({
                                            ...selectedValue,
                                            one: event.target.checked
                                        })
                                }),
                                label: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    children: [
                                        `${siteSchedules[0]?.display_name} (Active Products: ${`${siteSchedules[0]?.product.map((product)=>{
                                            return `${productIds.get(product)}`;
                                        }).join(", ")}`})`,
                                        /*#__PURE__*/ (0, $k4ank.jsx)($8e74df390e4cf2e9$export$3bf5b4760f0d20e0, {
                                            nextArm: nextArm,
                                            flexScheduleId: siteSchedules[0]?.id
                                        })
                                    ]
                                })
                            }),
                            siteSchedules[1] && siteSchedules[1]?.product?.length > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                    checked: selectedValue.two,
                                    onChange: (event)=>setSelectedValue({
                                            ...selectedValue,
                                            two: event.target.checked
                                        })
                                }),
                                label: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    children: [
                                        `${siteSchedules[1]?.display_name} (Active Products: ${`${siteSchedules[1]?.product.map((product)=>{
                                            return `${productIds.get(product)}`;
                                        }).join(", ")}`})`,
                                        /*#__PURE__*/ (0, $k4ank.jsx)($8e74df390e4cf2e9$export$3bf5b4760f0d20e0, {
                                            nextArm: nextArm,
                                            flexScheduleId: siteSchedules[1]?.id
                                        })
                                    ]
                                })
                            }),
                            siteSchedules[2] && siteSchedules[2].product.length > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                    checked: selectedValue.three,
                                    onChange: (event)=>setSelectedValue({
                                            ...selectedValue,
                                            three: event.target.checked
                                        })
                                }),
                                label: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    children: [
                                        `${siteSchedules[2]?.display_name} (Active Products: ${`${siteSchedules[2]?.product.map((product)=>{
                                            return `${productIds.get(product)}`;
                                        }).join(", ")}`})`,
                                        /*#__PURE__*/ (0, $k4ank.jsx)($8e74df390e4cf2e9$export$3bf5b4760f0d20e0, {
                                            nextArm: nextArm,
                                            flexScheduleId: siteSchedules[2]?.id
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setDisarmSiteFlexScheduleDialogOpen(false);
                            setSiteInfo((previousState)=>{
                                return {
                                    ...previousState,
                                    armed: true
                                };
                            });
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            (0, $16sDS.handleDisarmSiteFlexSchedules)(setBackdropLoadingScreenOn, setSiteInfo, setAlertState, setSyncNeeded, setArmedStatus, navigate, setArmButtonDisabled, (0, $eIysU.handleCreateSelectedSchedulesArrays)(selectedValue, siteSchedules), setToolTipTitle);
                            setSiteInfo((previousState)=>{
                                return {
                                    ...previousState,
                                    armed: false
                                };
                            });
                            setDisarmSiteFlexScheduleDialogOpen(false);
                        },
                        text: "Disarm Site",
                        disabled: !selectedValue.one && !selectedValue.two && !selectedValue.three
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("16sDS", function(module, exports) {

$parcel$export(module.exports, "handleDisarmSiteFlexSchedules", () => $4dd4e2ba7d3a398b$export$e9bc65b6e8c832bb);

var $195EM = parcelRequire("195EM");

var $F8wri = parcelRequire("F8wri");

var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("elyck");
var $h5bv8 = parcelRequire("h5bv8");

var $ebTQj = parcelRequire("ebTQj");
const $4dd4e2ba7d3a398b$export$e9bc65b6e8c832bb = (setBackdropLoadingScreenOn, setSiteInfo, setAlertState, setSyncNeeded, setArmedStatus, navigate, setArmButtonDisabled, selectedSchedulesArrays, setToolTipTitle)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    setBackdropLoadingScreenOn(true);
    const retryFunction = ()=>{
        $4dd4e2ba7d3a398b$export$e9bc65b6e8c832bb(setBackdropLoadingScreenOn, setSiteInfo, setAlertState, setSyncNeeded, setArmedStatus, navigate, setArmButtonDisabled, selectedSchedulesArrays, setToolTipTitle);
    };
    AxiosUI.post(`flex_schedule/action/disarm/`, {
        flex_schedule_ids: selectedSchedulesArrays.ids
    }).then(()=>{
        AxiosUI.get(`customer/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}/about/`).then((response)=>{
            (0, $F8wri.checkArmedStatus)(response.data, setArmButtonDisabled, navigate, setSiteInfo, setArmedStatus);
            setSiteInfo(response.data);
            if (response.data.settings_deployed !== true) setSyncNeeded(true);
            alert(`The following schedules have been successfully disarmed: ${selectedSchedulesArrays.names.join(", ")}`);
            setArmedStatus(response.data.armed === true);
            setBackdropLoadingScreenOn(false);
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                setAlertState((previousState)=>{
                    return {
                        ...previousState,
                        changeSuccess: false,
                        activateSuccess: false,
                        deactivateSuccess: false,
                        disarmSuccess: true,
                        armSuccess: false,
                        syncSuccess: false,
                        cameraDeleteSuccess: false,
                        armFail: false
                    };
                });
                setBackdropLoadingScreenOn(false);
                (0, $ebTQj.logger).log(JSON.stringify(reason.message));
            });
        });
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
            setSiteInfo((previousState)=>{
                return {
                    ...previousState,
                    armed: true
                };
            });
        });
    });
};

});


parcelRegister("2JO2V", function(module, exports) {

$parcel$export(module.exports, "EditScheduleTimesDialog", () => $3914499bb69d3a61$export$46963b261377001e);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $kUcVg = parcelRequire("kUcVg");
var $eejVe = parcelRequire("eejVe");

var $gus0k = parcelRequire("gus0k");

var $kRZvb = parcelRequire("kRZvb");

var $f3puC = parcelRequire("f3puC");

var $3baw3 = parcelRequire("3baw3");

var $7UDCh = parcelRequire("7UDCh");

var $2SHRA = parcelRequire("2SHRA");

var $ddLR4 = parcelRequire("ddLR4");

var $kbChx = parcelRequire("kbChx");

var $hwWkD = parcelRequire("hwWkD");

var $6UPM7 = parcelRequire("6UPM7");

var $hfM8m = parcelRequire("hfM8m");

var $dJISD = parcelRequire("dJISD");

var $a6zeR = parcelRequire("a6zeR");

var $8jTCz = parcelRequire("8jTCz");

var $55pxR = parcelRequire("55pxR");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $kFZm4 = parcelRequire("kFZm4");

var $3FJ79 = parcelRequire("3FJ79");
const $3914499bb69d3a61$export$46963b261377001e = ({ setActiveTab: //   siteSchedules,
//   siteInfo,
//   editTimeScheduleDialogOpen,
//   setEditTimeScheduleDialogOpen,
//   matchingSchedules,
//   selectedDayInfo,
//   timeRanges,
//   duskToDawnLocation,
//   setBackdropLoadingScreenOn,
setActiveTab, setEditMode: setEditMode })=>{
    const navigate = (0, $3T949.useNavigate)();
    const label = {
        inputProps: {
            "aria-label": "Checkbox label"
        }
    };
    const schedulesIndex = Number(localStorage.schedulesIndex);
    const { siteSchedules: siteSchedules, siteInfo: siteInfo, editTimeScheduleDialogOpen: editTimeScheduleDialogOpen, setEditTimeScheduleDialogOpen: setEditTimeScheduleDialogOpen, matchingSchedules: matchingSchedules, selectedDayInfo: selectedDayInfo, timeRanges: timeRanges, duskToDawnLocation: duskToDawnLocation, setSiteSchedules: setSiteSchedules, setDeleteScheduleDialogOpen: setDeleteScheduleDialogOpen, setSiteInfo: setSiteInfo, setTimeRanges: setTimeRanges, setGrid: setGrid, setMatchingSchedules: setMatchingSchedules, setBackdropLoadingScreenOnEditingSchedule: setBackdropLoadingScreenOnEditingSchedule, patchDetailedSchedule: patchDetailedSchedule, flexSchedulesOn: flexSchedulesOn, handleUpdateTimeSchedulesForAddSchedule: handleUpdateTimeSchedulesForAddSchedule } = (0, $3FJ79.useSiteAboutStore)();
    const [dayOfWeekArray, setDayOfWeekArray] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(matchingSchedules.find((array)=>array.includes(selectedDayInfo.day)));
    const [startTime, setStartTime] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(selectedDayInfo.timeRanges !== "Always On" && selectedDayInfo.timeRanges !== "Dusk to Dawn" ? selectedDayInfo.timeRanges.slice(0, 5) : null);
    const [endTime, setEndTime] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(selectedDayInfo.timeRanges !== "Always On" && selectedDayInfo.timeRanges !== "Dusk to Dawn" ? selectedDayInfo.timeRanges.slice(8, 13) : null);
    const [alwaysOn, setAlwaysOn] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(selectedDayInfo.timeRanges === "Always On");
    const [duskToDawn, setDuskToDawn] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(selectedDayInfo.duskToDawn);
    const [bufferTime, setBufferTime] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(selectedDayInfo.bufferTime);
    const [selectedProducts, setSelectedProducts] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [scheduleName, setScheduleName] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const products = JSON.parse(localStorage.products);
    const productIds = new Map();
    const productNames = new Map();
    products.forEach((element)=>{
        productNames.set(`${element.name}`, element.id);
        productIds.set(element.id, `${element.name}`);
    });
    const productOptions = JSON.parse(localStorage.selectedProducts).map((number)=>productIds.get(number));
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!window.location.pathname.includes("addschedule")) {
            if (siteSchedules && Array.isArray(siteSchedules) && siteSchedules[schedulesIndex] && siteSchedules[schedulesIndex].display_name) {
                setScheduleName(siteSchedules[schedulesIndex].display_name);
                if (siteSchedules[schedulesIndex].product) setSelectedProducts(siteSchedules[schedulesIndex].product.map((number)=>productIds.get(number)));
            }
        }
    }, [
        siteSchedules,
        schedulesIndex
    ]);
    // Update local state when dialog opens or selectedDayInfo changes
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (editTimeScheduleDialogOpen) {
            setDuskToDawn(selectedDayInfo.duskToDawn);
            setBufferTime(selectedDayInfo.bufferTime);
            setAlwaysOn(selectedDayInfo.timeRanges === "Always On");
            // Update start and end times
            if (selectedDayInfo.timeRanges !== "Always On" && selectedDayInfo.timeRanges !== "Dusk to Dawn") {
                setStartTime(selectedDayInfo.timeRanges.slice(0, 5));
                setEndTime(selectedDayInfo.timeRanges.slice(8, 13));
            } else {
                setStartTime(null);
                setEndTime(null);
            }
            // Update day of week array
            const newDayOfWeekArray = matchingSchedules.find((array)=>array.includes(selectedDayInfo.day));
            if (newDayOfWeekArray) setDayOfWeekArray(newDayOfWeekArray);
        }
    }, [
        editTimeScheduleDialogOpen,
        selectedDayInfo,
        matchingSchedules
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: editTimeScheduleDialogOpen,
        onClose: ()=>setEditTimeScheduleDialogOpen(false),
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gus0k.default), {
                sx: {
                    position: "relative"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kRZvb.default), {
                    sx: {
                        background: "#001943"
                    },
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            ml: 2,
                            flex: 1
                        },
                        variant: "h6",
                        component: "div",
                        children: "Edit Schedule Times"
                    })
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "h-[425px]",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: " bg-white",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "pt-[20px] pl-[20px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $7UDCh.default), {
                                    component: "fieldset",
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $2SHRA.default), {
                                        "aria-label": "siteSchedule",
                                        row: true,
                                        children: [
                                            "\xa0",
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                value: "sunday",
                                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                    ...label,
                                                    defaultChecked: dayOfWeekArray.includes(0),
                                                    onChange: ()=>{
                                                        if (dayOfWeekArray.includes(0)) setDayOfWeekArray(dayOfWeekArray.filter((day)=>day !== 0));
                                                        else setDayOfWeekArray([
                                                            ...dayOfWeekArray,
                                                            0
                                                        ]);
                                                    }
                                                }),
                                                label: "Sunday",
                                                labelPlacement: "start"
                                            }),
                                            "\xa0\xa0\xa0\xa0\xa0",
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                value: "monday",
                                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                    ...label,
                                                    defaultChecked: dayOfWeekArray.includes(1),
                                                    onChange: ()=>{
                                                        if (dayOfWeekArray.includes(1)) setDayOfWeekArray(dayOfWeekArray.filter((day)=>day !== 1));
                                                        else setDayOfWeekArray([
                                                            ...dayOfWeekArray,
                                                            1
                                                        ]);
                                                    }
                                                }),
                                                label: "Monday",
                                                labelPlacement: "start"
                                            }),
                                            "\xa0\xa0\xa0\xa0\xa0",
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                value: "tuesday",
                                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                    ...label,
                                                    defaultChecked: dayOfWeekArray.includes(2),
                                                    onChange: ()=>{
                                                        if (dayOfWeekArray.includes(2)) setDayOfWeekArray(dayOfWeekArray.filter((day)=>day !== 2));
                                                        else setDayOfWeekArray([
                                                            ...dayOfWeekArray,
                                                            2
                                                        ]);
                                                    }
                                                }),
                                                label: "Tuesday",
                                                labelPlacement: "start"
                                            }),
                                            "\xa0\xa0\xa0\xa0\xa0",
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                value: "wednesday",
                                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                    ...label,
                                                    defaultChecked: dayOfWeekArray.includes(3),
                                                    onChange: ()=>{
                                                        if (dayOfWeekArray.includes(3)) setDayOfWeekArray(dayOfWeekArray.filter((day)=>day !== 3));
                                                        else setDayOfWeekArray([
                                                            ...dayOfWeekArray,
                                                            3
                                                        ]);
                                                    }
                                                }),
                                                label: "Wednesday",
                                                labelPlacement: "start"
                                            }),
                                            "\xa0\xa0\xa0\xa0\xa0",
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                value: "thursday",
                                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                    ...label,
                                                    defaultChecked: dayOfWeekArray.includes(4),
                                                    onChange: ()=>{
                                                        if (dayOfWeekArray.includes(4)) setDayOfWeekArray(dayOfWeekArray.filter((day)=>day !== 4));
                                                        else setDayOfWeekArray([
                                                            ...dayOfWeekArray,
                                                            4
                                                        ]);
                                                    }
                                                }),
                                                label: "Thursday",
                                                labelPlacement: "start"
                                            }),
                                            "\xa0\xa0\xa0\xa0\xa0",
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                value: "friday",
                                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                    ...label,
                                                    defaultChecked: dayOfWeekArray.includes(5),
                                                    onChange: ()=>{
                                                        if (dayOfWeekArray.includes(5)) setDayOfWeekArray(dayOfWeekArray.filter((day)=>day !== 5));
                                                        else setDayOfWeekArray([
                                                            ...dayOfWeekArray,
                                                            5
                                                        ]);
                                                    }
                                                }),
                                                label: "Friday",
                                                labelPlacement: "start"
                                            }),
                                            "\xa0\xa0\xa0\xa0\xa0",
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                value: "saturday",
                                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                    ...label,
                                                    defaultChecked: dayOfWeekArray.includes(6),
                                                    onChange: ()=>{
                                                        if (dayOfWeekArray.includes(6)) setDayOfWeekArray(dayOfWeekArray.filter((day)=>day !== 6));
                                                        else setDayOfWeekArray([
                                                            ...dayOfWeekArray,
                                                            6
                                                        ]);
                                                    }
                                                }),
                                                label: "Saturday",
                                                labelPlacement: "start"
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "pt-[5px] pl-[40px]",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                    defaultChecked: alwaysOn,
                                    color: "warning",
                                    onChange: (value)=>{
                                        setAlwaysOn(value.target.checked);
                                        if (!value.target.checked) {
                                            setStartTime(null);
                                            setEndTime(null);
                                        } else {
                                            setStartTime("00:00:00");
                                            setEndTime("23:59:59");
                                        }
                                    }
                                }),
                                label: "Always On"
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "flex pt-[20px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "pl-[35px]",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
                                        dateAdapter: (0, $hfM8m.AdapterDateFns),
                                        children: alwaysOn || duskToDawn ? /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $6UPM7.TimePicker), {
                                                label: "Arm Start Time",
                                                disabled: true,
                                                value: null,
                                                onChange: ()=>{},
                                                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                        ...params,
                                                        helperText: duskToDawn && (!bufferTime || bufferTime === 0) ? "Will arm at dusk." : bufferTime ? `Will arm ${bufferTime} minutes before dusk.` : ""
                                                    })
                                            })
                                        }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $6UPM7.TimePicker), {
                                            label: "Arm Start Time",
                                            disabled: false,
                                            value: !startTime ? null : (()=>{
                                                const [hours, minutes] = startTime.split(":").map(Number);
                                                const date = new Date();
                                                date.setHours(hours, minutes, 0, 0);
                                                return date;
                                            })(),
                                            onChange: (newValue)=>{
                                                if (newValue !== null) setStartTime(`${(0, $kFZm4.padTo2Digits)(newValue.getHours())}:${(0, $kFZm4.padTo2Digits)(newValue.getMinutes())}:00`);
                                                if (newValue === null) setStartTime(null);
                                            },
                                            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                    ...params
                                                })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "pl-[40px]",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
                                        dateAdapter: (0, $hfM8m.AdapterDateFns),
                                        children: alwaysOn || duskToDawn ? /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $6UPM7.TimePicker), {
                                                label: "Arm End Time",
                                                disabled: true,
                                                value: null,
                                                onChange: ()=>{},
                                                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                        ...params,
                                                        helperText: duskToDawn && (!bufferTime || bufferTime === 0) ? "Will disarm at dawn." : bufferTime ? `Will disarm ${bufferTime} minutes after dawn.` : ""
                                                    })
                                            })
                                        }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $6UPM7.TimePicker), {
                                            label: "Arm End Time",
                                            disabled: false,
                                            value: !endTime ? null : (()=>{
                                                const [hours, minutes] = endTime.split(":").map(Number);
                                                const date = new Date();
                                                date.setHours(hours, minutes, 0, 0);
                                                return date;
                                            })(),
                                            onChange: (newValue)=>{
                                                if (newValue !== null) setEndTime(`${(0, $kFZm4.padTo2Digits)(newValue.getHours())}:${(0, $kFZm4.padTo2Digits)(newValue.getMinutes())}:00`);
                                                if (newValue === null) setEndTime(null);
                                            },
                                            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                    ...params
                                                })
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "flex",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "pl-[40px]",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                        disablePortal: true,
                                        options: JSON.parse(localStorage.locations).map((object)=>{
                                            return `${object.name}, ${object.region}`;
                                        }),
                                        sx: {
                                            width: 225
                                        },
                                        value: (0, $a6zeR.locationsMatcher)("Name", duskToDawn),
                                        disabled: alwaysOn,
                                        onChange: (newValue, text)=>{
                                            // if blank, set to null
                                            if (text === "") setDuskToDawn(null);
                                            else {
                                                setDuskToDawn((0, $a6zeR.locationsMatcher)("Id", text));
                                                setBufferTime("");
                                            }
                                        },
                                        renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                ...params,
                                                variant: "standard",
                                                autoComplete: "off",
                                                label: "Location dusk to dawn",
                                                helperText: "If selected will always arm at dusk and disarm at dawn."
                                            })
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "pl-[40px]",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        error: bufferTime ? !(0, $dJISD.numbersOnly).test(bufferTime) : false,
                                        id: "",
                                        label: "Buffer Time",
                                        autoComplete: "off",
                                        disabled: alwaysOn || !duskToDawn,
                                        value: bufferTime,
                                        variant: "standard",
                                        sx: {
                                            width: 225
                                        },
                                        onChange: (newValue)=>{
                                            if (newValue.target.value === "") setBufferTime("");
                                            else if ((0, $dJISD.numbersOnly).test(newValue.target.value)) setBufferTime(newValue.target.value);
                                        },
                                        helperText: bufferTime && !(0, $dJISD.numbersOnly).test(bufferTime) ? "Must be a number" : "Amount of minutes to start before dusk and end after dawn."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "flex pr-[20px] pt-[20px]",
                            style: {
                                display: "flex"
                            },
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    style: {
                                        marginLeft: "auto"
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                        onClick: ()=>{
                                            setEditTimeScheduleDialogOpen(false);
                                        },
                                        text: "Cancel",
                                        disabled: false
                                    })
                                }),
                                "\xa0\xa0\xa0",
                                !window.location.href.includes("addschedule") && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                        onClick: ()=>{
                                            const scheduleGridObjectToSubmit = (0, $55pxR.handleCreateScheduleGridObjectToSubmit)(dayOfWeekArray, startTime, endTime, alwaysOn, duskToDawn, bufferTime, timeRanges, duskToDawnLocation);
                                            setEditTimeScheduleDialogOpen(false);
                                            setBackdropLoadingScreenOnEditingSchedule(true);
                                            patchDetailedSchedule(scheduleGridObjectToSubmit, setEditMode, setActiveTab, siteInfo, navigate);
                                        },
                                        text: "Save Changes",
                                        disabled: false
                                    })
                                }),
                                window.location.href.includes("addschedule") && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                        onClick: ()=>{
                                            handleUpdateTimeSchedulesForAddSchedule(dayOfWeekArray, startTime, endTime, alwaysOn, duskToDawn, bufferTime, duskToDawnLocation);
                                            setEditTimeScheduleDialogOpen(false);
                                        },
                                        text: "Ok",
                                        disabled: !alwaysOn && !duskToDawn && !bufferTime && !startTime && !endTime
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

});
parcelRegister("hwWkD", function(module, exports) {

$parcel$export(module.exports, "MuiPickersAdapterContext", () => $cc32ac549176398f$export$544976378534cf9);
$parcel$export(module.exports, "LocalizationProvider", () => $cc32ac549176398f$export$dc45bdc734ce6f1e);

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $4wdE9 = parcelRequire("4wdE9");

var $eD0C4 = parcelRequire("eD0C4");

var $k4ank = parcelRequire("k4ank");
const $cc32ac549176398f$export$544976378534cf9 = /*#__PURE__*/ $8T3gX.createContext(null);
$cc32ac549176398f$export$544976378534cf9.displayName = 'MuiPickersAdapterContext';
let $cc32ac549176398f$var$warnedOnce = false;
function $cc32ac549176398f$export$dc45bdc734ce6f1e(inProps) {
    const props = (0, $4wdE9.default)({
        props: inProps,
        name: 'MuiLocalizationProvider'
    });
    const { children: children, dateAdapter: Utils, dateFormats: dateFormats, dateLibInstance: dateLibInstance, locale: locale, adapterLocale: adapterLocale, localeText: localeText } = props;
    if (!$cc32ac549176398f$var$warnedOnce && locale !== undefined) {
        $cc32ac549176398f$var$warnedOnce = true;
        console.warn("LocalizationProvider's prop `locale` is deprecated and replaced by `adapterLocale`");
    }
    const utils = $8T3gX.useMemo(()=>new Utils({
            locale: adapterLocale != null ? adapterLocale : locale,
            formats: dateFormats,
            instance: dateLibInstance
        }), [
        Utils,
        locale,
        adapterLocale,
        dateFormats,
        dateLibInstance
    ]);
    const defaultDates = $8T3gX.useMemo(()=>{
        return {
            minDate: utils.date('1900-01-01T00:00:00.000'),
            maxDate: utils.date('2099-12-31T00:00:00.000')
        };
    }, [
        utils
    ]);
    const contextValue = $8T3gX.useMemo(()=>{
        return {
            utils: utils,
            defaultDates: defaultDates,
            localeText: (0, $eJfrs.default)({}, (0, $eD0C4.DEFAULT_LOCALE), localeText != null ? localeText : {})
        };
    }, [
        defaultDates,
        utils,
        localeText
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsx)($cc32ac549176398f$export$544976378534cf9.Provider, {
        value: contextValue,
        children: children
    });
}
$cc32ac549176398f$export$dc45bdc734ce6f1e.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * Locale for the date library you are using
   */ adapterLocale: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * DateIO adapter class function
   */ dateAdapter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired,
    /**
   * Formats that are used for any child pickers
   */ dateFormats: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        dayOfMonth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        fullDate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        fullDateTime: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        fullDateTime12h: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        fullDateTime24h: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        fullDateWithWeekday: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        fullTime: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        fullTime12h: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        fullTime24h: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        hours12h: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        hours24h: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        keyboardDate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        keyboardDateTime: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        keyboardDateTime12h: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        keyboardDateTime24h: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        monthAndDate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        monthAndYear: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        monthShort: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        normalDate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        normalDateWithWeekday: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        shortDate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        weekday: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        weekdayShort: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    }),
    /**
   * Date library instance you are using, if it has some global overrides
   * ```jsx
   * dateLibInstance={momentTimeZone}
   * ```
   */ dateLibInstance: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Locale for the date library you are using
   * @deprecated Use `adapterLocale` instead
   */ locale: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * Locale for components texts
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
};

});
parcelRegister("4wdE9", function(module, exports) {

$parcel$export(module.exports, "default", () => $34a4bc84cf7f274d$export$2e2bcd8739ae039);

var $ihMsk = parcelRequire("ihMsk");

var $ehyEf = parcelRequire("ehyEf");

var $kuBjs = parcelRequire("kuBjs");
'use client';
function $34a4bc84cf7f274d$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $ihMsk.default)({
        props: props,
        name: name,
        defaultTheme: $ehyEf.default,
        themeId: (0, $kuBjs.default)
    });
}

});

parcelRegister("eD0C4", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE", () => $aa652ef2b8f4a161$export$1af4c7e47ad72f44);

var $dnkMV = parcelRequire("dnkMV");
const $aa652ef2b8f4a161$var$enUSPickers = {
    // Calendar navigation
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    // View navigation
    openPreviousView: 'open previous view',
    openNextView: 'open next view',
    calendarViewSwitchingButtonAriaLabel: (view)=>view === 'year' ? 'year view is open, switch to calendar view' : 'calendar view is open, switch to year view',
    inputModeToggleButtonAriaLabel: (isKeyboardInputOpen, viewType)=>isKeyboardInputOpen ? `text input view is open, go to ${viewType} view` : `${viewType} view is open, go to text input view`,
    // DateRange placeholders
    start: 'Start',
    end: 'End',
    // Action bar
    cancelButtonLabel: 'Cancel',
    clearButtonLabel: 'Clear',
    okButtonLabel: 'OK',
    todayButtonLabel: 'Today',
    // Toolbar titles
    datePickerDefaultToolbarTitle: 'Select date',
    dateTimePickerDefaultToolbarTitle: 'Select date & time',
    timePickerDefaultToolbarTitle: 'Select time',
    dateRangePickerDefaultToolbarTitle: 'Select date range',
    // Clock labels
    clockLabelText: (view, time, adapter)=>`Select ${view}. ${time === null ? 'No time selected' : `Selected time is ${adapter.format(time, 'fullTime')}`}`,
    hoursClockNumberText: (hours)=>`${hours} hours`,
    minutesClockNumberText: (minutes)=>`${minutes} minutes`,
    secondsClockNumberText: (seconds)=>`${seconds} seconds`,
    // Open picker labels
    openDatePickerDialogue: (rawValue, utils)=>rawValue && utils.isValid(utils.date(rawValue)) ? `Choose date, selected date is ${utils.format(utils.date(rawValue), 'fullDate')}` : 'Choose date',
    openTimePickerDialogue: (rawValue, utils)=>rawValue && utils.isValid(utils.date(rawValue)) ? `Choose time, selected time is ${utils.format(utils.date(rawValue), 'fullTime')}` : 'Choose time',
    // Table labels
    timeTableLabel: 'pick time',
    dateTableLabel: 'pick date'
};
const $aa652ef2b8f4a161$export$1af4c7e47ad72f44 = $aa652ef2b8f4a161$var$enUSPickers;
const $aa652ef2b8f4a161$export$137380d9ce54f7f = (0, $dnkMV.getPickersLocalization)($aa652ef2b8f4a161$var$enUSPickers);

});
parcelRegister("dnkMV", function(module, exports) {

$parcel$export(module.exports, "getPickersLocalization", () => $9bcd8c6bb86becee$export$67c96d35a1b010b3);

var $eJfrs = parcelRequire("eJfrs");
const $9bcd8c6bb86becee$export$67c96d35a1b010b3 = (pickersTranslations)=>{
    return {
        components: {
            MuiLocalizationProvider: {
                defaultProps: {
                    localeText: (0, $eJfrs.default)({}, pickersTranslations)
                }
            }
        }
    };
};

});



parcelRegister("6UPM7", function(module, exports) {

$parcel$export(module.exports, "TimePicker", () => $509022830a667982$export$5f876910ea565cd3);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $4wdE9 = parcelRequire("4wdE9");

var $hHKnQ = parcelRequire("hHKnQ");

var $fdGrT = parcelRequire("fdGrT");

var $a50J4 = parcelRequire("a50J4");

var $9RYTR = parcelRequire("9RYTR");

var $k4ank = parcelRequire("k4ank");
const $509022830a667982$var$_excluded = [
    "desktopModeMediaQuery",
    "DialogProps",
    "PopperProps",
    "TransitionComponent"
];
const $509022830a667982$export$5f876910ea565cd3 = /*#__PURE__*/ $8T3gX.forwardRef(function TimePicker(inProps, ref) {
    const props = (0, $4wdE9.default)({
        props: inProps,
        name: 'MuiTimePicker'
    });
    const { desktopModeMediaQuery: desktopModeMediaQuery = '@media (pointer: fine)', DialogProps: DialogProps, PopperProps: PopperProps, TransitionComponent: TransitionComponent } = props, other = (0, $fAJB5.default)(props, $509022830a667982$var$_excluded); // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, $hHKnQ.default)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $a50J4.DesktopTimePicker), (0, $eJfrs.default)({
        ref: ref,
        PopperProps: PopperProps,
        TransitionComponent: TransitionComponent
    }, other));
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $9RYTR.MobileTimePicker), (0, $eJfrs.default)({
        ref: ref,
        DialogProps: DialogProps
    }, other));
});
$509022830a667982$export$5f876910ea565cd3.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * Regular expression to detect "accepted" symbols.
   * @default /\dap/gi
   */ acceptRegex: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).instanceOf(RegExp),
    /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */ ampm: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default false
   */ ampmInClock: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * className applied to the root component.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true` the popup or dialog will immediately close after submitting full date.
   * @default `true` for Desktop, `false` for Mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Overrideable components.
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The props used for each component slot.
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */ desktopModeMediaQuery: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Props applied to the [`Dialog`](https://mui.com/material-ui/api/dialog/) element.
   */ DialogProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Disable mask on the keyboard, this should be used rarely. Consider passing proper mask for your format.
   * @default false
   */ disableMaskedInput: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Do not render open picker button (renders only text field with validation).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Accessible text that helps user to understand which time and view is selected.
   * @template TDate
   * @param {ClockPickerView} view The current view rendered.
   * @param {TDate | null} time The current time.
   * @param {MuiPickersAdapter<TDate>} adapter The current date adapter.
   * @returns {string} The clock label.
   * @deprecated Use the `localeText` prop of `LocalizationProvider` instead, see https://mui.com/x/react-date-pickers/localization/.
   * @default <TDate extends any>(
   *   view: ClockView,
   *   time: TDate | null,
   *   adapter: MuiPickersAdapter<TDate>,
   * ) =>
   *   `Select ${view}. ${
   *     time === null ? 'No time selected' : `Selected time is ${adapter.format(time, 'fullTime')}`
   *   }`
   */ getClockLabelText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Get aria-label text for control that opens picker dialog. Aria-label text must include selected date. @DateIOType
   * @template TInputDate, TDate
   * @param {TInputDate} date The date from which we want to add an aria-text.
   * @param {MuiPickersAdapter<TDate>} utils The utils to manipulate the date.
   * @returns {string} The aria-text to render inside the dialog.
   * @default (date, utils) => `Choose date, selected date is ${utils.format(utils.date(date), 'fullDate')}`
   */ getOpenDialogAriaText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    ignoreInvalidInputs: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Props to pass to keyboard input adornment.
   */ InputAdornmentProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Format string.
   */ inputFormat: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    InputProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        })
    ]),
    label: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Custom mask. Can be used to override generate from format. (e.g. `__/__/____ __:__` or `__/__/____ __:__ _M`).
   */ mask: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Max time acceptable time.
   * For input validation date part of passed object will be ignored if `disableIgnoringDatePartForTimeValidation` not specified.
   */ maxTime: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Min time acceptable time.
   * For input validation date part of passed object will be ignored if `disableIgnoringDatePartForTimeValidation` not specified.
   */ minTime: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    /**
   * Callback fired when date is accepted @DateIOType.
   * @template TValue
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the value (the selected date) changes @DateIOType.
   * @template TValue
   * @param {TValue} value The new parsed value.
   * @param {string} keyboardInputValue The current value of the keyboard input.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback that fired when input value or new `value` prop validation returns **new** validation error (or value is valid after error).
   * In case of validation error detected `reason` prop return non-null value and `TextField` must be displayed in `error` state.
   * This can be used to render appropriate form error.
   *
   * [Read the guide](https://next.material-ui-pickers.dev/guides/forms) about form integration and error displaying.
   * @DateIOType
   *
   * @template TError, TInputValue
   * @param {TError} reason The reason why the current value is not valid.
   * @param {TInputValue} value The invalid value.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired on view change.
   * @param {ClockPickerView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Control the popup or dialog open state.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Props to pass to keyboard adornment button.
   */ OpenPickerButtonProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * First view to show.
   * Must be a valid option from `views` list
   * @default 'hours'
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'hours',
        'minutes',
        'seconds'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'landscape',
        'portrait'
    ]),
    /**
   * Paper props passed down to [Paper](https://mui.com/material-ui/api/paper/) component.
   */ PaperProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Popper props passed down to [Popper](https://mui.com/material-ui/api/popper/) component.
   */ PopperProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Make picker read only.
   * @default false
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The `renderInput` prop allows you to customize the rendered input.
   * The `props` argument of this render prop contains props of [TextField](https://mui.com/material-ui/api/text-field/#props) that you need to forward.
   * Pay specific attention to the `ref` and `inputProps` keys.
   * @example ```jsx
   * renderInput={props => <TextField {...props} />}
   * ````
   * @param {MuiTextFieldPropsType} props The props of the input.
   * @returns {React.ReactNode} The node to render as the input.
   */ renderInput: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired,
    /**
   * Custom formatter to be passed into Rifm component.
   * @param {string} str The un-formatted string.
   * @returns {string} The formatted string.
   */ rifmFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Dynamically check if time is disabled or not.
   * If returns `false` appropriate time point will ot be acceptable.
   * @param {number} timeValue The value to check.
   * @param {ClockPickerView} clockType The clock type of the timeValue.
   * @returns {boolean} Returns `true` if the time should be disabled
   */ shouldDisableTime: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, show the toolbar even in desktop mode.
   */ showToolbar: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Component that will replace default toolbar renderer.
   * @default TimePickerToolbar
   */ ToolbarComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * Mobile picker title, displaying in the toolbar.
   * @default 'Select time'
   */ toolbarTitle: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Custom component for popper [Transition](https://mui.com/material-ui/transitions/#transitioncomponent-prop).
   */ TransitionComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * The value of the picker.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Array of views to show.
   * @default ['hours', 'minutes']
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'hours',
        'minutes',
        'seconds'
    ]).isRequired)
};

});
parcelRegister("a50J4", function(module, exports) {

$parcel$export(module.exports, "DesktopTimePicker", () => $756aef2f8d13794a$export$c2eea9c279c6035b);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $faZcZ = parcelRequire("faZcZ");

var $4VrG8 = parcelRequire("4VrG8");

var $2WcNZ = parcelRequire("2WcNZ");

var $gE5dt = parcelRequire("gE5dt");

var $9vOM8 = parcelRequire("9vOM8");

var $01RPl = parcelRequire("01RPl");

var $hlZBr = parcelRequire("hlZBr");

var $k4ank = parcelRequire("k4ank");
const $756aef2f8d13794a$var$_excluded = [
    "onChange",
    "PaperProps",
    "PopperProps",
    "ToolbarComponent",
    "TransitionComponent",
    "value",
    "components",
    "componentsProps"
];
const $756aef2f8d13794a$export$c2eea9c279c6035b = /*#__PURE__*/ $8T3gX.forwardRef(function DesktopTimePicker(inProps, ref) {
    const props = (0, $faZcZ.useTimePickerDefaultizedProps)(inProps, 'MuiDesktopTimePicker');
    const validationError = (0, $9vOM8.useTimeValidation)(props) !== null;
    const { pickerProps: pickerProps, inputProps: inputProps, wrapperProps: wrapperProps } = (0, $hlZBr.usePickerState)(props, (0, $faZcZ.timePickerValueManager));
    const { PaperProps: PaperProps, PopperProps: PopperProps, ToolbarComponent: ToolbarComponent = (0, $4VrG8.TimePickerToolbar), TransitionComponent: TransitionComponent, components: components, componentsProps: componentsProps } = props, other = (0, $fAJB5.default)(props, $756aef2f8d13794a$var$_excluded);
    const DateInputProps = (0, $eJfrs.default)({}, inputProps, other, {
        components: components,
        componentsProps: componentsProps,
        ref: ref,
        validationError: validationError
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $2WcNZ.DesktopWrapper), (0, $eJfrs.default)({}, wrapperProps, {
        DateInputProps: DateInputProps,
        KeyboardDateInputComponent: (0, $01RPl.KeyboardDateInput),
        PopperProps: PopperProps,
        PaperProps: PaperProps,
        TransitionComponent: TransitionComponent,
        components: components,
        componentsProps: componentsProps,
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $gE5dt.CalendarOrClockPicker), (0, $eJfrs.default)({}, pickerProps, {
            autoFocus: true,
            toolbarTitle: props.label || props.toolbarTitle,
            ToolbarComponent: ToolbarComponent,
            DateInputProps: DateInputProps,
            components: components,
            componentsProps: componentsProps
        }, other))
    }));
});
$756aef2f8d13794a$export$c2eea9c279c6035b.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * Regular expression to detect "accepted" symbols.
   * @default /\dap/gi
   */ acceptRegex: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).instanceOf(RegExp),
    /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */ ampm: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default false
   */ ampmInClock: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * className applied to the root component.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true` the popup or dialog will immediately close after submitting full date.
   * @default `true` for Desktop, `false` for Mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Overrideable components.
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The props used for each component slot.
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Disable mask on the keyboard, this should be used rarely. Consider passing proper mask for your format.
   * @default false
   */ disableMaskedInput: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Do not render open picker button (renders only text field with validation).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Accessible text that helps user to understand which time and view is selected.
   * @template TDate
   * @param {ClockPickerView} view The current view rendered.
   * @param {TDate | null} time The current time.
   * @param {MuiPickersAdapter<TDate>} adapter The current date adapter.
   * @returns {string} The clock label.
   * @deprecated Use the `localeText` prop of `LocalizationProvider` instead, see https://mui.com/x/react-date-pickers/localization/.
   * @default <TDate extends any>(
   *   view: ClockView,
   *   time: TDate | null,
   *   adapter: MuiPickersAdapter<TDate>,
   * ) =>
   *   `Select ${view}. ${
   *     time === null ? 'No time selected' : `Selected time is ${adapter.format(time, 'fullTime')}`
   *   }`
   */ getClockLabelText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Get aria-label text for control that opens picker dialog. Aria-label text must include selected date. @DateIOType
   * @template TInputDate, TDate
   * @param {TInputDate} date The date from which we want to add an aria-text.
   * @param {MuiPickersAdapter<TDate>} utils The utils to manipulate the date.
   * @returns {string} The aria-text to render inside the dialog.
   * @default (date, utils) => `Choose date, selected date is ${utils.format(utils.date(date), 'fullDate')}`
   */ getOpenDialogAriaText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    ignoreInvalidInputs: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Props to pass to keyboard input adornment.
   */ InputAdornmentProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Format string.
   */ inputFormat: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    InputProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        })
    ]),
    label: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Custom mask. Can be used to override generate from format. (e.g. `__/__/____ __:__` or `__/__/____ __:__ _M`).
   */ mask: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Max time acceptable time.
   * For input validation date part of passed object will be ignored if `disableIgnoringDatePartForTimeValidation` not specified.
   */ maxTime: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Min time acceptable time.
   * For input validation date part of passed object will be ignored if `disableIgnoringDatePartForTimeValidation` not specified.
   */ minTime: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    /**
   * Callback fired when date is accepted @DateIOType.
   * @template TValue
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the value (the selected date) changes @DateIOType.
   * @template TValue
   * @param {TValue} value The new parsed value.
   * @param {string} keyboardInputValue The current value of the keyboard input.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback that fired when input value or new `value` prop validation returns **new** validation error (or value is valid after error).
   * In case of validation error detected `reason` prop return non-null value and `TextField` must be displayed in `error` state.
   * This can be used to render appropriate form error.
   *
   * [Read the guide](https://next.material-ui-pickers.dev/guides/forms) about form integration and error displaying.
   * @DateIOType
   *
   * @template TError, TInputValue
   * @param {TError} reason The reason why the current value is not valid.
   * @param {TInputValue} value The invalid value.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired on view change.
   * @param {ClockPickerView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Control the popup or dialog open state.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Props to pass to keyboard adornment button.
   */ OpenPickerButtonProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * First view to show.
   * Must be a valid option from `views` list
   * @default 'hours'
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'hours',
        'minutes',
        'seconds'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'landscape',
        'portrait'
    ]),
    /**
   * Paper props passed down to [Paper](https://mui.com/material-ui/api/paper/) component.
   */ PaperProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Popper props passed down to [Popper](https://mui.com/material-ui/api/popper/) component.
   */ PopperProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Make picker read only.
   * @default false
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The `renderInput` prop allows you to customize the rendered input.
   * The `props` argument of this render prop contains props of [TextField](https://mui.com/material-ui/api/text-field/#props) that you need to forward.
   * Pay specific attention to the `ref` and `inputProps` keys.
   * @example ```jsx
   * renderInput={props => <TextField {...props} />}
   * ````
   * @param {MuiTextFieldPropsType} props The props of the input.
   * @returns {React.ReactNode} The node to render as the input.
   */ renderInput: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired,
    /**
   * Custom formatter to be passed into Rifm component.
   * @param {string} str The un-formatted string.
   * @returns {string} The formatted string.
   */ rifmFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Dynamically check if time is disabled or not.
   * If returns `false` appropriate time point will ot be acceptable.
   * @param {number} timeValue The value to check.
   * @param {ClockPickerView} clockType The clock type of the timeValue.
   * @returns {boolean} Returns `true` if the time should be disabled
   */ shouldDisableTime: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, show the toolbar even in desktop mode.
   */ showToolbar: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Component that will replace default toolbar renderer.
   * @default TimePickerToolbar
   */ ToolbarComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * Mobile picker title, displaying in the toolbar.
   * @default 'Select time'
   */ toolbarTitle: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Custom component for popper [Transition](https://mui.com/material-ui/transitions/#transitioncomponent-prop).
   */ TransitionComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * The value of the picker.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Array of views to show.
   * @default ['hours', 'minutes']
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'hours',
        'minutes',
        'seconds'
    ]).isRequired)
};

});
parcelRegister("faZcZ", function(module, exports) {

$parcel$export(module.exports, "useTimePickerDefaultizedProps", () => $b0c744ebfb3c1556$export$586c31b46cc238ba);
$parcel$export(module.exports, "timePickerValueManager", () => $b0c744ebfb3c1556$export$d61bc0fc2de603bd);

var $eJfrs = parcelRequire("eJfrs");

var $4wdE9 = parcelRequire("4wdE9");

var $hIg9z = parcelRequire("hIg9z");

var $1hdeG = parcelRequire("1hdeG");

var $4EsxQ = parcelRequire("4EsxQ");
function $b0c744ebfb3c1556$export$586c31b46cc238ba(props, name) {
    var _themeProps$ampm;
    // This is technically unsound if the type parameters appear in optional props.
    // Optional props can be filled by `useThemeProps` with types that don't match the type parameters.
    const themeProps = (0, $4wdE9.default)({
        props: props,
        name: name
    });
    const utils = (0, $1hdeG.useUtils)();
    const ampm = (_themeProps$ampm = themeProps.ampm) != null ? _themeProps$ampm : utils.is12HourCycleInCurrentLocale();
    const localeText = (0, $1hdeG.useLocaleText)();
    const getOpenDialogAriaText = localeText.openTimePickerDialogue;
    return (0, $eJfrs.default)({
        ampm: ampm,
        openTo: 'hours',
        views: [
            'hours',
            'minutes'
        ],
        acceptRegex: ampm ? /[\dapAP]/gi : /\d/gi,
        disableMaskedInput: false,
        getOpenDialogAriaText: getOpenDialogAriaText,
        inputFormat: ampm ? utils.formats.fullTime12h : utils.formats.fullTime24h
    }, themeProps, {
        components: (0, $eJfrs.default)({
            OpenPickerIcon: (0, $hIg9z.Clock)
        }, themeProps.components)
    });
}
const $b0c744ebfb3c1556$export$d61bc0fc2de603bd = {
    emptyValue: null,
    parseInput: (0, $4EsxQ.parsePickerInputValue),
    getTodayValue: (utils)=>utils.date(),
    areValuesEqual: (utils, a, b)=>utils.isEqual(a, b),
    valueReducer: (utils, lastValidValue, newValue)=>{
        if (!lastValidValue || !utils.isValid(newValue)) return newValue;
        return utils.mergeDateAndTime(lastValidValue, newValue);
    }
};

});
parcelRegister("hIg9z", function(module, exports) {

$parcel$export(module.exports, "ArrowDropDown", () => $ce5313781c287a47$export$6243d250c3142fa2);
$parcel$export(module.exports, "ArrowLeft", () => $ce5313781c287a47$export$e4c291d45fea4cd0);
$parcel$export(module.exports, "ArrowRight", () => $ce5313781c287a47$export$acad20503ad73ac1);
$parcel$export(module.exports, "Calendar", () => $ce5313781c287a47$export$e1aef45b828286de);
$parcel$export(module.exports, "Clock", () => $ce5313781c287a47$export$9735c82c4bae3302);
$parcel$export(module.exports, "Pen", () => $ce5313781c287a47$export$54c11739735d3a0a);

var $a7uO0 = parcelRequire("a7uO0");

var $8T3gX = parcelRequire("8T3gX");

var $k4ank = parcelRequire("k4ank");
const $ce5313781c287a47$export$6243d250c3142fa2 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');
const $ce5313781c287a47$export$e4c291d45fea4cd0 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'ArrowLeft');
const $ce5313781c287a47$export$acad20503ad73ac1 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'ArrowRight');
const $ce5313781c287a47$export$e1aef45b828286de = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), 'Calendar');
const $ce5313781c287a47$export$9735c82c4bae3302 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsxs)($8T3gX.Fragment, {
    children: [
        /*#__PURE__*/ (0, $k4ank.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $k4ank.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Clock');
const $ce5313781c287a47$export$829bd850c745b6e = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), 'DateRange');
const $ce5313781c287a47$export$54c11739735d3a0a = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
}), 'Pen');
const $ce5313781c287a47$export$680ea196effce5f = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsxs)($8T3gX.Fragment, {
    children: [
        /*#__PURE__*/ (0, $k4ank.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $k4ank.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Time');

});

parcelRegister("1hdeG", function(module, exports) {

$parcel$export(module.exports, "useLocalizationContext", () => $0ee1a5566cd1a263$export$4b5a24245de9f7f9);
$parcel$export(module.exports, "useUtils", () => $0ee1a5566cd1a263$export$1163b47e39508a46);
$parcel$export(module.exports, "useDefaultDates", () => $0ee1a5566cd1a263$export$7c38da3a2e90fa83);
$parcel$export(module.exports, "useLocaleText", () => $0ee1a5566cd1a263$export$24fdeaa0f591a73e);
$parcel$export(module.exports, "useNow", () => $0ee1a5566cd1a263$export$3a404aece3dff2fa);

var $8T3gX = parcelRequire("8T3gX");

var $hwWkD = parcelRequire("hwWkD");
const $0ee1a5566cd1a263$export$4b5a24245de9f7f9 = ()=>{
    const localization = $8T3gX.useContext((0, $hwWkD.MuiPickersAdapterContext));
    if (localization === null) throw new Error('MUI: Can not find utils in context. It looks like you forgot to wrap your component in LocalizationProvider, or pass dateAdapter prop directly.');
    return localization;
};
const $0ee1a5566cd1a263$export$1163b47e39508a46 = ()=>$0ee1a5566cd1a263$export$4b5a24245de9f7f9().utils;
const $0ee1a5566cd1a263$export$7c38da3a2e90fa83 = ()=>$0ee1a5566cd1a263$export$4b5a24245de9f7f9().defaultDates;
const $0ee1a5566cd1a263$export$24fdeaa0f591a73e = ()=>$0ee1a5566cd1a263$export$4b5a24245de9f7f9().localeText;
const $0ee1a5566cd1a263$export$3a404aece3dff2fa = ()=>{
    const utils = $0ee1a5566cd1a263$export$1163b47e39508a46();
    const now = $8T3gX.useRef(utils.date());
    return now.current;
};

});

parcelRegister("4EsxQ", function(module, exports) {

$parcel$export(module.exports, "findClosestEnabledDate", () => $36310a483c97a1d1$export$ca1f317ae8db2ee8);
$parcel$export(module.exports, "parsePickerInputValue", () => $36310a483c97a1d1$export$ec1af8323095accb);
$parcel$export(module.exports, "parseNonNullablePickerDate", () => $36310a483c97a1d1$export$a69dec48c619d8fa);
const $36310a483c97a1d1$export$ca1f317ae8db2ee8 = ({ date: date, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, isDateDisabled: isDateDisabled, utils: utils })=>{
    const today = utils.startOfDay(utils.date());
    if (disablePast && utils.isBefore(minDate, today)) minDate = today;
    if (disableFuture && utils.isAfter(maxDate, today)) maxDate = today;
    let forward = date;
    let backward = date;
    if (utils.isBefore(date, minDate)) {
        forward = utils.date(minDate);
        backward = null;
    }
    if (utils.isAfter(date, maxDate)) {
        if (backward) backward = utils.date(maxDate);
        forward = null;
    }
    while(forward || backward){
        if (forward && utils.isAfter(forward, maxDate)) forward = null;
        if (backward && utils.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!isDateDisabled(forward)) return forward;
            forward = utils.addDays(forward, 1);
        }
        if (backward) {
            if (!isDateDisabled(backward)) return backward;
            backward = utils.addDays(backward, -1);
        }
    }
    return null;
};
const $36310a483c97a1d1$export$ec1af8323095accb = (utils, value)=>{
    const parsedValue = utils.date(value);
    return utils.isValid(parsedValue) ? parsedValue : null;
};
const $36310a483c97a1d1$export$a69dec48c619d8fa = (utils, value, defaultValue)=>{
    if (value == null) return defaultValue;
    const parsedValue = utils.date(value);
    const isDateValid = utils.isValid(parsedValue);
    if (isDateValid) return parsedValue;
    return defaultValue;
};

});


parcelRegister("4VrG8", function(module, exports) {

$parcel$export(module.exports, "TimePickerToolbar", () => $3961f4b484c47d0d$export$76f7aa019fd43cd9);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");
parcelRequire("8T3gX");

var $anJSP = parcelRequire("anJSP");
var $4nWZ9 = parcelRequire("4nWZ9");
var $4wdE9 = parcelRequire("4wdE9");

var $aYNpO = parcelRequire("aYNpO");

var $gdomg = parcelRequire("gdomg");

var $0aWCC = parcelRequire("0aWCC");

var $9o0Hh = parcelRequire("9o0Hh");

var $lwlpY = parcelRequire("lwlpY");

var $jsJJd = parcelRequire("jsJJd");

var $1hdeG = parcelRequire("1hdeG");

var $ekk2W = parcelRequire("ekk2W");

var $gF1hK = parcelRequire("gF1hK");

var $k4ank = parcelRequire("k4ank");
const $3961f4b484c47d0d$var$_excluded = [
    "ampm",
    "ampmInClock",
    "parsedValue",
    "isLandscape",
    "isMobileKeyboardViewOpen",
    "onChange",
    "openView",
    "setOpenView",
    "toggleMobileKeyboardView",
    "toolbarTitle",
    "views",
    "disabled",
    "readOnly"
];
const $3961f4b484c47d0d$var$useUtilityClasses = (ownerState)=>{
    const { theme: theme, isLandscape: isLandscape, classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        separator: [
            'separator'
        ],
        hourMinuteLabel: [
            'hourMinuteLabel',
            isLandscape && 'hourMinuteLabelLandscape',
            theme.direction === 'rtl' && 'hourMinuteLabelReverse'
        ],
        ampmSelection: [
            'ampmSelection',
            isLandscape && 'ampmLandscape'
        ],
        ampmLabel: [
            'ampmLabel'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $gF1hK.getTimePickerToolbarUtilityClass), classes);
};
const $3961f4b484c47d0d$var$TimePickerToolbarRoot = (0, $anJSP.default)((0, $9o0Hh.PickersToolbar), {
    name: 'MuiTimePickerToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    [`& .${(0, $lwlpY.pickersToolbarClasses).penIconButtonLandscape}`]: {
        marginTop: 'auto'
    }
});
const $3961f4b484c47d0d$var$TimePickerToolbarSeparator = (0, $anJSP.default)((0, $gdomg.PickersToolbarText), {
    name: 'MuiTimePickerToolbar',
    slot: 'Separator',
    overridesResolver: (props, styles)=>styles.separator
})({
    outline: 0,
    margin: '0 4px 0 2px',
    cursor: 'default'
});
const $3961f4b484c47d0d$var$TimePickerToolbarHourMinuteLabel = (0, $anJSP.default)('div', {
    name: 'MuiTimePickerToolbar',
    slot: 'HourMinuteLabel',
    overridesResolver: (props, styles)=>[
            {
                [`&.${(0, $gF1hK.timePickerToolbarClasses).hourMinuteLabelLandscape}`]: styles.hourMinuteLabelLandscape,
                [`&.${(0, $gF1hK.timePickerToolbarClasses).hourMinuteLabelReverse}`]: styles.hourMinuteLabelReverse
            },
            styles.hourMinuteLabel
        ]
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-end'
    }, ownerState.isLandscape && {
        marginTop: 'auto'
    }, theme.direction === 'rtl' && {
        flexDirection: 'row-reverse'
    }));
const $3961f4b484c47d0d$var$TimePickerToolbarAmPmSelection = (0, $anJSP.default)('div', {
    name: 'MuiTimePickerToolbar',
    slot: 'AmPmSelection',
    overridesResolver: (props, styles)=>[
            {
                [`.${(0, $gF1hK.timePickerToolbarClasses).ampmLabel}`]: styles.ampmLabel
            },
            {
                [`&.${(0, $gF1hK.timePickerToolbarClasses).ampmLandscape}`]: styles.ampmLandscape
            },
            styles.ampmSelection
        ]
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({
        display: 'flex',
        flexDirection: 'column',
        marginRight: 'auto',
        marginLeft: 12
    }, ownerState.isLandscape && {
        margin: '4px 0 auto',
        flexDirection: 'row',
        justifyContent: 'space-around',
        flexBasis: '100%'
    }, {
        [`& .${(0, $gF1hK.timePickerToolbarClasses).ampmLabel}`]: {
            fontSize: 17
        }
    }));
function $3961f4b484c47d0d$export$76f7aa019fd43cd9(inProps) {
    const props = (0, $4wdE9.default)({
        props: inProps,
        name: 'MuiTimePickerToolbar'
    });
    const { ampm: ampm, ampmInClock: ampmInClock, parsedValue: parsedValue, isLandscape: isLandscape, isMobileKeyboardViewOpen: isMobileKeyboardViewOpen, onChange: onChange, openView: openView, setOpenView: setOpenView, toggleMobileKeyboardView: toggleMobileKeyboardView, toolbarTitle: toolbarTitleProp, views: views, disabled: disabled, readOnly: readOnly } = props, other = (0, $fAJB5.default)(props, $3961f4b484c47d0d$var$_excluded);
    const utils = (0, $1hdeG.useUtils)();
    const localeText = (0, $1hdeG.useLocaleText)();
    const toolbarTitle = toolbarTitleProp != null ? toolbarTitleProp : localeText.timePickerDefaultToolbarTitle;
    const theme = (0, $4nWZ9.default)();
    const showAmPmControl = Boolean(ampm && !ampmInClock);
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $ekk2W.useMeridiemMode)(parsedValue, ampm, onChange);
    const formatHours = (time)=>ampm ? utils.format(time, 'hours12h') : utils.format(time, 'hours24h');
    const ownerState = props;
    const classes = $3961f4b484c47d0d$var$useUtilityClasses((0, $eJfrs.default)({}, ownerState, {
        theme: theme
    }));
    const separator = /*#__PURE__*/ (0, $k4ank.jsx)($3961f4b484c47d0d$var$TimePickerToolbarSeparator, {
        tabIndex: -1,
        value: ":",
        variant: "h3",
        selected: false,
        className: classes.separator
    });
    return /*#__PURE__*/ (0, $k4ank.jsxs)($3961f4b484c47d0d$var$TimePickerToolbarRoot, (0, $eJfrs.default)({
        viewType: "clock",
        landscapeDirection: "row",
        toolbarTitle: toolbarTitle,
        isLandscape: isLandscape,
        isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
        toggleMobileKeyboardView: toggleMobileKeyboardView,
        ownerState: ownerState,
        className: classes.root
    }, other, {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)($3961f4b484c47d0d$var$TimePickerToolbarHourMinuteLabel, {
                className: classes.hourMinuteLabel,
                ownerState: ownerState,
                children: [
                    (0, $jsJJd.arrayIncludes)(views, 'hours') && /*#__PURE__*/ (0, $k4ank.jsx)((0, $0aWCC.PickersToolbarButton), {
                        tabIndex: -1,
                        variant: "h3",
                        onClick: ()=>setOpenView('hours'),
                        selected: openView === 'hours',
                        value: parsedValue ? formatHours(parsedValue) : '--'
                    }),
                    (0, $jsJJd.arrayIncludes)(views, [
                        'hours',
                        'minutes'
                    ]) && separator,
                    (0, $jsJJd.arrayIncludes)(views, 'minutes') && /*#__PURE__*/ (0, $k4ank.jsx)((0, $0aWCC.PickersToolbarButton), {
                        tabIndex: -1,
                        variant: "h3",
                        onClick: ()=>setOpenView('minutes'),
                        selected: openView === 'minutes',
                        value: parsedValue ? utils.format(parsedValue, 'minutes') : '--'
                    }),
                    (0, $jsJJd.arrayIncludes)(views, [
                        'minutes',
                        'seconds'
                    ]) && separator,
                    (0, $jsJJd.arrayIncludes)(views, 'seconds') && /*#__PURE__*/ (0, $k4ank.jsx)((0, $0aWCC.PickersToolbarButton), {
                        variant: "h3",
                        onClick: ()=>setOpenView('seconds'),
                        selected: openView === 'seconds',
                        value: parsedValue ? utils.format(parsedValue, 'seconds') : '--'
                    })
                ]
            }),
            showAmPmControl && /*#__PURE__*/ (0, $k4ank.jsxs)($3961f4b484c47d0d$var$TimePickerToolbarAmPmSelection, {
                className: classes.ampmSelection,
                ownerState: ownerState,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $0aWCC.PickersToolbarButton), {
                        disableRipple: true,
                        variant: "subtitle2",
                        selected: meridiemMode === 'am',
                        typographyClassName: classes.ampmLabel,
                        value: utils.getMeridiemText('am'),
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange('am'),
                        disabled: disabled
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $0aWCC.PickersToolbarButton), {
                        disableRipple: true,
                        variant: "subtitle2",
                        selected: meridiemMode === 'pm',
                        typographyClassName: classes.ampmLabel,
                        value: utils.getMeridiemText('pm'),
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange('pm'),
                        disabled: disabled
                    })
                ]
            })
        ]
    }));
}

});
parcelRegister("gdomg", function(module, exports) {

$parcel$export(module.exports, "PickersToolbarText", () => $bce0c13e9a7c1ef9$export$2006bc630443fa2);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $hIlXQ = parcelRequire("hIlXQ");

var $f3puC = parcelRequire("f3puC");

var $anJSP = parcelRequire("anJSP");

var $aYNpO = parcelRequire("aYNpO");

var $dconV = parcelRequire("dconV");

var $k4ank = parcelRequire("k4ank");
const $bce0c13e9a7c1ef9$var$_excluded = [
    "className",
    "selected",
    "value"
];
const $bce0c13e9a7c1ef9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $dconV.getPickersToolbarTextUtilityClass), classes);
};
const $bce0c13e9a7c1ef9$var$PickersToolbarTextRoot = (0, $anJSP.default)((0, $f3puC.default), {
    name: 'PrivatePickersToolbarText',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, $dconV.pickersToolbarTextClasses).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>({
        transition: theme.transitions.create('color'),
        color: theme.palette.text.secondary,
        [`&.${(0, $dconV.pickersToolbarTextClasses).selected}`]: {
            color: theme.palette.text.primary
        }
    }));
const $bce0c13e9a7c1ef9$export$2006bc630443fa2 = /*#__PURE__*/ $8T3gX.forwardRef(function PickersToolbarText(props, ref) {
    // TODO v6: add 'useThemeProps' once the component class names are aligned
    const { className: className, value: value } = props, other = (0, $fAJB5.default)(props, $bce0c13e9a7c1ef9$var$_excluded);
    const classes = $bce0c13e9a7c1ef9$var$useUtilityClasses(props);
    return /*#__PURE__*/ (0, $k4ank.jsx)($bce0c13e9a7c1ef9$var$PickersToolbarTextRoot, (0, $eJfrs.default)({
        ref: ref,
        className: (0, $hIlXQ.default)(className, classes.root),
        component: "span"
    }, other, {
        children: value
    }));
});

});
parcelRegister("hIlXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce57955be2e43c96$export$2e2bcd8739ae039);
function $ce57955be2e43c96$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $ce57955be2e43c96$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $ce57955be2e43c96$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $ce57955be2e43c96$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $ce57955be2e43c96$export$2e2bcd8739ae039 = $ce57955be2e43c96$export$4f5d2d50c9deca37;

});

parcelRegister("dconV", function(module, exports) {

$parcel$export(module.exports, "getPickersToolbarTextUtilityClass", () => $99bf4fb4a3abcc90$export$2aab7addfa1bc589);
$parcel$export(module.exports, "pickersToolbarTextClasses", () => $99bf4fb4a3abcc90$export$4ca7b92014bf2e56);

var $kfTYv = parcelRequire("kfTYv");
var $jh2Zm = parcelRequire("jh2Zm");
function $99bf4fb4a3abcc90$export$2aab7addfa1bc589(slot) {
    // TODO v6: Rename 'PrivatePickersToolbarText' to 'MuiPickersToolbarText' to follow convention
    return (0, $kfTYv.default)('PrivatePickersToolbarText', slot);
} // TODO v6: Rename 'PrivatePickersToolbarText' to 'MuiPickersToolbarText' to follow convention
const $99bf4fb4a3abcc90$export$4ca7b92014bf2e56 = (0, $jh2Zm.default)('PrivatePickersToolbarText', [
    'root',
    'selected'
]);

});


parcelRegister("0aWCC", function(module, exports) {

$parcel$export(module.exports, "PickersToolbarButton", () => $00087d8dfa1dd4d6$export$614ed940168c780c);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $hIlXQ = parcelRequire("hIlXQ");

var $a65wX = parcelRequire("a65wX");

var $anJSP = parcelRequire("anJSP");
var $4wdE9 = parcelRequire("4wdE9");

var $aYNpO = parcelRequire("aYNpO");

var $gdomg = parcelRequire("gdomg");

var $lwlpY = parcelRequire("lwlpY");

var $k4ank = parcelRequire("k4ank");
const $00087d8dfa1dd4d6$var$_excluded = [
    "align",
    "className",
    "selected",
    "typographyClassName",
    "value",
    "variant"
];
const $00087d8dfa1dd4d6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $lwlpY.getPickersToolbarUtilityClass), classes);
};
const $00087d8dfa1dd4d6$var$PickersToolbarButtonRoot = (0, $anJSP.default)((0, $a65wX.default), {
    name: 'MuiPickersToolbarButton',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({
    padding: 0,
    minWidth: 16,
    textTransform: 'none'
});
const $00087d8dfa1dd4d6$export$614ed940168c780c = /*#__PURE__*/ $8T3gX.forwardRef(function PickersToolbarButton(inProps, ref) {
    const props = (0, $4wdE9.default)({
        props: inProps,
        name: 'MuiPickersToolbarButton'
    });
    const { align: align, className: className, selected: selected, typographyClassName: typographyClassName, value: value, variant: variant } = props, other = (0, $fAJB5.default)(props, $00087d8dfa1dd4d6$var$_excluded);
    const classes = $00087d8dfa1dd4d6$var$useUtilityClasses(props);
    return /*#__PURE__*/ (0, $k4ank.jsx)($00087d8dfa1dd4d6$var$PickersToolbarButtonRoot, (0, $eJfrs.default)({
        variant: "text",
        ref: ref,
        className: (0, $hIlXQ.default)(className, classes.root)
    }, other, {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $gdomg.PickersToolbarText), {
            align: align,
            className: typographyClassName,
            variant: variant,
            value: value,
            selected: selected
        })
    }));
});

});
parcelRegister("lwlpY", function(module, exports) {

$parcel$export(module.exports, "getPickersToolbarUtilityClass", () => $faad33479d346baa$export$b109c489973c3d80);
$parcel$export(module.exports, "pickersToolbarClasses", () => $faad33479d346baa$export$59f09e5e2b3d9913);

var $kfTYv = parcelRequire("kfTYv");
var $jh2Zm = parcelRequire("jh2Zm");
function $faad33479d346baa$export$b109c489973c3d80(slot) {
    return (0, $kfTYv.default)('MuiPickersToolbar', slot);
}
const $faad33479d346baa$export$59f09e5e2b3d9913 = (0, $jh2Zm.default)('MuiPickersToolbar', [
    'root',
    'content',
    'penIconButton',
    'penIconButtonLandscape'
]);

});


parcelRegister("9o0Hh", function(module, exports) {

$parcel$export(module.exports, "PickersToolbar", () => $6d56e55f8b654a93$export$eb3c4d84783d6feb);

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $hIlXQ = parcelRequire("hIlXQ");

var $kQuj6 = parcelRequire("kQuj6");

var $f3puC = parcelRequire("f3puC");

var $iKAtE = parcelRequire("iKAtE");

var $anJSP = parcelRequire("anJSP");
var $4wdE9 = parcelRequire("4wdE9");

var $aYNpO = parcelRequire("aYNpO");

var $hIg9z = parcelRequire("hIg9z");

var $1hdeG = parcelRequire("1hdeG");

var $lwlpY = parcelRequire("lwlpY");

var $k4ank = parcelRequire("k4ank");
const $6d56e55f8b654a93$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isLandscape: isLandscape } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        content: [
            'content'
        ],
        penIconButton: [
            'penIconButton',
            isLandscape && 'penIconButtonLandscape'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $lwlpY.getPickersToolbarUtilityClass), classes);
};
const $6d56e55f8b654a93$var$PickersToolbarRoot = (0, $anJSP.default)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        padding: theme.spacing(2, 3)
    }, ownerState.isLandscape && {
        height: 'auto',
        maxWidth: 160,
        padding: 16,
        justifyContent: 'flex-start',
        flexWrap: 'wrap'
    }));
const $6d56e55f8b654a93$var$PickersToolbarContent = (0, $anJSP.default)((0, $kQuj6.default), {
    name: 'MuiPickersToolbar',
    slot: 'Content',
    overridesResolver: (props, styles)=>styles.content
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({
        flex: 1
    }, !ownerState.isLandscape && {
        alignItems: 'center'
    }));
const $6d56e55f8b654a93$var$PickersToolbarPenIconButton = (0, $anJSP.default)((0, $iKAtE.default), {
    name: 'MuiPickersToolbar',
    slot: 'PenIconButton',
    overridesResolver: (props, styles)=>[
            {
                [`&.${(0, $lwlpY.pickersToolbarClasses).penIconButtonLandscape}`]: styles.penIconButtonLandscape
            },
            styles.penIconButton
        ]
})({});
const $6d56e55f8b654a93$var$getViewTypeIcon = (viewType)=>viewType === 'clock' ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $hIg9z.Clock), {
        color: "inherit"
    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $hIg9z.Calendar), {
        color: "inherit"
    });
const $6d56e55f8b654a93$export$eb3c4d84783d6feb = /*#__PURE__*/ $8T3gX.forwardRef(function PickersToolbar(inProps, ref) {
    const props = (0, $4wdE9.default)({
        props: inProps,
        name: 'MuiPickersToolbar'
    });
    const { children: children, className: className, getMobileKeyboardInputViewButtonText: getMobileKeyboardInputViewButtonText, isLandscape: isLandscape, isMobileKeyboardViewOpen: isMobileKeyboardViewOpen, landscapeDirection: landscapeDirection = 'column', toggleMobileKeyboardView: toggleMobileKeyboardView, toolbarTitle: toolbarTitle, viewType: viewType = 'calendar' } = props;
    const ownerState = props;
    const localeText = (0, $1hdeG.useLocaleText)();
    const classes = $6d56e55f8b654a93$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsxs)($6d56e55f8b654a93$var$PickersToolbarRoot, {
        ref: ref,
        className: (0, $hIlXQ.default)(classes.root, className),
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                color: "text.secondary",
                variant: "overline",
                children: toolbarTitle
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)($6d56e55f8b654a93$var$PickersToolbarContent, {
                container: true,
                justifyContent: "space-between",
                className: classes.content,
                ownerState: ownerState,
                direction: isLandscape ? landscapeDirection : 'row',
                alignItems: isLandscape ? 'flex-start' : 'flex-end',
                children: [
                    children,
                    /*#__PURE__*/ (0, $k4ank.jsx)($6d56e55f8b654a93$var$PickersToolbarPenIconButton, {
                        onClick: toggleMobileKeyboardView,
                        className: classes.penIconButton,
                        ownerState: ownerState,
                        color: "inherit",
                        "aria-label": getMobileKeyboardInputViewButtonText ? getMobileKeyboardInputViewButtonText(isMobileKeyboardViewOpen, viewType) : localeText.inputModeToggleButtonAriaLabel(isMobileKeyboardViewOpen, viewType),
                        children: isMobileKeyboardViewOpen ? $6d56e55f8b654a93$var$getViewTypeIcon(viewType) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $hIg9z.Pen), {
                            color: "inherit"
                        })
                    })
                ]
            })
        ]
    });
});

});
parcelRegister("kQuj6", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2d02c52f17978d2$export$2e2bcd8739ae039);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $o68UK = parcelRequire("o68UK");

var $bmcE0 = parcelRequire("bmcE0");

var $aYNpO = parcelRequire("aYNpO");

var $giT3W = parcelRequire("giT3W");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $4nWZ9 = parcelRequire("4nWZ9");

var $9LSkM = parcelRequire("9LSkM");

var $9AEsf = parcelRequire("9AEsf");

var $k4ank = parcelRequire("k4ank");
'use client';
const $f2d02c52f17978d2$var$_excluded = [
    "className",
    "columns",
    "columnSpacing",
    "component",
    "container",
    "direction",
    "item",
    "rowSpacing",
    "spacing",
    "wrap",
    "zeroMinWidth"
];
function $f2d02c52f17978d2$var$getOffset(val) {
    const parse = parseFloat(val);
    return `${parse}${String(val).replace(String(parse), '') || 'px'}`;
}
function $f2d02c52f17978d2$export$ca2a698f6020fda({ theme: theme, ownerState: ownerState }) {
    let size;
    return theme.breakpoints.keys.reduce((globalStyles, breakpoint)=>{
        // Use side effect over immutability for better performance.
        let styles = {};
        if (ownerState[breakpoint]) size = ownerState[breakpoint];
        if (!size) return globalStyles;
        if (size === true) // For the auto layouting
        styles = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        else if (size === 'auto') styles = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        else {
            const columnsBreakpointValues = (0, $o68UK.resolveBreakpointValues)({
                values: ownerState.columns,
                breakpoints: theme.breakpoints.values
            });
            const columnValue = typeof columnsBreakpointValues === 'object' ? columnsBreakpointValues[breakpoint] : columnsBreakpointValues;
            if (columnValue === undefined || columnValue === null) return globalStyles;
            // Keep 7 significant numbers.
            const width = `${Math.round(size / columnValue * 10e7) / 10e5}%`;
            let more = {};
            if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
                const themeSpacing = theme.spacing(ownerState.columnSpacing);
                if (themeSpacing !== '0px') {
                    const fullWidth = `calc(${width} + ${$f2d02c52f17978d2$var$getOffset(themeSpacing)})`;
                    more = {
                        flexBasis: fullWidth,
                        maxWidth: fullWidth
                    };
                }
            }
            // Close to the bootstrap implementation:
            // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
            styles = (0, $eJfrs.default)({
                flexBasis: width,
                flexGrow: 0,
                maxWidth: width
            }, more);
        }
        // No need for a media query for the first size.
        if (theme.breakpoints.values[breakpoint] === 0) Object.assign(globalStyles, styles);
        else globalStyles[theme.breakpoints.up(breakpoint)] = styles;
        return globalStyles;
    }, {});
}
function $f2d02c52f17978d2$export$71d4225eeb1bc13e({ theme: theme, ownerState: ownerState }) {
    const directionValues = (0, $o68UK.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    });
    return (0, $o68UK.handleBreakpoints)({
        theme: theme
    }, directionValues, (propValue)=>{
        const output = {
            flexDirection: propValue
        };
        if (propValue.indexOf('column') === 0) output[`& > .${(0, $9AEsf.default).item}`] = {
            maxWidth: 'none'
        };
        return output;
    });
}
/**
 * Extracts zero value breakpoint keys before a non-zero value breakpoint key.
 * @example { xs: 0, sm: 0, md: 2, lg: 0, xl: 0 } or [0, 0, 2, 0, 0]
 * @returns [xs, sm]
 */ function $f2d02c52f17978d2$var$extractZeroValueBreakpointKeys({ breakpoints: breakpoints, values: values }) {
    let nonZeroKey = '';
    Object.keys(values).forEach((key)=>{
        if (nonZeroKey !== '') return;
        if (values[key] !== 0) nonZeroKey = key;
    });
    const sortedBreakpointKeysByValue = Object.keys(breakpoints).sort((a, b)=>{
        return breakpoints[a] - breakpoints[b];
    });
    return sortedBreakpointKeysByValue.slice(0, sortedBreakpointKeysByValue.indexOf(nonZeroKey));
}
function $f2d02c52f17978d2$export$380604d7c79f9e8f({ theme: theme, ownerState: ownerState }) {
    const { container: container, rowSpacing: rowSpacing } = ownerState;
    let styles = {};
    if (container && rowSpacing !== 0) {
        const rowSpacingValues = (0, $o68UK.resolveBreakpointValues)({
            values: rowSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof rowSpacingValues === 'object') zeroValueBreakpointKeys = $f2d02c52f17978d2$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: rowSpacingValues
        });
        styles = (0, $o68UK.handleBreakpoints)({
            theme: theme
        }, rowSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                marginTop: `-${$f2d02c52f17978d2$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $9AEsf.default).item}`]: {
                    paddingTop: $f2d02c52f17978d2$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK.includes(breakpoint)) return {};
            return {
                marginTop: 0,
                [`& > .${(0, $9AEsf.default).item}`]: {
                    paddingTop: 0
                }
            };
        });
    }
    return styles;
}
function $f2d02c52f17978d2$export$4315fba5128fb4a1({ theme: theme, ownerState: ownerState }) {
    const { container: container, columnSpacing: columnSpacing } = ownerState;
    let styles = {};
    if (container && columnSpacing !== 0) {
        const columnSpacingValues = (0, $o68UK.resolveBreakpointValues)({
            values: columnSpacing,
            breakpoints: theme.breakpoints.values
        });
        let zeroValueBreakpointKeys;
        if (typeof columnSpacingValues === 'object') zeroValueBreakpointKeys = $f2d02c52f17978d2$var$extractZeroValueBreakpointKeys({
            breakpoints: theme.breakpoints.values,
            values: columnSpacingValues
        });
        styles = (0, $o68UK.handleBreakpoints)({
            theme: theme
        }, columnSpacingValues, (propValue, breakpoint)=>{
            var _zeroValueBreakpointK2;
            const themeSpacing = theme.spacing(propValue);
            if (themeSpacing !== '0px') return {
                width: `calc(100% + ${$f2d02c52f17978d2$var$getOffset(themeSpacing)})`,
                marginLeft: `-${$f2d02c52f17978d2$var$getOffset(themeSpacing)}`,
                [`& > .${(0, $9AEsf.default).item}`]: {
                    paddingLeft: $f2d02c52f17978d2$var$getOffset(themeSpacing)
                }
            };
            if ((_zeroValueBreakpointK2 = zeroValueBreakpointKeys) != null && _zeroValueBreakpointK2.includes(breakpoint)) return {};
            return {
                width: '100%',
                marginLeft: 0,
                [`& > .${(0, $9AEsf.default).item}`]: {
                    paddingLeft: 0
                }
            };
        });
    }
    return styles;
}
function $f2d02c52f17978d2$export$4ffcd0b3420424d2(spacing, breakpoints, styles = {}) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        styles[`spacing-xs-${String(spacing)}`]
    ];
    // in case of object `spacing`
    const spacingStyles = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) spacingStyles.push(styles[`spacing-${breakpoint}-${String(value)}`]);
    });
    return spacingStyles;
}
// Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',
const $f2d02c52f17978d2$var$GridRoot = (0, $anJSP.default)('div', {
    name: 'MuiGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
        let spacingStyles = [];
        // in case of grid item
        if (container) spacingStyles = $f2d02c52f17978d2$export$4ffcd0b3420424d2(spacing, breakpoints, styles);
        const breakpointsStyles = [];
        breakpoints.forEach((breakpoint)=>{
            const value = ownerState[breakpoint];
            if (value) breakpointsStyles.push(styles[`grid-${breakpoint}-${String(value)}`]);
        });
        return [
            styles.root,
            container && styles.container,
            item && styles.item,
            zeroMinWidth && styles.zeroMinWidth,
            ...spacingStyles,
            direction !== 'row' && styles[`direction-xs-${String(direction)}`],
            wrap !== 'wrap' && styles[`wrap-xs-${String(wrap)}`],
            ...breakpointsStyles
        ];
    }
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({
        boxSizing: 'border-box'
    }, ownerState.container && {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%'
    }, ownerState.item && {
        margin: 0 // For instance, it's useful when used with a `figure` element.
    }, ownerState.zeroMinWidth && {
        minWidth: 0
    }, ownerState.wrap !== 'wrap' && {
        flexWrap: ownerState.wrap
    }), $f2d02c52f17978d2$export$71d4225eeb1bc13e, $f2d02c52f17978d2$export$380604d7c79f9e8f, $f2d02c52f17978d2$export$4315fba5128fb4a1, $f2d02c52f17978d2$export$ca2a698f6020fda);
function $f2d02c52f17978d2$export$2d1097e8e67cf24b(spacing, breakpoints) {
    // undefined/null or `spacing` <= 0
    if (!spacing || spacing <= 0) return [];
    // in case of string/number `spacing`
    if (typeof spacing === 'string' && !Number.isNaN(Number(spacing)) || typeof spacing === 'number') return [
        `spacing-xs-${String(spacing)}`
    ];
    // in case of object `spacing`
    const classes = [];
    breakpoints.forEach((breakpoint)=>{
        const value = spacing[breakpoint];
        if (Number(value) > 0) {
            const className = `spacing-${breakpoint}-${String(value)}`;
            classes.push(className);
        }
    });
    return classes;
}
const $f2d02c52f17978d2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, container: container, direction: direction, item: item, spacing: spacing, wrap: wrap, zeroMinWidth: zeroMinWidth, breakpoints: breakpoints } = ownerState;
    let spacingClasses = [];
    // in case of grid item
    if (container) spacingClasses = $f2d02c52f17978d2$export$2d1097e8e67cf24b(spacing, breakpoints);
    const breakpointsClasses = [];
    breakpoints.forEach((breakpoint)=>{
        const value = ownerState[breakpoint];
        if (value) breakpointsClasses.push(`grid-${breakpoint}-${String(value)}`);
    });
    const slots = {
        root: [
            'root',
            container && 'container',
            item && 'item',
            zeroMinWidth && 'zeroMinWidth',
            ...spacingClasses,
            direction !== 'row' && `direction-xs-${String(direction)}`,
            wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
            ...breakpointsClasses
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $9AEsf.getGridUtilityClass), classes);
};
const $f2d02c52f17978d2$var$Grid = /*#__PURE__*/ $8T3gX.forwardRef(function Grid(inProps, ref) {
    const themeProps = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiGrid'
    });
    const { breakpoints: breakpoints } = (0, $4nWZ9.default)();
    const props = (0, $bmcE0.default)(themeProps);
    const { className: className, columns: columnsProp, columnSpacing: columnSpacingProp, component: component = 'div', container: container = false, direction: direction = 'row', item: item = false, rowSpacing: rowSpacingProp, spacing: spacing = 0, wrap: wrap = 'wrap', zeroMinWidth: zeroMinWidth = false } = props, other = (0, $fAJB5.default)(props, $f2d02c52f17978d2$var$_excluded);
    const rowSpacing = rowSpacingProp || spacing;
    const columnSpacing = columnSpacingProp || spacing;
    const columnsContext = $8T3gX.useContext((0, $9LSkM.default));
    // columns set with default breakpoint unit of 12
    const columns = container ? columnsProp || 12 : columnsContext;
    const breakpointsValues = {};
    const otherFiltered = (0, $eJfrs.default)({}, other);
    breakpoints.keys.forEach((breakpoint)=>{
        if (other[breakpoint] != null) {
            breakpointsValues[breakpoint] = other[breakpoint];
            delete otherFiltered[breakpoint];
        }
    });
    const ownerState = (0, $eJfrs.default)({}, props, {
        columns: columns,
        container: container,
        direction: direction,
        item: item,
        rowSpacing: rowSpacing,
        columnSpacing: columnSpacing,
        wrap: wrap,
        zeroMinWidth: zeroMinWidth,
        spacing: spacing
    }, breakpointsValues, {
        breakpoints: breakpoints.keys
    });
    const classes = $f2d02c52f17978d2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $9LSkM.default).Provider, {
        value: columns,
        children: /*#__PURE__*/ (0, $k4ank.jsx)($f2d02c52f17978d2$var$GridRoot, (0, $eJfrs.default)({
            ownerState: ownerState,
            className: (0, $iVyaN.default)(classes.root, className),
            as: component,
            ref: ref
        }, otherFiltered))
    });
});
$f2d02c52f17978d2$var$Grid.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The number of columns.
   * @default 12
   */ columns: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */ columnSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */ container: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'row'
   */ direction: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'column-reverse',
            'column',
            'row-reverse',
            'row'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'column-reverse',
            'column',
            'row-reverse',
            'row'
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */ item: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `lg` breakpoint and wider screens if not overridden.
   * @default false
   */ lg: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'auto'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
    ]),
    /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `md` breakpoint and wider screens if not overridden.
   * @default false
   */ md: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'auto'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
    ]),
    /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */ rowSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `sm` breakpoint and wider screens if not overridden.
   * @default false
   */ sm: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'auto'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
    ]),
    /**
   * Defines the space between the type `item` components.
   * It can only be used on a type `container` component.
   * @default 0
   */ spacing: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * @default 'wrap'
   */ wrap: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'nowrap',
        'wrap-reverse',
        'wrap'
    ]),
    /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `xl` breakpoint and wider screens if not overridden.
   * @default false
   */ xl: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'auto'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
    ]),
    /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for all the screen sizes with the lowest priority.
   * @default false
   */ xs: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'auto'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
    ]),
    /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   * @default false
   */ zeroMinWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
};
{
    const requireProp = (0, $giT3W.default)('Grid', $f2d02c52f17978d2$var$Grid);
    // eslint-disable-next-line no-useless-concat
    $f2d02c52f17978d2$var$Grid["propTypes"] = (0, $eJfrs.default)({}, $f2d02c52f17978d2$var$Grid.propTypes, {
        direction: requireProp('container'),
        lg: requireProp('item'),
        md: requireProp('item'),
        sm: requireProp('item'),
        spacing: requireProp('container'),
        wrap: requireProp('container'),
        xs: requireProp('item'),
        zeroMinWidth: requireProp('item')
    });
}var $f2d02c52f17978d2$export$2e2bcd8739ae039 = $f2d02c52f17978d2$var$Grid;

});
parcelRegister("giT3W", function(module, exports) {

$parcel$export(module.exports, "default", () => $bde90a14b5704b04$export$2e2bcd8739ae039);

var $k3qXY = parcelRequire("k3qXY");
var $bde90a14b5704b04$export$2e2bcd8739ae039 = (0, $k3qXY.default);

});
parcelRegister("k3qXY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e999016d800fe676$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");
function $e999016d800fe676$export$2e2bcd8739ae039(componentNameInError, Component) {
    // eslint-disable-next-line react/forbid-foreign-prop-types
    const prevPropTypes = Component ? (0, $eJfrs.default)({}, Component.propTypes) : null;
    const requireProp = (requiredProp)=>(props, propName, componentName, location, propFullName, ...args)=>{
            const propFullNameSafe = propFullName || propName;
            const defaultTypeChecker = prevPropTypes == null ? void 0 : prevPropTypes[propFullNameSafe];
            if (defaultTypeChecker) {
                const typeCheckerResult = defaultTypeChecker(props, propName, componentName, location, propFullName, ...args);
                if (typeCheckerResult) return typeCheckerResult;
            }
            if (typeof props[propName] !== 'undefined' && !props[requiredProp]) return new Error(`The prop \`${propFullNameSafe}\` of ` + `\`${componentNameInError}\` can only be used together with the \`${requiredProp}\` prop.`);
            return null;
        };
    return requireProp;
}

});


parcelRegister("9LSkM", function(module, exports) {

$parcel$export(module.exports, "default", () => $71d2a6757c1ac7fb$export$2e2bcd8739ae039);

var $8T3gX = parcelRequire("8T3gX");
'use client';
/**
 * @ignore - internal component.
 */ const $71d2a6757c1ac7fb$var$GridContext = /*#__PURE__*/ $8T3gX.createContext();
$71d2a6757c1ac7fb$var$GridContext.displayName = 'GridContext';
var $71d2a6757c1ac7fb$export$2e2bcd8739ae039 = $71d2a6757c1ac7fb$var$GridContext;

});

parcelRegister("9AEsf", function(module, exports) {

$parcel$export(module.exports, "getGridUtilityClass", () => $6fb6db4edc5cdda4$export$9973ac5fd0181f33);
$parcel$export(module.exports, "default", () => $6fb6db4edc5cdda4$export$2e2bcd8739ae039);

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $6fb6db4edc5cdda4$export$9973ac5fd0181f33(slot) {
    return (0, $kfTYv.default)('MuiGrid', slot);
}
const $6fb6db4edc5cdda4$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $6fb6db4edc5cdda4$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $6fb6db4edc5cdda4$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $6fb6db4edc5cdda4$var$GRID_SIZES = [
    'auto',
    true,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $6fb6db4edc5cdda4$var$gridClasses = (0, $jh2Zm.default)('MuiGrid', [
    'root',
    'container',
    'item',
    'zeroMinWidth',
    // spacings
    ...$6fb6db4edc5cdda4$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$6fb6db4edc5cdda4$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$6fb6db4edc5cdda4$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$6fb6db4edc5cdda4$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$6fb6db4edc5cdda4$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$6fb6db4edc5cdda4$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$6fb6db4edc5cdda4$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$6fb6db4edc5cdda4$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $6fb6db4edc5cdda4$export$2e2bcd8739ae039 = $6fb6db4edc5cdda4$var$gridClasses;

});



parcelRegister("jsJJd", function(module, exports) {

$parcel$export(module.exports, "arrayIncludes", () => $e2b41a8706d0cb99$export$22012a5c726bef55);
$parcel$export(module.exports, "onSpaceOrEnter", () => $e2b41a8706d0cb99$export$4467fe8634707c85);
$parcel$export(module.exports, "getActiveElement", () => $e2b41a8706d0cb99$export$cd4e5573fbe2b576);
/* Use it instead of .includes method for IE support */ function $e2b41a8706d0cb99$export$22012a5c726bef55(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every((item)=>array.indexOf(item) !== -1);
    return array.indexOf(itemOrItems) !== -1;
}
const $e2b41a8706d0cb99$export$4467fe8634707c85 = (innerFn, onFocus)=>(event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            innerFn(event); // prevent any side effects
            event.preventDefault();
            event.stopPropagation();
        }
        if (onFocus) onFocus(event);
    };
const $e2b41a8706d0cb99$export$2e03bc8dde24716b = (fn)=>{
    setTimeout(fn, 0);
};
const $e2b41a8706d0cb99$export$b3007168329c29c7 = ()=>{}; // https://www.abeautifulsite.net/posts/finding-the-active-element-in-a-shadow-root/
const $e2b41a8706d0cb99$export$cd4e5573fbe2b576 = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $e2b41a8706d0cb99$export$cd4e5573fbe2b576(activeEl.shadowRoot);
    return activeEl;
};

});

parcelRegister("ekk2W", function(module, exports) {

$parcel$export(module.exports, "useNextMonthDisabled", () => $a6e27bbc5238c1eb$export$923e8cc135843169);
$parcel$export(module.exports, "usePreviousMonthDisabled", () => $a6e27bbc5238c1eb$export$3b46d38ff4932cf7);
$parcel$export(module.exports, "useMeridiemMode", () => $a6e27bbc5238c1eb$export$6aaabc31cb076d17);

var $8T3gX = parcelRequire("8T3gX");

var $1hdeG = parcelRequire("1hdeG");

var $gA4XU = parcelRequire("gA4XU");
function $a6e27bbc5238c1eb$export$923e8cc135843169(month, { disableFuture: disableFuture, maxDate: maxDate }) {
    const utils = (0, $1hdeG.useUtils)();
    return $8T3gX.useMemo(()=>{
        const now = utils.date();
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        return !utils.isAfter(lastEnabledMonth, month);
    }, [
        disableFuture,
        maxDate,
        month,
        utils
    ]);
}
function $a6e27bbc5238c1eb$export$3b46d38ff4932cf7(month, { disablePast: disablePast, minDate: minDate }) {
    const utils = (0, $1hdeG.useUtils)();
    return $8T3gX.useMemo(()=>{
        const now = utils.date();
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        return !utils.isBefore(firstEnabledMonth, month);
    }, [
        disablePast,
        minDate,
        month,
        utils
    ]);
}
function $a6e27bbc5238c1eb$export$6aaabc31cb076d17(date, ampm, onChange) {
    const utils = (0, $1hdeG.useUtils)();
    const meridiemMode = (0, $gA4XU.getMeridiem)(date, utils);
    const handleMeridiemChange = $8T3gX.useCallback((mode)=>{
        const timeWithMeridiem = date == null ? null : (0, $gA4XU.convertToMeridiem)(date, mode, Boolean(ampm), utils);
        onChange(timeWithMeridiem, 'partial');
    }, [
        ampm,
        date,
        onChange,
        utils
    ]);
    return {
        meridiemMode: meridiemMode,
        handleMeridiemChange: handleMeridiemChange
    };
}

});
parcelRegister("gA4XU", function(module, exports) {

$parcel$export(module.exports, "getMeridiem", () => $c123dc23e6f51dd4$export$c3352ead7b032236);
$parcel$export(module.exports, "convertValueToMeridiem", () => $c123dc23e6f51dd4$export$4159dc823695870e);
$parcel$export(module.exports, "convertToMeridiem", () => $c123dc23e6f51dd4$export$c368d4ff66779998);
$parcel$export(module.exports, "createIsAfterIgnoreDatePart", () => $c123dc23e6f51dd4$export$fb87c80b35a46b89);
const $c123dc23e6f51dd4$export$c3352ead7b032236 = (date, utils)=>{
    if (!date) return null;
    return utils.getHours(date) >= 12 ? 'pm' : 'am';
};
const $c123dc23e6f51dd4$export$4159dc823695870e = (value, meridiem, ampm)=>{
    if (ampm) {
        const currentMeridiem = value >= 12 ? 'pm' : 'am';
        if (currentMeridiem !== meridiem) return meridiem === 'am' ? value - 12 : value + 12;
    }
    return value;
};
const $c123dc23e6f51dd4$export$c368d4ff66779998 = (time, meridiem, ampm, utils)=>{
    const newHoursAmount = $c123dc23e6f51dd4$export$4159dc823695870e(utils.getHours(time), meridiem, ampm);
    return utils.setHours(time, newHoursAmount);
};
const $c123dc23e6f51dd4$export$888a1ce13aa61986 = (date, utils)=>{
    return utils.getHours(date) * 3600 + utils.getMinutes(date) * 60 + utils.getSeconds(date);
};
const $c123dc23e6f51dd4$export$fb87c80b35a46b89 = (disableIgnoringDatePartForTimeValidation = false, utils)=>(dateLeft, dateRight)=>{
        if (disableIgnoringDatePartForTimeValidation) return utils.isAfter(dateLeft, dateRight);
        return $c123dc23e6f51dd4$export$888a1ce13aa61986(dateLeft, utils) > $c123dc23e6f51dd4$export$888a1ce13aa61986(dateRight, utils);
    };

});


parcelRegister("gF1hK", function(module, exports) {

$parcel$export(module.exports, "getTimePickerToolbarUtilityClass", () => $c21178e30602c776$export$56e751cdf7deddcb);
$parcel$export(module.exports, "timePickerToolbarClasses", () => $c21178e30602c776$export$b6febfcac6caa550);

var $kfTYv = parcelRequire("kfTYv");
var $jh2Zm = parcelRequire("jh2Zm");
function $c21178e30602c776$export$56e751cdf7deddcb(slot) {
    return (0, $kfTYv.default)('MuiTimePickerToolbar', slot);
}
const $c21178e30602c776$export$b6febfcac6caa550 = (0, $jh2Zm.default)('MuiTimePickerToolbar', [
    'root',
    'separator',
    'hourMinuteLabel',
    'hourMinuteLabelLandscape',
    'hourMinuteLabelReverse',
    'ampmSelection',
    'ampmLandscape',
    'ampmLabel'
]);

});


parcelRegister("2WcNZ", function(module, exports) {

$parcel$export(module.exports, "DesktopWrapper", () => $223aee6fd019257e$export$f368505c531184b6);

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $11ydL = parcelRequire("11ydL");

var $kneyk = parcelRequire("kneyk");

var $6gYFp = parcelRequire("6gYFp");

var $k4ank = parcelRequire("k4ank");
function $223aee6fd019257e$export$f368505c531184b6(props) {
    const { children: children, DateInputProps: DateInputProps, KeyboardDateInputComponent: KeyboardDateInputComponent, onClear: onClear, onDismiss: onDismiss, onCancel: onCancel, onAccept: onAccept, onSetToday: onSetToday, open: open, PopperProps: PopperProps, PaperProps: PaperProps, TransitionComponent: TransitionComponent, components: components, componentsProps: componentsProps } = props;
    const ownInputRef = $8T3gX.useRef(null);
    const inputRef = (0, $11ydL.default)(DateInputProps.inputRef, ownInputRef);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kneyk.WrapperVariantContext).Provider, {
        value: "desktop",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)(KeyboardDateInputComponent, (0, $eJfrs.default)({}, DateInputProps, {
                inputRef: inputRef
            })),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $6gYFp.PickersPopper), {
                role: "dialog",
                open: open,
                anchorEl: ownInputRef.current,
                TransitionComponent: TransitionComponent,
                PopperProps: PopperProps,
                PaperProps: PaperProps,
                onClose: onDismiss,
                onCancel: onCancel,
                onClear: onClear,
                onAccept: onAccept,
                onSetToday: onSetToday,
                components: components,
                componentsProps: componentsProps,
                children: children
            })
        ]
    });
}

});
parcelRegister("kneyk", function(module, exports) {

$parcel$export(module.exports, "WrapperVariantContext", () => $ed513e7f8a219d13$export$b4ddd57e25df14cc);

var $8T3gX = parcelRequire("8T3gX");
const $ed513e7f8a219d13$export$b4ddd57e25df14cc = /*#__PURE__*/ $8T3gX.createContext(null);

});

parcelRegister("6gYFp", function(module, exports) {

$parcel$export(module.exports, "PickersPopper", () => $49134bdefd531cb4$export$96ce8482474de8a5);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $6CjWJ = parcelRequire("6CjWJ");

var $4reBM = parcelRequire("4reBM");

var $cWqfz = parcelRequire("cWqfz");

var $72B8o = parcelRequire("72B8o");

var $lAhWb = parcelRequire("lAhWb");
var $7F3bH = parcelRequire("7F3bH");
var $11ydL = parcelRequire("11ydL");

var $anJSP = parcelRequire("anJSP");
var $4wdE9 = parcelRequire("4wdE9");

var $aYNpO = parcelRequire("aYNpO");

var $3MTyF = parcelRequire("3MTyF");

var $e9dA2 = parcelRequire("e9dA2");

var $jsJJd = parcelRequire("jsJJd");

var $k4ank = parcelRequire("k4ank");
const $49134bdefd531cb4$var$_excluded = [
    "onClick",
    "onTouchStart"
];
const $49134bdefd531cb4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $e9dA2.getPickersPopperUtilityClass), classes);
};
const $49134bdefd531cb4$var$PickersPopperRoot = (0, $anJSP.default)((0, $cWqfz.default), {
    name: 'MuiPickersPopper',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        zIndex: theme.zIndex.modal
    }));
const $49134bdefd531cb4$var$PickersPopperPaper = (0, $anJSP.default)((0, $4reBM.default), {
    name: 'MuiPickersPopper',
    slot: 'Paper',
    overridesResolver: (_, styles)=>styles.paper
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({
        transformOrigin: 'top center',
        outline: 0
    }, ownerState.placement === 'top' && {
        transformOrigin: 'bottom center'
    }));
function $49134bdefd531cb4$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Based on @mui/material/ClickAwayListener without the customization.
 * We can probably strip away even more since children won't be portaled.
 * @param {boolean} active Only listen to clicks when the popper is opened.
 * @param {(event: MouseEvent | TouchEvent) => void} onClickAway The callback to call when clicking outside the popper.
 * @returns {Array} The ref and event handler to listen to the outside clicks.
 */ function $49134bdefd531cb4$var$useClickAwayListener(active, onClickAway) {
    const movedRef = $8T3gX.useRef(false);
    const syntheticEventRef = $8T3gX.useRef(false);
    const nodeRef = $8T3gX.useRef(null);
    const activatedRef = $8T3gX.useRef(false);
    $8T3gX.useEffect(()=>{
        if (!active) return undefined;
         // Ensure that this hook is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        function armClickAwayListener() {
            activatedRef.current = true;
        }
        document.addEventListener('mousedown', armClickAwayListener, true);
        document.addEventListener('touchstart', armClickAwayListener, true);
        return ()=>{
            document.removeEventListener('mousedown', armClickAwayListener, true);
            document.removeEventListener('touchstart', armClickAwayListener, true);
            activatedRef.current = false;
        };
    }, [
        active
    ]); // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $7F3bH.default)((event)=>{
        if (!activatedRef.current) return;
         // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $lAhWb.default)(nodeRef.current); // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!nodeRef.current || // is a TouchEvent?
        'clientX' in event && $49134bdefd531cb4$var$clickedRootScrollbar(event, doc)) return;
         // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        if (!insideDOM && !insideReactTree) onClickAway(event);
    }); // Keep track of mouse/touch events that bubbled up through the portal.
    const handleSynthetic = ()=>{
        syntheticEventRef.current = true;
    };
    $8T3gX.useEffect(()=>{
        if (active) {
            const doc = (0, $lAhWb.default)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener('touchstart', handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener('touchstart', handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    $8T3gX.useEffect(()=>{
        // TODO This behavior is not tested automatically
        // It's unclear whether this is due to different update semantics in test (batched in act() vs discrete on click).
        // Or if this is a timing related issues due to different Transition components
        // Once we get rid of all the manual scheduling (e.g. setTimeout(update, 0)) we can revisit this code+test.
        if (active) {
            const doc = (0, $lAhWb.default)(nodeRef.current);
            doc.addEventListener('click', handleClickAway);
            return ()=>{
                doc.removeEventListener('click', handleClickAway); // cleanup `handleClickAway`
                syntheticEventRef.current = false;
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    return [
        nodeRef,
        handleSynthetic,
        handleSynthetic
    ];
}
function $49134bdefd531cb4$export$96ce8482474de8a5(inProps) {
    var _components$ActionBar;
    const props = (0, $4wdE9.default)({
        props: inProps,
        name: 'MuiPickersPopper'
    });
    const { anchorEl: anchorEl, children: children, containerRef: containerRef = null, onBlur: onBlur, onClose: onClose, onClear: onClear, onAccept: onAccept, onCancel: onCancel, onSetToday: onSetToday, open: open, PopperProps: PopperProps, role: role, TransitionComponent: TransitionComponent = (0, $6CjWJ.default), TrapFocusProps: TrapFocusProps, PaperProps: PaperProps = {}, components: components, componentsProps: componentsProps } = props;
    $8T3gX.useEffect(()=>{
        function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (open && (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc')) onClose();
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        onClose,
        open
    ]);
    const lastFocusedElementRef = $8T3gX.useRef(null);
    $8T3gX.useEffect(()=>{
        if (role === 'tooltip') return;
        if (open) lastFocusedElementRef.current = (0, $jsJJd.getActiveElement)(document);
        else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) // make sure the button is flushed with updated label, before returning focus to it
        // avoids issue, where screen reader could fail to announce selected date after selection
        setTimeout(()=>{
            if (lastFocusedElementRef.current instanceof HTMLElement) lastFocusedElementRef.current.focus();
        });
    }, [
        open,
        role
    ]);
    const [clickAwayRef, onPaperClick, onPaperTouchStart] = $49134bdefd531cb4$var$useClickAwayListener(open, onBlur != null ? onBlur : onClose);
    const paperRef = $8T3gX.useRef(null);
    const handleRef = (0, $11ydL.default)(paperRef, containerRef);
    const handlePaperRef = (0, $11ydL.default)(handleRef, clickAwayRef);
    const ownerState = props;
    const classes = $49134bdefd531cb4$var$useUtilityClasses(ownerState);
    const { onClick: onPaperClickProp, onTouchStart: onPaperTouchStartProp } = PaperProps, otherPaperProps = (0, $fAJB5.default)(PaperProps, $49134bdefd531cb4$var$_excluded);
    const handleKeyDown = (event)=>{
        if (event.key === 'Escape') {
            // stop the propagation to avoid closing parent modal
            event.stopPropagation();
            onClose();
        }
    };
    const ActionBar = (_components$ActionBar = components == null ? void 0 : components.ActionBar) != null ? _components$ActionBar : (0, $3MTyF.PickersActionBar);
    const PaperContent = (components == null ? void 0 : components.PaperContent) || $8T3gX.Fragment;
    return /*#__PURE__*/ (0, $k4ank.jsx)($49134bdefd531cb4$var$PickersPopperRoot, (0, $eJfrs.default)({
        transition: true,
        role: role,
        open: open,
        anchorEl: anchorEl,
        onKeyDown: handleKeyDown,
        className: classes.root
    }, PopperProps, {
        children: ({ TransitionProps: TransitionProps, placement: placement })=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $72B8o.default), (0, $eJfrs.default)({
                open: open,
                disableAutoFocus: true // pickers are managing focus position manually
                ,
                disableRestoreFocus: true,
                disableEnforceFocus: role === 'tooltip',
                isEnabled: ()=>true
            }, TrapFocusProps, {
                children: /*#__PURE__*/ (0, $k4ank.jsx)(TransitionComponent, (0, $eJfrs.default)({}, TransitionProps, {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)($49134bdefd531cb4$var$PickersPopperPaper, (0, $eJfrs.default)({
                        tabIndex: -1,
                        elevation: 8,
                        ref: handlePaperRef,
                        onClick: (event)=>{
                            onPaperClick(event);
                            if (onPaperClickProp) onPaperClickProp(event);
                        },
                        onTouchStart: (event)=>{
                            onPaperTouchStart(event);
                            if (onPaperTouchStartProp) onPaperTouchStartProp(event);
                        },
                        ownerState: (0, $eJfrs.default)({}, ownerState, {
                            placement: placement
                        }),
                        className: classes.paper
                    }, otherPaperProps, {
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)(PaperContent, (0, $eJfrs.default)({}, componentsProps == null ? void 0 : componentsProps.paperContent, {
                            children: [
                                children,
                                /*#__PURE__*/ (0, $k4ank.jsx)(ActionBar, (0, $eJfrs.default)({
                                    onAccept: onAccept,
                                    onClear: onClear,
                                    onCancel: onCancel,
                                    onSetToday: onSetToday,
                                    actions: []
                                }, componentsProps == null ? void 0 : componentsProps.actionBar))
                            ]
                        }))
                    }))
                }))
            }))
    }));
}

});
parcelRegister("3MTyF", function(module, exports) {

$parcel$export(module.exports, "PickersActionBar", () => $2c20f37b4184af20$export$72ffda3bb7ecf665);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $a65wX = parcelRequire("a65wX");

var $887xF = parcelRequire("887xF");

var $1hdeG = parcelRequire("1hdeG");

var $kneyk = parcelRequire("kneyk");

var $k4ank = parcelRequire("k4ank");
const $2c20f37b4184af20$var$_excluded = [
    "onAccept",
    "onClear",
    "onCancel",
    "onSetToday",
    "actions"
];
const $2c20f37b4184af20$export$72ffda3bb7ecf665 = (props)=>{
    const { onAccept: onAccept, onClear: onClear, onCancel: onCancel, onSetToday: onSetToday, actions: actions } = props, other = (0, $fAJB5.default)(props, $2c20f37b4184af20$var$_excluded);
    const wrapperVariant = $8T3gX.useContext((0, $kneyk.WrapperVariantContext));
    const localeText = (0, $1hdeG.useLocaleText)();
    const actionsArray = typeof actions === 'function' ? actions(wrapperVariant) : actions;
    if (actionsArray == null || actionsArray.length === 0) return null;
    const buttons = actionsArray == null ? void 0 : actionsArray.map((actionType)=>{
        switch(actionType){
            case 'clear':
                return /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                    onClick: onClear,
                    children: localeText.clearButtonLabel
                }, actionType);
            case 'cancel':
                return /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                    onClick: onCancel,
                    children: localeText.cancelButtonLabel
                }, actionType);
            case 'accept':
                return /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                    onClick: onAccept,
                    children: localeText.okButtonLabel
                }, actionType);
            case 'today':
                return /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                    onClick: onSetToday,
                    children: localeText.todayButtonLabel
                }, actionType);
            default:
                return null;
        }
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), (0, $eJfrs.default)({}, other, {
        children: buttons
    }));
};

});

parcelRegister("e9dA2", function(module, exports) {

$parcel$export(module.exports, "getPickersPopperUtilityClass", () => $a4cc70ba97c25437$export$5519b4d4bf80ce6f);

var $kfTYv = parcelRequire("kfTYv");
var $jh2Zm = parcelRequire("jh2Zm");
function $a4cc70ba97c25437$export$5519b4d4bf80ce6f(slot) {
    return (0, $kfTYv.default)('MuiPickersPopper', slot);
}
const $a4cc70ba97c25437$export$46e9184c9b1af0ce = (0, $jh2Zm.default)('MuiPickersPopper', [
    'root',
    'paper'
]);

});



parcelRegister("gE5dt", function(module, exports) {

$parcel$export(module.exports, "CalendarOrClockPicker", () => $c1e46d9f06cc8b20$export$1565360330d80aaf);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $anJSP = parcelRequire("anJSP");
var $4wdE9 = parcelRequire("4wdE9");

var $aYNpO = parcelRequire("aYNpO");

var $5T1k5 = parcelRequire("5T1k5");

var $2mbSs = parcelRequire("2mbSs");

var $9uYlC = parcelRequire("9uYlC");

var $01RPl = parcelRequire("01RPl");

var $a3xeE = parcelRequire("a3xeE");

var $kneyk = parcelRequire("kneyk");

var $J7AIr = parcelRequire("J7AIr");

var $gXmr1 = parcelRequire("gXmr1");

var $kUteV = parcelRequire("kUteV");

var $k4ank = parcelRequire("k4ank");
const $c1e46d9f06cc8b20$var$_excluded = [
    "autoFocus",
    "className",
    "parsedValue",
    "DateInputProps",
    "isMobileKeyboardViewOpen",
    "onDateChange",
    "onViewChange",
    "openTo",
    "orientation",
    "showToolbar",
    "toggleMobileKeyboardView",
    "ToolbarComponent",
    "toolbarFormat",
    "toolbarPlaceholder",
    "toolbarTitle",
    "views",
    "dateRangeIcon",
    "timeIcon",
    "hideTabs",
    "classes"
];
const $c1e46d9f06cc8b20$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        mobileKeyboardInputView: [
            'mobileKeyboardInputView'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $kUteV.getCalendarOrClockPickerUtilityClass), classes);
};
const $c1e46d9f06cc8b20$export$739a903982fd73c9 = (0, $anJSP.default)('div', {
    name: 'MuiCalendarOrClockPicker',
    slot: 'MobileKeyboardInputView',
    overridesResolver: (_, styles)=>styles.mobileKeyboardInputView
})({
    padding: '16px 24px'
});
const $c1e46d9f06cc8b20$var$PickerRoot = (0, $anJSP.default)('div', {
    name: 'MuiCalendarOrClockPicker',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({
        display: 'flex',
        flexDirection: 'column'
    }, ownerState.isLandscape && {
        flexDirection: 'row'
    }));
const $c1e46d9f06cc8b20$var$MobileKeyboardTextFieldProps = {
    fullWidth: true
};
const $c1e46d9f06cc8b20$var$isDatePickerView = (view)=>view === 'year' || view === 'month' || view === 'day';
const $c1e46d9f06cc8b20$var$isTimePickerView = (view)=>view === 'hours' || view === 'minutes' || view === 'seconds';
let $c1e46d9f06cc8b20$var$warnedOnceNotValidOpenTo = false;
function $c1e46d9f06cc8b20$export$1565360330d80aaf(inProps) {
    var _other$components, _other$componentsProp;
    const props = (0, $4wdE9.default)({
        props: inProps,
        name: 'MuiCalendarOrClockPicker'
    });
    const { autoFocus: autoFocus, parsedValue: parsedValue, DateInputProps: DateInputProps, isMobileKeyboardViewOpen: isMobileKeyboardViewOpen, onDateChange: onDateChange, onViewChange: onViewChange, openTo: openTo, orientation: orientation, showToolbar: showToolbar, toggleMobileKeyboardView: toggleMobileKeyboardView, ToolbarComponent: ToolbarComponent = ()=>null, toolbarFormat: toolbarFormat, toolbarPlaceholder: toolbarPlaceholder, toolbarTitle: toolbarTitle, views: views, dateRangeIcon: dateRangeIcon, timeIcon: timeIcon, hideTabs: hideTabs } = props, other = (0, $fAJB5.default)(props, $c1e46d9f06cc8b20$var$_excluded);
    const TabsComponent = (_other$components = other.components) == null ? void 0 : _other$components.Tabs;
    const isLandscape = (0, $a3xeE.useIsLandscape)(views, orientation);
    const wrapperVariant = $8T3gX.useContext((0, $kneyk.WrapperVariantContext));
    const classes = $c1e46d9f06cc8b20$var$useUtilityClasses(props);
    const toShowToolbar = showToolbar != null ? showToolbar : wrapperVariant !== 'desktop';
    const showTabs = !hideTabs && typeof window !== 'undefined' && window.innerHeight > 667;
    const handleDateChange = $8T3gX.useCallback((newDate, selectionState)=>{
        onDateChange(newDate, wrapperVariant, selectionState);
    }, [
        onDateChange,
        wrapperVariant
    ]);
    const handleViewChange = $8T3gX.useCallback((newView)=>{
        if (isMobileKeyboardViewOpen) toggleMobileKeyboardView();
        if (onViewChange) onViewChange(newView);
    }, [
        isMobileKeyboardViewOpen,
        onViewChange,
        toggleMobileKeyboardView
    ]);
    if (!$c1e46d9f06cc8b20$var$warnedOnceNotValidOpenTo && !views.includes(openTo)) {
        console.warn(`MUI: \`openTo="${openTo}"\` is not a valid prop.`, `It must be an element of \`views=["${views.join('", "')}"]\`.`);
        $c1e46d9f06cc8b20$var$warnedOnceNotValidOpenTo = true;
    }
    const { openView: openView, setOpenView: setOpenView, handleChangeAndOpenNext: handleChangeAndOpenNext } = (0, $5T1k5.useViews)({
        view: undefined,
        views: views,
        openTo: openTo,
        onChange: handleDateChange,
        onViewChange: handleViewChange
    });
    const { focusedView: focusedView, setFocusedView: setFocusedView } = (0, $gXmr1.useFocusManagement)({
        autoFocus: autoFocus,
        openView: openView
    });
    return /*#__PURE__*/ (0, $k4ank.jsxs)($c1e46d9f06cc8b20$var$PickerRoot, {
        ownerState: {
            isLandscape: isLandscape
        },
        className: classes.root,
        children: [
            toShowToolbar && /*#__PURE__*/ (0, $k4ank.jsx)(ToolbarComponent, (0, $eJfrs.default)({}, other, {
                views: views,
                isLandscape: isLandscape,
                parsedValue: parsedValue,
                onChange: handleDateChange,
                setOpenView: setOpenView,
                openView: openView,
                toolbarTitle: toolbarTitle,
                toolbarFormat: toolbarFormat,
                toolbarPlaceholder: toolbarPlaceholder,
                isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
                toggleMobileKeyboardView: toggleMobileKeyboardView
            })),
            showTabs && !!TabsComponent && /*#__PURE__*/ (0, $k4ank.jsx)(TabsComponent, (0, $eJfrs.default)({
                dateRangeIcon: dateRangeIcon,
                timeIcon: timeIcon,
                view: openView,
                onChange: setOpenView
            }, (_other$componentsProp = other.componentsProps) == null ? void 0 : _other$componentsProp.tabs)),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $J7AIr.PickerViewRoot), {
                children: isMobileKeyboardViewOpen ? /*#__PURE__*/ (0, $k4ank.jsx)($c1e46d9f06cc8b20$export$739a903982fd73c9, {
                    className: classes.mobileKeyboardInputView,
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $01RPl.KeyboardDateInput), (0, $eJfrs.default)({}, DateInputProps, {
                        ignoreInvalidInputs: true,
                        disableOpenPicker: true,
                        TextFieldProps: $c1e46d9f06cc8b20$var$MobileKeyboardTextFieldProps
                    }))
                }) : /*#__PURE__*/ (0, $k4ank.jsxs)($8T3gX.Fragment, {
                    children: [
                        $c1e46d9f06cc8b20$var$isDatePickerView(openView) && /*#__PURE__*/ (0, $k4ank.jsx)((0, $9uYlC.CalendarPicker), (0, $eJfrs.default)({
                            autoFocus: autoFocus,
                            date: parsedValue,
                            onViewChange: setOpenView,
                            onChange: handleChangeAndOpenNext,
                            view: openView // Unclear why the predicate `isDatePickerView` does not imply the casted type
                            ,
                            views: views.filter($c1e46d9f06cc8b20$var$isDatePickerView),
                            focusedView: focusedView,
                            onFocusedViewChange: setFocusedView
                        }, other)),
                        $c1e46d9f06cc8b20$var$isTimePickerView(openView) && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2mbSs.ClockPicker), (0, $eJfrs.default)({}, other, {
                            autoFocus: autoFocus,
                            date: parsedValue,
                            view: openView // Unclear why the predicate `isDatePickerView` does not imply the casted type
                            ,
                            views: views.filter($c1e46d9f06cc8b20$var$isTimePickerView),
                            onChange: handleChangeAndOpenNext,
                            onViewChange: setOpenView,
                            showViewSwitcher: wrapperVariant === 'desktop'
                        }))
                    ]
                })
            })
        ]
    });
}

});
parcelRegister("5T1k5", function(module, exports) {

$parcel$export(module.exports, "useViews", () => $44931d8b4f5ad936$export$9b46cba8f8ccd954);

var $8T3gX = parcelRequire("8T3gX");

var $7Wcl5 = parcelRequire("7Wcl5");

var $jsJJd = parcelRequire("jsJJd");
function $44931d8b4f5ad936$export$9b46cba8f8ccd954({ onChange: onChange, onViewChange: onViewChange, openTo: openTo, view: view, views: views }) {
    var _views, _views2;
    const [openView, setOpenView] = (0, $7Wcl5.default)({
        name: 'Picker',
        state: 'view',
        controlled: view,
        default: openTo && (0, $jsJJd.arrayIncludes)(views, openTo) ? openTo : views[0]
    });
    const previousView = (_views = views[views.indexOf(openView) - 1]) != null ? _views : null;
    const nextView = (_views2 = views[views.indexOf(openView) + 1]) != null ? _views2 : null;
    const changeView = $8T3gX.useCallback((newView)=>{
        setOpenView(newView);
        if (onViewChange) onViewChange(newView);
    }, [
        setOpenView,
        onViewChange
    ]);
    const openNext = $8T3gX.useCallback(()=>{
        if (nextView) changeView(nextView);
    }, [
        nextView,
        changeView
    ]);
    const handleChangeAndOpenNext = $8T3gX.useCallback((date, currentViewSelectionState)=>{
        const isSelectionFinishedOnCurrentView = currentViewSelectionState === 'finish';
        const globalSelectionState = isSelectionFinishedOnCurrentView && Boolean(nextView) ? 'partial' : currentViewSelectionState;
        onChange(date, globalSelectionState);
        if (isSelectionFinishedOnCurrentView) openNext();
    }, [
        nextView,
        onChange,
        openNext
    ]);
    return {
        handleChangeAndOpenNext: handleChangeAndOpenNext,
        nextView: nextView,
        previousView: previousView,
        openNext: openNext,
        openView: openView,
        setOpenView: changeView
    };
}

});

parcelRegister("2mbSs", function(module, exports) {

$parcel$export(module.exports, "ClockPicker", () => $1b76d972e217a719$export$d86c07922195f713);

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $hIlXQ = parcelRequire("hIlXQ");

var $fdGrT = parcelRequire("fdGrT");

var $1xq4a = parcelRequire("1xq4a");

var $anJSP = parcelRequire("anJSP");
var $4wdE9 = parcelRequire("4wdE9");

var $aYNpO = parcelRequire("aYNpO");

var $962o6 = parcelRequire("962o6");

var $1hdeG = parcelRequire("1hdeG");

var $daBls = parcelRequire("daBls");

var $jwfxk = parcelRequire("jwfxk");

var $ihjWR = parcelRequire("ihjWR");

var $gA4XU = parcelRequire("gA4XU");

var $5T1k5 = parcelRequire("5T1k5");

var $ekk2W = parcelRequire("ekk2W");

var $37Vsm = parcelRequire("37Vsm");

var $J7AIr = parcelRequire("J7AIr");

var $k4ank = parcelRequire("k4ank");
const $1b76d972e217a719$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        arrowSwitcher: [
            'arrowSwitcher'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $37Vsm.getClockPickerUtilityClass), classes);
};
const $1b76d972e217a719$var$ClockPickerRoot = (0, $anJSP.default)((0, $J7AIr.PickerViewRoot), {
    name: 'MuiClockPicker',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexDirection: 'column'
});
const $1b76d972e217a719$var$ClockPickerArrowSwitcher = (0, $anJSP.default)((0, $ihjWR.PickersArrowSwitcher), {
    name: 'MuiClockPicker',
    slot: 'ArrowSwitcher',
    overridesResolver: (props, styles)=>styles.arrowSwitcher
})({
    position: 'absolute',
    right: 12,
    top: 15
});
const $1b76d972e217a719$var$deprecatedPropsWarning = (0, $daBls.buildDeprecatedPropsWarning)('Props for translation are deprecated. See https://mui.com/x/react-date-pickers/localization for more information.');
const $1b76d972e217a719$export$d86c07922195f713 = /*#__PURE__*/ $8T3gX.forwardRef(function ClockPicker(inProps, ref) {
    const props = (0, $4wdE9.default)({
        props: inProps,
        name: 'MuiClockPicker'
    });
    const { ampm: ampm = false, ampmInClock: ampmInClock = false, autoFocus: autoFocus, components: components, componentsProps: componentsProps, date: date, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, getClockLabelText: getClockLabelTextProp, getHoursClockNumberText: getHoursClockNumberTextProp, getMinutesClockNumberText: getMinutesClockNumberTextProp, getSecondsClockNumberText: getSecondsClockNumberTextProp, leftArrowButtonText: leftArrowButtonTextProp, maxTime: maxTime, minTime: minTime, minutesStep: minutesStep = 1, rightArrowButtonText: rightArrowButtonTextProp, shouldDisableTime: shouldDisableTime, showViewSwitcher: showViewSwitcher, onChange: onChange, view: view, views: views = [
        'hours',
        'minutes'
    ], openTo: openTo, onViewChange: onViewChange, className: className, disabled: disabled, readOnly: readOnly } = props;
    $1b76d972e217a719$var$deprecatedPropsWarning({
        leftArrowButtonText: leftArrowButtonTextProp,
        rightArrowButtonText: rightArrowButtonTextProp,
        getClockLabelText: getClockLabelTextProp,
        getHoursClockNumberText: getHoursClockNumberTextProp,
        getMinutesClockNumberText: getMinutesClockNumberTextProp,
        getSecondsClockNumberText: getSecondsClockNumberTextProp
    });
    const localeText = (0, $1hdeG.useLocaleText)();
    const leftArrowButtonText = leftArrowButtonTextProp != null ? leftArrowButtonTextProp : localeText.openPreviousView;
    const rightArrowButtonText = rightArrowButtonTextProp != null ? rightArrowButtonTextProp : localeText.openNextView;
    const getClockLabelText = getClockLabelTextProp != null ? getClockLabelTextProp : localeText.clockLabelText;
    const getHoursClockNumberText = getHoursClockNumberTextProp != null ? getHoursClockNumberTextProp : localeText.hoursClockNumberText;
    const getMinutesClockNumberText = getMinutesClockNumberTextProp != null ? getMinutesClockNumberTextProp : localeText.minutesClockNumberText;
    const getSecondsClockNumberText = getSecondsClockNumberTextProp != null ? getSecondsClockNumberTextProp : localeText.secondsClockNumberText;
    const { openView: openView, setOpenView: setOpenView, nextView: nextView, previousView: previousView, handleChangeAndOpenNext: handleChangeAndOpenNext } = (0, $5T1k5.useViews)({
        view: view,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: onChange
    });
    const now = (0, $1hdeG.useNow)();
    const utils = (0, $1hdeG.useUtils)();
    const dateOrMidnight = $8T3gX.useMemo(()=>date || utils.setSeconds(utils.setMinutes(utils.setHours(now, 0), 0), 0), [
        date,
        now,
        utils
    ]);
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $ekk2W.useMeridiemMode)(dateOrMidnight, ampm, handleChangeAndOpenNext);
    const isTimeDisabled = $8T3gX.useCallback((rawValue, viewType)=>{
        const isAfter = (0, $gA4XU.createIsAfterIgnoreDatePart)(disableIgnoringDatePartForTimeValidation, utils);
        const containsValidTime = ({ start: start, end: end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            return true;
        };
        const isValidValue = (value, step = 1)=>{
            if (value % step !== 0) return false;
            if (shouldDisableTime) return !shouldDisableTime(value, viewType);
            return true;
        };
        switch(viewType){
            case 'hours':
                {
                    const value = (0, $gA4XU.convertValueToMeridiem)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = utils.setHours(dateOrMidnight, value);
                    const start = utils.setSeconds(utils.setMinutes(dateWithNewHours, 0), 0);
                    const end = utils.setSeconds(utils.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(value);
                }
            case 'minutes':
                {
                    const dateWithNewMinutes = utils.setMinutes(dateOrMidnight, rawValue);
                    const start = utils.setSeconds(dateWithNewMinutes, 0);
                    const end = utils.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case 'seconds':
                {
                    const dateWithNewSeconds = utils.setSeconds(dateOrMidnight, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error('not supported');
        }
    }, [
        ampm,
        dateOrMidnight,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableTime,
        utils
    ]);
    const selectedId = (0, $1xq4a.default)();
    const viewProps = $8T3gX.useMemo(()=>{
        switch(openView){
            case 'hours':
                {
                    const handleHoursChange = (value, isFinish)=>{
                        const valueWithMeridiem = (0, $gA4XU.convertValueToMeridiem)(value, meridiemMode, ampm);
                        handleChangeAndOpenNext(utils.setHours(dateOrMidnight, valueWithMeridiem), isFinish);
                    };
                    return {
                        onChange: handleHoursChange,
                        value: utils.getHours(dateOrMidnight),
                        children: (0, $jwfxk.getHourNumbers)({
                            date: date,
                            utils: utils,
                            ampm: ampm,
                            onChange: handleHoursChange,
                            getClockNumberText: getHoursClockNumberText,
                            isDisabled: (value)=>disabled || isTimeDisabled(value, 'hours'),
                            selectedId: selectedId
                        })
                    };
                }
            case 'minutes':
                {
                    const minutesValue = utils.getMinutes(dateOrMidnight);
                    const handleMinutesChange = (value, isFinish)=>{
                        handleChangeAndOpenNext(utils.setMinutes(dateOrMidnight, value), isFinish);
                    };
                    return {
                        value: minutesValue,
                        onChange: handleMinutesChange,
                        children: (0, $jwfxk.getMinutesNumbers)({
                            utils: utils,
                            value: minutesValue,
                            onChange: handleMinutesChange,
                            getClockNumberText: getMinutesClockNumberText,
                            isDisabled: (value)=>disabled || isTimeDisabled(value, 'minutes'),
                            selectedId: selectedId
                        })
                    };
                }
            case 'seconds':
                {
                    const secondsValue = utils.getSeconds(dateOrMidnight);
                    const handleSecondsChange = (value, isFinish)=>{
                        handleChangeAndOpenNext(utils.setSeconds(dateOrMidnight, value), isFinish);
                    };
                    return {
                        value: secondsValue,
                        onChange: handleSecondsChange,
                        children: (0, $jwfxk.getMinutesNumbers)({
                            utils: utils,
                            value: secondsValue,
                            onChange: handleSecondsChange,
                            getClockNumberText: getSecondsClockNumberText,
                            isDisabled: (value)=>disabled || isTimeDisabled(value, 'seconds'),
                            selectedId: selectedId
                        })
                    };
                }
            default:
                throw new Error('You must provide the type for ClockView');
        }
    }, [
        openView,
        utils,
        date,
        ampm,
        getHoursClockNumberText,
        getMinutesClockNumberText,
        getSecondsClockNumberText,
        meridiemMode,
        handleChangeAndOpenNext,
        dateOrMidnight,
        isTimeDisabled,
        selectedId,
        disabled
    ]);
    const ownerState = props;
    const classes = $1b76d972e217a719$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsxs)($1b76d972e217a719$var$ClockPickerRoot, {
        ref: ref,
        className: (0, $hIlXQ.default)(classes.root, className),
        ownerState: ownerState,
        children: [
            showViewSwitcher && /*#__PURE__*/ (0, $k4ank.jsx)($1b76d972e217a719$var$ClockPickerArrowSwitcher, {
                className: classes.arrowSwitcher,
                leftArrowButtonText: leftArrowButtonText,
                rightArrowButtonText: rightArrowButtonText,
                components: components,
                componentsProps: componentsProps,
                onLeftClick: ()=>setOpenView(previousView),
                onRightClick: ()=>setOpenView(nextView),
                isLeftDisabled: !previousView,
                isRightDisabled: !nextView,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $962o6.Clock), (0, $eJfrs.default)({
                autoFocus: autoFocus,
                date: date,
                ampmInClock: ampmInClock,
                type: openView,
                ampm: ampm,
                getClockLabelText: getClockLabelText,
                minutesStep: minutesStep,
                isTimeDisabled: isTimeDisabled,
                meridiemMode: meridiemMode,
                handleMeridiemChange: handleMeridiemChange,
                selectedId: selectedId,
                disabled: disabled,
                readOnly: readOnly
            }, viewProps))
        ]
    });
});
$1b76d972e217a719$export$d86c07922195f713.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * 12h/24h view for hour selection clock.
   * @default false
   */ ampm: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default false
   */ ampmInClock: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Set to `true` if focus should be moved to clock picker.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Overrideable components.
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The props used for each component slot.
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Selected date @DateIOType.
   */ date: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Accessible text that helps user to understand which time and view is selected.
   * @template TDate
   * @param {ClockPickerView} view The current view rendered.
   * @param {TDate | null} time The current time.
   * @param {MuiPickersAdapter<TDate>} adapter The current date adapter.
   * @returns {string} The clock label.
   * @deprecated Use the `localeText` prop of `LocalizationProvider` instead, see https://mui.com/x/react-date-pickers/localization/.
   * @default <TDate extends any>(
   *   view: ClockView,
   *   time: TDate | null,
   *   adapter: MuiPickersAdapter<TDate>,
   * ) =>
   *   `Select ${view}. ${
   *     time === null ? 'No time selected' : `Selected time is ${adapter.format(time, 'fullTime')}`
   *   }`
   */ getClockLabelText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Get clock number aria-text for hours.
   * @param {string} hours The hours to format.
   * @returns {string} the formatted hours text.
   * @default (hours: string) => `${hours} hours`
   * @deprecated Use the `localeText` prop of `LocalizationProvider` instead, see https://mui.com/x/react-date-pickers/localization/.
   */ getHoursClockNumberText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Get clock number aria-text for minutes.
   * @param {string} minutes The minutes to format.
   * @returns {string} the formatted minutes text.
   * @default (minutes: string) => `${minutes} minutes`
   * @deprecated Use the `localeText` prop of `LocalizationProvider` instead, see https://mui.com/x/react-date-pickers/localization/.
   */ getMinutesClockNumberText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Get clock number aria-text for seconds.
   * @param {string} seconds The seconds to format.
   * @returns {string} the formatted seconds text.
   * @default (seconds: string) => `${seconds} seconds`
   * @deprecated Use the `localeText` prop of `LocalizationProvider` instead, see https://mui.com/x/react-date-pickers/localization/.
   */ getSecondsClockNumberText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Left arrow icon aria-label text.
   * @default 'open previous view'
   * @deprecated Use the `localeText` prop of `LocalizationProvider` instead, see https://mui.com/x/react-date-pickers/localization/.
   */ leftArrowButtonText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Max time acceptable time.
   * For input validation date part of passed object will be ignored if `disableIgnoringDatePartForTimeValidation` not specified.
   */ maxTime: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Min time acceptable time.
   * For input validation date part of passed object will be ignored if `disableIgnoringDatePartForTimeValidation` not specified.
   */ minTime: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    /**
   * On change callback @DateIOType.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired,
    /**
   * Callback fired on view change.
   * @param {ClockPickerView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Initially open view.
   * @default 'hours'
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'hours',
        'minutes',
        'seconds'
    ]),
    /**
   * Make picker read only.
   * @default false
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Right arrow icon aria-label text.
   * @default 'open next view'
   * @deprecated Use the `localeText` prop of `LocalizationProvider` instead, see https://mui.com/x/react-date-pickers/localization/.
   */ rightArrowButtonText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Dynamically check if time is disabled or not.
   * If returns `false` appropriate time point will ot be acceptable.
   * @param {number} timeValue The value to check.
   * @param {ClockPickerView} clockType The clock type of the timeValue.
   * @returns {boolean} Returns `true` if the time should be disabled
   */ shouldDisableTime: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    showViewSwitcher: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Controlled open view.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'hours',
        'minutes',
        'seconds'
    ]),
    /**
   * Views for calendar picker.
   * @default ['hours', 'minutes']
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'hours',
        'minutes',
        'seconds'
    ]).isRequired)
};

});
parcelRegister("962o6", function(module, exports) {

$parcel$export(module.exports, "Clock", () => $69f686c20051f32f$export$9735c82c4bae3302);

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $hIlXQ = parcelRequire("hIlXQ");

var $iKAtE = parcelRequire("iKAtE");

var $f3puC = parcelRequire("f3puC");

var $anJSP = parcelRequire("anJSP");
var $4wdE9 = parcelRequire("4wdE9");

var $aYNpO = parcelRequire("aYNpO");
var $5IwAt = parcelRequire("5IwAt");

var $k26Jc = parcelRequire("k26Jc");

var $1hdeG = parcelRequire("1hdeG");

var $kneyk = parcelRequire("kneyk");

var $g4RVS = parcelRequire("g4RVS");

var $9GlJb = parcelRequire("9GlJb");

var $k4ank = parcelRequire("k4ank");
const $69f686c20051f32f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        clock: [
            'clock'
        ],
        wrapper: [
            'wrapper'
        ],
        squareMask: [
            'squareMask'
        ],
        pin: [
            'pin'
        ],
        amButton: [
            'amButton'
        ],
        pmButton: [
            'pmButton'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $9GlJb.getClockUtilityClass), classes);
};
const $69f686c20051f32f$var$ClockRoot = (0, $anJSP.default)('div', {
    name: 'MuiClock',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: theme.spacing(2)
    }));
const $69f686c20051f32f$var$ClockClock = (0, $anJSP.default)('div', {
    name: 'MuiClock',
    slot: 'Clock',
    overridesResolver: (_, styles)=>styles.clock
})({
    backgroundColor: 'rgba(0,0,0,.07)',
    borderRadius: '50%',
    height: 220,
    width: 220,
    flexShrink: 0,
    position: 'relative',
    pointerEvents: 'none'
});
const $69f686c20051f32f$var$ClockWrapper = (0, $anJSP.default)('div', {
    name: 'MuiClock',
    slot: 'Wrapper',
    overridesResolver: (_, styles)=>styles.wrapper
})({
    '&:focus': {
        outline: 'none'
    }
});
const $69f686c20051f32f$var$ClockSquareMask = (0, $anJSP.default)('div', {
    name: 'MuiClock',
    slot: 'SquareMask',
    overridesResolver: (_, styles)=>styles.squareMask
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({
        width: '100%',
        height: '100%',
        position: 'absolute',
        pointerEvents: 'auto',
        outline: 0,
        // Disable scroll capabilities.
        touchAction: 'none',
        userSelect: 'none'
    }, ownerState.disabled ? {} : {
        '@media (pointer: fine)': {
            cursor: 'pointer',
            borderRadius: '50%'
        },
        '&:active': {
            cursor: 'move'
        }
    }));
const $69f686c20051f32f$var$ClockPin = (0, $anJSP.default)('div', {
    name: 'MuiClock',
    slot: 'Pin',
    overridesResolver: (_, styles)=>styles.pin
})(({ theme: theme })=>({
        width: 6,
        height: 6,
        borderRadius: '50%',
        backgroundColor: theme.palette.primary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    }));
const $69f686c20051f32f$var$ClockAmButton = (0, $anJSP.default)((0, $iKAtE.default), {
    name: 'MuiClock',
    slot: 'AmButton',
    overridesResolver: (_, styles)=>styles.amButton
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        zIndex: 1,
        position: 'absolute',
        bottom: ownerState.ampmInClock ? 64 : 8,
        left: 8
    }, ownerState.meridiemMode === 'am' && {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        '&:hover': {
            backgroundColor: theme.palette.primary.light
        }
    }));
const $69f686c20051f32f$var$ClockPmButton = (0, $anJSP.default)((0, $iKAtE.default), {
    name: 'MuiClock',
    slot: 'PmButton',
    overridesResolver: (_, styles)=>styles.pmButton
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        zIndex: 1,
        position: 'absolute',
        bottom: ownerState.ampmInClock ? 64 : 8,
        right: 8
    }, ownerState.meridiemMode === 'pm' && {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        '&:hover': {
            backgroundColor: theme.palette.primary.light
        }
    }));
function $69f686c20051f32f$export$9735c82c4bae3302(inProps) {
    const props = (0, $4wdE9.default)({
        props: inProps,
        name: 'MuiClock'
    });
    const { ampm: ampm, ampmInClock: ampmInClock, autoFocus: autoFocus, children: children, date: date, getClockLabelText: getClockLabelText, handleMeridiemChange: handleMeridiemChange, isTimeDisabled: isTimeDisabled, meridiemMode: meridiemMode, minutesStep: minutesStep = 1, onChange: onChange, selectedId: selectedId, type: type, value: value, disabled: disabled, readOnly: readOnly, className: className } = props;
    const ownerState = props;
    const utils = (0, $1hdeG.useUtils)();
    const wrapperVariant = $8T3gX.useContext((0, $kneyk.WrapperVariantContext));
    const isMoving = $8T3gX.useRef(false);
    const classes = $69f686c20051f32f$var$useUtilityClasses(ownerState);
    const isSelectedTimeDisabled = isTimeDisabled(value, type);
    const isPointerInner = !ampm && type === 'hours' && (value < 1 || value > 12);
    const handleValueChange = (newValue, isFinish)=>{
        if (disabled || readOnly) return;
        if (isTimeDisabled(newValue, type)) return;
        onChange(newValue, isFinish);
    };
    const setTime = (event, isFinish)=>{
        let { offsetX: offsetX, offsetY: offsetY } = event;
        if (offsetX === undefined) {
            const rect = event.target.getBoundingClientRect();
            offsetX = event.changedTouches[0].clientX - rect.left;
            offsetY = event.changedTouches[0].clientY - rect.top;
        }
        const newSelectedValue = type === 'seconds' || type === 'minutes' ? (0, $g4RVS.getMinutes)(offsetX, offsetY, minutesStep) : (0, $g4RVS.getHours)(offsetX, offsetY, Boolean(ampm));
        handleValueChange(newSelectedValue, isFinish);
    };
    const handleTouchMove = (event)=>{
        isMoving.current = true;
        setTime(event, 'shallow');
    };
    const handleTouchEnd = (event)=>{
        if (isMoving.current) {
            setTime(event, 'finish');
            isMoving.current = false;
        }
    };
    const handleMouseMove = (event)=>{
        // event.buttons & PRIMARY_MOUSE_BUTTON
        if (event.buttons > 0) setTime(event.nativeEvent, 'shallow');
    };
    const handleMouseUp = (event)=>{
        if (isMoving.current) isMoving.current = false;
        setTime(event.nativeEvent, 'finish');
    };
    const hasSelected = $8T3gX.useMemo(()=>{
        if (type === 'hours') return true;
        return value % 5 === 0;
    }, [
        type,
        value
    ]);
    const keyboardControlStep = type === 'minutes' ? minutesStep : 1;
    const listboxRef = $8T3gX.useRef(null); // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $5IwAt.default)(()=>{
        if (autoFocus) // The ref not being resolved would be a bug in MUI.
        listboxRef.current.focus();
    }, [
        autoFocus
    ]);
    const handleKeyDown = (event)=>{
        // TODO: Why this early exit?
        if (isMoving.current) return;
        switch(event.key){
            case 'Home':
                // annulate both hours and minutes
                handleValueChange(0, 'partial');
                event.preventDefault();
                break;
            case 'End':
                handleValueChange(type === 'minutes' ? 59 : 23, 'partial');
                event.preventDefault();
                break;
            case 'ArrowUp':
                handleValueChange(value + keyboardControlStep, 'partial');
                event.preventDefault();
                break;
            case 'ArrowDown':
                handleValueChange(value - keyboardControlStep, 'partial');
                event.preventDefault();
                break;
            default:
        }
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)($69f686c20051f32f$var$ClockRoot, {
        className: (0, $hIlXQ.default)(className, classes.root),
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)($69f686c20051f32f$var$ClockClock, {
                className: classes.clock,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)($69f686c20051f32f$var$ClockSquareMask, {
                        onTouchMove: handleTouchMove,
                        onTouchEnd: handleTouchEnd,
                        onMouseUp: handleMouseUp,
                        onMouseMove: handleMouseMove,
                        ownerState: {
                            disabled: disabled
                        },
                        className: classes.squareMask
                    }),
                    !isSelectedTimeDisabled && /*#__PURE__*/ (0, $k4ank.jsxs)($8T3gX.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)($69f686c20051f32f$var$ClockPin, {
                                className: classes.pin
                            }),
                            date && /*#__PURE__*/ (0, $k4ank.jsx)((0, $k26Jc.ClockPointer), {
                                type: type,
                                value: value,
                                isInner: isPointerInner,
                                hasSelected: hasSelected
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)($69f686c20051f32f$var$ClockWrapper, {
                        "aria-activedescendant": selectedId,
                        "aria-label": getClockLabelText(type, date, utils),
                        ref: listboxRef,
                        role: "listbox",
                        onKeyDown: handleKeyDown,
                        tabIndex: 0,
                        className: classes.wrapper,
                        children: children
                    })
                ]
            }),
            ampm && (wrapperVariant === 'desktop' || ampmInClock) && /*#__PURE__*/ (0, $k4ank.jsxs)($8T3gX.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)($69f686c20051f32f$var$ClockAmButton, {
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange('am'),
                        disabled: disabled || meridiemMode === null,
                        ownerState: ownerState,
                        className: classes.amButton,
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                            variant: "caption",
                            children: "AM"
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)($69f686c20051f32f$var$ClockPmButton, {
                        disabled: disabled || meridiemMode === null,
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange('pm'),
                        ownerState: ownerState,
                        className: classes.pmButton,
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                            variant: "caption",
                            children: "PM"
                        })
                    })
                ]
            })
        ]
    });
}

});
parcelRegister("k26Jc", function(module, exports) {

$parcel$export(module.exports, "ClockPointer", () => $e959369dc1565de4$export$f257f213e6c08f97);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $hIlXQ = parcelRequire("hIlXQ");

var $anJSP = parcelRequire("anJSP");
var $4wdE9 = parcelRequire("4wdE9");

var $aYNpO = parcelRequire("aYNpO");

var $g4RVS = parcelRequire("g4RVS");

var $7cq1u = parcelRequire("7cq1u");

var $k4ank = parcelRequire("k4ank");
const $e959369dc1565de4$var$_excluded = [
    "className",
    "hasSelected",
    "isInner",
    "type",
    "value"
];
const $e959369dc1565de4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        thumb: [
            'thumb'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $7cq1u.getClockPointerUtilityClass), classes);
};
const $e959369dc1565de4$var$ClockPointerRoot = (0, $anJSP.default)('div', {
    name: 'MuiClockPointer',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        width: 2,
        backgroundColor: theme.palette.primary.main,
        position: 'absolute',
        left: 'calc(50% - 1px)',
        bottom: '50%',
        transformOrigin: 'center bottom 0px'
    }, ownerState.shouldAnimate && {
        transition: theme.transitions.create([
            'transform',
            'height'
        ])
    }));
const $e959369dc1565de4$var$ClockPointerThumb = (0, $anJSP.default)('div', {
    name: 'MuiClockPointer',
    slot: 'Thumb',
    overridesResolver: (_, styles)=>styles.thumb
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        width: 4,
        height: 4,
        backgroundColor: theme.palette.primary.contrastText,
        borderRadius: '50%',
        position: 'absolute',
        top: -21,
        left: `calc(50% - ${(0, $g4RVS.CLOCK_HOUR_WIDTH) / 2}px)`,
        border: `${((0, $g4RVS.CLOCK_HOUR_WIDTH) - 4) / 2}px solid ${theme.palette.primary.main}`,
        boxSizing: 'content-box'
    }, ownerState.hasSelected && {
        backgroundColor: theme.palette.primary.main
    }));
function $e959369dc1565de4$export$f257f213e6c08f97(inProps) {
    const props = (0, $4wdE9.default)({
        props: inProps,
        name: 'MuiClockPointer'
    });
    const { className: className, isInner: isInner, type: type, value: value } = props, other = (0, $fAJB5.default)(props, $e959369dc1565de4$var$_excluded);
    const previousType = $8T3gX.useRef(type);
    $8T3gX.useEffect(()=>{
        previousType.current = type;
    }, [
        type
    ]);
    const ownerState = (0, $eJfrs.default)({}, props, {
        shouldAnimate: previousType.current !== type
    });
    const classes = $e959369dc1565de4$var$useUtilityClasses(ownerState);
    const getAngleStyle = ()=>{
        const max = type === 'hours' ? 12 : 60;
        let angle = 360 / max * value;
        if (type === 'hours' && value > 12) angle -= 360; // round up angle to max 360 degrees
        return {
            height: Math.round((isInner ? 0.26 : 0.4) * (0, $g4RVS.CLOCK_WIDTH)),
            transform: `rotateZ(${angle}deg)`
        };
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)($e959369dc1565de4$var$ClockPointerRoot, (0, $eJfrs.default)({
        style: getAngleStyle(),
        className: (0, $hIlXQ.default)(className, classes.root),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $k4ank.jsx)($e959369dc1565de4$var$ClockPointerThumb, {
            ownerState: ownerState,
            className: classes.thumb
        })
    }));
}

});
parcelRegister("g4RVS", function(module, exports) {

$parcel$export(module.exports, "CLOCK_WIDTH", () => $bb46daea8b2d387d$export$8c8ec20d3854d7e6);
$parcel$export(module.exports, "CLOCK_HOUR_WIDTH", () => $bb46daea8b2d387d$export$729c0e543e4dc21d);
$parcel$export(module.exports, "getMinutes", () => $bb46daea8b2d387d$export$b7f1bc3ea3ac4145);
$parcel$export(module.exports, "getHours", () => $bb46daea8b2d387d$export$257b40f71c07d58f);
const $bb46daea8b2d387d$export$8c8ec20d3854d7e6 = 220;
const $bb46daea8b2d387d$export$729c0e543e4dc21d = 36;
const $bb46daea8b2d387d$var$clockCenter = {
    x: $bb46daea8b2d387d$export$8c8ec20d3854d7e6 / 2,
    y: $bb46daea8b2d387d$export$8c8ec20d3854d7e6 / 2
};
const $bb46daea8b2d387d$var$baseClockPoint = {
    x: $bb46daea8b2d387d$var$clockCenter.x,
    y: 0
};
const $bb46daea8b2d387d$var$cx = $bb46daea8b2d387d$var$baseClockPoint.x - $bb46daea8b2d387d$var$clockCenter.x;
const $bb46daea8b2d387d$var$cy = $bb46daea8b2d387d$var$baseClockPoint.y - $bb46daea8b2d387d$var$clockCenter.y;
const $bb46daea8b2d387d$var$rad2deg = (rad)=>rad * (180 / Math.PI);
const $bb46daea8b2d387d$var$getAngleValue = (step, offsetX, offsetY)=>{
    const x = offsetX - $bb46daea8b2d387d$var$clockCenter.x;
    const y = offsetY - $bb46daea8b2d387d$var$clockCenter.y;
    const atan = Math.atan2($bb46daea8b2d387d$var$cx, $bb46daea8b2d387d$var$cy) - Math.atan2(x, y);
    let deg = $bb46daea8b2d387d$var$rad2deg(atan);
    deg = Math.round(deg / step) * step;
    deg %= 360;
    const value = Math.floor(deg / step) || 0;
    const delta = x ** 2 + y ** 2;
    const distance = Math.sqrt(delta);
    return {
        value: value,
        distance: distance
    };
};
const $bb46daea8b2d387d$export$b7f1bc3ea3ac4145 = (offsetX, offsetY, step = 1)=>{
    const angleStep = step * 6;
    let { value: value } = $bb46daea8b2d387d$var$getAngleValue(angleStep, offsetX, offsetY);
    value = value * step % 60;
    return value;
};
const $bb46daea8b2d387d$export$257b40f71c07d58f = (offsetX, offsetY, ampm)=>{
    const { value: value, distance: distance } = $bb46daea8b2d387d$var$getAngleValue(30, offsetX, offsetY);
    let hour = value || 12;
    if (!ampm) {
        if (distance < $bb46daea8b2d387d$export$8c8ec20d3854d7e6 / 2 - $bb46daea8b2d387d$export$729c0e543e4dc21d) {
            hour += 12;
            hour %= 24;
        }
    } else hour %= 12;
    return hour;
};

});

parcelRegister("7cq1u", function(module, exports) {

$parcel$export(module.exports, "getClockPointerUtilityClass", () => $53ddd706ef5eadc8$export$12faa62796978e2f);

var $kfTYv = parcelRequire("kfTYv");
var $jh2Zm = parcelRequire("jh2Zm");
function $53ddd706ef5eadc8$export$12faa62796978e2f(slot) {
    return (0, $kfTYv.default)('MuiClockPointer', slot);
}
const $53ddd706ef5eadc8$export$64afeec9352615cb = (0, $jh2Zm.default)('MuiClockPointer', [
    'root',
    'thumb'
]);

});


parcelRegister("9GlJb", function(module, exports) {

$parcel$export(module.exports, "getClockUtilityClass", () => $70c8e3fd757dae5c$export$e44ecab24167799b);

var $kfTYv = parcelRequire("kfTYv");
var $jh2Zm = parcelRequire("jh2Zm");
function $70c8e3fd757dae5c$export$e44ecab24167799b(slot) {
    return (0, $kfTYv.default)('MuiClock', slot);
}
const $70c8e3fd757dae5c$export$4626e3a61e161c64 = (0, $jh2Zm.default)('MuiClock', [
    'root',
    'clock',
    'wrapper',
    'squareMask',
    'pin',
    'amButton',
    'pmButton'
]);

});


parcelRegister("daBls", function(module, exports) {

$parcel$export(module.exports, "buildDeprecatedPropsWarning", () => $99692d7fa60f8073$export$be61413ca3629f52);
const $99692d7fa60f8073$export$be61413ca3629f52 = (message)=>{
    let alreadyWarned = false;
    const cleanMessage = Array.isArray(message) ? message.join('\n') : message;
    return (deprecatedProps)=>{
        const deprecatedKeys = Object.entries(deprecatedProps).filter(([, value])=>value !== undefined).map(([key])=>`- ${key}`);
        if (!alreadyWarned && deprecatedKeys.length > 0) {
            alreadyWarned = true;
            console.warn([
                cleanMessage,
                'deprecated props observed:',
                ...deprecatedKeys
            ].join('\n'));
        }
    };
};

});

parcelRegister("jwfxk", function(module, exports) {

$parcel$export(module.exports, "getHourNumbers", () => $e35d0eb881846d5a$export$10850582eda9a8c7);
$parcel$export(module.exports, "getMinutesNumbers", () => $e35d0eb881846d5a$export$2c440057d7a731e4);
parcelRequire("8T3gX");

var $a5UNc = parcelRequire("a5UNc");

var $k4ank = parcelRequire("k4ank");
const $e35d0eb881846d5a$export$10850582eda9a8c7 = ({ ampm: ampm, date: date, getClockNumberText: getClockNumberText, isDisabled: isDisabled, selectedId: selectedId, utils: utils })=>{
    const currentHours = date ? utils.getHours(date) : null;
    const hourNumbers = [];
    const startHour = ampm ? 1 : 0;
    const endHour = ampm ? 12 : 23;
    const isSelected = (hour)=>{
        if (currentHours === null) return false;
        if (ampm) {
            if (hour === 12) return currentHours === 12 || currentHours === 0;
            return currentHours === hour || currentHours - 12 === hour;
        }
        return currentHours === hour;
    };
    for(let hour = startHour; hour <= endHour; hour += 1){
        let label = hour.toString();
        if (hour === 0) label = '00';
        const inner = !ampm && (hour === 0 || hour > 12);
        label = utils.formatNumber(label);
        const selected = isSelected(hour);
        hourNumbers.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $a5UNc.ClockNumber), {
            id: selected ? selectedId : undefined,
            index: hour,
            inner: inner,
            selected: selected,
            disabled: isDisabled(hour),
            label: label,
            "aria-label": getClockNumberText(label)
        }, hour));
    }
    return hourNumbers;
};
const $e35d0eb881846d5a$export$2c440057d7a731e4 = ({ utils: utils, value: value, isDisabled: isDisabled, getClockNumberText: getClockNumberText, selectedId: selectedId })=>{
    const f = utils.formatNumber;
    return [
        [
            5,
            f('05')
        ],
        [
            10,
            f('10')
        ],
        [
            15,
            f('15')
        ],
        [
            20,
            f('20')
        ],
        [
            25,
            f('25')
        ],
        [
            30,
            f('30')
        ],
        [
            35,
            f('35')
        ],
        [
            40,
            f('40')
        ],
        [
            45,
            f('45')
        ],
        [
            50,
            f('50')
        ],
        [
            55,
            f('55')
        ],
        [
            0,
            f('00')
        ]
    ].map(([numberValue, label], index)=>{
        const selected = numberValue === value;
        return /*#__PURE__*/ (0, $k4ank.jsx)((0, $a5UNc.ClockNumber), {
            label: label,
            id: selected ? selectedId : undefined,
            index: index + 1,
            inner: false,
            disabled: isDisabled(numberValue),
            selected: selected,
            "aria-label": getClockNumberText(label)
        }, numberValue);
    });
};

});
parcelRegister("a5UNc", function(module, exports) {

$parcel$export(module.exports, "ClockNumber", () => $75966cd1fb071342$export$6d5c4c748c9cc92c);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");
parcelRequire("8T3gX");

var $hIlXQ = parcelRequire("hIlXQ");

var $anJSP = parcelRequire("anJSP");
var $4wdE9 = parcelRequire("4wdE9");

var $aYNpO = parcelRequire("aYNpO");

var $g4RVS = parcelRequire("g4RVS");

var $bmsSu = parcelRequire("bmsSu");

var $k4ank = parcelRequire("k4ank");
const $75966cd1fb071342$var$_excluded = [
    "className",
    "disabled",
    "index",
    "inner",
    "label",
    "selected"
];
const $75966cd1fb071342$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            disabled && 'disabled'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $bmsSu.getClockNumberUtilityClass), classes);
};
const $75966cd1fb071342$var$ClockNumberRoot = (0, $anJSP.default)('span', {
    name: 'MuiClockNumber',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, $bmsSu.clockNumberClasses).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $bmsSu.clockNumberClasses).selected}`]: styles.selected
            }
        ]
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        height: (0, $g4RVS.CLOCK_HOUR_WIDTH),
        width: (0, $g4RVS.CLOCK_HOUR_WIDTH),
        position: 'absolute',
        left: `calc((100% - ${(0, $g4RVS.CLOCK_HOUR_WIDTH)}px) / 2)`,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        color: theme.palette.text.primary,
        fontFamily: theme.typography.fontFamily,
        '&:focused': {
            backgroundColor: theme.palette.background.paper
        },
        [`&.${(0, $bmsSu.clockNumberClasses).selected}`]: {
            color: theme.palette.primary.contrastText
        },
        [`&.${(0, $bmsSu.clockNumberClasses).disabled}`]: {
            pointerEvents: 'none',
            color: theme.palette.text.disabled
        }
    }, ownerState.inner && (0, $eJfrs.default)({}, theme.typography.body2, {
        color: theme.palette.text.secondary
    })));
function $75966cd1fb071342$export$6d5c4c748c9cc92c(inProps) {
    const props = (0, $4wdE9.default)({
        props: inProps,
        name: 'MuiClockNumber'
    });
    const { className: className, disabled: disabled, index: index, inner: inner, label: label, selected: selected } = props, other = (0, $fAJB5.default)(props, $75966cd1fb071342$var$_excluded);
    const ownerState = props;
    const classes = $75966cd1fb071342$var$useUtilityClasses(ownerState);
    const angle = index % 12 / 12 * Math.PI * 2 - Math.PI / 2;
    const length = ((0, $g4RVS.CLOCK_WIDTH) - (0, $g4RVS.CLOCK_HOUR_WIDTH) - 2) / 2 * (inner ? 0.65 : 1);
    const x = Math.round(Math.cos(angle) * length);
    const y = Math.round(Math.sin(angle) * length);
    return /*#__PURE__*/ (0, $k4ank.jsx)($75966cd1fb071342$var$ClockNumberRoot, (0, $eJfrs.default)({
        className: (0, $hIlXQ.default)(className, classes.root),
        "aria-disabled": disabled ? true : undefined,
        "aria-selected": selected ? true : undefined,
        role: "option",
        style: {
            transform: `translate(${x}px, ${y + ((0, $g4RVS.CLOCK_WIDTH) - (0, $g4RVS.CLOCK_HOUR_WIDTH)) / 2}px`
        },
        ownerState: ownerState
    }, other, {
        children: label
    }));
}

});
parcelRegister("bmsSu", function(module, exports) {

$parcel$export(module.exports, "getClockNumberUtilityClass", () => $8458264deb51f2b4$export$527226d166658911);
$parcel$export(module.exports, "clockNumberClasses", () => $8458264deb51f2b4$export$c8efb3a779c9844a);

var $kfTYv = parcelRequire("kfTYv");
var $jh2Zm = parcelRequire("jh2Zm");
function $8458264deb51f2b4$export$527226d166658911(slot) {
    return (0, $kfTYv.default)('MuiClockNumber', slot);
}
const $8458264deb51f2b4$export$c8efb3a779c9844a = (0, $jh2Zm.default)('MuiClockNumber', [
    'root',
    'selected',
    'disabled'
]);

});



parcelRegister("ihjWR", function(module, exports) {

$parcel$export(module.exports, "PickersArrowSwitcher", () => $d4e949d7b70c0fda$export$597b7cbdb7b2a24c);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $hIlXQ = parcelRequire("hIlXQ");

var $f3puC = parcelRequire("f3puC");

var $anJSP = parcelRequire("anJSP");
var $4nWZ9 = parcelRequire("4nWZ9");
var $4wdE9 = parcelRequire("4wdE9");

var $aYNpO = parcelRequire("aYNpO");

var $iKAtE = parcelRequire("iKAtE");

var $hIg9z = parcelRequire("hIg9z");

var $iij6Q = parcelRequire("iij6Q");

var $k4ank = parcelRequire("k4ank");
const $d4e949d7b70c0fda$var$_excluded = [
    "children",
    "className",
    "components",
    "componentsProps",
    "isLeftDisabled",
    "isLeftHidden",
    "isRightDisabled",
    "isRightHidden",
    "leftArrowButtonText",
    "onLeftClick",
    "onRightClick",
    "rightArrowButtonText"
];
const $d4e949d7b70c0fda$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        spacer: [
            'spacer'
        ],
        button: [
            'button'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $iij6Q.getPickersArrowSwitcherUtilityClass), classes);
};
const $d4e949d7b70c0fda$var$PickersArrowSwitcherRoot = (0, $anJSP.default)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex'
});
const $d4e949d7b70c0fda$var$PickersArrowSwitcherSpacer = (0, $anJSP.default)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Spacer',
    overridesResolver: (props, styles)=>styles.spacer
})(({ theme: theme })=>({
        width: theme.spacing(3)
    }));
const $d4e949d7b70c0fda$var$PickersArrowSwitcherButton = (0, $anJSP.default)((0, $iKAtE.default), {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Button',
    overridesResolver: (props, styles)=>styles.button
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({}, ownerState.hidden && {
        visibility: 'hidden'
    }));
const $d4e949d7b70c0fda$export$597b7cbdb7b2a24c = /*#__PURE__*/ $8T3gX.forwardRef(function PickersArrowSwitcher(inProps, ref) {
    const props = (0, $4wdE9.default)({
        props: inProps,
        name: 'MuiPickersArrowSwitcher'
    });
    const { children: children, className: className, components: components, componentsProps: componentsProps, isLeftDisabled: isLeftDisabled, isLeftHidden: isLeftHidden, isRightDisabled: isRightDisabled, isRightHidden: isRightHidden, leftArrowButtonText: leftArrowButtonText, onLeftClick: onLeftClick, onRightClick: onRightClick, rightArrowButtonText: rightArrowButtonText } = props, other = (0, $fAJB5.default)(props, $d4e949d7b70c0fda$var$_excluded);
    const theme = (0, $4nWZ9.default)();
    const isRtl = theme.direction === 'rtl';
    const leftArrowButtonProps = (componentsProps == null ? void 0 : componentsProps.leftArrowButton) || {};
    const LeftArrowIcon = (components == null ? void 0 : components.LeftArrowIcon) || (0, $hIg9z.ArrowLeft);
    const rightArrowButtonProps = (componentsProps == null ? void 0 : componentsProps.rightArrowButton) || {};
    const RightArrowIcon = (components == null ? void 0 : components.RightArrowIcon) || (0, $hIg9z.ArrowRight);
    const ownerState = props;
    const classes = $d4e949d7b70c0fda$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsxs)($d4e949d7b70c0fda$var$PickersArrowSwitcherRoot, (0, $eJfrs.default)({
        ref: ref,
        className: (0, $hIlXQ.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)($d4e949d7b70c0fda$var$PickersArrowSwitcherButton, (0, $eJfrs.default)({
                as: components == null ? void 0 : components.LeftArrowButton,
                size: "small",
                "aria-label": leftArrowButtonText,
                title: leftArrowButtonText,
                disabled: isLeftDisabled,
                edge: "end",
                onClick: onLeftClick
            }, leftArrowButtonProps, {
                className: (0, $hIlXQ.default)(classes.button, leftArrowButtonProps.className),
                ownerState: (0, $eJfrs.default)({}, ownerState, leftArrowButtonProps, {
                    hidden: isLeftHidden
                }),
                children: isRtl ? /*#__PURE__*/ (0, $k4ank.jsx)(RightArrowIcon, {}) : /*#__PURE__*/ (0, $k4ank.jsx)(LeftArrowIcon, {})
            })),
            children ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                variant: "subtitle1",
                component: "span",
                children: children
            }) : /*#__PURE__*/ (0, $k4ank.jsx)($d4e949d7b70c0fda$var$PickersArrowSwitcherSpacer, {
                className: classes.spacer,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)($d4e949d7b70c0fda$var$PickersArrowSwitcherButton, (0, $eJfrs.default)({
                as: components == null ? void 0 : components.RightArrowButton,
                size: "small",
                "aria-label": rightArrowButtonText,
                title: rightArrowButtonText,
                edge: "start",
                disabled: isRightDisabled,
                onClick: onRightClick
            }, rightArrowButtonProps, {
                className: (0, $hIlXQ.default)(classes.button, rightArrowButtonProps.className),
                ownerState: (0, $eJfrs.default)({}, ownerState, rightArrowButtonProps, {
                    hidden: isRightHidden
                }),
                children: isRtl ? /*#__PURE__*/ (0, $k4ank.jsx)(LeftArrowIcon, {}) : /*#__PURE__*/ (0, $k4ank.jsx)(RightArrowIcon, {})
            }))
        ]
    }));
});

});
parcelRegister("iij6Q", function(module, exports) {

$parcel$export(module.exports, "getPickersArrowSwitcherUtilityClass", () => $d518bb25803376f2$export$cef978c25740de90);

var $kfTYv = parcelRequire("kfTYv");
var $jh2Zm = parcelRequire("jh2Zm");
function $d518bb25803376f2$export$cef978c25740de90(slot) {
    return (0, $kfTYv.default)('MuiPickersArrowSwitcher', slot);
}
const $d518bb25803376f2$export$f8819209558cd362 = (0, $jh2Zm.default)('MuiPickersArrowSwitcher', [
    'root',
    'spacer',
    'button'
]);

});


parcelRegister("37Vsm", function(module, exports) {

$parcel$export(module.exports, "getClockPickerUtilityClass", () => $246e98306058ed7c$export$f8da5e3552abcf0a);

var $kfTYv = parcelRequire("kfTYv");
var $jh2Zm = parcelRequire("jh2Zm");
function $246e98306058ed7c$export$f8da5e3552abcf0a(slot) {
    return (0, $kfTYv.default)('MuiClockPicker', slot);
}
const $246e98306058ed7c$export$355e4a5f94c2b5f = (0, $jh2Zm.default)('MuiClockPicker', [
    'root',
    'arrowSwitcher'
]);

});

parcelRegister("J7AIr", function(module, exports) {

$parcel$export(module.exports, "PickerViewRoot", () => $087a1789555313fe$export$512b066b8abdfde4);

var $anJSP = parcelRequire("anJSP");

var $b75b5 = parcelRequire("b75b5");
const $087a1789555313fe$export$512b066b8abdfde4 = (0, $anJSP.default)('div')({
    overflowX: 'hidden',
    width: (0, $b75b5.DIALOG_WIDTH),
    maxHeight: (0, $b75b5.VIEW_HEIGHT),
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto'
});

});
parcelRegister("b75b5", function(module, exports) {

$parcel$export(module.exports, "DAY_SIZE", () => $81745d5bb85cc7df$export$3f0060ce4cc8f4d0);
$parcel$export(module.exports, "DAY_MARGIN", () => $81745d5bb85cc7df$export$dde58b009b497666);
$parcel$export(module.exports, "DIALOG_WIDTH", () => $81745d5bb85cc7df$export$ee46b8a74d6c94d3);
$parcel$export(module.exports, "VIEW_HEIGHT", () => $81745d5bb85cc7df$export$f2fef360e2df0cb7);
const $81745d5bb85cc7df$export$3f0060ce4cc8f4d0 = 36;
const $81745d5bb85cc7df$export$dde58b009b497666 = 2;
const $81745d5bb85cc7df$export$ee46b8a74d6c94d3 = 320;
const $81745d5bb85cc7df$export$f2fef360e2df0cb7 = 358;

});



parcelRegister("9uYlC", function(module, exports) {

$parcel$export(module.exports, "CalendarPicker", () => $6ea5ba37aae09d8c$export$904d39b6b448e4e5);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $hIlXQ = parcelRequire("hIlXQ");

var $anJSP = parcelRequire("anJSP");
var $4wdE9 = parcelRequire("4wdE9");

var $aYNpO = parcelRequire("aYNpO");

var $1xq4a = parcelRequire("1xq4a");
var $7Wcl5 = parcelRequire("7Wcl5");
var $7F3bH = parcelRequire("7F3bH");

var $aJjuH = parcelRequire("aJjuH");

var $ezXKE = parcelRequire("ezXKE");

var $1hdeG = parcelRequire("1hdeG");

var $5VpBQ = parcelRequire("5VpBQ");

var $4eIn9 = parcelRequire("4eIn9");

var $5T1k5 = parcelRequire("5T1k5");

var $aDEnH = parcelRequire("aDEnH");

var $d1frE = parcelRequire("d1frE");

var $4EsxQ = parcelRequire("4EsxQ");

var $J7AIr = parcelRequire("J7AIr");

var $5q3a5 = parcelRequire("5q3a5");

var $6OLA9 = parcelRequire("6OLA9");

var $k4ank = parcelRequire("k4ank");
const $6ea5ba37aae09d8c$var$_excluded = [
    "autoFocus",
    "onViewChange",
    "date",
    "disableFuture",
    "disablePast",
    "defaultCalendarMonth",
    "onChange",
    "onYearChange",
    "onMonthChange",
    "reduceAnimations",
    "shouldDisableDate",
    "shouldDisableMonth",
    "shouldDisableYear",
    "view",
    "views",
    "openTo",
    "className",
    "disabled",
    "readOnly",
    "minDate",
    "maxDate",
    "disableHighlightToday",
    "focusedView",
    "onFocusedViewChange",
    "classes"
];
const $6ea5ba37aae09d8c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        viewTransitionContainer: [
            'viewTransitionContainer'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $6OLA9.getCalendarPickerUtilityClass), classes);
};
function $6ea5ba37aae09d8c$var$useCalendarPickerDefaultizedProps(props, name) {
    const utils = (0, $1hdeG.useUtils)();
    const defaultDates = (0, $1hdeG.useDefaultDates)();
    const themeProps = (0, $4wdE9.default)({
        props: props,
        name: name
    });
    return (0, $eJfrs.default)({
        loading: false,
        disablePast: false,
        disableFuture: false,
        openTo: 'day',
        views: [
            'year',
            'day'
        ],
        reduceAnimations: (0, $5q3a5.defaultReduceAnimations),
        renderLoading: ()=>/*#__PURE__*/ (0, $k4ank.jsx)("span", {
                children: "..."
            })
    }, themeProps, {
        minDate: (0, $4EsxQ.parseNonNullablePickerDate)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $4EsxQ.parseNonNullablePickerDate)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $6ea5ba37aae09d8c$var$CalendarPickerRoot = (0, $anJSP.default)((0, $J7AIr.PickerViewRoot), {
    name: 'MuiCalendarPicker',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexDirection: 'column'
});
const $6ea5ba37aae09d8c$var$CalendarPickerViewTransitionContainer = (0, $anJSP.default)((0, $5VpBQ.PickersFadeTransitionGroup), {
    name: 'MuiCalendarPicker',
    slot: 'ViewTransitionContainer',
    overridesResolver: (props, styles)=>styles.viewTransitionContainer
})({});
const $6ea5ba37aae09d8c$export$904d39b6b448e4e5 = /*#__PURE__*/ $8T3gX.forwardRef(function CalendarPicker(inProps, ref) {
    const utils = (0, $1hdeG.useUtils)();
    const id = (0, $1xq4a.default)();
    const props = $6ea5ba37aae09d8c$var$useCalendarPickerDefaultizedProps(inProps, 'MuiCalendarPicker');
    const { autoFocus: autoFocus, onViewChange: onViewChange, date: date, disableFuture: disableFuture, disablePast: disablePast, defaultCalendarMonth: defaultCalendarMonth, onChange: onChange, onYearChange: onYearChange, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, view: view, views: views, openTo: openTo, className: className, disabled: disabled, readOnly: readOnly, minDate: minDate, maxDate: maxDate, disableHighlightToday: disableHighlightToday, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange } = props, other = (0, $fAJB5.default)(props, $6ea5ba37aae09d8c$var$_excluded);
    const { openView: openView, setOpenView: setOpenView, openNext: openNext } = (0, $5T1k5.useViews)({
        view: view,
        views: views,
        openTo: openTo,
        onChange: onChange,
        onViewChange: onViewChange
    });
    const { calendarState: calendarState, changeFocusedDay: changeFocusedDay, changeMonth: changeMonth, handleChangeMonth: handleChangeMonth, isDateDisabled: isDateDisabled, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd } = (0, $ezXKE.useCalendarState)({
        date: date,
        defaultCalendarMonth: defaultCalendarMonth,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        disablePast: disablePast,
        disableFuture: disableFuture
    });
    const handleDateMonthChange = $8T3gX.useCallback((newDate, selectionState)=>{
        const startOfMonth = utils.startOfMonth(newDate);
        const endOfMonth = utils.endOfMonth(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $4EsxQ.findClosestEnabledDate)({
            utils: utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
            maxDate: utils.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled
        }) : newDate;
        if (closestEnabledDate) {
            onChange(closestEnabledDate, selectionState);
            onMonthChange == null || onMonthChange(startOfMonth);
        } else {
            openNext();
            changeMonth(startOfMonth);
        }
        changeFocusedDay(closestEnabledDate, true);
    }, [
        changeFocusedDay,
        disableFuture,
        disablePast,
        isDateDisabled,
        maxDate,
        minDate,
        onChange,
        onMonthChange,
        changeMonth,
        openNext,
        utils
    ]);
    const handleDateYearChange = $8T3gX.useCallback((newDate, selectionState)=>{
        const startOfYear = utils.startOfYear(newDate);
        const endOfYear = utils.endOfYear(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $4EsxQ.findClosestEnabledDate)({
            utils: utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfYear) ? startOfYear : minDate,
            maxDate: utils.isAfter(maxDate, endOfYear) ? endOfYear : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled
        }) : newDate;
        if (closestEnabledDate) {
            onChange(closestEnabledDate, selectionState);
            onYearChange == null || onYearChange(closestEnabledDate);
        } else {
            openNext();
            changeMonth(startOfYear);
        }
        changeFocusedDay(closestEnabledDate, true);
    }, [
        changeFocusedDay,
        disableFuture,
        disablePast,
        isDateDisabled,
        maxDate,
        minDate,
        onChange,
        onYearChange,
        openNext,
        utils,
        changeMonth
    ]);
    const onSelectedDayChange = $8T3gX.useCallback((day, isFinish)=>{
        if (date && day) // If there is a date already selected, then we want to keep its time
        return onChange(utils.mergeDateAndTime(day, date), isFinish);
        return onChange(day, isFinish);
    }, [
        utils,
        date,
        onChange
    ]);
    $8T3gX.useEffect(()=>{
        if (date) changeMonth(date);
    }, [
        date
    ]); // eslint-disable-line
    const ownerState = props;
    const classes = $6ea5ba37aae09d8c$var$useUtilityClasses(ownerState);
    const baseDateValidationProps = {
        disablePast: disablePast,
        disableFuture: disableFuture,
        maxDate: maxDate,
        minDate: minDate
    }; // When disabled, limit the view to the selected date
    const minDateWithDisabled = disabled && date || minDate;
    const maxDateWithDisabled = disabled && date || maxDate;
    const commonViewProps = {
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled
    };
    const gridLabelId = `${id}-grid-label`;
    const [internalFocusedView, setInternalFocusedView] = (0, $7Wcl5.default)({
        name: 'DayPicker',
        state: 'focusedView',
        controlled: focusedView,
        default: autoFocus ? openView : null
    });
    const hasFocus = internalFocusedView !== null;
    const handleFocusedViewChange = (0, $7F3bH.default)((eventView)=>(newHasFocus)=>{
            if (onFocusedViewChange) {
                // Use the calendar or clock logic
                onFocusedViewChange(eventView)(newHasFocus);
                return;
            } // If alone, do the local modifications
            if (newHasFocus) setInternalFocusedView(eventView);
            else setInternalFocusedView((prevView)=>prevView === eventView ? null : prevView);
        });
    const prevOpenViewRef = $8T3gX.useRef(openView);
    $8T3gX.useEffect(()=>{
        // Set focus to the button when switching from a view to another
        if (prevOpenViewRef.current === openView) return;
        prevOpenViewRef.current = openView;
        handleFocusedViewChange(openView)(true);
    }, [
        openView,
        handleFocusedViewChange
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)($6ea5ba37aae09d8c$var$CalendarPickerRoot, {
        ref: ref,
        className: (0, $hIlXQ.default)(classes.root, className),
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aDEnH.PickersCalendarHeader), (0, $eJfrs.default)({}, other, {
                views: views,
                openView: openView,
                currentMonth: calendarState.currentMonth,
                onViewChange: setOpenView,
                onMonthChange: (newMonth, direction)=>handleChangeMonth({
                        newMonth: newMonth,
                        direction: direction
                    }),
                minDate: minDateWithDisabled,
                maxDate: maxDateWithDisabled,
                disabled: disabled,
                disablePast: disablePast,
                disableFuture: disableFuture,
                reduceAnimations: reduceAnimations,
                labelId: gridLabelId
            })),
            /*#__PURE__*/ (0, $k4ank.jsx)($6ea5ba37aae09d8c$var$CalendarPickerViewTransitionContainer, {
                reduceAnimations: reduceAnimations,
                className: classes.viewTransitionContainer,
                transKey: openView,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    children: [
                        openView === 'year' && /*#__PURE__*/ (0, $k4ank.jsx)((0, $d1frE.YearPicker), (0, $eJfrs.default)({}, other, baseDateValidationProps, commonViewProps, {
                            autoFocus: autoFocus,
                            date: date,
                            onChange: handleDateYearChange,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: handleFocusedViewChange('year')
                        })),
                        openView === 'month' && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aJjuH.MonthPicker), (0, $eJfrs.default)({}, baseDateValidationProps, commonViewProps, {
                            autoFocus: autoFocus,
                            hasFocus: hasFocus,
                            className: className,
                            date: date,
                            onChange: handleDateMonthChange,
                            shouldDisableMonth: shouldDisableMonth,
                            onFocusedViewChange: handleFocusedViewChange('month')
                        })),
                        openView === 'day' && /*#__PURE__*/ (0, $k4ank.jsx)((0, $4eIn9.DayPicker), (0, $eJfrs.default)({}, other, calendarState, baseDateValidationProps, commonViewProps, {
                            autoFocus: autoFocus,
                            onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
                            onFocusedDayChange: changeFocusedDay,
                            reduceAnimations: reduceAnimations,
                            selectedDays: [
                                date
                            ],
                            onSelectedDaysChange: onSelectedDayChange,
                            shouldDisableDate: shouldDisableDate,
                            hasFocus: hasFocus,
                            onFocusedViewChange: handleFocusedViewChange('day'),
                            gridLabelId: gridLabelId
                        }))
                    ]
                })
            })
        ]
    });
});
$6ea5ba37aae09d8c$export$904d39b6b448e4e5.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Overrideable components.
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The props used for each component slot.
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    date: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter's method `getWeekdays`.
   * @returns {string} The name to display.
   * @default (day) => day.charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Default calendar month displayed when `value={null}`.
   */ defaultCalendarMonth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true` future days are disabled.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true` past days are disabled.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    focusedView: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Get aria-label text for switching between views button.
   * @param {CalendarPickerView} currentView The view from which we want to get the button text.
   * @returns {string} The label of the view.
   * @deprecated Use the `localeText` prop of `LocalizationProvider` instead, see https://mui.com/x/react-date-pickers/localization/.
   */ getViewSwitchingButtonText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Left arrow icon aria-label text.
   * @deprecated
   */ leftArrowButtonText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true` renders `LoadingComponent` in calendar instead of calendar view.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Maximal selectable date. @DateIOType
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Minimal selectable date. @DateIOType
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Callback fired on date change
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired,
    onFocusedViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback firing on month change @DateIOType.
   * @template TDate
   * @param {TDate} month The new month.
   * @returns {void|Promise} -
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired on view change.
   * @param {CalendarPickerView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback firing on year change @DateIOType.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Initially open view.
   * @default 'day'
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Make picker read only.
   * @default false
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Disable heavy animations.
   * @default typeof navigator !== 'undefined' && /(android)/i.test(navigator.userAgent)
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Custom renderer for day. Check the [PickersDay](https://mui.com/x/api/date-pickers/pickers-day/) component.
   * @template TDate
   * @param {TDate} day The day to render.
   * @param {Array<TDate | null>} selectedDays The days currently selected.
   * @param {PickersDayProps<TDate>} pickersDayProps The props of the day to render.
   * @returns {JSX.Element} The element representing the day.
   */ renderDay: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Right arrow icon aria-label text.
   * @deprecated
   */ rightArrowButtonText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Disable specific date. @DateIOType
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} Returns `true` if the date should be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Disable specific months dynamically.
   * Works like `shouldDisableDate` but for month selection view @DateIOType.
   * @template TDate
   * @param {TDate} month The month to check.
   * @returns {boolean} If `true` the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Disable specific years dynamically.
   * Works like `shouldDisableDate` but for year selection view @DateIOType.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} Returns `true` if the year should be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, days that have `outsideCurrentMonth={true}` are displayed.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Controlled open view.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Views for calendar picker.
   * @default ['year', 'day']
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'day',
        'month',
        'year'
    ]).isRequired)
};

});
parcelRegister("aJjuH", function(module, exports) {

$parcel$export(module.exports, "MonthPicker", () => $7cfd3a769427a37b$export$6e979f880d369f74);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $hIlXQ = parcelRequire("hIlXQ");

var $a4EsH = parcelRequire("a4EsH");

var $anJSP = parcelRequire("anJSP");
var $4wdE9 = parcelRequire("4wdE9");

var $aYNpO = parcelRequire("aYNpO");
var $7Wcl5 = parcelRequire("7Wcl5");
var $7F3bH = parcelRequire("7F3bH");

var $dgkKt = parcelRequire("dgkKt");

var $1hdeG = parcelRequire("1hdeG");

var $jKwpm = parcelRequire("jKwpm");

var $4EsxQ = parcelRequire("4EsxQ");

var $k4ank = parcelRequire("k4ank");
const $7cfd3a769427a37b$var$_excluded = [
    "className",
    "date",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "shouldDisableMonth",
    "readOnly",
    "disableHighlightToday",
    "autoFocus",
    "onMonthFocus",
    "hasFocus",
    "onFocusedViewChange"
];
const $7cfd3a769427a37b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $jKwpm.getMonthPickerUtilityClass), classes);
};
function $7cfd3a769427a37b$export$433328f406bb2390(props, name) {
    const utils = (0, $1hdeG.useUtils)();
    const defaultDates = (0, $1hdeG.useDefaultDates)();
    const themeProps = (0, $4wdE9.default)({
        props: props,
        name: name
    });
    return (0, $eJfrs.default)({
        disableFuture: false,
        disablePast: false
    }, themeProps, {
        minDate: (0, $4EsxQ.parseNonNullablePickerDate)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $4EsxQ.parseNonNullablePickerDate)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $7cfd3a769427a37b$var$MonthPickerRoot = (0, $anJSP.default)('div', {
    name: 'MuiMonthPicker',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    width: 310,
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'stretch',
    margin: '0 4px'
});
const $7cfd3a769427a37b$export$6e979f880d369f74 = /*#__PURE__*/ $8T3gX.forwardRef(function MonthPicker(inProps, ref) {
    const utils = (0, $1hdeG.useUtils)();
    const now = (0, $1hdeG.useNow)();
    const props = $7cfd3a769427a37b$export$433328f406bb2390(inProps, 'MuiMonthPicker');
    const { className: className, date: date, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, shouldDisableMonth: shouldDisableMonth, readOnly: readOnly, disableHighlightToday: disableHighlightToday, autoFocus: autoFocus = false, onMonthFocus: onMonthFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange } = props, other = (0, $fAJB5.default)(props, $7cfd3a769427a37b$var$_excluded);
    const ownerState = props;
    const classes = $7cfd3a769427a37b$var$useUtilityClasses(ownerState);
    const theme = (0, $a4EsH.default)();
    const selectedDateOrStartOfMonth = $8T3gX.useMemo(()=>date != null ? date : utils.startOfMonth(now), [
        now,
        utils,
        date
    ]);
    const selectedMonth = $8T3gX.useMemo(()=>{
        if (date != null) return utils.getMonth(date);
        if (disableHighlightToday) return null;
        return utils.getMonth(now);
    }, [
        now,
        date,
        utils,
        disableHighlightToday
    ]);
    const [focusedMonth, setFocusedMonth] = $8T3gX.useState(()=>selectedMonth || utils.getMonth(now));
    const isMonthDisabled = $8T3gX.useCallback((month)=>{
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        if (utils.isBefore(month, firstEnabledMonth)) return true;
        if (utils.isAfter(month, lastEnabledMonth)) return true;
        if (!shouldDisableMonth) return false;
        return shouldDisableMonth(month);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableMonth,
        utils
    ]);
    const onMonthSelect = (month)=>{
        if (readOnly) return;
        const newDate = utils.setMonth(selectedDateOrStartOfMonth, month);
        onChange(newDate, 'finish');
    };
    const [internalHasFocus, setInternalHasFocus] = (0, $7Wcl5.default)({
        name: 'MonthPicker',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus
    });
    const changeHasFocus = $8T3gX.useCallback((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    }, [
        setInternalHasFocus,
        onFocusedViewChange
    ]);
    const focusMonth = $8T3gX.useCallback((month)=>{
        if (!isMonthDisabled(utils.setMonth(selectedDateOrStartOfMonth, month))) {
            setFocusedMonth(month);
            changeHasFocus(true);
            if (onMonthFocus) onMonthFocus(month);
        }
    }, [
        isMonthDisabled,
        utils,
        selectedDateOrStartOfMonth,
        changeHasFocus,
        onMonthFocus
    ]);
    $8T3gX.useEffect(()=>{
        setFocusedMonth((prevFocusedMonth)=>selectedMonth !== null && prevFocusedMonth !== selectedMonth ? selectedMonth : prevFocusedMonth);
    }, [
        selectedMonth
    ]);
    const handleKeyDown = (0, $7F3bH.default)((event)=>{
        const monthsInYear = 12;
        const monthsInRow = 3;
        switch(event.key){
            case 'ArrowUp':
                focusMonth((monthsInYear + focusedMonth - monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusMonth((monthsInYear + focusedMonth + monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusMonth((monthsInYear + focusedMonth + (theme.direction === 'ltr' ? -1 : 1)) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusMonth((monthsInYear + focusedMonth + (theme.direction === 'ltr' ? 1 : -1)) % monthsInYear);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleMonthFocus = $8T3gX.useCallback((event, month)=>{
        focusMonth(month);
    }, [
        focusMonth
    ]);
    const handleMonthBlur = $8T3gX.useCallback(()=>{
        changeHasFocus(false);
    }, [
        changeHasFocus
    ]);
    const currentMonthNumber = utils.getMonth(now);
    return /*#__PURE__*/ (0, $k4ank.jsx)($7cfd3a769427a37b$var$MonthPickerRoot, (0, $eJfrs.default)({
        ref: ref,
        className: (0, $hIlXQ.default)(classes.root, className),
        ownerState: ownerState,
        onKeyDown: handleKeyDown
    }, other, {
        children: utils.getMonthArray(selectedDateOrStartOfMonth).map((month)=>{
            const monthNumber = utils.getMonth(month);
            const monthText = utils.format(month, 'monthShort');
            const isDisabled = disabled || isMonthDisabled(month);
            return /*#__PURE__*/ (0, $k4ank.jsx)((0, $dgkKt.PickersMonth), {
                value: monthNumber,
                selected: monthNumber === selectedMonth,
                tabIndex: monthNumber === focusedMonth && !isDisabled ? 0 : -1,
                hasFocus: internalHasFocus && monthNumber === focusedMonth,
                onSelect: onMonthSelect,
                onFocus: handleMonthFocus,
                onBlur: handleMonthBlur,
                disabled: isDisabled,
                "aria-current": currentMonthNumber === monthNumber ? 'date' : undefined,
                children: monthText
            }, monthText);
        })
    }));
});
$7cfd3a769427a37b$export$6e979f880d369f74.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * className applied to the root element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Date value for the MonthPicker
   */ date: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * If `true` picker is disabled
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true` future days are disabled.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true` past days are disabled.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    hasFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Maximal selectable date. @DateIOType
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Minimal selectable date. @DateIOType
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Callback fired on date change.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired,
    onFocusedViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    onMonthFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true` picker is readonly
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Disable specific months dynamically.
   * Works like `shouldDisableDate` but for month selection view @DateIOType.
   * @template TDate
   * @param {TDate} month The month to check.
   * @returns {boolean} If `true` the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};

});
parcelRegister("dgkKt", function(module, exports) {

$parcel$export(module.exports, "PickersMonth", () => $9a7cdd345decfb26$export$bc52fdb7f02f591a);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $f3puC = parcelRequire("f3puC");

var $3RYg6 = parcelRequire("3RYg6");
var $anJSP = parcelRequire("anJSP");

var $aYNpO = parcelRequire("aYNpO");

var $a9NOs = parcelRequire("a9NOs");

var $jsJJd = parcelRequire("jsJJd");

var $1mw6Z = parcelRequire("1mw6Z");

var $k4ank = parcelRequire("k4ank");
const $9a7cdd345decfb26$var$_excluded = [
    "disabled",
    "onSelect",
    "selected",
    "value",
    "tabIndex",
    "hasFocus",
    "onFocus",
    "onBlur"
];
const $9a7cdd345decfb26$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $1mw6Z.getPickersMonthUtilityClass), classes);
};
const $9a7cdd345decfb26$var$PickersMonthRoot = (0, $anJSP.default)((0, $f3puC.default), {
    name: 'PrivatePickersMonth',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, $1mw6Z.pickersMonthClasses).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $eJfrs.default)({
        flex: '1 0 33.33%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: '8px 0',
        height: 36,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus, &:hover': {
            backgroundColor: (0, $3RYg6.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            pointerEvents: 'none',
            color: theme.palette.text.secondary
        },
        [`&.${(0, $1mw6Z.pickersMonthClasses).selected}`]: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: theme.palette.primary.dark
            }
        }
    }));
const $9a7cdd345decfb26$var$noop = ()=>{};
const $9a7cdd345decfb26$export$bc52fdb7f02f591a = (props)=>{
    // TODO v6 add 'useThemeProps' once the component class names are aligned
    const { disabled: disabled, onSelect: onSelect, selected: selected, value: value, tabIndex: tabIndex, hasFocus: hasFocus, onFocus: onFocus = $9a7cdd345decfb26$var$noop, onBlur: onBlur = $9a7cdd345decfb26$var$noop } = props, other = (0, $fAJB5.default)(props, $9a7cdd345decfb26$var$_excluded);
    const classes = $9a7cdd345decfb26$var$useUtilityClasses(props);
    const handleSelection = ()=>{
        onSelect(value);
    };
    const ref = $8T3gX.useRef(null);
    (0, $a9NOs.default)(()=>{
        if (hasFocus) {
            var _ref$current;
            (_ref$current = ref.current) == null || _ref$current.focus();
        }
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsx)($9a7cdd345decfb26$var$PickersMonthRoot, (0, $eJfrs.default)({
        ref: ref,
        component: "button",
        type: "button",
        className: classes.root,
        tabIndex: tabIndex,
        onClick: handleSelection,
        onKeyDown: (0, $jsJJd.onSpaceOrEnter)(handleSelection),
        color: selected ? 'primary' : undefined,
        variant: selected ? 'h5' : 'subtitle1',
        disabled: disabled,
        onFocus: (event)=>onFocus(event, value),
        onBlur: (event)=>onBlur(event, value)
    }, other));
};

});
parcelRegister("3RYg6", function(module, exports) {

$parcel$export(module.exports, "alpha", () => $2d151078977196b6$export$58f0f39f63f3cf42);


var $eKiFq = parcelRequire("eKiFq");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $2d151078977196b6$var$clampWrapper(value, min = 0, max = 1) {
    if (value < min || value > max) console.error(`MUI: The value provided ${value} is out of range [${min}, ${max}].`);
    return (0, $eKiFq.default)(value, min, max);
}
function $2d151078977196b6$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $2d151078977196b6$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $2d151078977196b6$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $2d151078977196b6$export$677b39864803984e($2d151078977196b6$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error(`MUI: Unsupported \`${color}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().`);
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error(`MUI: unsupported \`${colorSpace}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.`);
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $2d151078977196b6$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $2d151078977196b6$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
const $2d151078977196b6$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $2d151078977196b6$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
};
function $2d151078977196b6$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $2d151078977196b6$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $2d151078977196b6$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$2d151078977196b6$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $2d151078977196b6$export$29fb7152bd3f781a(color) {
    color = $2d151078977196b6$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $2d151078977196b6$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $2d151078977196b6$export$c852d90bf7403b62(color) {
    color = $2d151078977196b6$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $2d151078977196b6$export$677b39864803984e($2d151078977196b6$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $2d151078977196b6$export$d061e26956a60b0a(foreground, background) {
    const lumA = $2d151078977196b6$export$c852d90bf7403b62(foreground);
    const lumB = $2d151078977196b6$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $2d151078977196b6$export$58f0f39f63f3cf42(color, value) {
    color = $2d151078977196b6$export$677b39864803984e(color);
    value = $2d151078977196b6$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $2d151078977196b6$export$211a73f2b8c10ce4(color);
}
function $2d151078977196b6$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $2d151078977196b6$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
}
function $2d151078977196b6$export$4b073707ff63303(color, coefficient) {
    color = $2d151078977196b6$export$677b39864803984e(color);
    coefficient = $2d151078977196b6$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $2d151078977196b6$export$211a73f2b8c10ce4(color);
}
function $2d151078977196b6$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $2d151078977196b6$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
}
function $2d151078977196b6$export$c0816ed86df316af(color, coefficient) {
    color = $2d151078977196b6$export$677b39864803984e(color);
    coefficient = $2d151078977196b6$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $2d151078977196b6$export$211a73f2b8c10ce4(color);
}
function $2d151078977196b6$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $2d151078977196b6$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
}
function $2d151078977196b6$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $2d151078977196b6$export$c852d90bf7403b62(color) > 0.5 ? $2d151078977196b6$export$4b073707ff63303(color, coefficient) : $2d151078977196b6$export$c0816ed86df316af(color, coefficient);
}
function $2d151078977196b6$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $2d151078977196b6$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        if (warning && true) console.warn(warning);
        return color;
    }
}
function $2d151078977196b6$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $2d151078977196b6$export$677b39864803984e(background);
    const overlayColor = $2d151078977196b6$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $2d151078977196b6$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}

});

parcelRegister("1mw6Z", function(module, exports) {

$parcel$export(module.exports, "getPickersMonthUtilityClass", () => $0fe0c13c4180c976$export$db90a620ac957a73);
$parcel$export(module.exports, "pickersMonthClasses", () => $0fe0c13c4180c976$export$911e3973fa70a12b);

var $kfTYv = parcelRequire("kfTYv");
var $jh2Zm = parcelRequire("jh2Zm");
function $0fe0c13c4180c976$export$db90a620ac957a73(slot) {
    // TODO v6 Rename 'PrivatePickersMonth' to 'MuiPickersMonth' to follow convention
    return (0, $kfTYv.default)('PrivatePickersMonth', slot);
}
const $0fe0c13c4180c976$export$911e3973fa70a12b = (0, $jh2Zm.default)('PrivatePickersMonth', [
    'root',
    'selected'
]);

});


parcelRegister("jKwpm", function(module, exports) {

$parcel$export(module.exports, "getMonthPickerUtilityClass", () => $e60b73bcb7891884$export$c42c06ed5a8e405);

var $kfTYv = parcelRequire("kfTYv");
var $jh2Zm = parcelRequire("jh2Zm");
function $e60b73bcb7891884$export$c42c06ed5a8e405(slot) {
    return (0, $kfTYv.default)('MuiMonthPicker', slot);
}
const $e60b73bcb7891884$export$9dafc1a6d475c4d8 = (0, $jh2Zm.default)('MuiMonthPicker', [
    'root'
]);

});


parcelRegister("ezXKE", function(module, exports) {

$parcel$export(module.exports, "useCalendarState", () => $a9d2aef0b4b431d6$export$6d095e787d2b5e1f);

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $KPkRL = parcelRequire("KPkRL");

var $1hdeG = parcelRequire("1hdeG");
const $a9d2aef0b4b431d6$export$2aba07ea6b6cf430 = (reduceAnimations, disableSwitchToMonthOnDayFocus, utils)=>(state, action)=>{
        switch(action.type){
            case 'changeMonth':
                return (0, $eJfrs.default)({}, state, {
                    slideDirection: action.direction,
                    currentMonth: action.newMonth,
                    isMonthSwitchingAnimating: !reduceAnimations
                });
            case 'finishMonthSwitchingAnimation':
                return (0, $eJfrs.default)({}, state, {
                    isMonthSwitchingAnimating: false
                });
            case 'changeFocusedDay':
                {
                    if (state.focusedDay != null && action.focusedDay != null && utils.isSameDay(action.focusedDay, state.focusedDay)) return state;
                    const needMonthSwitch = action.focusedDay != null && !disableSwitchToMonthOnDayFocus && !utils.isSameMonth(state.currentMonth, action.focusedDay);
                    return (0, $eJfrs.default)({}, state, {
                        focusedDay: action.focusedDay,
                        isMonthSwitchingAnimating: needMonthSwitch && !reduceAnimations && !action.withoutMonthSwitchingAnimation,
                        currentMonth: needMonthSwitch ? utils.startOfMonth(action.focusedDay) : state.currentMonth,
                        slideDirection: action.focusedDay != null && utils.isAfterDay(action.focusedDay, state.currentMonth) ? 'left' : 'right'
                    });
                }
            default:
                throw new Error('missing support');
        }
    };
const $a9d2aef0b4b431d6$export$6d095e787d2b5e1f = ({ date: date, defaultCalendarMonth: defaultCalendarMonth, disableFuture: disableFuture, disablePast: disablePast, disableSwitchToMonthOnDayFocus: disableSwitchToMonthOnDayFocus = false, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate })=>{
    var _ref;
    const now = (0, $1hdeG.useNow)();
    const utils = (0, $1hdeG.useUtils)();
    const reducerFn = $8T3gX.useRef($a9d2aef0b4b431d6$export$2aba07ea6b6cf430(Boolean(reduceAnimations), disableSwitchToMonthOnDayFocus, utils)).current;
    const [calendarState, dispatch] = $8T3gX.useReducer(reducerFn, {
        isMonthSwitchingAnimating: false,
        focusedDay: date || now,
        currentMonth: utils.startOfMonth((_ref = date != null ? date : defaultCalendarMonth) != null ? _ref : now),
        slideDirection: 'left'
    });
    const handleChangeMonth = $8T3gX.useCallback((payload)=>{
        dispatch((0, $eJfrs.default)({
            type: 'changeMonth'
        }, payload));
        if (onMonthChange) onMonthChange(payload.newMonth);
    }, [
        onMonthChange
    ]);
    const changeMonth = $8T3gX.useCallback((newDate)=>{
        const newDateRequested = newDate != null ? newDate : now;
        if (utils.isSameMonth(newDateRequested, calendarState.currentMonth)) return;
        handleChangeMonth({
            newMonth: utils.startOfMonth(newDateRequested),
            direction: utils.isAfterDay(newDateRequested, calendarState.currentMonth) ? 'left' : 'right'
        });
    }, [
        calendarState.currentMonth,
        handleChangeMonth,
        now,
        utils
    ]);
    const isDateDisabled = (0, $KPkRL.useIsDayDisabled)({
        shouldDisableDate: shouldDisableDate,
        minDate: minDate,
        maxDate: maxDate,
        disableFuture: disableFuture,
        disablePast: disablePast
    });
    const onMonthSwitchingAnimationEnd = $8T3gX.useCallback(()=>{
        dispatch({
            type: 'finishMonthSwitchingAnimation'
        });
    }, []);
    const changeFocusedDay = $8T3gX.useCallback((newFocusedDate, withoutMonthSwitchingAnimation)=>{
        if (!isDateDisabled(newFocusedDate)) dispatch({
            type: 'changeFocusedDay',
            focusedDay: newFocusedDate,
            withoutMonthSwitchingAnimation: withoutMonthSwitchingAnimation
        });
    }, [
        isDateDisabled
    ]);
    return {
        calendarState: calendarState,
        changeMonth: changeMonth,
        changeFocusedDay: changeFocusedDay,
        isDateDisabled: isDateDisabled,
        onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
        handleChangeMonth: handleChangeMonth
    };
};

});
parcelRegister("KPkRL", function(module, exports) {

$parcel$export(module.exports, "useIsDayDisabled", () => $08cc1e29cbc13638$export$a09328bc56100216);
$parcel$export(module.exports, "useDateValidation", () => $08cc1e29cbc13638$export$23305e90c90aec3f);

var $8T3gX = parcelRequire("8T3gX");

var $aEwiL = parcelRequire("aEwiL");

var $1hdeG = parcelRequire("1hdeG");

var $4EsxQ = parcelRequire("4EsxQ");
const $08cc1e29cbc13638$export$ffb3d0046ef3a2 = ({ props: props, value: value, adapter: adapter })=>{
    const now = adapter.utils.date();
    const date = adapter.utils.date(value);
    const minDate = (0, $4EsxQ.parseNonNullablePickerDate)(adapter.utils, props.minDate, adapter.defaultDates.minDate);
    const maxDate = (0, $4EsxQ.parseNonNullablePickerDate)(adapter.utils, props.maxDate, adapter.defaultDates.maxDate);
    if (date === null) return null;
    switch(true){
        case !adapter.utils.isValid(value):
            return 'invalidDate';
        case Boolean(props.shouldDisableDate && props.shouldDisableDate(date)):
            return 'shouldDisableDate';
        case Boolean(props.disableFuture && adapter.utils.isAfterDay(date, now)):
            return 'disableFuture';
        case Boolean(props.disablePast && adapter.utils.isBeforeDay(date, now)):
            return 'disablePast';
        case Boolean(minDate && adapter.utils.isBeforeDay(date, minDate)):
            return 'minDate';
        case Boolean(maxDate && adapter.utils.isAfterDay(date, maxDate)):
            return 'maxDate';
        default:
            return null;
    }
};
const $08cc1e29cbc13638$export$a09328bc56100216 = ({ shouldDisableDate: shouldDisableDate, minDate: minDate, maxDate: maxDate, disableFuture: disableFuture, disablePast: disablePast })=>{
    const adapter = (0, $1hdeG.useLocalizationContext)();
    return $8T3gX.useCallback((day)=>$08cc1e29cbc13638$export$ffb3d0046ef3a2({
            adapter: adapter,
            value: day,
            props: {
                shouldDisableDate: shouldDisableDate,
                minDate: minDate,
                maxDate: maxDate,
                disableFuture: disableFuture,
                disablePast: disablePast
            }
        }) !== null, [
        adapter,
        shouldDisableDate,
        minDate,
        maxDate,
        disableFuture,
        disablePast
    ]);
};
const $08cc1e29cbc13638$export$1fc3f7983deb8467 = (a, b)=>a === b;
const $08cc1e29cbc13638$export$23305e90c90aec3f = (props)=>(0, $aEwiL.useValidation)(props, $08cc1e29cbc13638$export$ffb3d0046ef3a2, $08cc1e29cbc13638$export$1fc3f7983deb8467);

});
parcelRegister("aEwiL", function(module, exports) {

$parcel$export(module.exports, "useValidation", () => $7c16b241ad17cb8a$export$87fe492f99f25a20);

var $8T3gX = parcelRequire("8T3gX");

var $1hdeG = parcelRequire("1hdeG");
function $7c16b241ad17cb8a$export$87fe492f99f25a20(props, validate, isSameError) {
    const { value: value, onError: onError } = props;
    const adapter = (0, $1hdeG.useLocalizationContext)();
    const previousValidationErrorRef = $8T3gX.useRef(null);
    const validationError = validate({
        adapter: adapter,
        value: value,
        props: props
    });
    $8T3gX.useEffect(()=>{
        if (onError && !isSameError(validationError, previousValidationErrorRef.current)) onError(validationError, value);
        previousValidationErrorRef.current = validationError;
    }, [
        isSameError,
        onError,
        previousValidationErrorRef,
        validationError,
        value
    ]);
    return validationError;
}

});



parcelRegister("5VpBQ", function(module, exports) {

$parcel$export(module.exports, "PickersFadeTransitionGroup", () => $011d009524108b05$export$5262185daf493fee);
parcelRequire("8T3gX");

var $hIlXQ = parcelRequire("hIlXQ");

var $lHoGT = parcelRequire("lHoGT");

var $anJSP = parcelRequire("anJSP");
var $4wdE9 = parcelRequire("4wdE9");

var $aYNpO = parcelRequire("aYNpO");

var $d07hW = parcelRequire("d07hW");

var $jVyFZ = parcelRequire("jVyFZ");

var $k4ank = parcelRequire("k4ank");
const $011d009524108b05$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $jVyFZ.getPickersFadeTransitionGroupUtilityClass), classes);
};
const $011d009524108b05$var$animationDuration = 500;
const $011d009524108b05$var$PickersFadeTransitionGroupRoot = (0, $anJSP.default)((0, $d07hW.default), {
    name: 'MuiPickersFadeTransitionGroup',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({
    display: 'block',
    position: 'relative'
});
function $011d009524108b05$export$5262185daf493fee(inProps) {
    const props = (0, $4wdE9.default)({
        props: inProps,
        name: 'MuiPickersFadeTransitionGroup'
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, transKey: transKey } = props;
    const classes = $011d009524108b05$var$useUtilityClasses(props);
    if (reduceAnimations) return children;
    return /*#__PURE__*/ (0, $k4ank.jsx)($011d009524108b05$var$PickersFadeTransitionGroupRoot, {
        className: (0, $hIlXQ.default)(classes.root, className),
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $lHoGT.default), {
            appear: false,
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: {
                appear: $011d009524108b05$var$animationDuration,
                enter: $011d009524108b05$var$animationDuration / 2,
                exit: 0
            },
            children: children
        }, transKey)
    });
}

});
parcelRegister("jVyFZ", function(module, exports) {

$parcel$export(module.exports, "getPickersFadeTransitionGroupUtilityClass", () => $e81e3d28bf090d70$export$5b0bb0174eb448ca);

var $kfTYv = parcelRequire("kfTYv");
var $jh2Zm = parcelRequire("jh2Zm");
const $e81e3d28bf090d70$export$5b0bb0174eb448ca = (slot)=>(0, $kfTYv.default)('MuiPickersFadeTransitionGroup', slot);
const $e81e3d28bf090d70$export$1461f245817ac559 = (0, $jh2Zm.default)('MuiPickersFadeTransitionGroup', [
    'root'
]);

});


parcelRegister("4eIn9", function(module, exports) {

$parcel$export(module.exports, "DayPicker", () => $315ae3a5d476c303$export$97e6db89a86ff7ab);

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $f3puC = parcelRequire("f3puC");

var $anJSP = parcelRequire("anJSP");
var $4nWZ9 = parcelRequire("4nWZ9");
var $4wdE9 = parcelRequire("4wdE9");

var $aYNpO = parcelRequire("aYNpO");

var $hIlXQ = parcelRequire("hIlXQ");

var $e5S0Y = parcelRequire("e5S0Y");

var $1hdeG = parcelRequire("1hdeG");

var $b75b5 = parcelRequire("b75b5");

var $76WD5 = parcelRequire("76WD5");

var $KPkRL = parcelRequire("KPkRL");

var $4EsxQ = parcelRequire("4EsxQ");

var $dYIWA = parcelRequire("dYIWA");

var $k4ank = parcelRequire("k4ank");
const $315ae3a5d476c303$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        header: [
            'header'
        ],
        weekDayLabel: [
            'weekDayLabel'
        ],
        loadingContainer: [
            'loadingContainer'
        ],
        slideTransition: [
            'slideTransition'
        ],
        monthContainer: [
            'monthContainer'
        ],
        weekContainer: [
            'weekContainer'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $dYIWA.getDayPickerUtilityClass), classes);
};
const $315ae3a5d476c303$var$defaultDayOfWeekFormatter = (day)=>day.charAt(0).toUpperCase();
const $315ae3a5d476c303$var$weeksContainerHeight = ((0, $b75b5.DAY_SIZE) + (0, $b75b5.DAY_MARGIN) * 2) * 6;
const $315ae3a5d476c303$var$PickersCalendarDayHeader = (0, $anJSP.default)('div', {
    name: 'MuiDayPicker',
    slot: 'Header',
    overridesResolver: (_, styles)=>styles.header
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $315ae3a5d476c303$var$PickersCalendarWeekDayLabel = (0, $anJSP.default)((0, $f3puC.default), {
    name: 'MuiDayPicker',
    slot: 'WeekDayLabel',
    overridesResolver: (_, styles)=>styles.weekDayLabel
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: theme.palette.text.secondary
    }));
const $315ae3a5d476c303$var$PickersCalendarLoadingContainer = (0, $anJSP.default)('div', {
    name: 'MuiDayPicker',
    slot: 'LoadingContainer',
    overridesResolver: (_, styles)=>styles.loadingContainer
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: $315ae3a5d476c303$var$weeksContainerHeight
});
const $315ae3a5d476c303$var$PickersCalendarSlideTransition = (0, $anJSP.default)((0, $76WD5.PickersSlideTransition), {
    name: 'MuiDayPicker',
    slot: 'SlideTransition',
    overridesResolver: (_, styles)=>styles.slideTransition
})({
    minHeight: $315ae3a5d476c303$var$weeksContainerHeight
});
const $315ae3a5d476c303$var$PickersCalendarWeekContainer = (0, $anJSP.default)('div', {
    name: 'MuiDayPicker',
    slot: 'MonthContainer',
    overridesResolver: (_, styles)=>styles.monthContainer
})({
    overflow: 'hidden'
});
const $315ae3a5d476c303$var$PickersCalendarWeek = (0, $anJSP.default)('div', {
    name: 'MuiDayPicker',
    slot: 'WeekContainer',
    overridesResolver: (_, styles)=>styles.weekContainer
})({
    margin: `${(0, $b75b5.DAY_MARGIN)}px 0`,
    display: 'flex',
    justifyContent: 'center'
});
function $315ae3a5d476c303$export$97e6db89a86ff7ab(inProps) {
    const now = (0, $1hdeG.useNow)();
    const utils = (0, $1hdeG.useUtils)();
    const props = (0, $4wdE9.default)({
        props: inProps,
        name: 'MuiDayPicker'
    });
    const classes = $315ae3a5d476c303$var$useUtilityClasses(props);
    const { onFocusedDayChange: onFocusedDayChange, className: className, currentMonth: currentMonth, selectedDays: selectedDays, disabled: disabled, disableHighlightToday: disableHighlightToday, focusedDay: focusedDay, isMonthSwitchingAnimating: isMonthSwitchingAnimating, loading: loading, onSelectedDaysChange: onSelectedDaysChange, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd, readOnly: readOnly, reduceAnimations: reduceAnimations, renderDay: renderDay, renderLoading: renderLoading = ()=>/*#__PURE__*/ (0, $k4ank.jsx)("span", {
            children: "..."
        }), showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, slideDirection: slideDirection, TransitionProps: TransitionProps, disablePast: disablePast, disableFuture: disableFuture, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, dayOfWeekFormatter: dayOfWeekFormatter = $315ae3a5d476c303$var$defaultDayOfWeekFormatter, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, gridLabelId: gridLabelId } = props;
    const isDateDisabled = (0, $KPkRL.useIsDayDisabled)({
        shouldDisableDate: shouldDisableDate,
        minDate: minDate,
        maxDate: maxDate,
        disablePast: disablePast,
        disableFuture: disableFuture
    });
    const [internalFocusedDay, setInternalFocusedDay] = $8T3gX.useState(()=>focusedDay || now);
    const changeHasFocus = $8T3gX.useCallback((newHasFocus)=>{
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    }, [
        onFocusedViewChange
    ]);
    const handleDaySelect = $8T3gX.useCallback((day, isFinish = 'finish')=>{
        if (readOnly) return;
        onSelectedDaysChange(day, isFinish);
    }, [
        onSelectedDaysChange,
        readOnly
    ]);
    const focusDay = $8T3gX.useCallback((day)=>{
        if (!isDateDisabled(day)) {
            onFocusedDayChange(day);
            setInternalFocusedDay(day);
            changeHasFocus(true);
        }
    }, [
        isDateDisabled,
        onFocusedDayChange,
        changeHasFocus
    ]);
    const theme = (0, $4nWZ9.default)();
    function handleKeyDown(event, day) {
        switch(event.key){
            case 'ArrowUp':
                focusDay(utils.addDays(day, -7));
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusDay(utils.addDays(day, 7));
                event.preventDefault();
                break;
            case 'ArrowLeft':
                {
                    const newFocusedDayDefault = utils.addDays(day, theme.direction === 'ltr' ? -1 : 1);
                    const nextAvailableMonth = theme.direction === 'ltr' ? utils.getPreviousMonth(day) : utils.getNextMonth(day);
                    const closestDayToFocus = (0, $4EsxQ.findClosestEnabledDate)({
                        utils: utils,
                        date: newFocusedDayDefault,
                        minDate: theme.direction === 'ltr' ? utils.startOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        maxDate: theme.direction === 'ltr' ? newFocusedDayDefault : utils.endOfMonth(nextAvailableMonth),
                        isDateDisabled: isDateDisabled
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'ArrowRight':
                {
                    const newFocusedDayDefault = utils.addDays(day, theme.direction === 'ltr' ? 1 : -1);
                    const nextAvailableMonth = theme.direction === 'ltr' ? utils.getNextMonth(day) : utils.getPreviousMonth(day);
                    const closestDayToFocus = (0, $4EsxQ.findClosestEnabledDate)({
                        utils: utils,
                        date: newFocusedDayDefault,
                        minDate: theme.direction === 'ltr' ? newFocusedDayDefault : utils.startOfMonth(nextAvailableMonth),
                        maxDate: theme.direction === 'ltr' ? utils.endOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        isDateDisabled: isDateDisabled
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'Home':
                focusDay(utils.startOfWeek(day));
                event.preventDefault();
                break;
            case 'End':
                focusDay(utils.endOfWeek(day));
                event.preventDefault();
                break;
            case 'PageUp':
                focusDay(utils.getNextMonth(day));
                event.preventDefault();
                break;
            case 'PageDown':
                focusDay(utils.getPreviousMonth(day));
                event.preventDefault();
                break;
            default:
                break;
        }
    }
    function handleFocus(event, day) {
        focusDay(day);
    }
    function handleBlur(event, day) {
        if (hasFocus && utils.isSameDay(internalFocusedDay, day)) changeHasFocus(false);
    }
    const currentMonthNumber = utils.getMonth(currentMonth);
    const validSelectedDays = selectedDays.filter((day)=>!!day).map((day)=>utils.startOfDay(day)); // need a new ref whenever the `key` of the transition changes: http://reactcommunity.org/react-transition-group/transition/#Transition-prop-nodeRef.
    const transitionKey = currentMonthNumber; // eslint-disable-next-line react-hooks/exhaustive-deps
    const slideNodeRef = $8T3gX.useMemo(()=>/*#__PURE__*/ $8T3gX.createRef(), [
        transitionKey
    ]);
    const startOfCurrentWeek = utils.startOfWeek(now);
    const focusableDay = $8T3gX.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(currentMonth);
        const endOfMonth = utils.endOfMonth(currentMonth);
        if (isDateDisabled(internalFocusedDay) || utils.isAfterDay(internalFocusedDay, endOfMonth) || utils.isBeforeDay(internalFocusedDay, startOfMonth)) return (0, $4EsxQ.findClosestEnabledDate)({
            utils: utils,
            date: internalFocusedDay,
            minDate: startOfMonth,
            maxDate: endOfMonth,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled
        });
        return internalFocusedDay;
    }, [
        currentMonth,
        disableFuture,
        disablePast,
        internalFocusedDay,
        isDateDisabled,
        utils
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        role: "grid",
        "aria-labelledby": gridLabelId,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)($315ae3a5d476c303$var$PickersCalendarDayHeader, {
                role: "row",
                className: classes.header,
                children: utils.getWeekdays().map((day, i)=>{
                    var _dayOfWeekFormatter;
                    return /*#__PURE__*/ (0, $k4ank.jsx)($315ae3a5d476c303$var$PickersCalendarWeekDayLabel, {
                        variant: "caption",
                        role: "columnheader",
                        "aria-label": utils.format(utils.addDays(startOfCurrentWeek, i), 'weekday'),
                        className: classes.weekDayLabel,
                        children: (_dayOfWeekFormatter = dayOfWeekFormatter == null ? void 0 : dayOfWeekFormatter(day)) != null ? _dayOfWeekFormatter : day
                    }, day + i.toString());
                })
            }),
            loading ? /*#__PURE__*/ (0, $k4ank.jsx)($315ae3a5d476c303$var$PickersCalendarLoadingContainer, {
                className: classes.loadingContainer,
                children: renderLoading()
            }) : /*#__PURE__*/ (0, $k4ank.jsx)($315ae3a5d476c303$var$PickersCalendarSlideTransition, (0, $eJfrs.default)({
                transKey: transitionKey,
                onExited: onMonthSwitchingAnimationEnd,
                reduceAnimations: reduceAnimations,
                slideDirection: slideDirection,
                className: (0, $hIlXQ.default)(className, classes.slideTransition)
            }, TransitionProps, {
                nodeRef: slideNodeRef,
                children: /*#__PURE__*/ (0, $k4ank.jsx)($315ae3a5d476c303$var$PickersCalendarWeekContainer, {
                    ref: slideNodeRef,
                    role: "rowgroup",
                    className: classes.monthContainer,
                    children: utils.getWeekArray(currentMonth).map((week)=>/*#__PURE__*/ (0, $k4ank.jsx)($315ae3a5d476c303$var$PickersCalendarWeek, {
                            role: "row",
                            className: classes.weekContainer,
                            children: week.map((day)=>{
                                const isFocusableDay = focusableDay !== null && utils.isSameDay(day, focusableDay);
                                const isSelected = validSelectedDays.some((selectedDay)=>utils.isSameDay(selectedDay, day));
                                const isToday = utils.isSameDay(day, now);
                                const pickersDayProps = {
                                    key: day == null ? void 0 : day.toString(),
                                    day: day,
                                    isAnimating: isMonthSwitchingAnimating,
                                    disabled: disabled || isDateDisabled(day),
                                    autoFocus: hasFocus && isFocusableDay,
                                    today: isToday,
                                    outsideCurrentMonth: utils.getMonth(day) !== currentMonthNumber,
                                    selected: isSelected,
                                    disableHighlightToday: disableHighlightToday,
                                    showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
                                    onKeyDown: handleKeyDown,
                                    onFocus: handleFocus,
                                    onBlur: handleBlur,
                                    onDaySelect: handleDaySelect,
                                    tabIndex: isFocusableDay ? 0 : -1,
                                    role: 'gridcell',
                                    'aria-selected': isSelected
                                };
                                if (isToday) pickersDayProps['aria-current'] = 'date';
                                return renderDay ? renderDay(day, validSelectedDays, pickersDayProps) : /*#__PURE__*/ (0, $8T3gX.createElement)((0, $e5S0Y.PickersDay), (0, $eJfrs.default)({}, pickersDayProps, {
                                    key: pickersDayProps.key
                                }));
                            })
                        }, `week-${week[0]}`))
                })
            }))
        ]
    });
}

});
parcelRegister("e5S0Y", function(module, exports) {

$parcel$export(module.exports, "PickersDay", () => $a42b6e898a0a7eee$export$d7378e6e864346fa);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $hIlXQ = parcelRequire("hIlXQ");

var $hhKOZ = parcelRequire("hhKOZ");

var $5IwAt = parcelRequire("5IwAt");

var $aYNpO = parcelRequire("aYNpO");

var $3RYg6 = parcelRequire("3RYg6");
var $anJSP = parcelRequire("anJSP");
var $4wdE9 = parcelRequire("4wdE9");

var $11ydL = parcelRequire("11ydL");

var $1hdeG = parcelRequire("1hdeG");

var $b75b5 = parcelRequire("b75b5");

var $9JsvE = parcelRequire("9JsvE");

var $k4ank = parcelRequire("k4ank");
const $a42b6e898a0a7eee$var$_excluded = [
    "autoFocus",
    "className",
    "day",
    "disabled",
    "disableHighlightToday",
    "disableMargin",
    "hidden",
    "isAnimating",
    "onClick",
    "onDaySelect",
    "onFocus",
    "onBlur",
    "onKeyDown",
    "onMouseDown",
    "outsideCurrentMonth",
    "selected",
    "showDaysOutsideCurrentMonth",
    "children",
    "today"
];
const $a42b6e898a0a7eee$var$useUtilityClasses = (ownerState)=>{
    const { selected: selected, disableMargin: disableMargin, disableHighlightToday: disableHighlightToday, today: today, disabled: disabled, outsideCurrentMonth: outsideCurrentMonth, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            disabled && 'disabled',
            !disableMargin && 'dayWithMargin',
            !disableHighlightToday && today && 'today',
            outsideCurrentMonth && showDaysOutsideCurrentMonth && 'dayOutsideMonth',
            outsideCurrentMonth && !showDaysOutsideCurrentMonth && 'hiddenDaySpacingFiller'
        ],
        hiddenDaySpacingFiller: [
            'hiddenDaySpacingFiller'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $9JsvE.getPickersDayUtilityClass), classes);
};
const $a42b6e898a0a7eee$var$styleArg = ({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({}, theme.typography.caption, {
        width: (0, $b75b5.DAY_SIZE),
        height: (0, $b75b5.DAY_SIZE),
        borderRadius: '50%',
        padding: 0,
        // background required here to prevent collides with the other days when animating with transition group
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        '&:hover': {
            backgroundColor: (0, $3RYg6.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:focus': {
            backgroundColor: (0, $3RYg6.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            [`&.${(0, $9JsvE.pickersDayClasses).selected}`]: {
                willChange: 'background-color',
                backgroundColor: theme.palette.primary.dark
            }
        },
        [`&.${(0, $9JsvE.pickersDayClasses).selected}`]: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            transition: theme.transitions.create('background-color', {
                duration: theme.transitions.duration.short
            }),
            '&:hover': {
                willChange: 'background-color',
                backgroundColor: theme.palette.primary.dark
            }
        },
        [`&.${(0, $9JsvE.pickersDayClasses).disabled}`]: {
            color: theme.palette.text.disabled
        }
    }, !ownerState.disableMargin && {
        margin: `0 ${0, $b75b5.DAY_MARGIN}px`
    }, ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && {
        color: theme.palette.text.secondary
    }, !ownerState.disableHighlightToday && ownerState.today && {
        [`&:not(.${(0, $9JsvE.pickersDayClasses).selected})`]: {
            border: `1px solid ${theme.palette.text.secondary}`
        }
    });
const $a42b6e898a0a7eee$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        !ownerState.disableMargin && styles.dayWithMargin,
        !ownerState.disableHighlightToday && ownerState.today && styles.today,
        !ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth,
        ownerState.outsideCurrentMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller
    ];
};
const $a42b6e898a0a7eee$var$PickersDayRoot = (0, $anJSP.default)((0, $hhKOZ.default), {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver: $a42b6e898a0a7eee$var$overridesResolver
})($a42b6e898a0a7eee$var$styleArg);
const $a42b6e898a0a7eee$var$PickersDayFiller = (0, $anJSP.default)('div', {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver: $a42b6e898a0a7eee$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({}, $a42b6e898a0a7eee$var$styleArg({
        theme: theme,
        ownerState: ownerState
    }), {
        // visibility: 'hidden' does not work here as it hides the element from screen readers as well
        opacity: 0,
        pointerEvents: 'none'
    }));
const $a42b6e898a0a7eee$var$noop = ()=>{};
const $a42b6e898a0a7eee$var$PickersDayRaw = /*#__PURE__*/ $8T3gX.forwardRef(function PickersDay(inProps, forwardedRef) {
    const props = (0, $4wdE9.default)({
        props: inProps,
        name: 'MuiPickersDay'
    });
    const { autoFocus: autoFocus = false, className: className, day: day, disabled: disabled = false, disableHighlightToday: disableHighlightToday = false, disableMargin: disableMargin = false, isAnimating: isAnimating, onClick: onClick, onDaySelect: onDaySelect, onFocus: onFocus = $a42b6e898a0a7eee$var$noop, onBlur: onBlur = $a42b6e898a0a7eee$var$noop, onKeyDown: onKeyDown = $a42b6e898a0a7eee$var$noop, onMouseDown: onMouseDown, outsideCurrentMonth: outsideCurrentMonth, selected: selected = false, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth = false, children: children, today: isToday = false } = props, other = (0, $fAJB5.default)(props, $a42b6e898a0a7eee$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        autoFocus: autoFocus,
        disabled: disabled,
        disableHighlightToday: disableHighlightToday,
        disableMargin: disableMargin,
        selected: selected,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        today: isToday
    });
    const classes = $a42b6e898a0a7eee$var$useUtilityClasses(ownerState);
    const utils = (0, $1hdeG.useUtils)();
    const ref = $8T3gX.useRef(null);
    const handleRef = (0, $11ydL.default)(ref, forwardedRef); // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $5IwAt.default)(()=>{
        if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) // ref.current being null would be a bug in MUI
        ref.current.focus();
    }, [
        autoFocus,
        disabled,
        isAnimating,
        outsideCurrentMonth
    ]); // For day outside of current month, move focus from mouseDown to mouseUp
    // Goal: have the onClick ends before sliding to the new month
    const handleMouseDown = (event)=>{
        if (onMouseDown) onMouseDown(event);
        if (outsideCurrentMonth) event.preventDefault();
    };
    const handleClick = (event)=>{
        if (!disabled) onDaySelect(day, 'finish');
        if (outsideCurrentMonth) event.currentTarget.focus();
        if (onClick) onClick(event);
    };
    if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) return /*#__PURE__*/ (0, $k4ank.jsx)($a42b6e898a0a7eee$var$PickersDayFiller, {
        className: (0, $hIlXQ.default)(classes.root, classes.hiddenDaySpacingFiller, className),
        ownerState: ownerState,
        role: other.role
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)($a42b6e898a0a7eee$var$PickersDayRoot, (0, $eJfrs.default)({
        className: (0, $hIlXQ.default)(classes.root, className),
        ownerState: ownerState,
        ref: handleRef,
        centerRipple: true,
        disabled: disabled,
        tabIndex: selected ? 0 : -1,
        onKeyDown: (event)=>onKeyDown(event, day),
        onFocus: (event)=>onFocus(event, day),
        onBlur: (event)=>onBlur(event, day),
        onClick: handleClick,
        onMouseDown: handleMouseDown
    }, other, {
        children: !children ? utils.format(day, 'dayOfMonth') : children
    }));
});
const $a42b6e898a0a7eee$export$1fa4d5e98414e66a = (prevProps, nextProps)=>{
    return prevProps.autoFocus === nextProps.autoFocus && prevProps.isAnimating === nextProps.isAnimating && prevProps.today === nextProps.today && prevProps.disabled === nextProps.disabled && prevProps.selected === nextProps.selected && prevProps.disableMargin === nextProps.disableMargin && prevProps.showDaysOutsideCurrentMonth === nextProps.showDaysOutsideCurrentMonth && prevProps.disableHighlightToday === nextProps.disableHighlightToday && prevProps.className === nextProps.className && prevProps.sx === nextProps.sx && prevProps.outsideCurrentMonth === nextProps.outsideCurrentMonth && prevProps.onFocus === nextProps.onFocus && prevProps.onBlur === nextProps.onBlur && prevProps.onDaySelect === nextProps.onDaySelect;
};
$a42b6e898a0a7eee$var$PickersDayRaw.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The date to show.
   */ day: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any.isRequired,
    /**
   * If `true`, renders as disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, days are rendering without margin. Useful for displaying linked range of days.
   * @default false
   */ disableMargin: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    isAnimating: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    onDaySelect: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired,
    onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    onKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, day is outside of month and will be hidden.
   */ outsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool.isRequired,
    /**
   * If `true`, renders as selected.
   * @default false
   */ selected: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, days that have `outsideCurrentMonth={true}` are displayed.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * If `true`, renders as today date.
   * @default false
   */ today: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
};
const $a42b6e898a0a7eee$export$d7378e6e864346fa = /*#__PURE__*/ $8T3gX.memo($a42b6e898a0a7eee$var$PickersDayRaw, $a42b6e898a0a7eee$export$1fa4d5e98414e66a);

});
parcelRegister("9JsvE", function(module, exports) {

$parcel$export(module.exports, "getPickersDayUtilityClass", () => $715e6e70fb004081$export$4b25deb0350d3e53);
$parcel$export(module.exports, "pickersDayClasses", () => $715e6e70fb004081$export$68b221ad3c35e288);

var $kfTYv = parcelRequire("kfTYv");
var $jh2Zm = parcelRequire("jh2Zm");
function $715e6e70fb004081$export$4b25deb0350d3e53(slot) {
    return (0, $kfTYv.default)('MuiPickersDay', slot);
}
const $715e6e70fb004081$export$68b221ad3c35e288 = (0, $jh2Zm.default)('MuiPickersDay', [
    'root',
    'dayWithMargin',
    'dayOutsideMonth',
    'hiddenDaySpacingFiller',
    'today',
    'selected',
    'disabled'
]);

});


parcelRegister("76WD5", function(module, exports) {

$parcel$export(module.exports, "PickersSlideTransition", () => $01560a9f10a0366a$export$e868fcc7557d3a06);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $hIlXQ = parcelRequire("hIlXQ");

var $anJSP = parcelRequire("anJSP");

var $aYNpO = parcelRequire("aYNpO");

var $aOnLJ = parcelRequire("aOnLJ");
var $d07hW = parcelRequire("d07hW");

var $8Nclr = parcelRequire("8Nclr");

var $k4ank = parcelRequire("k4ank");
const $01560a9f10a0366a$var$_excluded = [
    "children",
    "className",
    "reduceAnimations",
    "slideDirection",
    "transKey"
];
const $01560a9f10a0366a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $8Nclr.getPickersSlideTransitionUtilityClass), classes);
};
const $01560a9f10a0366a$export$ee7cc8ee8a5215ec = 350;
const $01560a9f10a0366a$var$PickersSlideTransitionRoot = (0, $anJSP.default)((0, $d07hW.default), {
    name: 'PrivatePickersSlideTransition',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`.${(0, $8Nclr.pickersSlideTransitionClasses)['slideEnter-left']}`]: styles['slideEnter-left']
            },
            {
                [`.${(0, $8Nclr.pickersSlideTransitionClasses)['slideEnter-right']}`]: styles['slideEnter-right']
            },
            {
                [`.${(0, $8Nclr.pickersSlideTransitionClasses).slideEnterActive}`]: styles.slideEnterActive
            },
            {
                [`.${(0, $8Nclr.pickersSlideTransitionClasses).slideExit}`]: styles.slideExit
            },
            {
                [`.${(0, $8Nclr.pickersSlideTransitionClasses)['slideExitActiveLeft-left']}`]: styles['slideExitActiveLeft-left']
            },
            {
                [`.${(0, $8Nclr.pickersSlideTransitionClasses)['slideExitActiveLeft-right']}`]: styles['slideExitActiveLeft-right']
            }
        ]
})(({ theme: theme })=>{
    const slideTransition = theme.transitions.create('transform', {
        duration: $01560a9f10a0366a$export$ee7cc8ee8a5215ec,
        easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
    });
    return {
        display: 'block',
        position: 'relative',
        overflowX: 'hidden',
        '& > *': {
            position: 'absolute',
            top: 0,
            right: 0,
            left: 0
        },
        [`& .${(0, $8Nclr.pickersSlideTransitionClasses)['slideEnter-left']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            zIndex: 1
        },
        [`& .${(0, $8Nclr.pickersSlideTransitionClasses)['slideEnter-right']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            zIndex: 1
        },
        [`& .${(0, $8Nclr.pickersSlideTransitionClasses).slideEnterActive}`]: {
            transform: 'translate(0%)',
            transition: slideTransition
        },
        [`& .${(0, $8Nclr.pickersSlideTransitionClasses).slideExit}`]: {
            transform: 'translate(0%)'
        },
        [`& .${(0, $8Nclr.pickersSlideTransitionClasses)['slideExitActiveLeft-left']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            transition: slideTransition,
            zIndex: 0
        },
        [`& .${(0, $8Nclr.pickersSlideTransitionClasses)['slideExitActiveLeft-right']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            transition: slideTransition,
            zIndex: 0
        }
    };
});
const $01560a9f10a0366a$export$e868fcc7557d3a06 = (props)=>{
    // TODO v6: add 'useThemeProps' once the component class names are aligned
    const { children: children, className: className, reduceAnimations: reduceAnimations, slideDirection: slideDirection, transKey: transKey } = props, other = (0, $fAJB5.default)(props, $01560a9f10a0366a$var$_excluded);
    const classes = $01560a9f10a0366a$var$useUtilityClasses(props);
    if (reduceAnimations) return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: (0, $hIlXQ.default)(classes.root, className),
        children: children
    });
    const transitionClasses = {
        exit: (0, $8Nclr.pickersSlideTransitionClasses).slideExit,
        enterActive: (0, $8Nclr.pickersSlideTransitionClasses).slideEnterActive,
        enter: (0, $8Nclr.pickersSlideTransitionClasses)[`slideEnter-${slideDirection}`],
        exitActive: (0, $8Nclr.pickersSlideTransitionClasses)[`slideExitActiveLeft-${slideDirection}`]
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)($01560a9f10a0366a$var$PickersSlideTransitionRoot, {
        className: (0, $hIlXQ.default)(classes.root, className),
        childFactory: (element)=>/*#__PURE__*/ $8T3gX.cloneElement(element, {
                classNames: transitionClasses
            }),
        role: "presentation",
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aOnLJ.default), (0, $eJfrs.default)({
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: $01560a9f10a0366a$export$ee7cc8ee8a5215ec,
            classNames: transitionClasses
        }, other, {
            children: children
        }), transKey)
    });
};

});
parcelRegister("aOnLJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7df102e80bc5fafc$export$2e2bcd8739ae039);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8pync = parcelRequire("8pync");

var $fdGrT = parcelRequire("fdGrT");

var $l4DLB = parcelRequire("l4DLB");

var $gofkn = parcelRequire("gofkn");

var $8T3gX = parcelRequire("8T3gX");

var $8zaeI = parcelRequire("8zaeI");

var $9eunv = parcelRequire("9eunv");

var $hLM6y = parcelRequire("hLM6y");
var $7df102e80bc5fafc$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $l4DLB.default)(node, c);
    });
};
var $7df102e80bc5fafc$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $gofkn.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $7df102e80bc5fafc$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $8pync.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, $hLM6y.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $7df102e80bc5fafc$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $7df102e80bc5fafc$var$removeClass(node, baseClassName);
        if (activeClassName) $7df102e80bc5fafc$var$removeClass(node, activeClassName);
        if (doneClassName) $7df102e80bc5fafc$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $fAJB5.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $8zaeI.default), (0, $eJfrs.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Component);
$7df102e80bc5fafc$var$CSSTransition.defaultProps = {
    classNames: ''
};
$7df102e80bc5fafc$var$CSSTransition.propTypes = (0, $eJfrs.default)({}, (0, $8zaeI.default).propTypes, {
    /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */ classNames: (0, $9eunv.classNamesShape),
    /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
});
var $7df102e80bc5fafc$export$2e2bcd8739ae039 = $7df102e80bc5fafc$var$CSSTransition;

});
parcelRegister("l4DLB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f578d18afcfa4e57$export$2e2bcd8739ae039);

var $lBUdM = parcelRequire("lBUdM");
function $f578d18afcfa4e57$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $lBUdM.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}

});
parcelRegister("lBUdM", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbb8aa1191db27dc$export$2e2bcd8739ae039);
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $fbb8aa1191db27dc$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});


parcelRegister("gofkn", function(module, exports) {

$parcel$export(module.exports, "default", () => $beeac6f743a527fd$export$2e2bcd8739ae039);
function $beeac6f743a527fd$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $beeac6f743a527fd$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $beeac6f743a527fd$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $beeac6f743a527fd$var$replaceClassName(element.className && element.className.baseVal || '', className));
}

});


parcelRegister("8Nclr", function(module, exports) {

$parcel$export(module.exports, "getPickersSlideTransitionUtilityClass", () => $666c79c89e3e86be$export$e98c1b6c3bbc3c59);
$parcel$export(module.exports, "pickersSlideTransitionClasses", () => $666c79c89e3e86be$export$d251a58673156a67);

var $kfTYv = parcelRequire("kfTYv");
var $jh2Zm = parcelRequire("jh2Zm");
const $666c79c89e3e86be$export$e98c1b6c3bbc3c59 = (slot)=>(0, $kfTYv.default)('PrivatePickersSlideTransition', slot);
const $666c79c89e3e86be$export$d251a58673156a67 = (0, $jh2Zm.default)('PrivatePickersSlideTransition', [
    'root',
    'slideEnter-left',
    'slideEnter-right',
    'slideEnterActive',
    'slideExit',
    'slideExitActiveLeft-left',
    'slideExitActiveLeft-right'
]);

});


parcelRegister("dYIWA", function(module, exports) {

$parcel$export(module.exports, "getDayPickerUtilityClass", () => $a2d3bde0a7a1caa2$export$7735989980a2c0b6);

var $kfTYv = parcelRequire("kfTYv");
var $jh2Zm = parcelRequire("jh2Zm");
const $a2d3bde0a7a1caa2$export$7735989980a2c0b6 = (slot)=>(0, $kfTYv.default)('MuiDayPicker', slot);
const $a2d3bde0a7a1caa2$export$e0770f35b28ac552 = (0, $jh2Zm.default)('MuiDayPicker', [
    'header',
    'weekDayLabel',
    'loadingContainer',
    'slideTransition',
    'monthContainer',
    'weekContainer'
]);

});


parcelRegister("aDEnH", function(module, exports) {

$parcel$export(module.exports, "PickersCalendarHeader", () => $7becdec64cfb247c$export$6801ffebb353f473);

var $eJfrs = parcelRequire("eJfrs");
parcelRequire("8T3gX");

var $lHoGT = parcelRequire("lHoGT");

var $anJSP = parcelRequire("anJSP");
var $4wdE9 = parcelRequire("4wdE9");

var $aYNpO = parcelRequire("aYNpO");

var $iKAtE = parcelRequire("iKAtE");

var $1hdeG = parcelRequire("1hdeG");

var $5VpBQ = parcelRequire("5VpBQ");

var $hIg9z = parcelRequire("hIg9z");

var $ihjWR = parcelRequire("ihjWR");

var $ekk2W = parcelRequire("ekk2W");

var $daBls = parcelRequire("daBls");

var $PVpGa = parcelRequire("PVpGa");

var $k4ank = parcelRequire("k4ank");
const $7becdec64cfb247c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        labelContainer: [
            'labelContainer'
        ],
        label: [
            'label'
        ],
        switchViewButton: [
            'switchViewButton'
        ],
        switchViewIcon: [
            'switchViewIcon'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $PVpGa.getPickersCalendarHeaderUtilityClass), classes);
};
const $7becdec64cfb247c$var$PickersCalendarHeaderRoot = (0, $anJSP.default)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({
    display: 'flex',
    alignItems: 'center',
    marginTop: 16,
    marginBottom: 8,
    paddingLeft: 24,
    paddingRight: 12,
    // prevent jumping in safari
    maxHeight: 30,
    minHeight: 30
});
const $7becdec64cfb247c$var$PickersCalendarHeaderLabelContainer = (0, $anJSP.default)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'LabelContainer',
    overridesResolver: (_, styles)=>styles.labelContainer
})(({ theme: theme })=>(0, $eJfrs.default)({
        display: 'flex',
        maxHeight: 30,
        overflow: 'hidden',
        alignItems: 'center',
        cursor: 'pointer',
        marginRight: 'auto'
    }, theme.typography.body1, {
        fontWeight: theme.typography.fontWeightMedium
    }));
const $7becdec64cfb247c$var$PickersCalendarHeaderLabel = (0, $anJSP.default)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Label',
    overridesResolver: (_, styles)=>styles.label
})({
    marginRight: 6
});
const $7becdec64cfb247c$var$PickersCalendarHeaderSwitchViewButton = (0, $anJSP.default)((0, $iKAtE.default), {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewButton',
    overridesResolver: (_, styles)=>styles.switchViewButton
})({
    marginRight: 'auto'
});
const $7becdec64cfb247c$var$PickersCalendarHeaderSwitchViewIcon = (0, $anJSP.default)((0, $hIg9z.ArrowDropDown), {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewIcon',
    overridesResolver: (_, styles)=>styles.switchViewIcon
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        willChange: 'transform',
        transition: theme.transitions.create('transform'),
        transform: 'rotate(0deg)'
    }, ownerState.openView === 'year' && {
        transform: 'rotate(180deg)'
    }));
const $7becdec64cfb247c$var$deprecatedPropsWarning = (0, $daBls.buildDeprecatedPropsWarning)('Props for translation are deprecated. See https://mui.com/x/react-date-pickers/localization for more information.');
function $7becdec64cfb247c$export$6801ffebb353f473(inProps) {
    const props = (0, $4wdE9.default)({
        props: inProps,
        name: 'MuiPickersCalendarHeader'
    });
    const { components: components = {}, componentsProps: componentsProps = {}, currentMonth: month, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, getViewSwitchingButtonText: getViewSwitchingButtonTextProp, leftArrowButtonText: leftArrowButtonTextProp, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, onViewChange: onViewChange, openView: currentView, reduceAnimations: reduceAnimations, rightArrowButtonText: rightArrowButtonTextProp, views: views, labelId: labelId } = props;
    $7becdec64cfb247c$var$deprecatedPropsWarning({
        leftArrowButtonText: leftArrowButtonTextProp,
        rightArrowButtonText: rightArrowButtonTextProp,
        getViewSwitchingButtonText: getViewSwitchingButtonTextProp
    });
    const localeText = (0, $1hdeG.useLocaleText)();
    const leftArrowButtonText = leftArrowButtonTextProp != null ? leftArrowButtonTextProp : localeText.previousMonth;
    const rightArrowButtonText = rightArrowButtonTextProp != null ? rightArrowButtonTextProp : localeText.nextMonth;
    const getViewSwitchingButtonText = getViewSwitchingButtonTextProp != null ? getViewSwitchingButtonTextProp : localeText.calendarViewSwitchingButtonAriaLabel;
    const utils = (0, $1hdeG.useUtils)();
    const classes = $7becdec64cfb247c$var$useUtilityClasses(props);
    const switchViewButtonProps = componentsProps.switchViewButton || {};
    const selectNextMonth = ()=>onMonthChange(utils.getNextMonth(month), 'left');
    const selectPreviousMonth = ()=>onMonthChange(utils.getPreviousMonth(month), 'right');
    const isNextMonthDisabled = (0, $ekk2W.useNextMonthDisabled)(month, {
        disableFuture: disableFuture,
        maxDate: maxDate
    });
    const isPreviousMonthDisabled = (0, $ekk2W.usePreviousMonthDisabled)(month, {
        disablePast: disablePast,
        minDate: minDate
    });
    const handleToggleView = ()=>{
        if (views.length === 1 || !onViewChange || disabled) return;
        if (views.length === 2) onViewChange(views.find((view)=>view !== currentView) || views[0]);
        else {
            // switching only between first 2
            const nextIndexToOpen = views.indexOf(currentView) !== 0 ? 0 : 1;
            onViewChange(views[nextIndexToOpen]);
        }
    }; // No need to display more information
    if (views.length === 1 && views[0] === 'year') return null;
    const ownerState = props;
    return /*#__PURE__*/ (0, $k4ank.jsxs)($7becdec64cfb247c$var$PickersCalendarHeaderRoot, {
        ownerState: ownerState,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)($7becdec64cfb247c$var$PickersCalendarHeaderLabelContainer, {
                role: "presentation",
                onClick: handleToggleView,
                ownerState: ownerState // putting this on the label item element below breaks when using transition
                ,
                "aria-live": "polite",
                className: classes.labelContainer,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $5VpBQ.PickersFadeTransitionGroup), {
                        reduceAnimations: reduceAnimations,
                        transKey: utils.format(month, 'monthAndYear'),
                        children: /*#__PURE__*/ (0, $k4ank.jsx)($7becdec64cfb247c$var$PickersCalendarHeaderLabel, {
                            id: labelId,
                            ownerState: ownerState,
                            className: classes.label,
                            children: utils.format(month, 'monthAndYear')
                        })
                    }),
                    views.length > 1 && !disabled && /*#__PURE__*/ (0, $k4ank.jsx)($7becdec64cfb247c$var$PickersCalendarHeaderSwitchViewButton, (0, $eJfrs.default)({
                        size: "small",
                        as: components.SwitchViewButton,
                        "aria-label": getViewSwitchingButtonText(currentView),
                        className: classes.switchViewButton
                    }, switchViewButtonProps, {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)($7becdec64cfb247c$var$PickersCalendarHeaderSwitchViewIcon, {
                            as: components.SwitchViewIcon,
                            ownerState: ownerState,
                            className: classes.switchViewIcon
                        })
                    }))
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $lHoGT.default), {
                in: currentView === 'day',
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ihjWR.PickersArrowSwitcher), {
                    leftArrowButtonText: leftArrowButtonText,
                    rightArrowButtonText: rightArrowButtonText,
                    components: components,
                    componentsProps: componentsProps,
                    onLeftClick: selectPreviousMonth,
                    onRightClick: selectNextMonth,
                    isLeftDisabled: isPreviousMonthDisabled,
                    isRightDisabled: isNextMonthDisabled
                })
            })
        ]
    });
}

});
parcelRegister("PVpGa", function(module, exports) {

$parcel$export(module.exports, "getPickersCalendarHeaderUtilityClass", () => $09c14c98afd19019$export$457ac4d3a1ad92b4);

var $kfTYv = parcelRequire("kfTYv");
var $jh2Zm = parcelRequire("jh2Zm");
const $09c14c98afd19019$export$457ac4d3a1ad92b4 = (slot)=>(0, $kfTYv.default)('MuiPickersCalendarHeader', slot);
const $09c14c98afd19019$export$63db7afb9247cb91 = (0, $jh2Zm.default)('MuiPickersCalendarHeader', [
    'root',
    'labelContainer',
    'label',
    'switchViewButton',
    'switchViewIcon'
]);

});


parcelRegister("d1frE", function(module, exports) {

$parcel$export(module.exports, "YearPicker", () => $97a75968a22ce2f7$export$8fb3d2631255548c);

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $anJSP = parcelRequire("anJSP");
var $4nWZ9 = parcelRequire("4nWZ9");
var $4wdE9 = parcelRequire("4wdE9");

var $aYNpO = parcelRequire("aYNpO");

var $hIlXQ = parcelRequire("hIlXQ");

var $11ydL = parcelRequire("11ydL");

var $it0qC = parcelRequire("it0qC");

var $9X7c6 = parcelRequire("9X7c6");

var $1hdeG = parcelRequire("1hdeG");

var $kneyk = parcelRequire("kneyk");

var $hCdeS = parcelRequire("hCdeS");

var $4EsxQ = parcelRequire("4EsxQ");

var $k4ank = parcelRequire("k4ank");
const $97a75968a22ce2f7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $hCdeS.getYearPickerUtilityClass), classes);
};
function $97a75968a22ce2f7$var$useYearPickerDefaultizedProps(props, name) {
    const utils = (0, $1hdeG.useUtils)();
    const defaultDates = (0, $1hdeG.useDefaultDates)();
    const themeProps = (0, $4wdE9.default)({
        props: props,
        name: name
    });
    return (0, $eJfrs.default)({
        disablePast: false,
        disableFuture: false
    }, themeProps, {
        minDate: (0, $4EsxQ.parseNonNullablePickerDate)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $4EsxQ.parseNonNullablePickerDate)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $97a75968a22ce2f7$var$YearPickerRoot = (0, $anJSP.default)('div', {
    name: 'MuiYearPicker',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflowY: 'auto',
    height: '100%',
    padding: '0 4px',
    maxHeight: '304px'
});
const $97a75968a22ce2f7$export$8fb3d2631255548c = /*#__PURE__*/ $8T3gX.forwardRef(function YearPicker(inProps, ref) {
    const now = (0, $1hdeG.useNow)();
    const theme = (0, $4nWZ9.default)();
    const utils = (0, $1hdeG.useUtils)();
    const props = $97a75968a22ce2f7$var$useYearPickerDefaultizedProps(inProps, 'MuiYearPicker');
    const { autoFocus: autoFocus, className: className, date: date, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, readOnly: readOnly, shouldDisableYear: shouldDisableYear, disableHighlightToday: disableHighlightToday, onYearFocus: onYearFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange } = props;
    const ownerState = props;
    const classes = $97a75968a22ce2f7$var$useUtilityClasses(ownerState);
    const selectedDateOrStartOfYear = $8T3gX.useMemo(()=>date != null ? date : utils.startOfYear(now), [
        now,
        utils,
        date
    ]);
    const currentYear = $8T3gX.useMemo(()=>{
        if (date != null) return utils.getYear(date);
        if (disableHighlightToday) return null;
        return utils.getYear(now);
    }, [
        now,
        date,
        utils,
        disableHighlightToday
    ]);
    const wrapperVariant = $8T3gX.useContext((0, $kneyk.WrapperVariantContext));
    const selectedYearRef = $8T3gX.useRef(null);
    const [focusedYear, setFocusedYear] = $8T3gX.useState(()=>currentYear || utils.getYear(now));
    const [internalHasFocus, setInternalHasFocus] = (0, $it0qC.default)({
        name: 'YearPicker',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus
    });
    const changeHasFocus = $8T3gX.useCallback((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    }, [
        setInternalHasFocus,
        onFocusedViewChange
    ]);
    const isYearDisabled = $8T3gX.useCallback((dateToValidate)=>{
        if (disablePast && utils.isBeforeYear(dateToValidate, now)) return true;
        if (disableFuture && utils.isAfterYear(dateToValidate, now)) return true;
        if (minDate && utils.isBeforeYear(dateToValidate, minDate)) return true;
        if (maxDate && utils.isAfterYear(dateToValidate, maxDate)) return true;
        if (shouldDisableYear && shouldDisableYear(dateToValidate)) return true;
        return false;
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableYear,
        utils
    ]);
    const handleYearSelection = (event, year, isFinish = 'finish')=>{
        if (readOnly) return;
        const newDate = utils.setYear(selectedDateOrStartOfYear, year);
        onChange(newDate, isFinish);
    };
    const focusYear = $8T3gX.useCallback((year)=>{
        if (!isYearDisabled(utils.setYear(selectedDateOrStartOfYear, year))) {
            setFocusedYear(year);
            changeHasFocus(true);
            onYearFocus == null || onYearFocus(year);
        }
    }, [
        isYearDisabled,
        utils,
        selectedDateOrStartOfYear,
        changeHasFocus,
        onYearFocus
    ]);
    $8T3gX.useEffect(()=>{
        setFocusedYear((prevFocusedYear)=>currentYear !== null && prevFocusedYear !== currentYear ? currentYear : prevFocusedYear);
    }, [
        currentYear
    ]);
    const yearsInRow = wrapperVariant === 'desktop' ? 4 : 3;
    const handleKeyDown = $8T3gX.useCallback((event, year)=>{
        switch(event.key){
            case 'ArrowUp':
                focusYear(year - yearsInRow);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusYear(year + yearsInRow);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusYear(year + (theme.direction === 'ltr' ? -1 : 1));
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusYear(year + (theme.direction === 'ltr' ? 1 : -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    }, [
        focusYear,
        theme.direction,
        yearsInRow
    ]);
    const handleFocus = $8T3gX.useCallback((event, year)=>{
        focusYear(year);
    }, [
        focusYear
    ]);
    const handleBlur = $8T3gX.useCallback((event, year)=>{
        if (focusedYear === year) changeHasFocus(false);
    }, [
        focusedYear,
        changeHasFocus
    ]);
    const nowYear = utils.getYear(now);
    const scrollerRef = $8T3gX.useRef(null);
    const handleRef = (0, $11ydL.default)(ref, scrollerRef);
    $8T3gX.useEffect(()=>{
        if (autoFocus || scrollerRef.current === null) return;
        const tabbableButton = scrollerRef.current.querySelector('[tabindex="0"]');
        if (!tabbableButton) return;
         // Taken from useScroll in x-data-grid, but vertically centered
        const offsetHeight = tabbableButton.offsetHeight;
        const offsetTop = tabbableButton.offsetTop;
        const clientHeight = scrollerRef.current.clientHeight;
        const scrollTop = scrollerRef.current.scrollTop;
        const elementBottom = offsetTop + offsetHeight;
        if (offsetHeight > clientHeight || offsetTop < scrollTop) // Button already visible
        return;
        scrollerRef.current.scrollTop = elementBottom - clientHeight / 2 - offsetHeight / 2;
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsx)($97a75968a22ce2f7$var$YearPickerRoot, {
        ref: handleRef,
        className: (0, $hIlXQ.default)(classes.root, className),
        ownerState: ownerState,
        children: utils.getYearRange(minDate, maxDate).map((year)=>{
            const yearNumber = utils.getYear(year);
            const selected = yearNumber === currentYear;
            return /*#__PURE__*/ (0, $k4ank.jsx)((0, $9X7c6.PickersYear), {
                selected: selected,
                value: yearNumber,
                onClick: handleYearSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && yearNumber === focusedYear,
                ref: selected ? selectedYearRef : undefined,
                disabled: disabled || isYearDisabled(year),
                tabIndex: yearNumber === focusedYear ? 0 : -1,
                onFocus: handleFocus,
                onBlur: handleBlur,
                "aria-current": nowYear === yearNumber ? 'date' : undefined,
                children: utils.format(year, 'year')
            }, utils.format(year, 'year'));
        })
    });
});
$97a75968a22ce2f7$export$8fb3d2631255548c.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    date: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true` future days are disabled.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true` past days are disabled.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    hasFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Maximal selectable date. @DateIOType
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Minimal selectable date. @DateIOType
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired,
    onFocusedDayChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    onFocusedViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    onYearFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Disable specific years dynamically.
   * Works like `shouldDisableDate` but for year selection view @DateIOType.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} Returns `true` if the year should be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
};

});
parcelRegister("9X7c6", function(module, exports) {

$parcel$export(module.exports, "PickersYear", () => $73ef346143f4c630$export$261f3fbd5fd5814d);

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $hIlXQ = parcelRequire("hIlXQ");

var $iMOmE = parcelRequire("iMOmE");
var $11ydL = parcelRequire("11ydL");

var $3RYg6 = parcelRequire("3RYg6");
var $anJSP = parcelRequire("anJSP");

var $aYNpO = parcelRequire("aYNpO");

var $kneyk = parcelRequire("kneyk");

var $ewzjH = parcelRequire("ewzjH");

var $k4ank = parcelRequire("k4ank");
const $73ef346143f4c630$var$_excluded = [
    "autoFocus",
    "className",
    "children",
    "disabled",
    "onClick",
    "onKeyDown",
    "value",
    "tabIndex",
    "onFocus",
    "onBlur"
];
const $73ef346143f4c630$var$useUtilityClasses = (ownerState)=>{
    const { wrapperVariant: wrapperVariant, disabled: disabled, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            wrapperVariant && `mode${(0, $iMOmE.default)(wrapperVariant)}`
        ],
        yearButton: [
            'yearButton',
            disabled && 'disabled',
            selected && 'selected'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $ewzjH.getPickersYearUtilityClass), classes);
};
const $73ef346143f4c630$var$PickersYearRoot = (0, $anJSP.default)('div', {
    name: 'PrivatePickersYear',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, $ewzjH.pickersYearClasses).modeDesktop}`]: styles.modeDesktop
            },
            {
                [`&.${(0, $ewzjH.pickersYearClasses).modeMobile}`]: styles.modeMobile
            }
        ]
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({
        flexBasis: '33.3%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }, (ownerState == null ? void 0 : ownerState.wrapperVariant) === 'desktop' && {
        flexBasis: '25%'
    }));
const $73ef346143f4c630$var$PickersYearButton = (0, $anJSP.default)('button', {
    name: 'PrivatePickersYear',
    slot: 'Button',
    overridesResolver: (_, styles)=>[
            styles.button,
            {
                [`&.${(0, $ewzjH.pickersYearClasses).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $ewzjH.pickersYearClasses).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $eJfrs.default)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: '8px 0',
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus, &:hover': {
            backgroundColor: (0, $3RYg6.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $ewzjH.pickersYearClasses).disabled}`]: {
            color: theme.palette.text.secondary
        },
        [`&.${(0, $ewzjH.pickersYearClasses).selected}`]: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: theme.palette.primary.dark
            }
        }
    }));
const $73ef346143f4c630$var$noop = ()=>{};
const $73ef346143f4c630$export$261f3fbd5fd5814d = /*#__PURE__*/ $8T3gX.forwardRef(function PickersYear(props, forwardedRef) {
    // TODO v6: add 'useThemeProps' once the component class names are aligned
    const { autoFocus: autoFocus, className: className, children: children, disabled: disabled, onClick: onClick, onKeyDown: onKeyDown, value: value, tabIndex: tabIndex, onFocus: onFocus = $73ef346143f4c630$var$noop, onBlur: onBlur = $73ef346143f4c630$var$noop } = props, other = (0, $fAJB5.default)(props, $73ef346143f4c630$var$_excluded);
    const ref = $8T3gX.useRef(null);
    const refHandle = (0, $11ydL.default)(ref, forwardedRef);
    const wrapperVariant = $8T3gX.useContext((0, $kneyk.WrapperVariantContext));
    const ownerState = (0, $eJfrs.default)({}, props, {
        wrapperVariant: wrapperVariant
    });
    const classes = $73ef346143f4c630$var$useUtilityClasses(ownerState); // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    $8T3gX.useEffect(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current.focus();
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsx)($73ef346143f4c630$var$PickersYearRoot, {
        className: (0, $hIlXQ.default)(classes.root, className),
        ownerState: ownerState,
        children: /*#__PURE__*/ (0, $k4ank.jsx)($73ef346143f4c630$var$PickersYearButton, (0, $eJfrs.default)({
            ref: refHandle,
            disabled: disabled,
            type: "button",
            tabIndex: disabled ? -1 : tabIndex,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value),
            className: classes.yearButton,
            ownerState: ownerState
        }, other, {
            children: children
        }))
    });
});

});
parcelRegister("ewzjH", function(module, exports) {

$parcel$export(module.exports, "getPickersYearUtilityClass", () => $a92f7308581eb21a$export$183c9f339a61cd79);
$parcel$export(module.exports, "pickersYearClasses", () => $a92f7308581eb21a$export$4ef58a3d9c6f4296);

var $kfTYv = parcelRequire("kfTYv");
var $jh2Zm = parcelRequire("jh2Zm");
function $a92f7308581eb21a$export$183c9f339a61cd79(slot) {
    // TODO v6: Rename 'PrivatePickersYear' to 'MuiPickersYear' to follow convention
    return (0, $kfTYv.default)('PrivatePickersYear', slot);
} // TODO v6: Rename 'PrivatePickersYear' to 'MuiPickersYear' to follow convention
const $a92f7308581eb21a$export$4ef58a3d9c6f4296 = (0, $jh2Zm.default)('PrivatePickersYear', [
    'root',
    'modeDesktop',
    'modeMobile',
    'yearButton',
    'selected',
    'disabled'
]);

});


parcelRegister("hCdeS", function(module, exports) {

$parcel$export(module.exports, "getYearPickerUtilityClass", () => $cd304141195bc43f$export$f2ff97d66516573);

var $kfTYv = parcelRequire("kfTYv");
var $jh2Zm = parcelRequire("jh2Zm");
function $cd304141195bc43f$export$f2ff97d66516573(slot) {
    return (0, $kfTYv.default)('MuiYearPicker', slot);
}
const $cd304141195bc43f$export$bb4597d20e91e1c2 = (0, $jh2Zm.default)('MuiYearPicker', [
    'root'
]);

});


parcelRegister("5q3a5", function(module, exports) {

$parcel$export(module.exports, "defaultReduceAnimations", () => $3f21d55254c4e16a$export$96ab2969580bcdae);
const $3f21d55254c4e16a$export$96ab2969580bcdae = typeof navigator !== 'undefined' && /(android)/i.test(navigator.userAgent);

});

parcelRegister("6OLA9", function(module, exports) {

$parcel$export(module.exports, "getCalendarPickerUtilityClass", () => $4f6c5264a046a0f7$export$e590ef7d5266b255);

var $kfTYv = parcelRequire("kfTYv");
var $jh2Zm = parcelRequire("jh2Zm");
const $4f6c5264a046a0f7$export$e590ef7d5266b255 = (slot)=>(0, $kfTYv.default)('MuiCalendarPicker', slot);
const $4f6c5264a046a0f7$export$54d6b142efe8f412 = (0, $jh2Zm.default)('MuiCalendarPicker', [
    'root',
    'viewTransitionContainer'
]);

});


parcelRegister("01RPl", function(module, exports) {

$parcel$export(module.exports, "KeyboardDateInput", () => $0059d90df0091056$export$aa5e86c6cf7f6de8);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $iKAtE = parcelRequire("iKAtE");

var $1SPe4 = parcelRequire("1SPe4");

var $1hdeG = parcelRequire("1hdeG");

var $hIg9z = parcelRequire("hIg9z");

var $927H2 = parcelRequire("927H2");

var $k4ank = parcelRequire("k4ank");
const $0059d90df0091056$var$_excluded = [
    "className",
    "components",
    "disableOpenPicker",
    "getOpenDialogAriaText",
    "InputAdornmentProps",
    "InputProps",
    "inputRef",
    "openPicker",
    "OpenPickerButtonProps",
    "renderInput"
];
const $0059d90df0091056$export$aa5e86c6cf7f6de8 = /*#__PURE__*/ $8T3gX.forwardRef(function KeyboardDateInput(props, ref) {
    const { className: className, components: components = {}, disableOpenPicker: disableOpenPicker, getOpenDialogAriaText: getOpenDialogAriaTextProp, InputAdornmentProps: InputAdornmentProps, InputProps: InputProps, inputRef: inputRef, openPicker: openPicker, OpenPickerButtonProps: OpenPickerButtonProps, renderInput: renderInput } = props, other = (0, $fAJB5.default)(props, $0059d90df0091056$var$_excluded);
    const localeText = (0, $1hdeG.useLocaleText)();
    const getOpenDialogAriaText = getOpenDialogAriaTextProp != null ? getOpenDialogAriaTextProp : localeText.openDatePickerDialogue;
    const utils = (0, $1hdeG.useUtils)();
    const textFieldProps = (0, $927H2.useMaskedInput)(other);
    const adornmentPosition = (InputAdornmentProps == null ? void 0 : InputAdornmentProps.position) || 'end';
    const OpenPickerIcon = components.OpenPickerIcon || (0, $hIg9z.Calendar);
    return renderInput((0, $eJfrs.default)({
        ref: ref,
        inputRef: inputRef,
        className: className
    }, textFieldProps, {
        InputProps: (0, $eJfrs.default)({}, InputProps, {
            [`${adornmentPosition}Adornment`]: disableOpenPicker ? undefined : /*#__PURE__*/ (0, $k4ank.jsx)((0, $1SPe4.default), (0, $eJfrs.default)({
                position: adornmentPosition
            }, InputAdornmentProps, {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), (0, $eJfrs.default)({
                    edge: adornmentPosition,
                    disabled: other.disabled || other.readOnly,
                    "aria-label": getOpenDialogAriaText(other.rawValue, utils)
                }, OpenPickerButtonProps, {
                    onClick: openPicker,
                    children: /*#__PURE__*/ (0, $k4ank.jsx)(OpenPickerIcon, {})
                }))
            }))
        })
    }));
});

});
parcelRegister("927H2", function(module, exports) {

$parcel$export(module.exports, "useMaskedInput", () => $693a44a8c4353f27$export$3be87d890b5aa1ad);

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $62SR0 = parcelRequire("62SR0");

var $1hdeG = parcelRequire("1hdeG");

var $86Ccs = parcelRequire("86Ccs");
const $693a44a8c4353f27$export$3be87d890b5aa1ad = ({ acceptRegex: acceptRegex = /[\d]/gi, disabled: disabled, disableMaskedInput: disableMaskedInput, ignoreInvalidInputs: ignoreInvalidInputs, inputFormat: inputFormat, inputProps: inputProps, label: label, mask: mask, onChange: onChange, rawValue: rawValue, readOnly: readOnly, rifmFormatter: rifmFormatter, TextFieldProps: TextFieldProps, validationError: validationError })=>{
    const utils = (0, $1hdeG.useUtils)();
    const formatHelperText = utils.getFormatHelperText(inputFormat);
    const { shouldUseMaskedInput: shouldUseMaskedInput, maskToUse: maskToUse } = $8T3gX.useMemo(()=>{
        // formatting of dates is a quite slow thing, so do not make useless .format calls
        if (disableMaskedInput) return {
            shouldUseMaskedInput: false,
            maskToUse: ''
        };
        const computedMaskToUse = (0, $86Ccs.getMaskFromCurrentFormat)(mask, inputFormat, acceptRegex, utils);
        return {
            shouldUseMaskedInput: (0, $86Ccs.checkMaskIsValidForCurrentFormat)(computedMaskToUse, inputFormat, acceptRegex, utils),
            maskToUse: computedMaskToUse
        };
    }, [
        acceptRegex,
        disableMaskedInput,
        inputFormat,
        mask,
        utils
    ]);
    const formatter = $8T3gX.useMemo(()=>shouldUseMaskedInput && maskToUse ? (0, $86Ccs.maskedDateFormatter)(maskToUse, acceptRegex) : (st)=>st, [
        acceptRegex,
        maskToUse,
        shouldUseMaskedInput
    ]); // TODO: Implement with controlled vs uncontrolled `rawValue`
    const parsedValue = rawValue === null ? null : utils.date(rawValue); // Track the value of the input
    const [innerInputValue, setInnerInputValue] = $8T3gX.useState(parsedValue); // control the input text
    const [innerDisplayedInputValue, setInnerDisplayedInputValue] = $8T3gX.useState((0, $86Ccs.getDisplayDate)(utils, rawValue, inputFormat)); // Inspired from autocomplete: https://github.com/mui/material-ui/blob/2c89d036dc2e16f100528f161600dffc83241768/packages/mui-base/src/AutocompleteUnstyled/useAutocomplete.js#L185:L201
    const prevRawValue = $8T3gX.useRef();
    const prevLocale = $8T3gX.useRef(utils.locale);
    const prevInputFormat = $8T3gX.useRef(inputFormat);
    $8T3gX.useEffect(()=>{
        const rawValueHasChanged = rawValue !== prevRawValue.current;
        const localeHasChanged = utils.locale !== prevLocale.current;
        const inputFormatHasChanged = inputFormat !== prevInputFormat.current;
        prevRawValue.current = rawValue;
        prevLocale.current = utils.locale;
        prevInputFormat.current = inputFormat;
        if (!rawValueHasChanged && !localeHasChanged && !inputFormatHasChanged) return;
        const newParsedValue = rawValue === null ? null : utils.date(rawValue);
        const isAcceptedValue = rawValue === null || utils.isValid(newParsedValue);
        let innerEqualsParsed = innerInputValue === null && newParsedValue === null; // equal by being both null
        if (innerInputValue !== null && newParsedValue !== null) {
            const areEqual = utils.isEqual(innerInputValue, newParsedValue);
            if (areEqual) innerEqualsParsed = true;
            else {
                const diff = Math.abs(utils.getDiff(innerInputValue, newParsedValue)); // diff in ms
                innerEqualsParsed = diff === 0 ? areEqual // if no diff, use equal to test the time-zone
                 : diff < 1000; // accept a difference bellow 1s
            }
        }
        if (!localeHasChanged && !inputFormatHasChanged && (!isAcceptedValue || innerEqualsParsed)) return;
         // When dev set a new valid value, we trust them
        const newDisplayDate = (0, $86Ccs.getDisplayDate)(utils, rawValue, inputFormat);
        setInnerInputValue(newParsedValue);
        setInnerDisplayedInputValue(newDisplayDate);
    }, [
        utils,
        rawValue,
        inputFormat,
        innerInputValue
    ]);
    const handleChange = (text)=>{
        const finalString = text === '' || text === mask ? '' : text;
        setInnerDisplayedInputValue(finalString);
        const date = finalString === null ? null : utils.parse(finalString, inputFormat);
        if (ignoreInvalidInputs && !utils.isValid(date)) return;
        setInnerInputValue(date);
        onChange(date, finalString || undefined);
    };
    const rifmProps = (0, $62SR0.useRifm)({
        value: innerDisplayedInputValue,
        onChange: handleChange,
        format: rifmFormatter || formatter
    });
    const inputStateArgs = shouldUseMaskedInput ? rifmProps : {
        value: innerDisplayedInputValue,
        onChange: (event)=>{
            handleChange(event.currentTarget.value);
        }
    };
    return (0, $eJfrs.default)({
        label: label,
        disabled: disabled,
        error: validationError,
        inputProps: (0, $eJfrs.default)({}, inputStateArgs, {
            disabled: disabled,
            placeholder: formatHelperText,
            readOnly: readOnly,
            type: shouldUseMaskedInput ? 'tel' : 'text'
        }, inputProps)
    }, TextFieldProps);
};

});
parcelRegister("62SR0", function(module, exports) {

$parcel$export(module.exports, "useRifm", () => $466d7ad8825bf23d$export$9a2620970bbf44b7);

var $8T3gX = parcelRequire("8T3gX");
const $466d7ad8825bf23d$export$9a2620970bbf44b7 = (props)=>{
    const [, refresh] = (0, $8T3gX.useReducer)((c)=>c + 1, 0);
    const valueRef = (0, $8T3gX.useRef)(null);
    const { replace: replace, append: append } = props;
    const userValue = replace ? replace(props.format(props.value)) : props.format(props.value); // state of delete button see comments below about inputType support
    const isDeleleteButtonDownRef = (0, $8T3gX.useRef)(false);
    const onChange = (evt)=>{
        if (evt.target.type === 'number') {
            console.error('Rifm does not support input type=number, use type=tel instead.');
            return;
        }
        if (evt.target.type === 'date') {
            console.error('Rifm does not support input type=date.');
            return;
        }
        const eventValue = evt.target.value;
        valueRef.current = [
            eventValue,
            evt.target,
            eventValue.length > userValue.length,
            isDeleleteButtonDownRef.current,
            userValue === props.format(eventValue) // isNoOperation
        ];
        {
            const formattedEventValue = props.format(eventValue);
            if (eventValue !== formattedEventValue && eventValue.toLowerCase() === formattedEventValue.toLowerCase()) console.warn('Case enforcement does not work with format. Please use replace={value => value.toLowerCase()} instead');
        }
        // that allows us to calculate right cursor position after formatting (see getCursorPosition)
        // then we format new value and call props.onChange with masked/formatted value
        // and finally we are able to set cursor position into right place
        refresh();
    }; // React prints warn on server in non production mode about useLayoutEffect usage
    // in both cases it's noop
    if (typeof window !== 'undefined') (0, $8T3gX.useLayoutEffect)(()=>{
        if (valueRef.current == null) return;
        let [eventValue, input, isSizeIncreaseOperation, isDeleleteButtonDown, isNoOperation] = valueRef.current;
        valueRef.current = null; // this usually occurs on deleting special symbols like ' here 123'123.00
        // in case of isDeleleteButtonDown cursor should move differently vs backspace
        const deleteWasNoOp = isDeleleteButtonDown && isNoOperation;
        const valueAfterSelectionStart = eventValue.slice(input.selectionStart);
        const acceptedCharIndexAfterDelete = valueAfterSelectionStart.search(props.accept || /\d/g);
        const charsToSkipAfterDelete = acceptedCharIndexAfterDelete !== -1 ? acceptedCharIndexAfterDelete : 0; // Create string from only accepted symbols
        const clean = (str)=>(str.match(props.accept || /\d/g) || []).join('');
        const valueBeforeSelectionStart = clean(eventValue.substr(0, input.selectionStart)); // trying to find cursor position in formatted value having knowledge about valueBeforeSelectionStart
        // This works because we assume that format doesn't change the order of accepted symbols.
        // Imagine we have formatter which adds ' symbol between numbers, and by default we refuse all non numeric symbols
        // for example we had input = 1'2|'4 (| means cursor position) then user entered '3' symbol
        // inputValue = 1'23'|4 so valueBeforeSelectionStart = 123 and formatted value = 1'2'3'4
        // calling getCursorPosition("1'2'3'4") will give us position after 3, 1'2'3|'4
        // so for formatting just this function to determine cursor position after formatting is enough
        // with masking we need to do some additional checks see `mask` below
        const getCursorPosition = (val)=>{
            let start = 0;
            let cleanPos = 0;
            for(let i = 0; i !== valueBeforeSelectionStart.length; ++i){
                let newPos = val.indexOf(valueBeforeSelectionStart[i], start) + 1;
                let newCleanPos = clean(val).indexOf(valueBeforeSelectionStart[i], cleanPos) + 1; // this skips position change if accepted symbols order was broken
                // For example fixes edge case with fixed point numbers:
                // You have '0|.00', then press 1, it becomes 01|.00 and after format 1.00, this breaks our assumption
                // that order of accepted symbols is not changed after format,
                // so here we don't update start position if other accepted symbols was inbetween current and new position
                if (newCleanPos - cleanPos > 1) {
                    newPos = start;
                    newCleanPos = cleanPos;
                }
                cleanPos = Math.max(newCleanPos, cleanPos);
                start = Math.max(start, newPos);
            }
            return start;
        }; // Masking part, for masks if size of mask is above some value
        // we need to replace symbols instead of do nothing as like in format
        if (props.mask === true && isSizeIncreaseOperation && !isNoOperation) {
            let start = getCursorPosition(eventValue);
            const c = clean(eventValue.substr(start))[0];
            start = eventValue.indexOf(c, start);
            eventValue = `${eventValue.substr(0, start)}${eventValue.substr(start + 1)}`;
        }
        let formattedValue = props.format(eventValue);
        if (append != null && // cursor at the end
        input.selectionStart === eventValue.length && !isNoOperation) {
            if (isSizeIncreaseOperation) formattedValue = append(formattedValue);
            else // If after delete last char is special character and we use append
            // delete it too
            // was: "12-3|" backspace pressed, then should be "12|"
            if (clean(formattedValue.slice(-1)) === '') formattedValue = formattedValue.slice(0, -1);
        }
        const replacedValue = replace ? replace(formattedValue) : formattedValue;
        if (userValue === replacedValue) // if nothing changed for formatted value, just refresh so userValue will be used at render
        refresh();
        else props.onChange(replacedValue);
        return ()=>{
            let start = getCursorPosition(formattedValue); // Visually improves working with masked values,
            // like cursor jumping over refused symbols
            // as an example date mask: was "5|1-24-3" then user pressed "6"
            // it becomes "56-|12-43" with this code, and "56|-12-43" without
            if (props.mask != null && (isSizeIncreaseOperation || isDeleleteButtonDown && !deleteWasNoOp)) while(formattedValue[start] && clean(formattedValue[start]) === '')start += 1;
            input.selectionStart = input.selectionEnd = start + (deleteWasNoOp ? 1 + charsToSkipAfterDelete : 0);
        };
    });
    (0, $8T3gX.useEffect)(()=>{
        // until https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported
        // by all major browsers (now supported by: +chrome, +safari, ?edge, !firefox)
        // there is no way I found to distinguish in onChange
        // backspace or delete was called in some situations
        // firefox track https://bugzilla.mozilla.org/show_bug.cgi?id=1447239
        const handleKeyDown = (evt)=>{
            if (evt.code === 'Delete') isDeleleteButtonDownRef.current = true;
        };
        const handleKeyUp = (evt)=>{
            if (evt.code === 'Delete') isDeleleteButtonDownRef.current = false;
        };
        document.addEventListener('keydown', handleKeyDown);
        document.addEventListener('keyup', handleKeyUp);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
            document.removeEventListener('keyup', handleKeyUp);
        };
    }, []);
    return {
        value: valueRef.current != null ? valueRef.current[0] : userValue,
        onChange: onChange
    };
};
const $466d7ad8825bf23d$export$5519909ee832c7c = (props)=>{
    const renderProps = $466d7ad8825bf23d$export$9a2620970bbf44b7(props);
    return props.children(renderProps);
};

});

parcelRegister("86Ccs", function(module, exports) {

$parcel$export(module.exports, "getDisplayDate", () => $5e6c83fb9640f5ba$export$61abca328afe490a);
$parcel$export(module.exports, "getMaskFromCurrentFormat", () => $5e6c83fb9640f5ba$export$4b5431a6d21283e4);
$parcel$export(module.exports, "checkMaskIsValidForCurrentFormat", () => $5e6c83fb9640f5ba$export$17b3b67b7ed6b51d);
$parcel$export(module.exports, "maskedDateFormatter", () => $5e6c83fb9640f5ba$export$bd2dd9a8014709bf);
const $5e6c83fb9640f5ba$export$61abca328afe490a = (utils, rawValue, inputFormat)=>{
    const date = utils.date(rawValue);
    const isEmpty = rawValue === null;
    if (isEmpty) return '';
    return utils.isValid(date) ? utils.formatByString(// Either we allow `TDate | null` to be valid and guard against calling `formatByString` with `null`.
    // Or we ensure `formatByString` is callable with `null`.
    date, inputFormat) : '';
};
const $5e6c83fb9640f5ba$var$MASK_USER_INPUT_SYMBOL = '_';
const $5e6c83fb9640f5ba$var$staticDateWith2DigitTokens = '2019-11-21T22:30:00.000';
const $5e6c83fb9640f5ba$var$staticDateWith1DigitTokens = '2019-01-01T09:00:00.000';
function $5e6c83fb9640f5ba$export$4b5431a6d21283e4(mask, format, acceptRegex, utils) {
    if (mask) return mask;
    const formattedDateWith1Digit = utils.formatByString(utils.date($5e6c83fb9640f5ba$var$staticDateWith1DigitTokens), format);
    const inferredFormatPatternWith1Digits = formattedDateWith1Digit.replace(acceptRegex, $5e6c83fb9640f5ba$var$MASK_USER_INPUT_SYMBOL);
    const inferredFormatPatternWith2Digits = utils.formatByString(utils.date($5e6c83fb9640f5ba$var$staticDateWith2DigitTokens), format).replace(acceptRegex, '_');
    if (inferredFormatPatternWith1Digits === inferredFormatPatternWith2Digits) return inferredFormatPatternWith1Digits;
    console.warn([
        `Mask does not support numbers with variable length such as 'M'.`,
        `Either use numbers with fix length or disable mask feature with 'disableMaskedInput' prop`,
        `Falling down to uncontrolled no-mask input.`
    ].join('\n'));
    return '';
}
function $5e6c83fb9640f5ba$export$17b3b67b7ed6b51d(mask, format, acceptRegex, utils) {
    if (!mask) return false;
    const formattedDateWith1Digit = utils.formatByString(utils.date($5e6c83fb9640f5ba$var$staticDateWith1DigitTokens), format);
    const inferredFormatPatternWith1Digits = formattedDateWith1Digit.replace(acceptRegex, $5e6c83fb9640f5ba$var$MASK_USER_INPUT_SYMBOL);
    const inferredFormatPatternWith2Digits = utils.formatByString(utils.date($5e6c83fb9640f5ba$var$staticDateWith2DigitTokens), format).replace(acceptRegex, '_');
    const isMaskValid = inferredFormatPatternWith2Digits === inferredFormatPatternWith1Digits && mask === inferredFormatPatternWith2Digits;
    if (!isMaskValid && utils.lib !== 'luxon' && true) {
        if (format.includes('MMM')) console.warn([
            `Mask does not support literals such as 'MMM'.`,
            `Either use numbers with fix length or disable mask feature with 'disableMaskedInput' prop`,
            `Falling down to uncontrolled no-mask input.`
        ].join('\n'));
        else if (inferredFormatPatternWith2Digits && inferredFormatPatternWith2Digits !== inferredFormatPatternWith1Digits) console.warn([
            `Mask does not support numbers with variable length such as 'M'.`,
            `Either use numbers with fix length or disable mask feature with 'disableMaskedInput' prop`,
            `Falling down to uncontrolled no-mask input.`
        ].join('\n'));
        else if (mask) console.warn([
            `The mask "${mask}" you passed is not valid for the format used ${format}.`,
            `Falling down to uncontrolled no-mask input.`
        ].join('\n'));
    }
    return isMaskValid;
}
const $5e6c83fb9640f5ba$export$bd2dd9a8014709bf = (mask, acceptRegexp)=>(value)=>{
        let outputCharIndex = 0;
        return value.split('').map((char, inputCharIndex)=>{
            acceptRegexp.lastIndex = 0;
            if (outputCharIndex > mask.length - 1) return '';
            const maskChar = mask[outputCharIndex];
            const nextMaskChar = mask[outputCharIndex + 1];
            const acceptedChar = acceptRegexp.test(char) ? char : '';
            const formattedChar = maskChar === $5e6c83fb9640f5ba$var$MASK_USER_INPUT_SYMBOL ? acceptedChar : maskChar + acceptedChar;
            outputCharIndex += formattedChar.length;
            const isLastCharacter = inputCharIndex === value.length - 1;
            if (isLastCharacter && nextMaskChar && nextMaskChar !== $5e6c83fb9640f5ba$var$MASK_USER_INPUT_SYMBOL) // when cursor at the end of mask part (e.g. month) prerender next symbol "21" -> "21/"
            return formattedChar ? formattedChar + nextMaskChar : '';
            return formattedChar;
        }).join('');
    };

});



parcelRegister("a3xeE", function(module, exports) {

$parcel$export(module.exports, "useIsLandscape", () => $7523f70470168f7e$export$6f60b24e37af6448);

var $8T3gX = parcelRequire("8T3gX");

var $5IwAt = parcelRequire("5IwAt");

var $jsJJd = parcelRequire("jsJJd");
function $7523f70470168f7e$var$getOrientation() {
    if (typeof window === 'undefined') return 'portrait';
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
     // Support IOS safari
    if (window.orientation) return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
    return 'portrait';
}
const $7523f70470168f7e$export$6f60b24e37af6448 = (views, customOrientation)=>{
    const [orientation, setOrientation] = $8T3gX.useState($7523f70470168f7e$var$getOrientation);
    (0, $5IwAt.default)(()=>{
        const eventHandler = ()=>{
            setOrientation($7523f70470168f7e$var$getOrientation());
        };
        window.addEventListener('orientationchange', eventHandler);
        return ()=>{
            window.removeEventListener('orientationchange', eventHandler);
        };
    }, []);
    if ((0, $jsJJd.arrayIncludes)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) // could not display 13:34:44 in landscape mode
    return false;
    const orientationToUse = customOrientation || orientation;
    return orientationToUse === 'landscape';
};

});

parcelRegister("gXmr1", function(module, exports) {

$parcel$export(module.exports, "useFocusManagement", () => $c5838f20742771b6$export$a82d382c0b37f9cc);

var $8T3gX = parcelRequire("8T3gX");
const $c5838f20742771b6$export$a82d382c0b37f9cc = ({ autoFocus: autoFocus, openView: openView })=>{
    const [focusedView, setFocusedView] = $8T3gX.useState(autoFocus ? openView : null);
    const setFocusedViewCallback = $8T3gX.useCallback((view)=>(newHasFocus)=>{
            if (newHasFocus) setFocusedView(view);
            else setFocusedView((prevFocusedView)=>view === prevFocusedView ? null : prevFocusedView);
        }, []);
    return {
        focusedView: focusedView,
        setFocusedView: setFocusedViewCallback
    };
};

});

parcelRegister("kUteV", function(module, exports) {

$parcel$export(module.exports, "getCalendarOrClockPickerUtilityClass", () => $f38fb8071118f4a3$export$585697e91ac63d80);

var $kfTYv = parcelRequire("kfTYv");
var $jh2Zm = parcelRequire("jh2Zm");
function $f38fb8071118f4a3$export$585697e91ac63d80(slot) {
    return (0, $kfTYv.default)('MuiCalendarOrClockPicker', slot);
}
const $f38fb8071118f4a3$export$4d7e84bf47c0a26d = (0, $jh2Zm.default)('MuiCalendarOrClockPicker', [
    'root',
    'mobileKeyboardInputView'
]);

});


parcelRegister("9vOM8", function(module, exports) {

$parcel$export(module.exports, "useTimeValidation", () => $6ece6543211a6de4$export$6913080731fabed9);

var $gA4XU = parcelRequire("gA4XU");

var $aEwiL = parcelRequire("aEwiL");
const $6ece6543211a6de4$export$7bd013ac69eb590c = ({ adapter: adapter, value: value, props: props })=>{
    const { minTime: minTime, maxTime: maxTime, minutesStep: minutesStep, shouldDisableTime: shouldDisableTime, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation } = props;
    const date = adapter.utils.date(value);
    const isAfter = (0, $gA4XU.createIsAfterIgnoreDatePart)(disableIgnoringDatePartForTimeValidation, adapter.utils);
    if (value === null) return null;
    switch(true){
        case !adapter.utils.isValid(value):
            return 'invalidDate';
        case Boolean(minTime && isAfter(minTime, date)):
            return 'minTime';
        case Boolean(maxTime && isAfter(date, maxTime)):
            return 'maxTime';
        case Boolean(shouldDisableTime && shouldDisableTime(adapter.utils.getHours(date), 'hours')):
            return 'shouldDisableTime-hours';
        case Boolean(shouldDisableTime && shouldDisableTime(adapter.utils.getMinutes(date), 'minutes')):
            return 'shouldDisableTime-minutes';
        case Boolean(shouldDisableTime && shouldDisableTime(adapter.utils.getSeconds(date), 'seconds')):
            return 'shouldDisableTime-seconds';
        case Boolean(minutesStep && adapter.utils.getMinutes(date) % minutesStep !== 0):
            return 'minutesStep';
        default:
            return null;
    }
};
const $6ece6543211a6de4$var$isSameTimeError = (a, b)=>a === b;
const $6ece6543211a6de4$export$6913080731fabed9 = (props)=>(0, $aEwiL.useValidation)(props, $6ece6543211a6de4$export$7bd013ac69eb590c, $6ece6543211a6de4$var$isSameTimeError);

});

parcelRegister("hlZBr", function(module, exports) {

$parcel$export(module.exports, "usePickerState", () => $ca242edd15deca1a$export$68b76ad63c1c3f8f);

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $34RwU = parcelRequire("34RwU");

var $1hdeG = parcelRequire("1hdeG");
const $ca242edd15deca1a$export$68b76ad63c1c3f8f = (props, valueManager)=>{
    const { onAccept: onAccept, onChange: onChange, value: value, closeOnSelect: closeOnSelect } = props;
    const utils = (0, $1hdeG.useUtils)();
    const { isOpen: isOpen, setIsOpen: setIsOpen } = (0, $34RwU.useOpenState)(props);
    const parsedDateValue = $8T3gX.useMemo(()=>valueManager.parseInput(utils, value), [
        valueManager,
        utils,
        value
    ]);
    const [lastValidDateValue, setLastValidDateValue] = $8T3gX.useState(parsedDateValue);
    const [dateState, setDateState] = $8T3gX.useState(()=>({
            committed: parsedDateValue,
            draft: parsedDateValue,
            resetFallback: parsedDateValue
        }));
    const setDate = $8T3gX.useCallback((params)=>{
        setDateState((prev)=>{
            switch(params.action){
                case 'setAll':
                case 'acceptAndClose':
                    return {
                        draft: params.value,
                        committed: params.value,
                        resetFallback: params.value
                    };
                case 'setCommitted':
                    return (0, $eJfrs.default)({}, prev, {
                        draft: params.value,
                        committed: params.value
                    });
                case 'setDraft':
                    return (0, $eJfrs.default)({}, prev, {
                        draft: params.value
                    });
                default:
                    return prev;
            }
        });
        if (params.forceOnChangeCall || !params.skipOnChangeCall && !valueManager.areValuesEqual(utils, dateState.committed, params.value)) onChange(params.value);
        if (params.action === 'acceptAndClose') {
            setIsOpen(false);
            if (onAccept && !valueManager.areValuesEqual(utils, dateState.resetFallback, params.value)) onAccept(params.value);
        }
    }, [
        onAccept,
        onChange,
        setIsOpen,
        dateState,
        utils,
        valueManager
    ]);
    $8T3gX.useEffect(()=>{
        if (utils.isValid(parsedDateValue)) setLastValidDateValue(parsedDateValue);
    }, [
        utils,
        parsedDateValue
    ]);
    $8T3gX.useEffect(()=>{
        if (isOpen) // Update all dates in state to equal the current prop value
        setDate({
            action: 'setAll',
            value: parsedDateValue,
            skipOnChangeCall: true
        });
    }, [
        isOpen
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // Set the draft and committed date to equal the new prop value.
    if (!valueManager.areValuesEqual(utils, dateState.committed, parsedDateValue)) setDate({
        action: 'setCommitted',
        value: parsedDateValue,
        skipOnChangeCall: true
    });
    const wrapperProps = $8T3gX.useMemo(()=>({
            open: isOpen,
            onClear: ()=>{
                // Reset all date in state to the empty value and close picker.
                setDate({
                    value: valueManager.emptyValue,
                    action: 'acceptAndClose',
                    // force `onChange` in cases like input (value) === `Invalid date`
                    forceOnChangeCall: !valueManager.areValuesEqual(utils, value, valueManager.emptyValue)
                });
            },
            onAccept: ()=>{
                // Set all date in state to equal the current draft value and close picker.
                setDate({
                    value: dateState.draft,
                    action: 'acceptAndClose',
                    // force `onChange` in cases like input (value) === `Invalid date`
                    forceOnChangeCall: !valueManager.areValuesEqual(utils, value, parsedDateValue)
                });
            },
            onDismiss: ()=>{
                // Set all dates in state to equal the last committed date.
                // e.g. Reset the state to the last committed value.
                setDate({
                    value: dateState.committed,
                    action: 'acceptAndClose'
                });
            },
            onCancel: ()=>{
                // Set all dates in state to equal the last accepted date and close picker.
                // e.g. Reset the state to the last accepted value
                setDate({
                    value: dateState.resetFallback,
                    action: 'acceptAndClose'
                });
            },
            onSetToday: ()=>{
                // Set all dates in state to equal today and close picker.
                setDate({
                    value: valueManager.getTodayValue(utils),
                    action: 'acceptAndClose'
                });
            }
        }), [
        setDate,
        isOpen,
        utils,
        dateState,
        valueManager,
        value,
        parsedDateValue
    ]); // Mobile keyboard view is a special case.
    // When it's open picker should work like closed, because we are just showing text field
    const [isMobileKeyboardViewOpen, setMobileKeyboardViewOpen] = $8T3gX.useState(false);
    const pickerProps = $8T3gX.useMemo(()=>({
            parsedValue: dateState.draft,
            isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
            toggleMobileKeyboardView: ()=>setMobileKeyboardViewOpen(!isMobileKeyboardViewOpen),
            onDateChange: (newDate, wrapperVariant, selectionState = 'partial')=>{
                switch(selectionState){
                    case 'shallow':
                        // Update the `draft` state but do not fire `onChange`
                        return setDate({
                            action: 'setDraft',
                            value: newDate,
                            skipOnChangeCall: true
                        });
                    case 'partial':
                        // Update the `draft` state and fire `onChange`
                        return setDate({
                            action: 'setDraft',
                            value: newDate
                        });
                    case 'finish':
                        if (closeOnSelect != null ? closeOnSelect : wrapperVariant === 'desktop') // Set all dates in state to equal the new date and close picker.
                        return setDate({
                            value: newDate,
                            action: 'acceptAndClose'
                        });
                         // Updates the `committed` state and fire `onChange`
                        return setDate({
                            value: newDate,
                            action: 'setCommitted'
                        });
                    default:
                        throw new Error('MUI: Invalid selectionState passed to `onDateChange`');
                }
            }
        }), [
        setDate,
        isMobileKeyboardViewOpen,
        dateState.draft,
        closeOnSelect
    ]);
    const handleInputChange = $8T3gX.useCallback((newParsedValue, keyboardInputValue)=>{
        const cleanParsedValue = valueManager.valueReducer ? valueManager.valueReducer(utils, lastValidDateValue, newParsedValue) : newParsedValue;
        onChange(cleanParsedValue, keyboardInputValue);
    }, [
        onChange,
        valueManager,
        lastValidDateValue,
        utils
    ]);
    const inputProps = $8T3gX.useMemo(()=>({
            onChange: handleInputChange,
            open: isOpen,
            rawValue: value,
            openPicker: ()=>setIsOpen(true)
        }), [
        handleInputChange,
        isOpen,
        value,
        setIsOpen
    ]);
    const pickerState = {
        pickerProps: pickerProps,
        inputProps: inputProps,
        wrapperProps: wrapperProps
    };
    $8T3gX.useDebugValue(pickerState, ()=>({
            MuiPickerState: {
                dateState: dateState,
                other: pickerState
            }
        }));
    return pickerState;
};

});
parcelRegister("34RwU", function(module, exports) {

$parcel$export(module.exports, "useOpenState", () => $23db44b963bb9173$export$7d3a09d5141ab1f4);

var $8T3gX = parcelRequire("8T3gX");
const $23db44b963bb9173$export$7d3a09d5141ab1f4 = ({ open: open, onOpen: onOpen, onClose: onClose })=>{
    const isControllingOpenProp = $8T3gX.useRef(typeof open === 'boolean').current;
    const [openState, setIsOpenState] = $8T3gX.useState(false); // It is required to update inner state in useEffect in order to avoid situation when
    // Our component is not mounted yet, but `open` state is set to `true` (e.g. initially opened)
    $8T3gX.useEffect(()=>{
        if (isControllingOpenProp) {
            if (typeof open !== 'boolean') throw new Error('You must not mix controlling and uncontrolled mode for `open` prop');
            setIsOpenState(open);
        }
    }, [
        isControllingOpenProp,
        open
    ]);
    const setIsOpen = $8T3gX.useCallback((newIsOpen)=>{
        if (!isControllingOpenProp) setIsOpenState(newIsOpen);
        if (newIsOpen && onOpen) onOpen();
        if (!newIsOpen && onClose) onClose();
    }, [
        isControllingOpenProp,
        onOpen,
        onClose
    ]);
    return {
        isOpen: openState,
        setIsOpen: setIsOpen
    };
};

});



parcelRegister("9RYTR", function(module, exports) {

$parcel$export(module.exports, "MobileTimePicker", () => $72f84dc82d116340$export$984018df37898b81);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $faZcZ = parcelRequire("faZcZ");

var $4VrG8 = parcelRequire("4VrG8");

var $3QCZS = parcelRequire("3QCZS");

var $gE5dt = parcelRequire("gE5dt");

var $9vOM8 = parcelRequire("9vOM8");

var $hgQKr = parcelRequire("hgQKr");

var $hlZBr = parcelRequire("hlZBr");

var $k4ank = parcelRequire("k4ank");
const $72f84dc82d116340$var$_excluded = [
    "ToolbarComponent",
    "value",
    "onChange",
    "components",
    "componentsProps"
];
const $72f84dc82d116340$export$984018df37898b81 = /*#__PURE__*/ $8T3gX.forwardRef(function MobileTimePicker(inProps, ref) {
    const props = (0, $faZcZ.useTimePickerDefaultizedProps)(inProps, 'MuiMobileTimePicker');
    const validationError = (0, $9vOM8.useTimeValidation)(props) !== null;
    const { pickerProps: pickerProps, inputProps: inputProps, wrapperProps: wrapperProps } = (0, $hlZBr.usePickerState)(props, (0, $faZcZ.timePickerValueManager)); // Note that we are passing down all the value without spread.
    // It saves us >1kb gzip and make any prop available automatically on any level down.
    const { ToolbarComponent: ToolbarComponent = (0, $4VrG8.TimePickerToolbar), components: components, componentsProps: componentsProps } = props, other = (0, $fAJB5.default)(props, $72f84dc82d116340$var$_excluded);
    const DateInputProps = (0, $eJfrs.default)({}, inputProps, other, {
        components: components,
        componentsProps: componentsProps,
        ref: ref,
        validationError: validationError
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QCZS.MobileWrapper), (0, $eJfrs.default)({}, other, wrapperProps, {
        DateInputProps: DateInputProps,
        PureDateInputComponent: (0, $hgQKr.PureDateInput),
        components: components,
        componentsProps: componentsProps,
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $gE5dt.CalendarOrClockPicker), (0, $eJfrs.default)({}, pickerProps, {
            autoFocus: true,
            toolbarTitle: props.label || props.toolbarTitle,
            ToolbarComponent: ToolbarComponent,
            DateInputProps: DateInputProps,
            components: components,
            componentsProps: componentsProps
        }, other))
    }));
});
$72f84dc82d116340$export$984018df37898b81.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * Regular expression to detect "accepted" symbols.
   * @default /\dap/gi
   */ acceptRegex: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).instanceOf(RegExp),
    /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */ ampm: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default false
   */ ampmInClock: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * className applied to the root component.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true` the popup or dialog will immediately close after submitting full date.
   * @default `true` for Desktop, `false` for Mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Overrideable components.
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The props used for each component slot.
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Props applied to the [`Dialog`](https://mui.com/material-ui/api/dialog/) element.
   */ DialogProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Disable mask on the keyboard, this should be used rarely. Consider passing proper mask for your format.
   * @default false
   */ disableMaskedInput: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Do not render open picker button (renders only text field with validation).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Accessible text that helps user to understand which time and view is selected.
   * @template TDate
   * @param {ClockPickerView} view The current view rendered.
   * @param {TDate | null} time The current time.
   * @param {MuiPickersAdapter<TDate>} adapter The current date adapter.
   * @returns {string} The clock label.
   * @deprecated Use the `localeText` prop of `LocalizationProvider` instead, see https://mui.com/x/react-date-pickers/localization/.
   * @default <TDate extends any>(
   *   view: ClockView,
   *   time: TDate | null,
   *   adapter: MuiPickersAdapter<TDate>,
   * ) =>
   *   `Select ${view}. ${
   *     time === null ? 'No time selected' : `Selected time is ${adapter.format(time, 'fullTime')}`
   *   }`
   */ getClockLabelText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Get aria-label text for control that opens picker dialog. Aria-label text must include selected date. @DateIOType
   * @template TInputDate, TDate
   * @param {TInputDate} date The date from which we want to add an aria-text.
   * @param {MuiPickersAdapter<TDate>} utils The utils to manipulate the date.
   * @returns {string} The aria-text to render inside the dialog.
   * @default (date, utils) => `Choose date, selected date is ${utils.format(utils.date(date), 'fullDate')}`
   */ getOpenDialogAriaText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    ignoreInvalidInputs: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Props to pass to keyboard input adornment.
   */ InputAdornmentProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Format string.
   */ inputFormat: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    InputProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        })
    ]),
    label: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Custom mask. Can be used to override generate from format. (e.g. `__/__/____ __:__` or `__/__/____ __:__ _M`).
   */ mask: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Max time acceptable time.
   * For input validation date part of passed object will be ignored if `disableIgnoringDatePartForTimeValidation` not specified.
   */ maxTime: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Min time acceptable time.
   * For input validation date part of passed object will be ignored if `disableIgnoringDatePartForTimeValidation` not specified.
   */ minTime: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    /**
   * Callback fired when date is accepted @DateIOType.
   * @template TValue
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the value (the selected date) changes @DateIOType.
   * @template TValue
   * @param {TValue} value The new parsed value.
   * @param {string} keyboardInputValue The current value of the keyboard input.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback that fired when input value or new `value` prop validation returns **new** validation error (or value is valid after error).
   * In case of validation error detected `reason` prop return non-null value and `TextField` must be displayed in `error` state.
   * This can be used to render appropriate form error.
   *
   * [Read the guide](https://next.material-ui-pickers.dev/guides/forms) about form integration and error displaying.
   * @DateIOType
   *
   * @template TError, TInputValue
   * @param {TError} reason The reason why the current value is not valid.
   * @param {TInputValue} value The invalid value.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired on view change.
   * @param {ClockPickerView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Control the popup or dialog open state.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Props to pass to keyboard adornment button.
   */ OpenPickerButtonProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * First view to show.
   * Must be a valid option from `views` list
   * @default 'hours'
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'hours',
        'minutes',
        'seconds'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'landscape',
        'portrait'
    ]),
    /**
   * Make picker read only.
   * @default false
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The `renderInput` prop allows you to customize the rendered input.
   * The `props` argument of this render prop contains props of [TextField](https://mui.com/material-ui/api/text-field/#props) that you need to forward.
   * Pay specific attention to the `ref` and `inputProps` keys.
   * @example ```jsx
   * renderInput={props => <TextField {...props} />}
   * ````
   * @param {MuiTextFieldPropsType} props The props of the input.
   * @returns {React.ReactNode} The node to render as the input.
   */ renderInput: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired,
    /**
   * Custom formatter to be passed into Rifm component.
   * @param {string} str The un-formatted string.
   * @returns {string} The formatted string.
   */ rifmFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Dynamically check if time is disabled or not.
   * If returns `false` appropriate time point will ot be acceptable.
   * @param {number} timeValue The value to check.
   * @param {ClockPickerView} clockType The clock type of the timeValue.
   * @returns {boolean} Returns `true` if the time should be disabled
   */ shouldDisableTime: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, show the toolbar even in desktop mode.
   */ showToolbar: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Component that will replace default toolbar renderer.
   * @default TimePickerToolbar
   */ ToolbarComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * Mobile picker title, displaying in the toolbar.
   * @default 'Select time'
   */ toolbarTitle: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * The value of the picker.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Array of views to show.
   * @default ['hours', 'minutes']
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'hours',
        'minutes',
        'seconds'
    ]).isRequired)
};

});
parcelRegister("3QCZS", function(module, exports) {

$parcel$export(module.exports, "MobileWrapper", () => $2cd47a6e2b16777d$export$170a55317307b99f);

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");
parcelRequire("8T3gX");

var $kneyk = parcelRequire("kneyk");

var $kHp6x = parcelRequire("kHp6x");

var $k4ank = parcelRequire("k4ank");
const $2cd47a6e2b16777d$var$_excluded = [
    "children",
    "DateInputProps",
    "DialogProps",
    "onAccept",
    "onClear",
    "onDismiss",
    "onCancel",
    "onSetToday",
    "open",
    "PureDateInputComponent",
    "components",
    "componentsProps"
];
function $2cd47a6e2b16777d$export$170a55317307b99f(props) {
    const { children: children, DateInputProps: DateInputProps, DialogProps: DialogProps, onAccept: onAccept, onClear: onClear, onDismiss: onDismiss, onCancel: onCancel, onSetToday: onSetToday, open: open, PureDateInputComponent: PureDateInputComponent, components: components, componentsProps: componentsProps } = props, other = (0, $fAJB5.default)(props, $2cd47a6e2b16777d$var$_excluded);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kneyk.WrapperVariantContext).Provider, {
        value: "mobile",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)(PureDateInputComponent, (0, $eJfrs.default)({
                components: components
            }, other, DateInputProps)),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $kHp6x.PickersModalDialog), {
                DialogProps: DialogProps,
                onAccept: onAccept,
                onClear: onClear,
                onDismiss: onDismiss,
                onCancel: onCancel,
                onSetToday: onSetToday,
                open: open,
                components: components,
                componentsProps: componentsProps,
                children: children
            })
        ]
    });
}

});
parcelRegister("kHp6x", function(module, exports) {

$parcel$export(module.exports, "PickersModalDialog", () => $f11b4c066ea28c28$export$99f83c99e1491f77);

var $eJfrs = parcelRequire("eJfrs");
parcelRequire("8T3gX");

var $1TOOV = parcelRequire("1TOOV");

var $kUcVg = parcelRequire("kUcVg");
var $3ZnLf = parcelRequire("3ZnLf");

var $anJSP = parcelRequire("anJSP");

var $b75b5 = parcelRequire("b75b5");

var $3MTyF = parcelRequire("3MTyF");

var $k4ank = parcelRequire("k4ank");
const $f11b4c066ea28c28$var$PickersModalDialogRoot = (0, $anJSP.default)((0, $kUcVg.default))({
    [`& .${(0, $3ZnLf.default).container}`]: {
        outline: 0
    },
    [`& .${(0, $3ZnLf.default).paper}`]: {
        outline: 0,
        minWidth: (0, $b75b5.DIALOG_WIDTH)
    }
});
const $f11b4c066ea28c28$var$PickersModalDialogContent = (0, $anJSP.default)((0, $1TOOV.default))({
    '&:first-of-type': {
        padding: 0
    }
});
const $f11b4c066ea28c28$export$99f83c99e1491f77 = (props)=>{
    var _components$ActionBar;
    const { children: children, DialogProps: DialogProps = {}, onAccept: onAccept, onClear: onClear, onDismiss: onDismiss, onCancel: onCancel, onSetToday: onSetToday, open: open, components: components, componentsProps: componentsProps } = props;
    const ActionBar = (_components$ActionBar = components == null ? void 0 : components.ActionBar) != null ? _components$ActionBar : (0, $3MTyF.PickersActionBar);
    return /*#__PURE__*/ (0, $k4ank.jsxs)($f11b4c066ea28c28$var$PickersModalDialogRoot, (0, $eJfrs.default)({
        open: open,
        onClose: onDismiss
    }, DialogProps, {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)($f11b4c066ea28c28$var$PickersModalDialogContent, {
                children: children
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)(ActionBar, (0, $eJfrs.default)({
                onAccept: onAccept,
                onClear: onClear,
                onCancel: onCancel,
                onSetToday: onSetToday,
                actions: [
                    'cancel',
                    'accept'
                ]
            }, componentsProps == null ? void 0 : componentsProps.actionBar))
        ]
    }));
};

});


parcelRegister("hgQKr", function(module, exports) {

$parcel$export(module.exports, "PureDateInput", () => $c92cd8f636674d6d$export$b6fcc7785a24bca1);

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $7F3bH = parcelRequire("7F3bH");

var $jsJJd = parcelRequire("jsJJd");

var $1hdeG = parcelRequire("1hdeG");

var $86Ccs = parcelRequire("86Ccs");
const $c92cd8f636674d6d$export$b6fcc7785a24bca1 = /*#__PURE__*/ $8T3gX.forwardRef(function PureDateInput(props, ref) {
    const { disabled: disabled, getOpenDialogAriaText: getOpenDialogAriaTextProp, inputFormat: inputFormat, InputProps: InputProps, inputRef: inputRef, label: label, openPicker: onOpen, rawValue: rawValue, renderInput: renderInput, TextFieldProps: TextFieldProps = {}, validationError: validationError, className: className } = props;
    const localeText = (0, $1hdeG.useLocaleText)(); // The prop can not be deprecated
    // Default is "Choose date, ...", but time pickers override it with "Choose time, ..."
    const getOpenDialogAriaText = getOpenDialogAriaTextProp != null ? getOpenDialogAriaTextProp : localeText.openDatePickerDialogue;
    const utils = (0, $1hdeG.useUtils)();
    const PureDateInputProps = $8T3gX.useMemo(()=>(0, $eJfrs.default)({}, InputProps, {
            readOnly: true
        }), [
        InputProps
    ]);
    const inputValue = (0, $86Ccs.getDisplayDate)(utils, rawValue, inputFormat);
    const handleOnClick = (0, $7F3bH.default)((event)=>{
        event.stopPropagation();
        onOpen();
    });
    return renderInput((0, $eJfrs.default)({
        label: label,
        disabled: disabled,
        ref: ref,
        inputRef: inputRef,
        error: validationError,
        InputProps: PureDateInputProps,
        className: className
    }, !props.readOnly && !props.disabled && {
        onClick: handleOnClick
    }, {
        inputProps: (0, $eJfrs.default)({
            disabled: disabled,
            readOnly: true,
            'aria-readonly': true,
            'aria-label': getOpenDialogAriaText(rawValue, utils),
            value: inputValue
        }, !props.readOnly && {
            onClick: handleOnClick
        }, {
            onKeyDown: (0, $jsJJd.onSpaceOrEnter)(onOpen)
        })
    }, TextFieldProps));
});

});



parcelRegister("hfM8m", function(module, exports) {

$parcel$export(module.exports, "AdapterDateFns", () => $c8f92cc41cb0a836$export$81f56c0329a1921d);

var $c55RS = parcelRequire("c55RS");

var $jgags = parcelRequire("jgags");

var $fGmR0 = parcelRequire("fGmR0");
const $c8f92cc41cb0a836$var$formatTokenMap = {
    y: 'year',
    yy: 'year',
    yyy: 'year',
    yyyy: 'year',
    MMMM: 'month',
    MM: 'month',
    DD: 'day',
    d: 'day',
    dd: 'day',
    H: 'hour',
    HH: 'hour',
    h: 'hour',
    hh: 'hour',
    mm: 'minute',
    ss: 'second',
    a: 'am-pm',
    aa: 'am-pm',
    aaa: 'am-pm'
};
class $c8f92cc41cb0a836$export$81f56c0329a1921d extends (0, $c55RS.default) {
    constructor(...args){
        super(...args);
        this.formatTokenMap = $c8f92cc41cb0a836$var$formatTokenMap;
        this.expandFormat = (format)=>{
            const longFormatRegexp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g; // @see https://github.com/date-fns/date-fns/blob/master/src/format/index.js#L31
            return format.match(longFormatRegexp).map((token)=>{
                const firstCharacter = token[0];
                if (firstCharacter === 'p' || firstCharacter === 'P') {
                    const longFormatter = (0, (/*@__PURE__*/$parcel$interopDefault($fGmR0)))[firstCharacter];
                    const locale = this.locale || (0, $jgags.default);
                    return longFormatter(token, locale.formatLong, {});
                }
                return token;
            }).join('');
        };
        this.getFormatHelperText = (format)=>{
            return this.expandFormat(format).replace(/(aaa|aa|a)/g, '(a|p)m').toLocaleLowerCase();
        };
    }
}

});
parcelRegister("c55RS", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cba80eac902a4f6$export$2e2bcd8739ae039);

var $kSoZw = parcelRequire("kSoZw");

var $buNGg = parcelRequire("buNGg");

var $lx4f3 = parcelRequire("lx4f3");

var $lO56d = parcelRequire("lO56d");

var $hoZTM = parcelRequire("hoZTM");

var $gBA4x = parcelRequire("gBA4x");

var $cA1W6 = parcelRequire("cA1W6");

var $8DMKx = parcelRequire("8DMKx");

var $2LDIM = parcelRequire("2LDIM");

var $kjlsb = parcelRequire("kjlsb");

var $fILxK = parcelRequire("fILxK");

var $e9VdT = parcelRequire("e9VdT");

var $fNzth = parcelRequire("fNzth");

var $ehwOH = parcelRequire("ehwOH");

var $b6bqx = parcelRequire("b6bqx");

var $eAw3a = parcelRequire("eAw3a");

var $bziUP = parcelRequire("bziUP");

var $OZta4 = parcelRequire("OZta4");

var $eaxuW = parcelRequire("eaxuW");

var $7IwFK = parcelRequire("7IwFK");

var $vjWp9 = parcelRequire("vjWp9");

var $1a5Mh = parcelRequire("1a5Mh");

var $8vDaa = parcelRequire("8vDaa");

var $dmv68 = parcelRequire("dmv68");

var $hmByX = parcelRequire("hmByX");

var $8O1FX = parcelRequire("8O1FX");

var $82bgg = parcelRequire("82bgg");

var $5BiC3 = parcelRequire("5BiC3");

var $cUcTA = parcelRequire("cUcTA");

var $28JjW = parcelRequire("28JjW");

var $keAdO = parcelRequire("keAdO");

var $hTj25 = parcelRequire("hTj25");

var $eZFiw = parcelRequire("eZFiw");

var $13RWS = parcelRequire("13RWS");

var $4zJRF = parcelRequire("4zJRF");

var $9FFvK = parcelRequire("9FFvK");

var $56FBa = parcelRequire("56FBa");

var $kPWgP = parcelRequire("kPWgP");

var $1zprp = parcelRequire("1zprp");

var $khrLS = parcelRequire("khrLS");

var $3Rwxg = parcelRequire("3Rwxg");

var $krBe9 = parcelRequire("krBe9");

var $6wupV = parcelRequire("6wupV");

var $75ZRt = parcelRequire("75ZRt");

var $lGTzH = parcelRequire("lGTzH");

var $ikJW5 = parcelRequire("ikJW5");

var $gIy8g = parcelRequire("gIy8g");

var $dEWl7 = parcelRequire("dEWl7");

var $kNnNZ = parcelRequire("kNnNZ");

var $f7iMk = parcelRequire("f7iMk");

var $ihKsA = parcelRequire("ihKsA");

var $8lPH0 = parcelRequire("8lPH0");

var $fGmR0 = parcelRequire("fGmR0");

var $jgags = parcelRequire("jgags");
const $8cba80eac902a4f6$var$defaultFormats = {
    dayOfMonth: "d",
    fullDate: "PP",
    fullDateWithWeekday: "PPPP",
    fullDateTime: "PP p",
    fullDateTime12h: "PP hh:mm aaa",
    fullDateTime24h: "PP HH:mm",
    fullTime: "p",
    fullTime12h: "hh:mm aaa",
    fullTime24h: "HH:mm",
    hours12h: "hh",
    hours24h: "HH",
    keyboardDate: "P",
    keyboardDateTime: "P p",
    keyboardDateTime12h: "P hh:mm aaa",
    keyboardDateTime24h: "P HH:mm",
    minutes: "mm",
    month: "LLLL",
    monthAndDate: "MMMM d",
    monthAndYear: "LLLL yyyy",
    monthShort: "MMM",
    weekday: "EEEE",
    weekdayShort: "EEE",
    normalDate: "d MMMM",
    normalDateWithWeekday: "EEE, MMM d",
    seconds: "ss",
    shortDate: "MMM d",
    year: "yyyy"
};
class $8cba80eac902a4f6$export$2e2bcd8739ae039 {
    constructor({ locale: locale, formats: formats } = {}){
        this.lib = "date-fns";
        // Note: date-fns input types are more lenient than this adapter, so we need to expose our more
        // strict signature and delegate to the more lenient signature. Otherwise, we have downstream type errors upon usage.
        this.is12HourCycleInCurrentLocale = ()=>{
            var _a;
            if (this.locale) return /a/.test((_a = this.locale.formatLong) === null || _a === void 0 ? void 0 : _a.time());
            // By default date-fns is using en-US locale with am/pm enabled
            return true;
        };
        this.getFormatHelperText = (format)=>{
            var _a, _b;
            // @see https://github.com/date-fns/date-fns/blob/master/src/format/index.js#L31
            const longFormatRegexp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
            const locale = this.locale || (0, $jgags.default);
            return (_b = (_a = format.match(longFormatRegexp)) === null || _a === void 0 ? void 0 : _a.map((token)=>{
                const firstCharacter = token[0];
                if (firstCharacter === "p" || firstCharacter === "P") {
                    const longFormatter = (0, (/*@__PURE__*/$parcel$interopDefault($fGmR0)))[firstCharacter];
                    return longFormatter(token, locale.formatLong, {});
                }
                return token;
            }).join("").replace(/(aaa|aa|a)/g, "(a|p)m").toLocaleLowerCase()) !== null && _b !== void 0 ? _b : format;
        };
        this.parseISO = (isoString)=>{
            return (0, $f7iMk.default)(isoString);
        };
        this.toISO = (value)=>{
            return (0, $ihKsA.default)(value, {
                format: "extended"
            });
        };
        this.getCurrentLocaleCode = ()=>{
            var _a;
            return ((_a = this.locale) === null || _a === void 0 ? void 0 : _a.code) || "en-US";
        };
        this.addSeconds = (value, count)=>{
            return (0, $buNGg.default)(value, count);
        };
        this.addMinutes = (value, count)=>{
            return (0, $lx4f3.default)(value, count);
        };
        this.addHours = (value, count)=>{
            return (0, $lO56d.default)(value, count);
        };
        this.addDays = (value, count)=>{
            return (0, $kSoZw.default)(value, count);
        };
        this.addWeeks = (value, count)=>{
            return (0, $hoZTM.default)(value, count);
        };
        this.addMonths = (value, count)=>{
            return (0, $gBA4x.default)(value, count);
        };
        this.addYears = (value, count)=>{
            return (0, $cA1W6.default)(value, count);
        };
        this.isValid = (value)=>{
            return (0, $56FBa.default)(this.date(value));
        };
        this.getDiff = (value, comparing, unit)=>{
            var _a;
            // we output 0 if the compare date is string and parsing is not valid
            const dateToCompare = (_a = this.date(comparing)) !== null && _a !== void 0 ? _a : value;
            if (!this.isValid(dateToCompare)) return 0;
            switch(unit){
                case "years":
                    return (0, $8DMKx.default)(value, dateToCompare);
                case "quarters":
                    return (0, $2LDIM.default)(value, dateToCompare);
                case "months":
                    return (0, $kjlsb.default)(value, dateToCompare);
                case "weeks":
                    return (0, $fILxK.default)(value, dateToCompare);
                case "days":
                    return (0, $e9VdT.default)(value, dateToCompare);
                case "hours":
                    return (0, $fNzth.default)(value, dateToCompare);
                case "minutes":
                    return (0, $ehwOH.default)(value, dateToCompare);
                case "seconds":
                    return (0, $b6bqx.default)(value, dateToCompare);
                default:
                    return (0, $eAw3a.default)(value, dateToCompare);
            }
        };
        this.isAfter = (value, comparing)=>{
            return (0, $28JjW.default)(value, comparing);
        };
        this.isBefore = (value, comparing)=>{
            return (0, $keAdO.default)(value, comparing);
        };
        this.startOfDay = (value)=>{
            return (0, $lGTzH.default)(value);
        };
        this.endOfDay = (value)=>{
            return (0, $OZta4.default)(value);
        };
        this.getHours = (value)=>{
            return (0, $hmByX.default)(value);
        };
        this.setHours = (value, count)=>{
            return (0, $khrLS.default)(value, count);
        };
        this.setMinutes = (value, count)=>{
            return (0, $3Rwxg.default)(value, count);
        };
        this.getSeconds = (value)=>{
            return (0, $5BiC3.default)(value);
        };
        this.setSeconds = (value, count)=>{
            return (0, $6wupV.default)(value, count);
        };
        this.isSameDay = (value, comparing)=>{
            return (0, $eZFiw.default)(value, comparing);
        };
        this.isSameMonth = (value, comparing)=>{
            return (0, $4zJRF.default)(value, comparing);
        };
        this.isSameYear = (value, comparing)=>{
            return (0, $13RWS.default)(value, comparing);
        };
        this.isSameHour = (value, comparing)=>{
            return (0, $9FFvK.default)(value, comparing);
        };
        this.startOfYear = (value)=>{
            return (0, $kNnNZ.default)(value);
        };
        this.endOfYear = (value)=>{
            return (0, $7IwFK.default)(value);
        };
        this.startOfMonth = (value)=>{
            return (0, $ikJW5.default)(value);
        };
        this.endOfMonth = (value)=>{
            return (0, $gIy8g.default)(value);
        };
        this.startOfWeek = (value)=>{
            return (0, $dEWl7.default)(value, {
                locale: this.locale
            });
        };
        this.endOfWeek = (value)=>{
            return (0, $eaxuW.default)(value, {
                locale: this.locale
            });
        };
        this.getYear = (value)=>{
            return (0, $cUcTA.default)(value);
        };
        this.setYear = (value, count)=>{
            return (0, $75ZRt.default)(value, count);
        };
        this.date = (value)=>{
            if (typeof value === "undefined") return new Date();
            if (value === null) return null;
            return new Date(value);
        };
        this.toJsDate = (value)=>{
            return value;
        };
        this.parse = (value, formatString)=>{
            if (value === "") return null;
            return (0, $kPWgP.default)(value, formatString, new Date(), {
                locale: this.locale
            });
        };
        this.format = (date, formatKey)=>{
            return this.formatByString(date, this.formats[formatKey]);
        };
        this.formatByString = (date, formatString)=>{
            return (0, $vjWp9.default)(date, formatString, {
                locale: this.locale
            });
        };
        this.isEqual = (date, comparing)=>{
            if (date === null && comparing === null) return true;
            return (0, $hTj25.default)(date, comparing);
        };
        this.isNull = (date)=>{
            return date === null;
        };
        this.isAfterDay = (date, value)=>{
            return (0, $28JjW.default)(date, (0, $OZta4.default)(value));
        };
        this.isBeforeDay = (date, value)=>{
            return (0, $keAdO.default)(date, (0, $lGTzH.default)(value));
        };
        this.isBeforeYear = (date, value)=>{
            return (0, $keAdO.default)(date, (0, $kNnNZ.default)(value));
        };
        this.isAfterYear = (date, value)=>{
            return (0, $28JjW.default)(date, (0, $7IwFK.default)(value));
        };
        this.isWithinRange = (date, [start, end])=>{
            return (0, $8lPH0.default)(date, {
                start: start,
                end: end
            });
        };
        this.formatNumber = (numberToFormat)=>{
            return numberToFormat;
        };
        this.getMinutes = (date)=>{
            return (0, $8O1FX.default)(date);
        };
        this.getDate = (date)=>{
            return (0, $1a5Mh.default)(date);
        };
        this.setDate = (date, count)=>{
            return (0, $1zprp.default)(date, count);
        };
        this.getMonth = (date)=>{
            return (0, $82bgg.default)(date);
        };
        this.getDaysInMonth = (date)=>{
            return (0, $dmv68.default)(date);
        };
        this.setMonth = (date, count)=>{
            return (0, $krBe9.default)(date, count);
        };
        this.getMeridiemText = (ampm)=>{
            return ampm === "am" ? "AM" : "PM";
        };
        this.getNextMonth = (date)=>{
            return (0, $gBA4x.default)(date, 1);
        };
        this.getPreviousMonth = (date)=>{
            return (0, $gBA4x.default)(date, -1);
        };
        this.getMonthArray = (date)=>{
            const firstMonth = (0, $kNnNZ.default)(date);
            const monthArray = [
                firstMonth
            ];
            while(monthArray.length < 12){
                const prevMonth = monthArray[monthArray.length - 1];
                monthArray.push(this.getNextMonth(prevMonth));
            }
            return monthArray;
        };
        this.mergeDateAndTime = (date, time)=>{
            return this.setSeconds(this.setMinutes(this.setHours(date, this.getHours(time)), this.getMinutes(time)), this.getSeconds(time));
        };
        this.getWeekdays = ()=>{
            const now = new Date();
            return (0, $bziUP.default)({
                start: (0, $dEWl7.default)(now, {
                    locale: this.locale
                }),
                end: (0, $eaxuW.default)(now, {
                    locale: this.locale
                })
            }).map((day)=>this.formatByString(day, "EEEEEE"));
        };
        this.getWeekArray = (date)=>{
            const start = (0, $dEWl7.default)((0, $ikJW5.default)(date), {
                locale: this.locale
            });
            const end = (0, $eaxuW.default)((0, $gIy8g.default)(date), {
                locale: this.locale
            });
            let count = 0;
            let current = start;
            const nestedWeeks = [];
            let lastDay = null;
            while((0, $keAdO.default)(current, end)){
                const weekNumber = Math.floor(count / 7);
                nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
                const day = (0, $8vDaa.default)(current);
                if (lastDay !== day) {
                    lastDay = day;
                    nestedWeeks[weekNumber].push(current);
                    count += 1;
                }
                current = (0, $kSoZw.default)(current, 1);
            }
            return nestedWeeks;
        };
        this.getYearRange = (start, end)=>{
            const startDate = (0, $kNnNZ.default)(start);
            const endDate = (0, $7IwFK.default)(end);
            const years = [];
            let current = startDate;
            while((0, $keAdO.default)(current, endDate)){
                years.push(current);
                current = (0, $cA1W6.default)(current, 1);
            }
            return years;
        };
        this.locale = locale;
        this.formats = Object.assign({}, $8cba80eac902a4f6$var$defaultFormats, formats);
    }
    isBeforeMonth(value, comparing) {
        return (0, $keAdO.default)(value, (0, $ikJW5.default)(comparing));
    }
    isAfterMonth(value, comparing) {
        return (0, $28JjW.default)(value, (0, $ikJW5.default)(comparing));
    }
}

});
parcelRegister("kSoZw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f32c3c867c1ecd39$export$2e2bcd8739ae039);

var $kKOHX = parcelRequire("kKOHX");

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $f32c3c867c1ecd39$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $kl91g.default)(2, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    var amount = (0, $kKOHX.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});
parcelRegister("kKOHX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1bf70133955bb3a$export$2e2bcd8739ae039);
function $f1bf70133955bb3a$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});

parcelRegister("jwXww", function(module, exports) {

$parcel$export(module.exports, "default", () => $e37f2d9ca9fce3c8$export$2e2bcd8739ae039);

var $THUM4 = parcelRequire("THUM4");

var $kl91g = parcelRequire("kl91g");
function $e37f2d9ca9fce3c8$export$2e2bcd8739ae039(argument) {
    (0, $kl91g.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $THUM4.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("THUM4", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a7733b75de60c69$export$2e2bcd8739ae039);
function $0a7733b75de60c69$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $0a7733b75de60c69$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0a7733b75de60c69$export$2e2bcd8739ae039(o);
}

});

parcelRegister("kl91g", function(module, exports) {

$parcel$export(module.exports, "default", () => $ececc3daf0914d69$export$2e2bcd8739ae039);
function $ececc3daf0914d69$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});



parcelRegister("buNGg", function(module, exports) {

$parcel$export(module.exports, "default", () => $85e9089b30a0b19a$export$2e2bcd8739ae039);

var $kKOHX = parcelRequire("kKOHX");

var $Z8b0I = parcelRequire("Z8b0I");

var $kl91g = parcelRequire("kl91g");
function $85e9089b30a0b19a$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $kl91g.default)(2, arguments);
    var amount = (0, $kKOHX.default)(dirtyAmount);
    return (0, $Z8b0I.default)(dirtyDate, amount * 1000);
}

});
parcelRegister("Z8b0I", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b7c0a5206e24126$export$2e2bcd8739ae039);

var $kKOHX = parcelRequire("kKOHX");

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $0b7c0a5206e24126$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $kl91g.default)(2, arguments);
    var timestamp = (0, $jwXww.default)(dirtyDate).getTime();
    var amount = (0, $kKOHX.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});


parcelRegister("lx4f3", function(module, exports) {

$parcel$export(module.exports, "default", () => $facff85f4d52d874$export$2e2bcd8739ae039);

var $kKOHX = parcelRequire("kKOHX");

var $Z8b0I = parcelRequire("Z8b0I");

var $kl91g = parcelRequire("kl91g");
var $facff85f4d52d874$var$MILLISECONDS_IN_MINUTE = 60000;
function $facff85f4d52d874$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $kl91g.default)(2, arguments);
    var amount = (0, $kKOHX.default)(dirtyAmount);
    return (0, $Z8b0I.default)(dirtyDate, amount * $facff85f4d52d874$var$MILLISECONDS_IN_MINUTE);
}

});

parcelRegister("lO56d", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe023915033195b5$export$2e2bcd8739ae039);

var $kKOHX = parcelRequire("kKOHX");

var $Z8b0I = parcelRequire("Z8b0I");

var $kl91g = parcelRequire("kl91g");
var $fe023915033195b5$var$MILLISECONDS_IN_HOUR = 3600000;
function $fe023915033195b5$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $kl91g.default)(2, arguments);
    var amount = (0, $kKOHX.default)(dirtyAmount);
    return (0, $Z8b0I.default)(dirtyDate, amount * $fe023915033195b5$var$MILLISECONDS_IN_HOUR);
}

});

parcelRegister("hoZTM", function(module, exports) {

$parcel$export(module.exports, "default", () => $cab4b15a98dac0fa$export$2e2bcd8739ae039);

var $kKOHX = parcelRequire("kKOHX");

var $kSoZw = parcelRequire("kSoZw");

var $kl91g = parcelRequire("kl91g");
function $cab4b15a98dac0fa$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $kl91g.default)(2, arguments);
    var amount = (0, $kKOHX.default)(dirtyAmount);
    var days = amount * 7;
    return (0, $kSoZw.default)(dirtyDate, days);
}

});

parcelRegister("gBA4x", function(module, exports) {

$parcel$export(module.exports, "default", () => $c16c1536be5b9507$export$2e2bcd8739ae039);

var $kKOHX = parcelRequire("kKOHX");

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $c16c1536be5b9507$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $kl91g.default)(2, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    var amount = (0, $kKOHX.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});

parcelRegister("cA1W6", function(module, exports) {

$parcel$export(module.exports, "default", () => $928a594b130b8a6d$export$2e2bcd8739ae039);

var $kKOHX = parcelRequire("kKOHX");

var $gBA4x = parcelRequire("gBA4x");

var $kl91g = parcelRequire("kl91g");
function $928a594b130b8a6d$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $kl91g.default)(2, arguments);
    var amount = (0, $kKOHX.default)(dirtyAmount);
    return (0, $gBA4x.default)(dirtyDate, amount * 12);
}

});

parcelRegister("8DMKx", function(module, exports) {

$parcel$export(module.exports, "default", () => $64a7c7ea1ec704ce$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $9qZ6S = parcelRequire("9qZ6S");

var $kgZz3 = parcelRequire("kgZz3");

var $kl91g = parcelRequire("kl91g");
function $64a7c7ea1ec704ce$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $kl91g.default)(2, arguments);
    var dateLeft = (0, $jwXww.default)(dirtyDateLeft);
    var dateRight = (0, $jwXww.default)(dirtyDateRight);
    var sign = (0, $kgZz3.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $9qZ6S.default)(dateLeft, dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    dateLeft.setFullYear(1584);
    dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastYearNotFull = (0, $kgZz3.default)(dateLeft, dateRight) === -sign;
    var result = sign * (difference - Number(isLastYearNotFull));
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("9qZ6S", function(module, exports) {

$parcel$export(module.exports, "default", () => $6de5f1ec751a9e8e$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $6de5f1ec751a9e8e$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $kl91g.default)(2, arguments);
    var dateLeft = (0, $jwXww.default)(dirtyDateLeft);
    var dateRight = (0, $jwXww.default)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}

});

parcelRegister("kgZz3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec250eb0000ff500$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $ec250eb0000ff500$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $kl91g.default)(2, arguments);
    var dateLeft = (0, $jwXww.default)(dirtyDateLeft);
    var dateRight = (0, $jwXww.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});


parcelRegister("2LDIM", function(module, exports) {

$parcel$export(module.exports, "default", () => $203ec859131ceb2a$export$2e2bcd8739ae039);

var $kjlsb = parcelRequire("kjlsb");

var $kl91g = parcelRequire("kl91g");

var $lWusn = parcelRequire("lWusn");
function $203ec859131ceb2a$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $kl91g.default)(2, arguments);
    var diff = (0, $kjlsb.default)(dateLeft, dateRight) / 3;
    return (0, $lWusn.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});
parcelRegister("kjlsb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec96393c6ec9139a$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $boxy5 = parcelRequire("boxy5");

var $kgZz3 = parcelRequire("kgZz3");

var $kl91g = parcelRequire("kl91g");

var $6nhUR = parcelRequire("6nhUR");
function $ec96393c6ec9139a$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $kl91g.default)(2, arguments);
    var dateLeft = (0, $jwXww.default)(dirtyDateLeft);
    var dateRight = (0, $jwXww.default)(dirtyDateRight);
    var sign = (0, $kgZz3.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $boxy5.default)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $kgZz3.default)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $6nhUR.default)((0, $jwXww.default)(dirtyDateLeft)) && difference === 1 && (0, $kgZz3.default)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("boxy5", function(module, exports) {

$parcel$export(module.exports, "default", () => $84bbf5adb43b9752$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $84bbf5adb43b9752$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $kl91g.default)(2, arguments);
    var dateLeft = (0, $jwXww.default)(dirtyDateLeft);
    var dateRight = (0, $jwXww.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("6nhUR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a42c9d7fc83deae$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $OZta4 = parcelRequire("OZta4");

var $gIy8g = parcelRequire("gIy8g");

var $kl91g = parcelRequire("kl91g");
function $4a42c9d7fc83deae$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kl91g.default)(1, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    return (0, $OZta4.default)(date).getTime() === (0, $gIy8g.default)(date).getTime();
}

});
parcelRegister("OZta4", function(module, exports) {

$parcel$export(module.exports, "default", () => $09945a287720f595$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $09945a287720f595$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kl91g.default)(1, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("gIy8g", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2bb3b5cb574d364$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $c2bb3b5cb574d364$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kl91g.default)(1, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});



parcelRegister("lWusn", function(module, exports) {

$parcel$export(module.exports, "getRoundingMethod", () => $ff96a3d2e3effa2c$export$b6474a47258c1211);
var $ff96a3d2e3effa2c$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $ff96a3d2e3effa2c$var$defaultRoundingMethod = 'trunc';
function $ff96a3d2e3effa2c$export$b6474a47258c1211(method) {
    return method ? $ff96a3d2e3effa2c$var$roundingMap[method] : $ff96a3d2e3effa2c$var$roundingMap[$ff96a3d2e3effa2c$var$defaultRoundingMethod];
}

});


parcelRegister("fILxK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b71fd836138db8ad$export$2e2bcd8739ae039);

var $e9VdT = parcelRequire("e9VdT");

var $kl91g = parcelRequire("kl91g");

var $lWusn = parcelRequire("lWusn");
function $b71fd836138db8ad$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $kl91g.default)(2, arguments);
    var diff = (0, $e9VdT.default)(dateLeft, dateRight) / 7;
    return (0, $lWusn.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});
parcelRegister("e9VdT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4ee4b4559e347c5$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $ffS5G = parcelRequire("ffS5G");

var $kl91g = parcelRequire("kl91g");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $a4ee4b4559e347c5$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $a4ee4b4559e347c5$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $kl91g.default)(2, arguments);
    var dateLeft = (0, $jwXww.default)(dirtyDateLeft);
    var dateRight = (0, $jwXww.default)(dirtyDateRight);
    var sign = $a4ee4b4559e347c5$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $ffS5G.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($a4ee4b4559e347c5$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("ffS5G", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1b237035b2c544c$export$2e2bcd8739ae039);

var $5Bj0e = parcelRequire("5Bj0e");

var $lGTzH = parcelRequire("lGTzH");

var $kl91g = parcelRequire("kl91g");
var $b1b237035b2c544c$var$MILLISECONDS_IN_DAY = 86400000;
function $b1b237035b2c544c$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $kl91g.default)(2, arguments);
    var startOfDayLeft = (0, $lGTzH.default)(dirtyDateLeft);
    var startOfDayRight = (0, $lGTzH.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $5Bj0e.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $5Bj0e.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $b1b237035b2c544c$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("5Bj0e", function(module, exports) {

$parcel$export(module.exports, "default", () => $413f25f9f1b7dafb$export$2e2bcd8739ae039);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $413f25f9f1b7dafb$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("lGTzH", function(module, exports) {

$parcel$export(module.exports, "default", () => $fca8a13cb898fa94$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $fca8a13cb898fa94$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kl91g.default)(1, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});




parcelRegister("fNzth", function(module, exports) {

$parcel$export(module.exports, "default", () => $b806f27bde32b0eb$export$2e2bcd8739ae039);

var $HfRMJ = parcelRequire("HfRMJ");

var $eAw3a = parcelRequire("eAw3a");

var $kl91g = parcelRequire("kl91g");

var $lWusn = parcelRequire("lWusn");
function $b806f27bde32b0eb$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $kl91g.default)(2, arguments);
    var diff = (0, $eAw3a.default)(dateLeft, dateRight) / (0, $HfRMJ.millisecondsInHour);
    return (0, $lWusn.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});
parcelRegister("HfRMJ", function(module, exports) {

$parcel$export(module.exports, "millisecondsInMinute", () => $08205305e64851bb$export$91246f0b9bd9beff);
$parcel$export(module.exports, "millisecondsInHour", () => $08205305e64851bb$export$7f72910d6dfd237a);
$parcel$export(module.exports, "millisecondsInSecond", () => $08205305e64851bb$export$397c2d5776aa9055);
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $08205305e64851bb$export$dfd9b671c89acc8e = 7;
var $08205305e64851bb$export$3913210603d8e9ae = 365.2425;
var $08205305e64851bb$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $08205305e64851bb$export$91246f0b9bd9beff = 60000;
var $08205305e64851bb$export$7f72910d6dfd237a = 3600000;
var $08205305e64851bb$export$397c2d5776aa9055 = 1000;
var $08205305e64851bb$export$4dec998e48f9c246 = -$08205305e64851bb$export$81caae6e1cc7a622;
var $08205305e64851bb$export$f2f5ae5a8e2d8f9f = 60;
var $08205305e64851bb$export$3c58128db900d44e = 3;
var $08205305e64851bb$export$80d7e435f744f319 = 12;
var $08205305e64851bb$export$4db7641526e3241f = 4;
var $08205305e64851bb$export$698aec755e92c695 = 3600;
var $08205305e64851bb$export$a77c1a7ebebe2a5a = 60;
var $08205305e64851bb$export$815a9362476d2fe3 = $08205305e64851bb$export$698aec755e92c695 * 24;
var $08205305e64851bb$export$34804a017b31e2fe = $08205305e64851bb$export$815a9362476d2fe3 * 7;
var $08205305e64851bb$export$7271e9e3478110d1 = $08205305e64851bb$export$815a9362476d2fe3 * $08205305e64851bb$export$3913210603d8e9ae;
var $08205305e64851bb$export$8e6600bbdee7dabb = $08205305e64851bb$export$7271e9e3478110d1 / 12;
var $08205305e64851bb$export$be1dccf2de902d31 = $08205305e64851bb$export$8e6600bbdee7dabb * 3;

});

parcelRegister("eAw3a", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9ed49f3cace5a16$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $a9ed49f3cace5a16$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $kl91g.default)(2, arguments);
    return (0, $jwXww.default)(dateLeft).getTime() - (0, $jwXww.default)(dateRight).getTime();
}

});


parcelRegister("ehwOH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a65c1bed11778e36$export$2e2bcd8739ae039);

var $HfRMJ = parcelRequire("HfRMJ");

var $eAw3a = parcelRequire("eAw3a");

var $kl91g = parcelRequire("kl91g");

var $lWusn = parcelRequire("lWusn");
function $a65c1bed11778e36$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $kl91g.default)(2, arguments);
    var diff = (0, $eAw3a.default)(dateLeft, dateRight) / (0, $HfRMJ.millisecondsInMinute);
    return (0, $lWusn.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("b6bqx", function(module, exports) {

$parcel$export(module.exports, "default", () => $81491e6dee20ca5b$export$2e2bcd8739ae039);

var $eAw3a = parcelRequire("eAw3a");

var $kl91g = parcelRequire("kl91g");

var $lWusn = parcelRequire("lWusn");
function $81491e6dee20ca5b$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $kl91g.default)(2, arguments);
    var diff = (0, $eAw3a.default)(dateLeft, dateRight) / 1000;
    return (0, $lWusn.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("bziUP", function(module, exports) {

$parcel$export(module.exports, "default", () => $86c1a2d24b15a26e$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $86c1a2d24b15a26e$export$2e2bcd8739ae039(dirtyInterval, options) {
    var _options$step;
    (0, $kl91g.default)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, $jwXww.default)(interval.start);
    var endDate = (0, $jwXww.default)(interval.end);
    var endTime = endDate.getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startDate.getTime() <= endTime)) throw new RangeError('Invalid interval');
    var dates = [];
    var currentDate = startDate;
    currentDate.setHours(0, 0, 0, 0);
    var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
    if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
    while(currentDate.getTime() <= endTime){
        dates.push((0, $jwXww.default)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return dates;
}

});

parcelRegister("eaxuW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a50bfbde9a48d138$export$2e2bcd8739ae039);

var $8wGln = parcelRequire("8wGln");

var $jwXww = parcelRequire("jwXww");

var $kKOHX = parcelRequire("kKOHX");

var $kl91g = parcelRequire("kl91g");
function $a50bfbde9a48d138$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $kl91g.default)(1, arguments);
    var defaultOptions = (0, $8wGln.getDefaultOptions)();
    var weekStartsOn = (0, $kKOHX.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $jwXww.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}

});
parcelRegister("8wGln", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $6352287f3bd1f23b$export$430a3269e24b912e);
var $6352287f3bd1f23b$var$defaultOptions = {};
function $6352287f3bd1f23b$export$430a3269e24b912e() {
    return $6352287f3bd1f23b$var$defaultOptions;
}
function $6352287f3bd1f23b$export$95365be1b0704abc(newOptions) {
    $6352287f3bd1f23b$var$defaultOptions = newOptions;
}

});


parcelRegister("7IwFK", function(module, exports) {

$parcel$export(module.exports, "default", () => $59e5fc8509e3d8b8$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $59e5fc8509e3d8b8$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kl91g.default)(1, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("vjWp9", function(module, exports) {

$parcel$export(module.exports, "default", () => $05e25d3c1fa4c65f$export$2e2bcd8739ae039);

var $56FBa = parcelRequire("56FBa");

var $bZbxy = parcelRequire("bZbxy");

var $jwXww = parcelRequire("jwXww");

var $2naF6 = parcelRequire("2naF6");

var $csjg0 = parcelRequire("csjg0");

var $5Bj0e = parcelRequire("5Bj0e");

var $jChhX = parcelRequire("jChhX");

var $kKOHX = parcelRequire("kKOHX");

var $kl91g = parcelRequire("kl91g");

var $8wGln = parcelRequire("8wGln");

var $8927d = parcelRequire("8927d");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $05e25d3c1fa4c65f$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $05e25d3c1fa4c65f$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $05e25d3c1fa4c65f$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $05e25d3c1fa4c65f$var$doubleQuoteRegExp = /''/g;
var $05e25d3c1fa4c65f$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $05e25d3c1fa4c65f$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $kl91g.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $8wGln.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $8927d.default);
    var firstWeekContainsDate = (0, $kKOHX.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $kKOHX.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $jwXww.default)(dirtyDate);
    if (!(0, $56FBa.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $5Bj0e.default)(originalDate);
    var utcDate = (0, $bZbxy.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($05e25d3c1fa4c65f$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $csjg0.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($05e25d3c1fa4c65f$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $05e25d3c1fa4c65f$var$cleanEscapedString(substring);
        var formatter = (0, $2naF6.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $jChhX.isProtectedWeekYearToken)(substring)) (0, $jChhX.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $jChhX.isProtectedDayOfYearToken)(substring)) (0, $jChhX.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($05e25d3c1fa4c65f$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $05e25d3c1fa4c65f$var$cleanEscapedString(input) {
    var matched = input.match($05e25d3c1fa4c65f$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($05e25d3c1fa4c65f$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("56FBa", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b7dc7e77a6a5d98$export$2e2bcd8739ae039);

var $6SzXM = parcelRequire("6SzXM");

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $3b7dc7e77a6a5d98$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kl91g.default)(1, arguments);
    if (!(0, $6SzXM.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $jwXww.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("6SzXM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5023aec52e8320a9$export$2e2bcd8739ae039);

var $THUM4 = parcelRequire("THUM4");

var $kl91g = parcelRequire("kl91g");
function $5023aec52e8320a9$export$2e2bcd8739ae039(value) {
    (0, $kl91g.default)(1, arguments);
    return value instanceof Date || (0, $THUM4.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

});


parcelRegister("bZbxy", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b9e57d5af3d76b5$export$2e2bcd8739ae039);

var $Z8b0I = parcelRequire("Z8b0I");

var $kl91g = parcelRequire("kl91g");

var $kKOHX = parcelRequire("kKOHX");
function $8b9e57d5af3d76b5$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $kl91g.default)(2, arguments);
    var amount = (0, $kKOHX.default)(dirtyAmount);
    return (0, $Z8b0I.default)(dirtyDate, -amount);
}

});

parcelRegister("2naF6", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ba5fffbc2fbddd9$export$2e2bcd8739ae039);

var $lzium = parcelRequire("lzium");

var $eHL5u = parcelRequire("eHL5u");

var $dCHW2 = parcelRequire("dCHW2");

var $2E1z6 = parcelRequire("2E1z6");

var $hvmv7 = parcelRequire("hvmv7");

var $fJf0R = parcelRequire("fJf0R");

var $3FCM8 = parcelRequire("3FCM8");
var $1ba5fffbc2fbddd9$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $1ba5fffbc2fbddd9$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $3FCM8.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $hvmv7.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $fJf0R.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $fJf0R.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $dCHW2.default)(date);
        // Padding
        return (0, $fJf0R.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $fJf0R.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $fJf0R.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $fJf0R.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $3FCM8.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $fJf0R.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $2E1z6.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $fJf0R.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $eHL5u.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $fJf0R.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $3FCM8.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $lzium.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $fJf0R.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $fJf0R.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $fJf0R.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $fJf0R.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $1ba5fffbc2fbddd9$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $1ba5fffbc2fbddd9$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $1ba5fffbc2fbddd9$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $1ba5fffbc2fbddd9$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $1ba5fffbc2fbddd9$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $1ba5fffbc2fbddd9$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $3FCM8.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $3FCM8.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $fJf0R.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $fJf0R.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $3FCM8.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $3FCM8.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $3FCM8.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $1ba5fffbc2fbddd9$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $1ba5fffbc2fbddd9$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $1ba5fffbc2fbddd9$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $1ba5fffbc2fbddd9$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $1ba5fffbc2fbddd9$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $1ba5fffbc2fbddd9$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $1ba5fffbc2fbddd9$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $1ba5fffbc2fbddd9$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $1ba5fffbc2fbddd9$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $1ba5fffbc2fbddd9$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $fJf0R.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $fJf0R.default)(timestamp, token.length);
    }
};
function $1ba5fffbc2fbddd9$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $fJf0R.default)(minutes, 2);
}
function $1ba5fffbc2fbddd9$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $fJf0R.default)(Math.abs(offset) / 60, 2);
    }
    return $1ba5fffbc2fbddd9$var$formatTimezone(offset, dirtyDelimiter);
}
function $1ba5fffbc2fbddd9$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $fJf0R.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $fJf0R.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $1ba5fffbc2fbddd9$export$2e2bcd8739ae039 = $1ba5fffbc2fbddd9$var$formatters;

});
parcelRegister("lzium", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb3b35549edda28b$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
var $fb3b35549edda28b$var$MILLISECONDS_IN_DAY = 86400000;
function $fb3b35549edda28b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kl91g.default)(1, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $fb3b35549edda28b$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("eHL5u", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab499b6f9374ad82$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $5sReG = parcelRequire("5sReG");

var $8ZJh0 = parcelRequire("8ZJh0");

var $kl91g = parcelRequire("kl91g");
var $ab499b6f9374ad82$var$MILLISECONDS_IN_WEEK = 604800000;
function $ab499b6f9374ad82$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kl91g.default)(1, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    var diff = (0, $5sReG.default)(date).getTime() - (0, $8ZJh0.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $ab499b6f9374ad82$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("5sReG", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa8dcd27ccc7610$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $3fa8dcd27ccc7610$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kl91g.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $jwXww.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("8ZJh0", function(module, exports) {

$parcel$export(module.exports, "default", () => $68c723953458276a$export$2e2bcd8739ae039);

var $dCHW2 = parcelRequire("dCHW2");

var $5sReG = parcelRequire("5sReG");

var $kl91g = parcelRequire("kl91g");
function $68c723953458276a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kl91g.default)(1, arguments);
    var year = (0, $dCHW2.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $5sReG.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("dCHW2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9eb0e7933d8b62c1$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");

var $5sReG = parcelRequire("5sReG");
function $9eb0e7933d8b62c1$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kl91g.default)(1, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $5sReG.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $5sReG.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("2E1z6", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ed08808bc9bd46e$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $jYhGL = parcelRequire("jYhGL");

var $c6X1G = parcelRequire("c6X1G");

var $kl91g = parcelRequire("kl91g");
var $1ed08808bc9bd46e$var$MILLISECONDS_IN_WEEK = 604800000;
function $1ed08808bc9bd46e$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $kl91g.default)(1, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    var diff = (0, $jYhGL.default)(date, options).getTime() - (0, $c6X1G.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $1ed08808bc9bd46e$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("jYhGL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8a15785dd28e61a$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");

var $kKOHX = parcelRequire("kKOHX");

var $8wGln = parcelRequire("8wGln");
function $e8a15785dd28e61a$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $kl91g.default)(1, arguments);
    var defaultOptions = (0, $8wGln.getDefaultOptions)();
    var weekStartsOn = (0, $kKOHX.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $jwXww.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("c6X1G", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d13d4f42d74cb4b$export$2e2bcd8739ae039);

var $hvmv7 = parcelRequire("hvmv7");

var $kl91g = parcelRequire("kl91g");

var $jYhGL = parcelRequire("jYhGL");

var $kKOHX = parcelRequire("kKOHX");

var $8wGln = parcelRequire("8wGln");
function $8d13d4f42d74cb4b$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $kl91g.default)(1, arguments);
    var defaultOptions = (0, $8wGln.getDefaultOptions)();
    var firstWeekContainsDate = (0, $kKOHX.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $hvmv7.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $jYhGL.default)(firstWeek, options);
    return date;
}

});
parcelRegister("hvmv7", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbe6c921bfbe3214$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");

var $jYhGL = parcelRequire("jYhGL");

var $kKOHX = parcelRequire("kKOHX");

var $8wGln = parcelRequire("8wGln");
function $cbe6c921bfbe3214$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $kl91g.default)(1, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $8wGln.getDefaultOptions)();
    var firstWeekContainsDate = (0, $kKOHX.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $jYhGL.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $jYhGL.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("fJf0R", function(module, exports) {

$parcel$export(module.exports, "default", () => $b736b43a8f9f876d$export$2e2bcd8739ae039);
function $b736b43a8f9f876d$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}

});

parcelRegister("3FCM8", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ac3476fb68092ee$export$2e2bcd8739ae039);

var $fJf0R = parcelRequire("fJf0R");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $2ac3476fb68092ee$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $fJf0R.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $fJf0R.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $fJf0R.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $fJf0R.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $fJf0R.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $fJf0R.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $fJf0R.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $fJf0R.default)(fractionalSeconds, token.length);
    }
};
var $2ac3476fb68092ee$export$2e2bcd8739ae039 = $2ac3476fb68092ee$var$formatters;

});


parcelRegister("csjg0", function(module, exports) {

$parcel$export(module.exports, "default", () => $9117099c465641e2$export$2e2bcd8739ae039);
var $9117099c465641e2$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $9117099c465641e2$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $9117099c465641e2$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $9117099c465641e2$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $9117099c465641e2$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $9117099c465641e2$var$timeLongFormatter(timePattern, formatLong));
};
var $9117099c465641e2$var$longFormatters = {
    p: $9117099c465641e2$var$timeLongFormatter,
    P: $9117099c465641e2$var$dateTimeLongFormatter
};
var $9117099c465641e2$export$2e2bcd8739ae039 = $9117099c465641e2$var$longFormatters;

});

parcelRegister("jChhX", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", () => $e47efa1dbd28bcfd$export$c6cc36aa33304772);
$parcel$export(module.exports, "isProtectedWeekYearToken", () => $e47efa1dbd28bcfd$export$c6b49d6dceb604a1);
$parcel$export(module.exports, "throwProtectedError", () => $e47efa1dbd28bcfd$export$8073c1ae88f0e727);
var $e47efa1dbd28bcfd$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $e47efa1dbd28bcfd$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $e47efa1dbd28bcfd$export$c6cc36aa33304772(token) {
    return $e47efa1dbd28bcfd$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $e47efa1dbd28bcfd$export$c6b49d6dceb604a1(token) {
    return $e47efa1dbd28bcfd$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $e47efa1dbd28bcfd$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("8927d", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ee0ce0a961cbbe7$export$2e2bcd8739ae039);

var $jgags = parcelRequire("jgags");
var $5ee0ce0a961cbbe7$export$2e2bcd8739ae039 = (0, $jgags.default);

});
parcelRegister("jgags", function(module, exports) {

$parcel$export(module.exports, "default", () => $e05779446950f999$export$2e2bcd8739ae039);

var $9HNQQ = parcelRequire("9HNQQ");

var $5rQs0 = parcelRequire("5rQs0");

var $h9XEd = parcelRequire("h9XEd");

var $kklX3 = parcelRequire("kklX3");

var $f2M1w = parcelRequire("f2M1w");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $e05779446950f999$var$locale = {
    code: 'en-US',
    formatDistance: (0, $9HNQQ.default),
    formatLong: (0, $5rQs0.default),
    formatRelative: (0, $h9XEd.default),
    localize: (0, $kklX3.default),
    match: (0, $f2M1w.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $e05779446950f999$export$2e2bcd8739ae039 = $e05779446950f999$var$locale;

});
parcelRegister("9HNQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $710ecca583f4c18e$export$2e2bcd8739ae039);
var $710ecca583f4c18e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $710ecca583f4c18e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $710ecca583f4c18e$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $710ecca583f4c18e$export$2e2bcd8739ae039 = $710ecca583f4c18e$var$formatDistance;

});

parcelRegister("5rQs0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f7828fbdcff0260$export$2e2bcd8739ae039);

var $gms4p = parcelRequire("gms4p");
var $3f7828fbdcff0260$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $3f7828fbdcff0260$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $3f7828fbdcff0260$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $3f7828fbdcff0260$var$formatLong = {
    date: (0, $gms4p.default)({
        formats: $3f7828fbdcff0260$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $gms4p.default)({
        formats: $3f7828fbdcff0260$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $gms4p.default)({
        formats: $3f7828fbdcff0260$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $3f7828fbdcff0260$export$2e2bcd8739ae039 = $3f7828fbdcff0260$var$formatLong;

});
parcelRegister("gms4p", function(module, exports) {

$parcel$export(module.exports, "default", () => $be9479922c8e4bfa$export$2e2bcd8739ae039);
function $be9479922c8e4bfa$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("h9XEd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7e18bb3f19119e1$export$2e2bcd8739ae039);
var $c7e18bb3f19119e1$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $c7e18bb3f19119e1$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $c7e18bb3f19119e1$var$formatRelativeLocale[token];
};
var $c7e18bb3f19119e1$export$2e2bcd8739ae039 = $c7e18bb3f19119e1$var$formatRelative;

});

parcelRegister("kklX3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecc6b403c0505e95$export$2e2bcd8739ae039);

var $4sM6r = parcelRequire("4sM6r");
var $ecc6b403c0505e95$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $ecc6b403c0505e95$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $ecc6b403c0505e95$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $ecc6b403c0505e95$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $ecc6b403c0505e95$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $ecc6b403c0505e95$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $ecc6b403c0505e95$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $ecc6b403c0505e95$var$localize = {
    ordinalNumber: $ecc6b403c0505e95$var$ordinalNumber,
    era: (0, $4sM6r.default)({
        values: $ecc6b403c0505e95$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $4sM6r.default)({
        values: $ecc6b403c0505e95$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $4sM6r.default)({
        values: $ecc6b403c0505e95$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $4sM6r.default)({
        values: $ecc6b403c0505e95$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $4sM6r.default)({
        values: $ecc6b403c0505e95$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $ecc6b403c0505e95$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $ecc6b403c0505e95$export$2e2bcd8739ae039 = $ecc6b403c0505e95$var$localize;

});
parcelRegister("4sM6r", function(module, exports) {

$parcel$export(module.exports, "default", () => $33ff17294e902818$export$2e2bcd8739ae039);
function $33ff17294e902818$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("f2M1w", function(module, exports) {

$parcel$export(module.exports, "default", () => $af3c4b63dafdc1bc$export$2e2bcd8739ae039);

var $lUMnK = parcelRequire("lUMnK");

var $e0hHr = parcelRequire("e0hHr");
var $af3c4b63dafdc1bc$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $af3c4b63dafdc1bc$var$parseOrdinalNumberPattern = /\d+/i;
var $af3c4b63dafdc1bc$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $af3c4b63dafdc1bc$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $af3c4b63dafdc1bc$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $af3c4b63dafdc1bc$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $af3c4b63dafdc1bc$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $af3c4b63dafdc1bc$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $af3c4b63dafdc1bc$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $af3c4b63dafdc1bc$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $af3c4b63dafdc1bc$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $af3c4b63dafdc1bc$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $af3c4b63dafdc1bc$var$match = {
    ordinalNumber: (0, $e0hHr.default)({
        matchPattern: $af3c4b63dafdc1bc$var$matchOrdinalNumberPattern,
        parsePattern: $af3c4b63dafdc1bc$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $lUMnK.default)({
        matchPatterns: $af3c4b63dafdc1bc$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $af3c4b63dafdc1bc$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $lUMnK.default)({
        matchPatterns: $af3c4b63dafdc1bc$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $af3c4b63dafdc1bc$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $lUMnK.default)({
        matchPatterns: $af3c4b63dafdc1bc$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $af3c4b63dafdc1bc$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $lUMnK.default)({
        matchPatterns: $af3c4b63dafdc1bc$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $af3c4b63dafdc1bc$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $lUMnK.default)({
        matchPatterns: $af3c4b63dafdc1bc$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $af3c4b63dafdc1bc$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $af3c4b63dafdc1bc$export$2e2bcd8739ae039 = $af3c4b63dafdc1bc$var$match;

});
parcelRegister("lUMnK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff445b934a8defa0$export$2e2bcd8739ae039);
function $ff445b934a8defa0$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $ff445b934a8defa0$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $ff445b934a8defa0$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $ff445b934a8defa0$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $ff445b934a8defa0$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("e0hHr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a31ecb931747cf1a$export$2e2bcd8739ae039);
function $a31ecb931747cf1a$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});





parcelRegister("1a5Mh", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d8b34f648b0578b$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $0d8b34f648b0578b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kl91g.default)(1, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}

});

parcelRegister("8vDaa", function(module, exports) {

$parcel$export(module.exports, "default", () => $631f98ed6ce2d5fe$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $631f98ed6ce2d5fe$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kl91g.default)(1, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    var day = date.getDay();
    return day;
}

});

parcelRegister("dmv68", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ba573d10e4f4ccd$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $9ba573d10e4f4ccd$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kl91g.default)(1, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

});

parcelRegister("hmByX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca41a0ead72227df$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $ca41a0ead72227df$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kl91g.default)(1, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    var hours = date.getHours();
    return hours;
}

});

parcelRegister("8O1FX", function(module, exports) {

$parcel$export(module.exports, "default", () => $66944b0797699cb0$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $66944b0797699cb0$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kl91g.default)(1, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    var minutes = date.getMinutes();
    return minutes;
}

});

parcelRegister("82bgg", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d973ee7f4678849$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $5d973ee7f4678849$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kl91g.default)(1, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    var month = date.getMonth();
    return month;
}

});

parcelRegister("5BiC3", function(module, exports) {

$parcel$export(module.exports, "default", () => $413ed892ed897c97$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $413ed892ed897c97$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kl91g.default)(1, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
}

});

parcelRegister("cUcTA", function(module, exports) {

$parcel$export(module.exports, "default", () => $9654b7cd5f2364a6$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $9654b7cd5f2364a6$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kl91g.default)(1, arguments);
    return (0, $jwXww.default)(dirtyDate).getFullYear();
}

});

parcelRegister("28JjW", function(module, exports) {

$parcel$export(module.exports, "default", () => $18ef7bd7f831d914$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $18ef7bd7f831d914$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $kl91g.default)(2, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    var dateToCompare = (0, $jwXww.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("keAdO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebb13656d3bc0d28$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $ebb13656d3bc0d28$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $kl91g.default)(2, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    var dateToCompare = (0, $jwXww.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("hTj25", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0665630867bb4d4$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $d0665630867bb4d4$export$2e2bcd8739ae039(dirtyLeftDate, dirtyRightDate) {
    (0, $kl91g.default)(2, arguments);
    var dateLeft = (0, $jwXww.default)(dirtyLeftDate);
    var dateRight = (0, $jwXww.default)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}

});

parcelRegister("eZFiw", function(module, exports) {

$parcel$export(module.exports, "default", () => $aea6cc0be194f3b9$export$2e2bcd8739ae039);

var $lGTzH = parcelRequire("lGTzH");

var $kl91g = parcelRequire("kl91g");
function $aea6cc0be194f3b9$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $kl91g.default)(2, arguments);
    var dateLeftStartOfDay = (0, $lGTzH.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $lGTzH.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

});

parcelRegister("13RWS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c5feb578912fdc6$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $0c5feb578912fdc6$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $kl91g.default)(2, arguments);
    var dateLeft = (0, $jwXww.default)(dirtyDateLeft);
    var dateRight = (0, $jwXww.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}

});

parcelRegister("4zJRF", function(module, exports) {

$parcel$export(module.exports, "default", () => $354e020d7ba52824$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $354e020d7ba52824$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $kl91g.default)(2, arguments);
    var dateLeft = (0, $jwXww.default)(dirtyDateLeft);
    var dateRight = (0, $jwXww.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

});

parcelRegister("9FFvK", function(module, exports) {

$parcel$export(module.exports, "default", () => $70a824a2860300ec$export$2e2bcd8739ae039);

var $gNjN3 = parcelRequire("gNjN3");

var $kl91g = parcelRequire("kl91g");
function $70a824a2860300ec$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $kl91g.default)(2, arguments);
    var dateLeftStartOfHour = (0, $gNjN3.default)(dirtyDateLeft);
    var dateRightStartOfHour = (0, $gNjN3.default)(dirtyDateRight);
    return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
}

});
parcelRegister("gNjN3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3a092e1bf522aad$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $c3a092e1bf522aad$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kl91g.default)(1, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    date.setMinutes(0, 0, 0);
    return date;
}

});


parcelRegister("kPWgP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2b5c55f40084f47$export$2e2bcd8739ae039);

var $THUM4 = parcelRequire("THUM4");

var $407dk = parcelRequire("407dk");

var $8927d = parcelRequire("8927d");

var $bZbxy = parcelRequire("bZbxy");

var $jwXww = parcelRequire("jwXww");

var $i8qr4 = parcelRequire("i8qr4");

var $csjg0 = parcelRequire("csjg0");

var $5Bj0e = parcelRequire("5Bj0e");

var $jChhX = parcelRequire("jChhX");

var $kKOHX = parcelRequire("kKOHX");

var $kl91g = parcelRequire("kl91g");

var $b3Cbe = parcelRequire("b3Cbe");

var $hzmLn = parcelRequire("hzmLn");

var $8wGln = parcelRequire("8wGln");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $f2b5c55f40084f47$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $f2b5c55f40084f47$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $f2b5c55f40084f47$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $f2b5c55f40084f47$var$doubleQuoteRegExp = /''/g;
var $f2b5c55f40084f47$var$notWhitespaceRegExp = /\S/;
var $f2b5c55f40084f47$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $f2b5c55f40084f47$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $kl91g.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $8wGln.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $8927d.default);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $kKOHX.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $kKOHX.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $jwXww.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $b3Cbe.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match($f2b5c55f40084f47$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $csjg0.default)) {
            var longFormatter = (0, $csjg0.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($f2b5c55f40084f47$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $407dk.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $jChhX.isProtectedWeekYearToken)(token)) (0, $jChhX.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $jChhX.isProtectedDayOfYearToken)(token)) (0, $jChhX.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $hzmLn.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($f2b5c55f40084f47$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $f2b5c55f40084f47$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $THUM4.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $f2b5c55f40084f47$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $jwXww.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $bZbxy.default)(date, (0, $5Bj0e.default)(date));
    var flags = {};
    var _iterator2 = (0, $407dk.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $i8qr4.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $f2b5c55f40084f47$var$cleanEscapedString(input) {
    return input.match($f2b5c55f40084f47$var$escapedStringRegExp)[1].replace($f2b5c55f40084f47$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("407dk", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e9cc20fe631f89b$export$2e2bcd8739ae039);

var $ez5Ll = parcelRequire("ez5Ll");
function $2e9cc20fe631f89b$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $ez5Ll.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}

});
parcelRegister("ez5Ll", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9a8cde4ebbe33c2$export$2e2bcd8739ae039);

var $gN0I3 = parcelRequire("gN0I3");
function $a9a8cde4ebbe33c2$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $gN0I3.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $gN0I3.default)(r, a) : void 0;
    }
}

});
parcelRegister("gN0I3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c391c5d90be6c199$export$2e2bcd8739ae039);
function $c391c5d90be6c199$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});



parcelRegister("i8qr4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d33d7aeedb94c424$export$2e2bcd8739ae039);
function $d33d7aeedb94c424$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});

parcelRegister("b3Cbe", function(module, exports) {

$parcel$export(module.exports, "ValueSetter", () => $80cd97509a967654$export$9a09e32dd4990fd5);
$parcel$export(module.exports, "DateToSystemTimezoneSetter", () => $80cd97509a967654$export$5aaf7ff7f09ea4ee);

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $ecU2x = parcelRequire("ecU2x");
var $80cd97509a967654$var$TIMEZONE_UNIT_PRIORITY = 10;
var $80cd97509a967654$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $fsi6a.default)(this, Setter);
        (0, $ecU2x.default)(this, "priority", void 0);
        (0, $ecU2x.default)(this, "subPriority", 0);
    }
    (0, $1Kal7.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $80cd97509a967654$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $3s1Q9.default)(ValueSetter, _Setter);
    var _super = (0, $dWNJz.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $fsi6a.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $1Kal7.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($80cd97509a967654$export$81d53e3678089a6);
var $80cd97509a967654$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $3s1Q9.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $dWNJz.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $fsi6a.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this2), "priority", $80cd97509a967654$var$TIMEZONE_UNIT_PRIORITY);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $1Kal7.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($80cd97509a967654$export$81d53e3678089a6);

});
parcelRegister("3s1Q9", function(module, exports) {

$parcel$export(module.exports, "default", () => $28356a0ee6f60882$export$2e2bcd8739ae039);

var $kafOy = parcelRequire("kafOy");
function $28356a0ee6f60882$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $kafOy.default)(t, e);
}

});

parcelRegister("dWNJz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a277454a6894bd71$export$2e2bcd8739ae039);

var $knfpu = parcelRequire("knfpu");

var $lLVso = parcelRequire("lLVso");

var $8YjvV = parcelRequire("8YjvV");
function $a277454a6894bd71$export$2e2bcd8739ae039(t) {
    var r = (0, $lLVso.default)();
    return function() {
        var e, o = (0, $knfpu.default)(t);
        if (r) {
            var s = (0, $knfpu.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $8YjvV.default)(this, e);
    };
}

});
parcelRegister("knfpu", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed51e8c8fbbadc36$export$2e2bcd8739ae039);
function $ed51e8c8fbbadc36$export$2e2bcd8739ae039(t) {
    return $ed51e8c8fbbadc36$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $ed51e8c8fbbadc36$export$2e2bcd8739ae039(t);
}

});

parcelRegister("lLVso", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd9a8e804720c2b7$export$2e2bcd8739ae039);
function $fd9a8e804720c2b7$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($fd9a8e804720c2b7$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("8YjvV", function(module, exports) {

$parcel$export(module.exports, "default", () => $6883105f40df7376$export$2e2bcd8739ae039);

var $THUM4 = parcelRequire("THUM4");

var $lVo1d = parcelRequire("lVo1d");
function $6883105f40df7376$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $THUM4.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $lVo1d.default)(t);
}

});


parcelRegister("fsi6a", function(module, exports) {

$parcel$export(module.exports, "default", () => $b407828583279cd8$export$2e2bcd8739ae039);
function $b407828583279cd8$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("1Kal7", function(module, exports) {

$parcel$export(module.exports, "default", () => $14521b8c072a81d1$export$2e2bcd8739ae039);

var $gEB38 = parcelRequire("gEB38");
function $14521b8c072a81d1$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $gEB38.default)(o.key), o);
    }
}
function $14521b8c072a81d1$export$2e2bcd8739ae039(e, r, t) {
    return r && $14521b8c072a81d1$var$_defineProperties(e.prototype, r), t && $14521b8c072a81d1$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("gEB38", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1fd1f0e2195353d$export$2e2bcd8739ae039);

var $THUM4 = parcelRequire("THUM4");

var $3nbCF = parcelRequire("3nbCF");
function $c1fd1f0e2195353d$export$2e2bcd8739ae039(t) {
    var i = (0, $3nbCF.default)(t, "string");
    return "symbol" == (0, $THUM4.default)(i) ? i : i + "";
}

});
parcelRegister("3nbCF", function(module, exports) {

$parcel$export(module.exports, "default", () => $274c891e0c4ec675$export$2e2bcd8739ae039);

var $THUM4 = parcelRequire("THUM4");
function $274c891e0c4ec675$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $THUM4.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $THUM4.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("ecU2x", function(module, exports) {

$parcel$export(module.exports, "default", () => $a57da8081f11bdf9$export$2e2bcd8739ae039);

var $gEB38 = parcelRequire("gEB38");
function $a57da8081f11bdf9$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $gEB38.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});


parcelRegister("hzmLn", function(module, exports) {

$parcel$export(module.exports, "parsers", () => $cca75cdb8db4dea2$export$19131010e7fd8373);

var $9xAID = parcelRequire("9xAID");

var $hkVYC = parcelRequire("hkVYC");

var $e9BvS = parcelRequire("e9BvS");

var $iizsP = parcelRequire("iizsP");

var $4h6ak = parcelRequire("4h6ak");

var $gqEOg = parcelRequire("gqEOg");

var $2qpL4 = parcelRequire("2qpL4");

var $lxYas = parcelRequire("lxYas");

var $aSt5G = parcelRequire("aSt5G");

var $6s8er = parcelRequire("6s8er");

var $cHZIq = parcelRequire("cHZIq");

var $kjEOz = parcelRequire("kjEOz");

var $57Jwl = parcelRequire("57Jwl");

var $68EXM = parcelRequire("68EXM");

var $6mzDT = parcelRequire("6mzDT");

var $ahCXQ = parcelRequire("ahCXQ");

var $8l9kt = parcelRequire("8l9kt");

var $5mEzj = parcelRequire("5mEzj");

var $6o0kb = parcelRequire("6o0kb");

var $bumgg = parcelRequire("bumgg");

var $biNZt = parcelRequire("biNZt");

var $juZ6m = parcelRequire("juZ6m");

var $iIXlE = parcelRequire("iIXlE");

var $d0Bub = parcelRequire("d0Bub");

var $jrzdV = parcelRequire("jrzdV");

var $2MiCa = parcelRequire("2MiCa");

var $dcwtE = parcelRequire("dcwtE");

var $dJl0U = parcelRequire("dJl0U");

var $bvpQA = parcelRequire("bvpQA");

var $l0xdL = parcelRequire("l0xdL");

var $9atxF = parcelRequire("9atxF");
var $cca75cdb8db4dea2$export$19131010e7fd8373 = {
    G: new (0, $9xAID.EraParser)(),
    y: new (0, $hkVYC.YearParser)(),
    Y: new (0, $e9BvS.LocalWeekYearParser)(),
    R: new (0, $iizsP.ISOWeekYearParser)(),
    u: new (0, $4h6ak.ExtendedYearParser)(),
    Q: new (0, $gqEOg.QuarterParser)(),
    q: new (0, $2qpL4.StandAloneQuarterParser)(),
    M: new (0, $lxYas.MonthParser)(),
    L: new (0, $aSt5G.StandAloneMonthParser)(),
    w: new (0, $6s8er.LocalWeekParser)(),
    I: new (0, $cHZIq.ISOWeekParser)(),
    d: new (0, $kjEOz.DateParser)(),
    D: new (0, $57Jwl.DayOfYearParser)(),
    E: new (0, $68EXM.DayParser)(),
    e: new (0, $6mzDT.LocalDayParser)(),
    c: new (0, $ahCXQ.StandAloneLocalDayParser)(),
    i: new (0, $8l9kt.ISODayParser)(),
    a: new (0, $5mEzj.AMPMParser)(),
    b: new (0, $6o0kb.AMPMMidnightParser)(),
    B: new (0, $bumgg.DayPeriodParser)(),
    h: new (0, $biNZt.Hour1to12Parser)(),
    H: new (0, $juZ6m.Hour0to23Parser)(),
    K: new (0, $iIXlE.Hour0To11Parser)(),
    k: new (0, $d0Bub.Hour1To24Parser)(),
    m: new (0, $jrzdV.MinuteParser)(),
    s: new (0, $2MiCa.SecondParser)(),
    S: new (0, $dcwtE.FractionOfSecondParser)(),
    X: new (0, $dJl0U.ISOTimezoneWithZParser)(),
    x: new (0, $bvpQA.ISOTimezoneParser)(),
    t: new (0, $l0xdL.TimestampSecondsParser)(),
    T: new (0, $9atxF.TimestampMillisecondsParser)()
};

});
parcelRegister("9xAID", function(module, exports) {

$parcel$export(module.exports, "EraParser", () => $6f23adbaba2fadd6$export$8e5a1d3f85a9688);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");
var $6f23adbaba2fadd6$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(EraParser, _Parser);
    var _super = (0, $dWNJz.default)(EraParser);
    function EraParser() {
        var _this;
        (0, $fsi6a.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 140);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $ecHQG.Parser));

});
parcelRegister("ecHQG", function(module, exports) {

$parcel$export(module.exports, "Parser", () => $a574331f2a42db69$export$7acfa6ed01010e37);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $ecU2x = parcelRequire("ecU2x");

var $b3Cbe = parcelRequire("b3Cbe");
var $a574331f2a42db69$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $fsi6a.default)(this, Parser);
        (0, $ecU2x.default)(this, "incompatibleTokens", void 0);
        (0, $ecU2x.default)(this, "priority", void 0);
        (0, $ecU2x.default)(this, "subPriority", void 0);
    }
    (0, $1Kal7.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $b3Cbe.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

});


parcelRegister("hkVYC", function(module, exports) {

$parcel$export(module.exports, "YearParser", () => $c9f146e7337c0ff2$export$48d352de7cd4a988);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $1q4p8 = parcelRequire("1q4p8");
var $c9f146e7337c0ff2$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(YearParser, _Parser);
    var _super = (0, $dWNJz.default)(YearParser);
    function YearParser() {
        var _this;
        (0, $fsi6a.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 130);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $1q4p8.mapValue)((0, $1q4p8.parseNDigits)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $1q4p8.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $1q4p8.mapValue)((0, $1q4p8.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $1q4p8.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $ecHQG.Parser));

});
parcelRegister("1q4p8", function(module, exports) {

$parcel$export(module.exports, "mapValue", () => $108ba2c15aaa4964$export$4f84e3a82c7b538);
$parcel$export(module.exports, "parseNumericPattern", () => $108ba2c15aaa4964$export$cc7cc9e2a3ff9388);
$parcel$export(module.exports, "parseTimezonePattern", () => $108ba2c15aaa4964$export$6497f4c0ecdfba8e);
$parcel$export(module.exports, "parseAnyDigitsSigned", () => $108ba2c15aaa4964$export$d931c43c4608a164);
$parcel$export(module.exports, "parseNDigits", () => $108ba2c15aaa4964$export$513bb01536146ab6);
$parcel$export(module.exports, "parseNDigitsSigned", () => $108ba2c15aaa4964$export$2c9307b2e29c533c);
$parcel$export(module.exports, "dayPeriodEnumToHours", () => $108ba2c15aaa4964$export$fb506d2676e7f207);
$parcel$export(module.exports, "normalizeTwoDigitYear", () => $108ba2c15aaa4964$export$29126f735cbf69f7);
$parcel$export(module.exports, "isLeapYearIndex", () => $108ba2c15aaa4964$export$3d50627710b84d75);

var $HfRMJ = parcelRequire("HfRMJ");

var $fwkrO = parcelRequire("fwkrO");
function $108ba2c15aaa4964$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $108ba2c15aaa4964$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $108ba2c15aaa4964$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $HfRMJ.millisecondsInHour) + minutes * (0, $HfRMJ.millisecondsInMinute) + seconds * (0, $HfRMJ.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $108ba2c15aaa4964$export$d931c43c4608a164(dateString) {
    return $108ba2c15aaa4964$export$cc7cc9e2a3ff9388((0, $fwkrO.numericPatterns).anyDigitsSigned, dateString);
}
function $108ba2c15aaa4964$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $108ba2c15aaa4964$export$cc7cc9e2a3ff9388((0, $fwkrO.numericPatterns).singleDigit, dateString);
        case 2:
            return $108ba2c15aaa4964$export$cc7cc9e2a3ff9388((0, $fwkrO.numericPatterns).twoDigits, dateString);
        case 3:
            return $108ba2c15aaa4964$export$cc7cc9e2a3ff9388((0, $fwkrO.numericPatterns).threeDigits, dateString);
        case 4:
            return $108ba2c15aaa4964$export$cc7cc9e2a3ff9388((0, $fwkrO.numericPatterns).fourDigits, dateString);
        default:
            return $108ba2c15aaa4964$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $108ba2c15aaa4964$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $108ba2c15aaa4964$export$cc7cc9e2a3ff9388((0, $fwkrO.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return $108ba2c15aaa4964$export$cc7cc9e2a3ff9388((0, $fwkrO.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return $108ba2c15aaa4964$export$cc7cc9e2a3ff9388((0, $fwkrO.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return $108ba2c15aaa4964$export$cc7cc9e2a3ff9388((0, $fwkrO.numericPatterns).fourDigitsSigned, dateString);
        default:
            return $108ba2c15aaa4964$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $108ba2c15aaa4964$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $108ba2c15aaa4964$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $108ba2c15aaa4964$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("fwkrO", function(module, exports) {

$parcel$export(module.exports, "numericPatterns", () => $b4c9b4a77f7dddeb$export$c123ee06d9da8480);
$parcel$export(module.exports, "timezonePatterns", () => $b4c9b4a77f7dddeb$export$a7ee192b982af9c1);
var $b4c9b4a77f7dddeb$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $b4c9b4a77f7dddeb$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("e9BvS", function(module, exports) {

$parcel$export(module.exports, "LocalWeekYearParser", () => $a4df014238d3220a$export$b8ef38dfcf05d5db);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $1q4p8 = parcelRequire("1q4p8");

var $hvmv7 = parcelRequire("hvmv7");

var $jYhGL = parcelRequire("jYhGL");
var $a4df014238d3220a$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(LocalWeekYearParser, _Parser);
    var _super = (0, $dWNJz.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $fsi6a.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 130);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $1q4p8.mapValue)((0, $1q4p8.parseNDigits)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $1q4p8.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $1q4p8.mapValue)((0, $1q4p8.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $hvmv7.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $1q4p8.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $jYhGL.default)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $jYhGL.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $ecHQG.Parser));

});

parcelRegister("iizsP", function(module, exports) {

$parcel$export(module.exports, "ISOWeekYearParser", () => $d5256ad1b6268fdf$export$951d1df011fde06f);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $1q4p8 = parcelRequire("1q4p8");

var $5sReG = parcelRequire("5sReG");
var $d5256ad1b6268fdf$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(ISOWeekYearParser, _Parser);
    var _super = (0, $dWNJz.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $fsi6a.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 130);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $1q4p8.parseNDigitsSigned)(4, dateString);
                return (0, $1q4p8.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $5sReG.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $ecHQG.Parser));

});

parcelRegister("4h6ak", function(module, exports) {

$parcel$export(module.exports, "ExtendedYearParser", () => $31cd88519a2f462b$export$bad9d2ea38e8f1a);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $1q4p8 = parcelRequire("1q4p8");
var $31cd88519a2f462b$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(ExtendedYearParser, _Parser);
    var _super = (0, $dWNJz.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $fsi6a.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 130);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $1q4p8.parseNDigitsSigned)(4, dateString);
                return (0, $1q4p8.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $ecHQG.Parser));

});

parcelRegister("gqEOg", function(module, exports) {

$parcel$export(module.exports, "QuarterParser", () => $bf5ebb07859031ec$export$5cb0f701186dde1d);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $1q4p8 = parcelRequire("1q4p8");
var $bf5ebb07859031ec$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(QuarterParser, _Parser);
    var _super = (0, $dWNJz.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $fsi6a.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 120);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $1q4p8.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $ecHQG.Parser));

});

parcelRegister("2qpL4", function(module, exports) {

$parcel$export(module.exports, "StandAloneQuarterParser", () => $1c41fd873655bc52$export$300c0c2990e20e6d);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $1q4p8 = parcelRequire("1q4p8");
var $1c41fd873655bc52$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, $dWNJz.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $fsi6a.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 120);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $1q4p8.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $ecHQG.Parser));

});

parcelRegister("lxYas", function(module, exports) {

$parcel$export(module.exports, "MonthParser", () => $fafb5a14f2b13977$export$400dd8b40ef138a3);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $1q4p8 = parcelRequire("1q4p8");

var $ecHQG = parcelRequire("ecHQG");

var $fwkrO = parcelRequire("fwkrO");
var $fafb5a14f2b13977$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(MonthParser, _Parser);
    var _super = (0, $dWNJz.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $fsi6a.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 110);
        return _this;
    }
    (0, $1Kal7.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $1q4p8.mapValue)((0, $1q4p8.parseNumericPattern)((0, $fwkrO.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $1q4p8.mapValue)((0, $1q4p8.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $1q4p8.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $ecHQG.Parser));

});

parcelRegister("aSt5G", function(module, exports) {

$parcel$export(module.exports, "StandAloneMonthParser", () => $7eb5834f6476414a$export$1d7eaa53eaa5deba);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $fwkrO = parcelRequire("fwkrO");

var $1q4p8 = parcelRequire("1q4p8");
var $7eb5834f6476414a$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(StandAloneMonthParser, _Parser);
    var _super = (0, $dWNJz.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $fsi6a.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 110);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $1q4p8.mapValue)((0, $1q4p8.parseNumericPattern)((0, $fwkrO.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $1q4p8.mapValue)((0, $1q4p8.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $1q4p8.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $ecHQG.Parser));

});

parcelRegister("6s8er", function(module, exports) {

$parcel$export(module.exports, "LocalWeekParser", () => $4b2bbe452ed49c6d$export$c4005ffc174e07c0);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $fwkrO = parcelRequire("fwkrO");

var $1q4p8 = parcelRequire("1q4p8");

var $enrji = parcelRequire("enrji");

var $jYhGL = parcelRequire("jYhGL");
var $4b2bbe452ed49c6d$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(LocalWeekParser, _Parser);
    var _super = (0, $dWNJz.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $fsi6a.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 100);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $1q4p8.parseNumericPattern)((0, $fwkrO.numericPatterns).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $1q4p8.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $jYhGL.default)((0, $enrji.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $ecHQG.Parser));

});
parcelRegister("enrji", function(module, exports) {

$parcel$export(module.exports, "default", () => $a77865ea5752df74$export$2e2bcd8739ae039);

var $kKOHX = parcelRequire("kKOHX");

var $jwXww = parcelRequire("jwXww");

var $2E1z6 = parcelRequire("2E1z6");

var $kl91g = parcelRequire("kl91g");
function $a77865ea5752df74$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $kl91g.default)(2, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    var week = (0, $kKOHX.default)(dirtyWeek);
    var diff = (0, $2E1z6.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("cHZIq", function(module, exports) {

$parcel$export(module.exports, "ISOWeekParser", () => $94095f9def2bf8d7$export$6fc8dbedd560a6af);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $fwkrO = parcelRequire("fwkrO");

var $1q4p8 = parcelRequire("1q4p8");

var $eoTBL = parcelRequire("eoTBL");

var $5sReG = parcelRequire("5sReG");
var $94095f9def2bf8d7$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(ISOWeekParser, _Parser);
    var _super = (0, $dWNJz.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $fsi6a.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 100);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $1q4p8.parseNumericPattern)((0, $fwkrO.numericPatterns).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $1q4p8.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $5sReG.default)((0, $eoTBL.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $ecHQG.Parser));

});
parcelRegister("eoTBL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7be712d68e342f2$export$2e2bcd8739ae039);

var $kKOHX = parcelRequire("kKOHX");

var $jwXww = parcelRequire("jwXww");

var $eHL5u = parcelRequire("eHL5u");

var $kl91g = parcelRequire("kl91g");
function $a7be712d68e342f2$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $kl91g.default)(2, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    var isoWeek = (0, $kKOHX.default)(dirtyISOWeek);
    var diff = (0, $eHL5u.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("kjEOz", function(module, exports) {

$parcel$export(module.exports, "DateParser", () => $eca53df07babfde5$export$e8d4b28a20981dd2);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $1q4p8 = parcelRequire("1q4p8");

var $ecHQG = parcelRequire("ecHQG");

var $fwkrO = parcelRequire("fwkrO");
var $eca53df07babfde5$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $eca53df07babfde5$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $eca53df07babfde5$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(DateParser, _Parser);
    var _super = (0, $dWNJz.default)(DateParser);
    function DateParser() {
        var _this;
        (0, $fsi6a.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 90);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "subPriority", 1);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $1q4p8.parseNumericPattern)((0, $fwkrO.numericPatterns).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $1q4p8.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $1q4p8.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $eca53df07babfde5$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $eca53df07babfde5$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $ecHQG.Parser));

});

parcelRegister("57Jwl", function(module, exports) {

$parcel$export(module.exports, "DayOfYearParser", () => $3bb0eaae2bb9a9be$export$6cfe0d613455f615);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $fwkrO = parcelRequire("fwkrO");

var $1q4p8 = parcelRequire("1q4p8");
var $3bb0eaae2bb9a9be$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(DayOfYearParser, _Parser);
    var _super = (0, $dWNJz.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $fsi6a.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 90);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "subpriority", 1);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $1q4p8.parseNumericPattern)((0, $fwkrO.numericPatterns).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $1q4p8.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $1q4p8.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $ecHQG.Parser));

});

parcelRegister("68EXM", function(module, exports) {

$parcel$export(module.exports, "DayParser", () => $478343db337c5cbe$export$1b03c8b76262f7bd);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $abDYX = parcelRequire("abDYX");
var $478343db337c5cbe$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(DayParser, _Parser);
    var _super = (0, $dWNJz.default)(DayParser);
    function DayParser() {
        var _this;
        (0, $fsi6a.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 90);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $abDYX.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $ecHQG.Parser));

});
parcelRegister("abDYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $76a9f21a9edbdaea$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");

var $kKOHX = parcelRequire("kKOHX");

var $8wGln = parcelRequire("8wGln");
function $76a9f21a9edbdaea$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $kl91g.default)(2, arguments);
    var defaultOptions = (0, $8wGln.getDefaultOptions)();
    var weekStartsOn = (0, $kKOHX.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $jwXww.default)(dirtyDate);
    var day = (0, $kKOHX.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("6mzDT", function(module, exports) {

$parcel$export(module.exports, "LocalDayParser", () => $4a2071f8f1d2c962$export$44d1c127ab42c480);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $1q4p8 = parcelRequire("1q4p8");

var $abDYX = parcelRequire("abDYX");
var $4a2071f8f1d2c962$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(LocalDayParser, _Parser);
    var _super = (0, $dWNJz.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $fsi6a.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 90);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $1q4p8.mapValue)((0, $1q4p8.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $1q4p8.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $abDYX.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $ecHQG.Parser));

});

parcelRegister("ahCXQ", function(module, exports) {

$parcel$export(module.exports, "StandAloneLocalDayParser", () => $77c9b7608de58d3f$export$e447a647caaaec1d);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $1q4p8 = parcelRequire("1q4p8");

var $abDYX = parcelRequire("abDYX");
var $77c9b7608de58d3f$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $dWNJz.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $fsi6a.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 90);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $1q4p8.mapValue)((0, $1q4p8.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $1q4p8.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $abDYX.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $ecHQG.Parser));

});

parcelRegister("8l9kt", function(module, exports) {

$parcel$export(module.exports, "ISODayParser", () => $61278576c5aa906d$export$693fb1e525095b2a);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $1q4p8 = parcelRequire("1q4p8");

var $lLplX = parcelRequire("lLplX");
var $61278576c5aa906d$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(ISODayParser, _Parser);
    var _super = (0, $dWNJz.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $fsi6a.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 90);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $1q4p8.parseNDigits)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $1q4p8.mapValue)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $1q4p8.mapValue)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $1q4p8.mapValue)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $1q4p8.mapValue)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $lLplX.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $ecHQG.Parser));

});
parcelRegister("lLplX", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd81a75aa0669fc9$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");

var $kKOHX = parcelRequire("kKOHX");
function $fd81a75aa0669fc9$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $kl91g.default)(2, arguments);
    var day = (0, $kKOHX.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $jwXww.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("5mEzj", function(module, exports) {

$parcel$export(module.exports, "AMPMParser", () => $3e7e79e8194ea6fa$export$8d1e08492351df91);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $1q4p8 = parcelRequire("1q4p8");
var $3e7e79e8194ea6fa$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(AMPMParser, _Parser);
    var _super = (0, $dWNJz.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $fsi6a.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 80);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $1q4p8.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $ecHQG.Parser));

});

parcelRegister("6o0kb", function(module, exports) {

$parcel$export(module.exports, "AMPMMidnightParser", () => $4a653c63834408ef$export$73ca2bd0a17d273);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $1q4p8 = parcelRequire("1q4p8");
var $4a653c63834408ef$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(AMPMMidnightParser, _Parser);
    var _super = (0, $dWNJz.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $fsi6a.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 80);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $1q4p8.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $ecHQG.Parser));

});

parcelRegister("bumgg", function(module, exports) {

$parcel$export(module.exports, "DayPeriodParser", () => $85d3c3ad821d1f4a$export$bb9212adf05373db);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $1q4p8 = parcelRequire("1q4p8");
var $85d3c3ad821d1f4a$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(DayPeriodParser, _Parser);
    var _super = (0, $dWNJz.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $fsi6a.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 80);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $1q4p8.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $ecHQG.Parser));

});

parcelRegister("biNZt", function(module, exports) {

$parcel$export(module.exports, "Hour1to12Parser", () => $83a82733dcdd60ba$export$8a04050a727a1756);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $fwkrO = parcelRequire("fwkrO");

var $1q4p8 = parcelRequire("1q4p8");
var $83a82733dcdd60ba$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(Hour1to12Parser, _Parser);
    var _super = (0, $dWNJz.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $fsi6a.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 70);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $1q4p8.parseNumericPattern)((0, $fwkrO.numericPatterns).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $1q4p8.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $ecHQG.Parser));

});

parcelRegister("juZ6m", function(module, exports) {

$parcel$export(module.exports, "Hour0to23Parser", () => $e3203726e01384d5$export$e56f4dea2c3e56dd);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $fwkrO = parcelRequire("fwkrO");

var $1q4p8 = parcelRequire("1q4p8");
var $e3203726e01384d5$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(Hour0to23Parser, _Parser);
    var _super = (0, $dWNJz.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $fsi6a.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 70);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $1q4p8.parseNumericPattern)((0, $fwkrO.numericPatterns).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $1q4p8.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $ecHQG.Parser));

});

parcelRegister("iIXlE", function(module, exports) {

$parcel$export(module.exports, "Hour0To11Parser", () => $da1a5f626013c749$export$cbbe855312f87d77);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $fwkrO = parcelRequire("fwkrO");

var $1q4p8 = parcelRequire("1q4p8");
var $da1a5f626013c749$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(Hour0To11Parser, _Parser);
    var _super = (0, $dWNJz.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $fsi6a.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 70);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $1q4p8.parseNumericPattern)((0, $fwkrO.numericPatterns).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $1q4p8.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $ecHQG.Parser));

});

parcelRegister("d0Bub", function(module, exports) {

$parcel$export(module.exports, "Hour1To24Parser", () => $97885a541a0013ef$export$6008046d2b34b6a5);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $fwkrO = parcelRequire("fwkrO");

var $1q4p8 = parcelRequire("1q4p8");
var $97885a541a0013ef$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(Hour1To24Parser, _Parser);
    var _super = (0, $dWNJz.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $fsi6a.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 70);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $1q4p8.parseNumericPattern)((0, $fwkrO.numericPatterns).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $1q4p8.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $ecHQG.Parser));

});

parcelRegister("jrzdV", function(module, exports) {

$parcel$export(module.exports, "MinuteParser", () => $e27bdc9680e58633$export$2b52670d9e2be53);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $fwkrO = parcelRequire("fwkrO");

var $1q4p8 = parcelRequire("1q4p8");
var $e27bdc9680e58633$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(MinuteParser, _Parser);
    var _super = (0, $dWNJz.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $fsi6a.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 60);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $1q4p8.parseNumericPattern)((0, $fwkrO.numericPatterns).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $1q4p8.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $ecHQG.Parser));

});

parcelRegister("2MiCa", function(module, exports) {

$parcel$export(module.exports, "SecondParser", () => $205e80f48fd04747$export$94d46d540cf1366a);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $fwkrO = parcelRequire("fwkrO");

var $1q4p8 = parcelRequire("1q4p8");
var $205e80f48fd04747$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(SecondParser, _Parser);
    var _super = (0, $dWNJz.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $fsi6a.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 50);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $1q4p8.parseNumericPattern)((0, $fwkrO.numericPatterns).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $1q4p8.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $ecHQG.Parser));

});

parcelRegister("dcwtE", function(module, exports) {

$parcel$export(module.exports, "FractionOfSecondParser", () => $99c596acd73e0264$export$b8e6f8b2d70893b1);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $1q4p8 = parcelRequire("1q4p8");
var $99c596acd73e0264$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(FractionOfSecondParser, _Parser);
    var _super = (0, $dWNJz.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $fsi6a.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 30);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $1q4p8.mapValue)((0, $1q4p8.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $ecHQG.Parser));

});

parcelRegister("dJl0U", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneWithZParser", () => $9fefc735f4743b9e$export$104d901d49fea29b);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $fwkrO = parcelRequire("fwkrO");

var $1q4p8 = parcelRequire("1q4p8");
var $9fefc735f4743b9e$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $dWNJz.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $fsi6a.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 10);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $1q4p8.parseTimezonePattern)((0, $fwkrO.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $1q4p8.parseTimezonePattern)((0, $fwkrO.timezonePatterns).basic, dateString);
                    case 'XXXX':
                        return (0, $1q4p8.parseTimezonePattern)((0, $fwkrO.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $1q4p8.parseTimezonePattern)((0, $fwkrO.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $1q4p8.parseTimezonePattern)((0, $fwkrO.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $ecHQG.Parser));

});

parcelRegister("bvpQA", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneParser", () => $8606a3aeb564740f$export$12910e5204b52b9);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $fwkrO = parcelRequire("fwkrO");

var $1q4p8 = parcelRequire("1q4p8");
var $8606a3aeb564740f$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(ISOTimezoneParser, _Parser);
    var _super = (0, $dWNJz.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $fsi6a.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 10);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, $1Kal7.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $1q4p8.parseTimezonePattern)((0, $fwkrO.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $1q4p8.parseTimezonePattern)((0, $fwkrO.timezonePatterns).basic, dateString);
                    case 'xxxx':
                        return (0, $1q4p8.parseTimezonePattern)((0, $fwkrO.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $1q4p8.parseTimezonePattern)((0, $fwkrO.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $1q4p8.parseTimezonePattern)((0, $fwkrO.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $ecHQG.Parser));

});

parcelRegister("l0xdL", function(module, exports) {

$parcel$export(module.exports, "TimestampSecondsParser", () => $f4b35e10481fa625$export$2cd8bf877a05e96);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $1q4p8 = parcelRequire("1q4p8");
var $f4b35e10481fa625$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(TimestampSecondsParser, _Parser);
    var _super = (0, $dWNJz.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $fsi6a.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 40);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $1Kal7.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $1q4p8.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $ecHQG.Parser));

});

parcelRegister("9atxF", function(module, exports) {

$parcel$export(module.exports, "TimestampMillisecondsParser", () => $6acbf6a898c53f17$export$6d8f69c6906d6368);

var $fsi6a = parcelRequire("fsi6a");

var $1Kal7 = parcelRequire("1Kal7");

var $lVo1d = parcelRequire("lVo1d");

var $3s1Q9 = parcelRequire("3s1Q9");

var $dWNJz = parcelRequire("dWNJz");

var $ecU2x = parcelRequire("ecU2x");

var $ecHQG = parcelRequire("ecHQG");

var $1q4p8 = parcelRequire("1q4p8");
var $6acbf6a898c53f17$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $3s1Q9.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $dWNJz.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $fsi6a.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "priority", 20);
        (0, $ecU2x.default)((0, $lVo1d.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $1Kal7.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $1q4p8.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $ecHQG.Parser));

});



parcelRegister("1zprp", function(module, exports) {

$parcel$export(module.exports, "default", () => $124ccb6aceb4d52e$export$2e2bcd8739ae039);

var $kKOHX = parcelRequire("kKOHX");

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $124ccb6aceb4d52e$export$2e2bcd8739ae039(dirtyDate, dirtyDayOfMonth) {
    (0, $kl91g.default)(2, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    var dayOfMonth = (0, $kKOHX.default)(dirtyDayOfMonth);
    date.setDate(dayOfMonth);
    return date;
}

});

parcelRegister("khrLS", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec3aeff02179fb57$export$2e2bcd8739ae039);

var $kKOHX = parcelRequire("kKOHX");

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $ec3aeff02179fb57$export$2e2bcd8739ae039(dirtyDate, dirtyHours) {
    (0, $kl91g.default)(2, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    var hours = (0, $kKOHX.default)(dirtyHours);
    date.setHours(hours);
    return date;
}

});

parcelRegister("3Rwxg", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cff8f302a0a83f9$export$2e2bcd8739ae039);

var $kKOHX = parcelRequire("kKOHX");

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $2cff8f302a0a83f9$export$2e2bcd8739ae039(dirtyDate, dirtyMinutes) {
    (0, $kl91g.default)(2, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    var minutes = (0, $kKOHX.default)(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
}

});

parcelRegister("krBe9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee2334cc0e53fa08$export$2e2bcd8739ae039);

var $kKOHX = parcelRequire("kKOHX");

var $jwXww = parcelRequire("jwXww");

var $dmv68 = parcelRequire("dmv68");

var $kl91g = parcelRequire("kl91g");
function $ee2334cc0e53fa08$export$2e2bcd8739ae039(dirtyDate, dirtyMonth) {
    (0, $kl91g.default)(2, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    var month = (0, $kKOHX.default)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, $dmv68.default)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}

});

parcelRegister("6wupV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bfd537424044909$export$2e2bcd8739ae039);

var $kKOHX = parcelRequire("kKOHX");

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $4bfd537424044909$export$2e2bcd8739ae039(dirtyDate, dirtySeconds) {
    (0, $kl91g.default)(2, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    var seconds = (0, $kKOHX.default)(dirtySeconds);
    date.setSeconds(seconds);
    return date;
}

});

parcelRegister("75ZRt", function(module, exports) {

$parcel$export(module.exports, "default", () => $52a8fc6891d6c5ac$export$2e2bcd8739ae039);

var $kKOHX = parcelRequire("kKOHX");

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $52a8fc6891d6c5ac$export$2e2bcd8739ae039(dirtyDate, dirtyYear) {
    (0, $kl91g.default)(2, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    var year = (0, $kKOHX.default)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}

});

parcelRegister("ikJW5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d58dba28ed8da5b2$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $d58dba28ed8da5b2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kl91g.default)(1, arguments);
    var date = (0, $jwXww.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("dEWl7", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f1c43d07e11337c$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kKOHX = parcelRequire("kKOHX");

var $kl91g = parcelRequire("kl91g");

var $8wGln = parcelRequire("8wGln");
function $9f1c43d07e11337c$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $kl91g.default)(1, arguments);
    var defaultOptions = (0, $8wGln.getDefaultOptions)();
    var weekStartsOn = (0, $kKOHX.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $jwXww.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("kNnNZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f23ad981f151e57c$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $f23ad981f151e57c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kl91g.default)(1, arguments);
    var cleanDate = (0, $jwXww.default)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("f7iMk", function(module, exports) {

$parcel$export(module.exports, "default", () => $b016137a142edcad$export$2e2bcd8739ae039);

var $HfRMJ = parcelRequire("HfRMJ");

var $kl91g = parcelRequire("kl91g");

var $kKOHX = parcelRequire("kKOHX");
function $b016137a142edcad$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $kl91g.default)(1, arguments);
    var additionalDigits = (0, $kKOHX.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $b016137a142edcad$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $b016137a142edcad$var$parseYear(dateStrings.date, additionalDigits);
        date = $b016137a142edcad$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $b016137a142edcad$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $b016137a142edcad$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $b016137a142edcad$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $b016137a142edcad$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $b016137a142edcad$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $b016137a142edcad$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $b016137a142edcad$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($b016137a142edcad$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($b016137a142edcad$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($b016137a142edcad$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $b016137a142edcad$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $b016137a142edcad$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $b016137a142edcad$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($b016137a142edcad$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $b016137a142edcad$var$parseDateUnit(captures[1]);
    var month = $b016137a142edcad$var$parseDateUnit(captures[2]) - 1;
    var day = $b016137a142edcad$var$parseDateUnit(captures[3]);
    var week = $b016137a142edcad$var$parseDateUnit(captures[4]);
    var dayOfWeek = $b016137a142edcad$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$b016137a142edcad$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $b016137a142edcad$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$b016137a142edcad$var$validateDate(year, month, day) || !$b016137a142edcad$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $b016137a142edcad$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $b016137a142edcad$var$parseTime(timeString) {
    var captures = timeString.match($b016137a142edcad$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $b016137a142edcad$var$parseTimeUnit(captures[1]);
    var minutes = $b016137a142edcad$var$parseTimeUnit(captures[2]);
    var seconds = $b016137a142edcad$var$parseTimeUnit(captures[3]);
    if (!$b016137a142edcad$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $HfRMJ.millisecondsInHour) + minutes * (0, $HfRMJ.millisecondsInMinute) + seconds * 1000;
}
function $b016137a142edcad$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $b016137a142edcad$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($b016137a142edcad$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$b016137a142edcad$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $HfRMJ.millisecondsInHour) + minutes * (0, $HfRMJ.millisecondsInMinute));
}
function $b016137a142edcad$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $b016137a142edcad$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $b016137a142edcad$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $b016137a142edcad$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($b016137a142edcad$var$daysInMonths[month] || ($b016137a142edcad$var$isLeapYearIndex(year) ? 29 : 28));
}
function $b016137a142edcad$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($b016137a142edcad$var$isLeapYearIndex(year) ? 366 : 365);
}
function $b016137a142edcad$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $b016137a142edcad$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $b016137a142edcad$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("ihKsA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4fdda8d88e78b37$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $fJf0R = parcelRequire("fJf0R");

var $kl91g = parcelRequire("kl91g");
function $d4fdda8d88e78b37$export$2e2bcd8739ae039(date, options) {
    var _options$format, _options$representati;
    (0, $kl91g.default)(1, arguments);
    var originalDate = (0, $jwXww.default)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError('Invalid time value');
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
    if (format !== 'extended' && format !== 'basic') throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== 'date' && representation !== 'time' && representation !== 'complete') throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = '';
    var tzOffset = '';
    var dateDelimiter = format === 'extended' ? '-' : '';
    var timeDelimiter = format === 'extended' ? ':' : '';
    // Representation is either 'date' or 'complete'
    if (representation !== 'time') {
        var day = (0, $fJf0R.default)(originalDate.getDate(), 2);
        var month = (0, $fJf0R.default)(originalDate.getMonth() + 1, 2);
        var year = (0, $fJf0R.default)(originalDate.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== 'date') {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, $fJf0R.default)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, $fJf0R.default)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? '+' : '-';
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = 'Z';
        var hour = (0, $fJf0R.default)(originalDate.getHours(), 2);
        var minute = (0, $fJf0R.default)(originalDate.getMinutes(), 2);
        var second = (0, $fJf0R.default)(originalDate.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === '' ? '' : 'T';
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}

});

parcelRegister("8lPH0", function(module, exports) {

$parcel$export(module.exports, "default", () => $614861f56756c2c1$export$2e2bcd8739ae039);

var $jwXww = parcelRequire("jwXww");

var $kl91g = parcelRequire("kl91g");
function $614861f56756c2c1$export$2e2bcd8739ae039(dirtyDate, interval) {
    (0, $kl91g.default)(2, arguments);
    var time = (0, $jwXww.default)(dirtyDate).getTime();
    var startTime = (0, $jwXww.default)(interval.start).getTime();
    var endTime = (0, $jwXww.default)(interval.end).getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError('Invalid interval');
    return time >= startTime && time <= endTime;
}

});

parcelRegister("fGmR0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $b6ac819984486ec5$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $b6ac819984486ec5$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $b6ac819984486ec5$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $b6ac819984486ec5$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $b6ac819984486ec5$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $b6ac819984486ec5$var$timeLongFormatter(timePattern, formatLong));
};
var $b6ac819984486ec5$var$longFormatters = {
    p: $b6ac819984486ec5$var$timeLongFormatter,
    P: $b6ac819984486ec5$var$dateTimeLongFormatter
};
var $b6ac819984486ec5$var$_default = $b6ac819984486ec5$var$longFormatters;
module.exports.default = $b6ac819984486ec5$var$_default;
module.exports = module.exports.default;

});



parcelRegister("a6zeR", function(module, exports) {

$parcel$export(module.exports, "locationsMatcher", () => $b12d78827096deef$export$d59be1f44aaa51ec);
const $b12d78827096deef$export$d59be1f44aaa51ec = (type, input)=>{
    const locations = JSON.parse(localStorage.locations);
    const locationIds = new Map();
    const locationNames = new Map();
    locations.forEach((element)=>{
        locationNames.set(`${element.name}, ${element.region}`, element.id);
        locationIds.set(element.id, `${element.name}, ${element.region}`);
    });
    if (type === "Id") return locationNames.get(input);
    else if (type === "Name") return locationIds.get(input);
};

});

parcelRegister("55pxR", function(module, exports) {

$parcel$export(module.exports, "handleCreateScheduleGridObjectToSubmit", () => $cfc41ed073c8d429$export$e4b33b14349a8549);
parcelRequire("8T3gX");
parcelRequire("elyck");
var $h5bv8 = parcelRequire("h5bv8");
const $cfc41ed073c8d429$export$e4b33b14349a8549 = (dayOfWeekArray, startTime, endTime, alwaysOn, duskToDawn, bufferTime, timeRanges, duskToDawnLocation)=>{
    const daysOfWeek = [
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ];
    const returnArray = [];
    //remove any numbers from the daysOfWeek array that are included in the dayOfWeekArray
    const filteredDaysOfWeek = daysOfWeek.filter((day)=>!dayOfWeekArray.includes(day));
    returnArray.push({
        always_on: alwaysOn,
        buffer_time: bufferTime ? bufferTime : 0,
        customer: (0, $h5bv8.getNumbersAfterAboutSite)(location.href),
        day_of_week: dayOfWeekArray,
        enabled: true,
        end_time: endTime ? endTime.length === 5 ? `${endTime}:00` : endTime : null,
        is_overide: false,
        location_dusk_dawn: duskToDawn,
        start_time: startTime ? startTime.length === 5 ? `${startTime}:00` : startTime : null
    });
    filteredDaysOfWeek.forEach((day)=>{
        returnArray.push({
            always_on: timeRanges[day] === "Always On",
            buffer_time: duskToDawnLocation[day][1] ? duskToDawnLocation[day][1] : 0,
            customer: (0, $h5bv8.getNumbersAfterAboutSite)(location.href),
            day_of_week: [
                day
            ],
            enabled: true,
            end_time: timeRanges[day] === "Always On" || timeRanges[day] === "Dusk to Dawn" ? "23:59:59" : timeRanges[day].slice(8, 13),
            is_overide: false,
            location_dusk_dawn: duskToDawnLocation[day][0],
            start_time: timeRanges[day] === "Always On" || timeRanges[day] === "Dusk to Dawn" ? "00:00:00" : timeRanges[day].slice(0, 5)
        });
    });
    return returnArray;
};

});

parcelRegister("kFZm4", function(module, exports) {

$parcel$export(module.exports, "padTo2Digits", () => $786641060e8204b3$export$d4d4f0990c66df76);
const $786641060e8204b3$export$d4d4f0990c66df76 = (num)=>{
    return String(num).padStart(2, "0");
};

});



parcelRegister("2erCI", function(module, exports) {

$parcel$export(module.exports, "AddSiteWebhookDialog", () => $1ce729d3028d9fee$export$105ce4e5fca999b6);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $ce8iU = parcelRequire("ce8iU");

var $f3puC = parcelRequire("f3puC");

var $8jTCz = parcelRequire("8jTCz");

var $7etC6 = parcelRequire("7etC6");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");

var $b1uoD = parcelRequire("b1uoD");

var $9vEj4 = parcelRequire("9vEj4");

var $3FJ79 = parcelRequire("3FJ79");

var $7l43O = parcelRequire("7l43O");
const $1ce729d3028d9fee$export$7dc4f1b8a824e02d = (siteId, values)=>{
    const { auth: auth, ...rest } = values;
    return {
        customer: siteId,
        ...rest,
        ...(0, $9vEj4.buildWebhookAuthCreatePayload)(auth)
    };
};
const $1ce729d3028d9fee$export$105ce4e5fca999b6 = ({ siteId: siteId, onCreated: onCreated, navigate: navigate })=>{
    const open = (0, $3FJ79.useSiteAboutStore)((state)=>state.addSiteWebhookDialogOpen);
    const setOpen = (0, $3FJ79.useSiteAboutStore)((state)=>state.setAddSiteWebhookDialogOpen);
    const [values, setValues] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState((0, $7etC6.EMPTY_SITE_WEBHOOK_FORM_VALUES));
    const [fieldErrors, setFieldErrors] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [submitting, setSubmitting] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const reset = ()=>{
        setValues((0, $7etC6.EMPTY_SITE_WEBHOOK_FORM_VALUES));
        setFieldErrors({});
        setSubmitting(false);
    };
    const close = ()=>{
        setOpen(false);
        reset();
    };
    const submit = ()=>{
        const AxiosUI = (0, $195EM.createApi)(``);
        const payload = $1ce729d3028d9fee$export$7dc4f1b8a824e02d(siteId, values);
        setSubmitting(true);
        setFieldErrors({});
        AxiosUI.post("webhook_customer/", payload).then((response)=>{
            onCreated(response.data);
            close();
        }, (reason)=>{
            setSubmitting(false);
            // A 400 names the rejected fields (an auth_endpoint refused by the
            // SSRF guard, an auth_body that can't authenticate, ...): keep the
            // input and show the messages inline on those fields.
            const nextFieldErrors = (0, $9vEj4.extractWebhookFieldErrors)(reason);
            if (Object.keys(nextFieldErrors).length > 0) {
                setFieldErrors(nextFieldErrors);
                return;
            }
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, submit, ()=>{
                alert("Error adding the webhook. Please try again.");
            });
        });
    };
    const submitDisabled = submitting || !values.display_name.trim() || !values.target_url.trim() || Boolean((0, $9vEj4.authBodyJsonError)(values.auth.auth_body)) || Boolean((0, $7l43O.jsonTextError)(values.message_body, "Message Body"));
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: open,
        onClose: close,
        "aria-labelledby": "add-site-webhook-dialog-title",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "add-site-webhook-dialog-title",
                sx: {
                    textAlign: "center"
                },
                children: "Add Site Webhook"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "pt-[6px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $7etC6.SiteWebhookFormFields), {
                            values: values,
                            fieldErrors: fieldErrors,
                            width: 500,
                            messageBodyHelperText: "JSON sent to the webhook. Use the placeholders from the support page.",
                            onFieldChange: (field, value)=>{
                                setValues((previousState)=>({
                                        ...previousState,
                                        [field]: value
                                    }));
                            },
                            onAuthFieldChange: (field, value)=>{
                                setValues((previousState)=>({
                                        ...previousState,
                                        auth: {
                                            ...previousState.auth,
                                            [field]: value
                                        }
                                    }));
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                        variant: "caption",
                        sx: {
                            mt: 2,
                            display: "block"
                        },
                        children: [
                            "Display Name and Target URL are required. The webhook type is set to Custom automatically. Formatting examples are on our support page:",
                            " ",
                            /*#__PURE__*/ (0, $k4ank.jsx)("a", {
                                href: (0, $b1uoD.getSupportUrl)("/admin_ui/webhooks/"),
                                target: "_blank",
                                rel: "noopener noreferrer",
                                style: {
                                    color: "#1976d2",
                                    textDecoration: "none"
                                },
                                children: "Webhooks"
                            }),
                            ". Cameras pick which site webhook they send to under Edit Camera \u2192 Alert Settings \u2192 Add Stream Webhook."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: close,
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: submit,
                        text: "Submit",
                        disabled: submitDisabled
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("7etC6", function(module, exports) {

$parcel$export(module.exports, "EMPTY_SITE_WEBHOOK_FORM_VALUES", () => $22f0ee7b3f1336b6$export$2c684a14228f4160);
$parcel$export(module.exports, "SiteWebhookFormFields", () => $22f0ee7b3f1336b6$export$fe79643e2017f9d7);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eejVe = parcelRequire("eejVe");

var $aRSHn = parcelRequire("aRSHn");

var $7l43O = parcelRequire("7l43O");
const $22f0ee7b3f1336b6$export$a09298d1308d7b87 = [
    "POST",
    "GET"
];
const $22f0ee7b3f1336b6$export$2c684a14228f4160 = {
    display_name: "",
    target_url: "",
    method: "POST",
    message_body: "{}",
    auth: {
        auth_type: null,
        auth_endpoint: null,
        auth_body: null,
        auth_token_path: null
    }
};
const $22f0ee7b3f1336b6$export$fe79643e2017f9d7 = ({ values: values, onFieldChange: onFieldChange, onAuthFieldChange: onAuthFieldChange, fieldErrors: fieldErrors = {}, width: width = 350, messageBodyHelperText: messageBodyHelperText = "*optional" })=>{
    const messageBodyError = fieldErrors.message_body || (0, $7l43O.jsonTextError)(values.message_body, "Message Body");
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "flex flex-col gap-5",
        "data-testid": "site-webhook-form",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                label: "Display Name",
                variant: "standard",
                value: values.display_name,
                onChange: (event)=>{
                    const nextValue = event.target.value;
                    onFieldChange("display_name", nextValue);
                },
                error: Boolean(fieldErrors.display_name),
                helperText: fieldErrors.display_name || "",
                inputProps: {
                    "aria-label": "Display Name"
                },
                sx: {
                    fontFamily: "Mulish",
                    width: width
                }
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                label: "Target URL",
                variant: "standard",
                value: values.target_url,
                onChange: (event)=>{
                    const nextValue = event.target.value;
                    onFieldChange("target_url", nextValue);
                },
                error: Boolean(fieldErrors.target_url),
                helperText: fieldErrors.target_url || "",
                inputProps: {
                    "aria-label": "Target URL"
                },
                sx: {
                    fontFamily: "Mulish",
                    width: width
                }
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                select: true,
                SelectProps: {
                    native: true
                },
                label: "Method",
                variant: "standard",
                value: values.method,
                onChange: (event)=>{
                    const nextValue = event.target.value;
                    onFieldChange("method", nextValue);
                },
                error: Boolean(fieldErrors.method),
                helperText: fieldErrors.method || "",
                InputLabelProps: {
                    shrink: true
                },
                inputProps: {
                    "aria-label": "Method"
                },
                sx: {
                    fontFamily: "Mulish",
                    width: 120
                },
                children: $22f0ee7b3f1336b6$export$a09298d1308d7b87.map((method)=>/*#__PURE__*/ (0, $k4ank.jsx)("option", {
                        value: method,
                        children: method
                    }, method))
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                multiline: true,
                rows: 4,
                label: "Message Body",
                variant: "outlined",
                value: values.message_body,
                onChange: (event)=>{
                    const nextValue = event.target.value;
                    onFieldChange("message_body", nextValue);
                },
                error: Boolean(messageBodyError),
                helperText: messageBodyError || messageBodyHelperText,
                inputProps: {
                    "aria-label": "Message Body",
                    spellCheck: false
                },
                sx: {
                    fontFamily: "Mulish",
                    width: width
                }
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aRSHn.WebhookAuthFields), {
                values: values.auth,
                errors: fieldErrors,
                onFieldChange: onAuthFieldChange,
                width: width
            })
        ]
    });
};

});


parcelRegister("9OjJ7", function(module, exports) {

$parcel$export(module.exports, "SiteAboutAlerts", () => $4a9e9006b541db4b$export$9e9dab6615969557);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $3QMQN = parcelRequire("3QMQN");
var $iKAtE = parcelRequire("iKAtE");

var $433j1 = parcelRequire("433j1");

var $fIsAN = parcelRequire("fIsAN");

var $2kGAP = parcelRequire("2kGAP");
parcelRequire("elyck");
var $h5bv8 = parcelRequire("h5bv8");

var $3FJ79 = parcelRequire("3FJ79");

var $f0C6U = parcelRequire("f0C6U");

var $5bO6h = parcelRequire("5bO6h");

var $kUNf4 = parcelRequire("kUNf4");

var $imDMS = parcelRequire("imDMS");
const $4a9e9006b541db4b$export$9e9dab6615969557 = ({ siteDeployed: siteDeployed, aiLinkSite: aiLinkSite, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setSyncNeeded: setSyncNeeded, setAlertState: setAlertState, siteInfo: siteInfo, setSiteInfo: setSiteInfo, setAllSiteSchedules: setAllSiteSchedules, setActiveTab: setActiveTab, vmsVariables: vmsVariables, setSiteDeployed: setSiteDeployed, setDeativateInquiryDialogOpen: setDeativateInquiryDialogOpen, setSiteCameras: setSiteCameras, camerasNotDeployed: camerasNotDeployed, setCamerasNotDeployed: setCamerasNotDeployed, navigate: navigate, setVmsVariables: setVmsVariables, alertState: alertState, setEditMode: setEditMode, setClickedTab: setClickedTab, setArmButtonDisabled: setArmButtonDisabled, setArmedStatus: setArmedStatus, setRebootDialogOpen: setRebootDialogOpen })=>{
    const { siteAboutAlerts: siteAboutAlerts, setSiteAboutAlerts: setSiteAboutAlerts, setScheduleGridEditable: setScheduleGridEditable, syncSiteNeededAlertOpen: syncSiteNeededAlertOpen, setSyncSiteNeededAlertOpen: setSyncSiteNeededAlertOpen, setSyncSiteNeeded: setSyncSiteNeeded } = (0, $3FJ79.useSiteAboutStore)();
    const isSyncExcludedIntegration = siteInfo.integration_type_name === "autopatrol" || siteInfo.integration_type_name === "clips";
    // "Don't show again for this site" on any sync banner hides the reminder for
    // this site for the rest of the browser session (SUP-924). The header Sync
    // Site button still turns red while changes are pending, so nothing is lost
    // — only the nag.
    const syncBannersHidden = (0, $kUNf4.useSyncBannersHiddenForCurrentSite)();
    const closeSyncNeededAlert = ()=>{
        setAlertState((previousState)=>{
            return {
                ...previousState,
                changeSuccess: false
            };
        });
        setSyncSiteNeededAlertOpen(false);
        setEditMode(false);
        setScheduleGridEditable(false);
    };
    // With the reminder hidden, a save still needs a confirmation: show a plain
    // "Changes saved" that clears itself, instead of nothing at all.
    const showSavedConfirmationOnly = alertState.changeSuccess && !isSyncExcludedIntegration && syncBannersHidden;
    $8T3gX.useEffect(()=>{
        if (!showSavedConfirmationOnly) return;
        const timer = setTimeout(()=>{
            setAlertState((previousState)=>{
                return {
                    ...previousState,
                    changeSuccess: false
                };
            });
        }, 6000);
        return ()=>clearTimeout(timer);
    }, [
        showSavedConfirmationOnly
    ]);
    // ENG-2631: a holiday/one-off override replaces the regular schedule today
    // (SUP-954). Nothing when admin doesn't send the fields (old prod admin).
    const overrideBanner = (0, $f0C6U.overrideBannerText)(siteInfo);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            !siteDeployed && !aiLinkSite && !isSyncExcludedIntegration && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3QMQN.default), {
                severity: "warning",
                onClose: ()=>{
                    setSiteDeployed(true);
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                        className: "font-mulish font-bold text-[16px]",
                        children: [
                            "Site not deployed.",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                        className: "font-mulish text-[15px]",
                        children: [
                            "Please\xa0",
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                                to: `/sites/aboutsite/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}`,
                                onClick: ()=>{
                                    setSiteDeployed(true);
                                    setBackdropLoadingScreenOn(true);
                                    (0, $2kGAP.handleSyncSite)(setBackdropLoadingScreenOn, setAlertState, siteInfo, setSiteInfo, setSyncNeeded, setAllSiteSchedules, setActiveTab, vmsVariables, setSiteDeployed, setDeativateInquiryDialogOpen, setSiteCameras, camerasNotDeployed, setCamerasNotDeployed, navigate, setVmsVariables, setClickedTab, setArmButtonDisabled, setArmedStatus, setRebootDialogOpen);
                                },
                                className: "underline underline-offset-1",
                                children: "Sync Site"
                            }),
                            "\xa0to deploy site."
                        ]
                    })
                ]
            }),
            alertState.noCameraOrSchedule && !aiLinkSite && localStorage.noAutoAddCamerasDialogOpen === "false" && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3QMQN.default), {
                severity: "warning",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-mulish font-bold text-[16px]",
                        children: "Incomplete Information"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                        className: "font-mulish text-[15px]",
                        children: [
                            "Please\xa0",
                            siteInfo.auto_add ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                                to: "/sites/autoaddcamera",
                                className: "underline underline-offset-1",
                                children: "Add Cameras"
                            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                                to: "/sites/addCamera",
                                className: "underline underline-offset-1",
                                onClick: ()=>{
                                    localStorage.setItem("firstCameraAdded", "true");
                                    localStorage.setItem("copyValues", "true");
                                },
                                children: "Add Cameras"
                            }),
                            "\xa0and then add schedule to run the Site."
                        ]
                    })
                ]
            }),
            alertState.noSchedule && !aiLinkSite && Boolean(siteInfo.display_schedule) && Boolean(siteInfo.active) === true && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3QMQN.default), {
                severity: "warning",
                onClose: ()=>{
                    setAlertState((previousState)=>{
                        return {
                            ...previousState,
                            noSchedule: false
                        };
                    });
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-mulish font-bold text-[16px]",
                        children: "Incomplete Information"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-mulish text-[15px]",
                        children: "Please add schedule to run the Site."
                    })
                ]
            }),
            overrideBanner && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3QMQN.default), {
                severity: "info",
                "data-testid": "site-override-banner",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("b", {
                        children: [
                            overrideBanner,
                            "."
                        ]
                    }),
                    " It replaces the regular schedule today, so the site arms and disarms only as the override says. See the Schedules tab for its hours."
                ]
            }),
            alertState.activateSuccess && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                onClose: ()=>{
                    setAlertState((previousState)=>{
                        return {
                            ...previousState,
                            activateSuccess: false
                        };
                    });
                },
                children: "Site successfully activated."
            }),
            alertState.deactivateSuccess && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                onClose: ()=>{
                    setAlertState((previousState)=>{
                        return {
                            ...previousState,
                            deactivateSuccess: false
                        };
                    });
                },
                children: "Site successfully deactivated."
            }),
            (alertState.changeSuccess || syncSiteNeededAlertOpen) && !isSyncExcludedIntegration && !syncBannersHidden && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3QMQN.default), {
                severity: "warning",
                action: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $imDMS.HideSyncBannerCheckbox), {
                            onHide: closeSyncNeededAlert
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                            "aria-label": "Close",
                            color: "inherit",
                            size: "small",
                            onClick: closeSyncNeededAlert,
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {
                                fontSize: "inherit"
                            })
                        })
                    ]
                }),
                children: [
                    "Changes saved successfully! Please\xa0",
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                        to: `/sites/aboutsite/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}`,
                        onClick: ()=>{
                            setBackdropLoadingScreenOn(true);
                            setSyncSiteNeededAlertOpen(false);
                            (0, $2kGAP.handleSyncSite)(setBackdropLoadingScreenOn, setAlertState, siteInfo, setSiteInfo, setSyncNeeded, setAllSiteSchedules, setActiveTab, vmsVariables, setSiteDeployed, setDeativateInquiryDialogOpen, setSiteCameras, camerasNotDeployed, setCamerasNotDeployed, navigate, setVmsVariables, setClickedTab, setArmButtonDisabled, setArmedStatus, setRebootDialogOpen);
                        },
                        className: "underline underline-offset-1",
                        children: "Sync Site"
                    }),
                    "\xa0to apply changes."
                ]
            }),
            showSavedConfirmationOnly && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                onClose: ()=>{
                    setAlertState((previousState)=>{
                        return {
                            ...previousState,
                            changeSuccess: false
                        };
                    });
                },
                children: "Changes saved successfully."
            }),
            alertState.disarmSuccess && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                onClose: ()=>{
                    setAlertState((previousState)=>{
                        return {
                            ...previousState,
                            disarmSuccess: false
                        };
                    });
                },
                children: "Site disarm command sent successfully. It may take a few moments for site arm status to update."
            }),
            alertState.armSuccess && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                onClose: ()=>{
                    setAlertState((previousState)=>{
                        return {
                            ...previousState,
                            armSuccess: false
                        };
                    });
                },
                children: "Site arm command sent successfully. It may take a few moments for arm status to update."
            }),
            alertState.armFail && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                severity: "warning",
                onClose: ()=>{
                    setAlertState((previousState)=>{
                        return {
                            ...previousState,
                            armFail: false
                        };
                    });
                },
                children: "Site arm command failed. Please try again"
            }),
            alertState.syncSuccess && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                onClose: ()=>{
                    setAlertState((previousState)=>{
                        return {
                            ...previousState,
                            syncSuccess: false
                        };
                    });
                },
                children: "Site synced successfully."
            }),
            alertState.configureMotion.phase !== "idle" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                severity: (0, $5bO6h.configureMotionSeverity)(alertState.configureMotion.phase),
                onClose: ()=>{
                    setAlertState((previousState)=>{
                        return {
                            ...previousState,
                            configureMotion: (0, $5bO6h.IDLE_CONFIGURE_MOTION)
                        };
                    });
                },
                children: alertState.configureMotion.message
            }),
            alertState.refreshCameraSuccess && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                onClose: ()=>{
                    setAlertState((previousState)=>{
                        return {
                            ...previousState,
                            refreshCameraSuccess: false
                        };
                    });
                },
                children: "Cameras refreshed successfully."
            }),
            alertState.refreshCameraFail && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                onClose: ()=>{
                    setAlertState((previousState)=>{
                        return {
                            ...previousState,
                            refreshCameraFail: false
                        };
                    });
                },
                children: "Cameras failed to refresh. Please try again."
            }),
            alertState.webhookChangesFail && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                severity: "error",
                onClose: ()=>{
                    setAlertState((previousState)=>{
                        return {
                            ...previousState,
                            webhookChangesFail: false
                        };
                    });
                },
                children: "Webhooks updates failed to save. Please try again."
            }),
            alertState.cameraDeleteSuccess && !isSyncExcludedIntegration && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3QMQN.default), {
                severity: "warning",
                onClose: ()=>{
                    setAlertState((previousState)=>{
                        return {
                            ...previousState,
                            cameraDeleteSuccess: false
                        };
                    });
                },
                children: [
                    "Camera delete successful! Please",
                    " ",
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                        to: `/sites/aboutsite/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}`,
                        onClick: ()=>{
                            setBackdropLoadingScreenOn(true);
                            setSyncNeeded(false);
                            (0, $2kGAP.handleSyncSite)(setBackdropLoadingScreenOn, setAlertState, siteInfo, setSiteInfo, setSyncNeeded, setAllSiteSchedules, setActiveTab, vmsVariables, setSiteDeployed, setDeativateInquiryDialogOpen, setSiteCameras, camerasNotDeployed, setCamerasNotDeployed, navigate, setVmsVariables, setClickedTab, setArmButtonDisabled, setArmedStatus, setRebootDialogOpen);
                        },
                        className: "underline underline-offset-1",
                        children: "Sync Site"
                    }),
                    "\xa0to apply changes."
                ]
            }),
            camerasNotDeployed && !isSyncExcludedIntegration && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3QMQN.default), {
                severity: "warning",
                onClose: ()=>{
                    setCamerasNotDeployed(false);
                },
                children: [
                    "One or more cameras has changes which have not been deployed! Please",
                    " ",
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                        to: `/sites/aboutsite/${(0, $h5bv8.getNumbersAfterAboutSite)(location.href)}`,
                        onClick: ()=>{
                            setBackdropLoadingScreenOn(true);
                            (0, $2kGAP.handleSyncSite)(setBackdropLoadingScreenOn, setAlertState, siteInfo, setSiteInfo, setSyncNeeded, setAllSiteSchedules, setActiveTab, vmsVariables, setSiteDeployed, setDeativateInquiryDialogOpen, setSiteCameras, camerasNotDeployed, setCamerasNotDeployed, navigate, setVmsVariables, setClickedTab, setArmButtonDisabled, setArmedStatus, setRebootDialogOpen);
                        },
                        className: "underline underline-offset-1",
                        children: "Sync Site"
                    }),
                    "\xa0to apply changes."
                ]
            }),
            siteAboutAlerts.scheduleSubmittedAndSiteSynced && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                onClose: ()=>{
                    setSiteAboutAlerts({
                        ...siteAboutAlerts,
                        scheduleSubmittedAndSiteSynced: false
                    });
                },
                children: "Schedule changes submitted and site synced successfully."
            })
        ]
    });
};

});
parcelRegister("5bO6h", function(module, exports) {

$parcel$export(module.exports, "CONFIGURE_MOTION_POLL_INTERVAL_MS", () => $01713eb1d0293f21$export$aade58306dbe39b2);
$parcel$export(module.exports, "CONFIGURE_MOTION_POLL_ATTEMPTS", () => $01713eb1d0293f21$export$350dfc9b64c9675d);
$parcel$export(module.exports, "DISPATCH_CLOCK_SKEW_MS", () => $01713eb1d0293f21$export$7e83c6af38584e79);
$parcel$export(module.exports, "PENDING_MESSAGE", () => $01713eb1d0293f21$export$5fc4c9fd6d2b7d8e);
$parcel$export(module.exports, "TIMEOUT_MESSAGE", () => $01713eb1d0293f21$export$d99c3f7202e189a6);
$parcel$export(module.exports, "REQUEST_FAILED_MESSAGE", () => $01713eb1d0293f21$export$2fdebf6cf91e931f);
$parcel$export(module.exports, "IDLE_CONFIGURE_MOTION", () => $01713eb1d0293f21$export$5ca2c9e1be90bbf1);
$parcel$export(module.exports, "skippedMessage", () => $01713eb1d0293f21$export$1fa34218df727585);
$parcel$export(module.exports, "summarizeConfigureMotion", () => $01713eb1d0293f21$export$6f61438ab3af99a);
$parcel$export(module.exports, "configureMotionSeverity", () => $01713eb1d0293f21$export$c1b026d9a8192b58);
const $01713eb1d0293f21$export$aade58306dbe39b2 = 3000;
const $01713eb1d0293f21$export$350dfc9b64c9675d = 40; // ~2 minutes
const $01713eb1d0293f21$export$7e83c6af38584e79 = 60000;
const $01713eb1d0293f21$export$5fc4c9fd6d2b7d8e = "Configuring motion. The Nx Witness rule is created by a background job \u2014 this usually takes under a minute.";
const $01713eb1d0293f21$export$d99c3f7202e189a6 = "Configure Motion is still running. Check Event Rules in Nx Witness, or try again in a few minutes.";
const $01713eb1d0293f21$export$2fdebf6cf91e931f = "Configure Motion request failed. Please try again.";
const $01713eb1d0293f21$export$5ca2c9e1be90bbf1 = {
    phase: "idle",
    message: ""
};
const $01713eb1d0293f21$export$1fa34218df727585 = (messages)=>{
    if (!Array.isArray(messages)) return null;
    const blocking = messages.find((m)=>m && (m.level_tag === "warning" || m.level_tag === "error"));
    return blocking ? String(blocking.message) : null;
};
const $01713eb1d0293f21$var$plural = (count, noun)=>`${count} ${noun}${count === 1 ? "" : "s"}`;
const $01713eb1d0293f21$export$6f61438ab3af99a = (response)=>{
    const cameras = response.result?.cameras ?? [];
    const configured = cameras.filter((c)=>c.status === "configured");
    const already = cameras.filter((c)=>c.status === "already_configured");
    const failed = cameras.filter((c)=>c.status === "failed");
    const stale = cameras.filter((c)=>c.stale_rules && c.stale_rules.length > 0);
    const parts = [];
    if (configured.length) parts.push(`rule created for ${$01713eb1d0293f21$var$plural(configured.length, "camera")}`);
    if (already.length) parts.push(`${already.length} already configured`);
    const failedDetail = failed.map((c)=>`${c.camera_name ?? c.camera_id}${c.detail ? ` (${c.detail})` : ""}`).join("; ");
    switch(response.status){
        case "success":
            {
                let message = `Motion configured: ${parts.join(", ") || "no changes needed"}.`;
                if (stale.length) message += ` ${$01713eb1d0293f21$var$plural(stale.length, "camera")} ${stale.length === 1 ? "has" : "have"} an older Actuate rule pointing at a different camera \u{2014} review it in Nx Witness.`;
                return {
                    phase: "success",
                    message: message
                };
            }
        case "partial":
            return {
                phase: "partial",
                message: `Motion configured for some cameras (${parts.join(", ")}) but failed for: ${failedDetail}.`
            };
        case "failed":
            {
                const reason = response.result?.error || failedDetail || "unknown error";
                return {
                    phase: "failed",
                    message: `Configure Motion failed: ${reason}`
                };
            }
        default:
            return {
                phase: "pending",
                message: $01713eb1d0293f21$export$5fc4c9fd6d2b7d8e
            };
    }
};
const $01713eb1d0293f21$export$c1b026d9a8192b58 = (phase)=>{
    switch(phase){
        case "success":
            return "success";
        case "failed":
            return "error";
        case "pending":
            return "info";
        default:
            // partial, skipped, timeout: something needs a look, nothing is broken
            // for certain.
            return "warning";
    }
};

});

parcelRegister("kUNf4", function(module, exports) {

$parcel$export(module.exports, "useSyncBannersHiddenForCurrentSite", () => $598050ecb98fd781$export$1e782eb45925220f);
$parcel$export(module.exports, "hideSyncBannersForCurrentSite", () => $598050ecb98fd781$export$8c0aaf3c1d688c28);
$parcel$export(module.exports, "resetSyncBannerPreference", () => $598050ecb98fd781$export$e91cf9c970f5d2f5);
$parcel$export(module.exports, "HIDE_SYNC_BANNER_LABEL", () => $598050ecb98fd781$export$a80a72fc10faa89f);

var $9OjAn = parcelRequire("9OjAn");

var $815yO = parcelRequire("815yO");
/**
 * "Don't show the sync reminder again for this site" — a per-site,
 * per-browser-session preference (SUP-924).
 *
 * Every save on the About page and the camera-level edit views re-shows a
 * "please sync" banner. Operators working through a freshly onboarded site
 * (cameras connect, then a run of ignore zones, line crossings, …) asked for
 * a way to stop seeing it. This store remembers that choice:
 *
 *  - Per site, keyed by the site id in the URL — hiding the reminder on one
 *    site never hides it on another. The operator ticks the box again on the
 *    next site if they want it there too.
 *  - Mirrored in sessionStorage, so it survives route changes and reloads but
 *    is dropped when the tab closes — the reminder comes back next visit.
 *  - Cleared on logout (handleLogout), so the next person to sign in on the
 *    same tab gets the reminder again.
 *
 * It hides only the banners. The red "Sync Site" buttons (About page header
 * and edit-view headers) keep showing whenever the site has unsynced changes,
 * so the operator always has a visible way to see and act on pending changes.
 */ const $598050ecb98fd781$var$STORAGE_KEY = "syncBannerHiddenSiteIds";
const $598050ecb98fd781$var$readMirror = ()=>{
    try {
        const stored = JSON.parse(sessionStorage.getItem($598050ecb98fd781$var$STORAGE_KEY) || "[]");
        return Array.isArray(stored) ? stored.map(String) : [];
    } catch  {
        return [];
    }
};
const $598050ecb98fd781$var$writeMirror = (siteIds)=>{
    try {
        if (siteIds.length === 0) sessionStorage.removeItem($598050ecb98fd781$var$STORAGE_KEY);
        else sessionStorage.setItem($598050ecb98fd781$var$STORAGE_KEY, JSON.stringify(siteIds));
    } catch  {
    // Storage unavailable (private mode, quota) — in-memory state still works
    // for this page load.
    }
};
const $598050ecb98fd781$export$6a68023ef7acf408 = (0, $9OjAn.create)((set, get)=>({
        hiddenSiteIds: $598050ecb98fd781$var$readMirror(),
        hideSyncBannersForSite: (siteId)=>{
            if (!siteId) return;
            const ids = get().hiddenSiteIds;
            if (ids.includes(siteId)) return;
            const next = [
                ...ids,
                siteId
            ];
            $598050ecb98fd781$var$writeMirror(next);
            set({
                hiddenSiteIds: next
            });
        },
        resetSyncBannerPreference: ()=>{
            $598050ecb98fd781$var$writeMirror([]);
            set({
                hiddenSiteIds: []
            });
        }
    }));
const $598050ecb98fd781$export$1e782eb45925220f = ()=>$598050ecb98fd781$export$6a68023ef7acf408((s)=>s.hiddenSiteIds.includes((0, $815yO.getSiteIdFromUrl)()));
const $598050ecb98fd781$export$8c0aaf3c1d688c28 = ()=>$598050ecb98fd781$export$6a68023ef7acf408.getState().hideSyncBannersForSite((0, $815yO.getSiteIdFromUrl)());
const $598050ecb98fd781$export$e91cf9c970f5d2f5 = ()=>$598050ecb98fd781$export$6a68023ef7acf408.getState().resetSyncBannerPreference();
const $598050ecb98fd781$export$a80a72fc10faa89f = "Don't show again for this site";

});

parcelRegister("imDMS", function(module, exports) {

$parcel$export(module.exports, "HideSyncBannerCheckbox", () => $01a3720b78f384e2$export$4ee23c6b62f0eeaa);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kbChx = parcelRequire("kbChx");
var $3baw3 = parcelRequire("3baw3");

var $kUNf4 = parcelRequire("kUNf4");
const $01a3720b78f384e2$export$4ee23c6b62f0eeaa = ({ onHide: onHide })=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
            size: "small",
            color: "default",
            checked: false,
            onChange: (_event, checked)=>{
                if (!checked) return;
                (0, $kUNf4.hideSyncBannersForCurrentSite)();
                onHide?.();
            },
            sx: {
                py: 0,
                color: "inherit",
                "&.Mui-checked": {
                    color: "inherit"
                }
            }
        }),
        label: (0, $kUNf4.HIDE_SYNC_BANNER_LABEL),
        sx: {
            mr: 1,
            whiteSpace: "nowrap",
            "& .MuiFormControlLabel-label": {
                fontFamily: "Mulish",
                fontSize: 13
            }
        }
    });

});


parcelRegister("4wo2Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $e086c14e0248a9bc$export$2e2bcd8739ae039);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $ebTQj = parcelRequire("ebTQj");
class $e086c14e0248a9bc$var$ErrorBoundary extends (0, $8T3gX.Component) {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(error, errorInfo) {
        // Log the error to an error reporting service
        (0, $ebTQj.logger).error("Error caught by ErrorBoundary:", {
            error: error,
            errorInfo: errorInfo
        });
        // Update state to indicate an error has occurred
        this.setState({
            hasError: true
        });
    }
    render() {
        if (this.state.hasError) // alert(
        //   "Part of this page was unable to load.  Try refreshing page. If problem persists please contact support@actuate.ai"
        // );
        // Render fallback UI when an error occurs
        return /*#__PURE__*/ (0, $k4ank.jsx)("div", {});
        // Render children if no error has occurred
        return /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
            children: this.props.children
        });
    }
}
var $e086c14e0248a9bc$export$2e2bcd8739ae039 = $e086c14e0248a9bc$var$ErrorBoundary;

});

parcelRegister("jiOBG", function(module, exports) {

$parcel$export(module.exports, "GreenRedSwitch", () => $91bf13c254b7b037$export$cc1444f8328d51dc);
parcelRequire("8T3gX");

var $ddLR4 = parcelRequire("ddLR4");

var $anJSP = parcelRequire("anJSP");
const $91bf13c254b7b037$export$cc1444f8328d51dc = (0, $anJSP.default)((0, $ddLR4.default))(({ theme: theme })=>({
        "& .MuiSwitch-switchBase": {
            color: "red",
            "& + .MuiSwitch-track": {
                backgroundColor: "red"
            },
            "&.Mui-checked": {
                color: "green",
                "& + .MuiSwitch-track": {
                    backgroundColor: "green"
                }
            },
            // Disabled state (unchecked)
            "&.Mui-disabled": {
                color: "#ff9999",
                "& + .MuiSwitch-track": {
                    backgroundColor: "#ffcccc",
                    opacity: 1
                }
            },
            // Disabled & checked (on)
            "&.Mui-checked.Mui-disabled": {
                color: "#99e699",
                "& + .MuiSwitch-track": {
                    backgroundColor: "#ccffcc",
                    opacity: 1
                }
            }
        }
    }));

});

parcelRegister("deJMp", function(module, exports) {

$parcel$export(module.exports, "ArmedStatusChip", () => $152ad4c38ccacc36$export$69b010b6665c676f);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $6MI6A = parcelRequire("6MI6A");

var $cVCJe = parcelRequire("cVCJe");

var $5Ibhh = parcelRequire("5Ibhh");

var $cye0Y = parcelRequire("cye0Y");

var $gt8Ee = parcelRequire("gt8Ee");

var $gouAT = parcelRequire("gouAT");

var $eeN3r = parcelRequire("eeN3r");

var $hjOOA = parcelRequire("hjOOA");

var $hXXs8 = parcelRequire("hXXs8");

var $agMWc = parcelRequire("agMWc");
const $152ad4c38ccacc36$var$TONE_STYLES = {
    armed: {
        bg: "#e6f4ea",
        fg: "#1b5e20"
    },
    manual: {
        bg: "#e6f4ea",
        fg: "#1b5e20"
    },
    transitional: {
        bg: "#fff3e0",
        fg: "#a35300"
    },
    warning: {
        bg: "#fff3e0",
        fg: "#a35300"
    },
    error: {
        bg: "#fdecea",
        fg: "#b71c1c"
    },
    disarmed: {
        bg: "#eeeeee",
        fg: "#424242"
    },
    unknown: {
        bg: "#eeeeee",
        fg: "#616161"
    }
};
const $152ad4c38ccacc36$var$toneIcon = (status, tone)=>{
    if (status === "ARMING") return /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eeN3r))), {});
    if (status === "DISARMING") return /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hjOOA))), {});
    switch(tone){
        case "armed":
            return /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5Ibhh))), {});
        case "manual":
        case "warning":
            return /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gt8Ee))), {});
        case "error":
            return /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gouAT))), {});
        case "disarmed":
            return /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cye0Y))), {});
        default:
            return /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hXXs8))), {});
    }
};
const $152ad4c38ccacc36$export$69b010b6665c676f = ({ armedStatus: armedStatus, armed: armed, active: active = true })=>{
    const presentation = (0, $agMWc.getArmedStatusPresentation)(armedStatus, armed, active);
    const colors = $152ad4c38ccacc36$var$TONE_STYLES[presentation.tone];
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: presentation.description,
        placement: "top",
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $6MI6A.default), {
            size: "small",
            icon: $152ad4c38ccacc36$var$toneIcon(presentation.status, presentation.tone),
            label: presentation.label,
            "data-testid": "armed-status-chip",
            "data-armed-status": presentation.status,
            sx: {
                backgroundColor: colors.bg,
                color: colors.fg,
                fontFamily: "Mulish",
                fontWeight: 700,
                "& .MuiChip-icon": {
                    color: colors.fg
                }
            }
        })
    });
};

});
parcelRegister("eeN3r", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a5d86cb800409c4c$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $a5d86cb800409c4c$var$_default = module.exports.default = (0, $a5d86cb800409c4c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6m6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26"
}), 'Autorenew');

});

parcelRegister("hjOOA", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c9bba0cedcb3a51d$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $c9bba0cedcb3a51d$var$_default = module.exports.default = (0, $c9bba0cedcb3a51d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "m6 2 .01 6L10 12l-3.99 4.01L6 22h12v-6l-4-4 4-3.99V2zm10 14.5V20H8v-3.5l4-4z"
}), 'HourglassTop');

});


parcelRegister("bjLOU", function(module, exports) {

$parcel$export(module.exports, "SiteAboutAutoPatrol", () => $ca79525154695a8a$export$4cbf07befbd75cd9);
/* eslint-disable react-hooks/exhaustive-deps */ 
var $k4ank = parcelRequire("k4ank");

var $jVN1H = parcelRequire("jVN1H");

var $8T3gX = parcelRequire("8T3gX");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $h1wcZ = parcelRequire("h1wcZ");

var $bPE00 = parcelRequire("bPE00");

var $kHsF1 = parcelRequire("kHsF1");

var $77F6P = parcelRequire("77F6P");

var $dHtmK = parcelRequire("dHtmK");

var $8jTCz = parcelRequire("8jTCz");

var $cye0Y = parcelRequire("cye0Y");

var $6wUjC = parcelRequire("6wUjC");

var $2SHRA = parcelRequire("2SHRA");

var $7FIuT = parcelRequire("7FIuT");

var $9OjJ7 = parcelRequire("9OjJ7");

var $crpct = parcelRequire("crpct");

var $5bO6h = parcelRequire("5bO6h");

var $aMH8L = parcelRequire("aMH8L");

var $3QMQN = parcelRequire("3QMQN");

var $4wo2Y = parcelRequire("4wo2Y");

var $3FJ79 = parcelRequire("3FJ79");

var $lWchQ = parcelRequire("lWchQ");

var $2aMB5 = parcelRequire("2aMB5");

var $2uQ4j = parcelRequire("2uQ4j");

var $1W2ma = parcelRequire("1W2ma");

var $5zfN2 = parcelRequire("5zfN2");

var $ffVZD = parcelRequire("ffVZD");

var $hTYVM = parcelRequire("hTYVM");

var $4PFLW = parcelRequire("4PFLW");

var $8UhTy = parcelRequire("8UhTy");

var $195EM = parcelRequire("195EM");
const $ca79525154695a8a$export$f5172043e17f66eb = (url)=>{
    if (window.location.href.includes("aboutsitesecret")) {
        const match = url.match(/\/aboutsitesecret\/(\d+)/);
        if (match) return match[1];
        else return "";
    } else {
        const match = url.match(/\/aboutsite\/(\d+)/);
        if (match) return match[1];
        else return "";
    }
};
const $ca79525154695a8a$export$4cbf07befbd75cd9 = ({ permissions: permissions, navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed })=>{
    const [dataLoaded, setDataLoaded] = $8T3gX.useState(false);
    const [loadProgressPercent, setLoadProgressPercent] = $8T3gX.useState(5);
    const [loadProgressMessage, setLoadProgressMessage] = $8T3gX.useState("Loading site data...");
    const [clickedTab, setClickedTab] = $8T3gX.useState("three"); // Default to Schedules tab for AutoPatrol
    const [editMode, setEditMode] = $8T3gX.useState(false);
    const [schedulesEditMode, setSchedulesEditMode] = $8T3gX.useState(false);
    const [siteInfo, setSiteInfo] = $8T3gX.useState({});
    const [siteInfoBackup, setSiteInfoBackup] = $8T3gX.useState({});
    const [webhooksInfo, setWebhooksInfo] = $8T3gX.useState([]);
    const [activeTab, setActiveTab] = $8T3gX.useState(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
    const [vmsVariables, setVmsVariables] = $8T3gX.useState([]);
    const [vmsVariablesBackup, setVmsVariablesBackup] = $8T3gX.useState([]);
    const [patchObject, setPatchObject] = $8T3gX.useState({
        name: ""
    });
    const [siteSchedules, setSiteSchedules] = $8T3gX.useState([]);
    const [allSiteSchedules, setAllSiteSchedules] = $8T3gX.useState([]);
    const [webhooksPatchObject, setWebhooksPatchObject] = $8T3gX.useState({
        customer: $ca79525154695a8a$export$f5172043e17f66eb(location.href)
    });
    const [webhooksChangesMade, setWebhooksChangesMade] = $8T3gX.useState(false);
    const [wireguardTunnels, setWireguardTunnels] = $8T3gX.useState([]);
    const wireguardTunnelsLoading = false;
    const [selectedWireguardTunnelId, setSelectedWireguardTunnelId] = $8T3gX.useState(null);
    const [wireguardChangesMade, setWireguardChangesMade] = $8T3gX.useState(false);
    const wireGuardEditSessionRef = $8T3gX.useRef(null);
    const { width: width } = (0, $crpct.default)();
    const [alertState, setAlertState] = $8T3gX.useState({
        changeSuccess: false,
        noCameraOrSchedule: false,
        noSchedule: false,
        activateSuccess: false,
        deactivateSuccess: false,
        disarmSuccess: false,
        armSuccess: false,
        armFail: false,
        syncSuccess: false,
        cameraDeleteSuccess: false,
        configureMotion: (0, $5bO6h.IDLE_CONFIGURE_MOTION),
        refreshCameraSuccess: false,
        refreshCameraFail: false,
        webhookChangesFail: false
    });
    const [camerasNotDeployed, setCamerasNotDeployed] = $8T3gX.useState(false);
    const [backdropLoadingScreenOn, setBackdropLoadingScreenOn] = $8T3gX.useState(true);
    const [deleteSiteDialogOpen, setDeleteSiteDialogOpen] = $8T3gX.useState(false);
    const [siteInfoChangesMade, setSiteInfoChangesMade] = $8T3gX.useState(false);
    const [scheduleChangesMade, setScheduleChangesMade] = $8T3gX.useState(false);
    const [siteCameras, setSiteCameras] = $8T3gX.useState(localStorage.siteCameras ? JSON.parse(localStorage.siteCameras) : []);
    const [disarmDialogOpen, setDisarmDialogOpen] = $8T3gX.useState(false);
    const [armDialogOpen, setArmDialogOpen] = $8T3gX.useState(false);
    const [rebootDialogOpen, setRebootDialogOpen] = $8T3gX.useState(false);
    const [activateSiteDialogOpen, setActivateSiteDialogOpen] = $8T3gX.useState(false);
    const [deactivateSiteDialogOpen, setDeactivateSiteDialogOpen] = $8T3gX.useState(false);
    const [deativateInquiryDialogOpen, setDeativateInquiryDialogOpen] = $8T3gX.useState(false);
    const [noAutoAddCamerasDialogOpen, setNoAutoAddCamerasDialogOpen] = $8T3gX.useState(false);
    const [siteDeployed, setSiteDeployed] = $8T3gX.useState(true);
    const [aiLinkSite, setAiLinkSite] = $8T3gX.useState(false);
    const deleteSiteText = /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cye0Y))), {
                fontSize: "small"
            }),
            "\xa0DELETE Site"
        ]
    });
    const ref = $8T3gX.useRef(null);
    const isMountedRef = $8T3gX.useRef(true);
    const [armedStatus, setArmedStatus] = $8T3gX.useState(false);
    const [recordingServerData, setRecordingServerData] = $8T3gX.useState({});
    const [recordingServerPatchObject, setRecordingServerPatchObject] = $8T3gX.useState({});
    const [recordingServerChangesMade, setRecordingServerChangesMade] = $8T3gX.useState(false);
    const [recordingServerVisible, setRecordingServerVisible] = $8T3gX.useState(false);
    const [healthCheckData, setHealthCheckData] = $8T3gX.useState({});
    const [cameraHealthPatchObject, setCameraHealthPatchObject] = $8T3gX.useState({});
    const [cameraHealthChangesMade, setCameraHealthChangesMade] = $8T3gX.useState(false);
    const [camerasRefreshing, setCamerasRefreshing] = $8T3gX.useState(false);
    const [addCameraHealthDialogOpen, setAddCameraHealthDialogOpen] = $8T3gX.useState(false);
    const [turnOffHealthDialogOpen, setTurnOffHealthDialogOpen] = $8T3gX.useState(false);
    const [cameraCheckAlertOpen, setCameraCheckAlertOpen] = $8T3gX.useState(localStorage.cameraCheckAlertOpen === "true");
    const [activateSiteWithScheduleDialogOpen, setActivateSiteWithScheduleDialogOpen] = $8T3gX.useState(false);
    const [armSiteFlexScheduleDialogOpen, setArmSiteFlexScheduleDialogOpen] = $8T3gX.useState(false);
    // Flex picker flavor (ENG-1404): AutoPatrol reboots also go through the
    // shared dialogs, so thread the same arm/reboot flavor state.
    const [armSiteFlexScheduleDialogAction, setArmSiteFlexScheduleDialogAction] = $8T3gX.useState("arm");
    const [disarmSiteFlexScheduleDialogOpen, setDisarmSiteFlexScheduleDialogOpen] = $8T3gX.useState(false);
    const [initialApFlexPresetSyncComplete, setInitialApFlexPresetSyncComplete] = $8T3gX.useState(false);
    const initialApFlexPresetSyncKeyRef = $8T3gX.useRef("");
    const { resetSiteAboutState: resetSiteAboutState, getHealthCheckMetricsData: getHealthCheckMetricsData, prefetchSiteMetricsSimplified: prefetchSiteMetricsSimplified, backdropLoadingScreenOnEditingSchedule: backdropLoadingScreenOnEditingSchedule, autoPatrolSchedules: autoPatrolSchedules, setAutoPatrolFlexIgnoreZonesEnabledForSite: setAutoPatrolFlexIgnoreZonesEnabledForSite, setAutoPatrolFlexIgnoreZonesPresetsForCamera: setAutoPatrolFlexIgnoreZonesPresetsForCamera, setAutoPatrolFlexIgnoreZonesSelectedPresetForScheduleCamera: setAutoPatrolFlexIgnoreZonesSelectedPresetForScheduleCamera } = (0, $3FJ79.useSiteAboutStore)();
    const { flags: flags } = (0, $4PFLW.useFeatureFlag)();
    const showAutoPatrolFlexIgnoreZones = flags.showAutoPatrolFlexIgnoreZones === true;
    const autoPatrolOnlySchedules = $8T3gX.useMemo(()=>autoPatrolSchedules.filter((schedule)=>schedule?.patrolType === "AutoPatrol"), [
        autoPatrolSchedules
    ]);
    const handleSiteLoadPhase = $8T3gX.useCallback((phase, progress)=>{
        if (phase === "site-metadata") {
            setLoadProgressPercent(25);
            setLoadProgressMessage("Loading site fields...");
            return;
        }
        if (phase === "site-extra-fields") {
            setLoadProgressPercent(45);
            setLoadProgressMessage("Loading cameras...");
            return;
        }
        if (phase === "site-cameras") {
            setLoadProgressPercent(70);
            setLoadProgressMessage("Loading camera details...");
            return;
        }
        if (phase === "camera-row-prefetch-start") {
            const total = progress?.total ?? 0;
            setLoadProgressPercent(74);
            setLoadProgressMessage(total > 0 ? `Loading camera details (0/${total})...` : "Loading camera details...");
            return;
        }
        if (phase === "camera-row-prefetch-progress") {
            const completed = progress?.completed ?? 0;
            const total = progress?.total ?? 0;
            const ratio = total > 0 ? completed / total : 1;
            const clampedRatio = Math.max(0, Math.min(1, ratio));
            const percent = 74 + Math.round(clampedRatio * 8);
            setLoadProgressPercent(percent);
            setLoadProgressMessage(total > 0 ? `Loading camera details (${completed}/${total})...` : "Saving camera details...");
            return;
        }
        if (phase === "camera-row-prefetch-complete") {
            setLoadProgressPercent(82);
            setLoadProgressMessage("Loaded per-camera details...");
            return;
        }
        setLoadProgressPercent(85);
        setLoadProgressMessage("Loaded schedules and health data...");
    }, []);
    $8T3gX.useEffect(()=>{
        isMountedRef.current = true;
        setInitialApFlexPresetSyncComplete(false);
        initialApFlexPresetSyncKeyRef.current = "";
        setLoadProgressPercent(5);
        setLoadProgressMessage("Loading site data...");
        resetSiteAboutState();
        (0, $aMH8L.handleGetAllData)($ca79525154695a8a$export$f5172043e17f66eb(location.href), navigate, setSiteInfo, setSiteSchedules, setSiteCameras, setActiveTab, setDataLoaded, setBackdropLoadingScreenOn, setAllSiteSchedules, setVmsVariables, setNoAutoAddCamerasDialogOpen, setArmedStatus, setAiLinkSite, setSiteDeployed, ()=>{}, setAlertState, setCamerasNotDeployed, ()=>{}, ()=>{}, setPatchObject, ()=>{}, setRecordingServerData, setRecordingServerPatchObject, setRecordingServerVisible, setHealthCheckData, setWebhooksInfo, setWebhooksPatchObject, ()=>isMountedRef.current, handleSiteLoadPhase);
        getHealthCheckMetricsData(navigate, $ca79525154695a8a$export$f5172043e17f66eb(location.href));
        prefetchSiteMetricsSimplified?.(navigate, $ca79525154695a8a$export$f5172043e17f66eb(location.href));
        localStorage.setItem("schedulesIndex", "0");
        localStorage.setItem("clickedSchedulesTab", "one");
        let cameraCheckTimerId;
        if (localStorage.cameraCheckAlertOpen === "true") cameraCheckTimerId = setTimeout(()=>{
            if (isMountedRef.current) {
                setCameraCheckAlertOpen(false);
                localStorage.setItem("cameraCheckAlertOpen", "false");
            }
        }, 10000);
        return ()=>{
            isMountedRef.current = false;
            if (cameraCheckTimerId !== undefined) clearTimeout(cameraCheckTimerId);
        };
    }, []);
    $8T3gX.useEffect(()=>{
        const siteIdFromUrl = $ca79525154695a8a$export$f5172043e17f66eb(location.href);
        const handleRefreshSiteCamerasTable = ()=>{
            const AxiosUI = (0, $195EM.createApi)("");
            AxiosUI.get(`camera/site/?customer__id=${siteIdFromUrl}`).then((response)=>{
                localStorage.setItem("siteCameras", JSON.stringify(response.data));
                setSiteCameras(response.data);
            });
        };
        window.addEventListener("refreshSiteCamerasTable", handleRefreshSiteCamerasTable);
        return ()=>{
            window.removeEventListener("refreshSiteCamerasTable", handleRefreshSiteCamerasTable);
        };
    }, []);
    const setScrollTop = (event)=>{
        localStorage.setItem("siteAboutScrollTop", event.target.scrollTop);
    };
    $8T3gX.useEffect(()=>{
        if (ref) setTimeout(()=>{
            if (ref.current !== null) ref.current.scrollTop = localStorage.siteAboutScrollTop;
        }, 500);
    }, [
        backdropLoadingScreenOn
    ]);
    $8T3gX.useEffect(()=>{
        localStorage.setItem("navigatedFromSitesAboutPage", "true");
        localStorage.setItem("allSiteSchedulesBackup", JSON.stringify(siteSchedules));
    }, []);
    $8T3gX.useEffect(()=>{
        if (!dataLoaded) {
            setInitialApFlexPresetSyncComplete(false);
            initialApFlexPresetSyncKeyRef.current = "";
            return;
        }
        if (!showAutoPatrolFlexIgnoreZones || !siteInfo?.id) {
            setInitialApFlexPresetSyncComplete(true);
            setLoadProgressPercent(100);
            setLoadProgressMessage("Finalizing...");
            return;
        }
        if (autoPatrolOnlySchedules.length === 0) {
            setInitialApFlexPresetSyncComplete(true);
            setLoadProgressPercent(100);
            setLoadProgressMessage("Finalizing...");
            return;
        }
        const siteId = Number(siteInfo.id);
        const syncKey = `${siteId}:${autoPatrolOnlySchedules.map((schedule)=>Number(schedule.id)).join(",")}`;
        if (initialApFlexPresetSyncKeyRef.current === syncKey) return;
        initialApFlexPresetSyncKeyRef.current = syncKey;
        const shouldCompleteInitialLoad = !initialApFlexPresetSyncComplete;
        if (shouldCompleteInitialLoad) {
            setLoadProgressPercent(90);
            setLoadProgressMessage("Loading flex schedule presets...");
        }
        (async ()=>{
            const { autoPatrolFlexIgnoreZonesPresetsByCamera: currentPresetsByCamera } = (0, $3FJ79.useSiteAboutStore).getState();
            try {
                await (0, $8UhTy.syncAutoPatrolFlexIgnoreZonesFromApi)({
                    siteId: siteId,
                    schedules: autoPatrolOnlySchedules,
                    existingPresetsByCamera: currentPresetsByCamera,
                    setEnabledForSite: setAutoPatrolFlexIgnoreZonesEnabledForSite,
                    setPresetsForCamera: setAutoPatrolFlexIgnoreZonesPresetsForCamera,
                    setSelectedPresetForScheduleCamera: setAutoPatrolFlexIgnoreZonesSelectedPresetForScheduleCamera
                });
            } finally{
                if (isMountedRef.current) {
                    if (shouldCompleteInitialLoad) {
                        setLoadProgressPercent(100);
                        setLoadProgressMessage("Finalizing...");
                    }
                    setInitialApFlexPresetSyncComplete(true);
                }
            }
        })();
    }, [
        dataLoaded,
        showAutoPatrolFlexIgnoreZones,
        siteInfo?.id,
        autoPatrolOnlySchedules,
        setAutoPatrolFlexIgnoreZonesEnabledForSite,
        setAutoPatrolFlexIgnoreZonesPresetsForCamera,
        setAutoPatrolFlexIgnoreZonesSelectedPresetForScheduleCamera,
        initialApFlexPresetSyncComplete
    ]);
    const waitForInitialAutoPatrolFlexSync = dataLoaded && showAutoPatrolFlexIgnoreZones && autoPatrolOnlySchedules.length > 0 && !initialApFlexPresetSyncComplete;
    // Set Schedules tab as default for autopatrol sites
    $8T3gX.useEffect(()=>{
        if (siteInfo?.integration_type_name === "autopatrol") {
            setClickedTab("three");
            setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $2uQ4j.SchedulesTab), {
                siteInfo: siteInfo
            }));
        }
    }, [
        siteInfo?.integration_type_name
    ]);
    const navigate = (0, $3T949.useNavigate)();
    // AutoPatrol-specific breadcrumb navigation to /sites_patrol
    const handleSiteBreadcrumbClick = (event)=>{
        event.preventDefault();
        localStorage.setItem("siteAboutScrollTop", "0");
        localStorage.setItem("expandedObjectSaved", "false");
        localStorage.setItem("navigatedFromSitesAboutPage", "true");
        localStorage.setItem("level0Click", "true");
        localStorage.setItem("sitesTablePage", "0");
        localStorage.setItem("storedSelectedIndex", JSON.stringify({
            level1: [],
            level2: [],
            level3: [],
            level4: [],
            level5: [],
            level6: []
        }));
        // AutoPatrol sites navigate to /sites_patrol
        navigate("/sites_patrol");
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                children: [
                    cameraCheckAlertOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                        severity: "info",
                        onClose: ()=>{
                            setCameraCheckAlertOpen(false);
                            localStorage.setItem("cameraCheckAlertOpen", "false");
                        },
                        children: "Camera check is running in the background. This may take a few minutes. You will be alerted when it is complete. Please do not close your window or refresh any page until the check has been completed."
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $7FIuT.SiteAboutDialogs), {
                        setDeleteScheduleDialogOpen: ()=>{},
                        setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                        setAllSiteSchedules: setAllSiteSchedules,
                        setSiteInfo: setSiteInfo,
                        editMode: editMode,
                        setActiveTab: setActiveTab,
                        siteInfo: siteInfo,
                        setScheduleChangesMade: setScheduleChangesMade,
                        rebootDialogOpen: rebootDialogOpen,
                        setRebootDialogOpen: setRebootDialogOpen,
                        setAlertState: setAlertState,
                        activateSiteDialogOpen: activateSiteDialogOpen,
                        setActivateSiteDialogOpen: setActivateSiteDialogOpen,
                        setPatchObject: setPatchObject,
                        patchObject: patchObject,
                        deactivateSiteDialogOpen: deactivateSiteDialogOpen,
                        setDeactivateSiteDialogOpen: setDeactivateSiteDialogOpen,
                        deativateInquiryDialogOpen: deativateInquiryDialogOpen,
                        setDeativateInquiryDialogOpen: setDeativateInquiryDialogOpen,
                        disarmDialogOpen: disarmDialogOpen,
                        setDisarmDialogOpen: setDisarmDialogOpen,
                        armDialogOpen: armDialogOpen,
                        setArmDialogOpen: setArmDialogOpen,
                        deleteSiteDialogOpen: deleteSiteDialogOpen,
                        setDeleteSiteDialogOpen: setDeleteSiteDialogOpen,
                        navigate: navigate,
                        setSyncNeeded: ()=>{},
                        noAutoAddCamerasDialogOpen: noAutoAddCamerasDialogOpen,
                        setNoAutoAddCamerasDialogOpen: setNoAutoAddCamerasDialogOpen,
                        setArmedStatus: setArmedStatus,
                        setArmButtonDisabled: ()=>{},
                        setEditMode: setEditMode,
                        clickedTab: clickedTab,
                        vmsVariables: vmsVariables,
                        siteSchedules: siteSchedules,
                        setSiteSchedules: setSiteSchedules,
                        addCameraHealthDialogOpen: addCameraHealthDialogOpen,
                        setAddCameraHealthDialogOpen: setAddCameraHealthDialogOpen,
                        healthCheckData: healthCheckData,
                        setCameraHealthPatchObject: setCameraHealthPatchObject,
                        setCameraHealthChangesMade: setCameraHealthChangesMade,
                        setHealthCheckData: setHealthCheckData,
                        turnOffHealthDialogOpen: turnOffHealthDialogOpen,
                        setTurnOffHealthDialogOpen: setTurnOffHealthDialogOpen,
                        permissions: permissions,
                        activateSiteWithScheduleDialogOpen: activateSiteWithScheduleDialogOpen,
                        setActivateSiteWithScheduleDialogOpen: setActivateSiteWithScheduleDialogOpen,
                        armSiteFlexScheduleDialogOpen: armSiteFlexScheduleDialogOpen,
                        setArmSiteFlexScheduleDialogOpen: setArmSiteFlexScheduleDialogOpen,
                        armSiteFlexScheduleDialogAction: armSiteFlexScheduleDialogAction,
                        setArmSiteFlexScheduleDialogAction: setArmSiteFlexScheduleDialogAction,
                        disarmSiteFlexScheduleDialogOpen: disarmSiteFlexScheduleDialogOpen,
                        setDisarmSiteFlexScheduleDialogOpen: setDisarmSiteFlexScheduleDialogOpen,
                        setToolTipTitle: ()=>{}
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $9OjJ7.SiteAboutAlerts), {
                        siteDeployed: siteDeployed,
                        aiLinkSite: aiLinkSite,
                        setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                        setSyncNeeded: ()=>{},
                        setAlertState: setAlertState,
                        siteInfo: siteInfo,
                        setSiteInfo: setSiteInfo,
                        setAllSiteSchedules: setAllSiteSchedules,
                        setActiveTab: setActiveTab,
                        vmsVariables: vmsVariables,
                        setSiteDeployed: setSiteDeployed,
                        setDeativateInquiryDialogOpen: setDeativateInquiryDialogOpen,
                        setSiteCameras: setSiteCameras,
                        camerasNotDeployed: camerasNotDeployed,
                        setCamerasNotDeployed: setCamerasNotDeployed,
                        navigate: navigate,
                        setVmsVariables: setVmsVariables,
                        alertState: alertState,
                        setEditMode: setEditMode,
                        setClickedTab: setClickedTab,
                        setArmButtonDisabled: ()=>{},
                        setArmedStatus: setArmedStatus,
                        setRebootDialogOpen: setRebootDialogOpen
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                        openState: backdropLoadingScreenOn || waitForInitialAutoPatrolFlexSync,
                        progressPercent: loadProgressPercent,
                        message: loadProgressMessage
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                        openState: backdropLoadingScreenOnEditingSchedule
                    }),
                    dataLoaded && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "bg-actuate-grey absolute w-full h-full overflow-scroll",
                        onScroll: setScrollTop,
                        ref: ref,
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: !navBarCollapsed ? "absolute top-[15px] left-[150px] right-0 h-[59px] bg-white min-w-[1370px]" : "absolute top-[15px] left-[75px] right-0 h-[59px] bg-white min-w-[1370px]",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "absolute top-[16px] left-[30px] right-[650px] overflow-x-auto",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $77F6P.BreadCrumbsComponet), {
                                                linksArray: (0, $6wUjC.createLinksArray)(siteInfo.breadcrumb_info),
                                                handleClick: handleSiteBreadcrumbClick,
                                                styling: "",
                                                breadcrumb_info: siteInfo.breadcrumb_info,
                                                siteInfo: siteInfo
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $2SHRA.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                    className: "absolute right-[390px] top-[15px] flex",
                                                    children: [
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                            className: "text-[16px] font-mulish",
                                                            children: "Armed"
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                            className: "ml-2",
                                                            children: armedStatus ? (0, $lWchQ.checkedCircleIcon) : (0, $2aMB5.cancelIconRed)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                    className: "absolute right-[535px] top-[15px] flex",
                                                    children: [
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                            className: "text-[16px] font-mulish",
                                                            children: "Active"
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                            className: "ml-2",
                                                            children: siteInfo.active ? (0, $lWchQ.checkedCircleIcon) : (0, $2aMB5.cancelIconRed)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "absolute top-[11px] right-52",
                                                    children: permissions.delete_cameras && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                        onClick: ()=>setDeleteSiteDialogOpen(true),
                                                        text: deleteSiteText,
                                                        disabled: false
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: !navBarCollapsed ? "absolute top-[93px] left-[150px] right-[1px] h-[60px] min-w-[1370px] bg-white" : "absolute top-[93px] left-[75px] right-[1px] h-[60px] min-w-[1370px] bg-white",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "font-black font-mulish text-[20px] pt-3  indent-[15px]",
                                            children: "General Site Info"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: width > 1300 ? "absolute top-[12px] right-[20px]" : "absolute top-[12px] left-[1008px]",
                                            children: editMode && /*#__PURE__*/ (0, $k4ank.jsx)((0, $kHsF1.SaveChangesButton), {
                                                patchObject: patchObject,
                                                setEditMode: setEditMode,
                                                setSiteInfo: setSiteInfo,
                                                setPatchObject: setPatchObject,
                                                siteInfo: siteInfo,
                                                clickedTab: clickedTab,
                                                setActiveTab: setActiveTab,
                                                vmsVariables: vmsVariables,
                                                allSiteSchedules: allSiteSchedules,
                                                siteSchedules: siteSchedules,
                                                setAllSiteSchedules: setAllSiteSchedules,
                                                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                                                setAlertState: setAlertState,
                                                setSyncNeeded: ()=>{},
                                                editMode: editMode,
                                                setSchedulesTabActive: ()=>{},
                                                setClickedTab: setClickedTab,
                                                siteInfoChangesMade: siteInfoChangesMade,
                                                setSiteInfoChangesMade: setSiteInfoChangesMade,
                                                scheduleChangesMade: scheduleChangesMade,
                                                setScheduleChangesMade: setScheduleChangesMade,
                                                setDeleteScheduleDialogOpen: ()=>{},
                                                setSiteSchedules: setSiteSchedules,
                                                setArmButtonDisabled: ()=>{},
                                                recordingServerChangesMade: recordingServerChangesMade,
                                                recordingServerData: recordingServerData,
                                                recordingServerPatchObject: recordingServerPatchObject,
                                                setRecordingServerData: setRecordingServerData,
                                                setRecordingServerPatchObject: setRecordingServerPatchObject,
                                                setRecordingServerChangesMade: setRecordingServerChangesMade,
                                                cameraHealthChangesMade: cameraHealthChangesMade,
                                                healthCheckData: healthCheckData,
                                                setHealthCheckData: setHealthCheckData,
                                                cameraHealthPatchObject: cameraHealthPatchObject,
                                                setCameraHealthPatchObject: setCameraHealthPatchObject,
                                                setCameraHealthChangesMade: setCameraHealthChangesMade,
                                                setArmedStatus: setArmedStatus,
                                                webhooksChangesMade: webhooksChangesMade,
                                                webhooksInfo: webhooksInfo,
                                                setWebhooksInfo: setWebhooksInfo,
                                                webhooksPatchObject: webhooksPatchObject,
                                                setWebhooksPatchObject: setWebhooksPatchObject,
                                                setWebhooksChangesMade: setWebhooksChangesMade,
                                                setDeactivateSiteInsteadDialogOpen: ()=>{},
                                                setActivateSiteWithScheduleDialogOpen: setActivateSiteWithScheduleDialogOpen,
                                                wireguardChangesMade: wireguardChangesMade,
                                                wireGuardEditSessionRef: wireGuardEditSessionRef,
                                                setWireguardTunnels: setWireguardTunnels,
                                                setWireguardChangesMade: setWireguardChangesMade,
                                                wireguardTunnels: wireguardTunnels,
                                                wireguardTunnelsLoading: wireguardTunnelsLoading,
                                                selectedWireguardTunnelId: selectedWireguardTunnelId,
                                                setSelectedWireguardTunnelId: setSelectedWireguardTunnelId
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: width > 1300 ? "absolute top-[12px] right-[200px]" : "absolute top-[12px] left-[878px]",
                                            children: editMode && /*#__PURE__*/ (0, $k4ank.jsx)((0, $bPE00.CancelButton), {
                                                setEditMode: setEditMode,
                                                clickedTab: clickedTab,
                                                setActiveTab: setActiveTab,
                                                siteInfo: siteInfo,
                                                setRecordingServerPatchObject: setRecordingServerPatchObject,
                                                healthCheckData: healthCheckData,
                                                webhooksInfo: webhooksInfo,
                                                siteInfoBackup: siteInfoBackup,
                                                setSiteInfo: setSiteInfo,
                                                vmsVariablesBackup: vmsVariablesBackup,
                                                setVmsVariables: setVmsVariables,
                                                wireguardTunnels: wireguardTunnels,
                                                wireguardTunnelsLoading: wireguardTunnelsLoading,
                                                selectedWireguardTunnelId: selectedWireguardTunnelId,
                                                setSelectedWireguardTunnelId: setSelectedWireguardTunnelId,
                                                clearWireGuardEditSession: ()=>{
                                                    wireGuardEditSessionRef.current = null;
                                                },
                                                setWireguardChangesMade: setWireguardChangesMade
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: !navBarCollapsed ? "absolute top-[148px] left-[150px] right-[1px] h-[17vh] min-w-[1370px]" : "absolute top-[148px] left-[75px] right-[1px] h-[17vh] min-w-[1370px]",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $1W2ma.GeneralInfoTabAutoPatrol), {
                                            editMode: editMode
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "flex w-full gap-4 overflow-hidden pt-[5px]",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "min-w-0 flex-[2]",
                                                    children: !camerasRefreshing && /*#__PURE__*/ (0, $k4ank.jsx)((0, $h1wcZ.SiteCamerasTableAutoPatrol), {
                                                        setAlertState: setAlertState,
                                                        siteCameras: siteCameras,
                                                        setSiteCameras: setSiteCameras,
                                                        setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                                                        setNoAutoAddCamerasDialogOpen: setNoAutoAddCamerasDialogOpen,
                                                        siteInfo: siteInfo,
                                                        setSiteInfo: setSiteInfo,
                                                        setSiteSchedules: setSiteSchedules,
                                                        setActiveTab: setActiveTab,
                                                        setDataLoaded: setDataLoaded,
                                                        setAllSiteSchedules: setAllSiteSchedules,
                                                        setVmsVariables: setVmsVariables,
                                                        setArmedStatus: setArmedStatus,
                                                        setAiLinkSite: setAiLinkSite,
                                                        setSiteDeployed: setSiteDeployed,
                                                        setCamerasNotDeployed: setCamerasNotDeployed,
                                                        setToolTipTitle: ()=>{},
                                                        setConfigureMotion: ()=>{},
                                                        setPatchObject: setPatchObject,
                                                        setArmButtonDisabled: ()=>{},
                                                        setRecordingServerData: setRecordingServerData,
                                                        setRecordingServerPatchObject: setRecordingServerPatchObject,
                                                        setRecordingServerVisible: setRecordingServerVisible,
                                                        setHealthCheckData: setHealthCheckData,
                                                        setCamerasRefreshing: setCamerasRefreshing,
                                                        permissions: permissions,
                                                        setWebhooksInfo: setWebhooksInfo,
                                                        setWebhooksPatchObject: setWebhooksPatchObject,
                                                        siteSchedules: siteSchedules
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "min-w-0 flex-[3]",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $5zfN2.SchedulesTabAutopatrol), {
                                                        editMode: schedulesEditMode,
                                                        permissions: permissions,
                                                        onEditSchedulesClick: ()=>(0, $ffVZD.handleEditSchedulesClick)(setSchedulesEditMode),
                                                        onSaveSchedulesClick: ()=>(0, $hTYVM.saveAutoPatrolSchedulesOnly)(navigate, ()=>setSchedulesEditMode(false)),
                                                        onCancelSchedulesClick: ()=>(0, $ffVZD.handleCancelSchedulesClick)(setSchedulesEditMode)
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "justify-start",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jVN1H.NavBar), {
                    navBarCollapsed: navBarCollapsed,
                    setNavBarCollapsed: setNavBarCollapsed,
                    props: {}
                })
            })
        ]
    });
};

});
parcelRegister("h1wcZ", function(module, exports) {

$parcel$export(module.exports, "SiteCamerasTableAutoPatrol", () => $8f4009d1c54f4dbc$export$32417761ae4d954d);
/* eslint-disable react-hooks/exhaustive-deps */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $dBDyu = parcelRequire("dBDyu");

var $996Hf = parcelRequire("996Hf");

var $3FJ79 = parcelRequire("3FJ79");
const $8f4009d1c54f4dbc$export$32417761ae4d954d = ({ setAlertState: setAlertState, siteCameras: siteCameras, setSiteCameras: setSiteCameras, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setNoAutoAddCamerasDialogOpen: setNoAutoAddCamerasDialogOpen, siteInfo: siteInfo, setSiteInfo: setSiteInfo, setSiteSchedules: setSiteSchedules, setActiveTab: setActiveTab, setDataLoaded: setDataLoaded, setAllSiteSchedules: setAllSiteSchedules, setVmsVariables: setVmsVariables, setArmedStatus: setArmedStatus, setAiLinkSite: setAiLinkSite, setSiteDeployed: setSiteDeployed, setCamerasNotDeployed: setCamerasNotDeployed, setToolTipTitle: setToolTipTitle, setConfigureMotion: setConfigureMotion, setPatchObject: setPatchObject, setArmButtonDisabled: setArmButtonDisabled, setRecordingServerData: setRecordingServerData, setRecordingServerPatchObject: setRecordingServerPatchObject, setRecordingServerVisible: setRecordingServerVisible, setHealthCheckData: setHealthCheckData, setCamerasRefreshing: setCamerasRefreshing, permissions: permissions, setWebhooksInfo: setWebhooksInfo, setWebhooksPatchObject: setWebhooksPatchObject, siteSchedules: siteSchedules })=>{
    const [selected, setSelected] = $8T3gX.useState([]);
    const navigate = (0, $3T949.useNavigate)();
    const { autopatrolCamerasTablePage: autopatrolCamerasTablePage, autopatrolCamerasTableRowsPerPage: autopatrolCamerasTableRowsPerPage, setAutopatrolCamerasTablePage: setAutopatrolCamerasTablePage, setAutopatrolCamerasTableRowsPerPage: setAutopatrolCamerasTableRowsPerPage } = (0, $3FJ79.useSiteAboutStore)();
    $8T3gX.useEffect(()=>{
        const currentIds = new Set(siteCameras.results.map((camera)=>String(camera.id)));
        setSelected((prevSelected)=>prevSelected.filter((id)=>currentIds.has(String(id))));
    }, [
        siteCameras.results
    ]);
    $8T3gX.useEffect(()=>{
        setSelected([]);
        setAutopatrolCamerasTablePage(0);
        setAutopatrolCamerasTableRowsPerPage(5);
    }, [
        siteInfo.id
    ]);
    const hasCameras = siteCameras.results && siteCameras.results.length > 0;
    const setPage = $8T3gX.useCallback((value)=>{
        setAutopatrolCamerasTablePage(typeof value === "function" ? value(autopatrolCamerasTablePage) : value);
    }, [
        autopatrolCamerasTablePage,
        setAutopatrolCamerasTablePage
    ]);
    const setRowsPerPage = $8T3gX.useCallback((value)=>{
        setAutopatrolCamerasTableRowsPerPage(typeof value === "function" ? value(autopatrolCamerasTableRowsPerPage) : value);
    }, [
        autopatrolCamerasTableRowsPerPage,
        setAutopatrolCamerasTableRowsPerPage
    ]);
    const handleSingleCheckboxClick = (_event, id)=>{
        const idStr = String(id);
        const selectedIndex = selected.indexOf(idStr);
        let newSelected = [];
        if (selectedIndex === -1) newSelected = newSelected.concat(selected, idStr);
        else if (selectedIndex === 0) newSelected = newSelected.concat(selected.slice(1));
        else if (selectedIndex === selected.length - 1) newSelected = newSelected.concat(selected.slice(0, -1));
        else if (selectedIndex > 0) newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        setSelected(newSelected);
    };
    const isSelected = (id)=>selected.indexOf(String(id)) !== -1;
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
        children: hasCameras ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $996Hf.CamerasTableAutoPatrol), {
            navigate: navigate,
            siteCameras: siteCameras,
            page: autopatrolCamerasTablePage,
            rowsPerPage: autopatrolCamerasTableRowsPerPage,
            selected: selected,
            isSelected: isSelected,
            handleSingleCheckboxClick: handleSingleCheckboxClick,
            setSelected: setSelected,
            setPage: setPage,
            setRowsPerPage: setRowsPerPage,
            setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
            setNoAutoAddCamerasDialogOpen: setNoAutoAddCamerasDialogOpen,
            siteInfo: siteInfo,
            setSiteInfo: setSiteInfo,
            setSiteSchedules: setSiteSchedules,
            setActiveTab: setActiveTab,
            setDataLoaded: setDataLoaded,
            setAllSiteSchedules: setAllSiteSchedules,
            setVmsVariables: setVmsVariables,
            setArmedStatus: setArmedStatus,
            setAiLinkSite: setAiLinkSite,
            setSiteDeployed: setSiteDeployed,
            setCamerasNotDeployed: setCamerasNotDeployed,
            setToolTipTitle: setToolTipTitle,
            setConfigureMotion: setConfigureMotion,
            setPatchObject: setPatchObject,
            setArmButtonDisabled: setArmButtonDisabled,
            setRecordingServerData: setRecordingServerData,
            setRecordingServerPatchObject: setRecordingServerPatchObject,
            setRecordingServerVisible: setRecordingServerVisible,
            setHealthCheckData: setHealthCheckData,
            setCamerasRefreshing: setCamerasRefreshing,
            permissions: permissions,
            setWebhooksInfo: setWebhooksInfo,
            setWebhooksPatchObject: setWebhooksPatchObject,
            siteSchedules: siteSchedules,
            setSiteCameras: setSiteCameras,
            setAlertState: setAlertState
        }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $dBDyu.NoCameras), {
            navigate: navigate,
            setNoAutoAddCamerasDialogOpen: setNoAutoAddCamerasDialogOpen
        })
    });
};

});
parcelRegister("996Hf", function(module, exports) {

$parcel$export(module.exports, "CamerasTableAutoPatrol", () => $ad44a3716874e549$export$9739c61d9922ed1c);
/* eslint-disable react-hooks/exhaustive-deps */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $1wcxl = parcelRequire("1wcxl");

var $4reBM = parcelRequire("4reBM");

var $f3puC = parcelRequire("f3puC");

var $b9p11 = parcelRequire("b9p11");

var $faP87 = parcelRequire("faP87");

var $a65wX = parcelRequire("a65wX");
var $60vL1 = parcelRequire("60vL1");

var $kbChx = parcelRequire("kbChx");

var $iKAtE = parcelRequire("iKAtE");

var $e9rQm = parcelRequire("e9rQm");

var $g0plP = parcelRequire("g0plP");

var $daJc9 = parcelRequire("daJc9");

var $cVCJe = parcelRequire("cVCJe");

var $2mUkt = parcelRequire("2mUkt");

var $fIsAN = parcelRequire("fIsAN");

var $68w5E = parcelRequire("68w5E");

var $fWsn7 = parcelRequire("fWsn7");

var $cIfQ5 = parcelRequire("cIfQ5");

var $3f8Bb = parcelRequire("3f8Bb");

var $3FJ79 = parcelRequire("3FJ79");

var $hcX4E = parcelRequire("hcX4E");

var $eDfvp = parcelRequire("eDfvp");

var $ePwXE = parcelRequire("ePwXE");

var $eka8d = parcelRequire("eka8d");

var $kKBBF = parcelRequire("kKBBF");

var $4PFLW = parcelRequire("4PFLW");
const $ad44a3716874e549$export$9739c61d9922ed1c = ({ navigate: navigate, siteCameras: siteCameras, page: page, rowsPerPage: rowsPerPage, selected: selected, isSelected: isSelected, handleSingleCheckboxClick: handleSingleCheckboxClick, setSelected: setSelected, setPage: setPage, setRowsPerPage: setRowsPerPage, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setNoAutoAddCamerasDialogOpen: setNoAutoAddCamerasDialogOpen, siteInfo: siteInfo, setSiteInfo: setSiteInfo, setSiteSchedules: setSiteSchedules, setSiteCameras: setSiteCameras, setActiveTab: setActiveTab, setDataLoaded: setDataLoaded, setAllSiteSchedules: setAllSiteSchedules, setVmsVariables: setVmsVariables, setArmedStatus: setArmedStatus, setAiLinkSite: setAiLinkSite, setSiteDeployed: setSiteDeployed, setCamerasNotDeployed: setCamerasNotDeployed, setToolTipTitle: setToolTipTitle, setConfigureMotion: setConfigureMotion, setPatchObject: setPatchObject, setArmButtonDisabled: setArmButtonDisabled, setRecordingServerData: setRecordingServerData, setRecordingServerPatchObject: setRecordingServerPatchObject, setRecordingServerVisible: setRecordingServerVisible, setHealthCheckData: setHealthCheckData, setCamerasRefreshing: setCamerasRefreshing, permissions: permissions, setWebhooksInfo: setWebhooksInfo, setWebhooksPatchObject: setWebhooksPatchObject, siteSchedules: siteSchedules, setAlertState: setAlertState })=>{
    const [expandedObject, setExpandedObject] = $8T3gX.useState({});
    const [srcImages, setSrcImages] = $8T3gX.useState({});
    const [order, setOrder] = $8T3gX.useState("asc");
    const [orderBy, setOrderBy] = $8T3gX.useState("camera_name");
    const [renderedRows, setRenderedRows] = $8T3gX.useState(siteCameras.results);
    const [allExpanded, setAllExpanded] = $8T3gX.useState(false);
    const [expandedScheduleContext, setExpandedScheduleContext] = $8T3gX.useState({});
    const [count, setCount] = $8T3gX.useState(0);
    const [bulkUpdateDialogOpen, setBulkUpdateDialogOpen] = $8T3gX.useState(false);
    const { isFeatureEnabled: isFeatureEnabled } = (0, $4PFLW.useFeatureFlag)();
    const showBulkUpdating = isFeatureEnabled("showBulkUpdating", false);
    const { handleFilterCameras: handleFilterCameras, selectedAutoPatrolScheduleIndex: selectedAutoPatrolScheduleIndex, autoPatrolSchedules: autoPatrolSchedules, activeCameraProducts: activeCameraProducts, activeCameraProductsLoading: activeCameraProductsLoading, prefetchBulkDialogActiveCameraProducts: prefetchBulkDialogActiveCameraProducts } = (0, $3FJ79.useSiteAboutStore)();
    const handleRequestSort = (_event, property)=>{
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };
    const saveExpandedObject = (objectId)=>{
        const objectKey = String(objectId);
        setExpandedObject((previousState)=>{
            const isExpanding = !previousState[objectKey];
            if (isExpanding) {
                const selectedSchedule = autoPatrolSchedules[selectedAutoPatrolScheduleIndex];
                setExpandedScheduleContext((previousContext)=>({
                        ...previousContext,
                        [objectKey]: {
                            scheduleId: selectedSchedule?.id ?? null,
                            patrolType: selectedSchedule?.patrolType ?? null
                        }
                    }));
            } else setExpandedScheduleContext((previousContext)=>{
                const nextContext = {
                    ...previousContext
                };
                delete nextContext[objectKey];
                return nextContext;
            });
            return {
                ...previousState,
                [objectKey]: isExpanding
            };
        });
    };
    const saveExpandedObjectAllTrue = ()=>{
        const selectedSchedule = autoPatrolSchedules[selectedAutoPatrolScheduleIndex];
        setExpandedScheduleContext((previousContext)=>{
            const nextContext = {
                ...previousContext
            };
            siteCameras.results.forEach((camera)=>{
                nextContext[String(camera.id)] = {
                    scheduleId: selectedSchedule?.id ?? null,
                    patrolType: selectedSchedule?.patrolType ?? null
                };
            });
            return nextContext;
        });
        setExpandedObject((previousState)=>{
            const nextState = {
                ...previousState
            };
            Object.keys(nextState).forEach((key)=>{
                nextState[key] = true;
            });
            return nextState;
        });
    };
    const saveExpandedObjectAllFalse = ()=>{
        setExpandedScheduleContext({});
        setExpandedObject((previousState)=>{
            const nextState = {
                ...previousState
            };
            Object.keys(nextState).forEach((key)=>{
                nextState[key] = false;
            });
            return nextState;
        });
    };
    const handleChangePage = (_event, newPage)=>{
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event)=>{
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    $8T3gX.useEffect(()=>{
        siteCameras.results.forEach((object)=>{
            setExpandedObject((prev)=>({
                    ...prev,
                    [String(object.id)]: false
                }));
        });
    }, []);
    $8T3gX.useEffect(()=>{
        const filteredCameras = handleFilterCameras(siteCameras.results);
        setCount(filteredCameras.length);
        setRenderedRows(filteredCameras);
    }, [
        siteCameras,
        selectedAutoPatrolScheduleIndex
    ]);
    const cameraIdsSignature = $8T3gX.useMemo(()=>siteCameras?.results?.map((c)=>c.id).join(",") ?? "", [
        siteCameras?.results
    ]);
    const siteCamerasRef = $8T3gX.useRef(siteCameras);
    siteCamerasRef.current = siteCameras;
    $8T3gX.useEffect(()=>{
        if (!cameraIdsSignature) return;
        (0, $2mUkt.getAndSaveSiteImages)(siteCamerasRef.current, setSrcImages, navigate);
    }, [
        cameraIdsSignature,
        navigate
    ]);
    // activeCameraProducts for bulk dialog: prefetch uses /metric/simplified/ when possible, else general_info per camera.
    const visibleRows = $8T3gX.useMemo(()=>(0, $fWsn7.stableSort)(renderedRows, (0, $fWsn7.getComparator)(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage), [
        order,
        orderBy,
        page,
        rowsPerPage,
        renderedRows
    ]);
    const selectedCameras = $8T3gX.useMemo(()=>siteCameras.results.filter((camera)=>selected.includes(String(camera.id))).map((camera)=>({
                id: camera.id,
                camera_name: camera.camera_name
            })), [
        siteCameras.results,
        selected
    ]);
    const renderedRowIds = $8T3gX.useMemo(()=>renderedRows.map((camera)=>String(camera.id)), [
        renderedRows
    ]);
    const selectedInViewCount = $8T3gX.useMemo(()=>renderedRowIds.filter((id)=>selected.includes(id)).length, [
        renderedRowIds,
        selected
    ]);
    const handleSelectAllVisible = (event)=>{
        if (event.target.checked) {
            setSelected((prevSelected)=>{
                const existing = new Set(prevSelected.map(String));
                renderedRowIds.forEach((id)=>existing.add(id));
                return Array.from(existing);
            });
            return;
        }
        setSelected((prevSelected)=>prevSelected.filter((id)=>!renderedRowIds.includes(String(id))));
    };
    const openBulkUpdateDialog = ()=>{
        const selectedCameraIds = selected.map(Number);
        if (selectedCameraIds.length === 0) return;
        setBulkUpdateDialogOpen(true);
        prefetchBulkDialogActiveCameraProducts(navigate, siteInfo?.id, selectedCameraIds);
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4reBM.default), {
        sx: {
            width: "100%",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            minHeight: 0
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3Nm8Z.default), {
                sx: {
                    flex: 1,
                    minHeight: 0,
                    overflow: "auto"
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "relative",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                            sx: {
                                fontFamily: "Mulish",
                                fontWeight: "Bold",
                                paddingLeft: 2,
                                paddingTop: 1,
                                paddingBottom: 0.5
                            },
                            variant: "h6",
                            component: "div",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                                    component: "span",
                                    sx: {
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: 0.5
                                    },
                                    children: [
                                        "Site Cameras",
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                            title: "All configurations done at the camera level are global and apply to all schedules. These settings do not change per schedule.",
                                            placement: "top",
                                            sx: {
                                                fontSize: "15px",
                                                fontFamily: "Mulish"
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                                fontSize: "small"
                                            })
                                        })
                                    ]
                                }),
                                siteInfo.display_refresh && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "absolute left-[160px] top-[6px]",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                                        theme: (0, $faP87.theme),
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $a65wX.default), {
                                            type: "button",
                                            color: "primary",
                                            size: "small",
                                            onClick: ()=>{
                                                setBackdropLoadingScreenOn(true);
                                                setExpandedObject({});
                                                setExpandedScheduleContext({});
                                                setCamerasRefreshing(true);
                                                (0, $3f8Bb.handleRefreshCameras)(navigate, setSiteInfo, setSiteSchedules, setSiteCameras, setActiveTab, setDataLoaded, setBackdropLoadingScreenOn, setAllSiteSchedules, setVmsVariables, setNoAutoAddCamerasDialogOpen, setArmedStatus, setAiLinkSite, setSiteDeployed, ()=>{}, setAlertState, setCamerasNotDeployed, setToolTipTitle, setConfigureMotion, setPatchObject, setArmButtonDisabled, setRecordingServerData, setRecordingServerPatchObject, setRecordingServerVisible, setHealthCheckData, setCamerasRefreshing, setWebhooksInfo, setWebhooksPatchObject);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cIfQ5))), {
                                                    fontSize: "small"
                                                }),
                                                " \xa0 Refresh Previews"
                                            ]
                                        })
                                    })
                                }),
                                showBulkUpdating && permissions.edit_cameras && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "absolute right-[30px] top-[6px]",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                                        theme: (0, $faP87.theme),
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                            type: "button",
                                            color: "primary",
                                            size: "small",
                                            onClick: openBulkUpdateDialog,
                                            disabled: selected.length === 0,
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            children: "Bulk Update"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                        sx: {
                            width: "100%",
                            fontFamily: "Mulish"
                        },
                        "aria-label": "cameras table",
                        size: "small",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $68w5E.EnhancedCameraTableHeadAutoPatrol), {
                                onSelectAllClick: handleSelectAllVisible,
                                numSelected: selectedInViewCount,
                                rowCount: renderedRows.length,
                                showSelection: showBulkUpdating && permissions.edit_cameras,
                                onRequestSort: handleRequestSort,
                                orderBy: orderBy,
                                order: order,
                                allExpanded: allExpanded,
                                setAllExpanded: setAllExpanded,
                                setExpandedObject: setExpandedObject,
                                saveExpandedObjectAllTrue: saveExpandedObjectAllTrue,
                                saveExpandedObjectAllFalse: saveExpandedObjectAllFalse
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                children: visibleRows.map((obj)=>/*#__PURE__*/ (0, $k4ank.jsxs)($8T3gX.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                selected: isSelected(obj.id),
                                                children: [
                                                    showBulkUpdating && permissions.edit_cameras && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        padding: "checkbox",
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                            color: "primary",
                                                            checked: isSelected(obj.id),
                                                            onClick: (event)=>handleSingleCheckboxClick(event, obj.id)
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        sx: {
                                                            fontFamily: "Mulish",
                                                            fontSize: "14px",
                                                            paddingLeft: 2,
                                                            paddingRight: 1,
                                                            width: "40%",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap"
                                                        },
                                                        align: "left",
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                            title: srcImages[String(obj.id)] ? /*#__PURE__*/ (0, $k4ank.jsx)($8T3gX.Fragment, {
                                                                children: srcImages[String(obj.id)]
                                                            }) : "",
                                                            placement: "right-start",
                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                                                                to: `/sites/${siteInfo.id}/editcamera/${obj.id}`,
                                                                style: {
                                                                    color: "#0d47a1",
                                                                    textDecoration: "none",
                                                                    cursor: "pointer",
                                                                    whiteSpace: "nowrap"
                                                                },
                                                                onMouseEnter: (e)=>{
                                                                    e.currentTarget.style.color = "#002171";
                                                                    e.currentTarget.style.textDecoration = "underline";
                                                                },
                                                                onMouseLeave: (e)=>{
                                                                    e.currentTarget.style.color = "#0d47a1";
                                                                    e.currentTarget.style.textDecoration = "none";
                                                                },
                                                                children: obj.camera_name ?? "\u2014"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        sx: {
                                                            fontFamily: "Mulish",
                                                            fontSize: "14px",
                                                            paddingLeft: 1,
                                                            paddingRight: 1,
                                                            width: "40%",
                                                            whiteSpace: "normal",
                                                            wordBreak: "break-word"
                                                        },
                                                        align: "left",
                                                        children: activeCameraProductsLoading[obj.id] ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                                            size: 18,
                                                            color: "primary"
                                                        }) : activeCameraProducts[obj.id] === undefined ? /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                            style: {
                                                                color: "var(--mui-palette-text-secondary)"
                                                            },
                                                            children: "\u2014"
                                                        }) : (()=>{
                                                            const products = activeCameraProducts[obj.id];
                                                            const hasAny = (0, $hcX4E.ACTIVE_PRODUCTS_PARENT_CATEGORIES).some((parent)=>parent.children.some((name)=>products?.[name]));
                                                            if (!hasAny) return /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                                style: {
                                                                    color: "var(--mui-palette-text-secondary)"
                                                                },
                                                                children: "\u2014"
                                                            });
                                                            return /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                                                component: "span",
                                                                sx: {
                                                                    display: "inline-flex",
                                                                    alignItems: "center",
                                                                    gap: 0.75,
                                                                    flexWrap: "wrap"
                                                                },
                                                                children: (0, $hcX4E.ACTIVE_PRODUCTS_PARENT_CATEGORIES).map((parent)=>{
                                                                    const activeChildren = parent.children.filter((name)=>products?.[name]);
                                                                    if (activeChildren.length === 0) return null;
                                                                    const { Icon: Icon } = parent;
                                                                    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                                        title: activeChildren.join(", "),
                                                                        placement: "top",
                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                                                            component: "span",
                                                                            sx: {
                                                                                display: "inline-flex",
                                                                                lineHeight: 0
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)(Icon, {
                                                                                sx: {
                                                                                    color: parent.color,
                                                                                    fontSize: 28
                                                                                }
                                                                            })
                                                                        })
                                                                    }, parent.parentLabel);
                                                                })
                                                            });
                                                        })()
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "right",
                                                        sx: {
                                                            fontFamily: "Mulish",
                                                            fontSize: "14px",
                                                            paddingLeft: 1,
                                                            paddingRight: 2,
                                                            width: "20%",
                                                            whiteSpace: "nowrap"
                                                        },
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                                            "aria-label": expandedObject[String(obj.id)] ? "collapse row" : "expand row",
                                                            size: "small",
                                                            onClick: ()=>{
                                                                saveExpandedObject(String(obj.id));
                                                            },
                                                            children: expandedObject[String(obj.id)] ? /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g0plP))), {
                                                                fontSize: "large",
                                                                color: "primary"
                                                            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9rQm))), {
                                                                fontSize: "large",
                                                                color: "primary"
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $daJc9.CameraInfoRowAutoPatrol), {
                                                obj: obj,
                                                expanded: !!expandedObject[String(obj.id)],
                                                lockedScheduleId: expandedScheduleContext[String(obj.id)]?.scheduleId ?? null,
                                                lockedSchedulePatrolType: expandedScheduleContext[String(obj.id)]?.patrolType ?? null,
                                                showSelectionColumn: showBulkUpdating && permissions.edit_cameras,
                                                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                                                siteInfo: siteInfo,
                                                permissions: permissions,
                                                srcImages: srcImages
                                            })
                                        ]
                                    }, obj.id))
                            })
                        ]
                    })
                ]
            }),
            showBulkUpdating && /*#__PURE__*/ (0, $k4ank.jsx)((0, $eka8d.BulkUpdateProductsDialog), {
                open: bulkUpdateDialogOpen,
                selectedCameras: selectedCameras,
                activeCameraProducts: activeCameraProducts,
                activeCameraProductsLoading: activeCameraProductsLoading,
                siteInfo: siteInfo,
                navigate: navigate,
                productRows: (0, $kKBBF.AUTOPATROL_PRODUCT_BULK_ROWS),
                onClose: ()=>{
                    setBulkUpdateDialogOpen(false);
                    setSelected([]);
                },
                onApply: ()=>{
                    setBulkUpdateDialogOpen(false);
                    setSelected([]);
                }
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wcxl.default), {
                rowsPerPageOptions: [
                    5,
                    10,
                    25
                ],
                component: "div",
                count: count,
                rowsPerPage: rowsPerPage,
                page: page,
                onPageChange: handleChangePage,
                onRowsPerPageChange: handleChangeRowsPerPage
            })
        ]
    });
};

});
parcelRegister("daJc9", function(module, exports) {

$parcel$export(module.exports, "CameraInfoRowAutoPatrol", () => $9ed4f873f177218c$export$c767739621980c95);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $aVDw9 = parcelRequire("aVDw9");

var $4o6Cs = parcelRequire("4o6Cs");

var $eDfvp = parcelRequire("eDfvp");

var $60vL1 = parcelRequire("60vL1");

var $yndCB = parcelRequire("yndCB");

var $195EM = parcelRequire("195EM");

var $3n3uW = parcelRequire("3n3uW");

var $2suvB = parcelRequire("2suvB");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $3Zv1D = parcelRequire("3Zv1D");

var $kPQrn = parcelRequire("kPQrn");

var $83bsI = parcelRequire("83bsI");

var $3FJ79 = parcelRequire("3FJ79");

var $glcO0 = parcelRequire("glcO0");

var $7Ep9S = parcelRequire("7Ep9S");

var $4PFLW = parcelRequire("4PFLW");

var $64WJh = parcelRequire("64WJh");

var $jUxHc = parcelRequire("jUxHc");

var $2aMB5 = parcelRequire("2aMB5");

var $lWchQ = parcelRequire("lWchQ");

var $8UhTy = parcelRequire("8UhTy");

var $a2fXs = parcelRequire("a2fXs");
const $9ed4f873f177218c$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $9ed4f873f177218c$export$c767739621980c95 = ({ obj: obj, expanded: expanded, lockedScheduleId: lockedScheduleId, lockedSchedulePatrolType: lockedSchedulePatrolType, showSelectionColumn: showSelectionColumn, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, siteInfo: siteInfo, permissions: permissions, srcImages: srcImages })=>{
    const { vCHOnlySchedules: vCHOnlySchedules, activeCameraProducts: activeCameraProducts, activeCameraProductsLoading: activeCameraProductsLoading, cameraSlice: cameraSlice, autoPatrolSchedules: autoPatrolSchedules, selectedAutoPatrolScheduleIndex: selectedAutoPatrolScheduleIndex, autoPatrolFlexIgnoreZonesEnabledBySite: autoPatrolFlexIgnoreZonesEnabledBySite } = (0, $3FJ79.useSiteAboutStore)();
    const [metadataTagZones, setMetadataTagZones] = $8T3gX.useState([]);
    const [allIgnoreZones, setAllIgnoreZones] = $8T3gX.useState([]);
    const [visibleIgnoreZones, setVisibleIgnoreZones] = $8T3gX.useState([]);
    const [clickedTab, setClickedTab] = $8T3gX.useState("one");
    const [responseObject, setResponseObject] = $8T3gX.useState({
        // null until /camera/{id}/status/ answers, so an unloaded or failed row
        // shows "No data yet" and not a green tick it never earned (ENG-1782)
        connected: null,
        frame_since_launch: null,
        good_frame: null,
        blur_metric: 0,
        native_frame_rate: 0,
        frame_dimensions: "",
        last_motion: 0,
        preview_url: "",
        health_status: "",
        is_blurry: null,
        aspect_ratio: "",
        comments: "",
        camera_view: "",
        aspect_ratio_status: "unknown",
        frame_rate_status: "unknown",
        resolution_status: "unknown",
        camera_health_comments: "",
        camera_name: "",
        camera_start_time: 0,
        camera_view_comments: "",
        camera_view_status: "unknown",
        codec_status: "unknown",
        display_frame_since_launch: true,
        dynamic_slicing: false,
        id: 0,
        overall_status: "unknown"
    });
    const [dimensions, setDimensions] = $8T3gX.useState(null);
    const [previewLoadFailed, setPreviewLoadFailed] = $8T3gX.useState(false);
    const [previewRefreshRequested, setPreviewRefreshRequested] = $8T3gX.useState(false);
    const navigate = (0, $3T949.useNavigate)();
    const { flags: flags } = (0, $4PFLW.useFeatureFlag)();
    const viewEditMetadataTagZonesPage = flags.viewEditMetadataTagZonesPage;
    const showAutoPatrolFlexIgnoreZones = flags.showAutoPatrolFlexIgnoreZones === true;
    const selectedSchedule = autoPatrolSchedules[selectedAutoPatrolScheduleIndex];
    const selectedScheduleId = selectedSchedule?.id;
    const effectiveScheduleId = lockedScheduleId != null ? lockedScheduleId : selectedScheduleId ?? null;
    const effectivePatrolType = lockedSchedulePatrolType != null ? lockedSchedulePatrolType : selectedSchedule?.patrolType ?? null;
    const flexIgnoreZonesActive = showAutoPatrolFlexIgnoreZones && effectivePatrolType === "AutoPatrol" && !!siteInfo?.id && autoPatrolFlexIgnoreZonesEnabledBySite[siteInfo.id] === true;
    const aPICall = (navigate, id, obj, setResponseObject, setAllIgnoreZones)=>{
        const AxiosUI = (0, $195EM.createApi)(``);
        const retryFunction = ()=>{
            aPICall(navigate, id, obj, setResponseObject, setAllIgnoreZones);
        };
        AxiosUI.get(`/camera/${id}/status/`).then((response)=>{
            setResponseObject(response.data);
            localStorage.setItem("preview_url", JSON.stringify(response.data.preview_url));
            AxiosUI.get(`/camera/${obj.id}/ignore_zones/`).then((response)=>{
                const normalizedIgnoreZones = (0, $83bsI.addIgnoreLabel)(response.data);
                setAllIgnoreZones(normalizedIgnoreZones);
                // In flex preset mode, selected preset zones control the overlay.
                // Avoid overriding them when camera default zones return later.
                if (!flexIgnoreZonesActive) setVisibleIgnoreZones(normalizedIgnoreZones);
                localStorage.setItem("ignoreZones", JSON.stringify(normalizedIgnoreZones));
            }, (reason)=>{
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
            });
            AxiosUI.get(`tagzone/?camera=${id}`).then((response)=>{
                setMetadataTagZones(response.data.results);
            }, (reason)=>{
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
            });
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
        });
    };
    $8T3gX.useEffect(()=>{
        if (!expanded || !obj.id) return;
        aPICall(navigate, obj.id.toString(), obj, setResponseObject, setAllIgnoreZones);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- rerun when refreshed row data changes
    }, [
        expanded,
        obj.id,
        obj.has_ignore_zones,
        obj.preview_url
    ]);
    $8T3gX.useEffect(()=>{
        if (!flexIgnoreZonesActive) setVisibleIgnoreZones(allIgnoreZones);
    }, [
        flexIgnoreZonesActive,
        allIgnoreZones
    ]);
    const handleImageLoad = (event)=>{
        const { naturalWidth: naturalWidth, naturalHeight: naturalHeight } = event.currentTarget;
        setDimensions((0, $kPQrn.resizeImage)(naturalWidth, naturalHeight));
    };
    const resolvedPreviewUrl = (responseObject.preview_url || obj.preview_url || "").trim();
    const normalizeZonePolygons = $8T3gX.useCallback((coordinates)=>{
        if (!Array.isArray(coordinates) || coordinates.length === 0) return [];
        // API may return either a single polygon (number[][]) or many polygons (number[][][]).
        if (Array.isArray(coordinates[0]) && typeof coordinates[0][0] === "number") return [
            coordinates
        ];
        return coordinates;
    }, []);
    const ignoreZoneHoverEnabled = clickedTab === "one" && !!dimensions && !previewLoadFailed && !!resolvedPreviewUrl && visibleIgnoreZones.length > 0;
    $8T3gX.useEffect(()=>{
        setPreviewLoadFailed(false);
        setPreviewRefreshRequested(false);
    }, [
        resolvedPreviewUrl,
        expanded,
        obj.id
    ]);
    const refreshPreviewFromApi = $8T3gX.useCallback(()=>{
        if (!obj.id || previewRefreshRequested) return;
        setPreviewRefreshRequested(true);
        const AxiosUI = (0, $195EM.createApi)("");
        AxiosUI.get(`/camera/${obj.id}/status/`).then((response)=>{
            const nextPreview = (response.data?.preview_url || "").trim();
            setResponseObject((previousState)=>({
                    ...previousState,
                    ...response.data,
                    preview_url: nextPreview || previousState.preview_url
                }));
            if (nextPreview) setPreviewLoadFailed(false);
        }).catch(()=>{});
    }, [
        obj.id,
        previewRefreshRequested
    ]);
    if (!obj.id) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {});
    const showTabs = viewEditMetadataTagZonesPage && !vCHOnlySchedules;
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
            style: {
                paddingBottom: 0,
                paddingTop: 0
            },
            colSpan: showSelectionColumn ? 4 : 3,
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $yndCB.default), {
                in: expanded,
                timeout: "auto",
                unmountOnExit: true,
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                    sx: {
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "nowrap",
                        width: "100%",
                        minHeight: 0,
                        gap: 1,
                        py: 1,
                        alignItems: "flex-start"
                    },
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                            sx: {
                                flex: "0 1 50%",
                                minWidth: 0,
                                maxWidth: showTabs ? "50%" : "100%"
                            },
                            children: [
                                siteInfo.integration_type_name !== "ailink" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                    sx: {
                                        position: "relative",
                                        width: "100%",
                                        "& > img": {
                                            display: "block"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $a2fXs.IgnoreZonePreviewHoverLayer), {
                                        zones: visibleIgnoreZones,
                                        enabled: ignoreZoneHoverEnabled,
                                        children: [
                                            !previewLoadFailed && resolvedPreviewUrl && /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                                                src: resolvedPreviewUrl,
                                                style: {
                                                    width: "100%",
                                                    height: "auto",
                                                    maxWidth: "100%",
                                                    verticalAlign: "middle"
                                                },
                                                onLoad: handleImageLoad,
                                                onError: ()=>{
                                                    setPreviewLoadFailed(true);
                                                    refreshPreviewFromApi();
                                                },
                                                alt: "Camera preview"
                                            }),
                                            (previewLoadFailed || !resolvedPreviewUrl) && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "font-mulish text-[14px] text-gray-600",
                                                children: "Camera preview unavailable."
                                            }),
                                            dimensions && !previewLoadFailed && !!resolvedPreviewUrl && clickedTab === "one" && visibleIgnoreZones.flatMap((object, zoneIndex)=>normalizeZonePolygons(object.coordinates).map((polygon, polygonIndex)=>/*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                                                        style: {
                                                            position: "absolute",
                                                            top: 0,
                                                            left: 0,
                                                            width: "100%",
                                                            height: "100%",
                                                            pointerEvents: "none"
                                                        },
                                                        viewBox: `0 0 ${dimensions.width} ${dimensions.height}`,
                                                        preserveAspectRatio: "xMidYMid meet",
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("polygon", {
                                                            points: (0, $64WJh.pointsCreator)(polygon, dimensions.height, dimensions.width),
                                                            stroke: object.line_color,
                                                            strokeWidth: "5",
                                                            fill: object.line_color,
                                                            fillOpacity: "50%"
                                                        })
                                                    }, `ignore-${obj.id}-${zoneIndex}-${polygonIndex}-${object.stream_id}-${object.metric_id}-${object.label}`))),
                                            dimensions && !previewLoadFailed && !!resolvedPreviewUrl && clickedTab === "two" && metadataTagZones.map((object, index)=>/*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                                                    style: {
                                                        position: "absolute",
                                                        top: 0,
                                                        left: 0,
                                                        width: "100%",
                                                        height: "100%",
                                                        pointerEvents: "none"
                                                    },
                                                    viewBox: `0 0 ${dimensions.width} ${dimensions.height}`,
                                                    preserveAspectRatio: "xMidYMid meet",
                                                    children: object.coordinates.map((polygon, index)=>/*#__PURE__*/ (0, $k4ank.jsx)("polygon", {
                                                            points: (0, $64WJh.pointsCreator)(polygon, dimensions.height, dimensions.width),
                                                            stroke: object.line_color,
                                                            strokeWidth: "5",
                                                            fill: object.line_color,
                                                            fillOpacity: "50%"
                                                        }, index))
                                                }, object.id ?? `metadata-tag-${object.camera}-${object.name}-${index}`))
                                        ]
                                    })
                                }),
                                siteInfo?.integration_type_name === "autopatrol" && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                                    sx: {
                                        mt: 1.5
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                                            sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                                mb: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                                    component: "span",
                                                    sx: {
                                                        fontFamily: "Mulish",
                                                        fontWeight: 600,
                                                        fontSize: {
                                                            xs: "12px",
                                                            sm: "13px"
                                                        }
                                                    },
                                                    children: "Slicing"
                                                }),
                                                cameraSlice[obj.id] === undefined ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                                    component: "span",
                                                    sx: {
                                                        color: "text.secondary"
                                                    },
                                                    children: "\u2014"
                                                }) : cameraSlice[obj.id] ? (0, $lWchQ.checkedCircleIcon) : (0, $2aMB5.cancelIconRed)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                            component: "span",
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: 600,
                                                fontSize: {
                                                    xs: "12px",
                                                    sm: "13px"
                                                },
                                                display: "block",
                                                mb: 0.5
                                            },
                                            children: "Active Products"
                                        }),
                                        activeCameraProductsLoading[obj.id] ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                            size: 18,
                                            color: "primary"
                                        }) : activeCameraProducts[obj.id] === undefined ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                            component: "span",
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontSize: {
                                                    xs: "12px",
                                                    sm: "14px"
                                                },
                                                color: "text.secondary"
                                            },
                                            children: "\u2014"
                                        }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                                            children: (0, $jUxHc.ACTIVE_PRODUCTS_DISPLAY_NAMES).filter((name)=>activeCameraProducts[obj.id]?.[name]).length === 0 ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                                component: "span",
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    fontSize: {
                                                        xs: "12px",
                                                        sm: "14px"
                                                    },
                                                    color: "text.secondary"
                                                },
                                                children: "\u2014"
                                            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                                component: "span",
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    fontSize: {
                                                        xs: "12px",
                                                        sm: "14px"
                                                    }
                                                },
                                                children: (0, $jUxHc.ACTIVE_PRODUCTS_DISPLAY_NAMES).filter((name)=>activeCameraProducts[obj.id]?.[name]).join(", ")
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        showTabs && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                            sx: {
                                flex: "0 1 50%",
                                minWidth: 0,
                                display: "flex",
                                flexDirection: "column",
                                overflow: "hidden"
                            },
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                    sx: {
                                        borderBottom: 1,
                                        borderColor: "divider"
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                                        theme: $9ed4f873f177218c$var$theme,
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3n3uW.default), {
                                            value: clickedTab,
                                            onChange: (event, tabValue)=>{
                                                setClickedTab(tabValue);
                                            },
                                            "aria-label": "zones tabs",
                                            sx: {
                                                minHeight: 36,
                                                "& .MuiTab-root": {
                                                    minHeight: 36,
                                                    fontFamily: "Mulish",
                                                    fontWeight: "Bold",
                                                    fontSize: {
                                                        xs: "11px",
                                                        sm: "12px",
                                                        md: "13px"
                                                    }
                                                }
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                                                    value: "one",
                                                    label: "Ignore Zones"
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                                                    value: "two",
                                                    label: "Metadata Tag Zones"
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                                    sx: {
                                        overflow: "auto",
                                        flex: 1,
                                        minHeight: 0,
                                        paddingTop: "10px"
                                    },
                                    children: [
                                        clickedTab === "one" && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                            children: [
                                                flexIgnoreZonesActive && effectiveScheduleId != null && Number.isFinite(Number(effectiveScheduleId)) && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8UhTy.AutoPatrolFlexPresetSelectForCameraRow), {
                                                    siteId: Number(siteInfo.id),
                                                    scheduleId: Number(effectiveScheduleId),
                                                    cameraId: Number(obj.id),
                                                    cameraName: obj.camera_name,
                                                    previewUrl: resolvedPreviewUrl,
                                                    defaultZones: allIgnoreZones,
                                                    onZonesChange: (zones)=>setVisibleIgnoreZones(zones)
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $glcO0.IgnoreZonesTable), {
                                                    visibleIgnoreZones: visibleIgnoreZones,
                                                    onEditClick: ()=>{
                                                        setBackdropLoadingScreenOn(true);
                                                        navigate(`/sites/${siteInfo.id}/editcamera/${obj.id}/editignorezones`);
                                                    }
                                                })
                                            ]
                                        }),
                                        clickedTab === "two" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $7Ep9S.MetadataTagZonesTable), {
                                            metadataTagZones: metadataTagZones,
                                            onEditClick: ()=>{
                                                setBackdropLoadingScreenOn(true);
                                                navigate(`/sites/${siteInfo.id}/editcamera/${obj.id}/editmetadatatagzones`);
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};

});

parcelRegister("68w5E", function(module, exports) {

$parcel$export(module.exports, "EnhancedCameraTableHeadAutoPatrol", () => $eb741651a6f48564$export$66d8c52e150153ed);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");
var $kbChx = parcelRequire("kbChx");
var $aVDw9 = parcelRequire("aVDw9");
var $ha39s = parcelRequire("ha39s");
var $4o6Cs = parcelRequire("4o6Cs");
var $kLvBh = parcelRequire("kLvBh");

var $9lVTU = parcelRequire("9lVTU");

var $8jTCz = parcelRequire("8jTCz");

var $e9rQm = parcelRequire("e9rQm");

var $g0plP = parcelRequire("g0plP");
const $eb741651a6f48564$export$66d8c52e150153ed = (props)=>{
    const { onSelectAllClick: onSelectAllClick, numSelected: numSelected, rowCount: rowCount, showSelection: showSelection, onRequestSort: onRequestSort, orderBy: orderBy, order: order, allExpanded: allExpanded, setExpandedObject: setExpandedObject, saveExpandedObjectAllTrue: saveExpandedObjectAllTrue, saveExpandedObjectAllFalse: saveExpandedObjectAllFalse } = props;
    const createSortHandler = (property)=>(event)=>{
            onRequestSort(event, property);
        };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
            children: [
                showSelection && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    padding: "checkbox",
                    sx: {
                        width: "5%",
                        paddingLeft: 1,
                        paddingRight: 1
                    },
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                        color: "primary",
                        indeterminate: numSelected > 0 && numSelected < rowCount,
                        checked: rowCount > 0 && numSelected === rowCount,
                        onChange: onSelectAllClick,
                        inputProps: {
                            "aria-label": "select all cameras"
                        }
                    })
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    sx: {
                        fontSize: "14px",
                        fontFamily: "Mulish",
                        fontWeight: "Bold",
                        paddingLeft: showSelection ? 1 : 2,
                        paddingRight: 1,
                        whiteSpace: "nowrap",
                        width: showSelection ? "35%" : "40%"
                    },
                    align: "left",
                    sortDirection: orderBy === "camera_name" ? order : false,
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kLvBh.default), {
                        active: orderBy === "camera_name",
                        direction: orderBy === "camera_name" ? order : "asc",
                        onClick: createSortHandler("camera_name"),
                        children: [
                            "Camera Name",
                            orderBy === "camera_name" ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                component: "span",
                                sx: (0, $9lVTU.default),
                                children: order === "desc" ? "sorted Z to A" : "sorted A to Z"
                            }) : null
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    sx: {
                        fontSize: "14px",
                        fontFamily: "Mulish",
                        fontWeight: "Bold",
                        paddingLeft: 1,
                        paddingRight: 1,
                        width: "40%",
                        whiteSpace: "nowrap"
                    },
                    align: "left",
                    children: "Active Products"
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    align: "right",
                    sx: {
                        fontFamily: "Mulish",
                        fontWeight: "Bold",
                        fontSize: "14px",
                        paddingLeft: 1,
                        paddingRight: 2,
                        whiteSpace: "nowrap",
                        width: "20%"
                    },
                    children: !allExpanded ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            props.setAllExpanded(true);
                            setExpandedObject((prev)=>{
                                const next = {
                                    ...prev
                                };
                                Object.keys(next).forEach((k)=>{
                                    next[k] = true;
                                });
                                return next;
                            });
                            saveExpandedObjectAllTrue();
                        },
                        text: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9rQm))), {
                                    fontSize: "small"
                                }),
                                "\xa0Expand All"
                            ]
                        }),
                        disabled: false
                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            props.setAllExpanded(false);
                            setExpandedObject((prev)=>{
                                const next = {
                                    ...prev
                                };
                                Object.keys(next).forEach((k)=>{
                                    next[k] = false;
                                });
                                return next;
                            });
                            saveExpandedObjectAllFalse();
                        },
                        text: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g0plP))), {
                                    fontSize: "small"
                                }),
                                "\xa0Collapse All"
                            ]
                        }),
                        disabled: false
                    })
                })
            ]
        })
    });
};

});

parcelRegister("hcX4E", function(module, exports) {

$parcel$export(module.exports, "ACTIVE_PRODUCTS_PARENT_CATEGORIES", () => $108de0d03d93577b$export$1a16f39181cb8cd4);
parcelRequire("8T3gX");

var $dSMnH = parcelRequire("dSMnH");

var $fejSa = parcelRequire("fejSa");

var $gjeqz = parcelRequire("gjeqz");

var $yz7hO = parcelRequire("yz7hO");

var $fywrj = parcelRequire("fywrj");
const $108de0d03d93577b$export$1a16f39181cb8cd4 = [
    {
        parentLabel: "Intruder",
        children: [
            "Intruder",
            "Vehicle",
            "Bike"
        ],
        color: "#FF8400",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dSMnH)))
    },
    {
        parentLabel: "Crowd",
        children: [
            "Crowd"
        ],
        color: "#2196F3",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($fejSa)))
    },
    {
        parentLabel: "Fire",
        children: [
            "Fire",
            "Smoke"
        ],
        color: "#F44336",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gjeqz)))
    },
    {
        parentLabel: "Non-UPS Vehicle ID",
        children: [
            "Non-UPS"
        ],
        color: "#03A9F4",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($fywrj)))
    },
    {
        parentLabel: "Vehicle ID",
        children: [
            "Amazon",
            "DHL",
            "Fedex",
            "School Bus",
            "UPS",
            "USPS",
            "Fire Truck"
        ],
        color: "#4CAF50",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($yz7hO)))
    }
];

});
parcelRegister("dSMnH", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1b5d9042f0e7b41$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $a1b5d9042f0e7b41$var$_default = module.exports.default = (0, $a1b5d9042f0e7b41$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4"
}), 'Person');

});

parcelRegister("fejSa", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b16794182c401f16$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $b16794182c401f16$var$_default = module.exports.default = (0, $b16794182c401f16$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M12 12.75c1.63 0 3.07.39 4.24.9 1.08.48 1.76 1.56 1.76 2.73V18H6v-1.61c0-1.18.68-2.26 1.76-2.73 1.17-.52 2.61-.91 4.24-.91M4 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m1.13 1.1c-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58C.48 14.9 0 15.62 0 16.43V18h4.5v-1.61c0-.83.23-1.61.63-2.29M20 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m4 3.43c0-.81-.48-1.53-1.22-1.85-.85-.37-1.79-.58-2.78-.58-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V18H24zM12 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3"
}), 'Groups');

});

parcelRegister("gjeqz", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bdf99cb3fd45165d$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $bdf99cb3fd45165d$var$_default = module.exports.default = (0, $bdf99cb3fd45165d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67M11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8"
}), 'Whatshot');

});

parcelRegister("yz7hO", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $067e6a7ff8cfa989$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $067e6a7ff8cfa989$var$_default = module.exports.default = (0, $067e6a7ff8cfa989$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5m13.5-9 1.96 2.5H17V9.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5"
}), 'LocalShipping');

});

parcelRegister("fywrj", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b53331cefc283264$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $b53331cefc283264$var$_default = module.exports.default = (0, $b53331cefc283264$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16m11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5M5 11l1.5-4.5h11L19 11z"
}), 'DirectionsCar');

});




parcelRegister("ffVZD", function(module, exports) {

$parcel$export(module.exports, "handleEditSchedulesClick", () => $431c96c7c70ef707$export$a2ae8f18b5dd2f65);
$parcel$export(module.exports, "handleCancelSchedulesClick", () => $431c96c7c70ef707$export$78709ae697f7863c);

var $3FJ79 = parcelRequire("3FJ79");
const $431c96c7c70ef707$var$BACKUP_AUTO_PATROL_SCHEDULES = "backupAutoPatrolSchedules";
const $431c96c7c70ef707$var$BACKUP_AUTO_PATROL_SCHEDULE_HEALTHCHCK_METRICS = "backupAutoPatrolScheduleHealthchckMetrics";
const $431c96c7c70ef707$var$BACKUP_AUTO_PATROL_CAMERA_PRODUCTS = "backupAutoPatrolCameraProducts";
const $431c96c7c70ef707$var$BACKUP_UPDATED_PRODUCT_METRICS_IDS = "backupUpdatedProductMetricsIds";
const $431c96c7c70ef707$export$a2ae8f18b5dd2f65 = (setSchedulesEditMode)=>{
    const { autoPatrolSchedules: autoPatrolSchedules, autoPatrolScheduleHealthchckMetrics: autoPatrolScheduleHealthchckMetrics, autoPatrolCameraProducts: autoPatrolCameraProducts, updatedProductMetricsIds: updatedProductMetricsIds } = (0, $3FJ79.useSiteAboutStore).getState();
    localStorage.setItem($431c96c7c70ef707$var$BACKUP_AUTO_PATROL_SCHEDULES, JSON.stringify(autoPatrolSchedules));
    localStorage.setItem($431c96c7c70ef707$var$BACKUP_AUTO_PATROL_SCHEDULE_HEALTHCHCK_METRICS, JSON.stringify(autoPatrolScheduleHealthchckMetrics));
    localStorage.setItem($431c96c7c70ef707$var$BACKUP_AUTO_PATROL_CAMERA_PRODUCTS, JSON.stringify(autoPatrolCameraProducts));
    localStorage.setItem($431c96c7c70ef707$var$BACKUP_UPDATED_PRODUCT_METRICS_IDS, JSON.stringify(updatedProductMetricsIds));
    setSchedulesEditMode(true);
};
const $431c96c7c70ef707$export$78709ae697f7863c = (setSchedulesEditMode)=>{
    const { setAutoPatrolSchedules: setAutoPatrolSchedules, setAutoPatrolScheduleHealthchckMetrics: setAutoPatrolScheduleHealthchckMetrics, setAutoPatrolCameraProducts: setAutoPatrolCameraProducts, setUpdatedProductMetricsIds: setUpdatedProductMetricsIds, setProductMetricsWereUpdated: setProductMetricsWereUpdated, setAutoPatrolSchedulesUpdatedBoolean: setAutoPatrolSchedulesUpdatedBoolean, setUpdatedAutoPatrolScheduleIndexes: setUpdatedAutoPatrolScheduleIndexes, setAutoPatrolScheduleHealthchckMetricsUpdatedBoolean: setAutoPatrolScheduleHealthchckMetricsUpdatedBoolean, setUpdatedAutoPatrolScheduleHealthchckMetricsIds: setUpdatedAutoPatrolScheduleHealthchckMetricsIds } = (0, $3FJ79.useSiteAboutStore).getState();
    const backupAutoPatrolMetrics = localStorage.getItem($431c96c7c70ef707$var$BACKUP_AUTO_PATROL_SCHEDULE_HEALTHCHCK_METRICS);
    if (backupAutoPatrolMetrics) setAutoPatrolScheduleHealthchckMetrics(JSON.parse(backupAutoPatrolMetrics));
    const backupAutoPatrol = localStorage.getItem($431c96c7c70ef707$var$BACKUP_AUTO_PATROL_SCHEDULES);
    if (backupAutoPatrol) setAutoPatrolSchedules(JSON.parse(backupAutoPatrol));
    const backupCameraProducts = localStorage.getItem($431c96c7c70ef707$var$BACKUP_AUTO_PATROL_CAMERA_PRODUCTS);
    if (backupCameraProducts) setAutoPatrolCameraProducts(JSON.parse(backupCameraProducts));
    const backupProductMetricsIds = localStorage.getItem($431c96c7c70ef707$var$BACKUP_UPDATED_PRODUCT_METRICS_IDS);
    if (backupProductMetricsIds) setUpdatedProductMetricsIds(JSON.parse(backupProductMetricsIds));
    setProductMetricsWereUpdated(false);
    setAutoPatrolSchedulesUpdatedBoolean(false);
    setUpdatedAutoPatrolScheduleIndexes([]);
    setAutoPatrolScheduleHealthchckMetricsUpdatedBoolean(false);
    setUpdatedAutoPatrolScheduleHealthchckMetricsIds([]);
    setSchedulesEditMode(false);
};

});


parcelRegister("jKvMX", function(module, exports) {

$parcel$export(module.exports, "SiteAboutActionsMenu", () => $01202389f0421f50$export$45d5b36b5f14c6aa);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $iKAtE = parcelRequire("iKAtE");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");

var $i5MAs = parcelRequire("i5MAs");

var $gouAT = parcelRequire("gouAT");

var $cye0Y = parcelRequire("cye0Y");

var $jSKYJ = parcelRequire("jSKYJ");

var $kiL10 = parcelRequire("kiL10");

var $8ISah = parcelRequire("8ISah");

var $k3Hi0 = parcelRequire("k3Hi0");

var $8sSou = parcelRequire("8sSou");

var $9ejAJ = parcelRequire("9ejAJ");

var $bK5fk = parcelRequire("bK5fk");

var $3GvXV = parcelRequire("3GvXV");
const $01202389f0421f50$export$45d5b36b5f14c6aa = ({ siteInfo: siteInfo, permissions: permissions, configureMotion: configureMotion, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setAlertState: setAlertState, setDeleteSiteDialogOpen: setDeleteSiteDialogOpen, navigate: navigate })=>{
    const [anchorEl, setAnchorEl] = $8T3gX.useState(null);
    const open = Boolean(anchorEl);
    // Same poll-lifetime rules as ConfigureMotionButton: abort on unmount or
    // re-click so Configure Motion never updates state after leaving the page.
    const pollAbort = $8T3gX.useRef(null);
    $8T3gX.useEffect(()=>{
        return ()=>{
            pollAbort.current?.abort();
        };
    }, []);
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const isAutopatrol = siteInfo.integration_type_name === "autopatrol";
    const isGenetec = siteInfo.integration_type_name === "genetec";
    // Configure Motion and the Genetec alarm setup change site settings, so
    // they need edit_cameras — arm/disarm alone isn't enough (PROD-56).
    const canEditSite = Boolean(permissions.edit_cameras);
    const [genetecAlarmDialogOpen, setGenetecAlarmDialogOpen] = $8T3gX.useState(false);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                "aria-label": "Site about actions",
                "aria-controls": open ? "site-about-actions-menu" : undefined,
                "aria-expanded": open ? "true" : undefined,
                "aria-haspopup": "true",
                onClick: (event)=>setAnchorEl(event.currentTarget),
                size: "small",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5MAs))), {})
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                id: "site-about-actions-menu",
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "right"
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                        onClick: ()=>{
                            handleClose();
                            (0, $8sSou.downloadSiteDetails)(siteInfo.id, siteInfo.name).catch(()=>{
                                alert("Failed to download the site details report. Please try again.");
                            });
                        },
                        sx: {
                            fontFamily: "Mulish"
                        },
                        children: (0, $k3Hi0.DownloadSiteDetailsText)
                    }),
                    canEditSite && configureMotion && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $cxknk.default), {
                        onClick: ()=>{
                            handleClose();
                            pollAbort.current?.abort();
                            const controller = new AbortController();
                            pollAbort.current = controller;
                            setBackdropLoadingScreenOn(true);
                            (0, $9ejAJ.handleConfigureMotion)(setBackdropLoadingScreenOn, setAlertState, navigate, {
                                signal: controller.signal
                            });
                        },
                        sx: {
                            fontFamily: "Mulish"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jSKYJ))), {
                                fontSize: "small"
                            }),
                            "\xa0Configure Motion"
                        ]
                    }),
                    canEditSite && isGenetec && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $cxknk.default), {
                        onClick: ()=>{
                            handleClose();
                            setGenetecAlarmDialogOpen(true);
                        },
                        sx: {
                            fontFamily: "Mulish"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kiL10))), {
                                fontSize: "small"
                            }),
                            "\xa0Set up Security Center alarms"
                        ]
                    }),
                    !isAutopatrol && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                        onClick: ()=>{
                            handleClose();
                            navigate(`/actionlogs/${siteInfo.id}`);
                        },
                        sx: {
                            fontFamily: "Mulish"
                        },
                        children: (0, $8ISah.ActionLogsText)
                    }),
                    !isAutopatrol && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $cxknk.default), {
                        onClick: ()=>{
                            handleClose();
                            navigate((0, $bK5fk.getSeeAlertsPath)(siteInfo));
                        },
                        sx: {
                            fontFamily: "Mulish"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gouAT))), {
                                fontSize: "small"
                            }),
                            "\xa0See Alerts"
                        ]
                    }),
                    permissions.delete_cameras && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $cxknk.default), {
                        onClick: ()=>{
                            handleClose();
                            setDeleteSiteDialogOpen(true);
                        },
                        sx: {
                            fontFamily: "Mulish"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cye0Y))), {
                                fontSize: "small"
                            }),
                            "\xa0DELETE Site"
                        ]
                    })
                ]
            }),
            isGenetec && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3GvXV.GenetecAlarmSetupDialog), {
                open: genetecAlarmDialogOpen,
                siteId: siteInfo.id,
                onClose: ()=>setGenetecAlarmDialogOpen(false),
                showStreamCoverage: true,
                navigate: navigate
            })
        ]
    });
};

});
parcelRegister("i5MAs", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2be61f9cb5502c5$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $d2be61f9cb5502c5$var$_default = module.exports.default = (0, $d2be61f9cb5502c5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), 'MoreVert');

});

parcelRegister("jSKYJ", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e79780681c0789cb$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $e79780681c0789cb$var$_default = module.exports.default = (0, $e79780681c0789cb$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M7.76 16.24C6.67 15.16 6 13.66 6 12s.67-3.16 1.76-4.24l1.42 1.42C8.45 9.9 8 10.9 8 12c0 1.1.45 2.1 1.17 2.83zm8.48 0C17.33 15.16 18 13.66 18 12s-.67-3.16-1.76-4.24l-1.42 1.42C15.55 9.9 16 10.9 16 12c0 1.1-.45 2.1-1.17 2.83zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m8 2c0 2.21-.9 4.21-2.35 5.65l1.42 1.42C20.88 17.26 22 14.76 22 12s-1.12-5.26-2.93-7.07l-1.42 1.42C19.1 7.79 20 9.79 20 12M6.35 6.35 4.93 4.93C3.12 6.74 2 9.24 2 12s1.12 5.26 2.93 7.07l1.42-1.42C4.9 16.21 4 14.21 4 12s.9-4.21 2.35-5.65"
}), 'Sensors');

});

parcelRegister("kiL10", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ec79f553123f6d9a$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $ec79f553123f6d9a$var$_default = module.exports.default = (0, $ec79f553123f6d9a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M7.58 4.08 6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2c.15-2.65 1.51-4.97 3.55-6.42m12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43c2.02 1.45 3.39 3.77 3.54 6.42M18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2"
}), 'NotificationsActive');

});

parcelRegister("8ISah", function(module, exports) {

$parcel$export(module.exports, "ActionLogsText", () => $2c9f4d1b6ba525f5$export$e671d1f9619e10ba);

var $k4ank = parcelRequire("k4ank");

var $d75YN = parcelRequire("d75YN");
const $2c9f4d1b6ba525f5$export$e671d1f9619e10ba = /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
    children: [
        /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d75YN))), {
            fontSize: "small"
        }),
        "\xa0Action Logs"
    ]
});

});
parcelRegister("d75YN", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98c09139209a9557$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $98c09139209a9557$var$_default = module.exports.default = (0, $98c09139209a9557$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M3 18h12v-2H3zM3 6v2h18V6zm0 7h18v-2H3z"
}), 'Notes');

});


parcelRegister("k3Hi0", function(module, exports) {

$parcel$export(module.exports, "DownloadSiteDetailsText", () => $959277b68d2f6e1b$export$1fa676896cd27efb);

var $k4ank = parcelRequire("k4ank");

var $2zBdB = parcelRequire("2zBdB");
const $959277b68d2f6e1b$export$1fa676896cd27efb = /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
    children: [
        /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2zBdB))), {
            fontSize: "small"
        }),
        "\xa0Download Site Details"
    ]
});

});
parcelRegister("2zBdB", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1dfbb871525d91a2$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $1dfbb871525d91a2$var$_default = module.exports.default = (0, $1dfbb871525d91a2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M5 20h14v-2H5zM19 9h-4V3H9v6H5l7 7z"
}), 'Download');

});


parcelRegister("8sSou", function(module, exports) {

$parcel$export(module.exports, "downloadSiteDetails", () => $7b502e58b5b3ec6c$export$48b46e19aedfe7ac);

var $195EM = parcelRequire("195EM");

var $iIAML = parcelRequire("iIAML");
const $7b502e58b5b3ec6c$export$48b46e19aedfe7ac = async (siteId, siteName)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const response = await AxiosUI.get(`site_settings_report/${siteId}/pdf/`, {
        responseType: "blob"
    });
    const blob = new Blob([
        response.data
    ], {
        type: "application/pdf"
    });
    const name = (siteName || `site_${siteId}`).replace(/[^a-zA-Z0-9-_ ]/g, "").trim().replace(/\s+/g, "_");
    (0, $iIAML.saveAs)(blob, `${name}_site_details.pdf`);
};

});

parcelRegister("9ejAJ", function(module, exports) {

$parcel$export(module.exports, "handleConfigureMotion", () => $49bff66abf2659f3$export$7f58b8db09d4e63d);

var $c8yf1 = parcelRequire("c8yf1");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("elyck");
var $h5bv8 = parcelRequire("h5bv8");

var $5bO6h = parcelRequire("5bO6h");
const $49bff66abf2659f3$var$setConfigureMotion = (setAlertState, configureMotion)=>{
    setAlertState((previousState)=>{
        return {
            ...previousState,
            configureMotion: configureMotion
        };
    });
};
const $49bff66abf2659f3$export$ecbca38c0005bb84 = async (AxiosUI, siteId, setAlertState, dispatchedAt, options = {})=>{
    const attempts = options.attempts ?? (0, $5bO6h.CONFIGURE_MOTION_POLL_ATTEMPTS);
    const intervalMs = options.intervalMs ?? (0, $5bO6h.CONFIGURE_MOTION_POLL_INTERVAL_MS);
    const signal = options.signal;
    for(let attempt = 0; attempt < attempts; attempt++){
        await (0, $c8yf1.abortableWait)(intervalMs, signal);
        if (signal?.aborted) return null;
        try {
            const response = await AxiosUI.get(`customer/${siteId}/action_status/?action=configure_motion`, {
                signal: signal
            });
            if (signal?.aborted) return null;
            const data = response.data;
            const fromThisClick = Date.parse(data.request_date) >= dispatchedAt - (0, $5bO6h.DISPATCH_CLOCK_SKEW_MS);
            if (fromThisClick && data.status && data.status !== "pending") {
                const state = (0, $5bO6h.summarizeConfigureMotion)(data);
                $49bff66abf2659f3$var$setConfigureMotion(setAlertState, state);
                return state;
            }
        } catch  {
        // 404 (no row yet), transient error, or the request was aborted: the
        // abort check at the top of the loop decides which.
        }
    }
    if (signal?.aborted) return null;
    const state = {
        phase: "timeout",
        message: (0, $5bO6h.TIMEOUT_MESSAGE)
    };
    $49bff66abf2659f3$var$setConfigureMotion(setAlertState, state);
    return state;
};
const $49bff66abf2659f3$export$7f58b8db09d4e63d = (setBackdropLoadingScreenOn, setAlertState, navigate, pollOptions = {})=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const siteId = (0, $h5bv8.getNumbersAfterAboutSite)(location.href);
    const dispatchedAt = Date.now();
    const retryFunction = ()=>{
        $49bff66abf2659f3$export$7f58b8db09d4e63d(setBackdropLoadingScreenOn, setAlertState, navigate, pollOptions);
    };
    AxiosUI.post(`customer/${siteId}/action/configure_motion/`).then((response)=>{
        if (pollOptions.signal?.aborted) // The page is gone; the job still runs and lands in Command History.
        return;
        // The request is accepted; the outcome comes from the background job.
        // Don't hold the page behind the backdrop while it runs.
        setBackdropLoadingScreenOn(false);
        const skipped = (0, $5bO6h.skippedMessage)(response?.data);
        if (skipped) {
            $49bff66abf2659f3$var$setConfigureMotion(setAlertState, {
                phase: "skipped",
                message: skipped
            });
            return;
        }
        $49bff66abf2659f3$var$setConfigureMotion(setAlertState, {
            phase: "pending",
            message: (0, $5bO6h.PENDING_MESSAGE)
        });
        $49bff66abf2659f3$export$ecbca38c0005bb84(AxiosUI, siteId, setAlertState, dispatchedAt, pollOptions);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            if (pollOptions.signal?.aborted) return;
            $49bff66abf2659f3$var$setConfigureMotion(setAlertState, {
                phase: "failed",
                message: (0, $5bO6h.REQUEST_FAILED_MESSAGE)
            });
            setBackdropLoadingScreenOn(false);
        });
    });
};

});
parcelRegister("c8yf1", function(module, exports) {

$parcel$export(module.exports, "abortableWait", () => $464814144088b923$export$8733762594c535b);
// Resolves after `ms`, or immediately once `signal` aborts. Shared by the
// site-action pollers (Configure Motion, Genetec alarm setup) so an aborted
// poll stops waiting as soon as the page that started it goes away.
const $464814144088b923$export$8733762594c535b = (ms, signal)=>new Promise((resolve)=>{
        if (signal?.aborted) {
            resolve();
            return;
        }
        const done = ()=>{
            clearTimeout(timer);
            signal?.removeEventListener("abort", done);
            resolve();
        };
        const timer = setTimeout(done, ms);
        signal?.addEventListener("abort", done);
    });

});


parcelRegister("bK5fk", function(module, exports) {

$parcel$export(module.exports, "getSeeAlertsPath", () => $d3ad70639b701c69$export$8fa3b788149b2f64);
// Integration types whose alerts live on the Clips page rather than the
// Alerts page. Mirrors `is_clips=True` in actuate_admin's integration enum
// (ailink, sentinel-verifier, clips).
const $d3ad70639b701c69$export$1a1ea264b9a25cdd = [
    "ailink",
    "sentinel-verifier",
    "clips"
];
const $d3ad70639b701c69$export$ac2d91b91804fac3 = (integrationTypeName)=>$d3ad70639b701c69$export$1a1ea264b9a25cdd.includes(integrationTypeName ?? "");
const $d3ad70639b701c69$var$clipsTabFor = (integrationTypeName)=>integrationTypeName === "sentinel-verifier" ? "sentinel" : "ailink";
const $d3ad70639b701c69$var$readCredentials = (storageKey)=>{
    try {
        const parsed = JSON.parse(localStorage.getItem(storageKey) || "[]");
        return Array.isArray(parsed) ? parsed : [];
    } catch  {
        return [];
    }
};
// The Clips page filters by immix credential (`user=`), whose group is one of
// the site's ancestor groups. Walk the breadcrumb chain until a credential in
// the cached list matches; the cached lists are populated at login by
// dataFetchers (`aiLinkUsers` / `sentinelUsers`).
const $d3ad70639b701c69$var$findCredentialUsername = (tab, breadcrumbs)=>{
    const credentials = $d3ad70639b701c69$var$readCredentials(tab === "sentinel" ? "sentinelUsers" : "aiLinkUsers");
    if (!credentials.length) return null;
    for (const crumb of breadcrumbs){
        const match = credentials.find((credential)=>String(credential.group?.id) === String(crumb.id));
        if (match?.username) return match.username;
    }
    return null;
};
const $d3ad70639b701c69$export$8fa3b788149b2f64 = (siteInfo)=>{
    const breadcrumbs = siteInfo.breadcrumb_info ?? [];
    const topGroupId = breadcrumbs[0]?.id;
    if (!$d3ad70639b701c69$export$ac2d91b91804fac3(siteInfo.integration_type_name)) return `/alerts?group=${topGroupId}&site=${siteInfo.id}`;
    const tab = $d3ad70639b701c69$var$clipsTabFor(siteInfo.integration_type_name);
    const params = new URLSearchParams();
    params.set("tab", tab);
    const username = $d3ad70639b701c69$var$findCredentialUsername(tab, breadcrumbs);
    if (username) params.set("user", username);
    params.set("site", String(siteInfo.id));
    return `/clips?${params.toString()}`;
};

});

parcelRegister("3GvXV", function(module, exports) {

$parcel$export(module.exports, "GenetecAlarmSetupDialog", () => $2d19257cde314728$export$e8199c5e33d811ce);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $3QMQN = parcelRequire("3QMQN");

var $60vL1 = parcelRequire("60vL1");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $ce8iU = parcelRequire("ce8iU");

var $cpJfj = parcelRequire("cpJfj");

var $8jTCz = parcelRequire("8jTCz");

var $3Zv1D = parcelRequire("3Zv1D");

var $jyh06 = parcelRequire("jyh06");

var $WtptA = parcelRequire("WtptA");
const $2d19257cde314728$export$c70ce0575371008b = "Send detections to Security Center as alarms?";
const $2d19257cde314728$var$errorDetail = (reason, fallback)=>{
    const data = reason?.response?.data;
    if (data && typeof data === "object") {
        if (typeof data.detail === "string") return data.detail;
        if (Array.isArray(data) && typeof data[0] === "string") return data[0];
    }
    return fallback;
};
const $2d19257cde314728$export$e8199c5e33d811ce = ({ open: open, siteId: siteId, onClose: onClose, setup: providedSetup, showStreamCoverage: showStreamCoverage = false, navigate: navigate, pollOptions: pollOptions })=>{
    const [setup, setSetup] = $8T3gX.useState(providedSetup ?? null);
    const [phase, setPhase] = $8T3gX.useState(providedSetup ? {
        kind: "prompt"
    } : {
        kind: "loading"
    });
    const abortRef = $8T3gX.useRef(null);
    const newController = ()=>{
        abortRef.current?.abort();
        const controller = new AbortController();
        abortRef.current = controller;
        return controller;
    };
    $8T3gX.useEffect(()=>()=>abortRef.current?.abort(), []);
    const handleApiError = (reason, retry, onError)=>{
        if (navigate) (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retry, onError);
        else onError();
    };
    const load = $8T3gX.useCallback(()=>{
        const controller = newController();
        setPhase({
            kind: "loading"
        });
        (0, $jyh06.fetchGenetecAlarmSetup)(siteId, controller.signal).then((data)=>{
            if (controller.signal.aborted) return;
            setSetup(data);
            setPhase({
                kind: "prompt"
            });
        }, (reason)=>{
            if (controller.signal.aborted) return;
            handleApiError(reason, load, ()=>setPhase({
                    kind: "loadError",
                    message: $2d19257cde314728$var$errorDetail(reason, "Couldn't load the Security Center alarm settings. Please try again.")
                }));
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        siteId
    ]);
    // Reset every time the dialog opens so a re-run starts from the prompt.
    $8T3gX.useEffect(()=>{
        if (!open) {
            abortRef.current?.abort();
            return;
        }
        if (providedSetup) {
            setSetup(providedSetup);
            setPhase({
                kind: "prompt"
            });
        } else load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    const runSetup = ()=>{
        const controller = newController();
        setPhase({
            kind: "running"
        });
        (0, $jyh06.startGenetecAlarmSetup)(siteId).then(async (dispatch)=>{
            if (controller.signal.aborted) return;
            const outcome = await (0, $jyh06.pollGenetecAlarmSetup)(siteId, dispatch.command_id, {
                ...pollOptions,
                signal: controller.signal
            });
            if (outcome === null || controller.signal.aborted) return;
            setPhase({
                kind: "done",
                summary: (0, $WtptA.summarizeGenetecAlarmSetup)(outcome)
            });
        }, (reason)=>{
            if (controller.signal.aborted) return;
            handleApiError(reason, runSetup, ()=>setPhase({
                    kind: "prompt",
                    error: $2d19257cde314728$var$errorDetail(reason, "Couldn't start the alarm setup. Please try again.")
                }));
        });
    };
    const close = ()=>{
        abortRef.current?.abort();
        onClose();
    };
    const alarmNames = setup?.alarm_names ?? [];
    const canSetUp = Boolean(setup?.is_genetec) && alarmNames.length > 0;
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: open,
        onClose: close,
        "aria-labelledby": "genetec-alarm-setup-title",
        maxWidth: "sm",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "genetec-alarm-setup-title",
                sx: {
                    fontFamily: "Mulish"
                },
                children: $2d19257cde314728$export$c70ce0575371008b
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                sx: {
                    fontFamily: "Mulish"
                },
                children: [
                    phase.kind === "loading" && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "flex justify-center py-4",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                            color: "warning",
                            size: 28
                        })
                    }),
                    phase.kind === "loadError" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                        severity: "error",
                        children: phase.message
                    }),
                    phase.kind === "prompt" && setup && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "font-mulish text-actuate-blue",
                        children: [
                            canSetUp ? /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                children: [
                                    "We'll create these alarms on your Security Center:",
                                    " ",
                                    /*#__PURE__*/ (0, $k4ank.jsx)("strong", {
                                        "data-testid": "genetec-alarm-names",
                                        children: alarmNames.join(", ")
                                    }),
                                    " ",
                                    "(re-trigger delay 0). After that, add recipients to them in Config Tool \u2192 Alarms \u2192 Recipients."
                                ]
                            }) : /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                children: setup.is_genetec ? "None of this site's streams have a Security Center alarm name yet, so there is nothing to set up." : "Security Center alarms are only available for Genetec sites."
                            }),
                            showStreamCoverage && /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                className: "pt-3",
                                "data-testid": "genetec-alarm-coverage",
                                children: [
                                    "Alarms are on for ",
                                    setup.streams_alarm_on,
                                    " of",
                                    " ",
                                    setup.streams_total,
                                    " stream",
                                    setup.streams_total === 1 ? "" : "s",
                                    "."
                                ]
                            }),
                            phase.error && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                                severity: "error",
                                sx: {
                                    mt: 2
                                },
                                children: phase.error
                            })
                        ]
                    }),
                    phase.kind === "running" && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "flex items-center gap-3 py-2 font-mulish text-actuate-blue",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                color: "warning",
                                size: 24
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                children: "Setting up alarms on Security Center. This usually takes under a minute."
                            })
                        ]
                    }),
                    phase.kind === "done" && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3QMQN.default), {
                        severity: phase.summary.severity,
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                children: phase.summary.headline
                            }),
                            phase.summary.failedAlarms.length > 0 && /*#__PURE__*/ (0, $k4ank.jsx)("ul", {
                                className: "list-disc pl-5 pt-1",
                                children: phase.summary.failedAlarms.map((alarm)=>/*#__PURE__*/ (0, $k4ank.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)("strong", {
                                                children: alarm.name
                                            }),
                                            alarm.detail ? ` \u{2014} ${alarm.detail}` : ""
                                        ]
                                    }, alarm.name))
                            }),
                            phase.summary.severity === "warning" && phase.summary.needsRecipients.length > 0 && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "pt-1",
                                children: (0, $WtptA.recipientsSentence)(phase.summary.needsRecipients)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    phase.kind === "prompt" && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: close,
                                text: "Not now",
                                disabled: false
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cpJfj.ActuateButton), {
                                onClick: runSetup,
                                text: "Set up alarms",
                                disabled: !canSetUp
                            })
                        ]
                    }),
                    phase.kind === "loadError" && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: close,
                                text: "Close",
                                disabled: false
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: load,
                                text: "Retry",
                                disabled: false
                            })
                        ]
                    }),
                    phase.kind === "loading" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: close,
                        text: "Not now",
                        disabled: false
                    }),
                    (phase.kind === "done" || phase.kind === "running") && // Closing while running only stops watching; the job keeps going.
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: close,
                        text: "Close",
                        disabled: false
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("jyh06", function(module, exports) {

$parcel$export(module.exports, "shouldPromptGenetecAlarmSetup", () => $a1b5c9c2a06cd070$export$75bae4a6ec0f6211);
$parcel$export(module.exports, "fetchGenetecAlarmSetup", () => $a1b5c9c2a06cd070$export$6b0baafec54c579a);
$parcel$export(module.exports, "startGenetecAlarmSetup", () => $a1b5c9c2a06cd070$export$69fd0c92a32ae45c);
$parcel$export(module.exports, "pollGenetecAlarmSetup", () => $a1b5c9c2a06cd070$export$db7bc8edba860246);

var $195EM = parcelRequire("195EM");

var $c8yf1 = parcelRequire("c8yf1");
const $a1b5c9c2a06cd070$export$86fdfadfa8c7d3cb = "genetec_alarm_setup";
const $a1b5c9c2a06cd070$export$11a5cb9cb1ac41fe = 3000;
const $a1b5c9c2a06cd070$export$913e39777d5fb898 = 40; // ~2 minutes
const $a1b5c9c2a06cd070$export$75bae4a6ec0f6211 = (setup)=>Boolean(setup && setup.is_genetec && Array.isArray(setup.alarm_names) && setup.alarm_names.length > 0 && setup.streams_alarm_on < setup.streams_total);
const $a1b5c9c2a06cd070$var$api = ()=>(0, $195EM.createApi)(``);
const $a1b5c9c2a06cd070$export$6b0baafec54c579a = async (siteId, signal)=>{
    const response = await $a1b5c9c2a06cd070$var$api().get(`customer/${siteId}/genetec_alarm_setup/`, {
        signal: signal
    });
    return response.data;
};
const $a1b5c9c2a06cd070$export$69fd0c92a32ae45c = async (siteId)=>{
    const response = await $a1b5c9c2a06cd070$var$api().post(`customer/${siteId}/genetec_alarm_setup/`);
    return response.data;
};
const $a1b5c9c2a06cd070$export$db7bc8edba860246 = async (siteId, commandId, options = {})=>{
    const attempts = options.attempts ?? $a1b5c9c2a06cd070$export$913e39777d5fb898;
    const intervalMs = options.intervalMs ?? $a1b5c9c2a06cd070$export$11a5cb9cb1ac41fe;
    const signal = options.signal;
    const client = $a1b5c9c2a06cd070$var$api();
    for(let attempt = 0; attempt < attempts; attempt++){
        await (0, $c8yf1.abortableWait)(intervalMs, signal);
        if (signal?.aborted) return null;
        try {
            const response = await client.get(`customer/${siteId}/action_status/?action=${$a1b5c9c2a06cd070$export$86fdfadfa8c7d3cb}`, {
                signal: signal
            });
            if (signal?.aborted) return null;
            const data = response.data;
            if (data && data.id === commandId && data.status && data.status !== "pending") return data;
        } catch  {
        // 404 (no row yet), transient error, or aborted: the loop decides.
        }
    }
    return signal?.aborted ? null : "timeout";
};

});

parcelRegister("WtptA", function(module, exports) {

$parcel$export(module.exports, "recipientsSentence", () => $0bffb50dff35cfd5$export$380ca94e53b3fc9d);
$parcel$export(module.exports, "summarizeGenetecAlarmSetup", () => $0bffb50dff35cfd5$export$8b4e97062f5b0f9a);
const $0bffb50dff35cfd5$export$f38e7fcd98c0309b = "The alarm setup job hasn't reported back yet. It may still be running \u2014 check Config Tool \u2192 Alarms in a few minutes, or run this again.";
// Per-alarm statuses that mean the alarm was not set up. Anything else
// (created, already existed, updated) counts as ready.
const $0bffb50dff35cfd5$var$FAILED_ALARM_STATUSES = new Set([
    "failed",
    "error"
]);
const $0bffb50dff35cfd5$export$2c50aa1e8ac7d391 = (alarm)=>$0bffb50dff35cfd5$var$FAILED_ALARM_STATUSES.has(String(alarm.status).toLowerCase());
const $0bffb50dff35cfd5$export$380ca94e53b3fc9d = (names)=>names.length > 0 ? `Add recipients in Config Tool to: ${names.join(", ")}.` : "";
const $0bffb50dff35cfd5$export$8b4e97062f5b0f9a = (outcome)=>{
    if (outcome === "timeout" || outcome.status === "timed_out") return {
        severity: "info",
        headline: $0bffb50dff35cfd5$export$f38e7fcd98c0309b,
        failedAlarms: [],
        needsRecipients: []
    };
    const alarms = outcome.result?.alarms ?? [];
    const failedAlarms = alarms.filter($0bffb50dff35cfd5$export$2c50aa1e8ac7d391);
    const needsRecipients = outcome.result?.needs_recipients ?? [];
    switch(outcome.status){
        case "success":
            return {
                severity: "success",
                headline: [
                    "Alarms ready.",
                    $0bffb50dff35cfd5$export$380ca94e53b3fc9d(needsRecipients)
                ].filter(Boolean).join(" "),
                failedAlarms: [],
                needsRecipients: needsRecipients
            };
        case "partial":
            return {
                severity: "warning",
                headline: "Some alarms were set up, but these failed:",
                failedAlarms: failedAlarms,
                needsRecipients: needsRecipients
            };
        default:
            {
                const reason = outcome.result?.error;
                return {
                    severity: "error",
                    headline: failedAlarms.length > 0 ? "Alarm setup failed for:" : `Alarm setup failed${reason ? `: ${reason}` : "."}`,
                    failedAlarms: failedAlarms,
                    needsRecipients: []
                };
            }
    }
};

});



parcelRegister("a0tnU", function(module, exports) {

$parcel$export(module.exports, "DoubleTakeTab", () => $0d60bdd24f3d3ac7$export$71fc953e07d84794);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $4reBM = parcelRequire("4reBM");

var $ddLR4 = parcelRequire("ddLR4");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $gfzcx = parcelRequire("gfzcx");

var $195EM = parcelRequire("195EM");

var $815yO = parcelRequire("815yO");

var $3Zv1D = parcelRequire("3Zv1D");

var $2bi6M = parcelRequire("2bi6M");
const $0d60bdd24f3d3ac7$export$a053882935258489 = "Runs a second AI check on alerts from this site's cameras and labels each one Likely FP or Likely TP in Live Alerts.";
const $0d60bdd24f3d3ac7$export$d708ac01e3094f99 = "Turning this on enables the DoubleTake column on Edit Camera \u203A Products so cameras can be opted in. Applies after sync.";
const $0d60bdd24f3d3ac7$export$3af0bd3470e5d5d5 = "Cameras opt in on Edit Camera \u203A Products \u203A DoubleTake. Applies after sync.";
const $0d60bdd24f3d3ac7$export$175eb5a1973ba0da = "You can turn DoubleTake off. To turn it back on, contact support.";
const $0d60bdd24f3d3ac7$export$3695c9c8eff8219f = "Alerts marked as likely false positives are held from Immix, Patriot and Sentinel.";
const $0d60bdd24f3d3ac7$export$f7bdad368ae85bb1 = "Set by Actuate. Contact support to change.";
const $0d60bdd24f3d3ac7$export$dd861e1ceee525da = "DoubleTake settings couldn't be saved. Try again.";
// Matches the General Info table so the two tabs line up column for column.
const $0d60bdd24f3d3ac7$var$COLUMN_COUNT = 7;
const $0d60bdd24f3d3ac7$var$CELL_WIDTH = `${100 / $0d60bdd24f3d3ac7$var$COLUMN_COUNT}%`;
const $0d60bdd24f3d3ac7$var$CELL_SX = {
    fontFamily: "Mulish",
    width: $0d60bdd24f3d3ac7$var$CELL_WIDTH
};
const $0d60bdd24f3d3ac7$export$71fc953e07d84794 = ({ siteId: siteId, siteInfo: siteInfo, isStaff: isStaff, editMode: editMode, saveRef: saveRef, onSiteInfoSaved: onSiteInfoSaved })=>{
    const navigate = (0, $3T949.useNavigate)();
    const [saved, setSaved] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        vlmEnabled: Boolean(siteInfo.vlm_enabled),
        gateEnabled: false
    });
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(saved);
    // The gate lives on customer/{id}/, not About; until it loads the gating
    // cell shows "--" so it never shows a guessed value.
    const [gateLoaded, setGateLoaded] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const loadGate = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback(()=>{
        (0, $195EM.createApi)(`customer/${siteId}/`).get("").then((response)=>{
            const gateEnabled = Boolean(response.data?.vlm_gate_enabled);
            setSaved((previous)=>({
                    ...previous,
                    gateEnabled: gateEnabled
                }));
            setDraft((previous)=>({
                    ...previous,
                    gateEnabled: gateEnabled
                }));
            setGateLoaded(true);
        }).catch((reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, loadGate, ()=>{
                setGateLoaded(false);
            });
        });
    }, [
        siteId,
        navigate
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        loadGate();
    }, [
        loadGate
    ]);
    // Cancel (or a save) leaves edit mode; start the next edit from what's saved.
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!editMode) {
            setDraft(saved);
            setError(null);
        }
    }, [
        editMode,
        saved
    ]);
    const patches = (0, $2bi6M.buildDoubleTakePatches)(saved, draft, isStaff);
    const doubleTakeToggleable = (0, $2bi6M.canToggleDoubleTake)(saved.vlmEnabled, siteInfo, isStaff);
    const noAccessButOn = !isStaff && saved.vlmEnabled && !siteInfo.doubletake_available;
    const save = ()=>{
        if (!patches.about && !patches.gate) return Promise.resolve("unchanged");
        setError(null);
        const requests = [];
        if (patches.about) requests.push((0, $195EM.createApi)(`customer/${siteId}/about/`).patch("", patches.about));
        if (patches.gate) requests.push((0, $195EM.createApi)(`customer/${siteId}/`).patch("", patches.gate));
        return Promise.all(requests).then(()=>{
            setSaved(draft);
            if (patches.about) onSiteInfoSaved({
                vlm_enabled: draft.vlmEnabled
            });
            (0, $815yO.markSiteUnsynced)(String(siteId));
            return "saved";
        }).catch((reason)=>new Promise((resolve)=>{
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, ()=>resolve(save()), ()=>{
                    setError($0d60bdd24f3d3ac7$export$dd861e1ceee525da);
                    resolve("failed");
                });
            }));
    };
    saveRef.current = save;
    const titles = [
        [
            "DoubleTake",
            "doubleTake"
        ],
        [
            "FP Gating",
            "fpGating"
        ],
        ...Array.from({
            length: $0d60bdd24f3d3ac7$var$COLUMN_COUNT - 2
        }, ()=>[
                "",
                ""
            ])
    ];
    const toolTipText = {
        doubleTake: `${$0d60bdd24f3d3ac7$export$a053882935258489} ${draft.vlmEnabled ? $0d60bdd24f3d3ac7$export$3af0bd3470e5d5d5 : $0d60bdd24f3d3ac7$export$d708ac01e3094f99}`,
        fpGating: isStaff ? $0d60bdd24f3d3ac7$export$3695c9c8eff8219f : `${$0d60bdd24f3d3ac7$export$3695c9c8eff8219f} ${$0d60bdd24f3d3ac7$export$f7bdad368ae85bb1}`
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        "data-testid": "double-take-tab",
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
            component: (0, $4reBM.default),
            sx: {
                width: "100%"
            },
            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                sx: {
                    width: "100%",
                    fontFamily: "Mulish",
                    tableLayout: "fixed"
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TooltipTableHeadComponent), {
                        titlesArray: titles,
                        toolTipText: toolTipText
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: $0d60bdd24f3d3ac7$var$CELL_SX,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                        checked: draft.vlmEnabled,
                                        disabled: !editMode || !doubleTakeToggleable,
                                        color: "warning",
                                        inputProps: {
                                            "aria-label": "DoubleTake"
                                        },
                                        onChange: (event)=>{
                                            const vlmEnabled = event.target.checked;
                                            setDraft((previous)=>({
                                                    ...previous,
                                                    vlmEnabled: vlmEnabled
                                                }));
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: $0d60bdd24f3d3ac7$var$CELL_SX,
                                    "data-testid": "double-take-gating-cell",
                                    children: draft.vlmEnabled && gateLoaded ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                        checked: draft.gateEnabled,
                                        disabled: !editMode || !isStaff,
                                        color: "warning",
                                        inputProps: {
                                            "aria-label": "FP gating"
                                        },
                                        onChange: (event)=>{
                                            const gateEnabled = event.target.checked;
                                            setDraft((previous)=>({
                                                    ...previous,
                                                    gateEnabled: gateEnabled
                                                }));
                                        }
                                    }) : "--"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    colSpan: $0d60bdd24f3d3ac7$var$COLUMN_COUNT - 2,
                                    sx: {
                                        fontFamily: "Mulish",
                                        color: "#6b7280"
                                    },
                                    children: error ? /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                        role: "alert",
                                        className: "text-red-700",
                                        children: error
                                    }) : editMode && noAccessButOn && $0d60bdd24f3d3ac7$export$175eb5a1973ba0da
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};

});



parcelRegister("jjo0k", function(module, exports) {

$parcel$export(module.exports, "handleCheckForOverlappingSchedulesWithShareProducts", () => $1f7c9932d2f8f6ca$export$47c1418c70565c58);
parcelRequire("8T3gX");

var $bitEk = parcelRequire("bitEk");
parcelRequire("elyck");
var $h5bv8 = parcelRequire("h5bv8");
const $1f7c9932d2f8f6ca$export$47c1418c70565c58 = (timeRanges, duskToDawnLocation, matchingSchedules, siteSchedules, schedulesIndex)=>{
    // Create a deep copy instead of a reference
    const previousSiteSchedules = JSON.parse(JSON.stringify(siteSchedules));
    if (previousSiteSchedules.length === 0 && !window.location.pathname.includes("addschedule")) return;
    const returnArray = [];
    let duskToDawnStartTime;
    let duskToDawnEndTime;
    if (!window.location.pathname.includes("addschedule")) {
        if (previousSiteSchedules[schedulesIndex]) {
            const currentSchedule = previousSiteSchedules[schedulesIndex].schedule;
            currentSchedule.forEach((schedule)=>{
                if (schedule.location_dusk_dawn) {
                    duskToDawnStartTime = schedule.start_time;
                    duskToDawnEndTime = schedule.end_time;
                }
            });
        }
    }
    matchingSchedules.forEach((array)=>{
        const alwaysOn = timeRanges[array[0]] === "Always On";
        const duskToDawn = duskToDawnLocation[array[0]][0];
        const bufferTime = duskToDawnLocation[array[0]][1];
        const endTime = timeRanges[array[0]] === "Always On" ? // timeRanges[array[0]] === "Dusk to Dawn"
        "23:59:59" : timeRanges[array[0]] === "Dusk to Dawn" ? duskToDawnEndTime : `${timeRanges[array[0]].slice(8, 13)}:00`;
        const startTime = timeRanges[array[0]] === "Always On" ? // timeRanges[array[0]] === "Dusk to Dawn"
        "00:00:00" : timeRanges[array[0]] === "Dusk to Dawn" ? duskToDawnStartTime : `${timeRanges[array[0]].slice(0, 5)}:00`;
        returnArray.push({
            always_on: alwaysOn,
            buffer_time: bufferTime ? bufferTime : 0,
            customer: Number((0, $h5bv8.getNumbersAfterAboutSite)(location.href)),
            day_of_week: array,
            enabled: true,
            end_time: endTime === "24:00:00" ? "23:59:59" : endTime,
            is_overide: false,
            location_dusk_dawn: duskToDawn,
            start_time: startTime
        });
    });
    if (previousSiteSchedules[schedulesIndex]) previousSiteSchedules[schedulesIndex].schedule = returnArray;
    return (0, $bitEk.handleCheckOverlappingSchedulesForSharedProducts)(previousSiteSchedules);
};

});



parcelRegister("feyZu", function(module, exports) {

$parcel$export(module.exports, "overnightOverlapWarning", () => $753e2108033b9a31$export$bde309b55dace638);
/**
 * Confirm text when saved flex schedules share a product and overlap after
 * midnight (ENG-1970). Product names come from the cached product list.
 */ const $753e2108033b9a31$export$bde309b55dace638 = (productIds)=>{
    let names = [];
    try {
        const products = JSON.parse(localStorage.getItem("products") || "[]");
        const byId = new Map(products.map((product)=>[
                product.id,
                product.name
            ]));
        names = productIds.map((id)=>byId.get(id) ?? `product ${id}`);
    } catch  {
        names = productIds.map((id)=>`product ${id}`);
    }
    return `Two schedules both run ${names.join(", ")} at the same time after midnight, ` + `so those alerts will arrive twice during the overlap. We recommend changing ` + `the schedule times so they don't overlap.\n\nSave anyway?`;
};

});

parcelRegister("aqMJ2", function(module, exports) {

$parcel$export(module.exports, "arrangeScheduleHealthMetricsAutopatrol", () => $809c4b1e987baba3$export$3275d8e843babaf8);
parcelRequire("8T3gX");
const $809c4b1e987baba3$export$3275d8e843babaf8 = (healthMetricsArray)=>{
    const metricOrder = [
        "scene_change_check",
        "stream_quality_check",
        "image_quality_check",
        "motion_status_check",
        "recording_check",
        "connectivity_check"
    ];
    const metricsByType = (healthMetricsArray || []).reduce((acc, item)=>{
        const metricType = item?.metric_type?.value;
        if (metricType) acc[metricType] = item;
        return acc;
    }, {});
    const orderedKnownMetrics = metricOrder.map((metricType)=>metricsByType[metricType]).filter(Boolean);
    const remainingMetrics = (healthMetricsArray || []).filter((item)=>{
        const metricType = item?.metric_type?.value;
        return !metricOrder.includes(metricType);
    });
    return [
        ...orderedKnownMetrics,
        ...remainingMetrics
    ];
};

});

parcelRegister("a8BPe", function(module, exports) {

$parcel$export(module.exports, "getNumbersAfterSites", () => $98091ef4cb0be47b$export$62f493f291feb370);
$parcel$export(module.exports, "getNumbersAfterEditCamera", () => $98091ef4cb0be47b$export$88bda3d6cec839a8);
$parcel$export(module.exports, "editCameraIdFromUrl", () => $98091ef4cb0be47b$export$94072b76e13307e4);
$parcel$export(module.exports, "recordEditCameraOpened", () => $98091ef4cb0be47b$export$d5ad09e369496af2);
const $98091ef4cb0be47b$export$62f493f291feb370 = (url)=>{
    const match = url.match(/\/sites\/(\d+)/);
    if (match) return match[1];
    else return "";
};
const $98091ef4cb0be47b$export$88bda3d6cec839a8 = (url)=>{
    const match = url.match(/\/editcamera\/(\d+)/);
    if (match) return match[1];
    else return "";
};
const $98091ef4cb0be47b$export$94072b76e13307e4 = (url = window.location.href)=>$98091ef4cb0be47b$export$88bda3d6cec839a8(url) || localStorage.currentCameraId || "";
const $98091ef4cb0be47b$export$d5ad09e369496af2 = (url = window.location.href)=>{
    localStorage.setItem("editCamerActiveTab", "one");
    const cameraId = $98091ef4cb0be47b$export$88bda3d6cec839a8(url);
    if (cameraId) localStorage.setItem("currentCameraId", cameraId);
};

});

parcelRegister("iMum1", function(module, exports) {

$parcel$export(module.exports, "backendToFrontendDirection", () => $fe38060d4eff5622$export$8c03aafdebe217e4);
$parcel$export(module.exports, "isLegacyDirectionFormat", () => $fe38060d4eff5622$export$857e51f486dd2835);
$parcel$export(module.exports, "useEditLineCrossingsStore", () => $fe38060d4eff5622$export$8f8e1b11597af3);

var $9OjAn = parcelRequire("9OjAn");

var $fLtYK = parcelRequire("fLtYK");

var $195EM = parcelRequire("195EM");

var $815yO = parcelRequire("815yO");

var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");

var $1Xths = parcelRequire("1Xths");

var $2wOL1 = parcelRequire("2wOL1");
/**
 * Determines if Side A is on the left side of the screen based on line coordinates.
 * Side A is defined as clockwise from Point 1, Side B is clockwise from Point 2.
 *
 * For non-horizontal lines:
 * - If dy < 0 (point 2 above point 1): Side A is on the left
 * - If dy > 0 (point 2 below point 1): Side A is on the right
 *
 * For horizontal lines (dy = 0), the backend treats top as "left" and bottom as "right":
 * - If dx > 0 (point 2 to the right): Side A is below = right
 * - If dx < 0 (point 2 to the left): Side A is above = left
 */ const $fe38060d4eff5622$var$isSideAOnLeft = (coordinates)=>{
    const [point1, point2] = coordinates;
    const dx = point2[0] - point1[0];
    const dy = point2[1] - point1[1];
    if (dy !== 0) // Non-horizontal line: Side A is left if point 2 is above point 1
    return dy < 0;
    else // Horizontal line: top = left, bottom = right
    // If dx > 0, Side A is below (right). If dx < 0, Side A is above (left).
    return dx < 0;
};
const $fe38060d4eff5622$export$8c03aafdebe217e4 = (rawBackendDirection, coordinates)=>{
    // ENG-1317: case-insensitive; see normalizeBackendDirection.
    const backendDirection = (0, $fLtYK.normalizeBackendDirection)(rawBackendDirection);
    if (backendDirection === "both") return "Both";
    const sideAIsLeft = $fe38060d4eff5622$var$isSideAOnLeft(coordinates);
    if (backendDirection === "l2r") // Left to right crossing
    return sideAIsLeft ? "AtoB" : "BtoA";
    else // Right to left crossing (r2l)
    return sideAIsLeft ? "BtoA" : "AtoB";
};
const $fe38060d4eff5622$export$1c3c31aca35d7966 = (frontendDirection, coordinates)=>{
    if (frontendDirection === "Both") return "both";
    const sideAIsLeft = $fe38060d4eff5622$var$isSideAOnLeft(coordinates);
    if (frontendDirection === "AtoB") // Crossing from A to B
    return sideAIsLeft ? "l2r" : "r2l";
    else // Crossing from B to A
    return sideAIsLeft ? "r2l" : "l2r";
};
const $fe38060d4eff5622$export$857e51f486dd2835 = (direction)=>{
    return direction === "AtoB" || direction === "BtoA" || direction === "Both";
};
const $fe38060d4eff5622$export$5e71be90f36266b0 = (legacyDirection, coordinates)=>{
    if (legacyDirection === "Both") return "both";
    return $fe38060d4eff5622$export$1c3c31aca35d7966(legacyDirection, coordinates);
};
const $fe38060d4eff5622$export$95a548407beff47b = 20;
const $fe38060d4eff5622$export$50fbc37ec82460d4 = (coordinates, width, height)=>{
    return [
        [
            coordinates[0][0] * width + $fe38060d4eff5622$export$95a548407beff47b,
            coordinates[0][1] * height + $fe38060d4eff5622$export$95a548407beff47b
        ],
        [
            coordinates[1][0] * width + $fe38060d4eff5622$export$95a548407beff47b,
            coordinates[1][1] * height + $fe38060d4eff5622$export$95a548407beff47b
        ]
    ];
};
const $fe38060d4eff5622$export$b74c5d6d3402b949 = (coordinates, width, height)=>{
    return [
        [
            (coordinates[0][0] - $fe38060d4eff5622$export$95a548407beff47b) / width,
            (coordinates[0][1] - $fe38060d4eff5622$export$95a548407beff47b) / height
        ],
        [
            (coordinates[1][0] - $fe38060d4eff5622$export$95a548407beff47b) / width,
            (coordinates[1][1] - $fe38060d4eff5622$export$95a548407beff47b) / height
        ]
    ];
};
const $fe38060d4eff5622$var$parsePresetOptions = (data)=>{
    const rows = Array.isArray(data?.results) ? data.results : Array.isArray(data) ? data : [];
    return rows.map((row)=>({
            id: Number(row?.id),
            name: String(row?.name ?? "")
        })).filter((row)=>Number.isFinite(row.id) && row.id > 0).map((row)=>({
            id: row.id,
            name: row.name.trim() || `Preset #${row.id}`
        }));
};
/**
 * Map one `/line_crossing/` API row to the editor's `Line` shape: backend
 * percentage coordinates → canvas pixels (with padding), backend direction
 * (l2r/r2l/both, or a legacy AtoB/BtoA/Both value) → frontend direction.
 */ const $fe38060d4eff5622$var$toFrontendLine = (line, displayDimensions, color)=>{
    const frontendCoordinates = $fe38060d4eff5622$export$50fbc37ec82460d4(line.coordinates, displayDimensions.width, displayDimensions.height);
    let frontendDirection;
    if ($fe38060d4eff5622$export$857e51f486dd2835(line.direction || "")) // Legacy format - use as-is since it's already in frontend format
    frontendDirection = line.direction || "Both";
    else // New backend format - convert to frontend format
    frontendDirection = $fe38060d4eff5622$export$8c03aafdebe217e4(line.direction || "both", line.coordinates);
    return {
        id: line.id,
        camera: line.camera,
        metric_labels: line.metric_labels || [],
        coordinates: frontendCoordinates,
        direction: frontendDirection,
        preset: line.preset ?? null,
        color: color
    };
};
const $fe38060d4eff5622$var$resizeImageLineCrossings = (input)=>{
    if (input) {
        const [widthStr, heightStr] = input.split("x").map((str)=>parseInt(str.trim()));
        const aspectRatio = widthStr / heightStr;
        let adjustedWidth = widthStr;
        let adjustedHeight = heightStr;
        if (adjustedWidth / aspectRatio > 360) {
            adjustedWidth = 640;
            adjustedHeight = adjustedWidth / aspectRatio;
        } else {
            adjustedHeight = 360;
            adjustedWidth = adjustedHeight * aspectRatio;
        }
        if (adjustedWidth > 640) {
            adjustedWidth = 640;
            adjustedHeight = adjustedWidth / aspectRatio;
        }
        if (adjustedHeight > 360) {
            adjustedHeight = 360;
            adjustedWidth = adjustedHeight * aspectRatio;
        }
        return {
            width: adjustedWidth,
            height: adjustedHeight
        };
    } else return {
        height: 360,
        width: 640
    };
};
const $fe38060d4eff5622$export$8f8e1b11597af3 = (0, $9OjAn.create)((set, get)=>({
        // Lines array
        lines: [],
        setLines: (lines)=>set({
                lines: lines
            }),
        // Original lines
        originalLines: [],
        setOriginalLines: (originalLines)=>set({
                originalLines: originalLines
            }),
        // Current line being drawn
        currentLine: null,
        setCurrentLine: (currentLine)=>set({
                currentLine: currentLine
            }),
        // Drawing state
        isDrawing: false,
        setIsDrawing: (isDrawing)=>set({
                isDrawing: isDrawing
            }),
        // Selected line index
        selectedLineIndex: null,
        setSelectedLineIndex: (selectedLineIndex)=>set({
                selectedLineIndex: selectedLineIndex
            }),
        // Line color
        lineColor: "#FF8400",
        setLineColor: (lineColor)=>set({
                lineColor: lineColor
            }),
        // Image dimensions
        imageWidth: 720,
        imageHeight: 576,
        setImageDimensions: (width, height)=>set({
                imageWidth: width,
                imageHeight: height
            }),
        // Adjusted dimensions
        adjustedDimensions: {
            x: 720,
            y: 576
        },
        setAdjustedDimensions: (adjustedDimensions)=>set({
                adjustedDimensions: adjustedDimensions
            }),
        // Dimensions object
        dimensions: {
            width: 640,
            height: 360
        },
        setDimensions: (dimensions)=>set({
                dimensions: dimensions
            }),
        // Image URL
        imageURL: "",
        setImageURL: (imageURL)=>set({
                imageURL: imageURL
            }),
        // Page loading state
        pageLoading: true,
        setPageLoading: (pageLoading)=>set({
                pageLoading: pageLoading
            }),
        // Edits made flag
        editsMade: false,
        setEditsMade: (editsMade)=>set({
                editsMade: editsMade
            }),
        // Editor visible state
        editorVisible: false,
        setEditorVisible: (editorVisible)=>set({
                editorVisible: editorVisible
            }),
        // Breadcrumbs
        breadcrumbs: [],
        setBreadcrumbs: (breadcrumbs)=>set({
                breadcrumbs: breadcrumbs
            }),
        // Camera info
        cameraInfo: {
            camera_name: ""
        },
        setCameraInfo: (cameraInfo)=>set({
                cameraInfo: cameraInfo
            }),
        // Metric labels
        metricLabels: [],
        setMetricLabels: (metricLabels)=>set({
                metricLabels: metricLabels
            }),
        // Update line direction
        updateLineDirection: (lineIndex, direction)=>{
            const { lines: lines } = get();
            const updatedLines = [
                ...lines
            ];
            if (updatedLines[lineIndex]) {
                updatedLines[lineIndex] = {
                    ...updatedLines[lineIndex],
                    direction: direction
                };
                set({
                    lines: updatedLines,
                    editsMade: true
                });
            }
        },
        // Update line metric labels
        updateLineMetricLabels: (lineIndex, metricLabels)=>{
            const { lines: lines } = get();
            const updatedLines = [
                ...lines
            ];
            if (updatedLines[lineIndex]) {
                updatedLines[lineIndex] = {
                    ...updatedLines[lineIndex],
                    metric_labels: metricLabels
                };
                set({
                    lines: updatedLines,
                    editsMade: true
                });
            }
        },
        // Get all page info
        getAllEditLineCrossingsPageInfo: async (navigate)=>{
            const { getAllEditLineCrossingsPageInfo: getAllEditLineCrossingsPageInfo, setDimensions: setDimensions, setImageURL: setImageURL, setPageLoading: setPageLoading, setBreadcrumbs: setBreadcrumbs, setCameraInfo: setCameraInfo, setMetricLabels: setMetricLabels, setLines: setLines, setOriginalLines: setOriginalLines, setLineCrossingActive: setLineCrossingActive } = get();
            const AxiosUI = (0, $195EM.createApi)(``);
            const cameraId = (0, $a8BPe.getNumbersAfterEditCamera)(location.href);
            // `?preset=<id>` pre-selects a configuration (Site About passes its picker).
            const requestedPresetId = (0, $2wOL1.parseLineCrossingsPresetIdFromHref)(location.href);
            const retryFunction = ()=>{
                getAllEditLineCrossingsPageInfo(navigate);
            };
            try {
                // Run API calls concurrently using Promise.all. The preset list is
                // optional context for the configuration switcher, so its failure must
                // not take the page down with it.
                const [cameraStatusResponse, customerAboutResponse, metricsResponse, lineCrossingsResponse, generalInfoResponse, presetsResponse] = await Promise.all([
                    AxiosUI.get(`/camera/${cameraId}/status/`),
                    AxiosUI.get(`/customer/${(0, $a8BPe.getNumbersAfterSites)(location.href)}/about/`),
                    AxiosUI.get(`/metric/?camera_id=${cameraId}`),
                    AxiosUI.get((0, $2wOL1.buildLineCrossingsListPath)(cameraId, requestedPresetId)),
                    AxiosUI.get(`/camera/${cameraId}/general_info/`),
                    AxiosUI.get(`/preset/?camera=${cameraId}`).catch(()=>null)
                ]);
                const cameraPresets = presetsResponse ? $fe38060d4eff5622$var$parsePresetOptions(presetsResponse.data) : [];
                // Keep a requested preset even if the list could not be loaded (the
                // lines above were already fetched for it); drop it only when the
                // list loaded and proves it is not one of this camera's presets.
                const selectedPresetId = requestedPresetId != null && (presetsResponse == null || cameraPresets.some((preset)=>preset.id === requestedPresetId)) ? requestedPresetId : null;
                set({
                    cameraPresets: cameraPresets,
                    selectedPresetId: selectedPresetId
                });
                // The lines above were fetched for the requested preset. If that
                // preset was just rejected (deleted, or another camera's id in a
                // stale link) the page is now showing Default, so it needs Default's
                // lines rather than the rejected preset's (usually empty) list.
                const linesResponse = selectedPresetId === requestedPresetId ? lineCrossingsResponse : await AxiosUI.get((0, $2wOL1.buildLineCrossingsListPath)(cameraId, null));
                // Process all responses
                const displayDimensions = $fe38060d4eff5622$var$resizeImageLineCrossings(cameraStatusResponse.data.frame_dimensions);
                setDimensions(displayDimensions);
                setCameraInfo(cameraStatusResponse.data);
                setImageURL(cameraStatusResponse.data.preview_url);
                setBreadcrumbs(customerAboutResponse.data.breadcrumbs);
                // Filter metrics to only include intruder_line_crossing, vehicle_line_crossing, bike_line_crossing
                const allowedLabels = [
                    "intruder_line_crossing",
                    "vehicle_line_crossing",
                    "bike_line_crossing"
                ];
                const filteredMetrics = metricsResponse.data.results.filter((metric)=>allowedLabels.includes(metric.label_name)).map((metric)=>({
                        id: metric.label,
                        label_name: metric.label_name
                    }));
                setMetricLabels(filteredMetrics);
                // Extract lineCrossingActive state from general_info response
                const streams = generalInfoResponse.data.streams || [];
                let intruderLineCrossingActive = false;
                let vehicleLineCrossingActive = false;
                streams.forEach((stream)=>{
                    const streamMetrics = stream.stream_metrics || [];
                    streamMetrics.forEach((metric)=>{
                        if (metric.label_name === "intruder_line_crossing" && metric.active) intruderLineCrossingActive = true;
                        if (metric.label_name === "vehicle_line_crossing" && metric.active) vehicleLineCrossingActive = true;
                    });
                });
                setLineCrossingActive({
                    intruder: intruderLineCrossingActive,
                    vehicle: vehicleLineCrossingActive
                });
                // Process line crossings - assign colors to each line
                // Convert backend direction format (l2r/r2l/both) to frontend format (AtoB/BtoA/Both)
                const lineCrossings = linesResponse.data.results || [];
                // Check for legacy direction formats and migrate them
                const legacyLines = lineCrossings.filter((line)=>line.direction && $fe38060d4eff5622$export$857e51f486dd2835(line.direction));
                if (legacyLines.length > 0) {
                    // Migrate legacy directions to new format by patching them
                    const migrationPromises = legacyLines.map((line)=>{
                        const correctedDirection = $fe38060d4eff5622$export$5e71be90f36266b0(line.direction, line.coordinates);
                        return AxiosUI.patch(`/line_crossing/${line.id}/`, {
                            direction: correctedDirection
                        });
                    });
                    // Wait for all migrations to complete (fire and forget - don't block UI)
                    Promise.all(migrationPromises).catch((error)=>{
                        console.warn("Failed to migrate some legacy line crossing directions:", error);
                    });
                }
                const processedLines = lineCrossings.map((line, index)=>$fe38060d4eff5622$var$toFrontendLine(line, displayDimensions, (0, $1Xths.LINE_COLORS)[index % (0, $1Xths.LINE_COLORS).length]));
                setLines(processedLines);
                setOriginalLines(processedLines);
                // Set loading to false only after all requests complete successfully
                setPageLoading(false);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    alert("Unable to load page information. Please try refreshing the page.");
                    setPageLoading(false);
                });
            }
        },
        selectedPresetId: null,
        cameraPresets: [],
        switchConfiguration: async (navigate, presetId)=>{
            const { editorVisible: editorVisible, dimensions: dimensions, setPageLoading: setPageLoading, setLines: setLines, setOriginalLines: setOriginalLines, setSelectedLineIndex: setSelectedLineIndex } = get();
            if (editorVisible) // Unsaved edits belong to the current configuration; the page keeps the
            // switcher disabled in edit mode, this is the belt to that braces.
            return;
            const cameraId = (0, $a8BPe.getNumbersAfterEditCamera)(location.href);
            const retryFunction = ()=>{
                get().switchConfiguration(navigate, presetId);
            };
            const AxiosUI = (0, $195EM.createApi)(``);
            // Commit the new configuration only once its lines are in hand; until
            // then the lines on screen still belong to the previous one, and a
            // save against a mislabeled list would write into the wrong configuration.
            const previousPresetId = get().selectedPresetId;
            set({
                pageLoading: true
            });
            try {
                const lineCrossingsResponse = await AxiosUI.get((0, $2wOL1.buildLineCrossingsListPath)(cameraId, presetId));
                const lineCrossings = lineCrossingsResponse.data.results || [];
                const processedLines = lineCrossings.map((line, index)=>$fe38060d4eff5622$var$toFrontendLine(line, dimensions, (0, $1Xths.LINE_COLORS)[index % (0, $1Xths.LINE_COLORS).length]));
                set({
                    selectedPresetId: presetId
                });
                setLines(processedLines);
                setOriginalLines(processedLines);
                setSelectedLineIndex(null);
                setPageLoading(false);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    alert("Unable to load line crossings for this configuration. Please try again.");
                    // The page rewrote the URL before calling us; put it back so a
                    // refresh reopens the configuration whose lines are still shown.
                    navigate({
                        search: (0, $2wOL1.lineCrossingsPresetSearch)(previousPresetId)
                    }, {
                        replace: true
                    });
                    setPageLoading(false);
                });
            }
        },
        // Post/Patch line crossings
        handlePostLineCrossings: async (navigate)=>{
            const { handlePostLineCrossings: handlePostLineCrossings, lines: lines, originalLines: originalLines, dimensions: dimensions, selectedPresetId: selectedPresetId, setPageLoading: setPageLoading, setLines: setLines, setOriginalLines: setOriginalLines, setEditorVisible: setEditorVisible, setEditsMade: setEditsMade } = get();
            const AxiosUI = (0, $195EM.createApi)(``);
            const cameraId = (0, $a8BPe.getNumbersAfterEditCamera)(location.href);
            const retryFunction = ()=>{
                handlePostLineCrossings(navigate);
            };
            try {
                // Find lines that were deleted during edit mode
                // (lines that existed in originalLines but are no longer in lines)
                const currentLineIds = new Set(lines.map((l)=>l.id).filter(Boolean));
                const deletedLines = originalLines.filter((ol)=>ol.id && !currentLineIds.has(ol.id));
                // Create array of promises for DELETE calls
                const deletePromises = deletedLines.map((line)=>AxiosUI.delete(`/line_crossing/${line.id}/`));
                // Create array of promises for POST/PATCH calls
                const apiPromises = lines.map((line)=>{
                    // Convert frontend coordinates (pixels with padding) to backend coordinates (percentages)
                    const backendCoordinates = $fe38060d4eff5622$export$b74c5d6d3402b949(line.coordinates, dimensions.width, dimensions.height);
                    // Prepare line data for API (exclude color which is for rendering only)
                    // Convert frontend direction format (AtoB/BtoA/Both) to backend format (l2r/r2l/both)
                    // Use backend coordinates for direction calculation since that's what the backend uses
                    const lineData = {
                        camera: line.camera,
                        metric_labels: line.metric_labels,
                        coordinates: backendCoordinates,
                        direction: $fe38060d4eff5622$export$1c3c31aca35d7966(line.direction, backendCoordinates)
                    };
                    if (!line.id) // New line - POST without id. A line created while a named
                    // configuration is loaded belongs to that preset; Default lines
                    // omit the field (the API defaults `preset` to null).
                    return AxiosUI.post(`/line_crossing/`, selectedPresetId != null ? {
                        ...lineData,
                        preset: selectedPresetId
                    } : lineData);
                    else {
                        // Existing line - check if it was modified
                        const originalLine = originalLines.find((ol)=>ol.id === line.id);
                        const wasModified = !originalLine || JSON.stringify({
                            metric_labels: originalLine.metric_labels,
                            coordinates: originalLine.coordinates,
                            direction: originalLine.direction
                        }) !== JSON.stringify({
                            metric_labels: line.metric_labels,
                            coordinates: line.coordinates,
                            direction: line.direction
                        });
                        if (wasModified) // Modified existing line - PATCH with id
                        return AxiosUI.patch(`/line_crossing/${line.id}/`, lineData);
                        // No changes to this line - return resolved promise
                        return Promise.resolve();
                    }
                });
                // Wait for all API calls to complete (deletes + posts/patches)
                await Promise.all([
                    ...deletePromises,
                    ...apiPromises
                ]);
                // Saving no longer auto-syncs. Mark the site as having unsynced
                // changes; the operator syncs explicitly via the edit-view Sync control.
                (0, $815yO.markSiteUnsynced)();
                // Fetch updated lines from API to get proper IDs (same configuration)
                const lineCrossingsResponse = await AxiosUI.get((0, $2wOL1.buildLineCrossingsListPath)(cameraId, selectedPresetId));
                const lineCrossings = lineCrossingsResponse.data.results || [];
                // Build a map of existing line colors to preserve them
                // For existing lines, use their ID; for new lines, use backend coordinates as key
                const existingColorMap = new Map();
                lines.forEach((line)=>{
                    if (line.id) existingColorMap.set(`id:${line.id}`, line.color);
                    // Also map by backend coordinates (percentages) for newly created lines
                    const backendCoords = $fe38060d4eff5622$export$b74c5d6d3402b949(line.coordinates, dimensions.width, dimensions.height);
                    const coordKey = `coords:${JSON.stringify(backendCoords)}`;
                    existingColorMap.set(coordKey, line.color);
                });
                const processedLines = lineCrossings.map((line, index)=>{
                    // Try to find existing color by ID first, then by coordinates
                    const existingColorById = existingColorMap.get(`id:${line.id}`);
                    const existingColorByCoords = existingColorMap.get(`coords:${JSON.stringify(line.coordinates)}`);
                    const existingColor = existingColorById || existingColorByCoords;
                    // Convert backend coordinates (percentages) to frontend coordinates (pixels with padding)
                    const frontendCoordinates = $fe38060d4eff5622$export$50fbc37ec82460d4(line.coordinates, dimensions.width, dimensions.height);
                    // Handle both legacy and new formats
                    let frontendDirection;
                    if ($fe38060d4eff5622$export$857e51f486dd2835(line.direction || "")) // Legacy format - use as-is since it's already in frontend format
                    frontendDirection = line.direction || "Both";
                    else // New backend format - convert to frontend format
                    frontendDirection = $fe38060d4eff5622$export$8c03aafdebe217e4(line.direction || "both", line.coordinates);
                    return {
                        id: line.id,
                        camera: line.camera,
                        metric_labels: line.metric_labels || [],
                        coordinates: frontendCoordinates,
                        direction: frontendDirection,
                        // Preserve existing color if available, otherwise assign new one
                        color: existingColor || (0, $1Xths.LINE_COLORS)[index % (0, $1Xths.LINE_COLORS).length]
                    };
                });
                setLines(processedLines);
                setOriginalLines(processedLines);
                // Exit edit mode
                setEditorVisible(false);
                setEditsMade(false);
                // Set loading to false only after all requests complete successfully
                setPageLoading(false);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    alert("Unable to save line crossings. Please try again.");
                    // Reset lines to original state (like cancel)
                    set({
                        lines: [
                            ...originalLines
                        ]
                    });
                    setEditorVisible(false);
                    setEditsMade(false);
                    setPageLoading(false);
                });
            }
        },
        // Delete line crossing dialog
        deleteLineCrossingDialogOpen: false,
        setDeleteLineCrossingDialogOpen: (open)=>set({
                deleteLineCrossingDialogOpen: open
            }),
        lineToDeleteId: null,
        setLineToDeleteId: (id)=>set({
                lineToDeleteId: id
            }),
        // Line crossing active state
        lineCrossingActive: {
            intruder: false,
            vehicle: false
        },
        setLineCrossingActive: (lineCrossingActive)=>set({
                lineCrossingActive: lineCrossingActive
            }),
        // Delete line crossing
        handleDeleteLineCrossing: async (navigate)=>{
            const { handleDeleteLineCrossing: handleDeleteLineCrossing, lines: currentLines, dimensions: dimensions, lineToDeleteId: lineToDeleteId, setPageLoading: setPageLoading, setLines: setLines, setOriginalLines: setOriginalLines, setLineToDeleteId: setLineToDeleteId, setDeleteLineCrossingDialogOpen: setDeleteLineCrossingDialogOpen } = get();
            const AxiosUI = (0, $195EM.createApi)(``);
            const cameraId = (0, $a8BPe.getNumbersAfterEditCamera)(location.href);
            const retryFunction = ()=>{
                handleDeleteLineCrossing(navigate);
            };
            if (!lineToDeleteId) {
                setDeleteLineCrossingDialogOpen(false);
                setPageLoading(false);
                return;
            }
            try {
                // Delete the line crossing
                await AxiosUI.delete(`/line_crossing/${lineToDeleteId}/`);
                // Deleting a line crossing no longer auto-syncs. Mark the site as
                // having unsynced changes; the operator syncs explicitly via the
                // edit-view Sync control.
                (0, $815yO.markSiteUnsynced)();
                // Fetch updated lines (same configuration)
                const lineCrossingsResponse = await AxiosUI.get((0, $2wOL1.buildLineCrossingsListPath)(cameraId, get().selectedPresetId));
                const lineCrossings = lineCrossingsResponse.data.results || [];
                // Build a map of existing line colors to preserve them
                const existingColorMap = new Map();
                currentLines.forEach((line)=>{
                    if (line.id) existingColorMap.set(line.id, line.color);
                });
                const processedLines = lineCrossings.map((line, index)=>{
                    // Convert backend coordinates (percentages) to frontend coordinates (pixels with padding)
                    const frontendCoordinates = $fe38060d4eff5622$export$50fbc37ec82460d4(line.coordinates, dimensions.width, dimensions.height);
                    // Handle both legacy and new formats
                    let frontendDirection;
                    if ($fe38060d4eff5622$export$857e51f486dd2835(line.direction || "")) // Legacy format - use as-is since it's already in frontend format
                    frontendDirection = line.direction || "Both";
                    else // New backend format - convert to frontend format
                    frontendDirection = $fe38060d4eff5622$export$8c03aafdebe217e4(line.direction || "both", line.coordinates);
                    return {
                        id: line.id,
                        camera: line.camera,
                        metric_labels: line.metric_labels || [],
                        coordinates: frontendCoordinates,
                        direction: frontendDirection,
                        // Preserve existing color if available, otherwise assign new one
                        color: existingColorMap.get(line.id) || (0, $1Xths.LINE_COLORS)[index % (0, $1Xths.LINE_COLORS).length]
                    };
                });
                setLines(processedLines);
                setOriginalLines(processedLines);
                // Reset delete state
                setLineToDeleteId(null);
                setDeleteLineCrossingDialogOpen(false);
                // Set loading to false only after all requests complete successfully
                setPageLoading(false);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    alert("Unable to delete line crossing. Please try again.");
                    setDeleteLineCrossingDialogOpen(false);
                    setPageLoading(false);
                });
            }
        }
    }));

});
parcelRegister("fLtYK", function(module, exports) {

$parcel$export(module.exports, "normalizeBackendDirection", () => $18ba43dc2fc8d733$export$8313a19240e09f23);
/**
 * The backend's line-crossing `direction` as the three values the UI reasons
 * about. Case- and whitespace-insensitive (ENG-1317): the Django admin dropdown
 * writes `L2R`/`R2L`/`BOTH`, this UI writes `l2r`/`r2l`/`both`, and the model
 * validates nothing. A strict `=== "l2r"` comparison sent every uppercase row
 * down the R2L branch, so `L2R` rendered as R2L and `BOTH` as a single arrow —
 * and saving the page wrote the wrong value back. Unknown values render as
 * "Both", which is also how the connector treats them.
 */ const $18ba43dc2fc8d733$export$8313a19240e09f23 = (raw)=>{
    const key = String(raw ?? "both").trim().toLowerCase();
    if (key === "l2r" || key === "left_to_right") return "l2r";
    if (key === "r2l" || key === "right_to_left") return "r2l";
    return "both";
};

});

parcelRegister("dfWDO", function(module, exports) {

$parcel$export(module.exports, "EditCamera", () => $770f21171eb1d420$export$942f9b2f43de8244);
$parcel$export(module.exports, "getNumbersAfterSites", () => (parcelRequire("a8BPe")).getNumbersAfterSites);
$parcel$export(module.exports, "getNumbersAfterEditCamera", () => (parcelRequire("a8BPe")).getNumbersAfterEditCamera);
/**
 * EditCamera Component
 *
 * Note: This component has been updated to handle localStorage quota issues.
 * Large camera objects are no longer stored in localStorage to prevent
 * "QuotaExceededError" exceptions. Only essential camera info (id, name, type)
 * is stored using the safeSetItem utility function.
 */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $jVN1H = parcelRequire("jVN1H");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $8jTCz = parcelRequire("8jTCz");

var $8ZARq = parcelRequire("8ZARq");

var $8gqnT = parcelRequire("8gqnT");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $6pdiI = parcelRequire("6pdiI");

var $iWyxG = parcelRequire("iWyxG");

var $j5jOb = parcelRequire("j5jOb");

var $2sriY = parcelRequire("2sriY");

var $aZdoQ = parcelRequire("aZdoQ");

var $dHtmK = parcelRequire("dHtmK");

var $4KzIO = parcelRequire("4KzIO");

var $aqdBl = parcelRequire("aqdBl");

var $gBjZk = parcelRequire("gBjZk");

var $crpct = parcelRequire("crpct");

var $6oEZE = parcelRequire("6oEZE");

var $02she = parcelRequire("02she");

var $7TDDC = parcelRequire("7TDDC");

var $fXzUh = parcelRequire("fXzUh");

var $lPFIv = parcelRequire("lPFIv");

var $jDWxC = parcelRequire("jDWxC");

var $h0DCc = parcelRequire("h0DCc");

var $kZIQb = parcelRequire("kZIQb");

var $2hXui = parcelRequire("2hXui");

var $frXOV = parcelRequire("frXOV");

var $2qUoo = parcelRequire("2qUoo");

var $a65wX = parcelRequire("a65wX");
var $5GP2e = parcelRequire("5GP2e");
var $cVCJe = parcelRequire("cVCJe");

var $i5LXy = parcelRequire("i5LXy");

var $7DeOh = parcelRequire("7DeOh");

var $gouAT = parcelRequire("gouAT");

var $8quhT = parcelRequire("8quhT");

var $k3urr = parcelRequire("k3urr");

var $7R3rw = parcelRequire("7R3rw");

var $4M4T1 = parcelRequire("4M4T1");

var $dDwzT = parcelRequire("dDwzT");

var $6aUtL = parcelRequire("6aUtL");

var $85F5S = parcelRequire("85F5S");

var $7mN1J = parcelRequire("7mN1J");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

var $aZxZ3 = parcelRequire("aZxZ3");

var $cgrVY = parcelRequire("cgrVY");

var $gyvxI = parcelRequire("gyvxI");

var $bR0RS = parcelRequire("bR0RS");

var $hdv6W = parcelRequire("hdv6W");

var $6pQI1 = parcelRequire("6pQI1");

var $8ISah = parcelRequire("8ISah");

var $4PFLW = parcelRequire("4PFLW");

var $2nm0w = parcelRequire("2nm0w");

var $a8BPe = parcelRequire("a8BPe");
const $770f21171eb1d420$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $770f21171eb1d420$export$f5172043e17f66eb = (url)=>{
    const match = url.match(/\/aboutsite\/(\d+)/);
    if (match) return match[1];
    else return "";
};
const $770f21171eb1d420$export$942f9b2f43de8244 = ({ permissions: permissions, navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed })=>{
    const { backdropLoadingScreenEditCameraOn: backdropLoadingScreenEditCameraOn, deleteWebhookDialogOpen: deleteWebhookDialogOpen, resetEditCameraStore: resetEditCameraStore, notesDialogEditCameraOpen: notesDialogEditCameraOpen, deleteAlertDialogOpen: deleteAlertDialogOpen, addSysaidAlertDialogOpen: addSysaidAlertDialogOpen, lineCrossingActive: lineCrossingActive } = (0, $aZxZ3.useEditCameraStore)();
    const { isFeatureEnabled: isFeatureEnabled } = (0, $4PFLW.useFeatureFlag)();
    const showFlexIgnoreZonesFlag = isFeatureEnabled("showFlexIgnoreZones", false);
    /** Ref so async getEditCameraData completion reads latest LD value for flex backdrop hold. */ const holdFlexBackdropAfterLoadRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(false);
    holdFlexBackdropAfterLoadRef.current = showFlexIgnoreZonesFlag;
    const [editCameraInitialFlexHydrationDone, setEditCameraInitialFlexHydrationDone] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [editPageLoadProgressPercent, setEditPageLoadProgressPercent] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(undefined);
    const [editPageLoadProgressMessage, setEditPageLoadProgressMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("Loading camera data...");
    // Ref to track if component is mounted - prevents state updates after unmount
    const isMountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(true);
    const [cameraDataLoaded, setCameraDataLoaded] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [cameraObject, setCameraObject] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [siteInfo, setSiteInfo] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [clickedTab, setClickedTab] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("one");
    const [editMode, setEditMode] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [addImmixAlertDialogOpen, setAddImmixAlertDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [addDiceAlertDialogOpen, setAddDiceAlertDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [addSureviewAlertDialogOpen, setAddSureviewAlertDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [addSentinelAlertDialogOpen, setAddSentinelAlertDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [addBoldAlertDialogOpen, setAddBoldAlertDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [addPatriotAlertDialogOpen, setAddPatriotAlertDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [addUSMonitoringAlertDialogOpen, setAddUSMonitoringAlertDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [addSoftguardAlertDialogOpen, setAddSoftguardAlertDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [addStreamWebhookDialogOpen, setAddStreamWebhookDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [editStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [deleteImmixAlertDialogOpen, setDeleteImmixAlertDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [deleteDiceAlertDialogOpen, setDeleteDiceAlertDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [productActionLogsDialogOpen, setProductActionLogsDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const { height: height, width: width } = (0, $crpct.default)();
    const [cameraGeneralInfo, setCameraGeneralInfo] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [cameraGeneralInfoBackup, setCameraGeneralInfoBackup] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [patchObject, setPatchObject] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [generalInfoChangesMade, setGeneralInfoChangesMade] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [activeChangeMade, setActiveChangeMade] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [axisCamera, setAxisCamera] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [mobotixCamera, setMobotixCamera] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [activeTab, setActiveTab] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
    const [backdropLoadingScreenOn, setBackdropLoadingScreenOn] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [immixAlertsOnCamera, setImmixAlertsOnCamera] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [immixAlerts, setImmixAlerts] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [diceAlertsOnCamera, setDiceAlertsOnCamera] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [diceAlerts, setDiceAlerts] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [sureViewAlertsOnCamera, setSureViewAlertsOnCamera] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [sureviewAlerts, setSureviewAlerts] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [sentinelAlertsOnCamera, setSentinelAlertsOnCamera] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [sentinelAlerts, setSentinelAlerts] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [boldAlertsOnCamera, setBoldAlertsOnCamera] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [boldAlerts, setBoldAlerts] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [patriotAlertsOnCamera, setPatriotAlertsOnCamera] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [patriotAlerts, setPatriotAlerts] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [uSMonitoringAlertsOnCamera, setUSMonitoringAlertsOnCamera] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [uSMonitoringAlerts, setUSMonitoringAlerts] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [softguardAlertsOnCamera, setSoftguardAlertsOnCamera] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [softguardAlerts, setSoftguardAlerts] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [evalinkAlertsOnCamera, setEvalinkAlertsOnCamera] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [showStreamParameters, setShowStreamParameters] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const handleSitesBreadcrumbClick = (event)=>{
        event.preventDefault();
        localStorage.setItem("level0Click", "false");
        localStorage.setItem("navigatedFromSitesAboutPage", "false");
        navigate("/sites");
    };
    const handleSingularSiteBreadcrumbClick = ()=>{
        navigate(`/sites/aboutsite/${(0, $a8BPe.getNumbersAfterSites)(location.href)}`);
        localStorage.setItem("navigatedFromEditCameraPage", "true");
    };
    const [ignoreZonesBreadCrumbs, setIgnoreZonesBreadCrumbs] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
    const [editCameraAlerts, setEditCameraAlerts] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        triggerMotionSuccess: false,
        triggerMotionFail: false
    });
    const [recipientsConfiguredData, setRecipientsConfiguredData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [titlesArray, setTitlesArray] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([
        "Name",
        "Recipient Type",
        "Host",
        "Port",
        "Email From",
        "Email To"
    ]);
    const [actionRulesData, setActionRulesData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [actionRulesTitlesArray, setActionRulesTitlesArray] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([
        "Name",
        "Host",
        "Port",
        "Email From",
        "Email To",
        "Message",
        "Enabled",
        "Profile"
    ]);
    const [applicationsConfiguredData, setApplicationsConfiguredData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [timeTablesData, setTimeTablesData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [iPNotifyData, setIPNotifyData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [actionHandlerData, setActionHandlerData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [mobotixFinished, setMobotixFinished] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        timeTable: false,
        iPNotify: false,
        actionHandler: false
    });
    const [axisFinished, setAxisFinished] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        recipient: false,
        actionRules: false,
        application: false
    });
    const [streamsObject, setStreamsObject] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [activeProducts, setActiveProducts] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [sendingImmixTest, setSendingImmixTest] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [immixTestSuccessDialogOpen, setImmixTestSuccessDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [immixTestFailDialogOpen, setImmixTestFailDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [sendingDiceTest, setSendingDiceTest] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [diceTestSuccessDialogOpen, setDiceTestSuccessDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [diceTestFailDialogOpen, setDiceTestFailDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [v1RedirectDialogOpen, setv1RedirectDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [srcImages, setSrcImages] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [cameraInfoRow, setCameraInfoRow] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [cameraWebhookData, setCameraWebhookData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [webhooksAlertsOnCamera, setWebhooksAlertsOnCamera] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [cameraWebhooksPatchObject, setCameraWebhooksPatchObject] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [cameraWebhooksChangesMade, setCameraWebhooksChangesMade] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [streamParametersData, setStreamParametersData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [streamParametersPatchObject, setStreamParametersPatchObject] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [streamParametersChangesMade, setStreamParametersChangesMade] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const navigate = (0, $3T949.useNavigate)();
    // const { fetchRecipientsConfiguredData }: any = useAxisTabStore();
    const [productsData, setProductsData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([
        {
            name: "Intruder",
            label_name: "intruder",
            open: false,
            metrics: {}
        },
        {
            name: "Intruder Plus",
            label_name: "intruderPlus",
            open: false,
            metrics: {}
        },
        {
            name: "Motion Plus",
            label_name: "motionPlus",
            open: false,
            metrics: {}
        },
        {
            name: "Gun",
            label_name: "gun",
            open: false,
            metrics: {}
        },
        {
            name: "Crowd",
            label_name: "crowd",
            open: false,
            metrics: {}
        },
        {
            name: "Loitering",
            label_name: "loitering",
            open: false,
            metrics: {}
        },
        {
            name: "Slip and Fall",
            label_name: "fallPerson",
            open: false,
            metrics: {}
        },
        // {
        //   name: "Slip and Fall (old model)",
        //   label_name: "fall",
        //   open: false,
        //   metrics: {
        //     fall: fallMetrics,
        //   },
        // },
        {
            name: "No Hard Hat",
            label_name: "noHardHat",
            open: false,
            metrics: {}
        },
        // { name: "Mask", label_name: "mask", open: false, metrics: {} },
        {
            name: "Social Distancing",
            label_name: "socialDistancing",
            open: false,
            metrics: {}
        },
        // {
        //   name: "Left Object",
        //   label_name: "leftObject",
        //   open: false,
        //   metrics: {},
        // },
        // {
        //   name: "Package",
        //   label_name: "package",
        //   open: false,
        //   metrics: {},
        // },
        {
            name: "Fire",
            label_name: "fire",
            open: false,
            metrics: {}
        },
        {
            name: "Vehicle Logo ID",
            label_name: "vehicleLogoId",
            open: false,
            metrics: {}
        },
        // {
        //   name: "People Flow",
        //   label_name: "peopleFlow",
        //   open: false,
        //   metrics: peopleFlowMetrics,
        // },
        {
            name: "Non-UPS",
            label_name: "nonUps",
            open: false,
            metrics: {}
        }
    ]);
    const [backupProductsData, setBackupProductsData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(productsData);
    const [allTabsOpen, setAllTabsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [allCamerasData, setAllCamerasData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [cameraIndex, setCameraIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        // Reset mounted ref to true on mount
        isMountedRef.current = true;
        resetEditCameraStore();
        if (Number((0, $a8BPe.getNumbersAfterSites)(location.href)) && Number((0, $a8BPe.getNumbersAfterEditCamera)(location.href))) {
            localStorage.setItem("editCamerActiveTab", "one");
            localStorage.setItem("currentCameraId", (0, $a8BPe.getNumbersAfterEditCamera)(location.href));
            (0, $02she.getEditCameraData)(navigate, (0, $a8BPe.getNumbersAfterSites)(location.href), (0, $a8BPe.getNumbersAfterEditCamera)(location.href), setSiteInfo, setCameraGeneralInfo, setCameraObject, setCameraDataLoaded, setBackdropLoadingScreenOn, setImmixAlertsOnCamera, setIgnoreZonesBreadCrumbs, (0, $h0DCc.createIgnoreZonesLinksArray), handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, setSureViewAlertsOnCamera, setAxisCamera, setMobotixFinished, setRecipientsConfiguredData, setTitlesArray, setActionRulesData, setActionRulesTitlesArray, setApplicationsConfiguredData, mobotixFinished, setAxisFinished, axisFinished, setMobotixCamera, setTimeTablesData, setIPNotifyData, setActionHandlerData, setCameraGeneralInfoBackup, setImmixAlerts, setSureviewAlerts, setActiveProducts, setActiveTab, actionRulesTitlesArray, applicationsConfiguredData, cameraGeneralInfo, actionRulesData, setSrcImages, permissions, setCameraInfoRow, width, setCameraWebhookData, setProductsData, setBackupProductsData, setSentinelAlertsOnCamera, setSentinelAlerts, setBoldAlertsOnCamera, setBoldAlerts, setPatriotAlertsOnCamera, setPatriotAlerts, setUSMonitoringAlertsOnCamera, setUSMonitoringAlerts, setWebhooksAlertsOnCamera, setSoftguardAlertsOnCamera, setSoftguardAlerts, setEvalinkAlertsOnCamera, setStreamParametersData, setShowStreamParameters, setEditCameraAlerts, setDiceAlertsOnCamera, setDiceAlerts, ()=>holdFlexBackdropAfterLoadRef.current, isMountedRef);
            (0, $2hXui.getAllCameras)(Number((0, $a8BPe.getNumbersAfterSites)(location.href)), Number((0, $a8BPe.getNumbersAfterEditCamera)(location.href)), setAllCamerasData, setCameraIndex);
        } else navigate("/*");
        // Cleanup function - set mounted to false when component unmounts
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    const editInformationText = /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {
                fontSize: "small"
            }),
            "\xa0Edit Information"
        ]
    });
    const seeAlertText = /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gouAT))), {
                fontSize: "small"
            }),
            "\xa0See Alerts"
        ]
    });
    const [alertsLink, setAlertsLink] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const autopatrolSite = siteInfo.integration_type_name === "autopatrol";
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (siteInfo.breadcrumb_info) setAlertsLink(`/alerts?group=${siteInfo.breadcrumb_info[0].id}&site=${(0, $a8BPe.getNumbersAfterSites)(location.href)}&camera=${(0, $a8BPe.getNumbersAfterEditCamera)(location.href)}`);
    }, [
        siteInfo
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!cameraDataLoaded || siteInfo?.id == null || siteInfo?.id === "") return;
        const controller = new AbortController();
        (async ()=>{
            if (!showFlexIgnoreZonesFlag) {
                if (isMountedRef.current) {
                    setBackdropLoadingScreenOn(false);
                    setEditCameraInitialFlexHydrationDone(true);
                    setEditPageLoadProgressPercent(undefined);
                    setEditPageLoadProgressMessage("");
                }
                return;
            }
            if (isMountedRef.current) {
                setEditPageLoadProgressPercent(88);
                setEditPageLoadProgressMessage("Loading flex schedule presets...");
            }
            try {
                const focusCameraId = Number((0, $a8BPe.getNumbersAfterEditCamera)(location.href));
                await (0, $2nm0w.hydrateFlexIgnoreZonesForEditCameraPage)(siteInfo.id, {
                    signal: controller.signal,
                    ...Number.isFinite(focusCameraId) && focusCameraId > 0 ? {
                        focusCameraId: focusCameraId
                    } : {}
                });
            } catch  {
            // Best-effort: flex row still falls back to camera ignore zones API.
            } finally{
                if (isMountedRef.current) {
                    setEditPageLoadProgressPercent(undefined);
                    setEditPageLoadProgressMessage("");
                    setBackdropLoadingScreenOn(false);
                    setEditCameraInitialFlexHydrationDone(true);
                }
            }
        })();
        return ()=>controller.abort();
    }, [
        cameraDataLoaded,
        siteInfo?.id,
        showFlexIgnoreZonesFlag
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8gqnT.SyncNeededBanner), {
                navigate: navigate
            }),
            notesDialogEditCameraOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $gyvxI.NotesDialogEditCamera), {}),
            v1RedirectDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $kZIQb.V1RedirectDialog), {
                v1RedirectDialogOpen: v1RedirectDialogOpen,
                setv1RedirectDialogOpen: setv1RedirectDialogOpen
            }),
            addImmixAlertDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $4KzIO.AddImmixAlertDialog), {
                setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                addImmixAlertDialogOpen: addImmixAlertDialogOpen,
                immixAlerts: immixAlerts,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setCameraGeneralInfo: setCameraGeneralInfo,
                setCameraGeneralInfoBackup: setCameraGeneralInfoBackup,
                setGeneralInfoChangesMade: setGeneralInfoChangesMade,
                setPatchObject: setPatchObject,
                setImmixAlerts: setImmixAlerts,
                setActiveTab: setActiveTab,
                cameraGeneralInfoBackup: cameraGeneralInfoBackup,
                setIgnoreZonesBreadCrumbs: setIgnoreZonesBreadCrumbs,
                handleSitesBreadcrumbClick: handleSitesBreadcrumbClick,
                handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick,
                cameraGeneralInfo: cameraGeneralInfo,
                setSendingImmixTest: setSendingImmixTest,
                setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                sureviewAlerts: sureviewAlerts,
                setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                cameraWebhookData: cameraWebhookData,
                setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                sentinelAlerts: sentinelAlerts,
                setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                boldAlerts: boldAlerts,
                setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                patriotAlerts: patriotAlerts,
                setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                softguardAlerts: softguardAlerts,
                setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                immixAlertsOnCamera: immixAlertsOnCamera,
                sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                siteInfo: siteInfo,
                webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                boldAlertsOnCamera: boldAlertsOnCamera,
                patriotAlertsOnCamera: patriotAlertsOnCamera,
                softguardAlertsOnCamera: softguardAlertsOnCamera,
                evalinkAlertsOnCamera: evalinkAlertsOnCamera
            }),
            addDiceAlertDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aqdBl.AddDiceAlertDialog), {
                setAddDiceAlertDialogOpen: setAddDiceAlertDialogOpen,
                addDiceAlertDialogOpen: addDiceAlertDialogOpen,
                diceAlerts: diceAlerts,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setCameraGeneralInfo: setCameraGeneralInfo,
                setCameraGeneralInfoBackup: setCameraGeneralInfoBackup,
                setGeneralInfoChangesMade: setGeneralInfoChangesMade,
                setPatchObject: setPatchObject,
                setDiceAlerts: setDiceAlerts,
                setActiveTab: setActiveTab,
                cameraGeneralInfoBackup: cameraGeneralInfoBackup,
                setIgnoreZonesBreadCrumbs: setIgnoreZonesBreadCrumbs,
                handleSitesBreadcrumbClick: handleSitesBreadcrumbClick,
                handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick,
                cameraGeneralInfo: cameraGeneralInfo,
                setSendingDiceTest: setSendingDiceTest,
                setDiceTestSuccessDialogOpen: setDiceTestSuccessDialogOpen,
                setDiceTestFailDialogOpen: setDiceTestFailDialogOpen,
                setDeleteDiceAlertDialogOpen: setDeleteDiceAlertDialogOpen,
                sureviewAlerts: sureviewAlerts,
                setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                cameraWebhookData: cameraWebhookData,
                setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                sentinelAlerts: sentinelAlerts,
                setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                boldAlerts: boldAlerts,
                setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                patriotAlerts: patriotAlerts,
                setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                softguardAlerts: softguardAlerts,
                setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                diceAlertsOnCamera: diceAlertsOnCamera,
                sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                siteInfo: siteInfo,
                webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                boldAlertsOnCamera: boldAlertsOnCamera,
                patriotAlertsOnCamera: patriotAlertsOnCamera,
                softguardAlertsOnCamera: softguardAlertsOnCamera,
                evalinkAlertsOnCamera: evalinkAlertsOnCamera
            }),
            deleteImmixAlertDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $85F5S.DeleteImmixAlertDialog), {
                deleteImmixAlertDialogOpen: deleteImmixAlertDialogOpen,
                setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                immixAlerts: immixAlerts,
                setImmixAlerts: setImmixAlerts,
                setActiveTab: setActiveTab,
                setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                setSendingImmixTest: setSendingImmixTest,
                setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                sureviewAlerts: sureviewAlerts,
                setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                cameraWebhookData: cameraWebhookData,
                setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                sentinelAlerts: sentinelAlerts,
                setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                boldAlerts: boldAlerts,
                setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                patriotAlerts: patriotAlerts,
                setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                softguardAlerts: softguardAlerts,
                setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                immixAlertsOnCamera: immixAlertsOnCamera,
                sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                siteInfo: siteInfo,
                webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                boldAlertsOnCamera: boldAlertsOnCamera,
                patriotAlertsOnCamera: patriotAlertsOnCamera,
                softguardAlertsOnCamera: softguardAlertsOnCamera,
                evalinkAlertsOnCamera: evalinkAlertsOnCamera,
                navigate: navigate
            }),
            deleteDiceAlertDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $7mN1J.DeleteDiceAlertDialog), {
                deleteDiceAlertDialogOpen: deleteDiceAlertDialogOpen,
                setDeleteDiceAlertDialogOpen: setDeleteDiceAlertDialogOpen,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                diceAlerts: diceAlerts,
                setDiceAlerts: setDiceAlerts,
                setActiveTab: setActiveTab,
                setAddDiceAlertDialogOpen: setAddDiceAlertDialogOpen,
                setSendingDiceTest: setSendingDiceTest,
                setDiceTestSuccessDialogOpen: setDiceTestSuccessDialogOpen,
                setDiceTestFailDialogOpen: setDiceTestFailDialogOpen,
                sureviewAlerts: sureviewAlerts,
                setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                cameraWebhookData: cameraWebhookData,
                setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                sentinelAlerts: sentinelAlerts,
                setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                boldAlerts: boldAlerts,
                setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                patriotAlerts: patriotAlerts,
                setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                softguardAlerts: softguardAlerts,
                setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                diceAlertsOnCamera: diceAlertsOnCamera,
                sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                siteInfo: siteInfo,
                webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                boldAlertsOnCamera: boldAlertsOnCamera,
                patriotAlertsOnCamera: patriotAlertsOnCamera,
                softguardAlertsOnCamera: softguardAlertsOnCamera,
                evalinkAlertsOnCamera: evalinkAlertsOnCamera,
                navigate: navigate
            }),
            deleteAlertDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $bR0RS.DeleteAlertDialog), {}),
            addSentinelAlertDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $7DeOh.AddSentinelAlertDialog), {
                setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                addSentinelAlertDialogOpen: addSentinelAlertDialogOpen,
                sentinelAlerts: sentinelAlerts,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setCameraGeneralInfo: setCameraGeneralInfo,
                setCameraGeneralInfoBackup: setCameraGeneralInfoBackup,
                setGeneralInfoChangesMade: setGeneralInfoChangesMade,
                setPatchObject: setPatchObject,
                setSentinelAlerts: setSentinelAlerts,
                setActiveTab: setActiveTab,
                cameraGeneralInfoBackup: cameraGeneralInfoBackup,
                setIgnoreZonesBreadCrumbs: setIgnoreZonesBreadCrumbs,
                handleSitesBreadcrumbClick: handleSitesBreadcrumbClick,
                handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick,
                cameraGeneralInfo: cameraGeneralInfo,
                immixAlerts: immixAlerts,
                setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                setSendingImmixTest: setSendingImmixTest,
                setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                sureviewAlerts: sureviewAlerts,
                setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                cameraWebhookData: cameraWebhookData,
                setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                boldAlerts: boldAlerts,
                setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                patriotAlerts: patriotAlerts,
                setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                softguardAlerts: softguardAlerts,
                setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                immixAlertsOnCamera: immixAlertsOnCamera,
                sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                siteInfo: siteInfo,
                webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                boldAlertsOnCamera: boldAlertsOnCamera,
                patriotAlertsOnCamera: patriotAlertsOnCamera,
                softguardAlertsOnCamera: softguardAlertsOnCamera,
                evalinkAlertsOnCamera: evalinkAlertsOnCamera
            }),
            addBoldAlertDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8quhT.AddBoldAlertDialog), {
                setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                addBoldAlertDialogOpen: addBoldAlertDialogOpen,
                boldAlerts: boldAlerts,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setCameraGeneralInfo: setCameraGeneralInfo,
                setCameraGeneralInfoBackup: setCameraGeneralInfoBackup,
                setGeneralInfoChangesMade: setGeneralInfoChangesMade,
                setPatchObject: setPatchObject,
                setBoldAlerts: setBoldAlerts,
                setActiveTab: setActiveTab,
                cameraGeneralInfoBackup: cameraGeneralInfoBackup,
                setIgnoreZonesBreadCrumbs: setIgnoreZonesBreadCrumbs,
                handleSitesBreadcrumbClick: handleSitesBreadcrumbClick,
                handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick,
                cameraGeneralInfo: cameraGeneralInfo,
                immixAlerts: immixAlerts,
                setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                setSendingImmixTest: setSendingImmixTest,
                setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                sureviewAlerts: sureviewAlerts,
                setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                cameraWebhookData: cameraWebhookData,
                setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                sentinelAlerts: sentinelAlerts,
                setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                patriotAlerts: patriotAlerts,
                setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                softguardAlerts: softguardAlerts,
                setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                immixAlertsOnCamera: immixAlertsOnCamera,
                sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                siteInfo: siteInfo,
                webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                boldAlertsOnCamera: boldAlertsOnCamera,
                patriotAlertsOnCamera: patriotAlertsOnCamera,
                softguardAlertsOnCamera: softguardAlertsOnCamera,
                evalinkAlertsOnCamera: evalinkAlertsOnCamera
            }),
            addPatriotAlertDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $k3urr.AddPatriotAlertDialog), {
                setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                addPatriotAlertDialogOpen: addPatriotAlertDialogOpen,
                patriotAlerts: patriotAlerts,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setCameraGeneralInfo: setCameraGeneralInfo,
                setCameraGeneralInfoBackup: setCameraGeneralInfoBackup,
                setGeneralInfoChangesMade: setGeneralInfoChangesMade,
                setPatchObject: setPatchObject,
                setPatriotAlerts: setPatriotAlerts,
                setActiveTab: setActiveTab,
                cameraGeneralInfoBackup: cameraGeneralInfoBackup,
                setIgnoreZonesBreadCrumbs: setIgnoreZonesBreadCrumbs,
                handleSitesBreadcrumbClick: handleSitesBreadcrumbClick,
                handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick,
                cameraGeneralInfo: cameraGeneralInfo,
                immixAlerts: immixAlerts,
                setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                setSendingImmixTest: setSendingImmixTest,
                setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                sureviewAlerts: sureviewAlerts,
                setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                cameraWebhookData: cameraWebhookData,
                setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                sentinelAlerts: sentinelAlerts,
                setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                boldAlerts: boldAlerts,
                setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                softguardAlerts: softguardAlerts,
                setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                immixAlertsOnCamera: immixAlertsOnCamera,
                sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                siteInfo: siteInfo,
                webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                boldAlertsOnCamera: boldAlertsOnCamera,
                patriotAlertsOnCamera: patriotAlertsOnCamera,
                softguardAlertsOnCamera: softguardAlertsOnCamera,
                evalinkAlertsOnCamera: evalinkAlertsOnCamera
            }),
            addUSMonitoringAlertDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $7R3rw.AddUSMonitoringAlertDialog), {
                setAddUSMonitoringAlertDialogOpen: setAddUSMonitoringAlertDialogOpen,
                addUSMonitoringAlertDialogOpen: addUSMonitoringAlertDialogOpen,
                uSMonitoringAlerts: uSMonitoringAlerts,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setCameraGeneralInfo: setCameraGeneralInfo,
                setCameraGeneralInfoBackup: setCameraGeneralInfoBackup,
                setGeneralInfoChangesMade: setGeneralInfoChangesMade,
                setPatchObject: setPatchObject,
                setUSMonitoringAlerts: setUSMonitoringAlerts,
                setActiveTab: setActiveTab,
                cameraGeneralInfoBackup: cameraGeneralInfoBackup,
                setIgnoreZonesBreadCrumbs: setIgnoreZonesBreadCrumbs,
                handleSitesBreadcrumbClick: handleSitesBreadcrumbClick,
                handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick,
                cameraGeneralInfo: cameraGeneralInfo
            }),
            addSoftguardAlertDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $4M4T1.AddSoftguardAlertDialog), {
                setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                addSoftguardAlertDialogOpen: addSoftguardAlertDialogOpen,
                softguardAlerts: softguardAlerts,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setCameraGeneralInfo: setCameraGeneralInfo,
                setCameraGeneralInfoBackup: setCameraGeneralInfoBackup,
                setGeneralInfoChangesMade: setGeneralInfoChangesMade,
                setPatchObject: setPatchObject,
                setSoftguardAlerts: setSoftguardAlerts,
                setActiveTab: setActiveTab,
                cameraGeneralInfoBackup: cameraGeneralInfoBackup,
                setIgnoreZonesBreadCrumbs: setIgnoreZonesBreadCrumbs,
                handleSitesBreadcrumbClick: handleSitesBreadcrumbClick,
                handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick,
                cameraGeneralInfo: cameraGeneralInfo,
                immixAlerts: immixAlerts,
                setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                setSendingImmixTest: setSendingImmixTest,
                setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                sureviewAlerts: sureviewAlerts,
                setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                cameraWebhookData: cameraWebhookData,
                setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                sentinelAlerts: sentinelAlerts,
                setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                patriotAlerts: patriotAlerts,
                setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                boldAlerts: boldAlerts,
                setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                immixAlertsOnCamera: immixAlertsOnCamera,
                sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                siteInfo: siteInfo,
                webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                boldAlertsOnCamera: boldAlertsOnCamera,
                patriotAlertsOnCamera: patriotAlertsOnCamera,
                softguardAlertsOnCamera: softguardAlertsOnCamera,
                evalinkAlertsOnCamera: evalinkAlertsOnCamera
            }),
            addSysaidAlertDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $hdv6W.AddSysaidAlertDialog), {
                setCameraGeneralInfo: setCameraGeneralInfo,
                setCameraGeneralInfoBackup: setCameraGeneralInfoBackup,
                setPatchObject: setPatchObject,
                cameraGeneralInfoBackup: cameraGeneralInfoBackup
            }),
            addStreamWebhookDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $dDwzT.AddStreamWebhookDialog), {
                setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                addStreamWebhookDialogOpen: addStreamWebhookDialogOpen,
                cameraGeneralInfo: cameraGeneralInfo
            }),
            editStreamWebhookDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $6aUtL.EditStreamWebhookDialog), {
                setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                editStreamWebhookDialogOpen: editStreamWebhookDialogOpen
            }),
            immixTestSuccessDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $7TDDC.ImmixTestSuccessDialog), {
                immixTestSuccessDialogOpen: immixTestSuccessDialogOpen,
                setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen
            }),
            immixTestFailDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $fXzUh.ImmixTestFailDialog), {
                immixTestFailDialogOpen: immixTestFailDialogOpen,
                setImmixTestFailDialogOpen: setImmixTestFailDialogOpen
            }),
            diceTestSuccessDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $lPFIv.DiceTestSuccessDialog), {
                diceTestSuccessDialogOpen: diceTestSuccessDialogOpen,
                setDiceTestSuccessDialogOpen: setDiceTestSuccessDialogOpen
            }),
            diceTestFailDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $jDWxC.DiceTestFailDialog), {
                diceTestFailDialogOpen: diceTestFailDialogOpen,
                setDiceTestFailDialogOpen: setDiceTestFailDialogOpen
            }),
            addSureviewAlertDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $gBjZk.AddSureviewAlertDialog), {
                setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                addSureviewAlertDialogOpen: addSureviewAlertDialogOpen,
                sureViewAlerts: sureviewAlerts,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setCameraGeneralInfo: setCameraGeneralInfo,
                setCameraGeneralInfoBackup: setCameraGeneralInfoBackup,
                setGeneralInfoChangesMade: setGeneralInfoChangesMade,
                setPatchObject: setPatchObject,
                setSureviewAlerts: setSureviewAlerts,
                setActiveTab: setActiveTab,
                cameraGeneralInfoBackup: cameraGeneralInfoBackup,
                setIgnoreZonesBreadCrumbs: setIgnoreZonesBreadCrumbs,
                handleSitesBreadcrumbClick: handleSitesBreadcrumbClick,
                handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick,
                cameraGeneralInfo: cameraGeneralInfo,
                immixAlerts: immixAlerts,
                setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                setSendingImmixTest: setSendingImmixTest,
                setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                cameraWebhookData: cameraWebhookData,
                setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                sentinelAlerts: sentinelAlerts,
                setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                boldAlerts: boldAlerts,
                setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                patriotAlerts: patriotAlerts,
                setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                softguardAlerts: softguardAlerts,
                setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                immixAlertsOnCamera: immixAlertsOnCamera,
                sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                siteInfo: siteInfo,
                webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                boldAlertsOnCamera: boldAlertsOnCamera,
                patriotAlertsOnCamera: patriotAlertsOnCamera,
                softguardAlertsOnCamera: softguardAlertsOnCamera,
                evalinkAlertsOnCamera: evalinkAlertsOnCamera
            }),
            deleteWebhookDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cgrVY.DeleteWebhookDialog), {
                navigate: navigate
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $6pQI1.ProductActionLogsDialog), {
                open: productActionLogsDialogOpen,
                onClose: ()=>setProductActionLogsDialogOpen(false),
                cameraId: (0, $a8BPe.getNumbersAfterEditCamera)(location.href),
                siteTimezone: siteInfo?.timezone ?? null
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                        openState: backdropLoadingScreenOn,
                        progressPercent: editPageLoadProgressPercent,
                        message: editPageLoadProgressMessage
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                        openState: sendingImmixTest
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                        openState: sendingDiceTest
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                        openState: backdropLoadingScreenEditCameraOn
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $6oEZE.EditCameraAlerts), {
                        editCameraAlerts: editCameraAlerts,
                        setEditCameraAlerts: setEditCameraAlerts,
                        cameraName: cameraObject.camera_name
                    }),
                    cameraDataLoaded && cameraInfoRow && (!showFlexIgnoreZonesFlag || editCameraInitialFlexHydrationDone) && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "bg-actuate-grey absolute w-full h-full overflow-scroll",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: !navBarCollapsed ? "ml-[150px] mr-[1px] min-w-[1250px] w-[calc(100%-151px)]" : "ml-[75px] mr-[1px] min-w-[1250px] w-[calc(100%-76px)]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "relative mt-[15px] h-[59px] w-full min-w-[1250px] bg-white",
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "absolute top-[7px] left-0 right-0 flex min-w-[1250px] items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "min-w-0 flex-1 overflow-hidden",
                                                children: ignoreZonesBreadCrumbs
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                className: "ml-4 mr-[7vw] shrink-0 flex items-center gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8ZARq.EditViewSyncButton), {
                                                        navigate: navigate
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                        onClick: ()=>setProductActionLogsDialogOpen(true),
                                                        text: (0, $8ISah.ActionLogsText),
                                                        disabled: false
                                                    }),
                                                    permissions.edit_cameras && !autopatrolSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                                                        theme: $770f21171eb1d420$var$theme,
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                                            type: "button",
                                                            color: "primary",
                                                            onClick: ()=>{
                                                                navigate(alertsLink);
                                                            },
                                                            disabled: false,
                                                            className: "hover:bg-[#E67300]",
                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                                                                href: alertsLink,
                                                                onClick: (e)=>{
                                                                    e.preventDefault(); // Prevent default anchor navigation
                                                                    navigate(alertsLink);
                                                                },
                                                                sx: {
                                                                    textDecoration: "none",
                                                                    color: "inherit",
                                                                    cursor: "pointer",
                                                                    height: "100%"
                                                                },
                                                                children: seeAlertText
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "mt-[15px] min-h-[450px] w-full min-w-[1250px] bg-white",
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            allCamerasData.length > 1 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "pt-[200px] w-[40px]",
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                    title: `Previous Camera: ${cameraIndex === 0 ? allCamerasData[allCamerasData.length - 1].camera_name : allCamerasData[cameraIndex - 1].camera_name}`,
                                                    placement: "top",
                                                    sx: {
                                                        fontSize: "12px",
                                                        fontFamily: "mulish"
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                            onClick: ()=>{
                                                                (0, $i5LXy.resetState)(setCameraDataLoaded, setCameraObject, setSiteInfo, setClickedTab, setEditMode, setAddImmixAlertDialogOpen, setAddSureviewAlertDialogOpen, setCameraGeneralInfo, setCameraGeneralInfoBackup, setPatchObject, setGeneralInfoChangesMade, setActiveChangeMade, setAxisCamera, setMobotixCamera, setActiveTab, setBackdropLoadingScreenOn, setImmixAlertsOnCamera, setImmixAlerts, setSureViewAlertsOnCamera, setSureviewAlerts, setIgnoreZonesBreadCrumbs, setEditCameraAlerts, setRecipientsConfiguredData, setTitlesArray, setActionRulesData, setActionRulesTitlesArray, setApplicationsConfiguredData, setTimeTablesData, setIPNotifyData, setActionHandlerData, setMobotixFinished, setAxisFinished, setStreamsObject, setActiveProducts, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setv1RedirectDialogOpen, setSrcImages, setCameraInfoRow, setCameraWebhookData, setCameraWebhooksPatchObject, setCameraWebhooksChangesMade, setProductsData, setBackupProductsData, setAllTabsOpen, setAllCamerasData, setCameraIndex, setSentinelAlertsOnCamera, setSentinelAlerts, setBoldAlerts, setBoldAlertsOnCamera, setPatriotAlerts, setPatriotAlertsOnCamera, setUSMonitoringAlerts, setUSMonitoringAlertsOnCamera, setSoftguardAlerts, setSoftguardAlertsOnCamera);
                                                                setTimeout(()=>{
                                                                    if (cameraIndex === 0) {
                                                                        navigate(`/sites/${(0, $a8BPe.getNumbersAfterSites)(location.href)}/editcamera/${allCamerasData[allCamerasData.length - 1].id}`);
                                                                        localStorage.setItem("editCamerActiveTab", "one");
                                                                        localStorage.setItem("currentCameraId", (0, $a8BPe.getNumbersAfterEditCamera)(location.href));
                                                                        (0, $02she.getEditCameraData)(navigate, (0, $a8BPe.getNumbersAfterSites)(location.href), (0, $a8BPe.getNumbersAfterEditCamera)(location.href), setSiteInfo, setCameraGeneralInfo, setCameraObject, setCameraDataLoaded, setBackdropLoadingScreenOn, setImmixAlertsOnCamera, setIgnoreZonesBreadCrumbs, (0, $h0DCc.createIgnoreZonesLinksArray), handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, setSureViewAlertsOnCamera, setAxisCamera, setMobotixFinished, setRecipientsConfiguredData, setTitlesArray, setActionRulesData, setActionRulesTitlesArray, setApplicationsConfiguredData, mobotixFinished, setAxisFinished, axisFinished, setMobotixCamera, setTimeTablesData, setIPNotifyData, setActionHandlerData, setCameraGeneralInfoBackup, setImmixAlerts, setSureviewAlerts, setActiveProducts, setActiveTab, actionRulesTitlesArray, applicationsConfiguredData, cameraGeneralInfo, actionRulesData, setSrcImages, permissions, setCameraInfoRow, width, setCameraWebhookData, setProductsData, setBackupProductsData, setSentinelAlertsOnCamera, setSentinelAlertsOnCamera, setBoldAlertsOnCamera, setBoldAlerts, setPatriotAlertsOnCamera, setPatriotAlerts, setUSMonitoringAlertsOnCamera, setUSMonitoringAlerts, setWebhooksAlertsOnCamera, setSoftguardAlertsOnCamera, setSoftguardAlerts, setEvalinkAlertsOnCamera, setStreamParametersData, setShowStreamParameters, setEditCameraAlerts, setDiceAlertsOnCamera, setDiceAlerts, undefined, isMountedRef);
                                                                        (0, $2hXui.getAllCameras)(Number((0, $a8BPe.getNumbersAfterSites)(location.href)), Number((0, $a8BPe.getNumbersAfterEditCamera)(location.href)), setAllCamerasData, setCameraIndex);
                                                                    } else {
                                                                        navigate(`/sites/${(0, $a8BPe.getNumbersAfterSites)(location.href)}/editcamera/${allCamerasData[cameraIndex - 1].id}`);
                                                                        localStorage.setItem("editCamerActiveTab", "one");
                                                                        localStorage.setItem("currentCameraId", (0, $a8BPe.getNumbersAfterEditCamera)(location.href));
                                                                        (0, $02she.getEditCameraData)(navigate, (0, $a8BPe.getNumbersAfterSites)(location.href), (0, $a8BPe.getNumbersAfterEditCamera)(location.href), setSiteInfo, setCameraGeneralInfo, setCameraObject, setCameraDataLoaded, setBackdropLoadingScreenOn, setImmixAlertsOnCamera, setIgnoreZonesBreadCrumbs, (0, $h0DCc.createIgnoreZonesLinksArray), handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, setSureViewAlertsOnCamera, setAxisCamera, setMobotixFinished, setRecipientsConfiguredData, setTitlesArray, setActionRulesData, setActionRulesTitlesArray, setApplicationsConfiguredData, mobotixFinished, setAxisFinished, axisFinished, setMobotixCamera, setTimeTablesData, setIPNotifyData, setActionHandlerData, setCameraGeneralInfoBackup, setImmixAlerts, setSureviewAlerts, setActiveProducts, setActiveTab, actionRulesTitlesArray, applicationsConfiguredData, cameraGeneralInfo, actionRulesData, setSrcImages, permissions, setCameraInfoRow, width, setCameraWebhookData, setProductsData, setBackupProductsData, setSentinelAlertsOnCamera, setSentinelAlerts, setBoldAlertsOnCamera, setBoldAlerts, setPatriotAlertsOnCamera, setPatriotAlerts, setUSMonitoringAlertsOnCamera, setUSMonitoringAlerts, setWebhooksAlertsOnCamera, setSoftguardAlertsOnCamera, setSoftguardAlerts, setEvalinkAlertsOnCamera, setStreamParametersData, setShowStreamParameters, setEditCameraAlerts, setDiceAlertsOnCamera, setDiceAlerts, undefined, isMountedRef);
                                                                        (0, $2hXui.getAllCameras)(Number((0, $a8BPe.getNumbersAfterSites)(location.href)), Number((0, $a8BPe.getNumbersAfterEditCamera)(location.href)), setAllCamerasData, setCameraIndex);
                                                                    }
                                                                }, 1);
                                                            },
                                                            text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($frXOV))), {
                                                                fontSize: "large",
                                                                id: "backButton"
                                                            }),
                                                            disabled: allCamerasData.length < 2
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k8Qy8.default), {
                                                    sx: {
                                                        minWidth: 1000,
                                                        fontFamily: "Mulish"
                                                    },
                                                    "aria-label": "simple table",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                        children: cameraInfoRow
                                                    })
                                                })
                                            }),
                                            allCamerasData.length > 1 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "pt-[200px] pl-[280px]",
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                    title: `Next Camera: ${cameraIndex + 1 === allCamerasData.length ? allCamerasData[0].camera_name : allCamerasData[cameraIndex + 1].camera_name}`,
                                                    placement: "top",
                                                    sx: {
                                                        fontSize: "12px",
                                                        fontFamily: "mulish"
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                            onClick: ()=>{
                                                                (0, $i5LXy.resetState)(setCameraDataLoaded, setCameraObject, setSiteInfo, setClickedTab, setEditMode, setAddImmixAlertDialogOpen, setAddSureviewAlertDialogOpen, setCameraGeneralInfo, setCameraGeneralInfoBackup, setPatchObject, setGeneralInfoChangesMade, setActiveChangeMade, setAxisCamera, setMobotixCamera, setActiveTab, setBackdropLoadingScreenOn, setImmixAlertsOnCamera, setImmixAlerts, setSureViewAlertsOnCamera, setSureviewAlerts, setIgnoreZonesBreadCrumbs, setEditCameraAlerts, setRecipientsConfiguredData, setTitlesArray, setActionRulesData, setActionRulesTitlesArray, setApplicationsConfiguredData, setTimeTablesData, setIPNotifyData, setActionHandlerData, setMobotixFinished, setAxisFinished, setStreamsObject, setActiveProducts, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setv1RedirectDialogOpen, setSrcImages, setCameraInfoRow, setCameraWebhookData, setCameraWebhooksPatchObject, setCameraWebhooksChangesMade, setProductsData, setBackupProductsData, setAllTabsOpen, setAllCamerasData, setCameraIndex, setSentinelAlertsOnCamera, setSentinelAlerts, setBoldAlerts, setBoldAlertsOnCamera, setPatriotAlertsOnCamera, setPatriotAlerts, setUSMonitoringAlertsOnCamera, setUSMonitoringAlerts, setSoftguardAlertsOnCamera, setSoftguardAlerts);
                                                                setTimeout(()=>{
                                                                    if (cameraIndex + 1 === allCamerasData.length) {
                                                                        navigate(`/sites/${(0, $a8BPe.getNumbersAfterSites)(location.href)}/editcamera/${allCamerasData[0].id}`);
                                                                        // ENG-2680: like Previous, point localStorage at
                                                                        // the camera now open (the save used to hit the
                                                                        // previous camera after Next).
                                                                        (0, $a8BPe.recordEditCameraOpened)();
                                                                        (0, $02she.getEditCameraData)(navigate, (0, $a8BPe.getNumbersAfterSites)(location.href), (0, $a8BPe.getNumbersAfterEditCamera)(location.href), setSiteInfo, setCameraGeneralInfo, setCameraObject, setCameraDataLoaded, setBackdropLoadingScreenOn, setImmixAlertsOnCamera, setIgnoreZonesBreadCrumbs, (0, $h0DCc.createIgnoreZonesLinksArray), handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, setSureViewAlertsOnCamera, setAxisCamera, setMobotixFinished, setRecipientsConfiguredData, setTitlesArray, setActionRulesData, setActionRulesTitlesArray, setApplicationsConfiguredData, mobotixFinished, setAxisFinished, axisFinished, setMobotixCamera, setTimeTablesData, setIPNotifyData, setActionHandlerData, setCameraGeneralInfoBackup, setImmixAlerts, setSureviewAlerts, setActiveProducts, setActiveTab, actionRulesTitlesArray, applicationsConfiguredData, cameraGeneralInfo, actionRulesData, setSrcImages, permissions, setCameraInfoRow, width, setCameraWebhookData, setProductsData, setBackupProductsData, setSentinelAlertsOnCamera, setSentinelAlerts, setBoldAlertsOnCamera, setBoldAlerts, setPatriotAlertsOnCamera, setPatriotAlerts, setUSMonitoringAlertsOnCamera, setUSMonitoringAlerts, setWebhooksAlertsOnCamera, setSoftguardAlertsOnCamera, setSoftguardAlerts, setEvalinkAlertsOnCamera, setStreamParametersData, setShowStreamParameters, setEditCameraAlerts, setDiceAlertsOnCamera, setDiceAlerts, undefined, isMountedRef);
                                                                        (0, $2hXui.getAllCameras)(Number((0, $a8BPe.getNumbersAfterSites)(location.href)), Number((0, $a8BPe.getNumbersAfterEditCamera)(location.href)), setAllCamerasData, setCameraIndex);
                                                                    } else {
                                                                        navigate(`/sites/${(0, $a8BPe.getNumbersAfterSites)(location.href)}/editcamera/${allCamerasData[cameraIndex + 1].id}`);
                                                                        // ENG-2680: like Previous, point localStorage at
                                                                        // the camera now open (the save used to hit the
                                                                        // previous camera after Next).
                                                                        (0, $a8BPe.recordEditCameraOpened)();
                                                                        (0, $02she.getEditCameraData)(navigate, (0, $a8BPe.getNumbersAfterSites)(location.href), (0, $a8BPe.getNumbersAfterEditCamera)(location.href), setSiteInfo, setCameraGeneralInfo, setCameraObject, setCameraDataLoaded, setBackdropLoadingScreenOn, setImmixAlertsOnCamera, setIgnoreZonesBreadCrumbs, (0, $h0DCc.createIgnoreZonesLinksArray), handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, setSureViewAlertsOnCamera, setAxisCamera, setMobotixFinished, setRecipientsConfiguredData, setTitlesArray, setActionRulesData, setActionRulesTitlesArray, setApplicationsConfiguredData, mobotixFinished, setAxisFinished, axisFinished, setMobotixCamera, setTimeTablesData, setIPNotifyData, setActionHandlerData, setCameraGeneralInfoBackup, setImmixAlerts, setSureviewAlerts, setActiveProducts, setActiveTab, actionRulesTitlesArray, applicationsConfiguredData, cameraGeneralInfo, actionRulesData, setSrcImages, permissions, setCameraInfoRow, width, setCameraWebhookData, setProductsData, setBackupProductsData, setSentinelAlertsOnCamera, setSentinelAlerts, setBoldAlertsOnCamera, setBoldAlerts, setPatriotAlertsOnCamera, setPatriotAlerts, setUSMonitoringAlertsOnCamera, setUSMonitoringAlerts, setWebhooksAlertsOnCamera, setSoftguardAlertsOnCamera, setSoftguardAlerts, setEvalinkAlertsOnCamera, setStreamParametersData, setShowStreamParameters, setEditCameraAlerts, setDiceAlertsOnCamera, setDiceAlerts, undefined, isMountedRef);
                                                                        (0, $2hXui.getAllCameras)(Number((0, $a8BPe.getNumbersAfterSites)(location.href)), Number((0, $a8BPe.getNumbersAfterEditCamera)(location.href)), setAllCamerasData, setCameraIndex);
                                                                    }
                                                                }, 1);
                                                            },
                                                            text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2qUoo))), {
                                                                fontSize: "large",
                                                                id: "forwardButton"
                                                            }),
                                                            disabled: allCamerasData.length < 2
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "relative mt-[15px] h-[59px] w-full min-w-[1250px] bg-white",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "flex",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "font-black font-mulish text-[20px] p-3 indent-4",
                                                children: "Camera Information"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "absolute right-[90px] top-[10px]",
                                            children: !editMode && clickedTab !== "seven" && clickedTab !== "nine" && permissions.edit_cameras && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                onClick: ()=>{
                                                    (0, $j5jOb.handleEditInfoButtonClick)(setEditMode, clickedTab, setActiveTab, siteInfo, cameraGeneralInfo, setCameraGeneralInfo, setPatchObject, setGeneralInfoChangesMade, setActiveChangeMade, immixAlerts, diceAlerts, sureviewAlerts, activeProducts, cameraWebhookData, productsData, setProductsData, allTabsOpen, setAllTabsOpen, setBackupProductsData, sentinelAlerts, boldAlerts, patriotAlerts, softguardAlerts, streamParametersData, streamParametersPatchObject, setStreamParametersPatchObject, setStreamParametersChangesMade, setEditStreamWebhookDialogOpen, immixAlertsOnCamera, diceAlertsOnCamera, sureViewAlertsOnCamera, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera, setAddStreamWebhookDialogOpen);
                                                },
                                                text: editInformationText,
                                                disabled: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "absolute top-[10px] right-[90px]",
                                            children: editMode && clickedTab !== "seven" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2sriY.EditCameraSaveChangesButton), {
                                                setEditMode: setEditMode,
                                                clickedTab: clickedTab,
                                                setActiveTab: setActiveTab,
                                                siteInfo: siteInfo,
                                                cameraGeneralInfo: cameraGeneralInfo,
                                                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                                                generalInfoChangesMade: generalInfoChangesMade,
                                                patchObject: patchObject,
                                                setGeneralInfoChangesMade: setGeneralInfoChangesMade,
                                                setPatchObject: setPatchObject,
                                                setCameraGeneralInfo: setCameraGeneralInfo,
                                                cameraGeneralInfoBackup: cameraGeneralInfoBackup,
                                                setCameraGeneralInfoBackup: setCameraGeneralInfoBackup,
                                                immixAlerts: immixAlerts,
                                                diceAlerts: diceAlerts,
                                                activeChangeMade: activeChangeMade,
                                                sureviewAlerts: sureviewAlerts,
                                                setIgnoreZonesBreadCrumbs: setIgnoreZonesBreadCrumbs,
                                                handleSitesBreadcrumbClick: handleSitesBreadcrumbClick,
                                                handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick,
                                                setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                                                setAddDiceAlertDialogOpen: setAddDiceAlertDialogOpen,
                                                setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                                                activeProducts: activeProducts,
                                                setStreamsObject: setStreamsObject,
                                                setActiveProducts: setActiveProducts,
                                                setImmixAlertsOnCamera: setImmixAlertsOnCamera,
                                                setDiceAlertsOnCamera: setDiceAlertsOnCamera,
                                                setSureViewAlertsOnCamera: setSureViewAlertsOnCamera,
                                                setSendingImmixTest: setSendingImmixTest,
                                                setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                                                setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                                                setSendingDiceTest: setSendingDiceTest,
                                                setDiceTestSuccessDialogOpen: setDiceTestSuccessDialogOpen,
                                                setDiceTestFailDialogOpen: setDiceTestFailDialogOpen,
                                                setSrcImages: setSrcImages,
                                                setCameraInfoRow: setCameraInfoRow,
                                                width: width,
                                                permissions: permissions,
                                                cameraWebhooksChangesMade: cameraWebhooksChangesMade,
                                                cameraWebhooksPatchObject: cameraWebhooksPatchObject,
                                                recipientsConfiguredData: recipientsConfiguredData,
                                                titlesArray: titlesArray,
                                                setRecipientsConfiguredData: setRecipientsConfiguredData,
                                                setTitlesArray: setTitlesArray,
                                                actionRulesData: actionRulesData,
                                                setActionRulesData: setActionRulesData,
                                                actionRulesTitlesArray: actionRulesTitlesArray,
                                                setActionRulesTitlesArray: setActionRulesTitlesArray,
                                                applicationsConfiguredData: applicationsConfiguredData,
                                                axisFinished: axisFinished,
                                                timeTablesData: timeTablesData,
                                                setTimeTablesData: setTimeTablesData,
                                                iPNotifyData: iPNotifyData,
                                                setIPNotifyData: setIPNotifyData,
                                                actionHandlerData: actionHandlerData,
                                                setActionHandlerData: setActionHandlerData,
                                                cameraWebhookData: cameraWebhookData,
                                                setCameraWebhookData: setCameraWebhookData,
                                                setCameraWebhooksPatchObject: setCameraWebhooksPatchObject,
                                                setCameraWebhooksChangesMade: setCameraWebhooksChangesMade,
                                                productsData: productsData,
                                                setProductsData: setProductsData,
                                                allTabsOpen: allTabsOpen,
                                                setAllTabsOpen: setAllTabsOpen,
                                                backupProductsData: backupProductsData,
                                                setBackupProductsData: setBackupProductsData,
                                                setSentinelAlertsOnCamera: setSentinelAlertsOnCamera,
                                                sentinelAlerts: sentinelAlerts,
                                                setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                                                setBoldAlertsOnCamera: setBoldAlertsOnCamera,
                                                boldAlerts: boldAlerts,
                                                setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                                                setPatriotAlertsOnCamera: setPatriotAlertsOnCamera,
                                                patriotAlerts: patriotAlerts,
                                                setPatriotAlerts: setPatriotAlerts,
                                                setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                                                setUSMonitoringAlertsOnCamera: setUSMonitoringAlertsOnCamera,
                                                uSMonitoringAlerts: uSMonitoringAlerts,
                                                setAddUSMonitoringAlertDialogOpen: setAddUSMonitoringAlertDialogOpen,
                                                setSoftguardAlertsOnCamera: setSoftguardAlertsOnCamera,
                                                softguardAlerts: softguardAlerts,
                                                setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                                                setSoftguardAlerts: setSoftguardAlerts,
                                                streamParametersData: streamParametersData,
                                                streamParametersChangesMade: streamParametersChangesMade,
                                                setStreamParametersData: setStreamParametersData,
                                                setStreamParametersChangesMade: setStreamParametersChangesMade,
                                                streamParametersPatchObject: streamParametersPatchObject,
                                                setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                                                setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                                                setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                                                setDeleteDiceAlertDialogOpen: setDeleteDiceAlertDialogOpen,
                                                immixAlertsOnCamera: immixAlertsOnCamera,
                                                diceAlertsOnCamera: diceAlertsOnCamera,
                                                sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                                                webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                                                sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                                                boldAlertsOnCamera: boldAlertsOnCamera,
                                                patriotAlertsOnCamera: patriotAlertsOnCamera,
                                                softguardAlertsOnCamera: softguardAlertsOnCamera,
                                                evalinkAlertsOnCamera: evalinkAlertsOnCamera,
                                                setEvalinkAlertsOnCamera: setEvalinkAlertsOnCamera,
                                                setCameraObject: setCameraObject,
                                                saveProgress: {
                                                    setProgressPercent: setEditPageLoadProgressPercent,
                                                    setProgressMessage: setEditPageLoadProgressMessage
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "absolute top-[10px] right-[250px]",
                                            children: editMode && clickedTab !== "seven" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aZdoQ.EditCameraCancelButton), {
                                                setEditMode: setEditMode,
                                                clickedTab: clickedTab,
                                                setActiveTab: setActiveTab,
                                                siteInfo: siteInfo,
                                                cameraGeneralInfo: cameraGeneralInfo,
                                                setCameraGeneralInfo: setCameraGeneralInfo,
                                                cameraGeneralInfoBackup: cameraGeneralInfoBackup,
                                                setPatchObject: setPatchObject,
                                                immixAlerts: immixAlerts,
                                                diceAlerts: diceAlerts,
                                                sureviewAlerts: sureviewAlerts,
                                                setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                                                setAddDiceAlertDialogOpen: setAddDiceAlertDialogOpen,
                                                setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                                                activeProducts: activeProducts,
                                                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                                                setSendingImmixTest: setSendingImmixTest,
                                                setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                                                setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                                                setSendingDiceTest: setSendingDiceTest,
                                                setDiceTestSuccessDialogOpen: setDiceTestSuccessDialogOpen,
                                                setDiceTestFailDialogOpen: setDiceTestFailDialogOpen,
                                                recipientsConfiguredData: recipientsConfiguredData,
                                                titlesArray: titlesArray,
                                                setRecipientsConfiguredData: setRecipientsConfiguredData,
                                                setTitlesArray: setTitlesArray,
                                                actionRulesData: actionRulesData,
                                                setActionRulesData: setActionRulesData,
                                                actionRulesTitlesArray: actionRulesTitlesArray,
                                                setActionRulesTitlesArray: setActionRulesTitlesArray,
                                                applicationsConfiguredData: applicationsConfiguredData,
                                                axisFinished: axisFinished,
                                                timeTablesData: timeTablesData,
                                                setTimeTablesData: setTimeTablesData,
                                                iPNotifyData: iPNotifyData,
                                                setIPNotifyData: setIPNotifyData,
                                                actionHandlerData: actionHandlerData,
                                                setActionHandlerData: setActionHandlerData,
                                                cameraWebhookData: cameraWebhookData,
                                                productsData: productsData,
                                                setProductsData: setProductsData,
                                                allTabsOpen: allTabsOpen,
                                                setAllTabsOpen: setAllTabsOpen,
                                                backupProductsData: backupProductsData,
                                                setBackupProductsData: setBackupProductsData,
                                                sentinelAlerts: sentinelAlerts,
                                                setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                                                boldAlerts: boldAlerts,
                                                setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                                                patriotAlerts: patriotAlerts,
                                                setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                                                uSMonitoringAlerts: uSMonitoringAlerts,
                                                setAddUSMonitoringAlertDialogOpen: setAddUSMonitoringAlertDialogOpen,
                                                softguardAlerts: softguardAlerts,
                                                setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                                                streamParametersData: streamParametersData,
                                                setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                                                setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                                                setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                                                setDeleteDiceAlertDialogOpen: setDeleteDiceAlertDialogOpen,
                                                immixAlertsOnCamera: immixAlertsOnCamera,
                                                diceAlertsOnCamera: diceAlertsOnCamera,
                                                sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                                                webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                                                sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                                                boldAlertsOnCamera: boldAlertsOnCamera,
                                                patriotAlertsOnCamera: patriotAlertsOnCamera,
                                                softguardAlertsOnCamera: softguardAlertsOnCamera,
                                                evalinkAlertsOnCamera: evalinkAlertsOnCamera,
                                                navigate: navigate
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "w-full min-w-[1250px] bg-white",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iWyxG.EditCameraTabs), {
                                        clickedTab: clickedTab,
                                        setClickedTab: setClickedTab,
                                        editMode: editMode,
                                        setActiveTab: setActiveTab,
                                        siteInfo: siteInfo,
                                        cameraGeneralInfo: cameraGeneralInfo,
                                        setCameraGeneralInfo: setCameraGeneralInfo,
                                        setPatchObject: setPatchObject,
                                        setGeneralInfoChangesMade: setGeneralInfoChangesMade,
                                        immixAlertsOnCamera: immixAlertsOnCamera,
                                        diceAlertsOnCamera: diceAlertsOnCamera,
                                        sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                                        immixAlerts: immixAlerts,
                                        diceAlerts: diceAlerts,
                                        setActiveChangeMade: setActiveChangeMade,
                                        sureviewAlerts: sureviewAlerts,
                                        setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                                        setAddDiceAlertDialogOpen: setAddDiceAlertDialogOpen,
                                        setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                                        streamsObject: streamsObject,
                                        setActiveProducts: setActiveProducts,
                                        activeProducts: activeProducts,
                                        axisCamera: axisCamera,
                                        recipientsConfiguredData: recipientsConfiguredData,
                                        titlesArray: titlesArray,
                                        navigate: navigate,
                                        setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                                        setRecipientsConfiguredData: setRecipientsConfiguredData,
                                        setTitlesArray: setTitlesArray,
                                        actionRulesData: actionRulesData,
                                        setActionRulesData: setActionRulesData,
                                        actionRulesTitlesArray: actionRulesTitlesArray,
                                        setActionRulesTitlesArray: setActionRulesTitlesArray,
                                        applicationsConfiguredData: applicationsConfiguredData,
                                        mobotixCamera: mobotixCamera,
                                        timeTablesData: timeTablesData,
                                        setTimeTablesData: setTimeTablesData,
                                        iPNotifyData: iPNotifyData,
                                        setIPNotifyData: setIPNotifyData,
                                        actionHandlerData: actionHandlerData,
                                        setActionHandlerData: setActionHandlerData,
                                        axisFinished: axisFinished,
                                        setSendingImmixTest: setSendingImmixTest,
                                        setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                                        setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                                        setSendingDiceTest: setSendingDiceTest,
                                        setDiceTestSuccessDialogOpen: setDiceTestSuccessDialogOpen,
                                        setDiceTestFailDialogOpen: setDiceTestFailDialogOpen,
                                        cameraWebhookData: cameraWebhookData,
                                        setCameraWebhooksPatchObject: setCameraWebhooksPatchObject,
                                        setCameraWebhooksChangesMade: setCameraWebhooksChangesMade,
                                        productsData: productsData,
                                        setProductsData: setProductsData,
                                        allTabsOpen: allTabsOpen,
                                        setAllTabsOpen: setAllTabsOpen,
                                        setBackupProductsData: setBackupProductsData,
                                        sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                                        sentinelAlerts: sentinelAlerts,
                                        setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                                        boldAlertsOnCamera: boldAlertsOnCamera,
                                        boldAlerts: boldAlerts,
                                        setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                                        patriotAlertsOnCamera: patriotAlertsOnCamera,
                                        patriotAlerts: patriotAlerts,
                                        setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                                        uSMonitoringAlertsOnCamera: uSMonitoringAlertsOnCamera,
                                        uSMonitoringAlerts: uSMonitoringAlerts,
                                        setAddUSMonitoringAlertDialogOpen: setAddUSMonitoringAlertDialogOpen,
                                        webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                                        softguardAlertsOnCamera: softguardAlertsOnCamera,
                                        softguardAlerts: softguardAlerts,
                                        setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                                        evalinkAlertsOnCamera: evalinkAlertsOnCamera,
                                        showStreamParameters: showStreamParameters,
                                        streamParametersData: streamParametersData,
                                        streamParametersPatchObject: streamParametersPatchObject,
                                        setStreamParametersPatchObject: setStreamParametersPatchObject,
                                        setStreamParametersChangesMade: setStreamParametersChangesMade,
                                        setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                                        setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                                        setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                                        setDeleteDiceAlertDialogOpen: setDeleteDiceAlertDialogOpen
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "min-h-[17vh] w-full min-w-[1250px]",
                                    children: activeTab
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "justify-start",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jVN1H.NavBar), {
                    navBarCollapsed: navBarCollapsed,
                    setNavBarCollapsed: setNavBarCollapsed,
                    props: {}
                })
            })
        ]
    });
};

});
parcelRegister("8ZARq", function(module, exports) {

$parcel$export(module.exports, "EditViewSyncButton", () => $9b14578e2a8a817b$export$62ccc2b3e7742b75);

var $k4ank = parcelRequire("k4ank");

var $cIfQ5 = parcelRequire("cIfQ5");
parcelRequire("8T3gX");

var $cVCJe = parcelRequire("cVCJe");

var $hGkpk = parcelRequire("hGkpk");
const $9b14578e2a8a817b$export$62ccc2b3e7742b75 = ({ navigate: navigate })=>{
    const { syncNeeded: syncNeeded, syncing: syncing, syncApplies: syncApplies, syncNow: syncNow, rebootDialog: rebootDialog } = (0, $hGkpk.useSyncSiteFlow)(navigate);
    if (!syncApplies) return null;
    let button = null;
    if (syncing) button = /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
        className: "shadow-button bg-[#ed6c02] rounded font-mulish text-white text-base p-1.5 cursor-wait",
        disabled: true,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cIfQ5))), {
                fontSize: "small",
                className: "animate-spin"
            }),
            "\xa0 Syncing... \xa0"
        ]
    });
    else if (syncNeeded) // While editing there is nothing to sync yet, so the button is hidden. It
    // appears only once a submit has marked the site unsynced.
    button = /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: "You have unsynced changes. Sync to push them to the cloud, then reboot the site to apply them.",
        placement: "top",
        sx: {
            fontSize: "15px",
            fontFamily: "mulish"
        },
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
            className: "shadow-button bg-[#d32f2f] rounded font-mulish text-white text-base p-1.5 hover:bg-[#c62828]",
            onClick: syncNow,
            disabled: false,
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cIfQ5))), {
                    fontSize: "small"
                }),
                "\xa0 Sync Site \xa0"
            ]
        })
    });
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            rebootDialog,
            button
        ]
    });
};

});
parcelRegister("hGkpk", function(module, exports) {

$parcel$export(module.exports, "useSyncSiteFlow", () => $b28b8a610fd2025a$export$a11b911b3830edc9);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");
var $887xF = parcelRequire("887xF");
var $1TOOV = parcelRequire("1TOOV");
var $iLEpm = parcelRequire("iLEpm");
var $ce8iU = parcelRequire("ce8iU");

var $TzEEg = parcelRequire("TzEEg");

var $815yO = parcelRequire("815yO");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");

var $c4ZfI = parcelRequire("c4ZfI");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");

var $8jTCz = parcelRequire("8jTCz");
/**
 * Shared sync-from-an-edit-view flow, used by both the header Sync button
 * (EditViewSyncButton) and the unsynced-changes banner (SyncNeededBanner) so
 * they can't drift apart.
 *
 * Wraps the shared `syncSite` helper and the follow-up reboot decision: a
 * successful sync arms the one-shot `rebootSite` flag, and on an armed site we
 * offer to reboot now to apply — the same choice the About page gives.
 */ const $b28b8a610fd2025a$var$readIntegrationTypeName = ()=>{
    try {
        return JSON.parse(localStorage.getItem("siteInfo") || "{}").integration_type_name;
    } catch  {
        return undefined;
    }
};
/**
 * Whether to offer the post-sync reboot (= arm), decided from FRESH site
 * state. The cached localStorage `siteInfo` was a snapshot from page load —
 * on the schedules edit view that snapshot predates the schedule save that
 * may have just disarmed the site, so it said `armed: true` for a site the
 * schedule had turned off, and the prompt offered an arm-outside-schedule
 * (SUP-311 / ENG-811). Refetch /about/ so both `armed` and `arm_intended`
 * are current; on fetch failure fall back to the cached snapshot's `armed`
 * only, mirroring the old behavior rather than silently dropping the offer.
 */ const $b28b8a610fd2025a$var$shouldOfferReboot = async (siteId)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    try {
        const response = await AxiosUI.get(`customer/${siteId}/about/`);
        localStorage.setItem("siteInfo", JSON.stringify(response.data));
        return (0, $c4ZfI.shouldOfferRebootToApply)(response.data);
    } catch  {
        try {
            const cached = JSON.parse(localStorage.getItem("siteInfo") || "{}");
            return (0, $c4ZfI.shouldOfferRebootToApply)(cached);
        } catch  {
            return false;
        }
    }
};
const $b28b8a610fd2025a$var$readHasFlexSchedule = ()=>{
    try {
        return !!JSON.parse(localStorage.getItem("siteInfo") || "{}").has_flex_schedule;
    } catch  {
        return false;
    }
};
const $b28b8a610fd2025a$export$a11b911b3830edc9 = (navigate)=>{
    const syncNeeded = (0, $815yO.useCurrentSiteSyncNeeded)();
    const [syncing, setSyncing] = (0, $8T3gX.useState)(false);
    const [rebootPromptOpen, setRebootPromptOpen] = (0, $8T3gX.useState)(false);
    // Clips/autopatrol sites don't deploy connector settings, so syncing doesn't
    // apply — mirror the About-page SyncSiteButton guard.
    const integrationTypeName = $b28b8a610fd2025a$var$readIntegrationTypeName();
    const syncApplies = integrationTypeName !== "clips" && integrationTypeName !== "autopatrol";
    const syncNow = async ()=>{
        if (syncing) return;
        setSyncing(true);
        // syncSite marks the store synced on success (or handleDeployNextFailure
        // re-marks it unsynced on failure) — consumers re-render from the store.
        await (0, $TzEEg.syncSite)((0, $a8BPe.getNumbersAfterSites)(location.href), navigate);
        setSyncing(false);
        // On a successful sync (reboot flag armed) of an armed site that is meant
        // to be armed (schedule or manual arm),
        // offer to reboot now to apply — matching the About-page behavior so the
        // operator can finish the flow without leaving this page. Decided from a
        // fresh fetch, never the page-load snapshot (ENG-811).
        if (localStorage.getItem("rebootSite") === "true" && await $b28b8a610fd2025a$var$shouldOfferReboot((0, $a8BPe.getNumbersAfterSites)(location.href))) setRebootPromptOpen(true);
    };
    const handleDeclineReboot = ()=>{
        setRebootPromptOpen(false);
        // The operator chose not to reboot now; clear the flag so the About page
        // doesn't re-prompt for the same synced change.
        localStorage.setItem("rebootSite", "false");
    };
    const handleReboot = async ()=>{
        setRebootPromptOpen(false);
        const siteId = (0, $a8BPe.getNumbersAfterSites)(location.href);
        if ($b28b8a610fd2025a$var$readHasFlexSchedule()) {
            // Flex-schedule sites can't be armed site-wide — the backend rejects
            // customer/{id}/action/arm for them without arming anything (ENG-389),
            // and the per-schedule picker lives on the About page. Keep the
            // one-shot rebootSite flag set and navigate there: the About page
            // consumes the flag and re-opens its RebootDialog, which routes flex
            // sites into the schedule picker.
            navigate(`/sites/aboutsite/${siteId}`);
            return;
        }
        localStorage.setItem("rebootSite", "false");
        const AxiosUI = (0, $195EM.createApi)(``);
        // Rebooting a site is an arm (the connector restarts and re-reads its
        // settings from the cloud), but action/reboot/ records it as a
        // "Manual Reboot" in the action log instead of a "Manual Arm" the
        // operator never performed (ENG-1380 / SUP-433). No local state to
        // refresh — we're on an edit view, and the About page reloads fresh on
        // navigation.
        await AxiosUI.post(`customer/${siteId}/action/reboot/`).then(()=>{}, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, handleReboot, ()=>{
                alert("Error rebooting site, please try again.");
            });
        });
    };
    const rebootDialog = /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: rebootPromptOpen,
        "aria-labelledby": "edit-view-reboot-title",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "edit-view-reboot-title",
                children: "Reboot Site?"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                    children: "Your changes are synced to the cloud, but the camera connection is still running the previous settings. Would you like to reboot the site now to apply them? Otherwise the changes are applied the next time the site arms on its schedule."
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: handleDeclineReboot,
                        text: "No",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: handleReboot,
                        text: "Reboot",
                        disabled: false
                    })
                ]
            })
        ]
    });
    return {
        syncNeeded: syncNeeded,
        syncing: syncing,
        syncApplies: syncApplies,
        syncNow: syncNow,
        rebootDialog: rebootDialog
    };
};

});
parcelRegister("TzEEg", function(module, exports) {

$parcel$export(module.exports, "syncSite", () => $40b5c738707270a4$export$3c2cb9ec5a5307a8);
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $815yO = parcelRequire("815yO");

var $3Zv1D = parcelRequire("3Zv1D");

var $ebsyJ = parcelRequire("ebsyJ");
const $40b5c738707270a4$export$3c2cb9ec5a5307a8 = async (siteId, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $40b5c738707270a4$export$3c2cb9ec5a5307a8(siteId, navigate);
    };
    await AxiosUI.post(`customer/${siteId}/action/deploy_next/`).then(()=>{
        (0, $815yO.markSiteSynced)();
        // Syncing pushes the latest settings to the cloud but does NOT make them
        // live on an already-running connector — that needs a reboot. Arm the
        // one-shot reboot prompt so the About page offers to reboot (armed sites
        // only) the next time the operator lands there. This is the single place
        // "reboot needed" is set now that saving no longer auto-syncs.
        localStorage.setItem("rebootSite", "true");
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, (0, $ebsyJ.handleDeployNextFailure));
    });
};

});
parcelRegister("ebsyJ", function(module, exports) {

$parcel$export(module.exports, "handleDeployNextFailure", () => $a08ed9518167a9df$export$c4b6b2fb39217d08);

var $815yO = parcelRequire("815yO");
const $a08ed9518167a9df$export$c4b6b2fb39217d08 = (context)=>{
    (0, $815yO.markSiteUnsynced)();
    if (context?.willRetry || context?.offline) return;
    alert('Your changes were saved, but automatically deploying them to the site failed. Please open the site\'s About page and click "Sync Site" to deploy your changes.');
};

});




parcelRegister("8gqnT", function(module, exports) {

$parcel$export(module.exports, "SyncNeededBanner", () => $180e2f6d8e5d4841$export$a1ec715fa1b0fdf2);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $3QMQN = parcelRequire("3QMQN");
var $a65wX = parcelRequire("a65wX");
var $iKAtE = parcelRequire("iKAtE");

var $433j1 = parcelRequire("433j1");

var $hGkpk = parcelRequire("hGkpk");

var $815yO = parcelRequire("815yO");

var $kUNf4 = parcelRequire("kUNf4");

var $imDMS = parcelRequire("imDMS");
const $180e2f6d8e5d4841$export$a1ec715fa1b0fdf2 = ({ navigate: navigate })=>{
    const { syncNeeded: syncNeeded, syncing: syncing, syncApplies: syncApplies, syncNow: syncNow, rebootDialog: rebootDialog } = (0, $hGkpk.useSyncSiteFlow)(navigate);
    const bannersHidden = (0, $kUNf4.useSyncBannersHiddenForCurrentSite)();
    const dismissed = (0, $815yO.useCurrentSiteBannerDismissed)();
    if (!syncApplies || bannersHidden || dismissed && !syncing || !syncNeeded && !syncing) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
        children: rebootDialog
    });
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            rebootDialog,
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                severity: "warning",
                sx: {
                    alignItems: "center",
                    fontFamily: "Mulish"
                },
                action: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $imDMS.HideSyncBannerCheckbox), {}),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                            color: "inherit",
                            size: "small",
                            disabled: syncing,
                            onClick: syncNow,
                            sx: {
                                fontWeight: 700,
                                whiteSpace: "nowrap"
                            },
                            children: syncing ? "Syncing..." : "Sync Site Now"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                            "aria-label": "Close",
                            color: "inherit",
                            size: "small",
                            disabled: syncing,
                            onClick: ()=>(0, $815yO.dismissSyncBannerForCurrentSite)(),
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {
                                fontSize: "inherit"
                            })
                        })
                    ]
                }),
                children: "This site has unsynced changes \u2014 settings won't take effect until you sync."
            })
        ]
    });
};

});

parcelRegister("iWyxG", function(module, exports) {

$parcel$export(module.exports, "EditCameraTabs", () => $56a23882e4089d11$export$1f0e431bcfc797cd);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $7b37s = parcelRequire("7b37s");

var $eDfvp = parcelRequire("eDfvp");

var $3n3uW = parcelRequire("3n3uW");

var $2suvB = parcelRequire("2suvB");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

var $48GtE = parcelRequire("48GtE");

var $aZxZ3 = parcelRequire("aZxZ3");

var $4PFLW = parcelRequire("4PFLW");
const $56a23882e4089d11$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $56a23882e4089d11$export$1f0e431bcfc797cd = ({ clickedTab: clickedTab, setClickedTab: setClickedTab, editMode: editMode, setActiveTab: setActiveTab, siteInfo: siteInfo, cameraGeneralInfo: cameraGeneralInfo, setCameraGeneralInfo: setCameraGeneralInfo, setPatchObject: setPatchObject, setGeneralInfoChangesMade: setGeneralInfoChangesMade, immixAlertsOnCamera: immixAlertsOnCamera, diceAlertsOnCamera: diceAlertsOnCamera, sureViewAlertsOnCamera: sureViewAlertsOnCamera, immixAlerts: immixAlerts, diceAlerts: diceAlerts, setActiveChangeMade: setActiveChangeMade, sureviewAlerts: sureviewAlerts, setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen, setAddDiceAlertDialogOpen: setAddDiceAlertDialogOpen, setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen, streamsObject: streamsObject, setActiveProducts: setActiveProducts, activeProducts: activeProducts, axisCamera: axisCamera, recipientsConfiguredData: recipientsConfiguredData, titlesArray: titlesArray, navigate: navigate, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setRecipientsConfiguredData: setRecipientsConfiguredData, setTitlesArray: setTitlesArray, actionRulesData: actionRulesData, setActionRulesData: setActionRulesData, actionRulesTitlesArray: actionRulesTitlesArray, setActionRulesTitlesArray: setActionRulesTitlesArray, applicationsConfiguredData: applicationsConfiguredData, mobotixCamera: mobotixCamera, timeTablesData: timeTablesData, setTimeTablesData: setTimeTablesData, iPNotifyData: iPNotifyData, setIPNotifyData: setIPNotifyData, actionHandlerData: actionHandlerData, setActionHandlerData: setActionHandlerData, axisFinished: axisFinished, setSendingImmixTest: setSendingImmixTest, setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen: setImmixTestFailDialogOpen, setSendingDiceTest: setSendingDiceTest, setDiceTestSuccessDialogOpen: setDiceTestSuccessDialogOpen, setDiceTestFailDialogOpen: setDiceTestFailDialogOpen, cameraWebhookData: cameraWebhookData, setCameraWebhooksPatchObject: setCameraWebhooksPatchObject, setCameraWebhooksChangesMade: setCameraWebhooksChangesMade, productsData: productsData, setProductsData: setProductsData, allTabsOpen: allTabsOpen, setAllTabsOpen: setAllTabsOpen, setBackupProductsData: setBackupProductsData, sentinelAlertsOnCamera: sentinelAlertsOnCamera, sentinelAlerts: sentinelAlerts, setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen, boldAlertsOnCamera: boldAlertsOnCamera, boldAlerts: boldAlerts, setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen, patriotAlertsOnCamera: patriotAlertsOnCamera, patriotAlerts: patriotAlerts, setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen, uSMonitoringAlertsOnCamera: uSMonitoringAlertsOnCamera, uSMonitoringAlerts: uSMonitoringAlerts, setAddUSMonitoringAlertDialogOpen: setAddUSMonitoringAlertDialogOpen, webhooksAlertsOnCamera: webhooksAlertsOnCamera, softguardAlertsOnCamera: softguardAlertsOnCamera, softguardAlerts: softguardAlerts, setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen, evalinkAlertsOnCamera: evalinkAlertsOnCamera, showStreamParameters: showStreamParameters, streamParametersData: streamParametersData, streamParametersPatchObject: streamParametersPatchObject, setStreamParametersPatchObject: setStreamParametersPatchObject, setStreamParametersChangesMade: setStreamParametersChangesMade, setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen, setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen, setDeleteDiceAlertDialogOpen: setDeleteDiceAlertDialogOpen })=>{
    const { flags: flags } = (0, $4PFLW.useFeatureFlag)();
    const showProductsTabAutopatrolCameras = flags.showProductsTabAutopatrolCameras;
    const showSlicingTab = flags.showSlicingTab;
    const showVlmTab = flags.showVlmTab;
    const { sysaidAlertsOnCamera: sysaidAlertsOnCamera, vCHOnlySite: vCHOnlySite } = (0, $aZxZ3.useEditCameraStore)();
    const showAlertSettingsTab = (immixAlertsOnCamera || diceAlertsOnCamera || sureViewAlertsOnCamera || cameraWebhookData || siteInfo.webhooks || webhooksAlertsOnCamera || sentinelAlertsOnCamera || boldAlertsOnCamera || patriotAlertsOnCamera || softguardAlertsOnCamera || sysaidAlertsOnCamera || evalinkAlertsOnCamera) && siteInfo.integration_type_name !== "autopatrol";
    // TODO: REMOVE - Temporary debug logs for Products tab visibility
    const showProductsTab = siteInfo.integration_type_name !== "autopatrol" || siteInfo.integration_type_name === "autopatrol" && showProductsTabAutopatrolCameras && !vCHOnlySite;
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
        sx: {
            width: "100%"
        },
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
            theme: $56a23882e4089d11$var$theme,
            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3n3uW.default), {
                value: clickedTab,
                onChange: (event, tabValue)=>(0, $48GtE.handleTabChangeEditCamera)(tabValue, editMode, setClickedTab, setActiveTab, siteInfo, cameraGeneralInfo, setCameraGeneralInfo, setPatchObject, setGeneralInfoChangesMade, immixAlerts, diceAlerts, setActiveChangeMade, sureviewAlerts, setAddImmixAlertDialogOpen, setAddDiceAlertDialogOpen, setAddSureviewAlertDialogOpen, streamsObject, activeProducts, recipientsConfiguredData, titlesArray, navigate, setBackdropLoadingScreenOn, setRecipientsConfiguredData, setTitlesArray, actionRulesData, setActionRulesData, actionRulesTitlesArray, setActionRulesTitlesArray, applicationsConfiguredData, timeTablesData, setTimeTablesData, iPNotifyData, setIPNotifyData, actionHandlerData, setActionHandlerData, axisFinished, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setSendingDiceTest, setDiceTestSuccessDialogOpen, setDiceTestFailDialogOpen, cameraWebhookData, setCameraWebhooksPatchObject, setCameraWebhooksChangesMade, productsData, setProductsData, allTabsOpen, setAllTabsOpen, setBackupProductsData, sentinelAlerts, setAddSentinelAlertDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, uSMonitoringAlerts, setAddUSMonitoringAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, streamParametersData, streamParametersPatchObject, setStreamParametersPatchObject, setStreamParametersChangesMade, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, setDeleteImmixAlertDialogOpen, setDeleteDiceAlertDialogOpen, immixAlertsOnCamera, diceAlertsOnCamera, sureViewAlertsOnCamera, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera),
                "aria-label": "tabs",
                color: "primary",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                        value: "one",
                        label: "General Info",
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold",
                            color: "primary"
                        }
                    }),
                    showStreamParameters && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                        value: "fifteen",
                        label: (0, $7b37s.STREAM_OPTIONS_TAB_LABEL),
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold",
                            color: "primary"
                        }
                    }),
                    (siteInfo.integration_type_name !== "autopatrol" || siteInfo.integration_type_name === "autopatrol" && showProductsTabAutopatrolCameras && !vCHOnlySite) && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                        value: "four",
                        label: "Products",
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold",
                            color: "primary"
                        }
                    }),
                    showProductsTab && showSlicingTab && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                        value: "five",
                        label: "Slicing",
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold",
                            color: "primary"
                        }
                    }),
                    showVlmTab && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                        value: "seventeen",
                        label: "VLM",
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold",
                            color: "primary"
                        }
                    }),
                    showAlertSettingsTab && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                        value: "sixteen",
                        label: "Alert Settings",
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold",
                            color: "primary"
                        }
                    }),
                    axisCamera && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                        value: "seven",
                        label: "Axis Settings",
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold",
                            color: "primary"
                        }
                    }),
                    mobotixCamera && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                        value: "eight",
                        label: "Mobotix Settings",
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold",
                            color: "primary"
                        }
                    })
                ]
            })
        })
    });
};

});
parcelRegister("7b37s", function(module, exports) {

$parcel$export(module.exports, "GENERAL_INFO_COLUMN_COUNT", () => $f906c959676b4d1c$export$22ac953fd873960a);
$parcel$export(module.exports, "STREAM_OPTIONS_TAB_LABEL", () => $f906c959676b4d1c$export$fb3b6f003dbae6f1);
$parcel$export(module.exports, "generalInfoTableCellSx", () => $f906c959676b4d1c$export$c4e31434ddcec23b);
$parcel$export(module.exports, "connectionFieldTextFieldSx", () => $f906c959676b4d1c$export$eaa6be8b5d91be0a);
$parcel$export(module.exports, "packIntoRows", () => $f906c959676b4d1c$export$5953427fbef74e56);
/** General Info row uses seven columns; connection fields pack into the same grid. */ const $f906c959676b4d1c$export$22ac953fd873960a = 7;
const $f906c959676b4d1c$export$fb3b6f003dbae6f1 = "Stream Options";
const $f906c959676b4d1c$export$c4e31434ddcec23b = {
    fontFamily: "Mulish",
    verticalAlign: "top"
};
const $f906c959676b4d1c$export$eaa6be8b5d91be0a = {
    width: 150
};
const $f906c959676b4d1c$export$5953427fbef74e56 = (items, columnCount = $f906c959676b4d1c$export$22ac953fd873960a)=>{
    if (items.length === 0) return [];
    const rows = [];
    for(let index = 0; index < items.length; index += columnCount){
        const row = items.slice(index, index + columnCount);
        while(row.length < columnCount)row.push(null);
        rows.push(row);
    }
    return rows;
};

});

parcelRegister("48GtE", function(module, exports) {

$parcel$export(module.exports, "handleTabChangeEditCamera", () => $c478114a9471978f$export$90b6e625f06e4659);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $dmblq = parcelRequire("dmblq");

var $dGpG4 = parcelRequire("dGpG4");

var $jdgli = parcelRequire("jdgli");

var $eWsxc = parcelRequire("eWsxc");

var $fNPIE = parcelRequire("fNPIE");

var $kR2pu = parcelRequire("kR2pu");

var $8xHBc = parcelRequire("8xHBc");

var $jZEH7 = parcelRequire("jZEH7");

var $pQI3G = parcelRequire("pQI3G");

var $7SrQs = parcelRequire("7SrQs");

var $4wo2Y = parcelRequire("4wo2Y");

var $lE6VE = parcelRequire("lE6VE");

var $fU1zL = parcelRequire("fU1zL");

var $dWhHk = parcelRequire("dWhHk");

var $5UPfW = parcelRequire("5UPfW");

var $1wTA3 = parcelRequire("1wTA3");

var $8ntwe = parcelRequire("8ntwe");

var $bvvPD = parcelRequire("bvvPD");

var $cxjhB = parcelRequire("cxjhB");
const $c478114a9471978f$export$90b6e625f06e4659 = (tabValue, editMode, setClickedTab, setActiveTab, siteInfo, cameraGeneralInfo, setCameraGeneralInfo, setPatchObject, setGeneralInfoChangesMade, immixAlerts, diceAlerts, setActiveChangeMade, sureviewAlerts, setAddImmixAlertDialogOpen, setAddDiceAlertDialogOpen, setAddSureviewAlertDialogOpen, streamsObject, activeProducts, recipientsConfiguredData, titlesArray, navigate, setBackdropLoadingScreenOn, setRecipientsConfiguredData, setTitlesArray, actionRulesData, setActionRulesData, actionRulesTitlesArray, setActionRulesTitlesArray, applicationsConfiguredData, timeTablesData, setTimeTablesData, iPNotifyData, setIPNotifyData, actionHandlerData, setActionHandlerData, axisFinished, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setSendingDiceTest, setDiceTestSuccessDialogOpen, setDiceTestFailDialogOpen, cameraWebhookData, setCameraWebhooksPatchObject, setCameraWebhooksChangesMade, productsData, setProductsData, allTabsOpen, setAllTabsOpen, setBackupProductsData, sentinelAlerts, setAddSentinelAlertDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, uSMonitoringAlerts, setAddUSMonitoringAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, streamParametersData, streamParametersPatchObject, setStreamParametersPatchObject, setStreamParametersChangesMade, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, setDeleteImmixAlertDialogOpen, setDeleteDiceAlertDialogOpen, immixAlertsOnCamera, diceAlertsOnCamera, sureViewAlertsOnCamera, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera)=>{
    setClickedTab(tabValue);
    localStorage.setItem("editCamerActiveTab", tabValue);
    if (tabValue === "one" && !editMode) setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dmblq.GeneralInfoEditCameraTab), {
            siteInfo: siteInfo,
            cameraGeneralInfo: cameraGeneralInfo
        })
    }));
    else if (tabValue === "one" && editMode) setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dGpG4.GeneralInfoEditCameraTabEditMode), {
            siteInfo: siteInfo,
            cameraGeneralInfo: cameraGeneralInfo,
            setCameraGeneralInfo: setCameraGeneralInfo,
            setPatchObject: setPatchObject,
            setGeneralInfoChangesMade: setGeneralInfoChangesMade,
            setActiveChangeMade: setActiveChangeMade
        })
    }));
    else if (tabValue === "two" && !editMode) setActiveTab(/*#__PURE__*/ (0, $k4ank.jsxs)((0, $4wo2Y.default), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $jdgli.ConnectionsTab), {
                cameraGeneralInfo: cameraGeneralInfo
            }),
            " "
        ]
    }));
    else if (tabValue === "two" && editMode) setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eWsxc.ConnectionsTabEditMode), {
            cameraGeneralInfo: cameraGeneralInfo,
            setCameraGeneralInfo: setCameraGeneralInfo,
            setPatchObject: setPatchObject,
            setGeneralInfoChangesMade: setGeneralInfoChangesMade
        })
    }));
    else if (tabValue === "three" && !editMode) setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fNPIE.NotificationsTab), {
            cameraGeneralInfo: cameraGeneralInfo
        })
    }));
    else if (tabValue === "three" && editMode) setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kR2pu.NotificationsTabEditMode), {
            cameraGeneralInfo: cameraGeneralInfo,
            setCameraGeneralInfo: setCameraGeneralInfo,
            setPatchObject: setPatchObject,
            setGeneralInfoChangesMade: setGeneralInfoChangesMade
        })
    }));
    else if (tabValue === "four" && !editMode) setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8xHBc.ProductsTab), {
            productsData: productsData,
            setProductsData: setProductsData,
            allTabsOpen: allTabsOpen,
            setAllTabsOpen: setAllTabsOpen,
            setBackupProductsData: setBackupProductsData
        })
    }));
    else if (tabValue === "four" && editMode) setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jZEH7.ProductsTabEditMode), {
            activeProducts: activeProducts,
            setPatchObject: setPatchObject,
            setGeneralInfoChangesMade: setGeneralInfoChangesMade,
            cameraGeneralInfo: cameraGeneralInfo,
            productsData: productsData,
            setProductsData: setProductsData,
            allTabsOpen: allTabsOpen,
            setAllTabsOpen: setAllTabsOpen,
            setBackupProductsData: setBackupProductsData,
            siteInfo: siteInfo
        })
    }));
    else if (tabValue === "five" && !editMode) setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wTA3.SlicingTab), {})
    }));
    else if (tabValue === "five" && editMode) setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8ntwe.SlicingTabEditMode), {})
    }));
    else if (tabValue === "seventeen" && !editMode) setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $bvvPD.VlmTab), {})
    }));
    else if (tabValue === "seventeen" && editMode) setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxjhB.VlmTabEditMode), {})
    }));
    else if (tabValue === "seven") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
            recipientsConfiguredData: recipientsConfiguredData,
            titlesArray: titlesArray,
            navigate: navigate,
            setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
            setRecipientsConfiguredData: setRecipientsConfiguredData,
            setTitlesArray: setTitlesArray,
            actionRulesData: actionRulesData,
            setActionRulesData: setActionRulesData,
            actionRulesTitlesArray: actionRulesTitlesArray,
            setActionRulesTitlesArray: setActionRulesTitlesArray,
            setActiveTab: setActiveTab,
            applicationsConfiguredData: applicationsConfiguredData,
            cameraGeneralInfo: cameraGeneralInfo,
            axisFinished: axisFinished
        })
    }));
    else if (tabValue === "eight") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $7SrQs.MobotixTab), {
            timeTablesData: timeTablesData,
            navigate: navigate,
            setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
            setTimeTablesData: setTimeTablesData,
            setActiveTab: setActiveTab,
            iPNotifyData: iPNotifyData,
            setIPNotifyData: setIPNotifyData,
            actionHandlerData: actionHandlerData,
            setActionHandlerData: setActionHandlerData
        })
    }));
    else if (tabValue === "fifteen" && !editMode) setActiveTab(/*#__PURE__*/ (0, $k4ank.jsxs)((0, $4wo2Y.default), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $lE6VE.StreamParametersTab), {
                streamParametersData: streamParametersData,
                siteInfo: siteInfo
            }),
            " "
        ]
    }));
    else if (tabValue === "fifteen" && editMode) setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fU1zL.StreamParametersTabEditMode), {
            streamParametersData: streamParametersData,
            streamParametersPatchObject: streamParametersPatchObject,
            setStreamParametersPatchObject: setStreamParametersPatchObject,
            setStreamParametersChangesMade: setStreamParametersChangesMade,
            siteInfo: siteInfo
        })
    }));
    else if (tabValue === "sixteen" && !editMode) {
        localStorage.setItem("softguardAlertsBackup", JSON.stringify(softguardAlerts));
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dWhHk.AlertSettingsTab), {
                immixAlerts: immixAlerts,
                setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                setSendingImmixTest: setSendingImmixTest,
                setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                diceAlerts: diceAlerts,
                setAddDiceAlertDialogOpen: setAddDiceAlertDialogOpen,
                setSendingDiceTest: setSendingDiceTest,
                setDiceTestSuccessDialogOpen: setDiceTestSuccessDialogOpen,
                setDiceTestFailDialogOpen: setDiceTestFailDialogOpen,
                setDeleteDiceAlertDialogOpen: setDeleteDiceAlertDialogOpen,
                sureviewAlerts: sureviewAlerts,
                setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                sentinelAlerts: sentinelAlerts,
                setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                boldAlerts: boldAlerts,
                setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                patriotAlerts: patriotAlerts,
                setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                softguardAlerts: softguardAlerts,
                setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                immixAlertsOnCamera: immixAlertsOnCamera,
                diceAlertsOnCamera: diceAlertsOnCamera,
                sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                siteInfo: siteInfo,
                webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                boldAlertsOnCamera: boldAlertsOnCamera,
                patriotAlertsOnCamera: patriotAlertsOnCamera,
                softguardAlertsOnCamera: softguardAlertsOnCamera,
                evalinkAlertsOnCamera: evalinkAlertsOnCamera,
                navigate: navigate
            })
        }));
    } else if (tabValue === "sixteen" && editMode) setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $5UPfW.AlertSettingsTabEditMode), {
            immixAlerts: immixAlerts,
            diceAlerts: diceAlerts,
            sureviewAlerts: sureviewAlerts,
            setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
            sentinelAlerts: sentinelAlerts,
            boldAlerts: boldAlerts,
            patriotAlerts: patriotAlerts,
            softguardAlerts: softguardAlerts,
            immixAlertsOnCamera: immixAlertsOnCamera,
            diceAlertsOnCamera: diceAlertsOnCamera,
            sureViewAlertsOnCamera: sureViewAlertsOnCamera,
            siteInfo: siteInfo,
            webhooksAlertsOnCamera: webhooksAlertsOnCamera,
            sentinelAlertsOnCamera: sentinelAlertsOnCamera,
            boldAlertsOnCamera: boldAlertsOnCamera,
            patriotAlertsOnCamera: patriotAlertsOnCamera,
            softguardAlertsOnCamera: softguardAlertsOnCamera,
            evalinkAlertsOnCamera: evalinkAlertsOnCamera,
            cameraGeneralInfo: cameraGeneralInfo,
            setPatchObject: setPatchObject,
            setGeneralInfoChangesMade: setGeneralInfoChangesMade,
            setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen
        })
    }));
};

});
parcelRegister("dmblq", function(module, exports) {

$parcel$export(module.exports, "GeneralInfoEditCameraTab", () => $acee4aae8c34e52b$export$7567138e7f4135b0);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $ddLR4 = parcelRequire("ddLR4");

var $gfzcx = parcelRequire("gfzcx");

var $3r5gr = parcelRequire("3r5gr");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");

var $aZxZ3 = parcelRequire("aZxZ3");

var $cs9mF = parcelRequire("cs9mF");

var $lWchQ = parcelRequire("lWchQ");

var $2aMB5 = parcelRequire("2aMB5");

var $8jTCz = parcelRequire("8jTCz");

var $aYdit = parcelRequire("aYdit");

var $7b37s = parcelRequire("7b37s");

var $k7hHD = parcelRequire("k7hHD");
const $acee4aae8c34e52b$export$7567138e7f4135b0 = ({ siteInfo: siteInfo, cameraGeneralInfo: cameraGeneralInfo })=>{
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    const cameraViewOptions = JSON.parse(localStorage.cameraViewOptions);
    const cameraViewOptionNames = new Map();
    cameraViewOptions.forEach((option)=>{
        cameraViewOptionNames.set(option.value, option.name);
    });
    const connectionsTitlesArray = JSON.parse(localStorage.connectionsTitlesArray);
    const [showPassword, setShowPassword] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const handleClickShowPassword = ()=>setShowPassword((show)=>!show);
    const handleMouseDownPassword = (event)=>{
        event.preventDefault();
    };
    const handleMouseUpPassword = (event)=>{
        event.preventDefault();
    };
    const [titlesArray, setTitlesArray] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([
        "",
        ""
    ]);
    const { chmActive: chmActive, setNotesDialogEditCameraOpen: setNotesDialogEditCameraOpen } = (0, $aZxZ3.useEditCameraStore)();
    const autopatrolSite = siteInfo.integration_type_name === "autopatrol";
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (cameraGeneralInfo.streams[0].show_nvr_alarm) setTitlesArray([
            "SES recipients",
            "NVR Alarm"
        ]);
        else setTitlesArray([
            "SES recipients",
            ""
        ]);
    }, []);
    const generalInfoHeaders = autopatrolSite ? [
        "Customer",
        "Camera Name",
        "Active",
        "Notes"
    ] : [
        "Customer",
        "Camera Name",
        "Camera View",
        "Alarm Type",
        "Active",
        "Camera Health Monitoring",
        "Notes"
    ];
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                sx: {
                    minWidth: 1000,
                    fontFamily: "Mulish",
                    tableLayout: "fixed"
                },
                "aria-label": "simple table",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("colgroup", {
                        children: Array.from({
                            length: (0, $7b37s.GENERAL_INFO_COLUMN_COUNT)
                        }).map((_, index)=>/*#__PURE__*/ (0, $k4ank.jsx)("col", {
                                style: {
                                    width: `${100 / (0, $7b37s.GENERAL_INFO_COLUMN_COUNT)}%`
                                }
                            }, `general-info-col-${index}`))
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                        titlesArray: generalInfoHeaders
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $gXvgZ.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: (0, $7b37s.generalInfoTableCellSx),
                                        children: siteInfo.parent_group.name
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: (0, $7b37s.generalInfoTableCellSx),
                                        children: cameraGeneralInfo.camera_name
                                    }),
                                    !autopatrolSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: (0, $7b37s.generalInfoTableCellSx),
                                        children: cameraViewOptionNames.get(cameraGeneralInfo.camera_view)
                                    }),
                                    !autopatrolSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: (0, $7b37s.generalInfoTableCellSx),
                                        children: (0, $3r5gr.createCameraAlarmType)(cameraGeneralInfo.default_alarm)
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: (0, $7b37s.generalInfoTableCellSx),
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                            checked: cameraGeneralInfo.active,
                                            color: "warning",
                                            disabled: true
                                        })
                                    }),
                                    !autopatrolSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: (0, $7b37s.generalInfoTableCellSx),
                                        children: chmActive ? (0, $lWchQ.checkedCircleIcon) : (0, $2aMB5.cancelIconRed)
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: (0, $7b37s.generalInfoTableCellSx),
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                            onClick: ()=>{
                                                setNotesDialogEditCameraOpen(true);
                                            },
                                            text: "See Notes",
                                            disabled: false
                                        })
                                    })
                                ]
                            }, (0, $a8BPe.getNumbersAfterEditCamera)(location.href)),
                            !autopatrolSite && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $k7hHD.GeneralInfoConnectionHeaderRows), {
                                        connectionTitles: connectionsTitlesArray
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $k7hHD.GeneralInfoConnectionViewRows), {
                                        siteInfo: siteInfo,
                                        cameraGeneralInfo: cameraGeneralInfo,
                                        userPermissions: userPermissions,
                                        showPassword: showPassword,
                                        onToggleShowPassword: handleClickShowPassword,
                                        onMouseDownPassword: handleMouseDownPassword,
                                        onMouseUpPassword: handleMouseUpPassword
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !autopatrolSite && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                sx: {
                    minWidth: 1000,
                    fontFamily: "Mulish"
                },
                "aria-label": "simple table",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                        titlesArray: titlesArray
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        width: 600
                                    },
                                    children: cameraGeneralInfo.streams[0].ses_recipients ? cameraGeneralInfo.streams[0].ses_recipients : "--"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: cameraGeneralInfo.streams[0].show_nvr_alarm && /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                        checked: cameraGeneralInfo.streams[0].nvr_alarm,
                                        color: "warning",
                                        disabled: true
                                    })
                                })
                            ]
                        }, (0, $a8BPe.getNumbersAfterEditCamera)(location.href))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cs9mF.CameraMotionSetting), {
                cameraGeneralInfo: cameraGeneralInfo,
                siteInfo: siteInfo
            })
        ]
    });
};

});
parcelRegister("3r5gr", function(module, exports) {

$parcel$export(module.exports, "createCameraAlarmType", () => $7e153f35a634b8bd$export$e69b7e0132f1fda5);
parcelRequire("8T3gX");
const $7e153f35a634b8bd$export$e69b7e0132f1fda5 = (defaultAlarmNumber)=>{
    const alarmOptions = JSON.parse(localStorage.alarmOptions);
    const alarmNames = new Map();
    alarmOptions.forEach((object)=>{
        alarmNames.set(object.value, object.name);
    });
    return alarmNames.get(defaultAlarmNumber);
};

});

parcelRegister("aZxZ3", function(module, exports) {

$parcel$export(module.exports, "useEditCameraStore", () => $01f7f3204326992e$export$bf3fcc0fd92e87c0);

var $9OjAn = parcelRequire("9OjAn");

var $fLtYK = parcelRequire("fLtYK");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");

var $815yO = parcelRequire("815yO");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");

var $1Xths = parcelRequire("1Xths");

var $2wOL1 = parcelRequire("2wOL1");

var $8F1dZ = parcelRequire("8F1dZ");

var $h0GCV = parcelRequire("h0GCV");

var $2ET09 = parcelRequire("2ET09");

var $cgwj6 = parcelRequire("cgwj6");

var $bWd1D = parcelRequire("bWd1D");

var $2Vdx4 = parcelRequire("2Vdx4");
/** `permission.super_user` from the login-time user/info in localStorage. */ const $01f7f3204326992e$var$isSuperUserFromLocalStorage = ()=>{
    try {
        const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
        return userInfo?.permission?.super_user === true;
    } catch  {
        return false;
    }
};
/**
 * Determines if Side A is on the left side of the screen based on line coordinates.
 */ const $01f7f3204326992e$var$isSideAOnLeft = (coordinates)=>{
    const [point1, point2] = coordinates;
    const dx = point2[0] - point1[0];
    const dy = point2[1] - point1[1];
    if (dy !== 0) return dy < 0;
    else return dx < 0;
};
/**
 * Converts backend direction format to frontend format.
 */ const $01f7f3204326992e$var$backendToFrontendDirection = (rawBackendDirection, coordinates)=>{
    // ENG-1317: case-insensitive; see normalizeBackendDirection.
    const backendDirection = (0, $fLtYK.normalizeBackendDirection)(rawBackendDirection);
    if (backendDirection === "both") return "Both";
    const sideAIsLeft = $01f7f3204326992e$var$isSideAOnLeft(coordinates);
    if (backendDirection === "l2r") return sideAIsLeft ? "AtoB" : "BtoA";
    else return sideAIsLeft ? "BtoA" : "AtoB";
};
/**
 * Checks if a direction string is in the legacy frontend format.
 */ const $01f7f3204326992e$var$isLegacyDirectionFormat = (direction)=>{
    return direction === "AtoB" || direction === "BtoA" || direction === "Both";
};
const $01f7f3204326992e$export$bf3fcc0fd92e87c0 = (0, $9OjAn.create)((set, get)=>({
        selectedAlertId: "",
        selectedAlertType: "",
        setSelectedAlertId: (selectedAlertId)=>set({
                selectedAlertId: selectedAlertId
            }),
        setSelectedAlertType: (selectedAlertType)=>set({
                selectedAlertType: selectedAlertType
            }),
        notesDialogEditCameraOpen: false,
        notesText: "",
        setNotesText: (notesText)=>set({
                notesText: notesText
            }),
        setNotesDialogEditCameraOpen: (notesDialogEditCameraOpen)=>set({
                notesDialogEditCameraOpen: notesDialogEditCameraOpen
            }),
        streamChangesMade: false,
        setStreamChangesMade: (streamChangesMade)=>set({
                streamChangesMade: streamChangesMade
            }),
        enveraUser: // ((userInfo?.group?.name === "Envera") || (userInfo?.permission?.super_user)) ? true :
        false,
        siteInfoEditCamera: {},
        setSiteInfoEditCamera: (siteInfoEditCamera)=>set({
                siteInfoEditCamera: siteInfoEditCamera
            }),
        chmActive: false,
        setChmActive: (chmActive)=>set({
                chmActive: chmActive
            }),
        lineCrossingActive: {
            intruder: false,
            vehicle: false
        },
        setLineCrossingActive: (lineCrossingActive)=>set({
                lineCrossingActive: lineCrossingActive
            }),
        // Line crossings data
        lineCrossingsData: [],
        setLineCrossingsData: (lineCrossingsData)=>set({
                lineCrossingsData: lineCrossingsData
            }),
        lineCrossingsMetricLabels: [],
        setLineCrossingsMetricLabels: (lineCrossingsMetricLabels)=>set({
                lineCrossingsMetricLabels: lineCrossingsMetricLabels
            }),
        getLineCrossingsData: async (navigate, cameraId)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const { setLineCrossingsData: setLineCrossingsData, setLineCrossingsMetricLabels: setLineCrossingsMetricLabels, getLineCrossingsData: getLineCrossingsData } = get();
            const retryFunction = ()=>{
                getLineCrossingsData(navigate, cameraId);
            };
            try {
                // Fetch line crossings and metrics concurrently
                const [lineCrossingsResponse, metricsResponse] = await Promise.all([
                    // Default (camera-wide) lines only; preset lines belong to their preset's view.
                    AxiosUI.get((0, $2wOL1.buildLineCrossingsListPath)(cameraId)),
                    AxiosUI.get(`/metric/?camera_id=${cameraId}`)
                ]);
                // Filter metrics to only include intruder_line_crossing, vehicle_line_crossing, bike_line_crossing
                const allowedLabels = [
                    "intruder_line_crossing",
                    "vehicle_line_crossing",
                    "bike_line_crossing"
                ];
                const filteredMetrics = metricsResponse.data.results.filter((metric)=>allowedLabels.includes(metric.label_name)).map((metric)=>({
                        id: metric.label,
                        label_name: metric.label_name
                    }));
                setLineCrossingsMetricLabels(filteredMetrics);
                // Process line crossings - assign colors to each line
                const lineCrossings = lineCrossingsResponse.data.results || [];
                const processedLines = lineCrossings.map((line, index)=>{
                    // Handle both legacy and new formats for direction
                    let frontendDirection;
                    if ($01f7f3204326992e$var$isLegacyDirectionFormat(line.direction || "")) frontendDirection = line.direction || "Both";
                    else frontendDirection = $01f7f3204326992e$var$backendToFrontendDirection(line.direction || "both", line.coordinates);
                    return {
                        id: line.id,
                        camera: line.camera,
                        metric_labels: line.metric_labels || [],
                        coordinates: line.coordinates,
                        direction: frontendDirection,
                        color: (0, $1Xths.LINE_COLORS)[index % (0, $1Xths.LINE_COLORS).length]
                    };
                });
                setLineCrossingsData(processedLines);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    // Silently fail - line crossings data is supplementary
                    console.warn("Failed to load line crossings data");
                });
            }
        },
        addHealthMonitoringDialogOpen: false,
        setAddHealthMonitoringDialogOpen: (addHealthMonitoringDialogOpen)=>set({
                addHealthMonitoringDialogOpen: addHealthMonitoringDialogOpen
            }),
        chmValueChanged: false,
        deleteWebhookDialogOpen: false,
        setDeleteWebhookDialogOpen: (deleteWebhookDialogOpen)=>set({
                deleteWebhookDialogOpen: deleteWebhookDialogOpen
            }),
        deleteAlertDialogOpen: false,
        setDeleteAlertDialogOpen: (deleteAlertDialogOpen)=>set({
                deleteAlertDialogOpen: deleteAlertDialogOpen
            }),
        webhookIdToDelete: "",
        setWebhookIdToDelete: (webhookIdToDelete)=>set({
                webhookIdToDelete: webhookIdToDelete
            }),
        backdropLoadingScreenEditCameraOn: false,
        setBackdropLoadingScreenEditCameraOn: (backdropLoadingScreenEditCameraOn)=>set({
                backdropLoadingScreenEditCameraOn: backdropLoadingScreenEditCameraOn
            }),
        setCHMValueChanged: (chmValueChanged)=>set({
                chmValueChanged: chmValueChanged
            }),
        showHealthMonitoring: false,
        setShowHealthMonitoring: (showHealthMonitoring)=>set({
                showHealthMonitoring: showHealthMonitoring
            }),
        chmStreamMetric: {},
        setCHMStreamMetric: (chmStreamMetric)=>set({
                chmStreamMetric: chmStreamMetric
            }),
        cameraStreams: null,
        setCameraStreams: (cameraStreams)=>set({
                cameraStreams: cameraStreams
            }),
        cameraStreamsSelectedIndex: 0,
        setCameraStreamsSelectedIndex: (cameraStreamsSelectedIndex)=>set({
                cameraStreamsSelectedIndex: cameraStreamsSelectedIndex
            }),
        sysaidAlertsOnCamera: false,
        setSysaidAlertsOnCamera: (sysaidAlertsOnCamera)=>set({
                sysaidAlertsOnCamera: sysaidAlertsOnCamera
            }),
        addSysaidAlertDialogOpen: false,
        setAddSysaidAlertDialogOpen: (addSysaidAlertDialogOpen)=>set({
                addSysaidAlertDialogOpen: addSysaidAlertDialogOpen
            }),
        webhooksData: null,
        setWebhooksData: (webhooksData)=>set({
                webhooksData: webhooksData
            }),
        cameraStreamsObject: {},
        setCameraStreamsObject: (cameraStreamsObject)=>set({
                cameraStreamsObject: cameraStreamsObject
            }),
        cameraStreamsPatchObject: [],
        setCameraStreamsPatchObject: (cameraStreamsPatchObject)=>set((state)=>({
                    cameraStreamsPatchObject: typeof cameraStreamsPatchObject === "function" ? cameraStreamsPatchObject(state.cameraStreamsPatchObject || []) : cameraStreamsPatchObject
                })),
        updatedAlertStreamTypes: {
            immix: false,
            dice: false,
            sureview: false,
            sentinel: false,
            bold: false,
            patriot: false,
            softguard: false,
            sysaid: false,
            evalink: false
        },
        updatedAlertStreams: {
            immix: {},
            dice: {},
            sureview: {},
            sentinel: {},
            bold: {},
            patriot: {},
            softguard: {},
            sysaid: {},
            evalink: {}
        },
        setUpdatedAlertStreamTypes: (updatedAlertStreamTypes)=>set((state)=>({
                    updatedAlertStreamTypes: typeof updatedAlertStreamTypes === "function" ? updatedAlertStreamTypes(state.updatedAlertStreamTypes) : updatedAlertStreamTypes
                })),
        setUpdatedAlertStreams: (updatedAlertStreams)=>set((state)=>({
                    updatedAlertStreams: typeof updatedAlertStreams === "function" ? updatedAlertStreams(state.updatedAlertStreams) : updatedAlertStreams
                })),
        vCHOnlySite: false,
        setVCHOnlySite: (vCHOnlySite)=>set({
                vCHOnlySite: vCHOnlySite
            }),
        slicingChangesMade: false,
        setSlicingChangesMade: (slicingChangesMade)=>set({
                slicingChangesMade: slicingChangesMade
            }),
        slicingChanges: [],
        setSlicingChanges: (slicingChanges)=>set({
                slicingChanges: slicingChanges
            }),
        showSlicingWarningMessage: false,
        setShowSlicingWarningMessage: (showSlicingWarningMessage)=>set({
                showSlicingWarningMessage: showSlicingWarningMessage
            }),
        vlmSettings: {
            ...(0, $8F1dZ.DEFAULT_VLM_SETTINGS)
        },
        vlmSettingsBackup: {
            ...(0, $8F1dZ.DEFAULT_VLM_SETTINGS)
        },
        vlmCustomCase: (0, $8F1dZ.DEFAULT_CUSTOM_ANALYSIS_NAME),
        vlmCustomCaseBackup: (0, $8F1dZ.DEFAULT_CUSTOM_ANALYSIS_NAME),
        vlmConfigLoading: false,
        vlmConfigLoaded: false,
        vlmConfigCameraId: null,
        vlmCaseValueMap: {},
        vlmChangesMade: false,
        setVlmChangesMade: (vlmChangesMade)=>set({
                vlmChangesMade: vlmChangesMade
            }),
        fetchCameraVlmConfig: async (cameraId, navigate)=>{
            const { vlmConfigLoaded: vlmConfigLoaded, vlmConfigCameraId: vlmConfigCameraId } = get();
            if (vlmConfigLoaded && vlmConfigCameraId === cameraId) return;
            set({
                vlmConfigLoading: true,
                vlmConfigCameraId: cameraId
            });
            const response = await (0, $2ET09.getCameraVlmConfig)(cameraId, navigate);
            if (!response) {
                set({
                    vlmConfigLoading: false
                });
                return;
            }
            const { singleImageModalityId: singleImageModalityId, imageDiffModalityId: imageDiffModalityId } = (0, $2Vdx4.getModalityIdsFromConfig)(response.modalities);
            // vlm_case/ is superuser-only on the admin API; for everyone else the
            // three reads below only produced a 403 per Edit Camera open (SUP-688,
            // ENG-2014), so they are skipped and the case map stays empty.
            const canReadVlmCases = $01f7f3204326992e$var$isSuperUserFromLocalStorage();
            const [singleImageCases, imageDiffCases, allCases] = await Promise.all([
                canReadVlmCases && singleImageModalityId ? (0, $cgwj6.getVlmCases)(singleImageModalityId, navigate) : Promise.resolve([]),
                canReadVlmCases && imageDiffModalityId ? (0, $cgwj6.getVlmCases)(imageDiffModalityId, navigate) : Promise.resolve([]),
                canReadVlmCases ? (0, $cgwj6.getAllVlmCases)(navigate) : Promise.resolve([])
            ]);
            const vlmCaseValueMap = (0, $2Vdx4.resolveVlmCaseValueMap)(response, singleImageCases, imageDiffCases, allCases);
            const uiState = (0, $h0GCV.mapVlmConfigToUi)(response, vlmCaseValueMap);
            set({
                vlmSettings: uiState.settings,
                vlmSettingsBackup: {
                    ...uiState.settings
                },
                vlmCustomCase: uiState.customAnalysisName,
                vlmCustomCaseBackup: uiState.customAnalysisName,
                vlmConfigLoading: false,
                vlmConfigLoaded: true,
                vlmCaseValueMap: vlmCaseValueMap,
                vlmChangesMade: false
            });
        },
        setVlmDraft: (settings, customAnalysisName)=>{
            set((state)=>({
                    vlmSettings: settings ? {
                        ...state.vlmSettings,
                        ...settings
                    } : state.vlmSettings,
                    vlmCustomCase: customAnalysisName !== undefined ? customAnalysisName : state.vlmCustomCase,
                    vlmChangesMade: true
                }));
        },
        resetVlmDraft: ()=>{
            const { vlmSettingsBackup: vlmSettingsBackup, vlmCustomCaseBackup: vlmCustomCaseBackup } = get();
            set({
                vlmSettings: {
                    ...vlmSettingsBackup
                },
                vlmCustomCase: vlmCustomCaseBackup,
                vlmChangesMade: false
            });
        },
        patchCameraVlmConfig: async (cameraId, navigate)=>{
            const { vlmSettings: vlmSettings, vlmSettingsBackup: vlmSettingsBackup, vlmCustomCase: vlmCustomCase, vlmCustomCaseBackup: vlmCustomCaseBackup, vlmCaseValueMap: vlmCaseValueMap } = get();
            const patchBody = (0, $h0GCV.buildVlmConfigPatch)({
                settings: vlmSettingsBackup,
                customAnalysisName: vlmCustomCaseBackup
            }, {
                settings: vlmSettings,
                customAnalysisName: vlmCustomCase
            }, vlmCaseValueMap);
            if (!patchBody) {
                set({
                    vlmChangesMade: false
                });
                return true;
            }
            const response = await (0, $bWd1D.patchCameraVlmConfig)(cameraId, patchBody, navigate);
            if (!response) return false;
            const uiState = (0, $h0GCV.mapVlmConfigToUi)(response, vlmCaseValueMap);
            set({
                vlmSettings: uiState.settings,
                vlmSettingsBackup: {
                    ...uiState.settings
                },
                vlmCustomCase: uiState.customAnalysisName,
                vlmCustomCaseBackup: uiState.customAnalysisName,
                vlmChangesMade: false
            });
            return true;
        },
        handleDeleteWebhook: async (navigate, webhookId)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().handleDeleteWebhook(navigate, webhookId);
            };
            const { setBackdropLoadingScreenEditCameraOn: setBackdropLoadingScreenEditCameraOn } = get();
            // setBackdropLoadingScreenEditCameraOn(true);
            try {
                await AxiosUI.delete(`webhook/${webhookId}/`);
                // Stream webhooks ride settings.json (stream_webhooks) — needs a sync.
                (0, $815yO.markSiteUnsynced)();
                get().getWebhooksData(navigate, Number((0, $a8BPe.getNumbersAfterEditCamera)(window.location.href)));
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    alert("Problem deleting Webhook. Please try again.");
                    setBackdropLoadingScreenEditCameraOn(false);
                });
            }
        },
        getWebhooksData: async (navigate, cameraId)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const { setWebhooksData: setWebhooksData, setBackdropLoadingScreenEditCameraOn: setBackdropLoadingScreenEditCameraOn } = get();
            const retryFunction = ()=>{
                get().getWebhooksData(navigate, cameraId);
            };
            try {
                const response = await AxiosUI.get(`/webhook/?stream__camera__id=${cameraId}`);
                if (response.data.count > 0) setWebhooksData(response.data.results);
                setBackdropLoadingScreenEditCameraOn(false);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
            }
        },
        handleSubmitNewStreamWebhook: async (postObject, navigate, cameraId)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const { setBackdropLoadingScreenEditCameraOn: setBackdropLoadingScreenEditCameraOn } = get();
            const retryFunction = ()=>{
                get().handleSubmitNewStreamWebhook(postObject, navigate, cameraId);
            };
            try {
                await AxiosUI.post(`/webhook/add/`, postObject);
                (0, $815yO.markSiteUnsynced)();
                const { getWebhooksData: getWebhooksData } = get();
                getWebhooksData(navigate, cameraId);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    alert("Error creating new Stream Webhook.  Please try again.");
                    setBackdropLoadingScreenEditCameraOn(false);
                });
            }
        },
        handlePatchStreamWebhook: async (postObject, webhookId, navigate)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().handlePatchStreamWebhook(postObject, webhookId, navigate);
            };
            const { getWebhooksData: getWebhooksData, setBackdropLoadingScreenEditCameraOn: setBackdropLoadingScreenEditCameraOn } = get();
            try {
                await AxiosUI.patch(`/webhook/${webhookId}/`, postObject);
                (0, $815yO.markSiteUnsynced)();
                getWebhooksData(navigate, Number((0, $a8BPe.getNumbersAfterEditCamera)(window.location.href)));
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    alert("Error updating Stream Webhook.  Please try again.");
                    setBackdropLoadingScreenEditCameraOn(false);
                });
            }
        },
        getCameraStreams: async (navigate, cameraId)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const { setCameraStreams: setCameraStreams } = get();
            const retryFunction = ()=>{
                get().getCameraStreams(navigate, cameraId);
            };
            try {
                const response = await AxiosUI.get(`stream/product/?camera_id=${cameraId}`);
                if (response.data) setCameraStreams(response.data);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
            }
        },
        handlePatchCameraStreams: async (navigate, cameraId, setEditMode)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const { cameraStreamsPatchObject: cameraStreamsPatchObject, setStreamChangesMade: setStreamChangesMade, setCameraStreamsPatchObject: setCameraStreamsPatchObject, setCameraStreamsObject: setCameraStreamsObject, cameraStreamsObject: cameraStreamsObject, setBackdropLoadingScreenEditCameraOn: setBackdropLoadingScreenEditCameraOn, handlePatchCameraStreams: handlePatchCameraStreams } = get();
            const retryFunction = ()=>{
                handlePatchCameraStreams(navigate, cameraId, setEditMode);
            };
            setBackdropLoadingScreenEditCameraOn(true);
            try {
                const response = await AxiosUI.patch(`camera/${cameraId}/general_info/`, {
                    streams: cameraStreamsPatchObject
                });
                // Stream config rides settings.json to the connector — the site now has
                // unsynced changes.
                (0, $815yO.markSiteUnsynced)();
                setStreamChangesMade(false);
                setEditMode(false);
                setCameraStreamsPatchObject(response.data.streams);
                setCameraStreamsObject(response.data.streams);
                setBackdropLoadingScreenEditCameraOn(false);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setCameraStreamsPatchObject(cameraStreamsObject);
                    alert("Error updating Stream.  Please try again.");
                    setBackdropLoadingScreenEditCameraOn(false);
                });
            }
        },
        handleSubmitNewSysaidAlert: async (postObject, setCameraGeneralInfo, setCameraGeneralInfoBackup, setPatchObject, cameraGeneralInfoBackup, navigate)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const { setBackdropLoadingScreenEditCameraOn: setBackdropLoadingScreenEditCameraOn, handleSubmitNewSysaidAlert: handleSubmitNewSysaidAlert, setCameraStreamsPatchObject: setCameraStreamsPatchObject, setCameraStreamsObject: setCameraStreamsObject } = get();
            setBackdropLoadingScreenEditCameraOn(true);
            const retryFunction = ()=>{
                handleSubmitNewSysaidAlert(postObject, setCameraGeneralInfo, setCameraGeneralInfoBackup, setPatchObject, cameraGeneralInfoBackup, navigate);
            };
            try {
                const response = await AxiosUI.patch(`/camera/${(0, $a8BPe.getNumbersAfterEditCamera)(location.href)}/general_info/`, {
                    streams: postObject
                });
                // New SysAid alert rides the streams in settings.json — needs a sync.
                (0, $815yO.markSiteUnsynced)();
                setCameraGeneralInfo(response.data);
                setCameraGeneralInfoBackup(response.data);
                setCameraStreamsPatchObject(response.data.streams);
                setCameraStreamsObject(response.data.streams);
                setBackdropLoadingScreenEditCameraOn(false);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    alert("Error adding SysAid Alert.  Please try again.");
                    setCameraGeneralInfo(cameraGeneralInfoBackup);
                    setPatchObject({
                        camera_name: cameraGeneralInfoBackup.camera_name,
                        streams: cameraGeneralInfoBackup.streams
                    });
                    setCameraStreamsPatchObject(cameraGeneralInfoBackup.streams);
                    setCameraStreamsObject(cameraGeneralInfoBackup.streams);
                    setBackdropLoadingScreenEditCameraOn(false);
                });
            }
        },
        handlePatchImmixAlerts: async (navigate, setEditMode)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const { setUpdatedAlertStreams: setUpdatedAlertStreams, handlePatchImmixAlerts: handlePatchImmixAlerts, updatedAlertStreams: updatedAlertStreams, setUpdatedAlertStreamTypes: setUpdatedAlertStreamTypes, setBackdropLoadingScreenEditCameraOn: setBackdropLoadingScreenEditCameraOn, setCameraStreamsPatchObject: setCameraStreamsPatchObject, setCameraStreamsObject: setCameraStreamsObject } = get();
            const retryFunction = ()=>{
                handlePatchImmixAlerts(navigate, setEditMode);
            };
            if (updatedAlertStreams.immix) {
                setBackdropLoadingScreenEditCameraOn(true);
                const keys = Object.keys(updatedAlertStreams.immix);
                keys.forEach(async (key, index)=>{
                    const alertId = key;
                    const alertData = updatedAlertStreams.immix[alertId];
                    try {
                        await AxiosUI.patch(`/immix/${alertId}/`, alertData);
                        (0, $815yO.markSiteUnsynced)();
                        if (index === keys.length - 1) {
                            setUpdatedAlertStreamTypes((prev)=>({
                                    ...prev,
                                    immix: false
                                }));
                            setUpdatedAlertStreams((prev)=>({
                                    ...prev,
                                    immix: {}
                                }));
                            try {
                                const response = await AxiosUI.get(`camera/${(0, $a8BPe.getNumbersAfterEditCamera)(window.location.href)}/general_info/`);
                                if (response.data) {
                                    setEditMode(false);
                                    setCameraStreamsPatchObject(response.data.streams);
                                    setCameraStreamsObject(response.data.streams);
                                    setBackdropLoadingScreenEditCameraOn(false);
                                }
                            } catch (reason) {
                                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                                    setEditMode(false);
                                    setBackdropLoadingScreenEditCameraOn(false);
                                });
                            }
                        }
                    } catch (reason) {
                        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                            alert("Error updating an Immix Alert.  Please try again.");
                            if (index === keys.length - 1) {
                                setUpdatedAlertStreamTypes((prev)=>({
                                        ...prev,
                                        immix: false
                                    }));
                                setUpdatedAlertStreams((prev)=>({
                                        ...prev,
                                        immix: {}
                                    }));
                            }
                            setBackdropLoadingScreenEditCameraOn(false);
                        });
                    }
                });
            }
        },
        handlePatchDiceAlerts: async (navigate, setEditMode)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const { setUpdatedAlertStreams: setUpdatedAlertStreams, handlePatchDiceAlerts: handlePatchDiceAlerts, updatedAlertStreams: updatedAlertStreams, setUpdatedAlertStreamTypes: setUpdatedAlertStreamTypes, setBackdropLoadingScreenEditCameraOn: setBackdropLoadingScreenEditCameraOn, setCameraStreamsPatchObject: setCameraStreamsPatchObject, setCameraStreamsObject: setCameraStreamsObject } = get();
            const retryFunction = ()=>{
                handlePatchDiceAlerts(navigate, setEditMode);
            };
            if (updatedAlertStreams.dice) {
                setBackdropLoadingScreenEditCameraOn(true);
                const keys = Object.keys(updatedAlertStreams.dice);
                keys.forEach(async (key, index)=>{
                    const alertId = key;
                    const alertData = updatedAlertStreams.dice[alertId];
                    try {
                        await AxiosUI.patch(`/dice/${alertId}/`, alertData);
                        (0, $815yO.markSiteUnsynced)();
                        if (index === keys.length - 1) {
                            setUpdatedAlertStreamTypes((prev)=>({
                                    ...prev,
                                    dice: false
                                }));
                            setUpdatedAlertStreams((prev)=>({
                                    ...prev,
                                    dice: {}
                                }));
                            try {
                                const response = await AxiosUI.get(`camera/${(0, $a8BPe.getNumbersAfterEditCamera)(window.location.href)}/general_info/`);
                                if (response.data) {
                                    setEditMode(false);
                                    setCameraStreamsPatchObject(response.data.streams);
                                    setCameraStreamsObject(response.data.streams);
                                    setBackdropLoadingScreenEditCameraOn(false);
                                }
                            } catch (reason) {
                                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                                    setEditMode(false);
                                    setBackdropLoadingScreenEditCameraOn(false);
                                });
                            }
                        }
                    } catch (reason) {
                        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                            alert("Error updating a Dice Alert.  Please try again.");
                            if (index === keys.length - 1) {
                                setUpdatedAlertStreamTypes((prev)=>({
                                        ...prev,
                                        dice: false
                                    }));
                                setUpdatedAlertStreams((prev)=>({
                                        ...prev,
                                        dice: {}
                                    }));
                            }
                            setBackdropLoadingScreenEditCameraOn(false);
                        });
                    }
                });
            }
        },
        handlePatchBoldAlerts: async (navigate, setEditMode)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const { setUpdatedAlertStreams: setUpdatedAlertStreams, handlePatchBoldAlerts: handlePatchBoldAlerts, updatedAlertStreams: updatedAlertStreams, setUpdatedAlertStreamTypes: setUpdatedAlertStreamTypes, setBackdropLoadingScreenEditCameraOn: setBackdropLoadingScreenEditCameraOn, setCameraStreamsPatchObject: setCameraStreamsPatchObject, setCameraStreamsObject: setCameraStreamsObject } = get();
            const retryFunction = ()=>{
                handlePatchBoldAlerts(navigate, setEditMode);
            };
            if (updatedAlertStreams.bold) {
                setBackdropLoadingScreenEditCameraOn(true);
                const keys = Object.keys(updatedAlertStreams.bold);
                keys.forEach(async (key, index)=>{
                    const alertId = key;
                    const alertData = updatedAlertStreams.bold[alertId];
                    try {
                        await AxiosUI.patch(`/bold/${alertId}/`, alertData);
                        (0, $815yO.markSiteUnsynced)();
                        if (index === keys.length - 1) {
                            setUpdatedAlertStreamTypes((prev)=>({
                                    ...prev,
                                    bold: false
                                }));
                            setUpdatedAlertStreams((prev)=>({
                                    ...prev,
                                    bold: {}
                                }));
                            try {
                                const response = await AxiosUI.get(`camera/${(0, $a8BPe.getNumbersAfterEditCamera)(window.location.href)}/general_info/`);
                                if (response.data) {
                                    setEditMode(false);
                                    setCameraStreamsPatchObject(response.data.streams);
                                    setCameraStreamsObject(response.data.streams);
                                    setBackdropLoadingScreenEditCameraOn(false);
                                }
                            } catch (reason) {
                                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                                    setEditMode(false);
                                    setBackdropLoadingScreenEditCameraOn(false);
                                });
                            }
                        }
                    } catch (reason) {
                        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                            alert("Error updating an Immix Alert.  Please try again.");
                            if (index === keys.length - 1) {
                                setUpdatedAlertStreamTypes((prev)=>({
                                        ...prev,
                                        bold: false
                                    }));
                                setUpdatedAlertStreams((prev)=>({
                                        ...prev,
                                        bold: {}
                                    }));
                            }
                            setBackdropLoadingScreenEditCameraOn(false);
                        });
                    }
                });
            }
        },
        handlePatchPatriotAlerts: async (navigate, setEditMode, setPatriotAlerts)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const { setUpdatedAlertStreams: setUpdatedAlertStreams, handlePatchPatriotAlerts: handlePatchPatriotAlerts, updatedAlertStreams: updatedAlertStreams, setUpdatedAlertStreamTypes: setUpdatedAlertStreamTypes, setBackdropLoadingScreenEditCameraOn: setBackdropLoadingScreenEditCameraOn, setCameraStreamsPatchObject: setCameraStreamsPatchObject, setCameraStreamsObject: setCameraStreamsObject } = get();
            const retryFunction = ()=>{
                handlePatchPatriotAlerts(navigate, setEditMode, setPatriotAlerts);
            };
            if (updatedAlertStreams.patriot) {
                setBackdropLoadingScreenEditCameraOn(true);
                const keys = Object.keys(updatedAlertStreams.patriot);
                try {
                    // Use Promise.all to properly await all PATCH operations
                    await Promise.all(keys.map(async (key)=>{
                        const alertId = key;
                        const alertData = updatedAlertStreams.patriot[alertId];
                        await AxiosUI.patch(`/patriot/${alertId}/`, alertData);
                        (0, $815yO.markSiteUnsynced)();
                    }));
                    // All patches succeeded, now update state and refresh data
                    setUpdatedAlertStreamTypes((prev)=>({
                            ...prev,
                            patriot: false
                        }));
                    setUpdatedAlertStreams((prev)=>({
                            ...prev,
                            patriot: {}
                        }));
                    try {
                        const response = await AxiosUI.get(`camera/${(0, $a8BPe.getNumbersAfterEditCamera)(window.location.href)}/general_info/`);
                        if (response.data) {
                            setEditMode(false);
                            setCameraStreamsPatchObject(response.data.streams);
                            setCameraStreamsObject(response.data.streams);
                            // Update patriotAlerts state with the refreshed data
                            const patriotPushedArray = [];
                            if (response.data.streams[0]?.patriot_alerts) response.data.streams[0].patriot_alerts.forEach((alertObject)=>{
                                patriotPushedArray.push(alertObject);
                            });
                            setPatriotAlerts(patriotPushedArray);
                            setBackdropLoadingScreenEditCameraOn(false);
                        }
                    } catch (reason) {
                        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                            setEditMode(false);
                            setBackdropLoadingScreenEditCameraOn(false);
                        });
                    }
                } catch (reason) {
                    (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                        alert("Error updating a Patriot Alert.  Please try again.");
                        setUpdatedAlertStreamTypes((prev)=>({
                                ...prev,
                                patriot: false
                            }));
                        setUpdatedAlertStreams((prev)=>({
                                ...prev,
                                patriot: {}
                            }));
                        setBackdropLoadingScreenEditCameraOn(false);
                    });
                }
            }
        },
        handlePatchSureviewAlerts: async (navigate, setEditMode)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const { setUpdatedAlertStreams: setUpdatedAlertStreams, handlePatchSureviewAlerts: handlePatchSureviewAlerts, updatedAlertStreams: updatedAlertStreams, setUpdatedAlertStreamTypes: setUpdatedAlertStreamTypes, setBackdropLoadingScreenEditCameraOn: setBackdropLoadingScreenEditCameraOn, setCameraStreamsPatchObject: setCameraStreamsPatchObject, setCameraStreamsObject: setCameraStreamsObject } = get();
            const retryFunction = ()=>{
                handlePatchSureviewAlerts(navigate, setEditMode);
            };
            if (updatedAlertStreams.sureview) {
                setBackdropLoadingScreenEditCameraOn(true);
                const keys = Object.keys(updatedAlertStreams.sureview);
                keys.forEach(async (key, index)=>{
                    const alertId = key;
                    const alertData = updatedAlertStreams.sureview[alertId];
                    try {
                        await AxiosUI.patch(`/sureview/${alertId}/`, alertData);
                        (0, $815yO.markSiteUnsynced)();
                        if (index === keys.length - 1) {
                            setUpdatedAlertStreamTypes((prev)=>({
                                    ...prev,
                                    sureview: false
                                }));
                            setUpdatedAlertStreams((prev)=>({
                                    ...prev,
                                    sureview: {}
                                }));
                            try {
                                const response = await AxiosUI.get(`camera/${(0, $a8BPe.getNumbersAfterEditCamera)(window.location.href)}/general_info/`);
                                if (response.data) {
                                    setEditMode(false);
                                    setCameraStreamsPatchObject(response.data.streams);
                                    setCameraStreamsObject(response.data.streams);
                                    setBackdropLoadingScreenEditCameraOn(false);
                                }
                            } catch (reason) {
                                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                                    setEditMode(false);
                                    setBackdropLoadingScreenEditCameraOn(false);
                                });
                            }
                        }
                    } catch (reason) {
                        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                            alert("Error updating an Sureview Alert.  Please try again.");
                            if (index === keys.length - 1) {
                                setUpdatedAlertStreamTypes((prev)=>({
                                        ...prev,
                                        sureview: false
                                    }));
                                setUpdatedAlertStreams((prev)=>({
                                        ...prev,
                                        sureview: {}
                                    }));
                            }
                            setBackdropLoadingScreenEditCameraOn(false);
                        });
                    }
                });
            }
        },
        handlePatchSentinelAlerts: async (navigate, setEditMode)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const { setUpdatedAlertStreams: setUpdatedAlertStreams, handlePatchSentinelAlerts: handlePatchSentinelAlerts, updatedAlertStreams: updatedAlertStreams, setUpdatedAlertStreamTypes: setUpdatedAlertStreamTypes, setBackdropLoadingScreenEditCameraOn: setBackdropLoadingScreenEditCameraOn, setCameraStreamsPatchObject: setCameraStreamsPatchObject, setCameraStreamsObject: setCameraStreamsObject } = get();
            const retryFunction = ()=>{
                handlePatchSentinelAlerts(navigate, setEditMode);
            };
            if (updatedAlertStreams.sentinel) {
                setBackdropLoadingScreenEditCameraOn(true);
                const keys = Object.keys(updatedAlertStreams.sentinel);
                keys.forEach(async (key, index)=>{
                    const alertId = key;
                    const alertData = updatedAlertStreams.sentinel[alertId];
                    try {
                        await AxiosUI.patch(`/sentinel/${alertId}/`, alertData);
                        (0, $815yO.markSiteUnsynced)();
                        if (index === keys.length - 1) {
                            setUpdatedAlertStreamTypes((prev)=>({
                                    ...prev,
                                    sentinel: false
                                }));
                            setUpdatedAlertStreams((prev)=>({
                                    ...prev,
                                    sentinel: {}
                                }));
                            try {
                                const response = await AxiosUI.get(`camera/${(0, $a8BPe.getNumbersAfterEditCamera)(window.location.href)}/general_info/`);
                                if (response.data) {
                                    setEditMode(false);
                                    setCameraStreamsPatchObject(response.data.streams);
                                    setCameraStreamsObject(response.data.streams);
                                    setBackdropLoadingScreenEditCameraOn(false);
                                }
                            } catch (reason) {
                                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                                    setEditMode(false);
                                    setBackdropLoadingScreenEditCameraOn(false);
                                });
                            }
                        }
                    } catch (reason) {
                        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                            alert("Error updating an Sentinel Alert.  Please try again.");
                            if (index === keys.length - 1) {
                                setUpdatedAlertStreamTypes((prev)=>({
                                        ...prev,
                                        sentinel: false
                                    }));
                                setUpdatedAlertStreams((prev)=>({
                                        ...prev,
                                        sentinel: {}
                                    }));
                            }
                            setBackdropLoadingScreenEditCameraOn(false);
                        });
                    }
                });
            }
        },
        handlePatchSoftguardAlerts: async (navigate, setEditMode)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const { setUpdatedAlertStreams: setUpdatedAlertStreams, handlePatchSoftguardAlerts: handlePatchSoftguardAlerts, updatedAlertStreams: updatedAlertStreams, setUpdatedAlertStreamTypes: setUpdatedAlertStreamTypes, setBackdropLoadingScreenEditCameraOn: setBackdropLoadingScreenEditCameraOn, setCameraStreamsPatchObject: setCameraStreamsPatchObject, setCameraStreamsObject: setCameraStreamsObject } = get();
            const retryFunction = ()=>{
                handlePatchSoftguardAlerts(navigate, setEditMode);
            };
            if (updatedAlertStreams.softguard) {
                setBackdropLoadingScreenEditCameraOn(true);
                const keys = Object.keys(updatedAlertStreams.softguard);
                keys.forEach(async (key, index)=>{
                    const alertId = key;
                    const alertData = updatedAlertStreams.softguard[alertId];
                    try {
                        await AxiosUI.patch(`/softguard/${alertId}/`, alertData);
                        (0, $815yO.markSiteUnsynced)();
                        if (index === keys.length - 1) {
                            setUpdatedAlertStreamTypes((prev)=>({
                                    ...prev,
                                    softguard: false
                                }));
                            setUpdatedAlertStreams((prev)=>({
                                    ...prev,
                                    softguard: {}
                                }));
                            try {
                                const response = await AxiosUI.get(`camera/${(0, $a8BPe.getNumbersAfterEditCamera)(window.location.href)}/general_info/`);
                                if (response.data) {
                                    setEditMode(false);
                                    setCameraStreamsPatchObject(response.data.streams);
                                    setCameraStreamsObject(response.data.streams);
                                    setBackdropLoadingScreenEditCameraOn(false);
                                }
                            } catch (reason) {
                                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                                    setEditMode(false);
                                    setBackdropLoadingScreenEditCameraOn(false);
                                });
                            }
                        }
                    } catch (reason) {
                        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                            alert("Error updating an Softguard Alert.  Please try again.");
                            if (index === keys.length - 1) {
                                setUpdatedAlertStreamTypes((prev)=>({
                                        ...prev,
                                        softguard: false
                                    }));
                                setUpdatedAlertStreams((prev)=>({
                                        ...prev,
                                        softguard: {}
                                    }));
                            }
                            setBackdropLoadingScreenEditCameraOn(false);
                        });
                    }
                });
            }
        },
        handlePatchSysaidAlerts: async (navigate, setEditMode)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const { setUpdatedAlertStreams: setUpdatedAlertStreams, handlePatchSysaidAlerts: handlePatchSysaidAlerts, updatedAlertStreams: updatedAlertStreams, setUpdatedAlertStreamTypes: setUpdatedAlertStreamTypes, setBackdropLoadingScreenEditCameraOn: setBackdropLoadingScreenEditCameraOn, setCameraStreamsPatchObject: setCameraStreamsPatchObject, setCameraStreamsObject: setCameraStreamsObject } = get();
            const retryFunction = ()=>{
                handlePatchSysaidAlerts(navigate, setEditMode);
            };
            if (updatedAlertStreams.sysaid) {
                setBackdropLoadingScreenEditCameraOn(true);
                const keys = Object.keys(updatedAlertStreams.sysaid);
                keys.forEach(async (key, index)=>{
                    const alertId = key;
                    const alertData = updatedAlertStreams.sysaid[alertId];
                    try {
                        await AxiosUI.patch(`/sysaid/${alertId}/`, alertData);
                        (0, $815yO.markSiteUnsynced)();
                        if (index === keys.length - 1) {
                            setUpdatedAlertStreamTypes((prev)=>({
                                    ...prev,
                                    sysaid: false
                                }));
                            setUpdatedAlertStreams((prev)=>({
                                    ...prev,
                                    sysaid: {}
                                }));
                            try {
                                const response = await AxiosUI.get(`camera/${(0, $a8BPe.getNumbersAfterEditCamera)(window.location.href)}/general_info/`);
                                if (response.data) {
                                    setEditMode(false);
                                    setCameraStreamsPatchObject(response.data.streams);
                                    setCameraStreamsObject(response.data.streams);
                                    setBackdropLoadingScreenEditCameraOn(false);
                                }
                            } catch (reason) {
                                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                                    setEditMode(false);
                                    setBackdropLoadingScreenEditCameraOn(false);
                                });
                            }
                        }
                    } catch (reason) {
                        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                            alert("Error updating an SysAid Alert.  Please try again.");
                            if (index === keys.length - 1) {
                                setUpdatedAlertStreamTypes((prev)=>({
                                        ...prev,
                                        sysaid: false
                                    }));
                                setUpdatedAlertStreams((prev)=>({
                                        ...prev,
                                        sysaid: {}
                                    }));
                            }
                            setBackdropLoadingScreenEditCameraOn(false);
                        });
                    }
                });
            }
        },
        handlePatchEvalinkAlerts: async (navigate, setEditMode)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const { setUpdatedAlertStreams: setUpdatedAlertStreams, handlePatchEvalinkAlerts: handlePatchEvalinkAlerts, updatedAlertStreams: updatedAlertStreams, setUpdatedAlertStreamTypes: setUpdatedAlertStreamTypes, setBackdropLoadingScreenEditCameraOn: setBackdropLoadingScreenEditCameraOn, setCameraStreamsPatchObject: setCameraStreamsPatchObject, setCameraStreamsObject: setCameraStreamsObject } = get();
            const retryFunction = ()=>{
                handlePatchEvalinkAlerts(navigate, setEditMode);
            };
            if (updatedAlertStreams.evalink) {
                setBackdropLoadingScreenEditCameraOn(true);
                const keys = Object.keys(updatedAlertStreams.evalink);
                keys.forEach(async (key, index)=>{
                    const alertId = key;
                    const alertData = updatedAlertStreams.evalink[alertId];
                    try {
                        await AxiosUI.patch(`/evalink/${alertId}/`, alertData);
                        (0, $815yO.markSiteUnsynced)();
                        if (index === keys.length - 1) {
                            setUpdatedAlertStreamTypes((prev)=>({
                                    ...prev,
                                    evalink: false
                                }));
                            setUpdatedAlertStreams((prev)=>({
                                    ...prev,
                                    evalink: {}
                                }));
                            try {
                                const response = await AxiosUI.get(`camera/${(0, $a8BPe.getNumbersAfterEditCamera)(window.location.href)}/general_info/`);
                                if (response.data) {
                                    setEditMode(false);
                                    setCameraStreamsPatchObject(response.data.streams);
                                    setCameraStreamsObject(response.data.streams);
                                    setBackdropLoadingScreenEditCameraOn(false);
                                }
                            } catch (reason) {
                                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                                    setEditMode(false);
                                    setBackdropLoadingScreenEditCameraOn(false);
                                });
                            }
                        }
                    } catch (reason) {
                        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                            alert("Error updating an Evalink Alert.  Please try again.");
                            if (index === keys.length - 1) {
                                setUpdatedAlertStreamTypes((prev)=>({
                                        ...prev,
                                        evalink: false
                                    }));
                                setUpdatedAlertStreams((prev)=>({
                                        ...prev,
                                        evalink: {}
                                    }));
                            }
                            setBackdropLoadingScreenEditCameraOn(false);
                        });
                    }
                });
            }
        },
        handleDeleteAlerts: async (navigate)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const { setBackdropLoadingScreenEditCameraOn: setBackdropLoadingScreenEditCameraOn, handleDeleteAlerts: handleDeleteAlerts, setCameraStreamsPatchObject: setCameraStreamsPatchObject, setCameraStreamsObject: setCameraStreamsObject, selectedAlertId: selectedAlertId, selectedAlertType: selectedAlertType } = get();
            const retryFunction = ()=>{
                handleDeleteAlerts(navigate);
            };
            setBackdropLoadingScreenEditCameraOn(true);
            try {
                await AxiosUI.delete(`/${selectedAlertType}/${selectedAlertId}/`);
                // Alert-integration configs ride settings.json — needs a sync.
                (0, $815yO.markSiteUnsynced)();
                try {
                    const response = await AxiosUI.get(`camera/${(0, $a8BPe.getNumbersAfterEditCamera)(window.location.href)}/general_info/`);
                    setCameraStreamsPatchObject(response.data.streams);
                    setCameraStreamsObject(response.data.streams);
                    setBackdropLoadingScreenEditCameraOn(false);
                } catch (reason) {
                    (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                        alert("Problem getting updated data.  Please refresh the page.");
                        setBackdropLoadingScreenEditCameraOn(false);
                    });
                }
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    alert("Problem deleting Alert. Please try again.");
                    setBackdropLoadingScreenEditCameraOn(false);
                });
            }
        },
        handleCheckForVCHOnlySite: async (navigate)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const { handleCheckForVCHOnlySite: handleCheckForVCHOnlySite, setVCHOnlySite: setVCHOnlySite } = get();
            const retryFunction = ()=>{
                handleCheckForVCHOnlySite(navigate);
            };
            try {
                const response = await AxiosUI.get(`auto_patrol_schedule/by_customer/${(0, $a8BPe.getNumbersAfterSites)(window.location.href)}/`);
                const hasAPSchedules = response.data.some((schedule)=>schedule.patrolType === "AutoPatrol");
                if (!hasAPSchedules) setVCHOnlySite(true);
                else setVCHOnlySite(false);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
            }
        },
        handlePatchSlicing: async (streamId, slice, streamIndex, navigate, max_slices)=>{
            const AxiosUI = (0, $195EM.createApi)(``);
            const { setCameraStreamsObject: setCameraStreamsObject } = get();
            const retryFunction = ()=>{
                get().handlePatchSlicing(streamId, slice, streamIndex, navigate, max_slices);
            };
            const patchData = {
                slice: slice
            };
            if (max_slices !== undefined) patchData.max_slices = max_slices;
            try {
                await AxiosUI.patch(`stream/${streamId}/`, patchData);
                // Slicing rides settings.json — same unsynced marking as the bulk
                // slicing dialog.
                (0, $815yO.markSiteUnsynced)();
                const currentStreams = get().cameraStreamsObject;
                const updatedStreams = currentStreams.map((stream, idx)=>idx === streamIndex ? {
                        ...stream,
                        slice: slice,
                        ...max_slices !== undefined && {
                            max_slices: max_slices
                        }
                    } : stream);
                setCameraStreamsObject(updatedStreams);
                return true;
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
                return false;
            }
        },
        resetEditCameraStore: ()=>{
            set({
                cameraStreamsSelectedIndex: 0,
                // Reset on mount so a previous camera's site can't be read as this one's
                // until getEditCameraData refills it.
                siteInfoEditCamera: {},
                sysaidAlertsOnCamera: false,
                addSysaidAlertDialogOpen: false,
                vCHOnlySite: false,
                backdropLoadingScreenEditCameraOn: false,
                lineCrossingActive: {
                    intruder: false,
                    vehicle: false
                },
                lineCrossingsData: [],
                lineCrossingsMetricLabels: [],
                showSlicingWarningMessage: false,
                vlmSettings: {
                    ...(0, $8F1dZ.DEFAULT_VLM_SETTINGS)
                },
                vlmSettingsBackup: {
                    ...(0, $8F1dZ.DEFAULT_VLM_SETTINGS)
                },
                vlmCustomCase: (0, $8F1dZ.DEFAULT_CUSTOM_ANALYSIS_NAME),
                vlmCustomCaseBackup: (0, $8F1dZ.DEFAULT_CUSTOM_ANALYSIS_NAME),
                vlmConfigLoading: false,
                vlmConfigLoaded: false,
                vlmConfigCameraId: null,
                vlmCaseValueMap: {},
                vlmChangesMade: false
            });
        }
    }));

});
parcelRegister("1Xths", function(module, exports) {

$parcel$export(module.exports, "LINE_COLORS", () => $0848b571cc8d45f0$export$b7f07238211e7efd);
$parcel$export(module.exports, "getNextLineColor", () => $0848b571cc8d45f0$export$9aba921de6544e83);

var $aHe9T = parcelRequire("aHe9T");
const $0848b571cc8d45f0$export$b7f07238211e7efd = (0, $aHe9T.metadataTagZonesColorArray);
const $0848b571cc8d45f0$export$9aba921de6544e83 = (existingLines)=>{
    const usedColors = existingLines.map((line)=>line.color);
    // Find the first unused color
    for (const color of $0848b571cc8d45f0$export$b7f07238211e7efd){
        if (!usedColors.includes(color)) return color;
    }
    // If all colors are used, cycle based on the number of existing lines
    return $0848b571cc8d45f0$export$b7f07238211e7efd[existingLines.length % $0848b571cc8d45f0$export$b7f07238211e7efd.length];
};

});
parcelRegister("aHe9T", function(module, exports) {

$parcel$export(module.exports, "metadataTagZonesColorArray", () => $36c96a0c2fe7d36b$export$93ea4aec34faf8f3);
const $36c96a0c2fe7d36b$export$93ea4aec34faf8f3 = [
    "#FF4AEA",
    "#71D9FF",
    "#50FF00",
    "#FFAD07",
    "#B739FF",
    "#FF69B4",
    "#FFD700",
    "#FF6347",
    "#32CD32",
    "#FF1493",
    "#1E90FF",
    "#FF8C00",
    "#00FF7F",
    "#8A2BE2",
    "#00CED1",
    "#ffff00"
];

});


parcelRegister("8F1dZ", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_VLM_SETTINGS", () => $90afa10d5ca97876$export$1df90d0d951f6a24);
$parcel$export(module.exports, "DEFAULT_CUSTOM_ANALYSIS_NAME", () => $90afa10d5ca97876$export$fb03aa6cf656503);
$parcel$export(module.exports, "VlmTabToggles", () => $90afa10d5ca97876$export$6a722d0c306a4707);

var $k4ank = parcelRequire("k4ank");

var $eDfvp = parcelRequire("eDfvp");

var $4reBM = parcelRequire("4reBM");

var $ddLR4 = parcelRequire("ddLR4");

var $eejVe = parcelRequire("eejVe");

var $f3puC = parcelRequire("f3puC");
const $90afa10d5ca97876$export$1df90d0d951f6a24 = {
    environmentalHazards: false,
    lighting: false,
    entryway: false,
    lossPrevention: false,
    leftObjectDetection: false,
    customAnalysis: false
};
const $90afa10d5ca97876$export$fb03aa6cf656503 = "";
const $90afa10d5ca97876$var$columnSx = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: 1,
    minWidth: 140
};
const $90afa10d5ca97876$var$labelSx = {
    fontFamily: "Mulish",
    fontWeight: 700,
    fontSize: 14,
    textAlign: "center",
    mb: 1
};
const $90afa10d5ca97876$var$subLabelSx = {
    fontFamily: "Mulish",
    fontWeight: 600,
    fontSize: 12,
    textAlign: "center",
    mb: 0.5
};
const $90afa10d5ca97876$var$customAnalysisNameSx = {
    fontFamily: "Mulish",
    fontSize: 13,
    textAlign: "center",
    mt: 1,
    width: "100%",
    minHeight: 24,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word"
};
const $90afa10d5ca97876$var$ToggleColumn = ({ label: label, settingKey: settingKey, settings: settings, disabled: disabled, onChange: onChange })=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
        sx: $90afa10d5ca97876$var$columnSx,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                sx: $90afa10d5ca97876$var$labelSx,
                children: label
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                checked: settings[settingKey],
                color: "warning",
                disabled: disabled,
                onChange: (event)=>onChange?.(settingKey, event.target.checked),
                inputProps: {
                    "aria-label": label
                }
            })
        ]
    });
const $90afa10d5ca97876$export$6a722d0c306a4707 = ({ settings: settings, customAnalysisName: customAnalysisName, disabled: disabled, onChange: onChange, onCustomAnalysisNameChange: onCustomAnalysisNameChange })=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $4reBM.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
            sx: {
                display: "flex",
                flexDirection: "row",
                gap: 2,
                p: 3,
                fontFamily: "Mulish",
                flexWrap: "wrap",
                justifyContent: "space-between"
            },
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)($90afa10d5ca97876$var$ToggleColumn, {
                    label: "Environmental Hazards",
                    settingKey: "environmentalHazards",
                    settings: settings,
                    disabled: disabled,
                    onChange: onChange
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)($90afa10d5ca97876$var$ToggleColumn, {
                    label: "Lighting",
                    settingKey: "lighting",
                    settings: settings,
                    disabled: disabled,
                    onChange: onChange
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)($90afa10d5ca97876$var$ToggleColumn, {
                    label: "Entryway",
                    settingKey: "entryway",
                    settings: settings,
                    disabled: disabled,
                    onChange: onChange
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                    sx: {
                        ...$90afa10d5ca97876$var$columnSx,
                        minWidth: 220
                    },
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                            sx: $90afa10d5ca97876$var$labelSx,
                            children: "Compare with Last Patrol"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                            sx: {
                                display: "flex",
                                flexDirection: "row",
                                gap: 2,
                                mt: 1,
                                justifyContent: "center",
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                                    sx: {
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                            sx: $90afa10d5ca97876$var$subLabelSx,
                                            children: "Loss Prevention"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                            checked: settings.lossPrevention,
                                            color: "warning",
                                            disabled: disabled,
                                            onChange: (event)=>onChange?.("lossPrevention", event.target.checked),
                                            inputProps: {
                                                "aria-label": "Loss Prevention"
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                                    sx: {
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                            sx: $90afa10d5ca97876$var$subLabelSx,
                                            children: "Left Object Detection"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                            checked: settings.leftObjectDetection,
                                            color: "warning",
                                            disabled: disabled,
                                            onChange: (event)=>onChange?.("leftObjectDetection", event.target.checked),
                                            inputProps: {
                                                "aria-label": "Left Object Detection"
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                    sx: {
                        ...$90afa10d5ca97876$var$columnSx,
                        minWidth: 180
                    },
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                            sx: $90afa10d5ca97876$var$labelSx,
                            children: "Custom Analysis"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                            checked: settings.customAnalysis,
                            color: "warning",
                            disabled: disabled,
                            onChange: (event)=>onChange?.("customAnalysis", event.target.checked),
                            inputProps: {
                                "aria-label": "Custom Analysis"
                            }
                        }),
                        disabled ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                            sx: $90afa10d5ca97876$var$customAnalysisNameSx,
                            children: customAnalysisName
                        }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                            value: customAnalysisName,
                            onChange: (event)=>onCustomAnalysisNameChange?.(event.target.value),
                            variant: "outlined",
                            multiline: true,
                            rows: 3,
                            placeholder: "Enter custom analysis name",
                            sx: {
                                mt: 1,
                                width: "100%",
                                "& .MuiInputBase-root": {
                                    fontFamily: "Mulish"
                                },
                                "& .MuiInputBase-input": {
                                    fontFamily: "Mulish"
                                }
                            },
                            inputProps: {
                                "aria-label": "Custom analysis name"
                            }
                        })
                    ]
                })
            ]
        })
    });

});

parcelRegister("h0GCV", function(module, exports) {

$parcel$export(module.exports, "mapVlmConfigToUi", () => $0e47f544d219c60b$export$a189c7e2db199e7d);
$parcel$export(module.exports, "buildVlmConfigPatch", () => $0e47f544d219c60b$export$46aa8b8ee5f610ab);

var $8F1dZ = parcelRequire("8F1dZ");
const $0e47f544d219c60b$var$UI_FLAG_MAPPINGS = [
    {
        settingsKey: "environmentalHazards",
        modality: "single_image"
    },
    {
        settingsKey: "lighting",
        modality: "single_image"
    },
    {
        settingsKey: "entryway",
        modality: "single_image"
    },
    {
        settingsKey: "lossPrevention",
        modality: "image_diff"
    },
    {
        settingsKey: "leftObjectDetection",
        modality: "image_diff"
    },
    {
        settingsKey: "customAnalysis",
        modality: "single_image"
    }
];
const $0e47f544d219c60b$var$getCaseKey = (settingsKey, caseValueMap)=>caseValueMap[settingsKey];
const $0e47f544d219c60b$var$getFlagEnabled = (response, modality, caseKey)=>{
    const entry = response.vlm_flags?.[modality]?.[caseKey];
    return entry?.enabled ?? false;
};
const $0e47f544d219c60b$export$a189c7e2db199e7d = (response, caseValueMap = {})=>{
    const settings = {
        ...(0, $8F1dZ.DEFAULT_VLM_SETTINGS)
    };
    $0e47f544d219c60b$var$UI_FLAG_MAPPINGS.forEach((mapping)=>{
        const caseKey = $0e47f544d219c60b$var$getCaseKey(mapping.settingsKey, caseValueMap);
        settings[mapping.settingsKey] = caseKey ? $0e47f544d219c60b$var$getFlagEnabled(response, mapping.modality, caseKey) : false;
    });
    return {
        settings: settings,
        customAnalysisName: response.vlm_custom_case ?? ""
    };
};
const $0e47f544d219c60b$export$46aa8b8ee5f610ab = (baseline, draft, caseValueMap = {})=>{
    const patch = {};
    const vlmFlags = {};
    $0e47f544d219c60b$var$UI_FLAG_MAPPINGS.forEach((mapping)=>{
        const baselineValue = baseline.settings[mapping.settingsKey];
        const draftValue = draft.settings[mapping.settingsKey];
        const caseKey = $0e47f544d219c60b$var$getCaseKey(mapping.settingsKey, caseValueMap);
        if (caseKey && baselineValue !== draftValue) {
            if (!vlmFlags[mapping.modality]) vlmFlags[mapping.modality] = {};
            vlmFlags[mapping.modality][caseKey] = draftValue;
        }
    });
    if (Object.keys(vlmFlags).length > 0) patch.vlm_flags = vlmFlags;
    if (baseline.customAnalysisName !== draft.customAnalysisName) patch.vlm_custom_case = draft.customAnalysisName;
    return Object.keys(patch).length > 0 ? patch : null;
};

});

parcelRegister("2ET09", function(module, exports) {

$parcel$export(module.exports, "getCameraVlmConfig", () => $86fe729e7f27e61e$export$2db673388be4b232);

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $86fe729e7f27e61e$export$2db673388be4b232 = (cameraId, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>$86fe729e7f27e61e$export$2db673388be4b232(cameraId, navigate);
    return AxiosUI.get(`/camera/${cameraId}/vlm_config/`).then((response)=>response.data).catch((reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
        return null;
    });
};

});

parcelRegister("cgwj6", function(module, exports) {

$parcel$export(module.exports, "getVlmCases", () => $baad5cf9ee022007$export$34c10d75b73d7693);
$parcel$export(module.exports, "getAllVlmCases", () => $baad5cf9ee022007$export$12aac232de7f5936);

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $baad5cf9ee022007$var$normalizeVlmCaseList = (data)=>{
    if (Array.isArray(data)) return data;
    return data.results ?? [];
};
const $baad5cf9ee022007$export$34c10d75b73d7693 = (modalityId, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>$baad5cf9ee022007$export$34c10d75b73d7693(modalityId, navigate);
    return AxiosUI.get(`/vlm_case/?modality=${modalityId}`).then((response)=>$baad5cf9ee022007$var$normalizeVlmCaseList(response.data)).catch((reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
        return [];
    });
};
const $baad5cf9ee022007$export$12aac232de7f5936 = (navigate)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>$baad5cf9ee022007$export$12aac232de7f5936(navigate);
    return AxiosUI.get("/vlm_case/").then((response)=>$baad5cf9ee022007$var$normalizeVlmCaseList(response.data)).catch((reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
        return [];
    });
};

});

parcelRegister("bWd1D", function(module, exports) {

$parcel$export(module.exports, "patchCameraVlmConfig", () => $b21f3ec285f44687$export$7187ca90084747c9);

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $b21f3ec285f44687$export$7187ca90084747c9 = (cameraId, patchBody, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>$b21f3ec285f44687$export$7187ca90084747c9(cameraId, patchBody, navigate);
    return AxiosUI.patch(`/camera/${cameraId}/vlm_config/`, patchBody).then((response)=>response.data).catch((reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
        return null;
    });
};

});

parcelRegister("2Vdx4", function(module, exports) {

$parcel$export(module.exports, "getModalityIdsFromConfig", () => $562edc355d1e9ef0$export$7f4b4f0e6f9aff1);
$parcel$export(module.exports, "resolveVlmCaseValueMap", () => $562edc355d1e9ef0$export$aca7ec0a47e64353);
const $562edc355d1e9ef0$export$5c241751b2a3121 = [
    "environmentalHazards",
    "lighting",
    "entryway",
    "lossPrevention",
    "leftObjectDetection",
    "customAnalysis"
];
/** Backend case values to try in priority order (first match wins). */ const $562edc355d1e9ef0$var$SINGLE_IMAGE_CASE_CANDIDATES = {
    environmentalHazards: [
        "environmental_hazards",
        "environmental_single_img",
        "environmental"
    ],
    lighting: [
        "lighting_single_img",
        "lighting"
    ],
    entryway: [
        "entryway_single_img",
        "entryway"
    ],
    customAnalysis: [
        "custom"
    ]
};
const $562edc355d1e9ef0$var$IMAGE_DIFF_CASE_CANDIDATES = {
    lossPrevention: [
        "loss_prevention_diff",
        "loss_prevention"
    ],
    leftObjectDetection: [
        "left_object_detection_diff",
        "left_object_detection"
    ]
};
const $562edc355d1e9ef0$var$isInternalCaseValue = (value)=>/^dummy_/i.test(value) || /template/i.test(value) || value === "confirmation" || value === "synonym" || value === "contains_feat" || value === "sys_prompt" || value === "postprocessing_stage2" || value === "cvd_meta_analysis" || /^cvd_for_site_classification/i.test(value) || value === "long_cvd_for_site_classification" || value === "long_site_classification" || value === "site_classification" || value === "img-diff";
const $562edc355d1e9ef0$var$resolveCaseValueFromCandidates = (cases, candidates)=>{
    const available = new Set(cases.map((row)=>row.value));
    for (const candidate of candidates){
        if (available.has(candidate)) return candidate;
    }
    return undefined;
};
const $562edc355d1e9ef0$var$resolveSingleImageCases = (cases, map)=>{
    Object.keys($562edc355d1e9ef0$var$SINGLE_IMAGE_CASE_CANDIDATES).forEach((settingsKey)=>{
        if (map[settingsKey]) return;
        const resolved = $562edc355d1e9ef0$var$resolveCaseValueFromCandidates(cases, $562edc355d1e9ef0$var$SINGLE_IMAGE_CASE_CANDIDATES[settingsKey]);
        if (resolved) map[settingsKey] = resolved;
    });
};
const $562edc355d1e9ef0$var$resolveImageDiffCases = (cases, map)=>{
    Object.keys($562edc355d1e9ef0$var$IMAGE_DIFF_CASE_CANDIDATES).forEach((settingsKey)=>{
        if (map[settingsKey]) return;
        const resolved = $562edc355d1e9ef0$var$resolveCaseValueFromCandidates(cases, $562edc355d1e9ef0$var$IMAGE_DIFF_CASE_CANDIDATES[settingsKey]);
        if (resolved) map[settingsKey] = resolved;
    });
};
const $562edc355d1e9ef0$export$7f4b4f0e6f9aff1 = (modalities)=>({
        singleImageModalityId: modalities?.single_image?.modality_id,
        imageDiffModalityId: modalities?.image_diff?.modality_id
    });
const $562edc355d1e9ef0$export$36a05d5e3d48511d = (vlmFlags)=>{
    const map = {};
    const singleImage = vlmFlags?.single_image ?? {};
    const imageDiff = vlmFlags?.image_diff ?? {};
    Object.keys(singleImage).forEach((caseKey)=>{
        if ($562edc355d1e9ef0$var$isInternalCaseValue(caseKey)) return;
        if (/environmental/i.test(caseKey)) map.environmentalHazards = caseKey;
        else if (/lighting/i.test(caseKey)) map.lighting = caseKey;
        else if (/entryway/i.test(caseKey)) map.entryway = caseKey;
        else if (caseKey === "custom") map.customAnalysis = caseKey;
    });
    Object.keys(imageDiff).forEach((caseKey)=>{
        if (/loss.prevention/i.test(caseKey)) map.lossPrevention = caseKey;
        else if (/left.object/i.test(caseKey)) map.leftObjectDetection = caseKey;
    });
    return map;
};
const $562edc355d1e9ef0$export$afc7ad35f577accc = (singleImageCases, imageDiffCases, inferredFromFlags = {})=>{
    const map = {
        ...inferredFromFlags
    };
    $562edc355d1e9ef0$var$resolveSingleImageCases(singleImageCases, map);
    $562edc355d1e9ef0$var$resolveImageDiffCases(imageDiffCases, map);
    return map;
};
const $562edc355d1e9ef0$export$c7c9b6b36600fd37 = (allCases, inferredFromFlags = {})=>{
    const customerCases = allCases.filter((row)=>!$562edc355d1e9ef0$var$isInternalCaseValue(row.value));
    const map = {
        ...inferredFromFlags
    };
    $562edc355d1e9ef0$var$resolveSingleImageCases(customerCases, map);
    $562edc355d1e9ef0$var$resolveImageDiffCases(customerCases, map);
    return map;
};
const $562edc355d1e9ef0$export$aca7ec0a47e64353 = (response, singleImageCases, imageDiffCases, allCases)=>{
    const inferred = $562edc355d1e9ef0$export$36a05d5e3d48511d(response.vlm_flags);
    let map = $562edc355d1e9ef0$export$afc7ad35f577accc(singleImageCases, imageDiffCases, inferred);
    const missingKeys = $562edc355d1e9ef0$export$5c241751b2a3121.filter((key)=>!map[key]);
    if (missingKeys.length > 0 && allCases.length > 0) map = $562edc355d1e9ef0$export$c7c9b6b36600fd37(allCases, map);
    return map;
};

});


parcelRegister("cs9mF", function(module, exports) {

$parcel$export(module.exports, "CameraMotionSetting", () => $37b7b346912056c9$export$c819d02e02eaad43);
/**
 * Edit Camera → General Info: per-camera "Motion" setting (ENG-2242).
 *
 * Inherit the site / Use motion / Always stream, saved on its own with a
 * PATCH of only `use_motion_override` (see cameraMotionOverride.ts for the
 * backend contract). The value rides the connector settings file, so a save
 * marks the site unsynced and says how to apply it.
 *
 * Shown to anyone with camera edit permission; without it the current choice
 * is shown read-only. Hidden on integrations where the setting means nothing
 * (SMTP, AutoPatrol, non-settings-file sites), while the general_info
 * payload doesn't carry the field, and on sites that don't use motion (see
 * motionSettingVisible).
 *
 * Choosing "Use motion" on a site that streams over RTSP shows an advisory
 * note recommending HTTP streaming (ENG-2828, motionStreamingAdvice.ts).
 */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k1BHZ = parcelRequire("k1BHZ");

var $imWqP = parcelRequire("imWqP");

var $3baw3 = parcelRequire("3baw3");

var $3QMQN = parcelRequire("3QMQN");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $815yO = parcelRequire("815yO");

var $3Zv1D = parcelRequire("3Zv1D");

var $195EM = parcelRequire("195EM");

var $aYdit = parcelRequire("aYdit");

var $l8TQ5 = parcelRequire("l8TQ5");

var $9VM4t = parcelRequire("9VM4t");
const $37b7b346912056c9$export$c819d02e02eaad43 = ({ cameraGeneralInfo: cameraGeneralInfo, siteInfo: siteInfo })=>{
    const navigate = (0, $3T949.useNavigate)();
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    const canEdit = !!userPermissions?.edit_cameras;
    const integrationTypeName = siteInfo?.integration_type_name;
    const cameraId = cameraGeneralInfo?.id != null ? String(cameraGeneralInfo.id) : null;
    const fromProp = (0, $l8TQ5.cameraMotionFromGeneralInfo)(cameraGeneralInfo);
    const fromStore = (0, $l8TQ5.useCameraMotionStore)((state)=>cameraId ? state.byCamera[cameraId] : undefined);
    const setCameraMotion = (0, $l8TQ5.useCameraMotionStore)((state)=>state.setCameraMotion);
    const current = fromStore ?? fromProp;
    const currentChoice = (0, $l8TQ5.overrideToChoice)(current?.override);
    // On Milestone XProtect, "inherit" means the camera's milestone_motion,
    // which general_info doesn't carry. Only needed while an override hides it
    // (with no override, the resolved use_motion already is that value).
    const [milestoneMotion, setMilestoneMotion] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(undefined);
    const needsMilestoneMotion = integrationTypeName === "milestone" && current?.override !== null && current?.override !== undefined && milestoneMotion === undefined;
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!needsMilestoneMotion || !cameraId) return;
        let cancelled = false;
        (0, $195EM.createApi)("").get(`/camera/${cameraId}/extra_fields/`).then((response)=>{
            if (!cancelled) setMilestoneMotion(response?.data?.milestone_motion ?? null);
        }, ()=>{
            if (!cancelled) setMilestoneMotion(null);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        needsMilestoneMotion,
        cameraId
    ]);
    const inherited = (0, $l8TQ5.inheritedMotionValue)({
        override: current?.override,
        effective: current?.effective,
        integrationTypeName: integrationTypeName,
        siteUseMotion: siteInfo?.use_motion,
        milestoneMotion: milestoneMotion
    });
    const [draft, setDraft] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(currentChoice);
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [savedNote, setSavedNote] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setDraft(currentChoice);
    }, [
        currentChoice,
        cameraId
    ]);
    if (!cameraId || !current || !(0, $l8TQ5.motionSettingVisible)({
        integrationTypeName: integrationTypeName,
        siteUseMotion: siteInfo?.use_motion,
        cameraUsesMotion: current.effective === true,
        overrideMatters: (0, $l8TQ5.overrideMayMatter)({
            integrationTypeName: integrationTypeName,
            override: current.override
        })
    })) return null;
    const dirty = canEdit && draft !== currentChoice;
    // "Use motion" on an RTSP site: recommend HTTP streaming (ENG-2828).
    // Advisory only; siteInfo is the site About payload the page already loads.
    const streamingAdvice = (0, $9VM4t.cameraMotionStreamingAdvice)(siteInfo, draft === "motion");
    const save = async ()=>{
        if (!dirty || saving) return;
        setSaving(true);
        setError(null);
        setSavedNote(false);
        const override = (0, $l8TQ5.choiceToOverride)(draft);
        try {
            const next = await (0, $l8TQ5.patchCameraMotionOverride)(cameraId, override);
            setCameraMotion(cameraId, next);
            // use_motion rides the connector settings file: needs a Sync (and, on
            // an armed site, the restart the sync prompt offers).
            (0, $815yO.markSiteUnsynced)();
            setSavedNote(true);
            setSaving(false);
        } catch (reason) {
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, ()=>{
                save();
            }, (context)=>{
                if (context?.willRetry) return;
                setError((0, $l8TQ5.MOTION_SAVE_FAILED));
                setSaving(false);
            });
        }
    };
    const groupName = `camera-motion-${cameraId}`;
    const optionLabel = (choice)=>choice === "inherit" ? (0, $l8TQ5.inheritLabel)(inherited) : (0, $l8TQ5.MOTION_CHOICE_LABELS)[choice];
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "m-4 rounded-lg border border-[#E2E8F2] bg-white px-4 py-3 font-mulish text-actuate-blue",
        "data-testid": "camera-motion-setting",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex flex-wrap items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                        id: `${groupName}-label`,
                        className: "text-[15px] font-bold",
                        children: (0, $l8TQ5.MOTION_SETTING_LABEL)
                    }),
                    typeof current.effective === "boolean" && /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                        className: "rounded-full bg-[#F5F7FA] px-2.5 py-0.5 text-[12px] font-semibold text-[#5B6B86]",
                        children: current.effective ? "Using motion" : "Always streaming"
                    }),
                    dirty && /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                        type: "button",
                        onClick: save,
                        disabled: saving,
                        className: "rounded bg-actuate-orange px-3 py-1 text-[13px] font-bold text-white hover:bg-[#e67700] disabled:opacity-60",
                        children: saving ? "Saving\u2026" : "Save"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $imWqP.default), {
                "aria-labelledby": `${groupName}-label`,
                name: groupName,
                value: draft,
                onChange: (event)=>{
                    // Capture eagerly (see CLAUDE.md's setState-updater gotcha).
                    const nextChoice = event.target.value;
                    setDraft(nextChoice);
                    setSavedNote(false);
                    setError(null);
                },
                children: (0, $l8TQ5.MOTION_CHOICES).map((choice)=>/*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "mt-1",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                value: choice,
                                disabled: !canEdit || saving,
                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {
                                    size: "small",
                                    color: "warning"
                                }),
                                label: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                    className: "font-mulish text-[14px] font-semibold",
                                    children: optionLabel(choice)
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "ml-[30px] -mt-1 text-[13px] text-[#5B6B86]",
                                children: (0, $l8TQ5.MOTION_CHOICE_DESCRIPTIONS)[choice]
                            })
                        ]
                    }, choice))
            }),
            streamingAdvice && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                severity: "info",
                "data-testid": "camera-motion-streaming-advice",
                sx: {
                    fontFamily: "Mulish",
                    fontSize: "13px",
                    mt: 1
                },
                children: streamingAdvice
            }),
            savedNote && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                role: "status",
                className: "mt-2 rounded border-l-4 border-actuate-orange bg-[#FFF4E5] px-3 py-2 text-[13px]",
                children: (0, $l8TQ5.MOTION_SAVED_NOTE)
            }),
            error && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                role: "alert",
                className: "mt-2 text-[13px] text-[#D93636]",
                children: error
            })
        ]
    });
};

});

parcelRegister("k7hHD", function(module, exports) {

$parcel$export(module.exports, "GeneralInfoConnectionHeaderRows", () => $ccd2d36d6c6e6447$export$c86edc2cc5e7ae91);
$parcel$export(module.exports, "GeneralInfoConnectionViewRows", () => $ccd2d36d6c6e6447$export$ddd3f0e746245c63);
$parcel$export(module.exports, "GeneralInfoConnectionEditRows", () => $ccd2d36d6c6e6447$export$bfffd7ce358e1ef6);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $aVDw9 = parcelRequire("aVDw9");

var $4o6Cs = parcelRequire("4o6Cs");

var $ddLR4 = parcelRequire("ddLR4");

var $8B8vg = parcelRequire("8B8vg");
var $7UDCh = parcelRequire("7UDCh");
var $9qNow = parcelRequire("9qNow");
var $iKAtE = parcelRequire("iKAtE");
var $fN7FV = parcelRequire("fN7FV");
var $1SPe4 = parcelRequire("1SPe4");
var $eejVe = parcelRequire("eejVe");

var $2yNMw = parcelRequire("2yNMw");
var $4m1S6 = parcelRequire("4m1S6");

var $7t6MD = parcelRequire("7t6MD");

var $gAGBu = parcelRequire("gAGBu");

var $4ziqD = parcelRequire("4ziqD");

var $7b37s = parcelRequire("7b37s");

var $6o91K = parcelRequire("6o91K");

var $lT6uY = parcelRequire("lT6uY");
/**
 * Read-only effective Video source for a camera on a Genetec site, with the
 * API's fallback reason (e.g. "No host set, streaming through the Media
 * Gateway") underneath. Same cell in view and edit mode.
 */ const $ccd2d36d6c6e6447$var$VideoSourceCell = ({ cameraGeneralInfo: cameraGeneralInfo, siteInfo: siteInfo })=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
        align: "left",
        sx: (0, $7b37s.generalInfoTableCellSx),
        "data-testid": "video-source-cell",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                children: (0, $lT6uY.getCameraVideoSourceLabel)(cameraGeneralInfo, siteInfo)
            }),
            cameraGeneralInfo.video_source_reason ? /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "text-xs text-gray-500 mt-1",
                "data-testid": "video-source-reason",
                children: cameraGeneralInfo.video_source_reason
            }) : null
        ]
    }, "video_source");
const $ccd2d36d6c6e6447$export$e24bd3396d52f3c5 = (previousState, nextValue)=>{
    const trimmed = String(nextValue ?? "").trim();
    if (trimmed === "") {
        const { rtsp: _omitted, ...rest } = previousState;
        return rest;
    }
    const port = Number(trimmed);
    return {
        ...previousState,
        rtsp: Number.isInteger(port) && /^\d+$/.test(trimmed) ? port : trimmed
    };
};
const $ccd2d36d6c6e6447$export$c86edc2cc5e7ae91 = ({ connectionTitles: connectionTitles })=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
        children: (0, $7b37s.packIntoRows)(connectionTitles).map((titleRow, rowIndex)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                children: titleRow.map((title, columnIndex)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                        align: "left",
                        sx: {
                            ...(0, $7b37s.generalInfoTableCellSx),
                            fontWeight: 600
                        },
                        children: title ?? ""
                    }, `connection-header-${rowIndex}-${columnIndex}`))
            }, `connection-header-${rowIndex}`))
    });
const $ccd2d36d6c6e6447$export$ddd3f0e746245c63 = ({ siteInfo: siteInfo, cameraGeneralInfo: cameraGeneralInfo, userPermissions: userPermissions, showPassword: showPassword, onToggleShowPassword: onToggleShowPassword, onMouseDownPassword: onMouseDownPassword, onMouseUpPassword: onMouseUpPassword })=>{
    const cells = [];
    if ((0, $6o91K.showVideoSourceColumn)(siteInfo)) cells.push(/*#__PURE__*/ (0, $k4ank.jsx)($ccd2d36d6c6e6447$var$VideoSourceCell, {
        cameraGeneralInfo: cameraGeneralInfo,
        siteInfo: siteInfo
    }, "video_source"));
    if ((0, $6o91K.showHostColumn)(cameraGeneralInfo, siteInfo)) cells.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
        align: "left",
        sx: (0, $7b37s.generalInfoTableCellSx),
        "data-testid": "camera-host-cell",
        children: cameraGeneralInfo.ip ? cameraGeneralInfo.ip : "--"
    }, "host"));
    if ((0, $6o91K.showRtspPortColumn)(siteInfo)) cells.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
        align: "left",
        sx: (0, $7b37s.generalInfoTableCellSx),
        "data-testid": "camera-rtsp-cell",
        children: cameraGeneralInfo.rtsp ? cameraGeneralInfo.rtsp : "--"
    }, "rtsp"));
    if (cameraGeneralInfo.http) cells.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
        align: "left",
        sx: (0, $7b37s.generalInfoTableCellSx),
        children: cameraGeneralInfo.http
    }, "http"));
    if (cameraGeneralInfo.server_port) cells.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
        align: "left",
        sx: (0, $7b37s.generalInfoTableCellSx),
        children: cameraGeneralInfo.server_port
    }, "server_port"));
    if ((0, $4ziqD.showCameraCredentialColumn)("username", cameraGeneralInfo, siteInfo)) cells.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
        align: "left",
        sx: (0, $7b37s.generalInfoTableCellSx),
        "data-testid": "camera-username-cell",
        children: cameraGeneralInfo.username ? cameraGeneralInfo.username : "--"
    }, "username"));
    if ((0, $4ziqD.showCameraCredentialColumn)("password", cameraGeneralInfo, siteInfo)) cells.push(/*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
        align: "left",
        sx: (0, $7b37s.generalInfoTableCellSx),
        "data-testid": "camera-password-cell",
        children: [
            !cameraGeneralInfo.password && "--",
            cameraGeneralInfo.password && userPermissions.view_passwords && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex",
                children: [
                    showPassword ? cameraGeneralInfo.password : (0, $7t6MD.createDots)(cameraGeneralInfo.password),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1SPe4.default), {
                            position: "end",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                "aria-label": showPassword ? "hide the password" : "display the password",
                                onClick: onToggleShowPassword,
                                onMouseDown: onMouseDownPassword,
                                onMouseUp: onMouseUpPassword,
                                edge: "end",
                                children: showPassword ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $4m1S6.default), {}) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $2yNMw.default), {})
                            })
                        })
                    })
                ]
            }),
            cameraGeneralInfo.password && !userPermissions.view_passwords && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "flex items-center",
                children: (0, $7t6MD.createDots)(cameraGeneralInfo.password)
            })
        ]
    }, "password"));
    if (cameraGeneralInfo.channel) cells.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
        align: "left",
        sx: (0, $7b37s.generalInfoTableCellSx),
        children: cameraGeneralInfo.channel
    }, "channel"));
    if ((0, $4ziqD.showStreamParametersColumn)(cameraGeneralInfo, siteInfo)) cells.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
        align: "left",
        sx: (0, $7b37s.generalInfoTableCellSx),
        "data-testid": "stream-parameters-cell",
        children: cameraGeneralInfo.stream_parameters ? cameraGeneralInfo.stream_parameters : "--"
    }, "stream_parameters"));
    if (cameraGeneralInfo.slice) cells.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
        align: "left",
        sx: (0, $7b37s.generalInfoTableCellSx),
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
            checked: cameraGeneralInfo.slice,
            color: "warning",
            disabled: true
        })
    }, "slice"));
    if (cameraGeneralInfo.split) cells.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
        align: "left",
        sx: (0, $7b37s.generalInfoTableCellSx),
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
            checked: cameraGeneralInfo.split,
            color: "warning",
            disabled: true
        })
    }, "split"));
    if (cameraGeneralInfo.use_stream_quality) cells.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
        align: "left",
        sx: (0, $7b37s.generalInfoTableCellSx),
        children: cameraGeneralInfo.stream_quality ? cameraGeneralInfo.stream_quality : 1
    }, "stream_quality"));
    if (cameraGeneralInfo.stream_source) {
        cells.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
            align: "left",
            sx: (0, $7b37s.generalInfoTableCellSx),
            children: (0, $gAGBu.getStreamSourceName)(cameraGeneralInfo.stream_source)
        }, "stream_source"));
        cells.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
            align: "left",
            sx: (0, $7b37s.generalInfoTableCellSx),
            children: cameraGeneralInfo.livestream_url ? (0, $gAGBu.maskLivestreamUrlPassword)(cameraGeneralInfo.livestream_url) : "--"
        }, "livestream_url"));
    }
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
        children: (0, $7b37s.packIntoRows)(cells).map((cellRow, rowIndex)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                children: cellRow.map((cell, columnIndex)=>cell ?? /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                        align: "left",
                        sx: (0, $7b37s.generalInfoTableCellSx)
                    }, `connection-pad-${rowIndex}-${columnIndex}`))
            }, `connection-data-${rowIndex}`))
    });
};
const $ccd2d36d6c6e6447$export$bfffd7ce358e1ef6 = ({ siteInfo: siteInfo, cameraGeneralInfo: cameraGeneralInfo, setCameraGeneralInfo: setCameraGeneralInfo, setPatchObject: setPatchObject, setGeneralInfoChangesMade: setGeneralInfoChangesMade, userPermissions: userPermissions, showPassword: showPassword, onToggleShowPassword: onToggleShowPassword, onMouseDownPassword: onMouseDownPassword, onMouseUpPassword: onMouseUpPassword, handleCredentialChange: handleCredentialChange, livestreamUrlError: livestreamUrlError, setLivestreamUrlError: setLivestreamUrlError })=>{
    const cells = [];
    const genetecDirect = (0, $lT6uY.isGenetecDirectSite)(siteInfo);
    if ((0, $6o91K.showVideoSourceColumn)(siteInfo)) cells.push(/*#__PURE__*/ (0, $k4ank.jsx)($ccd2d36d6c6e6447$var$VideoSourceCell, {
        cameraGeneralInfo: cameraGeneralInfo,
        siteInfo: siteInfo
    }, "video_source"));
    if ((0, $6o91K.showHostColumn)(cameraGeneralInfo, siteInfo)) cells.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
        align: "left",
        sx: (0, $7b37s.generalInfoTableCellSx),
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
            inputProps: {
                "aria-label": "Host"
            },
            defaultValue: cameraGeneralInfo.ip ?? "",
            placeholder: genetecDirect ? (0, $lT6uY.GENETEC_DIRECT_PLACEHOLDERS).host : undefined,
            variant: "standard",
            sx: (0, $7b37s.connectionFieldTextFieldSx),
            type: "string",
            onChange: (event)=>{
                const nextValue = event.target.value;
                setCameraGeneralInfo((previousState)=>({
                        ...previousState,
                        ip: nextValue
                    }));
                setPatchObject((previousState)=>({
                        ...previousState,
                        ip: nextValue
                    }));
                setGeneralInfoChangesMade(true);
            }
        })
    }, "host"));
    if ((0, $6o91K.showRtspPortColumn)(siteInfo)) cells.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
        align: "left",
        sx: (0, $7b37s.generalInfoTableCellSx),
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
            inputProps: {
                "aria-label": "RTSP",
                inputMode: "numeric"
            },
            defaultValue: cameraGeneralInfo.rtsp ?? "",
            placeholder: genetecDirect ? (0, $lT6uY.GENETEC_DIRECT_PLACEHOLDERS).rtsp : undefined,
            variant: "standard",
            sx: (0, $7b37s.connectionFieldTextFieldSx),
            type: "string",
            onChange: (event)=>{
                const nextValue = event.target.value;
                setCameraGeneralInfo((previousState)=>({
                        ...previousState,
                        rtsp: nextValue
                    }));
                setPatchObject((previousState)=>$ccd2d36d6c6e6447$export$e24bd3396d52f3c5(previousState, nextValue));
                setGeneralInfoChangesMade(true);
            }
        })
    }, "rtsp"));
    if (cameraGeneralInfo.http) cells.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
        align: "left",
        sx: (0, $7b37s.generalInfoTableCellSx),
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
            defaultValue: cameraGeneralInfo.http,
            variant: "standard",
            sx: (0, $7b37s.connectionFieldTextFieldSx),
            type: "string",
            onChange: (event)=>{
                setCameraGeneralInfo((previousState)=>({
                        ...previousState,
                        http: event.target.value
                    }));
                setPatchObject((previousState)=>({
                        ...previousState,
                        http: event.target.value
                    }));
                setGeneralInfoChangesMade(true);
            }
        })
    }, "http"));
    if (cameraGeneralInfo.server_port) cells.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
        align: "left",
        sx: (0, $7b37s.generalInfoTableCellSx),
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
            defaultValue: cameraGeneralInfo.server_port,
            variant: "standard",
            sx: (0, $7b37s.connectionFieldTextFieldSx),
            type: "string",
            onChange: (event)=>{
                setCameraGeneralInfo((previousState)=>({
                        ...previousState,
                        server_port: event.target.value
                    }));
                setPatchObject((previousState)=>({
                        ...previousState,
                        server_port: event.target.value
                    }));
                setGeneralInfoChangesMade(true);
            }
        })
    }, "server_port"));
    if ((0, $4ziqD.showCameraCredentialColumn)("username", cameraGeneralInfo, siteInfo)) cells.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
        align: "left",
        sx: (0, $7b37s.generalInfoTableCellSx),
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
            inputProps: {
                "aria-label": "Username"
            },
            defaultValue: cameraGeneralInfo.username ?? "",
            variant: "standard",
            sx: (0, $7b37s.connectionFieldTextFieldSx),
            type: "string",
            helperText: cameraGeneralInfo.username ? undefined : (0, $4ziqD.SITE_CREDENTIALS_HELPER_TEXT),
            onChange: (event)=>{
                handleCredentialChange("username", event.target.value);
            }
        })
    }, "username"));
    if ((0, $4ziqD.showCameraCredentialColumn)("password", cameraGeneralInfo, siteInfo)) cells.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
        align: "left",
        sx: (0, $7b37s.generalInfoTableCellSx),
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
            sx: (0, $7b37s.connectionFieldTextFieldSx),
            variant: "standard",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $fN7FV.default), {
                    inputProps: {
                        "aria-label": "Password"
                    },
                    type: showPassword ? "text" : "password",
                    defaultValue: cameraGeneralInfo.password ?? "",
                    onChange: (event)=>{
                        handleCredentialChange("password", event.target.value);
                    },
                    endAdornment: userPermissions.view_passwords ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $1SPe4.default), {
                        position: "end",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                            "aria-label": showPassword ? "hide the password" : "display the password",
                            onClick: onToggleShowPassword,
                            onMouseDown: onMouseDownPassword,
                            onMouseUp: onMouseUpPassword,
                            edge: "end",
                            children: showPassword ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $4m1S6.default), {}) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $2yNMw.default), {})
                        })
                    }) : null
                }),
                !cameraGeneralInfo.password && /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                    children: (0, $4ziqD.SITE_CREDENTIALS_HELPER_TEXT)
                })
            ]
        })
    }, "password"));
    if (cameraGeneralInfo.channel) cells.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
        align: "left",
        sx: (0, $7b37s.generalInfoTableCellSx),
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
            defaultValue: cameraGeneralInfo.channel,
            variant: "standard",
            sx: (0, $7b37s.connectionFieldTextFieldSx),
            type: "string",
            onChange: (event)=>{
                setCameraGeneralInfo((previousState)=>({
                        ...previousState,
                        channel: event.target.value
                    }));
                setPatchObject((previousState)=>({
                        ...previousState,
                        channel: event.target.value
                    }));
                setGeneralInfoChangesMade(true);
            }
        })
    }, "channel"));
    if ((0, $4ziqD.showStreamParametersColumn)(cameraGeneralInfo, siteInfo)) cells.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
        align: "left",
        sx: (0, $7b37s.generalInfoTableCellSx),
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
            inputProps: {
                "aria-label": "Stream Parameters"
            },
            defaultValue: cameraGeneralInfo.stream_parameters ?? "",
            placeholder: (0, $lT6uY.isGenetecSite)(siteInfo) ? (0, $lT6uY.GENETEC_DIRECT_PLACEHOLDERS).stream_parameters : "/Streaming/Channels/101",
            variant: "standard",
            sx: (0, $7b37s.connectionFieldTextFieldSx),
            type: "string",
            onChange: (event)=>{
                const nextValue = event.target.value;
                setCameraGeneralInfo((previousState)=>({
                        ...previousState,
                        stream_parameters: nextValue
                    }));
                setPatchObject((previousState)=>({
                        ...previousState,
                        stream_parameters: nextValue
                    }));
                setGeneralInfoChangesMade(true);
            }
        })
    }, "stream_parameters"));
    if (cameraGeneralInfo.slice) cells.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
        align: "left",
        sx: (0, $7b37s.generalInfoTableCellSx),
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
            defaultChecked: Boolean(cameraGeneralInfo.slice),
            color: "warning",
            disabled: false,
            onChange: (event)=>{
                setCameraGeneralInfo((previousState)=>({
                        ...previousState,
                        slice: event.target.checked
                    }));
                setPatchObject((previousState)=>({
                        ...previousState,
                        slice: event.target.checked
                    }));
                setGeneralInfoChangesMade(true);
            }
        })
    }, "slice"));
    if (cameraGeneralInfo.split) cells.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
        align: "left",
        sx: (0, $7b37s.generalInfoTableCellSx),
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
            defaultChecked: Boolean(cameraGeneralInfo.split),
            color: "warning",
            disabled: false,
            onChange: (event)=>{
                setCameraGeneralInfo((previousState)=>({
                        ...previousState,
                        split: event.target.checked
                    }));
                setPatchObject((previousState)=>({
                        ...previousState,
                        split: event.target.checked
                    }));
                setGeneralInfoChangesMade(true);
            }
        })
    }, "split"));
    if (cameraGeneralInfo.use_stream_quality) cells.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
        align: "left",
        sx: (0, $7b37s.generalInfoTableCellSx),
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
            defaultValue: cameraGeneralInfo.stream_quality,
            variant: "standard",
            sx: (0, $7b37s.connectionFieldTextFieldSx),
            type: "string",
            onChange: (event)=>{
                setCameraGeneralInfo((previousState)=>({
                        ...previousState,
                        stream_quality: event.target.value
                    }));
                setPatchObject((previousState)=>({
                        ...previousState,
                        stream_quality: event.target.value
                    }));
                setGeneralInfoChangesMade(true);
            }
        })
    }, "stream_quality"));
    if (cameraGeneralInfo.stream_source) {
        cells.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
            align: "left",
            sx: (0, $7b37s.generalInfoTableCellSx),
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                disablePortal: true,
                disableClearable: true,
                options: (0, $gAGBu.STREAM_SOURCE_OPTIONS).map((option)=>option.name),
                defaultValue: (0, $gAGBu.getStreamSourceName)(cameraGeneralInfo.stream_source),
                onChange: (event, value)=>{
                    const newStreamSource = (0, $gAGBu.STREAM_SOURCE_OPTIONS).find((option)=>option.name === value)?.value ?? "connector";
                    setCameraGeneralInfo((previousState)=>({
                            ...previousState,
                            stream_source: newStreamSource
                        }));
                    setPatchObject((previousState)=>{
                        if (newStreamSource !== "external_url") {
                            const { livestream_url: _omitted, ...rest } = previousState;
                            return {
                                ...rest,
                                stream_source: newStreamSource
                            };
                        }
                        return {
                            ...previousState,
                            stream_source: newStreamSource
                        };
                    });
                    if (newStreamSource !== "external_url") setLivestreamUrlError(false);
                    setGeneralInfoChangesMade(true);
                },
                sx: (0, $7b37s.connectionFieldTextFieldSx),
                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        ...params,
                        variant: "standard",
                        sx: {}
                    })
            })
        }, "stream_source"));
        cells.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
            align: "left",
            sx: (0, $7b37s.generalInfoTableCellSx),
            children: cameraGeneralInfo.stream_source === "external_url" ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                defaultValue: "",
                placeholder: cameraGeneralInfo.livestream_url ? (0, $gAGBu.maskLivestreamUrlPassword)(cameraGeneralInfo.livestream_url) : "rtsp://user:pass@host/stream",
                error: livestreamUrlError,
                helperText: livestreamUrlError ? (0, $gAGBu.LIVESTREAM_URL_ERROR_MESSAGE) : cameraGeneralInfo.livestream_url ? "Leave blank to keep the current URL." : "",
                variant: "standard",
                sx: (0, $7b37s.connectionFieldTextFieldSx),
                type: "string",
                onChange: (event)=>{
                    const newUrl = event.target.value;
                    setLivestreamUrlError(newUrl !== "" && !(0, $gAGBu.isValidLivestreamUrl)(newUrl));
                    setPatchObject((previousState)=>{
                        if (newUrl === "") {
                            const { livestream_url: _omitted, ...rest } = previousState;
                            return rest;
                        }
                        return {
                            ...previousState,
                            livestream_url: newUrl
                        };
                    });
                    setGeneralInfoChangesMade(true);
                }
            }) : "--"
        }, "livestream_url"));
    }
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
        children: (0, $7b37s.packIntoRows)(cells).map((cellRow, rowIndex)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                children: cellRow.map((cell, columnIndex)=>cell ?? /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                        align: "left",
                        sx: (0, $7b37s.generalInfoTableCellSx)
                    }, `connection-edit-pad-${rowIndex}-${columnIndex}`))
            }, `connection-edit-${rowIndex}`))
    });
};

});
parcelRegister("gAGBu", function(module, exports) {

$parcel$export(module.exports, "STREAM_SOURCE_OPTIONS", () => $5e5e8bdbd68fb1b3$export$864f2c31174dc7d);
$parcel$export(module.exports, "getStreamSourceName", () => $5e5e8bdbd68fb1b3$export$1cdd299de617cd95);
$parcel$export(module.exports, "LIVESTREAM_URL_ERROR_MESSAGE", () => $5e5e8bdbd68fb1b3$export$b5c973cb58e8da2f);
$parcel$export(module.exports, "isValidLivestreamUrl", () => $5e5e8bdbd68fb1b3$export$48e5313f3a5a5e4f);
$parcel$export(module.exports, "maskLivestreamUrlPassword", () => $5e5e8bdbd68fb1b3$export$ef24a119c83b270d);
// Helpers for the camera "Stream Source" / "Live Stream URL" fields
// (backend: Camera.stream_source + Camera.livestream_url, exposed via
// /camera/:id/general_info/). External URLs let sites whose integration
// can't natively stream (e.g. SMTP camera sites) provide a stream URL
// that the streaming stack pulls instead of the connector.
// Customer-facing labels: never say "connector" — customers don't know what
// that is. "Default" = video comes through the camera's normal integration.
const $5e5e8bdbd68fb1b3$export$864f2c31174dc7d = [
    {
        name: "Default",
        value: "connector"
    },
    {
        name: "External URL",
        value: "external_url"
    }
];
const $5e5e8bdbd68fb1b3$export$1cdd299de617cd95 = (value)=>{
    const option = $5e5e8bdbd68fb1b3$export$864f2c31174dc7d.find((object)=>object.value === value);
    return option ? option.name : value;
};
const $5e5e8bdbd68fb1b3$export$b5c973cb58e8da2f = "Live Stream URL must start with rtsp://, rtsps://, http://, or https://";
const $5e5e8bdbd68fb1b3$export$48e5313f3a5a5e4f = (url)=>{
    return /^(rtsps?|https?):\/\//i.test(url.trim());
};
const $5e5e8bdbd68fb1b3$export$ef24a119c83b270d = (url)=>{
    return url.replace(/^([a-z][a-z0-9+.-]*:\/\/[^:@/?#]+:)([^@/?#]+)(?=@)/i, "$1\u2022\u2022\u2022");
};

});

parcelRegister("4ziqD", function(module, exports) {

$parcel$export(module.exports, "showStreamParametersColumn", () => $c5f39a6c8646e0c0$export$2fe9f494f60d9756);
$parcel$export(module.exports, "showCameraCredentialColumn", () => $c5f39a6c8646e0c0$export$3a6436d384479d14);
$parcel$export(module.exports, "SITE_CREDENTIALS_HELPER_TEXT", () => $c5f39a6c8646e0c0$export$691ee894f2071870);

var $lT6uY = parcelRequire("lT6uY");
const $c5f39a6c8646e0c0$export$4a22f8cf234ca899 = [
    "rtsp",
    "hikvision",
    "lightapi",
    "alibi",
    "orchid",
    "milestone_rtsp",
    "wisenet",
    "onvif_wireguard"
];
const $c5f39a6c8646e0c0$export$190781d685d3e3c9 = (integrationTypeName)=>$c5f39a6c8646e0c0$export$4a22f8cf234ca899.includes(String(integrationTypeName ?? ""));
const $c5f39a6c8646e0c0$export$39b0e16933674e30 = (siteInfo)=>$c5f39a6c8646e0c0$export$190781d685d3e3c9(siteInfo?.integration_type_name) || (0, $lT6uY.isGenetecDirectSite)(siteInfo);
const $c5f39a6c8646e0c0$export$2fe9f494f60d9756 = (cameraObject, siteInfo)=>Boolean(cameraObject?.stream_parameters) || $c5f39a6c8646e0c0$export$39b0e16933674e30(siteInfo);
const $c5f39a6c8646e0c0$export$3a6436d384479d14 = (field, cameraObject, siteInfo)=>Boolean(cameraObject?.[field]) || $c5f39a6c8646e0c0$export$39b0e16933674e30(siteInfo);
const $c5f39a6c8646e0c0$export$691ee894f2071870 = "Leave blank to use the site's credentials.";

});

parcelRegister("6o91K", function(module, exports) {

$parcel$export(module.exports, "showVideoSourceColumn", () => $c6b7d45ddd00982a$export$7632c55a5ba06992);
$parcel$export(module.exports, "showHostColumn", () => $c6b7d45ddd00982a$export$9a0b2759a527d029);
$parcel$export(module.exports, "showRtspPortColumn", () => $c6b7d45ddd00982a$export$52362749c6a5b56a);
$parcel$export(module.exports, "buildConnectionsTitlesArray", () => $c6b7d45ddd00982a$export$240bc3aae17da364);

var $lT6uY = parcelRequire("lT6uY");

var $4ziqD = parcelRequire("4ziqD");
const $c6b7d45ddd00982a$export$79942614bc8d1146 = {
    video_source: (0, $lT6uY.VIDEO_SOURCE_COLUMN_TITLE),
    host: "Host",
    rtsp: "RTSP",
    http: "HTTP Port",
    server_port: "Server Port",
    username: "Username",
    password: "Password",
    channel: "Channel",
    stream_parameters: "Stream Parameters",
    slice: "Slice",
    split: "Split",
    stream_quality: "Stream Quality",
    stream_source: "Stream Source",
    livestream_url: "Live Stream URL"
};
const $c6b7d45ddd00982a$export$7632c55a5ba06992 = (siteInfo)=>(0, $lT6uY.isGenetecSite)(siteInfo);
const $c6b7d45ddd00982a$export$9a0b2759a527d029 = (cameraObject, siteInfo)=>Boolean(cameraObject?.ip) || (0, $lT6uY.isGenetecDirectSite)(siteInfo);
const $c6b7d45ddd00982a$export$52362749c6a5b56a = (siteInfo)=>siteInfo?.integration_type_name === "rtsp" || (0, $lT6uY.isGenetecDirectSite)(siteInfo);
const $c6b7d45ddd00982a$export$a9e63fbf6e2c2d62 = (cameraObject, siteInfo)=>{
    const keys = [];
    if ($c6b7d45ddd00982a$export$7632c55a5ba06992(siteInfo)) keys.push("video_source");
    if ($c6b7d45ddd00982a$export$9a0b2759a527d029(cameraObject, siteInfo)) keys.push("host");
    if ($c6b7d45ddd00982a$export$52362749c6a5b56a(siteInfo)) keys.push("rtsp");
    if (cameraObject?.http) keys.push("http");
    if (cameraObject?.server_port) keys.push("server_port");
    if ((0, $4ziqD.showCameraCredentialColumn)("username", cameraObject, siteInfo)) keys.push("username");
    if ((0, $4ziqD.showCameraCredentialColumn)("password", cameraObject, siteInfo)) keys.push("password");
    if (cameraObject?.channel) keys.push("channel");
    if ((0, $4ziqD.showStreamParametersColumn)(cameraObject, siteInfo)) keys.push("stream_parameters");
    if (cameraObject?.slice) keys.push("slice");
    if (cameraObject?.split) keys.push("split");
    if (cameraObject?.use_stream_quality) keys.push("stream_quality");
    if (cameraObject?.stream_source) {
        keys.push("stream_source");
        keys.push("livestream_url");
    }
    return keys;
};
const $c6b7d45ddd00982a$export$240bc3aae17da364 = (cameraObject, siteInfo)=>$c6b7d45ddd00982a$export$a9e63fbf6e2c2d62(cameraObject, siteInfo).map((key)=>$c6b7d45ddd00982a$export$79942614bc8d1146[key]);

});



parcelRegister("dGpG4", function(module, exports) {

$parcel$export(module.exports, "GeneralInfoEditCameraTabEditMode", () => $e641fbc220ca3e21$export$daf23d12df93ed2a);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $ddLR4 = parcelRequire("ddLR4");

var $gfzcx = parcelRequire("gfzcx");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");

var $3r5gr = parcelRequire("3r5gr");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");

var $aZxZ3 = parcelRequire("aZxZ3");

var $cs9mF = parcelRequire("cs9mF");

var $lWchQ = parcelRequire("lWchQ");

var $2aMB5 = parcelRequire("2aMB5");

var $aYdit = parcelRequire("aYdit");

var $7b37s = parcelRequire("7b37s");

var $k7hHD = parcelRequire("k7hHD");
const $e641fbc220ca3e21$export$daf23d12df93ed2a = ({ siteInfo: siteInfo, cameraGeneralInfo: cameraGeneralInfo, setCameraGeneralInfo: setCameraGeneralInfo, setPatchObject: setPatchObject, setGeneralInfoChangesMade: setGeneralInfoChangesMade, setActiveChangeMade: setActiveChangeMade })=>{
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    const cameraViewOptions = JSON.parse(localStorage.cameraViewOptions);
    const cameraViewOptionIds = new Map();
    const cameraViewOptionNames = new Map();
    cameraViewOptions.forEach((option)=>{
        cameraViewOptionIds.set(option.name, option.value);
    });
    cameraViewOptions.forEach((option)=>{
        cameraViewOptionNames.set(option.value, option.name);
    });
    const connectionsTitlesArray = JSON.parse(localStorage.connectionsTitlesArray);
    const [showPassword, setShowPassword] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    // The camera's own login as loaded, before any typing (ENG-2144). A blank
    // value means the camera uses the site's credentials.
    const initialCredentials = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef({
        username: cameraGeneralInfo.username ?? "",
        password: cameraGeneralInfo.password ?? ""
    });
    /**
   * Record a username/password edit. When the camera had no login of its own
   * and the field is blank again, drop the key from the PATCH instead of
   * sending "" over the site-inherited credential. A camera that had its own
   * value keeps today's behaviour: clearing it sends "".
   */ const handleCredentialChange = (field, nextValue)=>{
        setCameraGeneralInfo((previousState)=>({
                ...previousState,
                [field]: nextValue
            }));
        setPatchObject((previousState)=>{
            if (!nextValue && !initialCredentials.current[field]) {
                const rest = {
                    ...previousState
                };
                delete rest[field];
                return rest;
            }
            return {
                ...previousState,
                [field]: nextValue
            };
        });
        setGeneralInfoChangesMade(true);
    };
    const [livestreamUrlError, setLivestreamUrlError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const { chmActive: chmActive, notesText: notesText } = (0, $aZxZ3.useEditCameraStore)();
    const handleClickShowPassword = ()=>setShowPassword((show)=>!show);
    const handleMouseDownPassword = (event)=>{
        event.preventDefault();
    };
    const handleMouseUpPassword = (event)=>{
        event.preventDefault();
    };
    const [titlesArray, setTitlesArray] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([
        "",
        ""
    ]);
    const autopatrolSite = siteInfo.integration_type_name === "autopatrol";
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (cameraGeneralInfo.streams[0].show_nvr_alarm) setTitlesArray([
            "SES recipients",
            "NVR Alarm"
        ]);
        else setTitlesArray([
            "SES recipients",
            ""
        ]);
    }, []);
    const generalInfoHeaders = autopatrolSite ? [
        "Customer",
        "Camera Name",
        "Active",
        "Notes"
    ] : [
        "Customer",
        "Camera Name",
        "Camera View",
        "Alarm Type",
        "Active",
        "Camera Health Monitoring",
        "Notes"
    ];
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                sx: {
                    minWidth: 1000,
                    fontFamily: "Mulish",
                    tableLayout: "fixed"
                },
                "aria-label": "simple table",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("colgroup", {
                        children: Array.from({
                            length: (0, $7b37s.GENERAL_INFO_COLUMN_COUNT)
                        }).map((_, index)=>/*#__PURE__*/ (0, $k4ank.jsx)("col", {
                                style: {
                                    width: `${100 / (0, $7b37s.GENERAL_INFO_COLUMN_COUNT)}%`
                                }
                            }, `general-info-col-${index}`))
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                        titlesArray: generalInfoHeaders
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $gXvgZ.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: (0, $7b37s.generalInfoTableCellSx),
                                        children: siteInfo.parent_group.name
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: (0, $7b37s.generalInfoTableCellSx),
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                defaultValue: cameraGeneralInfo.camera_name,
                                                variant: "standard",
                                                sx: (0, $7b37s.connectionFieldTextFieldSx),
                                                type: "string",
                                                onChange: (event)=>{
                                                    setCameraGeneralInfo((previousState)=>{
                                                        return {
                                                            ...previousState,
                                                            camera_name: event.target.value
                                                        };
                                                    });
                                                    setPatchObject((previousState)=>{
                                                        return {
                                                            ...previousState,
                                                            camera_name: event.target.value
                                                        };
                                                    });
                                                    setGeneralInfoChangesMade(true);
                                                }
                                            })
                                        }, siteInfo.name)
                                    }),
                                    !autopatrolSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: (0, $7b37s.generalInfoTableCellSx),
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                            disablePortal: true,
                                            options: cameraViewOptions.map((option)=>{
                                                return option.name;
                                            }),
                                            defaultValue: cameraViewOptionNames.get(cameraGeneralInfo.camera_view),
                                            onChange: (event, value)=>{
                                                setCameraGeneralInfo((previousState)=>{
                                                    return {
                                                        ...previousState,
                                                        camera_view: cameraViewOptionIds.get(value)
                                                    };
                                                });
                                                setPatchObject((previousState)=>{
                                                    return {
                                                        ...previousState,
                                                        camera_view: cameraViewOptionIds.get(value)
                                                    };
                                                });
                                                setGeneralInfoChangesMade(true);
                                            },
                                            sx: (0, $7b37s.connectionFieldTextFieldSx),
                                            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                    ...params,
                                                    variant: "standard",
                                                    sx: {}
                                                })
                                        })
                                    }),
                                    !autopatrolSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: (0, $7b37s.generalInfoTableCellSx),
                                        children: (0, $3r5gr.createCameraAlarmType)(cameraGeneralInfo.default_alarm)
                                    }),
                                    !autopatrolSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: (0, $7b37s.generalInfoTableCellSx),
                                        children: cameraGeneralInfo.active ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                            defaultChecked: true,
                                            color: "warning",
                                            disabled: false,
                                            onChange: (event)=>{
                                                setCameraGeneralInfo((previousState)=>{
                                                    return {
                                                        ...previousState,
                                                        active: event.target.checked
                                                    };
                                                });
                                                setActiveChangeMade(true);
                                            }
                                        }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                            color: "warning",
                                            disabled: false,
                                            onChange: (event)=>{
                                                setCameraGeneralInfo((previousState)=>{
                                                    return {
                                                        ...previousState,
                                                        active: event.target.checked
                                                    };
                                                });
                                                setActiveChangeMade(true);
                                            }
                                        })
                                    }),
                                    siteInfo.integration_type_name === "autopatrol" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: (0, $7b37s.generalInfoTableCellSx),
                                        children: chmActive ? (0, $lWchQ.checkedCircleIcon) : (0, $2aMB5.cancelIconRed)
                                    }),
                                    !autopatrolSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: (0, $7b37s.generalInfoTableCellSx),
                                        children: chmActive ? (0, $lWchQ.checkedCircleIcon) : (0, $2aMB5.cancelIconRed)
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: (0, $7b37s.generalInfoTableCellSx),
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                            defaultValue: notesText,
                                            variant: "outlined",
                                            multiline: true,
                                            rows: 4,
                                            sx: {
                                                width: 225
                                            },
                                            type: "string",
                                            onChange: (event)=>{
                                                setPatchObject((previousState)=>{
                                                    return {
                                                        ...previousState,
                                                        notes: event.target.value
                                                    };
                                                });
                                                setGeneralInfoChangesMade(true);
                                            }
                                        })
                                    })
                                ]
                            }, (0, $a8BPe.getNumbersAfterEditCamera)(location.href)),
                            !autopatrolSite && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $k7hHD.GeneralInfoConnectionHeaderRows), {
                                        connectionTitles: connectionsTitlesArray
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $k7hHD.GeneralInfoConnectionEditRows), {
                                        siteInfo: siteInfo,
                                        cameraGeneralInfo: cameraGeneralInfo,
                                        setCameraGeneralInfo: setCameraGeneralInfo,
                                        setPatchObject: setPatchObject,
                                        setGeneralInfoChangesMade: setGeneralInfoChangesMade,
                                        userPermissions: userPermissions,
                                        showPassword: showPassword,
                                        onToggleShowPassword: handleClickShowPassword,
                                        onMouseDownPassword: handleMouseDownPassword,
                                        onMouseUpPassword: handleMouseUpPassword,
                                        handleCredentialChange: handleCredentialChange,
                                        livestreamUrlError: livestreamUrlError,
                                        setLivestreamUrlError: setLivestreamUrlError
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !autopatrolSite && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                sx: {
                    minWidth: 1000,
                    fontFamily: "Mulish"
                },
                "aria-label": "simple table",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                        titlesArray: titlesArray
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        width: 600
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                            multiline: true,
                                            id: "ses_recipients",
                                            label: "Recipient emails",
                                            name: "ses_recipients",
                                            defaultValue: cameraGeneralInfo.streams[0].ses_recipients,
                                            sx: {
                                                fontFamily: "Mulish",
                                                width: 600
                                            },
                                            helperText: "E-mails to receive notifications with images attached. You can specify more than one separated by comma.",
                                            rows: 2,
                                            onChange: (event)=>{
                                                const newStreams = cameraGeneralInfo.streams;
                                                newStreams.forEach((object)=>{
                                                    object.ses_recipients = event.target.value;
                                                });
                                                setPatchObject((previousState)=>{
                                                    return {
                                                        ...previousState,
                                                        streams: newStreams
                                                    };
                                                });
                                                setCameraGeneralInfo((previousState)=>{
                                                    return {
                                                        ...previousState,
                                                        streams: newStreams
                                                    };
                                                });
                                                setGeneralInfoChangesMade(true);
                                            }
                                        })
                                    }, "ses_recipients")
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        zIndex: "modal"
                                    },
                                    children: cameraGeneralInfo.streams[0].show_nvr_alarm && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        children: cameraGeneralInfo.streams[0].nvr_alarm ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                            sx: {
                                                top: -40
                                            },
                                            defaultChecked: true,
                                            color: "warning",
                                            disabled: false,
                                            onChange: (event)=>{
                                                const newStreams = cameraGeneralInfo.streams;
                                                newStreams.forEach((object)=>{
                                                    object.nvr_alarm = event.target.checked;
                                                });
                                                setCameraGeneralInfo((previousState)=>{
                                                    return {
                                                        ...previousState,
                                                        streams: newStreams
                                                    };
                                                });
                                                setPatchObject((previousState)=>{
                                                    return {
                                                        ...previousState,
                                                        streams: newStreams
                                                    };
                                                });
                                                setGeneralInfoChangesMade(true);
                                            }
                                        }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                            sx: {
                                                top: -40
                                            },
                                            color: "warning",
                                            disabled: false,
                                            onChange: (event)=>{
                                                const newStreams = cameraGeneralInfo.streams;
                                                newStreams.forEach((object)=>{
                                                    object.nvr_alarm = event.target.checked;
                                                });
                                                setCameraGeneralInfo((previousState)=>{
                                                    return {
                                                        ...previousState,
                                                        streams: newStreams
                                                    };
                                                });
                                                setPatchObject((previousState)=>{
                                                    return {
                                                        ...previousState,
                                                        streams: newStreams
                                                    };
                                                });
                                                setGeneralInfoChangesMade(true);
                                            }
                                        })
                                    })
                                })
                            ]
                        }, (0, $a8BPe.getNumbersAfterEditCamera)(location.href))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cs9mF.CameraMotionSetting), {
                cameraGeneralInfo: cameraGeneralInfo,
                siteInfo: siteInfo
            })
        ]
    });
};

});

parcelRegister("jdgli", function(module, exports) {

$parcel$export(module.exports, "ConnectionsTab", () => $fc8759d99304c997$export$c57ca7fbcbe1759e);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $iKAtE = parcelRequire("iKAtE");
var $1SPe4 = parcelRequire("1SPe4");
var $ddLR4 = parcelRequire("ddLR4");

var $2yNMw = parcelRequire("2yNMw");
var $4m1S6 = parcelRequire("4m1S6");

var $7t6MD = parcelRequire("7t6MD");

var $aYdit = parcelRequire("aYdit");

var $gAGBu = parcelRequire("gAGBu");
const $fc8759d99304c997$export$c57ca7fbcbe1759e = ({ cameraGeneralInfo: cameraGeneralInfo })=>{
    const connectionsTitlesArray = JSON.parse(localStorage.connectionsTitlesArray);
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    const [showPassword, setShowPassword] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const handleClickShowPassword = ()=>setShowPassword((show)=>!show);
    const handleMouseDownPassword = (event)=>{
        event.preventDefault();
    };
    const handleMouseUpPassword = (event)=>{
        event.preventDefault();
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
            sx: {
                minWidth: 1000,
                fontFamily: "Mulish"
            },
            "aria-label": "simple table",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                    titlesArray: connectionsTitlesArray
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                        children: [
                            cameraGeneralInfo.ip && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: cameraGeneralInfo.ip
                            }),
                            cameraGeneralInfo.rtsp && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: cameraGeneralInfo.rtsp
                            }),
                            cameraGeneralInfo.http && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: cameraGeneralInfo.http
                            }),
                            cameraGeneralInfo.server_port && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: cameraGeneralInfo.server_port
                            }),
                            cameraGeneralInfo.username && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: cameraGeneralInfo.username
                            }),
                            cameraGeneralInfo.password && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: [
                                    userPermissions.view_passwords && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            showPassword ? cameraGeneralInfo.password : (0, $7t6MD.createDots)(cameraGeneralInfo.password),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1SPe4.default), {
                                                    position: "end",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                                        "aria-label": showPassword ? "hide the password" : "display the password",
                                                        onClick: handleClickShowPassword,
                                                        onMouseDown: handleMouseDownPassword,
                                                        onMouseUp: handleMouseUpPassword,
                                                        edge: "end",
                                                        children: showPassword ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $4m1S6.default), {}) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $2yNMw.default), {})
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    !userPermissions.view_passwords && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "flex items-center",
                                        children: (0, $7t6MD.createDots)(cameraGeneralInfo.password)
                                    })
                                ]
                            }),
                            cameraGeneralInfo.channel && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: cameraGeneralInfo.channel
                            }),
                            cameraGeneralInfo.stream_parameters && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: cameraGeneralInfo.stream_parameters
                            }),
                            cameraGeneralInfo.slice && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                    checked: cameraGeneralInfo.slice,
                                    color: "warning",
                                    disabled: true
                                })
                            }),
                            cameraGeneralInfo.split && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                    checked: cameraGeneralInfo.split,
                                    color: "warning",
                                    disabled: true
                                })
                            }),
                            cameraGeneralInfo.use_stream_quality && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: cameraGeneralInfo.stream_quality ? cameraGeneralInfo.stream_quality : 1
                            }),
                            cameraGeneralInfo.stream_source && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: (0, $gAGBu.getStreamSourceName)(cameraGeneralInfo.stream_source)
                            }),
                            cameraGeneralInfo.stream_source && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: cameraGeneralInfo.livestream_url ? (0, $gAGBu.maskLivestreamUrlPassword)(cameraGeneralInfo.livestream_url) : "--"
                            })
                        ]
                    }, `connections_table_row_1`)
                })
            ]
        })
    });
};

});

parcelRegister("eWsxc", function(module, exports) {

$parcel$export(module.exports, "ConnectionsTabEditMode", () => $353e5d3ec8404061$export$3c0b572492c6991f);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $8B8vg = parcelRequire("8B8vg");
var $7UDCh = parcelRequire("7UDCh");
var $iKAtE = parcelRequire("iKAtE");
var $1SPe4 = parcelRequire("1SPe4");
var $ddLR4 = parcelRequire("ddLR4");
var $eejVe = parcelRequire("eejVe");

var $fN7FV = parcelRequire("fN7FV");

var $2yNMw = parcelRequire("2yNMw");
var $4m1S6 = parcelRequire("4m1S6");

var $gAGBu = parcelRequire("gAGBu");
const $353e5d3ec8404061$export$3c0b572492c6991f = ({ cameraGeneralInfo: cameraGeneralInfo, setCameraGeneralInfo: setCameraGeneralInfo, setPatchObject: setPatchObject, setGeneralInfoChangesMade: setGeneralInfoChangesMade })=>{
    const connectionsTitlesArray = JSON.parse(localStorage.connectionsTitlesArray);
    const [showPassword, setShowPassword] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [livestreamUrlError, setLivestreamUrlError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const handleClickShowPassword = ()=>setShowPassword((show)=>!show);
    const handleMouseDownPassword = (event)=>{
        event.preventDefault();
    };
    const handleMouseUpPassword = (event)=>{
        event.preventDefault();
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
            sx: {
                minWidth: 1000,
                fontFamily: "Mulish"
            },
            "aria-label": "simple table",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                    titlesArray: connectionsTitlesArray
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                        children: [
                            cameraGeneralInfo.ip && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        id: cameraGeneralInfo.ip,
                                        defaultValue: cameraGeneralInfo.ip,
                                        variant: "standard",
                                        sx: {
                                            width: 150
                                        },
                                        type: "string",
                                        onChange: (event)=>{
                                            setCameraGeneralInfo((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    ip: event.target.value
                                                };
                                            });
                                            setPatchObject((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    ip: event.target.value
                                                };
                                            });
                                            setGeneralInfoChangesMade(true);
                                        }
                                    })
                                }, cameraGeneralInfo.ip)
                            }),
                            cameraGeneralInfo.rtsp && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        id: cameraGeneralInfo.rtsp,
                                        defaultValue: cameraGeneralInfo.rtsp,
                                        variant: "standard",
                                        sx: {
                                            width: 150
                                        },
                                        type: "string",
                                        onChange: (event)=>{
                                            setCameraGeneralInfo((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    rtsp: event.target.value
                                                };
                                            });
                                            setPatchObject((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    rtsp: event.target.value
                                                };
                                            });
                                            setGeneralInfoChangesMade(true);
                                        }
                                    })
                                }, cameraGeneralInfo.rtsp)
                            }),
                            cameraGeneralInfo.http && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        id: cameraGeneralInfo.http,
                                        defaultValue: cameraGeneralInfo.http,
                                        variant: "standard",
                                        sx: {
                                            width: 150
                                        },
                                        type: "string",
                                        onChange: (event)=>{
                                            setCameraGeneralInfo((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    http: event.target.value
                                                };
                                            });
                                            setPatchObject((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    http: event.target.value
                                                };
                                            });
                                            setGeneralInfoChangesMade(true);
                                        }
                                    })
                                }, cameraGeneralInfo.http)
                            }),
                            cameraGeneralInfo.server_port && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        id: cameraGeneralInfo.server_port,
                                        defaultValue: cameraGeneralInfo.server_port,
                                        variant: "standard",
                                        sx: {
                                            width: 150
                                        },
                                        type: "string",
                                        onChange: (event)=>{
                                            setCameraGeneralInfo((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    server_port: event.target.value
                                                };
                                            });
                                            setPatchObject((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    server_port: event.target.value
                                                };
                                            });
                                            setGeneralInfoChangesMade(true);
                                        }
                                    })
                                }, cameraGeneralInfo.server_port)
                            }),
                            cameraGeneralInfo.username && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        id: cameraGeneralInfo.username,
                                        defaultValue: cameraGeneralInfo.username,
                                        variant: "standard",
                                        sx: {
                                            width: 150
                                        },
                                        type: "string",
                                        onChange: (event)=>{
                                            setCameraGeneralInfo((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    username: event.target.value
                                                };
                                            });
                                            setPatchObject((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    username: event.target.value
                                                };
                                            });
                                            setGeneralInfoChangesMade(true);
                                        }
                                    })
                                }, cameraGeneralInfo.username)
                            }),
                            cameraGeneralInfo.password && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $7UDCh.default), {
                                    sx: {
                                        width: 150
                                    },
                                    variant: "standard",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fN7FV.default), {
                                        id: "standard-adornment-password",
                                        type: showPassword ? "text" : "password",
                                        defaultValue: cameraGeneralInfo.password,
                                        onChange: (event)=>{
                                            setCameraGeneralInfo((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    password: event.target.value
                                                };
                                            });
                                            setPatchObject((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    password: event.target.value
                                                };
                                            });
                                            setGeneralInfoChangesMade(true);
                                        },
                                        endAdornment: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1SPe4.default), {
                                            position: "end",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                                "aria-label": showPassword ? "hide the password" : "display the password",
                                                onClick: handleClickShowPassword,
                                                onMouseDown: handleMouseDownPassword,
                                                onMouseUp: handleMouseUpPassword,
                                                edge: "end",
                                                children: showPassword ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $4m1S6.default), {}) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $2yNMw.default), {})
                                            })
                                        })
                                    })
                                })
                            }),
                            cameraGeneralInfo.channel && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        id: cameraGeneralInfo.channel,
                                        defaultValue: cameraGeneralInfo.channel,
                                        variant: "standard",
                                        sx: {
                                            width: 150
                                        },
                                        type: "string",
                                        onChange: (event)=>{
                                            setCameraGeneralInfo((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    channel: event.target.value
                                                };
                                            });
                                            setPatchObject((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    channel: event.target.value
                                                };
                                            });
                                            setGeneralInfoChangesMade(true);
                                        }
                                    })
                                }, cameraGeneralInfo.channel)
                            }),
                            cameraGeneralInfo.stream_parameters && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        id: cameraGeneralInfo.stream_parameters,
                                        defaultValue: cameraGeneralInfo.stream_parameters,
                                        variant: "outlined",
                                        multiline: true,
                                        rows: 4,
                                        sx: {
                                            width: 225
                                        },
                                        type: "string",
                                        onChange: (event)=>{
                                            setCameraGeneralInfo((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    stream_parameters: event.target.value
                                                };
                                            });
                                            setPatchObject((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    stream_parameters: event.target.value
                                                };
                                            });
                                            setGeneralInfoChangesMade(true);
                                        }
                                    })
                                }, cameraGeneralInfo.stream_parameters)
                            }),
                            cameraGeneralInfo.slice && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: cameraGeneralInfo.slice ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                    defaultChecked: true,
                                    color: "warning",
                                    disabled: false,
                                    onChange: (event)=>{
                                        setCameraGeneralInfo((previousState)=>{
                                            return {
                                                ...previousState,
                                                slice: event.target.checked
                                            };
                                        });
                                        setPatchObject((previousState)=>{
                                            return {
                                                ...previousState,
                                                slice: event.target.value
                                            };
                                        });
                                        setGeneralInfoChangesMade(true);
                                    }
                                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                    color: "warning",
                                    disabled: false,
                                    onChange: (event)=>{
                                        setCameraGeneralInfo((previousState)=>{
                                            return {
                                                ...previousState,
                                                slice: event.target.checked
                                            };
                                        });
                                        setPatchObject((previousState)=>{
                                            return {
                                                ...previousState,
                                                slice: event.target.value
                                            };
                                        });
                                        setGeneralInfoChangesMade(true);
                                    }
                                })
                            }),
                            cameraGeneralInfo.split && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: cameraGeneralInfo.split ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                    defaultChecked: true,
                                    color: "warning",
                                    disabled: false,
                                    onChange: (event)=>{
                                        setCameraGeneralInfo((previousState)=>{
                                            return {
                                                ...previousState,
                                                split: event.target.checked
                                            };
                                        });
                                        setPatchObject((previousState)=>{
                                            return {
                                                ...previousState,
                                                split: event.target.value
                                            };
                                        });
                                        setGeneralInfoChangesMade(true);
                                    }
                                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                    color: "warning",
                                    disabled: false,
                                    onChange: (event)=>{
                                        setCameraGeneralInfo((previousState)=>{
                                            return {
                                                ...previousState,
                                                split: event.target.checked
                                            };
                                        });
                                        setPatchObject((previousState)=>{
                                            return {
                                                ...previousState,
                                                split: event.target.value
                                            };
                                        });
                                        setGeneralInfoChangesMade(true);
                                    }
                                })
                            }),
                            cameraGeneralInfo.use_stream_quality && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        id: cameraGeneralInfo.stream_quality,
                                        defaultValue: cameraGeneralInfo.stream_quality,
                                        variant: "standard",
                                        sx: {
                                            width: 150
                                        },
                                        type: "string",
                                        onChange: (event)=>{
                                            setCameraGeneralInfo((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    stream_quality: event.target.value
                                                };
                                            });
                                            setPatchObject((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    stream_quality: event.target.value
                                                };
                                            });
                                            setGeneralInfoChangesMade(true);
                                        }
                                    })
                                }, cameraGeneralInfo.stream_quality)
                            }),
                            cameraGeneralInfo.stream_source && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                    disablePortal: true,
                                    disableClearable: true,
                                    options: (0, $gAGBu.STREAM_SOURCE_OPTIONS).map((option)=>{
                                        return option.name;
                                    }),
                                    defaultValue: (0, $gAGBu.getStreamSourceName)(cameraGeneralInfo.stream_source),
                                    onChange: (event, value)=>{
                                        const newStreamSource = (0, $gAGBu.STREAM_SOURCE_OPTIONS).find((option)=>option.name === value)?.value ?? "connector";
                                        setCameraGeneralInfo((previousState)=>{
                                            return {
                                                ...previousState,
                                                stream_source: newStreamSource
                                            };
                                        });
                                        setPatchObject((previousState)=>{
                                            if (newStreamSource !== "external_url") {
                                                // Drop any pending URL edit so a masked or invalid
                                                // value is never sent alongside the connector source
                                                const { livestream_url: _omitted, ...rest } = previousState;
                                                return {
                                                    ...rest,
                                                    stream_source: newStreamSource
                                                };
                                            }
                                            return {
                                                ...previousState,
                                                stream_source: newStreamSource
                                            };
                                        });
                                        if (newStreamSource !== "external_url") setLivestreamUrlError(false);
                                        setGeneralInfoChangesMade(true);
                                    },
                                    sx: {
                                        width: 200
                                    },
                                    renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                            ...params,
                                            variant: "standard",
                                            sx: {}
                                        })
                                })
                            }),
                            cameraGeneralInfo.stream_source && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: cameraGeneralInfo.stream_source === "external_url" ? /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        id: "livestream_url",
                                        defaultValue: "",
                                        placeholder: cameraGeneralInfo.livestream_url ? (0, $gAGBu.maskLivestreamUrlPassword)(cameraGeneralInfo.livestream_url) : "rtsp://user:pass@host/stream",
                                        error: livestreamUrlError,
                                        helperText: livestreamUrlError ? (0, $gAGBu.LIVESTREAM_URL_ERROR_MESSAGE) : cameraGeneralInfo.livestream_url ? "Leave blank to keep the current URL." : "",
                                        variant: "standard",
                                        sx: {
                                            width: 225
                                        },
                                        type: "string",
                                        onChange: (event)=>{
                                            const newUrl = event.target.value;
                                            setLivestreamUrlError(newUrl !== "" && !(0, $gAGBu.isValidLivestreamUrl)(newUrl));
                                            setPatchObject((previousState)=>{
                                                if (newUrl === "") {
                                                    // Blank means "keep the current URL" — the masked
                                                    // display value must never be sent back to the API
                                                    const { livestream_url: _omitted, ...rest } = previousState;
                                                    return rest;
                                                }
                                                return {
                                                    ...previousState,
                                                    livestream_url: newUrl
                                                };
                                            });
                                            setGeneralInfoChangesMade(true);
                                        }
                                    })
                                }, "livestream_url") : "--"
                            })
                        ]
                    }, `connections_table_row_1`)
                })
            ]
        })
    });
};

});

parcelRegister("fNPIE", function(module, exports) {

$parcel$export(module.exports, "NotificationsTab", () => $e0d908dabbdad96a$export$4add2c2cd93978d1);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $ddLR4 = parcelRequire("ddLR4");

var $gfzcx = parcelRequire("gfzcx");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");
const $e0d908dabbdad96a$export$4add2c2cd93978d1 = ({ cameraGeneralInfo: cameraGeneralInfo })=>{
    const [titlesArray, setTitlesArray] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([
        "",
        ""
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (cameraGeneralInfo.streams[0].show_nvr_alarm) setTitlesArray([
            "SES recipients",
            "NVR Alarm"
        ]);
        else setTitlesArray([
            "SES recipients",
            ""
        ]);
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
            sx: {
                minWidth: 1000,
                fontFamily: "Mulish"
            },
            "aria-label": "simple table",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                    titlesArray: titlesArray
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish",
                                    width: 600
                                },
                                children: cameraGeneralInfo.streams[0].ses_recipients ? cameraGeneralInfo.streams[0].ses_recipients : "--"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: cameraGeneralInfo.streams[0].show_nvr_alarm && /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                    checked: cameraGeneralInfo.streams[0].nvr_alarm,
                                    color: "warning",
                                    disabled: true
                                })
                            })
                        ]
                    }, (0, $a8BPe.getNumbersAfterEditCamera)(location.href))
                })
            ]
        })
    });
};

});

parcelRegister("kR2pu", function(module, exports) {

$parcel$export(module.exports, "NotificationsTabEditMode", () => $420ccd9da264e13f$export$fe037a89c1901e9d);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $ddLR4 = parcelRequire("ddLR4");

var $gfzcx = parcelRequire("gfzcx");

var $eejVe = parcelRequire("eejVe");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");
const $420ccd9da264e13f$export$fe037a89c1901e9d = ({ cameraGeneralInfo: cameraGeneralInfo, setCameraGeneralInfo: setCameraGeneralInfo, setPatchObject: setPatchObject, setGeneralInfoChangesMade: setGeneralInfoChangesMade })=>{
    const [titlesArray, setTitlesArray] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([
        "",
        ""
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (cameraGeneralInfo.streams[0].show_nvr_alarm) setTitlesArray([
            "SES recipients",
            "NVR Alarm"
        ]);
        else setTitlesArray([
            "SES recipients",
            ""
        ]);
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
            sx: {
                minWidth: 1000,
                fontFamily: "Mulish"
            },
            "aria-label": "simple table",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                    titlesArray: titlesArray
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish",
                                    width: 600
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        multiline: true,
                                        id: "ses_recipients",
                                        label: "Recipient emails",
                                        name: "ses_recipients",
                                        defaultValue: cameraGeneralInfo.streams[0].ses_recipients,
                                        sx: {
                                            fontFamily: "Mulish",
                                            width: 600
                                        },
                                        helperText: "E-mails to receive notifications with images attached. You can specify more than one separated by comma.",
                                        rows: 2,
                                        onChange: (event)=>{
                                            const newStreams = cameraGeneralInfo.streams;
                                            newStreams.forEach((object)=>{
                                                object.ses_recipients = event.target.value;
                                            });
                                            setPatchObject((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    streams: newStreams
                                                };
                                            });
                                            setCameraGeneralInfo((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    streams: newStreams
                                                };
                                            });
                                            setGeneralInfoChangesMade(true);
                                        }
                                    })
                                }, "ses_recipients")
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish",
                                    zIndex: "modal"
                                },
                                children: cameraGeneralInfo.streams[0].show_nvr_alarm && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: cameraGeneralInfo.streams[0].nvr_alarm ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                        sx: {
                                            top: -40
                                        },
                                        defaultChecked: true,
                                        color: "warning",
                                        disabled: false,
                                        onChange: (event)=>{
                                            const newStreams = cameraGeneralInfo.streams;
                                            newStreams.forEach((object)=>{
                                                object.nvr_alarm = event.target.checked;
                                            });
                                            setCameraGeneralInfo((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    streams: newStreams
                                                };
                                            });
                                            setPatchObject((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    streams: newStreams
                                                };
                                            });
                                            setGeneralInfoChangesMade(true);
                                        }
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                        sx: {
                                            top: -40
                                        },
                                        color: "warning",
                                        disabled: false,
                                        onChange: (event)=>{
                                            const newStreams = cameraGeneralInfo.streams;
                                            newStreams.forEach((object)=>{
                                                object.nvr_alarm = event.target.checked;
                                            });
                                            setCameraGeneralInfo((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    streams: newStreams
                                                };
                                            });
                                            setPatchObject((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    streams: newStreams
                                                };
                                            });
                                            setGeneralInfoChangesMade(true);
                                        }
                                    })
                                })
                            })
                        ]
                    }, (0, $a8BPe.getNumbersAfterEditCamera)(location.href))
                })
            ]
        })
    });
};

});

parcelRegister("8xHBc", function(module, exports) {

$parcel$export(module.exports, "ProductsTab", () => $8dbcc54ee5aad699$export$b6b174168c9be784);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $f3puC = parcelRequire("f3puC");

var $ddLR4 = parcelRequire("ddLR4");

var $cVCJe = parcelRequire("cVCJe");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $8jTCz = parcelRequire("8jTCz");

var $g0plP = parcelRequire("g0plP");

var $e9rQm = parcelRequire("e9rQm");

var $gr09N = parcelRequire("gr09N");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");

var $aZxZ3 = parcelRequire("aZxZ3");

var $4PFLW = parcelRequire("4PFLW");

var $abZpG = parcelRequire("abZpG");
const $8dbcc54ee5aad699$export$b6b174168c9be784 = ({ productsData: productsData, setProductsData: setProductsData, allTabsOpen: allTabsOpen, setAllTabsOpen: setAllTabsOpen, setBackupProductsData: setBackupProductsData })=>{
    const handleOpenNewTab = ()=>{
        // Use window.open to open a new tab
        window.open("/productrequirements", "_blank");
    };
    const [tabsOpen, setTabsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(allTabsOpen);
    const [localProductsData, setLocalProductsData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(productsData);
    const [selectedGroups, setSelectedGroups] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        intruder: {
            selected: false,
            disabled: false,
            intruder: false,
            bike: false,
            vehicle: false
        },
        intruderPlus: {
            selected: false,
            disabled: false,
            intruder_plus: false,
            bike_plus: false,
            vehicle_plus: false
        },
        motionPlus: {
            selected: false,
            intruder_motion: false,
            vehicle_motion: false,
            bike_motion: false
        },
        gun: {
            selected: false,
            gun: false,
            pistol: false
        },
        crowd: {
            selected: false,
            crowd: false
        },
        loitering: {
            selected: false,
            loiterer: false,
            vehicle_loiterer: false
        },
        fallPerson: {
            selected: false,
            fall_person: false
        },
        noHardHat: {
            selected: false,
            no_hard_hat: false
        },
        // mask: {
        //   selected: false,
        //   mask: false,
        //   mask_compliance: false,
        //   no_mask: false,
        // },
        socialDistancing: {
            selected: false,
            social_distancing: false
        },
        // leftObject: {
        //   selected: false,
        //   left_object: false,
        // },
        // package: {
        //   selected: false,
        //   package: false,
        // },
        fire: {
            selected: false,
            fire: false,
            smoke: false
        },
        lineCrossing: {
            selected: false,
            intruder_line_crossing: false,
            vehicle_line_crossing: false
        },
        peopleFlow: {
            selected: false,
            people_flow: false
        },
        fall: {
            selected: false,
            fall: false
        },
        vehicleLogoId: {
            selected: false,
            amazon: false,
            dhl: false,
            fedex: false,
            school_bus: false,
            ups: false,
            usps: false,
            envera: false,
            fire_truck: false
        },
        nonUps: {
            selected: false,
            non_ups: false
        }
    });
    const [updatingSelectedGroups, setUpdatingSelectedGroups] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const cloneProductsData = (value)=>JSON.parse(JSON.stringify(value));
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        (0, $gr09N.handleCreateSelectedProducts)(productsData, setSelectedGroups, selectedGroups, setUpdatingSelectedGroups);
        setBackupProductsData(cloneProductsData(productsData));
    // localStorage.setItem("backupProductsData", JSON.stringify(productsData));
    }, []);
    const { chmActive: chmActive, showHealthMonitoring: showHealthMonitoring, siteInfoEditCamera: siteInfoEditCamera } = (0, $aZxZ3.useEditCameraStore)();
    const { flags: flags, isFeatureEnabled: isFeatureEnabled } = (0, $4PFLW.useFeatureFlag)();
    const showLineCrossings = isFeatureEnabled("showLineCrossings", true);
    // DoubleTake column: same gate as the Alerts-page filters (ENG-1306).
    const showDoubleTake = (0, $abZpG.isDoubleTakeVisible)(flags, siteInfoEditCamera);
    const doubleTakeHeader = showDoubleTake ? [
        (0, $abZpG.DOUBLE_TAKE_COLUMN_TITLE)
    ] : [];
    const isAutopatrolSite = siteInfoEditCamera.integration_type_name === "autopatrol";
    const filteredAPProductsData = localProductsData.filter((object)=>[
            "Intruder",
            "Crowd",
            "Fire",
            "Vehicle Logo ID",
            "Non-UPS"
        ].includes(object.name));
    const productsToExclude = [
        "Social Distancing"
    ];
    if (!showLineCrossings) productsToExclude.push("Line Crossing");
    const filteredProductsData = isAutopatrolSite ? filteredAPProductsData : localProductsData.filter((object)=>!productsToExclude.includes(object.name));
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: !updatingSelectedGroups && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "relative right-[1px] h-[38px] bg-white min-w-[1250px]",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute right-[50px] top-[5px]",
                        children: !tabsOpen ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            onClick: ()=>{
                                const newTesterData = [
                                    ...filteredProductsData
                                ];
                                newTesterData.forEach((object)=>{
                                    object.open = true;
                                });
                                setProductsData(newTesterData);
                                setLocalProductsData(newTesterData);
                                setTabsOpen(true);
                                setAllTabsOpen(true);
                            },
                            text: "Open All",
                            disabled: false
                        }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            onClick: ()=>{
                                const newTesterData = [
                                    ...filteredProductsData
                                ];
                                newTesterData.forEach((object)=>{
                                    object.open = false;
                                });
                                setProductsData(newTesterData);
                                setLocalProductsData(setLocalProductsData);
                                setTabsOpen(false);
                                setAllTabsOpen(false);
                            },
                            text: "Collapse All",
                            disabled: false
                        })
                    })
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    children: showHealthMonitoring && !isAutopatrolSite && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "relative right-[1px] h-[58px] bg-white min-w-[1250px]",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "absolute left-[20px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                    variant: "h6",
                                    gutterBottom: true,
                                    component: "div",
                                    fontWeight: "bold",
                                    sx: {
                                        fontFamily: "Mulish",
                                        color: "#001943",
                                        paddingTop: "10px"
                                    },
                                    children: "Health Monitoring"
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "absolute left-[200px] top-[8px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                    checked: chmActive,
                                    color: "warning",
                                    disabled: true
                                })
                            })
                        ]
                    })
                }),
                filteredProductsData.length !== 0 && filteredProductsData.map((object, index)=>{
                    const objectLabelName = object.label_name;
                    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: index === 0 ? "" : "pt-[1px]",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "relative right-[1px] h-[58px] bg-white min-w-[1250px]",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "absolute left-[20px]",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                            variant: "h6",
                                            gutterBottom: true,
                                            component: "div",
                                            fontWeight: "bold",
                                            sx: {
                                                fontFamily: "Mulish",
                                                color: "#001943",
                                                paddingTop: "10px"
                                            },
                                            children: object.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "absolute left-[200px] top-[8px]",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                            checked: selectedGroups[object.label_name].selected,
                                            color: "warning",
                                            disabled: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "absolute right-[150] top-[10px]",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                            onClick: handleOpenNewTab,
                                            text: "See product requirements",
                                            disabled: false
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "absolute right-[50px] top-[10px]",
                                        children: object.open ? /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g0plP))), {
                                                fontSize: "large",
                                                onClick: ()=>{
                                                    const newTesterData = [
                                                        ...filteredProductsData
                                                    ];
                                                    newTesterData[index].open = !newTesterData[index].open;
                                                    setProductsData(newTesterData);
                                                    setLocalProductsData(newTesterData);
                                                }
                                            })
                                        }) : /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9rQm))), {
                                                fontSize: "large",
                                                onClick: ()=>{
                                                    const newTesterData = [
                                                        ...filteredProductsData
                                                    ];
                                                    newTesterData[index].open = !newTesterData[index].open;
                                                    setProductsData(newTesterData);
                                                    setLocalProductsData(newTesterData);
                                                }
                                            })
                                        })
                                    })
                                ]
                            }),
                            object.open && // create an outlined table that is padded with 10px inside the div
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "bg-white",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "pt-[1px] pl-[40px] pr-[40px] pb-[10px]",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                        component: (0, $4reBM.default),
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            "aria-label": "simple table",
                                            children: [
                                                object.name === "Crowd" && object.metrics.crowd.display_distance && /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                    titlesArray: [
                                                        "METRIC",
                                                        "ACTIVE",
                                                        "SENSITIVITY",
                                                        "MIN CROWD SIZE",
                                                        "DISTANCE",
                                                        ...doubleTakeHeader
                                                    ]
                                                }),
                                                object.display_name === "Crowd" && !object.metrics.crowd.display_distance && /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                    titlesArray: [
                                                        "METRIC",
                                                        "ACTIVE",
                                                        "SENSITIVITY",
                                                        "MIN CROWD SIZE",
                                                        "",
                                                        ...doubleTakeHeader
                                                    ]
                                                }),
                                                object.name === "Social Distancing" && object.metrics.social_distancing.display_distance && /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                    titlesArray: [
                                                        "METRIC",
                                                        "ACTIVE",
                                                        "SENSITIVITY",
                                                        "DISTANCE",
                                                        "",
                                                        ...doubleTakeHeader
                                                    ]
                                                }),
                                                object.name === "Social Distancing" && !object.metrics.social_distancing.display_distance && /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                    titlesArray: [
                                                        "METRIC",
                                                        "ACTIVE",
                                                        "SENSITIVITY",
                                                        "",
                                                        "",
                                                        ...doubleTakeHeader
                                                    ]
                                                }),
                                                // object.name === "Left Object" ||
                                                object.name === "Loitering" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                    titlesArray: [
                                                        "METRIC",
                                                        "ACTIVE",
                                                        "SENSITIVITY",
                                                        "LOITERING TIME",
                                                        "",
                                                        ...doubleTakeHeader
                                                    ]
                                                }),
                                                object.name !== "Crowd" && // object.name !== "Left Object" &&
                                                object.name !== "Loitering" && object.name !== "Social Distancing" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                    titlesArray: [
                                                        "METRIC",
                                                        "ACTIVE",
                                                        "SENSITIVITY",
                                                        "",
                                                        "",
                                                        ...doubleTakeHeader
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                    children: Object.entries(object.metrics).map(([key, metricsObject])=>{
                                                        const options = metricsObject.options;
                                                        const optionsIds = new Map();
                                                        const distanceOptions = metricsObject.distance_options;
                                                        const distanceOptionsIds = new Map();
                                                        if (metricsObject.options) options.forEach((option)=>{
                                                            optionsIds.set(option[1], option[0]);
                                                        });
                                                        if (metricsObject.distance_options) distanceOptions.forEach((option)=>{
                                                            distanceOptionsIds.set(option[1], option[0]);
                                                        });
                                                        return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    sx: {
                                                                        fontFamily: "Mulish",
                                                                        width: "200px",
                                                                        fontWeight: "bold"
                                                                    },
                                                                    children: metricsObject.display_name
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    sx: {
                                                                        fontFamily: "Mulish",
                                                                        width: "200px"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                                        checked: selectedGroups[objectLabelName][metricsObject.label_name],
                                                                        color: "warning",
                                                                        disabled: true
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    sx: {
                                                                        fontFamily: "Mulish",
                                                                        width: "200px"
                                                                    },
                                                                    children: metricsObject.option_id ? optionsIds.get(Number(metricsObject.option_id)) : "--"
                                                                }),
                                                                object.name === "Social Distancing" && object.metrics.social_distancing.display_distance ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    sx: {
                                                                        fontFamily: "Mulish",
                                                                        width: "200px"
                                                                    },
                                                                    children: object.metrics.social_distancing.distance ? distanceOptionsIds.get(object.metrics.social_distancing.distance) : ""
                                                                }) : metricsObject.user_input_label ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    sx: {
                                                                        fontFamily: "Mulish",
                                                                        width: "200px"
                                                                    },
                                                                    children: metricsObject.user_input_value
                                                                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    sx: {
                                                                        fontFamily: "Mulish",
                                                                        width: "200px"
                                                                    }
                                                                }),
                                                                object.name === "Crowd" && object.metrics.crowd.display_distance ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    sx: {
                                                                        fontFamily: "Mulish",
                                                                        width: "200px"
                                                                    },
                                                                    children: object.metrics.crowd.distance ? distanceOptionsIds.get(object.metrics.crowd.distance) : ""
                                                                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    sx: {
                                                                        fontFamily: "Mulish",
                                                                        width: "200px"
                                                                    }
                                                                }),
                                                                showDoubleTake && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    sx: {
                                                                        fontFamily: "Mulish",
                                                                        width: "200px"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                                        title: (0, $abZpG.isDoubleTakeSupported)(metricsObject) ? "" : (0, $abZpG.DOUBLE_TAKE_UNSUPPORTED_TOOLTIP),
                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                                                checked: Boolean(metricsObject.vlm_enabled),
                                                                                color: "warning",
                                                                                disabled: true,
                                                                                inputProps: {
                                                                                    "aria-label": `DoubleTake ${metricsObject.display_name}`
                                                                                }
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }, (0, $a8BPe.getNumbersAfterEditCamera)(location.href));
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }, object.name);
                })
            ]
        })
    });
};

});
parcelRegister("gr09N", function(module, exports) {

$parcel$export(module.exports, "handleCreateSelectedProducts", () => $60cc2d0ae65eae69$export$5c46580a14d9f0e);
parcelRequire("8T3gX");
const $60cc2d0ae65eae69$export$5c46580a14d9f0e = (productsData, setSelectedGroups, selectedGroups, setUpdatingSelectedGroups)=>{
    const updatedSelectedGroups = selectedGroups;
    if (productsData.length !== 0) productsData.forEach((product)=>{
        const metrics = product.metrics;
        for(const key in metrics){
            if (key === "intruder") {
                updatedSelectedGroups.intruder.intruder = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.intruder.selected = true;
            }
            if (key === "bike") {
                updatedSelectedGroups.intruder.bike = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.intruder.selected = true;
            }
            if (key === "vehicle") {
                updatedSelectedGroups.intruder.vehicle = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.intruder.selected = true;
            }
            if (key === "intruder_plus") {
                updatedSelectedGroups.intruderPlus.intruder_plus = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.intruderPlus.selected = true;
            }
            if (key === "bike_plus") {
                updatedSelectedGroups.intruderPlus.bike_plus = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.intruderPlus.selected = true;
            }
            if (key === "vehicle_plus") {
                updatedSelectedGroups.intruderPlus.vehicle_plus = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.intruderPlus.selected = true;
            }
            if (key === "intruder_motion") {
                updatedSelectedGroups.motionPlus.intruder_motion = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.motionPlus.selected = true;
            }
            if (key === "bike_motion") {
                updatedSelectedGroups.motionPlus.bike_motion = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.motionPlus.selected = true;
            }
            if (key === "vehicle_motion") {
                updatedSelectedGroups.motionPlus.vehicle_motion = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.motionPlus.selected = true;
            }
            if (key === "gun") {
                updatedSelectedGroups.gun.gun = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.gun.selected = true;
            }
            if (key === "pistol") {
                updatedSelectedGroups.gun.pistol = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.gun.selected = true;
            }
            if (key === "crowd") {
                updatedSelectedGroups.crowd.crowd = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.crowd.selected = true;
            }
            if (key === "loiterer") {
                updatedSelectedGroups.loitering.loiterer = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.loitering.selected = true;
            }
            if (key === "vehicle_loiterer") {
                updatedSelectedGroups.loitering.vehicle_loiterer = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.loitering.selected = true;
            }
            if (key === "fall_person") {
                updatedSelectedGroups.fallPerson.fall_person = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.fallPerson.selected = true;
            }
            if (key === "no_hard_hat") {
                updatedSelectedGroups.noHardHat.no_hard_hat = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.noHardHat.selected = true;
            }
            if (key === "mask") {
                updatedSelectedGroups.mask.mask = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.mask.selected = true;
            }
            if (key === "mask_compliance") {
                updatedSelectedGroups.mask.mask_compliance = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.mask.selected = true;
            }
            if (key === "no_mask") {
                updatedSelectedGroups.mask.no_mask = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.mask.selected = true;
            }
            if (key === "social_distancing") {
                updatedSelectedGroups.socialDistancing.social_distancing = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.socialDistancing.selected = true;
            }
            if (key === "left_object") {
                updatedSelectedGroups.leftObject.left_object = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.leftObject.selected = true;
            }
            if (key === "package") {
                updatedSelectedGroups.package.package = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.package.selected = true;
            }
            if (key === "fire") {
                updatedSelectedGroups.fire.fire = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.fire.selected = true;
            }
            if (key === "smoke") {
                updatedSelectedGroups.fire.smoke = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.fire.selected = true;
            }
            if (key === "intruder_line_crossing") {
                updatedSelectedGroups.lineCrossing.intruder_line_crossing = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.lineCrossing.selected = true;
            }
            if (key === "vehicle_line_crossing") {
                updatedSelectedGroups.lineCrossing.vehicle_line_crossing = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.lineCrossing.selected = true;
            }
            if (key === "people_flow") {
                updatedSelectedGroups.peopleFlow.people_flow = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.peopleFlow.selected = true;
            }
            if (key === "fall") {
                updatedSelectedGroups.fall.fall = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.fall.selected = true;
            }
            if (key === "amazon") {
                updatedSelectedGroups.vehicleLogoId.amazon = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.vehicleLogoId.selected = true;
            }
            if (key === "dhl") {
                updatedSelectedGroups.vehicleLogoId.dhl = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.vehicleLogoId.selected = true;
            }
            if (key === "fedex") {
                updatedSelectedGroups.vehicleLogoId.fedex = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.vehicleLogoId.selected = true;
            }
            if (key === "school_bus") {
                updatedSelectedGroups.vehicleLogoId.school_bus = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.vehicleLogoId.selected = true;
            }
            if (key === "ups") {
                updatedSelectedGroups.vehicleLogoId.ups = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.vehicleLogoId.selected = true;
            }
            if (key === "usps") {
                updatedSelectedGroups.vehicleLogoId.usps = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.vehicleLogoId.selected = true;
            }
            if (key === "envera") {
                updatedSelectedGroups.vehicleLogoId.envera = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.vehicleLogoId.selected = true;
            }
            if (key === "fire_truck") {
                updatedSelectedGroups.vehicleLogoId.fire_truck = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.vehicleLogoId.selected = true;
            }
            if (key === "non_ups") {
                updatedSelectedGroups.nonUps.non_ups = metrics[key].active;
                if (metrics[key].active) updatedSelectedGroups.nonUps.selected = true;
            }
        }
    });
    setSelectedGroups(updatedSelectedGroups);
    if (setUpdatingSelectedGroups) setUpdatingSelectedGroups(false);
};

});

parcelRegister("abZpG", function(module, exports) {

$parcel$export(module.exports, "DOUBLE_TAKE_COLUMN_TITLE", () => $e5ae7bfe912155eb$export$83946a388c3150e6);
$parcel$export(module.exports, "DOUBLE_TAKE_UNSUPPORTED_TOOLTIP", () => $e5ae7bfe912155eb$export$be50fdbfbf7dec7a);
$parcel$export(module.exports, "isDoubleTakeVisible", () => $e5ae7bfe912155eb$export$f8e912937fdbc757);
$parcel$export(module.exports, "isDoubleTakeSupported", () => $e5ae7bfe912155eb$export$dcbd7c7a8ec91992);
$parcel$export(module.exports, "getDoubleTakeDisabledReason", () => $e5ae7bfe912155eb$export$3387f6cbaec09643);
$parcel$export(module.exports, "hasDoubleTakeChanged", () => $e5ae7bfe912155eb$export$8c1bdeaee65f1c9f);
$parcel$export(module.exports, "setMetricDoubleTake", () => $e5ae7bfe912155eb$export$1b68afd32d2d9452);
/**
 * DoubleTake (the VLM false-positive filter) per product on the Edit Camera
 * Products tab (ENG-1306).
 *
 * The API contract: every entry in `stream_metrics` carries
 * `vlm_enabled` (read/write; `true` is rejected with a 400 on a product whose
 * label isn't supported) and `vlm_supported` (read-only). The stream-level
 * `vlm_enabled` is derived and never written by this UI.
 */ const $e5ae7bfe912155eb$export$83946a388c3150e6 = "DOUBLETAKE";
const $e5ae7bfe912155eb$export$be50fdbfbf7dec7a = "DoubleTake isn't available for this product yet";
const $e5ae7bfe912155eb$export$f8e912937fdbc757 = (flags, siteInfo)=>Boolean(flags?.showVlmFilters) && Boolean(siteInfo?.vlm_enabled);
const $e5ae7bfe912155eb$export$dcbd7c7a8ec91992 = (metric)=>metric?.vlm_supported === true;
const $e5ae7bfe912155eb$export$ffb6ca1c9607669a = "Enable the product first";
const $e5ae7bfe912155eb$export$3387f6cbaec09643 = (metric)=>{
    if (!metric?.active) return $e5ae7bfe912155eb$export$ffb6ca1c9607669a;
    if (!$e5ae7bfe912155eb$export$dcbd7c7a8ec91992(metric)) return $e5ae7bfe912155eb$export$be50fdbfbf7dec7a;
    return null;
};
const $e5ae7bfe912155eb$export$8c1bdeaee65f1c9f = (currentMetric, previousMetric)=>currentMetric?.vlm_enabled !== undefined && currentMetric.vlm_enabled !== previousMetric?.vlm_enabled;
const $e5ae7bfe912155eb$export$1b68afd32d2d9452 = (productsData, groupLabelName, metricLabelName, vlmEnabled)=>productsData.map((product)=>{
        if (product.label_name !== groupLabelName) return product;
        const metric = product.metrics?.[metricLabelName];
        if (!metric) return product;
        return {
            ...product,
            metrics: {
                ...product.metrics,
                [metricLabelName]: {
                    ...metric,
                    vlm_enabled: vlmEnabled
                }
            }
        };
    });

});


parcelRegister("jZEH7", function(module, exports) {

$parcel$export(module.exports, "ProductsTabEditMode", () => $8660cd8a581feafc$export$2aef0712ba4b0bb0);
/* eslint-disable react-hooks/exhaustive-deps */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $f3puC = parcelRequire("f3puC");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $ddLR4 = parcelRequire("ddLR4");

var $g0plP = parcelRequire("g0plP");

var $e9rQm = parcelRequire("e9rQm");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");

var $5bqo6 = parcelRequire("5bqo6");

var $8jTCz = parcelRequire("8jTCz");

var $8Izxp = parcelRequire("8Izxp");

var $jIHXr = parcelRequire("jIHXr");

var $gr09N = parcelRequire("gr09N");

var $cVCJe = parcelRequire("cVCJe");

var $6CNXS = parcelRequire("6CNXS");

var $dLErb = parcelRequire("dLErb");

var $aZxZ3 = parcelRequire("aZxZ3");

var $19GR5 = parcelRequire("19GR5");

var $4PFLW = parcelRequire("4PFLW");

var $abZpG = parcelRequire("abZpG");
const $8660cd8a581feafc$export$2aef0712ba4b0bb0 = ({ activeProducts: activeProducts, setPatchObject: setPatchObject, setGeneralInfoChangesMade: setGeneralInfoChangesMade, cameraGeneralInfo: cameraGeneralInfo, productsData: productsData, setProductsData: setProductsData, allTabsOpen: allTabsOpen, setAllTabsOpen: setAllTabsOpen, setBackupProductsData: setBackupProductsData, siteInfo: siteInfo })=>{
    const handlePatchThresh = (value, groupLabelName, object, optionNames)=>{
        const resolvedOptionId = value === null || value === undefined || value === "" ? null : optionNames.get(value);
        setLocalProductsData((previousState)=>{
            const updatedProducts = [
                ...previousState
            ];
            const productIndex = updatedProducts.findIndex((product)=>product.label_name === groupLabelName);
            const updatedProduct = updatedProducts[productIndex];
            updatedProduct.metrics[object.label_name].option_id = resolvedOptionId;
            updatedProducts[productIndex] = updatedProduct;
            return updatedProducts;
        });
        setProductsData((previousState)=>{
            const updatedProducts = [
                ...previousState
            ];
            const productIndex = updatedProducts.findIndex((product)=>product.label_name === groupLabelName);
            const updatedProduct = updatedProducts[productIndex];
            updatedProduct.metrics[object.label_name].option_id = resolvedOptionId;
            updatedProducts[productIndex] = updatedProduct;
            return updatedProducts;
        });
    };
    const handlePatchDistance = (value, groupLabelName, object, optionNames)=>{
        setLocalProductsData((previousState)=>{
            const updatedProducts = [
                ...previousState
            ];
            const productIndex = updatedProducts.findIndex((product)=>product.label_name === groupLabelName);
            const updatedProduct = updatedProducts[productIndex];
            updatedProduct.metrics[object.label_name].distance = optionNames.get(value);
            updatedProducts[productIndex] = updatedProduct;
            return updatedProducts;
        });
        setProductsData((previousState)=>{
            const updatedProducts = [
                ...previousState
            ];
            const productIndex = updatedProducts.findIndex((product)=>product.label_name === groupLabelName);
            const updatedProduct = updatedProducts[productIndex];
            updatedProduct.metrics[object.label_name].distance = optionNames.get(value);
            updatedProducts[productIndex] = updatedProduct;
            return updatedProducts;
        });
    };
    const handleExtraFieldInput = (value, groupLabelName, object)=>{
        setLocalProductsData((previousState)=>{
            const updatedProducts = [
                ...previousState
            ];
            const productIndex = updatedProducts.findIndex((product)=>product.label_name === groupLabelName);
            const updatedProduct = updatedProducts[productIndex];
            updatedProduct.metrics[object.label_name].user_input_value = value;
            updatedProducts[productIndex] = updatedProduct;
            return updatedProducts;
        });
        setProductsData((previousState)=>{
            const updatedProducts = [
                ...previousState
            ];
            const productIndex = updatedProducts.findIndex((product)=>product.label_name === groupLabelName);
            const updatedProduct = updatedProducts[productIndex];
            updatedProduct.metrics[object.label_name].user_input_value = value;
            updatedProducts[productIndex] = updatedProduct;
            return updatedProducts;
        });
    };
    const [tabsOpen, setTabsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(allTabsOpen);
    const [localProductsData, setLocalProductsData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(productsData);
    const [selectedGroups, setSelectedGroups] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        intruder: {
            selected: false,
            disabled: false,
            intruder: false,
            bike: false,
            vehicle: false
        },
        intruderPlus: {
            selected: false,
            disabled: false,
            intruder_plus: false,
            bike_plus: false,
            vehicle_plus: false
        },
        motionPlus: {
            selected: false,
            intruder_motion: false,
            vehicle_motion: false,
            bike_motion: false
        },
        gun: {
            selected: false,
            gun: false,
            pistol: false
        },
        crowd: {
            selected: false,
            crowd: false
        },
        loitering: {
            selected: false,
            loiterer: false,
            vehicle_loiterer: false
        },
        fallPerson: {
            selected: false,
            fall_person: false
        },
        noHardHat: {
            selected: false,
            no_hard_hat: false
        },
        mask: {
            selected: false,
            mask: false,
            mask_compliance: false,
            no_mask: false
        },
        socialDistancing: {
            selected: false,
            social_distancing: false
        },
        leftObject: {
            selected: false,
            left_object: false
        },
        package: {
            selected: false,
            package: false
        },
        fire: {
            selected: false,
            fire: false,
            smoke: false
        },
        lineCrossing: {
            selected: false,
            intruder_line_crossing: false,
            vehicle_line_crossing: false
        },
        peopleFlow: {
            selected: false,
            people_flow: false
        },
        fall: {
            selected: false,
            fall: false
        },
        vehicleLogoId: {
            selected: false,
            amazon: false,
            dhl: false,
            fedex: false,
            school_bus: false,
            ups: false,
            usps: false,
            envera: false,
            fire_truck: false
        },
        nonUps: {
            selected: false,
            non_ups: false
        }
    });
    const [updatingSelectedGroups, setUpdatingSelectedGroups] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const { flags: flags, isFeatureEnabled: isFeatureEnabled } = (0, $4PFLW.useFeatureFlag)();
    const showLineCrossings = isFeatureEnabled("showLineCrossings", true);
    const allowConcurrentLineCrossingIntruderProducts = isFeatureEnabled("allowConcurrentLineCrossingIntruderProducts", false);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (productsData.length !== 0) (0, $jIHXr.handleCheckForDisabledProducts)(productsData, setSelectedGroups, allowConcurrentLineCrossingIntruderProducts);
        (0, $gr09N.handleCreateSelectedProducts)(productsData, setSelectedGroups, selectedGroups, setUpdatingSelectedGroups);
    }, []);
    const { chmActive: chmActive, setChmActive: setChmActive, setAddHealthMonitoringDialogOpen: setAddHealthMonitoringDialogOpen, siteInfoEditCamera: siteInfoEditCamera, vCHOnlySite: vCHOnlySite, setCHMValueChanged: setCHMValueChanged, addHealthMonitoringDialogOpen: addHealthMonitoringDialogOpen, setCHMStreamMetric: setCHMStreamMetric, chmStreamMetric: chmStreamMetric, showHealthMonitoring: showHealthMonitoring } = (0, $aZxZ3.useEditCameraStore)();
    const isAutopatrolSite = siteInfoEditCamera.integration_type_name === "autopatrol";
    // DoubleTake column: same gate as the Alerts-page filters (ENG-1306). The
    // toggle is staged on productsData and rides the per-metric PATCH on save.
    const showDoubleTake = (0, $abZpG.isDoubleTakeVisible)(flags, siteInfoEditCamera);
    const doubleTakeHeader = showDoubleTake ? [
        (0, $abZpG.DOUBLE_TAKE_COLUMN_TITLE)
    ] : [];
    const handleToggleDoubleTake = (groupLabelName, metricLabelName, vlmEnabled)=>{
        setLocalProductsData((previousState)=>(0, $abZpG.setMetricDoubleTake)(previousState, groupLabelName, metricLabelName, vlmEnabled));
        setProductsData((previousState)=>(0, $abZpG.setMetricDoubleTake)(previousState, groupLabelName, metricLabelName, vlmEnabled));
        setGeneralInfoChangesMade(true);
    };
    const useAutopatrolControlledSensitivity = isAutopatrolSite && !vCHOnlySite;
    const filteredAPProductsData = localProductsData.filter((object)=>[
            "Intruder",
            "Crowd",
            "Fire",
            "Vehicle Logo ID",
            "Non-UPS"
        ].includes(object.name));
    const productsToExclude = [
        "Social Distancing",
        "Fall Person"
    ];
    if (!showLineCrossings) productsToExclude.push("Line Crossing");
    const filteredProductsData = isAutopatrolSite ? filteredAPProductsData : localProductsData.filter((object)=>!productsToExclude.includes(object.name));
    const isIntruderEnabled = selectedGroups.intruder.selected;
    const isMotionPlusEnabled = selectedGroups.motionPlus.selected;
    const isLineCrossingEnabled = selectedGroups.lineCrossing.selected;
    const productConflictRecoveryMode = (0, $dLErb.trioMutualExclusionRecoveryMode)(selectedGroups, allowConcurrentLineCrossingIntruderProducts);
    const trioActiveCount = Number(isIntruderEnabled) + Number(isMotionPlusEnabled) + Number(isLineCrossingEnabled);
    const motionPlusLockedAsThirdWhenTwoOn = !allowConcurrentLineCrossingIntruderProducts && trioActiveCount === 2 && !isMotionPlusEnabled;
    const lineCrossingLockedAsThirdWhenTwoOn = !allowConcurrentLineCrossingIntruderProducts && trioActiveCount === 2 && !isLineCrossingEnabled;
    const motionPlusBlockedByIntruder = selectedGroups.intruderPlus.disabled || isIntruderEnabled;
    const motionPlusBlockedByLineCrossing = !allowConcurrentLineCrossingIntruderProducts && isLineCrossingEnabled;
    const isMotionPlusToggleDisabled = allowConcurrentLineCrossingIntruderProducts ? isIntruderEnabled && !isMotionPlusEnabled && !productConflictRecoveryMode : motionPlusLockedAsThirdWhenTwoOn || !productConflictRecoveryMode && (motionPlusBlockedByIntruder || motionPlusBlockedByLineCrossing);
    const lineCrossingBlockedByIntruder = !allowConcurrentLineCrossingIntruderProducts && isIntruderEnabled;
    const lineCrossingBlockedByMotionPlus = !allowConcurrentLineCrossingIntruderProducts && isMotionPlusEnabled;
    const isLineCrossingToggleDisabled = !allowConcurrentLineCrossingIntruderProducts && (lineCrossingLockedAsThirdWhenTwoOn || !productConflictRecoveryMode && (lineCrossingBlockedByIntruder || lineCrossingBlockedByMotionPlus));
    const motionPlusDisabledTooltip = allowConcurrentLineCrossingIntruderProducts ? `Intruder and Motion Plus can not run together. To enable Motion Plus, please toggle off Intruder.` : motionPlusLockedAsThirdWhenTwoOn ? `Intruder and Line Crossing are enabled. Turn one off before enabling Motion Plus.` : motionPlusBlockedByIntruder && motionPlusBlockedByLineCrossing ? `Motion Plus can not be run with either Intruder or Line Crossing enabled. To enable Motion Plus, please toggle off both Intruder and Line Crossing.` : motionPlusBlockedByIntruder ? `Intruder and Motion Plus can not run together. To enable Motion Plus, please toggle off Intruder.` : `Line Crossing and Motion Plus can not run together. To enable Motion Plus, please toggle off Line Crossing.`;
    const lineCrossingDisabledTooltip = lineCrossingLockedAsThirdWhenTwoOn ? `Intruder and Motion Plus are enabled. Turn one off before enabling Line Crossing.` : lineCrossingBlockedByIntruder && lineCrossingBlockedByMotionPlus ? `Line Crossing can not be run with either Intruder or Motion Plus enabled. To enable Line Crossing, please toggle off both Intruder and Motion Plus.` : lineCrossingBlockedByIntruder ? `Intruder and Line Crossing can not run together. To enable Line Crossing, please toggle off Intruder.` : `Motion Plus and Line Crossing can not run together. To enable Line Crossing, please toggle off Motion Plus.`;
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            addHealthMonitoringDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $19GR5.AddHealthMonitoringDialog), {}),
            !updatingSelectedGroups && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "relative right-[1px] h-[38px] bg-white min-w-[1250px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "absolute right-[50px] top-[5px]",
                            children: !tabsOpen ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    const newTesterData = [
                                        ...filteredProductsData
                                    ];
                                    newTesterData.forEach((object)=>{
                                        object.open = true;
                                    });
                                    setProductsData(newTesterData);
                                    setLocalProductsData(newTesterData);
                                    setAllTabsOpen(true);
                                    setTabsOpen(true);
                                },
                                text: "Open All",
                                disabled: false
                            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    const newTesterData = [
                                        ...filteredProductsData
                                    ];
                                    newTesterData.forEach((object)=>{
                                        object.open = false;
                                    });
                                    setProductsData(newTesterData);
                                    setLocalProductsData(newTesterData);
                                    setAllTabsOpen(false);
                                    setTabsOpen(false);
                                },
                                text: "Collapse All",
                                disabled: false
                            })
                        })
                    }),
                    showHealthMonitoring && !isAutopatrolSite && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "relative right-[1px] h-[58px] bg-white min-w-[1250px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "absolute left-[20px]",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                        variant: "h6",
                                        gutterBottom: true,
                                        component: "div",
                                        fontWeight: "bold",
                                        sx: {
                                            fontFamily: "Mulish",
                                            color: "#001943",
                                            paddingTop: "10px"
                                        },
                                        children: "Health Monitoring"
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "absolute left-[200px] top-[8px]",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                        checked: chmActive,
                                        color: "warning",
                                        disabled: false,
                                        onChange: (event)=>{
                                            if (event.target.checked && !siteInfoEditCamera.chm) {
                                                setChmActive(true);
                                                setCHMValueChanged(true);
                                                setAddHealthMonitoringDialogOpen(true);
                                                const updatedChmStreamMetric = {
                                                    ...chmStreamMetric,
                                                    active: true
                                                };
                                                setCHMStreamMetric(updatedChmStreamMetric);
                                            }
                                            if (event.target.checked && siteInfoEditCamera.chm) {
                                                setChmActive(true);
                                                const updatedChmStreamMetric = {
                                                    ...chmStreamMetric,
                                                    active: true
                                                };
                                                setCHMStreamMetric(updatedChmStreamMetric);
                                                setCHMValueChanged(true);
                                            }
                                            if (!event.target.checked) {
                                                setChmActive(false);
                                                const updatedChmStreamMetric = {
                                                    ...chmStreamMetric,
                                                    active: false
                                                };
                                                setCHMStreamMetric(updatedChmStreamMetric);
                                                setCHMValueChanged(true);
                                            }
                                        }
                                    })
                                })
                            ]
                        })
                    }),
                    filteredProductsData.length !== 0 && filteredProductsData.map((productObject, productIndex)=>{
                        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: productIndex === 0 ? "" : "pt-[1px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "relative right-[1px] h-[58px] bg-white min-w-[1250px]",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "absolute left-[20px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                                variant: "h6",
                                                gutterBottom: true,
                                                component: "div",
                                                fontWeight: "bold",
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    color: "#001943",
                                                    paddingTop: "10px"
                                                },
                                                children: productObject.name
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "absolute left-[200px] top-[8px]",
                                            children: [
                                                productObject.name !== "Intruder" && productObject.name !== "Intruder Plus" && productObject.name !== "Motion Plus" && productObject.name !== "Line Crossing" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                    checked: selectedGroups[productObject.label_name].selected,
                                                    color: "warning",
                                                    disabled: false,
                                                    onChange: (event)=>{
                                                        setSelectedGroups((previousState)=>{
                                                            const updatedState = {
                                                                ...previousState
                                                            };
                                                            const updatedGroup = updatedState[productObject.label_name];
                                                            for(const key in updatedGroup)updatedGroup[key] = event.target.checked;
                                                            updatedState[productObject.label_name] = updatedGroup;
                                                            return updatedState;
                                                        });
                                                        (0, $8Izxp.handleProductMasterSwitchEvent)(setLocalProductsData, setProductsData, event, productObject);
                                                        setGeneralInfoChangesMade(true);
                                                    }
                                                }),
                                                productObject.name === "Intruder" && (0, $6CNXS.createIntruderToggle)(selectedGroups, setSelectedGroups, setLocalProductsData, setProductsData, setGeneralInfoChangesMade, productObject, allowConcurrentLineCrossingIntruderProducts),
                                                productObject.name === "Intruder Plus" && (selectedGroups.intruderPlus.disabled ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                    title: `Intruder is already enabled. To enable Intruder Plus, please toggle off Intruder.`,
                                                    placement: "top",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                            checked: selectedGroups.intruderPlus.selected,
                                                            color: "warning",
                                                            disabled: true
                                                        })
                                                    })
                                                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                    checked: selectedGroups.intruderPlus.selected,
                                                    color: "warning",
                                                    disabled: false,
                                                    onChange: (event)=>{
                                                        if (!event.target.checked) setSelectedGroups((previousState)=>{
                                                            return {
                                                                ...previousState,
                                                                intruder: {
                                                                    selected: previousState.intruder.selected,
                                                                    disabled: selectedGroups.intruder.selected,
                                                                    intruder: previousState.intruder.intruder,
                                                                    bike: previousState.intruder.bike,
                                                                    vehicle: previousState.intruder.vehicle
                                                                },
                                                                intruderPlus: {
                                                                    selected: false,
                                                                    disabled: previousState.intruderPlus.disabled,
                                                                    intruder_plus: false,
                                                                    bike_plus: false,
                                                                    vehicle_plus: false
                                                                }
                                                            };
                                                        });
                                                        if (event.target.checked) setSelectedGroups((previousState)=>{
                                                            return {
                                                                ...previousState,
                                                                intruder: {
                                                                    selected: previousState.intruder.selected,
                                                                    disabled: !selectedGroups.intruder.selected,
                                                                    intruder: previousState.intruder.intruder,
                                                                    bike: previousState.intruder.bike,
                                                                    vehicle: previousState.intruder.vehicle
                                                                },
                                                                intruderPlus: {
                                                                    selected: true,
                                                                    disabled: previousState.intruderPlus.disabled,
                                                                    intruder_plus: true,
                                                                    bike_plus: true,
                                                                    vehicle_plus: true
                                                                }
                                                            };
                                                        });
                                                        (0, $8Izxp.handleProductMasterSwitchEvent)(setLocalProductsData, setProductsData, event, productObject);
                                                        setGeneralInfoChangesMade(true);
                                                    }
                                                })),
                                                productObject.name === "Motion Plus" && (isMotionPlusToggleDisabled ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                    title: motionPlusDisabledTooltip,
                                                    placement: "top",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                            checked: selectedGroups.motionPlus.selected,
                                                            color: "warning",
                                                            disabled: true
                                                        })
                                                    })
                                                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                    checked: selectedGroups.motionPlus.selected,
                                                    color: "warning",
                                                    disabled: false,
                                                    onChange: (event)=>{
                                                        if (!event.target.checked) setSelectedGroups((previousState)=>{
                                                            const intruderDisabledAfterMotionOff = previousState.intruderPlus.selected || !allowConcurrentLineCrossingIntruderProducts && previousState.lineCrossing.selected;
                                                            return {
                                                                ...previousState,
                                                                intruder: {
                                                                    selected: previousState.intruder.selected,
                                                                    disabled: intruderDisabledAfterMotionOff,
                                                                    intruder: previousState.intruder.intruder,
                                                                    bike: previousState.intruder.bike,
                                                                    vehicle: previousState.intruder.vehicle
                                                                },
                                                                motionPlus: {
                                                                    selected: false,
                                                                    vehicle_motion: false,
                                                                    bike_motion: false,
                                                                    intruder_motion: false
                                                                }
                                                            };
                                                        });
                                                        if (event.target.checked) setSelectedGroups((previousState)=>{
                                                            return {
                                                                ...previousState,
                                                                intruder: {
                                                                    selected: previousState.intruder.selected,
                                                                    disabled: selectedGroups.intruder.selected,
                                                                    intruder: previousState.intruder.intruder,
                                                                    bike: previousState.intruder.bike,
                                                                    vehicle: previousState.intruder.vehicle
                                                                },
                                                                motionPlus: {
                                                                    selected: true,
                                                                    vehicle_motion: true,
                                                                    bike_motion: true,
                                                                    intruder_motion: true
                                                                }
                                                            };
                                                        });
                                                        (0, $8Izxp.handleProductMasterSwitchEvent)(setLocalProductsData, setProductsData, event, productObject);
                                                        setGeneralInfoChangesMade(true);
                                                    }
                                                })),
                                                productObject.name === "Line Crossing" && (isLineCrossingToggleDisabled ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                    title: lineCrossingDisabledTooltip,
                                                    placement: "top",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                            checked: selectedGroups.lineCrossing.selected,
                                                            color: "warning",
                                                            disabled: true
                                                        })
                                                    })
                                                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                    checked: selectedGroups.lineCrossing.selected,
                                                    color: "warning",
                                                    disabled: false,
                                                    onChange: (event)=>{
                                                        setSelectedGroups((previousState)=>{
                                                            const updatedState = {
                                                                ...previousState
                                                            };
                                                            const updatedGroup = updatedState.lineCrossing;
                                                            for(const key in updatedGroup)updatedGroup[key] = event.target.checked;
                                                            updatedState.lineCrossing = updatedGroup;
                                                            return updatedState;
                                                        });
                                                        (0, $8Izxp.handleProductMasterSwitchEvent)(setLocalProductsData, setProductsData, event, productObject);
                                                        setGeneralInfoChangesMade(true);
                                                    }
                                                }))
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "absolute right-[50px] top-[10px]",
                                            children: productObject.open ? /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g0plP))), {
                                                    fontSize: "large",
                                                    onClick: ()=>{
                                                        const newTesterData = [
                                                            ...filteredProductsData
                                                        ];
                                                        newTesterData[productIndex].open = !newTesterData[productIndex].open;
                                                        setProductsData(newTesterData);
                                                        setLocalProductsData(newTesterData);
                                                    }
                                                })
                                            }) : /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9rQm))), {
                                                    fontSize: "large",
                                                    onClick: ()=>{
                                                        const newTesterData = [
                                                            ...filteredProductsData
                                                        ];
                                                        newTesterData[productIndex].open = !newTesterData[productIndex].open;
                                                        setProductsData(newTesterData);
                                                        setLocalProductsData(newTesterData);
                                                    }
                                                })
                                            })
                                        })
                                    ]
                                }),
                                productObject.open && // create an outlined table that is padded with 10px inside the div
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "bg-white",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "pt-[1px] pl-[40px] pr-[40px] pb-[10px]",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                            component: (0, $4reBM.default),
                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                "aria-label": "simple table",
                                                children: [
                                                    productObject.name === "Crowd" && productObject.metrics.crowd.display_distance && /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                        titlesArray: [
                                                            "METRIC",
                                                            "ACTIVE",
                                                            "SENSITIVITY",
                                                            "MIN CROWD SIZE",
                                                            "DISTANCE",
                                                            ...doubleTakeHeader
                                                        ]
                                                    }),
                                                    productObject.display_name === "Crowd" && !productObject.metrics.crowd.display_distance && /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                        titlesArray: [
                                                            "METRIC",
                                                            "ACTIVE",
                                                            "SENSITIVITY",
                                                            "MIN CROWD SIZE",
                                                            "",
                                                            ...doubleTakeHeader
                                                        ]
                                                    }),
                                                    productObject.name === "Social Distancing" && productObject.metrics.social_distancing.display_distance && /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                        titlesArray: [
                                                            "METRIC",
                                                            "ACTIVE",
                                                            "SENSITIVITY",
                                                            "DISTANCE",
                                                            "",
                                                            ...doubleTakeHeader
                                                        ]
                                                    }),
                                                    productObject.name === "Social Distancing" && !productObject.metrics.social_distancing.display_distance && /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                        titlesArray: [
                                                            "METRIC",
                                                            "ACTIVE",
                                                            "SENSITIVITY",
                                                            "",
                                                            "",
                                                            ...doubleTakeHeader
                                                        ]
                                                    }),
                                                    // productObject.name === "Left Object" ||
                                                    productObject.name === "Loitering" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                        titlesArray: [
                                                            "METRIC",
                                                            "ACTIVE",
                                                            "SENSITIVITY",
                                                            "LOITERING TIME",
                                                            "",
                                                            ...doubleTakeHeader
                                                        ]
                                                    }),
                                                    productObject.name !== "Crowd" && // productObject.name !== "Left Object" &&
                                                    productObject.name !== "Loitering" && productObject.name !== "Social Distancing" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                        titlesArray: [
                                                            "METRIC",
                                                            "ACTIVE",
                                                            "SENSITIVITY",
                                                            "",
                                                            "",
                                                            ...doubleTakeHeader
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                        children: Object.entries(productObject.metrics).map(([key, metricsObject], metricIndex)=>{
                                                            const options = metricsObject.options;
                                                            const optionsIds = new Map();
                                                            const optionNames = new Map();
                                                            const distanceOptions = metricsObject.distance_options;
                                                            const distanceOptionsIds = new Map();
                                                            const distanceOptionNames = new Map();
                                                            if (metricsObject.options) {
                                                                options.forEach((option)=>{
                                                                    optionsIds.set(option[1], option[0]);
                                                                });
                                                                options.forEach((option)=>{
                                                                    optionNames.set(option[0], option[1]);
                                                                });
                                                            }
                                                            if (metricsObject.distance_options) {
                                                                distanceOptions.forEach((option)=>{
                                                                    distanceOptionsIds.set(option[1], option[0]);
                                                                });
                                                                distanceOptions.forEach((option)=>{
                                                                    distanceOptionNames.set(option[0], option[1]);
                                                                });
                                                            }
                                                            const isSubMetricSettingsDisabled = !metricsObject.active;
                                                            return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                        align: "left",
                                                                        sx: {
                                                                            fontFamily: "Mulish",
                                                                            width: "200px",
                                                                            fontWeight: "bold"
                                                                        },
                                                                        children: metricsObject.display_name
                                                                    }),
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                        align: "left",
                                                                        sx: {
                                                                            fontFamily: "Mulish",
                                                                            width: "200px"
                                                                        },
                                                                        children: (0, $5bqo6.switchCreator)(metricsObject, selectedGroups, productObject.label_name, setSelectedGroups, setLocalProductsData, setProductsData, setGeneralInfoChangesMade, allowConcurrentLineCrossingIntruderProducts)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                        align: "left",
                                                                        sx: {
                                                                            fontFamily: "Mulish",
                                                                            width: "40px"
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                                                                disablePortal: true,
                                                                                disabled: isSubMetricSettingsDisabled,
                                                                                id: key,
                                                                                options: options.map((option)=>{
                                                                                    return option[0];
                                                                                }),
                                                                                ...useAutopatrolControlledSensitivity ? {
                                                                                    value: metricsObject.option_id ? optionsIds.get(metricsObject.option_id) ?? null : null
                                                                                } : {
                                                                                    defaultValue: metricsObject.option_id ? optionsIds.get(metricsObject.option_id) : ""
                                                                                },
                                                                                onChange: (event, newInputValue)=>{
                                                                                    handlePatchThresh(newInputValue, productObject.label_name, metricsObject, optionNames);
                                                                                    setGeneralInfoChangesMade(true);
                                                                                },
                                                                                sx: {
                                                                                    width: 250
                                                                                },
                                                                                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                                        ...params,
                                                                                        variant: "standard",
                                                                                        label: "Thresh",
                                                                                        autoComplete: "off",
                                                                                        id: key,
                                                                                        name: key
                                                                                    })
                                                                            })
                                                                        }, "thresh_option")
                                                                    }),
                                                                    productObject.name === "Social Distancing" && productObject.metrics.social_distancing.display_distance ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                        align: "left",
                                                                        sx: {
                                                                            fontFamily: "Mulish",
                                                                            width: "200px"
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                                                                disablePortal: true,
                                                                                disabled: isSubMetricSettingsDisabled,
                                                                                id: key,
                                                                                options: distanceOptions.map((option)=>{
                                                                                    return option[0];
                                                                                }),
                                                                                defaultValue: productObject.metrics.social_distancing.distance ? distanceOptionsIds.get(productObject.metrics.social_distancing.distance) : "",
                                                                                onChange: (event, newInputValue)=>{
                                                                                    handlePatchDistance(newInputValue, productObject.label_name, metricsObject, distanceOptionNames);
                                                                                    setGeneralInfoChangesMade(true);
                                                                                },
                                                                                sx: {
                                                                                    width: 250
                                                                                },
                                                                                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                                        ...params,
                                                                                        variant: "standard",
                                                                                        label: "Distance",
                                                                                        autoComplete: "off",
                                                                                        id: key,
                                                                                        name: key
                                                                                    })
                                                                            })
                                                                        }, "distance_option")
                                                                    }) : metricsObject.user_input_label ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                        align: "left",
                                                                        sx: {
                                                                            fontFamily: "Mulish",
                                                                            width: "200px"
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                                defaultValue: metricsObject.user_input_value,
                                                                                autoComplete: "off",
                                                                                variant: "standard",
                                                                                disabled: isSubMetricSettingsDisabled,
                                                                                onChange: (event)=>{
                                                                                    handleExtraFieldInput(event.target.value, productObject.label_name, metricsObject);
                                                                                    setGeneralInfoChangesMade(true);
                                                                                },
                                                                                sx: {
                                                                                    width: 150
                                                                                }
                                                                            })
                                                                        })
                                                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                        align: "left",
                                                                        sx: {
                                                                            fontFamily: "Mulish",
                                                                            width: "200px"
                                                                        }
                                                                    }),
                                                                    productObject.name === "Crowd" && productObject.metrics.crowd.display_distance ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                        align: "left",
                                                                        sx: {
                                                                            fontFamily: "Mulish",
                                                                            width: "200px"
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                                                                disablePortal: true,
                                                                                disabled: isSubMetricSettingsDisabled,
                                                                                id: key,
                                                                                options: distanceOptions.map((option)=>{
                                                                                    return option[0];
                                                                                }),
                                                                                defaultValue: productObject.metrics.crowd.distance ? distanceOptionsIds.get(productObject.metrics.crowd.distance) : "",
                                                                                onChange: (event, newInputValue)=>{
                                                                                    handlePatchDistance(newInputValue, productObject.label_name, metricsObject, distanceOptionNames);
                                                                                    setGeneralInfoChangesMade(true);
                                                                                },
                                                                                sx: {
                                                                                    width: 250
                                                                                },
                                                                                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                                        ...params,
                                                                                        variant: "standard",
                                                                                        label: "Distance",
                                                                                        autoComplete: "off",
                                                                                        id: key,
                                                                                        name: key
                                                                                    })
                                                                            })
                                                                        }, "distance_option")
                                                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                        align: "left",
                                                                        sx: {
                                                                            fontFamily: "Mulish",
                                                                            width: "200px"
                                                                        }
                                                                    }),
                                                                    showDoubleTake && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                        align: "left",
                                                                        sx: {
                                                                            fontFamily: "Mulish",
                                                                            width: "200px"
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                                            title: (0, $abZpG.getDoubleTakeDisabledReason)(metricsObject) ?? "",
                                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                                                    checked: Boolean(metricsObject.vlm_enabled),
                                                                                    color: "warning",
                                                                                    disabled: (0, $abZpG.getDoubleTakeDisabledReason)(metricsObject) !== null,
                                                                                    inputProps: {
                                                                                        "aria-label": `DoubleTake ${metricsObject.display_name}`
                                                                                    },
                                                                                    onChange: (event)=>{
                                                                                        handleToggleDoubleTake(productObject.label_name, metricsObject.label_name, event.target.checked);
                                                                                    }
                                                                                })
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            }, key);
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        }, productObject.name);
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("5bqo6", function(module, exports) {

$parcel$export(module.exports, "switchCreator", () => $40bebb0af83ac63a$export$faea4228d9d4a990);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $ddLR4 = parcelRequire("ddLR4");

var $84usX = parcelRequire("84usX");

var $dLErb = parcelRequire("dLErb");
const $40bebb0af83ac63a$var$disabledChecker = (labelName, selectedGroups, allowConcurrentLineCrossingIntruderProducts = false)=>{
    const intruderMotionConflict = selectedGroups.intruder.selected && selectedGroups.motionPlus.selected;
    const trioCount = (0, $dLErb.trioActiveProductCount)(selectedGroups);
    if (labelName === "intruder" || labelName === "vehicle" || labelName === "bike") {
        if (allowConcurrentLineCrossingIntruderProducts) {
            if (intruderMotionConflict) return selectedGroups.intruder.disabled;
            return selectedGroups.intruder.disabled || selectedGroups.motionPlus.selected;
        }
        if (trioCount >= 2 && selectedGroups.intruder.selected) return selectedGroups.intruder.disabled;
        if (trioCount === 2 && !selectedGroups.intruder.selected) return true;
        return selectedGroups.intruder.disabled || selectedGroups.motionPlus.selected || selectedGroups.lineCrossing.selected;
    } else if (labelName === "intruder_plus" || labelName === "vehicle_plus" || labelName === "bike_plus") return selectedGroups.intruderPlus.disabled;
    else if (labelName === "intruder_motion" || labelName === "vehicle_motion" || labelName === "bike_motion") {
        if (allowConcurrentLineCrossingIntruderProducts) {
            if (intruderMotionConflict) return false;
            return selectedGroups.intruder.selected;
        }
        if (trioCount >= 2 && selectedGroups.motionPlus.selected) return false;
        if (trioCount === 2 && !selectedGroups.motionPlus.selected) return true;
        return selectedGroups.intruder.selected || selectedGroups.lineCrossing.selected;
    } else if (labelName === "intruder_line_crossing" || labelName === "vehicle_line_crossing") {
        if (allowConcurrentLineCrossingIntruderProducts) return false;
        if (trioCount >= 2 && selectedGroups.lineCrossing.selected) return false;
        if (trioCount === 2 && !selectedGroups.lineCrossing.selected) return true;
        return selectedGroups.intruder.selected || selectedGroups.motionPlus.selected;
    } else return false;
};
const $40bebb0af83ac63a$export$faea4228d9d4a990 = (object, selectedGroups, groupLabelName, setSelectedGroups, setLocalProductsData, setProductsData, setGeneralInfoChangesMade, allowConcurrentLineCrossingIntruderProducts = false)=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
        checked: selectedGroups[groupLabelName][object.label_name],
        color: "warning",
        disabled: $40bebb0af83ac63a$var$disabledChecker(object.label_name, selectedGroups, allowConcurrentLineCrossingIntruderProducts),
        onChange: (event)=>{
            // update productsData and localProductsData with the new active state
            setLocalProductsData((previousState)=>{
                //find the index of the product from the previous state whos label_name matches labelName
                const updatedProducts = [
                    ...previousState
                ];
                const productIndex = updatedProducts.findIndex((product)=>product.label_name === groupLabelName);
                const updatedProduct = updatedProducts[productIndex];
                const metric = updatedProduct.metrics[object.label_name];
                metric.active = event.target.checked;
                if (event.target.checked && (0, $84usX.shouldApplyAutopatrolHighSensitivityDefault)()) (0, $84usX.applyDefaultHighSensitivityIfUnset)(metric);
                updatedProducts[productIndex] = updatedProduct;
                return updatedProducts;
            });
            setProductsData((previousState)=>{
                const updatedProducts = [
                    ...previousState
                ];
                const productIndex = updatedProducts.findIndex((product)=>product.label_name === groupLabelName);
                const updatedProduct = updatedProducts[productIndex];
                const metric = updatedProduct.metrics[object.label_name];
                metric.active = event.target.checked;
                if (event.target.checked && (0, $84usX.shouldApplyAutopatrolHighSensitivityDefault)()) (0, $84usX.applyDefaultHighSensitivityIfUnset)(metric);
                updatedProducts[productIndex] = updatedProduct;
                return updatedProducts;
            });
            setGeneralInfoChangesMade(true);
            if (event.target.checked) setSelectedGroups((previousState)=>{
                const updatedState = {
                    ...previousState
                };
                const updatedMetric = updatedState[groupLabelName];
                updatedMetric[object.label_name] = event.target.checked;
                updatedMetric.selected = event.target.checked;
                if (groupLabelName === "intruder") {
                    if (!updatedState.intruderPlus.intruder_plus && !updatedState.intruderPlus.intruder_plus && !updatedState.intruderPlus.vehicle_plus) updatedState.intruderPlus.disabled = true;
                }
                if (groupLabelName === "intruderPlus") {
                    if (!updatedState.intruder.bike && !updatedState.intruder.vehicle && !updatedState.intruder.intruder) updatedState.intruder.disabled = true;
                }
                if (groupLabelName === "motionPlus" || !allowConcurrentLineCrossingIntruderProducts && groupLabelName === "lineCrossing") updatedState.intruder.disabled = true;
                updatedState[groupLabelName] = updatedMetric;
                return updatedState;
            });
            if (!event.target.checked) setSelectedGroups((previousState)=>{
                const updatedState = {
                    ...previousState
                };
                const updatedMetric = updatedState[groupLabelName];
                let anyMetricTrue = false;
                for(const key in updatedMetric)if (updatedMetric[key] && key !== object.label_name && key !== "selected" && key !== "disabled") anyMetricTrue = true;
                if (!anyMetricTrue) updatedMetric.selected = false;
                if (groupLabelName === "intruder" && !anyMetricTrue) updatedState.intruderPlus.disabled = false;
                if (groupLabelName === "intruderPlus" && !anyMetricTrue) updatedState.intruder.disabled = false;
                if (groupLabelName === "motionPlus" && !anyMetricTrue && !updatedState.intruderPlus.selected && (!allowConcurrentLineCrossingIntruderProducts ? !updatedState.lineCrossing.selected : true)) updatedState.intruder.disabled = false;
                if (!allowConcurrentLineCrossingIntruderProducts && groupLabelName === "lineCrossing" && !anyMetricTrue && !updatedState.intruderPlus.selected && !updatedState.motionPlus.selected) updatedState.intruder.disabled = false;
                updatedMetric[object.label_name] = event.target.checked;
                updatedState[groupLabelName] = updatedMetric;
                return updatedState;
            });
        // if (event.target.checked) {
        // }
        // if (event.target.checked) {
        //   if (
        //     object.label_name !== "vehicle_plus" &&
        //     object.label_name !== "bike_plus"
        //   ) {
        //     setProductsData((previousState: any) => {
        //       const updatedProducts = [...previousState];
        //       updatedProducts[productIndex].active = true;
        //       return updatedProducts;
        //     });
        //     setLocalProductsData((previousState: any) => {
        //       const updatedProducts = [...previousState];
        //       updatedProducts[productIndex].active = true;
        //       return updatedProducts;
        //     });
        //     switchDisabler(
        //       productsData[productIndex].metrics[productMetricsIndex]
        //         .display_name,
        //       event.target.checked,
        //       intruderDisabled,
        //       intruderPlusDisabled,
        //       setIntruderDisabled,
        //       setIntruderPlusDisabled,
        //       disabledProducts,
        //       setDisabledProducts
        //     );
        //   } else {
        //     setProductsData((previousState: any) => {
        //       const updatedProducts = [...previousState];
        //       updatedProducts[1].active = true;
        //       return updatedProducts;
        //     });
        //     setLocalProductsData((previousState: any) => {
        //       const updatedProducts = [...previousState];
        //       updatedProducts[1].active = true;
        //       return updatedProducts;
        //     });
        //     switchDisabler(
        //       productsData[1].metrics[productMetricsIndex].display_name,
        //       event.target.checked,
        //       intruderDisabled,
        //       intruderPlusDisabled,
        //       setIntruderDisabled,
        //       setIntruderPlusDisabled,
        //       disabledProducts,
        //       setDisabledProducts
        //     );
        //   }
        // }
        // if (!event.target.checked) {
        //   let anyMetricTrue = false;
        //   productsData[productIndex].metrics.forEach((metric: any) => {
        //     if (
        //       metric.active &&
        //       metric.label_name !==
        //         productsData[productIndex].metrics[productMetricsIndex]
        //           .label_name
        //     ) {
        //       anyMetricTrue = true;
        //     }
        //   });
        //   if (!anyMetricTrue) {
        //     setProductsData((previousState: any) => {
        //       const updatedProducts = [...previousState];
        //       updatedProducts[productIndex].active = false;
        //       return updatedProducts;
        //     });
        //     setLocalProductsData((previousState: any) => {
        //       const updatedProducts = [...previousState];
        //       updatedProducts[productIndex].active = false;
        //       return updatedProducts;
        //     });
        //   }
        //   switchDisabler(
        //     productsData[productIndex].metrics[productMetricsIndex]
        //       .display_name,
        //     event.target.checked,
        //     intruderDisabled,
        //     intruderPlusDisabled,
        //     setIntruderDisabled,
        //     setIntruderPlusDisabled,
        //     disabledProducts,
        //     setDisabledProducts
        //   );
        // }
        // if (
        //   object.label_name !== "vehicle_plus" &&
        //   object.label_name !== "bike_plus"
        // ) {
        //   setPatchObject((previousState: any) => {
        //     return {
        //       ...previousState,
        //       streams: [
        //         handlePatchActiveProducts(event.target.checked, metricIndex),
        //       ],
        //     };
        //   });
        //   setLocalProductsData((previousState: any) => {
        //     const updatedProducts = [...previousState];
        //     updatedProducts[productIndex].metrics[productMetricsIndex].active =
        //       event.target.checked;
        //     return updatedProducts;
        //   });
        //   setProductsData((previousState: any) => {
        //     const updatedProducts = [...previousState];
        //     updatedProducts[productIndex].metrics[productMetricsIndex].active =
        //       event.target.checked;
        //     return updatedProducts;
        //   });
        // } else if (object.label_name === "vehicle_plus") {
        //   console.log("selectedProducts", selectedProducts);
        //   setPatchObject((previousState: any) => {
        //     return {
        //       ...previousState,
        //       streams: [
        //         handlePatchActiveProducts(event.target.checked, metricIndex),
        //       ],
        //     };
        //   });
        //   if (!selectedProducts.intruder_plus && !selectedProducts.bike_plus) {
        //     setLocalProductsData((previousState: any) => {
        //       const updatedProducts = [...previousState];
        //       updatedProducts[1].active = event.target.checked;
        //       return updatedProducts;
        //     });
        //     setProductsData((previousState: any) => {
        //       const updatedProducts = [...previousState];
        //       updatedProducts[1].active = event.target.checked;
        //       return updatedProducts;
        //     });
        //   }
        // } else if (object.label_name === "bike_plus") {
        //   setPatchObject((previousState: any) => {
        //     return {
        //       ...previousState,
        //       streams: [
        //         handlePatchActiveProducts(event.target.checked, metricIndex),
        //       ],
        //     };
        //   });
        //   if (
        //     !selectedProducts.intruder_plus &&
        //     !selectedProducts.vehicle_plus
        //   ) {
        //     setLocalProductsData((previousState: any) => {
        //       const updatedProducts = [...previousState];
        //       updatedProducts[1].active = event.target.checked;
        //       return updatedProducts;
        //     });
        //     setProductsData((previousState: any) => {
        //       const updatedProducts = [...previousState];
        //       updatedProducts[1].active = event.target.checked;
        //       return updatedProducts;
        //     });
        //   }
        // }
        // setGeneralInfoChangesMade(true);
        }
    });
};

});
parcelRegister("84usX", function(module, exports) {

$parcel$export(module.exports, "applyDefaultHighSensitivityIfUnset", () => $051fdb321fb2366f$export$4cc6db142209db84);
$parcel$export(module.exports, "shouldApplyAutopatrolHighSensitivityDefault", () => $051fdb321fb2366f$export$ff939f053e2d706a);
$parcel$export(module.exports, "resolveMetricOptionIdForSubmit", () => $051fdb321fb2366f$export$f08b71e9a619ee65);

var $aZxZ3 = parcelRequire("aZxZ3");
const $051fdb321fb2366f$export$44fefbba42b85a4b = "High (more sensitive)";
const $051fdb321fb2366f$export$382b494201f4e3e3 = (optionId)=>optionId !== null && optionId !== undefined && optionId !== "";
const $051fdb321fb2366f$export$63fedca485fd27c = (options)=>{
    if (!Array.isArray(options)) return null;
    const highOption = options.find((option)=>Array.isArray(option) && option[0] === $051fdb321fb2366f$export$44fefbba42b85a4b && option[1] !== undefined);
    return Array.isArray(highOption) ? highOption[1] : null;
};
const $051fdb321fb2366f$export$4cc6db142209db84 = (metric)=>{
    if ($051fdb321fb2366f$export$382b494201f4e3e3(metric.option_id)) return;
    const highOptionId = $051fdb321fb2366f$export$63fedca485fd27c(metric.options);
    if (highOptionId !== null) metric.option_id = highOptionId;
};
const $051fdb321fb2366f$export$ff939f053e2d706a = ()=>{
    const { siteInfoEditCamera: siteInfoEditCamera, vCHOnlySite: vCHOnlySite } = (0, $aZxZ3.useEditCameraStore).getState();
    return siteInfoEditCamera?.integration_type_name === "autopatrol" && !vCHOnlySite;
};
const $051fdb321fb2366f$var$getMediumOrFirstOptionId = (options)=>{
    if (!Array.isArray(options)) return null;
    const mediumOption = options.find((option)=>Array.isArray(option) && typeof option[0] === "string" && option[0].toLowerCase() === "medium");
    if (Array.isArray(mediumOption) && mediumOption[1] !== undefined) return mediumOption[1];
    const firstOption = options.find((option)=>Array.isArray(option) && option[1] !== undefined);
    return Array.isArray(firstOption) ? firstOption[1] : null;
};
const $051fdb321fb2366f$export$f08b71e9a619ee65 = (currentMetric, previousMetric, isPostRequest, applyAutopatrolHighSensitivityDefault)=>{
    if ($051fdb321fb2366f$export$382b494201f4e3e3(currentMetric.option_id)) return currentMetric.option_id;
    if (isPostRequest && currentMetric.option_id === undefined) {
        if ($051fdb321fb2366f$export$382b494201f4e3e3(previousMetric?.option_id)) return previousMetric?.option_id;
    }
    if (applyAutopatrolHighSensitivityDefault && currentMetric.active) {
        const highOptionId = $051fdb321fb2366f$export$63fedca485fd27c(currentMetric.options ?? previousMetric?.options);
        if (highOptionId !== null) return highOptionId;
    }
    if (isPostRequest) return $051fdb321fb2366f$var$getMediumOrFirstOptionId(currentMetric.options ?? previousMetric?.options);
    return currentMetric.option_id;
};

});

parcelRegister("dLErb", function(module, exports) {

$parcel$export(module.exports, "trioActiveProductCount", () => $a05ea3f47d8a4972$export$19aac6cc1d7a4e49);
$parcel$export(module.exports, "trioMutualExclusionRecoveryMode", () => $a05ea3f47d8a4972$export$d081828f854acc6);
$parcel$export(module.exports, "trioMutualExclusionRecoveryModeFromApiFlags", () => $a05ea3f47d8a4972$export$4cd0aa61b1c38634);
$parcel$export(module.exports, "shouldDisableIntruderForActiveProducts", () => $a05ea3f47d8a4972$export$c3f352c3ddfb0c7b);
/**
 * Product exclusion rules for Intruder, Motion Plus, and Line Crossing.
 *
 * When `allowConcurrentLineCrossingIntruderProducts` is false (legacy):
 * all three products are mutually exclusive.
 *
 * When true: only Intruder and Motion Plus are mutually exclusive; Line Crossing
 * can run with either product.
 */ function $a05ea3f47d8a4972$export$19aac6cc1d7a4e49(selectedGroups) {
    return Number(!!selectedGroups.intruder.selected) + Number(!!selectedGroups.motionPlus.selected) + Number(!!selectedGroups.lineCrossing.selected);
}
function $a05ea3f47d8a4972$export$d081828f854acc6(selectedGroups, allowConcurrentLineCrossingIntruderProducts = false) {
    if (allowConcurrentLineCrossingIntruderProducts) return selectedGroups.intruder.selected && selectedGroups.motionPlus.selected;
    return $a05ea3f47d8a4972$export$19aac6cc1d7a4e49(selectedGroups) >= 2;
}
function $a05ea3f47d8a4972$export$4cd0aa61b1c38634(baseIntruderActive, motionPlusActive, lineCrossingActive, allowConcurrentLineCrossingIntruderProducts = false) {
    if (allowConcurrentLineCrossingIntruderProducts) return baseIntruderActive && motionPlusActive;
    const activeCount = Number(baseIntruderActive) + Number(motionPlusActive) + Number(lineCrossingActive);
    return activeCount >= 2;
}
function $a05ea3f47d8a4972$export$c3f352c3ddfb0c7b(motionPlusActive, lineCrossingActive, allowConcurrentLineCrossingIntruderProducts) {
    return motionPlusActive || !allowConcurrentLineCrossingIntruderProducts && lineCrossingActive;
}

});


parcelRegister("8Izxp", function(module, exports) {

$parcel$export(module.exports, "handleProductMasterSwitchEvent", () => $6a625988482af002$export$6d81c789ffc7aad2);
parcelRequire("8T3gX");

var $84usX = parcelRequire("84usX");
const $6a625988482af002$export$6d81c789ffc7aad2 = (setLocalProductsData, setProductsData, event, productObject)=>{
    let objectIndex = 0;
    setLocalProductsData((previousState)=>{
        const updatedLocalProductsData = [
            ...previousState
        ];
        objectIndex = updatedLocalProductsData.findIndex((product)=>product.label_name === productObject.label_name && product.name === productObject.name);
        // update the local products data by using a for in loop to iterate through the metrics object
        for(const key in updatedLocalProductsData[objectIndex].metrics){
            const metric = updatedLocalProductsData[objectIndex].metrics[key];
            metric.active = event.target.checked;
            if (event.target.checked && (0, $84usX.shouldApplyAutopatrolHighSensitivityDefault)()) (0, $84usX.applyDefaultHighSensitivityIfUnset)(metric);
        }
        updatedLocalProductsData[objectIndex].open = true;
        return updatedLocalProductsData;
    });
    setProductsData((previousState)=>{
        const updatedProductsData = [
            ...previousState
        ];
        objectIndex = updatedProductsData.findIndex((product)=>product.label_name === productObject.label_name && product.name === productObject.name);
        for(const key in updatedProductsData[objectIndex].metrics){
            const metric = updatedProductsData[objectIndex].metrics[key];
            metric.active = event.target.checked;
            if (event.target.checked && (0, $84usX.shouldApplyAutopatrolHighSensitivityDefault)()) (0, $84usX.applyDefaultHighSensitivityIfUnset)(metric);
        }
        updatedProductsData[objectIndex].open = true;
        return updatedProductsData;
    });
};

});

parcelRegister("jIHXr", function(module, exports) {

$parcel$export(module.exports, "handleCheckForDisabledProducts", () => $da7750e67e1caab8$export$5692ab2fa263e65d);
parcelRequire("8T3gX");

var $dLErb = parcelRequire("dLErb");
const $da7750e67e1caab8$export$5692ab2fa263e65d = (productsData, setSelectedGroups, allowConcurrentLineCrossingIntruderProducts = false)=>{
    const productsActive = {
        intruder: false,
        bike: false,
        vehicle: false,
        intruder_plus: false,
        bike_plus: false,
        vehicle_plus: false,
        intruder_motion: false,
        bike_motion: false,
        vehicle_motion: false,
        intruder_line_crossing: false,
        vehicle_line_crossing: false
    };
    productsData.forEach((product)=>{
        const metrics = product.metrics;
        for(const key in metrics){
            if (key === "intruder") productsActive.intruder = metrics[key].active;
            else if (key === "intruder_plus") productsActive.intruder_plus = metrics[key].active;
            else if (key === "bike") productsActive.bike = metrics[key].active;
            else if (key === "bike_plus") productsActive.bike_plus = metrics[key].active;
            else if (key === "vehicle") productsActive.vehicle = metrics[key].active;
            else if (key === "vehicle_plus") productsActive.vehicle_plus = metrics[key].active;
            else if (key === "intruder_motion") productsActive.intruder_motion = metrics[key].active;
            else if (key === "bike_motion") productsActive.bike_motion = metrics[key].active;
            else if (key === "vehicle_motion") productsActive.vehicle_motion = metrics[key].active;
            else if (key === "intruder_line_crossing") productsActive.intruder_line_crossing = metrics[key].active;
            else if (key === "vehicle_line_crossing") productsActive.vehicle_line_crossing = metrics[key].active;
        }
    });
    const baseIntruderActive = productsActive.intruder || productsActive.bike || productsActive.vehicle;
    const intruderPlusActive = productsActive.intruder_plus || productsActive.bike_plus || productsActive.vehicle_plus;
    const motionPlusActive = productsActive.intruder_motion || productsActive.bike_motion || productsActive.vehicle_motion;
    const lineCrossingActive = productsActive.intruder_line_crossing || productsActive.vehicle_line_crossing;
    const trioConflictFromApi = (0, $dLErb.trioMutualExclusionRecoveryModeFromApiFlags)(baseIntruderActive, motionPlusActive, lineCrossingActive, allowConcurrentLineCrossingIntruderProducts);
    setSelectedGroups((previousState)=>{
        const updatedSelectedGroups = {
            ...previousState
        };
        updatedSelectedGroups.intruderPlus.disabled = baseIntruderActive;
        updatedSelectedGroups.intruder.disabled = intruderPlusActive || !trioConflictFromApi && (0, $dLErb.shouldDisableIntruderForActiveProducts)(motionPlusActive, lineCrossingActive, allowConcurrentLineCrossingIntruderProducts);
        updatedSelectedGroups.intruder.intruder = productsActive.intruder;
        updatedSelectedGroups.intruder.bike = productsActive.bike;
        updatedSelectedGroups.intruder.vehicle = productsActive.vehicle;
        updatedSelectedGroups.intruderPlus.intruder_plus = productsActive.intruder_plus;
        updatedSelectedGroups.intruderPlus.bike_plus = productsActive.bike_plus;
        updatedSelectedGroups.intruderPlus.vehicle_plus = productsActive.vehicle_plus;
        return updatedSelectedGroups;
    });
};

});

parcelRegister("6CNXS", function(module, exports) {

$parcel$export(module.exports, "createIntruderToggle", () => $519fe98eb5fa4a09$export$f1bfe45ee88d16d6);

var $k4ank = parcelRequire("k4ank");

var $ddLR4 = parcelRequire("ddLR4");
var $cVCJe = parcelRequire("cVCJe");
parcelRequire("8T3gX");

var $8Izxp = parcelRequire("8Izxp");

var $dLErb = parcelRequire("dLErb");
const $519fe98eb5fa4a09$export$f1bfe45ee88d16d6 = (selectedGroups, setSelectedGroups, setLocalProductsData, setProductsData, setGeneralInfoChangesMade, productObject, allowConcurrentLineCrossingIntruderProducts = false)=>{
    if (!allowConcurrentLineCrossingIntruderProducts) {
        const trioCount = (0, $dLErb.trioActiveProductCount)(selectedGroups);
        if (trioCount === 2 && !selectedGroups.intruder.selected) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
            title: "Motion Plus and Line Crossing are enabled. Turn one off before enabling Intruder.",
            placement: "top",
            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                    checked: false,
                    color: "warning",
                    disabled: true
                })
            })
        });
    }
    const trioRecoveryMode = (0, $dLErb.trioMutualExclusionRecoveryMode)(selectedGroups, allowConcurrentLineCrossingIntruderProducts);
    const trioCount = (0, $dLErb.trioActiveProductCount)(selectedGroups);
    const allowIntruderDespiteTrioOverlap = allowConcurrentLineCrossingIntruderProducts ? trioRecoveryMode && selectedGroups.intruder.selected : trioCount >= 3 || trioCount === 2 && selectedGroups.intruder.selected;
    const blockers = [];
    const intruderPlusBlocking = selectedGroups.intruderPlus.selected || !allowIntruderDespiteTrioOverlap && selectedGroups.intruder.disabled;
    if (intruderPlusBlocking) blockers.push("Intruder Plus");
    if (!allowIntruderDespiteTrioOverlap && selectedGroups.motionPlus.selected) blockers.push("Motion Plus");
    if (!allowConcurrentLineCrossingIntruderProducts && !allowIntruderDespiteTrioOverlap && selectedGroups.lineCrossing.selected) blockers.push("Line Crossing");
    if (blockers.length > 0) {
        const blockerText = blockers.length === 1 ? blockers[0] : blockers.length === 2 ? `${blockers[0]} or ${blockers[1]}` : `${blockers[0]}, ${blockers[1]}, or ${blockers[2]}`;
        return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
            title: `Intruder can not be run with ${blockerText} enabled. To enable Intruder, please toggle off ${blockerText}.`,
            placement: "top",
            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                    checked: selectedGroups.intruder.selected,
                    color: "warning",
                    disabled: true
                })
            })
        });
    }
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
        checked: selectedGroups.intruder.selected,
        color: "warning",
        disabled: false,
        onChange: (event)=>{
            if (!event.target.checked) setSelectedGroups((previousState)=>{
                return {
                    ...previousState,
                    intruder: {
                        selected: false,
                        disabled: previousState.intruder.disabled,
                        intruder: false,
                        bike: false,
                        vehicle: false
                    },
                    intruderPlus: {
                        selected: previousState.intruderPlus.selected,
                        disabled: selectedGroups.intruderPlus.selected,
                        intruder_plus: previousState.intruderPlus.intruder_plus,
                        bike_plus: previousState.intruderPlus.bike_plus,
                        vehicle_plus: previousState.intruderPlus.vehicle_plus
                    }
                };
            });
            if (event.target.checked) setSelectedGroups((previousState)=>{
                return {
                    ...previousState,
                    intruder: {
                        selected: true,
                        disabled: previousState.intruder.disabled,
                        intruder: true,
                        bike: true,
                        vehicle: true
                    },
                    intruderPlus: {
                        selected: previousState.intruderPlus.selected,
                        disabled: !selectedGroups.intruderPlus.selected,
                        intruder_plus: previousState.intruderPlus.intruder_plus,
                        bike_plus: previousState.intruderPlus.bike_plus,
                        vehicle_plus: previousState.intruderPlus.vehicle_plus
                    }
                };
            });
            (0, $8Izxp.handleProductMasterSwitchEvent)(setLocalProductsData, setProductsData, event, productObject);
            setGeneralInfoChangesMade(true);
        }
    });
};

});

parcelRegister("19GR5", function(module, exports) {

$parcel$export(module.exports, "AddHealthMonitoringDialog", () => $87ff1ab97187c240$export$cc77c7ea51ca02c0);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $8jTCz = parcelRequire("8jTCz");

var $aZxZ3 = parcelRequire("aZxZ3");
const $87ff1ab97187c240$export$cc77c7ea51ca02c0 = ()=>{
    const { addHealthMonitoringDialogOpen: addHealthMonitoringDialogOpen, setAddHealthMonitoringDialogOpen: setAddHealthMonitoringDialogOpen } = (0, $aZxZ3.useEditCameraStore)();
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: addHealthMonitoringDialogOpen,
        onClose: ()=>{},
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-mulish text-[18px] pt-[20px]",
                        children: "The site for this camera does currently not have camera health monitoring enabled."
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                        className: "font-mulish text-[18px]",
                        children: [
                            "Note: If Camera Health Monitoring has not been previously enabled for this site, turning it on for this camera will enable it for",
                            " ",
                            /*#__PURE__*/ (0, $k4ank.jsx)("strong", {
                                children: "all cameras"
                            }),
                            " on the site."
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-mulish text-[18px]",
                        children: "Once health monitoring is enabled on all cameras you can disable it for each camera individually."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                    onClick: ()=>{
                        setAddHealthMonitoringDialogOpen(false);
                    },
                    text: "Ok",
                    disabled: false
                })
            })
        ]
    });
};

});


parcelRegister("pQI3G", function(module, exports) {

$parcel$export(module.exports, "AxisTab", () => $26143313a4f75b58$export$a84a0e421f146a34);

var $k4ank = parcelRequire("k4ank");

var $3QMQN = parcelRequire("3QMQN");
var $f3puC = parcelRequire("f3puC");

var $8T3gX = parcelRequire("8T3gX");

var $ewxEl = parcelRequire("ewxEl");

var $g987h = parcelRequire("g987h");

var $9rEUz = parcelRequire("9rEUz");

var $83QTP = parcelRequire("83QTP");

var $g8Pav = parcelRequire("g8Pav");

var $60vL1 = parcelRequire("60vL1");

var $7Rd0f = parcelRequire("7Rd0f");

var $a8BPe = parcelRequire("a8BPe");

var $6LVwH = parcelRequire("6LVwH");
const $26143313a4f75b58$export$cfcbaf3b30f35fed = ({ ruleJob: ruleJob })=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $3QMQN.default), {
        severity: ruleJob.severity,
        icon: ruleJob.phase === "pending" ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
            color: "inherit",
            size: 20
        }) : undefined,
        sx: {
            fontFamily: "Mulish",
            marginTop: 1
        },
        "data-testid": "axis-rule-job-alert",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                children: ruleJob.message
            }),
            ruleJob.details.map((line)=>/*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    children: line
                }, line))
        ]
    });
const $26143313a4f75b58$export$a84a0e421f146a34 = ({ recipientsConfiguredData: recipientsConfiguredData, titlesArray: titlesArray, navigate: navigate, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setRecipientsConfiguredData: setRecipientsConfiguredData, setTitlesArray: setTitlesArray, actionRulesData: actionRulesData, setActionRulesData: setActionRulesData, actionRulesTitlesArray: actionRulesTitlesArray, setActionRulesTitlesArray: setActionRulesTitlesArray, setActiveTab: setActiveTab, applicationsConfiguredData: applicationsConfiguredData, cameraGeneralInfo: cameraGeneralInfo, axisFinished: axisFinished })=>{
    const currentCameraInfo = cameraGeneralInfo;
    const motionOff = (0, $7Rd0f.useMotionOff)(currentCameraInfo?.id);
    // ENG-2822: keyed by the camera in the URL, as the Axis requests are.
    const deviceKey = String((0, $a8BPe.editCameraIdFromUrl)() || currentCameraInfo?.id);
    const unreachableMessage = (0, $6LVwH.useAxisDeviceJobStore)((state)=>state.unreachable[deviceKey]);
    const ruleJob = (0, $6LVwH.useAxisDeviceJobStore)((state)=>state.ruleJobs[deviceKey]);
    // const {recipientsConfiguredDataZustand}: any = useAxisTabStore()
    const [actionRulesTable, setActionRulesTable] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(/*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "pl-[20px] flex",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                className: "mr-2",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                    color: "primary",
                    size: 30
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                className: "pl-[10px] pt-[5px]",
                children: "Loading Data..."
            })
        ]
    }));
    // const { fetchRecipientsConfiguredData }: any = useAxisTabStore();
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (axisFinished.actionRules) // fetchRecipientsConfiguredData()
        setActionRulesTable(/*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            children: [
                " ",
                axisFinished.recipient && axisFinished.actionRules && axisFinished.application && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "absolute top-[15px] left-[150px]",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $7Rd0f.MotionRuleButton), {
                        vendor: "Axis",
                        motionOff: motionOff,
                        onClick: ()=>{
                            setBackdropLoadingScreenOn(true);
                            (0, $83QTP.handleAddAxisActionRule)(currentCameraInfo.id, navigate, setBackdropLoadingScreenOn, setActionRulesData, setActionRulesTitlesArray, setRecipientsConfiguredData, setTitlesArray, setActiveTab, recipientsConfiguredData, titlesArray, actionRulesData, actionRulesTitlesArray, applicationsConfiguredData, cameraGeneralInfo, axisFinished);
                        },
                        text: "+ Add Action Rule"
                    })
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $g987h.ActionRulesTable), {
                    actionRulesData: actionRulesData,
                    setActionRulesData: setActionRulesData,
                    setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                    actionRulesTitlesArray: actionRulesTitlesArray,
                    setActionRulesTitlesArray: setActionRulesTitlesArray,
                    navigate: navigate,
                    setRecipientsConfiguredData: setRecipientsConfiguredData,
                    setTitlesArray: setTitlesArray,
                    setActiveTab: setActiveTab,
                    recipientsConfiguredData: recipientsConfiguredData,
                    titlesArray: titlesArray,
                    applicationsConfiguredData: applicationsConfiguredData,
                    cameraGeneralInfo: cameraGeneralInfo,
                    axisFinished: axisFinished
                })
            ]
        }));
    }, [
        axisFinished,
        motionOff
    ]);
    if (unreachableMessage) // The camera can't be reached from admin's servers (WireGuard site): no
    // tables to show, but Add Action Rule still works — it runs as a Job on
    // the site's network.
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "relative min-w-[1150px] left-[0px] bg-white",
        children: [
            motionOff && /*#__PURE__*/ (0, $k4ank.jsx)((0, $7Rd0f.MotionOffNotice), {
                vendor: "Axis",
                scope: motionOff
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        variant: "h6",
                        gutterBottom: true,
                        component: "div",
                        fontWeight: "bold",
                        sx: {
                            fontFamily: "Mulish",
                            color: "#001943",
                            paddingTop: 2,
                            paddingLeft: 2
                        },
                        children: "Action Rules"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-[15px] left-[150px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $7Rd0f.MotionRuleButton), {
                            vendor: "Axis",
                            motionOff: motionOff,
                            disabled: ruleJob?.phase === "pending",
                            onClick: ()=>{
                                setBackdropLoadingScreenOn(true);
                                (0, $83QTP.handleAddAxisActionRule)(currentCameraInfo.id, navigate, setBackdropLoadingScreenOn, setActionRulesData, setActionRulesTitlesArray, setRecipientsConfiguredData, setTitlesArray, setActiveTab, recipientsConfiguredData, titlesArray, actionRulesData, actionRulesTitlesArray, applicationsConfiguredData, cameraGeneralInfo, axisFinished);
                            },
                            text: "+ Add Action Rule"
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "px-[16px] pb-[16px]",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                                severity: "info",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                "data-testid": "axis-device-unreachable",
                                children: unreachableMessage
                            }),
                            ruleJob && /*#__PURE__*/ (0, $k4ank.jsx)($26143313a4f75b58$export$cfcbaf3b30f35fed, {
                                ruleJob: ruleJob
                            })
                        ]
                    })
                ]
            }, "action_rules")
        ]
    });
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "relative min-w-[1150px] left-[0px] bg-white",
        children: [
            motionOff && /*#__PURE__*/ (0, $k4ank.jsx)((0, $7Rd0f.MotionOffNotice), {
                vendor: "Axis",
                scope: motionOff
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "relative",
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                            variant: "h6",
                            gutterBottom: true,
                            component: "div",
                            fontWeight: "bold",
                            sx: {
                                fontFamily: "Mulish",
                                color: "#001943",
                                paddingTop: 2,
                                paddingLeft: 2,
                                paddingBottom: 1
                            },
                            children: "Recipients Configured"
                        }),
                        axisFinished.recipient && axisFinished.actionRules && axisFinished.application && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "absolute top-[15px] left-[250px]",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $7Rd0f.MotionRuleButton), {
                                vendor: "Axis",
                                motionOff: motionOff,
                                onClick: ()=>{
                                    setBackdropLoadingScreenOn(true);
                                    (0, $9rEUz.handleAddRecipient)(currentCameraInfo.id, navigate, setBackdropLoadingScreenOn, setRecipientsConfiguredData, setTitlesArray, setActiveTab, recipientsConfiguredData, titlesArray, actionRulesData, setActionRulesData, actionRulesTitlesArray, setActionRulesTitlesArray, applicationsConfiguredData, cameraGeneralInfo, axisFinished);
                                },
                                text: "+ Add Recipient"
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $ewxEl.RecipientsConfiguredTable), {
                            recipientsConfiguredData: recipientsConfiguredData,
                            titlesArray: titlesArray,
                            navigate: navigate,
                            setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                            setRecipientsConfiguredData: setRecipientsConfiguredData,
                            setTitlesArray: setTitlesArray,
                            setActiveTab: setActiveTab,
                            actionRulesData: actionRulesData,
                            setActionRulesData: setActionRulesData,
                            actionRulesTitlesArray: actionRulesTitlesArray,
                            setActionRulesTitlesArray: setActionRulesTitlesArray,
                            applicationsConfiguredData: applicationsConfiguredData,
                            cameraGeneralInfo: cameraGeneralInfo,
                            axisFinished: axisFinished
                        })
                    ]
                })
            }, "recipients_configured"),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "relative min-w-[1150px]",
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                            variant: "h6",
                            gutterBottom: true,
                            component: "div",
                            fontWeight: "bold",
                            sx: {
                                fontFamily: "Mulish",
                                color: "#001943",
                                paddingTop: 2,
                                paddingLeft: 2
                            },
                            children: "Action Rules"
                        }),
                        ruleJob && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "px-[16px]",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)($26143313a4f75b58$export$cfcbaf3b30f35fed, {
                                ruleJob: ruleJob
                            })
                        }),
                        actionRulesTable
                    ]
                })
            }, "action_rules"),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                            variant: "h6",
                            gutterBottom: true,
                            component: "div",
                            fontWeight: "bold",
                            sx: {
                                fontFamily: "Mulish",
                                color: "#001943",
                                paddingTop: 2,
                                paddingLeft: 2
                            },
                            children: "Applications Configured"
                        }),
                        axisFinished.application ? /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $g8Pav.ApplicationsConfiguredTable), {
                                applicationsConfiguredData: applicationsConfiguredData
                            })
                        }) : /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "pl-[20px] flex",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                    className: "mr-2",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                        color: "primary",
                                        size: 30
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                    className: "pl-[10px] pt-[5px]",
                                    children: "Loading Data..."
                                })
                            ]
                        })
                    ]
                })
            }, "applications_configured")
        ]
    });
};

});
parcelRegister("ewxEl", function(module, exports) {

$parcel$export(module.exports, "RecipientsConfiguredTable", () => $f62f50faccdcd1c6$export$1401d0ececc189ec);

var $k4ank = parcelRequire("k4ank");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");
parcelRequire("8T3gX");

var $kvMEt = parcelRequire("kvMEt");

var $8jTCz = parcelRequire("8jTCz");

var $84hil = parcelRequire("84hil");

var $60vL1 = parcelRequire("60vL1");
const $f62f50faccdcd1c6$export$1401d0ececc189ec = ({ recipientsConfiguredData: recipientsConfiguredData, titlesArray: titlesArray, navigate: navigate, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setRecipientsConfiguredData: setRecipientsConfiguredData, setTitlesArray: setTitlesArray, setActiveTab: setActiveTab, actionRulesData: actionRulesData, setActionRulesData: setActionRulesData, actionRulesTitlesArray: actionRulesTitlesArray, setActionRulesTitlesArray: setActionRulesTitlesArray, applicationsConfiguredData: applicationsConfiguredData, cameraGeneralInfo: cameraGeneralInfo, axisFinished: axisFinished })=>{
    const currentCameraInfo = JSON.parse(localStorage.currentCameraInfo);
    return axisFinished.recipient ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
            sx: {
                minWidth: 1000,
                fontFamily: "Mulish"
            },
            "aria-label": "simple table",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                    titlesArray: titlesArray
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                    children: recipientsConfiguredData.map((object)=>{
                        return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        minWidth: "125px"
                                    },
                                    children: object.display_name ? object.display_name : "--"
                                }),
                                titlesArray.includes("Recipient Type") && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        minWidth: "136px"
                                    },
                                    children: object.recipient_type ? object.recipient_type : "--"
                                }),
                                titlesArray.includes("Host") && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        minWidth: "200px"
                                    },
                                    children: object.host ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                        children: [
                                            (0, $kvMEt.checkOrX)(object.is_host_ok),
                                            " ",
                                            object.host
                                        ]
                                    }) : "--"
                                }),
                                titlesArray.includes("Port") && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        minWidth: "100px"
                                    },
                                    children: object.port ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                        children: [
                                            (0, $kvMEt.checkOrX)(object.is_port_ok),
                                            " ",
                                            object.port
                                        ]
                                    }) : "--"
                                }),
                                titlesArray.includes("Email From") && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        minWidth: "210px"
                                    },
                                    children: object.email_from ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                        children: [
                                            (0, $kvMEt.checkOrX)(object.is_email_from_ok),
                                            " ",
                                            object.email_from
                                        ]
                                    }) : "--"
                                }),
                                titlesArray.includes("Email To") && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        minWidth: "150px"
                                    },
                                    children: object.email_to ? object.email_to : "--"
                                }),
                                titlesArray.includes("Login") && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        minWidth: "150px"
                                    },
                                    children: object.login ? object.login : "--"
                                }),
                                titlesArray.includes("Password") && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        minWidth: "150px"
                                    },
                                    children: object.password ? object.password : "--"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        minWidth: "100px"
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                        onClick: ()=>{
                                            setBackdropLoadingScreenOn(true);
                                            (0, $84hil.handleDeleteRecipient)(currentCameraInfo.id, object.id, navigate, setBackdropLoadingScreenOn, setRecipientsConfiguredData, setTitlesArray, setActiveTab, recipientsConfiguredData, titlesArray, actionRulesData, setActionRulesData, actionRulesTitlesArray, setActionRulesTitlesArray, applicationsConfiguredData, cameraGeneralInfo, axisFinished);
                                        },
                                        text: "Delete",
                                        disabled: false
                                    })
                                })
                            ]
                        }, object.id);
                    })
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "pl-[20px] flex",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                className: "mr-2",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                    color: "primary",
                    size: 30
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                className: "pl-[10px] pt-[5px]",
                children: "Loading Data..."
            })
        ]
    });
};

});
parcelRegister("kvMEt", function(module, exports) {

$parcel$export(module.exports, "checkOrX", () => $6f4d9ebba36683b1$export$1483394e2b54b4fc);
parcelRequire("8T3gX");

var $lWchQ = parcelRequire("lWchQ");

var $2aMB5 = parcelRequire("2aMB5");
const $6f4d9ebba36683b1$export$1483394e2b54b4fc = (bool)=>{
    if (bool) return 0, $lWchQ.checkedCircleIcon;
    else return 0, $2aMB5.cancelIconRed;
};

});

parcelRegister("84hil", function(module, exports) {

$parcel$export(module.exports, "handleDeleteRecipient", () => $ba6ea701450c0fa1$export$c8b7d670f95d450a);
// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $pQI3G = parcelRequire("pQI3G");

var $3Zv1D = parcelRequire("3Zv1D");
const $ba6ea701450c0fa1$export$c8b7d670f95d450a = (cameraId, recipientId, navigate, setBackdropLoadingScreenOn, setRecipientsConfiguredData, setTitlesArray, setActiveTab, recipientsConfiguredData, titlesArray, actionRulesData, setActionRulesData, actionRulesTitlesArray, setActionRulesTitlesArray, applicationsConfiguredData, cameraGeneralInfo, axisFinished)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $ba6ea701450c0fa1$export$c8b7d670f95d450a(cameraId, recipientId, navigate, setBackdropLoadingScreenOn, setRecipientsConfiguredData, setTitlesArray, setActiveTab, recipientsConfiguredData, titlesArray, actionRulesData, setActionRulesData, actionRulesTitlesArray, setActionRulesTitlesArray, applicationsConfiguredData, cameraGeneralInfo, axisFinished);
    };
    AxiosUI.delete(`/axis/${cameraId}/recipient/${recipientId}/`).then((response)=>{
        setRecipientsConfiguredData(response.data);
        const newTitlesArray = [
            "Name"
        ];
        response.data.forEach((object)=>{
            object.additional_fields.forEach((obj)=>{
                if (obj.id === "recipient_type" && !newTitlesArray.includes("Recipient Type")) newTitlesArray.push("Recipient Type");
                if (obj.id === "host" && !newTitlesArray.includes("Host")) newTitlesArray.push("Host");
                if (obj.id === "port" && !newTitlesArray.includes("Port")) newTitlesArray.push("Port");
                if (obj.id === "email_from" && !newTitlesArray.includes("Email From")) newTitlesArray.push("Email From");
                if (obj.id === "email_to" && !newTitlesArray.includes("Email To")) newTitlesArray.push("Email To");
                if (obj.id === "login" && !newTitlesArray.includes("Login")) newTitlesArray.push("Login");
                if (obj.id === "password" && !newTitlesArray.includes("Password")) newTitlesArray.push("Password");
            });
        });
        newTitlesArray.push("");
        setTitlesArray(newTitlesArray);
        setBackdropLoadingScreenOn(false);
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
            recipientsConfiguredData: response.data,
            titlesArray: newTitlesArray,
            navigate: navigate,
            setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
            setRecipientsConfiguredData: setRecipientsConfiguredData,
            setTitlesArray: setTitlesArray,
            actionRulesData: actionRulesData,
            setActionRulesData: setActionRulesData,
            actionRulesTitlesArray: actionRulesTitlesArray,
            setActionRulesTitlesArray: setActionRulesTitlesArray,
            setActiveTab: setActiveTab,
            applicationsConfiguredData: applicationsConfiguredData,
            cameraGeneralInfo: cameraGeneralInfo,
            axisFinished: axisFinished
        }));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
            alert("Problem deleting recipient, please try again");
        });
    });
};

});


parcelRegister("g987h", function(module, exports) {

$parcel$export(module.exports, "ActionRulesTable", () => $2efb07756e0cf90e$export$50dbb7e3844a9fab);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $kvMEt = parcelRequire("kvMEt");

var $8jTCz = parcelRequire("8jTCz");

var $brRlU = parcelRequire("brRlU");
const $2efb07756e0cf90e$export$50dbb7e3844a9fab = ({ actionRulesData: actionRulesData, setActionRulesData: setActionRulesData, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, actionRulesTitlesArray: actionRulesTitlesArray, setActionRulesTitlesArray: setActionRulesTitlesArray, navigate: navigate, setRecipientsConfiguredData: setRecipientsConfiguredData, setTitlesArray: setTitlesArray, setActiveTab: setActiveTab, recipientsConfiguredData: recipientsConfiguredData, titlesArray: titlesArray, applicationsConfiguredData: applicationsConfiguredData, cameraGeneralInfo: cameraGeneralInfo, axisFinished: axisFinished })=>{
    const currentCameraInfo = JSON.parse(localStorage.currentCameraInfo);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
            sx: {
                minWidth: 1000,
                fontFamily: "Mulish"
            },
            "aria-label": "simple table",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                    titlesArray: actionRulesTitlesArray
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                    children: actionRulesData.map((object)=>{
                        return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                object.is_actuate ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        minWidth: "125px"
                                    },
                                    children: object.display_name ? object.display_name : "--"
                                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        minWidth: "125px",
                                        color: "#7E7F7B"
                                    },
                                    children: object.display_name ? object.display_name : "--"
                                }),
                                object.is_actuate ? actionRulesTitlesArray.includes("Host") && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        minWidth: "150px"
                                    },
                                    children: object.is_host_ok ? (0, $kvMEt.checkOrX)(object.is_host_ok) : "--"
                                }) : actionRulesTitlesArray.includes("Host") && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        minWidth: "150px",
                                        color: "#7E7F7B"
                                    },
                                    children: object.is_host_ok ? (0, $kvMEt.checkOrX)(object.is_host_ok) : "--"
                                }),
                                object.is_actuate ? actionRulesTitlesArray.includes("Port") && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        minWidth: "100px"
                                    },
                                    children: object.port ? object.port : "--"
                                }) : actionRulesTitlesArray.includes("Port") && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        minWidth: "100px",
                                        color: "#7E7F7B"
                                    },
                                    children: object.port ? object.port : "--"
                                }),
                                object.is_actuate ? actionRulesTitlesArray.includes("E-mail to") && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        minWidth: "200px"
                                    },
                                    children: object.email_to ? object.email_to : "--"
                                }) : actionRulesTitlesArray.includes("E-mail to") && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        minWidth: "200px",
                                        color: "#7E7F7B"
                                    },
                                    children: object.email_to ? object.email_to : "--"
                                }),
                                object.is_actuate ? actionRulesTitlesArray.includes("E-mail from") && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        minWidth: "250px"
                                    },
                                    children: object.email_from ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                        children: [
                                            (0, $kvMEt.checkOrX)(object.is_email_from_ok),
                                            " ",
                                            object.email_from
                                        ]
                                    }) : "--"
                                }) : actionRulesTitlesArray.includes("E-mail from") && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        minWidth: "250px",
                                        color: "#7E7F7B"
                                    },
                                    children: object.email_from ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                        children: [
                                            (0, $kvMEt.checkOrX)(object.is_email_from_ok),
                                            " ",
                                            object.email_from
                                        ]
                                    }) : "--"
                                }),
                                object.is_actuate ? actionRulesTitlesArray.includes("Message") && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        minWidth: "150px"
                                    },
                                    children: object.message ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                        children: [
                                            (0, $kvMEt.checkOrX)(object.is_message_ok),
                                            " ",
                                            object.message
                                        ]
                                    }) : "--"
                                }) : actionRulesTitlesArray.includes("Message") && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        minWidth: "150px",
                                        color: "#7E7F7B"
                                    },
                                    children: object.message ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                        children: [
                                            (0, $kvMEt.checkOrX)(object.is_message_ok),
                                            " ",
                                            object.message
                                        ]
                                    }) : "--"
                                }),
                                object.is_actuate ? actionRulesTitlesArray.includes("Enabled") && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        minWidth: "100px"
                                    },
                                    children: object.is_enabled ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                        children: [
                                            (0, $kvMEt.checkOrX)(object.is_enabled),
                                            " ",
                                            object.enabled
                                        ]
                                    }) : "--"
                                }) : actionRulesTitlesArray.includes("Enabled") && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        minWidth: "100px",
                                        color: "#7E7F7B"
                                    },
                                    children: object.is_enabled ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                                        children: (0, $kvMEt.checkOrX)(object.is_enabled)
                                    }) : "--"
                                }),
                                object.is_actuate ? actionRulesTitlesArray.includes("Profile") && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        minWidth: "150px"
                                    },
                                    children: object.is_profile_ok ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                                        children: (0, $kvMEt.checkOrX)(object.is_profile_ok)
                                    }) : "--"
                                }) : actionRulesTitlesArray.includes("Profile") && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        minWidth: "150px",
                                        color: "#7E7F7B"
                                    },
                                    children: object.is_profile_ok ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                                        children: (0, $kvMEt.checkOrX)(object.is_profile_ok)
                                    }) : "--"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        minWidth: "100px"
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                        onClick: ()=>{
                                            setBackdropLoadingScreenOn(true);
                                            (0, $brRlU.handleDeleteAxisActionRule)(currentCameraInfo.id, object.id, navigate, setBackdropLoadingScreenOn, setActionRulesData, setActionRulesTitlesArray, setRecipientsConfiguredData, setTitlesArray, setActiveTab, recipientsConfiguredData, titlesArray, actionRulesData, actionRulesTitlesArray, applicationsConfiguredData, cameraGeneralInfo, axisFinished);
                                        },
                                        text: "Delete",
                                        disabled: false
                                    })
                                })
                            ]
                        }, object.id);
                    })
                })
            ]
        })
    });
};

});
parcelRegister("brRlU", function(module, exports) {

$parcel$export(module.exports, "handleDeleteAxisActionRule", () => $5d9865d48f508b35$export$d7100fcbd61203fe);
// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $pQI3G = parcelRequire("pQI3G");

var $3Zv1D = parcelRequire("3Zv1D");
const $5d9865d48f508b35$export$d7100fcbd61203fe = (cameraId, ruleId, navigate, setBackdropLoadingScreenOn, setActionRulesData, setActionRulesTitlesArray, setRecipientsConfiguredData, setTitlesArray, setActiveTab, recipientsConfiguredData, titlesArray, actionRulesData, actionRulesTitlesArray, applicationsConfiguredData, cameraGeneralInfo, axisFinished)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $5d9865d48f508b35$export$d7100fcbd61203fe(cameraId, ruleId, navigate, setBackdropLoadingScreenOn, setActionRulesData, setActionRulesTitlesArray, setRecipientsConfiguredData, setTitlesArray, setActiveTab, recipientsConfiguredData, titlesArray, actionRulesData, actionRulesTitlesArray, applicationsConfiguredData, cameraGeneralInfo, axisFinished);
    };
    AxiosUI.delete(`/axis/${cameraId}/action_rule/${ruleId}/`).then((response)=>{
        setActionRulesData(response.data);
        const newActionRulesTitlesArray = [
            "Name"
        ];
        response.data.forEach((object)=>{
            object.additional_fields.forEach((obj)=>{
                if (obj.id === "host" && !newActionRulesTitlesArray.includes("Host")) newActionRulesTitlesArray.push("Host");
                if (obj.id === "port" && !newActionRulesTitlesArray.includes("Port")) newActionRulesTitlesArray.push("Port");
                if (obj.id === "email_to" && !newActionRulesTitlesArray.includes("E-mail to")) newActionRulesTitlesArray.push("E-mail to");
                if (obj.id === "email_from" && !newActionRulesTitlesArray.includes("E-mail from")) newActionRulesTitlesArray.push("E-mail from");
                if (obj.id === "message" && !newActionRulesTitlesArray.includes("Message")) newActionRulesTitlesArray.push("Message");
                if (obj.id === "enabled" && !newActionRulesTitlesArray.includes("Enabled")) newActionRulesTitlesArray.push("Enabled");
                if (obj.id === "profile_selected" && !newActionRulesTitlesArray.includes("Profile")) newActionRulesTitlesArray.push("Profile");
            });
        });
        const orderedFinalTitles = [
            "Name"
        ];
        if (!orderedFinalTitles.includes("Host")) orderedFinalTitles.push("Host");
        if (!orderedFinalTitles.includes("Port")) orderedFinalTitles.push("Port");
        if (!orderedFinalTitles.includes("E-mail to")) orderedFinalTitles.push("E-mail to");
        if (!orderedFinalTitles.includes("E-mail from")) orderedFinalTitles.push("E-mail from");
        if (!orderedFinalTitles.includes("Message")) orderedFinalTitles.push("Message");
        if (!orderedFinalTitles.includes("Enabled")) orderedFinalTitles.push("Enabled");
        if (!orderedFinalTitles.includes("Profile")) orderedFinalTitles.push("Profile");
        orderedFinalTitles.push("");
        setActionRulesTitlesArray(orderedFinalTitles);
        setBackdropLoadingScreenOn(false);
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
            // The delete returns the camera's remaining action rules, not its
            // recipients; keep the recipients table as it was (SUP-999).
            recipientsConfiguredData: recipientsConfiguredData,
            titlesArray: titlesArray,
            navigate: navigate,
            setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
            setRecipientsConfiguredData: setRecipientsConfiguredData,
            setTitlesArray: setTitlesArray,
            actionRulesData: response.data,
            setActionRulesData: setActionRulesData,
            actionRulesTitlesArray: orderedFinalTitles,
            setActionRulesTitlesArray: setActionRulesTitlesArray,
            setActiveTab: setActiveTab,
            applicationsConfiguredData: applicationsConfiguredData,
            cameraGeneralInfo: cameraGeneralInfo,
            axisFinished: axisFinished
        }));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
            alert("Problem deleting action rule, please try again");
        });
    });
};

});


parcelRegister("9rEUz", function(module, exports) {

$parcel$export(module.exports, "handleAddRecipient", () => $6f84755d5d070a87$export$422c477347458c35);
// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $pQI3G = parcelRequire("pQI3G");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");

var $3Zv1D = parcelRequire("3Zv1D");
const $6f84755d5d070a87$export$422c477347458c35 = (cameraId, navigate, setBackdropLoadingScreenOn, setRecipientsConfiguredData, setTitlesArray, setActiveTab, recipientsConfiguredData, titlesArray, actionRulesData, setActionRulesData, actionRulesTitlesArray, setActionRulesTitlesArray, applicationsConfiguredData, cameraGeneralInfo, axisFinished)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $6f84755d5d070a87$export$422c477347458c35(cameraId, navigate, setBackdropLoadingScreenOn, setRecipientsConfiguredData, setTitlesArray, setActiveTab, recipientsConfiguredData, titlesArray, actionRulesData, setActionRulesData, actionRulesTitlesArray, setActionRulesTitlesArray, applicationsConfiguredData, cameraGeneralInfo, axisFinished);
    };
    AxiosUI.post(`/axis/${(0, $a8BPe.getNumbersAfterEditCamera)(location.href)}/recipient/`, "{}").then((response)=>{
        if (response.data[0] && response.data[0].message && response.data[0].message.includes("Error retrieving recipients.")) {
            setBackdropLoadingScreenOn(false);
            alert("Problem adding recipient, please try again");
        } else {
            setRecipientsConfiguredData(response.data);
            const newTitlesArray = [
                "Name"
            ];
            response.data.forEach((object)=>{
                object.additional_fields.forEach((obj)=>{
                    if (obj.id === "recipient_type" && !newTitlesArray.includes("Recipient Type")) newTitlesArray.push("Recipient Type");
                    if (obj.id === "host" && !newTitlesArray.includes("Host")) newTitlesArray.push("Host");
                    if (obj.id === "port" && !newTitlesArray.includes("Port")) newTitlesArray.push("Port");
                    if (obj.id === "email_from" && !newTitlesArray.includes("Email From")) newTitlesArray.push("Email From");
                    if (obj.id === "email_to" && !newTitlesArray.includes("Email To")) newTitlesArray.push("Email To");
                    if (obj.id === "login" && !newTitlesArray.includes("Login")) newTitlesArray.push("Login");
                    if (obj.id === "password" && !newTitlesArray.includes("Password")) newTitlesArray.push("Password");
                });
            });
            newTitlesArray.push("");
            setTitlesArray(newTitlesArray);
            setBackdropLoadingScreenOn(false);
            setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
            setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
                recipientsConfiguredData: response.data,
                titlesArray: newTitlesArray,
                navigate: navigate,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setRecipientsConfiguredData: setRecipientsConfiguredData,
                setTitlesArray: setTitlesArray,
                actionRulesData: actionRulesData,
                setActionRulesData: setActionRulesData,
                actionRulesTitlesArray: actionRulesTitlesArray,
                setActionRulesTitlesArray: setActionRulesTitlesArray,
                setActiveTab: setActiveTab,
                applicationsConfiguredData: applicationsConfiguredData,
                cameraGeneralInfo: cameraGeneralInfo,
                axisFinished: axisFinished
            }));
        }
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
            alert("Problem adding recipient, please try again");
        });
    });
};

});

parcelRegister("83QTP", function(module, exports) {

$parcel$export(module.exports, "handleAddAxisActionRule", () => $66d2045893beb0ef$export$3d3597efa71ebbde);
// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $pQI3G = parcelRequire("pQI3G");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");

var $3Zv1D = parcelRequire("3Zv1D");

var $a8BPe = parcelRequire("a8BPe");

var $6LVwH = parcelRequire("6LVwH");
const $66d2045893beb0ef$export$bc94ab9faa08402d = async (cameraId, siteId, dispatch, pollOptions = {})=>{
    const { setRuleJob: setRuleJob } = (0, $6LVwH.useAxisDeviceJobStore).getState();
    setRuleJob(cameraId, {
        phase: "pending",
        severity: "info",
        message: (0, $6LVwH.AXIS_RULE_JOB_PENDING_MESSAGE),
        details: []
    });
    const outcome = await (0, $6LVwH.pollAxisRuleJob)(siteId, dispatch, pollOptions);
    if (outcome === null) return;
    setRuleJob(cameraId, (0, $6LVwH.summarizeAxisRuleJob)(outcome, cameraId));
};
const $66d2045893beb0ef$export$3d3597efa71ebbde = (cameraId, navigate, setBackdropLoadingScreenOn, setActionRulesData, setActionRulesTitlesArray, setRecipientsConfiguredData, setTitlesArray, setActiveTab, recipientsConfiguredData, titlesArray, actionRulesData, actionRulesTitlesArray, applicationsConfiguredData, cameraGeneralInfo, axisFinished, pollOptions = {})=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $66d2045893beb0ef$export$3d3597efa71ebbde(cameraId, navigate, setBackdropLoadingScreenOn, setActionRulesData, setActionRulesTitlesArray, setRecipientsConfiguredData, setTitlesArray, setActiveTab, recipientsConfiguredData, titlesArray, actionRulesData, actionRulesTitlesArray, applicationsConfiguredData, cameraGeneralInfo, axisFinished, pollOptions);
    };
    AxiosUI.post(`/axis/${(0, $a8BPe.getNumbersAfterEditCamera)(location.href)}/action_rule/`, "{}").then((response)=>{
        if (response.status === 202) {
            setBackdropLoadingScreenOn(false);
            $66d2045893beb0ef$export$bc94ab9faa08402d((0, $a8BPe.getNumbersAfterEditCamera)(location.href) || cameraId, (0, $a8BPe.getNumbersAfterSites)(location.href), response.data, pollOptions);
        } else if (response.data[0] && response.data[0].message && response.data[0].message.includes("Error retrieving")) {
            setBackdropLoadingScreenOn(false);
            alert("Problem adding action rule, please try again");
        } else {
            setActionRulesData(response.data);
            const newActionRulesTitlesArray = [
                "Name"
            ];
            response.data.forEach((object)=>{
                object.additional_fields.forEach((obj)=>{
                    if (obj.id === "host" && !newActionRulesTitlesArray.includes("Host")) newActionRulesTitlesArray.push("Host");
                    if (obj.id === "port" && !newActionRulesTitlesArray.includes("Port")) newActionRulesTitlesArray.push("Port");
                    if (obj.id === "email_to" && !newActionRulesTitlesArray.includes("E-mail to")) newActionRulesTitlesArray.push("E-mail to");
                    if (obj.id === "email_from" && !newActionRulesTitlesArray.includes("E-mail from")) newActionRulesTitlesArray.push("E-mail from");
                    if (obj.id === "message" && !newActionRulesTitlesArray.includes("Message")) newActionRulesTitlesArray.push("Message");
                    if (obj.id === "enabled" && !newActionRulesTitlesArray.includes("Enabled")) newActionRulesTitlesArray.push("Enabled");
                    if (obj.id === "profile_selected" && !newActionRulesTitlesArray.includes("Profile")) newActionRulesTitlesArray.push("Profile");
                });
            });
            const orderedFinalTitles = [
                "Name"
            ];
            if (!orderedFinalTitles.includes("Host")) orderedFinalTitles.push("Host");
            if (!orderedFinalTitles.includes("Port")) orderedFinalTitles.push("Port");
            if (!orderedFinalTitles.includes("E-mail to")) orderedFinalTitles.push("E-mail to");
            if (!orderedFinalTitles.includes("E-mail from")) orderedFinalTitles.push("E-mail from");
            if (!orderedFinalTitles.includes("Message")) orderedFinalTitles.push("Message");
            if (!orderedFinalTitles.includes("Enabled")) orderedFinalTitles.push("Enabled");
            if (!orderedFinalTitles.includes("Profile")) orderedFinalTitles.push("Profile");
            orderedFinalTitles.push("");
            setActionRulesTitlesArray(orderedFinalTitles);
            setBackdropLoadingScreenOn(false);
            setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
            setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
                recipientsConfiguredData: recipientsConfiguredData,
                titlesArray: titlesArray,
                navigate: navigate,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setRecipientsConfiguredData: setRecipientsConfiguredData,
                setTitlesArray: setTitlesArray,
                actionRulesData: response.data,
                setActionRulesData: setActionRulesData,
                actionRulesTitlesArray: orderedFinalTitles,
                setActionRulesTitlesArray: setActionRulesTitlesArray,
                setActiveTab: setActiveTab,
                applicationsConfiguredData: applicationsConfiguredData,
                cameraGeneralInfo: cameraGeneralInfo,
                axisFinished: axisFinished
            }));
        }
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
            // The API explains why (e.g. which sensor a multi-sensor camera needs);
            // fall back to the generic text when it doesn't.
            const data = reason.response?.data;
            const apiMessage = Array.isArray(data) ? data[0]?.message : undefined;
            alert(apiMessage || "Problem adding action rule, please try again");
        });
    });
};

});
parcelRegister("6LVwH", function(module, exports) {

$parcel$export(module.exports, "AXIS_RULE_JOB_PENDING_MESSAGE", () => $5ccd9cff12908520$export$50db87c6cc258766);
$parcel$export(module.exports, "axisDeviceUnreachableMessage", () => $5ccd9cff12908520$export$806fd347147e4bcf);
$parcel$export(module.exports, "summarizeAxisRuleJob", () => $5ccd9cff12908520$export$590f4352c5d1c141);
$parcel$export(module.exports, "useAxisDeviceJobStore", () => $5ccd9cff12908520$export$8c77f053e8d0c090);
$parcel$export(module.exports, "pollAxisRuleJob", () => $5ccd9cff12908520$export$5adbd1faf2a470d7);

var $9OjAn = parcelRequire("9OjAn");

var $195EM = parcelRequire("195EM");

var $c8yf1 = parcelRequire("c8yf1");
const $5ccd9cff12908520$export$25e597656af51b13 = "fix_axis_multisensor_rules";
const $5ccd9cff12908520$export$c5ca15ee5b6f55dd = 3000;
const $5ccd9cff12908520$export$4d18e800d33df063 = 40; // ~2 minutes
const $5ccd9cff12908520$export$50db87c6cc258766 = "Adding the action rule from the site's network. This usually takes under a minute.";
const $5ccd9cff12908520$export$8b5053fea863717b = "The action rule job hasn't reported back yet. It may still be running \u2014 check again in a few minutes, or try again.";
const $5ccd9cff12908520$export$3493bad2b09dc248 = "This camera can't be reached from Actuate's servers, so its Axis settings can't be shown here.";
const $5ccd9cff12908520$var$STATUS_LABELS = {
    FIXED: "fixed",
    ALREADY_OK: "already OK",
    FAILED: "failed",
    STALE_LEFT: "old rule left in place",
    UNREACHABLE: "unreachable",
    HOST_REFUSED: "refused by the camera",
    NO_MOTION: "no motion detection",
    NO_SENSOR: "no sensor",
    BAD_SENSOR: "bad sensor",
    DEVICE_BLOCKED: "device blocked",
    SINGLE_SENSOR: "single sensor"
};
const $5ccd9cff12908520$export$c6db34a00108fcec = (status)=>$5ccd9cff12908520$var$STATUS_LABELS[String(status).toUpperCase()] ?? String(status).toLowerCase().replace(/_/g, " ");
const $5ccd9cff12908520$var$capitalize = (text)=>text ? text.charAt(0).toUpperCase() + text.slice(1) : text;
const $5ccd9cff12908520$var$plural = (count, noun)=>`${count} ${noun}${count === 1 ? "" : "s"}`;
const $5ccd9cff12908520$export$806fd347147e4bcf = (reason)=>{
    if (reason?.response?.status !== 409) return null;
    const data = reason.response.data;
    if (Array.isArray(data)) {
        const message = data.find((m)=>m && typeof m.message === "string");
        if (message) return String(message.message);
    } else if (data && typeof data.message === "string") return data.message;
    else if (data && typeof data.detail === "string") return data.detail;
    return $5ccd9cff12908520$export$3493bad2b09dc248;
};
const $5ccd9cff12908520$export$590f4352c5d1c141 = (outcome, cameraId)=>{
    if (outcome === "timeout" || outcome.status === "timed_out") return {
        phase: "done",
        severity: "info",
        message: $5ccd9cff12908520$export$8b5053fea863717b,
        details: []
    };
    const cameras = outcome.result?.cameras ?? [];
    const row = cameras.find((c)=>String(c.camera_id) === String(cameraId));
    const details = [];
    if (row) {
        details.push(`This camera: ${$5ccd9cff12908520$export$c6db34a00108fcec(row.status)}${row.detail ? ` \u{2014} ${row.detail}` : ""}.`);
        const views = row.device ? cameras.filter((c)=>c.device === row.device) : [
            row
        ];
        if (views.length > 1) {
            const counts = [];
            const seen = {};
            views.forEach((c)=>{
                const label = $5ccd9cff12908520$export$c6db34a00108fcec(c.status);
                if (seen[label] === undefined) {
                    seen[label] = counts.length;
                    counts.push(label);
                }
            });
            const tally = counts.map((label)=>`${views.filter((c)=>$5ccd9cff12908520$export$c6db34a00108fcec(c.status) === label).length} ${label}`);
            details.push(`${$5ccd9cff12908520$var$plural(views.length, "view")}: ${tally.join(", ")}.`);
        }
    }
    switch(outcome.status){
        case "success":
            return {
                phase: "done",
                severity: "success",
                message: "Action rule job finished.",
                details: details
            };
        case "partial":
            return {
                phase: "done",
                severity: "warning",
                message: "Action rule job finished, but not every view was fixed.",
                details: details
            };
        default:
            {
                const reason = outcome.result?.error || row?.detail || (row ? $5ccd9cff12908520$var$capitalize($5ccd9cff12908520$export$c6db34a00108fcec(row.status)) : "") || "unknown error";
                return {
                    phase: "done",
                    severity: "error",
                    message: `Action rule job failed: ${reason}`,
                    details: outcome.result?.error ? details : details.slice(1)
                };
            }
    }
};
const $5ccd9cff12908520$export$8c77f053e8d0c090 = (0, $9OjAn.create)((set)=>({
        unreachable: {},
        ruleJobs: {},
        setUnreachable: (cameraId, message)=>set((state)=>{
                const unreachable = {
                    ...state.unreachable
                };
                if (message) unreachable[String(cameraId)] = message;
                else delete unreachable[String(cameraId)];
                return {
                    unreachable: unreachable
                };
            }),
        setRuleJob: (cameraId, job)=>set((state)=>{
                const ruleJobs = {
                    ...state.ruleJobs
                };
                if (job) ruleJobs[String(cameraId)] = job;
                else delete ruleJobs[String(cameraId)];
                return {
                    ruleJobs: ruleJobs
                };
            })
    }));
const $5ccd9cff12908520$export$5adbd1faf2a470d7 = async (siteId, dispatch, options = {})=>{
    const attempts = options.attempts ?? $5ccd9cff12908520$export$4d18e800d33df063;
    const intervalMs = options.intervalMs ?? $5ccd9cff12908520$export$c5ca15ee5b6f55dd;
    const signal = options.signal;
    const client = (0, $195EM.createApi)(``);
    const dispatchedAt = Date.parse(dispatch.request_date);
    const hasId = dispatch.id !== null && dispatch.id !== undefined;
    const statusUrl = `customer/${siteId}/action_status/?action=${$5ccd9cff12908520$export$25e597656af51b13}` + (hasId ? `&id=${dispatch.id}` : "");
    const isThisJob = (data)=>{
        if (hasId) return data.id === dispatch.id;
        if (Number.isNaN(dispatchedAt)) return true;
        return Date.parse(data.request_date) >= dispatchedAt;
    };
    for(let attempt = 0; attempt < attempts; attempt++){
        await (0, $c8yf1.abortableWait)(intervalMs, signal);
        if (signal?.aborted) return null;
        try {
            const response = await client.get(statusUrl, {
                signal: signal
            });
            if (signal?.aborted) return null;
            const data = response.data;
            if (data && isThisJob(data) && data.status && data.status !== "pending") return data;
        } catch  {
        // 404 (no row yet), transient error, or aborted: the loop decides.
        }
    }
    return signal?.aborted ? null : "timeout";
};

});


parcelRegister("g8Pav", function(module, exports) {

$parcel$export(module.exports, "ApplicationsConfiguredTable", () => $0aba4a54ea72c784$export$770efecb728567ab);

var $k4ank = parcelRequire("k4ank");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");
parcelRequire("8T3gX");
const $0aba4a54ea72c784$export$770efecb728567ab = ({ applicationsConfiguredData: applicationsConfiguredData })=>{
    const titlesArray = [
        "Name",
        "Vendor",
        "Version",
        "Status"
    ];
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
            sx: {
                minWidth: 1000,
                fontFamily: "Mulish"
            },
            "aria-label": "simple table",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                    titlesArray: titlesArray
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                    children: applicationsConfiguredData.map((object)=>{
                        return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: object.display_name ? object.display_name : "--"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: object.vendor ? object.vendor : "--"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: object.version ? object.version : "--"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: object.status ? object.status : "--"
                                })
                            ]
                        }, object.id);
                    })
                })
            ]
        })
    });
};

});

parcelRegister("7Rd0f", function(module, exports) {

$parcel$export(module.exports, "useMotionOff", () => $d8059dc21ebf280d$export$825c024ec9360852);
$parcel$export(module.exports, "MotionOffNotice", () => $d8059dc21ebf280d$export$d6bb7292712ac6e8);
$parcel$export(module.exports, "MotionRuleButton", () => $d8059dc21ebf280d$export$b6e560095a9f93e0);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $cVCJe = parcelRequire("cVCJe");

var $8jTCz = parcelRequire("8jTCz");

var $aZxZ3 = parcelRequire("aZxZ3");

var $l8TQ5 = parcelRequire("l8TQ5");
const $d8059dc21ebf280d$export$d967dc627f69816c = [
    "milestone",
    "SMTP_per_camera",
    "speco_smtp"
];
const $d8059dc21ebf280d$export$a73076df14533874 = ({ integrationTypeName: integrationTypeName, siteUseMotion: siteUseMotion, camera: camera })=>{
    if ($d8059dc21ebf280d$export$d967dc627f69816c.includes(integrationTypeName ?? "")) return null;
    if (camera && typeof camera.effective === "boolean") {
        if (camera.effective) return null;
        return camera.override === false ? "camera" : "site";
    }
    return siteUseMotion === false ? "site" : null;
};
const $d8059dc21ebf280d$export$825c024ec9360852 = (cameraId)=>{
    const site = (0, $aZxZ3.useEditCameraStore)((state)=>state.siteInfoEditCamera);
    const camera = (0, $l8TQ5.useCameraMotionStore)((state)=>cameraId != null ? state.byCamera[String(cameraId)] : undefined);
    return $d8059dc21ebf280d$export$a73076df14533874({
        integrationTypeName: site?.integration_type_name,
        siteUseMotion: site?.use_motion,
        camera: camera
    });
};
const $d8059dc21ebf280d$export$c1ed84abc1a473bc = (vendor, scope = "site")=>scope === "camera" ? `${vendor} motion is off for this camera \u{2014} it is set to Always stream, so it streams continuously instead. Set this camera's Motion to Use motion (General Info tab) to enable these rules.` : `${vendor} motion is off for this site \u{2014} cameras are streaming continuously instead. Turn Use Motion on for the site to enable these rules.`;
const $d8059dc21ebf280d$export$d6bb7292712ac6e8 = ({ vendor: vendor, scope: scope = "site" })=>/*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "mx-4 mt-4 rounded border-l-4 border-actuate-orange bg-[#FFF4E5] px-4 py-3 font-mulish text-actuate-blue",
        children: scope === "camera" ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                    className: "font-bold",
                    children: [
                        vendor,
                        " motion is off for this camera."
                    ]
                }),
                " ",
                "It is set to Always stream, so it streams continuously instead. Set this camera's Motion setting on the General Info tab to Use motion to enable these motion rules."
            ]
        }) : /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                    className: "font-bold",
                    children: [
                        vendor,
                        " motion is off for this site."
                    ]
                }),
                " ",
                "Cameras are streaming continuously instead. Turn Use Motion on for the site to enable these motion rules."
            ]
        })
    });
const $d8059dc21ebf280d$export$b6e560095a9f93e0 = ({ vendor: vendor, motionOff: motionOff, onClick: onClick, text: text, disabled: disabled = false })=>motionOff ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: $d8059dc21ebf280d$export$c1ed84abc1a473bc(vendor, motionOff === "camera" ? "camera" : "site"),
        placement: "top",
        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                onClick: undefined,
                text: text,
                disabled: true
            })
        })
    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
        onClick: disabled ? undefined : onClick,
        text: text,
        disabled: disabled
    });

});


parcelRegister("7SrQs", function(module, exports) {

$parcel$export(module.exports, "MobotixTab", () => $667a1de0729937a8$export$fef5fa14b1f37c8d);

var $k4ank = parcelRequire("k4ank");

var $f3puC = parcelRequire("f3puC");
parcelRequire("8T3gX");

var $7Rd0f = parcelRequire("7Rd0f");

var $9iwwe = parcelRequire("9iwwe");

var $g1doh = parcelRequire("g1doh");

var $2ZHgF = parcelRequire("2ZHgF");

var $hkbZb = parcelRequire("hkbZb");

var $d82Ag = parcelRequire("d82Ag");

var $ksH0T = parcelRequire("ksH0T");
const $667a1de0729937a8$export$fef5fa14b1f37c8d = ({ timeTablesData: timeTablesData, navigate: navigate, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setTimeTablesData: setTimeTablesData, setActiveTab: setActiveTab, iPNotifyData: iPNotifyData, setIPNotifyData: setIPNotifyData, actionHandlerData: actionHandlerData, setActionHandlerData: setActionHandlerData })=>{
    const currentCameraInfo = JSON.parse(localStorage.currentCameraInfo);
    const userInfo = JSON.parse(localStorage.userInfo);
    const permissions = userInfo.permission;
    const motionOff = (0, $7Rd0f.useMotionOff)(currentCameraInfo?.id);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "relative min-w-[1150px] left-[0px] bg-white",
        children: [
            motionOff && /*#__PURE__*/ (0, $k4ank.jsx)((0, $7Rd0f.MotionOffNotice), {
                vendor: "Mobotix",
                scope: motionOff
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                variant: "h6",
                                gutterBottom: true,
                                component: "div",
                                fontWeight: "bold",
                                sx: {
                                    fontFamily: "Mulish",
                                    color: "#001943",
                                    paddingTop: 2,
                                    paddingLeft: 2,
                                    paddingBottom: 1
                                },
                                children: "Time Tables"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "absolute top-[15px] left-[150px]",
                                children: permissions.edit_cameras && /*#__PURE__*/ (0, $k4ank.jsx)((0, $7Rd0f.MotionRuleButton), {
                                    vendor: "Mobotix",
                                    motionOff: motionOff,
                                    onClick: ()=>{
                                        setBackdropLoadingScreenOn(true);
                                        (0, $g1doh.handleAddTimeTable)(currentCameraInfo.id, navigate, setBackdropLoadingScreenOn, setTimeTablesData, setActiveTab, iPNotifyData, setIPNotifyData, actionHandlerData, setActionHandlerData);
                                    },
                                    text: "+ Add Time table"
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $9iwwe.TimeTablesTable), {
                                timeTablesData: timeTablesData
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "relative min-w-[1150px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                    variant: "h6",
                                    gutterBottom: true,
                                    component: "div",
                                    fontWeight: "bold",
                                    sx: {
                                        fontFamily: "Mulish",
                                        color: "#001943",
                                        paddingTop: 2,
                                        paddingLeft: 2
                                    },
                                    children: "IP Notify"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "absolute top-[15px] left-[150px]",
                                    children: permissions.edit_cameras && /*#__PURE__*/ (0, $k4ank.jsx)((0, $7Rd0f.MotionRuleButton), {
                                        vendor: "Mobotix",
                                        motionOff: motionOff,
                                        onClick: ()=>{
                                            setBackdropLoadingScreenOn(true);
                                            (0, $hkbZb.handleAddIPNotify)(currentCameraInfo.id, navigate, setBackdropLoadingScreenOn, setIPNotifyData, setActiveTab, timeTablesData, setTimeTablesData, actionHandlerData, setActionHandlerData);
                                        },
                                        text: "+ Add IP Notify"
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $2ZHgF.IPNotifyTable), {
                                    iPNotifyData: iPNotifyData
                                })
                            ]
                        })
                    }, "ip_notify"),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "relative min-w-[1150px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                    variant: "h6",
                                    gutterBottom: true,
                                    component: "div",
                                    fontWeight: "bold",
                                    sx: {
                                        fontFamily: "Mulish",
                                        color: "#001943",
                                        paddingTop: 2,
                                        paddingLeft: 2
                                    },
                                    children: "Actions"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "absolute top-[15px] left-[150px]",
                                    children: permissions.edit_cameras && /*#__PURE__*/ (0, $k4ank.jsx)((0, $7Rd0f.MotionRuleButton), {
                                        vendor: "Mobotix",
                                        motionOff: motionOff,
                                        onClick: ()=>{
                                            setBackdropLoadingScreenOn(true);
                                            (0, $ksH0T.handleAddAction)(currentCameraInfo.id, navigate, setBackdropLoadingScreenOn, setIPNotifyData, setActiveTab, timeTablesData, setTimeTablesData, iPNotifyData, setActionHandlerData);
                                        },
                                        text: "+ Add Action"
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $d82Ag.ActionsTable), {
                                    actionHandlerData: actionHandlerData
                                })
                            ]
                        })
                    }, "actions")
                ]
            }, "time_tables")
        ]
    });
};

});
parcelRegister("9iwwe", function(module, exports) {

$parcel$export(module.exports, "TimeTablesTable", () => $19f201ccaf2bd841$export$a5e57da19873ee81);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $kvMEt = parcelRequire("kvMEt");
const $19f201ccaf2bd841$export$a5e57da19873ee81 = ({ timeTablesData: timeTablesData })=>{
    const titlesArray = [
        "Name",
        "Time",
        "Table"
    ];
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
            sx: {
                minWidth: 1000,
                fontFamily: "Mulish"
            },
            "aria-label": "time_tables_table",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                    titlesArray: titlesArray
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                    children: timeTablesData.map((object)=>{
                        return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: object.display_name ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                                        children: object.display_name
                                    }) : "--"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: object.time ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                                        children: object.time
                                    }) : "--"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: object.table ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                        children: [
                                            (0, $kvMEt.checkOrX)(object.is_actuate),
                                            " ",
                                            object.table
                                        ]
                                    }) : "--"
                                })
                            ]
                        }, object.id);
                    })
                })
            ]
        })
    });
};

});

parcelRegister("g1doh", function(module, exports) {

$parcel$export(module.exports, "handleAddTimeTable", () => $27fec2349322e258$export$e9ec56e73890e27c);
// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $7SrQs = parcelRequire("7SrQs");

var $3Zv1D = parcelRequire("3Zv1D");
const $27fec2349322e258$export$e9ec56e73890e27c = (cameraId, navigate, setBackdropLoadingScreenOn, setTimeTablesData, setActiveTab, iPNotifyData, setIPNotifyData, actionHandlerData, setActionHandlerData)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $27fec2349322e258$export$e9ec56e73890e27c(cameraId, navigate, setBackdropLoadingScreenOn, setTimeTablesData, setActiveTab, iPNotifyData, setIPNotifyData, actionHandlerData, setActionHandlerData);
    };
    AxiosUI.post(`/mobotix/${cameraId}/timetable/`, {}).then((response)=>{
        setTimeTablesData(response.data);
        setBackdropLoadingScreenOn(false);
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $7SrQs.MobotixTab), {
            timeTablesData: response.data,
            navigate: navigate,
            setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
            setTimeTablesData: setTimeTablesData,
            setActiveTab: setActiveTab,
            iPNotifyData: iPNotifyData,
            setIPNotifyData: setIPNotifyData,
            actionHandlerData: actionHandlerData,
            setActionHandlerData: setActionHandlerData
        }));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
            alert("Problem adding time table, please try again");
        });
    });
};

});

parcelRegister("2ZHgF", function(module, exports) {

$parcel$export(module.exports, "IPNotifyTable", () => $01d8f096e242d428$export$9c03677884273b3);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $kvMEt = parcelRequire("kvMEt");
const $01d8f096e242d428$export$9c03677884273b3 = ({ iPNotifyData: iPNotifyData })=>{
    const titlesArray = [
        "Name",
        "IP Notify Address",
        "Message"
    ];
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
            sx: {
                minWidth: 1000,
                fontFamily: "Mulish"
            },
            "aria-label": "time_tables_table",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                    titlesArray: titlesArray
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                    children: iPNotifyData.map((object)=>{
                        return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: object.display_name ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                                        children: object.display_name
                                    }) : "--"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: object.address ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                        children: [
                                            (0, $kvMEt.checkOrX)(object.is_address_ok),
                                            " ",
                                            object.address
                                        ]
                                    }) : "--"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: object.message ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                        children: [
                                            (0, $kvMEt.checkOrX)(object.is_message_ok),
                                            " ",
                                            object.message
                                        ]
                                    }) : "--"
                                })
                            ]
                        }, object.id);
                    })
                })
            ]
        })
    });
};

});

parcelRegister("hkbZb", function(module, exports) {

$parcel$export(module.exports, "handleAddIPNotify", () => $0ae22a91645131e7$export$207748f120b6dc9b);
// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $7SrQs = parcelRequire("7SrQs");

var $3Zv1D = parcelRequire("3Zv1D");
const $0ae22a91645131e7$export$207748f120b6dc9b = (cameraId, navigate, setBackdropLoadingScreenOn, setIPNotifyData, setActiveTab, timeTablesData, setTimeTablesData, actionHandlerData, setActionHandlerData)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $0ae22a91645131e7$export$207748f120b6dc9b(cameraId, navigate, setBackdropLoadingScreenOn, setIPNotifyData, setActiveTab, timeTablesData, setTimeTablesData, actionHandlerData, setActionHandlerData);
    };
    AxiosUI.post(`/mobotix/${cameraId}/ip_notify/`, {}).then((response)=>{
        setIPNotifyData(response.data);
        setBackdropLoadingScreenOn(false);
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $7SrQs.MobotixTab), {
            timeTablesData: timeTablesData,
            navigate: navigate,
            setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
            setTimeTablesData: setTimeTablesData,
            setActiveTab: setActiveTab,
            iPNotifyData: response.data,
            setIPNotifyData: setIPNotifyData,
            actionHandlerData: actionHandlerData,
            setActionHandlerData: setActionHandlerData
        }));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
            alert("Problem adding IP Notify, please try again");
        });
    });
};

});

parcelRegister("d82Ag", function(module, exports) {

$parcel$export(module.exports, "ActionsTable", () => $ecc2d609793e911b$export$a8a916c7810ec3f);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $kvMEt = parcelRequire("kvMEt");
const $ecc2d609793e911b$export$a8a916c7810ec3f = ({ actionHandlerData: actionHandlerData })=>{
    const titlesArray = [
        "Name",
        "ID",
        "Action",
        "Subactions",
        "Timeout",
        "Timetable"
    ];
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
            sx: {
                minWidth: 1000,
                fontFamily: "Mulish"
            },
            "aria-label": "time_tables_table",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                    titlesArray: titlesArray
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                    children: actionHandlerData.map((object)=>{
                        return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: object.display_name ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                                        children: object.display_name
                                    }) : "--"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: object.id ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                                        children: object.id
                                    }) : "--"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: object.action ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                        children: [
                                            (0, $kvMEt.checkOrX)(object.is_actuate),
                                            " ",
                                            object.action
                                        ]
                                    }) : "--"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: object.subactions ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                                        children: object.subactions
                                    }) : "--"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: object.timeout ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                                        children: object.timeout
                                    }) : "--"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: object.timetable ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                        children: [
                                            (0, $kvMEt.checkOrX)(object.is_timetable_ok),
                                            " ",
                                            object.timetable
                                        ]
                                    }) : "--"
                                })
                            ]
                        }, object.id);
                    })
                })
            ]
        })
    });
};

});

parcelRegister("ksH0T", function(module, exports) {

$parcel$export(module.exports, "handleAddAction", () => $650379396454560d$export$ca08f29a477be8fa);
// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $7SrQs = parcelRequire("7SrQs");

var $3Zv1D = parcelRequire("3Zv1D");
const $650379396454560d$export$ca08f29a477be8fa = (cameraId, navigate, setBackdropLoadingScreenOn, setIPNotifyData, setActiveTab, timeTablesData, setTimeTablesData, iPNotifyData, setActionHandlerData)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $650379396454560d$export$ca08f29a477be8fa(cameraId, navigate, setBackdropLoadingScreenOn, setIPNotifyData, setActiveTab, timeTablesData, setTimeTablesData, iPNotifyData, setActionHandlerData);
    };
    AxiosUI.post(`/mobotix/${cameraId}/action_handler/`, {}).then((response)=>{
        setActionHandlerData(response.data);
        setBackdropLoadingScreenOn(false);
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $7SrQs.MobotixTab), {
            timeTablesData: timeTablesData,
            navigate: navigate,
            setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
            setTimeTablesData: setTimeTablesData,
            setActiveTab: setActiveTab,
            iPNotifyData: iPNotifyData,
            setIPNotifyData: setIPNotifyData,
            actionHandlerData: response.data,
            setActionHandlerData: setActionHandlerData
        }));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
            alert("Problem adding Action, please try again");
        });
    });
};

});


parcelRegister("lE6VE", function(module, exports) {

$parcel$export(module.exports, "StreamParametersTab", () => $7b4e4f78131d0d78$export$7d2b3514fc79e76c);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $6oG4D = parcelRequire("6oG4D");
const $7b4e4f78131d0d78$export$7d2b3514fc79e76c = ({ streamParametersData: streamParametersData, siteInfo: siteInfo })=>{
    const extraFields = streamParametersData.extra_fields;
    // The integration writes a helperText for each field (actuate_admin's
    // list_extra_camera_fields); surface it on the header rather than dropping it.
    const titlesArray = extraFields.map((field)=>[
            field.label,
            field.field
        ]);
    const toolTipText = (0, $6oG4D.buildStreamParameterTooltips)(extraFields);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
            sx: {
                minWidth: 1000,
                fontFamily: "Mulish"
            },
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TooltipTableHeadComponent), {
                    titlesArray: titlesArray,
                    toolTipText: toolTipText
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                        children: extraFields.map((object)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                children: (0, $6oG4D.formatStreamParameterValue)(streamParametersData[object.field], object.type, object.options, {
                                    field: object.field,
                                    label: object.label,
                                    siteProtocol: siteInfo?.protocol
                                })
                            }, object.id))
                    }, `stream_parameters`)
                })
            ]
        })
    });
};

});
parcelRegister("6oG4D", function(module, exports) {

$parcel$export(module.exports, "isCheckboxStreamParameter", () => $213eb854d363a6d6$export$b4ba71b28524c651);
$parcel$export(module.exports, "isChoiceStreamParameter", () => $213eb854d363a6d6$export$75ec1e7d35a415d3);
$parcel$export(module.exports, "isPerCameraProtocolField", () => $213eb854d363a6d6$export$5f80793ff108c0e9);
$parcel$export(module.exports, "relabelProtocolChoiceOptions", () => $213eb854d363a6d6$export$b9e53ef9e203a399);
$parcel$export(module.exports, "choiceValue", () => $213eb854d363a6d6$export$1d4615efff3fa18e);
$parcel$export(module.exports, "formatStreamParameterValue", () => $213eb854d363a6d6$export$efaf9a931961e898);
$parcel$export(module.exports, "buildStreamParameterTooltips", () => $213eb854d363a6d6$export$e3406d9a56e922ad);
/**
 * Stream Options tab (extra fields) = the integration's `list_extra_camera_fields()` from
 * actuate_admin, served by `camera/{id}/extra_fields/`. Every field carries a
 * `type` (UIFieldType); until ENG-950 they were all strings, so the tab rendered
 * everything as a text input. Milestone motion is the first checkbox.
 */ const $213eb854d363a6d6$export$b4ba71b28524c651 = (type)=>type === "checkbox";
const $213eb854d363a6d6$export$75ec1e7d35a415d3 = (type)=>type === "choice";
const $213eb854d363a6d6$export$5f80793ff108c0e9 = (field, label)=>field === "protocol" || label === "Protocol";
const $213eb854d363a6d6$export$e6c7d689fc1c5c4c = (siteProtocol)=>{
    const normalized = (siteProtocol ?? "rtsp").trim() || "rtsp";
    return `Site default (${normalized.toUpperCase()})`;
};
const $213eb854d363a6d6$export$b9e53ef9e203a399 = (options, siteProtocol)=>(options ?? []).map(([label, value])=>{
        if (value === "" || value === null || value === undefined) return [
            $213eb854d363a6d6$export$e6c7d689fc1c5c4c(siteProtocol),
            ""
        ];
        return [
            label,
            value
        ];
    });
const $213eb854d363a6d6$export$1d4615efff3fa18e = (value)=>value === null || value === undefined ? "" : String(value);
const $213eb854d363a6d6$export$efaf9a931961e898 = (value, type, options, context)=>{
    if ($213eb854d363a6d6$export$b4ba71b28524c651(type)) return value ? "On" : "Off";
    if ($213eb854d363a6d6$export$75ec1e7d35a415d3(type) && Array.isArray(options)) {
        const normalized = $213eb854d363a6d6$export$1d4615efff3fa18e(value);
        if ($213eb854d363a6d6$export$5f80793ff108c0e9(context?.field, context?.label) && normalized === "") return $213eb854d363a6d6$export$e6c7d689fc1c5c4c(context?.siteProtocol);
        const displayOptions = $213eb854d363a6d6$export$5f80793ff108c0e9(context?.field, context?.label) ? $213eb854d363a6d6$export$b9e53ef9e203a399(options, context?.siteProtocol) : options;
        const match = displayOptions.find(([, optionValue])=>optionValue === normalized);
        if (match) return match[0];
    }
    return value !== null && value !== undefined ? String(value) : "--";
};
const $213eb854d363a6d6$export$e3406d9a56e922ad = (extraFields = [])=>extraFields.reduce((tooltips, field)=>{
        if (field?.field && field.helperText) tooltips[field.field] = field.helperText;
        return tooltips;
    }, {});

});


parcelRegister("fU1zL", function(module, exports) {

$parcel$export(module.exports, "StreamParametersTabEditMode", () => $3dd8a439c691fffb$export$77338beb5d2faece);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $cxknk = parcelRequire("cxknk");
var $ddLR4 = parcelRequire("ddLR4");
var $eejVe = parcelRequire("eejVe");

var $6oG4D = parcelRequire("6oG4D");
const $3dd8a439c691fffb$var$buildFieldValuesFromData = (extraFields, streamParametersData)=>{
    const values = {};
    extraFields.forEach((field)=>{
        values[field.field] = streamParametersData[field.field];
    });
    return values;
};
const $3dd8a439c691fffb$var$choiceLabelForValue = (options, value)=>{
    const normalized = (0, $6oG4D.choiceValue)(value);
    return options.find(([, optionValue])=>optionValue === normalized)?.[0] ?? normalized;
};
const $3dd8a439c691fffb$export$77338beb5d2faece = ({ streamParametersData: streamParametersData, streamParametersPatchObject: _streamParametersPatchObject, setStreamParametersPatchObject: setStreamParametersPatchObject, setStreamParametersChangesMade: setStreamParametersChangesMade, siteInfo: siteInfo })=>{
    const extraFields = streamParametersData.extra_fields;
    // Edit Camera stores the active tab JSX in state, so props like
    // streamParametersPatchObject are frozen at tab-switch time. Keep pending
    // extra-field edits in local state for a responsive UI; still mirror into
    // the parent patch object for Save.
    const [fieldValues, setFieldValues] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(()=>$3dd8a439c691fffb$var$buildFieldValuesFromData(extraFields, streamParametersData));
    const commitFieldValue = (field, nextValue)=>{
        setFieldValues((previous)=>({
                ...previous,
                [field]: nextValue
            }));
        setStreamParametersChangesMade(true);
        setStreamParametersPatchObject((previous)=>({
                ...previous,
                [field]: nextValue
            }));
    };
    // The integration writes a helperText for each field (actuate_admin's
    // list_extra_camera_fields); surface it on the header rather than dropping it.
    const titlesArray = extraFields.map((field)=>[
            field.label,
            field.field
        ]);
    const toolTipText = (0, $6oG4D.buildStreamParameterTooltips)(extraFields);
    const didSeedPatch = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (didSeedPatch.current) return;
        didSeedPatch.current = true;
        setStreamParametersPatchObject($3dd8a439c691fffb$var$buildFieldValuesFromData(extraFields, streamParametersData));
    }, [
        extraFields,
        setStreamParametersPatchObject,
        streamParametersData
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
            sx: {
                minWidth: 1000,
                fontFamily: "Mulish"
            },
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TooltipTableHeadComponent), {
                    titlesArray: titlesArray,
                    toolTipText: toolTipText
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                        children: extraFields.map((object)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: (0, $6oG4D.isCheckboxStreamParameter)(object.type) ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                        id: object.id,
                                        inputProps: {
                                            "aria-label": object.label
                                        },
                                        checked: Boolean(fieldValues[object.field]),
                                        onChange: ()=>{
                                            commitFieldValue(object.field, !Boolean(fieldValues[object.field]));
                                        }
                                    }) : (0, $6oG4D.isChoiceStreamParameter)(object.type) ? (()=>{
                                        const choiceOptions = (0, $6oG4D.isPerCameraProtocolField)(object.field, object.label) ? (0, $6oG4D.relabelProtocolChoiceOptions)(object.options, siteInfo?.protocol) : object.options || [];
                                        const selectedValue = (0, $6oG4D.choiceValue)(fieldValues[object.field]);
                                        return /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                            id: object.id,
                                            select: true,
                                            variant: "standard",
                                            sx: {
                                                minWidth: 280
                                            },
                                            inputProps: {
                                                "aria-label": object.label
                                            },
                                            value: selectedValue,
                                            SelectProps: (0, $6oG4D.isPerCameraProtocolField)(object.field, object.label) ? {
                                                displayEmpty: true,
                                                renderValue: (selected)=>$3dd8a439c691fffb$var$choiceLabelForValue(choiceOptions, selected)
                                            } : undefined,
                                            onChange: (event)=>{
                                                const nextValue = event.target.value;
                                                commitFieldValue(object.field, nextValue);
                                            },
                                            helperText: object.helperText ? object.helperText : "",
                                            children: choiceOptions.map(([label, value])=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                    value: value,
                                                    children: label
                                                }, value || "default"))
                                        });
                                    })() : /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        id: object.id,
                                        value: fieldValues[object.field] !== null && fieldValues[object.field] !== undefined ? String(fieldValues[object.field]) : "",
                                        variant: "standard",
                                        sx: {
                                            width: 150
                                        },
                                        type: "string",
                                        onChange: (event)=>{
                                            commitFieldValue(object.field, event.target.value);
                                        },
                                        helperText: object.helperText ? object.helperText : ""
                                    })
                                })
                            }, object.id))
                    }, `stream_parameters`)
                })
            ]
        })
    });
};

});

parcelRegister("dWhHk", function(module, exports) {

$parcel$export(module.exports, "AlertSettingsTab", () => $4134b39f9ab88cf4$export$28222e7fcfd5110);

var $k4ank = parcelRequire("k4ank");

var $f3puC = parcelRequire("f3puC");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $8jTCz = parcelRequire("8jTCz");

var $dkwTx = parcelRequire("dkwTx");

var $g0t9v = parcelRequire("g0t9v");

var $iKAtE = parcelRequire("iKAtE");
var $1SPe4 = parcelRequire("1SPe4");
var $ddLR4 = parcelRequire("ddLR4");
var $cVCJe = parcelRequire("cVCJe");

var $2yNMw = parcelRequire("2yNMw");
var $4m1S6 = parcelRequire("4m1S6");

var $ka01y = parcelRequire("ka01y");

var $6pdiI = parcelRequire("6pdiI");

var $7t6MD = parcelRequire("7t6MD");

var $aYdit = parcelRequire("aYdit");

var $8T3gX = parcelRequire("8T3gX");

var $aZxZ3 = parcelRequire("aZxZ3");

var $7txAP = parcelRequire("7txAP");

var $hG03Q = parcelRequire("hG03Q");

var $34PsC = parcelRequire("34PsC");
const $4134b39f9ab88cf4$export$28222e7fcfd5110 = ({ immixAlerts: immixAlerts, setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen, setSendingImmixTest: setSendingImmixTest, setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen: setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen, diceAlerts: diceAlerts, setAddDiceAlertDialogOpen: setAddDiceAlertDialogOpen, setSendingDiceTest: setSendingDiceTest, setDiceTestSuccessDialogOpen: setDiceTestSuccessDialogOpen, setDiceTestFailDialogOpen: setDiceTestFailDialogOpen, setDeleteDiceAlertDialogOpen: setDeleteDiceAlertDialogOpen, sureviewAlerts: sureviewAlerts, setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen, setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen, sentinelAlerts: sentinelAlerts, setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen, boldAlerts: boldAlerts, setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen, patriotAlerts: patriotAlerts, setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen, softguardAlerts: softguardAlerts, setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen, immixAlertsOnCamera: immixAlertsOnCamera, diceAlertsOnCamera: diceAlertsOnCamera, sureViewAlertsOnCamera: sureViewAlertsOnCamera, siteInfo: siteInfo, webhooksAlertsOnCamera: webhooksAlertsOnCamera, sentinelAlertsOnCamera: sentinelAlertsOnCamera, boldAlertsOnCamera: boldAlertsOnCamera, patriotAlertsOnCamera: patriotAlertsOnCamera, softguardAlertsOnCamera: softguardAlertsOnCamera, evalinkAlertsOnCamera: evalinkAlertsOnCamera, navigate: navigate })=>{
    const userInfo = JSON.parse(localStorage.userInfo);
    const patriotIgnoreZonesOnAlertPage = (0, $7txAP.usePatriotIgnoreZonesOnAlertPage)();
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    const permissions = userInfo.permission;
    const { setDeleteWebhookDialogOpen: setDeleteWebhookDialogOpen, setWebhookIdToDelete: setWebhookIdToDelete, webhooksData: webhooksData, cameraStreams: cameraStreams, cameraStreamsSelectedIndex: cameraStreamsSelectedIndex, cameraStreamsObject: cameraStreamsObject, setSelectedAlertId: setSelectedAlertId, setSelectedAlertType: setSelectedAlertType, setDeleteAlertDialogOpen: setDeleteAlertDialogOpen, sysaidAlertsOnCamera: sysaidAlertsOnCamera, setAddSysaidAlertDialogOpen: setAddSysaidAlertDialogOpen } = (0, $aZxZ3.useEditCameraStore)();
    // State for password visibility
    const [showPasswords, setShowPasswords] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const handleClickShowPassword = (passwordId)=>{
        setShowPasswords((prev)=>({
                ...prev,
                [passwordId]: !prev[passwordId]
            }));
    };
    const sureviewServerOptions = [
        [
            "US SMTP Server",
            "us-smtp.sureviewops.com"
        ],
        [
            "EU SMTP Server",
            "eu-smtp.sureviewops.com"
        ]
    ];
    const sureViewOptionNames = new Map();
    sureviewServerOptions.forEach((option)=>{
        sureViewOptionNames.set(option[1], option[0]);
    });
    const webhooksTitlesArray = [
        "Webhook",
        "Custom Fields",
        "Event Type"
    ];
    const handleConvertTypeToString = (string)=>{
        if (string === "no_motion") return "No Motion";
        else if (string === "unable_to_connect") return "Unable to Connect";
        else if (string === "detection") return "Detection";
        else return "";
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "relative w-full min-w-[1150px]",
        children: [
            cameraStreams && cameraStreams.length > 1 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "bg-white",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $34PsC.default), {})
            }),
            immixAlertsOnCamera && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "pb-[20px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "min-w-[1150px] h-[60px] bg-white",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                variant: "h6",
                                gutterBottom: true,
                                component: "div",
                                sx: {
                                    fontFamily: "Mulish",
                                    fontWeight: "Bold",
                                    color: "black",
                                    textIndent: "1vw",
                                    paddingTop: "10px",
                                    paddingBottom: "10px"
                                },
                                children: "Immix Alerts"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "absolute right-[70px] top-[10px]",
                                children: permissions.edit_cameras && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    onClick: ()=>{
                                        setAddImmixAlertDialogOpen(true);
                                    },
                                    text: "+ Add Immix Alert",
                                    disabled: false
                                })
                            })
                        ]
                    }),
                    cameraStreamsObject && cameraStreamsObject[cameraStreamsSelectedIndex] && (cameraStreamsObject[cameraStreamsSelectedIndex]?.immix_alerts?.length ?? 0) > 0 && cameraStreamsObject[cameraStreamsSelectedIndex]?.immix_alerts?.map((object, index)=>{
                        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "h-[208px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "min-w-[1150px] h-[80px] bg-white",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "flex",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                                    gutterBottom: true,
                                                    component: "div",
                                                    sx: {
                                                        fontFamily: "Mulish",
                                                        fontWeight: "Bold",
                                                        color: "black",
                                                        textIndent: "1vw",
                                                        paddingTop: "10px"
                                                    },
                                                    children: [
                                                        "Immix Alert ",
                                                        index + 1
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                    onClick: ()=>{
                                                        setDeleteImmixAlertDialogOpen(true);
                                                        localStorage.setItem("selectedImmixAlertId", object.id);
                                                    },
                                                    text: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                        title: `Delete Immix Alert ${index + 1}`,
                                                        placement: "top",
                                                        sx: {
                                                            fontSize: "20px",
                                                            fontFamily: "mulish"
                                                        },
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ka01y))), {})
                                                    }),
                                                    disabled: false
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "pl-[10px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                onClick: ()=>{
                                                    setSendingImmixTest(true);
                                                    (0, $dkwTx.handleSendImmixTest)(object, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, navigate);
                                                },
                                                text: "Send test alert",
                                                disabled: false
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                        component: (0, $4reBM.default),
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                            sx: {
                                                minWidth: 1000,
                                                fontFamily: "Mulish"
                                            },
                                            "aria-label": "simple table",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                    titlesArray: [
                                                        "Immix Server",
                                                        "Immix Port",
                                                        "Immix Email",
                                                        "Immix input 1",
                                                        "Draw Ignore Zones"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.immix_server ? object.immix_server : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.immix_port ? object.immix_port : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.immix_email ? object.immix_email : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.immix_input1 ? object.immix_input1 : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.draw_ignore_zones !== null ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                                    color: "warning",
                                                                    checked: object.draw_ignore_zones,
                                                                    disabled: true
                                                                }) : "--"
                                                            })
                                                        ]
                                                    }, object.id)
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }, object.id);
                    })
                ]
            }, "immixAlerts"),
            diceAlertsOnCamera && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "pb-[20px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "min-w-[1150px] h-[60px] bg-white",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                variant: "h6",
                                gutterBottom: true,
                                component: "div",
                                sx: {
                                    fontFamily: "Mulish",
                                    fontWeight: "Bold",
                                    color: "black",
                                    textIndent: "1vw",
                                    paddingTop: "10px",
                                    paddingBottom: "10px"
                                },
                                children: "Dice Alerts"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "absolute right-[70px] top-[10px]",
                                children: permissions.edit_cameras && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    onClick: ()=>{
                                        setAddDiceAlertDialogOpen(true);
                                    },
                                    text: "+ Add Dice Alert",
                                    disabled: false
                                })
                            })
                        ]
                    }),
                    cameraStreamsObject && cameraStreamsObject[cameraStreamsSelectedIndex] && (cameraStreamsObject[cameraStreamsSelectedIndex]?.dice_alerts?.length ?? 0) > 0 && cameraStreamsObject[cameraStreamsSelectedIndex]?.dice_alerts?.map((object, index)=>{
                        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "h-[208px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "min-w-[1150px] h-[80px] bg-white",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "flex",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                                    gutterBottom: true,
                                                    component: "div",
                                                    sx: {
                                                        fontFamily: "Mulish",
                                                        fontWeight: "Bold",
                                                        color: "black",
                                                        textIndent: "1vw",
                                                        paddingTop: "10px"
                                                    },
                                                    children: [
                                                        "Dice Alert ",
                                                        index + 1
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                    onClick: ()=>{
                                                        setDeleteDiceAlertDialogOpen(true);
                                                        localStorage.setItem("selectedDiceAlertId", object.id);
                                                    },
                                                    text: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                        title: `Delete Dice Alert ${index + 1}`,
                                                        placement: "top",
                                                        sx: {
                                                            fontSize: "20px",
                                                            fontFamily: "mulish"
                                                        },
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ka01y))), {})
                                                    }),
                                                    disabled: false
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "pl-[10px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                onClick: ()=>{
                                                    setSendingDiceTest(true);
                                                    (0, $g0t9v.handleSendDiceTest)(object, setSendingDiceTest, setDiceTestSuccessDialogOpen, setDiceTestFailDialogOpen, navigate);
                                                },
                                                text: "Send test alert",
                                                disabled: false
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                        component: (0, $4reBM.default),
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                            sx: {
                                                minWidth: 1000,
                                                fontFamily: "Mulish"
                                            },
                                            "aria-label": "simple table",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                    titlesArray: [
                                                        "Dice Server",
                                                        "Dice Port",
                                                        "Dice Email",
                                                        "Dice input 1",
                                                        "Draw Ignore Zones"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.dice_server ? object.dice_server : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.dice_port ? object.dice_port : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.dice_email ? object.dice_email : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.dice_input1 ? object.dice_input1 : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.draw_ignore_zones !== null ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                                    color: "warning",
                                                                    checked: object.draw_ignore_zones,
                                                                    disabled: true
                                                                }) : "--"
                                                            })
                                                        ]
                                                    }, object.id)
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }, object.id);
                    })
                ]
            }, "diceAlerts"),
            sureViewAlertsOnCamera && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "pb-[20px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "min-w-[1150px] h-[60px] bg-white flex relative",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                variant: "h6",
                                gutterBottom: true,
                                component: "div",
                                sx: {
                                    fontFamily: "Mulish",
                                    fontWeight: "Bold",
                                    color: "black",
                                    textIndent: "1vw",
                                    paddingTop: "10px",
                                    paddingBottom: "10px"
                                },
                                children: "Sureview Alerts"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "absolute right-[70px] pt-[10px]",
                                children: permissions.edit_cameras && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    onClick: ()=>{
                                        setAddSureviewAlertDialogOpen(true);
                                    },
                                    text: "+ Add Sureview Alert",
                                    disabled: false
                                })
                            })
                        ]
                    }),
                    cameraStreamsObject && cameraStreamsObject[cameraStreamsSelectedIndex] && (cameraStreamsObject[cameraStreamsSelectedIndex]?.sureview_alerts?.length ?? 0) > 0 && cameraStreamsObject[cameraStreamsSelectedIndex]?.sureview_alerts?.map((object, index)=>{
                        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "h-[148px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "min-w-[1150px] h-[40px] bg-white",
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                                gutterBottom: true,
                                                component: "div",
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    fontWeight: "Bold",
                                                    color: "black",
                                                    textIndent: "1vw",
                                                    paddingTop: "10px"
                                                },
                                                children: [
                                                    "Sureview Alert ",
                                                    index + 1
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                onClick: ()=>{
                                                    setSelectedAlertId(object.id);
                                                    setSelectedAlertType("sureview");
                                                    setDeleteAlertDialogOpen(true);
                                                },
                                                text: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                    title: `Delete Sureview Alert ${index + 1}`,
                                                    placement: "top",
                                                    sx: {
                                                        fontSize: "20px",
                                                        fontFamily: "mulish"
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ka01y))), {})
                                                }),
                                                disabled: false
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                        component: (0, $4reBM.default),
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                            sx: {
                                                minWidth: 1000,
                                                fontFamily: "Mulish"
                                            },
                                            "aria-label": "simple table",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                    titlesArray: [
                                                        "Sureview Server",
                                                        "Sureview Subject",
                                                        "Sureview cc",
                                                        "Sureview Email"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.sureview_server ? sureViewOptionNames.get(object.sureview_server) : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.sureview_subject ? object.sureview_subject : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.sureview_cc ? object.sureview_cc : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.sureview_email ? object.sureview_email : "--"
                                                            })
                                                        ]
                                                    }, object.id)
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }, object.id);
                    })
                ]
            }, "sureviewAlerts"),
            (webhooksData || siteInfo.webhooks || webhooksAlertsOnCamera) && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "pb-[20px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "min-w-[1150px] h-[60px] bg-white flex relative",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                variant: "h6",
                                gutterBottom: true,
                                component: "div",
                                sx: {
                                    fontFamily: "Mulish",
                                    fontWeight: "Bold",
                                    color: "black",
                                    textIndent: "1vw",
                                    paddingTop: "10px",
                                    paddingBottom: "10px"
                                },
                                children: "Webhooks"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "absolute right-[70px] pt-[10px]",
                                children: permissions.edit_cameras && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    onClick: ()=>{
                                        setAddStreamWebhookDialogOpen(true);
                                    },
                                    text: "+ Add Stream Webhook",
                                    disabled: false
                                })
                            })
                        ]
                    }),
                    webhooksData && webhooksData[0] && webhooksData.filter((object)=>cameraStreams && cameraStreams[cameraStreamsSelectedIndex] && object.stream.id === cameraStreams[cameraStreamsSelectedIndex].id).map((object, index)=>{
                        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "h-[168px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "min-w-[1150px] h-[60px] bg-white",
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                        gutterBottom: true,
                                        component: "div",
                                        sx: {
                                            fontFamily: "Mulish",
                                            fontWeight: "Bold",
                                            color: "black",
                                            textIndent: "1vw",
                                            paddingTop: "10px"
                                        },
                                        children: [
                                            "Stream Webhook ",
                                            index + 1,
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                onClick: ()=>{
                                                    localStorage.setItem("selectedWebhook", JSON.stringify(object));
                                                    setEditStreamWebhookDialogOpen(true);
                                                },
                                                text: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {
                                                        fontSize: "small"
                                                    })
                                                }),
                                                disabled: false
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                onClick: ()=>{
                                                    setDeleteWebhookDialogOpen(true);
                                                    setWebhookIdToDelete(object.id);
                                                },
                                                text: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ka01y))), {
                                                        fontSize: "small"
                                                    })
                                                }),
                                                disabled: false
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                        component: (0, $4reBM.default),
                                        sx: {
                                            width: "100%"
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                            sx: {
                                                width: "100%",
                                                fontFamily: "Mulish",
                                                tableLayout: "fixed"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                    titlesArray: webhooksTitlesArray
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    width: "33.33%",
                                                                    wordWrap: "break-word"
                                                                },
                                                                children: object.webhook.display_name ? object.webhook.display_name : ""
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    width: "33.33%",
                                                                    wordWrap: "break-word"
                                                                },
                                                                children: object.custom_fields ? `${JSON.stringify(object.custom_fields)}` : ""
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    width: "33.33%",
                                                                    wordWrap: "break-word"
                                                                },
                                                                children: object.event_types ? object.event_types[0] ? object.event_types.map((eventType, eventIndex)=>{
                                                                    const isLast = eventIndex === object.event_types.length - 1;
                                                                    return `${handleConvertTypeToString(eventType)}${isLast ? "" : ", "}`;
                                                                }) : "" : ""
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }, object.id);
                    })
                ]
            }, "webhooks"),
            sentinelAlertsOnCamera && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "pb-[20px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "min-w-[1150px] h-[60px] bg-white flex relative",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                variant: "h6",
                                gutterBottom: true,
                                component: "div",
                                sx: {
                                    fontFamily: "Mulish",
                                    fontWeight: "Bold",
                                    color: "black",
                                    textIndent: "1vw",
                                    paddingTop: "10px",
                                    paddingBottom: "10px"
                                },
                                children: "Sentinel Alerts"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "absolute right-[70px] pt-[10px]",
                                children: permissions.edit_cameras && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    onClick: ()=>{
                                        setAddSentinelAlertDialogOpen(true);
                                    },
                                    text: "+ Add Sentinel Alert",
                                    disabled: false
                                })
                            })
                        ]
                    }),
                    cameraStreamsObject && cameraStreamsObject[cameraStreamsSelectedIndex] && (cameraStreamsObject[cameraStreamsSelectedIndex]?.sentinel_alerts?.length ?? 0) > 0 && cameraStreamsObject[cameraStreamsSelectedIndex]?.sentinel_alerts?.map((object, index)=>{
                        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "h-[168px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "min-w-[1150px] h-[40px] bg-white",
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                                gutterBottom: true,
                                                component: "div",
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    fontWeight: "Bold",
                                                    color: "black",
                                                    textIndent: "1vw",
                                                    paddingTop: "10px"
                                                },
                                                children: [
                                                    "Sentinel Alert ",
                                                    index + 1
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                onClick: ()=>{
                                                    setSelectedAlertId(object.id);
                                                    setSelectedAlertType("sentinel");
                                                    setDeleteAlertDialogOpen(true);
                                                },
                                                text: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                    title: `Delete Sentinel Alert ${index + 1}`,
                                                    placement: "top",
                                                    sx: {
                                                        fontSize: "20px",
                                                        fontFamily: "mulish"
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ka01y))), {})
                                                }),
                                                disabled: false
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                        component: (0, $4reBM.default),
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                            sx: {
                                                minWidth: 1000,
                                                fontFamily: "Mulish"
                                            },
                                            "aria-label": "simple table",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                    titlesArray: [
                                                        "Sentinel Server",
                                                        "Sentinel Site Id",
                                                        "Sentinel Device Address",
                                                        "Draw Ignore Zones"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.sentinel_server ? object.sentinel_server : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.sentinel_site_id ? object.sentinel_site_id : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.sentinel_device_address ? object.sentinel_device_address : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.draw_ignore_zones !== null ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                                    color: "warning",
                                                                    checked: object.draw_ignore_zones,
                                                                    disabled: true
                                                                }) : "--"
                                                            })
                                                        ]
                                                    }, object.id)
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }, object.id);
                    })
                ]
            }, "sentinelAlerts"),
            boldAlertsOnCamera && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "pb-[20px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "min-w-[1150px] h-[60px] bg-white flex relative",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                variant: "h6",
                                gutterBottom: true,
                                component: "div",
                                sx: {
                                    fontFamily: "Mulish",
                                    fontWeight: "Bold",
                                    color: "black",
                                    textIndent: "1vw",
                                    paddingTop: "10px",
                                    paddingBottom: "10px"
                                },
                                children: "Bold Alerts"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "absolute right-[70px] pt-[10px]",
                                children: permissions.edit_cameras && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    onClick: ()=>{
                                        setAddBoldAlertDialogOpen(true);
                                    },
                                    text: "+ Add Bold Alert",
                                    disabled: false
                                })
                            })
                        ]
                    }),
                    cameraStreamsObject && cameraStreamsObject[cameraStreamsSelectedIndex] && (cameraStreamsObject[cameraStreamsSelectedIndex]?.bold_alerts?.length ?? 0) > 0 && cameraStreamsObject[cameraStreamsSelectedIndex]?.bold_alerts?.map((object, index)=>{
                        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "h-[160px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "min-w-[1150px] h-[50px] pt-[10px] bg-white",
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                                gutterBottom: true,
                                                component: "div",
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    fontWeight: "Bold",
                                                    color: "black",
                                                    textIndent: "1vw"
                                                },
                                                children: [
                                                    "Bold Alert ",
                                                    index + 1
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                onClick: ()=>{
                                                    setSelectedAlertId(object.id);
                                                    setSelectedAlertType("bold");
                                                    setDeleteAlertDialogOpen(true);
                                                },
                                                text: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                    title: `Delete Bold Alert ${index + 1}`,
                                                    placement: "top",
                                                    sx: {
                                                        fontSize: "20px",
                                                        fontFamily: "mulish"
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ka01y))), {})
                                                }),
                                                disabled: false
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                        component: (0, $4reBM.default),
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                            sx: {
                                                minWidth: 1000,
                                                fontFamily: "Mulish"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                    titlesArray: [
                                                        "Bold Server",
                                                        "Bold port",
                                                        "Bold id",
                                                        "Bold sdnis",
                                                        "Bold Zone",
                                                        "Bold Alarm Type"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.bold_server ? object.bold_server : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.bold_port ? object.bold_port : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.bold_id ? object.bold_id : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.bold_sdnis ? object.bold_sdnis : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.bold_zone ? object.bold_zone : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.bold_alarmtype ? object.bold_alarmtype : "--"
                                                            })
                                                        ]
                                                    }, object.id)
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }, object.id);
                    })
                ]
            }, "boldAlerts"),
            patriotAlertsOnCamera && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "pb-[20px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "min-w-[1150px] h-[60px] bg-white flex relative",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                variant: "h6",
                                gutterBottom: true,
                                component: "div",
                                sx: {
                                    fontFamily: "Mulish",
                                    fontWeight: "Bold",
                                    color: "black",
                                    textIndent: "1vw",
                                    paddingTop: "10px",
                                    paddingBottom: "10px"
                                },
                                children: "Patriot Alerts"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "absolute right-[70px] pt-[10px]",
                                children: permissions.edit_cameras && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    onClick: ()=>{
                                        setAddPatriotAlertDialogOpen(true);
                                    },
                                    text: "+ Add Patriot Alert",
                                    disabled: false
                                })
                            })
                        ]
                    }),
                    cameraStreamsObject && cameraStreamsObject[cameraStreamsSelectedIndex] && (cameraStreamsObject[cameraStreamsSelectedIndex]?.patriot_alerts?.length ?? 0) > 0 && cameraStreamsObject[cameraStreamsSelectedIndex]?.patriot_alerts?.map((object, index)=>{
                        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "min-h-[160px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "min-w-[1150px] h-[50px] pt-[10px] bg-white",
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                                gutterBottom: true,
                                                component: "div",
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    fontWeight: "Bold",
                                                    color: "black",
                                                    textIndent: "1vw"
                                                },
                                                children: [
                                                    "Patriot Alert ",
                                                    index + 1
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                onClick: ()=>{
                                                    setSelectedAlertId(object.id);
                                                    setSelectedAlertType("patriot");
                                                    setDeleteAlertDialogOpen(true);
                                                },
                                                text: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                    title: `Delete Patriot Alert ${index + 1}`,
                                                    placement: "top",
                                                    sx: {
                                                        fontSize: "20px",
                                                        fontFamily: "mulish"
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ka01y))), {})
                                                }),
                                                disabled: false
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                            component: (0, $4reBM.default),
                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                                sx: {
                                                    minWidth: 1000,
                                                    fontFamily: "Mulish"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                        titlesArray: [
                                                            "Patriot Server",
                                                            "Patriot client no",
                                                            "Patriot username",
                                                            "Patriot password",
                                                            "Patriot zone number",
                                                            "Patriot type number",
                                                            (0, $hG03Q.PATRIOT_DELIVERY_LABEL)
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: object.patriot_server ? object.patriot_server : "--"
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: object.patriot_client_no ? object.patriot_client_no : "--"
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: object.patriot_username ? object.patriot_username : "--"
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: object.patriot_password ? userPermissions.view_passwords ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                        className: "flex",
                                                                        children: [
                                                                            showPasswords[object.id] ? object.patriot_password : (0, $7t6MD.createDots)(object.patriot_password),
                                                                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1SPe4.default), {
                                                                                    position: "end",
                                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                                                                        "aria-label": showPasswords[object.id] ? "hide the password" : "display the password",
                                                                                        onClick: ()=>handleClickShowPassword(object.id),
                                                                                        onMouseDown: (event)=>event.preventDefault(),
                                                                                        onMouseUp: (event)=>event.preventDefault(),
                                                                                        edge: "end",
                                                                                        children: showPasswords[object.id] ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $4m1S6.default), {}) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $2yNMw.default), {})
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                        className: "flex items-center",
                                                                        children: (0, $7t6MD.createDots)(object.patriot_password)
                                                                    }) : "--"
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: object.patriot_zone_number ? object.patriot_zone_number : "--"
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: object.patriot_type_number ? object.patriot_type_number : "--"
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    "data-testid": "patriot-delivery-display",
                                                                    children: (0, $hG03Q.patriotDeliveryDisplayText)(object.patriot_send_video, object.draw_ignore_zones, patriotIgnoreZonesOnAlertPage)
                                                                })
                                                            ]
                                                        }, object.id)
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $7txAP.PatriotDeliverySummary), {
                                            sendVideo: object.patriot_send_video,
                                            drawIgnoreZones: object.draw_ignore_zones
                                        })
                                    ]
                                })
                            ]
                        }, object.id);
                    })
                ]
            }, "patriotAlerts"),
            softguardAlertsOnCamera && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "pb-[20px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "min-w-[1150px] h-[60px] bg-white flex relative",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                variant: "h6",
                                gutterBottom: true,
                                component: "div",
                                sx: {
                                    fontFamily: "Mulish",
                                    fontWeight: "Bold",
                                    color: "black",
                                    textIndent: "1vw",
                                    paddingTop: "10px",
                                    paddingBottom: "10px"
                                },
                                children: "Softguard Alerts"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "absolute right-[70px] pt-[10px]",
                                children: permissions.edit_cameras && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    onClick: ()=>{
                                        setAddSoftguardAlertDialogOpen(true);
                                    },
                                    text: "+ Add Softguard Alert",
                                    disabled: false
                                })
                            })
                        ]
                    }),
                    cameraStreamsObject && cameraStreamsObject[cameraStreamsSelectedIndex] && (cameraStreamsObject[cameraStreamsSelectedIndex]?.softguard_alerts?.length ?? 0) > 0 && cameraStreamsObject[cameraStreamsSelectedIndex]?.softguard_alerts?.map((object, index)=>{
                        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "h-[160px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "min-w-[1150px] h-[50px] pt-[10px] bg-white",
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                                gutterBottom: true,
                                                component: "div",
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    fontWeight: "Bold",
                                                    color: "black",
                                                    textIndent: "1vw"
                                                },
                                                children: [
                                                    "Softguard Alert ",
                                                    index + 1
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                onClick: ()=>{
                                                    setSelectedAlertId(object.id);
                                                    setSelectedAlertType("softguard");
                                                    setDeleteAlertDialogOpen(true);
                                                },
                                                text: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                    title: `Delete Softguard Alert ${index + 1}`,
                                                    placement: "top",
                                                    sx: {
                                                        fontSize: "20px",
                                                        fontFamily: "mulish"
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ka01y))), {})
                                                }),
                                                disabled: false
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                        component: (0, $4reBM.default),
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                            sx: {
                                                minWidth: 1000,
                                                fontFamily: "Mulish"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                    titlesArray: [
                                                        "Server",
                                                        "Port",
                                                        "Zone",
                                                        "Account",
                                                        "User",
                                                        "User Ext"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.server ? object.server : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.port ? object.port : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.zone ? object.zone : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.account ? object.account : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.user ? object.user : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.user_ext ? object.user_ext : "--"
                                                            })
                                                        ]
                                                    }, object.id)
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }, object.id);
                    })
                ]
            }, "softguardAlerts"),
            evalinkAlertsOnCamera && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "pb-[20px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "min-w-[1150px] h-[60px] bg-white flex relative",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                            variant: "h6",
                            gutterBottom: true,
                            component: "div",
                            sx: {
                                fontFamily: "Mulish",
                                fontWeight: "Bold",
                                color: "black",
                                textIndent: "1vw",
                                paddingTop: "10px",
                                paddingBottom: "10px"
                            },
                            children: "Evalink Alerts"
                        })
                    }),
                    cameraStreamsObject && cameraStreamsObject[cameraStreamsSelectedIndex] && (cameraStreamsObject[cameraStreamsSelectedIndex]?.evalink_alerts?.length ?? 0) > 0 && cameraStreamsObject[cameraStreamsSelectedIndex]?.evalink_alerts?.map((object, index)=>{
                        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "h-[148px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "min-w-[1150px] h-[40px] bg-white",
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                        gutterBottom: true,
                                        component: "div",
                                        sx: {
                                            fontFamily: "Mulish",
                                            fontWeight: "Bold",
                                            color: "black",
                                            textIndent: "1vw",
                                            paddingTop: "10px"
                                        },
                                        children: [
                                            "Evalink Alert ",
                                            index + 1
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                        component: (0, $4reBM.default),
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                            sx: {
                                                minWidth: 1000,
                                                fontFamily: "Mulish"
                                            },
                                            "aria-label": "simple table",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                    titlesArray: [
                                                        "Evalink Token",
                                                        "Evalink Device ID",
                                                        "Evalink Company ID",
                                                        "Partition ID",
                                                        "Alarm Zone ID"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.evalink_token ? object.evalink_token : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.evalink_device_id ? object.evalink_device_id : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.evalink_company_id ? object.evalink_company_id : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.partition_id ? object.partition_id : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.alarm_zone_id ? object.alarm_zone_id : "--"
                                                            })
                                                        ]
                                                    }, object.id)
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }, object.id);
                    })
                ]
            }, "evalinkAlerts"),
            sysaidAlertsOnCamera && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "pb-[20px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "min-w-[1150px] h-[60px] bg-white flex relative",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                variant: "h6",
                                gutterBottom: true,
                                component: "div",
                                sx: {
                                    fontFamily: "Mulish",
                                    fontWeight: "Bold",
                                    color: "black",
                                    textIndent: "1vw",
                                    paddingTop: "10px",
                                    paddingBottom: "10px"
                                },
                                children: "SysAid Alerts"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "absolute right-[70px] pt-[10px]",
                                children: permissions.edit_cameras && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    onClick: ()=>{
                                        setAddSysaidAlertDialogOpen(true);
                                    },
                                    text: "+ Add SysAid Alert",
                                    disabled: false
                                })
                            })
                        ]
                    }),
                    cameraStreamsObject && cameraStreamsObject[cameraStreamsSelectedIndex] && (cameraStreamsObject[cameraStreamsSelectedIndex]?.sysaid_alerts?.length ?? 0) > 0 && cameraStreamsObject[cameraStreamsSelectedIndex]?.sysaid_alerts?.map((object, index)=>{
                        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "h-[160px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "min-w-[1150px] h-[50px] pt-[10px] bg-white",
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                                gutterBottom: true,
                                                component: "div",
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    fontWeight: "Bold",
                                                    color: "black",
                                                    textIndent: "1vw"
                                                },
                                                children: [
                                                    "SysAid Alert ",
                                                    index + 1
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                onClick: ()=>{
                                                    setSelectedAlertId(object.id);
                                                    setSelectedAlertType("sysaid");
                                                    setDeleteAlertDialogOpen(true);
                                                },
                                                text: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                    title: `Delete SysAid Alert ${index + 1}`,
                                                    placement: "top",
                                                    sx: {
                                                        fontSize: "20px",
                                                        fontFamily: "mulish"
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ka01y))), {})
                                                }),
                                                disabled: false
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                        component: (0, $4reBM.default),
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                            sx: {
                                                minWidth: 1000,
                                                fontFamily: "Mulish"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                    titlesArray: [
                                                        "SysAid server",
                                                        "SysAid client local",
                                                        "SysAid username",
                                                        "SysAid password"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.sysaid_server ? object.sysaid_server : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.sysaid_client_local ? object.sysaid_client_local : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.sysaid_username ? object.sysaid_username : "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.sysaid_password ? object.sysaid_password : "--"
                                                            })
                                                        ]
                                                    }, object.id)
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }, object.id);
                    })
                ]
            }, "sysaidAlerts")
        ]
    });
};

});
parcelRegister("dkwTx", function(module, exports) {

$parcel$export(module.exports, "handleSendImmixTest", () => $d5a58265618479ae$export$8a1ac150a831fcce);
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $d5a58265618479ae$export$8a1ac150a831fcce = (immixAlert, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const postedObject = {
        alert_url: "",
        immix_server: immixAlert.immix_server,
        immix_port: immixAlert.immix_port,
        immix_email: immixAlert.immix_email,
        immix_frames: 5,
        immix_input1: immixAlert.immix_input1,
        immix_text: "",
        ses_cc: ""
    };
    const retryFunction = ()=>{
        $d5a58265618479ae$export$8a1ac150a831fcce(immixAlert, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, navigate);
    };
    AxiosUI.post(`/alarm/immix/`, postedObject).then(()=>{
        setSendingImmixTest(false);
        setImmixTestSuccessDialogOpen(true);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setSendingImmixTest(false);
            setImmixTestFailDialogOpen(true);
        });
    });
};

});

parcelRegister("g0t9v", function(module, exports) {

$parcel$export(module.exports, "handleSendDiceTest", () => $92a4ebea01928797$export$220531f40e7d63ec);
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $92a4ebea01928797$export$220531f40e7d63ec = (diceAlert, setSendingDiceTest, setDiceTestSuccessDialogOpen, setDiceTestFailDialogOpen, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const postedObject = {
        alert_url: "",
        dice_server: diceAlert.dice_server,
        dice_port: diceAlert.dice_port,
        dice_email: diceAlert.dice_email,
        dice_frames: 5,
        dice_input1: diceAlert.dice_input1,
        dice_text: "",
        ses_cc: ""
    };
    const retryFunction = ()=>{
        $92a4ebea01928797$export$220531f40e7d63ec(diceAlert, setSendingDiceTest, setDiceTestSuccessDialogOpen, setDiceTestFailDialogOpen, navigate);
    };
    AxiosUI.post(`/alarm/dice/`, postedObject).then(()=>{
        setSendingDiceTest(false);
        setDiceTestSuccessDialogOpen(true);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setSendingDiceTest(false);
            setDiceTestFailDialogOpen(true);
        });
    });
};

});

parcelRegister("ka01y", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ead4c29bc8889919$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $ead4c29bc8889919$var$_default = module.exports.default = (0, $ead4c29bc8889919$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), 'Delete');

});

parcelRegister("7txAP", function(module, exports) {

$parcel$export(module.exports, "usePatriotIgnoreZonesOnAlertPage", () => $dfe10579f4ffb0de$export$9980add8a5e528df);
$parcel$export(module.exports, "isPatriotSendVideoOn", () => $dfe10579f4ffb0de$export$a5e3739aecbe329a);
$parcel$export(module.exports, "PatriotDeliverySummary", () => $dfe10579f4ffb0de$export$1eb99a706d47ebc2);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $9qNow = parcelRequire("9qNow");

var $4PFLW = parcelRequire("4PFLW");
const $dfe10579f4ffb0de$export$7154d7aae1a5e755 = "patriotIgnoreZonesOnAlertPage";
const $dfe10579f4ffb0de$export$9980add8a5e528df = ()=>{
    const flags = (0, $4PFLW.useFeatureFlag)()?.flags;
    return flags?.[$dfe10579f4ffb0de$export$7154d7aae1a5e755] === true;
};
const $dfe10579f4ffb0de$export$a5e3739aecbe329a = (value)=>value === true || value === "True" || value === "true";
const $dfe10579f4ffb0de$export$ecbea650ce3ca9ec = {
    link: "Patriot receives: a link to the Actuate alert page (clip plays there; no ignore zones).",
    // Alert-page flag on: the link can carry ignore zones, so drop "no ignore zones".
    linkAlertPage: "Patriot receives: a link to the Actuate alert page (clip plays there).",
    linkWithZones: "Patriot receives: a link to the Actuate alert page with ignore zones drawn.",
    video: "Patriot receives: an MP4 video clip of the alert.",
    videoWithZones: "Patriot receives: an MP4 video clip of the alert with ignore zones drawn."
};
const $dfe10579f4ffb0de$export$be86db75ed4848f6 = ({ sendVideo: sendVideo, drawIgnoreZones: drawIgnoreZones, ignoreZonesOnAlertPage: ignoreZonesOnAlertPage = false })=>{
    if (!$dfe10579f4ffb0de$export$a5e3739aecbe329a(sendVideo)) {
        if (!ignoreZonesOnAlertPage) return $dfe10579f4ffb0de$export$ecbea650ce3ca9ec.link;
        return $dfe10579f4ffb0de$export$a5e3739aecbe329a(drawIgnoreZones) ? $dfe10579f4ffb0de$export$ecbea650ce3ca9ec.linkWithZones : $dfe10579f4ffb0de$export$ecbea650ce3ca9ec.linkAlertPage;
    }
    return $dfe10579f4ffb0de$export$a5e3739aecbe329a(drawIgnoreZones) ? $dfe10579f4ffb0de$export$ecbea650ce3ca9ec.videoWithZones : $dfe10579f4ffb0de$export$ecbea650ce3ca9ec.video;
};
const $dfe10579f4ffb0de$export$1eb99a706d47ebc2 = ({ sendVideo: sendVideo, drawIgnoreZones: drawIgnoreZones })=>{
    const ignoreZonesOnAlertPage = $dfe10579f4ffb0de$export$9980add8a5e528df();
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
        "data-testid": "patriot-delivery-summary",
        sx: {
            fontFamily: "Mulish",
            marginLeft: "1vw"
        },
        children: $dfe10579f4ffb0de$export$be86db75ed4848f6({
            sendVideo: sendVideo,
            drawIgnoreZones: drawIgnoreZones,
            ignoreZonesOnAlertPage: ignoreZonesOnAlertPage
        })
    });
};

});

parcelRegister("hG03Q", function(module, exports) {

$parcel$export(module.exports, "PATRIOT_DELIVERY_LABEL", () => $eca6990896ee6ccf$export$fef6b64dc98ede8e);
$parcel$export(module.exports, "patriotDeliveryDisplayText", () => $eca6990896ee6ccf$export$f24efea71d06d053);
$parcel$export(module.exports, "PatriotDeliveryChoice", () => $eca6990896ee6ccf$export$5a624e1d485e121c);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");
var $kbChx = parcelRequire("kbChx");
var $7UDCh = parcelRequire("7UDCh");
var $3baw3 = parcelRequire("3baw3");
var $lk6eW = parcelRequire("lk6eW");
var $k1BHZ = parcelRequire("k1BHZ");
var $imWqP = parcelRequire("imWqP");

var $7txAP = parcelRequire("7txAP");
const $eca6990896ee6ccf$export$fef6b64dc98ede8e = "What Patriot receives";
const $eca6990896ee6ccf$export$c331d622cc441567 = {
    link: "Alert link",
    linkWithZones: "Alert link with ignore zones",
    linkWithZonesComingSoon: "Alert link with ignore zones (coming soon)",
    video: "Video clip (MP4)"
};
const $eca6990896ee6ccf$export$e1353525d095da90 = "Draw ignore zones on the video";
const $eca6990896ee6ccf$export$e07bfaa91211b09e = (sendVideo, drawIgnoreZones)=>{
    if ((0, $7txAP.isPatriotSendVideoOn)(sendVideo)) return "video";
    return (0, $7txAP.isPatriotSendVideoOn)(drawIgnoreZones) ? "linkWithZones" : "link";
};
const $eca6990896ee6ccf$export$b444f7c427f85c22 = (delivery, currentDrawIgnoreZones)=>{
    if (delivery === "video") return {
        patriot_send_video: true,
        draw_ignore_zones: (0, $7txAP.isPatriotSendVideoOn)(currentDrawIgnoreZones)
    };
    return {
        patriot_send_video: false,
        draw_ignore_zones: delivery === "linkWithZones"
    };
};
const $eca6990896ee6ccf$export$f24efea71d06d053 = (sendVideo, drawIgnoreZones, ignoreZonesOnAlertPage)=>{
    const delivery = $eca6990896ee6ccf$export$e07bfaa91211b09e(sendVideo, drawIgnoreZones);
    if (delivery === "video") return (0, $7txAP.isPatriotSendVideoOn)(drawIgnoreZones) ? `${$eca6990896ee6ccf$export$c331d622cc441567.video}, ignore zones drawn` : $eca6990896ee6ccf$export$c331d622cc441567.video;
    if (delivery === "linkWithZones") return ignoreZonesOnAlertPage ? $eca6990896ee6ccf$export$c331d622cc441567.linkWithZones : $eca6990896ee6ccf$export$c331d622cc441567.linkWithZonesComingSoon;
    return $eca6990896ee6ccf$export$c331d622cc441567.link;
};
const $eca6990896ee6ccf$export$5a624e1d485e121c = ({ sendVideo: sendVideo, drawIgnoreZones: drawIgnoreZones, onChange: onChange, name: name = "patriot-delivery", showLabel: showLabel = true })=>{
    const ignoreZonesOnAlertPage = (0, $7txAP.usePatriotIgnoreZonesOnAlertPage)();
    const delivery = $eca6990896ee6ccf$export$e07bfaa91211b09e(sendVideo, drawIgnoreZones);
    const showLinkWithZones = ignoreZonesOnAlertPage || delivery === "linkWithZones";
    const labelId = `${name}-label`;
    return(// Fixed width so picking an option never resizes the table column the
    // choice sits in (which shifted the whole row sideways).
    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
        "data-testid": "patriot-delivery-choice",
        sx: {
            minWidth: "17rem"
        },
        children: [
            showLabel && /*#__PURE__*/ (0, $k4ank.jsx)((0, $lk6eW.default), {
                id: labelId,
                sx: {
                    fontFamily: "Mulish",
                    color: "#001943"
                },
                children: $eca6990896ee6ccf$export$fef6b64dc98ede8e
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $imWqP.default), {
                "aria-label": showLabel ? undefined : $eca6990896ee6ccf$export$fef6b64dc98ede8e,
                "aria-labelledby": showLabel ? labelId : undefined,
                name: name,
                value: delivery,
                onChange: (event)=>{
                    const next = event.target.value;
                    onChange($eca6990896ee6ccf$export$b444f7c427f85c22(next, drawIgnoreZones));
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                        value: "link",
                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {
                            color: "primary",
                            size: "small"
                        }),
                        label: $eca6990896ee6ccf$export$c331d622cc441567.link
                    }),
                    showLinkWithZones && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                        value: "linkWithZones",
                        disabled: !ignoreZonesOnAlertPage,
                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {
                            color: "primary",
                            size: "small"
                        }),
                        label: ignoreZonesOnAlertPage ? $eca6990896ee6ccf$export$c331d622cc441567.linkWithZones : $eca6990896ee6ccf$export$c331d622cc441567.linkWithZonesComingSoon
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                        value: "video",
                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {
                            color: "primary",
                            size: "small"
                        }),
                        label: $eca6990896ee6ccf$export$c331d622cc441567.video
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                "aria-hidden": delivery !== "video",
                sx: {
                    visibility: delivery === "video" ? "visible" : "hidden"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                    sx: {
                        marginLeft: "1.5rem"
                    },
                    disabled: delivery !== "video",
                    label: $eca6990896ee6ccf$export$e1353525d095da90,
                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                        color: "primary",
                        size: "small",
                        checked: (0, $7txAP.isPatriotSendVideoOn)(drawIgnoreZones),
                        onChange: (event, checked)=>{
                            onChange({
                                patriot_send_video: true,
                                draw_ignore_zones: checked
                            });
                        }
                    })
                })
            })
        ]
    }));
};

});

parcelRegister("34PsC", function(module, exports) {

$parcel$export(module.exports, "default", () => $da4a4cf4d6da82b5$export$2e2bcd8739ae039);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $aZxZ3 = parcelRequire("aZxZ3");

var $a65wX = parcelRequire("a65wX");
var $1fWBE = parcelRequire("1fWBE");
var $cxknk = parcelRequire("cxknk");
const $da4a4cf4d6da82b5$var$SelectedStreamDropDown = ()=>{
    const { cameraStreams: cameraStreams, cameraStreamsSelectedIndex: cameraStreamsSelectedIndex, setCameraStreamsSelectedIndex: setCameraStreamsSelectedIndex } = (0, $aZxZ3.useEditCameraStore)();
    const [anchorEl, setAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    if (!cameraStreams) return null;
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "flex border-b-[1px] pb-[10px] border-gray-300",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "text-actuate-blue font-mulish font-bold text-[16px] pt-[15px] pl-[15px]",
                children: "Selected Stream:"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "pl-[10px] pt-[10px]",
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "text-actuate-blue font-mulish text-[16px]",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                            id: "stream-selector",
                            "aria-controls": open ? "stream-menu" : undefined,
                            "aria-haspopup": "true",
                            "aria-expanded": open ? "true" : undefined,
                            onClick: handleClick,
                            children: cameraStreams[cameraStreamsSelectedIndex]?.name
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $1fWBE.default), {
                            id: "schedule-menu",
                            anchorEl: anchorEl,
                            open: open,
                            onClose: handleClose,
                            MenuListProps: {
                                "aria-labelledby": "schedule-selector"
                            },
                            children: cameraStreams.map((stream, index)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                    onClick: ()=>{
                                        setCameraStreamsSelectedIndex(index);
                                        handleClose();
                                    },
                                    children: stream.name
                                }, stream.name))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "text-actuate-blue font-mulish font-bold text-[16px] pt-[15px] pl-[35px]",
                children: "Stream Products:"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "text-actuate-blue font-mulish font-bold text-[16px] pt-[15px] pl-[35px]",
                children: cameraStreams[cameraStreamsSelectedIndex]?.product || "--"
            })
        ]
    });
};
var $da4a4cf4d6da82b5$export$2e2bcd8739ae039 = $da4a4cf4d6da82b5$var$SelectedStreamDropDown;

});


parcelRegister("5UPfW", function(module, exports) {

$parcel$export(module.exports, "AlertSettingsTabEditMode", () => $19244ba5a8ecac14$export$738c0763693ea220);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $f3puC = parcelRequire("f3puC");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $8jTCz = parcelRequire("8jTCz");

var $8B8vg = parcelRequire("8B8vg");
var $7UDCh = parcelRequire("7UDCh");
var $iKAtE = parcelRequire("iKAtE");
var $fN7FV = parcelRequire("fN7FV");
var $1SPe4 = parcelRequire("1SPe4");
var $6gU8O = parcelRequire("6gU8O");
var $ddLR4 = parcelRequire("ddLR4");
var $eejVe = parcelRequire("eejVe");

var $2yNMw = parcelRequire("2yNMw");
var $4m1S6 = parcelRequire("4m1S6");

var $6pdiI = parcelRequire("6pdiI");

var $ka01y = parcelRequire("ka01y");

var $aYdit = parcelRequire("aYdit");

var $aZxZ3 = parcelRequire("aZxZ3");

var $34PsC = parcelRequire("34PsC");

var $7txAP = parcelRequire("7txAP");

var $hG03Q = parcelRequire("hG03Q");
const $19244ba5a8ecac14$export$738c0763693ea220 = ({ immixAlerts: immixAlerts, diceAlerts: diceAlerts, sureviewAlerts: sureviewAlerts, setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen, sentinelAlerts: sentinelAlerts, boldAlerts: boldAlerts, patriotAlerts: patriotAlerts, softguardAlerts: softguardAlerts, immixAlertsOnCamera: immixAlertsOnCamera, diceAlertsOnCamera: diceAlertsOnCamera, sureViewAlertsOnCamera: sureViewAlertsOnCamera, siteInfo: siteInfo, webhooksAlertsOnCamera: webhooksAlertsOnCamera, sentinelAlertsOnCamera: sentinelAlertsOnCamera, boldAlertsOnCamera: boldAlertsOnCamera, patriotAlertsOnCamera: patriotAlertsOnCamera, softguardAlertsOnCamera: softguardAlertsOnCamera, evalinkAlertsOnCamera: evalinkAlertsOnCamera, cameraGeneralInfo: cameraGeneralInfo, setPatchObject: setPatchObject, setGeneralInfoChangesMade: setGeneralInfoChangesMade, setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen })=>{
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    const { setDeleteWebhookDialogOpen: setDeleteWebhookDialogOpen, setWebhookIdToDelete: setWebhookIdToDelete, webhooksData: webhooksData, cameraStreams: cameraStreams, cameraStreamsSelectedIndex: cameraStreamsSelectedIndex, cameraStreamsObject: cameraStreamsObject, cameraStreamsPatchObject: cameraStreamsPatchObject, setCameraStreamsPatchObject: setCameraStreamsPatchObject, setUpdatedAlertStreams: setUpdatedAlertStreams, setUpdatedAlertStreamTypes: setUpdatedAlertStreamTypes, sysaidAlertsOnCamera: sysaidAlertsOnCamera } = (0, $aZxZ3.useEditCameraStore)();
    const sureviewServerOptions = [
        [
            "US SMTP Server",
            "us-smtp.sureviewops.com"
        ],
        [
            "EU SMTP Server",
            "eu-smtp.sureviewops.com"
        ]
    ];
    const sureViewOptionNames = new Map();
    sureviewServerOptions.forEach((option)=>{
        sureViewOptionNames.set(option[1], option[0]);
    });
    const sureViewOptionIds = new Map();
    sureviewServerOptions.forEach((option)=>{
        sureViewOptionIds.set(option[0], option[1]);
    });
    const webhooksTitlesArray = [
        "Webhook",
        "Custom Fields",
        "Event Type"
    ];
    const handleConvertTypeToString = (string)=>{
        if (string === "no_motion") return "No Motion";
        else if (string === "unable_to_connect") return "Unable to Connect";
        else if (string === "detection") return "Detection";
        else return "";
    };
    // State for password visibility
    const [showPasswords, setShowPasswords] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    // Local state for Immix alerts to prevent re-renders
    const [localImmixAlerts, setLocalImmixAlerts] = (0, $8T3gX.useState)({});
    // Local state for Dice alerts to prevent re-renders
    const [localDiceAlerts, setLocalDiceAlerts] = (0, $8T3gX.useState)({});
    const [localSureviewAlerts, setLocalSureviewAlerts] = (0, $8T3gX.useState)({});
    const [localSentinelAlerts, setLocalSentinelAlerts] = (0, $8T3gX.useState)({});
    const [localBoldAlerts, setLocalBoldAlerts] = (0, $8T3gX.useState)({});
    const [localPatriotAlerts, setLocalPatriotAlerts] = (0, $8T3gX.useState)({});
    const [localSoftguardAlerts, setLocalSoftguardAlerts] = (0, $8T3gX.useState)({});
    const [localSysaidAlerts, setLocalSysaidAlerts] = (0, $8T3gX.useState)({});
    const [localEvalinkAlerts, setLocalEvalinkAlerts] = (0, $8T3gX.useState)({});
    // Initialize local state when cameraStreamsPatchObject changes
    (0, $8T3gX.useEffect)(()=>{
        if (cameraStreamsPatchObject && cameraStreamsObject[cameraStreamsSelectedIndex]?.immix_alerts) {
            const alerts = cameraStreamsPatchObject[cameraStreamsSelectedIndex]?.immix_alerts;
            if (alerts) {
                const localAlerts = {};
                alerts.forEach((alert, index)=>{
                    if (alert?.id) localAlerts[alert.id] = {
                        immix_server: alert.immix_server || "",
                        immix_port: alert.immix_port || "",
                        immix_email: alert.immix_email || "",
                        immix_input1: alert.immix_input1 || "",
                        draw_ignore_zones: alert.draw_ignore_zones || false
                    };
                });
                setLocalImmixAlerts(localAlerts);
            }
        }
        if (cameraStreamsPatchObject && cameraStreamsObject[cameraStreamsSelectedIndex]?.dice_alerts) {
            const alerts = cameraStreamsPatchObject[cameraStreamsSelectedIndex]?.dice_alerts;
            if (alerts) {
                const localAlerts = {};
                alerts.forEach((alert, index)=>{
                    if (alert?.id) localAlerts[alert.id] = {
                        dice_server: alert.dice_server || "",
                        dice_port: alert.dice_port || "",
                        dice_email: alert.dice_email || "",
                        dice_input1: alert.dice_input1 || "",
                        draw_ignore_zones: alert.draw_ignore_zones || false
                    };
                });
                setLocalDiceAlerts(localAlerts);
            }
        }
        if (cameraStreamsPatchObject && cameraStreamsObject[cameraStreamsSelectedIndex]?.sureview_alerts) {
            const alerts = cameraStreamsPatchObject[cameraStreamsSelectedIndex]?.sureview_alerts;
            if (alerts) {
                const localSureviewAlerts = {};
                alerts.forEach((alert, index)=>{
                    if (alert?.id) localSureviewAlerts[alert.id] = {
                        sureview_server: alert.sureview_server || "",
                        sureview_subject: alert.sureview_subject || "",
                        sureview_cc: alert.sureview_cc || "",
                        sureview_email: alert.sureview_email || ""
                    };
                });
                setLocalSureviewAlerts(localSureviewAlerts);
            }
        }
        if (cameraStreamsPatchObject && cameraStreamsObject[cameraStreamsSelectedIndex]?.sentinel_alerts) {
            const alerts = cameraStreamsPatchObject[cameraStreamsSelectedIndex]?.sentinel_alerts;
            if (alerts) {
                const localSentinelAlerts = {};
                alerts.forEach((alert, index)=>{
                    if (alert?.id) localSentinelAlerts[alert.id] = {
                        sentinel_server: alert.sentinel_server || "",
                        sentinel_site_id: alert.sentinel_site_id || "",
                        sentinel_device_address: alert.sentinel_device_address || "",
                        draw_ignore_zones: alert.draw_ignore_zones || false
                    };
                });
                setLocalSentinelAlerts(localSentinelAlerts);
            }
        }
        if (cameraStreamsPatchObject && cameraStreamsObject[cameraStreamsSelectedIndex]?.bold_alerts) {
            const alerts = cameraStreamsPatchObject[cameraStreamsSelectedIndex]?.bold_alerts;
            if (alerts) {
                const localBoldAlerts = {};
                alerts.forEach((alert, index)=>{
                    if (alert?.id) localBoldAlerts[alert.id] = {
                        bold_server: alert.bold_server || "",
                        bold_port: alert.bold_port || "",
                        bold_id: alert.bold_id || "",
                        bold_sdnis: alert.bold_sdnis || "",
                        bold_zone: alert.bold_zone || "",
                        bold_alarmtype: alert.bold_alarmtype || ""
                    };
                });
                setLocalBoldAlerts(localBoldAlerts);
            }
        }
        if (cameraStreamsPatchObject && cameraStreamsObject[cameraStreamsSelectedIndex]?.patriot_alerts) {
            const alerts = cameraStreamsPatchObject[cameraStreamsSelectedIndex]?.patriot_alerts;
            if (alerts) {
                const localPatriotAlerts = {};
                alerts.forEach((alert, index)=>{
                    if (alert?.id) localPatriotAlerts[alert.id] = {
                        patriot_server: alert.patriot_server || "",
                        patriot_client_no: alert.patriot_client_no || "",
                        patriot_username: alert.patriot_username || "",
                        patriot_password: alert.patriot_password || "",
                        patriot_zone_number: alert.patriot_zone_number || "",
                        patriot_send_video: alert.patriot_send_video || false,
                        patriot_type_number: alert.patriot_type_number || "",
                        draw_ignore_zones: alert.draw_ignore_zones || false
                    };
                });
                setLocalPatriotAlerts(localPatriotAlerts);
            }
        }
        if (cameraStreamsPatchObject && cameraStreamsObject[cameraStreamsSelectedIndex]?.softguard_alerts) {
            const alerts = cameraStreamsPatchObject[cameraStreamsSelectedIndex]?.softguard_alerts;
            if (alerts) {
                const localSoftguardAlerts = {};
                alerts.forEach((alert, index)=>{
                    if (alert?.id) localSoftguardAlerts[alert.id] = {
                        server: alert.server || "",
                        port: alert.port || "",
                        zone: alert.zone || "",
                        account: alert.account || "",
                        user: alert.user || "",
                        user_ext: alert.user_ext || ""
                    };
                });
                setLocalSoftguardAlerts(localSoftguardAlerts);
            }
        }
        if (cameraStreamsPatchObject && cameraStreamsObject[cameraStreamsSelectedIndex]?.sysaid_alerts) {
            const alerts = cameraStreamsPatchObject[cameraStreamsSelectedIndex]?.sysaid_alerts;
            if (alerts) {
                const localSysaidAlerts = {};
                alerts.forEach((alert, index)=>{
                    if (alert?.id) localSysaidAlerts[alert.id] = {
                        sysaid_server: alert.sysaid_server || "",
                        sysaid_client_local: alert.sysaid_client_local || "",
                        sysaid_username: alert.sysaid_username || "",
                        sysaid_password: alert.sysaid_password || ""
                    };
                });
                setLocalSysaidAlerts(localSysaidAlerts);
            }
        }
        if (cameraStreamsPatchObject && cameraStreamsObject[cameraStreamsSelectedIndex]?.evalink_alerts) {
            const alerts = cameraStreamsPatchObject[cameraStreamsSelectedIndex]?.evalink_alerts;
            if (alerts) {
                const localEvalinkAlertsData = {};
                alerts.forEach((alert)=>{
                    if (alert?.id) localEvalinkAlertsData[alert.id] = {
                        evalink_token: alert.evalink_token || "",
                        evalink_device_id: alert.evalink_device_id || "",
                        evalink_company_id: alert.evalink_company_id || "",
                        partition_id: alert.partition_id || "",
                        alarm_zone_id: alert.alarm_zone_id || "",
                        active: alert.active ?? true
                    };
                });
                setLocalEvalinkAlerts(localEvalinkAlertsData);
            }
        }
    }, [
        cameraStreamsPatchObject,
        cameraStreamsSelectedIndex,
        cameraStreamsObject,
        cameraStreams
    ]);
    const handleClickShowPassword = (passwordId)=>{
        setShowPasswords((prev)=>({
                ...prev,
                [passwordId]: !prev[passwordId]
            }));
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setPatchObject((previousState)=>{
            return {
                ...previousState,
                streams: cameraGeneralInfo.streams
            };
        });
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "relative w-full min-w-[1150px]",
        children: [
            cameraStreams && cameraStreams.length > 1 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "bg-white",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $34PsC.default), {})
            }),
            immixAlertsOnCamera && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "pb-[20px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "min-w-[1150px] h-[60px] bg-white",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                            variant: "h6",
                            gutterBottom: true,
                            component: "div",
                            sx: {
                                fontFamily: "Mulish",
                                fontWeight: "Bold",
                                color: "black",
                                textIndent: "1vw",
                                paddingTop: "10px",
                                paddingBottom: "10px"
                            },
                            children: "Immix Alerts"
                        })
                    }),
                    cameraStreamsPatchObject && cameraStreamsPatchObject[cameraStreamsSelectedIndex] && (cameraStreamsPatchObject[cameraStreamsSelectedIndex]?.immix_alerts?.length ?? 0) > 0 && cameraStreamsPatchObject[cameraStreamsSelectedIndex]?.immix_alerts?.map((object, index)=>{
                        const currentIndex = index;
                        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "h-[208px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "min-w-[1150px] h-[80px] bg-white",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "flex",
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                            gutterBottom: true,
                                            component: "div",
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: "Bold",
                                                color: "black",
                                                textIndent: "1vw",
                                                paddingTop: "10px"
                                            },
                                            children: [
                                                "Immix Alert ",
                                                index + 1
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                        component: (0, $4reBM.default),
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                            sx: {
                                                minWidth: 1000,
                                                fontFamily: "Mulish"
                                            },
                                            "aria-label": "simple table",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                    titlesArray: [
                                                        "Immix Server",
                                                        "Immix Port",
                                                        "Immix Email",
                                                        "Immix input 1",
                                                        "Draw Ignore Zones"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.immix_server,
                                                                        value: localImmixAlerts[object.id]?.immix_server || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalImmixAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        immix_server: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    immix: {
                                                                                        ...prev.immix,
                                                                                        [object.id]: {
                                                                                            ...localImmixAlerts?.[object.id],
                                                                                            immix_server: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    immix: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.immix_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.immix_server = localImmixAlerts[object.id]?.immix_server || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.immix_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.immix_server)
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.immix_port,
                                                                        value: localImmixAlerts[object.id]?.immix_port || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalImmixAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        immix_port: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    immix: {
                                                                                        ...prev.immix,
                                                                                        [object.id]: {
                                                                                            ...localImmixAlerts?.[object.id],
                                                                                            immix_port: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    immix: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.immix_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.immix_port = localImmixAlerts[object.id]?.immix_port || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.immix_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.immix_port)
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.immix_email,
                                                                        value: localImmixAlerts[object.id]?.immix_email || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalImmixAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        immix_email: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    immix: {
                                                                                        ...prev.immix,
                                                                                        [object.id]: {
                                                                                            ...localImmixAlerts?.[object.id],
                                                                                            immix_email: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    immix: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.immix_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.immix_email = localImmixAlerts[object.id]?.immix_email || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.immix_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.immix_email)
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.immix_input1,
                                                                        value: localImmixAlerts[object.id]?.immix_input1 || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalImmixAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        immix_input1: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    immix: {
                                                                                        ...prev.immix,
                                                                                        [object.id]: {
                                                                                            ...localImmixAlerts?.[object.id],
                                                                                            immix_input1: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    immix: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.immix_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.immix_input1 = localImmixAlerts[object.id]?.immix_input1 || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.immix_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.immix_input1)
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                                        id: object.draw_ignore_zones,
                                                                        checked: localImmixAlerts[object.id]?.draw_ignore_zones || false,
                                                                        color: "warning",
                                                                        onChange: (event, checked)=>{
                                                                            setLocalImmixAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        draw_ignore_zones: checked
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    immix: {
                                                                                        ...prev.immix,
                                                                                        [object.id]: {
                                                                                            ...localImmixAlerts?.[object.id],
                                                                                            draw_ignore_zones: checked
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    immix: true
                                                                                }));
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.immix_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.draw_ignore_zones = checked;
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.immix_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.draw_ignore_zones)
                                                            })
                                                        ]
                                                    }, object.id)
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }, object.id);
                    })
                ]
            }, "immixAlerts"),
            diceAlertsOnCamera && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "pb-[20px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "min-w-[1150px] h-[60px] bg-white",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                            variant: "h6",
                            gutterBottom: true,
                            component: "div",
                            sx: {
                                fontFamily: "Mulish",
                                fontWeight: "Bold",
                                color: "black",
                                textIndent: "1vw",
                                paddingTop: "10px",
                                paddingBottom: "10px"
                            },
                            children: "Dice Alerts"
                        })
                    }),
                    cameraStreamsPatchObject && cameraStreamsPatchObject[cameraStreamsSelectedIndex] && (cameraStreamsPatchObject[cameraStreamsSelectedIndex]?.dice_alerts?.length ?? 0) > 0 && cameraStreamsPatchObject[cameraStreamsSelectedIndex]?.dice_alerts?.map((object, index)=>{
                        const currentIndex = index;
                        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "h-[208px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "min-w-[1150px] h-[80px] bg-white",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "flex",
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                            gutterBottom: true,
                                            component: "div",
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: "Bold",
                                                color: "black",
                                                textIndent: "1vw",
                                                paddingTop: "10px"
                                            },
                                            children: [
                                                "Dice Alert ",
                                                index + 1
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                        component: (0, $4reBM.default),
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                            sx: {
                                                minWidth: 1000,
                                                fontFamily: "Mulish"
                                            },
                                            "aria-label": "simple table",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                    titlesArray: [
                                                        "Dice Server",
                                                        "Dice Port",
                                                        "Dice Email",
                                                        "Dice input 1",
                                                        "Draw Ignore Zones"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.dice_server,
                                                                        value: localDiceAlerts[object.id]?.dice_server || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalDiceAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        dice_server: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    dice: {
                                                                                        ...prev.dice,
                                                                                        [object.id]: {
                                                                                            ...localDiceAlerts?.[object.id],
                                                                                            dice_server: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    dice: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.dice_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.dice_server = localDiceAlerts[object.id]?.dice_server || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.dice_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.dice_server)
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.dice_port,
                                                                        value: localDiceAlerts[object.id]?.dice_port || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalDiceAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        dice_port: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    dice: {
                                                                                        ...prev.dice,
                                                                                        [object.id]: {
                                                                                            ...localDiceAlerts?.[object.id],
                                                                                            dice_port: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    dice: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.dice_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.dice_port = localDiceAlerts[object.id]?.dice_port || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.dice_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.dice_port)
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.dice_email,
                                                                        value: localDiceAlerts[object.id]?.dice_email || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalDiceAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        dice_email: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    dice: {
                                                                                        ...prev.dice,
                                                                                        [object.id]: {
                                                                                            ...localDiceAlerts?.[object.id],
                                                                                            dice_email: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    dice: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.dice_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.dice_email = localDiceAlerts[object.id]?.dice_email || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.dice_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.dice_email)
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.dice_input1,
                                                                        value: localDiceAlerts[object.id]?.dice_input1 || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalDiceAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        dice_input1: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    dice: {
                                                                                        ...prev.dice,
                                                                                        [object.id]: {
                                                                                            ...localDiceAlerts?.[object.id],
                                                                                            dice_input1: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    dice: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.dice_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.dice_input1 = localDiceAlerts[object.id]?.dice_input1 || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.dice_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.dice_input1)
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                                        id: object.draw_ignore_zones,
                                                                        checked: localDiceAlerts[object.id]?.draw_ignore_zones || false,
                                                                        color: "warning",
                                                                        onChange: (event, checked)=>{
                                                                            setLocalDiceAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        draw_ignore_zones: checked
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    dice: {
                                                                                        ...prev.dice,
                                                                                        [object.id]: {
                                                                                            ...localDiceAlerts?.[object.id],
                                                                                            draw_ignore_zones: checked
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    dice: true
                                                                                }));
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.dice_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.draw_ignore_zones = checked;
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.dice_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.draw_ignore_zones)
                                                            })
                                                        ]
                                                    }, object.id)
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }, object.id);
                    })
                ]
            }, "diceAlerts"),
            sureViewAlertsOnCamera && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "pb-[20px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "min-w-[1150px] h-[60px] bg-white",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                            variant: "h6",
                            gutterBottom: true,
                            component: "div",
                            sx: {
                                fontFamily: "Mulish",
                                fontWeight: "Bold",
                                color: "black",
                                textIndent: "1vw",
                                paddingTop: "10px",
                                paddingBottom: "10px"
                            },
                            children: "Sureview Alerts"
                        })
                    }),
                    cameraStreamsPatchObject && cameraStreamsPatchObject[cameraStreamsSelectedIndex] && (cameraStreamsPatchObject[cameraStreamsSelectedIndex]?.sureview_alerts?.length ?? 0) > 0 && cameraStreamsPatchObject[cameraStreamsSelectedIndex]?.sureview_alerts?.map((object, index)=>{
                        const currentIndex = index;
                        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "h-[208px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "min-w-[1150px] h-[80px] bg-white",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "flex",
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                            gutterBottom: true,
                                            component: "div",
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: "Bold",
                                                color: "black",
                                                textIndent: "1vw",
                                                paddingTop: "10px"
                                            },
                                            children: [
                                                "Sureview Alert ",
                                                index + 1
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                        component: (0, $4reBM.default),
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                            sx: {
                                                minWidth: 1000,
                                                fontFamily: "Mulish"
                                            },
                                            "aria-label": "simple table",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                    titlesArray: [
                                                        "Sureview Server",
                                                        "Sureview Subject",
                                                        "Sureview cc",
                                                        "Sureview Email"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                                                        disablePortal: true,
                                                                        id: object.sureview_server,
                                                                        options: sureviewServerOptions.map((option)=>{
                                                                            return option[0];
                                                                        }),
                                                                        value: sureViewOptionNames.get(localSureviewAlerts[object.id]?.sureview_server || "") || "",
                                                                        onChange: (event, newInputValue)=>{
                                                                            const convertedInputValue = sureViewOptionIds.get(newInputValue);
                                                                            setLocalSureviewAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        sureview_server: convertedInputValue || ""
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    sureview: {
                                                                                        ...prev.sureview,
                                                                                        [object.id]: {
                                                                                            ...localSureviewAlerts?.[object.id],
                                                                                            sureview_server: convertedInputValue
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    sureview: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.sureview_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.sureview_server = localSureviewAlerts[object.id]?.sureview_server || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.sureview_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        },
                                                                        sx: {
                                                                            width: 350
                                                                        },
                                                                        renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                                ...params,
                                                                                variant: "standard",
                                                                                label: "Sureview Server",
                                                                                autoComplete: "off",
                                                                                id: object.sureview_server,
                                                                                name: object.sureview_server
                                                                            })
                                                                    })
                                                                }, object.sureview_server)
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.sureview_subject,
                                                                        value: localSureviewAlerts[object.id]?.sureview_subject || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalSureviewAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        sureview_subject: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    sureview: {
                                                                                        ...prev.sureview,
                                                                                        [object.id]: {
                                                                                            ...localSureviewAlerts?.[object.id],
                                                                                            sureview_subject: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    sureview: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.sureview_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.sureview_subject = localSureviewAlerts[object.id]?.sureview_subject || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.sureview_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.sureview_subject)
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.sureview_cc,
                                                                        value: localSureviewAlerts[object.id]?.sureview_cc || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalSureviewAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        sureview_cc: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    sureview: {
                                                                                        ...prev.sureview,
                                                                                        [object.id]: {
                                                                                            ...localSureviewAlerts?.[object.id],
                                                                                            sureview_cc: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    sureview: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.sureview_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.sureview_cc = localSureviewAlerts[object.id]?.sureview_cc || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.sureview_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.sureview_cc)
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.sureview_email,
                                                                        value: localSureviewAlerts[object.id]?.sureview_email || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalSureviewAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        sureview_email: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    sureview: {
                                                                                        ...prev.sureview,
                                                                                        [object.id]: {
                                                                                            ...localSureviewAlerts?.[object.id],
                                                                                            sureview_email: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    sureview: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.sureview_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.sureview_email = localSureviewAlerts[object.id]?.sureview_email || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.sureview_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.sureview_email)
                                                            })
                                                        ]
                                                    }, object.id)
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }, object.id);
                    })
                ]
            }, "sureviewAlerts"),
            (webhooksData || siteInfo.webhooks || webhooksAlertsOnCamera) && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "pb-[20px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "min-w-[1150px] h-[60px] bg-white flex relative",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                variant: "h6",
                                gutterBottom: true,
                                component: "div",
                                sx: {
                                    fontFamily: "Mulish",
                                    fontWeight: "Bold",
                                    color: "black",
                                    textIndent: "1vw",
                                    paddingTop: "10px",
                                    paddingBottom: "10px"
                                },
                                children: "Webhooks"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "absolute right-[70px] pt-[10px]",
                                children: userPermissions.edit_cameras && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    onClick: ()=>{
                                        setAddStreamWebhookDialogOpen(true);
                                    },
                                    text: "+ Add Stream Webhook",
                                    disabled: false
                                })
                            })
                        ]
                    }),
                    webhooksData && webhooksData[0] && webhooksData.filter((object)=>cameraStreams && cameraStreams[cameraStreamsSelectedIndex] && object.stream.id === cameraStreams[cameraStreamsSelectedIndex].id).map((object, index)=>{
                        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "h-[168px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "min-w-[1150px] h-[60px] bg-white",
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                        gutterBottom: true,
                                        component: "div",
                                        sx: {
                                            fontFamily: "Mulish",
                                            fontWeight: "Bold",
                                            color: "black",
                                            textIndent: "1vw",
                                            paddingTop: "10px"
                                        },
                                        children: [
                                            "Stream Webhook ",
                                            index + 1,
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                onClick: ()=>{
                                                    localStorage.setItem("selectedWebhook", JSON.stringify(object));
                                                    setEditStreamWebhookDialogOpen(true);
                                                },
                                                text: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {
                                                        fontSize: "small"
                                                    })
                                                }),
                                                disabled: false
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                onClick: ()=>{
                                                    setDeleteWebhookDialogOpen(true);
                                                    setWebhookIdToDelete(object.id);
                                                },
                                                text: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ka01y))), {
                                                        fontSize: "small"
                                                    })
                                                }),
                                                disabled: false
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                        component: (0, $4reBM.default),
                                        sx: {
                                            width: "100%"
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                            sx: {
                                                width: "100%",
                                                fontFamily: "Mulish",
                                                tableLayout: "fixed"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                    titlesArray: webhooksTitlesArray
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    width: "33.33%",
                                                                    wordWrap: "break-word"
                                                                },
                                                                children: object.webhook.display_name ? object.webhook.display_name : ""
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    width: "33.33%",
                                                                    wordWrap: "break-word"
                                                                },
                                                                children: object.custom_fields ? `${JSON.stringify(object.custom_fields)}` : ""
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    width: "33.33%",
                                                                    wordWrap: "break-word"
                                                                },
                                                                children: object.event_types ? object.event_types[0] ? object.event_types.map((eventType, eventIndex)=>{
                                                                    const isLast = eventIndex === object.event_types.length - 1;
                                                                    return `${handleConvertTypeToString(eventType)}${isLast ? "" : ", "}`;
                                                                }) : "" : ""
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }, object.id);
                    })
                ]
            }, "webhooks"),
            sentinelAlertsOnCamera && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "pb-[20px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "min-w-[1150px] h-[60px] bg-white",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                            variant: "h6",
                            gutterBottom: true,
                            component: "div",
                            sx: {
                                fontFamily: "Mulish",
                                fontWeight: "Bold",
                                color: "black",
                                textIndent: "1vw",
                                paddingTop: "10px",
                                paddingBottom: "10px"
                            },
                            children: "Sentinel Alerts"
                        })
                    }),
                    cameraStreamsPatchObject && cameraStreamsPatchObject[cameraStreamsSelectedIndex] && (cameraStreamsPatchObject[cameraStreamsSelectedIndex]?.sentinel_alerts?.length ?? 0) > 0 && cameraStreamsPatchObject[cameraStreamsSelectedIndex]?.sentinel_alerts?.map((object, index)=>{
                        const currentIndex = index;
                        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "h-[208px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "min-w-[1150px] h-[80px] bg-white",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "flex",
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                            gutterBottom: true,
                                            component: "div",
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: "Bold",
                                                color: "black",
                                                textIndent: "1vw",
                                                paddingTop: "10px"
                                            },
                                            children: [
                                                "Sentinel Alert ",
                                                index + 1
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                        component: (0, $4reBM.default),
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                            sx: {
                                                minWidth: 1000,
                                                fontFamily: "Mulish"
                                            },
                                            "aria-label": "simple table",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                    titlesArray: [
                                                        "Sentinel Server",
                                                        "Sentinel Site Id",
                                                        "Sentinel Device Address",
                                                        "Draw Ignore Zones"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.sentinel_server,
                                                                        value: localSentinelAlerts[object.id]?.sentinel_server || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalSentinelAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        sentinel_server: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    sentinel: {
                                                                                        ...prev.sentinel,
                                                                                        [object.id]: {
                                                                                            ...localSentinelAlerts?.[object.id],
                                                                                            sentinel_server: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    sentinel: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.sentinel_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.sentinel_server = localSentinelAlerts[object.id]?.sentinel_server || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.sentinel_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.sentinel_server)
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.sentinel_site_id,
                                                                        value: localSentinelAlerts[object.id]?.sentinel_site_id || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalSentinelAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        sentinel_site_id: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    sentinel: {
                                                                                        ...prev.sentinel,
                                                                                        [object.id]: {
                                                                                            ...localSentinelAlerts?.[object.id],
                                                                                            sentinel_site_id: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    sentinel: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.sentinel_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.sentinel_site_id = localSentinelAlerts[object.id]?.sentinel_site_id || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.sentinel_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.sentinel_site_id)
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.sentinel_device_address,
                                                                        value: localSentinelAlerts[object.id]?.sentinel_device_address || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalSentinelAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        sentinel_device_address: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    sentinel: {
                                                                                        ...prev.sentinel,
                                                                                        [object.id]: {
                                                                                            ...localSentinelAlerts?.[object.id],
                                                                                            sentinel_device_address: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.sentinel_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.sentinel_device_address = localSentinelAlerts[object.id]?.sentinel_device_address || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.sentinel_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.sentinel_device_address)
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                                        id: object.draw_ignore_zones,
                                                                        checked: localSentinelAlerts[object.id]?.draw_ignore_zones || false,
                                                                        color: "warning",
                                                                        onChange: (event, checked)=>{
                                                                            setLocalSentinelAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        draw_ignore_zones: checked
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    sentinel: {
                                                                                        ...prev.sentinel,
                                                                                        [object.id]: {
                                                                                            ...localSentinelAlerts?.[object.id],
                                                                                            draw_ignore_zones: checked
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    sentinel: true
                                                                                }));
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.sentinel_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.draw_ignore_zones = checked;
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.sentinel_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.draw_ignore_zones)
                                                            })
                                                        ]
                                                    }, object.id)
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }, object.id);
                    })
                ]
            }, "sentinelAlerts"),
            boldAlertsOnCamera && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "pb-[20px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "min-w-[1150px] h-[60px] bg-white",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                            variant: "h6",
                            gutterBottom: true,
                            component: "div",
                            sx: {
                                fontFamily: "Mulish",
                                fontWeight: "Bold",
                                color: "black",
                                textIndent: "1vw",
                                paddingTop: "10px",
                                paddingBottom: "10px"
                            },
                            children: "Bold Alerts"
                        })
                    }),
                    cameraStreamsPatchObject && cameraStreamsPatchObject[cameraStreamsSelectedIndex] && (cameraStreamsPatchObject[cameraStreamsSelectedIndex]?.bold_alerts?.length ?? 0) > 0 && cameraStreamsPatchObject[cameraStreamsSelectedIndex]?.bold_alerts?.map((object, index)=>{
                        const currentIndex = index;
                        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "h-[208px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "min-w-[1150px] h-[80px] bg-white",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "flex",
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                            gutterBottom: true,
                                            component: "div",
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: "Bold",
                                                color: "black",
                                                textIndent: "1vw",
                                                paddingTop: "10px"
                                            },
                                            children: [
                                                "Bold Alert ",
                                                index + 1
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                        component: (0, $4reBM.default),
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                            sx: {
                                                minWidth: 1000,
                                                fontFamily: "Mulish"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                    titlesArray: [
                                                        "Bold Server",
                                                        "Bold port",
                                                        "Bold id",
                                                        "Bold sdnis",
                                                        "Bold Zone",
                                                        "Bold Alarm Type"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.bold_server,
                                                                        value: localBoldAlerts[object.id]?.bold_server || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalBoldAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        bold_server: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    bold: {
                                                                                        ...prev.bold,
                                                                                        [object.id]: {
                                                                                            ...localBoldAlerts?.[object.id],
                                                                                            bold_server: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    bold: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.bold_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.bold_server = localBoldAlerts[object.id]?.bold_server || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.bold_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.bold_server)
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.bold_port,
                                                                        value: localBoldAlerts[object.id]?.bold_port || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalBoldAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        bold_port: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    bold: {
                                                                                        ...prev.bold,
                                                                                        [object.id]: {
                                                                                            ...localBoldAlerts?.[object.id],
                                                                                            bold_port: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    bold: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.bold_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.bold_port = localBoldAlerts[object.id]?.bold_port || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.bold_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.bold_port)
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.bold_id,
                                                                        value: localBoldAlerts[object.id]?.bold_id || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalBoldAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        bold_id: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    bold: {
                                                                                        ...prev.bold,
                                                                                        [object.id]: {
                                                                                            ...localBoldAlerts?.[object.id],
                                                                                            bold_id: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    bold: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.bold_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.bold_id = localBoldAlerts[object.id]?.bold_id || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.bold_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.bold_id)
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.bold_sdnis,
                                                                        value: localBoldAlerts[object.id]?.bold_sdnis || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalBoldAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        bold_sdnis: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    bold: {
                                                                                        ...prev.bold,
                                                                                        [object.id]: {
                                                                                            ...localBoldAlerts?.[object.id],
                                                                                            bold_sdnis: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    bold: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.bold_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.bold_sdnis = localBoldAlerts[object.id]?.bold_sdnis || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.bold_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.bold_sdnis)
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.bold_zone,
                                                                        value: localBoldAlerts[object.id]?.bold_zone || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalBoldAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        bold_zone: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    bold: {
                                                                                        ...prev.bold,
                                                                                        [object.id]: {
                                                                                            ...localBoldAlerts?.[object.id],
                                                                                            bold_zone: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    bold: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.bold_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.bold_zone = localBoldAlerts[object.id]?.bold_zone || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.bold_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.bold_zone)
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.bold_alarmtype,
                                                                        value: localBoldAlerts[object.id]?.bold_alarmtype || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalBoldAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        bold_alarmtype: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    bold: {
                                                                                        ...prev.bold,
                                                                                        [object.id]: {
                                                                                            ...localBoldAlerts?.[object.id],
                                                                                            bold_alarmtype: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    bold: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.bold_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.bold_alarmtype = localBoldAlerts[object.id]?.bold_alarmtype || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.bold_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.bold_alarmtype)
                                                            })
                                                        ]
                                                    }, object.id)
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }, object.id);
                    })
                ]
            }, "boldAlerts"),
            patriotAlertsOnCamera && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "pb-[20px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "min-w-[1150px] h-[60px] bg-white",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                            variant: "h6",
                            gutterBottom: true,
                            component: "div",
                            sx: {
                                fontFamily: "Mulish",
                                fontWeight: "Bold",
                                color: "black",
                                textIndent: "1vw",
                                paddingTop: "10px",
                                paddingBottom: "10px"
                            },
                            children: "Patriot Alerts"
                        })
                    }),
                    cameraStreamsPatchObject && cameraStreamsPatchObject[cameraStreamsSelectedIndex] && (cameraStreamsPatchObject[cameraStreamsSelectedIndex]?.patriot_alerts?.length ?? 0) > 0 && cameraStreamsPatchObject[cameraStreamsSelectedIndex]?.patriot_alerts?.map((object, index)=>{
                        const currentIndex = index;
                        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "min-h-[208px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "min-w-[1150px] h-[80px] bg-white",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "flex",
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                            gutterBottom: true,
                                            component: "div",
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: "Bold",
                                                color: "black",
                                                textIndent: "1vw",
                                                paddingTop: "10px"
                                            },
                                            children: [
                                                "Patriot Alert ",
                                                index + 1
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                            component: (0, $4reBM.default),
                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                                sx: {
                                                    minWidth: 1000,
                                                    fontFamily: "Mulish"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                        titlesArray: [
                                                            "Patriot Server",
                                                            "Patriot client no",
                                                            "Patriot username",
                                                            "Patriot password",
                                                            "Patriot zone number",
                                                            "Patriot type number",
                                                            (0, $hG03Q.PATRIOT_DELIVERY_LABEL)
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                            id: object.patriot_server,
                                                                            value: localPatriotAlerts[object.id]?.patriot_server || "",
                                                                            variant: "standard",
                                                                            sx: {
                                                                                width: 150
                                                                            },
                                                                            type: "string",
                                                                            onChange: (event)=>{
                                                                                setLocalPatriotAlerts((prev)=>({
                                                                                        ...prev,
                                                                                        [object.id]: {
                                                                                            ...prev[object.id],
                                                                                            patriot_server: event.target.value
                                                                                        }
                                                                                    }));
                                                                                setUpdatedAlertStreams((prev)=>({
                                                                                        ...prev,
                                                                                        patriot: {
                                                                                            ...prev.patriot,
                                                                                            [object.id]: {
                                                                                                ...localPatriotAlerts?.[object.id],
                                                                                                patriot_server: event.target.value
                                                                                            }
                                                                                        }
                                                                                    }));
                                                                                setUpdatedAlertStreamTypes((prev)=>({
                                                                                        ...prev,
                                                                                        patriot: true
                                                                                    }));
                                                                            },
                                                                            onBlur: ()=>{
                                                                                setCameraStreamsPatchObject((previousState)=>{
                                                                                    const newState = [
                                                                                        ...previousState || []
                                                                                    ];
                                                                                    const newStream = {
                                                                                        ...newState[cameraStreamsSelectedIndex]
                                                                                    };
                                                                                    const newAlerts = [
                                                                                        ...newStream.patriot_alerts || []
                                                                                    ];
                                                                                    const newAlert = {
                                                                                        ...newAlerts[currentIndex]
                                                                                    };
                                                                                    newAlert.patriot_server = localPatriotAlerts[object.id]?.patriot_server || "";
                                                                                    newAlerts[currentIndex] = newAlert;
                                                                                    newStream.patriot_alerts = newAlerts;
                                                                                    newState[cameraStreamsSelectedIndex] = newStream;
                                                                                    return newState;
                                                                                });
                                                                            // setStreamChangesMade(true);
                                                                            }
                                                                        })
                                                                    }, object.patriot_server)
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                            id: object.patriot_client_no,
                                                                            value: localPatriotAlerts[object.id]?.patriot_client_no || "",
                                                                            variant: "standard",
                                                                            sx: {
                                                                                width: 150
                                                                            },
                                                                            type: "string",
                                                                            onChange: (event)=>{
                                                                                setLocalPatriotAlerts((prev)=>({
                                                                                        ...prev,
                                                                                        [object.id]: {
                                                                                            ...prev[object.id],
                                                                                            patriot_client_no: event.target.value
                                                                                        }
                                                                                    }));
                                                                                setUpdatedAlertStreams((prev)=>({
                                                                                        ...prev,
                                                                                        patriot: {
                                                                                            ...prev.patriot,
                                                                                            [object.id]: {
                                                                                                ...localPatriotAlerts?.[object.id],
                                                                                                patriot_client_no: event.target.value
                                                                                            }
                                                                                        }
                                                                                    }));
                                                                                setUpdatedAlertStreamTypes((prev)=>({
                                                                                        ...prev,
                                                                                        patriot: true
                                                                                    }));
                                                                            },
                                                                            onBlur: ()=>{
                                                                                setCameraStreamsPatchObject((previousState)=>{
                                                                                    const newState = [
                                                                                        ...previousState || []
                                                                                    ];
                                                                                    const newStream = {
                                                                                        ...newState[cameraStreamsSelectedIndex]
                                                                                    };
                                                                                    const newAlerts = [
                                                                                        ...newStream.patriot_alerts || []
                                                                                    ];
                                                                                    const newAlert = {
                                                                                        ...newAlerts[currentIndex]
                                                                                    };
                                                                                    newAlert.patriot_client_no = localPatriotAlerts[object.id]?.patriot_client_no || "";
                                                                                    newAlerts[currentIndex] = newAlert;
                                                                                    newStream.patriot_alerts = newAlerts;
                                                                                    newState[cameraStreamsSelectedIndex] = newStream;
                                                                                    return newState;
                                                                                });
                                                                            // setStreamChangesMade(true);
                                                                            }
                                                                        })
                                                                    }, object.patriot_client_no)
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                            id: object.patriot_username,
                                                                            value: localPatriotAlerts[object.id]?.patriot_username || "",
                                                                            variant: "standard",
                                                                            sx: {
                                                                                width: 150
                                                                            },
                                                                            type: "string",
                                                                            onChange: (event)=>{
                                                                                setLocalPatriotAlerts((prev)=>({
                                                                                        ...prev,
                                                                                        [object.id]: {
                                                                                            ...prev[object.id],
                                                                                            patriot_username: event.target.value
                                                                                        }
                                                                                    }));
                                                                                setUpdatedAlertStreams((prev)=>({
                                                                                        ...prev,
                                                                                        patriot: {
                                                                                            ...prev.patriot,
                                                                                            [object.id]: {
                                                                                                ...localPatriotAlerts?.[object.id],
                                                                                                patriot_username: event.target.value
                                                                                            }
                                                                                        }
                                                                                    }));
                                                                                setUpdatedAlertStreamTypes((prev)=>({
                                                                                        ...prev,
                                                                                        patriot: true
                                                                                    }));
                                                                            },
                                                                            onBlur: ()=>{
                                                                                setCameraStreamsPatchObject((previousState)=>{
                                                                                    const newState = [
                                                                                        ...previousState || []
                                                                                    ];
                                                                                    const newStream = {
                                                                                        ...newState[cameraStreamsSelectedIndex]
                                                                                    };
                                                                                    const newAlerts = [
                                                                                        ...newStream.patriot_alerts || []
                                                                                    ];
                                                                                    const newAlert = {
                                                                                        ...newAlerts[currentIndex]
                                                                                    };
                                                                                    newAlert.patriot_username = localPatriotAlerts[object.id]?.patriot_username || "";
                                                                                    newAlerts[currentIndex] = newAlert;
                                                                                    newStream.patriot_alerts = newAlerts;
                                                                                    newState[cameraStreamsSelectedIndex] = newStream;
                                                                                    return newState;
                                                                                });
                                                                            // setStreamChangesMade(true);
                                                                            }
                                                                        })
                                                                    }, object.patriot_username)
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                                                                            variant: "standard",
                                                                            sx: {
                                                                                m: 1,
                                                                                width: 150
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $6gU8O.default), {
                                                                                    htmlFor: "standard-adornment-password",
                                                                                    children: "Password"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $fN7FV.default), {
                                                                                    id: "standard-adornment-password",
                                                                                    type: showPasswords[object.id] ? "text" : "password",
                                                                                    value: localPatriotAlerts[object.id]?.patriot_password || "",
                                                                                    onChange: (event)=>{
                                                                                        setLocalPatriotAlerts((prev)=>({
                                                                                                ...prev,
                                                                                                [object.id]: {
                                                                                                    ...prev[object.id],
                                                                                                    patriot_password: event.target.value
                                                                                                }
                                                                                            }));
                                                                                        setUpdatedAlertStreams((prev)=>({
                                                                                                ...prev,
                                                                                                patriot: {
                                                                                                    ...prev.patriot,
                                                                                                    [object.id]: {
                                                                                                        ...localPatriotAlerts?.[object.id],
                                                                                                        patriot_password: event.target.value
                                                                                                    }
                                                                                                }
                                                                                            }));
                                                                                        setUpdatedAlertStreamTypes((prev)=>({
                                                                                                ...prev,
                                                                                                patriot: true
                                                                                            }));
                                                                                    },
                                                                                    onBlur: ()=>{
                                                                                        setCameraStreamsPatchObject((previousState)=>{
                                                                                            const newState = [
                                                                                                ...previousState || []
                                                                                            ];
                                                                                            const newStream = {
                                                                                                ...newState[cameraStreamsSelectedIndex]
                                                                                            };
                                                                                            const newAlerts = [
                                                                                                ...newStream.patriot_alerts || []
                                                                                            ];
                                                                                            const newAlert = {
                                                                                                ...newAlerts[currentIndex]
                                                                                            };
                                                                                            newAlert.patriot_password = localPatriotAlerts[object.id]?.patriot_password || "";
                                                                                            newAlerts[currentIndex] = newAlert;
                                                                                            newStream.patriot_alerts = newAlerts;
                                                                                            newState[cameraStreamsSelectedIndex] = newStream;
                                                                                            return newState;
                                                                                        });
                                                                                    // setStreamChangesMade(true);
                                                                                    },
                                                                                    endAdornment: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1SPe4.default), {
                                                                                        position: "end",
                                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                                                                            "aria-label": "toggle password visibility",
                                                                                            onClick: ()=>handleClickShowPassword(object.id),
                                                                                            onMouseDown: (event)=>{
                                                                                                event.preventDefault();
                                                                                            },
                                                                                            edge: "end",
                                                                                            children: showPasswords[object.id] ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $4m1S6.default), {}) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $2yNMw.default), {})
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }, object.patriot_password)
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                            id: object.patriot_zone_number,
                                                                            value: localPatriotAlerts[object.id]?.patriot_zone_number || "",
                                                                            variant: "standard",
                                                                            sx: {
                                                                                width: 150
                                                                            },
                                                                            type: "string",
                                                                            onChange: (event)=>{
                                                                                setLocalPatriotAlerts((prev)=>({
                                                                                        ...prev,
                                                                                        [object.id]: {
                                                                                            ...prev[object.id],
                                                                                            patriot_zone_number: event.target.value
                                                                                        }
                                                                                    }));
                                                                                setUpdatedAlertStreams((prev)=>({
                                                                                        ...prev,
                                                                                        patriot: {
                                                                                            ...prev.patriot,
                                                                                            [object.id]: {
                                                                                                ...localPatriotAlerts?.[object.id],
                                                                                                patriot_zone_number: event.target.value
                                                                                            }
                                                                                        }
                                                                                    }));
                                                                                setUpdatedAlertStreamTypes((prev)=>({
                                                                                        ...prev,
                                                                                        patriot: true
                                                                                    }));
                                                                            },
                                                                            onBlur: ()=>{
                                                                                setCameraStreamsPatchObject((previousState)=>{
                                                                                    const newState = [
                                                                                        ...previousState || []
                                                                                    ];
                                                                                    const newStream = {
                                                                                        ...newState[cameraStreamsSelectedIndex]
                                                                                    };
                                                                                    const newAlerts = [
                                                                                        ...newStream.patriot_alerts || []
                                                                                    ];
                                                                                    const newAlert = {
                                                                                        ...newAlerts[currentIndex]
                                                                                    };
                                                                                    newAlert.patriot_zone_number = localPatriotAlerts[object.id]?.patriot_zone_number || "";
                                                                                    newAlerts[currentIndex] = newAlert;
                                                                                    newStream.patriot_alerts = newAlerts;
                                                                                    newState[cameraStreamsSelectedIndex] = newStream;
                                                                                    return newState;
                                                                                });
                                                                            // setStreamChangesMade(true);
                                                                            }
                                                                        })
                                                                    }, object.patriot_zone_number)
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                            id: object.patriot_type_number,
                                                                            value: localPatriotAlerts[object.id]?.patriot_type_number || "",
                                                                            variant: "standard",
                                                                            sx: {
                                                                                width: 150
                                                                            },
                                                                            type: "string",
                                                                            onChange: (event)=>{
                                                                                setLocalPatriotAlerts((prev)=>({
                                                                                        ...prev,
                                                                                        [object.id]: {
                                                                                            ...prev[object.id],
                                                                                            patriot_type_number: event.target.value
                                                                                        }
                                                                                    }));
                                                                                setUpdatedAlertStreams((prev)=>({
                                                                                        ...prev,
                                                                                        patriot: {
                                                                                            ...prev.patriot,
                                                                                            [object.id]: {
                                                                                                ...localPatriotAlerts?.[object.id],
                                                                                                patriot_type_number: event.target.value
                                                                                            }
                                                                                        }
                                                                                    }));
                                                                                setUpdatedAlertStreamTypes((prev)=>({
                                                                                        ...prev,
                                                                                        patriot: true
                                                                                    }));
                                                                            },
                                                                            onBlur: ()=>{
                                                                                setCameraStreamsPatchObject((previousState)=>{
                                                                                    const newState = [
                                                                                        ...previousState || []
                                                                                    ];
                                                                                    const newStream = {
                                                                                        ...newState[cameraStreamsSelectedIndex]
                                                                                    };
                                                                                    const newAlerts = [
                                                                                        ...newStream.patriot_alerts || []
                                                                                    ];
                                                                                    const newAlert = {
                                                                                        ...newAlerts[currentIndex]
                                                                                    };
                                                                                    newAlert.patriot_type_number = localPatriotAlerts[object.id]?.patriot_type_number || "";
                                                                                    newAlerts[currentIndex] = newAlert;
                                                                                    newStream.patriot_alerts = newAlerts;
                                                                                    newState[cameraStreamsSelectedIndex] = newStream;
                                                                                    return newState;
                                                                                });
                                                                            // setStreamChangesMade(true);
                                                                            }
                                                                        })
                                                                    }, object.patriot_type_number)
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $hG03Q.PatriotDeliveryChoice), {
                                                                        name: `patriot-delivery-${object.id}`,
                                                                        showLabel: false,
                                                                        sendVideo: localPatriotAlerts[object.id]?.patriot_send_video,
                                                                        drawIgnoreZones: localPatriotAlerts[object.id]?.draw_ignore_zones,
                                                                        onChange: (values)=>{
                                                                            setLocalPatriotAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        ...values
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    patriot: {
                                                                                        ...prev.patriot,
                                                                                        [object.id]: {
                                                                                            ...localPatriotAlerts?.[object.id],
                                                                                            ...values
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    patriot: true
                                                                                }));
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.patriot_alerts || []
                                                                                ];
                                                                                newAlerts[currentIndex] = {
                                                                                    ...newAlerts[currentIndex],
                                                                                    ...values
                                                                                };
                                                                                newStream.patriot_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        }, object.id)
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $7txAP.PatriotDeliverySummary), {
                                            sendVideo: localPatriotAlerts[object.id]?.patriot_send_video,
                                            drawIgnoreZones: localPatriotAlerts[object.id]?.draw_ignore_zones
                                        })
                                    ]
                                })
                            ]
                        }, object.id);
                    })
                ]
            }, "patriotAlerts"),
            softguardAlertsOnCamera && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "pb-[20px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "min-w-[1150px] h-[60px] bg-white",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                            variant: "h6",
                            gutterBottom: true,
                            component: "div",
                            sx: {
                                fontFamily: "Mulish",
                                fontWeight: "Bold",
                                color: "black",
                                textIndent: "1vw",
                                paddingTop: "10px",
                                paddingBottom: "10px"
                            },
                            children: "Softguard Alerts"
                        })
                    }),
                    cameraStreamsPatchObject && cameraStreamsPatchObject[cameraStreamsSelectedIndex] && (cameraStreamsPatchObject[cameraStreamsSelectedIndex]?.softguard_alerts?.length ?? 0) > 0 && cameraStreamsPatchObject[cameraStreamsSelectedIndex]?.softguard_alerts?.map((object, index)=>{
                        const currentIndex = index;
                        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "h-[208px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "min-w-[1150px] h-[80px] bg-white",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "flex",
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                            gutterBottom: true,
                                            component: "div",
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: "Bold",
                                                color: "black",
                                                textIndent: "1vw",
                                                paddingTop: "10px"
                                            },
                                            children: [
                                                "Softguard Alert ",
                                                index + 1
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                        component: (0, $4reBM.default),
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                            sx: {
                                                minWidth: 1000,
                                                fontFamily: "Mulish"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                    titlesArray: [
                                                        "Server",
                                                        "Port",
                                                        "Zone",
                                                        "Account",
                                                        "User",
                                                        "User Ext"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.server,
                                                                        value: localSoftguardAlerts[object.id]?.server || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalSoftguardAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        server: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    softguard: {
                                                                                        ...prev.softguard,
                                                                                        [object.id]: {
                                                                                            ...localSoftguardAlerts?.[object.id],
                                                                                            server: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    softguard: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.softguard_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.server = localSoftguardAlerts[object.id]?.server || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.softguard_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.server)
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.port,
                                                                        value: localSoftguardAlerts[object.id]?.port || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalSoftguardAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        port: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    softguard: {
                                                                                        ...prev.softguard,
                                                                                        [object.id]: {
                                                                                            ...localSoftguardAlerts?.[object.id],
                                                                                            port: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    softguard: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.softguard_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.port = localSoftguardAlerts[object.id]?.port || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.softguard_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.port)
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.zone,
                                                                        value: localSoftguardAlerts[object.id]?.zone || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalSoftguardAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        zone: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    softguard: {
                                                                                        ...prev.softguard,
                                                                                        [object.id]: {
                                                                                            ...localSoftguardAlerts?.[object.id],
                                                                                            zone: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    softguard: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.softguard_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.zone = localSoftguardAlerts[object.id]?.zone || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.softguard_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.zone)
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.account,
                                                                        value: localSoftguardAlerts[object.id]?.account || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalSoftguardAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        account: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    softguard: {
                                                                                        ...prev.softguard,
                                                                                        [object.id]: {
                                                                                            ...localSoftguardAlerts?.[object.id],
                                                                                            account: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    softguard: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.softguard_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.account = localSoftguardAlerts[object.id]?.account || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.softguard_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.account)
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.user,
                                                                        value: localSoftguardAlerts[object.id]?.user || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalSoftguardAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        user: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    softguard: {
                                                                                        ...prev.softguard,
                                                                                        [object.id]: {
                                                                                            ...localSoftguardAlerts?.[object.id],
                                                                                            user: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    softguard: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.softguard_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.user = localSoftguardAlerts[object.id]?.user || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.softguard_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.user)
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.user_ext,
                                                                        value: localSoftguardAlerts[object.id]?.user_ext || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalSoftguardAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        user_ext: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    softguard: {
                                                                                        ...prev.softguard,
                                                                                        [object.id]: {
                                                                                            ...localSoftguardAlerts?.[object.id],
                                                                                            user_ext: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    softguard: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.softguard_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.user_ext = localSoftguardAlerts[object.id]?.user_ext || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.softguard_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.user_ext)
                                                            })
                                                        ]
                                                    }, object.id)
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }, object.id);
                    })
                ]
            }, "softguardAlerts"),
            evalinkAlertsOnCamera && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "pb-[20px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "min-w-[1150px] h-[60px] bg-white",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                            variant: "h6",
                            gutterBottom: true,
                            component: "div",
                            sx: {
                                fontFamily: "Mulish",
                                fontWeight: "Bold",
                                color: "black",
                                textIndent: "1vw",
                                paddingTop: "10px",
                                paddingBottom: "10px"
                            },
                            children: "Evalink Alerts"
                        })
                    }),
                    cameraStreamsPatchObject && cameraStreamsPatchObject[cameraStreamsSelectedIndex] && (cameraStreamsPatchObject[cameraStreamsSelectedIndex]?.evalink_alerts?.length ?? 0) > 0 && cameraStreamsPatchObject[cameraStreamsSelectedIndex]?.evalink_alerts?.map((object, index)=>{
                        const currentIndex = index;
                        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "h-[148px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "min-w-[1150px] h-[40px] bg-white",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "flex",
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                            gutterBottom: true,
                                            component: "div",
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: "Bold",
                                                color: "black",
                                                textIndent: "1vw",
                                                paddingTop: "10px"
                                            },
                                            children: [
                                                "Evalink Alert ",
                                                index + 1
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                        component: (0, $4reBM.default),
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                            sx: {
                                                minWidth: 1000,
                                                fontFamily: "Mulish"
                                            },
                                            "aria-label": "simple table",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                    titlesArray: [
                                                        "Evalink Token",
                                                        "Evalink Device ID",
                                                        "Evalink Company ID",
                                                        "Partition ID",
                                                        "Alarm Zone ID"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.evalink_token || "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.evalink_device_id || "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: object.evalink_company_id || "--"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                    value: localEvalinkAlerts[object.id]?.partition_id || "",
                                                                    variant: "standard",
                                                                    sx: {
                                                                        width: 80
                                                                    },
                                                                    type: "string",
                                                                    onChange: (event)=>{
                                                                        setLocalEvalinkAlerts((prev)=>({
                                                                                ...prev,
                                                                                [object.id]: {
                                                                                    ...prev[object.id],
                                                                                    partition_id: event.target.value
                                                                                }
                                                                            }));
                                                                        setUpdatedAlertStreams((prev)=>({
                                                                                ...prev,
                                                                                evalink: {
                                                                                    ...prev.evalink,
                                                                                    [object.id]: {
                                                                                        ...localEvalinkAlerts?.[object.id],
                                                                                        partition_id: event.target.value
                                                                                    }
                                                                                }
                                                                            }));
                                                                        setUpdatedAlertStreamTypes((prev)=>({
                                                                                ...prev,
                                                                                evalink: true
                                                                            }));
                                                                    },
                                                                    onBlur: ()=>{
                                                                        setCameraStreamsPatchObject((previousState)=>{
                                                                            const newState = [
                                                                                ...previousState || []
                                                                            ];
                                                                            const newStream = {
                                                                                ...newState[cameraStreamsSelectedIndex]
                                                                            };
                                                                            const newAlerts = [
                                                                                ...newStream.evalink_alerts || []
                                                                            ];
                                                                            const newAlert = {
                                                                                ...newAlerts[currentIndex]
                                                                            };
                                                                            newAlert.partition_id = localEvalinkAlerts[object.id]?.partition_id || "";
                                                                            newAlerts[currentIndex] = newAlert;
                                                                            newStream.evalink_alerts = newAlerts;
                                                                            newState[cameraStreamsSelectedIndex] = newStream;
                                                                            return newState;
                                                                        });
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                    value: localEvalinkAlerts[object.id]?.alarm_zone_id || "",
                                                                    variant: "standard",
                                                                    sx: {
                                                                        width: 80
                                                                    },
                                                                    type: "string",
                                                                    onChange: (event)=>{
                                                                        setLocalEvalinkAlerts((prev)=>({
                                                                                ...prev,
                                                                                [object.id]: {
                                                                                    ...prev[object.id],
                                                                                    alarm_zone_id: event.target.value
                                                                                }
                                                                            }));
                                                                        setUpdatedAlertStreams((prev)=>({
                                                                                ...prev,
                                                                                evalink: {
                                                                                    ...prev.evalink,
                                                                                    [object.id]: {
                                                                                        ...localEvalinkAlerts?.[object.id],
                                                                                        alarm_zone_id: event.target.value
                                                                                    }
                                                                                }
                                                                            }));
                                                                        setUpdatedAlertStreamTypes((prev)=>({
                                                                                ...prev,
                                                                                evalink: true
                                                                            }));
                                                                    },
                                                                    onBlur: ()=>{
                                                                        setCameraStreamsPatchObject((previousState)=>{
                                                                            const newState = [
                                                                                ...previousState || []
                                                                            ];
                                                                            const newStream = {
                                                                                ...newState[cameraStreamsSelectedIndex]
                                                                            };
                                                                            const newAlerts = [
                                                                                ...newStream.evalink_alerts || []
                                                                            ];
                                                                            const newAlert = {
                                                                                ...newAlerts[currentIndex]
                                                                            };
                                                                            newAlert.alarm_zone_id = localEvalinkAlerts[object.id]?.alarm_zone_id || "";
                                                                            newAlerts[currentIndex] = newAlert;
                                                                            newStream.evalink_alerts = newAlerts;
                                                                            newState[cameraStreamsSelectedIndex] = newStream;
                                                                            return newState;
                                                                        });
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    }, object.id)
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }, object.id);
                    })
                ]
            }, "evalinkAlerts"),
            sysaidAlertsOnCamera && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "pb-[20px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "min-w-[1150px] h-[60px] bg-white",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                            variant: "h6",
                            gutterBottom: true,
                            component: "div",
                            sx: {
                                fontFamily: "Mulish",
                                fontWeight: "Bold",
                                color: "black",
                                textIndent: "1vw",
                                paddingTop: "10px",
                                paddingBottom: "10px"
                            },
                            children: "SysAid Alerts"
                        })
                    }),
                    cameraStreamsPatchObject && cameraStreamsPatchObject[cameraStreamsSelectedIndex] && (cameraStreamsPatchObject[cameraStreamsSelectedIndex]?.sysaid_alerts?.length ?? 0) > 0 && cameraStreamsPatchObject[cameraStreamsSelectedIndex]?.sysaid_alerts?.map((object, index)=>{
                        const currentIndex = index;
                        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "h-[208px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "min-w-[1150px] h-[80px] bg-white",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "flex",
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                            gutterBottom: true,
                                            component: "div",
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: "Bold",
                                                color: "black",
                                                textIndent: "1vw",
                                                paddingTop: "10px"
                                            },
                                            children: [
                                                "SysAid Alert ",
                                                index + 1
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                        component: (0, $4reBM.default),
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                            sx: {
                                                minWidth: 1000,
                                                fontFamily: "Mulish"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                                    titlesArray: [
                                                        "SysAid Server",
                                                        "SysAid Client Local",
                                                        "SysAid Username",
                                                        "SysAid Password"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.sysaid_server,
                                                                        value: localSysaidAlerts[object.id]?.sysaid_server || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalSysaidAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        sysaid_server: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    sysaid: {
                                                                                        ...prev.sysaid,
                                                                                        [object.id]: {
                                                                                            ...localSysaidAlerts?.[object.id],
                                                                                            sysaid_server: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    sysaid: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.sysaid_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.sysaid_server = localSysaidAlerts[object.id]?.sysaid_server || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.sysaid_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.sysaid_server)
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.sysaid_client_local,
                                                                        value: localSysaidAlerts[object.id]?.sysaid_client_local || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalSysaidAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        sysaid_client_local: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    sysaid: {
                                                                                        ...prev.sysaid,
                                                                                        [object.id]: {
                                                                                            ...localSysaidAlerts?.[object.id],
                                                                                            sysaid_client_local: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    sysaid: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.sysaid_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.sysaid_client_local = localSysaidAlerts[object.id]?.sysaid_client_local || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.sysaid_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.sysaid_client_local)
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.sysaid_username,
                                                                        value: localSysaidAlerts[object.id]?.sysaid_username || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalSysaidAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        sysaid_username: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    sysaid: {
                                                                                        ...prev.sysaid,
                                                                                        [object.id]: {
                                                                                            ...localSysaidAlerts?.[object.id],
                                                                                            sysaid_username: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    sysaid: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.sysaid_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.sysaid_username = localSysaidAlerts[object.id]?.sysaid_username || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.sysaid_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.sysaid_username)
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                align: "left",
                                                                sx: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        id: object.sysaid_password,
                                                                        value: localSysaidAlerts[object.id]?.sysaid_password || "",
                                                                        variant: "standard",
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        type: "string",
                                                                        onChange: (event)=>{
                                                                            setLocalSysaidAlerts((prev)=>({
                                                                                    ...prev,
                                                                                    [object.id]: {
                                                                                        ...prev[object.id],
                                                                                        sysaid_password: event.target.value
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreams((prev)=>({
                                                                                    ...prev,
                                                                                    sysaid: {
                                                                                        ...prev.sysaid,
                                                                                        [object.id]: {
                                                                                            ...localSysaidAlerts?.[object.id],
                                                                                            sysaid_password: event.target.value
                                                                                        }
                                                                                    }
                                                                                }));
                                                                            setUpdatedAlertStreamTypes((prev)=>({
                                                                                    ...prev,
                                                                                    sysaid: true
                                                                                }));
                                                                        },
                                                                        onBlur: ()=>{
                                                                            setCameraStreamsPatchObject((previousState)=>{
                                                                                const newState = [
                                                                                    ...previousState || []
                                                                                ];
                                                                                const newStream = {
                                                                                    ...newState[cameraStreamsSelectedIndex]
                                                                                };
                                                                                const newAlerts = [
                                                                                    ...newStream.sysaid_alerts || []
                                                                                ];
                                                                                const newAlert = {
                                                                                    ...newAlerts[currentIndex]
                                                                                };
                                                                                newAlert.sysaid_password = localSysaidAlerts[object.id]?.sysaid_password || "";
                                                                                newAlerts[currentIndex] = newAlert;
                                                                                newStream.sysaid_alerts = newAlerts;
                                                                                newState[cameraStreamsSelectedIndex] = newStream;
                                                                                return newState;
                                                                            });
                                                                        // setStreamChangesMade(true);
                                                                        }
                                                                    })
                                                                }, object.sysaid_password)
                                                            })
                                                        ]
                                                    }, object.id)
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }, object.id);
                    })
                ]
            }, "sysaidAlerts")
        ]
    });
};

});

parcelRegister("1wTA3", function(module, exports) {

$parcel$export(module.exports, "SlicingTab", () => $5565e41b80bffc33$export$932a64dbfdfde002);

var $k4ank = parcelRequire("k4ank");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $ddLR4 = parcelRequire("ddLR4");

var $cVCJe = parcelRequire("cVCJe");

var $aZxZ3 = parcelRequire("aZxZ3");

var $gfzcx = parcelRequire("gfzcx");
const $5565e41b80bffc33$export$932a64dbfdfde002 = ()=>{
    const { cameraStreams: cameraStreams, cameraStreamsObject: cameraStreamsObject, showSlicingWarningMessage: showSlicingWarningMessage } = (0, $aZxZ3.useEditCameraStore)();
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                    titlesArray: [
                        "Stream",
                        "Stream Products",
                        "Slicing",
                        "Max Slices"
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                    children: cameraStreams?.map((stream, index)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        width: "25%"
                                    },
                                    children: stream.name
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        width: "25%"
                                    },
                                    children: stream.product
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        width: "25%"
                                    },
                                    children: stream.name === "production_gun" && cameraStreamsObject[index]?.slice ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                        title: "Slicing is required and enabled automatically for gun detection (already included in the cost).",
                                        placement: "top",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                                checked: cameraStreamsObject[index]?.slice,
                                                color: "warning",
                                                disabled: true
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                        checked: cameraStreamsObject[index]?.slice,
                                        color: "warning",
                                        disabled: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish",
                                        width: "25%"
                                    },
                                    children: [
                                        cameraStreamsObject[index]?.slice ? cameraStreamsObject[index]?.max_slices : "",
                                        cameraStreamsObject[index]?.slice && cameraStreamsObject[index]?.max_slices && (cameraStreamsObject[index]?.max_slices ?? 0) <= 4 && showSlicingWarningMessage && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "text-red-500 text-[12px]",
                                                    children: "Your site/camera may require a higher number"
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "text-red-500 text-[12px]",
                                                    children: "of slices. Please contact Support to inquire."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, stream.id))
                })
            ]
        })
    });
};

});

parcelRegister("8ntwe", function(module, exports) {

$parcel$export(module.exports, "SlicingTabEditMode", () => $f28fbd1ab9520b60$export$45fb59eae7004a3b);

var $k4ank = parcelRequire("k4ank");

var $k8Qy8 = parcelRequire("k8Qy8");

var $8T3gX = parcelRequire("8T3gX");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $ddLR4 = parcelRequire("ddLR4");

var $aZxZ3 = parcelRequire("aZxZ3");

var $gfzcx = parcelRequire("gfzcx");

var $aYdit = parcelRequire("aYdit");

var $eejVe = parcelRequire("eejVe");

var $kUcVg = parcelRequire("kUcVg");

var $ce8iU = parcelRequire("ce8iU");

var $1TOOV = parcelRequire("1TOOV");

var $iLEpm = parcelRequire("iLEpm");

var $887xF = parcelRequire("887xF");

var $8jTCz = parcelRequire("8jTCz");
const $f28fbd1ab9520b60$export$45fb59eae7004a3b = ()=>{
    const { cameraStreams: cameraStreams, cameraStreamsObject: cameraStreamsObject, slicingChanges: slicingChanges, showSlicingWarningMessage: showSlicingWarningMessage, setSlicingChangesMade: setSlicingChangesMade, setSlicingChanges: setSlicingChanges } = (0, $aZxZ3.useEditCameraStore)();
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    const [showMaxSlices, setShowMaxSlices] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [maxSlicesValues, setMaxSlicesValues] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [sliceValues, setSliceValues] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [slicingWarningDialogOpen, setSlicingWarningDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [pendingSliceChange, setPendingSliceChange] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const applySliceChange = (streamId, streamIndex, checked)=>{
        setSlicingChangesMade(true);
        const existingIndex = slicingChanges.findIndex((change)=>change.streamId === streamId);
        if (existingIndex !== -1) {
            const updated = [
                ...slicingChanges
            ];
            updated[existingIndex] = {
                streamId: streamId,
                slice: checked,
                streamIndex: streamIndex
            };
            setSlicingChanges(updated);
        } else setSlicingChanges([
            ...slicingChanges,
            {
                streamId: streamId,
                slice: checked,
                streamIndex: streamIndex
            }
        ]);
        setShowMaxSlices((prev)=>({
                ...prev,
                [streamId]: checked
            }));
        setSliceValues((prev)=>({
                ...prev,
                [streamId]: checked
            }));
    };
    const handleSlicingWarningConfirm = ()=>{
        if (pendingSliceChange) applySliceChange(pendingSliceChange.streamId, pendingSliceChange.streamIndex, pendingSliceChange.checked);
        setSlicingWarningDialogOpen(false);
        setPendingSliceChange(null);
    };
    const handleSlicingWarningCancel = ()=>{
        setSlicingWarningDialogOpen(false);
        setPendingSliceChange(null);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        cameraStreams?.forEach((stream, index)=>{
            setShowMaxSlices((prev)=>({
                    ...prev,
                    [stream.id]: cameraStreamsObject[index]?.slice ?? false
                }));
            setMaxSlicesValues((prev)=>({
                    ...prev,
                    [stream.id]: cameraStreamsObject[index]?.max_slices?.toString() ?? ""
                }));
            setSliceValues((prev)=>({
                    ...prev,
                    [stream.id]: cameraStreamsObject[index]?.slice ?? false
                }));
        });
    }, [
        cameraStreams,
        cameraStreamsObject
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                        titlesArray: [
                            "Stream",
                            "Stream Products",
                            "Slicing",
                            "Max Slices"
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                        children: cameraStreams?.map((stream, index)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: {
                                            fontFamily: "Mulish",
                                            width: "25%"
                                        },
                                        children: stream.name
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: {
                                            fontFamily: "Mulish",
                                            width: "25%"
                                        },
                                        children: stream.product
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: {
                                            fontFamily: "Mulish",
                                            width: "25%"
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                                            checked: sliceValues[stream.id] ?? cameraStreamsObject[index]?.slice ?? false,
                                            color: "warning",
                                            disabled: false,
                                            onChange: (event)=>{
                                                const isChecked = event.target.checked;
                                                // Show warning dialog for non-super users enabling slicing on non-gun products
                                                if (!userPermissions.super_user && stream.name !== "production_gun" && isChecked) {
                                                    setPendingSliceChange({
                                                        streamId: stream.id,
                                                        streamIndex: index,
                                                        checked: isChecked
                                                    });
                                                    setSlicingWarningDialogOpen(true);
                                                    return;
                                                }
                                                applySliceChange(stream.id, index, isChecked);
                                            }
                                        })
                                    }),
                                    !userPermissions.super_user ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: {
                                            fontFamily: "Mulish",
                                            width: "25%"
                                        },
                                        children: [
                                            cameraStreamsObject[index]?.slice ? cameraStreamsObject[index]?.max_slices : "",
                                            cameraStreamsObject[index]?.slice && cameraStreamsObject[index]?.max_slices && (cameraStreamsObject[index]?.max_slices ?? 0) <= 4 && showSlicingWarningMessage && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "text-red-500 text-[12px]",
                                                        children: "Your site/camera may require a higher number"
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "text-red-500 text-[12px]",
                                                        children: "of slices. Please contact Support to inquire."
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "left",
                                        sx: {
                                            fontFamily: "Mulish",
                                            width: "25%"
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                            value: maxSlicesValues[stream.id] ?? "",
                                            variant: "standard",
                                            sx: {
                                                width: 200
                                            },
                                            type: "number",
                                            inputProps: {
                                                min: 2
                                            },
                                            error: maxSlicesValues[stream.id] !== "" && !isNaN(parseInt(maxSlicesValues[stream.id], 10)) && parseInt(maxSlicesValues[stream.id], 10) < 2,
                                            helperText: maxSlicesValues[stream.id] !== "" && !isNaN(parseInt(maxSlicesValues[stream.id], 10)) && parseInt(maxSlicesValues[stream.id], 10) < 2 ? "Value must be 2 or greater" : "Minimum value is 2",
                                            onChange: (event)=>{
                                                const inputValue = event.target.value;
                                                const newMaxSlices = parseInt(inputValue, 10);
                                                // Update local state for controlled input
                                                setMaxSlicesValues((prev)=>({
                                                        ...prev,
                                                        [stream.id]: inputValue
                                                    }));
                                                // Only update store if value is valid (>= 2)
                                                if (inputValue === "" || isNaN(newMaxSlices) || newMaxSlices < 2) return;
                                                setSlicingChangesMade(true);
                                                const existingIndex = slicingChanges.findIndex((change)=>change.streamId === stream.id);
                                                if (existingIndex !== -1) {
                                                    const updated = [
                                                        ...slicingChanges
                                                    ];
                                                    updated[existingIndex] = {
                                                        ...updated[existingIndex],
                                                        max_slices: newMaxSlices
                                                    };
                                                    setSlicingChanges(updated);
                                                } else setSlicingChanges([
                                                    ...slicingChanges,
                                                    {
                                                        streamId: stream.id,
                                                        slice: cameraStreamsObject[index]?.slice ?? false,
                                                        streamIndex: index,
                                                        max_slices: newMaxSlices
                                                    }
                                                ]);
                                            }
                                        })
                                    })
                                ]
                            }, stream.id))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                open: slicingWarningDialogOpen,
                onClose: handleSlicingWarningCancel,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                        children: "Slicing Cost Warning"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                            children: "Please note that slicing for non-gun products incur an additional cost. Please contact your Account Manager if you have any additional questions."
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: handleSlicingWarningCancel,
                                text: "Cancel",
                                disabled: false
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: handleSlicingWarningConfirm,
                                text: "Continue",
                                disabled: false
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("bvvPD", function(module, exports) {

$parcel$export(module.exports, "VlmTab", () => $466104ba8414af39$export$8a6ec83ff7c406d8);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");

var $60vL1 = parcelRequire("60vL1");

var $aZxZ3 = parcelRequire("aZxZ3");

var $8F1dZ = parcelRequire("8F1dZ");
const $466104ba8414af39$export$8a6ec83ff7c406d8 = ()=>{
    const { vlmSettings: vlmSettings, vlmCustomCase: vlmCustomCase, vlmConfigLoading: vlmConfigLoading } = (0, $aZxZ3.useEditCameraStore)();
    if (vlmConfigLoading) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
        sx: {
            display: "flex",
            justifyContent: "center",
            p: 4
        },
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
            color: "warning"
        })
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $8F1dZ.VlmTabToggles), {
        settings: vlmSettings,
        customAnalysisName: vlmCustomCase,
        disabled: true
    });
};

});

parcelRegister("cxjhB", function(module, exports) {

$parcel$export(module.exports, "VlmTabEditMode", () => $b9a706ad9edd64d3$export$e670c8cbdd5957df);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");

var $60vL1 = parcelRequire("60vL1");

var $aZxZ3 = parcelRequire("aZxZ3");

var $8F1dZ = parcelRequire("8F1dZ");
const $b9a706ad9edd64d3$export$e670c8cbdd5957df = ()=>{
    const { vlmSettings: vlmSettings, vlmCustomCase: vlmCustomCase, vlmConfigLoading: vlmConfigLoading, setVlmDraft: setVlmDraft } = (0, $aZxZ3.useEditCameraStore)();
    const handleChange = (key, checked)=>{
        setVlmDraft({
            [key]: checked
        });
    };
    const handleCustomAnalysisNameChange = (value)=>{
        setVlmDraft(undefined, value);
    };
    if (vlmConfigLoading) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
        sx: {
            display: "flex",
            justifyContent: "center",
            p: 4
        },
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
            color: "warning"
        })
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $8F1dZ.VlmTabToggles), {
        settings: vlmSettings,
        customAnalysisName: vlmCustomCase,
        disabled: false,
        onChange: handleChange,
        onCustomAnalysisNameChange: handleCustomAnalysisNameChange
    });
};

});



parcelRegister("j5jOb", function(module, exports) {

$parcel$export(module.exports, "handleEditInfoButtonClick", () => $1cb5b32b5631bf05$export$69fd47a9897d611e);

var $k4ank = parcelRequire("k4ank");

var $dGpG4 = parcelRequire("dGpG4");

var $eWsxc = parcelRequire("eWsxc");

var $kR2pu = parcelRequire("kR2pu");

var $jZEH7 = parcelRequire("jZEH7");

var $4wo2Y = parcelRequire("4wo2Y");

var $fU1zL = parcelRequire("fU1zL");

var $5UPfW = parcelRequire("5UPfW");

var $8ntwe = parcelRequire("8ntwe");

var $cxjhB = parcelRequire("cxjhB");
const $1cb5b32b5631bf05$export$69fd47a9897d611e = (setEditMode, clickedTab, setActiveTab, siteInfo, cameraGeneralInfo, setCameraGeneralInfo, setPatchObject, setGeneralInfoChangesMade, setActiveChangeMade, immixAlerts, diceAlerts, sureviewAlerts, activeProducts, cameraWebhookData, productsData, setProductsData, allTabsOpen, setAllTabsOpen, setBackupProductsData, sentinelAlerts, boldAlerts, patriotAlerts, softguardAlerts, streamParametersData, streamParametersPatchObject, setStreamParametersPatchObject, setStreamParametersChangesMade, setEditStreamWebhookDialogOpen, immixAlertsOnCamera, diceAlertsOnCamera, sureViewAlertsOnCamera, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera, setAddStreamWebhookDialogOpen)=>{
    setEditMode(true);
    if (clickedTab === "one") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dGpG4.GeneralInfoEditCameraTabEditMode), {
            siteInfo: siteInfo,
            cameraGeneralInfo: cameraGeneralInfo,
            setCameraGeneralInfo: setCameraGeneralInfo,
            setPatchObject: setPatchObject,
            setGeneralInfoChangesMade: setGeneralInfoChangesMade,
            setActiveChangeMade: setActiveChangeMade
        })
    }));
    else if (clickedTab === "two") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eWsxc.ConnectionsTabEditMode), {
            cameraGeneralInfo: cameraGeneralInfo,
            setCameraGeneralInfo: setCameraGeneralInfo,
            setPatchObject: setPatchObject,
            setGeneralInfoChangesMade: setGeneralInfoChangesMade
        })
    }));
    else if (clickedTab === "three") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kR2pu.NotificationsTabEditMode), {
            cameraGeneralInfo: cameraGeneralInfo,
            setCameraGeneralInfo: setCameraGeneralInfo,
            setPatchObject: setPatchObject,
            setGeneralInfoChangesMade: setGeneralInfoChangesMade
        })
    }));
    else if (clickedTab === "four") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jZEH7.ProductsTabEditMode), {
            activeProducts: activeProducts,
            setPatchObject: setPatchObject,
            setGeneralInfoChangesMade: setGeneralInfoChangesMade,
            cameraGeneralInfo: cameraGeneralInfo,
            productsData: productsData,
            setProductsData: setProductsData,
            allTabsOpen: allTabsOpen,
            setAllTabsOpen: setAllTabsOpen,
            setBackupProductsData: setBackupProductsData,
            siteInfo: siteInfo
        })
    }));
    else if (clickedTab === "fifteen") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fU1zL.StreamParametersTabEditMode), {
            streamParametersData: streamParametersData,
            streamParametersPatchObject: streamParametersPatchObject,
            setStreamParametersPatchObject: setStreamParametersPatchObject,
            setStreamParametersChangesMade: setStreamParametersChangesMade,
            siteInfo: siteInfo
        })
    }));
    else if (clickedTab === "sixteen") {
        localStorage.setItem("softguardAlertsBackup", JSON.stringify(softguardAlerts));
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $5UPfW.AlertSettingsTabEditMode), {
                immixAlerts: immixAlerts,
                diceAlerts: diceAlerts,
                sureviewAlerts: sureviewAlerts,
                setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                sentinelAlerts: sentinelAlerts,
                boldAlerts: boldAlerts,
                patriotAlerts: patriotAlerts,
                softguardAlerts: softguardAlerts,
                immixAlertsOnCamera: immixAlertsOnCamera,
                diceAlertsOnCamera: diceAlertsOnCamera,
                sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                siteInfo: siteInfo,
                webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                boldAlertsOnCamera: boldAlertsOnCamera,
                patriotAlertsOnCamera: patriotAlertsOnCamera,
                softguardAlertsOnCamera: softguardAlertsOnCamera,
                evalinkAlertsOnCamera: evalinkAlertsOnCamera,
                cameraGeneralInfo: cameraGeneralInfo,
                setPatchObject: setPatchObject,
                setGeneralInfoChangesMade: setGeneralInfoChangesMade,
                setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen
            })
        }));
    } else if (clickedTab === "five") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8ntwe.SlicingTabEditMode), {})
    }));
    else if (clickedTab === "seventeen") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxjhB.VlmTabEditMode), {})
    }));
};

});

parcelRegister("2sriY", function(module, exports) {

$parcel$export(module.exports, "EditCameraSaveChangesButton", () => $cf96c66b4c34c5c7$export$9bd826bb957c4fc9);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $5yK6D = parcelRequire("5yK6D");
const $cf96c66b4c34c5c7$export$9bd826bb957c4fc9 = ({ setEditMode: setEditMode, clickedTab: clickedTab, setActiveTab: setActiveTab, siteInfo: siteInfo, cameraGeneralInfo: cameraGeneralInfo, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, generalInfoChangesMade: generalInfoChangesMade, patchObject: patchObject, setGeneralInfoChangesMade: setGeneralInfoChangesMade, setPatchObject: setPatchObject, setCameraGeneralInfo: setCameraGeneralInfo, cameraGeneralInfoBackup: cameraGeneralInfoBackup, setCameraGeneralInfoBackup: setCameraGeneralInfoBackup, immixAlerts: immixAlerts, diceAlerts: diceAlerts, activeChangeMade: activeChangeMade, sureviewAlerts: sureviewAlerts, setIgnoreZonesBreadCrumbs: setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick: handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick, setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen, setAddDiceAlertDialogOpen: setAddDiceAlertDialogOpen, setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen, activeProducts: activeProducts, setStreamsObject: setStreamsObject, setActiveProducts: setActiveProducts, setImmixAlertsOnCamera: setImmixAlertsOnCamera, setDiceAlertsOnCamera: setDiceAlertsOnCamera, setSureViewAlertsOnCamera: setSureViewAlertsOnCamera, setSendingImmixTest: setSendingImmixTest, setSendingDiceTest: setSendingDiceTest, setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen, setDiceTestSuccessDialogOpen: setDiceTestSuccessDialogOpen, setImmixTestFailDialogOpen: setImmixTestFailDialogOpen, setDiceTestFailDialogOpen: setDiceTestFailDialogOpen, setSrcImages: setSrcImages, setCameraInfoRow: setCameraInfoRow, width: width, permissions: permissions, cameraWebhooksChangesMade: cameraWebhooksChangesMade, cameraWebhooksPatchObject: cameraWebhooksPatchObject, recipientsConfiguredData: recipientsConfiguredData, titlesArray: titlesArray, setRecipientsConfiguredData: setRecipientsConfiguredData, setTitlesArray: setTitlesArray, actionRulesData: actionRulesData, setActionRulesData: setActionRulesData, actionRulesTitlesArray: actionRulesTitlesArray, setActionRulesTitlesArray: setActionRulesTitlesArray, applicationsConfiguredData: applicationsConfiguredData, axisFinished: axisFinished, timeTablesData: timeTablesData, setTimeTablesData: setTimeTablesData, iPNotifyData: iPNotifyData, setIPNotifyData: setIPNotifyData, actionHandlerData: actionHandlerData, setActionHandlerData: setActionHandlerData, cameraWebhookData: cameraWebhookData, setCameraWebhookData: setCameraWebhookData, setCameraWebhooksPatchObject: setCameraWebhooksPatchObject, setCameraWebhooksChangesMade: setCameraWebhooksChangesMade, productsData: productsData, setProductsData: setProductsData, allTabsOpen: allTabsOpen, setAllTabsOpen: setAllTabsOpen, backupProductsData: backupProductsData, setBackupProductsData: setBackupProductsData, setSentinelAlertsOnCamera: setSentinelAlertsOnCamera, sentinelAlerts: sentinelAlerts, setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen, setBoldAlertsOnCamera: setBoldAlertsOnCamera, boldAlerts: boldAlerts, setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen, setPatriotAlertsOnCamera: setPatriotAlertsOnCamera, patriotAlerts: patriotAlerts, setPatriotAlerts: setPatriotAlerts, setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen, setUSMonitoringAlertsOnCamera: setUSMonitoringAlertsOnCamera, uSMonitoringAlerts: uSMonitoringAlerts, setAddUSMonitoringAlertDialogOpen: setAddUSMonitoringAlertDialogOpen, setSoftguardAlertsOnCamera: setSoftguardAlertsOnCamera, softguardAlerts: softguardAlerts, setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen, setSoftguardAlerts: setSoftguardAlerts, streamParametersData: streamParametersData, streamParametersChangesMade: streamParametersChangesMade, setStreamParametersData: setStreamParametersData, setStreamParametersChangesMade: setStreamParametersChangesMade, streamParametersPatchObject: streamParametersPatchObject, setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen, setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen, setDeleteDiceAlertDialogOpen: setDeleteDiceAlertDialogOpen, immixAlertsOnCamera: immixAlertsOnCamera, diceAlertsOnCamera: diceAlertsOnCamera, sureViewAlertsOnCamera: sureViewAlertsOnCamera, webhooksAlertsOnCamera: webhooksAlertsOnCamera, sentinelAlertsOnCamera: sentinelAlertsOnCamera, boldAlertsOnCamera: boldAlertsOnCamera, patriotAlertsOnCamera: patriotAlertsOnCamera, softguardAlertsOnCamera: softguardAlertsOnCamera, evalinkAlertsOnCamera: evalinkAlertsOnCamera, setEvalinkAlertsOnCamera: setEvalinkAlertsOnCamera, setCameraObject: setCameraObject, saveProgress: saveProgress })=>{
    const navigate = (0, $3T949.useNavigate)();
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
            onClick: ()=>{
                (0, $5yK6D.handleEditCameraSaveChangesButtonClicked)(setEditMode, clickedTab, setActiveTab, siteInfo, cameraGeneralInfo, setBackdropLoadingScreenOn, generalInfoChangesMade, patchObject, setGeneralInfoChangesMade, setPatchObject, navigate, setCameraGeneralInfo, cameraGeneralInfoBackup, setCameraGeneralInfoBackup, immixAlerts, diceAlerts, activeChangeMade, sureviewAlerts, setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, setAddImmixAlertDialogOpen, setAddDiceAlertDialogOpen, setAddSureviewAlertDialogOpen, activeProducts, setStreamsObject, setActiveProducts, setImmixAlertsOnCamera, setDiceAlertsOnCamera, setSureViewAlertsOnCamera, setSendingImmixTest, setSendingDiceTest, setImmixTestSuccessDialogOpen, setDiceTestSuccessDialogOpen, setImmixTestFailDialogOpen, setDiceTestFailDialogOpen, setSrcImages, setCameraInfoRow, width, permissions, cameraWebhooksChangesMade, cameraWebhooksPatchObject, recipientsConfiguredData, titlesArray, setRecipientsConfiguredData, setTitlesArray, actionRulesData, setActionRulesData, actionRulesTitlesArray, setActionRulesTitlesArray, applicationsConfiguredData, axisFinished, timeTablesData, setTimeTablesData, iPNotifyData, setIPNotifyData, actionHandlerData, setActionHandlerData, cameraWebhookData, setCameraWebhookData, setCameraWebhooksPatchObject, setCameraWebhooksChangesMade, productsData, setProductsData, allTabsOpen, setAllTabsOpen, backupProductsData, setBackupProductsData, setSentinelAlertsOnCamera, sentinelAlerts, setAddSentinelAlertDialogOpen, setBoldAlertsOnCamera, boldAlerts, setAddBoldAlertDialogOpen, setPatriotAlertsOnCamera, patriotAlerts, setPatriotAlerts, setAddPatriotAlertDialogOpen, setUSMonitoringAlertsOnCamera, uSMonitoringAlerts, setAddUSMonitoringAlertDialogOpen, setSoftguardAlertsOnCamera, softguardAlerts, setAddSoftguardAlertDialogOpen, setSoftguardAlerts, streamParametersData, streamParametersChangesMade, setStreamParametersData, setStreamParametersChangesMade, streamParametersPatchObject, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, setDeleteImmixAlertDialogOpen, setDeleteDiceAlertDialogOpen, immixAlertsOnCamera, diceAlertsOnCamera, sureViewAlertsOnCamera, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera, setEvalinkAlertsOnCamera, setCameraObject, saveProgress);
            },
            text: "SAVE CHANGES",
            disabled: false
        })
    });
};

});
parcelRegister("5yK6D", function(module, exports) {

$parcel$export(module.exports, "handleEditCameraSaveChangesButtonClicked", () => $6fe76f66881d2006$export$23e6a8882744c7c6);

var $k4ank = parcelRequire("k4ank");

var $dmblq = parcelRequire("dmblq");

var $jdgli = parcelRequire("jdgli");

var $fNPIE = parcelRequire("fNPIE");

var $8xHBc = parcelRequire("8xHBc");

var $195EM = parcelRequire("195EM");

var $815yO = parcelRequire("815yO");

var $6TrRL = parcelRequire("6TrRL");

var $lukvk = parcelRequire("lukvk");

var $h0DCc = parcelRequire("h0DCc");

var $9Zf9w = parcelRequire("9Zf9w");

var $3Zv1D = parcelRequire("3Zv1D");

var $igqrx = parcelRequire("igqrx");

var $7SrQs = parcelRequire("7SrQs");

var $4wo2Y = parcelRequire("4wo2Y");

var $pQI3G = parcelRequire("pQI3G");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");

var $lE6VE = parcelRequire("lE6VE");

var $dWhHk = parcelRequire("dWhHk");

var $aZxZ3 = parcelRequire("aZxZ3");

var $ebTQj = parcelRequire("ebTQj");

var $a8BPe = parcelRequire("a8BPe");

var $83bsI = parcelRequire("83bsI");

var $3FJ79 = parcelRequire("3FJ79");

var $1wTA3 = parcelRequire("1wTA3");

var $bvvPD = parcelRequire("bvvPD");

var $7IAhZ = parcelRequire("7IAhZ");

var $6o91K = parcelRequire("6o91K");

var $jj9da = parcelRequire("jj9da");

var $84usX = parcelRequire("84usX");

var $gAGBu = parcelRequire("gAGBu");

var $abZpG = parcelRequire("abZpG");
function $6fe76f66881d2006$export$40c268e9b22bd479(updatedPatchObject, patriotAlertsWerePatched, chmValueChanged) {
    if (patriotAlertsWerePatched && !chmValueChanged) {
        const { streams: _streams, ...rest } = updatedPatchObject;
        return rest;
    }
    return updatedPatchObject;
}
const $6fe76f66881d2006$var$createMetricKey = (metric)=>{
    if (metric?.id) return `id:${metric.id}`;
    return `label:${metric?.label_name}`;
};
const $6fe76f66881d2006$var$hasMetricChanged = (currentMetric, previousMetric)=>{
    if (!previousMetric) return true;
    if (currentMetric.active !== previousMetric.active) return true;
    // DoubleTake is an explicit per-product switch, so a toggle counts even on
    // an inactive product (the guard below only skips stale tuning values).
    if ((0, $abZpG.hasDoubleTakeChanged)(currentMetric, previousMetric)) return true;
    // When a metric remains inactive, stale UI/default values for tuning fields
    // should not generate API updates.
    if (!currentMetric.active && !previousMetric.active) return false;
    const currentOptionId = currentMetric.option_id === undefined ? currentMetric.active ? null : previousMetric.option_id : currentMetric.option_id;
    const currentUserInputValue = currentMetric.user_input_value === undefined ? previousMetric.user_input_value : currentMetric.user_input_value;
    const currentDistance = currentMetric.distance === undefined ? previousMetric.distance : currentMetric.distance;
    const currentDistanceOptions = currentMetric.distance_options === undefined ? previousMetric.distance_options : currentMetric.distance_options;
    return currentOptionId !== previousMetric.option_id || currentUserInputValue !== previousMetric.user_input_value || currentDistance !== previousMetric.distance || JSON.stringify(currentDistanceOptions) !== JSON.stringify(previousMetric.distance_options);
};
const $6fe76f66881d2006$export$15de1e5446437b78 = (productsData, backupProductsData)=>{
    const backupMetricMap = new Map();
    backupProductsData.forEach((product)=>{
        Object.values(product.metrics || {}).forEach((metric)=>{
            const metricAsRecord = metric;
            const metricKey = $6fe76f66881d2006$var$createMetricKey(metricAsRecord);
            backupMetricMap.set(metricKey, metricAsRecord);
        });
    });
    const metricChanges = [];
    productsData.forEach((product)=>{
        Object.values(product.metrics || {}).forEach((metric)=>{
            const metricAsRecord = metric;
            const metricKey = $6fe76f66881d2006$var$createMetricKey(metricAsRecord);
            const previousMetric = backupMetricMap.get(metricKey);
            if ($6fe76f66881d2006$var$hasMetricChanged(metricAsRecord, previousMetric)) metricChanges.push({
                metricKey: metricKey,
                productName: product.name,
                metricLabelName: metricAsRecord.label_name,
                currentMetric: metricAsRecord,
                previousMetric: previousMetric || null
            });
        });
    });
    return metricChanges;
};
const $6fe76f66881d2006$export$e1663d0e7f896872 = (currentMetric, previousMetric, isPostRequest, applyAutopatrolHighSensitivityDefault = false)=>{
    const getPostValue = (currentValue, previousValue, fallback = null)=>currentValue ?? previousValue ?? fallback;
    const payload = {
        label_name: currentMetric.label_name,
        active: currentMetric.active
    };
    if (isPostRequest || currentMetric.option_id !== previousMetric?.option_id) {
        const resolvedOptionId = (0, $84usX.resolveMetricOptionIdForSubmit)(currentMetric, previousMetric, isPostRequest, applyAutopatrolHighSensitivityDefault);
        if (!isPostRequest || resolvedOptionId !== null && resolvedOptionId !== undefined) payload.option_id = resolvedOptionId;
    }
    if (isPostRequest || currentMetric.user_input_value !== previousMetric?.user_input_value) payload.user_input_value = isPostRequest ? getPostValue(currentMetric.user_input_value, previousMetric?.user_input_value) : currentMetric.user_input_value;
    if (isPostRequest || currentMetric.distance !== previousMetric?.distance) payload.distance = isPostRequest ? getPostValue(currentMetric.distance, previousMetric?.distance) : currentMetric.distance ?? null;
    if (isPostRequest || JSON.stringify(currentMetric.distance_options) !== JSON.stringify(previousMetric?.distance_options)) payload.distance_options = isPostRequest ? getPostValue(currentMetric.distance_options, previousMetric?.distance_options) : currentMetric.distance_options ?? previousMetric?.distance_options ?? null;
    if ((0, $abZpG.hasDoubleTakeChanged)(currentMetric, previousMetric)) payload.vlm_enabled = currentMetric.vlm_enabled;
    return payload;
};
const $6fe76f66881d2006$export$c346e49f3a341c12 = (productsData, backupProductsData, failedMetricKeys)=>{
    const failedKeySet = new Set(failedMetricKeys);
    const backupMetricMap = new Map();
    backupProductsData.forEach((product)=>{
        Object.values(product.metrics || {}).forEach((metric)=>{
            const metricAsRecord = metric;
            backupMetricMap.set($6fe76f66881d2006$var$createMetricKey(metricAsRecord), metricAsRecord);
        });
    });
    return productsData.map((product)=>{
        const updatedMetrics = {
            ...product.metrics
        };
        Object.keys(updatedMetrics).forEach((metricObjectKey)=>{
            const metric = updatedMetrics[metricObjectKey];
            const metricAsRecord = metric;
            const metricKey = $6fe76f66881d2006$var$createMetricKey(metricAsRecord);
            if (failedKeySet.has(metricKey) && backupMetricMap.has(metricKey)) updatedMetrics[metricObjectKey] = {
                ...backupMetricMap.get(metricKey)
            };
        });
        return {
            ...product,
            metrics: updatedMetrics
        };
    });
};
const $6fe76f66881d2006$var$cloneProductsData = (products)=>JSON.parse(JSON.stringify(products));
const $6fe76f66881d2006$var$metricMatchesUpdate = (metric, successfulUpdate)=>{
    const responseMetric = successfulUpdate.metricResponse;
    const metricResponseId = responseMetric?.id ?? null;
    if (metricResponseId && metric.id === metricResponseId) return true;
    const originalMetricKey = successfulUpdate.metricChange.metricKey;
    return $6fe76f66881d2006$var$createMetricKey(metric) === originalMetricKey || metric.label_name === responseMetric?.label_name;
};
const $6fe76f66881d2006$export$b6c35154c18077c5 = (productsData, successfulMetricUpdates)=>{
    if (successfulMetricUpdates.length === 0) return productsData;
    return productsData.map((product)=>{
        const updatedMetrics = {
            ...product.metrics
        };
        Object.keys(updatedMetrics).forEach((metricObjectKey)=>{
            const metric = updatedMetrics[metricObjectKey];
            const successfulUpdate = successfulMetricUpdates.find((update)=>$6fe76f66881d2006$var$metricMatchesUpdate(metric, update));
            if (successfulUpdate) updatedMetrics[metricObjectKey] = {
                ...metric,
                ...successfulUpdate.metricResponse
            };
        });
        return {
            ...product,
            metrics: updatedMetrics
        };
    });
};
const $6fe76f66881d2006$var$hasNonStreamGeneralInfoChanges = (patchObject)=>{
    return Object.keys(patchObject || {}).some((key)=>key !== "streams");
};
const $6fe76f66881d2006$export$23e6a8882744c7c6 = async (setEditMode, clickedTab, setActiveTab, siteInfo, cameraGeneralInfo, setBackdropLoadingScreenOn, generalInfoChangesMade, patchObject, setGeneralInfoChangesMade, setPatchObject, navigate, setCameraGeneralInfo, cameraGeneralInfoBackup, setCameraGeneralInfoBackup, immixAlerts, diceAlerts, activeChangeMade, sureviewAlerts, setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, setAddImmixAlertDialogOpen, setAddDiceAlertDialogOpen, setAddSureviewAlertDialogOpen, activeProducts, setStreamsObject, setActiveProducts, setImmixAlertsOnCamera, setDiceAlertsOnCamera, setSureViewAlertsOnCamera, setSendingImmixTest, setSendingDiceTest, setImmixTestSuccessDialogOpen, setDiceTestSuccessDialogOpen, setImmixTestFailDialogOpen, setDiceTestFailDialogOpen, setSrcImages, setCameraInfoRow, width, permissions, cameraWebhooksChangesMade, cameraWebhooksPatchObject, recipientsConfiguredData, titlesArray, setRecipientsConfiguredData, setTitlesArray, actionRulesData, setActionRulesData, actionRulesTitlesArray, setActionRulesTitlesArray, applicationsConfiguredData, axisFinished, timeTablesData, setTimeTablesData, iPNotifyData, setIPNotifyData, actionHandlerData, setActionHandlerData, cameraWebhookData, setCameraWebhookData, setCameraWebhooksPatchObject, setCameraWebhooksChangesMade, productsData, setProductsData, allTabsOpen, setAllTabsOpen, backupProductsData, setBackupProductsData, setSentinelAlertsOnCamera, sentinelAlerts, setAddSentinelAlertDialogOpen, setBoldAlertsOnCamera, boldAlerts, setAddBoldAlertDialogOpen, setPatriotAlertsOnCamera, patriotAlerts, setPatriotAlerts, setAddPatriotAlertDialogOpen, setUSMonitoringAlertsOnCamera, uSMonitoringAlerts, setAddUSMonitoringAlertDialogOpen, setSoftguardAlertsOnCamera, softguardAlerts, setAddSoftguardAlertDialogOpen, setSoftguardAlerts, streamParametersData, streamParametersChangesMade, setStreamParametersData, setStreamParametersChangesMade, streamParametersPatchObject, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, setDeleteImmixAlertDialogOpen, setDeleteDiceAlertDialogOpen, immixAlertsOnCamera, diceAlertsOnCamera, sureViewAlertsOnCamera, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera, setEvalinkAlertsOnCamera, setCameraObject, saveProgress)=>{
    // Client-side validation: block save when an edited Live Stream URL has an
    // unsupported scheme. Unedited URLs never enter patchObject, so an existing
    // (masked-for-display) value can never fail this check or be re-sent.
    if (patchObject?.livestream_url !== undefined && !(0, $gAGBu.isValidLivestreamUrl)(patchObject.livestream_url)) {
        alert((0, $gAGBu.LIVESTREAM_URL_ERROR_MESSAGE));
        return;
    }
    const AxiosUI = (0, $195EM.createApi)(``);
    const closeLoading = ()=>{
        setBackdropLoadingScreenOn(false);
        (0, $jj9da.clearEditCameraSaveProgress)(saveProgress);
    };
    setBackdropLoadingScreenOn(true);
    (0, $jj9da.reportEditCameraSaveStart)(saveProgress);
    const alarmOptions = JSON.parse(localStorage.alarmOptions);
    const alarmIds = new Map();
    alarmOptions.forEach((object)=>{
        alarmIds.set(object.value, object.name);
    });
    const { setAllIgnoreZones: setAllIgnoreZones, setVisibleIgnoreZones: setVisibleIgnoreZones } = (0, $3FJ79.useSiteAboutStore).getState();
    const retryFunction = ()=>{
        $6fe76f66881d2006$export$23e6a8882744c7c6(setEditMode, clickedTab, setActiveTab, siteInfo, cameraGeneralInfo, setBackdropLoadingScreenOn, generalInfoChangesMade, patchObject, setGeneralInfoChangesMade, setPatchObject, navigate, setCameraGeneralInfo, cameraGeneralInfoBackup, setCameraGeneralInfoBackup, immixAlerts, diceAlerts, activeChangeMade, sureviewAlerts, setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, setAddImmixAlertDialogOpen, setAddDiceAlertDialogOpen, setAddSureviewAlertDialogOpen, activeProducts, setStreamsObject, setActiveProducts, setImmixAlertsOnCamera, setDiceAlertsOnCamera, setSureViewAlertsOnCamera, setSendingImmixTest, setSendingDiceTest, setImmixTestSuccessDialogOpen, setDiceTestSuccessDialogOpen, setImmixTestFailDialogOpen, setDiceTestFailDialogOpen, setSrcImages, setCameraInfoRow, width, permissions, cameraWebhooksChangesMade, cameraWebhooksPatchObject, recipientsConfiguredData, titlesArray, setRecipientsConfiguredData, setTitlesArray, actionRulesData, setActionRulesData, actionRulesTitlesArray, setActionRulesTitlesArray, applicationsConfiguredData, axisFinished, timeTablesData, setTimeTablesData, iPNotifyData, setIPNotifyData, actionHandlerData, setActionHandlerData, cameraWebhookData, setCameraWebhookData, setCameraWebhooksPatchObject, setCameraWebhooksChangesMade, productsData, setProductsData, allTabsOpen, setAllTabsOpen, backupProductsData, setBackupProductsData, setSentinelAlertsOnCamera, sentinelAlerts, setAddSentinelAlertDialogOpen, setBoldAlertsOnCamera, boldAlerts, setAddBoldAlertDialogOpen, setPatriotAlertsOnCamera, patriotAlerts, setPatriotAlerts, setAddPatriotAlertDialogOpen, setUSMonitoringAlertsOnCamera, uSMonitoringAlerts, setAddUSMonitoringAlertDialogOpen, setSoftguardAlertsOnCamera, softguardAlerts, setAddSoftguardAlertDialogOpen, setSoftguardAlerts, streamParametersData, streamParametersChangesMade, setStreamParametersData, setStreamParametersChangesMade, streamParametersPatchObject, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, setDeleteImmixAlertDialogOpen, setDeleteDiceAlertDialogOpen, immixAlertsOnCamera, diceAlertsOnCamera, sureViewAlertsOnCamera, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera, setEvalinkAlertsOnCamera, setCameraObject, saveProgress);
    };
    const { chmValueChanged: chmValueChanged, chmStreamMetric: chmStreamMetric, streamChangesMade: streamChangesMade, handlePatchCameraStreams: handlePatchCameraStreams, getCameraStreams: getCameraStreams, setCameraStreamsObject: setCameraStreamsObject, setCameraStreamsPatchObject: setCameraStreamsPatchObject, setCameraStreamsSelectedIndex: setCameraStreamsSelectedIndex, updatedAlertStreamTypes: updatedAlertStreamTypes, handlePatchImmixAlerts: handlePatchImmixAlerts, handlePatchDiceAlerts: handlePatchDiceAlerts, handlePatchBoldAlerts: handlePatchBoldAlerts, handlePatchPatriotAlerts: handlePatchPatriotAlerts, handlePatchSureviewAlerts: handlePatchSureviewAlerts, handlePatchSentinelAlerts: handlePatchSentinelAlerts, handlePatchSoftguardAlerts: handlePatchSoftguardAlerts, handlePatchSysaidAlerts: handlePatchSysaidAlerts, handlePatchEvalinkAlerts: handlePatchEvalinkAlerts, setNotesText: setNotesText, slicingChangesMade: slicingChangesMade, slicingChanges: slicingChanges, handlePatchSlicing: handlePatchSlicing, setSlicingChangesMade: setSlicingChangesMade, setSlicingChanges: setSlicingChanges, vlmChangesMade: vlmChangesMade, patchCameraVlmConfig: patchCameraVlmConfig } = (0, $aZxZ3.useEditCameraStore).getState();
    // When patriot (or other alert-type) PATCH runs, it updates the backend; the general_info
    // patch must not send streams in the same save or it will overwrite those alert changes.
    const patriotAlertsWerePatched = !!updatedAlertStreamTypes.patriot;
    const metricChanges = $6fe76f66881d2006$export$15de1e5446437b78(productsData, backupProductsData);
    const hasMetricChanges = metricChanges.length > 0;
    let productsDataAfterMetricSave = productsData;
    if (updatedAlertStreamTypes.immix) await handlePatchImmixAlerts(navigate, setEditMode);
    if (updatedAlertStreamTypes.dice) await handlePatchDiceAlerts(navigate, setEditMode);
    if (updatedAlertStreamTypes.bold) await handlePatchBoldAlerts(navigate, setEditMode);
    if (updatedAlertStreamTypes.patriot) await handlePatchPatriotAlerts(navigate, setEditMode, setPatriotAlerts);
    if (updatedAlertStreamTypes.sureview) await handlePatchSureviewAlerts(navigate, setEditMode);
    if (updatedAlertStreamTypes.sentinel) await handlePatchSentinelAlerts(navigate, setEditMode);
    if (updatedAlertStreamTypes.softguard) await handlePatchSoftguardAlerts(navigate, setEditMode);
    if (updatedAlertStreamTypes.sysaid) await handlePatchSysaidAlerts(navigate, setEditMode);
    if (updatedAlertStreamTypes.evalink) await handlePatchEvalinkAlerts(navigate, setEditMode);
    if (hasMetricChanges) {
        const fallbackStreamId = cameraGeneralInfo?.streams?.[0]?.id ?? null;
        let latestSuccessfulPostStreamId = null;
        const metricLabelToStreamIds = new Map();
        (cameraGeneralInfo?.streams || []).forEach((stream)=>{
            (stream?.stream_metrics || []).forEach((metric)=>{
                if (!metric?.label_name) return;
                const existing = metricLabelToStreamIds.get(metric.label_name) || [];
                if (!existing.includes(stream.id)) {
                    existing.push(stream.id);
                    metricLabelToStreamIds.set(metric.label_name, existing);
                }
            });
        });
        const metricResults = [];
        const totalMetricChanges = metricChanges.length;
        let completedMetricChanges = 0;
        (0, $jj9da.reportProductMetricsSaveProgress)(saveProgress, 0, totalMetricChanges);
        for (const metricChange of metricChanges){
            const metricId = metricChange.currentMetric.id ?? metricChange.previousMetric?.id ?? null;
            const isPostRequest = !metricId;
            const payload = $6fe76f66881d2006$export$e1663d0e7f896872(metricChange.currentMetric, metricChange.previousMetric, isPostRequest, (0, $84usX.shouldApplyAutopatrolHighSensitivityDefault)());
            if (isPostRequest) {
                const candidateStreamId = metricLabelToStreamIds.get(metricChange.metricLabelName)?.[0] ?? null;
                payload.stream_id = latestSuccessfulPostStreamId ?? candidateStreamId ?? metricChange.currentMetric.stream_id ?? metricChange.previousMetric?.stream_id ?? fallbackStreamId;
            }
            try {
                const response = isPostRequest ? await AxiosUI.post(`/metric/`, payload) : await AxiosUI.patch(`/metric/${metricId}/`, payload);
                if (isPostRequest && response?.data?.stream_id) latestSuccessfulPostStreamId = response.data.stream_id;
                metricResults.push({
                    status: "fulfilled",
                    value: {
                        metricChange: metricChange,
                        metricResponse: response.data
                    }
                });
            } catch (reason) {
                metricResults.push({
                    status: "rejected",
                    reason: reason
                });
            } finally{
                completedMetricChanges += 1;
                (0, $jj9da.reportProductMetricsSaveProgress)(saveProgress, completedMetricChanges, totalMetricChanges);
            }
        }
        const successfulMetricUpdates = metricResults.filter((result)=>result.status === "fulfilled").map((result)=>result.value);
        const mergedProductsData = $6fe76f66881d2006$export$b6c35154c18077c5(productsData, successfulMetricUpdates);
        if (successfulMetricUpdates.length > 0) {
            setProductsData(mergedProductsData);
            setBackupProductsData($6fe76f66881d2006$var$cloneProductsData(mergedProductsData));
            productsDataAfterMetricSave = mergedProductsData;
            // Product/metric changes ride settings.json to the connector, so the
            // site now has unsynced changes. Set here (not per exit path) so every
            // metric flow — metrics-only, partial failure, metrics+general-info —
            // surfaces the Sync control.
            (0, $815yO.markSiteUnsynced)();
        }
        const failedMetricChanges = metricResults.map((result, index)=>({
                result: result,
                metricChange: metricChanges[index]
            })).filter(({ result: result })=>result.status === "rejected").map(({ metricChange: metricChange })=>metricChange);
        if (failedMetricChanges.length > 0) {
            const failedProducts = Array.from(new Set(failedMetricChanges.map((change)=>change.productName)));
            const revertedProductsData = $6fe76f66881d2006$export$c346e49f3a341c12(mergedProductsData, backupProductsData, failedMetricChanges.map((change)=>change.metricKey));
            setProductsData(revertedProductsData);
            setBackupProductsData($6fe76f66881d2006$var$cloneProductsData(revertedProductsData));
            productsDataAfterMetricSave = revertedProductsData;
            alert(`Failed to update these products: ${failedProducts.join(", ")}. Reverted failed product updates.`);
            closeLoading();
            return;
        }
    }
    // Turn off the main loading screen after alert handlers complete
    // (individual handlers manage their own backdropLoadingScreenEditCameraOn state)
    const anyAlertUpdated = updatedAlertStreamTypes.immix || updatedAlertStreamTypes.bold || updatedAlertStreamTypes.patriot || updatedAlertStreamTypes.sureview || updatedAlertStreamTypes.sentinel || updatedAlertStreamTypes.softguard || updatedAlertStreamTypes.sysaid || updatedAlertStreamTypes.evalink;
    if (anyAlertUpdated && !slicingChangesMade && !streamChangesMade && !hasMetricChanges) {
        closeLoading();
        // Switch back to the non-edit mode AlertSettingsTab after alert updates
        if (clickedTab === "sixteen") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dWhHk.AlertSettingsTab), {
                immixAlerts: immixAlerts,
                diceAlerts: diceAlerts,
                setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                setAddDiceAlertDialogOpen: setAddDiceAlertDialogOpen,
                setSendingImmixTest: setSendingImmixTest,
                setSendingDiceTest: setSendingDiceTest,
                setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                setDiceTestSuccessDialogOpen: setDiceTestSuccessDialogOpen,
                setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                setDiceTestFailDialogOpen: setDiceTestFailDialogOpen,
                setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                setDeleteDiceAlertDialogOpen: setDeleteDiceAlertDialogOpen,
                sureviewAlerts: sureviewAlerts,
                setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                sentinelAlerts: sentinelAlerts,
                setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                boldAlerts: boldAlerts,
                setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                patriotAlerts: patriotAlerts,
                setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                softguardAlerts: softguardAlerts,
                setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                immixAlertsOnCamera: immixAlertsOnCamera,
                diceAlertsOnCamera: diceAlertsOnCamera,
                sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                siteInfo: siteInfo,
                webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                boldAlertsOnCamera: boldAlertsOnCamera,
                patriotAlertsOnCamera: patriotAlertsOnCamera,
                softguardAlertsOnCamera: softguardAlertsOnCamera,
                evalinkAlertsOnCamera: evalinkAlertsOnCamera,
                navigate: navigate
            })
        }));
    }
    if (slicingChangesMade) {
        setBackdropLoadingScreenOn(true);
        const failedChanges = [];
        for (const change of slicingChanges){
            const success = await handlePatchSlicing(change.streamId, change.slice, change.streamIndex, navigate, change.max_slices);
            if (!success) failedChanges.push(change);
        }
        if (failedChanges.length === 0) {
            setSlicingChangesMade(false);
            setSlicingChanges([]);
            setEditMode(false);
            if (clickedTab === "one") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dmblq.GeneralInfoEditCameraTab), {
                    siteInfo: siteInfo,
                    cameraGeneralInfo: cameraGeneralInfo
                })
            }));
            else if (clickedTab === "two") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jdgli.ConnectionsTab), {
                    cameraGeneralInfo: cameraGeneralInfo
                })
            }));
            else if (clickedTab === "three") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fNPIE.NotificationsTab), {
                    cameraGeneralInfo: cameraGeneralInfo
                })
            }));
            else if (clickedTab === "four") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8xHBc.ProductsTab), {
                    productsData: productsData,
                    setProductsData: setProductsData,
                    allTabsOpen: allTabsOpen,
                    setAllTabsOpen: setAllTabsOpen,
                    setBackupProductsData: setBackupProductsData
                })
            }));
            else if (clickedTab === "seven") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
                    recipientsConfiguredData: recipientsConfiguredData,
                    titlesArray: titlesArray,
                    navigate: navigate,
                    setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                    setRecipientsConfiguredData: setRecipientsConfiguredData,
                    setTitlesArray: setTitlesArray,
                    actionRulesData: actionRulesData,
                    setActionRulesData: setActionRulesData,
                    actionRulesTitlesArray: actionRulesTitlesArray,
                    setActionRulesTitlesArray: setActionRulesTitlesArray,
                    setActiveTab: setActiveTab,
                    applicationsConfiguredData: applicationsConfiguredData,
                    cameraGeneralInfo: cameraGeneralInfo,
                    axisFinished: axisFinished
                })
            }));
            else if (clickedTab === "eight") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $7SrQs.MobotixTab), {
                    timeTablesData: timeTablesData,
                    navigate: navigate,
                    setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                    setTimeTablesData: setTimeTablesData,
                    setActiveTab: setActiveTab,
                    iPNotifyData: iPNotifyData,
                    setIPNotifyData: setIPNotifyData,
                    actionHandlerData: actionHandlerData,
                    setActionHandlerData: setActionHandlerData
                })
            }));
            else if (clickedTab === "fifteen") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $lE6VE.StreamParametersTab), {
                    streamParametersData: streamParametersData
                })
            }));
            else if (clickedTab === "sixteen") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dWhHk.AlertSettingsTab), {
                    immixAlerts: immixAlerts,
                    diceAlerts: diceAlerts,
                    setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                    setAddDiceAlertDialogOpen: setAddDiceAlertDialogOpen,
                    setSendingImmixTest: setSendingImmixTest,
                    setSendingDiceTest: setSendingDiceTest,
                    setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                    setDiceTestSuccessDialogOpen: setDiceTestSuccessDialogOpen,
                    setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                    setDiceTestFailDialogOpen: setDiceTestFailDialogOpen,
                    setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                    setDeleteDiceAlertDialogOpen: setDeleteDiceAlertDialogOpen,
                    sureviewAlerts: sureviewAlerts,
                    setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                    setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                    setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                    sentinelAlerts: sentinelAlerts,
                    setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                    boldAlerts: boldAlerts,
                    setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                    patriotAlerts: patriotAlerts,
                    setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                    softguardAlerts: softguardAlerts,
                    setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                    immixAlertsOnCamera: immixAlertsOnCamera,
                    diceAlertsOnCamera: diceAlertsOnCamera,
                    sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                    siteInfo: siteInfo,
                    webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                    sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                    boldAlertsOnCamera: boldAlertsOnCamera,
                    patriotAlertsOnCamera: patriotAlertsOnCamera,
                    softguardAlertsOnCamera: softguardAlertsOnCamera,
                    evalinkAlertsOnCamera: evalinkAlertsOnCamera,
                    navigate: navigate
                })
            }));
            else if (clickedTab === "five") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wTA3.SlicingTab), {})
            }));
            else if (clickedTab === "seventeen") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $bvvPD.VlmTab), {})
            }));
        } else setSlicingChanges(failedChanges);
        closeLoading();
    }
    if (vlmChangesMade) {
        setBackdropLoadingScreenOn(true);
        const vlmPatchSuccess = await patchCameraVlmConfig(Number((0, $a8BPe.getNumbersAfterEditCamera)(location.href)), navigate);
        if (vlmPatchSuccess) {
            setEditMode(false);
            if (clickedTab === "seventeen") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $bvvPD.VlmTab), {})
            }));
        }
        closeLoading();
    }
    if (streamChangesMade) {
        closeLoading();
        try {
            await handlePatchCameraStreams(navigate, Number((0, $a8BPe.getNumbersAfterEditCamera)(location.href)), setEditMode);
            setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dWhHk.AlertSettingsTab), {
                    immixAlerts: immixAlerts,
                    diceAlerts: diceAlerts,
                    setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                    setAddDiceAlertDialogOpen: setAddDiceAlertDialogOpen,
                    setSendingImmixTest: setSendingImmixTest,
                    setSendingDiceTest: setSendingDiceTest,
                    setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                    setDiceTestSuccessDialogOpen: setDiceTestSuccessDialogOpen,
                    setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                    setDiceTestFailDialogOpen: setDiceTestFailDialogOpen,
                    setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                    setDeleteDiceAlertDialogOpen: setDeleteDiceAlertDialogOpen,
                    sureviewAlerts: sureviewAlerts,
                    setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                    setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                    setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                    sentinelAlerts: sentinelAlerts,
                    setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                    boldAlerts: boldAlerts,
                    setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                    patriotAlerts: patriotAlerts,
                    setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                    softguardAlerts: softguardAlerts,
                    setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                    immixAlertsOnCamera: immixAlertsOnCamera,
                    diceAlertsOnCamera: diceAlertsOnCamera,
                    sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                    siteInfo: siteInfo,
                    webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                    sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                    boldAlertsOnCamera: boldAlertsOnCamera,
                    patriotAlertsOnCamera: patriotAlertsOnCamera,
                    softguardAlertsOnCamera: softguardAlertsOnCamera,
                    evalinkAlertsOnCamera: evalinkAlertsOnCamera,
                    navigate: navigate
                })
            }));
        } catch (error) {
            (0, $ebTQj.logger).log(`${error}`);
        }
    }
    if (cameraWebhooksChangesMade) AxiosUI.patch(`/webhook/${cameraWebhookData.id}/`, cameraWebhooksPatchObject).then(()=>{
        // Stream webhooks ride settings.json (stream_webhooks) — needs a sync.
        (0, $815yO.markSiteUnsynced)();
        const webHookEventTypeOptions = JSON.parse(localStorage.webHookEventTypeOptions);
        const webHookEventTypeValue = new Map();
        webHookEventTypeOptions.forEach((option)=>{
            webHookEventTypeValue.set(option.id, option.value);
        });
        const newCameraWebhookData = cameraWebhookData;
        newCameraWebhookData.custom_fields = cameraWebhooksPatchObject.custom_fields;
        newCameraWebhookData.event_types = [
            webHookEventTypeValue.get(cameraWebhooksPatchObject.event_types[0])
        ];
        setCameraWebhookData(newCameraWebhookData);
        setCameraWebhooksPatchObject({});
        setCameraWebhooksChangesMade(false);
        setEditMode(false);
        if (!activeChangeMade) closeLoading();
        if (clickedTab === "one") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dmblq.GeneralInfoEditCameraTab), {
                siteInfo: siteInfo,
                cameraGeneralInfo: cameraGeneralInfo
            })
        }));
        else if (clickedTab === "two") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jdgli.ConnectionsTab), {
                cameraGeneralInfo: cameraGeneralInfo
            })
        }));
        else if (clickedTab === "three") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fNPIE.NotificationsTab), {
                cameraGeneralInfo: cameraGeneralInfo
            })
        }));
        else if (clickedTab === "four") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8xHBc.ProductsTab), {
                productsData: productsData,
                setProductsData: setProductsData,
                allTabsOpen: allTabsOpen,
                setAllTabsOpen: setAllTabsOpen,
                setBackupProductsData: setBackupProductsData
            })
        }));
        else if (clickedTab === "seven") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
                recipientsConfiguredData: recipientsConfiguredData,
                titlesArray: titlesArray,
                navigate: navigate,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setRecipientsConfiguredData: setRecipientsConfiguredData,
                setTitlesArray: setTitlesArray,
                actionRulesData: actionRulesData,
                setActionRulesData: setActionRulesData,
                actionRulesTitlesArray: actionRulesTitlesArray,
                setActionRulesTitlesArray: setActionRulesTitlesArray,
                setActiveTab: setActiveTab,
                applicationsConfiguredData: applicationsConfiguredData,
                cameraGeneralInfo: cameraGeneralInfo,
                axisFinished: axisFinished
            })
        }));
        else if (clickedTab === "eight") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $7SrQs.MobotixTab), {
                timeTablesData: timeTablesData,
                navigate: navigate,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setTimeTablesData: setTimeTablesData,
                setActiveTab: setActiveTab,
                iPNotifyData: iPNotifyData,
                setIPNotifyData: setIPNotifyData,
                actionHandlerData: actionHandlerData,
                setActionHandlerData: setActionHandlerData
            })
        }));
        else if (clickedTab === "fifteen") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $lE6VE.StreamParametersTab), {
                streamParametersData: streamParametersData
            })
        }));
        else if (clickedTab === "sixteen") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dWhHk.AlertSettingsTab), {
                immixAlerts: immixAlerts,
                diceAlerts: diceAlerts,
                setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                setAddDiceAlertDialogOpen: setAddDiceAlertDialogOpen,
                setSendingImmixTest: setSendingImmixTest,
                setSendingDiceTest: setSendingDiceTest,
                setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                setDiceTestSuccessDialogOpen: setDiceTestSuccessDialogOpen,
                setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                setDiceTestFailDialogOpen: setDiceTestFailDialogOpen,
                setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                setDeleteDiceAlertDialogOpen: setDeleteDiceAlertDialogOpen,
                sureviewAlerts: sureviewAlerts,
                setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                sentinelAlerts: sentinelAlerts,
                setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                boldAlerts: boldAlerts,
                setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                patriotAlerts: patriotAlerts,
                setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                softguardAlerts: softguardAlerts,
                setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                immixAlertsOnCamera: immixAlertsOnCamera,
                diceAlertsOnCamera: diceAlertsOnCamera,
                sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                siteInfo: siteInfo,
                webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                boldAlertsOnCamera: boldAlertsOnCamera,
                patriotAlertsOnCamera: patriotAlertsOnCamera,
                softguardAlertsOnCamera: softguardAlertsOnCamera,
                evalinkAlertsOnCamera: evalinkAlertsOnCamera,
                navigate: navigate
            })
        }));
        else if (clickedTab === "five") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wTA3.SlicingTab), {})
        }));
        else if (clickedTab === "seventeen") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $bvvPD.VlmTab), {})
        }));
        closeLoading();
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Failed to submit Webhook changes, please try again.");
            setCameraWebhooksPatchObject({});
            setCameraWebhooksChangesMade(false);
            setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dWhHk.AlertSettingsTab), {
                    immixAlerts: immixAlerts,
                    diceAlerts: diceAlerts,
                    setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                    setAddDiceAlertDialogOpen: setAddDiceAlertDialogOpen,
                    setSendingImmixTest: setSendingImmixTest,
                    setSendingDiceTest: setSendingDiceTest,
                    setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                    setDiceTestSuccessDialogOpen: setDiceTestSuccessDialogOpen,
                    setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                    setDiceTestFailDialogOpen: setDiceTestFailDialogOpen,
                    setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                    setDeleteDiceAlertDialogOpen: setDeleteDiceAlertDialogOpen,
                    sureviewAlerts: sureviewAlerts,
                    setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                    setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                    setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                    sentinelAlerts: sentinelAlerts,
                    setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                    boldAlerts: boldAlerts,
                    setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                    patriotAlerts: patriotAlerts,
                    setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                    softguardAlerts: softguardAlerts,
                    setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                    immixAlertsOnCamera: immixAlertsOnCamera,
                    diceAlertsOnCamera: diceAlertsOnCamera,
                    sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                    siteInfo: siteInfo,
                    webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                    sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                    boldAlertsOnCamera: boldAlertsOnCamera,
                    patriotAlertsOnCamera: patriotAlertsOnCamera,
                    softguardAlertsOnCamera: softguardAlertsOnCamera,
                    evalinkAlertsOnCamera: evalinkAlertsOnCamera,
                    navigate: navigate
                })
            }));
            closeLoading();
        });
    });
    const shouldPatchGeneralInfo = chmValueChanged || generalInfoChangesMade && ($6fe76f66881d2006$var$hasNonStreamGeneralInfoChanges(patchObject) || !hasMetricChanges);
    if (shouldPatchGeneralInfo) {
        (0, $jj9da.reportEditCameraSaveProgress)(saveProgress, hasMetricChanges ? 88 : 50, hasMetricChanges ? "Saving camera settings..." : "Saving changes...");
        let postPatchObjectFail = false;
        let getCameraInfoFail = false;
        let getSiteCamerasFail = false;
        // Store the updated camera info from the API response so it can be used
        // in later success handlers (closure variables remain stale)
        let updatedCameraGeneralInfo = cameraGeneralInfo;
        const updatedPatchObject = patchObject;
        if (chmValueChanged) {
            if (!updatedPatchObject.streams) updatedPatchObject.streams = cameraGeneralInfo?.streams?.length ? [
                cameraGeneralInfo.streams[0]
            ] : [
                {
                    stream_metrics: []
                }
            ];
            if (!updatedPatchObject.streams[0]) updatedPatchObject.streams[0] = {
                stream_metrics: []
            };
            if (!updatedPatchObject.streams[0].stream_metrics) updatedPatchObject.streams[0].stream_metrics = [];
            updatedPatchObject.streams[0].stream_metrics.push(chmStreamMetric);
        }
        // If patriot alerts were patched this save, omit streams from general_info payload
        // so we do not overwrite the alert data that was just saved via /patriot/:id/.
        const generalInfoPayload = $6fe76f66881d2006$export$40c268e9b22bd479(updatedPatchObject, patriotAlertsWerePatched, chmValueChanged);
        await AxiosUI.patch(`/camera/${(0, $a8BPe.getNumbersAfterEditCamera)(location.href)}/general_info/`, generalInfoPayload).then((response)=>{
            setNotesText(response.data.notes);
            setCameraStreamsObject(response.data.streams);
            setCameraStreamsPatchObject(response.data.streams);
            postPatchObjectFail = false;
            setCameraStreamsSelectedIndex(0);
            getCameraStreams(navigate, Number((0, $a8BPe.getNumbersAfterEditCamera)(location.href)));
            AxiosUI.get(`/camera/${(0, $a8BPe.getNumbersAfterEditCamera)(location.href)}/ignore_zones/`).then((response)=>{
                setAllIgnoreZones((0, $83bsI.addIgnoreLabel)(response.data));
                setVisibleIgnoreZones((0, $83bsI.addIgnoreLabel)(response.data));
                localStorage.setItem("ignoreZones", JSON.stringify((0, $83bsI.addIgnoreLabel)(response.data)));
            }, (reason)=>{
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
            });
        }, (reason)=>{
            postPatchObjectFail = true;
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                setEditMode(false);
                setCameraGeneralInfo(cameraGeneralInfoBackup);
                setPatchObject({
                    camera_name: cameraGeneralInfoBackup.camera_name,
                    streams: cameraGeneralInfoBackup.streams
                });
                if (clickedTab === "one") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dmblq.GeneralInfoEditCameraTab), {
                        siteInfo: siteInfo,
                        cameraGeneralInfo: cameraGeneralInfoBackup
                    })
                }));
                else if (clickedTab === "two") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jdgli.ConnectionsTab), {
                        cameraGeneralInfo: cameraGeneralInfoBackup
                    })
                }));
                else if (clickedTab === "three") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fNPIE.NotificationsTab), {
                        cameraGeneralInfo: cameraGeneralInfoBackup
                    })
                }));
                else if (clickedTab === "four") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8xHBc.ProductsTab), {
                        productsData: productsData,
                        setProductsData: setProductsData,
                        allTabsOpen: allTabsOpen,
                        setAllTabsOpen: setAllTabsOpen,
                        setBackupProductsData: setBackupProductsData
                    })
                }));
                else if (clickedTab === "seven") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
                        recipientsConfiguredData: recipientsConfiguredData,
                        titlesArray: titlesArray,
                        navigate: navigate,
                        setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                        setRecipientsConfiguredData: setRecipientsConfiguredData,
                        setTitlesArray: setTitlesArray,
                        actionRulesData: actionRulesData,
                        setActionRulesData: setActionRulesData,
                        actionRulesTitlesArray: actionRulesTitlesArray,
                        setActionRulesTitlesArray: setActionRulesTitlesArray,
                        setActiveTab: setActiveTab,
                        applicationsConfiguredData: applicationsConfiguredData,
                        cameraGeneralInfo: cameraGeneralInfo,
                        axisFinished: axisFinished
                    })
                }));
                else if (clickedTab === "eight") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $7SrQs.MobotixTab), {
                        timeTablesData: timeTablesData,
                        navigate: navigate,
                        setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                        setTimeTablesData: setTimeTablesData,
                        setActiveTab: setActiveTab,
                        iPNotifyData: iPNotifyData,
                        setIPNotifyData: setIPNotifyData,
                        actionHandlerData: actionHandlerData,
                        setActionHandlerData: setActionHandlerData
                    })
                }));
                else if (clickedTab === "fifteen") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $lE6VE.StreamParametersTab), {
                        streamParametersData: streamParametersData
                    })
                }));
                else if (clickedTab === "sixteen") {
                    let newSoftguardAlerts = softguardAlerts;
                    if (localStorage.softguardAlertsBackup) {
                        newSoftguardAlerts = JSON.parse(localStorage.softguardAlertsBackup);
                        setSoftguardAlerts(newSoftguardAlerts);
                    }
                    setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dWhHk.AlertSettingsTab), {
                            immixAlerts: immixAlerts,
                            diceAlerts: diceAlerts,
                            setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                            setAddDiceAlertDialogOpen: setAddDiceAlertDialogOpen,
                            setSendingImmixTest: setSendingImmixTest,
                            setSendingDiceTest: setSendingDiceTest,
                            setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                            setDiceTestSuccessDialogOpen: setDiceTestSuccessDialogOpen,
                            setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                            setDiceTestFailDialogOpen: setDiceTestFailDialogOpen,
                            setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                            setDeleteDiceAlertDialogOpen: setDeleteDiceAlertDialogOpen,
                            sureviewAlerts: sureviewAlerts,
                            setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                            setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                            setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                            sentinelAlerts: sentinelAlerts,
                            setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                            boldAlerts: boldAlerts,
                            setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                            patriotAlerts: patriotAlerts,
                            setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                            softguardAlerts: softguardAlerts,
                            setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                            immixAlertsOnCamera: immixAlertsOnCamera,
                            diceAlertsOnCamera: diceAlertsOnCamera,
                            sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                            siteInfo: siteInfo,
                            webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                            sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                            boldAlertsOnCamera: boldAlertsOnCamera,
                            patriotAlertsOnCamera: patriotAlertsOnCamera,
                            softguardAlertsOnCamera: softguardAlertsOnCamera,
                            evalinkAlertsOnCamera: evalinkAlertsOnCamera,
                            navigate: navigate
                        })
                    }));
                } else if (clickedTab === "five") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wTA3.SlicingTab), {})
                }));
                else if (clickedTab === "seventeen") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $bvvPD.VlmTab), {})
                }));
                closeLoading();
                // alert("Failed to submit changes.  Redo changes and try again");
                alert(`${reason}`);
            });
        });
        !postPatchObjectFail && await AxiosUI.get(`/camera/${cameraGeneralInfo.id}/general_info/`).then((response)=>{
            const cameraObject = response.data;
            // Update the shared variable so later success handlers can access the new data
            updatedCameraGeneralInfo = cameraObject;
            setNotesText(cameraObject.notes);
            localStorage.setItem("currentCamera", response.data.camera_name);
            setCameraGeneralInfo(cameraObject);
            const { setCameraStreamsObject: setCameraStreamsObject, setCameraStreamsPatchObject: setCameraStreamsPatchObject } = (0, $aZxZ3.useEditCameraStore).getState();
            setCameraStreamsObject(cameraObject.streams);
            setCameraStreamsPatchObject(cameraObject.streams);
            setCameraObject(cameraObject);
            const resolvedDefaultAlarmName = (0, $7IAhZ.getDefaultAlarmName)(cameraObject.default_alarm);
            if (resolvedDefaultAlarmName === "Immix") setImmixAlertsOnCamera(true);
            if (resolvedDefaultAlarmName === "Dice") setDiceAlertsOnCamera(true);
            if (resolvedDefaultAlarmName === "SureView") setSureViewAlertsOnCamera(true);
            if (resolvedDefaultAlarmName === "Sentinel") setSentinelAlertsOnCamera(true);
            if (resolvedDefaultAlarmName === "Evalink") setEvalinkAlertsOnCamera(true);
            if (resolvedDefaultAlarmName === "Sysaid") (0, $aZxZ3.useEditCameraStore).getState().setSysaidAlertsOnCamera(true);
            // Same builder as the load path, so the header row the camera is
            // re-rendered with after a save matches the cells.
            const connectionsTitlesArray = (0, $6o91K.buildConnectionsTitlesArray)(cameraObject, siteInfo);
            localStorage.setItem("connectionsTitlesArray", JSON.stringify(connectionsTitlesArray));
            setCameraGeneralInfoBackup(cameraObject);
            const pushedArrayImmix = [];
            const pushedArrayDice = [];
            const pushedArraySentinel = [];
            if (cameraObject.streams[0]) {
                if (cameraObject.streams[0].immix_alerts[0]) cameraObject.streams[0].immix_alerts.forEach((object)=>{
                    pushedArrayImmix.push(object);
                });
                if (cameraObject.streams[0].dice_alerts?.[0]) cameraObject.streams[0].dice_alerts?.forEach((object)=>{
                    pushedArrayDice.push(object);
                });
                if (cameraObject.streams[0].sentinel_alerts[0]) cameraObject.streams[0].sentinel_alerts.forEach((object)=>{
                    pushedArraySentinel.push(object);
                });
            }
            if (cameraObject.streams[0]) cameraObject.streams.forEach((streamObject)=>{
                if (streamObject.sureview_alerts[0]) localStorage.setItem("sureViewStreamObject", JSON.stringify(streamObject));
                else if (streamObject.immix_alerts[0]) localStorage.setItem("immixStreamObject", JSON.stringify(streamObject));
                else if (streamObject.dice_alerts?.[0]) localStorage.setItem("diceStreamObject", JSON.stringify(streamObject));
            });
            const sureViewPushedArray = [];
            if (cameraObject.streams[0]) {
                if (cameraObject.streams[0].sureview_alerts[0]) cameraObject.streams[0].sureview_alerts.forEach((object)=>{
                    sureViewPushedArray.push(object);
                });
            }
            (0, $9Zf9w.generateActiveProducts)(cameraObject.streams, setActiveProducts, setProductsData, setBackupProductsData);
            getCameraInfoFail = false;
        }, (reason)=>{
            if ((0, $igqrx.isResourceNotFoundError)(reason)) (0, $igqrx.navigateToResourceNotFound)(navigate, "camera", cameraGeneralInfo.id);
            else (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                alert("Error retrieving site data");
                getCameraInfoFail = true;
                navigate("/");
            });
        });
        !postPatchObjectFail && !getCameraInfoFail && await AxiosUI.get(`camera/site/?customer__id=${(0, $a8BPe.getNumbersAfterSites)(location.href)}`).then((response)=>{
            getSiteCamerasFail = false;
            localStorage.setItem("siteCameras", JSON.stringify(response.data));
        }, (reason)=>{
            getSiteCamerasFail = true;
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
        });
        // Saving no longer auto-syncs. Mark the site as having unsynced changes;
        // the operator syncs explicitly via the edit-view Sync control.
        if (!postPatchObjectFail && !getCameraInfoFail && !getSiteCamerasFail) (0, $815yO.markSiteUnsynced)();
        !postPatchObjectFail && !getCameraInfoFail && !getSiteCamerasFail && await AxiosUI.get(`customer/${(0, $a8BPe.getNumbersAfterSites)(location.href)}/about/`).then((response)=>{
            localStorage.setItem("siteInfo", JSON.stringify(response.data));
            localStorage.setItem("integrationType", response.data.integration_type);
            setIgnoreZonesBreadCrumbs(/*#__PURE__*/ (0, $k4ank.jsx)((0, $lukvk.IgnoreZonesBreadCrumbs), {
                linksArray: (0, $h0DCc.createIgnoreZonesLinksArray)(response.data.breadcrumbs),
                handleSitesBreadcrumbClick: handleSitesBreadcrumbClick,
                handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick,
                styling: "absolute top-[10px] left-[30px]"
            }));
            setEditMode(false);
            if (!activeChangeMade) closeLoading();
            if (clickedTab === "one") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dmblq.GeneralInfoEditCameraTab), {
                    siteInfo: siteInfo,
                    cameraGeneralInfo: updatedCameraGeneralInfo
                })
            }));
            else if (clickedTab === "two") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jdgli.ConnectionsTab), {
                    cameraGeneralInfo: updatedCameraGeneralInfo
                })
            }));
            else if (clickedTab === "three") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fNPIE.NotificationsTab), {
                    cameraGeneralInfo: updatedCameraGeneralInfo
                })
            }));
            else if (clickedTab === "four") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8xHBc.ProductsTab), {
                    productsData: productsData,
                    setProductsData: setProductsData,
                    allTabsOpen: allTabsOpen,
                    setAllTabsOpen: setAllTabsOpen,
                    setBackupProductsData: setBackupProductsData
                })
            }));
            else if (clickedTab === "seven") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
                    recipientsConfiguredData: recipientsConfiguredData,
                    titlesArray: titlesArray,
                    navigate: navigate,
                    setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                    setRecipientsConfiguredData: setRecipientsConfiguredData,
                    setTitlesArray: setTitlesArray,
                    actionRulesData: actionRulesData,
                    setActionRulesData: setActionRulesData,
                    actionRulesTitlesArray: actionRulesTitlesArray,
                    setActionRulesTitlesArray: setActionRulesTitlesArray,
                    setActiveTab: setActiveTab,
                    applicationsConfiguredData: applicationsConfiguredData,
                    cameraGeneralInfo: updatedCameraGeneralInfo,
                    axisFinished: axisFinished
                })
            }));
            else if (clickedTab === "eight") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $7SrQs.MobotixTab), {
                    timeTablesData: timeTablesData,
                    navigate: navigate,
                    setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                    setTimeTablesData: setTimeTablesData,
                    setActiveTab: setActiveTab,
                    iPNotifyData: iPNotifyData,
                    setIPNotifyData: setIPNotifyData,
                    actionHandlerData: actionHandlerData,
                    setActionHandlerData: setActionHandlerData
                })
            }));
            else if (clickedTab === "fifteen") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $lE6VE.StreamParametersTab), {
                    streamParametersData: streamParametersData
                })
            }));
            else if (clickedTab === "sixteen") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dWhHk.AlertSettingsTab), {
                    immixAlerts: immixAlerts,
                    diceAlerts: diceAlerts,
                    setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                    setAddDiceAlertDialogOpen: setAddDiceAlertDialogOpen,
                    setSendingImmixTest: setSendingImmixTest,
                    setSendingDiceTest: setSendingDiceTest,
                    setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                    setDiceTestSuccessDialogOpen: setDiceTestSuccessDialogOpen,
                    setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                    setDiceTestFailDialogOpen: setDiceTestFailDialogOpen,
                    setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                    setDeleteDiceAlertDialogOpen: setDeleteDiceAlertDialogOpen,
                    sureviewAlerts: sureviewAlerts,
                    setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                    setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                    setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                    sentinelAlerts: sentinelAlerts,
                    setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                    boldAlerts: boldAlerts,
                    setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                    patriotAlerts: patriotAlerts,
                    setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                    softguardAlerts: softguardAlerts,
                    setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                    immixAlertsOnCamera: immixAlertsOnCamera,
                    diceAlertsOnCamera: diceAlertsOnCamera,
                    sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                    siteInfo: siteInfo,
                    webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                    sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                    boldAlertsOnCamera: boldAlertsOnCamera,
                    patriotAlertsOnCamera: patriotAlertsOnCamera,
                    softguardAlertsOnCamera: softguardAlertsOnCamera,
                    evalinkAlertsOnCamera: evalinkAlertsOnCamera,
                    navigate: navigate
                })
            }));
            else if (clickedTab === "five") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wTA3.SlicingTab), {})
            }));
            else if (clickedTab === "seventeen") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $bvvPD.VlmTab), {})
            }));
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                if (clickedTab === "one") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dmblq.GeneralInfoEditCameraTab), {
                        siteInfo: siteInfo,
                        cameraGeneralInfo: cameraGeneralInfo
                    })
                }));
                else if (clickedTab === "two") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jdgli.ConnectionsTab), {
                        cameraGeneralInfo: cameraGeneralInfo
                    })
                }));
                else if (clickedTab === "three") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fNPIE.NotificationsTab), {
                        cameraGeneralInfo: cameraGeneralInfo
                    })
                }));
                else if (clickedTab === "four") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8xHBc.ProductsTab), {
                        productsData: productsData,
                        setProductsData: setProductsData,
                        allTabsOpen: allTabsOpen,
                        setAllTabsOpen: setAllTabsOpen,
                        setBackupProductsData: setBackupProductsData
                    })
                }));
                else if (clickedTab === "seven") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
                        recipientsConfiguredData: recipientsConfiguredData,
                        titlesArray: titlesArray,
                        navigate: navigate,
                        setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                        setRecipientsConfiguredData: setRecipientsConfiguredData,
                        setTitlesArray: setTitlesArray,
                        actionRulesData: actionRulesData,
                        setActionRulesData: setActionRulesData,
                        actionRulesTitlesArray: actionRulesTitlesArray,
                        setActionRulesTitlesArray: setActionRulesTitlesArray,
                        setActiveTab: setActiveTab,
                        applicationsConfiguredData: applicationsConfiguredData,
                        cameraGeneralInfo: cameraGeneralInfo,
                        axisFinished: axisFinished
                    })
                }));
                else if (clickedTab === "eight") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $7SrQs.MobotixTab), {
                        timeTablesData: timeTablesData,
                        navigate: navigate,
                        setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                        setTimeTablesData: setTimeTablesData,
                        setActiveTab: setActiveTab,
                        iPNotifyData: iPNotifyData,
                        setIPNotifyData: setIPNotifyData,
                        actionHandlerData: actionHandlerData,
                        setActionHandlerData: setActionHandlerData
                    })
                }));
                else if (clickedTab === "fifteen") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $lE6VE.StreamParametersTab), {
                        streamParametersData: streamParametersData
                    })
                }));
                else if (clickedTab === "sixteen") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dWhHk.AlertSettingsTab), {
                        immixAlerts: immixAlerts,
                        diceAlerts: diceAlerts,
                        setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                        setAddDiceAlertDialogOpen: setAddDiceAlertDialogOpen,
                        setSendingImmixTest: setSendingImmixTest,
                        setSendingDiceTest: setSendingDiceTest,
                        setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                        setDiceTestSuccessDialogOpen: setDiceTestSuccessDialogOpen,
                        setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                        setDiceTestFailDialogOpen: setDiceTestFailDialogOpen,
                        setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                        setDeleteDiceAlertDialogOpen: setDeleteDiceAlertDialogOpen,
                        sureviewAlerts: sureviewAlerts,
                        setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                        setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                        setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                        sentinelAlerts: sentinelAlerts,
                        setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                        boldAlerts: boldAlerts,
                        setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                        patriotAlerts: patriotAlerts,
                        setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                        softguardAlerts: softguardAlerts,
                        setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                        immixAlertsOnCamera: immixAlertsOnCamera,
                        diceAlertsOnCamera: diceAlertsOnCamera,
                        sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                        siteInfo: siteInfo,
                        webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                        sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                        boldAlertsOnCamera: boldAlertsOnCamera,
                        patriotAlertsOnCamera: patriotAlertsOnCamera,
                        softguardAlertsOnCamera: softguardAlertsOnCamera,
                        evalinkAlertsOnCamera: evalinkAlertsOnCamera,
                        navigate: navigate
                    })
                }));
                else if (clickedTab === "five") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wTA3.SlicingTab), {})
                }));
                else if (clickedTab === "seventeen") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $bvvPD.VlmTab), {})
                }));
                closeLoading();
            });
        });
    }
    if (hasMetricChanges && !shouldPatchGeneralInfo) {
        try {
            (0, $jj9da.reportEditCameraSaveRefreshing)(saveProgress);
            const cameraInfoResponse = await AxiosUI.get(`/camera/${cameraGeneralInfo.id}/general_info/`);
            const refreshedCameraInfo = cameraInfoResponse.data;
            setCameraGeneralInfo(refreshedCameraInfo);
            setCameraGeneralInfoBackup(refreshedCameraInfo);
            setCameraObject(refreshedCameraInfo);
            setNotesText(refreshedCameraInfo.notes);
            (0, $9Zf9w.generateActiveProducts)(refreshedCameraInfo.streams, setActiveProducts, setProductsData, setBackupProductsData);
            setGeneralInfoChangesMade(false);
            setEditMode(false);
            if (clickedTab === "four") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8xHBc.ProductsTab), {
                    productsData: productsDataAfterMetricSave,
                    setProductsData: setProductsData,
                    allTabsOpen: allTabsOpen,
                    setAllTabsOpen: setAllTabsOpen,
                    setBackupProductsData: setBackupProductsData
                })
            }));
        } catch (reason) {
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                alert("Metric updates were saved, but camera data refresh failed.");
            });
        } finally{
            closeLoading();
        }
        return;
    }
    if (activeChangeMade) {
        let cameraActivateOrDeactivateFail = false;
        if (cameraGeneralInfo.active) {
            const submittedObject = {
                camera_ids: [
                    (0, $a8BPe.editCameraIdFromUrl)()
                ]
            };
            await AxiosUI.post(`camera/action/activate/`, submittedObject).then(()=>{
                cameraActivateOrDeactivateFail = false;
                setEditMode(false);
            }, (reason)=>{
                cameraActivateOrDeactivateFail = true;
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    closeLoading();
                    setCameraGeneralInfo((previousState)=>{
                        return {
                            ...previousState,
                            active: !cameraGeneralInfo.active
                        };
                    });
                });
            });
        }
        if (!cameraGeneralInfo.active) {
            const submittedObject = {
                camera_ids: [
                    (0, $a8BPe.editCameraIdFromUrl)()
                ]
            };
            await AxiosUI.post(`camera/action/deactivate/`, submittedObject).then(()=>{
                cameraActivateOrDeactivateFail = false;
                setEditMode(false);
            }, (reason)=>{
                cameraActivateOrDeactivateFail = true;
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    closeLoading();
                    setCameraGeneralInfo((previousState)=>{
                        return {
                            ...previousState,
                            active: !cameraGeneralInfo.active
                        };
                    });
                });
            });
        }
        // Activating/deactivating a camera no longer auto-syncs. Mark the site as
        // having unsynced changes; the operator syncs explicitly via the edit-view
        // Sync control.
        if (!cameraActivateOrDeactivateFail) (0, $815yO.markSiteUnsynced)();
        !cameraActivateOrDeactivateFail && await AxiosUI.get(`camera/site/?customer__id=${(0, $a8BPe.getNumbersAfterSites)(location.href)}`).then((response)=>{
            localStorage.setItem("siteCameras", JSON.stringify(response.data));
            closeLoading();
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                closeLoading();
            });
        });
    }
    if (streamParametersChangesMade) AxiosUI.patch(`camera/${(0, $a8BPe.getNumbersAfterEditCamera)(location.href)}/extra_fields/`, streamParametersPatchObject).then((response)=>{
        // Extra fields (e.g. milestone_motion) ride settings.json — needs a sync.
        (0, $815yO.markSiteUnsynced)();
        setStreamParametersData(response.data);
        setStreamParametersChangesMade(false);
        setEditMode(false);
        closeLoading();
        if (clickedTab === "one") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dmblq.GeneralInfoEditCameraTab), {
                siteInfo: siteInfo,
                cameraGeneralInfo: cameraGeneralInfo
            })
        }));
        else if (clickedTab === "two") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jdgli.ConnectionsTab), {
                cameraGeneralInfo: cameraGeneralInfo
            })
        }));
        else if (clickedTab === "three") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fNPIE.NotificationsTab), {
                cameraGeneralInfo: cameraGeneralInfo
            })
        }));
        else if (clickedTab === "four") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8xHBc.ProductsTab), {
                productsData: productsData,
                setProductsData: setProductsData,
                allTabsOpen: allTabsOpen,
                setAllTabsOpen: setAllTabsOpen,
                setBackupProductsData: setBackupProductsData
            })
        }));
        else if (clickedTab === "seven") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
                recipientsConfiguredData: recipientsConfiguredData,
                titlesArray: titlesArray,
                navigate: navigate,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setRecipientsConfiguredData: setRecipientsConfiguredData,
                setTitlesArray: setTitlesArray,
                actionRulesData: actionRulesData,
                setActionRulesData: setActionRulesData,
                actionRulesTitlesArray: actionRulesTitlesArray,
                setActionRulesTitlesArray: setActionRulesTitlesArray,
                setActiveTab: setActiveTab,
                applicationsConfiguredData: applicationsConfiguredData,
                cameraGeneralInfo: cameraGeneralInfo,
                axisFinished: axisFinished
            })
        }));
        else if (clickedTab === "eight") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $7SrQs.MobotixTab), {
                timeTablesData: timeTablesData,
                navigate: navigate,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setTimeTablesData: setTimeTablesData,
                setActiveTab: setActiveTab,
                iPNotifyData: iPNotifyData,
                setIPNotifyData: setIPNotifyData,
                actionHandlerData: actionHandlerData,
                setActionHandlerData: setActionHandlerData
            })
        }));
        else if (clickedTab === "fifteen") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $lE6VE.StreamParametersTab), {
                streamParametersData: response.data
            })
        }));
        else if (clickedTab === "sixteen") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dWhHk.AlertSettingsTab), {
                immixAlerts: immixAlerts,
                diceAlerts: diceAlerts,
                setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                setAddDiceAlertDialogOpen: setAddDiceAlertDialogOpen,
                setSendingImmixTest: setSendingImmixTest,
                setSendingDiceTest: setSendingDiceTest,
                setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                setDiceTestSuccessDialogOpen: setDiceTestSuccessDialogOpen,
                setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                setDiceTestFailDialogOpen: setDiceTestFailDialogOpen,
                setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                setDeleteDiceAlertDialogOpen: setDeleteDiceAlertDialogOpen,
                sureviewAlerts: sureviewAlerts,
                setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                sentinelAlerts: sentinelAlerts,
                setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                boldAlerts: boldAlerts,
                setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                patriotAlerts: patriotAlerts,
                setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                softguardAlerts: softguardAlerts,
                setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                immixAlertsOnCamera: immixAlertsOnCamera,
                diceAlertsOnCamera: diceAlertsOnCamera,
                sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                siteInfo: siteInfo,
                webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                boldAlertsOnCamera: boldAlertsOnCamera,
                patriotAlertsOnCamera: patriotAlertsOnCamera,
                softguardAlertsOnCamera: softguardAlertsOnCamera,
                evalinkAlertsOnCamera: evalinkAlertsOnCamera,
                navigate: navigate
            })
        }));
        else if (clickedTab === "five") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wTA3.SlicingTab), {})
        }));
        else if (clickedTab === "seventeen") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $bvvPD.VlmTab), {})
        }));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            if (clickedTab === "one") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dmblq.GeneralInfoEditCameraTab), {
                    siteInfo: siteInfo,
                    cameraGeneralInfo: cameraGeneralInfo
                })
            }));
            else if (clickedTab === "two") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jdgli.ConnectionsTab), {
                    cameraGeneralInfo: cameraGeneralInfo
                })
            }));
            else if (clickedTab === "three") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fNPIE.NotificationsTab), {
                    cameraGeneralInfo: cameraGeneralInfo
                })
            }));
            else if (clickedTab === "four") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8xHBc.ProductsTab), {
                    productsData: productsData,
                    setProductsData: setProductsData,
                    allTabsOpen: allTabsOpen,
                    setAllTabsOpen: setAllTabsOpen,
                    setBackupProductsData: setBackupProductsData
                })
            }));
            else if (clickedTab === "seven") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
                    recipientsConfiguredData: recipientsConfiguredData,
                    titlesArray: titlesArray,
                    navigate: navigate,
                    setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                    setRecipientsConfiguredData: setRecipientsConfiguredData,
                    setTitlesArray: setTitlesArray,
                    actionRulesData: actionRulesData,
                    setActionRulesData: setActionRulesData,
                    actionRulesTitlesArray: actionRulesTitlesArray,
                    setActionRulesTitlesArray: setActionRulesTitlesArray,
                    setActiveTab: setActiveTab,
                    applicationsConfiguredData: applicationsConfiguredData,
                    cameraGeneralInfo: cameraGeneralInfo,
                    axisFinished: axisFinished
                })
            }));
            else if (clickedTab === "eight") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $7SrQs.MobotixTab), {
                    timeTablesData: timeTablesData,
                    navigate: navigate,
                    setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                    setTimeTablesData: setTimeTablesData,
                    setActiveTab: setActiveTab,
                    iPNotifyData: iPNotifyData,
                    setIPNotifyData: setIPNotifyData,
                    actionHandlerData: actionHandlerData,
                    setActionHandlerData: setActionHandlerData
                })
            }));
            else if (clickedTab === "fifteen") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $lE6VE.StreamParametersTab), {
                    streamParametersData: streamParametersData
                })
            }));
            else if (clickedTab === "sixteen") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dWhHk.AlertSettingsTab), {
                    immixAlerts: immixAlerts,
                    diceAlerts: diceAlerts,
                    setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                    setAddDiceAlertDialogOpen: setAddDiceAlertDialogOpen,
                    setSendingImmixTest: setSendingImmixTest,
                    setSendingDiceTest: setSendingDiceTest,
                    setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                    setDiceTestSuccessDialogOpen: setDiceTestSuccessDialogOpen,
                    setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                    setDiceTestFailDialogOpen: setDiceTestFailDialogOpen,
                    setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                    setDeleteDiceAlertDialogOpen: setDeleteDiceAlertDialogOpen,
                    sureviewAlerts: sureviewAlerts,
                    setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                    setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                    setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                    sentinelAlerts: sentinelAlerts,
                    setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                    boldAlerts: boldAlerts,
                    setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                    patriotAlerts: patriotAlerts,
                    setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                    softguardAlerts: softguardAlerts,
                    setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                    immixAlertsOnCamera: immixAlertsOnCamera,
                    diceAlertsOnCamera: diceAlertsOnCamera,
                    sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                    siteInfo: siteInfo,
                    webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                    sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                    boldAlertsOnCamera: boldAlertsOnCamera,
                    patriotAlertsOnCamera: patriotAlertsOnCamera,
                    softguardAlertsOnCamera: softguardAlertsOnCamera,
                    evalinkAlertsOnCamera: evalinkAlertsOnCamera,
                    navigate: navigate
                })
            }));
            else if (clickedTab === "five") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wTA3.SlicingTab), {})
            }));
            else if (clickedTab === "seventeen") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $bvvPD.VlmTab), {})
            }));
            closeLoading();
        });
    });
    // Only call handleEditCameraCancelButtonClick when NO changes were made
    // (to exit edit mode without saving). When changes were made and saved,
    // the success handlers above already set the active tab with the updated data.
    // Calling cancel here with stale closure values would revert the UI to old data.
    if (!cameraWebhooksChangesMade && !activeChangeMade && !generalInfoChangesMade && !streamParametersChangesMade && !updatedAlertStreamTypes.immix && !updatedAlertStreamTypes.dice && !updatedAlertStreamTypes.sureview && !updatedAlertStreamTypes.sentinel && !updatedAlertStreamTypes.bold && !updatedAlertStreamTypes.patriot && !updatedAlertStreamTypes.softguard && !streamChangesMade && !chmValueChanged && !slicingChangesMade && !vlmChangesMade) (0, $6TrRL.handleEditCameraCancelButtonClick)(setEditMode, clickedTab, setActiveTab, siteInfo, cameraGeneralInfo, setCameraGeneralInfo, cameraGeneralInfoBackup, setPatchObject, immixAlerts, diceAlerts, sureviewAlerts, setAddImmixAlertDialogOpen, setAddDiceAlertDialogOpen, setAddSureviewAlertDialogOpen, activeProducts, setBackdropLoadingScreenOn, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setSendingDiceTest, setDiceTestSuccessDialogOpen, setDiceTestFailDialogOpen, recipientsConfiguredData, titlesArray, setRecipientsConfiguredData, setTitlesArray, actionRulesData, setActionRulesData, actionRulesTitlesArray, setActionRulesTitlesArray, applicationsConfiguredData, axisFinished, timeTablesData, setTimeTablesData, iPNotifyData, setIPNotifyData, actionHandlerData, setActionHandlerData, cameraWebhookData, productsData, setProductsData, allTabsOpen, setAllTabsOpen, backupProductsData, setBackupProductsData, sentinelAlerts, setAddSentinelAlertDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, uSMonitoringAlerts, setAddUSMonitoringAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, streamParametersData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, setDeleteImmixAlertDialogOpen, setDeleteDiceAlertDialogOpen, immixAlertsOnCamera, diceAlertsOnCamera, sureViewAlertsOnCamera, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera, navigate);
};

});
parcelRegister("6TrRL", function(module, exports) {

$parcel$export(module.exports, "handleEditCameraCancelButtonClick", () => $ce61d15efb868ac8$export$310f8cb90e0e27a7);

var $k4ank = parcelRequire("k4ank");

var $dmblq = parcelRequire("dmblq");

var $jdgli = parcelRequire("jdgli");

var $fNPIE = parcelRequire("fNPIE");

var $8xHBc = parcelRequire("8xHBc");

var $pQI3G = parcelRequire("pQI3G");

var $7SrQs = parcelRequire("7SrQs");

var $4wo2Y = parcelRequire("4wo2Y");

var $lE6VE = parcelRequire("lE6VE");

var $dWhHk = parcelRequire("dWhHk");

var $aZxZ3 = parcelRequire("aZxZ3");

var $1wTA3 = parcelRequire("1wTA3");

var $bvvPD = parcelRequire("bvvPD");
const $ce61d15efb868ac8$export$310f8cb90e0e27a7 = (setEditMode, clickedTab, setActiveTab, siteInfo, cameraGeneralInfo, setCameraGeneralInfo, cameraGeneralInfoBackup, setPatchObject, immixAlerts, diceAlerts, sureviewAlerts, setAddImmixAlertDialogOpen, setAddDiceAlertDialogOpen, setAddSureviewAlertDialogOpen, activeProducts, setBackdropLoadingScreenOn, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setSendingDiceTest, setDiceTestSuccessDialogOpen, setDiceTestFailDialogOpen, recipientsConfiguredData, titlesArray, setRecipientsConfiguredData, setTitlesArray, actionRulesData, setActionRulesData, actionRulesTitlesArray, setActionRulesTitlesArray, applicationsConfiguredData, axisFinished, timeTablesData, setTimeTablesData, iPNotifyData, setIPNotifyData, actionHandlerData, setActionHandlerData, cameraWebhookData, productsData, setProductsData, allTabsOpen, setAllTabsOpen, backupProductsData, setBackupProductsData, sentinelAlerts, setAddSentinelAlertDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, uSMonitoringAlerts, setAddUSMonitoringAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, streamParametersData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, setDeleteImmixAlertDialogOpen, setDeleteDiceAlertDialogOpen, immixAlertsOnCamera, diceAlertsOnCamera, sureViewAlertsOnCamera, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera, navigate)=>{
    const { setUpdatedAlertStreams: setUpdatedAlertStreams, setUpdatedAlertStreamTypes: setUpdatedAlertStreamTypes } = (0, $aZxZ3.useEditCameraStore).getState();
    setProductsData(backupProductsData);
    setEditMode(false);
    setCameraGeneralInfo(cameraGeneralInfoBackup);
    setPatchObject({
        camera_name: cameraGeneralInfoBackup.camera_name,
        streams: cameraGeneralInfoBackup.streams
    });
    setUpdatedAlertStreams({
        immix: {},
        dice: {},
        sureview: {},
        sentinel: {},
        bold: {},
        patriot: {},
        softguard: {},
        sysaid: {},
        evalink: {}
    });
    setUpdatedAlertStreamTypes({
        immix: false,
        dice: false,
        sureview: false,
        sentinel: false,
        bold: false,
        patriot: false,
        softguard: false,
        sysaid: false,
        evalink: false
    });
    if (clickedTab === "one") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dmblq.GeneralInfoEditCameraTab), {
            siteInfo: siteInfo,
            cameraGeneralInfo: cameraGeneralInfoBackup
        })
    }));
    else if (clickedTab === "two") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jdgli.ConnectionsTab), {
            cameraGeneralInfo: cameraGeneralInfoBackup
        })
    }));
    else if (clickedTab === "three") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fNPIE.NotificationsTab), {
            cameraGeneralInfo: cameraGeneralInfoBackup
        })
    }));
    else if (clickedTab === "four") {
        setProductsData(backupProductsData);
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8xHBc.ProductsTab), {
                productsData: backupProductsData,
                setProductsData: setProductsData,
                allTabsOpen: allTabsOpen,
                setAllTabsOpen: setAllTabsOpen,
                setBackupProductsData: setBackupProductsData
            })
        }));
    } else if (clickedTab === "seven") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
            recipientsConfiguredData: recipientsConfiguredData,
            titlesArray: titlesArray,
            navigate: navigate,
            setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
            setRecipientsConfiguredData: setRecipientsConfiguredData,
            setTitlesArray: setTitlesArray,
            actionRulesData: actionRulesData,
            setActionRulesData: setActionRulesData,
            actionRulesTitlesArray: actionRulesTitlesArray,
            setActionRulesTitlesArray: setActionRulesTitlesArray,
            setActiveTab: setActiveTab,
            applicationsConfiguredData: applicationsConfiguredData,
            cameraGeneralInfo: cameraGeneralInfo,
            axisFinished: axisFinished
        })
    }));
    else if (clickedTab === "eight") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $7SrQs.MobotixTab), {
            timeTablesData: timeTablesData,
            navigate: navigate,
            setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
            setTimeTablesData: setTimeTablesData,
            setActiveTab: setActiveTab,
            iPNotifyData: iPNotifyData,
            setIPNotifyData: setIPNotifyData,
            actionHandlerData: actionHandlerData,
            setActionHandlerData: setActionHandlerData
        })
    }));
    else if (clickedTab === "fifteen") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $lE6VE.StreamParametersTab), {
            streamParametersData: streamParametersData
        })
    }));
    else if (clickedTab === "sixteen") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dWhHk.AlertSettingsTab), {
            immixAlerts: immixAlerts,
            setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
            setSendingImmixTest: setSendingImmixTest,
            setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
            setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
            setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
            diceAlerts: diceAlerts,
            setAddDiceAlertDialogOpen: setAddDiceAlertDialogOpen,
            setSendingDiceTest: setSendingDiceTest,
            setDiceTestSuccessDialogOpen: setDiceTestSuccessDialogOpen,
            setDiceTestFailDialogOpen: setDiceTestFailDialogOpen,
            setDeleteDiceAlertDialogOpen: setDeleteDiceAlertDialogOpen,
            sureviewAlerts: sureviewAlerts,
            setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
            setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
            setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
            sentinelAlerts: sentinelAlerts,
            setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
            boldAlerts: boldAlerts,
            setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
            patriotAlerts: patriotAlerts,
            setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
            softguardAlerts: softguardAlerts,
            setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
            immixAlertsOnCamera: immixAlertsOnCamera,
            diceAlertsOnCamera: diceAlertsOnCamera,
            sureViewAlertsOnCamera: sureViewAlertsOnCamera,
            siteInfo: siteInfo,
            webhooksAlertsOnCamera: webhooksAlertsOnCamera,
            sentinelAlertsOnCamera: sentinelAlertsOnCamera,
            boldAlertsOnCamera: boldAlertsOnCamera,
            patriotAlertsOnCamera: patriotAlertsOnCamera,
            softguardAlertsOnCamera: softguardAlertsOnCamera,
            evalinkAlertsOnCamera: evalinkAlertsOnCamera,
            navigate: navigate
        })
    }));
    else if (clickedTab === "five") setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wTA3.SlicingTab), {})
    }));
    else if (clickedTab === "seventeen") {
        (0, $aZxZ3.useEditCameraStore).getState().resetVlmDraft();
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $bvvPD.VlmTab), {})
        }));
    }
    setBackdropLoadingScreenOn(false);
};

});

parcelRegister("lukvk", function(module, exports) {

$parcel$export(module.exports, "IgnoreZonesBreadCrumbs", () => $da60e319e420a2e5$export$9883029d873b3876);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $j0ZEU = parcelRequire("j0ZEU");

var $3IuQ3 = parcelRequire("3IuQ3");

var $f3puC = parcelRequire("f3puC");

var $5GP2e = parcelRequire("5GP2e");

var $eXOoR = parcelRequire("eXOoR");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");
const $da60e319e420a2e5$export$9883029d873b3876 = ({ linksArray: linksArray, handleSitesBreadcrumbClick: handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick, styling: styling })=>{
    const navigate = (0, $3T949.useNavigate)();
    const handleCameraBreadcrumbClick = (event)=>{
        event.preventDefault();
        navigate(`/sites/${(0, $a8BPe.getNumbersAfterSites)(location.href)}/editcamera/${(0, $a8BPe.getNumbersAfterEditCamera)(location.href)}`);
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3IuQ3.default), {
        spacing: 2,
        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
            className: styling,
            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $j0ZEU.default), {
                separator: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXOoR))), {
                    fontSize: "medium"
                }),
                "aria-label": "breadcrumb",
                children: [
                    linksArray.map((object, index)=>{
                        if (index === 0) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                            underline: "hover",
                            color: "inherit",
                            href: "/sites",
                            sx: {
                                fontSize: "18px",
                                fontFamily: "Mulish",
                                fontWeight: "bold",
                                cursor: "pointer"
                            },
                            variant: "h5",
                            onClick: handleSitesBreadcrumbClick,
                            children: object.name
                        }, index);
                        else if (index === linksArray.length - 1) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                            underline: "hover",
                            color: "inherit",
                            // href="/sites/aboutsite"
                            sx: {
                                fontSize: "18px",
                                fontFamily: "Mulish",
                                fontWeight: "bold",
                                cursor: "pointer"
                            },
                            variant: "h5",
                            onClick: handleSingularSiteBreadcrumbClick,
                            children: object.name
                        }, index);
                        else if (index === linksArray.length && !window.location.href.includes("editignorezones")) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                            color: "text.primary",
                            fontSize: "18px",
                            fontFamily: "Mulish",
                            fontWeight: "bold",
                            children: object.name
                        }, index);
                        else if (index === linksArray.length && window.location.href.includes("editignorezones")) return linksArray[1] ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                            underline: "hover",
                            color: "inherit",
                            href: "/sites",
                            sx: {
                                fontSize: "18px",
                                fontFamily: "Mulish",
                                fontWeight: "bold",
                                cursor: "pointer"
                            },
                            variant: "h5",
                            onClick: handleCameraBreadcrumbClick,
                            children: localStorage.currentCamera
                        }, localStorage.currentCamera) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {});
                    }),
                    !window.location.href.includes("editignorezones") ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        color: "text.primary",
                        fontSize: "18px",
                        fontFamily: "Mulish",
                        fontWeight: "bold",
                        children: localStorage.currentCamera
                    }, "current_camera") : linksArray[1] ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                        underline: "hover",
                        color: "inherit",
                        // href="/sites/aboutsite"
                        sx: {
                            fontSize: "18px",
                            fontFamily: "Mulish",
                            fontWeight: "bold",
                            cursor: "pointer"
                        },
                        variant: "h5",
                        onClick: handleCameraBreadcrumbClick,
                        children: localStorage.currentCamera
                    }, localStorage.currentCamera) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {})
                ]
            })
        })
    });
};

});

parcelRegister("h0DCc", function(module, exports) {

$parcel$export(module.exports, "createIgnoreZonesLinksArray", () => $86b66d5e761d0237$export$89c67b564440f6c);
const $86b66d5e761d0237$export$89c67b564440f6c = (pushedArray)=>{
    const linksArray = [
        {
            name: "Sites"
        }
    ];
    pushedArray.forEach((name)=>{
        linksArray.push({
            name: name
        });
    });
    return linksArray;
};

});

parcelRegister("9Zf9w", function(module, exports) {

$parcel$export(module.exports, "generateActiveProducts", () => $98009debf9473bcf$export$a0a72fcd2738509c);
// import { assignMetricsToProducts } from "./assignMetricsToProducts";
// export const generateActiveProducts = (
//   streamsObject: any,
//   setActiveProducts: any,
//   setProductsData: any,
//   setBackupProductsData: any
// ) => {
//   const activeProductsToSet: any[] = [];
//   let count = 0;
//   for (const key in streamsObject) {
//     const streamsMetcis: any[] = streamsObject[key].stream_metrics;
//     streamsMetcis.forEach((object: any) => {
//       if (count === 0) {
//         activeProductsToSet.push(object);
//       } else {
//         activeProductsToSet.forEach((obj: any, index: any) => {
//           if (obj.label_name === object.label_name) {
//             if (object.active) {
//               activeProductsToSet[index] = object;
//             }
//           }
//         });
//       }
//     });
//     count += 1;
//   }
//   setActiveProducts(activeProductsToSet);
//   assignMetricsToProducts(
//     activeProductsToSet,
//     setProductsData,
//     setBackupProductsData
//   );
//   return activeProductsToSet;
// };

var $ccXXR = parcelRequire("ccXXR");

var $aZxZ3 = parcelRequire("aZxZ3");
const $98009debf9473bcf$export$a0a72fcd2738509c = (streamsObject, setActiveProducts, setProductsData, setBackupProductsData)=>{
    const productsMap = new Map();
    let streamsObjectToLoop = streamsObject;
    const { setCHMStreamMetric: setCHMStreamMetric, enveraUser: enveraUser } = (0, $aZxZ3.useEditCameraStore).getState();
    if (!streamsObject) streamsObjectToLoop = {
        1: {
            stream_metrics: [
                {
                    id: null,
                    label_name: "intruder",
                    display_name: "Intruder",
                    active: false,
                    option_id: null,
                    options: [
                        [
                            "Low",
                            36
                        ],
                        [
                            "Medium",
                            37
                        ],
                        [
                            "Intermediate (Medium-High)",
                            64
                        ],
                        [
                            "High (more sensitive)",
                            38
                        ]
                    ],
                    user_input_label: null,
                    user_input_field: null,
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                },
                {
                    id: null,
                    label_name: "vehicle",
                    display_name: "Vehicle (grouped car, truck, bus)",
                    active: false,
                    option_id: null,
                    options: [
                        [
                            "Low",
                            36
                        ],
                        [
                            "Medium",
                            37
                        ],
                        [
                            "Intermediate (Medium-High)",
                            64
                        ],
                        [
                            "High (more sensitive)",
                            38
                        ]
                    ],
                    user_input_label: null,
                    user_input_field: null,
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                },
                {
                    id: null,
                    label_name: "bike",
                    display_name: "Bike (grouped bicycle, motorcycle)",
                    active: false,
                    option_id: null,
                    options: [
                        [
                            "Low",
                            36
                        ],
                        [
                            "Medium",
                            37
                        ],
                        [
                            "Intermediate (Medium-High)",
                            64
                        ],
                        [
                            "High (more sensitive)",
                            38
                        ]
                    ],
                    user_input_label: null,
                    user_input_field: null,
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                },
                {
                    id: null,
                    label_name: "intruder_plus",
                    display_name: "Intruder +",
                    active: false,
                    option_id: null,
                    options: [
                        [
                            "Low",
                            58
                        ],
                        [
                            "Medium",
                            59
                        ],
                        [
                            "Intermediate (Medium-High)",
                            61
                        ],
                        [
                            "High (more sensitive)",
                            60
                        ]
                    ],
                    user_input_label: null,
                    user_input_field: null,
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                },
                {
                    id: null,
                    label_name: "vehicle_plus",
                    display_name: "Vehicle +",
                    active: false,
                    option_id: null,
                    options: [
                        [
                            "Low",
                            58
                        ],
                        [
                            "Medium",
                            59
                        ],
                        [
                            "Intermediate (Medium-High)",
                            61
                        ],
                        [
                            "High (more sensitive)",
                            60
                        ]
                    ],
                    user_input_label: null,
                    user_input_field: null,
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                },
                {
                    id: null,
                    label_name: "bike_plus",
                    display_name: "Bike +",
                    active: false,
                    option_id: null,
                    options: [
                        [
                            "Low",
                            58
                        ],
                        [
                            "Medium",
                            59
                        ],
                        [
                            "Intermediate (Medium-High)",
                            61
                        ],
                        [
                            "High (more sensitive)",
                            60
                        ]
                    ],
                    user_input_label: null,
                    user_input_field: null,
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                },
                {
                    id: null,
                    label_name: "gun",
                    display_name: "Gun",
                    active: false,
                    option_id: null,
                    options: [
                        [
                            "Low",
                            32
                        ],
                        [
                            "Medium",
                            33
                        ],
                        [
                            "High (more sensitive)",
                            34
                        ]
                    ],
                    user_input_label: null,
                    user_input_field: null,
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                },
                {
                    id: null,
                    label_name: "pistol",
                    display_name: "Pistol",
                    active: false,
                    option_id: null,
                    options: [
                        [
                            "Low",
                            32
                        ],
                        [
                            "Medium",
                            33
                        ],
                        [
                            "High (more sensitive)",
                            34
                        ]
                    ],
                    user_input_label: null,
                    user_input_field: null,
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                },
                {
                    id: null,
                    label_name: "crowd",
                    display_name: "Crowd",
                    active: false,
                    option_id: null,
                    options: [
                        [
                            "Low",
                            27
                        ],
                        [
                            "Medium",
                            28
                        ],
                        [
                            "High (more sensitive)",
                            29
                        ]
                    ],
                    user_input_label: "Min Crowd Size",
                    user_input_field: "min_crowd_size",
                    user_input_value: null,
                    display_distance: true,
                    distance: null,
                    distance_options: [
                        [
                            "Close",
                            "0.5"
                        ],
                        [
                            "Normal",
                            "1.0"
                        ],
                        [
                            "Far Apart",
                            "2.0"
                        ]
                    ]
                },
                {
                    id: null,
                    label_name: "loiterer",
                    display_name: "Loitering",
                    active: false,
                    option_id: null,
                    options: [
                        [
                            "Low",
                            40
                        ],
                        [
                            "Medium",
                            41
                        ],
                        [
                            "Intermediate (Medium-High)",
                            62
                        ],
                        [
                            "High (more sensitive)",
                            42
                        ]
                    ],
                    user_input_label: "Frame Thresh",
                    user_input_field: "frame_thresh",
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                },
                {
                    id: null,
                    label_name: "vehicle_loiterer",
                    display_name: "Vehicle Loitering",
                    active: false,
                    option_id: null,
                    options: [
                        [
                            "Low",
                            55
                        ],
                        [
                            "Medium",
                            56
                        ],
                        [
                            "Intermediate (Medium-High)",
                            63
                        ],
                        [
                            "High (more sensitive)",
                            57
                        ]
                    ],
                    user_input_label: "Frame Thresh",
                    user_input_field: "frame_thresh",
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                },
                {
                    id: null,
                    label_name: "people_flow",
                    display_name: "People Flow",
                    active: false,
                    option_id: null,
                    options: [],
                    user_input_label: null,
                    user_input_field: null,
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                },
                {
                    id: null,
                    label_name: "social_distancing",
                    display_name: "Social Distancing",
                    active: false,
                    option_id: null,
                    options: [
                        [
                            "Low",
                            49
                        ],
                        [
                            "Medium",
                            50
                        ],
                        [
                            "High (more sensitive)",
                            51
                        ]
                    ],
                    user_input_label: null,
                    user_input_field: null,
                    user_input_value: null,
                    display_distance: true,
                    distance: null,
                    distance_options: [
                        [
                            "Close",
                            "0.5"
                        ],
                        [
                            "Normal",
                            "1.0"
                        ],
                        [
                            "Far Apart",
                            "2.0"
                        ]
                    ]
                },
                {
                    id: null,
                    label_name: "fall_person",
                    display_name: "Slip and Fall",
                    active: false,
                    option_id: null,
                    options: [
                        [
                            "Medium",
                            30
                        ]
                    ],
                    user_input_label: null,
                    user_input_field: null,
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                },
                {
                    id: null,
                    label_name: "mask",
                    display_name: "Mask",
                    active: false,
                    option_id: null,
                    options: [
                        [
                            "Medium",
                            43
                        ]
                    ],
                    user_input_label: null,
                    user_input_field: null,
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                },
                {
                    id: null,
                    label_name: "mask_compliance",
                    display_name: "Mask Compliance",
                    active: false,
                    option_id: null,
                    options: [
                        [
                            "Medium",
                            44
                        ]
                    ],
                    user_input_label: null,
                    user_input_field: null,
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                },
                // {
                //   id: null,
                //   label_name: "no_mask",
                //   display_name: "No Mask",
                //   active: false,
                //   option_id: null,
                //   options: [["Medium", 44]],
                //   user_input_label: null,
                //   user_input_field: null,
                //   user_input_value: null,
                //   display_distance: false,
                //   distance: null,
                //   distance_options: null,
                // },
                {
                    id: null,
                    label_name: "no_hard_hat",
                    display_name: "No Hard Hat",
                    active: false,
                    option_id: null,
                    options: [
                        [
                            "Medium",
                            35
                        ]
                    ],
                    user_input_label: null,
                    user_input_field: null,
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                },
                // {
                //   id: null,
                //   label_name: "left_object",
                //   display_name: "Left Object",
                //   active: false,
                //   option_id: null,
                //   options: [["Medium", 39]],
                //   user_input_label: "Frame Thresh",
                //   user_input_field: "frame_thresh",
                //   user_input_value: null,
                //   display_distance: false,
                //   distance: null,
                //   distance_options: null,
                // },
                // {
                //   id: null,
                //   label_name: "package",
                //   display_name: "Package",
                //   active: false,
                //   option_id: null,
                //   options: [["Medium", 45]],
                //   user_input_label: null,
                //   user_input_field: null,
                //   user_input_value: null,
                //   display_distance: false,
                //   distance: null,
                //   distance_options: null,
                // },
                {
                    id: null,
                    label_name: "amazon",
                    display_name: "Amazon",
                    active: false,
                    option_id: null,
                    options: [
                        [
                            "Low",
                            46
                        ],
                        [
                            "Medium",
                            47
                        ],
                        [
                            "High (more sensitive)",
                            48
                        ]
                    ],
                    user_input_label: null,
                    user_input_field: null,
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                },
                {
                    id: null,
                    label_name: "dhl",
                    display_name: "DHL",
                    active: false,
                    option_id: null,
                    options: [
                        [
                            "Low",
                            46
                        ],
                        [
                            "Medium",
                            47
                        ],
                        [
                            "High (more sensitive)",
                            48
                        ]
                    ],
                    user_input_label: null,
                    user_input_field: null,
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                },
                {
                    id: null,
                    label_name: "fedex",
                    display_name: "Fedex",
                    active: false,
                    option_id: null,
                    options: [
                        [
                            "Low",
                            46
                        ],
                        [
                            "Medium",
                            47
                        ],
                        [
                            "High (more sensitive)",
                            48
                        ]
                    ],
                    user_input_label: null,
                    user_input_field: null,
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                },
                {
                    id: null,
                    label_name: "school_bus",
                    display_name: "School Bus",
                    active: false,
                    option_id: null,
                    options: [
                        [
                            "Low",
                            46
                        ],
                        [
                            "Medium",
                            47
                        ],
                        [
                            "High (more sensitive)",
                            48
                        ]
                    ],
                    user_input_label: null,
                    user_input_field: null,
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                },
                {
                    id: null,
                    label_name: "ups",
                    display_name: "UPS",
                    active: false,
                    option_id: null,
                    options: [
                        [
                            "Low",
                            46
                        ],
                        [
                            "Medium",
                            47
                        ],
                        [
                            "High (more sensitive)",
                            48
                        ]
                    ],
                    user_input_label: null,
                    user_input_field: null,
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                },
                {
                    id: null,
                    label_name: "usps",
                    display_name: "USPS",
                    active: false,
                    option_id: null,
                    options: [
                        [
                            "Low",
                            46
                        ],
                        [
                            "Medium",
                            47
                        ],
                        [
                            "High (more sensitive)",
                            48
                        ]
                    ],
                    user_input_label: null,
                    user_input_field: null,
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                },
                {
                    id: null,
                    label_name: "envera",
                    display_name: "Envera",
                    active: false,
                    option_id: null,
                    options: [
                        [
                            "Low",
                            46
                        ],
                        [
                            "Medium",
                            47
                        ],
                        [
                            "High (more sensitive)",
                            48
                        ]
                    ],
                    user_input_label: null,
                    user_input_field: null,
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                },
                {
                    id: null,
                    label_name: "sudden_scene_change",
                    display_name: "Sudden Scene Change",
                    active: false,
                    option_id: null,
                    options: [
                        [
                            "Low",
                            52
                        ],
                        [
                            "Medium",
                            53
                        ],
                        [
                            "High (more sensitive)",
                            54
                        ]
                    ],
                    user_input_label: null,
                    user_input_field: null,
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                },
                {
                    id: null,
                    label_name: "fire",
                    display_name: "Fire",
                    active: false,
                    option_id: null,
                    options: [],
                    user_input_label: null,
                    user_input_field: null,
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                },
                {
                    id: null,
                    label_name: "smoke",
                    display_name: "Smoke",
                    active: false,
                    option_id: null,
                    options: [],
                    user_input_label: null,
                    user_input_field: null,
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                },
                {
                    id: null,
                    label_name: "fall",
                    display_name: "Slip and Fall (old model)",
                    active: false,
                    option_id: null,
                    options: [],
                    user_input_label: null,
                    user_input_field: null,
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                },
                {
                    id: null,
                    label_name: "non_ups",
                    display_name: "Non-UPS",
                    active: false,
                    option_id: null,
                    options: [],
                    user_input_label: null,
                    user_input_field: null,
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                },
                {
                    id: null,
                    label_name: "fire_truck",
                    display_name: "Fire Truck",
                    active: false,
                    option_id: null,
                    options: [
                        [
                            "Low",
                            46
                        ],
                        [
                            "Medium",
                            47
                        ],
                        [
                            "High (more sensitive)",
                            48
                        ]
                    ],
                    user_input_label: null,
                    user_input_field: null,
                    user_input_value: null,
                    display_distance: false,
                    distance: null,
                    distance_options: null
                }
            ]
        }
    };
    // Filter out 'envera' product if user is not an Envera user
    if (!enveraUser) {
        const filteredResult = {};
        // Ensure streamsObjectToLoop is not null/undefined before trying to iterate its keys
        if (streamsObjectToLoop) {
            for(const key in streamsObjectToLoop)// Check if the property belongs to the object itself, not its prototype
            if (Object.prototype.hasOwnProperty.call(streamsObjectToLoop, key)) {
                const stream = streamsObjectToLoop[key];
                // Ensure the stream and its stream_metrics are valid
                if (stream && Array.isArray(stream.stream_metrics)) filteredResult[key] = {
                    ...stream,
                    stream_metrics: stream.stream_metrics.filter((metric)=>metric.label_name !== "envera")
                };
                else // If stream or stream_metrics is invalid, copy it as is
                filteredResult[key] = stream;
            }
        }
        streamsObjectToLoop = filteredResult;
    }
    const chmMetrics = [];
    // Iterate over each stream
    for(const key in streamsObjectToLoop){
        const streamMetrics = streamsObjectToLoop[key].stream_metrics;
        streamMetrics.forEach((metric)=>{
            if (metric.label_name === "chm") chmMetrics.push(metric);
            // If it's the first encounter or metric is active, set or update the product
            if (!productsMap.has(metric.label_name) || metric.active) productsMap.set(metric.label_name, metric);
        });
    }
    let metricWithIdFound = false;
    let activeMetricFound = false;
    chmMetrics.forEach((metric, index)=>{
        if (index !== chmMetrics.length - 1) {
            if (metric.id) {
                metricWithIdFound = true;
                if (activeMetricFound) return;
                if (metric.active) {
                    activeMetricFound = true;
                    setCHMStreamMetric(metric);
                    (0, $aZxZ3.useEditCameraStore).getState().setChmActive(true);
                } else setCHMStreamMetric(metric);
            }
        } else {
            if (metricWithIdFound) return;
            setCHMStreamMetric(metric);
            if (metric.active) (0, $aZxZ3.useEditCameraStore).getState().setChmActive(true);
            else (0, $aZxZ3.useEditCameraStore).getState().setChmActive(false);
        }
    });
    const activeProductsToSet = Array.from(productsMap.values());
    // Set lineCrossingActive state based on metrics
    const intruderLineCrossingMetric = productsMap.get("intruder_line_crossing");
    const vehicleLineCrossingMetric = productsMap.get("vehicle_line_crossing");
    (0, $aZxZ3.useEditCameraStore).getState().setLineCrossingActive({
        intruder: intruderLineCrossingMetric?.active || false,
        vehicle: vehicleLineCrossingMetric?.active || false
    });
    setActiveProducts(activeProductsToSet);
    (0, $ccXXR.assignMetricsToProducts)(activeProductsToSet, setProductsData, setBackupProductsData);
    return activeProductsToSet;
};

});
parcelRegister("ccXXR", function(module, exports) {

$parcel$export(module.exports, "assignMetricsToProducts", () => $f811e6fffc66e524$export$a50c34c8a71b77d6);
parcelRequire("8T3gX");
const $f811e6fffc66e524$var$cloneProductsData = (value)=>JSON.parse(JSON.stringify(value));
const $f811e6fffc66e524$export$a50c34c8a71b77d6 = (activeProducts, setProductsData, setBackupProductsData)=>{
    const intruderMetrics = {
    };
    // const intruderPlusMetrics: any = {
    //   // intruder_plus: {},
    //   // bike_plus: {},
    //   // vehicle_plus: {},
    // };
    const motionPlusMetrics = {};
    const gunMetrics = {
    };
    const crowdMetrics = {
    };
    const loiteringMetrics = {
    };
    const fallPersonMetrics = {
    };
    const noHardHatMetrics = {
    };
    const maskMetrics = {
    };
    const socialDistancingMetrics = {
    };
    const leftObjectMetrics = {
    };
    const packageMetrics = {
    };
    const fireMetrics = {
    };
    const lineCrossingMetrics = {
    };
    // const peopleFlowMetrics = {
    //   people_flow: {},
    // };
    const fallMetrics = {
    };
    const vehicleLogoIdMetrics = {
    };
    const nonUpsMetrics = {
    };
    activeProducts.forEach((product)=>{
        if (product.label_name === "intruder") intruderMetrics.intruder = product;
        if (product.label_name === "vehicle") intruderMetrics.vehicle = product;
        if (product.label_name === "bike") intruderMetrics.bike = product;
        // if (product.label_name === "intruder_plus") {
        //   intruderPlusMetrics.intruder_plus = product;
        // }
        // if (product.label_name === "vehicle_plus") {
        //   intruderPlusMetrics.vehicle_plus = product;
        // }
        // if (product.label_name === "bike_plus") {
        //   intruderPlusMetrics.bike_plus = product;
        // }
        if (product.label_name === "intruder_motion") motionPlusMetrics.intruder_motion = product;
        if (product.label_name === "vehicle_motion") motionPlusMetrics.vehicle_motion = product;
        if (product.label_name === "bike_motion") motionPlusMetrics.bike_motion = product;
        if (product.label_name === "gun") gunMetrics.gun = product;
        if (product.label_name === "pistol") gunMetrics.pistol = product;
        if (product.label_name === "crowd") crowdMetrics.crowd = product;
        if (product.label_name === "loiterer") loiteringMetrics.loiterer = product;
        if (product.label_name === "vehicle_loiterer") loiteringMetrics.vehicle_loiterer = product;
        if (product.label_name === "fall_person") fallPersonMetrics.fall_person = product;
        if (product.label_name === "no_hard_hat") noHardHatMetrics.no_hard_hat = product;
        if (product.label_name === "mask") maskMetrics.mask = product;
        if (product.label_name === "mask_compliance") maskMetrics.mask_compliance = product;
        if (product.label_name === "no_mask") maskMetrics.no_mask = product;
        if (product.label_name === "social_distancing") socialDistancingMetrics.social_distancing = product;
        if (product.label_name === "left_object") leftObjectMetrics.left_object = product;
        if (product.label_name === "package") packageMetrics.package = product;
        if (product.label_name === "fire") fireMetrics.fire = product;
        if (product.label_name === "smoke") fireMetrics.smoke = product;
        if (product.label_name === "intruder_line_crossing") lineCrossingMetrics.intruder_line_crossing = product;
        if (product.label_name === "vehicle_line_crossing") lineCrossingMetrics.vehicle_line_crossing = product;
        if (product.label_name === "amazon") vehicleLogoIdMetrics.amazon = product;
        if (product.label_name === "dhl") vehicleLogoIdMetrics.dhl = product;
        if (product.label_name === "fedex") vehicleLogoIdMetrics.fedex = product;
        if (product.label_name === "school_bus") vehicleLogoIdMetrics.school_bus = product;
        if (product.label_name === "ups") vehicleLogoIdMetrics.ups = product;
        if (product.label_name === "usps") vehicleLogoIdMetrics.usps = product;
        if (product.label_name === "envera") vehicleLogoIdMetrics.envera = product;
        if (product.label_name === "fire_truck") vehicleLogoIdMetrics.fire_truck = product;
        if (product.label_name === "non_ups") nonUpsMetrics.non_ups = product;
        if (product.label_name === "fall") fallMetrics.fall = product;
    });
    // Build updatedProductsData after processing all products
    const updatedProductsData = [];
    if (Object.keys(intruderMetrics).length > 0) updatedProductsData.push({
        name: "Intruder",
        label_name: "intruder",
        open: false,
        metrics: intruderMetrics
    });
    // if (Object.keys(intruderPlusMetrics).length > 0) {
    //   updatedProductsData.push({
    //     name: "Intruder Plus",
    //     label_name: "intruderPlus",
    //     open: false,
    //     metrics: intruderPlusMetrics,
    //   });
    // }
    if (Object.keys(motionPlusMetrics).length > 0) updatedProductsData.push({
        name: "Motion Plus",
        label_name: "motionPlus",
        open: false,
        metrics: motionPlusMetrics
    });
    if (Object.keys(gunMetrics).length > 0) updatedProductsData.push({
        name: "Gun",
        label_name: "gun",
        open: false,
        metrics: gunMetrics
    });
    if (Object.keys(crowdMetrics).length > 0) updatedProductsData.push({
        name: "Crowd",
        label_name: "crowd",
        open: false,
        metrics: crowdMetrics
    });
    if (Object.keys(loiteringMetrics).length > 0) updatedProductsData.push({
        name: "Loitering",
        label_name: "loitering",
        open: false,
        metrics: loiteringMetrics
    });
    if (Object.keys(fallPersonMetrics).length > 0) updatedProductsData.push({
        name: "Slip and Fall",
        label_name: "fallPerson",
        open: false,
        metrics: fallPersonMetrics
    });
    if (Object.keys(noHardHatMetrics).length > 0) updatedProductsData.push({
        name: "No Hard Hat",
        label_name: "noHardHat",
        open: false,
        metrics: noHardHatMetrics
    });
    // if (Object.keys(maskMetrics).length > 0) {
    //   updatedProductsData.push({
    //     name: "Mask",
    //     label_name: "mask",
    //     open: false,
    //     metrics: maskMetrics,
    //   });
    // }
    if (Object.keys(socialDistancingMetrics).length > 0) updatedProductsData.push({
        name: "Social Distancing",
        label_name: "socialDistancing",
        open: false,
        metrics: socialDistancingMetrics
    });
    // if (Object.keys(leftObjectMetrics).length > 0) {
    //   updatedProductsData.push({
    //     name: "Left Object",
    //     label_name: "leftObject",
    //     open: false,
    //     metrics: leftObjectMetrics,
    //   });
    // }
    // if (Object.keys(packageMetrics).length > 0) {
    //   updatedProductsData.push({
    //     name: "Package",
    //     label_name: "package",
    //     open: false,
    //     metrics: packageMetrics,
    //   });
    // }
    if (Object.keys(fireMetrics).length > 0) updatedProductsData.push({
        name: "Fire",
        label_name: "fire",
        open: false,
        metrics: fireMetrics
    });
    if (Object.keys(lineCrossingMetrics).length > 0) updatedProductsData.push({
        name: "Line Crossing",
        label_name: "lineCrossing",
        open: false,
        metrics: lineCrossingMetrics
    });
    if (Object.keys(vehicleLogoIdMetrics).length > 0) updatedProductsData.push({
        name: "Vehicle Logo ID",
        label_name: "vehicleLogoId",
        open: false,
        metrics: vehicleLogoIdMetrics
    });
    if (Object.keys(nonUpsMetrics).length > 0) updatedProductsData.push({
        name: "Non-UPS",
        label_name: "nonUps",
        open: false,
        metrics: nonUpsMetrics
    });
    setProductsData(updatedProductsData);
    setBackupProductsData($f811e6fffc66e524$var$cloneProductsData(updatedProductsData));
};

});


parcelRegister("jj9da", function(module, exports) {

$parcel$export(module.exports, "clearEditCameraSaveProgress", () => $a7ef6c148636013a$export$274028399fc7b028);
$parcel$export(module.exports, "reportEditCameraSaveProgress", () => $a7ef6c148636013a$export$5be77a699711b2c5);
$parcel$export(module.exports, "reportEditCameraSaveStart", () => $a7ef6c148636013a$export$9f2197e2bfff44e7);
$parcel$export(module.exports, "reportProductMetricsSaveProgress", () => $a7ef6c148636013a$export$1b0b3e4ec238fdfd);
$parcel$export(module.exports, "reportEditCameraSaveRefreshing", () => $a7ef6c148636013a$export$d5922d61f163e865);
const $a7ef6c148636013a$export$274028399fc7b028 = (handlers)=>{
    handlers?.setProgressPercent?.(undefined);
    handlers?.setProgressMessage?.("");
};
const $a7ef6c148636013a$export$5be77a699711b2c5 = (handlers, percent, message)=>{
    handlers?.setProgressPercent?.(percent);
    handlers?.setProgressMessage?.(message);
};
const $a7ef6c148636013a$export$9f2197e2bfff44e7 = (handlers)=>{
    $a7ef6c148636013a$export$5be77a699711b2c5(handlers, 10, "Saving changes...");
};
const $a7ef6c148636013a$export$1b0b3e4ec238fdfd = (handlers, completed, total)=>{
    if (total <= 0) {
        $a7ef6c148636013a$export$5be77a699711b2c5(handlers, 50, "Updating products...");
        return;
    }
    const percent = Math.min(85, Math.round(15 + completed / total * 70));
    const message = total === 1 ? "Updating products..." : `Updating products (${completed} of ${total})...`;
    $a7ef6c148636013a$export$5be77a699711b2c5(handlers, percent, message);
};
const $a7ef6c148636013a$export$d5922d61f163e865 = (handlers)=>{
    $a7ef6c148636013a$export$5be77a699711b2c5(handlers, 90, "Refreshing camera data...");
};

});



parcelRegister("aZdoQ", function(module, exports) {

$parcel$export(module.exports, "EditCameraCancelButton", () => $050ff8ea4d44942b$export$8926b35aa1367fc6);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $8jTCz = parcelRequire("8jTCz");

var $6TrRL = parcelRequire("6TrRL");
const $050ff8ea4d44942b$export$8926b35aa1367fc6 = ({ setEditMode: setEditMode, clickedTab: clickedTab, setActiveTab: setActiveTab, siteInfo: siteInfo, cameraGeneralInfo: cameraGeneralInfo, setCameraGeneralInfo: setCameraGeneralInfo, cameraGeneralInfoBackup: cameraGeneralInfoBackup, setPatchObject: setPatchObject, immixAlerts: immixAlerts, diceAlerts: diceAlerts, sureviewAlerts: sureviewAlerts, setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen, setAddDiceAlertDialogOpen: setAddDiceAlertDialogOpen, setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen, activeProducts: activeProducts, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setSendingImmixTest: setSendingImmixTest, setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen: setImmixTestFailDialogOpen, setSendingDiceTest: setSendingDiceTest, setDiceTestSuccessDialogOpen: setDiceTestSuccessDialogOpen, setDiceTestFailDialogOpen: setDiceTestFailDialogOpen, recipientsConfiguredData: recipientsConfiguredData, titlesArray: titlesArray, setRecipientsConfiguredData: setRecipientsConfiguredData, setTitlesArray: setTitlesArray, actionRulesData: actionRulesData, setActionRulesData: setActionRulesData, actionRulesTitlesArray: actionRulesTitlesArray, setActionRulesTitlesArray: setActionRulesTitlesArray, applicationsConfiguredData: applicationsConfiguredData, axisFinished: axisFinished, timeTablesData: timeTablesData, setTimeTablesData: setTimeTablesData, iPNotifyData: iPNotifyData, setIPNotifyData: setIPNotifyData, actionHandlerData: actionHandlerData, setActionHandlerData: setActionHandlerData, cameraWebhookData: cameraWebhookData, productsData: productsData, setProductsData: setProductsData, allTabsOpen: allTabsOpen, setAllTabsOpen: setAllTabsOpen, backupProductsData: backupProductsData, setBackupProductsData: setBackupProductsData, sentinelAlerts: sentinelAlerts, setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen, boldAlerts: boldAlerts, setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen, patriotAlerts: patriotAlerts, setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen, uSMonitoringAlerts: uSMonitoringAlerts, setAddUSMonitoringAlertDialogOpen: setAddUSMonitoringAlertDialogOpen, softguardAlerts: softguardAlerts, setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen, streamParametersData: streamParametersData, setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen, setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen, setDeleteDiceAlertDialogOpen: setDeleteDiceAlertDialogOpen, immixAlertsOnCamera: immixAlertsOnCamera, diceAlertsOnCamera: diceAlertsOnCamera, sureViewAlertsOnCamera: sureViewAlertsOnCamera, webhooksAlertsOnCamera: webhooksAlertsOnCamera, sentinelAlertsOnCamera: sentinelAlertsOnCamera, boldAlertsOnCamera: boldAlertsOnCamera, patriotAlertsOnCamera: patriotAlertsOnCamera, softguardAlertsOnCamera: softguardAlertsOnCamera, evalinkAlertsOnCamera: evalinkAlertsOnCamera, navigate: navigate })=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
            onClick: ()=>{
                (0, $6TrRL.handleEditCameraCancelButtonClick)(setEditMode, clickedTab, setActiveTab, siteInfo, cameraGeneralInfo, setCameraGeneralInfo, cameraGeneralInfoBackup, setPatchObject, immixAlerts, diceAlerts, sureviewAlerts, setAddImmixAlertDialogOpen, setAddDiceAlertDialogOpen, setAddSureviewAlertDialogOpen, activeProducts, setBackdropLoadingScreenOn, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setSendingDiceTest, setDiceTestSuccessDialogOpen, setDiceTestFailDialogOpen, recipientsConfiguredData, titlesArray, setRecipientsConfiguredData, setTitlesArray, actionRulesData, setActionRulesData, actionRulesTitlesArray, setActionRulesTitlesArray, applicationsConfiguredData, axisFinished, timeTablesData, setTimeTablesData, iPNotifyData, setIPNotifyData, actionHandlerData, setActionHandlerData, cameraWebhookData, productsData, setProductsData, allTabsOpen, setAllTabsOpen, backupProductsData, setBackupProductsData, sentinelAlerts, setAddSentinelAlertDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, uSMonitoringAlerts, setAddUSMonitoringAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, streamParametersData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, setDeleteImmixAlertDialogOpen, setDeleteDiceAlertDialogOpen, immixAlertsOnCamera, diceAlertsOnCamera, sureViewAlertsOnCamera, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera, navigate);
            },
            text: "CANCEL",
            disabled: false
        })
    });
};

});

parcelRegister("4KzIO", function(module, exports) {

$parcel$export(module.exports, "AddImmixAlertDialog", () => $e40fdde8eb7068db$export$2ad82a400f465e71);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $ce8iU = parcelRequire("ce8iU");

var $lk6eW = parcelRequire("lk6eW");

var $8B8vg = parcelRequire("8B8vg");
var $kbChx = parcelRequire("kbChx");
var $3baw3 = parcelRequire("3baw3");
var $9qNow = parcelRequire("9qNow");
var $eejVe = parcelRequire("eejVe");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $1mYjO = parcelRequire("1mYjO");

var $aZxZ3 = parcelRequire("aZxZ3");
const $e40fdde8eb7068db$export$2ad82a400f465e71 = ({ setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen, addImmixAlertDialogOpen: addImmixAlertDialogOpen, immixAlerts: immixAlerts, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setCameraGeneralInfo: setCameraGeneralInfo, setCameraGeneralInfoBackup: setCameraGeneralInfoBackup, setGeneralInfoChangesMade: setGeneralInfoChangesMade, setPatchObject: setPatchObject, setImmixAlerts: setImmixAlerts, setActiveTab: setActiveTab, cameraGeneralInfoBackup: cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs: setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick: handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick, cameraGeneralInfo: cameraGeneralInfo, setSendingImmixTest: setSendingImmixTest, setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen: setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen, sureviewAlerts: sureviewAlerts, setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen, cameraWebhookData: cameraWebhookData, setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen, sentinelAlerts: sentinelAlerts, setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen, boldAlerts: boldAlerts, setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen, patriotAlerts: patriotAlerts, setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen, softguardAlerts: softguardAlerts, setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen, immixAlertsOnCamera: immixAlertsOnCamera, sureViewAlertsOnCamera: sureViewAlertsOnCamera, siteInfo: siteInfo, webhooksAlertsOnCamera: webhooksAlertsOnCamera, sentinelAlertsOnCamera: sentinelAlertsOnCamera, boldAlertsOnCamera: boldAlertsOnCamera, patriotAlertsOnCamera: patriotAlertsOnCamera, softguardAlertsOnCamera: softguardAlertsOnCamera, evalinkAlertsOnCamera: evalinkAlertsOnCamera })=>{
    const { cameraStreams: cameraStreams, cameraStreamsPatchObject: cameraStreamsPatchObject } = (0, $aZxZ3.useEditCameraStore)();
    const streamNames = new Map();
    cameraStreams?.forEach((object, index)=>{
        streamNames.set(`${object.name} (${object.product})`, index);
    });
    const navigate = (0, $3T949.useNavigate)();
    const [postObject, setPostObject] = $8T3gX.useState({
        id: -1,
        immix_server: "",
        immix_port: 0,
        immix_email: "",
        immix_input1: "",
        draw_ignore_zones: false,
        active: true
    });
    const [selectedStreamNames, setSelectedStreamNames] = $8T3gX.useState([]);
    $8T3gX.useEffect(()=>{
        if (immixAlerts[0]) setPostObject({
            id: -1,
            immix_server: immixAlerts[0].immix_server,
            immix_port: immixAlerts[0].immix_port,
            immix_email: immixAlerts[0].immix_email,
            immix_input1: immixAlerts[0].immix_input1,
            draw_ignore_zones: immixAlerts[0].draw_ignore_zones,
            active: true
        });
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: addImmixAlertDialogOpen,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: "Add Immix Alert"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                children: [
                    cameraStreams && cameraStreams.length > 1 && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $lk6eW.default), {
                                component: "legend",
                                sx: {
                                    paddingBottom: 1
                                },
                                children: [
                                    " ",
                                    "Streams*"
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                multiple: true,
                                options: cameraStreams.map((object)=>{
                                    return `${object.name} (${object.product})`;
                                }),
                                sx: {
                                    width: 400
                                },
                                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        ...params
                                    }),
                                onChange: (event, value)=>{
                                    setSelectedStreamNames(value);
                                }
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "immix_server",
                        variant: "standard",
                        label: "Immix Server",
                        defaultValue: immixAlerts[0] ? immixAlerts[0].immix_server : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    immix_server: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        helperText: "What is the url for your immix server.",
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "immix_port",
                        variant: "standard",
                        label: "Immix Port",
                        defaultValue: immixAlerts[0] ? immixAlerts[0].immix_port : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    immix_port: parseInt(event.target.value, 10)
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        helperText: "What is the port for your immix server.",
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "immix_email",
                        variant: "standard",
                        label: "Immix email",
                        defaultValue: immixAlerts[0] ? immixAlerts[0].immix_email : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    immix_email: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "immix_input1",
                        variant: "standard",
                        label: "Immix Input1",
                        defaultValue: immixAlerts[0] ? immixAlerts[0].immix_input1 : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    immix_input1: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                sx: {
                                    fontFamily: "Mulish",
                                    color: "#001943"
                                },
                                label: "Draw Ignore Zones",
                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                    color: "primary",
                                    defaultChecked: immixAlerts[0] ? immixAlerts[0].draw_ignore_zones : false,
                                    onChange: (event, checked)=>{
                                        setPostObject((previousState)=>{
                                            return {
                                                ...previousState,
                                                draw_ignore_zones: checked
                                            };
                                        });
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                                children: "If checked, draws ignore zones in the alert images."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setAddImmixAlertDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            const selectedStreamIndexs = [];
                            const streamsObjectToPost = JSON.parse(JSON.stringify(cameraStreamsPatchObject));
                            if (cameraStreams && cameraStreams.length > 1) {
                                selectedStreamNames.forEach((streamName)=>{
                                    selectedStreamIndexs.push(streamNames.get(streamName));
                                });
                                selectedStreamIndexs.forEach((streamIndex)=>{
                                    if (streamsObjectToPost[streamIndex]) streamsObjectToPost[streamIndex].immix_alerts = [
                                        ...streamsObjectToPost[streamIndex].immix_alerts,
                                        postObject
                                    ];
                                });
                            }
                            if (cameraStreams && cameraStreams.length === 1) streamsObjectToPost[0].immix_alerts.push(postObject);
                            setAddImmixAlertDialogOpen(false);
                            setBackdropLoadingScreenOn(true);
                            (0, $1mYjO.handleSubmitNewImmixAlert)(cameraGeneralInfo, immixAlerts, streamsObjectToPost, navigate, setBackdropLoadingScreenOn, setCameraGeneralInfo, setCameraGeneralInfoBackup, setGeneralInfoChangesMade, setPatchObject, setImmixAlerts, setActiveTab, setAddImmixAlertDialogOpen, cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen, sureviewAlerts, setAddSureviewAlertDialogOpen, cameraWebhookData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, sentinelAlerts, setAddSentinelAlertDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, immixAlertsOnCamera, sureViewAlertsOnCamera, siteInfo, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera);
                        },
                        text: "Submit",
                        disabled: false
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("1mYjO", function(module, exports) {

$parcel$export(module.exports, "handleSubmitNewImmixAlert", () => $37d1bcd8f796d671$export$ad897a1b8368cf62);

var $k4ank = parcelRequire("k4ank");

var $195EM = parcelRequire("195EM");

var $815yO = parcelRequire("815yO");

var $lukvk = parcelRequire("lukvk");

var $h0DCc = parcelRequire("h0DCc");

var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");

var $dWhHk = parcelRequire("dWhHk");

var $4wo2Y = parcelRequire("4wo2Y");

var $aZxZ3 = parcelRequire("aZxZ3");
const $37d1bcd8f796d671$export$ad897a1b8368cf62 = async (cameraGeneralInfo, immixAlerts, postObject, navigate, setBackdropLoadingScreenOn, setCameraGeneralInfo, setCameraGeneralInfoBackup, setGeneralInfoChangesMade, setPatchObject, setImmixAlerts, setActiveTab, setAddImmixAlertDialogOpen, cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen, sureviewAlerts, setAddSureviewAlertDialogOpen, cameraWebhookData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, sentinelAlerts, setAddSentinelAlertDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, immixAlertsOnCamera, sureViewAlertsOnCamera, siteInfo, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $37d1bcd8f796d671$export$ad897a1b8368cf62(cameraGeneralInfo, immixAlerts, postObject, navigate, setBackdropLoadingScreenOn, setCameraGeneralInfo, setCameraGeneralInfoBackup, setGeneralInfoChangesMade, setPatchObject, setImmixAlerts, setActiveTab, setAddImmixAlertDialogOpen, cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen, sureviewAlerts, setAddSureviewAlertDialogOpen, cameraWebhookData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, sentinelAlerts, setAddSentinelAlertDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, immixAlertsOnCamera, sureViewAlertsOnCamera, siteInfo, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera);
    };
    let postPatchObjectFail = false;
    let getSiteCamerasFail = false;
    const { setCameraStreamsPatchObject: setCameraStreamsPatchObject, setCameraStreamsObject: setCameraStreamsObject } = (0, $aZxZ3.useEditCameraStore).getState();
    await AxiosUI.patch(`/camera/${(0, $a8BPe.getNumbersAfterEditCamera)(location.href)}/general_info/`, {
        streams: postObject
    }).then((response)=>{
        postPatchObjectFail = false;
        (0, $815yO.markSiteUnsynced)();
        setCameraGeneralInfo(response.data);
        setCameraGeneralInfoBackup(response.data);
        setCameraStreamsPatchObject(response.data.streams);
        setCameraStreamsObject(response.data.streams);
        const pushedArray = [];
        response.data.streams[0].immix_alerts.forEach((alertObject)=>{
            pushedArray.push(alertObject);
        });
        setImmixAlerts(pushedArray);
        setGeneralInfoChangesMade(false);
        setPatchObject({});
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dWhHk.AlertSettingsTab), {
                immixAlerts: pushedArray,
                setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                setSendingImmixTest: setSendingImmixTest,
                setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                sureviewAlerts: sureviewAlerts,
                setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                sentinelAlerts: sentinelAlerts,
                setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                boldAlerts: boldAlerts,
                setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                patriotAlerts: patriotAlerts,
                setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                softguardAlerts: softguardAlerts,
                setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                immixAlertsOnCamera: immixAlertsOnCamera,
                sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                siteInfo: siteInfo,
                webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                boldAlertsOnCamera: boldAlertsOnCamera,
                patriotAlertsOnCamera: patriotAlertsOnCamera,
                softguardAlertsOnCamera: softguardAlertsOnCamera,
                evalinkAlertsOnCamera: evalinkAlertsOnCamera,
                navigate: navigate
            })
        }));
        setBackdropLoadingScreenOn(false);
    }, (reason)=>{
        postPatchObjectFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setCameraGeneralInfo(cameraGeneralInfoBackup);
            setPatchObject({
                camera_name: cameraGeneralInfoBackup.camera_name,
                streams: cameraGeneralInfoBackup.streams
            });
            setBackdropLoadingScreenOn(false);
        });
    });
    !postPatchObjectFail && await AxiosUI.get(`camera/site/?customer__id=${(0, $a8BPe.getNumbersAfterSites)(location.href)}`).then((response)=>{
        getSiteCamerasFail = false;
        localStorage.setItem("siteCameras", JSON.stringify(response.data));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            getSiteCamerasFail = true;
        });
    });
    !postPatchObjectFail && !getSiteCamerasFail && await AxiosUI.get(`customer/${(0, $a8BPe.getNumbersAfterSites)(location.href)}/about/`).then((response)=>{
        localStorage.setItem("siteInfo", JSON.stringify(response.data));
        localStorage.setItem("integrationType", response.data.integration_type);
        setIgnoreZonesBreadCrumbs(/*#__PURE__*/ (0, $k4ank.jsx)((0, $lukvk.IgnoreZonesBreadCrumbs), {
            linksArray: (0, $h0DCc.createIgnoreZonesLinksArray)(response.data.breadcrumbs),
            handleSitesBreadcrumbClick: handleSitesBreadcrumbClick,
            handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick,
            styling: "absolute top-[10px] left-[30px]"
        }));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
        });
    });
};

});


parcelRegister("aqdBl", function(module, exports) {

$parcel$export(module.exports, "AddDiceAlertDialog", () => $d1e98d60efd6cf52$export$905be1bc829be1aa);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $ce8iU = parcelRequire("ce8iU");

var $lk6eW = parcelRequire("lk6eW");

var $8B8vg = parcelRequire("8B8vg");
var $kbChx = parcelRequire("kbChx");
var $3baw3 = parcelRequire("3baw3");
var $9qNow = parcelRequire("9qNow");
var $eejVe = parcelRequire("eejVe");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $jFFWl = parcelRequire("jFFWl");

var $aZxZ3 = parcelRequire("aZxZ3");
const $d1e98d60efd6cf52$export$905be1bc829be1aa = ({ setAddDiceAlertDialogOpen: setAddDiceAlertDialogOpen, addDiceAlertDialogOpen: addDiceAlertDialogOpen, diceAlerts: diceAlerts, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setCameraGeneralInfo: setCameraGeneralInfo, setCameraGeneralInfoBackup: setCameraGeneralInfoBackup, setGeneralInfoChangesMade: setGeneralInfoChangesMade, setPatchObject: setPatchObject, setDiceAlerts: setDiceAlerts, setActiveTab: setActiveTab, cameraGeneralInfoBackup: cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs: setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick: handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick, cameraGeneralInfo: cameraGeneralInfo, setSendingDiceTest: setSendingDiceTest, setDiceTestSuccessDialogOpen: setDiceTestSuccessDialogOpen, setDiceTestFailDialogOpen: setDiceTestFailDialogOpen, setDeleteDiceAlertDialogOpen: setDeleteDiceAlertDialogOpen, sureviewAlerts: sureviewAlerts, setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen, cameraWebhookData: cameraWebhookData, setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen, sentinelAlerts: sentinelAlerts, setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen, boldAlerts: boldAlerts, setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen, patriotAlerts: patriotAlerts, setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen, softguardAlerts: softguardAlerts, setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen, diceAlertsOnCamera: diceAlertsOnCamera, sureViewAlertsOnCamera: sureViewAlertsOnCamera, siteInfo: siteInfo, webhooksAlertsOnCamera: webhooksAlertsOnCamera, sentinelAlertsOnCamera: sentinelAlertsOnCamera, boldAlertsOnCamera: boldAlertsOnCamera, patriotAlertsOnCamera: patriotAlertsOnCamera, softguardAlertsOnCamera: softguardAlertsOnCamera, evalinkAlertsOnCamera: evalinkAlertsOnCamera })=>{
    const { cameraStreams: cameraStreams, cameraStreamsPatchObject: cameraStreamsPatchObject } = (0, $aZxZ3.useEditCameraStore)();
    const streamNames = new Map();
    cameraStreams?.forEach((object, index)=>{
        streamNames.set(`${object.name} (${object.product})`, index);
    });
    const navigate = (0, $3T949.useNavigate)();
    const [postObject, setPostObject] = $8T3gX.useState({
        id: -1,
        dice_server: "",
        dice_port: 0,
        dice_email: "",
        dice_input1: "",
        draw_ignore_zones: false,
        active: true
    });
    const [selectedStreamNames, setSelectedStreamNames] = $8T3gX.useState([]);
    $8T3gX.useEffect(()=>{
        if (diceAlerts[0]) setPostObject({
            id: -1,
            dice_server: diceAlerts[0].dice_server,
            dice_port: diceAlerts[0].dice_port,
            dice_email: diceAlerts[0].dice_email,
            dice_input1: diceAlerts[0].dice_input1,
            draw_ignore_zones: diceAlerts[0].draw_ignore_zones,
            active: true
        });
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: addDiceAlertDialogOpen,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: "Add Dice Alert"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                children: [
                    cameraStreams && cameraStreams.length > 1 && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $lk6eW.default), {
                                component: "legend",
                                sx: {
                                    paddingBottom: 1
                                },
                                children: [
                                    " ",
                                    "Streams*"
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                multiple: true,
                                options: cameraStreams.map((object)=>{
                                    return `${object.name} (${object.product})`;
                                }),
                                sx: {
                                    width: 400
                                },
                                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        ...params
                                    }),
                                onChange: (event, value)=>{
                                    setSelectedStreamNames(value);
                                }
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "dice_server",
                        variant: "standard",
                        label: "Dice Server",
                        defaultValue: diceAlerts[0] ? diceAlerts[0].dice_server : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    dice_server: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        helperText: "What is the url for your dice server.",
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "dice_port",
                        variant: "standard",
                        label: "Dice Port",
                        defaultValue: diceAlerts[0] ? diceAlerts[0].dice_port : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    dice_port: parseInt(event.target.value, 10)
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        helperText: "What is the port for your dice server.",
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "dice_email",
                        variant: "standard",
                        label: "Dice email",
                        defaultValue: diceAlerts[0] ? diceAlerts[0].dice_email : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    dice_email: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "dice_input1",
                        variant: "standard",
                        label: "Dice Input1",
                        defaultValue: diceAlerts[0] ? diceAlerts[0].dice_input1 : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    dice_input1: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                sx: {
                                    fontFamily: "Mulish",
                                    color: "#001943"
                                },
                                label: "Draw Ignore Zones",
                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                    color: "primary",
                                    defaultChecked: diceAlerts[0] ? diceAlerts[0].draw_ignore_zones : false,
                                    onChange: (event, checked)=>{
                                        setPostObject((previousState)=>{
                                            return {
                                                ...previousState,
                                                draw_ignore_zones: checked
                                            };
                                        });
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                                children: "If checked, draws ignore zones in the alert images."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setAddDiceAlertDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            const selectedStreamIndexs = [];
                            const streamsObjectToPost = JSON.parse(JSON.stringify(cameraStreamsPatchObject));
                            if (cameraStreams && cameraStreams.length > 1) {
                                selectedStreamNames.forEach((streamName)=>{
                                    selectedStreamIndexs.push(streamNames.get(streamName));
                                });
                                selectedStreamIndexs.forEach((streamIndex)=>{
                                    if (streamsObjectToPost[streamIndex]) streamsObjectToPost[streamIndex].dice_alerts = [
                                        ...streamsObjectToPost[streamIndex].dice_alerts,
                                        postObject
                                    ];
                                });
                            }
                            if (cameraStreams && cameraStreams.length === 1) streamsObjectToPost[0].dice_alerts.push(postObject);
                            setAddDiceAlertDialogOpen(false);
                            setBackdropLoadingScreenOn(true);
                            (0, $jFFWl.handleSubmitNewDiceAlert)(cameraGeneralInfo, diceAlerts, streamsObjectToPost, navigate, setBackdropLoadingScreenOn, setCameraGeneralInfo, setCameraGeneralInfoBackup, setGeneralInfoChangesMade, setPatchObject, setDiceAlerts, setActiveTab, setAddDiceAlertDialogOpen, cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, setSendingDiceTest, setDiceTestSuccessDialogOpen, setDiceTestFailDialogOpen, setDeleteDiceAlertDialogOpen, sureviewAlerts, setAddSureviewAlertDialogOpen, cameraWebhookData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, sentinelAlerts, setAddSentinelAlertDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, diceAlertsOnCamera, sureViewAlertsOnCamera, siteInfo, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera);
                        },
                        text: "Submit",
                        disabled: false
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("jFFWl", function(module, exports) {

$parcel$export(module.exports, "handleSubmitNewDiceAlert", () => $6682f108ae125226$export$9bf1e49de711b899);

var $k4ank = parcelRequire("k4ank");

var $195EM = parcelRequire("195EM");

var $815yO = parcelRequire("815yO");

var $lukvk = parcelRequire("lukvk");

var $h0DCc = parcelRequire("h0DCc");

var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");

var $dWhHk = parcelRequire("dWhHk");

var $4wo2Y = parcelRequire("4wo2Y");

var $aZxZ3 = parcelRequire("aZxZ3");
const $6682f108ae125226$export$9bf1e49de711b899 = async (cameraGeneralInfo, diceAlerts, postObject, navigate, setBackdropLoadingScreenOn, setCameraGeneralInfo, setCameraGeneralInfoBackup, setGeneralInfoChangesMade, setPatchObject, setDiceAlerts, setActiveTab, setAddDiceAlertDialogOpen, cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, setSendingDiceTest, setDiceTestSuccessDialogOpen, setDiceTestFailDialogOpen, setDeleteDiceAlertDialogOpen, sureviewAlerts, setAddSureviewAlertDialogOpen, cameraWebhookData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, sentinelAlerts, setAddSentinelAlertDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, diceAlertsOnCamera, sureViewAlertsOnCamera, siteInfo, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $6682f108ae125226$export$9bf1e49de711b899(cameraGeneralInfo, diceAlerts, postObject, navigate, setBackdropLoadingScreenOn, setCameraGeneralInfo, setCameraGeneralInfoBackup, setGeneralInfoChangesMade, setPatchObject, setDiceAlerts, setActiveTab, setAddDiceAlertDialogOpen, cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, setSendingDiceTest, setDiceTestSuccessDialogOpen, setDiceTestFailDialogOpen, setDeleteDiceAlertDialogOpen, sureviewAlerts, setAddSureviewAlertDialogOpen, cameraWebhookData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, sentinelAlerts, setAddSentinelAlertDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, diceAlertsOnCamera, sureViewAlertsOnCamera, siteInfo, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera);
    };
    let postPatchObjectFail = false;
    let getSiteCamerasFail = false;
    const { setCameraStreamsPatchObject: setCameraStreamsPatchObject, setCameraStreamsObject: setCameraStreamsObject } = (0, $aZxZ3.useEditCameraStore).getState();
    await AxiosUI.patch(`/camera/${(0, $a8BPe.getNumbersAfterEditCamera)(location.href)}/general_info/`, {
        streams: postObject
    }).then((response)=>{
        postPatchObjectFail = false;
        (0, $815yO.markSiteUnsynced)();
        setCameraGeneralInfo(response.data);
        setCameraGeneralInfoBackup(response.data);
        setCameraStreamsPatchObject(response.data.streams);
        setCameraStreamsObject(response.data.streams);
        const pushedArray = [];
        response.data.streams[0].dice_alerts.forEach((alertObject)=>{
            pushedArray.push(alertObject);
        });
        setDiceAlerts(pushedArray);
        setGeneralInfoChangesMade(false);
        setPatchObject({});
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dWhHk.AlertSettingsTab), {
                diceAlerts: pushedArray,
                setAddDiceAlertDialogOpen: setAddDiceAlertDialogOpen,
                setSendingDiceTest: setSendingDiceTest,
                setDiceTestSuccessDialogOpen: setDiceTestSuccessDialogOpen,
                setDiceTestFailDialogOpen: setDiceTestFailDialogOpen,
                setDeleteDiceAlertDialogOpen: setDeleteDiceAlertDialogOpen,
                sureviewAlerts: sureviewAlerts,
                setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                sentinelAlerts: sentinelAlerts,
                setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                boldAlerts: boldAlerts,
                setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                patriotAlerts: patriotAlerts,
                setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                softguardAlerts: softguardAlerts,
                setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                diceAlertsOnCamera: diceAlertsOnCamera,
                sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                siteInfo: siteInfo,
                webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                boldAlertsOnCamera: boldAlertsOnCamera,
                patriotAlertsOnCamera: patriotAlertsOnCamera,
                softguardAlertsOnCamera: softguardAlertsOnCamera,
                evalinkAlertsOnCamera: evalinkAlertsOnCamera,
                navigate: navigate
            })
        }));
        setBackdropLoadingScreenOn(false);
    }, (reason)=>{
        postPatchObjectFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setCameraGeneralInfo(cameraGeneralInfoBackup);
            setPatchObject({
                camera_name: cameraGeneralInfoBackup.camera_name,
                streams: cameraGeneralInfoBackup.streams
            });
            setBackdropLoadingScreenOn(false);
        });
    });
    !postPatchObjectFail && await AxiosUI.get(`camera/site/?customer__id=${(0, $a8BPe.getNumbersAfterSites)(location.href)}`).then((response)=>{
        getSiteCamerasFail = false;
        localStorage.setItem("siteCameras", JSON.stringify(response.data));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            getSiteCamerasFail = true;
        });
    });
    !postPatchObjectFail && !getSiteCamerasFail && await AxiosUI.get(`customer/${(0, $a8BPe.getNumbersAfterSites)(location.href)}/about/`).then((response)=>{
        localStorage.setItem("siteInfo", JSON.stringify(response.data));
        localStorage.setItem("integrationType", response.data.integration_type);
        setIgnoreZonesBreadCrumbs(/*#__PURE__*/ (0, $k4ank.jsx)((0, $lukvk.IgnoreZonesBreadCrumbs), {
            linksArray: (0, $h0DCc.createIgnoreZonesLinksArray)(response.data.breadcrumbs),
            handleSitesBreadcrumbClick: handleSitesBreadcrumbClick,
            handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick,
            styling: "absolute top-[10px] left-[30px]"
        }));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
        });
    });
};

});


parcelRegister("gBjZk", function(module, exports) {

$parcel$export(module.exports, "AddSureviewAlertDialog", () => $d156428e97771ff6$export$3db2280ea1bb8640);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");

var $SVr4d = parcelRequire("SVr4d");

var $aZxZ3 = parcelRequire("aZxZ3");

var $lk6eW = parcelRequire("lk6eW");
const $d156428e97771ff6$export$3db2280ea1bb8640 = ({ setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen, addSureviewAlertDialogOpen: addSureviewAlertDialogOpen, sureViewAlerts: sureViewAlerts, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setCameraGeneralInfo: setCameraGeneralInfo, setCameraGeneralInfoBackup: setCameraGeneralInfoBackup, setGeneralInfoChangesMade: setGeneralInfoChangesMade, setPatchObject: setPatchObject, setSureviewAlerts: setSureviewAlerts, setActiveTab: setActiveTab, cameraGeneralInfoBackup: cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs: setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick: handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick, cameraGeneralInfo: cameraGeneralInfo, immixAlerts: immixAlerts, setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen, setSendingImmixTest: setSendingImmixTest, setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen: setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen, cameraWebhookData: cameraWebhookData, setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen, sentinelAlerts: sentinelAlerts, setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen, boldAlerts: boldAlerts, setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen, patriotAlerts: patriotAlerts, setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen, softguardAlerts: softguardAlerts, setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen, immixAlertsOnCamera: immixAlertsOnCamera, sureViewAlertsOnCamera: sureViewAlertsOnCamera, siteInfo: siteInfo, webhooksAlertsOnCamera: webhooksAlertsOnCamera, sentinelAlertsOnCamera: sentinelAlertsOnCamera, boldAlertsOnCamera: boldAlertsOnCamera, patriotAlertsOnCamera: patriotAlertsOnCamera, softguardAlertsOnCamera: softguardAlertsOnCamera, evalinkAlertsOnCamera: evalinkAlertsOnCamera })=>{
    const { cameraStreams: cameraStreams, cameraStreamsPatchObject: cameraStreamsPatchObject } = (0, $aZxZ3.useEditCameraStore)();
    const streamNames = new Map();
    cameraStreams?.forEach((object, index)=>{
        streamNames.set(`${object.name} (${object.product})`, index);
    });
    const navigate = (0, $3T949.useNavigate)();
    const serverOptions = [
        [
            "US SMTP Server",
            "us-smtp.sureviewops.com"
        ],
        [
            "EU SMTP Server",
            "eu-smtp.sureviewops.com"
        ]
    ];
    const optionsIds = new Map();
    const optionNames = new Map();
    serverOptions.forEach((option)=>{
        optionsIds.set(option[0], option[1]);
    });
    serverOptions.forEach((option)=>{
        optionNames.set(option[1], option[0]);
    });
    const [postObject, setPostObject] = $8T3gX.useState({
        id: null,
        sureview_server: "",
        sureview_subject: "",
        sureview_cc: "",
        sureview_email: ""
    });
    const [selectedStreamNames, setSelectedStreamNames] = $8T3gX.useState([]);
    $8T3gX.useEffect(()=>{
        if (sureViewAlerts[0]) setPostObject({
            id: null,
            sureview_server: sureViewAlerts[0].sureview_server,
            sureview_subject: sureViewAlerts[0].sureview_subject,
            sureview_cc: sureViewAlerts[0].sureview_cc,
            sureview_email: sureViewAlerts[0].sureview_email
        });
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: addSureviewAlertDialogOpen,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: "Add Sureview Alert"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                children: [
                    cameraStreams && cameraStreams.length > 1 && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $lk6eW.default), {
                                component: "legend",
                                sx: {
                                    paddingBottom: 1
                                },
                                children: [
                                    " ",
                                    "Streams*"
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                multiple: true,
                                options: cameraStreams.map((object)=>{
                                    return `${object.name} (${object.product})`;
                                }),
                                sx: {
                                    width: 400
                                },
                                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        ...params
                                    }),
                                onChange: (event, value)=>{
                                    setSelectedStreamNames(value);
                                }
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                            disablePortal: true,
                            id: "sureview_server",
                            defaultValue: sureViewAlerts[0] ? optionNames.get(sureViewAlerts[0].sureview_server) : "",
                            options: serverOptions.map((option)=>{
                                return option[0];
                            }),
                            onChange: (event, newInputValue)=>{
                                setPostObject((previousState)=>{
                                    return {
                                        ...previousState,
                                        sureview_server: optionsIds.get(newInputValue)
                                    };
                                });
                            },
                            sx: {
                                width: 350
                            },
                            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                    ...params,
                                    variant: "standard",
                                    label: "Sureview Server",
                                    autoComplete: "off",
                                    id: "sureview_server",
                                    name: "sureview_server"
                                })
                        })
                    }, "sureview_server"),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "sureview_subject",
                        variant: "standard",
                        label: "Sureview Subject",
                        defaultValue: sureViewAlerts[0] ? sureViewAlerts[0].sureview_subject : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    sureview_subject: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        helperText: "",
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "sureview_cc",
                        variant: "standard",
                        label: "Sureview cc",
                        defaultValue: sureViewAlerts[0] ? sureViewAlerts[0].sureview_cc : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    sureview_cc: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        helperText: "",
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "sureview_email",
                        variant: "standard",
                        label: "Sureview Email",
                        defaultValue: sureViewAlerts[0] ? sureViewAlerts[0].sureview_email : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    sureview_email: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        helperText: "",
                        type: "string"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setAddSureviewAlertDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            const selectedStreamIndexs = [];
                            const streamsObjectToPost = JSON.parse(JSON.stringify(cameraStreamsPatchObject));
                            if (cameraStreams && cameraStreams.length > 1) {
                                selectedStreamNames.forEach((streamName)=>{
                                    selectedStreamIndexs.push(streamNames.get(streamName));
                                });
                                selectedStreamIndexs.forEach((streamIndex)=>{
                                    if (streamsObjectToPost[streamIndex]) streamsObjectToPost[streamIndex].sureview_alerts = [
                                        ...streamsObjectToPost[streamIndex].sureview_alerts,
                                        postObject
                                    ];
                                });
                            }
                            if (cameraStreams && cameraStreams.length === 1) streamsObjectToPost[0].sureview_alerts.push(postObject);
                            setAddSureviewAlertDialogOpen(false);
                            setBackdropLoadingScreenOn(true);
                            (0, $SVr4d.handleSubmitNewSureviewAlert)(cameraGeneralInfo, sureViewAlerts, streamsObjectToPost, navigate, setBackdropLoadingScreenOn, setCameraGeneralInfo, setCameraGeneralInfoBackup, setGeneralInfoChangesMade, setPatchObject, setSureviewAlerts, setActiveTab, setAddSureviewAlertDialogOpen, cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, immixAlerts, setAddImmixAlertDialogOpen, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen, cameraWebhookData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, sentinelAlerts, setAddSentinelAlertDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, immixAlertsOnCamera, sureViewAlertsOnCamera, siteInfo, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera);
                        },
                        text: "Submit",
                        disabled: false
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("SVr4d", function(module, exports) {

$parcel$export(module.exports, "handleSubmitNewSureviewAlert", () => $ddbe1eafa61f8d4c$export$1d569f3e1860c44e);

var $k4ank = parcelRequire("k4ank");

var $195EM = parcelRequire("195EM");

var $815yO = parcelRequire("815yO");

var $lukvk = parcelRequire("lukvk");

var $h0DCc = parcelRequire("h0DCc");

var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");

var $4wo2Y = parcelRequire("4wo2Y");

var $dWhHk = parcelRequire("dWhHk");

var $aZxZ3 = parcelRequire("aZxZ3");
const $ddbe1eafa61f8d4c$export$1d569f3e1860c44e = async (cameraGeneralInfo, sureViewAlerts, postObject, navigate, setBackdropLoadingScreenOn, setCameraGeneralInfo, setCameraGeneralInfoBackup, setGeneralInfoChangesMade, setPatchObject, setSureviewAlerts, setActiveTab, setAddSureviewAlertDialogOpen, cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, immixAlerts, setAddImmixAlertDialogOpen, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen, cameraWebhookData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, sentinelAlerts, setAddSentinelAlertDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, immixAlertsOnCamera, sureViewAlertsOnCamera, siteInfo, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $ddbe1eafa61f8d4c$export$1d569f3e1860c44e(cameraGeneralInfo, sureViewAlerts, postObject, navigate, setBackdropLoadingScreenOn, setCameraGeneralInfo, setCameraGeneralInfoBackup, setGeneralInfoChangesMade, setPatchObject, setSureviewAlerts, setActiveTab, setAddSureviewAlertDialogOpen, cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, immixAlerts, setAddImmixAlertDialogOpen, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen, cameraWebhookData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, sentinelAlerts, setAddSentinelAlertDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, immixAlertsOnCamera, sureViewAlertsOnCamera, siteInfo, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera);
    };
    let postPatchObjectFail = false;
    let getSiteCamerasFail = false;
    const { setCameraStreamsPatchObject: setCameraStreamsPatchObject, setCameraStreamsObject: setCameraStreamsObject } = (0, $aZxZ3.useEditCameraStore).getState();
    await AxiosUI.patch(`/camera/${(0, $a8BPe.getNumbersAfterEditCamera)(location.href)}/general_info/`, {
        streams: postObject
    }).then((response)=>{
        postPatchObjectFail = false;
        (0, $815yO.markSiteUnsynced)();
        setCameraGeneralInfo(response.data);
        setCameraGeneralInfoBackup(response.data);
        setCameraStreamsPatchObject(response.data.streams);
        setCameraStreamsObject(response.data.streams);
        const pushedArray = [];
        response.data.streams[0].sureview_alerts.forEach((alertObject)=>{
            pushedArray.push(alertObject);
        });
        setSureviewAlerts(pushedArray);
        setGeneralInfoChangesMade(false);
        setPatchObject({});
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dWhHk.AlertSettingsTab), {
                immixAlerts: immixAlerts,
                setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                setSendingImmixTest: setSendingImmixTest,
                setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                sureviewAlerts: pushedArray,
                setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                sentinelAlerts: sentinelAlerts,
                setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                boldAlerts: boldAlerts,
                setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                patriotAlerts: patriotAlerts,
                setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                softguardAlerts: softguardAlerts,
                setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                immixAlertsOnCamera: immixAlertsOnCamera,
                sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                siteInfo: siteInfo,
                webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                boldAlertsOnCamera: boldAlertsOnCamera,
                patriotAlertsOnCamera: patriotAlertsOnCamera,
                softguardAlertsOnCamera: softguardAlertsOnCamera,
                evalinkAlertsOnCamera: evalinkAlertsOnCamera,
                navigate: navigate
            })
        }));
        setBackdropLoadingScreenOn(false);
    }, (reason)=>{
        postPatchObjectFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setCameraGeneralInfo(cameraGeneralInfoBackup);
            setPatchObject({
                camera_name: cameraGeneralInfoBackup.camera_name,
                streams: cameraGeneralInfoBackup.streams
            });
            setBackdropLoadingScreenOn(false);
        });
    });
    !postPatchObjectFail && await AxiosUI.get(`camera/site/?customer__id=${(0, $a8BPe.getNumbersAfterSites)(location.href)}`).then((response)=>{
        getSiteCamerasFail = false;
        localStorage.setItem("siteCameras", JSON.stringify(response.data));
    }, (reason)=>{
        getSiteCamerasFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
    });
    !postPatchObjectFail && !getSiteCamerasFail && await AxiosUI.get(`customer/${(0, $a8BPe.getNumbersAfterSites)(location.href)}/about/`).then((response)=>{
        localStorage.setItem("siteInfo", JSON.stringify(response.data));
        localStorage.setItem("integrationType", response.data.integration_type);
        setIgnoreZonesBreadCrumbs(/*#__PURE__*/ (0, $k4ank.jsx)((0, $lukvk.IgnoreZonesBreadCrumbs), {
            linksArray: (0, $h0DCc.createIgnoreZonesLinksArray)(response.data.breadcrumbs),
            handleSitesBreadcrumbClick: handleSitesBreadcrumbClick,
            handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick,
            styling: "absolute top-[10px] left-[30px]"
        }));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
        });
    });
};

});


parcelRegister("6oEZE", function(module, exports) {

$parcel$export(module.exports, "EditCameraAlerts", () => $beea9d664f695114$export$19763f416499bac7);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $3QMQN = parcelRequire("3QMQN");
const $beea9d664f695114$export$19763f416499bac7 = ({ editCameraAlerts: editCameraAlerts, setEditCameraAlerts: setEditCameraAlerts, cameraName: cameraName })=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            editCameraAlerts.triggerMotionSuccess && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                onClose: ()=>{
                    setEditCameraAlerts((previousState)=>{
                        return {
                            ...previousState,
                            triggerMotionSuccess: false
                        };
                    });
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "font-mulish font-bold text-[16px]",
                    children: `Motion event sent successfully to ${cameraName}`
                })
            }),
            editCameraAlerts.triggerMotionFail && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                severity: "warning",
                onClose: ()=>{
                    setEditCameraAlerts((previousState)=>{
                        return {
                            ...previousState,
                            triggerMotionFail: false
                        };
                    });
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "font-mulish font-bold text-[16px]",
                    children: `Motion event failed to send, please try again`
                })
            })
        ]
    });
};

});

parcelRegister("02she", function(module, exports) {

$parcel$export(module.exports, "getEditCameraData", () => $6c3c22cc9985eb4d$export$8dadfb84fac704f);

var $k4ank = parcelRequire("k4ank");

var $195EM = parcelRequire("195EM");

var $7kQyB = parcelRequire("7kQyB");

var $9nV3F = parcelRequire("9nV3F");

var $b5NEf = parcelRequire("b5NEf");

var $lukvk = parcelRequire("lukvk");

var $erReF = parcelRequire("erReF");

var $4toZl = parcelRequire("4toZl");

var $9Zf9w = parcelRequire("9Zf9w");

var $dmblq = parcelRequire("dmblq");

var $3Zv1D = parcelRequire("3Zv1D");

var $igqrx = parcelRequire("igqrx");

var $b9Vun = parcelRequire("b9Vun");

var $21UOo = parcelRequire("21UOo");

var $l8TQ5 = parcelRequire("l8TQ5");

var $aZxZ3 = parcelRequire("aZxZ3");

var $2uwzz = parcelRequire("2uwzz");

var $ebTQj = parcelRequire("ebTQj");

var $7IAhZ = parcelRequire("7IAhZ");

var $3FJ79 = parcelRequire("3FJ79");

var $alfPp = parcelRequire("alfPp");

var $6o91K = parcelRequire("6o91K");
const $6c3c22cc9985eb4d$export$8dadfb84fac704f = async (navigate, siteId, cameraId, setSiteInfo, setCameraGeneralInfo, setCameraObject, setCameraDataLoaded, setBackdropLoadingScreenOn, setImmixAlertsOnCamera, setIgnoreZonesBreadCrumbs, createIgnoreZonesLinksArray, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, setSureViewAlertsOnCamera, setAxisCamera, setMobotixFinished, setRecipientsConfiguredData, setTitlesArray, setActionRulesData, setActionRulesTitlesArray, setApplicationsConfiguredData, mobotixFinished, setAxisFinished, axisFinished, setMobotixCamera, setTimeTablesData, setIPNotifyData, setActionHandlerData, setCameraGeneralInfoBackup, setImmixAlerts, setSureviewAlerts, setActiveProducts, setActiveTab, actionRulesTitlesArray, applicationsConfiguredData, cameraGeneralInfo, actionRulesData, setSrcImages, permissions, setCameraInfoRow, width, setCameraWebhookData, setProductsData, setBackupProductsData, setSentinelAlertsOnCamera, setSentinelAlerts, setBoldAlertsOnCamera, setBoldAlerts, setPatriotAlertsOnCamera, setPatriotAlerts, setUSMonitoringAlertsOnCamera, setUSMonitoringAlerts, setWebhooksAlertsOnCamera, setSoftguardAlertsOnCamera, setSoftguardAlerts, setEvalinkAlertsOnCamera, setStreamParametersData, setShowStreamParameters, setEditCameraAlerts, setDiceAlertsOnCamera, setDiceAlerts, holdBackdropAfterCameraLoad, isMountedRef)=>{
    // Helper function to safely call state setters only if component is mounted
    const safeSetState = (setter, value)=>{
        if (!isMountedRef || isMountedRef.current) setter(value);
    };
    const { getMetadataTagZones: getMetadataTagZones } = (0, $3FJ79.useSiteAboutStore).getState();
    const { setShowHealthMonitoring: setShowHealthMonitoring, handleCheckForVCHOnlySite: handleCheckForVCHOnlySite, setShowSlicingWarningMessage: setShowSlicingWarningMessage } = (0, $aZxZ3.useEditCameraStore).getState();
    localStorage.setItem("siteId", siteId);
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $6c3c22cc9985eb4d$export$8dadfb84fac704f(navigate, siteId, cameraId, setSiteInfo, setCameraGeneralInfo, setCameraObject, setCameraDataLoaded, setBackdropLoadingScreenOn, setImmixAlertsOnCamera, setIgnoreZonesBreadCrumbs, createIgnoreZonesLinksArray, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, setSureViewAlertsOnCamera, setAxisCamera, setMobotixFinished, setRecipientsConfiguredData, setTitlesArray, setActionRulesData, setActionRulesTitlesArray, setApplicationsConfiguredData, mobotixFinished, setAxisFinished, axisFinished, setMobotixCamera, setTimeTablesData, setIPNotifyData, setActionHandlerData, setCameraGeneralInfoBackup, setImmixAlerts, setSureviewAlerts, setActiveProducts, setActiveTab, actionRulesTitlesArray, applicationsConfiguredData, cameraGeneralInfo, actionRulesData, setSrcImages, permissions, setCameraInfoRow, width, setCameraWebhookData, setProductsData, setBackupProductsData, setSentinelAlertsOnCamera, setSentinelAlerts, setBoldAlertsOnCamera, setBoldAlerts, setPatriotAlertsOnCamera, setPatriotAlerts, setUSMonitoringAlertsOnCamera, setUSMonitoringAlerts, setWebhooksAlertsOnCamera, setSoftguardAlertsOnCamera, setSoftguardAlerts, setEvalinkAlertsOnCamera, setStreamParametersData, setShowStreamParameters, setEditCameraAlerts, setDiceAlertsOnCamera, setDiceAlerts, holdBackdropAfterCameraLoad, isMountedRef);
    };
    let getSiteInfoFail = false;
    localStorage.setItem("noAutoAddCamerasDialogOpen", "true");
    let generalInfo = {};
    const alarmOptions = localStorage.alarmOptions ? JSON.parse(localStorage.alarmOptions) : [];
    const alarmIds = new Map();
    alarmOptions.forEach((object)=>{
        alarmIds.set(object.value, object.name);
    });
    let tempSiteInfo = {};
    const { setSysaidAlertsOnCamera: setSysaidAlertsOnCamera, setNotesText: setNotesText } = (0, $aZxZ3.useEditCameraStore).getState();
    await AxiosUI.get(`customer/${siteId}/about/`).then((response)=>{
        // Check if component is still mounted before updating state
        if (isMountedRef && !isMountedRef.current) return;
        getSiteInfoFail = false;
        (0, $7kQyB.fetchAddCameraInfo)(siteId, navigate);
        safeSetState(setSiteInfo, response.data);
        const { setSiteInfoEditCamera: setSiteInfoEditCamera } = (0, $aZxZ3.useEditCameraStore).getState();
        setSiteInfoEditCamera(response.data);
        tempSiteInfo = response.data;
        generalInfo = response.data;
        localStorage.setItem("siteInfo", JSON.stringify(response.data));
        if (response.data.integration_type_name.includes("SMTP")) setShowSlicingWarningMessage(true);
        if (response.data.chm) setShowHealthMonitoring(true);
        if (response.data.integration_type_name === "autopatrol") {
            getMetadataTagZones(navigate);
            handleCheckForVCHOnlySite(navigate);
        }
        (0, $b9Vun.checkForAlarmType)(response.data.default_alarm, setBoldAlertsOnCamera, setPatriotAlertsOnCamera, setSureViewAlertsOnCamera, setSentinelAlertsOnCamera, setImmixAlertsOnCamera, setWebhooksAlertsOnCamera, setSoftguardAlertsOnCamera, setEvalinkAlertsOnCamera, setDiceAlertsOnCamera);
        (0, $21UOo.getStreamParametersExtraFields)(cameraId, setStreamParametersData, setShowStreamParameters, navigate);
        safeSetState(setIgnoreZonesBreadCrumbs, /*#__PURE__*/ (0, $k4ank.jsx)((0, $lukvk.IgnoreZonesBreadCrumbs), {
            linksArray: createIgnoreZonesLinksArray(response.data.breadcrumbs),
            handleSitesBreadcrumbClick: handleSitesBreadcrumbClick,
            handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick,
            styling: "absolute top-[10px] left-[30px]"
        }));
        localStorage.setItem("integrationType", response.data.integration_type);
        if (response.data.auto_add) localStorage.setItem("autoAdd", "true");
        else localStorage.setItem("autoAdd", "false");
    }, (reason)=>{
        getSiteInfoFail = true;
        if ((0, $igqrx.isResourceNotFoundError)(reason)) {
            setBackdropLoadingScreenOn(false);
            (0, $igqrx.navigateToResourceNotFound)(navigate, "site", siteId);
        } else (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Error retrieving site data");
            navigate("/dashboard");
            (0, $ebTQj.logger).log(`${reason}`);
            localStorage.setItem("autoAdd", "true");
        });
    });
    !getSiteInfoFail && await AxiosUI.get(`/camera/${cameraId}/general_info/`).then((response)=>{
        // Check if component is still mounted before updating state
        if (isMountedRef && !isMountedRef.current) return;
        const cameraObject = response.data;
        setNotesText(cameraObject.notes);
        localStorage.setItem("currentCamera", response.data.camera_name);
        safeSetState(setCameraGeneralInfo, cameraObject);
        // Per-camera motion (ENG-2242): the motion card and the Axis/Mobotix
        // motion-off logic read the camera's override/resolved value from here.
        (0, $l8TQ5.recordCameraMotionFromGeneralInfo)(cameraObject);
        const { setCameraStreamsObject: setCameraStreamsObject, setCameraStreamsPatchObject: setCameraStreamsPatchObject, setLineCrossingActive: setLineCrossingActive, getLineCrossingsData: getLineCrossingsData, fetchCameraVlmConfig: fetchCameraVlmConfig } = (0, $aZxZ3.useEditCameraStore).getState();
        if (cameraObject.camera_view === "fisheye" || cameraObject.camera_view === "180_fisheye") setShowSlicingWarningMessage(true);
        // Extract lineCrossingActive state from general_info response
        const streams = cameraObject.streams || [];
        let intruderLineCrossingActive = false;
        let vehicleLineCrossingActive = false;
        streams.forEach((stream)=>{
            const streamMetrics = stream.stream_metrics || [];
            streamMetrics.forEach((metric)=>{
                if (metric.label_name === "intruder_line_crossing" && metric.active) intruderLineCrossingActive = true;
                if (metric.label_name === "vehicle_line_crossing" && metric.active) vehicleLineCrossingActive = true;
            });
        });
        setLineCrossingActive({
            intruder: intruderLineCrossingActive,
            vehicle: vehicleLineCrossingActive
        });
        // Fetch line crossings and VLM config during initial page load
        getLineCrossingsData(navigate, cameraId);
        fetchCameraVlmConfig(Number(cameraId), navigate);
        setCameraStreamsObject(cameraObject.streams);
        setCameraStreamsPatchObject(cameraObject.streams);
        // Store only essential camera info to avoid localStorage quota issues
        const essentialCameraInfo = {
            id: cameraObject.id,
            camera_name: cameraObject.camera_name,
            camera_type: cameraObject.camera_type?.display_name || null
        };
        (0, $2uwzz.safeSetItem)("currentCameraInfo", essentialCameraInfo);
        safeSetState(setCameraObject, cameraObject);
        const resolvedDefaultAlarmName = (0, $7IAhZ.getDefaultAlarmName)(cameraObject.default_alarm);
        if (resolvedDefaultAlarmName === "Immix") safeSetState(setImmixAlertsOnCamera, true);
        if (resolvedDefaultAlarmName === "Dice") safeSetState(setDiceAlertsOnCamera, true);
        if (resolvedDefaultAlarmName === "SureView") safeSetState(setSureViewAlertsOnCamera, true);
        if (resolvedDefaultAlarmName === "Sentinel") safeSetState(setSentinelAlertsOnCamera, true);
        if (resolvedDefaultAlarmName === "Evalink") safeSetState(setEvalinkAlertsOnCamera, true);
        if (resolvedDefaultAlarmName === "Sysaid") setSysaidAlertsOnCamera(true);
        if (cameraObject.streams[0]) cameraObject.streams.forEach((obj)=>{
            if (obj.bold_alerts[0]) safeSetState(setBoldAlertsOnCamera, true);
            if (obj.patriot_alerts[0]) safeSetState(setPatriotAlertsOnCamera, true);
            if (obj.sysaid_alerts[0]) setSysaidAlertsOnCamera(true);
            if (obj.evalink_alerts?.[0]) safeSetState(setEvalinkAlertsOnCamera, true);
            // if (obj.us_monitoring_alerts[0]) {
            //   safeSetState(setUSMonitoringAlertsOnCamera, true);
            // }
            if (obj.sureview_alerts[0]) safeSetState(setSureViewAlertsOnCamera, true);
            if (obj.immix_alerts[0]) {
                safeSetState(setImmixAlertsOnCamera, true);
                //make a clone object of response
                if (obj.immix_alerts.length > 1) {
                    const newSortedObect = cameraObject;
                    //make a clone streams of clone object and run numericallySortAlerts on the clone stream object
                    const newSortedStreams = (0, $b5NEf.matchAllStreams)(newSortedObect.streams, "immix_alerts");
                    //reassign clone object's streams property to the clone streams
                    newSortedObect.streams = newSortedStreams;
                    //store the clone object in local storage
                    safeSetState(setCameraGeneralInfo, newSortedObect);
                }
            }
            if (obj.dice_alerts?.[0]) {
                safeSetState(setDiceAlertsOnCamera, true);
                //make a clone object of response
                if (obj.dice_alerts.length > 1) {
                    const newSortedObect = cameraObject;
                    //make a clone streams of clone object and run numericallySortAlerts on the clone stream object
                    const newSortedStreams = (0, $b5NEf.matchAllStreams)(newSortedObect.streams, "dice_alerts");
                    //reassign clone object's streams property to the clone streams
                    newSortedObect.streams = newSortedStreams;
                    //store the clone object in local storage
                    safeSetState(setCameraGeneralInfo, newSortedObect);
                }
            }
            if (obj.sureview_alerts[0]) //make a clone object of response
            {
                if (obj.sureview_alerts.length > 1) {
                    const newSortedObect = cameraObject;
                    //make a clone streams of clone object and run numericallySortAlerts on the clone stream object
                    const newSortedStreams = (0, $b5NEf.matchAllStreams)(newSortedObect.streams, "sureview_alerts");
                    //reassign clone object's streams property to the clone streams
                    newSortedObect.streams = newSortedStreams;
                    //store the clone object in local storage
                    safeSetState(setCameraGeneralInfo, newSortedObect);
                }
            }
        });
        if (cameraObject.camera_type) {
            if (cameraObject.camera_type.display_name === "Axis") {
                safeSetState(setAxisCamera, true);
                safeSetState(setMobotixFinished, {
                    timeTable: true,
                    iPNotify: true,
                    actionHandler: true
                });
                (0, $erReF.getAxisData)(cameraObject.id, navigate, setRecipientsConfiguredData, setTitlesArray, setActionRulesData, setActionRulesTitlesArray, setApplicationsConfiguredData, mobotixFinished, setAxisFinished, setBackdropLoadingScreenOn, axisFinished, setActiveTab, actionRulesTitlesArray, applicationsConfiguredData, cameraGeneralInfo, actionRulesData);
            } else if (cameraObject.camera_type.display_name === "Mobotix") {
                safeSetState(setMobotixCamera, true);
                safeSetState(setAxisFinished, {
                    recipient: true,
                    actionRules: true,
                    application: true
                });
                (0, $4toZl.getMobotixData)(cameraObject.id, navigate, setTimeTablesData, setBackdropLoadingScreenOn, setIPNotifyData, setActionHandlerData, axisFinished, mobotixFinished, setMobotixFinished);
            }
        }
        // Titles and cells are matched by position; both come from
        // connectionColumns.ts so they cannot drift apart.
        const connectionsTitlesArray = (0, $6o91K.buildConnectionsTitlesArray)(cameraObject, tempSiteInfo);
        localStorage.setItem("connectionsTitlesArray", JSON.stringify(connectionsTitlesArray));
        safeSetState(setCameraGeneralInfoBackup, cameraObject);
        const pushedArrayImmix = [];
        const pushedArrayDice = [];
        const pushedArraySentinel = [];
        if (cameraObject.streams[0]) {
            if (cameraObject.streams[0].immix_alerts[0]) cameraObject.streams[0].immix_alerts.forEach((object)=>{
                pushedArrayImmix.push(object);
            });
            if (cameraObject.streams[0].dice_alerts?.[0]) cameraObject.streams[0].dice_alerts.forEach((object)=>{
                pushedArrayDice.push(object);
            });
            if (cameraObject.streams[0].sentinel_alerts[0]) cameraObject.streams[0].sentinel_alerts.forEach((object)=>{
                pushedArraySentinel.push(object);
            });
        }
        safeSetState(setImmixAlerts, pushedArrayImmix);
        safeSetState(setDiceAlerts, pushedArrayDice);
        safeSetState(setSentinelAlerts, pushedArraySentinel);
        if (cameraObject.streams[0]) cameraObject.streams.forEach((streamObject)=>{
            if (streamObject.sureview_alerts[0]) localStorage.setItem("sureViewStreamObject", JSON.stringify(streamObject));
            else if (streamObject.immix_alerts[0]) localStorage.setItem("immixStreamObject", JSON.stringify(streamObject));
            else if (streamObject.dice_alerts?.[0]) localStorage.setItem("diceStreamObject", JSON.stringify(streamObject));
        });
        const sureViewPushedArray = [];
        if (cameraObject.streams[0]) {
            if (cameraObject.streams[0].sureview_alerts[0]) cameraObject.streams[0].sureview_alerts.forEach((object)=>{
                sureViewPushedArray.push(object);
            });
        }
        safeSetState(setSureviewAlerts, sureViewPushedArray);
        const boldPushedArray = [];
        if (cameraObject.streams[0]) {
            if (cameraObject.streams[0].bold_alerts[0]) cameraObject.streams[0].bold_alerts.forEach((object)=>{
                boldPushedArray.push(object);
            });
        }
        safeSetState(setBoldAlerts, boldPushedArray);
        const patriotPushedArray = [];
        if (cameraObject.streams[0]) {
            if (cameraObject.streams[0].patriot_alerts[0]) cameraObject.streams[0].patriot_alerts.forEach((object)=>{
                patriotPushedArray.push(object);
            });
        }
        safeSetState(setPatriotAlerts, patriotPushedArray);
        const softguardPushedArray = [];
        if (cameraObject.streams[0]) {
            if (cameraObject.streams[0].softguard_alerts[0]) cameraObject.streams[0].softguard_alerts.forEach((object)=>{
                softguardPushedArray.push(object);
            });
        }
        safeSetState(setSoftguardAlerts, softguardPushedArray);
        // const usMonitoringPushedArray: any[] = [];
        // if (cameraObject.streams[0]) {
        //   if (cameraObject.streams[0].us_monitoring_alerts[0]) {
        //     cameraObject.streams[0].us_monitoring_alerts.forEach((object: any) => {
        //       usMonitoringPushedArray.push(object);
        //     });
        //   }
        // }
        // setUSMonitoringAlerts(usMonitoringPushedArray);
        const streamsObject = (0, $9nV3F.createStreamsObject)(cameraObject.streams);
        (0, $9Zf9w.generateActiveProducts)(streamsObject, setActiveProducts, setProductsData, setBackupProductsData);
        safeSetState(setActiveTab, /*#__PURE__*/ (0, $k4ank.jsx)((0, $dmblq.GeneralInfoEditCameraTab), {
            siteInfo: generalInfo,
            cameraGeneralInfo: cameraObject
        }));
        AxiosUI.get(`/camera/${cameraObject.id}/status/`).then((response)=>{
            // Check if component is still mounted before updating state
            if (isMountedRef && !isMountedRef.current) return;
            const name = `${cameraObject.id}full`;
            safeSetState(setSrcImages, (previousState)=>{
                return {
                    ...previousState,
                    [cameraObject.id]: /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                        src: response.data.preview_url,
                        alt: "site_image"
                    }),
                    [name]: response.data
                };
            });
            safeSetState(setCameraInfoRow, /*#__PURE__*/ (0, $k4ank.jsx)((0, $alfPp.CameraInfoRowEditCamera), {
                obj: cameraObject,
                expanded: true,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setEditCameraAlerts: setEditCameraAlerts,
                siteInfo: tempSiteInfo,
                permissions: permissions,
                srcImages: {
                    [cameraObject.id]: /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                        src: response.data.preview_url,
                        alt: "site_image"
                    }),
                    [name]: response.data
                }
            }));
            const { getWebhooksData: getWebhooksData, getCameraStreams: getCameraStreams } = (0, $aZxZ3.useEditCameraStore).getState();
            getCameraStreams(navigate, cameraObject.id);
            getWebhooksData(navigate, cameraObject.id);
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
        });
        safeSetState(setCameraDataLoaded, true);
        if (!holdBackdropAfterCameraLoad?.()) safeSetState(setBackdropLoadingScreenOn, false);
    }, (reason)=>{
        if ((0, $igqrx.isResourceNotFoundError)(reason)) {
            setBackdropLoadingScreenOn(false);
            (0, $igqrx.navigateToResourceNotFound)(navigate, "camera", cameraId);
        } else (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Error retrieving site data");
            navigate("/");
        });
    });
};

});
parcelRegister("9nV3F", function(module, exports) {

$parcel$export(module.exports, "createStreamsObject", () => $5721bcbf9770a7c9$export$d4e2a9a101a0713f);
const $5721bcbf9770a7c9$export$d4e2a9a101a0713f = (streams)=>{
    if (!streams[0]) return;
    const passedStreamObj = {};
    streams.forEach((object)=>{
        passedStreamObj[object.id] = object;
    });
    return passedStreamObj;
};

});

parcelRegister("b5NEf", function(module, exports) {

$parcel$export(module.exports, "matchAllStreams", () => $1e64b4b8c52ff3c8$export$4b6fffee871a0b2a);
const $1e64b4b8c52ff3c8$var$numericallySortObject = (object)=>{
    const resortedObject = object;
    for(let i = 1; i < resortedObject.length; i++)for(let j = 0; j < i; j++)if (resortedObject[i].id < resortedObject[j].id) {
        const x = resortedObject[i];
        resortedObject[i] = resortedObject[j];
        resortedObject[j] = x;
    }
    return resortedObject;
};
const $1e64b4b8c52ff3c8$export$1665b829b2330625 = (streams, string)=>{
    const sortedStreams = streams;
    sortedStreams.forEach((object, index)=>{
        const sortedObject = object;
        if (string === "sureview_alerts") {
            const numericalSureviewAlerts = sortedObject.sureview_alerts;
            $1e64b4b8c52ff3c8$var$numericallySortObject(numericalSureviewAlerts);
            sortedObject.sureview_alerts = numericalSureviewAlerts;
        }
        if (string === "immix_alerts") {
            const numericalImmixViewAlerts = sortedObject.immix_alerts;
            $1e64b4b8c52ff3c8$var$numericallySortObject(numericalImmixViewAlerts);
            sortedObject.immix_alerts = numericalImmixViewAlerts;
        }
        sortedStreams[index] = sortedObject;
    });
    return sortedStreams;
};
const $1e64b4b8c52ff3c8$export$4b6fffee871a0b2a = (streams, string)=>{
    const sortedStreams = streams;
    if (string === "sureview_alerts") {
        const comparedArray = streams[0].sureview_alerts;
        sortedStreams.forEach((object, sortedStreamsIndex)=>{
            const originalAlerts = object.sureview_alerts;
            const newlySortedAlerts = new Array(originalAlerts.length);
            originalAlerts.forEach((alertObject)=>{
                for(let i = 0; i < comparedArray.length; i++)if (alertObject.sureview_server === comparedArray[i].sureview_server && alertObject.sureview_subject === comparedArray[i].sureview_subject && alertObject.sureview_cc === comparedArray[i].sureview_cc && alertObject.sureview_email === comparedArray[i].sureview_email) {
                    newlySortedAlerts[i] = alertObject;
                    break; // Found the correct position, no need to continue searching
                }
            });
            // Fill any remaining empty slots with remaining alerts
            let remainingIndex = 0;
            for(let i = 0; i < newlySortedAlerts.length; i++)if (!newlySortedAlerts[i]) {
                while(remainingIndex < originalAlerts.length && newlySortedAlerts.includes(originalAlerts[remainingIndex]))remainingIndex++;
                if (remainingIndex < originalAlerts.length) {
                    newlySortedAlerts[i] = originalAlerts[remainingIndex];
                    remainingIndex++;
                }
            }
            sortedStreams[sortedStreamsIndex].sureview_alerts = newlySortedAlerts;
        });
        return sortedStreams;
    }
    if (string === "immix_alerts") {
        const comparedArray = streams[0].immix_alerts;
        sortedStreams.forEach((object, sortedStreamsIndex)=>{
            const originalAlerts = object.immix_alerts;
            const newlySortedAlerts = new Array(originalAlerts.length);
            originalAlerts.forEach((alertObject)=>{
                for(let i = 0; i < comparedArray.length; i++)if (alertObject.immix_server === comparedArray[i].immix_server && alertObject.immix_port === comparedArray[i].immix_port && alertObject.immix_email === comparedArray[i].immix_email && alertObject.immix_input1 === comparedArray[i].immix_input1) {
                    newlySortedAlerts[i] = alertObject;
                    break; // Found the correct position, no need to continue searching
                }
            });
            // Fill any remaining empty slots with remaining alerts
            let remainingIndex = 0;
            for(let i = 0; i < newlySortedAlerts.length; i++)if (!newlySortedAlerts[i]) {
                while(remainingIndex < originalAlerts.length && newlySortedAlerts.includes(originalAlerts[remainingIndex]))remainingIndex++;
                if (remainingIndex < originalAlerts.length) {
                    newlySortedAlerts[i] = originalAlerts[remainingIndex];
                    remainingIndex++;
                }
            }
            sortedStreams[sortedStreamsIndex].immix_alerts = newlySortedAlerts;
        });
    }
    return sortedStreams;
};

});

parcelRegister("erReF", function(module, exports) {

$parcel$export(module.exports, "getAxisData", () => $3bd13a16b4602801$export$115d32e688df63d4);
// eslint-disable-next-line @typescript-eslint/no-unused-vars

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $pQI3G = parcelRequire("pQI3G");

var $3Zv1D = parcelRequire("3Zv1D");

var $ebTQj = parcelRequire("ebTQj");

var $6LVwH = parcelRequire("6LVwH");
const $3bd13a16b4602801$export$6d2e50683f1af3c2 = (cameraId)=>{
    if (localStorage.getItem("editCamerActiveTab") !== "seven") return false;
    const current = localStorage.getItem("currentCameraId");
    return !current || String(current) === String(cameraId);
};
const $3bd13a16b4602801$export$115d32e688df63d4 = async (inputId, navigate, setRecipientsConfiguredData, setTitlesArray, setActionRulesData, setActionRulesTitlesArray, setApplicationsConfiguredData, mobotixFinished, setAxisFinished, setBackdropLoadingScreenOn, axisFinished, setActiveTab, actionRulesTitlesArray, applicationsConfiguredData, cameraGeneralInfo, actionRulesData)=>{
    const showAxisTab = (tab)=>{
        if ($3bd13a16b4602801$export$6d2e50683f1af3c2(inputId)) setActiveTab(tab);
    };
    const retryFunction = ()=>{
        $3bd13a16b4602801$export$115d32e688df63d4(inputId, navigate, setRecipientsConfiguredData, setTitlesArray, setActionRulesData, setActionRulesTitlesArray, setApplicationsConfiguredData, mobotixFinished, setAxisFinished, setBackdropLoadingScreenOn, axisFinished, setActiveTab, actionRulesTitlesArray, applicationsConfiguredData, cameraGeneralInfo, actionRulesData);
    };
    const AxiosUI = (0, $195EM.createApi)("");
    // WireGuard sites (ENG-2822): admin's servers can't reach the camera and
    // say so with a 409. Show that message in the tab instead of the tables,
    // keeping Add Action Rule (it dispatches a Job on the site's network).
    // Returns false for any other error, which keeps its existing path.
    const showDeviceUnreachable = (reason)=>{
        const message = (0, $6LVwH.axisDeviceUnreachableMessage)(reason);
        if (!message) return false;
        (0, $6LVwH.useAxisDeviceJobStore).getState().setUnreachable(inputId, message);
        setAxisFinished({
            recipient: true,
            actionRules: true,
            application: true
        });
        showAxisTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
            recipientsConfiguredData: [],
            titlesArray: [],
            navigate: navigate,
            setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
            setRecipientsConfiguredData: setRecipientsConfiguredData,
            setTitlesArray: setTitlesArray,
            actionRulesData: [],
            setActionRulesData: setActionRulesData,
            actionRulesTitlesArray: [],
            setActionRulesTitlesArray: setActionRulesTitlesArray,
            setActiveTab: setActiveTab,
            applicationsConfiguredData: [],
            cameraGeneralInfo: cameraGeneralInfo,
            axisFinished: {
                recipient: true,
                actionRules: true,
                application: true
            }
        }));
        setBackdropLoadingScreenOn(false);
        return true;
    };
    let getRecipientFail = false;
    let getActionsRulesFail = false;
    let recipientData = [];
    let recipientTitlesArray = [];
    let newActionRulesData = [];
    let actionsRulesTitles = [];
    await AxiosUI.get(`/axis/${inputId}/recipient/`).then((response)=>{
        // The camera answered, so any earlier "can't reach" no longer applies.
        (0, $6LVwH.useAxisDeviceJobStore).getState().setUnreachable(inputId, null);
        if (response.data) {
            if (response.data[0]) {
                if (response.data[0].level_tag) {
                    setAxisFinished((previousState)=>{
                        return {
                            ...previousState,
                            recipient: true
                        };
                    });
                    if (localStorage.editCamerActiveTab === "seven") {
                        setBackdropLoadingScreenOn(true);
                        recipientTitlesArray = [
                            "Name",
                            "Recipient Type",
                            "Host",
                            "Port",
                            "Email From",
                            "Email To"
                        ];
                        showAxisTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
                            recipientsConfiguredData: [],
                            titlesArray: [
                                "Name",
                                "Recipient Type",
                                "Host",
                                "Port",
                                "Email From",
                                "Email To"
                            ],
                            navigate: navigate,
                            setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                            setRecipientsConfiguredData: setRecipientsConfiguredData,
                            setTitlesArray: setTitlesArray,
                            actionRulesData: actionRulesData,
                            setActionRulesData: setActionRulesData,
                            actionRulesTitlesArray: actionRulesTitlesArray,
                            setActionRulesTitlesArray: setActionRulesTitlesArray,
                            setActiveTab: setActiveTab,
                            applicationsConfiguredData: applicationsConfiguredData,
                            cameraGeneralInfo: cameraGeneralInfo,
                            axisFinished: {
                                recipient: true,
                                actionRules: false,
                                application: false
                            }
                        }));
                        setBackdropLoadingScreenOn(false);
                    }
                } else {
                    getRecipientFail = false;
                    setAxisFinished((previousState)=>{
                        return {
                            ...previousState,
                            recipient: true
                        };
                    });
                    setRecipientsConfiguredData(response.data);
                    const newTitlesArray = [
                        "Name"
                    ];
                    response.data.forEach((object)=>{
                        object.additional_fields.forEach((obj)=>{
                            if (obj.id === "recipient_type" && !newTitlesArray.includes("Recipient Type")) newTitlesArray.push("Recipient Type");
                            if (obj.id === "host" && !newTitlesArray.includes("Host")) newTitlesArray.push("Host");
                            if (obj.id === "port" && !newTitlesArray.includes("Port")) newTitlesArray.push("Port");
                            if (obj.id === "email_from" && !newTitlesArray.includes("Email From")) newTitlesArray.push("Email From");
                            if (obj.id === "email_to" && !newTitlesArray.includes("Email To")) newTitlesArray.push("Email To");
                            if (obj.id === "login" && !newTitlesArray.includes("Login")) newTitlesArray.push("Login");
                            if (obj.id === "password" && !newTitlesArray.includes("Password")) newTitlesArray.push("Password");
                        });
                    });
                    newTitlesArray.push("");
                    setTitlesArray(newTitlesArray);
                    recipientTitlesArray = newTitlesArray;
                    recipientData = response.data;
                    if (localStorage.editCamerActiveTab === "seven") {
                        setBackdropLoadingScreenOn(true);
                        showAxisTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
                            recipientsConfiguredData: recipientData,
                            titlesArray: newTitlesArray,
                            navigate: navigate,
                            setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                            setRecipientsConfiguredData: setRecipientsConfiguredData,
                            setTitlesArray: setTitlesArray,
                            actionRulesData: actionRulesData,
                            setActionRulesData: setActionRulesData,
                            actionRulesTitlesArray: actionRulesTitlesArray,
                            setActionRulesTitlesArray: setActionRulesTitlesArray,
                            setActiveTab: setActiveTab,
                            applicationsConfiguredData: applicationsConfiguredData,
                            cameraGeneralInfo: cameraGeneralInfo,
                            axisFinished: {
                                recipient: true,
                                actionRules: false,
                                application: false
                            }
                        }));
                        setBackdropLoadingScreenOn(false);
                    }
                }
            } else {
                setBackdropLoadingScreenOn(true);
                recipientTitlesArray = [
                    "Name",
                    "Recipient Type",
                    "Host",
                    "Port",
                    "Email From",
                    "Email To"
                ];
                showAxisTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
                    recipientsConfiguredData: [],
                    titlesArray: [
                        "Name",
                        "Recipient Type",
                        "Host",
                        "Port",
                        "Email From",
                        "Email To"
                    ],
                    navigate: navigate,
                    setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                    setRecipientsConfiguredData: setRecipientsConfiguredData,
                    setTitlesArray: setTitlesArray,
                    actionRulesData: actionRulesData,
                    setActionRulesData: setActionRulesData,
                    actionRulesTitlesArray: actionRulesTitlesArray,
                    setActionRulesTitlesArray: setActionRulesTitlesArray,
                    setActiveTab: setActiveTab,
                    applicationsConfiguredData: applicationsConfiguredData,
                    cameraGeneralInfo: cameraGeneralInfo,
                    axisFinished: {
                        recipient: true,
                        actionRules: true,
                        application: true
                    }
                }));
                setAxisFinished({
                    recipient: true,
                    actionRules: true,
                    application: true
                });
                setBackdropLoadingScreenOn(false);
            }
        } else {
            setBackdropLoadingScreenOn(true);
            recipientTitlesArray = [
                "Name",
                "Recipient Type",
                "Host",
                "Port",
                "Email From",
                "Email To"
            ];
            showAxisTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
                recipientsConfiguredData: [],
                titlesArray: [
                    "Name",
                    "Recipient Type",
                    "Host",
                    "Port",
                    "Email From",
                    "Email To"
                ],
                navigate: navigate,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setRecipientsConfiguredData: setRecipientsConfiguredData,
                setTitlesArray: setTitlesArray,
                actionRulesData: actionRulesData,
                setActionRulesData: setActionRulesData,
                actionRulesTitlesArray: actionRulesTitlesArray,
                setActionRulesTitlesArray: setActionRulesTitlesArray,
                setActiveTab: setActiveTab,
                applicationsConfiguredData: applicationsConfiguredData,
                cameraGeneralInfo: cameraGeneralInfo,
                axisFinished: {
                    recipient: true,
                    actionRules: true,
                    application: true
                }
            }));
            setAxisFinished({
                recipient: true,
                actionRules: true,
                application: true
            });
            setBackdropLoadingScreenOn(false);
        }
        AxiosUI.get(`/axis/${inputId}/action_rule/`).then((response)=>{
            if (response.data) {
                if (response.data[0]) {
                    if (response.data[0].level_tag) {
                        setAxisFinished((previousState)=>{
                            return {
                                ...previousState,
                                actionRules: true
                            };
                        });
                        if (localStorage.editCamerActiveTab === "seven") {
                            setBackdropLoadingScreenOn(true);
                            actionsRulesTitles = [
                                "Name",
                                "Host",
                                "Port",
                                "Email From",
                                "Email To",
                                "Message",
                                "Enabled",
                                "Profile"
                            ];
                            showAxisTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
                                recipientsConfiguredData: recipientData,
                                titlesArray: recipientTitlesArray,
                                navigate: navigate,
                                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                                setRecipientsConfiguredData: setRecipientsConfiguredData,
                                setTitlesArray: setTitlesArray,
                                actionRulesData: [],
                                setActionRulesData: setActionRulesData,
                                actionRulesTitlesArray: [
                                    "Name",
                                    "Host",
                                    "Port",
                                    "Email From",
                                    "Email To",
                                    "Message",
                                    "Enabled",
                                    "Profile"
                                ],
                                setActionRulesTitlesArray: setActionRulesTitlesArray,
                                setActiveTab: setActiveTab,
                                applicationsConfiguredData: applicationsConfiguredData,
                                cameraGeneralInfo: cameraGeneralInfo,
                                axisFinished: {
                                    recipient: true,
                                    actionRules: true,
                                    application: false
                                }
                            }));
                            setBackdropLoadingScreenOn(false);
                        }
                    } else {
                        getActionsRulesFail = false;
                        setActionRulesData(response.data);
                        newActionRulesData = response.data;
                        setAxisFinished((previousState)=>{
                            return {
                                ...previousState,
                                actionRules: true
                            };
                        });
                        const newActionRulesTitlesArray = [
                            "Name"
                        ];
                        response.data.forEach((object)=>{
                            object.additional_fields.forEach((obj)=>{
                                if (obj.id === "host" && !newActionRulesTitlesArray.includes("Host")) newActionRulesTitlesArray.push("Host");
                                if (obj.id === "port" && !newActionRulesTitlesArray.includes("Port")) newActionRulesTitlesArray.push("Port");
                                if (obj.id === "email_to" && !newActionRulesTitlesArray.includes("E-mail to")) newActionRulesTitlesArray.push("E-mail to");
                                if (obj.id === "email_from" && !newActionRulesTitlesArray.includes("E-mail from")) newActionRulesTitlesArray.push("E-mail from");
                                if (obj.id === "message" && !newActionRulesTitlesArray.includes("Message")) newActionRulesTitlesArray.push("Message");
                                if (obj.id === "enabled" && !newActionRulesTitlesArray.includes("Enabled")) newActionRulesTitlesArray.push("Enabled");
                                if (obj.id === "profile_selected" && !newActionRulesTitlesArray.includes("Profile")) newActionRulesTitlesArray.push("Profile");
                            });
                        });
                        const orderedFinalTitles = [
                            "Name"
                        ];
                        if (!orderedFinalTitles.includes("Host")) orderedFinalTitles.push("Host");
                        if (!orderedFinalTitles.includes("Port")) orderedFinalTitles.push("Port");
                        if (!orderedFinalTitles.includes("E-mail to")) orderedFinalTitles.push("E-mail to");
                        if (!orderedFinalTitles.includes("E-mail from")) orderedFinalTitles.push("E-mail from");
                        if (!orderedFinalTitles.includes("Message")) orderedFinalTitles.push("Message");
                        if (!orderedFinalTitles.includes("Enabled")) orderedFinalTitles.push("Enabled");
                        if (!orderedFinalTitles.includes("Profile")) orderedFinalTitles.push("Profile");
                        orderedFinalTitles.push("");
                        setActionRulesTitlesArray(orderedFinalTitles);
                        actionsRulesTitles = orderedFinalTitles;
                        if (localStorage.editCamerActiveTab === "seven") {
                            setBackdropLoadingScreenOn(true);
                            showAxisTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
                                recipientsConfiguredData: recipientData,
                                titlesArray: recipientTitlesArray,
                                navigate: navigate,
                                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                                setRecipientsConfiguredData: setRecipientsConfiguredData,
                                setTitlesArray: setTitlesArray,
                                actionRulesData: response.data,
                                setActionRulesData: setActionRulesData,
                                actionRulesTitlesArray: orderedFinalTitles,
                                setActionRulesTitlesArray: setActionRulesTitlesArray,
                                setActiveTab: setActiveTab,
                                applicationsConfiguredData: applicationsConfiguredData,
                                cameraGeneralInfo: cameraGeneralInfo,
                                axisFinished: {
                                    recipient: true,
                                    actionRules: true,
                                    application: false
                                }
                            }));
                            setBackdropLoadingScreenOn(false);
                        }
                    }
                } else {
                    actionsRulesTitles = [
                        "Name",
                        "Host",
                        "Port",
                        "Email From",
                        "Email To",
                        "Message",
                        "Enabled",
                        "Profile"
                    ];
                    setBackdropLoadingScreenOn(true);
                    showAxisTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
                        recipientsConfiguredData: recipientData,
                        titlesArray: recipientTitlesArray,
                        navigate: navigate,
                        setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                        setRecipientsConfiguredData: setRecipientsConfiguredData,
                        setTitlesArray: setTitlesArray,
                        actionRulesData: [],
                        setActionRulesData: setActionRulesData,
                        actionRulesTitlesArray: [
                            "Name",
                            "Host",
                            "Port",
                            "Email From",
                            "Email To",
                            "Message",
                            "Enabled",
                            "Profile"
                        ],
                        setActionRulesTitlesArray: setActionRulesTitlesArray,
                        setActiveTab: setActiveTab,
                        applicationsConfiguredData: applicationsConfiguredData,
                        cameraGeneralInfo: cameraGeneralInfo,
                        axisFinished: {
                            recipient: true,
                            actionRules: true,
                            application: false
                        }
                    }));
                    setBackdropLoadingScreenOn(false);
                }
            } else {
                actionsRulesTitles = [
                    "Name",
                    "Host",
                    "Port",
                    "Email From",
                    "Email To",
                    "Message",
                    "Enabled",
                    "Profile"
                ];
                setBackdropLoadingScreenOn(true);
                showAxisTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
                    recipientsConfiguredData: recipientData,
                    titlesArray: recipientTitlesArray,
                    navigate: navigate,
                    setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                    setRecipientsConfiguredData: setRecipientsConfiguredData,
                    setTitlesArray: setTitlesArray,
                    actionRulesData: [],
                    setActionRulesData: setActionRulesData,
                    actionRulesTitlesArray: [
                        "Name",
                        "Host",
                        "Port",
                        "Email From",
                        "Email To",
                        "Message",
                        "Enabled",
                        "Profile"
                    ],
                    setActionRulesTitlesArray: setActionRulesTitlesArray,
                    setActiveTab: setActiveTab,
                    applicationsConfiguredData: applicationsConfiguredData,
                    cameraGeneralInfo: cameraGeneralInfo,
                    axisFinished: {
                        recipient: true,
                        actionRules: true,
                        application: false
                    }
                }));
                setBackdropLoadingScreenOn(false);
            }
            AxiosUI.get(`/axis/${inputId}/application/`).then((response)=>{
                if (response.data) {
                    if (response.data[0]) {
                        if (response.data[0].level_tag) {
                            setAxisFinished((previousState)=>{
                                return {
                                    ...previousState,
                                    application: true
                                };
                            });
                            if (localStorage.editCamerActiveTab === "seven") {
                                setBackdropLoadingScreenOn(true);
                                showAxisTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
                                    recipientsConfiguredData: recipientData,
                                    titlesArray: recipientTitlesArray,
                                    navigate: navigate,
                                    setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                                    setRecipientsConfiguredData: setRecipientsConfiguredData,
                                    setTitlesArray: setTitlesArray,
                                    actionRulesData: newActionRulesData,
                                    setActionRulesData: setActionRulesData,
                                    actionRulesTitlesArray: actionsRulesTitles,
                                    setActionRulesTitlesArray: setActionRulesTitlesArray,
                                    setActiveTab: setActiveTab,
                                    applicationsConfiguredData: [],
                                    cameraGeneralInfo: cameraGeneralInfo,
                                    axisFinished: {
                                        recipient: true,
                                        actionRules: true,
                                        application: true
                                    }
                                }));
                                setBackdropLoadingScreenOn(false);
                            }
                        } else {
                            setApplicationsConfiguredData(response.data);
                            setAxisFinished((previousState)=>{
                                return {
                                    ...previousState,
                                    application: true
                                };
                            });
                            if (localStorage.editCamerActiveTab === "seven") {
                                setBackdropLoadingScreenOn(true);
                                showAxisTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
                                    recipientsConfiguredData: recipientData,
                                    titlesArray: recipientTitlesArray,
                                    navigate: navigate,
                                    setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                                    setRecipientsConfiguredData: setRecipientsConfiguredData,
                                    setTitlesArray: setTitlesArray,
                                    actionRulesData: newActionRulesData,
                                    setActionRulesData: setActionRulesData,
                                    actionRulesTitlesArray: actionsRulesTitles,
                                    setActionRulesTitlesArray: setActionRulesTitlesArray,
                                    setActiveTab: setActiveTab,
                                    applicationsConfiguredData: response.data,
                                    cameraGeneralInfo: cameraGeneralInfo,
                                    axisFinished: {
                                        recipient: true,
                                        actionRules: true,
                                        application: true
                                    }
                                }));
                                setBackdropLoadingScreenOn(false);
                            }
                        }
                    } else {
                        setBackdropLoadingScreenOn(true);
                        showAxisTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
                            recipientsConfiguredData: recipientData,
                            titlesArray: recipientTitlesArray,
                            navigate: navigate,
                            setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                            setRecipientsConfiguredData: setRecipientsConfiguredData,
                            setTitlesArray: setTitlesArray,
                            actionRulesData: newActionRulesData,
                            setActionRulesData: setActionRulesData,
                            actionRulesTitlesArray: actionsRulesTitles,
                            setActionRulesTitlesArray: setActionRulesTitlesArray,
                            setActiveTab: setActiveTab,
                            applicationsConfiguredData: [],
                            cameraGeneralInfo: cameraGeneralInfo,
                            axisFinished: {
                                recipient: true,
                                actionRules: true,
                                application: true
                            }
                        }));
                        setBackdropLoadingScreenOn(false);
                    }
                } else {
                    setBackdropLoadingScreenOn(true);
                    showAxisTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
                        recipientsConfiguredData: recipientData,
                        titlesArray: recipientTitlesArray,
                        navigate: navigate,
                        setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                        setRecipientsConfiguredData: setRecipientsConfiguredData,
                        setTitlesArray: setTitlesArray,
                        actionRulesData: newActionRulesData,
                        setActionRulesData: setActionRulesData,
                        actionRulesTitlesArray: actionsRulesTitles,
                        setActionRulesTitlesArray: setActionRulesTitlesArray,
                        setActiveTab: setActiveTab,
                        applicationsConfiguredData: [],
                        cameraGeneralInfo: cameraGeneralInfo,
                        axisFinished: {
                            recipient: true,
                            actionRules: true,
                            application: true
                        }
                    }));
                    setBackdropLoadingScreenOn(false);
                }
            }, (reason)=>{
                if (showDeviceUnreachable(reason)) return;
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    (0, $ebTQj.logger).log(`${reason}`);
                    setAxisFinished((previousState)=>{
                        return {
                            ...previousState,
                            application: true
                        };
                    });
                    if (localStorage.editCamerActiveTab === "seven") {
                        setBackdropLoadingScreenOn(true);
                        showAxisTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
                            recipientsConfiguredData: recipientData,
                            titlesArray: recipientTitlesArray,
                            navigate: navigate,
                            setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                            setRecipientsConfiguredData: setRecipientsConfiguredData,
                            setTitlesArray: setTitlesArray,
                            actionRulesData: newActionRulesData,
                            setActionRulesData: setActionRulesData,
                            actionRulesTitlesArray: actionsRulesTitles,
                            setActionRulesTitlesArray: setActionRulesTitlesArray,
                            setActiveTab: setActiveTab,
                            applicationsConfiguredData: [],
                            cameraGeneralInfo: cameraGeneralInfo,
                            axisFinished: {
                                recipient: true,
                                actionRules: true,
                                application: true
                            }
                        }));
                        setBackdropLoadingScreenOn(false);
                    }
                });
            });
        }, (reason)=>{
            getActionsRulesFail = true;
            if (showDeviceUnreachable(reason)) return;
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                setAxisFinished((previousState)=>{
                    return {
                        ...previousState,
                        actionRules: true
                    };
                });
                if (localStorage.editCamerActiveTab === "seven") {
                    actionsRulesTitles = [
                        "Name",
                        "Host",
                        "Port",
                        "Email From",
                        "Email To",
                        "Message",
                        "Enabled",
                        "Profile"
                    ];
                    setBackdropLoadingScreenOn(true);
                    showAxisTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
                        recipientsConfiguredData: recipientData,
                        titlesArray: recipientTitlesArray,
                        navigate: navigate,
                        setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                        setRecipientsConfiguredData: setRecipientsConfiguredData,
                        setTitlesArray: setTitlesArray,
                        actionRulesData: [],
                        setActionRulesData: setActionRulesData,
                        actionRulesTitlesArray: [
                            "Name",
                            "Host",
                            "Port",
                            "Email From",
                            "Email To",
                            "Message",
                            "Enabled",
                            "Profile"
                        ],
                        setActionRulesTitlesArray: setActionRulesTitlesArray,
                        setActiveTab: setActiveTab,
                        applicationsConfiguredData: applicationsConfiguredData,
                        cameraGeneralInfo: cameraGeneralInfo,
                        axisFinished: {
                            recipient: true,
                            actionRules: true,
                            application: false
                        }
                    }));
                    setBackdropLoadingScreenOn(false);
                }
            });
        });
    }, (reason)=>{
        if (showDeviceUnreachable(reason)) return;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setAxisFinished((previousState)=>{
                return {
                    ...previousState,
                    recipient: true
                };
            });
            if (localStorage.editCamerActiveTab === "seven") {
                setBackdropLoadingScreenOn(true);
                recipientTitlesArray = [
                    "Name",
                    "Recipient Type",
                    "Host",
                    "Port",
                    "Email From",
                    "Email To"
                ];
                showAxisTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $pQI3G.AxisTab), {
                    recipientsConfiguredData: [],
                    titlesArray: [
                        "Name",
                        "Recipient Type",
                        "Host",
                        "Port",
                        "Email From",
                        "Email To"
                    ],
                    navigate: navigate,
                    setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                    setRecipientsConfiguredData: setRecipientsConfiguredData,
                    setTitlesArray: setTitlesArray,
                    actionRulesData: actionRulesData,
                    setActionRulesData: setActionRulesData,
                    actionRulesTitlesArray: actionRulesTitlesArray,
                    setActionRulesTitlesArray: setActionRulesTitlesArray,
                    setActiveTab: setActiveTab,
                    applicationsConfiguredData: applicationsConfiguredData,
                    cameraGeneralInfo: cameraGeneralInfo,
                    axisFinished: {
                        recipient: true,
                        actionRules: true,
                        application: true
                    }
                }));
                setAxisFinished({
                    recipient: true,
                    actionRules: true,
                    application: true
                });
                setBackdropLoadingScreenOn(false);
            }
        });
    });
};

});

parcelRegister("4toZl", function(module, exports) {

$parcel$export(module.exports, "getMobotixData", () => $e8eb9393deaf9d3d$export$4007048ce5574c1b);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $e8eb9393deaf9d3d$export$4007048ce5574c1b = async (inputId, navigate, setTimeTablesData, setBackdropLoadingScreenOn, setIPNotifyData, setActionHandlerData, axisFinished, mobotixFinshed, setMobotixFinished)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $e8eb9393deaf9d3d$export$4007048ce5574c1b(inputId, navigate, setTimeTablesData, setBackdropLoadingScreenOn, setIPNotifyData, setActionHandlerData, axisFinished, mobotixFinshed, setMobotixFinished);
    };
    let getTimeTableFail = false;
    let getIPNotifyFail = false;
    await AxiosUI.get(`/mobotix/${inputId}/timetable/`).then((response)=>{
        if (response.data[0].level_tag) setMobotixFinished((previousState)=>{
            return {
                ...previousState,
                timeTable: true
            };
        });
        else {
            getTimeTableFail = false;
            setTimeTablesData(response.data);
            setMobotixFinished((previousState)=>{
                return {
                    ...previousState,
                    timeTable: true
                };
            });
        }
    }, (reason)=>{
        getTimeTableFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setMobotixFinished((previousState)=>{
                return {
                    ...previousState,
                    timeTable: true
                };
            });
        });
    });
    !getTimeTableFail && await AxiosUI.get(`/mobotix/${inputId}/ip_notify/`).then((response)=>{
        if (response.data[0].level_tag) setMobotixFinished((previousState)=>{
            return {
                ...previousState,
                iPNotify: true
            };
        });
        else {
            getIPNotifyFail = false;
            setIPNotifyData(response.data);
            setMobotixFinished((previousState)=>{
                return {
                    ...previousState,
                    iPNotify: true
                };
            });
        }
    }, (reason)=>{
        getIPNotifyFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setMobotixFinished((previousState)=>{
                return {
                    ...previousState,
                    iPNotify: true
                };
            });
        });
    });
    !getTimeTableFail && !getIPNotifyFail && await AxiosUI.get(`/mobotix/${inputId}/action_handler/`).then((response)=>{
        if (response.data[0].level_tag) setMobotixFinished((previousState)=>{
            return {
                ...previousState,
                actionHandler: true
            };
        });
        else {
            setActionHandlerData(response.data);
            setMobotixFinished((previousState)=>{
                return {
                    ...previousState,
                    actionHandler: true
                };
            });
        }
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setMobotixFinished((previousState)=>{
                return {
                    ...previousState,
                    actionHandler: true
                };
            });
        });
    });
};

});

parcelRegister("b9Vun", function(module, exports) {

$parcel$export(module.exports, "checkForAlarmType", () => $f5ca2c0e6d706572$export$99344d6964f4089d);
parcelRequire("8T3gX");

var $aZxZ3 = parcelRequire("aZxZ3");

var $7IAhZ = parcelRequire("7IAhZ");
const $f5ca2c0e6d706572$export$99344d6964f4089d = (alarmId, setBoldAlertsOnCamera, setPatriotAlertsOnCamera, setSureViewAlertsOnCamera, setSentinelAlertsOnCamera, setImmixAlertsOnCamera, setWebhooksAlertsOnCamera, setSoftguardAlertsOnCamera, setEvalinkAlertsOnCamera, setDiceAlertsOnCamera)=>{
    if (!localStorage.alarmOptions) return;
    const alarmType = (0, $7IAhZ.getDefaultAlarmName)(alarmId);
    if (alarmType === "Bold") setBoldAlertsOnCamera(true);
    if (alarmType === "Patriot") setPatriotAlertsOnCamera(true);
    if (alarmType === "SureView") setSureViewAlertsOnCamera(true);
    if (alarmType === "Sentinel") setSentinelAlertsOnCamera(true);
    if (alarmType === "Immix") setImmixAlertsOnCamera(true);
    if (alarmType === "Dice") setDiceAlertsOnCamera(true);
    if (alarmType === "Webhooks") setWebhooksAlertsOnCamera(true);
    if (alarmType === "Softguard") setSoftguardAlertsOnCamera(true);
    if (alarmType === "Evalink") setEvalinkAlertsOnCamera(true);
    if (alarmType === "Sysaid") (0, $aZxZ3.useEditCameraStore).getState().setSysaidAlertsOnCamera(true);
};

});

parcelRegister("21UOo", function(module, exports) {

$parcel$export(module.exports, "getStreamParametersExtraFields", () => $19447929879d6ac0$export$16eb5ed89418ab68);
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $19447929879d6ac0$export$16eb5ed89418ab68 = (cameraId, setStreamParametersData, setShowStreamParameters, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $19447929879d6ac0$export$16eb5ed89418ab68(cameraId, setStreamParametersData, setShowStreamParameters, navigate);
    };
    AxiosUI.get(`/camera/${cameraId}/extra_fields/`).then((response)=>{
        if (response.data.extra_fields[0]) {
            setShowStreamParameters(true);
            setStreamParametersData(response.data);
        }
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
    });
};

});

parcelRegister("alfPp", function(module, exports) {

$parcel$export(module.exports, "CameraInfoRowEditCamera", () => $5e5ce15b5f0d79e8$export$36fb08681571ba15);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $aVDw9 = parcelRequire("aVDw9");

var $4o6Cs = parcelRequire("4o6Cs");

var $lWchQ = parcelRequire("lWchQ");

var $65sov = parcelRequire("65sov");

var $g41iy = parcelRequire("g41iy");

var $eDfvp = parcelRequire("eDfvp");

var $yndCB = parcelRequire("yndCB");

var $195EM = parcelRequire("195EM");

var $jDisJ = parcelRequire("jDisJ");

var $64WJh = parcelRequire("64WJh");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $6pdiI = parcelRequire("6pdiI");

var $grVw9 = parcelRequire("grVw9");

var $3n3uW = parcelRequire("3n3uW");

var $2suvB = parcelRequire("2suvB");

var $hHKnQ = parcelRequire("hHKnQ");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

var $kqFN9 = parcelRequire("kqFN9");

var $gBR2p = parcelRequire("gBR2p");

var $3Zv1D = parcelRequire("3Zv1D");

var $kPQrn = parcelRequire("kPQrn");

var $cVCJe = parcelRequire("cVCJe");

var $3mOKt = parcelRequire("3mOKt");

var $83bsI = parcelRequire("83bsI");

var $aOOQP = parcelRequire("aOOQP");

var $3FJ79 = parcelRequire("3FJ79");

var $glcO0 = parcelRequire("glcO0");

var $7Ep9S = parcelRequire("7Ep9S");

var $4PFLW = parcelRequire("4PFLW");

var $aZxZ3 = parcelRequire("aZxZ3");

var $2uwzz = parcelRequire("2uwzz");

var $5axmO = parcelRequire("5axmO");

var $dXEa5 = parcelRequire("dXEa5");

var $a2fXs = parcelRequire("a2fXs");

var $c2wA2 = parcelRequire("c2wA2");

var $bjrAt = parcelRequire("bjrAt");
const $5e5ce15b5f0d79e8$export$36fb08681571ba15 = ({ obj: obj, expanded: expanded, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setEditCameraAlerts: setEditCameraAlerts, siteInfo: siteInfo, permissions: permissions, srcImages: srcImages })=>{
    const autopatrolSite = siteInfo.integration_type_name === "autopatrol";
    const isAxisCamera = obj.camera_type?.display_name === "Axis";
    const [isChmOnlyIgnoreZonesCamera, setIsChmOnlyIgnoreZonesCamera] = $8T3gX.useState(false);
    const [initialRowDataLoaded, setInitialRowDataLoaded] = $8T3gX.useState(false);
    const hideCameraIgnoreZonesPanel = isChmOnlyIgnoreZonesCamera;
    const [metadataTagZones, setMetadataTagZones] = $8T3gX.useState([]);
    const sentinelVerifierSite = (0, $3mOKt.integrationsMatcher)("Name", siteInfo.integration_type) === "Sentinel Verifier" ? true : false;
    const aiLinkSite = (0, $3mOKt.integrationsMatcher)("Name", siteInfo.integration_type) === "AI Link" ? true : false;
    const { allIgnoreZones: allIgnoreZones, setAllIgnoreZones: setAllIgnoreZones, visibleIgnoreZones: visibleIgnoreZones, setVisibleIgnoreZones: setVisibleIgnoreZones } = (0, $3FJ79.useSiteAboutStore)();
    const { lineCrossingActive: lineCrossingActive, lineCrossingsData: lineCrossingsData, lineCrossingsMetricLabels: lineCrossingsMetricLabels, setShowSlicingWarningMessage: setShowSlicingWarningMessage } = (0, $aZxZ3.useEditCameraStore)();
    const editCameraText = /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
        children: permissions.edit_cameras ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {
                    fontSize: "small"
                }),
                "\xa0Edit Camera"
            ]
        }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
            children: "Full Camera Info"
        })
    });
    const theme = (0, $cFPmV.default)({
        palette: {
            primary: {
                main: "#FF8400"
            }
        }
    });
    const shrinkLineCrossingsTabs = (0, $hHKnQ.default)("(max-width:1575px)");
    const lineCrossingsTabsWidth = shrinkLineCrossingsTabs ? "305px" : "375px";
    const navigate = (0, $3T949.useNavigate)();
    const [clickedTab, setClickedTab] = $8T3gX.useState("one");
    const [responseObject, setResponseObject] = $8T3gX.useState({
        // null until /camera/{id}/status/ answers, so an unloaded or failed row
        // shows "No data yet" and not a green tick it never earned (ENG-1782)
        connected: null,
        frame_since_launch: null,
        good_frame: null,
        blur_metric: 0,
        native_frame_rate: 0,
        frame_dimensions: "",
        last_motion: 0,
        preview_url: "",
        health_status: "",
        is_blurry: null,
        aspect_ratio: "",
        comments: "",
        camera_view: "",
        aspect_ratio_status: "unknown",
        frame_rate_status: "unknown",
        resolution_status: "unknown",
        camera_health_comments: "",
        camera_name: "",
        camera_start_time: 0,
        camera_view_comments: "",
        camera_view_status: "unknown",
        codec_status: "unknown",
        display_frame_since_launch: true,
        dynamic_slicing: false,
        id: 0,
        overall_status: "unknown"
    });
    const aPICall = async (navigate, id, setResponseObject, setAllIgnoreZones, setVisibleIgnoreZones)=>{
        const AxiosUI = (0, $195EM.createApi)(``);
        setIsChmOnlyIgnoreZonesCamera(false);
        const retryFunction = ()=>{
            aPICall(navigate, id, setResponseObject, setAllIgnoreZones, setVisibleIgnoreZones);
        };
        try {
            const statusResponse = await AxiosUI.get(`/camera/${id}/status/`);
            const frameDimensions = statusResponse.data.frame_dimensions?.match(/\d+/g);
            if (frameDimensions?.some((dim)=>parseInt(dim, 10) > 1080)) setShowSlicingWarningMessage(true);
            setResponseObject(statusResponse.data);
            localStorage.setItem("preview_url", JSON.stringify(statusResponse.data.preview_url));
            const [ignoreZonesResult, tagZonesResult] = await Promise.allSettled([
                AxiosUI.get(`/camera/${obj.id}/ignore_zones/`),
                AxiosUI.get(`tagzone/?camera=${id}`)
            ]);
            if (ignoreZonesResult.status === "fulfilled") {
                const ignoreZonesResponse = ignoreZonesResult.value;
                setIsChmOnlyIgnoreZonesCamera((0, $aOOQP.isChmOnlyIgnoreZones)(ignoreZonesResponse.data || []));
                const labeledZones = (0, $83bsI.addIgnoreLabel)(ignoreZonesResponse.data);
                setAllIgnoreZones(labeledZones);
                setVisibleIgnoreZones(labeledZones);
                localStorage.setItem("ignoreZones", JSON.stringify(labeledZones));
            } else (0, $3Zv1D.universalAPIErrorHandler)(ignoreZonesResult.reason, navigate, retryFunction, ()=>{});
            if (tagZonesResult.status === "fulfilled") setMetadataTagZones(tagZonesResult.value.data.results);
            else (0, $3Zv1D.universalAPIErrorHandler)(tagZonesResult.reason, navigate, retryFunction, ()=>{});
        } catch (reason) {
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                setShowSlicingWarningMessage(false);
            });
        }
    };
    $8T3gX.useEffect(()=>{
        if (!obj.id) return;
        let mounted = true;
        setBackdropLoadingScreenOn(true);
        setInitialRowDataLoaded(false);
        aPICall(navigate, obj.id.toString(), setResponseObject, setAllIgnoreZones, setVisibleIgnoreZones).finally(()=>{
            if (!mounted) return;
            setInitialRowDataLoaded(true);
            setBackdropLoadingScreenOn(false);
        });
        return ()=>{
            mounted = false;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once per selected camera initial load
    }, [
        obj.id,
        navigate,
        setAllIgnoreZones,
        setBackdropLoadingScreenOn,
        setVisibleIgnoreZones
    ]);
    const [dimensions, setDimensions] = $8T3gX.useState(null);
    const handleImageLoad = (event)=>{
        const { naturalWidth: naturalWidth, naturalHeight: naturalHeight } = event.currentTarget;
        setDimensions((0, $kPQrn.resizeImage)(naturalWidth, naturalHeight));
    };
    const { flags: flags } = (0, $4PFLW.useFeatureFlag)();
    const viewEditMetadataTagZonesPage = flags.viewEditMetadataTagZonesPage;
    const showLineCrossings = flags.showLineCrossings;
    const { flexIzActive: flexIzActive, zonesForPreview: zonesForPreview, zonesForColorSidebar: zonesForColorSidebar, ignoreZonesTitleText: ignoreZonesTitleText, ignoreZonesHeadingClassName: ignoreZonesHeadingClassName, flexPresetSelectControl: flexPresetSelectControl, flexPresetDialog: flexPresetDialog } = (0, $dXEa5.useFlexIgnoreZonesCameraRow)({
        siteInfo: siteInfo,
        obj: obj,
        expanded: expanded,
        visibleIgnoreZones: visibleIgnoreZones,
        allIgnoreZones: allIgnoreZones
    });
    const ignoreZoneHoverEnabled = !hideCameraIgnoreZonesPanel && zonesForPreview.length > 0 && (!autopatrolSite && clickedTab !== "four" || autopatrolSite && clickedTab === "one");
    const showLineCrossingTabs = showLineCrossings && (lineCrossingActive.intruder || lineCrossingActive.vehicle);
    $8T3gX.useEffect(()=>{
        if (hideCameraIgnoreZonesPanel && showLineCrossingTabs) setClickedTab("four");
    }, [
        hideCameraIgnoreZonesPanel,
        showLineCrossingTabs
    ]);
    const cameraTimingSummaryRow = !autopatrolSite ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "mt-[8px] flex flex-col gap-y-2 pt-[8px]",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "h-px w-[200px] max-w-full shrink-0 bg-gray-200",
                "aria-hidden": true
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "w-full min-w-0",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "font-mulish font-bold text-[11px] leading-tight text-black",
                        children: "Last Motion Time"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "font-mulish text-[11px] leading-snug text-black",
                        children: responseObject.last_motion ? (0, $jDisJ.timeSinceConvertor)(Number(responseObject.last_motion)) : "--"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "w-full min-w-0",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "font-mulish font-bold text-[11px] leading-tight text-black",
                        children: "Camera Start Time"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "font-mulish text-[11px] leading-snug text-black",
                        children: responseObject.camera_start_time ? (0, $jDisJ.timeSinceConvertor)(Number(responseObject.camera_start_time)) : "--"
                    })
                ]
            }),
            srcImages ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "w-full min-w-0",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "font-mulish font-bold text-[11px] leading-tight text-black",
                        children: "Camera View"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "font-mulish text-[11px] leading-snug text-black",
                        children: (0, $gBR2p.createCameraViewIcon)(responseObject, srcImages)
                    })
                ]
            }) : null,
            !hideCameraIgnoreZonesPanel && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "h-px w-[200px] max-w-full shrink-0 bg-gray-200",
                "aria-hidden": true
            })
        ]
    }) : null;
    const cameraSettingsBlock = !autopatrolSite ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "font-mulish text-[16px] text-actuate-blue pt-[16px]",
                children: "Camera Settings"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "font-mulish text-[12px] text-black pt-[10px] flex",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            (0, $kqFN9.createCameraSettingsIcon)(responseObject.aspect_ratio_status, "Aspect Ratio", responseObject.comments, responseObject.camera_view, responseObject),
                            "\xa0\xa0Aspect Ratio"
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "font-mulish font-bold text-[12px] text-black pl-[28px]",
                        children: responseObject.aspect_ratio ? responseObject.aspect_ratio : "N/A"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "font-mulish text-[12px] text-black pt-[10px] flex",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            (0, $kqFN9.createCameraSettingsIcon)(responseObject.resolution_status, "Resolution", responseObject.comments, responseObject.camera_view, responseObject),
                            "\xa0\xa0Resolution"
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "font-mulish font-bold text-[12px] text-black pl-[36px]",
                        children: responseObject.frame_dimensions ? responseObject.frame_dimensions : "N/A"
                    })
                ]
            }),
            !sentinelVerifierSite && !aiLinkSite && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "font-mulish text-[12px] text-black pt-[10px] flex",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            children: [
                                (0, $kqFN9.createCameraSettingsIcon)(responseObject.frame_rate_status, "Frame Rate", responseObject.comments, responseObject.camera_view, responseObject),
                                "\xa0\xa0Frame Rate"
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "font-mulish font-bold text-[12px] text-black pl-[32px]",
                            children: (0, $bjrAt.formatFrameRate)(responseObject.native_frame_rate)
                        })
                    ]
                })
            })
        ]
    }) : null;
    if (!initialRowDataLoaded) return null;
    const triggerMotionButton = isAxisCamera ? /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "pt-[10px]",
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
            onClick: ()=>{
                setBackdropLoadingScreenOn(true);
                (0, $c2wA2.handleTriggerMotionAxis)(String(obj.id), navigate, setBackdropLoadingScreenOn, setEditCameraAlerts);
            },
            text: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($grVw9))), {}),
                    "\xa0Trigger Motion on Camera"
                ]
            }),
            disabled: false
        })
    }) : null;
    return obj.id ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
            style: {
                paddingBottom: 0,
                paddingTop: 0
            },
            colSpan: 9,
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $yndCB.default), {
                in: expanded,
                timeout: "auto",
                unmountOnExit: true,
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                    sx: {
                        margin: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "relative flex min-h-[420px] items-start gap-[15px] pt-5 pb-4",
                            children: [
                                !window.location.href.includes("editcamera") && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "absolute top-[10px] right-[0px] w-[160px]",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                        onClick: ()=>{
                                            setBackdropLoadingScreenOn(true);
                                            localStorage.setItem("currentCameraId", JSON.stringify(obj.id));
                                            localStorage.setItem("currentCamera", obj.camera_name);
                                            // Store only essential camera info to avoid localStorage quota issues
                                            (0, $2uwzz.safeSetItem)("currentCameraInfo", {
                                                id: obj.id,
                                                camera_name: obj.camera_name
                                            });
                                            localStorage.setItem("preview_url", JSON.stringify(responseObject.preview_url));
                                            localStorage.setItem("ignoreZones", JSON.stringify(allIgnoreZones));
                                            navigate(`/sites/${siteInfo.id}/editcamera/${obj.id}`);
                                        },
                                        text: editCameraText,
                                        disabled: false
                                    })
                                }),
                                siteInfo.integration_type_name !== "ailink" && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "order-2 w-[380px] shrink-0",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "font-mulish text-[16px] text-actuate-blue",
                                            children: "General Information"
                                        }),
                                        siteInfo.integration_type_name !== "SMTP_per_camera" && !autopatrolSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $65sov.VideoFlowStatusLine), {
                                            siteId: siteInfo.id,
                                            cameraId: obj.id,
                                            connected: responseObject.connected
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "w-full font-mulish text-[12px] text-actuate-blue pt-[10px]",
                                            children: [
                                                (0, $g41iy.triStateIcon)(responseObject.is_blurry === null ? null : !responseObject.is_blurry),
                                                "\xa0\xa0Blur Metric"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "w-full font-mulish text-[12px] text-actuate-blue pt-[10px]",
                                            children: [
                                                (0, $g41iy.triStateIcon)(responseObject.good_frame),
                                                "\xa0\xa0Stream Stability"
                                            ]
                                        }),
                                        !autopatrolSite && responseObject.display_frame_since_launch && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "w-full font-mulish text-[12px] text-actuate-blue pt-[10px]",
                                            children: [
                                                (0, $g41iy.triStateIcon)(responseObject.frame_since_launch),
                                                "\xa0\xa0Frame Since Launch"
                                            ]
                                        }),
                                        responseObject.dynamic_slicing && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "w-full font-mulish text-[12px] text-actuate-blue pt-[10px]",
                                            children: [
                                                (0, $lWchQ.checkedCircleIconSmall),
                                                "\xa0\xa0Dynamic Slicing"
                                            ]
                                        }),
                                        cameraTimingSummaryRow,
                                        !hideCameraIgnoreZonesPanel && cameraSettingsBlock
                                    ]
                                }),
                                siteInfo.integration_type_name === "ailink" && cameraTimingSummaryRow && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "order-2 w-[380px] shrink-0",
                                    children: cameraTimingSummaryRow
                                }),
                                !autopatrolSite && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "order-3 min-h-[300px] w-[375px] shrink-0",
                                    children: [
                                        hideCameraIgnoreZonesPanel && cameraSettingsBlock,
                                        hideCameraIgnoreZonesPanel && showLineCrossingTabs && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "w-[375px] pt-[12px]",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "font-mulish text-[18px] text-actuate-blue",
                                                    children: "Line Crossings"
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "pt-[8px]",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                        onClick: ()=>{
                                                            setBackdropLoadingScreenOn(true);
                                                            navigate(`/sites/${siteInfo.id}/editcamera/${obj.id}/editlinecrossings`);
                                                        },
                                                        text: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {
                                                                    fontSize: "small"
                                                                }),
                                                                "\xa0Edit Line Crossings"
                                                            ]
                                                        }),
                                                        disabled: false
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "relative mt-[8px] w-[375px] max-h-[220px] overflow-auto",
                                                    children: lineCrossingsData.length > 0 ? lineCrossingsData.map((line, index)=>{
                                                        const displayLabels = [];
                                                        const hasIntruder = line.metric_labels.some((id)=>lineCrossingsMetricLabels.find((m)=>m.id === id)?.label_name === "intruder_line_crossing");
                                                        const hasVehicle = line.metric_labels.some((id)=>lineCrossingsMetricLabels.find((m)=>m.id === id)?.label_name === "vehicle_line_crossing");
                                                        const hasBike = line.metric_labels.some((id)=>lineCrossingsMetricLabels.find((m)=>m.id === id)?.label_name === "bike_line_crossing");
                                                        if (hasIntruder) displayLabels.push("Intruder");
                                                        if (hasVehicle || hasBike) displayLabels.push("Vehicle/Bike");
                                                        const metricsText = displayLabels.length > 0 ? displayLabels.join(", ") : "No metrics";
                                                        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    style: {
                                                                        height: 20,
                                                                        width: 6,
                                                                        background: `${line.color}`
                                                                    },
                                                                    className: "absolute"
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                                    className: "font-mulish text-[14px] indent-5",
                                                                    children: metricsText
                                                                }),
                                                                "\xa0"
                                                            ]
                                                        }, `line-lc-${line.id || index}`);
                                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                        className: "font-mulish text-[14px] text-gray-500",
                                                        children: "No line crossings configured"
                                                    })
                                                })
                                            ]
                                        }),
                                        !hideCameraIgnoreZonesPanel && !showLineCrossingTabs && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "flex w-[375px] flex-col",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                    className: "flex items-start gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                            className: ignoreZonesHeadingClassName,
                                                            children: ignoreZonesTitleText
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                            className: "shrink-0",
                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                                onClick: ()=>{
                                                                    setBackdropLoadingScreenOn(true);
                                                                    localStorage.setItem("currentCameraId", JSON.stringify(obj.id));
                                                                    localStorage.setItem("currentCamera", obj.camera_name);
                                                                    (0, $2uwzz.safeSetItem)("currentCameraInfo", {
                                                                        id: obj.id,
                                                                        camera_name: obj.camera_name
                                                                    });
                                                                    localStorage.setItem("preview_url", JSON.stringify(responseObject.preview_url));
                                                                    localStorage.setItem("ignoreZones", JSON.stringify(allIgnoreZones));
                                                                    navigate(`/sites/${siteInfo.id}/editcamera/${obj.id}/editignorezones`);
                                                                },
                                                                text: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                                    title: "Edit Ignore Zones",
                                                                    placement: "top",
                                                                    sx: {
                                                                        fontSize: "20px",
                                                                        fontFamily: "mulish"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {})
                                                                }),
                                                                disabled: false
                                                            })
                                                        })
                                                    ]
                                                }),
                                                flexPresetSelectControl,
                                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "mt-[4px] max-h-[220px] min-h-[150px] w-full overflow-auto",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "w-full",
                                                        children: zonesForColorSidebar.map((object, zi)=>/*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                className: "relative",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                        style: {
                                                                            height: 20,
                                                                            width: 6,
                                                                            background: `${object.line_color}`
                                                                        },
                                                                        className: "absolute"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                                        className: "font-mulish text-[14px] indent-5",
                                                                        children: object.label_display_name
                                                                    }),
                                                                    "\xa0"
                                                                ]
                                                            }, `${obj.id}-sidebar-${zi}-${object.metric_id}-${object.preset_zone_id ?? object.label}`))
                                                    })
                                                })
                                            ]
                                        }),
                                        !hideCameraIgnoreZonesPanel && showLineCrossingTabs && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "relative w-[375px]",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "font-mulish text-[18px] text-actuate-blue flex",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                                        sx: {
                                                            borderBottom: 1,
                                                            borderColor: "divider"
                                                        },
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                                                            theme: theme,
                                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3n3uW.default), {
                                                                value: clickedTab,
                                                                onChange: (event, tabValue)=>{
                                                                    setClickedTab(tabValue);
                                                                },
                                                                "aria-label": "intestigation_tabs",
                                                                color: "primary",
                                                                sx: {
                                                                    width: lineCrossingsTabsWidth
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                                                                        value: "one",
                                                                        label: ignoreZonesTitleText,
                                                                        sx: {
                                                                            fontFamily: "Mulish",
                                                                            fontWeight: "Bold",
                                                                            color: "primary",
                                                                            fontSize: "16px"
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                                                                        value: "four",
                                                                        label: `Line Crossings`,
                                                                        sx: {
                                                                            fontFamily: "Mulish",
                                                                            fontWeight: "Bold",
                                                                            color: "primary",
                                                                            fontSize: "16px"
                                                                        }
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                }),
                                                clickedTab === "one" && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "absolute pt-[5px]",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                        onClick: ()=>{
                                                            setBackdropLoadingScreenOn(true);
                                                            navigate(`/sites/${siteInfo.id}/editcamera/${obj.id}/editignorezones`);
                                                        },
                                                        text: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {
                                                                    fontSize: "small"
                                                                }),
                                                                "\xa0Edit Ignore Zones"
                                                            ]
                                                        }),
                                                        disabled: false
                                                    })
                                                }),
                                                clickedTab === "one" && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                    className: "relative left-[0px] top-[50px] w-[375px]",
                                                    children: [
                                                        flexPresetSelectControl,
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                            className: "h-[250px] w-full overflow-auto pt-[10px]",
                                                            children: zonesForColorSidebar.map((object, zi)=>/*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                    className: "relative",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                            style: {
                                                                                height: 20,
                                                                                width: 6,
                                                                                background: `${object.line_color}`
                                                                            },
                                                                            className: "absolute"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                                            className: "font-mulish text-[14px] indent-5",
                                                                            children: object.label_display_name
                                                                        }),
                                                                        "\xa0"
                                                                    ]
                                                                }, `${obj.id}-lc-sidebar-${zi}-${object.metric_id}-${object.preset_zone_id ?? object.label}`))
                                                        })
                                                    ]
                                                }),
                                                clickedTab === "four" && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "absolute pt-[5px]",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                        onClick: ()=>{
                                                            setBackdropLoadingScreenOn(true);
                                                            navigate(`/sites/${siteInfo.id}/editcamera/${obj.id}/editlinecrossings`);
                                                        },
                                                        text: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {
                                                                    fontSize: "small"
                                                                }),
                                                                "\xa0Edit Line Crossings"
                                                            ]
                                                        }),
                                                        disabled: false
                                                    })
                                                }),
                                                clickedTab === "four" && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "relative left-[0px] top-[50px] w-[375px] h-[130px] overflow-auto",
                                                    children: lineCrossingsData.length > 0 ? lineCrossingsData.map((line, index)=>{
                                                        const displayLabels = [];
                                                        const hasIntruder = line.metric_labels.some((id)=>lineCrossingsMetricLabels.find((m)=>m.id === id)?.label_name === "intruder_line_crossing");
                                                        const hasVehicle = line.metric_labels.some((id)=>lineCrossingsMetricLabels.find((m)=>m.id === id)?.label_name === "vehicle_line_crossing");
                                                        const hasBike = line.metric_labels.some((id)=>lineCrossingsMetricLabels.find((m)=>m.id === id)?.label_name === "bike_line_crossing");
                                                        if (hasIntruder) displayLabels.push("Intruder");
                                                        if (hasVehicle || hasBike) displayLabels.push("Vehicle/Bike");
                                                        const metricsText = displayLabels.length > 0 ? displayLabels.join(", ") : "No metrics";
                                                        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                    style: {
                                                                        height: 20,
                                                                        width: 6,
                                                                        background: `${line.color}`
                                                                    },
                                                                    className: "absolute"
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                                    className: "font-mulish text-[14px] indent-5",
                                                                    children: metricsText
                                                                }),
                                                                "\xa0"
                                                            ]
                                                        }, `line-${line.id || index}`);
                                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                        className: "font-mulish text-[14px] text-gray-500",
                                                        children: "No line crossings configured"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                autopatrolSite && viewEditMetadataTagZonesPage && !hideCameraIgnoreZonesPanel && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "order-3 w-[400px] shrink-0",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "font-mulish text-[18px] text-actuate-blue flex",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                                sx: {
                                                    borderBottom: 1,
                                                    borderColor: "divider"
                                                },
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                                                    theme: theme,
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3n3uW.default), {
                                                        value: clickedTab,
                                                        onChange: (event, tabValue)=>{
                                                            setClickedTab(tabValue);
                                                        },
                                                        "aria-label": "intestigation_tabs",
                                                        color: "primary",
                                                        sx: {
                                                            width: "345px"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                                                                value: "one",
                                                                label: ignoreZonesTitleText,
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    fontWeight: "Bold",
                                                                    color: "primary",
                                                                    fontSize: "16px"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                                                                value: "two",
                                                                label: `Metadata Tag Zones`,
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    fontWeight: "Bold",
                                                                    color: "primary",
                                                                    fontSize: "16px"
                                                                }
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            children: [
                                                clickedTab === "one" && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                                        flexPresetSelectControl,
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $glcO0.IgnoreZonesTable), {
                                                            visibleIgnoreZones: flexIzActive ? zonesForPreview : visibleIgnoreZones,
                                                            onEditClick: ()=>{
                                                                setBackdropLoadingScreenOn(true);
                                                                navigate(`/sites/${siteInfo.id}/editcamera/${obj.id}/editignorezones`);
                                                            }
                                                        })
                                                    ]
                                                }),
                                                clickedTab === "two" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $7Ep9S.MetadataTagZonesTable), {
                                                    metadataTagZones: metadataTagZones,
                                                    onEditClick: ()=>{
                                                        setBackdropLoadingScreenOn(true);
                                                        navigate(`/sites/${siteInfo.id}/editcamera/${obj.id}/editmetadatatagzones`);
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                autopatrolSite && !viewEditMetadataTagZonesPage && !hideCameraIgnoreZonesPanel && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "order-3 flex min-h-[300px] w-[320px] shrink-0 flex-col",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "flex items-start gap-2",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                    className: ignoreZonesHeadingClassName,
                                                    children: ignoreZonesTitleText
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "shrink-0",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                        onClick: ()=>{
                                                            setBackdropLoadingScreenOn(true);
                                                            localStorage.setItem("currentCameraId", JSON.stringify(obj.id));
                                                            localStorage.setItem("currentCamera", obj.camera_name);
                                                            (0, $2uwzz.safeSetItem)("currentCameraInfo", {
                                                                id: obj.id,
                                                                camera_name: obj.camera_name
                                                            });
                                                            localStorage.setItem("preview_url", JSON.stringify(responseObject.preview_url));
                                                            localStorage.setItem("ignoreZones", JSON.stringify(allIgnoreZones));
                                                            navigate(`/sites/${siteInfo.id}/editcamera/${obj.id}/editignorezones`);
                                                        },
                                                        text: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                            title: "Edit Ignore Zones",
                                                            placement: "top",
                                                            sx: {
                                                                fontSize: "20px",
                                                                fontFamily: "mulish"
                                                            },
                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {})
                                                        }),
                                                        disabled: false
                                                    })
                                                })
                                            ]
                                        }),
                                        flexPresetSelectControl,
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "mt-[4px] max-h-[200px] min-h-[150px] w-[305px] overflow-auto",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "w-[275px]",
                                                children: zonesForColorSidebar.map((object, zi)=>/*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                        className: "relative",
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                style: {
                                                                    height: 20,
                                                                    width: 6,
                                                                    background: `${object.line_color}`
                                                                },
                                                                className: "absolute"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                                className: "font-mulish text-[14px] indent-5",
                                                                children: object.label_display_name
                                                            }),
                                                            "\xa0"
                                                        ]
                                                    }, `${obj.id}-sidebar-${zi}-${object.metric_id}-${object.preset_zone_id ?? object.label}`))
                                            })
                                        })
                                    ]
                                }),
                                siteInfo.integration_type_name !== "ailink" ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "order-1 shrink-0 flex flex-col",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $a2fXs.IgnoreZonePreviewHoverLayer), {
                                            className: "relative",
                                            zones: zonesForPreview,
                                            enabled: ignoreZoneHoverEnabled,
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                                                    src: responseObject.preview_url,
                                                    style: {
                                                        width: dimensions ? `${dimensions.width}px` : "auto",
                                                        height: dimensions ? `${dimensions.height}px` : "auto"
                                                    },
                                                    onLoad: handleImageLoad,
                                                    alt: "TestCameraPhoto"
                                                }),
                                                !autopatrolSite && !hideCameraIgnoreZonesPanel && clickedTab !== "four" && zonesForPreview.map((object, zi)=>{
                                                    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "absolute top-[0px]",
                                                        children: object.coordinates.map((array, index)=>/*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                                                                className: "absolute top-[0px]",
                                                                style: {
                                                                    width: dimensions ? `${dimensions.width}px` : "auto",
                                                                    height: dimensions ? `${dimensions.height}px` : "auto"
                                                                },
                                                                children: dimensions && /*#__PURE__*/ (0, $k4ank.jsx)("polygon", {
                                                                    points: (0, $64WJh.pointsCreator)(object.coordinates[index], dimensions.height, dimensions.width),
                                                                    stroke: object.line_color,
                                                                    strokeWidth: "5",
                                                                    fill: object.line_color,
                                                                    fillOpacity: "50%"
                                                                })
                                                            }, index))
                                                    }, `${obj.id}-iz-${zi}-${object.metric_id}-${object.preset_zone_id ?? object.label}`);
                                                }),
                                                !autopatrolSite && dimensions && lineCrossingsData.length > 0 && (clickedTab === "four" || hideCameraIgnoreZonesPanel && showLineCrossingTabs) && /*#__PURE__*/ (0, $k4ank.jsx)((0, $5axmO.LineCrossingsOverlay), {
                                                    lines: lineCrossingsData,
                                                    width: dimensions.width,
                                                    height: dimensions.height,
                                                    frameDimensions: responseObject.frame_dimensions
                                                }),
                                                autopatrolSite && !hideCameraIgnoreZonesPanel && clickedTab === "one" && zonesForPreview.map((object, zi)=>{
                                                    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "absolute top-[0px]",
                                                        children: object.coordinates.map((array, index)=>/*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                                                                className: "absolute top-[0px]",
                                                                style: {
                                                                    width: dimensions ? `${dimensions.width}px` : "auto",
                                                                    height: dimensions ? `${dimensions.height}px` : "auto"
                                                                },
                                                                children: dimensions && /*#__PURE__*/ (0, $k4ank.jsx)("polygon", {
                                                                    points: (0, $64WJh.pointsCreator)(object.coordinates[index], dimensions.height, dimensions.width),
                                                                    stroke: object.line_color,
                                                                    strokeWidth: "5",
                                                                    fill: object.line_color,
                                                                    fillOpacity: "50%"
                                                                })
                                                            }, index))
                                                    }, `${obj.id}-iz-ap-${zi}-${object.metric_id}-${object.preset_zone_id ?? object.label}`);
                                                }),
                                                autopatrolSite && clickedTab === "two" && metadataTagZones.map((object)=>{
                                                    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "absolute top-[0px]",
                                                        children: object.coordinates.map((array, index)=>/*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                                                                className: "absolute top-[0px]",
                                                                style: {
                                                                    width: dimensions ? `${dimensions.width}px` : "auto",
                                                                    height: dimensions ? `${dimensions.height}px` : "auto"
                                                                },
                                                                children: dimensions && /*#__PURE__*/ (0, $k4ank.jsx)("polygon", {
                                                                    points: (0, $64WJh.pointsCreator)(object.coordinates[index], dimensions.height, dimensions.width),
                                                                    stroke: object.line_color,
                                                                    strokeWidth: "5",
                                                                    fill: object.line_color,
                                                                    fillOpacity: "50%"
                                                                })
                                                            }, index))
                                                    }, object.label);
                                                })
                                            ]
                                        }),
                                        triggerMotionButton
                                    ]
                                }) : /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "order-1 shrink-0 flex flex-col",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $a2fXs.IgnoreZonePreviewHoverLayer), {
                                            className: "relative",
                                            zones: zonesForPreview,
                                            enabled: ignoreZoneHoverEnabled,
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                                                    src: responseObject.preview_url,
                                                    onLoad: handleImageLoad,
                                                    style: {
                                                        width: dimensions ? `${dimensions.width}px` : "auto",
                                                        height: dimensions ? `${dimensions.height}px` : "auto"
                                                    },
                                                    alt: "TestCameraPhoto"
                                                }),
                                                !hideCameraIgnoreZonesPanel && zonesForPreview.map((object, zi)=>{
                                                    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "absolute top-[0px]",
                                                        children: object.coordinates.map((array, index)=>{
                                                            return /*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                                                                className: "absolute top-[0px]",
                                                                style: {
                                                                    width: dimensions ? `${dimensions.width}px` : "auto",
                                                                    height: dimensions ? `${dimensions.height}px` : "auto"
                                                                },
                                                                children: dimensions && /*#__PURE__*/ (0, $k4ank.jsx)("polygon", {
                                                                    points: (0, $64WJh.pointsCreator)(object.coordinates[index], dimensions.height, dimensions.width),
                                                                    stroke: object.line_color,
                                                                    strokeWidth: "5",
                                                                    fill: object.line_color,
                                                                    fillOpacity: "50%"
                                                                })
                                                            }, array[0]);
                                                        })
                                                    }, `${obj.id}-iz-ailink-${zi}-${object.metric_id}-${object.preset_zone_id ?? object.label}`);
                                                })
                                            ]
                                        }),
                                        triggerMotionButton
                                    ]
                                })
                            ]
                        }),
                        !hideCameraIgnoreZonesPanel && flexPresetDialog
                    ]
                })
            })
        })
    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {});
};

});
parcelRegister("grVw9", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $031728662cd396b4$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $031728662cd396b4$var$_default = module.exports.default = (0, $031728662cd396b4$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1.5 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1m2.5 6c-.7 0-2.01-.54-2.91-1.76l-.41 2.35L14 14.03V18h-1v-3.58l-1.11-1.21-.52 2.64-3.77-.77.2-.98 2.78.57.96-4.89-1.54.57V12H9V9.65l3.28-1.21c.49-.18 1.03.06 1.26.53.83 1.7 2.05 2.03 2.46 2.03z"
}), 'RunCircle');

});

parcelRegister("c2wA2", function(module, exports) {

$parcel$export(module.exports, "handleTriggerMotionAxis", () => $4950048952a8bfeb$export$a5297cab1d4a31c0);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $4950048952a8bfeb$export$a5297cab1d4a31c0 = (cameraId, navigate, setBackdropLoadingScreenOn, setEditCameraAlerts)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $4950048952a8bfeb$export$a5297cab1d4a31c0(cameraId, navigate, setBackdropLoadingScreenOn, setEditCameraAlerts);
    };
    AxiosUI.post(`/axis/${cameraId}/trigger_motion/`).then(()=>{
        setBackdropLoadingScreenOn(false);
        setEditCameraAlerts((previousState)=>{
            return {
                ...previousState,
                triggerMotionFail: false,
                triggerMotionSuccess: true
            };
        });
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
            setEditCameraAlerts((previousState)=>{
                return {
                    ...previousState,
                    triggerMotionFail: true,
                    triggerMotionSuccess: false
                };
            });
        });
    });
};

});



parcelRegister("7TDDC", function(module, exports) {

$parcel$export(module.exports, "ImmixTestSuccessDialog", () => $155bd63b3891cbad$export$9f9547c8f8aed464);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $8jTCz = parcelRequire("8jTCz");
const $155bd63b3891cbad$export$9f9547c8f8aed464 = ({ immixTestSuccessDialogOpen: immixTestSuccessDialogOpen, setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen })=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: immixTestSuccessDialogOpen,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-mulish text-[20px]",
                        children: "Immix test succeeded!"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                        children: [
                            "The test alert successfully reached your Immix server. If you are still experiencing issues viewing alerts in Immix, please contact support@actuate.ai.",
                            " "
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                    onClick: ()=>{
                        setImmixTestSuccessDialogOpen(false);
                    },
                    text: "Ok",
                    disabled: false
                })
            })
        ]
    });
};

});

parcelRegister("fXzUh", function(module, exports) {

$parcel$export(module.exports, "ImmixTestFailDialog", () => $9c3b55844561a15a$export$4bd202828d5f0990);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $8jTCz = parcelRequire("8jTCz");
const $9c3b55844561a15a$export$4bd202828d5f0990 = ({ immixTestFailDialogOpen: immixTestFailDialogOpen, setImmixTestFailDialogOpen: setImmixTestFailDialogOpen })=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: immixTestFailDialogOpen,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-mulish text-[20px]",
                        children: "Immix test failed."
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                        children: [
                            "The test alert failed to reach your Immix server. Please ensure the information entered matches the generic stream device on your Immix Summary Report and that the site is armed in Immix. If you are still experiencing issues, please contact support@actuate.ai.",
                            " "
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                    onClick: ()=>{
                        setImmixTestFailDialogOpen(false);
                    },
                    text: "Ok",
                    disabled: false
                })
            })
        ]
    });
};

});

parcelRegister("lPFIv", function(module, exports) {

$parcel$export(module.exports, "DiceTestSuccessDialog", () => $c30341d5d8e21884$export$a40efa28da359afd);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $8jTCz = parcelRequire("8jTCz");
const $c30341d5d8e21884$export$a40efa28da359afd = ({ diceTestSuccessDialogOpen: diceTestSuccessDialogOpen, setDiceTestSuccessDialogOpen: setDiceTestSuccessDialogOpen })=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: diceTestSuccessDialogOpen,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-mulish text-[20px]",
                        children: "Dice test succeeded!"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                        children: [
                            "The test alert successfully reached your Dice server. If you are still experiencing issues viewing alerts in Dice, please contact support@actuate.ai.",
                            " "
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                    onClick: ()=>{
                        setDiceTestSuccessDialogOpen(false);
                    },
                    text: "Ok",
                    disabled: false
                })
            })
        ]
    });
};

});

parcelRegister("jDWxC", function(module, exports) {

$parcel$export(module.exports, "DiceTestFailDialog", () => $75bf3340c4130fd7$export$3f8929c619ca1d64);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $8jTCz = parcelRequire("8jTCz");
const $75bf3340c4130fd7$export$3f8929c619ca1d64 = ({ diceTestFailDialogOpen: diceTestFailDialogOpen, setDiceTestFailDialogOpen: setDiceTestFailDialogOpen })=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: diceTestFailDialogOpen,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-mulish text-[20px]",
                        children: "Dice test failed."
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                        children: [
                            "The test alert failed to reach your Dice server. Please ensure the information entered matches the generic stream device on your Dice Summary Report and that the site is armed in Dice. If you are still experiencing issues, please contact support@actuate.ai.",
                            " "
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                    onClick: ()=>{
                        setDiceTestFailDialogOpen(false);
                    },
                    text: "Ok",
                    disabled: false
                })
            })
        ]
    });
};

});

parcelRegister("kZIQb", function(module, exports) {

$parcel$export(module.exports, "V1RedirectDialog", () => $7509cc303470861b$export$ffd7df2ea3fceda7);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");
const $7509cc303470861b$export$ffd7df2ea3fceda7 = ({ v1RedirectDialogOpen: v1RedirectDialogOpen, setv1RedirectDialogOpen: setv1RedirectDialogOpen })=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: v1RedirectDialogOpen,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                    children: [
                        "Edit Ignore Zones is current under reconstruction. Would you like to navigate to version 1 of the Actuate site to edit ignore zones?",
                        " "
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setv1RedirectDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            window.open(`https://admin.actuateui.net/inframap/label_zones/${(0, $a8BPe.getNumbersAfterEditCamera)(location.href)}/?_changelist_filters=customer__id__exact%3D10257`);
                            setv1RedirectDialogOpen(false);
                        },
                        text: "Ok",
                        disabled: false
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("2hXui", function(module, exports) {

$parcel$export(module.exports, "getAllCameras", () => $de774f99a87d1b00$export$aec3f2e8fea4c159);
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");
const $de774f99a87d1b00$export$aec3f2e8fea4c159 = (customerId, cameraId, setAllCamerasData, setCameraIndex)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    let allCamerasData = [];
    const getAllCamerasAPICall = (pageNumber)=>{
        AxiosUI.get(`camera/site/?customer__id=${customerId}&page=${pageNumber}`).then((response)=>{
            if (response.data.count) {
                if (pageNumber === 1) allCamerasData = response.data.results;
                if (pageNumber > 1) allCamerasData.push(...response.data.results);
                if (response.data.next) getAllCamerasAPICall(pageNumber + 1);
                else {
                    allCamerasData.forEach((camera, index)=>{
                        if (camera.id === cameraId) setCameraIndex(index);
                    });
                    setAllCamerasData(allCamerasData);
                }
            }
        });
    };
    getAllCamerasAPICall(1);
};

});

parcelRegister("frXOV", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b3f7c7baca02c64d$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $b3f7c7baca02c64d$var$_default = module.exports.default = (0, $b3f7c7baca02c64d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M11.67 3.87 9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"
}), 'ArrowBackIos');

});

parcelRegister("2qUoo", function(module, exports) {
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1c59c0d49dcbeeef$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $1c59c0d49dcbeeef$var$_default = module.exports.default = (0, $1c59c0d49dcbeeef$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M6.23 20.23 8 22l10-10L8 2 6.23 3.77 14.46 12z"
}), 'ArrowForwardIos');

});

parcelRegister("i5LXy", function(module, exports) {

$parcel$export(module.exports, "resetState", () => $80946a76c129d49d$export$8e84bad0b35de9e8);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");
const $80946a76c129d49d$export$8e84bad0b35de9e8 = (setCameraDataLoaded, setCameraObject, setSiteInfo, setClickedTab, setEditMode, setAddImmixAlertDialogOpen, setAddSureviewAlertDialogOpen, setCameraGeneralInfo, setCameraGeneralInfoBackup, setPatchObject, setGeneralInfoChangesMade, setActiveChangeMade, setAxisCamera, setMobotixCamera, setActiveTab, setBackdropLoadingScreenOn, setImmixAlertsOnCamera, setImmixAlerts, setSureViewAlertsOnCamera, setSureviewAlerts, setIgnoreZonesBreadCrumbs, setEditCameraAlerts, setRecipientsConfiguredData, setTitlesArray, setActionRulesData, setActionRulesTitlesArray, setApplicationsConfiguredData, setTimeTablesData, setIPNotifyData, setActionHandlerData, setMobotixFinished, setAxisFinished, setStreamsObject, setActiveProducts, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setv1RedirectDialogOpen, setSrcImages, setCameraInfoRow, setCameraWebhookData, setCameraWebhooksPatchObject, setCameraWebhooksChangesMade, setProductsData, setBackupProductsData, setAllTabsOpen, setAllCamerasData, setCameraIndex, setSentinelAlertsOnCamera, setSentinelAlerts, setBoldAlerts, setBoldAlertsOnCamera, setPatriotAlerts, setPatriotAlertsOnCamera, setUSMonitoringAlerts, setUSMonitoringAlertsOnCamera, setSoftguardAlerts, setSoftguardAlertsOnCamera)=>{
    setCameraDataLoaded(false);
    setCameraObject({});
    setSiteInfo({});
    setClickedTab("one");
    setEditMode(false);
    setAddImmixAlertDialogOpen(false);
    setAddSureviewAlertDialogOpen(false);
    setCameraGeneralInfo({});
    setCameraGeneralInfoBackup({});
    setPatchObject({});
    setGeneralInfoChangesMade(false);
    setActiveChangeMade(false);
    setAxisCamera(false);
    setMobotixCamera(false);
    setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
    setBackdropLoadingScreenOn(true);
    setImmixAlertsOnCamera(false);
    setImmixAlerts([]);
    setSureViewAlertsOnCamera(false);
    setSureviewAlerts([]);
    setSentinelAlertsOnCamera(false);
    setSentinelAlerts([]);
    setBoldAlerts([]);
    setBoldAlertsOnCamera(false);
    setPatriotAlerts([]);
    setPatriotAlertsOnCamera(false);
    setUSMonitoringAlerts([]);
    setUSMonitoringAlertsOnCamera(false);
    setSoftguardAlerts([]);
    setSoftguardAlertsOnCamera(false);
    setIgnoreZonesBreadCrumbs(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
    setEditCameraAlerts({
        triggerMotionSuccess: false,
        triggerMotionFail: false
    });
    setRecipientsConfiguredData([]);
    setTitlesArray([
        "Name",
        "Recipient Type",
        "Host",
        "Port",
        "Email From",
        "Email To"
    ]);
    setActionRulesData([]);
    setActionRulesTitlesArray([
        "Name",
        "Host",
        "Port",
        "Email From",
        "Email To",
        "Message",
        "Enabled",
        "Profile"
    ]);
    setApplicationsConfiguredData([]);
    setTimeTablesData([]);
    setIPNotifyData([]);
    setActionHandlerData([]);
    setMobotixFinished({
        timeTable: false,
        iPNotify: false,
        actionHandler: false
    });
    setAxisFinished({
        recipient: false,
        actionRules: false,
        application: false
    });
    setStreamsObject({});
    setActiveProducts([]);
    setSendingImmixTest(false);
    setImmixTestSuccessDialogOpen(false);
    setImmixTestFailDialogOpen(false);
    setv1RedirectDialogOpen(false);
    setSrcImages({});
    setCameraInfoRow("");
    setCameraWebhookData([]);
    setCameraWebhooksPatchObject({});
    setCameraWebhooksChangesMade(false);
    setProductsData([
        {
            name: "Intruder",
            label_name: "intruder",
            open: false,
            metrics: {}
        },
        {
            name: "Intruder Plus",
            label_name: "intruderPlus",
            open: false,
            metrics: {}
        },
        {
            name: "Gun",
            label_name: "gun",
            open: false,
            metrics: {}
        },
        {
            name: "Crowd",
            label_name: "crowd",
            open: false,
            metrics: {}
        },
        {
            name: "Loitering",
            label_name: "loitering",
            open: false,
            metrics: {}
        },
        {
            name: "Slip and Fall",
            label_name: "fallPerson",
            open: false,
            metrics: {}
        },
        {
            name: "No Hard Hat",
            label_name: "noHardHat",
            open: false,
            metrics: {}
        },
        // { name: "Mask", label_name: "mask", open: false, metrics: {} },
        {
            name: "Social Distancing",
            label_name: "socialDistancing",
            open: false,
            metrics: {}
        },
        // {
        //   name: "Left Object",
        //   label_name: "leftObject",
        //   open: false,
        //   metrics: {},
        // },
        // {
        //   name: "Package",
        //   label_name: "package",
        //   open: false,
        //   metrics: {},
        // },
        {
            name: "Fire",
            label_name: "fire",
            open: false,
            metrics: {}
        },
        {
            name: "Vehicle Logo ID",
            label_name: "vehicleLogoId",
            open: false,
            metrics: {}
        },
        {
            name: "Non-UPS",
            label_name: "nonUps",
            open: false,
            metrics: {}
        }
    ]);
    setBackupProductsData([]);
    setAllTabsOpen(false);
    setAllCamerasData([]);
    setCameraIndex(0);
};

});

parcelRegister("7DeOh", function(module, exports) {

$parcel$export(module.exports, "AddSentinelAlertDialog", () => $7cdf4cd4b2c3d8dd$export$a606f5ad7c3c4352);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $8B8vg = parcelRequire("8B8vg");
var $9qNow = parcelRequire("9qNow");
var $eejVe = parcelRequire("eejVe");

var $lk6eW = parcelRequire("lk6eW");

var $kbChx = parcelRequire("kbChx");

var $3baw3 = parcelRequire("3baw3");

var $aJbkY = parcelRequire("aJbkY");

var $aZxZ3 = parcelRequire("aZxZ3");
const $7cdf4cd4b2c3d8dd$export$a606f5ad7c3c4352 = ({ setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen, addSentinelAlertDialogOpen: addSentinelAlertDialogOpen, sentinelAlerts: sentinelAlerts, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setCameraGeneralInfo: setCameraGeneralInfo, setCameraGeneralInfoBackup: setCameraGeneralInfoBackup, setGeneralInfoChangesMade: setGeneralInfoChangesMade, setPatchObject: setPatchObject, setSentinelAlerts: setSentinelAlerts, setActiveTab: setActiveTab, cameraGeneralInfoBackup: cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs: setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick: handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick, cameraGeneralInfo: cameraGeneralInfo, immixAlerts: immixAlerts, setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen, setSendingImmixTest: setSendingImmixTest, setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen: setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen, sureviewAlerts: sureviewAlerts, setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen, cameraWebhookData: cameraWebhookData, setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen, boldAlerts: boldAlerts, setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen, patriotAlerts: patriotAlerts, setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen, softguardAlerts: softguardAlerts, setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen, immixAlertsOnCamera: immixAlertsOnCamera, sureViewAlertsOnCamera: sureViewAlertsOnCamera, siteInfo: siteInfo, webhooksAlertsOnCamera: webhooksAlertsOnCamera, sentinelAlertsOnCamera: sentinelAlertsOnCamera, boldAlertsOnCamera: boldAlertsOnCamera, patriotAlertsOnCamera: patriotAlertsOnCamera, softguardAlertsOnCamera: softguardAlertsOnCamera, evalinkAlertsOnCamera: evalinkAlertsOnCamera })=>{
    const { cameraStreams: cameraStreams, cameraStreamsPatchObject: cameraStreamsPatchObject } = (0, $aZxZ3.useEditCameraStore)();
    const streamNames = new Map();
    cameraStreams?.forEach((object, index)=>{
        streamNames.set(`${object.name} (${object.product})`, index);
    });
    const navigate = (0, $3T949.useNavigate)();
    const [postObject, setPostObject] = $8T3gX.useState({
        id: -1,
        sentinel_server: "",
        sentinel_site_id: "",
        sentinel_device_address: "",
        draw_ignore_zones: false
    });
    const [selectedStreamNames, setSelectedStreamNames] = $8T3gX.useState([]);
    $8T3gX.useEffect(()=>{
        if (sentinelAlerts[0]) setPostObject({
            id: -1,
            sentinel_server: sentinelAlerts[0].sentinel_server,
            sentinel_site_id: sentinelAlerts[0].sentinel_site_id,
            sentinel_device_address: sentinelAlerts[0].sentinel_device_address,
            draw_ignore_zones: sentinelAlerts[0].draw_ignore_zones
        });
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: addSentinelAlertDialogOpen,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: "Add Sentinel Alert"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                children: [
                    cameraStreams && cameraStreams.length > 1 && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $lk6eW.default), {
                                component: "legend",
                                sx: {
                                    paddingBottom: 1
                                },
                                children: [
                                    " ",
                                    "Streams*"
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                multiple: true,
                                options: cameraStreams.map((object)=>{
                                    return `${object.name} (${object.product})`;
                                }),
                                sx: {
                                    width: 400
                                },
                                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        ...params
                                    }),
                                onChange: (event, value)=>{
                                    setSelectedStreamNames(value);
                                }
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "sentinel_server",
                        variant: "standard",
                        label: "Sentinel Server",
                        defaultValue: sentinelAlerts[0] ? sentinelAlerts[0].sentinel_server : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    sentinel_server: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        helperText: "What is the url for your Sentinel server.",
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "sentinel_site_id",
                        variant: "standard",
                        label: "Sentinel site id",
                        defaultValue: sentinelAlerts[0] ? sentinelAlerts[0].sentinel_site_id : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    sentinel_site_id: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "sentinel_device_address",
                        variant: "standard",
                        label: "Sentinel device address",
                        defaultValue: sentinelAlerts[0] ? sentinelAlerts[0].sentinel_device_address : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    sentinel_device_address: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                sx: {
                                    fontFamily: "Mulish",
                                    color: "#001943"
                                },
                                label: "Draw Ignore Zones",
                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                    color: "primary",
                                    defaultChecked: sentinelAlerts[0] ? sentinelAlerts[0].draw_ignore_zones : false,
                                    onChange: (event, checked)=>{
                                        setPostObject((previousState)=>{
                                            return {
                                                ...previousState,
                                                draw_ignore_zones: checked
                                            };
                                        });
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                                children: "If checked, draws ignore zones in the alert images."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setAddSentinelAlertDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            const selectedStreamIndexs = [];
                            const streamsObjectToPost = JSON.parse(JSON.stringify(cameraStreamsPatchObject));
                            if (cameraStreams && cameraStreams.length > 1) {
                                selectedStreamNames.forEach((streamName)=>{
                                    selectedStreamIndexs.push(streamNames.get(streamName));
                                });
                                selectedStreamIndexs.forEach((streamIndex)=>{
                                    if (streamsObjectToPost[streamIndex]) streamsObjectToPost[streamIndex].sentinel_alerts = [
                                        ...streamsObjectToPost[streamIndex].sentinel_alerts,
                                        postObject
                                    ];
                                });
                            }
                            if (cameraStreams && cameraStreams.length === 1) streamsObjectToPost[0].sentinel_alerts.push(postObject);
                            setAddSentinelAlertDialogOpen(false);
                            setBackdropLoadingScreenOn(true);
                            (0, $aJbkY.handleSubmitNewSentinelAlert)(cameraGeneralInfo, sentinelAlerts, streamsObjectToPost, navigate, setBackdropLoadingScreenOn, setCameraGeneralInfo, setCameraGeneralInfoBackup, setGeneralInfoChangesMade, setPatchObject, setSentinelAlerts, setActiveTab, setAddSentinelAlertDialogOpen, cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, immixAlerts, setAddImmixAlertDialogOpen, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen, sureviewAlerts, setAddSureviewAlertDialogOpen, cameraWebhookData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, immixAlertsOnCamera, sureViewAlertsOnCamera, siteInfo, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera);
                        },
                        text: "Submit",
                        disabled: false
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("aJbkY", function(module, exports) {

$parcel$export(module.exports, "handleSubmitNewSentinelAlert", () => $4ab15fd539881f98$export$b78ece0f74f341ae);

var $k4ank = parcelRequire("k4ank");

var $195EM = parcelRequire("195EM");

var $815yO = parcelRequire("815yO");

var $lukvk = parcelRequire("lukvk");

var $h0DCc = parcelRequire("h0DCc");

var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");

var $4wo2Y = parcelRequire("4wo2Y");

var $dWhHk = parcelRequire("dWhHk");

var $aZxZ3 = parcelRequire("aZxZ3");
const $4ab15fd539881f98$export$b78ece0f74f341ae = async (cameraGeneralInfo, sentinelAlerts, postObject, navigate, setBackdropLoadingScreenOn, setCameraGeneralInfo, setCameraGeneralInfoBackup, setGeneralInfoChangesMade, setPatchObject, setSentinelAlerts, setActiveTab, setAddSentinelAlertDialogOpen, cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, immixAlerts, setAddImmixAlertDialogOpen, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen, sureviewAlerts, setAddSureviewAlertDialogOpen, cameraWebhookData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, immixAlertsOnCamera, sureViewAlertsOnCamera, siteInfo, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $4ab15fd539881f98$export$b78ece0f74f341ae(cameraGeneralInfo, sentinelAlerts, postObject, navigate, setBackdropLoadingScreenOn, setCameraGeneralInfo, setCameraGeneralInfoBackup, setGeneralInfoChangesMade, setPatchObject, setSentinelAlerts, setActiveTab, setAddSentinelAlertDialogOpen, cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, immixAlerts, setAddImmixAlertDialogOpen, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen, sureviewAlerts, setAddSureviewAlertDialogOpen, cameraWebhookData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, immixAlertsOnCamera, sureViewAlertsOnCamera, siteInfo, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera);
    };
    let postPatchObjectFail = false;
    let getSiteCamerasFail = false;
    const { setCameraStreamsPatchObject: setCameraStreamsPatchObject, setCameraStreamsObject: setCameraStreamsObject } = (0, $aZxZ3.useEditCameraStore).getState();
    await AxiosUI.patch(`/camera/${(0, $a8BPe.getNumbersAfterEditCamera)(location.href)}/general_info/`, {
        streams: postObject
    }).then((response)=>{
        postPatchObjectFail = false;
        (0, $815yO.markSiteUnsynced)();
        setCameraGeneralInfo(response.data);
        setCameraGeneralInfoBackup(response.data);
        setCameraStreamsPatchObject(response.data.streams);
        setCameraStreamsObject(response.data.streams);
        const pushedArray = [];
        response.data.streams[0].sentinel_alerts.forEach((alertObject)=>{
            pushedArray.push(alertObject);
        });
        setSentinelAlerts(pushedArray);
        setGeneralInfoChangesMade(false);
        setPatchObject({});
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dWhHk.AlertSettingsTab), {
                immixAlerts: immixAlerts,
                setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                setSendingImmixTest: setSendingImmixTest,
                setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                sureviewAlerts: sureviewAlerts,
                setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                sentinelAlerts: pushedArray,
                setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                boldAlerts: boldAlerts,
                setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                patriotAlerts: patriotAlerts,
                setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                softguardAlerts: softguardAlerts,
                setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                immixAlertsOnCamera: immixAlertsOnCamera,
                sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                siteInfo: siteInfo,
                webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                boldAlertsOnCamera: boldAlertsOnCamera,
                patriotAlertsOnCamera: patriotAlertsOnCamera,
                softguardAlertsOnCamera: softguardAlertsOnCamera,
                evalinkAlertsOnCamera: evalinkAlertsOnCamera,
                navigate: navigate
            })
        }));
        setBackdropLoadingScreenOn(false);
    }, (reason)=>{
        postPatchObjectFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setCameraGeneralInfo(cameraGeneralInfoBackup);
            setPatchObject({
                camera_name: cameraGeneralInfoBackup.camera_name,
                streams: cameraGeneralInfoBackup.streams
            });
            setBackdropLoadingScreenOn(false);
        });
    });
    !postPatchObjectFail && await AxiosUI.get(`camera/site/?customer__id=${(0, $a8BPe.getNumbersAfterSites)(location.href)}`).then((response)=>{
        getSiteCamerasFail = false;
        localStorage.setItem("siteCameras", JSON.stringify(response.data));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            getSiteCamerasFail = true;
        });
    });
    !postPatchObjectFail && !getSiteCamerasFail && await AxiosUI.get(`customer/${(0, $a8BPe.getNumbersAfterSites)(location.href)}/about/`).then((response)=>{
        localStorage.setItem("siteInfo", JSON.stringify(response.data));
        localStorage.setItem("integrationType", response.data.integration_type);
        setIgnoreZonesBreadCrumbs(/*#__PURE__*/ (0, $k4ank.jsx)((0, $lukvk.IgnoreZonesBreadCrumbs), {
            linksArray: (0, $h0DCc.createIgnoreZonesLinksArray)(response.data.breadcrumbs),
            handleSitesBreadcrumbClick: handleSitesBreadcrumbClick,
            handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick,
            styling: "absolute top-[10px] left-[30px]"
        }));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
        });
    });
};

});


parcelRegister("8quhT", function(module, exports) {

$parcel$export(module.exports, "AddBoldAlertDialog", () => $c9c9b0440960c97d$export$b43a662bfe504483);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");

var $lk6eW = parcelRequire("lk6eW");

var $k9WQy = parcelRequire("k9WQy");

var $aZxZ3 = parcelRequire("aZxZ3");
const $c9c9b0440960c97d$export$b43a662bfe504483 = ({ setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen, addBoldAlertDialogOpen: addBoldAlertDialogOpen, boldAlerts: boldAlerts, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setCameraGeneralInfo: setCameraGeneralInfo, setCameraGeneralInfoBackup: setCameraGeneralInfoBackup, setGeneralInfoChangesMade: setGeneralInfoChangesMade, setPatchObject: setPatchObject, setBoldAlerts: setBoldAlerts, setActiveTab: setActiveTab, cameraGeneralInfoBackup: cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs: setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick: handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick, cameraGeneralInfo: cameraGeneralInfo, immixAlerts: immixAlerts, setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen, setSendingImmixTest: setSendingImmixTest, setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen: setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen, sureviewAlerts: sureviewAlerts, setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen, cameraWebhookData: cameraWebhookData, setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen, sentinelAlerts: sentinelAlerts, setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen, patriotAlerts: patriotAlerts, setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen, softguardAlerts: softguardAlerts, setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen, immixAlertsOnCamera: immixAlertsOnCamera, sureViewAlertsOnCamera: sureViewAlertsOnCamera, siteInfo: siteInfo, webhooksAlertsOnCamera: webhooksAlertsOnCamera, sentinelAlertsOnCamera: sentinelAlertsOnCamera, boldAlertsOnCamera: boldAlertsOnCamera, patriotAlertsOnCamera: patriotAlertsOnCamera, softguardAlertsOnCamera: softguardAlertsOnCamera, evalinkAlertsOnCamera: evalinkAlertsOnCamera })=>{
    const { cameraStreams: cameraStreams, cameraStreamsPatchObject: cameraStreamsPatchObject } = (0, $aZxZ3.useEditCameraStore)();
    const streamNames = new Map();
    cameraStreams?.forEach((object, index)=>{
        streamNames.set(`${object.name} (${object.product})`, index);
    });
    const navigate = (0, $3T949.useNavigate)();
    const [postObject, setPostObject] = $8T3gX.useState({
        id: -1,
        bold_server: "",
        bold_port: "",
        bold_id: "",
        bold_sdnis: "",
        bold_zone: "",
        bold_alarmtype: ""
    });
    const [selectedStreamNames, setSelectedStreamNames] = $8T3gX.useState([]);
    $8T3gX.useEffect(()=>{
        if (boldAlerts[0]) setPostObject({
            id: -1,
            bold_server: boldAlerts[0].bold_server,
            bold_port: boldAlerts[0].bold_port,
            bold_id: boldAlerts[0].bold_id,
            bold_sdnis: boldAlerts[0].bold_sdnis,
            bold_zone: boldAlerts[0].bold_zone,
            bold_alarmtype: boldAlerts[0].bold_alarmtype
        });
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: addBoldAlertDialogOpen,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: "Add Bold Alert"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                children: [
                    cameraStreams && cameraStreams.length > 1 && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $lk6eW.default), {
                                component: "legend",
                                sx: {
                                    paddingBottom: 1
                                },
                                children: [
                                    " ",
                                    "Streams*"
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                multiple: true,
                                options: cameraStreams.map((object)=>{
                                    return `${object.name} (${object.product})`;
                                }),
                                sx: {
                                    width: 400
                                },
                                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        ...params
                                    }),
                                onChange: (event, value)=>{
                                    setSelectedStreamNames(value);
                                }
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "bold_server",
                        variant: "standard",
                        label: "Bold Server",
                        defaultValue: boldAlerts[0] ? boldAlerts[0].bold_server : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    bold_server: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "bold_port",
                        variant: "standard",
                        label: "Bold Port",
                        defaultValue: boldAlerts[0] ? boldAlerts[0].bold_port : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    bold_port: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "bold_id",
                        variant: "standard",
                        label: "Bold Id",
                        defaultValue: boldAlerts[0] ? boldAlerts[0].bold_id : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    bold_id: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "bold_sdnis",
                        variant: "standard",
                        label: "Bold sdnis",
                        defaultValue: boldAlerts[0] ? boldAlerts[0].bold_sdnis : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    bold_sdnis: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "bold_zone",
                        variant: "standard",
                        label: "Bold Zone",
                        defaultValue: boldAlerts[0] ? boldAlerts[0].bold_zone : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    bold_zone: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "bold_alarmtype",
                        variant: "standard",
                        label: "Bold Alarm Type",
                        defaultValue: boldAlerts[0] ? boldAlerts[0].bold_alarmtype : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    bold_alarmtype: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        type: "string",
                        helperText: "Alarm type for alert, default is BA (Burglary alarm)."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setAddBoldAlertDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            const selectedStreamIndexs = [];
                            const streamsObjectToPost = JSON.parse(JSON.stringify(cameraStreamsPatchObject));
                            if (cameraStreams && cameraStreams.length > 1) {
                                selectedStreamNames.forEach((streamName)=>{
                                    selectedStreamIndexs.push(streamNames.get(streamName));
                                });
                                selectedStreamIndexs.forEach((streamIndex)=>{
                                    if (streamsObjectToPost[streamIndex]) streamsObjectToPost[streamIndex].bold_alerts = [
                                        ...streamsObjectToPost[streamIndex].bold_alerts,
                                        postObject
                                    ];
                                });
                            }
                            if (cameraStreams && cameraStreams.length === 1) streamsObjectToPost[0].bold_alerts.push(postObject);
                            setAddBoldAlertDialogOpen(false);
                            setBackdropLoadingScreenOn(true);
                            (0, $k9WQy.handleSubmitNewBoldAlert)(cameraGeneralInfo, boldAlerts, streamsObjectToPost, navigate, setBackdropLoadingScreenOn, setCameraGeneralInfo, setCameraGeneralInfoBackup, setGeneralInfoChangesMade, setPatchObject, setBoldAlerts, setActiveTab, setAddBoldAlertDialogOpen, cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, immixAlerts, setAddImmixAlertDialogOpen, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen, sureviewAlerts, setAddSureviewAlertDialogOpen, cameraWebhookData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, sentinelAlerts, setAddSentinelAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, immixAlertsOnCamera, sureViewAlertsOnCamera, siteInfo, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera);
                        },
                        text: "Submit",
                        disabled: false
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("k9WQy", function(module, exports) {

$parcel$export(module.exports, "handleSubmitNewBoldAlert", () => $a3386e0faa657ceb$export$4202d78ee3ae7fe9);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $815yO = parcelRequire("815yO");

var $lukvk = parcelRequire("lukvk");

var $h0DCc = parcelRequire("h0DCc");

var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");

var $4wo2Y = parcelRequire("4wo2Y");

var $dWhHk = parcelRequire("dWhHk");

var $aZxZ3 = parcelRequire("aZxZ3");
const $a3386e0faa657ceb$export$4202d78ee3ae7fe9 = async (cameraGeneralInfo, boldAlerts, postObject, navigate, setBackdropLoadingScreenOn, setCameraGeneralInfo, setCameraGeneralInfoBackup, setGeneralInfoChangesMade, setPatchObject, setBoldAlerts, setActiveTab, setAddBoldAlertDialogOpen, cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, immixAlerts, setAddImmixAlertDialogOpen, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen, sureviewAlerts, setAddSureviewAlertDialogOpen, cameraWebhookData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, sentinelAlerts, setAddSentinelAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, immixAlertsOnCamera, sureViewAlertsOnCamera, siteInfo, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $a3386e0faa657ceb$export$4202d78ee3ae7fe9(cameraGeneralInfo, boldAlerts, postObject, navigate, setBackdropLoadingScreenOn, setCameraGeneralInfo, setCameraGeneralInfoBackup, setGeneralInfoChangesMade, setPatchObject, setBoldAlerts, setActiveTab, setAddBoldAlertDialogOpen, cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, immixAlerts, setAddImmixAlertDialogOpen, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen, sureviewAlerts, setAddSureviewAlertDialogOpen, cameraWebhookData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, sentinelAlerts, setAddSentinelAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, immixAlertsOnCamera, sureViewAlertsOnCamera, siteInfo, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera);
    };
    let postPatchObjectFail = false;
    let getSiteCamerasFail = false;
    const { setCameraStreamsPatchObject: setCameraStreamsPatchObject, setCameraStreamsObject: setCameraStreamsObject } = (0, $aZxZ3.useEditCameraStore).getState();
    await AxiosUI.patch(`/camera/${(0, $a8BPe.getNumbersAfterEditCamera)(location.href)}/general_info/`, {
        streams: postObject
    }).then((response)=>{
        postPatchObjectFail = false;
        (0, $815yO.markSiteUnsynced)();
        setCameraGeneralInfo(response.data);
        setCameraGeneralInfoBackup(response.data);
        setCameraStreamsPatchObject(response.data.streams);
        setCameraStreamsObject(response.data.streams);
        const pushedArray = [];
        response.data.streams[0].bold_alerts.forEach((alertObject)=>{
            pushedArray.push(alertObject);
        });
        setBoldAlerts(pushedArray);
        setGeneralInfoChangesMade(false);
        setPatchObject({});
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dWhHk.AlertSettingsTab), {
                immixAlerts: immixAlerts,
                setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                setSendingImmixTest: setSendingImmixTest,
                setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                sureviewAlerts: sureviewAlerts,
                setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                sentinelAlerts: sentinelAlerts,
                setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                boldAlerts: pushedArray,
                setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                patriotAlerts: patriotAlerts,
                setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                softguardAlerts: softguardAlerts,
                setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                immixAlertsOnCamera: immixAlertsOnCamera,
                sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                siteInfo: siteInfo,
                webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                boldAlertsOnCamera: boldAlertsOnCamera,
                patriotAlertsOnCamera: patriotAlertsOnCamera,
                softguardAlertsOnCamera: softguardAlertsOnCamera,
                evalinkAlertsOnCamera: evalinkAlertsOnCamera,
                navigate: navigate
            })
        }));
        setBackdropLoadingScreenOn(false);
    }, (reason)=>{
        postPatchObjectFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setCameraGeneralInfo(cameraGeneralInfoBackup);
            setPatchObject({
                camera_name: cameraGeneralInfoBackup.camera_name,
                streams: cameraGeneralInfoBackup.streams
            });
            setBackdropLoadingScreenOn(false);
        });
    });
    !postPatchObjectFail && await AxiosUI.get(`camera/site/?customer__id=${(0, $a8BPe.getNumbersAfterSites)(location.href)}`).then((response)=>{
        getSiteCamerasFail = false;
        localStorage.setItem("siteCameras", JSON.stringify(response.data));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            getSiteCamerasFail = true;
        });
    });
    !postPatchObjectFail && !getSiteCamerasFail && await AxiosUI.get(`customer/${(0, $a8BPe.getNumbersAfterSites)(location.href)}/about/`).then((response)=>{
        localStorage.setItem("siteInfo", JSON.stringify(response.data));
        localStorage.setItem("integrationType", response.data.integration_type);
        setIgnoreZonesBreadCrumbs(/*#__PURE__*/ (0, $k4ank.jsx)((0, $lukvk.IgnoreZonesBreadCrumbs), {
            linksArray: (0, $h0DCc.createIgnoreZonesLinksArray)(response.data.breadcrumbs),
            handleSitesBreadcrumbClick: handleSitesBreadcrumbClick,
            handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick,
            styling: "absolute top-[10px] left-[30px]"
        }));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
        });
    });
};

});


parcelRegister("k3urr", function(module, exports) {

$parcel$export(module.exports, "AddPatriotAlertDialog", () => $bc1feefb814594d9$export$6f766a2139e42279);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");

var $lk6eW = parcelRequire("lk6eW");

var $1BQwf = parcelRequire("1BQwf");

var $aZxZ3 = parcelRequire("aZxZ3");

var $7txAP = parcelRequire("7txAP");

var $hG03Q = parcelRequire("hG03Q");
const $bc1feefb814594d9$export$6f766a2139e42279 = ({ setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen, addPatriotAlertDialogOpen: addPatriotAlertDialogOpen, patriotAlerts: patriotAlerts, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setCameraGeneralInfo: setCameraGeneralInfo, setCameraGeneralInfoBackup: setCameraGeneralInfoBackup, setGeneralInfoChangesMade: setGeneralInfoChangesMade, setPatchObject: setPatchObject, setPatriotAlerts: setPatriotAlerts, setActiveTab: setActiveTab, cameraGeneralInfoBackup: cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs: setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick: handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick, cameraGeneralInfo: cameraGeneralInfo, immixAlerts: immixAlerts, setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen, setSendingImmixTest: setSendingImmixTest, setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen: setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen, sureviewAlerts: sureviewAlerts, setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen, cameraWebhookData: cameraWebhookData, setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen, sentinelAlerts: sentinelAlerts, setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen, boldAlerts: boldAlerts, setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen, softguardAlerts: softguardAlerts, setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen, immixAlertsOnCamera: immixAlertsOnCamera, sureViewAlertsOnCamera: sureViewAlertsOnCamera, siteInfo: siteInfo, webhooksAlertsOnCamera: webhooksAlertsOnCamera, sentinelAlertsOnCamera: sentinelAlertsOnCamera, boldAlertsOnCamera: boldAlertsOnCamera, patriotAlertsOnCamera: patriotAlertsOnCamera, softguardAlertsOnCamera: softguardAlertsOnCamera, evalinkAlertsOnCamera: evalinkAlertsOnCamera })=>{
    const { cameraStreams: cameraStreams, cameraStreamsPatchObject: cameraStreamsPatchObject } = (0, $aZxZ3.useEditCameraStore)();
    const streamNames = new Map();
    cameraStreams?.forEach((object, index)=>{
        streamNames.set(`${object.name} (${object.product})`, index);
    });
    const navigate = (0, $3T949.useNavigate)();
    const [postObject, setPostObject] = $8T3gX.useState({
        id: -1,
        patriot_server: "",
        patriot_client_no: "",
        patriot_username: "",
        patriot_password: "",
        patriot_zone_number: "",
        patriot_type_number: "",
        patriot_send_video: false,
        draw_ignore_zones: false
    });
    const [selectedStreamNames, setSelectedStreamNames] = $8T3gX.useState([]);
    $8T3gX.useEffect(()=>{
        if (patriotAlerts[0]) setPostObject({
            id: -1,
            patriot_server: patriotAlerts[0].patriot_server,
            patriot_client_no: patriotAlerts[0].patriot_client_no,
            patriot_username: patriotAlerts[0].patriot_username,
            patriot_password: patriotAlerts[0].patriot_password,
            patriot_zone_number: patriotAlerts[0].patriot_zone_number,
            patriot_type_number: patriotAlerts[0].patriot_type_number,
            patriot_send_video: patriotAlerts[0].patriot_send_video,
            draw_ignore_zones: patriotAlerts[0].draw_ignore_zones
        });
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: addPatriotAlertDialogOpen,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: "Add Patriot Alert"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                children: [
                    cameraStreams && cameraStreams.length > 1 && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $lk6eW.default), {
                                component: "legend",
                                sx: {
                                    paddingBottom: 1
                                },
                                children: [
                                    " ",
                                    "Streams*"
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                multiple: true,
                                options: cameraStreams.map((object)=>{
                                    return `${object.name} (${object.product})`;
                                }),
                                sx: {
                                    width: 400
                                },
                                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        ...params
                                    }),
                                onChange: (event, value)=>{
                                    setSelectedStreamNames(value);
                                }
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "patriot_server",
                        variant: "standard",
                        label: "Patriot Server",
                        defaultValue: patriotAlerts[0] ? patriotAlerts[0].patriot_server : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    patriot_server: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "patriot_client_no",
                        variant: "standard",
                        label: "Patriot client no",
                        defaultValue: patriotAlerts[0] ? patriotAlerts[0].patriot_client_no : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    patriot_client_no: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "patriot_username",
                        variant: "standard",
                        label: "Patriot username",
                        defaultValue: patriotAlerts[0] ? patriotAlerts[0].patriot_username : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    patriot_username: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "patriot_password",
                        variant: "standard",
                        label: "Patriot password",
                        defaultValue: patriotAlerts[0] ? patriotAlerts[0].patriot_password : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    patriot_password: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "patriot_zone_number",
                        variant: "standard",
                        label: "Patriot zone number",
                        defaultValue: patriotAlerts[0] ? patriotAlerts[0].patriot_zone_number : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    patriot_zone_number: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "patriot_type_number",
                        variant: "standard",
                        label: "Patriot type number",
                        defaultValue: patriotAlerts[0] ? patriotAlerts[0].patriot_type_number : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    patriot_type_number: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $hG03Q.PatriotDeliveryChoice), {
                        name: "add-patriot-alert-delivery",
                        sendVideo: postObject.patriot_send_video,
                        drawIgnoreZones: postObject.draw_ignore_zones,
                        onChange: (values)=>{
                            setPostObject((previousState)=>({
                                    ...previousState,
                                    ...values
                                }));
                        }
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $7txAP.PatriotDeliverySummary), {
                        sendVideo: postObject.patriot_send_video,
                        drawIgnoreZones: postObject.draw_ignore_zones
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setAddPatriotAlertDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            const selectedStreamIndexs = [];
                            const streamsObjectToPost = JSON.parse(JSON.stringify(cameraStreamsPatchObject));
                            if (cameraStreams && cameraStreams.length > 1) {
                                selectedStreamNames.forEach((streamName)=>{
                                    selectedStreamIndexs.push(streamNames.get(streamName));
                                });
                                selectedStreamIndexs.forEach((streamIndex)=>{
                                    if (streamsObjectToPost[streamIndex]) streamsObjectToPost[streamIndex].patriot_alerts = [
                                        ...streamsObjectToPost[streamIndex].patriot_alerts,
                                        postObject
                                    ];
                                });
                            }
                            if (cameraStreams && cameraStreams.length === 1) streamsObjectToPost[0].patriot_alerts.push(postObject);
                            setAddPatriotAlertDialogOpen(false);
                            setBackdropLoadingScreenOn(true);
                            (0, $1BQwf.handleSubmitNewPatriotAlert)(cameraGeneralInfo, patriotAlerts, streamsObjectToPost, navigate, setBackdropLoadingScreenOn, setCameraGeneralInfo, setCameraGeneralInfoBackup, setGeneralInfoChangesMade, setPatchObject, setPatriotAlerts, setActiveTab, setAddPatriotAlertDialogOpen, cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, immixAlerts, setAddImmixAlertDialogOpen, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen, sureviewAlerts, setAddSureviewAlertDialogOpen, cameraWebhookData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, sentinelAlerts, setAddSentinelAlertDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, immixAlertsOnCamera, sureViewAlertsOnCamera, siteInfo, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera);
                        },
                        text: "Submit",
                        disabled: false
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("1BQwf", function(module, exports) {

$parcel$export(module.exports, "handleSubmitNewPatriotAlert", () => $dcc0fe62ea192852$export$b0736c165e7cf39);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $815yO = parcelRequire("815yO");

var $lukvk = parcelRequire("lukvk");

var $h0DCc = parcelRequire("h0DCc");

var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");

var $4wo2Y = parcelRequire("4wo2Y");

var $dWhHk = parcelRequire("dWhHk");

var $aZxZ3 = parcelRequire("aZxZ3");
const $dcc0fe62ea192852$export$b0736c165e7cf39 = async (cameraGeneralInfo, patriotAlerts, postObject, navigate, setBackdropLoadingScreenOn, setCameraGeneralInfo, setCameraGeneralInfoBackup, setGeneralInfoChangesMade, setPatchObject, setPatriotAlerts, setActiveTab, setAddPatriotAlertDialogOpen, cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, immixAlerts, setAddImmixAlertDialogOpen, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen, sureviewAlerts, setAddSureviewAlertDialogOpen, cameraWebhookData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, sentinelAlerts, setAddSentinelAlertDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, immixAlertsOnCamera, sureViewAlertsOnCamera, siteInfo, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $dcc0fe62ea192852$export$b0736c165e7cf39(cameraGeneralInfo, patriotAlerts, postObject, navigate, setBackdropLoadingScreenOn, setCameraGeneralInfo, setCameraGeneralInfoBackup, setGeneralInfoChangesMade, setPatchObject, setPatriotAlerts, setActiveTab, setAddPatriotAlertDialogOpen, cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, immixAlerts, setAddImmixAlertDialogOpen, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen, sureviewAlerts, setAddSureviewAlertDialogOpen, cameraWebhookData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, sentinelAlerts, setAddSentinelAlertDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, immixAlertsOnCamera, sureViewAlertsOnCamera, siteInfo, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera);
    };
    let postPatchObjectFail = false;
    let getSiteCamerasFail = false;
    const { setCameraStreamsPatchObject: setCameraStreamsPatchObject, setCameraStreamsObject: setCameraStreamsObject } = (0, $aZxZ3.useEditCameraStore).getState();
    await AxiosUI.patch(`/camera/${(0, $a8BPe.getNumbersAfterEditCamera)(location.href)}/general_info/`, {
        streams: postObject
    }).then((response)=>{
        postPatchObjectFail = false;
        (0, $815yO.markSiteUnsynced)();
        setCameraGeneralInfo(response.data);
        setCameraGeneralInfoBackup(response.data);
        setCameraStreamsPatchObject(response.data.streams);
        setCameraStreamsObject(response.data.streams);
        const pushedArray = [];
        response.data.streams[0].patriot_alerts.forEach((alertObject)=>{
            pushedArray.push(alertObject);
        });
        setPatriotAlerts(pushedArray);
        setGeneralInfoChangesMade(false);
        setPatchObject({});
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dWhHk.AlertSettingsTab), {
                immixAlerts: immixAlerts,
                setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                setSendingImmixTest: setSendingImmixTest,
                setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                sureviewAlerts: sureviewAlerts,
                setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                sentinelAlerts: sentinelAlerts,
                setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                boldAlerts: boldAlerts,
                setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                patriotAlerts: pushedArray,
                setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                softguardAlerts: softguardAlerts,
                setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                immixAlertsOnCamera: immixAlertsOnCamera,
                sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                siteInfo: siteInfo,
                webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                boldAlertsOnCamera: boldAlertsOnCamera,
                patriotAlertsOnCamera: patriotAlertsOnCamera,
                softguardAlertsOnCamera: softguardAlertsOnCamera,
                evalinkAlertsOnCamera: evalinkAlertsOnCamera,
                navigate: navigate
            })
        }));
        setBackdropLoadingScreenOn(false);
    }, (reason)=>{
        postPatchObjectFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setCameraGeneralInfo(cameraGeneralInfoBackup);
            setPatchObject({
                camera_name: cameraGeneralInfoBackup.camera_name,
                streams: cameraGeneralInfoBackup.streams
            });
            setBackdropLoadingScreenOn(false);
        });
    });
    !postPatchObjectFail && await AxiosUI.get(`camera/site/?customer__id=${(0, $a8BPe.getNumbersAfterSites)(location.href)}`).then((response)=>{
        getSiteCamerasFail = false;
        localStorage.setItem("siteCameras", JSON.stringify(response.data));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            getSiteCamerasFail = true;
        });
    });
    !postPatchObjectFail && !getSiteCamerasFail && await AxiosUI.get(`customer/${(0, $a8BPe.getNumbersAfterSites)(location.href)}/about/`).then((response)=>{
        localStorage.setItem("siteInfo", JSON.stringify(response.data));
        localStorage.setItem("integrationType", response.data.integration_type);
        setIgnoreZonesBreadCrumbs(/*#__PURE__*/ (0, $k4ank.jsx)((0, $lukvk.IgnoreZonesBreadCrumbs), {
            linksArray: (0, $h0DCc.createIgnoreZonesLinksArray)(response.data.breadcrumbs),
            handleSitesBreadcrumbClick: handleSitesBreadcrumbClick,
            handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick,
            styling: "absolute top-[10px] left-[30px]"
        }));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
        });
    });
};

});


parcelRegister("7R3rw", function(module, exports) {

$parcel$export(module.exports, "AddUSMonitoringAlertDialog", () => $6f5780663f0ea43b$export$66995c26520a1f20);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $eejVe = parcelRequire("eejVe");

var $fjema = parcelRequire("fjema");
const $6f5780663f0ea43b$export$66995c26520a1f20 = ({ setAddUSMonitoringAlertDialogOpen: setAddUSMonitoringAlertDialogOpen, addUSMonitoringAlertDialogOpen: addUSMonitoringAlertDialogOpen, uSMonitoringAlerts: uSMonitoringAlerts, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setCameraGeneralInfo: setCameraGeneralInfo, setCameraGeneralInfoBackup: setCameraGeneralInfoBackup, setGeneralInfoChangesMade: setGeneralInfoChangesMade, setPatchObject: setPatchObject, setUSMonitoringAlerts: setUSMonitoringAlerts, setActiveTab: setActiveTab, cameraGeneralInfoBackup: cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs: setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick: handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick, cameraGeneralInfo: cameraGeneralInfo })=>{
    const navigate = (0, $3T949.useNavigate)();
    const [postObject, setPostObject] = $8T3gX.useState({
        id: -1,
        us_monitoring_cid: "",
        us_monitoring_zone: ""
    });
    $8T3gX.useEffect(()=>{
        if (uSMonitoringAlerts[0]) setPostObject({
            id: -1,
            us_monitoring_cid: uSMonitoringAlerts[0].us_monitoring_cid,
            us_monitoring_zone: uSMonitoringAlerts[0].us_monitoring_zone
        });
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: addUSMonitoringAlertDialogOpen,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: "Add US Monitoring Alert"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "us_monitoring_cid",
                        variant: "standard",
                        label: "US Monitoring CID",
                        defaultValue: uSMonitoringAlerts[0] ? uSMonitoringAlerts[0].us_monitoring_cid : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    us_monitoring_cid: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "us_monitoring_zone",
                        variant: "standard",
                        label: "US Monitoring Zone",
                        defaultValue: uSMonitoringAlerts[0] ? uSMonitoringAlerts[0].us_monitoring_zone : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    us_monitoring_zone: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        type: "string"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setAddUSMonitoringAlertDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setAddUSMonitoringAlertDialogOpen(false);
                            setBackdropLoadingScreenOn(true);
                            (0, $fjema.handleSubmitNewUSMonitoringAlert)(cameraGeneralInfo, uSMonitoringAlerts, postObject, navigate, setBackdropLoadingScreenOn, setCameraGeneralInfo, setCameraGeneralInfoBackup, setGeneralInfoChangesMade, setPatchObject, setUSMonitoringAlerts, setActiveTab, setAddUSMonitoringAlertDialogOpen, cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick);
                        },
                        text: "Submit",
                        disabled: false
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("fjema", function(module, exports) {

$parcel$export(module.exports, "handleSubmitNewUSMonitoringAlert", () => $e4dff5a558c92fbd$export$feee1b7c03083ba);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $815yO = parcelRequire("815yO");

var $lukvk = parcelRequire("lukvk");

var $h0DCc = parcelRequire("h0DCc");

var $3Zv1D = parcelRequire("3Zv1D");

var $fcdwp = parcelRequire("fcdwp");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");
const $e4dff5a558c92fbd$export$feee1b7c03083ba = async (cameraGeneralInfo, uSMonitoringAlerts, postObject, navigate, setBackdropLoadingScreenOn, setCameraGeneralInfo, setCameraGeneralInfoBackup, setGeneralInfoChangesMade, setPatchObject, setUSMonitoringAlerts, setActiveTab, setAddUSMonitoringAlertDialogOpen, cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $e4dff5a558c92fbd$export$feee1b7c03083ba(cameraGeneralInfo, uSMonitoringAlerts, postObject, navigate, setBackdropLoadingScreenOn, setCameraGeneralInfo, setCameraGeneralInfoBackup, setGeneralInfoChangesMade, setPatchObject, setUSMonitoringAlerts, setActiveTab, setAddUSMonitoringAlertDialogOpen, cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick);
    };
    const createNewStreamsObject = (streams)=>{
        const updatedStreams = streams;
        updatedStreams.forEach((object, index)=>{
            const updatedUSMonitoringAlerts = object?.us_monitoring_alerts ? object.us_monitoring_alerts : [];
            updatedUSMonitoringAlerts.push(postObject);
            updatedStreams[index].us_monitoring_alerts = updatedUSMonitoringAlerts;
        });
        return updatedStreams;
    };
    let postPatchObjectFail = false;
    let getSiteCamerasFail = false;
    await AxiosUI.patch(`/camera/${(0, $a8BPe.getNumbersAfterEditCamera)(location.href)}/general_info/`, {
        streams: createNewStreamsObject(cameraGeneralInfo.streams)
    }).then((response)=>{
        postPatchObjectFail = false;
        (0, $815yO.markSiteUnsynced)();
        setCameraGeneralInfo(response.data);
        setCameraGeneralInfoBackup(response.data);
        const pushedArray = [];
        response.data.streams[0].us_monitoring_alerts.forEach((alertObject)=>{
            pushedArray.push(alertObject);
        });
        setUSMonitoringAlerts(pushedArray);
        setGeneralInfoChangesMade(false);
        setPatchObject({});
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $fcdwp.USMonitoringAlertsTab), {
            uSMonitoringAlerts: pushedArray,
            setAddUSMonitoringAlertDialogOpen: setAddUSMonitoringAlertDialogOpen
        }));
        setBackdropLoadingScreenOn(false);
    }, (reason)=>{
        postPatchObjectFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setCameraGeneralInfo(cameraGeneralInfoBackup);
            setPatchObject({
                camera_name: cameraGeneralInfoBackup.camera_name,
                streams: cameraGeneralInfoBackup.streams
            });
            setBackdropLoadingScreenOn(false);
        });
    });
    !postPatchObjectFail && await AxiosUI.get(`camera/site/?customer__id=${(0, $a8BPe.getNumbersAfterSites)(location.href)}`).then((response)=>{
        getSiteCamerasFail = false;
        localStorage.setItem("siteCameras", JSON.stringify(response.data));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            getSiteCamerasFail = true;
        });
    });
    !postPatchObjectFail && !getSiteCamerasFail && await AxiosUI.get(`customer/${(0, $a8BPe.getNumbersAfterSites)(location.href)}/about/`).then((response)=>{
        localStorage.setItem("siteInfo", JSON.stringify(response.data));
        localStorage.setItem("integrationType", response.data.integration_type);
        setIgnoreZonesBreadCrumbs(/*#__PURE__*/ (0, $k4ank.jsx)((0, $lukvk.IgnoreZonesBreadCrumbs), {
            linksArray: (0, $h0DCc.createIgnoreZonesLinksArray)(response.data.breadcrumbs),
            handleSitesBreadcrumbClick: handleSitesBreadcrumbClick,
            handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick,
            styling: "absolute top-[10px] left-[30px]"
        }));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
        });
    });
};

});
parcelRegister("fcdwp", function(module, exports) {

$parcel$export(module.exports, "USMonitoringAlertsTab", () => $3dd1facf28cb520f$export$f7589f082afb4879);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $f3puC = parcelRequire("f3puC");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $8jTCz = parcelRequire("8jTCz");
const $3dd1facf28cb520f$export$f7589f082afb4879 = ({ uSMonitoringAlerts: uSMonitoringAlerts, setAddUSMonitoringAlertDialogOpen: setAddUSMonitoringAlertDialogOpen })=>{
    const userInfo = JSON.parse(localStorage.userInfo);
    const permissions = userInfo.permission;
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "relative w-full min-w-[1150px]",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "min-w-[1150px] h-[50px] bg-white",
                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "absolute right-[70px] top-[10px]",
                    children: permissions.edit_cameras && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setAddUSMonitoringAlertDialogOpen(true);
                        },
                        text: "+ Add US Monitoring Alert",
                        disabled: false
                    })
                })
            }),
            uSMonitoringAlerts[0] && uSMonitoringAlerts.map((object, index)=>{
                return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "h-[160px]",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "min-w-[1150px] h-[50px] pt-[10px] bg-white",
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                variant: "h6",
                                gutterBottom: true,
                                component: "div",
                                sx: {
                                    fontFamily: "Mulish",
                                    fontWeight: "Bold",
                                    color: "black",
                                    textIndent: "1vw"
                                },
                                children: [
                                    "US Monitoring Alert ",
                                    index + 1
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                component: (0, $4reBM.default),
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                    sx: {
                                        minWidth: 1000,
                                        fontFamily: "Mulish"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                            titlesArray: [
                                                "US Monitoring CID",
                                                "US Monitoring Zone"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish"
                                                        },
                                                        children: object.us_monitoring_cid ? object.us_monitoring_cid : "--"
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish"
                                                        },
                                                        children: object.us_monitoring_zone ? object.us_monitoring_zone : "--"
                                                    })
                                                ]
                                            }, object.id)
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }, object.id);
            })
        ]
    });
};

});



parcelRegister("4M4T1", function(module, exports) {

$parcel$export(module.exports, "AddSoftguardAlertDialog", () => $0c3497bbb54dfe9d$export$af7bca435f904c67);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");

var $lk6eW = parcelRequire("lk6eW");

var $9fhzn = parcelRequire("9fhzn");

var $aZxZ3 = parcelRequire("aZxZ3");
const $0c3497bbb54dfe9d$export$af7bca435f904c67 = ({ setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen, addSoftguardAlertDialogOpen: addSoftguardAlertDialogOpen, softguardAlerts: softguardAlerts, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setCameraGeneralInfo: setCameraGeneralInfo, setCameraGeneralInfoBackup: setCameraGeneralInfoBackup, setGeneralInfoChangesMade: setGeneralInfoChangesMade, setPatchObject: setPatchObject, setSoftguardAlerts: setSoftguardAlerts, setActiveTab: setActiveTab, cameraGeneralInfoBackup: cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs: setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick: handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick, cameraGeneralInfo: cameraGeneralInfo, immixAlerts: immixAlerts, setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen, setSendingImmixTest: setSendingImmixTest, setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen: setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen, sureviewAlerts: sureviewAlerts, setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen, cameraWebhookData: cameraWebhookData, setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen, sentinelAlerts: sentinelAlerts, setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen, boldAlerts: boldAlerts, setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen, patriotAlerts: patriotAlerts, setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen, immixAlertsOnCamera: immixAlertsOnCamera, sureViewAlertsOnCamera: sureViewAlertsOnCamera, siteInfo: siteInfo, webhooksAlertsOnCamera: webhooksAlertsOnCamera, sentinelAlertsOnCamera: sentinelAlertsOnCamera, boldAlertsOnCamera: boldAlertsOnCamera, patriotAlertsOnCamera: patriotAlertsOnCamera, softguardAlertsOnCamera: softguardAlertsOnCamera, evalinkAlertsOnCamera: evalinkAlertsOnCamera })=>{
    const { cameraStreams: cameraStreams, cameraStreamsPatchObject: cameraStreamsPatchObject } = (0, $aZxZ3.useEditCameraStore)();
    const streamNames = new Map();
    cameraStreams?.forEach((object, index)=>{
        streamNames.set(`${object.name} (${object.product})`, index);
    });
    const navigate = (0, $3T949.useNavigate)();
    const [errorMode, setErrorMode] = $8T3gX.useState(false);
    const [postObject, setPostObject] = $8T3gX.useState({
        id: -1,
        server: "",
        port: "",
        zone: "",
        account: "",
        user: "",
        user_ext: ""
    });
    const [selectedStreamNames, setSelectedStreamNames] = $8T3gX.useState([]);
    $8T3gX.useEffect(()=>{
        if (softguardAlerts[0]) setPostObject({
            id: -1,
            server: softguardAlerts[0].server,
            port: softguardAlerts[0].port,
            zone: softguardAlerts[0].zone,
            account: softguardAlerts[0].account,
            user: softguardAlerts[0].user,
            user_ext: softguardAlerts[0].user_ext
        });
    }, []);
    $8T3gX.useEffect(()=>{
        if (postObject.server.length === 0 || postObject.port.length === 0 || postObject.zone.length === 0 || postObject.account.length === 0 || postObject.user.length === 0 || postObject.user_ext.length === 0 || postObject.server.length > 100 || postObject.port.length > 100 || postObject.zone.length > 3 || postObject.account.length > 8 || postObject.user.length > 3 || postObject.user_ext.length > 100) setErrorMode(true);
        else setErrorMode(false);
    }, [
        postObject
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: addSoftguardAlertDialogOpen,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: "Add Softguard Alert"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                children: [
                    cameraStreams && cameraStreams.length > 1 && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $lk6eW.default), {
                                component: "legend",
                                sx: {
                                    paddingBottom: 1
                                },
                                children: [
                                    " ",
                                    "Streams*"
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                multiple: true,
                                options: cameraStreams.map((object)=>{
                                    return `${object.name} (${object.product})`;
                                }),
                                sx: {
                                    width: 400
                                },
                                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        ...params
                                    }),
                                onChange: (event, value)=>{
                                    setSelectedStreamNames(value);
                                }
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "server",
                        variant: "standard",
                        label: "Server",
                        defaultValue: softguardAlerts[0] ? softguardAlerts[0].server : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    server: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        error: postObject.server.length === 0 || postObject.server.length > 100,
                        helperText: postObject.server.length === 0 || postObject.server.length > 100 ? postObject.server.length === 0 ? "Server cannot be empty" : "Server cannot be longer than 100 characters" : "",
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "port",
                        variant: "standard",
                        label: "Port",
                        defaultValue: softguardAlerts[0] ? softguardAlerts[0].port : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    port: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        error: postObject.port.length === 0 || postObject.port.length > 100,
                        helperText: postObject.port.length === 0 || postObject.port.length > 100 ? postObject.port.length === 0 ? "Port cannot be empty" : "Port cannot be longer than 100 characters" : "",
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "zone",
                        variant: "standard",
                        label: "Zone",
                        defaultValue: softguardAlerts[0] ? softguardAlerts[0].zone : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    zone: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        error: postObject.zone.length === 0 || postObject.zone.length > 3,
                        helperText: postObject.zone.length === 0 || postObject.zone.length > 3 ? postObject.zone.length === 0 ? "Zone cannot be empty" : "Zone cannot be longer than 3 characters" : "",
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "account",
                        variant: "standard",
                        label: "Account",
                        defaultValue: softguardAlerts[0] ? softguardAlerts[0].account : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    account: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        error: postObject.account.length === 0 || postObject.account.length > 8,
                        helperText: postObject.account.length === 0 || postObject.account.length > 8 ? postObject.account.length === 0 ? "Account cannot be empty" : "Account cannot be longer than 8 characters" : "",
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "user",
                        variant: "standard",
                        label: "User",
                        defaultValue: softguardAlerts[0] ? softguardAlerts[0].user : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    user: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        error: postObject.user.length === 0 || postObject.user.length > 3,
                        helperText: postObject.user.length === 0 || postObject.user.length > 3 ? postObject.user.length === 0 ? "User cannot be empty" : "User cannot  be longer than 3 characters" : "",
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "user_ext",
                        variant: "standard",
                        label: "User Ext",
                        defaultValue: softguardAlerts[0] ? softguardAlerts[0].user_ext : "",
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    user_ext: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        error: postObject.user_ext.length === 0 || postObject.user_ext.length > 100,
                        helperText: postObject.user_ext.length === 0 || postObject.user_ext.length > 100 ? postObject.user_ext.length === 0 ? "User Ext cannot be empty" : "User Ext cannot be longer than 100 characters" : "",
                        type: "string"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setAddSoftguardAlertDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            const selectedStreamIndexs = [];
                            const streamsObjectToPost = JSON.parse(JSON.stringify(cameraStreamsPatchObject));
                            if (cameraStreams && cameraStreams.length > 1) {
                                selectedStreamNames.forEach((streamName)=>{
                                    selectedStreamIndexs.push(streamNames.get(streamName));
                                });
                                selectedStreamIndexs.forEach((streamIndex)=>{
                                    if (streamsObjectToPost[streamIndex]) streamsObjectToPost[streamIndex].softguard_alerts = [
                                        ...streamsObjectToPost[streamIndex].softguard_alerts,
                                        postObject
                                    ];
                                });
                            }
                            if (cameraStreams && cameraStreams.length === 1) streamsObjectToPost[0].softguard_alerts.push(postObject);
                            setAddSoftguardAlertDialogOpen(false);
                            setBackdropLoadingScreenOn(true);
                            (0, $9fhzn.handleSubmitNewSoftguardAlert)(cameraGeneralInfo, softguardAlerts, streamsObjectToPost, navigate, setBackdropLoadingScreenOn, setCameraGeneralInfo, setCameraGeneralInfoBackup, setGeneralInfoChangesMade, setPatchObject, setSoftguardAlerts, setActiveTab, setAddSoftguardAlertDialogOpen, cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, immixAlerts, setAddImmixAlertDialogOpen, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen, sureviewAlerts, setAddSureviewAlertDialogOpen, cameraWebhookData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, sentinelAlerts, setAddSentinelAlertDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, immixAlertsOnCamera, sureViewAlertsOnCamera, siteInfo, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera);
                        },
                        text: "Submit",
                        disabled: errorMode
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("9fhzn", function(module, exports) {

$parcel$export(module.exports, "handleSubmitNewSoftguardAlert", () => $a71d18f264baa309$export$22ed9a1e6ec49218);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $815yO = parcelRequire("815yO");

var $lukvk = parcelRequire("lukvk");

var $h0DCc = parcelRequire("h0DCc");

var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");

var $4wo2Y = parcelRequire("4wo2Y");

var $dWhHk = parcelRequire("dWhHk");

var $aZxZ3 = parcelRequire("aZxZ3");
const $a71d18f264baa309$export$22ed9a1e6ec49218 = async (cameraGeneralInfo, softguardAlerts, postObject, navigate, setBackdropLoadingScreenOn, setCameraGeneralInfo, setCameraGeneralInfoBackup, setGeneralInfoChangesMade, setPatchObject, setSoftguardAlerts, setActiveTab, setAddSoftguardAlertDialogOpen, cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, immixAlerts, setAddImmixAlertDialogOpen, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen, sureviewAlerts, setAddSureviewAlertDialogOpen, cameraWebhookData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, sentinelAlerts, setAddSentinelAlertDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, immixAlertsOnCamera, sureViewAlertsOnCamera, siteInfo, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $a71d18f264baa309$export$22ed9a1e6ec49218(cameraGeneralInfo, softguardAlerts, postObject, navigate, setBackdropLoadingScreenOn, setCameraGeneralInfo, setCameraGeneralInfoBackup, setGeneralInfoChangesMade, setPatchObject, setSoftguardAlerts, setActiveTab, setAddSoftguardAlertDialogOpen, cameraGeneralInfoBackup, setIgnoreZonesBreadCrumbs, handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick, immixAlerts, setAddImmixAlertDialogOpen, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen, sureviewAlerts, setAddSureviewAlertDialogOpen, cameraWebhookData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, sentinelAlerts, setAddSentinelAlertDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, immixAlertsOnCamera, sureViewAlertsOnCamera, siteInfo, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera);
    };
    let postPatchObjectFail = false;
    let getSiteCamerasFail = false;
    const { setCameraStreamsPatchObject: setCameraStreamsPatchObject, setCameraStreamsObject: setCameraStreamsObject } = (0, $aZxZ3.useEditCameraStore).getState();
    await AxiosUI.patch(`/camera/${(0, $a8BPe.getNumbersAfterEditCamera)(location.href)}/general_info/`, {
        streams: postObject
    }).then((response)=>{
        postPatchObjectFail = false;
        (0, $815yO.markSiteUnsynced)();
        setCameraGeneralInfo(response.data);
        setCameraGeneralInfoBackup(response.data);
        setCameraStreamsPatchObject(response.data.streams);
        setCameraStreamsObject(response.data.streams);
        const pushedArray = [];
        response.data.streams[0].softguard_alerts.forEach((alertObject)=>{
            pushedArray.push(alertObject);
        });
        setSoftguardAlerts(pushedArray);
        setGeneralInfoChangesMade(false);
        setPatchObject({});
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dWhHk.AlertSettingsTab), {
                immixAlerts: immixAlerts,
                setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                setSendingImmixTest: setSendingImmixTest,
                setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                sureviewAlerts: sureviewAlerts,
                setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                sentinelAlerts: sentinelAlerts,
                setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                boldAlerts: boldAlerts,
                setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                patriotAlerts: patriotAlerts,
                setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                softguardAlerts: pushedArray,
                setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                immixAlertsOnCamera: immixAlertsOnCamera,
                sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                siteInfo: siteInfo,
                webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                boldAlertsOnCamera: boldAlertsOnCamera,
                patriotAlertsOnCamera: patriotAlertsOnCamera,
                softguardAlertsOnCamera: softguardAlertsOnCamera,
                evalinkAlertsOnCamera: evalinkAlertsOnCamera,
                navigate: navigate
            })
        }));
        setBackdropLoadingScreenOn(false);
    }, (reason)=>{
        postPatchObjectFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setCameraGeneralInfo(cameraGeneralInfoBackup);
            setPatchObject({
                camera_name: cameraGeneralInfoBackup.camera_name,
                streams: cameraGeneralInfoBackup.streams
            });
            alert(`Failed to add new Softguard Alert. Please try again.`);
            setBackdropLoadingScreenOn(false);
        });
    });
    !postPatchObjectFail && await AxiosUI.get(`camera/site/?customer__id=${(0, $a8BPe.getNumbersAfterSites)(location.href)}`).then((response)=>{
        getSiteCamerasFail = false;
        localStorage.setItem("siteCameras", JSON.stringify(response.data));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            getSiteCamerasFail = true;
        });
    });
    !postPatchObjectFail && !getSiteCamerasFail && await AxiosUI.get(`customer/${(0, $a8BPe.getNumbersAfterSites)(location.href)}/about/`).then((response)=>{
        localStorage.setItem("siteInfo", JSON.stringify(response.data));
        localStorage.setItem("integrationType", response.data.integration_type);
        setIgnoreZonesBreadCrumbs(/*#__PURE__*/ (0, $k4ank.jsx)((0, $lukvk.IgnoreZonesBreadCrumbs), {
            linksArray: (0, $h0DCc.createIgnoreZonesLinksArray)(response.data.breadcrumbs),
            handleSitesBreadcrumbClick: handleSitesBreadcrumbClick,
            handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick,
            styling: "absolute top-[10px] left-[30px]"
        }));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
        });
    });
};

});


parcelRegister("dDwzT", function(module, exports) {

$parcel$export(module.exports, "AddStreamWebhookDialog", () => $d2c60a85d87f7bbb$export$48e26763a6a6d925);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $b1uoD = parcelRequire("b1uoD");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");
var $f3puC = parcelRequire("f3puC");

var $5FAJk = parcelRequire("5FAJk");

var $a8BPe = parcelRequire("a8BPe");

var $eDfvp = parcelRequire("eDfvp");

var $lk6eW = parcelRequire("lk6eW");

var $7UDCh = parcelRequire("7UDCh");

var $2SHRA = parcelRequire("2SHRA");

var $3baw3 = parcelRequire("3baw3");

var $kbChx = parcelRequire("kbChx");

var $aZxZ3 = parcelRequire("aZxZ3");
const $d2c60a85d87f7bbb$export$48e26763a6a6d925 = ({ setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen, addStreamWebhookDialogOpen: addStreamWebhookDialogOpen, cameraGeneralInfo: cameraGeneralInfo })=>{
    const { setBackdropLoadingScreenEditCameraOn: setBackdropLoadingScreenEditCameraOn, handleSubmitNewStreamWebhook: handleSubmitNewStreamWebhook, cameraStreams: cameraStreams } = (0, $aZxZ3.useEditCameraStore)();
    const navigate = (0, $3T949.useNavigate)();
    const [postObject, setPostObject] = $8T3gX.useState({
        webhook: null,
        streams: [],
        custom_fields: "{}",
        event_types: []
    });
    const [errorState, setErrorState] = $8T3gX.useState({
        webhook: true,
        custom_fields: false
    });
    const [customerWebhooks, setCustomerWebhooks] = $8T3gX.useState([]);
    const [webhooksLoaded, setWebhooksLoaded] = $8T3gX.useState(false);
    const webHookEventTypeOptions = JSON.parse(localStorage.webHookEventTypeOptions);
    const webHookEventTypeNames = new Map();
    webHookEventTypeOptions.forEach((option)=>{
        webHookEventTypeNames.set(option.name, option.id);
    });
    const streamNames = new Map();
    cameraStreams?.forEach((stream)=>{
        streamNames.set(`${stream.name} (${stream.product})`, stream.id);
    });
    $8T3gX.useEffect(()=>{
        (0, $5FAJk.getCustomerWebhooks)(navigate, setCustomerWebhooks, ()=>setWebhooksLoaded(true));
    }, []);
    $8T3gX.useEffect(()=>{
        if (cameraStreams && cameraStreams.length === 1) setPostObject((previousState)=>{
            return {
                ...previousState,
                streams: [
                    cameraStreams[0].id
                ]
            };
        });
    }, [
        customerWebhooks
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: addStreamWebhookDialogOpen,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                sx: {
                    textAlign: "center"
                },
                children: [
                    "Add Stream Webhook",
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $lk6eW.default), {
                        component: "legend",
                        sx: {
                            paddingBottom: 1
                        },
                        children: [
                            " ",
                            "Webhook*"
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                        id: "webhook",
                        options: customerWebhooks,
                        getOptionLabel: (option)=>option?.display_name ?? "",
                        isOptionEqualToValue: (option, value)=>option?.id === value?.id,
                        sx: {
                            width: 400
                        },
                        renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                ...params,
                                inputProps: {
                                    ...params.inputProps,
                                    "aria-label": "Webhook"
                                }
                            }),
                        onChange: (event, value)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    webhook: value ? value.id : null
                                };
                            });
                            setErrorState((previousState)=>{
                                return {
                                    ...previousState,
                                    webhook: value === null
                                };
                            });
                        }
                    }),
                    webhooksLoaded && customerWebhooks.length === 0 && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                        variant: "body2",
                        sx: {
                            mt: 1,
                            color: "#283E6D"
                        },
                        "data-testid": "no-site-webhooks",
                        children: [
                            "This site has no webhooks yet. Add one on the site's",
                            " ",
                            /*#__PURE__*/ (0, $k4ank.jsx)("a", {
                                href: `/sites/aboutsite/${(0, $a8BPe.getNumbersAfterSites)(location.href)}`,
                                onClick: (event)=>{
                                    event.preventDefault();
                                    navigate(`/sites/aboutsite/${(0, $a8BPe.getNumbersAfterSites)(location.href)}`);
                                },
                                style: {
                                    color: "#1976d2",
                                    textDecoration: "none"
                                },
                                children: "Webhooks tab"
                            }),
                            ", then come back to attach it to this camera."
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    cameraStreams && cameraStreams.length > 1 && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $lk6eW.default), {
                                component: "legend",
                                sx: {
                                    paddingBottom: 1
                                },
                                children: [
                                    " ",
                                    "Streams*"
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                id: "streams",
                                multiple: true,
                                options: cameraStreams.map((object)=>{
                                    return `${object.name} (${object.product})`;
                                }),
                                sx: {
                                    width: 400
                                },
                                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        ...params
                                    }),
                                onChange: (event, value)=>{
                                    setPostObject((previousState)=>{
                                        return {
                                            ...previousState,
                                            streams: value.map((object)=>{
                                                return streamNames.get(object);
                                            })
                                        };
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                        sx: {
                            display: "flex"
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                            variant: "standard",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $lk6eW.default), {
                                    component: "legend",
                                    children: "Event Types"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $2SHRA.default), {
                                    children: webHookEventTypeOptions.map((option)=>{
                                        return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                            control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                onChange: (event)=>{
                                                    if (event.target.checked) setPostObject((previousState)=>{
                                                        return {
                                                            ...previousState,
                                                            event_types: [
                                                                ...previousState.event_types,
                                                                webHookEventTypeNames.get(option.name)
                                                            ]
                                                        };
                                                    });
                                                    else setPostObject((previousState)=>{
                                                        return {
                                                            ...previousState,
                                                            event_types: previousState.event_types.filter((eventType)=>eventType !== webHookEventTypeNames.get(option.name))
                                                        };
                                                    });
                                                },
                                                name: option.name
                                            }),
                                            label: option.name
                                        }, option.name);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $lk6eW.default), {
                        component: "legend",
                        sx: {
                            paddingBottom: 1
                        },
                        children: [
                            " ",
                            "Custom Fields"
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                sx: {
                                    width: 550
                                },
                                multiline: true,
                                rows: 7,
                                value: postObject.custom_fields,
                                error: errorState.custom_fields,
                                onChange: (event)=>{
                                    const inputValue = event.target.value;
                                    // Update postObject with the current input value
                                    setPostObject((previousState)=>({
                                            ...previousState,
                                            custom_fields: inputValue
                                        }));
                                    // Validate JSON
                                    try {
                                        JSON.parse(inputValue);
                                        setErrorState((previousState)=>({
                                                ...previousState,
                                                custom_fields: false
                                            }));
                                    } catch (e) {
                                        setErrorState((previousState)=>({
                                                ...previousState,
                                                custom_fields: true
                                            }));
                                    }
                                },
                                helperText: errorState.custom_fields ? "Invalid JSON format. Ensure your input is a valid JSON object." : ""
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                variant: "caption",
                                sx: {
                                    mt: 1,
                                    display: "block"
                                },
                                children: [
                                    "Enter a valid JSON with custom fields that should be sent specifically for this camera. See formatting examples in our support page:",
                                    " ",
                                    /*#__PURE__*/ (0, $k4ank.jsx)("a", {
                                        href: (0, $b1uoD.getSupportUrl)("/admin_ui/webhooks/"),
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        style: {
                                            color: "#1976d2",
                                            textDecoration: "none"
                                        },
                                        children: "Webhooks"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $lk6eW.default), {
                        component: "legend",
                        children: " *Required"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setAddStreamWebhookDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            try {
                                const parsedCustomFields = JSON.parse(postObject.custom_fields);
                                // Prepare the postObject for API submission
                                const payload = {
                                    ...postObject,
                                    custom_fields: parsedCustomFields
                                };
                                setBackdropLoadingScreenEditCameraOn(true);
                                setAddStreamWebhookDialogOpen(false);
                                handleSubmitNewStreamWebhook(payload, navigate, cameraGeneralInfo.id);
                            } catch (error) {
                                alert("Invalid JSON, cannot submit.");
                            }
                        },
                        text: "Submit",
                        disabled: errorState.webhook || errorState.custom_fields || postObject.streams.length === 0
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("5FAJk", function(module, exports) {

$parcel$export(module.exports, "getCustomerWebhooks", () => $4e73a935999f480e$export$1117b3351ccd6e55);
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");

var $3Zv1D = parcelRequire("3Zv1D");
const $4e73a935999f480e$export$1117b3351ccd6e55 = (navigate, setCustomerWebhooks, onSettled)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $4e73a935999f480e$export$1117b3351ccd6e55(navigate, setCustomerWebhooks, onSettled);
    };
    AxiosUI.get(`webhook_customer/?customer=${(0, $a8BPe.getNumbersAfterSites)(location.href)}`).then((response)=>{
        setCustomerWebhooks(Array.isArray(response.data) ? response.data : []);
        onSettled?.();
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setCustomerWebhooks([]);
            onSettled?.();
        });
    });
};

});


parcelRegister("6aUtL", function(module, exports) {

$parcel$export(module.exports, "EditStreamWebhookDialog", () => $1762ba68f44ee013$export$1166734ae7932520);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $b1uoD = parcelRequire("b1uoD");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");
var $f3puC = parcelRequire("f3puC");

var $5FAJk = parcelRequire("5FAJk");

var $a8BPe = parcelRequire("a8BPe");

var $eDfvp = parcelRequire("eDfvp");

var $lk6eW = parcelRequire("lk6eW");

var $7UDCh = parcelRequire("7UDCh");

var $2SHRA = parcelRequire("2SHRA");

var $3baw3 = parcelRequire("3baw3");

var $kbChx = parcelRequire("kbChx");

var $aZxZ3 = parcelRequire("aZxZ3");
const $1762ba68f44ee013$export$1166734ae7932520 = ({ setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen, editStreamWebhookDialogOpen: editStreamWebhookDialogOpen })=>{
    const { handlePatchStreamWebhook: handlePatchStreamWebhook, setBackdropLoadingScreenEditCameraOn: setBackdropLoadingScreenEditCameraOn } = (0, $aZxZ3.useEditCameraStore)();
    const navigate = (0, $3T949.useNavigate)();
    const selectedWebhook = JSON.parse(localStorage.selectedWebhook);
    const webHookEventTypeOptions = JSON.parse(localStorage.webHookEventTypeOptions);
    const webHookEventTypeNames = new Map();
    webHookEventTypeOptions.forEach((option)=>{
        webHookEventTypeNames.set(option.name, option.id);
    });
    const webHookEventValues = new Map();
    webHookEventTypeOptions.forEach((option)=>{
        webHookEventValues.set(option.value, option.id);
    });
    const [postObject, setPostObject] = $8T3gX.useState({
        stream: selectedWebhook.stream.id,
        webhook: selectedWebhook.webhook.id,
        custom_fields: JSON.stringify(selectedWebhook.custom_fields, null, 2),
        event_types: []
    });
    const [errorState, setErrorState] = $8T3gX.useState({
        webhook: false,
        custom_fields: false
    });
    const [customerWebhooks, setCustomerWebhooks] = $8T3gX.useState([]);
    const [webhooksLoaded, setWebhooksLoaded] = $8T3gX.useState(false);
    $8T3gX.useEffect(()=>{
        (0, $5FAJk.getCustomerWebhooks)(navigate, setCustomerWebhooks, ()=>setWebhooksLoaded(true));
        const updatedEventTypes = [];
        selectedWebhook.event_types.forEach((eventType)=>{
            updatedEventTypes.push(webHookEventValues.get(eventType));
        });
        setPostObject((previousState)=>{
            return {
                ...previousState,
                event_types: updatedEventTypes
            };
        });
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: editStreamWebhookDialogOpen,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                sx: {
                    textAlign: "center"
                },
                children: [
                    "Edit Stream Webhook",
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $lk6eW.default), {
                        component: "legend",
                        sx: {
                            paddingBottom: 1
                        },
                        children: [
                            " ",
                            "Webhook*"
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                        id: "webhook",
                        options: customerWebhooks,
                        value: customerWebhooks.find((candidate)=>candidate.id === postObject.webhook) ?? (postObject.webhook === selectedWebhook.webhook.id ? selectedWebhook.webhook : null),
                        getOptionLabel: (option)=>option?.display_name ?? "",
                        isOptionEqualToValue: (option, value)=>option?.id === value?.id,
                        sx: {
                            width: 400
                        },
                        renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                ...params,
                                inputProps: {
                                    ...params.inputProps,
                                    "aria-label": "Webhook"
                                }
                            }),
                        onChange: (event, value)=>{
                            setErrorState((previousState)=>{
                                return {
                                    ...previousState,
                                    webhook: value === null
                                };
                            });
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    webhook: value ? value.id : null
                                };
                            });
                        }
                    }),
                    webhooksLoaded && customerWebhooks.length === 0 && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                        variant: "body2",
                        sx: {
                            mt: 1,
                            color: "#283E6D"
                        },
                        "data-testid": "no-site-webhooks",
                        children: [
                            "This site has no webhooks yet. Add one on the site's",
                            " ",
                            /*#__PURE__*/ (0, $k4ank.jsx)("a", {
                                href: `/sites/aboutsite/${(0, $a8BPe.getNumbersAfterSites)(location.href)}`,
                                onClick: (event)=>{
                                    event.preventDefault();
                                    navigate(`/sites/aboutsite/${(0, $a8BPe.getNumbersAfterSites)(location.href)}`);
                                },
                                style: {
                                    color: "#1976d2",
                                    textDecoration: "none"
                                },
                                children: "Webhooks tab"
                            }),
                            ", then come back to attach it to this camera."
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                        sx: {
                            display: "flex"
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                            variant: "standard",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $lk6eW.default), {
                                    component: "legend",
                                    children: "Event Types"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $2SHRA.default), {
                                    children: webHookEventTypeOptions.map((option)=>{
                                        return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                            control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                //set default checked if the selected webhook has the event type
                                                defaultChecked: selectedWebhook.event_types.includes(option.value),
                                                onChange: (event)=>{
                                                    if (event.target.checked) setPostObject((previousState)=>{
                                                        return {
                                                            ...previousState,
                                                            event_types: [
                                                                ...previousState.event_types,
                                                                webHookEventTypeNames.get(option.name)
                                                            ]
                                                        };
                                                    });
                                                    else setPostObject((previousState)=>{
                                                        return {
                                                            ...previousState,
                                                            event_types: previousState.event_types.filter((eventType)=>eventType !== webHookEventTypeNames.get(option.name))
                                                        };
                                                    });
                                                },
                                                name: option.name
                                            }),
                                            label: option.name
                                        }, option.name);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $lk6eW.default), {
                        component: "legend",
                        sx: {
                            paddingBottom: 1
                        },
                        children: [
                            " ",
                            "Custom Fields"
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                sx: {
                                    width: 550
                                },
                                multiline: true,
                                rows: 7,
                                value: postObject.custom_fields,
                                error: errorState.custom_fields,
                                defaultValue: JSON.stringify(selectedWebhook.custom_fields, null, 2),
                                onChange: (event)=>{
                                    const inputValue = event.target.value;
                                    // Update postObject with the current input value
                                    setPostObject((previousState)=>({
                                            ...previousState,
                                            custom_fields: inputValue
                                        }));
                                    // Validate JSON
                                    try {
                                        JSON.parse(inputValue);
                                        setErrorState((previousState)=>({
                                                ...previousState,
                                                custom_fields: false
                                            }));
                                    } catch (e) {
                                        setErrorState((previousState)=>({
                                                ...previousState,
                                                custom_fields: true
                                            }));
                                    }
                                },
                                helperText: errorState.custom_fields ? "Invalid JSON format. Ensure your input is a valid JSON object." : ""
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                variant: "caption",
                                sx: {
                                    mt: 1,
                                    display: "block"
                                },
                                children: [
                                    "Enter a valid JSON with custom fields that should be sent specifically for this camera. See formatting examples in our support page:",
                                    " ",
                                    /*#__PURE__*/ (0, $k4ank.jsx)("a", {
                                        href: (0, $b1uoD.getSupportUrl)("/admin_ui/webhooks/"),
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        style: {
                                            color: "#1976d2",
                                            textDecoration: "none"
                                        },
                                        children: "Webhooks"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $lk6eW.default), {
                        component: "legend",
                        children: " *Required"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setEditStreamWebhookDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            try {
                                const parsedCustomFields = JSON.parse(postObject.custom_fields);
                                // Prepare the postObject for API submission
                                const payload = {
                                    ...postObject,
                                    custom_fields: parsedCustomFields
                                };
                                setBackdropLoadingScreenEditCameraOn(true);
                                setEditStreamWebhookDialogOpen(false);
                                handlePatchStreamWebhook(payload, selectedWebhook.id, navigate);
                            } catch (error) {
                                alert("Invalid JSON, cannot submit.");
                            }
                        },
                        text: "Submit & Test",
                        disabled: errorState.webhook || errorState.custom_fields
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("85F5S", function(module, exports) {

$parcel$export(module.exports, "DeleteImmixAlertDialog", () => $3954387a3e418a28$export$13a5ff13b57a2e7d);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");

var $eMw9m = parcelRequire("eMw9m");
const $3954387a3e418a28$export$13a5ff13b57a2e7d = ({ deleteImmixAlertDialogOpen: deleteImmixAlertDialogOpen, setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, immixAlerts: immixAlerts, setImmixAlerts: setImmixAlerts, setActiveTab: setActiveTab, setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen, setSendingImmixTest: setSendingImmixTest, setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen: setImmixTestFailDialogOpen, sureviewAlerts: sureviewAlerts, setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen, cameraWebhookData: cameraWebhookData, setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen, sentinelAlerts: sentinelAlerts, setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen, boldAlerts: boldAlerts, setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen, patriotAlerts: patriotAlerts, setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen, softguardAlerts: softguardAlerts, setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen, immixAlertsOnCamera: immixAlertsOnCamera, sureViewAlertsOnCamera: sureViewAlertsOnCamera, siteInfo: siteInfo, webhooksAlertsOnCamera: webhooksAlertsOnCamera, sentinelAlertsOnCamera: sentinelAlertsOnCamera, boldAlertsOnCamera: boldAlertsOnCamera, patriotAlertsOnCamera: patriotAlertsOnCamera, softguardAlertsOnCamera: softguardAlertsOnCamera, evalinkAlertsOnCamera: evalinkAlertsOnCamera, navigate: navigate })=>{
    const immixAlertId = localStorage.selectedImmixAlertId;
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: deleteImmixAlertDialogOpen,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: " Are you sure you want to delete this Alert?"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setDeleteImmixAlertDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setBackdropLoadingScreenOn(true);
                            (0, $eMw9m.handleDeleteImmixAlert)(immixAlertId, immixAlerts, setImmixAlerts, setActiveTab, setAddImmixAlertDialogOpen, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen, setBackdropLoadingScreenOn, sureviewAlerts, setAddSureviewAlertDialogOpen, cameraWebhookData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, sentinelAlerts, setAddSentinelAlertDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, immixAlertsOnCamera, sureViewAlertsOnCamera, siteInfo, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera, navigate);
                            setDeleteImmixAlertDialogOpen(false);
                        },
                        text: "Delete Alert",
                        disabled: false
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("eMw9m", function(module, exports) {

$parcel$export(module.exports, "handleDeleteImmixAlert", () => $f9f13fc50ac5a823$export$4940cb870c3e9755);

var $k4ank = parcelRequire("k4ank");

var $195EM = parcelRequire("195EM");

var $815yO = parcelRequire("815yO");

var $3Zv1D = parcelRequire("3Zv1D");

var $4wo2Y = parcelRequire("4wo2Y");

var $dWhHk = parcelRequire("dWhHk");

var $aZxZ3 = parcelRequire("aZxZ3");
const $f9f13fc50ac5a823$export$4940cb870c3e9755 = (immixAlertId, immixAlerts, setImmixAlerts, setActiveTab, setAddImmixAlertDialogOpen, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen, setBackdropLoadingScreenOn, sureviewAlerts, setAddSureviewAlertDialogOpen, cameraWebhookData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, sentinelAlerts, setAddSentinelAlertDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, immixAlertsOnCamera, sureViewAlertsOnCamera, siteInfo, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $f9f13fc50ac5a823$export$4940cb870c3e9755(immixAlertId, immixAlerts, setImmixAlerts, setActiveTab, setAddImmixAlertDialogOpen, setSendingImmixTest, setImmixTestSuccessDialogOpen, setImmixTestFailDialogOpen, setDeleteImmixAlertDialogOpen, setBackdropLoadingScreenOn, sureviewAlerts, setAddSureviewAlertDialogOpen, cameraWebhookData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, sentinelAlerts, setAddSentinelAlertDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, immixAlertsOnCamera, sureViewAlertsOnCamera, siteInfo, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera, navigate);
    };
    const { cameraStreamsObject: cameraStreamsObject, setCameraStreamsPatchObject: setCameraStreamsPatchObject, setCameraStreamsObject: setCameraStreamsObject, cameraStreamsSelectedIndex: cameraStreamsSelectedIndex } = (0, $aZxZ3.useEditCameraStore).getState();
    AxiosUI.delete(`/immix/${immixAlertId}/`).then(()=>{
        // Alert configs ride settings.json — deleting one needs a sync.
        (0, $815yO.markSiteUnsynced)();
        // const updatedImmixAlerts = immixAlerts.filter(
        //   (alert: any) => Number(alert.id) !== Number(immixAlertId)
        // );
        const updatedStreams = cameraStreamsObject;
        if (updatedStreams[cameraStreamsSelectedIndex]?.immix_alerts && cameraStreamsObject[cameraStreamsSelectedIndex]?.immix_alerts) updatedStreams[cameraStreamsSelectedIndex].immix_alerts = cameraStreamsObject[cameraStreamsSelectedIndex].immix_alerts.filter((alert1)=>Number(alert1.id) !== Number(immixAlertId));
        setCameraStreamsPatchObject(updatedStreams);
        setCameraStreamsObject(updatedStreams);
        // setImmixAlerts(updatedImmixAlerts);
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dWhHk.AlertSettingsTab), {
                immixAlerts: [],
                setAddImmixAlertDialogOpen: setAddImmixAlertDialogOpen,
                setSendingImmixTest: setSendingImmixTest,
                setImmixTestSuccessDialogOpen: setImmixTestSuccessDialogOpen,
                setImmixTestFailDialogOpen: setImmixTestFailDialogOpen,
                setDeleteImmixAlertDialogOpen: setDeleteImmixAlertDialogOpen,
                sureviewAlerts: sureviewAlerts,
                setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                sentinelAlerts: sentinelAlerts,
                setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                boldAlerts: boldAlerts,
                setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                patriotAlerts: patriotAlerts,
                setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                softguardAlerts: softguardAlerts,
                setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                immixAlertsOnCamera: immixAlertsOnCamera,
                sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                siteInfo: siteInfo,
                webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                boldAlertsOnCamera: boldAlertsOnCamera,
                patriotAlertsOnCamera: patriotAlertsOnCamera,
                softguardAlertsOnCamera: softguardAlertsOnCamera,
                evalinkAlertsOnCamera: evalinkAlertsOnCamera,
                navigate: navigate
            })
        }));
        setBackdropLoadingScreenOn(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Error deleting Immix Alert, please try again.");
            setBackdropLoadingScreenOn(false);
        });
    });
};

});


parcelRegister("7mN1J", function(module, exports) {

$parcel$export(module.exports, "DeleteDiceAlertDialog", () => $e7e7a6ae7089b547$export$f3857828469881a9);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");

var $cmCCO = parcelRequire("cmCCO");
const $e7e7a6ae7089b547$export$f3857828469881a9 = ({ deleteDiceAlertDialogOpen: deleteDiceAlertDialogOpen, setDeleteDiceAlertDialogOpen: setDeleteDiceAlertDialogOpen, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, diceAlerts: diceAlerts, setDiceAlerts: setDiceAlerts, setActiveTab: setActiveTab, setAddDiceAlertDialogOpen: setAddDiceAlertDialogOpen, setSendingDiceTest: setSendingDiceTest, setDiceTestSuccessDialogOpen: setDiceTestSuccessDialogOpen, setDiceTestFailDialogOpen: setDiceTestFailDialogOpen, sureviewAlerts: sureviewAlerts, setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen, cameraWebhookData: cameraWebhookData, setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen, sentinelAlerts: sentinelAlerts, setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen, boldAlerts: boldAlerts, setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen, patriotAlerts: patriotAlerts, setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen, softguardAlerts: softguardAlerts, setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen, diceAlertsOnCamera: diceAlertsOnCamera, sureViewAlertsOnCamera: sureViewAlertsOnCamera, siteInfo: siteInfo, webhooksAlertsOnCamera: webhooksAlertsOnCamera, sentinelAlertsOnCamera: sentinelAlertsOnCamera, boldAlertsOnCamera: boldAlertsOnCamera, patriotAlertsOnCamera: patriotAlertsOnCamera, softguardAlertsOnCamera: softguardAlertsOnCamera, evalinkAlertsOnCamera: evalinkAlertsOnCamera, navigate: navigate })=>{
    const diceAlertId = localStorage.selectedDiceAlertId;
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: deleteDiceAlertDialogOpen,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: " Are you sure you want to delete this Alert?"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setDeleteDiceAlertDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setBackdropLoadingScreenOn(true);
                            (0, $cmCCO.handleDeleteDiceAlert)(diceAlertId, diceAlerts, setDiceAlerts, setActiveTab, setAddDiceAlertDialogOpen, setSendingDiceTest, setDiceTestSuccessDialogOpen, setDiceTestFailDialogOpen, setDeleteDiceAlertDialogOpen, setBackdropLoadingScreenOn, sureviewAlerts, setAddSureviewAlertDialogOpen, cameraWebhookData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, sentinelAlerts, setAddSentinelAlertDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, diceAlertsOnCamera, sureViewAlertsOnCamera, siteInfo, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera, navigate);
                            setDeleteDiceAlertDialogOpen(false);
                        },
                        text: "Delete Alert",
                        disabled: false
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("cmCCO", function(module, exports) {

$parcel$export(module.exports, "handleDeleteDiceAlert", () => $c86aecbddeaef01e$export$e009cad2c023974c);

var $k4ank = parcelRequire("k4ank");

var $195EM = parcelRequire("195EM");

var $815yO = parcelRequire("815yO");

var $3Zv1D = parcelRequire("3Zv1D");

var $4wo2Y = parcelRequire("4wo2Y");

var $dWhHk = parcelRequire("dWhHk");

var $aZxZ3 = parcelRequire("aZxZ3");
const $c86aecbddeaef01e$export$e009cad2c023974c = (diceAlertId, diceAlerts, setDiceAlerts, setActiveTab, setAddDiceAlertDialogOpen, setSendingDiceTest, setDiceTestSuccessDialogOpen, setDiceTestFailDialogOpen, setDeleteDiceAlertDialogOpen, setBackdropLoadingScreenOn, sureviewAlerts, setAddSureviewAlertDialogOpen, cameraWebhookData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, sentinelAlerts, setAddSentinelAlertDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, diceAlertsOnCamera, sureViewAlertsOnCamera, siteInfo, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $c86aecbddeaef01e$export$e009cad2c023974c(diceAlertId, diceAlerts, setDiceAlerts, setActiveTab, setAddDiceAlertDialogOpen, setSendingDiceTest, setDiceTestSuccessDialogOpen, setDiceTestFailDialogOpen, setDeleteDiceAlertDialogOpen, setBackdropLoadingScreenOn, sureviewAlerts, setAddSureviewAlertDialogOpen, cameraWebhookData, setAddStreamWebhookDialogOpen, setEditStreamWebhookDialogOpen, sentinelAlerts, setAddSentinelAlertDialogOpen, boldAlerts, setAddBoldAlertDialogOpen, patriotAlerts, setAddPatriotAlertDialogOpen, softguardAlerts, setAddSoftguardAlertDialogOpen, diceAlertsOnCamera, sureViewAlertsOnCamera, siteInfo, webhooksAlertsOnCamera, sentinelAlertsOnCamera, boldAlertsOnCamera, patriotAlertsOnCamera, softguardAlertsOnCamera, evalinkAlertsOnCamera, navigate);
    };
    const { cameraStreamsObject: cameraStreamsObject, setCameraStreamsPatchObject: setCameraStreamsPatchObject, setCameraStreamsObject: setCameraStreamsObject, cameraStreamsSelectedIndex: cameraStreamsSelectedIndex } = (0, $aZxZ3.useEditCameraStore).getState();
    AxiosUI.delete(`/dice/${diceAlertId}/`).then(()=>{
        // Alert configs ride settings.json — deleting one needs a sync.
        (0, $815yO.markSiteUnsynced)();
        // const updatedDiceAlerts = diceAlerts.filter(
        //   (alert: any) => Number(alert.id) !== Number(diceAlertId)
        // );
        const updatedStreams = cameraStreamsObject;
        if (updatedStreams[cameraStreamsSelectedIndex]?.dice_alerts && cameraStreamsObject[cameraStreamsSelectedIndex]?.dice_alerts) updatedStreams[cameraStreamsSelectedIndex].dice_alerts = cameraStreamsObject[cameraStreamsSelectedIndex].dice_alerts.filter((alert1)=>Number(alert1.id) !== Number(diceAlertId));
        setCameraStreamsPatchObject(updatedStreams);
        setCameraStreamsObject(updatedStreams);
        // setDiceAlerts(updatedDiceAlerts);
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
        setActiveTab(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dWhHk.AlertSettingsTab), {
                diceAlerts: [],
                setAddDiceAlertDialogOpen: setAddDiceAlertDialogOpen,
                setSendingDiceTest: setSendingDiceTest,
                setDiceTestSuccessDialogOpen: setDiceTestSuccessDialogOpen,
                setDiceTestFailDialogOpen: setDiceTestFailDialogOpen,
                setDeleteDiceAlertDialogOpen: setDeleteDiceAlertDialogOpen,
                sureviewAlerts: sureviewAlerts,
                setAddSureviewAlertDialogOpen: setAddSureviewAlertDialogOpen,
                setAddStreamWebhookDialogOpen: setAddStreamWebhookDialogOpen,
                setEditStreamWebhookDialogOpen: setEditStreamWebhookDialogOpen,
                sentinelAlerts: sentinelAlerts,
                setAddSentinelAlertDialogOpen: setAddSentinelAlertDialogOpen,
                boldAlerts: boldAlerts,
                setAddBoldAlertDialogOpen: setAddBoldAlertDialogOpen,
                patriotAlerts: patriotAlerts,
                setAddPatriotAlertDialogOpen: setAddPatriotAlertDialogOpen,
                softguardAlerts: softguardAlerts,
                setAddSoftguardAlertDialogOpen: setAddSoftguardAlertDialogOpen,
                diceAlertsOnCamera: diceAlertsOnCamera,
                sureViewAlertsOnCamera: sureViewAlertsOnCamera,
                siteInfo: siteInfo,
                webhooksAlertsOnCamera: webhooksAlertsOnCamera,
                sentinelAlertsOnCamera: sentinelAlertsOnCamera,
                boldAlertsOnCamera: boldAlertsOnCamera,
                patriotAlertsOnCamera: patriotAlertsOnCamera,
                softguardAlertsOnCamera: softguardAlertsOnCamera,
                evalinkAlertsOnCamera: evalinkAlertsOnCamera,
                navigate: navigate
            })
        }));
        setBackdropLoadingScreenOn(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Error deleting Dice Alert, please try again.");
            setBackdropLoadingScreenOn(false);
        });
    });
};

});


parcelRegister("cgrVY", function(module, exports) {

$parcel$export(module.exports, "DeleteWebhookDialog", () => $6d9d9b32b20fb4ea$export$81c8a0e346b4a8ec);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");

var $aZxZ3 = parcelRequire("aZxZ3");
const $6d9d9b32b20fb4ea$export$81c8a0e346b4a8ec = ({ navigate: navigate })=>{
    const { deleteWebhookDialogOpen: deleteWebhookDialogOpen, setDeleteWebhookDialogOpen: setDeleteWebhookDialogOpen, setBackdropLoadingScreenEditCameraOn: setBackdropLoadingScreenEditCameraOn, handleDeleteWebhook: handleDeleteWebhook, webhookIdToDelete: webhookIdToDelete } = (0, $aZxZ3.useEditCameraStore)();
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: deleteWebhookDialogOpen,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: " Are you sure you want to delete this Webhook?"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setDeleteWebhookDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setBackdropLoadingScreenEditCameraOn(true);
                            handleDeleteWebhook(navigate, webhookIdToDelete);
                            setDeleteWebhookDialogOpen(false);
                        },
                        text: "Delete Webhook",
                        disabled: false
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("gyvxI", function(module, exports) {

$parcel$export(module.exports, "NotesDialogEditCamera", () => $809580aa76088cca$export$7d439c6e420bd4a8);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $iLEpm = parcelRequire("iLEpm");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");

var $aZxZ3 = parcelRequire("aZxZ3");
const $809580aa76088cca$export$7d439c6e420bd4a8 = ()=>{
    const { notesDialogEditCameraOpen: notesDialogEditCameraOpen, setNotesDialogEditCameraOpen: setNotesDialogEditCameraOpen, notesText: notesText } = (0, $aZxZ3.useEditCameraStore)();
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: notesDialogEditCameraOpen,
        fullWidth: true,
        maxWidth: "xs",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: "Notes"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                    children: notesText
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                    onClick: ()=>{
                        setNotesDialogEditCameraOpen(false);
                    },
                    text: "Ok",
                    disabled: false
                })
            })
        ]
    });
};

});

parcelRegister("bR0RS", function(module, exports) {

$parcel$export(module.exports, "DeleteAlertDialog", () => $6ed0330495a7056e$export$4ae407de52529cb8);

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");

var $aZxZ3 = parcelRequire("aZxZ3");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $6ed0330495a7056e$export$4ae407de52529cb8 = ()=>{
    const navigate = (0, $3T949.useNavigate)();
    const { deleteAlertDialogOpen: deleteAlertDialogOpen, setDeleteAlertDialogOpen: setDeleteAlertDialogOpen, handleDeleteAlerts: handleDeleteAlerts } = (0, $aZxZ3.useEditCameraStore)();
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: deleteAlertDialogOpen,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: " Are you sure you want to delete this Alert?"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setDeleteAlertDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            handleDeleteAlerts(navigate);
                            setDeleteAlertDialogOpen(false);
                        },
                        text: "Delete Alert",
                        disabled: false
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("hdv6W", function(module, exports) {

$parcel$export(module.exports, "AddSysaidAlertDialog", () => $2b2dfa6b50abe151$export$a34d7964275494f9);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");

var $lk6eW = parcelRequire("lk6eW");

var $aZxZ3 = parcelRequire("aZxZ3");
const $2b2dfa6b50abe151$export$a34d7964275494f9 = ({ setCameraGeneralInfo: setCameraGeneralInfo, setCameraGeneralInfoBackup: setCameraGeneralInfoBackup, setPatchObject: setPatchObject, cameraGeneralInfoBackup: cameraGeneralInfoBackup })=>{
    const { cameraStreams: cameraStreams, cameraStreamsPatchObject: cameraStreamsPatchObject, cameraStreamsObject: cameraStreamsObject, addSysaidAlertDialogOpen: addSysaidAlertDialogOpen, setAddSysaidAlertDialogOpen: setAddSysaidAlertDialogOpen, handleSubmitNewSysaidAlert: handleSubmitNewSysaidAlert } = (0, $aZxZ3.useEditCameraStore)();
    const streamNames = new Map();
    cameraStreams?.forEach((object, index)=>{
        streamNames.set(`${object.name} (${object.product})`, index);
    });
    const navigate = (0, $3T949.useNavigate)();
    const [postObject, setPostObject] = $8T3gX.useState({
        id: -1,
        sysaid_server: "",
        sysaid_client_local: "",
        sysaid_username: "",
        sysaid_password: ""
    });
    const [selectedStreamNames, setSelectedStreamNames] = $8T3gX.useState([]);
    $8T3gX.useEffect(()=>{
        if (cameraStreamsObject[0]?.sysaid_alerts) setPostObject({
            id: -1,
            sysaid_server: cameraStreamsObject[0]?.sysaid_alerts[0]?.sysaid_server,
            sysaid_client_local: cameraStreamsObject[0]?.sysaid_alerts[0]?.sysaid_client_local,
            sysaid_username: cameraStreamsObject[0]?.sysaid_alerts[0]?.sysaid_username,
            sysaid_password: cameraStreamsObject[0]?.sysaid_alerts[0]?.sysaid_password
        });
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: addSysaidAlertDialogOpen,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: "Add SysAid Alert"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                children: [
                    cameraStreams && cameraStreams.length > 1 && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $lk6eW.default), {
                                component: "legend",
                                sx: {
                                    paddingBottom: 1
                                },
                                children: [
                                    " ",
                                    "Streams*"
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                multiple: true,
                                options: cameraStreams.map((object)=>{
                                    return `${object.name} (${object.product})`;
                                }),
                                sx: {
                                    width: 400
                                },
                                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        ...params
                                    }),
                                onChange: (event, value)=>{
                                    setSelectedStreamNames(value);
                                }
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "sysaid_server",
                        variant: "standard",
                        label: "SysAid Server",
                        defaultValue: postObject.sysaid_server,
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    sysaid_server: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "sysaid_client_local",
                        variant: "standard",
                        label: "SysAid Client Local",
                        defaultValue: postObject.sysaid_client_local,
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    sysaid_client_local: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "sysaid_username",
                        variant: "standard",
                        label: "SysAid Username",
                        defaultValue: postObject.sysaid_username,
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    sysaid_username: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "sysaid_password",
                        variant: "standard",
                        label: "SysAid Password",
                        defaultValue: postObject.sysaid_password,
                        onChange: (event)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    sysaid_password: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "400px"
                        },
                        type: "string"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setAddSysaidAlertDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            const selectedStreamIndexs = [];
                            const streamsObjectToPost = JSON.parse(JSON.stringify(cameraStreamsPatchObject));
                            if (cameraStreams && cameraStreams.length > 1) {
                                selectedStreamNames.forEach((streamName)=>{
                                    selectedStreamIndexs.push(streamNames.get(streamName));
                                });
                                selectedStreamIndexs.forEach((streamIndex)=>{
                                    if (streamsObjectToPost[streamIndex]) streamsObjectToPost[streamIndex].sysaid_alerts = [
                                        ...streamsObjectToPost[streamIndex].sysaid_alerts,
                                        postObject
                                    ];
                                });
                            }
                            if (cameraStreams && cameraStreams.length === 1) streamsObjectToPost[0].sysaid_alerts.push(postObject);
                            handleSubmitNewSysaidAlert(streamsObjectToPost, setCameraGeneralInfo, setCameraGeneralInfoBackup, setPatchObject, cameraGeneralInfoBackup, navigate);
                            setAddSysaidAlertDialogOpen(false);
                        },
                        text: "Submit",
                        disabled: false
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("6pQI1", function(module, exports) {

$parcel$export(module.exports, "ProductActionLogsDialog", () => $a6a25e02030cec8c$export$1c3549d91ed0a775);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $ce8iU = parcelRequire("ce8iU");

var $1TOOV = parcelRequire("1TOOV");

var $iKAtE = parcelRequire("iKAtE");

var $433j1 = parcelRequire("433j1");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $ha39s = parcelRequire("ha39s");

var $4o6Cs = parcelRequire("4o6Cs");

var $1wcxl = parcelRequire("1wcxl");

var $4reBM = parcelRequire("4reBM");

var $eDfvp = parcelRequire("eDfvp");

var $kLvBh = parcelRequire("kLvBh");

var $9lVTU = parcelRequire("9lVTU");

var $195EM = parcelRequire("195EM");

var $fWsn7 = parcelRequire("fWsn7");

var $60vL1 = parcelRequire("60vL1");

var $f3puC = parcelRequire("f3puC");

var $8jTCz = parcelRequire("8jTCz");

var $kAYr8 = parcelRequire("kAYr8");

var $6ZGvG = parcelRequire("6ZGvG");

var $jgSER = parcelRequire("jgSER");
const $a6a25e02030cec8c$var$headCells = [
    {
        id: "history_date",
        numeric: false,
        label: "Date"
    },
    {
        id: "label_display_name",
        numeric: false,
        label: "Product Metric"
    },
    {
        id: "history_type",
        numeric: false,
        label: "Action Type"
    },
    {
        id: "sensitivity_name",
        numeric: false,
        label: "Current Sensitivity"
    },
    {
        id: "username",
        numeric: false,
        label: "Updated by"
    }
];
// The endpoint pages at 100 rows by default, and the generic "Updated" rows
// (filtered out below) are common, so reading only page 1 dropped older ignore
// zone and sensitivity changes (SUP-834). Follow every page, up to the
// backend's 10,000-row merge cap.
const $a6a25e02030cec8c$var$HISTORY_PAGE_SIZE = 500;
const $a6a25e02030cec8c$var$HISTORY_MAX_PAGES = 20;
const $a6a25e02030cec8c$var$fetchAllProductHistory = async (cameraId, isCancelled)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const results = [];
    for(let page = 1; page <= $a6a25e02030cec8c$var$HISTORY_MAX_PAGES; page++){
        const response = await AxiosUI.get(`metric/history/?camera=${cameraId}&page_size=${$a6a25e02030cec8c$var$HISTORY_PAGE_SIZE}&page=${page}`);
        results.push(...response.data.results || []);
        if (!response.data.next || isCancelled()) break;
    }
    return results;
};
const $a6a25e02030cec8c$var$normalizeHistoryType = (historyType)=>historyType.trim().toLowerCase();
const $a6a25e02030cec8c$var$isLineCrossingRow = (row)=>row.record_type === "line_crossing";
const $a6a25e02030cec8c$var$isGenericUpdatedProductAction = (row)=>$a6a25e02030cec8c$var$normalizeHistoryType(row.history_type) === "updated";
function $a6a25e02030cec8c$var$formatHistoryDate(dateString, siteTimezone) {
    return (0, $6ZGvG.formatSiteTimestamp)(new Date(dateString), siteTimezone);
}
function $a6a25e02030cec8c$var$ProductActionLogsTableHead({ orderBy: orderBy, onRequestSort: onRequestSort, order: order }) {
    const createSortHandler = (property)=>(event)=>{
            onRequestSort(event, property);
        };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
            children: [
                $a6a25e02030cec8c$var$headCells.map((headCell)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                        align: "left",
                        sortDirection: orderBy === headCell.id ? order : false,
                        sx: {
                            fontSize: "15px",
                            fontFamily: "Mulish",
                            fontWeight: "Bold"
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kLvBh.default), {
                            active: orderBy === headCell.id,
                            direction: orderBy === headCell.id ? order : "asc",
                            onClick: createSortHandler(headCell.id),
                            children: [
                                headCell.label,
                                orderBy === headCell.id ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                    component: "span",
                                    sx: (0, $9lVTU.default),
                                    children: order === "desc" ? "sorted descending" : "sorted ascending"
                                }) : null
                            ]
                        })
                    }, headCell.id)),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    align: "left",
                    sx: {
                        fontSize: "15px",
                        fontFamily: "Mulish",
                        fontWeight: "Bold"
                    },
                    children: "Zones / Lines"
                })
            ]
        })
    });
}
const $a6a25e02030cec8c$export$1c3549d91ed0a775 = ({ open: open, onClose: onClose, cameraId: cameraId, siteTimezone: siteTimezone = null })=>{
    const [rows, setRows] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [order, setOrder] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("desc");
    const [orderBy, setOrderBy] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("history_date");
    const [page, setPage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [rowsPerPage, setRowsPerPage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(25);
    const [selectedRowForIgnoreZones, setSelectedRowForIgnoreZones] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [selectedRowForLineCrossing, setSelectedRowForLineCrossing] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!open || !cameraId) return;
        let cancelled = false;
        setLoading(true);
        setError(null);
        $a6a25e02030cec8c$var$fetchAllProductHistory(cameraId, ()=>cancelled).then((results)=>{
            if (cancelled) return;
            const flattened = results.map((item)=>({
                    id: item.id,
                    history_date: item.history_date,
                    formatted_date: $a6a25e02030cec8c$var$formatHistoryDate(item.history_date, siteTimezone),
                    label_display_name: item.label?.display_name ?? "",
                    history_type: item.history_type ?? "",
                    sensitivity_name: item.sensitivity?.name ?? "",
                    username: item.username ?? "",
                    polygonal_zones: Array.isArray(item.polygonal_zones) ? item.polygonal_zones : null,
                    record_type: item.record_type ?? "metric",
                    line_crossing: item.line_crossing ?? null
                }));
            setRows(flattened);
        }).catch((err)=>{
            if (!cancelled) setError(err?.message ?? "Failed to load product action logs.");
        }).finally(()=>{
            if (!cancelled) setLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        open,
        cameraId,
        siteTimezone
    ]);
    const filteredRows = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>rows.filter((row)=>!$a6a25e02030cec8c$var$isGenericUpdatedProductAction(row)), [
        rows
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        const maxPage = Math.max(0, Math.ceil(filteredRows.length / rowsPerPage) - 1);
        if (page > maxPage) setPage(maxPage);
    }, [
        filteredRows.length,
        rowsPerPage,
        page
    ]);
    const handleRequestSort = (_event, property)=>{
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };
    const handleChangePage = (_event, newPage)=>{
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event)=>{
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const visibleRows = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>{
        const comparator = (0, $fWsn7.getComparator)(order, orderBy);
        const sorted = (0, $fWsn7.stableSort)(filteredRows, comparator);
        return sorted.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    }, [
        filteredRows,
        order,
        orderBy,
        page,
        rowsPerPage
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: open,
        onClose: onClose,
        fullWidth: true,
        maxWidth: "lg",
        PaperProps: {
            sx: {
                minHeight: "80vh",
                fontFamily: "Mulish"
            }
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $ce8iU.default), {
                sx: {
                    fontFamily: "Mulish",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    pr: 1
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                        children: "Product Action Logs"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                        "aria-label": "close",
                        onClick: onClose,
                        sx: {
                            color: "text.primary"
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                dividers: true,
                children: [
                    loading && /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            minHeight: 200
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {})
                    }),
                    error && /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            fontFamily: "Mulish",
                            color: "error.main",
                            py: 2
                        },
                        children: error
                    }),
                    !loading && !error && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4reBM.default), {
                        sx: {
                            width: "100%",
                            overflow: "hidden"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                sx: {
                                    maxHeight: "60vh"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                    stickyHeader: true,
                                    "aria-label": "product action logs table",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)($a6a25e02030cec8c$var$ProductActionLogsTableHead, {
                                            orderBy: orderBy,
                                            onRequestSort: handleRequestSort,
                                            order: order
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                            children: visibleRows.map((row)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                    hover: true,
                                                    children: [
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            sx: {
                                                                fontFamily: "Mulish"
                                                            },
                                                            align: "left",
                                                            children: row.formatted_date
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            sx: {
                                                                fontFamily: "Mulish"
                                                            },
                                                            align: "left",
                                                            children: row.label_display_name
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            sx: {
                                                                fontFamily: "Mulish"
                                                            },
                                                            align: "left",
                                                            children: row.history_type
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            sx: {
                                                                fontFamily: "Mulish"
                                                            },
                                                            align: "left",
                                                            children: row.sensitivity_name || "\u2014"
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            sx: {
                                                                fontFamily: "Mulish"
                                                            },
                                                            align: "left",
                                                            children: row.username
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            sx: {
                                                                fontFamily: "Mulish"
                                                            },
                                                            align: "left",
                                                            children: $a6a25e02030cec8c$var$isLineCrossingRow(row) ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                                onClick: ()=>setSelectedRowForLineCrossing(row),
                                                                text: "See Line Crossing",
                                                                disabled: false
                                                            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                                onClick: ()=>setSelectedRowForIgnoreZones(row),
                                                                text: "See Ignore Zones",
                                                                disabled: false
                                                            })
                                                        })
                                                    ]
                                                }, row.id))
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wcxl.default), {
                                rowsPerPageOptions: [
                                    10,
                                    25,
                                    50
                                ],
                                component: "div",
                                count: filteredRows.length,
                                rowsPerPage: rowsPerPage,
                                page: page,
                                onPageChange: handleChangePage,
                                onRowsPerPageChange: handleChangeRowsPerPage,
                                sx: {
                                    fontFamily: "Mulish"
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $kAYr8.IgnoreZonesPreviewDialog), {
                open: selectedRowForIgnoreZones !== null,
                onClose: ()=>setSelectedRowForIgnoreZones(null),
                cameraId: cameraId,
                polygonalZones: selectedRowForIgnoreZones?.polygonal_zones ?? null
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $jgSER.LineCrossingPreviewDialog), {
                open: selectedRowForLineCrossing !== null,
                onClose: ()=>setSelectedRowForLineCrossing(null),
                cameraId: cameraId,
                lineCrossing: selectedRowForLineCrossing?.line_crossing ?? null
            })
        ]
    });
};

});
parcelRegister("kAYr8", function(module, exports) {

$parcel$export(module.exports, "IgnoreZonesPreviewDialog", () => $89b0a5ae9f56fba5$export$de634d53a31cf98c);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $ce8iU = parcelRequire("ce8iU");

var $1TOOV = parcelRequire("1TOOV");

var $iKAtE = parcelRequire("iKAtE");

var $433j1 = parcelRequire("433j1");

var $eDfvp = parcelRequire("eDfvp");

var $f3puC = parcelRequire("f3puC");

var $60vL1 = parcelRequire("60vL1");

var $64WJh = parcelRequire("64WJh");

var $kPQrn = parcelRequire("kPQrn");

var $dVjTN = parcelRequire("dVjTN");

var $3xZfu = parcelRequire("3xZfu");
const $89b0a5ae9f56fba5$var$ACTUATE_ORANGE = "#FF8400";
const $89b0a5ae9f56fba5$export$de634d53a31cf98c = ({ open: open, onClose: onClose, cameraId: cameraId, polygonalZones: polygonalZones })=>{
    const { previewUrl: previewUrl, loading: loading, error: error } = (0, $dVjTN.useCameraPreviewUrl)(open, cameraId);
    const [dimensions, setDimensions] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (open) setDimensions(null);
    }, [
        open,
        cameraId
    ]);
    const handleImageLoad = (event)=>{
        const { naturalWidth: naturalWidth, naturalHeight: naturalHeight } = event.currentTarget;
        setDimensions((0, $kPQrn.resizeImage)(naturalWidth, naturalHeight));
    };
    const hasZones = Array.isArray(polygonalZones) && polygonalZones.length > 0;
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: open,
        onClose: onClose,
        maxWidth: "md",
        fullWidth: true,
        PaperProps: {
            sx: {
                fontFamily: "Mulish"
            }
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $ce8iU.default), {
                sx: {
                    fontFamily: "Mulish",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    pr: 1
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                        children: "Ignore Zones"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                        "aria-label": "close",
                        onClick: onClose,
                        sx: {
                            color: "text.primary"
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                dividers: true,
                children: [
                    loading && /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            minHeight: 300
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {})
                    }),
                    error && /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            fontFamily: "Mulish",
                            color: "error.main",
                            py: 2
                        },
                        children: error
                    }),
                    !loading && !error && previewUrl && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                        sx: {
                            position: "relative",
                            display: "inline-block"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                                src: previewUrl,
                                onLoad: handleImageLoad,
                                alt: "Camera preview",
                                style: {
                                    width: dimensions ? `${dimensions.width}px` : "auto",
                                    height: dimensions ? `${dimensions.height}px` : "auto",
                                    display: "block"
                                }
                            }),
                            dimensions && hasZones && polygonalZones.map((polygon, polygonIndex)=>/*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    style: {
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        pointerEvents: "none"
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                                        style: {
                                            width: `${dimensions.width}px`,
                                            height: `${dimensions.height}px`
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("polygon", {
                                            points: (0, $64WJh.pointsCreator)(polygon, dimensions.height, dimensions.width),
                                            stroke: $89b0a5ae9f56fba5$var$ACTUATE_ORANGE,
                                            strokeWidth: "5",
                                            fill: $89b0a5ae9f56fba5$var$ACTUATE_ORANGE,
                                            fillOpacity: "0.5"
                                        })
                                    })
                                }, polygonIndex)),
                            dimensions && !hasZones && /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                children: "There were no ignore zones assigned for this product during this change."
                            })
                        ]
                    }),
                    !loading && hasZones && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3xZfu.HistoryCoordinates), {
                        value: polygonalZones
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("dVjTN", function(module, exports) {

$parcel$export(module.exports, "useCameraPreviewUrl", () => $322da23e16a2e8ac$export$d40e3ebb91555180);

var $8T3gX = parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");
const $322da23e16a2e8ac$export$d40e3ebb91555180 = (open, cameraId)=>{
    const [previewUrl, setPreviewUrl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!open || !cameraId) return;
        let cancelled = false;
        setLoading(true);
        setError(null);
        setPreviewUrl(null);
        const AxiosUI = (0, $195EM.createApi)(``);
        AxiosUI.get(`/camera/${cameraId}/status/`).then((response)=>{
            if (cancelled) return;
            setPreviewUrl(response.data.preview_url ?? null);
        }).catch((err)=>{
            if (!cancelled) setError(err?.message ?? "Failed to load camera preview.");
        }).finally(()=>{
            if (!cancelled) setLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        open,
        cameraId
    ]);
    return {
        previewUrl: previewUrl,
        loading: loading,
        error: error
    };
};

});

parcelRegister("3xZfu", function(module, exports) {

$parcel$export(module.exports, "HistoryCoordinates", () => $0fc8bde83ae7e3de$export$f540fbdf9ae9f09b);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");

var $f3puC = parcelRequire("f3puC");

var $8jTCz = parcelRequire("8jTCz");
const $0fc8bde83ae7e3de$export$f540fbdf9ae9f09b = ({ value: value })=>{
    const [copied, setCopied] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const text = JSON.stringify(value);
    const handleCopy = async ()=>{
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
        } catch  {
            setCopied(false);
        }
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
        sx: {
            mt: 2
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "bold"
                        },
                        children: "Coordinates"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: handleCopy,
                        text: copied ? "Copied" : "Copy",
                        disabled: false
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                component: "pre",
                "data-testid": "history-coordinates",
                sx: {
                    m: 0,
                    p: 1,
                    fontSize: "12px",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-all",
                    backgroundColor: "#F5F5F5",
                    borderRadius: 1
                },
                children: text
            })
        ]
    });
};

});


parcelRegister("6ZGvG", function(module, exports) {

$parcel$export(module.exports, "formatSiteTimestamp", () => $2f0743a935227e9a$export$b44dd3661af4e5d7);
// ENG-2504: Action Logs show times in the site's timezone, labelled with the
// zone ("Oct 20, 2026, 6:44 AM EDT"), so CS staff abroad don't have to convert.
// Falls back to the viewer's browser timezone when the site has none, or an
// unrecognised one (Intl throws a RangeError on unknown zone names).
const $2f0743a935227e9a$var$BASE_OPTIONS = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    timeZoneName: "short"
};
const $2f0743a935227e9a$export$b44dd3661af4e5d7 = (date, siteTimezone)=>{
    if (siteTimezone) try {
        return date.toLocaleString("en-US", {
            ...$2f0743a935227e9a$var$BASE_OPTIONS,
            timeZone: siteTimezone
        });
    } catch  {
    // Unknown zone name: fall through to browser time.
    }
    return date.toLocaleString("en-US", $2f0743a935227e9a$var$BASE_OPTIONS);
};

});

parcelRegister("jgSER", function(module, exports) {

$parcel$export(module.exports, "LineCrossingPreviewDialog", () => $dbb6c5f73a9c1d17$export$1f652e88adad0549);

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $ce8iU = parcelRequire("ce8iU");

var $1TOOV = parcelRequire("1TOOV");

var $iKAtE = parcelRequire("iKAtE");

var $433j1 = parcelRequire("433j1");

var $eDfvp = parcelRequire("eDfvp");

var $f3puC = parcelRequire("f3puC");

var $60vL1 = parcelRequire("60vL1");

var $kPQrn = parcelRequire("kPQrn");

var $5axmO = parcelRequire("5axmO");

var $iMum1 = parcelRequire("iMum1");

var $fLtYK = parcelRequire("fLtYK");

var $1Xths = parcelRequire("1Xths");

var $dVjTN = parcelRequire("dVjTN");

var $3xZfu = parcelRequire("3xZfu");
const $dbb6c5f73a9c1d17$var$DIRECTION_LABELS = {
    l2r: "Left to right",
    r2l: "Right to left",
    both: "Both"
};
const $dbb6c5f73a9c1d17$export$1f652e88adad0549 = ({ open: open, onClose: onClose, cameraId: cameraId, lineCrossing: lineCrossing })=>{
    const { previewUrl: previewUrl, loading: loading, error: error } = (0, $dVjTN.useCameraPreviewUrl)(open, cameraId);
    const [dimensions, setDimensions] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (open) setDimensions(null);
    }, [
        open,
        cameraId
    ]);
    const handleImageLoad = (event)=>{
        const { naturalWidth: naturalWidth, naturalHeight: naturalHeight } = event.currentTarget;
        setDimensions((0, $kPQrn.resizeImage)(naturalWidth, naturalHeight));
    };
    const line = lineCrossing && Array.isArray(lineCrossing.coordinates) && lineCrossing.coordinates.length === 2 ? lineCrossing : null;
    const overlayLines = line ? [
        {
            id: line.id,
            camera: Number(cameraId),
            metric_labels: [],
            coordinates: line.coordinates,
            direction: (0, $iMum1.backendToFrontendDirection)(line.direction ?? "both", line.coordinates),
            preset: line.preset,
            color: (0, $1Xths.LINE_COLORS)[0]
        }
    ] : [];
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: open,
        onClose: onClose,
        maxWidth: "md",
        fullWidth: true,
        PaperProps: {
            sx: {
                fontFamily: "Mulish"
            }
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $ce8iU.default), {
                sx: {
                    fontFamily: "Mulish",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    pr: 1
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                        children: "Line Crossing"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                        "aria-label": "close",
                        onClick: onClose,
                        sx: {
                            color: "text.primary"
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                dividers: true,
                children: [
                    loading && /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            minHeight: 300
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {})
                    }),
                    error && /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            fontFamily: "Mulish",
                            color: "error.main",
                            py: 2
                        },
                        children: error
                    }),
                    !loading && !error && previewUrl && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                        sx: {
                            position: "relative",
                            display: "inline-block"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                                src: previewUrl,
                                onLoad: handleImageLoad,
                                alt: "Camera preview",
                                style: {
                                    width: dimensions ? `${dimensions.width}px` : "auto",
                                    height: dimensions ? `${dimensions.height}px` : "auto",
                                    display: "block"
                                }
                            }),
                            dimensions && line && /*#__PURE__*/ (0, $k4ank.jsx)((0, $5axmO.LineCrossingsOverlay), {
                                lines: overlayLines,
                                width: dimensions.width,
                                height: dimensions.height
                            })
                        ]
                    }),
                    !loading && line && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                        sx: {
                            fontFamily: "Mulish"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                sx: {
                                    fontFamily: "Mulish",
                                    mt: 2
                                },
                                children: [
                                    "Direction:",
                                    " ",
                                    $dbb6c5f73a9c1d17$var$DIRECTION_LABELS[(0, $fLtYK.normalizeBackendDirection)(line.direction)]
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: [
                                    "Configuration:",
                                    " ",
                                    line.preset === null ? "Default" : `Preset ${line.preset}`
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3xZfu.HistoryCoordinates), {
                                value: line.coordinates
                            })
                        ]
                    }),
                    !loading && !line && /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            fontFamily: "Mulish",
                            mt: 2
                        },
                        children: "There was no line recorded for this change."
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("2nm0w", function(module, exports) {

$parcel$export(module.exports, "hydrateFlexIgnoreZonesForEditCameraPage", () => $4fbcd76d17709045$export$897a4a24f0ecd46b);

var $195EM = parcelRequire("195EM");

var $3FJ79 = parcelRequire("3FJ79");

var $eYzFO = parcelRequire("eYzFO");
const $4fbcd76d17709045$export$7576ae6f26d36f9d = (results)=>results.map((camera)=>({
            id: Number(camera.id),
            camera_name: camera.camera_name,
            preview_url: camera.preview_url,
            ignore_zones: camera.ignore_zones
        }));
const $4fbcd76d17709045$export$7c8e7d38439fc427 = (data)=>{
    if (!Array.isArray(data) || data.length === 0) return [];
    return data.map((s, idx)=>({
            id: Number(s?.id ?? idx + 1),
            display_name: s?.display_name || `Schedule ${idx + 1}`
        })).filter((row)=>Number.isFinite(row.id));
};
async function $4fbcd76d17709045$export$897a4a24f0ecd46b(siteId, options) {
    const signal = options?.signal;
    const focusCameraId = options?.focusCameraId;
    const AxiosUI = (0, $195EM.createApi)("");
    let flexCameras;
    if (focusCameraId != null && Number.isFinite(Number(focusCameraId)) && Number(focusCameraId) > 0) {
        const id = Number(focusCameraId);
        flexCameras = [
            {
                id: id,
                camera_name: "",
                preview_url: "",
                ignore_zones: []
            }
        ];
    } else {
        const allResults = [];
        let pageNumber = 1;
        let hasMore = true;
        while(hasMore){
            if (signal?.aborted) return;
            const res = await AxiosUI.get(`camera/site/?customer__id=${siteId}&page=${pageNumber}`, {
                signal: signal
            });
            const chunk = res.data?.results;
            if (Array.isArray(chunk)) allResults.push(...chunk);
            if (res.data?.next) pageNumber += 1;
            else hasMore = false;
        }
        if (signal?.aborted) return;
        flexCameras = $4fbcd76d17709045$export$7576ae6f26d36f9d(allResults);
    }
    let flexSchedules = [];
    try {
        const schedRes = await AxiosUI.get(`flex_schedule/by_customer/${siteId}/`, {
            signal: signal
        });
        const raw = schedRes.data;
        (0, $3FJ79.useSiteAboutStore).getState().setSiteSchedules(raw);
        flexSchedules = $4fbcd76d17709045$export$7c8e7d38439fc427(raw);
    } catch  {
        (0, $3FJ79.useSiteAboutStore).getState().setSiteSchedules([]);
    }
    if (signal?.aborted) return;
    await (0, $eYzFO.useFlexIgnoreZonesOnboardingStore).getState().syncFlexIgnoreZonesEnabledFromApi(Number(siteId), flexCameras, flexSchedules.length > 0 ? flexSchedules : undefined, true);
}

});



parcelRegister("7z9u9", function(module, exports) {

$parcel$export(module.exports, "persistFlexSchedulePresetAssignmentsAfterPatch", () => $42145cdfec1604d8$export$1d3e2355567ee72d);
/**
 * After a successful flex_schedule PATCH, push flex ignore zone preset selections
 * (camera-schedule-preset) from the onboarding store. Dynamic import avoids a
 * circular dependency between siteAboutStore and flexIgnoreZonesOnboardingStore.
 */ 
async function $42145cdfec1604d8$export$1d3e2355567ee72d(siteId, flexSchedulesResponse) {
    try {
        const { useFlexIgnoreZonesOnboardingStore: useFlexIgnoreZonesOnboardingStore } = await Promise.resolve((parcelRequire("eYzFO")));
        const persistResult = await useFlexIgnoreZonesOnboardingStore.getState().persistFlexSchedulePresetAssignments(siteId, flexSchedulesResponse);
        if (!persistResult.ok) alert(persistResult.error || "Schedule times were saved, but flex ignore zone preset assignments could not be updated.");
    } catch  {
        alert("Schedule times were saved, but flex ignore zone preset assignments could not be updated.");
    }
}

});

parcelRegister("7ZVeh", function(module, exports) {

$parcel$export(module.exports, "blockOnFlexPresetConflicts", () => $a529e36ac318f460$export$efd6d45f8b0d9e9c);

var $5P5Ui = parcelRequire("5P5Ui");

async function $a529e36ac318f460$export$efd6d45f8b0d9e9c(siteInfo, flexSchedules) {
    if (!(0, $5P5Ui.isFleetSite)(siteInfo)) return false;
    try {
        const { useFlexIgnoreZonesOnboardingStore: useFlexIgnoreZonesOnboardingStore } = await Promise.resolve((parcelRequire("eYzFO")));
        const conflicts = useFlexIgnoreZonesOnboardingStore.getState().getPresetConflictsForSite(siteInfo.id, flexSchedules);
        if (conflicts.length === 0) return false;
        alert((0, $5P5Ui.presetConflictsAlertText)(conflicts));
        return true;
    } catch  {
        // The server check still applies; don't block the save on a client error.
        return false;
    }
}

});



parcelRegister("fWdZn", function(module, exports) {
module.exports = import("gJ7zX").then(()=>parcelRequire('b7g9k'));

});

parcelRegister("6JVXJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $4e83e82aed4f9e97$var$_react = $4e83e82aed4f9e97$var$_interopRequireDefault((parcelRequire("8T3gX")));

var $cm1Gu = parcelRequire("cm1Gu");

var $4e83e82aed4f9e97$var$_json2mq = $4e83e82aed4f9e97$var$_interopRequireDefault((parcelRequire("f8V7z")));

var $4e83e82aed4f9e97$var$_defaultProps = $4e83e82aed4f9e97$var$_interopRequireDefault((parcelRequire("57X2G")));

var $5JcZe = parcelRequire("5JcZe");
function $4e83e82aed4f9e97$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $4e83e82aed4f9e97$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4e83e82aed4f9e97$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4e83e82aed4f9e97$var$_typeof(o);
}
function $4e83e82aed4f9e97$var$_extends() {
    return $4e83e82aed4f9e97$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4e83e82aed4f9e97$var$_extends.apply(null, arguments);
}
function $4e83e82aed4f9e97$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4e83e82aed4f9e97$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4e83e82aed4f9e97$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4e83e82aed4f9e97$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4e83e82aed4f9e97$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4e83e82aed4f9e97$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $4e83e82aed4f9e97$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $4e83e82aed4f9e97$var$_toPropertyKey(o.key), o);
    }
}
function $4e83e82aed4f9e97$var$_createClass(e, r, t) {
    return r && $4e83e82aed4f9e97$var$_defineProperties(e.prototype, r), t && $4e83e82aed4f9e97$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $4e83e82aed4f9e97$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $4e83e82aed4f9e97$var$_setPrototypeOf(t, e);
}
function $4e83e82aed4f9e97$var$_setPrototypeOf(t, e) {
    return $4e83e82aed4f9e97$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $4e83e82aed4f9e97$var$_setPrototypeOf(t, e);
}
function $4e83e82aed4f9e97$var$_createSuper(t) {
    var r = $4e83e82aed4f9e97$var$_isNativeReflectConstruct();
    return function() {
        var e, o = $4e83e82aed4f9e97$var$_getPrototypeOf(t);
        if (r) {
            var s = $4e83e82aed4f9e97$var$_getPrototypeOf(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return $4e83e82aed4f9e97$var$_possibleConstructorReturn(this, e);
    };
}
function $4e83e82aed4f9e97$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $4e83e82aed4f9e97$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $4e83e82aed4f9e97$var$_assertThisInitialized(t);
}
function $4e83e82aed4f9e97$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function $4e83e82aed4f9e97$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($4e83e82aed4f9e97$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $4e83e82aed4f9e97$var$_getPrototypeOf(t) {
    return $4e83e82aed4f9e97$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $4e83e82aed4f9e97$var$_getPrototypeOf(t);
}
function $4e83e82aed4f9e97$var$_defineProperty(e, r, t) {
    return (r = $4e83e82aed4f9e97$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4e83e82aed4f9e97$var$_toPropertyKey(t) {
    var i = $4e83e82aed4f9e97$var$_toPrimitive(t, "string");
    return "symbol" == $4e83e82aed4f9e97$var$_typeof(i) ? i : i + "";
}
function $4e83e82aed4f9e97$var$_toPrimitive(t, r) {
    if ("object" != $4e83e82aed4f9e97$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4e83e82aed4f9e97$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $4e83e82aed4f9e97$var$Slider = module.exports["default"] = /*#__PURE__*/ function(_React$Component) {
    $4e83e82aed4f9e97$var$_inherits(Slider, _React$Component);
    var _super = $4e83e82aed4f9e97$var$_createSuper(Slider);
    function Slider(props) {
        var _this;
        $4e83e82aed4f9e97$var$_classCallCheck(this, Slider);
        _this = _super.call(this, props);
        $4e83e82aed4f9e97$var$_defineProperty($4e83e82aed4f9e97$var$_assertThisInitialized(_this), "innerSliderRefHandler", function(ref) {
            return _this.innerSlider = ref;
        });
        $4e83e82aed4f9e97$var$_defineProperty($4e83e82aed4f9e97$var$_assertThisInitialized(_this), "slickPrev", function() {
            return _this.innerSlider.slickPrev();
        });
        $4e83e82aed4f9e97$var$_defineProperty($4e83e82aed4f9e97$var$_assertThisInitialized(_this), "slickNext", function() {
            return _this.innerSlider.slickNext();
        });
        $4e83e82aed4f9e97$var$_defineProperty($4e83e82aed4f9e97$var$_assertThisInitialized(_this), "slickGoTo", function(slide) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            return _this.innerSlider.slickGoTo(slide, dontAnimate);
        });
        $4e83e82aed4f9e97$var$_defineProperty($4e83e82aed4f9e97$var$_assertThisInitialized(_this), "slickPause", function() {
            return _this.innerSlider.pause("paused");
        });
        $4e83e82aed4f9e97$var$_defineProperty($4e83e82aed4f9e97$var$_assertThisInitialized(_this), "slickPlay", function() {
            return _this.innerSlider.autoPlay("play");
        });
        _this.state = {
            breakpoint: null
        };
        _this._responsiveMediaHandlers = [];
        return _this;
    }
    $4e83e82aed4f9e97$var$_createClass(Slider, [
        {
            key: "media",
            value: function media(query, handler) {
                // javascript handler for  css media query
                var mql = window.matchMedia(query);
                var listener = function listener(_ref) {
                    var matches = _ref.matches;
                    if (matches) handler();
                };
                mql.addListener(listener);
                this._responsiveMediaHandlers.push({
                    mql: mql,
                    query: query,
                    listener: listener
                });
            } // handles responsive breakpoints
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                // performance monitoring
                //if (process.env.NODE_ENV !== 'production') {
                //const { whyDidYouUpdate } = require('why-did-you-update')
                //whyDidYouUpdate(React)
                //}
                if (this.props.responsive) {
                    var breakpoints = this.props.responsive.map(function(breakpt) {
                        return breakpt.breakpoint;
                    });
                    // sort them in increasing order of their numerical value
                    breakpoints.sort(function(x, y) {
                        return x - y;
                    });
                    breakpoints.forEach(function(breakpoint, index) {
                        // media query for each breakpoint
                        var bQuery;
                        if (index === 0) bQuery = (0, $4e83e82aed4f9e97$var$_json2mq["default"])({
                            minWidth: 0,
                            maxWidth: breakpoint
                        });
                        else bQuery = (0, $4e83e82aed4f9e97$var$_json2mq["default"])({
                            minWidth: breakpoints[index - 1] + 1,
                            maxWidth: breakpoint
                        });
                        // when not using server side rendering
                        (0, $5JcZe.canUseDOM)() && _this2.media(bQuery, function() {
                            _this2.setState({
                                breakpoint: breakpoint
                            });
                        });
                    });
                    // Register media query for full screen. Need to support resize from small to large
                    // convert javascript object to media query string
                    var query = (0, $4e83e82aed4f9e97$var$_json2mq["default"])({
                        minWidth: breakpoints.slice(-1)[0]
                    });
                    (0, $5JcZe.canUseDOM)() && this.media(query, function() {
                        _this2.setState({
                            breakpoint: null
                        });
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._responsiveMediaHandlers.forEach(function(obj) {
                    obj.mql.removeListener(obj.listener);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var settings;
                var newProps;
                if (this.state.breakpoint) {
                    newProps = this.props.responsive.filter(function(resp) {
                        return resp.breakpoint === _this3.state.breakpoint;
                    });
                    settings = newProps[0].settings === "unslick" ? "unslick" : $4e83e82aed4f9e97$var$_objectSpread($4e83e82aed4f9e97$var$_objectSpread($4e83e82aed4f9e97$var$_objectSpread({}, $4e83e82aed4f9e97$var$_defaultProps["default"]), this.props), newProps[0].settings);
                } else settings = $4e83e82aed4f9e97$var$_objectSpread($4e83e82aed4f9e97$var$_objectSpread({}, $4e83e82aed4f9e97$var$_defaultProps["default"]), this.props);
                // force scrolling by one if centerMode is on
                if (settings.centerMode) {
                    if (settings.slidesToScroll > 1 && true) console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
                    settings.slidesToScroll = 1;
                }
                // force showing one slide and scrolling by one if the fade mode is on
                if (settings.fade) {
                    if (settings.slidesToShow > 1 && true) console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
                    if (settings.slidesToScroll > 1 && true) console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
                    settings.slidesToShow = 1;
                    settings.slidesToScroll = 1;
                }
                // makes sure that children is an array, even when there is only 1 child
                var children = $4e83e82aed4f9e97$var$_react["default"].Children.toArray(this.props.children);
                // Children may contain false or null, so we should filter them
                // children may also contain string filled with spaces (in certain cases where we use jsx strings)
                children = children.filter(function(child) {
                    if (typeof child === "string") return !!child.trim();
                    return !!child;
                });
                // rows and slidesPerRow logic is handled here
                if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
                    console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
                    settings.variableWidth = false;
                }
                var newChildren = [];
                var currentWidth = null;
                for(var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow){
                    var newSlide = [];
                    for(var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow){
                        var row = [];
                        for(var k = j; k < j + settings.slidesPerRow; k += 1){
                            if (settings.variableWidth && children[k].props.style) currentWidth = children[k].props.style.width;
                            if (k >= children.length) break;
                            row.push(/*#__PURE__*/ $4e83e82aed4f9e97$var$_react["default"].cloneElement(children[k], {
                                key: 100 * i + 10 * j + k,
                                tabIndex: -1,
                                style: {
                                    width: "".concat(100 / settings.slidesPerRow, "%"),
                                    display: "inline-block"
                                }
                            }));
                        }
                        newSlide.push(/*#__PURE__*/ $4e83e82aed4f9e97$var$_react["default"].createElement("div", {
                            key: 10 * i + j
                        }, row));
                    }
                    if (settings.variableWidth) newChildren.push(/*#__PURE__*/ $4e83e82aed4f9e97$var$_react["default"].createElement("div", {
                        key: i,
                        style: {
                            width: currentWidth
                        }
                    }, newSlide));
                    else newChildren.push(/*#__PURE__*/ $4e83e82aed4f9e97$var$_react["default"].createElement("div", {
                        key: i
                    }, newSlide));
                }
                if (settings === "unslick") {
                    var className = "regular slider " + (this.props.className || "");
                    return /*#__PURE__*/ $4e83e82aed4f9e97$var$_react["default"].createElement("div", {
                        className: className
                    }, children);
                } else if (newChildren.length <= settings.slidesToShow) settings.unslick = true;
                return /*#__PURE__*/ $4e83e82aed4f9e97$var$_react["default"].createElement($cm1Gu.InnerSlider, $4e83e82aed4f9e97$var$_extends({
                    style: this.props.style,
                    ref: this.innerSliderRefHandler
                }, (0, $5JcZe.filterSettings)(settings)), newChildren);
            }
        }
    ]);
    return Slider;
}($4e83e82aed4f9e97$var$_react["default"].Component);

});
parcelRegister("cm1Gu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InnerSlider = void 0;

var $8fe8d88fb6fdde78$var$_react = $8fe8d88fb6fdde78$var$_interopRequireDefault((parcelRequire("8T3gX")));

var $8fe8d88fb6fdde78$var$_initialState = $8fe8d88fb6fdde78$var$_interopRequireDefault((parcelRequire("3URpg")));

var $8fe8d88fb6fdde78$var$_lodash = $8fe8d88fb6fdde78$var$_interopRequireDefault((parcelRequire("hSflS")));

var $8fe8d88fb6fdde78$var$_classnames = $8fe8d88fb6fdde78$var$_interopRequireDefault((parcelRequire("i02Bg")));

var $5JcZe = parcelRequire("5JcZe");

var $1pCIF = parcelRequire("1pCIF");

var $auwzK = parcelRequire("auwzK");

var $ai95H = parcelRequire("ai95H");

var $8fe8d88fb6fdde78$var$_resizeObserverPolyfill = $8fe8d88fb6fdde78$var$_interopRequireDefault((parcelRequire("6IXhZ")));
function $8fe8d88fb6fdde78$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $8fe8d88fb6fdde78$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8fe8d88fb6fdde78$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8fe8d88fb6fdde78$var$_typeof(o);
}
function $8fe8d88fb6fdde78$var$_extends() {
    return $8fe8d88fb6fdde78$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8fe8d88fb6fdde78$var$_extends.apply(null, arguments);
}
function $8fe8d88fb6fdde78$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $8fe8d88fb6fdde78$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $8fe8d88fb6fdde78$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $8fe8d88fb6fdde78$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8fe8d88fb6fdde78$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8fe8d88fb6fdde78$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8fe8d88fb6fdde78$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8fe8d88fb6fdde78$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8fe8d88fb6fdde78$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $8fe8d88fb6fdde78$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $8fe8d88fb6fdde78$var$_toPropertyKey(o.key), o);
    }
}
function $8fe8d88fb6fdde78$var$_createClass(e, r, t) {
    return r && $8fe8d88fb6fdde78$var$_defineProperties(e.prototype, r), t && $8fe8d88fb6fdde78$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $8fe8d88fb6fdde78$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $8fe8d88fb6fdde78$var$_setPrototypeOf(t, e);
}
function $8fe8d88fb6fdde78$var$_setPrototypeOf(t, e) {
    return $8fe8d88fb6fdde78$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $8fe8d88fb6fdde78$var$_setPrototypeOf(t, e);
}
function $8fe8d88fb6fdde78$var$_createSuper(t) {
    var r = $8fe8d88fb6fdde78$var$_isNativeReflectConstruct();
    return function() {
        var e, o = $8fe8d88fb6fdde78$var$_getPrototypeOf(t);
        if (r) {
            var s = $8fe8d88fb6fdde78$var$_getPrototypeOf(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return $8fe8d88fb6fdde78$var$_possibleConstructorReturn(this, e);
    };
}
function $8fe8d88fb6fdde78$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $8fe8d88fb6fdde78$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $8fe8d88fb6fdde78$var$_assertThisInitialized(t);
}
function $8fe8d88fb6fdde78$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function $8fe8d88fb6fdde78$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($8fe8d88fb6fdde78$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $8fe8d88fb6fdde78$var$_getPrototypeOf(t) {
    return $8fe8d88fb6fdde78$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $8fe8d88fb6fdde78$var$_getPrototypeOf(t);
}
function $8fe8d88fb6fdde78$var$_defineProperty(e, r, t) {
    return (r = $8fe8d88fb6fdde78$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $8fe8d88fb6fdde78$var$_toPropertyKey(t) {
    var i = $8fe8d88fb6fdde78$var$_toPrimitive(t, "string");
    return "symbol" == $8fe8d88fb6fdde78$var$_typeof(i) ? i : i + "";
}
function $8fe8d88fb6fdde78$var$_toPrimitive(t, r) {
    if ("object" != $8fe8d88fb6fdde78$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8fe8d88fb6fdde78$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $8fe8d88fb6fdde78$var$InnerSlider = module.exports.InnerSlider = /*#__PURE__*/ function(_React$Component) {
    $8fe8d88fb6fdde78$var$_inherits(InnerSlider, _React$Component);
    var _super = $8fe8d88fb6fdde78$var$_createSuper(InnerSlider);
    function InnerSlider(props) {
        var _this;
        $8fe8d88fb6fdde78$var$_classCallCheck(this, InnerSlider);
        _this = _super.call(this, props);
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "listRefHandler", function(ref) {
            return _this.list = ref;
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "trackRefHandler", function(ref) {
            return _this.track = ref;
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "adaptHeight", function() {
            if (_this.props.adaptiveHeight && _this.list) {
                var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));
                _this.list.style.height = (0, $5JcZe.getHeight)(elem) + "px";
            }
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "componentDidMount", function() {
            _this.props.onInit && _this.props.onInit();
            if (_this.props.lazyLoad) {
                var slidesToLoad = (0, $5JcZe.getOnDemandLazySlides)($8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread({}, _this.props), _this.state));
                if (slidesToLoad.length > 0) {
                    _this.setState(function(prevState) {
                        return {
                            lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
                        };
                    });
                    if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
                }
            }
            var spec = $8fe8d88fb6fdde78$var$_objectSpread({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props);
            _this.updateState(spec, true, function() {
                _this.adaptHeight();
                _this.props.autoplay && _this.autoPlay("update");
            });
            if (_this.props.lazyLoad === "progressive") _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
            _this.ro = new $8fe8d88fb6fdde78$var$_resizeObserverPolyfill["default"](function() {
                if (_this.state.animating) {
                    _this.onWindowResized(false); // don't set trackStyle hence don't break animation
                    _this.callbackTimers.push(setTimeout(function() {
                        return _this.onWindowResized();
                    }, _this.props.speed));
                } else _this.onWindowResized();
            });
            _this.ro.observe(_this.list);
            document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function(slide) {
                slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
                slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
            });
            if (window.addEventListener) window.addEventListener("resize", _this.onWindowResized);
            else window.attachEvent("onresize", _this.onWindowResized);
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "componentWillUnmount", function() {
            if (_this.animationEndCallback) clearTimeout(_this.animationEndCallback);
            if (_this.lazyLoadTimer) clearInterval(_this.lazyLoadTimer);
            if (_this.callbackTimers.length) {
                _this.callbackTimers.forEach(function(timer) {
                    return clearTimeout(timer);
                });
                _this.callbackTimers = [];
            }
            if (window.addEventListener) window.removeEventListener("resize", _this.onWindowResized);
            else window.detachEvent("onresize", _this.onWindowResized);
            if (_this.autoplayTimer) clearInterval(_this.autoplayTimer);
            _this.ro.disconnect();
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "componentDidUpdate", function(prevProps) {
            _this.checkImagesLoad();
            _this.props.onReInit && _this.props.onReInit();
            if (_this.props.lazyLoad) {
                var slidesToLoad = (0, $5JcZe.getOnDemandLazySlides)($8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread({}, _this.props), _this.state));
                if (slidesToLoad.length > 0) {
                    _this.setState(function(prevState) {
                        return {
                            lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
                        };
                    });
                    if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
                }
            }
            // if (this.props.onLazyLoad) {
            //   this.props.onLazyLoad([leftMostSlide])
            // }
            _this.adaptHeight();
            var spec = $8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props), _this.state);
            var setTrackStyle = _this.didPropsChange(prevProps);
            setTrackStyle && _this.updateState(spec, setTrackStyle, function() {
                if (_this.state.currentSlide >= $8fe8d88fb6fdde78$var$_react["default"].Children.count(_this.props.children)) _this.changeSlide({
                    message: "index",
                    index: $8fe8d88fb6fdde78$var$_react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
                    currentSlide: _this.state.currentSlide
                });
                if (_this.props.autoplay) _this.autoPlay("update");
                else _this.pause("paused");
            });
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "onWindowResized", function(setTrackStyle) {
            if (_this.debouncedResize) _this.debouncedResize.cancel();
            _this.debouncedResize = (0, $8fe8d88fb6fdde78$var$_lodash["default"])(function() {
                return _this.resizeWindow(setTrackStyle);
            }, 50);
            _this.debouncedResize();
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "resizeWindow", function() {
            var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var isTrackMounted = Boolean(_this.track && _this.track.node);
            // prevent warning: setting state on unmounted component (server side rendering)
            if (!isTrackMounted) return;
            var spec = $8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props), _this.state);
            _this.updateState(spec, setTrackStyle, function() {
                if (_this.props.autoplay) _this.autoPlay("update");
                else _this.pause("paused");
            });
            // animating state should be cleared while resizing, otherwise autoplay stops working
            _this.setState({
                animating: false
            });
            clearTimeout(_this.animationEndCallback);
            delete _this.animationEndCallback;
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "updateState", function(spec, setTrackStyle, callback) {
            var updatedState = (0, $5JcZe.initializedState)(spec);
            spec = $8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread({}, spec), updatedState), {}, {
                slideIndex: updatedState.currentSlide
            });
            var targetLeft = (0, $5JcZe.getTrackLeft)(spec);
            spec = $8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread({}, spec), {}, {
                left: targetLeft
            });
            var trackStyle = (0, $5JcZe.getTrackCSS)(spec);
            if (setTrackStyle || $8fe8d88fb6fdde78$var$_react["default"].Children.count(_this.props.children) !== $8fe8d88fb6fdde78$var$_react["default"].Children.count(spec.children)) updatedState["trackStyle"] = trackStyle;
            _this.setState(updatedState, callback);
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "ssrInit", function() {
            if (_this.props.variableWidth) {
                var _trackWidth = 0, _trackLeft = 0;
                var childrenWidths = [];
                var preClones = (0, $5JcZe.getPreClones)($8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread({}, _this.props), _this.state), {}, {
                    slideCount: _this.props.children.length
                }));
                var postClones = (0, $5JcZe.getPostClones)($8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread({}, _this.props), _this.state), {}, {
                    slideCount: _this.props.children.length
                }));
                _this.props.children.forEach(function(child) {
                    childrenWidths.push(child.props.style.width);
                    _trackWidth += child.props.style.width;
                });
                for(var i = 0; i < preClones; i++){
                    _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
                    _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
                }
                for(var _i = 0; _i < postClones; _i++)_trackWidth += childrenWidths[_i];
                for(var _i2 = 0; _i2 < _this.state.currentSlide; _i2++)_trackLeft += childrenWidths[_i2];
                var _trackStyle = {
                    width: _trackWidth + "px",
                    left: -_trackLeft + "px"
                };
                if (_this.props.centerMode) {
                    var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
                    _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
                }
                return {
                    trackStyle: _trackStyle
                };
            }
            var childrenCount = $8fe8d88fb6fdde78$var$_react["default"].Children.count(_this.props.children);
            var spec = $8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread({}, _this.props), _this.state), {}, {
                slideCount: childrenCount
            });
            var slideCount = (0, $5JcZe.getPreClones)(spec) + (0, $5JcZe.getPostClones)(spec) + childrenCount;
            var trackWidth = 100 / _this.props.slidesToShow * slideCount;
            var slideWidth = 100 / slideCount;
            var trackLeft = -slideWidth * ((0, $5JcZe.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
            if (_this.props.centerMode) trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
            var trackStyle = {
                width: trackWidth + "%",
                left: trackLeft + "%"
            };
            return {
                slideWidth: slideWidth + "%",
                trackStyle: trackStyle
            };
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "checkImagesLoad", function() {
            var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
            var imagesCount = images.length, loadedCount = 0;
            Array.prototype.forEach.call(images, function(image) {
                var handler = function handler() {
                    return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
                };
                if (!image.onclick) image.onclick = function() {
                    return image.parentNode.focus();
                };
                else {
                    var prevClickHandler = image.onclick;
                    image.onclick = function(e) {
                        prevClickHandler(e);
                        image.parentNode.focus();
                    };
                }
                if (!image.onload) {
                    if (_this.props.lazyLoad) image.onload = function() {
                        _this.adaptHeight();
                        _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
                    };
                    else {
                        image.onload = handler;
                        image.onerror = function() {
                            handler();
                            _this.props.onLazyLoadError && _this.props.onLazyLoadError();
                        };
                    }
                }
            });
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "progressiveLazyLoad", function() {
            var slidesToLoad = [];
            var spec = $8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread({}, _this.props), _this.state);
            for(var index = _this.state.currentSlide; index < _this.state.slideCount + (0, $5JcZe.getPostClones)(spec); index++)if (_this.state.lazyLoadedList.indexOf(index) < 0) {
                slidesToLoad.push(index);
                break;
            }
            for(var _index = _this.state.currentSlide - 1; _index >= -(0, $5JcZe.getPreClones)(spec); _index--)if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
                slidesToLoad.push(_index);
                break;
            }
            if (slidesToLoad.length > 0) {
                _this.setState(function(state) {
                    return {
                        lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
                    };
                });
                if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
            } else if (_this.lazyLoadTimer) {
                clearInterval(_this.lazyLoadTimer);
                delete _this.lazyLoadTimer;
            }
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "slideHandler", function(index) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var _this$props = _this.props, asNavFor = _this$props.asNavFor, beforeChange = _this$props.beforeChange, onLazyLoad = _this$props.onLazyLoad, speed = _this$props.speed, afterChange = _this$props.afterChange; // capture currentslide before state is updated
            var currentSlide = _this.state.currentSlide;
            var _slideHandler = (0, $5JcZe.slideHandler)($8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread({
                index: index
            }, _this.props), _this.state), {}, {
                trackRef: _this.track,
                useCSS: _this.props.useCSS && !dontAnimate
            })), state = _slideHandler.state, nextState = _slideHandler.nextState;
            if (!state) return;
            beforeChange && beforeChange(currentSlide, state.currentSlide);
            var slidesToLoad = state.lazyLoadedList.filter(function(value) {
                return _this.state.lazyLoadedList.indexOf(value) < 0;
            });
            onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
            if (!_this.props.waitForAnimate && _this.animationEndCallback) {
                clearTimeout(_this.animationEndCallback);
                afterChange && afterChange(currentSlide);
                delete _this.animationEndCallback;
            }
            _this.setState(state, function() {
                // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
                if (asNavFor && _this.asNavForIndex !== index) {
                    _this.asNavForIndex = index;
                    asNavFor.innerSlider.slideHandler(index);
                }
                if (!nextState) return;
                _this.animationEndCallback = setTimeout(function() {
                    var animating = nextState.animating, firstBatch = $8fe8d88fb6fdde78$var$_objectWithoutProperties(nextState, [
                        "animating"
                    ]);
                    _this.setState(firstBatch, function() {
                        _this.callbackTimers.push(setTimeout(function() {
                            return _this.setState({
                                animating: animating
                            });
                        }, 10));
                        afterChange && afterChange(state.currentSlide);
                        delete _this.animationEndCallback;
                    });
                }, speed);
            });
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "changeSlide", function(options) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var spec = $8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread({}, _this.props), _this.state);
            var targetSlide = (0, $5JcZe.changeSlide)(spec, options);
            if (targetSlide !== 0 && !targetSlide) return;
            if (dontAnimate === true) _this.slideHandler(targetSlide, dontAnimate);
            else _this.slideHandler(targetSlide);
            _this.props.autoplay && _this.autoPlay("update");
            if (_this.props.focusOnSelect) {
                var nodes = _this.list.querySelectorAll(".slick-current");
                nodes[0] && nodes[0].focus();
            }
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "clickHandler", function(e) {
            if (_this.clickable === false) {
                e.stopPropagation();
                e.preventDefault();
            }
            _this.clickable = true;
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "keyHandler", function(e) {
            var dir = (0, $5JcZe.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
            dir !== "" && _this.changeSlide({
                message: dir
            });
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "selectHandler", function(options) {
            _this.changeSlide(options);
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "disableBodyScroll", function() {
            var preventDefault = function preventDefault(e) {
                e = e || window.event;
                if (e.preventDefault) e.preventDefault();
                e.returnValue = false;
            };
            window.ontouchmove = preventDefault;
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "enableBodyScroll", function() {
            window.ontouchmove = null;
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "swipeStart", function(e) {
            if (_this.props.verticalSwiping) _this.disableBodyScroll();
            var state = (0, $5JcZe.swipeStart)(e, _this.props.swipe, _this.props.draggable);
            state !== "" && _this.setState(state);
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "swipeMove", function(e) {
            var state = (0, $5JcZe.swipeMove)(e, $8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread({}, _this.props), _this.state), {}, {
                trackRef: _this.track,
                listRef: _this.list,
                slideIndex: _this.state.currentSlide
            }));
            if (!state) return;
            if (state["swiping"]) _this.clickable = false;
            _this.setState(state);
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "swipeEnd", function(e) {
            var state = (0, $5JcZe.swipeEnd)(e, $8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread({}, _this.props), _this.state), {}, {
                trackRef: _this.track,
                listRef: _this.list,
                slideIndex: _this.state.currentSlide
            }));
            if (!state) return;
            var triggerSlideHandler = state["triggerSlideHandler"];
            delete state["triggerSlideHandler"];
            _this.setState(state);
            if (triggerSlideHandler === undefined) return;
            _this.slideHandler(triggerSlideHandler);
            if (_this.props.verticalSwiping) _this.enableBodyScroll();
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "touchEnd", function(e) {
            _this.swipeEnd(e);
            _this.clickable = true;
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "slickPrev", function() {
            // this and fellow methods are wrapped in setTimeout
            // to make sure initialize setState has happened before
            // any of such methods are called
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "previous"
                });
            }, 0));
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "slickNext", function() {
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "next"
                });
            }, 0));
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "slickGoTo", function(slide) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            slide = Number(slide);
            if (isNaN(slide)) return "";
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "index",
                    index: slide,
                    currentSlide: _this.state.currentSlide
                }, dontAnimate);
            }, 0));
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "play", function() {
            var nextIndex;
            if (_this.props.rtl) nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
            else {
                if ((0, $5JcZe.canGoNext)($8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread({}, _this.props), _this.state))) nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
                else return false;
            }
            _this.slideHandler(nextIndex);
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "autoPlay", function(playType) {
            if (_this.autoplayTimer) clearInterval(_this.autoplayTimer);
            var autoplaying = _this.state.autoplaying;
            if (playType === "update") {
                if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") return;
            } else if (playType === "leave") {
                if (autoplaying === "paused" || autoplaying === "focused") return;
            } else if (playType === "blur") {
                if (autoplaying === "paused" || autoplaying === "hovered") return;
            }
            _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
            _this.setState({
                autoplaying: "playing"
            });
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "pause", function(pauseType) {
            if (_this.autoplayTimer) {
                clearInterval(_this.autoplayTimer);
                _this.autoplayTimer = null;
            }
            var autoplaying = _this.state.autoplaying;
            if (pauseType === "paused") _this.setState({
                autoplaying: "paused"
            });
            else if (pauseType === "focused") {
                if (autoplaying === "hovered" || autoplaying === "playing") _this.setState({
                    autoplaying: "focused"
                });
            } else // pauseType  is 'hovered'
            if (autoplaying === "playing") _this.setState({
                autoplaying: "hovered"
            });
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "onDotsOver", function() {
            return _this.props.autoplay && _this.pause("hovered");
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "onDotsLeave", function() {
            return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "onTrackOver", function() {
            return _this.props.autoplay && _this.pause("hovered");
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "onTrackLeave", function() {
            return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "onSlideFocus", function() {
            return _this.props.autoplay && _this.pause("focused");
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "onSlideBlur", function() {
            return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
        });
        $8fe8d88fb6fdde78$var$_defineProperty($8fe8d88fb6fdde78$var$_assertThisInitialized(_this), "render", function() {
            var className = (0, $8fe8d88fb6fdde78$var$_classnames["default"])("slick-slider", _this.props.className, {
                "slick-vertical": _this.props.vertical,
                "slick-initialized": true
            });
            var spec = $8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread({}, _this.props), _this.state);
            var trackProps = (0, $5JcZe.extractObject)(spec, [
                "fade",
                "cssEase",
                "speed",
                "infinite",
                "centerMode",
                "focusOnSelect",
                "currentSlide",
                "lazyLoad",
                "lazyLoadedList",
                "rtl",
                "slideWidth",
                "slideHeight",
                "listHeight",
                "vertical",
                "slidesToShow",
                "slidesToScroll",
                "slideCount",
                "trackStyle",
                "variableWidth",
                "unslick",
                "centerPadding",
                "targetSlide",
                "useCSS"
            ]);
            var pauseOnHover = _this.props.pauseOnHover;
            trackProps = $8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread({}, trackProps), {}, {
                onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
                onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
                onMouseOver: pauseOnHover ? _this.onTrackOver : null,
                focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
            });
            var dots;
            if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
                var dotProps = (0, $5JcZe.extractObject)(spec, [
                    "dotsClass",
                    "slideCount",
                    "slidesToShow",
                    "currentSlide",
                    "slidesToScroll",
                    "clickHandler",
                    "children",
                    "customPaging",
                    "infinite",
                    "appendDots"
                ]);
                var pauseOnDotsHover = _this.props.pauseOnDotsHover;
                dotProps = $8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread({}, dotProps), {}, {
                    clickHandler: _this.changeSlide,
                    onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
                    onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
                    onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
                });
                dots = /*#__PURE__*/ $8fe8d88fb6fdde78$var$_react["default"].createElement($auwzK.Dots, dotProps);
            }
            var prevArrow, nextArrow;
            var arrowProps = (0, $5JcZe.extractObject)(spec, [
                "infinite",
                "centerMode",
                "currentSlide",
                "slideCount",
                "slidesToShow",
                "prevArrow",
                "nextArrow"
            ]);
            arrowProps.clickHandler = _this.changeSlide;
            if (_this.props.arrows) {
                prevArrow = /*#__PURE__*/ $8fe8d88fb6fdde78$var$_react["default"].createElement($ai95H.PrevArrow, arrowProps);
                nextArrow = /*#__PURE__*/ $8fe8d88fb6fdde78$var$_react["default"].createElement($ai95H.NextArrow, arrowProps);
            }
            var verticalHeightStyle = null;
            if (_this.props.vertical) verticalHeightStyle = {
                height: _this.state.listHeight
            };
            var centerPaddingStyle = null;
            if (_this.props.vertical === false) {
                if (_this.props.centerMode === true) centerPaddingStyle = {
                    padding: "0px " + _this.props.centerPadding
                };
            } else if (_this.props.centerMode === true) centerPaddingStyle = {
                padding: _this.props.centerPadding + " 0px"
            };
            var listStyle = $8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread({}, verticalHeightStyle), centerPaddingStyle);
            var touchMove = _this.props.touchMove;
            var listProps = {
                className: "slick-list",
                style: listStyle,
                onClick: _this.clickHandler,
                onMouseDown: touchMove ? _this.swipeStart : null,
                onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
                onMouseUp: touchMove ? _this.swipeEnd : null,
                onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
                onTouchStart: touchMove ? _this.swipeStart : null,
                onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
                onTouchEnd: touchMove ? _this.touchEnd : null,
                onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
                onKeyDown: _this.props.accessibility ? _this.keyHandler : null
            };
            var innerSliderProps = {
                className: className,
                dir: "ltr",
                style: _this.props.style
            };
            if (_this.props.unslick) {
                listProps = {
                    className: "slick-list"
                };
                innerSliderProps = {
                    className: className,
                    style: _this.props.style
                };
            }
            return /*#__PURE__*/ $8fe8d88fb6fdde78$var$_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/ $8fe8d88fb6fdde78$var$_react["default"].createElement("div", $8fe8d88fb6fdde78$var$_extends({
                ref: _this.listRefHandler
            }, listProps), /*#__PURE__*/ $8fe8d88fb6fdde78$var$_react["default"].createElement($1pCIF.Track, $8fe8d88fb6fdde78$var$_extends({
                ref: _this.trackRefHandler
            }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
        });
        _this.list = null;
        _this.track = null;
        _this.state = $8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread({}, $8fe8d88fb6fdde78$var$_initialState["default"]), {}, {
            currentSlide: _this.props.initialSlide,
            targetSlide: _this.props.initialSlide ? _this.props.initialSlide : 0,
            slideCount: $8fe8d88fb6fdde78$var$_react["default"].Children.count(_this.props.children)
        });
        _this.callbackTimers = [];
        _this.clickable = true;
        _this.debouncedResize = null;
        var ssrState = _this.ssrInit();
        _this.state = $8fe8d88fb6fdde78$var$_objectSpread($8fe8d88fb6fdde78$var$_objectSpread({}, _this.state), ssrState);
        return _this;
    }
    $8fe8d88fb6fdde78$var$_createClass(InnerSlider, [
        {
            key: "didPropsChange",
            value: function didPropsChange(prevProps) {
                var setTrackStyle = false;
                for(var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++){
                    var key = _Object$keys[_i3];
                    if (!prevProps.hasOwnProperty(key)) {
                        setTrackStyle = true;
                        break;
                    }
                    if ($8fe8d88fb6fdde78$var$_typeof(prevProps[key]) === "object" || typeof prevProps[key] === "function" || isNaN(prevProps[key])) continue;
                    if (prevProps[key] !== this.props[key]) {
                        setTrackStyle = true;
                        break;
                    }
                }
                return setTrackStyle || $8fe8d88fb6fdde78$var$_react["default"].Children.count(this.props.children) !== $8fe8d88fb6fdde78$var$_react["default"].Children.count(prevProps.children);
            }
        }
    ]);
    return InnerSlider;
}($8fe8d88fb6fdde78$var$_react["default"].Component);

});
parcelRegister("3URpg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $2da0077dc1235b03$var$initialState = {
    animating: false,
    autoplaying: null,
    currentDirection: 0,
    currentLeft: null,
    currentSlide: 0,
    direction: 1,
    dragging: false,
    edgeDragged: false,
    initialized: false,
    lazyLoadedList: [],
    listHeight: null,
    listWidth: null,
    scrolling: false,
    slideCount: null,
    slideHeight: null,
    slideWidth: null,
    swipeLeft: null,
    swiped: false,
    // used by swipeEvent. differentites between touch and swipe.
    swiping: false,
    touchObject: {
        startX: 0,
        startY: 0,
        curX: 0,
        curY: 0
    },
    trackStyle: {},
    trackWidth: 0,
    targetSlide: 0
};
var $2da0077dc1235b03$var$_default = module.exports["default"] = $2da0077dc1235b03$var$initialState;

});

parcelRegister("hSflS", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $d033635ebb90c6f9$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $d033635ebb90c6f9$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $d033635ebb90c6f9$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $d033635ebb90c6f9$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $d033635ebb90c6f9$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $d033635ebb90c6f9$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $d033635ebb90c6f9$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $d033635ebb90c6f9$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $d033635ebb90c6f9$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $d033635ebb90c6f9$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $d033635ebb90c6f9$var$root = $d033635ebb90c6f9$var$freeGlobal || $d033635ebb90c6f9$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $d033635ebb90c6f9$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $d033635ebb90c6f9$var$objectToString = $d033635ebb90c6f9$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d033635ebb90c6f9$var$nativeMax = Math.max, $d033635ebb90c6f9$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $d033635ebb90c6f9$var$now = function() {
    return $d033635ebb90c6f9$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $d033635ebb90c6f9$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($d033635ebb90c6f9$var$FUNC_ERROR_TEXT);
    wait = $d033635ebb90c6f9$var$toNumber(wait) || 0;
    if ($d033635ebb90c6f9$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $d033635ebb90c6f9$var$nativeMax($d033635ebb90c6f9$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $d033635ebb90c6f9$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $d033635ebb90c6f9$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($d033635ebb90c6f9$var$now());
    }
    function debounced() {
        var time = $d033635ebb90c6f9$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $d033635ebb90c6f9$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $d033635ebb90c6f9$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $d033635ebb90c6f9$var$isSymbol(value) {
    return typeof value == 'symbol' || $d033635ebb90c6f9$var$isObjectLike(value) && $d033635ebb90c6f9$var$objectToString.call(value) == $d033635ebb90c6f9$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $d033635ebb90c6f9$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($d033635ebb90c6f9$var$isSymbol(value)) return $d033635ebb90c6f9$var$NAN;
    if ($d033635ebb90c6f9$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $d033635ebb90c6f9$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($d033635ebb90c6f9$var$reTrim, '');
    var isBinary = $d033635ebb90c6f9$var$reIsBinary.test(value);
    return isBinary || $d033635ebb90c6f9$var$reIsOctal.test(value) ? $d033635ebb90c6f9$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $d033635ebb90c6f9$var$reIsBadHex.test(value) ? $d033635ebb90c6f9$var$NAN : +value;
}
module.exports = $d033635ebb90c6f9$var$debounce;

});

parcelRegister("i02Bg", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("5JcZe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkSpecKeys = module.exports.checkNavigable = module.exports.changeSlide = module.exports.canUseDOM = module.exports.canGoNext = void 0;
module.exports.clamp = $42bb3a95682ef960$var$clamp;
module.exports.extractObject = void 0;
module.exports.filterSettings = $42bb3a95682ef960$var$filterSettings;
module.exports.validSettings = module.exports.swipeStart = module.exports.swipeMove = module.exports.swipeEnd = module.exports.slidesOnRight = module.exports.slidesOnLeft = module.exports.slideHandler = module.exports.siblingDirection = module.exports.safePreventDefault = module.exports.lazyStartIndex = module.exports.lazySlidesOnRight = module.exports.lazySlidesOnLeft = module.exports.lazyEndIndex = module.exports.keyHandler = module.exports.initializedState = module.exports.getWidth = module.exports.getTrackLeft = module.exports.getTrackCSS = module.exports.getTrackAnimateCSS = module.exports.getTotalSlides = module.exports.getSwipeDirection = module.exports.getSlideCount = module.exports.getRequiredLazySlides = module.exports.getPreClones = module.exports.getPostClones = module.exports.getOnDemandLazySlides = module.exports.getNavigableIndexes = module.exports.getHeight = void 0;

var $42bb3a95682ef960$var$_react = $42bb3a95682ef960$var$_interopRequireDefault((parcelRequire("8T3gX")));

var $42bb3a95682ef960$var$_defaultProps = $42bb3a95682ef960$var$_interopRequireDefault((parcelRequire("57X2G")));
function $42bb3a95682ef960$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $42bb3a95682ef960$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $42bb3a95682ef960$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $42bb3a95682ef960$var$_typeof(o);
}
function $42bb3a95682ef960$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $42bb3a95682ef960$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $42bb3a95682ef960$var$ownKeys(Object(t), !0).forEach(function(r) {
            $42bb3a95682ef960$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $42bb3a95682ef960$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $42bb3a95682ef960$var$_defineProperty(e, r, t) {
    return (r = $42bb3a95682ef960$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $42bb3a95682ef960$var$_toPropertyKey(t) {
    var i = $42bb3a95682ef960$var$_toPrimitive(t, "string");
    return "symbol" == $42bb3a95682ef960$var$_typeof(i) ? i : i + "";
}
function $42bb3a95682ef960$var$_toPrimitive(t, r) {
    if ("object" != $42bb3a95682ef960$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $42bb3a95682ef960$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $42bb3a95682ef960$var$clamp(number, lowerBound, upperBound) {
    return Math.max(lowerBound, Math.min(number, upperBound));
}
var $42bb3a95682ef960$var$safePreventDefault = module.exports.safePreventDefault = function safePreventDefault(event) {
    var passiveEvents = [
        "onTouchStart",
        "onTouchMove",
        "onWheel"
    ];
    if (!passiveEvents.includes(event._reactName)) event.preventDefault();
};
var $42bb3a95682ef960$var$getOnDemandLazySlides = module.exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
    var onDemandSlides = [];
    var startIndex = $42bb3a95682ef960$var$lazyStartIndex(spec);
    var endIndex = $42bb3a95682ef960$var$lazyEndIndex(spec);
    for(var slideIndex = startIndex; slideIndex < endIndex; slideIndex++)if (spec.lazyLoadedList.indexOf(slideIndex) < 0) onDemandSlides.push(slideIndex);
    return onDemandSlides;
};
// return list of slides that need to be present
var $42bb3a95682ef960$var$getRequiredLazySlides = module.exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
    var requiredSlides = [];
    var startIndex = $42bb3a95682ef960$var$lazyStartIndex(spec);
    var endIndex = $42bb3a95682ef960$var$lazyEndIndex(spec);
    for(var slideIndex = startIndex; slideIndex < endIndex; slideIndex++)requiredSlides.push(slideIndex);
    return requiredSlides;
};
// startIndex that needs to be present
var $42bb3a95682ef960$var$lazyStartIndex = module.exports.lazyStartIndex = function lazyStartIndex(spec) {
    return spec.currentSlide - $42bb3a95682ef960$var$lazySlidesOnLeft(spec);
};
var $42bb3a95682ef960$var$lazyEndIndex = module.exports.lazyEndIndex = function lazyEndIndex(spec) {
    return spec.currentSlide + $42bb3a95682ef960$var$lazySlidesOnRight(spec);
};
var $42bb3a95682ef960$var$lazySlidesOnLeft = module.exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
    return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var $42bb3a95682ef960$var$lazySlidesOnRight = module.exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
    return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};
// get width of an element
var $42bb3a95682ef960$var$getWidth = module.exports.getWidth = function getWidth(elem) {
    return elem && elem.offsetWidth || 0;
};
var $42bb3a95682ef960$var$getHeight = module.exports.getHeight = function getHeight(elem) {
    return elem && elem.offsetHeight || 0;
};
var $42bb3a95682ef960$var$getSwipeDirection = module.exports.getSwipeDirection = function getSwipeDirection(touchObject) {
    var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var xDist, yDist, r, swipeAngle;
    xDist = touchObject.startX - touchObject.curX;
    yDist = touchObject.startY - touchObject.curY;
    r = Math.atan2(yDist, xDist);
    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) swipeAngle = 360 - Math.abs(swipeAngle);
    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) return "left";
    if (swipeAngle >= 135 && swipeAngle <= 225) return "right";
    if (verticalSwiping === true) {
        if (swipeAngle >= 35 && swipeAngle <= 135) return "up";
        else return "down";
    }
    return "vertical";
};
// whether or not we can go next
var $42bb3a95682ef960$var$canGoNext = module.exports.canGoNext = function canGoNext(spec) {
    var canGo = true;
    if (!spec.infinite) {
        if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) canGo = false;
        else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) canGo = false;
    }
    return canGo;
};
// given an object and a list of keys, return new object with given keys
var $42bb3a95682ef960$var$extractObject = module.exports.extractObject = function extractObject(spec, keys) {
    var newObject = {};
    keys.forEach(function(key) {
        return newObject[key] = spec[key];
    });
    return newObject;
};
// get initialized state
var $42bb3a95682ef960$var$initializedState = module.exports.initializedState = function initializedState(spec) {
    // spec also contains listRef, trackRef
    var slideCount = $42bb3a95682ef960$var$_react["default"].Children.count(spec.children);
    var listNode = spec.listRef;
    var listWidth = Math.ceil($42bb3a95682ef960$var$getWidth(listNode));
    var trackNode = spec.trackRef && spec.trackRef.node;
    var trackWidth = Math.ceil($42bb3a95682ef960$var$getWidth(trackNode));
    var slideWidth;
    if (!spec.vertical) {
        var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
        if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") centerPaddingAdj *= listWidth / 100;
        slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
    } else slideWidth = listWidth;
    var slideHeight = listNode && $42bb3a95682ef960$var$getHeight(listNode.querySelector('[data-index="0"]'));
    var listHeight = slideHeight * spec.slidesToShow;
    var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
    if (spec.rtl && spec.currentSlide === undefined) currentSlide = slideCount - 1 - spec.initialSlide;
    var lazyLoadedList = spec.lazyLoadedList || [];
    var slidesToLoad = $42bb3a95682ef960$var$getOnDemandLazySlides($42bb3a95682ef960$var$_objectSpread($42bb3a95682ef960$var$_objectSpread({}, spec), {}, {
        currentSlide: currentSlide,
        lazyLoadedList: lazyLoadedList
    }));
    lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
    var state = {
        slideCount: slideCount,
        slideWidth: slideWidth,
        listWidth: listWidth,
        trackWidth: trackWidth,
        currentSlide: currentSlide,
        slideHeight: slideHeight,
        listHeight: listHeight,
        lazyLoadedList: lazyLoadedList
    };
    if (spec.autoplaying === null && spec.autoplay) state["autoplaying"] = "playing";
    return state;
};
var $42bb3a95682ef960$var$slideHandler = module.exports.slideHandler = function slideHandler(spec) {
    var waitForAnimate = spec.waitForAnimate, animating = spec.animating, fade = spec.fade, infinite = spec.infinite, index = spec.index, slideCount = spec.slideCount, lazyLoad = spec.lazyLoad, currentSlide = spec.currentSlide, centerMode = spec.centerMode, slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, useCSS = spec.useCSS;
    var lazyLoadedList = spec.lazyLoadedList;
    if (waitForAnimate && animating) return {};
    var animationSlide = index, finalSlide, animationLeft, finalLeft;
    var state = {}, nextState = {};
    var targetSlide = infinite ? index : $42bb3a95682ef960$var$clamp(index, 0, slideCount - 1);
    if (fade) {
        if (!infinite && (index < 0 || index >= slideCount)) return {};
        if (index < 0) animationSlide = index + slideCount;
        else if (index >= slideCount) animationSlide = index - slideCount;
        if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) lazyLoadedList = lazyLoadedList.concat(animationSlide);
        state = {
            animating: true,
            currentSlide: animationSlide,
            lazyLoadedList: lazyLoadedList,
            targetSlide: animationSlide
        };
        nextState = {
            animating: false,
            targetSlide: animationSlide
        };
    } else {
        finalSlide = animationSlide;
        if (animationSlide < 0) {
            finalSlide = animationSlide + slideCount;
            if (!infinite) finalSlide = 0;
            else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
        } else if (!$42bb3a95682ef960$var$canGoNext(spec) && animationSlide > currentSlide) animationSlide = finalSlide = currentSlide;
        else if (centerMode && animationSlide >= slideCount) {
            animationSlide = infinite ? slideCount : slideCount - 1;
            finalSlide = infinite ? 0 : slideCount - 1;
        } else if (animationSlide >= slideCount) {
            finalSlide = animationSlide - slideCount;
            if (!infinite) finalSlide = slideCount - slidesToShow;
            else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
        }
        if (!infinite && animationSlide + slidesToShow >= slideCount) finalSlide = slideCount - slidesToShow;
        animationLeft = $42bb3a95682ef960$var$getTrackLeft($42bb3a95682ef960$var$_objectSpread($42bb3a95682ef960$var$_objectSpread({}, spec), {}, {
            slideIndex: animationSlide
        }));
        finalLeft = $42bb3a95682ef960$var$getTrackLeft($42bb3a95682ef960$var$_objectSpread($42bb3a95682ef960$var$_objectSpread({}, spec), {}, {
            slideIndex: finalSlide
        }));
        if (!infinite) {
            if (animationLeft === finalLeft) animationSlide = finalSlide;
            animationLeft = finalLeft;
        }
        if (lazyLoad) lazyLoadedList = lazyLoadedList.concat($42bb3a95682ef960$var$getOnDemandLazySlides($42bb3a95682ef960$var$_objectSpread($42bb3a95682ef960$var$_objectSpread({}, spec), {}, {
            currentSlide: animationSlide
        })));
        if (!useCSS) state = {
            currentSlide: finalSlide,
            trackStyle: $42bb3a95682ef960$var$getTrackCSS($42bb3a95682ef960$var$_objectSpread($42bb3a95682ef960$var$_objectSpread({}, spec), {}, {
                left: finalLeft
            })),
            lazyLoadedList: lazyLoadedList,
            targetSlide: targetSlide
        };
        else {
            state = {
                animating: true,
                currentSlide: finalSlide,
                trackStyle: $42bb3a95682ef960$var$getTrackAnimateCSS($42bb3a95682ef960$var$_objectSpread($42bb3a95682ef960$var$_objectSpread({}, spec), {}, {
                    left: animationLeft
                })),
                lazyLoadedList: lazyLoadedList,
                targetSlide: targetSlide
            };
            nextState = {
                animating: false,
                currentSlide: finalSlide,
                trackStyle: $42bb3a95682ef960$var$getTrackCSS($42bb3a95682ef960$var$_objectSpread($42bb3a95682ef960$var$_objectSpread({}, spec), {}, {
                    left: finalLeft
                })),
                swipeLeft: null,
                targetSlide: targetSlide
            };
        }
    }
    return {
        state: state,
        nextState: nextState
    };
};
var $42bb3a95682ef960$var$changeSlide = module.exports.changeSlide = function changeSlide(spec, options) {
    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
    var slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, slideCount = spec.slideCount, currentSlide = spec.currentSlide, previousTargetSlide = spec.targetSlide, lazyLoad = spec.lazyLoad, infinite = spec.infinite;
    unevenOffset = slideCount % slidesToScroll !== 0;
    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
    if (options.message === "previous") {
        slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
        targetSlide = currentSlide - slideOffset;
        if (lazyLoad && !infinite) {
            previousInt = currentSlide - slideOffset;
            targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
        }
        if (!infinite) targetSlide = previousTargetSlide - slidesToScroll;
    } else if (options.message === "next") {
        slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
        targetSlide = currentSlide + slideOffset;
        if (lazyLoad && !infinite) targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
        if (!infinite) targetSlide = previousTargetSlide + slidesToScroll;
    } else if (options.message === "dots") // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    else if (options.message === "children") {
        // Click on the slides
        targetSlide = options.index;
        if (infinite) {
            var direction = $42bb3a95682ef960$var$siblingDirection($42bb3a95682ef960$var$_objectSpread($42bb3a95682ef960$var$_objectSpread({}, spec), {}, {
                targetSlide: targetSlide
            }));
            if (targetSlide > options.currentSlide && direction === "left") targetSlide = targetSlide - slideCount;
            else if (targetSlide < options.currentSlide && direction === "right") targetSlide = targetSlide + slideCount;
        }
    } else if (options.message === "index") targetSlide = Number(options.index);
    return targetSlide;
};
var $42bb3a95682ef960$var$keyHandler = module.exports.keyHandler = function keyHandler(e, accessibility, rtl) {
    if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
    if (e.keyCode === 37) return rtl ? "next" : "previous";
    if (e.keyCode === 39) return rtl ? "previous" : "next";
    return "";
};
var $42bb3a95682ef960$var$swipeStart = module.exports.swipeStart = function swipeStart(e, swipe, draggable) {
    e.target.tagName === "IMG" && $42bb3a95682ef960$var$safePreventDefault(e);
    if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
    return {
        dragging: true,
        touchObject: {
            startX: e.touches ? e.touches[0].pageX : e.clientX,
            startY: e.touches ? e.touches[0].pageY : e.clientY,
            curX: e.touches ? e.touches[0].pageX : e.clientX,
            curY: e.touches ? e.touches[0].pageY : e.clientY
        }
    };
};
var $42bb3a95682ef960$var$swipeMove = module.exports.swipeMove = function swipeMove(e, spec) {
    // spec also contains, trackRef and slideIndex
    var scrolling = spec.scrolling, animating = spec.animating, vertical = spec.vertical, swipeToSlide = spec.swipeToSlide, verticalSwiping = spec.verticalSwiping, rtl = spec.rtl, currentSlide = spec.currentSlide, edgeFriction = spec.edgeFriction, edgeDragged = spec.edgeDragged, onEdge = spec.onEdge, swiped = spec.swiped, swiping = spec.swiping, slideCount = spec.slideCount, slidesToScroll = spec.slidesToScroll, infinite = spec.infinite, touchObject = spec.touchObject, swipeEvent = spec.swipeEvent, listHeight = spec.listHeight, listWidth = spec.listWidth;
    if (scrolling) return;
    if (animating) return $42bb3a95682ef960$var$safePreventDefault(e);
    if (vertical && swipeToSlide && verticalSwiping) $42bb3a95682ef960$var$safePreventDefault(e);
    var swipeLeft, state = {};
    var curLeft = $42bb3a95682ef960$var$getTrackLeft(spec);
    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
    var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
    if (!verticalSwiping && !swiping && verticalSwipeLength > 10) return {
        scrolling: true
    };
    if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
    var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
    if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
    var dotCount = Math.ceil(slideCount / slidesToScroll);
    var swipeDirection = $42bb3a95682ef960$var$getSwipeDirection(spec.touchObject, verticalSwiping);
    var touchSwipeLength = touchObject.swipeLength;
    if (!infinite) {
        if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !$42bb3a95682ef960$var$canGoNext(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
            touchSwipeLength = touchObject.swipeLength * edgeFriction;
            if (edgeDragged === false && onEdge) {
                onEdge(swipeDirection);
                state["edgeDragged"] = true;
            }
        }
    }
    if (!swiped && swipeEvent) {
        swipeEvent(swipeDirection);
        state["swiped"] = true;
    }
    if (!vertical) {
        if (!rtl) swipeLeft = curLeft + touchSwipeLength * positionOffset;
        else swipeLeft = curLeft - touchSwipeLength * positionOffset;
    } else swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
    if (verticalSwiping) swipeLeft = curLeft + touchSwipeLength * positionOffset;
    state = $42bb3a95682ef960$var$_objectSpread($42bb3a95682ef960$var$_objectSpread({}, state), {}, {
        touchObject: touchObject,
        swipeLeft: swipeLeft,
        trackStyle: $42bb3a95682ef960$var$getTrackCSS($42bb3a95682ef960$var$_objectSpread($42bb3a95682ef960$var$_objectSpread({}, spec), {}, {
            left: swipeLeft
        }))
    });
    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) return state;
    if (touchObject.swipeLength > 10) {
        state["swiping"] = true;
        $42bb3a95682ef960$var$safePreventDefault(e);
    }
    return state;
};
var $42bb3a95682ef960$var$swipeEnd = module.exports.swipeEnd = function swipeEnd(e, spec) {
    var dragging = spec.dragging, swipe = spec.swipe, touchObject = spec.touchObject, listWidth = spec.listWidth, touchThreshold = spec.touchThreshold, verticalSwiping = spec.verticalSwiping, listHeight = spec.listHeight, swipeToSlide = spec.swipeToSlide, scrolling = spec.scrolling, onSwipe = spec.onSwipe, targetSlide = spec.targetSlide, currentSlide = spec.currentSlide, infinite = spec.infinite;
    if (!dragging) {
        if (swipe) $42bb3a95682ef960$var$safePreventDefault(e);
        return {};
    }
    var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
    var swipeDirection = $42bb3a95682ef960$var$getSwipeDirection(touchObject, verticalSwiping);
    // reset the state of touch related state variables.
    var state = {
        dragging: false,
        edgeDragged: false,
        scrolling: false,
        swiping: false,
        swiped: false,
        swipeLeft: null,
        touchObject: {}
    };
    if (scrolling) return state;
    if (!touchObject.swipeLength) return state;
    if (touchObject.swipeLength > minSwipe) {
        $42bb3a95682ef960$var$safePreventDefault(e);
        if (onSwipe) onSwipe(swipeDirection);
        var slideCount, newSlide;
        var activeSlide = infinite ? currentSlide : targetSlide;
        switch(swipeDirection){
            case "left":
            case "up":
                newSlide = activeSlide + $42bb3a95682ef960$var$getSlideCount(spec);
                slideCount = swipeToSlide ? $42bb3a95682ef960$var$checkNavigable(spec, newSlide) : newSlide;
                state["currentDirection"] = 0;
                break;
            case "right":
            case "down":
                newSlide = activeSlide - $42bb3a95682ef960$var$getSlideCount(spec);
                slideCount = swipeToSlide ? $42bb3a95682ef960$var$checkNavigable(spec, newSlide) : newSlide;
                state["currentDirection"] = 1;
                break;
            default:
                slideCount = activeSlide;
        }
        state["triggerSlideHandler"] = slideCount;
    } else {
        // Adjust the track back to it's original position.
        var currentLeft = $42bb3a95682ef960$var$getTrackLeft(spec);
        state["trackStyle"] = $42bb3a95682ef960$var$getTrackAnimateCSS($42bb3a95682ef960$var$_objectSpread($42bb3a95682ef960$var$_objectSpread({}, spec), {}, {
            left: currentLeft
        }));
    }
    return state;
};
var $42bb3a95682ef960$var$getNavigableIndexes = module.exports.getNavigableIndexes = function getNavigableIndexes(spec) {
    var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
    var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
    var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
    var indexes = [];
    while(breakpoint < max){
        indexes.push(breakpoint);
        breakpoint = counter + spec.slidesToScroll;
        counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
    }
    return indexes;
};
var $42bb3a95682ef960$var$checkNavigable = module.exports.checkNavigable = function checkNavigable(spec, index) {
    var navigables = $42bb3a95682ef960$var$getNavigableIndexes(spec);
    var prevNavigable = 0;
    if (index > navigables[navigables.length - 1]) index = navigables[navigables.length - 1];
    else for(var n in navigables){
        if (index < navigables[n]) {
            index = prevNavigable;
            break;
        }
        prevNavigable = navigables[n];
    }
    return index;
};
var $42bb3a95682ef960$var$getSlideCount = module.exports.getSlideCount = function getSlideCount(spec) {
    var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
    if (spec.swipeToSlide) {
        var swipedSlide;
        var slickList = spec.listRef;
        var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
        Array.from(slides).every(function(slide) {
            if (!spec.vertical) {
                if (slide.offsetLeft - centerOffset + $42bb3a95682ef960$var$getWidth(slide) / 2 > spec.swipeLeft * -1) {
                    swipedSlide = slide;
                    return false;
                }
            } else if (slide.offsetTop + $42bb3a95682ef960$var$getHeight(slide) / 2 > spec.swipeLeft * -1) {
                swipedSlide = slide;
                return false;
            }
            return true;
        });
        if (!swipedSlide) return 0;
        var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
        var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
        return slidesTraversed;
    } else return spec.slidesToScroll;
};
var $42bb3a95682ef960$var$checkSpecKeys = module.exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
    return keysArray.reduce(function(value, key) {
        return value && spec.hasOwnProperty(key);
    }, true) ? null : console.error("Keys Missing:", spec);
};
var $42bb3a95682ef960$var$getTrackCSS = module.exports.getTrackCSS = function getTrackCSS(spec) {
    $42bb3a95682ef960$var$checkSpecKeys(spec, [
        "left",
        "variableWidth",
        "slideCount",
        "slidesToShow",
        "slideWidth"
    ]);
    var trackWidth, trackHeight;
    if (!spec.vertical) trackWidth = $42bb3a95682ef960$var$getTotalSlides(spec) * spec.slideWidth;
    else {
        var trackChildren = spec.unslick ? spec.slideCount : spec.slideCount + 2 * spec.slidesToShow;
        trackHeight = trackChildren * spec.slideHeight;
    }
    var style = {
        opacity: 1,
        transition: "",
        WebkitTransition: ""
    };
    if (spec.useTransform) {
        var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
        var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
        var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
        style = $42bb3a95682ef960$var$_objectSpread($42bb3a95682ef960$var$_objectSpread({}, style), {}, {
            WebkitTransform: WebkitTransform,
            transform: transform,
            msTransform: msTransform
        });
    } else if (spec.vertical) style["top"] = spec.left;
    else style["left"] = spec.left;
    if (spec.fade) style = {
        opacity: 1
    };
    if (trackWidth) style.width = trackWidth;
    if (trackHeight) style.height = trackHeight;
    // Fallback for IE8
    if (window && !window.addEventListener && window.attachEvent) {
        if (!spec.vertical) style.marginLeft = spec.left + "px";
        else style.marginTop = spec.left + "px";
    }
    return style;
};
var $42bb3a95682ef960$var$getTrackAnimateCSS = module.exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
    $42bb3a95682ef960$var$checkSpecKeys(spec, [
        "left",
        "variableWidth",
        "slideCount",
        "slidesToShow",
        "slideWidth",
        "speed",
        "cssEase"
    ]);
    var style = $42bb3a95682ef960$var$getTrackCSS(spec);
    // useCSS is true by default so it can be undefined
    if (spec.useTransform) {
        style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
        style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
    } else if (spec.vertical) style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    else style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    return style;
};
var $42bb3a95682ef960$var$getTrackLeft = module.exports.getTrackLeft = function getTrackLeft(spec) {
    if (spec.unslick) return 0;
    $42bb3a95682ef960$var$checkSpecKeys(spec, [
        "slideIndex",
        "trackRef",
        "infinite",
        "centerMode",
        "slideCount",
        "slidesToShow",
        "slidesToScroll",
        "slideWidth",
        "listWidth",
        "variableWidth",
        "slideHeight"
    ]);
    var slideIndex = spec.slideIndex, trackRef = spec.trackRef, infinite = spec.infinite, centerMode = spec.centerMode, slideCount = spec.slideCount, slidesToShow = spec.slidesToShow, slidesToScroll = spec.slidesToScroll, slideWidth = spec.slideWidth, listWidth = spec.listWidth, variableWidth = spec.variableWidth, slideHeight = spec.slideHeight, fade = spec.fade, vertical = spec.vertical;
    var slideOffset = 0;
    var targetLeft;
    var targetSlide;
    var verticalOffset = 0;
    if (fade || spec.slideCount === 1) return 0;
    var slidesToOffset = 0;
    if (infinite) {
        slidesToOffset = -$42bb3a95682ef960$var$getPreClones(spec); // bring active slide to the beginning of visual area
        // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
        if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
        // shift current slide to center of the frame
        if (centerMode) slidesToOffset += parseInt(slidesToShow / 2);
    } else {
        if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) slidesToOffset = slidesToShow - slideCount % slidesToScroll;
        if (centerMode) slidesToOffset = parseInt(slidesToShow / 2);
    }
    slideOffset = slidesToOffset * slideWidth;
    verticalOffset = slidesToOffset * slideHeight;
    if (!vertical) targetLeft = slideIndex * slideWidth * -1 + slideOffset;
    else targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
    if (variableWidth === true) {
        var targetSlideIndex;
        var trackElem = trackRef && trackRef.node;
        targetSlideIndex = slideIndex + $42bb3a95682ef960$var$getPreClones(spec);
        targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
        targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
        if (centerMode === true) {
            targetSlideIndex = infinite ? slideIndex + $42bb3a95682ef960$var$getPreClones(spec) : slideIndex;
            targetSlide = trackElem && trackElem.children[targetSlideIndex];
            targetLeft = 0;
            for(var slide = 0; slide < targetSlideIndex; slide++)targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
            targetLeft -= parseInt(spec.centerPadding);
            targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
        }
    }
    return targetLeft;
};
var $42bb3a95682ef960$var$getPreClones = module.exports.getPreClones = function getPreClones(spec) {
    if (spec.unslick || !spec.infinite) return 0;
    if (spec.variableWidth) return spec.slideCount;
    return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};
var $42bb3a95682ef960$var$getPostClones = module.exports.getPostClones = function getPostClones(spec) {
    if (spec.unslick || !spec.infinite) return 0;
    if (spec.variableWidth) return spec.slideCount;
    return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};
var $42bb3a95682ef960$var$getTotalSlides = module.exports.getTotalSlides = function getTotalSlides(spec) {
    return spec.slideCount === 1 ? 1 : $42bb3a95682ef960$var$getPreClones(spec) + spec.slideCount + $42bb3a95682ef960$var$getPostClones(spec);
};
var $42bb3a95682ef960$var$siblingDirection = module.exports.siblingDirection = function siblingDirection(spec) {
    if (spec.targetSlide > spec.currentSlide) {
        if (spec.targetSlide > spec.currentSlide + $42bb3a95682ef960$var$slidesOnRight(spec)) return "left";
        return "right";
    } else {
        if (spec.targetSlide < spec.currentSlide - $42bb3a95682ef960$var$slidesOnLeft(spec)) return "right";
        return "left";
    }
};
var $42bb3a95682ef960$var$slidesOnRight = module.exports.slidesOnRight = function slidesOnRight(_ref) {
    var slidesToShow = _ref.slidesToShow, centerMode = _ref.centerMode, rtl = _ref.rtl, centerPadding = _ref.centerPadding;
    // returns no of slides on the right of active slide
    if (centerMode) {
        var right = (slidesToShow - 1) / 2 + 1;
        if (parseInt(centerPadding) > 0) right += 1;
        if (rtl && slidesToShow % 2 === 0) right += 1;
        return right;
    }
    if (rtl) return 0;
    return slidesToShow - 1;
};
var $42bb3a95682ef960$var$slidesOnLeft = module.exports.slidesOnLeft = function slidesOnLeft(_ref2) {
    var slidesToShow = _ref2.slidesToShow, centerMode = _ref2.centerMode, rtl = _ref2.rtl, centerPadding = _ref2.centerPadding;
    // returns no of slides on the left of active slide
    if (centerMode) {
        var left = (slidesToShow - 1) / 2 + 1;
        if (parseInt(centerPadding) > 0) left += 1;
        if (!rtl && slidesToShow % 2 === 0) left += 1;
        return left;
    }
    if (rtl) return slidesToShow - 1;
    return 0;
};
var $42bb3a95682ef960$var$canUseDOM = module.exports.canUseDOM = function canUseDOM() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};
var $42bb3a95682ef960$var$validSettings = module.exports.validSettings = Object.keys($42bb3a95682ef960$var$_defaultProps["default"]);
function $42bb3a95682ef960$var$filterSettings(settings) {
    return $42bb3a95682ef960$var$validSettings.reduce(function(acc, settingName) {
        if (settings.hasOwnProperty(settingName)) acc[settingName] = settings[settingName];
        return acc;
    }, {});
}

});
parcelRegister("57X2G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $3bbb67c1f2a17b3d$var$_react = $3bbb67c1f2a17b3d$var$_interopRequireDefault((parcelRequire("8T3gX")));
function $3bbb67c1f2a17b3d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $3bbb67c1f2a17b3d$var$defaultProps = {
    accessibility: true,
    adaptiveHeight: false,
    afterChange: null,
    appendDots: function appendDots(dots) {
        return /*#__PURE__*/ $3bbb67c1f2a17b3d$var$_react["default"].createElement("ul", {
            style: {
                display: "block"
            }
        }, dots);
    },
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    beforeChange: null,
    centerMode: false,
    centerPadding: "50px",
    className: "",
    cssEase: "ease",
    customPaging: function customPaging(i) {
        return /*#__PURE__*/ $3bbb67c1f2a17b3d$var$_react["default"].createElement("button", null, i + 1);
    },
    dots: false,
    dotsClass: "slick-dots",
    draggable: true,
    easing: "linear",
    edgeFriction: 0.35,
    fade: false,
    focusOnSelect: false,
    infinite: true,
    initialSlide: 0,
    lazyLoad: null,
    nextArrow: null,
    onEdge: null,
    onInit: null,
    onLazyLoadError: null,
    onReInit: null,
    pauseOnDotsHover: false,
    pauseOnFocus: false,
    pauseOnHover: true,
    prevArrow: null,
    responsive: null,
    rows: 1,
    rtl: false,
    slide: "div",
    slidesPerRow: 1,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
    swipe: true,
    swipeEvent: null,
    swipeToSlide: false,
    touchMove: true,
    touchThreshold: 5,
    useCSS: true,
    useTransform: true,
    variableWidth: false,
    vertical: false,
    verticalSwiping: false,
    waitForAnimate: true,
    asNavFor: null,
    unslick: false
};
var $3bbb67c1f2a17b3d$var$_default = module.exports["default"] = $3bbb67c1f2a17b3d$var$defaultProps;

});


parcelRegister("1pCIF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Track = void 0;

var $107629229edf418e$var$_react = $107629229edf418e$var$_interopRequireDefault((parcelRequire("8T3gX")));

var $107629229edf418e$var$_classnames = $107629229edf418e$var$_interopRequireDefault((parcelRequire("i02Bg")));

var $5JcZe = parcelRequire("5JcZe");
function $107629229edf418e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $107629229edf418e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $107629229edf418e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $107629229edf418e$var$_typeof(o);
}
function $107629229edf418e$var$_extends() {
    return $107629229edf418e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $107629229edf418e$var$_extends.apply(null, arguments);
}
function $107629229edf418e$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $107629229edf418e$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $107629229edf418e$var$_toPropertyKey(o.key), o);
    }
}
function $107629229edf418e$var$_createClass(e, r, t) {
    return r && $107629229edf418e$var$_defineProperties(e.prototype, r), t && $107629229edf418e$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $107629229edf418e$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $107629229edf418e$var$_setPrototypeOf(t, e);
}
function $107629229edf418e$var$_setPrototypeOf(t, e) {
    return $107629229edf418e$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $107629229edf418e$var$_setPrototypeOf(t, e);
}
function $107629229edf418e$var$_createSuper(t) {
    var r = $107629229edf418e$var$_isNativeReflectConstruct();
    return function() {
        var e, o = $107629229edf418e$var$_getPrototypeOf(t);
        if (r) {
            var s = $107629229edf418e$var$_getPrototypeOf(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return $107629229edf418e$var$_possibleConstructorReturn(this, e);
    };
}
function $107629229edf418e$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $107629229edf418e$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $107629229edf418e$var$_assertThisInitialized(t);
}
function $107629229edf418e$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function $107629229edf418e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($107629229edf418e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $107629229edf418e$var$_getPrototypeOf(t) {
    return $107629229edf418e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $107629229edf418e$var$_getPrototypeOf(t);
}
function $107629229edf418e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $107629229edf418e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $107629229edf418e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $107629229edf418e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $107629229edf418e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $107629229edf418e$var$_defineProperty(e, r, t) {
    return (r = $107629229edf418e$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $107629229edf418e$var$_toPropertyKey(t) {
    var i = $107629229edf418e$var$_toPrimitive(t, "string");
    return "symbol" == $107629229edf418e$var$_typeof(i) ? i : i + "";
}
function $107629229edf418e$var$_toPrimitive(t, r) {
    if ("object" != $107629229edf418e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $107629229edf418e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var $107629229edf418e$var$getSlideClasses = function getSlideClasses(spec) {
    var slickActive, slickCenter, slickCloned;
    var centerOffset, index;
    if (spec.rtl) index = spec.slideCount - 1 - spec.index;
    else index = spec.index;
    slickCloned = index < 0 || index >= spec.slideCount;
    if (spec.centerMode) {
        centerOffset = Math.floor(spec.slidesToShow / 2);
        slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
        if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) slickActive = true;
    } else slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
    var focusedSlide;
    if (spec.targetSlide < 0) focusedSlide = spec.targetSlide + spec.slideCount;
    else if (spec.targetSlide >= spec.slideCount) focusedSlide = spec.targetSlide - spec.slideCount;
    else focusedSlide = spec.targetSlide;
    var slickCurrent = index === focusedSlide;
    return {
        "slick-slide": true,
        "slick-active": slickActive,
        "slick-center": slickCenter,
        "slick-cloned": slickCloned,
        "slick-current": slickCurrent // dubious in case of RTL
    };
};
var $107629229edf418e$var$getSlideStyle = function getSlideStyle(spec) {
    var style = {};
    if (spec.variableWidth === undefined || spec.variableWidth === false) style.width = spec.slideWidth;
    if (spec.fade) {
        style.position = "relative";
        if (spec.vertical) style.top = -spec.index * parseInt(spec.slideHeight);
        else style.left = -spec.index * parseInt(spec.slideWidth);
        style.opacity = spec.currentSlide === spec.index ? 1 : 0;
        style.zIndex = spec.currentSlide === spec.index ? 999 : 998;
        if (spec.useCSS) style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    }
    return style;
};
var $107629229edf418e$var$getKey = function getKey(child, fallbackKey) {
    return child.key || fallbackKey;
};
var $107629229edf418e$var$renderSlides = function renderSlides(spec) {
    var key;
    var slides = [];
    var preCloneSlides = [];
    var postCloneSlides = [];
    var childrenCount = $107629229edf418e$var$_react["default"].Children.count(spec.children);
    var startIndex = (0, $5JcZe.lazyStartIndex)(spec);
    var endIndex = (0, $5JcZe.lazyEndIndex)(spec);
    $107629229edf418e$var$_react["default"].Children.forEach(spec.children, function(elem, index) {
        var child;
        var childOnClickOptions = {
            message: "children",
            index: index,
            slidesToScroll: spec.slidesToScroll,
            currentSlide: spec.currentSlide
        };
        // in case of lazyLoad, whether or not we want to fetch the slide
        if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) child = elem;
        else child = /*#__PURE__*/ $107629229edf418e$var$_react["default"].createElement("div", null);
        var childStyle = $107629229edf418e$var$getSlideStyle($107629229edf418e$var$_objectSpread($107629229edf418e$var$_objectSpread({}, spec), {}, {
            index: index
        }));
        var slideClass = child.props.className || "";
        var slideClasses = $107629229edf418e$var$getSlideClasses($107629229edf418e$var$_objectSpread($107629229edf418e$var$_objectSpread({}, spec), {}, {
            index: index
        }));
        // push a cloned element of the desired slide
        slides.push(/*#__PURE__*/ $107629229edf418e$var$_react["default"].cloneElement(child, {
            key: "original" + $107629229edf418e$var$getKey(child, index),
            "data-index": index,
            className: (0, $107629229edf418e$var$_classnames["default"])(slideClasses, slideClass),
            tabIndex: "-1",
            "aria-hidden": !slideClasses["slick-active"],
            style: $107629229edf418e$var$_objectSpread($107629229edf418e$var$_objectSpread({
                outline: "none"
            }, child.props.style || {}), childStyle),
            onClick: function onClick(e) {
                child.props && child.props.onClick && child.props.onClick(e);
                if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
            }
        }));
        // if slide needs to be precloned or postcloned
        if (spec.infinite && childrenCount > 1 && spec.fade === false && !spec.unslick) {
            var preCloneNo = childrenCount - index;
            if (preCloneNo <= (0, $5JcZe.getPreClones)(spec)) {
                key = -preCloneNo;
                if (key >= startIndex) child = elem;
                slideClasses = $107629229edf418e$var$getSlideClasses($107629229edf418e$var$_objectSpread($107629229edf418e$var$_objectSpread({}, spec), {}, {
                    index: key
                }));
                preCloneSlides.push(/*#__PURE__*/ $107629229edf418e$var$_react["default"].cloneElement(child, {
                    key: "precloned" + $107629229edf418e$var$getKey(child, key),
                    "data-index": key,
                    tabIndex: "-1",
                    className: (0, $107629229edf418e$var$_classnames["default"])(slideClasses, slideClass),
                    "aria-hidden": !slideClasses["slick-active"],
                    style: $107629229edf418e$var$_objectSpread($107629229edf418e$var$_objectSpread({}, child.props.style || {}), childStyle),
                    onClick: function onClick(e) {
                        child.props && child.props.onClick && child.props.onClick(e);
                        if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
                    }
                }));
            }
            if (index < (0, $5JcZe.getPostClones)(spec)) {
                key = childrenCount + index;
                if (key < endIndex) child = elem;
                slideClasses = $107629229edf418e$var$getSlideClasses($107629229edf418e$var$_objectSpread($107629229edf418e$var$_objectSpread({}, spec), {}, {
                    index: key
                }));
                postCloneSlides.push(/*#__PURE__*/ $107629229edf418e$var$_react["default"].cloneElement(child, {
                    key: "postcloned" + $107629229edf418e$var$getKey(child, key),
                    "data-index": key,
                    tabIndex: "-1",
                    className: (0, $107629229edf418e$var$_classnames["default"])(slideClasses, slideClass),
                    "aria-hidden": !slideClasses["slick-active"],
                    style: $107629229edf418e$var$_objectSpread($107629229edf418e$var$_objectSpread({}, child.props.style || {}), childStyle),
                    onClick: function onClick(e) {
                        child.props && child.props.onClick && child.props.onClick(e);
                        if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
                    }
                }));
            }
        }
    });
    if (spec.rtl) return preCloneSlides.concat(slides, postCloneSlides).reverse();
    else return preCloneSlides.concat(slides, postCloneSlides);
};
var $107629229edf418e$var$Track = module.exports.Track = /*#__PURE__*/ function(_React$PureComponent) {
    $107629229edf418e$var$_inherits(Track, _React$PureComponent);
    var _super = $107629229edf418e$var$_createSuper(Track);
    function Track() {
        var _this;
        $107629229edf418e$var$_classCallCheck(this, Track);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $107629229edf418e$var$_defineProperty($107629229edf418e$var$_assertThisInitialized(_this), "node", null);
        $107629229edf418e$var$_defineProperty($107629229edf418e$var$_assertThisInitialized(_this), "handleRef", function(ref) {
            _this.node = ref;
        });
        return _this;
    }
    $107629229edf418e$var$_createClass(Track, [
        {
            key: "render",
            value: function render() {
                var slides = $107629229edf418e$var$renderSlides(this.props);
                var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave;
                var mouseEvents = {
                    onMouseEnter: onMouseEnter,
                    onMouseOver: onMouseOver,
                    onMouseLeave: onMouseLeave
                };
                return /*#__PURE__*/ $107629229edf418e$var$_react["default"].createElement("div", $107629229edf418e$var$_extends({
                    ref: this.handleRef,
                    className: "slick-track",
                    style: this.props.trackStyle
                }, mouseEvents), slides);
            }
        }
    ]);
    return Track;
}($107629229edf418e$var$_react["default"].PureComponent);

});

parcelRegister("auwzK", function(module, exports) {
"use strict";
function $7a35f9924f8658cf$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7a35f9924f8658cf$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7a35f9924f8658cf$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dots = void 0;

var $7a35f9924f8658cf$var$_react = $7a35f9924f8658cf$var$_interopRequireDefault((parcelRequire("8T3gX")));

var $7a35f9924f8658cf$var$_classnames = $7a35f9924f8658cf$var$_interopRequireDefault((parcelRequire("i02Bg")));

var $5JcZe = parcelRequire("5JcZe");
function $7a35f9924f8658cf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $7a35f9924f8658cf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7a35f9924f8658cf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7a35f9924f8658cf$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7a35f9924f8658cf$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7a35f9924f8658cf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7a35f9924f8658cf$var$_defineProperty(e, r, t) {
    return (r = $7a35f9924f8658cf$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $7a35f9924f8658cf$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $7a35f9924f8658cf$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $7a35f9924f8658cf$var$_toPropertyKey(o.key), o);
    }
}
function $7a35f9924f8658cf$var$_createClass(e, r, t) {
    return r && $7a35f9924f8658cf$var$_defineProperties(e.prototype, r), t && $7a35f9924f8658cf$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $7a35f9924f8658cf$var$_toPropertyKey(t) {
    var i = $7a35f9924f8658cf$var$_toPrimitive(t, "string");
    return "symbol" == $7a35f9924f8658cf$var$_typeof(i) ? i : i + "";
}
function $7a35f9924f8658cf$var$_toPrimitive(t, r) {
    if ("object" != $7a35f9924f8658cf$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $7a35f9924f8658cf$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $7a35f9924f8658cf$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $7a35f9924f8658cf$var$_setPrototypeOf(t, e);
}
function $7a35f9924f8658cf$var$_setPrototypeOf(t, e) {
    return $7a35f9924f8658cf$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $7a35f9924f8658cf$var$_setPrototypeOf(t, e);
}
function $7a35f9924f8658cf$var$_createSuper(t) {
    var r = $7a35f9924f8658cf$var$_isNativeReflectConstruct();
    return function() {
        var e, o = $7a35f9924f8658cf$var$_getPrototypeOf(t);
        if (r) {
            var s = $7a35f9924f8658cf$var$_getPrototypeOf(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return $7a35f9924f8658cf$var$_possibleConstructorReturn(this, e);
    };
}
function $7a35f9924f8658cf$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $7a35f9924f8658cf$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $7a35f9924f8658cf$var$_assertThisInitialized(t);
}
function $7a35f9924f8658cf$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function $7a35f9924f8658cf$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7a35f9924f8658cf$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $7a35f9924f8658cf$var$_getPrototypeOf(t) {
    return $7a35f9924f8658cf$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $7a35f9924f8658cf$var$_getPrototypeOf(t);
}
var $7a35f9924f8658cf$var$getDotCount = function getDotCount(spec) {
    var dots;
    if (spec.infinite) dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
    else dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
    return dots;
};
var $7a35f9924f8658cf$var$Dots = module.exports.Dots = /*#__PURE__*/ function(_React$PureComponent) {
    $7a35f9924f8658cf$var$_inherits(Dots, _React$PureComponent);
    var _super = $7a35f9924f8658cf$var$_createSuper(Dots);
    function Dots() {
        $7a35f9924f8658cf$var$_classCallCheck(this, Dots);
        return _super.apply(this, arguments);
    }
    $7a35f9924f8658cf$var$_createClass(Dots, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                // In Autoplay the focus stays on clicked button even after transition
                // to next slide. That only goes away by click somewhere outside
                e.preventDefault();
                this.props.clickHandler(options);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave, infinite = _this$props.infinite, slidesToScroll = _this$props.slidesToScroll, slidesToShow = _this$props.slidesToShow, slideCount = _this$props.slideCount, currentSlide = _this$props.currentSlide;
                var dotCount = $7a35f9924f8658cf$var$getDotCount({
                    slideCount: slideCount,
                    slidesToScroll: slidesToScroll,
                    slidesToShow: slidesToShow,
                    infinite: infinite
                });
                var mouseEvents = {
                    onMouseEnter: onMouseEnter,
                    onMouseOver: onMouseOver,
                    onMouseLeave: onMouseLeave
                };
                var dots = [];
                for(var i = 0; i < dotCount; i++){
                    var _rightBound = (i + 1) * slidesToScroll - 1;
                    var rightBound = infinite ? _rightBound : (0, $5JcZe.clamp)(_rightBound, 0, slideCount - 1);
                    var _leftBound = rightBound - (slidesToScroll - 1);
                    var leftBound = infinite ? _leftBound : (0, $5JcZe.clamp)(_leftBound, 0, slideCount - 1);
                    var className = (0, $7a35f9924f8658cf$var$_classnames["default"])({
                        "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
                    });
                    var dotOptions = {
                        message: "dots",
                        index: i,
                        slidesToScroll: slidesToScroll,
                        currentSlide: currentSlide
                    };
                    var onClick = this.clickHandler.bind(this, dotOptions);
                    dots = dots.concat(/*#__PURE__*/ $7a35f9924f8658cf$var$_react["default"].createElement("li", {
                        key: i,
                        className: className
                    }, /*#__PURE__*/ $7a35f9924f8658cf$var$_react["default"].cloneElement(this.props.customPaging(i), {
                        onClick: onClick
                    })));
                }
                return /*#__PURE__*/ $7a35f9924f8658cf$var$_react["default"].cloneElement(this.props.appendDots(dots), $7a35f9924f8658cf$var$_objectSpread({
                    className: this.props.dotsClass
                }, mouseEvents));
            }
        }
    ]);
    return Dots;
}($7a35f9924f8658cf$var$_react["default"].PureComponent);

});

parcelRegister("ai95H", function(module, exports) {
"use strict";
function $77e2a316de1724f5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $77e2a316de1724f5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $77e2a316de1724f5$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrevArrow = module.exports.NextArrow = void 0;

var $77e2a316de1724f5$var$_react = $77e2a316de1724f5$var$_interopRequireDefault((parcelRequire("8T3gX")));

var $77e2a316de1724f5$var$_classnames = $77e2a316de1724f5$var$_interopRequireDefault((parcelRequire("i02Bg")));

var $5JcZe = parcelRequire("5JcZe");
function $77e2a316de1724f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $77e2a316de1724f5$var$_extends() {
    return $77e2a316de1724f5$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $77e2a316de1724f5$var$_extends.apply(null, arguments);
}
function $77e2a316de1724f5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $77e2a316de1724f5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $77e2a316de1724f5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $77e2a316de1724f5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $77e2a316de1724f5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $77e2a316de1724f5$var$_defineProperty(e, r, t) {
    return (r = $77e2a316de1724f5$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $77e2a316de1724f5$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $77e2a316de1724f5$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $77e2a316de1724f5$var$_toPropertyKey(o.key), o);
    }
}
function $77e2a316de1724f5$var$_createClass(e, r, t) {
    return r && $77e2a316de1724f5$var$_defineProperties(e.prototype, r), t && $77e2a316de1724f5$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $77e2a316de1724f5$var$_toPropertyKey(t) {
    var i = $77e2a316de1724f5$var$_toPrimitive(t, "string");
    return "symbol" == $77e2a316de1724f5$var$_typeof(i) ? i : i + "";
}
function $77e2a316de1724f5$var$_toPrimitive(t, r) {
    if ("object" != $77e2a316de1724f5$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $77e2a316de1724f5$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $77e2a316de1724f5$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $77e2a316de1724f5$var$_setPrototypeOf(t, e);
}
function $77e2a316de1724f5$var$_setPrototypeOf(t, e) {
    return $77e2a316de1724f5$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $77e2a316de1724f5$var$_setPrototypeOf(t, e);
}
function $77e2a316de1724f5$var$_createSuper(t) {
    var r = $77e2a316de1724f5$var$_isNativeReflectConstruct();
    return function() {
        var e, o = $77e2a316de1724f5$var$_getPrototypeOf(t);
        if (r) {
            var s = $77e2a316de1724f5$var$_getPrototypeOf(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return $77e2a316de1724f5$var$_possibleConstructorReturn(this, e);
    };
}
function $77e2a316de1724f5$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $77e2a316de1724f5$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $77e2a316de1724f5$var$_assertThisInitialized(t);
}
function $77e2a316de1724f5$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function $77e2a316de1724f5$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($77e2a316de1724f5$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $77e2a316de1724f5$var$_getPrototypeOf(t) {
    return $77e2a316de1724f5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $77e2a316de1724f5$var$_getPrototypeOf(t);
}
var $77e2a316de1724f5$var$PrevArrow = module.exports.PrevArrow = /*#__PURE__*/ function(_React$PureComponent) {
    $77e2a316de1724f5$var$_inherits(PrevArrow, _React$PureComponent);
    var _super = $77e2a316de1724f5$var$_createSuper(PrevArrow);
    function PrevArrow() {
        $77e2a316de1724f5$var$_classCallCheck(this, PrevArrow);
        return _super.apply(this, arguments);
    }
    $77e2a316de1724f5$var$_createClass(PrevArrow, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                if (e) e.preventDefault();
                this.props.clickHandler(options, e);
            }
        },
        {
            key: "render",
            value: function render() {
                var prevClasses = {
                    "slick-arrow": true,
                    "slick-prev": true
                };
                var prevHandler = this.clickHandler.bind(this, {
                    message: "previous"
                });
                if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
                    prevClasses["slick-disabled"] = true;
                    prevHandler = null;
                }
                var prevArrowProps = {
                    key: "0",
                    "data-role": "none",
                    className: (0, $77e2a316de1724f5$var$_classnames["default"])(prevClasses),
                    style: {
                        display: "block"
                    },
                    onClick: prevHandler
                };
                var customProps = {
                    currentSlide: this.props.currentSlide,
                    slideCount: this.props.slideCount
                };
                var prevArrow;
                if (this.props.prevArrow) prevArrow = /*#__PURE__*/ $77e2a316de1724f5$var$_react["default"].cloneElement(this.props.prevArrow, $77e2a316de1724f5$var$_objectSpread($77e2a316de1724f5$var$_objectSpread({}, prevArrowProps), customProps));
                else prevArrow = /*#__PURE__*/ $77e2a316de1724f5$var$_react["default"].createElement("button", $77e2a316de1724f5$var$_extends({
                    key: "0",
                    type: "button"
                }, prevArrowProps), " ", "Previous");
                return prevArrow;
            }
        }
    ]);
    return PrevArrow;
}($77e2a316de1724f5$var$_react["default"].PureComponent);
var $77e2a316de1724f5$var$NextArrow = module.exports.NextArrow = /*#__PURE__*/ function(_React$PureComponent2) {
    $77e2a316de1724f5$var$_inherits(NextArrow, _React$PureComponent2);
    var _super2 = $77e2a316de1724f5$var$_createSuper(NextArrow);
    function NextArrow() {
        $77e2a316de1724f5$var$_classCallCheck(this, NextArrow);
        return _super2.apply(this, arguments);
    }
    $77e2a316de1724f5$var$_createClass(NextArrow, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                if (e) e.preventDefault();
                this.props.clickHandler(options, e);
            }
        },
        {
            key: "render",
            value: function render() {
                var nextClasses = {
                    "slick-arrow": true,
                    "slick-next": true
                };
                var nextHandler = this.clickHandler.bind(this, {
                    message: "next"
                });
                if (!(0, $5JcZe.canGoNext)(this.props)) {
                    nextClasses["slick-disabled"] = true;
                    nextHandler = null;
                }
                var nextArrowProps = {
                    key: "1",
                    "data-role": "none",
                    className: (0, $77e2a316de1724f5$var$_classnames["default"])(nextClasses),
                    style: {
                        display: "block"
                    },
                    onClick: nextHandler
                };
                var customProps = {
                    currentSlide: this.props.currentSlide,
                    slideCount: this.props.slideCount
                };
                var nextArrow;
                if (this.props.nextArrow) nextArrow = /*#__PURE__*/ $77e2a316de1724f5$var$_react["default"].cloneElement(this.props.nextArrow, $77e2a316de1724f5$var$_objectSpread($77e2a316de1724f5$var$_objectSpread({}, nextArrowProps), customProps));
                else nextArrow = /*#__PURE__*/ $77e2a316de1724f5$var$_react["default"].createElement("button", $77e2a316de1724f5$var$_extends({
                    key: "1",
                    type: "button"
                }, nextArrowProps), " ", "Next");
                return nextArrow;
            }
        }
    ]);
    return NextArrow;
}($77e2a316de1724f5$var$_react["default"].PureComponent);

});

parcelRegister("6IXhZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4e54d7bfb4ad9530$export$2e2bcd8739ae039);
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $4e54d7bfb4ad9530$var$MapShim = function() {
    if (typeof Map !== 'undefined') return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $4e54d7bfb4ad9530$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
// Returns global object of a current environment.
var $4e54d7bfb4ad9530$var$global$1 = function() {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== 'undefined' && self.Math === Math) return self;
    if (typeof window !== 'undefined' && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $4e54d7bfb4ad9530$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === 'function') // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($4e54d7bfb4ad9530$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $4e54d7bfb4ad9530$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $4e54d7bfb4ad9530$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $4e54d7bfb4ad9530$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $4e54d7bfb4ad9530$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $4e54d7bfb4ad9530$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $4e54d7bfb4ad9530$var$transitionKeys = [
    'top',
    'right',
    'bottom',
    'left',
    'width',
    'height',
    'size',
    'weight'
];
// Check if MutationObserver is available.
var $4e54d7bfb4ad9530$var$mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $4e54d7bfb4ad9530$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $4e54d7bfb4ad9530$var$throttle(this.refresh.bind(this), $4e54d7bfb4ad9530$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$4e54d7bfb4ad9530$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if ($4e54d7bfb4ad9530$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$4e54d7bfb4ad9530$var$isBrowser || !this.connected_) return;
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener('DOMSubtreeModified', this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $4e54d7bfb4ad9530$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $4e54d7bfb4ad9530$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $4e54d7bfb4ad9530$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $4e54d7bfb4ad9530$var$global$1;
};
// Placeholder of an empty content rectangle.
var $4e54d7bfb4ad9530$var$emptyRect = $4e54d7bfb4ad9530$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $4e54d7bfb4ad9530$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $4e54d7bfb4ad9530$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles['border-' + position + '-width'];
        return size + $4e54d7bfb4ad9530$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $4e54d7bfb4ad9530$var$getPaddings(styles) {
    var positions = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = $4e54d7bfb4ad9530$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $4e54d7bfb4ad9530$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $4e54d7bfb4ad9530$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $4e54d7bfb4ad9530$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $4e54d7bfb4ad9530$var$emptyRect;
    var styles = $4e54d7bfb4ad9530$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $4e54d7bfb4ad9530$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $4e54d7bfb4ad9530$var$toFloat(styles.width), height = $4e54d7bfb4ad9530$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $4e54d7bfb4ad9530$var$getBordersSize(styles, 'left', 'right') + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $4e54d7bfb4ad9530$var$getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$4e54d7bfb4ad9530$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $4e54d7bfb4ad9530$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $4e54d7bfb4ad9530$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') return function(target) {
        return target instanceof $4e54d7bfb4ad9530$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $4e54d7bfb4ad9530$var$getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $4e54d7bfb4ad9530$var$isDocumentElement(target) {
    return target === $4e54d7bfb4ad9530$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $4e54d7bfb4ad9530$var$getContentRect(target) {
    if (!$4e54d7bfb4ad9530$var$isBrowser) return $4e54d7bfb4ad9530$var$emptyRect;
    if ($4e54d7bfb4ad9530$var$isSVGGraphicsElement(target)) return $4e54d7bfb4ad9530$var$getSVGContentRect(target);
    return $4e54d7bfb4ad9530$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $4e54d7bfb4ad9530$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $4e54d7bfb4ad9530$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $4e54d7bfb4ad9530$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $4e54d7bfb4ad9530$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $4e54d7bfb4ad9530$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $4e54d7bfb4ad9530$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $4e54d7bfb4ad9530$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $4e54d7bfb4ad9530$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $4e54d7bfb4ad9530$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $4e54d7bfb4ad9530$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $4e54d7bfb4ad9530$var$MapShim();
        if (typeof callback !== 'function') throw new TypeError('The callback provided as parameter 1 is not a function.');
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $4e54d7bfb4ad9530$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $4e54d7bfb4ad9530$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $4e54d7bfb4ad9530$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $4e54d7bfb4ad9530$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $4e54d7bfb4ad9530$var$observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new $4e54d7bfb4ad9530$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $4e54d7bfb4ad9530$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError('Cannot call a class as a function.');
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        var controller = $4e54d7bfb4ad9530$var$ResizeObserverController.getInstance();
        var observer = new $4e54d7bfb4ad9530$var$ResizeObserverSPI(callback, controller, this);
        $4e54d7bfb4ad9530$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function(method) {
    $4e54d7bfb4ad9530$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $4e54d7bfb4ad9530$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $4e54d7bfb4ad9530$var$index = function() {
    // Export existing implementation if available.
    if (typeof $4e54d7bfb4ad9530$var$global$1.ResizeObserver !== 'undefined') return $4e54d7bfb4ad9530$var$global$1.ResizeObserver;
    return $4e54d7bfb4ad9530$var$ResizeObserver;
}();
var $4e54d7bfb4ad9530$export$2e2bcd8739ae039 = $4e54d7bfb4ad9530$var$index;

});


parcelRegister("f8V7z", function(module, exports) {

var $alNvZ = parcelRequire("alNvZ");
var $b063e97299e674e0$var$isDimension = function(feature) {
    var re = /[height|width]$/;
    return re.test(feature);
};
var $b063e97299e674e0$var$obj2mq = function(obj) {
    var mq = '';
    var features = Object.keys(obj);
    features.forEach(function(feature, index) {
        var value = obj[feature];
        feature = $alNvZ(feature);
        // Add px to dimension features
        if ($b063e97299e674e0$var$isDimension(feature) && typeof value === 'number') value = value + 'px';
        if (value === true) mq += feature;
        else if (value === false) mq += 'not ' + feature;
        else mq += '(' + feature + ': ' + value + ')';
        if (index < features.length - 1) mq += ' and ';
    });
    return mq;
};
var $b063e97299e674e0$var$json2mq = function(query) {
    var mq = '';
    if (typeof query === 'string') return query;
    // Handling array of media queries
    if (query instanceof Array) {
        query.forEach(function(q, index) {
            mq += $b063e97299e674e0$var$obj2mq(q);
            if (index < query.length - 1) mq += ', ';
        });
        return mq;
    }
    // Handling single media query
    return $b063e97299e674e0$var$obj2mq(query);
};
module.exports = $b063e97299e674e0$var$json2mq;

});
parcelRegister("alNvZ", function(module, exports) {
var $78924631eccf7c53$var$camel2hyphen = function(str) {
    return str.replace(/[A-Z]/g, function(match) {
        return '-' + match.toLowerCase();
    }).toLowerCase();
};
module.exports = $78924631eccf7c53$var$camel2hyphen;

});




var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8VQWA = parcelRequire("8VQWA");

var $k4ank = parcelRequire("k4ank");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");
const $a72857d2c4579fd9$var$login = ()=>{
// Note: Authentication state is now managed by cookies only
// This function is kept for backward compatibility
};
const $a72857d2c4579fd9$var$AuthContext = /*#__PURE__*/ (0, $8T3gX.createContext)({
    login: $a72857d2c4579fd9$var$login
});
const $a72857d2c4579fd9$export$87091915187a1a85 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)($a72857d2c4579fd9$var$AuthContext.Provider, {
        value: {
            login: $a72857d2c4579fd9$var$login
        },
        children: children
    });
};
const $a72857d2c4579fd9$export$1d39dc5b47e56ff0 = ()=>{
    return (0, $8T3gX.useContext)($a72857d2c4579fd9$var$AuthContext);
};



var $8T3gX = parcelRequire("8T3gX");

var $iJyAr = parcelRequire("iJyAr");

var $8T3gX = parcelRequire("8T3gX");

var $iJyAr = parcelRequire("iJyAr");
var $c2b7e10765f65ffa$export$2e2bcd8739ae039 = (0, $iJyAr.default);


var $2df597f88289f000$var$CookiesContext = $8T3gX.createContext(new (0, $c2b7e10765f65ffa$export$2e2bcd8739ae039)());
var $2df597f88289f000$export$2881499e37b75b9a = $2df597f88289f000$var$CookiesContext.Provider, $2df597f88289f000$export$b3bffd4bb7da6b8f = $2df597f88289f000$var$CookiesContext.Consumer;
var $2df597f88289f000$export$2e2bcd8739ae039 = $2df597f88289f000$var$CookiesContext;


var $406fbd5b4df51c19$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $406fbd5b4df51c19$var$CookiesProvider = /** @class */ function(_super) {
    $406fbd5b4df51c19$var$__extends(CookiesProvider, _super);
    function CookiesProvider(props) {
        var _this = _super.call(this, props) || this;
        if (props.cookies) _this.cookies = props.cookies;
        else _this.cookies = new (0, $iJyAr.default)();
        return _this;
    }
    CookiesProvider.prototype.render = function() {
        return $8T3gX.createElement((0, $2df597f88289f000$export$2881499e37b75b9a), {
            value: this.cookies
        }, this.props.children);
    };
    return CookiesProvider;
}($8T3gX.Component);
var $406fbd5b4df51c19$export$2e2bcd8739ae039 = $406fbd5b4df51c19$var$CookiesProvider;



var $3T949 = parcelRequire("3T949");parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $ax3yI = parcelRequire("ax3yI");
/* eslint-disable react-hooks/exhaustive-deps */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $jVN1H = parcelRequire("jVN1H");

var $k4ank = parcelRequire("k4ank");

var $cye0Y = parcelRequire("cye0Y");

var $gouAT = parcelRequire("gouAT");

var $5Ibhh = parcelRequire("5Ibhh");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");

var $3n3uW = parcelRequire("3n3uW");

var $2suvB = parcelRequire("2suvB");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

var $9OjAn = parcelRequire("9OjAn");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $ad6781d64ea9d765$export$176f58333fc13682 = (0, $9OjAn.create)((set, get)=>({
        // Dashboard totals
        dashboardTotal: {},
        setDashboardTotal: (data)=>set({
                dashboardTotal: data
            }),
        // Camera info
        camerasErrorInfo: [],
        setCamerasErrorInfo: (data)=>{
            const newState = typeof data === "function" ? data(get().camerasErrorInfo) : data;
            set({
                camerasErrorInfo: newState
            });
        },
        camerasWarningInfo: [],
        setCamerasWarningInfo: (data)=>{
            const newState = typeof data === "function" ? data(get().camerasWarningInfo) : data;
            set({
                camerasWarningInfo: newState
            });
        },
        // Tab state
        activeTab: "error",
        setActiveTab: (tab)=>set({
                activeTab: tab
            }),
        // Pagination
        page: 0,
        setPage: (page)=>set({
                page: page
            }),
        rowsPerPage: 10,
        setRowsPerPage: (rowsPerPage)=>set({
                rowsPerPage: rowsPerPage
            }),
        errorPaginationNumber: 1,
        setErrorPaginationNumber: (num)=>set({
                errorPaginationNumber: num
            }),
        warningPaginationNumber: 1,
        setWarningPaginationNumber: (num)=>set({
                warningPaginationNumber: num
            }),
        loadingErrorInfo: true,
        setLoadingErrorInfo: (loading)=>set({
                loadingErrorInfo: loading
            }),
        loadingWarningInfo: true,
        setLoadingWarningInfo: (loading)=>set({
                loadingWarningInfo: loading
            }),
        // UI states
        displayShowMoreButton: false,
        loadingMoreData: false,
        setLoadingMoreData: (loading)=>set({
                loadingMoreData: loading
            }),
        // Loading states
        pageLoading: false,
        setPageLoading: (loading)=>set({
                pageLoading: typeof loading === "function" ? loading(get().pageLoading) : loading
            }),
        dataIsLoading: true,
        setDataIsLoading: (loading)=>set({
                dataIsLoading: loading
            }),
        // Data usage
        usageData: [],
        setUsageData: (data)=>set({
                usageData: data
            }),
        currentData: "usageData",
        setCurrentData: (data)=>set({
                currentData: data
            }),
        dateRangeName: "Last 24 hours",
        setDateRangeName: (name)=>set({
                dateRangeName: name
            }),
        errorFetchingUsageData: false,
        setErrorFetchingUsageData: (error)=>set({
                errorFetchingUsageData: error
            }),
        dateRangeString: "last_24_hours",
        setDateRangeString: (dateRangeString)=>set({
                dateRangeString: dateRangeString
            }),
        typeString: "bandwidth",
        setTypeString: (typeString)=>set({
                typeString: typeString
            }),
        // Data usage graph specific state
        dataUsageOn: false,
        setDataUsageOn: (on)=>set({
                dataUsageOn: on
            }),
        last5Name: "Data Usage",
        setLast5Name: (name)=>set({
                last5Name: name
            }),
        rangeChoices: [],
        setRangeChoices: (choices)=>set({
                rangeChoices: choices
            }),
        // False positive data
        falsePositiveData: null,
        setFalsePositiveData: (data)=>set({
                falsePositiveData: data
            }),
        noFPData: false,
        setNoFPData: (noData)=>set({
                noFPData: noData
            }),
        // API Actions
        getTotalCamerasInfo: async (navigate)=>{
            const { setDashboardTotal: setDashboardTotal, setCamerasErrorInfo: setCamerasErrorInfo, setCamerasWarningInfo: setCamerasWarningInfo, setActiveTab: setActiveTab, activeTab: activeTab, setLoadingErrorInfo: setLoadingErrorInfo, setLoadingWarningInfo: setLoadingWarningInfo } = get();
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().getTotalCamerasInfo(navigate);
            };
            try {
                const response = await AxiosUI.get(`camera/dashboard_total/`);
                setDashboardTotal(response.data);
                try {
                    const errorResponse = await AxiosUI.get(`camera/dashboard/?status=error`);
                    setCamerasErrorInfo(errorResponse.data.results);
                    setLoadingErrorInfo(false);
                    if (activeTab === "error") {
                        setActiveTab("warning");
                        setActiveTab("error");
                    }
                } catch (reason) {
                    (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                        setCamerasErrorInfo([]);
                    });
                }
                try {
                    const warningResponse = await AxiosUI.get(`camera/dashboard/?status=warning`);
                    setCamerasWarningInfo(warningResponse.data.results);
                    setLoadingWarningInfo(false);
                    if (activeTab === "warning") {
                        setActiveTab("error");
                        setActiveTab("warning");
                    }
                } catch (reason) {
                    (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                        setCamerasWarningInfo([]);
                    });
                }
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
            }
        },
        getFalsePositiveData: async (navigate)=>{
            const { setFalsePositiveData: setFalsePositiveData, setNoFPData: setNoFPData } = get();
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().getFalsePositiveData(navigate);
            };
            try {
                const response = await AxiosUI.get(`analytics/false_positive/`);
                setFalsePositiveData(response.data);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setNoFPData(true);
                });
            }
        },
        getDataUsageData: async (navigate)=>{
            const { setUsageData: setUsageData, setDataIsLoading: setDataIsLoading, setErrorFetchingUsageData: setErrorFetchingUsageData, dateRangeString: dateRangeString, typeString: typeString } = get();
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().getDataUsageData(navigate);
            };
            setErrorFetchingUsageData(false);
            try {
                const response = await AxiosUI.get(`analytics/data_usage/?date_range=${dateRangeString}&order_by=${typeString}`);
                const updatedData = response.data;
                for(const key in updatedData){
                    const updatedKey = updatedData[key];
                    updatedKey.abreviated_name = `${updatedKey.display_name.slice(0, 7)}...`;
                    if (updatedKey.kbs) {
                        const updatedKBS = Math.round(updatedKey.kbs / 10000) / 100;
                        updatedKey.kbs = updatedKBS;
                    }
                }
                setUsageData(updatedData);
                setDataIsLoading(false);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setUsageData([]);
                    setErrorFetchingUsageData(true);
                    setDataIsLoading(false);
                });
            }
        },
        getAdditionalData: async (navigate)=>{
            const { activeTab: activeTab, errorPaginationNumber: errorPaginationNumber, setErrorPaginationNumber: setErrorPaginationNumber, setCamerasErrorInfo: setCamerasErrorInfo, warningPaginationNumber: warningPaginationNumber, setWarningPaginationNumber: setWarningPaginationNumber, setCamerasWarningInfo: setCamerasWarningInfo } = get();
            // Set loading state
            set({
                loadingMoreData: true,
                displayShowMoreButton: false
            });
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().getAdditionalData(navigate);
            };
            if (activeTab === "error") try {
                const response = await AxiosUI.get(`camera/dashboard/?page=${errorPaginationNumber + 1}&status=error`);
                setErrorPaginationNumber(errorPaginationNumber + 1);
                setCamerasErrorInfo((previousState)=>[
                        ...previousState,
                        ...response.data.results
                    ]);
                // Update UI states
                set({
                    loadingMoreData: false
                });
                // Update displayShowMoreButton based on response
                const shouldShowMoreButton = response.data.results.length === 100;
                set({
                    displayShowMoreButton: shouldShowMoreButton
                });
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    set({
                        loadingMoreData: false,
                        displayShowMoreButton: false
                    });
                });
            }
            else if (activeTab === "warning") try {
                const response = await AxiosUI.get(`camera/dashboard/?page=${warningPaginationNumber + 1}&status=warning`);
                setWarningPaginationNumber(warningPaginationNumber + 1);
                setCamerasWarningInfo((previousState)=>[
                        ...previousState,
                        ...response.data.results
                    ]);
                // Update UI states
                set({
                    loadingMoreData: false
                });
                // Update displayShowMoreButton based on response
                const shouldShowMoreButton = response.data.results.length === 100;
                set({
                    displayShowMoreButton: shouldShowMoreButton
                });
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    set({
                        loadingMoreData: false,
                        displayShowMoreButton: false
                    });
                });
            }
        },
        // Add this function after getAdditionalData
        updateShowMoreButtonState: ()=>{
            const { activeTab: activeTab, page: page, rowsPerPage: rowsPerPage, errorPaginationNumber: errorPaginationNumber, warningPaginationNumber: warningPaginationNumber, camerasErrorInfo: camerasErrorInfo, camerasWarningInfo: camerasWarningInfo } = get();
            const currentData = activeTab === "error" ? camerasErrorInfo : camerasWarningInfo;
            const currentPaginationNumber = activeTab === "error" ? errorPaginationNumber : warningPaginationNumber;
            // Ensure data exists before checking length
            if (!currentData || currentData.length === 0) {
                set({
                    displayShowMoreButton: false
                });
                return;
            }
            // Logic to show button:
            // 1. If the total items aren't a multiple of 100, it means we've loaded all pages from the backend for this chunk.
            // 2. Or, if the current page index + 1 equals the total number of pages fetched so far.
            const morePagesPotentiallyAvailable = currentData.length % 100 === 0;
            let showButton = false;
            if (morePagesPotentiallyAvailable) {
                const totalPagesFetched = currentPaginationNumber;
                const currentPageIndex = page; // page is 0-based index
                if (rowsPerPage === 100) showButton = totalPagesFetched === currentPageIndex + 1;
                else if (rowsPerPage === 25) // Show if the last item on the current page is the last item fetched so far
                showButton = (currentPageIndex + 1) * 25 === currentData.length && totalPagesFetched * 100 === currentData.length;
                else if (rowsPerPage === 10) // Show if the last item on the current page is the last item fetched so far
                showButton = (currentPageIndex + 1) * 10 === currentData.length && totalPagesFetched * 100 === currentData.length;
            }
            set({
                displayShowMoreButton: showButton
            });
        },
        // Add this function to reset all state to initial values
        resetState: ()=>set({
                dashboardTotal: {},
                camerasErrorInfo: [],
                camerasWarningInfo: [],
                activeTab: "error",
                page: 0,
                rowsPerPage: 10,
                errorPaginationNumber: 1,
                warningPaginationNumber: 1,
                displayShowMoreButton: false,
                loadingMoreData: false,
                pageLoading: false,
                dataIsLoading: true,
                usageData: [],
                currentData: "usageData",
                dateRangeName: "Last 24 hours",
                dataUsageOn: false,
                last5Name: "Data Usage",
                noFPData: false,
                errorFetchingUsageData: false,
                loadingErrorInfo: true,
                loadingWarningInfo: true
            })
    }));


const $4a8deacf667ef978$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $4a8deacf667ef978$export$8c3c5d4aa881b133 = ()=>{
    // Get state and actions directly from the store
    const { dashboardTotal: dashboardTotal, setActiveTab: setActiveTab, setPage: setPage } = (0, $ad6781d64ea9d765$export$176f58333fc13682)();
    const [clickedTab, setClickedTab] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("one");
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
            theme: $4a8deacf667ef978$var$theme,
            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3n3uW.default), {
                value: clickedTab,
                onChange: (event, tabValue)=>{
                    setClickedTab(tabValue);
                    if (tabValue === "one") {
                        setPage(0);
                        setActiveTab("error");
                    }
                    if (tabValue === "two") {
                        setPage(0);
                        setActiveTab("warning");
                    }
                },
                "aria-label": "tabs",
                color: "primary",
                variant: "fullWidth",
                sx: {
                    width: "100%",
                    maxWidth: "600px"
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                        value: "one",
                        label: `Error ${dashboardTotal.error ? `(${dashboardTotal.error})` : `(0)`}`,
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold",
                            color: "primary"
                        }
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                        value: "two",
                        label: `Warning ${dashboardTotal.warning ? `(${dashboardTotal.warning})` : `(0)`}`,
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold",
                            color: "primary"
                        }
                    })
                ]
            })
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $1wcxl = parcelRequire("1wcxl");

var $ha39s = parcelRequire("ha39s");

var $4reBM = parcelRequire("4reBM");

var $60vL1 = parcelRequire("60vL1");

var $k4ank = parcelRequire("k4ank");

var $cVCJe = parcelRequire("cVCJe");

var $aVDw9 = parcelRequire("aVDw9");
const $5787c4e90f761041$export$4a92fa353ea61a04 = (nameString, typeString, setPageLoading, object, navigate)=>{
    if (!nameString) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
        align: "left",
        sx: {
            fontFamily: "Mulish",
            width: "137.5px"
        },
        onClick: ()=>{
            navigate(`/sites/${object.customer.id}/editcamera/${object.id}`);
        },
        children: "--"
    });
    else if (nameString.length < 20 && typeString === "name") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
        align: "left",
        sx: {
            fontFamily: "Mulish",
            width: "137.5px"
        },
        onClick: ()=>{
            navigate(`/sites/${object.customer.id}/editcamera/${object.id}`);
        },
        children: nameString
    });
    else if (nameString.length < 20 && typeString === "error") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
        align: "left",
        sx: {
            fontFamily: "Mulish",
            width: "137.5px",
            color: "#D32F2F"
        },
        onClick: ()=>{
            navigate(`/sites/${object.customer.id}/editcamera/${object.id}`);
        },
        children: nameString
    });
    else if (nameString.length > 19 && typeString === "name") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: nameString,
        placement: "top",
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
            align: "left",
            sx: {
                fontFamily: "Mulish",
                width: "137.5px"
            },
            onClick: ()=>{
                navigate(`/sites/${object.customer.id}/editcamera/${object.id}`);
            },
            children: `${nameString.slice(0, 16)}...`
        })
    });
    else if (nameString.length > 19 && typeString === "error") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: nameString,
        placement: "top",
        onClick: ()=>{
            navigate(`/sites/${object.customer.id}/editcamera/${object.id}`);
        },
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
            align: "left",
            sx: {
                fontFamily: "Mulish",
                width: "137.5px",
                color: "#D32F2F"
            },
            onClick: ()=>{
                navigate(`/sites/${object.customer.id}/editcamera/${object.id}`);
            },
            children: `${nameString.slice(0, 16)}...`
        })
    });
    else return /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
        align: "left",
        sx: {
            fontFamily: "Mulish",
            width: "137.5px"
        },
        onClick: ()=>{
            navigate(`/sites/${object.customer.id}/editcamera/${object.id}`);
        },
        children: "--"
    });
};



var $8jTCz = parcelRequire("8jTCz");

var $dHtmK = parcelRequire("dHtmK");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

const $ee54b7e828af85e7$var$formatDateFromEpoch = (epoch)=>{
    const date = new Date(epoch * 1000); // Convert epoch seconds to milliseconds
    const options = {
        month: "short",
        day: "2-digit",
        year: "numeric"
    };
    return date.toLocaleDateString("en-US", options);
};
const $ee54b7e828af85e7$export$afe0f7a443b2bc8b = ()=>{
    const navigate = (0, $3T949.useNavigate)();
    // Get all state and actions directly from the store
    const { activeTab: activeTab, camerasErrorInfo: camerasErrorInfo, camerasWarningInfo: camerasWarningInfo, page: page, setPage: setPage, rowsPerPage: rowsPerPage, setRowsPerPage: setRowsPerPage, setPageLoading: setPageLoading, loadingMoreData: loadingMoreData, displayShowMoreButton: displayShowMoreButton, getAdditionalData: getAdditionalData, updateShowMoreButtonState: updateShowMoreButtonState, loadingErrorInfo: loadingErrorInfo, loadingWarningInfo: loadingWarningInfo } = (0, $ad6781d64ea9d765$export$176f58333fc13682)();
    // Determine data source based on activeTab
    const dataToDisplay = activeTab === "error" ? camerasErrorInfo : camerasWarningInfo;
    // const isLoading = dataToDisplay.length === 0; // Simple loading check
    // Update the "Load More" button visibility when relevant state changes
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        updateShowMoreButtonState();
    }, [
        rowsPerPage,
        page,
        activeTab,
        camerasErrorInfo,
        camerasWarningInfo,
        updateShowMoreButtonState
    ]);
    // Reset page when tab changes
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setPage(0);
    }, [
        activeTab,
        setPage
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4reBM.default), {
        sx: {
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                openState: loadingMoreData
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3Nm8Z.default), {
                sx: {
                    maxHeight: 640,
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                        "aria-label": "simple table",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: "Bold",
                                                width: "137.5px"
                                            },
                                            children: "Site"
                                        }, "site"),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: "Bold",
                                                width: "137.5px"
                                            },
                                            children: "Camera"
                                        }, "camera"),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: "Bold",
                                                width: "137.5px"
                                            },
                                            children: "Date"
                                        }, "date"),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            align: "left",
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: "Bold",
                                                width: "137.5px"
                                            },
                                            children: "Error"
                                        }, "error")
                                    ]
                                })
                            }),
                            (activeTab === "error" && !loadingErrorInfo || activeTab === "warning" && !loadingWarningInfo) && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $gXvgZ.default), {
                                children: [
                                    dataToDisplay.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((object)=>{
                                        return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                            hover: true,
                                            role: "checkbox",
                                            sx: {
                                                cursor: "pointer",
                                                fontFamily: "Mulish"
                                            },
                                            onClick: ()=>{
                                                navigate(`/sites/${object.customer.id}/editcamera/${object.id}`);
                                            },
                                            children: [
                                                (0, $5787c4e90f761041$export$4a92fa353ea61a04)(object.customer.name, "name", setPageLoading, object, navigate),
                                                (0, $5787c4e90f761041$export$4a92fa353ea61a04)(object.camera_name, "name", setPageLoading, object, navigate),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    onClick: ()=>{
                                                        navigate(`/sites/${object.customer.id}/editcamera/${object.id}`);
                                                    },
                                                    align: "left",
                                                    sx: {
                                                        fontFamily: "Mulish",
                                                        width: "137.5px"
                                                    },
                                                    children: object.date_added ? $ee54b7e828af85e7$var$formatDateFromEpoch(object.date_added) : "--"
                                                }),
                                                (0, $5787c4e90f761041$export$4a92fa353ea61a04)(object.message, "error", setPageLoading, object, navigate)
                                            ]
                                        }, object.id);
                                    }),
                                    displayShowMoreButton && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {}),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {}),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {}),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                    onClick: ()=>{
                                                        getAdditionalData(navigate);
                                                    },
                                                    text: "Load More",
                                                    disabled: false
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (activeTab === "error" && loadingErrorInfo || activeTab === "warning" && loadingWarningInfo) && /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        colSpan: 4,
                                        align: "center",
                                        sx: {
                                            padding: "20px"
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "flex flex-col items-center justify-center",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                                    size: 25,
                                                    sx: {
                                                        marginBottom: "8px"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "font-mulish text-actuate-blue font-bold",
                                                    children: "Fetching Data..."
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    dataToDisplay && /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wcxl.default), {
                        component: "div",
                        rowsPerPageOptions: [
                            10,
                            25,
                            100
                        ],
                        count: dataToDisplay.length,
                        rowsPerPage: rowsPerPage,
                        page: page,
                        onPageChange: (event, newPage)=>{
                            setPage(newPage);
                        },
                        onRowsPerPageChange: (event)=>{
                            setRowsPerPage(parseInt(event.target.value, 10));
                            setPage(0);
                        }
                    })
                ]
            })
        ]
    });
};



var $60vL1 = parcelRequire("60vL1");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

const $e5f6a9ef88175e17$export$5b42e29e5416e234 = ()=>{
    const { dashboardTotal: dashboardTotal } = (0, $ad6781d64ea9d765$export$176f58333fc13682)();
    const theme = (0, $cFPmV.default)({
        palette: {
            primary: {
                main: "#001943"
            },
            secondary: {
                main: "#F57C00"
            },
            success: {
                main: "#2E7D32"
            },
            error: {
                main: "#F44336"
            }
        }
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
        theme: theme,
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: "w-full min-w-0 bg-white",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "flex flex-wrap items-stretch gap-x-6 gap-y-4 px-6 py-5 sm:flex-nowrap",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "shrink-0 border-r-4 border-[#BDBDBD] pr-8",
                            children: [
                                Number(dashboardTotal.total) >= 0 ? /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "text-actuate-blue font-mulish text-[26px] font-bold",
                                    children: dashboardTotal.total
                                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                    color: "primary",
                                    size: 35
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "text-actuate-blue font-mulish text-[16px] font-bold",
                                    children: "Total Cameras"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "flex min-w-0 flex-1 items-center justify-around gap-4",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "flex flex-col items-center",
                                    children: [
                                        Number(dashboardTotal.error) >= 0 ? /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "text-[#F44336] font-mulish text-[16px] font-bold",
                                            children: dashboardTotal.error
                                        }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                            color: "error",
                                            size: 25
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "text-[#F44336] font-mulish text-[16px]",
                                            children: "Error"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cye0Y))), {
                                            sx: {
                                                color: "#F44336"
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "flex flex-col items-center",
                                    children: [
                                        Number(dashboardTotal.warning) >= 0 ? /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "text-[#F57C00] font-mulish text-[16px] font-bold",
                                            children: dashboardTotal.warning
                                        }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                            color: "secondary",
                                            size: 25
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "text-[#F57C00] font-mulish text-[16px]",
                                            children: "Warning"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gouAT))), {
                                            sx: {
                                                color: "#F57C00"
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "flex flex-col items-center",
                                    children: [
                                        Number(dashboardTotal.healthy) >= 0 ? /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "text-[#2E7D32] font-mulish text-[16px] font-bold",
                                            children: dashboardTotal.healthy
                                        }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                            color: "success",
                                            size: 25
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "text-[#2E7D32] font-mulish text-[16px]",
                                            children: "Healthy"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5Ibhh))), {
                                            sx: {
                                                color: "#2E7D32"
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "px-6",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4a8deacf667ef978$export$8c3c5d4aa881b133), {})
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "pt-4",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ee54b7e828af85e7$export$afe0f7a443b2bc8b), {})
                })
            ]
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $anJSP = parcelRequire("anJSP");

var $ddLR4 = parcelRequire("ddLR4");

var $3IuQ3 = parcelRequire("3IuQ3");

var $f3puC = parcelRequire("f3puC");

const $a4a6da4329941212$export$e37592be944b3337 = ()=>{
    const { setCurrentData: setCurrentData, dataUsageOn: dataUsageOn, setDataUsageOn: setDataUsageOn } = (0, $ad6781d64ea9d765$export$176f58333fc13682)();
    const AntSwitch = (0, $anJSP.default)((0, $ddLR4.default))(({ theme: theme })=>({
            width: 28,
            height: 16,
            padding: 0,
            display: "flex",
            "&:active": {
                "& .MuiSwitch-thumb": {
                    width: 15
                },
                "& .MuiSwitch-switchBase.Mui-checked": {
                    transform: "translateX(9px)"
                }
            },
            "& .MuiSwitch-switchBase": {
                padding: 2,
                "&.Mui-checked": {
                    transform: "translateX(12px)",
                    color: "#fff",
                    "& + .MuiSwitch-track": {
                        opacity: 1,
                        backgroundColor: "#283E6D"
                    }
                }
            },
            "& .MuiSwitch-thumb": {
                boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
                width: 12,
                height: 12,
                borderRadius: 6,
                transition: theme.transitions.create([
                    "width"
                ], {
                    duration: 200
                })
            },
            "& .MuiSwitch-track": {
                borderRadius: 8,
                opacity: 1,
                backgroundColor: "#FF8400",
                boxSizing: "border-box"
            }
        }));
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3IuQ3.default), {
        direction: "row",
        spacing: 1,
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                className: "text-actuate-orange ",
                children: "Data Usage"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)(AntSwitch, {
                checked: dataUsageOn,
                inputProps: {
                    "aria-label": "ant design"
                },
                onChange: (event, value)=>{
                    if (value) {
                        setDataUsageOn(true);
                        setCurrentData("alertVolumeData");
                    } else {
                        setDataUsageOn(false);
                        setCurrentData("usageData");
                    }
                }
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                className: "text-actuate-blue ",
                children: "Alert Volume"
            })
        ]
    });
};



var $60vL1 = parcelRequire("60vL1");

var $a65wX = parcelRequire("a65wX");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");

var $8T3gX = parcelRequire("8T3gX");

var $iVyaN = parcelRequire("iVyaN");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");
var $1fe5224011f53749$exports = {};
(function(global, factory) {
    factory($1fe5224011f53749$exports);
})($1fe5224011f53749$exports, function(exports1) {
    'use strict';
    const { getOwnPropertyNames: getOwnPropertyNames, getOwnPropertySymbols: getOwnPropertySymbols } = Object;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const { hasOwnProperty: hasOwnProperty } = Object.prototype;
    /**
     * Combine two comparators into a single comparators.
     */ function combineComparators(comparatorA, comparatorB) {
        return function isEqual(a, b, state) {
            return comparatorA(a, b, state) && comparatorB(a, b, state);
        };
    }
    /**
     * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
     * for circular references to be safely included in the comparison without creating
     * stack overflows.
     */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, state) {
            if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return areItemsEqual(a, b, state);
            const { cache: cache } = state;
            const cachedA = cache.get(a);
            const cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            const result = areItemsEqual(a, b, state);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
     * Get the `@@toStringTag` of the value, if it exists.
     */ function getShortTag(value) {
        return value != null ? value[Symbol.toStringTag] : undefined;
    }
    /**
     * Get the properties to strictly examine, which include both own properties that are
     * not enumerable and symbol properties.
     */ function getStrictProperties(object) {
        return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
    }
    /**
     * Whether the object contains the property passed as an own property.
     */ const hasOwn = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    Object.hasOwn || ((object, property)=>hasOwnProperty.call(object, property));
    /**
     * Whether the values passed are strictly equal or both NaN.
     */ function sameValueZeroEqual(a, b) {
        return a === b || !a && !b && a !== a && b !== b;
    }
    const PREACT_VNODE = '__v';
    const PREACT_OWNER = '__o';
    const REACT_OWNER = '_owner';
    const { getOwnPropertyDescriptor: getOwnPropertyDescriptor, keys: keys } = Object;
    /**
     * Whether the array buffers are equal in value.
     */ function areArrayBuffersEqual(a, b) {
        return a.byteLength === b.byteLength && areTypedArraysEqual(new Uint8Array(a), new Uint8Array(b));
    }
    /**
     * Whether the arrays are equal in value.
     */ function areArraysEqual(a, b, state) {
        let index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the dataviews are equal in value.
     */ function areDataViewsEqual(a, b) {
        return a.byteLength === b.byteLength && areTypedArraysEqual(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength));
    }
    /**
     * Whether the dates passed are equal in value.
     */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.getTime(), b.getTime());
    }
    /**
     * Whether the errors passed are equal in value.
     */ function areErrorsEqual(a, b) {
        return a.name === b.name && a.message === b.message && a.cause === b.cause && a.stack === b.stack;
    }
    /**
     * Whether the functions passed are equal in value.
     */ function areFunctionsEqual(a, b) {
        return a === b;
    }
    /**
     * Whether the `Map`s are equal in value.
     */ function areMapsEqual(a, b, state) {
        const size = a.size;
        if (size !== b.size) return false;
        if (!size) return true;
        const matchedIndices = new Array(size);
        const aIterable = a.entries();
        let aResult;
        let bResult;
        let index = 0;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            const bIterable = b.entries();
            let hasMatch = false;
            let matchIndex = 0;
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (matchedIndices[matchIndex]) {
                    matchIndex++;
                    continue;
                }
                const aEntry = aResult.value;
                const bEntry = bResult.value;
                if (state.equals(aEntry[0], bEntry[0], index, matchIndex, a, b, state) && state.equals(aEntry[1], bEntry[1], aEntry[0], bEntry[0], a, b, state)) {
                    hasMatch = matchedIndices[matchIndex] = true;
                    break;
                }
                matchIndex++;
            }
            if (!hasMatch) return false;
            index++;
        }
        return true;
    }
    /**
     * Whether the numbers are equal in value.
     */ const areNumbersEqual = sameValueZeroEqual;
    /**
     * Whether the objects are equal in value.
     */ function areObjectsEqual(a, b, state) {
        const properties = keys(a);
        let index = properties.length;
        if (keys(b).length !== index) return false;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            if (!isPropertyEqual(a, b, state, properties[index])) return false;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value with strict property checking.
     */ function areObjectsEqualStrict(a, b, state) {
        const properties = getStrictProperties(a);
        let index = properties.length;
        if (getStrictProperties(b).length !== index) return false;
        let property;
        let descriptorA;
        let descriptorB;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (!isPropertyEqual(a, b, state, property)) return false;
            descriptorA = getOwnPropertyDescriptor(a, property);
            descriptorB = getOwnPropertyDescriptor(b, property);
            if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
        }
        return true;
    }
    /**
     * Whether the primitive wrappers passed are equal in value.
     */ function arePrimitiveWrappersEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
     * Whether the regexps passed are equal in value.
     */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
     * Whether the `Set`s are equal in value.
     */ function areSetsEqual(a, b, state) {
        const size = a.size;
        if (size !== b.size) return false;
        if (!size) return true;
        const matchedIndices = new Array(size);
        const aIterable = a.values();
        let aResult;
        let bResult;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            const bIterable = b.values();
            let hasMatch = false;
            let matchIndex = 0;
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (!matchedIndices[matchIndex] && state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state)) {
                    hasMatch = matchedIndices[matchIndex] = true;
                    break;
                }
                matchIndex++;
            }
            if (!hasMatch) return false;
        }
        return true;
    }
    /**
     * Whether the TypedArray instances are equal in value.
     */ function areTypedArraysEqual(a, b) {
        let index = a.byteLength;
        if (b.byteLength !== index || a.byteOffset !== b.byteOffset) return false;
        while(index-- > 0){
            if (a[index] !== b[index]) return false;
        }
        return true;
    }
    /**
     * Whether the URL instances are equal in value.
     */ function areUrlsEqual(a, b) {
        return a.hostname === b.hostname && a.pathname === b.pathname && a.protocol === b.protocol && a.port === b.port && a.hash === b.hash && a.username === b.username && a.password === b.password;
    }
    function isPropertyEqual(a, b, state, property) {
        if ((property === REACT_OWNER || property === PREACT_OWNER || property === PREACT_VNODE) && (a.$$typeof || b.$$typeof)) return true;
        return hasOwn(b, property) && state.equals(a[property], b[property], property, property, a, b, state);
    }
    const ARRAY_BUFFER_TAG = '[object ArrayBuffer]';
    const ARGUMENTS_TAG = '[object Arguments]';
    const BOOLEAN_TAG = '[object Boolean]';
    const DATA_VIEW_TAG = '[object DataView]';
    const DATE_TAG = '[object Date]';
    const ERROR_TAG = '[object Error]';
    const MAP_TAG = '[object Map]';
    const NUMBER_TAG = '[object Number]';
    const OBJECT_TAG = '[object Object]';
    const REG_EXP_TAG = '[object RegExp]';
    const SET_TAG = '[object Set]';
    const STRING_TAG = '[object String]';
    const TYPED_ARRAY_TAGS = {
        '[object Int8Array]': true,
        '[object Uint8Array]': true,
        '[object Uint8ClampedArray]': true,
        '[object Int16Array]': true,
        '[object Uint16Array]': true,
        '[object Int32Array]': true,
        '[object Uint32Array]': true,
        '[object Float16Array]': true,
        '[object Float32Array]': true,
        '[object Float64Array]': true,
        '[object BigInt64Array]': true,
        '[object BigUint64Array]': true
    };
    const URL_TAG = '[object URL]';
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const toString = Object.prototype.toString;
    /**
     * Create a comparator method based on the type-specific equality comparators passed.
     */ function createEqualityComparator({ areArrayBuffersEqual: areArrayBuffersEqual, areArraysEqual: areArraysEqual, areDataViewsEqual: areDataViewsEqual, areDatesEqual: areDatesEqual, areErrorsEqual: areErrorsEqual, areFunctionsEqual: areFunctionsEqual, areMapsEqual: areMapsEqual, areNumbersEqual: areNumbersEqual, areObjectsEqual: areObjectsEqual, arePrimitiveWrappersEqual: arePrimitiveWrappersEqual, areRegExpsEqual: areRegExpsEqual, areSetsEqual: areSetsEqual, areTypedArraysEqual: areTypedArraysEqual, areUrlsEqual: areUrlsEqual, unknownTagComparators: unknownTagComparators }) {
        /**
         * compare the value of the two objects and return true if they are equivalent in values
         */ return function comparator(a, b, state) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If either of the items are nullish and fail the strictly equal check
            // above, then they must be unequal.
            if (a == null || b == null) return false;
            const type = typeof a;
            if (type !== typeof b) return false;
            if (type !== 'object') {
                if (type === 'number') return areNumbersEqual(a, b, state);
                if (type === 'function') return areFunctionsEqual(a, b, state);
                // If a primitive value that is not strictly equal, it must be unequal.
                return false;
            }
            const constructor = a.constructor;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // Constructors should match, otherwise there is potential for false positives
            // between class and subclass or custom object and POJO.
            if (constructor !== b.constructor) return false;
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid capturing the string tag.
            if (constructor === Object) return areObjectsEqual(a, b, state);
            // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
            // the string tag or doing an `instanceof` check.
            if (Array.isArray(a)) return areArraysEqual(a, b, state);
            // Try to fast-path equality checks for other complex object types in the
            // same realm to avoid capturing the string tag. Strict equality is used
            // instead of `instanceof` because it is more performant for the common
            // use-case. If someone is subclassing a native class, it will be handled
            // with the string tag comparison.
            if (constructor === Date) return areDatesEqual(a, b, state);
            if (constructor === RegExp) return areRegExpsEqual(a, b, state);
            if (constructor === Map) return areMapsEqual(a, b, state);
            if (constructor === Set) return areSetsEqual(a, b, state);
            // Since this is a custom object, capture the string tag to determing its type.
            // This is reasonably performant in modern environments like v8 and SpiderMonkey.
            const tag = toString.call(a);
            if (tag === DATE_TAG) return areDatesEqual(a, b, state);
            // For RegExp, the properties are not enumerable, and therefore will give false positives if
            // tested like a standard object.
            if (tag === REG_EXP_TAG) return areRegExpsEqual(a, b, state);
            if (tag === MAP_TAG) return areMapsEqual(a, b, state);
            if (tag === SET_TAG) return areSetsEqual(a, b, state);
            if (tag === OBJECT_TAG) // The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            return typeof a.then !== 'function' && typeof b.then !== 'function' && areObjectsEqual(a, b, state);
            // If a URL tag, it should be tested explicitly. Like RegExp, the properties are not
            // enumerable, and therefore will give false positives if tested like a standard object.
            if (tag === URL_TAG) return areUrlsEqual(a, b, state);
            // If an error tag, it should be tested explicitly. Like RegExp, the properties are not
            // enumerable, and therefore will give false positives if tested like a standard object.
            if (tag === ERROR_TAG) return areErrorsEqual(a, b, state);
            // If an arguments tag, it should be treated as a standard object.
            if (tag === ARGUMENTS_TAG) return areObjectsEqual(a, b, state);
            if (TYPED_ARRAY_TAGS[tag]) return areTypedArraysEqual(a, b, state);
            if (tag === ARRAY_BUFFER_TAG) return areArrayBuffersEqual(a, b, state);
            if (tag === DATA_VIEW_TAG) return areDataViewsEqual(a, b, state);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) return arePrimitiveWrappersEqual(a, b, state);
            if (unknownTagComparators) {
                let unknownTagComparator = unknownTagComparators[tag];
                if (!unknownTagComparator) {
                    const shortTag = getShortTag(a);
                    if (shortTag) unknownTagComparator = unknownTagComparators[shortTag];
                }
                // If the custom config has an unknown tag comparator that matches the captured tag or the
                // @@toStringTag, it is the source of truth for whether the values are equal.
                if (unknownTagComparator) return unknownTagComparator(a, b, state);
            }
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        };
    }
    /**
     * Create the configuration object used for building comparators.
     */ function createEqualityComparatorConfig({ circular: circular, createCustomConfig: createCustomConfig, strict: strict }) {
        let config = {
            areArrayBuffersEqual: areArrayBuffersEqual,
            areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
            areDataViewsEqual: areDataViewsEqual,
            areDatesEqual: areDatesEqual,
            areErrorsEqual: areErrorsEqual,
            areFunctionsEqual: areFunctionsEqual,
            areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
            areNumbersEqual: areNumbersEqual,
            areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
            arePrimitiveWrappersEqual: arePrimitiveWrappersEqual,
            areRegExpsEqual: areRegExpsEqual,
            areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
            areTypedArraysEqual: strict ? combineComparators(areTypedArraysEqual, areObjectsEqualStrict) : areTypedArraysEqual,
            areUrlsEqual: areUrlsEqual,
            unknownTagComparators: undefined
        };
        if (createCustomConfig) config = Object.assign({}, config, createCustomConfig(config));
        if (circular) {
            const areArraysEqual = createIsCircular(config.areArraysEqual);
            const areMapsEqual = createIsCircular(config.areMapsEqual);
            const areObjectsEqual = createIsCircular(config.areObjectsEqual);
            const areSetsEqual = createIsCircular(config.areSetsEqual);
            config = Object.assign({}, config, {
                areArraysEqual: areArraysEqual,
                areMapsEqual: areMapsEqual,
                areObjectsEqual: areObjectsEqual,
                areSetsEqual: areSetsEqual
            });
        }
        return config;
    }
    /**
     * Default equality comparator pass-through, used as the standard `isEqual` creator for
     * use inside the built comparator.
     */ function createInternalEqualityComparator(compare) {
        return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
            return compare(a, b, state);
        };
    }
    /**
     * Create the `isEqual` function used by the consuming application.
     */ function createIsEqual({ circular: circular, comparator: comparator, createState: createState, equals: equals, strict: strict }) {
        if (createState) return function isEqual(a, b) {
            const { cache: cache = circular ? new WeakMap() : undefined, meta: meta } = createState();
            return comparator(a, b, {
                cache: cache,
                equals: equals,
                meta: meta,
                strict: strict
            });
        };
        if (circular) return function isEqual(a, b) {
            return comparator(a, b, {
                cache: new WeakMap(),
                equals: equals,
                meta: undefined,
                strict: strict
            });
        };
        const state = {
            cache: undefined,
            equals: equals,
            meta: undefined,
            strict: strict
        };
        return function isEqual(a, b) {
            return comparator(a, b, state);
        };
    }
    /**
     * Whether the items passed are deeply-equal in value.
     */ const deepEqual = createCustomEqual();
    /**
     * Whether the items passed are deeply-equal in value based on strict comparison.
     */ const strictDeepEqual = createCustomEqual({
        strict: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references.
     */ const circularDeepEqual = createCustomEqual({
        circular: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references,
     * based on strict comparison.
     */ const strictCircularDeepEqual = createCustomEqual({
        circular: true,
        strict: true
    });
    /**
     * Whether the items passed are shallowly-equal in value.
     */ const shallowEqual = createCustomEqual({
        createInternalComparator: ()=>sameValueZeroEqual
    });
    /**
     * Whether the items passed are shallowly-equal in value based on strict comparison
     */ const strictShallowEqual = createCustomEqual({
        strict: true,
        createInternalComparator: ()=>sameValueZeroEqual
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references.
     */ const circularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: ()=>sameValueZeroEqual
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references,
     * based on strict comparison.
     */ const strictCircularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: ()=>sameValueZeroEqual,
        strict: true
    });
    /**
     * Create a custom equality comparison method.
     *
     * This can be done to create very targeted comparisons in extreme hot-path scenarios
     * where the standard methods are not performant enough, but can also be used to provide
     * support for legacy environments that do not support expected features like
     * `RegExp.prototype.flags` out of the box.
     */ function createCustomEqual(options = {}) {
        const { circular: circular = false, createInternalComparator: createCustomInternalComparator, createState: createState, strict: strict = false } = options;
        const config = createEqualityComparatorConfig(options);
        const comparator = createEqualityComparator(config);
        const equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
        return createIsEqual({
            circular: circular,
            comparator: comparator,
            createState: createState,
            equals: equals,
            strict: strict
        });
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    exports1.strictCircularDeepEqual = strictCircularDeepEqual;
    exports1.strictCircularShallowEqual = strictCircularShallowEqual;
    exports1.strictDeepEqual = strictDeepEqual;
    exports1.strictShallowEqual = strictShallowEqual;
});


function $b83d730e24d84112$var$safeRequestAnimationFrame(callback) {
    if (typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(callback);
}
function $b83d730e24d84112$export$2e2bcd8739ae039(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var currTime = -1;
    var shouldUpdate = function shouldUpdate(now) {
        if (currTime < 0) currTime = now;
        if (now - currTime > timeout) {
            callback(now);
            currTime = -1;
        } else $b83d730e24d84112$var$safeRequestAnimationFrame(shouldUpdate);
    };
    requestAnimationFrame(shouldUpdate);
}


function $12df2919cff867fd$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $12df2919cff867fd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $12df2919cff867fd$var$_typeof(o);
}
function $12df2919cff867fd$var$_toArray(arr) {
    return $12df2919cff867fd$var$_arrayWithHoles(arr) || $12df2919cff867fd$var$_iterableToArray(arr) || $12df2919cff867fd$var$_unsupportedIterableToArray(arr) || $12df2919cff867fd$var$_nonIterableRest();
}
function $12df2919cff867fd$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $12df2919cff867fd$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $12df2919cff867fd$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $12df2919cff867fd$var$_arrayLikeToArray(o, minLen);
}
function $12df2919cff867fd$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $12df2919cff867fd$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $12df2919cff867fd$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $12df2919cff867fd$export$2e2bcd8739ae039() {
    var currStyle = {};
    var handleChange = function handleChange() {
        return null;
    };
    var shouldStop = false;
    var setStyle = function setStyle(_style) {
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var _styles = $12df2919cff867fd$var$_toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
            if (typeof curr === 'number') {
                (0, $b83d730e24d84112$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            (0, $b83d730e24d84112$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles));
            return;
        }
        if ($12df2919cff867fd$var$_typeof(_style) === 'object') {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === 'function') _style();
    };
    return {
        stop: function stop() {
            shouldStop = true;
        },
        start: function start(style) {
            shouldStop = false;
            setStyle(style);
        },
        subscribe: function subscribe(_handleChange) {
            handleChange = _handleChange;
            return function() {
                handleChange = function handleChange() {
                    return null;
                };
            };
        }
    };
}


function $d91e3e493da0d0b9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d91e3e493da0d0b9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d91e3e493da0d0b9$var$_typeof(o);
}
function $d91e3e493da0d0b9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d91e3e493da0d0b9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d91e3e493da0d0b9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d91e3e493da0d0b9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d91e3e493da0d0b9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d91e3e493da0d0b9$var$_defineProperty(obj, key, value) {
    key = $d91e3e493da0d0b9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d91e3e493da0d0b9$var$_toPropertyKey(arg) {
    var key = $d91e3e493da0d0b9$var$_toPrimitive(arg, "string");
    return $d91e3e493da0d0b9$var$_typeof(key) === "symbol" ? key : String(key);
}
function $d91e3e493da0d0b9$var$_toPrimitive(input, hint) {
    if ($d91e3e493da0d0b9$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($d91e3e493da0d0b9$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $d91e3e493da0d0b9$export$59e29973723da0b3 = function getIntersectionKeys(preObj, nextObj) {
    return [
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce(function(a, b) {
        return a.filter(function(c) {
            return b.includes(c);
        });
    });
};
var $d91e3e493da0d0b9$export$f0954fd7d5368655 = function identity(param) {
    return param;
};
var $d91e3e493da0d0b9$export$51610fddbf64bc9d = function getDashCase(name) {
    return name.replace(/([A-Z])/g, function(v) {
        return "-".concat(v.toLowerCase());
    });
};
var $d91e3e493da0d0b9$export$bef1f36f5486a6a3 = function log() {
    var _console;
    (_console = console).log.apply(_console, arguments);
};
var $d91e3e493da0d0b9$export$1c9f709888824e05 = function debug(name) {
    return function(item) {
        $d91e3e493da0d0b9$export$bef1f36f5486a6a3(name, item);
        return item;
    };
};
var $d91e3e493da0d0b9$export$1dc45301cd23a8c7 = function debugf(tag, f) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var res = f.apply(void 0, args);
        var name = tag || f.name || 'anonymous function';
        var argNames = "(".concat(args.map(JSON.stringify).join(', '), ")");
        $d91e3e493da0d0b9$export$bef1f36f5486a6a3("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
        return res;
    };
};
var $d91e3e493da0d0b9$export$d6051a0f7a227332 = function mapObject(fn, obj) {
    return Object.keys(obj).reduce(function(res, key) {
        return $d91e3e493da0d0b9$var$_objectSpread($d91e3e493da0d0b9$var$_objectSpread({}, res), {}, $d91e3e493da0d0b9$var$_defineProperty({}, key, fn(key, obj[key])));
    }, {});
};
var $d91e3e493da0d0b9$export$1594c78389ee3429 = function getTransitionVal(props, duration, easing) {
    return props.map(function(prop) {
        return "".concat($d91e3e493da0d0b9$export$51610fddbf64bc9d(prop), " ").concat(duration, "ms ").concat(easing);
    }).join(',');
};
var $d91e3e493da0d0b9$var$isDev = true;
var $d91e3e493da0d0b9$export$c106dd0671a0fc2d = function warn(condition, format, a, b, c, d, e, f) {
    if ($d91e3e493da0d0b9$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var args = [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f
                ];
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};


function $51f6008f9b1479d2$var$_slicedToArray(arr, i) {
    return $51f6008f9b1479d2$var$_arrayWithHoles(arr) || $51f6008f9b1479d2$var$_iterableToArrayLimit(arr, i) || $51f6008f9b1479d2$var$_unsupportedIterableToArray(arr, i) || $51f6008f9b1479d2$var$_nonIterableRest();
}
function $51f6008f9b1479d2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $51f6008f9b1479d2$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $51f6008f9b1479d2$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $51f6008f9b1479d2$var$_toConsumableArray(arr) {
    return $51f6008f9b1479d2$var$_arrayWithoutHoles(arr) || $51f6008f9b1479d2$var$_iterableToArray(arr) || $51f6008f9b1479d2$var$_unsupportedIterableToArray(arr) || $51f6008f9b1479d2$var$_nonIterableSpread();
}
function $51f6008f9b1479d2$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $51f6008f9b1479d2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $51f6008f9b1479d2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $51f6008f9b1479d2$var$_arrayLikeToArray(o, minLen);
}
function $51f6008f9b1479d2$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $51f6008f9b1479d2$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $51f6008f9b1479d2$var$_arrayLikeToArray(arr);
}
function $51f6008f9b1479d2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $51f6008f9b1479d2$var$ACCURACY = 1e-4;
var $51f6008f9b1479d2$var$cubicBezierFactor = function cubicBezierFactor(c1, c2) {
    return [
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
};
var $51f6008f9b1479d2$var$multyTime = function multyTime(params, t) {
    return params.map(function(param, i) {
        return param * Math.pow(t, i);
    }).reduce(function(pre, curr) {
        return pre + curr;
    });
};
var $51f6008f9b1479d2$var$cubicBezier = function cubicBezier(c1, c2) {
    return function(t) {
        var params = $51f6008f9b1479d2$var$cubicBezierFactor(c1, c2);
        return $51f6008f9b1479d2$var$multyTime(params, t);
    };
};
var $51f6008f9b1479d2$var$derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
    return function(t) {
        var params = $51f6008f9b1479d2$var$cubicBezierFactor(c1, c2);
        var newParams = [].concat($51f6008f9b1479d2$var$_toConsumableArray(params.map(function(param, i) {
            return param * i;
        }).slice(1)), [
            0
        ]);
        return $51f6008f9b1479d2$var$multyTime(newParams, t);
    };
};
var $51f6008f9b1479d2$export$56c51296f72f0592 = function configBezier() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var x1 = args[0], y1 = args[1], x2 = args[2], y2 = args[3];
    if (args.length === 1) switch(args[0]){
        case 'linear':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease':
            x1 = 0.25;
            y1 = 0.1;
            x2 = 0.25;
            y2 = 1.0;
            break;
        case 'ease-in':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case 'ease-out':
            x1 = 0.42;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        case 'ease-in-out':
            x1 = 0.0;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        default:
            var easing = args[0].split('(');
            if (easing[0] === 'cubic-bezier' && easing[1].split(')')[0].split(',').length === 4) {
                var _easing$1$split$0$spl = easing[1].split(')')[0].split(',').map(function(x) {
                    return parseFloat(x);
                });
                var _easing$1$split$0$spl2 = $51f6008f9b1479d2$var$_slicedToArray(_easing$1$split$0$spl, 4);
                x1 = _easing$1$split$0$spl2[0];
                y1 = _easing$1$split$0$spl2[1];
                x2 = _easing$1$split$0$spl2[2];
                y2 = _easing$1$split$0$spl2[3];
            } else (0, $d91e3e493da0d0b9$export$c106dd0671a0fc2d)(false, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
    }
    (0, $d91e3e493da0d0b9$export$c106dd0671a0fc2d)([
        x1,
        x2,
        y1,
        y2
    ].every(function(num) {
        return typeof num === 'number' && num >= 0 && num <= 1;
    }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
    var curveX = $51f6008f9b1479d2$var$cubicBezier(x1, x2);
    var curveY = $51f6008f9b1479d2$var$cubicBezier(y1, y2);
    var derCurveX = $51f6008f9b1479d2$var$derivativeCubicBezier(x1, x2);
    var rangeValue = function rangeValue(value) {
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = function bezier(_t) {
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < $51f6008f9b1479d2$var$ACCURACY || derVal < $51f6008f9b1479d2$var$ACCURACY) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var $51f6008f9b1479d2$export$12fc25daf62b865a = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$stiff = config.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config.dt, dt = _config$dt === void 0 ? 17 : _config$dt;
    var stepper = function stepper(currX, destX, currV) {
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < $51f6008f9b1479d2$var$ACCURACY && Math.abs(newV) < $51f6008f9b1479d2$var$ACCURACY) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var $51f6008f9b1479d2$export$e3e04925801e5434 = function configEasing() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var easing = args[0];
    if (typeof easing === 'string') switch(easing){
        case 'ease':
        case 'ease-in-out':
        case 'ease-out':
        case 'ease-in':
        case 'linear':
            return $51f6008f9b1479d2$export$56c51296f72f0592(easing);
        case 'spring':
            return $51f6008f9b1479d2$export$12fc25daf62b865a();
        default:
            if (easing.split('(')[0] === 'cubic-bezier') return $51f6008f9b1479d2$export$56c51296f72f0592(easing);
            (0, $d91e3e493da0d0b9$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
    if (typeof easing === 'function') return easing;
    (0, $d91e3e493da0d0b9$export$c106dd0671a0fc2d)(false, '[configEasing]: first argument type should be function or string, instead received %s', args);
    return null;
};



function $9b48f1c1b24e4596$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9b48f1c1b24e4596$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9b48f1c1b24e4596$var$_typeof(o);
}
function $9b48f1c1b24e4596$var$_toConsumableArray(arr) {
    return $9b48f1c1b24e4596$var$_arrayWithoutHoles(arr) || $9b48f1c1b24e4596$var$_iterableToArray(arr) || $9b48f1c1b24e4596$var$_unsupportedIterableToArray(arr) || $9b48f1c1b24e4596$var$_nonIterableSpread();
}
function $9b48f1c1b24e4596$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9b48f1c1b24e4596$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $9b48f1c1b24e4596$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9b48f1c1b24e4596$var$_arrayLikeToArray(arr);
}
function $9b48f1c1b24e4596$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9b48f1c1b24e4596$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9b48f1c1b24e4596$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9b48f1c1b24e4596$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9b48f1c1b24e4596$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9b48f1c1b24e4596$var$_defineProperty(obj, key, value) {
    key = $9b48f1c1b24e4596$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9b48f1c1b24e4596$var$_toPropertyKey(arg) {
    var key = $9b48f1c1b24e4596$var$_toPrimitive(arg, "string");
    return $9b48f1c1b24e4596$var$_typeof(key) === "symbol" ? key : String(key);
}
function $9b48f1c1b24e4596$var$_toPrimitive(input, hint) {
    if ($9b48f1c1b24e4596$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($9b48f1c1b24e4596$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $9b48f1c1b24e4596$var$_slicedToArray(arr, i) {
    return $9b48f1c1b24e4596$var$_arrayWithHoles(arr) || $9b48f1c1b24e4596$var$_iterableToArrayLimit(arr, i) || $9b48f1c1b24e4596$var$_unsupportedIterableToArray(arr, i) || $9b48f1c1b24e4596$var$_nonIterableRest();
}
function $9b48f1c1b24e4596$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9b48f1c1b24e4596$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9b48f1c1b24e4596$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9b48f1c1b24e4596$var$_arrayLikeToArray(o, minLen);
}
function $9b48f1c1b24e4596$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9b48f1c1b24e4596$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $9b48f1c1b24e4596$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $9b48f1c1b24e4596$var$alpha = function alpha(begin, end, k) {
    return begin + (end - begin) * k;
};
var $9b48f1c1b24e4596$var$needContinue = function needContinue(_ref) {
    var from = _ref.from, to = _ref.to;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var $9b48f1c1b24e4596$var$calStepperVals = function calStepperVals(easing, preVals, steps) {
    var nextStepVals = (0, $d91e3e493da0d0b9$export$d6051a0f7a227332)(function(key, val) {
        if ($9b48f1c1b24e4596$var$needContinue(val)) {
            var _easing = easing(val.from, val.to, val.velocity), _easing2 = $9b48f1c1b24e4596$var$_slicedToArray(_easing, 2), newX = _easing2[0], newV = _easing2[1];
            return $9b48f1c1b24e4596$var$_objectSpread($9b48f1c1b24e4596$var$_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, $d91e3e493da0d0b9$export$d6051a0f7a227332)(function(key, val) {
        if ($9b48f1c1b24e4596$var$needContinue(val)) return $9b48f1c1b24e4596$var$_objectSpread($9b48f1c1b24e4596$var$_objectSpread({}, val), {}, {
            velocity: $9b48f1c1b24e4596$var$alpha(val.velocity, nextStepVals[key].velocity, steps),
            from: $9b48f1c1b24e4596$var$alpha(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return calStepperVals(easing, nextStepVals, steps - 1);
};
var // configure update function
$9b48f1c1b24e4596$export$2e2bcd8739ae039 = function(from, to, easing, duration, render) {
    var interKeys = (0, $d91e3e493da0d0b9$export$59e29973723da0b3)(from, to);
    var timingStyle = interKeys.reduce(function(res, key) {
        return $9b48f1c1b24e4596$var$_objectSpread($9b48f1c1b24e4596$var$_objectSpread({}, res), {}, $9b48f1c1b24e4596$var$_defineProperty({}, key, [
            from[key],
            to[key]
        ]));
    }, {});
    var stepperStyle = interKeys.reduce(function(res, key) {
        return $9b48f1c1b24e4596$var$_objectSpread($9b48f1c1b24e4596$var$_objectSpread({}, res), {}, $9b48f1c1b24e4596$var$_defineProperty({}, key, {
            from: from[key],
            velocity: 0,
            to: to[key]
        }));
    }, {});
    var cafId = -1;
    var preTime;
    var beginTime;
    var update = function update() {
        return null;
    };
    var getCurrStyle = function getCurrStyle() {
        return (0, $d91e3e493da0d0b9$export$d6051a0f7a227332)(function(key, val) {
            return val.from;
        }, stepperStyle);
    };
    var shouldStopAnimation = function shouldStopAnimation() {
        return !Object.values(stepperStyle).filter($9b48f1c1b24e4596$var$needContinue).length;
    };
    // stepper timing function like spring
    var stepperUpdate = function stepperUpdate(now) {
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = $9b48f1c1b24e4596$var$calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render($9b48f1c1b24e4596$var$_objectSpread($9b48f1c1b24e4596$var$_objectSpread($9b48f1c1b24e4596$var$_objectSpread({}, from), to), getCurrStyle(stepperStyle)));
        preTime = now;
        if (!shouldStopAnimation()) cafId = requestAnimationFrame(update);
    };
    // t => val timing function like cubic-bezier
    var timingUpdate = function timingUpdate(now) {
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, $d91e3e493da0d0b9$export$d6051a0f7a227332)(function(key, val) {
            return $9b48f1c1b24e4596$var$alpha.apply(void 0, $9b48f1c1b24e4596$var$_toConsumableArray(val).concat([
                easing(t)
            ]));
        }, timingStyle);
        // get union set and add compatible prefix
        render($9b48f1c1b24e4596$var$_objectSpread($9b48f1c1b24e4596$var$_objectSpread($9b48f1c1b24e4596$var$_objectSpread({}, from), to), currStyle));
        if (t < 1) cafId = requestAnimationFrame(update);
        else {
            var finalStyle = (0, $d91e3e493da0d0b9$export$d6051a0f7a227332)(function(key, val) {
                return $9b48f1c1b24e4596$var$alpha.apply(void 0, $9b48f1c1b24e4596$var$_toConsumableArray(val).concat([
                    easing(1)
                ]));
            }, timingStyle);
            render($9b48f1c1b24e4596$var$_objectSpread($9b48f1c1b24e4596$var$_objectSpread($9b48f1c1b24e4596$var$_objectSpread({}, from), to), finalStyle));
        }
    };
    update = easing.isStepper ? stepperUpdate : timingUpdate;
    // return start animation method
    return function() {
        requestAnimationFrame(update);
        // return stop animation method
        return function() {
            cancelAnimationFrame(cafId);
        };
    };
};



function $1d21108f50b7f549$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1d21108f50b7f549$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1d21108f50b7f549$var$_typeof(o);
}
var $1d21108f50b7f549$var$_excluded = [
    "children",
    "begin",
    "duration",
    "attributeName",
    "easing",
    "isActive",
    "steps",
    "from",
    "to",
    "canBegin",
    "onAnimationEnd",
    "shouldReAnimate",
    "onAnimationReStart"
];
function $1d21108f50b7f549$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1d21108f50b7f549$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1d21108f50b7f549$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $1d21108f50b7f549$var$_toConsumableArray(arr) {
    return $1d21108f50b7f549$var$_arrayWithoutHoles(arr) || $1d21108f50b7f549$var$_iterableToArray(arr) || $1d21108f50b7f549$var$_unsupportedIterableToArray(arr) || $1d21108f50b7f549$var$_nonIterableSpread();
}
function $1d21108f50b7f549$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1d21108f50b7f549$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1d21108f50b7f549$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1d21108f50b7f549$var$_arrayLikeToArray(o, minLen);
}
function $1d21108f50b7f549$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $1d21108f50b7f549$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1d21108f50b7f549$var$_arrayLikeToArray(arr);
}
function $1d21108f50b7f549$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1d21108f50b7f549$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1d21108f50b7f549$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1d21108f50b7f549$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1d21108f50b7f549$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1d21108f50b7f549$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1d21108f50b7f549$var$_defineProperty(obj, key, value) {
    key = $1d21108f50b7f549$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1d21108f50b7f549$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1d21108f50b7f549$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $1d21108f50b7f549$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $1d21108f50b7f549$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1d21108f50b7f549$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1d21108f50b7f549$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $1d21108f50b7f549$var$_toPropertyKey(arg) {
    var key = $1d21108f50b7f549$var$_toPrimitive(arg, "string");
    return $1d21108f50b7f549$var$_typeof(key) === "symbol" ? key : String(key);
}
function $1d21108f50b7f549$var$_toPrimitive(input, hint) {
    if ($1d21108f50b7f549$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($1d21108f50b7f549$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $1d21108f50b7f549$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $1d21108f50b7f549$var$_setPrototypeOf(subClass, superClass);
}
function $1d21108f50b7f549$var$_setPrototypeOf(o, p) {
    $1d21108f50b7f549$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1d21108f50b7f549$var$_setPrototypeOf(o, p);
}
function $1d21108f50b7f549$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1d21108f50b7f549$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $1d21108f50b7f549$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1d21108f50b7f549$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1d21108f50b7f549$var$_possibleConstructorReturn(this, result);
    };
}
function $1d21108f50b7f549$var$_possibleConstructorReturn(self, call) {
    if (call && ($1d21108f50b7f549$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $1d21108f50b7f549$var$_assertThisInitialized(self);
}
function $1d21108f50b7f549$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1d21108f50b7f549$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $1d21108f50b7f549$var$_getPrototypeOf(o) {
    $1d21108f50b7f549$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1d21108f50b7f549$var$_getPrototypeOf(o);
}
var $1d21108f50b7f549$var$Animate = /*#__PURE__*/ function(_PureComponent) {
    $1d21108f50b7f549$var$_inherits(Animate, _PureComponent);
    var _super = $1d21108f50b7f549$var$_createSuper(Animate);
    function Animate(props, context) {
        var _this;
        $1d21108f50b7f549$var$_classCallCheck(this, Animate);
        _this = _super.call(this, props, context);
        var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps = _this$props.steps, children = _this$props.children, duration = _this$props.duration;
        _this.handleStyleChange = _this.handleStyleChange.bind($1d21108f50b7f549$var$_assertThisInitialized(_this));
        _this.changeStyle = _this.changeStyle.bind($1d21108f50b7f549$var$_assertThisInitialized(_this));
        if (!isActive || duration <= 0) {
            _this.state = {
                style: {}
            };
            // if children is a function and animation is not active, set style to 'to'
            if (typeof children === 'function') _this.state = {
                style: to
            };
            return $1d21108f50b7f549$var$_possibleConstructorReturn(_this);
        }
        if (steps && steps.length) _this.state = {
            style: steps[0].style
        };
        else if (from) {
            if (typeof children === 'function') {
                _this.state = {
                    style: from
                };
                return $1d21108f50b7f549$var$_possibleConstructorReturn(_this);
            }
            _this.state = {
                style: attributeName ? $1d21108f50b7f549$var$_defineProperty({}, attributeName, from) : from
            };
        } else _this.state = {
            style: {}
        };
        return _this;
    }
    $1d21108f50b7f549$var$_createClass(Animate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
                this.mounted = true;
                if (!isActive || !canBegin) return;
                this.runAnimation(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate, to = _this$props3.to, currentFrom = _this$props3.from;
                var style = this.state.style;
                if (!canBegin) return;
                if (!isActive) {
                    var newState = {
                        style: attributeName ? $1d21108f50b7f549$var$_defineProperty({}, attributeName, to) : to
                    };
                    if (this.state && style) {
                        if (attributeName && style[attributeName] !== to || !attributeName && style !== to) // eslint-disable-next-line react/no-did-update-set-state
                        this.setState(newState);
                    }
                    return;
                }
                if ((0, $1fe5224011f53749$exports.deepEqual)(prevProps.to, to) && prevProps.canBegin && prevProps.isActive) return;
                var isTriggered = !prevProps.canBegin || !prevProps.isActive;
                if (this.manager) this.manager.stop();
                if (this.stopJSAnimation) this.stopJSAnimation();
                var from = isTriggered || shouldReAnimate ? currentFrom : prevProps.to;
                if (this.state && style) {
                    var _newState = {
                        style: attributeName ? $1d21108f50b7f549$var$_defineProperty({}, attributeName, from) : from
                    };
                    if (attributeName && style[attributeName] !== from || !attributeName && style !== from) // eslint-disable-next-line react/no-did-update-set-state
                    this.setState(_newState);
                }
                this.runAnimation($1d21108f50b7f549$var$_objectSpread($1d21108f50b7f549$var$_objectSpread({}, this.props), {}, {
                    from: from,
                    begin: 0
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
                var onAnimationEnd = this.props.onAnimationEnd;
                if (this.unSubscribe) this.unSubscribe();
                if (this.manager) {
                    this.manager.stop();
                    this.manager = null;
                }
                if (this.stopJSAnimation) this.stopJSAnimation();
                if (onAnimationEnd) onAnimationEnd();
            }
        },
        {
            key: "handleStyleChange",
            value: function handleStyleChange(style) {
                this.changeStyle(style);
            }
        },
        {
            key: "changeStyle",
            value: function changeStyle(style) {
                if (this.mounted) this.setState({
                    style: style
                });
            }
        },
        {
            key: "runJSAnimation",
            value: function runJSAnimation(props) {
                var _this2 = this;
                var from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd = props.onAnimationEnd, onAnimationStart = props.onAnimationStart;
                var startAnimation = (0, $9b48f1c1b24e4596$export$2e2bcd8739ae039)(from, to, (0, $51f6008f9b1479d2$export$e3e04925801e5434)(easing), duration, this.changeStyle);
                var finalStartAnimation = function finalStartAnimation() {
                    _this2.stopJSAnimation = startAnimation();
                };
                this.manager.start([
                    onAnimationStart,
                    begin,
                    finalStartAnimation,
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "runStepAnimation",
            value: function runStepAnimation(props) {
                var _this3 = this;
                var steps = props.steps, begin = props.begin, onAnimationStart = props.onAnimationStart;
                var _steps$ = steps[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
                var addStyle = function addStyle(sequence, nextItem, index) {
                    if (index === 0) return sequence;
                    var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? 'ease' : _nextItem$easing, style = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd = nextItem.onAnimationEnd;
                    var preItem = index > 0 ? steps[index - 1] : nextItem;
                    var properties = nextProperties || Object.keys(style);
                    if (typeof easing === 'function' || easing === 'spring') return [].concat($1d21108f50b7f549$var$_toConsumableArray(sequence), [
                        _this3.runJSAnimation.bind(_this3, {
                            from: preItem.style,
                            to: style,
                            duration: duration,
                            easing: easing
                        }),
                        duration
                    ]);
                    var transition = (0, $d91e3e493da0d0b9$export$1594c78389ee3429)(properties, duration, easing);
                    var newStyle = $1d21108f50b7f549$var$_objectSpread($1d21108f50b7f549$var$_objectSpread($1d21108f50b7f549$var$_objectSpread({}, preItem.style), style), {}, {
                        transition: transition
                    });
                    return [].concat($1d21108f50b7f549$var$_toConsumableArray(sequence), [
                        newStyle,
                        duration,
                        onAnimationEnd
                    ]).filter((0, $d91e3e493da0d0b9$export$f0954fd7d5368655));
                };
                return this.manager.start([
                    onAnimationStart
                ].concat($1d21108f50b7f549$var$_toConsumableArray(steps.reduce(addStyle, [
                    initialStyle,
                    Math.max(initialTime, begin)
                ])), [
                    props.onAnimationEnd
                ]));
            }
        },
        {
            key: "runAnimation",
            value: function runAnimation(props) {
                if (!this.manager) this.manager = (0, $12df2919cff867fd$export$2e2bcd8739ae039)();
                var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart = props.onAnimationStart, onAnimationEnd = props.onAnimationEnd, steps = props.steps, children = props.children;
                var manager = this.manager;
                this.unSubscribe = manager.subscribe(this.handleStyleChange);
                if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
                    this.runJSAnimation(props);
                    return;
                }
                if (steps.length > 1) {
                    this.runStepAnimation(props);
                    return;
                }
                var to = attributeName ? $1d21108f50b7f549$var$_defineProperty({}, attributeName, propsTo) : propsTo;
                var transition = (0, $d91e3e493da0d0b9$export$1594c78389ee3429)(Object.keys(to), duration, easing);
                manager.start([
                    onAnimationStart,
                    begin,
                    $1d21108f50b7f549$var$_objectSpread($1d21108f50b7f549$var$_objectSpread({}, to), {}, {
                        transition: transition
                    }),
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, children = _this$props4.children, begin = _this$props4.begin, duration = _this$props4.duration, attributeName = _this$props4.attributeName, easing = _this$props4.easing, isActive = _this$props4.isActive, steps = _this$props4.steps, from = _this$props4.from, to = _this$props4.to, canBegin = _this$props4.canBegin, onAnimationEnd = _this$props4.onAnimationEnd, shouldReAnimate = _this$props4.shouldReAnimate, onAnimationReStart = _this$props4.onAnimationReStart, others = $1d21108f50b7f549$var$_objectWithoutProperties(_this$props4, $1d21108f50b7f549$var$_excluded);
                var count = (0, $8T3gX.Children).count(children);
                // eslint-disable-next-line react/destructuring-assignment
                var stateStyle = this.state.style;
                if (typeof children === 'function') return children(stateStyle);
                if (!isActive || count === 0 || duration <= 0) return children;
                var cloneContainer = function cloneContainer(container) {
                    var _container$props = container.props, _container$props$styl = _container$props.style, style = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className;
                    var res = /*#__PURE__*/ (0, $8T3gX.cloneElement)(container, $1d21108f50b7f549$var$_objectSpread($1d21108f50b7f549$var$_objectSpread({}, others), {}, {
                        style: $1d21108f50b7f549$var$_objectSpread($1d21108f50b7f549$var$_objectSpread({}, style), stateStyle),
                        className: className
                    }));
                    return res;
                };
                if (count === 1) return cloneContainer((0, $8T3gX.Children).only(children));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("div", null, (0, $8T3gX.Children).map(children, function(child) {
                    return cloneContainer(child);
                }));
            }
        }
    ]);
    return Animate;
}((0, $8T3gX.PureComponent));
$1d21108f50b7f549$var$Animate.displayName = 'Animate';
$1d21108f50b7f549$var$Animate.defaultProps = {
    begin: 0,
    duration: 1000,
    from: '',
    to: '',
    attributeName: '',
    easing: 'ease',
    isActive: true,
    canBegin: true,
    steps: [],
    onAnimationEnd: function onAnimationEnd() {},
    onAnimationStart: function onAnimationStart() {}
};
$1d21108f50b7f549$var$Animate.propTypes = {
    from: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    to: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    attributeName: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    // animation duration
    duration: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    begin: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
    easing: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        duration: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number.isRequired,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object.isRequired,
        easing: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
                'ease',
                'ease-in',
                'ease-out',
                'ease-in-out',
                'linear'
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
        ]),
        // transition css properties(dash case), optional
        properties: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf('string'),
        onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    })),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]),
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    canBegin: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    // decide if it should reanimate with initial from style when props change
    shouldReAnimate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    onAnimationStart: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    onAnimationReStart: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
};
var $1d21108f50b7f549$export$2e2bcd8739ae039 = $1d21108f50b7f549$var$Animate;




var $ab29ae7e0941d876$export$2e2bcd8739ae039 = (0, $1d21108f50b7f549$export$2e2bcd8739ae039);


var $c9cb355ea2786d76$exports = {};
var $8ad758ceb849e9eb$exports = {};
var $e4f52da9bede4538$exports = {};
var $861d1b63d8478a81$exports = {};
var $6dd6695614025177$exports = {};
var $b96ab4311dcfa352$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $b96ab4311dcfa352$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$b96ab4311dcfa352$exports = $b96ab4311dcfa352$var$listCacheClear;


var $466bbec72aba2505$exports = {};
var $50cb19614cb34eb7$exports = {};
var $ba1c04d40f072e77$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $ba1c04d40f072e77$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$ba1c04d40f072e77$exports = $ba1c04d40f072e77$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $50cb19614cb34eb7$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($ba1c04d40f072e77$exports(array[length][0], key)) return length;
    }
    return -1;
}
$50cb19614cb34eb7$exports = $50cb19614cb34eb7$var$assocIndexOf;


/** Used for built-in method references. */ var $466bbec72aba2505$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $466bbec72aba2505$var$splice = $466bbec72aba2505$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $466bbec72aba2505$var$listCacheDelete(key) {
    var data = this.__data__, index = $50cb19614cb34eb7$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $466bbec72aba2505$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$466bbec72aba2505$exports = $466bbec72aba2505$var$listCacheDelete;


var $e5d142a7b1ecdf41$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $e5d142a7b1ecdf41$var$listCacheGet(key) {
    var data = this.__data__, index = $50cb19614cb34eb7$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$e5d142a7b1ecdf41$exports = $e5d142a7b1ecdf41$var$listCacheGet;


var $be9285f32253522a$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $be9285f32253522a$var$listCacheHas(key) {
    return $50cb19614cb34eb7$exports(this.__data__, key) > -1;
}
$be9285f32253522a$exports = $be9285f32253522a$var$listCacheHas;


var $981099f55d831c25$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $981099f55d831c25$var$listCacheSet(key, value) {
    var data = this.__data__, index = $50cb19614cb34eb7$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$981099f55d831c25$exports = $981099f55d831c25$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $6dd6695614025177$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$6dd6695614025177$var$ListCache.prototype.clear = $b96ab4311dcfa352$exports;
$6dd6695614025177$var$ListCache.prototype['delete'] = $466bbec72aba2505$exports;
$6dd6695614025177$var$ListCache.prototype.get = $e5d142a7b1ecdf41$exports;
$6dd6695614025177$var$ListCache.prototype.has = $be9285f32253522a$exports;
$6dd6695614025177$var$ListCache.prototype.set = $981099f55d831c25$exports;
$6dd6695614025177$exports = $6dd6695614025177$var$ListCache;


var $251d14789fe83bed$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $251d14789fe83bed$var$stackClear() {
    this.__data__ = new $6dd6695614025177$exports;
    this.size = 0;
}
$251d14789fe83bed$exports = $251d14789fe83bed$var$stackClear;


var $a54eae6a59036bad$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $a54eae6a59036bad$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$a54eae6a59036bad$exports = $a54eae6a59036bad$var$stackDelete;


var $551ce2e9d4884d48$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $551ce2e9d4884d48$var$stackGet(key) {
    return this.__data__.get(key);
}
$551ce2e9d4884d48$exports = $551ce2e9d4884d48$var$stackGet;


var $06ec3213039408a4$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $06ec3213039408a4$var$stackHas(key) {
    return this.__data__.has(key);
}
$06ec3213039408a4$exports = $06ec3213039408a4$var$stackHas;


var $63efddd99fc6b52e$exports = {};

var $17cc21fdf5acfaaf$exports = {};
var $7899283e38926019$exports = {};
var $073976792844c8a5$exports = {};
var $cd41833a2a331f63$exports = {};
var $4003a8f3ae86bec1$exports = {};
var $29a029238437d6de$exports = {};

var $yRFSk = parcelRequire("yRFSk");
/** Built-in value references. */ var $29a029238437d6de$var$Symbol = $yRFSk.Symbol;
$29a029238437d6de$exports = $29a029238437d6de$var$Symbol;


var $00046f8171ed0f0c$exports = {};

/** Used for built-in method references. */ var $00046f8171ed0f0c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $00046f8171ed0f0c$var$hasOwnProperty = $00046f8171ed0f0c$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $00046f8171ed0f0c$var$nativeObjectToString = $00046f8171ed0f0c$var$objectProto.toString;
/** Built-in value references. */ var $00046f8171ed0f0c$var$symToStringTag = $29a029238437d6de$exports ? $29a029238437d6de$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $00046f8171ed0f0c$var$getRawTag(value) {
    var isOwn = $00046f8171ed0f0c$var$hasOwnProperty.call(value, $00046f8171ed0f0c$var$symToStringTag), tag = value[$00046f8171ed0f0c$var$symToStringTag];
    try {
        value[$00046f8171ed0f0c$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $00046f8171ed0f0c$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$00046f8171ed0f0c$var$symToStringTag] = tag;
        else delete value[$00046f8171ed0f0c$var$symToStringTag];
    }
    return result;
}
$00046f8171ed0f0c$exports = $00046f8171ed0f0c$var$getRawTag;


var $0928a1a9fd840c4c$exports = {};
/** Used for built-in method references. */ var $0928a1a9fd840c4c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $0928a1a9fd840c4c$var$nativeObjectToString = $0928a1a9fd840c4c$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $0928a1a9fd840c4c$var$objectToString(value) {
    return $0928a1a9fd840c4c$var$nativeObjectToString.call(value);
}
$0928a1a9fd840c4c$exports = $0928a1a9fd840c4c$var$objectToString;


/** `Object#toString` result references. */ var $4003a8f3ae86bec1$var$nullTag = '[object Null]', $4003a8f3ae86bec1$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $4003a8f3ae86bec1$var$symToStringTag = $29a029238437d6de$exports ? $29a029238437d6de$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $4003a8f3ae86bec1$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $4003a8f3ae86bec1$var$undefinedTag : $4003a8f3ae86bec1$var$nullTag;
    return $4003a8f3ae86bec1$var$symToStringTag && $4003a8f3ae86bec1$var$symToStringTag in Object(value) ? $00046f8171ed0f0c$exports(value) : $0928a1a9fd840c4c$exports(value);
}
$4003a8f3ae86bec1$exports = $4003a8f3ae86bec1$var$baseGetTag;


var $cd2b0b1294af0960$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $cd2b0b1294af0960$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$cd2b0b1294af0960$exports = $cd2b0b1294af0960$var$isObject;


/** `Object#toString` result references. */ var $cd41833a2a331f63$var$asyncTag = '[object AsyncFunction]', $cd41833a2a331f63$var$funcTag = '[object Function]', $cd41833a2a331f63$var$genTag = '[object GeneratorFunction]', $cd41833a2a331f63$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $cd41833a2a331f63$var$isFunction(value) {
    if (!$cd2b0b1294af0960$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $4003a8f3ae86bec1$exports(value);
    return tag == $cd41833a2a331f63$var$funcTag || tag == $cd41833a2a331f63$var$genTag || tag == $cd41833a2a331f63$var$asyncTag || tag == $cd41833a2a331f63$var$proxyTag;
}
$cd41833a2a331f63$exports = $cd41833a2a331f63$var$isFunction;


var $13ca6f8ce4d26492$exports = {};
var $602aa9999b550509$exports = {};

var $yRFSk = parcelRequire("yRFSk");
/** Used to detect overreaching core-js shims. */ var $602aa9999b550509$var$coreJsData = $yRFSk["__core-js_shared__"];
$602aa9999b550509$exports = $602aa9999b550509$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $13ca6f8ce4d26492$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($602aa9999b550509$exports && $602aa9999b550509$exports.keys && $602aa9999b550509$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $13ca6f8ce4d26492$var$isMasked(func) {
    return !!$13ca6f8ce4d26492$var$maskSrcKey && $13ca6f8ce4d26492$var$maskSrcKey in func;
}
$13ca6f8ce4d26492$exports = $13ca6f8ce4d26492$var$isMasked;



var $b15df2ee81e34172$exports = {};
/** Used for built-in method references. */ var $b15df2ee81e34172$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $b15df2ee81e34172$var$funcToString = $b15df2ee81e34172$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $b15df2ee81e34172$var$toSource(func) {
    if (func != null) {
        try {
            return $b15df2ee81e34172$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$b15df2ee81e34172$exports = $b15df2ee81e34172$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $073976792844c8a5$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $073976792844c8a5$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $073976792844c8a5$var$funcProto = Function.prototype, $073976792844c8a5$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $073976792844c8a5$var$funcToString = $073976792844c8a5$var$funcProto.toString;
/** Used to check objects for own properties. */ var $073976792844c8a5$var$hasOwnProperty = $073976792844c8a5$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $073976792844c8a5$var$reIsNative = RegExp('^' + $073976792844c8a5$var$funcToString.call($073976792844c8a5$var$hasOwnProperty).replace($073976792844c8a5$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $073976792844c8a5$var$baseIsNative(value) {
    if (!$cd2b0b1294af0960$exports(value) || $13ca6f8ce4d26492$exports(value)) return false;
    var pattern = $cd41833a2a331f63$exports(value) ? $073976792844c8a5$var$reIsNative : $073976792844c8a5$var$reIsHostCtor;
    return pattern.test($b15df2ee81e34172$exports(value));
}
$073976792844c8a5$exports = $073976792844c8a5$var$baseIsNative;


var $a7e0be82f624d54f$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $a7e0be82f624d54f$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$a7e0be82f624d54f$exports = $a7e0be82f624d54f$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $7899283e38926019$var$getNative(object, key) {
    var value = $a7e0be82f624d54f$exports(object, key);
    return $073976792844c8a5$exports(value) ? value : undefined;
}
$7899283e38926019$exports = $7899283e38926019$var$getNative;



var $yRFSk = parcelRequire("yRFSk");
/* Built-in method references that are verified to be native. */ var $17cc21fdf5acfaaf$var$Map = $7899283e38926019$exports($yRFSk, 'Map');
$17cc21fdf5acfaaf$exports = $17cc21fdf5acfaaf$var$Map;


var $f0e334302b29cec1$exports = {};
var $337091f917dedcda$exports = {};
var $cddfb4317dbcd3e4$exports = {};
var $8b7b2c23cf80529c$exports = {};
var $6003b8e84d843fe2$exports = {};

/* Built-in method references that are verified to be native. */ var $6003b8e84d843fe2$var$nativeCreate = $7899283e38926019$exports(Object, 'create');
$6003b8e84d843fe2$exports = $6003b8e84d843fe2$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $8b7b2c23cf80529c$var$hashClear() {
    this.__data__ = $6003b8e84d843fe2$exports ? $6003b8e84d843fe2$exports(null) : {};
    this.size = 0;
}
$8b7b2c23cf80529c$exports = $8b7b2c23cf80529c$var$hashClear;


var $a4cb96ed0124daef$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $a4cb96ed0124daef$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$a4cb96ed0124daef$exports = $a4cb96ed0124daef$var$hashDelete;


var $72050bf5e34e224c$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $72050bf5e34e224c$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $72050bf5e34e224c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $72050bf5e34e224c$var$hasOwnProperty = $72050bf5e34e224c$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $72050bf5e34e224c$var$hashGet(key) {
    var data = this.__data__;
    if ($6003b8e84d843fe2$exports) {
        var result = data[key];
        return result === $72050bf5e34e224c$var$HASH_UNDEFINED ? undefined : result;
    }
    return $72050bf5e34e224c$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$72050bf5e34e224c$exports = $72050bf5e34e224c$var$hashGet;


var $fa6aed7f39c0961d$exports = {};

/** Used for built-in method references. */ var $fa6aed7f39c0961d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fa6aed7f39c0961d$var$hasOwnProperty = $fa6aed7f39c0961d$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fa6aed7f39c0961d$var$hashHas(key) {
    var data = this.__data__;
    return $6003b8e84d843fe2$exports ? data[key] !== undefined : $fa6aed7f39c0961d$var$hasOwnProperty.call(data, key);
}
$fa6aed7f39c0961d$exports = $fa6aed7f39c0961d$var$hashHas;


var $ef4be21c342ab041$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $ef4be21c342ab041$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $ef4be21c342ab041$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $6003b8e84d843fe2$exports && value === undefined ? $ef4be21c342ab041$var$HASH_UNDEFINED : value;
    return this;
}
$ef4be21c342ab041$exports = $ef4be21c342ab041$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $cddfb4317dbcd3e4$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$cddfb4317dbcd3e4$var$Hash.prototype.clear = $8b7b2c23cf80529c$exports;
$cddfb4317dbcd3e4$var$Hash.prototype['delete'] = $a4cb96ed0124daef$exports;
$cddfb4317dbcd3e4$var$Hash.prototype.get = $72050bf5e34e224c$exports;
$cddfb4317dbcd3e4$var$Hash.prototype.has = $fa6aed7f39c0961d$exports;
$cddfb4317dbcd3e4$var$Hash.prototype.set = $ef4be21c342ab041$exports;
$cddfb4317dbcd3e4$exports = $cddfb4317dbcd3e4$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $337091f917dedcda$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $cddfb4317dbcd3e4$exports,
        'map': new ($17cc21fdf5acfaaf$exports || $6dd6695614025177$exports),
        'string': new $cddfb4317dbcd3e4$exports
    };
}
$337091f917dedcda$exports = $337091f917dedcda$var$mapCacheClear;


var $b849d43a090134cb$exports = {};
var $f97ff534a0efc75f$exports = {};
var $ff1c3374e65a1ef6$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $ff1c3374e65a1ef6$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$ff1c3374e65a1ef6$exports = $ff1c3374e65a1ef6$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $f97ff534a0efc75f$var$getMapData(map, key) {
    var data = map.__data__;
    return $ff1c3374e65a1ef6$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$f97ff534a0efc75f$exports = $f97ff534a0efc75f$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b849d43a090134cb$var$mapCacheDelete(key) {
    var result = $f97ff534a0efc75f$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$b849d43a090134cb$exports = $b849d43a090134cb$var$mapCacheDelete;


var $818885dbfe5034e3$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $818885dbfe5034e3$var$mapCacheGet(key) {
    return $f97ff534a0efc75f$exports(this, key).get(key);
}
$818885dbfe5034e3$exports = $818885dbfe5034e3$var$mapCacheGet;


var $27bc6c99d62317f3$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $27bc6c99d62317f3$var$mapCacheHas(key) {
    return $f97ff534a0efc75f$exports(this, key).has(key);
}
$27bc6c99d62317f3$exports = $27bc6c99d62317f3$var$mapCacheHas;


var $a9ae7446e772b13e$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $a9ae7446e772b13e$var$mapCacheSet(key, value) {
    var data = $f97ff534a0efc75f$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$a9ae7446e772b13e$exports = $a9ae7446e772b13e$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f0e334302b29cec1$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$f0e334302b29cec1$var$MapCache.prototype.clear = $337091f917dedcda$exports;
$f0e334302b29cec1$var$MapCache.prototype['delete'] = $b849d43a090134cb$exports;
$f0e334302b29cec1$var$MapCache.prototype.get = $818885dbfe5034e3$exports;
$f0e334302b29cec1$var$MapCache.prototype.has = $27bc6c99d62317f3$exports;
$f0e334302b29cec1$var$MapCache.prototype.set = $a9ae7446e772b13e$exports;
$f0e334302b29cec1$exports = $f0e334302b29cec1$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $63efddd99fc6b52e$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $63efddd99fc6b52e$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $6dd6695614025177$exports) {
        var pairs = data.__data__;
        if (!$17cc21fdf5acfaaf$exports || pairs.length < $63efddd99fc6b52e$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $f0e334302b29cec1$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$63efddd99fc6b52e$exports = $63efddd99fc6b52e$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $861d1b63d8478a81$var$Stack(entries) {
    var data = this.__data__ = new $6dd6695614025177$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$861d1b63d8478a81$var$Stack.prototype.clear = $251d14789fe83bed$exports;
$861d1b63d8478a81$var$Stack.prototype['delete'] = $a54eae6a59036bad$exports;
$861d1b63d8478a81$var$Stack.prototype.get = $551ce2e9d4884d48$exports;
$861d1b63d8478a81$var$Stack.prototype.has = $06ec3213039408a4$exports;
$861d1b63d8478a81$var$Stack.prototype.set = $63efddd99fc6b52e$exports;
$861d1b63d8478a81$exports = $861d1b63d8478a81$var$Stack;


var $e746817bf72f1621$exports = {};
var $0caf93a6e311dd5e$exports = {};

var $f17e25f845dd7c71$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $f17e25f845dd7c71$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $f17e25f845dd7c71$var$setCacheAdd(value) {
    this.__data__.set(value, $f17e25f845dd7c71$var$HASH_UNDEFINED);
    return this;
}
$f17e25f845dd7c71$exports = $f17e25f845dd7c71$var$setCacheAdd;


var $fc28c343c6be2769$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $fc28c343c6be2769$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$fc28c343c6be2769$exports = $fc28c343c6be2769$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $0caf93a6e311dd5e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $f0e334302b29cec1$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$0caf93a6e311dd5e$var$SetCache.prototype.add = $0caf93a6e311dd5e$var$SetCache.prototype.push = $f17e25f845dd7c71$exports;
$0caf93a6e311dd5e$var$SetCache.prototype.has = $fc28c343c6be2769$exports;
$0caf93a6e311dd5e$exports = $0caf93a6e311dd5e$var$SetCache;


var $a56761d28df36f98$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $a56761d28df36f98$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$a56761d28df36f98$exports = $a56761d28df36f98$var$arraySome;


var $fcea3308b25e2289$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fcea3308b25e2289$var$cacheHas(cache, key) {
    return cache.has(key);
}
$fcea3308b25e2289$exports = $fcea3308b25e2289$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $e746817bf72f1621$var$COMPARE_PARTIAL_FLAG = 1, $e746817bf72f1621$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $e746817bf72f1621$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $e746817bf72f1621$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $e746817bf72f1621$var$COMPARE_UNORDERED_FLAG ? new $0caf93a6e311dd5e$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$a56761d28df36f98$exports(other, function(othValue, othIndex) {
                if (!$fcea3308b25e2289$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$e746817bf72f1621$exports = $e746817bf72f1621$var$equalArrays;


var $e058699895282cc5$exports = {};

var $894004397dec7019$exports = {};

var $yRFSk = parcelRequire("yRFSk");
/** Built-in value references. */ var $894004397dec7019$var$Uint8Array = $yRFSk.Uint8Array;
$894004397dec7019$exports = $894004397dec7019$var$Uint8Array;




var $443284b5df2a6873$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $443284b5df2a6873$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$443284b5df2a6873$exports = $443284b5df2a6873$var$mapToArray;


var $2923149d82fb4e32$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $2923149d82fb4e32$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$2923149d82fb4e32$exports = $2923149d82fb4e32$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $e058699895282cc5$var$COMPARE_PARTIAL_FLAG = 1, $e058699895282cc5$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $e058699895282cc5$var$boolTag = '[object Boolean]', $e058699895282cc5$var$dateTag = '[object Date]', $e058699895282cc5$var$errorTag = '[object Error]', $e058699895282cc5$var$mapTag = '[object Map]', $e058699895282cc5$var$numberTag = '[object Number]', $e058699895282cc5$var$regexpTag = '[object RegExp]', $e058699895282cc5$var$setTag = '[object Set]', $e058699895282cc5$var$stringTag = '[object String]', $e058699895282cc5$var$symbolTag = '[object Symbol]';
var $e058699895282cc5$var$arrayBufferTag = '[object ArrayBuffer]', $e058699895282cc5$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $e058699895282cc5$var$symbolProto = $29a029238437d6de$exports ? $29a029238437d6de$exports.prototype : undefined, $e058699895282cc5$var$symbolValueOf = $e058699895282cc5$var$symbolProto ? $e058699895282cc5$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $e058699895282cc5$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $e058699895282cc5$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $e058699895282cc5$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $894004397dec7019$exports(object), new $894004397dec7019$exports(other))) return false;
            return true;
        case $e058699895282cc5$var$boolTag:
        case $e058699895282cc5$var$dateTag:
        case $e058699895282cc5$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $ba1c04d40f072e77$exports(+object, +other);
        case $e058699895282cc5$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $e058699895282cc5$var$regexpTag:
        case $e058699895282cc5$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $e058699895282cc5$var$mapTag:
            var convert = $443284b5df2a6873$exports;
        case $e058699895282cc5$var$setTag:
            var isPartial = bitmask & $e058699895282cc5$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $2923149d82fb4e32$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $e058699895282cc5$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $e746817bf72f1621$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $e058699895282cc5$var$symbolTag:
            if ($e058699895282cc5$var$symbolValueOf) return $e058699895282cc5$var$symbolValueOf.call(object) == $e058699895282cc5$var$symbolValueOf.call(other);
    }
    return false;
}
$e058699895282cc5$exports = $e058699895282cc5$var$equalByTag;


var $f135f267fd805d15$exports = {};
var $6a2e5419fb614e31$exports = {};
var $c29475283cf67e7d$exports = {};
var $3bf95b782724c68c$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $3bf95b782724c68c$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$3bf95b782724c68c$exports = $3bf95b782724c68c$var$arrayPush;


var $b47d971f66a6f054$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $b47d971f66a6f054$var$isArray = Array.isArray;
$b47d971f66a6f054$exports = $b47d971f66a6f054$var$isArray;


/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $c29475283cf67e7d$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $b47d971f66a6f054$exports(object) ? result : $3bf95b782724c68c$exports(result, symbolsFunc(object));
}
$c29475283cf67e7d$exports = $c29475283cf67e7d$var$baseGetAllKeys;


var $75381d22f22a25de$exports = {};
var $35a63e38c03b8c57$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $35a63e38c03b8c57$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$35a63e38c03b8c57$exports = $35a63e38c03b8c57$var$arrayFilter;


var $f109fd11e633354b$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $f109fd11e633354b$var$stubArray() {
    return [];
}
$f109fd11e633354b$exports = $f109fd11e633354b$var$stubArray;


/** Used for built-in method references. */ var $75381d22f22a25de$var$objectProto = Object.prototype;
/** Built-in value references. */ var $75381d22f22a25de$var$propertyIsEnumerable = $75381d22f22a25de$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $75381d22f22a25de$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $75381d22f22a25de$var$getSymbols = !$75381d22f22a25de$var$nativeGetSymbols ? $f109fd11e633354b$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $35a63e38c03b8c57$exports($75381d22f22a25de$var$nativeGetSymbols(object), function(symbol) {
        return $75381d22f22a25de$var$propertyIsEnumerable.call(object, symbol);
    });
};
$75381d22f22a25de$exports = $75381d22f22a25de$var$getSymbols;


var $9c7d1fa85e24a67e$exports = {};
var $c8166565a24fe234$exports = {};
var $e2c9b661c7956192$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $e2c9b661c7956192$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$e2c9b661c7956192$exports = $e2c9b661c7956192$var$baseTimes;


var $343d561a7d6a3b42$exports = {};
var $3b156beb9c94911a$exports = {};

var $65ef2014975340ff$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $65ef2014975340ff$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$65ef2014975340ff$exports = $65ef2014975340ff$var$isObjectLike;


/** `Object#toString` result references. */ var $3b156beb9c94911a$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $3b156beb9c94911a$var$baseIsArguments(value) {
    return $65ef2014975340ff$exports(value) && $4003a8f3ae86bec1$exports(value) == $3b156beb9c94911a$var$argsTag;
}
$3b156beb9c94911a$exports = $3b156beb9c94911a$var$baseIsArguments;



/** Used for built-in method references. */ var $343d561a7d6a3b42$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $343d561a7d6a3b42$var$hasOwnProperty = $343d561a7d6a3b42$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $343d561a7d6a3b42$var$propertyIsEnumerable = $343d561a7d6a3b42$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $343d561a7d6a3b42$var$isArguments = $3b156beb9c94911a$exports(function() {
    return arguments;
}()) ? $3b156beb9c94911a$exports : function(value) {
    return $65ef2014975340ff$exports(value) && $343d561a7d6a3b42$var$hasOwnProperty.call(value, 'callee') && !$343d561a7d6a3b42$var$propertyIsEnumerable.call(value, 'callee');
};
$343d561a7d6a3b42$exports = $343d561a7d6a3b42$var$isArguments;




var $hAe8M = parcelRequire("hAe8M");
var $c60ce55ccfd38e2a$exports = {};
/** Used as references for various `Number` constants. */ var $c60ce55ccfd38e2a$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $c60ce55ccfd38e2a$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $c60ce55ccfd38e2a$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $c60ce55ccfd38e2a$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $c60ce55ccfd38e2a$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$c60ce55ccfd38e2a$exports = $c60ce55ccfd38e2a$var$isIndex;


var $f88c9406e419272a$exports = {};
var $3d06ad770a2684eb$exports = {};

var $27f0a97b97c49daa$exports = {};
/** Used as references for various `Number` constants. */ var $27f0a97b97c49daa$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $27f0a97b97c49daa$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $27f0a97b97c49daa$var$MAX_SAFE_INTEGER;
}
$27f0a97b97c49daa$exports = $27f0a97b97c49daa$var$isLength;



/** `Object#toString` result references. */ var $3d06ad770a2684eb$var$argsTag = '[object Arguments]', $3d06ad770a2684eb$var$arrayTag = '[object Array]', $3d06ad770a2684eb$var$boolTag = '[object Boolean]', $3d06ad770a2684eb$var$dateTag = '[object Date]', $3d06ad770a2684eb$var$errorTag = '[object Error]', $3d06ad770a2684eb$var$funcTag = '[object Function]', $3d06ad770a2684eb$var$mapTag = '[object Map]', $3d06ad770a2684eb$var$numberTag = '[object Number]', $3d06ad770a2684eb$var$objectTag = '[object Object]', $3d06ad770a2684eb$var$regexpTag = '[object RegExp]', $3d06ad770a2684eb$var$setTag = '[object Set]', $3d06ad770a2684eb$var$stringTag = '[object String]', $3d06ad770a2684eb$var$weakMapTag = '[object WeakMap]';
var $3d06ad770a2684eb$var$arrayBufferTag = '[object ArrayBuffer]', $3d06ad770a2684eb$var$dataViewTag = '[object DataView]', $3d06ad770a2684eb$var$float32Tag = '[object Float32Array]', $3d06ad770a2684eb$var$float64Tag = '[object Float64Array]', $3d06ad770a2684eb$var$int8Tag = '[object Int8Array]', $3d06ad770a2684eb$var$int16Tag = '[object Int16Array]', $3d06ad770a2684eb$var$int32Tag = '[object Int32Array]', $3d06ad770a2684eb$var$uint8Tag = '[object Uint8Array]', $3d06ad770a2684eb$var$uint8ClampedTag = '[object Uint8ClampedArray]', $3d06ad770a2684eb$var$uint16Tag = '[object Uint16Array]', $3d06ad770a2684eb$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $3d06ad770a2684eb$var$typedArrayTags = {};
$3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$float32Tag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$float64Tag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$int8Tag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$int16Tag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$int32Tag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$uint8Tag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$uint8ClampedTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$uint16Tag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$uint32Tag] = true;
$3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$argsTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$arrayTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$arrayBufferTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$boolTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$dataViewTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$dateTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$errorTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$funcTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$mapTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$numberTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$objectTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$regexpTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$setTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$stringTag] = $3d06ad770a2684eb$var$typedArrayTags[$3d06ad770a2684eb$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $3d06ad770a2684eb$var$baseIsTypedArray(value) {
    return $65ef2014975340ff$exports(value) && $27f0a97b97c49daa$exports(value.length) && !!$3d06ad770a2684eb$var$typedArrayTags[$4003a8f3ae86bec1$exports(value)];
}
$3d06ad770a2684eb$exports = $3d06ad770a2684eb$var$baseIsTypedArray;


var $259a13e6311f4b7a$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $259a13e6311f4b7a$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$259a13e6311f4b7a$exports = $259a13e6311f4b7a$var$baseUnary;



var $3TIQ3 = parcelRequire("3TIQ3");
/* Node.js helper references. */ var $f88c9406e419272a$var$nodeIsTypedArray = $3TIQ3 && $3TIQ3.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $f88c9406e419272a$var$isTypedArray = $f88c9406e419272a$var$nodeIsTypedArray ? $259a13e6311f4b7a$exports($f88c9406e419272a$var$nodeIsTypedArray) : $3d06ad770a2684eb$exports;
$f88c9406e419272a$exports = $f88c9406e419272a$var$isTypedArray;


/** Used for built-in method references. */ var $c8166565a24fe234$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c8166565a24fe234$var$hasOwnProperty = $c8166565a24fe234$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $c8166565a24fe234$var$arrayLikeKeys(value, inherited) {
    var isArr = $b47d971f66a6f054$exports(value), isArg = !isArr && $343d561a7d6a3b42$exports(value), isBuff = !isArr && !isArg && $hAe8M(value), isType = !isArr && !isArg && !isBuff && $f88c9406e419272a$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $e2c9b661c7956192$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $c8166565a24fe234$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $c60ce55ccfd38e2a$exports(key, length)))) result.push(key);
    return result;
}
$c8166565a24fe234$exports = $c8166565a24fe234$var$arrayLikeKeys;


var $32f67937b014759c$exports = {};
var $0d327a1cf9457c9f$exports = {};
/** Used for built-in method references. */ var $0d327a1cf9457c9f$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $0d327a1cf9457c9f$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $0d327a1cf9457c9f$var$objectProto;
    return value === proto;
}
$0d327a1cf9457c9f$exports = $0d327a1cf9457c9f$var$isPrototype;


var $8c0152eef7f984bf$exports = {};
var $ea458d5b09fec244$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ea458d5b09fec244$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$ea458d5b09fec244$exports = $ea458d5b09fec244$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $8c0152eef7f984bf$var$nativeKeys = $ea458d5b09fec244$exports(Object.keys, Object);
$8c0152eef7f984bf$exports = $8c0152eef7f984bf$var$nativeKeys;


/** Used for built-in method references. */ var $32f67937b014759c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $32f67937b014759c$var$hasOwnProperty = $32f67937b014759c$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $32f67937b014759c$var$baseKeys(object) {
    if (!$0d327a1cf9457c9f$exports(object)) return $8c0152eef7f984bf$exports(object);
    var result = [];
    for(var key in Object(object))if ($32f67937b014759c$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$32f67937b014759c$exports = $32f67937b014759c$var$baseKeys;


var $edace719698f1e70$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $edace719698f1e70$var$isArrayLike(value) {
    return value != null && $27f0a97b97c49daa$exports(value.length) && !$cd41833a2a331f63$exports(value);
}
$edace719698f1e70$exports = $edace719698f1e70$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $9c7d1fa85e24a67e$var$keys(object) {
    return $edace719698f1e70$exports(object) ? $c8166565a24fe234$exports(object) : $32f67937b014759c$exports(object);
}
$9c7d1fa85e24a67e$exports = $9c7d1fa85e24a67e$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $6a2e5419fb614e31$var$getAllKeys(object) {
    return $c29475283cf67e7d$exports(object, $9c7d1fa85e24a67e$exports, $75381d22f22a25de$exports);
}
$6a2e5419fb614e31$exports = $6a2e5419fb614e31$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $f135f267fd805d15$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $f135f267fd805d15$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f135f267fd805d15$var$hasOwnProperty = $f135f267fd805d15$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $f135f267fd805d15$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $f135f267fd805d15$var$COMPARE_PARTIAL_FLAG, objProps = $6a2e5419fb614e31$exports(object), objLength = objProps.length, othProps = $6a2e5419fb614e31$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $f135f267fd805d15$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$f135f267fd805d15$exports = $f135f267fd805d15$var$equalObjects;


var $8d5c6ea4cc5d862e$exports = {};
var $8191d20b90474416$exports = {};


var $yRFSk = parcelRequire("yRFSk");
/* Built-in method references that are verified to be native. */ var $8191d20b90474416$var$DataView = $7899283e38926019$exports($yRFSk, 'DataView');
$8191d20b90474416$exports = $8191d20b90474416$var$DataView;



var $fdb3487977023d82$exports = {};


var $yRFSk = parcelRequire("yRFSk");
/* Built-in method references that are verified to be native. */ var $fdb3487977023d82$var$Promise = $7899283e38926019$exports($yRFSk, 'Promise');
$fdb3487977023d82$exports = $fdb3487977023d82$var$Promise;


var $f7e45b5ac0aba58a$exports = {};


var $yRFSk = parcelRequire("yRFSk");
/* Built-in method references that are verified to be native. */ var $f7e45b5ac0aba58a$var$Set = $7899283e38926019$exports($yRFSk, 'Set');
$f7e45b5ac0aba58a$exports = $f7e45b5ac0aba58a$var$Set;


var $ae0df087007bfc5b$exports = {};


var $yRFSk = parcelRequire("yRFSk");
/* Built-in method references that are verified to be native. */ var $ae0df087007bfc5b$var$WeakMap = $7899283e38926019$exports($yRFSk, 'WeakMap');
$ae0df087007bfc5b$exports = $ae0df087007bfc5b$var$WeakMap;




/** `Object#toString` result references. */ var $8d5c6ea4cc5d862e$var$mapTag = '[object Map]', $8d5c6ea4cc5d862e$var$objectTag = '[object Object]', $8d5c6ea4cc5d862e$var$promiseTag = '[object Promise]', $8d5c6ea4cc5d862e$var$setTag = '[object Set]', $8d5c6ea4cc5d862e$var$weakMapTag = '[object WeakMap]';
var $8d5c6ea4cc5d862e$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $8d5c6ea4cc5d862e$var$dataViewCtorString = $b15df2ee81e34172$exports($8191d20b90474416$exports), $8d5c6ea4cc5d862e$var$mapCtorString = $b15df2ee81e34172$exports($17cc21fdf5acfaaf$exports), $8d5c6ea4cc5d862e$var$promiseCtorString = $b15df2ee81e34172$exports($fdb3487977023d82$exports), $8d5c6ea4cc5d862e$var$setCtorString = $b15df2ee81e34172$exports($f7e45b5ac0aba58a$exports), $8d5c6ea4cc5d862e$var$weakMapCtorString = $b15df2ee81e34172$exports($ae0df087007bfc5b$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $8d5c6ea4cc5d862e$var$getTag = $4003a8f3ae86bec1$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($8191d20b90474416$exports && $8d5c6ea4cc5d862e$var$getTag(new $8191d20b90474416$exports(new ArrayBuffer(1))) != $8d5c6ea4cc5d862e$var$dataViewTag || $17cc21fdf5acfaaf$exports && $8d5c6ea4cc5d862e$var$getTag(new $17cc21fdf5acfaaf$exports) != $8d5c6ea4cc5d862e$var$mapTag || $fdb3487977023d82$exports && $8d5c6ea4cc5d862e$var$getTag($fdb3487977023d82$exports.resolve()) != $8d5c6ea4cc5d862e$var$promiseTag || $f7e45b5ac0aba58a$exports && $8d5c6ea4cc5d862e$var$getTag(new $f7e45b5ac0aba58a$exports) != $8d5c6ea4cc5d862e$var$setTag || $ae0df087007bfc5b$exports && $8d5c6ea4cc5d862e$var$getTag(new $ae0df087007bfc5b$exports) != $8d5c6ea4cc5d862e$var$weakMapTag) $8d5c6ea4cc5d862e$var$getTag = function(value) {
    var result = $4003a8f3ae86bec1$exports(value), Ctor = result == $8d5c6ea4cc5d862e$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $b15df2ee81e34172$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $8d5c6ea4cc5d862e$var$dataViewCtorString:
            return $8d5c6ea4cc5d862e$var$dataViewTag;
        case $8d5c6ea4cc5d862e$var$mapCtorString:
            return $8d5c6ea4cc5d862e$var$mapTag;
        case $8d5c6ea4cc5d862e$var$promiseCtorString:
            return $8d5c6ea4cc5d862e$var$promiseTag;
        case $8d5c6ea4cc5d862e$var$setCtorString:
            return $8d5c6ea4cc5d862e$var$setTag;
        case $8d5c6ea4cc5d862e$var$weakMapCtorString:
            return $8d5c6ea4cc5d862e$var$weakMapTag;
    }
    return result;
};
$8d5c6ea4cc5d862e$exports = $8d5c6ea4cc5d862e$var$getTag;




var $hAe8M = parcelRequire("hAe8M");

/** Used to compose bitmasks for value comparisons. */ var $e4f52da9bede4538$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $e4f52da9bede4538$var$argsTag = '[object Arguments]', $e4f52da9bede4538$var$arrayTag = '[object Array]', $e4f52da9bede4538$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $e4f52da9bede4538$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e4f52da9bede4538$var$hasOwnProperty = $e4f52da9bede4538$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $e4f52da9bede4538$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $b47d971f66a6f054$exports(object), othIsArr = $b47d971f66a6f054$exports(other), objTag = objIsArr ? $e4f52da9bede4538$var$arrayTag : $8d5c6ea4cc5d862e$exports(object), othTag = othIsArr ? $e4f52da9bede4538$var$arrayTag : $8d5c6ea4cc5d862e$exports(other);
    objTag = objTag == $e4f52da9bede4538$var$argsTag ? $e4f52da9bede4538$var$objectTag : objTag;
    othTag = othTag == $e4f52da9bede4538$var$argsTag ? $e4f52da9bede4538$var$objectTag : othTag;
    var objIsObj = objTag == $e4f52da9bede4538$var$objectTag, othIsObj = othTag == $e4f52da9bede4538$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $hAe8M(object)) {
        if (!$hAe8M(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $861d1b63d8478a81$exports);
        return objIsArr || $f88c9406e419272a$exports(object) ? $e746817bf72f1621$exports(object, other, bitmask, customizer, equalFunc, stack) : $e058699895282cc5$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $e4f52da9bede4538$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $e4f52da9bede4538$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $e4f52da9bede4538$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $861d1b63d8478a81$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $861d1b63d8478a81$exports);
    return $f135f267fd805d15$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$e4f52da9bede4538$exports = $e4f52da9bede4538$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $8ad758ceb849e9eb$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$65ef2014975340ff$exports(value) && !$65ef2014975340ff$exports(other)) return value !== value && other !== other;
    return $e4f52da9bede4538$exports(value, other, bitmask, customizer, $8ad758ceb849e9eb$var$baseIsEqual, stack);
}
$8ad758ceb849e9eb$exports = $8ad758ceb849e9eb$var$baseIsEqual;


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $c9cb355ea2786d76$var$isEqual(value, other) {
    return $8ad758ceb849e9eb$exports(value, other);
}
$c9cb355ea2786d76$exports = $c9cb355ea2786d76$var$isEqual;


var $39cd5f6f9b941b5d$exports = {};
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $39cd5f6f9b941b5d$var$isNil(value) {
    return value == null;
}
$39cd5f6f9b941b5d$exports = $39cd5f6f9b941b5d$var$isNil;



var $8T3gX = parcelRequire("8T3gX");

var $iVyaN = parcelRequire("iVyaN");
var $eb02300d30d6bdcb$exports = {};
var $7bff94b74b05cdba$exports = {};
var $5f248967e32df0c1$exports = {};

var $32fa1f4d8228ffde$exports = {};

var $193702f8737ef12b$exports = {};


/** `Object#toString` result references. */ var $193702f8737ef12b$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $193702f8737ef12b$var$isSymbol(value) {
    return typeof value == 'symbol' || $65ef2014975340ff$exports(value) && $4003a8f3ae86bec1$exports(value) == $193702f8737ef12b$var$symbolTag;
}
$193702f8737ef12b$exports = $193702f8737ef12b$var$isSymbol;


/** Used to match property names within property paths. */ var $32fa1f4d8228ffde$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $32fa1f4d8228ffde$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $32fa1f4d8228ffde$var$isKey(value, object) {
    if ($b47d971f66a6f054$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $193702f8737ef12b$exports(value)) return true;
    return $32fa1f4d8228ffde$var$reIsPlainProp.test(value) || !$32fa1f4d8228ffde$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$32fa1f4d8228ffde$exports = $32fa1f4d8228ffde$var$isKey;


var $b3bb2312c416cd11$exports = {};
var $b16a399366d4e11c$exports = {};
var $5659748bd598a7eb$exports = {};

/** Error message constants. */ var $5659748bd598a7eb$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $5659748bd598a7eb$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($5659748bd598a7eb$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($5659748bd598a7eb$var$memoize.Cache || $f0e334302b29cec1$exports);
    return memoized;
}
// Expose `MapCache`.
$5659748bd598a7eb$var$memoize.Cache = $f0e334302b29cec1$exports;
$5659748bd598a7eb$exports = $5659748bd598a7eb$var$memoize;


/** Used as the maximum memoize cache size. */ var $b16a399366d4e11c$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $b16a399366d4e11c$var$memoizeCapped(func) {
    var result = $5659748bd598a7eb$exports(func, function(key) {
        if (cache.size === $b16a399366d4e11c$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$b16a399366d4e11c$exports = $b16a399366d4e11c$var$memoizeCapped;


/** Used to match property names within property paths. */ var $b3bb2312c416cd11$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $b3bb2312c416cd11$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $b3bb2312c416cd11$var$stringToPath = $b16a399366d4e11c$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($b3bb2312c416cd11$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($b3bb2312c416cd11$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$b3bb2312c416cd11$exports = $b3bb2312c416cd11$var$stringToPath;


var $4360b921cc50ac20$exports = {};
var $94e29f736f5ee1b8$exports = {};

var $95a41775a4f282b8$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $95a41775a4f282b8$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$95a41775a4f282b8$exports = $95a41775a4f282b8$var$arrayMap;




/** Used as references for various `Number` constants. */ var $94e29f736f5ee1b8$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $94e29f736f5ee1b8$var$symbolProto = $29a029238437d6de$exports ? $29a029238437d6de$exports.prototype : undefined, $94e29f736f5ee1b8$var$symbolToString = $94e29f736f5ee1b8$var$symbolProto ? $94e29f736f5ee1b8$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $94e29f736f5ee1b8$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($b47d971f66a6f054$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $95a41775a4f282b8$exports(value, $94e29f736f5ee1b8$var$baseToString) + '';
    if ($193702f8737ef12b$exports(value)) return $94e29f736f5ee1b8$var$symbolToString ? $94e29f736f5ee1b8$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$94e29f736f5ee1b8$var$INFINITY ? '-0' : result;
}
$94e29f736f5ee1b8$exports = $94e29f736f5ee1b8$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $4360b921cc50ac20$var$toString(value) {
    return value == null ? '' : $94e29f736f5ee1b8$exports(value);
}
$4360b921cc50ac20$exports = $4360b921cc50ac20$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $5f248967e32df0c1$var$castPath(value, object) {
    if ($b47d971f66a6f054$exports(value)) return value;
    return $32fa1f4d8228ffde$exports(value, object) ? [
        value
    ] : $b3bb2312c416cd11$exports($4360b921cc50ac20$exports(value));
}
$5f248967e32df0c1$exports = $5f248967e32df0c1$var$castPath;


var $4bf6972158fbafc8$exports = {};

/** Used as references for various `Number` constants. */ var $4bf6972158fbafc8$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $4bf6972158fbafc8$var$toKey(value) {
    if (typeof value == 'string' || $193702f8737ef12b$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$4bf6972158fbafc8$var$INFINITY ? '-0' : result;
}
$4bf6972158fbafc8$exports = $4bf6972158fbafc8$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $7bff94b74b05cdba$var$baseGet(object, path) {
    path = $5f248967e32df0c1$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$4bf6972158fbafc8$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$7bff94b74b05cdba$exports = $7bff94b74b05cdba$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $eb02300d30d6bdcb$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $7bff94b74b05cdba$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$eb02300d30d6bdcb$exports = $eb02300d30d6bdcb$var$get;



var $b674a8a9f1dd7eca$exports = {};



/** `Object#toString` result references. */ var $b674a8a9f1dd7eca$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $b674a8a9f1dd7eca$var$isString(value) {
    return typeof value == 'string' || !$b47d971f66a6f054$exports(value) && $65ef2014975340ff$exports(value) && $4003a8f3ae86bec1$exports(value) == $b674a8a9f1dd7eca$var$stringTag;
}
$b674a8a9f1dd7eca$exports = $b674a8a9f1dd7eca$var$isString;





var $8T3gX = parcelRequire("8T3gX");
var $6446984f457e89e7$exports = {};
'use strict';

$6446984f457e89e7$exports = (parcelRequire("1gEEb"));



var $8f10a67e567007ae$exports = {};
var $4e2d235b822f6ccb$exports = {};


/** `Object#toString` result references. */ var $4e2d235b822f6ccb$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $4e2d235b822f6ccb$var$isNumber(value) {
    return typeof value == 'number' || $65ef2014975340ff$exports(value) && $4003a8f3ae86bec1$exports(value) == $4e2d235b822f6ccb$var$numberTag;
}
$4e2d235b822f6ccb$exports = $4e2d235b822f6ccb$var$isNumber;


/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function $8f10a67e567007ae$var$isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return $4e2d235b822f6ccb$exports(value) && value != +value;
}
$8f10a67e567007ae$exports = $8f10a67e567007ae$var$isNaN;





var $ec351366ffe25ce6$export$9d334328eb75e624 = function mathSign(value) {
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var $ec351366ffe25ce6$export$e50269385c77c348 = function isPercent(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b674a8a9f1dd7eca$exports)))(value) && value.indexOf('%') === value.length - 1;
};
var $ec351366ffe25ce6$export$7e4aa119212bc614 = function isNumber(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4e2d235b822f6ccb$exports)))(value) && !(0, (/*@__PURE__*/$parcel$interopDefault($8f10a67e567007ae$exports)))(value);
};
var $ec351366ffe25ce6$export$b931b78cbb3caf86 = function isNullish(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(value);
};
var $ec351366ffe25ce6$export$402a499e1ea44294 = function isNumOrStr(value) {
    return $ec351366ffe25ce6$export$7e4aa119212bc614(value) || (0, (/*@__PURE__*/$parcel$interopDefault($b674a8a9f1dd7eca$exports)))(value);
};
var $ec351366ffe25ce6$var$idCounter = 0;
var $ec351366ffe25ce6$export$8b15d37bc3f197d4 = function uniqueId(prefix) {
    var id = ++$ec351366ffe25ce6$var$idCounter;
    return "".concat(prefix || '').concat(id);
};
var $ec351366ffe25ce6$export$476354dbf49bdff6 = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$ec351366ffe25ce6$export$7e4aa119212bc614(percent) && !(0, (/*@__PURE__*/$parcel$interopDefault($b674a8a9f1dd7eca$exports)))(percent)) return defaultValue;
    var value;
    if ($ec351366ffe25ce6$export$e50269385c77c348(percent)) {
        var index = percent.indexOf('%');
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8f10a67e567007ae$exports)))(value)) value = defaultValue;
    if (validate && value > totalValue) value = totalValue;
    return value;
};
var $ec351366ffe25ce6$export$b88993f0aa0bf776 = function getAnyElementOfObject(obj) {
    if (!obj) return null;
    var keys = Object.keys(obj);
    if (keys && keys.length) return obj[keys[0]];
    return null;
};
var $ec351366ffe25ce6$export$732baf6a98f122 = function hasDuplicate(ary) {
    if (!Array.isArray(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[ary[i]]) cache[ary[i]] = true;
        else return true;
    }
    return false;
};
var $ec351366ffe25ce6$export$d871d53bd7eeb390 = function interpolateNumber(numberA, numberB) {
    if ($ec351366ffe25ce6$export$7e4aa119212bc614(numberA) && $ec351366ffe25ce6$export$7e4aa119212bc614(numberB)) return function(t) {
        return numberA + t * (numberB - numberA);
    };
    return function() {
        return numberB;
    };
};
function $ec351366ffe25ce6$export$66950d3869f5cc67(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return null;
    return ary.find(function(entry) {
        return entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : (0, (/*@__PURE__*/$parcel$interopDefault($eb02300d30d6bdcb$exports)))(entry, specifiedKey)) === specifiedValue;
    });
}
var $ec351366ffe25ce6$export$484982720961754e = function getLinearRegression(data) {
    if (!data || !data.length) return null;
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        xcurrent = data[i].cx || 0;
        ycurrent = data[i].cy || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};
var $ec351366ffe25ce6$export$6ab1df3197f7c641 = function compareValues(a, b) {
    if ($ec351366ffe25ce6$export$7e4aa119212bc614(a) && $ec351366ffe25ce6$export$7e4aa119212bc614(b)) return a - b;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($b674a8a9f1dd7eca$exports)))(a) && (0, (/*@__PURE__*/$parcel$interopDefault($b674a8a9f1dd7eca$exports)))(b)) return a.localeCompare(b);
    if (a instanceof Date && b instanceof Date) return a.getTime() - b.getTime();
    return String(a).localeCompare(String(b));
};


function $902ad73c142587a6$export$d36bdfa510afb180(a, b) {
    /* eslint-disable no-restricted-syntax */ for(var key in a){
        if (({}).hasOwnProperty.call(a, key) && (!({}).hasOwnProperty.call(b, key) || a[key] !== b[key])) return false;
    }
    for(var _key in b){
        if (({}).hasOwnProperty.call(b, _key) && !({}).hasOwnProperty.call(a, _key)) return false;
    }
    return true;
}



var $8T3gX = parcelRequire("8T3gX");

function $a19170a4abc07995$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a19170a4abc07995$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a19170a4abc07995$var$_typeof(o);
}
/**
 * Determines how values are stacked:
 *
 * - `none` is the default, it adds values on top of each other. No smarts. Negative values will overlap.
 * - `expand` make it so that the values always add up to 1 - so the chart will look like a rectangle.
 * - `wiggle` and `silhouette` tries to keep the chart centered.
 * - `sign` stacks positive values above zero and negative values below zero. Similar to `none` but handles negatives.
 * - `positive` ignores all negative values, and then behaves like \`none\`.
 *
 * Also see https://d3js.org/d3-shape/stack#stack-offsets
 * (note that the `diverging` offset in d3 is named `sign` in recharts)
 */ //
// Event Handler Types -- Copied from @types/react/index.d.ts and adapted for Props.
//
var $a19170a4abc07995$var$SVGContainerPropKeys = [
    'viewBox',
    'children'
];
var $a19170a4abc07995$export$190f430946f96110 = [
    'aria-activedescendant',
    'aria-atomic',
    'aria-autocomplete',
    'aria-busy',
    'aria-checked',
    'aria-colcount',
    'aria-colindex',
    'aria-colspan',
    'aria-controls',
    'aria-current',
    'aria-describedby',
    'aria-details',
    'aria-disabled',
    'aria-errormessage',
    'aria-expanded',
    'aria-flowto',
    'aria-haspopup',
    'aria-hidden',
    'aria-invalid',
    'aria-keyshortcuts',
    'aria-label',
    'aria-labelledby',
    'aria-level',
    'aria-live',
    'aria-modal',
    'aria-multiline',
    'aria-multiselectable',
    'aria-orientation',
    'aria-owns',
    'aria-placeholder',
    'aria-posinset',
    'aria-pressed',
    'aria-readonly',
    'aria-relevant',
    'aria-required',
    'aria-roledescription',
    'aria-rowcount',
    'aria-rowindex',
    'aria-rowspan',
    'aria-selected',
    'aria-setsize',
    'aria-sort',
    'aria-valuemax',
    'aria-valuemin',
    'aria-valuenow',
    'aria-valuetext',
    'className',
    'color',
    'height',
    'id',
    'lang',
    'max',
    'media',
    'method',
    'min',
    'name',
    'style',
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    'target',
    'width',
    'role',
    'tabIndex',
    'accentHeight',
    'accumulate',
    'additive',
    'alignmentBaseline',
    'allowReorder',
    'alphabetic',
    'amplitude',
    'arabicForm',
    'ascent',
    'attributeName',
    'attributeType',
    'autoReverse',
    'azimuth',
    'baseFrequency',
    'baselineShift',
    'baseProfile',
    'bbox',
    'begin',
    'bias',
    'by',
    'calcMode',
    'capHeight',
    'clip',
    'clipPath',
    'clipPathUnits',
    'clipRule',
    'colorInterpolation',
    'colorInterpolationFilters',
    'colorProfile',
    'colorRendering',
    'contentScriptType',
    'contentStyleType',
    'cursor',
    'cx',
    'cy',
    'd',
    'decelerate',
    'descent',
    'diffuseConstant',
    'direction',
    'display',
    'divisor',
    'dominantBaseline',
    'dur',
    'dx',
    'dy',
    'edgeMode',
    'elevation',
    'enableBackground',
    'end',
    'exponent',
    'externalResourcesRequired',
    'fill',
    'fillOpacity',
    'fillRule',
    'filter',
    'filterRes',
    'filterUnits',
    'floodColor',
    'floodOpacity',
    'focusable',
    'fontFamily',
    'fontSize',
    'fontSizeAdjust',
    'fontStretch',
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'format',
    'from',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyphName',
    'glyphOrientationHorizontal',
    'glyphOrientationVertical',
    'glyphRef',
    'gradientTransform',
    'gradientUnits',
    'hanging',
    'horizAdvX',
    'horizOriginX',
    'href',
    'ideographic',
    'imageRendering',
    'in2',
    'in',
    'intercept',
    'k1',
    'k2',
    'k3',
    'k4',
    'k',
    'kernelMatrix',
    'kernelUnitLength',
    'kerning',
    'keyPoints',
    'keySplines',
    'keyTimes',
    'lengthAdjust',
    'letterSpacing',
    'lightingColor',
    'limitingConeAngle',
    'local',
    'markerEnd',
    'markerHeight',
    'markerMid',
    'markerStart',
    'markerUnits',
    'markerWidth',
    'mask',
    'maskContentUnits',
    'maskUnits',
    'mathematical',
    'mode',
    'numOctaves',
    'offset',
    'opacity',
    'operator',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'overlinePosition',
    'overlineThickness',
    'paintOrder',
    'panose1',
    'pathLength',
    'patternContentUnits',
    'patternTransform',
    'patternUnits',
    'pointerEvents',
    'pointsAtX',
    'pointsAtY',
    'pointsAtZ',
    'preserveAlpha',
    'preserveAspectRatio',
    'primitiveUnits',
    'r',
    'radius',
    'refX',
    'refY',
    'renderingIntent',
    'repeatCount',
    'repeatDur',
    'requiredExtensions',
    'requiredFeatures',
    'restart',
    'result',
    'rotate',
    'rx',
    'ry',
    'seed',
    'shapeRendering',
    'slope',
    'spacing',
    'specularConstant',
    'specularExponent',
    'speed',
    'spreadMethod',
    'startOffset',
    'stdDeviation',
    'stemh',
    'stemv',
    'stitchTiles',
    'stopColor',
    'stopOpacity',
    'strikethroughPosition',
    'strikethroughThickness',
    'string',
    'stroke',
    'strokeDasharray',
    'strokeDashoffset',
    'strokeLinecap',
    'strokeLinejoin',
    'strokeMiterlimit',
    'strokeOpacity',
    'strokeWidth',
    'surfaceScale',
    'systemLanguage',
    'tableValues',
    'targetX',
    'targetY',
    'textAnchor',
    'textDecoration',
    'textLength',
    'textRendering',
    'to',
    'transform',
    'u1',
    'u2',
    'underlinePosition',
    'underlineThickness',
    'unicode',
    'unicodeBidi',
    'unicodeRange',
    'unitsPerEm',
    'vAlphabetic',
    'values',
    'vectorEffect',
    'version',
    'vertAdvY',
    'vertOriginX',
    'vertOriginY',
    'vHanging',
    'vIdeographic',
    'viewTarget',
    'visibility',
    'vMathematical',
    'widths',
    'wordSpacing',
    'writingMode',
    'x1',
    'x2',
    'x',
    'xChannelSelector',
    'xHeight',
    'xlinkActuate',
    'xlinkArcrole',
    'xlinkHref',
    'xlinkRole',
    'xlinkShow',
    'xlinkTitle',
    'xlinkType',
    'xmlBase',
    'xmlLang',
    'xmlns',
    'xmlnsXlink',
    'xmlSpace',
    'y1',
    'y2',
    'y',
    'yChannelSelector',
    'z',
    'zoomAndPan',
    'ref',
    'key',
    'angle'
];
var $a19170a4abc07995$var$PolyElementKeys = [
    'points',
    'pathLength'
];
var $a19170a4abc07995$export$2b22758266a6fa48 = {
    svg: $a19170a4abc07995$var$SVGContainerPropKeys,
    polygon: $a19170a4abc07995$var$PolyElementKeys,
    polyline: $a19170a4abc07995$var$PolyElementKeys
};
var $a19170a4abc07995$export$f30789245f2c4d11 = [
    'dangerouslySetInnerHTML',
    'onCopy',
    'onCopyCapture',
    'onCut',
    'onCutCapture',
    'onPaste',
    'onPasteCapture',
    'onCompositionEnd',
    'onCompositionEndCapture',
    'onCompositionStart',
    'onCompositionStartCapture',
    'onCompositionUpdate',
    'onCompositionUpdateCapture',
    'onFocus',
    'onFocusCapture',
    'onBlur',
    'onBlurCapture',
    'onChange',
    'onChangeCapture',
    'onBeforeInput',
    'onBeforeInputCapture',
    'onInput',
    'onInputCapture',
    'onReset',
    'onResetCapture',
    'onSubmit',
    'onSubmitCapture',
    'onInvalid',
    'onInvalidCapture',
    'onLoad',
    'onLoadCapture',
    'onError',
    'onErrorCapture',
    'onKeyDown',
    'onKeyDownCapture',
    'onKeyPress',
    'onKeyPressCapture',
    'onKeyUp',
    'onKeyUpCapture',
    'onAbort',
    'onAbortCapture',
    'onCanPlay',
    'onCanPlayCapture',
    'onCanPlayThrough',
    'onCanPlayThroughCapture',
    'onDurationChange',
    'onDurationChangeCapture',
    'onEmptied',
    'onEmptiedCapture',
    'onEncrypted',
    'onEncryptedCapture',
    'onEnded',
    'onEndedCapture',
    'onLoadedData',
    'onLoadedDataCapture',
    'onLoadedMetadata',
    'onLoadedMetadataCapture',
    'onLoadStart',
    'onLoadStartCapture',
    'onPause',
    'onPauseCapture',
    'onPlay',
    'onPlayCapture',
    'onPlaying',
    'onPlayingCapture',
    'onProgress',
    'onProgressCapture',
    'onRateChange',
    'onRateChangeCapture',
    'onSeeked',
    'onSeekedCapture',
    'onSeeking',
    'onSeekingCapture',
    'onStalled',
    'onStalledCapture',
    'onSuspend',
    'onSuspendCapture',
    'onTimeUpdate',
    'onTimeUpdateCapture',
    'onVolumeChange',
    'onVolumeChangeCapture',
    'onWaiting',
    'onWaitingCapture',
    'onAuxClick',
    'onAuxClickCapture',
    'onClick',
    'onClickCapture',
    'onContextMenu',
    'onContextMenuCapture',
    'onDoubleClick',
    'onDoubleClickCapture',
    'onDrag',
    'onDragCapture',
    'onDragEnd',
    'onDragEndCapture',
    'onDragEnter',
    'onDragEnterCapture',
    'onDragExit',
    'onDragExitCapture',
    'onDragLeave',
    'onDragLeaveCapture',
    'onDragOver',
    'onDragOverCapture',
    'onDragStart',
    'onDragStartCapture',
    'onDrop',
    'onDropCapture',
    'onMouseDown',
    'onMouseDownCapture',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseMoveCapture',
    'onMouseOut',
    'onMouseOutCapture',
    'onMouseOver',
    'onMouseOverCapture',
    'onMouseUp',
    'onMouseUpCapture',
    'onSelect',
    'onSelectCapture',
    'onTouchCancel',
    'onTouchCancelCapture',
    'onTouchEnd',
    'onTouchEndCapture',
    'onTouchMove',
    'onTouchMoveCapture',
    'onTouchStart',
    'onTouchStartCapture',
    'onPointerDown',
    'onPointerDownCapture',
    'onPointerMove',
    'onPointerMoveCapture',
    'onPointerUp',
    'onPointerUpCapture',
    'onPointerCancel',
    'onPointerCancelCapture',
    'onPointerEnter',
    'onPointerEnterCapture',
    'onPointerLeave',
    'onPointerLeaveCapture',
    'onPointerOver',
    'onPointerOverCapture',
    'onPointerOut',
    'onPointerOutCapture',
    'onGotPointerCapture',
    'onGotPointerCaptureCapture',
    'onLostPointerCapture',
    'onLostPointerCaptureCapture',
    'onScroll',
    'onScrollCapture',
    'onWheel',
    'onWheelCapture',
    'onAnimationStart',
    'onAnimationStartCapture',
    'onAnimationEnd',
    'onAnimationEndCapture',
    'onAnimationIteration',
    'onAnimationIterationCapture',
    'onTransitionEnd',
    'onTransitionEndCapture'
];
var $a19170a4abc07995$export$7c4c290a4a9c1b1e = function adaptEventHandlers(props, newHandler) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $8T3gX.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cd2b0b1294af0960$exports)))(inputProps)) return null;
    var out = {};
    Object.keys(inputProps).forEach(function(key) {
        if ($a19170a4abc07995$export$f30789245f2c4d11.includes(key)) out[key] = newHandler || function(e) {
            return inputProps[key](inputProps, e);
        };
    });
    return out;
};
var $a19170a4abc07995$var$getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
    return function(e) {
        originalHandler(data, index, e);
        return null;
    };
};
var $a19170a4abc07995$export$ca62be0d67a3158c = function adaptEventsOfChild(props, data, index) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cd2b0b1294af0960$exports)))(props) || $a19170a4abc07995$var$_typeof(props) !== 'object') return null;
    var out = null;
    Object.keys(props).forEach(function(key) {
        var item = props[key];
        if ($a19170a4abc07995$export$f30789245f2c4d11.includes(key) && typeof item === 'function') {
            if (!out) out = {};
            out[key] = $a19170a4abc07995$var$getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};


var $10636f1b3e62ab88$var$_excluded = [
    "children"
], $10636f1b3e62ab88$var$_excluded2 = [
    "children"
];
function $10636f1b3e62ab88$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $10636f1b3e62ab88$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $10636f1b3e62ab88$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $10636f1b3e62ab88$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $10636f1b3e62ab88$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $10636f1b3e62ab88$var$_typeof(o);
}
var $10636f1b3e62ab88$var$REACT_BROWSER_EVENT_MAP = {
    click: 'onClick',
    mousedown: 'onMouseDown',
    mouseup: 'onMouseUp',
    mouseover: 'onMouseOver',
    mousemove: 'onMouseMove',
    mouseout: 'onMouseOut',
    mouseenter: 'onMouseEnter',
    mouseleave: 'onMouseLeave',
    touchcancel: 'onTouchCancel',
    touchend: 'onTouchEnd',
    touchmove: 'onTouchMove',
    touchstart: 'onTouchStart',
    contextmenu: 'onContextMenu',
    dblclick: 'onDoubleClick'
};
var $10636f1b3e62ab88$export$e65e0ff8d3882b46 = [
    'auto',
    'linear',
    'pow',
    'sqrt',
    'log',
    'identity',
    'time',
    'band',
    'point',
    'ordinal',
    'quantile',
    'quantize',
    'utc',
    'sequential',
    'threshold'
];
var $10636f1b3e62ab88$export$84dbd3b52ff06578 = [
    'plainline',
    'line',
    'square',
    'rect',
    'circle',
    'cross',
    'diamond',
    'star',
    'triangle',
    'wye',
    'none'
];
var $10636f1b3e62ab88$export$59a4d7d024cf1025 = [
    'none'
];
var $10636f1b3e62ab88$export$be63e0664592e141 = function getDisplayName(Comp) {
    if (typeof Comp === 'string') return Comp;
    if (!Comp) return '';
    return Comp.displayName || Comp.name || 'Component';
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var $10636f1b3e62ab88$var$lastChildren = null;
var $10636f1b3e62ab88$var$lastResult = null;
var $10636f1b3e62ab88$export$45b10814cc054894 = function toArray(children) {
    if (children === $10636f1b3e62ab88$var$lastChildren && Array.isArray($10636f1b3e62ab88$var$lastResult)) return $10636f1b3e62ab88$var$lastResult;
    var result = [];
    (0, $8T3gX.Children).forEach(children, function(child) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(child)) return;
        if ((0, $6446984f457e89e7$exports.isFragment)(child)) result = result.concat(toArray(child.props.children));
        else // @ts-expect-error this could still be Iterable<ReactNode> and TS does not like that
        result.push(child);
    });
    $10636f1b3e62ab88$var$lastResult = result;
    $10636f1b3e62ab88$var$lastChildren = children;
    return result;
};
function $10636f1b3e62ab88$export$fdd5e64c0e8495bb(children, type) {
    var result = [];
    var types = [];
    if (Array.isArray(type)) types = type.map(function(t) {
        return $10636f1b3e62ab88$export$be63e0664592e141(t);
    });
    else types = [
        $10636f1b3e62ab88$export$be63e0664592e141(type)
    ];
    $10636f1b3e62ab88$export$45b10814cc054894(children).forEach(function(child) {
        var childType = (0, (/*@__PURE__*/$parcel$interopDefault($eb02300d30d6bdcb$exports)))(child, 'type.displayName') || (0, (/*@__PURE__*/$parcel$interopDefault($eb02300d30d6bdcb$exports)))(child, 'type.name');
        if (types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
function $10636f1b3e62ab88$export$64c61536a2b72e0f(children, type) {
    var result = $10636f1b3e62ab88$export$fdd5e64c0e8495bb(children, type);
    return result && result[0];
}
var $10636f1b3e62ab88$export$d0b46a9571fa5ebf = function withoutType(children, type) {
    var newChildren = [];
    var types;
    if (Array.isArray(type)) types = type.map(function(t) {
        return $10636f1b3e62ab88$export$be63e0664592e141(t);
    });
    else types = [
        $10636f1b3e62ab88$export$be63e0664592e141(type)
    ];
    $10636f1b3e62ab88$export$45b10814cc054894(children).forEach(function(child) {
        var displayName = (0, (/*@__PURE__*/$parcel$interopDefault($eb02300d30d6bdcb$exports)))(child, 'type.displayName');
        if (displayName && types.indexOf(displayName) !== -1) return;
        newChildren.push(child);
    });
    return newChildren;
};
var $10636f1b3e62ab88$export$5301de6bfd3cfa2a = function validateWidthHeight(el) {
    if (!el || !el.props) return false;
    var _el$props = el.props, width = _el$props.width, height = _el$props.height;
    if (!(0, $ec351366ffe25ce6$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $ec351366ffe25ce6$export$7e4aa119212bc614)(height) || height <= 0) return false;
    return true;
};
var $10636f1b3e62ab88$var$SVG_TAGS = [
    'a',
    'altGlyph',
    'altGlyphDef',
    'altGlyphItem',
    'animate',
    'animateColor',
    'animateMotion',
    'animateTransform',
    'circle',
    'clipPath',
    'color-profile',
    'cursor',
    'defs',
    'desc',
    'ellipse',
    'feBlend',
    'feColormatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'filter',
    'font',
    'font-face',
    'font-face-format',
    'font-face-name',
    'font-face-url',
    'foreignObject',
    'g',
    'glyph',
    'glyphRef',
    'hkern',
    'image',
    'line',
    'lineGradient',
    'marker',
    'mask',
    'metadata',
    'missing-glyph',
    'mpath',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'script',
    'set',
    'stop',
    'style',
    'svg',
    'switch',
    'symbol',
    'text',
    'textPath',
    'title',
    'tref',
    'tspan',
    'use',
    'view',
    'vkern'
];
var $10636f1b3e62ab88$var$isSvgElement = function isSvgElement(child) {
    return child && child.type && (0, (/*@__PURE__*/$parcel$interopDefault($b674a8a9f1dd7eca$exports)))(child.type) && $10636f1b3e62ab88$var$SVG_TAGS.indexOf(child.type) >= 0;
};
var $10636f1b3e62ab88$export$392f6c9701718a4e = function hasClipDot(dot) {
    return dot && $10636f1b3e62ab88$var$_typeof(dot) === 'object' && 'clipDot' in dot;
};
var $10636f1b3e62ab88$export$be767fcc756dddf6 = function isValidSpreadableProp(property, key, includeEvents, svgElementType) {
    var _FilteredElementKeyMa;
    /**
   * If the svg element type is explicitly included, check against the filtered element key map
   * to determine if there are attributes that should only exist on that element type.
   * @todo Add an internal cjs version of https://github.com/wooorm/svg-element-attributes for full coverage.
   */ var matchingElementTypeKeys = (_FilteredElementKeyMa = (0, $a19170a4abc07995$export$2b22758266a6fa48) === null || (0, $a19170a4abc07995$export$2b22758266a6fa48) === void 0 ? void 0 : (0, $a19170a4abc07995$export$2b22758266a6fa48)[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
    return key.startsWith('data-') || !(0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(property) && (svgElementType && matchingElementTypeKeys.includes(key) || (0, $a19170a4abc07995$export$190f430946f96110).includes(key)) || includeEvents && (0, $a19170a4abc07995$export$f30789245f2c4d11).includes(key);
};
var $10636f1b3e62ab88$export$ef6f3b46dcb37b3f = function filterSvgElements(children) {
    var svgElements = [];
    $10636f1b3e62ab88$export$45b10814cc054894(children).forEach(function(entry) {
        if ($10636f1b3e62ab88$var$isSvgElement(entry)) svgElements.push(entry);
    });
    return svgElements;
};
var $10636f1b3e62ab88$export$d697c39a2985a4c = function filterProps(props, includeEvents, svgElementType) {
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $8T3gX.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cd2b0b1294af0960$exports)))(inputProps)) return null;
    var out = {};
    /**
   * Props are blindly spread onto SVG elements. This loop filters out properties that we don't want to spread.
   * Items filtered out are as follows:
   *   - functions in properties that are SVG attributes (functions are included when includeEvents is true)
   *   - props that are SVG attributes but don't matched the passed svgElementType
   *   - any prop that is not in SVGElementPropKeys (or in EventKeys if includeEvents is true)
   */ Object.keys(inputProps).forEach(function(key) {
        var _inputProps;
        if ($10636f1b3e62ab88$export$be767fcc756dddf6((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key], key, includeEvents, svgElementType)) out[key] = inputProps[key];
    });
    return out;
};
var $10636f1b3e62ab88$export$acdc716e08572f94 = function isChildrenEqual(nextChildren, prevChildren) {
    if (nextChildren === prevChildren) return true;
    var count = (0, $8T3gX.Children).count(nextChildren);
    if (count !== (0, $8T3gX.Children).count(prevChildren)) return false;
    if (count === 0) return true;
    if (count === 1) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $10636f1b3e62ab88$export$96bceecf65400492(Array.isArray(nextChildren) ? nextChildren[0] : nextChildren, Array.isArray(prevChildren) ? prevChildren[0] : prevChildren);
    for(var i = 0; i < count; i++){
        var nextChild = nextChildren[i];
        var prevChild = prevChildren[i];
        if (Array.isArray(nextChild) || Array.isArray(prevChild)) {
            if (!isChildrenEqual(nextChild, prevChild)) return false;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        } else if (!$10636f1b3e62ab88$export$96bceecf65400492(nextChild, prevChild)) return false;
    }
    return true;
};
var $10636f1b3e62ab88$export$96bceecf65400492 = function isSingleChildEqual(nextChild, prevChild) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(nextChild) && (0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(prevChild)) return true;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(nextChild) && !(0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(prevChild)) {
        var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = $10636f1b3e62ab88$var$_objectWithoutProperties(_ref, $10636f1b3e62ab88$var$_excluded);
        var _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = $10636f1b3e62ab88$var$_objectWithoutProperties(_ref2, $10636f1b3e62ab88$var$_excluded2);
        if (nextChildren && prevChildren) return (0, $902ad73c142587a6$export$d36bdfa510afb180)(nextProps, prevProps) && $10636f1b3e62ab88$export$acdc716e08572f94(nextChildren, prevChildren);
        if (!nextChildren && !prevChildren) return (0, $902ad73c142587a6$export$d36bdfa510afb180)(nextProps, prevProps);
        return false;
    }
    return false;
};
var $10636f1b3e62ab88$export$a98d6da55570cb82 = function renderByOrder(children, renderMap) {
    var elements = [];
    var record = {};
    $10636f1b3e62ab88$export$45b10814cc054894(children).forEach(function(child, index) {
        if ($10636f1b3e62ab88$var$isSvgElement(child)) elements.push(child);
        else if (child) {
            var displayName = $10636f1b3e62ab88$export$be63e0664592e141(child.type);
            var _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once = _ref3.once;
            if (handler && (!once || !record[displayName])) {
                var results = handler(child, displayName, index);
                elements.push(results);
                record[displayName] = true;
            }
        }
    });
    return elements;
};
var $10636f1b3e62ab88$export$afb3591bc51a0b70 = function getReactEventByType(e) {
    var type = e && e.type;
    if (type && $10636f1b3e62ab88$var$REACT_BROWSER_EVENT_MAP[type]) return $10636f1b3e62ab88$var$REACT_BROWSER_EVENT_MAP[type];
    return null;
};
var $10636f1b3e62ab88$export$857ca101f741953 = function parseChildIndex(child, children) {
    return $10636f1b3e62ab88$export$45b10814cc054894(children).indexOf(child);
};


var $3366a7250677b47e$var$_excluded = [
    "children",
    "className"
];
function $3366a7250677b47e$var$_extends() {
    $3366a7250677b47e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3366a7250677b47e$var$_extends.apply(this, arguments);
}
function $3366a7250677b47e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3366a7250677b47e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3366a7250677b47e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $3366a7250677b47e$export$936d0764594b6eb3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).forwardRef(function(props, ref) {
    var children = props.children, className = props.className, others = $3366a7250677b47e$var$_objectWithoutProperties(props, $3366a7250677b47e$var$_excluded);
    var layerClass = (0, $iVyaN.default)('recharts-layer', className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("g", $3366a7250677b47e$var$_extends({
        className: layerClass
    }, (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(others, true), {
        ref: ref
    }), children);
});



var $8T3gX = parcelRequire("8T3gX");
var $668d778f3ad25eac$var$isProduction = false;
var $668d778f3ad25eac$var$prefix = 'Invariant failed';
function $668d778f3ad25eac$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($668d778f3ad25eac$var$isProduction) throw new Error($668d778f3ad25eac$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($668d778f3ad25eac$var$prefix, ": ").concat(provided) : $668d778f3ad25eac$var$prefix;
    throw new Error(value);
}




var $3ba1a13bb3875529$var$_excluded = [
    "offset",
    "layout",
    "width",
    "dataKey",
    "data",
    "dataPointFormatter",
    "xAxis",
    "yAxis"
];
function $3ba1a13bb3875529$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3ba1a13bb3875529$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3ba1a13bb3875529$var$_typeof(o);
}
function $3ba1a13bb3875529$var$_extends() {
    $3ba1a13bb3875529$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3ba1a13bb3875529$var$_extends.apply(this, arguments);
}
function $3ba1a13bb3875529$var$_slicedToArray(arr, i) {
    return $3ba1a13bb3875529$var$_arrayWithHoles(arr) || $3ba1a13bb3875529$var$_iterableToArrayLimit(arr, i) || $3ba1a13bb3875529$var$_unsupportedIterableToArray(arr, i) || $3ba1a13bb3875529$var$_nonIterableRest();
}
function $3ba1a13bb3875529$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3ba1a13bb3875529$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3ba1a13bb3875529$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3ba1a13bb3875529$var$_arrayLikeToArray(o, minLen);
}
function $3ba1a13bb3875529$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3ba1a13bb3875529$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $3ba1a13bb3875529$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3ba1a13bb3875529$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3ba1a13bb3875529$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3ba1a13bb3875529$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $3ba1a13bb3875529$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3ba1a13bb3875529$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $3ba1a13bb3875529$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $3ba1a13bb3875529$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3ba1a13bb3875529$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3ba1a13bb3875529$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $3ba1a13bb3875529$var$_callSuper(t, o, e) {
    return o = $3ba1a13bb3875529$var$_getPrototypeOf(o), $3ba1a13bb3875529$var$_possibleConstructorReturn(t, $3ba1a13bb3875529$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $3ba1a13bb3875529$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $3ba1a13bb3875529$var$_possibleConstructorReturn(self, call) {
    if (call && ($3ba1a13bb3875529$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $3ba1a13bb3875529$var$_assertThisInitialized(self);
}
function $3ba1a13bb3875529$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3ba1a13bb3875529$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3ba1a13bb3875529$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $3ba1a13bb3875529$var$_getPrototypeOf(o) {
    $3ba1a13bb3875529$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3ba1a13bb3875529$var$_getPrototypeOf(o);
}
function $3ba1a13bb3875529$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $3ba1a13bb3875529$var$_setPrototypeOf(subClass, superClass);
}
function $3ba1a13bb3875529$var$_setPrototypeOf(o, p) {
    $3ba1a13bb3875529$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3ba1a13bb3875529$var$_setPrototypeOf(o, p);
}
function $3ba1a13bb3875529$var$_defineProperty(obj, key, value) {
    key = $3ba1a13bb3875529$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3ba1a13bb3875529$var$_toPropertyKey(t) {
    var i = $3ba1a13bb3875529$var$_toPrimitive(t, "string");
    return "symbol" == $3ba1a13bb3875529$var$_typeof(i) ? i : i + "";
}
function $3ba1a13bb3875529$var$_toPrimitive(t, r) {
    if ("object" != $3ba1a13bb3875529$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3ba1a13bb3875529$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $3ba1a13bb3875529$export$4f4d7676bdf949e5 = /*#__PURE__*/ function(_React$Component) {
    function ErrorBar() {
        $3ba1a13bb3875529$var$_classCallCheck(this, ErrorBar);
        return $3ba1a13bb3875529$var$_callSuper(this, ErrorBar, arguments);
    }
    $3ba1a13bb3875529$var$_inherits(ErrorBar, _React$Component);
    return $3ba1a13bb3875529$var$_createClass(ErrorBar, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, offset = _this$props.offset, layout = _this$props.layout, width = _this$props.width, dataKey = _this$props.dataKey, data = _this$props.data, dataPointFormatter = _this$props.dataPointFormatter, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, others = $3ba1a13bb3875529$var$_objectWithoutProperties(_this$props, $3ba1a13bb3875529$var$_excluded);
                var svgProps = (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(others, false);
                !!(this.props.direction === 'x' && xAxis.type !== 'number') && (0, $668d778f3ad25eac$export$2e2bcd8739ae039)(false, 'ErrorBar requires Axis type property to be "number".');
                var errorBars = data.map(function(entry) {
                    var _dataPointFormatter = dataPointFormatter(entry, dataKey), x = _dataPointFormatter.x, y = _dataPointFormatter.y, value = _dataPointFormatter.value, errorVal = _dataPointFormatter.errorVal;
                    if (!errorVal) return null;
                    var lineCoordinates = [];
                    var lowBound, highBound;
                    if (Array.isArray(errorVal)) {
                        var _errorVal = $3ba1a13bb3875529$var$_slicedToArray(errorVal, 2);
                        lowBound = _errorVal[0];
                        highBound = _errorVal[1];
                    } else lowBound = highBound = errorVal;
                    if (layout === 'vertical') {
                        // error bar for horizontal charts, the y is fixed, x is a range value
                        var scale = xAxis.scale;
                        var yMid = y + offset;
                        var yMin = yMid + width;
                        var yMax = yMid - width;
                        var xMin = scale(value - lowBound);
                        var xMax = scale(value + highBound);
                        // the right line of |--|
                        lineCoordinates.push({
                            x1: xMax,
                            y1: yMin,
                            x2: xMax,
                            y2: yMax
                        });
                        // the middle line of |--|
                        lineCoordinates.push({
                            x1: xMin,
                            y1: yMid,
                            x2: xMax,
                            y2: yMid
                        });
                        // the left line of |--|
                        lineCoordinates.push({
                            x1: xMin,
                            y1: yMin,
                            x2: xMin,
                            y2: yMax
                        });
                    } else if (layout === 'horizontal') {
                        // error bar for horizontal charts, the x is fixed, y is a range value
                        var _scale = yAxis.scale;
                        var xMid = x + offset;
                        var _xMin = xMid - width;
                        var _xMax = xMid + width;
                        var _yMin = _scale(value - lowBound);
                        var _yMax = _scale(value + highBound);
                        // the top line
                        lineCoordinates.push({
                            x1: _xMin,
                            y1: _yMax,
                            x2: _xMax,
                            y2: _yMax
                        });
                        // the middle line
                        lineCoordinates.push({
                            x1: xMid,
                            y1: _yMin,
                            x2: xMid,
                            y2: _yMax
                        });
                        // the bottom line
                        lineCoordinates.push({
                            x1: _xMin,
                            y1: _yMin,
                            x2: _xMax,
                            y2: _yMin
                        });
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $3366a7250677b47e$export$936d0764594b6eb3), $3ba1a13bb3875529$var$_extends({
                        className: "recharts-errorBar",
                        key: "bar-".concat(lineCoordinates.map(function(c) {
                            return "".concat(c.x1, "-").concat(c.x2, "-").concat(c.y1, "-").concat(c.y2);
                        }))
                    }, svgProps), lineCoordinates.map(function(coordinates) {
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("line", $3ba1a13bb3875529$var$_extends({}, coordinates, {
                            key: "line-".concat(coordinates.x1, "-").concat(coordinates.x2, "-").concat(coordinates.y1, "-").concat(coordinates.y2)
                        }));
                    }));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $3366a7250677b47e$export$936d0764594b6eb3), {
                    className: "recharts-errorBars"
                }, errorBars);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Component);
$3ba1a13bb3875529$var$_defineProperty($3ba1a13bb3875529$export$4f4d7676bdf949e5, "defaultProps", {
    stroke: 'black',
    strokeWidth: 1.5,
    width: 5,
    offset: 0,
    layout: 'horizontal'
});
$3ba1a13bb3875529$var$_defineProperty($3ba1a13bb3875529$export$4f4d7676bdf949e5, "displayName", 'ErrorBar');


/**
 * @fileOverview Cross
 */ var $fe1584e453ed4ef4$export$f6f0c3fe4ec306ea = function Cell(_props) {
    return null;
};
$fe1584e453ed4ef4$export$f6f0c3fe4ec306ea.displayName = 'Cell';



var $8T3gX = parcelRequire("8T3gX");



var $c8275cc063b9781c$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $c8275cc063b9781c$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$c8275cc063b9781c$exports = $c8275cc063b9781c$var$last;



var $8T3gX = parcelRequire("8T3gX");




var $iVyaN = parcelRequire("iVyaN");

var $8T3gX = parcelRequire("8T3gX");


var $iVyaN = parcelRequire("iVyaN");

var $809421885870cd36$var$parseIsSsrByDefault = function parseIsSsrByDefault() {
    return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
};
var $809421885870cd36$export$98f03c5d19621d70 = {
    isSsr: $809421885870cd36$var$parseIsSsrByDefault(),
    get: function get(key) {
        return $809421885870cd36$export$98f03c5d19621d70[key];
    },
    set: function set(key, value) {
        if (typeof key === 'string') $809421885870cd36$export$98f03c5d19621d70[key] = value;
        else {
            var keys = Object.keys(key);
            if (keys && keys.length) keys.forEach(function(k) {
                $809421885870cd36$export$98f03c5d19621d70[k] = key[k];
            });
        }
    }
};




function $cf8622a67b6f7493$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $cf8622a67b6f7493$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $cf8622a67b6f7493$var$_typeof(o);
}
function $cf8622a67b6f7493$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cf8622a67b6f7493$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cf8622a67b6f7493$var$ownKeys(Object(t), !0).forEach(function(r) {
            $cf8622a67b6f7493$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cf8622a67b6f7493$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cf8622a67b6f7493$var$_defineProperty(obj, key, value) {
    key = $cf8622a67b6f7493$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cf8622a67b6f7493$var$_toPropertyKey(t) {
    var i = $cf8622a67b6f7493$var$_toPrimitive(t, "string");
    return "symbol" == $cf8622a67b6f7493$var$_typeof(i) ? i : i + "";
}
function $cf8622a67b6f7493$var$_toPrimitive(t, r) {
    if ("object" != $cf8622a67b6f7493$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $cf8622a67b6f7493$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $cf8622a67b6f7493$var$_toConsumableArray(arr) {
    return $cf8622a67b6f7493$var$_arrayWithoutHoles(arr) || $cf8622a67b6f7493$var$_iterableToArray(arr) || $cf8622a67b6f7493$var$_unsupportedIterableToArray(arr) || $cf8622a67b6f7493$var$_nonIterableSpread();
}
function $cf8622a67b6f7493$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cf8622a67b6f7493$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cf8622a67b6f7493$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cf8622a67b6f7493$var$_arrayLikeToArray(o, minLen);
}
function $cf8622a67b6f7493$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $cf8622a67b6f7493$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $cf8622a67b6f7493$var$_arrayLikeToArray(arr);
}
function $cf8622a67b6f7493$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $cf8622a67b6f7493$var$stringCache = {
    widthCache: {},
    cacheCount: 0
};
var $cf8622a67b6f7493$var$MAX_CACHE_NUM = 2000;
var $cf8622a67b6f7493$var$SPAN_STYLE = {
    position: 'absolute',
    top: '-20000px',
    left: 0,
    padding: 0,
    margin: 0,
    border: 'none',
    whiteSpace: 'pre'
};
var $cf8622a67b6f7493$var$STYLE_LIST = [
    'minWidth',
    'maxWidth',
    'width',
    'minHeight',
    'maxHeight',
    'height',
    'top',
    'left',
    'fontSize',
    'lineHeight',
    'padding',
    'margin',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    'paddingBottom',
    'marginLeft',
    'marginRight',
    'marginTop',
    'marginBottom'
];
var $cf8622a67b6f7493$var$MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
function $cf8622a67b6f7493$var$autoCompleteStyle(name, value) {
    if ($cf8622a67b6f7493$var$STYLE_LIST.indexOf(name) >= 0 && value === +value) return "".concat(value, "px");
    return value;
}
function $cf8622a67b6f7493$var$camelToMiddleLine(text) {
    var strs = text.split('');
    var formatStrs = strs.reduce(function(result, entry) {
        if (entry === entry.toUpperCase()) return [].concat($cf8622a67b6f7493$var$_toConsumableArray(result), [
            '-',
            entry.toLowerCase()
        ]);
        return [].concat($cf8622a67b6f7493$var$_toConsumableArray(result), [
            entry
        ]);
    }, []);
    return formatStrs.join('');
}
var $cf8622a67b6f7493$export$9a2c38fb88d8e30 = function getStyleString(style) {
    return Object.keys(style).reduce(function(result, s) {
        return "".concat(result).concat($cf8622a67b6f7493$var$camelToMiddleLine(s), ":").concat($cf8622a67b6f7493$var$autoCompleteStyle(s, style[s]), ";");
    }, '');
};
function $cf8622a67b6f7493$var$removeInvalidKeys(obj) {
    var copyObj = $cf8622a67b6f7493$var$_objectSpread({}, obj);
    Object.keys(copyObj).forEach(function(key) {
        if (!copyObj[key]) delete copyObj[key];
    });
    return copyObj;
}
var $cf8622a67b6f7493$export$e5560531f057ad5d = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, $809421885870cd36$export$98f03c5d19621d70).isSsr) return {
        width: 0,
        height: 0
    };
    var copyStyle = $cf8622a67b6f7493$var$removeInvalidKeys(style);
    var cacheKey = JSON.stringify({
        text: text,
        copyStyle: copyStyle
    });
    if ($cf8622a67b6f7493$var$stringCache.widthCache[cacheKey]) return $cf8622a67b6f7493$var$stringCache.widthCache[cacheKey];
    try {
        var measurementSpan = document.getElementById($cf8622a67b6f7493$var$MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement('span');
            measurementSpan.setAttribute('id', $cf8622a67b6f7493$var$MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute('aria-hidden', 'true');
            document.body.appendChild(measurementSpan);
        }
        // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
        // https://en.wikipedia.org/wiki/Content_Security_Policy
        var measurementSpanStyle = $cf8622a67b6f7493$var$_objectSpread($cf8622a67b6f7493$var$_objectSpread({}, $cf8622a67b6f7493$var$SPAN_STYLE), copyStyle);
        Object.assign(measurementSpan.style, measurementSpanStyle);
        measurementSpan.textContent = "".concat(text);
        var rect = measurementSpan.getBoundingClientRect();
        var result = {
            width: rect.width,
            height: rect.height
        };
        $cf8622a67b6f7493$var$stringCache.widthCache[cacheKey] = result;
        if (++$cf8622a67b6f7493$var$stringCache.cacheCount > $cf8622a67b6f7493$var$MAX_CACHE_NUM) {
            $cf8622a67b6f7493$var$stringCache.cacheCount = 0;
            $cf8622a67b6f7493$var$stringCache.widthCache = {};
        }
        return result;
    } catch (e) {
        return {
            width: 0,
            height: 0
        };
    }
};
var $cf8622a67b6f7493$export$622cea445a1c5b7d = function getOffset(rect) {
    return {
        top: rect.top + window.scrollY - document.documentElement.clientTop,
        left: rect.left + window.scrollX - document.documentElement.clientLeft
    };
};


function $e474b00e84b593bd$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e474b00e84b593bd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e474b00e84b593bd$var$_typeof(o);
}
function $e474b00e84b593bd$var$_slicedToArray(arr, i) {
    return $e474b00e84b593bd$var$_arrayWithHoles(arr) || $e474b00e84b593bd$var$_iterableToArrayLimit(arr, i) || $e474b00e84b593bd$var$_unsupportedIterableToArray(arr, i) || $e474b00e84b593bd$var$_nonIterableRest();
}
function $e474b00e84b593bd$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e474b00e84b593bd$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e474b00e84b593bd$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e474b00e84b593bd$var$_arrayLikeToArray(o, minLen);
}
function $e474b00e84b593bd$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e474b00e84b593bd$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $e474b00e84b593bd$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $e474b00e84b593bd$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e474b00e84b593bd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e474b00e84b593bd$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $e474b00e84b593bd$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e474b00e84b593bd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e474b00e84b593bd$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e474b00e84b593bd$var$_toPropertyKey(t) {
    var i = $e474b00e84b593bd$var$_toPrimitive(t, "string");
    return "symbol" == $e474b00e84b593bd$var$_typeof(i) ? i : i + "";
}
function $e474b00e84b593bd$var$_toPrimitive(t, r) {
    if ("object" != $e474b00e84b593bd$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e474b00e84b593bd$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $e474b00e84b593bd$var$MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $e474b00e84b593bd$var$ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $e474b00e84b593bd$var$CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/;
var $e474b00e84b593bd$var$NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var $e474b00e84b593bd$var$CONVERSION_RATES = {
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    pt: 96 / 72,
    pc: 16,
    "in": 96,
    Q: 96 / 101.6,
    px: 1
};
var $e474b00e84b593bd$var$FIXED_CSS_LENGTH_UNITS = Object.keys($e474b00e84b593bd$var$CONVERSION_RATES);
var $e474b00e84b593bd$var$STR_NAN = 'NaN';
function $e474b00e84b593bd$var$convertToPx(value, unit) {
    return value * $e474b00e84b593bd$var$CONVERSION_RATES[unit];
}
var $e474b00e84b593bd$var$DecimalCSS = /*#__PURE__*/ function() {
    function DecimalCSS(num, unit) {
        $e474b00e84b593bd$var$_classCallCheck(this, DecimalCSS);
        this.num = num;
        this.unit = unit;
        this.num = num;
        this.unit = unit;
        if (Number.isNaN(num)) this.unit = '';
        if (unit !== '' && !$e474b00e84b593bd$var$CSS_LENGTH_UNIT_REGEX.test(unit)) {
            this.num = NaN;
            this.unit = '';
        }
        if ($e474b00e84b593bd$var$FIXED_CSS_LENGTH_UNITS.includes(unit)) {
            this.num = $e474b00e84b593bd$var$convertToPx(num, unit);
            this.unit = 'px';
        }
    }
    return $e474b00e84b593bd$var$_createClass(DecimalCSS, [
        {
            key: "add",
            value: function add(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num + other.num, this.unit);
            }
        },
        {
            key: "subtract",
            value: function subtract(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num - other.num, this.unit);
            }
        },
        {
            key: "multiply",
            value: function multiply(other) {
                if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num * other.num, this.unit || other.unit);
            }
        },
        {
            key: "divide",
            value: function divide(other) {
                if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
                return new DecimalCSS(this.num / other.num, this.unit || other.unit);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.num).concat(this.unit);
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.num);
            }
        }
    ], [
        {
            key: "parse",
            value: function parse(str) {
                var _NUM_SPLIT_REGEX$exec;
                var _ref = (_NUM_SPLIT_REGEX$exec = $e474b00e84b593bd$var$NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [], _ref2 = $e474b00e84b593bd$var$_slicedToArray(_ref, 3), numStr = _ref2[1], unit = _ref2[2];
                return new DecimalCSS(parseFloat(numStr), unit !== null && unit !== void 0 ? unit : '');
            }
        }
    ]);
}();
function $e474b00e84b593bd$var$calculateArithmetic(expr) {
    if (expr.includes($e474b00e84b593bd$var$STR_NAN)) return $e474b00e84b593bd$var$STR_NAN;
    var newExpr = expr;
    while(newExpr.includes('*') || newExpr.includes('/')){
        var _MULTIPLY_OR_DIVIDE_R;
        var _ref3 = (_MULTIPLY_OR_DIVIDE_R = $e474b00e84b593bd$var$MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [], _ref4 = $e474b00e84b593bd$var$_slicedToArray(_ref3, 4), leftOperand = _ref4[1], operator = _ref4[2], rightOperand = _ref4[3];
        var lTs = $e474b00e84b593bd$var$DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : '');
        var rTs = $e474b00e84b593bd$var$DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : '');
        var result = operator === '*' ? lTs.multiply(rTs) : lTs.divide(rTs);
        if (result.isNaN()) return $e474b00e84b593bd$var$STR_NAN;
        newExpr = newExpr.replace($e474b00e84b593bd$var$MULTIPLY_OR_DIVIDE_REGEX, result.toString());
    }
    while(newExpr.includes('+') || /.-\d+(?:\.\d+)?/.test(newExpr)){
        var _ADD_OR_SUBTRACT_REGE;
        var _ref5 = (_ADD_OR_SUBTRACT_REGE = $e474b00e84b593bd$var$ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [], _ref6 = $e474b00e84b593bd$var$_slicedToArray(_ref5, 4), _leftOperand = _ref6[1], _operator = _ref6[2], _rightOperand = _ref6[3];
        var _lTs = $e474b00e84b593bd$var$DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : '');
        var _rTs = $e474b00e84b593bd$var$DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : '');
        var _result = _operator === '+' ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
        if (_result.isNaN()) return $e474b00e84b593bd$var$STR_NAN;
        newExpr = newExpr.replace($e474b00e84b593bd$var$ADD_OR_SUBTRACT_REGEX, _result.toString());
    }
    return newExpr;
}
var $e474b00e84b593bd$var$PARENTHESES_REGEX = /\(([^()]*)\)/;
function $e474b00e84b593bd$var$calculateParentheses(expr) {
    var newExpr = expr;
    while(newExpr.includes('(')){
        var _PARENTHESES_REGEX$ex = $e474b00e84b593bd$var$PARENTHESES_REGEX.exec(newExpr), _PARENTHESES_REGEX$ex2 = $e474b00e84b593bd$var$_slicedToArray(_PARENTHESES_REGEX$ex, 2), parentheticalExpression = _PARENTHESES_REGEX$ex2[1];
        newExpr = newExpr.replace($e474b00e84b593bd$var$PARENTHESES_REGEX, $e474b00e84b593bd$var$calculateArithmetic(parentheticalExpression));
    }
    return newExpr;
}
function $e474b00e84b593bd$var$evaluateExpression(expression) {
    var newExpr = expression.replace(/\s+/g, '');
    newExpr = $e474b00e84b593bd$var$calculateParentheses(newExpr);
    newExpr = $e474b00e84b593bd$var$calculateArithmetic(newExpr);
    return newExpr;
}
function $e474b00e84b593bd$export$c891f73c9c6d00c9(expression) {
    try {
        return $e474b00e84b593bd$var$evaluateExpression(expression);
    } catch (e) {
        /* istanbul ignore next */ return $e474b00e84b593bd$var$STR_NAN;
    }
}
function $e474b00e84b593bd$export$254eac204f89fd7d(expression) {
    var result = $e474b00e84b593bd$export$c891f73c9c6d00c9(expression.slice(5, -1));
    if (result === $e474b00e84b593bd$var$STR_NAN) // notify the user
    return '';
    return result;
}


var $46eed3e26c0880f0$var$_excluded = [
    "x",
    "y",
    "lineHeight",
    "capHeight",
    "scaleToFit",
    "textAnchor",
    "verticalAnchor",
    "fill"
], $46eed3e26c0880f0$var$_excluded2 = [
    "dx",
    "dy",
    "angle",
    "className",
    "breakAll"
];
function $46eed3e26c0880f0$var$_extends() {
    $46eed3e26c0880f0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $46eed3e26c0880f0$var$_extends.apply(this, arguments);
}
function $46eed3e26c0880f0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $46eed3e26c0880f0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $46eed3e26c0880f0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $46eed3e26c0880f0$var$_slicedToArray(arr, i) {
    return $46eed3e26c0880f0$var$_arrayWithHoles(arr) || $46eed3e26c0880f0$var$_iterableToArrayLimit(arr, i) || $46eed3e26c0880f0$var$_unsupportedIterableToArray(arr, i) || $46eed3e26c0880f0$var$_nonIterableRest();
}
function $46eed3e26c0880f0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $46eed3e26c0880f0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $46eed3e26c0880f0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $46eed3e26c0880f0$var$_arrayLikeToArray(o, minLen);
}
function $46eed3e26c0880f0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $46eed3e26c0880f0$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $46eed3e26c0880f0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $46eed3e26c0880f0$var$BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var $46eed3e26c0880f0$var$calculateWordWidths = function calculateWordWidths(_ref) {
    var children = _ref.children, breakAll = _ref.breakAll, style = _ref.style;
    try {
        var words = [];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(children)) {
            if (breakAll) words = children.toString().split('');
            else words = children.toString().split($46eed3e26c0880f0$var$BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map(function(word) {
            return {
                word: word,
                width: (0, $cf8622a67b6f7493$export$e5560531f057ad5d)(word, style).width
            };
        });
        var spaceWidth = breakAll ? 0 : (0, $cf8622a67b6f7493$export$e5560531f057ad5d)("\xA0", style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (e) {
        return null;
    }
};
var $46eed3e26c0880f0$var$calculateWordsByLines = function calculateWordsByLines(_ref2, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
    var maxLines = _ref2.maxLines, children = _ref2.children, style = _ref2.style, breakAll = _ref2.breakAll;
    var shouldLimitLines = (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(maxLines);
    var text = children;
    var calculate = function calculate() {
        var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return words.reduce(function(result, _ref3) {
            var word = _ref3.word, width = _ref3.width;
            var currentLine = result[result.length - 1];
            if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
                // Word can be added to an existing line
                currentLine.words.push(word);
                currentLine.width += width + spaceWidth;
            } else {
                // Add first word to line or word is too long to scaleToFit on existing line
                var newLine = {
                    words: [
                        word
                    ],
                    width: width
                };
                result.push(newLine);
            }
            return result;
        }, []);
    };
    var originalResult = calculate(initialWordsWithComputedWith);
    var findLongestLine = function findLongestLine(words) {
        return words.reduce(function(a, b) {
            return a.width > b.width ? a : b;
        });
    };
    if (!shouldLimitLines) return originalResult;
    var suffix = "\u2026";
    var checkOverflow = function checkOverflow(index) {
        var tempText = text.slice(0, index);
        var words = $46eed3e26c0880f0$var$calculateWordWidths({
            breakAll: breakAll,
            style: style,
            children: tempText + suffix
        }).wordsWithComputedWidth;
        var result = calculate(words);
        var doesOverflow = result.length > maxLines || findLongestLine(result).width > Number(lineWidth);
        return [
            doesOverflow,
            result
        ];
    };
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var _checkOverflow = checkOverflow(prev), _checkOverflow2 = $46eed3e26c0880f0$var$_slicedToArray(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
        var _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = $46eed3e26c0880f0$var$_slicedToArray(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var $46eed3e26c0880f0$var$getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
    var words = !(0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(children) ? children.toString().split($46eed3e26c0880f0$var$BREAKING_SPACES) : [];
    return [
        {
            words: words
        }
    ];
};
var $46eed3e26c0880f0$var$getWordsByLines = function getWordsByLines(_ref4) {
    var width = _ref4.width, scaleToFit = _ref4.scaleToFit, children = _ref4.children, style = _ref4.style, breakAll = _ref4.breakAll, maxLines = _ref4.maxLines;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, $809421885870cd36$export$98f03c5d19621d70).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = $46eed3e26c0880f0$var$calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return $46eed3e26c0880f0$var$getWordsWithoutCalculate(children);
        return $46eed3e26c0880f0$var$calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, scaleToFit);
    }
    return $46eed3e26c0880f0$var$getWordsWithoutCalculate(children);
};
var $46eed3e26c0880f0$var$DEFAULT_FILL = '#808080';
var $46eed3e26c0880f0$export$5f1af8db9871e1d6 = function Text(_ref5) {
    var _ref5$x = _ref5.x, propsX = _ref5$x === void 0 ? 0 : _ref5$x, _ref5$y = _ref5.y, propsY = _ref5$y === void 0 ? 0 : _ref5$y, _ref5$lineHeight = _ref5.lineHeight, lineHeight = _ref5$lineHeight === void 0 ? '1em' : _ref5$lineHeight, _ref5$capHeight = _ref5.capHeight, capHeight = _ref5$capHeight === void 0 ? '0.71em' : _ref5$capHeight, _ref5$scaleToFit = _ref5.scaleToFit, scaleToFit = _ref5$scaleToFit === void 0 ? false : _ref5$scaleToFit, _ref5$textAnchor = _ref5.textAnchor, textAnchor = _ref5$textAnchor === void 0 ? 'start' : _ref5$textAnchor, _ref5$verticalAnchor = _ref5.verticalAnchor, verticalAnchor = _ref5$verticalAnchor === void 0 ? 'end' : _ref5$verticalAnchor, _ref5$fill = _ref5.fill, fill = _ref5$fill === void 0 ? $46eed3e26c0880f0$var$DEFAULT_FILL : _ref5$fill, props = $46eed3e26c0880f0$var$_objectWithoutProperties(_ref5, $46eed3e26c0880f0$var$_excluded);
    var wordsByLines = (0, $8T3gX.useMemo)(function() {
        return $46eed3e26c0880f0$var$getWordsByLines({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        scaleToFit,
        props.style,
        props.width
    ]);
    var dx = props.dx, dy = props.dy, angle = props.angle, className = props.className, breakAll = props.breakAll, textProps = $46eed3e26c0880f0$var$_objectWithoutProperties(props, $46eed3e26c0880f0$var$_excluded2);
    if (!(0, $ec351366ffe25ce6$export$402a499e1ea44294)(propsX) || !(0, $ec351366ffe25ce6$export$402a499e1ea44294)(propsY)) return null;
    var x = propsX + ((0, $ec351366ffe25ce6$export$7e4aa119212bc614)(dx) ? dx : 0);
    var y = propsY + ((0, $ec351366ffe25ce6$export$7e4aa119212bc614)(dy) ? dy : 0);
    var startDy;
    switch(verticalAnchor){
        case 'start':
            startDy = (0, $e474b00e84b593bd$export$254eac204f89fd7d)("calc(".concat(capHeight, ")"));
            break;
        case 'middle':
            startDy = (0, $e474b00e84b593bd$export$254eac204f89fd7d)("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, $e474b00e84b593bd$export$254eac204f89fd7d)("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        var width = props.width;
        transforms.push("scale(".concat(((0, $ec351366ffe25ce6$export$7e4aa119212bc614)(width) ? width / lineWidth : 1) / lineWidth, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(' ');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("text", $46eed3e26c0880f0$var$_extends({}, (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(textProps, true), {
        x: x,
        y: y,
        className: (0, $iVyaN.default)('recharts-text', className),
        textAnchor: textAnchor,
        fill: fill.includes('url') ? $46eed3e26c0880f0$var$DEFAULT_FILL : fill
    }), wordsByLines.map(function(line, index) {
        var words = line.words.join(breakAll ? '' : ' ');
        return(/*#__PURE__*/ // duplicate words will cause duplicate keys
        // eslint-disable-next-line react/no-array-index-key
        (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: "".concat(words, "-").concat(index)
        }, words));
    }));
};






var $8T3gX = parcelRequire("8T3gX");


var $56a5f1c61b5282e1$exports = {};
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$56a5f1c61b5282e1$exports = (parcelRequire("hK0qV"));


var $40ccc67e29ee0e40$exports = {};
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$40ccc67e29ee0e40$exports = (parcelRequire("3kTGk"));


var $70218499e448ea52$exports = {};
var $0eb0c4e323f34f75$exports = {};

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $0eb0c4e323f34f75$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$193702f8737ef12b$exports(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
$0eb0c4e323f34f75$exports = $0eb0c4e323f34f75$var$baseExtremum;


var $ea8bcbd0b5c15ef7$exports = {};
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $ea8bcbd0b5c15ef7$var$baseGt(value, other) {
    return value > other;
}
$ea8bcbd0b5c15ef7$exports = $ea8bcbd0b5c15ef7$var$baseGt;


var $30121ce9c4b4eb3d$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $30121ce9c4b4eb3d$var$identity(value) {
    return value;
}
$30121ce9c4b4eb3d$exports = $30121ce9c4b4eb3d$var$identity;


/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $70218499e448ea52$var$max(array) {
    return array && array.length ? $0eb0c4e323f34f75$exports(array, $30121ce9c4b4eb3d$exports, $ea8bcbd0b5c15ef7$exports) : undefined;
}
$70218499e448ea52$exports = $70218499e448ea52$var$max;


var $d30612692dabe970$exports = {};

var $6aca1bbaaba76f68$exports = {};
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $6aca1bbaaba76f68$var$baseLt(value, other) {
    return value < other;
}
$6aca1bbaaba76f68$exports = $6aca1bbaaba76f68$var$baseLt;



/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $d30612692dabe970$var$min(array) {
    return array && array.length ? $0eb0c4e323f34f75$exports(array, $30121ce9c4b4eb3d$exports, $6aca1bbaaba76f68$exports) : undefined;
}
$d30612692dabe970$exports = $d30612692dabe970$var$min;






var $d7f8215938131932$exports = {};
var $f9578710aaa0eee6$exports = {};

var $e799fb37cc1f1ae8$exports = {};



/** Built-in value references. */ var $e799fb37cc1f1ae8$var$spreadableSymbol = $29a029238437d6de$exports ? $29a029238437d6de$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $e799fb37cc1f1ae8$var$isFlattenable(value) {
    return $b47d971f66a6f054$exports(value) || $343d561a7d6a3b42$exports(value) || !!($e799fb37cc1f1ae8$var$spreadableSymbol && value && value[$e799fb37cc1f1ae8$var$spreadableSymbol]);
}
$e799fb37cc1f1ae8$exports = $e799fb37cc1f1ae8$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $f9578710aaa0eee6$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $e799fb37cc1f1ae8$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $f9578710aaa0eee6$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $3bf95b782724c68c$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$f9578710aaa0eee6$exports = $f9578710aaa0eee6$var$baseFlatten;


var $fe7123de84c36863$exports = {};

var $9dd1d38dfe69ddcf$exports = {};
var $5d8d0bf2708d1398$exports = {};
var $2d9d6e3f255e1c55$exports = {};


/** Used to compose bitmasks for value comparisons. */ var $2d9d6e3f255e1c55$var$COMPARE_PARTIAL_FLAG = 1, $2d9d6e3f255e1c55$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $2d9d6e3f255e1c55$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $861d1b63d8478a81$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $8ad758ceb849e9eb$exports(srcValue, objValue, $2d9d6e3f255e1c55$var$COMPARE_PARTIAL_FLAG | $2d9d6e3f255e1c55$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$2d9d6e3f255e1c55$exports = $2d9d6e3f255e1c55$var$baseIsMatch;


var $408a77f431c35515$exports = {};
var $24ee6f8381d21d53$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $24ee6f8381d21d53$var$isStrictComparable(value) {
    return value === value && !$cd2b0b1294af0960$exports(value);
}
$24ee6f8381d21d53$exports = $24ee6f8381d21d53$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $408a77f431c35515$var$getMatchData(object) {
    var result = $9c7d1fa85e24a67e$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $24ee6f8381d21d53$exports(value)
        ];
    }
    return result;
}
$408a77f431c35515$exports = $408a77f431c35515$var$getMatchData;


var $d36ae16033f20bf3$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $d36ae16033f20bf3$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$d36ae16033f20bf3$exports = $d36ae16033f20bf3$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $5d8d0bf2708d1398$var$baseMatches(source) {
    var matchData = $408a77f431c35515$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $d36ae16033f20bf3$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $2d9d6e3f255e1c55$exports(object, source, matchData);
    };
}
$5d8d0bf2708d1398$exports = $5d8d0bf2708d1398$var$baseMatches;


var $69125bc30b33891f$exports = {};


var $029d15c9e3b4deab$exports = {};
var $ae1d3982bc9cc8a8$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $ae1d3982bc9cc8a8$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$ae1d3982bc9cc8a8$exports = $ae1d3982bc9cc8a8$var$baseHasIn;


var $eb3af6a59d7130a0$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $eb3af6a59d7130a0$var$hasPath(object, path, hasFunc) {
    path = $5f248967e32df0c1$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $4bf6972158fbafc8$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $27f0a97b97c49daa$exports(length) && $c60ce55ccfd38e2a$exports(key, length) && ($b47d971f66a6f054$exports(object) || $343d561a7d6a3b42$exports(object));
}
$eb3af6a59d7130a0$exports = $eb3af6a59d7130a0$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $029d15c9e3b4deab$var$hasIn(object, path) {
    return object != null && $eb3af6a59d7130a0$exports(object, path, $ae1d3982bc9cc8a8$exports);
}
$029d15c9e3b4deab$exports = $029d15c9e3b4deab$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $69125bc30b33891f$var$COMPARE_PARTIAL_FLAG = 1, $69125bc30b33891f$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $69125bc30b33891f$var$baseMatchesProperty(path, srcValue) {
    if ($32fa1f4d8228ffde$exports(path) && $24ee6f8381d21d53$exports(srcValue)) return $d36ae16033f20bf3$exports($4bf6972158fbafc8$exports(path), srcValue);
    return function(object) {
        var objValue = $eb02300d30d6bdcb$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $029d15c9e3b4deab$exports(object, path) : $8ad758ceb849e9eb$exports(srcValue, objValue, $69125bc30b33891f$var$COMPARE_PARTIAL_FLAG | $69125bc30b33891f$var$COMPARE_UNORDERED_FLAG);
    };
}
$69125bc30b33891f$exports = $69125bc30b33891f$var$baseMatchesProperty;




var $bd112cd1a4525cec$exports = {};
var $989c41a7f058035c$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $989c41a7f058035c$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$989c41a7f058035c$exports = $989c41a7f058035c$var$baseProperty;


var $2b33052c26df4562$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $2b33052c26df4562$var$basePropertyDeep(path) {
    return function(object) {
        return $7bff94b74b05cdba$exports(object, path);
    };
}
$2b33052c26df4562$exports = $2b33052c26df4562$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $bd112cd1a4525cec$var$property(path) {
    return $32fa1f4d8228ffde$exports(path) ? $989c41a7f058035c$exports($4bf6972158fbafc8$exports(path)) : $2b33052c26df4562$exports(path);
}
$bd112cd1a4525cec$exports = $bd112cd1a4525cec$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $9dd1d38dfe69ddcf$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $30121ce9c4b4eb3d$exports;
    if (typeof value == 'object') return $b47d971f66a6f054$exports(value) ? $69125bc30b33891f$exports(value[0], value[1]) : $5d8d0bf2708d1398$exports(value);
    return $bd112cd1a4525cec$exports(value);
}
$9dd1d38dfe69ddcf$exports = $9dd1d38dfe69ddcf$var$baseIteratee;


var $de0a1f9ad102f4c6$exports = {};
var $fc4011160035cb96$exports = {};
var $b8b184dbd2d79b13$exports = {};
var $e9e0f6175c094900$exports = {};
var $dd860dd02794d46b$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $dd860dd02794d46b$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$dd860dd02794d46b$exports = $dd860dd02794d46b$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $e9e0f6175c094900$var$baseFor = $dd860dd02794d46b$exports();
$e9e0f6175c094900$exports = $e9e0f6175c094900$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $b8b184dbd2d79b13$var$baseForOwn(object, iteratee) {
    return object && $e9e0f6175c094900$exports(object, iteratee, $9c7d1fa85e24a67e$exports);
}
$b8b184dbd2d79b13$exports = $b8b184dbd2d79b13$var$baseForOwn;


var $d1a8b7ac9f09109f$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $d1a8b7ac9f09109f$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$edace719698f1e70$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$d1a8b7ac9f09109f$exports = $d1a8b7ac9f09109f$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $fc4011160035cb96$var$baseEach = $d1a8b7ac9f09109f$exports($b8b184dbd2d79b13$exports);
$fc4011160035cb96$exports = $fc4011160035cb96$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $de0a1f9ad102f4c6$var$baseMap(collection, iteratee) {
    var index = -1, result = $edace719698f1e70$exports(collection) ? Array(collection.length) : [];
    $fc4011160035cb96$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$de0a1f9ad102f4c6$exports = $de0a1f9ad102f4c6$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $fe7123de84c36863$var$map(collection, iteratee) {
    var func = $b47d971f66a6f054$exports(collection) ? $95a41775a4f282b8$exports : $de0a1f9ad102f4c6$exports;
    return func(collection, $9dd1d38dfe69ddcf$exports(iteratee, 3));
}
$fe7123de84c36863$exports = $fe7123de84c36863$var$map;


/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $d7f8215938131932$var$flatMap(collection, iteratee) {
    return $f9578710aaa0eee6$exports($fe7123de84c36863$exports(collection, iteratee), 1);
}
$d7f8215938131932$exports = $d7f8215938131932$var$flatMap;



var $7808c9375de28fec$exports = {};
var $df44d154f923fa11$exports = {};
var $ebe801ef62adbbc1$exports = {};
var $0e19f04a90e03e02$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $0e19f04a90e03e02$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$0e19f04a90e03e02$exports = $0e19f04a90e03e02$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $ebe801ef62adbbc1$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $0e19f04a90e03e02$exports(array, start, end);
}
$ebe801ef62adbbc1$exports = $ebe801ef62adbbc1$var$castSlice;


var $717155b8e4c94c08$exports = {};
/** Used to compose unicode character classes. */ var $717155b8e4c94c08$var$rsAstralRange = '\\ud800-\\udfff', $717155b8e4c94c08$var$rsComboMarksRange = '\\u0300-\\u036f', $717155b8e4c94c08$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $717155b8e4c94c08$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $717155b8e4c94c08$var$rsComboRange = $717155b8e4c94c08$var$rsComboMarksRange + $717155b8e4c94c08$var$reComboHalfMarksRange + $717155b8e4c94c08$var$rsComboSymbolsRange, $717155b8e4c94c08$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $717155b8e4c94c08$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $717155b8e4c94c08$var$reHasUnicode = RegExp('[' + $717155b8e4c94c08$var$rsZWJ + $717155b8e4c94c08$var$rsAstralRange + $717155b8e4c94c08$var$rsComboRange + $717155b8e4c94c08$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $717155b8e4c94c08$var$hasUnicode(string) {
    return $717155b8e4c94c08$var$reHasUnicode.test(string);
}
$717155b8e4c94c08$exports = $717155b8e4c94c08$var$hasUnicode;


var $b763529d918ebe20$exports = {};
var $566788d71c31d357$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $566788d71c31d357$var$asciiToArray(string) {
    return string.split('');
}
$566788d71c31d357$exports = $566788d71c31d357$var$asciiToArray;



var $1108c93b94ae6e12$exports = {};
/** Used to compose unicode character classes. */ var $1108c93b94ae6e12$var$rsAstralRange = '\\ud800-\\udfff', $1108c93b94ae6e12$var$rsComboMarksRange = '\\u0300-\\u036f', $1108c93b94ae6e12$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $1108c93b94ae6e12$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $1108c93b94ae6e12$var$rsComboRange = $1108c93b94ae6e12$var$rsComboMarksRange + $1108c93b94ae6e12$var$reComboHalfMarksRange + $1108c93b94ae6e12$var$rsComboSymbolsRange, $1108c93b94ae6e12$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $1108c93b94ae6e12$var$rsAstral = '[' + $1108c93b94ae6e12$var$rsAstralRange + ']', $1108c93b94ae6e12$var$rsCombo = '[' + $1108c93b94ae6e12$var$rsComboRange + ']', $1108c93b94ae6e12$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $1108c93b94ae6e12$var$rsModifier = '(?:' + $1108c93b94ae6e12$var$rsCombo + '|' + $1108c93b94ae6e12$var$rsFitz + ')', $1108c93b94ae6e12$var$rsNonAstral = '[^' + $1108c93b94ae6e12$var$rsAstralRange + ']', $1108c93b94ae6e12$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $1108c93b94ae6e12$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $1108c93b94ae6e12$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $1108c93b94ae6e12$var$reOptMod = $1108c93b94ae6e12$var$rsModifier + '?', $1108c93b94ae6e12$var$rsOptVar = '[' + $1108c93b94ae6e12$var$rsVarRange + ']?', $1108c93b94ae6e12$var$rsOptJoin = '(?:' + $1108c93b94ae6e12$var$rsZWJ + '(?:' + [
    $1108c93b94ae6e12$var$rsNonAstral,
    $1108c93b94ae6e12$var$rsRegional,
    $1108c93b94ae6e12$var$rsSurrPair
].join('|') + ')' + $1108c93b94ae6e12$var$rsOptVar + $1108c93b94ae6e12$var$reOptMod + ')*', $1108c93b94ae6e12$var$rsSeq = $1108c93b94ae6e12$var$rsOptVar + $1108c93b94ae6e12$var$reOptMod + $1108c93b94ae6e12$var$rsOptJoin, $1108c93b94ae6e12$var$rsSymbol = '(?:' + [
    $1108c93b94ae6e12$var$rsNonAstral + $1108c93b94ae6e12$var$rsCombo + '?',
    $1108c93b94ae6e12$var$rsCombo,
    $1108c93b94ae6e12$var$rsRegional,
    $1108c93b94ae6e12$var$rsSurrPair,
    $1108c93b94ae6e12$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $1108c93b94ae6e12$var$reUnicode = RegExp($1108c93b94ae6e12$var$rsFitz + '(?=' + $1108c93b94ae6e12$var$rsFitz + ')|' + $1108c93b94ae6e12$var$rsSymbol + $1108c93b94ae6e12$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $1108c93b94ae6e12$var$unicodeToArray(string) {
    return string.match($1108c93b94ae6e12$var$reUnicode) || [];
}
$1108c93b94ae6e12$exports = $1108c93b94ae6e12$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $b763529d918ebe20$var$stringToArray(string) {
    return $717155b8e4c94c08$exports(string) ? $1108c93b94ae6e12$exports(string) : $566788d71c31d357$exports(string);
}
$b763529d918ebe20$exports = $b763529d918ebe20$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $df44d154f923fa11$var$createCaseFirst(methodName) {
    return function(string) {
        string = $4360b921cc50ac20$exports(string);
        var strSymbols = $717155b8e4c94c08$exports(string) ? $b763529d918ebe20$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $ebe801ef62adbbc1$exports(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$df44d154f923fa11$exports = $df44d154f923fa11$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $7808c9375de28fec$var$upperFirst = $df44d154f923fa11$exports('toUpperCase');
$7808c9375de28fec$exports = $7808c9375de28fec$var$upperFirst;



var $e2540731f2bf6197$exports = {};

var $c94e7b06b8e313f6$exports = {};




var $b9b9dff48b295ca5$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $b9b9dff48b295ca5$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$b9b9dff48b295ca5$exports = $b9b9dff48b295ca5$var$baseSortBy;



var $88e08f958f59c713$exports = {};
var $70789da24f6478d5$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $70789da24f6478d5$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $193702f8737ef12b$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $193702f8737ef12b$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$70789da24f6478d5$exports = $70789da24f6478d5$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $88e08f958f59c713$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $70789da24f6478d5$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$88e08f958f59c713$exports = $88e08f958f59c713$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $c94e7b06b8e313f6$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $95a41775a4f282b8$exports(iteratees, function(iteratee) {
        if ($b47d971f66a6f054$exports(iteratee)) return function(value) {
            return $7bff94b74b05cdba$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $30121ce9c4b4eb3d$exports
    ];
    var index = -1;
    iteratees = $95a41775a4f282b8$exports(iteratees, $259a13e6311f4b7a$exports($9dd1d38dfe69ddcf$exports));
    var result = $de0a1f9ad102f4c6$exports(collection, function(value, key, collection) {
        var criteria = $95a41775a4f282b8$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $b9b9dff48b295ca5$exports(result, function(object, other) {
        return $88e08f958f59c713$exports(object, other, orders);
    });
}
$c94e7b06b8e313f6$exports = $c94e7b06b8e313f6$var$baseOrderBy;


var $3432652d35d8dc24$exports = {};

var $8f23d6c287483fb1$exports = {};
var $255ecd28778da441$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $255ecd28778da441$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$255ecd28778da441$exports = $255ecd28778da441$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $8f23d6c287483fb1$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $8f23d6c287483fb1$var$overRest(func, start, transform) {
    start = $8f23d6c287483fb1$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $8f23d6c287483fb1$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $255ecd28778da441$exports(func, this, otherArgs);
    };
}
$8f23d6c287483fb1$exports = $8f23d6c287483fb1$var$overRest;


var $734501f4df78661a$exports = {};
var $4a28569ea83baadb$exports = {};
var $8c05603d1b1154c7$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $8c05603d1b1154c7$var$constant(value) {
    return function() {
        return value;
    };
}
$8c05603d1b1154c7$exports = $8c05603d1b1154c7$var$constant;


var $38fd38fdd95df333$exports = {};

var $38fd38fdd95df333$var$defineProperty = function() {
    try {
        var func = $7899283e38926019$exports(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$38fd38fdd95df333$exports = $38fd38fdd95df333$var$defineProperty;



/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $4a28569ea83baadb$var$baseSetToString = !$38fd38fdd95df333$exports ? $30121ce9c4b4eb3d$exports : function(func, string) {
    return $38fd38fdd95df333$exports(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $8c05603d1b1154c7$exports(string),
        'writable': true
    });
};
$4a28569ea83baadb$exports = $4a28569ea83baadb$var$baseSetToString;


var $48dec04e06444fc8$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $48dec04e06444fc8$var$HOT_COUNT = 800, $48dec04e06444fc8$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $48dec04e06444fc8$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $48dec04e06444fc8$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $48dec04e06444fc8$var$nativeNow(), remaining = $48dec04e06444fc8$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $48dec04e06444fc8$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$48dec04e06444fc8$exports = $48dec04e06444fc8$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $734501f4df78661a$var$setToString = $48dec04e06444fc8$exports($4a28569ea83baadb$exports);
$734501f4df78661a$exports = $734501f4df78661a$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $3432652d35d8dc24$var$baseRest(func, start) {
    return $734501f4df78661a$exports($8f23d6c287483fb1$exports(func, start, $30121ce9c4b4eb3d$exports), func + '');
}
$3432652d35d8dc24$exports = $3432652d35d8dc24$var$baseRest;


var $f5d86346a533d383$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $f5d86346a533d383$var$isIterateeCall(value, index, object) {
    if (!$cd2b0b1294af0960$exports(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $edace719698f1e70$exports(object) && $c60ce55ccfd38e2a$exports(index, object.length) : type == 'string' && index in object) return $ba1c04d40f072e77$exports(object[index], value);
    return false;
}
$f5d86346a533d383$exports = $f5d86346a533d383$var$isIterateeCall;


/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $e2540731f2bf6197$var$sortBy = $3432652d35d8dc24$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $f5d86346a533d383$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $f5d86346a533d383$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $c94e7b06b8e313f6$exports(collection, $f9578710aaa0eee6$exports(iteratees, 1), []);
});
$e2540731f2bf6197$exports = $e2540731f2bf6197$var$sortBy;


var $7997f99eb3137523$exports = {};
/*! decimal.js-light v2.5.1 https://github.com/MikeMcl/decimal.js-light/LICENCE */ (function(globalScope) {
    'use strict';
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = '[DecimalError] ', invalidArgument = decimalError + 'Invalid argument: ', exponentOutOfRange = decimalError + 'Exponent out of range: ', mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + 'NaN');
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + 'NaN');
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += '0';
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != '9999') break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + 'Infinity');
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + 'NaN');
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + '';
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + '';
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return '0';
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + 'Division by zero');
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + 'LN10 precision limit exceeded');
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = '';
        for(; k--;)zs += '0';
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor('0.' + c);
                e++;
            } else x = new Ctor(c0 + '.' + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + '');
            x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += '0';
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
            str = str + (e < 0 ? 'e' : 'e+') + e;
        } else if (e < 0) {
            str = '0.' + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += '.';
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? '-' + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === 'number') {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== 'string') throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                'precision',
                'rounding',
                'toExpNeg',
                'toExpPos',
                'LN10'
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
        var i, p, v, ps = [
            'precision',
            1,
            MAX_DIGITS,
            'rounding',
            0,
            8,
            'toExpNeg',
            -1 / 0,
            0,
            'toExpPos',
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ': ' + v);
        }
        if ((v = obj[p = 'LN10']) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ': ' + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal['default'] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return Decimal;
    });
    else if ($7997f99eb3137523$exports) $7997f99eb3137523$exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != 'undefined' && self && self.self == self ? self : Function('return this')();
        globalScope.Decimal = Decimal;
    }
})($7997f99eb3137523$exports);


function $f6138b441fe37193$var$_toConsumableArray(arr) {
    return $f6138b441fe37193$var$_arrayWithoutHoles(arr) || $f6138b441fe37193$var$_iterableToArray(arr) || $f6138b441fe37193$var$_unsupportedIterableToArray(arr) || $f6138b441fe37193$var$_nonIterableSpread();
}
function $f6138b441fe37193$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f6138b441fe37193$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f6138b441fe37193$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f6138b441fe37193$var$_arrayLikeToArray(o, minLen);
}
function $f6138b441fe37193$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $f6138b441fe37193$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $f6138b441fe37193$var$_arrayLikeToArray(arr);
}
function $f6138b441fe37193$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $f6138b441fe37193$var$identity = function identity(i) {
    return i;
};
var $f6138b441fe37193$export$ca73b6d700d0505 = {
    '@@functional/placeholder': true
};
var $f6138b441fe37193$var$isPlaceHolder = function isPlaceHolder(val) {
    return val === $f6138b441fe37193$export$ca73b6d700d0505;
};
var $f6138b441fe37193$var$curry0 = function curry0(fn) {
    return function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && $f6138b441fe37193$var$isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn.apply(void 0, arguments);
    };
};
var $f6138b441fe37193$var$curryN = function curryN(n, fn) {
    if (n === 1) return fn;
    return $f6138b441fe37193$var$curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter(function(arg) {
            return arg !== $f6138b441fe37193$export$ca73b6d700d0505;
        }).length;
        if (argsLength >= n) return fn.apply(void 0, args);
        return curryN(n - argsLength, $f6138b441fe37193$var$curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map(function(arg) {
                return $f6138b441fe37193$var$isPlaceHolder(arg) ? restArgs.shift() : arg;
            });
            return fn.apply(void 0, $f6138b441fe37193$var$_toConsumableArray(newArgs).concat(restArgs));
        }));
    });
};
var $f6138b441fe37193$export$c3095a23b368d1f2 = function curry(fn) {
    return $f6138b441fe37193$var$curryN(fn.length, fn);
};
var $f6138b441fe37193$export$d02631cccf789723 = function range(begin, end) {
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var $f6138b441fe37193$export$871de8747c9eaa88 = $f6138b441fe37193$export$c3095a23b368d1f2(function(fn, arr) {
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map(function(key) {
        return arr[key];
    }).map(fn);
});
var $f6138b441fe37193$export$f672e0b6f7222cd7 = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return $f6138b441fe37193$var$identity;
    var fns = args.reverse(); // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $f6138b441fe37193$export$66c1ae025e96b4bc = function reverse(arr) {
    if (Array.isArray(arr)) return arr.reverse();
     // can be string
    return arr.split('').reverse.join('');
};
var $f6138b441fe37193$export$fc10aeed3a532e2a = function memoize(fn) {
    var lastArgs = null;
    var lastResult = null;
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        if (lastArgs && args.every(function(val, i) {
            return val === lastArgs[i];
        })) return lastResult;
        lastArgs = args;
        lastResult = fn.apply(void 0, args);
        return lastResult;
    };
};


/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */ 

/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */ function $700fec1742feb14b$var$getDigitCount(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */ function $700fec1742feb14b$var$rangeStep(start, end, step) {
    var num = new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(start);
    var i = 0;
    var result = []; // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */ var $700fec1742feb14b$var$interpolateNumber = (0, $f6138b441fe37193$export$c3095a23b368d1f2)(function(a, b, t) {
    var newA = +a;
    var newB = +b;
    return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */ var $700fec1742feb14b$var$uninterpolateNumber = (0, $f6138b441fe37193$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */ var $700fec1742feb14b$var$uninterpolateTruncation = (0, $f6138b441fe37193$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return Math.max(0, Math.min(1, (x - a) / diff));
});
var $700fec1742feb14b$export$2e2bcd8739ae039 = {
    rangeStep: $700fec1742feb14b$var$rangeStep,
    getDigitCount: $700fec1742feb14b$var$getDigitCount,
    interpolateNumber: $700fec1742feb14b$var$interpolateNumber,
    uninterpolateNumber: $700fec1742feb14b$var$uninterpolateNumber,
    uninterpolateTruncation: $700fec1742feb14b$var$uninterpolateTruncation
};


function $90aac6b8d65031a1$var$_toConsumableArray(arr) {
    return $90aac6b8d65031a1$var$_arrayWithoutHoles(arr) || $90aac6b8d65031a1$var$_iterableToArray(arr) || $90aac6b8d65031a1$var$_unsupportedIterableToArray(arr) || $90aac6b8d65031a1$var$_nonIterableSpread();
}
function $90aac6b8d65031a1$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $90aac6b8d65031a1$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $90aac6b8d65031a1$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $90aac6b8d65031a1$var$_arrayLikeToArray(arr);
}
function $90aac6b8d65031a1$var$_slicedToArray(arr, i) {
    return $90aac6b8d65031a1$var$_arrayWithHoles(arr) || $90aac6b8d65031a1$var$_iterableToArrayLimit(arr, i) || $90aac6b8d65031a1$var$_unsupportedIterableToArray(arr, i) || $90aac6b8d65031a1$var$_nonIterableRest();
}
function $90aac6b8d65031a1$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $90aac6b8d65031a1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $90aac6b8d65031a1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $90aac6b8d65031a1$var$_arrayLikeToArray(o, minLen);
}
function $90aac6b8d65031a1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $90aac6b8d65031a1$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $90aac6b8d65031a1$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */ function $90aac6b8d65031a1$var$getValidInterval(_ref) {
    var _ref2 = $90aac6b8d65031a1$var$_slicedToArray(_ref, 2), min = _ref2[0], max = _ref2[1];
    var validMin = min, validMax = max; // exchange
    if (min > max) {
        validMin = max;
        validMax = min;
    }
    return [
        validMin,
        validMax
    ];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */ function $90aac6b8d65031a1$var$getFormatStep(roughStep, allowDecimals, correctionFactor) {
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(0);
    var digitCount = (0, $700fec1742feb14b$export$2e2bcd8739ae039).getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? formatStep : new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */ function $90aac6b8d65031a1$var$getTickOfSingleValue(value, tickCount, allowDecimals) {
    var step = 1; // calculate the middle value of ticks
    var middle = new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(10).pow((0, $700fec1742feb14b$export$2e2bcd8739ae039).getDigitCount(value) - 1);
            middle = new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(Math.floor(value));
    } else if (value === 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, $f6138b441fe37193$export$f672e0b6f7222cd7)((0, $f6138b441fe37193$export$871de8747c9eaa88)(function(n) {
        return middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(n - middleIndex).mul(step)).toNumber();
    }), (0, $f6138b441fe37193$export$d02631cccf789723));
    return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */ function $90aac6b8d65031a1$var$calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(0),
        tickMin: new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(0),
        tickMax: new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(0)
    };
     // The step which is easy to understand between two ticks
    var step = $90aac6b8d65031a1$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
    var middle; // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(0);
    else {
        // calculate the middle value
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(min).add(max).div(2); // minus modulo value
        middle = middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return $90aac6b8d65031a1$var$calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(belowCount).mul(step)),
        tickMax: middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(upCount).mul(step))
    };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $90aac6b8d65031a1$var$getNiceTickValuesFn(_ref3) {
    var _ref4 = $90aac6b8d65031a1$var$_slicedToArray(_ref3, 2), min = _ref4[0], max = _ref4[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval = $90aac6b8d65031a1$var$getValidInterval([
        min,
        max
    ]), _getValidInterval2 = $90aac6b8d65031a1$var$_slicedToArray(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin
        ].concat($90aac6b8d65031a1$var$_toConsumableArray((0, $f6138b441fe37193$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return Infinity;
        }))) : [].concat($90aac6b8d65031a1$var$_toConsumableArray((0, $f6138b441fe37193$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return -Infinity;
        })), [
            cormax
        ]);
        return min > max ? (0, $f6138b441fe37193$export$66c1ae025e96b4bc)(_values) : _values;
    }
    if (cormin === cormax) return $90aac6b8d65031a1$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
     // Get the step between two ticks
    var _calculateStep = $90aac6b8d65031a1$var$calculateStep(cormin, cormax, count, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax;
    var values = (0, $700fec1742feb14b$export$2e2bcd8739ae039).rangeStep(tickMin, tickMax.add(new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(0.1).mul(step)), step);
    return min > max ? (0, $f6138b441fe37193$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $90aac6b8d65031a1$var$getTickValuesFn(_ref5) {
    var _ref6 = $90aac6b8d65031a1$var$_slicedToArray(_ref5, 2), min = _ref6[0], max = _ref6[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval3 = $90aac6b8d65031a1$var$getValidInterval([
        min,
        max
    ]), _getValidInterval4 = $90aac6b8d65031a1$var$_slicedToArray(_getValidInterval3, 2), cormin = _getValidInterval4[0], cormax = _getValidInterval4[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return $90aac6b8d65031a1$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
    var step = $90aac6b8d65031a1$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var fn = (0, $f6138b441fe37193$export$f672e0b6f7222cd7)((0, $f6138b441fe37193$export$871de8747c9eaa88)(function(n) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(cormin).add(new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(n).mul(step)).toNumber();
    }), (0, $f6138b441fe37193$export$d02631cccf789723));
    var values = fn(0, count).filter(function(entry) {
        return entry >= cormin && entry <= cormax;
    });
    return min > max ? (0, $f6138b441fe37193$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $90aac6b8d65031a1$var$getTickValuesFixedDomainFn(_ref7, tickCount) {
    var _ref8 = $90aac6b8d65031a1$var$_slicedToArray(_ref7, 2), min = _ref8[0], max = _ref8[1];
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var _getValidInterval5 = $90aac6b8d65031a1$var$getValidInterval([
        min,
        max
    ]), _getValidInterval6 = $90aac6b8d65031a1$var$_slicedToArray(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = $90aac6b8d65031a1$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [].concat($90aac6b8d65031a1$var$_toConsumableArray((0, $700fec1742feb14b$export$2e2bcd8739ae039).rangeStep(new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(cormin), new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(cormax).sub(new (0, (/*@__PURE__*/$parcel$interopDefault($7997f99eb3137523$exports)))(0.99).mul(step)), step)), [
        cormax
    ]);
    return min > max ? (0, $f6138b441fe37193$export$66c1ae025e96b4bc)(values) : values;
}
var $90aac6b8d65031a1$export$b84e75ccbfe6a612 = (0, $f6138b441fe37193$export$fc10aeed3a532e2a)($90aac6b8d65031a1$var$getNiceTickValuesFn);
var $90aac6b8d65031a1$export$4cc7a216492b1f53 = (0, $f6138b441fe37193$export$fc10aeed3a532e2a)($90aac6b8d65031a1$var$getTickValuesFn);
var $90aac6b8d65031a1$export$e9d28da780436e98 = (0, $f6138b441fe37193$export$fc10aeed3a532e2a)($90aac6b8d65031a1$var$getTickValuesFixedDomainFn);








var $8T3gX = parcelRequire("8T3gX");

var $8T3gX = parcelRequire("8T3gX");


var $iVyaN = parcelRequire("iVyaN");
/* eslint no-console: 0 */ var $a1b0f3d7b382d4a4$var$isDev = true;
var $a1b0f3d7b382d4a4$export$c106dd0671a0fc2d = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if ($a1b0f3d7b382d4a4$var$isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};



var $8T3gX = parcelRequire("8T3gX");

var $iVyaN = parcelRequire("iVyaN");

var $d2dcb066e7083be7$var$_excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style",
    "title",
    "desc"
];
function $d2dcb066e7083be7$var$_extends() {
    $d2dcb066e7083be7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d2dcb066e7083be7$var$_extends.apply(this, arguments);
}
function $d2dcb066e7083be7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d2dcb066e7083be7$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d2dcb066e7083be7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $d2dcb066e7083be7$export$7b92b459e668cb21(props) {
    var children = props.children, width = props.width, height = props.height, viewBox = props.viewBox, className = props.className, style = props.style, title = props.title, desc = props.desc, others = $d2dcb066e7083be7$var$_objectWithoutProperties(props, $d2dcb066e7083be7$var$_excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, $iVyaN.default)('recharts-surface', className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("svg", $d2dcb066e7083be7$var$_extends({}, (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(others, true, 'svg'), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("desc", null, desc), children);
}



var $8T3gX = parcelRequire("8T3gX");



var $iVyaN = parcelRequire("iVyaN");

function $d1f791143049a74c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d1f791143049a74c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d1f791143049a74c$var$_typeof(o);
}
var $d1f791143049a74c$var$_excluded = [
    "type",
    "size",
    "sizeType"
];
function $d1f791143049a74c$var$_extends() {
    $d1f791143049a74c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d1f791143049a74c$var$_extends.apply(this, arguments);
}
function $d1f791143049a74c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d1f791143049a74c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d1f791143049a74c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d1f791143049a74c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d1f791143049a74c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d1f791143049a74c$var$_defineProperty(obj, key, value) {
    key = $d1f791143049a74c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d1f791143049a74c$var$_toPropertyKey(t) {
    var i = $d1f791143049a74c$var$_toPrimitive(t, "string");
    return "symbol" == $d1f791143049a74c$var$_typeof(i) ? i : i + "";
}
function $d1f791143049a74c$var$_toPrimitive(t, r) {
    if ("object" != $d1f791143049a74c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d1f791143049a74c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $d1f791143049a74c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d1f791143049a74c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d1f791143049a74c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $d1f791143049a74c$var$symbolFactories = {
    symbolCircle: (0, $40ccc67e29ee0e40$exports.symbolCircle),
    symbolCross: (0, $40ccc67e29ee0e40$exports.symbolCross),
    symbolDiamond: (0, $40ccc67e29ee0e40$exports.symbolDiamond),
    symbolSquare: (0, $40ccc67e29ee0e40$exports.symbolSquare),
    symbolStar: (0, $40ccc67e29ee0e40$exports.symbolStar),
    symbolTriangle: (0, $40ccc67e29ee0e40$exports.symbolTriangle),
    symbolWye: (0, $40ccc67e29ee0e40$exports.symbolWye)
};
var $d1f791143049a74c$var$RADIAN = Math.PI / 180;
var $d1f791143049a74c$var$getSymbolFactory = function getSymbolFactory(type) {
    var name = "symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($7808c9375de28fec$exports)))(type));
    return $d1f791143049a74c$var$symbolFactories[name] || (0, $40ccc67e29ee0e40$exports.symbolCircle);
};
var $d1f791143049a74c$var$calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
    if (sizeType === 'area') return size;
    switch(type){
        case 'cross':
            return 5 * size * size / 9;
        case 'diamond':
            return 0.5 * size * size / Math.sqrt(3);
        case 'square':
            return size * size;
        case 'star':
            var angle = 18 * $d1f791143049a74c$var$RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
        case 'triangle':
            return Math.sqrt(3) * size * size / 4;
        case 'wye':
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var $d1f791143049a74c$var$registerSymbol = function registerSymbol(key, factory) {
    $d1f791143049a74c$var$symbolFactories["symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($7808c9375de28fec$exports)))(key))] = factory;
};
var $d1f791143049a74c$export$fa456266707bf4e4 = function Symbols(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'circle' : _ref$type, _ref$size = _ref.size, size = _ref$size === void 0 ? 64 : _ref$size, _ref$sizeType = _ref.sizeType, sizeType = _ref$sizeType === void 0 ? 'area' : _ref$sizeType, rest = $d1f791143049a74c$var$_objectWithoutProperties(_ref, $d1f791143049a74c$var$_excluded);
    var props = $d1f791143049a74c$var$_objectSpread($d1f791143049a74c$var$_objectSpread({}, rest), {}, {
        type: type,
        size: size,
        sizeType: sizeType
    });
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = function getPath() {
        var symbolFactory = $d1f791143049a74c$var$getSymbolFactory(type);
        var symbol = (0, $40ccc67e29ee0e40$exports.symbol)().type(symbolFactory).size($d1f791143049a74c$var$calculateAreaSize(size, sizeType, type));
        return symbol();
    };
    var className = props.className, cx = props.cx, cy = props.cy;
    var filteredProps = (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(props, true);
    if (cx === +cx && cy === +cy && size === +size) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("path", $d1f791143049a74c$var$_extends({}, filteredProps, {
        className: (0, $iVyaN.default)('recharts-symbols', className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
$d1f791143049a74c$export$fa456266707bf4e4.registerSymbol = $d1f791143049a74c$var$registerSymbol;



function $a515be796d1d4420$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a515be796d1d4420$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a515be796d1d4420$var$_typeof(o);
}
function $a515be796d1d4420$var$_extends() {
    $a515be796d1d4420$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a515be796d1d4420$var$_extends.apply(this, arguments);
}
function $a515be796d1d4420$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a515be796d1d4420$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a515be796d1d4420$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a515be796d1d4420$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a515be796d1d4420$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a515be796d1d4420$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a515be796d1d4420$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $a515be796d1d4420$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $a515be796d1d4420$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a515be796d1d4420$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a515be796d1d4420$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $a515be796d1d4420$var$_callSuper(t, o, e) {
    return o = $a515be796d1d4420$var$_getPrototypeOf(o), $a515be796d1d4420$var$_possibleConstructorReturn(t, $a515be796d1d4420$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $a515be796d1d4420$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $a515be796d1d4420$var$_possibleConstructorReturn(self, call) {
    if (call && ($a515be796d1d4420$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $a515be796d1d4420$var$_assertThisInitialized(self);
}
function $a515be796d1d4420$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a515be796d1d4420$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a515be796d1d4420$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $a515be796d1d4420$var$_getPrototypeOf(o) {
    $a515be796d1d4420$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a515be796d1d4420$var$_getPrototypeOf(o);
}
function $a515be796d1d4420$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $a515be796d1d4420$var$_setPrototypeOf(subClass, superClass);
}
function $a515be796d1d4420$var$_setPrototypeOf(o, p) {
    $a515be796d1d4420$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a515be796d1d4420$var$_setPrototypeOf(o, p);
}
function $a515be796d1d4420$var$_defineProperty(obj, key, value) {
    key = $a515be796d1d4420$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a515be796d1d4420$var$_toPropertyKey(t) {
    var i = $a515be796d1d4420$var$_toPrimitive(t, "string");
    return "symbol" == $a515be796d1d4420$var$_typeof(i) ? i : i + "";
}
function $a515be796d1d4420$var$_toPrimitive(t, r) {
    if ("object" != $a515be796d1d4420$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a515be796d1d4420$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $a515be796d1d4420$var$SIZE = 32;
var $a515be796d1d4420$export$99f8d96ed0cededa = /*#__PURE__*/ function(_PureComponent) {
    function DefaultLegendContent() {
        $a515be796d1d4420$var$_classCallCheck(this, DefaultLegendContent);
        return $a515be796d1d4420$var$_callSuper(this, DefaultLegendContent, arguments);
    }
    $a515be796d1d4420$var$_inherits(DefaultLegendContent, _PureComponent);
    return $a515be796d1d4420$var$_createClass(DefaultLegendContent, [
        {
            key: "renderIcon",
            value: /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */ function renderIcon(data) {
                var inactiveColor = this.props.inactiveColor;
                var halfSize = $a515be796d1d4420$var$SIZE / 2;
                var sixthSize = $a515be796d1d4420$var$SIZE / 6;
                var thirdSize = $a515be796d1d4420$var$SIZE / 3;
                var color = data.inactive ? inactiveColor : data.color;
                if (data.type === 'plainline') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("line", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    strokeDasharray: data.payload.strokeDasharray,
                    x1: 0,
                    y1: halfSize,
                    x2: $a515be796d1d4420$var$SIZE,
                    y2: halfSize,
                    className: "recharts-legend-icon"
                });
                if (data.type === 'line') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("path", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat($a515be796d1d4420$var$SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
                    className: "recharts-legend-icon"
                });
                if (data.type === 'rect') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("path", {
                    stroke: "none",
                    fill: color,
                    d: "M0,".concat($a515be796d1d4420$var$SIZE / 8, "h").concat($a515be796d1d4420$var$SIZE, "v").concat($a515be796d1d4420$var$SIZE * 3 / 4, "h").concat(-$a515be796d1d4420$var$SIZE, "z"),
                    className: "recharts-legend-icon"
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).isValidElement(data.legendIcon)) {
                    var iconProps = $a515be796d1d4420$var$_objectSpread({}, data);
                    delete iconProps.legendIcon;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(data.legendIcon, iconProps);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $d1f791143049a74c$export$fa456266707bf4e4), {
                    fill: color,
                    cx: halfSize,
                    cy: halfSize,
                    size: $a515be796d1d4420$var$SIZE,
                    sizeType: "diameter",
                    type: data.type
                });
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _this = this;
                var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: $a515be796d1d4420$var$SIZE,
                    height: $a515be796d1d4420$var$SIZE
                };
                var itemStyle = {
                    display: layout === 'horizontal' ? 'inline-block' : 'block',
                    marginRight: 10
                };
                var svgStyle = {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    marginRight: 4
                };
                return payload.map(function(entry, i) {
                    var finalFormatter = entry.formatter || formatter;
                    var className = (0, $iVyaN.default)($a515be796d1d4420$var$_defineProperty($a515be796d1d4420$var$_defineProperty({
                        'recharts-legend-item': true
                    }, "legend-item-".concat(i), true), "inactive", entry.inactive));
                    if (entry.type === 'none') return null;
                    // Do not render entry.value as functions. Always require static string properties.
                    var entryValue = !(0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(entry.value) ? entry.value : null;
                    (0, $a1b0f3d7b382d4a4$export$c106dd0671a0fc2d)(!(0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(entry.value), "The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name=\"Name of my Data\"/>" // eslint-disable-line max-len
                    );
                    var color = entry.inactive ? inactiveColor : entry.color;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("li", $a515be796d1d4420$var$_extends({
                        className: className,
                        style: itemStyle,
                        key: "legend-item-".concat(i)
                    }, (0, $a19170a4abc07995$export$ca62be0d67a3158c)(_this.props, entry, i)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $d2dcb066e7083be7$export$7b92b459e668cb21), {
                        width: iconSize,
                        height: iconSize,
                        viewBox: viewBox,
                        style: svgStyle
                    }, _this.renderIcon(entry)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("span", {
                        className: "recharts-legend-item-text",
                        style: {
                            color: color
                        }
                    }, finalFormatter ? finalFormatter(entryValue, entry, i) : entryValue));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, payload = _this$props2.payload, layout = _this$props2.layout, align = _this$props2.align;
                if (!payload || !payload.length) return null;
                var finalStyle = {
                    padding: 0,
                    margin: 0,
                    textAlign: layout === 'horizontal' ? align : 'left'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("ul", {
                    className: "recharts-default-legend",
                    style: finalStyle
                }, this.renderItems());
            }
        }
    ]);
}((0, $8T3gX.PureComponent));
$a515be796d1d4420$var$_defineProperty($a515be796d1d4420$export$99f8d96ed0cededa, "displayName", 'Legend');
$a515be796d1d4420$var$_defineProperty($a515be796d1d4420$export$99f8d96ed0cededa, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'middle',
    inactiveColor: '#ccc'
});



var $02a01f9a4517f244$exports = {};

var $6d06713981607225$exports = {};

var $75e039934c534e29$exports = {};
var $90ff81eaf0557cbd$exports = {};
var $97e784a8512e4a9d$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $97e784a8512e4a9d$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$97e784a8512e4a9d$exports = $97e784a8512e4a9d$var$baseFindIndex;


var $8b2390ea294cba45$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $8b2390ea294cba45$var$baseIsNaN(value) {
    return value !== value;
}
$8b2390ea294cba45$exports = $8b2390ea294cba45$var$baseIsNaN;


var $3b49aa4d5d9ee37d$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $3b49aa4d5d9ee37d$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$3b49aa4d5d9ee37d$exports = $3b49aa4d5d9ee37d$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $90ff81eaf0557cbd$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $3b49aa4d5d9ee37d$exports(array, value, fromIndex) : $97e784a8512e4a9d$exports(array, $8b2390ea294cba45$exports, fromIndex);
}
$90ff81eaf0557cbd$exports = $90ff81eaf0557cbd$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $75e039934c534e29$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $90ff81eaf0557cbd$exports(array, value, 0) > -1;
}
$75e039934c534e29$exports = $75e039934c534e29$var$arrayIncludes;


var $872519cf5d897167$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $872519cf5d897167$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$872519cf5d897167$exports = $872519cf5d897167$var$arrayIncludesWith;



var $946538378bdd1c68$exports = {};

var $64dbcb14cdcbd774$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $64dbcb14cdcbd774$var$noop() {
// No operation performed.
}
$64dbcb14cdcbd774$exports = $64dbcb14cdcbd774$var$noop;



/** Used as references for various `Number` constants. */ var $946538378bdd1c68$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $946538378bdd1c68$var$createSet = !($f7e45b5ac0aba58a$exports && 1 / $2923149d82fb4e32$exports(new $f7e45b5ac0aba58a$exports([
    ,
    -0
]))[1] == $946538378bdd1c68$var$INFINITY) ? $64dbcb14cdcbd774$exports : function(values) {
    return new $f7e45b5ac0aba58a$exports(values);
};
$946538378bdd1c68$exports = $946538378bdd1c68$var$createSet;



/** Used as the size to enable large array optimizations. */ var $6d06713981607225$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $6d06713981607225$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $75e039934c534e29$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $872519cf5d897167$exports;
    } else if (length >= $6d06713981607225$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $946538378bdd1c68$exports(array);
        if (set) return $2923149d82fb4e32$exports(set);
        isCommon = false;
        includes = $fcea3308b25e2289$exports;
        seen = new $0caf93a6e311dd5e$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$6d06713981607225$exports = $6d06713981607225$var$baseUniq;


/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $02a01f9a4517f244$var$uniqBy(array, iteratee) {
    return array && array.length ? $6d06713981607225$exports(array, $9dd1d38dfe69ddcf$exports(iteratee, 2)) : [];
}
$02a01f9a4517f244$exports = $02a01f9a4517f244$var$uniqBy;



function $d0016136b2d04c35$export$b67e33c2fb1535fa(payload, option, defaultUniqBy) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($02a01f9a4517f244$exports)))(payload, defaultUniqBy);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(option)) return (0, (/*@__PURE__*/$parcel$interopDefault($02a01f9a4517f244$exports)))(payload, option);
    return payload;
}


function $a67bff487a060557$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a67bff487a060557$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a67bff487a060557$var$_typeof(o);
}
var $a67bff487a060557$var$_excluded = [
    "ref"
];
function $a67bff487a060557$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a67bff487a060557$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a67bff487a060557$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a67bff487a060557$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a67bff487a060557$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a67bff487a060557$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a67bff487a060557$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $a67bff487a060557$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $a67bff487a060557$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a67bff487a060557$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a67bff487a060557$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $a67bff487a060557$var$_callSuper(t, o, e) {
    return o = $a67bff487a060557$var$_getPrototypeOf(o), $a67bff487a060557$var$_possibleConstructorReturn(t, $a67bff487a060557$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $a67bff487a060557$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $a67bff487a060557$var$_possibleConstructorReturn(self, call) {
    if (call && ($a67bff487a060557$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $a67bff487a060557$var$_assertThisInitialized(self);
}
function $a67bff487a060557$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a67bff487a060557$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a67bff487a060557$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $a67bff487a060557$var$_getPrototypeOf(o) {
    $a67bff487a060557$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a67bff487a060557$var$_getPrototypeOf(o);
}
function $a67bff487a060557$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $a67bff487a060557$var$_setPrototypeOf(subClass, superClass);
}
function $a67bff487a060557$var$_setPrototypeOf(o, p) {
    $a67bff487a060557$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a67bff487a060557$var$_setPrototypeOf(o, p);
}
function $a67bff487a060557$var$_defineProperty(obj, key, value) {
    key = $a67bff487a060557$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a67bff487a060557$var$_toPropertyKey(t) {
    var i = $a67bff487a060557$var$_toPrimitive(t, "string");
    return "symbol" == $a67bff487a060557$var$_typeof(i) ? i : i + "";
}
function $a67bff487a060557$var$_toPrimitive(t, r) {
    if ("object" != $a67bff487a060557$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a67bff487a060557$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $a67bff487a060557$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a67bff487a060557$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a67bff487a060557$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a67bff487a060557$var$defaultUniqBy(entry) {
    return entry.value;
}
function $a67bff487a060557$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement(content, props);
    var ref = props.ref, otherProps = $a67bff487a060557$var$_objectWithoutProperties(props, $a67bff487a060557$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $a515be796d1d4420$export$99f8d96ed0cededa), otherProps);
}
var $a67bff487a060557$var$EPS = 1;
var $a67bff487a060557$export$ed247974535929c7 = /*#__PURE__*/ function(_PureComponent) {
    function Legend() {
        var _this;
        $a67bff487a060557$var$_classCallCheck(this, Legend);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $a67bff487a060557$var$_callSuper(this, Legend, [].concat(args));
        $a67bff487a060557$var$_defineProperty(_this, "lastBoundingBox", {
            width: -1,
            height: -1
        });
        return _this;
    }
    $a67bff487a060557$var$_inherits(Legend, _PureComponent);
    return $a67bff487a060557$var$_createClass(Legend, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateBBox();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateBBox();
            }
        },
        {
            key: "getBBox",
            value: function getBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    box.height = this.wrapperNode.offsetHeight;
                    box.width = this.wrapperNode.offsetWidth;
                    return box;
                }
                return null;
            }
        },
        {
            key: "updateBBox",
            value: function updateBBox() {
                var onBBoxUpdate = this.props.onBBoxUpdate;
                var box = this.getBBox();
                if (box) {
                    if (Math.abs(box.width - this.lastBoundingBox.width) > $a67bff487a060557$var$EPS || Math.abs(box.height - this.lastBoundingBox.height) > $a67bff487a060557$var$EPS) {
                        this.lastBoundingBox.width = box.width;
                        this.lastBoundingBox.height = box.height;
                        if (onBBoxUpdate) onBBoxUpdate(box);
                    }
                } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
                    this.lastBoundingBox.width = -1;
                    this.lastBoundingBox.height = -1;
                    if (onBBoxUpdate) onBBoxUpdate(null);
                }
            }
        },
        {
            key: "getBBoxSnapshot",
            value: function getBBoxSnapshot() {
                if (this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0) return $a67bff487a060557$var$_objectSpread({}, this.lastBoundingBox);
                return {
                    width: 0,
                    height: 0
                };
            }
        },
        {
            key: "getDefaultPosition",
            value: function getDefaultPosition(style) {
                var _this$props = this.props, layout = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
                var hPos, vPos;
                if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
                    if (align === 'center' && layout === 'vertical') {
                        var box = this.getBBoxSnapshot();
                        hPos = {
                            left: ((chartWidth || 0) - box.width) / 2
                        };
                    } else hPos = align === 'right' ? {
                        right: margin && margin.right || 0
                    } : {
                        left: margin && margin.left || 0
                    };
                }
                if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
                    if (verticalAlign === 'middle') {
                        var _box = this.getBBoxSnapshot();
                        vPos = {
                            top: ((chartHeight || 0) - _box.height) / 2
                        };
                    } else vPos = verticalAlign === 'bottom' ? {
                        bottom: margin && margin.bottom || 0
                    } : {
                        top: margin && margin.top || 0
                    };
                }
                return $a67bff487a060557$var$_objectSpread($a67bff487a060557$var$_objectSpread({}, hPos), vPos);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, content = _this$props2.content, width = _this$props2.width, height = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
                var outerStyle = $a67bff487a060557$var$_objectSpread($a67bff487a060557$var$_objectSpread({
                    position: 'absolute',
                    width: width || 'auto',
                    height: height || 'auto'
                }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("div", {
                    className: "recharts-legend-wrapper",
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, $a67bff487a060557$var$renderContent(content, $a67bff487a060557$var$_objectSpread($a67bff487a060557$var$_objectSpread({}, this.props), {}, {
                    payload: (0, $d0016136b2d04c35$export$b67e33c2fb1535fa)(payload, payloadUniqBy, $a67bff487a060557$var$defaultUniqBy)
                })));
            }
        }
    ], [
        {
            key: "getWithHeight",
            value: function getWithHeight(item, chartWidth) {
                var _this$defaultProps$it = $a67bff487a060557$var$_objectSpread($a67bff487a060557$var$_objectSpread({}, this.defaultProps), item.props), layout = _this$defaultProps$it.layout;
                if (layout === 'vertical' && (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(item.props.height)) return {
                    height: item.props.height
                };
                if (layout === 'horizontal') return {
                    width: item.props.width || chartWidth
                };
                return null;
            }
        }
    ]);
}((0, $8T3gX.PureComponent));
$a67bff487a060557$var$_defineProperty($a67bff487a060557$export$ed247974535929c7, "displayName", 'Legend');
$a67bff487a060557$var$_defineProperty($a67bff487a060557$export$ed247974535929c7, "defaultProps", {
    iconSize: 14,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom'
});




function $952a3f9c16857392$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $952a3f9c16857392$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $952a3f9c16857392$var$_typeof(o);
}
function $952a3f9c16857392$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $952a3f9c16857392$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $952a3f9c16857392$var$ownKeys(Object(t), !0).forEach(function(r) {
            $952a3f9c16857392$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $952a3f9c16857392$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $952a3f9c16857392$var$_defineProperty(obj, key, value) {
    key = $952a3f9c16857392$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $952a3f9c16857392$var$_toPropertyKey(t) {
    var i = $952a3f9c16857392$var$_toPrimitive(t, "string");
    return "symbol" == $952a3f9c16857392$var$_typeof(i) ? i : i + "";
}
function $952a3f9c16857392$var$_toPrimitive(t, r) {
    if ("object" != $952a3f9c16857392$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $952a3f9c16857392$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $952a3f9c16857392$export$8f9424d123c36aa = function getLegendProps(_ref) {
    var children = _ref.children, formattedGraphicalItems = _ref.formattedGraphicalItems, legendWidth = _ref.legendWidth, legendContent = _ref.legendContent;
    var legendItem = (0, $10636f1b3e62ab88$export$64c61536a2b72e0f)(children, (0, $a67bff487a060557$export$ed247974535929c7));
    if (!legendItem) return null;
    var legendDefaultProps = (0, $a67bff487a060557$export$ed247974535929c7).defaultProps;
    var legendProps = legendDefaultProps !== undefined ? $952a3f9c16857392$var$_objectSpread($952a3f9c16857392$var$_objectSpread({}, legendDefaultProps), legendItem.props) : {};
    var legendData;
    if (legendItem.props && legendItem.props.payload) legendData = legendItem.props && legendItem.props.payload;
    else if (legendContent === 'children') legendData = (formattedGraphicalItems || []).reduce(function(result, _ref2) {
        var item = _ref2.item, props = _ref2.props;
        var data = props.sectors || props.data || [];
        return result.concat(data.map(function(entry) {
            return {
                type: legendItem.props.iconType || item.props.legendType,
                value: entry.name,
                color: entry.fill,
                payload: entry
            };
        }));
    }, []);
    else legendData = (formattedGraphicalItems || []).map(function(_ref3) {
        var item = _ref3.item;
        var itemDefaultProps = item.type.defaultProps;
        var itemProps = itemDefaultProps !== undefined ? $952a3f9c16857392$var$_objectSpread($952a3f9c16857392$var$_objectSpread({}, itemDefaultProps), item.props) : {};
        var dataKey = itemProps.dataKey, name = itemProps.name, legendType = itemProps.legendType, hide = itemProps.hide;
        return {
            inactive: hide,
            dataKey: dataKey,
            type: legendProps.iconType || legendType || 'square',
            color: (0, $bc60c84815913bd8$export$ec6cab5a7a3b93bf)(item),
            value: name || dataKey,
            // @ts-expect-error property strokeDasharray is required in Payload but optional in props
            payload: itemProps
        };
    });
    return $952a3f9c16857392$var$_objectSpread($952a3f9c16857392$var$_objectSpread($952a3f9c16857392$var$_objectSpread({}, legendProps), (0, $a67bff487a060557$export$ed247974535929c7).getWithHeight(legendItem, legendWidth)), {}, {
        payload: legendData,
        item: legendItem
    });
};


function $bc60c84815913bd8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $bc60c84815913bd8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $bc60c84815913bd8$var$_typeof(o);
}
function $bc60c84815913bd8$var$_toConsumableArray(arr) {
    return $bc60c84815913bd8$var$_arrayWithoutHoles(arr) || $bc60c84815913bd8$var$_iterableToArray(arr) || $bc60c84815913bd8$var$_unsupportedIterableToArray(arr) || $bc60c84815913bd8$var$_nonIterableSpread();
}
function $bc60c84815913bd8$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $bc60c84815913bd8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $bc60c84815913bd8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $bc60c84815913bd8$var$_arrayLikeToArray(o, minLen);
}
function $bc60c84815913bd8$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $bc60c84815913bd8$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $bc60c84815913bd8$var$_arrayLikeToArray(arr);
}
function $bc60c84815913bd8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $bc60c84815913bd8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bc60c84815913bd8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bc60c84815913bd8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $bc60c84815913bd8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bc60c84815913bd8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $bc60c84815913bd8$var$_defineProperty(obj, key, value) {
    key = $bc60c84815913bd8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bc60c84815913bd8$var$_toPropertyKey(t) {
    var i = $bc60c84815913bd8$var$_toPrimitive(t, "string");
    return "symbol" == $bc60c84815913bd8$var$_typeof(i) ? i : i + "";
}
function $bc60c84815913bd8$var$_toPrimitive(t, r) {
    if ("object" != $bc60c84815913bd8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $bc60c84815913bd8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $bc60c84815913bd8$export$f97fc4a450f29a(obj, dataKey, defaultValue) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(obj) || (0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(dataKey)) return defaultValue;
    if ((0, $ec351366ffe25ce6$export$402a499e1ea44294)(dataKey)) return (0, (/*@__PURE__*/$parcel$interopDefault($eb02300d30d6bdcb$exports)))(obj, dataKey, defaultValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(dataKey)) return dataKey(obj);
    return defaultValue;
}
function $bc60c84815913bd8$export$6a1e7873444c95a7(data, key, type, filterNil) {
    var flattenData = (0, (/*@__PURE__*/$parcel$interopDefault($d7f8215938131932$exports)))(data, function(entry) {
        return $bc60c84815913bd8$export$f97fc4a450f29a(entry, key);
    });
    if (type === 'number') {
        // @ts-expect-error parseFloat type only accepts strings
        var domain = flattenData.filter(function(entry) {
            return (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(entry) || parseFloat(entry);
        });
        return domain.length ? [
            (0, (/*@__PURE__*/$parcel$interopDefault($d30612692dabe970$exports)))(domain),
            (0, (/*@__PURE__*/$parcel$interopDefault($70218499e448ea52$exports)))(domain)
        ] : [
            Infinity,
            -Infinity
        ];
    }
    var validateData = filterNil ? flattenData.filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(entry);
    }) : flattenData;
    // Supports x-axis of Date type
    return validateData.map(function(entry) {
        return (0, $ec351366ffe25ce6$export$402a499e1ea44294)(entry) || entry instanceof Date ? entry : '';
    });
}
var $bc60c84815913bd8$export$3071d39cc844078e = function calculateActiveTickIndex(coordinate) {
    var _ticks$length;
    var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
    var axis = arguments.length > 3 ? arguments[3] : undefined;
    var index = -1;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or less ticks ticks then the active tick is at index 0
    if (len <= 1) return 0;
    if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
        var range = axis.range;
        // ticks are distributed in a circle
        for(var i = 0; i < len; i++){
            var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
            var cur = unsortedTicks[i].coordinate;
            var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
            var sameDirectionCoord = void 0;
            if ((0, $ec351366ffe25ce6$export$9d334328eb75e624)(cur - before) !== (0, $ec351366ffe25ce6$export$9d334328eb75e624)(after - cur)) {
                var diffInterval = [];
                if ((0, $ec351366ffe25ce6$export$9d334328eb75e624)(after - cur) === (0, $ec351366ffe25ce6$export$9d334328eb75e624)(range[1] - range[0])) {
                    sameDirectionCoord = after;
                    var curInRange = cur + range[1] - range[0];
                    diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                    diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
                } else {
                    sameDirectionCoord = before;
                    var afterInRange = after + range[1] - range[0];
                    diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                    diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
                }
                var sameInterval = [
                    Math.min(cur, (sameDirectionCoord + cur) / 2),
                    Math.max(cur, (sameDirectionCoord + cur) / 2)
                ];
                if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                    index = unsortedTicks[i].index;
                    break;
                }
            } else {
                var minValue = Math.min(before, after);
                var maxValue = Math.max(before, after);
                if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
                    index = unsortedTicks[i].index;
                    break;
                }
            }
        }
    } else {
        // ticks are distributed in a single direction
        for(var _i = 0; _i < len; _i++)if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
            index = ticks[_i].index;
            break;
        }
    }
    return index;
};
var $bc60c84815913bd8$export$ec6cab5a7a3b93bf = function getMainColorOfGraphicItem(item) {
    var _item$type;
    var _ref = item, displayName = _ref.type.displayName; // TODO: check if displayName is valid.
    var defaultedProps = (_item$type = item.type) !== null && _item$type !== void 0 && _item$type.defaultProps ? $bc60c84815913bd8$var$_objectSpread($bc60c84815913bd8$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
    var stroke = defaultedProps.stroke, fill = defaultedProps.fill;
    var result;
    switch(displayName){
        case 'Line':
            result = stroke;
            break;
        case 'Area':
        case 'Radar':
            result = stroke && stroke !== 'none' ? stroke : fill;
            break;
        default:
            result = fill;
            break;
    }
    return result;
};
var $bc60c84815913bd8$export$570d306bee26c748 = function getBarSizeList(_ref2) {
    var globalSize = _ref2.barSize, totalSize = _ref2.totalSize, _ref2$stackGroups = _ref2.stackGroups, stackGroups = _ref2$stackGroups === void 0 ? {} : _ref2$stackGroups;
    if (!stackGroups) return {};
    var result = {};
    var numericAxisIds = Object.keys(stackGroups);
    for(var i = 0, len = numericAxisIds.length; i < len; i++){
        var sgs = stackGroups[numericAxisIds[i]].stackGroups;
        var stackIds = Object.keys(sgs);
        for(var j = 0, sLen = stackIds.length; j < sLen; j++){
            var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId;
            var barItems = items.filter(function(item) {
                return (0, $10636f1b3e62ab88$export$be63e0664592e141)(item.type).indexOf('Bar') >= 0;
            });
            if (barItems && barItems.length) {
                var barItemDefaultProps = barItems[0].type.defaultProps;
                var barItemProps = barItemDefaultProps !== undefined ? $bc60c84815913bd8$var$_objectSpread($bc60c84815913bd8$var$_objectSpread({}, barItemDefaultProps), barItems[0].props) : barItems[0].props;
                var selfSize = barItemProps.barSize;
                var cateId = barItemProps[cateAxisId];
                if (!result[cateId]) result[cateId] = [];
                var barSize = (0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(selfSize) ? globalSize : selfSize;
                result[cateId].push({
                    item: barItems[0],
                    stackList: barItems.slice(1),
                    barSize: (0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(barSize) ? undefined : (0, $ec351366ffe25ce6$export$476354dbf49bdff6)(barSize, totalSize, 0)
                });
            }
        }
    }
    return result;
};
var $bc60c84815913bd8$export$d36834ecd87f906b = function getBarPosition(_ref3) {
    var barGap = _ref3.barGap, barCategoryGap = _ref3.barCategoryGap, bandSize = _ref3.bandSize, _ref3$sizeList = _ref3.sizeList, sizeList = _ref3$sizeList === void 0 ? [] : _ref3$sizeList, maxBarSize = _ref3.maxBarSize;
    var len = sizeList.length;
    if (len < 1) return null;
    var realBarGap = (0, $ec351366ffe25ce6$export$476354dbf49bdff6)(barGap, bandSize, 0, true);
    var result;
    var initialValue = [];
    // whether or not is barSize setted by user
    if (sizeList[0].barSize === +sizeList[0].barSize) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        // @ts-expect-error the type check above does not check for type number explicitly
        var sum = sizeList.reduce(function(res, entry) {
            return res + entry.barSize || 0;
        }, 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce(function(res, entry) {
            var newPosition = {
                item: entry.item,
                position: {
                    offset: prev.offset + prev.size + realBarGap,
                    // @ts-expect-error the type check above does not check for type number explicitly
                    size: useFull ? fullBarSize : entry.barSize
                }
            };
            var newRes = [].concat($bc60c84815913bd8$var$_toConsumableArray(res), [
                newPosition
            ]);
            prev = newRes[newRes.length - 1].position;
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: prev
                });
            });
            return newRes;
        }, initialValue);
    } else {
        var _offset = (0, $ec351366ffe25ce6$export$476354dbf49bdff6)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce(function(res, entry, i) {
            var newRes = [].concat($bc60c84815913bd8$var$_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ]);
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: newRes[newRes.length - 1].position
                });
            });
            return newRes;
        }, initialValue);
    }
    return result;
};
var $bc60c84815913bd8$export$3a657a8c9f789617 = function appendOffsetOfLegend(offset, _unused, props, legendBox) {
    var children = props.children, width = props.width, margin = props.margin;
    var legendWidth = width - (margin.left || 0) - (margin.right || 0);
    var legendProps = (0, $952a3f9c16857392$export$8f9424d123c36aa)({
        children: children,
        legendWidth: legendWidth
    });
    if (legendProps) {
        var _ref4 = legendBox || {}, boxWidth = _ref4.width, boxHeight = _ref4.height;
        var align = legendProps.align, verticalAlign = legendProps.verticalAlign, layout = legendProps.layout;
        if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'middle') && align !== 'center' && (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(offset[align])) return $bc60c84815913bd8$var$_objectSpread($bc60c84815913bd8$var$_objectSpread({}, offset), {}, $bc60c84815913bd8$var$_defineProperty({}, align, offset[align] + (boxWidth || 0)));
        if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && verticalAlign !== 'middle' && (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(offset[verticalAlign])) return $bc60c84815913bd8$var$_objectSpread($bc60c84815913bd8$var$_objectSpread({}, offset), {}, $bc60c84815913bd8$var$_defineProperty({}, verticalAlign, offset[verticalAlign] + (boxHeight || 0)));
    }
    return offset;
};
var $bc60c84815913bd8$var$isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis(layout, axisType, direction) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(axisType)) return true;
    if (layout === 'horizontal') return axisType === 'yAxis';
    if (layout === 'vertical') return axisType === 'xAxis';
    if (direction === 'x') return axisType === 'xAxis';
    if (direction === 'y') return axisType === 'yAxis';
    return true;
};
var $bc60c84815913bd8$export$8a46d1a2b0f8e61a = function getDomainOfErrorBars(data, item, dataKey, layout, axisType) {
    var children = item.props.children;
    var errorBars = (0, $10636f1b3e62ab88$export$fdd5e64c0e8495bb)(children, (0, $3ba1a13bb3875529$export$4f4d7676bdf949e5)).filter(function(errorBarChild) {
        return $bc60c84815913bd8$var$isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
    });
    if (errorBars && errorBars.length) {
        var keys = errorBars.map(function(errorBarChild) {
            return errorBarChild.props.dataKey;
        });
        return data.reduce(function(result, entry) {
            var entryValue = $bc60c84815913bd8$export$f97fc4a450f29a(entry, dataKey);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(entryValue)) return result;
            var mainValue = Array.isArray(entryValue) ? [
                (0, (/*@__PURE__*/$parcel$interopDefault($d30612692dabe970$exports)))(entryValue),
                (0, (/*@__PURE__*/$parcel$interopDefault($70218499e448ea52$exports)))(entryValue)
            ] : [
                entryValue,
                entryValue
            ];
            var errorDomain = keys.reduce(function(prevErrorArr, k) {
                var errorValue = $bc60c84815913bd8$export$f97fc4a450f29a(entry, k, 0);
                var lowerValue = mainValue[0] - Math.abs(Array.isArray(errorValue) ? errorValue[0] : errorValue);
                var upperValue = mainValue[1] + Math.abs(Array.isArray(errorValue) ? errorValue[1] : errorValue);
                return [
                    Math.min(lowerValue, prevErrorArr[0]),
                    Math.max(upperValue, prevErrorArr[1])
                ];
            }, [
                Infinity,
                -Infinity
            ]);
            return [
                Math.min(errorDomain[0], result[0]),
                Math.max(errorDomain[1], result[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
    }
    return null;
};
var $bc60c84815913bd8$export$2266342e22c737e8 = function parseErrorBarsOfAxis(data, items, dataKey, axisType, layout) {
    var domains = items.map(function(item) {
        return $bc60c84815913bd8$export$8a46d1a2b0f8e61a(data, item, dataKey, layout, axisType);
    }).filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(entry);
    });
    if (domains && domains.length) return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    return null;
};
var $bc60c84815913bd8$export$c92c4f4286b1390d = function getDomainOfItemsWithSameAxis(data, items, type, layout, filterNil) {
    var domains = items.map(function(item) {
        var dataKey = item.props.dataKey;
        if (type === 'number' && dataKey) return $bc60c84815913bd8$export$8a46d1a2b0f8e61a(data, item, dataKey, layout) || $bc60c84815913bd8$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
        return $bc60c84815913bd8$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
    });
    if (type === 'number') // Calculate the domain of number axis
    return domains.reduce(// @ts-expect-error if (type === number) means that the domain is numerical type
    // - but this link is missing in the type definition
    function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    var tag = {};
    // Get the union set of category axis
    return domains.reduce(function(result, entry) {
        for(var i = 0, len = entry.length; i < len; i++)// @ts-expect-error Date cannot index an object
        if (!tag[entry[i]]) {
            // @ts-expect-error Date cannot index an object
            tag[entry[i]] = true;
            // @ts-expect-error Date cannot index an object
            result.push(entry[i]);
        }
        return result;
    }, []);
};
var $bc60c84815913bd8$export$9fc1baaa6c6368b = function isCategoricalAxis(layout, axisType) {
    return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
};
var $bc60c84815913bd8$export$846dc5ac5fecff74 = function getCoordinatesOfGrid(ticks, minValue, maxValue, syncWithTicks) {
    if (syncWithTicks) return ticks.map(function(entry) {
        return entry.coordinate;
    });
    var hasMin, hasMax;
    var values = ticks.map(function(entry) {
        if (entry.coordinate === minValue) hasMin = true;
        if (entry.coordinate === maxValue) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(minValue);
    if (!hasMax) values.push(maxValue);
    return values;
};
var $bc60c84815913bd8$export$c829ee42daf7f66d = function getTicksOfAxis(axis, isGrid, isAll) {
    if (!axis) return null;
    var scale = axis.scale;
    var duplicateDomain = axis.duplicateDomain, type = axis.type, range = axis.range;
    var offsetForBand = axis.realScaleType === 'scaleBand' ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axis.axisType === 'angleAxis' && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, $ec351366ffe25ce6$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (axis.ticks || axis.niceTicks)) {
        var result = (axis.ticks || axis.niceTicks).map(function(entry) {
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset: offset
            };
        });
        return result.filter(function(row) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($8f10a67e567007ae$exports)))(row.coordinate);
        });
    }
    // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"
    if (axis.isCategorical && axis.categoricalDomain) return axis.categoricalDomain.map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        };
    });
    if (scale.ticks && !isAll) return scale.ticks(axis.tickCount).map(function(entry) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        };
    });
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    });
};
/**
 * combine the handlers
 * @param  {Function} defaultHandler Internal private handler
 * @param  {Function} childHandler Handler function specified in child component
 * @return {Function}                The combined handler
 */ var $bc60c84815913bd8$var$handlerWeakMap = new WeakMap();
var $bc60c84815913bd8$export$760ec406ba47bace = function combineEventHandlers(defaultHandler, childHandler) {
    if (typeof childHandler !== 'function') return defaultHandler;
    if (!$bc60c84815913bd8$var$handlerWeakMap.has(defaultHandler)) $bc60c84815913bd8$var$handlerWeakMap.set(defaultHandler, new WeakMap());
    var childWeakMap = $bc60c84815913bd8$var$handlerWeakMap.get(defaultHandler);
    if (childWeakMap.has(childHandler)) return childWeakMap.get(childHandler);
    var combineHandler = function combineHandler() {
        defaultHandler.apply(void 0, arguments);
        childHandler.apply(void 0, arguments);
    };
    childWeakMap.set(childHandler, combineHandler);
    return combineHandler;
};
var $bc60c84815913bd8$export$534b094a708572c1 = function parseScale(axis, chartType, hasBar) {
    var scale = axis.scale, type = axis.type, layout = axis.layout, axisType = axis.axisType;
    if (scale === 'auto') {
        if (layout === 'radial' && axisType === 'radiusAxis') return {
            scale: $56a5f1c61b5282e1$exports.scaleBand(),
            realScaleType: 'band'
        };
        if (layout === 'radial' && axisType === 'angleAxis') return {
            scale: $56a5f1c61b5282e1$exports.scaleLinear(),
            realScaleType: 'linear'
        };
        if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0 || chartType.indexOf('ComposedChart') >= 0 && !hasBar)) return {
            scale: $56a5f1c61b5282e1$exports.scalePoint(),
            realScaleType: 'point'
        };
        if (type === 'category') return {
            scale: $56a5f1c61b5282e1$exports.scaleBand(),
            realScaleType: 'band'
        };
        return {
            scale: $56a5f1c61b5282e1$exports.scaleLinear(),
            realScaleType: 'linear'
        };
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($b674a8a9f1dd7eca$exports)))(scale)) {
        var name = "scale".concat((0, (/*@__PURE__*/$parcel$interopDefault($7808c9375de28fec$exports)))(scale));
        return {
            scale: ($56a5f1c61b5282e1$exports[name] || $56a5f1c61b5282e1$exports.scalePoint)(),
            realScaleType: $56a5f1c61b5282e1$exports[name] ? name : 'point'
        };
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(scale) ? {
        scale: scale
    } : {
        scale: $56a5f1c61b5282e1$exports.scalePoint(),
        realScaleType: 'point'
    };
};
var $bc60c84815913bd8$var$EPS = 1e-4;
var $bc60c84815913bd8$export$9d80152e23bae434 = function checkDomainOfScale(scale) {
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var minValue = Math.min(range[0], range[1]) - $bc60c84815913bd8$var$EPS;
    var maxValue = Math.max(range[0], range[1]) + $bc60c84815913bd8$var$EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < minValue || first > maxValue || last < minValue || last > maxValue) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var $bc60c84815913bd8$export$778e70011fdf4625 = function findPositionOfBar(barPosition, child) {
    if (!barPosition) return null;
    for(var i = 0, len = barPosition.length; i < len; i++){
        if (barPosition[i].item === child) return barPosition[i].position;
    }
    return null;
};
var $bc60c84815913bd8$export$c7ec0fa96d0c462e = function truncateByDomain(value, domain) {
    if (!domain || domain.length !== 2 || !(0, $ec351366ffe25ce6$export$7e4aa119212bc614)(domain[0]) || !(0, $ec351366ffe25ce6$export$7e4aa119212bc614)(domain[1])) return value;
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, $ec351366ffe25ce6$export$7e4aa119212bc614)(value[0]) || value[0] < minValue) result[0] = minValue;
    if (!(0, $ec351366ffe25ce6$export$7e4aa119212bc614)(value[1]) || value[1] > maxValue) result[1] = maxValue;
    if (result[0] > maxValue) result[0] = maxValue;
    if (result[1] < minValue) result[1] = minValue;
    return result;
};
var $bc60c84815913bd8$export$3104c513558164c1 = function offsetSign(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($8f10a67e567007ae$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = negative;
                series[i][j][1] = negative + value;
                negative = series[i][j][1];
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
var $bc60c84815913bd8$export$9f2c6ead70935022 = function offsetPositive(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($8f10a67e567007ae$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = 0;
                series[i][j][1] = 0;
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
/**
 * Function type to compute offset for stacked data.
 *
 * d3-shape has something fishy going on with its types.
 * In @definitelytyped/d3-shape, this function (the offset accessor) is typed as Series<> => void.
 * However! When I actually open the storybook I can see that the offset accessor actually receives Array<Series<>>.
 * The same I can see in the source code itself:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 * That one unfortunately has no types but we can tell it passes three-dimensional array.
 *
 * Which leads me to believe that definitelytyped is wrong on this one.
 * There's open discussion on this topic without much attention:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 */ var $bc60c84815913bd8$var$STACK_OFFSET_MAP = {
    sign: $bc60c84815913bd8$export$3104c513558164c1,
    // @ts-expect-error definitelytyped types are incorrect
    expand: (0, $40ccc67e29ee0e40$exports.stackOffsetExpand),
    // @ts-expect-error definitelytyped types are incorrect
    none: (0, $40ccc67e29ee0e40$exports.stackOffsetNone),
    // @ts-expect-error definitelytyped types are incorrect
    silhouette: (0, $40ccc67e29ee0e40$exports.stackOffsetSilhouette),
    // @ts-expect-error definitelytyped types are incorrect
    wiggle: (0, $40ccc67e29ee0e40$exports.stackOffsetWiggle),
    positive: $bc60c84815913bd8$export$9f2c6ead70935022
};
var $bc60c84815913bd8$export$c2170542cfc0177c = function getStackedData(data, stackItems, offsetType) {
    var dataKeys = stackItems.map(function(item) {
        return item.props.dataKey;
    });
    var offsetAccessor = $bc60c84815913bd8$var$STACK_OFFSET_MAP[offsetType];
    var stack = (0, $40ccc67e29ee0e40$exports.stack)()// @ts-expect-error stack.keys type wants an array of strings, but we provide array of DataKeys
    .keys(dataKeys).value(function(d, key) {
        return +$bc60c84815913bd8$export$f97fc4a450f29a(d, key, 0);
    }).order((0, $40ccc67e29ee0e40$exports.stackOrderNone))// @ts-expect-error definitelytyped types are incorrect
    .offset(offsetAccessor);
    return stack(data);
};
var $bc60c84815913bd8$export$9af3ba56474b9601 = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
    if (!data) return null;
    // reversing items to affect render order (for layering)
    var items = reverseStackOrder ? _items.reverse() : _items;
    var parentStackGroupsInitialValue = {};
    var stackGroups = items.reduce(function(result, item) {
        var _item$type2;
        var defaultedProps = (_item$type2 = item.type) !== null && _item$type2 !== void 0 && _item$type2.defaultProps ? $bc60c84815913bd8$var$_objectSpread($bc60c84815913bd8$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
        var stackId = defaultedProps.stackId, hide = defaultedProps.hide;
        if (hide) return result;
        var axisId = defaultedProps[numericAxisId];
        var parentGroup = result[axisId] || {
            hasStack: false,
            stackGroups: {}
        };
        if ((0, $ec351366ffe25ce6$export$402a499e1ea44294)(stackId)) {
            var childGroup = parentGroup.stackGroups[stackId] || {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: []
            };
            childGroup.items.push(item);
            parentGroup.hasStack = true;
            parentGroup.stackGroups[stackId] = childGroup;
        } else parentGroup.stackGroups[(0, $ec351366ffe25ce6$export$8b15d37bc3f197d4)('_stackId_')] = {
            numericAxisId: numericAxisId,
            cateAxisId: cateAxisId,
            items: [
                item
            ]
        };
        return $bc60c84815913bd8$var$_objectSpread($bc60c84815913bd8$var$_objectSpread({}, result), {}, $bc60c84815913bd8$var$_defineProperty({}, axisId, parentGroup));
    }, parentStackGroupsInitialValue);
    var axisStackGroupsInitialValue = {};
    return Object.keys(stackGroups).reduce(function(result, axisId) {
        var group = stackGroups[axisId];
        if (group.hasStack) {
            var stackGroupsInitialValue = {};
            group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
                var g = group.stackGroups[stackId];
                return $bc60c84815913bd8$var$_objectSpread($bc60c84815913bd8$var$_objectSpread({}, res), {}, $bc60c84815913bd8$var$_defineProperty({}, stackId, {
                    numericAxisId: numericAxisId,
                    cateAxisId: cateAxisId,
                    items: g.items,
                    stackedData: $bc60c84815913bd8$export$c2170542cfc0177c(data, g.items, offsetType)
                }));
            }, stackGroupsInitialValue);
        }
        return $bc60c84815913bd8$var$_objectSpread($bc60c84815913bd8$var$_objectSpread({}, result), {}, $bc60c84815913bd8$var$_defineProperty({}, axisId, group));
    }, axisStackGroupsInitialValue);
};
var $bc60c84815913bd8$export$ac086aaa4358d590 = function getTicksOfScale(scale, opts) {
    var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals;
    var scaleType = realScaleType || opts.scale;
    if (scaleType !== 'auto' && scaleType !== 'linear') return null;
    if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
        // Calculate the ticks by the number of grid when the axis is a number axis
        var domain = scale.domain();
        if (!domain.length) return null;
        var tickValues = (0, $90aac6b8d65031a1$export$b84e75ccbfe6a612)(domain, tickCount, allowDecimals);
        scale.domain([
            (0, (/*@__PURE__*/$parcel$interopDefault($d30612692dabe970$exports)))(tickValues),
            (0, (/*@__PURE__*/$parcel$interopDefault($70218499e448ea52$exports)))(tickValues)
        ]);
        return {
            niceTicks: tickValues
        };
    }
    if (tickCount && type === 'number') {
        var _domain = scale.domain();
        var _tickValues = (0, $90aac6b8d65031a1$export$e9d28da780436e98)(_domain, tickCount, allowDecimals);
        return {
            niceTicks: _tickValues
        };
    }
    return null;
};
function $bc60c84815913bd8$export$6e87f3defb83c3f(_ref5) {
    var axis = _ref5.axis, ticks = _ref5.ticks, bandSize = _ref5.bandSize, entry = _ref5.entry, index = _ref5.index, dataKey = _ref5.dataKey;
    if (axis.type === 'category') {
        // find coordinate of category axis by the value of category
        // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(entry[axis.dataKey])) {
            // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
            var matchedTick = (0, $ec351366ffe25ce6$export$66950d3869f5cc67)(ticks, 'value', entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = $bc60c84815913bd8$export$f97fc4a450f29a(entry, !(0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(dataKey) ? dataKey : axis.dataKey);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(value) ? axis.scale(value) : null;
}
var $bc60c84815913bd8$export$8abb9e87422f3a0c = function getCateCoordinateOfBar(_ref6) {
    var axis = _ref6.axis, ticks = _ref6.ticks, offset = _ref6.offset, bandSize = _ref6.bandSize, entry = _ref6.entry, index = _ref6.index;
    if (axis.type === 'category') return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = $bc60c84815913bd8$export$f97fc4a450f29a(entry, axis.dataKey, axis.domain[index]);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var $bc60c84815913bd8$export$54f3200dd4a8a235 = function getBaseValueOfBar(_ref7) {
    var numericAxis = _ref7.numericAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        var minValue = Math.min(domain[0], domain[1]);
        var maxValue = Math.max(domain[0], domain[1]);
        if (minValue <= 0 && maxValue >= 0) return 0;
        if (maxValue < 0) return maxValue;
        return minValue;
    }
    return domain[0];
};
var $bc60c84815913bd8$export$a17bf3d98457878c = function getStackedDataOfItem(item, stackGroups) {
    var _item$type3;
    var defaultedProps = (_item$type3 = item.type) !== null && _item$type3 !== void 0 && _item$type3.defaultProps ? $bc60c84815913bd8$var$_objectSpread($bc60c84815913bd8$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
    var stackId = defaultedProps.stackId;
    if ((0, $ec351366ffe25ce6$export$402a499e1ea44294)(stackId)) {
        var group = stackGroups[stackId];
        if (group) {
            var itemIndex = group.items.indexOf(item);
            return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
        }
    }
    return null;
};
var $bc60c84815913bd8$var$getDomainOfSingle = function getDomainOfSingle(data) {
    return data.reduce(function(result, entry) {
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($d30612692dabe970$exports)))(entry.concat([
                result[0]
            ]).filter((0, $ec351366ffe25ce6$export$7e4aa119212bc614))),
            (0, (/*@__PURE__*/$parcel$interopDefault($70218499e448ea52$exports)))(entry.concat([
                result[1]
            ]).filter((0, $ec351366ffe25ce6$export$7e4aa119212bc614)))
        ];
    }, [
        Infinity,
        -Infinity
    ]);
};
var $bc60c84815913bd8$export$26522b779eb5497c = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
    return Object.keys(stackGroups).reduce(function(result, stackId) {
        var group = stackGroups[stackId];
        var stackedData = group.stackedData;
        var domain = stackedData.reduce(function(res, entry) {
            var s = $bc60c84815913bd8$var$getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]).map(function(result) {
        return result === Infinity || result === -Infinity ? 0 : result;
    });
};
var $bc60c84815913bd8$export$75a7b23ff266dfa1 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $bc60c84815913bd8$export$19c111ec8ad6c644 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $bc60c84815913bd8$export$a0bc8660980558a0 = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(specifiedDomain)) return specifiedDomain(dataDomain, allowDataOverflow);
    if (!Array.isArray(specifiedDomain)) return dataDomain;
    var domain = [];
    /* eslint-disable prefer-destructuring */ if ((0, $ec351366ffe25ce6$export$7e4aa119212bc614)(specifiedDomain[0])) domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
    else if ($bc60c84815913bd8$export$75a7b23ff266dfa1.test(specifiedDomain[0])) {
        var value = +$bc60c84815913bd8$export$75a7b23ff266dfa1.exec(specifiedDomain[0])[1];
        domain[0] = dataDomain[0] - value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(specifiedDomain[0])) domain[0] = specifiedDomain[0](dataDomain[0]);
    else domain[0] = dataDomain[0];
    if ((0, $ec351366ffe25ce6$export$7e4aa119212bc614)(specifiedDomain[1])) domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
    else if ($bc60c84815913bd8$export$19c111ec8ad6c644.test(specifiedDomain[1])) {
        var _value = +$bc60c84815913bd8$export$19c111ec8ad6c644.exec(specifiedDomain[1])[1];
        domain[1] = dataDomain[1] + _value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(specifiedDomain[1])) domain[1] = specifiedDomain[1](dataDomain[1]);
    else domain[1] = dataDomain[1];
    /* eslint-enable prefer-destructuring */ return domain;
};
var $bc60c84815913bd8$export$212ec45c42fe68a7 = function getBandSizeOfAxis(axis, ticks, isBar) {
    // @ts-expect-error we need to rethink scale type
    if (axis && axis.scale && axis.scale.bandwidth) {
        // @ts-expect-error we need to rethink scale type
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, (/*@__PURE__*/$parcel$interopDefault($e2540731f2bf6197$exports)))(ticks, function(o) {
            return o.coordinate;
        });
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
var $bc60c84815913bd8$export$c9a5230f0dda41bf = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
    if (!specifiedDomain || !specifiedDomain.length) return calculatedDomain;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($c9cb355ea2786d76$exports)))(specifiedDomain, (0, (/*@__PURE__*/$parcel$interopDefault($eb02300d30d6bdcb$exports)))(axisChild, 'type.defaultProps.domain'))) return calculatedDomain;
    return specifiedDomain;
};
var $bc60c84815913bd8$export$a4ea3faa19bc2d90 = function getTooltipItem(graphicalItem, payload) {
    var defaultedProps = graphicalItem.type.defaultProps ? $bc60c84815913bd8$var$_objectSpread($bc60c84815913bd8$var$_objectSpread({}, graphicalItem.type.defaultProps), graphicalItem.props) : graphicalItem.props;
    var dataKey = defaultedProps.dataKey, name = defaultedProps.name, unit = defaultedProps.unit, formatter = defaultedProps.formatter, tooltipType = defaultedProps.tooltipType, chartType = defaultedProps.chartType, hide = defaultedProps.hide;
    return $bc60c84815913bd8$var$_objectSpread($bc60c84815913bd8$var$_objectSpread({}, (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(graphicalItem, false)), {}, {
        dataKey: dataKey,
        unit: unit,
        formatter: formatter,
        name: name || dataKey,
        color: $bc60c84815913bd8$export$ec6cab5a7a3b93bf(graphicalItem),
        value: $bc60c84815913bd8$export$f97fc4a450f29a(payload, dataKey),
        type: tooltipType,
        payload: payload,
        chartType: chartType,
        hide: hide
    });
};


function $8e3433adec38d948$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8e3433adec38d948$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8e3433adec38d948$var$_typeof(o);
}
function $8e3433adec38d948$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8e3433adec38d948$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8e3433adec38d948$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8e3433adec38d948$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8e3433adec38d948$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8e3433adec38d948$var$_defineProperty(obj, key, value) {
    key = $8e3433adec38d948$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8e3433adec38d948$var$_toPropertyKey(t) {
    var i = $8e3433adec38d948$var$_toPrimitive(t, "string");
    return "symbol" == $8e3433adec38d948$var$_typeof(i) ? i : i + "";
}
function $8e3433adec38d948$var$_toPrimitive(t, r) {
    if ("object" != $8e3433adec38d948$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8e3433adec38d948$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $8e3433adec38d948$var$_slicedToArray(arr, i) {
    return $8e3433adec38d948$var$_arrayWithHoles(arr) || $8e3433adec38d948$var$_iterableToArrayLimit(arr, i) || $8e3433adec38d948$var$_unsupportedIterableToArray(arr, i) || $8e3433adec38d948$var$_nonIterableRest();
}
function $8e3433adec38d948$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8e3433adec38d948$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8e3433adec38d948$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8e3433adec38d948$var$_arrayLikeToArray(o, minLen);
}
function $8e3433adec38d948$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8e3433adec38d948$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $8e3433adec38d948$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $8e3433adec38d948$export$d74e8f7e9cc3fed3 = Math.PI / 180;
var $8e3433adec38d948$export$4f2c4f194778dcbb = function degreeToRadian(angle) {
    return angle * Math.PI / 180;
};
var $8e3433adec38d948$export$1c20e104e3e29a0a = function radianToDegree(angleInRadian) {
    return angleInRadian * 180 / Math.PI;
};
var $8e3433adec38d948$export$5c9a959bb3fc7749 = function polarToCartesian(cx, cy, radius, angle) {
    return {
        x: cx + Math.cos(-$8e3433adec38d948$export$d74e8f7e9cc3fed3 * angle) * radius,
        y: cy + Math.sin(-$8e3433adec38d948$export$d74e8f7e9cc3fed3 * angle) * radius
    };
};
var $8e3433adec38d948$export$ad5c48602371adfa = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var $8e3433adec38d948$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height;
    var startAngle = props.startAngle, endAngle = props.endAngle;
    var cx = (0, $ec351366ffe25ce6$export$476354dbf49bdff6)(props.cx, width, width / 2);
    var cy = (0, $ec351366ffe25ce6$export$476354dbf49bdff6)(props.cy, height, height / 2);
    var maxRadius = $8e3433adec38d948$export$ad5c48602371adfa(width, height, offset);
    var innerRadius = (0, $ec351366ffe25ce6$export$476354dbf49bdff6)(props.innerRadius, maxRadius, 0);
    var outerRadius = (0, $ec351366ffe25ce6$export$476354dbf49bdff6)(props.outerRadius, maxRadius, maxRadius * 0.8);
    var ids = Object.keys(axisMap);
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var domain = axis.domain, reversed = axis.reversed;
        var range;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(axis.range)) {
            if (axisType === 'angleAxis') range = [
                startAngle,
                endAngle
            ];
            else if (axisType === 'radiusAxis') range = [
                innerRadius,
                outerRadius
            ];
            if (reversed) range = [
                range[1],
                range[0]
            ];
        } else {
            range = axis.range;
            var _range = range;
            var _range2 = $8e3433adec38d948$var$_slicedToArray(_range, 2);
            startAngle = _range2[0];
            endAngle = _range2[1];
        }
        var _parseScale = (0, $bc60c84815913bd8$export$534b094a708572c1)(axis, chartName), realScaleType = _parseScale.realScaleType, scale = _parseScale.scale;
        scale.domain(domain).range(range);
        (0, $bc60c84815913bd8$export$9d80152e23bae434)(scale);
        var ticks = (0, $bc60c84815913bd8$export$ac086aaa4358d590)(scale, $8e3433adec38d948$var$_objectSpread($8e3433adec38d948$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        var finalAxis = $8e3433adec38d948$var$_objectSpread($8e3433adec38d948$var$_objectSpread($8e3433adec38d948$var$_objectSpread({}, axis), ticks), {}, {
            range: range,
            radius: outerRadius,
            realScaleType: realScaleType,
            scale: scale,
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
        return $8e3433adec38d948$var$_objectSpread($8e3433adec38d948$var$_objectSpread({}, result), {}, $8e3433adec38d948$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $8e3433adec38d948$export$b59117efbc9c7af = function distanceBetweenPoints(point, anotherPoint) {
    var x1 = point.x, y1 = point.y;
    var x2 = anotherPoint.x, y2 = anotherPoint.y;
    return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var $8e3433adec38d948$export$bc42f851bd05a2ae = function getAngleOfPoint(_ref, _ref2) {
    var x = _ref.x, y = _ref.y;
    var cx = _ref2.cx, cy = _ref2.cy;
    var radius = $8e3433adec38d948$export$b59117efbc9c7af({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: $8e3433adec38d948$export$1c20e104e3e29a0a(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var $8e3433adec38d948$export$c8ca70209d427b81 = function formatAngleOfSector(_ref3) {
    var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var $8e3433adec38d948$var$reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
    var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var $8e3433adec38d948$export$e85a2bf8cd31c504 = function inRangeOfSector(_ref5, sector) {
    var x = _ref5.x, y = _ref5.y;
    var _getAngleOfPoint = $8e3433adec38d948$export$bc42f851bd05a2ae({
        x: x,
        y: y
    }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
    var innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
    if (radius < innerRadius || radius > outerRadius) return false;
    if (radius === 0) return true;
    var _formatAngleOfSector = $8e3433adec38d948$export$c8ca70209d427b81(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return $8e3433adec38d948$var$_objectSpread($8e3433adec38d948$var$_objectSpread({}, sector), {}, {
        radius: radius,
        angle: $8e3433adec38d948$var$reverseFormatAngleOfSetor(formatAngle, sector)
    });
    return null;
};
var $8e3433adec38d948$export$88d525dabc04abcd = function getTickClassName(tick) {
    return !/*#__PURE__*/ (0, $8T3gX.isValidElement)(tick) && !(0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(tick) && typeof tick !== 'boolean' ? tick.className : '';
};


function $eb6f3b719cc1691f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $eb6f3b719cc1691f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $eb6f3b719cc1691f$var$_typeof(o);
}
var $eb6f3b719cc1691f$var$_excluded = [
    "offset"
];
function $eb6f3b719cc1691f$var$_toConsumableArray(arr) {
    return $eb6f3b719cc1691f$var$_arrayWithoutHoles(arr) || $eb6f3b719cc1691f$var$_iterableToArray(arr) || $eb6f3b719cc1691f$var$_unsupportedIterableToArray(arr) || $eb6f3b719cc1691f$var$_nonIterableSpread();
}
function $eb6f3b719cc1691f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $eb6f3b719cc1691f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $eb6f3b719cc1691f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $eb6f3b719cc1691f$var$_arrayLikeToArray(o, minLen);
}
function $eb6f3b719cc1691f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $eb6f3b719cc1691f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $eb6f3b719cc1691f$var$_arrayLikeToArray(arr);
}
function $eb6f3b719cc1691f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $eb6f3b719cc1691f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $eb6f3b719cc1691f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $eb6f3b719cc1691f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $eb6f3b719cc1691f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eb6f3b719cc1691f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eb6f3b719cc1691f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $eb6f3b719cc1691f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eb6f3b719cc1691f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $eb6f3b719cc1691f$var$_defineProperty(obj, key, value) {
    key = $eb6f3b719cc1691f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $eb6f3b719cc1691f$var$_toPropertyKey(t) {
    var i = $eb6f3b719cc1691f$var$_toPrimitive(t, "string");
    return "symbol" == $eb6f3b719cc1691f$var$_typeof(i) ? i : i + "";
}
function $eb6f3b719cc1691f$var$_toPrimitive(t, r) {
    if ("object" != $eb6f3b719cc1691f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $eb6f3b719cc1691f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $eb6f3b719cc1691f$var$_extends() {
    $eb6f3b719cc1691f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $eb6f3b719cc1691f$var$_extends.apply(this, arguments);
}
var $eb6f3b719cc1691f$var$getLabel = function getLabel(props) {
    var value = props.value, formatter = props.formatter;
    var label = (0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(props.children) ? value : props.children;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(formatter)) return formatter(label);
    return label;
};
var $eb6f3b719cc1691f$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $ec351366ffe25ce6$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $eb6f3b719cc1691f$var$renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
    var position = labelProps.position, viewBox = labelProps.viewBox, offset = labelProps.offset, className = labelProps.className;
    var _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = $eb6f3b719cc1691f$var$getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    if (position === 'insideStart') {
        labelAngle = startAngle + sign * offset;
        direction = clockWise;
    } else if (position === 'insideEnd') {
        labelAngle = endAngle - sign * offset;
        direction = !clockWise;
    } else if (position === 'end') {
        labelAngle = endAngle + sign * offset;
        direction = clockWise;
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, $8e3433adec38d948$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle);
    var endPoint = (0, $8e3433adec38d948$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(labelProps.id) ? (0, $ec351366ffe25ce6$export$8b15d37bc3f197d4)('recharts-radial-line-') : labelProps.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("text", $eb6f3b719cc1691f$var$_extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, $iVyaN.default)('recharts-radial-bar-label', className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var $eb6f3b719cc1691f$var$getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
    var viewBox = props.viewBox, offset = props.offset, position = props.position;
    var _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === 'outside') {
        var _polarToCartesian = (0, $8e3433adec38d948$export$5c9a959bb3fc7749)(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? 'start' : 'end',
            verticalAnchor: 'middle'
        };
    }
    if (position === 'center') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
    if (position === 'centerTop') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'start'
    };
    if (position === 'centerBottom') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'end'
    };
    var r = (innerRadius + outerRadius) / 2;
    var _polarToCartesian2 = (0, $8e3433adec38d948$export$5c9a959bb3fc7749)(cx, cy, r, midAngle), x = _polarToCartesian2.x, y = _polarToCartesian2.y;
    return {
        x: x,
        y: y,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
};
var $eb6f3b719cc1691f$var$getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
    var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset = props.offset, position = props.position;
    var _ref3 = viewBox, x = _ref3.x, y = _ref3.y, width = _ref3.width, height = _ref3.height;
    // Define vertical offsets and position inverts based on the value being positive or negative
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? 'end' : 'start';
    var verticalStart = verticalSign > 0 ? 'start' : 'end';
    // Define horizontal offsets and position inverts based on the value being positive or negative
    var horizontalSign = width >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? 'end' : 'start';
    var horizontalStart = horizontalSign > 0 ? 'start' : 'end';
    if (position === 'top') {
        var attrs = {
            x: x + width / 2,
            y: y - verticalSign * offset,
            textAnchor: 'middle',
            verticalAnchor: verticalEnd
        };
        return $eb6f3b719cc1691f$var$_objectSpread($eb6f3b719cc1691f$var$_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: width
        } : {});
    }
    if (position === 'bottom') {
        var _attrs = {
            x: x + width / 2,
            y: y + height + verticalOffset,
            textAnchor: 'middle',
            verticalAnchor: verticalStart
        };
        return $eb6f3b719cc1691f$var$_objectSpread($eb6f3b719cc1691f$var$_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: width
        } : {});
    }
    if (position === 'left') {
        var _attrs2 = {
            x: x - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: 'middle'
        };
        return $eb6f3b719cc1691f$var$_objectSpread($eb6f3b719cc1691f$var$_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height
        } : {});
    }
    if (position === 'right') {
        var _attrs3 = {
            x: x + width + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: 'middle'
        };
        return $eb6f3b719cc1691f$var$_objectSpread($eb6f3b719cc1691f$var$_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: width,
        height: height
    } : {};
    if (position === 'insideLeft') return $eb6f3b719cc1691f$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideRight') return $eb6f3b719cc1691f$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideTop') return $eb6f3b719cc1691f$var$_objectSpread({
        x: x + width / 2,
        y: y + verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottom') return $eb6f3b719cc1691f$var$_objectSpread({
        x: x + width / 2,
        y: y + height - verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideTopLeft') return $eb6f3b719cc1691f$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideTopRight') return $eb6f3b719cc1691f$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottomLeft') return $eb6f3b719cc1691f$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideBottomRight') return $eb6f3b719cc1691f$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cd2b0b1294af0960$exports)))(position) && ((0, $ec351366ffe25ce6$export$7e4aa119212bc614)(position.x) || (0, $ec351366ffe25ce6$export$e50269385c77c348)(position.x)) && ((0, $ec351366ffe25ce6$export$7e4aa119212bc614)(position.y) || (0, $ec351366ffe25ce6$export$e50269385c77c348)(position.y))) return $eb6f3b719cc1691f$var$_objectSpread({
        x: x + (0, $ec351366ffe25ce6$export$476354dbf49bdff6)(position.x, width),
        y: y + (0, $ec351366ffe25ce6$export$476354dbf49bdff6)(position.y, height),
        textAnchor: 'end',
        verticalAnchor: 'end'
    }, sizeAttrs);
    return $eb6f3b719cc1691f$var$_objectSpread({
        x: x + width / 2,
        y: y + height / 2,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    }, sizeAttrs);
};
var $eb6f3b719cc1691f$var$isPolar = function isPolar(viewBox) {
    return 'cx' in viewBox && (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(viewBox.cx);
};
function $eb6f3b719cc1691f$export$b04be29aa201d4f5(_ref4) {
    var _ref4$offset = _ref4.offset, offset = _ref4$offset === void 0 ? 5 : _ref4$offset, restProps = $eb6f3b719cc1691f$var$_objectWithoutProperties(_ref4, $eb6f3b719cc1691f$var$_excluded);
    var props = $eb6f3b719cc1691f$var$_objectSpread({
        offset: offset
    }, restProps);
    var viewBox = props.viewBox, position = props.position, value = props.value, children = props.children, content = props.content, _props$className = props.className, className = _props$className === void 0 ? '' : _props$className, textBreakAll = props.textBreakAll;
    if (!viewBox || (0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(value) && (0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(children) && !/*#__PURE__*/ (0, $8T3gX.isValidElement)(content) && !(0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(content)) return null;
    if (/*#__PURE__*/ (0, $8T3gX.isValidElement)(content)) return /*#__PURE__*/ (0, $8T3gX.cloneElement)(content, props);
    var label;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(content)) {
        label = /*#__PURE__*/ (0, $8T3gX.createElement)(content, props);
        if (/*#__PURE__*/ (0, $8T3gX.isValidElement)(label)) return label;
    } else label = $eb6f3b719cc1691f$var$getLabel(props);
    var isPolarLabel = $eb6f3b719cc1691f$var$isPolar(viewBox);
    var attrs = (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(props, true);
    if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) return $eb6f3b719cc1691f$var$renderRadialLabel(props, label, attrs);
    var positionAttrs = isPolarLabel ? $eb6f3b719cc1691f$var$getAttrsOfPolarLabel(props) : $eb6f3b719cc1691f$var$getAttrsOfCartesianLabel(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $46eed3e26c0880f0$export$5f1af8db9871e1d6), $eb6f3b719cc1691f$var$_extends({
        className: (0, $iVyaN.default)('recharts-label', className)
    }, attrs, positionAttrs, {
        breakAll: textBreakAll
    }), label);
}
$eb6f3b719cc1691f$export$b04be29aa201d4f5.displayName = 'Label';
var $eb6f3b719cc1691f$var$parseViewBox = function parseViewBox(props) {
    var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x = props.x, y = props.y, top = props.top, left = props.left, width = props.width, height = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
    if (labelViewBox) return labelViewBox;
    if ((0, $ec351366ffe25ce6$export$7e4aa119212bc614)(width) && (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(height)) {
        if ((0, $ec351366ffe25ce6$export$7e4aa119212bc614)(x) && (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(y)) return {
            x: x,
            y: y,
            width: width,
            height: height
        };
        if ((0, $ec351366ffe25ce6$export$7e4aa119212bc614)(top) && (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(left)) return {
            x: top,
            y: left,
            width: width,
            height: height
        };
    }
    if ((0, $ec351366ffe25ce6$export$7e4aa119212bc614)(x) && (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(y)) return {
        x: x,
        y: y,
        width: 0,
        height: 0
    };
    if ((0, $ec351366ffe25ce6$export$7e4aa119212bc614)(cx) && (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(cy)) return {
        cx: cx,
        cy: cy,
        startAngle: startAngle || angle || 0,
        endAngle: endAngle || angle || 0,
        innerRadius: innerRadius || 0,
        outerRadius: outerRadius || radius || r || 0,
        clockWise: clockWise
    };
    if (props.viewBox) return props.viewBox;
    return {};
};
var $eb6f3b719cc1691f$var$parseLabel = function parseLabel(label, viewBox) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement($eb6f3b719cc1691f$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox
    });
    if ((0, $ec351366ffe25ce6$export$402a499e1ea44294)(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement($eb6f3b719cc1691f$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox,
        value: label
    });
    if (/*#__PURE__*/ (0, $8T3gX.isValidElement)(label)) {
        if (label.type === $eb6f3b719cc1691f$export$b04be29aa201d4f5) return /*#__PURE__*/ (0, $8T3gX.cloneElement)(label, {
            key: 'label-implicit',
            viewBox: viewBox
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement($eb6f3b719cc1691f$export$b04be29aa201d4f5, {
            key: "label-implicit",
            content: label,
            viewBox: viewBox
        });
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement($eb6f3b719cc1691f$export$b04be29aa201d4f5, {
        key: "label-implicit",
        content: label,
        viewBox: viewBox
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cd2b0b1294af0960$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement($eb6f3b719cc1691f$export$b04be29aa201d4f5, $eb6f3b719cc1691f$var$_extends({
        viewBox: viewBox
    }, label, {
        key: "label-implicit"
    }));
    return null;
};
var $eb6f3b719cc1691f$var$renderCallByParent = function renderCallByParent(parentProps, viewBox) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var parentViewBox = $eb6f3b719cc1691f$var$parseViewBox(parentProps);
    var explicitChildren = (0, $10636f1b3e62ab88$export$fdd5e64c0e8495bb)(children, $eb6f3b719cc1691f$export$b04be29aa201d4f5).map(function(child, index) {
        return /*#__PURE__*/ (0, $8T3gX.cloneElement)(child, {
            viewBox: viewBox || parentViewBox,
            // eslint-disable-next-line react/no-array-index-key
            key: "label-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabel = $eb6f3b719cc1691f$var$parseLabel(parentProps.label, viewBox || parentViewBox);
    return [
        implicitLabel
    ].concat($eb6f3b719cc1691f$var$_toConsumableArray(explicitChildren));
};
$eb6f3b719cc1691f$export$b04be29aa201d4f5.parseViewBox = $eb6f3b719cc1691f$var$parseViewBox;
$eb6f3b719cc1691f$export$b04be29aa201d4f5.renderCallByParent = $eb6f3b719cc1691f$var$renderCallByParent;





function $1778bc5734fdac4c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1778bc5734fdac4c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1778bc5734fdac4c$var$_typeof(o);
}
var $1778bc5734fdac4c$var$_excluded = [
    "valueAccessor"
], $1778bc5734fdac4c$var$_excluded2 = [
    "data",
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll"
];
function $1778bc5734fdac4c$var$_toConsumableArray(arr) {
    return $1778bc5734fdac4c$var$_arrayWithoutHoles(arr) || $1778bc5734fdac4c$var$_iterableToArray(arr) || $1778bc5734fdac4c$var$_unsupportedIterableToArray(arr) || $1778bc5734fdac4c$var$_nonIterableSpread();
}
function $1778bc5734fdac4c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1778bc5734fdac4c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1778bc5734fdac4c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1778bc5734fdac4c$var$_arrayLikeToArray(o, minLen);
}
function $1778bc5734fdac4c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $1778bc5734fdac4c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1778bc5734fdac4c$var$_arrayLikeToArray(arr);
}
function $1778bc5734fdac4c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1778bc5734fdac4c$var$_extends() {
    $1778bc5734fdac4c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1778bc5734fdac4c$var$_extends.apply(this, arguments);
}
function $1778bc5734fdac4c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1778bc5734fdac4c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1778bc5734fdac4c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1778bc5734fdac4c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1778bc5734fdac4c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1778bc5734fdac4c$var$_defineProperty(obj, key, value) {
    key = $1778bc5734fdac4c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1778bc5734fdac4c$var$_toPropertyKey(t) {
    var i = $1778bc5734fdac4c$var$_toPrimitive(t, "string");
    return "symbol" == $1778bc5734fdac4c$var$_typeof(i) ? i : i + "";
}
function $1778bc5734fdac4c$var$_toPrimitive(t, r) {
    if ("object" != $1778bc5734fdac4c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1778bc5734fdac4c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1778bc5734fdac4c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1778bc5734fdac4c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1778bc5734fdac4c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $1778bc5734fdac4c$var$defaultAccessor = function defaultAccessor(entry) {
    return Array.isArray(entry.value) ? (0, (/*@__PURE__*/$parcel$interopDefault($c8275cc063b9781c$exports)))(entry.value) : entry.value;
};
function $1778bc5734fdac4c$export$835fcf23ab7bf88(_ref) {
    var _ref$valueAccessor = _ref.valueAccessor, valueAccessor = _ref$valueAccessor === void 0 ? $1778bc5734fdac4c$var$defaultAccessor : _ref$valueAccessor, restProps = $1778bc5734fdac4c$var$_objectWithoutProperties(_ref, $1778bc5734fdac4c$var$_excluded);
    var data = restProps.data, dataKey = restProps.dataKey, clockWise = restProps.clockWise, id = restProps.id, textBreakAll = restProps.textBreakAll, others = $1778bc5734fdac4c$var$_objectWithoutProperties(restProps, $1778bc5734fdac4c$var$_excluded2);
    if (!data || !data.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $3366a7250677b47e$export$936d0764594b6eb3), {
        className: "recharts-label-list"
    }, data.map(function(entry, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(dataKey) ? valueAccessor(entry, index) : (0, $bc60c84815913bd8$export$f97fc4a450f29a)(entry && entry.payload, dataKey);
        var idProps = (0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $eb6f3b719cc1691f$export$b04be29aa201d4f5), $1778bc5734fdac4c$var$_extends({}, (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(entry, true), others, idProps, {
            parentViewBox: entry.parentViewBox,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: (0, $eb6f3b719cc1691f$export$b04be29aa201d4f5).parseViewBox((0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(clockWise) ? entry : $1778bc5734fdac4c$var$_objectSpread($1778bc5734fdac4c$var$_objectSpread({}, entry), {}, {
                clockWise: clockWise
            })),
            key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
            ,
            index: index
        }));
    }));
}
$1778bc5734fdac4c$export$835fcf23ab7bf88.displayName = 'LabelList';
function $1778bc5734fdac4c$var$parseLabelList(label, data) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement($1778bc5734fdac4c$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data
    });
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).isValidElement(label) || (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement($1778bc5734fdac4c$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data,
        content: label
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cd2b0b1294af0960$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement($1778bc5734fdac4c$export$835fcf23ab7bf88, $1778bc5734fdac4c$var$_extends({
        data: data
    }, label, {
        key: "labelList-implicit"
    }));
    return null;
}
function $1778bc5734fdac4c$var$renderCallByParent(parentProps, data) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var explicitChildren = (0, $10636f1b3e62ab88$export$fdd5e64c0e8495bb)(children, $1778bc5734fdac4c$export$835fcf23ab7bf88).map(function(child, index) {
        return /*#__PURE__*/ (0, $8T3gX.cloneElement)(child, {
            data: data,
            // eslint-disable-next-line react/no-array-index-key
            key: "labelList-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabelList = $1778bc5734fdac4c$var$parseLabelList(parentProps.label, data);
    return [
        implicitLabelList
    ].concat($1778bc5734fdac4c$var$_toConsumableArray(explicitChildren));
}
$1778bc5734fdac4c$export$835fcf23ab7bf88.renderCallByParent = $1778bc5734fdac4c$var$renderCallByParent;








var $8T3gX = parcelRequire("8T3gX");


var $8T3gX = parcelRequire("8T3gX");

var $2537df67cd52c170$exports = {};

var $35bf467654165918$exports = {};

/** Built-in value references. */ var $35bf467654165918$var$getPrototype = $ea458d5b09fec244$exports(Object.getPrototypeOf, Object);
$35bf467654165918$exports = $35bf467654165918$var$getPrototype;



/** `Object#toString` result references. */ var $2537df67cd52c170$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $2537df67cd52c170$var$funcProto = Function.prototype, $2537df67cd52c170$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $2537df67cd52c170$var$funcToString = $2537df67cd52c170$var$funcProto.toString;
/** Used to check objects for own properties. */ var $2537df67cd52c170$var$hasOwnProperty = $2537df67cd52c170$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $2537df67cd52c170$var$objectCtorString = $2537df67cd52c170$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $2537df67cd52c170$var$isPlainObject(value) {
    if (!$65ef2014975340ff$exports(value) || $4003a8f3ae86bec1$exports(value) != $2537df67cd52c170$var$objectTag) return false;
    var proto = $35bf467654165918$exports(value);
    if (proto === null) return true;
    var Ctor = $2537df67cd52c170$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $2537df67cd52c170$var$funcToString.call(Ctor) == $2537df67cd52c170$var$objectCtorString;
}
$2537df67cd52c170$exports = $2537df67cd52c170$var$isPlainObject;


var $0c6f57f188dee375$exports = {};


/** `Object#toString` result references. */ var $0c6f57f188dee375$var$boolTag = '[object Boolean]';
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $0c6f57f188dee375$var$isBoolean(value) {
    return value === true || value === false || $65ef2014975340ff$exports(value) && $4003a8f3ae86bec1$exports(value) == $0c6f57f188dee375$var$boolTag;
}
$0c6f57f188dee375$exports = $0c6f57f188dee375$var$isBoolean;




var $8T3gX = parcelRequire("8T3gX");

var $iVyaN = parcelRequire("iVyaN");


function $0ab2d840c2839083$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0ab2d840c2839083$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0ab2d840c2839083$var$_typeof(o);
}
function $0ab2d840c2839083$var$_extends() {
    $0ab2d840c2839083$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0ab2d840c2839083$var$_extends.apply(this, arguments);
}
function $0ab2d840c2839083$var$_slicedToArray(arr, i) {
    return $0ab2d840c2839083$var$_arrayWithHoles(arr) || $0ab2d840c2839083$var$_iterableToArrayLimit(arr, i) || $0ab2d840c2839083$var$_unsupportedIterableToArray(arr, i) || $0ab2d840c2839083$var$_nonIterableRest();
}
function $0ab2d840c2839083$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0ab2d840c2839083$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0ab2d840c2839083$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0ab2d840c2839083$var$_arrayLikeToArray(o, minLen);
}
function $0ab2d840c2839083$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0ab2d840c2839083$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $0ab2d840c2839083$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $0ab2d840c2839083$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0ab2d840c2839083$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0ab2d840c2839083$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0ab2d840c2839083$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0ab2d840c2839083$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0ab2d840c2839083$var$_defineProperty(obj, key, value) {
    key = $0ab2d840c2839083$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0ab2d840c2839083$var$_toPropertyKey(t) {
    var i = $0ab2d840c2839083$var$_toPrimitive(t, "string");
    return "symbol" == $0ab2d840c2839083$var$_typeof(i) ? i : i + "";
}
function $0ab2d840c2839083$var$_toPrimitive(t, r) {
    if ("object" != $0ab2d840c2839083$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0ab2d840c2839083$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $0ab2d840c2839083$var$getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
    var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
    var ySign = height >= 0 ? 1 : -1;
    var xSign = width >= 0 ? 1 : -1;
    var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
        path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
        if (newRadius[1] > 0) path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
        path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
        path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
        if (newRadius[3] > 0) path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
        path += 'Z';
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
    } else path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
    return path;
};
var $0ab2d840c2839083$export$f783d19325be51d5 = function isInRectangle(point, rect) {
    if (!point || !rect) return false;
    var px = point.x, py = point.y;
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    if (Math.abs(width) > 0 && Math.abs(height) > 0) {
        var minX = Math.min(x, x + width);
        var maxX = Math.max(x, x + width);
        var minY = Math.min(y, y + height);
        var maxY = Math.max(y, y + height);
        return px >= minX && px <= maxX && py >= minY && py <= maxY;
    }
    return false;
};
var $0ab2d840c2839083$var$defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $0ab2d840c2839083$export$4617fb02663045ef = function Rectangle(rectangleProps) {
    var props = $0ab2d840c2839083$var$_objectSpread($0ab2d840c2839083$var$_objectSpread({}, $0ab2d840c2839083$var$defaultProps), rectangleProps);
    var pathRef = (0, $8T3gX.useRef)();
    var _useState = (0, $8T3gX.useState)(-1), _useState2 = $0ab2d840c2839083$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $8T3gX.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = props.x, y = props.y, width = props.width, height = props.height, radius = props.radius, className = props.className;
    var animationEasing = props.animationEasing, animationDuration = props.animationDuration, animationBegin = props.animationBegin, isAnimationActive = props.isAnimationActive, isUpdateAnimationActive = props.isUpdateAnimationActive;
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, $iVyaN.default)('recharts-rectangle', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("path", $0ab2d840c2839083$var$_extends({}, (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: $0ab2d840c2839083$var$getRectanglePath(x, y, width, height, radius)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $ab29ae7e0941d876$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        to: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $ab29ae7e0941d876$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            isActive: isAnimationActive,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("path", $0ab2d840c2839083$var$_extends({}, (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(props, true), {
            className: layerClass,
            d: $0ab2d840c2839083$var$getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef
        })));
    });
};



var $8T3gX = parcelRequire("8T3gX");

var $iVyaN = parcelRequire("iVyaN");


function $3694f5183c81b138$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3694f5183c81b138$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3694f5183c81b138$var$_typeof(o);
}
function $3694f5183c81b138$var$_extends() {
    $3694f5183c81b138$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3694f5183c81b138$var$_extends.apply(this, arguments);
}
function $3694f5183c81b138$var$_slicedToArray(arr, i) {
    return $3694f5183c81b138$var$_arrayWithHoles(arr) || $3694f5183c81b138$var$_iterableToArrayLimit(arr, i) || $3694f5183c81b138$var$_unsupportedIterableToArray(arr, i) || $3694f5183c81b138$var$_nonIterableRest();
}
function $3694f5183c81b138$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3694f5183c81b138$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3694f5183c81b138$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3694f5183c81b138$var$_arrayLikeToArray(o, minLen);
}
function $3694f5183c81b138$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3694f5183c81b138$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $3694f5183c81b138$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3694f5183c81b138$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3694f5183c81b138$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3694f5183c81b138$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3694f5183c81b138$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3694f5183c81b138$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3694f5183c81b138$var$_defineProperty(obj, key, value) {
    key = $3694f5183c81b138$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3694f5183c81b138$var$_toPropertyKey(t) {
    var i = $3694f5183c81b138$var$_toPrimitive(t, "string");
    return "symbol" == $3694f5183c81b138$var$_typeof(i) ? i : i + "";
}
function $3694f5183c81b138$var$_toPrimitive(t, r) {
    if ("object" != $3694f5183c81b138$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3694f5183c81b138$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $3694f5183c81b138$var$getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
    var widthGap = upperWidth - lowerWidth;
    var path;
    path = "M ".concat(x, ",").concat(y);
    path += "L ".concat(x + upperWidth, ",").concat(y);
    path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
    path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
    path += "L ".concat(x, ",").concat(y, " Z");
    return path;
};
var $3694f5183c81b138$var$defaultProps = {
    x: 0,
    y: 0,
    upperWidth: 0,
    lowerWidth: 0,
    height: 0,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var $3694f5183c81b138$export$d1ed33dc592f5337 = function Trapezoid(props) {
    var trapezoidProps = $3694f5183c81b138$var$_objectSpread($3694f5183c81b138$var$_objectSpread({}, $3694f5183c81b138$var$defaultProps), props);
    var pathRef = (0, $8T3gX.useRef)();
    var _useState = (0, $8T3gX.useState)(-1), _useState2 = $3694f5183c81b138$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $8T3gX.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = trapezoidProps.x, y = trapezoidProps.y, upperWidth = trapezoidProps.upperWidth, lowerWidth = trapezoidProps.lowerWidth, height = trapezoidProps.height, className = trapezoidProps.className;
    var animationEasing = trapezoidProps.animationEasing, animationDuration = trapezoidProps.animationDuration, animationBegin = trapezoidProps.animationBegin, isUpdateAnimationActive = trapezoidProps.isUpdateAnimationActive;
    if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) return null;
    var layerClass = (0, $iVyaN.default)('recharts-trapezoid', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("path", $3694f5183c81b138$var$_extends({}, (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(trapezoidProps, true), {
        className: layerClass,
        d: $3694f5183c81b138$var$getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $ab29ae7e0941d876$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            upperWidth: 0,
            lowerWidth: 0,
            height: height,
            x: x,
            y: y
        },
        to: {
            upperWidth: upperWidth,
            lowerWidth: lowerWidth,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currUpperWidth = _ref.upperWidth, currLowerWidth = _ref.lowerWidth, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $ab29ae7e0941d876$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("path", $3694f5183c81b138$var$_extends({}, (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(trapezoidProps, true), {
            className: layerClass,
            d: $3694f5183c81b138$var$getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
            ref: pathRef
        })));
    });
};



var $8T3gX = parcelRequire("8T3gX");

var $iVyaN = parcelRequire("iVyaN");



function $fd3fe470e36b9343$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fd3fe470e36b9343$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fd3fe470e36b9343$var$_typeof(o);
}
function $fd3fe470e36b9343$var$_extends() {
    $fd3fe470e36b9343$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fd3fe470e36b9343$var$_extends.apply(this, arguments);
}
function $fd3fe470e36b9343$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fd3fe470e36b9343$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fd3fe470e36b9343$var$ownKeys(Object(t), !0).forEach(function(r) {
            $fd3fe470e36b9343$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fd3fe470e36b9343$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fd3fe470e36b9343$var$_defineProperty(obj, key, value) {
    key = $fd3fe470e36b9343$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fd3fe470e36b9343$var$_toPropertyKey(t) {
    var i = $fd3fe470e36b9343$var$_toPrimitive(t, "string");
    return "symbol" == $fd3fe470e36b9343$var$_typeof(i) ? i : i + "";
}
function $fd3fe470e36b9343$var$_toPrimitive(t, r) {
    if ("object" != $fd3fe470e36b9343$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $fd3fe470e36b9343$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $fd3fe470e36b9343$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $ec351366ffe25ce6$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var $fd3fe470e36b9343$var$getTangentCircle = function getTangentCircle(_ref) {
    var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, $8e3433adec38d948$export$d74e8f7e9cc3fed3);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, $8e3433adec38d948$export$5c9a959bb3fc7749)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, $8e3433adec38d948$export$5c9a959bb3fc7749)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, $8e3433adec38d948$export$5c9a959bb3fc7749)(cx, cy, centerRadius * Math.cos(theta * (0, $8e3433adec38d948$export$d74e8f7e9cc3fed3)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var $fd3fe470e36b9343$var$getSectorPath = function getSectorPath(_ref2) {
    var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var angle = $fd3fe470e36b9343$var$getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, $8e3433adec38d948$export$5c9a959bb3fc7749)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, $8e3433adec38d948$export$5c9a959bb3fc7749)(cx, cy, outerRadius, tempEndAngle);
    var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
    if (innerRadius > 0) {
        var innerStartPoint = (0, $8e3433adec38d948$export$5c9a959bb3fc7749)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, $8e3433adec38d948$export$5c9a959bb3fc7749)(cx, cy, innerRadius, tempEndAngle);
        path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
    } else path += "L ".concat(cx, ",").concat(cy, " Z");
    return path;
};
var $fd3fe470e36b9343$var$getSectorWithCorner = function getSectorWithCorner(_ref3) {
    var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var sign = (0, $ec351366ffe25ce6$export$9d334328eb75e624)(endAngle - startAngle);
    var _getTangentCircle = $fd3fe470e36b9343$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
    var _getTangentCircle2 = $fd3fe470e36b9343$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
        return $fd3fe470e36b9343$var$getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
    if (innerRadius > 0) {
        var _getTangentCircle3 = $fd3fe470e36b9343$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
        var _getTangentCircle4 = $fd3fe470e36b9343$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
    } else path += "L".concat(cx, ",").concat(cy, "Z");
    return path;
};
var $fd3fe470e36b9343$var$defaultProps = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};
var $fd3fe470e36b9343$export$e98c2c7eb2b14f45 = function Sector(sectorProps) {
    var props = $fd3fe470e36b9343$var$_objectSpread($fd3fe470e36b9343$var$_objectSpread({}, $fd3fe470e36b9343$var$defaultProps), sectorProps);
    var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, cornerRadius = props.cornerRadius, forceCornerRadius = props.forceCornerRadius, cornerIsExternal = props.cornerIsExternal, startAngle = props.startAngle, endAngle = props.endAngle, className = props.className;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, $iVyaN.default)('recharts-sector', className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, $ec351366ffe25ce6$export$476354dbf49bdff6)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = $fd3fe470e36b9343$var$getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = $fd3fe470e36b9343$var$getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("path", $fd3fe470e36b9343$var$_extends({}, (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: path,
        role: "img"
    }));
};




var $8de249487f1d36dd$var$_excluded = [
    "option",
    "shapeType",
    "propTransformer",
    "activeClassName",
    "isActive"
];
function $8de249487f1d36dd$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8de249487f1d36dd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8de249487f1d36dd$var$_typeof(o);
}
function $8de249487f1d36dd$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8de249487f1d36dd$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8de249487f1d36dd$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8de249487f1d36dd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8de249487f1d36dd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8de249487f1d36dd$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8de249487f1d36dd$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8de249487f1d36dd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8de249487f1d36dd$var$_defineProperty(obj, key, value) {
    key = $8de249487f1d36dd$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8de249487f1d36dd$var$_toPropertyKey(t) {
    var i = $8de249487f1d36dd$var$_toPrimitive(t, "string");
    return "symbol" == $8de249487f1d36dd$var$_typeof(i) ? i : i + "";
}
function $8de249487f1d36dd$var$_toPrimitive(t, r) {
    if ("object" != $8de249487f1d36dd$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8de249487f1d36dd$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * This is an abstraction for rendering a user defined prop for a customized shape in several forms.
 *
 * <Shape /> is the root and will handle taking in:
 *  - an object of svg properties
 *  - a boolean
 *  - a render prop(inline function that returns jsx)
 *  - a react element
 *
 * <ShapeSelector /> is a subcomponent of <Shape /> and used to match a component
 * to the value of props.shapeType that is passed to the root.
 *
 */ function $8de249487f1d36dd$var$defaultPropTransformer(option, props) {
    return $8de249487f1d36dd$var$_objectSpread($8de249487f1d36dd$var$_objectSpread({}, props), option);
}
function $8de249487f1d36dd$var$isSymbolsProps(shapeType, _elementProps) {
    return shapeType === 'symbols';
}
function $8de249487f1d36dd$var$ShapeSelector(_ref) {
    var shapeType = _ref.shapeType, elementProps = _ref.elementProps;
    switch(shapeType){
        case 'rectangle':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $0ab2d840c2839083$export$4617fb02663045ef), elementProps);
        case 'trapezoid':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $3694f5183c81b138$export$d1ed33dc592f5337), elementProps);
        case 'sector':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $fd3fe470e36b9343$export$e98c2c7eb2b14f45), elementProps);
        case 'symbols':
            if ($8de249487f1d36dd$var$isSymbolsProps(shapeType, elementProps)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $d1f791143049a74c$export$fa456266707bf4e4), elementProps);
            break;
        default:
            return null;
    }
}
function $8de249487f1d36dd$export$33c4f706a443da24(option) {
    if (/*#__PURE__*/ (0, $8T3gX.isValidElement)(option)) return option.props;
    return option;
}
function $8de249487f1d36dd$export$6428a7f2611ef1fa(_ref2) {
    var option = _ref2.option, shapeType = _ref2.shapeType, _ref2$propTransformer = _ref2.propTransformer, propTransformer = _ref2$propTransformer === void 0 ? $8de249487f1d36dd$var$defaultPropTransformer : _ref2$propTransformer, _ref2$activeClassName = _ref2.activeClassName, activeClassName = _ref2$activeClassName === void 0 ? 'recharts-active-shape' : _ref2$activeClassName, isActive = _ref2.isActive, props = $8de249487f1d36dd$var$_objectWithoutProperties(_ref2, $8de249487f1d36dd$var$_excluded);
    var shape;
    if (/*#__PURE__*/ (0, $8T3gX.isValidElement)(option)) shape = /*#__PURE__*/ (0, $8T3gX.cloneElement)(option, $8de249487f1d36dd$var$_objectSpread($8de249487f1d36dd$var$_objectSpread({}, props), $8de249487f1d36dd$export$33c4f706a443da24(option)));
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(option)) shape = option(props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($2537df67cd52c170$exports)))(option) && !(0, (/*@__PURE__*/$parcel$interopDefault($0c6f57f188dee375$exports)))(option)) {
        var nextProps = propTransformer(option, props);
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement($8de249487f1d36dd$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: nextProps
        });
    } else {
        var elementProps = props;
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement($8de249487f1d36dd$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: elementProps
        });
    }
    if (isActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $3366a7250677b47e$export$936d0764594b6eb3), {
        className: activeClassName
    }, shape);
    return shape;
}
function $8de249487f1d36dd$export$4b83e8415af38a18(graphicalItem, _item) {
    return _item != null && 'trapezoids' in graphicalItem.props;
}
function $8de249487f1d36dd$export$f722d7e63cc07b(graphicalItem, _item) {
    return _item != null && 'sectors' in graphicalItem.props;
}
function $8de249487f1d36dd$export$f62b21bcfd1a733e(graphicalItem, _item) {
    return _item != null && 'points' in graphicalItem.props;
}
function $8de249487f1d36dd$export$7c9a98b3f068686f(shapeData, activeTooltipItem) {
    var _activeTooltipItem$la, _activeTooltipItem$la2;
    var xMatches = shapeData.x === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la === void 0 ? void 0 : _activeTooltipItem$la.x) || shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la2 = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la2 === void 0 ? void 0 : _activeTooltipItem$la2.y) || shapeData.y === activeTooltipItem.y;
    return xMatches && yMatches;
}
function $8de249487f1d36dd$export$b356b51e8337a02f(shapeData, activeTooltipItem) {
    var startAngleMatches = shapeData.endAngle === activeTooltipItem.endAngle;
    var endAngleMatches = shapeData.startAngle === activeTooltipItem.startAngle;
    return startAngleMatches && endAngleMatches;
}
function $8de249487f1d36dd$export$559c3a78b4889350(shapeData, activeTooltipItem) {
    var xMatches = shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === activeTooltipItem.y;
    var zMatches = shapeData.z === activeTooltipItem.z;
    return xMatches && yMatches && zMatches;
}
function $8de249487f1d36dd$var$getComparisonFn(graphicalItem, activeItem) {
    var comparison;
    if ($8de249487f1d36dd$export$4b83e8415af38a18(graphicalItem, activeItem)) comparison = $8de249487f1d36dd$export$7c9a98b3f068686f;
    else if ($8de249487f1d36dd$export$f722d7e63cc07b(graphicalItem, activeItem)) comparison = $8de249487f1d36dd$export$b356b51e8337a02f;
    else if ($8de249487f1d36dd$export$f62b21bcfd1a733e(graphicalItem, activeItem)) comparison = $8de249487f1d36dd$export$559c3a78b4889350;
    return comparison;
}
function $8de249487f1d36dd$var$getShapeDataKey(graphicalItem, activeItem) {
    var shapeKey;
    if ($8de249487f1d36dd$export$4b83e8415af38a18(graphicalItem, activeItem)) shapeKey = 'trapezoids';
    else if ($8de249487f1d36dd$export$f722d7e63cc07b(graphicalItem, activeItem)) shapeKey = 'sectors';
    else if ($8de249487f1d36dd$export$f62b21bcfd1a733e(graphicalItem, activeItem)) shapeKey = 'points';
    return shapeKey;
}
function $8de249487f1d36dd$var$getActiveShapeTooltipPayload(graphicalItem, activeItem) {
    if ($8de249487f1d36dd$export$4b83e8415af38a18(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa;
        return (_activeItem$tooltipPa = activeItem.tooltipPayload) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa[0]) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa.payload) === null || _activeItem$tooltipPa === void 0 ? void 0 : _activeItem$tooltipPa.payload;
    }
    if ($8de249487f1d36dd$export$f722d7e63cc07b(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa2;
        return (_activeItem$tooltipPa2 = activeItem.tooltipPayload) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2[0]) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2.payload) === null || _activeItem$tooltipPa2 === void 0 ? void 0 : _activeItem$tooltipPa2.payload;
    }
    if ($8de249487f1d36dd$export$f62b21bcfd1a733e(graphicalItem, activeItem)) return activeItem.payload;
    return {};
}
function $8de249487f1d36dd$export$bd5d63c57ca4468(_ref3) {
    var activeTooltipItem = _ref3.activeTooltipItem, graphicalItem = _ref3.graphicalItem, itemData = _ref3.itemData;
    var shapeKey = $8de249487f1d36dd$var$getShapeDataKey(graphicalItem, activeTooltipItem);
    var tooltipPayload = $8de249487f1d36dd$var$getActiveShapeTooltipPayload(graphicalItem, activeTooltipItem);
    var activeItemMatches = itemData.filter(function(datum, dataIndex) {
        var valuesMatch = (0, (/*@__PURE__*/$parcel$interopDefault($c9cb355ea2786d76$exports)))(tooltipPayload, datum);
        var mouseCoordinateMatches = graphicalItem.props[shapeKey].filter(function(shapeData) {
            var comparison = $8de249487f1d36dd$var$getComparisonFn(graphicalItem, activeTooltipItem);
            return comparison(shapeData, activeTooltipItem);
        });
        // get the last index in case of multiple matches
        var indexOfMouseCoordinates = graphicalItem.props[shapeKey].indexOf(mouseCoordinateMatches[mouseCoordinateMatches.length - 1]);
        var coordinatesMatch = dataIndex === indexOfMouseCoordinates;
        return valuesMatch && coordinatesMatch;
    });
    // get the last index in case of multiple matches
    var activeIndex = itemData.indexOf(activeItemMatches[activeItemMatches.length - 1]);
    return activeIndex;
}



var $de9c498aaf767413$var$_excluded = [
    "x",
    "y"
];
function $de9c498aaf767413$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $de9c498aaf767413$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $de9c498aaf767413$var$_typeof(o);
}
function $de9c498aaf767413$var$_extends() {
    $de9c498aaf767413$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $de9c498aaf767413$var$_extends.apply(this, arguments);
}
function $de9c498aaf767413$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $de9c498aaf767413$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $de9c498aaf767413$var$ownKeys(Object(t), !0).forEach(function(r) {
            $de9c498aaf767413$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $de9c498aaf767413$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $de9c498aaf767413$var$_defineProperty(obj, key, value) {
    key = $de9c498aaf767413$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $de9c498aaf767413$var$_toPropertyKey(t) {
    var i = $de9c498aaf767413$var$_toPrimitive(t, "string");
    return "symbol" == $de9c498aaf767413$var$_typeof(i) ? i : i + "";
}
function $de9c498aaf767413$var$_toPrimitive(t, r) {
    if ("object" != $de9c498aaf767413$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $de9c498aaf767413$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $de9c498aaf767413$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $de9c498aaf767413$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $de9c498aaf767413$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Rectangle props is expecting x, y, height, width as numbers, name as a string, and radius as a custom type
// When props are being spread in from a user defined component in Bar,
// the prop types of an SVGElement have these typed as something else.
// This function will return the passed in props
// along with x, y, height as numbers, name as a string, and radius as number | [number, number, number, number]
function $de9c498aaf767413$var$typeguardBarRectangleProps(_ref, props) {
    var xProp = _ref.x, yProp = _ref.y, option = $de9c498aaf767413$var$_objectWithoutProperties(_ref, $de9c498aaf767413$var$_excluded);
    var xValue = "".concat(xProp);
    var x = parseInt(xValue, 10);
    var yValue = "".concat(yProp);
    var y = parseInt(yValue, 10);
    var heightValue = "".concat(props.height || option.height);
    var height = parseInt(heightValue, 10);
    var widthValue = "".concat(props.width || option.width);
    var width = parseInt(widthValue, 10);
    return $de9c498aaf767413$var$_objectSpread($de9c498aaf767413$var$_objectSpread($de9c498aaf767413$var$_objectSpread($de9c498aaf767413$var$_objectSpread($de9c498aaf767413$var$_objectSpread({}, props), option), x ? {
        x: x
    } : {}), y ? {
        y: y
    } : {}), {}, {
        height: height,
        width: width,
        name: props.name,
        radius: props.radius
    });
}
function $de9c498aaf767413$export$f19074a6842f9217(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $8de249487f1d36dd$export$6428a7f2611ef1fa), $de9c498aaf767413$var$_extends({
        shapeType: "rectangle",
        propTransformer: $de9c498aaf767413$var$typeguardBarRectangleProps,
        activeClassName: "recharts-active-bar"
    }, props));
}
var $de9c498aaf767413$export$c20d73790de171f0 = function minPointSizeCallback(minPointSize) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return function(value, index) {
        if (typeof minPointSize === 'number') return minPointSize;
        var isValueNumberOrNil = (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(value) || (0, $ec351366ffe25ce6$export$b931b78cbb3caf86)(value);
        if (isValueNumberOrNil) return minPointSize(value, index);
        !isValueNumberOrNil && (0, $668d778f3ad25eac$export$2e2bcd8739ae039)(false, "minPointSize callback function received a value with type of ".concat($de9c498aaf767413$var$_typeof(value), ". Currently only numbers or null/undefined are supported."));
        return defaultValue;
    };
};


var $7d5fe63ca2eb078d$var$_excluded = [
    "value",
    "background"
];
var $7d5fe63ca2eb078d$var$_Bar;
function $7d5fe63ca2eb078d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7d5fe63ca2eb078d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7d5fe63ca2eb078d$var$_typeof(o);
}
function $7d5fe63ca2eb078d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7d5fe63ca2eb078d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $7d5fe63ca2eb078d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7d5fe63ca2eb078d$var$_extends() {
    $7d5fe63ca2eb078d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7d5fe63ca2eb078d$var$_extends.apply(this, arguments);
}
function $7d5fe63ca2eb078d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7d5fe63ca2eb078d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7d5fe63ca2eb078d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7d5fe63ca2eb078d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7d5fe63ca2eb078d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7d5fe63ca2eb078d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7d5fe63ca2eb078d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7d5fe63ca2eb078d$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7d5fe63ca2eb078d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7d5fe63ca2eb078d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7d5fe63ca2eb078d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7d5fe63ca2eb078d$var$_callSuper(t, o, e) {
    return o = $7d5fe63ca2eb078d$var$_getPrototypeOf(o), $7d5fe63ca2eb078d$var$_possibleConstructorReturn(t, $7d5fe63ca2eb078d$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $7d5fe63ca2eb078d$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $7d5fe63ca2eb078d$var$_possibleConstructorReturn(self, call) {
    if (call && ($7d5fe63ca2eb078d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $7d5fe63ca2eb078d$var$_assertThisInitialized(self);
}
function $7d5fe63ca2eb078d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7d5fe63ca2eb078d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7d5fe63ca2eb078d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $7d5fe63ca2eb078d$var$_getPrototypeOf(o) {
    $7d5fe63ca2eb078d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7d5fe63ca2eb078d$var$_getPrototypeOf(o);
}
function $7d5fe63ca2eb078d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $7d5fe63ca2eb078d$var$_setPrototypeOf(subClass, superClass);
}
function $7d5fe63ca2eb078d$var$_setPrototypeOf(o, p) {
    $7d5fe63ca2eb078d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7d5fe63ca2eb078d$var$_setPrototypeOf(o, p);
}
function $7d5fe63ca2eb078d$var$_defineProperty(obj, key, value) {
    key = $7d5fe63ca2eb078d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7d5fe63ca2eb078d$var$_toPropertyKey(t) {
    var i = $7d5fe63ca2eb078d$var$_toPrimitive(t, "string");
    return "symbol" == $7d5fe63ca2eb078d$var$_typeof(i) ? i : i + "";
}
function $7d5fe63ca2eb078d$var$_toPrimitive(t, r) {
    if ("object" != $7d5fe63ca2eb078d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $7d5fe63ca2eb078d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $7d5fe63ca2eb078d$export$bbc6c6369b38e3d1 = /*#__PURE__*/ function(_PureComponent) {
    function Bar() {
        var _this;
        $7d5fe63ca2eb078d$var$_classCallCheck(this, Bar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $7d5fe63ca2eb078d$var$_callSuper(this, Bar, [].concat(args));
        $7d5fe63ca2eb078d$var$_defineProperty(_this, "state", {
            isAnimationFinished: false
        });
        $7d5fe63ca2eb078d$var$_defineProperty(_this, "id", (0, $ec351366ffe25ce6$export$8b15d37bc3f197d4)('recharts-bar-'));
        $7d5fe63ca2eb078d$var$_defineProperty(_this, "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if (onAnimationEnd) onAnimationEnd();
        });
        $7d5fe63ca2eb078d$var$_defineProperty(_this, "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if (onAnimationStart) onAnimationStart();
        });
        return _this;
    }
    $7d5fe63ca2eb078d$var$_inherits(Bar, _PureComponent);
    return $7d5fe63ca2eb078d$var$_createClass(Bar, [
        {
            key: "renderRectanglesStatically",
            value: function renderRectanglesStatically(data) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, dataKey = _this$props.dataKey, activeIndex = _this$props.activeIndex, activeBar = _this$props.activeBar;
                var baseProps = (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(this.props, false);
                return data && data.map(function(entry, i) {
                    var isActive = i === activeIndex;
                    var option = isActive ? activeBar : shape;
                    var props = $7d5fe63ca2eb078d$var$_objectSpread($7d5fe63ca2eb078d$var$_objectSpread($7d5fe63ca2eb078d$var$_objectSpread({}, baseProps), entry), {}, {
                        isActive: isActive,
                        option: option,
                        index: i,
                        dataKey: dataKey,
                        onAnimationStart: _this2.handleAnimationStart,
                        onAnimationEnd: _this2.handleAnimationEnd
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $3366a7250677b47e$export$936d0764594b6eb3), $7d5fe63ca2eb078d$var$_extends({
                        className: "recharts-bar-rectangle"
                    }, (0, $a19170a4abc07995$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        // https://github.com/recharts/recharts/issues/5415
                        // eslint-disable-next-line react/no-array-index-key
                        key: "rectangle-".concat(entry === null || entry === void 0 ? void 0 : entry.x, "-").concat(entry === null || entry === void 0 ? void 0 : entry.y, "-").concat(entry === null || entry === void 0 ? void 0 : entry.value, "-").concat(i)
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $de9c498aaf767413$export$f19074a6842f9217), props));
                });
            }
        },
        {
            key: "renderRectanglesWithAnimation",
            value: function renderRectanglesWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, data = _this$props2.data, layout = _this$props2.layout, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevData = this.state.prevData;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $ab29ae7e0941d876$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "bar-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = data.map(function(entry, index) {
                        var prev = prevData && prevData[index];
                        if (prev) {
                            var interpolatorX = (0, $ec351366ffe25ce6$export$d871d53bd7eeb390)(prev.x, entry.x);
                            var interpolatorY = (0, $ec351366ffe25ce6$export$d871d53bd7eeb390)(prev.y, entry.y);
                            var interpolatorWidth = (0, $ec351366ffe25ce6$export$d871d53bd7eeb390)(prev.width, entry.width);
                            var interpolatorHeight = (0, $ec351366ffe25ce6$export$d871d53bd7eeb390)(prev.height, entry.height);
                            return $7d5fe63ca2eb078d$var$_objectSpread($7d5fe63ca2eb078d$var$_objectSpread({}, entry), {}, {
                                x: interpolatorX(t),
                                y: interpolatorY(t),
                                width: interpolatorWidth(t),
                                height: interpolatorHeight(t)
                            });
                        }
                        if (layout === 'horizontal') {
                            var _interpolatorHeight = (0, $ec351366ffe25ce6$export$d871d53bd7eeb390)(0, entry.height);
                            var h = _interpolatorHeight(t);
                            return $7d5fe63ca2eb078d$var$_objectSpread($7d5fe63ca2eb078d$var$_objectSpread({}, entry), {}, {
                                y: entry.y + entry.height - h,
                                height: h
                            });
                        }
                        var interpolator = (0, $ec351366ffe25ce6$export$d871d53bd7eeb390)(0, entry.width);
                        var w = interpolator(t);
                        return $7d5fe63ca2eb078d$var$_objectSpread($7d5fe63ca2eb078d$var$_objectSpread({}, entry), {}, {
                            width: w
                        });
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $3366a7250677b47e$export$936d0764594b6eb3), null, _this3.renderRectanglesStatically(stepData));
                });
            }
        },
        {
            key: "renderRectangles",
            value: function renderRectangles() {
                var _this$props3 = this.props, data = _this$props3.data, isAnimationActive = _this$props3.isAnimationActive;
                var prevData = this.state.prevData;
                if (isAnimationActive && data && data.length && (!prevData || !(0, (/*@__PURE__*/$parcel$interopDefault($c9cb355ea2786d76$exports)))(prevData, data))) return this.renderRectanglesWithAnimation();
                return this.renderRectanglesStatically(data);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this4 = this;
                var _this$props4 = this.props, data = _this$props4.data, dataKey = _this$props4.dataKey, activeIndex = _this$props4.activeIndex;
                var backgroundProps = (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(this.props.background, false);
                return data.map(function(entry, i) {
                    var value = entry.value, background = entry.background, rest = $7d5fe63ca2eb078d$var$_objectWithoutProperties(entry, $7d5fe63ca2eb078d$var$_excluded);
                    if (!background) return null;
                    var props = $7d5fe63ca2eb078d$var$_objectSpread($7d5fe63ca2eb078d$var$_objectSpread($7d5fe63ca2eb078d$var$_objectSpread($7d5fe63ca2eb078d$var$_objectSpread($7d5fe63ca2eb078d$var$_objectSpread({}, rest), {}, {
                        fill: '#eee'
                    }, background), backgroundProps), (0, $a19170a4abc07995$export$ca62be0d67a3158c)(_this4.props, entry, i)), {}, {
                        onAnimationStart: _this4.handleAnimationStart,
                        onAnimationEnd: _this4.handleAnimationEnd,
                        dataKey: dataKey,
                        index: i,
                        className: 'recharts-bar-background-rectangle'
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $de9c498aaf767413$export$f19074a6842f9217), $7d5fe63ca2eb078d$var$_extends({
                        key: "background-bar-".concat(i),
                        option: _this4.props.background,
                        isActive: i === activeIndex
                    }, props));
                });
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props5 = this.props, data = _this$props5.data, xAxis = _this$props5.xAxis, yAxis = _this$props5.yAxis, layout = _this$props5.layout, children = _this$props5.children;
                var errorBarItems = (0, $10636f1b3e62ab88$export$fdd5e64c0e8495bb)(children, (0, $3ba1a13bb3875529$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    /**
         * if the value coming from `getComposedData` is an array then this is a stacked bar chart.
         * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
         * */ var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: value,
                        errorVal: (0, $bc60c84815913bd8$export$f97fc4a450f29a)(dataPoint, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $3366a7250677b47e$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(item, {
                        key: "error-bar-".concat(clipPathId, "-").concat(item.props.dataKey),
                        data: data,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        offset: offset,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, data = _this$props6.data, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, background = _this$props6.background, id = _this$props6.id;
                if (hide || !data || !data.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, $iVyaN.default)('recharts-bar', className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $3366a7250677b47e$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $3366a7250677b47e$export$936d0764594b6eb3), {
                    className: "recharts-bar-rectangles",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $1778bc5734fdac4c$export$835fcf23ab7bf88).renderCallByParent(this.props, data));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curData: nextProps.data,
                    prevData: prevState.curData
                };
                if (nextProps.data !== prevState.curData) return {
                    curData: nextProps.data
                };
                return null;
            }
        }
    ]);
}((0, $8T3gX.PureComponent));
$7d5fe63ca2eb078d$var$_Bar = $7d5fe63ca2eb078d$export$bbc6c6369b38e3d1;
$7d5fe63ca2eb078d$var$_defineProperty($7d5fe63ca2eb078d$export$bbc6c6369b38e3d1, "displayName", 'Bar');
$7d5fe63ca2eb078d$var$_defineProperty($7d5fe63ca2eb078d$export$bbc6c6369b38e3d1, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    legendType: 'rect',
    minPointSize: 0,
    hide: false,
    data: [],
    layout: 'vertical',
    activeBar: false,
    isAnimationActive: !(0, $809421885870cd36$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: 'ease'
});
/**
 * Compose the data of each group
 * @param {Object} props Props for the component
 * @param {Object} item        An instance of Bar
 * @param {Array} barPosition  The offset and size of each bar
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {Array} stackedData  The stacked data of a bar item
 * @return{Array} Composed data
 */ $7d5fe63ca2eb078d$var$_defineProperty($7d5fe63ca2eb078d$export$bbc6c6369b38e3d1, "getComposedData", function(_ref2) {
    var props = _ref2.props, item = _ref2.item, barPosition = _ref2.barPosition, bandSize = _ref2.bandSize, xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, stackedData = _ref2.stackedData, dataStartIndex = _ref2.dataStartIndex, displayedData = _ref2.displayedData, offset = _ref2.offset;
    var pos = (0, $bc60c84815913bd8$export$778e70011fdf4625)(barPosition, item);
    if (!pos) return null;
    var layout = props.layout;
    var itemDefaultProps = item.type.defaultProps;
    var itemProps = itemDefaultProps !== undefined ? $7d5fe63ca2eb078d$var$_objectSpread($7d5fe63ca2eb078d$var$_objectSpread({}, itemDefaultProps), item.props) : item.props;
    var dataKey = itemProps.dataKey, children = itemProps.children, minPointSizeProp = itemProps.minPointSize;
    var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, $bc60c84815913bd8$export$54f3200dd4a8a235)({
        numericAxis: numericAxis
    });
    var cells = (0, $10636f1b3e62ab88$export$fdd5e64c0e8495bb)(children, (0, $fe1584e453ed4ef4$export$f6f0c3fe4ec306ea));
    var rects = displayedData.map(function(entry, index) {
        var value, x, y, width, height, background;
        if (stackedData) value = (0, $bc60c84815913bd8$export$c7ec0fa96d0c462e)(stackedData[dataStartIndex + index], stackedDomain);
        else {
            value = (0, $bc60c84815913bd8$export$f97fc4a450f29a)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
        }
        var minPointSize = (0, $de9c498aaf767413$export$c20d73790de171f0)(minPointSizeProp, $7d5fe63ca2eb078d$var$_Bar.defaultProps.minPointSize)(value[1], index);
        if (layout === 'horizontal') {
            var _ref4;
            var _ref3 = [
                yAxis.scale(value[0]),
                yAxis.scale(value[1])
            ], baseValueScale = _ref3[0], currentValueScale = _ref3[1];
            x = (0, $bc60c84815913bd8$export$8abb9e87422f3a0c)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            y = (_ref4 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref4 !== void 0 ? _ref4 : undefined;
            width = pos.size;
            var computedHeight = baseValueScale - currentValueScale;
            height = Number.isNaN(computedHeight) ? 0 : computedHeight;
            background = {
                x: x,
                y: yAxis.y,
                width: width,
                height: yAxis.height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
                var delta = (0, $ec351366ffe25ce6$export$9d334328eb75e624)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
                y -= delta;
                height += delta;
            }
        } else {
            var _ref5 = [
                xAxis.scale(value[0]),
                xAxis.scale(value[1])
            ], _baseValueScale = _ref5[0], _currentValueScale = _ref5[1];
            x = _baseValueScale;
            y = (0, $bc60c84815913bd8$export$8abb9e87422f3a0c)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            width = _currentValueScale - _baseValueScale;
            height = pos.size;
            background = {
                x: xAxis.x,
                y: y,
                width: xAxis.width,
                height: height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
                var _delta = (0, $ec351366ffe25ce6$export$9d334328eb75e624)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
                width += _delta;
            }
        }
        return $7d5fe63ca2eb078d$var$_objectSpread($7d5fe63ca2eb078d$var$_objectSpread($7d5fe63ca2eb078d$var$_objectSpread({}, entry), {}, {
            x: x,
            y: y,
            width: width,
            height: height,
            value: stackedData ? value : value[1],
            payload: entry,
            background: background
        }, cells && cells[index] && cells[index].props), {}, {
            tooltipPayload: [
                (0, $bc60c84815913bd8$export$a4ea3faa19bc2d90)(item, entry)
            ],
            tooltipPosition: {
                x: x + width / 2,
                y: y + height / 2
            }
        });
    });
    return $7d5fe63ca2eb078d$var$_objectSpread({
        data: rects,
        layout: layout
    }, offset);
});

/**
 * @fileOverview Bar Chart
 */ 
var $8T3gX = parcelRequire("8T3gX");


var $a2e6c83a615b2213$exports = {};
var $c62fa601898fb5f9$exports = {};
var $3a4f0e262c548c9e$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3a4f0e262c548c9e$var$nativeCeil = Math.ceil, $3a4f0e262c548c9e$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $3a4f0e262c548c9e$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $3a4f0e262c548c9e$var$nativeMax($3a4f0e262c548c9e$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
$3a4f0e262c548c9e$exports = $3a4f0e262c548c9e$var$baseRange;



var $420360e96c86f53d$exports = {};
var $f038f60db3b99cd9$exports = {};
var $0d102123d2b2ab0b$exports = {};
var $7895653026268022$exports = {};
/** Used to match a single whitespace character. */ var $7895653026268022$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $7895653026268022$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $7895653026268022$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$7895653026268022$exports = $7895653026268022$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $0d102123d2b2ab0b$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $0d102123d2b2ab0b$var$baseTrim(string) {
    return string ? string.slice(0, $7895653026268022$exports(string) + 1).replace($0d102123d2b2ab0b$var$reTrimStart, '') : string;
}
$0d102123d2b2ab0b$exports = $0d102123d2b2ab0b$var$baseTrim;




/** Used as references for various `Number` constants. */ var $f038f60db3b99cd9$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $f038f60db3b99cd9$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $f038f60db3b99cd9$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $f038f60db3b99cd9$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $f038f60db3b99cd9$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $f038f60db3b99cd9$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($193702f8737ef12b$exports(value)) return $f038f60db3b99cd9$var$NAN;
    if ($cd2b0b1294af0960$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $cd2b0b1294af0960$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $0d102123d2b2ab0b$exports(value);
    var isBinary = $f038f60db3b99cd9$var$reIsBinary.test(value);
    return isBinary || $f038f60db3b99cd9$var$reIsOctal.test(value) ? $f038f60db3b99cd9$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $f038f60db3b99cd9$var$reIsBadHex.test(value) ? $f038f60db3b99cd9$var$NAN : +value;
}
$f038f60db3b99cd9$exports = $f038f60db3b99cd9$var$toNumber;


/** Used as references for various `Number` constants. */ var $420360e96c86f53d$var$INFINITY = 1 / 0, $420360e96c86f53d$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $420360e96c86f53d$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $f038f60db3b99cd9$exports(value);
    if (value === $420360e96c86f53d$var$INFINITY || value === -$420360e96c86f53d$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $420360e96c86f53d$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$420360e96c86f53d$exports = $420360e96c86f53d$var$toFinite;


/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $c62fa601898fb5f9$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $f5d86346a533d383$exports(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $420360e96c86f53d$exports(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $420360e96c86f53d$exports(end);
        step = step === undefined ? start < end ? 1 : -1 : $420360e96c86f53d$exports(step);
        return $3a4f0e262c548c9e$exports(start, end, step, fromRight);
    };
}
$c62fa601898fb5f9$exports = $c62fa601898fb5f9$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $a2e6c83a615b2213$var$range = $c62fa601898fb5f9$exports();
$a2e6c83a615b2213$exports = $a2e6c83a615b2213$var$range;




var $ad4be26b64041d02$exports = {};
var $8c093098a81a5c8d$exports = {};

var $1a94396811726448$exports = {};

var $yRFSk = parcelRequire("yRFSk");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $1a94396811726448$var$now = function() {
    return $yRFSk.Date.now();
};
$1a94396811726448$exports = $1a94396811726448$var$now;



/** Error message constants. */ var $8c093098a81a5c8d$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8c093098a81a5c8d$var$nativeMax = Math.max, $8c093098a81a5c8d$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $8c093098a81a5c8d$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($8c093098a81a5c8d$var$FUNC_ERROR_TEXT);
    wait = $f038f60db3b99cd9$exports(wait) || 0;
    if ($cd2b0b1294af0960$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $8c093098a81a5c8d$var$nativeMax($f038f60db3b99cd9$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $8c093098a81a5c8d$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $1a94396811726448$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($1a94396811726448$exports());
    }
    function debounced() {
        var time = $1a94396811726448$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$8c093098a81a5c8d$exports = $8c093098a81a5c8d$var$debounce;



/** Error message constants. */ var $ad4be26b64041d02$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $ad4be26b64041d02$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($ad4be26b64041d02$var$FUNC_ERROR_TEXT);
    if ($cd2b0b1294af0960$exports(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $8c093098a81a5c8d$exports(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
$ad4be26b64041d02$exports = $ad4be26b64041d02$var$throttle;



var $iVyaN = parcelRequire("iVyaN");




var $8T3gX = parcelRequire("8T3gX");

var $8T3gX = parcelRequire("8T3gX");



var $iVyaN = parcelRequire("iVyaN");

function $055d6018246c05d5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $055d6018246c05d5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $055d6018246c05d5$var$_typeof(o);
}
function $055d6018246c05d5$var$_extends() {
    $055d6018246c05d5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $055d6018246c05d5$var$_extends.apply(this, arguments);
}
function $055d6018246c05d5$var$_slicedToArray(arr, i) {
    return $055d6018246c05d5$var$_arrayWithHoles(arr) || $055d6018246c05d5$var$_iterableToArrayLimit(arr, i) || $055d6018246c05d5$var$_unsupportedIterableToArray(arr, i) || $055d6018246c05d5$var$_nonIterableRest();
}
function $055d6018246c05d5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $055d6018246c05d5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $055d6018246c05d5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $055d6018246c05d5$var$_arrayLikeToArray(o, minLen);
}
function $055d6018246c05d5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $055d6018246c05d5$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $055d6018246c05d5$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $055d6018246c05d5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $055d6018246c05d5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $055d6018246c05d5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $055d6018246c05d5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $055d6018246c05d5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $055d6018246c05d5$var$_defineProperty(obj, key, value) {
    key = $055d6018246c05d5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $055d6018246c05d5$var$_toPropertyKey(t) {
    var i = $055d6018246c05d5$var$_toPrimitive(t, "string");
    return "symbol" == $055d6018246c05d5$var$_typeof(i) ? i : i + "";
}
function $055d6018246c05d5$var$_toPrimitive(t, r) {
    if ("object" != $055d6018246c05d5$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $055d6018246c05d5$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $055d6018246c05d5$var$defaultFormatter(value) {
    return Array.isArray(value) && (0, $ec351366ffe25ce6$export$402a499e1ea44294)(value[0]) && (0, $ec351366ffe25ce6$export$402a499e1ea44294)(value[1]) ? value.join(' ~ ') : value;
}
var $055d6018246c05d5$export$6fe33945eebf9ac8 = function DefaultTooltipContent(props) {
    var _props$separator = props.separator, separator = _props$separator === void 0 ? ' : ' : _props$separator, _props$contentStyle = props.contentStyle, contentStyle = _props$contentStyle === void 0 ? {} : _props$contentStyle, _props$itemStyle = props.itemStyle, itemStyle = _props$itemStyle === void 0 ? {} : _props$itemStyle, _props$labelStyle = props.labelStyle, labelStyle = _props$labelStyle === void 0 ? {} : _props$labelStyle, payload = props.payload, formatter = props.formatter, itemSorter = props.itemSorter, wrapperClassName = props.wrapperClassName, labelClassName = props.labelClassName, label = props.label, labelFormatter = props.labelFormatter, _props$accessibilityL = props.accessibilityLayer, accessibilityLayer = _props$accessibilityL === void 0 ? false : _props$accessibilityL;
    var renderContent = function renderContent() {
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var items = (itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($e2540731f2bf6197$exports)))(payload, itemSorter) : payload).map(function(entry, i) {
                if (entry.type === 'none') return null;
                var finalItemStyle = $055d6018246c05d5$var$_objectSpread({
                    display: 'block',
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: entry.color || '#000'
                }, itemStyle);
                var finalFormatter = entry.formatter || formatter || $055d6018246c05d5$var$defaultFormatter;
                var value = entry.value, name = entry.name;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter && finalValue != null && finalName != null) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) {
                        var _formatted = $055d6018246c05d5$var$_slicedToArray(formatted, 2);
                        finalValue = _formatted[0];
                        finalName = _formatted[1];
                    } else finalValue = formatted;
                }
                return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, $ec351366ffe25ce6$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, $ec351366ffe25ce6$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || '')));
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = $055d6018246c05d5$var$_objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        whiteSpace: 'nowrap'
    }, contentStyle);
    var finalLabelStyle = $055d6018246c05d5$var$_objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(label);
    var finalLabel = hasLabel ? label : '';
    var wrapperCN = (0, $iVyaN.default)('recharts-default-tooltip', wrapperClassName);
    var labelCN = (0, $iVyaN.default)('recharts-tooltip-label', labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    var accessibilityAttributes = accessibilityLayer ? {
        role: 'status',
        'aria-live': 'assertive'
    } : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("div", $055d6018246c05d5$var$_extends({
        className: wrapperCN,
        style: finalStyle
    }, accessibilityAttributes), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};



var $8T3gX = parcelRequire("8T3gX");

var $iVyaN = parcelRequire("iVyaN");

function $c06300f88b1c3d75$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c06300f88b1c3d75$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c06300f88b1c3d75$var$_typeof(o);
}
function $c06300f88b1c3d75$var$_defineProperty(obj, key, value) {
    key = $c06300f88b1c3d75$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c06300f88b1c3d75$var$_toPropertyKey(t) {
    var i = $c06300f88b1c3d75$var$_toPrimitive(t, "string");
    return "symbol" == $c06300f88b1c3d75$var$_typeof(i) ? i : i + "";
}
function $c06300f88b1c3d75$var$_toPrimitive(t, r) {
    if ("object" != $c06300f88b1c3d75$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c06300f88b1c3d75$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $c06300f88b1c3d75$var$CSS_CLASS_PREFIX = 'recharts-tooltip-wrapper';
var $c06300f88b1c3d75$var$TOOLTIP_HIDDEN = {
    visibility: 'hidden'
};
function $c06300f88b1c3d75$export$46aee7ef09f78756(_ref) {
    var coordinate = _ref.coordinate, translateX = _ref.translateX, translateY = _ref.translateY;
    return (0, $iVyaN.default)($c06300f88b1c3d75$var$CSS_CLASS_PREFIX, $c06300f88b1c3d75$var$_defineProperty($c06300f88b1c3d75$var$_defineProperty($c06300f88b1c3d75$var$_defineProperty($c06300f88b1c3d75$var$_defineProperty({}, "".concat($c06300f88b1c3d75$var$CSS_CLASS_PREFIX, "-right"), (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(translateX) && coordinate && (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(coordinate.x) && translateX >= coordinate.x), "".concat($c06300f88b1c3d75$var$CSS_CLASS_PREFIX, "-left"), (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(translateX) && coordinate && (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(coordinate.x) && translateX < coordinate.x), "".concat($c06300f88b1c3d75$var$CSS_CLASS_PREFIX, "-bottom"), (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(translateY) && coordinate && (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(coordinate.y) && translateY >= coordinate.y), "".concat($c06300f88b1c3d75$var$CSS_CLASS_PREFIX, "-top"), (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(translateY) && coordinate && (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(coordinate.y) && translateY < coordinate.y));
}
function $c06300f88b1c3d75$export$4cccba03fe0eccc6(_ref2) {
    var allowEscapeViewBox = _ref2.allowEscapeViewBox, coordinate = _ref2.coordinate, key = _ref2.key, offsetTopLeft = _ref2.offsetTopLeft, position = _ref2.position, reverseDirection = _ref2.reverseDirection, tooltipDimension = _ref2.tooltipDimension, viewBox = _ref2.viewBox, viewBoxDimension = _ref2.viewBoxDimension;
    if (position && (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(position[key])) return position[key];
    var negative = coordinate[key] - tooltipDimension - offsetTopLeft;
    var positive = coordinate[key] + offsetTopLeft;
    if (allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
    if (reverseDirection[key]) {
        var _tooltipBoundary = negative;
        var _viewBoxBoundary = viewBox[key];
        if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBox[key]);
        return Math.max(negative, viewBox[key]);
    }
    var tooltipBoundary = positive + tooltipDimension;
    var viewBoxBoundary = viewBox[key] + viewBoxDimension;
    if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBox[key]);
    return Math.max(positive, viewBox[key]);
}
function $c06300f88b1c3d75$export$4fe0982879780f9b(_ref3) {
    var translateX = _ref3.translateX, translateY = _ref3.translateY, useTranslate3d = _ref3.useTranslate3d;
    return {
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    };
}
function $c06300f88b1c3d75$export$25e3b0ae21503056(_ref4) {
    var allowEscapeViewBox = _ref4.allowEscapeViewBox, coordinate = _ref4.coordinate, offsetTopLeft = _ref4.offsetTopLeft, position = _ref4.position, reverseDirection = _ref4.reverseDirection, tooltipBox = _ref4.tooltipBox, useTranslate3d = _ref4.useTranslate3d, viewBox = _ref4.viewBox;
    var cssProperties, translateX, translateY;
    if (tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
        translateX = $c06300f88b1c3d75$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'x',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.width,
            viewBox: viewBox,
            viewBoxDimension: viewBox.width
        });
        translateY = $c06300f88b1c3d75$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: 'y',
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.height,
            viewBox: viewBox,
            viewBoxDimension: viewBox.height
        });
        cssProperties = $c06300f88b1c3d75$export$4fe0982879780f9b({
            translateX: translateX,
            translateY: translateY,
            useTranslate3d: useTranslate3d
        });
    } else cssProperties = $c06300f88b1c3d75$var$TOOLTIP_HIDDEN;
    return {
        cssProperties: cssProperties,
        cssClasses: $c06300f88b1c3d75$export$46aee7ef09f78756({
            translateX: translateX,
            translateY: translateY,
            coordinate: coordinate
        })
    };
}


function $1d78a64c82d93312$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1d78a64c82d93312$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1d78a64c82d93312$var$_typeof(o);
}
function $1d78a64c82d93312$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1d78a64c82d93312$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1d78a64c82d93312$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1d78a64c82d93312$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1d78a64c82d93312$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1d78a64c82d93312$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1d78a64c82d93312$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $1d78a64c82d93312$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $1d78a64c82d93312$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1d78a64c82d93312$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1d78a64c82d93312$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $1d78a64c82d93312$var$_callSuper(t, o, e) {
    return o = $1d78a64c82d93312$var$_getPrototypeOf(o), $1d78a64c82d93312$var$_possibleConstructorReturn(t, $1d78a64c82d93312$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $1d78a64c82d93312$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $1d78a64c82d93312$var$_possibleConstructorReturn(self, call) {
    if (call && ($1d78a64c82d93312$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $1d78a64c82d93312$var$_assertThisInitialized(self);
}
function $1d78a64c82d93312$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1d78a64c82d93312$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1d78a64c82d93312$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $1d78a64c82d93312$var$_getPrototypeOf(o) {
    $1d78a64c82d93312$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1d78a64c82d93312$var$_getPrototypeOf(o);
}
function $1d78a64c82d93312$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $1d78a64c82d93312$var$_setPrototypeOf(subClass, superClass);
}
function $1d78a64c82d93312$var$_setPrototypeOf(o, p) {
    $1d78a64c82d93312$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1d78a64c82d93312$var$_setPrototypeOf(o, p);
}
function $1d78a64c82d93312$var$_defineProperty(obj, key, value) {
    key = $1d78a64c82d93312$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1d78a64c82d93312$var$_toPropertyKey(t) {
    var i = $1d78a64c82d93312$var$_toPrimitive(t, "string");
    return "symbol" == $1d78a64c82d93312$var$_typeof(i) ? i : i + "";
}
function $1d78a64c82d93312$var$_toPrimitive(t, r) {
    if ("object" != $1d78a64c82d93312$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1d78a64c82d93312$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $1d78a64c82d93312$var$EPSILON = 1;
var $1d78a64c82d93312$export$9e6cee7b86551b9c = /*#__PURE__*/ function(_PureComponent) {
    function TooltipBoundingBox() {
        var _this;
        $1d78a64c82d93312$var$_classCallCheck(this, TooltipBoundingBox);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $1d78a64c82d93312$var$_callSuper(this, TooltipBoundingBox, [].concat(args));
        $1d78a64c82d93312$var$_defineProperty(_this, "state", {
            dismissed: false,
            dismissedAtCoordinate: {
                x: 0,
                y: 0
            },
            lastBoundingBox: {
                width: -1,
                height: -1
            }
        });
        $1d78a64c82d93312$var$_defineProperty(_this, "handleKeyDown", function(event) {
            if (event.key === 'Escape') {
                var _this$props$coordinat, _this$props$coordinat2, _this$props$coordinat3, _this$props$coordinat4;
                _this.setState({
                    dismissed: true,
                    dismissedAtCoordinate: {
                        x: (_this$props$coordinat = (_this$props$coordinat2 = _this.props.coordinate) === null || _this$props$coordinat2 === void 0 ? void 0 : _this$props$coordinat2.x) !== null && _this$props$coordinat !== void 0 ? _this$props$coordinat : 0,
                        y: (_this$props$coordinat3 = (_this$props$coordinat4 = _this.props.coordinate) === null || _this$props$coordinat4 === void 0 ? void 0 : _this$props$coordinat4.y) !== null && _this$props$coordinat3 !== void 0 ? _this$props$coordinat3 : 0
                    }
                });
            }
        });
        return _this;
    }
    $1d78a64c82d93312$var$_inherits(TooltipBoundingBox, _PureComponent);
    return $1d78a64c82d93312$var$_createClass(TooltipBoundingBox, [
        {
            key: "updateBBox",
            value: function updateBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(box.width - this.state.lastBoundingBox.width) > $1d78a64c82d93312$var$EPSILON || Math.abs(box.height - this.state.lastBoundingBox.height) > $1d78a64c82d93312$var$EPSILON) this.setState({
                        lastBoundingBox: {
                            width: box.width,
                            height: box.height
                        }
                    });
                } else if (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) this.setState({
                    lastBoundingBox: {
                        width: -1,
                        height: -1
                    }
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener('keydown', this.handleKeyDown);
                this.updateBBox();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener('keydown', this.handleKeyDown);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this$props$coordinat5, _this$props$coordinat6;
                if (this.props.active) this.updateBBox();
                if (!this.state.dismissed) return;
                if (((_this$props$coordinat5 = this.props.coordinate) === null || _this$props$coordinat5 === void 0 ? void 0 : _this$props$coordinat5.x) !== this.state.dismissedAtCoordinate.x || ((_this$props$coordinat6 = this.props.coordinate) === null || _this$props$coordinat6 === void 0 ? void 0 : _this$props$coordinat6.y) !== this.state.dismissedAtCoordinate.y) this.state.dismissed = false;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, children = _this$props.children, coordinate = _this$props.coordinate, hasPayload = _this$props.hasPayload, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var _getTooltipTranslate = (0, $c06300f88b1c3d75$export$25e3b0ae21503056)({
                    allowEscapeViewBox: allowEscapeViewBox,
                    coordinate: coordinate,
                    offsetTopLeft: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    tooltipBox: this.state.lastBoundingBox,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox
                }), cssClasses = _getTooltipTranslate.cssClasses, cssProperties = _getTooltipTranslate.cssProperties;
                var outerStyle = $1d78a64c82d93312$var$_objectSpread($1d78a64c82d93312$var$_objectSpread({
                    transition: isAnimationActive && active ? "transform ".concat(animationDuration, "ms ").concat(animationEasing) : undefined
                }, cssProperties), {}, {
                    pointerEvents: 'none',
                    visibility: !this.state.dismissed && active && hasPayload ? 'visible' : 'hidden',
                    position: 'absolute',
                    top: 0,
                    left: 0
                }, wrapperStyle);
                return(/*#__PURE__*/ // This element allow listening to the `Escape` key.
                // See https://github.com/recharts/recharts/pull/2925
                (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("div", {
                    tabIndex: -1,
                    className: cssClasses,
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, children));
            }
        }
    ]);
}((0, $8T3gX.PureComponent));




function $45dbb8bb277f9d9d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $45dbb8bb277f9d9d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $45dbb8bb277f9d9d$var$_typeof(o);
}
function $45dbb8bb277f9d9d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $45dbb8bb277f9d9d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $45dbb8bb277f9d9d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $45dbb8bb277f9d9d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $45dbb8bb277f9d9d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $45dbb8bb277f9d9d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $45dbb8bb277f9d9d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $45dbb8bb277f9d9d$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $45dbb8bb277f9d9d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $45dbb8bb277f9d9d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $45dbb8bb277f9d9d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $45dbb8bb277f9d9d$var$_callSuper(t, o, e) {
    return o = $45dbb8bb277f9d9d$var$_getPrototypeOf(o), $45dbb8bb277f9d9d$var$_possibleConstructorReturn(t, $45dbb8bb277f9d9d$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $45dbb8bb277f9d9d$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $45dbb8bb277f9d9d$var$_possibleConstructorReturn(self, call) {
    if (call && ($45dbb8bb277f9d9d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $45dbb8bb277f9d9d$var$_assertThisInitialized(self);
}
function $45dbb8bb277f9d9d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $45dbb8bb277f9d9d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($45dbb8bb277f9d9d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $45dbb8bb277f9d9d$var$_getPrototypeOf(o) {
    $45dbb8bb277f9d9d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $45dbb8bb277f9d9d$var$_getPrototypeOf(o);
}
function $45dbb8bb277f9d9d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $45dbb8bb277f9d9d$var$_setPrototypeOf(subClass, superClass);
}
function $45dbb8bb277f9d9d$var$_setPrototypeOf(o, p) {
    $45dbb8bb277f9d9d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $45dbb8bb277f9d9d$var$_setPrototypeOf(o, p);
}
function $45dbb8bb277f9d9d$var$_defineProperty(obj, key, value) {
    key = $45dbb8bb277f9d9d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $45dbb8bb277f9d9d$var$_toPropertyKey(t) {
    var i = $45dbb8bb277f9d9d$var$_toPrimitive(t, "string");
    return "symbol" == $45dbb8bb277f9d9d$var$_typeof(i) ? i : i + "";
}
function $45dbb8bb277f9d9d$var$_toPrimitive(t, r) {
    if ("object" != $45dbb8bb277f9d9d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $45dbb8bb277f9d9d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $45dbb8bb277f9d9d$var$defaultUniqBy(entry) {
    return entry.dataKey;
}
function $45dbb8bb277f9d9d$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement(content, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $055d6018246c05d5$export$6fe33945eebf9ac8), props);
}
var $45dbb8bb277f9d9d$export$28c660c63b792dea = /*#__PURE__*/ function(_PureComponent) {
    function Tooltip() {
        $45dbb8bb277f9d9d$var$_classCallCheck(this, Tooltip);
        return $45dbb8bb277f9d9d$var$_callSuper(this, Tooltip, arguments);
    }
    $45dbb8bb277f9d9d$var$_inherits(Tooltip, _PureComponent);
    return $45dbb8bb277f9d9d$var$_createClass(Tooltip, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, content = _this$props.content, coordinate = _this$props.coordinate, filterNull = _this$props.filterNull, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, payload = _this$props.payload, payloadUniqBy = _this$props.payloadUniqBy, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var finalPayload = payload !== null && payload !== void 0 ? payload : [];
                if (filterNull && finalPayload.length) finalPayload = (0, $d0016136b2d04c35$export$b67e33c2fb1535fa)(payload.filter(function(entry) {
                    return entry.value != null && (entry.hide !== true || _this.props.includeHidden);
                }), payloadUniqBy, $45dbb8bb277f9d9d$var$defaultUniqBy);
                var hasPayload = finalPayload.length > 0;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $1d78a64c82d93312$export$9e6cee7b86551b9c), {
                    allowEscapeViewBox: allowEscapeViewBox,
                    animationDuration: animationDuration,
                    animationEasing: animationEasing,
                    isAnimationActive: isAnimationActive,
                    active: active,
                    coordinate: coordinate,
                    hasPayload: hasPayload,
                    offset: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox,
                    wrapperStyle: wrapperStyle
                }, $45dbb8bb277f9d9d$var$renderContent(content, $45dbb8bb277f9d9d$var$_objectSpread($45dbb8bb277f9d9d$var$_objectSpread({}, this.props), {}, {
                    payload: finalPayload
                })));
            }
        }
    ]);
}((0, $8T3gX.PureComponent));
$45dbb8bb277f9d9d$var$_defineProperty($45dbb8bb277f9d9d$export$28c660c63b792dea, "displayName", 'Tooltip');
$45dbb8bb277f9d9d$var$_defineProperty($45dbb8bb277f9d9d$export$28c660c63b792dea, "defaultProps", {
    accessibilityLayer: false,
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    animationDuration: 400,
    animationEasing: 'ease',
    contentStyle: {},
    coordinate: {
        x: 0,
        y: 0
    },
    cursor: true,
    cursorStyle: {},
    filterNull: true,
    isAnimationActive: !(0, $809421885870cd36$export$98f03c5d19621d70).isSsr,
    itemStyle: {},
    labelStyle: {},
    offset: 10,
    reverseDirection: {
        x: false,
        y: false
    },
    separator: ' : ',
    trigger: 'hover',
    useTranslate3d: false,
    viewBox: {
        x: 0,
        y: 0,
        height: 0,
        width: 0
    },
    wrapperStyle: {}
});




var $8T3gX = parcelRequire("8T3gX");

var $iVyaN = parcelRequire("iVyaN");


function $295618a64acc25e0$var$_extends() {
    $295618a64acc25e0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $295618a64acc25e0$var$_extends.apply(this, arguments);
}
var $295618a64acc25e0$export$d046b3c4a416f60d = function Dot(props) {
    var cx = props.cx, cy = props.cy, r = props.r, className = props.className;
    var layerClass = (0, $iVyaN.default)('recharts-dot', className);
    if (cx === +cx && cy === +cy && r === +r) return /*#__PURE__*/ $8T3gX.createElement("circle", $295618a64acc25e0$var$_extends({}, (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(props, false), (0, $a19170a4abc07995$export$7c4c290a4a9c1b1e)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};





var $8T3gX = parcelRequire("8T3gX");

var $iVyaN = parcelRequire("iVyaN");







function $9201ba5e05084789$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9201ba5e05084789$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9201ba5e05084789$var$_typeof(o);
}
function $9201ba5e05084789$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9201ba5e05084789$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9201ba5e05084789$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9201ba5e05084789$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9201ba5e05084789$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9201ba5e05084789$var$_defineProperty(obj, key, value) {
    key = $9201ba5e05084789$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9201ba5e05084789$var$_toPropertyKey(t) {
    var i = $9201ba5e05084789$var$_toPrimitive(t, "string");
    return "symbol" == $9201ba5e05084789$var$_typeof(i) ? i : i + "";
}
function $9201ba5e05084789$var$_toPrimitive(t, r) {
    if ("object" != $9201ba5e05084789$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $9201ba5e05084789$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $9201ba5e05084789$var$PREFIX_LIST = [
    'Webkit',
    'Moz',
    'O',
    'ms'
];
var $9201ba5e05084789$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if (!name) return null;
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var result = $9201ba5e05084789$var$PREFIX_LIST.reduce(function(res, entry) {
        return $9201ba5e05084789$var$_objectSpread($9201ba5e05084789$var$_objectSpread({}, res), {}, $9201ba5e05084789$var$_defineProperty({}, entry + camelName, value));
    }, {});
    result[name] = value;
    return result;
};



function $303bff326b387541$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $303bff326b387541$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $303bff326b387541$var$_typeof(o);
}
function $303bff326b387541$var$_extends() {
    $303bff326b387541$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $303bff326b387541$var$_extends.apply(this, arguments);
}
function $303bff326b387541$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $303bff326b387541$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $303bff326b387541$var$ownKeys(Object(t), !0).forEach(function(r) {
            $303bff326b387541$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $303bff326b387541$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $303bff326b387541$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $303bff326b387541$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $303bff326b387541$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $303bff326b387541$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $303bff326b387541$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $303bff326b387541$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $303bff326b387541$var$_callSuper(t, o, e) {
    return o = $303bff326b387541$var$_getPrototypeOf(o), $303bff326b387541$var$_possibleConstructorReturn(t, $303bff326b387541$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $303bff326b387541$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $303bff326b387541$var$_possibleConstructorReturn(self, call) {
    if (call && ($303bff326b387541$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $303bff326b387541$var$_assertThisInitialized(self);
}
function $303bff326b387541$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $303bff326b387541$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($303bff326b387541$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $303bff326b387541$var$_getPrototypeOf(o) {
    $303bff326b387541$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $303bff326b387541$var$_getPrototypeOf(o);
}
function $303bff326b387541$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $303bff326b387541$var$_setPrototypeOf(subClass, superClass);
}
function $303bff326b387541$var$_setPrototypeOf(o, p) {
    $303bff326b387541$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $303bff326b387541$var$_setPrototypeOf(o, p);
}
function $303bff326b387541$var$_defineProperty(obj, key, value) {
    key = $303bff326b387541$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $303bff326b387541$var$_toPropertyKey(t) {
    var i = $303bff326b387541$var$_toPrimitive(t, "string");
    return "symbol" == $303bff326b387541$var$_typeof(i) ? i : i + "";
}
function $303bff326b387541$var$_toPrimitive(t, r) {
    if ("object" != $303bff326b387541$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $303bff326b387541$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $303bff326b387541$var$createScale = function createScale(_ref) {
    var data = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x = _ref.x, width = _ref.width, travellerWidth = _ref.travellerWidth;
    if (!data || !data.length) return {};
    var len = data.length;
    var scale = (0, $56a5f1c61b5282e1$exports.scalePoint)().domain((0, (/*@__PURE__*/$parcel$interopDefault($a2e6c83a615b2213$exports)))(0, len)).range([
        x,
        x + width - travellerWidth
    ]);
    var scaleValues = scale.domain().map(function(entry) {
        return scale(entry);
    });
    return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        isTravellerFocused: false,
        startX: scale(startIndex),
        endX: scale(endIndex),
        scale: scale,
        scaleValues: scaleValues
    };
};
var $303bff326b387541$var$isTouch = function isTouch(e) {
    return e.changedTouches && !!e.changedTouches.length;
};
var $303bff326b387541$export$59bc2e3533b384a0 = /*#__PURE__*/ function(_PureComponent) {
    function Brush(props) {
        var _this;
        $303bff326b387541$var$_classCallCheck(this, Brush);
        _this = $303bff326b387541$var$_callSuper(this, Brush, [
            props
        ]);
        $303bff326b387541$var$_defineProperty(_this, "handleDrag", function(e) {
            if (_this.leaveTimer) {
                clearTimeout(_this.leaveTimer);
                _this.leaveTimer = null;
            }
            if (_this.state.isTravellerMoving) _this.handleTravellerMove(e);
            else if (_this.state.isSlideMoving) _this.handleSlideDrag(e);
        });
        $303bff326b387541$var$_defineProperty(_this, "handleTouchMove", function(e) {
            if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleDrag(e.changedTouches[0]);
        });
        $303bff326b387541$var$_defineProperty(_this, "handleDragEnd", function() {
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: false
            }, function() {
                var _this$props = _this.props, endIndex = _this$props.endIndex, onDragEnd = _this$props.onDragEnd, startIndex = _this$props.startIndex;
                onDragEnd === null || onDragEnd === void 0 || onDragEnd({
                    endIndex: endIndex,
                    startIndex: startIndex
                });
            });
            _this.detachDragEndListener();
        });
        $303bff326b387541$var$_defineProperty(_this, "handleLeaveWrapper", function() {
            if (_this.state.isTravellerMoving || _this.state.isSlideMoving) _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
        });
        $303bff326b387541$var$_defineProperty(_this, "handleEnterSlideOrTraveller", function() {
            _this.setState({
                isTextActive: true
            });
        });
        $303bff326b387541$var$_defineProperty(_this, "handleLeaveSlideOrTraveller", function() {
            _this.setState({
                isTextActive: false
            });
        });
        $303bff326b387541$var$_defineProperty(_this, "handleSlideDragStart", function(e) {
            var event = $303bff326b387541$var$isTouch(e) ? e.changedTouches[0] : e;
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: true,
                slideMoveStartX: event.pageX
            });
            _this.attachDragEndListener();
        });
        _this.travellerDragStartHandlers = {
            startX: _this.handleTravellerDragStart.bind(_this, 'startX'),
            endX: _this.handleTravellerDragStart.bind(_this, 'endX')
        };
        _this.state = {};
        return _this;
    }
    $303bff326b387541$var$_inherits(Brush, _PureComponent);
    return $303bff326b387541$var$_createClass(Brush, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.leaveTimer) {
                    clearTimeout(this.leaveTimer);
                    this.leaveTimer = null;
                }
                this.detachDragEndListener();
            }
        },
        {
            key: "getIndex",
            value: function getIndex(_ref2) {
                var startX = _ref2.startX, endX = _ref2.endX;
                var scaleValues = this.state.scaleValues;
                var _this$props2 = this.props, gap = _this$props2.gap, data = _this$props2.data;
                var lastIndex = data.length - 1;
                var min = Math.min(startX, endX);
                var max = Math.max(startX, endX);
                var minIndex = Brush.getIndexInRange(scaleValues, min);
                var maxIndex = Brush.getIndexInRange(scaleValues, max);
                return {
                    startIndex: minIndex - minIndex % gap,
                    endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
                };
            }
        },
        {
            key: "getTextOfTick",
            value: function getTextOfTick(index) {
                var _this$props3 = this.props, data = _this$props3.data, tickFormatter = _this$props3.tickFormatter, dataKey = _this$props3.dataKey;
                var text = (0, $bc60c84815913bd8$export$f97fc4a450f29a)(data[index], dataKey, index);
                return (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(tickFormatter) ? tickFormatter(text, index) : text;
            }
        },
        {
            key: "attachDragEndListener",
            value: function attachDragEndListener() {
                window.addEventListener('mouseup', this.handleDragEnd, true);
                window.addEventListener('touchend', this.handleDragEnd, true);
                window.addEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "detachDragEndListener",
            value: function detachDragEndListener() {
                window.removeEventListener('mouseup', this.handleDragEnd, true);
                window.removeEventListener('touchend', this.handleDragEnd, true);
                window.removeEventListener('mousemove', this.handleDrag, true);
            }
        },
        {
            key: "handleSlideDrag",
            value: function handleSlideDrag(e) {
                var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX;
                var _this$props4 = this.props, x = _this$props4.x, width = _this$props4.width, travellerWidth = _this$props4.travellerWidth, startIndex = _this$props4.startIndex, endIndex = _this$props4.endIndex, onChange = _this$props4.onChange;
                var delta = e.pageX - slideMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
                else if (delta < 0) delta = Math.max(delta, x - startX, x - endX);
                var newIndex = this.getIndex({
                    startX: startX + delta,
                    endX: endX + delta
                });
                if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) onChange(newIndex);
                this.setState({
                    startX: startX + delta,
                    endX: endX + delta,
                    slideMoveStartX: e.pageX
                });
            }
        },
        {
            key: "handleTravellerDragStart",
            value: function handleTravellerDragStart(id, e) {
                var event = $303bff326b387541$var$isTouch(e) ? e.changedTouches[0] : e;
                this.setState({
                    isSlideMoving: false,
                    isTravellerMoving: true,
                    movingTravellerId: id,
                    brushMoveStartX: event.pageX
                });
                this.attachDragEndListener();
            }
        },
        {
            key: "handleTravellerMove",
            value: function handleTravellerMove(e) {
                var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX;
                var prevValue = this.state[movingTravellerId];
                var _this$props5 = this.props, x = _this$props5.x, width = _this$props5.width, travellerWidth = _this$props5.travellerWidth, onChange = _this$props5.onChange, gap = _this$props5.gap, data = _this$props5.data;
                var params = {
                    startX: this.state.startX,
                    endX: this.state.endX
                };
                var delta = e.pageX - brushMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - prevValue);
                else if (delta < 0) delta = Math.max(delta, x - prevValue);
                params[movingTravellerId] = prevValue + delta;
                var newIndex = this.getIndex(params);
                var startIndex = newIndex.startIndex, endIndex = newIndex.endIndex;
                var isFullGap = function isFullGap() {
                    var lastIndex = data.length - 1;
                    if (movingTravellerId === 'startX' && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === 'endX' && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) return true;
                    return false;
                };
                this.setState($303bff326b387541$var$_defineProperty($303bff326b387541$var$_defineProperty({}, movingTravellerId, prevValue + delta), "brushMoveStartX", e.pageX), function() {
                    if (onChange) {
                        if (isFullGap()) onChange(newIndex);
                    }
                });
            }
        },
        {
            key: "handleTravellerMoveKeyboard",
            value: function handleTravellerMoveKeyboard(direction, id) {
                var _this2 = this;
                // scaleValues are a list of coordinates. For example: [65, 250, 435, 620, 805, 990].
                var _this$state3 = this.state, scaleValues = _this$state3.scaleValues, startX = _this$state3.startX, endX = _this$state3.endX;
                // currentScaleValue refers to which coordinate the current traveller should be placed at.
                var currentScaleValue = this.state[id];
                var currentIndex = scaleValues.indexOf(currentScaleValue);
                if (currentIndex === -1) return;
                var newIndex = currentIndex + direction;
                if (newIndex === -1 || newIndex >= scaleValues.length) return;
                var newScaleValue = scaleValues[newIndex];
                // Prevent travellers from being on top of each other or overlapping
                if (id === 'startX' && newScaleValue >= endX || id === 'endX' && newScaleValue <= startX) return;
                this.setState($303bff326b387541$var$_defineProperty({}, id, newScaleValue), function() {
                    _this2.props.onChange(_this2.getIndex({
                        startX: _this2.state.startX,
                        endX: _this2.state.endX
                    }));
                });
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, fill = _this$props6.fill, stroke = _this$props6.stroke;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("rect", {
                    stroke: stroke,
                    fill: fill,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderPanorama",
            value: function renderPanorama() {
                var _this$props7 = this.props, x = _this$props7.x, y = _this$props7.y, width = _this$props7.width, height = _this$props7.height, data = _this$props7.data, children = _this$props7.children, padding = _this$props7.padding;
                var chartElement = (0, $8T3gX.Children).only(children);
                if (!chartElement) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(chartElement, {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    margin: padding,
                    compact: true,
                    data: data
                });
            }
        },
        {
            key: "renderTravellerLayer",
            value: function renderTravellerLayer(travellerX, id) {
                var _data$startIndex, _data$endIndex, _this3 = this;
                var _this$props8 = this.props, y = _this$props8.y, travellerWidth = _this$props8.travellerWidth, height = _this$props8.height, traveller = _this$props8.traveller, ariaLabel = _this$props8.ariaLabel, data = _this$props8.data, startIndex = _this$props8.startIndex, endIndex = _this$props8.endIndex;
                var x = Math.max(travellerX, this.props.x);
                var travellerProps = $303bff326b387541$var$_objectSpread($303bff326b387541$var$_objectSpread({}, (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(this.props, false)), {}, {
                    x: x,
                    y: y,
                    width: travellerWidth,
                    height: height
                });
                var ariaLabelBrush = ariaLabel || "Min value: ".concat((_data$startIndex = data[startIndex]) === null || _data$startIndex === void 0 ? void 0 : _data$startIndex.name, ", Max value: ").concat((_data$endIndex = data[endIndex]) === null || _data$endIndex === void 0 ? void 0 : _data$endIndex.name);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $3366a7250677b47e$export$936d0764594b6eb3), {
                    tabIndex: 0,
                    role: "slider",
                    "aria-label": ariaLabelBrush,
                    "aria-valuenow": travellerX,
                    className: "recharts-brush-traveller",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.travellerDragStartHandlers[id],
                    onTouchStart: this.travellerDragStartHandlers[id],
                    onKeyDown: function onKeyDown(e) {
                        if (![
                            'ArrowLeft',
                            'ArrowRight'
                        ].includes(e.key)) return;
                        e.preventDefault();
                        e.stopPropagation();
                        _this3.handleTravellerMoveKeyboard(e.key === 'ArrowRight' ? 1 : -1, id);
                    },
                    onFocus: function onFocus() {
                        _this3.setState({
                            isTravellerFocused: true
                        });
                    },
                    onBlur: function onBlur() {
                        _this3.setState({
                            isTravellerFocused: false
                        });
                    },
                    style: {
                        cursor: 'col-resize'
                    }
                }, Brush.renderTraveller(traveller, travellerProps));
            }
        },
        {
            key: "renderSlide",
            value: function renderSlide(startX, endX) {
                var _this$props9 = this.props, y = _this$props9.y, height = _this$props9.height, stroke = _this$props9.stroke, travellerWidth = _this$props9.travellerWidth;
                var x = Math.min(startX, endX) + travellerWidth;
                var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("rect", {
                    className: "recharts-brush-slide",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.handleSlideDragStart,
                    onTouchStart: this.handleSlideDragStart,
                    style: {
                        cursor: 'move'
                    },
                    stroke: "none",
                    fill: stroke,
                    fillOpacity: 0.2,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderText",
            value: function renderText() {
                var _this$props10 = this.props, startIndex = _this$props10.startIndex, endIndex = _this$props10.endIndex, y = _this$props10.y, height = _this$props10.height, travellerWidth = _this$props10.travellerWidth, stroke = _this$props10.stroke;
                var _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX;
                var offset = 5;
                var attrs = {
                    pointerEvents: 'none',
                    fill: stroke
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $3366a7250677b47e$export$936d0764594b6eb3), {
                    className: "recharts-brush-texts"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $46eed3e26c0880f0$export$5f1af8db9871e1d6), $303bff326b387541$var$_extends({
                    textAnchor: "end",
                    verticalAnchor: "middle",
                    x: Math.min(startX, endX) - offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(startIndex)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $46eed3e26c0880f0$export$5f1af8db9871e1d6), $303bff326b387541$var$_extends({
                    textAnchor: "start",
                    verticalAnchor: "middle",
                    x: Math.max(startX, endX) + travellerWidth + offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(endIndex)));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props11 = this.props, data = _this$props11.data, className = _this$props11.className, children = _this$props11.children, x = _this$props11.x, y = _this$props11.y, width = _this$props11.width, height = _this$props11.height, alwaysShowText = _this$props11.alwaysShowText;
                var _this$state5 = this.state, startX = _this$state5.startX, endX = _this$state5.endX, isTextActive = _this$state5.isTextActive, isSlideMoving = _this$state5.isSlideMoving, isTravellerMoving = _this$state5.isTravellerMoving, isTravellerFocused = _this$state5.isTravellerFocused;
                if (!data || !data.length || !(0, $ec351366ffe25ce6$export$7e4aa119212bc614)(x) || !(0, $ec351366ffe25ce6$export$7e4aa119212bc614)(y) || !(0, $ec351366ffe25ce6$export$7e4aa119212bc614)(width) || !(0, $ec351366ffe25ce6$export$7e4aa119212bc614)(height) || width <= 0 || height <= 0) return null;
                var layerClass = (0, $iVyaN.default)('recharts-brush', className);
                var isPanoramic = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.count(children) === 1;
                var style = (0, $9201ba5e05084789$export$4a9169b65825efee)('userSelect', 'none');
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $3366a7250677b47e$export$936d0764594b6eb3), {
                    className: layerClass,
                    onMouseLeave: this.handleLeaveWrapper,
                    onTouchMove: this.handleTouchMove,
                    style: style
                }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, 'startX'), this.renderTravellerLayer(endX, 'endX'), (isTextActive || isSlideMoving || isTravellerMoving || isTravellerFocused || alwaysShowText) && this.renderText());
            }
        }
    ], [
        {
            key: "renderDefaultTraveller",
            value: function renderDefaultTraveller(props) {
                var x = props.x, y = props.y, width = props.width, height = props.height, stroke = props.stroke;
                var lineY = Math.floor(y + height / 2) - 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    fill: stroke,
                    stroke: "none"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("line", {
                    x1: x + 1,
                    y1: lineY,
                    x2: x + width - 1,
                    y2: lineY,
                    fill: "none",
                    stroke: "#fff"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("line", {
                    x1: x + 1,
                    y1: lineY + 2,
                    x2: x + width - 1,
                    y2: lineY + 2,
                    fill: "none",
                    stroke: "#fff"
                }));
            }
        },
        {
            key: "renderTraveller",
            value: function renderTraveller(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).isValidElement(option)) rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(option)) rectangle = option(props);
                else rectangle = Brush.renderDefaultTraveller(props);
                return rectangle;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var data = nextProps.data, width = nextProps.width, x = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
                if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) return $303bff326b387541$var$_objectSpread({
                    prevData: data,
                    prevTravellerWidth: travellerWidth,
                    prevUpdateId: updateId,
                    prevX: x,
                    prevWidth: width
                }, data && data.length ? $303bff326b387541$var$createScale({
                    data: data,
                    width: width,
                    x: x,
                    travellerWidth: travellerWidth,
                    startIndex: startIndex,
                    endIndex: endIndex
                }) : {
                    scale: null,
                    scaleValues: null
                });
                if (prevState.scale && (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
                    prevState.scale.range([
                        x,
                        x + width - travellerWidth
                    ]);
                    var scaleValues = prevState.scale.domain().map(function(entry) {
                        return prevState.scale(entry);
                    });
                    return {
                        prevData: data,
                        prevTravellerWidth: travellerWidth,
                        prevUpdateId: updateId,
                        prevX: x,
                        prevWidth: width,
                        startX: prevState.scale(nextProps.startIndex),
                        endX: prevState.scale(nextProps.endIndex),
                        scaleValues: scaleValues
                    };
                }
                return null;
            }
        },
        {
            key: "getIndexInRange",
            value: function getIndexInRange(valueRange, x) {
                var len = valueRange.length;
                var start = 0;
                var end = len - 1;
                while(end - start > 1){
                    var middle = Math.floor((start + end) / 2);
                    if (valueRange[middle] > x) end = middle;
                    else start = middle;
                }
                return x >= valueRange[end] ? end : start;
            }
        }
    ]);
}((0, $8T3gX.PureComponent));
$303bff326b387541$var$_defineProperty($303bff326b387541$export$59bc2e3533b384a0, "displayName", 'Brush');
$303bff326b387541$var$_defineProperty($303bff326b387541$export$59bc2e3533b384a0, "defaultProps", {
    height: 40,
    travellerWidth: 5,
    gap: 1,
    fill: '#fff',
    stroke: '#666',
    padding: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
    },
    leaveTimeOut: 1000,
    alwaysShowText: false
});






var $8T3gX = parcelRequire("8T3gX");


var $iVyaN = parcelRequire("iVyaN");




var $6b03c6e1efdec508$export$3fb112445eb31879 = function ifOverflowMatches(props, value) {
    var alwaysShow = props.alwaysShow;
    var ifOverflow = props.ifOverflow;
    if (alwaysShow) ifOverflow = 'extendDomain';
    return ifOverflow === value;
};


var $25b56b7191d13321$exports = {};
var $5cd807a6ad780171$exports = {};

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $5cd807a6ad780171$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $38fd38fdd95df333$exports) $38fd38fdd95df333$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$5cd807a6ad780171$exports = $5cd807a6ad780171$var$baseAssignValue;




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $25b56b7191d13321$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $9dd1d38dfe69ddcf$exports(iteratee, 3);
    $b8b184dbd2d79b13$exports(object, function(value, key, object) {
        $5cd807a6ad780171$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$25b56b7191d13321$exports = $25b56b7191d13321$var$mapValues;


var $3090a3b497c3e395$exports = {};
var $36d740e98ecd7cb4$exports = {};
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function $36d740e98ecd7cb4$var$arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
$36d740e98ecd7cb4$exports = $36d740e98ecd7cb4$var$arrayEvery;


var $6558049d188ec6c0$exports = {};

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function $6558049d188ec6c0$var$baseEvery(collection, predicate) {
    var result = true;
    $fc4011160035cb96$exports(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
$6558049d188ec6c0$exports = $6558049d188ec6c0$var$baseEvery;





/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function $3090a3b497c3e395$var$every(collection, predicate, guard) {
    var func = $b47d971f66a6f054$exports(collection) ? $36d740e98ecd7cb4$exports : $6558049d188ec6c0$exports;
    if (guard && $f5d86346a533d383$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $9dd1d38dfe69ddcf$exports(predicate, 3));
}
$3090a3b497c3e395$exports = $3090a3b497c3e395$var$every;






function $7d73999c8f418f71$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7d73999c8f418f71$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7d73999c8f418f71$var$_typeof(o);
}
function $7d73999c8f418f71$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7d73999c8f418f71$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7d73999c8f418f71$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7d73999c8f418f71$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7d73999c8f418f71$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7d73999c8f418f71$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7d73999c8f418f71$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7d73999c8f418f71$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7d73999c8f418f71$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7d73999c8f418f71$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7d73999c8f418f71$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7d73999c8f418f71$var$_defineProperty(obj, key, value) {
    key = $7d73999c8f418f71$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7d73999c8f418f71$var$_toPropertyKey(t) {
    var i = $7d73999c8f418f71$var$_toPrimitive(t, "string");
    return "symbol" == $7d73999c8f418f71$var$_typeof(i) ? i : i + "";
}
function $7d73999c8f418f71$var$_toPrimitive(t, r) {
    if ("object" != $7d73999c8f418f71$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $7d73999c8f418f71$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $7d73999c8f418f71$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height, layout = props.layout, children = props.children;
    var ids = Object.keys(axisMap);
    var steps = {
        left: offset.left,
        leftMirror: offset.left,
        right: width - offset.right,
        rightMirror: width - offset.right,
        top: offset.top,
        topMirror: offset.top,
        bottom: height - offset.bottom,
        bottomMirror: height - offset.bottom
    };
    var hasBar = !!(0, $10636f1b3e62ab88$export$64c61536a2b72e0f)(children, (0, $7d5fe63ca2eb078d$export$bbc6c6369b38e3d1));
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var orientation = axis.orientation, domain = axis.domain, _axis$padding = axis.padding, padding = _axis$padding === void 0 ? {} : _axis$padding, mirror = axis.mirror, reversed = axis.reversed;
        var offsetKey = "".concat(orientation).concat(mirror ? 'Mirror' : '');
        var calculatedPadding, range, x, y, needSpace;
        if (axis.type === 'number' && (axis.padding === 'gap' || axis.padding === 'no-gap')) {
            var diff = domain[1] - domain[0];
            var smallestDistanceBetweenValues = Infinity;
            var sortedValues = axis.categoricalDomain.sort((0, $ec351366ffe25ce6$export$6ab1df3197f7c641));
            sortedValues.forEach(function(value, index) {
                if (index > 0) smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index - 1] || 0), smallestDistanceBetweenValues);
            });
            if (Number.isFinite(smallestDistanceBetweenValues)) {
                var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
                var rangeWidth = axis.layout === 'vertical' ? offset.height : offset.width;
                if (axis.padding === 'gap') calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
                if (axis.padding === 'no-gap') {
                    var gap = (0, $ec351366ffe25ce6$export$476354dbf49bdff6)(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
                    var halfBand = smallestDistanceInPercent * rangeWidth / 2;
                    calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
                }
            }
        }
        if (axisType === 'xAxis') range = [
            offset.left + (padding.left || 0) + (calculatedPadding || 0),
            offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)
        ];
        else if (axisType === 'yAxis') range = layout === 'horizontal' ? [
            offset.top + offset.height - (padding.bottom || 0),
            offset.top + (padding.top || 0)
        ] : [
            offset.top + (padding.top || 0) + (calculatedPadding || 0),
            offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)
        ];
        else range = axis.range;
        if (reversed) range = [
            range[1],
            range[0]
        ];
        var _parseScale = (0, $bc60c84815913bd8$export$534b094a708572c1)(axis, chartName, hasBar), scale = _parseScale.scale, realScaleType = _parseScale.realScaleType;
        scale.domain(domain).range(range);
        (0, $bc60c84815913bd8$export$9d80152e23bae434)(scale);
        var ticks = (0, $bc60c84815913bd8$export$ac086aaa4358d590)(scale, $7d73999c8f418f71$var$_objectSpread($7d73999c8f418f71$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        if (axisType === 'xAxis') {
            needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
            x = offset.left;
            y = steps[offsetKey] - needSpace * axis.height;
        } else if (axisType === 'yAxis') {
            needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
            x = steps[offsetKey] - needSpace * axis.width;
            y = offset.top;
        }
        var finalAxis = $7d73999c8f418f71$var$_objectSpread($7d73999c8f418f71$var$_objectSpread($7d73999c8f418f71$var$_objectSpread({}, axis), ticks), {}, {
            realScaleType: realScaleType,
            x: x,
            y: y,
            scale: scale,
            width: axisType === 'xAxis' ? offset.width : axis.width,
            height: axisType === 'yAxis' ? offset.height : axis.height
        });
        finalAxis.bandSize = (0, $bc60c84815913bd8$export$212ec45c42fe68a7)(finalAxis, ticks);
        if (!axis.hide && axisType === 'xAxis') steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
        else if (!axis.hide) steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
        return $7d73999c8f418f71$var$_objectSpread($7d73999c8f418f71$var$_objectSpread({}, result), {}, $7d73999c8f418f71$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $7d73999c8f418f71$export$c7964a5b9439ae62 = function rectWithPoints(_ref, _ref2) {
    var x1 = _ref.x, y1 = _ref.y;
    var x2 = _ref2.x, y2 = _ref2.y;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var $7d73999c8f418f71$export$6df2062b9e15eec0 = function rectWithCoords(_ref3) {
    var x1 = _ref3.x1, y1 = _ref3.y1, x2 = _ref3.x2, y2 = _ref3.y2;
    return $7d73999c8f418f71$export$c7964a5b9439ae62({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
var $7d73999c8f418f71$export$dae1ac4449a69ee8 = /*#__PURE__*/ function() {
    function ScaleHelper(scale) {
        $7d73999c8f418f71$var$_classCallCheck(this, ScaleHelper);
        this.scale = scale;
    }
    return $7d73999c8f418f71$var$_createClass(ScaleHelper, [
        {
            key: "domain",
            get: function get() {
                return this.scale.domain;
            }
        },
        {
            key: "range",
            get: function get() {
                return this.scale.range;
            }
        },
        {
            key: "rangeMin",
            get: function get() {
                return this.range()[0];
            }
        },
        {
            key: "rangeMax",
            get: function get() {
                return this.range()[1];
            }
        },
        {
            key: "bandwidth",
            get: function get() {
                return this.scale.bandwidth;
            }
        },
        {
            key: "apply",
            value: function apply(value) {
                var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref4.bandAware, position = _ref4.position;
                if (value === undefined) return undefined;
                if (position) switch(position){
                    case 'start':
                        return this.scale(value);
                    case 'middle':
                        var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                        return this.scale(value) + offset;
                    case 'end':
                        var _offset = this.bandwidth ? this.bandwidth() : 0;
                        return this.scale(value) + _offset;
                    default:
                        return this.scale(value);
                }
                if (bandAware) {
                    var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
                    return this.scale(value) + _offset2;
                }
                return this.scale(value);
            }
        },
        {
            key: "isInRange",
            value: function isInRange(value) {
                var range = this.range();
                var first = range[0];
                var last = range[range.length - 1];
                return first <= last ? value >= first && value <= last : value >= last && value <= first;
            }
        }
    ], [
        {
            key: "create",
            value: function create(obj) {
                return new ScaleHelper(obj);
            }
        }
    ]);
}();
$7d73999c8f418f71$var$_defineProperty($7d73999c8f418f71$export$dae1ac4449a69ee8, "EPS", 1e-4);
var $7d73999c8f418f71$export$db77ae668c18269f = function createLabeledScales(options) {
    var scales = Object.keys(options).reduce(function(res, key) {
        return $7d73999c8f418f71$var$_objectSpread($7d73999c8f418f71$var$_objectSpread({}, res), {}, $7d73999c8f418f71$var$_defineProperty({}, key, $7d73999c8f418f71$export$dae1ac4449a69ee8.create(options[key])));
    }, {});
    return $7d73999c8f418f71$var$_objectSpread($7d73999c8f418f71$var$_objectSpread({}, scales), {}, {
        apply: function apply(coord) {
            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref5.bandAware, position = _ref5.position;
            return (0, (/*@__PURE__*/$parcel$interopDefault($25b56b7191d13321$exports)))(coord, function(value, label) {
                return scales[label].apply(value, {
                    bandAware: bandAware,
                    position: position
                });
            });
        },
        isInRange: function isInRange(coord) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($3090a3b497c3e395$exports)))(coord, function(value, label) {
                return scales[label].isInRange(value);
            });
        }
    });
};
function $7d73999c8f418f71$export$e3df76cf4464bc81(angle) {
    return (angle % 180 + 180) % 180;
}
var $7d73999c8f418f71$export$3ee78d51cffc2b68 = function getAngledRectangleWidth(_ref6) {
    var width = _ref6.width, height = _ref6.height;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = $7d73999c8f418f71$export$e3df76cf4464bc81(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};




function $ef0ba41c4c37f570$var$_extends() {
    $ef0ba41c4c37f570$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ef0ba41c4c37f570$var$_extends.apply(this, arguments);
}
function $ef0ba41c4c37f570$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ef0ba41c4c37f570$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ef0ba41c4c37f570$var$_typeof(o);
}
function $ef0ba41c4c37f570$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ef0ba41c4c37f570$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ef0ba41c4c37f570$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ef0ba41c4c37f570$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ef0ba41c4c37f570$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ef0ba41c4c37f570$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ef0ba41c4c37f570$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $ef0ba41c4c37f570$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $ef0ba41c4c37f570$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ef0ba41c4c37f570$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ef0ba41c4c37f570$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $ef0ba41c4c37f570$var$_callSuper(t, o, e) {
    return o = $ef0ba41c4c37f570$var$_getPrototypeOf(o), $ef0ba41c4c37f570$var$_possibleConstructorReturn(t, $ef0ba41c4c37f570$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $ef0ba41c4c37f570$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $ef0ba41c4c37f570$var$_possibleConstructorReturn(self, call) {
    if (call && ($ef0ba41c4c37f570$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $ef0ba41c4c37f570$var$_assertThisInitialized(self);
}
function $ef0ba41c4c37f570$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ef0ba41c4c37f570$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ef0ba41c4c37f570$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $ef0ba41c4c37f570$var$_getPrototypeOf(o) {
    $ef0ba41c4c37f570$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ef0ba41c4c37f570$var$_getPrototypeOf(o);
}
function $ef0ba41c4c37f570$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $ef0ba41c4c37f570$var$_setPrototypeOf(subClass, superClass);
}
function $ef0ba41c4c37f570$var$_setPrototypeOf(o, p) {
    $ef0ba41c4c37f570$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ef0ba41c4c37f570$var$_setPrototypeOf(o, p);
}
function $ef0ba41c4c37f570$var$_defineProperty(obj, key, value) {
    key = $ef0ba41c4c37f570$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ef0ba41c4c37f570$var$_toPropertyKey(t) {
    var i = $ef0ba41c4c37f570$var$_toPrimitive(t, "string");
    return "symbol" == $ef0ba41c4c37f570$var$_typeof(i) ? i : i + "";
}
function $ef0ba41c4c37f570$var$_toPrimitive(t, r) {
    if ("object" != $ef0ba41c4c37f570$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ef0ba41c4c37f570$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $ef0ba41c4c37f570$var$getCoordinate = function getCoordinate(props) {
    var x = props.x, y = props.y, xAxis = props.xAxis, yAxis = props.yAxis;
    var scales = (0, $7d73999c8f418f71$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var result = scales.apply({
        x: x,
        y: y
    }, {
        bandAware: true
    });
    if ((0, $6b03c6e1efdec508$export$3fb112445eb31879)(props, 'discard') && !scales.isInRange(result)) return null;
    return result;
};
var $ef0ba41c4c37f570$export$aa7f0b0106bff39 = /*#__PURE__*/ function(_React$Component) {
    function ReferenceDot() {
        $ef0ba41c4c37f570$var$_classCallCheck(this, ReferenceDot);
        return $ef0ba41c4c37f570$var$_callSuper(this, ReferenceDot, arguments);
    }
    $ef0ba41c4c37f570$var$_inherits(ReferenceDot, _React$Component);
    return $ef0ba41c4c37f570$var$_createClass(ReferenceDot, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x = _this$props.x, y = _this$props.y, r = _this$props.r, alwaysShow = _this$props.alwaysShow, clipPathId = _this$props.clipPathId;
                var isX = (0, $ec351366ffe25ce6$export$402a499e1ea44294)(x);
                var isY = (0, $ec351366ffe25ce6$export$402a499e1ea44294)(y);
                (0, $a1b0f3d7b382d4a4$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
                if (!isX || !isY) return null;
                var coordinate = $ef0ba41c4c37f570$var$getCoordinate(this.props);
                if (!coordinate) return null;
                var cx = coordinate.x, cy = coordinate.y;
                var _this$props2 = this.props, shape = _this$props2.shape, className = _this$props2.className;
                var clipPath = (0, $6b03c6e1efdec508$export$3fb112445eb31879)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
                var dotProps = $ef0ba41c4c37f570$var$_objectSpread($ef0ba41c4c37f570$var$_objectSpread({
                    clipPath: clipPath
                }, (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(this.props, true)), {}, {
                    cx: cx,
                    cy: cy
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $3366a7250677b47e$export$936d0764594b6eb3), {
                    className: (0, $iVyaN.default)('recharts-reference-dot', className)
                }, ReferenceDot.renderDot(shape, dotProps), (0, $eb6f3b719cc1691f$export$b04be29aa201d4f5).renderCallByParent(this.props, {
                    x: cx - r,
                    y: cy - r,
                    width: 2 * r,
                    height: 2 * r
                }));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Component);
$ef0ba41c4c37f570$var$_defineProperty($ef0ba41c4c37f570$export$aa7f0b0106bff39, "displayName", 'ReferenceDot');
$ef0ba41c4c37f570$var$_defineProperty($ef0ba41c4c37f570$export$aa7f0b0106bff39, "defaultProps", {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#fff',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1
});
$ef0ba41c4c37f570$var$_defineProperty($ef0ba41c4c37f570$export$aa7f0b0106bff39, "renderDot", function(option, props) {
    var dot;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).isValidElement(option)) dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(option)) dot = option(props);
    else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $295618a64acc25e0$export$d046b3c4a416f60d), $ef0ba41c4c37f570$var$_extends({}, props, {
        cx: props.cx,
        cy: props.cy,
        className: "recharts-reference-dot-dot"
    }));
    return dot;
});



var $8T3gX = parcelRequire("8T3gX");

var $17477d2910b68364$exports = {};


var $6af3cdb838677e75$exports = {};

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $6af3cdb838677e75$var$baseSome(collection, predicate) {
    var result;
    $fc4011160035cb96$exports(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
$6af3cdb838677e75$exports = $6af3cdb838677e75$var$baseSome;




/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $17477d2910b68364$var$some(collection, predicate, guard) {
    var func = $b47d971f66a6f054$exports(collection) ? $a56761d28df36f98$exports : $6af3cdb838677e75$exports;
    if (guard && $f5d86346a533d383$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $9dd1d38dfe69ddcf$exports(predicate, 3));
}
$17477d2910b68364$exports = $17477d2910b68364$var$some;



var $iVyaN = parcelRequire("iVyaN");








var $8T3gX = parcelRequire("8T3gX");

var $9f60e838fdb2edf2$exports = {};
var $01f07113cfe93416$exports = {};



/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $01f07113cfe93416$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$edace719698f1e70$exports(collection)) {
            var iteratee = $9dd1d38dfe69ddcf$exports(predicate, 3);
            collection = $9c7d1fa85e24a67e$exports(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
$01f07113cfe93416$exports = $01f07113cfe93416$var$createFind;


var $b06cdbd0cbf9caa7$exports = {};


var $da5fff48ccc726db$exports = {};

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $da5fff48ccc726db$var$toInteger(value) {
    var result = $420360e96c86f53d$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$da5fff48ccc726db$exports = $da5fff48ccc726db$var$toInteger;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $b06cdbd0cbf9caa7$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $b06cdbd0cbf9caa7$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $da5fff48ccc726db$exports(fromIndex);
    if (index < 0) index = $b06cdbd0cbf9caa7$var$nativeMax(length + index, 0);
    return $97e784a8512e4a9d$exports(array, $9dd1d38dfe69ddcf$exports(predicate, 3), index);
}
$b06cdbd0cbf9caa7$exports = $b06cdbd0cbf9caa7$var$findIndex;


/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $9f60e838fdb2edf2$var$find = $01f07113cfe93416$exports($b06cdbd0cbf9caa7$exports);
$9f60e838fdb2edf2$exports = $9f60e838fdb2edf2$var$find;




var $788af798e245c5f3$export$7e29f973febe72ad = (0, (/*@__PURE__*/$parcel$interopDefault($5659748bd598a7eb$exports)))(function(offset) {
    return {
        x: offset.left,
        y: offset.top,
        width: offset.width,
        height: offset.height
    };
}, function(offset) {
    return [
        'l',
        offset.left,
        't',
        offset.top,
        'w',
        offset.width,
        'h',
        offset.height
    ].join('');
});



function $aaec315a6c49009f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $aaec315a6c49009f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $aaec315a6c49009f$var$_typeof(o);
}
var $aaec315a6c49009f$export$92c2a2c8239475bf = /*#__PURE__*/ (0, $8T3gX.createContext)(undefined);
var $aaec315a6c49009f$export$40ceabe61e17c4dc = /*#__PURE__*/ (0, $8T3gX.createContext)(undefined);
var $aaec315a6c49009f$export$29b7735f8b5653b2 = /*#__PURE__*/ (0, $8T3gX.createContext)(undefined);
var $aaec315a6c49009f$export$482c85f2026f212e = /*#__PURE__*/ (0, $8T3gX.createContext)({});
var $aaec315a6c49009f$export$e42cfe3f3988c70f = /*#__PURE__*/ (0, $8T3gX.createContext)(undefined);
var $aaec315a6c49009f$export$b18854f928720bc8 = /*#__PURE__*/ (0, $8T3gX.createContext)(0);
var $aaec315a6c49009f$export$3c3f0c9338cf7530 = /*#__PURE__*/ (0, $8T3gX.createContext)(0);
var $aaec315a6c49009f$export$e22c0f72c980af5a = function ChartLayoutContextProvider(props) {
    var _props$state = props.state, xAxisMap = _props$state.xAxisMap, yAxisMap = _props$state.yAxisMap, offset = _props$state.offset, clipPathId = props.clipPathId, children = props.children, width = props.width, height = props.height;
    /**
   * Perhaps we should compute this property when reading? Let's see what is more often used
   */ var viewBox = (0, $788af798e245c5f3$export$7e29f973febe72ad)(offset);
    /*
   * This pretends to be a single context but actually is split into multiple smaller ones.
   * Why?
   * Because one React Context only allows to set one value.
   * But we need to set multiple values.
   * If we do that with one context, then we force re-render on components that might not even be interested
   * in the part of the state that has changed.
   *
   * By splitting into smaller contexts, we allow each components to be optimized and only re-render when its dependencies change.
   *
   * To actually achieve the optimal re-render, it is necessary to use React.memo().
   * See the test file for details.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement($aaec315a6c49009f$export$92c2a2c8239475bf.Provider, {
        value: xAxisMap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement($aaec315a6c49009f$export$40ceabe61e17c4dc.Provider, {
        value: yAxisMap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement($aaec315a6c49009f$export$482c85f2026f212e.Provider, {
        value: offset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement($aaec315a6c49009f$export$29b7735f8b5653b2.Provider, {
        value: viewBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement($aaec315a6c49009f$export$e42cfe3f3988c70f.Provider, {
        value: clipPathId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement($aaec315a6c49009f$export$b18854f928720bc8.Provider, {
        value: height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement($aaec315a6c49009f$export$3c3f0c9338cf7530.Provider, {
        value: width
    }, children)))))));
};
var $aaec315a6c49009f$export$71e825c43eae6ca6 = function useClipPathId() {
    return (0, $8T3gX.useContext)($aaec315a6c49009f$export$e42cfe3f3988c70f);
};
function $aaec315a6c49009f$var$getKeysForDebug(object) {
    var keys = Object.keys(object);
    if (keys.length === 0) return 'There are no available ids.';
    return "Available ids are: ".concat(keys, ".");
}
var $aaec315a6c49009f$export$54f54805c81085c5 = function useXAxisOrThrow(xAxisId) {
    var xAxisMap = (0, $8T3gX.useContext)($aaec315a6c49009f$export$92c2a2c8239475bf);
    !(xAxisMap != null) && (0, $668d778f3ad25eac$export$2e2bcd8739ae039)(false, 'Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?');
    var xAxis = xAxisMap[xAxisId];
    !(xAxis != null) && (0, $668d778f3ad25eac$export$2e2bcd8739ae039)(false, "Could not find xAxis by id \"".concat(xAxisId, "\" [").concat($aaec315a6c49009f$var$_typeof(xAxisId), "]. ").concat($aaec315a6c49009f$var$getKeysForDebug(xAxisMap)));
    return xAxis;
};
var $aaec315a6c49009f$export$1d855c2865750a72 = function useArbitraryXAxis() {
    var xAxisMap = (0, $8T3gX.useContext)($aaec315a6c49009f$export$92c2a2c8239475bf);
    return (0, $ec351366ffe25ce6$export$b88993f0aa0bf776)(xAxisMap);
};
var $aaec315a6c49009f$export$a691147b33d52613 = function useArbitraryYAxis() {
    var yAxisMap = (0, $8T3gX.useContext)($aaec315a6c49009f$export$40ceabe61e17c4dc);
    return (0, $ec351366ffe25ce6$export$b88993f0aa0bf776)(yAxisMap);
};
var $aaec315a6c49009f$export$631ee617f1052e16 = function useYAxisWithFiniteDomainOrRandom() {
    var yAxisMap = (0, $8T3gX.useContext)($aaec315a6c49009f$export$40ceabe61e17c4dc);
    var yAxisWithFiniteDomain = (0, (/*@__PURE__*/$parcel$interopDefault($9f60e838fdb2edf2$exports)))(yAxisMap, function(axis) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($3090a3b497c3e395$exports)))(axis.domain, Number.isFinite);
    });
    return yAxisWithFiniteDomain || (0, $ec351366ffe25ce6$export$b88993f0aa0bf776)(yAxisMap);
};
var $aaec315a6c49009f$export$6f8958021ad81c20 = function useYAxisOrThrow(yAxisId) {
    var yAxisMap = (0, $8T3gX.useContext)($aaec315a6c49009f$export$40ceabe61e17c4dc);
    !(yAxisMap != null) && (0, $668d778f3ad25eac$export$2e2bcd8739ae039)(false, 'Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?');
    var yAxis = yAxisMap[yAxisId];
    !(yAxis != null) && (0, $668d778f3ad25eac$export$2e2bcd8739ae039)(false, "Could not find yAxis by id \"".concat(yAxisId, "\" [").concat($aaec315a6c49009f$var$_typeof(yAxisId), "]. ").concat($aaec315a6c49009f$var$getKeysForDebug(yAxisMap)));
    return yAxis;
};
var $aaec315a6c49009f$export$76b29bb074e0c45a = function useViewBox() {
    var viewBox = (0, $8T3gX.useContext)($aaec315a6c49009f$export$29b7735f8b5653b2);
    return viewBox;
};
var $aaec315a6c49009f$export$99e5207fa7e69f17 = function useOffset() {
    return (0, $8T3gX.useContext)($aaec315a6c49009f$export$482c85f2026f212e);
};
var $aaec315a6c49009f$export$8854f7ece606854b = function useChartWidth() {
    return (0, $8T3gX.useContext)($aaec315a6c49009f$export$3c3f0c9338cf7530);
};
var $aaec315a6c49009f$export$369ae257969c6f9f = function useChartHeight() {
    return (0, $8T3gX.useContext)($aaec315a6c49009f$export$b18854f928720bc8);
};


function $8e450cc7e7af7203$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8e450cc7e7af7203$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8e450cc7e7af7203$var$_typeof(o);
}
function $8e450cc7e7af7203$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8e450cc7e7af7203$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $8e450cc7e7af7203$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $8e450cc7e7af7203$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8e450cc7e7af7203$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8e450cc7e7af7203$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $8e450cc7e7af7203$var$_callSuper(t, o, e) {
    return o = $8e450cc7e7af7203$var$_getPrototypeOf(o), $8e450cc7e7af7203$var$_possibleConstructorReturn(t, $8e450cc7e7af7203$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $8e450cc7e7af7203$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $8e450cc7e7af7203$var$_possibleConstructorReturn(self, call) {
    if (call && ($8e450cc7e7af7203$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $8e450cc7e7af7203$var$_assertThisInitialized(self);
}
function $8e450cc7e7af7203$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $8e450cc7e7af7203$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($8e450cc7e7af7203$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $8e450cc7e7af7203$var$_getPrototypeOf(o) {
    $8e450cc7e7af7203$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8e450cc7e7af7203$var$_getPrototypeOf(o);
}
function $8e450cc7e7af7203$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $8e450cc7e7af7203$var$_setPrototypeOf(subClass, superClass);
}
function $8e450cc7e7af7203$var$_setPrototypeOf(o, p) {
    $8e450cc7e7af7203$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8e450cc7e7af7203$var$_setPrototypeOf(o, p);
}
function $8e450cc7e7af7203$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8e450cc7e7af7203$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8e450cc7e7af7203$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8e450cc7e7af7203$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8e450cc7e7af7203$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8e450cc7e7af7203$var$_defineProperty(obj, key, value) {
    key = $8e450cc7e7af7203$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8e450cc7e7af7203$var$_toPropertyKey(t) {
    var i = $8e450cc7e7af7203$var$_toPrimitive(t, "string");
    return "symbol" == $8e450cc7e7af7203$var$_typeof(i) ? i : i + "";
}
function $8e450cc7e7af7203$var$_toPrimitive(t, r) {
    if ("object" != $8e450cc7e7af7203$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8e450cc7e7af7203$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $8e450cc7e7af7203$var$_slicedToArray(arr, i) {
    return $8e450cc7e7af7203$var$_arrayWithHoles(arr) || $8e450cc7e7af7203$var$_iterableToArrayLimit(arr, i) || $8e450cc7e7af7203$var$_unsupportedIterableToArray(arr, i) || $8e450cc7e7af7203$var$_nonIterableRest();
}
function $8e450cc7e7af7203$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8e450cc7e7af7203$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8e450cc7e7af7203$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8e450cc7e7af7203$var$_arrayLikeToArray(o, minLen);
}
function $8e450cc7e7af7203$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8e450cc7e7af7203$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $8e450cc7e7af7203$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $8e450cc7e7af7203$var$_extends() {
    $8e450cc7e7af7203$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8e450cc7e7af7203$var$_extends.apply(this, arguments);
}
/**
 * This excludes `viewBox` prop from svg for two reasons:
 * 1. The components wants viewBox of object type, and svg wants string
 *    - so there's a conflict, and the component will throw if it gets string
 * 2. Internally the component calls `filterProps` which filters the viewBox away anyway
 */ var $8e450cc7e7af7203$var$renderLine = function renderLine(option, props) {
    var line;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).isValidElement(option)) line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(option)) line = option(props);
    else line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("line", $8e450cc7e7af7203$var$_extends({}, props, {
        className: "recharts-reference-line-line"
    }));
    return line;
};
var $8e450cc7e7af7203$export$f273d496b213b6da = function getEndPoints(scales, isFixedX, isFixedY, isSegment, viewBox, position, xAxisOrientation, yAxisOrientation, props) {
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (isFixedY) {
        var yCoord = props.y;
        var coord = scales.y.apply(yCoord, {
            position: position
        });
        if ((0, $6b03c6e1efdec508$export$3fb112445eb31879)(props, 'discard') && !scales.y.isInRange(coord)) return null;
        var points = [
            {
                x: x + width,
                y: coord
            },
            {
                x: x,
                y: coord
            }
        ];
        return yAxisOrientation === 'left' ? points.reverse() : points;
    }
    if (isFixedX) {
        var xCoord = props.x;
        var _coord = scales.x.apply(xCoord, {
            position: position
        });
        if ((0, $6b03c6e1efdec508$export$3fb112445eb31879)(props, 'discard') && !scales.x.isInRange(_coord)) return null;
        var _points = [
            {
                x: _coord,
                y: y + height
            },
            {
                x: _coord,
                y: y
            }
        ];
        return xAxisOrientation === 'top' ? _points.reverse() : _points;
    }
    if (isSegment) {
        var segment = props.segment;
        var _points2 = segment.map(function(p) {
            return scales.apply(p, {
                position: position
            });
        });
        if ((0, $6b03c6e1efdec508$export$3fb112445eb31879)(props, 'discard') && (0, (/*@__PURE__*/$parcel$interopDefault($17477d2910b68364$exports)))(_points2, function(p) {
            return !scales.isInRange(p);
        })) return null;
        return _points2;
    }
    return null;
};
function $8e450cc7e7af7203$var$ReferenceLineImpl(props) {
    var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxisId = props.xAxisId, yAxisId = props.yAxisId, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow;
    var clipPathId = (0, $aaec315a6c49009f$export$71e825c43eae6ca6)();
    var xAxis = (0, $aaec315a6c49009f$export$54f54805c81085c5)(xAxisId);
    var yAxis = (0, $aaec315a6c49009f$export$6f8958021ad81c20)(yAxisId);
    var viewBox = (0, $aaec315a6c49009f$export$76b29bb074e0c45a)();
    if (!clipPathId || !viewBox) return null;
    (0, $a1b0f3d7b382d4a4$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var scales = (0, $7d73999c8f418f71$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var isX = (0, $ec351366ffe25ce6$export$402a499e1ea44294)(fixedX);
    var isY = (0, $ec351366ffe25ce6$export$402a499e1ea44294)(fixedY);
    var isSegment = segment && segment.length === 2;
    var endPoints = $8e450cc7e7af7203$export$f273d496b213b6da(scales, isX, isY, isSegment, viewBox, props.position, xAxis.orientation, yAxis.orientation, props);
    if (!endPoints) return null;
    var _endPoints = $8e450cc7e7af7203$var$_slicedToArray(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x2 = _endPoints$2.x, y2 = _endPoints$2.y;
    var clipPath = (0, $6b03c6e1efdec508$export$3fb112445eb31879)(props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
    var lineProps = $8e450cc7e7af7203$var$_objectSpread($8e450cc7e7af7203$var$_objectSpread({
        clipPath: clipPath
    }, (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(props, true)), {}, {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $3366a7250677b47e$export$936d0764594b6eb3), {
        className: (0, $iVyaN.default)('recharts-reference-line', className)
    }, $8e450cc7e7af7203$var$renderLine(shape, lineProps), (0, $eb6f3b719cc1691f$export$b04be29aa201d4f5).renderCallByParent(props, (0, $7d73999c8f418f71$export$6df2062b9e15eec0)({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    })));
}
var $8e450cc7e7af7203$export$b2f28e248e7838eb = /*#__PURE__*/ function(_React$Component) {
    function ReferenceLine() {
        $8e450cc7e7af7203$var$_classCallCheck(this, ReferenceLine);
        return $8e450cc7e7af7203$var$_callSuper(this, ReferenceLine, arguments);
    }
    $8e450cc7e7af7203$var$_inherits(ReferenceLine, _React$Component);
    return $8e450cc7e7af7203$var$_createClass(ReferenceLine, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement($8e450cc7e7af7203$var$ReferenceLineImpl, this.props);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Component);
$8e450cc7e7af7203$var$_defineProperty($8e450cc7e7af7203$export$b2f28e248e7838eb, "displayName", 'ReferenceLine');
$8e450cc7e7af7203$var$_defineProperty($8e450cc7e7af7203$export$b2f28e248e7838eb, "defaultProps", {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    fill: 'none',
    stroke: '#ccc',
    fillOpacity: 1,
    strokeWidth: 1,
    position: 'middle'
});



var $8T3gX = parcelRequire("8T3gX");


var $iVyaN = parcelRequire("iVyaN");








function $6e00151360c41a8d$var$_extends() {
    $6e00151360c41a8d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6e00151360c41a8d$var$_extends.apply(this, arguments);
}
function $6e00151360c41a8d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6e00151360c41a8d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6e00151360c41a8d$var$_typeof(o);
}
function $6e00151360c41a8d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6e00151360c41a8d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6e00151360c41a8d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6e00151360c41a8d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6e00151360c41a8d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6e00151360c41a8d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6e00151360c41a8d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $6e00151360c41a8d$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $6e00151360c41a8d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6e00151360c41a8d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6e00151360c41a8d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $6e00151360c41a8d$var$_callSuper(t, o, e) {
    return o = $6e00151360c41a8d$var$_getPrototypeOf(o), $6e00151360c41a8d$var$_possibleConstructorReturn(t, $6e00151360c41a8d$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $6e00151360c41a8d$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $6e00151360c41a8d$var$_possibleConstructorReturn(self, call) {
    if (call && ($6e00151360c41a8d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $6e00151360c41a8d$var$_assertThisInitialized(self);
}
function $6e00151360c41a8d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6e00151360c41a8d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($6e00151360c41a8d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $6e00151360c41a8d$var$_getPrototypeOf(o) {
    $6e00151360c41a8d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6e00151360c41a8d$var$_getPrototypeOf(o);
}
function $6e00151360c41a8d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $6e00151360c41a8d$var$_setPrototypeOf(subClass, superClass);
}
function $6e00151360c41a8d$var$_setPrototypeOf(o, p) {
    $6e00151360c41a8d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6e00151360c41a8d$var$_setPrototypeOf(o, p);
}
function $6e00151360c41a8d$var$_defineProperty(obj, key, value) {
    key = $6e00151360c41a8d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6e00151360c41a8d$var$_toPropertyKey(t) {
    var i = $6e00151360c41a8d$var$_toPrimitive(t, "string");
    return "symbol" == $6e00151360c41a8d$var$_typeof(i) ? i : i + "";
}
function $6e00151360c41a8d$var$_toPrimitive(t, r) {
    if ("object" != $6e00151360c41a8d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6e00151360c41a8d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $6e00151360c41a8d$var$getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
    var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
    if (!xAxis || !yAxis) return null;
    var scales = (0, $7d73999c8f418f71$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var p1 = {
        x: hasX1 ? scales.x.apply(xValue1, {
            position: 'start'
        }) : scales.x.rangeMin,
        y: hasY1 ? scales.y.apply(yValue1, {
            position: 'start'
        }) : scales.y.rangeMin
    };
    var p2 = {
        x: hasX2 ? scales.x.apply(xValue2, {
            position: 'end'
        }) : scales.x.rangeMax,
        y: hasY2 ? scales.y.apply(yValue2, {
            position: 'end'
        }) : scales.y.rangeMax
    };
    if ((0, $6b03c6e1efdec508$export$3fb112445eb31879)(props, 'discard') && (!scales.isInRange(p1) || !scales.isInRange(p2))) return null;
    return (0, $7d73999c8f418f71$export$c7964a5b9439ae62)(p1, p2);
};
var $6e00151360c41a8d$export$b4ec4f050ce240b9 = /*#__PURE__*/ function(_React$Component) {
    function ReferenceArea() {
        $6e00151360c41a8d$var$_classCallCheck(this, ReferenceArea);
        return $6e00151360c41a8d$var$_callSuper(this, ReferenceArea, arguments);
    }
    $6e00151360c41a8d$var$_inherits(ReferenceArea, _React$Component);
    return $6e00151360c41a8d$var$_createClass(ReferenceArea, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x1 = _this$props.x1, x2 = _this$props.x2, y1 = _this$props.y1, y2 = _this$props.y2, className = _this$props.className, alwaysShow = _this$props.alwaysShow, clipPathId = _this$props.clipPathId;
                (0, $a1b0f3d7b382d4a4$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
                var hasX1 = (0, $ec351366ffe25ce6$export$402a499e1ea44294)(x1);
                var hasX2 = (0, $ec351366ffe25ce6$export$402a499e1ea44294)(x2);
                var hasY1 = (0, $ec351366ffe25ce6$export$402a499e1ea44294)(y1);
                var hasY2 = (0, $ec351366ffe25ce6$export$402a499e1ea44294)(y2);
                var shape = this.props.shape;
                if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) return null;
                var rect = $6e00151360c41a8d$var$getRect(hasX1, hasX2, hasY1, hasY2, this.props);
                if (!rect && !shape) return null;
                var clipPath = (0, $6b03c6e1efdec508$export$3fb112445eb31879)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $3366a7250677b47e$export$936d0764594b6eb3), {
                    className: (0, $iVyaN.default)('recharts-reference-area', className)
                }, ReferenceArea.renderRect(shape, $6e00151360c41a8d$var$_objectSpread($6e00151360c41a8d$var$_objectSpread({
                    clipPath: clipPath
                }, (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(this.props, true)), rect)), (0, $eb6f3b719cc1691f$export$b04be29aa201d4f5).renderCallByParent(this.props, rect));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Component);
$6e00151360c41a8d$var$_defineProperty($6e00151360c41a8d$export$b4ec4f050ce240b9, "displayName", 'ReferenceArea');
$6e00151360c41a8d$var$_defineProperty($6e00151360c41a8d$export$b4ec4f050ce240b9, "defaultProps", {
    isFront: false,
    ifOverflow: 'discard',
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: '#ccc',
    fillOpacity: 0.5,
    stroke: 'none',
    strokeWidth: 1
});
$6e00151360c41a8d$var$_defineProperty($6e00151360c41a8d$export$b4ec4f050ce240b9, "renderRect", function(option, props) {
    var rect;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).isValidElement(option)) rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(option)) rect = option(props);
    else rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $0ab2d840c2839083$export$4617fb02663045ef), $6e00151360c41a8d$var$_extends({}, props, {
        className: "recharts-reference-area-rect"
    }));
    return rect;
});





function $ba11ad50196cc280$var$_toConsumableArray(arr) {
    return $ba11ad50196cc280$var$_arrayWithoutHoles(arr) || $ba11ad50196cc280$var$_iterableToArray(arr) || $ba11ad50196cc280$var$_unsupportedIterableToArray(arr) || $ba11ad50196cc280$var$_nonIterableSpread();
}
function $ba11ad50196cc280$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ba11ad50196cc280$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ba11ad50196cc280$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ba11ad50196cc280$var$_arrayLikeToArray(o, minLen);
}
function $ba11ad50196cc280$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $ba11ad50196cc280$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ba11ad50196cc280$var$_arrayLikeToArray(arr);
}
function $ba11ad50196cc280$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $ba11ad50196cc280$export$62ecf5c04b491381 = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
    var lines = (0, $10636f1b3e62ab88$export$fdd5e64c0e8495bb)(children, (0, $8e450cc7e7af7203$export$b2f28e248e7838eb));
    var dots = (0, $10636f1b3e62ab88$export$fdd5e64c0e8495bb)(children, (0, $ef0ba41c4c37f570$export$aa7f0b0106bff39));
    var elements = [].concat($ba11ad50196cc280$var$_toConsumableArray(lines), $ba11ad50196cc280$var$_toConsumableArray(dots));
    var areas = (0, $10636f1b3e62ab88$export$fdd5e64c0e8495bb)(children, (0, $6e00151360c41a8d$export$b4ec4f050ce240b9));
    var idKey = "".concat(axisType, "Id");
    var valueKey = axisType[0];
    var finalDomain = domain;
    if (elements.length) finalDomain = elements.reduce(function(result, el) {
        if (el.props[idKey] === axisId && (0, $6b03c6e1efdec508$export$3fb112445eb31879)(el.props, 'extendDomain') && (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(el.props[valueKey])) {
            var value = el.props[valueKey];
            return [
                Math.min(result[0], value),
                Math.max(result[1], value)
            ];
        }
        return result;
    }, finalDomain);
    if (areas.length) {
        var key1 = "".concat(valueKey, "1");
        var key2 = "".concat(valueKey, "2");
        finalDomain = areas.reduce(function(result, el) {
            if (el.props[idKey] === axisId && (0, $6b03c6e1efdec508$export$3fb112445eb31879)(el.props, 'extendDomain') && (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(el.props[key1]) && (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(el.props[key2])) {
                var value1 = el.props[key1];
                var value2 = el.props[key2];
                return [
                    Math.min(result[0], value1, value2),
                    Math.max(result[1], value1, value2)
                ];
            }
            return result;
        }, finalDomain);
    }
    if (specifiedTicks && specifiedTicks.length) finalDomain = specifiedTicks.reduce(function(result, tick) {
        if ((0, $ec351366ffe25ce6$export$7e4aa119212bc614)(tick)) return [
            Math.min(result[0], tick),
            Math.max(result[1], tick)
        ];
        return result;
    }, finalDomain);
    return finalDomain;
};




var $d879c7d1cbaaa2e5$exports = {};
'use strict';
var $d879c7d1cbaaa2e5$var$has = Object.prototype.hasOwnProperty, $d879c7d1cbaaa2e5$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $d879c7d1cbaaa2e5$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $d879c7d1cbaaa2e5$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $d879c7d1cbaaa2e5$var$Events().__proto__) $d879c7d1cbaaa2e5$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $d879c7d1cbaaa2e5$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $d879c7d1cbaaa2e5$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $d879c7d1cbaaa2e5$var$EE(fn, context || emitter, once), evt = $d879c7d1cbaaa2e5$var$prefix ? $d879c7d1cbaaa2e5$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $d879c7d1cbaaa2e5$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $d879c7d1cbaaa2e5$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $d879c7d1cbaaa2e5$var$EventEmitter() {
    this._events = new $d879c7d1cbaaa2e5$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $d879c7d1cbaaa2e5$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($d879c7d1cbaaa2e5$var$has.call(events, name)) names.push($d879c7d1cbaaa2e5$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $d879c7d1cbaaa2e5$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $d879c7d1cbaaa2e5$var$prefix ? $d879c7d1cbaaa2e5$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $d879c7d1cbaaa2e5$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $d879c7d1cbaaa2e5$var$prefix ? $d879c7d1cbaaa2e5$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $d879c7d1cbaaa2e5$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $d879c7d1cbaaa2e5$var$prefix ? $d879c7d1cbaaa2e5$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $d879c7d1cbaaa2e5$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $d879c7d1cbaaa2e5$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $d879c7d1cbaaa2e5$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $d879c7d1cbaaa2e5$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $d879c7d1cbaaa2e5$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $d879c7d1cbaaa2e5$var$prefix ? $d879c7d1cbaaa2e5$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $d879c7d1cbaaa2e5$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $d879c7d1cbaaa2e5$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $d879c7d1cbaaa2e5$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $d879c7d1cbaaa2e5$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $d879c7d1cbaaa2e5$var$prefix ? $d879c7d1cbaaa2e5$var$prefix + event : event;
        if (this._events[evt]) $d879c7d1cbaaa2e5$var$clearEvent(this, evt);
    } else {
        this._events = new $d879c7d1cbaaa2e5$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$d879c7d1cbaaa2e5$var$EventEmitter.prototype.off = $d879c7d1cbaaa2e5$var$EventEmitter.prototype.removeListener;
$d879c7d1cbaaa2e5$var$EventEmitter.prototype.addListener = $d879c7d1cbaaa2e5$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$d879c7d1cbaaa2e5$var$EventEmitter.prefixed = $d879c7d1cbaaa2e5$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$d879c7d1cbaaa2e5$var$EventEmitter.EventEmitter = $d879c7d1cbaaa2e5$var$EventEmitter;
$d879c7d1cbaaa2e5$exports = $d879c7d1cbaaa2e5$var$EventEmitter;


var $b8959d024b33388d$export$9bcdfe5f29bb33 = new (0, (/*@__PURE__*/$parcel$interopDefault($d879c7d1cbaaa2e5$exports)))();
var $b8959d024b33388d$export$ff9a08f6d0c38b8f = 'recharts.syncMouseEvents';



function $f530cbe85455dc73$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f530cbe85455dc73$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f530cbe85455dc73$var$_typeof(o);
}
function $f530cbe85455dc73$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f530cbe85455dc73$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $f530cbe85455dc73$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $f530cbe85455dc73$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f530cbe85455dc73$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f530cbe85455dc73$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $f530cbe85455dc73$var$_defineProperty(obj, key, value) {
    key = $f530cbe85455dc73$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f530cbe85455dc73$var$_toPropertyKey(t) {
    var i = $f530cbe85455dc73$var$_toPrimitive(t, "string");
    return "symbol" == $f530cbe85455dc73$var$_typeof(i) ? i : i + "";
}
function $f530cbe85455dc73$var$_toPrimitive(t, r) {
    if ("object" != $f530cbe85455dc73$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f530cbe85455dc73$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $f530cbe85455dc73$export$a2c2de1efa8671eb = /*#__PURE__*/ function() {
    function AccessibilityManager() {
        $f530cbe85455dc73$var$_classCallCheck(this, AccessibilityManager);
        $f530cbe85455dc73$var$_defineProperty(this, "activeIndex", 0);
        $f530cbe85455dc73$var$_defineProperty(this, "coordinateList", []);
        $f530cbe85455dc73$var$_defineProperty(this, "layout", 'horizontal');
    }
    return $f530cbe85455dc73$var$_createClass(AccessibilityManager, [
        {
            key: "setDetails",
            value: function setDetails(_ref) {
                var _ref2;
                var _ref$coordinateList = _ref.coordinateList, coordinateList = _ref$coordinateList === void 0 ? null : _ref$coordinateList, _ref$container = _ref.container, container = _ref$container === void 0 ? null : _ref$container, _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? null : _ref$layout, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? null : _ref$offset, _ref$mouseHandlerCall = _ref.mouseHandlerCallback, mouseHandlerCallback = _ref$mouseHandlerCall === void 0 ? null : _ref$mouseHandlerCall;
                this.coordinateList = (_ref2 = coordinateList !== null && coordinateList !== void 0 ? coordinateList : this.coordinateList) !== null && _ref2 !== void 0 ? _ref2 : [];
                this.container = container !== null && container !== void 0 ? container : this.container;
                this.layout = layout !== null && layout !== void 0 ? layout : this.layout;
                this.offset = offset !== null && offset !== void 0 ? offset : this.offset;
                this.mouseHandlerCallback = mouseHandlerCallback !== null && mouseHandlerCallback !== void 0 ? mouseHandlerCallback : this.mouseHandlerCallback;
                // Keep activeIndex in the bounds between 0 and the last coordinate index
                this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.spoofMouse();
            }
        },
        {
            key: "keyboardEvent",
            value: function keyboardEvent(e) {
                // The AccessibilityManager relies on the Tooltip component. When tooltips suddenly stop existing,
                // it can cause errors. We use this function to check. We don't want arrow keys to be processed
                // if there are no tooltips, since that will cause unexpected behavior of users.
                if (this.coordinateList.length === 0) return;
                switch(e.key){
                    case 'ArrowRight':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1);
                        this.spoofMouse();
                        break;
                    case 'ArrowLeft':
                        if (this.layout !== 'horizontal') return;
                        this.activeIndex = Math.max(this.activeIndex - 1, 0);
                        this.spoofMouse();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "setIndex",
            value: function setIndex(newIndex) {
                this.activeIndex = newIndex;
            }
        },
        {
            key: "spoofMouse",
            value: function spoofMouse() {
                var _window, _window2;
                if (this.layout !== 'horizontal') return;
                // This can happen when the tooltips suddenly stop existing as children of the component
                // That update doesn't otherwise fire events, so we have to double check here.
                if (this.coordinateList.length === 0) return;
                var _this$container$getBo = this.container.getBoundingClientRect(), x = _this$container$getBo.x, y = _this$container$getBo.y, height = _this$container$getBo.height;
                var coordinate = this.coordinateList[this.activeIndex].coordinate;
                var scrollOffsetX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
                var scrollOffsetY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
                var pageX = x + coordinate + scrollOffsetX;
                var pageY = y + this.offset.top + height / 2 + scrollOffsetY;
                this.mouseHandlerCallback({
                    pageX: pageX,
                    pageY: pageY
                });
            }
        }
    ]);
}();



function $ddc3bf6c5275b64e$export$33279f645a5831b7(domain, allowDataOverflow, axisType) {
    if (axisType === 'number' && allowDataOverflow === true && Array.isArray(domain)) {
        var domainStart = domain === null || domain === void 0 ? void 0 : domain[0];
        var domainEnd = domain === null || domain === void 0 ? void 0 : domain[1];
        /*
     * The `isNumber` check is needed because the user could also provide strings like "dataMin" via the domain props.
     * In such case, we have to compute the domain from the data.
     */ if (!!domainStart && !!domainEnd && (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(domainStart) && (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(domainEnd)) return true;
    }
    return false;
}




var $8T3gX = parcelRequire("8T3gX");

var $iVyaN = parcelRequire("iVyaN");

var $8T3gX = parcelRequire("8T3gX");




var $iVyaN = parcelRequire("iVyaN");



function $78b1108d5bdf31db$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $78b1108d5bdf31db$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $78b1108d5bdf31db$var$_typeof(o);
}
function $78b1108d5bdf31db$var$_extends() {
    $78b1108d5bdf31db$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $78b1108d5bdf31db$var$_extends.apply(this, arguments);
}
function $78b1108d5bdf31db$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $78b1108d5bdf31db$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $78b1108d5bdf31db$var$ownKeys(Object(t), !0).forEach(function(r) {
            $78b1108d5bdf31db$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $78b1108d5bdf31db$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $78b1108d5bdf31db$var$_defineProperty(obj, key, value) {
    key = $78b1108d5bdf31db$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $78b1108d5bdf31db$var$_toPropertyKey(t) {
    var i = $78b1108d5bdf31db$var$_toPrimitive(t, "string");
    return "symbol" == $78b1108d5bdf31db$var$_typeof(i) ? i : i + "";
}
function $78b1108d5bdf31db$var$_toPrimitive(t, r) {
    if ("object" != $78b1108d5bdf31db$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $78b1108d5bdf31db$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $78b1108d5bdf31db$var$CURVE_FACTORIES = {
    curveBasisClosed: (0, $40ccc67e29ee0e40$exports.curveBasisClosed),
    curveBasisOpen: (0, $40ccc67e29ee0e40$exports.curveBasisOpen),
    curveBasis: (0, $40ccc67e29ee0e40$exports.curveBasis),
    curveBumpX: (0, $40ccc67e29ee0e40$exports.curveBumpX),
    curveBumpY: (0, $40ccc67e29ee0e40$exports.curveBumpY),
    curveLinearClosed: (0, $40ccc67e29ee0e40$exports.curveLinearClosed),
    curveLinear: (0, $40ccc67e29ee0e40$exports.curveLinear),
    curveMonotoneX: (0, $40ccc67e29ee0e40$exports.curveMonotoneX),
    curveMonotoneY: (0, $40ccc67e29ee0e40$exports.curveMonotoneY),
    curveNatural: (0, $40ccc67e29ee0e40$exports.curveNatural),
    curveStep: (0, $40ccc67e29ee0e40$exports.curveStep),
    curveStepAfter: (0, $40ccc67e29ee0e40$exports.curveStepAfter),
    curveStepBefore: (0, $40ccc67e29ee0e40$exports.curveStepBefore)
};
var $78b1108d5bdf31db$var$defined = function defined(p) {
    return p.x === +p.x && p.y === +p.y;
};
var $78b1108d5bdf31db$var$getX = function getX(p) {
    return p.x;
};
var $78b1108d5bdf31db$var$getY = function getY(p) {
    return p.y;
};
var $78b1108d5bdf31db$var$getCurveFactory = function getCurveFactory(type, layout) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(type)) return type;
    var name = "curve".concat((0, (/*@__PURE__*/$parcel$interopDefault($7808c9375de28fec$exports)))(type));
    if ((name === 'curveMonotone' || name === 'curveBump') && layout) return $78b1108d5bdf31db$var$CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
    return $78b1108d5bdf31db$var$CURVE_FACTORIES[name] || (0, $40ccc67e29ee0e40$exports.curveLinear);
};
var $78b1108d5bdf31db$export$2aa3fd96c49a84a8 = function getPath(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? 'linear' : _ref$type, _ref$points = _ref.points, points = _ref$points === void 0 ? [] : _ref$points, baseLine = _ref.baseLine, layout = _ref.layout, _ref$connectNulls = _ref.connectNulls, connectNulls = _ref$connectNulls === void 0 ? false : _ref$connectNulls;
    var curveFactory = $78b1108d5bdf31db$var$getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter(function(entry) {
        return $78b1108d5bdf31db$var$defined(entry);
    }) : points;
    var lineFunction;
    if (Array.isArray(baseLine)) {
        var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
            return $78b1108d5bdf31db$var$defined(base);
        }) : baseLine;
        var areaPoints = formatPoints.map(function(entry, index) {
            return $78b1108d5bdf31db$var$_objectSpread($78b1108d5bdf31db$var$_objectSpread({}, entry), {}, {
                base: formatBaseLine[index]
            });
        });
        if (layout === 'vertical') lineFunction = (0, $40ccc67e29ee0e40$exports.area)().y($78b1108d5bdf31db$var$getY).x1($78b1108d5bdf31db$var$getX).x0(function(d) {
            return d.base.x;
        });
        else lineFunction = (0, $40ccc67e29ee0e40$exports.area)().x($78b1108d5bdf31db$var$getX).y1($78b1108d5bdf31db$var$getY).y0(function(d) {
            return d.base.y;
        });
        lineFunction.defined($78b1108d5bdf31db$var$defined).curve(curveFactory);
        return lineFunction(areaPoints);
    }
    if (layout === 'vertical' && (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $40ccc67e29ee0e40$exports.area)().y($78b1108d5bdf31db$var$getY).x1($78b1108d5bdf31db$var$getX).x0(baseLine);
    else if ((0, $ec351366ffe25ce6$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $40ccc67e29ee0e40$exports.area)().x($78b1108d5bdf31db$var$getX).y1($78b1108d5bdf31db$var$getY).y0(baseLine);
    else lineFunction = (0, $40ccc67e29ee0e40$exports.line)().x($78b1108d5bdf31db$var$getX).y($78b1108d5bdf31db$var$getY);
    lineFunction.defined($78b1108d5bdf31db$var$defined).curve(curveFactory);
    return lineFunction(formatPoints);
};
var $78b1108d5bdf31db$export$b0e83c3ef8d2db1 = function Curve(props) {
    var className = props.className, points = props.points, path = props.path, pathRef = props.pathRef;
    if ((!points || !points.length) && !path) return null;
    var realPath = points && points.length ? $78b1108d5bdf31db$export$2aa3fd96c49a84a8(props) : path;
    return /*#__PURE__*/ $8T3gX.createElement("path", $78b1108d5bdf31db$var$_extends({}, (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(props, false), (0, $a19170a4abc07995$export$7c4c290a4a9c1b1e)(props), {
        className: (0, $iVyaN.default)('recharts-curve', className),
        d: realPath,
        ref: pathRef
    }));
};



var $8T3gX = parcelRequire("8T3gX");

var $iVyaN = parcelRequire("iVyaN");


function $357c9299548dcdef$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $357c9299548dcdef$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $357c9299548dcdef$var$_typeof(o);
}
var $357c9299548dcdef$var$_excluded = [
    "x",
    "y",
    "top",
    "left",
    "width",
    "height",
    "className"
];
function $357c9299548dcdef$var$_extends() {
    $357c9299548dcdef$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $357c9299548dcdef$var$_extends.apply(this, arguments);
}
function $357c9299548dcdef$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $357c9299548dcdef$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $357c9299548dcdef$var$ownKeys(Object(t), !0).forEach(function(r) {
            $357c9299548dcdef$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $357c9299548dcdef$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $357c9299548dcdef$var$_defineProperty(obj, key, value) {
    key = $357c9299548dcdef$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $357c9299548dcdef$var$_toPropertyKey(t) {
    var i = $357c9299548dcdef$var$_toPrimitive(t, "string");
    return "symbol" == $357c9299548dcdef$var$_typeof(i) ? i : i + "";
}
function $357c9299548dcdef$var$_toPrimitive(t, r) {
    if ("object" != $357c9299548dcdef$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $357c9299548dcdef$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $357c9299548dcdef$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $357c9299548dcdef$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $357c9299548dcdef$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $357c9299548dcdef$var$getPath = function getPath(x, y, width, height, top, left) {
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var $357c9299548dcdef$export$3c877bb842c36952 = function Cross(_ref) {
    var _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y, _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, _ref$width = _ref.width, width = _ref$width === void 0 ? 0 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 0 : _ref$height, className = _ref.className, rest = $357c9299548dcdef$var$_objectWithoutProperties(_ref, $357c9299548dcdef$var$_excluded);
    var props = $357c9299548dcdef$var$_objectSpread({
        x: x,
        y: y,
        top: top,
        left: left,
        width: width,
        height: height
    }, rest);
    if (!(0, $ec351366ffe25ce6$export$7e4aa119212bc614)(x) || !(0, $ec351366ffe25ce6$export$7e4aa119212bc614)(y) || !(0, $ec351366ffe25ce6$export$7e4aa119212bc614)(width) || !(0, $ec351366ffe25ce6$export$7e4aa119212bc614)(height) || !(0, $ec351366ffe25ce6$export$7e4aa119212bc614)(top) || !(0, $ec351366ffe25ce6$export$7e4aa119212bc614)(left)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("path", $357c9299548dcdef$var$_extends({}, (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(props, true), {
        className: (0, $iVyaN.default)('recharts-cross', className),
        d: $357c9299548dcdef$var$getPath(x, y, width, height, top, left)
    }));
};


function $fab150bae3a17398$export$f84ec1ecc69a13c9(layout, activeCoordinate, offset, tooltipAxisBandSize) {
    var halfSize = tooltipAxisBandSize / 2;
    return {
        stroke: 'none',
        fill: '#ccc',
        x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
        y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
        width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
        height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
    };
}




function $732fcf87a8c67a95$export$ad661ef85a042a4f(activeCoordinate) {
    var cx = activeCoordinate.cx, cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
    var startPoint = (0, $8e3433adec38d948$export$5c9a959bb3fc7749)(cx, cy, radius, startAngle);
    var endPoint = (0, $8e3433adec38d948$export$5c9a959bb3fc7749)(cx, cy, radius, endAngle);
    return {
        points: [
            startPoint,
            endPoint
        ],
        cx: cx,
        cy: cy,
        radius: radius,
        startAngle: startAngle,
        endAngle: endAngle
    };
}





function $b34aa892f1a78dfd$export$56e1305620ce5745(layout, activeCoordinate, offset) {
    var x1, y1, x2, y2;
    if (layout === 'horizontal') {
        x1 = activeCoordinate.x;
        x2 = x1;
        y1 = offset.top;
        y2 = offset.top + offset.height;
    } else if (layout === 'vertical') {
        y1 = activeCoordinate.y;
        y2 = y1;
        x1 = offset.left;
        x2 = offset.left + offset.width;
    } else if (activeCoordinate.cx != null && activeCoordinate.cy != null) {
        if (layout === 'centric') {
            var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
            var innerPoint = (0, $8e3433adec38d948$export$5c9a959bb3fc7749)(cx, cy, innerRadius, angle);
            var outerPoint = (0, $8e3433adec38d948$export$5c9a959bb3fc7749)(cx, cy, outerRadius, angle);
            x1 = innerPoint.x;
            y1 = innerPoint.y;
            x2 = outerPoint.x;
            y2 = outerPoint.y;
        } else return (0, $732fcf87a8c67a95$export$ad661ef85a042a4f)(activeCoordinate);
    }
    return [
        {
            x: x1,
            y: y1
        },
        {
            x: x2,
            y: y2
        }
    ];
}



function $a0b4d05e8561e67e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a0b4d05e8561e67e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a0b4d05e8561e67e$var$_typeof(o);
}
function $a0b4d05e8561e67e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a0b4d05e8561e67e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a0b4d05e8561e67e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a0b4d05e8561e67e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a0b4d05e8561e67e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a0b4d05e8561e67e$var$_defineProperty(obj, key, value) {
    key = $a0b4d05e8561e67e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a0b4d05e8561e67e$var$_toPropertyKey(t) {
    var i = $a0b4d05e8561e67e$var$_toPrimitive(t, "string");
    return "symbol" == $a0b4d05e8561e67e$var$_typeof(i) ? i : i + "";
}
function $a0b4d05e8561e67e$var$_toPrimitive(t, r) {
    if ("object" != $a0b4d05e8561e67e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a0b4d05e8561e67e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $a0b4d05e8561e67e$export$b6a79797ad180576(props) {
    var _element$props$cursor, _defaultProps;
    var element = props.element, tooltipEventType = props.tooltipEventType, isActive = props.isActive, activeCoordinate = props.activeCoordinate, activePayload = props.activePayload, offset = props.offset, activeTooltipIndex = props.activeTooltipIndex, tooltipAxisBandSize = props.tooltipAxisBandSize, layout = props.layout, chartName = props.chartName;
    var elementPropsCursor = (_element$props$cursor = element.props.cursor) !== null && _element$props$cursor !== void 0 ? _element$props$cursor : (_defaultProps = element.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps.cursor;
    if (!element || !elementPropsCursor || !isActive || !activeCoordinate || chartName !== 'ScatterChart' && tooltipEventType !== 'axis') return null;
    var restProps;
    var cursorComp = (0, $78b1108d5bdf31db$export$b0e83c3ef8d2db1);
    if (chartName === 'ScatterChart') {
        restProps = activeCoordinate;
        cursorComp = (0, $357c9299548dcdef$export$3c877bb842c36952);
    } else if (chartName === 'BarChart') {
        restProps = (0, $fab150bae3a17398$export$f84ec1ecc69a13c9)(layout, activeCoordinate, offset, tooltipAxisBandSize);
        cursorComp = (0, $0ab2d840c2839083$export$4617fb02663045ef);
    } else if (layout === 'radial') {
        var _getRadialCursorPoint = (0, $732fcf87a8c67a95$export$ad661ef85a042a4f)(activeCoordinate), cx = _getRadialCursorPoint.cx, cy = _getRadialCursorPoint.cy, radius = _getRadialCursorPoint.radius, startAngle = _getRadialCursorPoint.startAngle, endAngle = _getRadialCursorPoint.endAngle;
        restProps = {
            cx: cx,
            cy: cy,
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: radius,
            outerRadius: radius
        };
        cursorComp = (0, $fd3fe470e36b9343$export$e98c2c7eb2b14f45);
    } else {
        restProps = {
            points: (0, $b34aa892f1a78dfd$export$56e1305620ce5745)(layout, activeCoordinate, offset)
        };
        cursorComp = (0, $78b1108d5bdf31db$export$b0e83c3ef8d2db1);
    }
    var cursorProps = $a0b4d05e8561e67e$var$_objectSpread($a0b4d05e8561e67e$var$_objectSpread($a0b4d05e8561e67e$var$_objectSpread($a0b4d05e8561e67e$var$_objectSpread({
        stroke: '#ccc',
        pointerEvents: 'none'
    }, offset), restProps), (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(elementPropsCursor, false)), {}, {
        payload: activePayload,
        payloadIndex: activeTooltipIndex,
        className: (0, $iVyaN.default)('recharts-tooltip-cursor', elementPropsCursor.className)
    });
    return /*#__PURE__*/ (0, $8T3gX.isValidElement)(elementPropsCursor) ? /*#__PURE__*/ (0, $8T3gX.cloneElement)(elementPropsCursor, cursorProps) : /*#__PURE__*/ (0, $8T3gX.createElement)(cursorComp, cursorProps);
}



var $c6b16af6ccfd04cd$var$_excluded = [
    "item"
], $c6b16af6ccfd04cd$var$_excluded2 = [
    "children",
    "className",
    "width",
    "height",
    "style",
    "compact",
    "title",
    "desc"
];
function $c6b16af6ccfd04cd$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c6b16af6ccfd04cd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c6b16af6ccfd04cd$var$_typeof(o);
}
function $c6b16af6ccfd04cd$var$_extends() {
    $c6b16af6ccfd04cd$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c6b16af6ccfd04cd$var$_extends.apply(this, arguments);
}
function $c6b16af6ccfd04cd$var$_slicedToArray(arr, i) {
    return $c6b16af6ccfd04cd$var$_arrayWithHoles(arr) || $c6b16af6ccfd04cd$var$_iterableToArrayLimit(arr, i) || $c6b16af6ccfd04cd$var$_unsupportedIterableToArray(arr, i) || $c6b16af6ccfd04cd$var$_nonIterableRest();
}
function $c6b16af6ccfd04cd$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c6b16af6ccfd04cd$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $c6b16af6ccfd04cd$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c6b16af6ccfd04cd$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c6b16af6ccfd04cd$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c6b16af6ccfd04cd$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $c6b16af6ccfd04cd$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c6b16af6ccfd04cd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c6b16af6ccfd04cd$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c6b16af6ccfd04cd$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c6b16af6ccfd04cd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c6b16af6ccfd04cd$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c6b16af6ccfd04cd$var$_callSuper(t, o, e) {
    return o = $c6b16af6ccfd04cd$var$_getPrototypeOf(o), $c6b16af6ccfd04cd$var$_possibleConstructorReturn(t, $c6b16af6ccfd04cd$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $c6b16af6ccfd04cd$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $c6b16af6ccfd04cd$var$_possibleConstructorReturn(self, call) {
    if (call && ($c6b16af6ccfd04cd$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $c6b16af6ccfd04cd$var$_assertThisInitialized(self);
}
function $c6b16af6ccfd04cd$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c6b16af6ccfd04cd$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c6b16af6ccfd04cd$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $c6b16af6ccfd04cd$var$_getPrototypeOf(o) {
    $c6b16af6ccfd04cd$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c6b16af6ccfd04cd$var$_getPrototypeOf(o);
}
function $c6b16af6ccfd04cd$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $c6b16af6ccfd04cd$var$_setPrototypeOf(subClass, superClass);
}
function $c6b16af6ccfd04cd$var$_setPrototypeOf(o, p) {
    $c6b16af6ccfd04cd$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c6b16af6ccfd04cd$var$_setPrototypeOf(o, p);
}
function $c6b16af6ccfd04cd$var$_toConsumableArray(arr) {
    return $c6b16af6ccfd04cd$var$_arrayWithoutHoles(arr) || $c6b16af6ccfd04cd$var$_iterableToArray(arr) || $c6b16af6ccfd04cd$var$_unsupportedIterableToArray(arr) || $c6b16af6ccfd04cd$var$_nonIterableSpread();
}
function $c6b16af6ccfd04cd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c6b16af6ccfd04cd$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c6b16af6ccfd04cd$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c6b16af6ccfd04cd$var$_arrayLikeToArray(o, minLen);
}
function $c6b16af6ccfd04cd$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $c6b16af6ccfd04cd$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $c6b16af6ccfd04cd$var$_arrayLikeToArray(arr);
}
function $c6b16af6ccfd04cd$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c6b16af6ccfd04cd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c6b16af6ccfd04cd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c6b16af6ccfd04cd$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c6b16af6ccfd04cd$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c6b16af6ccfd04cd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c6b16af6ccfd04cd$var$_defineProperty(obj, key, value) {
    key = $c6b16af6ccfd04cd$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c6b16af6ccfd04cd$var$_toPropertyKey(t) {
    var i = $c6b16af6ccfd04cd$var$_toPrimitive(t, "string");
    return "symbol" == $c6b16af6ccfd04cd$var$_typeof(i) ? i : i + "";
}
function $c6b16af6ccfd04cd$var$_toPrimitive(t, r) {
    if ("object" != $c6b16af6ccfd04cd$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c6b16af6ccfd04cd$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $c6b16af6ccfd04cd$var$ORIENT_MAP = {
    xAxis: [
        'bottom',
        'top'
    ],
    yAxis: [
        'left',
        'right'
    ]
};
var $c6b16af6ccfd04cd$var$FULL_WIDTH_AND_HEIGHT = {
    width: '100%',
    height: '100%'
};
var $c6b16af6ccfd04cd$var$originCoordinate = {
    x: 0,
    y: 0
};
/**
 * This function exists as a temporary workaround.
 *
 * Why? generateCategoricalChart does not render `{children}` directly;
 * instead it passes them through `renderByOrder` function which reads their handlers.
 *
 * So, this is a handler that does nothing.
 * Once we get rid of `renderByOrder` and switch to JSX only, we can get rid of this handler too.
 *
 * @param {JSX} element as is in JSX
 * @returns {JSX} the same element
 */ function $c6b16af6ccfd04cd$var$renderAsIs(element) {
    return element;
}
var $c6b16af6ccfd04cd$var$calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
    if (layout === 'horizontal') return rangeObj.x;
    if (layout === 'vertical') return rangeObj.y;
    if (layout === 'centric') return rangeObj.angle;
    return rangeObj.radius;
};
var $c6b16af6ccfd04cd$var$getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
    var entry = tooltipTicks.find(function(tick) {
        return tick && tick.index === activeIndex;
    });
    if (entry) {
        if (layout === 'horizontal') return {
            x: entry.coordinate,
            y: rangeObj.y
        };
        if (layout === 'vertical') return {
            x: rangeObj.x,
            y: entry.coordinate
        };
        if (layout === 'centric') {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, rangeObj), (0, $8e3433adec38d948$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var angle = rangeObj.angle;
        return $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, rangeObj), (0, $8e3433adec38d948$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return $c6b16af6ccfd04cd$var$originCoordinate;
};
var $c6b16af6ccfd04cd$var$getDisplayedData = function getDisplayedData(data, _ref) {
    var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    var itemsData = (graphicalItems !== null && graphicalItems !== void 0 ? graphicalItems : []).reduce(function(result, child) {
        var itemData = child.props.data;
        if (itemData && itemData.length) return [].concat($c6b16af6ccfd04cd$var$_toConsumableArray(result), $c6b16af6ccfd04cd$var$_toConsumableArray(itemData));
        return result;
    }, []);
    if (itemsData.length > 0) return itemsData;
    if (data && data.length && (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(dataStartIndex) && (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(dataEndIndex)) return data.slice(dataStartIndex, dataEndIndex + 1);
    return [];
};
function $c6b16af6ccfd04cd$var$getDefaultDomainByAxisType(axisType) {
    return axisType === 'number' ? [
        0,
        'auto'
    ] : undefined;
}
/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */ var $c6b16af6ccfd04cd$var$getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
    var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis;
    var displayedData = $c6b16af6ccfd04cd$var$getDisplayedData(chartData, state);
    if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) return null;
    // get data by activeIndex when the axis don't allow duplicated category
    return graphicalItems.reduce(function(result, child) {
        var _child$props$data;
        /**
     * Fixes: https://github.com/recharts/recharts/issues/3669
     * Defaulting to chartData below to fix an edge case where the tooltip does not include data from all charts
     * when a separate dataset is passed to chart prop data and specified on Line/Area/etc prop data
     */ var data = (_child$props$data = child.props.data) !== null && _child$props$data !== void 0 ? _child$props$data : chartData;
        if (data && state.dataStartIndex + state.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
        // The data is sliced only when the active index is within the start/end index range.
        state.dataEndIndex - state.dataStartIndex >= activeIndex) data = data.slice(state.dataStartIndex, state.dataEndIndex + 1);
        var payload;
        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            var entries = data === undefined ? displayedData : data;
            payload = (0, $ec351366ffe25ce6$export$66950d3869f5cc67)(entries, tooltipAxis.dataKey, activeLabel);
        } else payload = data && data[activeIndex] || displayedData[activeIndex];
        if (!payload) return result;
        return [].concat($c6b16af6ccfd04cd$var$_toConsumableArray(result), [
            (0, $bc60c84815913bd8$export$a4ea3faa19bc2d90)(child, payload)
        ]);
    }, []);
};
/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */ var $c6b16af6ccfd04cd$var$getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
    var rangeData = rangeObj || {
        x: state.chartX,
        y: state.chartY
    };
    var pos = $c6b16af6ccfd04cd$var$calculateTooltipPos(rangeData, layout);
    var ticks = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks;
    var activeIndex = (0, $bc60c84815913bd8$export$3071d39cc844078e)(pos, ticks, tooltipTicks, axis);
    if (activeIndex >= 0 && tooltipTicks) {
        var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
        var activePayload = $c6b16af6ccfd04cd$var$getTooltipContent(state, chartData, activeIndex, activeLabel);
        var activeCoordinate = $c6b16af6ccfd04cd$var$getActiveCoordinate(layout, ticks, activeIndex, rangeData);
        return {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
        };
    }
    return null;
};
var $c6b16af6ccfd04cd$export$7a36da8ad5d1965e = function getAxisMapByAxes(props, _ref2) {
    var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    var layout = props.layout, children = props.children, stackOffset = props.stackOffset;
    var isCategorical = (0, $bc60c84815913bd8$export$9fc1baaa6c6368b)(layout, axisType);
    // Eliminate duplicated axes
    return axes.reduce(function(result, child) {
        var _childProps$domain2;
        var childProps = child.type.defaultProps !== undefined ? $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, child.type.defaultProps), child.props) : child.props;
        var type = childProps.type, dataKey = childProps.dataKey, allowDataOverflow = childProps.allowDataOverflow, allowDuplicatedCategory = childProps.allowDuplicatedCategory, scale = childProps.scale, ticks = childProps.ticks, includeHidden = childProps.includeHidden;
        var axisId = childProps[axisIdKey];
        if (result[axisId]) return result;
        var displayedData = $c6b16af6ccfd04cd$var$getDisplayedData(props.data, {
            graphicalItems: graphicalItems.filter(function(item) {
                var _defaultProps;
                var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps = item.type.defaultProps) === null || _defaultProps === void 0 ? void 0 : _defaultProps[axisIdKey];
                return itemAxisId === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        var domain, duplicateDomain, categoricalDomain;
        /*
     * This is a hack to short-circuit the domain creation here to enhance performance.
     * Usually, the data is used to determine the domain, but when the user specifies
     * a domain upfront (via props), there is no need to calculate the domain start and end,
     * which is very expensive for a larger amount of data.
     * The only thing that would prohibit short-circuiting is when the user doesn't allow data overflow,
     * because the axis is supposed to ignore the specified domain that way.
     */ if ((0, $ddc3bf6c5275b64e$export$33279f645a5831b7)(childProps.domain, allowDataOverflow, type)) {
            domain = (0, $bc60c84815913bd8$export$a0bc8660980558a0)(childProps.domain, null, allowDataOverflow);
            /* The chart can be categorical and have the domain specified in numbers
       * we still need to calculate the categorical domain
       * TODO: refactor this more
       */ if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, $bc60c84815913bd8$export$6a1e7873444c95a7)(displayedData, dataKey, 'category');
        }
        // if the domain is defaulted we need this for `originalDomain` as well
        var defaultDomain = $c6b16af6ccfd04cd$var$getDefaultDomainByAxisType(type);
        // we didn't create the domain from user's props above, so we need to calculate it
        if (!domain || domain.length === 0) {
            var _childProps$domain;
            var childDomain = (_childProps$domain = childProps.domain) !== null && _childProps$domain !== void 0 ? _childProps$domain : defaultDomain;
            if (dataKey) {
                // has dataKey in <Axis />
                domain = (0, $bc60c84815913bd8$export$6a1e7873444c95a7)(displayedData, dataKey, type);
                if (type === 'category' && isCategorical) {
                    // the field type is category data and this axis is categorical axis
                    var duplicate = (0, $ec351366ffe25ce6$export$732baf6a98f122)(domain);
                    if (allowDuplicatedCategory && duplicate) {
                        duplicateDomain = domain;
                        // When category axis has duplicated text, serial numbers are used to generate scale
                        domain = (0, (/*@__PURE__*/$parcel$interopDefault($a2e6c83a615b2213$exports)))(0, len);
                    } else if (!allowDuplicatedCategory) // remove duplicated category
                    domain = (0, $bc60c84815913bd8$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat($c6b16af6ccfd04cd$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                } else if (type === 'category') {
                    // the field type is category data and this axis is numerical axis
                    if (!allowDuplicatedCategory) domain = (0, $bc60c84815913bd8$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 || entry === '' || (0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(entry) ? finalDomain : [].concat($c6b16af6ccfd04cd$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                    else // eliminate undefined or null or empty string
                    domain = domain.filter(function(entry) {
                        return entry !== '' && !(0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(entry);
                    });
                } else if (type === 'number') {
                    // the field type is numerical
                    var errorBarsDomain = (0, $bc60c84815913bd8$export$2266342e22c737e8)(displayedData, graphicalItems.filter(function(item) {
                        var _defaultProps2, _defaultProps3;
                        var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps2 = item.type.defaultProps) === null || _defaultProps2 === void 0 ? void 0 : _defaultProps2[axisIdKey];
                        var itemHide = 'hide' in item.props ? item.props.hide : (_defaultProps3 = item.type.defaultProps) === null || _defaultProps3 === void 0 ? void 0 : _defaultProps3.hide;
                        return itemAxisId === axisId && (includeHidden || !itemHide);
                    }), dataKey, axisType, layout);
                    if (errorBarsDomain) domain = errorBarsDomain;
                }
                if (isCategorical && (type === 'number' || scale !== 'auto')) categoricalDomain = (0, $bc60c84815913bd8$export$6a1e7873444c95a7)(displayedData, dataKey, 'category');
            } else if (isCategorical) // the axis is a categorical axis
            domain = (0, (/*@__PURE__*/$parcel$interopDefault($a2e6c83a615b2213$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
            domain = stackOffset === 'expand' ? [
                0,
                1
            ] : (0, $bc60c84815913bd8$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            else domain = (0, $bc60c84815913bd8$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : item.type.defaultProps[axisIdKey];
                var itemHide = 'hide' in item.props ? item.props.hide : item.type.defaultProps.hide;
                return itemAxisId === axisId && (includeHidden || !itemHide);
            }), type, layout, true);
            if (type === 'number') {
                // To detect wether there is any reference lines whose props alwaysShow is true
                domain = (0, $ba11ad50196cc280$export$62ecf5c04b491381)(children, domain, axisId, axisType, ticks);
                if (childDomain) domain = (0, $bc60c84815913bd8$export$a0bc8660980558a0)(childDomain, domain, allowDataOverflow);
            } else if (type === 'category' && childDomain) {
                var axisDomain = childDomain;
                var isDomainValid = domain.every(function(entry) {
                    return axisDomain.indexOf(entry) >= 0;
                });
                if (isDomainValid) domain = axisDomain;
            }
        }
        return $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, result), {}, $c6b16af6ccfd04cd$var$_defineProperty({}, axisId, $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, childProps), {}, {
            axisType: axisType,
            domain: domain,
            categoricalDomain: categoricalDomain,
            duplicateDomain: duplicateDomain,
            originalDomain: (_childProps$domain2 = childProps.domain) !== null && _childProps$domain2 !== void 0 ? _childProps$domain2 : defaultDomain,
            isCategorical: isCategorical,
            layout: layout
        })));
    }, {});
};
/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */ var $c6b16af6ccfd04cd$var$getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
    var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
    var layout = props.layout, children = props.children;
    var displayedData = $c6b16af6ccfd04cd$var$getDisplayedData(props.data, {
        graphicalItems: graphicalItems,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    var len = displayedData.length;
    var isCategorical = (0, $bc60c84815913bd8$export$9fc1baaa6c6368b)(layout, axisType);
    var index = -1;
    // The default type of x-axis is category axis,
    // The default contents of x-axis is the serial numbers of data
    // The default type of y-axis is number axis
    // The default contents of y-axis is the domain of data
    return graphicalItems.reduce(function(result, child) {
        var childProps = child.type.defaultProps !== undefined ? $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, child.type.defaultProps), child.props) : child.props;
        var axisId = childProps[axisIdKey];
        var originalDomain = $c6b16af6ccfd04cd$var$getDefaultDomainByAxisType('number');
        if (!result[axisId]) {
            index++;
            var domain;
            if (isCategorical) domain = (0, (/*@__PURE__*/$parcel$interopDefault($a2e6c83a615b2213$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
                domain = (0, $bc60c84815913bd8$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
                domain = (0, $ba11ad50196cc280$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            } else {
                domain = (0, $bc60c84815913bd8$export$a0bc8660980558a0)(originalDomain, (0, $bc60c84815913bd8$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                    var _defaultProps4, _defaultProps5;
                    var itemAxisId = axisIdKey in item.props ? item.props[axisIdKey] : (_defaultProps4 = item.type.defaultProps) === null || _defaultProps4 === void 0 ? void 0 : _defaultProps4[axisIdKey];
                    var itemHide = 'hide' in item.props ? item.props.hide : (_defaultProps5 = item.type.defaultProps) === null || _defaultProps5 === void 0 ? void 0 : _defaultProps5.hide;
                    return itemAxisId === axisId && !itemHide;
                }), 'number', layout), Axis.defaultProps.allowDataOverflow);
                domain = (0, $ba11ad50196cc280$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            }
            return $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, result), {}, $c6b16af6ccfd04cd$var$_defineProperty({}, axisId, $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({
                axisType: axisType
            }, Axis.defaultProps), {}, {
                hide: true,
                orientation: (0, (/*@__PURE__*/$parcel$interopDefault($eb02300d30d6bdcb$exports)))($c6b16af6ccfd04cd$var$ORIENT_MAP, "".concat(axisType, ".").concat(index % 2), null),
                domain: domain,
                originalDomain: originalDomain,
                isCategorical: isCategorical,
                layout: layout
            })));
        }
        return result;
    }, {});
};
/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {React.ComponentType}  [AxisComp]      Axis Component
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */ var $c6b16af6ccfd04cd$var$getAxisMap = function getAxisMap(props, _ref4) {
    var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? 'xAxis' : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex;
    var children = props.children;
    var axisIdKey = "".concat(axisType, "Id");
    // Get all the instance of Axis
    var axes = (0, $10636f1b3e62ab88$export$fdd5e64c0e8495bb)(children, AxisComp);
    var axisMap = {};
    if (axes && axes.length) axisMap = $c6b16af6ccfd04cd$export$7a36da8ad5d1965e(props, {
        axes: axes,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    else if (graphicalItems && graphicalItems.length) axisMap = $c6b16af6ccfd04cd$var$getAxisMapByItems(props, {
        Axis: AxisComp,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    return axisMap;
};
var $c6b16af6ccfd04cd$var$tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
    var axis = (0, $ec351366ffe25ce6$export$b88993f0aa0bf776)(axisMap);
    var tooltipTicks = (0, $bc60c84815913bd8$export$c829ee42daf7f66d)(axis, false, true);
    return {
        tooltipTicks: tooltipTicks,
        orderedTooltipTicks: (0, (/*@__PURE__*/$parcel$interopDefault($e2540731f2bf6197$exports)))(tooltipTicks, function(o) {
            return o.coordinate;
        }),
        tooltipAxis: axis,
        tooltipAxisBandSize: (0, $bc60c84815913bd8$export$212ec45c42fe68a7)(axis, tooltipTicks)
    };
};
var $c6b16af6ccfd04cd$export$e5182fb58612e577 = function createDefaultState(props) {
    var children = props.children, defaultShowTooltip = props.defaultShowTooltip;
    var brushItem = (0, $10636f1b3e62ab88$export$64c61536a2b72e0f)(children, (0, $303bff326b387541$export$59bc2e3533b384a0));
    var startIndex = 0;
    var endIndex = 0;
    if (props.data && props.data.length !== 0) endIndex = props.data.length - 1;
    if (brushItem && brushItem.props) {
        if (brushItem.props.startIndex >= 0) startIndex = brushItem.props.startIndex;
        if (brushItem.props.endIndex >= 0) endIndex = brushItem.props.endIndex;
    }
    return {
        chartX: 0,
        chartY: 0,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex,
        activeTooltipIndex: -1,
        isTooltipActive: Boolean(defaultShowTooltip)
    };
};
var $c6b16af6ccfd04cd$var$hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) return false;
    return graphicalItems.some(function(item) {
        var name = (0, $10636f1b3e62ab88$export$be63e0664592e141)(item && item.type);
        return name && name.indexOf('Bar') >= 0;
    });
};
var $c6b16af6ccfd04cd$var$getAxisNameByLayout = function getAxisNameByLayout(layout) {
    if (layout === 'horizontal') return {
        numericAxisName: 'yAxis',
        cateAxisName: 'xAxis'
    };
    if (layout === 'vertical') return {
        numericAxisName: 'xAxis',
        cateAxisName: 'yAxis'
    };
    if (layout === 'centric') return {
        numericAxisName: 'radiusAxis',
        cateAxisName: 'angleAxis'
    };
    return {
        numericAxisName: 'angleAxis',
        cateAxisName: 'radiusAxis'
    };
};
/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} params.props          Latest props
 * @param  {Array}  params.graphicalItems The instances of item
 * @param  {Object} params.xAxisMap       The configuration of x-axis
 * @param  {Object} params.yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox        The boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */ var $c6b16af6ccfd04cd$var$calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
    var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
    var width = props.width, height = props.height, children = props.children;
    var margin = props.margin || {};
    var brushItem = (0, $10636f1b3e62ab88$export$64c61536a2b72e0f)(children, (0, $303bff326b387541$export$59bc2e3533b384a0));
    var legendItem = (0, $10636f1b3e62ab88$export$64c61536a2b72e0f)(children, (0, $a67bff487a060557$export$ed247974535929c7));
    var offsetH = Object.keys(yAxisMap).reduce(function(result, id) {
        var entry = yAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, result), {}, $c6b16af6ccfd04cd$var$_defineProperty({}, orientation, result[orientation] + entry.width));
        return result;
    }, {
        left: margin.left || 0,
        right: margin.right || 0
    });
    var offsetV = Object.keys(xAxisMap).reduce(function(result, id) {
        var entry = xAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, result), {}, $c6b16af6ccfd04cd$var$_defineProperty({}, orientation, (0, (/*@__PURE__*/$parcel$interopDefault($eb02300d30d6bdcb$exports)))(result, "".concat(orientation)) + entry.height));
        return result;
    }, {
        top: margin.top || 0,
        bottom: margin.bottom || 0
    });
    var offset = $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    if (brushItem) offset.bottom += brushItem.props.height || (0, $303bff326b387541$export$59bc2e3533b384a0).defaultProps.height;
    if (legendItem && prevLegendBBox) // @ts-expect-error margin is optional in props but required in appendOffsetOfLegend
    offset = (0, $bc60c84815913bd8$export$3a657a8c9f789617)(offset, graphicalItems, props, prevLegendBBox);
    var offsetWidth = width - offset.left - offset.right;
    var offsetHeight = height - offset.top - offset.bottom;
    return $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        // never return negative values for height and width
        width: Math.max(offsetWidth, 0),
        height: Math.max(offsetHeight, 0)
    });
};
// Determine the size of the axis, used for calculation of relative bar sizes
var $c6b16af6ccfd04cd$var$getCartesianAxisSize = function getCartesianAxisSize(axisObj, axisName) {
    if (axisName === 'xAxis') return axisObj[axisName].width;
    if (axisName === 'yAxis') return axisObj[axisName].height;
    // This is only supported for Bar charts (i.e. charts with cartesian axes), so we should never get here
    return undefined;
};
var $c6b16af6ccfd04cd$export$77871aede60e6838 = function generateCategoricalChart(_ref6) {
    var chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? 'axis' : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? [
        'axis'
    ] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap = _ref6.formatAxisMap, defaultProps = _ref6.defaultProps;
    var getFormatItems = function getFormatItems(props, currentState) {
        var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize, layout = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize;
        var _getAxisNameByLayout = $c6b16af6ccfd04cd$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName;
        var hasBar = $c6b16af6ccfd04cd$var$hasGraphicalBarItem(graphicalItems);
        var formattedItems = [];
        graphicalItems.forEach(function(item, index) {
            var displayedData = $c6b16af6ccfd04cd$var$getDisplayedData(props.data, {
                graphicalItems: [
                    item
                ],
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            });
            var itemProps = item.type.defaultProps !== undefined ? $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
            var dataKey = itemProps.dataKey, childMaxBarSize = itemProps.maxBarSize;
            // axisId of the numerical axis
            var numericAxisId = itemProps["".concat(numericAxisName, "Id")];
            // axisId of the categorical axis
            var cateAxisId = itemProps["".concat(cateAxisName, "Id")];
            var axisObjInitialValue = {};
            var axisObj = axisComponents.reduce(function(result, entry) {
                var _item$type$displayNam, _item$type;
                // map of axisId to axis for a specific axis type
                var axisMap = currentState["".concat(entry.axisType, "Map")];
                // axisId of axis we are currently computing
                var id = itemProps["".concat(entry.axisType, "Id")];
                /**
         * tell the user in dev mode that their configuration is incorrect if we cannot find a match between
         * axisId on the chart and axisId on the axis. zAxis does not get passed in the map for ComposedChart,
         * leave it out of the check for now.
         */ !(axisMap && axisMap[id] || entry.axisType === 'zAxis') && (0, $668d778f3ad25eac$export$2e2bcd8739ae039)(false, "Specifying a(n) ".concat(entry.axisType, "Id requires a corresponding ").concat(entry.axisType, "Id on the targeted graphical component ").concat((_item$type$displayNam = item === null || item === void 0 || (_item$type = item.type) === null || _item$type === void 0 ? void 0 : _item$type.displayName) !== null && _item$type$displayNam !== void 0 ? _item$type$displayNam : ''));
                // the axis we are currently formatting
                var axis = axisMap[id];
                return $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, result), {}, $c6b16af6ccfd04cd$var$_defineProperty($c6b16af6ccfd04cd$var$_defineProperty({}, entry.axisType, axis), "".concat(entry.axisType, "Ticks"), (0, $bc60c84815913bd8$export$c829ee42daf7f66d)(axis)));
            }, axisObjInitialValue);
            var cateAxis = axisObj[cateAxisName];
            var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
            var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, $bc60c84815913bd8$export$a17bf3d98457878c)(item, stackGroups[numericAxisId].stackGroups);
            var itemIsBar = (0, $10636f1b3e62ab88$export$be63e0664592e141)(item.type).indexOf('Bar') >= 0;
            var bandSize = (0, $bc60c84815913bd8$export$212ec45c42fe68a7)(cateAxis, cateTicks);
            var barPosition = [];
            var sizeList = hasBar && (0, $bc60c84815913bd8$export$570d306bee26c748)({
                barSize: barSize,
                stackGroups: stackGroups,
                totalSize: $c6b16af6ccfd04cd$var$getCartesianAxisSize(axisObj, cateAxisName)
            });
            if (itemIsBar) {
                var _ref7, _getBandSizeOfAxis;
                // If it is bar, calculate the position of bar
                var maxBarSize = (0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
                var barBandSize = (_ref7 = (_getBandSizeOfAxis = (0, $bc60c84815913bd8$export$212ec45c42fe68a7)(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
                barPosition = (0, $bc60c84815913bd8$export$d36834ecd87f906b)({
                    barGap: barGap,
                    barCategoryGap: barCategoryGap,
                    bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
                    sizeList: sizeList[cateAxisId],
                    maxBarSize: maxBarSize
                });
                if (barBandSize !== bandSize) barPosition = barPosition.map(function(pos) {
                    return $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, pos), {}, {
                        position: $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, pos.position), {}, {
                            offset: pos.position.offset - barBandSize / 2
                        })
                    });
                });
            }
            // @ts-expect-error we should stop reading data from ReactElements
            var composedFn = item && item.type && item.type.getComposedData;
            if (composedFn) formattedItems.push({
                props: $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, composedFn($c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, axisObj), {}, {
                    displayedData: displayedData,
                    props: props,
                    dataKey: dataKey,
                    item: item,
                    bandSize: bandSize,
                    barPosition: barPosition,
                    offset: offset,
                    stackedData: stackedData,
                    layout: layout,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }))), {}, $c6b16af6ccfd04cd$var$_defineProperty($c6b16af6ccfd04cd$var$_defineProperty($c6b16af6ccfd04cd$var$_defineProperty({
                    key: item.key || "item-".concat(index)
                }, numericAxisName, axisObj[numericAxisName]), cateAxisName, axisObj[cateAxisName]), "animationId", updateId)),
                childIndex: (0, $10636f1b3e62ab88$export$857ca101f741953)(item, props.children),
                item: item
            });
        });
        return formattedItems;
    };
    /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */ var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
        var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
        if (!(0, $10636f1b3e62ab88$export$5301de6bfd3cfa2a)({
            props: props
        })) return null;
        var children = props.children, layout = props.layout, stackOffset = props.stackOffset, data = props.data, reverseStackOrder = props.reverseStackOrder;
        var _getAxisNameByLayout2 = $c6b16af6ccfd04cd$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName;
        var graphicalItems = (0, $10636f1b3e62ab88$export$fdd5e64c0e8495bb)(children, GraphicalChild);
        var stackGroups = (0, $bc60c84815913bd8$export$9af3ba56474b9601)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function(result, entry) {
            var name = "".concat(entry.axisType, "Map");
            return $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, result), {}, $c6b16af6ccfd04cd$var$_defineProperty({}, name, $c6b16af6ccfd04cd$var$getAxisMap(props, $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, entry), {}, {
                graphicalItems: graphicalItems,
                stackGroups: entry.axisType === numericAxisName && stackGroups,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }))));
        }, {});
        var offset = $c6b16af6ccfd04cd$var$calculateOffset($c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, axisObj), {}, {
            props: props,
            graphicalItems: graphicalItems
        }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
        Object.keys(axisObj).forEach(function(key) {
            axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
        });
        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
        var ticksObj = $c6b16af6ccfd04cd$var$tooltipTicksGenerator(cateAxisMap);
        var formattedGraphicalItems = getFormatItems(props, $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, axisObj), {}, {
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId,
            graphicalItems: graphicalItems,
            stackGroups: stackGroups,
            offset: offset
        }));
        return $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({
            formattedGraphicalItems: formattedGraphicalItems,
            graphicalItems: graphicalItems,
            offset: offset,
            stackGroups: stackGroups
        }, ticksObj), axisObj);
    };
    var CategoricalChartWrapper = /*#__PURE__*/ function(_Component) {
        function CategoricalChartWrapper(_props) {
            var _props$id, _props$throttleDelay;
            var _this;
            $c6b16af6ccfd04cd$var$_classCallCheck(this, CategoricalChartWrapper);
            _this = $c6b16af6ccfd04cd$var$_callSuper(this, CategoricalChartWrapper, [
                _props
            ]);
            $c6b16af6ccfd04cd$var$_defineProperty(_this, "eventEmitterSymbol", Symbol('rechartsEventEmitter'));
            $c6b16af6ccfd04cd$var$_defineProperty(_this, "accessibilityManager", new (0, $f530cbe85455dc73$export$a2c2de1efa8671eb)());
            $c6b16af6ccfd04cd$var$_defineProperty(_this, "handleLegendBBoxUpdate", function(box) {
                if (box) {
                    var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
                    _this.setState($c6b16af6ccfd04cd$var$_objectSpread({
                        legendBBox: box
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: _this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, _this.state), {}, {
                        legendBBox: box
                    }))));
                }
            });
            $c6b16af6ccfd04cd$var$_defineProperty(_this, "handleReceiveSyncEvent", function(cId, data, emitter) {
                if (_this.props.syncId === cId) {
                    if (emitter === _this.eventEmitterSymbol && typeof _this.props.syncMethod !== 'function') return;
                    _this.applySyncEvent(data);
                }
            });
            $c6b16af6ccfd04cd$var$_defineProperty(_this, "handleBrushChange", function(_ref9) {
                var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
                // Only trigger changes if the extents of the brush have actually changed
                if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
                    var updateId = _this.state.updateId;
                    _this.setState(function() {
                        return $c6b16af6ccfd04cd$var$_objectSpread({
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex
                        }, updateStateOfAxisMapsOffsetAndStackGroups({
                            props: _this.props,
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex,
                            updateId: updateId
                        }, _this.state));
                    });
                    _this.triggerSyncEvent({
                        dataStartIndex: startIndex,
                        dataEndIndex: endIndex
                    });
                }
            });
            /**
       * The handler of mouse entering chart
       * @param  {Object} e              Event object
       * @return {Null}                  null
       */ $c6b16af6ccfd04cd$var$_defineProperty(_this, "handleMouseEnter", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState = $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState);
                    _this.triggerSyncEvent(_nextState);
                    var onMouseEnter = _this.props.onMouseEnter;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(onMouseEnter)) onMouseEnter(_nextState, e);
                }
            });
            $c6b16af6ccfd04cd$var$_defineProperty(_this, "triggeredAfterMouseMove", function(e) {
                var mouse = _this.getMouseInfo(e);
                var nextState = mouse ? $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, mouse), {}, {
                    isTooltipActive: true
                }) : {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseMove = _this.props.onMouseMove;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(onMouseMove)) onMouseMove(nextState, e);
            });
            /**
       * The handler of mouse entering a scatter
       * @param {Object} el The active scatter
       * @return {Object} no return
       */ $c6b16af6ccfd04cd$var$_defineProperty(_this, "handleItemMouseEnter", function(el) {
                _this.setState(function() {
                    return {
                        isTooltipActive: true,
                        activeItem: el,
                        activePayload: el.tooltipPayload,
                        activeCoordinate: el.tooltipPosition || {
                            x: el.cx,
                            y: el.cy
                        }
                    };
                });
            });
            /**
       * The handler of mouse leaving a scatter
       * @return {Object} no return
       */ $c6b16af6ccfd04cd$var$_defineProperty(_this, "handleItemMouseLeave", function() {
                _this.setState(function() {
                    return {
                        isTooltipActive: false
                    };
                });
            });
            /**
       * The handler of mouse moving in chart
       * @param  {React.MouseEvent} e        Event object
       * @return {void} no return
       */ $c6b16af6ccfd04cd$var$_defineProperty(_this, "handleMouseMove", function(e) {
                e.persist();
                _this.throttleTriggeredAfterMouseMove(e);
            });
            /**
       * The handler if mouse leaving chart
       * @param {Object} e Event object
       * @return {Null} no return
       */ $c6b16af6ccfd04cd$var$_defineProperty(_this, "handleMouseLeave", function(e) {
                _this.throttleTriggeredAfterMouseMove.cancel();
                var nextState = {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseLeave = _this.props.onMouseLeave;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(onMouseLeave)) onMouseLeave(nextState, e);
            });
            $c6b16af6ccfd04cd$var$_defineProperty(_this, "handleOuterEvent", function(e) {
                var eventName = (0, $10636f1b3e62ab88$export$afb3591bc51a0b70)(e);
                var event = (0, (/*@__PURE__*/$parcel$interopDefault($eb02300d30d6bdcb$exports)))(_this.props, "".concat(eventName));
                if (eventName && (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(event)) {
                    var _mouse;
                    var mouse;
                    if (/.*touch.*/i.test(eventName)) mouse = _this.getMouseInfo(e.changedTouches[0]);
                    else mouse = _this.getMouseInfo(e);
                    event((_mouse = mouse) !== null && _mouse !== void 0 ? _mouse : {}, e);
                }
            });
            $c6b16af6ccfd04cd$var$_defineProperty(_this, "handleClick", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState2 = $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState2);
                    _this.triggerSyncEvent(_nextState2);
                    var onClick = _this.props.onClick;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(onClick)) onClick(_nextState2, e);
                }
            });
            $c6b16af6ccfd04cd$var$_defineProperty(_this, "handleMouseDown", function(e) {
                var onMouseDown = _this.props.onMouseDown;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(onMouseDown)) {
                    var _nextState3 = _this.getMouseInfo(e);
                    onMouseDown(_nextState3, e);
                }
            });
            $c6b16af6ccfd04cd$var$_defineProperty(_this, "handleMouseUp", function(e) {
                var onMouseUp = _this.props.onMouseUp;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(onMouseUp)) {
                    var _nextState4 = _this.getMouseInfo(e);
                    onMouseUp(_nextState4, e);
                }
            });
            $c6b16af6ccfd04cd$var$_defineProperty(_this, "handleTouchMove", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.throttleTriggeredAfterMouseMove(e.changedTouches[0]);
            });
            $c6b16af6ccfd04cd$var$_defineProperty(_this, "handleTouchStart", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseDown(e.changedTouches[0]);
            });
            $c6b16af6ccfd04cd$var$_defineProperty(_this, "handleTouchEnd", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseUp(e.changedTouches[0]);
            });
            $c6b16af6ccfd04cd$var$_defineProperty(_this, "handleDoubleClick", function(e) {
                var onDoubleClick = _this.props.onDoubleClick;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(onDoubleClick)) {
                    var _nextState5 = _this.getMouseInfo(e);
                    onDoubleClick(_nextState5, e);
                }
            });
            $c6b16af6ccfd04cd$var$_defineProperty(_this, "handleContextMenu", function(e) {
                var onContextMenu = _this.props.onContextMenu;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(onContextMenu)) {
                    var _nextState6 = _this.getMouseInfo(e);
                    onContextMenu(_nextState6, e);
                }
            });
            $c6b16af6ccfd04cd$var$_defineProperty(_this, "triggerSyncEvent", function(data) {
                if (_this.props.syncId !== undefined) (0, $b8959d024b33388d$export$9bcdfe5f29bb33).emit((0, $b8959d024b33388d$export$ff9a08f6d0c38b8f), _this.props.syncId, data, _this.eventEmitterSymbol);
            });
            $c6b16af6ccfd04cd$var$_defineProperty(_this, "applySyncEvent", function(data) {
                var _this$props = _this.props, layout = _this$props.layout, syncMethod = _this$props.syncMethod;
                var updateId = _this.state.updateId;
                var dataStartIndex = data.dataStartIndex, dataEndIndex = data.dataEndIndex;
                if (data.dataStartIndex !== undefined || data.dataEndIndex !== undefined) _this.setState($c6b16af6ccfd04cd$var$_objectSpread({
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }, updateStateOfAxisMapsOffsetAndStackGroups({
                    props: _this.props,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex,
                    updateId: updateId
                }, _this.state)));
                else if (data.activeTooltipIndex !== undefined) {
                    var chartX = data.chartX, chartY = data.chartY;
                    var activeTooltipIndex = data.activeTooltipIndex;
                    var _this$state2 = _this.state, offset = _this$state2.offset, tooltipTicks = _this$state2.tooltipTicks;
                    if (!offset) return;
                    if (typeof syncMethod === 'function') // Call a callback function. If there is an application specific algorithm
                    activeTooltipIndex = syncMethod(tooltipTicks, data);
                    else if (syncMethod === 'value') {
                        // Set activeTooltipIndex to the index with the same value as data.activeLabel
                        // For loop instead of findIndex because the latter is very slow in some browsers
                        activeTooltipIndex = -1; // in case we cannot find the element
                        for(var i = 0; i < tooltipTicks.length; i++)if (tooltipTicks[i].value === data.activeLabel) {
                            activeTooltipIndex = i;
                            break;
                        }
                    }
                    var viewBox = $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    });
                    // When a categorical chart is combined with another chart, the value of chartX
                    // and chartY may beyond the boundaries.
                    var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
                    var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
                    var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
                    var activePayload = $c6b16af6ccfd04cd$var$getTooltipContent(_this.state, _this.props.data, activeTooltipIndex);
                    var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
                        x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
                        y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
                    } : $c6b16af6ccfd04cd$var$originCoordinate;
                    _this.setState($c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, data), {}, {
                        activeLabel: activeLabel,
                        activeCoordinate: activeCoordinate,
                        activePayload: activePayload,
                        activeTooltipIndex: activeTooltipIndex
                    }));
                } else _this.setState(data);
            });
            $c6b16af6ccfd04cd$var$_defineProperty(_this, "renderCursor", function(element) {
                var _element$props$active;
                var _this$state3 = _this.state, isTooltipActive = _this$state3.isTooltipActive, activeCoordinate = _this$state3.activeCoordinate, activePayload = _this$state3.activePayload, offset = _this$state3.offset, activeTooltipIndex = _this$state3.activeTooltipIndex, tooltipAxisBandSize = _this$state3.tooltipAxisBandSize;
                var tooltipEventType = _this.getTooltipEventType();
                // The cursor is a part of the Tooltip, and it should be shown (by default) when the Tooltip is active.
                var isActive = (_element$props$active = element.props.active) !== null && _element$props$active !== void 0 ? _element$props$active : isTooltipActive;
                var layout = _this.props.layout;
                var key = element.key || '_recharts-cursor';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $a0b4d05e8561e67e$export$b6a79797ad180576), {
                    key: key,
                    activeCoordinate: activeCoordinate,
                    activePayload: activePayload,
                    activeTooltipIndex: activeTooltipIndex,
                    chartName: chartName,
                    element: element,
                    isActive: isActive,
                    layout: layout,
                    offset: offset,
                    tooltipAxisBandSize: tooltipAxisBandSize,
                    tooltipEventType: tooltipEventType
                });
            });
            $c6b16af6ccfd04cd$var$_defineProperty(_this, "renderPolarAxis", function(element, displayName, index) {
                var axisType = (0, (/*@__PURE__*/$parcel$interopDefault($eb02300d30d6bdcb$exports)))(element, 'type.axisType');
                var axisMap = (0, (/*@__PURE__*/$parcel$interopDefault($eb02300d30d6bdcb$exports)))(_this.state, "".concat(axisType, "Map"));
                var elementDefaultProps = element.type.defaultProps;
                var elementProps = elementDefaultProps !== undefined ? $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, elementDefaultProps), element.props) : element.props;
                var axisOption = axisMap && axisMap[elementProps["".concat(axisType, "Id")]];
                return /*#__PURE__*/ (0, $8T3gX.cloneElement)(element, $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, axisOption), {}, {
                    className: (0, $iVyaN.default)(axisType, axisOption.className),
                    key: element.key || "".concat(displayName, "-").concat(index),
                    ticks: (0, $bc60c84815913bd8$export$c829ee42daf7f66d)(axisOption, true)
                }));
            });
            $c6b16af6ccfd04cd$var$_defineProperty(_this, "renderPolarGrid", function(element) {
                var _element$props = element.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius;
                var _this$state4 = _this.state, radiusAxisMap = _this$state4.radiusAxisMap, angleAxisMap = _this$state4.angleAxisMap;
                var radiusAxis = (0, $ec351366ffe25ce6$export$b88993f0aa0bf776)(radiusAxisMap);
                var angleAxis = (0, $ec351366ffe25ce6$export$b88993f0aa0bf776)(angleAxisMap);
                var cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
                return /*#__PURE__*/ (0, $8T3gX.cloneElement)(element, {
                    polarAngles: Array.isArray(polarAngles) ? polarAngles : (0, $bc60c84815913bd8$export$c829ee42daf7f66d)(angleAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    polarRadius: Array.isArray(polarRadius) ? polarRadius : (0, $bc60c84815913bd8$export$c829ee42daf7f66d)(radiusAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    key: element.key || 'polar-grid',
                    radialLines: radialLines
                });
            });
            /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */ $c6b16af6ccfd04cd$var$_defineProperty(_this, "renderLegend", function() {
                var formattedGraphicalItems = _this.state.formattedGraphicalItems;
                var _this$props2 = _this.props, children = _this$props2.children, width = _this$props2.width, height = _this$props2.height;
                var margin = _this.props.margin || {};
                var legendWidth = width - (margin.left || 0) - (margin.right || 0);
                var props = (0, $952a3f9c16857392$export$8f9424d123c36aa)({
                    children: children,
                    formattedGraphicalItems: formattedGraphicalItems,
                    legendWidth: legendWidth,
                    legendContent: legendContent
                });
                if (!props) return null;
                var item = props.item, otherProps = $c6b16af6ccfd04cd$var$_objectWithoutProperties(props, $c6b16af6ccfd04cd$var$_excluded);
                return /*#__PURE__*/ (0, $8T3gX.cloneElement)(item, $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, otherProps), {}, {
                    chartWidth: width,
                    chartHeight: height,
                    margin: margin,
                    onBBoxUpdate: _this.handleLegendBBoxUpdate
                }));
            });
            /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */ $c6b16af6ccfd04cd$var$_defineProperty(_this, "renderTooltip", function() {
                var _tooltipItem$props$ac;
                var _this$props3 = _this.props, children = _this$props3.children, accessibilityLayer = _this$props3.accessibilityLayer;
                var tooltipItem = (0, $10636f1b3e62ab88$export$64c61536a2b72e0f)(children, (0, $45dbb8bb277f9d9d$export$28c660c63b792dea));
                if (!tooltipItem) return null;
                var _this$state5 = _this.state, isTooltipActive = _this$state5.isTooltipActive, activeCoordinate = _this$state5.activeCoordinate, activePayload = _this$state5.activePayload, activeLabel = _this$state5.activeLabel, offset = _this$state5.offset;
                // The user can set isActive on the Tooltip,
                // and we respect the user to enable customisation.
                // The Tooltip is active if the user has set isActive, or if the tooltip is active due to a mouse event.
                var isActive = (_tooltipItem$props$ac = tooltipItem.props.active) !== null && _tooltipItem$props$ac !== void 0 ? _tooltipItem$props$ac : isTooltipActive;
                return /*#__PURE__*/ (0, $8T3gX.cloneElement)(tooltipItem, {
                    viewBox: $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    }),
                    active: isActive,
                    label: activeLabel,
                    payload: isActive ? activePayload : [],
                    coordinate: activeCoordinate,
                    accessibilityLayer: accessibilityLayer
                });
            });
            $c6b16af6ccfd04cd$var$_defineProperty(_this, "renderBrush", function(element) {
                var _this$props4 = _this.props, margin = _this$props4.margin, data = _this$props4.data;
                var _this$state6 = _this.state, offset = _this$state6.offset, dataStartIndex = _this$state6.dataStartIndex, dataEndIndex = _this$state6.dataEndIndex, updateId = _this$state6.updateId;
                // TODO: update brush when children update
                return /*#__PURE__*/ (0, $8T3gX.cloneElement)(element, {
                    key: element.key || '_recharts-brush',
                    onChange: (0, $bc60c84815913bd8$export$760ec406ba47bace)(_this.handleBrushChange, element.props.onChange),
                    data: data,
                    x: (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(element.props.x) ? element.props.x : offset.left,
                    y: (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
                    width: (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(element.props.width) ? element.props.width : offset.width,
                    startIndex: dataStartIndex,
                    endIndex: dataEndIndex,
                    updateId: "brush-".concat(updateId)
                });
            });
            $c6b16af6ccfd04cd$var$_defineProperty(_this, "renderReferenceElement", function(element, displayName, index) {
                if (!element) return null;
                var _this2 = _this, clipPathId = _this2.clipPathId;
                var _this$state7 = _this.state, xAxisMap = _this$state7.xAxisMap, yAxisMap = _this$state7.yAxisMap, offset = _this$state7.offset;
                var elementDefaultProps = element.type.defaultProps || {};
                var _element$props2 = element.props, _element$props2$xAxis = _element$props2.xAxisId, xAxisId = _element$props2$xAxis === void 0 ? elementDefaultProps.xAxisId : _element$props2$xAxis, _element$props2$yAxis = _element$props2.yAxisId, yAxisId = _element$props2$yAxis === void 0 ? elementDefaultProps.yAxisId : _element$props2$yAxis;
                return /*#__PURE__*/ (0, $8T3gX.cloneElement)(element, {
                    key: element.key || "".concat(displayName, "-").concat(index),
                    xAxis: xAxisMap[xAxisId],
                    yAxis: yAxisMap[yAxisId],
                    viewBox: {
                        x: offset.left,
                        y: offset.top,
                        width: offset.width,
                        height: offset.height
                    },
                    clipPathId: clipPathId
                });
            });
            $c6b16af6ccfd04cd$var$_defineProperty(_this, "renderActivePoints", function(_ref10) {
                var item = _ref10.item, activePoint = _ref10.activePoint, basePoint = _ref10.basePoint, childIndex = _ref10.childIndex, isRange = _ref10.isRange;
                var result = [];
                // item is not a React Element so we don't need to resolve defaultProps.
                var key = item.props.key;
                var itemItemProps = item.item.type.defaultProps !== undefined ? $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, item.item.type.defaultProps), item.item.props) : item.item.props;
                var activeDot = itemItemProps.activeDot, dataKey = itemItemProps.dataKey;
                var dotProps = $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({
                    index: childIndex,
                    dataKey: dataKey,
                    cx: activePoint.x,
                    cy: activePoint.y,
                    r: 4,
                    fill: (0, $bc60c84815913bd8$export$ec6cab5a7a3b93bf)(item.item),
                    strokeWidth: 2,
                    stroke: '#fff',
                    payload: activePoint.payload,
                    value: activePoint.value
                }, (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(activeDot, false)), (0, $a19170a4abc07995$export$7c4c290a4a9c1b1e)(activeDot));
                result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps, "".concat(key, "-activePoint-").concat(childIndex)));
                if (basePoint) result.push(CategoricalChartWrapper.renderActiveDot(activeDot, $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, dotProps), {}, {
                    cx: basePoint.x,
                    cy: basePoint.y
                }), "".concat(key, "-basePoint-").concat(childIndex)));
                else if (isRange) result.push(null);
                return result;
            });
            $c6b16af6ccfd04cd$var$_defineProperty(_this, "renderGraphicChild", function(element, displayName, index) {
                var item = _this.filterFormatItem(element, displayName, index);
                if (!item) return null;
                var tooltipEventType = _this.getTooltipEventType();
                var _this$state8 = _this.state, isTooltipActive = _this$state8.isTooltipActive, tooltipAxis = _this$state8.tooltipAxis, activeTooltipIndex = _this$state8.activeTooltipIndex, activeLabel = _this$state8.activeLabel;
                var children = _this.props.children;
                var tooltipItem = (0, $10636f1b3e62ab88$export$64c61536a2b72e0f)(children, (0, $45dbb8bb277f9d9d$export$28c660c63b792dea));
                // item is not a React Element so we don't need to resolve defaultProps
                var _item$props = item.props, points = _item$props.points, isRange = _item$props.isRange, baseLine = _item$props.baseLine;
                var itemItemProps = item.item.type.defaultProps !== undefined ? $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, item.item.type.defaultProps), item.item.props) : item.item.props;
                var activeDot = itemItemProps.activeDot, hide = itemItemProps.hide, activeBar = itemItemProps.activeBar, activeShape = itemItemProps.activeShape;
                var hasActive = Boolean(!hide && isTooltipActive && tooltipItem && (activeDot || activeBar || activeShape));
                var itemEvents = {};
                if (tooltipEventType !== 'axis' && tooltipItem && tooltipItem.props.trigger === 'click') itemEvents = {
                    onClick: (0, $bc60c84815913bd8$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onClick)
                };
                else if (tooltipEventType !== 'axis') itemEvents = {
                    onMouseLeave: (0, $bc60c84815913bd8$export$760ec406ba47bace)(_this.handleItemMouseLeave, element.props.onMouseLeave),
                    onMouseEnter: (0, $bc60c84815913bd8$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onMouseEnter)
                };
                var graphicalItem = /*#__PURE__*/ (0, $8T3gX.cloneElement)(element, $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, item.props), itemEvents));
                function findWithPayload(entry) {
                    // TODO needs to verify dataKey is Function
                    return typeof tooltipAxis.dataKey === 'function' ? tooltipAxis.dataKey(entry.payload) : null;
                }
                if (hasActive) {
                    if (activeTooltipIndex >= 0) {
                        var activePoint, basePoint;
                        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
                            // number transform to string
                            var specifiedKey = typeof tooltipAxis.dataKey === 'function' ? findWithPayload : 'payload.'.concat(tooltipAxis.dataKey.toString());
                            activePoint = (0, $ec351366ffe25ce6$export$66950d3869f5cc67)(points, specifiedKey, activeLabel);
                            basePoint = isRange && baseLine && (0, $ec351366ffe25ce6$export$66950d3869f5cc67)(baseLine, specifiedKey, activeLabel);
                        } else {
                            activePoint = points === null || points === void 0 ? void 0 : points[activeTooltipIndex];
                            basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
                        }
                        if (activeShape || activeBar) {
                            var activeIndex = element.props.activeIndex !== undefined ? element.props.activeIndex : activeTooltipIndex;
                            return [
                                /*#__PURE__*/ (0, $8T3gX.cloneElement)(element, $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, item.props), itemEvents), {}, {
                                    activeIndex: activeIndex
                                })),
                                null,
                                null
                            ];
                        }
                        if (!(0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(activePoint)) return [
                            graphicalItem
                        ].concat($c6b16af6ccfd04cd$var$_toConsumableArray(_this.renderActivePoints({
                            item: item,
                            activePoint: activePoint,
                            basePoint: basePoint,
                            childIndex: activeTooltipIndex,
                            isRange: isRange
                        })));
                    } else {
                        var _this$getItemByXY;
                        /**
             * We hit this block if consumer uses a Tooltip without XAxis and/or YAxis.
             * In which case, this.state.activeTooltipIndex never gets set
             * because the mouse events that trigger that value getting set never get trigged without the axis components.
             *
             * An example usage case is a FunnelChart
             */ var _ref11 = (_this$getItemByXY = _this.getItemByXY(_this.state.activeCoordinate)) !== null && _this$getItemByXY !== void 0 ? _this$getItemByXY : {
                            graphicalItem: graphicalItem
                        }, _ref11$graphicalItem = _ref11.graphicalItem, _ref11$graphicalItem$ = _ref11$graphicalItem.item, xyItem = _ref11$graphicalItem$ === void 0 ? element : _ref11$graphicalItem$, childIndex = _ref11$graphicalItem.childIndex;
                        var elementProps = $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, item.props), itemEvents), {}, {
                            activeIndex: childIndex
                        });
                        return [
                            /*#__PURE__*/ (0, $8T3gX.cloneElement)(xyItem, elementProps),
                            null,
                            null
                        ];
                    }
                }
                if (isRange) return [
                    graphicalItem,
                    null,
                    null
                ];
                return [
                    graphicalItem,
                    null
                ];
            });
            $c6b16af6ccfd04cd$var$_defineProperty(_this, "renderCustomized", function(element, displayName, index) {
                return /*#__PURE__*/ (0, $8T3gX.cloneElement)(element, $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({
                    key: "recharts-customized-".concat(index)
                }, _this.props), _this.state));
            });
            $c6b16af6ccfd04cd$var$_defineProperty(_this, "renderMap", {
                CartesianGrid: {
                    handler: $c6b16af6ccfd04cd$var$renderAsIs,
                    once: true
                },
                ReferenceArea: {
                    handler: _this.renderReferenceElement
                },
                ReferenceLine: {
                    handler: $c6b16af6ccfd04cd$var$renderAsIs
                },
                ReferenceDot: {
                    handler: _this.renderReferenceElement
                },
                XAxis: {
                    handler: $c6b16af6ccfd04cd$var$renderAsIs
                },
                YAxis: {
                    handler: $c6b16af6ccfd04cd$var$renderAsIs
                },
                Brush: {
                    handler: _this.renderBrush,
                    once: true
                },
                Bar: {
                    handler: _this.renderGraphicChild
                },
                Line: {
                    handler: _this.renderGraphicChild
                },
                Area: {
                    handler: _this.renderGraphicChild
                },
                Radar: {
                    handler: _this.renderGraphicChild
                },
                RadialBar: {
                    handler: _this.renderGraphicChild
                },
                Scatter: {
                    handler: _this.renderGraphicChild
                },
                Pie: {
                    handler: _this.renderGraphicChild
                },
                Funnel: {
                    handler: _this.renderGraphicChild
                },
                Tooltip: {
                    handler: _this.renderCursor,
                    once: true
                },
                PolarGrid: {
                    handler: _this.renderPolarGrid,
                    once: true
                },
                PolarAngleAxis: {
                    handler: _this.renderPolarAxis
                },
                PolarRadiusAxis: {
                    handler: _this.renderPolarAxis
                },
                Customized: {
                    handler: _this.renderCustomized
                }
            });
            _this.clipPathId = "".concat((_props$id = _props.id) !== null && _props$id !== void 0 ? _props$id : (0, $ec351366ffe25ce6$export$8b15d37bc3f197d4)('recharts'), "-clip");
            // trigger 60fps
            _this.throttleTriggeredAfterMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($ad4be26b64041d02$exports)))(_this.triggeredAfterMouseMove, (_props$throttleDelay = _props.throttleDelay) !== null && _props$throttleDelay !== void 0 ? _props$throttleDelay : 1000 / 60);
            _this.state = {};
            return _this;
        }
        $c6b16af6ccfd04cd$var$_inherits(CategoricalChartWrapper, _Component);
        return $c6b16af6ccfd04cd$var$_createClass(CategoricalChartWrapper, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this$props$margin$le, _this$props$margin$to;
                    this.addListener();
                    this.accessibilityManager.setDetails({
                        container: this.container,
                        offset: {
                            left: (_this$props$margin$le = this.props.margin.left) !== null && _this$props$margin$le !== void 0 ? _this$props$margin$le : 0,
                            top: (_this$props$margin$to = this.props.margin.top) !== null && _this$props$margin$to !== void 0 ? _this$props$margin$to : 0
                        },
                        coordinateList: this.state.tooltipTicks,
                        mouseHandlerCallback: this.triggeredAfterMouseMove,
                        layout: this.props.layout
                    });
                    this.displayDefaultTooltip();
                }
            },
            {
                key: "displayDefaultTooltip",
                value: function displayDefaultTooltip() {
                    var _this$props5 = this.props, children = _this$props5.children, data = _this$props5.data, height = _this$props5.height, layout = _this$props5.layout;
                    var tooltipElem = (0, $10636f1b3e62ab88$export$64c61536a2b72e0f)(children, (0, $45dbb8bb277f9d9d$export$28c660c63b792dea));
                    // If the chart doesn't include a <Tooltip /> element, there's no tooltip to display
                    if (!tooltipElem) return;
                    var defaultIndex = tooltipElem.props.defaultIndex;
                    // Protect against runtime errors
                    if (typeof defaultIndex !== 'number' || defaultIndex < 0 || defaultIndex > this.state.tooltipTicks.length - 1) return;
                    var activeLabel = this.state.tooltipTicks[defaultIndex] && this.state.tooltipTicks[defaultIndex].value;
                    var activePayload = $c6b16af6ccfd04cd$var$getTooltipContent(this.state, data, defaultIndex, activeLabel);
                    var independentAxisCoord = this.state.tooltipTicks[defaultIndex].coordinate;
                    var dependentAxisCoord = (this.state.offset.top + height) / 2;
                    var isHorizontal = layout === 'horizontal';
                    var activeCoordinate = isHorizontal ? {
                        x: independentAxisCoord,
                        y: dependentAxisCoord
                    } : {
                        y: independentAxisCoord,
                        x: dependentAxisCoord
                    };
                    // Unlike other chart types, scatter plot's tooltip positions rely on both X and Y coordinates. Only the scatter plot
                    // element knows its own Y coordinates.
                    // If there's a scatter plot, we'll want to grab that element for an interrogation.
                    var scatterPlotElement = this.state.formattedGraphicalItems.find(function(_ref12) {
                        var item = _ref12.item;
                        return item.type.name === 'Scatter';
                    });
                    if (scatterPlotElement) {
                        activeCoordinate = $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, activeCoordinate), scatterPlotElement.props.points[defaultIndex].tooltipPosition);
                        activePayload = scatterPlotElement.props.points[defaultIndex].tooltipPayload;
                    }
                    var nextState = {
                        activeTooltipIndex: defaultIndex,
                        isTooltipActive: true,
                        activeLabel: activeLabel,
                        activePayload: activePayload,
                        activeCoordinate: activeCoordinate
                    };
                    this.setState(nextState);
                    this.renderCursor(tooltipElem);
                    // Make sure that anyone who keyboard-only users who tab to the chart will start their
                    // cursors at defaultIndex
                    this.accessibilityManager.setIndex(defaultIndex);
                }
            },
            {
                key: "getSnapshotBeforeUpdate",
                value: function getSnapshotBeforeUpdate(prevProps, prevState) {
                    if (!this.props.accessibilityLayer) return null;
                    if (this.state.tooltipTicks !== prevState.tooltipTicks) this.accessibilityManager.setDetails({
                        coordinateList: this.state.tooltipTicks
                    });
                    if (this.props.layout !== prevProps.layout) this.accessibilityManager.setDetails({
                        layout: this.props.layout
                    });
                    if (this.props.margin !== prevProps.margin) {
                        var _this$props$margin$le2, _this$props$margin$to2;
                        this.accessibilityManager.setDetails({
                            offset: {
                                left: (_this$props$margin$le2 = this.props.margin.left) !== null && _this$props$margin$le2 !== void 0 ? _this$props$margin$le2 : 0,
                                top: (_this$props$margin$to2 = this.props.margin.top) !== null && _this$props$margin$to2 !== void 0 ? _this$props$margin$to2 : 0
                            }
                        });
                    }
                    // Something has to be returned for getSnapshotBeforeUpdate
                    return null;
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    // Check to see if the Tooltip updated. If so, re-check default tooltip position
                    if (!(0, $10636f1b3e62ab88$export$acdc716e08572f94)([
                        (0, $10636f1b3e62ab88$export$64c61536a2b72e0f)(prevProps.children, (0, $45dbb8bb277f9d9d$export$28c660c63b792dea))
                    ], [
                        (0, $10636f1b3e62ab88$export$64c61536a2b72e0f)(this.props.children, (0, $45dbb8bb277f9d9d$export$28c660c63b792dea))
                    ])) this.displayDefaultTooltip();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.removeListener();
                    this.throttleTriggeredAfterMouseMove.cancel();
                }
            },
            {
                key: "getTooltipEventType",
                value: function getTooltipEventType() {
                    var tooltipItem = (0, $10636f1b3e62ab88$export$64c61536a2b72e0f)(this.props.children, (0, $45dbb8bb277f9d9d$export$28c660c63b792dea));
                    if (tooltipItem && typeof tooltipItem.props.shared === 'boolean') {
                        var eventType = tooltipItem.props.shared ? 'axis' : 'item';
                        return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
                    }
                    return defaultTooltipEventType;
                }
            },
            {
                key: "getMouseInfo",
                value: function getMouseInfo(event) {
                    if (!this.container) return null;
                    var element = this.container;
                    var boundingRect = element.getBoundingClientRect();
                    var containerOffset = (0, $cf8622a67b6f7493$export$622cea445a1c5b7d)(boundingRect);
                    var e = {
                        chartX: Math.round(event.pageX - containerOffset.left),
                        chartY: Math.round(event.pageY - containerOffset.top)
                    };
                    var scale = boundingRect.width / element.offsetWidth || 1;
                    var rangeObj = this.inRange(e.chartX, e.chartY, scale);
                    if (!rangeObj) return null;
                    var _this$state9 = this.state, xAxisMap = _this$state9.xAxisMap, yAxisMap = _this$state9.yAxisMap;
                    var tooltipEventType = this.getTooltipEventType();
                    var toolTipData = $c6b16af6ccfd04cd$var$getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
                    if (tooltipEventType !== 'axis' && xAxisMap && yAxisMap) {
                        var xScale = (0, $ec351366ffe25ce6$export$b88993f0aa0bf776)(xAxisMap).scale;
                        var yScale = (0, $ec351366ffe25ce6$export$b88993f0aa0bf776)(yAxisMap).scale;
                        var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
                        var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
                        return $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, e), {}, {
                            xValue: xValue,
                            yValue: yValue
                        }, toolTipData);
                    }
                    if (toolTipData) return $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, e), toolTipData);
                    return null;
                }
            },
            {
                key: "inRange",
                value: function inRange(x, y) {
                    var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                    var layout = this.props.layout;
                    var scaledX = x / scale, scaledY = y / scale;
                    if (layout === 'horizontal' || layout === 'vertical') {
                        var offset = this.state.offset;
                        var isInRange = scaledX >= offset.left && scaledX <= offset.left + offset.width && scaledY >= offset.top && scaledY <= offset.top + offset.height;
                        return isInRange ? {
                            x: scaledX,
                            y: scaledY
                        } : null;
                    }
                    var _this$state10 = this.state, angleAxisMap = _this$state10.angleAxisMap, radiusAxisMap = _this$state10.radiusAxisMap;
                    if (angleAxisMap && radiusAxisMap) {
                        var angleAxis = (0, $ec351366ffe25ce6$export$b88993f0aa0bf776)(angleAxisMap);
                        return (0, $8e3433adec38d948$export$e85a2bf8cd31c504)({
                            x: scaledX,
                            y: scaledY
                        }, angleAxis);
                    }
                    return null;
                }
            },
            {
                key: "parseEventsOfWrapper",
                value: function parseEventsOfWrapper() {
                    var children = this.props.children;
                    var tooltipEventType = this.getTooltipEventType();
                    var tooltipItem = (0, $10636f1b3e62ab88$export$64c61536a2b72e0f)(children, (0, $45dbb8bb277f9d9d$export$28c660c63b792dea));
                    var tooltipEvents = {};
                    if (tooltipItem && tooltipEventType === 'axis') {
                        if (tooltipItem.props.trigger === 'click') tooltipEvents = {
                            onClick: this.handleClick
                        };
                        else tooltipEvents = {
                            onMouseEnter: this.handleMouseEnter,
                            onDoubleClick: this.handleDoubleClick,
                            onMouseMove: this.handleMouseMove,
                            onMouseLeave: this.handleMouseLeave,
                            onTouchMove: this.handleTouchMove,
                            onTouchStart: this.handleTouchStart,
                            onTouchEnd: this.handleTouchEnd,
                            onContextMenu: this.handleContextMenu
                        };
                    }
                    // @ts-expect-error adaptEventHandlers expects DOM Event but generateCategoricalChart works with React UIEvents
                    var outerEvents = (0, $a19170a4abc07995$export$7c4c290a4a9c1b1e)(this.props, this.handleOuterEvent);
                    return $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, outerEvents), tooltipEvents);
                }
            },
            {
                key: "addListener",
                value: function addListener() {
                    (0, $b8959d024b33388d$export$9bcdfe5f29bb33).on((0, $b8959d024b33388d$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "removeListener",
                value: function removeListener() {
                    (0, $b8959d024b33388d$export$9bcdfe5f29bb33).removeListener((0, $b8959d024b33388d$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "filterFormatItem",
                value: function filterFormatItem(item, displayName, childIndex) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var entry = formattedGraphicalItems[i];
                        if (entry.item === item || entry.props.key === item.key || displayName === (0, $10636f1b3e62ab88$export$be63e0664592e141)(entry.item.type) && childIndex === entry.childIndex) return entry;
                    }
                    return null;
                }
            },
            {
                key: "renderClipPath",
                value: function renderClipPath() {
                    var clipPathId = this.clipPathId;
                    var _this$state$offset = this.state.offset, left = _this$state$offset.left, top = _this$state$offset.top, height = _this$state$offset.height, width = _this$state$offset.width;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("clipPath", {
                        id: clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("rect", {
                        x: left,
                        y: top,
                        height: height,
                        width: width
                    })));
                }
            },
            {
                key: "getXScales",
                value: function getXScales() {
                    var xAxisMap = this.state.xAxisMap;
                    return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref13) {
                        var _ref14 = $c6b16af6ccfd04cd$var$_slicedToArray(_ref13, 2), axisId = _ref14[0], axisProps = _ref14[1];
                        return $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, res), {}, $c6b16af6ccfd04cd$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getYScales",
                value: function getYScales() {
                    var yAxisMap = this.state.yAxisMap;
                    return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref15) {
                        var _ref16 = $c6b16af6ccfd04cd$var$_slicedToArray(_ref15, 2), axisId = _ref16[0], axisProps = _ref16[1];
                        return $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, res), {}, $c6b16af6ccfd04cd$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getXScaleByAxisId",
                value: function getXScaleByAxisId(axisId) {
                    var _this$state$xAxisMap;
                    return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 || (_this$state$xAxisMap = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap === void 0 ? void 0 : _this$state$xAxisMap.scale;
                }
            },
            {
                key: "getYScaleByAxisId",
                value: function getYScaleByAxisId(axisId) {
                    var _this$state$yAxisMap;
                    return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 || (_this$state$yAxisMap = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap === void 0 ? void 0 : _this$state$yAxisMap.scale;
                }
            },
            {
                key: "getItemByXY",
                value: function getItemByXY(chartXY) {
                    var _this$state11 = this.state, formattedGraphicalItems = _this$state11.formattedGraphicalItems, activeItem = _this$state11.activeItem;
                    if (formattedGraphicalItems && formattedGraphicalItems.length) for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var graphicalItem = formattedGraphicalItems[i];
                        // graphicalItem is not a React Element so we don't need to resolve defaultProps
                        var props = graphicalItem.props, item = graphicalItem.item;
                        var itemProps = item.type.defaultProps !== undefined ? $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, item.type.defaultProps), item.props) : item.props;
                        var itemDisplayName = (0, $10636f1b3e62ab88$export$be63e0664592e141)(item.type);
                        if (itemDisplayName === 'Bar') {
                            var activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $0ab2d840c2839083$export$f783d19325be51d5)(chartXY, entry);
                            });
                            if (activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: activeBarItem
                            };
                        } else if (itemDisplayName === 'RadialBar') {
                            var _activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $8e3433adec38d948$export$e85a2bf8cd31c504)(chartXY, entry);
                            });
                            if (_activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: _activeBarItem
                            };
                        } else if ((0, $8de249487f1d36dd$export$4b83e8415af38a18)(graphicalItem, activeItem) || (0, $8de249487f1d36dd$export$f722d7e63cc07b)(graphicalItem, activeItem) || (0, $8de249487f1d36dd$export$f62b21bcfd1a733e)(graphicalItem, activeItem)) {
                            var activeIndex = (0, $8de249487f1d36dd$export$bd5d63c57ca4468)({
                                graphicalItem: graphicalItem,
                                activeTooltipItem: activeItem,
                                itemData: itemProps.data
                            });
                            var childIndex = itemProps.activeIndex === undefined ? activeIndex : itemProps.activeIndex;
                            return {
                                graphicalItem: $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, graphicalItem), {}, {
                                    childIndex: childIndex
                                }),
                                payload: (0, $8de249487f1d36dd$export$f62b21bcfd1a733e)(graphicalItem, activeItem) ? itemProps.data[activeIndex] : graphicalItem.props.data[activeIndex]
                            };
                        }
                    }
                    return null;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this3 = this;
                    if (!(0, $10636f1b3e62ab88$export$5301de6bfd3cfa2a)(this)) return null;
                    var _this$props6 = this.props, children = _this$props6.children, className = _this$props6.className, width = _this$props6.width, height = _this$props6.height, style = _this$props6.style, compact = _this$props6.compact, title = _this$props6.title, desc = _this$props6.desc, others = $c6b16af6ccfd04cd$var$_objectWithoutProperties(_this$props6, $c6b16af6ccfd04cd$var$_excluded2);
                    var attrs = (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(others, false);
                    // The "compact" mode is mainly used as the panorama within Brush
                    if (compact) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $aaec315a6c49009f$export$e22c0f72c980af5a), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $d2dcb066e7083be7$export$7b92b459e668cb21), $c6b16af6ccfd04cd$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc
                    }), this.renderClipPath(), (0, $10636f1b3e62ab88$export$a98d6da55570cb82)(children, this.renderMap)));
                    if (this.props.accessibilityLayer) {
                        var _this$props$tabIndex, _this$props$role;
                        // Set tabIndex to 0 by default (can be overwritten)
                        attrs.tabIndex = (_this$props$tabIndex = this.props.tabIndex) !== null && _this$props$tabIndex !== void 0 ? _this$props$tabIndex : 0;
                        // Set role to img by default (can be overwritten)
                        attrs.role = (_this$props$role = this.props.role) !== null && _this$props$role !== void 0 ? _this$props$role : 'application';
                        attrs.onKeyDown = function(e) {
                            _this3.accessibilityManager.keyboardEvent(e);
                        // 'onKeyDown' is not currently a supported prop that can be passed through
                        // if it's added, this should be added: this.props.onKeyDown(e);
                        };
                        attrs.onFocus = function() {
                            _this3.accessibilityManager.focus();
                        // 'onFocus' is not currently a supported prop that can be passed through
                        // if it's added, the focus event should be forwarded to the prop
                        };
                    }
                    var events = this.parseEventsOfWrapper();
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $aaec315a6c49009f$export$e22c0f72c980af5a), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("div", $c6b16af6ccfd04cd$var$_extends({
                        className: (0, $iVyaN.default)('recharts-wrapper', className),
                        style: $c6b16af6ccfd04cd$var$_objectSpread({
                            position: 'relative',
                            cursor: 'default',
                            width: width,
                            height: height
                        }, style)
                    }, events, {
                        ref: function ref(node) {
                            _this3.container = node;
                        }
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $d2dcb066e7083be7$export$7b92b459e668cb21), $c6b16af6ccfd04cd$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc,
                        style: $c6b16af6ccfd04cd$var$FULL_WIDTH_AND_HEIGHT
                    }), this.renderClipPath(), (0, $10636f1b3e62ab88$export$a98d6da55570cb82)(children, this.renderMap)), this.renderLegend(), this.renderTooltip()));
                }
            }
        ]);
    }((0, $8T3gX.Component));
    $c6b16af6ccfd04cd$var$_defineProperty(CategoricalChartWrapper, "displayName", chartName);
    // todo join specific chart propTypes
    $c6b16af6ccfd04cd$var$_defineProperty(CategoricalChartWrapper, "defaultProps", $c6b16af6ccfd04cd$var$_objectSpread({
        layout: 'horizontal',
        stackOffset: 'none',
        barCategoryGap: '10%',
        barGap: 4,
        margin: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
        },
        reverseStackOrder: false,
        syncMethod: 'index'
    }, defaultProps));
    $c6b16af6ccfd04cd$var$_defineProperty(CategoricalChartWrapper, "getDerivedStateFromProps", function(nextProps, prevState) {
        var dataKey = nextProps.dataKey, data = nextProps.data, children = nextProps.children, width = nextProps.width, height = nextProps.height, layout = nextProps.layout, stackOffset = nextProps.stackOffset, margin = nextProps.margin;
        var dataStartIndex = prevState.dataStartIndex, dataEndIndex = prevState.dataEndIndex;
        if (prevState.updateId === undefined) {
            var defaultState = $c6b16af6ccfd04cd$export$e5182fb58612e577(nextProps);
            return $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, defaultState), {}, {
                updateId: 0
            }, updateStateOfAxisMapsOffsetAndStackGroups($c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({
                props: nextProps
            }, defaultState), {}, {
                updateId: 0
            }), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (dataKey !== prevState.prevDataKey || data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !(0, $902ad73c142587a6$export$d36bdfa510afb180)(margin, prevState.prevMargin)) {
            var _defaultState = $c6b16af6ccfd04cd$export$e5182fb58612e577(nextProps);
            // Fixes https://github.com/recharts/recharts/issues/2143
            var keepFromPrevState = {
                // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
                // any flickering
                chartX: prevState.chartX,
                chartY: prevState.chartY,
                // The tooltip should stay active when it was active in the previous render. If this is not
                // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
                isTooltipActive: prevState.isTooltipActive
            };
            var updatesToState = $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, $c6b16af6ccfd04cd$var$getTooltipData(prevState, data, layout)), {}, {
                updateId: prevState.updateId + 1
            });
            var newState = $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, _defaultState), keepFromPrevState), updatesToState);
            return $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({}, newState), updateStateOfAxisMapsOffsetAndStackGroups($c6b16af6ccfd04cd$var$_objectSpread({
                props: nextProps
            }, newState), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (!(0, $10636f1b3e62ab88$export$acdc716e08572f94)(children, prevState.prevChildren)) {
            var _brush$props$startInd, _brush$props, _brush$props$endIndex, _brush$props2;
            // specifically check for Brush - if it exists and the start and end indexes are different, re-render with the new ones
            var brush = (0, $10636f1b3e62ab88$export$64c61536a2b72e0f)(children, (0, $303bff326b387541$export$59bc2e3533b384a0));
            var startIndex = brush ? (_brush$props$startInd = (_brush$props = brush.props) === null || _brush$props === void 0 ? void 0 : _brush$props.startIndex) !== null && _brush$props$startInd !== void 0 ? _brush$props$startInd : dataStartIndex : dataStartIndex;
            var endIndex = brush ? (_brush$props$endIndex = (_brush$props2 = brush.props) === null || _brush$props2 === void 0 ? void 0 : _brush$props2.endIndex) !== null && _brush$props$endIndex !== void 0 ? _brush$props$endIndex : dataEndIndex : dataEndIndex;
            var hasDifferentStartOrEndIndex = startIndex !== dataStartIndex || endIndex !== dataEndIndex;
            // update configuration in children
            var hasGlobalData = !(0, (/*@__PURE__*/$parcel$interopDefault($39cd5f6f9b941b5d$exports)))(data);
            var newUpdateId = hasGlobalData && !hasDifferentStartOrEndIndex ? prevState.updateId : prevState.updateId + 1;
            return $c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({
                updateId: newUpdateId
            }, updateStateOfAxisMapsOffsetAndStackGroups($c6b16af6ccfd04cd$var$_objectSpread($c6b16af6ccfd04cd$var$_objectSpread({
                props: nextProps
            }, prevState), {}, {
                updateId: newUpdateId,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            }), prevState)), {}, {
                prevChildren: children,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            });
        }
        return null;
    });
    $c6b16af6ccfd04cd$var$_defineProperty(CategoricalChartWrapper, "renderActiveDot", function(option, props, key) {
        var dot;
        if (/*#__PURE__*/ (0, $8T3gX.isValidElement)(option)) dot = /*#__PURE__*/ (0, $8T3gX.cloneElement)(option, props);
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(option)) dot = option(props);
        else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $295618a64acc25e0$export$d046b3c4a416f60d), props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $3366a7250677b47e$export$936d0764594b6eb3), {
            className: "recharts-active-dot",
            key: key
        }, dot);
    });
    var CategoricalChart = /*#__PURE__*/ (0, $8T3gX.forwardRef)(function CategoricalChart(props, ref) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement(CategoricalChartWrapper, $c6b16af6ccfd04cd$var$_extends({}, props, {
            ref: ref
        }));
    });
    CategoricalChart.displayName = CategoricalChartWrapper.displayName;
    return CategoricalChart;
};




var $8T3gX = parcelRequire("8T3gX");

var $iVyaN = parcelRequire("iVyaN");


var $8T3gX = parcelRequire("8T3gX");



var $iVyaN = parcelRequire("iVyaN");












/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * If isValid is provided, all candidates must suffice the condition, else undefined is returned.
 * @param {T[]} array An input array.
 * @param {integer} n A number
 * @param {Function} isValid A function to evaluate a candidate form the array
 * @returns {T[]} The result array of the same type as the input array.
 */ function $fecef1cb6a332c56$export$41514b9f058a6886(array, n, isValid) {
    if (n < 1) return [];
    if (n === 1 && isValid === undefined) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        if (isValid === undefined || isValid(array[i]) === true) result.push(array[i]);
        else return undefined;
    }
    return result;
}


function $c3aab31a979daa17$export$a1966f4ad955c82b(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, $7d73999c8f418f71$export$3ee78d51cffc2b68)(size, angle);
}
function $c3aab31a979daa17$export$a257eb8806d5033d(viewBox, sign, sizeKey) {
    var isWidth = sizeKey === 'width';
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (sign === 1) return {
        start: isWidth ? x : y,
        end: isWidth ? x + width : y + height
    };
    return {
        start: isWidth ? x + width : y + height,
        end: isWidth ? x : y
    };
}
function $c3aab31a979daa17$export$795910f5f15a9633(sign, tickPosition, getSize, start, end) {
    /* Since getSize() is expensive (it reads the ticks' size from the DOM), we do this check first to avoid calculating
   * the tick's size. */ if (sign * tickPosition < sign * start || sign * tickPosition > sign * end) return false;
    var size = getSize();
    return sign * (tickPosition - sign * size / 2 - start) >= 0 && sign * (tickPosition + sign * size / 2 - end) <= 0;
}
function $c3aab31a979daa17$export$beeebbe3ff1b306b(ticks, interval) {
    return (0, $fecef1cb6a332c56$export$41514b9f058a6886)(ticks, interval + 1);
}




function $56b3eca4c98c365f$export$77bf2ab5711b7f99(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var initialStart = boundaries.start, end = boundaries.end;
    var index = 0;
    // Premature optimisation idea 1: Estimate a lower bound, and start from there.
    // For now, start from every tick
    var stepsize = 1;
    var start = initialStart;
    var _loop = function _loop() {
        // Given stepsize, evaluate whether every stepsize-th tick can be shown.
        // If it can not, then increase the stepsize by 1, and try again.
        var entry = ticks === null || ticks === void 0 ? void 0 : ticks[index];
        // Break condition - If we have evaluate all the ticks, then we are done.
        if (entry === undefined) return {
            v: (0, $fecef1cb6a332c56$export$41514b9f058a6886)(ticks, stepsize)
        };
        // Check if the element collides with the next element
        var i = index;
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        var tickCoord = entry.coordinate;
        // We will always show the first tick.
        var isShow = index === 0 || (0, $c3aab31a979daa17$export$795910f5f15a9633)(sign, tickCoord, getSize, start, end);
        if (!isShow) {
            // Start all over with a larger stepsize
            index = 0;
            start = initialStart;
            stepsize += 1;
        }
        if (isShow) {
            // If it can be shown, update the start
            start = tickCoord + sign * (getSize() / 2 + minTickGap);
            index += stepsize;
        }
    }, _ret;
    while(stepsize <= result.length){
        _ret = _loop();
        if (_ret) return _ret.v;
    }
    return [];
}


function $06aba9fe4ca08a60$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $06aba9fe4ca08a60$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $06aba9fe4ca08a60$var$_typeof(o);
}
function $06aba9fe4ca08a60$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $06aba9fe4ca08a60$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $06aba9fe4ca08a60$var$ownKeys(Object(t), !0).forEach(function(r) {
            $06aba9fe4ca08a60$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $06aba9fe4ca08a60$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $06aba9fe4ca08a60$var$_defineProperty(obj, key, value) {
    key = $06aba9fe4ca08a60$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $06aba9fe4ca08a60$var$_toPropertyKey(t) {
    var i = $06aba9fe4ca08a60$var$_toPrimitive(t, "string");
    return "symbol" == $06aba9fe4ca08a60$var$_typeof(i) ? i : i + "";
}
function $06aba9fe4ca08a60$var$_toPrimitive(t, r) {
    if ("object" != $06aba9fe4ca08a60$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $06aba9fe4ca08a60$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $06aba9fe4ca08a60$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start;
    var end = boundaries.end;
    var _loop = function _loop(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * getSize() / 2 - end);
            result[i] = entry = $06aba9fe4ca08a60$var$_objectSpread($06aba9fe4ca08a60$var$_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $06aba9fe4ca08a60$var$_objectSpread($06aba9fe4ca08a60$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $c3aab31a979daa17$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            end = entry.tickCoord - sign * (getSize() / 2 + minTickGap);
            result[i] = $06aba9fe4ca08a60$var$_objectSpread($06aba9fe4ca08a60$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = len - 1; i >= 0; i--)_loop(i);
    return result;
}
function $06aba9fe4ca08a60$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, preserveEnd) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start, end = boundaries.end;
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailSize = getTickSize(tail, len - 1);
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = $06aba9fe4ca08a60$var$_objectSpread($06aba9fe4ca08a60$var$_objectSpread({}, tail), {}, {
            tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        var isTailShow = (0, $c3aab31a979daa17$export$795910f5f15a9633)(sign, tail.tickCoord, function() {
            return tailSize;
        }, start, end);
        if (isTailShow) {
            end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
            result[len - 1] = $06aba9fe4ca08a60$var$_objectSpread($06aba9fe4ca08a60$var$_objectSpread({}, tail), {}, {
                isShow: true
            });
        }
    }
    var count = preserveEnd ? len - 1 : len;
    var _loop2 = function _loop2(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * getSize() / 2 - start);
            result[i] = entry = $06aba9fe4ca08a60$var$_objectSpread($06aba9fe4ca08a60$var$_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $06aba9fe4ca08a60$var$_objectSpread($06aba9fe4ca08a60$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $c3aab31a979daa17$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            start = entry.tickCoord + sign * (getSize() / 2 + minTickGap);
            result[i] = $06aba9fe4ca08a60$var$_objectSpread($06aba9fe4ca08a60$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = 0; i < count; i++)_loop2(i);
    return result;
}
function $06aba9fe4ca08a60$export$3d27d42b1034de5c(props, fontSize, letterSpacing) {
    var tick = props.tick, ticks = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit = props.unit, angle = props.angle;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, $ec351366ffe25ce6$export$7e4aa119212bc614)(interval) || (0, $809421885870cd36$export$98f03c5d19621d70).isSsr) return (0, $c3aab31a979daa17$export$beeebbe3ff1b306b)(ticks, typeof interval === 'number' && (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(interval) ? interval : 0);
    var candidates = [];
    var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
    var unitSize = unit && sizeKey === 'width' ? (0, $cf8622a67b6f7493$export$e5560531f057ad5d)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var getTickSize = function getTickSize(content, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(tickFormatter) ? tickFormatter(content.value, index) : content.value;
        // Recharts only supports angles when sizeKey === 'width'
        return sizeKey === 'width' ? (0, $c3aab31a979daa17$export$a1966f4ad955c82b)((0, $cf8622a67b6f7493$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $cf8622a67b6f7493$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
    };
    var sign = ticks.length >= 2 ? (0, $ec351366ffe25ce6$export$9d334328eb75e624)(ticks[1].coordinate - ticks[0].coordinate) : 1;
    var boundaries = (0, $c3aab31a979daa17$export$a257eb8806d5033d)(viewBox, sign, sizeKey);
    if (interval === 'equidistantPreserveStart') return (0, $56b3eca4c98c365f$export$77bf2ab5711b7f99)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === 'preserveStart' || interval === 'preserveStartEnd') candidates = $06aba9fe4ca08a60$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, interval === 'preserveStartEnd');
    else candidates = $06aba9fe4ca08a60$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap);
    return candidates.filter(function(entry) {
        return entry.isShow;
    });
}


var $3e6bf0cc5feb1dca$var$_excluded = [
    "viewBox"
], $3e6bf0cc5feb1dca$var$_excluded2 = [
    "viewBox"
], $3e6bf0cc5feb1dca$var$_excluded3 = [
    "ticks"
];
function $3e6bf0cc5feb1dca$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3e6bf0cc5feb1dca$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3e6bf0cc5feb1dca$var$_typeof(o);
}
function $3e6bf0cc5feb1dca$var$_extends() {
    $3e6bf0cc5feb1dca$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3e6bf0cc5feb1dca$var$_extends.apply(this, arguments);
}
function $3e6bf0cc5feb1dca$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3e6bf0cc5feb1dca$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3e6bf0cc5feb1dca$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3e6bf0cc5feb1dca$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3e6bf0cc5feb1dca$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3e6bf0cc5feb1dca$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3e6bf0cc5feb1dca$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3e6bf0cc5feb1dca$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $3e6bf0cc5feb1dca$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3e6bf0cc5feb1dca$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $3e6bf0cc5feb1dca$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $3e6bf0cc5feb1dca$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3e6bf0cc5feb1dca$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3e6bf0cc5feb1dca$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $3e6bf0cc5feb1dca$var$_callSuper(t, o, e) {
    return o = $3e6bf0cc5feb1dca$var$_getPrototypeOf(o), $3e6bf0cc5feb1dca$var$_possibleConstructorReturn(t, $3e6bf0cc5feb1dca$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $3e6bf0cc5feb1dca$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $3e6bf0cc5feb1dca$var$_possibleConstructorReturn(self, call) {
    if (call && ($3e6bf0cc5feb1dca$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $3e6bf0cc5feb1dca$var$_assertThisInitialized(self);
}
function $3e6bf0cc5feb1dca$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3e6bf0cc5feb1dca$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3e6bf0cc5feb1dca$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $3e6bf0cc5feb1dca$var$_getPrototypeOf(o) {
    $3e6bf0cc5feb1dca$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3e6bf0cc5feb1dca$var$_getPrototypeOf(o);
}
function $3e6bf0cc5feb1dca$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $3e6bf0cc5feb1dca$var$_setPrototypeOf(subClass, superClass);
}
function $3e6bf0cc5feb1dca$var$_setPrototypeOf(o, p) {
    $3e6bf0cc5feb1dca$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3e6bf0cc5feb1dca$var$_setPrototypeOf(o, p);
}
function $3e6bf0cc5feb1dca$var$_defineProperty(obj, key, value) {
    key = $3e6bf0cc5feb1dca$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3e6bf0cc5feb1dca$var$_toPropertyKey(t) {
    var i = $3e6bf0cc5feb1dca$var$_toPrimitive(t, "string");
    return "symbol" == $3e6bf0cc5feb1dca$var$_typeof(i) ? i : i + "";
}
function $3e6bf0cc5feb1dca$var$_toPrimitive(t, r) {
    if ("object" != $3e6bf0cc5feb1dca$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3e6bf0cc5feb1dca$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $3e6bf0cc5feb1dca$export$bdd99f2cdf352bae = /*#__PURE__*/ function(_Component) {
    function CartesianAxis(props) {
        var _this;
        $3e6bf0cc5feb1dca$var$_classCallCheck(this, CartesianAxis);
        _this = $3e6bf0cc5feb1dca$var$_callSuper(this, CartesianAxis, [
            props
        ]);
        _this.state = {
            fontSize: '',
            letterSpacing: ''
        };
        return _this;
    }
    $3e6bf0cc5feb1dca$var$_inherits(CartesianAxis, _Component);
    return $3e6bf0cc5feb1dca$var$_createClass(CartesianAxis, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref, nextState) {
                var viewBox = _ref.viewBox, restProps = $3e6bf0cc5feb1dca$var$_objectWithoutProperties(_ref, $3e6bf0cc5feb1dca$var$_excluded);
                // props.viewBox is sometimes generated every time -
                // check that specially as object equality is likely to fail
                var _this$props = this.props, viewBoxOld = _this$props.viewBox, restPropsOld = $3e6bf0cc5feb1dca$var$_objectWithoutProperties(_this$props, $3e6bf0cc5feb1dca$var$_excluded2);
                return !(0, $902ad73c142587a6$export$d36bdfa510afb180)(viewBox, viewBoxOld) || !(0, $902ad73c142587a6$export$d36bdfa510afb180)(restProps, restPropsOld) || !(0, $902ad73c142587a6$export$d36bdfa510afb180)(nextState, this.state);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var htmlLayer = this.layerReference;
                if (!htmlLayer) return;
                var tick = htmlLayer.getElementsByClassName('recharts-cartesian-axis-tick-value')[0];
                if (tick) this.setState({
                    fontSize: window.getComputedStyle(tick).fontSize,
                    letterSpacing: window.getComputedStyle(tick).letterSpacing
                });
            }
        },
        {
            key: "getTickLineCoord",
            value: function getTickLineCoord(data) {
                var _this$props2 = this.props, x = _this$props2.x, y = _this$props2.y, width = _this$props2.width, height = _this$props2.height, orientation = _this$props2.orientation, tickSize = _this$props2.tickSize, mirror = _this$props2.mirror, tickMargin = _this$props2.tickMargin;
                var x1, x2, y1, y2, tx, ty;
                var sign = mirror ? -1 : 1;
                var finalTickSize = data.tickSize || tickSize;
                var tickCoord = (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(data.tickCoord) ? data.tickCoord : data.coordinate;
                switch(orientation){
                    case 'top':
                        x1 = x2 = data.coordinate;
                        y2 = y + +!mirror * height;
                        y1 = y2 - sign * finalTickSize;
                        ty = y1 - sign * tickMargin;
                        tx = tickCoord;
                        break;
                    case 'left':
                        y1 = y2 = data.coordinate;
                        x2 = x + +!mirror * width;
                        x1 = x2 - sign * finalTickSize;
                        tx = x1 - sign * tickMargin;
                        ty = tickCoord;
                        break;
                    case 'right':
                        y1 = y2 = data.coordinate;
                        x2 = x + +mirror * width;
                        x1 = x2 + sign * finalTickSize;
                        tx = x1 + sign * tickMargin;
                        ty = tickCoord;
                        break;
                    default:
                        x1 = x2 = data.coordinate;
                        y2 = y + +mirror * height;
                        y1 = y2 + sign * finalTickSize;
                        ty = y1 + sign * tickMargin;
                        tx = tickCoord;
                        break;
                }
                return {
                    line: {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2
                    },
                    tick: {
                        x: tx,
                        y: ty
                    }
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var _this$props3 = this.props, orientation = _this$props3.orientation, mirror = _this$props3.mirror;
                var textAnchor;
                switch(orientation){
                    case 'left':
                        textAnchor = mirror ? 'start' : 'end';
                        break;
                    case 'right':
                        textAnchor = mirror ? 'end' : 'start';
                        break;
                    default:
                        textAnchor = 'middle';
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getTickVerticalAnchor",
            value: function getTickVerticalAnchor() {
                var _this$props4 = this.props, orientation = _this$props4.orientation, mirror = _this$props4.mirror;
                var verticalAnchor = 'end';
                switch(orientation){
                    case 'left':
                    case 'right':
                        verticalAnchor = 'middle';
                        break;
                    case 'top':
                        verticalAnchor = mirror ? 'start' : 'end';
                        break;
                    default:
                        verticalAnchor = mirror ? 'end' : 'start';
                        break;
                }
                return verticalAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, orientation = _this$props5.orientation, mirror = _this$props5.mirror, axisLine = _this$props5.axisLine;
                var props = $3e6bf0cc5feb1dca$var$_objectSpread($3e6bf0cc5feb1dca$var$_objectSpread($3e6bf0cc5feb1dca$var$_objectSpread({}, (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(this.props, false)), (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(axisLine, false)), {}, {
                    fill: 'none'
                });
                if (orientation === 'top' || orientation === 'bottom') {
                    var needHeight = +(orientation === 'top' && !mirror || orientation === 'bottom' && mirror);
                    props = $3e6bf0cc5feb1dca$var$_objectSpread($3e6bf0cc5feb1dca$var$_objectSpread({}, props), {}, {
                        x1: x,
                        y1: y + needHeight * height,
                        x2: x + width,
                        y2: y + needHeight * height
                    });
                } else {
                    var needWidth = +(orientation === 'left' && !mirror || orientation === 'right' && mirror);
                    props = $3e6bf0cc5feb1dca$var$_objectSpread($3e6bf0cc5feb1dca$var$_objectSpread({}, props), {}, {
                        x1: x + needWidth * width,
                        y1: y,
                        x2: x + needWidth * width,
                        y2: y + height
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("line", $3e6bf0cc5feb1dca$var$_extends({}, props, {
                    className: (0, $iVyaN.default)('recharts-cartesian-axis-line', (0, (/*@__PURE__*/$parcel$interopDefault($eb02300d30d6bdcb$exports)))(axisLine, 'className'))
                }));
            }
        },
        {
            key: "renderTicks",
            value: /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @param {string} fontSize Fontsize to consider for tick spacing
     * @param {string} letterSpacing Letterspacing to consider for tick spacing
     * @return {ReactComponent} renderedTicks
     */ function renderTicks(ticks, fontSize, letterSpacing) {
                var _this2 = this;
                var _this$props6 = this.props, tickLine = _this$props6.tickLine, stroke = _this$props6.stroke, tick = _this$props6.tick, tickFormatter = _this$props6.tickFormatter, unit = _this$props6.unit;
                var finalTicks = (0, $06aba9fe4ca08a60$export$3d27d42b1034de5c)($3e6bf0cc5feb1dca$var$_objectSpread($3e6bf0cc5feb1dca$var$_objectSpread({}, this.props), {}, {
                    ticks: ticks
                }), fontSize, letterSpacing);
                var textAnchor = this.getTickTextAnchor();
                var verticalAnchor = this.getTickVerticalAnchor();
                var axisProps = (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(this.props, false);
                var customTickProps = (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(tick, false);
                var tickLineProps = $3e6bf0cc5feb1dca$var$_objectSpread($3e6bf0cc5feb1dca$var$_objectSpread({}, axisProps), {}, {
                    fill: 'none'
                }, (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(tickLine, false));
                var items = finalTicks.map(function(entry, i) {
                    var _this2$getTickLineCoo = _this2.getTickLineCoord(entry), lineCoord = _this2$getTickLineCoo.line, tickCoord = _this2$getTickLineCoo.tick;
                    var tickProps = $3e6bf0cc5feb1dca$var$_objectSpread($3e6bf0cc5feb1dca$var$_objectSpread($3e6bf0cc5feb1dca$var$_objectSpread($3e6bf0cc5feb1dca$var$_objectSpread({
                        textAnchor: textAnchor,
                        verticalAnchor: verticalAnchor
                    }, axisProps), {}, {
                        stroke: 'none',
                        fill: stroke
                    }, customTickProps), tickCoord), {}, {
                        index: i,
                        payload: entry,
                        visibleTicksCount: finalTicks.length,
                        tickFormatter: tickFormatter
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $3366a7250677b47e$export$936d0764594b6eb3), $3e6bf0cc5feb1dca$var$_extends({
                        className: "recharts-cartesian-axis-tick",
                        key: "tick-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
                    }, (0, $a19170a4abc07995$export$ca62be0d67a3158c)(_this2.props, entry, i)), tickLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("line", $3e6bf0cc5feb1dca$var$_extends({}, tickLineProps, lineCoord, {
                        className: (0, $iVyaN.default)('recharts-cartesian-axis-tick-line', (0, (/*@__PURE__*/$parcel$interopDefault($eb02300d30d6bdcb$exports)))(tickLine, 'className'))
                    })), tick && CartesianAxis.renderTickItem(tick, tickProps, "".concat((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit || '')));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("g", {
                    className: "recharts-cartesian-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props7 = this.props, axisLine = _this$props7.axisLine, width = _this$props7.width, height = _this$props7.height, ticksGenerator = _this$props7.ticksGenerator, className = _this$props7.className, hide = _this$props7.hide;
                if (hide) return null;
                var _this$props8 = this.props, ticks = _this$props8.ticks, noTicksProps = $3e6bf0cc5feb1dca$var$_objectWithoutProperties(_this$props8, $3e6bf0cc5feb1dca$var$_excluded3);
                var finalTicks = ticks;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(ticksGenerator)) finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
                if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $3366a7250677b47e$export$936d0764594b6eb3), {
                    className: (0, $iVyaN.default)('recharts-cartesian-axis', className),
                    ref: function ref(_ref2) {
                        _this3.layerReference = _ref2;
                    }
                }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks, this.state.fontSize, this.state.letterSpacing), (0, $eb6f3b719cc1691f$export$b04be29aa201d4f5).renderCallByParent(this.props));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                var combinedClassName = (0, $iVyaN.default)(props.className, 'recharts-cartesian-axis-tick-value');
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(option, $3e6bf0cc5feb1dca$var$_objectSpread($3e6bf0cc5feb1dca$var$_objectSpread({}, props), {}, {
                    className: combinedClassName
                }));
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(option)) tickItem = option($3e6bf0cc5feb1dca$var$_objectSpread($3e6bf0cc5feb1dca$var$_objectSpread({}, props), {}, {
                    className: combinedClassName
                }));
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, $46eed3e26c0880f0$export$5f1af8db9871e1d6), $3e6bf0cc5feb1dca$var$_extends({}, props, {
                    className: "recharts-cartesian-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
}((0, $8T3gX.Component));
$3e6bf0cc5feb1dca$var$_defineProperty($3e6bf0cc5feb1dca$export$bdd99f2cdf352bae, "displayName", 'CartesianAxis');
$3e6bf0cc5feb1dca$var$_defineProperty($3e6bf0cc5feb1dca$export$bdd99f2cdf352bae, "defaultProps", {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: 'bottom',
    // The ticks
    ticks: [],
    stroke: '#666',
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: 'preserveEnd'
});



function $e3fbaf009dcc8585$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e3fbaf009dcc8585$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e3fbaf009dcc8585$var$_typeof(o);
}
function $e3fbaf009dcc8585$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e3fbaf009dcc8585$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e3fbaf009dcc8585$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $e3fbaf009dcc8585$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e3fbaf009dcc8585$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e3fbaf009dcc8585$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e3fbaf009dcc8585$var$_callSuper(t, o, e) {
    return o = $e3fbaf009dcc8585$var$_getPrototypeOf(o), $e3fbaf009dcc8585$var$_possibleConstructorReturn(t, $e3fbaf009dcc8585$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $e3fbaf009dcc8585$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $e3fbaf009dcc8585$var$_possibleConstructorReturn(self, call) {
    if (call && ($e3fbaf009dcc8585$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $e3fbaf009dcc8585$var$_assertThisInitialized(self);
}
function $e3fbaf009dcc8585$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e3fbaf009dcc8585$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e3fbaf009dcc8585$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $e3fbaf009dcc8585$var$_getPrototypeOf(o) {
    $e3fbaf009dcc8585$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e3fbaf009dcc8585$var$_getPrototypeOf(o);
}
function $e3fbaf009dcc8585$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $e3fbaf009dcc8585$var$_setPrototypeOf(subClass, superClass);
}
function $e3fbaf009dcc8585$var$_setPrototypeOf(o, p) {
    $e3fbaf009dcc8585$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e3fbaf009dcc8585$var$_setPrototypeOf(o, p);
}
function $e3fbaf009dcc8585$var$_defineProperty(obj, key, value) {
    key = $e3fbaf009dcc8585$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e3fbaf009dcc8585$var$_toPropertyKey(t) {
    var i = $e3fbaf009dcc8585$var$_toPrimitive(t, "string");
    return "symbol" == $e3fbaf009dcc8585$var$_typeof(i) ? i : i + "";
}
function $e3fbaf009dcc8585$var$_toPrimitive(t, r) {
    if ("object" != $e3fbaf009dcc8585$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $e3fbaf009dcc8585$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $e3fbaf009dcc8585$var$_extends() {
    $e3fbaf009dcc8585$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e3fbaf009dcc8585$var$_extends.apply(this, arguments);
}
/** Define of XAxis props */ function $e3fbaf009dcc8585$var$XAxisImpl(_ref) {
    var xAxisId = _ref.xAxisId;
    var width = (0, $aaec315a6c49009f$export$8854f7ece606854b)();
    var height = (0, $aaec315a6c49009f$export$369ae257969c6f9f)();
    var axisOptions = (0, $aaec315a6c49009f$export$54f54805c81085c5)(xAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    $8T3gX.createElement((0, $3e6bf0cc5feb1dca$export$bdd99f2cdf352bae), $e3fbaf009dcc8585$var$_extends({}, axisOptions, {
        className: (0, $iVyaN.default)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, $bc60c84815913bd8$export$c829ee42daf7f66d)(axis, true);
        }
    })));
}
var $e3fbaf009dcc8585$export$ea77231de273b52d = /*#__PURE__*/ function(_React$Component) {
    function XAxis() {
        $e3fbaf009dcc8585$var$_classCallCheck(this, XAxis);
        return $e3fbaf009dcc8585$var$_callSuper(this, XAxis, arguments);
    }
    $e3fbaf009dcc8585$var$_inherits(XAxis, _React$Component);
    return $e3fbaf009dcc8585$var$_createClass(XAxis, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ $8T3gX.createElement($e3fbaf009dcc8585$var$XAxisImpl, this.props);
            }
        }
    ]);
}($8T3gX.Component);
$e3fbaf009dcc8585$var$_defineProperty($e3fbaf009dcc8585$export$ea77231de273b52d, "displayName", 'XAxis');
$e3fbaf009dcc8585$var$_defineProperty($e3fbaf009dcc8585$export$ea77231de273b52d, "defaultProps", {
    allowDecimals: true,
    hide: false,
    orientation: 'bottom',
    width: 0,
    height: 30,
    mirror: false,
    xAxisId: 0,
    tickCount: 5,
    type: 'category',
    padding: {
        left: 0,
        right: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false,
    allowDuplicatedCategory: true
});



var $8T3gX = parcelRequire("8T3gX");

var $iVyaN = parcelRequire("iVyaN");



function $c7554316bfb1649b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c7554316bfb1649b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c7554316bfb1649b$var$_typeof(o);
}
function $c7554316bfb1649b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c7554316bfb1649b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c7554316bfb1649b$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c7554316bfb1649b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c7554316bfb1649b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c7554316bfb1649b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c7554316bfb1649b$var$_callSuper(t, o, e) {
    return o = $c7554316bfb1649b$var$_getPrototypeOf(o), $c7554316bfb1649b$var$_possibleConstructorReturn(t, $c7554316bfb1649b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $c7554316bfb1649b$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $c7554316bfb1649b$var$_possibleConstructorReturn(self, call) {
    if (call && ($c7554316bfb1649b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $c7554316bfb1649b$var$_assertThisInitialized(self);
}
function $c7554316bfb1649b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c7554316bfb1649b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c7554316bfb1649b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $c7554316bfb1649b$var$_getPrototypeOf(o) {
    $c7554316bfb1649b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c7554316bfb1649b$var$_getPrototypeOf(o);
}
function $c7554316bfb1649b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $c7554316bfb1649b$var$_setPrototypeOf(subClass, superClass);
}
function $c7554316bfb1649b$var$_setPrototypeOf(o, p) {
    $c7554316bfb1649b$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c7554316bfb1649b$var$_setPrototypeOf(o, p);
}
function $c7554316bfb1649b$var$_defineProperty(obj, key, value) {
    key = $c7554316bfb1649b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c7554316bfb1649b$var$_toPropertyKey(t) {
    var i = $c7554316bfb1649b$var$_toPrimitive(t, "string");
    return "symbol" == $c7554316bfb1649b$var$_typeof(i) ? i : i + "";
}
function $c7554316bfb1649b$var$_toPrimitive(t, r) {
    if ("object" != $c7554316bfb1649b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c7554316bfb1649b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c7554316bfb1649b$var$_extends() {
    $c7554316bfb1649b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c7554316bfb1649b$var$_extends.apply(this, arguments);
}
var $c7554316bfb1649b$var$YAxisImpl = function YAxisImpl(_ref) {
    var yAxisId = _ref.yAxisId;
    var width = (0, $aaec315a6c49009f$export$8854f7ece606854b)();
    var height = (0, $aaec315a6c49009f$export$369ae257969c6f9f)();
    var axisOptions = (0, $aaec315a6c49009f$export$6f8958021ad81c20)(yAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    $8T3gX.createElement((0, $3e6bf0cc5feb1dca$export$bdd99f2cdf352bae), $c7554316bfb1649b$var$_extends({}, axisOptions, {
        className: (0, $iVyaN.default)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, $bc60c84815913bd8$export$c829ee42daf7f66d)(axis, true);
        }
    })));
};
var $c7554316bfb1649b$export$f96c4024c52de8f4 = /*#__PURE__*/ function(_React$Component) {
    function YAxis() {
        $c7554316bfb1649b$var$_classCallCheck(this, YAxis);
        return $c7554316bfb1649b$var$_callSuper(this, YAxis, arguments);
    }
    $c7554316bfb1649b$var$_inherits(YAxis, _React$Component);
    return $c7554316bfb1649b$var$_createClass(YAxis, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ $8T3gX.createElement($c7554316bfb1649b$var$YAxisImpl, this.props);
            }
        }
    ]);
}($8T3gX.Component);
$c7554316bfb1649b$var$_defineProperty($c7554316bfb1649b$export$f96c4024c52de8f4, "displayName", 'YAxis');
$c7554316bfb1649b$var$_defineProperty($c7554316bfb1649b$export$f96c4024c52de8f4, "defaultProps", {
    allowDuplicatedCategory: true,
    allowDecimals: true,
    hide: false,
    orientation: 'left',
    width: 60,
    height: 0,
    mirror: false,
    yAxisId: 0,
    tickCount: 5,
    type: 'number',
    padding: {
        top: 0,
        bottom: 0
    },
    allowDataOverflow: false,
    scale: 'auto',
    reversed: false
});



var $dc284d0fb10e6f6a$export$94aefc399ef206a9 = (0, $c6b16af6ccfd04cd$export$77871aede60e6838)({
    chartName: 'BarChart',
    GraphicalChild: (0, $7d5fe63ca2eb078d$export$bbc6c6369b38e3d1),
    defaultTooltipEventType: 'axis',
    validateTooltipEventTypes: [
        'axis',
        'item'
    ],
    axisComponents: [
        {
            axisType: 'xAxis',
            AxisComp: (0, $e3fbaf009dcc8585$export$ea77231de273b52d)
        },
        {
            axisType: 'yAxis',
            AxisComp: (0, $c7554316bfb1649b$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $7d73999c8f418f71$export$ece7de1383db5ac)
});


var $8T3gX = parcelRequire("8T3gX");








var $381060c808bbe825$var$_excluded = [
    "x1",
    "y1",
    "x2",
    "y2",
    "key"
], $381060c808bbe825$var$_excluded2 = [
    "offset"
];
function $381060c808bbe825$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $381060c808bbe825$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $381060c808bbe825$var$_typeof(o);
}
function $381060c808bbe825$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $381060c808bbe825$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $381060c808bbe825$var$ownKeys(Object(t), !0).forEach(function(r) {
            $381060c808bbe825$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $381060c808bbe825$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $381060c808bbe825$var$_defineProperty(obj, key, value) {
    key = $381060c808bbe825$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $381060c808bbe825$var$_toPropertyKey(t) {
    var i = $381060c808bbe825$var$_toPrimitive(t, "string");
    return "symbol" == $381060c808bbe825$var$_typeof(i) ? i : i + "";
}
function $381060c808bbe825$var$_toPrimitive(t, r) {
    if ("object" != $381060c808bbe825$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $381060c808bbe825$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $381060c808bbe825$var$_extends() {
    $381060c808bbe825$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $381060c808bbe825$var$_extends.apply(this, arguments);
}
function $381060c808bbe825$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $381060c808bbe825$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $381060c808bbe825$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * The <CartesianGrid horizontal
 */ var $381060c808bbe825$var$Background = function Background(props) {
    var fill = props.fill;
    if (!fill || fill === 'none') return null;
    var fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, ry = props.ry;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("rect", {
        x: x,
        y: y,
        ry: ry,
        width: width,
        height: height,
        stroke: "none",
        fill: fill,
        fillOpacity: fillOpacity,
        className: "recharts-cartesian-grid-bg"
    });
};
function $381060c808bbe825$var$renderLineItem(option, props) {
    var lineItem;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).isValidElement(option)) // @ts-expect-error typescript does not see the props type when cloning an element
    lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(option)) lineItem = option(props);
    else {
        var x1 = props.x1, y1 = props.y1, x2 = props.x2, y2 = props.y2, key = props.key, others = $381060c808bbe825$var$_objectWithoutProperties(props, $381060c808bbe825$var$_excluded);
        var _filterProps = (0, $10636f1b3e62ab88$export$d697c39a2985a4c)(others, false), __ = _filterProps.offset, restOfFilteredProps = $381060c808bbe825$var$_objectWithoutProperties(_filterProps, $381060c808bbe825$var$_excluded2);
        lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("line", $381060c808bbe825$var$_extends({}, restOfFilteredProps, {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            fill: "none",
            key: key
        }));
    }
    return lineItem;
}
function $381060c808bbe825$var$HorizontalGridLines(props) {
    var x = props.x, width = props.width, _props$horizontal = props.horizontal, horizontal = _props$horizontal === void 0 ? true : _props$horizontal, horizontalPoints = props.horizontalPoints;
    if (!horizontal || !horizontalPoints || !horizontalPoints.length) return null;
    var items = horizontalPoints.map(function(entry, i) {
        var lineItemProps = $381060c808bbe825$var$_objectSpread($381060c808bbe825$var$_objectSpread({}, props), {}, {
            x1: x,
            y1: entry,
            x2: x + width,
            y2: entry,
            key: "line-".concat(i),
            index: i
        });
        return $381060c808bbe825$var$renderLineItem(horizontal, lineItemProps);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("g", {
        className: "recharts-cartesian-grid-horizontal"
    }, items);
}
function $381060c808bbe825$var$VerticalGridLines(props) {
    var y = props.y, height = props.height, _props$vertical = props.vertical, vertical = _props$vertical === void 0 ? true : _props$vertical, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalPoints || !verticalPoints.length) return null;
    var items = verticalPoints.map(function(entry, i) {
        var lineItemProps = $381060c808bbe825$var$_objectSpread($381060c808bbe825$var$_objectSpread({}, props), {}, {
            x1: entry,
            y1: y,
            x2: entry,
            y2: y + height,
            key: "line-".concat(i),
            index: i
        });
        return $381060c808bbe825$var$renderLineItem(vertical, lineItemProps);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("g", {
        className: "recharts-cartesian-grid-vertical"
    }, items);
}
function $381060c808bbe825$var$HorizontalStripes(props) {
    var horizontalFill = props.horizontalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, horizontalPoints = props.horizontalPoints, _props$horizontal2 = props.horizontal, horizontal = _props$horizontal2 === void 0 ? true : _props$horizontal2;
    if (!horizontal || !horizontalFill || !horizontalFill.length) return null;
    // Why =y -y? I was trying to find any difference that this makes, with floating point numbers and edge cases but ... nothing.
    var roundedSortedHorizontalPoints = horizontalPoints.map(function(e) {
        return Math.round(e + y - y);
    }).sort(function(a, b) {
        return a - b;
    });
    // Why is this condition `!==` instead of `<=` ?
    if (y !== roundedSortedHorizontalPoints[0]) roundedSortedHorizontalPoints.unshift(0);
    var items = roundedSortedHorizontalPoints.map(function(entry, i) {
        // Why do we strip only the last stripe if it is invisible, and not all invisible stripes?
        var lastStripe = !roundedSortedHorizontalPoints[i + 1];
        var lineHeight = lastStripe ? y + height - entry : roundedSortedHorizontalPoints[i + 1] - entry;
        if (lineHeight <= 0) return null;
        var colorIndex = i % horizontalFill.length;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            y: entry,
            x: x,
            height: lineHeight,
            width: width,
            stroke: "none",
            fill: horizontalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("g", {
        className: "recharts-cartesian-gridstripes-horizontal"
    }, items);
}
function $381060c808bbe825$var$VerticalStripes(props) {
    var _props$vertical2 = props.vertical, vertical = _props$vertical2 === void 0 ? true : _props$vertical2, verticalFill = props.verticalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalFill || !verticalFill.length) return null;
    var roundedSortedVerticalPoints = verticalPoints.map(function(e) {
        return Math.round(e + x - x);
    }).sort(function(a, b) {
        return a - b;
    });
    if (x !== roundedSortedVerticalPoints[0]) roundedSortedVerticalPoints.unshift(0);
    var items = roundedSortedVerticalPoints.map(function(entry, i) {
        var lastStripe = !roundedSortedVerticalPoints[i + 1];
        var lineWidth = lastStripe ? x + width - entry : roundedSortedVerticalPoints[i + 1] - entry;
        if (lineWidth <= 0) return null;
        var colorIndex = i % verticalFill.length;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            x: entry,
            y: y,
            width: lineWidth,
            height: height,
            stroke: "none",
            fill: verticalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("g", {
        className: "recharts-cartesian-gridstripes-vertical"
    }, items);
}
var $381060c808bbe825$var$defaultVerticalCoordinatesGenerator = function defaultVerticalCoordinatesGenerator(_ref, syncWithTicks) {
    var xAxis = _ref.xAxis, width = _ref.width, height = _ref.height, offset = _ref.offset;
    return (0, $bc60c84815913bd8$export$846dc5ac5fecff74)((0, $06aba9fe4ca08a60$export$3d27d42b1034de5c)($381060c808bbe825$var$_objectSpread($381060c808bbe825$var$_objectSpread($381060c808bbe825$var$_objectSpread({}, (0, $3e6bf0cc5feb1dca$export$bdd99f2cdf352bae).defaultProps), xAxis), {}, {
        ticks: (0, $bc60c84815913bd8$export$c829ee42daf7f66d)(xAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.left, offset.left + offset.width, syncWithTicks);
};
var $381060c808bbe825$var$defaultHorizontalCoordinatesGenerator = function defaultHorizontalCoordinatesGenerator(_ref2, syncWithTicks) {
    var yAxis = _ref2.yAxis, width = _ref2.width, height = _ref2.height, offset = _ref2.offset;
    return (0, $bc60c84815913bd8$export$846dc5ac5fecff74)((0, $06aba9fe4ca08a60$export$3d27d42b1034de5c)($381060c808bbe825$var$_objectSpread($381060c808bbe825$var$_objectSpread($381060c808bbe825$var$_objectSpread({}, (0, $3e6bf0cc5feb1dca$export$bdd99f2cdf352bae).defaultProps), yAxis), {}, {
        ticks: (0, $bc60c84815913bd8$export$c829ee42daf7f66d)(yAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.top, offset.top + offset.height, syncWithTicks);
};
var $381060c808bbe825$var$defaultProps = {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: '#ccc',
    fill: 'none',
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: []
};
function $381060c808bbe825$export$6440e27b9f186856(props) {
    var _props$stroke, _props$fill, _props$horizontal3, _props$horizontalFill, _props$vertical3, _props$verticalFill;
    var chartWidth = (0, $aaec315a6c49009f$export$8854f7ece606854b)();
    var chartHeight = (0, $aaec315a6c49009f$export$369ae257969c6f9f)();
    var offset = (0, $aaec315a6c49009f$export$99e5207fa7e69f17)();
    var propsIncludingDefaults = $381060c808bbe825$var$_objectSpread($381060c808bbe825$var$_objectSpread({}, props), {}, {
        stroke: (_props$stroke = props.stroke) !== null && _props$stroke !== void 0 ? _props$stroke : $381060c808bbe825$var$defaultProps.stroke,
        fill: (_props$fill = props.fill) !== null && _props$fill !== void 0 ? _props$fill : $381060c808bbe825$var$defaultProps.fill,
        horizontal: (_props$horizontal3 = props.horizontal) !== null && _props$horizontal3 !== void 0 ? _props$horizontal3 : $381060c808bbe825$var$defaultProps.horizontal,
        horizontalFill: (_props$horizontalFill = props.horizontalFill) !== null && _props$horizontalFill !== void 0 ? _props$horizontalFill : $381060c808bbe825$var$defaultProps.horizontalFill,
        vertical: (_props$vertical3 = props.vertical) !== null && _props$vertical3 !== void 0 ? _props$vertical3 : $381060c808bbe825$var$defaultProps.vertical,
        verticalFill: (_props$verticalFill = props.verticalFill) !== null && _props$verticalFill !== void 0 ? _props$verticalFill : $381060c808bbe825$var$defaultProps.verticalFill,
        x: (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(props.x) ? props.x : offset.left,
        y: (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(props.y) ? props.y : offset.top,
        width: (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(props.width) ? props.width : offset.width,
        height: (0, $ec351366ffe25ce6$export$7e4aa119212bc614)(props.height) ? props.height : offset.height
    });
    var x = propsIncludingDefaults.x, y = propsIncludingDefaults.y, width = propsIncludingDefaults.width, height = propsIncludingDefaults.height, syncWithTicks = propsIncludingDefaults.syncWithTicks, horizontalValues = propsIncludingDefaults.horizontalValues, verticalValues = propsIncludingDefaults.verticalValues;
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var xAxis = (0, $aaec315a6c49009f$export$1d855c2865750a72)();
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var yAxis = (0, $aaec315a6c49009f$export$631ee617f1052e16)();
    if (!(0, $ec351366ffe25ce6$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $ec351366ffe25ce6$export$7e4aa119212bc614)(height) || height <= 0 || !(0, $ec351366ffe25ce6$export$7e4aa119212bc614)(x) || x !== +x || !(0, $ec351366ffe25ce6$export$7e4aa119212bc614)(y) || y !== +y) return null;
    /*
   * verticalCoordinatesGenerator and horizontalCoordinatesGenerator are defined
   * outside of the propsIncludingDefaults because they were never part of the original props
   * and they were never passed as a prop down to horizontal/vertical custom elements.
   * If we add these two to propsIncludingDefaults then we are changing public API.
   * Not a bad thing per se but also not necessary.
   */ var verticalCoordinatesGenerator = propsIncludingDefaults.verticalCoordinatesGenerator || $381060c808bbe825$var$defaultVerticalCoordinatesGenerator;
    var horizontalCoordinatesGenerator = propsIncludingDefaults.horizontalCoordinatesGenerator || $381060c808bbe825$var$defaultHorizontalCoordinatesGenerator;
    var horizontalPoints = propsIncludingDefaults.horizontalPoints, verticalPoints = propsIncludingDefaults.verticalPoints;
    // No horizontal points are specified
    if ((!horizontalPoints || !horizontalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(horizontalCoordinatesGenerator)) {
        var isHorizontalValues = horizontalValues && horizontalValues.length;
        var generatorResult = horizontalCoordinatesGenerator({
            yAxis: yAxis ? $381060c808bbe825$var$_objectSpread($381060c808bbe825$var$_objectSpread({}, yAxis), {}, {
                ticks: isHorizontalValues ? horizontalValues : yAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isHorizontalValues ? true : syncWithTicks);
        (0, $a1b0f3d7b382d4a4$export$c106dd0671a0fc2d)(Array.isArray(generatorResult), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat($381060c808bbe825$var$_typeof(generatorResult), "]"));
        if (Array.isArray(generatorResult)) horizontalPoints = generatorResult;
    }
    // No vertical points are specified
    if ((!verticalPoints || !verticalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($cd41833a2a331f63$exports)))(verticalCoordinatesGenerator)) {
        var isVerticalValues = verticalValues && verticalValues.length;
        var _generatorResult = verticalCoordinatesGenerator({
            xAxis: xAxis ? $381060c808bbe825$var$_objectSpread($381060c808bbe825$var$_objectSpread({}, xAxis), {}, {
                ticks: isVerticalValues ? verticalValues : xAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isVerticalValues ? true : syncWithTicks);
        (0, $a1b0f3d7b382d4a4$export$c106dd0671a0fc2d)(Array.isArray(_generatorResult), "verticalCoordinatesGenerator should return Array but instead it returned [".concat($381060c808bbe825$var$_typeof(_generatorResult), "]"));
        if (Array.isArray(_generatorResult)) verticalPoints = _generatorResult;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("g", {
        className: "recharts-cartesian-grid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement($381060c808bbe825$var$Background, {
        fill: propsIncludingDefaults.fill,
        fillOpacity: propsIncludingDefaults.fillOpacity,
        x: propsIncludingDefaults.x,
        y: propsIncludingDefaults.y,
        width: propsIncludingDefaults.width,
        height: propsIncludingDefaults.height,
        ry: propsIncludingDefaults.ry
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement($381060c808bbe825$var$HorizontalGridLines, $381060c808bbe825$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        horizontalPoints: horizontalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement($381060c808bbe825$var$VerticalGridLines, $381060c808bbe825$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        verticalPoints: verticalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement($381060c808bbe825$var$HorizontalStripes, $381060c808bbe825$var$_extends({}, propsIncludingDefaults, {
        horizontalPoints: horizontalPoints
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement($381060c808bbe825$var$VerticalStripes, $381060c808bbe825$var$_extends({}, propsIncludingDefaults, {
        verticalPoints: verticalPoints
    })));
}
$381060c808bbe825$export$6440e27b9f186856.displayName = 'CartesianGrid';


var $iVyaN = parcelRequire("iVyaN");

var $8T3gX = parcelRequire("8T3gX");




function $0deeafe8345931ee$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0deeafe8345931ee$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0deeafe8345931ee$var$_typeof(o);
}
function $0deeafe8345931ee$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0deeafe8345931ee$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0deeafe8345931ee$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0deeafe8345931ee$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0deeafe8345931ee$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0deeafe8345931ee$var$_defineProperty(obj, key, value) {
    key = $0deeafe8345931ee$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0deeafe8345931ee$var$_toPropertyKey(t) {
    var i = $0deeafe8345931ee$var$_toPrimitive(t, "string");
    return "symbol" == $0deeafe8345931ee$var$_typeof(i) ? i : i + "";
}
function $0deeafe8345931ee$var$_toPrimitive(t, r) {
    if ("object" != $0deeafe8345931ee$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0deeafe8345931ee$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0deeafe8345931ee$var$_slicedToArray(arr, i) {
    return $0deeafe8345931ee$var$_arrayWithHoles(arr) || $0deeafe8345931ee$var$_iterableToArrayLimit(arr, i) || $0deeafe8345931ee$var$_unsupportedIterableToArray(arr, i) || $0deeafe8345931ee$var$_nonIterableRest();
}
function $0deeafe8345931ee$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0deeafe8345931ee$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0deeafe8345931ee$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0deeafe8345931ee$var$_arrayLikeToArray(o, minLen);
}
function $0deeafe8345931ee$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0deeafe8345931ee$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $0deeafe8345931ee$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $0deeafe8345931ee$export$e60a4704009a0009 = /*#__PURE__*/ (0, $8T3gX.forwardRef)(function(_ref, ref) {
    var aspect = _ref.aspect, _ref$initialDimension = _ref.initialDimension, initialDimension = _ref$initialDimension === void 0 ? {
        width: -1,
        height: -1
    } : _ref$initialDimension, _ref$width = _ref.width, width = _ref$width === void 0 ? '100%' : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? '100%' : _ref$height, _ref$minWidth = _ref.minWidth, minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, children = _ref.children, _ref$debounce = _ref.debounce, debounce = _ref$debounce === void 0 ? 0 : _ref$debounce, id = _ref.id, className = _ref.className, onResize = _ref.onResize, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style;
    var containerRef = (0, $8T3gX.useRef)(null);
    var onResizeRef = (0, $8T3gX.useRef)();
    onResizeRef.current = onResize;
    (0, $8T3gX.useImperativeHandle)(ref, function() {
        return Object.defineProperty(containerRef.current, 'current', {
            get: function get() {
                // eslint-disable-next-line no-console
                console.warn('The usage of ref.current.current is deprecated and will no longer be supported.');
                return containerRef.current;
            },
            configurable: true
        });
    });
    var _useState = (0, $8T3gX.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    }), _useState2 = $0deeafe8345931ee$var$_slicedToArray(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
    var setContainerSize = (0, $8T3gX.useCallback)(function(newWidth, newHeight) {
        setSizes(function(prevState) {
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    (0, $8T3gX.useEffect)(function() {
        var callback = function callback(entries) {
            var _onResizeRef$current;
            var _entries$0$contentRec = entries[0].contentRect, containerWidth = _entries$0$contentRec.width, containerHeight = _entries$0$contentRec.height;
            setContainerSize(containerWidth, containerHeight);
            (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth, containerHeight);
        };
        if (debounce > 0) callback = (0, (/*@__PURE__*/$parcel$interopDefault($ad4be26b64041d02$exports)))(callback, debounce, {
            trailing: true,
            leading: false
        });
        var observer = new ResizeObserver(callback);
        var _containerRef$current = containerRef.current.getBoundingClientRect(), containerWidth = _containerRef$current.width, containerHeight = _containerRef$current.height;
        setContainerSize(containerWidth, containerHeight);
        observer.observe(containerRef.current);
        return function() {
            observer.disconnect();
        };
    }, [
        setContainerSize,
        debounce
    ]);
    var chartContent = (0, $8T3gX.useMemo)(function() {
        var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
        if (containerWidth < 0 || containerHeight < 0) return null;
        (0, $a1b0f3d7b382d4a4$export$c106dd0671a0fc2d)((0, $ec351366ffe25ce6$export$e50269385c77c348)(width) || (0, $ec351366ffe25ce6$export$e50269385c77c348)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
        (0, $a1b0f3d7b382d4a4$export$c106dd0671a0fc2d)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
        var calculatedWidth = (0, $ec351366ffe25ce6$export$e50269385c77c348)(width) ? containerWidth : width;
        var calculatedHeight = (0, $ec351366ffe25ce6$export$e50269385c77c348)(height) ? containerHeight : height;
        if (aspect && aspect > 0) {
            // Preserve the desired aspect ratio
            if (calculatedWidth) // Will default to using width for aspect ratio
            calculatedHeight = calculatedWidth / aspect;
            else if (calculatedHeight) // But we should also take height into consideration
            calculatedWidth = calculatedHeight * aspect;
            // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
            if (maxHeight && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
        }
        (0, $a1b0f3d7b382d4a4$export$c106dd0671a0fc2d)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
        var isCharts = !Array.isArray(children) && (0, $10636f1b3e62ab88$export$be63e0664592e141)(children.type).endsWith('Chart');
        return (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.map(children, function(child) {
            if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).isValidElement(child)) return /*#__PURE__*/ (0, $8T3gX.cloneElement)(child, $0deeafe8345931ee$var$_objectSpread({
                width: calculatedWidth,
                height: calculatedHeight
            }, isCharts ? {
                style: $0deeafe8345931ee$var$_objectSpread({
                    height: '100%',
                    width: '100%',
                    maxHeight: calculatedHeight,
                    maxWidth: calculatedWidth
                }, child.props.style)
            } : {}));
            return child;
        });
    }, [
        aspect,
        children,
        height,
        maxHeight,
        minHeight,
        minWidth,
        sizes,
        width
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement("div", {
        id: id ? "".concat(id) : undefined,
        className: (0, $iVyaN.default)('recharts-responsive-container', className),
        style: $0deeafe8345931ee$var$_objectSpread($0deeafe8345931ee$var$_objectSpread({}, style), {}, {
            width: width,
            height: height,
            minWidth: minWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        }),
        ref: containerRef
    }, chartContent);
});


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");


var $8jTCz = parcelRequire("8jTCz");
var $9222626528c451ae$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($9222626528c451ae$exports, "__esModule", {
    value: true
});
$9222626528c451ae$exports.default = void 0;

var $9222626528c451ae$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $9222626528c451ae$var$_default = $9222626528c451ae$exports.default = (0, $9222626528c451ae$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4z"
}), 'Refresh');


const $fa0213fde50de9cb$export$7fc3a82a5d676bd8 = ()=>{
    const { usageData: usageData, currentData: currentData, setCurrentData: setCurrentData, dateRangeName: dateRangeName, setDateRangeName: setDateRangeName, dataIsLoading: dataIsLoading, setDataIsLoading: setDataIsLoading, errorFetchingUsageData: errorFetchingUsageData, setTypeString: setTypeString, setDateRangeString: setDateRangeString, getDataUsageData: getDataUsageData } = (0, $ad6781d64ea9d765$export$176f58333fc13682)();
    const retryText = /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9222626528c451ae$exports))), {
                fontSize: "small"
            }),
            "\xa0Retry"
        ]
    });
    const navigate = (0, $3T949.useNavigate)();
    const [anchorEl, setAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [last5AnchorEl, setLast5AnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [last5Name, setLast5Name] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("Data Usage");
    const open = Boolean(anchorEl);
    const last5Open = Boolean(last5AnchorEl);
    const [rangeChoices, setRangeChoices] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const dataUsageAlertVolumeArray = [
        {
            name: "Data Usage",
            value: "bandwidth"
        },
        {
            name: "Alert Volume",
            value: "alert_volume"
        }
    ];
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (localStorage.rangeChoices) setRangeChoices(JSON.parse(localStorage.rangeChoices));
    }, []);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const handleLast5Click = (event)=>{
        setLast5AnchorEl(event.currentTarget);
    };
    const handleLast5Close = ()=>{
        setLast5AnchorEl(null);
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "w-full min-w-0 bg-white px-4 pt-4 pb-5 sm:px-6",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex flex-wrap items-center justify-between gap-2",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "text-actuate-blue font-mulish text-[26px] font-bold",
                        children: "Data Usage vs Alert Volume"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "text-actuate-blue font-mulish text-[16px]",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                id: "time-frame-selector",
                                "aria-controls": open ? "time-frame-menu" : undefined,
                                "aria-haspopup": "true",
                                "aria-expanded": open ? "true" : undefined,
                                onClick: handleClick,
                                children: dateRangeName
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1fWBE.default), {
                                id: "time-frame-menu",
                                anchorEl: anchorEl,
                                open: open,
                                onClose: handleClose,
                                MenuListProps: {
                                    "aria-labelledby": "time-frame-selector"
                                },
                                children: rangeChoices.map((rangeChoiceObject)=>{
                                    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: ()=>{
                                            const timeChoiceValues = new Map();
                                            dataUsageAlertVolumeArray.forEach((option)=>{
                                                timeChoiceValues.set(`${option.name}`, `${option.value}`);
                                            });
                                            setDateRangeName(rangeChoiceObject.name);
                                            setDateRangeString(rangeChoiceObject.value);
                                            setDataIsLoading(true);
                                            handleClose();
                                            getDataUsageData(navigate);
                                        },
                                        children: rangeChoiceObject.name
                                    }, rangeChoiceObject.value);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex flex-wrap items-center",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "text-actuate-blue font-mulish text-[16px]",
                        children: "Sort Top 5 Sites by"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "text-actuate-blue font-mulish text-[16px]",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                id: "sort-type-selector",
                                "aria-controls": last5Open ? "sort-type-menu" : undefined,
                                "aria-haspopup": "true",
                                "aria-expanded": last5Open ? "true" : undefined,
                                onClick: handleLast5Click,
                                children: last5Name
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1fWBE.default), {
                                id: "sort-type-menu",
                                anchorEl: last5AnchorEl,
                                open: last5Open,
                                onClose: handleLast5Close,
                                MenuListProps: {
                                    "aria-labelledby": "sort-type-selector"
                                },
                                children: dataUsageAlertVolumeArray.map((object)=>{
                                    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: ()=>{
                                            handleClose();
                                            handleLast5Close();
                                            const rangeChoiceValues = new Map();
                                            rangeChoices.forEach((option)=>{
                                                rangeChoiceValues.set(`${option.name}`, `${option.value}`);
                                            });
                                            if (object.value === "alert_volume") setCurrentData("alertVolumeData");
                                            if (object.value === "bandwidth") setCurrentData("usageData");
                                            setTypeString(object.value);
                                            setLast5Name(object.name);
                                            setDataIsLoading(true);
                                            getDataUsageData(navigate);
                                        },
                                        children: object.name
                                    }, object.value);
                                })
                            })
                        ]
                    })
                ]
            }),
            !errorFetchingUsageData && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "pt-2",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a4a6da4329941212$export$e37592be944b3337), {})
                    }),
                    !dataIsLoading && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "mt-3 flex w-full items-stretch",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "flex shrink-0 items-center",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "text-[#757575] font-mulish text-[16px] rotate-180",
                                    style: {
                                        writingMode: "vertical-rl"
                                    },
                                    children: currentData === "usageData" ? "Real Time Bandwidth Usage GB" : "Number of Alerts"
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "h-[260px] min-w-0 flex-1",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $0deeafe8345931ee$export$e60a4704009a0009), {
                                    width: "100%",
                                    height: "100%",
                                    children: currentData === "usageData" ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $dc284d0fb10e6f6a$export$94aefc399ef206a9), {
                                        data: usageData,
                                        margin: {
                                            top: 5,
                                            right: 20,
                                            left: 20,
                                            bottom: 20
                                        },
                                        onClick: (event)=>{
                                            navigate(`/sites/aboutsite/${event.activePayload[0].payload.id}`);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $381060c808bbe825$export$6440e27b9f186856), {
                                                strokeDasharray: "3 3"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $e3fbaf009dcc8585$export$ea77231de273b52d), {
                                                dataKey: "display_name",
                                                type: "category",
                                                hide: true
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $c7554316bfb1649b$export$f96c4024c52de8f4), {
                                                allowDecimals: false
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $45dbb8bb277f9d9d$export$28c660c63b792dea), {}),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $7d5fe63ca2eb078d$export$bbc6c6369b38e3d1), {
                                                cursor: "pointer",
                                                dataKey: "kbs",
                                                fill: "#FF8400",
                                                name: "GB",
                                                onClick: (event)=>navigate(`/sites/aboutsite/${event.id}`),
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1778bc5734fdac4c$export$835fcf23ab7bf88), {
                                                    dataKey: "abreviated_name",
                                                    position: "bottom"
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $k4ank.jsxs)((0, $dc284d0fb10e6f6a$export$94aefc399ef206a9), {
                                        data: usageData,
                                        margin: {
                                            top: 5,
                                            right: 20,
                                            left: 20,
                                            bottom: 20
                                        },
                                        onClick: (event)=>{
                                            navigate(`/sites/aboutsite/${event.activePayload[0].payload.id}`);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $381060c808bbe825$export$6440e27b9f186856), {
                                                strokeDasharray: "3 3"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $e3fbaf009dcc8585$export$ea77231de273b52d), {
                                                dataKey: "display_name",
                                                type: "category",
                                                hide: true
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $c7554316bfb1649b$export$f96c4024c52de8f4), {
                                                allowDecimals: false
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $45dbb8bb277f9d9d$export$28c660c63b792dea), {}),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $7d5fe63ca2eb078d$export$bbc6c6369b38e3d1), {
                                                cursor: "pointer",
                                                dataKey: "alert_volume",
                                                fill: "#283E6D",
                                                name: "Alerts",
                                                onClick: (event)=>navigate(`/sites/aboutsite/${event.id}`),
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1778bc5734fdac4c$export$835fcf23ab7bf88), {
                                                    dataKey: "abreviated_name",
                                                    position: "bottom"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    !dataIsLoading && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "pt-2 text-center text-[#757575] font-mulish text-[16px]",
                        children: last5Name === "Data Usage" ? usageData.length > 1 ? `${usageData.length} sites with Highest Data Usage` : `Site with highest Data Usage` : usageData.length > 1 ? `${usageData.length} sites with Highest Alert Volume` : `Site with highest Alert Volume`
                    }),
                    dataIsLoading && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "flex h-[260px] flex-col items-center justify-center",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                size: 25
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "font-mulish text-actuate-blue test-bold pt-2",
                                children: "Fetching Data..."
                            })
                        ]
                    })
                ]
            }),
            errorFetchingUsageData && !dataIsLoading && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex h-[260px] flex-col items-center justify-center",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "font-mulish text-actuate-blue test-bold text-[20px]",
                        children: "Error fetching data."
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setDataIsLoading(true);
                            getDataUsageData(navigate);
                        },
                        text: retryText,
                        disabled: false
                    })
                ]
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");


var $60vL1 = parcelRequire("60vL1");

var $8jTCz = parcelRequire("8jTCz");


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $fd67dcfd2e5f9396$export$62a6043387083b2c = ()=>{
    const { noFPData: noFPData, setNoFPData: setNoFPData, setFalsePositiveData: setFalsePositiveData, falsePositiveData: falsePositiveData, getFalsePositiveData: getFalsePositiveData } = (0, $ad6781d64ea9d765$export$176f58333fc13682)();
    const retryText = /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9222626528c451ae$exports))), {
                fontSize: "small"
            }),
            "\xa0Retry"
        ]
    });
    const navigate = (0, $3T949.useNavigate)();
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "w-full min-w-0 bg-white px-4 pt-4 pb-5 sm:px-6",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex flex-wrap items-baseline justify-between gap-2",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "text-actuate-blue font-mulish text-[26px] font-bold",
                        children: "False Positive Reduction"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "text-actuate-blue font-mulish text-[16px]",
                        children: "Last 5 Days"
                    })
                ]
            }),
            !falsePositiveData && !noFPData && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex h-[280px] flex-col items-center justify-center",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                        size: 25
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "font-mulish text-actuate-blue test-bold pt-2",
                        children: "Fetching Data..."
                    })
                ]
            }),
            !falsePositiveData && noFPData && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex h-[280px] flex-col items-center justify-center",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "font-mulish text-actuate-blue test-bold text-[20px]",
                        children: "Error fetching data."
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setNoFPData(false);
                            setFalsePositiveData(null);
                            getFalsePositiveData(navigate);
                        },
                        text: retryText,
                        disabled: false
                    })
                ]
            }),
            falsePositiveData && !noFPData && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "mt-4 h-[280px] w-full",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $0deeafe8345931ee$export$e60a4704009a0009), {
                    width: "100%",
                    height: "100%",
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $dc284d0fb10e6f6a$export$94aefc399ef206a9), {
                        data: falsePositiveData,
                        margin: {
                            top: 5,
                            right: 20,
                            left: 30,
                            bottom: 5
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $381060c808bbe825$export$6440e27b9f186856), {
                                strokeDasharray: "3 3"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $e3fbaf009dcc8585$export$ea77231de273b52d), {
                                dataKey: "date"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $c7554316bfb1649b$export$f96c4024c52de8f4), {
                                allowDecimals: false
                            }),
                            falsePositiveData && falsePositiveData.length > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $45dbb8bb277f9d9d$export$28c660c63b792dea), {}),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $a67bff487a060557$export$ed247974535929c7), {
                                verticalAlign: "top",
                                height: 36
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $7d5fe63ca2eb078d$export$bbc6c6369b38e3d1), {
                                dataKey: "detections",
                                stackId: "a",
                                fill: "#283E6D",
                                name: "Detections"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $7d5fe63ca2eb078d$export$bbc6c6369b38e3d1), {
                                dataKey: "motion_counts",
                                stackId: "b",
                                fill: "#FF8400",
                                name: "Motion Counts"
                            })
                        ]
                    })
                })
            })
        ]
    });
};


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $dHtmK = parcelRequire("dHtmK");

var $8utdm = parcelRequire("8utdm");


var $1BWfV = parcelRequire("1BWfV");
const $4a4e6e8a12b91557$export$fe82a520fc33e5f4 = ({ navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed })=>{
    const userName = localStorage.username;
    const firstName = localStorage.first_name;
    const navigate = (0, $3T949.useNavigate)();
    const { pageLoading: pageLoading, falsePositiveData: falsePositiveData, getTotalCamerasInfo: getTotalCamerasInfo, getFalsePositiveData: getFalsePositiveData, getDataUsageData: getDataUsageData, resetState: resetState } = (0, $ad6781d64ea9d765$export$176f58333fc13682)();
    // Debug functions available globally for console testing (development only)
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        window.forceTokenExpiration = ()=>{
            console.log("\uD83E\uDDEA DEBUG: Forcing token expiration for testing");
            (0, $1BWfV.authStateManager).clearAuthState();
            localStorage.removeItem("loggedIn");
            localStorage.removeItem("token");
            localStorage.removeItem("token_secret");
            window.location.reload();
        };
        window.simulateExpiredToken = ()=>{
            console.log("\uD83E\uDDEA DEBUG: Simulating expired token (keeping tokens but marking as invalid)");
            localStorage.removeItem("loggedIn");
            window.location.reload();
        };
        window.simulateTrulyExpiredToken = ()=>{
            console.log("\uD83E\uDDEA DEBUG: Simulating truly expired token (invalid access token but valid refresh token)");
            // Get the current refresh token (keep it valid)
            const currentRefreshToken = document.cookie.split("; ").find((row)=>row.startsWith("token_secret="))?.split("=")[1];
            if (!currentRefreshToken) {
                console.log("\uD83E\uDDEA DEBUG: No refresh token found, cannot simulate this scenario");
                return;
            }
            // Clear the access token cookie (make it expired/invalid)
            document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            // Keep the refresh token valid (don't touch it)
            console.log("\uD83E\uDDEA DEBUG: Access token cleared, refresh token kept valid");
            // Reload to trigger the scenario
            window.location.reload();
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        // Reset state when component mounts
        resetState();
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        // Fetch initial data
        getTotalCamerasInfo(navigate);
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!falsePositiveData) getFalsePositiveData(navigate);
    }, [
        falsePositiveData
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        getDataUsageData(navigate);
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8utdm.ReleaseNotesBanner), {}),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                openState: pageLoading
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "bg-actuate-grey absolute w-full h-full overflow-y-auto overflow-x-hidden",
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: navBarCollapsed ? "pl-[95px] pr-6 pb-10" : "pl-[170px] pr-6 pb-10",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "pt-2 pb-2 border-b-4 border-[#BDBDBD]",
                            children: !firstName ? /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                className: "text-actuate-blue font-mulish text-[20px] font-bold",
                                children: [
                                    "Welcome, ",
                                    userName
                                ]
                            }) : /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                className: "text-actuate-blue font-mulish text-[20px] font-bold",
                                children: [
                                    "Welcome, ",
                                    firstName
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "mt-5 grid grid-cols-1 gap-6 xl:grid-cols-2 items-start",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $e5f6a9ef88175e17$export$5b42e29e5416e234), {}),
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "flex min-w-0 flex-col gap-6",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $fd67dcfd2e5f9396$export$62a6043387083b2c), {}),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $fa0213fde50de9cb$export$7fc3a82a5d676bd8), {})
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "justify-start",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jVN1H.NavBar), {
                    navBarCollapsed: navBarCollapsed,
                    setNavBarCollapsed: setNavBarCollapsed,
                    props: {}
                })
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $jVN1H = parcelRequire("jVN1H");

var $8T3gX = parcelRequire("8T3gX");

var $fIsAN = parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kCUgG = parcelRequire("kCUgG");

var $bAwA3 = parcelRequire("bAwA3");

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $aBrLz = parcelRequire("aBrLz");

var $anJSP = parcelRequire("anJSP");
var $3dQcH = parcelRequire("3dQcH");

var $7AQZl = parcelRequire("7AQZl");

var $hhKOZ = parcelRequire("hhKOZ");

var $a9NOs = parcelRequire("a9NOs");

var $11ydL = parcelRequire("11ydL");

var $dZfqJ = parcelRequire("dZfqJ");

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $1c87a964daab329d$export$c09531d8563c67a5(slot) {
    return (0, $kfTYv.default)('MuiListItemButton', slot);
}
const $1c87a964daab329d$var$listItemButtonClasses = (0, $jh2Zm.default)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $1c87a964daab329d$export$2e2bcd8739ae039 = $1c87a964daab329d$var$listItemButtonClasses;



var $k4ank = parcelRequire("k4ank");
'use client';
const $07bcecd6345c33ee$var$_excluded = [
    "alignItems",
    "autoFocus",
    "component",
    "children",
    "dense",
    "disableGutters",
    "divider",
    "focusVisibleClassName",
    "selected",
    "className"
];
const $07bcecd6345c33ee$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $07bcecd6345c33ee$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, divider: divider, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            divider && 'divider',
            disabled && 'disabled',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $aYNpO.default)(slots, (0, $1c87a964daab329d$export$c09531d8563c67a5), classes);
    return (0, $eJfrs.default)({}, classes, composedClasses);
};
const $07bcecd6345c33ee$var$ListItemButtonRoot = (0, $anJSP.default)((0, $hhKOZ.default), {
    shouldForwardProp: (prop)=>(0, $3dQcH.default)(prop) || prop === 'classes',
    name: 'MuiListItemButton',
    slot: 'Root',
    overridesResolver: $07bcecd6345c33ee$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minWidth: 0,
        boxSizing: 'border-box',
        textAlign: 'left',
        paddingTop: 8,
        paddingBottom: 8,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $1c87a964daab329d$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $aBrLz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $1c87a964daab329d$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $aBrLz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $1c87a964daab329d$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $aBrLz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $aBrLz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $1c87a964daab329d$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $1c87a964daab329d$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, ownerState.alignItems === 'flex-start' && {
        alignItems: 'flex-start'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }));
const $07bcecd6345c33ee$var$ListItemButton = /*#__PURE__*/ $8T3gX.forwardRef(function ListItemButton(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemButton'
    });
    const { alignItems: alignItems = 'center', autoFocus: autoFocus = false, component: component = 'div', children: children, dense: dense = false, disableGutters: disableGutters = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, selected: selected = false, className: className } = props, other = (0, $fAJB5.default)(props, $07bcecd6345c33ee$var$_excluded);
    const context = $8T3gX.useContext((0, $dZfqJ.default));
    const childContext = $8T3gX.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $8T3gX.useRef(null);
    (0, $a9NOs.default)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
            else console.error('MUI: Unable to set focus to a ListItemButton whose component has not been rendered.');
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $eJfrs.default)({}, props, {
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        divider: divider,
        selected: selected
    });
    const classes = $07bcecd6345c33ee$var$useUtilityClasses(ownerState);
    const handleRef = (0, $11ydL.default)(listItemRef, ref);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $dZfqJ.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $k4ank.jsx)($07bcecd6345c33ee$var$ListItemButtonRoot, (0, $eJfrs.default)({
            ref: handleRef,
            href: other.href || other.to,
            component: (other.href || other.to) && component === 'div' ? 'button' : component,
            focusVisibleClassName: (0, $iVyaN.default)(classes.focusVisible, focusVisibleClassName),
            ownerState: ownerState,
            className: (0, $iVyaN.default)(classes.root, className)
        }, other, {
            classes: classes,
            children: children
        }))
    });
});
$07bcecd6345c33ee$var$ListItemButton.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Defines the `align-items` style property.
   * @default 'center'
   */ alignItems: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'center',
        'flex-start'
    ]),
    /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */ dense: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the left and right padding is removed.
   * @default false
   */ disableGutters: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */ divider: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */ focusVisibleClassName: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * @ignore
   */ href: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Use to apply selected styling.
   * @default false
   */ selected: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $07bcecd6345c33ee$export$2e2bcd8739ae039 = $07bcecd6345c33ee$var$ListItemButton;



var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $j9hJf = parcelRequire("j9hJf");

var $dZfqJ = parcelRequire("dZfqJ");

var $k4ank = parcelRequire("k4ank");
'use client';
const $fc0c7440c238b2e1$var$_excluded = [
    "className"
];
const $fc0c7440c238b2e1$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $j9hJf.getListItemIconUtilityClass), classes);
};
const $fc0c7440c238b2e1$var$ListItemIconRoot = (0, $anJSP.default)('div', {
    name: 'MuiListItemIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: 'inline-flex'
    }, ownerState.alignItems === 'flex-start' && {
        marginTop: 8
    }));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $fc0c7440c238b2e1$var$ListItemIcon = /*#__PURE__*/ $8T3gX.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemIcon'
    });
    const { className: className } = props, other = (0, $fAJB5.default)(props, $fc0c7440c238b2e1$var$_excluded);
    const context = $8T3gX.useContext((0, $dZfqJ.default));
    const ownerState = (0, $eJfrs.default)({}, props, {
        alignItems: context.alignItems
    });
    const classes = $fc0c7440c238b2e1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsx)($fc0c7440c238b2e1$var$ListItemIconRoot, (0, $eJfrs.default)({
        className: (0, $iVyaN.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$fc0c7440c238b2e1$var$ListItemIcon.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@mui/icons-material` SVG icon element.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $fc0c7440c238b2e1$export$2e2bcd8739ae039 = $fc0c7440c238b2e1$var$ListItemIcon;


var $c712346e3704c7fb$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($c712346e3704c7fb$exports, "__esModule", {
    value: true
});
$c712346e3704c7fb$exports.default = void 0;

var $c712346e3704c7fb$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $c712346e3704c7fb$var$_default = $c712346e3704c7fb$exports.default = (0, $c712346e3704c7fb$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8z"
}), 'Folder');



var $yndCB = parcelRequire("yndCB");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");



var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $f3puC = parcelRequire("f3puC");

var $dZfqJ = parcelRequire("dZfqJ");

var $7AQZl = parcelRequire("7AQZl");

var $anJSP = parcelRequire("anJSP");

var $d6MXx = parcelRequire("d6MXx");

var $k4ank = parcelRequire("k4ank");
'use client';
const $a7d6d1bc115c33d6$var$_excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const $a7d6d1bc115c33d6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            'root',
            inset && 'inset',
            dense && 'dense',
            primary && secondary && 'multiline'
        ],
        primary: [
            'primary'
        ],
        secondary: [
            'secondary'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $d6MXx.getListItemTextUtilityClass), classes);
};
const $a7d6d1bc115c33d6$var$ListItemTextRoot = (0, $anJSP.default)('div', {
    name: 'MuiListItemText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $d6MXx.default).primary}`]: styles.primary
            },
            {
                [`& .${(0, $d6MXx.default).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({
        flex: '1 1 auto',
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const $a7d6d1bc115c33d6$var$ListItemText = /*#__PURE__*/ $8T3gX.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemText'
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps } = props, other = (0, $fAJB5.default)(props, $a7d6d1bc115c33d6$var$_excluded);
    const { dense: dense } = $8T3gX.useContext((0, $dZfqJ.default));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, $eJfrs.default)({}, props, {
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    });
    const classes = $a7d6d1bc115c33d6$var$useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, $f3puC.default) && !disableTypography) primary = /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), (0, $eJfrs.default)({
        variant: dense ? 'body2' : 'body1',
        className: classes.primary,
        component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : 'span',
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, $f3puC.default) && !disableTypography) secondary = /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), (0, $eJfrs.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, $k4ank.jsxs)($a7d6d1bc115c33d6$var$ListItemTextRoot, (0, $eJfrs.default)({
        className: (0, $iVyaN.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
$a7d6d1bc115c33d6$var$ListItemText.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Alias for the `primary` prop.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   * @default false
   */ disableTypography: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the children are indented.
   * This should be used if there is no left avatar or left icon.
   * @default false
   */ inset: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The main content element.
   */ primary: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   */ primaryTypographyProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The secondary content element.
   */ secondary: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   */ secondaryTypographyProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $a7d6d1bc115c33d6$export$2e2bcd8739ae039 = $a7d6d1bc115c33d6$var$ListItemText;



var $879ea8b84720ab7f$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($879ea8b84720ab7f$exports, "__esModule", {
    value: true
});
$879ea8b84720ab7f$exports.default = void 0;

var $879ea8b84720ab7f$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $879ea8b84720ab7f$var$_default = $879ea8b84720ab7f$exports.default = (0, $879ea8b84720ab7f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), 'ExpandLess');



var $5gr4N = parcelRequire("5gr4N");
parcelRequire("8T3gX");
const $590e33a77eb71d54$export$656c6610220ba923 = (targetNumber, numbers)=>{
    // Use filter to create a new array without the targetNumber
    const newArray = numbers.filter((num)=>num !== targetNumber);
    return newArray;
};


const $a3beba492469dd62$export$f85788f606ef8b2c = (selectedIndex, levelName, id, setSelectedIndex)=>{
    const storedSelectedIndex = JSON.parse(localStorage.storedSelectedIndex);
    if (selectedIndex[levelName].includes(id)) setSelectedIndex((previousState)=>{
        return {
            ...previousState,
            [levelName]: (0, $590e33a77eb71d54$export$656c6610220ba923)(id, previousState[levelName])
        };
    });
    else if (!selectedIndex[levelName].includes(id)) setSelectedIndex((previousState)=>{
        const newArray = previousState[levelName];
        if (id && newArray) newArray.push(id);
        return {
            ...previousState,
            [levelName]: newArray
        };
    });
};



var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");

var $9OjAn = parcelRequire("9OjAn");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $0bb5fda2d17b239c$export$97ac24bd611f62c0 = (0, $9OjAn.create)((set, get)=>({
        sitesOverviewNotice: null,
        setSitesOverviewNotice: (sitesOverviewNotice)=>set({
                sitesOverviewNotice: sitesOverviewNotice
            }),
        sitesOverviewInProgress: false,
        setSitesOverviewInProgress: (sitesOverviewInProgress)=>set({
                sitesOverviewInProgress: sitesOverviewInProgress
            }),
        selectedName: "",
        setSelectedName: (name)=>set({
                selectedName: name
            }),
        batchSize: 0,
        setBatchSize: (batchSize)=>set({
                batchSize: batchSize
            }),
        minimumResolutionHeight: 0,
        setMinimumResolutionHeight: (minimumResolutionHeight)=>set({
                minimumResolutionHeight: minimumResolutionHeight
            }),
        updatingBatchSize: false,
        setUpdatingBatchSize: (updatingBatchSize)=>set({
                updatingBatchSize: updatingBatchSize
            }),
        fetchingTenantSettings: false,
        setFetchingTenantSettings: (fetchingTenantSettings)=>set({
                fetchingTenantSettings: fetchingTenantSettings
            }),
        selectedGropupId: 0,
        setSelectedGropupId: (selectedGropupId)=>set({
                selectedGropupId: selectedGropupId
            }),
        selectedGroupName: "",
        setSelectedGroupName: (selectedGroupName)=>set({
                selectedGroupName: selectedGroupName
            }),
        selectedGroupCounts: {},
        setSelectedGroupCounts: (selectedGroupCounts)=>set({
                selectedGroupCounts: selectedGroupCounts
            }),
        fetchingSelectedGroupCounts: false,
        setFetchingSelectedGroupCounts: (fetchingSelectedGroupCounts)=>set({
                fetchingSelectedGroupCounts: fetchingSelectedGroupCounts
            }),
        // Initialize the cache as an empty object
        groupCountsCache: {},
        immixRemotelinkDialogOpen: false,
        setImmixRemotelinkDialogOpen: (immixRemotelinkDialogOpen)=>set({
                immixRemotelinkDialogOpen: immixRemotelinkDialogOpen
            }),
        mappedSites: [],
        setMappedSites: (mappedSites)=>set({
                mappedSites: mappedSites
            }),
        unmappedSites: [],
        setUnmappedSites: (unmappedSites)=>set({
                unmappedSites: unmappedSites
            }),
        // Method to add data to the cache
        addToGroupCountsCache: (groupId, groupCounts)=>set((state)=>({
                    groupCountsCache: {
                        ...state.groupCountsCache,
                        [groupId]: groupCounts
                    }
                })),
        // Method to clear the cache
        clearGroupCountsCache: ()=>set({
                groupCountsCache: {}
            }),
        // Initialize healthCheckMetricsData as an empty array
        getSelectedGroupCounts: async (navigate, groupId)=>{
            const { setSelectedGroupCounts: setSelectedGroupCounts, setFetchingSelectedGroupCounts: setFetchingSelectedGroupCounts, groupCountsCache: groupCountsCache, addToGroupCountsCache: addToGroupCountsCache } = get();
            // Check if we already have this data in the cache
            if (groupCountsCache[groupId]) {
                // Use cached data instead of making an API call
                setSelectedGroupCounts(groupCountsCache[groupId]);
                // If a fetch for another item was active, and we hit cache for this one,
                // ensure fetching flag is false if this cached item is now the target.
                // This specific line might need adjustment based on overall app flow,
                // but for now, if we serve from cache, fetching should ideally be false for this item.
                if (get().selectedGroupCounts?.id === groupId) setFetchingSelectedGroupCounts(false);
                return;
            } // Not in cache, proceed with API call:
            // 1. Set fetching flag to true.
            setFetchingSelectedGroupCounts(true);
            // 2. Set selectedGroupCounts to an intermediate state indicating which group is loading.
            // This helps UI to know *which* item is loading if multiple onOpen events fire rapidly.
            // The absence of count fields (sites, sub_groups) signifies loading.
            setSelectedGroupCounts({
                id: groupId
            });
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().getSelectedGroupCounts(navigate, groupId);
            };
            try {
                const response = await AxiosUI.get(`group/${groupId}/counts/`);
                const selectedGroupCountsData = response.data;
                // Store in cache for future use
                addToGroupCountsCache(groupId, selectedGroupCountsData);
                // Update current selection, but only if this groupId is still the active target
                // and we are still in a fetching state for it.
                if (get().selectedGroupCounts?.id === groupId && get().fetchingSelectedGroupCounts) setSelectedGroupCounts(selectedGroupCountsData);
            } catch (reason) {
                // Handle error, but only if this groupId is still the active target.
                if (get().selectedGroupCounts?.id === groupId && get().fetchingSelectedGroupCounts) (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    // Clear counts for this specific group on error, if it's still the target.
                    if (get().selectedGroupCounts?.id === groupId) setSelectedGroupCounts({
                        id: groupId
                    }); // Or simply {} if preferred for error state
                });
            } finally{
                // Set fetching to false, but only if this groupId's fetch is completing
                // and it's still the active target.
                if (get().selectedGroupCounts?.id === groupId && get().fetchingSelectedGroupCounts) setFetchingSelectedGroupCounts(false);
            }
        },
        getTenantSettings: async (groupId, navigate)=>{
            const { setBatchSize: setBatchSize, setFetchingTenantSettings: setFetchingTenantSettings, setMinimumResolutionHeight: setMinimumResolutionHeight } = get();
            setFetchingTenantSettings(true);
            setBatchSize(0);
            setMinimumResolutionHeight(0);
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().getTenantSettings(groupId, navigate);
            };
            try {
                const response = await AxiosUI.get(`group/${groupId}/`);
                setBatchSize(response.data?.max_batch_size || 0);
                setMinimumResolutionHeight(response.data?.minimum_resolution_height || 0);
                setFetchingTenantSettings(false);
            } catch (reason) {
                setFetchingTenantSettings(false);
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setBatchSize(0);
                    setMinimumResolutionHeight(0);
                });
            }
        },
        handlePatchTenantSettings: async (batchSize, minimumResolutionHeight, navigate)=>{
            const { setUpdatingBatchSize: setUpdatingBatchSize, selectedGropupId: selectedGropupId, setBatchSize: setBatchSize, setMinimumResolutionHeight: setMinimumResolutionHeight } = get();
            setUpdatingBatchSize(true);
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().handlePatchTenantSettings(batchSize, minimumResolutionHeight, navigate);
            };
            try {
                await AxiosUI.patch(`group/${selectedGropupId}/`, {
                    max_batch_size: batchSize,
                    minimum_resolution_height: minimumResolutionHeight
                });
                setBatchSize(batchSize);
                setMinimumResolutionHeight(minimumResolutionHeight);
                setUpdatingBatchSize(false);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setUpdatingBatchSize(false);
                });
            }
        },
        searchGroupId: 0,
        setSearchGroupId: (groupId)=>set({
                searchGroupId: groupId
            }),
        groupSitesProgress: null,
        setGroupSitesProgress: (groupSitesProgress)=>set({
                groupSitesProgress: groupSitesProgress
            }),
        remoteLinkSites: [],
        setRemotelinkSites: (remoteLinkSites)=>set({
                remoteLinkSites: remoteLinkSites
            }),
        optionsIdsMap: new Map(),
        setOptionsIdsMap: (optionsIdsMap)=>set({
                optionsIdsMap: optionsIdsMap
            }),
        fetchingImmixRemoteLinkData: false,
        setFetchingImmixRemoteLinkData: (fetchingImmixRemoteLinkData)=>set({
                fetchingImmixRemoteLinkData: fetchingImmixRemoteLinkData
            }),
        updatingImmixRemoteLinkData: false,
        setUpdatingImmixRemoteLinkData: (updatingImmixRemoteLinkData)=>set({
                updatingImmixRemoteLinkData: updatingImmixRemoteLinkData
            }),
        getMappedSites: async (navigate)=>{
            const { getMappedSites: getMappedSites, setMappedSites: setMappedSites } = get();
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                getMappedSites(navigate);
            };
            try {
                const response = await AxiosUI.get(`remote_link/?is_mapped=true`);
                setMappedSites(response.data.results);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
            }
        },
        getUnmappedSites: async (navigate)=>{
            const { getUnmappedSites: getUnmappedSites, setUnmappedSites: setUnmappedSites } = get();
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                getUnmappedSites(navigate);
            };
            try {
                const response = await AxiosUI.get(`remote_link/?is_mapped=false`);
                setUnmappedSites(response.data.results);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
            }
        },
        getRemotelinkSites: async (navigate)=>{
            const { setRemotelinkSites: setRemotelinkSites, setOptionsIdsMap: setOptionsIdsMap } = get();
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().getRemotelinkSites(navigate);
            };
            try {
                const response = await AxiosUI.get(`group/?group_type=remote_link&page_size=20000`);
                setRemotelinkSites(response.data.results);
                const optionsIds = new Map();
                response.data.results.forEach((rlSite)=>{
                    optionsIds.set(rlSite.name, rlSite.id);
                });
                setOptionsIdsMap(optionsIds);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
            }
        },
        getImmixRemoteLinkData: async (navigate)=>{
            const { setFetchingImmixRemoteLinkData: setFetchingImmixRemoteLinkData, getMappedSites: getMappedSites, getUnmappedSites: getUnmappedSites, getRemotelinkSites: getRemotelinkSites } = get();
            setFetchingImmixRemoteLinkData(true);
            try {
                await Promise.all([
                    getMappedSites(navigate),
                    getUnmappedSites(navigate),
                    getRemotelinkSites(navigate)
                ]);
            } finally{
                setFetchingImmixRemoteLinkData(false);
            }
        },
        updateImmixRemoteLinkData: async (patchObject, navigate)=>{
            const { setUpdatingImmixRemoteLinkData: setUpdatingImmixRemoteLinkData, setMappedSites: setMappedSites, mappedSites: mappedSites, setUnmappedSites: setUnmappedSites, unmappedSites: unmappedSites } = get();
            setUpdatingImmixRemoteLinkData(true);
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().updateImmixRemoteLinkData(patchObject, navigate);
            };
            try {
                const response = await AxiosUI.patch(`remote_link/${patchObject.id}/`, {
                    admin_group: patchObject.admin_group_id
                });
                setMappedSites([
                    ...mappedSites,
                    response.data
                ]);
                setUnmappedSites(unmappedSites.filter((site)=>site.id !== patchObject.id));
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    alert("Error updating Immix Remotelink data, please try again");
                });
            } finally{
                setUpdatingImmixRemoteLinkData(false);
            }
        },
        unlinkImmixRemoteLinkData: async (site, navigate)=>{
            const { setUpdatingImmixRemoteLinkData: setUpdatingImmixRemoteLinkData } = get();
            setUpdatingImmixRemoteLinkData(true);
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().unlinkImmixRemoteLinkData(site, navigate);
            };
            try {
                const response = await AxiosUI.patch(`remote_link/${site.id}/`, {
                    admin_group: null
                });
                // Re-read the lists at completion time: another save may have landed
                // while the request was in flight.
                const { mappedSites: mappedSites, unmappedSites: unmappedSites } = get();
                get().setMappedSites(mappedSites.filter((s)=>s.id !== site.id));
                get().setUnmappedSites([
                    ...unmappedSites.filter((s)=>s.id !== site.id),
                    {
                        ...response.data,
                        admin_group: null
                    }
                ]);
                return true;
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    alert("Error unlinking Immix Remotelink site, please try again");
                });
                return false;
            } finally{
                setUpdatingImmixRemoteLinkData(false);
            }
        },
        resetImmixRemoteLinkData: ()=>{
            const { setMappedSites: setMappedSites, setUnmappedSites: setUnmappedSites, setOptionsIdsMap: setOptionsIdsMap, setUpdatingImmixRemoteLinkData: setUpdatingImmixRemoteLinkData } = get();
            setMappedSites([]);
            setUnmappedSites([]);
            setOptionsIdsMap(new Map());
            setUpdatingImmixRemoteLinkData(false);
        }
    }));



var $ebTQj = parcelRequire("ebTQj");
const $9b1233e28e731320$export$c46d21d61d4e916 = 100;
const $9b1233e28e731320$export$1782ffb6073041f9 = 3;
/** Bumped on every load, so a newer load (even of the same group) wins. */ let $9b1233e28e731320$var$loadSeq = 0;
const $9b1233e28e731320$export$c833c47a0e6a4215 = ()=>{
    $9b1233e28e731320$var$loadSeq += 1;
    (0, $0bb5fda2d17b239c$export$97ac24bd611f62c0).getState().setGroupSitesProgress(null);
};
const $9b1233e28e731320$export$316efaa9553dbeca = async (id, setRenderedRows, setPageLoading, setSiteBreadcrumbs, setSelected, setEditableGroupSelected, setSelectedGroupListName, navigate)=>{
    setPageLoading(true);
    const AxiosUI = (0, $195EM.createApi)(`customer/`);
    const Axios = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $9b1233e28e731320$export$316efaa9553dbeca(id, setRenderedRows, setPageLoading, setSiteBreadcrumbs, setSelected, setEditableGroupSelected, setSelectedGroupListName, navigate);
    };
    // localStorage.setItem("group_id", id);
    localStorage.setItem("selectedGroupOrSiteId", id);
    setSelected([]);
    (0, $0bb5fda2d17b239c$export$97ac24bd611f62c0).getState().setGroupSitesProgress(null);
    // Still the latest load, for the group the user asked for? Earlier clicks
    // may still be loading.
    const thisLoad = ++$9b1233e28e731320$var$loadSeq;
    const stillCurrent = ()=>thisLoad === $9b1233e28e731320$var$loadSeq && id === (0, $0bb5fda2d17b239c$export$97ac24bd611f62c0).getState().searchGroupId;
    const { setGroupSitesProgress: setGroupSitesProgress } = (0, $0bb5fda2d17b239c$export$97ac24bd611f62c0).getState();
    const loadBreadcrumbs = ()=>Axios.get(`group/${id}/ancestors/`).then((response)=>{
            if (Number(id) === Number(localStorage.getIndividualGroupId)) setSiteBreadcrumbs(response.data);
            setPageLoading(false);
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                setSiteBreadcrumbs([]);
                setPageLoading(false);
            });
        });
    /**
   * ENG-2634: a group with thousands of sites took ~2 min to show anything
   * because every 1000-site page (15-40 ms per site server-side) was fetched
   * in sequence before rendering. Render the first SITES_PAGE_SIZE sites as
   * soon as they arrive, then fetch the rest a few pages at a time in the
   * background, adding rows as they come in. groupSitesProgress tells the
   * table the list is still partial (progress note, select-all off).
   */ const getGroups = async ()=>{
        const fetchPage = (pageNumber)=>AxiosUI.get(`/by_group_id/${id}/?page=${pageNumber}&page_size=${$9b1233e28e731320$export$c46d21d61d4e916}`);
        let first;
        try {
            first = await fetchPage(1);
        } catch (reason) {
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                setPageLoading(false);
            });
            return;
        }
        if (!stillCurrent()) return;
        const pages = [
            first.data.results ?? []
        ];
        const total = first.data.count ?? pages[0].length;
        const lastPage = Math.max(1, Math.ceil(total / $9b1233e28e731320$export$c46d21d61d4e916));
        const loadedRows = ()=>pages.reduce((rows, page)=>page ? rows.concat(page) : rows, []);
        setRenderedRows(loadedRows());
        setGroupSitesProgress(lastPage > 1 ? {
            groupId: id,
            loaded: pages[0].length,
            total: total,
            done: false,
            failed: false
        } : null);
        loadBreadcrumbs();
        if (lastPage === 1) return;
        let nextPage = 2;
        let failed = false;
        const worker = async ()=>{
            while(nextPage <= lastPage){
                const pageNumber = nextPage++;
                if (!stillCurrent()) return;
                try {
                    const response = await fetchPage(pageNumber);
                    if (!stillCurrent()) return;
                    pages[pageNumber - 1] = response.data.results ?? [];
                } catch (reason) {
                    failed = true;
                    (0, $ebTQj.logger).error(`Sites page: page ${pageNumber} of group ${id} failed to load`, reason);
                }
                if (!stillCurrent()) return;
                const rows = loadedRows();
                setRenderedRows(rows);
                setGroupSitesProgress({
                    groupId: id,
                    loaded: rows.length,
                    total: total,
                    done: false,
                    failed: failed
                });
            }
        };
        await Promise.all(Array.from({
            length: Math.min($9b1233e28e731320$export$1782ffb6073041f9, lastPage - 1)
        }, worker));
        if (!stillCurrent()) return;
        const rows = loadedRows();
        setGroupSitesProgress(failed ? {
            groupId: id,
            loaded: rows.length,
            total: total,
            done: true,
            failed: true
        } : null);
    };
    await Axios.get(`/group/${id}/`).then((response)=>{
        const searchGroupId = (0, $0bb5fda2d17b239c$export$97ac24bd611f62c0).getState().searchGroupId;
        if (id === searchGroupId) {
            localStorage.setItem("selectedIndvidualGroupInfo", JSON.stringify(response.data));
            if (response.data.parent === null) {
                setEditableGroupSelected(false);
                setSelectedGroupListName(response.data.name);
            }
        }
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
    });
    getGroups();
};



const $7130059543d1308b$export$c0ebe461ead3ff2c = async (setPage, setCurrentTitle, name, id, selectedIndex, levelName, setSelectedIndex, setRenderedRows, setPageLoading, navigate, setSiteBreadcrumbs, setSelected, setSelectedGroupListName, setEditableGroupSelected, expandClick)=>{
    const setSearchGroupId = (0, $0bb5fda2d17b239c$export$97ac24bd611f62c0).getState().setSearchGroupId;
    if (expandClick) {
        setEditableGroupSelected(true);
        setSelectedGroupListName(name);
        setSiteBreadcrumbs("");
        setPage(0);
        setCurrentTitle(name);
        localStorage.setItem("getIndividualGroupId", id);
        setSearchGroupId(id);
        (0, $9b1233e28e731320$export$316efaa9553dbeca)(id, setRenderedRows, setPageLoading, setSiteBreadcrumbs, setSelected, setEditableGroupSelected, setSelectedGroupListName, navigate);
    }
    (0, $a3beba492469dd62$export$f85788f606ef8b2c)(selectedIndex, levelName, id, setSelectedIndex);
};



var $cVCJe = parcelRequire("cVCJe");


var $2uwzz = parcelRequire("2uwzz");
const $ebcce0ea28455bc0$export$f0f8687183866d47 = ({ arrayItem: arrayItem, selectedIndex: selectedIndex, setPage: setPage, setCurrentTitle: setCurrentTitle, levelName: levelName, setSelectedIndex: setSelectedIndex, setRenderedRows: setRenderedRows, setPageLoading: setPageLoading, navigate: navigate, indentNumber: indentNumber, setSiteBreadcrumbs: // maxWordLength, // This prop is passed but not visibly used in the text slicing logic below.
// The existing logic uses hardcoded values (18 and 15).
setSiteBreadcrumbs, navBarCollapsed: navBarCollapsed, setSelected: setSelected, setSelectedGroupListName: setSelectedGroupListName, setEditableGroupSelected: setEditableGroupSelected })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        // Set selected item in localStorage when arrayItem changes
        // Store only essential data to prevent quota exceeded errors
        const essentialData = {
            id: arrayItem.id,
            name: arrayItem.name,
            parent: arrayItem.parent,
            parent_account: arrayItem.parent_account
        };
        (0, $2uwzz.safeSetItem)("selectedItemSiteGroupList", essentialData, {
            maxRetries: 1,
            clearOnQuotaExceeded: true,
            compress: true
        });
    }, [
        arrayItem
    ]);
    const { getSelectedGroupCounts: getSelectedGroupCounts, selectedGroupCounts: selectedGroupCounts, fetchingSelectedGroupCounts: fetchingSelectedGroupCounts } = (0, $0bb5fda2d17b239c$export$97ac24bd611f62c0)();
    let tooltipContent = null;
    if (fetchingSelectedGroupCounts) tooltipContent = /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: "Loading counts..."
    });
    else if (selectedGroupCounts && selectedGroupCounts.id === arrayItem.id) {
        const hasSubGroupsCount = selectedGroupCounts.sub_groups !== undefined;
        const hasSitesCount = selectedGroupCounts.sites !== undefined;
        if (hasSubGroupsCount || hasSitesCount) tooltipContent = /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    children: arrayItem.name
                }),
                hasSubGroupsCount && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    children: `Sub Groups: ${selectedGroupCounts.sub_groups}`
                }),
                hasSitesCount && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    children: `Sites: ${selectedGroupCounts.sites}`
                })
            ]
        });
    // If no relevant counts, tooltipContent remains null, and the tooltip will not be shown.
    }
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: tooltipContent,
        placement: "right",
        onOpen: ()=>{
            getSelectedGroupCounts(navigate, arrayItem.id);
        },
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $07bcecd6345c33ee$export$2e2bcd8739ae039), {
            onClick: ()=>{
                const expandClick = !selectedIndex[levelName].includes(arrayItem.id);
                (0, $7130059543d1308b$export$c0ebe461ead3ff2c)(setPage, setCurrentTitle, arrayItem.name, arrayItem.id, selectedIndex, levelName, setSelectedIndex, setRenderedRows, setPageLoading, navigate, setSiteBreadcrumbs, setSelected, setSelectedGroupListName, setEditableGroupSelected, expandClick);
            },
            sx: {
                pl: indentNumber
            },
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $fc0c7440c238b2e1$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c712346e3704c7fb$exports))), {})
                }),
                arrayItem.name.length < 18 || navBarCollapsed ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $a7d6d1bc115c33d6$export$2e2bcd8739ae039), {
                    primary: `${arrayItem.name}`,
                    primaryTypographyProps: {
                        fontSize: 14,
                        fontFamily: "Mulish"
                    }
                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $a7d6d1bc115c33d6$export$2e2bcd8739ae039), {
                    primary: `${arrayItem.name.slice(0, 15)}...`,
                    primaryTypographyProps: {
                        fontSize: 14,
                        fontFamily: "Mulish"
                    }
                }),
                selectedIndex[levelName].includes(arrayItem.id) ? /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($879ea8b84720ab7f$exports))), {}) : /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5gr4N))), {})
            ]
        })
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");





const $cc709c0532055ee2$export$f0a14f1c87176f9d = async (setPage, setCurrentTitle, name, id, setRenderedRows, setPageLoading, navigate, setSiteBreadcrumbs, setSelected, cameraIconBoolean, setSelectedGroupListName, setEditableGroupSelected)=>{
    const setSearchGroupId = (0, $0bb5fda2d17b239c$export$97ac24bd611f62c0).getState().setSearchGroupId;
    setSelectedGroupListName(name);
    setEditableGroupSelected(!cameraIconBoolean);
    localStorage.setItem("clickedId", id);
    setSiteBreadcrumbs("");
    setPage(0);
    setCurrentTitle(name);
    localStorage.setItem("getIndividualGroupId", id);
    setSearchGroupId(id);
    (0, $9b1233e28e731320$export$316efaa9553dbeca)(id, setRenderedRows, setPageLoading, setSiteBreadcrumbs, setSelected, setEditableGroupSelected, setSelectedGroupListName, navigate);
};



var $bHNwu = parcelRequire("bHNwu");


var $cVCJe = parcelRequire("cVCJe");

const $e346ba6328ad9558$export$b4073a2b7704d03d = ({ arrayItem: arrayItem, setPage: setPage, setCurrentTitle: setCurrentTitle, indentNumber: indentNumber, setRenderedRows: setRenderedRows, setPageLoading: setPageLoading, navigate: navigate, setSiteBreadcrumbs: setSiteBreadcrumbs, navBarCollapsed: navBarCollapsed, setSelected: setSelected, setSelectedGroupListName: setSelectedGroupListName, setEditableGroupSelected: setEditableGroupSelected })=>{
    const { getSelectedGroupCounts: getSelectedGroupCounts, selectedGroupCounts: selectedGroupCounts, fetchingSelectedGroupCounts: fetchingSelectedGroupCounts } = (0, $0bb5fda2d17b239c$export$97ac24bd611f62c0)();
    let tooltipContent = null;
    if (fetchingSelectedGroupCounts) tooltipContent = /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: "Loading counts..."
    });
    else if (selectedGroupCounts && selectedGroupCounts.id === arrayItem.id) {
        const hasSitesCount = selectedGroupCounts.sites !== undefined;
        if (hasSitesCount) tooltipContent = /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    children: arrayItem.name
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    children: `Sub Groups: ${selectedGroupCounts.sub_groups}`
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    children: `Sites: ${selectedGroupCounts.sites}`
                })
            ]
        });
    // If no sites count, tooltipContent remains null, and the tooltip will not be shown.
    }
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
        children: arrayItem.parent_account ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
            title: tooltipContent,
            placement: "right",
            onOpen: ()=>{
                getSelectedGroupCounts(navigate, arrayItem.id);
            },
            children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $07bcecd6345c33ee$export$2e2bcd8739ae039), {
                    sx: {
                        pl: indentNumber
                    },
                    onClick: ()=>{
                        (0, $cc709c0532055ee2$export$f0a14f1c87176f9d)(setPage, setCurrentTitle, arrayItem.name, arrayItem.id, setRenderedRows, setPageLoading, navigate, setSiteBreadcrumbs, setSelected, true, setSelectedGroupListName, setEditableGroupSelected);
                    },
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $fc0c7440c238b2e1$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c712346e3704c7fb$exports))), {
                                className: "ml-[15px]"
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $a7d6d1bc115c33d6$export$2e2bcd8739ae039), {
                            primary: `${arrayItem.name}`,
                            primaryTypographyProps: {
                                fontSize: 14,
                                fontFamily: "Mulish"
                            }
                        })
                    ]
                })
            })
        }) : /*#__PURE__*/ (0, $k4ank.jsxs)((0, $07bcecd6345c33ee$export$2e2bcd8739ae039), {
            sx: {
                pl: indentNumber
            },
            onClick: ()=>{
                (0, $cc709c0532055ee2$export$f0a14f1c87176f9d)(setPage, setCurrentTitle, arrayItem.name, arrayItem.id, setRenderedRows, setPageLoading, navigate, setSiteBreadcrumbs, setSelected, true, setSelectedGroupListName, setEditableGroupSelected);
            },
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $fc0c7440c238b2e1$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $bHNwu.CameraIcon), {})
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $a7d6d1bc115c33d6$export$2e2bcd8739ae039), {
                    primary: `${arrayItem.name}`,
                    primaryTypographyProps: {
                        fontSize: 14,
                        fontFamily: "Mulish"
                    }
                })
            ]
        })
    });
};





var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $iKAtE = parcelRequire("iKAtE");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");

var $i5MAs = parcelRequire("i5MAs");

var $8E01L = parcelRequire("8E01L");

var $3QMQN = parcelRequire("3QMQN");

var $a65wX = parcelRequire("a65wX");


var $aYdit = parcelRequire("aYdit");

var $195EM = parcelRequire("195EM");

var $iIAML = parcelRequire("iIAML");
const $4b705c36d90d4f6c$export$9ff702e5576cf48 = "sites_overview.xlsx";
const $4b705c36d90d4f6c$export$6986f0741764ae29 = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
const $4b705c36d90d4f6c$export$f7202588eeb02bc9 = 3000;
const $4b705c36d90d4f6c$export$a000577beb8a6eb3 = 900000;
class $4b705c36d90d4f6c$export$dfa9a2611c9f95b4 extends Error {
    constructor(detail){
        super(detail || "The sites overview could not be built.");
        this.name = "SitesOverviewFailedError";
    }
}
const $4b705c36d90d4f6c$var$wait = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $4b705c36d90d4f6c$export$9c5f7aef8391e583 = (url)=>{
    const frame = document.createElement("iframe");
    frame.setAttribute("aria-hidden", "true");
    frame.setAttribute("data-testid", "sites-overview-download");
    frame.style.display = "none";
    frame.src = url;
    document.body.appendChild(frame);
    // Long enough for the browser to begin the download on a slow link.
    setTimeout(()=>frame.remove(), 60000);
};
const $4b705c36d90d4f6c$var$isXlsxResponse = (headers)=>String(headers?.["content-type"] ?? "").toLowerCase().startsWith($4b705c36d90d4f6c$export$6986f0741764ae29);
const $4b705c36d90d4f6c$export$d438ca44b65d7d23 = async (groupId, onProgress)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const params = new URLSearchParams();
    if (groupId) params.set("group_id", String(groupId));
    const endpoint = ()=>`site_settings_report/overview_xlsx/${params.toString() ? `?${params.toString()}` : ""}`;
    onProgress?.("preparing");
    const deadline = Date.now() + $4b705c36d90d4f6c$export$a000577beb8a6eb3;
    // eslint-disable-next-line no-constant-condition
    while(true){
        // arraybuffer rather than blob: the xlsx case wraps the bytes as-is and
        // the JSON case decodes them synchronously, with no FileReader.
        const response = await AxiosUI.get(endpoint(), {
            responseType: "arraybuffer"
        });
        if ($4b705c36d90d4f6c$var$isXlsxResponse(response.headers)) {
            onProgress?.("downloading");
            const blob = new Blob([
                response.data
            ], {
                type: $4b705c36d90d4f6c$export$6986f0741764ae29
            });
            (0, $iIAML.saveAs)(blob, $4b705c36d90d4f6c$export$9ff702e5576cf48);
            return null;
        }
        const body = JSON.parse(new TextDecoder().decode(response.data));
        if (body.status === "ready") {
            onProgress?.("downloading", body.url);
            $4b705c36d90d4f6c$export$9c5f7aef8391e583(body.url);
            return body.url;
        }
        if (body.status === "failed") throw new $4b705c36d90d4f6c$export$dfa9a2611c9f95b4(body.detail);
        params.set("task_id", body.task_id);
        if (Date.now() >= deadline) throw new $4b705c36d90d4f6c$export$dfa9a2611c9f95b4("The sites overview is taking too long to build. Please try again later.");
        await $4b705c36d90d4f6c$var$wait($4b705c36d90d4f6c$export$f7202588eeb02bc9);
    }
};



var $4PFLW = parcelRequire("4PFLW");

var $jboFg = parcelRequire("jboFg");
const $c13bdca64b3a3322$var$ITEM_HEIGHT = 48;
const $c13bdca64b3a3322$export$cd305fa8a11563b2 = ({ navigate: navigate, setAddGroupDialogOpen: setAddGroupDialogOpen })=>{
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    const { flags: flags } = (0, $4PFLW.useFeatureFlag)();
    const { setImmixRemotelinkDialogOpen: setImmixRemotelinkDialogOpen, searchGroupId: searchGroupId, sitesOverviewNotice: overviewNotice, setSitesOverviewNotice: setOverviewNotice, sitesOverviewInProgress: overviewInProgress, setSitesOverviewInProgress: setOverviewInProgress } = (0, $0bb5fda2d17b239c$export$97ac24bd611f62c0)();
    // Add Group / Add Site / Calendars create things and follow add_cameras
    // (the routes behind them are gated the same way). Download Sites Overview
    // is a read every level may run, View Only included; the API behind it
    // (site_settings_report/sites_csv/) only requires authentication.
    const canAdd = Boolean(userPermissions?.add_cameras);
    const showTalkDownMessages = Boolean(flags?.[0, $jboFg.TALK_DOWN_FLAG]) && Boolean(userPermissions?.talk_down);
    const [anchorEl, setAnchorEl] = $8T3gX.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    // The sites overview is built off-request on the backend and can take a
    // few minutes for a large group, so keep the user informed while we poll.
    // State is in the sites page store so it outlives this component.
    const handleDownloadSitesOverview = ()=>{
        handleClose();
        if (overviewInProgress) return;
        setOverviewInProgress(true);
        const onProgress = (progress, url)=>{
            if (progress === "preparing") setOverviewNotice({
                severity: "info",
                message: "Preparing the sites overview. This can take a few minutes for a large group; the download starts automatically when it is ready."
            });
            else if (url) setOverviewNotice({
                severity: "success",
                message: "Sites overview ready. If the download did not start, use Download.",
                url: url
            });
            else setOverviewNotice({
                severity: "success",
                message: "Sites overview ready. Your download has started."
            });
        };
        (0, $4b705c36d90d4f6c$export$d438ca44b65d7d23)(searchGroupId, onProgress).catch((error)=>{
            setOverviewNotice({
                severity: "error",
                message: error instanceof (0, $4b705c36d90d4f6c$export$dfa9a2611c9f95b4) ? error.message : "Failed to download the sites overview. Please try again."
            });
        }).finally(()=>setOverviewInProgress(false));
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                "aria-label": "more",
                id: "long-button",
                "aria-controls": open ? "long-menu" : undefined,
                "aria-expanded": open ? "true" : undefined,
                "aria-haspopup": "true",
                onClick: handleClick,
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5MAs))), {})
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                id: "long-menu",
                MenuListProps: {
                    "aria-labelledby": "long-button"
                },
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "left"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "left"
                },
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                PaperProps: {
                    style: {
                        // No fixed width: auto-size to the longest item so the padding
                        // is symmetric (MenuItem's own 16px on each side)
                        maxHeight: $c13bdca64b3a3322$var$ITEM_HEIGHT * 6.5
                    }
                },
                children: [
                    canAdd && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                        onClick: ()=>{
                            setAddGroupDialogOpen(true);
                            handleClose();
                        },
                        children: "Add Group"
                    }, "add-group"),
                    canAdd && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                        onClick: ()=>{
                            handleClose();
                            localStorage.setItem("clickedFromSiteAboutPage", "false");
                            navigate("/sites/addsite");
                            localStorage.setItem("addAnotherScheduleScreen", "false");
                        },
                        children: "Add Site"
                    }, "add-site"),
                    canAdd && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                        onClick: ()=>{
                            handleClose();
                            navigate("/calendars");
                        },
                        children: "Calendars"
                    }, "calendars"),
                    showTalkDownMessages && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                        onClick: ()=>{
                            handleClose();
                            navigate("/talkdown");
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                            className: "inline-flex items-center gap-2 font-mulish",
                            children: [
                                "Talk Down Messages",
                                /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                    className: "rounded bg-actuate-orange px-1.5 py-0.5 text-[10px] font-bold uppercase leading-none text-white",
                                    children: "NEW"
                                })
                            ]
                        })
                    }, "talk-down-messages"),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                        onClick: handleDownloadSitesOverview,
                        disabled: overviewInProgress,
                        children: overviewInProgress ? "Preparing Sites Overview\u2026" : "Download Sites Overview"
                    }, "download-sites-overview"),
                    userPermissions.remote_link && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                        onClick: ()=>{
                            handleClose();
                            setImmixRemotelinkDialogOpen(true);
                        },
                        children: "Immix Remotelink"
                    }, "immix-remotelink")
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8E01L.default), {
                open: overviewNotice !== null,
                // Every notice stays until dismissed: a user who switches away for
                // the minutes a big group takes must still find what happened, and
                // the ready notice carries the click-to-download fallback.
                autoHideDuration: null,
                onClose: (_event, reason)=>{
                    if (reason === "clickaway") return;
                    setOverviewNotice(null);
                },
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                    elevation: 6,
                    variant: "filled",
                    severity: overviewNotice?.severity ?? "info",
                    onClose: ()=>setOverviewNotice(null),
                    sx: {
                        width: "100%",
                        fontFamily: "Mulish"
                    },
                    action: overviewNotice?.url ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                        color: "inherit",
                        size: "small",
                        href: overviewNotice.url,
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: 700
                        },
                        children: "Download"
                    }) : undefined,
                    children: overviewNotice?.message
                })
            })
        ]
    });
};




var $60vL1 = parcelRequire("60vL1");
var $cVCJe = parcelRequire("cVCJe");
parcelRequire("8T3gX");
const $fbd95a286762eec2$export$b0386cad75322218 = (groupsArray)=>{
    // check each object in the groups array and if object.children[0] exists, push it to the top of the array
    const groupsArrayCopy = [
        ...groupsArray
    ];
    const groupsWithChildren = groupsArrayCopy.filter((group)=>group.children[0] || group.parent_account);
    const groupsWithoutChildren = groupsArrayCopy.filter((group)=>!group.children[0] && !group.parent_account);
    const sortedGroupsArray = [
        ...groupsWithChildren,
        ...groupsWithoutChildren
    ];
    return sortedGroupsArray;
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");
var $0f42bd3abae37cbe$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($0f42bd3abae37cbe$exports, "__esModule", {
    value: true
});
$0f42bd3abae37cbe$exports.default = void 0;

var $0f42bd3abae37cbe$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $0f42bd3abae37cbe$var$_default = $0f42bd3abae37cbe$exports.default = (0, $0f42bd3abae37cbe$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), 'Search');



var $3RYg6 = parcelRequire("3RYg6");
var $anJSP = parcelRequire("anJSP");

var $iFXjq = parcelRequire("iFXjq");
const $c9d4fba0d4c728e8$export$4b85d3515bd863a5 = (0, $anJSP.default)("div")(({ theme: theme })=>({
        position: "relative",
        borderRadius: theme.shape.borderRadius,
        backgroundColor: (0, $3RYg6.alpha)(theme.palette.common.white, 0.75),
        "&:hover": {
            backgroundColor: (0, $3RYg6.alpha)(theme.palette.common.white, 1.0)
        },
        marginRight: theme.spacing(2),
        marginLeft: 0,
        width: "100%",
        [theme.breakpoints.up("sm")]: {
            marginLeft: theme.spacing(3),
            width: "auto"
        }
    }));
const $c9d4fba0d4c728e8$export$e9ad429a7452907b = (0, $anJSP.default)("div")(({ theme: theme })=>({
        padding: theme.spacing(0, 2),
        height: "100%",
        position: "absolute",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }));
const $c9d4fba0d4c728e8$export$b030dc24f7f252a3 = (0, $anJSP.default)((0, $iFXjq.default))(({ theme: theme })=>({
        color: "inherit",
        "& .MuiInputBase-input": {
            padding: theme.spacing(1, 1, 1, 0),
            // vertical padding + font size from searchIcon
            paddingLeft: `calc(1em + ${theme.spacing(4)})`,
            transition: theme.transitions.create("width"),
            width: "100%",
            [theme.breakpoints.up("md")]: {
                width: "30ch"
            }
        }
    }));



var $195EM = parcelRequire("195EM");

var $7pFvC = parcelRequire("7pFvC");

var $3Zv1D = parcelRequire("3Zv1D");
// The group search endpoint hides empty non-parent groups server-side, but
// empty parent accounts always come back (and users with the view_empty_group
// permission receive every empty group). site_count and group_count are
// direct-child counts annotated on every result, so a group with zero of both
// has nothing to show when clicked.
const $c511aaa08806b744$export$14748681f30eb616 = (results)=>{
    if (!Array.isArray(results)) return [];
    return results.filter((group)=>group?.site_count !== 0 || group?.group_count !== 0);
};


const $ad9453042faa292f$export$666887174726bd2f = async (inputValue, setSearchBarValue, setEditedParentGroupList, navigate, setBackdropLoadingScreenOn, // ENG-2682: the search bar aborts the previous search when a new one starts,
// so a slow earlier response can't overwrite the newer results.
signal)=>{
    setSearchBarValue(inputValue);
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        if (signal?.aborted) return;
        $ad9453042faa292f$export$666887174726bd2f(inputValue, setSearchBarValue, setEditedParentGroupList, navigate, setBackdropLoadingScreenOn, signal);
    };
    const groupType = window.location.pathname.includes("patrol") ? "patrol" : "connector";
    await AxiosUI.get(`group/?search=${encodeURIComponent(inputValue)}&group_type=${groupType}`, {
        signal: signal
    }).then((response)=>{
        if (signal?.aborted) return;
        setBackdropLoadingScreenOn(false);
        setEditedParentGroupList((0, $c511aaa08806b744$export$14748681f30eb616)(response.data.results));
    }, (reason)=>{
        // A newer search replaced this one: nothing to show or retry.
        if ((0, (/*@__PURE__*/$parcel$interopDefault($7pFvC))).isCancel(reason) || signal?.aborted) return;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, (context)=>{
            // A failed search used to leave the loading overlay up for good.
            if (!context?.willRetry) setBackdropLoadingScreenOn(false);
        });
    });
};


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $7a4c5f32d6f9023c$export$daaf46d09df3262a = ({ setSearchBarValue: setSearchBarValue, setEditedParentGroupList: setEditedParentGroupList, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, searchBarValue: searchBarValue })=>{
    const navigate = (0, $3T949.useNavigate)();
    const [inputValue, setInputValue] = (0, $8T3gX.useState)(searchBarValue);
    const pathnameRef = (0, $8T3gX.useRef)(window.location.pathname);
    const didRunInitialSearch = (0, $8T3gX.useRef)(false);
    const searchAbortRef = (0, $8T3gX.useRef)(null);
    // Abort any search still in flight when the bar unmounts.
    (0, $8T3gX.useEffect)(()=>()=>searchAbortRef.current?.abort(), []);
    (0, $8T3gX.useEffect)(()=>{
        // Only run if pathname hasn't changed
        if (pathnameRef.current === window.location.pathname) {
            const timer = setTimeout(()=>{
                localStorage.setItem("siteSearchBarValue", inputValue);
                // Skip the group/?search= API call on initial mount when search is empty
                if (!didRunInitialSearch.current) {
                    didRunInitialSearch.current = true;
                    if ((inputValue ?? "").trim() === "") {
                        setSearchBarValue(inputValue ?? "");
                        return;
                    }
                }
                // ENG-2682: one search in flight at a time; the newest one wins.
                searchAbortRef.current?.abort();
                const controller = new AbortController();
                searchAbortRef.current = controller;
                (0, $ad9453042faa292f$export$666887174726bd2f)(inputValue, setSearchBarValue, setEditedParentGroupList, navigate, setBackdropLoadingScreenOn, controller.signal);
            }, 500);
            return ()=>clearTimeout(timer);
        }
    }, [
        inputValue,
        setSearchBarValue,
        setEditedParentGroupList,
        setBackdropLoadingScreenOn
    ]);
    // Update pathname ref when it changes
    (0, $8T3gX.useEffect)(()=>{
        pathnameRef.current = window.location.pathname;
    }, [
        window.location.pathname
    ]);
    const handleChange = (event)=>{
        setInputValue(event.target.value);
        setLocalSearchBarValue(event.target.value);
    };
    const [localSearchBarValue, setLocalSearchBarValue] = (0, $8T3gX.useState)(searchBarValue);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setLocalSearchBarValue("");
    }, [
        window.location.pathname
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $c9d4fba0d4c728e8$export$4b85d3515bd863a5), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $c9d4fba0d4c728e8$export$e9ad429a7452907b), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0f42bd3abae37cbe$exports))), {})
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $c9d4fba0d4c728e8$export$b030dc24f7f252a3), {
                value: localSearchBarValue,
                placeholder: "Search Groups...",
                onChange: handleChange,
                inputProps: {
                    "aria-label": "search"
                }
            })
        ]
    });
};



var $bHNwu = parcelRequire("bHNwu");

const $668c900d2e9ed468$export$f57e24d40c19b981 = ({ groupTrees: groupTrees, selectedIndex: selectedIndex, setPage: setPage, setCurrentTitle: setCurrentTitle, setSelectedIndex: setSelectedIndex, setRenderedRows: setRenderedRows, setPageLoading: setPageLoading, navigate: navigate, setSiteBreadcrumbs: setSiteBreadcrumbs, setAddGroupDialogOpen: setAddGroupDialogOpen, permissions: permissions, navBarCollapsed: navBarCollapsed, setSelected: setSelected, searchBarValue: searchBarValue, editedparentsGroupsList: editedparentsGroupsList, setSearchBarValue: setSearchBarValue, setEditedParentGroupList: setEditedParentGroupList, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setSelectedGroupListName: setSelectedGroupListName, setEditableGroupSelected: setEditableGroupSelected })=>{
    const { setSearchGroupId: setSearchGroupId } = (0, $0bb5fda2d17b239c$export$97ac24bd611f62c0)();
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (localStorage.level1Click === "true") {
            localStorage.setItem("getIndividualGroupId", localStorage.level1Id);
            setSearchGroupId(Number(localStorage.level1Id));
            (0, $9b1233e28e731320$export$316efaa9553dbeca)(Number(localStorage.level1Id), setRenderedRows, setPageLoading, setSiteBreadcrumbs, setSelected, setEditableGroupSelected, setSelectedGroupListName, navigate);
            setSelectedIndex((previousState)=>{
                return {
                    ...previousState,
                    level1: [
                        Number(localStorage.level1Id)
                    ]
                };
            });
            localStorage.removeItem("level2Id");
            localStorage.removeItem("level3Id");
            localStorage.removeItem("level4Id");
            localStorage.removeItem("level5Id");
            localStorage.setItem("level1Click", "false");
        } else if (localStorage.level2Click === "true") {
            localStorage.setItem("getIndividualGroupId", localStorage.level2Id);
            setSearchGroupId(Number(localStorage.level2Id));
            (0, $9b1233e28e731320$export$316efaa9553dbeca)(Number(localStorage.level2Id), setRenderedRows, setPageLoading, setSiteBreadcrumbs, setSelected, setEditableGroupSelected, setSelectedGroupListName, navigate);
            window.location.pathname.includes("patrol") ? setSelectedIndex((previousState)=>{
                return {
                    ...previousState,
                    level1: [
                        Number(localStorage.level2Id)
                    ],
                    level2: []
                };
            }) : setSelectedIndex((previousState)=>{
                return {
                    ...previousState,
                    level1: [
                        Number(localStorage.level1Id)
                    ],
                    level2: [
                        Number(localStorage.level2Id)
                    ]
                };
            });
            localStorage.removeItem("level3Id");
            localStorage.removeItem("level4Id");
            localStorage.removeItem("level5Id");
            localStorage.setItem("level2Click", "false");
        } else if (localStorage.level3Click === "true") {
            localStorage.setItem("getIndividualGroupId", localStorage.level3Id);
            setSearchGroupId(Number(localStorage.level3Id));
            (0, $9b1233e28e731320$export$316efaa9553dbeca)(Number(localStorage.level3Id), setRenderedRows, setPageLoading, setSiteBreadcrumbs, setSelected, setEditableGroupSelected, setSelectedGroupListName, navigate);
            setSelectedIndex((previousState)=>{
                return {
                    ...previousState,
                    level1: [
                        Number(localStorage.level1Id)
                    ],
                    level2: [
                        Number(localStorage.level2Id)
                    ],
                    level3: [
                        Number(localStorage.level3Id)
                    ]
                };
            });
            localStorage.removeItem("level4Id");
            localStorage.removeItem("level5Id");
            localStorage.setItem("level3Click", "false");
        } else if (localStorage.level4Click === "true") {
            localStorage.setItem("getIndividualGroupId", localStorage.level4Id);
            setSearchGroupId(Number(localStorage.level4Id));
            (0, $9b1233e28e731320$export$316efaa9553dbeca)(Number(localStorage.level4Id), setRenderedRows, setPageLoading, setSiteBreadcrumbs, setSelected, setEditableGroupSelected, setSelectedGroupListName, navigate);
            setSelectedIndex((previousState)=>{
                return {
                    ...previousState,
                    level1: [
                        Number(localStorage.level1Id)
                    ],
                    level2: [
                        Number(localStorage.level2Id)
                    ],
                    level3: [
                        Number(localStorage.level3Id)
                    ],
                    level4: [
                        Number(localStorage.level4Id)
                    ]
                };
            });
            localStorage.removeItem("level5Id");
            localStorage.setItem("level4Click", "false");
        } else if (localStorage.level5Click === "true") {
            localStorage.setItem("getIndividualGroupId", localStorage.level5Id);
            setSearchGroupId(Number(localStorage.level5Id));
            (0, $9b1233e28e731320$export$316efaa9553dbeca)(Number(localStorage.level5Id), setRenderedRows, setPageLoading, setSiteBreadcrumbs, setSelected, setEditableGroupSelected, setSelectedGroupListName, navigate);
            setSelectedIndex((previousState)=>{
                return {
                    ...previousState,
                    level1: [
                        Number(localStorage.level1Id)
                    ],
                    level2: [
                        Number(localStorage.level2Id)
                    ],
                    level3: [
                        Number(localStorage.level3Id)
                    ],
                    level4: [
                        Number(localStorage.level4Id)
                    ],
                    level5: [
                        Number(localStorage.level5Id)
                    ]
                };
            });
            localStorage.setItem("level5Click", "false");
        }
    }, []);
    const { getSelectedGroupCounts: getSelectedGroupCounts, selectedGroupCounts: selectedGroupCounts, fetchingSelectedGroupCounts: fetchingSelectedGroupCounts } = (0, $0bb5fda2d17b239c$export$97ac24bd611f62c0)();
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kCUgG.default), {
            sx: {
                width: "100%",
                maxWidth: 360,
                bgcolor: "background.paper"
            },
            component: "nav",
            "aria-labelledby": "nested-list-subheader",
            subheader: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $bAwA3.default), {
                sx: {
                    fontSize: "18px",
                    fontFamily: "Mulish"
                },
                component: "div",
                id: "all-parent-group-subheader",
                children: [
                    searchBarValue ? `Filtered Groups (${editedparentsGroupsList.length})` : "Parent Groups & Sites",
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "relative left-[185px] top-[-48px] h-[1px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $c13bdca64b3a3322$export$cd305fa8a11563b2), {
                            navigate: navigate,
                            setAddGroupDialogOpen: setAddGroupDialogOpen
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "relative left-[-40px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $7a4c5f32d6f9023c$export$daaf46d09df3262a), {
                            setSearchBarValue: setSearchBarValue,
                            setEditedParentGroupList: setEditedParentGroupList,
                            setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                            searchBarValue: searchBarValue
                        })
                    })
                ]
            }),
            children: groupTrees === undefined ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "relative left-[55px] top-[15px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                        size: 25,
                        sx: {
                            position: "relative",
                            left: 45
                        }
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "font-mulish text-bold",
                        children: "Fetching groups..."
                    })
                ]
            }) : searchBarValue ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                children: [
                    editedparentsGroupsList.length === 0 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "font-mulish text-sm text-gray-500 pl-4 pt-2",
                        children: `No sites found for "${searchBarValue}"`
                    }),
                    editedparentsGroupsList.map((arrayLvl1Item)=>{
                        if (arrayLvl1Item.parent_account) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                            title: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                children: [
                                    fetchingSelectedGroupCounts && (!selectedGroupCounts || selectedGroupCounts.id !== arrayLvl1Item.id) && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        children: "Loading counts..."
                                    }),
                                    selectedGroupCounts && selectedGroupCounts.id === arrayLvl1Item.id && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                children: arrayLvl1Item.name
                                            }),
                                            selectedGroupCounts.sub_groups !== undefined && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                children: `Sub Groups: ${selectedGroupCounts.sub_groups}`
                                            }),
                                            selectedGroupCounts.sites !== undefined && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                children: `Sites: ${selectedGroupCounts.sites}`
                                            })
                                        ]
                                    })
                                ]
                            }),
                            placement: "right",
                            onOpen: ()=>{
                                getSelectedGroupCounts(navigate, arrayLvl1Item.id);
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $07bcecd6345c33ee$export$2e2bcd8739ae039), {
                                onClick: ()=>{
                                    (0, $cc709c0532055ee2$export$f0a14f1c87176f9d)(setPage, setCurrentTitle, arrayLvl1Item.name, arrayLvl1Item.id, setRenderedRows, setPageLoading, navigate, setSiteBreadcrumbs, setSelected, false, setSelectedGroupListName, setEditableGroupSelected);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $fc0c7440c238b2e1$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c712346e3704c7fb$exports))), {})
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $a7d6d1bc115c33d6$export$2e2bcd8739ae039), {
                                        primary: arrayLvl1Item.name,
                                        primaryTypographyProps: {
                                            fontSize: 14,
                                            fontFamily: "Mulish"
                                        }
                                    })
                                ]
                            })
                        }, arrayLvl1Item.id);
                        else return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $07bcecd6345c33ee$export$2e2bcd8739ae039), {
                            onClick: ()=>{
                                (0, $cc709c0532055ee2$export$f0a14f1c87176f9d)(setPage, setCurrentTitle, arrayLvl1Item.name, arrayLvl1Item.id, setRenderedRows, setPageLoading, navigate, setSiteBreadcrumbs, setSelected, true, setSelectedGroupListName, setEditableGroupSelected);
                            },
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "relative left-[-15px]",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fc0c7440c238b2e1$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $bHNwu.CameraIcon), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "relative",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a7d6d1bc115c33d6$export$2e2bcd8739ae039), {
                                        primary: arrayLvl1Item.name,
                                        primaryTypographyProps: {
                                            fontSize: 14,
                                            fontFamily: "Mulish"
                                        }
                                    })
                                })
                            ]
                        }, arrayLvl1Item.id);
                    })
                ]
            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                children: (0, $fbd95a286762eec2$export$b0386cad75322218)(groupTrees).map((arrayLvl1Item)=>{
                    if (arrayLvl1Item.children[0]) return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ebcce0ea28455bc0$export$f0f8687183866d47), {
                                arrayItem: arrayLvl1Item,
                                selectedIndex: selectedIndex,
                                setPage: setPage,
                                setCurrentTitle: setCurrentTitle,
                                levelName: "level1",
                                setSelectedIndex: setSelectedIndex,
                                setRenderedRows: setRenderedRows,
                                setPageLoading: setPageLoading,
                                navigate: navigate,
                                indentNumber: undefined,
                                setSiteBreadcrumbs: setSiteBreadcrumbs,
                                navBarCollapsed: navBarCollapsed,
                                setSelected: setSelected,
                                setSelectedGroupListName: setSelectedGroupListName,
                                setEditableGroupSelected: setEditableGroupSelected
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $yndCB.default), {
                                in: selectedIndex.level1.includes(arrayLvl1Item.id),
                                timeout: "auto",
                                unmountOnExit: true,
                                children: (0, $fbd95a286762eec2$export$b0386cad75322218)(arrayLvl1Item.children).map((arrayLvl2Item)=>{
                                    if (arrayLvl2Item.children[0]) return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ebcce0ea28455bc0$export$f0f8687183866d47), {
                                                arrayItem: arrayLvl2Item,
                                                selectedIndex: selectedIndex,
                                                setPage: setPage,
                                                setCurrentTitle: setCurrentTitle,
                                                levelName: "level2",
                                                setSelectedIndex: setSelectedIndex,
                                                setRenderedRows: setRenderedRows,
                                                setPageLoading: setPageLoading,
                                                navigate: navigate,
                                                indentNumber: 5,
                                                setSiteBreadcrumbs: setSiteBreadcrumbs,
                                                navBarCollapsed: navBarCollapsed,
                                                setSelected: setSelected,
                                                setSelectedGroupListName: setSelectedGroupListName,
                                                setEditableGroupSelected: setEditableGroupSelected
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $yndCB.default), {
                                                in: // arrayLvl2Item.id === selectedIndex.level2
                                                selectedIndex.level2.includes(arrayLvl2Item.id),
                                                timeout: "auto",
                                                unmountOnExit: true,
                                                children: (0, $fbd95a286762eec2$export$b0386cad75322218)(arrayLvl2Item.children).map((arrayLvl3Item)=>{
                                                    if (arrayLvl3Item.children[0]) return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ebcce0ea28455bc0$export$f0f8687183866d47), {
                                                                arrayItem: arrayLvl3Item,
                                                                selectedIndex: selectedIndex,
                                                                setPage: setPage,
                                                                setCurrentTitle: setCurrentTitle,
                                                                levelName: "level3",
                                                                setSelectedIndex: setSelectedIndex,
                                                                setRenderedRows: setRenderedRows,
                                                                setPageLoading: setPageLoading,
                                                                navigate: navigate,
                                                                indentNumber: 8,
                                                                setSiteBreadcrumbs: setSiteBreadcrumbs,
                                                                navBarCollapsed: navBarCollapsed,
                                                                setSelected: setSelected,
                                                                setSelectedGroupListName: setSelectedGroupListName,
                                                                setEditableGroupSelected: setEditableGroupSelected
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $yndCB.default), {
                                                                in: selectedIndex.level3.includes(arrayLvl3Item.id),
                                                                timeout: "auto",
                                                                unmountOnExit: true,
                                                                children: (0, $fbd95a286762eec2$export$b0386cad75322218)(arrayLvl3Item.children).map((arrayLvl4Item)=>{
                                                                    if (arrayLvl4Item.children[0]) return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ebcce0ea28455bc0$export$f0f8687183866d47), {
                                                                                arrayItem: arrayLvl4Item,
                                                                                selectedIndex: selectedIndex,
                                                                                setPage: setPage,
                                                                                setCurrentTitle: setCurrentTitle,
                                                                                levelName: "level4",
                                                                                setSelectedIndex: setSelectedIndex,
                                                                                setRenderedRows: setRenderedRows,
                                                                                setPageLoading: setPageLoading,
                                                                                navigate: navigate,
                                                                                indentNumber: 11,
                                                                                setSiteBreadcrumbs: setSiteBreadcrumbs,
                                                                                navBarCollapsed: navBarCollapsed,
                                                                                setSelected: setSelected,
                                                                                setSelectedGroupListName: setSelectedGroupListName,
                                                                                setEditableGroupSelected: setEditableGroupSelected
                                                                            }),
                                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $yndCB.default), {
                                                                                in: selectedIndex.level4.includes(arrayLvl4Item.id),
                                                                                timeout: "auto",
                                                                                unmountOnExit: true,
                                                                                children: (0, $fbd95a286762eec2$export$b0386cad75322218)(arrayLvl4Item.children).map((arrayLvl5Item)=>{
                                                                                    if (arrayLvl5Item.children[0]) return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ebcce0ea28455bc0$export$f0f8687183866d47), {
                                                                                                arrayItem: arrayLvl5Item,
                                                                                                selectedIndex: selectedIndex,
                                                                                                setPage: setPage,
                                                                                                setCurrentTitle: setCurrentTitle,
                                                                                                levelName: "level5",
                                                                                                setSelectedIndex: setSelectedIndex,
                                                                                                setRenderedRows: setRenderedRows,
                                                                                                setPageLoading: setPageLoading,
                                                                                                navigate: navigate,
                                                                                                indentNumber: 14,
                                                                                                setSiteBreadcrumbs: setSiteBreadcrumbs,
                                                                                                navBarCollapsed: navBarCollapsed,
                                                                                                setSelected: setSelected,
                                                                                                setSelectedGroupListName: setSelectedGroupListName,
                                                                                                setEditableGroupSelected: setEditableGroupSelected
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $yndCB.default), {
                                                                                                in: selectedIndex.level5.includes(arrayLvl5Item.id),
                                                                                                timeout: "auto",
                                                                                                unmountOnExit: true,
                                                                                                children: (0, $fbd95a286762eec2$export$b0386cad75322218)(arrayLvl5Item.children).map((arrayLvl6Item)=>{
                                                                                                    if (arrayLvl6Item.children[0]) return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ebcce0ea28455bc0$export$f0f8687183866d47), {
                                                                                                            arrayItem: arrayLvl6Item,
                                                                                                            selectedIndex: selectedIndex,
                                                                                                            setPage: setPage,
                                                                                                            setCurrentTitle: setCurrentTitle,
                                                                                                            levelName: "level6",
                                                                                                            setSelectedIndex: setSelectedIndex,
                                                                                                            setRenderedRows: setRenderedRows,
                                                                                                            setPageLoading: setPageLoading,
                                                                                                            navigate: navigate,
                                                                                                            indentNumber: 17,
                                                                                                            setSiteBreadcrumbs: setSiteBreadcrumbs,
                                                                                                            navBarCollapsed: navBarCollapsed,
                                                                                                            setSelected: setSelected,
                                                                                                            setSelectedGroupListName: setSelectedGroupListName,
                                                                                                            setEditableGroupSelected: setEditableGroupSelected
                                                                                                        })
                                                                                                    }, arrayLvl6Item.id);
                                                                                                    else return /*#__PURE__*/ (0, $k4ank.jsx)((0, $kCUgG.default), {
                                                                                                        component: "div",
                                                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $e346ba6328ad9558$export$b4073a2b7704d03d), {
                                                                                                            arrayItem: arrayLvl6Item,
                                                                                                            setPage: setPage,
                                                                                                            setCurrentTitle: setCurrentTitle,
                                                                                                            indentNumber: 12,
                                                                                                            setRenderedRows: setRenderedRows,
                                                                                                            setPageLoading: setPageLoading,
                                                                                                            navigate: navigate,
                                                                                                            setSiteBreadcrumbs: setSiteBreadcrumbs,
                                                                                                            navBarCollapsed: navBarCollapsed,
                                                                                                            setSelected: setSelected,
                                                                                                            setSelectedGroupListName: setSelectedGroupListName,
                                                                                                            setEditableGroupSelected: setEditableGroupSelected
                                                                                                        })
                                                                                                    }, arrayLvl6Item.id);
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    }, arrayLvl5Item.id);
                                                                                    else return /*#__PURE__*/ (0, $k4ank.jsx)((0, $kCUgG.default), {
                                                                                        component: "div",
                                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $e346ba6328ad9558$export$b4073a2b7704d03d), {
                                                                                            arrayItem: arrayLvl5Item,
                                                                                            setPage: setPage,
                                                                                            setCurrentTitle: setCurrentTitle,
                                                                                            indentNumber: 12,
                                                                                            setRenderedRows: setRenderedRows,
                                                                                            setPageLoading: setPageLoading,
                                                                                            navigate: navigate,
                                                                                            setSiteBreadcrumbs: setSiteBreadcrumbs,
                                                                                            navBarCollapsed: navBarCollapsed,
                                                                                            setSelected: setSelected,
                                                                                            setSelectedGroupListName: setSelectedGroupListName,
                                                                                            setEditableGroupSelected: setEditableGroupSelected
                                                                                        })
                                                                                    }, arrayLvl5Item.id);
                                                                                })
                                                                            })
                                                                        ]
                                                                    }, arrayLvl4Item.id);
                                                                    else return /*#__PURE__*/ (0, $k4ank.jsx)((0, $kCUgG.default), {
                                                                        component: "div",
                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $e346ba6328ad9558$export$b4073a2b7704d03d), {
                                                                            arrayItem: arrayLvl4Item,
                                                                            setPage: setPage,
                                                                            setCurrentTitle: setCurrentTitle,
                                                                            indentNumber: 9,
                                                                            setRenderedRows: setRenderedRows,
                                                                            setPageLoading: setPageLoading,
                                                                            navigate: navigate,
                                                                            setSiteBreadcrumbs: setSiteBreadcrumbs,
                                                                            navBarCollapsed: navBarCollapsed,
                                                                            setSelected: setSelected,
                                                                            setSelectedGroupListName: setSelectedGroupListName,
                                                                            setEditableGroupSelected: setEditableGroupSelected
                                                                        })
                                                                    }, arrayLvl4Item.id);
                                                                })
                                                            })
                                                        ]
                                                    }, arrayLvl3Item.id);
                                                    else return /*#__PURE__*/ (0, $k4ank.jsx)((0, $kCUgG.default), {
                                                        component: "div",
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $e346ba6328ad9558$export$b4073a2b7704d03d), {
                                                            arrayItem: arrayLvl3Item,
                                                            setPage: setPage,
                                                            setCurrentTitle: setCurrentTitle,
                                                            indentNumber: 6,
                                                            setRenderedRows: setRenderedRows,
                                                            setPageLoading: setPageLoading,
                                                            navigate: navigate,
                                                            setSiteBreadcrumbs: setSiteBreadcrumbs,
                                                            navBarCollapsed: navBarCollapsed,
                                                            setSelected: setSelected,
                                                            setSelectedGroupListName: setSelectedGroupListName,
                                                            setEditableGroupSelected: setEditableGroupSelected
                                                        })
                                                    }, arrayLvl3Item.id);
                                                })
                                            })
                                        ]
                                    }, arrayLvl2Item.id);
                                    else return /*#__PURE__*/ (0, $k4ank.jsx)((0, $kCUgG.default), {
                                        component: "div",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $e346ba6328ad9558$export$b4073a2b7704d03d), {
                                            arrayItem: arrayLvl2Item,
                                            setPage: setPage,
                                            setCurrentTitle: setCurrentTitle,
                                            indentNumber: 3,
                                            setRenderedRows: setRenderedRows,
                                            setPageLoading: setPageLoading,
                                            navigate: navigate,
                                            setSiteBreadcrumbs: setSiteBreadcrumbs,
                                            navBarCollapsed: navBarCollapsed,
                                            setSelected: setSelected,
                                            setSelectedGroupListName: setSelectedGroupListName,
                                            setEditableGroupSelected: setEditableGroupSelected
                                        })
                                    }, arrayLvl2Item.id);
                                })
                            })
                        ]
                    }, arrayLvl1Item.id);
                    else {
                        if (arrayLvl1Item.parent_account) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                            title: fetchingSelectedGroupCounts ? /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                children: "Loading counts..."
                            }) : selectedGroupCounts && selectedGroupCounts.id === arrayLvl1Item.id && selectedGroupCounts.sites !== undefined ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        children: arrayLvl1Item.name
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        children: `Sub Groups: ${selectedGroupCounts.sub_groups}`
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        children: `Sites: ${selectedGroupCounts.sites}`
                                    })
                                ]
                            }) : null,
                            placement: "right",
                            onOpen: ()=>{
                                getSelectedGroupCounts(navigate, arrayLvl1Item.id);
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $07bcecd6345c33ee$export$2e2bcd8739ae039), {
                                onClick: ()=>{
                                    (0, $cc709c0532055ee2$export$f0a14f1c87176f9d)(setPage, setCurrentTitle, arrayLvl1Item.name, arrayLvl1Item.id, setRenderedRows, setPageLoading, navigate, setSiteBreadcrumbs, setSelected, false, setSelectedGroupListName, setEditableGroupSelected);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $fc0c7440c238b2e1$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c712346e3704c7fb$exports))), {})
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $a7d6d1bc115c33d6$export$2e2bcd8739ae039), {
                                        primary: `${arrayLvl1Item.name}`,
                                        primaryTypographyProps: {
                                            fontSize: 14,
                                            fontFamily: "Mulish"
                                        }
                                    })
                                ]
                            }, arrayLvl1Item.id)
                        }, arrayLvl1Item.id);
                        else return /*#__PURE__*/ (0, $k4ank.jsx)((0, $kCUgG.default), {
                            component: "div",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $e346ba6328ad9558$export$b4073a2b7704d03d), {
                                arrayItem: arrayLvl1Item,
                                setPage: setPage,
                                setCurrentTitle: setCurrentTitle,
                                indentNumber: 0,
                                setRenderedRows: setRenderedRows,
                                setPageLoading: setPageLoading,
                                navigate: navigate,
                                setSiteBreadcrumbs: setSiteBreadcrumbs,
                                navBarCollapsed: navBarCollapsed,
                                setSelected: setSelected,
                                setSelectedGroupListName: setSelectedGroupListName,
                                setEditableGroupSelected: setEditableGroupSelected
                            })
                        }, arrayLvl1Item.id);
                    }
                })
            })
        })
    });
};



var $3Nm8Z = parcelRequire("3Nm8Z");

var $crpct = parcelRequire("crpct");

var $60vL1 = parcelRequire("60vL1");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $1wcxl = parcelRequire("1wcxl");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");
const $516d697317347b79$export$219817a61b68f7e1 = (event, newPage, setPage)=>{
    setPage(newPage);
    localStorage.setItem("sitesTablePage", newPage.toString());
};


const $d4a3124cb14e8591$export$8f225a03c4563930 = (event, setRowsPerPage, setPage)=>{
    setRowsPerPage(event.target.value);
    localStorage.setItem("sitesRowsPerPage", event.target.value);
    setPage(0);
    localStorage.setItem("sitesTablePage", "0");
};



var $fWsn7 = parcelRequire("fWsn7");

var $5Ibhh = parcelRequire("5Ibhh");

var $cye0Y = parcelRequire("cye0Y");

var $cFPmV = parcelRequire("cFPmV");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");
var $aVDw9 = parcelRequire("aVDw9");
var $ha39s = parcelRequire("ha39s");
var $4o6Cs = parcelRequire("4o6Cs");
var $kLvBh = parcelRequire("kLvBh");
var $cVCJe = parcelRequire("cVCJe");

var $ePwXE = parcelRequire("ePwXE");

var $9lVTU = parcelRequire("9lVTU");

var $kbChx = parcelRequire("kbChx");

var $aYdit = parcelRequire("aYdit");
const $d7016a2e03c6974f$var$headCells = [
    {
        id: "name",
        numeric: false,
        label: "Site Name"
    },
    {
        id: "armed",
        numeric: false,
        label: "Armed"
    },
    {
        id: "cameras",
        numeric: true,
        label: `Cameras`
    },
    {
        id: "health",
        numeric: false,
        label: "Health"
    },
    {
        id: "optimal_settings_number",
        numeric: false,
        label: "Optimal Settings"
    },
    // {
    //   id: "schedules",
    //   numeric: false,
    //   label: "Schedules",
    // },
    {
        id: "bandwidth",
        numeric: false,
        label: "Bandwidth Usage"
    },
    {
        id: "deployed",
        numeric: false,
        label: "Synced"
    },
    {
        id: "active",
        numeric: false,
        label: "Active"
    }
];
const $d7016a2e03c6974f$var$headCellsPatrolOnly = [
    {
        id: "name",
        numeric: false,
        label: "Site Name"
    },
    // {
    //   id: "cameras",
    //   numeric: true,
    //   label: `Cameras`,
    // },
    {
        id: "active",
        numeric: false,
        label: "Active"
    },
    {
        id: "patrol_schedules",
        numeric: true,
        label: "Patrol Schedules"
    }
];
const $d7016a2e03c6974f$var$activeText = "A green checkmark indicates that the site is running. A red X indicates the site is off.";
const $d7016a2e03c6974f$var$armedText = "A metric that shares if the site is scheduled to send alerts at the time of viewing or not. If the icon is a yellow or grey alert symbol, hovering over it will specify any issues that are present. A red X indicates the site is disarmed.";
const $d7016a2e03c6974f$var$bandwidth_usageText = "How much data Actuate is receiving from the site. Normal usage should be less than 100 kbps per camera at the site.";
const $d7016a2e03c6974f$var$healthText = "An indicator of healthy cameras.  If all cameras are healthy an green checkmark is displayed. If 1 or more cameras is not healthy the number of unhealthy cameras is displayed along with a red X.";
const $d7016a2e03c6974f$var$optimalText = "A green checkmark indicates that all cameras have optimal settings. A warning symbol indicate that some cameras have acceptable but not optimal settings that may result in performance issues. A red X indicates that some cameras have bad settings that will likely result in performance issues.";
const $d7016a2e03c6974f$export$c84958dc9f5c6fe = (props)=>{
    const { onRequestSort: onRequestSort, orderBy: orderBy, order: order, onSelectAllClick: onSelectAllClick, selectAllDisabled: selectAllDisabled } = props;
    const patrolOnlySitesPage = window.location.pathname.includes("patrol") ? true : false;
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    const headCellsToDisplay = patrolOnlySitesPage ? $d7016a2e03c6974f$var$headCellsPatrolOnly : $d7016a2e03c6974f$var$headCells;
    const createSortHandler = (property)=>(event)=>{
            onRequestSort(event, property);
        };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
            children: [
                !patrolOnlySitesPage && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    padding: "checkbox",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                        color: "primary",
                        onChange: onSelectAllClick,
                        disabled: !!selectAllDisabled,
                        inputProps: {
                            "aria-label": selectAllDisabled ? "Select all (available once every site has loaded)" : "Select all"
                        }
                    })
                }),
                headCellsToDisplay.map((headCell)=>{
                    let itemText = "";
                    if (headCell.id === "active") itemText = $d7016a2e03c6974f$var$activeText;
                    else if (headCell.id === "armed") itemText = $d7016a2e03c6974f$var$armedText;
                    else if (headCell.id === "bandwidth") itemText = $d7016a2e03c6974f$var$bandwidth_usageText;
                    else if (headCell.id === "health") itemText = $d7016a2e03c6974f$var$healthText;
                    else if (headCell.id === "optimal_settings_number") itemText = $d7016a2e03c6974f$var$optimalText;
                    if (headCell.id === "armed" || headCell.id === "health" || headCell.id === "bandwidth" || headCell.id === "active" || headCell.id === "optimal_settings_number") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                        sx: {
                            fontSize: "12px",
                            fontFamily: "mulish",
                            fontWeight: "Bold",
                            maxWidth: 50
                        },
                        style: {
                            minWidth: headCell.id === "optimal_settings_number" ? 90 : 95
                        },
                        align: "left",
                        sortDirection: orderBy === headCell.id ? order : false,
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kLvBh.default), {
                            active: orderBy === headCell.id,
                            direction: orderBy === headCell.id ? order : "asc",
                            onClick: createSortHandler(headCell.id),
                            children: [
                                headCell.label,
                                "\xa0",
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                    title: itemText,
                                    placement: "top",
                                    sx: {
                                        fontSize: "12px",
                                        fontFamily: "mulish"
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                        fontSize: "small"
                                    })
                                }),
                                orderBy === headCell.id ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                    component: "span",
                                    sx: (0, $9lVTU.default),
                                    children: order === "desc" ? "sorted descending" : "sorted ascending"
                                }) : null
                            ]
                        })
                    }, headCell.id);
                    else return /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                        sx: {
                            fontSize: "12px",
                            fontFamily: "mulish",
                            fontWeight: "Bold"
                        },
                        style: {
                            maxWidth: 100
                        },
                        align: "left",
                        sortDirection: orderBy === headCell.id ? order : false,
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kLvBh.default), {
                            active: orderBy === headCell.id,
                            direction: orderBy === headCell.id ? order : "asc",
                            onClick: createSortHandler(headCell.id),
                            children: [
                                headCell.label,
                                orderBy === headCell.id ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                    component: "span",
                                    sx: (0, $9lVTU.default),
                                    children: order === "desc" ? "sorted descending" : "sorted ascending"
                                }) : null
                            ]
                        })
                    }, headCell.id);
                }),
                !patrolOnlySitesPage && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {})
            ]
        })
    });
};



var $crpct = parcelRequire("crpct");
parcelRequire("8T3gX");

var $9OjAn = parcelRequire("9OjAn");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("8T3gX");
const $56d755191d61e930$export$10aa7e930ee49de0 = (conversionArray)=>{
    const finalConversionsArray = [];
    let max7 = 0;
    conversionArray.forEach((obj)=>{
        if (max7 > 6) return;
        finalConversionsArray.push(obj);
        max7 += 1;
    });
    const totalsArray = [];
    finalConversionsArray.forEach((obj)=>{
        let total = 0;
        for(const key in obj)if (key !== "name" && key !== "abreviated_name") total += Number(obj[key]);
        totalsArray.push([
            total,
            obj
        ]);
    });
    const sortingFucntion = (a, b)=>{
        return b[0] - a[0];
    };
    totalsArray.sort(sortingFucntion);
    const finalArray = [];
    totalsArray.forEach((array)=>{
        finalArray.push(array[1]);
    });
    return finalArray;
};


parcelRequire("8T3gX");
const $0f328bc1569eb013$export$b0850dcaeb58b1b1 = (parentGroupsAlertsData, setConversionArray, setShowMoreVisible)=>{
    const conversionArray = [];
    parentGroupsAlertsData.forEach((object)=>{
        if (!conversionArray[0]) {
            const pushedObject = {
                name: object.name,
                abreviated_name: object.abreviated_name,
                [object.label.name]: object.alert_volume
            };
            conversionArray.push(pushedObject);
        }
        let nameExists = false;
        conversionArray.forEach((obj, index)=>{
            if (object.name === obj.name) {
                nameExists = true;
                conversionArray[index][object.label.name] = object.alert_volume;
            }
            if (index === conversionArray.length - 1 && !nameExists) conversionArray.push({
                name: object.name,
                abreviated_name: object.abreviated_name,
                [object.label.name]: object.alert_volume
            });
        });
    });
    if (conversionArray.length > 7) setShowMoreVisible(true);
    if (conversionArray.length < 8) setShowMoreVisible(false);
    setConversionArray(conversionArray);
    return conversionArray;
};


const $0acc3663e9cf84b8$var$startDate = new Date();
$0acc3663e9cf84b8$var$startDate.setDate($0acc3663e9cf84b8$var$startDate.getDate() - 5);
const $0acc3663e9cf84b8$var$endDate = new Date();
const $0acc3663e9cf84b8$var$savedAnalyticsFilters = JSON.parse(localStorage.savedAnalyticsFilters || "null");
const $0acc3663e9cf84b8$var$savedSiteDropDownValue = JSON.parse(localStorage.siteDropDownValueAnalytics || "null");
const $0acc3663e9cf84b8$var$savedCameraDropDownValue = JSON.parse(localStorage.cameraDropDownValueAnalytics || "null");
const $0acc3663e9cf84b8$var$getTotalAlerts = (allAlertsData)=>{
    let totalAlerts = 0;
    allAlertsData.forEach((alert1)=>{
        totalAlerts += alert1.alert_volume;
    });
    return totalAlerts;
};
const $0acc3663e9cf84b8$export$e69ca36e0aa135e7 = (0, $9OjAn.create)((set, get)=>({
        // Loading states
        loadingData: {
            allAlertsData: true,
            parentGroupsData: true,
            falsePositiveData: true,
            percetageOfMotionData: true
        },
        pageLoading: false,
        loadingSites: false,
        loadingCameras: false,
        parentAccountsLoading: true,
        // Dropdown values and options
        siteDropDownValue: localStorage.filtersSavedClicked === "true" && $0acc3663e9cf84b8$var$savedSiteDropDownValue ? $0acc3663e9cf84b8$var$savedSiteDropDownValue : [],
        cameraDropDownValue: localStorage.filtersSavedClicked === "true" && $0acc3663e9cf84b8$var$savedCameraDropDownValue ? $0acc3663e9cf84b8$var$savedCameraDropDownValue : [],
        siteOptions: [],
        cameraOptions: [],
        // Data arrays and objects
        allAlertsData: [],
        parentGroupsAlertsData: [],
        falsePostiveData: [],
        percetageOfMotionData: [],
        visibleArray: [],
        conversionArray: [],
        parentAccounts: [],
        parentIds: new Map(),
        parentNames: new Map(),
        totalAlerts: 0,
        // UI state
        showMoreVisible: false,
        showMoreOpen: false,
        displayOnLeftBool: false,
        filtersSavedClicked: localStorage.filtersSavedClicked === "true",
        dateChangesMade: false,
        filtersApplied: false,
        // Names and URLs
        alertGraphName: "Parent Group",
        dateGraphName: "",
        downloadURL: "",
        alertURL: "",
        // Filters and metrics
        userFilters: localStorage.filtersSavedClicked === "true" && $0acc3663e9cf84b8$var$savedAnalyticsFilters ? {
            parent_group: $0acc3663e9cf84b8$var$savedAnalyticsFilters.parent_group,
            site: $0acc3663e9cf84b8$var$savedAnalyticsFilters.site,
            camera: $0acc3663e9cf84b8$var$savedAnalyticsFilters.camera,
            start_date: $0acc3663e9cf84b8$var$startDate,
            end_date: $0acc3663e9cf84b8$var$endDate
        } : {
            parent_group: "",
            site: [],
            camera: [],
            start_date: $0acc3663e9cf84b8$var$startDate,
            end_date: $0acc3663e9cf84b8$var$endDate
        },
        averagePercentageOfMotion: NaN,
        alertState: {
            dateTooFar: false,
            startAfterEnd: false,
            endBeforeStart: false
        },
        // Chart dimensions
        barChartHeight: 385,
        barChartHeightFull: 600,
        outerBoxHeight: 425,
        outerBoxHeightFull: 640,
        innerBoxHeight: 423,
        innerBoxHeightFull: 638,
        // Chart dimension setters
        setBarChartHeight: (height)=>set({
                barChartHeight: height
            }),
        setOuterBoxHeight: (height)=>set({
                outerBoxHeight: height
            }),
        setInnerBoxHeight: (height)=>set({
                innerBoxHeight: height
            }),
        // Setters
        setLoadingData: (loadingData)=>set((state)=>({
                    loadingData: {
                        ...state.loadingData,
                        ...loadingData
                    }
                })),
        setPageLoading: (loading)=>set({
                pageLoading: loading
            }),
        setLoadingSites: (loading)=>set({
                loadingSites: loading
            }),
        setLoadingCameras: (loading)=>set({
                loadingCameras: loading
            }),
        setParentAccountsLoading: (loading)=>set({
                parentAccountsLoading: loading
            }),
        setSiteDropDownValue: (value)=>set({
                siteDropDownValue: value
            }),
        setCameraDropDownValue: (value)=>set({
                cameraDropDownValue: value
            }),
        setSiteOptions: (options)=>set({
                siteOptions: options
            }),
        setCameraOptions: (options)=>set({
                cameraOptions: options
            }),
        setAllAlertsData: (data)=>set({
                allAlertsData: data
            }),
        setParentGroupsAlertsData: (data)=>set({
                parentGroupsAlertsData: data
            }),
        setFalsePostiveData: (data)=>set({
                falsePostiveData: data
            }),
        setPercetageOfMotionData: (data)=>set({
                percetageOfMotionData: data
            }),
        setVisibleArray: (array)=>set({
                visibleArray: array
            }),
        setConversionArray: (array)=>set({
                conversionArray: array
            }),
        setParentAccounts: (accounts)=>set({
                parentAccounts: accounts
            }),
        setParentIds: (ids)=>set({
                parentIds: ids
            }),
        setParentNames: (names)=>set({
                parentNames: names
            }),
        setTotalAlerts: (total)=>set({
                totalAlerts: total
            }),
        setShowMoreVisible: (visible)=>set({
                showMoreVisible: visible
            }),
        setShowMoreOpen: (open)=>set({
                showMoreOpen: open
            }),
        setDisplayOnLeftBool: (display)=>set({
                displayOnLeftBool: display
            }),
        setFiltersSavedClicked: (clicked)=>set({
                filtersSavedClicked: clicked
            }),
        setDateChangesMade: (changed)=>set({
                dateChangesMade: changed
            }),
        setFiltersApplied: (applied)=>set({
                filtersApplied: applied
            }),
        setAlertsGraphName: (name)=>set({
                alertGraphName: name
            }),
        setDateGraphName: (name)=>set({
                dateGraphName: name
            }),
        setDownloadURL: (url)=>set({
                downloadURL: url
            }),
        setAlertURL: (url)=>set({
                alertURL: url
            }),
        setUserFilters: (filters)=>set((state)=>({
                    userFilters: typeof filters === "function" ? filters(state.userFilters) : filters
                })),
        setAveragePercentageOfMotion: (percentage)=>set({
                averagePercentageOfMotion: percentage
            }),
        setAlertState: (state)=>set({
                alertState: state
            }),
        // Reset state function
        resetState: ()=>{
            const startDate = new Date();
            startDate.setDate(startDate.getDate() - 5);
            const endDate = new Date();
            const initialResetState = {
                loadingData: {
                    allAlertsData: true,
                    parentGroupsData: true,
                    falsePositiveData: true,
                    percetageOfMotionData: true
                },
                pageLoading: false,
                loadingSites: false,
                loadingCameras: false,
                parentAccountsLoading: true,
                siteOptions: [],
                cameraOptions: [],
                allAlertsData: [],
                parentGroupsAlertsData: [],
                falsePostiveData: [],
                percetageOfMotionData: [],
                visibleArray: [],
                conversionArray: [],
                parentAccounts: [],
                parentIds: new Map(),
                parentNames: new Map(),
                totalAlerts: 0,
                showMoreVisible: false,
                showMoreOpen: false,
                displayOnLeftBool: false,
                dateChangesMade: false,
                // alertGraphName: "Parent Group",
                dateGraphName: "",
                downloadURL: "",
                alertURL: "",
                averagePercentageOfMotion: NaN,
                alertState: {
                    dateTooFar: false,
                    startAfterEnd: false,
                    endBeforeStart: false
                },
                barChartHeight: 385,
                barChartHeightFull: 600,
                outerBoxHeight: 425,
                outerBoxHeightFull: 640,
                innerBoxHeight: 423,
                innerBoxHeightFull: 638
            };
            set(initialResetState);
            if (localStorage.filtersSavedClicked !== "true") set({
                siteDropDownValue: [],
                cameraDropDownValue: [],
                filtersSavedClicked: false,
                alertGraphName: "Parent Group",
                userFilters: {
                    parent_group: "",
                    site: [],
                    camera: [],
                    start_date: startDate,
                    end_date: endDate
                }
            });
        },
        // Functions
        fetchAllGraphsData: async (navigate)=>{
            const store = get();
            const { parent_group: groupId, start_date: start_date, end_date: end_date, site: siteIdsArray } = store.userFilters;
            // Convert dates to string format for API
            const startDate = start_date ? start_date.toISOString().split("T")[0] : undefined;
            const endDate = end_date ? end_date.toISOString().split("T")[0] : undefined;
            const searchParamsString = $0acc3663e9cf84b8$var$buildSearchParamsString(groupId, startDate, endDate, siteIdsArray);
            store.setLoadingData({
                allAlertsData: true,
                parentGroupsData: true,
                falsePositiveData: true,
                percetageOfMotionData: true
            });
            // Fetch all data
            await Promise.all([
                $0acc3663e9cf84b8$export$844955611cc32e74(navigate, searchParamsString),
                $0acc3663e9cf84b8$export$c1b09d86c4218815(navigate, searchParamsString),
                $0acc3663e9cf84b8$export$111784ddfbf64066(navigate, searchParamsString),
                $0acc3663e9cf84b8$export$b5953de484804eda(navigate, searchParamsString)
            ]);
            store.setDateChangesMade(false);
        }
    }));
const $0acc3663e9cf84b8$var$buildSearchParamsString = (groupId, startDate, endDate, siteIdsArray = [], cameraIdsArray = [])=>{
    let searchParamsString = "";
    // Handle date and group combinations
    if (!groupId && !endDate && startDate) searchParamsString = `?start_date=${startDate}`;
    if (!groupId && endDate && !startDate) searchParamsString = `?end_date=${endDate}`;
    if (groupId && !endDate && startDate) searchParamsString = `?group=${groupId}&start_date=${startDate}`;
    if (groupId && endDate && !startDate) searchParamsString = `?group=${groupId}&end_date=${endDate}`;
    if (groupId && endDate && startDate) searchParamsString = `?group=${groupId}&start_date=${startDate}&end_date=${endDate}`;
    if (!groupId && endDate && startDate) searchParamsString = `?start_date=${startDate}&end_date=${endDate}`;
    // Handle site IDs
    if (siteIdsArray[0]) {
        let additionalSiteString = `&site=${siteIdsArray[0]}`;
        if (siteIdsArray.length > 1) siteIdsArray.forEach((siteId, index)=>{
            if (index !== 0) additionalSiteString += `,${siteId}`;
        });
        searchParamsString += additionalSiteString;
    }
    // Handle camera IDs - this overrides previous params if cameras are specified
    if (cameraIdsArray[0]) {
        let additionalCamerasString = `${cameraIdsArray[0]}`;
        if (cameraIdsArray.length > 1) cameraIdsArray.forEach((cameraId, index)=>{
            if (index !== 0) additionalCamerasString += `,${cameraId}`;
        });
        searchParamsString = `?camera=${additionalCamerasString}&start_date=${startDate}&end_date=${endDate}`;
    }
    return searchParamsString;
};
const $0acc3663e9cf84b8$export$844955611cc32e74 = async (navigate, searchParamsString)=>{
    const store = $0acc3663e9cf84b8$export$e69ca36e0aa135e7.getState();
    const api = (0, $195EM.createApi)("");
    try {
        const response = await api.get(`analytics/alert_volume/${searchParamsString}`);
        store.setAllAlertsData(response.data);
        store.setTotalAlerts($0acc3663e9cf84b8$var$getTotalAlerts(response.data));
        store.setLoadingData({
            allAlertsData: false
        });
    } catch (error) {
        const axiosError = error;
        (0, $3Zv1D.universalAPIErrorHandler)(axiosError, navigate, ()=>$0acc3663e9cf84b8$export$844955611cc32e74(navigate, searchParamsString), ()=>{
            store.setLoadingData({
                allAlertsData: false
            });
        });
    }
};
const $0acc3663e9cf84b8$export$c1b09d86c4218815 = async (navigate, searchParamsString)=>{
    const store = $0acc3663e9cf84b8$export$e69ca36e0aa135e7.getState();
    const api = (0, $195EM.createApi)("");
    try {
        const response = await api.get(`analytics/alerts_by_parent/${searchParamsString}`);
        const updatedData = response.data;
        // Process the data to add abbreviated names
        for(const key in updatedData){
            const updatedKey = updatedData[key];
            if (updatedKey.name.length > 4) updatedKey.abreviated_name = `${updatedKey.name.slice(0, 3)}...`;
            else updatedKey.abreviated_name = updatedKey.name;
        }
        // Update store state
        store.setParentGroupsAlertsData(updatedData);
        const conversionArray = (0, $0f328bc1569eb013$export$b0850dcaeb58b1b1)(updatedData, store.setConversionArray, store.setShowMoreVisible);
        store.setVisibleArray((0, $56d755191d61e930$export$10aa7e930ee49de0)(conversionArray));
        store.setShowMoreOpen(false);
        store.setLoadingData({
            parentGroupsData: false
        });
    } catch (error) {
        const axiosError = error;
        (0, $3Zv1D.universalAPIErrorHandler)(axiosError, navigate, ()=>$0acc3663e9cf84b8$export$c1b09d86c4218815(navigate, searchParamsString), ()=>{
            // Update graph name based on filters
            if (!store.userFilters.parent_group) store.setAlertsGraphName("Parent Group");
            else if (store.userFilters.parent_group) store.setAlertsGraphName("Site");
            else if (store.userFilters.site[0]) store.setAlertsGraphName("Camera");
            store.setLoadingData({
                parentGroupsData: false
            });
        });
    }
};
const $0acc3663e9cf84b8$export$111784ddfbf64066 = async (navigate, searchParamsString)=>{
    const store = $0acc3663e9cf84b8$export$e69ca36e0aa135e7.getState();
    const api = (0, $195EM.createApi)("");
    try {
        const response = await api.get(`analytics/false_positive/${searchParamsString}`);
        store.setFalsePostiveData(response.data);
        store.setLoadingData({
            falsePositiveData: false
        });
    } catch (error) {
        const axiosError = error;
        (0, $3Zv1D.universalAPIErrorHandler)(axiosError, navigate, ()=>$0acc3663e9cf84b8$export$111784ddfbf64066(navigate, searchParamsString), ()=>{
            store.setLoadingData({
                falsePositiveData: false
            });
        });
    }
};
const $0acc3663e9cf84b8$export$b5953de484804eda = async (navigate, searchParamsString)=>{
    const store = $0acc3663e9cf84b8$export$e69ca36e0aa135e7.getState();
    const api = (0, $195EM.createApi)("");
    try {
        // Reset average percentage before fetching new data
        store.setAveragePercentageOfMotion(NaN);
        const response = await api.get(`analytics/percentage_motion_with_average/${searchParamsString}`);
        const newDataArray = [];
        if (response.data.report) {
            const data = response.data.report;
            if (data[0]) data.forEach((object)=>{
                const newObject = {
                    ...object
                };
                const newPercentFiltered = object.percentage_filtered.toFixed(2);
                newObject.percentage_filtered = Number(newPercentFiltered);
                newDataArray.push(newObject);
            });
        }
        store.setAveragePercentageOfMotion(response.data.average || 0);
        store.setPercetageOfMotionData(newDataArray);
        store.setLoadingData({
            percetageOfMotionData: false
        });
    } catch (error) {
        const axiosError = error;
        (0, $3Zv1D.universalAPIErrorHandler)(axiosError, navigate, ()=>$0acc3663e9cf84b8$export$b5953de484804eda(navigate, searchParamsString), ()=>{
            store.setLoadingData({
                percetageOfMotionData: false
            });
        });
    }
};
const $0acc3663e9cf84b8$export$a14df7b657d0c56a = async (idArray, navigate)=>{
    const store = $0acc3663e9cf84b8$export$e69ca36e0aa135e7.getState();
    const api = (0, $195EM.createApi)("");
    store.setLoadingCameras(true);
    if (idArray.length === 0) {
        store.setCameraOptions([]);
        store.setLoadingCameras(false);
        return;
    }
    // Build the ID string for the API call
    const idString = idArray.reduce((acc, id, index)=>{
        if (index === 0) return id;
        return `${acc},${id}`;
    }, "");
    try {
        const response = await api.get(`camera/site/?customers=${idString}`);
        store.setCameraOptions(response.data.results);
        store.setLoadingCameras(false);
    } catch (error) {
        const axiosError = error;
        (0, $3Zv1D.universalAPIErrorHandler)(axiosError, navigate, ()=>$0acc3663e9cf84b8$export$a14df7b657d0c56a(idArray, navigate), ()=>{
            alert("Error retrieving cameras.");
            store.setLoadingCameras(false);
        });
    }
};
const $0acc3663e9cf84b8$export$6a85d43941d325e8 = async (idArray, cameraIds, navigate)=>{
    const store = $0acc3663e9cf84b8$export$e69ca36e0aa135e7.getState();
    const api = (0, $195EM.createApi)("");
    store.setLoadingCameras(true);
    if (idArray.length === 0) {
        store.setCameraOptions([]);
        store.setLoadingCameras(false);
        return;
    }
    // Build the ID string for the API call
    const idString = idArray.reduce((acc, id, index)=>{
        if (index === 0) return id;
        return `${acc},${id}`;
    }, "");
    try {
        const response = await api.get(`camera/site/?customers=${idString}`);
        store.setCameraOptions(response.data.results);
        // Create maps for ID to name conversion
        const cameraNames = new Map();
        response.data.results.forEach((object)=>{
            cameraNames.set(object.id, object.camera_name);
        });
        // Set dropdown values based on camera IDs from URL
        const cameraNamesArray = cameraIds.map((cameraId)=>cameraNames.get(cameraId)).filter(Boolean);
        if (cameraNamesArray.length > 0) {
            store.setCameraDropDownValue(cameraNamesArray);
            localStorage.setItem("cameraDropDownValueAnalytics", JSON.stringify(cameraNamesArray));
        }
        store.setLoadingCameras(false);
    } catch (error) {
        const axiosError = error;
        (0, $3Zv1D.universalAPIErrorHandler)(axiosError, navigate, ()=>$0acc3663e9cf84b8$export$6a85d43941d325e8(idArray, cameraIds, navigate), ()=>{
            alert("Error retrieving cameras.");
            store.setLoadingCameras(false);
        });
    }
};
const $0acc3663e9cf84b8$export$664d1b7592a4aa30 = async (id, navigate)=>{
    const store = $0acc3663e9cf84b8$export$e69ca36e0aa135e7.getState();
    const api = (0, $195EM.createApi)("");
    store.setLoadingSites(true);
    try {
        const response = await api.get(`customer/names/${id}/`);
        store.setSiteOptions(response.data);
        store.setLoadingSites(false);
    } catch (error) {
        const axiosError = error;
        (0, $3Zv1D.universalAPIErrorHandler)(axiosError, navigate, ()=>$0acc3663e9cf84b8$export$664d1b7592a4aa30(id, navigate), ()=>{
            alert("Error retrieving sites. Please try again");
            store.setLoadingSites(false);
        });
    }
};
const $0acc3663e9cf84b8$export$c96eb7d11a0b2c94 = async (id, siteIds, navigate)=>{
    const store = $0acc3663e9cf84b8$export$e69ca36e0aa135e7.getState();
    const api = (0, $195EM.createApi)("");
    store.setLoadingSites(true);
    try {
        const response = await api.get(`customer/names/${id}/`);
        store.setSiteOptions(response.data);
        // Create maps for ID to name conversion
        const siteNames = new Map();
        response.data.forEach((object)=>{
            siteNames.set(object.id, object.name);
        });
        // Set dropdown values based on site IDs from URL
        const siteNamesArray = siteIds.map((siteId)=>siteNames.get(siteId)).filter(Boolean);
        if (siteNamesArray.length > 0) {
            store.setSiteDropDownValue(siteNamesArray);
            localStorage.setItem("siteDropDownValueAnalytics", JSON.stringify(siteNamesArray));
        }
        store.setLoadingSites(false);
    } catch (error) {
        const axiosError = error;
        (0, $3Zv1D.universalAPIErrorHandler)(axiosError, navigate, ()=>$0acc3663e9cf84b8$export$c96eb7d11a0b2c94(id, siteIds, navigate), ()=>{
            alert("Error retrieving sites. Please try again");
            store.setLoadingSites(false);
        });
    }
};
const $0acc3663e9cf84b8$export$2b01a829fc5d8171 = async (navigate)=>{
    const store = $0acc3663e9cf84b8$export$e69ca36e0aa135e7.getState();
    const api = (0, $195EM.createApi)("");
    store.setPageLoading(true);
    const parentGroupId = localStorage.analyticsParentGroupId;
    const siteId = localStorage.analyticsSiteId;
    const idArray = [
        siteId
    ];
    // Build the ID string for the API call
    const idString = idArray.reduce((acc, id, index)=>{
        if (index === 0) return id;
        return `${acc},${id}`;
    }, "");
    try {
        // Fetch sites by parent group
        const sitesResponse = await api.get(`customer/by_group_id/${parentGroupId}/?page_size=1000`);
        store.setSiteOptions(sitesResponse.data.results);
        store.setLoadingSites(false);
        // Fetch cameras by site
        const camerasResponse = await api.get(`camera/site/?customers=${idString}`);
        store.setCameraOptions(camerasResponse.data.results);
        store.setPageLoading(false);
        // Update user filters with the site data
        store.setUserFilters((prev)=>({
                ...prev,
                parent_group: parentGroupId,
                site: [
                    siteId
                ]
            }));
        // Fetch all analytics data
        await $0acc3663e9cf84b8$export$3d053cc9d93dcd6c(navigate);
    } catch (error) {
        const axiosError = error;
        (0, $3Zv1D.universalAPIErrorHandler)(axiosError, navigate, ()=>$0acc3663e9cf84b8$export$2b01a829fc5d8171(navigate), ()=>{
            alert("Error retrieving sites. Please try again");
            store.setPageLoading(false);
            store.setLoadingSites(false);
        });
    }
    localStorage.setItem("navigatedToAnalyticsFromSitesPage", "false");
};
const $0acc3663e9cf84b8$export$1afee6b338a45ddb = ()=>{
    const store = $0acc3663e9cf84b8$export$e69ca36e0aa135e7.getState();
    if (!store.showMoreOpen) {
        store.setDisplayOnLeftBool(true);
        store.setShowMoreOpen(true);
        store.setVisibleArray(store.conversionArray);
        store.setBarChartHeight(store.barChartHeightFull);
        store.setOuterBoxHeight(store.outerBoxHeightFull);
        store.setInnerBoxHeight(store.innerBoxHeightFull);
    } else {
        store.setDisplayOnLeftBool(false);
        store.setShowMoreOpen(false);
        store.setVisibleArray((0, $56d755191d61e930$export$10aa7e930ee49de0)(store.conversionArray));
        store.setBarChartHeight(385);
        store.setOuterBoxHeight(425);
        store.setInnerBoxHeight(423);
    }
};
const $0acc3663e9cf84b8$export$872eef920382aa9b = ()=>{
    const store = $0acc3663e9cf84b8$export$e69ca36e0aa135e7.getState();
    const cameraIdsArray = store.userFilters.camera;
    // Filter parent groups alerts data based on camera IDs
    const updatedParentGroupsAlertsData = store.parentGroupsAlertsData.filter((object)=>cameraIdsArray.includes(object.id.toString()));
    // Update store state
    store.setParentGroupsAlertsData(updatedParentGroupsAlertsData);
    // Get conversion array and update visible array
    const conversionArray = (0, $0f328bc1569eb013$export$b0850dcaeb58b1b1)(updatedParentGroupsAlertsData, store.setConversionArray, store.setShowMoreVisible);
    store.setVisibleArray((0, $56d755191d61e930$export$10aa7e930ee49de0)(conversionArray));
    store.setShowMoreOpen(false);
    store.setLoadingData({
        parentGroupsData: false
    });
};
const $0acc3663e9cf84b8$export$f6aa9e254c3ecd77 = async (navigate)=>{
    const store = $0acc3663e9cf84b8$export$e69ca36e0aa135e7.getState();
    const api = (0, $195EM.createApi)("");
    const { parent_group: groupId, start_date: start_date, end_date: end_date, site: siteIdsArray, camera: cameraIdsArray } = store.userFilters;
    // Convert dates to string format for API
    const startDate = start_date ? start_date.toISOString().split("T")[0] : undefined;
    const endDate = end_date ? end_date.toISOString().split("T")[0] : undefined;
    // Build the base URL with required date parameters
    let url = `analytics/download/?start_date=${startDate}&end_date=${endDate}`;
    // Add optional parameters if they exist
    if (groupId) url += `&group=${groupId}`;
    if (siteIdsArray.length > 0) {
        const siteString = siteIdsArray.join(",");
        url += `&site=${siteString}`;
    }
    if (cameraIdsArray.length > 0) {
        const cameraString = cameraIdsArray.join(",");
        url += `&camera=${cameraString}`;
    }
    try {
        const response = await api.get(url);
        store.setDownloadURL(response.data.url);
    } catch (error) {
        const axiosError = error;
        (0, $3Zv1D.universalAPIErrorHandler)(axiosError, navigate, ()=>$0acc3663e9cf84b8$export$f6aa9e254c3ecd77(navigate), ()=>{});
    }
};
const $0acc3663e9cf84b8$export$3d053cc9d93dcd6c = async (navigate)=>{
    const store = $0acc3663e9cf84b8$export$e69ca36e0aa135e7.getState();
    const api = (0, $195EM.createApi)("");
    try {
        // Reset loading states
        store.setLoadingData({
            allAlertsData: true,
            parentGroupsData: true,
            falsePositiveData: true,
            percetageOfMotionData: true
        });
        // Fetch parent accounts
        const parentAccountsResponse = await api.get("group/?parent_account=true&page_size=10000");
        const parentAccounts = parentAccountsResponse.data.results;
        const parentIds = new Map();
        const parentNames = new Map();
        parentAccounts.forEach((object)=>{
            parentIds.set(object.name, object.id);
            parentNames.set(object.id, object.name);
        });
        store.setParentAccounts(parentAccounts);
        store.setParentIds(parentIds);
        store.setParentNames(parentNames);
        store.setParentAccountsLoading(false);
        // Fetch all analytics data
        await store.fetchAllGraphsData(navigate);
        // Get download URL
        await $0acc3663e9cf84b8$export$f6aa9e254c3ecd77(navigate);
    } catch (error) {
        (0, $3Zv1D.universalAPIErrorHandler)(error, navigate, ()=>$0acc3663e9cf84b8$export$3d053cc9d93dcd6c(navigate), ()=>{
            store.setLoadingData({
                allAlertsData: false,
                parentGroupsData: false,
                falsePositiveData: false,
                percetageOfMotionData: false
            });
            store.setParentAccountsLoading(false);
        });
    }
};
const $0acc3663e9cf84b8$export$5af0127e847509ea = async (navigate)=>{
    const store = $0acc3663e9cf84b8$export$e69ca36e0aa135e7.getState();
    const api = (0, $195EM.createApi)("");
    const { parent_group: groupId, start_date: start_date, end_date: end_date, site: siteIdsArray, camera: cameraIdsArray } = store.userFilters;
    // Convert dates to string format for API
    const startDate = start_date ? start_date.toISOString().split("T")[0] : undefined;
    const endDate = end_date ? end_date.toISOString().split("T")[0] : undefined;
    let searchParamsString = ``;
    if (!groupId && !endDate && startDate) searchParamsString = `?start_date=${startDate}`;
    if (!groupId && endDate && !startDate) searchParamsString = `?end_date=${endDate}`;
    if (groupId && !endDate && startDate) searchParamsString = `?group=${groupId}&start_date=${startDate}`;
    if (groupId && endDate && !startDate) searchParamsString = `?group=${groupId}&end_date=${endDate}`;
    if (groupId && endDate && startDate) searchParamsString = `?group=${groupId}&start_date=${startDate}&end_date=${endDate}`;
    if (!groupId && endDate && startDate) searchParamsString = `?start_date=${startDate}&end_date=${endDate}`;
    if (siteIdsArray[0]) {
        let additionalSiteString = `&site=${siteIdsArray[0]}`;
        if (siteIdsArray.length > 1) siteIdsArray.forEach((siteId, index)=>{
            if (index !== 0) additionalSiteString += `,${siteId}`;
        });
        searchParamsString += additionalSiteString;
    }
    if (cameraIdsArray[0]) {
        let additionalCamerasString = `${cameraIdsArray[0]}`;
        if (cameraIdsArray.length > 1) cameraIdsArray.forEach((cameraId, index)=>{
            if (index !== 0) additionalCamerasString += `,${cameraId}`;
        });
        searchParamsString = `?camera=${additionalCamerasString}&start_date=${startDate}&end_date=${endDate}`;
    }
    try {
        store.setLoadingData({
            allAlertsData: true
        });
        const response = await api.get(`analytics/alert_volume/${searchParamsString}`);
        store.setAllAlertsData(response.data);
        store.setLoadingData({
            allAlertsData: false
        });
    } catch (error) {
        (0, $3Zv1D.universalAPIErrorHandler)(error, navigate, ()=>$0acc3663e9cf84b8$export$5af0127e847509ea(navigate), ()=>{
            store.setLoadingData({
                allAlertsData: false
            });
        });
    }
};
const $0acc3663e9cf84b8$export$3fa0309c53a1947e = (checkBoxValue)=>{
    const store = $0acc3663e9cf84b8$export$e69ca36e0aa135e7.getState();
    const setFiltersSavedClicked = store.setFiltersSavedClicked;
    if (checkBoxValue) {
        setFiltersSavedClicked(true);
        localStorage.setItem("filtersSavedClicked", "true");
        localStorage.setItem("savedAnalyticsFilters", JSON.stringify(store.userFilters));
    } else {
        setFiltersSavedClicked(false);
        localStorage.setItem("filtersSavedClicked", "false");
    }
};


const $471e4fda77b11d18$export$83b9ba99925051d2 = (siteName, parentGroupId, siteId, navigate)=>{
    localStorage.setItem("navigatedToAnalyticsFromSitesPage", "true");
    localStorage.setItem("analyticsParentGroupId", parentGroupId);
    localStorage.setItem("analyticsSiteId", siteId);
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 5);
    const endDate = new Date();
    (0, $0acc3663e9cf84b8$export$e69ca36e0aa135e7).setState({
        siteDropDownValue: [
            siteName
        ],
        cameraDropDownValue: [],
        alertGraphName: "Site",
        userFilters: {
            parent_group: parentGroupId,
            site: [
                siteId
            ],
            camera: [],
            start_date: startDate,
            end_date: endDate
        },
        filtersSavedClicked: false
    });
    navigate("/analytics");
};



var $iKAtE = parcelRequire("iKAtE");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");

var $i5MAs = parcelRequire("i5MAs");

var $k4ank = parcelRequire("k4ank");

var $5Ibhh = parcelRequire("5Ibhh");

var $cye0Y = parcelRequire("cye0Y");

var $gt8Ee = parcelRequire("gt8Ee");

var $gouAT = parcelRequire("gouAT");

var $eeN3r = parcelRequire("eeN3r");

var $hjOOA = parcelRequire("hjOOA");

var $cVCJe = parcelRequire("cVCJe");

var $agMWc = parcelRequire("agMWc");
const $72999d1495bbb021$var$ORANGE = "#FF8400";
const $72999d1495bbb021$export$245d71629b1d752a = (armedInput, armedStatusInput)=>{
    const presentation = (0, $agMWc.getArmedStatusPresentation)(armedStatusInput, armedInput);
    const status = presentation.status;
    let icon;
    if (status === "OK") icon = /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5Ibhh))), {
        color: "success"
    });
    else if (status === "ARMED_OUTSIDE_SCHEDULE") icon = /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gt8Ee))), {
        color: "success"
    });
    else if (status === "WARNING") icon = /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gt8Ee))), {
        sx: {
            color: $72999d1495bbb021$var$ORANGE
        }
    });
    else if (status === "ERROR") icon = /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gouAT))), {
        color: "error"
    });
    else if (status === "ARMING") icon = /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eeN3r))), {
        sx: {
            color: $72999d1495bbb021$var$ORANGE
        }
    });
    else if (status === "DISARMING") icon = /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hjOOA))), {
        sx: {
            color: $72999d1495bbb021$var$ORANGE
        }
    });
    else if (status === "NOT_RUNNING" && armedInput) icon = /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gt8Ee))), {
        sx: {
            color: $72999d1495bbb021$var$ORANGE
        }
    });
    else if (status === "UNKNOWN") icon = /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gt8Ee))), {
        sx: {
            color: "#b4b4b4"
        }
    });
    else icon = /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cye0Y))), {
        color: "error"
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: presentation.description,
        children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
            "data-testid": "armed-status-icon",
            "data-armed-status": status,
            "aria-label": presentation.label,
            style: {
                display: "inline-flex",
                verticalAlign: "middle"
            },
            children: icon
        })
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $5Ibhh = parcelRequire("5Ibhh");

var $cye0Y = parcelRequire("cye0Y");

var $cVCJe = parcelRequire("cVCJe");
const $0eccbe0a25436241$export$135e73f04b466e08 = (num, errorNumber, warningNumber)=>{
    let message = "";
    if (warningNumber > 0 && errorNumber === 0) message = `${warningNumber} camera(s) with broken frames since launch or blurry view.`;
    if (errorNumber > 0 && warningNumber === 0) message = `${errorNumber} camera(s) unable to connect or provided no frame since launch.`;
    if (warningNumber > 0 && errorNumber > 0) message = `${warningNumber} camera(s) with broken frames since launch or blurry view. ${errorNumber} camera(s) unable to connect or provided no frame since launch.`;
    if (num !== 0) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: message,
        placement: "top",
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            children: [
                num,
                "\xa0",
                /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cye0Y))), {
                    color: "error",
                    fontSize: "small"
                })
            ]
        })
    });
    else return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            num,
            "\xa0",
            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5Ibhh))), {
                color: "success",
                fontSize: "small"
            })
        ]
    });
};


const $3428fce36a3d76b5$export$ad6f9224b29a30a4 = (inputNum)=>{
    const roundedNum = Math.round(inputNum);
    return `${roundedNum} KB/S`;
};



var $kbChx = parcelRequire("kbChx");
var $5GP2e = parcelRequire("5GP2e");
var $ha39s = parcelRequire("ha39s");
var $cVCJe = parcelRequire("cVCJe");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $2aMB5 = parcelRequire("2aMB5");

var $gt8Ee = parcelRequire("gt8Ee");

var $lWchQ = parcelRequire("lWchQ");

var $cVCJe = parcelRequire("cVCJe");
const $712f729ecf62e7b6$export$e20667e62845fc5b = (requirements_bad, requirements_warning)=>{
    if (requirements_warning > 0 && requirements_bad < 1) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: "Some cameras on this site have settings which are only acceptable, and may result in performance issues.",
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gt8Ee))), {
            sx: {
                color: "#FF8400"
            },
            fontSize: "small"
        })
    });
    else if (requirements_bad > 0) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: "Some cameras on this site have settings which are below optimal, and will likely result in performance issues.",
        children: (0, $2aMB5.cancelIconRedSmall)
    });
    else return 0, $lWchQ.checkedCircleIconSmall;
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $a65wX = parcelRequire("a65wX");

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $aBrLz = parcelRequire("aBrLz");

var $8T3gX = parcelRequire("8T3gX");
function $80ec24ee1c65835e$export$2e2bcd8739ae039(children) {
    return $8T3gX.Children.toArray(children).filter((child)=>/*#__PURE__*/ $8T3gX.isValidElement(child));
}



var $iMOmE = parcelRequire("iMOmE");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $b0a2284b85a26d1b$export$b85c003f960b1f3a(slot) {
    return (0, $kfTYv.default)('MuiButtonGroup', slot);
}
const $b0a2284b85a26d1b$var$buttonGroupClasses = (0, $jh2Zm.default)('MuiButtonGroup', [
    'root',
    'contained',
    'outlined',
    'text',
    'disableElevation',
    'disabled',
    'firstButton',
    'fullWidth',
    'vertical',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'groupedText',
    'groupedTextHorizontal',
    'groupedTextVertical',
    'groupedTextPrimary',
    'groupedTextSecondary',
    'groupedOutlined',
    'groupedOutlinedHorizontal',
    'groupedOutlinedVertical',
    'groupedOutlinedPrimary',
    'groupedOutlinedSecondary',
    'groupedContained',
    'groupedContainedHorizontal',
    'groupedContainedVertical',
    'groupedContainedPrimary',
    'groupedContainedSecondary',
    'lastButton',
    'middleButton'
]);
var $b0a2284b85a26d1b$export$2e2bcd8739ae039 = $b0a2284b85a26d1b$var$buttonGroupClasses;



var $1qvgV = parcelRequire("1qvgV");

var $ixWGs = parcelRequire("ixWGs");

var $k4ank = parcelRequire("k4ank");
'use client';
const $d685fbaea40075f4$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "disableRipple",
    "fullWidth",
    "orientation",
    "size",
    "variant"
];
const $d685fbaea40075f4$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        {
            [`& .${(0, $b0a2284b85a26d1b$export$2e2bcd8739ae039).grouped}`]: styles.grouped
        },
        {
            [`& .${(0, $b0a2284b85a26d1b$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $iMOmE.default)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $b0a2284b85a26d1b$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $iMOmE.default)(ownerState.variant)}`]
        },
        {
            [`& .${(0, $b0a2284b85a26d1b$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $iMOmE.default)(ownerState.variant)}${(0, $iMOmE.default)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $b0a2284b85a26d1b$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $iMOmE.default)(ownerState.variant)}${(0, $iMOmE.default)(ownerState.color)}`]
        },
        {
            [`& .${(0, $b0a2284b85a26d1b$export$2e2bcd8739ae039).firstButton}`]: styles.firstButton
        },
        {
            [`& .${(0, $b0a2284b85a26d1b$export$2e2bcd8739ae039).lastButton}`]: styles.lastButton
        },
        {
            [`& .${(0, $b0a2284b85a26d1b$export$2e2bcd8739ae039).middleButton}`]: styles.middleButton
        },
        styles.root,
        styles[ownerState.variant],
        ownerState.disableElevation === true && styles.disableElevation,
        ownerState.fullWidth && styles.fullWidth,
        ownerState.orientation === 'vertical' && styles.vertical
    ];
};
const $d685fbaea40075f4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, disableElevation: disableElevation, fullWidth: fullWidth, orientation: orientation, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            orientation === 'vertical' && 'vertical',
            fullWidth && 'fullWidth',
            disableElevation && 'disableElevation'
        ],
        grouped: [
            'grouped',
            `grouped${(0, $iMOmE.default)(orientation)}`,
            `grouped${(0, $iMOmE.default)(variant)}`,
            `grouped${(0, $iMOmE.default)(variant)}${(0, $iMOmE.default)(orientation)}`,
            `grouped${(0, $iMOmE.default)(variant)}${(0, $iMOmE.default)(color)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $b0a2284b85a26d1b$export$b85c003f960b1f3a), classes);
};
const $d685fbaea40075f4$var$ButtonGroupRoot = (0, $anJSP.default)('div', {
    name: 'MuiButtonGroup',
    slot: 'Root',
    overridesResolver: $d685fbaea40075f4$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius
    }, ownerState.variant === 'contained' && {
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.disableElevation && {
        boxShadow: 'none'
    }, ownerState.fullWidth && {
        width: '100%'
    }, ownerState.orientation === 'vertical' && {
        flexDirection: 'column'
    }, {
        [`& .${(0, $b0a2284b85a26d1b$export$2e2bcd8739ae039).grouped}`]: (0, $eJfrs.default)({
            minWidth: 40,
            '&:hover': (0, $eJfrs.default)({}, ownerState.variant === 'contained' && {
                boxShadow: 'none'
            })
        }, ownerState.variant === 'contained' && {
            boxShadow: 'none'
        }),
        [`& .${(0, $b0a2284b85a26d1b$export$2e2bcd8739ae039).firstButton},& .${(0, $b0a2284b85a26d1b$export$2e2bcd8739ae039).middleButton}`]: (0, $eJfrs.default)({}, ownerState.orientation === 'horizontal' && {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0
        }, ownerState.orientation === 'vertical' && {
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0
        }, ownerState.variant === 'text' && ownerState.orientation === 'horizontal' && {
            borderRight: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
            [`&.${(0, $b0a2284b85a26d1b$export$2e2bcd8739ae039).disabled}`]: {
                borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === 'text' && ownerState.orientation === 'vertical' && {
            borderBottom: theme.vars ? `1px solid rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
            [`&.${(0, $b0a2284b85a26d1b$export$2e2bcd8739ae039).disabled}`]: {
                borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
            borderColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : (0, $aBrLz.alpha)(theme.palette[ownerState.color].main, 0.5)
        }, ownerState.variant === 'outlined' && ownerState.orientation === 'horizontal' && {
            borderRightColor: 'transparent'
        }, ownerState.variant === 'outlined' && ownerState.orientation === 'vertical' && {
            borderBottomColor: 'transparent'
        }, ownerState.variant === 'contained' && ownerState.orientation === 'horizontal' && {
            borderRight: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
            [`&.${(0, $b0a2284b85a26d1b$export$2e2bcd8739ae039).disabled}`]: {
                borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === 'contained' && ownerState.orientation === 'vertical' && {
            borderBottom: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
            [`&.${(0, $b0a2284b85a26d1b$export$2e2bcd8739ae039).disabled}`]: {
                borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
            }
        }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
            borderColor: (theme.vars || theme).palette[ownerState.color].dark
        }, {
            '&:hover': (0, $eJfrs.default)({}, ownerState.variant === 'outlined' && ownerState.orientation === 'horizontal' && {
                borderRightColor: 'currentColor'
            }, ownerState.variant === 'outlined' && ownerState.orientation === 'vertical' && {
                borderBottomColor: 'currentColor'
            })
        }),
        [`& .${(0, $b0a2284b85a26d1b$export$2e2bcd8739ae039).lastButton},& .${(0, $b0a2284b85a26d1b$export$2e2bcd8739ae039).middleButton}`]: (0, $eJfrs.default)({}, ownerState.orientation === 'horizontal' && {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0
        }, ownerState.orientation === 'vertical' && {
            borderTopRightRadius: 0,
            borderTopLeftRadius: 0
        }, ownerState.variant === 'outlined' && ownerState.orientation === 'horizontal' && {
            marginLeft: -1
        }, ownerState.variant === 'outlined' && ownerState.orientation === 'vertical' && {
            marginTop: -1
        })
    }));
const $d685fbaea40075f4$var$ButtonGroup = /*#__PURE__*/ $8T3gX.forwardRef(function ButtonGroup(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonGroup'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, disableRipple: disableRipple = false, fullWidth: fullWidth = false, orientation: orientation = 'horizontal', size: size = 'medium', variant: variant = 'outlined' } = props, other = (0, $fAJB5.default)(props, $d685fbaea40075f4$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        disableRipple: disableRipple,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size,
        variant: variant
    });
    const classes = $d685fbaea40075f4$var$useUtilityClasses(ownerState);
    const context = $8T3gX.useMemo(()=>({
            className: classes.grouped,
            color: color,
            disabled: disabled,
            disableElevation: disableElevation,
            disableFocusRipple: disableFocusRipple,
            disableRipple: disableRipple,
            fullWidth: fullWidth,
            size: size,
            variant: variant
        }), [
        color,
        disabled,
        disableElevation,
        disableFocusRipple,
        disableRipple,
        fullWidth,
        size,
        variant,
        classes.grouped
    ]);
    const validChildren = (0, $80ec24ee1c65835e$export$2e2bcd8739ae039)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)($d685fbaea40075f4$var$ButtonGroupRoot, (0, $eJfrs.default)({
        as: component,
        role: "group",
        className: (0, $iVyaN.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1qvgV.default).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $k4ank.jsx)((0, $ixWGs.default).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    }));
});
$d685fbaea40075f4$var$ButtonGroup.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'inherit',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, no elevation is used.
   * @default false
   */ disableElevation: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the button keyboard focus ripple is disabled.
   * @default false
   */ disableFocusRipple: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the button ripple effect is disabled.
   * @default false
   */ disableRipple: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the buttons will take up the full width of its container.
   * @default false
   */ fullWidth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'horizontal',
        'vertical'
    ]),
    /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'small',
            'medium',
            'large'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * The variant to use.
   * @default 'outlined'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'contained',
            'outlined',
            'text'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ])
};
var $d685fbaea40075f4$export$2e2bcd8739ae039 = $d685fbaea40075f4$var$ButtonGroup;


var $bf807683d00d38ca$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($bf807683d00d38ca$exports, "__esModule", {
    value: true
});
$bf807683d00d38ca$exports.default = void 0;

var $bf807683d00d38ca$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $bf807683d00d38ca$var$_default = $bf807683d00d38ca$exports.default = (0, $bf807683d00d38ca$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "m7 10 5 5 5-5z"
}), 'ArrowDropDown');



var $eg2OC = parcelRequire("eg2OC");

var $6CjWJ = parcelRequire("6CjWJ");

var $4reBM = parcelRequire("4reBM");

var $cWqfz = parcelRequire("cWqfz");

var $cxknk = parcelRequire("cxknk");

var $eJK3E = parcelRequire("eJK3E");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");


var $9OjAn = parcelRequire("9OjAn");

var $195EM = parcelRequire("195EM");

var $c4ZfI = parcelRequire("c4ZfI");

var $gOe74 = parcelRequire("gOe74");
const $d3da6e0f4850a50d$export$237daa153d47bae = (about)=>{
    if (!(0, $c4ZfI.shouldOfferRebootToApply)(about)) return null;
    return about.has_flex_schedule ? "flex" : "restart";
};
const $d3da6e0f4850a50d$export$8082cf22425fba15 = async (siteIds, namesById)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const results = await Promise.all(siteIds.map((id)=>(0, $gOe74.waitForSettingsDeployed)(AxiosUI, id)));
    const candidates = {
        restart: [],
        flex: [],
        unconfirmed: []
    };
    results.forEach((result, index)=>{
        const id = siteIds[index];
        const about = result.siteInfo ?? {};
        const site = {
            id: id,
            name: about.name || namesById[id] || id
        };
        if (!result.deployed) {
            candidates.unconfirmed.push(site);
            return;
        }
        const bucket = $d3da6e0f4850a50d$export$237daa153d47bae(about);
        if (bucket) candidates[bucket].push(site);
    });
    return candidates;
};
const $d3da6e0f4850a50d$export$3693a6a9c6afd791 = async (sites)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    // action/reboot/ logs a "Manual Reboot", not a "Manual Arm" (ENG-1380).
    const results = await Promise.allSettled(sites.map((site)=>AxiosUI.post(`customer/${site.id}/action/reboot/`)));
    return sites.filter((_, index)=>results[index].status === "rejected").map((site)=>site.name);
};
const $d3da6e0f4850a50d$var$EMPTY = {
    restart: [],
    flex: [],
    unconfirmed: []
};
const $d3da6e0f4850a50d$export$7ea88d4c285933d3 = (0, $9OjAn.create)((set)=>({
        ...$d3da6e0f4850a50d$var$EMPTY,
        open: false,
        openPrompt: (candidates)=>{
            if (candidates.restart.length === 0 && candidates.flex.length === 0 && candidates.unconfirmed.length === 0) return;
            set({
                ...candidates,
                open: true
            });
        },
        close: ()=>set({
                ...$d3da6e0f4850a50d$var$EMPTY,
                open: false
            })
    }));


const $401e73ae5d9ac0cf$export$69fc1e497838bf4c = (actionString, selected, renderedRows, setSiteScreenLoading, groupId, setPageLoading, setSelected, setRenderedRows, setSiteBreadcrumbs, setSiteScreenAlerts, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    setSiteScreenLoading(true);
    // The refresh below replaces the rows; a background group load must not
    // overwrite them afterwards (ENG-2634).
    (0, $9b1233e28e731320$export$c833c47a0e6a4215)();
    const retryFunction = ()=>{
        $401e73ae5d9ac0cf$export$69fc1e497838bf4c(actionString, selected, renderedRows, setSiteScreenLoading, groupId, setPageLoading, setSelected, setRenderedRows, setSiteBreadcrumbs, setSiteScreenAlerts, navigate);
    };
    const sitesWithFlexSchedules = [];
    const disabledSites = [];
    const findWordsBeforeIs = (string)=>{
        const words = string.split(" ");
        const index = words.indexOf("is");
        return words.slice(0, index).join(" ");
    };
    const findWordsBeforeHas = (string)=>{
        const words = string.split(" ");
        const index = words.indexOf("has");
        return words.slice(0, index).join(" ");
    };
    if (selected.length === renderedRows.length && actionString !== "deploy") AxiosUI.post(`group/${groupId}/action/${actionString}/`).then((resp)=>{
        setSiteScreenLoading(false);
        setPageLoading(true);
        setSelected([]);
        if (actionString === "arm") {
            if (resp.data.length > 0) {
                resp.data.forEach((obj)=>{
                    if (obj?.message) {
                        if (!obj.message.includes("Requested reboot")) {
                            if (obj.message.includes("flex schedule")) sitesWithFlexSchedules.push(findWordsBeforeHas(obj.message));
                            else if (obj.message.includes("disabled")) disabledSites.push(findWordsBeforeIs(obj.message));
                            else alert(obj.message);
                        }
                    }
                });
                if (sitesWithFlexSchedules.length > 0) alert(`The following sites have flex schedules and were not armed: ${sitesWithFlexSchedules.join(", ")}.  To arm, visit the site's about page and turn on the "Arm" toggle to select which schedules to arm.`);
                if (disabledSites.length > 0) alert(`The following sites are currently disabled and were not armed: ${disabledSites.join(", ")}.  To arm, visit the site's about page and turn on the "Active" toggle.`);
            }
        }
        AxiosUI.get(`customer/by_group_id/${groupId}/?page_size=1000`).then((response)=>{
            const data = response.data.results;
            setRenderedRows(data);
            setPageLoading(false);
            if (actionString === "arm") setSiteScreenAlerts((previousState)=>{
                return {
                    ...previousState,
                    armGroupSuccess: true
                };
            });
            if (actionString === "disarm") setSiteScreenAlerts((previousState)=>{
                return {
                    ...previousState,
                    disarmGroupSuccess: true
                };
            });
            // if (actionString === "deploy") {
            //   setSiteScreenAlerts((previousState: any) => {
            //     return { ...previousState, deployGroupSuccess: true };
            //   });
            // }
            if (data) {
                const breadcrumbs = response.data.results[0].breadcrumbs;
                setSiteBreadcrumbs(breadcrumbs);
                localStorage.setItem("currentSiteBreadcrumbs", JSON.stringify(breadcrumbs));
                if (localStorage.navigatedFromSitesAboutPage === "true") localStorage.setItem("navigatedFromSitesAboutPage", "false");
            }
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                alert("Error Retrieving site data.");
                setRenderedRows([]);
                setPageLoading(false);
            });
        });
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert(`Error ${actionString}ing site. Please try again.`);
            setSiteScreenLoading(false);
        });
    });
    else {
        // Bulk SYNC: once every site has answered, offer to restart the synced
        // sites that are running, since Sync itself never restarts (ENG-2800).
        const syncedSiteIds = [];
        let settledCount = 0;
        const offerRestartWhenDone = ()=>{
            settledCount += 1;
            if (actionString !== "deploy" || settledCount !== selected.length) return;
            if (syncedSiteIds.length === 0) return;
            const namesById = {};
            (renderedRows ?? []).forEach((row)=>{
                if (row?.id !== undefined) namesById[String(row.id)] = row.name;
            });
            (0, $d3da6e0f4850a50d$export$8082cf22425fba15)(syncedSiteIds, namesById).then((0, $d3da6e0f4850a50d$export$7ea88d4c285933d3).getState().openPrompt);
        };
        selected.forEach(async (cameraId, index)=>{
            let action = actionString;
            if (actionString === "deploy") action = "deploy_next";
            await AxiosUI.post(`customer/${cameraId}/action/${action}/`).then((response)=>{
                if (!response.data[0]?.message) syncedSiteIds.push(String(cameraId));
                if (response.data[0]?.message) {
                    if (response.data[0].message.includes("flex schedule")) sitesWithFlexSchedules.push(findWordsBeforeHas(response.data[0].message));
                    else if (response.data[0].message.includes("disabled")) disabledSites.push(findWordsBeforeIs(response.data[0].message));
                    else alert(response.data[0].message);
                }
                if (selected.length - 1 === index) {
                    setSiteScreenLoading(false);
                    setPageLoading(true);
                    setSelected([]);
                    AxiosUI.get(`customer/by_group_id/${groupId}/?page_size=1000`).then((response)=>{
                        const data = response.data.results;
                        setRenderedRows(data);
                        setPageLoading(false);
                        if (actionString === "arm") {
                            if (sitesWithFlexSchedules.length > 0) alert(`The following sites have flex schedules and were not armed: ${sitesWithFlexSchedules.join(", ")}.  To arm, visit the site's about page and turn on the "Arm" toggle to select which schedules to arm.`);
                            if (disabledSites.length > 0) alert(`The following sites are currently disabled and were not armed: ${disabledSites.join(", ")}.  To arm, visit the site's about page and turn on the "Active" toggle.`);
                            setSiteScreenAlerts((previousState)=>{
                                return {
                                    ...previousState,
                                    armGroupSuccess: true
                                };
                            });
                        }
                        if (actionString === "disarm") setSiteScreenAlerts((previousState)=>{
                            return {
                                ...previousState,
                                disarmGroupSuccess: true
                            };
                        });
                        if (actionString === "deploy") setSiteScreenAlerts((previousState)=>{
                            return {
                                ...previousState,
                                deployGroupSuccess: true
                            };
                        });
                        if (data) {
                            const breadcrumbs = response.data.results[0].breadcrumbs;
                            setSiteBreadcrumbs(breadcrumbs);
                            localStorage.setItem("currentSiteBreadcrumbs", JSON.stringify(breadcrumbs));
                            if (localStorage.navigatedFromSitesAboutPage === "true") localStorage.setItem("navigatedFromSitesAboutPage", "false");
                        }
                    }, (reason)=>{
                        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                            alert("Error Retrieving site data.");
                            setRenderedRows([]);
                            setPageLoading(false);
                        });
                    });
                }
            }, (reason)=>{
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    alert(`Error ${actionString}ing site ${cameraId}.`);
                    setSiteScreenLoading(false);
                });
            });
            offerRestartWhenDone();
        });
    }
};



var $aYdit = parcelRequire("aYdit");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");
var $887xF = parcelRequire("887xF");
var $1TOOV = parcelRequire("1TOOV");
var $iLEpm = parcelRequire("iLEpm");
var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");

const $ff9bb024725de0a4$export$7c91c71aa8dd54c9 = ()=>{
    const { open: open, restart: restart, flex: flex, unconfirmed: unconfirmed, close: close } = (0, $d3da6e0f4850a50d$export$7ea88d4c285933d3)();
    const [restarting, setRestarting] = (0, $8T3gX.useState)(false);
    const handleRestart = async ()=>{
        setRestarting(true);
        const failed = await (0, $d3da6e0f4850a50d$export$3693a6a9c6afd791)(restart);
        setRestarting(false);
        close();
        if (failed.length > 0) alert(`These sites could not be restarted: ${failed.join(", ")}. Open each site's About page to restart it.`);
    };
    const siteList = (names)=>/*#__PURE__*/ (0, $k4ank.jsx)("ul", {
            className: "list-disc pl-[20px] mt-[6px] max-h-[160px] overflow-y-auto",
            children: names.map((name)=>/*#__PURE__*/ (0, $k4ank.jsx)("li", {
                    children: name
                }, name))
        });
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: open,
        "aria-labelledby": "bulk-sync-restart-title",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "bulk-sync-restart-title",
                children: restart.length > 0 ? "Restart running sites?" : "Sync finished"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                children: [
                    restart.length > 0 && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $iLEpm.default), {
                        component: "div",
                        children: [
                            restart.length === 1 ? "1 synced site is armed and still running its previous settings:" : `${restart.length} synced sites are armed and still running their previous settings:`,
                            siteList(restart.map((site)=>site.name)),
                            "Restart them now to apply the changes, or wait and the changes apply the next time each site arms."
                        ]
                    }),
                    flex.length > 0 && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $iLEpm.default), {
                        component: "div",
                        className: "mt-[12px]",
                        children: [
                            "These sites use flex schedules and can't be restarted from here. To apply now, open each site's About page and restart the schedules you want:",
                            siteList(flex.map((site)=>site.name))
                        ]
                    }),
                    unconfirmed.length > 0 && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $iLEpm.default), {
                        component: "div",
                        className: "mt-[12px]",
                        children: [
                            "We couldn't confirm these sites finished syncing, so they weren't included. Check each site's About page:",
                            siteList(unconfirmed.map((site)=>site.name))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), {
                children: restart.length > 0 ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            onClick: close,
                            text: "Wait for next arm",
                            disabled: restarting
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            onClick: handleRestart,
                            text: restarting ? "Restarting\u2026" : "Restart now",
                            disabled: restarting
                        })
                    ]
                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                    onClick: close,
                    text: "OK",
                    disabled: false
                })
            })
        ]
    });
};


const $83abe4d924206640$export$f72c5e4221c06d99 = (permissions)=>[
        ...permissions.arm_disarm ? [
            {
                action: "arm",
                label: "ARM"
            },
            {
                action: "disarm",
                label: "DISARM"
            }
        ] : [],
        ...permissions.edit_cameras ? [
            {
                action: "deploy",
                label: "SYNC"
            }
        ] : []
    ];
const $83abe4d924206640$export$4a30296ef9019606 = ({ selected: selected, renderedRows: renderedRows, setSiteScreenLoading: setSiteScreenLoading, groupId: groupId, setPageLoading: setPageLoading, setSelected: setSelected, setRenderedRows: setRenderedRows, setSiteBreadcrumbs: setSiteBreadcrumbs, setSiteScreenAlerts: setSiteScreenAlerts, navigate: navigate })=>{
    const [open, setOpen] = $8T3gX.useState(false);
    const anchorRef = $8T3gX.useRef(null);
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    const options = $83abe4d924206640$export$f72c5e4221c06d99(userPermissions);
    // Default to DISARM when it's offered, as before.
    const [selectedIndex, setSelectedIndex] = $8T3gX.useState(options.length > 1 ? 1 : 0);
    const handleClick = ()=>{
        const option = options[selectedIndex];
        if (!option) return;
        (0, $401e73ae5d9ac0cf$export$69fc1e497838bf4c)(option.action, selected, renderedRows, setSiteScreenLoading, groupId, setPageLoading, setSelected, setRenderedRows, setSiteBreadcrumbs, setSiteScreenAlerts, navigate);
    };
    const handleMenuItemClick = (event, index)=>{
        setSelectedIndex(index);
        setOpen(false);
    };
    const handleToggle = ()=>{
        setOpen((prevOpen)=>!prevOpen);
    };
    const handleClose = (event)=>{
        if (anchorRef.current && anchorRef.current.contains(event.target)) return;
        setOpen(false);
    };
    if (options.length === 0) return null;
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "z-10",
        children: /*#__PURE__*/ (0, $k4ank.jsxs)($8T3gX.Fragment, {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $d685fbaea40075f4$export$2e2bcd8739ae039), {
                    variant: "contained",
                    ref: anchorRef,
                    "aria-label": "Site Group Actions",
                    disabled: !selected[0],
                    color: "warning",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                            onClick: handleClick,
                            sx: {
                                backgroundColor: "#FF8400",
                                "&:hover": {
                                    backgroundColor: "#E67300"
                                }
                            },
                            children: options[selectedIndex]?.label
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                            size: "small",
                            "aria-controls": open ? "split-button-menu" : undefined,
                            "aria-expanded": open ? "true" : undefined,
                            "aria-label": "select group action",
                            "aria-haspopup": "menu",
                            sx: {
                                backgroundColor: "#FF8400",
                                "&:hover": {
                                    backgroundColor: "#E67300"
                                }
                            },
                            onClick: handleToggle,
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bf807683d00d38ca$exports))), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $cWqfz.default), {
                    sx: {
                        zIndex: 1
                    },
                    open: open,
                    anchorEl: anchorRef.current,
                    role: undefined,
                    transition: true,
                    disablePortal: true,
                    children: ({ TransitionProps: TransitionProps, placement: placement })=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $6CjWJ.default), {
                            ...TransitionProps,
                            style: {
                                transformOrigin: placement === "bottom" ? "center top" : "center bottom"
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4reBM.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eg2OC.ClickAwayListener), {
                                    onClickAway: handleClose,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eJK3E.default), {
                                        className: "absolute",
                                        id: "split-button-menu",
                                        autoFocusItem: true,
                                        children: options.map((option, index)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                selected: index === selectedIndex,
                                                onClick: (event)=>handleMenuItemClick(event, index),
                                                children: option.label
                                            }, option.action))
                                    })
                                })
                            })
                        })
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $ff9bb024725de0a4$export$7c91c71aa8dd54c9), {})
            ]
        })
    });
};



var $8jTCz = parcelRequire("8jTCz");

var $6pdiI = parcelRequire("6pdiI");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");

var $eejVe = parcelRequire("eejVe");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $6f1e18a50506a495$export$59974ab29c12f985 = (groupTrees, setGroupTrees, id, updatedName)=>{
    // Helper function to recursively update the name
    const updateName = (nodes)=>{
        return nodes.map((node)=>{
            if (node.id === id) // If the current node matches the id, update its name
            return {
                ...node,
                name: updatedName
            };
            // If the current node has children, recursively update them
            if (node.children && node.children.length > 0) return {
                ...node,
                children: updateName(node.children)
            };
            // Return the node unchanged if no match is found
            return node;
        });
    };
    // Update the groupTrees and call setGroupTrees with the new state
    setGroupTrees(updateName(groupTrees));
};


const $52d6d72dacd9e796$export$5b8189d9ad86d356 = (updatedGroupListName, setBackdropLoadingScreenOn, setSelectedGroupListName, groupTrees, setGroupTrees, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const selectedIndvidualGroupInfo = JSON.parse(localStorage.getItem("selectedIndvidualGroupInfo") || "{}");
    const refreshFunction = ()=>{
        $52d6d72dacd9e796$export$5b8189d9ad86d356(updatedGroupListName, setBackdropLoadingScreenOn, setSelectedGroupListName, groupTrees, setGroupTrees, navigate);
    };
    const pushObject = {
        name: updatedGroupListName,
        parent: selectedIndvidualGroupInfo.parent
    };
    AxiosUI.patch(`/group/${selectedIndvidualGroupInfo.id}/`, pushObject).then(()=>{
        setSelectedGroupListName(updatedGroupListName);
        (0, $6f1e18a50506a495$export$59974ab29c12f985)(groupTrees, setGroupTrees, selectedIndvidualGroupInfo.id, updatedGroupListName);
        setBackdropLoadingScreenOn(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, refreshFunction, ()=>{
            setBackdropLoadingScreenOn(false);
        });
    });
};


const $8c1b922fecbfbc77$export$53fd3eeed4b1bb6 = ({ editGroupNameDialogOpen: editGroupNameDialogOpen, setEditGroupNameDialogOpen: setEditGroupNameDialogOpen, initialValue: initialValue, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setSelectedGroupListName: setSelectedGroupListName, groupTrees: groupTrees, setGroupTrees: setGroupTrees, navigate: navigate })=>{
    const [newGroupName, setNewGroupName] = $8T3gX.useState(initialValue);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: editGroupNameDialogOpen,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                children: "Edit Group Name"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    defaultValue: initialValue,
                    id: "immix_server",
                    variant: "standard",
                    label: "Group Name",
                    onChange: (event)=>{
                        setNewGroupName(event.target.value);
                    },
                    sx: {
                        width: "400px"
                    },
                    type: "string"
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setEditGroupNameDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setEditGroupNameDialogOpen(false);
                            setBackdropLoadingScreenOn(true);
                            (0, $52d6d72dacd9e796$export$5b8189d9ad86d356)(newGroupName, setBackdropLoadingScreenOn, setSelectedGroupListName, groupTrees, setGroupTrees, navigate);
                        },
                        text: "Save",
                        disabled: false
                    })
                ]
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $j0ZEU = parcelRequire("j0ZEU");

var $3IuQ3 = parcelRequire("3IuQ3");

var $f3puC = parcelRequire("f3puC");

var $eXOoR = parcelRequire("eXOoR");

var $a65wX = parcelRequire("a65wX");
var $1fWBE = parcelRequire("1fWBE");
var $cxknk = parcelRequire("cxknk");

var $5GP2e = parcelRequire("5GP2e");


var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $60vL1 = parcelRequire("60vL1");
var $kUcVg = parcelRequire("kUcVg");
var $887xF = parcelRequire("887xF");
var $1TOOV = parcelRequire("1TOOV");
var $ce8iU = parcelRequire("ce8iU");
var $eejVe = parcelRequire("eejVe");
var $f3puC = parcelRequire("f3puC");


var $8jTCz = parcelRequire("8jTCz");
const $c948280532c89524$export$8cf66b2f8685561 = ({ open: open, onClose: onClose, navigate: navigate })=>{
    const { batchSize: batchSize, minimumResolutionHeight: minimumResolutionHeight, fetchingTenantSettings: fetchingTenantSettings, handlePatchTenantSettings: handlePatchTenantSettings, setUpdatingBatchSize: setUpdatingBatchSize, selectedGroupName: selectedGroupName } = (0, $0bb5fda2d17b239c$export$97ac24bd611f62c0)();
    const [localBatchSize, setLocalBatchSize] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(batchSize ?? 0);
    const [localMinimumResolutionHeight, setLocalMinimumResolutionHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(minimumResolutionHeight ?? 0);
    const [hasChanges, setHasChanges] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    // Reset local state when dialog opens
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (open) {
            setLocalBatchSize(batchSize ?? 0);
            setLocalMinimumResolutionHeight(minimumResolutionHeight ?? 0);
        }
    }, [
        open,
        batchSize,
        minimumResolutionHeight
    ]);
    // Check if the current value is different from the original
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: open,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                children: selectedGroupName ? `${selectedGroupName}` : "View / Edit Tenant Settings"
            }),
            fetchingTenantSettings ? /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "flex justify-center items-center h-full",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                    color: "primary"
                })
            }) : /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                        sx: {
                            width: 400
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "pl-[20px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                    children: "Max Batch Size:"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                    id: "outlined-basic",
                                    variant: "outlined",
                                    type: "number",
                                    value: localBatchSize,
                                    inputProps: {
                                        min: 1,
                                        step: 1
                                    },
                                    sx: {
                                        width: 150
                                    },
                                    onChange: (event)=>{
                                        const value = event.target.value;
                                        // Only allow positive integers
                                        if (value === "" || /^\d+$/.test(value)) {
                                            const numericValue = value === "" ? "" : Number(value);
                                            setLocalBatchSize(numericValue);
                                            setHasChanges(true);
                                        }
                                    },
                                    onKeyDown: (event)=>{
                                        // Prevent non-numeric characters except backspace, delete, arrow keys, etc.
                                        const allowedKeys = [
                                            "Backspace",
                                            "Delete",
                                            "ArrowLeft",
                                            "ArrowRight",
                                            "Tab"
                                        ];
                                        if (!allowedKeys.includes(event.key) && !/^\d$/.test(event.key)) event.preventDefault();
                                    }
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                            sx: {
                                                paddingTop: "20px"
                                            },
                                            children: "Minimum Resolution Height:"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                            value: localMinimumResolutionHeight,
                                            onChange: (event)=>{
                                                const value = event.target.value;
                                                // Only allow positive integers
                                                if (value === "" || /^\d+$/.test(value)) {
                                                    const numericValue = value === "" ? "" : Number(value);
                                                    setLocalMinimumResolutionHeight(numericValue);
                                                    setHasChanges(true);
                                                }
                                            },
                                            error: Number(localMinimumResolutionHeight) < 360,
                                            helperText: Number(localMinimumResolutionHeight) < 360 ? "Any resolution below 360 px may experience poor scene change performance." : "",
                                            variant: "outlined",
                                            sx: {
                                                width: 150
                                            },
                                            type: "number",
                                            inputProps: {
                                                min: 0
                                            },
                                            InputLabelProps: {
                                                shrink: true
                                            },
                                            autoComplete: "off"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    onClose();
                                },
                                text: "Cancel",
                                disabled: false
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    setUpdatingBatchSize(true);
                                    handlePatchTenantSettings(Number(localBatchSize), Number(localMinimumResolutionHeight), navigate);
                                    onClose();
                                },
                                text: ` Save `,
                                disabled: !hasChanges
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


const $784e658587299880$export$70f04861eac3ff76 = ({ siteBreadcrumbs: siteBreadcrumbs, setSelectedIndex: setSelectedIndex, setPageLoading: setPageLoading, getIndividualGroup: getIndividualGroup, setRenderedRows: setRenderedRows, setSiteBreadcrumbs: setSiteBreadcrumbs, setSelected: setSelected, setEditableGroupSelected: setEditableGroupSelected, setSelectedGroupListName: setSelectedGroupListName, navigate: navigate })=>{
    const { setSearchGroupId: setSearchGroupId, setSelectedGropupId: setSelectedGropupId, setSelectedGroupName: setSelectedGroupName, getTenantSettings: getTenantSettings, setFetchingTenantSettings: setFetchingTenantSettings } = (0, $0bb5fda2d17b239c$export$97ac24bd611f62c0)();
    const [anchorEl, setAnchorEl] = (0, $8T3gX.useState)(null);
    const [tenantSettingsDialogOpen, setTenantSettingsDialogOpen] = (0, $8T3gX.useState)(false);
    const [selectedObject, setSelectedObject] = (0, $8T3gX.useState)(null);
    const open = Boolean(anchorEl);
    const handleClick = (event, object)=>{
        setAnchorEl(event.currentTarget);
        setSelectedObject(object);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
        setSelectedObject(null);
    };
    const handleShowSites = (index)=>{
        const object = siteBreadcrumbs[index + 1];
        setSelectedIndex({
            level1: [
                object.id
            ],
            level2: [],
            level3: [],
            level4: [],
            level5: [],
            level6: []
        });
        setPageLoading(true);
        localStorage.setItem("getIndividualGroupId", object.id);
        setSearchGroupId(object.id);
        getIndividualGroup(object.id, setRenderedRows, setPageLoading, setSiteBreadcrumbs, setSelected, setEditableGroupSelected, setSelectedGroupListName, navigate);
        handleClose();
    };
    const handleViewEditBatchSize = ()=>{
        setSelectedGropupId(selectedObject?.id);
        setSelectedGroupName(selectedObject?.name);
        getTenantSettings(selectedObject?.id, navigate);
        setFetchingTenantSettings(true);
        setTenantSettingsDialogOpen(true);
        handleClose();
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3IuQ3.default), {
        spacing: 2,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "whitespace-nowrap flex-nowrap",
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $j0ZEU.default), {
                    separator: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXOoR))), {
                        fontSize: "medium"
                    }),
                    "aria-label": "breadcrumb",
                    sx: {
                        "& .MuiBreadcrumbs-ol": {
                            flexWrap: "nowrap",
                            whiteSpace: "nowrap"
                        },
                        "& .MuiBreadcrumbs-li": {
                            flexShrink: 0
                        }
                    },
                    children: [
                        !window.location.pathname.includes("patrol") && siteBreadcrumbs.map((object, index)=>{
                            if (index === 0 && siteBreadcrumbs.length > 1) // Original link behavior for non-patrol pages
                            return /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                                underline: "hover",
                                color: "inherit",
                                href: "/sites",
                                sx: {
                                    fontSize: "14px",
                                    fontFamily: "Mulish",
                                    fontWeight: "bold"
                                },
                                variant: "h5",
                                onClick: (event)=>{
                                    event.preventDefault();
                                    setSelectedIndex({
                                        level1: [
                                            object.id
                                        ],
                                        level2: [],
                                        level3: [],
                                        level4: [],
                                        level5: [],
                                        level6: []
                                    });
                                    setPageLoading(true);
                                    localStorage.setItem("getIndividualGroupId", object.id);
                                    setSearchGroupId(object.id);
                                    getIndividualGroup(object.id, setRenderedRows, setPageLoading, setSiteBreadcrumbs, setSelected, setEditableGroupSelected, setSelectedGroupListName, navigate);
                                },
                                children: object.name
                            }, index);
                            else if (index === 1 && siteBreadcrumbs.length > 2) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                                underline: "hover",
                                color: "inherit",
                                href: "#",
                                sx: {
                                    fontSize: "14px",
                                    fontFamily: "Mulish",
                                    fontWeight: "bold"
                                },
                                variant: "h5",
                                onClick: ()=>{
                                    setSelectedIndex({
                                        level1: [
                                            siteBreadcrumbs[0].id
                                        ],
                                        level2: [
                                            object.id
                                        ],
                                        level3: [],
                                        level4: [],
                                        level5: [],
                                        level6: []
                                    });
                                    setPageLoading(true);
                                    localStorage.setItem("getIndividualGroupId", object.id);
                                    setSearchGroupId(object.id);
                                    getIndividualGroup(object.id, setRenderedRows, setPageLoading, setSiteBreadcrumbs, setSelected, setEditableGroupSelected, setSelectedGroupListName, navigate);
                                },
                                children: object.name
                            }, index);
                            else if (index === 2 && siteBreadcrumbs.length > 3) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                                underline: "hover",
                                color: "inherit",
                                href: "#",
                                sx: {
                                    fontSize: "14px",
                                    fontFamily: "Mulish",
                                    fontWeight: "bold"
                                },
                                variant: "h5",
                                onClick: ()=>{
                                    setSelectedIndex({
                                        level1: [
                                            siteBreadcrumbs[0].id
                                        ],
                                        level2: [
                                            siteBreadcrumbs[1].id
                                        ],
                                        level3: [
                                            object.id
                                        ],
                                        level4: [],
                                        level5: [],
                                        level6: []
                                    });
                                    setPageLoading(true);
                                    localStorage.setItem("getIndividualGroupId", object.id);
                                    setSearchGroupId(object.id);
                                    getIndividualGroup(object.id, setRenderedRows, setPageLoading, setSiteBreadcrumbs, setSelected, setEditableGroupSelected, setSelectedGroupListName, navigate);
                                },
                                children: object.name
                            }, index);
                            else if (index === 3 && siteBreadcrumbs.length > 4) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                                underline: "hover",
                                color: "inherit",
                                href: "#",
                                sx: {
                                    fontSize: "14px",
                                    fontFamily: "Mulish",
                                    fontWeight: "bold"
                                },
                                variant: "h5",
                                onClick: ()=>{
                                    setSelectedIndex({
                                        level1: [
                                            siteBreadcrumbs[0].id
                                        ],
                                        level2: [
                                            siteBreadcrumbs[1].id
                                        ],
                                        level3: [
                                            siteBreadcrumbs[2].id
                                        ],
                                        level4: [
                                            object.id
                                        ],
                                        level5: [],
                                        level6: []
                                    });
                                    setPageLoading(true);
                                    localStorage.setItem("getIndividualGroupId", object.id);
                                    setSearchGroupId(object.id);
                                    getIndividualGroup(object.id, setRenderedRows, setPageLoading, setSiteBreadcrumbs, setSelected, setEditableGroupSelected, setSelectedGroupListName, navigate);
                                },
                                children: object.name
                            }, index);
                            else if (index === 4 && siteBreadcrumbs.length > 5) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                                underline: "hover",
                                color: "inherit",
                                href: "#",
                                sx: {
                                    fontSize: "14px",
                                    fontFamily: "Mulish",
                                    fontWeight: "bold"
                                },
                                variant: "h5",
                                onClick: ()=>{
                                    setSelectedIndex({
                                        level1: [
                                            siteBreadcrumbs[0].id
                                        ],
                                        level2: [
                                            siteBreadcrumbs[1].id
                                        ],
                                        level3: [
                                            siteBreadcrumbs[2].id
                                        ],
                                        level4: [
                                            siteBreadcrumbs[3].id
                                        ],
                                        level5: [
                                            object.id
                                        ],
                                        level6: []
                                    });
                                    setPageLoading(true);
                                    localStorage.setItem("getIndividualGroupId", object.id);
                                    setSearchGroupId(object.id);
                                    getIndividualGroup(object.id, setRenderedRows, setPageLoading, setSiteBreadcrumbs, setSelected, setEditableGroupSelected, setSelectedGroupListName, navigate);
                                },
                                children: object.name
                            }, index);
                            else if (index === 5 && siteBreadcrumbs.length > 6) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                                underline: "hover",
                                color: "inherit",
                                href: "#",
                                sx: {
                                    fontSize: "14px",
                                    fontFamily: "Mulish",
                                    fontWeight: "bold"
                                },
                                variant: "h5",
                                onClick: ()=>{
                                    setSelectedIndex({
                                        level1: [
                                            siteBreadcrumbs[0].id
                                        ],
                                        level2: [
                                            siteBreadcrumbs[1].id
                                        ],
                                        level3: [
                                            siteBreadcrumbs[2].id
                                        ],
                                        level4: [
                                            siteBreadcrumbs[3].id
                                        ],
                                        level5: [
                                            siteBreadcrumbs[4].id
                                        ],
                                        level6: [
                                            object.id
                                        ]
                                    });
                                    setPageLoading(true);
                                    localStorage.setItem("getIndividualGroupId", object.id);
                                    setSearchGroupId(object.id);
                                    getIndividualGroup(object.id, setRenderedRows, setPageLoading, setSiteBreadcrumbs, setSelected, setEditableGroupSelected, setSelectedGroupListName, navigate);
                                },
                                children: object.name
                            }, index);
                            else return /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                color: "text.primary",
                                fontSize: "14px",
                                fontFamily: "Mulish",
                                fontWeight: "bold",
                                children: object.name
                            }, index);
                        }),
                        window.location.pathname.includes("patrol") && siteBreadcrumbs.slice(1).map((object, index)=>{
                            // Capture the object for this specific button to avoid closure issues
                            const currentObject = object;
                            if (currentObject?.parent_account) return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                        onClick: (event)=>handleClick(event, currentObject),
                                        sx: {
                                            fontSize: "14px",
                                            fontFamily: "Mulish",
                                            fontWeight: "bold",
                                            color: "inherit",
                                            textTransform: "none",
                                            padding: 0,
                                            minWidth: "auto",
                                            "&:hover": {
                                                backgroundColor: "transparent",
                                                textDecoration: "underline"
                                            }
                                        },
                                        children: currentObject.name
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                                        anchorEl: anchorEl,
                                        open: open,
                                        onClose: handleClose,
                                        anchorOrigin: {
                                            vertical: "bottom",
                                            horizontal: "left"
                                        },
                                        transformOrigin: {
                                            vertical: "top",
                                            horizontal: "left"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                onClick: ()=>handleShowSites(index),
                                                children: "Show Sites"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                onClick: ()=>{
                                                    handleViewEditBatchSize();
                                                },
                                                children: "View/Edit Tenant Settings"
                                            })
                                        ]
                                    })
                                ]
                            }, index);
                            else return /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                color: "text.primary",
                                fontSize: "14px",
                                fontFamily: "Mulish",
                                fontWeight: "bold",
                                children: object.name
                            }, index);
                        })
                    ]
                })
            }),
            window.location.pathname.includes("patrol") && /*#__PURE__*/ (0, $k4ank.jsx)((0, $c948280532c89524$export$8cf66b2f8685561), {
                open: tenantSettingsDialogOpen,
                onClose: ()=>setTenantSettingsDialogOpen(false),
                navigate: navigate
            })
        ]
    });
};



var $aYdit = parcelRequire("aYdit");


var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $aYdit = parcelRequire("aYdit");

var $8jTCz = parcelRequire("8jTCz");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kbChx = parcelRequire("kbChx");
var $60vL1 = parcelRequire("60vL1");
var $kUcVg = parcelRequire("kUcVg");
var $887xF = parcelRequire("887xF");
var $1TOOV = parcelRequire("1TOOV");
var $ce8iU = parcelRequire("ce8iU");
var $3baw3 = parcelRequire("3baw3");
var $cxknk = parcelRequire("cxknk");
var $eejVe = parcelRequire("eejVe");

var $8jTCz = parcelRequire("8jTCz");

var $hG03Q = parcelRequire("hG03Q");

var $7txAP = parcelRequire("7txAP");

var $815yO = parcelRequire("815yO");

var $3Zv1D = parcelRequire("3Zv1D");

var $195EM = parcelRequire("195EM");
const $059ee3331a5c6de0$export$884f651e257ccae8 = {
    no_access: "You don't have permission to edit this site",
    not_found: "Site not found",
    no_matching_alerts: "No Patriot alerts match"
};
const $059ee3331a5c6de0$export$d75de65e70ca0101 = (reason)=>$059ee3331a5c6de0$export$884f651e257ccae8[reason] ?? "Skipped";
const $059ee3331a5c6de0$var$ERROR_CODE_TEXT = {
    bad_integration: "That integration can't be changed in bulk yet.",
    no_sites: "Select at least one site.",
    too_many_sites: "Too many sites for one change. Select fewer sites and try again.",
    bad_changes: "That change isn't valid. Pick what Patriot receives again."
};
const $059ee3331a5c6de0$export$c22c7c99f22fa695 = "You don't have permission to change alert settings for these sites.";
const $059ee3331a5c6de0$export$d722c71e52daa4e2 = (error)=>{
    if (error.response?.status === 400) {
        const data = error.response?.data ?? {};
        const code = data.code ?? data.error ?? data.detail;
        return typeof code === "string" && $059ee3331a5c6de0$var$ERROR_CODE_TEXT[code] || "The change couldn't be made. Check your choices and try again.";
    }
    return null;
};
const $059ee3331a5c6de0$export$f7f42a4b256f49fe = async (request)=>{
    const response = await (0, $195EM.createApi)("").post("alert-settings/bulk/", request);
    return response.data;
};
const $059ee3331a5c6de0$export$aaa60ab18256f792 = (filter)=>{
    const cleaned = {};
    const clientNo = filter.patriot_client_no?.trim();
    const server = filter.patriot_server?.trim();
    if (clientNo) cleaned.patriot_client_no = clientNo;
    if (server) cleaned.patriot_server = server;
    return Object.keys(cleaned).length ? cleaned : undefined;
};
const $059ee3331a5c6de0$export$3faf2fb4bb66db2f = (sites)=>{
    let changed = 0;
    let unchanged = 0;
    sites.forEach((site)=>site.cameras.forEach((camera)=>camera.alerts.forEach((alert)=>{
                if (alert.changed) changed += 1;
                else unchanged += 1;
            })));
    return {
        changed: changed,
        unchanged: unchanged
    };
};


const $21157eb284987462$export$91f762c42547c7b4 = [
    {
        id: "patriot",
        label: "Patriot",
        filterFields: [
            {
                key: "patriot_client_no",
                label: "Patriot client no"
            },
            {
                key: "patriot_server",
                label: "Patriot server"
            }
        ]
    }
];
const $21157eb284987462$var$plural = (count, word)=>`${count} ${word}${count === 1 ? "" : "s"}`;
const $21157eb284987462$export$b29c32aa689195c2 = ({ open: open, onClose: onClose, sites: sites, groupName: groupName, allSitesInGroup: allSitesInGroup, navigate: navigate })=>{
    const ignoreZonesOnAlertPage = (0, $7txAP.usePatriotIgnoreZonesOnAlertPage)();
    const [includedIds, setIncludedIds] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(()=>sites.map((site)=>site.id));
    const [integration, setIntegration] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("patriot");
    const [changes, setChanges] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        patriot_send_video: false,
        draw_ignore_zones: false
    });
    const [filter, setFilter] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [preview, setPreview] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [result, setResult] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [error, setError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const integrationConfig = $21157eb284987462$export$91f762c42547c7b4.find((option)=>option.id === integration) ?? $21157eb284987462$export$91f762c42547c7b4[0];
    const siteName = (id)=>sites.find((site)=>site.id === id)?.name ?? `Site ${id}`;
    // Any edit to the inputs makes an earlier preview stale.
    const invalidate = ()=>{
        setPreview(null);
        setError("");
    };
    const send = (dryRun)=>{
        setLoading(true);
        setError("");
        (0, $059ee3331a5c6de0$export$f7f42a4b256f49fe)({
            site_ids: includedIds,
            integration: integration,
            changes: changes,
            filter: (0, $059ee3331a5c6de0$export$aaa60ab18256f792)(filter),
            dry_run: dryRun
        }).then((data)=>{
            setLoading(false);
            if (dryRun) {
                setPreview(data);
                return;
            }
            data.sites.forEach((site)=>{
                if (site.changed_count > 0) (0, $815yO.markSiteUnsynced)(String(site.site_id));
            });
            setResult(data);
        }, (reason)=>{
            setLoading(false);
            const message = (0, $059ee3331a5c6de0$export$d722c71e52daa4e2)(reason);
            if (message) {
                setError(message);
                return;
            }
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, ()=>send(dryRun), ()=>setError(reason.response?.status === 403 ? (0, $059ee3331a5c6de0$export$c22c7c99f22fa695) : "Something went wrong saving alert settings. Please try again."));
        });
    };
    const deliveryText = (values)=>(0, $hG03Q.patriotDeliveryDisplayText)(values.patriot_send_video, values.draw_ignore_zones, ignoreZonesOnAlertPage);
    const renderSkipped = (data)=>data.skipped_sites.length > 0 && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: "mt-3",
            "data-testid": "bulk-skipped-sites",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                    className: "font-mulish font-bold text-sm",
                    children: [
                        "Skipped ",
                        $21157eb284987462$var$plural(data.skipped_sites.length, "site")
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("ul", {
                    className: "list-disc pl-5 text-sm",
                    children: data.skipped_sites.map((skipped)=>/*#__PURE__*/ (0, $k4ank.jsxs)("li", {
                            children: [
                                siteName(skipped.site_id),
                                ": ",
                                (0, $059ee3331a5c6de0$export$d75de65e70ca0101)(skipped.reason)
                            ]
                        }, skipped.site_id))
                })
            ]
        });
    const renderPreview = (data)=>{
        const { changed: changed, unchanged: unchanged } = (0, $059ee3331a5c6de0$export$3faf2fb4bb66db2f)(data.sites);
        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: "mt-4",
            "data-testid": "bulk-preview",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                    className: "font-mulish font-bold",
                    children: [
                        $21157eb284987462$var$plural(changed, "alert"),
                        " will change across",
                        " ",
                        $21157eb284987462$var$plural(data.sites.filter((site)=>site.changed_count > 0).length, "site"),
                        unchanged > 0 && `; ${unchanged} already set this way`
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "max-h-[320px] overflow-y-auto mt-2 border border-actuate-grey rounded",
                    children: data.sites.map((site)=>/*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "p-2 border-b border-actuate-grey",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                    className: "font-mulish font-bold text-sm",
                                    children: [
                                        site.site_name,
                                        " (",
                                        site.changed_count,
                                        " changing)"
                                    ]
                                }),
                                site.cameras.map((camera)=>/*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "pl-3 mt-1",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "font-mulish text-sm",
                                                children: camera.camera_name
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("ul", {
                                                className: "pl-3 text-xs",
                                                children: camera.alerts.map((alert)=>/*#__PURE__*/ (0, $k4ank.jsxs)("li", {
                                                        className: alert.changed ? "" : "text-gray-500",
                                                        children: [
                                                            "Client ",
                                                            alert.patriot_client_no || "-",
                                                            ", zone",
                                                            " ",
                                                            alert.patriot_zone_number ?? "-",
                                                            ":",
                                                            " ",
                                                            alert.changed ? `${deliveryText(alert.before)} \u{2192} ${deliveryText(alert.after)}` : `${deliveryText(alert.before)} (no change)`
                                                        ]
                                                    }, alert.alert_id))
                                            })
                                        ]
                                    }, camera.camera_id))
                            ]
                        }, site.site_id))
                }),
                renderSkipped(data)
            ]
        });
    };
    const renderResult = (data)=>{
        const changedSites = data.sites.filter((site)=>site.changed_count > 0);
        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            "data-testid": "bulk-result",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                    className: "font-mulish font-bold",
                    children: [
                        "Updated ",
                        $21157eb284987462$var$plural(data.changed_count, "alert"),
                        " across",
                        " ",
                        $21157eb284987462$var$plural(changedSites.length, "site"),
                        "."
                    ]
                }),
                changedSites.length > 0 && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "font-mulish text-sm mt-2",
                            children: "These changes reach each site's connector after you Sync it. Open a site and press Sync, or select the sites here and use Bulk Action \u2192 SYNC."
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("ul", {
                            className: "list-disc pl-5 text-sm mt-1",
                            children: changedSites.map((site)=>/*#__PURE__*/ (0, $k4ank.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("a", {
                                        className: "text-actuate-blue underline",
                                        href: `/sites/aboutsite/${site.site_id}`,
                                        onClick: (event)=>{
                                            event.preventDefault();
                                            onClose();
                                            navigate(`/sites/aboutsite/${site.site_id}`);
                                        },
                                        children: site.site_name
                                    })
                                }, site.site_id))
                        })
                    ]
                }),
                renderSkipped(data)
            ]
        });
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: open,
        onClose: onClose,
        maxWidth: "md",
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                sx: {
                    fontFamily: "Mulish"
                },
                children: "Bulk alert settings"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                children: [
                    result ? renderResult(result) : /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "font-mulish",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                className: "font-bold",
                                children: [
                                    allSitesInGroup ? `All ${sites.length} sites in ${groupName}` : `${$21157eb284987462$var$plural(sites.length, "selected site")}`,
                                    includedIds.length !== sites.length && ` (${includedIds.length} included)`
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "max-h-[160px] overflow-y-auto mt-1 mb-3 flex flex-col",
                                children: sites.map((site)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                        label: site.name,
                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                            size: "small",
                                            checked: includedIds.includes(site.id),
                                            onChange: (event, checked)=>{
                                                setIncludedIds((previous)=>checked ? [
                                                        ...previous,
                                                        site.id
                                                    ] : previous.filter((id)=>id !== site.id));
                                                invalidate();
                                            }
                                        })
                                    }, site.id))
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                select: true,
                                size: "small",
                                label: "Integration",
                                value: integration,
                                onChange: (event)=>{
                                    const next = event.target.value;
                                    setIntegration(next);
                                    invalidate();
                                },
                                sx: {
                                    minWidth: "14rem",
                                    marginBottom: "1rem"
                                },
                                children: $21157eb284987462$export$91f762c42547c7b4.map((option)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        value: option.id,
                                        children: option.label
                                    }, option.id))
                            }),
                            integration === "patriot" && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "mb-3",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $hG03Q.PatriotDeliveryChoice), {
                                    name: "bulk-patriot-delivery",
                                    sendVideo: changes.patriot_send_video,
                                    drawIgnoreZones: changes.draw_ignore_zones,
                                    onChange: (values)=>{
                                        setChanges(values);
                                        invalidate();
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "font-bold text-sm",
                                children: "Only change alerts for (optional)"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "flex flex-wrap gap-3 mt-2",
                                children: integrationConfig.filterFields.map((field)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        size: "small",
                                        label: field.label,
                                        value: filter[field.key] ?? "",
                                        onChange: (event)=>{
                                            // Capture eagerly; see CLAUDE.md "event.target.value" gotcha.
                                            const nextValue = event.target.value;
                                            setFilter((previous)=>({
                                                    ...previous,
                                                    [field.key]: nextValue
                                                }));
                                            invalidate();
                                        }
                                    }, field.key))
                            }),
                            preview && renderPreview(preview)
                        ]
                    }),
                    error && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        role: "alert",
                        className: "text-red-600 font-mulish text-sm mt-3",
                        children: error
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    loading && /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                        size: 20,
                        sx: {
                            marginRight: "8px"
                        }
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: onClose,
                        text: result ? "Close" : "Cancel",
                        disabled: false
                    }),
                    !result && !preview && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>send(true),
                        text: "Preview changes",
                        disabled: loading || includedIds.length === 0
                    }),
                    !result && preview && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>send(false),
                        text: "Apply",
                        disabled: loading || preview.changed_count === 0
                    })
                ]
            })
        ]
    });
};


const $441b21dd4f3829cf$export$c8398ca36db98ae9 = ({ selected: selected, renderedRows: renderedRows, groupName: groupName, navigate: navigate })=>{
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [dialogSites, setDialogSites] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    if (!userPermissions?.edit_cameras) return null;
    const rows = Array.isArray(renderedRows) ? renderedRows : [];
    if (rows.length === 0) return null;
    const selectedIds = selected.map(String);
    const allSitesInGroup = selectedIds.length === 0;
    const handleOpen = ()=>{
        const chosen = allSitesInGroup ? rows : rows.filter((row)=>selectedIds.includes(String(row.id)));
        setDialogSites(chosen.map((row)=>({
                id: Number(row.id),
                name: String(row.name)
            })));
        setOpen(true);
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                onClick: handleOpen,
                text: "Bulk alert settings",
                disabled: false,
                className: "hover:bg-[#E67300] ml-2"
            }),
            open && /*#__PURE__*/ (0, $k4ank.jsx)((0, $21157eb284987462$export$b29c32aa689195c2), {
                open: open,
                onClose: ()=>setOpen(false),
                sites: dialogSites,
                groupName: groupName,
                allSitesInGroup: allSitesInGroup,
                navigate: navigate
            })
        ]
    });
};


const $06c7bcc94349a545$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $06c7bcc94349a545$export$ec49a4b6162b54ba = (props)=>{
    const { navBarCollapsed: navBarCollapsed, renderedRows: renderedRows, page: page, rowsPerPage: rowsPerPage, setPageLoading: setPageLoading, navigate: navigate, setPage: setPage, setRowsPerPage: setRowsPerPage, handleSelectAllClick: handleSelectAllClick, handleSingleCheckboxClick: handleSingleCheckboxClick, isSelected: isSelected, selected: selected, setSelected: setSelected, setSiteBreadcrumbs: setSiteBreadcrumbs, setSiteScreenAlerts: setSiteScreenAlerts, setRenderedRows: setRenderedRows, setSiteScreenLoading: setSiteScreenLoading, editableGroupSelected: editableGroupSelected, selectedGroupListName: selectedGroupListName, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setSelectedGroupListName: setSelectedGroupListName, groupTrees: groupTrees, setGroupTrees: setGroupTrees, siteBreadcrumbs: siteBreadcrumbs, setSelectedIndex: setSelectedIndex, getIndividualGroup: getIndividualGroup, setEditableGroupSelected: setEditableGroupSelected } = props;
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    const [order, setOrder] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("asc");
    const [orderBy, setOrderBy] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("name");
    // Add local state to manage renderedRows, similar to CamerasTable
    const [localRenderedRows, setLocalRenderedRows] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(Array.isArray(renderedRows) ? renderedRows : []);
    // Sync local state with prop changes
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (Array.isArray(renderedRows)) setLocalRenderedRows(renderedRows);
        else setLocalRenderedRows([]);
    }, [
        renderedRows,
        window.location.pathname
    ]);
    // ENG-2634: a big group renders its first page and keeps loading the rest.
    const groupSitesProgress = (0, $0bb5fda2d17b239c$export$97ac24bd611f62c0)((state)=>state.groupSitesProgress);
    const sitesStillLoading = !!groupSitesProgress && !groupSitesProgress.done;
    const handleRequestSort = (event, property)=>{
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };
    const visibleRows = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>{
        // Ensure page and rowsPerPage are valid numbers
        const validPage = typeof page === "number" && !isNaN(page) ? page : 0;
        const validRowsPerPage = typeof rowsPerPage === "number" && !isNaN(rowsPerPage) ? rowsPerPage : 10;
        return (0, $fWsn7.stableSort)(localRenderedRows, (0, $fWsn7.getComparator)(order, orderBy)).slice(validPage * validRowsPerPage, validPage * validRowsPerPage + validRowsPerPage);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        order,
        orderBy,
        page,
        rowsPerPage,
        localRenderedRows
    ]);
    const { height: height } = (0, $crpct.default)();
    const [anchorEl, setAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const ITEM_HEIGHT = 48;
    const [selectedRow, setSelectedRow] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setCalculatedHeight(height - 205);
    }, [
        height
    ]);
    const [calcuatedHeight, setCalculatedHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [editGroupNameDialogOpen, setEditGroupNameDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const patrolOnlySitesPage = window.location.pathname.includes("patrol") ? true : false;
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: `absolute ${navBarCollapsed ? "left-[330px]" : "left-[405px]"} top-[77px] right-[5px]`,
        children: [
            editGroupNameDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8c1b922fecbfbc77$export$53fd3eeed4b1bb6), {
                editGroupNameDialogOpen: editGroupNameDialogOpen,
                setEditGroupNameDialogOpen: setEditGroupNameDialogOpen,
                initialValue: selectedGroupListName,
                setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                setSelectedGroupListName: setSelectedGroupListName,
                groupTrees: groupTrees,
                setGroupTrees: setGroupTrees,
                navigate: navigate
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4reBM.default), {
                sx: {
                    width: "100%",
                    overflow: "hidden",
                    minWidth: 700
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "relative pt-[10px] pl-[15px] pr-[15px] z-51",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "flex items-center justify-between min-w-0",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "flex-1 min-w-0 overflow-hidden",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "font-mulish text-[20px] z-10 pt-[8px] pb-[2px] flex items-center min-w-0",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "overflow-x-auto overflow-y-hidden flex-1 min-w-0",
                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                className: "flex items-center whitespace-nowrap flex-nowrap",
                                                children: [
                                                    siteBreadcrumbs[0] ? /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "flex-shrink-0",
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $784e658587299880$export$70f04861eac3ff76), {
                                                            siteBreadcrumbs: siteBreadcrumbs,
                                                            setSelectedIndex: setSelectedIndex,
                                                            setPageLoading: setPageLoading,
                                                            getIndividualGroup: getIndividualGroup,
                                                            setRenderedRows: setRenderedRows,
                                                            setSiteBreadcrumbs: setSiteBreadcrumbs,
                                                            setSelected: setSelected,
                                                            setEditableGroupSelected: setEditableGroupSelected,
                                                            setSelectedGroupListName: setSelectedGroupListName,
                                                            navigate: navigate
                                                        })
                                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "flex-shrink-0",
                                                        children: selectedGroupListName
                                                    }),
                                                    editableGroupSelected && userPermissions.edit_cameras && !patrolOnlySitesPage ? /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "flex-shrink-0 ml-2",
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                            text: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                                title: "Edit Group Name",
                                                                placement: "top",
                                                                sx: {
                                                                    fontSize: "18px",
                                                                    fontFamily: "mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {})
                                                            }),
                                                            onClick: ()=>{
                                                                setEditGroupNameDialogOpen(true);
                                                            },
                                                            disabled: false
                                                        })
                                                    }) : ""
                                                ]
                                            })
                                        })
                                    })
                                }),
                                selectedGroupListName && !patrolOnlySitesPage && (0, $83abe4d924206640$export$f72c5e4221c06d99)(userPermissions).length > 0 && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "flex items-center ml-4 flex-shrink-0 pb-[5px]",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "font-mulish font-bold pt-[5px] pr-[15px]",
                                            children: "Bulk Action:"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $83abe4d924206640$export$4a30296ef9019606), {
                                            selected: selected,
                                            renderedRows: renderedRows,
                                            setSiteScreenLoading: setSiteScreenLoading,
                                            groupId: renderedRows[0]?.breadcrumbs[0].id,
                                            setPageLoading: setPageLoading,
                                            setSelected: setSelected,
                                            setRenderedRows: setRenderedRows,
                                            setSiteBreadcrumbs: setSiteBreadcrumbs,
                                            setSiteScreenAlerts: setSiteScreenAlerts,
                                            navigate: navigate
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $441b21dd4f3829cf$export$c8398ca36db98ae9), {
                                            selected: selected,
                                            renderedRows: renderedRows,
                                            groupName: selectedGroupListName,
                                            navigate: navigate
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    groupSitesProgress && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "font-mulish text-[13px] px-[16px] py-[6px] bg-[#fff8e1] text-[#6b4f00]",
                        "data-testid": "group-sites-progress",
                        children: groupSitesProgress.failed && groupSitesProgress.done ? `Couldn't load every site in this group (${groupSitesProgress.loaded.toLocaleString()} of ${groupSitesProgress.total.toLocaleString()}). Reopen the group to try again.` : `Loading sites\u{2026} ${groupSitesProgress.loaded.toLocaleString()} of ${groupSitesProgress.total.toLocaleString()}. Sorting and search cover the loaded sites; select all is available once every site has loaded.`
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                        sx: {
                            maxHeight: calcuatedHeight
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                            stickyHeader: true,
                            size: "small",
                            sx: {
                                postion: "absolute",
                                top: 150,
                                // minWidth: "1030px",
                                minWidth: patrolOnlySitesPage ? "820px" : "1050px",
                                fontFamily: "Mulish"
                            },
                            children: [
                                !renderedRows[0] ? !patrolOnlySitesPage ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontSize: "12px",
                                                    fontFamily: "mulish",
                                                    fontWeight: "Bold"
                                                },
                                                children: "Site Name"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontSize: "12px",
                                                    fontFamily: "mulish",
                                                    fontWeight: "Bold"
                                                },
                                                children: "Armed"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontSize: "12px",
                                                    fontFamily: "mulish",
                                                    fontWeight: "Bold"
                                                },
                                                children: "Cameras"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontSize: "12px",
                                                    fontFamily: "mulish",
                                                    fontWeight: "Bold"
                                                },
                                                children: "Health"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontSize: "12px",
                                                    fontFamily: "mulish",
                                                    fontWeight: "Bold"
                                                },
                                                children: "Optimal Settings"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontSize: "12px",
                                                    fontFamily: "mulish",
                                                    fontWeight: "Bold"
                                                },
                                                children: "Bandwidth Usage"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontSize: "12px",
                                                    fontFamily: "mulish",
                                                    fontWeight: "Bold"
                                                },
                                                children: "Synced"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontSize: "12px",
                                                    fontFamily: "mulish",
                                                    fontWeight: "Bold"
                                                },
                                                children: "Active"
                                            })
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontSize: "12px",
                                                    fontFamily: "mulish",
                                                    fontWeight: "Bold"
                                                },
                                                children: "Site Name"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontSize: "12px",
                                                    fontFamily: "mulish",
                                                    fontWeight: "Bold"
                                                },
                                                children: "Cameras"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontSize: "12px",
                                                    fontFamily: "mulish",
                                                    fontWeight: "Bold"
                                                },
                                                children: "Active"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontSize: "12px",
                                                    fontFamily: "mulish",
                                                    fontWeight: "Bold"
                                                },
                                                children: "Patrol Schedules"
                                            })
                                        ]
                                    })
                                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $d7016a2e03c6974f$export$c84958dc9f5c6fe), {
                                    onRequestSort: handleRequestSort,
                                    orderBy: orderBy,
                                    order: order,
                                    onSelectAllClick: handleSelectAllClick,
                                    selectAllDisabled: sitesStillLoading
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                    children: visibleRows.map((row, index)=>{
                                        const isItemSelected = isSelected(row.id);
                                        return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                            hover: true,
                                            onClick: ()=>{
                                                setSelectedRow(row);
                                            },
                                            tabIndex: -1,
                                            sx: {
                                                cursor: "pointer",
                                                fontFamily: "Mulish"
                                            },
                                            children: [
                                                !patrolOnlySitesPage && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    padding: "checkbox",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                        color: "primary",
                                                        checked: isItemSelected,
                                                        onClick: (event)=>handleSingleCheckboxClick(event, row.id)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    sx: {
                                                        fontFamily: "Mulish",
                                                        fontSize: 12,
                                                        minWidth: "200px"
                                                    },
                                                    onClick: ()=>{
                                                        navigate(`/sites/aboutsite/${row.id}`);
                                                        handleClose();
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                                                        href: `/sites/aboutsite/${row.id}`,
                                                        onClick: (e)=>{
                                                            e.preventDefault(); // Prevent default anchor navigation
                                                            navigate(`/sites/aboutsite/${row.id}`); // Use React Router navigation
                                                        },
                                                        sx: {
                                                            textDecoration: "none",
                                                            color: "inherit",
                                                            cursor: "pointer",
                                                            height: "100%"
                                                        },
                                                        children: row.name
                                                    })
                                                }),
                                                !patrolOnlySitesPage && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    onClick: ()=>{
                                                        navigate(`/sites/aboutsite/${row.id}`);
                                                        handleClose();
                                                    },
                                                    sx: {
                                                        fontFamily: "Mulish",
                                                        width: "95px"
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                                                        href: `/sites/aboutsite/${row.id}`,
                                                        onClick: (e)=>{
                                                            e.preventDefault(); // Prevent default anchor navigation
                                                            navigate(`/sites/aboutsite/${row.id}`); // Use React Router navigation
                                                        },
                                                        sx: {
                                                            textDecoration: "none",
                                                            color: "inherit",
                                                            cursor: "pointer",
                                                            height: "100%"
                                                        },
                                                        children: (0, $72999d1495bbb021$export$245d71629b1d752a)(row.armed, row.armed_status)
                                                    })
                                                }),
                                                !patrolOnlySitesPage && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    onClick: ()=>{
                                                        navigate(`/sites/aboutsite/${row.id}`);
                                                        handleClose();
                                                    },
                                                    sx: {
                                                        fontFamily: "Mulish",
                                                        fontSize: 13,
                                                        width: "95px"
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                                                        href: `/sites/aboutsite/${row.id}`,
                                                        onClick: (e)=>{
                                                            e.preventDefault(); // Prevent default anchor navigation
                                                            navigate(`/sites/aboutsite/${row.id}`); // Use React Router navigation
                                                        },
                                                        sx: {
                                                            textDecoration: "none",
                                                            color: "inherit",
                                                            cursor: "pointer",
                                                            height: "100%"
                                                        },
                                                        children: row.cameras
                                                    })
                                                }),
                                                !patrolOnlySitesPage && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    onClick: ()=>{
                                                        navigate(`/sites/aboutsite/${row.id}`);
                                                        handleClose();
                                                    },
                                                    sx: {
                                                        fontFamily: "Mulish",
                                                        fontSize: 13,
                                                        width: "95px"
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                                                        href: `/sites/aboutsite/${row.id}`,
                                                        onClick: (e)=>{
                                                            e.preventDefault(); // Prevent default anchor navigation
                                                            navigate(`/sites/aboutsite/${row.id}`); // Use React Router navigation
                                                        },
                                                        sx: {
                                                            textDecoration: "none",
                                                            color: "inherit",
                                                            cursor: "pointer",
                                                            height: "100%"
                                                        },
                                                        children: (0, $0eccbe0a25436241$export$135e73f04b466e08)(row.health, row.error, row.warning)
                                                    })
                                                }),
                                                !patrolOnlySitesPage && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    onClick: ()=>{
                                                        navigate(`/sites/aboutsite/${row.id}`);
                                                        handleClose();
                                                    },
                                                    sx: {
                                                        fontFamily: "Mulish",
                                                        fontSize: 13,
                                                        width: "135px"
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                                                        href: `/sites/aboutsite/${row.id}`,
                                                        onClick: (e)=>{
                                                            e.preventDefault(); // Prevent default anchor navigation
                                                            navigate(`/sites/aboutsite/${row.id}`); // Use React Router navigation
                                                        },
                                                        sx: {
                                                            textDecoration: "none",
                                                            color: "inherit",
                                                            cursor: "pointer",
                                                            height: "100%"
                                                        },
                                                        children: (0, $712f729ecf62e7b6$export$e20667e62845fc5b)(row.requirements_bad, row.requirements_warning)
                                                    })
                                                }),
                                                !patrolOnlySitesPage && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    onClick: ()=>{
                                                        navigate(`/sites/aboutsite/${row.id}`);
                                                        handleClose();
                                                    },
                                                    sx: {
                                                        fontFamily: "Mulish",
                                                        fontSize: 13,
                                                        width: 135
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                                                        href: `/sites/aboutsite/${row.id}`,
                                                        onClick: (e)=>{
                                                            e.preventDefault(); // Prevent default anchor navigation
                                                            navigate(`/sites/aboutsite/${row.id}`); // Use React Router navigation
                                                        },
                                                        sx: {
                                                            textDecoration: "none",
                                                            color: "inherit",
                                                            cursor: "pointer",
                                                            height: "100%"
                                                        },
                                                        children: row.bandwidth ? (0, $3428fce36a3d76b5$export$ad6f9224b29a30a4)(row.bandwidth) : "N/A"
                                                    })
                                                }),
                                                !patrolOnlySitesPage && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    onClick: ()=>{
                                                        navigate(`/sites/aboutsite/${row.id}`);
                                                        handleClose();
                                                    },
                                                    sx: {
                                                        fontFamily: "Mulish",
                                                        width: "95px"
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                                                        href: `/sites/aboutsite/${row.id}`,
                                                        onClick: (e)=>{
                                                            e.preventDefault(); // Prevent default anchor navigation
                                                            navigate(`/sites/aboutsite/${row.id}`); // Use React Router navigation
                                                        },
                                                        sx: {
                                                            textDecoration: "none",
                                                            color: "inherit",
                                                            cursor: "pointer",
                                                            height: "100%"
                                                        },
                                                        children: row.deployed ? /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5Ibhh))), {
                                                            color: "success",
                                                            fontSize: "small"
                                                        }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cye0Y))), {
                                                            color: "error",
                                                            fontSize: "small"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    onClick: ()=>{
                                                        navigate(`/sites/aboutsite/${row.id}`);
                                                        handleClose();
                                                    },
                                                    sx: {
                                                        fontFamily: "Mulish",
                                                        width: 90
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                                                        href: `/sites/aboutsite/${row.id}`,
                                                        onClick: (e)=>{
                                                            e.preventDefault(); // Prevent default anchor navigation
                                                            navigate(`/sites/aboutsite/${row.id}`); // Use React Router navigation
                                                        },
                                                        sx: {
                                                            textDecoration: "none",
                                                            color: "inherit",
                                                            cursor: "pointer",
                                                            height: "100%"
                                                        },
                                                        children: row.active ? /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5Ibhh))), {
                                                            color: "success",
                                                            fontSize: "small"
                                                        }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cye0Y))), {
                                                            color: "error",
                                                            fontSize: "small"
                                                        })
                                                    })
                                                }),
                                                patrolOnlySitesPage && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    onClick: ()=>{
                                                        navigate(`/sites/aboutsite/${row.id}`);
                                                        handleClose();
                                                    },
                                                    sx: {
                                                        fontFamily: "Mulish",
                                                        fontSize: 13,
                                                        width: "64px"
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                                                        href: `/sites/aboutsite/${row.id}`,
                                                        onClick: (e)=>{
                                                            e.preventDefault(); // Prevent default anchor navigation
                                                            navigate(`/sites/aboutsite/${row.id}`); // Use React Router navigation
                                                        },
                                                        sx: {
                                                            textDecoration: "none",
                                                            color: "inherit",
                                                            cursor: "pointer",
                                                            height: "100%"
                                                        },
                                                        children: row.patrol_schedules ? row.patrol_schedules : "N/A"
                                                    })
                                                }),
                                                !patrolOnlySitesPage && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                                            "aria-label": "more",
                                                            id: "long-button",
                                                            "aria-controls": open ? "long-menu" : undefined,
                                                            "aria-expanded": open ? "true" : undefined,
                                                            "aria-haspopup": "true",
                                                            onClick: (e)=>{
                                                                setSelectedRow(row);
                                                                handleClick(e);
                                                            },
                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5MAs))), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                                                            id: "long-menu",
                                                            MenuListProps: {
                                                                "aria-labelledby": "long-button"
                                                            },
                                                            anchorOrigin: {
                                                                vertical: "top",
                                                                horizontal: "left"
                                                            },
                                                            transformOrigin: {
                                                                vertical: "top",
                                                                horizontal: "left"
                                                            },
                                                            anchorEl: anchorEl,
                                                            open: open,
                                                            onClose: handleClose,
                                                            PaperProps: {
                                                                style: {
                                                                    maxHeight: ITEM_HEIGHT * 4.5,
                                                                    width: "20ch"
                                                                }
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                                    onClick: ()=>{
                                                                        navigate(`/sites/aboutsite/${selectedRow.id}`);
                                                                        handleClose();
                                                                    },
                                                                    children: "View/Edit Site"
                                                                }, "view-edit-site"),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                                    onClick: ()=>{
                                                                        (0, $471e4fda77b11d18$export$83b9ba99925051d2)(selectedRow.name, selectedRow.breadcrumbs[0].id, selectedRow.id, navigate);
                                                                        handleClose();
                                                                    },
                                                                    children: "Site Analytics"
                                                                }, "site-analytics"),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                                    onClick: ()=>{
                                                                        navigate(`/alerts/?group=${selectedRow.breadcrumbs[0].id}&site=${selectedRow.id}`);
                                                                        handleClose();
                                                                    },
                                                                    children: "Site Alerts"
                                                                }, "site-analytics"),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                                    onClick: ()=>{
                                                                        navigate(`/actionlogs/${selectedRow.id}/`);
                                                                        handleClose();
                                                                    },
                                                                    children: "Action Logs"
                                                                }, "site-analytics")
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, row.id);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wcxl.default), {
                        rowsPerPageOptions: [
                            10,
                            25,
                            100
                        ],
                        component: "div",
                        count: localRenderedRows.length,
                        rowsPerPage: rowsPerPage,
                        page: Math.min(page, Math.max(0, Math.ceil(localRenderedRows.length / rowsPerPage) - 1)),
                        // sx={{display:"flex", justifyContent:"left"}}
                        onPageChange: (event, newPage)=>(0, $516d697317347b79$export$219817a61b68f7e1)(event, newPage, setPage),
                        onRowsPerPageChange: (event)=>(0, $d4a3124cb14e8591$export$8f225a03c4563930)(event, setRowsPerPage, setPage)
                    })
                ]
            })
        ]
    });
};


parcelRequire("8T3gX");
const $206673fda146bbe4$export$b8290481eb98cda4 = (renderedRows)=>{
    const updatedRenderedRows = [];
    renderedRows.forEach((row)=>{
        const newRow = row;
        let optimalSettingsNumber = 0;
        if (row.requirements_warning > 0 && row.requirements_bad < 1) optimalSettingsNumber = 1;
        else if (row.requirements_bad > 0) optimalSettingsNumber = 2;
        else optimalSettingsNumber = 0;
        newRow.optimal_settings_number = optimalSettingsNumber;
        updatedRenderedRows.push(newRow);
    });
    return updatedRenderedRows;
};


const $de29dda75a71799b$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $de29dda75a71799b$export$b73718dcdc23fe61 = ({ searchBarValue: searchBarValue, currentTitle: currentTitle, pageLoading: pageLoading, renderedRows: renderedRows, page: page, rowsPerPage: rowsPerPage, setPageLoading: setPageLoading, navigate: navigate, groupTrees: groupTrees, selectedIndex: selectedIndex, setPage: setPage, setCurrentTitle: setCurrentTitle, setSelectedIndex: setSelectedIndex, setRenderedRows: setRenderedRows, editedparentsGroupsList: editedparentsGroupsList, setRowsPerPage: setRowsPerPage, setSiteBreadcrumbs: setSiteBreadcrumbs, siteBreadcrumbs: siteBreadcrumbs, setAddGroupDialogOpen: setAddGroupDialogOpen, navBarCollapsed: navBarCollapsed, permissions: permissions, selected: selected, setSelected: setSelected, setSiteScreenAlerts: setSiteScreenAlerts, setSiteScreenLoading: setSiteScreenLoading, setSearchBarValue: setSearchBarValue, setEditedParentGroupList: setEditedParentGroupList, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, editableGroupSelected: editableGroupSelected, setEditableGroupSelected: setEditableGroupSelected, selectedGroupListName: selectedGroupListName, setSelectedGroupListName: setSelectedGroupListName, setGroupTrees: setGroupTrees, getIndividualGroup: getIndividualGroup })=>{
    const ref = $8T3gX.useRef(null);
    const { height: height } = (0, $crpct.default)();
    const handleSelectAllClick = (event)=>{
        if (event.target.checked) {
            const newSelecteds = renderedRows.map((obj)=>obj.id);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };
    const handleSingleCheckboxClick = (event, id)=>{
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];
        if (selectedIndex === -1) newSelected = newSelected.concat(selected, id);
        else if (selectedIndex === 0) newSelected = newSelected.concat(selected.slice(1));
        else if (selectedIndex === selected.length - 1) newSelected = newSelected.concat(selected.slice(0, -1));
        else if (selectedIndex > 0) newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        setSelected(newSelected);
    };
    const isSelected = (id)=>selected.indexOf(id) !== -1;
    const loadingDiv = /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 -translate-x-[-140px]",
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
            theme: $de29dda75a71799b$var$theme,
            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                    color: "primary"
                })
            })
        })
    });
    const siteGroupList = $8T3gX.useMemo(()=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $668c900d2e9ed468$export$f57e24d40c19b981), {
            groupTrees: groupTrees,
            selectedIndex: selectedIndex,
            setPage: setPage,
            setCurrentTitle: setCurrentTitle,
            setSelectedIndex: setSelectedIndex,
            setRenderedRows: setRenderedRows,
            setPageLoading: setPageLoading,
            navigate: navigate,
            setSiteBreadcrumbs: setSiteBreadcrumbs,
            setAddGroupDialogOpen: setAddGroupDialogOpen,
            permissions: permissions,
            navBarCollapsed: navBarCollapsed,
            setSelected: setSelected,
            searchBarValue: searchBarValue,
            editedparentsGroupsList: editedparentsGroupsList,
            setSearchBarValue: setSearchBarValue,
            setEditedParentGroupList: setEditedParentGroupList,
            setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
            setSelectedGroupListName: setSelectedGroupListName,
            setEditableGroupSelected: setEditableGroupSelected
        }), [
        selectedIndex,
        groupTrees,
        navBarCollapsed,
        searchBarValue,
        editedparentsGroupsList
    ]);
    const updatedRenderedRows = (0, $206673fda146bbe4$export$b8290481eb98cda4)(renderedRows);
    $8T3gX.useEffect(()=>{
        if (!groupTrees || !Array.isArray(groupTrees)) return;
        // Reset group list scroll to top whenever the page loads so the list always
        // starts at the top when visiting the Sites page
        if (ref?.current) ref.current.scrollTop = 0;
    }, [
        groupTrees
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                    ref: ref,
                    sx: navBarCollapsed ? {
                        position: "absolute",
                        left: 75,
                        top: 77,
                        height: height - 107,
                        width: "250px",
                        bgcolor: "background.paper"
                    } : {
                        position: "absolute",
                        left: 150,
                        top: 77,
                        height: height - 107,
                        width: "250px",
                        bgcolor: "background.paper"
                    },
                    children: siteGroupList
                })
            }),
            !pageLoading && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $06c7bcc94349a545$export$ec49a4b6162b54ba), {
                    navBarCollapsed: navBarCollapsed,
                    renderedRows: updatedRenderedRows,
                    page: page,
                    rowsPerPage: rowsPerPage,
                    setPageLoading: setPageLoading,
                    navigate: navigate,
                    setPage: setPage,
                    setRowsPerPage: setRowsPerPage,
                    handleSelectAllClick: handleSelectAllClick,
                    handleSingleCheckboxClick: handleSingleCheckboxClick,
                    isSelected: isSelected,
                    selected: selected,
                    setSelected: setSelected,
                    setSiteBreadcrumbs: setSiteBreadcrumbs,
                    setSiteScreenAlerts: setSiteScreenAlerts,
                    setRenderedRows: setRenderedRows,
                    setSiteScreenLoading: setSiteScreenLoading,
                    editableGroupSelected: editableGroupSelected,
                    selectedGroupListName: selectedGroupListName,
                    setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                    setSelectedGroupListName: setSelectedGroupListName,
                    groupTrees: groupTrees,
                    setGroupTrees: setGroupTrees,
                    siteBreadcrumbs: siteBreadcrumbs,
                    setSelectedIndex: setSelectedIndex,
                    getIndividualGroup: getIndividualGroup,
                    setEditableGroupSelected: setEditableGroupSelected
                })
            }),
            pageLoading ? loadingDiv : ""
        ]
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $cpJfj = parcelRequire("cpJfj");
const $c5de109ba17f2516$export$61d1096ad4c06c80 = ({ navigate: navigate })=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "absolute right-[7vw] top-[18px]",
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cpJfj.ActuateButton), {
            onClick: ()=>{
                localStorage.setItem("siteSchedule", "false");
                localStorage.setItem("clickedFromSiteAboutPage", "false");
                navigate("/sites/addsite");
                localStorage.setItem("addAnotherScheduleScreen", "false");
                localStorage.removeItem("addSiteError");
            },
            text: "Add Site",
            disabled: false
        })
    });
};



var $dHtmK = parcelRequire("dHtmK");

var $3QMQN = parcelRequire("3QMQN");


var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");

var $aYdit = parcelRequire("aYdit");
const $0c3f1c7cad817d93$export$c43e6fca79b86f29 = async (submitObject, navigate, setBackdropLoadingScreenOn, setGroupAddedAlert)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $0c3f1c7cad817d93$export$c43e6fca79b86f29(submitObject, navigate, setBackdropLoadingScreenOn, setGroupAddedAlert);
    };
    setBackdropLoadingScreenOn(true);
    await AxiosUI.post(`/group/`, submitObject).then(()=>{
        setGroupAddedAlert(true);
        AxiosUI.get(`group/?page_size=10000`).then((response)=>{
            localStorage.setItem("parentGroups", JSON.stringify(response.data.results));
            AxiosUI.get(`group/tree/?group_type=connector&page_size=1000`).then((response)=>{
                (0, $aYdit.useAppStore).getState().setGroupTrees(response.data.results);
                setBackdropLoadingScreenOn(false);
            }, (reason)=>{
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setBackdropLoadingScreenOn(false);
                });
            });
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                setBackdropLoadingScreenOn(false);
            });
        });
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setBackdropLoadingScreenOn(false);
            alert("Error submitting new group, please try again");
        });
    });
};


const $5cbf3eda628e9bd3$export$a5a8db9596bccfa = ({ addGroupDialogOpen: addGroupDialogOpen, setAddGroupDialogOpen: setAddGroupDialogOpen, setBackdropLoadingScreenOn: setBackdropLoadingScreenOn, setGroupAddedAlert: setGroupAddedAlert })=>{
    const navigate = (0, $3T949.useNavigate)();
    const [postObject, setPostObject] = $8T3gX.useState({
        name: "",
        parent: "",
        parent_account: true
    });
    const options = JSON.parse(localStorage.parentGroups);
    const optionsIds = new Map();
    const optionNames = new Map();
    options.forEach((option)=>{
        optionsIds.set(option.id, `${option.name} (group id: ${option.id})`);
    });
    options.forEach((option)=>{
        optionNames.set(`${option.name} (group id: ${option.id})`, option.id);
    });
    const handleGroupNameChange = (event)=>{
        setPostObject((previousState)=>{
            return {
                ...previousState,
                name: event.target.value
            };
        });
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: addGroupDialogOpen,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: "Add Group"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "group_name",
                        variant: "standard",
                        label: "Group Name",
                        onChange: handleGroupNameChange,
                        sx: {
                            width: "400px"
                        },
                        helperText: "What would you like to name this new group?",
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                        disablePortal: true,
                        id: "parent_group",
                        options: options.map((option)=>{
                            return `${option.name} (group id: ${option.id})`;
                        }),
                        onChange: (event, newInputValue)=>{
                            setPostObject((previousState)=>{
                                return {
                                    ...previousState,
                                    parent: optionNames.get(newInputValue)
                                };
                            });
                        },
                        sx: {
                            width: 400
                        },
                        renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                ...params,
                                variant: "standard",
                                label: "Parent Group",
                                helperText: "What parent group should this group be under?"
                            })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setAddGroupDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            (0, $0c3f1c7cad817d93$export$c43e6fca79b86f29)(postObject, navigate, setBackdropLoadingScreenOn, setGroupAddedAlert);
                            setAddGroupDialogOpen(false);
                        },
                        text: "Submit",
                        disabled: false
                    })
                ]
            })
        ]
    });
};



var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");

var $aYdit = parcelRequire("aYdit");
const $bde4263f39e1c275$export$82933cc467e1704e = (navigate, groupType)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        return $bde4263f39e1c275$export$82933cc467e1704e(navigate, groupType);
    };
    const setResults = (data)=>{
        const results = data?.results;
        const list = Array.isArray(results) ? results : [];
        if (groupType === "patrol") (0, $aYdit.useAppStore).getState().setGroupTreesPatrolOnly(list);
        else (0, $aYdit.useAppStore).getState().setGroupTrees(list);
        return list;
    };
    if (groupType === "patrol") return new Promise((resolve, reject)=>{
        AxiosUI.get(`group/tree/?group_type=patrol`).then((response)=>{
            const list = setResults(response.data);
            resolve(list);
        }).catch((reason)=>{
            setResults(null);
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
            reject(reason);
        });
    });
    return new Promise((resolve, reject)=>{
        AxiosUI.get(`group/tree/?group_type=connector&page_size=1000`).then((response)=>{
            const list = setResults(response.data);
            resolve(list);
        }).catch((reason)=>{
            setResults(null);
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
            reject(reason);
        });
    });
};



var $k4ank = parcelRequire("k4ank");

var $3QMQN = parcelRequire("3QMQN");
parcelRequire("8T3gX");
const $f13baa5d827a51d3$export$b48d3346334f9818 = ({ siteScreenAlerts: siteScreenAlerts, setSiteScreenAlerts: setSiteScreenAlerts })=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            siteScreenAlerts.armGroupSuccess && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                severity: "success",
                onClose: ()=>setSiteScreenAlerts({
                        ...siteScreenAlerts,
                        armGroupSuccess: false
                    }),
                children: "Group armed command sent successfully. It may take a few moments for armed status to update."
            }),
            siteScreenAlerts.disarmGroupSuccess && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                severity: "success",
                onClose: ()=>setSiteScreenAlerts({
                        ...siteScreenAlerts,
                        disarmGroupSuccess: false
                    }),
                children: "Group disarm command sent successfully. It may take a few moments for armed status to update."
            }),
            siteScreenAlerts.deployGroupSuccess && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                severity: "success",
                onClose: ()=>setSiteScreenAlerts({
                        ...siteScreenAlerts,
                        deployGroupSuccess: false
                    }),
                children: "Group sync command sent successfully."
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $1TOOV = parcelRequire("1TOOV");

var $ce8iU = parcelRequire("ce8iU");



var $iKAtE = parcelRequire("iKAtE");

var $433j1 = parcelRequire("433j1");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $658256b912e8ecf1$export$7468ea0c8171e483 = (inputValue, setSearchCameraResults, setSearchingCameras, setMoreToLoad, pageNumber, setPageNumber, setLoadingMore, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    AxiosUI.get(`camera/search/?search=${inputValue}&page=${pageNumber}`).then((response)=>{
        if (inputValue === localStorage.searchCameraInputValue) {
            setSearchCameraResults((prevResults)=>[
                    ...prevResults,
                    ...response.data.results
                ]);
            setLoadingMore(false);
            if (response.data.next) {
                setMoreToLoad(true);
                setPageNumber((prevPage)=>prevPage + 1);
            } else setMoreToLoad(false);
            setSearchingCameras(false);
        }
    }, (reason)=>{
        const retryFunction = ()=>{
            $658256b912e8ecf1$export$7468ea0c8171e483(inputValue, setSearchCameraResults, setSearchingCameras, setMoreToLoad, pageNumber, setPageNumber, setLoadingMore, navigate);
        };
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setSearchCameraResults([]);
            setSearchingCameras(false);
            setLoadingMore(false);
            setMoreToLoad(false);
            setPageNumber(1);
        });
    });
};



var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $cVCJe = parcelRequire("cVCJe");

var $8jTCz = parcelRequire("8jTCz");

var $60vL1 = parcelRequire("60vL1");
var $2ef2d4a2b40b785b$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($2ef2d4a2b40b785b$exports, "__esModule", {
    value: true
});
$2ef2d4a2b40b785b$exports.default = void 0;

var $2ef2d4a2b40b785b$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $2ef2d4a2b40b785b$var$_default = $2ef2d4a2b40b785b$exports.default = (0, $2ef2d4a2b40b785b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M5 16h3v3h2v-5H5zm3-8H5v2h5V5H8zm6 11h2v-3h3v-2h-5zm2-11V5h-2v5h5V8z"
}), 'FullscreenExit');


var $36ccc3b2bca62ab4$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($36ccc3b2bca62ab4$exports, "__esModule", {
    value: true
});
$36ccc3b2bca62ab4$exports.default = void 0;

var $36ccc3b2bca62ab4$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $36ccc3b2bca62ab4$var$_default = $36ccc3b2bca62ab4$exports.default = (0, $36ccc3b2bca62ab4$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M7 14H5v5h5v-2H7zm-2-4h2V7h3V5H5zm12 7h-3v2h5v-5h-2zM14 5v2h3v3h2V5z"
}), 'Fullscreen');



var $gfzcx = parcelRequire("gfzcx");

var $lWchQ = parcelRequire("lWchQ");

var $2aMB5 = parcelRequire("2aMB5");
const $2792f70ff2405e0a$export$60adf1bccf0df177 = ({ searchCamerasDialogOpen: searchCamerasDialogOpen, setSearchCamerasDialogOpen: setSearchCamerasDialogOpen, navigate: navigate })=>{
    const [inputValue, setInputValue] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [searchCameraResults, setSearchCameraResults] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [searchingCameras, setSearchingCameras] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [pageNumber, setPageNumber] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(1);
    const [moreToLoad, setMoreToLoad] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [loadingMore, setLoadingMore] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [fullScreenOn, setFullScreenOn] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (inputValue === "") {
            setSearchCameraResults([]);
            localStorage.setItem("searchCameraInputValue", "");
            return;
        } else {
            setSearchingCameras(true);
            setMoreToLoad(false);
            setPageNumber(1);
            const timer = setTimeout(()=>{
                (0, $658256b912e8ecf1$export$7468ea0c8171e483)(inputValue, setSearchCameraResults, setSearchingCameras, setMoreToLoad, 1, setPageNumber, setLoadingMore, navigate);
            }, 500);
            return ()=>clearTimeout(timer);
        }
    }, [
        inputValue
    ]);
    const handleChange = (event)=>{
        setSearchCameraResults([]);
        setInputValue(event.target.value);
        localStorage.setItem("searchCameraInputValue", event.target.value);
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: searchCamerasDialogOpen,
        fullWidth: true,
        maxWidth: "md",
        fullScreen: fullScreenOn,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                "aria-label": "close",
                onClick: ()=>setFullScreenOn(!fullScreenOn),
                sx: (theme)=>({
                        position: "absolute",
                        left: 8,
                        top: 8,
                        color: theme.palette.grey[500]
                    }),
                children: fullScreenOn ? /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2ef2d4a2b40b785b$exports))), {
                    fontSize: "large"
                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                    title: "Full Screen",
                    placement: "bottom-start",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($36ccc3b2bca62ab4$exports))), {
                        fontSize: "large"
                    })
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                sx: {
                    fontFamily: "mulish",
                    fontSize: "20px",
                    fontWeight: "bold",
                    paddingLeft: "70px"
                },
                children: "Search Cameras"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                "aria-label": "close",
                onClick: ()=>setSearchCamerasDialogOpen(false),
                sx: (theme)=>({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500]
                    }),
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $c9d4fba0d4c728e8$export$4b85d3515bd863a5), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $c9d4fba0d4c728e8$export$e9ad429a7452907b), {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0f42bd3abae37cbe$exports))), {})
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $c9d4fba0d4c728e8$export$b030dc24f7f252a3), {
                                    defaultValue: inputValue,
                                    placeholder: "Search Cameras...",
                                    onChange: handleChange,
                                    inputProps: {
                                        "aria-label": "search"
                                    }
                                })
                            ]
                        }),
                        searchCameraResults.length > 0 && !searchingCameras && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                            component: (0, $4reBM.default),
                            sx: fullScreenOn ? {
                                maxHeight: "calc(100vh - 200px)",
                                minWidth: "1500px",
                                width: "100%",
                                overflow: "auto"
                            } : {
                                maxHeight: 400,
                                minWidth: "1500px",
                                width: 850,
                                overflow: "auto"
                            },
                            className: "mt-[20px]",
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                stickyHeader: true,
                                "aria-label": "sticky table",
                                sx: {
                                    tableLayout: "fixed"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponentSmallerText), {
                                        titlesArray: [
                                            "Camera Name",
                                            "Site Name",
                                            "Active",
                                            "Host",
                                            "RTSP",
                                            "HTTP",
                                            "Server Port",
                                            "Immix/Sureview Email",
                                            ""
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $gXvgZ.default), {
                                        children: [
                                            searchCameraResults.map((camera)=>camera.camera_name ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            component: "th",
                                                            scope: "row",
                                                            sx: {
                                                                fontSize: 12,
                                                                maxWidth: "150px",
                                                                overflow: "hidden",
                                                                wordWrap: "break-word",
                                                                wordBreak: "break-word"
                                                            },
                                                            children: camera.camera_name
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            component: "th",
                                                            scope: "row",
                                                            sx: {
                                                                fontSize: 12,
                                                                maxWidth: "150px",
                                                                overflow: "hidden",
                                                                wordWrap: "break-word",
                                                                wordBreak: "break-word"
                                                            },
                                                            children: camera.site.name
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            component: "th",
                                                            scope: "row",
                                                            sx: {
                                                                fontSize: 12,
                                                                width: "60px",
                                                                textAlign: "center"
                                                            },
                                                            children: camera.active ? (0, $lWchQ.checkedCircleIconSmall) : (0, $2aMB5.cancelIconRedSmall)
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            component: "th",
                                                            scope: "row",
                                                            sx: {
                                                                fontSize: 12,
                                                                maxWidth: "180px",
                                                                overflow: "hidden",
                                                                wordWrap: "break-word",
                                                                wordBreak: "break-word"
                                                            },
                                                            children: camera.ip ? camera.ip : "--"
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            component: "th",
                                                            scope: "row",
                                                            sx: {
                                                                fontSize: 12,
                                                                width: "80px",
                                                                overflow: "hidden",
                                                                wordWrap: "break-word",
                                                                wordBreak: "break-word"
                                                            },
                                                            children: camera.rtsp ? camera.rtsp : "--"
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            component: "th",
                                                            scope: "row",
                                                            sx: {
                                                                fontSize: 12,
                                                                width: "80px",
                                                                overflow: "hidden",
                                                                wordWrap: "break-word",
                                                                wordBreak: "break-word"
                                                            },
                                                            children: camera.http ? camera.http : "--"
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            component: "th",
                                                            scope: "row",
                                                            sx: {
                                                                fontSize: 12,
                                                                width: "100px",
                                                                overflow: "hidden",
                                                                wordWrap: "break-word",
                                                                wordBreak: "break-word"
                                                            },
                                                            children: camera.server_port ? camera.server_port : "--"
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            component: "th",
                                                            scope: "row",
                                                            sx: {
                                                                fontSize: 12,
                                                                maxWidth: "200px",
                                                                overflow: "hidden",
                                                                wordWrap: "break-word",
                                                                wordBreak: "break-word"
                                                            },
                                                            children: camera.alert_emails ? camera.alert_emails : "--"
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            sx: {
                                                                fontSize: 12,
                                                                width: "120px",
                                                                textAlign: "center"
                                                            },
                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                                onClick: ()=>{
                                                                    navigate(`/sites/${camera.site.id}/editcamera/${camera.id}`);
                                                                    setSearchCamerasDialogOpen(false);
                                                                },
                                                                text: "See Camera",
                                                                disabled: false
                                                            })
                                                        })
                                                    ]
                                                }, camera.id) : null),
                                            moreToLoad ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    colSpan: 3,
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "flex justify-center",
                                                        children: loadingMore ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                                            color: "primary"
                                                        }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                            onClick: ()=>{
                                                                setLoadingMore(true);
                                                                (0, $658256b912e8ecf1$export$7468ea0c8171e483)(inputValue, setSearchCameraResults, setSearchingCameras, setMoreToLoad, pageNumber, setPageNumber, setLoadingMore, navigate);
                                                            },
                                                            text: "Load More",
                                                            disabled: false
                                                        })
                                                    })
                                                })
                                            }) : null
                                        ]
                                    })
                                ]
                            })
                        }),
                        searchingCameras && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "flex flex-col justify-center items-center",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                    color: "primary"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    style: {
                                        marginTop: "10px",
                                        font: "16px",
                                        fontFamily: "mulish"
                                    },
                                    children: "Searching Cameras..."
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};



var $8jTCz = parcelRequire("8jTCz");


var $aYdit = parcelRequire("aYdit");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $1TOOV = parcelRequire("1TOOV");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $jVN1H = parcelRequire("jVN1H");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $827f18cdab69c4b1$export$e8722922009db361 = (setCalendarData, setFetchingCalendarData, querryString, setPage, setShowMoreDialogOpen, setSelectedRow, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $827f18cdab69c4b1$export$e8722922009db361(setCalendarData, setFetchingCalendarData, querryString, setPage, setShowMoreDialogOpen, setSelectedRow, navigate);
    };
    let fullQuerryString = "";
    if (querryString !== "") fullQuerryString = `?search=${querryString}`;
    AxiosUI.get(`calendar/${fullQuerryString}`).then((response)=>{
        const results = response.data.results;
        // const updatedResults: any[] = [];
        setCalendarData(results);
        if (results[0]) setSelectedRow(results[0]);
        setFetchingCalendarData(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setFetchingCalendarData(false);
        });
    });
};


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");


const $c716f24a56dca3fc$export$2186db845d83391c = ({ setCalendarsSearchString: setCalendarsSearchString })=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $c9d4fba0d4c728e8$export$4b85d3515bd863a5), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $c9d4fba0d4c728e8$export$e9ad429a7452907b), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0f42bd3abae37cbe$exports))), {})
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $c9d4fba0d4c728e8$export$b030dc24f7f252a3), {
                // placeholder="Search Calendar Names"
                onChange: (event)=>setCalendarsSearchString(event.target.value),
                inputProps: {
                    "aria-label": "search"
                }
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $cpJfj = parcelRequire("cpJfj");

const $dcf3175213d3d23d$export$e61a7e8e2c301e8e = ({ setFetchingCalendarData: setFetchingCalendarData, setCalendarData: setCalendarData, calendarsSearchString: calendarsSearchString, setPage: setPage, setShowMoreDialogOpen: setShowMoreDialogOpen, setSelectedRow: setSelectedRow, navigate: navigate })=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cpJfj.ActuateButton), {
            onClick: ()=>{
                setFetchingCalendarData(true);
                setPage(0);
                (0, $827f18cdab69c4b1$export$e8722922009db361)(setCalendarData, setFetchingCalendarData, calendarsSearchString, setPage, setShowMoreDialogOpen, setSelectedRow, navigate);
            },
            text: "Search",
            disabled: false
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $1wcxl = parcelRequire("1wcxl");

var $4reBM = parcelRequire("4reBM");

var $fWsn7 = parcelRequire("fWsn7");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $aVDw9 = parcelRequire("aVDw9");
var $ha39s = parcelRequire("ha39s");
var $4o6Cs = parcelRequire("4o6Cs");
const $d2448ae5f3bc4063$var$headCells = [
    {
        id: "name",
        numeric: false,
        label: "Name"
    },
    {
        id: "group",
        numeric: false,
        label: "Group"
    }
];
const $d2448ae5f3bc4063$var$EnhancedCalendarsTableHead = (props)=>{
    const { onSelectAllClick: onSelectAllClick, onRequestSort: onRequestSort, orderBy: orderBy, order: order } = props;
    const createSortHandler = (property)=>(event)=>{
            onRequestSort(event, property);
        };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
            children: [
                $d2448ae5f3bc4063$var$headCells.map((headCell)=>{
                    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                        sx: {
                            fontSize: "15px",
                            fontFamily: "mulish",
                            fontWeight: "Bold",
                            maxWidth: 250
                        },
                        style: {
                            minWidth: 200
                        },
                        align: "left",
                        sortDirection: orderBy === headCell.id ? order : false,
                        children: headCell.label
                    }, headCell.id);
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    align: "left",
                    sx: {
                        fontFamily: "Mulish",
                        fontWeight: "Bold",
                        fontSize: "15px",
                        minWidth: 200
                    },
                    children: "Assigned to Sites"
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    align: "center",
                    sx: {
                        fontFamily: "Mulish",
                        fontWeight: "Bold",
                        fontSize: "15px",
                        minWidth: 200
                    },
                    children: "More Info"
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    align: "center"
                })
            ]
        })
    });
};
var $d2448ae5f3bc4063$export$2e2bcd8739ae039 = $d2448ae5f3bc4063$var$EnhancedCalendarsTableHead;



var $iKAtE = parcelRequire("iKAtE");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");
parcelRequire("8T3gX");

var $a7uO0 = parcelRequire("a7uO0");

var $k4ank = parcelRequire("k4ank");
const $4edf75b704cab85d$export$6de472a3df735882 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
}), 'ArrowUpward');
const $4edf75b704cab85d$export$1f2d4db4a79871d4 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');
const $4edf75b704cab85d$export$8da6370d9999894a = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'KeyboardArrowRight');
const $4edf75b704cab85d$export$5b6f85a3ddabf4ca = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');
const $4edf75b704cab85d$export$cb1a577169e125de = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
}), 'FilterList');
const $4edf75b704cab85d$export$4f4f59585ffe8deb = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61z"
}), 'FilterAlt');
const $4edf75b704cab85d$export$d33e6ad54b379a5d = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), 'Search');
const $4edf75b704cab85d$export$3c3b03774b2ed8ce = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), 'Menu');
const $4edf75b704cab85d$export$7a7700ab3e9c7e95 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckCircle');
const $4edf75b704cab85d$export$10a5a2f68ff67c50 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"
}), 'ColumnIcon');
const $4edf75b704cab85d$export$e918bd395b324de6 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M11 19V5h2v14z"
}), 'Separator');
const $4edf75b704cab85d$export$3bcf566f7053b242 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
}), 'ViewHeadline');
const $4edf75b704cab85d$export$adcade5d1a52a335 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M21,8H3V4h18V8z M21,10H3v4h18V10z M21,16H3v4h18V16z"
}), 'TableRows');
const $4edf75b704cab85d$export$60a4c153d2d7b084 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M4 18h17v-6H4v6zM4 5v6h17V5H4z"
}), 'ViewStream');
const $4edf75b704cab85d$export$2fbf0de7557957a8 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'TripleDotsVertical');
const $4edf75b704cab85d$export$cbefef3cfb8e2783 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');
const $4edf75b704cab85d$export$e483c1441c7fca0b = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), 'Add');
const $4edf75b704cab85d$export$d8fa92cc66e4dec8 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M19 13H5v-2h14v2z"
}), 'Remove');
const $4edf75b704cab85d$export$52992a9d5fa53c3c = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
}), 'Load');
const $4edf75b704cab85d$export$305773dd821bb81d = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'Drag');
const $4edf75b704cab85d$export$78df866ac12db1bd = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"
}), 'SaveAlt');
const $4edf75b704cab85d$export$1f9ec58b2f66f46d = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');
const $4edf75b704cab85d$export$6eaba7fcfbaac527 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreVert');



var $8jTCz = parcelRequire("8jTCz");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $61840df64dd1d37b$export$204a2f369a393ad4 = (setCalendarEvents, setLoadingEventData, selectedRow, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $61840df64dd1d37b$export$204a2f369a393ad4(setCalendarEvents, setLoadingEventData, selectedRow, navigate);
    };
    AxiosUI.get(`calendar_event/?calendar__id=${selectedRow.id}`).then((response)=>{
        setCalendarEvents(response.data.results);
        setLoadingEventData(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setLoadingEventData(false);
        });
    });
};



var $crpct = parcelRequire("crpct");

var $2aMB5 = parcelRequire("2aMB5");

var $lWchQ = parcelRequire("lWchQ");
const $1bf2d29e1314bdca$export$14339a52e0dcfa6d = ({ calendarData: calendarData, page: page, setPage: setPage, rowsPerPage: rowsPerPage, setRowsPerPage: setRowsPerPage, handleSelectAllClick: handleSelectAllClick, isSelected: isSelected, handleSingleCheckboxClick: handleSingleCheckboxClick, setSelectedRow: setSelectedRow, setShowMoreDialogOpen: setShowMoreDialogOpen, setLoadingEventData: setLoadingEventData, setCalendarEvents: setCalendarEvents, setCalendarId: setCalendarId, setDeleteCalendarDialogOpen: setDeleteCalendarDialogOpen, setDeletedCalendarId: setDeletedCalendarId, setRowIndex: setRowIndex, setAssignedSitesDialogOpen: setAssignedSitesDialogOpen, navigate: navigate })=>{
    const [order, setOrder] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("asc");
    const [orderBy, setOrderBy] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("formatted_date");
    const [anchorEl, setAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const ITEM_HEIGHT = 48;
    const handleRequestSort = (event, property)=>{
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };
    const handleChangePage = (event, newPage)=>{
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event)=>{
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const visibleRows = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>(0, $fWsn7.stableSort)(calendarData, (0, $fWsn7.getComparator)(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        order,
        orderBy,
        page,
        rowsPerPage
    ]);
    const { height: height, width: width } = (0, $crpct.default)();
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setCalculatedHeight(height - 205);
        setCalculatedWidth(width - 150);
    }, [
        height,
        width
    ]);
    const [calcuatedHeight, setCalculatedHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [calcuatedWidth, setCalculatedWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4reBM.default), {
        sx: {
            width: "100%",
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                sx: {
                    maxHeight: calcuatedHeight,
                    minWidth: calcuatedWidth
                },
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                    sx: {
                        fontFamily: "Mulish"
                    },
                    "aria-label": "calendars_table",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $d2448ae5f3bc4063$export$2e2bcd8739ae039), {
                            onSelectAllClick: handleSelectAllClick,
                            onRequestSort: handleRequestSort,
                            orderBy: orderBy,
                            order: order
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                            children: calendarData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((obj, index)=>{
                                const isItemSelected = isSelected(obj.id);
                                return /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                        role: "checkbox",
                                        "aria-checked": isItemSelected,
                                        tabIndex: -1,
                                        selected: isItemSelected,
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                align: "left",
                                                children: obj.name
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                align: "left",
                                                children: obj.group.name
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                align: "left",
                                                children: obj.customer[0] ? (0, $lWchQ.checkedCircleIcon) : (0, $2aMB5.cancelIconRed)
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                align: "center",
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                    text: "SHOW MORE",
                                                    onClick: ()=>{
                                                        setRowIndex(index);
                                                        setLoadingEventData(true);
                                                        setSelectedRow(obj);
                                                        setCalendarId(obj.id);
                                                        (0, $61840df64dd1d37b$export$204a2f369a393ad4)(setCalendarEvents, setLoadingEventData, obj, navigate);
                                                        setShowMoreDialogOpen(true);
                                                    },
                                                    disabled: false
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                                align: "center",
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                                        "aria-label": "more",
                                                        id: "long-button",
                                                        "aria-controls": open ? "long-menu" : undefined,
                                                        "aria-expanded": open ? "true" : undefined,
                                                        "aria-haspopup": "true",
                                                        onClick: (event)=>{
                                                            handleClick(event);
                                                            setDeletedCalendarId(obj.id);
                                                            setSelectedRow(obj);
                                                        },
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4edf75b704cab85d$export$6eaba7fcfbaac527), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                                                        id: "long-menu",
                                                        MenuListProps: {
                                                            "aria-labelledby": "long-button"
                                                        },
                                                        anchorOrigin: {
                                                            vertical: "top",
                                                            horizontal: "left"
                                                        },
                                                        transformOrigin: {
                                                            vertical: "top",
                                                            horizontal: "left"
                                                        },
                                                        anchorEl: anchorEl,
                                                        open: open,
                                                        onClose: handleClose,
                                                        PaperProps: {
                                                            style: {
                                                                maxHeight: ITEM_HEIGHT * 4.5,
                                                                width: "20ch"
                                                            }
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                                onClick: ()=>{
                                                                    handleClose();
                                                                    setAssignedSitesDialogOpen(true);
                                                                },
                                                                children: "Assigned Sites"
                                                            }, "apply-to-schedules"),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                                onClick: ()=>{
                                                                    setDeleteCalendarDialogOpen(true);
                                                                },
                                                                children: "Delete"
                                                            }, "delete")
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, obj.id);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wcxl.default), {
                rowsPerPageOptions: [
                    5,
                    10,
                    25
                ],
                component: "div",
                count: calendarData.length,
                rowsPerPage: rowsPerPage,
                page: page,
                onPageChange: handleChangePage,
                onRowsPerPageChange: handleChangeRowsPerPage
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $b9p11 = parcelRequire("b9p11");

var $faP87 = parcelRequire("faP87");

var $a65wX = parcelRequire("a65wX");
const $b32604d1b8d94d0b$export$60a6671944a0e6f0 = ({ setAddCalendarScreenOpen: setAddCalendarScreenOpen })=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
        theme: (0, $faP87.theme),
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
            type: "button",
            color: "primary",
            onClick: ()=>{
                setAddCalendarScreenOpen(true);
            },
            children: "+ Add Calendar"
        })
    });
};



var $dHtmK = parcelRequire("dHtmK");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $iKAtE = parcelRequire("iKAtE");

var $433j1 = parcelRequire("433j1");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $887xF = parcelRequire("887xF");
var $kRZvb = parcelRequire("kRZvb");
var $cVCJe = parcelRequire("cVCJe");
var $f3puC = parcelRequire("f3puC");

var $8jTCz = parcelRequire("8jTCz");

var $ka01y = parcelRequire("ka01y");
var $983e97e2604996b4$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($983e97e2604996b4$exports, "__esModule", {
    value: true
});
$983e97e2604996b4$exports.default = void 0;

var $983e97e2604996b4$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $983e97e2604996b4$var$_default = $983e97e2604996b4$exports.default = (0, $983e97e2604996b4$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), 'ModeEdit');


parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $ac54c2593114132c$export$487c2bc7442c930e = (eventId, setCalendarEvents, setEditingCalendar, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $ac54c2593114132c$export$487c2bc7442c930e(eventId, setCalendarEvents, setEditingCalendar, navigate);
    };
    AxiosUI.delete(`calendar_event/${eventId}/`).then((response)=>{
        AxiosUI.get(`calendar_event/?calendar__id=${response.data.calendar}`).then((response)=>{
            setCalendarEvents(response.data.results);
            setEditingCalendar(false);
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                setEditingCalendar(false);
            });
        });
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setEditingCalendar(false);
        });
    });
};


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $dHtmK = parcelRequire("dHtmK");
const $ccd18487931e09c7$export$d871accbd9c9720a = 96;
const $ccd18487931e09c7$var$MINUTES_PER_SLOT = 15;
const $ccd18487931e09c7$var$MINUTES_PER_DAY = 1440;
const $ccd18487931e09c7$var$clampMinutes = (minutes)=>Math.max(0, Math.min($ccd18487931e09c7$var$MINUTES_PER_DAY, minutes));
const $ccd18487931e09c7$export$17f94c0d03a6a65a = ()=>Array.from({
        length: $ccd18487931e09c7$export$d871accbd9c9720a
    }, ()=>false);
const $ccd18487931e09c7$var$getRanges = (selected)=>{
    if (selected.length !== $ccd18487931e09c7$export$d871accbd9c9720a) throw new Error("Selection must contain exactly 96 values.");
    const ranges = [];
    let startIndex = null;
    for(let i = 0; i < selected.length; i++){
        if (selected[i] && startIndex === null) startIndex = i;
        else if (!selected[i] && startIndex !== null) {
            ranges.push([
                startIndex,
                i
            ]);
            startIndex = null;
        }
    }
    if (startIndex !== null) ranges.push([
        startIndex,
        selected.length
    ]);
    return ranges;
};
const $ccd18487931e09c7$export$1bc11f3b004c66a7 = (selected)=>{
    const ranges = $ccd18487931e09c7$var$getRanges(selected);
    return ranges.length > 2 || ranges.length === 2 && (ranges[0][0] !== 0 || ranges[1][1] !== $ccd18487931e09c7$export$d871accbd9c9720a);
};
const $ccd18487931e09c7$export$4583ef486354f23e = (selected)=>{
    const ranges = $ccd18487931e09c7$var$getRanges(selected);
    if (!ranges.length) return null;
    if (ranges.length === 1) return {
        startMinutes: ranges[0][0] * $ccd18487931e09c7$var$MINUTES_PER_SLOT,
        endMinutes: ranges[0][1] * $ccd18487931e09c7$var$MINUTES_PER_SLOT
    };
    if (ranges.length === 2 && ranges[0][0] === 0 && ranges[1][1] === $ccd18487931e09c7$export$d871accbd9c9720a) return {
        startMinutes: ranges[1][0] * $ccd18487931e09c7$var$MINUTES_PER_SLOT,
        endMinutes: ranges[0][1] * $ccd18487931e09c7$var$MINUTES_PER_SLOT
    };
    return null;
};
const $ccd18487931e09c7$export$5a7b4a6a639b7af9 = (minutes, mode)=>{
    const clamped = $ccd18487931e09c7$var$clampMinutes(minutes);
    const slotValue = clamped / $ccd18487931e09c7$var$MINUTES_PER_SLOT;
    const rounded = mode === "floor" ? Math.floor(slotValue) : Math.ceil(slotValue);
    return $ccd18487931e09c7$var$clampMinutes(rounded * $ccd18487931e09c7$var$MINUTES_PER_SLOT);
};
const $ccd18487931e09c7$export$d3ad747999865bd9 = (value)=>value.getHours() * 60 + value.getMinutes();
const $ccd18487931e09c7$export$62f659bbe94e4df7 = (baseDate, minutes)=>{
    const date = new Date(baseDate);
    const dayOffset = Math.floor(minutes / $ccd18487931e09c7$var$MINUTES_PER_DAY);
    const minuteOffset = minutes % $ccd18487931e09c7$var$MINUTES_PER_DAY;
    date.setDate(date.getDate() + dayOffset);
    date.setHours(Math.floor(minuteOffset / 60), minuteOffset % 60, 0, 0);
    return date;
};
const $ccd18487931e09c7$export$8491938b27b4bdbc = (time)=>{
    const [hours = 0, minutes = 0] = time.split(":").map(Number);
    return hours * 60 + minutes;
};
const $ccd18487931e09c7$export$3d1ef2819c14a5ae = (startTime, endTime)=>{
    if (!startTime || !endTime) return true;
    return startTime === "00:00:00" && endTime === "23:59:59";
};
const $ccd18487931e09c7$export$2dac4520d1ba284 = (startTime, endTime)=>{
    if ($ccd18487931e09c7$export$3d1ef2819c14a5ae(startTime, endTime)) return {
        start_time: "00:00:00",
        end_time: "23:59:59"
    };
    return {
        start_time: startTime ?? null,
        end_time: endTime ?? null
    };
};
const $ccd18487931e09c7$export$2a212a58125b39b3 = (dateString)=>{
    const parts = dateString.split("-");
    return new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
};
const $ccd18487931e09c7$export$f845d6b95e482b29 = (date)=>{
    const pad = (value)=>String(value).padStart(2, "0");
    return `${pad(date.getHours())}:${pad(date.getMinutes())}:00`;
};
const $ccd18487931e09c7$var$formatCalendarEventTimeForDisplay = (time)=>{
    const [hours = "00", minutes = "00"] = time.split(":");
    return `${hours}:${minutes}`;
};
const $ccd18487931e09c7$export$9513d8c54f3bb9fa = (startTime, endTime)=>{
    if ($ccd18487931e09c7$export$3d1ef2819c14a5ae(startTime, endTime)) return "Always On";
    return `${$ccd18487931e09c7$var$formatCalendarEventTimeForDisplay(startTime)}-${$ccd18487931e09c7$var$formatCalendarEventTimeForDisplay(endTime)}`;
};
const $ccd18487931e09c7$export$59eebec189dfc007 = (detectionsAlwaysOn, startTime, endTime)=>{
    if (detectionsAlwaysOn) return {
        start_time: "00:00:00",
        end_time: "23:59:59"
    };
    if (!startTime || !endTime) return {
        start_time: null,
        end_time: null
    };
    return {
        start_time: $ccd18487931e09c7$export$f845d6b95e482b29(startTime),
        end_time: $ccd18487931e09c7$export$f845d6b95e482b29(endTime)
    };
};
const $ccd18487931e09c7$export$347bac2607247493 = (startMinutes, endMinutes)=>{
    const normalizedStart = $ccd18487931e09c7$export$5a7b4a6a639b7af9(startMinutes, "floor");
    const normalizedEnd = $ccd18487931e09c7$export$5a7b4a6a639b7af9(endMinutes, "ceil");
    const selected = $ccd18487931e09c7$export$17f94c0d03a6a65a();
    const startSlot = normalizedStart / $ccd18487931e09c7$var$MINUTES_PER_SLOT;
    const endSlot = normalizedEnd / $ccd18487931e09c7$var$MINUTES_PER_SLOT;
    if (startSlot === endSlot) return selected;
    if (startSlot < endSlot) {
        for(let i = startSlot; i < endSlot; i++)selected[i] = true;
        return selected;
    }
    for(let i = startSlot; i < $ccd18487931e09c7$export$d871accbd9c9720a; i++)selected[i] = true;
    for(let i = 0; i < endSlot; i++)selected[i] = true;
    return selected;
};


const $1a36966a2d753e0d$var$monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
const $1a36966a2d753e0d$var$getMouthName = (monthNumber)=>{
    return $1a36966a2d753e0d$var$monthNames[monthNumber - 1];
};
const $1a36966a2d753e0d$var$formatDate = (date)=>{
    if (date === "--") return "--";
    const parts = date.split("-");
    return `${$1a36966a2d753e0d$var$getMouthName(parts[1])} ${parts[2]}, ${parts[0]}`;
};
const $1a36966a2d753e0d$export$227798582466ec7b = ({ setShowMoreDialogOpen: setShowMoreDialogOpen, selectedRow: selectedRow, calendarEvents: calendarEvents, setCalendarEvents: setCalendarEvents, setAddDateDialogOpen: setAddDateDialogOpen, editingCalendar: editingCalendar, loadingEventData: loadingEventData, setEditingCalendar: setEditingCalendar, setPatchEvent: setPatchEvent, setEditEventDialogOpen: setEditEventDialogOpen, setEditCalendarDialogOpen: setEditCalendarDialogOpen })=>{
    const navigate = (0, $3T949.useNavigate)();
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "absolute align-middle",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                openState: editingCalendar || loadingEventData
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4reBM.default), {
                sx: {
                    width: 750,
                    overflow: "hidden"
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kRZvb.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                sx: {
                                    flex: "1 1 100%"
                                },
                                variant: "h6",
                                id: "tableTitle",
                                component: "div",
                                children: [
                                    selectedRow.name,
                                    " | ",
                                    selectedRow.group.name,
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                        onClick: ()=>{
                                            setEditCalendarDialogOpen(true);
                                        },
                                        text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($983e97e2604996b4$exports))), {}),
                                        disabled: false
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                title: "Close Screen",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                    "aria-label": "close",
                                    onClick: ()=>{
                                        setShowMoreDialogOpen(false);
                                        setCalendarEvents([]);
                                    },
                                    sx: {
                                        position: "absolute",
                                        right: 8,
                                        top: 8,
                                        color: (theme)=>theme.palette.grey[500]
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                        sx: {
                            maxHeight: 440
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                            sx: {
                                fontFamily: "Mulish",
                                width: "100%",
                                overflow: "scroll"
                            },
                            "aria-label": "simple table",
                            stickyHeader: true,
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                    titlesArray: [
                                        "Event Date",
                                        "Event Name",
                                        "Start Time/End Time",
                                        ""
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                    children: calendarEvents.map((object)=>{
                                        return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    sx: {
                                                        fontFamily: "Mulish"
                                                    },
                                                    children: $1a36966a2d753e0d$var$formatDate(object.event_date)
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    sx: {
                                                        fontFamily: "Mulish"
                                                    },
                                                    children: object.name
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    sx: {
                                                        fontFamily: "Mulish"
                                                    },
                                                    children: (0, $ccd18487931e09c7$export$9513d8c54f3bb9fa)(object.start_time, object.end_time)
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                                    align: "right",
                                                    sx: {
                                                        fontFamily: "Mulish"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                            onClick: ()=>{
                                                                setPatchEvent(object);
                                                                setEditEventDialogOpen(true);
                                                            },
                                                            text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($983e97e2604996b4$exports))), {}),
                                                            disabled: false
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                            onClick: ()=>{
                                                                setEditingCalendar(true);
                                                                (0, $ac54c2593114132c$export$487c2bc7442c930e)(object.id, setCalendarEvents, setEditingCalendar, navigate);
                                                            },
                                                            text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ka01y))), {}),
                                                            disabled: false
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, object.name);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    setAddDateDialogOpen(true);
                                },
                                text: "+ Add Date",
                                disabled: false
                            })
                        })
                    })
                ]
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $7be2031d29a706f9$export$d22b7535015240ea = (newDate, setCalendarEvents, setEditingCalendar, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $7be2031d29a706f9$export$d22b7535015240ea(newDate, setCalendarEvents, setEditingCalendar, navigate);
    };
    AxiosUI.post(`calendar_event/`, {
        ...newDate,
        start_time: newDate.start_time ?? "00:00:00",
        end_time: newDate.end_time ?? "23:59:59"
    }).then((response)=>{
        AxiosUI.get(`calendar_event/?calendar__id=${response.data.calendar}`).then((response)=>{
            setCalendarEvents(response.data.results);
            setEditingCalendar(false);
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                setEditingCalendar(false);
            });
        });
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Error adding date, please try again");
            setEditingCalendar(false);
        });
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kbChx = parcelRequire("kbChx");
var $kUcVg = parcelRequire("kUcVg");
var $887xF = parcelRequire("887xF");
var $1TOOV = parcelRequire("1TOOV");
var $ce8iU = parcelRequire("ce8iU");
var $3baw3 = parcelRequire("3baw3");
var $k8Qy8 = parcelRequire("k8Qy8");
var $gXvgZ = parcelRequire("gXvgZ");
var $aVDw9 = parcelRequire("aVDw9");
var $ha39s = parcelRequire("ha39s");
var $4o6Cs = parcelRequire("4o6Cs");
var $eejVe = parcelRequire("eejVe");

var $hwWkD = parcelRequire("hwWkD");

var $hfM8m = parcelRequire("hfM8m");

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $4wdE9 = parcelRequire("4wdE9");

var $hHKnQ = parcelRequire("hHKnQ");

var $fdGrT = parcelRequire("fdGrT");

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $eJfrs = parcelRequire("eJfrs");

var $4wdE9 = parcelRequire("4wdE9");

var $1hdeG = parcelRequire("1hdeG");

var $4EsxQ = parcelRequire("4EsxQ");
const $b0826bd3c84e4838$export$eb577c89cfdd574a = (views)=>views.length === 1 && views[0] === 'year';
const $b0826bd3c84e4838$export$2d2db6dbaaf33a55 = (views)=>views.length === 2 && views.indexOf('month') !== -1 && views.indexOf('year') !== -1;
const $b0826bd3c84e4838$var$getFormatAndMaskByViews = (views, utils)=>{
    if ($b0826bd3c84e4838$export$eb577c89cfdd574a(views)) return {
        inputFormat: utils.formats.year
    };
    if ($b0826bd3c84e4838$export$2d2db6dbaaf33a55(views)) return {
        disableMaskedInput: true,
        inputFormat: utils.formats.monthAndYear
    };
    return {
        inputFormat: utils.formats.keyboardDate
    };
};
function $b0826bd3c84e4838$export$a552c17ed3587731(props, name) {
    var _themeProps$views;
    const utils = (0, $1hdeG.useUtils)();
    const defaultDates = (0, $1hdeG.useDefaultDates)(); // This is technically unsound if the type parameters appear in optional props.
    // Optional props can be filled by `useThemeProps` with types that don't match the type parameters.
    const themeProps = (0, $4wdE9.default)({
        props: props,
        name: name
    });
    const views = (_themeProps$views = themeProps.views) != null ? _themeProps$views : [
        'year',
        'day'
    ];
    return (0, $eJfrs.default)({
        openTo: 'day',
        disableFuture: false,
        disablePast: false
    }, $b0826bd3c84e4838$var$getFormatAndMaskByViews(views, utils), themeProps, {
        views: views,
        minDate: (0, $4EsxQ.parseNonNullablePickerDate)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $4EsxQ.parseNonNullablePickerDate)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $b0826bd3c84e4838$export$31874dacbbc1e607 = {
    emptyValue: null,
    getTodayValue: (utils)=>utils.date(),
    parseInput: (0, $4EsxQ.parsePickerInputValue),
    areValuesEqual: (utils, a, b)=>utils.isEqual(a, b)
};



var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $f3puC = parcelRequire("f3puC");

var $anJSP = parcelRequire("anJSP");
var $4wdE9 = parcelRequire("4wdE9");

var $aYNpO = parcelRequire("aYNpO");

var $9o0Hh = parcelRequire("9o0Hh");

var $1hdeG = parcelRequire("1hdeG");


var $kfTYv = parcelRequire("kfTYv");
var $jh2Zm = parcelRequire("jh2Zm");
function $06ab6017781fcd58$export$a1c3879af2c3b694(slot) {
    return (0, $kfTYv.default)('MuiDatePickerToolbar', slot);
}
const $06ab6017781fcd58$export$2e35fa7d24ef4179 = (0, $jh2Zm.default)('MuiDatePickerToolbar', [
    'root',
    'title'
]);



var $k4ank = parcelRequire("k4ank");
const $11da5e4c5508a072$var$_excluded = [
    "parsedValue",
    "isLandscape",
    "isMobileKeyboardViewOpen",
    "onChange",
    "toggleMobileKeyboardView",
    "toolbarFormat",
    "toolbarPlaceholder",
    "toolbarTitle",
    "views"
];
const $11da5e4c5508a072$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        title: [
            'title'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $06ab6017781fcd58$export$a1c3879af2c3b694), classes);
};
const $11da5e4c5508a072$var$DatePickerToolbarRoot = (0, $anJSP.default)((0, $9o0Hh.PickersToolbar), {
    name: 'MuiDatePickerToolbar',
    slot: 'Root',
    overridesResolver: (_, styles)=>styles.root
})({});
const $11da5e4c5508a072$var$DatePickerToolbarTitle = (0, $anJSP.default)((0, $f3puC.default), {
    name: 'MuiDatePickerToolbar',
    slot: 'Title',
    overridesResolver: (_, styles)=>styles.title
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({}, ownerState.isLandscape && {
        margin: 'auto 16px auto auto'
    }));
const $11da5e4c5508a072$export$21b7f8ea763109eb = /*#__PURE__*/ $8T3gX.forwardRef(function DatePickerToolbar(inProps, ref) {
    const props = (0, $4wdE9.default)({
        props: inProps,
        name: 'MuiDatePickerToolbar'
    });
    const { parsedValue: parsedValue, isLandscape: isLandscape, isMobileKeyboardViewOpen: isMobileKeyboardViewOpen, toggleMobileKeyboardView: toggleMobileKeyboardView, toolbarFormat: toolbarFormat, toolbarPlaceholder: toolbarPlaceholder = "\u2013\u2013", toolbarTitle: toolbarTitleProp, views: views } = props, other = (0, $fAJB5.default)(props, $11da5e4c5508a072$var$_excluded);
    const utils = (0, $1hdeG.useUtils)();
    const localeText = (0, $1hdeG.useLocaleText)();
    const classes = $11da5e4c5508a072$var$useUtilityClasses(props);
    const toolbarTitle = toolbarTitleProp != null ? toolbarTitleProp : localeText.datePickerDefaultToolbarTitle;
    const dateText = $8T3gX.useMemo(()=>{
        if (!parsedValue) return toolbarPlaceholder;
        if (toolbarFormat) return utils.formatByString(parsedValue, toolbarFormat);
        if ((0, $b0826bd3c84e4838$export$eb577c89cfdd574a)(views)) return utils.format(parsedValue, 'year');
        if ((0, $b0826bd3c84e4838$export$2d2db6dbaaf33a55)(views)) return utils.format(parsedValue, 'month');
         // Little localization hack (Google is doing the same for android native pickers):
        // For english localization it is convenient to include weekday into the date "Mon, Jun 1".
        // For other locales using strings like "June 1", without weekday.
        return /en/.test(utils.getCurrentLocaleCode()) ? utils.format(parsedValue, 'normalDateWithWeekday') : utils.format(parsedValue, 'normalDate');
    }, [
        parsedValue,
        toolbarFormat,
        toolbarPlaceholder,
        utils,
        views
    ]);
    const ownerState = props;
    return /*#__PURE__*/ (0, $k4ank.jsx)($11da5e4c5508a072$var$DatePickerToolbarRoot, (0, $eJfrs.default)({
        ref: ref,
        toolbarTitle: toolbarTitle,
        isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
        toggleMobileKeyboardView: toggleMobileKeyboardView,
        isLandscape: isLandscape,
        className: classes.root
    }, other, {
        children: /*#__PURE__*/ (0, $k4ank.jsx)($11da5e4c5508a072$var$DatePickerToolbarTitle, {
            variant: "h4",
            align: isLandscape ? 'left' : 'center',
            ownerState: ownerState,
            className: classes.title,
            children: dateText
        })
    }));
});



var $2WcNZ = parcelRequire("2WcNZ");

var $gE5dt = parcelRequire("gE5dt");

var $KPkRL = parcelRequire("KPkRL");

var $01RPl = parcelRequire("01RPl");

var $hlZBr = parcelRequire("hlZBr");

var $k4ank = parcelRequire("k4ank");
const $bccca0db79d3c688$var$_excluded = [
    "onChange",
    "PopperProps",
    "PaperProps",
    "ToolbarComponent",
    "TransitionComponent",
    "value",
    "components",
    "componentsProps"
];
const $bccca0db79d3c688$export$5a73641f0156e1e4 = /*#__PURE__*/ $8T3gX.forwardRef(function DesktopDatePicker(inProps, ref) {
    const props = (0, $b0826bd3c84e4838$export$a552c17ed3587731)(inProps, 'MuiDesktopDatePicker');
    const validationError = (0, $KPkRL.useDateValidation)(props) !== null;
    const { pickerProps: pickerProps, inputProps: inputProps, wrapperProps: wrapperProps } = (0, $hlZBr.usePickerState)(props, (0, $b0826bd3c84e4838$export$31874dacbbc1e607));
    const { PopperProps: PopperProps, PaperProps: PaperProps, ToolbarComponent: ToolbarComponent = (0, $11da5e4c5508a072$export$21b7f8ea763109eb), TransitionComponent: TransitionComponent, components: components, componentsProps: componentsProps } = props, other = (0, $fAJB5.default)(props, $bccca0db79d3c688$var$_excluded);
    const AllDateInputProps = (0, $eJfrs.default)({}, inputProps, other, {
        components: components,
        componentsProps: componentsProps,
        ref: ref,
        validationError: validationError
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $2WcNZ.DesktopWrapper), (0, $eJfrs.default)({}, wrapperProps, {
        DateInputProps: AllDateInputProps,
        KeyboardDateInputComponent: (0, $01RPl.KeyboardDateInput),
        PopperProps: PopperProps,
        PaperProps: PaperProps,
        TransitionComponent: TransitionComponent,
        components: components,
        componentsProps: componentsProps,
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $gE5dt.CalendarOrClockPicker), (0, $eJfrs.default)({}, pickerProps, {
            autoFocus: true,
            toolbarTitle: props.label || props.toolbarTitle,
            ToolbarComponent: ToolbarComponent,
            DateInputProps: AllDateInputProps,
            components: components,
            componentsProps: componentsProps
        }, other))
    }));
});
$bccca0db79d3c688$export$5a73641f0156e1e4.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * Regular expression to detect "accepted" symbols.
   * @default /\dap/gi
   */ acceptRegex: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).instanceOf(RegExp),
    autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * className applied to the root component.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true` the popup or dialog will immediately close after submitting full date.
   * @default `true` for Desktop, `false` for Mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Overrideable components.
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The props used for each component slot.
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter's method `getWeekdays`.
   * @returns {string} The name to display.
   * @default (day) => day.charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Default calendar month displayed when `value={null}`.
   */ defaultCalendarMonth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true` future days are disabled.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Disable mask on the keyboard, this should be used rarely. Consider passing proper mask for your format.
   * @default false
   */ disableMaskedInput: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Do not render open picker button (renders only text field with validation).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true` past days are disabled.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Get aria-label text for control that opens picker dialog. Aria-label text must include selected date. @DateIOType
   * @template TInputDate, TDate
   * @param {TInputDate} date The date from which we want to add an aria-text.
   * @param {MuiPickersAdapter<TDate>} utils The utils to manipulate the date.
   * @returns {string} The aria-text to render inside the dialog.
   * @default (date, utils) => `Choose date, selected date is ${utils.format(utils.date(date), 'fullDate')}`
   */ getOpenDialogAriaText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Get aria-label text for switching between views button.
   * @param {CalendarPickerView} currentView The view from which we want to get the button text.
   * @returns {string} The label of the view.
   * @deprecated Use the `localeText` prop of `LocalizationProvider` instead, see https://mui.com/x/react-date-pickers/localization/.
   */ getViewSwitchingButtonText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    ignoreInvalidInputs: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Props to pass to keyboard input adornment.
   */ InputAdornmentProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Format string.
   */ inputFormat: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    InputProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        })
    ]),
    label: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Left arrow icon aria-label text.
   * @deprecated
   */ leftArrowButtonText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true` renders `LoadingComponent` in calendar instead of calendar view.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Custom mask. Can be used to override generate from format. (e.g. `__/__/____ __:__` or `__/__/____ __:__ _M`).
   */ mask: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Maximal selectable date. @DateIOType
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Minimal selectable date. @DateIOType
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Callback fired when date is accepted @DateIOType.
   * @template TValue
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the value (the selected date) changes @DateIOType.
   * @template TValue
   * @param {TValue} value The new parsed value.
   * @param {string} keyboardInputValue The current value of the keyboard input.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback that fired when input value or new `value` prop validation returns **new** validation error (or value is valid after error).
   * In case of validation error detected `reason` prop return non-null value and `TextField` must be displayed in `error` state.
   * This can be used to render appropriate form error.
   *
   * [Read the guide](https://next.material-ui-pickers.dev/guides/forms) about form integration and error displaying.
   * @DateIOType
   *
   * @template TError, TInputValue
   * @param {TError} reason The reason why the current value is not valid.
   * @param {TInputValue} value The invalid value.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback firing on month change @DateIOType.
   * @template TDate
   * @param {TDate} month The new month.
   * @returns {void|Promise} -
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired on view change.
   * @param {CalendarPickerView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback firing on year change @DateIOType.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Control the popup or dialog open state.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Props to pass to keyboard adornment button.
   */ OpenPickerButtonProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * First view to show.
   * Must be a valid option from `views` list
   * @default 'day'
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'landscape',
        'portrait'
    ]),
    /**
   * Paper props passed down to [Paper](https://mui.com/material-ui/api/paper/) component.
   */ PaperProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Popper props passed down to [Popper](https://mui.com/material-ui/api/popper/) component.
   */ PopperProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Make picker read only.
   * @default false
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Disable heavy animations.
   * @default typeof navigator !== 'undefined' && /(android)/i.test(navigator.userAgent)
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Custom renderer for day. Check the [PickersDay](https://mui.com/x/api/date-pickers/pickers-day/) component.
   * @template TDate
   * @param {TDate} day The day to render.
   * @param {Array<TDate | null>} selectedDays The days currently selected.
   * @param {PickersDayProps<TDate>} pickersDayProps The props of the day to render.
   * @returns {JSX.Element} The element representing the day.
   */ renderDay: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * The `renderInput` prop allows you to customize the rendered input.
   * The `props` argument of this render prop contains props of [TextField](https://mui.com/material-ui/api/text-field/#props) that you need to forward.
   * Pay specific attention to the `ref` and `inputProps` keys.
   * @example ```jsx
   * renderInput={props => <TextField {...props} />}
   * ````
   * @param {MuiTextFieldPropsType} props The props of the input.
   * @returns {React.ReactNode} The node to render as the input.
   */ renderInput: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Custom formatter to be passed into Rifm component.
   * @param {string} str The un-formatted string.
   * @returns {string} The formatted string.
   */ rifmFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Right arrow icon aria-label text.
   * @deprecated
   */ rightArrowButtonText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Disable specific date. @DateIOType
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} Returns `true` if the date should be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Disable specific months dynamically.
   * Works like `shouldDisableDate` but for month selection view @DateIOType.
   * @template TDate
   * @param {TDate} month The month to check.
   * @returns {boolean} If `true` the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Disable specific years dynamically.
   * Works like `shouldDisableDate` but for year selection view @DateIOType.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} Returns `true` if the year should be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, days that have `outsideCurrentMonth={true}` are displayed.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, show the toolbar even in desktop mode.
   */ showToolbar: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Component that will replace default toolbar renderer.
   * @default DatePickerToolbar
   */ ToolbarComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * Date format, that is displaying in toolbar.
   */ toolbarFormat: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Mobile picker date value placeholder, displaying if `value` === `null`.
   * @default '–'
   */ toolbarPlaceholder: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Mobile picker title, displaying in the toolbar.
   * @default 'Select date'
   */ toolbarTitle: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Custom component for popper [Transition](https://mui.com/material-ui/transitions/#transitioncomponent-prop).
   */ TransitionComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * The value of the picker.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Array of views to show.
   * @default ['year', 'day']
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'day',
        'month',
        'year'
    ]).isRequired)
};



var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");



var $3QCZS = parcelRequire("3QCZS");

var $gE5dt = parcelRequire("gE5dt");

var $KPkRL = parcelRequire("KPkRL");

var $hgQKr = parcelRequire("hgQKr");

var $hlZBr = parcelRequire("hlZBr");

var $k4ank = parcelRequire("k4ank");
const $dc1437a7a8c72858$var$_excluded = [
    "ToolbarComponent",
    "value",
    "onChange",
    "components",
    "componentsProps"
];
const $dc1437a7a8c72858$export$97b476d7a92fee62 = /*#__PURE__*/ $8T3gX.forwardRef(function MobileDatePicker(inProps, ref) {
    const props = (0, $b0826bd3c84e4838$export$a552c17ed3587731)(inProps, 'MuiMobileDatePicker');
    const validationError = (0, $KPkRL.useDateValidation)(props) !== null;
    const { pickerProps: pickerProps, inputProps: inputProps, wrapperProps: wrapperProps } = (0, $hlZBr.usePickerState)(props, (0, $b0826bd3c84e4838$export$31874dacbbc1e607)); // Note that we are passing down all the value without spread.
    // It saves us >1kb gzip and make any prop available automatically on any level down.
    const { ToolbarComponent: ToolbarComponent = (0, $11da5e4c5508a072$export$21b7f8ea763109eb), components: components, componentsProps: componentsProps } = props, other = (0, $fAJB5.default)(props, $dc1437a7a8c72858$var$_excluded);
    const DateInputProps = (0, $eJfrs.default)({}, inputProps, other, {
        components: components,
        componentsProps: componentsProps,
        ref: ref,
        validationError: validationError
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QCZS.MobileWrapper), (0, $eJfrs.default)({}, other, wrapperProps, {
        DateInputProps: DateInputProps,
        PureDateInputComponent: (0, $hgQKr.PureDateInput),
        components: components,
        componentsProps: componentsProps,
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $gE5dt.CalendarOrClockPicker), (0, $eJfrs.default)({}, pickerProps, {
            autoFocus: true,
            toolbarTitle: props.label || props.toolbarTitle,
            ToolbarComponent: ToolbarComponent,
            DateInputProps: DateInputProps,
            components: components,
            componentsProps: componentsProps
        }, other))
    }));
});
$dc1437a7a8c72858$export$97b476d7a92fee62.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * Regular expression to detect "accepted" symbols.
   * @default /\dap/gi
   */ acceptRegex: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).instanceOf(RegExp),
    autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * className applied to the root component.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true` the popup or dialog will immediately close after submitting full date.
   * @default `true` for Desktop, `false` for Mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Overrideable components.
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The props used for each component slot.
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter's method `getWeekdays`.
   * @returns {string} The name to display.
   * @default (day) => day.charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Default calendar month displayed when `value={null}`.
   */ defaultCalendarMonth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Props applied to the [`Dialog`](https://mui.com/material-ui/api/dialog/) element.
   */ DialogProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true` future days are disabled.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Disable mask on the keyboard, this should be used rarely. Consider passing proper mask for your format.
   * @default false
   */ disableMaskedInput: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Do not render open picker button (renders only text field with validation).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true` past days are disabled.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Get aria-label text for control that opens picker dialog. Aria-label text must include selected date. @DateIOType
   * @template TInputDate, TDate
   * @param {TInputDate} date The date from which we want to add an aria-text.
   * @param {MuiPickersAdapter<TDate>} utils The utils to manipulate the date.
   * @returns {string} The aria-text to render inside the dialog.
   * @default (date, utils) => `Choose date, selected date is ${utils.format(utils.date(date), 'fullDate')}`
   */ getOpenDialogAriaText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Get aria-label text for switching between views button.
   * @param {CalendarPickerView} currentView The view from which we want to get the button text.
   * @returns {string} The label of the view.
   * @deprecated Use the `localeText` prop of `LocalizationProvider` instead, see https://mui.com/x/react-date-pickers/localization/.
   */ getViewSwitchingButtonText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    ignoreInvalidInputs: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Props to pass to keyboard input adornment.
   */ InputAdornmentProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Format string.
   */ inputFormat: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    InputProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        })
    ]),
    label: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Left arrow icon aria-label text.
   * @deprecated
   */ leftArrowButtonText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true` renders `LoadingComponent` in calendar instead of calendar view.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Custom mask. Can be used to override generate from format. (e.g. `__/__/____ __:__` or `__/__/____ __:__ _M`).
   */ mask: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Maximal selectable date. @DateIOType
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Minimal selectable date. @DateIOType
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Callback fired when date is accepted @DateIOType.
   * @template TValue
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the value (the selected date) changes @DateIOType.
   * @template TValue
   * @param {TValue} value The new parsed value.
   * @param {string} keyboardInputValue The current value of the keyboard input.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback that fired when input value or new `value` prop validation returns **new** validation error (or value is valid after error).
   * In case of validation error detected `reason` prop return non-null value and `TextField` must be displayed in `error` state.
   * This can be used to render appropriate form error.
   *
   * [Read the guide](https://next.material-ui-pickers.dev/guides/forms) about form integration and error displaying.
   * @DateIOType
   *
   * @template TError, TInputValue
   * @param {TError} reason The reason why the current value is not valid.
   * @param {TInputValue} value The invalid value.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback firing on month change @DateIOType.
   * @template TDate
   * @param {TDate} month The new month.
   * @returns {void|Promise} -
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired on view change.
   * @param {CalendarPickerView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback firing on year change @DateIOType.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Control the popup or dialog open state.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Props to pass to keyboard adornment button.
   */ OpenPickerButtonProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * First view to show.
   * Must be a valid option from `views` list
   * @default 'day'
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'landscape',
        'portrait'
    ]),
    /**
   * Make picker read only.
   * @default false
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Disable heavy animations.
   * @default typeof navigator !== 'undefined' && /(android)/i.test(navigator.userAgent)
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Custom renderer for day. Check the [PickersDay](https://mui.com/x/api/date-pickers/pickers-day/) component.
   * @template TDate
   * @param {TDate} day The day to render.
   * @param {Array<TDate | null>} selectedDays The days currently selected.
   * @param {PickersDayProps<TDate>} pickersDayProps The props of the day to render.
   * @returns {JSX.Element} The element representing the day.
   */ renderDay: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * The `renderInput` prop allows you to customize the rendered input.
   * The `props` argument of this render prop contains props of [TextField](https://mui.com/material-ui/api/text-field/#props) that you need to forward.
   * Pay specific attention to the `ref` and `inputProps` keys.
   * @example ```jsx
   * renderInput={props => <TextField {...props} />}
   * ````
   * @param {MuiTextFieldPropsType} props The props of the input.
   * @returns {React.ReactNode} The node to render as the input.
   */ renderInput: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Custom formatter to be passed into Rifm component.
   * @param {string} str The un-formatted string.
   * @returns {string} The formatted string.
   */ rifmFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Right arrow icon aria-label text.
   * @deprecated
   */ rightArrowButtonText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Disable specific date. @DateIOType
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} Returns `true` if the date should be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Disable specific months dynamically.
   * Works like `shouldDisableDate` but for month selection view @DateIOType.
   * @template TDate
   * @param {TDate} month The month to check.
   * @returns {boolean} If `true` the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Disable specific years dynamically.
   * Works like `shouldDisableDate` but for year selection view @DateIOType.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} Returns `true` if the year should be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, days that have `outsideCurrentMonth={true}` are displayed.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, show the toolbar even in desktop mode.
   */ showToolbar: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Component that will replace default toolbar renderer.
   * @default DatePickerToolbar
   */ ToolbarComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * Date format, that is displaying in toolbar.
   */ toolbarFormat: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Mobile picker date value placeholder, displaying if `value` === `null`.
   * @default '–'
   */ toolbarPlaceholder: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Mobile picker title, displaying in the toolbar.
   * @default 'Select date'
   */ toolbarTitle: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * The value of the picker.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Array of views to show.
   * @default ['year', 'day']
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'day',
        'month',
        'year'
    ]).isRequired)
};



var $k4ank = parcelRequire("k4ank");
const $cbaf068f14972fdf$var$_excluded = [
    "desktopModeMediaQuery",
    "DialogProps",
    "PopperProps",
    "TransitionComponent"
];
const $cbaf068f14972fdf$export$5109c6dd95d8fb00 = /*#__PURE__*/ $8T3gX.forwardRef(function DatePicker(inProps, ref) {
    const props = (0, $4wdE9.default)({
        props: inProps,
        name: 'MuiDatePicker'
    });
    const { desktopModeMediaQuery: desktopModeMediaQuery = '@media (pointer: fine)', DialogProps: DialogProps, PopperProps: PopperProps, TransitionComponent: TransitionComponent } = props, other = (0, $fAJB5.default)(props, $cbaf068f14972fdf$var$_excluded); // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, $hHKnQ.default)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $bccca0db79d3c688$export$5a73641f0156e1e4), (0, $eJfrs.default)({
        ref: ref,
        PopperProps: PopperProps,
        TransitionComponent: TransitionComponent
    }, other));
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $dc1437a7a8c72858$export$97b476d7a92fee62), (0, $eJfrs.default)({
        ref: ref,
        DialogProps: DialogProps
    }, other));
});
$cbaf068f14972fdf$export$5109c6dd95d8fb00.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * Regular expression to detect "accepted" symbols.
   * @default /\dap/gi
   */ acceptRegex: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).instanceOf(RegExp),
    autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * className applied to the root component.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true` the popup or dialog will immediately close after submitting full date.
   * @default `true` for Desktop, `false` for Mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Overrideable components.
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The props used for each component slot.
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter's method `getWeekdays`.
   * @returns {string} The name to display.
   * @default (day) => day.charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Default calendar month displayed when `value={null}`.
   */ defaultCalendarMonth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */ desktopModeMediaQuery: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Props applied to the [`Dialog`](https://mui.com/material-ui/api/dialog/) element.
   */ DialogProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true` future days are disabled.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Disable mask on the keyboard, this should be used rarely. Consider passing proper mask for your format.
   * @default false
   */ disableMaskedInput: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Do not render open picker button (renders only text field with validation).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true` past days are disabled.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Get aria-label text for control that opens picker dialog. Aria-label text must include selected date. @DateIOType
   * @template TInputDate, TDate
   * @param {TInputDate} date The date from which we want to add an aria-text.
   * @param {MuiPickersAdapter<TDate>} utils The utils to manipulate the date.
   * @returns {string} The aria-text to render inside the dialog.
   * @default (date, utils) => `Choose date, selected date is ${utils.format(utils.date(date), 'fullDate')}`
   */ getOpenDialogAriaText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Get aria-label text for switching between views button.
   * @param {CalendarPickerView} currentView The view from which we want to get the button text.
   * @returns {string} The label of the view.
   * @deprecated Use the `localeText` prop of `LocalizationProvider` instead, see https://mui.com/x/react-date-pickers/localization/.
   */ getViewSwitchingButtonText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    ignoreInvalidInputs: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Props to pass to keyboard input adornment.
   */ InputAdornmentProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Format string.
   */ inputFormat: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    InputProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            current: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
        })
    ]),
    label: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Left arrow icon aria-label text.
   * @deprecated
   */ leftArrowButtonText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * If `true` renders `LoadingComponent` in calendar instead of calendar view.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Custom mask. Can be used to override generate from format. (e.g. `__/__/____ __:__` or `__/__/____ __:__ _M`).
   */ mask: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Maximal selectable date. @DateIOType
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Minimal selectable date. @DateIOType
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Callback fired when date is accepted @DateIOType.
   * @template TValue
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the value (the selected date) changes @DateIOType.
   * @template TValue
   * @param {TValue} value The new parsed value.
   * @param {string} keyboardInputValue The current value of the keyboard input.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback that fired when input value or new `value` prop validation returns **new** validation error (or value is valid after error).
   * In case of validation error detected `reason` prop return non-null value and `TextField` must be displayed in `error` state.
   * This can be used to render appropriate form error.
   *
   * [Read the guide](https://next.material-ui-pickers.dev/guides/forms) about form integration and error displaying.
   * @DateIOType
   *
   * @template TError, TInputValue
   * @param {TError} reason The reason why the current value is not valid.
   * @param {TInputValue} value The invalid value.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback firing on month change @DateIOType.
   * @template TDate
   * @param {TDate} month The new month.
   * @returns {void|Promise} -
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback fired on view change.
   * @param {CalendarPickerView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Callback firing on year change @DateIOType.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Control the popup or dialog open state.
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Props to pass to keyboard adornment button.
   */ OpenPickerButtonProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * First view to show.
   * Must be a valid option from `views` list
   * @default 'day'
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'landscape',
        'portrait'
    ]),
    /**
   * Paper props passed down to [Paper](https://mui.com/material-ui/api/paper/) component.
   */ PaperProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Popper props passed down to [Popper](https://mui.com/material-ui/api/popper/) component.
   */ PopperProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Make picker read only.
   * @default false
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Disable heavy animations.
   * @default typeof navigator !== 'undefined' && /(android)/i.test(navigator.userAgent)
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Custom renderer for day. Check the [PickersDay](https://mui.com/x/api/date-pickers/pickers-day/) component.
   * @template TDate
   * @param {TDate} day The day to render.
   * @param {Array<TDate | null>} selectedDays The days currently selected.
   * @param {PickersDayProps<TDate>} pickersDayProps The props of the day to render.
   * @returns {JSX.Element} The element representing the day.
   */ renderDay: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * The `renderInput` prop allows you to customize the rendered input.
   * The `props` argument of this render prop contains props of [TextField](https://mui.com/material-ui/api/text-field/#props) that you need to forward.
   * Pay specific attention to the `ref` and `inputProps` keys.
   * @example ```jsx
   * renderInput={props => <TextField {...props} />}
   * ````
   * @param {MuiTextFieldPropsType} props The props of the input.
   * @returns {React.ReactNode} The node to render as the input.
   */ renderInput: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Custom formatter to be passed into Rifm component.
   * @param {string} str The un-formatted string.
   * @returns {string} The formatted string.
   */ rifmFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Right arrow icon aria-label text.
   * @deprecated
   */ rightArrowButtonText: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Disable specific date. @DateIOType
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} Returns `true` if the date should be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Disable specific months dynamically.
   * Works like `shouldDisableDate` but for month selection view @DateIOType.
   * @template TDate
   * @param {TDate} month The month to check.
   * @returns {boolean} If `true` the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Disable specific years dynamically.
   * Works like `shouldDisableDate` but for year selection view @DateIOType.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} Returns `true` if the year should be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, days that have `outsideCurrentMonth={true}` are displayed.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, show the toolbar even in desktop mode.
   */ showToolbar: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Component that will replace default toolbar renderer.
   * @default DatePickerToolbar
   */ ToolbarComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * Date format, that is displaying in toolbar.
   */ toolbarFormat: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Mobile picker date value placeholder, displaying if `value` === `null`.
   * @default '–'
   */ toolbarPlaceholder: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Mobile picker title, displaying in the toolbar.
   * @default 'Select date'
   */ toolbarTitle: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Custom component for popper [Transition](https://mui.com/material-ui/transitions/#transitioncomponent-prop).
   */ TransitionComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * The value of the picker.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).any,
    /**
   * Array of views to show.
   * @default ['year', 'day']
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'day',
        'month',
        'year'
    ]).isRequired)
};


var $6UPM7 = parcelRequire("6UPM7");

var $8jTCz = parcelRequire("8jTCz");

var $5L5iJ = parcelRequire("5L5iJ");

const $0ddb02651f35e13a$var$hourLabels = [
    "12",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11"
];
const $0ddb02651f35e13a$export$fb9e1512f325609e = ({ open: open, onCancel: onCancel, onSubmit: onSubmit, title: title = "Add Event", submitLabel: submitLabel = "Submit", initialEvent: initialEvent, requireChanges: requireChanges = false, showScheduleTime: showScheduleTime = true })=>{
    const dialogMaxWidth = showScheduleTime ? "lg" : "sm";
    const createMidnightDate = ()=>{
        const midnight = new Date();
        midnight.setHours(0, 0, 0, 0);
        return midnight;
    };
    const createFilledSelection = ()=>Array.from({
            length: 96
        }, ()=>true);
    const [eventDate, setEventDate] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(new Date());
    const [eventName, setEventName] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [selectedSlots, setSelectedSlots] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState((0, $ccd18487931e09c7$export$17f94c0d03a6a65a)());
    const [startTime, setStartTime] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(createMidnightDate());
    const [endTime, setEndTime] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(createMidnightDate());
    const [isMouseDown, setIsMouseDown] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [dragStartSlot, setDragStartSlot] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [hoverSlot, setHoverSlot] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [detectionsAlwaysOn, setDetectionsAlwaysOn] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [hasChanges, setHasChanges] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!open) return;
        if (initialEvent) {
            const alwaysOn = (0, $ccd18487931e09c7$export$3d1ef2819c14a5ae)(initialEvent.start_time, initialEvent.end_time);
            setEventDate((0, $ccd18487931e09c7$export$2a212a58125b39b3)(initialEvent.event_date));
            setEventName(initialEvent.name);
            setDetectionsAlwaysOn(alwaysOn);
            setIsMouseDown(false);
            setDragStartSlot(null);
            setHoverSlot(null);
            if (alwaysOn) {
                setSelectedSlots((0, $ccd18487931e09c7$export$17f94c0d03a6a65a)());
                setStartTime(createMidnightDate());
                setEndTime(createMidnightDate());
            } else {
                const startMinutes = (0, $ccd18487931e09c7$export$8491938b27b4bdbc)(initialEvent.start_time);
                const endMinutes = (0, $ccd18487931e09c7$export$8491938b27b4bdbc)(initialEvent.end_time);
                const selection = (0, $ccd18487931e09c7$export$347bac2607247493)(startMinutes, endMinutes);
                const baseDate = new Date();
                setSelectedSlots(selection);
                setStartTime((0, $ccd18487931e09c7$export$62f659bbe94e4df7)(baseDate, startMinutes));
                setEndTime((0, $ccd18487931e09c7$export$62f659bbe94e4df7)(baseDate, endMinutes));
            }
        } else {
            setEventDate(new Date());
            setEventName("");
            setSelectedSlots((0, $ccd18487931e09c7$export$17f94c0d03a6a65a)());
            setStartTime(createMidnightDate());
            setEndTime(createMidnightDate());
            setIsMouseDown(false);
            setDragStartSlot(null);
            setHoverSlot(null);
            setDetectionsAlwaysOn(true);
        }
        setHasChanges(false);
    }, [
        open,
        initialEvent?.event_date,
        initialEvent?.name,
        initialEvent?.start_time,
        initialEvent?.end_time
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!open || !initialEvent || !requireChanges) {
            setHasChanges(false);
            return;
        }
        const currentValues = {
            event_date: (0, $5L5iJ.yyyymmddGenerator)(eventDate),
            name: eventName.trim(),
            ...showScheduleTime ? (0, $ccd18487931e09c7$export$59eebec189dfc007)(detectionsAlwaysOn, startTime, endTime) : {}
        };
        const initialValues = {
            event_date: initialEvent.event_date,
            name: initialEvent.name.trim(),
            ...showScheduleTime ? (0, $ccd18487931e09c7$export$2dac4520d1ba284)(initialEvent.start_time, initialEvent.end_time) : {}
        };
        setHasChanges(currentValues.event_date !== initialValues.event_date || currentValues.name !== initialValues.name || showScheduleTime && (currentValues.start_time !== initialValues.start_time || currentValues.end_time !== initialValues.end_time));
    }, [
        open,
        initialEvent,
        requireChanges,
        showScheduleTime,
        eventDate,
        eventName,
        detectionsAlwaysOn,
        startTime,
        endTime
    ]);
    const updateTimesFromSelection = (nextSelection)=>{
        const range = (0, $ccd18487931e09c7$export$4583ef486354f23e)(nextSelection);
        if (!range) {
            setStartTime(null);
            setEndTime(null);
            return;
        }
        const baseDate = new Date();
        setStartTime((0, $ccd18487931e09c7$export$62f659bbe94e4df7)(baseDate, range.startMinutes));
        setEndTime((0, $ccd18487931e09c7$export$62f659bbe94e4df7)(baseDate, range.endMinutes));
    };
    const applySelection = (nextSelection, syncTimes = true)=>{
        if ((0, $ccd18487931e09c7$export$1bc11f3b004c66a7)(nextSelection)) {
            alert("Only one start and end time are supported.");
            return;
        }
        setSelectedSlots(nextSelection);
        if (syncTimes) updateTimesFromSelection(nextSelection);
    };
    const toggleRange = (startIndex, endIndex)=>{
        const nextSelection = [
            ...selectedSlots
        ];
        const min = Math.min(startIndex, endIndex);
        const max = Math.max(startIndex, endIndex);
        for(let i = min; i <= max; i++)nextSelection[i] = !nextSelection[i];
        applySelection(nextSelection);
    };
    const handleStartTimeChange = (nextStart)=>{
        setStartTime(nextStart);
        if (!nextStart || !endTime) return;
        applySelection((0, $ccd18487931e09c7$export$347bac2607247493)((0, $ccd18487931e09c7$export$d3ad747999865bd9)(nextStart), (0, $ccd18487931e09c7$export$d3ad747999865bd9)(endTime)), false);
    };
    const handleEndTimeChange = (nextEnd)=>{
        setEndTime(nextEnd);
        if (!startTime || !nextEnd) return;
        applySelection((0, $ccd18487931e09c7$export$347bac2607247493)((0, $ccd18487931e09c7$export$d3ad747999865bd9)(startTime), (0, $ccd18487931e09c7$export$d3ad747999865bd9)(nextEnd)), false);
    };
    const isPreviewCell = (slotIndex)=>{
        if (!isMouseDown || dragStartSlot === null || hoverSlot === null) return false;
        const min = Math.min(dragStartSlot, hoverSlot);
        const max = Math.max(dragStartSlot, hoverSlot);
        return slotIndex >= min && slotIndex <= max;
    };
    const displayedSlots = detectionsAlwaysOn ? Array.from({
        length: 96
    }, ()=>true) : selectedSlots;
    const displayedStartTime = detectionsAlwaysOn ? createMidnightDate() : startTime;
    const displayedEndTime = detectionsAlwaysOn ? createMidnightDate() : endTime;
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: open,
        onClose: onCancel,
        maxWidth: dialogMaxWidth,
        fullWidth: true,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                sx: {
                    fontFamily: "Mulish"
                },
                children: title
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
                    dateAdapter: (0, $hfM8m.AdapterDateFns),
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "mt-2 flex flex-col gap-4",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "flex gap-[20px]",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cbaf068f14972fdf$export$5109c6dd95d8fb00), {
                                        label: "Event Date",
                                        value: eventDate,
                                        onChange: (newValue)=>{
                                            if (newValue) setEventDate(newValue);
                                        },
                                        renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                ...params,
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    width: 200
                                                }
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        label: "Event Name",
                                        variant: "standard",
                                        value: eventName,
                                        onChange: (event)=>setEventName(event.target.value),
                                        sx: {
                                            fontFamily: "Mulish",
                                            width: 500
                                        }
                                    })
                                ]
                            }),
                            showScheduleTime && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        children: " "
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                            checked: detectionsAlwaysOn,
                                            onChange: (event)=>{
                                                const checked = event.target.checked;
                                                setDetectionsAlwaysOn(checked);
                                                if (!checked) setSelectedSlots(createFilledSelection());
                                            }
                                        }),
                                        label: "Detections Always On (Default)",
                                        sx: {
                                            "& .MuiFormControlLabel-label": {
                                                fontFamily: "Mulish"
                                            }
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                        size: "small",
                                        sx: {
                                            tableLayout: "fixed"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $ha39s.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                colSpan: 48,
                                                                align: "center",
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    borderTop: "1px solid #9CA3AF",
                                                                    borderBottom: "1px solid #9CA3AF",
                                                                    borderLeft: "1px solid #9CA3AF",
                                                                    borderRight: "2px solid #9CA3AF"
                                                                },
                                                                children: "AM"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                colSpan: 48,
                                                                align: "center",
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    borderTop: "1px solid #9CA3AF",
                                                                    borderBottom: "1px solid #9CA3AF",
                                                                    borderRight: "1px solid #9CA3AF",
                                                                    borderLeft: "2px solid #9CA3AF"
                                                                },
                                                                children: "PM"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                                        children: $0ddb02651f35e13a$var$hourLabels.map((label, index)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                colSpan: 4,
                                                                align: "center",
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    fontSize: "12px",
                                                                    padding: "4px 0",
                                                                    borderBottom: "1px solid #D1D5DB",
                                                                    borderLeft: index === 12 ? "2px solid #9CA3AF" : "1px solid #9CA3AF",
                                                                    borderRight: "1px solid #9CA3AF"
                                                                },
                                                                children: label
                                                            }, `hour-${index}`))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                                    children: displayedSlots.map((isActive, slotIndex)=>{
                                                        const previewCell = isPreviewCell(slotIndex);
                                                        return /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            "data-testid": `event-slot-${slotIndex}`,
                                                            onMouseDown: ()=>{
                                                                if (detectionsAlwaysOn) return;
                                                                setIsMouseDown(true);
                                                                setDragStartSlot(slotIndex);
                                                                setHoverSlot(slotIndex);
                                                            },
                                                            onMouseOver: ()=>{
                                                                if (detectionsAlwaysOn) return;
                                                                if (isMouseDown) setHoverSlot(slotIndex);
                                                            },
                                                            onMouseUp: ()=>{
                                                                if (detectionsAlwaysOn) return;
                                                                if (dragStartSlot === null) return;
                                                                toggleRange(dragStartSlot, slotIndex);
                                                                setIsMouseDown(false);
                                                                setDragStartSlot(null);
                                                                setHoverSlot(null);
                                                            },
                                                            sx: {
                                                                cursor: detectionsAlwaysOn ? "default" : "pointer",
                                                                padding: "20px 2px",
                                                                backgroundColor: isActive ? detectionsAlwaysOn ? "#A5D6A7" : "#66BB6A" : previewCell ? "#FFD6A6" : "#F3F4F6",
                                                                border: "1px solid #D1D5DB",
                                                                borderLeft: slotIndex === 48 ? "2px solid #9CA3AF" : slotIndex % 4 === 0 ? "1px solid #9CA3AF" : "1px solid #D1D5DB"
                                                            }
                                                        }, `slot-${slotIndex}`);
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    !detectionsAlwaysOn && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                            onClick: ()=>{
                                                applySelection((0, $ccd18487931e09c7$export$17f94c0d03a6a65a)());
                                            },
                                            text: "Clear Grid",
                                            disabled: false
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        children: " "
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "flex gap-[10px]",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $6UPM7.TimePicker), {
                                                label: "Start Time",
                                                value: displayedStartTime,
                                                onChange: handleStartTimeChange,
                                                disabled: detectionsAlwaysOn,
                                                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                        ...params,
                                                        inputProps: {
                                                            ...params.inputProps,
                                                            "data-testid": "start-time-input"
                                                        },
                                                        sx: {
                                                            fontFamily: "Mulish",
                                                            width: 250
                                                        }
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $6UPM7.TimePicker), {
                                                label: "End Time",
                                                value: displayedEndTime,
                                                onChange: handleEndTimeChange,
                                                disabled: detectionsAlwaysOn,
                                                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                        ...params,
                                                        inputProps: {
                                                            ...params.inputProps,
                                                            "data-testid": "end-time-input"
                                                        },
                                                        sx: {
                                                            fontFamily: "Mulish",
                                                            width: 250
                                                        }
                                                    })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                sx: {
                    paddingRight: 3,
                    paddingBottom: 2
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: onCancel,
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            const scheduleTimeValues = showScheduleTime ? (0, $ccd18487931e09c7$export$59eebec189dfc007)(detectionsAlwaysOn, startTime, endTime) : initialEvent ? (0, $ccd18487931e09c7$export$2dac4520d1ba284)(initialEvent.start_time, initialEvent.end_time) : {
                                start_time: null,
                                end_time: null
                            };
                            onSubmit({
                                event_date: (0, $5L5iJ.yyyymmddGenerator)(eventDate),
                                name: eventName.trim(),
                                ...scheduleTimeValues
                            });
                        },
                        text: submitLabel,
                        disabled: !eventName.trim() || requireChanges && !hasChanges
                    })
                ]
            })
        ]
    });
};



var $4PFLW = parcelRequire("4PFLW");
const $b2867f9a424e8e39$export$745f33b0c918d204 = ({ addDateDialogOpen: addDateDialogOpen, setAddDateDialogOpen: setAddDateDialogOpen, setCalendarEvents: setCalendarEvents, calendarId: calendarId, setShowMoreDialogOpen: setShowMoreDialogOpen, setEditingCalendar: setEditingCalendar, navigate: navigate })=>{
    const { isFeatureEnabled: isFeatureEnabled } = (0, $4PFLW.useFeatureFlag)();
    const showAddCalendarScheduleTime = isFeatureEnabled("showAddCalendarScheduleTime", false);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $0ddb02651f35e13a$export$fb9e1512f325609e), {
        open: addDateDialogOpen,
        title: "Add Date",
        submitLabel: "Save",
        showScheduleTime: showAddCalendarScheduleTime,
        onCancel: ()=>{
            setAddDateDialogOpen(false);
            setShowMoreDialogOpen(true);
        },
        onSubmit: (newEvent)=>{
            setEditingCalendar(true);
            (0, $7be2031d29a706f9$export$d22b7535015240ea)({
                calendar: calendarId,
                ...newEvent
            }, setCalendarEvents, setEditingCalendar, navigate);
            setAddDateDialogOpen(false);
            setShowMoreDialogOpen(true);
        }
    });
};



var $djxj8 = parcelRequire("djxj8");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $c342cba6aff09dce$export$da80447b5702aa5 = (patchEvent, setCalendarEvents, setEditingCalendar, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $c342cba6aff09dce$export$da80447b5702aa5(patchEvent, setCalendarEvents, setEditingCalendar, navigate);
    };
    const updatedPatchEvent = {
        calendar: patchEvent.calendar,
        event_date: patchEvent.event_date,
        name: patchEvent.name,
        start_time: patchEvent.start_time ?? "00:00:00",
        end_time: patchEvent.end_time ?? "23:59:59"
    };
    AxiosUI.patch(`calendar_event/${patchEvent.id}/`, updatedPatchEvent).then((response)=>{
        AxiosUI.get(`calendar_event/?calendar__id=${response.data.calendar}`).then((response)=>{
            setCalendarEvents(response.data.results);
            setEditingCalendar(false);
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                setEditingCalendar(false);
            });
        });
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Error updating event, please try again");
            setEditingCalendar(false);
        });
    });
};




var $4PFLW = parcelRequire("4PFLW");
const $1cfc222a8ca52913$export$de7ac5d992cddd48 = ({ patchEvent: patchEvent, editEventDialogOpen: editEventDialogOpen, setEditEventDialogOpen: setEditEventDialogOpen, setEditingCalendar: setEditingCalendar, setCalendarEvents: setCalendarEvents, navigate: navigate })=>{
    const { isFeatureEnabled: isFeatureEnabled } = (0, $4PFLW.useFeatureFlag)();
    const showAddCalendarScheduleTime = isFeatureEnabled("showAddCalendarScheduleTime", false);
    const initialEvent = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>({
            event_date: patchEvent.event_date,
            name: patchEvent.name,
            start_time: patchEvent.start_time ?? null,
            end_time: patchEvent.end_time ?? null
        }), [
        patchEvent.event_date,
        patchEvent.name,
        patchEvent.start_time,
        patchEvent.end_time
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $0ddb02651f35e13a$export$fb9e1512f325609e), {
        open: editEventDialogOpen,
        title: "Edit Event",
        submitLabel: "Save",
        requireChanges: true,
        initialEvent: initialEvent,
        showScheduleTime: showAddCalendarScheduleTime,
        onCancel: ()=>{
            setEditEventDialogOpen(false);
            setEditingCalendar(false);
        },
        onSubmit: (updatedEvent)=>{
            setEditEventDialogOpen(false);
            setEditingCalendar(true);
            (0, $c342cba6aff09dce$export$da80447b5702aa5)({
                ...patchEvent,
                ...updatedEvent
            }, setCalendarEvents, setEditingCalendar, navigate);
        }
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $ce8iU = parcelRequire("ce8iU");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $c258fcc72f32e147$export$b020ff7444736758 = (newCalendarInfo, setFetchingCalendarData, calendarData, setCalendarData, setCalendarAlerts, calendarsSearchString, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $c258fcc72f32e147$export$b020ff7444736758(newCalendarInfo, setFetchingCalendarData, calendarData, setCalendarData, setCalendarAlerts, calendarsSearchString, navigate);
    };
    AxiosUI.post(`calendar/`, newCalendarInfo).then((response)=>{
        if (!calendarsSearchString) setCalendarData([
            ...calendarData,
            response.data
        ]);
        localStorage.setItem("newCalendarName", newCalendarInfo.name);
        setCalendarAlerts((previousState)=>{
            return {
                ...previousState,
                addCalendarSuccess: true,
                deleteCalendarSuccess: false,
                setCalendarAlerts: false
            };
        });
        setFetchingCalendarData(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Error adding calendar, please try again");
            setFetchingCalendarData(false);
        });
    });
};



var $8T3gX = parcelRequire("8T3gX");
function $d6c6d44336954ff6$export$15a2cbbfd9d71fcb(s) {
    return s.trim().toLowerCase().replace(/\s+/g, " ");
}
function $d6c6d44336954ff6$export$5fb577f2a1fa696b(parentAccounts, selectedGroupId) {
    const groupOptionRows = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>{
        if (!parentAccounts?.[0]) return [];
        return parentAccounts.map((object, index)=>({
                id: object.id,
                name: String(object.name ?? ""),
                index: index
            }));
    }, [
        parentAccounts
    ]);
    const [groupFilterInput, setGroupFilterInput] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const filteredGroupOptions = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>{
        const q = $d6c6d44336954ff6$export$15a2cbbfd9d71fcb(groupFilterInput);
        if (!q) return groupOptionRows;
        return groupOptionRows.filter((opt)=>{
            const n = $d6c6d44336954ff6$export$15a2cbbfd9d71fcb(String(opt.name));
            return n.includes(q);
        });
    }, [
        groupFilterInput,
        groupOptionRows
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        const gid = selectedGroupId;
        if (gid === "" || gid == null) return;
        const row = groupOptionRows.find((r)=>String(r.id) === String(gid));
        if (row) setGroupFilterInput(String(row.name));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- sync when selection id or row count changes; `groupOptionRows` omitted (parent may pass new array ref each render).
    }, [
        selectedGroupId,
        groupOptionRows.length
    ]);
    const onGroupInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback((_event, value, reason)=>{
        if (reason === "input" || reason === "clear") setGroupFilterInput(reason === "clear" ? "" : value);
        else if (reason === "reset") {
            if (typeof value === "string" && value !== "") setGroupFilterInput(value);
        }
    }, []);
    const clearGroupFilterInput = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback(()=>{
        setGroupFilterInput("");
    }, []);
    const filterOptionsIdentity = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback((opts)=>opts, []);
    return {
        filteredGroupOptions: filteredGroupOptions,
        groupFilterInput: groupFilterInput,
        onGroupInputChange: onGroupInputChange,
        clearGroupFilterInput: clearGroupFilterInput,
        filterOptionsIdentity: filterOptionsIdentity
    };
}


const $f87a33808adf1904$export$c01d600c4cc28201 = ({ addCalendarDialogOpen: addCalendarDialogOpen, setAddCalendarDialogOpen: setAddCalendarDialogOpen, setFetchingCalendarData: setFetchingCalendarData, calendarData: calendarData, setCalendarData: setCalendarData, setCalendarAlerts: setCalendarAlerts, calendarsSearchString: calendarsSearchString, navigate: navigate })=>{
    const parentAccounts = JSON.parse(localStorage?.parentAccounts || "[]");
    const parentNames = new Map();
    parentAccounts.forEach((object)=>{
        parentNames.set(object.id, object.name);
    });
    const [newCalendarInfo, setNewCalendarInfo] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        group: "",
        name: ""
    });
    const { filteredGroupOptions: filteredGroupOptions, groupFilterInput: groupFilterInput, onGroupInputChange: onGroupInputChange, clearGroupFilterInput: clearGroupFilterInput, filterOptionsIdentity: filterOptionsIdentity } = (0, $d6c6d44336954ff6$export$5fb577f2a1fa696b)(parentAccounts, newCalendarInfo.group);
    const prevDialogOpenRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (addCalendarDialogOpen && !prevDialogOpenRef.current) clearGroupFilterInput();
        prevDialogOpenRef.current = addCalendarDialogOpen;
    }, [
        addCalendarDialogOpen,
        clearGroupFilterInput
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: addCalendarDialogOpen,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "add-calendar",
                children: "Add Calendar"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                sx: {
                    width: 450,
                    height: 375
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                        disablePortal: true,
                        options: filteredGroupOptions,
                        inputValue: groupFilterInput,
                        onInputChange: onGroupInputChange,
                        filterOptions: filterOptionsIdentity,
                        getOptionLabel: (option)=>option.name || "",
                        isOptionEqualToValue: (option, value)=>value != null && String(option.id) === String(value.id),
                        value: newCalendarInfo.group !== "" && newCalendarInfo.group != null ? {
                            id: Number(newCalendarInfo.group),
                            name: parentNames.get(Number(newCalendarInfo.group)),
                            index: parentAccounts.findIndex((obj)=>obj.id === Number(newCalendarInfo.group))
                        } : null,
                        onChange: (event, value)=>{
                            if (value == null) clearGroupFilterInput();
                            setNewCalendarInfo((previousState)=>({
                                    ...previousState,
                                    group: value?.id ?? ""
                                }));
                        },
                        sx: {
                            width: 350
                        },
                        renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                ...params,
                                variant: "standard",
                                label: "Group",
                                autoComplete: "off",
                                id: "group_name",
                                name: "group_name"
                            })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: "sureview_subject",
                        variant: "standard",
                        label: "Calendar Name",
                        value: newCalendarInfo.name,
                        onChange: (event)=>{
                            setNewCalendarInfo((previousState)=>{
                                return {
                                    ...previousState,
                                    name: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "350px"
                        },
                        helperText: "",
                        type: "string"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setAddCalendarDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setFetchingCalendarData(true);
                            setAddCalendarDialogOpen(false);
                            (0, $c258fcc72f32e147$export$b020ff7444736758)(newCalendarInfo, setFetchingCalendarData, calendarData, setCalendarData, setCalendarAlerts, calendarsSearchString, navigate);
                        },
                        text: "Submit",
                        disabled: !newCalendarInfo.group || !newCalendarInfo.name
                    })
                ]
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $3QMQN = parcelRequire("3QMQN");
parcelRequire("8T3gX");
const $1556ab6cd5f885f9$export$7267526df49a36d = ({ calendarAlerts: calendarAlerts, setCalendarAlerts: setCalendarAlerts })=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            calendarAlerts.addCalendarSuccess && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                onClose: ()=>{
                    setCalendarAlerts((previousState)=>{
                        return {
                            ...previousState,
                            addCalendarSuccess: false
                        };
                    });
                },
                children: `Calendar ${localStorage.newCalendarName} added successfully.`
            }),
            calendarAlerts.deleteCalendarSuccess && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                onClose: ()=>{
                    setCalendarAlerts((previousState)=>{
                        return {
                            ...previousState,
                            deleteCalendarSuccess: false
                        };
                    });
                },
                children: `Calendar ${localStorage.newCalendarName} deleted successfully.`
            }),
            calendarAlerts.addSitesToCalendarSuccess && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                onClose: ()=>{
                    setCalendarAlerts((previousState)=>{
                        return {
                            ...previousState,
                            addSitesToCalendarSuccess: false
                        };
                    });
                },
                children: `Sites for Calendar ${localStorage.newCalendarName} have been updated successfully.`
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $654adca1cae3f613$export$aecfb2a65261932e = (calendarID, setFetchingCalendarData, calendarData, setCalendarData, setCalendarAlerts, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $654adca1cae3f613$export$aecfb2a65261932e(calendarID, setFetchingCalendarData, calendarData, setCalendarData, setCalendarAlerts, navigate);
    };
    AxiosUI.delete(`calendar/${calendarID}/`).then((response)=>{
        setCalendarData(calendarData.filter((obj)=>obj.id !== calendarID));
        localStorage.setItem("newCalendarName", response.data.name);
        setCalendarAlerts((previousState)=>{
            return {
                ...previousState,
                deleteCalendarSuccess: true,
                addCalendarSuccess: false,
                setCalendarAlerts: false
            };
        });
        setFetchingCalendarData(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Error deleting calendar, please try again");
            setFetchingCalendarData(false);
        });
    });
};


const $19a4b96ed2baaa31$export$c00c7f1155c19f2 = ({ deleteCalendarDialogOpen: deleteCalendarDialogOpen, setDeleteCalendarDialogOpen: setDeleteCalendarDialogOpen, deletedCalendarId: deletedCalendarId, setFetchingCalendarData: setFetchingCalendarData, calendarData: calendarData, setCalendarData: setCalendarData, setCalendarAlerts: setCalendarAlerts, navigate: navigate })=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: deleteCalendarDialogOpen,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: " Are you sure you want to delete this Calendar?"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setDeleteCalendarDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setFetchingCalendarData(true);
                            setDeleteCalendarDialogOpen(false);
                            (0, $654adca1cae3f613$export$aecfb2a65261932e)(deletedCalendarId, setFetchingCalendarData, calendarData, setCalendarData, setCalendarAlerts, navigate);
                        },
                        text: "Delete Calendar",
                        disabled: false
                    })
                ]
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $ce8iU = parcelRequire("ce8iU");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $5f8f0229c5318daf$export$d0475cbc95bc8880 = (rowIndex, calendarId, groupName, patchObject, calendarData, setCalendarData, setCalendarAlerts, setSelectedRow, setEditingCalendar, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $5f8f0229c5318daf$export$d0475cbc95bc8880(rowIndex, calendarId, groupName, patchObject, calendarData, setCalendarData, setCalendarAlerts, setSelectedRow, setEditingCalendar, navigate);
    };
    AxiosUI.patch(`calendar/${calendarId}/`, patchObject).then(()=>{
        AxiosUI.get(`calendar/${calendarId}/`).then((response)=>{
            setCalendarData((prevState)=>{
                const newState = [
                    ...prevState
                ];
                newState[rowIndex] = response.data;
                return newState;
            });
            setSelectedRow(response.data);
            setEditingCalendar(false);
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                setEditingCalendar(false);
            });
        });
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Error updating calendar, please try again");
            setEditingCalendar(false);
        });
    });
};



const $e3bdc878ca00cde0$export$a74917dc66a33a41 = ({ selectedRow: selectedRow, editCalendarDialogOpen: editCalendarDialogOpen, setEditCalendarDialogOpen: setEditCalendarDialogOpen, calendarData: calendarData, setCalendarData: setCalendarData, setCalendarAlerts: setCalendarAlerts, rowIndex: rowIndex, setSelectedRow: setSelectedRow, setEditingCalendar: setEditingCalendar, navigate: navigate })=>{
    const parentAccounts = JSON.parse(localStorage?.parentAccounts || "[]");
    const parentNames = new Map();
    parentAccounts.forEach((object)=>{
        parentNames.set(object.id, object.name);
    });
    const [changesMade, setChangesMade] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [updatedCalendarInfo, setUpdatedCalendarInfo] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        group: selectedRow.group.id,
        name: selectedRow.name
    });
    const { filteredGroupOptions: filteredGroupOptions, groupFilterInput: groupFilterInput, onGroupInputChange: onGroupInputChange, clearGroupFilterInput: clearGroupFilterInput, filterOptionsIdentity: filterOptionsIdentity } = (0, $d6c6d44336954ff6$export$5fb577f2a1fa696b)(parentAccounts, updatedCalendarInfo.group);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: editCalendarDialogOpen,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "add-calendar",
                children: "Edit Calendar"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                sx: {
                    width: 450,
                    height: 375
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        variant: "standard",
                        label: "Calendar Name",
                        value: updatedCalendarInfo.name,
                        onChange: (event)=>{
                            setChangesMade(true);
                            setUpdatedCalendarInfo((previousState)=>{
                                return {
                                    ...previousState,
                                    name: event.target.value
                                };
                            });
                        },
                        sx: {
                            width: "350px"
                        },
                        helperText: "",
                        type: "string"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                        disablePortal: true,
                        options: filteredGroupOptions,
                        inputValue: groupFilterInput,
                        onInputChange: onGroupInputChange,
                        filterOptions: filterOptionsIdentity,
                        getOptionLabel: (option)=>option.name || "",
                        isOptionEqualToValue: (option, value)=>value != null && String(option.id) === String(value.id),
                        value: updatedCalendarInfo.group !== "" && updatedCalendarInfo.group != null ? {
                            id: Number(updatedCalendarInfo.group),
                            name: parentNames.get(Number(updatedCalendarInfo.group)),
                            index: parentAccounts.findIndex((obj)=>obj.id === Number(updatedCalendarInfo.group))
                        } : null,
                        onChange: (event, value)=>{
                            setChangesMade(true);
                            if (value == null) clearGroupFilterInput();
                            setUpdatedCalendarInfo((previousState)=>({
                                    ...previousState,
                                    group: value?.id ?? ""
                                }));
                        },
                        sx: {
                            width: 350
                        },
                        renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                ...params,
                                variant: "standard",
                                label: "Group",
                                autoComplete: "off",
                                id: "group_name",
                                name: "group_name"
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setEditCalendarDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setEditCalendarDialogOpen(false);
                            setEditingCalendar(true);
                            (0, $5f8f0229c5318daf$export$d0475cbc95bc8880)(rowIndex, selectedRow.id, selectedRow.group.name, updatedCalendarInfo, calendarData, setCalendarData, setCalendarAlerts, setSelectedRow, setEditingCalendar, navigate);
                        },
                        text: "Submit",
                        disabled: !changesMade
                    })
                ]
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $djxj8 = parcelRequire("djxj8");
var $kUcVg = parcelRequire("kUcVg");
var $887xF = parcelRequire("887xF");
var $1TOOV = parcelRequire("1TOOV");
var $iLEpm = parcelRequire("iLEpm");
var $ce8iU = parcelRequire("ce8iU");
var $cVCJe = parcelRequire("cVCJe");

var $kCUgG = parcelRequire("kCUgG");

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $26cdd = parcelRequire("26cdd");

var $bPpmJ = parcelRequire("bPpmJ");

var $aBrLz = parcelRequire("aBrLz");

var $lkMit = parcelRequire("lkMit");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $hhKOZ = parcelRequire("hhKOZ");

var $9ogDZ = parcelRequire("9ogDZ");

var $a9NOs = parcelRequire("a9NOs");

var $11ydL = parcelRequire("11ydL");

var $dZfqJ = parcelRequire("dZfqJ");

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $75222183862859fd$export$5682c366c0c669d9(slot) {
    return (0, $kfTYv.default)('MuiListItem', slot);
}
const $75222183862859fd$var$listItemClasses = (0, $jh2Zm.default)('MuiListItem', [
    'root',
    'container',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'padding',
    'button',
    'secondaryAction',
    'selected'
]);
var $75222183862859fd$export$2e2bcd8739ae039 = $75222183862859fd$var$listItemClasses;




var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $dZfqJ = parcelRequire("dZfqJ");

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $d3f3c8da526624d3$export$ccdb26aeba48a86e(slot) {
    return (0, $kfTYv.default)('MuiListItemSecondaryAction', slot);
}
const $d3f3c8da526624d3$var$listItemSecondaryActionClasses = (0, $jh2Zm.default)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var $d3f3c8da526624d3$export$2e2bcd8739ae039 = $d3f3c8da526624d3$var$listItemSecondaryActionClasses;



var $k4ank = parcelRequire("k4ank");
'use client';
const $3248c788ef1839dd$var$_excluded = [
    "className"
];
const $3248c788ef1839dd$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $d3f3c8da526624d3$export$ccdb26aeba48a86e), classes);
};
const $3248c788ef1839dd$var$ListItemSecondaryActionRoot = (0, $anJSP.default)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({
        position: 'absolute',
        right: 16,
        top: '50%',
        transform: 'translateY(-50%)'
    }, ownerState.disableGutters && {
        right: 0
    }));
/**
 * Must be used as the last child of ListItem to function properly.
 */ const $3248c788ef1839dd$var$ListItemSecondaryAction = /*#__PURE__*/ $8T3gX.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className: className } = props, other = (0, $fAJB5.default)(props, $3248c788ef1839dd$var$_excluded);
    const context = $8T3gX.useContext((0, $dZfqJ.default));
    const ownerState = (0, $eJfrs.default)({}, props, {
        disableGutters: context.disableGutters
    });
    const classes = $3248c788ef1839dd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsx)($3248c788ef1839dd$var$ListItemSecondaryActionRoot, (0, $eJfrs.default)({
        className: (0, $iVyaN.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$3248c788ef1839dd$var$ListItemSecondaryAction.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component, normally an `IconButton` or selection control.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
$3248c788ef1839dd$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $3248c788ef1839dd$export$2e2bcd8739ae039 = $3248c788ef1839dd$var$ListItemSecondaryAction;



var $k4ank = parcelRequire("k4ank");
'use client';
const $95031c517ca80bec$var$_excluded = [
    "className"
], $95031c517ca80bec$var$_excluded2 = [
    "alignItems",
    "autoFocus",
    "button",
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "ContainerComponent",
    "ContainerProps",
    "dense",
    "disabled",
    "disableGutters",
    "disablePadding",
    "divider",
    "focusVisibleClassName",
    "secondaryAction",
    "selected",
    "slotProps",
    "slots"
];
const $95031c517ca80bec$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.button && styles.button,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $95031c517ca80bec$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, button: button, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction, selected: selected } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            disabled && 'disabled',
            button && 'button',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction',
            selected && 'selected'
        ],
        container: [
            'container'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $75222183862859fd$export$5682c366c0c669d9), classes);
};
const $95031c517ca80bec$export$aed538f7519abe89 = (0, $anJSP.default)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver: $95031c517ca80bec$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left'
    }, !ownerState.disablePadding && (0, $eJfrs.default)({
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, !!ownerState.secondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }), !!ownerState.secondaryAction && {
        [`& > .${(0, $1c87a964daab329d$export$2e2bcd8739ae039).root}`]: {
            paddingRight: 48
        }
    }, {
        [`&.${(0, $75222183862859fd$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $75222183862859fd$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $aBrLz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $75222183862859fd$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $aBrLz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $75222183862859fd$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.alignItems === 'flex-start' && {
        alignItems: 'flex-start'
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, ownerState.button && {
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $75222183862859fd$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $aBrLz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $aBrLz.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }, ownerState.hasSecondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }));
const $95031c517ca80bec$var$ListItemContainer = (0, $anJSP.default)('li', {
    name: 'MuiListItem',
    slot: 'Container',
    overridesResolver: (props, styles)=>styles.container
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $95031c517ca80bec$var$ListItem = /*#__PURE__*/ $8T3gX.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems: alignItems = 'center', autoFocus: autoFocus = false, button: button = false, children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = 'li', ContainerProps: { className: ContainerClassName } = {}, dense: dense = false, disabled: disabled = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, secondaryAction: secondaryAction, selected: selected = false, slotProps: slotProps = {}, slots: slots = {} } = props, ContainerProps = (0, $fAJB5.default)(props.ContainerProps, $95031c517ca80bec$var$_excluded), other = (0, $fAJB5.default)(props, $95031c517ca80bec$var$_excluded2);
    const context = $8T3gX.useContext((0, $dZfqJ.default));
    const childContext = $8T3gX.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $8T3gX.useRef(null);
    (0, $a9NOs.default)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
            else console.error('MUI: Unable to set focus to a ListItem whose component has not been rendered.');
        }
    }, [
        autoFocus
    ]);
    const children = $8T3gX.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v5, will be removed in v6
    const hasSecondaryAction = children.length && (0, $9ogDZ.default)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = (0, $eJfrs.default)({}, props, {
        alignItems: alignItems,
        autoFocus: autoFocus,
        button: button,
        dense: childContext.dense,
        disabled: disabled,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction,
        selected: selected
    });
    const classes = $95031c517ca80bec$var$useUtilityClasses(ownerState);
    const handleRef = (0, $11ydL.default)(listItemRef, ref);
    const Root = slots.root || components.Root || $95031c517ca80bec$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = (0, $eJfrs.default)({
        className: (0, $iVyaN.default)(classes.root, rootProps.className, className),
        disabled: disabled
    }, other);
    let Component = componentProp || 'li';
    if (button) {
        componentProps.component = componentProp || 'div';
        componentProps.focusVisibleClassName = (0, $iVyaN.default)((0, $75222183862859fd$export$2e2bcd8739ae039).focusVisible, focusVisibleClassName);
        Component = (0, $hhKOZ.default);
    }
    // v4 implementation, deprecated in v5, will be removed in v6
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, $k4ank.jsx)((0, $dZfqJ.default).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $k4ank.jsxs)($95031c517ca80bec$var$ListItemContainer, (0, $eJfrs.default)({
                as: ContainerComponent,
                className: (0, $iVyaN.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)(Root, (0, $eJfrs.default)({}, rootProps, !(0, $lkMit.default)(Root) && {
                        as: Component,
                        ownerState: (0, $eJfrs.default)({}, ownerState, rootProps.ownerState)
                    }, componentProps, {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $dZfqJ.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $k4ank.jsxs)(Root, (0, $eJfrs.default)({}, rootProps, {
            as: Component,
            ref: handleRef
        }, !(0, $lkMit.default)(Root) && {
            ownerState: (0, $eJfrs.default)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3248c788ef1839dd$export$2e2bcd8739ae039), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
$95031c517ca80bec$var$ListItem.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Defines the `align-items` style property.
   * @default 'center'
   */ alignItems: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'center',
        'flex-start'
    ]),
    /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the list item is a button (using `ButtonBase`). Props intended
   * for `ButtonBase` can then be applied to `ListItem`.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */ button: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */ children: (0, $bPpmJ.default)((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node, (props)=>{
        const children = $8T3gX.Children.toArray(props.children);
        // React.Children.toArray(props.children).findLastIndex(isListItemSecondaryAction)
        let secondaryActionIndex = -1;
        for(let i = children.length - 1; i >= 0; i -= 1){
            const child = children[i];
            if ((0, $9ogDZ.default)(child, [
                'ListItemSecondaryAction'
            ])) {
                secondaryActionIndex = i;
                break;
            }
        }
        //  is ListItemSecondaryAction the last child of ListItem
        if (secondaryActionIndex !== -1 && secondaryActionIndex !== children.length - 1) return new Error("MUI: You used an element after ListItemSecondaryAction. For ListItem to detect that it has a secondary action you must pass it as the last child to ListItem.");
        return null;
    }),
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        Root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    }),
    /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   * @default 'li'
   * @deprecated
   */ ContainerComponent: (0, $26cdd.default),
    /**
   * Props applied to the container component if used.
   * @default {}
   * @deprecated
   */ ContainerProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */ dense: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the component is disabled.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the left and right padding is removed.
   * @default false
   */ disableGutters: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, all padding is removed.
   * @default false
   */ disablePadding: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */ divider: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * @ignore
   */ focusVisibleClassName: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The element to display at the end of ListItem.
   */ secondaryAction: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Use to apply selected styling.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */ selected: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    }),
    /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        root: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $95031c517ca80bec$export$2e2bcd8739ae039 = $95031c517ca80bec$var$ListItem;






var $kbChx = parcelRequire("kbChx");

var $iKAtE = parcelRequire("iKAtE");

var $433j1 = parcelRequire("433j1");

var $8jTCz = parcelRequire("8jTCz");

var $60vL1 = parcelRequire("60vL1");
// eslint-disable-next-line @typescript-eslint/no-unused-vars
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $27fa563d59549059$export$6b28e0ddc2fe699b = (id, navigate, setSiteOptions, setLoadingSites)=>{
    setLoadingSites(true);
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $27fa563d59549059$export$6b28e0ddc2fe699b(id, navigate, setSiteOptions, setLoadingSites);
    };
    AxiosUI.get(`customer/names/${id}/`).then((response)=>{
        const sites = Array.isArray(response.data) ? response.data : response.data?.results ?? [];
        setSiteOptions(sites);
        setLoadingSites(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Error retrieving sites. Please try again");
            setLoadingSites(false);
        });
    });
};


parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
/**
 * Keep only the sites the dialog actually lists. A calendar's saved site list
 * can hold sites that were later deleted or moved out of the calendar's group;
 * they never appear in the dialog, so they can't be unticked, and the apply
 * endpoint rejects the whole save if any listed site is outside the group
 * (SUP-908 / ENG-2495). Select All already dropped them; individual ticks
 * didn't.
 */ const $58fc26749b76916b$export$a13eb28d9cfcb4e2 = (assignedSites, siteOptions)=>{
    const listed = new Set(siteOptions.map((site)=>site.id));
    return assignedSites.filter((id)=>listed.has(id));
};
const $58fc26749b76916b$var$firstMessage = (value)=>{
    if (typeof value === "string" && value) return value;
    if (Array.isArray(value) && typeof value[0] === "string") return value[0];
    return null;
};
const $58fc26749b76916b$export$b1c3200330a57ee0 = (reason)=>{
    const data = reason?.response?.data;
    const detail = $58fc26749b76916b$var$firstMessage(data?.non_field_errors) ?? $58fc26749b76916b$var$firstMessage(data?.customer) ?? $58fc26749b76916b$var$firstMessage(data?.detail);
    return detail ? `Error updating calendar sites: ${detail}` : "Error updating calendar sites, please try again";
};


const $785b016028c0945c$export$75cd69fcdf7a92fd = (selectedRow, sitesArray, setUpdatingSites, setAssignedSitesDialogOpen, setCalendarAlerts, setCalendarData, calendarData, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $785b016028c0945c$export$75cd69fcdf7a92fd(selectedRow, sitesArray, setUpdatingSites, setAssignedSitesDialogOpen, setCalendarAlerts, setCalendarData, calendarData, navigate);
    };
    AxiosUI.post(`calendar/${selectedRow.id}/apply/`, {
        customer: sitesArray
    }).then(()=>{
        localStorage.setItem("newCalendarName", selectedRow.name);
        const updatedCalendarData = calendarData.filter((obj)=>obj.id !== selectedRow.id);
        const updatedRow = selectedRow;
        updatedRow.customer = sitesArray;
        updatedCalendarData.push(updatedRow);
        setCalendarData(updatedCalendarData);
        setCalendarAlerts((previousState)=>{
            return {
                ...previousState,
                deleteCalendarSuccess: false,
                addCalendarSuccess: false,
                addSitesToCalendarSuccess: true
            };
        });
        setUpdatingSites(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert((0, $58fc26749b76916b$export$b1c3200330a57ee0)(reason));
            setUpdatingSites(false);
        });
    });
};



const $ab30e3a15ec24906$export$5cce3d735af8dc2c = ({ groupId: groupId, siteArray: siteArray, assignedSitesDialogOpen: assignedSitesDialogOpen, setAssignedSitesDialogOpen: setAssignedSitesDialogOpen, setUpdatingSites: setUpdatingSites, selectedRow: selectedRow, setCalendarAlerts: setCalendarAlerts, setCalendarData: setCalendarData, calendarData: calendarData, Transition: Transition, navigate: navigate })=>{
    const [assignedSites, setAssignedSites] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(siteArray);
    const [changesMade, setChangesMade] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [siteOptions, setSiteOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [loadingSites, setLoadingSites] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [saveChangesDialogOpen, setSaveChangesDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const siteIds = new Map();
    const siteNames = new Map();
    const allSiteIds = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        (0, $27fa563d59549059$export$6b28e0ddc2fe699b)(groupId, navigate, setSiteOptions, setLoadingSites);
        siteOptions.forEach((object)=>{
            allSiteIds.push(object.id);
            siteIds.set(object.name, object.id);
            siteNames.set(object.id, object.name);
        });
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            saveChangesDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $djxj8.default), {
                sx: {
                    color: "#fff",
                    zIndex: (theme)=>theme.zIndex.drawer + 1
                },
                open: saveChangesDialogOpen
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $djxj8.default), {
                sx: {
                    color: "#fff",
                    zIndex: (theme)=>theme.zIndex.drawer + 1
                },
                open: saveChangesDialogOpen,
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                    open: saveChangesDialogOpen,
                    TransitionComponent: Transition,
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: "You have made changes to selected sites, would you like to save these changes?"
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    onClick: ()=>{
                                        setSaveChangesDialogOpen(false);
                                        setAssignedSitesDialogOpen(false);
                                    },
                                    text: "Don't Save",
                                    disabled: false
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    onClick: ()=>{
                                        setUpdatingSites(true);
                                        setSaveChangesDialogOpen(false);
                                        setAssignedSitesDialogOpen(false);
                                        (0, $785b016028c0945c$export$75cd69fcdf7a92fd)(selectedRow, (0, $58fc26749b76916b$export$a13eb28d9cfcb4e2)(assignedSites, siteOptions), setUpdatingSites, setAssignedSitesDialogOpen, setCalendarAlerts, setCalendarData, calendarData, navigate);
                                    },
                                    text: "Save Changes",
                                    disabled: false
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                open: assignedSitesDialogOpen,
                TransitionComponent: Transition,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                                id: "edit-event",
                                sx: {
                                    font: "mulish"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "font-mulish",
                                    children: "Assigned Sites"
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                title: "Close Screen",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                    "aria-label": "close",
                                    onClick: ()=>{
                                        changesMade ? setSaveChangesDialogOpen(true) : setAssignedSitesDialogOpen(false);
                                    },
                                    sx: {
                                        position: "absolute",
                                        right: 8,
                                        top: 8,
                                        color: (theme)=>theme.palette.grey[500]
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                                sx: {
                                    width: 500,
                                    height: 500
                                },
                                children: [
                                    loadingSites && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "absolute top-[270] left-[230]",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {})
                                    }),
                                    !loadingSites && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "font-mulish",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kCUgG.default), {
                                            sx: {
                                                width: "100%",
                                                maxWidth: 460,
                                                maxHeight: 400,
                                                bgcolor: "background.paper"
                                            },
                                            children: siteOptions.map((site)=>{
                                                return /*#__PURE__*/ (0, $k4ank.jsx)((0, $95031c517ca80bec$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $07bcecd6345c33ee$export$2e2bcd8739ae039), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $fc0c7440c238b2e1$export$2e2bcd8739ae039), {
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                                    edge: "start",
                                                                    checked: assignedSites.includes(site.id),
                                                                    tabIndex: -1,
                                                                    disableRipple: true,
                                                                    onChange: (event, checked)=>{
                                                                        setChangesMade(true);
                                                                        if (checked) setAssignedSites([
                                                                            ...assignedSites,
                                                                            site.id
                                                                        ]);
                                                                        else setAssignedSites(assignedSites.filter((number)=>number !== site.id));
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $a7d6d1bc115c33d6$export$2e2bcd8739ae039), {
                                                                primaryTypographyProps: {
                                                                    fontFamily: "Mulish"
                                                                },
                                                                id: site.name,
                                                                primary: `${site.name}`
                                                            })
                                                        ]
                                                    })
                                                }, site.id);
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    onClick: ()=>{
                                        setUpdatingSites(true);
                                        setAssignedSitesDialogOpen(false);
                                        (0, $785b016028c0945c$export$75cd69fcdf7a92fd)(selectedRow, (0, $58fc26749b76916b$export$a13eb28d9cfcb4e2)(assignedSites, siteOptions), setUpdatingSites, setAssignedSitesDialogOpen, setCalendarAlerts, setCalendarData, calendarData, navigate);
                                    },
                                    text: "Save",
                                    disabled: !changesMade
                                })
                            })
                        ]
                    }),
                    !loadingSites && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "absolute left-[12px] top-[55px] font-bold font-mulish bg-white h-[50px] w-[600px]",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                onChange: (event, checked)=>{
                                    setChangesMade(true);
                                    const allSiteIds = [];
                                    siteOptions.forEach((object)=>{
                                        allSiteIds.push(object.id);
                                    });
                                    if (checked) setAssignedSites(allSiteIds);
                                    else setAssignedSites([]);
                                }
                            }),
                            "Select All"
                        ]
                    })
                ]
            })
        ]
    });
};



var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $8zaeI = parcelRequire("8zaeI");

var $bPpmJ = parcelRequire("bPpmJ");

var $535LO = parcelRequire("535LO");

var $evygD = parcelRequire("evygD");

var $jphfx = parcelRequire("jphfx");

var $7dYD9 = parcelRequire("7dYD9");

var $11ydL = parcelRequire("11ydL");

var $4nWZ9 = parcelRequire("4nWZ9");

var $9Pc8j = parcelRequire("9Pc8j");

var $6aDoo = parcelRequire("6aDoo");

var $k4ank = parcelRequire("k4ank");
'use client';
const $212a5a6a44b7f18e$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "container",
    "direction",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $212a5a6a44b7f18e$var$getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, $6aDoo.default)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        const transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === 'left') {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === 'right') {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === 'up') {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function $212a5a6a44b7f18e$var$resolveContainer(containerPropProp) {
    return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}
function $212a5a6a44b7f18e$export$f820ccdc5b48abdf(direction, node, containerProp) {
    const resolvedContainer = $212a5a6a44b7f18e$var$resolveContainer(containerProp);
    const transform = $212a5a6a44b7f18e$var$getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $212a5a6a44b7f18e$var$Slide = /*#__PURE__*/ $8T3gX.forwardRef(function Slide(props, ref) {
    const theme = (0, $4nWZ9.default)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, container: containerProp, direction: direction = 'down', easing: easingProp = defaultEasing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $8zaeI.default) } = props, other = (0, $fAJB5.default)(props, $212a5a6a44b7f18e$var$_excluded);
    const childrenRef = $8T3gX.useRef(null);
    const handleRef = (0, $11ydL.default)((0, $jphfx.default)(children), childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        $212a5a6a44b7f18e$export$f820ccdc5b48abdf(direction, node, containerProp);
        (0, $9Pc8j.reflow)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, $9Pc8j.getTransitionProps)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, $eJfrs.default)({}, transitionProps));
        node.style.transition = theme.transitions.create('transform', (0, $eJfrs.default)({}, transitionProps));
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $9Pc8j.getTransitionProps)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        $212a5a6a44b7f18e$export$f820ccdc5b48abdf(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = $8T3gX.useCallback(()=>{
        if (childrenRef.current) $212a5a6a44b7f18e$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    $8T3gX.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        const handleResize = (0, $7dYD9.default)(()=>{
            if (childrenRef.current) $212a5a6a44b7f18e$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, $6aDoo.default)(childrenRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    $8T3gX.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsx)(TransitionComponent, (0, $eJfrs.default)({
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $8T3gX.cloneElement(children, (0, $eJfrs.default)({
                ref: handleRef,
                style: (0, $eJfrs.default)({
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, style, children.props.style)
            }, childProps));
        }
    }));
});
$212a5a6a44b7f18e$var$Slide.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */ addEndListener: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */ appear: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * A single child content element.
   */ children: (0, $evygD.default).isRequired,
    /**
   * An HTML element, or a function that returns one.
   * It's used to set the container the Slide is transitioning from.
   */ container: (0, $bPpmJ.default)((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, $535LO.default),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func
    ]), (props)=>{
        if (props.open) {
            const resolvedContainer = $212a5a6a44b7f18e$var$resolveContainer(props.container);
            if (resolvedContainer && resolvedContainer.nodeType === 1) {
                const box = resolvedContainer.getBoundingClientRect();
                if (box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) return new Error([
                    'MUI: The `container` prop provided to the component is invalid.',
                    'The anchor element should be part of the document layout.',
                    "Make sure the element is present in the document or that it's not display none."
                ].join('\n'));
            } else if (!resolvedContainer || typeof resolvedContainer.getBoundingClientRect !== 'function' || resolvedContainer.contextElement != null && resolvedContainer.contextElement.nodeType !== 1) return new Error([
                'MUI: The `container` prop provided to the component is invalid.',
                'It should be an HTML element instance.'
            ].join('\n'));
        }
        return null;
    }),
    /**
   * Direction the child node will enter from.
   * @default 'down'
   */ direction: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'down',
        'left',
        'right',
        'up'
    ]),
    /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   * @default {
   *   enter: theme.transitions.easing.easeOut,
   *   exit: theme.transitions.easing.sharp,
   * }
   */ easing: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ]),
    /**
   * If `true`, the component will transition in.
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * @ignore
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * @ignore
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */ timeout: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number
        })
    ])
};
var $212a5a6a44b7f18e$export$2e2bcd8739ae039 = $212a5a6a44b7f18e$var$Slide;



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");

const $73e68071618006e3$var$StepOneAddCalendar = ({ newCalendarInfo: newCalendarInfo, setNewCalendarInfo: setNewCalendarInfo, parentAccounts: parentAccounts, parentNames: parentNames, navigate: navigate, setSiteOptions: setSiteOptions, setLoadingSites: setLoadingSites })=>{
    const [updatedCalendarInfo, setUpdatedCalendarInfo] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(newCalendarInfo);
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: "absolute top-[160px] left-[30px]",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                    disablePortal: true,
                    options: parentAccounts[0] ? parentAccounts.map((object, index)=>({
                            id: object.id,
                            name: object.name,
                            index: index
                        })) : [],
                    getOptionLabel: (option)=>option.name || "",
                    isOptionEqualToValue: (option, value)=>option.id === value.id,
                    value: parentNames.get(updatedCalendarInfo.group),
                    onChange: (event, newInputValue)=>{
                        if (!newInputValue?.id) return;
                        (0, $27fa563d59549059$export$6b28e0ddc2fe699b)(newInputValue.id, navigate, setSiteOptions, setLoadingSites);
                        setUpdatedCalendarInfo((previousState)=>{
                            return {
                                ...previousState,
                                group: newInputValue.id
                            };
                        });
                        setNewCalendarInfo((previousState)=>{
                            return {
                                ...previousState,
                                group: newInputValue.id
                            };
                        });
                    },
                    sx: {
                        width: 350
                    },
                    renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                            ...params,
                            variant: "standard",
                            label: "Group",
                            autoComplete: "off",
                            id: "group_name",
                            name: "group_name"
                        }),
                    renderOption: (props, option)=>/*#__PURE__*/ (0, $8T3gX.createElement)("li", {
                            ...props,
                            key: option.id
                        }, option.name)
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    id: "sureview_subject",
                    variant: "standard",
                    label: "Calendar Name",
                    value: updatedCalendarInfo.name,
                    onChange: (event)=>{
                        setUpdatedCalendarInfo((previousState)=>{
                            return {
                                ...previousState,
                                name: event.target.value
                            };
                        });
                        setNewCalendarInfo((previousState)=>{
                            return {
                                ...previousState,
                                name: event.target.value
                            };
                        });
                    },
                    sx: {
                        width: "350px"
                    },
                    helperText: "",
                    type: "string"
                })
            ]
        })
    });
};
var $73e68071618006e3$export$2e2bcd8739ae039 = $73e68071618006e3$var$StepOneAddCalendar;



var $b9p11 = parcelRequire("b9p11");

var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $97LlG = parcelRequire("97LlG");

var $aYNpO = parcelRequire("aYNpO");

var $8T3gX = parcelRequire("8T3gX");
/**
 * Provides information about the current step in Stepper.
 */ const $b2d36598fb605cb3$var$StepperContext = /*#__PURE__*/ $8T3gX.createContext({});
$b2d36598fb605cb3$var$StepperContext.displayName = 'StepperContext';
function $b2d36598fb605cb3$export$1ff9b16b13b0447() {
    return $8T3gX.useContext($b2d36598fb605cb3$var$StepperContext);
}
var $b2d36598fb605cb3$export$2e2bcd8739ae039 = $b2d36598fb605cb3$var$StepperContext;



var $8T3gX = parcelRequire("8T3gX");
/**
 * Provides information about the current step in Stepper.
 */ const $dd58c99e27d1f71f$var$StepContext = /*#__PURE__*/ $8T3gX.createContext({});
$dd58c99e27d1f71f$var$StepContext.displayName = 'StepContext';
function $dd58c99e27d1f71f$export$90d5f24cfecec416() {
    return $8T3gX.useContext($dd58c99e27d1f71f$var$StepContext);
}
var $dd58c99e27d1f71f$export$2e2bcd8739ae039 = $dd58c99e27d1f71f$var$StepContext;



var $7AQZl = parcelRequire("7AQZl");

var $anJSP = parcelRequire("anJSP");

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $97c4751241937f27$export$8977e0f3c012cfac(slot) {
    return (0, $kfTYv.default)('MuiStep', slot);
}
const $97c4751241937f27$var$stepClasses = (0, $jh2Zm.default)('MuiStep', [
    'root',
    'horizontal',
    'vertical',
    'alternativeLabel',
    'completed'
]);
var $97c4751241937f27$export$2e2bcd8739ae039 = $97c4751241937f27$var$stepClasses;



var $k4ank = parcelRequire("k4ank");
'use client';
const $4238740b0329aed2$var$_excluded = [
    "active",
    "children",
    "className",
    "component",
    "completed",
    "disabled",
    "expanded",
    "index",
    "last"
];
const $4238740b0329aed2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, alternativeLabel: alternativeLabel, completed: completed } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            alternativeLabel && 'alternativeLabel',
            completed && 'completed'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $97c4751241937f27$export$8977e0f3c012cfac), classes);
};
const $4238740b0329aed2$var$StepRoot = (0, $anJSP.default)('div', {
    name: 'MuiStep',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.completed && styles.completed
        ];
    }
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({}, ownerState.orientation === 'horizontal' && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.alternativeLabel && {
        flex: 1,
        position: 'relative'
    }));
const $4238740b0329aed2$var$Step = /*#__PURE__*/ $8T3gX.forwardRef(function Step(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiStep'
    });
    const { active: activeProp, children: children, className: className, component: component = 'div', completed: completedProp, disabled: disabledProp, expanded: expanded = false, index: index, last: last } = props, other = (0, $fAJB5.default)(props, $4238740b0329aed2$var$_excluded);
    const { activeStep: activeStep, connector: connector, alternativeLabel: alternativeLabel, orientation: orientation, nonLinear: nonLinear } = $8T3gX.useContext((0, $b2d36598fb605cb3$export$2e2bcd8739ae039));
    let [active = false, completed = false, disabled = false] = [
        activeProp,
        completedProp,
        disabledProp
    ];
    if (activeStep === index) active = activeProp !== undefined ? activeProp : true;
    else if (!nonLinear && activeStep > index) completed = completedProp !== undefined ? completedProp : true;
    else if (!nonLinear && activeStep < index) disabled = disabledProp !== undefined ? disabledProp : true;
    const contextValue = $8T3gX.useMemo(()=>({
            index: index,
            last: last,
            expanded: expanded,
            icon: index + 1,
            active: active,
            completed: completed,
            disabled: disabled
        }), [
        index,
        last,
        expanded,
        active,
        completed,
        disabled
    ]);
    const ownerState = (0, $eJfrs.default)({}, props, {
        active: active,
        orientation: orientation,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        expanded: expanded,
        component: component
    });
    const classes = $4238740b0329aed2$var$useUtilityClasses(ownerState);
    const newChildren = /*#__PURE__*/ (0, $k4ank.jsxs)($4238740b0329aed2$var$StepRoot, (0, $eJfrs.default)({
        as: component,
        className: (0, $iVyaN.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            connector && alternativeLabel && index !== 0 ? connector : null,
            children
        ]
    }));
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $dd58c99e27d1f71f$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: connector && !alternativeLabel && index !== 0 ? /*#__PURE__*/ (0, $k4ank.jsxs)($8T3gX.Fragment, {
            children: [
                connector,
                newChildren
            ]
        }) : newChildren
    });
});
$4238740b0329aed2$var$Step.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Sets the step as active. Is passed to child components.
   */ active: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Mark the step as completed. Is passed to child components.
   */ completed: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * If `true`, the step is disabled, will also disable the button if
   * `StepButton` is a child of `Step`. Is passed to child components.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Expand the step.
   * @default false
   */ expanded: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The position of the step.
   * The prop defaults to the value inherited from the parent Stepper component.
   */ index: (0, $97LlG.default),
    /**
   * If `true`, the Step is displayed as rendered last.
   * The prop defaults to the value inherited from the parent Stepper component.
   */ last: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $4238740b0329aed2$export$2e2bcd8739ae039 = $4238740b0329aed2$var$Step;


var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $eJfrs = parcelRequire("eJfrs");

var $fAJB5 = parcelRequire("fAJB5");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");
parcelRequire("8T3gX");

var $a7uO0 = parcelRequire("a7uO0");

var $k4ank = parcelRequire("k4ank");
'use client';
var $58756f95b8d18bdb$export$2e2bcd8739ae039 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), 'CheckCircle');


parcelRequire("8T3gX");

var $a7uO0 = parcelRequire("a7uO0");

var $k4ank = parcelRequire("k4ank");
'use client';
var $65a29a6476db927a$export$2e2bcd8739ae039 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), 'Warning');



var $axLMO = parcelRequire("axLMO");

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $9fbe10cca2bd3f77$export$62a6e0748bec9297(slot) {
    return (0, $kfTYv.default)('MuiStepIcon', slot);
}
const $9fbe10cca2bd3f77$var$stepIconClasses = (0, $jh2Zm.default)('MuiStepIcon', [
    'root',
    'active',
    'completed',
    'error',
    'text'
]);
var $9fbe10cca2bd3f77$export$2e2bcd8739ae039 = $9fbe10cca2bd3f77$var$stepIconClasses;



var $k4ank = parcelRequire("k4ank");
'use client';
var $b62854285af379dd$var$_circle;
const $b62854285af379dd$var$_excluded = [
    "active",
    "className",
    "completed",
    "error",
    "icon"
];
const $b62854285af379dd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, active: active, completed: completed, error: error } = ownerState;
    const slots = {
        root: [
            'root',
            active && 'active',
            completed && 'completed',
            error && 'error'
        ],
        text: [
            'text'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $9fbe10cca2bd3f77$export$62a6e0748bec9297), classes);
};
const $b62854285af379dd$var$StepIconRoot = (0, $anJSP.default)((0, $axLMO.default), {
    name: 'MuiStepIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        display: 'block',
        transition: theme.transitions.create('color', {
            duration: theme.transitions.duration.shortest
        }),
        color: (theme.vars || theme).palette.text.disabled,
        [`&.${(0, $9fbe10cca2bd3f77$export$2e2bcd8739ae039).completed}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $9fbe10cca2bd3f77$export$2e2bcd8739ae039).active}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $9fbe10cca2bd3f77$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $b62854285af379dd$var$StepIconText = (0, $anJSP.default)('text', {
    name: 'MuiStepIcon',
    slot: 'Text',
    overridesResolver: (props, styles)=>styles.text
})(({ theme: theme })=>({
        fill: (theme.vars || theme).palette.primary.contrastText,
        fontSize: theme.typography.caption.fontSize,
        fontFamily: theme.typography.fontFamily
    }));
const $b62854285af379dd$var$StepIcon = /*#__PURE__*/ $8T3gX.forwardRef(function StepIcon(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiStepIcon'
    });
    const { active: active = false, className: classNameProp, completed: completed = false, error: error = false, icon: icon } = props, other = (0, $fAJB5.default)(props, $b62854285af379dd$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        active: active,
        completed: completed,
        error: error
    });
    const classes = $b62854285af379dd$var$useUtilityClasses(ownerState);
    if (typeof icon === 'number' || typeof icon === 'string') {
        const className = (0, $iVyaN.default)(classNameProp, classes.root);
        if (error) return /*#__PURE__*/ (0, $k4ank.jsx)($b62854285af379dd$var$StepIconRoot, (0, $eJfrs.default)({
            as: (0, $65a29a6476db927a$export$2e2bcd8739ae039),
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other));
        if (completed) return /*#__PURE__*/ (0, $k4ank.jsx)($b62854285af379dd$var$StepIconRoot, (0, $eJfrs.default)({
            as: (0, $58756f95b8d18bdb$export$2e2bcd8739ae039),
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other));
        return /*#__PURE__*/ (0, $k4ank.jsxs)($b62854285af379dd$var$StepIconRoot, (0, $eJfrs.default)({
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                $b62854285af379dd$var$_circle || ($b62854285af379dd$var$_circle = /*#__PURE__*/ (0, $k4ank.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "12"
                })),
                /*#__PURE__*/ (0, $k4ank.jsx)($b62854285af379dd$var$StepIconText, {
                    className: classes.text,
                    x: "12",
                    y: "12",
                    textAnchor: "middle",
                    dominantBaseline: "central",
                    ownerState: ownerState,
                    children: icon
                })
            ]
        }));
    }
    return icon;
});
$b62854285af379dd$var$StepIcon.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Whether this step is active.
   * @default false
   */ active: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */ completed: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the step is marked as failed.
   * @default false
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The label displayed in the step icon.
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $b62854285af379dd$export$2e2bcd8739ae039 = $b62854285af379dd$var$StepIcon;





var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $da177c97a899c28d$export$9625a725551d158a(slot) {
    return (0, $kfTYv.default)('MuiStepLabel', slot);
}
const $da177c97a899c28d$var$stepLabelClasses = (0, $jh2Zm.default)('MuiStepLabel', [
    'root',
    'horizontal',
    'vertical',
    'label',
    'active',
    'completed',
    'error',
    'disabled',
    'iconContainer',
    'alternativeLabel',
    'labelContainer'
]);
var $da177c97a899c28d$export$2e2bcd8739ae039 = $da177c97a899c28d$var$stepLabelClasses;



var $k4ank = parcelRequire("k4ank");
'use client';
const $e5e8e6de71eb5805$var$_excluded = [
    "children",
    "className",
    "componentsProps",
    "error",
    "icon",
    "optional",
    "slotProps",
    "StepIconComponent",
    "StepIconProps"
];
const $e5e8e6de71eb5805$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, active: active, completed: completed, error: error, disabled: disabled, alternativeLabel: alternativeLabel } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            error && 'error',
            disabled && 'disabled',
            alternativeLabel && 'alternativeLabel'
        ],
        label: [
            'label',
            active && 'active',
            completed && 'completed',
            error && 'error',
            disabled && 'disabled',
            alternativeLabel && 'alternativeLabel'
        ],
        iconContainer: [
            'iconContainer',
            active && 'active',
            completed && 'completed',
            error && 'error',
            disabled && 'disabled',
            alternativeLabel && 'alternativeLabel'
        ],
        labelContainer: [
            'labelContainer',
            alternativeLabel && 'alternativeLabel'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $da177c97a899c28d$export$9625a725551d158a), classes);
};
const $e5e8e6de71eb5805$var$StepLabelRoot = (0, $anJSP.default)('span', {
    name: 'MuiStepLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({
        display: 'flex',
        alignItems: 'center',
        [`&.${(0, $da177c97a899c28d$export$2e2bcd8739ae039).alternativeLabel}`]: {
            flexDirection: 'column'
        },
        [`&.${(0, $da177c97a899c28d$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        }
    }, ownerState.orientation === 'vertical' && {
        textAlign: 'left',
        padding: '8px 0'
    }));
const $e5e8e6de71eb5805$var$StepLabelLabel = (0, $anJSP.default)('span', {
    name: 'MuiStepLabel',
    slot: 'Label',
    overridesResolver: (props, styles)=>styles.label
})(({ theme: theme })=>(0, $eJfrs.default)({}, theme.typography.body2, {
        display: 'block',
        transition: theme.transitions.create('color', {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $da177c97a899c28d$export$2e2bcd8739ae039).active}`]: {
            color: (theme.vars || theme).palette.text.primary,
            fontWeight: 500
        },
        [`&.${(0, $da177c97a899c28d$export$2e2bcd8739ae039).completed}`]: {
            color: (theme.vars || theme).palette.text.primary,
            fontWeight: 500
        },
        [`&.${(0, $da177c97a899c28d$export$2e2bcd8739ae039).alternativeLabel}`]: {
            marginTop: 16
        },
        [`&.${(0, $da177c97a899c28d$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $e5e8e6de71eb5805$var$StepLabelIconContainer = (0, $anJSP.default)('span', {
    name: 'MuiStepLabel',
    slot: 'IconContainer',
    overridesResolver: (props, styles)=>styles.iconContainer
})(()=>({
        flexShrink: 0,
        // Fix IE11 issue
        display: 'flex',
        paddingRight: 8,
        [`&.${(0, $da177c97a899c28d$export$2e2bcd8739ae039).alternativeLabel}`]: {
            paddingRight: 0
        }
    }));
const $e5e8e6de71eb5805$var$StepLabelLabelContainer = (0, $anJSP.default)('span', {
    name: 'MuiStepLabel',
    slot: 'LabelContainer',
    overridesResolver: (props, styles)=>styles.labelContainer
})(({ theme: theme })=>({
        width: '100%',
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $da177c97a899c28d$export$2e2bcd8739ae039).alternativeLabel}`]: {
            textAlign: 'center'
        }
    }));
const $e5e8e6de71eb5805$var$StepLabel = /*#__PURE__*/ $8T3gX.forwardRef(function StepLabel(inProps, ref) {
    var _slotProps$label;
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiStepLabel'
    });
    const { children: children, className: className, componentsProps: componentsProps = {}, error: error = false, icon: iconProp, optional: optional, slotProps: slotProps = {}, StepIconComponent: StepIconComponentProp, StepIconProps: StepIconProps } = props, other = (0, $fAJB5.default)(props, $e5e8e6de71eb5805$var$_excluded);
    const { alternativeLabel: alternativeLabel, orientation: orientation } = $8T3gX.useContext((0, $b2d36598fb605cb3$export$2e2bcd8739ae039));
    const { active: active, disabled: disabled, completed: completed, icon: iconContext } = $8T3gX.useContext((0, $dd58c99e27d1f71f$export$2e2bcd8739ae039));
    const icon = iconProp || iconContext;
    let StepIconComponent = StepIconComponentProp;
    if (icon && !StepIconComponent) StepIconComponent = (0, $b62854285af379dd$export$2e2bcd8739ae039);
    const ownerState = (0, $eJfrs.default)({}, props, {
        active: active,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        error: error,
        orientation: orientation
    });
    const classes = $e5e8e6de71eb5805$var$useUtilityClasses(ownerState);
    const labelSlotProps = (_slotProps$label = slotProps.label) != null ? _slotProps$label : componentsProps.label;
    return /*#__PURE__*/ (0, $k4ank.jsxs)($e5e8e6de71eb5805$var$StepLabelRoot, (0, $eJfrs.default)({
        className: (0, $iVyaN.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            icon || StepIconComponent ? /*#__PURE__*/ (0, $k4ank.jsx)($e5e8e6de71eb5805$var$StepLabelIconContainer, {
                className: classes.iconContainer,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $k4ank.jsx)(StepIconComponent, (0, $eJfrs.default)({
                    completed: completed,
                    active: active,
                    error: error,
                    icon: icon
                }, StepIconProps))
            }) : null,
            /*#__PURE__*/ (0, $k4ank.jsxs)($e5e8e6de71eb5805$var$StepLabelLabelContainer, {
                className: classes.labelContainer,
                ownerState: ownerState,
                children: [
                    children ? /*#__PURE__*/ (0, $k4ank.jsx)($e5e8e6de71eb5805$var$StepLabelLabel, (0, $eJfrs.default)({
                        ownerState: ownerState
                    }, labelSlotProps, {
                        className: (0, $iVyaN.default)(classes.label, labelSlotProps == null ? void 0 : labelSlotProps.className),
                        children: children
                    })) : null,
                    optional
                ]
            })
        ]
    }));
});
$e5e8e6de71eb5805$var$StepLabel.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * In most cases will simply be a string containing a title for the label.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The props used for each slot inside.
   * @default {}
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        label: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    }),
    /**
   * If `true`, the step is marked as failed.
   * @default false
   */ error: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Override the default label of the step icon.
   */ icon: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * The optional node to display.
   */ optional: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
        label: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    }),
    /**
   * The component to render in place of the [`StepIcon`](/material-ui/api/step-icon/).
   */ StepIconComponent: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * Props applied to the [`StepIcon`](/material-ui/api/step-icon/) element.
   */ StepIconProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
$e5e8e6de71eb5805$var$StepLabel.muiName = 'StepLabel';
var $e5e8e6de71eb5805$export$2e2bcd8739ae039 = $e5e8e6de71eb5805$var$StepLabel;


var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $97LlG = parcelRequire("97LlG");

var $aYNpO = parcelRequire("aYNpO");

var $7AQZl = parcelRequire("7AQZl");

var $anJSP = parcelRequire("anJSP");

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $365db8f447a09668$export$797947b6292e28e1(slot) {
    return (0, $kfTYv.default)('MuiStepper', slot);
}
const $365db8f447a09668$var$stepperClasses = (0, $jh2Zm.default)('MuiStepper', [
    'root',
    'horizontal',
    'vertical',
    'nonLinear',
    'alternativeLabel'
]);
var $365db8f447a09668$export$2e2bcd8739ae039 = $365db8f447a09668$var$stepperClasses;



var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $iMOmE = parcelRequire("iMOmE");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");



var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $8422ba0d6019cd82$export$6fbaff484b0d9308(slot) {
    return (0, $kfTYv.default)('MuiStepConnector', slot);
}
const $8422ba0d6019cd82$var$stepConnectorClasses = (0, $jh2Zm.default)('MuiStepConnector', [
    'root',
    'horizontal',
    'vertical',
    'alternativeLabel',
    'active',
    'completed',
    'disabled',
    'line',
    'lineHorizontal',
    'lineVertical'
]);
var $8422ba0d6019cd82$export$2e2bcd8739ae039 = $8422ba0d6019cd82$var$stepConnectorClasses;



var $k4ank = parcelRequire("k4ank");
'use client';
const $65ba720a2d17da13$var$_excluded = [
    "className"
];
const $65ba720a2d17da13$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, alternativeLabel: alternativeLabel, active: active, completed: completed, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            alternativeLabel && 'alternativeLabel',
            active && 'active',
            completed && 'completed',
            disabled && 'disabled'
        ],
        line: [
            'line',
            `line${(0, $iMOmE.default)(orientation)}`
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $8422ba0d6019cd82$export$6fbaff484b0d9308), classes);
};
const $65ba720a2d17da13$var$StepConnectorRoot = (0, $anJSP.default)('div', {
    name: 'MuiStepConnector',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.completed && styles.completed
        ];
    }
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({
        flex: '1 1 auto'
    }, ownerState.orientation === 'vertical' && {
        marginLeft: 12 // half icon
    }, ownerState.alternativeLabel && {
        position: 'absolute',
        top: 12,
        left: 'calc(-50% + 20px)',
        right: 'calc(50% + 20px)'
    }));
const $65ba720a2d17da13$var$StepConnectorLine = (0, $anJSP.default)('span', {
    name: 'MuiStepConnector',
    slot: 'Line',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.line,
            styles[`line${(0, $iMOmE.default)(ownerState.orientation)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[600];
    return (0, $eJfrs.default)({
        display: 'block',
        borderColor: theme.vars ? theme.vars.palette.StepConnector.border : borderColor
    }, ownerState.orientation === 'horizontal' && {
        borderTopStyle: 'solid',
        borderTopWidth: 1
    }, ownerState.orientation === 'vertical' && {
        borderLeftStyle: 'solid',
        borderLeftWidth: 1,
        minHeight: 24
    });
});
const $65ba720a2d17da13$var$StepConnector = /*#__PURE__*/ $8T3gX.forwardRef(function StepConnector(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiStepConnector'
    });
    const { className: className } = props, other = (0, $fAJB5.default)(props, $65ba720a2d17da13$var$_excluded);
    const { alternativeLabel: alternativeLabel, orientation: orientation = 'horizontal' } = $8T3gX.useContext((0, $b2d36598fb605cb3$export$2e2bcd8739ae039));
    const { active: active, disabled: disabled, completed: completed } = $8T3gX.useContext((0, $dd58c99e27d1f71f$export$2e2bcd8739ae039));
    const ownerState = (0, $eJfrs.default)({}, props, {
        alternativeLabel: alternativeLabel,
        orientation: orientation,
        active: active,
        completed: completed,
        disabled: disabled
    });
    const classes = $65ba720a2d17da13$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsx)($65ba720a2d17da13$var$StepConnectorRoot, (0, $eJfrs.default)({
        className: (0, $iVyaN.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $k4ank.jsx)($65ba720a2d17da13$var$StepConnectorLine, {
            className: classes.line,
            ownerState: ownerState
        })
    }));
});
$65ba720a2d17da13$var$StepConnector.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $65ba720a2d17da13$export$2e2bcd8739ae039 = $65ba720a2d17da13$var$StepConnector;




var $k4ank = parcelRequire("k4ank");
'use client';
const $91c8cb97eec976fc$var$_excluded = [
    "activeStep",
    "alternativeLabel",
    "children",
    "className",
    "component",
    "connector",
    "nonLinear",
    "orientation"
];
const $91c8cb97eec976fc$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, nonLinear: nonLinear, alternativeLabel: alternativeLabel, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            nonLinear && 'nonLinear',
            alternativeLabel && 'alternativeLabel'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $365db8f447a09668$export$797947b6292e28e1), classes);
};
const $91c8cb97eec976fc$var$StepperRoot = (0, $anJSP.default)('div', {
    name: 'MuiStepper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.nonLinear && styles.nonLinear
        ];
    }
})(({ ownerState: ownerState })=>(0, $eJfrs.default)({
        display: 'flex'
    }, ownerState.orientation === 'horizontal' && {
        flexDirection: 'row',
        alignItems: 'center'
    }, ownerState.orientation === 'vertical' && {
        flexDirection: 'column'
    }, ownerState.alternativeLabel && {
        alignItems: 'flex-start'
    }));
const $91c8cb97eec976fc$var$defaultConnector = /*#__PURE__*/ (0, $k4ank.jsx)((0, $65ba720a2d17da13$export$2e2bcd8739ae039), {});
const $91c8cb97eec976fc$var$Stepper = /*#__PURE__*/ $8T3gX.forwardRef(function Stepper(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiStepper'
    });
    const { activeStep: activeStep = 0, alternativeLabel: alternativeLabel = false, children: children, className: className, component: component = 'div', connector: connector = $91c8cb97eec976fc$var$defaultConnector, nonLinear: nonLinear = false, orientation: orientation = 'horizontal' } = props, other = (0, $fAJB5.default)(props, $91c8cb97eec976fc$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        nonLinear: nonLinear,
        alternativeLabel: alternativeLabel,
        orientation: orientation,
        component: component
    });
    const classes = $91c8cb97eec976fc$var$useUtilityClasses(ownerState);
    const childrenArray = $8T3gX.Children.toArray(children).filter(Boolean);
    const steps = childrenArray.map((step, index)=>{
        return /*#__PURE__*/ $8T3gX.cloneElement(step, (0, $eJfrs.default)({
            index: index,
            last: index + 1 === childrenArray.length
        }, step.props));
    });
    const contextValue = $8T3gX.useMemo(()=>({
            activeStep: activeStep,
            alternativeLabel: alternativeLabel,
            connector: connector,
            nonLinear: nonLinear,
            orientation: orientation
        }), [
        activeStep,
        alternativeLabel,
        connector,
        nonLinear,
        orientation
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $b2d36598fb605cb3$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $k4ank.jsx)($91c8cb97eec976fc$var$StepperRoot, (0, $eJfrs.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $iVyaN.default)(classes.root, className),
            ref: ref
        }, other, {
            children: steps
        }))
    });
});
$91c8cb97eec976fc$var$Stepper.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Set the active step (zero based index).
   * Set to -1 to disable all the steps.
   * @default 0
   */ activeStep: (0, $97LlG.default),
    /**
   * If set to 'true' and orientation is horizontal,
   * then the step label will be positioned under the icon.
   * @default false
   */ alternativeLabel: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Two or more `<Step />` components.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * An element to be placed between each step.
   * @default <StepConnector />
   */ connector: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).element,
    /**
   * If set the `Stepper` will not assist in controlling steps for linear flow.
   * @default false
   */ nonLinear: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'horizontal',
        'vertical'
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ])
};
var $91c8cb97eec976fc$export$2e2bcd8739ae039 = $91c8cb97eec976fc$var$Stepper;



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

const $635b38046a5de67e$export$bca14c5b3b88a9c9 = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    },
    components: {
        MuiStepLabel: {
            styleOverrides: {
                root: {
                    fontFamily: "Mulish"
                }
            }
        },
        MuiStepper: {
            styleOverrides: {
                root: {
                    fontFamily: "Mulish"
                }
            }
        },
        MuiStep: {
            styleOverrides: {
                root: {
                    fontFamily: "Mulish"
                }
            }
        }
    }
});
const $635b38046a5de67e$export$2cf5ff4e03e29cc1 = ({ activeStep: activeStep })=>{
    const steps = [
        "Integration",
        `Site's Information`
    ];
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
            theme: $635b38046a5de67e$export$bca14c5b3b88a9c9,
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $91c8cb97eec976fc$export$2e2bcd8739ae039), {
                activeStep: activeStep,
                sx: {
                    width: 565
                },
                children: steps.map((label)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $4238740b0329aed2$export$2e2bcd8739ae039), {
                        color: "primary",
                        sx: {
                            fontFamily: "Mulish"
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $e5e8e6de71eb5805$export$2e2bcd8739ae039), {
                            children: label
                        })
                    }, label))
            })
        })
    });
};



var $8jTCz = parcelRequire("8jTCz");

var $k4ank = parcelRequire("k4ank");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $gfzcx = parcelRequire("gfzcx");

var $8T3gX = parcelRequire("8T3gX");

var $8jTCz = parcelRequire("8jTCz");

var $ka01y = parcelRequire("ka01y");

var $crpct = parcelRequire("crpct");

var $887xF = parcelRequire("887xF");
var $eejVe = parcelRequire("eejVe");

var $hfM8m = parcelRequire("hfM8m");

var $hwWkD = parcelRequire("hwWkD");


var $5L5iJ = parcelRequire("5L5iJ");

var $4wo2Y = parcelRequire("4wo2Y");

var $4PFLW = parcelRequire("4PFLW");

const $2fbafee199e7ac7a$export$61b39bc450cdc60e = ({ calendarEvents: calendarEvents, setCalendarEvents: setCalendarEvents })=>{
    const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    const getMonthName = (monthNumber)=>{
        return monthNames[monthNumber - 1];
    };
    const formatDate = (date)=>{
        if (date === "--") return "--";
        const parts = date.split("-");
        return `${getMonthName(Number(parts[1]))} ${parts[2]}, ${parts[0]}`;
    };
    const { width: width, height: height } = (0, $crpct.default)();
    const [calcuatedHeight, setCalculatedHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setCalculatedHeight(height - 225);
    }, [
        height,
        width
    ]);
    const [calendarDate, setCalendarDate] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(new Date());
    const [tempString, setTempString] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [addDateDisabled, setAddDateDisabled] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [currentCalendarEvents, setCurrentCalendarEvents] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(calendarEvents);
    const [addEventDialogOpen, setAddEventDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const { isFeatureEnabled: isFeatureEnabled } = (0, $4PFLW.useFeatureFlag)();
    const showAddCalendarScheduleTime = isFeatureEnabled("showAddCalendarScheduleTime", false);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setCurrentCalendarEvents(calendarEvents);
    }, [
        calendarEvents
    ]);
    const handleDeleteEvent = (rowIndex)=>{
        const nextEvents = currentCalendarEvents.filter((_event, index)=>index !== rowIndex);
        setCurrentCalendarEvents(nextEvents);
        setCalendarEvents(nextEvents);
    };
    const handleSaveLegacyInlineEvent = (rowIndex)=>{
        const nextEvents = [
            ...currentCalendarEvents
        ];
        nextEvents[rowIndex] = {
            ...nextEvents[rowIndex],
            editMode: false,
            name: tempString,
            event_date: (0, $5L5iJ.yyyymmddGenerator)(calendarDate)
        };
        setCurrentCalendarEvents(nextEvents);
        setCalendarEvents(nextEvents);
        setAddDateDisabled(false);
    };
    const handleAddLegacyInlineEvent = ()=>{
        const nextEvents = [
            ...currentCalendarEvents,
            {
                event_date: (0, $5L5iJ.yyyymmddGenerator)(new Date()),
                name: "",
                editMode: true
            }
        ];
        setCurrentCalendarEvents(nextEvents);
        setTempString("");
        setAddDateDisabled(true);
        setCalendarDate(new Date());
    };
    const handleDialogSubmit = ({ event_date: event_date, name: name, start_time: start_time, end_time: end_time })=>{
        const nextEvents = [
            ...currentCalendarEvents,
            {
                event_date: event_date,
                name: name,
                start_time: start_time,
                end_time: end_time
            }
        ];
        setCurrentCalendarEvents(nextEvents);
        setCalendarEvents(nextEvents);
        setAddEventDialogOpen(false);
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "absolute top-[160px] left-[30px]",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                            sx: {
                                maxHeight: calcuatedHeight,
                                width: 540
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                sx: {
                                    fontFamily: "Mulish",
                                    width: "100%",
                                    overflow: "scroll"
                                },
                                "aria-label": "simple table",
                                stickyHeader: true,
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                        titlesArray: [
                                            "Event Date",
                                            "Event Name",
                                            ""
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                        children: currentCalendarEvents.map((object, rowIndex)=>{
                                            if (object.editMode) return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish"
                                                        },
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
                                                            dateAdapter: (0, $hfM8m.AdapterDateFns),
                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cbaf068f14972fdf$export$5109c6dd95d8fb00), {
                                                                value: calendarDate,
                                                                onChange: (newValue)=>{
                                                                    if (!newValue) return;
                                                                    setCalendarDate(newValue);
                                                                    const nextEvents = [
                                                                        ...currentCalendarEvents
                                                                    ];
                                                                    nextEvents[rowIndex] = {
                                                                        ...nextEvents[rowIndex],
                                                                        event_date: (0, $5L5iJ.yyyymmddGenerator)(newValue)
                                                                    };
                                                                    setCurrentCalendarEvents(nextEvents);
                                                                    setCalendarEvents(nextEvents);
                                                                },
                                                                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                        sx: {
                                                                            width: 150
                                                                        },
                                                                        ...params
                                                                    })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish"
                                                        },
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                            value: tempString,
                                                            onChange: (event)=>{
                                                                setTempString(event.target.value);
                                                            },
                                                            variant: "standard",
                                                            sx: {
                                                                fontFamily: "Mulish",
                                                                width: 200
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish"
                                                        },
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                            onClick: ()=>handleSaveLegacyInlineEvent(rowIndex),
                                                            disabled: false,
                                                            text: "Save"
                                                        })
                                                    })
                                                ]
                                            }, `inline-edit-row-${rowIndex}`);
                                            else return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish"
                                                        },
                                                        children: formatDate(object.event_date)
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish",
                                                            width: 250
                                                        },
                                                        children: object.name
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "right",
                                                        sx: {
                                                            fontFamily: "Mulish",
                                                            width: 100
                                                        },
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                            onClick: ()=>handleDeleteEvent(rowIndex),
                                                            text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ka01y))), {}),
                                                            disabled: false
                                                        })
                                                    })
                                                ]
                                            }, `event-row-${object.name}-${rowIndex}`);
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    onClick: ()=>{
                                        if (showAddCalendarScheduleTime) {
                                            setAddEventDialogOpen(true);
                                            return;
                                        }
                                        handleAddLegacyInlineEvent();
                                    },
                                    text: "+ Add Event",
                                    disabled: showAddCalendarScheduleTime ? false : addDateDisabled
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $0ddb02651f35e13a$export$fb9e1512f325609e), {
                    open: addEventDialogOpen,
                    onCancel: ()=>setAddEventDialogOpen(false),
                    onSubmit: handleDialogSubmit
                })
            ]
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $60vL1 = parcelRequire("60vL1");

var $kCUgG = parcelRequire("kCUgG");





var $kbChx = parcelRequire("kbChx");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $8jTCz = parcelRequire("8jTCz");

var $887xF = parcelRequire("887xF");

var $crpct = parcelRequire("crpct");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");
const $f05a511d40a0fd8d$export$3c049d782df88a0e = ({ text: text, styling: styling })=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
            className: styling,
            children: text
        })
    });
};



var $3Zv1D = parcelRequire("3Zv1D");
const $5d4c826e4dcfeeca$export$d96ed53e5b810eaf = (newCalendarInfo, calendarEvents, assignedSites, setVisibleScreen, calendarData, setCalendarData, setCalendarAlerts, setAddCalendarScreenOpen, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $5d4c826e4dcfeeca$export$d96ed53e5b810eaf(newCalendarInfo, calendarEvents, assignedSites, setVisibleScreen, calendarData, setCalendarData, setCalendarAlerts, setAddCalendarScreenOpen, navigate);
    };
    AxiosUI.post(`calendar/`, newCalendarInfo).then((response)=>{
        const calendarID = response.data.id;
        if (calendarEvents[0]) calendarEvents.forEach((object)=>{
            AxiosUI.post(`calendar_event/`, {
                calendar: calendarID,
                event_date: object.event_date,
                name: object.name,
                start_time: object.start_time ?? "00:00:00",
                end_time: object.end_time ?? "23:59:59"
            });
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                alert("Error adding one or more Calendar events");
                setAddCalendarScreenOpen(false);
            });
        });
        AxiosUI.post(`calendar/${calendarID}/apply/`, {
            customer: assignedSites
        }).then(()=>{
            AxiosUI.get(`calendar/${calendarID}/`).then((response)=>{
                setCalendarData([
                    ...calendarData,
                    response.data
                ]);
                setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $f05a511d40a0fd8d$export$3c049d782df88a0e), {
                    styling: "absolute first-line:font-black font-mulish text-[20px] left-[110px] text-center text-[#283E6D] w-[400px] top-80",
                    text: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        children: "Calendar added successfully!"
                    })
                }));
                setTimeout(()=>{
                    localStorage.setItem("newCalendarName", response.data.name);
                    setCalendarAlerts({
                        addCalendarSuccess: true,
                        deleteCalendarSuccess: false,
                        addSitesToCalendarSuccess: false
                    });
                    setAddCalendarScreenOpen(false);
                }, 3000);
            }, (reason)=>{
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setAddCalendarScreenOpen(false);
                });
            });
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                alert("Error applying sites to new Calendar");
                setAddCalendarScreenOpen(false);
            });
        });
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Error adding Calendar, please try again");
            setAddCalendarScreenOpen(false);
        });
    });
};




var $4wo2Y = parcelRequire("4wo2Y");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");


const $9e8c05c1e922c2ce$export$d453eb87ec65cc07 = ({ setSitesSearchString: setSitesSearchString })=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $c9d4fba0d4c728e8$export$4b85d3515bd863a5), {
        sx: {
            border: "1px solid #E0E0E0",
            borderRadius: "5px"
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $c9d4fba0d4c728e8$export$e9ad429a7452907b), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0f42bd3abae37cbe$exports))), {})
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $c9d4fba0d4c728e8$export$b030dc24f7f252a3), {
                // placeholder="Search Calendar Names"
                onChange: (event)=>setSitesSearchString(event.target.value),
                inputProps: {
                    "aria-label": "search"
                }
            })
        ]
    });
};


const $b7ce660f1b9579fc$export$f53e07bc049b2b46 = ({ siteOptions: siteOptions, loadingSites: loadingSites, assignedSites: assignedSites, setAssignedSites: setAssignedSites, newCalendarInfo: newCalendarInfo, calendarEvents: calendarEvents, setVisibleScreen: setVisibleScreen, calendarData: calendarData, setCalendarData: setCalendarData, setCalendarAlerts: setCalendarAlerts, setAddCalendarScreenOpen: setAddCalendarScreenOpen, setBackButtonHidden: setBackButtonHidden, navigate: navigate })=>{
    const siteIds = new Map();
    const siteNames = new Map();
    const allSiteIds = [];
    const [calcuatedHeight, setCalculatedHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const { width: width, height: height } = (0, $crpct.default)();
    const [sitesSearchString, setSitesSearchString] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const normalizedSiteOptions = Array.isArray(siteOptions) ? siteOptions : [];
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setCalculatedHeight(height - 225);
    }, [
        height,
        width
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        normalizedSiteOptions.forEach((object)=>{
            allSiteIds.push(object.id);
            siteIds.set(object.name, object.id);
            siteNames.set(object.id, object.name);
        });
    }, []);
    const [updatedAssignedSites, setUpdatedAssignedSites] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(assignedSites);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            children: [
                loadingSites && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "absolute top-[270] left-[230]",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {})
                }),
                !loadingSites && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "absolute top-[225px] left-[30px] font-mulish",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                        sx: {
                            maxHeight: height - 300,
                            width: 540,
                            overflow: "scroll"
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kCUgG.default), {
                            children: normalizedSiteOptions.filter((site)=>site.name.toLowerCase().includes(sitesSearchString.toLowerCase())).map((site)=>{
                                return /*#__PURE__*/ (0, $k4ank.jsx)((0, $95031c517ca80bec$export$2e2bcd8739ae039), {
                                    sx: {
                                        width: 400
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $07bcecd6345c33ee$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $fc0c7440c238b2e1$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                    edge: "start",
                                                    checked: updatedAssignedSites.includes(site.id),
                                                    tabIndex: -1,
                                                    disableRipple: true,
                                                    onChange: (event, checked)=>{
                                                        if (checked) {
                                                            setAssignedSites([
                                                                ...updatedAssignedSites,
                                                                site.id
                                                            ]);
                                                            setUpdatedAssignedSites([
                                                                ...updatedAssignedSites,
                                                                site.id
                                                            ]);
                                                        } else {
                                                            setAssignedSites(updatedAssignedSites.filter((number)=>number !== site.id));
                                                            setUpdatedAssignedSites(updatedAssignedSites.filter((number)=>number !== site.id));
                                                        }
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $a7d6d1bc115c33d6$export$2e2bcd8739ae039), {
                                                primaryTypographyProps: {
                                                    fontFamily: "Mulish",
                                                    color: "black"
                                                },
                                                id: site.name,
                                                primary: `${site.name}`
                                            })
                                        ]
                                    })
                                }, site.id);
                            })
                        })
                    })
                }),
                !loadingSites && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "absolute left-[30px] font-mulish",
                    style: {
                        top: `${height - 70}px`
                    },
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                text: "Submit",
                                disabled: false,
                                onClick: ()=>{
                                    setBackButtonHidden(true);
                                    setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $f05a511d40a0fd8d$export$3c049d782df88a0e), {
                                        styling: "absolute first-line:font-black font-mulish text-[20px] left-[130px] text-center text-[#283E6D] w-[400px] top-80",
                                        text: /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                            children: [
                                                "Adding new Calendar.",
                                                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                                "This might take a few seconds."
                                            ]
                                        })
                                    }));
                                    (0, $5d4c826e4dcfeeca$export$d96ed53e5b810eaf)(newCalendarInfo, calendarEvents, updatedAssignedSites, setVisibleScreen, calendarData, setCalendarData, setCalendarAlerts, setAddCalendarScreenOpen, navigate);
                                }
                            })
                        })
                    })
                }),
                !loadingSites && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "absolute left-[0px] top-[150px] font-bold font-mulish bg-white h-[50px] w-[580px] text-black",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $9e8c05c1e922c2ce$export$d453eb87ec65cc07), {
                        setSitesSearchString: setSitesSearchString
                    })
                }),
                !loadingSites && !sitesSearchString && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "absolute left-[20px] top-[200px] font-bold font-mulish bg-white h-[50px] w-[600px] text-black",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                            onChange: (event, checked)=>{
                                const allSiteIds = [];
                                normalizedSiteOptions.forEach((object)=>{
                                    allSiteIds.push(object.id);
                                });
                                if (checked) {
                                    setAssignedSites(allSiteIds);
                                    setUpdatedAssignedSites(allSiteIds);
                                } else {
                                    setAssignedSites([]);
                                    setUpdatedAssignedSites([]);
                                }
                            }
                        }),
                        "Select All"
                    ]
                })
            ]
        })
    });
};


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $0a67ba325634e2ae$export$6a8dce34b81d321b = ({ setAddCalendarScreenOpen: setAddCalendarScreenOpen, calendarData: calendarData, setCalendarData: setCalendarData, setCalendarAlerts: setCalendarAlerts, backButtonHidden: backButtonHidden, setBackButtonHidden: setBackButtonHidden })=>{
    const parentAccounts = JSON.parse(localStorage.parentAccounts);
    const parentNames = new Map();
    parentAccounts.forEach((object)=>{
        parentNames.set(object.id, object.name);
    });
    const [newCalendarInfo, setNewCalendarInfo] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        group: "",
        name: ""
    });
    const navigate = (0, $3T949.useNavigate)();
    const steps = [
        "Add New Calendar",
        "Add Events",
        "Add Sites"
    ];
    const [activeStep, setActiveStep] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [calendarEvents, setCalendarEvents] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [loadingSites, setLoadingSites] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [siteOptions, setSiteOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [assignedSites, setAssignedSites] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [visibleScreen, setVisibleScreen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const renderStepContent = ()=>{
        if (activeStep === 0) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $73e68071618006e3$export$2e2bcd8739ae039), {
            newCalendarInfo: newCalendarInfo,
            setNewCalendarInfo: setNewCalendarInfo,
            parentAccounts: parentAccounts,
            parentNames: parentNames,
            navigate: navigate,
            setSiteOptions: setSiteOptions,
            setLoadingSites: setLoadingSites
        });
        if (activeStep === 1) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $2fbafee199e7ac7a$export$61b39bc450cdc60e), {
            calendarEvents: calendarEvents,
            setCalendarEvents: setCalendarEvents
        });
        return /*#__PURE__*/ (0, $k4ank.jsx)((0, $b7ce660f1b9579fc$export$f53e07bc049b2b46), {
            siteOptions: siteOptions,
            loadingSites: loadingSites,
            assignedSites: assignedSites,
            setAssignedSites: setAssignedSites,
            newCalendarInfo: newCalendarInfo,
            calendarEvents: calendarEvents,
            setVisibleScreen: setVisibleScreen,
            calendarData: calendarData,
            setCalendarData: setCalendarData,
            setCalendarAlerts: setCalendarAlerts,
            setAddCalendarScreenOpen: setAddCalendarScreenOpen,
            setBackButtonHidden: setBackButtonHidden,
            navigate: navigate
        });
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: "absolute top-0 right-[600px] h-full bg-white",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "absolute h-full bg-white w-[600px]",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "bg-actuate-blue absolute w-[600px] h-[50px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                    className: "absolute right-6 top-[10px] text-white text-[18px]",
                                    onClick: ()=>{
                                        setAddCalendarScreenOpen(false);
                                    },
                                    children: "X"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "text-white absolute top-[1px] right-[450px] font-mulish text-[18px] p-3",
                                    children: "Add Calendar"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                                    theme: (0, $635b38046a5de67e$export$bca14c5b3b88a9c9),
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "absolute top-[70px] left-[20px]",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $91c8cb97eec976fc$export$2e2bcd8739ae039), {
                                            activeStep: activeStep,
                                            sx: {
                                                width: 565
                                            },
                                            children: steps.map((label)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $4238740b0329aed2$export$2e2bcd8739ae039), {
                                                    color: "primary",
                                                    sx: {
                                                        fontFamily: "Mulish"
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $e5e8e6de71eb5805$export$2e2bcd8739ae039), {
                                                        children: label
                                                    })
                                                }, label))
                                        })
                                    })
                                }),
                                activeStep !== 2 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "absolute right-4 top-28",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                        disabled: !newCalendarInfo.name,
                                        onClick: ()=>{
                                            if (activeStep === 0) setActiveStep(1);
                                            if (activeStep === 1) setActiveStep(2);
                                        },
                                        text: "Next"
                                    })
                                })
                            ]
                        }),
                        activeStep !== 0 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "absolute right-[520px] top-28",
                            children: !backButtonHidden && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                disabled: false,
                                onClick: ()=>{
                                    if (activeStep === 1) setActiveStep(0);
                                    if (activeStep === 2) setActiveStep(1);
                                },
                                text: "Back"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    children: visibleScreen ?? renderStepContent()
                })
            ]
        })
    });
};


const $8fd061cf8e8d69d2$export$be58926105124dd4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).forwardRef(function Transition(props, ref) {
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $212a5a6a44b7f18e$export$2e2bcd8739ae039), {
        direction: "up",
        ref: ref,
        ...props
    });
});
const $8fd061cf8e8d69d2$export$39d78c94fb91ad03 = ({ navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed })=>{
    const [calendarData, setCalendarData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [calendarsSearchString, setCalendarsSearchString] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [page, setPage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [rowsPerPage, setRowsPerPage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(5);
    const [selected, setSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [fetchingCalendarData, setFetchingCalendarData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [showMoreDialogOpen, setShowMoreDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [loadingEventData, setLoadingEventData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [selectedRow, setSelectedRow] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [calendarEvents, setCalendarEvents] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [calendarId, setCalendarId] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [addDateDialogOpen, setAddDateDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [editingCalendar, setEditingCalendar] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [patchEvent, setPatchEvent] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [editEventDialogOpen, setEditEventDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [addCalendarDialogOpen, setAddCalendarDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [deleteCalendarDialogOpen, setDeleteCalendarDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [deletedCalendarId, setDeletedCalendarId] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [editCalendarDialogOpen, setEditCalendarDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [rowIndex, setRowIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [addCalendarScreenOpen, setAddCalendarScreenOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [calendarAlerts, setCalendarAlerts] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        addCalendarSuccess: false,
        deleteCalendarSuccess: false,
        addSitesToCalendarSuccess: false
    });
    const [assignedSitesDialogOpen, setAssignedSitesDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [updatingSites, setUpdatingSites] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [backButtonHidden, setBackButtonHidden] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const navigate = (0, $3T949.useNavigate)();
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        (0, $827f18cdab69c4b1$export$e8722922009db361)(setCalendarData, setFetchingCalendarData, calendarsSearchString, setPage, setShowMoreDialogOpen, setSelectedRow, navigate);
    }, []);
    const handleSelectAllClick = (event)=>{
        if (event.target.checked) {
            const newSelecteds = calendarData.map((obj)=>obj.id);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };
    const handleSingleCheckboxClick = (event, id)=>{
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];
        if (selectedIndex === -1) newSelected = newSelected.concat(selected, id);
        else if (selectedIndex === 0) newSelected = newSelected.concat(selected.slice(1));
        else if (selectedIndex === selected.length - 1) newSelected = newSelected.concat(selected.slice(0, -1));
        else if (selectedIndex > 0) newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        setSelected(newSelected);
    };
    const isSelected = (id)=>selected.indexOf(id) !== -1;
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1556ab6cd5f885f9$export$7267526df49a36d), {
                calendarAlerts: calendarAlerts,
                setCalendarAlerts: setCalendarAlerts
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "bg-actuate-grey absolute w-screen h-screen",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                        openState: fetchingCalendarData
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                        openState: updatingSites
                    }),
                    addCalendarScreenOpen && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $djxj8.default), {
                            sx: {
                                color: "#fff",
                                zIndex: (theme)=>theme.zIndex.drawer + 1
                            },
                            open: addCalendarScreenOpen,
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $0a67ba325634e2ae$export$6a8dce34b81d321b), {
                                setAddCalendarScreenOpen: setAddCalendarScreenOpen,
                                calendarData: calendarData,
                                setCalendarData: setCalendarData,
                                setCalendarAlerts: setCalendarAlerts,
                                backButtonHidden: backButtonHidden,
                                setBackButtonHidden: setBackButtonHidden
                            })
                        })
                    }),
                    showMoreDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $djxj8.default), {
                            sx: {
                                color: "#fff",
                                zIndex: (theme)=>theme.zIndex.drawer + 1
                            },
                            open: showMoreDialogOpen,
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1a36966a2d753e0d$export$227798582466ec7b), {
                                setShowMoreDialogOpen: setShowMoreDialogOpen,
                                selectedRow: selectedRow,
                                calendarEvents: calendarEvents,
                                setCalendarEvents: setCalendarEvents,
                                setAddDateDialogOpen: setAddDateDialogOpen,
                                editingCalendar: editingCalendar,
                                loadingEventData: loadingEventData,
                                setEditingCalendar: setEditingCalendar,
                                setPatchEvent: setPatchEvent,
                                setEditEventDialogOpen: setEditEventDialogOpen,
                                setEditCalendarDialogOpen: setEditCalendarDialogOpen
                            })
                        })
                    }),
                    addDateDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $b2867f9a424e8e39$export$745f33b0c918d204), {
                        addDateDialogOpen: addDateDialogOpen,
                        setAddDateDialogOpen: setAddDateDialogOpen,
                        setCalendarEvents: setCalendarEvents,
                        calendarId: calendarId,
                        setShowMoreDialogOpen: setShowMoreDialogOpen,
                        setEditingCalendar: setEditingCalendar,
                        navigate: navigate
                    }),
                    editEventDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $1cfc222a8ca52913$export$de7ac5d992cddd48), {
                        patchEvent: patchEvent,
                        editEventDialogOpen: editEventDialogOpen,
                        setEditEventDialogOpen: setEditEventDialogOpen,
                        setEditingCalendar: setEditingCalendar,
                        setCalendarEvents: setCalendarEvents,
                        navigate: navigate
                    }),
                    addCalendarDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $f87a33808adf1904$export$c01d600c4cc28201), {
                        addCalendarDialogOpen: addCalendarDialogOpen,
                        setAddCalendarDialogOpen: setAddCalendarDialogOpen,
                        setFetchingCalendarData: setFetchingCalendarData,
                        calendarData: calendarData,
                        setCalendarData: setCalendarData,
                        setCalendarAlerts: setCalendarAlerts,
                        calendarsSearchString: calendarsSearchString,
                        navigate: navigate
                    }),
                    deleteCalendarDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $19a4b96ed2baaa31$export$c00c7f1155c19f2), {
                        deleteCalendarDialogOpen: deleteCalendarDialogOpen,
                        setDeleteCalendarDialogOpen: setDeleteCalendarDialogOpen,
                        deletedCalendarId: deletedCalendarId,
                        setFetchingCalendarData: setFetchingCalendarData,
                        calendarData: calendarData,
                        setCalendarData: setCalendarData,
                        setCalendarAlerts: setCalendarAlerts,
                        navigate: navigate
                    }),
                    editCalendarDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $e3bdc878ca00cde0$export$a74917dc66a33a41), {
                        selectedRow: selectedRow,
                        editCalendarDialogOpen: editCalendarDialogOpen,
                        setEditCalendarDialogOpen: setEditCalendarDialogOpen,
                        calendarData: calendarData,
                        setCalendarData: setCalendarData,
                        setCalendarAlerts: setCalendarAlerts,
                        rowIndex: rowIndex,
                        setSelectedRow: setSelectedRow,
                        setEditingCalendar: setEditingCalendar,
                        navigate: navigate
                    }),
                    assignedSitesDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $ab30e3a15ec24906$export$5cce3d735af8dc2c), {
                        groupId: selectedRow.group.id,
                        siteArray: selectedRow.customer,
                        assignedSitesDialogOpen: assignedSitesDialogOpen,
                        setAssignedSitesDialogOpen: setAssignedSitesDialogOpen,
                        setUpdatingSites: setUpdatingSites,
                        selectedRow: selectedRow,
                        setCalendarAlerts: setCalendarAlerts,
                        setCalendarData: setCalendarData,
                        calendarData: calendarData,
                        Transition: $8fd061cf8e8d69d2$export$be58926105124dd4,
                        navigate: navigate
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: !navBarCollapsed ? "absolute top-[60px] left-[150px] right-[1px] h-[19px]] bg-white" : "absolute top-[60px] left-[75px] right-[1px] h-[19px]] bg-white",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "font-black font-mulish text-[20px] p-3 indent-6",
                                children: "Calendars"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "absolute top-[7px] right-[30px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b32604d1b8d94d0b$export$60a6671944a0e6f0), {
                                    setAddCalendarScreenOpen: setAddCalendarScreenOpen
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: !navBarCollapsed ? "absolute left-[135px] top-[10px]" : "absolute left-[60px] top-[10px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $c716f24a56dca3fc$export$2186db845d83391c), {
                            setCalendarsSearchString: setCalendarsSearchString
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: !navBarCollapsed ? "absolute left-[500px] top-[10px]" : "absolute left-[425px] top-[10px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dcf3175213d3d23d$export$e61a7e8e2c301e8e), {
                            setFetchingCalendarData: setFetchingCalendarData,
                            setCalendarData: setCalendarData,
                            calendarsSearchString: calendarsSearchString,
                            setPage: setPage,
                            setShowMoreDialogOpen: setShowMoreDialogOpen,
                            setSelectedRow: setSelectedRow,
                            navigate: navigate
                        })
                    }),
                    !fetchingCalendarData && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: !navBarCollapsed ? "absolute left-[150px] top-[130px]" : "absolute left-[75px] top-[130px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1bf2d29e1314bdca$export$14339a52e0dcfa6d), {
                            calendarData: calendarData,
                            page: page,
                            setPage: setPage,
                            rowsPerPage: rowsPerPage,
                            setRowsPerPage: setRowsPerPage,
                            handleSelectAllClick: handleSelectAllClick,
                            isSelected: isSelected,
                            handleSingleCheckboxClick: handleSingleCheckboxClick,
                            setSelectedRow: setSelectedRow,
                            setShowMoreDialogOpen: setShowMoreDialogOpen,
                            setLoadingEventData: setLoadingEventData,
                            setCalendarEvents: setCalendarEvents,
                            setCalendarId: setCalendarId,
                            setDeleteCalendarDialogOpen: setDeleteCalendarDialogOpen,
                            setDeletedCalendarId: setDeletedCalendarId,
                            setRowIndex: setRowIndex,
                            setAssignedSitesDialogOpen: setAssignedSitesDialogOpen,
                            navigate: navigate
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "justify-start",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jVN1H.NavBar), {
                    navBarCollapsed: navBarCollapsed,
                    setNavBarCollapsed: setNavBarCollapsed,
                    props: {}
                })
            })
        ]
    });
};



var $iKAtE = parcelRequire("iKAtE");

var $433j1 = parcelRequire("433j1");

var $gus0k = parcelRequire("gus0k");

var $kRZvb = parcelRequire("kRZvb");

var $f3puC = parcelRequire("f3puC");


var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");
const $faa3af8218e5ecf5$export$8448af45fdc229b5 = ({ site: site, busy: busy, onCancel: onCancel, onConfirm: onConfirm })=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: site !== null,
        onClose: busy ? undefined : onCancel,
        "aria-labelledby": "unlink-remote-link-title",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "unlink-remote-link-title",
                sx: {
                    fontFamily: "Mulish",
                    color: "#001943",
                    fontWeight: "bold"
                },
                children: "Unlink Immix site?"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                children: site && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "font-mulish text-actuate-blue",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                            className: "mb-[12px]",
                            children: [
                                "Immix site",
                                " ",
                                /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                    className: "font-bold",
                                    children: site.immix_group_name
                                }),
                                " will no longer arm or disarm Actuate site",
                                " ",
                                /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                    className: "font-bold",
                                    children: site.admin_group_name
                                }),
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("ul", {
                            className: "list-disc pl-[20px] space-y-[6px] text-[14px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("li", {
                                    children: "Arm/disarm signals Immix keeps sending for this site will be ignored. The site will show under Unmapped Sites so it can be linked again later."
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("li", {
                                    children: "Schedules were disabled when Remote Link was enabled and are not turned back on automatically. The site stays in its current armed state until you set up a schedule on its Schedules tab or arm/disarm it manually."
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("li", {
                                    children: "Remove the Actuate external system link in Immix as well if you want Immix to stop sending signals for this site."
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        text: "Cancel",
                        onClick: onCancel,
                        disabled: busy
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        text: busy ? "Unlinking\u2026" : "Unlink",
                        onClick: onConfirm,
                        disabled: busy
                    })
                ]
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $9pphU = parcelRequire("9pphU");
const $1f6b01eb507c567c$export$b2cd6ff4f096eb6a = (option)=>option.site_count === 1;
const $1f6b01eb507c567c$export$bbbcd761e8e0beeb = (option)=>option.site_id != null ? `${option.name} (#${option.site_id})` : option.name;
const $1f6b01eb507c567c$export$29f6943a35132edd = (siteId)=>`/sites/aboutsite/${siteId}`;
const $1f6b01eb507c567c$export$ae8be6f549b2a70e = (0, $9pphU.createFilterOptions)({
    ignoreCase: true,
    ignoreAccents: true,
    trim: true,
    stringify: (option)=>[
            option.name,
            option.site_name ?? "",
            option.site_id != null ? `#${option.site_id} ${option.site_id}` : ""
        ].join(" ")
});
const $1f6b01eb507c567c$export$feb7d97e9da30d12 = ({ siteId: siteId, label: label })=>/*#__PURE__*/ (0, $k4ank.jsx)("a", {
        href: $1f6b01eb507c567c$export$29f6943a35132edd(siteId),
        target: "_blank",
        rel: "noopener noreferrer",
        "aria-label": `Open site ${siteId} in a new tab`,
        className: "shrink-0 font-mulish text-[13px] text-actuate-orange underline hover:text-[#E67300]",
        onMouseDown: (event)=>event.stopPropagation(),
        onClick: (event)=>event.stopPropagation(),
        children: label
    });



var $k8Qy8 = parcelRequire("k8Qy8");

var $ha39s = parcelRequire("ha39s");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $8B8vg = parcelRequire("8B8vg");
var $gXvgZ = parcelRequire("gXvgZ");
var $eejVe = parcelRequire("eejVe");

var $cpJfj = parcelRequire("cpJfj");

var $djxj8 = parcelRequire("djxj8");

var $60vL1 = parcelRequire("60vL1");
const $cdc935dcc6369b95$export$f0cf417f9d5bd992 = ()=>{
    const { immixRemotelinkDialogOpen: immixRemotelinkDialogOpen, setImmixRemotelinkDialogOpen: setImmixRemotelinkDialogOpen, remoteLinkSites: remoteLinkSites, fetchingImmixRemoteLinkData: fetchingImmixRemoteLinkData, getImmixRemoteLinkData: getImmixRemoteLinkData, mappedSites: mappedSites, unmappedSites: unmappedSites, updateImmixRemoteLinkData: updateImmixRemoteLinkData, unlinkImmixRemoteLinkData: unlinkImmixRemoteLinkData, resetImmixRemoteLinkData: resetImmixRemoteLinkData, updatingImmixRemoteLinkData: updatingImmixRemoteLinkData } = (0, $0bb5fda2d17b239c$export$97ac24bd611f62c0)();
    const navigate = (0, $3T949.useNavigate)();
    const [localMappedSites, setLocalMappedSites] = $8T3gX.useState({});
    // Mapped-site row whose "Unlink" button was clicked; drives the confirm
    // dialog. null = closed.
    const [siteToUnlink, setSiteToUnlink] = $8T3gX.useState(null);
    $8T3gX.useEffect(()=>{
        resetImmixRemoteLinkData();
        getImmixRemoteLinkData(navigate);
    }, []);
    // Close the confirm as soon as the site has left Mapped Sites. The store
    // moves it there on success, including when the shared error handler's
    // retry (after a token refresh) is what succeeded, whose result the
    // onConfirm await never sees.
    $8T3gX.useEffect(()=>{
        if (siteToUnlink && !mappedSites.some((s)=>s.id === siteToUnlink.id)) setSiteToUnlink(null);
    }, [
        mappedSites,
        siteToUnlink
    ]);
    const siteOptions = $8T3gX.useMemo(()=>remoteLinkSites.filter((0, $1f6b01eb507c567c$export$b2cd6ff4f096eb6a)), [
        remoteLinkSites
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "absolute",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                open: immixRemotelinkDialogOpen,
                TransitionComponent: (0, $8fd061cf8e8d69d2$export$be58926105124dd4),
                fullScreen: true,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $djxj8.default), {
                        sx: {
                            color: "#fff",
                            zIndex: (theme)=>theme.zIndex.modal + 1
                        },
                        open: updatingImmixRemoteLinkData,
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                            sx: {
                                color: "#FF8400"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gus0k.default), {
                        sx: {
                            position: "relative"
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kRZvb.default), {
                            sx: {
                                backgroundColor: "#001943"
                            },
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                    edge: "start",
                                    color: "inherit",
                                    onClick: ()=>{
                                        setImmixRemotelinkDialogOpen(false);
                                    },
                                    "aria-label": "close",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                    sx: {
                                        ml: 2,
                                        flex: 1
                                    },
                                    variant: "h6",
                                    component: "div",
                                    children: "Immix Remotelink"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                        children: fetchingImmixRemoteLinkData ? null : /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "font-mulish text-[20px] font-bold text-actuate-blue",
                                    children: "Mapped Sites"
                                }),
                                mappedSites.length > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                    sx: {
                                        width: 1000
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            sx: {
                                                                fontFamily: "Mulish",
                                                                fontWeight: "bold",
                                                                fontSize: 18,
                                                                color: "#FF8400",
                                                                textAlign: "center"
                                                            },
                                                            children: "Immix Site"
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            sx: {
                                                                fontFamily: "Mulish",
                                                                fontWeight: "bold",
                                                                fontSize: 18,
                                                                color: "#FF8400",
                                                                textAlign: "center"
                                                            },
                                                            children: "Actuate Site"
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            sx: {
                                                                fontFamily: "Mulish",
                                                                fontWeight: "bold",
                                                                fontSize: 18,
                                                                color: "#FF8400",
                                                                textAlign: "center",
                                                                width: 140
                                                            },
                                                            children: "Actions"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                children: mappedSites.map((site, index)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        sx: {
                                                            backgroundColor: index % 2 === 0 ? "#f5f5f5" : "transparent"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                sx: {
                                                                    textAlign: "center",
                                                                    borderLeft: "1px solid #e0e0e0",
                                                                    borderRight: "1px solid #e0e0e0",
                                                                    borderBottom: "1px solid #e0e0e0",
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: site.immix_group_name
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                sx: {
                                                                    textAlign: "center",
                                                                    borderRight: "1px solid #e0e0e0",
                                                                    borderBottom: "1px solid #e0e0e0",
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: site.admin_group_name
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                sx: {
                                                                    textAlign: "center",
                                                                    borderRight: "1px solid #e0e0e0",
                                                                    borderBottom: "1px solid #e0e0e0",
                                                                    fontFamily: "Mulish"
                                                                },
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                                                    type: "button",
                                                                    "aria-label": `Unlink ${site.immix_group_name}`,
                                                                    disabled: updatingImmixRemoteLinkData,
                                                                    onClick: ()=>setSiteToUnlink(site),
                                                                    className: "font-mulish text-base text-actuate-blue underline hover:text-[#E67300] disabled:text-[#A9A9A9] disabled:no-underline",
                                                                    children: "Unlink"
                                                                })
                                                            })
                                                        ]
                                                    }, site.id))
                                            })
                                        ]
                                    })
                                }),
                                mappedSites.length === 0 && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "font-mulish text-[16px] text-actuate-blue mt-[20px]",
                                    children: "No mapped Immix sites found."
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "font-mulish text-[20px] font-bold text-actuate-blue mt-[35px]",
                                    children: "Unmapped Sites"
                                }),
                                unmappedSites.length > 0 && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "font-mulish text-[16px] text-actuate-blue",
                                            children: "Please map the following Immix sites to Actuate sites to ensure signals are being received properly."
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                            sx: {
                                                width: 1000
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                                sx: {
                                                    tableLayout: "fixed"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    sx: {
                                                                        fontFamily: "Mulish",
                                                                        fontWeight: "bold",
                                                                        fontSize: 18,
                                                                        color: "#FF8400",
                                                                        textAlign: "center",
                                                                        width: "50%"
                                                                    },
                                                                    children: "Immix Site"
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    sx: {
                                                                        fontFamily: "Mulish",
                                                                        fontWeight: "bold",
                                                                        fontSize: 18,
                                                                        color: "#FF8400",
                                                                        textAlign: "center",
                                                                        width: "50%"
                                                                    },
                                                                    children: "Actuate Site"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                        children: unmappedSites.map((site, index)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                                sx: {
                                                                    backgroundColor: index % 2 === 0 ? "#f5f5f5" : "transparent"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                        sx: {
                                                                            textAlign: "center",
                                                                            borderLeft: "1px solid #e0e0e0",
                                                                            borderRight: "1px solid #e0e0e0",
                                                                            borderBottom: "1px solid #e0e0e0",
                                                                            fontFamily: "Mulish",
                                                                            width: "50%"
                                                                        },
                                                                        children: site.immix_group_name
                                                                    }),
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                        sx: {
                                                                            textAlign: "center",
                                                                            borderRight: "1px solid #e0e0e0",
                                                                            borderBottom: "1px solid #e0e0e0",
                                                                            fontFamily: "Mulish",
                                                                            width: "50%"
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                            className: "flex",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                                                                    disablePortal: true,
                                                                                    options: siteOptions,
                                                                                    getOptionLabel: (0, $1f6b01eb507c567c$export$bbbcd761e8e0beeb),
                                                                                    filterOptions: (0, $1f6b01eb507c567c$export$ae8be6f549b2a70e),
                                                                                    isOptionEqualToValue: (option, value)=>option.id === value.id,
                                                                                    renderOption: (props, option)=>/*#__PURE__*/ (0, $8T3gX.createElement)("li", {
                                                                                            ...props,
                                                                                            key: option.id
                                                                                        }, /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                                            className: "flex w-full items-center gap-[10px]",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                                                                    className: "grow text-left",
                                                                                                    children: option.name
                                                                                                }),
                                                                                                option.site_id != null && /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                                                                                                    className: "shrink-0 text-[12px] text-[#6b7280]",
                                                                                                    children: [
                                                                                                        "Site #",
                                                                                                        option.site_id
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        })),
                                                                                    onChange: (event, newInputValue)=>{
                                                                                        if (newInputValue) setLocalMappedSites({
                                                                                            ...localMappedSites,
                                                                                            [site.id]: {
                                                                                                id: site.id,
                                                                                                admin_group_id: newInputValue.id,
                                                                                                site_id: newInputValue.site_id ?? null
                                                                                            }
                                                                                        });
                                                                                        else {
                                                                                            const next = {
                                                                                                ...localMappedSites
                                                                                            };
                                                                                            delete next[site.id];
                                                                                            setLocalMappedSites(next);
                                                                                        }
                                                                                    },
                                                                                    sx: {
                                                                                        width: "450px"
                                                                                    },
                                                                                    renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                                            ...params,
                                                                                            variant: "standard",
                                                                                            autoComplete: "off",
                                                                                            placeholder: "Search by site name or number"
                                                                                        })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                                    className: "ml-[15px]"
                                                                                }),
                                                                                localMappedSites[site.id]?.site_id != null && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                                    className: "mr-[15px] self-center whitespace-nowrap",
                                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1f6b01eb507c567c$export$feb7d97e9da30d12), {
                                                                                        siteId: localMappedSites[site.id].site_id,
                                                                                        label: `View site #${localMappedSites[site.id].site_id} \u{2197}`
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $cpJfj.ActuateButton), {
                                                                                    disabled: !localMappedSites[site.id] || !localMappedSites[site.id].admin_group_id,
                                                                                    text: "Save",
                                                                                    onClick: ()=>{
                                                                                        // console.log(localMappedSites[site.immix_group_id]);
                                                                                        updateImmixRemoteLinkData(localMappedSites[site.id], navigate);
                                                                                    }
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            }, site.id))
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                unmappedSites.length === 0 && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "font-mulish text-[16px] text-actuate-blue mt-[20px]",
                                    children: "No unmapped Immix sites found."
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $faa3af8218e5ecf5$export$8448af45fdc229b5), {
                site: siteToUnlink,
                busy: updatingImmixRemoteLinkData,
                onCancel: ()=>setSiteToUnlink(null),
                onConfirm: async ()=>{
                    if (!siteToUnlink) return;
                    const ok = await unlinkImmixRemoteLinkData(siteToUnlink, navigate);
                    if (ok) setSiteToUnlink(null);
                }
            })
        ]
    });
};


const $1ddaf0c78cfa4126$export$590a034acff5c40e = ({ permissions: permissions, navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed })=>{
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    const { pathname: pathname } = (0, $3T949.useLocation)();
    const isPatrol = pathname.includes("patrol");
    const groupTrees = (0, $aYdit.useAppStore)((s)=>isPatrol ? s.groupTreesPatrolOnly : s.groupTrees);
    const setGroupTrees = (0, $aYdit.useAppStore)((s)=>isPatrol ? s.setGroupTreesPatrolOnly : s.setGroupTrees);
    const { updatingBatchSize: updatingBatchSize, batchSize: batchSize, minimumResolutionHeight: minimumResolutionHeight, immixRemotelinkDialogOpen: immixRemotelinkDialogOpen } = (0, $0bb5fda2d17b239c$export$97ac24bd611f62c0)();
    const navigate = (0, $3T949.useNavigate)();
    const clearGroupCountsCache = (0, $0bb5fda2d17b239c$export$97ac24bd611f62c0)((state)=>state.clearGroupCountsCache);
    const [page, setPage] = $8T3gX.useState(Number(localStorage.sitesTablePage) || 0);
    // Clear the group counts cache when the component mounts
    $8T3gX.useEffect(()=>{
        clearGroupCountsCache();
    }, [
        clearGroupCountsCache
    ]);
    const [rowsPerPage, setRowsPerPage] = $8T3gX.useState(Number(localStorage.sitesRowsPerPage) || 10);
    const [selected, setSelected] = $8T3gX.useState([]);
    $8T3gX.useEffect(()=>{
        const raw = window.location.pathname.includes("patrol") ? localStorage.groupTreesPatrolOnly : localStorage.groupTrees;
        if (raw != null && raw !== "") try {
            setGroupTrees(JSON.parse(raw));
        } catch  {
            setGroupTrees([]);
        }
    }, [
        window.location.pathname
    ]);
    // Refetch when visiting Sites page when there's no cache so groups appear as soon as the API returns
    $8T3gX.useEffect(()=>{
        const raw = window.location.pathname.includes("patrol") ? localStorage.groupTreesPatrolOnly : localStorage.groupTrees;
        let currentGroupsTrees = [];
        if (raw != null && raw !== "") try {
            currentGroupsTrees = JSON.parse(raw);
        } catch  {
            currentGroupsTrees = [];
        }
        if (!currentGroupsTrees[0]) {
            if (pathname.includes("patrol")) (0, $bde4263f39e1c275$export$82933cc467e1704e)(navigate, "patrol");
            else (0, $bde4263f39e1c275$export$82933cc467e1704e)(navigate);
        }
    }, [
        pathname,
        navigate,
        isPatrol
    ]);
    const [selectedIndex, setSelectedIndex] = $8T3gX.useState({
        level1: [],
        level2: [],
        level3: [],
        level4: [],
        level5: [],
        level6: []
    });
    const [renderedRows, setRenderedRows] = $8T3gX.useState([]);
    const [pageLoading, setPageLoading] = $8T3gX.useState(false);
    const [currentTitle, setCurrentTitle] = $8T3gX.useState("");
    const [searchBarValue, setSearchBarValue] = $8T3gX.useState("");
    const [editedparentsGroupsList, setEditedParentGroupList] = $8T3gX.useState([]);
    const [siteDeletedAlert, setSiteDeltedAlert] = $8T3gX.useState(localStorage.siteDeletedAlert);
    const [groupAddedAlert, setGroupAddedAlert] = $8T3gX.useState(false);
    const [backdropLoadingScreenOn, setBackdropLoadingScreenOn] = $8T3gX.useState(false);
    const [siteBreadcrumbs, setSiteBreadcrumbs] = $8T3gX.useState(// JSON.parse(localStorage.currentSiteBreadcrumbs)
    []);
    const [addGroupDialogOpen, setAddGroupDialogOpen] = $8T3gX.useState(false);
    const [searchCamerasDialogOpen, setSearchCamerasDialogOpen] = $8T3gX.useState(false);
    const [siteScreenAlerts, setSiteScreenAlerts] = $8T3gX.useState({
        armGroupSuccess: false,
        disarmGroupSuccess: false,
        deployGroupSuccess: false
    });
    const [siteScreenLoading, setSiteScreenLoading] = $8T3gX.useState(false);
    const [editableGroupSelected, setEditableGroupSelected] = $8T3gX.useState(false);
    const [selectedGroupListName, setSelectedGroupListName] = $8T3gX.useState("");
    const { setSearchGroupId: setSearchGroupId } = (0, $0bb5fda2d17b239c$export$97ac24bd611f62c0)();
    $8T3gX.useEffect(()=>{
        (0, $9b1233e28e731320$export$c833c47a0e6a4215)();
        setPage(0);
        setRenderedRows([]);
        setSiteBreadcrumbs([]);
        setSelected([]);
        setEditableGroupSelected(false);
        setSelectedGroupListName("");
        setSearchBarValue("");
        localStorage.setItem("selectedGroupOrSiteId", "");
    }, [
        pathname
    ]);
    $8T3gX.useEffect(()=>()=>{
            localStorage.setItem("siteDeletedAlert", "false");
            localStorage.setItem("siteSearchBarValue", "");
        }, []);
    $8T3gX.useEffect(()=>{
        if (localStorage.navigatedFromSitesAboutPage === "true" && localStorage.level0Click === "true" || !localStorage.clickedId) {
            setSiteBreadcrumbs([]);
            localStorage.setItem("navigatedFromSitesAboutPage", "false");
        } else if (localStorage.navigatedFromSitesAboutPage === "true" && localStorage.level0Click === "false") {
            setPageLoading(true);
            localStorage.setItem("getIndividualGroupId", localStorage.clickedId);
            setSearchGroupId(localStorage.clickedId);
            (0, $9b1233e28e731320$export$316efaa9553dbeca)(localStorage.clickedId, setRenderedRows, setPageLoading, setSiteBreadcrumbs, setSelected, setEditableGroupSelected, setSelectedGroupListName, navigate);
            localStorage.setItem("navigatedFromSitesAboutPage", "false");
        } else if (localStorage.navigatedFromSitesAboutPage === "false" && localStorage.level0Click === "false" && localStorage.siteJustDeleted !== "true") {
            setSelectedIndex(JSON.parse(localStorage.storedSelectedIndex));
            localStorage.setItem("getIndividualGroupId", localStorage.clickedId);
            setSearchGroupId(localStorage.clickedId);
            (0, $9b1233e28e731320$export$316efaa9553dbeca)(localStorage.clickedId, setRenderedRows, setPageLoading, setSiteBreadcrumbs, setSelected, setEditableGroupSelected, setSelectedGroupListName, navigate);
            localStorage.setItem("navigatedFromSitesAboutPage", "false");
        }
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                openState: updatingBatchSize
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f13baa5d827a51d3$export$b48d3346334f9818), {
                        siteScreenAlerts: siteScreenAlerts,
                        setSiteScreenAlerts: setSiteScreenAlerts
                    }),
                    siteDeletedAlert === "true" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                        onClose: ()=>{
                            setSiteDeltedAlert("false");
                            localStorage.setItem("siteDeletedAlert", "false");
                        },
                        children: "Site deleted successfully!"
                    }),
                    groupAddedAlert && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                        onClose: ()=>{
                            setGroupAddedAlert(false);
                        },
                        children: permissions?.view_empty_group ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                            children: "New Group added successfully!"
                        }) : /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                            children: [
                                " ",
                                "New Group added successfully! New Group will not appear in Parent Groups & Sites list until you\xa0",
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                                    to: "/sites/addsite",
                                    className: "underline underline-offset-1",
                                    children: "Add Site"
                                }),
                                "\xa0 to the group."
                            ]
                        })
                    }),
                    addGroupDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $5cbf3eda628e9bd3$export$a5a8db9596bccfa), {
                        addGroupDialogOpen: addGroupDialogOpen,
                        setAddGroupDialogOpen: setAddGroupDialogOpen,
                        setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                        setGroupAddedAlert: setGroupAddedAlert
                    }),
                    searchCamerasDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2792f70ff2405e0a$export$60adf1bccf0df177), {
                        searchCamerasDialogOpen: searchCamerasDialogOpen,
                        setSearchCamerasDialogOpen: setSearchCamerasDialogOpen,
                        navigate: navigate
                    }),
                    immixRemotelinkDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cdc935dcc6369b95$export$f0cf417f9d5bd992), {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                        openState: backdropLoadingScreenOn
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                        openState: siteScreenLoading
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "bg-actuate-grey absolute w-screen h-screen",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: navBarCollapsed ? "absolute top-[10px] left-[75px] right-[1px] h-[19px]] bg-white" : "absolute top-[10px] left-[150px] right-[1px] h-[19px]] bg-white",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "font-black font-mulish text-[20px] p-3 indent-6",
                                    children: "Sites"
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $de29dda75a71799b$export$b73718dcdc23fe61), {
                                    searchBarValue: searchBarValue,
                                    currentTitle: currentTitle,
                                    pageLoading: pageLoading,
                                    renderedRows: renderedRows,
                                    page: page,
                                    rowsPerPage: rowsPerPage,
                                    setPageLoading: setPageLoading,
                                    navigate: navigate,
                                    groupTrees: groupTrees,
                                    selectedIndex: selectedIndex,
                                    setPage: setPage,
                                    setCurrentTitle: setCurrentTitle,
                                    setSelectedIndex: setSelectedIndex,
                                    setRenderedRows: setRenderedRows,
                                    editedparentsGroupsList: editedparentsGroupsList,
                                    setRowsPerPage: setRowsPerPage,
                                    siteBreadcrumbs: siteBreadcrumbs,
                                    setSiteBreadcrumbs: setSiteBreadcrumbs,
                                    setAddGroupDialogOpen: setAddGroupDialogOpen,
                                    navBarCollapsed: navBarCollapsed,
                                    permissions: permissions,
                                    selected: selected,
                                    setSelected: setSelected,
                                    setSiteScreenAlerts: setSiteScreenAlerts,
                                    setSiteScreenLoading: setSiteScreenLoading,
                                    setSearchBarValue: setSearchBarValue,
                                    setEditedParentGroupList: setEditedParentGroupList,
                                    setBackdropLoadingScreenOn: setBackdropLoadingScreenOn,
                                    editableGroupSelected: editableGroupSelected,
                                    setEditableGroupSelected: setEditableGroupSelected,
                                    selectedGroupListName: selectedGroupListName,
                                    setSelectedGroupListName: setSelectedGroupListName,
                                    setGroupTrees: setGroupTrees,
                                    getIndividualGroup: (0, $9b1233e28e731320$export$316efaa9553dbeca)
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "absolute right-[14vw] top-[18px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    onClick: ()=>{
                                        setSearchCamerasDialogOpen(true);
                                    },
                                    text: "Search Cameras",
                                    disabled: false
                                })
                            }),
                            permissions.add_cameras && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $c5de109ba17f2516$export$61d1096ad4c06c80), {
                                    navigate: navigate
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "justify-start",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jVN1H.NavBar), {
                    navBarCollapsed: navBarCollapsed,
                    setNavBarCollapsed: setNavBarCollapsed,
                    props: {}
                })
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $fc1f706f45bf72ab$export$f81d45315d235306 = ({ text: text, visibleScreen: visibleScreen, styling: styling })=>{
    const navigate = (0, $3T949.useNavigate)();
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "bg-black fixed w-full h-full opacity-90",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "bg-black fixed w-full h-full opacity-10 pointer-events-none"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "flex justify-end text-left",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "absolute top-[50px] h-full bg-white w-[600px]"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "flex justify-end text-left",
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "absolute h-full bg-white w-[600px]",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "bg-actuate-blue absolute w-[600px] h-[50px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                    className: "absolute right-6 top-[10px] text-white text-[18px]",
                                    onClick: ()=>{
                                        localStorage.setItem("cameraNumber", "1");
                                        const cameFromSiteAbout = localStorage.navigatedFromSitesAboutPage === "true" || localStorage.clickedFromSiteAboutPage === "true" || localStorage.addAdditionalCamera === "true";
                                        if (cameFromSiteAbout && localStorage.siteId) navigate(`/sites/aboutsite/${localStorage.siteId}`);
                                        else navigate("/sites");
                                    },
                                    children: "X"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: styling,
                                    children: text
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            children: visibleScreen
                        })
                    ]
                })
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $53b11234ecc265c7$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($53b11234ecc265c7$exports, "__esModule", {
    value: true
});
$53b11234ecc265c7$exports.default = void 0;

var $53b11234ecc265c7$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $53b11234ecc265c7$var$_default = $53b11234ecc265c7$exports.default = (0, $53b11234ecc265c7$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), 'ArrowForward');



var $8jTCz = parcelRequire("8jTCz");

var $k4ank = parcelRequire("k4ank");

var $195EM = parcelRequire("195EM");
parcelRequire("8T3gX");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");


var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");
// ES6 Map
var $80ab0b2358430501$var$map;
try {
    $80ab0b2358430501$var$map = Map;
} catch (_) {}
var $80ab0b2358430501$var$set;
// ES6 Set
try {
    $80ab0b2358430501$var$set = Set;
} catch (_) {}
function $80ab0b2358430501$var$baseClone(src, circulars, clones) {
    // Null/undefined/functions/etc
    if (!src || typeof src !== 'object' || typeof src === 'function') return src;
    // DOM Node
    if (src.nodeType && 'cloneNode' in src) return src.cloneNode(true);
    // Date
    if (src instanceof Date) return new Date(src.getTime());
    // RegExp
    if (src instanceof RegExp) return new RegExp(src);
    // Arrays
    if (Array.isArray(src)) return src.map($80ab0b2358430501$export$2e2bcd8739ae039);
    // ES6 Maps
    if ($80ab0b2358430501$var$map && src instanceof $80ab0b2358430501$var$map) return new Map(Array.from(src.entries()));
    // ES6 Sets
    if ($80ab0b2358430501$var$set && src instanceof $80ab0b2358430501$var$set) return new Set(Array.from(src.values()));
    // Object
    if (src instanceof Object) {
        circulars.push(src);
        var obj = Object.create(src);
        clones.push(obj);
        for(var key in src){
            var idx = circulars.findIndex(function(i) {
                return i === src[key];
            });
            obj[key] = idx > -1 ? clones[idx] : $80ab0b2358430501$var$baseClone(src[key], circulars, clones);
        }
        return obj;
    }
    // ???
    return src;
}
function $80ab0b2358430501$export$2e2bcd8739ae039(src) {
    return $80ab0b2358430501$var$baseClone(src, [], []);
}


const $224039f1d02f653f$var$toString = Object.prototype.toString;
const $224039f1d02f653f$var$errorToString = Error.prototype.toString;
const $224039f1d02f653f$var$regExpToString = RegExp.prototype.toString;
const $224039f1d02f653f$var$symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : ()=>'';
const $224039f1d02f653f$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $224039f1d02f653f$var$printNumber(val) {
    if (val != +val) return 'NaN';
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? '-0' : '' + val;
}
function $224039f1d02f653f$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return '' + val;
    const typeOf = typeof val;
    if (typeOf === 'number') return $224039f1d02f653f$var$printNumber(val);
    if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
    if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
    if (typeOf === 'symbol') return $224039f1d02f653f$var$symbolToString.call(val).replace($224039f1d02f653f$var$SYMBOL_REGEXP, 'Symbol($1)');
    const tag = $224039f1d02f653f$var$toString.call(val).slice(8, -1);
    if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
    if (tag === 'Error' || val instanceof Error) return '[' + $224039f1d02f653f$var$errorToString.call(val) + ']';
    if (tag === 'RegExp') return $224039f1d02f653f$var$regExpToString.call(val);
    return null;
}
function $224039f1d02f653f$export$2e2bcd8739ae039(value, quoteStrings) {
    let result = $224039f1d02f653f$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $224039f1d02f653f$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}


let $f02a12ad0aa7f150$export$9b30b6294c1449a8 = {
    default: '${path} is invalid',
    required: '${path} is a required field',
    oneOf: '${path} must be one of the following values: ${values}',
    notOneOf: '${path} must not be one of the following values: ${values}',
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        let isCast = originalValue != null && originalValue !== value;
        let msg = `${path} must be a \`${type}\` type, ` + `but the final value was: \`${(0, $224039f1d02f653f$export$2e2bcd8739ae039)(value, true)}\`` + (isCast ? ` (cast from the value \`${(0, $224039f1d02f653f$export$2e2bcd8739ae039)(originalValue, true)}\`).` : '.');
        if (value === null) msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
        return msg;
    },
    defined: '${path} must be defined'
};
let $f02a12ad0aa7f150$export$22b082955e083ec3 = {
    length: '${path} must be exactly ${length} characters',
    min: '${path} must be at least ${min} characters',
    max: '${path} must be at most ${max} characters',
    matches: '${path} must match the following: "${regex}"',
    email: '${path} must be a valid email',
    url: '${path} must be a valid URL',
    uuid: '${path} must be a valid UUID',
    trim: '${path} must be a trimmed string',
    lowercase: '${path} must be a lowercase string',
    uppercase: '${path} must be a upper case string'
};
let $f02a12ad0aa7f150$export$98e628dec113755e = {
    min: '${path} must be greater than or equal to ${min}',
    max: '${path} must be less than or equal to ${max}',
    lessThan: '${path} must be less than ${less}',
    moreThan: '${path} must be greater than ${more}',
    positive: '${path} must be a positive number',
    negative: '${path} must be a negative number',
    integer: '${path} must be an integer'
};
let $f02a12ad0aa7f150$export$324d90190a8b822a = {
    min: '${path} field must be later than ${min}',
    max: '${path} field must be at earlier than ${max}'
};
let $f02a12ad0aa7f150$export$4a21f16c33752377 = {
    isValue: '${path} field must be ${value}'
};
let $f02a12ad0aa7f150$export$be5493f9613cbbe = {
    noUnknown: '${path} field has unspecified keys: ${unknown}'
};
let $f02a12ad0aa7f150$export$2f23118c22fb2630 = {
    min: '${path} field must have at least ${min} items',
    max: '${path} field must have less than or equal to ${max} items',
    length: '${path} must have ${length} items'
};
var $f02a12ad0aa7f150$export$2e2bcd8739ae039 = Object.assign(Object.create(null), {
    mixed: $f02a12ad0aa7f150$export$9b30b6294c1449a8,
    string: $f02a12ad0aa7f150$export$22b082955e083ec3,
    number: $f02a12ad0aa7f150$export$98e628dec113755e,
    date: $f02a12ad0aa7f150$export$324d90190a8b822a,
    object: $f02a12ad0aa7f150$export$be5493f9613cbbe,
    array: $f02a12ad0aa7f150$export$2f23118c22fb2630,
    boolean: $f02a12ad0aa7f150$export$4a21f16c33752377
});


var $74f2066a1bc7cb42$exports = {};
var $a58a7c3db55c39dd$exports = {};
/** Used for built-in method references. */ var $a58a7c3db55c39dd$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a58a7c3db55c39dd$var$hasOwnProperty = $a58a7c3db55c39dd$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $a58a7c3db55c39dd$var$baseHas(object, key) {
    return object != null && $a58a7c3db55c39dd$var$hasOwnProperty.call(object, key);
}
$a58a7c3db55c39dd$exports = $a58a7c3db55c39dd$var$baseHas;



/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $74f2066a1bc7cb42$var$has(object, path) {
    return object != null && $eb3af6a59d7130a0$exports(object, path, $a58a7c3db55c39dd$exports);
}
$74f2066a1bc7cb42$exports = $74f2066a1bc7cb42$var$has;


const $d7da6e9a699ca85f$var$isSchema = (obj)=>obj && obj.__isYupSchema__;
var $d7da6e9a699ca85f$export$2e2bcd8739ae039 = $d7da6e9a699ca85f$var$isSchema;


class $fded833dffd8a629$var$Condition {
    constructor(refs, options){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        if (typeof options === 'function') {
            this.fn = options;
            return;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($74f2066a1bc7cb42$exports)))(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
        if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
        let { is: is, then: then, otherwise: otherwise } = options;
        let check = typeof is === 'function' ? is : (...values)=>values.every((value)=>value === is);
        this.fn = function(...args) {
            let options = args.pop();
            let schema = args.pop();
            let branch = check(...args) ? then : otherwise;
            if (!branch) return undefined;
            if (typeof branch === 'function') return branch(schema);
            return schema.concat(branch.resolve(options));
        };
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn.apply(base, values.concat(base, options));
        if (schema === undefined || schema === base) return base;
        if (!(0, $d7da6e9a699ca85f$export$2e2bcd8739ae039)(schema)) throw new TypeError('conditions must return a schema object');
        return schema.resolve(options);
    }
}
var $fded833dffd8a629$export$2e2bcd8739ae039 = $fded833dffd8a629$var$Condition;



function $f84295837eebec9e$export$2e2bcd8739ae039(value) {
    return value == null ? [] : [].concat(value);
}


function $2e2c275a7d6d86e9$var$_extends() {
    $2e2c275a7d6d86e9$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2e2c275a7d6d86e9$var$_extends.apply(this, arguments);
}
let $2e2c275a7d6d86e9$var$strReg = /\$\{\s*(\w+)\s*\}/g;
class $2e2c275a7d6d86e9$export$2e2bcd8739ae039 extends Error {
    static formatError(message, params) {
        const path = params.label || params.path || 'this';
        if (path !== params.path) params = $2e2c275a7d6d86e9$var$_extends({}, params, {
            path: path
        });
        if (typeof message === 'string') return message.replace($2e2c275a7d6d86e9$var$strReg, (_, key)=>(0, $224039f1d02f653f$export$2e2bcd8739ae039)(params[key]));
        if (typeof message === 'function') return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === 'ValidationError';
    }
    constructor(errorOrErrors, value, field, type){
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.errors = void 0;
        this.params = void 0;
        this.inner = void 0;
        this.name = 'ValidationError';
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        (0, $f84295837eebec9e$export$2e2bcd8739ae039)(errorOrErrors).forEach((err)=>{
            if ($2e2c275a7d6d86e9$export$2e2bcd8739ae039.isError(err)) {
                this.errors.push(...err.errors);
                this.inner = this.inner.concat(err.inner.length ? err.inner : err);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
        if (Error.captureStackTrace) Error.captureStackTrace(this, $2e2c275a7d6d86e9$export$2e2bcd8739ae039);
    }
}


const $6d4d63260c35feb3$var$once = (cb)=>{
    let fired = false;
    return (...args)=>{
        if (fired) return;
        fired = true;
        cb(...args);
    };
};
function $6d4d63260c35feb3$export$2e2bcd8739ae039(options, cb) {
    let { endEarly: endEarly, tests: tests, args: args, value: value, errors: errors, sort: sort, path: path } = options;
    let callback = $6d4d63260c35feb3$var$once(cb);
    let count = tests.length;
    const nestedErrors = [];
    errors = errors ? errors : [];
    if (!count) return errors.length ? callback(new (0, $2e2c275a7d6d86e9$export$2e2bcd8739ae039)(errors, value, path)) : callback(null, value);
    for(let i = 0; i < tests.length; i++){
        const test = tests[i];
        test(args, function finishTestRun(err) {
            if (err) {
                // always return early for non validation errors
                if (!(0, $2e2c275a7d6d86e9$export$2e2bcd8739ae039).isError(err)) return callback(err, value);
                if (endEarly) {
                    err.value = value;
                    return callback(err, value);
                }
                nestedErrors.push(err);
            }
            if (--count <= 0) {
                if (nestedErrors.length) {
                    if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name
                    if (errors.length) nestedErrors.push(...errors);
                    errors = nestedErrors;
                }
                if (errors.length) {
                    callback(new (0, $2e2c275a7d6d86e9$export$2e2bcd8739ae039)(errors, value, path), value);
                    return;
                }
                callback(null, value);
            }
        });
    }
}




var $244f7b149ccbb36d$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ 'use strict';
function $244f7b149ccbb36d$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$244f7b149ccbb36d$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$244f7b149ccbb36d$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$244f7b149ccbb36d$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $244f7b149ccbb36d$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $244f7b149ccbb36d$var$DIGIT_REGEX = /^\d+$/, $244f7b149ccbb36d$var$LEAD_DIGIT_REGEX = /^\d/, $244f7b149ccbb36d$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $244f7b149ccbb36d$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $244f7b149ccbb36d$var$MAX_CACHE_SIZE = 512;
var $244f7b149ccbb36d$var$pathCache = new $244f7b149ccbb36d$var$Cache($244f7b149ccbb36d$var$MAX_CACHE_SIZE), $244f7b149ccbb36d$var$setCache = new $244f7b149ccbb36d$var$Cache($244f7b149ccbb36d$var$MAX_CACHE_SIZE), $244f7b149ccbb36d$var$getCache = new $244f7b149ccbb36d$var$Cache($244f7b149ccbb36d$var$MAX_CACHE_SIZE);
var $244f7b149ccbb36d$var$config;
$244f7b149ccbb36d$exports = {
    Cache: $244f7b149ccbb36d$var$Cache,
    split: $244f7b149ccbb36d$var$split,
    normalizePath: $244f7b149ccbb36d$var$normalizePath,
    setter: function(path) {
        var parts = $244f7b149ccbb36d$var$normalizePath(path);
        return $244f7b149ccbb36d$var$setCache.get(path) || $244f7b149ccbb36d$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === '__proto__' || part === 'constructor' || part === 'prototype') return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $244f7b149ccbb36d$var$normalizePath(path);
        return $244f7b149ccbb36d$var$getCache.get(path) || $244f7b149ccbb36d$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($244f7b149ccbb36d$var$isQuoted(part) || $244f7b149ccbb36d$var$DIGIT_REGEX.test(part) ? '[' + part + ']' : (path ? '.' : '') + part);
        }, '');
    },
    forEach: function(path, cb, thisArg) {
        $244f7b149ccbb36d$var$forEach(Array.isArray(path) ? path : $244f7b149ccbb36d$var$split(path), cb, thisArg);
    }
};
function $244f7b149ccbb36d$var$normalizePath(path) {
    return $244f7b149ccbb36d$var$pathCache.get(path) || $244f7b149ccbb36d$var$pathCache.set(path, $244f7b149ccbb36d$var$split(path).map(function(part) {
        return part.replace($244f7b149ccbb36d$var$CLEAN_QUOTES_REGEX, '$2');
    }));
}
function $244f7b149ccbb36d$var$split(path) {
    return path.match($244f7b149ccbb36d$var$SPLIT_REGEX) || [
        ''
    ];
}
function $244f7b149ccbb36d$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($244f7b149ccbb36d$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $244f7b149ccbb36d$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $244f7b149ccbb36d$var$isQuoted(str) {
    return typeof str === 'string' && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $244f7b149ccbb36d$var$hasLeadingNumber(part) {
    return part.match($244f7b149ccbb36d$var$LEAD_DIGIT_REGEX) && !part.match($244f7b149ccbb36d$var$DIGIT_REGEX);
}
function $244f7b149ccbb36d$var$hasSpecialChars(part) {
    return $244f7b149ccbb36d$var$SPEC_CHAR_REGEX.test(part);
}
function $244f7b149ccbb36d$var$shouldBeQuoted(part) {
    return !$244f7b149ccbb36d$var$isQuoted(part) && ($244f7b149ccbb36d$var$hasLeadingNumber(part) || $244f7b149ccbb36d$var$hasSpecialChars(part));
}


const $4f7105e0eeed856b$var$prefixes = {
    context: '$',
    value: '.'
};
function $4f7105e0eeed856b$export$185802fd694ee1f5(key, options) {
    return new $4f7105e0eeed856b$export$2e2bcd8739ae039(key, options);
}
class $4f7105e0eeed856b$export$2e2bcd8739ae039 {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
        this.key = key.trim();
        if (key === '') throw new TypeError('ref must be a non-empty string');
        this.isContext = this.key[0] === $4f7105e0eeed856b$var$prefixes.context;
        this.isValue = this.key[0] === $4f7105e0eeed856b$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $4f7105e0eeed856b$var$prefixes.context : this.isValue ? $4f7105e0eeed856b$var$prefixes.value : '';
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $244f7b149ccbb36d$exports.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: 'ref',
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
} // @ts-ignore
$4f7105e0eeed856b$export$2e2bcd8739ae039.prototype.__isYupRef = true;


function $57d6b939d99056cf$var$_extends() {
    $57d6b939d99056cf$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $57d6b939d99056cf$var$_extends.apply(this, arguments);
}
function $57d6b939d99056cf$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $57d6b939d99056cf$export$2e2bcd8739ae039(config) {
    function validate(_ref, cb) {
        let { value: value, path: path = '', label: label, options: options, originalValue: originalValue, sync: sync } = _ref, rest = $57d6b939d99056cf$var$_objectWithoutPropertiesLoose(_ref, [
            "value",
            "path",
            "label",
            "options",
            "originalValue",
            "sync"
        ]);
        const { name: name, test: test, params: params, message: message } = config;
        let { parent: parent, context: context } = options;
        function resolve(item) {
            return (0, $4f7105e0eeed856b$export$2e2bcd8739ae039).isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = (0, (/*@__PURE__*/$parcel$interopDefault($25b56b7191d13321$exports)))($57d6b939d99056cf$var$_extends({
                value: value,
                originalValue: originalValue,
                label: label,
                path: overrides.path || path
            }, params, overrides.params), resolve);
            const error = new (0, $2e2c275a7d6d86e9$export$2e2bcd8739ae039)((0, $2e2c275a7d6d86e9$export$2e2bcd8739ae039).formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
            error.params = nextParams;
            return error;
        }
        let ctx = $57d6b939d99056cf$var$_extends({
            path: path,
            parent: parent,
            type: name,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue
        }, rest);
        if (!sync) {
            try {
                Promise.resolve(test.call(ctx, value, ctx)).then((validOrError)=>{
                    if ((0, $2e2c275a7d6d86e9$export$2e2bcd8739ae039).isError(validOrError)) cb(validOrError);
                    else if (!validOrError) cb(createError());
                    else cb(null, validOrError);
                }).catch(cb);
            } catch (err) {
                cb(err);
            }
            return;
        }
        let result;
        try {
            var _ref2;
            result = test.call(ctx, value, ctx);
            if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === 'function') throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
        } catch (err) {
            cb(err);
            return;
        }
        if ((0, $2e2c275a7d6d86e9$export$2e2bcd8739ae039).isError(result)) cb(result);
        else if (!result) cb(createError());
        else cb(null, result);
    }
    validate.OPTIONS = config;
    return validate;
}





let $c6a1207b7c9e6e88$var$trim = (part)=>part.substr(0, part.length - 1).substr(1);
function $c6a1207b7c9e6e88$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug; // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $244f7b149ccbb36d$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? $c6a1207b7c9e6e88$var$trim(_part) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        if (schema.innerType) {
            let idx = isArray ? parseInt(part, 10) : 0;
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = schema.innerType;
        } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema._type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
const $c6a1207b7c9e6e88$var$reach = (obj, path, value, context)=>$c6a1207b7c9e6e88$export$c52e5867d5879e24(obj, path, value, context).schema;
var $c6a1207b7c9e6e88$export$2e2bcd8739ae039 = $c6a1207b7c9e6e88$var$reach;




class $a9fa3ac512a67a4e$export$2e2bcd8739ae039 {
    constructor(){
        this.list = void 0;
        this.refs = void 0;
        this.list = new Set();
        this.refs = new Map();
    }
    get size() {
        return this.list.size + this.refs.size;
    }
    describe() {
        const description = [];
        for (const item of this.list)description.push(item);
        for (const [, ref] of this.refs)description.push(ref.describe());
        return description;
    }
    toArray() {
        return Array.from(this.list).concat(Array.from(this.refs.values()));
    }
    resolveAll(resolve) {
        return this.toArray().reduce((acc, e)=>acc.concat((0, $4f7105e0eeed856b$export$2e2bcd8739ae039).isRef(e) ? resolve(e) : e), []);
    }
    add(value) {
        (0, $4f7105e0eeed856b$export$2e2bcd8739ae039).isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
    }
    delete(value) {
        (0, $4f7105e0eeed856b$export$2e2bcd8739ae039).isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
    }
    clone() {
        const next = new $a9fa3ac512a67a4e$export$2e2bcd8739ae039();
        next.list = new Set(this.list);
        next.refs = new Map(this.refs);
        return next;
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.list.forEach((value)=>next.add(value));
        newItems.refs.forEach((value)=>next.add(value));
        removeItems.list.forEach((value)=>next.delete(value));
        removeItems.refs.forEach((value)=>next.delete(value));
        return next;
    }
}



function $35699de99cca2c54$var$_extends() {
    $35699de99cca2c54$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $35699de99cca2c54$var$_extends.apply(this, arguments);
}
class $35699de99cca2c54$export$2e2bcd8739ae039 {
    constructor(options){
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this._typeError = void 0;
        this._whitelist = new (0, $a9fa3ac512a67a4e$export$2e2bcd8739ae039)();
        this._blacklist = new (0, $a9fa3ac512a67a4e$export$2e2bcd8739ae039)();
        this.exclusiveTests = Object.create(null);
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError((0, $f02a12ad0aa7f150$export$9b30b6294c1449a8).notType);
        });
        this.type = (options == null ? void 0 : options.type) || 'mixed';
        this.spec = $35699de99cca2c54$var$_extends({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            nullable: false,
            presence: 'optional'
        }, options == null ? void 0 : options.spec);
    }
    get _type() {
        return this.type;
    }
    _typeCheck(_value) {
        return true;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        } // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this)); // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeError = this._typeError;
        next._whitelistError = this._whitelistError;
        next._blacklistError = this._blacklistError;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.exclusiveTests = $35699de99cca2c54$var$_extends({}, this.exclusiveTests); // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = (0, $80ab0b2358430501$export$2e2bcd8739ae039)($35699de99cca2c54$var$_extends({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    //   TCast,
    //   TContext,
    //   TOutput
    // > {
    //   return this as any;
    // }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = $35699de99cca2c54$var$_extends({}, base.spec, combined.spec); // if (combined.spec.nullable === UNSET)
        //   mergedSpec.nullable = base.spec.nullable;
        // if (combined.spec.presence === UNSET)
        //   mergedSpec.presence = base.spec.presence;
        combined.spec = mergedSpec;
        combined._typeError || (combined._typeError = base._typeError);
        combined._whitelistError || (combined._whitelistError = base._whitelistError);
        combined._blacklistError || (combined._blacklistError = base._blacklistError); // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist); // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests; // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (this.spec.nullable && v === null) return true;
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((schema, condition)=>condition.resolve(schema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve($35699de99cca2c54$var$_extends({
            value: value
        }, options));
        let result = resolvedSchema._cast(value, options);
        if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
            let formattedValue = (0, $224039f1d02f653f$export$2e2bcd8739ae039)(value);
            let formattedResult = (0, $224039f1d02f653f$export$2e2bcd8739ae039)(result);
            throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema._type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
        }
        return result;
    }
    _cast(rawValue, _options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((value, fn)=>fn.call(this, value, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault();
        return value;
    }
    _validate(_value, options = {}, cb) {
        let { sync: sync, path: path, from: from = [], originalValue: originalValue = _value, strict: strict = this.spec.strict, abortEarly: abortEarly = this.spec.abortEarly } = options;
        let value = _value;
        if (!strict) // this._validating = true;
        value = this._cast(value, $35699de99cca2c54$var$_extends({
            assert: false
        }, options)); // this._validating = false;
         // value is cast, we can check if it meets type requirements
        let args = {
            value: value,
            path: path,
            options: options,
            originalValue: originalValue,
            schema: this,
            label: this.spec.label,
            sync: sync,
            from: from
        };
        let initialTests = [];
        if (this._typeError) initialTests.push(this._typeError);
        let finalTests = [];
        if (this._whitelistError) finalTests.push(this._whitelistError);
        if (this._blacklistError) finalTests.push(this._blacklistError);
        (0, $6d4d63260c35feb3$export$2e2bcd8739ae039)({
            args: args,
            value: value,
            path: path,
            sync: sync,
            tests: initialTests,
            endEarly: abortEarly
        }, (err)=>{
            if (err) return void cb(err, value);
            (0, $6d4d63260c35feb3$export$2e2bcd8739ae039)({
                tests: this.tests.concat(finalTests),
                args: args,
                path: path,
                sync: sync,
                value: value,
                endEarly: abortEarly
            }, cb);
        });
    }
    validate(value, options, maybeCb) {
        let schema = this.resolve($35699de99cca2c54$var$_extends({}, options, {
            value: value
        })); // callback case is for nested validations
        return typeof maybeCb === 'function' ? schema._validate(value, options, maybeCb) : new Promise((resolve, reject)=>schema._validate(value, options, (err, value)=>{
                if (err) reject(err);
                else resolve(value);
            }));
    }
    validateSync(value, options) {
        let schema = this.resolve($35699de99cca2c54$var$_extends({}, options, {
            value: value
        }));
        let result;
        schema._validate(value, $35699de99cca2c54$var$_extends({}, options, {
            sync: true
        }), (err, value)=>{
            if (err) throw err;
            result = value;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ((0, $2e2c275a7d6d86e9$export$2e2bcd8739ae039).isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ((0, $2e2c275a7d6d86e9$export$2e2bcd8739ae039).isError(err)) return false;
            throw err;
        }
    }
    _getDefault() {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === 'function' ? defaultValue.call(this) : (0, $80ab0b2358430501$export$2e2bcd8739ae039)(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault();
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        let next = this.clone();
        next.spec.strict = isStrict;
        return next;
    }
    _isPresent(value) {
        return value != null;
    }
    defined(message = (0, $f02a12ad0aa7f150$export$9b30b6294c1449a8).defined) {
        return this.test({
            message: message,
            name: 'defined',
            exclusive: true,
            test (value) {
                return value !== undefined;
            }
        });
    }
    required(message = (0, $f02a12ad0aa7f150$export$9b30b6294c1449a8).required) {
        return this.clone({
            presence: 'required'
        }).withMutation((s)=>s.test({
                message: message,
                name: 'required',
                exclusive: true,
                test (value) {
                    return this.schema._isPresent(value);
                }
            }));
    }
    notRequired() {
        let next = this.clone({
            presence: 'optional'
        });
        next.tests = next.tests.filter((test)=>test.OPTIONS.name !== 'required');
        return next;
    }
    nullable(isNullable = true) {
        let next = this.clone({
            nullable: isNullable !== false
        });
        return next;
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === 'function') opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = (0, $f02a12ad0aa7f150$export$9b30b6294c1449a8).default;
        if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
        let next = this.clone();
        let validate = (0, $57d6b939d99056cf$export$2e2bcd8739ae039)(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== 'string') {
            options = keys;
            keys = '.';
        }
        let next = this.clone();
        let deps = (0, $f84295837eebec9e$export$2e2bcd8739ae039)(keys).map((key)=>new (0, $4f7105e0eeed856b$export$2e2bcd8739ae039)(key));
        deps.forEach((dep)=>{
            // @ts-ignore
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(new (0, $fded833dffd8a629$export$2e2bcd8739ae039)(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next._typeError = (0, $57d6b939d99056cf$export$2e2bcd8739ae039)({
            message: message,
            name: 'typeError',
            test (value) {
                if (value !== undefined && !this.schema.isType(value)) return this.createError({
                    params: {
                        type: this.schema._type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = (0, $f02a12ad0aa7f150$export$9b30b6294c1449a8).oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next._whitelistError = (0, $57d6b939d99056cf$export$2e2bcd8739ae039)({
            message: message,
            name: 'oneOf',
            test (value) {
                if (value === undefined) return true;
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: valids.toArray().join(', '),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = (0, $f02a12ad0aa7f150$export$9b30b6294c1449a8).notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next._blacklistError = (0, $57d6b939d99056cf$export$2e2bcd8739ae039)({
            message: message,
            name: 'notOneOf',
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: invalids.toArray().join(', '),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    describe() {
        const next = this.clone();
        const { label: label, meta: meta } = next.spec;
        const description = {
            meta: meta,
            label: label,
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
} // eslint-disable-next-line @typescript-eslint/no-unused-vars
// @ts-expect-error
$35699de99cca2c54$export$2e2bcd8739ae039.prototype.__isYupSchema__ = true;
for (const method of [
    'validate',
    'validateSync'
])$35699de99cca2c54$export$2e2bcd8739ae039.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = (0, $c6a1207b7c9e6e88$export$c52e5867d5879e24)(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], $35699de99cca2c54$var$_extends({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    'equals',
    'is'
])$35699de99cca2c54$export$2e2bcd8739ae039.prototype[alias] = $35699de99cca2c54$export$2e2bcd8739ae039.prototype.oneOf;
for (const alias of [
    'not',
    'nope'
])$35699de99cca2c54$export$2e2bcd8739ae039.prototype[alias] = $35699de99cca2c54$export$2e2bcd8739ae039.prototype.notOneOf;
$35699de99cca2c54$export$2e2bcd8739ae039.prototype.optional = $35699de99cca2c54$export$2e2bcd8739ae039.prototype.notRequired;


const $4e760df7064085f7$var$Mixed = (0, $35699de99cca2c54$export$2e2bcd8739ae039);
var $4e760df7064085f7$export$2e2bcd8739ae039 = $4e760df7064085f7$var$Mixed;
function $4e760df7064085f7$export$185802fd694ee1f5() {
    return new $4e760df7064085f7$var$Mixed();
} // XXX: this is using the Base schema so that `addMethod(mixed)` works as a base class
$4e760df7064085f7$export$185802fd694ee1f5.prototype = $4e760df7064085f7$var$Mixed.prototype;




const $aaf7b0e5e55bfa00$var$isAbsent = (value)=>value == null;
var $aaf7b0e5e55bfa00$export$2e2bcd8739ae039 = $aaf7b0e5e55bfa00$var$isAbsent;


function $fb448ce089fee6c2$export$185802fd694ee1f5() {
    return new $fb448ce089fee6c2$export$2e2bcd8739ae039();
}
class $fb448ce089fee6c2$export$2e2bcd8739ae039 extends (0, $35699de99cca2c54$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: 'boolean'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (!this.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    _typeCheck(v) {
        if (v instanceof Boolean) v = v.valueOf();
        return typeof v === 'boolean';
    }
    isTrue(message = (0, $f02a12ad0aa7f150$export$4a21f16c33752377).isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'true'
            },
            test (value) {
                return (0, $aaf7b0e5e55bfa00$export$2e2bcd8739ae039)(value) || value === true;
            }
        });
    }
    isFalse(message = (0, $f02a12ad0aa7f150$export$4a21f16c33752377).isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'false'
            },
            test (value) {
                return (0, $aaf7b0e5e55bfa00$export$2e2bcd8739ae039)(value) || value === false;
            }
        });
    }
}
$fb448ce089fee6c2$export$185802fd694ee1f5.prototype = $fb448ce089fee6c2$export$2e2bcd8739ae039.prototype;





let $5ea63434b26cf26f$var$rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line
let $5ea63434b26cf26f$var$rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line
let $5ea63434b26cf26f$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $5ea63434b26cf26f$var$isTrimmed = (value)=>(0, $aaf7b0e5e55bfa00$export$2e2bcd8739ae039)(value) || value === value.trim();
let $5ea63434b26cf26f$var$objStringTag = ({}).toString();
function $5ea63434b26cf26f$export$185802fd694ee1f5() {
    return new $5ea63434b26cf26f$export$2e2bcd8739ae039();
}
class $5ea63434b26cf26f$export$2e2bcd8739ae039 extends (0, $35699de99cca2c54$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: 'string'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                if (strValue === $5ea63434b26cf26f$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    _typeCheck(value) {
        if (value instanceof String) value = value.valueOf();
        return typeof value === 'string';
    }
    _isPresent(value) {
        return super._isPresent(value) && !!value.length;
    }
    length(length, message = (0, $f02a12ad0aa7f150$export$22b082955e083ec3).length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            test (value) {
                return (0, $aaf7b0e5e55bfa00$export$2e2bcd8739ae039)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message = (0, $f02a12ad0aa7f150$export$22b082955e083ec3).min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $aaf7b0e5e55bfa00$export$2e2bcd8739ae039)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, $f02a12ad0aa7f150$export$22b082955e083ec3).max) {
        return this.test({
            name: 'max',
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            test (value) {
                return (0, $aaf7b0e5e55bfa00$export$2e2bcd8739ae039)(value) || value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === 'object') ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || 'matches',
            message: message || (0, $f02a12ad0aa7f150$export$22b082955e083ec3).matches,
            params: {
                regex: regex
            },
            test: (value)=>(0, $aaf7b0e5e55bfa00$export$2e2bcd8739ae039)(value) || value === '' && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = (0, $f02a12ad0aa7f150$export$22b082955e083ec3).email) {
        return this.matches($5ea63434b26cf26f$var$rEmail, {
            name: 'email',
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = (0, $f02a12ad0aa7f150$export$22b082955e083ec3).url) {
        return this.matches($5ea63434b26cf26f$var$rUrl, {
            name: 'url',
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = (0, $f02a12ad0aa7f150$export$22b082955e083ec3).uuid) {
        return this.matches($5ea63434b26cf26f$var$rUUID, {
            name: 'uuid',
            message: message,
            excludeEmptyString: false
        });
    }
    ensure() {
        return this.default('').transform((val)=>val === null ? '' : val);
    }
    trim(message = (0, $f02a12ad0aa7f150$export$22b082955e083ec3).trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: 'trim',
            test: $5ea63434b26cf26f$var$isTrimmed
        });
    }
    lowercase(message = (0, $f02a12ad0aa7f150$export$22b082955e083ec3).lowercase) {
        return this.transform((value)=>!(0, $aaf7b0e5e55bfa00$export$2e2bcd8739ae039)(value) ? value.toLowerCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            test: (value)=>(0, $aaf7b0e5e55bfa00$export$2e2bcd8739ae039)(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = (0, $f02a12ad0aa7f150$export$22b082955e083ec3).uppercase) {
        return this.transform((value)=>!(0, $aaf7b0e5e55bfa00$export$2e2bcd8739ae039)(value) ? value.toUpperCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            test: (value)=>(0, $aaf7b0e5e55bfa00$export$2e2bcd8739ae039)(value) || value === value.toUpperCase()
        });
    }
}
$5ea63434b26cf26f$export$185802fd694ee1f5.prototype = $5ea63434b26cf26f$export$2e2bcd8739ae039.prototype; //
 // String Interfaces
 //





let $538d3016da99da68$var$isNaN = (value)=>value != +value;
function $538d3016da99da68$export$185802fd694ee1f5() {
    return new $538d3016da99da68$export$2e2bcd8739ae039();
}
class $538d3016da99da68$export$2e2bcd8739ae039 extends (0, $35699de99cca2c54$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: 'number'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                let parsed = value;
                if (typeof parsed === 'string') {
                    parsed = parsed.replace(/\s/g, '');
                    if (parsed === '') return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                if (this.isType(parsed)) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    _typeCheck(value) {
        if (value instanceof Number) value = value.valueOf();
        return typeof value === 'number' && !$538d3016da99da68$var$isNaN(value);
    }
    min(min, message = (0, $f02a12ad0aa7f150$export$98e628dec113755e).min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $aaf7b0e5e55bfa00$export$2e2bcd8739ae039)(value) || value >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, $f02a12ad0aa7f150$export$98e628dec113755e).max) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $aaf7b0e5e55bfa00$export$2e2bcd8739ae039)(value) || value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = (0, $f02a12ad0aa7f150$export$98e628dec113755e).lessThan) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                less: less
            },
            test (value) {
                return (0, $aaf7b0e5e55bfa00$export$2e2bcd8739ae039)(value) || value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = (0, $f02a12ad0aa7f150$export$98e628dec113755e).moreThan) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                more: more
            },
            test (value) {
                return (0, $aaf7b0e5e55bfa00$export$2e2bcd8739ae039)(value) || value > this.resolve(more);
            }
        });
    }
    positive(msg = (0, $f02a12ad0aa7f150$export$98e628dec113755e).positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = (0, $f02a12ad0aa7f150$export$98e628dec113755e).negative) {
        return this.lessThan(0, msg);
    }
    integer(message = (0, $f02a12ad0aa7f150$export$98e628dec113755e).integer) {
        return this.test({
            name: 'integer',
            message: message,
            test: (val)=>(0, $aaf7b0e5e55bfa00$export$2e2bcd8739ae039)(val) || Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!(0, $aaf7b0e5e55bfa00$export$2e2bcd8739ae039)(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            'ceil',
            'floor',
            'round',
            'trunc'
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round'; // this exists for symemtry with the new Math.trunc
        if (method === 'trunc') return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
        return this.transform((value)=>!(0, $aaf7b0e5e55bfa00$export$2e2bcd8739ae039)(value) ? Math[method](value) : value);
    }
}
$538d3016da99da68$export$185802fd694ee1f5.prototype = $538d3016da99da68$export$2e2bcd8739ae039.prototype; //
 // Number Interfaces
 //


// @ts-ignore
/* eslint-disable */ /**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ //              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var $33653556dbad054a$var$isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $33653556dbad054a$export$2e2bcd8739ae039(date) {
    var numericKeys = [
        1,
        4,
        5,
        6,
        7,
        10,
        11
    ], minutesOffset = 0, timestamp, struct;
    if (struct = $33653556dbad054a$var$isoReg.exec(date)) {
        // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
        for(var i = 0, k; k = numericKeys[i]; ++i)struct[k] = +struct[k] || 0; // allow undefined days and months
        struct[2] = (+struct[2] || 1) - 1;
        struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds
        struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time
        if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);
        else {
            if (struct[8] !== 'Z' && struct[9] !== undefined) {
                minutesOffset = struct[10] * 60 + struct[11];
                if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
            }
            timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
        }
    } else timestamp = Date.parse ? Date.parse(date) : NaN;
    return timestamp;
}






let $4c95e26208c10127$var$invalidDate = new Date('');
let $4c95e26208c10127$var$isDate = (obj)=>Object.prototype.toString.call(obj) === '[object Date]';
function $4c95e26208c10127$export$185802fd694ee1f5() {
    return new $4c95e26208c10127$export$2e2bcd8739ae039();
}
class $4c95e26208c10127$export$2e2bcd8739ae039 extends (0, $35699de99cca2c54$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: 'date'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                value = (0, $33653556dbad054a$export$2e2bcd8739ae039)(value); // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $4c95e26208c10127$var$invalidDate;
            });
        });
    }
    _typeCheck(v) {
        return $4c95e26208c10127$var$isDate(v) && !isNaN(v.getTime());
    }
    prepareParam(ref, name) {
        let param;
        if (!(0, $4f7105e0eeed856b$export$2e2bcd8739ae039).isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = (0, $f02a12ad0aa7f150$export$324d90190a8b822a).min) {
        let limit = this.prepareParam(min, 'min');
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $aaf7b0e5e55bfa00$export$2e2bcd8739ae039)(value) || value >= this.resolve(limit);
            }
        });
    }
    max(max, message = (0, $f02a12ad0aa7f150$export$324d90190a8b822a).max) {
        let limit = this.prepareParam(max, 'max');
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $aaf7b0e5e55bfa00$export$2e2bcd8739ae039)(value) || value <= this.resolve(limit);
            }
        });
    }
}
$4c95e26208c10127$export$2e2bcd8739ae039.INVALID_DATE = $4c95e26208c10127$var$invalidDate;
$4c95e26208c10127$export$185802fd694ee1f5.prototype = $4c95e26208c10127$export$2e2bcd8739ae039.prototype;
$4c95e26208c10127$export$185802fd694ee1f5.INVALID_DATE = $4c95e26208c10127$var$invalidDate;



var $e265e8d3631f9ab0$exports = {};
var $fe9388759c111649$exports = {};
var $2c36a54c70aa4f55$exports = {};
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $2c36a54c70aa4f55$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
$2c36a54c70aa4f55$exports = $2c36a54c70aa4f55$var$arrayReduce;


var $24635202546837fa$exports = {};
var $afd58428ffffef53$exports = {};
var $276b5f20a1c48506$exports = {};
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $276b5f20a1c48506$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
$276b5f20a1c48506$exports = $276b5f20a1c48506$var$basePropertyOf;


/** Used to map Latin Unicode letters to basic Latin letters. */ var $afd58428ffffef53$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $afd58428ffffef53$var$deburrLetter = $276b5f20a1c48506$exports($afd58428ffffef53$var$deburredLetters);
$afd58428ffffef53$exports = $afd58428ffffef53$var$deburrLetter;



/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $24635202546837fa$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $24635202546837fa$var$rsComboMarksRange = '\\u0300-\\u036f', $24635202546837fa$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $24635202546837fa$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $24635202546837fa$var$rsComboRange = $24635202546837fa$var$rsComboMarksRange + $24635202546837fa$var$reComboHalfMarksRange + $24635202546837fa$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $24635202546837fa$var$rsCombo = '[' + $24635202546837fa$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $24635202546837fa$var$reComboMark = RegExp($24635202546837fa$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $24635202546837fa$var$deburr(string) {
    string = $4360b921cc50ac20$exports(string);
    return string && string.replace($24635202546837fa$var$reLatin, $afd58428ffffef53$exports).replace($24635202546837fa$var$reComboMark, '');
}
$24635202546837fa$exports = $24635202546837fa$var$deburr;


var $73884421b0952a01$exports = {};
var $1ae4de248a83c8ec$exports = {};
/** Used to match words composed of alphanumeric characters. */ var $1ae4de248a83c8ec$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $1ae4de248a83c8ec$var$asciiWords(string) {
    return string.match($1ae4de248a83c8ec$var$reAsciiWord) || [];
}
$1ae4de248a83c8ec$exports = $1ae4de248a83c8ec$var$asciiWords;


var $a853ed5f7cdacf35$exports = {};
/** Used to detect strings that need a more robust regexp to match words. */ var $a853ed5f7cdacf35$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $a853ed5f7cdacf35$var$hasUnicodeWord(string) {
    return $a853ed5f7cdacf35$var$reHasUnicodeWord.test(string);
}
$a853ed5f7cdacf35$exports = $a853ed5f7cdacf35$var$hasUnicodeWord;



var $3ca2de0af2b0ecb9$exports = {};
/** Used to compose unicode character classes. */ var $3ca2de0af2b0ecb9$var$rsAstralRange = '\\ud800-\\udfff', $3ca2de0af2b0ecb9$var$rsComboMarksRange = '\\u0300-\\u036f', $3ca2de0af2b0ecb9$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $3ca2de0af2b0ecb9$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $3ca2de0af2b0ecb9$var$rsComboRange = $3ca2de0af2b0ecb9$var$rsComboMarksRange + $3ca2de0af2b0ecb9$var$reComboHalfMarksRange + $3ca2de0af2b0ecb9$var$rsComboSymbolsRange, $3ca2de0af2b0ecb9$var$rsDingbatRange = '\\u2700-\\u27bf', $3ca2de0af2b0ecb9$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $3ca2de0af2b0ecb9$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $3ca2de0af2b0ecb9$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $3ca2de0af2b0ecb9$var$rsPunctuationRange = '\\u2000-\\u206f', $3ca2de0af2b0ecb9$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $3ca2de0af2b0ecb9$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $3ca2de0af2b0ecb9$var$rsVarRange = '\\ufe0e\\ufe0f', $3ca2de0af2b0ecb9$var$rsBreakRange = $3ca2de0af2b0ecb9$var$rsMathOpRange + $3ca2de0af2b0ecb9$var$rsNonCharRange + $3ca2de0af2b0ecb9$var$rsPunctuationRange + $3ca2de0af2b0ecb9$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $3ca2de0af2b0ecb9$var$rsApos = "['\u2019]", $3ca2de0af2b0ecb9$var$rsBreak = '[' + $3ca2de0af2b0ecb9$var$rsBreakRange + ']', $3ca2de0af2b0ecb9$var$rsCombo = '[' + $3ca2de0af2b0ecb9$var$rsComboRange + ']', $3ca2de0af2b0ecb9$var$rsDigits = '\\d+', $3ca2de0af2b0ecb9$var$rsDingbat = '[' + $3ca2de0af2b0ecb9$var$rsDingbatRange + ']', $3ca2de0af2b0ecb9$var$rsLower = '[' + $3ca2de0af2b0ecb9$var$rsLowerRange + ']', $3ca2de0af2b0ecb9$var$rsMisc = '[^' + $3ca2de0af2b0ecb9$var$rsAstralRange + $3ca2de0af2b0ecb9$var$rsBreakRange + $3ca2de0af2b0ecb9$var$rsDigits + $3ca2de0af2b0ecb9$var$rsDingbatRange + $3ca2de0af2b0ecb9$var$rsLowerRange + $3ca2de0af2b0ecb9$var$rsUpperRange + ']', $3ca2de0af2b0ecb9$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $3ca2de0af2b0ecb9$var$rsModifier = '(?:' + $3ca2de0af2b0ecb9$var$rsCombo + '|' + $3ca2de0af2b0ecb9$var$rsFitz + ')', $3ca2de0af2b0ecb9$var$rsNonAstral = '[^' + $3ca2de0af2b0ecb9$var$rsAstralRange + ']', $3ca2de0af2b0ecb9$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $3ca2de0af2b0ecb9$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $3ca2de0af2b0ecb9$var$rsUpper = '[' + $3ca2de0af2b0ecb9$var$rsUpperRange + ']', $3ca2de0af2b0ecb9$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $3ca2de0af2b0ecb9$var$rsMiscLower = '(?:' + $3ca2de0af2b0ecb9$var$rsLower + '|' + $3ca2de0af2b0ecb9$var$rsMisc + ')', $3ca2de0af2b0ecb9$var$rsMiscUpper = '(?:' + $3ca2de0af2b0ecb9$var$rsUpper + '|' + $3ca2de0af2b0ecb9$var$rsMisc + ')', $3ca2de0af2b0ecb9$var$rsOptContrLower = '(?:' + $3ca2de0af2b0ecb9$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $3ca2de0af2b0ecb9$var$rsOptContrUpper = '(?:' + $3ca2de0af2b0ecb9$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $3ca2de0af2b0ecb9$var$reOptMod = $3ca2de0af2b0ecb9$var$rsModifier + '?', $3ca2de0af2b0ecb9$var$rsOptVar = '[' + $3ca2de0af2b0ecb9$var$rsVarRange + ']?', $3ca2de0af2b0ecb9$var$rsOptJoin = '(?:' + $3ca2de0af2b0ecb9$var$rsZWJ + '(?:' + [
    $3ca2de0af2b0ecb9$var$rsNonAstral,
    $3ca2de0af2b0ecb9$var$rsRegional,
    $3ca2de0af2b0ecb9$var$rsSurrPair
].join('|') + ')' + $3ca2de0af2b0ecb9$var$rsOptVar + $3ca2de0af2b0ecb9$var$reOptMod + ')*', $3ca2de0af2b0ecb9$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $3ca2de0af2b0ecb9$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $3ca2de0af2b0ecb9$var$rsSeq = $3ca2de0af2b0ecb9$var$rsOptVar + $3ca2de0af2b0ecb9$var$reOptMod + $3ca2de0af2b0ecb9$var$rsOptJoin, $3ca2de0af2b0ecb9$var$rsEmoji = '(?:' + [
    $3ca2de0af2b0ecb9$var$rsDingbat,
    $3ca2de0af2b0ecb9$var$rsRegional,
    $3ca2de0af2b0ecb9$var$rsSurrPair
].join('|') + ')' + $3ca2de0af2b0ecb9$var$rsSeq;
/** Used to match complex or compound words. */ var $3ca2de0af2b0ecb9$var$reUnicodeWord = RegExp([
    $3ca2de0af2b0ecb9$var$rsUpper + '?' + $3ca2de0af2b0ecb9$var$rsLower + '+' + $3ca2de0af2b0ecb9$var$rsOptContrLower + '(?=' + [
        $3ca2de0af2b0ecb9$var$rsBreak,
        $3ca2de0af2b0ecb9$var$rsUpper,
        '$'
    ].join('|') + ')',
    $3ca2de0af2b0ecb9$var$rsMiscUpper + '+' + $3ca2de0af2b0ecb9$var$rsOptContrUpper + '(?=' + [
        $3ca2de0af2b0ecb9$var$rsBreak,
        $3ca2de0af2b0ecb9$var$rsUpper + $3ca2de0af2b0ecb9$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $3ca2de0af2b0ecb9$var$rsUpper + '?' + $3ca2de0af2b0ecb9$var$rsMiscLower + '+' + $3ca2de0af2b0ecb9$var$rsOptContrLower,
    $3ca2de0af2b0ecb9$var$rsUpper + '+' + $3ca2de0af2b0ecb9$var$rsOptContrUpper,
    $3ca2de0af2b0ecb9$var$rsOrdUpper,
    $3ca2de0af2b0ecb9$var$rsOrdLower,
    $3ca2de0af2b0ecb9$var$rsDigits,
    $3ca2de0af2b0ecb9$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $3ca2de0af2b0ecb9$var$unicodeWords(string) {
    return string.match($3ca2de0af2b0ecb9$var$reUnicodeWord) || [];
}
$3ca2de0af2b0ecb9$exports = $3ca2de0af2b0ecb9$var$unicodeWords;


/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $73884421b0952a01$var$words(string, pattern, guard) {
    string = $4360b921cc50ac20$exports(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $a853ed5f7cdacf35$exports(string) ? $3ca2de0af2b0ecb9$exports(string) : $1ae4de248a83c8ec$exports(string);
    return string.match(pattern) || [];
}
$73884421b0952a01$exports = $73884421b0952a01$var$words;


/** Used to compose unicode capture groups. */ var $fe9388759c111649$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $fe9388759c111649$var$reApos = RegExp($fe9388759c111649$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $fe9388759c111649$var$createCompounder(callback) {
    return function(string) {
        return $2c36a54c70aa4f55$exports($73884421b0952a01$exports($24635202546837fa$exports(string).replace($fe9388759c111649$var$reApos, '')), callback, '');
    };
}
$fe9388759c111649$exports = $fe9388759c111649$var$createCompounder;


/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */ var $e265e8d3631f9ab0$var$snakeCase = $fe9388759c111649$exports(function(result, word, index) {
    return result + (index ? '_' : '') + word.toLowerCase();
});
$e265e8d3631f9ab0$exports = $e265e8d3631f9ab0$var$snakeCase;


var $1c255134815a3bac$exports = {};
var $e752bc16ed597145$exports = {};


/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $e752bc16ed597145$var$capitalize(string) {
    return $7808c9375de28fec$exports($4360b921cc50ac20$exports(string).toLowerCase());
}
$e752bc16ed597145$exports = $e752bc16ed597145$var$capitalize;



/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $1c255134815a3bac$var$camelCase = $fe9388759c111649$exports(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $e752bc16ed597145$exports(word) : word);
});
$1c255134815a3bac$exports = $1c255134815a3bac$var$camelCase;


var $51736a102a0a10f4$exports = {};



/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $51736a102a0a10f4$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = $9dd1d38dfe69ddcf$exports(iteratee, 3);
    $b8b184dbd2d79b13$exports(object, function(value, key, object) {
        $5cd807a6ad780171$exports(result, iteratee(value, key, object), value);
    });
    return result;
}
$51736a102a0a10f4$exports = $51736a102a0a10f4$var$mapKeys;






var $99afd788953e0839$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $99afd788953e0839$exports = function(edges) {
    return $99afd788953e0839$var$toposort($99afd788953e0839$var$uniqueNodes(edges), edges);
};
$99afd788953e0839$exports.array = $99afd788953e0839$var$toposort;
function $99afd788953e0839$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $99afd788953e0839$var$makeOutgoingEdges(edges), nodesHash = $99afd788953e0839$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error('Unknown node. There is an unknown node in the supplied edges.');
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error('Cyclic dependency' + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: ' + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $99afd788953e0839$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $99afd788953e0839$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $99afd788953e0839$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}





function $e14ad8984cfd9c66$export$2e2bcd8739ae039(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $244f7b149ccbb36d$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for(const key in fields)if ((0, (/*@__PURE__*/$parcel$interopDefault($74f2066a1bc7cb42$exports)))(fields, key)) {
        let value = fields[key];
        nodes.add(key);
        if ((0, $4f7105e0eeed856b$export$2e2bcd8739ae039).isRef(value) && value.isSibling) addNode(value.path, key);
        else if ((0, $d7da6e9a699ca85f$export$2e2bcd8739ae039)(value) && 'deps' in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($99afd788953e0839$exports))).array(Array.from(nodes), edges).reverse();
}


function $347e3048bf9cc267$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if (((_err$path = err.path) == null ? void 0 : _err$path.indexOf(key)) !== -1) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $347e3048bf9cc267$export$2e2bcd8739ae039(keys) {
    return (a, b)=>{
        return $347e3048bf9cc267$var$findIndex(keys, a) - $347e3048bf9cc267$var$findIndex(keys, b);
    };
}





function $1b9e4df3da2fe282$var$_extends() {
    $1b9e4df3da2fe282$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1b9e4df3da2fe282$var$_extends.apply(this, arguments);
}
let $1b9e4df3da2fe282$var$isObject = (obj)=>Object.prototype.toString.call(obj) === '[object Object]';
function $1b9e4df3da2fe282$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $1b9e4df3da2fe282$var$defaultSort = (0, $347e3048bf9cc267$export$2e2bcd8739ae039)([]);
class $1b9e4df3da2fe282$export$2e2bcd8739ae039 extends (0, $35699de99cca2c54$export$2e2bcd8739ae039) {
    constructor(spec){
        super({
            type: 'object'
        });
        this.fields = Object.create(null);
        this._sortErrors = $1b9e4df3da2fe282$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            this.transform(function coerce(value) {
                if (typeof value === 'string') try {
                    value = JSON.parse(value);
                } catch (err) {
                    value = null;
                }
                if (this.isType(value)) return value;
                return null;
            });
            if (spec) this.shape(spec);
        });
    }
    _typeCheck(value) {
        return $1b9e4df3da2fe282$var$isObject(value) || typeof value === 'function';
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options); //should ignore nulls here
        if (value === undefined) return this.getDefault();
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = this._nodes.concat(Object.keys(value).filter((v)=>this._nodes.indexOf(v) === -1));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = $1b9e4df3da2fe282$var$_extends({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = (0, (/*@__PURE__*/$parcel$interopDefault($74f2066a1bc7cb42$exports)))(value, prop);
            if (field) {
                let fieldValue;
                let inputValue = value[prop]; // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : '') + prop; // innerOptions.value = value[prop];
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = 'spec' in field ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec == null ? void 0 : fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, opts = {}, callback) {
        let errors = [];
        let { sync: sync, from: from = [], originalValue: originalValue = _value, abortEarly: abortEarly = this.spec.abortEarly, recursive: recursive = this.spec.recursive } = opts;
        from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ]; // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        opts.__validating = true;
        opts.originalValue = originalValue;
        opts.from = from;
        super._validate(_value, opts, (err, value)=>{
            if (err) {
                if (!(0, $2e2c275a7d6d86e9$export$2e2bcd8739ae039).isError(err) || abortEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !$1b9e4df3da2fe282$var$isObject(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = this._nodes.map((key)=>(_, cb)=>{
                    let path = key.indexOf('.') === -1 ? (opts.path ? `${opts.path}.` : '') + key : `${opts.path || ''}["${key}"]`;
                    let field = this.fields[key];
                    if (field && 'validate' in field) {
                        field.validate(value[key], $1b9e4df3da2fe282$var$_extends({}, opts, {
                            path: // @ts-ignore
                            path,
                            from: from,
                            // inner fields are always strict:
                            // 1. this isn't strict so the casting will also have cast inner values
                            // 2. this is strict in which case the nested values weren't cast either
                            strict: true,
                            parent: value,
                            originalValue: originalValue[key]
                        }), cb);
                        return;
                    }
                    cb(null);
                });
            (0, $6d4d63260c35feb3$export$2e2bcd8739ae039)({
                sync: sync,
                tests: tests,
                value: value,
                errors: errors,
                endEarly: abortEarly,
                sort: this._sortErrors,
                path: opts.path
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = $1b9e4df3da2fe282$var$_extends({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            if (target === undefined) nextFields[field] = schemaOrRef;
            else if (target instanceof (0, $35699de99cca2c54$export$2e2bcd8739ae039) && schemaOrRef instanceof (0, $35699de99cca2c54$export$2e2bcd8739ae039)) nextFields[field] = schemaOrRef.concat(target);
        }
        return next.withMutation(()=>next.shape(nextFields, this._excludedEdges));
    }
    getDefaultFromShape() {
        let dft = {};
        this._nodes.forEach((key)=>{
            const field = this.fields[key];
            dft[key] = 'default' in field ? field.getDefault() : undefined;
        });
        return dft;
    }
    _getDefault() {
        if ('default' in this.spec) return super._getDefault();
         // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        return this.getDefaultFromShape();
    }
    shape(additions, excludes = []) {
        let next = this.clone();
        let fields = Object.assign(next.fields, additions);
        next.fields = fields;
        next._sortErrors = (0, $347e3048bf9cc267$export$2e2bcd8739ae039)(Object.keys(fields));
        if (excludes.length) {
            // this is a convenience for when users only supply a single pair
            if (!Array.isArray(excludes[0])) excludes = [
                excludes
            ];
            next._excludedEdges = [
                ...next._excludedEdges,
                ...excludes
            ];
        }
        next._nodes = (0, $e14ad8984cfd9c66$export$2e2bcd8739ae039)(fields, next._excludedEdges);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.clone().withMutation((next)=>{
            next.fields = {};
            return next.shape(picked);
        });
    }
    omit(keys) {
        const next = this.clone();
        const fields = next.fields;
        next.fields = {};
        for (const key of keys)delete fields[key];
        return next.withMutation(()=>next.shape(fields));
    }
    from(from, to, alias) {
        let fromGetter = (0, $244f7b149ccbb36d$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (obj == null) return obj;
            let newObj = obj;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($74f2066a1bc7cb42$exports)))(obj, from)) {
                newObj = $1b9e4df3da2fe282$var$_extends({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    noUnknown(noAllow = true, message = (0, $f02a12ad0aa7f150$export$be5493f9613cbbe).noUnknown) {
        if (typeof noAllow === 'string') {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: 'noUnknown',
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $1b9e4df3da2fe282$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(', ')
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = (0, $f02a12ad0aa7f150$export$be5493f9613cbbe).noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>obj && (0, (/*@__PURE__*/$parcel$interopDefault($51736a102a0a10f4$exports)))(obj, (_, key)=>fn(key)));
    }
    camelCase() {
        return this.transformKeys((0, (/*@__PURE__*/$parcel$interopDefault($1c255134815a3bac$exports))));
    }
    snakeCase() {
        return this.transformKeys((0, (/*@__PURE__*/$parcel$interopDefault($e265e8d3631f9ab0$exports))));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, (/*@__PURE__*/$parcel$interopDefault($e265e8d3631f9ab0$exports)))(key).toUpperCase());
    }
    describe() {
        let base = super.describe();
        base.fields = (0, (/*@__PURE__*/$parcel$interopDefault($25b56b7191d13321$exports)))(this.fields, (value)=>value.describe());
        return base;
    }
}
function $1b9e4df3da2fe282$export$185802fd694ee1f5(spec) {
    return new $1b9e4df3da2fe282$export$2e2bcd8739ae039(spec);
}
$1b9e4df3da2fe282$export$185802fd694ee1f5.prototype = $1b9e4df3da2fe282$export$2e2bcd8739ae039.prototype;









function $e96bb8d5bac99334$var$_extends() {
    $e96bb8d5bac99334$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e96bb8d5bac99334$var$_extends.apply(this, arguments);
}
function $e96bb8d5bac99334$export$185802fd694ee1f5(type) {
    return new $e96bb8d5bac99334$export$2e2bcd8739ae039(type);
}
class $e96bb8d5bac99334$export$2e2bcd8739ae039 extends (0, $35699de99cca2c54$export$2e2bcd8739ae039) {
    constructor(type){
        super({
            type: 'array'
        }); // `undefined` specifically means uninitialized, as opposed to
        // "no subtype"
        this.innerType = void 0;
        this.innerType = type;
        this.withMutation(()=>{
            this.transform(function(values) {
                if (typeof values === 'string') try {
                    values = JSON.parse(values);
                } catch (err) {
                    values = null;
                }
                return this.isType(values) ? values : null;
            });
        });
    }
    _typeCheck(v) {
        return Array.isArray(v);
    }
    get _subType() {
        return this.innerType;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts); //should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, $e96bb8d5bac99334$var$_extends({}, _opts, {
                path: `${_opts.path || ''}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, callback) {
        var _options$abortEarly, _options$recursive;
        let errors = [];
        let sync = options.sync;
        let path = options.path;
        let innerType = this.innerType;
        let endEarly = (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        let originalValue = options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, (err, value)=>{
            if (err) {
                if (!(0, $2e2c275a7d6d86e9$export$2e2bcd8739ae039).isError(err) || endEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !innerType || !this._typeCheck(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value; // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let idx = 0; idx < value.length; idx++){
                let item = value[idx];
                let path = `${options.path || ''}[${idx}]`; // object._validate note for isStrict explanation
                let innerOptions = $e96bb8d5bac99334$var$_extends({}, options, {
                    path: path,
                    strict: true,
                    parent: value,
                    index: idx,
                    originalValue: originalValue[idx]
                });
                tests[idx] = (_, cb)=>innerType.validate(item, innerOptions, cb);
            }
            (0, $6d4d63260c35feb3$export$2e2bcd8739ae039)({
                sync: sync,
                path: path,
                value: value,
                errors: errors,
                endEarly: endEarly,
                tests: tests
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.innerType = this.innerType;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        next.innerType = this.innerType;
        if (schema.innerType) next.innerType = next.innerType ? next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!(0, $d7da6e9a699ca85f$export$2e2bcd8739ae039)(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + (0, $224039f1d02f653f$export$2e2bcd8739ae039)(schema)); // FIXME(ts):
        next.innerType = schema;
        return next;
    }
    length(length, message = (0, $f02a12ad0aa7f150$export$2f23118c22fb2630).length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            test (value) {
                return (0, $aaf7b0e5e55bfa00$export$2e2bcd8739ae039)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || (0, $f02a12ad0aa7f150$export$2f23118c22fb2630).min;
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            // FIXME(ts): Array<typeof T>
            test (value) {
                return (0, $aaf7b0e5e55bfa00$export$2e2bcd8739ae039)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || (0, $f02a12ad0aa7f150$export$2f23118c22fb2630).max;
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $aaf7b0e5e55bfa00$export$2e2bcd8739ae039)(value) || value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe() {
        let base = super.describe();
        if (this.innerType) base.innerType = this.innerType.describe();
        return base;
    }
    nullable(isNullable = true) {
        return super.nullable(isNullable);
    }
    defined() {
        return super.defined();
    }
    required(msg) {
        return super.required(msg);
    }
}
$e96bb8d5bac99334$export$185802fd694ee1f5.prototype = $e96bb8d5bac99334$export$2e2bcd8739ae039.prototype; //
 // Interfaces
 //




function $9d69f0afd7d41741$export$185802fd694ee1f5(builder) {
    return new $9d69f0afd7d41741$var$Lazy(builder);
}
class $9d69f0afd7d41741$var$Lazy {
    constructor(builder){
        this.type = 'lazy';
        this.__isYupSchema__ = true;
        this.__inputType = void 0;
        this.__outputType = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!(0, $d7da6e9a699ca85f$export$2e2bcd8739ae039)(schema)) throw new TypeError('lazy() functions must return a valid schema');
            return schema.resolve(options);
        };
        this.builder = builder;
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    validate(value, options, maybeCb) {
        // @ts-expect-error missing public callback on type
        return this._resolve(value, options).validate(value, options, maybeCb);
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    describe() {
        return null;
    }
    isValid(value, options) {
        return this._resolve(value, options).isValid(value, options);
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
}
var $9d69f0afd7d41741$export$2e2bcd8739ae039 = $9d69f0afd7d41741$var$Lazy;






function $10c01600212bc1fa$export$2e2bcd8739ae039(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            (0, $f02a12ad0aa7f150$export$2e2bcd8739ae039)[type][method] = custom[type][method];
        });
    });
}



function $7dbeb5de87a2aa56$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !(0, $d7da6e9a699ca85f$export$2e2bcd8739ae039)(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
    if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
    if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
    schemaType.prototype[name] = fn;
}



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $k4ank = parcelRequire("k4ank");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $eejVe = parcelRequire("eejVe");

var $g2LMr = parcelRequire("g2LMr");
const $94514691c6a45869$export$158eb8aec0a82f84 = ({ config: config, formik: formik, setErrorState: setErrorState, stepNumber: stepNumber })=>{
    const numbersOnly = /^[0-9]+$/;
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (localStorage.copyValues === "true" && localStorage.firstCameraAdded === "false" && stepNumber === 1) {
            const values = JSON.parse(localStorage.copiedValues);
            formik.values.http = values.http;
            formik.values.rtsp = values.rtsp;
        }
        if (config.validation) setErrorState((previousState)=>{
            return {
                ...previousState,
                [config.id]: true
            };
        });
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $g2LMr.Field), {
            error: formik.values[config.field] && !numbersOnly.test(formik.values[config.field]),
            id: config.id,
            name: config.field,
            label: config.label,
            placeholder: config.label,
            autoComplete: "off",
            variant: "standard",
            sx: {
                width: 350
            },
            helperText: formik.values[config.field] && !numbersOnly.test(formik.values[config.field]) ? "Must be a number" : config.helperText,
            as: $94514691c6a45869$var$NumberComponent
        })
    }, config.id);
};
const $94514691c6a45869$var$NumberComponent = (props)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
        ...props
    });



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $eejVe = parcelRequire("eejVe");

var $g2LMr = parcelRequire("g2LMr");
const $8d1595539bee672a$export$625ef31dfb14019b = ({ config: config, formik: formik, setErrorState: setErrorState, stepNumber: stepNumber })=>{
    // const validateString = (value: any) => {
    //   requiredResponseValidator(
    //     value,
    //     config.id,
    //     config.validation,
    //     setErrorState
    //   );
    // };
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (localStorage.copyValues === "true" && localStorage.firstCameraAdded === "false" && stepNumber === 1) {
            const values = JSON.parse(localStorage.copiedValues);
            formik.values.ip = values.ip;
            formik.values.username = values.username;
            formik.values.channel = values.channel;
            formik.values.immix_server = values.immix_server;
            formik.values.immix_email = values.immix_email;
            formik.values.immix_port = values.immix_port;
            formik.values.immix_input1 = values.immix_input1;
            formik.values.sureview_server = values.sureview_server;
            formik.values.sureview_subject = values.sureview_subject;
            formik.values.sureview_cc = values.sureview_cc;
            formik.values.sureview_email = values.sureview_email;
        }
        if (config.validation) setErrorState((previousState)=>{
            return {
                ...previousState,
                [config.id]: true
            };
        });
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $g2LMr.Field), {
            id: config.id,
            label: config.label,
            name: config.field,
            autoComplete: "off",
            variant: "standard",
            sx: {
                width: 350
            },
            helperText: config.helperText,
            defaultValue: config.defaultValue ? config.defaultValue : "",
            type: "string",
            // validate={validateString}
            as: $8d1595539bee672a$var$TextComponent
        })
    }, config.id);
};
const $8d1595539bee672a$var$TextComponent = (props)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
        ...props
    });



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $iKAtE = parcelRequire("iKAtE");
var $1SPe4 = parcelRequire("1SPe4");
var $eejVe = parcelRequire("eejVe");

var $2yNMw = parcelRequire("2yNMw");
var $4m1S6 = parcelRequire("4m1S6");

var $g2LMr = parcelRequire("g2LMr");

var $aYdit = parcelRequire("aYdit");
const $d9fa6d318e061bd7$export$b4959feafefa5ff7 = ({ config: config, formik: formik, setErrorState: setErrorState, stepNumber: stepNumber })=>{
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    const [showPassword, setShowPassword] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (localStorage.copyValues === "true" && localStorage.firstCameraAdded === "false" && stepNumber === 1) {
            const values = JSON.parse(localStorage.copiedValues);
            formik.values.password = values.password;
        }
        if (config.validation) setErrorState((previousState)=>{
            return {
                ...previousState,
                [config.id]: true
            };
        });
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $g2LMr.Field), {
            id: config.id,
            label: config.label,
            name: config.field,
            variant: "standard",
            sx: {
                width: 350
            },
            helperText: config.helperText,
            type: showPassword ? "text" : "password",
            as: $d9fa6d318e061bd7$var$TextComponent,
            InputProps: userPermissions.view_passwords ? {
                endAdornment: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1SPe4.default), {
                    position: "end",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                        "aria-label": showPassword ? "hide the password" : "display the password",
                        onClick: ()=>setShowPassword((previousState)=>!previousState),
                        onMouseDown: (event)=>event.preventDefault(),
                        edge: "end",
                        children: showPassword ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $4m1S6.default), {}) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $2yNMw.default), {})
                    })
                })
            } : undefined
        })
    }, config.id);
};
const $d9fa6d318e061bd7$var$TextComponent = (props)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
        ...props
    });



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");

var $g2LMr = parcelRequire("g2LMr");
// eslint-disable-next-line @typescript-eslint/no-unused-vars
parcelRequire("8T3gX");
const $49c8d3d13bafb5d3$export$5955f7fa50eff0f0 = (selectedString, setHelperText)=>{
    if (selectedString === "Thermal") setHelperText(`We recommend contacting support@actuate.ai about Actuate's thermal model after onboarding this camera.`);
    if (selectedString === "Fisheye") setHelperText(`For fisheye cameras with only intruder (person or vehicle) detection, we recommend contacting support@actuate.ai about fisheye dewarping after onboarding this camera.`);
};



var $9OjAn = parcelRequire("9OjAn");
const $f3a38e087c86c35f$export$7003214a0e2ce77c = (0, $9OjAn.create)((set)=>({
        needsWireGuardOnboarding: false,
        setNeedsWireGuardOnboarding: (value)=>set({
                needsWireGuardOnboarding: value
            }),
        selectedWireGuardServer: null,
        setSelectedWireGuardServer: (value)=>set({
                selectedWireGuardServer: value
            }),
        resetOnboarding: ()=>set({
                needsWireGuardOnboarding: false,
                selectedWireGuardServer: null
            })
    }));




/**
 * Camera-step helpers for stream addresses (ENG-1924).
 *
 * Installers usually arrive with a working stream URL
 * (`rtsps://user:pass@172.16.254.237:654/<GUID>/live`), but the wizard asks for
 * it in pieces: Host (`ip`), RTSP port (`rtsp`) and Stream Parameter
 * (`channel`). The connector builds `{ip}:{rtsp}{channel}` with no separator,
 * so a whole URL pasted into Stream Parameter produced
 * `10.101.35.104:554rtsps://...` for every camera on a Genesis site
 * (connector-51646). These helpers split a pasted URL into the fields, flag
 * values the connector cannot use, and render the address it will dial.
 */ const $529194e764056c0b$var$SCHEME = /^(rtsps?|https?):\/\/(.*)$/is;
// RTSPS has no single real-world default: TLS-capable cameras use 554, the
// Genetec Media Gateway 654 (ENG-2042). 554 is the likelier guess; the hints
// below tell Genetec users to put :654 in the URL.
const $529194e764056c0b$var$DEFAULT_PORTS = {
    rtsp: "554",
    rtsps: "554",
    http: "80",
    https: "443"
};
const $529194e764056c0b$var$safeDecode = (value)=>{
    try {
        return decodeURIComponent(value);
    } catch  {
        return value;
    }
};
const $529194e764056c0b$export$f4b4f099cd6d7164 = (raw)=>{
    const match = $529194e764056c0b$var$SCHEME.exec((raw || "").trim());
    if (!match) return null;
    const protocol = match[1].toLowerCase();
    const rest = match[2];
    // The path starts at the first "/" after the scheme. A password with "/"
    // in it is the one shape this cannot handle; ask for it encoded (%2F).
    const slash = rest.indexOf("/");
    const authority = slash === -1 ? rest : rest.slice(0, slash);
    let path = slash === -1 ? "" : rest.slice(slash);
    const at = authority.lastIndexOf("@");
    const userinfo = at === -1 ? "" : authority.slice(0, at);
    const hostPort = at === -1 ? authority : authority.slice(at + 1);
    const colon = userinfo.indexOf(":");
    const username = colon === -1 ? userinfo : userinfo.slice(0, colon);
    const password = colon === -1 ? "" : userinfo.slice(colon + 1);
    const hostMatch = /^([^:?#]+)(?::(\d+))?$/.exec(hostPort);
    if (!hostMatch) return null;
    const [, host, port] = hostMatch;
    if (path && !path.startsWith("/")) path = `/${path}`;
    return {
        protocol: protocol,
        host: host,
        port: port || $529194e764056c0b$var$DEFAULT_PORTS[protocol] || "",
        path: path,
        username: $529194e764056c0b$var$safeDecode(username),
        password: $529194e764056c0b$var$safeDecode(password)
    };
};
const $529194e764056c0b$var$GUID_LIVE_PATH = /^\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/live/i;
/** Split off the part after the scheme into authority and path, or null. */ const $529194e764056c0b$var$splitAuthority = (raw)=>{
    const match = $529194e764056c0b$var$SCHEME.exec((raw || "").trim());
    if (!match) return null;
    const rest = match[2];
    const slash = rest.indexOf("/");
    return slash === -1 ? {
        authority: rest,
        path: ""
    } : {
        authority: rest.slice(0, slash),
        path: rest.slice(slash)
    };
};
const $529194e764056c0b$export$2c748151ef73242e = (raw)=>{
    const split = $529194e764056c0b$var$splitAuthority(raw);
    if (!split) return false;
    const hostPort = split.authority.slice(split.authority.lastIndexOf("@") + 1);
    return /:\d+$/.test(hostPort);
};
const $529194e764056c0b$export$d4b91fc51a3645b7 = (raw)=>{
    const hints = [];
    const split = $529194e764056c0b$var$splitAuthority(raw);
    if (!split) return hints;
    // "user:pa/ss@host/live" → the authority stops at "pa", and the "@" that
    // should end the credentials lands in the path.
    if (!split.authority.includes("@") && split.authority.includes(":") && split.path.includes("@")) hints.push('The password seems to contain "/". Write each "/" in the password as %2F, for example rtsp://admin:ab%2Fcd@203.0.113.20:554/live. Otherwise everything after the "/" is read as the stream path.');
    const parsed = $529194e764056c0b$export$f4b4f099cd6d7164(raw);
    if (!parsed) return hints;
    if (parsed.protocol === "rtsps" && !$529194e764056c0b$export$2c748151ef73242e(raw)) hints.push("This RTSPS URL has no port, so the default port 554 will be used.");
    const looksGenetec = /genetec/i.test(parsed.host) || /genetec/i.test(parsed.path) || $529194e764056c0b$var$GUID_LIVE_PATH.test(parsed.path);
    if (parsed.port !== "654" && (looksGenetec || parsed.protocol === "rtsps" && parsed.port === "554")) hints.push("Genetec Media Gateway usually needs :654 in the URL, for example rtsps://user:password@203.0.113.20:654/<camera GUID>/live.");
    return hints;
};
const $529194e764056c0b$export$b1c08bc023515e2 = (config)=>{
    const fields = new Set((config || []).map((c)=>c && c.field));
    return fields.has("ip") && fields.has("channel");
};
const $529194e764056c0b$export$44b93e0131bd846a = (values)=>{
    const problems = {};
    const host = String(values?.ip ?? "").trim();
    const channel = String(values?.channel ?? "").trim();
    if (host.includes("://") || host.includes("/")) problems.ip = "Host is only the address, without rtsp:// or a path. Example: 203.0.113.20";
    else if (/:\d+$/.test(host)) problems.ip = "Put the port in the port field (RTSP port or HTTP port), not in Host. Example: Host 203.0.113.20, RTSP port 554";
    if (channel.includes("://")) problems.channel = "Stream Parameter is only the path, not the full URL. Paste the full URL in the box below instead. Example: /01000000-\u2026/live";
    return problems;
};
const $529194e764056c0b$export$74ff1f481ebd43ed = (values)=>{
    const path = String(values?.stream_parameters || values?.channel || "").trim();
    if (!path || path.startsWith("/") || path.includes("://")) return path;
    return `/${path}`;
};
const $529194e764056c0b$export$22f59cb2161f8af8 = (values)=>{
    const host = String(values?.ip ?? "").trim();
    if (!host) return null;
    // Mobotix-style HTTP camera steps carry `http` as their port field.
    const port = String(values?.rtsp ?? values?.http ?? "").trim();
    const protocol = String(values?.protocol ?? "").trim().toLowerCase();
    return `${protocol ? `${protocol}://` : ""}${host}${port ? `:${port}` : ""}${$529194e764056c0b$export$74ff1f481ebd43ed(values)}`;
};
const $529194e764056c0b$var$PROTOCOL_LABELS = {
    rtsp: "RTSP (standard, unencrypted)",
    rtsps: "RTSPS (encrypted, use when the VMS requires TLS, e.g. Genetec)",
    http: "HTTP (web stream)",
    https: "HTTPS (encrypted web stream)"
};
const $529194e764056c0b$export$5fec587fc83af977 = (options)=>(options || []).map((option)=>{
        if (!Array.isArray(option)) return option;
        const label = $529194e764056c0b$var$PROTOCOL_LABELS[String(option[1] ?? "").toLowerCase()];
        return label ? [
            label,
            option[1]
        ] : option;
    });


function $c164b9d38679f5fa$var$normalizeGroupSearch(s) {
    return s.trim().toLowerCase().replace(/\s+/g, " ");
}
const $c164b9d38679f5fa$export$fb687e9ef1b1dada = ({ config: config, formik: formik, setErrorState: setErrorState, setChoicesChanger: setChoicesChanger, choicesChanger: choicesChanger })=>{
    // ENG-1924: plain-language Protocol labels; the stored value is unchanged.
    const options = config.field === "protocol" || config.id === "protocol" ? (0, $529194e764056c0b$export$5fec587fc83af977)(config.options) : config.options;
    const isGroupField = config.id === "group";
    const optionsIds = new Map();
    const optionNames = new Map();
    options.forEach((option)=>{
        optionsIds.set(option[0], option[1]);
    });
    options.forEach((option)=>{
        optionNames.set(option[1], option[0]);
    });
    // `config.options` entries are [displayName, groupId] tuples. MUI Autocomplete
    // uses { id, name, index } on the option objects — id/name map from tuple[1] /
    // tuple[0], not the same as `config.id` ("group"), which is the form control key.
    const groupOptionRows = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>{
        return options.map((option, index)=>({
                id: option[1],
                name: String(option[0]),
                index: index
            }));
    }, [
        options
    ]);
    const [groupFilterInput, setGroupFilterInput] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const groupFieldValue = formik.values[config.field];
    const filteredGroupOptions = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>{
        const q = $c164b9d38679f5fa$var$normalizeGroupSearch(groupFilterInput);
        if (!q) return groupOptionRows;
        return groupOptionRows.filter((opt)=>{
            const n = $c164b9d38679f5fa$var$normalizeGroupSearch(String(opt.name));
            return n.includes(q);
        });
    }, [
        groupFilterInput,
        groupOptionRows
    ]);
    /** When a group is selected, keep controlled input text in sync with the label (incl. after options load). */ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!isGroupField) return;
        const gid = groupFieldValue;
        if (gid === "" || gid == null) return;
        const row = groupOptionRows.find((r)=>String(r.id) === String(gid));
        if (row) setGroupFilterInput(String(row.name));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- sync when selection id or option count changes; `groupOptionRows` intentionally omitted (parent may pass new `options` ref each render).
    }, [
        isGroupField,
        config.field,
        groupFieldValue,
        groupOptionRows.length
    ]);
    const [helperText, setHelperText] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(config.helperText);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (config.validation) setErrorState((previousState)=>{
            return {
                ...previousState,
                [config.id]: true
            };
        });
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            disablePortal: true,
            id: config.id,
            options: isGroupField ? filteredGroupOptions : options.map((option)=>{
                return option[0];
            }),
            ...isGroupField ? {
                inputValue: groupFilterInput,
                getOptionLabel: (option)=>option && typeof option === "object" ? option.name || "" : "",
                isOptionEqualToValue: (option, value)=>value != null && option.id === value.id,
                // MUI's built-in filterOptions can receive an empty `inputValue` when
                // `inputValueIsSelectedValue && inputPristine` (see useAutocomplete.js),
                // which would show the full unfiltered list. We filter ourselves from
                // `groupFilterInput` (synced via onInputChange) and bypass MUI filtering.
                filterOptions: (opts)=>opts,
                onInputChange: (_event, value, reason)=>{
                    if (reason === "input" || reason === "clear") setGroupFilterInput(reason === "clear" ? "" : value);
                    else if (reason === "reset") // MUI can emit reset + "" immediately after each "input" while typing;
                    // applying that cleared our filter and showed all rows (see debug-9c4032.log).
                    {
                        if (typeof value === "string" && value !== "") setGroupFilterInput(value);
                    }
                },
                value: formik.values[config.field] !== "" && formik.values[config.field] != null ? {
                    id: formik.values[config.field],
                    name: optionNames.get(formik.values[config.field]),
                    index: options.findIndex((o)=>o[1] === formik.values[config.field] || String(o[1]) === String(formik.values[config.field]))
                } : null,
                renderOption: (props, option)=>/*#__PURE__*/ (0, $8T3gX.createElement)("li", {
                        ...props,
                        key: option.id
                    }, option.name)
            } : {
                value: optionNames.get(formik.values[config.field])
            },
            onChange: (event, newInputValue)=>{
                if (isGroupField) {
                    formik.values[config.field] = newInputValue != null && typeof newInputValue === "object" ? newInputValue.id : "";
                    if (newInputValue == null || typeof newInputValue !== "object") setGroupFilterInput("");
                } else formik.values[config.field] = optionsIds.get(newInputValue);
                setChoicesChanger(!choicesChanger);
                if (config.id === "default_alarm" && newInputValue === "Webhooks" && location.href.includes("addsite")) localStorage.setItem("showWebHooksOnboardingScreen", JSON.stringify(true));
                if (config.id === "default_alarm" && newInputValue !== "Webhooks" && location.href.includes("addsite")) localStorage.setItem("showWebHooksOnboardingScreen", JSON.stringify(false));
                if (config.id === "camera_view" && location.href.includes("addcamera")) (0, $49c8d3d13bafb5d3$export$5955f7fa50eff0f0)(newInputValue, setHelperText);
                if (config.id === "default_alarm") {
                    if (newInputValue === "Actuate Only") {
                        localStorage.setItem("immixAlertsSite", "false");
                        localStorage.setItem("sentinelAlertsSite", "false");
                        localStorage.setItem("sureviewAlertsSite", "false");
                        localStorage.setItem("diceAlertsSite", "false");
                    } else if (newInputValue === "Immix") {
                        localStorage.setItem("immixAlertsSite", "true");
                        localStorage.setItem("sentinelAlertsSite", "false");
                        localStorage.setItem("sureviewAlertsSite", "false");
                        localStorage.setItem("diceAlertsSite", "false");
                    } else if (newInputValue === "Dice") {
                        localStorage.setItem("immixAlertsSite", "false");
                        localStorage.setItem("sentinelAlertsSite", "false");
                        localStorage.setItem("sureviewAlertsSite", "false");
                        localStorage.setItem("diceAlertsSite", "true");
                    } else if (newInputValue === "SureView") {
                        localStorage.setItem("immixAlertsSite", "false");
                        localStorage.setItem("sureviewAlertsSite", "true");
                        localStorage.setItem("sentinelAlertsSite", "false");
                        localStorage.setItem("diceAlertsSite", "false");
                    } else if (newInputValue === "Sentinel") {
                        localStorage.setItem("immixAlertsSite", "false");
                        localStorage.setItem("sureviewAlertsSite", "false");
                        localStorage.setItem("sentinelAlertsSite", "true");
                        localStorage.setItem("diceAlertsSite", "false");
                    } else {
                        localStorage.setItem("immixAlertsSite", "false");
                        localStorage.setItem("sentinelAlertsSite", "false");
                        localStorage.setItem("sureviewAlertsSite", "false");
                        localStorage.setItem("diceAlertsSite", "false");
                    }
                }
                if (config.id === "group" && location.href.includes("addsite")) {
                    const groupLabel = newInputValue != null && typeof newInputValue === "object" ? newInputValue.name : "";
                    localStorage.setItem("groupSelected", groupLabel);
                }
                if (config.id === "wireguard" && location.href.includes("addsite")) {
                    const store = (0, $f3a38e087c86c35f$export$7003214a0e2ce77c).getState();
                    store.setNeedsWireGuardOnboarding(!!newInputValue);
                    store.setSelectedWireGuardServer(newInputValue || null);
                }
            },
            sx: {
                width: 350
            },
            renderInput: (params)=>isGroupField ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    variant: "standard",
                    label: config.label,
                    autoComplete: "off",
                    id: config.id,
                    helperText: helperText
                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $g2LMr.Field), {
                    ...params,
                    variant: "standard",
                    label: config.label,
                    autoComplete: "off",
                    id: config.id,
                    name: config.id,
                    helperText: helperText,
                    as: $c164b9d38679f5fa$var$TextFieldComponent
                })
        })
    }, config.id);
};
const $c164b9d38679f5fa$var$TextFieldComponent = (props)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
        ...props
    });



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $3baw3 = parcelRequire("3baw3");
var $lk6eW = parcelRequire("lk6eW");
var $k1BHZ = parcelRequire("k1BHZ");
var $imWqP = parcelRequire("imWqP");

var $g2LMr = parcelRequire("g2LMr");
const $88df612d76dfcf1e$export$ffe33dee859be702 = ({ config: config, formik: formik })=>/*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $lk6eW.default), {
                id: config.label,
                children: config.label
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $imWqP.default), {
                row: true,
                "aria-labelledby": `row-radio-buttons-${config.label}`,
                name: config.field,
                onChange: (item)=>{
                    formik.values[config.field] = item.target.value;
                },
                sx: {
                    width: 350
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $g2LMr.Field), {
                        type: "radio",
                        name: config.field,
                        value: config.option1,
                        label: config.option1,
                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {}),
                        as: $88df612d76dfcf1e$var$RadioComponent
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $g2LMr.Field), {
                        type: "radio",
                        name: config.field,
                        value: config.option2,
                        label: config.option2,
                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {}),
                        as: $88df612d76dfcf1e$var$RadioComponent
                    })
                ]
            })
        ]
    }, config.id);
const $88df612d76dfcf1e$var$RadioComponent = (props)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
        ...props
    });



var $k4ank = parcelRequire("k4ank");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");

var $g2LMr = parcelRequire("g2LMr");

var $8T3gX = parcelRequire("8T3gX");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");
const $b5d9c8f1ac0929c1$export$6fc71ba87775b558 = [
    {
        product: "Intruder",
        resolution: "480p",
        fps: 5,
        aspect_ratio: "4:3",
        codec: "H264"
    },
    {
        product: "Intruder+",
        resolution: "480p",
        fps: 5,
        aspect_ratio: "4:3",
        codec: "H264"
    },
    {
        product: "Gun",
        resolution: "720p",
        fps: 6,
        aspect_ratio: "16:9",
        codec: "H264"
    },
    {
        product: "Loitering",
        resolution: "480p",
        fps: 5,
        aspect_ratio: "4:3",
        codec: "H264"
    },
    {
        product: "Vehicle Loitering",
        resolution: "480p",
        fps: 5,
        aspect_ratio: "4:3",
        codec: "H264"
    },
    {
        product: "Crowd",
        resolution: "480p",
        fps: 5,
        aspect_ratio: "4:3",
        codec: "H264"
    },
    {
        product: "Hard Hat",
        resolution: "480p",
        fps: 5,
        aspect_ratio: "4:3",
        codec: "H264"
    },
    {
        product: "Fire",
        resolution: "720p",
        fps: 5,
        aspect_ratio: "4:3",
        codec: "H264"
    },
    // {
    //   product: "Left Object",
    //   resolution: "480p",
    //   fps: 5,
    //   aspect_ratio: "4:3",
    //   codec: "H264",
    // },
    {
        product: "Postal Vehicle ID",
        resolution: "480p",
        fps: 5,
        aspect_ratio: "4:3",
        codec: "H264"
    },
    {
        product: "Slip & Fall",
        resolution: "720p",
        fps: 5,
        aspect_ratio: "4:3",
        codec: "H264"
    },
    {
        product: "People Flow",
        resolution: "480p",
        fps: 5,
        aspect_ratio: "4:3",
        codec: "H264"
    },
    // {
    //   product: `Mask / No Mask`,
    //   resolution: "480p",
    //   fps: 5,
    //   aspect_ratio: "4:3",
    //   codec: "H264",
    // },
    // {
    //   product: `Package`,
    //   resolution: "480p",
    //   fps: 5,
    //   aspect_ratio: "4:3",
    //   codec: "H264",
    // },
    {
        product: `Social Distancing`,
        resolution: "480p",
        fps: 5,
        aspect_ratio: "4:3",
        codec: "H264"
    },
    {
        product: `Sudden Scene Change`,
        resolution: "480p",
        fps: 5,
        aspect_ratio: "4:3",
        codec: "H264"
    }
];



var $fIsAN = parcelRequire("fIsAN");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $d8f875ed9a0fa5f4$export$dd632f6ca29d1fa1 = (setHelperText, productsArray, options, navigate)=>{
    const baseValues = {
        resolution: "480p",
        fps: 2,
        aspect_ratio: "4:3",
        codec: "H264"
    };
    const optionIds = new Map();
    options.forEach((array)=>{
        optionIds.set(array[0], array[1]);
    });
    let numberString = ``;
    productsArray.forEach((name, index)=>{
        if (index === 0) numberString += `${optionIds.get(name)}`;
        else numberString += `,${optionIds.get(name)}`;
    });
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $d8f875ed9a0fa5f4$export$dd632f6ca29d1fa1(setHelperText, productsArray, options, navigate);
    };
    (0, $b5d9c8f1ac0929c1$export$6fc71ba87775b558).forEach((object)=>{
        if (productsArray.includes(object.product)) {
            if (Number(object.resolution.slice(0, 3)) > Number(baseValues.resolution.slice(0, 3))) baseValues.resolution = `${Number(object.resolution.slice(0, 3))}p`;
            if (object.fps > baseValues.fps) baseValues.fps = object.fps;
            if (object.aspect_ratio !== "4:3") baseValues.aspect_ratio, object.aspect_ratio;
        }
    });
    if (productsArray.length === 1 && productsArray[0] === "Healthcheck") {
        setHelperText(``);
        return;
    } else if (location.href.includes("addcamera") && productsArray[0]) AxiosUI.get(`product_requirements/per_products/?products=${numberString}`).then((response)=>{
        const data = response.data;
        setHelperText(/*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "font-bold text-[13px] text-red-600",
                    children: `For the selected ${productsArray.length === 1 ? "detection" : "detections"} we suggest that your cameras are onboarded with the following settings:`
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                    className: "font-bold text-[13px] text-red-600",
                    children: [
                        "\xa0 ",
                        `- Resolution: ${data.height}p`
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                    className: " font-bold text-[13px] text-red-600",
                    children: [
                        "\xa0 ",
                        `- Frame Rate: ${data.frame_rate_range}`
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                    className: "font-bold text-[13px] text-red-600",
                    children: [
                        "\xa0 ",
                        `- Aspect Ratio: ${data.aspect_ratio}`
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                    className: " font-bold text-[13px] text-red-600",
                    children: [
                        "\xa0 ",
                        `- Codec: ${data.codec}`
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "text-[#0000EE]",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                        to: "/productrequirements",
                        target: "_blank",
                        children: "CLICK HERE to see all product requirements."
                    })
                })
            ]
        }));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setHelperText(``);
        });
    });
    else setHelperText(``);
};


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");


var $4PFLW = parcelRequire("4PFLW");
const $2cdc286d7222c539$export$b8349a66e7a6bdd6 = [
    "Intruder",
    "Intruder +"
];
const $2cdc286d7222c539$export$51849f36d74f67d7 = [
    "Motion Plus",
    "Motion +"
];
const $2cdc286d7222c539$export$85aec4f2c2875209 = "Line Crossing";
const $2cdc286d7222c539$var$getTrioGroupForLabel = (label)=>{
    if ($2cdc286d7222c539$export$b8349a66e7a6bdd6.includes(label)) return "intruder";
    if ($2cdc286d7222c539$export$51849f36d74f67d7.includes(label)) return "motion-plus";
    if (label === $2cdc286d7222c539$export$85aec4f2c2875209) return "line-crossing";
    return null;
};
const $2cdc286d7222c539$export$b3961591d3ee8d61 = (selectedDisplayNames)=>{
    const selectedSet = new Set(selectedDisplayNames);
    const hideDisplayNames = new Set();
    const selectedGroups = new Set();
    selectedDisplayNames.forEach((label)=>{
        const group = $2cdc286d7222c539$var$getTrioGroupForLabel(label);
        if (group) selectedGroups.add(group);
    });
    if (selectedSet.has("Intruder")) hideDisplayNames.add("Intruder +");
    if (selectedSet.has("Intruder +")) hideDisplayNames.add("Intruder");
    if (selectedGroups.has("intruder")) {
        $2cdc286d7222c539$export$51849f36d74f67d7.forEach((label)=>hideDisplayNames.add(label));
        hideDisplayNames.add($2cdc286d7222c539$export$85aec4f2c2875209);
    }
    if (selectedGroups.has("motion-plus")) {
        $2cdc286d7222c539$export$b8349a66e7a6bdd6.forEach((label)=>hideDisplayNames.add(label));
        hideDisplayNames.add($2cdc286d7222c539$export$85aec4f2c2875209);
    }
    if (selectedGroups.has("line-crossing")) {
        $2cdc286d7222c539$export$b8349a66e7a6bdd6.forEach((label)=>hideDisplayNames.add(label));
        $2cdc286d7222c539$export$51849f36d74f67d7.forEach((label)=>hideDisplayNames.add(label));
    }
    return hideDisplayNames;
};
const $2cdc286d7222c539$export$2e53db296279b6d7 = (baseOptions, selectedDisplayNames)=>{
    const hiddenDisplayNames = $2cdc286d7222c539$export$b3961591d3ee8d61(selectedDisplayNames);
    return baseOptions.filter((row)=>!hiddenDisplayNames.has(row[0]));
};
const $2cdc286d7222c539$export$9a3d8fc14dd5f8c9 = (selectedProductIds, productsArray)=>{
    const idToName = new Map();
    const nameToId = new Map();
    productsArray.forEach(([name, id])=>{
        idToName.set(id, name);
        nameToId.set(name, id);
    });
    const selectedDisplayNames = selectedProductIds.map((id)=>idToName.get(id)).filter((name)=>name !== undefined);
    const hiddenDisplayNames = $2cdc286d7222c539$export$b3961591d3ee8d61(selectedDisplayNames);
    const hiddenProductIds = new Set();
    hiddenDisplayNames.forEach((name)=>{
        const id = nameToId.get(name);
        if (id !== undefined && !selectedProductIds.includes(id)) hiddenProductIds.add(id);
    });
    return hiddenProductIds;
};
const $2cdc286d7222c539$export$9ad9f736143d69a2 = (productName)=>$2cdc286d7222c539$var$getTrioGroupForLabel(productName) !== null;


const $fe6f2add1887b923$export$4486284370e00acb = ({ config: config, formik: formik, setErrorState: setErrorState, setChoicesChanger: setChoicesChanger, choicesChanger: choicesChanger, setHealthCheckSelected: setHealthCheckSelected, setActiveWizardContainer: setActiveWizardContainer, handleSubmitSite: handleSubmitSite, responseObject: responseObject, setVisibleScreen: setVisibleScreen })=>{
    const options = config.options;
    const optionsIds = new Map();
    const optionNames = new Map();
    options.forEach((option)=>{
        optionsIds.set(option[0], option[1]);
    });
    options.forEach((option)=>{
        optionNames.set(option[1], option[0]);
    });
    const [newChoicesChanger, setNewChoicesChanger] = $8T3gX.useState(false);
    const [helperText, setHelperText] = $8T3gX.useState(config.helperText);
    const navigate = (0, $3T949.useNavigate)();
    const { isFeatureEnabled: isFeatureEnabled } = (0, $4PFLW.useFeatureFlag)();
    const showLineCrossings = isFeatureEnabled("showLineCrossings", true);
    if (!choicesChanger) {
        choicesChanger = newChoicesChanger;
        setChoicesChanger = setNewChoicesChanger;
    }
    const getFilteredOptions = $8T3gX.useCallback((options)=>{
        if (config.id === "products" && !showLineCrossings) return options.filter((subArr)=>subArr[0] !== "Line Crossing");
        return options;
    }, [
        config.id,
        showLineCrossings
    ]);
    const vField = formik.values[config.field];
    const productsSelectionSignature = Array.isArray(vField) ? [
        ...vField
    ].sort((a, b)=>a - b).join(",") : "";
    const computeProductChoiceOptions = $8T3gX.useCallback((selectedDisplayNames)=>{
        const base = getFilteredOptions(config.options);
        if (config.id !== "products" || !location.href.includes("addcamera")) return base;
        return (0, $2cdc286d7222c539$export$2e53db296279b6d7)(base, selectedDisplayNames);
    }, [
        config.id,
        config.options,
        getFilteredOptions
    ]);
    const [choiceOptions, setChoiceOptions] = $8T3gX.useState(()=>computeProductChoiceOptions(Array.isArray(formik.values[config.field]) ? formik.values[config.field].map((element)=>optionNames.get(element)).filter((item)=>item !== undefined) : []));
    $8T3gX.useEffect(()=>{
        if (config.id !== "products") return;
        const namesById = new Map();
        config.options.forEach((opt)=>{
            namesById.set(opt[1], opt[0]);
        });
        const labels = Array.isArray(formik.values[config.field]) && namesById.size > 0 ? formik.values[config.field].map((id)=>namesById.get(id)).filter((x)=>x !== undefined) : [];
        setChoiceOptions(computeProductChoiceOptions(labels));
    }, [
        config.id,
        config.field,
        config.options,
        computeProductChoiceOptions,
        productsSelectionSignature
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            multiple: true,
            disablePortal: true,
            id: config.id,
            defaultValue: Array.isArray(formik.values[config.field]) ? formik.values[config.field].map((element)=>optionNames.get(element)).filter((item)=>item !== undefined) // Filter out invalid mappings
             : [],
            options: choiceOptions.map((option)=>{
                return option[0];
            }),
            onChange: (event, value)=>{
                if (config.id === "products" && location.href.includes("addcamera")) (0, $d8f875ed9a0fa5f4$export$dd632f6ca29d1fa1)(setHelperText, value, config.options, navigate);
                if (config.id === "products" && location.href.includes("addsite")) {
                    if (value.length === 1 && value[0] === "Health Monitoring") localStorage.setItem("healthMonitoringOnly", "true");
                    else localStorage.setItem("healthMonitoringOnly", "false");
                }
                if (config.id === "products" && location.href.includes("addsite") && value.includes("Healthcheck")) {
                    setHealthCheckSelected(true);
                    setActiveWizardContainer(/*#__PURE__*/ (0, $k4ank.jsx)((0, $ede6db9a8f6145a5$export$adee19d4c733bc3e), {
                        handleSubmitData: handleSubmitSite,
                        response: responseObject,
                        setVisibleScreen: setVisibleScreen,
                        responseObject: false,
                        choicesChanger: choicesChanger,
                        setChoicesChanger: setChoicesChanger,
                        setHealthCheckSelected: setHealthCheckSelected,
                        healthCheckSelected: true,
                        setActiveWizardContainer: setActiveWizardContainer,
                        handleSubmitSite: handleSubmitSite,
                        setCameraCheckFinsihedAlertOpen: ()=>{},
                        setGoodCameras: ()=>{},
                        setConnectivityCameras: ()=>{},
                        setLowResolutionCameras: ()=>{},
                        setCameraCheckResultDownloadURL: ()=>{}
                    }));
                    if (value.length === 1) localStorage.setItem("healthcheckOnly", "true");
                    if (value.length > 1) localStorage.setItem("healthcheckOnly", "false");
                }
                if (config.id === "products" && location.href.includes("addcamera")) setChoiceOptions(computeProductChoiceOptions(value));
                if (config.id === "products" && location.href.includes("addsite") && !value.includes("Healthcheck")) {
                    setHealthCheckSelected(false);
                    localStorage.setItem("healthcheckOnly", "false");
                    setActiveWizardContainer(/*#__PURE__*/ (0, $k4ank.jsx)((0, $ede6db9a8f6145a5$export$adee19d4c733bc3e), {
                        handleSubmitData: handleSubmitSite,
                        response: responseObject,
                        setVisibleScreen: setVisibleScreen,
                        responseObject: false,
                        choicesChanger: choicesChanger,
                        setChoicesChanger: setChoicesChanger,
                        setHealthCheckSelected: setHealthCheckSelected,
                        healthCheckSelected: false,
                        setActiveWizardContainer: setActiveWizardContainer,
                        handleSubmitSite: handleSubmitSite,
                        setCameraCheckFinsihedAlertOpen: ()=>{},
                        setGoodCameras: ()=>{},
                        setConnectivityCameras: ()=>{},
                        setLowResolutionCameras: ()=>{},
                        setCameraCheckResultDownloadURL: ()=>{}
                    }));
                }
                const choicesArray = [];
                value.forEach((element)=>{
                    choicesArray.push(optionsIds.get(element));
                });
                setChoicesChanger(!choicesChanger);
                formik.values[config.field] = choicesArray;
            },
            sx: {
                width: 350
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $g2LMr.Field), {
                    ...params,
                    variant: "standard",
                    defaultValue: formik.values[config.field],
                    label: config.label,
                    name: config.id,
                    helperText: helperText,
                    as: $fe6f2add1887b923$var$TextFieldComponent
                })
        })
    });
};
const $fe6f2add1887b923$var$TextFieldComponent = (props)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
        ...props
    });



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $eejVe = parcelRequire("eejVe");

var $g2LMr = parcelRequire("g2LMr");
const $f4601cce939a41bc$export$ce8ca4e436154818 = ({ config: config, formik: formik, setErrorState: setErrorState })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (config.validation) setErrorState((previousState)=>{
            return {
                ...previousState,
                [config.id]: true
            };
        });
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $g2LMr.Field), {
            id: config.id,
            label: config.label,
            name: config.field,
            sx: {
                width: 350
            },
            helperText: config.helperText,
            rows: config.rows ? config.rows : 2,
            as: $f4601cce939a41bc$var$TextComponent
        })
    }, config.id);
};
const $f4601cce939a41bc$var$TextComponent = (props)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
        multiline: true,
        ...props
    });



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kbChx = parcelRequire("kbChx");

var $3baw3 = parcelRequire("3baw3");

var $9qNow = parcelRequire("9qNow");

var $hG03Q = parcelRequire("hG03Q");
const $1b6a829de835a371$export$137e6cc60d12c1b = ({ config: config, formik: formik })=>{
    const hasInitializedField = $8T3gX.useRef(false);
    $8T3gX.useEffect(()=>{
        if (!hasInitializedField.current) {
            hasInitializedField.current = true;
            const normalizedCurrentValue = $1b6a829de835a371$var$normalizeCheckboxValue(formik.values[config.field]);
            if (formik.values[config.field] !== normalizedCurrentValue) {
                if (typeof formik.setFieldValue === "function") formik.setFieldValue(config.field, normalizedCurrentValue, false);
                else formik.values[config.field] = normalizedCurrentValue;
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Patriot forms (the only alarm form carrying patriot_send_video) replace
    // the send video / draw ignore zones checkboxes with one delivery choice:
    // it renders in place of patriot_send_video and owns draw_ignore_zones too.
    const isPatriotForm = !!formik.values && "patriot_send_video" in formik.values;
    if (isPatriotForm && config.field === "draw_ignore_zones") return null;
    if (isPatriotForm && config.field === "patriot_send_video") {
        const setField = (field, value)=>{
            if (typeof formik.setFieldValue === "function") formik.setFieldValue(field, value, false);
            else formik.values[field] = value;
        };
        return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
            className: "pb-2",
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $hG03Q.PatriotDeliveryChoice), {
                sendVideo: formik.values.patriot_send_video,
                drawIgnoreZones: formik.values.draw_ignore_zones,
                onChange: (values)=>{
                    setField("patriot_send_video", values.patriot_send_video);
                    setField("draw_ignore_zones", values.draw_ignore_zones);
                }
            })
        }, config.id);
    }
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                sx: {
                    fontFamily: "Mulish",
                    color: "#001943"
                },
                label: config.label === "NAT Instance" ? "Whitelisting" : config.label,
                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                    color: "primary",
                    checked: $1b6a829de835a371$var$normalizeCheckboxValue(formik.values[config.field]),
                    disabled: config.disabled,
                    onChange: (item)=>{
                        if (typeof formik.setFieldValue === "function") formik.setFieldValue(config.field, item.target.checked, false);
                        else formik.values[config.field] = item.target.checked;
                    }
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                sx: {
                    width: 350
                },
                children: config.helperText.includes("NAT") ? config.helperText.replace("NAT", "Whitelisting") : config.helperText
            })
        ]
    }, config.id);
};
const $1b6a829de835a371$var$normalizeCheckboxValue = (value)=>{
    if (value === true || value === "True") return true;
    if (value === false || value === "False" || value === "" || typeof value === "undefined" || value === null) return false;
    return Boolean(value);
};



var $8T3gX = parcelRequire("8T3gX");


var $7U8Fx = parcelRequire("7U8Fx");
const $9b73522489a91e48$export$1def6f1e551e2b34 = (formikValues, responseObject, setNextOrSubmitButtonDisabled)=>{
    let allRequiredFieldsFilled = true;
    responseObject.forEach((step)=>{
        // A field hidden by its visible_when rule (ENG-2535) cannot be filled
        // in, so it never blocks the step.
        if (step.validation && (0, $7U8Fx.isFieldVisible)(step.visible_when, formikValues)) {
            if (formikValues[step.field] === "" || formikValues[step.field] === undefined || formikValues[step.field] === null || //or if it is an array and the length is 0
            Array.isArray(formikValues[step.field]) && formikValues[step.field].length === 0) allRequiredFieldsFilled = false;
        }
    });
    // ENG-1924: a Host or Stream Parameter the connector cannot dial (e.g. a
    // whole rtsps:// URL in Stream Parameter) blocks the step like a missing
    // required field; StreamUrlAssist shows why.
    if ((0, $529194e764056c0b$export$b1c08bc023515e2)(responseObject) && Object.keys((0, $529194e764056c0b$export$44b93e0131bd846a)(formikValues)).length > 0) allRequiredFieldsFilled = false;
    setNextOrSubmitButtonDisabled(!allRequiredFieldsFilled);
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $eejVe = parcelRequire("eejVe");

/**
 * How the pasted URL was split, shown before (while typing) and after it
 * fills the fields (ENG-2042), so a wrong split is visible instead of saved.
 * The password is masked; only its length shows.
 */ const $35e72c1a4988deb6$var$ParsePreview = ({ raw: raw })=>{
    const parsed = (0, $529194e764056c0b$export$f4b4f099cd6d7164)(raw);
    const hints = (0, $529194e764056c0b$export$d4b91fc51a3645b7)(raw);
    if (!parsed && hints.length === 0) return null;
    const rows = parsed ? [
        [
            "Protocol",
            parsed.protocol.toUpperCase()
        ],
        [
            "Host",
            parsed.host
        ],
        [
            "Port",
            (0, $529194e764056c0b$export$2c748151ef73242e)(raw) ? parsed.port : `${parsed.port} (default)`
        ],
        [
            "Username",
            parsed.username || "(none)"
        ],
        [
            "Password",
            parsed.password ? `\u{2022}\u{2022}\u{2022}\u{2022} (${parsed.password.length} characters)` : "(none)"
        ],
        [
            "Stream Parameter",
            parsed.path || "(none)"
        ]
    ] : [];
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "font-mulish text-[13px] text-[#283E6D] mt-2 max-w-[350px]",
        "data-testid": "stream-url-parse-preview",
        children: [
            parsed && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        children: "How we read this URL:"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("ul", {
                        className: "ml-4",
                        children: rows.map(([label, value])=>/*#__PURE__*/ (0, $k4ank.jsxs)("li", {
                                "data-testid": `stream-url-parsed-${label}`,
                                children: [
                                    label,
                                    ": ",
                                    /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                        className: "font-bold break-all",
                                        children: value
                                    })
                                ]
                            }, label))
                    })
                ]
            }),
            hints.map((hint)=>/*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "text-[#B26A00] mt-1",
                    "data-testid": "stream-url-hint",
                    children: hint
                }, hint))
        ]
    });
};
const $35e72c1a4988deb6$export$6c347afb98a918d0 = ({ formik: formik })=>{
    const [pasted, setPasted] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [note, setNote] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    // The last URL applied to the fields, so its preview stays after the box
    // clears.
    const [applied, setApplied] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const values = formik.values || {};
    const problems = (0, $529194e764056c0b$export$44b93e0131bd846a)(values);
    const address = (0, $529194e764056c0b$export$22f59cb2161f8af8)(values);
    const setField = (field, value)=>{
        if (typeof formik.setFieldValue === "function") formik.setFieldValue(field, value, false);
        else formik.values[field] = value;
    };
    const applyUrl = (raw)=>{
        const parsed = (0, $529194e764056c0b$export$f4b4f099cd6d7164)(raw);
        if (!parsed) {
            setNote(raw.trim() ? "That doesn't look like a stream URL. Example: rtsp://admin:password@203.0.113.20:554/Streaming/Channels/101" : null);
            return;
        }
        setField("ip", parsed.host);
        if (parsed.protocol.startsWith("http") && "http" in values) setField("http", parsed.port);
        else if ("rtsp" in values || parsed.protocol.startsWith("rtsp")) setField("rtsp", parsed.port);
        setField("channel", parsed.path);
        if (parsed.username && "username" in values) setField("username", parsed.username);
        if (parsed.password && "password" in values) setField("password", parsed.password);
        setApplied(raw);
        setPasted("");
        setNote(`Filled Host, port and Stream Parameter from the URL. This URL uses ${parsed.protocol.toUpperCase()}: the site's Streaming Protocol must be ${parsed.protocol.toUpperCase()} too.`);
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        "data-testid": "stream-url-assist",
        className: "mt-2",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                id: "stream-url-paste",
                label: "Have a working stream URL? Paste it here",
                placeholder: "rtsp://admin:password@203.0.113.20:554/Streaming/Channels/101",
                variant: "standard",
                autoComplete: "off",
                sx: {
                    width: 350
                },
                value: pasted,
                onChange: (event)=>{
                    const nextValue = event.target.value;
                    setPasted(nextValue);
                },
                onBlur: ()=>pasted && applyUrl(pasted),
                onKeyDown: (event)=>{
                    if (event.key === "Enter") {
                        event.preventDefault();
                        applyUrl(pasted);
                    }
                },
                helperText: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                    children: [
                        "Example: rtsp://admin:password@203.0.113.20:554/Streaming/Channels/101",
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                        'We fill Host, port and Stream Parameter from it, and Username / Password when the URL includes them. The login and the port are optional. Use the address Actuate can reach: the public IP or hostname, or the camera\'s private IP only when this site connects over a VPN. If the password contains "/", write it as %2F. An RTSPS URL without a port uses 554; Genetec Media Gateway usually needs :654.'
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)($35e72c1a4988deb6$var$ParsePreview, {
                raw: pasted || applied
            }),
            note && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "font-mulish text-[13px] text-[#283E6D] mt-1",
                "data-testid": "stream-url-note",
                children: note
            }),
            address && /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                className: "font-mulish text-[13px] text-[#283E6D] mt-2 max-w-[350px]",
                "data-testid": "stream-address-preview",
                children: [
                    "We will connect to:",
                    " ",
                    /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                        className: "font-bold break-all",
                        "data-testid": "stream-address-preview-value",
                        children: address
                    })
                ]
            }),
            Object.entries(problems).map(([field, message])=>/*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "font-mulish text-[13px] text-[#D32F2F] mt-1",
                    "data-testid": `stream-address-problem-${field}`,
                    children: message
                }, field))
        ]
    });
};




var $7U8Fx = parcelRequire("7U8Fx");
const $02c2f7b25b009ab7$var$RecursiveContainer = ({ config: config, formik: formik, setErrorState: setErrorState, choicesChanger: choicesChanger, setChoicesChanger: setChoicesChanger, stepNumber: stepNumber, setHealthCheckSelected: setHealthCheckSelected, healthCheckSelected: healthCheckSelected, setActiveWizardContainer: setActiveWizardContainer, handleSubmitSite: handleSubmitSite, responseObject: responseObject, setVisibleScreen: setVisibleScreen, setNextOrSubmitButtonDisabled: setNextOrSubmitButtonDisabled })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        // console.log("formik", formik.values);
        // console.log("reponseObject", responseObject.forms[stepNumber]);
        (0, $9b73522489a91e48$export$1def6f1e551e2b34)(formik.values, responseObject.forms[stepNumber], setNextOrSubmitButtonDisabled);
    }, [
        formik
    ]);
    const builder = (individualConfig)=>{
        switch(individualConfig.type){
            case "integer":
                return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $94514691c6a45869$export$158eb8aec0a82f84), {
                            config: individualConfig,
                            formik: formik,
                            setErrorState: setErrorState,
                            stepNumber: stepNumber
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                    ]
                });
            case "string":
                return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $8d1595539bee672a$export$625ef31dfb14019b), {
                            config: individualConfig,
                            formik: formik,
                            setErrorState: setErrorState,
                            stepNumber: stepNumber
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                    ]
                });
            case "password":
                return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $d9fa6d318e061bd7$export$b4959feafefa5ff7), {
                            config: individualConfig,
                            formik: formik,
                            setErrorState: setErrorState,
                            stepNumber: stepNumber
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                    ]
                });
            case "choice":
                return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $c164b9d38679f5fa$export$fb687e9ef1b1dada), {
                            config: individualConfig,
                            formik: formik,
                            setErrorState: setErrorState,
                            setChoicesChanger: setChoicesChanger,
                            choicesChanger: choicesChanger
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                    ]
                });
            case "checkbox":
                return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $1b6a829de835a371$export$137e6cc60d12c1b), {
                            config: individualConfig,
                            formik: formik
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                    ]
                });
            case "radio":
                return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $88df612d76dfcf1e$export$ffe33dee859be702), {
                            config: individualConfig,
                            formik: formik
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                    ]
                });
            case "textarea":
                return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $f4601cce939a41bc$export$ce8ca4e436154818), {
                            config: individualConfig,
                            formik: formik,
                            setErrorState: setErrorState
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                    ]
                });
            case "multiChoice":
                return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $fe6f2add1887b923$export$4486284370e00acb), {
                            config: individualConfig,
                            formik: formik,
                            setErrorState: setErrorState,
                            setChoicesChanger: setChoicesChanger,
                            choicesChanger: choicesChanger,
                            setHealthCheckSelected: setHealthCheckSelected,
                            setActiveWizardContainer: setActiveWizardContainer,
                            handleSubmitSite: handleSubmitSite,
                            responseObject: responseObject,
                            setVisibleScreen: setVisibleScreen
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                    ]
                });
            case "array":
                return /*#__PURE__*/ (0, $k4ank.jsx)($02c2f7b25b009ab7$var$RecursiveContainer, {
                    config: individualConfig.children || [],
                    formik: formik,
                    setErrorState: setErrorState,
                    choicesChanger: choicesChanger,
                    setChoicesChanger: setChoicesChanger,
                    stepNumber: stepNumber,
                    setHealthCheckSelected: setHealthCheckSelected,
                    healthCheckSelected: healthCheckSelected,
                    setActiveWizardContainer: setActiveWizardContainer,
                    handleSubmitSite: handleSubmitSite,
                    responseObject: responseObject,
                    setVisibleScreen: setVisibleScreen,
                    setNextOrSubmitButtonDisabled: setNextOrSubmitButtonDisabled
                });
            default:
                return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    children: "Unsupported field"
                });
        }
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            config.map((c)=>{
                // ENG-2535: a field whose visible_when rule fails is not rendered; its
                // value stays in formik.values and is submitted unchanged.
                if (!(0, $7U8Fx.isFieldVisible)(c.visible_when, formik.values)) return null;
                // if (c.validation) {
                //   console.log("c.validation", formik.values[c.field]);
                // }
                // else {
                //   console.log("c", formik)
                // }
                if (c.label === "Alert emails") {
                    if (healthCheckSelected) return builder(c);
                } else if (c.label === "Report emails") {
                    if (healthCheckSelected) return builder(c);
                    return;
                } else return builder(c);
            }),
            (0, $529194e764056c0b$export$b1c08bc023515e2)(config) && /*#__PURE__*/ (0, $k4ank.jsx)((0, $35e72c1a4988deb6$export$6c347afb98a918d0), {
                formik: formik
            })
        ]
    });
};
var $02c2f7b25b009ab7$export$2e2bcd8739ae039 = $02c2f7b25b009ab7$var$RecursiveContainer;



var $g2LMr = parcelRequire("g2LMr");
const $4f1c12eb0c898328$var$Step = ({ formConfig: formConfig, validationSchema: validationSchema, setErrorState: setErrorState, choicesChanger: choicesChanger, setChoicesChanger: setChoicesChanger, stepNumber: stepNumber, setHealthCheckSelected: setHealthCheckSelected, healthCheckSelected: healthCheckSelected, setActiveWizardContainer: setActiveWizardContainer, handleSubmitSite: handleSubmitSite, responseObject: responseObject, setVisibleScreen: setVisibleScreen, setNextOrSubmitButtonDisabled: setNextOrSubmitButtonDisabled })=>{
    const formik = (0, $g2LMr.useFormikContext)();
    // formConfig.label === ""
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $02c2f7b25b009ab7$export$2e2bcd8739ae039), {
        config: formConfig,
        formik: formik,
        setErrorState: setErrorState,
        choicesChanger: choicesChanger,
        setChoicesChanger: setChoicesChanger,
        stepNumber: stepNumber,
        setHealthCheckSelected: setHealthCheckSelected,
        healthCheckSelected: healthCheckSelected,
        setActiveWizardContainer: setActiveWizardContainer,
        handleSubmitSite: handleSubmitSite,
        responseObject: responseObject,
        setVisibleScreen: setVisibleScreen,
        setNextOrSubmitButtonDisabled: setNextOrSubmitButtonDisabled
    });
};
var $4f1c12eb0c898328$export$2e2bcd8739ae039 = $4f1c12eb0c898328$var$Step;



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $g2LMr = parcelRequire("g2LMr");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $g2LMr = parcelRequire("g2LMr");

var $a65wX = parcelRequire("a65wX");
var $d3288a6590e888c8$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($d3288a6590e888c8$exports, "__esModule", {
    value: true
});
$d3288a6590e888c8$exports.default = void 0;

var $d3288a6590e888c8$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $d3288a6590e888c8$var$_default = $d3288a6590e888c8$exports.default = (0, $d3288a6590e888c8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
}), 'ArrowBack');



var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");
const $12bb6167a2fb0fea$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $12bb6167a2fb0fea$var$BackButton = ({ previous: previous })=>{
    const formik = (0, $g2LMr.useFormikContext)();
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "absolute right-[288px]",
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
            theme: $12bb6167a2fb0fea$var$theme,
            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $a65wX.default), {
                onClick: ()=>previous(formik.values),
                type: "button",
                color: "primary",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d3288a6590e888c8$exports))), {}),
                    " BACK"
                ]
            })
        })
    });
};
var $12bb6167a2fb0fea$export$2e2bcd8739ae039 = $12bb6167a2fb0fea$var$BackButton;



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $g2LMr = parcelRequire("g2LMr");

var $a65wX = parcelRequire("a65wX");


var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");
const $275d2bf10a630861$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $275d2bf10a630861$var$SubmitButton = ({ next: next, isLastStep: isLastStep, errorState: errorState, choicesChanger: choicesChanger, buttonDisabled: buttonDisabled, setButtonDisabled: setButtonDisabled, nextOrSubmitButtonDisabled: nextOrSubmitButtonDisabled })=>{
    const formik = (0, $g2LMr.useFormikContext)();
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        let anyDisabled = false;
        Object.keys(errorState).forEach((key)=>{
            if (Array.isArray(formik.values[key]) && !formik.values[key][0]) anyDisabled = true;
            else if (!Array.isArray(formik.values[key]) && !formik.values[key]) anyDisabled = true;
        });
        if (anyDisabled) setButtonDisabled(true);
        else setButtonDisabled(false);
    }, [
        formik,
        choicesChanger
    ]);
    return(// Offsets are relative to the wizard footer row (ENG-2144); bottom-[15px]
    // in a 40px row keeps the button where bottom-[-25px] used to put it.
    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "absolute right-[-169px] bottom-[15px]",
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
            theme: $275d2bf10a630861$var$theme,
            children: isLastStep ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                className: "shadow-button bg-actuate-orange rounded font-mulish text-white text-base p-1.5",
                type: "submit",
                disabled: // !formik.isValid && formik.isSubmitting
                // checkErrors()
                // buttonDisabled
                // false
                nextOrSubmitButtonDisabled,
                children: "Submit"
            }) : /*#__PURE__*/ (0, $k4ank.jsxs)((0, $a65wX.default), {
                type: "submit",
                color: "primary",
                disabled: // !formik.isValid && formik.isSubmitting
                // buttonDisabled
                // false
                nextOrSubmitButtonDisabled,
                children: [
                    "NEXT ",
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($53b11234ecc265c7$exports))), {})
                ]
            })
        })
    }));
};
var $275d2bf10a630861$export$2e2bcd8739ae039 = $275d2bf10a630861$var$SubmitButton;



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $g2LMr = parcelRequire("g2LMr");

var $8jTCz = parcelRequire("8jTCz");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");


var $195EM = parcelRequire("195EM");

var $815yO = parcelRequire("815yO");
const $7594ecf03fc2d0d0$var$VALUES_PREFIX = "values.";
const $7594ecf03fc2d0d0$export$8b9dcf1ca0501722 = (forms)=>{
    const integerFields = new Set();
    forms.forEach((step)=>{
        step.forEach((field)=>{
            if (field?.type === "integer" && field.field) integerFields.add(field.field);
        });
    });
    return integerFields;
};
const $7594ecf03fc2d0d0$var$coerceIntegerValue = (value)=>{
    if (value === "" || value == null) return value;
    return Number(value);
};
const $7594ecf03fc2d0d0$var$resolveSubmitObjectTemplate = (template, values, integerFields)=>{
    if (template === null || template === undefined) return template;
    if (typeof template === "string" && template.startsWith($7594ecf03fc2d0d0$var$VALUES_PREFIX)) {
        const fieldName = template.slice($7594ecf03fc2d0d0$var$VALUES_PREFIX.length);
        const resolvedValue = values[fieldName];
        if (integerFields.has(fieldName)) return $7594ecf03fc2d0d0$var$coerceIntegerValue(resolvedValue);
        return resolvedValue;
    }
    if (Array.isArray(template)) return template.map((item)=>$7594ecf03fc2d0d0$var$resolveSubmitObjectTemplate(item, values, integerFields));
    if (typeof template === "object") return Object.fromEntries(Object.entries(template).map(([key, value])=>[
            key,
            $7594ecf03fc2d0d0$var$resolveSubmitObjectTemplate(value, values, integerFields)
        ]));
    return template;
};
const $7594ecf03fc2d0d0$export$65bae08767da1779 = (submitObject, values, forms)=>{
    const integerFields = forms ? $7594ecf03fc2d0d0$export$8b9dcf1ca0501722(forms) : new Set();
    return $7594ecf03fc2d0d0$var$resolveSubmitObjectTemplate(submitObject, values, integerFields);
};
const $7594ecf03fc2d0d0$export$3eefdbcfd19bbcca = ()=>{
    if (typeof localStorage === "undefined" || !localStorage.addCameraInfo) return undefined;
    try {
        const addCameraInfo = JSON.parse(localStorage.addCameraInfo);
        return addCameraInfo?.submit_object;
    } catch  {
        return undefined;
    }
};
const $7594ecf03fc2d0d0$export$d429b3844d4e795d = (values)=>{
    const customerId = Number(localStorage.siteId);
    const returnObject = {
        camera_name: values.camera_name,
        customer: customerId,
        integration: Number(localStorage.integrationType),
        http: Number(values.http),
        ip: values.ip,
        username: values.username,
        password: values.password,
        channel: values.channel,
        tcp: Number(values.tcp),
        rtsp: Number(values.rtsp),
        camera_type: values.camera_type,
        stream_parameters: values.stream_parameters,
        products: values.products,
        een_api: values.een_api,
        app_name: values.app_name,
        api_key: values.api_key,
        username_star4live: values.username_star4live,
        password_star4live: values.password_star4live,
        device_name: values.device_name,
        software_type_smartpss: values.software_type_smartpss,
        immix: {
            immix_id: values.immix_id,
            immix_server: values.immix_server,
            immix_email: values.immix_email,
            immix_port: values.immix_port,
            immix_input1: values.immix_input1
        },
        dice: {
            dice_id: values.dice_id,
            dice_server: values.dice_server,
            dice_email: values.dice_email,
            dice_port: values.dice_port,
            dice_input1: values.dice_input1
        },
        sentinel: {
            sentinel_server: values.sentinel_server,
            sentinel_site_id: values.sentinel_site_id,
            sentinel_device_address: values.sentinel_device_address,
            draw_ignore_zones: values.draw_ignore_zones
        },
        bold: {
            bold_server: values.bold_server,
            bold_port: values.bold_port,
            bold_id: values.bold_id,
            bold_sdnis: values.bold_sdnis,
            bold_zone: values.bold_zone,
            bold_alarmtype: values.bold_alarmtype
        },
        sureview: {
            sureview_server: values.sureview_server,
            sureview_subject: values.sureview_subject,
            sureview_cc: values.sureview_cc,
            sureview_email: values.sureview_email
        },
        patriot: {
            patriot_server: values.patriot_server,
            patriot_username: values.patriot_username,
            patriot_password: values.patriot_password,
            patriot_zone_number: values.patriot_zone_number,
            patriot_send_video: values.patriot_send_video,
            patriot_client_no: values.patriot_client_no,
            patriot_type_number: values.patriot_type_number,
            draw_ignore_zones: values.draw_ignore_zones
        },
        sysaid: {
            sysaid_server: values.sysaid_server,
            sysaid_client_local: values.sysaid_client_local,
            sysaid_username: values.sysaid_username,
            sysaid_password: values.sysaid_password
        },
        evalink: {
            evalink_token: values.evalink_token,
            evalink_device_id: values.evalink_device_id,
            evalink_company_id: values.evalink_company_id,
            partition_id: values.partition_id,
            alarm_zone_id: values.alarm_zone_id
        },
        lisa: {
            lisa_server: values.lisa_server,
            lisa_token: values.lisa_token,
            draw_ignore_zones: values.draw_ignore_zones
        },
        camera_view: values.camera_view,
        dynamic_slicing: values.dynamic_slicing
    };
    if (values.webhook) returnObject.webhook = {
        stream: values.stream,
        webhook: values.webhook,
        custom_fields: values.custom_fields,
        event_types: values.event_types
    };
    if (values.server) returnObject.softguard = {
        server: values.server,
        port: values.port,
        zone: values.zone,
        account: values.account,
        user: values.user,
        user_ext: values.user_ext
    };
    return returnObject;
};
const $7594ecf03fc2d0d0$export$3bad86e60f9f9c4e = (values, submitObject, forms)=>{
    const resolvedSubmitObject = submitObject ?? $7594ecf03fc2d0d0$export$3eefdbcfd19bbcca();
    if (resolvedSubmitObject) return $7594ecf03fc2d0d0$export$65bae08767da1779(resolvedSubmitObject, values, forms);
    return $7594ecf03fc2d0d0$export$d429b3844d4e795d(values);
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");


var $3QMQN = parcelRequire("3QMQN");

var $4wo2Y = parcelRequire("4wo2Y");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");


var $195EM = parcelRequire("195EM");

var $815yO = parcelRequire("815yO");



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

var $eDfvp = parcelRequire("eDfvp");
var $a65wX = parcelRequire("a65wX");
var $f3puC = parcelRequire("f3puC");

var $2CHqP = parcelRequire("2CHqP");

var $kbChx = parcelRequire("kbChx");

var $3baw3 = parcelRequire("3baw3");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $k4ank = parcelRequire("k4ank");

var $195EM = parcelRequire("195EM");




var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $c2a726b3b17ac790$export$127540781e11c5a3 = async (setVisibleScreen, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $c2a726b3b17ac790$export$127540781e11c5a3(setVisibleScreen, navigate);
    };
    localStorage.setItem("noAutoAddCamerasDialogOpen", "true");
    await AxiosUI.get(`nvr_camera/${localStorage.siteId}/refresh_status/`).then(async (response)=>{
        let getNVRCamerasFail = false;
        if (response.data.is_refreshed && !response.data.refresh_failed) {
            await AxiosUI.get(`nvr_camera/?customer__id=${localStorage.siteId}`).then((response)=>{
                if (response.data.count === 0) {
                    localStorage.setItem("noAutoAddCamerasDialogOpen", "true");
                    alert("No cameras were found using the VMS information provided.");
                    getNVRCamerasFail = true;
                    navigate(`/sites/aboutsite/${localStorage.siteId}`);
                }
                if (response.data.count > 0) localStorage.setItem("noAutoAddCamerasDialogOpen", "false");
                getNVRCamerasFail = false;
            }, (reason)=>{
                getNVRCamerasFail = true;
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
            });
            !getNVRCamerasFail && await AxiosUI.get(`nvr_camera/extra_fields/?customer__id=${localStorage.siteId}`).then((response)=>{
                localStorage.setItem("additionalFieldNamesArray", JSON.stringify(response.data));
                navigate("/sites/autoaddcamera");
            }, (reason)=>{
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
            });
        } else if (!response.data.is_refreshed && !response.data.refresh_failed) setTimeout(()=>{
            if (window.location.pathname.includes("addsite")) AxiosUI.get(`nvr_camera/?customer__id=${localStorage.siteId}`).then((response)=>{
                if (response.data.count === 0) $c2a726b3b17ac790$export$127540781e11c5a3(setVisibleScreen, navigate);
                if (response.data.count > 0) {
                    localStorage.setItem("noAutoAddCamerasDialogOpen", "false");
                    AxiosUI.get(`nvr_camera/extra_fields/?customer__id=${localStorage.siteId}`).then((response)=>{
                        localStorage.setItem("additionalFieldNamesArray", JSON.stringify(response.data));
                        navigate("/sites/autoaddcamera");
                    }, (reason)=>{
                        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
                    });
                }
            });
        }, 4000);
        else if (response.data.refresh_failed && response.data.is_refreshed) {
            alert(`${response.data.message}`);
            navigate(`/sites/aboutsite/${localStorage.siteId}`);
        } else {
            alert("Problem retrieving auto add cameras.  Please check VMS info and try again.");
            navigate(`/sites/aboutsite/${localStorage.siteId}`);
        }
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Problem retrieving auto add cameras.  Please check VMS info and try again.");
            navigate(`/sites/aboutsite/${localStorage.siteId}`);
        });
    });
};



var $3Zv1D = parcelRequire("3Zv1D");

var $ebTQj = parcelRequire("ebTQj");
const $8b891866c4a0a1da$export$11989d36ca85991f = async (id, setVisibleScreen, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $8b891866c4a0a1da$export$11989d36ca85991f(id, setVisibleScreen, navigate);
    };
    // ONVIF over WireGuard: skip NVR auto-add / manual camera entry — cameras are
    // added later from the progress screen via Discover Cameras.
    if (localStorage.selectedIntegrationName === "onvif_wireguard") {
        setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $e4a2260e96905f88$export$770d5a29da7608e0), {
            percentage: 33,
            step: 1,
            setVisibleScreen: setVisibleScreen
        }));
        return;
    }
    if (localStorage.autoAdd === "true") (0, $c2a726b3b17ac790$export$127540781e11c5a3)(setVisibleScreen, navigate);
    else await AxiosUI.get(`customer/${id}/camera_onboarding_forms/`).then((response)=>{
        // handleAddImmixToAddCameraForm(response.data);
        // handleAddDiceToAddCameraForm(response.data);
        localStorage.setItem("addCameraInfo", JSON.stringify(response.data));
        localStorage.setItem("selectedProducts", JSON.stringify(response.data.initial_data.products));
        setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $f05a511d40a0fd8d$export$3c049d782df88a0e), {
            styling: "absolute first-line:font-black font-mulish text-[20px] right-[190px] text-center text-[#283E6D] top-80",
            text: "Site created successfully!"
        }));
        setTimeout(()=>{
            setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $e4a2260e96905f88$export$770d5a29da7608e0), {
                percentage: (0, $1444c94c32ef2738$export$79b714ae571551b5)() ? localStorage.healthMonitoringOnly === "true" ? 33 : 25 : 33,
                step: 1,
                setVisibleScreen: setVisibleScreen
            }));
        }, 2000);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            (0, $ebTQj.logger).log(`Error: ${reason}`);
            setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $40e1b9daa0b4b4d7$export$72852cc74d844f32), {
                setVisibleScreen: setVisibleScreen
            }));
        });
    });
};




var $195EM = parcelRequire("195EM");

var $7kQyB = parcelRequire("7kQyB");

var $3Zv1D = parcelRequire("3Zv1D");
const $3d5e2464ea939321$export$702c539eae400f89 = async (navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    localStorage.setItem("clickedId", JSON.stringify(localStorage.siteId));
    const retryFunction = ()=>{
        $3d5e2464ea939321$export$702c539eae400f89(navigate);
    };
    let getSiteInfoFail = false;
    let getSiteCamerasFail = false;
    await (0, $7kQyB.fetchAddCameraInfo)(localStorage.siteId, navigate);
    await AxiosUI.get(`customer/${localStorage.siteId}/about/`).then((response)=>{
        getSiteInfoFail = false;
        localStorage.setItem("siteInfo", JSON.stringify(response.data));
    }, (reason)=>{
        getSiteInfoFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
    });
    !getSiteInfoFail && await AxiosUI.get(`camera/site/?customer__id=${localStorage.siteId}`).then((response)=>{
        getSiteCamerasFail = false;
        localStorage.setItem("siteCameras", JSON.stringify(response.data));
    }, (reason)=>{
        getSiteCamerasFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
    });
    !getSiteInfoFail && !getSiteCamerasFail && await AxiosUI.get(`schedule/by_customer/${localStorage.siteId}/`).then((response)=>{
        localStorage.setItem("siteSchedule", JSON.stringify(response.data));
        navigate(`/sites/aboutsite/${localStorage.siteId}`);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert(`${reason}`);
        });
    });
};



var $4wo2Y = parcelRequire("4wo2Y");

var $3mOKt = parcelRequire("3mOKt");

var $8jTCz = parcelRequire("8jTCz");
/**
 * Whether onboarding should route to the post-onboarding camera check
 * (proactive-alerting report) for the integration picked in the wizard.
 *
 * actuate_admin serves `camera_check_supported` per integration on
 * `integration_type/onboarding/`, stored in localStorage as `integrationTypes`
 * by dataFetchers. The lookup is by `selectedIntegrationName` (the internal
 * name), never the display name, so renaming an integration in admin can't
 * change the wizard flow. Replaces the hardcoded `validIntegrationTypes` list
 * of display names (ENG-1919).
 *
 * Defaults to true when the flag is absent (older admin) or the integration
 * isn't found, so no integration is silently cut out of the check.
 */ const $1444c94c32ef2738$export$79b714ae571551b5 = (integrationName = typeof localStorage !== "undefined" ? localStorage.getItem("selectedIntegrationName") : null, integrationTypesJson = typeof localStorage !== "undefined" ? localStorage.getItem("integrationTypes") : null)=>{
    if (!integrationName || !integrationTypesJson) return true;
    let integrationTypes;
    try {
        integrationTypes = JSON.parse(integrationTypesJson);
    } catch  {
        return true;
    }
    if (!Array.isArray(integrationTypes)) return true;
    const match = integrationTypes.find((item)=>item && item.name === integrationName);
    if (!match || typeof match.camera_check_supported !== "boolean") return true;
    return match.camera_check_supported;
};


const $e4a2260e96905f88$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $e4a2260e96905f88$export$770d5a29da7608e0 = ({ percentage: percentage, step: step, setVisibleScreen: setVisibleScreen })=>{
    const navigate = (0, $3T949.useNavigate)();
    const isOnvifWireguard = localStorage.selectedIntegrationName === "onvif_wireguard";
    const [activeOnboardingScreen, setActiveOnboardingScreen] = $8T3gX.useState(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
    const validCameraCheckIntegration = (0, $1444c94c32ef2738$export$79b714ae571551b5)();
    $8T3gX.useEffect(()=>{
        setActiveOnboardingScreen(onboardingScreen);
    }, []);
    const onvifOnboardingScreen = /*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $b9p11.default), {
                theme: $e4a2260e96905f88$var$theme,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-[142px] right-44",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $2CHqP.default), {
                            color: "primary",
                            variant: "determinate",
                            value: percentage,
                            sx: {
                                width: 275
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-32 right-32",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                            variant: "body1",
                            children: [
                                percentage,
                                "%"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-[195px] right-[150px] font-mulish text-actuate-blue",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            children: " Please complete the following information. "
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-[220px] right-[190px] font-mulish text-actuate-blue",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            children: " Otherwise the site won't run."
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-[275px] right-[350px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                            sx: {
                                display: "flex",
                                flexDirection: "column",
                                ml: 3
                            },
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                    sx: {
                                        fontFamily: "Mulish",
                                        color: "#001943"
                                    },
                                    label: "Site Creation",
                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                        color: "primary",
                                        checked: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                    sx: {
                                        fontFamily: "Mulish",
                                        color: "#001943"
                                    },
                                    label: "Camera Setup",
                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                        color: "primary",
                                        checked: step > 1
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                    sx: {
                                        fontFamily: "Mulish",
                                        color: "#001943"
                                    },
                                    label: "Schedule Setup",
                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                        color: "primary",
                                        checked: step > 2
                                    })
                                })
                            ]
                        })
                    }),
                    step === 1 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-[346px] right-24",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            disabled: false,
                            text: "Discover Cameras",
                            onClick: ()=>{
                                navigate(`/sites/${localStorage.siteId}/onvifdiscovery`);
                            }
                        })
                    }),
                    step === 2 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-[411px] right-24",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                            color: "primary",
                            onClick: ()=>{
                                navigate("/sites/addschedule");
                                localStorage.setItem("cameraNumber", "1");
                            },
                            children: "+ Add Schedule"
                        })
                    })
                ]
            })
        })
    });
    const onboardingScreen = isOnvifWireguard ? onvifOnboardingScreen : /*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $b9p11.default), {
                theme: $e4a2260e96905f88$var$theme,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-[142px] right-44",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $2CHqP.default), {
                            color: "primary",
                            variant: "determinate",
                            value: percentage,
                            sx: {
                                width: 275
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-32 right-32",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                            variant: "body1",
                            children: [
                                percentage,
                                "%"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-[195px] right-[150px] font-mulish text-actuate-blue",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            children: " Please complete the following information. "
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-[220px] right-[190px] font-mulish text-actuate-blue",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            children: " Otherwise the site won't run."
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-[275px] right-[350px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                            sx: {
                                display: "flex",
                                flexDirection: "column",
                                ml: 3
                            },
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                    sx: {
                                        fontFamily: "Mulish",
                                        color: "#001943"
                                    },
                                    label: "Site Creation",
                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                        color: "primary",
                                        checked: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                    sx: {
                                        fontFamily: "Mulish",
                                        color: "#001943"
                                    },
                                    label: "Camera Setup",
                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                        color: "primary",
                                        checked: step > 1
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                localStorage.healthcheckOnly === "false" && localStorage.healthMonitoringOnly === "false" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                    label: "Schedule Setup",
                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                        color: "primary",
                                        checked: step > 2
                                    })
                                }),
                                validCameraCheckIntegration && localStorage.healthMonitoringOnly === "true" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                    label: "Check Cameras",
                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                        color: "primary",
                                        checked: false
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                validCameraCheckIntegration && localStorage.healthMonitoringOnly === "false" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                    label: "Check Cameras",
                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                        color: "primary",
                                        checked: false
                                    })
                                })
                            ]
                        })
                    }),
                    step === 1 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-[346px] right-24",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                            color: "primary",
                            onClick: ()=>{
                                localStorage.removeItem("addAdditionalCamera");
                                localStorage.setItem("clickedFromSiteAboutPage", "false");
                                if (localStorage.autoAdd === "false") {
                                    localStorage.setItem("firstCameraAdded", "true");
                                    localStorage.setItem("copyValues", "true");
                                    navigate("/sites/addcamera");
                                    localStorage.setItem("cameraNumber", "1");
                                } else {
                                    setActiveOnboardingScreen(camerasLoadingScreen);
                                    (0, $8b891866c4a0a1da$export$11989d36ca85991f)(localStorage.siteId, setVisibleScreen, navigate);
                                }
                            },
                            children: "+ Add Camera"
                        })
                    }),
                    localStorage.healthcheckOnly === "false" && localStorage.healthMonitoringOnly === "false" && step < 3 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-[411px] right-24",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                            color: "primary",
                            disabled: step !== 2,
                            onClick: ()=>{
                                navigate("/sites/addschedule");
                                localStorage.setItem("cameraNumber", "1");
                            },
                            children: "+ Add Schedule"
                        })
                    }),
                    validCameraCheckIntegration && localStorage.healthMonitoringOnly === "true" && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-[411px] right-24",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                            color: "primary",
                            disabled: step !== 2,
                            onClick: ()=>{
                                localStorage.setItem("healthMonitoringOnly", "false");
                                localStorage.setItem("cameraCheckAlertOpen", "true");
                                localStorage.setItem("clickedId", localStorage.siteId);
                                (0, $3d5e2464ea939321$export$702c539eae400f89)(navigate);
                                localStorage.setItem("navigatedFromSitesAboutPage", "true");
                                localStorage.setItem("level0Click", "true");
                            },
                            children: "TEST CAMERAS"
                        })
                    }),
                    validCameraCheckIntegration && localStorage.healthMonitoringOnly === "false" && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: localStorage.healthcheckOnly === "false" ? "absolute top-[474px] right-24" : "absolute top-[411px] right-24",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                            color: "primary",
                            disabled: step !== 3,
                            onClick: ()=>{
                                localStorage.setItem("cameraCheckAlertOpen", "true");
                                localStorage.setItem("clickedId", localStorage.siteId);
                                (0, $3d5e2464ea939321$export$702c539eae400f89)(navigate);
                                localStorage.setItem("navigatedFromSitesAboutPage", "true");
                                localStorage.setItem("level0Click", "true");
                            },
                            children: "TEST CAMERAS"
                        })
                    })
                ]
            })
        })
    });
    const camerasLoadingScreen = /*#__PURE__*/ (0, $k4ank.jsx)((0, $f05a511d40a0fd8d$export$3c049d782df88a0e), {
        styling: "absolute first-line:font-black font-mulish text-[20px] right-[150px] text-center text-[#283E6D] top-80",
        text: /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
            children: [
                "Fetching cameras.",
                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                (0, $3mOKt.integrationsMatcher)(localStorage.integrationType, "Id") === "hikcentral" ? `This might take a few seconds.` : `This might take a few minutes.`
            ]
        })
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: activeOnboardingScreen
    });
};



var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $cFPmV = parcelRequire("cFPmV");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $4792e48e25138c87$export$5dfd8c032f3a43fc = (setCameraCheckResultDownloadURL, siteId, setCameraCheckFinsihedAlertOpen, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $4792e48e25138c87$export$5dfd8c032f3a43fc(setCameraCheckResultDownloadURL, siteId, setCameraCheckFinsihedAlertOpen, navigate);
    };
    AxiosUI.get(`proactive_alerting/${siteId}/download/`).then((response)=>{
        setCameraCheckResultDownloadURL(response.data.url);
        setCameraCheckFinsihedAlertOpen(true);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setTimeout(()=>{
                $4792e48e25138c87$export$5dfd8c032f3a43fc(setCameraCheckResultDownloadURL, siteId, setCameraCheckFinsihedAlertOpen, navigate);
            }, 2000);
        });
    });
};


const $37903a6140fe6ab4$export$82756491d6fa579 = (setCameraCheckFinsihedAlertOpen, setGoodCameras, setConnectivityCameras, setLowResolutionCameras, siteId, setCameraCheckResultDownloadURL, navigate)=>{
    const theme = (0, $cFPmV.default)({
        palette: {
            primary: {
                main: "#FF8400"
            }
        }
    });
    const AxiosUI = (0, $195EM.createApi)(``);
    const checkProgress = (siteId)=>{
        AxiosUI.get(`proactive_alerting/${siteId}/check_progress/`).then((response)=>{
            const data = response.data;
            if (data.percent_completed !== 100 && !data.connectivity_reason && data.total_cameras !== 0) setTimeout(()=>{
                checkProgress(siteId);
            }, 2000);
            else if (data.total_cameras !== 0) {
                const totalCamerasLength = Number(data.total_cameras);
                AxiosUI.get(`camera/site/?customer__id=${siteId}`).then((response)=>{
                    const cameras = response.data.results;
                    const cameraNames = new Map();
                    cameras.forEach((object)=>{
                        cameraNames.set(object.id, object.camera_name);
                    });
                    AxiosUI.get(`proactive_alerting/${siteId}/check_cameras/`).then((response)=>{
                        const goodCameras = [];
                        const connectivityCameras = [];
                        const lowResolutionCameras = [];
                        const cameraResults = response.data;
                        cameraResults.forEach((object)=>{
                            if (object.section === "connectivity") object.camera_list.forEach((object)=>{
                                connectivityCameras.push(cameraNames.get(object.camera));
                            });
                            if (object.section === "good") object.camera_list.forEach((object)=>{
                                goodCameras.push(cameraNames.get(object.camera));
                            });
                            if (object.section === "suboptimal_settings") object.camera_list.forEach((object)=>{
                                lowResolutionCameras.push({
                                    cameraName: cameraNames.get(object.camera),
                                    detail: object.detail
                                });
                            });
                        });
                        if (goodCameras.length + connectivityCameras.length + lowResolutionCameras.length !== totalCamerasLength) setTimeout(()=>{
                            checkProgress(siteId);
                        }, 2000);
                        else {
                            setGoodCameras(goodCameras);
                            setConnectivityCameras(connectivityCameras);
                            setLowResolutionCameras(lowResolutionCameras);
                            (0, $4792e48e25138c87$export$5dfd8c032f3a43fc)(setCameraCheckResultDownloadURL, siteId, setCameraCheckFinsihedAlertOpen, navigate);
                        }
                    });
                });
            }
        });
    };
    AxiosUI.post(`/customer/${siteId}/action/refresh_preview/`).then(()=>{
        checkProgress(siteId);
    });
};


const $256ec1bd69fb2a7f$export$c29dca6f07559532 = async (values, setVisibleScreen, responseObject, setCameraCheckFinsihedAlertOpen, setGoodCameras, setConnectivityCameras, setLowResolutionCameras, setCameraCheckResultDownloadURL, navigate)=>{
    let onboardingFail = false;
    const navigateToAboutPage = ()=>{
        localStorage.removeItem("addAdditionalCamera");
        localStorage.removeItem("clickedFromSiteAboutPage");
        (0, $815yO.markSiteUnsynced)();
        navigate(`/sites/aboutsite/${localStorage.siteId}`);
    };
    const retryFunction = ()=>{
        $256ec1bd69fb2a7f$export$c29dca6f07559532(values, setVisibleScreen, responseObject, setCameraCheckFinsihedAlertOpen, setGoodCameras, setConnectivityCameras, setLowResolutionCameras, setCameraCheckResultDownloadURL, navigate);
    };
    setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $f05a511d40a0fd8d$export$3c049d782df88a0e), {
        styling: "absolute first-line:font-black font-mulish text-[20px] right-[150px] text-center text-[#283E6D] top-80",
        text: /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
            children: [
                "Camera Add in process.",
                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                "This might take a few seconds."
            ]
        })
    }));
    const AxiosUI = (0, $195EM.createApi)(`camera/onboarding/`);
    const ActuateUI = (0, $195EM.createApi)(``);
    await AxiosUI.post("", (0, $7594ecf03fc2d0d0$export$3bad86e60f9f9c4e)(values, responseObject?.submit_object, responseObject?.forms)).then((response)=>{
        onboardingFail = false;
        localStorage.setItem("cameraId", response.data.id);
        localStorage.removeItem("addCameraError");
        localStorage.removeItem("cameraNamingError");
        localStorage.removeItem("copyValues");
        localStorage.setItem("immixAlertsSite", "false");
        localStorage.setItem("diceAlertsSite", "false");
        localStorage.setItem("sentinelAlertsSite", "false");
        localStorage.setItem("sureviewAlertsSite", "false");
        localStorage.setItem("immixAlertPostObject", JSON.stringify({
            id: -1,
            immix_server: "",
            immix_port: ""
        }));
        localStorage.setItem("diceAlertPostObject", JSON.stringify({
            id: -1,
            dice_server: "",
            dice_port: ""
        }));
        setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $f05a511d40a0fd8d$export$3c049d782df88a0e), {
            styling: "absolute first-line:font-black font-mulish text-[20px] right-[190px] text-center text-[#283E6D] top-80",
            text: "Camera Add successful!"
        }));
        setTimeout(()=>{
            if (localStorage.addAdditionalCamera === "true" || localStorage.clickedFromSiteAboutPage === "true") {
                if ((0, $1444c94c32ef2738$export$79b714ae571551b5)()) {
                    localStorage.setItem("cameraCheckAlertOpen", "true");
                    localStorage.setItem("clickedId", localStorage.siteId);
                    localStorage.setItem("navigatedFromSitesAboutPage", "true");
                    localStorage.setItem("level0Click", "true");
                    localStorage.setItem("cameraChecksiteId", localStorage.siteId);
                    (0, $37903a6140fe6ab4$export$82756491d6fa579)(setCameraCheckFinsihedAlertOpen, setGoodCameras, setConnectivityCameras, setLowResolutionCameras, localStorage.siteId, setCameraCheckResultDownloadURL, navigate);
                }
                navigateToAboutPage();
            } else if (localStorage.healthcheckOnly === "true") {
                // setVisibleScreen(<ProgressFinishedScreen />);
                navigate(`/sites/aboutsite/${localStorage.siteId}`);
                localStorage.setItem("healthcheckOnly", "false");
            } else if (localStorage.healthMonitoringOnly === "true") {
                localStorage.setItem("healthcheckOnly", "true");
                navigate(`/sites/cameracheck`);
            } else setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $e4a2260e96905f88$export$770d5a29da7608e0), {
                percentage: (0, $1444c94c32ef2738$export$79b714ae571551b5)() ? localStorage.healthMonitoringOnly === "true" ? 66 : 50 : 66,
                step: 2,
                setVisibleScreen: setVisibleScreen
            }));
        }, 2000);
    }, (reason)=>{
        onboardingFail = true;
        if (reason.request.response.includes("Please select a different camera name")) {
            localStorage.setItem("cameraNamingError", "true");
            setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $f51e285c0ff6c076$export$ffee78e2cdb3d23f), {
                setVisibleScreen: setVisibleScreen,
                responseObject: responseObject,
                setCameraCheckFinsihedAlertOpen: setCameraCheckFinsihedAlertOpen,
                setGoodCameras: setGoodCameras,
                setConnectivityCameras: setConnectivityCameras,
                setLowResolutionCameras: setLowResolutionCameras,
                setCameraCheckResultDownloadURL: setCameraCheckResultDownloadURL
            }));
        } else (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Error adding camera, please try again.");
            setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $f51e285c0ff6c076$export$ffee78e2cdb3d23f), {
                setVisibleScreen: setVisibleScreen,
                responseObject: responseObject,
                setCameraCheckFinsihedAlertOpen: setCameraCheckFinsihedAlertOpen,
                setGoodCameras: setGoodCameras,
                setConnectivityCameras: setConnectivityCameras,
                setLowResolutionCameras: setLowResolutionCameras,
                setCameraCheckResultDownloadURL: setCameraCheckResultDownloadURL
            }));
        });
    });
    // Adding a camera no longer auto-syncs. Mark the site as having unsynced
    // changes; the operator syncs explicitly (the About-page Sync control shows
    // the unsynced state on arrival).
    if (!onboardingFail) (0, $815yO.markSiteUnsynced)();
    !onboardingFail && await ActuateUI.get(`camera/site/?customer__id=${localStorage.siteId}`).then((response)=>{
        localStorage.setItem("siteCameras", JSON.stringify(response.data));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
    });
};


const $f51e285c0ff6c076$export$ffee78e2cdb3d23f = ({ setVisibleScreen: setVisibleScreen, responseObject: responseObject, setCameraCheckFinsihedAlertOpen: setCameraCheckFinsihedAlertOpen, setGoodCameras: setGoodCameras, setConnectivityCameras: setConnectivityCameras, setLowResolutionCameras: setLowResolutionCameras, setCameraCheckResultDownloadURL: setCameraCheckResultDownloadURL })=>{
    const [addCameraError, setAddCameraError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(localStorage.addCameraError);
    const [choicesChanger, setChoicesChanger] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [cameraNamingError, setCameraNamingError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(localStorage.cameraNamingError);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            children: [
                addCameraError && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "absolute w-[600px] h-[50px]",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                        severity: "error",
                        onClose: ()=>{
                            setAddCameraError(false);
                            localStorage.removeItem("addCameraError");
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "font-mulish font-bold text-[16px]",
                            children: "Problem adding Camera. Please try again."
                        })
                    })
                }),
                cameraNamingError && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "absolute w-[600px] h-[50px]",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                        severity: "error",
                        onClose: ()=>{
                            setCameraNamingError(false);
                            localStorage.removeItem("cameraNamingError");
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "font-mulish font-bold text-[15px]",
                            children: "Camera name already exists. Select a different name."
                        })
                    })
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "font-mulish absolute top-[80px] text-[#283E6D] right-[160px] text-[21px]",
                    children: "Please complete the camera's information"
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                    className: "font-mulish absolute top-[130px] font-bold text-[#283E6D] right-[490px] text-[16px]",
                    children: [
                        "Camera ",
                        localStorage.cameraNumber
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "absolute right-[215px] top-[180px]",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ede6db9a8f6145a5$export$adee19d4c733bc3e), {
                        handleSubmitData: (0, $256ec1bd69fb2a7f$export$c29dca6f07559532),
                        response: responseObject,
                        setVisibleScreen: setVisibleScreen,
                        responseObject: responseObject,
                        choicesChanger: choicesChanger,
                        setChoicesChanger: setChoicesChanger,
                        setHealthCheckSelected: ()=>{},
                        healthCheckSelected: false,
                        setActiveWizardContainer: ()=>{},
                        handleSubmitSite: ()=>{},
                        setCameraCheckFinsihedAlertOpen: setCameraCheckFinsihedAlertOpen,
                        setGoodCameras: setGoodCameras,
                        setConnectivityCameras: setConnectivityCameras,
                        setLowResolutionCameras: setLowResolutionCameras,
                        setCameraCheckResultDownloadURL: setCameraCheckResultDownloadURL
                    })
                })
            ]
        })
    });
};



var $TzEEg = parcelRequire("TzEEg");

var $3Zv1D = parcelRequire("3Zv1D");
const $4ef7a3b5b13d6f48$export$d7a7978e44950aff = async (values, setVisibleScreen, responseObject, setCameraCheckFinsihedAlertOpen, setGoodCameras, setConnectivityCameras, setLowResolutionCameras, setCameraCheckResultDownloadURL, navigate)=>{
    const retryFunction = ()=>{
        $4ef7a3b5b13d6f48$export$d7a7978e44950aff(values, setVisibleScreen, responseObject, setCameraCheckFinsihedAlertOpen, setGoodCameras, setConnectivityCameras, setLowResolutionCameras, setCameraCheckResultDownloadURL, navigate);
    };
    setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $f05a511d40a0fd8d$export$3c049d782df88a0e), {
        styling: "absolute first-line:font-black font-mulish text-[20px] right-[150px] text-center text-[#283E6D] top-80",
        text: /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
            children: [
                "We're adding a new Camera.",
                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                "This might take a few seconds."
            ]
        })
    }));
    const AxiosUI = (0, $195EM.createApi)(`camera/onboarding/`);
    const ActuateUI = (0, $195EM.createApi)(``);
    let cameraObjectSubmitFail = false;
    await AxiosUI.post("", (0, $7594ecf03fc2d0d0$export$3bad86e60f9f9c4e)(values, responseObject?.submit_object, responseObject?.forms)).then((response)=>{
        localStorage.setItem("copiedValues", JSON.stringify(values));
        localStorage.setItem("copyValues", "true");
        cameraObjectSubmitFail = false;
        localStorage.setItem("cameraId", response.data.id);
        localStorage.removeItem("addCameraError");
        localStorage.removeItem("cameraNamingError");
        localStorage.setItem("firstCameraAdded", "false");
        (0, $TzEEg.syncSite)(localStorage.siteId, navigate);
        setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $f05a511d40a0fd8d$export$3c049d782df88a0e), {
            styling: "absolute first-line:font-black font-mulish text-[20px] right-[170px] text-center text-[#283E6D] top-80",
            text: "Camera Added successfully!"
        }));
        setTimeout(()=>{
            setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $f51e285c0ff6c076$export$ffee78e2cdb3d23f), {
                setVisibleScreen: setVisibleScreen,
                responseObject: responseObject,
                setCameraCheckFinsihedAlertOpen: setCameraCheckFinsihedAlertOpen,
                setGoodCameras: setGoodCameras,
                setConnectivityCameras: setConnectivityCameras,
                setLowResolutionCameras: setLowResolutionCameras,
                setCameraCheckResultDownloadURL: setCameraCheckResultDownloadURL
            }));
        }, 2000);
    }, (reason)=>{
        cameraObjectSubmitFail = true;
        if (reason.request.response.includes("Please select a different camera name")) {
            localStorage.setItem("cameraNamingError", "true");
            localStorage.setItem("cameraNumber", `${localStorage.cameraNumber - 1}`);
            setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $f51e285c0ff6c076$export$ffee78e2cdb3d23f), {
                setVisibleScreen: setVisibleScreen,
                responseObject: responseObject,
                setCameraCheckFinsihedAlertOpen: setCameraCheckFinsihedAlertOpen,
                setGoodCameras: setGoodCameras,
                setConnectivityCameras: setConnectivityCameras,
                setLowResolutionCameras: setLowResolutionCameras,
                setCameraCheckResultDownloadURL: setCameraCheckResultDownloadURL
            }));
        } else (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            localStorage.setItem("addCameraError", "true");
            localStorage.setItem("cameraNumber", `${localStorage.cameraNumber - 1}`);
            setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $f51e285c0ff6c076$export$ffee78e2cdb3d23f), {
                setVisibleScreen: setVisibleScreen,
                responseObject: responseObject,
                setCameraCheckFinsihedAlertOpen: setCameraCheckFinsihedAlertOpen,
                setGoodCameras: setGoodCameras,
                setConnectivityCameras: setConnectivityCameras,
                setLowResolutionCameras: setLowResolutionCameras,
                setCameraCheckResultDownloadURL: setCameraCheckResultDownloadURL
            }));
        });
    });
    // Adding a camera no longer auto-syncs. Mark the site as having unsynced
    // changes; the operator syncs explicitly (the About-page Sync control shows
    // the unsynced state on arrival).
    if (!cameraObjectSubmitFail) (0, $815yO.markSiteUnsynced)();
    !cameraObjectSubmitFail && await ActuateUI.get(`camera/site/?customer__id=${localStorage.siteId}`).then((response)=>{
        localStorage.setItem("siteCameras", JSON.stringify(response.data));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
    });
};


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $01e4e7dcefcae2c1$var$HandSubmitAndAddAnotherCameraButton = ({ isLastStep: isLastStep, setVisibleScreen: setVisibleScreen, responseObject: responseObject, buttonDisabled: buttonDisabled, setCameraCheckFinsihedAlertOpen: setCameraCheckFinsihedAlertOpen, setGoodCameras: setGoodCameras, setConnectivityCameras: setConnectivityCameras, setLowResolutionCameras: setLowResolutionCameras, setCameraCheckResultDownloadURL: setCameraCheckResultDownloadURL })=>{
    const formik = (0, $g2LMr.useFormikContext)();
    const navigate = (0, $3T949.useNavigate)();
    const increaseCameraNumber = (passedNumber)=>{
        return passedNumber + 1;
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "absolute right-[-40px] z-10",
        children: !isLastStep || !location.href.includes("addcamera") ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
            onClick: ()=>{
                localStorage.setItem("cameraNumber", `${increaseCameraNumber(Number(localStorage.cameraNumber))}`);
                // localStorage.setItem("values", JSON.stringify(formik.values));
                (0, $4ef7a3b5b13d6f48$export$d7a7978e44950aff)(formik.values, setVisibleScreen, responseObject, setCameraCheckFinsihedAlertOpen, setGoodCameras, setConnectivityCameras, setLowResolutionCameras, setCameraCheckResultDownloadURL, navigate);
            },
            text: "+ Submit and Add Another Camera",
            disabled: buttonDisabled
        })
    });
};
var $01e4e7dcefcae2c1$export$2e2bcd8739ae039 = $01e4e7dcefcae2c1$var$HandSubmitAndAddAnotherCameraButton;



var $3baw3 = parcelRequire("3baw3");

var $kbChx = parcelRequire("kbChx");
const $f0089d26a2ff4383$var$Wizard = ({ children: children, initialValues: initialValues, onSubmit: onSubmit, setVisibleScreen: setVisibleScreen, responseObject: responseObject, errorState: errorState, choicesChanger: choicesChanger, stepNumber: stepNumber, setStepNumber: setStepNumber, setCameraCheckFinsihedAlertOpen: setCameraCheckFinsihedAlertOpen, setGoodCameras: setGoodCameras, setConnectivityCameras: setConnectivityCameras, setLowResolutionCameras: setLowResolutionCameras, setCameraCheckResultDownloadURL: setCameraCheckResultDownloadURL, nextOrSubmitButtonDisabled: nextOrSubmitButtonDisabled })=>{
    const steps = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Children.toArray(children);
    const [snapshot, setSnapshot] = (0, $8T3gX.useState)(initialValues);
    const [buttonDisabled, setButtonDisabled] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const step = steps[stepNumber];
    const totalSteps = steps.length;
    const isLastStep = stepNumber === totalSteps - 1;
    const next = (values)=>{
        setSnapshot(values);
        setStepNumber(Math.min(stepNumber + 1, totalSteps - 1));
    };
    const previous = (values)=>{
        setSnapshot(values);
        setStepNumber(Math.max(stepNumber - 1, 0));
    };
    const handleSubmit = async (values, bag)=>{
        if (step.props.onSubmit) await step.props.onSubmit(values, bag);
        if (isLastStep) return onSubmit(values, bag);
        else {
            bag.setTouched({});
            next(values);
        }
    };
    const softguardAlertsBoolean = Object.keys(initialValues).includes("user_ext");
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $g2LMr.Formik), {
        initialValues: snapshot,
        onSubmit: handleSubmit,
        validationSchema: step.props.validationSchema,
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $g2LMr.Form), {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "font-mulish text-[#283E6D]",
                    children: `Step ${stepNumber + 1} of ${totalSteps}`
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "font-mulish text-[#283E6D] pt-[10px]",
                    children: softguardAlertsBoolean && stepNumber === 2 && `Softguard Alert Info`
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                step,
                location.href.includes("addcamera") && localStorage.integrationType === "1" && localStorage.firstCameraAdded === "true" && stepNumber === 1 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                    sx: {
                        fontFamily: "Mulish",
                        color: "#001943"
                    },
                    label: "Copy Values",
                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                        color: "primary",
                        defaultChecked: true,
                        onChange: (event, result)=>{
                            if (result === true) localStorage.setItem("copyValues", "true");
                            else localStorage.setItem("copyValues", "false");
                        }
                    })
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {}),
                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "relative flex h-[40px] mb-10",
                    "data-testid": "wizard-footer",
                    children: [
                        stepNumber > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $12bb6167a2fb0fea$export$2e2bcd8739ae039), {
                            previous: previous
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $275d2bf10a630861$export$2e2bcd8739ae039), {
                            next: next,
                            isLastStep: isLastStep,
                            errorState: errorState,
                            choicesChanger: choicesChanger,
                            buttonDisabled: buttonDisabled,
                            setButtonDisabled: setButtonDisabled,
                            nextOrSubmitButtonDisabled: nextOrSubmitButtonDisabled
                        }),
                        location.href.includes("addcamera") && /*#__PURE__*/ (0, $k4ank.jsx)((0, $01e4e7dcefcae2c1$export$2e2bcd8739ae039), {
                            isLastStep: isLastStep,
                            setVisibleScreen: setVisibleScreen,
                            responseObject: responseObject,
                            buttonDisabled: buttonDisabled,
                            setCameraCheckFinsihedAlertOpen: setCameraCheckFinsihedAlertOpen,
                            setGoodCameras: setGoodCameras,
                            setConnectivityCameras: setConnectivityCameras,
                            setLowResolutionCameras: setLowResolutionCameras,
                            setCameraCheckResultDownloadURL: setCameraCheckResultDownloadURL
                        })
                    ]
                })
            ]
        })
    });
};
var $f0089d26a2ff4383$export$2e2bcd8739ae039 = $f0089d26a2ff4383$var$Wizard;


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $ede6db9a8f6145a5$export$adee19d4c733bc3e = ({ handleSubmitData: handleSubmitData, response: response, setVisibleScreen: setVisibleScreen, responseObject: responseObject, choicesChanger: choicesChanger, setChoicesChanger: setChoicesChanger, setHealthCheckSelected: setHealthCheckSelected, healthCheckSelected: healthCheckSelected, setActiveWizardContainer: setActiveWizardContainer, handleSubmitSite: handleSubmitSite, setCameraCheckFinsihedAlertOpen: setCameraCheckFinsihedAlertOpen, setGoodCameras: setGoodCameras, setConnectivityCameras: setConnectivityCameras, setLowResolutionCameras: setLowResolutionCameras, setCameraCheckResultDownloadURL: setCameraCheckResultDownloadURL })=>{
    const navigate = (0, $3T949.useNavigate)();
    const [errorState, setErrorState] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [stepNumber, setStepNumber] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [nextOrSubmitButtonDisabled, setNextOrSubmitButtonDisabled] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const copyValues = typeof localStorage !== "undefined" ? localStorage.copyValues : undefined;
    const hasCopiedValues = typeof localStorage !== "undefined" && !!localStorage.copiedValues;
    const useMerged = copyValues === "true" && hasCopiedValues;
    let initialValues = response["initial_data"];
    if (useMerged && typeof localStorage.copiedValues === "string") try {
        initialValues = {
            ...response["initial_data"],
            ...JSON.parse(localStorage.copiedValues)
        };
    } catch  {
    // keep response["initial_data"] if parse fails
    }
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $f0089d26a2ff4383$export$2e2bcd8739ae039), {
        initialValues: initialValues,
        onSubmit: (values)=>{
            localStorage.setItem("values", JSON.stringify(values));
            const isAddCameraFlow = location.href.toLowerCase().includes("addcamera");
            if (isAddCameraFlow) handleSubmitData(values, setVisibleScreen, responseObject, setCameraCheckFinsihedAlertOpen, setGoodCameras, setConnectivityCameras, setLowResolutionCameras, setCameraCheckResultDownloadURL, navigate);
            else handleSubmitData(values, setVisibleScreen, responseObject, navigate, response);
        },
        setVisibleScreen: setVisibleScreen,
        responseObject: responseObject,
        errorState: errorState,
        choicesChanger: choicesChanger,
        stepNumber: stepNumber,
        setStepNumber: setStepNumber,
        setCameraCheckFinsihedAlertOpen: setCameraCheckFinsihedAlertOpen,
        setGoodCameras: setGoodCameras,
        setConnectivityCameras: setConnectivityCameras,
        setLowResolutionCameras: setLowResolutionCameras,
        setCameraCheckResultDownloadURL: setCameraCheckResultDownloadURL,
        nextOrSubmitButtonDisabled: nextOrSubmitButtonDisabled,
        children: response["forms"].map((formConfig)=>{
            const validationSchema = $1b9e4df3da2fe282$export$185802fd694ee1f5({
            });
            return(// eslint-disable-next-line react/jsx-key
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $4f1c12eb0c898328$export$2e2bcd8739ae039), {
                formConfig: formConfig,
                validationSchema: validationSchema,
                setErrorState: setErrorState,
                choicesChanger: choicesChanger,
                setChoicesChanger: setChoicesChanger,
                stepNumber: stepNumber,
                setHealthCheckSelected: setHealthCheckSelected,
                healthCheckSelected: healthCheckSelected,
                setActiveWizardContainer: setActiveWizardContainer,
                handleSubmitSite: handleSubmitSite,
                responseObject: response,
                setVisibleScreen: setVisibleScreen,
                setNextOrSubmitButtonDisabled: setNextOrSubmitButtonDisabled
            }));
        })
    });
};



var $3QMQN = parcelRequire("3QMQN");

var $4wo2Y = parcelRequire("4wo2Y");
const $b8e45df6cc7312fb$export$6b835921ba7e0f4b = ({ handleSubmitSite: handleSubmitSite, responseObject: responseObject, setVisibleScreen: setVisibleScreen })=>{
    const [addSiteError, setAddSiteError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(localStorage.addSiteError);
    const [choicesChanger, setChoicesChanger] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [healthCheckSelected, setHealthCheckSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [activeWizardContainer, setActiveWizardContainer] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setActiveWizardContainer(/*#__PURE__*/ (0, $k4ank.jsx)((0, $ede6db9a8f6145a5$export$adee19d4c733bc3e), {
            handleSubmitData: handleSubmitSite,
            response: responseObject,
            setVisibleScreen: setVisibleScreen,
            responseObject: false,
            choicesChanger: choicesChanger,
            setChoicesChanger: setChoicesChanger,
            setHealthCheckSelected: setHealthCheckSelected,
            healthCheckSelected: healthCheckSelected,
            setActiveWizardContainer: setActiveWizardContainer,
            handleSubmitSite: handleSubmitSite,
            setCameraCheckFinsihedAlertOpen: ()=>{},
            setGoodCameras: ()=>{},
            setConnectivityCameras: ()=>{},
            setLowResolutionCameras: ()=>{},
            setCameraCheckResultDownloadURL: ()=>{}
        }));
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            children: [
                addSiteError && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "absolute w-[600px] h-[50px]",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                        severity: "error",
                        onClose: ()=>{
                            setAddSiteError(false);
                            localStorage.removeItem("addSiteError");
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "font-mulish font-bold text-[16px]",
                            children: "Problem adding Site. Please try again."
                        })
                    })
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "absolute top-20 right-[15px]",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "flex justify-end",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $635b38046a5de67e$export$2cf5ff4e03e29cc1), {
                            activeStep: 1
                        })
                    })
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "font-mulish absolute top-[130px] text-[#283E6D] right-[150px] text-[18px]",
                    children: "Please complete the following for your Integration:"
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "absolute right-[215px] top-[180px]",
                    children: activeWizardContainer
                })
            ]
        })
    });
};



var $3Zv1D = parcelRequire("3Zv1D");
const $b5135a070d60b6a0$export$1c29bc844a08fcce = async (setVisibleScreen, handleSubmitSite, navigate, setIntegrationSubmitError)=>{
    const integrationsTypes = JSON.parse(localStorage.integrationTypes);
    const autoAddNums = [];
    integrationsTypes.forEach((object)=>{
        if (object.is_auto_add) autoAddNums.push(object.id);
    });
    const retryFunction = ()=>{
        $b5135a070d60b6a0$export$1c29bc844a08fcce(setVisibleScreen, handleSubmitSite, navigate, setIntegrationSubmitError);
    };
    const AxiosUI = (0, $195EM.createApi)(``);
    await AxiosUI.get(`integration_type/${localStorage.integrationType}/onboarding_forms/`).then((response)=>{
        const responseObject = {
            initial_data: response.data.initial_data,
            forms: response.data.forms
        };
        localStorage.setItem("responseObjectBackup", JSON.stringify(responseObject));
        localStorage.removeItem("integrationSubmitError");
        setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $b8e45df6cc7312fb$export$6b835921ba7e0f4b), {
            handleSubmitSite: handleSubmitSite,
            responseObject: responseObject,
            setVisibleScreen: setVisibleScreen
        }));
        if (autoAddNums.includes(Number(localStorage.integrationType))) localStorage.setItem("autoAdd", "true");
        else localStorage.setItem("autoAdd", "false");
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setIntegrationSubmitError(true);
        });
    });
};



var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");


var $195EM = parcelRequire("195EM");
const $ba1fbd5ec2ceaebf$export$56b33c7641763100 = (values)=>{
    const returnObject = values;
    const checkboxFields = [
        "ecs_nat_instance",
        "use_motion",
        "use_v5",
        "use_nx_proxy"
    ];
    checkboxFields.forEach((field)=>{
        if (returnObject[field] === "True") returnObject[field] = true;
        if (returnObject[field] === "False") returnObject[field] = false;
    });
    returnObject.integration = localStorage.integrationType;
    return returnObject;
};





var $TzEEg = parcelRequire("TzEEg");

var $bfBpo = parcelRequire("bfBpo");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8jTCz = parcelRequire("8jTCz");

var $eejVe = parcelRequire("eejVe");


var $4wo2Y = parcelRequire("4wo2Y");
const $3259993d86cdbbec$export$eb800053e14d4ae3 = ({ setVisibleScreen: setVisibleScreen })=>{
    const [postObject, setPostObject] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        id: -1,
        immix_server: "",
        immix_port: ""
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "font-mulish absolute top-[90px] w-[300px] font-bold text-[#283E6D] left-[25px] text-[16px]",
                    children: `Immix Alert Information`
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "pt-[140px] pl-[30px]",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                            value: postObject.immix_server,
                            id: "immix_server",
                            variant: "standard",
                            label: "Immix Server",
                            onChange: (event)=>{
                                setPostObject((previousState)=>{
                                    return {
                                        ...previousState,
                                        immix_server: event.target.value
                                    };
                                });
                            },
                            sx: {
                                width: "400px"
                            },
                            helperText: "What is the url for your immix server.",
                            type: "string"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                            value: postObject.immix_port,
                            id: "immix_port",
                            variant: "standard",
                            label: "Immix Port",
                            onChange: (event)=>{
                                setPostObject((previousState)=>{
                                    return {
                                        ...previousState,
                                        immix_port: event.target.value
                                    };
                                });
                            },
                            sx: {
                                width: "400px"
                            },
                            helperText: "What is the port for your immix server.",
                            type: "string"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "pt-10 pl-[420px]",
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        style: {
                            display: "flex"
                        },
                        children: [
                            "\xa0\xa0\xa0",
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    localStorage.setItem("immixAlertPostObject", JSON.stringify(postObject));
                                    setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $e4a2260e96905f88$export$770d5a29da7608e0), {
                                        percentage: (0, $1444c94c32ef2738$export$79b714ae571551b5)() ? localStorage.healthMonitoringOnly === "true" ? 33 : 25 : 33,
                                        step: 1,
                                        setVisibleScreen: setVisibleScreen
                                    }));
                                },
                                text: "Submit",
                                disabled: !postObject.immix_port || !postObject.immix_server
                            })
                        ]
                    })
                })
            ]
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8jTCz = parcelRequire("8jTCz");

var $eejVe = parcelRequire("eejVe");


var $4wo2Y = parcelRequire("4wo2Y");
const $224b8993a113ec7a$export$aff20cbd3ce2cb31 = ({ setVisibleScreen: setVisibleScreen })=>{
    const [postObject, setPostObject] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        id: -1,
        dice_server: "",
        dice_port: ""
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "font-mulish absolute top-[90px] w-[300px] font-bold text-[#283E6D] left-[25px] text-[16px]",
                    children: `Dice Alert Information`
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "pt-[140px] pl-[30px]",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                            value: postObject.dice_server,
                            id: "dice_server",
                            variant: "standard",
                            label: "Dice Server",
                            onChange: (event)=>{
                                setPostObject((previousState)=>{
                                    return {
                                        ...previousState,
                                        dice_server: event.target.value
                                    };
                                });
                            },
                            sx: {
                                width: "400px"
                            },
                            helperText: "What is the url for your dice server.",
                            type: "string"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                            value: postObject.dice_port,
                            id: "dice_port",
                            variant: "standard",
                            label: "Dice Port",
                            onChange: (event)=>{
                                setPostObject((previousState)=>{
                                    return {
                                        ...previousState,
                                        dice_port: event.target.value
                                    };
                                });
                            },
                            sx: {
                                width: "400px"
                            },
                            helperText: "What is the port for your dice server.",
                            type: "string"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "pt-10 pl-[420px]",
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        style: {
                            display: "flex"
                        },
                        children: [
                            "\xa0\xa0\xa0",
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    localStorage.setItem("diceAlertPostObject", JSON.stringify(postObject));
                                    setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $e4a2260e96905f88$export$770d5a29da7608e0), {
                                        percentage: (0, $1444c94c32ef2738$export$79b714ae571551b5)() ? localStorage.healthMonitoringOnly === "true" ? 33 : 25 : 33,
                                        step: 1,
                                        setVisibleScreen: setVisibleScreen
                                    }));
                                },
                                text: "Submit",
                                disabled: !postObject.dice_port || !postObject.dice_server
                            })
                        ]
                    })
                })
            ]
        })
    });
};



var $3Zv1D = parcelRequire("3Zv1D");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $4wo2Y = parcelRequire("4wo2Y");


var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

var $a65wX = parcelRequire("a65wX");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");


var $195EM = parcelRequire("195EM");


var $3Zv1D = parcelRequire("3Zv1D");


var $9vEj4 = parcelRequire("9vEj4");
const $7368966d267acfc3$export$6f011dcc208b73a5 = (webhooksInfo, setVisibleScreen, navigate, formValues)=>{
    setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $f05a511d40a0fd8d$export$3c049d782df88a0e), {
        styling: "absolute first-line:font-black font-mulish text-[20px] right-[150px] text-center text-[#283E6D] top-80",
        text: /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
            children: [
                "Submitting Webhooks info.",
                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                "This might take a few seconds."
            ]
        })
    }));
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $7368966d267acfc3$export$6f011dcc208b73a5(webhooksInfo, setVisibleScreen, navigate, formValues);
    };
    AxiosUI.post("webhook_customer/", {
        ...webhooksInfo,
        customer: Number(localStorage.siteId)
    }).then(()=>{
        AxiosUI.get(`customer/${Number(localStorage.siteId)}/camera_onboarding_forms/`).then((response)=>{
            // handleAddImmixToAddCameraForm(response.data);
            // handleAddDiceToAddCameraForm(response.data);
            localStorage.setItem("addCameraInfo", JSON.stringify(response.data));
            localStorage.setItem("selectedProducts", JSON.stringify(response.data.initial_data.products));
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $f05a511d40a0fd8d$export$3c049d782df88a0e), {
                    styling: "absolute first-line:font-black font-mulish text-[20px] right-[190px] text-center text-[#283E6D] top-80",
                    text: "Webhooks setup successful!"
                }));
                setTimeout(()=>{
                    setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $e4a2260e96905f88$export$770d5a29da7608e0), {
                        percentage: (0, $1444c94c32ef2738$export$79b714ae571551b5)() ? localStorage.healthMonitoringOnly === "true" ? 33 : 25 : 33,
                        step: 1,
                        setVisibleScreen: setVisibleScreen
                    }));
                }, 2000);
            });
        });
        setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $f05a511d40a0fd8d$export$3c049d782df88a0e), {
            styling: "absolute first-line:font-black font-mulish text-[20px] right-[190px] text-center text-[#283E6D] top-80",
            text: "Webhooks setup successful!"
        }));
        setTimeout(()=>{
            setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $e4a2260e96905f88$export$770d5a29da7608e0), {
                percentage: (0, $1444c94c32ef2738$export$79b714ae571551b5)() ? localStorage.healthMonitoringOnly === "true" ? 33 : 25 : 33,
                step: 1,
                setVisibleScreen: setVisibleScreen
            }));
        }, 2000);
    }, (reason)=>{
        // A 400 names the rejected fields (e.g. an auth_endpoint refused by the
        // SSRF guard, an auth_body that can't authenticate): put the form back
        // with the user's input and the messages inline on those fields.
        const fieldErrors = (0, $9vEj4.extractWebhookFieldErrors)(reason);
        if (Object.keys(fieldErrors).length > 0) {
            setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $faa29617becd29db$export$e238dc6c0409c0a6), {
                setVisibleScreen: setVisibleScreen,
                siteId: webhooksInfo.customer,
                initialValues: formValues,
                fieldErrors: fieldErrors
            }));
            return;
        }
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Error submitting Webhooks info. Please try again.");
            setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $faa29617becd29db$export$e238dc6c0409c0a6), {
                setVisibleScreen: setVisibleScreen,
                siteId: webhooksInfo.customer,
                initialValues: formValues
            }));
        });
    });
};



var $7etC6 = parcelRequire("7etC6");

var $9vEj4 = parcelRequire("9vEj4");

var $7l43O = parcelRequire("7l43O");
const $faa29617becd29db$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $faa29617becd29db$export$e238dc6c0409c0a6 = ({ setVisibleScreen: setVisibleScreen, siteId: siteId, initialValues: initialValues, fieldErrors: fieldErrors = {} })=>{
    const [webhooksInfo, setWebhooksInfo] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(initialValues ?? {
        customer: siteId,
        display_name: "",
        target_url: "",
        method: "POST",
        message_body: "",
        auth: (0, $9vEj4.EMPTY_WEBHOOK_AUTH_VALUES)
    });
    const navigate = (0, $3T949.useNavigate)();
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "absolute top-20 right-[15px]",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "flex justify-end",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $635b38046a5de67e$export$2cf5ff4e03e29cc1), {
                            activeStep: 1
                        })
                    })
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "font-mulish absolute top-[130px] text-[#283E6D] right-[130px] text-[18px]",
                    children: "Please complete the following Webhooks information:"
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "absolute right-[215px] top-[180px]",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $7etC6.SiteWebhookFormFields), {
                            values: webhooksInfo,
                            fieldErrors: fieldErrors,
                            onFieldChange: (field, value)=>{
                                setWebhooksInfo((previousState)=>({
                                        ...previousState,
                                        [field]: value
                                    }));
                            },
                            onAuthFieldChange: (field, value)=>{
                                setWebhooksInfo((previousState)=>({
                                        ...previousState,
                                        auth: {
                                            ...previousState.auth,
                                            [field]: value
                                        }
                                    }));
                            }
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "relative left-[400px] pt-[20px]",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                                theme: $faa29617becd29db$var$theme,
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                    className: "shadow-button bg-actuate-orange rounded font-mulish text-white text-base p-1.5",
                                    type: "submit",
                                    disabled: !webhooksInfo.display_name || !webhooksInfo.target_url || Boolean((0, $9vEj4.authBodyJsonError)(webhooksInfo.auth.auth_body)) || Boolean((0, $7l43O.jsonTextError)(webhooksInfo.message_body, "Message Body")),
                                    onClick: ()=>{
                                        const { auth: auth, ...rest } = webhooksInfo;
                                        (0, $7368966d267acfc3$export$6f011dcc208b73a5)({
                                            ...rest,
                                            ...(0, $9vEj4.buildWebhookAuthCreatePayload)(auth)
                                        }, setVisibleScreen, navigate, webhooksInfo);
                                    },
                                    children: "Submit"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8jTCz = parcelRequire("8jTCz");

var $9qNow = parcelRequire("9qNow");
var $eejVe = parcelRequire("eejVe");


var $4wo2Y = parcelRequire("4wo2Y");

var $kbChx = parcelRequire("kbChx");

var $3baw3 = parcelRequire("3baw3");
const $d87ed22067f82a90$export$fc1a56ff1879b6a5 = ({ setVisibleScreen: setVisibleScreen })=>{
    const [postObject, setPostObject] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        sentinel_server: "",
        sentinel_site_id: "",
        sentinel_device_address: "",
        draw_ignore_zones: true
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "font-mulish absolute top-[90px] w-[300px] font-bold text-[#283E6D] left-[25px] text-[16px]",
                    children: `Sentinel Alert Information`
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "pt-[140px] pl-[30px]",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                            value: postObject.sentinel_server,
                            id: "sentinel_server",
                            variant: "standard",
                            label: "Sentinel Server",
                            onChange: (event)=>{
                                setPostObject((previousState)=>{
                                    return {
                                        ...previousState,
                                        sentinel_server: event.target.value
                                    };
                                });
                            },
                            sx: {
                                width: "400px"
                            },
                            helperText: "What is the url for your Sentinel server.",
                            type: "string"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                            value: postObject.sentinel_site_id,
                            id: "sentinel_site_id",
                            variant: "standard",
                            label: "Sentinel site id",
                            onChange: (event)=>{
                                setPostObject((previousState)=>{
                                    return {
                                        ...previousState,
                                        sentinel_site_id: event.target.value
                                    };
                                });
                            },
                            sx: {
                                width: "400px"
                            },
                            type: "string"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                            value: postObject.sentinel_device_address,
                            id: "sentinel_device_address",
                            variant: "standard",
                            label: "Sentinel device address",
                            onChange: (event)=>{
                                setPostObject((previousState)=>{
                                    return {
                                        ...previousState,
                                        sentinel_device_address: event.target.value
                                    };
                                });
                            },
                            sx: {
                                width: "400px"
                            },
                            type: "string"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                    sx: {
                                        fontFamily: "Mulish",
                                        color: "#001943"
                                    },
                                    label: "Draw Ignore Zones",
                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                        color: "primary",
                                        checked: postObject.draw_ignore_zones,
                                        onChange: (event, checked)=>{
                                            setPostObject((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    draw_ignore_zones: checked
                                                };
                                            });
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                                    children: "If checked, draws ignore zones in the alert images."
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "pt-10 pl-[420px]",
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        style: {
                            display: "flex"
                        },
                        children: [
                            "\xa0\xa0\xa0",
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    localStorage.setItem("sentinelAlertPostObject", JSON.stringify(postObject));
                                    setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $e4a2260e96905f88$export$770d5a29da7608e0), {
                                        percentage: (0, $1444c94c32ef2738$export$79b714ae571551b5)() ? localStorage.healthMonitoringOnly === "true" ? 33 : 25 : 33,
                                        step: 1,
                                        setVisibleScreen: setVisibleScreen
                                    }));
                                },
                                text: "Submit",
                                disabled: false
                            })
                        ]
                    })
                })
            ]
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kbChx = parcelRequire("kbChx");

var $3baw3 = parcelRequire("3baw3");

var $8jTCz = parcelRequire("8jTCz");


var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8jTCz = parcelRequire("8jTCz");

var $60vL1 = parcelRequire("60vL1");
var $kUcVg = parcelRequire("kUcVg");
var $887xF = parcelRequire("887xF");
var $1TOOV = parcelRequire("1TOOV");
var $ce8iU = parcelRequire("ce8iU");
var $9qNow = parcelRequire("9qNow");
var $1SPe4 = parcelRequire("1SPe4");
var $eejVe = parcelRequire("eejVe");


var $4wo2Y = parcelRequire("4wo2Y");

var $kbChx = parcelRequire("kbChx");

var $3baw3 = parcelRequire("3baw3");


var $195EM = parcelRequire("195EM");
const $1396e2bdc93a1228$var$ExpandableHelperText = ({ text: text, contentTestId: contentTestId })=>{
    const [expanded, setExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
        className: "font-mulish text-[12px] text-[#6B7280]",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                "data-testid": contentTestId,
                style: {
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: expanded ? "unset" : 1,
                    overflow: "hidden"
                },
                children: text
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                type: "button",
                className: "font-mulish mt-1 p-0 text-[12px] text-[#283E6D] underline",
                onClick: ()=>setExpanded((prev)=>!prev),
                children: expanded ? "Show less" : "Read more"
            })
        ]
    });
};
const $1396e2bdc93a1228$export$f7abbf7cc2d226c1 = ({ setVisibleScreen: setVisibleScreen })=>{
    const [postObject, setPostObject] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        name: "",
        client_public_key: "",
        client_tunnel_ip: "",
        subnets: "",
        subnets_are_virtually_assigned: false
    });
    const [submitting, setSubmitting] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [isClientTunnelIpLoading, setIsClientTunnelIpLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [cameraCount, setCameraCount] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [cidrPrefixLength, setCidrPrefixLength] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("24");
    const [isSuggestingSubnet, setIsSuggestingSubnet] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [subnetSuggestionError, setSubnetSuggestionError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [showFailureDialog, setShowFailureDialog] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [failureErrorMessage, setFailureErrorMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const parseSubnetsInput = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback((subnetsInput)=>{
        const trimmed = subnetsInput.trim();
        if (!trimmed) return [];
        if (trimmed.startsWith("[") && trimmed.endsWith("]")) try {
            const parsed = JSON.parse(trimmed);
            if (Array.isArray(parsed)) return parsed.map((item)=>typeof item === "string" ? item.trim() : "").filter(Boolean);
        } catch (error) {
        // Fall through to comma-separated parsing.
        }
        return trimmed.split(",").map((value)=>value.trim().replace(/^\[/, "").replace(/\]$/, "").replace(/^['"]/, "").replace(/['"]$/, "")).filter(Boolean);
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        let isMounted = true;
        const fetchSuggestedClientTunnelIp = async ()=>{
            const AxiosUI = (0, $195EM.createApi)("");
            try {
                const response = await AxiosUI.get("wireguard_tunnel/suggest-next-client-ip/");
                const suggestedClientTunnelIp = response?.data?.client_tunnel_ip;
                if (!isMounted || !suggestedClientTunnelIp) return;
                setPostObject((prev)=>({
                        ...prev,
                        client_tunnel_ip: suggestedClientTunnelIp
                    }));
            } catch (error) {
            // If suggestion fetch fails, allow manual entry.
            } finally{
                if (isMounted) setIsClientTunnelIpLoading(false);
            }
        };
        fetchSuggestedClientTunnelIp();
        return ()=>{
            isMounted = false;
        };
    }, []);
    const goToOnboardingProgress = ()=>setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $e4a2260e96905f88$export$770d5a29da7608e0), {
            percentage: (0, $1444c94c32ef2738$export$79b714ae571551b5)() ? localStorage.healthMonitoringOnly === "true" ? 33 : 25 : 33,
            step: 1,
            setVisibleScreen: setVisibleScreen
        }));
    const handleSubmit = async ()=>{
        const wireguardServer = (0, $f3a38e087c86c35f$export$7003214a0e2ce77c).getState().selectedWireGuardServer ?? "";
        let selectedGroupId;
        try {
            const rawValues = localStorage.getItem("values");
            if (rawValues) {
                const parsedValues = JSON.parse(rawValues);
                const groupValue = parsedValues?.group;
                if (typeof groupValue === "string" && groupValue.trim() || typeof groupValue === "number") {
                    const parsedGroupId = Number(groupValue);
                    selectedGroupId = Number.isFinite(parsedGroupId) ? parsedGroupId : undefined;
                }
            }
        } catch (error) {
        // Keep submission flow working if localStorage values is malformed.
        }
        const subnetsArray = parseSubnetsInput(postObject.subnets);
        const payload = {
            name: postObject.name,
            wireguard_server: wireguardServer,
            group_id: selectedGroupId,
            client_public_key: postObject.client_public_key,
            client_tunnel_ip: postObject.client_tunnel_ip || undefined,
            subnets: subnetsArray,
            subnets_are_virtually_assigned: postObject.subnets_are_virtually_assigned
        };
        setSubmitting(true);
        const AxiosUI = (0, $195EM.createApi)("");
        try {
            await AxiosUI.post("wireguard_tunnel/", payload);
            goToOnboardingProgress();
        } catch (reason) {
            setSubmitting(false);
            const err = reason;
            const message = typeof err.response?.data === "object" && err.response?.data !== null ? err.response.data.error ?? err.response.data.detail : typeof err.response?.data === "string" ? err.response.data : null;
            setFailureErrorMessage(message ?? null);
            setShowFailureDialog(true);
            return;
        }
        setSubmitting(false);
    };
    const handleSuggestNextSubnet = async ()=>{
        const AxiosUI = (0, $195EM.createApi)("");
        setSubnetSuggestionError(null);
        setIsSuggestingSubnet(true);
        try {
            const trimmedCameraCount = cameraCount.trim();
            const trimmedPrefixLength = cidrPrefixLength.trim().replace("/", "");
            const queryParam = trimmedCameraCount ? `camera_count=${encodeURIComponent(trimmedCameraCount)}` : `prefix_length=${encodeURIComponent(trimmedPrefixLength || "24")}`;
            const response = await AxiosUI.get(`wireguard_tunnel/suggest-next-subnet/?${queryParam}`);
            const suggestedSubnet = response?.data?.subnet;
            if (!suggestedSubnet) {
                setSubnetSuggestionError("Unable to suggest a subnet right now.");
                return;
            }
            setPostObject((prev)=>({
                    ...prev,
                    subnets: `["${suggestedSubnet}"]`
                }));
        } catch (error) {
            setSubnetSuggestionError("Unable to suggest a subnet right now.");
        } finally{
            setIsSuggestingSubnet(false);
        }
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4wo2Y.default), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-mulish absolute top-[90px] w-[300px] font-bold text-[#283E6D] left-[25px] text-[16px]",
                        children: "WireGuard Configuration"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "pt-[140px] pl-[30px]",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                value: postObject.name,
                                id: "wireguard_name",
                                variant: "standard",
                                label: "Name",
                                required: true,
                                onChange: (event)=>{
                                    setPostObject((prev)=>({
                                            ...prev,
                                            name: event.target.value
                                        }));
                                },
                                sx: {
                                    width: "400px"
                                },
                                type: "string"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                            /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                value: postObject.client_public_key,
                                id: "client_public_key",
                                variant: "standard",
                                label: "Client Public Key",
                                required: true,
                                helperText: "WireGuard client public key (must be unique)",
                                onChange: (event)=>{
                                    setPostObject((prev)=>({
                                            ...prev,
                                            client_public_key: event.target.value
                                        }));
                                },
                                sx: {
                                    width: "400px"
                                },
                                type: "string"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                            /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                value: postObject.client_tunnel_ip,
                                id: "client_tunnel_ip",
                                variant: "standard",
                                label: "Client Tunnel IP",
                                helperText: /*#__PURE__*/ (0, $k4ank.jsx)($1396e2bdc93a1228$var$ExpandableHelperText, {
                                    text: "Client tunnel IP address (must end with /32, e.g., '10.0.0.1/32'). By default this is pre-populated with the first available IP from the pool, but you can change it if the client already has one assigned.",
                                    contentTestId: "client-tunnel-ip-helper-content"
                                }),
                                disabled: isClientTunnelIpLoading,
                                InputProps: {
                                    endAdornment: isClientTunnelIpLoading ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $1SPe4.default), {
                                        position: "end",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                            size: 16
                                        })
                                    }) : undefined
                                },
                                onChange: (event)=>{
                                    setPostObject((prev)=>({
                                            ...prev,
                                            client_tunnel_ip: event.target.value
                                        }));
                                },
                                sx: {
                                    width: "400px"
                                },
                                type: "string"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                            /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                value: postObject.subnets,
                                id: "subnets",
                                label: "Subnets",
                                multiline: true,
                                minRows: 2,
                                onChange: (event)=>{
                                    setPostObject((prev)=>({
                                            ...prev,
                                            subnets: event.target.value
                                        }));
                                },
                                sx: {
                                    width: "400px"
                                },
                                helperText: /*#__PURE__*/ (0, $k4ank.jsx)($1396e2bdc93a1228$var$ExpandableHelperText, {
                                    text: `The range of IP addresses on the customer's local network, in CIDR format (e.g., ["192.168.1.0/24"]). If the NVR/recording server is on the same machine as the WireGuard client, you can leave this empty. If the cameras are on a different IP range (e.g., the client routes traffic across their network), enter the local subnet(s) where their cameras live. Always use the smallest subnet that covers the required hosts - a /32 for a single IP is better than a /24 for an entire block.`
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "pl-[30px] mt-3 flex w-[400px] gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        value: cameraCount,
                                        id: "camera_count",
                                        label: "Approx camera count",
                                        type: "number",
                                        onChange: (event)=>{
                                            setSubnetSuggestionError(null);
                                            setCameraCount(event.target.value);
                                        },
                                        placeholder: "-",
                                        sx: {
                                            width: "192px"
                                        },
                                        helperText: "Leave blank if unknown"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        value: cidrPrefixLength,
                                        id: "cidr_size",
                                        label: "CIDR size",
                                        type: "number",
                                        onChange: (event)=>{
                                            setSubnetSuggestionError(null);
                                            setCidrPrefixLength(event.target.value);
                                        },
                                        sx: {
                                            width: "92px"
                                        },
                                        InputProps: {
                                            startAdornment: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1SPe4.default), {
                                                position: "start",
                                                children: "/"
                                            })
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "pl-[30px] mt-2",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    onClick: handleSuggestNextSubnet,
                                    text: isSuggestingSubnet ? "Suggesting\u2026" : "Suggest Next Subnet",
                                    disabled: isSuggestingSubnet
                                })
                            }),
                            subnetSuggestionError && /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                                className: "font-mulish mt-1 text-red-600",
                                role: "alert",
                                children: subnetSuggestionError
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                        sx: {
                                            fontFamily: "Mulish",
                                            color: "#001943"
                                        },
                                        label: "Virtually Assign Subnets",
                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                            color: "primary",
                                            checked: postObject.subnets_are_virtually_assigned,
                                            onChange: (event, checked)=>{
                                                setPostObject((prev)=>({
                                                        ...prev,
                                                        subnets_are_virtually_assigned: checked
                                                    }));
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)($1396e2bdc93a1228$var$ExpandableHelperText, {
                                            text: `Check this if the customer's real subnet overlaps with an existing tunnel's subnet. When enabled, the customer sets up DNAT/SNAT on their side to translate traffic to a virtual IP range, and you enter that virtual range in the Subnets field above. This avoids routing conflicts while keeping both tunnels operational.`
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "pt-10 pl-[420px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            style: {
                                display: "flex"
                            },
                            children: [
                                "\xa0\xa0\xa0",
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    onClick: handleSubmit,
                                    text: submitting ? "Submitting\u2026" : "Submit",
                                    disabled: submitting || !postObject.name.trim() || !postObject.client_public_key.trim()
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                open: showFailureDialog,
                onClose: ()=>{
                    setShowFailureDialog(false);
                    setFailureErrorMessage(null);
                },
                "aria-labelledby": "wireguard-failure-dialog-title",
                "aria-describedby": "wireguard-failure-dialog-description",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                        id: "wireguard-failure-dialog-title",
                        sx: {
                            fontFamily: "Mulish"
                        },
                        children: "WireGuard configuration could not be saved"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                        sx: {
                            fontFamily: "Mulish"
                        },
                        children: [
                            failureErrorMessage && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "font-mulish mb-3 text-[14px] text-red-600",
                                role: "alert",
                                children: failureErrorMessage
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                id: "wireguard-failure-dialog-description",
                                children: "Would you like to try again or skip this step and continue with onboarding?"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                        sx: {
                            px: 2,
                            pb: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    setShowFailureDialog(false);
                                    setFailureErrorMessage(null);
                                },
                                text: "Try Again",
                                disabled: false
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    setShowFailureDialog(false);
                                    setFailureErrorMessage(null);
                                    goToOnboardingProgress();
                                },
                                text: "Next Step",
                                disabled: false
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


const $04f5e8a333e57638$export$a40e294ebfc70fed = ({ setVisibleScreen: setVisibleScreen })=>{
    const [selectedOption, setSelectedOption] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const goToOnboardingProgress = ()=>setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $e4a2260e96905f88$export$770d5a29da7608e0), {
            percentage: (0, $1444c94c32ef2738$export$79b714ae571551b5)() ? localStorage.healthMonitoringOnly === "true" ? 33 : 25 : 33,
            step: 1,
            setVisibleScreen: setVisibleScreen
        }));
    const handleNext = ()=>{
        if (selectedOption === "yes") {
            setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $1396e2bdc93a1228$export$f7abbf7cc2d226c1), {
                setVisibleScreen: setVisibleScreen
            }));
            return;
        }
        goToOnboardingProgress();
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "pt-[140px] pl-[30px]",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "font-mulish mb-6 text-[20px] font-bold text-[#283E6D]",
                children: "Would you like to onboard a new wireguard tunnel for this site?"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "mb-8 flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                        sx: {
                            fontFamily: "Mulish",
                            color: "#001943"
                        },
                        label: "Yes",
                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                            checked: selectedOption === "yes",
                            onChange: ()=>setSelectedOption("yes")
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                        sx: {
                            fontFamily: "Mulish",
                            color: "#001943"
                        },
                        label: "No",
                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                            checked: selectedOption === "no",
                            onChange: ()=>setSelectedOption("no")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                onClick: handleNext,
                text: "Next",
                disabled: selectedOption === null
            })
        ]
    });
};




var $ebTQj = parcelRequire("ebTQj");

var $8QmWm = parcelRequire("8QmWm");
const $ad8745a6c4c2adda$export$4ca5b74ef6b328b2 = async (values, setVisibleScreen, responseObject, navigate, response, formik)=>{
    setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $f05a511d40a0fd8d$export$3c049d782df88a0e), {
        styling: "absolute first-line:font-black font-mulish text-[20px] right-[150px] text-center text-[#283E6D] top-80",
        text: /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
            children: [
                "We're creating the new Site.",
                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                "This might take a few seconds."
            ]
        })
    }));
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $ad8745a6c4c2adda$export$4ca5b74ef6b328b2(values, setVisibleScreen, responseObject, navigate, response, formik);
    };
    const handleRedirect = async ()=>{
        const AcuateUI = (0, $195EM.createApi)(`eagle_eye/`);
        await AcuateUI.get(`url`).then((response)=>{
            // Use safe redirect with allowed domains for Eagle Eye
            (0, $8QmWm.safeRedirect)(response.data.login_url, [
                "eagleeyenetworks.com",
                "actuateui.net"
            ], "/dashboard");
        }).catch((err)=>alert(`${err}`));
    };
    localStorage.removeItem("addSiteError");
    await AxiosUI.post("customer/onboarding/", (0, $ba1fbd5ec2ceaebf$export$56b33c7641763100)(values)).then((response)=>{
        localStorage.setItem("siteId", response.data.id);
        localStorage.setItem(`newSite${response.data.id}`, "true");
        localStorage.removeItem("addSiteError");
        const isOnvifWireguard = localStorage.selectedIntegrationName === "onvif_wireguard";
        // ONVIF over WireGuard skips sync (queue-backed deploy isn't used locally);
        // cameras are discovered later via the ONVIF scan step.
        if (!isOnvifWireguard) (0, $TzEEg.syncSite)(response.data.id, navigate);
        AxiosUI.get(`customer/${response.data.id}/camera_onboarding_forms/`).then((formsResponse)=>{
            // handleAddImmixToAddCameraForm(formsResponse.data);
            // handleAddDiceToAddCameraForm(formsResponse.data);
            localStorage.setItem("addCameraInfo", JSON.stringify(formsResponse.data));
            localStorage.setItem("selectedProducts", JSON.stringify(formsResponse.data.initial_data.products));
            (0, $bfBpo.getUpdatedSitesPageInfo)();
            setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $f05a511d40a0fd8d$export$3c049d782df88a0e), {
                styling: "absolute first-line:font-black font-mulish text-[20px] right-[190px] text-center text-[#283E6D] top-80",
                text: "Site created successfully!"
            }));
            setTimeout(()=>{
                if (isOnvifWireguard) {
                    // Cameras via Discover Cameras, then schedule — skip WireGuard
                    // decision / webhook / VMS-specific detours.
                    setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $e4a2260e96905f88$export$770d5a29da7608e0), {
                        percentage: 33,
                        step: 1,
                        setVisibleScreen: setVisibleScreen
                    }));
                    return;
                }
                if (localStorage.getItem("integrationType") === "35") {
                    setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $f05a511d40a0fd8d$export$3c049d782df88a0e), {
                        styling: "absolute first-line:font-black font-mulish text-[20px] right-[190px] text-center text-[#283E6D] top-80",
                        text: "Redirecting to Eagle Eye..."
                    }));
                    setTimeout(()=>{
                        handleRedirect();
                    }, 2000);
                } else if (localStorage.immixAlertsSite === "true") setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $3259993d86cdbbec$export$eb800053e14d4ae3), {
                    setVisibleScreen: setVisibleScreen
                }));
                else if (localStorage.diceAlertsSite === "true") setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $224b8993a113ec7a$export$aff20cbd3ce2cb31), {
                    setVisibleScreen: setVisibleScreen
                }));
                else if (localStorage.sentinelAlertsSite === "true") setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $d87ed22067f82a90$export$fc1a56ff1879b6a5), {
                    setVisibleScreen: setVisibleScreen
                }));
                else if ((0, $f3a38e087c86c35f$export$7003214a0e2ce77c).getState().needsWireGuardOnboarding) setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $04f5e8a333e57638$export$a40e294ebfc70fed), {
                    setVisibleScreen: setVisibleScreen
                }));
                else if (JSON.parse(localStorage.showWebHooksOnboardingScreen)) {
                    setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $faa29617becd29db$export$e238dc6c0409c0a6), {
                        setVisibleScreen: setVisibleScreen,
                        siteId: response.data.id
                    }));
                    localStorage.setItem("showWebHooksOnboardingScreen", JSON.stringify(false));
                } else setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $e4a2260e96905f88$export$770d5a29da7608e0), {
                    percentage: (0, $1444c94c32ef2738$export$79b714ae571551b5)() ? localStorage.healthMonitoringOnly === "true" ? 33 : 25 : 33,
                    step: 1,
                    setVisibleScreen: setVisibleScreen
                }));
            }, 2000);
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                alert(`${reason}`);
            });
        });
    }, (reason)=>{
        const backupResponse = JSON.parse(localStorage.responseObjectBackup);
        if (reason.request.response.includes("Please specify a valid Group")) {
            localStorage.setItem("responseObjectBackup", JSON.stringify(responseObject));
            setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $b8e45df6cc7312fb$export$6b835921ba7e0f4b), {
                handleSubmitSite: $ad8745a6c4c2adda$export$4ca5b74ef6b328b2,
                responseObject: backupResponse,
                setVisibleScreen: setVisibleScreen
            }));
            (0, $ebTQj.logger).error("Please select a valid group and retry.");
            alert("Please select a valid group and retry.");
        } else (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            localStorage.setItem("addSiteError", "true");
            setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $b8e45df6cc7312fb$export$6b835921ba7e0f4b), {
                handleSubmitSite: $ad8745a6c4c2adda$export$4ca5b74ef6b328b2,
                responseObject: backupResponse,
                setVisibleScreen: setVisibleScreen
            }));
        });
    });
};


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $3QMQN = parcelRequire("3QMQN");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

var $4wo2Y = parcelRequire("4wo2Y");
const $40e1b9daa0b4b4d7$var$theme = (0, $cFPmV.default)({
    components: {
        MuiTextField: {
            styleOverrides: {
                root: {
                    fontSize: "4rem"
                }
            }
        }
    }
});
const $40e1b9daa0b4b4d7$export$72852cc74d844f32 = ({ setVisibleScreen: setVisibleScreen })=>{
    const [integrationType, setIntegrationType] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [integrationsTypes] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(JSON.parse(localStorage.integrationTypes));
    const [integrationSubmitError, setIntegrationSubmitError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const integrationIds = new Map();
    const navigate = (0, $3T949.useNavigate)();
    const assignIntegrationIds = ()=>{
        integrationsTypes.forEach((element)=>{
            integrationIds.set(`${element.display_name}`, element.id);
        });
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            children: [
                integrationSubmitError && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "absolute w-[600px] h-[50px]",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                        severity: "error",
                        onClose: ()=>{
                            setIntegrationSubmitError(false);
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "font-mulish font-bold text-[16px]",
                            children: "Problem Submitting Integration. Please try again."
                        })
                    })
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "absolute top-20 right-[15px]",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "flex justify-end",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $635b38046a5de67e$export$2cf5ff4e03e29cc1), {
                            activeStep: 0
                        })
                    })
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "absolute right-4 top-32",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            disabled: !integrationType,
                            onClick: ()=>{
                                (0, $b5135a070d60b6a0$export$1c29bc844a08fcce)(setVisibleScreen, (0, $ad8745a6c4c2adda$export$4ca5b74ef6b328b2), navigate, setIntegrationSubmitError);
                            },
                            text: "Next"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($53b11234ecc265c7$exports))), {})
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "font-mulish absolute top-[180px] text-[#283E6D] right-[244px] text-[21px]",
                    children: "Please select the Integration type"
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "font-mulish absolute top-[235px] font-bold text-[#283E6D] right-[442px] text-[16px]",
                    children: "Integration type"
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                    theme: $40e1b9daa0b4b4d7$var$theme,
                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute right-[215px] top-[280px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                            value: integrationType,
                            isOptionEqualToValue: (option, value)=>option === value,
                            onChange: (event, newInputValue)=>{
                                assignIntegrationIds();
                                setIntegrationType(newInputValue);
                                localStorage.setItem("integrationType", integrationIds.get(newInputValue));
                                localStorage.setItem("selectedIntegrationType", newInputValue);
                                const selectedObj = integrationsTypes.find((el)=>el.display_name === newInputValue);
                                localStorage.setItem("selectedIntegrationName", selectedObj?.name || "");
                            },
                            disablePortal: true,
                            id: "integration-options",
                            options: JSON.parse(localStorage.integrationTypes).map((object)=>{
                                return `${object.display_name}`;
                            }),
                            sx: {
                                width: 350
                            },
                            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                    ...params,
                                    variant: "standard",
                                    label: "Integration *",
                                    sx: {}
                                })
                        })
                    })
                })
            ]
        })
    });
};



var $4wo2Y = parcelRequire("4wo2Y");

const $f195e9d0021846f0$export$150cfcc54fa9f63a = ()=>{
    const [visibleScreen, setVisibleScreen] = $8T3gX.useState(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
    const resetOnboarding = (0, $f3a38e087c86c35f$export$7003214a0e2ce77c)((state)=>state.resetOnboarding);
    $8T3gX.useEffect(()=>{
        resetOnboarding();
        localStorage.setItem("healthMonitoringOnly", "false");
        setVisibleScreen(// <AddWebhookScreen />
        /*#__PURE__*/ (0, $k4ank.jsx)((0, $40e1b9daa0b4b4d7$export$72852cc74d844f32), {
            setVisibleScreen: setVisibleScreen
        }));
        localStorage.removeItem("siteJustDeleted");
        localStorage.removeItem("selectedIntegrationName");
        localStorage.setItem("immixAlertsSite", "false");
        localStorage.setItem("diceAlertsSite", "false");
        localStorage.setItem("sentinelAlertsSite", "false");
        localStorage.setItem("sureviewAlertsSite", "false");
        localStorage.setItem("immixAlertPostObject", JSON.stringify({
            id: -1,
            immix_server: "",
            immix_port: ""
        }));
        localStorage.setItem("diceAlertPostObject", JSON.stringify({
            id: -1,
            dice_server: "",
            dice_port: ""
        }));
        // Reset so a previous site's Evalink credentials never leak into a new
        // onboarding (the auto-add screen seeds its fields from this object).
        localStorage.setItem("evalinkAlertPostObject", JSON.stringify({}));
    }, [
        resetOnboarding
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fc1f706f45bf72ab$export$f81d45315d235306), {
            text: "Add Site",
            visibleScreen: visibleScreen,
            styling: "text-white absolute top-[1px] right-[485px] font-mulish text-[18px] p-3"
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");



var $4wo2Y = parcelRequire("4wo2Y");

var $7kQyB = parcelRequire("7kQyB");

parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $5aef4e619f4ea332$var$readImmixAlertPostObject = ()=>{
    if (typeof localStorage === "undefined" || !localStorage.immixAlertPostObject) return {};
    try {
        return JSON.parse(localStorage.immixAlertPostObject);
    } catch  {
        return {};
    }
};
const $5aef4e619f4ea332$var$setFieldDefaultValue = (fields, fieldName, value)=>{
    if (value === undefined || value === null || value === "") return;
    const field = fields.find((entry)=>entry.field === fieldName);
    if (field) field.defaultValue = value;
};
const $5aef4e619f4ea332$export$f4d07c1f87f885eb = (form)=>{
    if (!Array.isArray(form) || form.length === 0) return form ?? [];
    const immixAlertPostObject = $5aef4e619f4ea332$var$readImmixAlertPostObject();
    const updatedForm = form.map((page)=>page.map((field)=>({
                ...field
            })));
    const lastPage = updatedForm[updatedForm.length - 1];
    if (!Array.isArray(lastPage) || lastPage.length === 0) return updatedForm;
    $5aef4e619f4ea332$var$setFieldDefaultValue(lastPage, "immix_server", immixAlertPostObject.immix_server);
    $5aef4e619f4ea332$var$setFieldDefaultValue(lastPage, "immix_port", immixAlertPostObject.immix_port);
    return updatedForm;
};


const $7cdcad1ad0dabd0b$var$readDiceAlertPostObject = ()=>{
    if (typeof localStorage === "undefined" || !localStorage.diceAlertPostObject) return {};
    try {
        return JSON.parse(localStorage.diceAlertPostObject);
    } catch  {
        return {};
    }
};
const $7cdcad1ad0dabd0b$var$setFieldDefaultValue = (fields, fieldName, value)=>{
    if (value === undefined || value === null || value === "") return;
    const field = fields.find((entry)=>entry.field === fieldName);
    if (field) field.defaultValue = value;
};
const $7cdcad1ad0dabd0b$export$2aea5e375fb52a4a = (form)=>{
    if (!Array.isArray(form) || form.length === 0) return form ?? [];
    const diceAlertPostObject = $7cdcad1ad0dabd0b$var$readDiceAlertPostObject();
    const updatedForm = form.map((page)=>page.map((field)=>({
                ...field
            })));
    const lastPage = updatedForm[updatedForm.length - 1];
    if (!Array.isArray(lastPage) || lastPage.length === 0) return updatedForm;
    $7cdcad1ad0dabd0b$var$setFieldDefaultValue(lastPage, "dice_server", diceAlertPostObject.dice_server);
    $7cdcad1ad0dabd0b$var$setFieldDefaultValue(lastPage, "dice_port", diceAlertPostObject.dice_port);
    return updatedForm;
};


parcelRequire("8T3gX");
const $c973c35b0d751dca$var$readAlertPostObject = (key)=>{
    if (typeof localStorage === "undefined" || !localStorage[key]) return {};
    try {
        return JSON.parse(localStorage[key]);
    } catch  {
        return {};
    }
};
const $c973c35b0d751dca$export$64f9c2a9c1b0ae6e = (initialData)=>{
    const immixAlertPostObject = $c973c35b0d751dca$var$readAlertPostObject("immixAlertPostObject");
    const diceAlertPostObject = $c973c35b0d751dca$var$readAlertPostObject("diceAlertPostObject");
    const sentinelAlertPostObject = $c973c35b0d751dca$var$readAlertPostObject("sentinelAlertPostObject");
    const updatedInitialData = initialData;
    if (immixAlertPostObject.immix_server) updatedInitialData.immix_server = immixAlertPostObject.immix_server;
    if (immixAlertPostObject.immix_port) updatedInitialData.immix_port = immixAlertPostObject.immix_port;
    if (diceAlertPostObject.dice_server) updatedInitialData.dice_server = diceAlertPostObject.dice_server;
    if (diceAlertPostObject.dice_port) updatedInitialData.dice_port = diceAlertPostObject.dice_port;
    if (sentinelAlertPostObject.sentinel_server) updatedInitialData.sentinel_server = sentinelAlertPostObject.sentinel_server;
    if (sentinelAlertPostObject.sentinel_site_id) updatedInitialData.sentinel_site_id = sentinelAlertPostObject.sentinel_site_id;
    if (sentinelAlertPostObject.sentinel_device_address) updatedInitialData.sentinel_device_address = sentinelAlertPostObject.sentinel_device_address;
    if (sentinelAlertPostObject.draw_ignore_zones) updatedInitialData.draw_ignore_zones = sentinelAlertPostObject.draw_ignore;
    return updatedInitialData;
};


const $20c574c628764d10$export$8b6ff4b740d40aab = (addCameraInfo)=>({
        initial_data: {
            ...(0, $c973c35b0d751dca$export$64f9c2a9c1b0ae6e)(addCameraInfo?.initial_data ?? {}),
            // Add Camera should start with no product pre-selection.
            products: []
        },
        forms: (0, $7cdcad1ad0dabd0b$export$2aea5e375fb52a4a)((0, $5aef4e619f4ea332$export$f4d07c1f87f885eb)(addCameraInfo?.forms ?? [])),
        submit_object: addCameraInfo?.submit_object
    });
const $20c574c628764d10$export$f772c2a1412aae0d = (addCameraInfo, siteId)=>{
    if (!siteId) return false;
    const submitObject = addCameraInfo?.submit_object;
    if (!submitObject) return true;
    return Number(submitObject.customer) !== Number(siteId);
};
const $20c574c628764d10$export$d63df7ba22be0539 = ()=>{
    if (typeof localStorage === "undefined" || !localStorage.addCameraInfo) return {};
    try {
        return JSON.parse(localStorage.addCameraInfo);
    } catch  {
        return {};
    }
};


const $78eceafc35b75d85$export$df0ffe8c4365c7a5 = ({ setCameraCheckFinsihedAlertOpen: setCameraCheckFinsihedAlertOpen, setGoodCameras: setGoodCameras, setConnectivityCameras: setConnectivityCameras, setLowResolutionCameras: setLowResolutionCameras, setCameraCheckResultDownloadURL: setCameraCheckResultDownloadURL })=>{
    const navigate = (0, $3T949.useNavigate)();
    const [visibleScreen, setVisibleScreen] = $8T3gX.useState(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
    const showWizard = $8T3gX.useCallback((responseObject)=>{
        setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f51e285c0ff6c076$export$ffee78e2cdb3d23f), {
                setVisibleScreen: setVisibleScreen,
                responseObject: responseObject,
                setCameraCheckFinsihedAlertOpen: setCameraCheckFinsihedAlertOpen,
                setGoodCameras: setGoodCameras,
                setConnectivityCameras: setConnectivityCameras,
                setLowResolutionCameras: setLowResolutionCameras,
                setCameraCheckResultDownloadURL: setCameraCheckResultDownloadURL
            })
        }));
    }, [
        setCameraCheckFinsihedAlertOpen,
        setConnectivityCameras,
        setGoodCameras,
        setLowResolutionCameras,
        setCameraCheckResultDownloadURL
    ]);
    $8T3gX.useEffect(()=>{
        // First time Add Camera loads (first camera): use API initial_data only.
        // copyValues is only set after "Submit and Add Another", so clear it on mount.
        localStorage.removeItem("copyValues");
        const siteId = localStorage.siteId;
        const cachedAddCameraInfo = (0, $20c574c628764d10$export$d63df7ba22be0539)();
        if (!(0, $20c574c628764d10$export$f772c2a1412aae0d)(cachedAddCameraInfo, siteId)) {
            showWizard((0, $20c574c628764d10$export$8b6ff4b740d40aab)(cachedAddCameraInfo));
            return;
        }
        setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $f05a511d40a0fd8d$export$3c049d782df88a0e), {
            styling: "absolute first-line:font-black font-mulish text-[20px] right-[190px] text-center text-[#283E6D] top-80",
            text: "Loading camera form..."
        }));
        (0, $7kQyB.fetchAddCameraInfo)(String(siteId), navigate).then((data)=>{
            const addCameraInfo = data ?? (0, $20c574c628764d10$export$d63df7ba22be0539)();
            showWizard((0, $20c574c628764d10$export$8b6ff4b740d40aab)(addCameraInfo));
        });
    }, [
        navigate,
        showWizard
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $fc1f706f45bf72ab$export$f81d45315d235306), {
        text: "Add Camera",
        visibleScreen: visibleScreen,
        styling: "text-white absolute top-[1px] right-[450px] font-mulish text-[18px] p-3"
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eejVe = parcelRequire("eejVe");
const $871b236273f4a325$export$a316a94c1bd540e2 = ({ id: id, defaultValue: defaultValue, value: value, onChange: onChange, helperText: helperText, stylingWidth: stylingWidth, label: label, error: error })=>{
    if (value) return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
            error: error,
            id: id,
            value: value,
            variant: "standard",
            onChange: onChange,
            sx: {
                width: stylingWidth
            },
            helperText: helperText,
            type: "string",
            label: label
        })
    }, id);
    else return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
            error: error,
            id: id,
            defaultValue: defaultValue,
            variant: "standard",
            onChange: onChange,
            sx: {
                width: stylingWidth
            },
            helperText: helperText,
            type: "string",
            label: label
        })
    }, id);
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");
const $0553efca519c1dc2$export$209b1f883cb1691c = ({ id: id, options: options, onChange: onChange, stylingWidth: stylingWidth, label: label, helperText: helperText, defaultValue: defaultValue, value: value })=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            multiple: true,
            disablePortal: true,
            id: id,
            options: options,
            ...value !== undefined ? {
                value: value
            } : {
                defaultValue: defaultValue
            },
            onChange: onChange,
            sx: {
                width: stylingWidth
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    variant: "standard",
                    label: label,
                    name: id,
                    helperText: helperText
                })
        })
    });
};



var $8B8vg = parcelRequire("8B8vg");
var $60vL1 = parcelRequire("60vL1");
var $kUcVg = parcelRequire("kUcVg");
var $887xF = parcelRequire("887xF");
var $1TOOV = parcelRequire("1TOOV");
var $ce8iU = parcelRequire("ce8iU");
var $9qNow = parcelRequire("9qNow");
var $3Nm8Z = parcelRequire("3Nm8Z");
var $eejVe = parcelRequire("eejVe");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $aVDw9 = parcelRequire("aVDw9");

var $ha39s = parcelRequire("ha39s");

var $4o6Cs = parcelRequire("4o6Cs");

var $gXvgZ = parcelRequire("gXvgZ");

var $kbChx = parcelRequire("kbChx");

var $3baw3 = parcelRequire("3baw3");

const $471d518762e7af5e$export$8744c2893a65a5bc = (type, input, returnedProducts)=>{
    const products = JSON.parse(localStorage.products);
    const productIds = new Map();
    const productNames = new Map();
    if (returnedProducts[0][0]) returnedProducts.forEach((array)=>{
        productNames.set(`${array[0]}`, array[1]);
        productIds.set(array[1], `${array[0]}`);
    });
    else products.forEach((element)=>{
        productNames.set(`${element.name}`, element.id);
        productIds.set(element.id, `${element.name}`);
    });
    if (type === "Id") return productNames.get(input);
    else if (type === "Name") return productIds.get(input);
};



const $320890599a031ab1$export$3604bb5ed997fb8a = (productName, setCamerasObject, camerasObject, objectId, checked, productsArray)=>{
    const productId = (0, $471d518762e7af5e$export$8744c2893a65a5bc)("Id", productName, productsArray);
    if (productId === undefined || productId === null) return;
    const currentProducts = [
        ...camerasObject[objectId]?.products || []
    ];
    const blockedProductIds = (0, $2cdc286d7222c539$export$9a3d8fc14dd5f8c9)(currentProducts, productsArray);
    if (checked && blockedProductIds.has(productId)) return;
    const nextProducts = checked ? currentProducts.includes(productId) ? currentProducts : [
        ...currentProducts,
        productId
    ] : currentProducts.filter((id)=>id !== productId);
    setCamerasObject((previousState)=>({
            ...previousState,
            [objectId]: {
                ...previousState[objectId],
                products: nextProducts
            }
        }));
};


const $24183b825f8ca9ac$export$e0710f738d4ba871 = (setCamerasObject, camerasObject, inputString, objectId)=>{
    const newObject = camerasObject[objectId];
    newObject.immix.immix_email = inputString;
    setCamerasObject((previousState)=>{
        return {
            ...previousState,
            objectId: newObject
        };
    });
};


const $baaa9165d4f9ae3c$export$97e3ebff0644dab4 = (setCamerasObject, camerasObject, inputString, objectId)=>{
    const newObject = camerasObject[objectId];
    newObject.immix.immix_input1 = inputString;
    setCamerasObject((previousState)=>{
        return {
            ...previousState,
            objectId: newObject
        };
    });
};


const $8941a3d3b533e314$export$113e0ad827f5ec14 = (setCamerasObject, camerasObject, inputString, objectId)=>{
    const newObject = camerasObject[objectId];
    newObject.dice.dice_email = inputString;
    setCamerasObject((previousState)=>{
        return {
            ...previousState,
            objectId: newObject
        };
    });
};


const $9be8edf253b6dd2c$export$43b6f40d8d72fe1e = (setCamerasObject, camerasObject, inputString, objectId)=>{
    const newObject = camerasObject[objectId];
    newObject.dice.dice_input1 = inputString;
    setCamerasObject((previousState)=>{
        return {
            ...previousState,
            objectId: newObject
        };
    });
};



var $60vL1 = parcelRequire("60vL1");
var $cxknk = parcelRequire("cxknk");
var $1wcxl = parcelRequire("1wcxl");
var $eejVe = parcelRequire("eejVe");
var $f3puC = parcelRequire("f3puC");


const $5795c0d73879d0d7$export$903c7efd8f42ee6d = (camerasObject, setCamerasObject, productName, checked, checkboxesChecked, setCheckBoxesChecked, productsArray)=>{
    const productId = (0, $471d518762e7af5e$export$8744c2893a65a5bc)("Id", productName, productsArray);
    if (productId === undefined || productId === null) return;
    const updatedCheckboxes = {
        ...checkboxesChecked,
        [productName]: checked
    };
    const updatedCamerasObject = {
        ...camerasObject
    };
    for(const key in camerasObject){
        const returnObject = {
            ...camerasObject[key]
        };
        const currentProducts = [
            ...camerasObject[key].products || []
        ];
        const rowCheckboxKey = `${productName}${key}`;
        if (checked) {
            const blockedProductIds = (0, $2cdc286d7222c539$export$9a3d8fc14dd5f8c9)(currentProducts, productsArray);
            if (blockedProductIds.has(productId)) updatedCheckboxes[rowCheckboxKey] = false;
            else if (!currentProducts.includes(productId)) {
                returnObject.products = [
                    ...currentProducts,
                    productId
                ];
                updatedCamerasObject[key] = returnObject;
                updatedCheckboxes[rowCheckboxKey] = true;
            } else updatedCheckboxes[rowCheckboxKey] = true;
        } else {
            const returnArray = currentProducts.filter((num)=>num !== productId);
            returnObject.products = returnArray;
            updatedCamerasObject[key] = returnObject;
            updatedCheckboxes[rowCheckboxKey] = false;
        }
    }
    setCamerasObject(updatedCamerasObject);
    setCheckBoxesChecked(updatedCheckboxes);
};


const $5db882ded2483122$export$70069f6b0fdcaadf = (setCamerasObject, camerasObject, inputString, objectId)=>{
    const newObject = camerasObject[objectId];
    newObject.sureview.sureview_email = inputString;
    setCamerasObject((previousState)=>{
        return {
            ...previousState,
            objectId: newObject
        };
    });
};


const $e0ec7b6c2fb7f8c9$export$e9d21c509adf2c17 = (setCamerasObject, camerasObject, inputString, objectId)=>{
    const newObject = camerasObject[objectId];
    newObject.sureview.sureview_cc = inputString;
    setCamerasObject((previousState)=>{
        return {
            ...previousState,
            objectId: newObject
        };
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $5Ibhh = parcelRequire("5Ibhh");

var $cye0Y = parcelRequire("cye0Y");

var $cVCJe = parcelRequire("cVCJe");
const $ad162c242e35003e$export$36bfae36e6dd07ae = (type, id, cameraObject, largerScreen)=>{
    switch(type){
        case "checkbox":
            return cameraObject[id] ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5Ibhh))), {
                    color: "success"
                })
            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cye0Y))), {
                color: "error"
            });
        case "string":
            if (cameraObject[id]) return cameraObject[id].length < 10 ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                children: cameraObject[id]
            }) : !largerScreen ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                    title: cameraObject[id],
                    placement: "top",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        children: `${cameraObject[id].slice(0, 7)}...`
                    })
                })
            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                children: cameraObject[id]
            });
    }
};



var $fIsAN = parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $28ef544f83a091a4$export$b9c8d142e906be5d = (setCamerasObject, camerasObject, inputString, objectId, inputNameString)=>{
    // Update localStorage first so AutoAddTable doesn't overwrite our changes.
    // Site-level fields (token / device id / company id / partition id) are
    // shared across all cameras; alarm_zone_id is per camera and deliberately
    // never stored here (ENG-352: each camera's zone must be typed in, no
    // silent duplicates).
    const evalinkAlertPostObject = JSON.parse(localStorage.evalinkAlertPostObject || "{}");
    if (inputNameString === "evalinkToken") evalinkAlertPostObject.evalink_token = inputString;
    if (inputNameString === "evalinkDeviceId") evalinkAlertPostObject.evalink_device_id = inputString;
    if (inputNameString === "evalinkCompanyId") evalinkAlertPostObject.evalink_company_id = inputString;
    if (inputNameString === "partitionId") evalinkAlertPostObject.partition_id = inputString;
    if (inputNameString !== "alarmZoneId") localStorage.setItem("evalinkAlertPostObject", JSON.stringify(evalinkAlertPostObject));
    // Create a deep copy of the camerasObject to ensure React detects the change
    const newCamerasObject = {
        ...camerasObject
    };
    for(const key in camerasObject)newCamerasObject[key] = {
        ...camerasObject[key],
        evalink: {
            ...camerasObject[key].evalink
        }
    };
    if (objectId) {
        // Handle single object update (per-camera alarm zone)
        if (inputNameString === "alarmZoneId") newCamerasObject[objectId].evalink.alarm_zone_id = inputString;
        setCamerasObject((previousState)=>{
            return {
                ...previousState,
                [objectId]: newCamerasObject[objectId]
            };
        });
    } else {
        // Handle all objects update (site-level fields)
        if (inputNameString === "evalinkToken") for(const key in newCamerasObject)newCamerasObject[key].evalink.evalink_token = inputString;
        if (inputNameString === "evalinkDeviceId") for(const key in newCamerasObject)newCamerasObject[key].evalink.evalink_device_id = inputString;
        if (inputNameString === "evalinkCompanyId") for(const key in newCamerasObject)newCamerasObject[key].evalink.evalink_company_id = inputString;
        if (inputNameString === "partitionId") for(const key in newCamerasObject)newCamerasObject[key].evalink.partition_id = inputString;
        setCamerasObject(newCamerasObject);
    }
};



var $8jTCz = parcelRequire("8jTCz");

var $9OjAn = parcelRequire("9OjAn");
const $a4d6ac0c9ead9c31$export$2b7358df2c708c72 = (0, $9OjAn.create)((set)=>({
        moreDataToLoadAutoAdd: false,
        setMoreDataToLoadAutoAdd: (value)=>set({
                moreDataToLoadAutoAdd: value
            }),
        loadingMoreAutoAddData: false,
        setLoadingMoreAutoAddData: (value)=>set({
                loadingMoreAutoAddData: value
            }),
        searchingCameras: false,
        setSearchingCameras: (value)=>set({
                searchingCameras: value
            }),
        columnSpan: 3,
        setColumnSpan: (value)=>set({
                columnSpan: value
            }),
        nvrNextString: "",
        setNvrNextString: (value)=>set({
                nvrNextString: value
            }),
        page: 0,
        setPage: (value)=>set({
                page: value
            }),
        rowsPerPage: 10,
        setRowsPerPage: (value)=>set({
                rowsPerPage: value
            }),
        totalCamerasPerAPIResponse: 0,
        setTotalCamerasPerAPIResponse: (value)=>set({
                totalCamerasPerAPIResponse: value
            })
    }));



var $195EM = parcelRequire("195EM");

const $1527cf3e70fe5162$export$28aa6ff945d84e88 = (cameras)=>{
    const returnObject = {};
    cameras.map((object)=>{
        returnObject[object.id] = {
            camera: object.camera ? true : false,
            id: object.id,
            products: [],
            immix: {},
            dice: {},
            sureview: {},
            sentinel: {},
            // softguard: {},
            sysaid: {},
            bold: {},
            patriot: {},
            evalink: {},
            // The NVR device id/guid is returned as `nvr_id` by the serializer;
            // fall back to it so the device id is populated (older code read the
            // non-existent `device_id` field, leaving this blank).
            device_id: object.device_id || object.nvr_id || ""
        };
    });
    return returnObject;
};



var $3Zv1D = parcelRequire("3Zv1D");


const $2bce7a63b3b30c9d$export$93479f6cc51139d3 = (setCamerasList, setCamerasObject, navigate, productsArray, setCheckboxesChecked, checkboxesChecked)=>{
    const { setMoreDataToLoadAutoAdd: setMoreDataToLoadAutoAdd, setLoadingMoreAutoAddData: setLoadingMoreAutoAddData, nvrNextString: nvrNextString, setNvrNextString: setNvrNextString, setTotalCamerasPerAPIResponse: setTotalCamerasPerAPIResponse } = (0, $a4d6ac0c9ead9c31$export$2b7358df2c708c72).getState();
    const retryFunction = ()=>{
        $2bce7a63b3b30c9d$export$93479f6cc51139d3(setCamerasList, setCamerasObject, navigate, productsArray, setCheckboxesChecked, checkboxesChecked);
    };
    const AxiosUI = (0, $195EM.createApi)(``);
    AxiosUI.get(`nvr_camera/${nvrNextString}`).then((response)=>{
        // Update total cameras count from API response
        if (response.data.count !== undefined) setTotalCamerasPerAPIResponse(response.data.count);
        setCamerasList((previousState)=>({
                ...previousState,
                ...response.data,
                results: [
                    ...previousState.results || [],
                    ...response.data.results
                ]
            }));
        if (response.data.next) {
            setMoreDataToLoadAutoAdd(true);
            setNvrNextString(response.data.next.slice(response.data.next.indexOf("?")));
        } else setMoreDataToLoadAutoAdd(false);
        const nvrResults = response.data.results;
        AxiosUI.get(`nvr_camera/product/?customer__id=${localStorage.siteId}`).then((response)=>{
            const productResponse = response.data;
            const idsArray = [];
            productResponse.forEach((array)=>{
                idsArray.push(array[1]);
            });
            // Batch all checkbox state updates into a single update to prevent multiple re-renders
            const newCheckboxesState = {
                ...checkboxesChecked
            };
            // Update camerasObject: merge new cameras and add product IDs if header checkboxes are checked
            setCamerasObject((previousCamerasObject)=>{
                // First, merge the new cameras into the object
                const newCamerasObject = (0, $1527cf3e70fe5162$export$28aa6ff945d84e88)(nvrResults);
                const updatedCamerasObject = {
                    ...previousCamerasObject || {},
                    ...newCamerasObject
                };
                idsArray.forEach((id)=>{
                    if ((0, $471d518762e7af5e$export$8744c2893a65a5bc)("Name", id, productResponse)) {
                        const name = (0, $471d518762e7af5e$export$8744c2893a65a5bc)("Name", id, productResponse);
                        const productId = (0, $471d518762e7af5e$export$8744c2893a65a5bc)("Id", name, productsArray);
                        // Preserve the existing header checkbox state (don't overwrite it)
                        // Only initialize if it doesn't exist
                        if (newCheckboxesState[name] === undefined) newCheckboxesState[name] = false;
                        // Check if the header checkbox is checked for this product
                        const isProductHeaderChecked = checkboxesChecked[name] === true;
                        nvrResults.forEach((object)=>{
                            if (!object.camera) {
                                const newName = `${name}${object.id}`;
                                // Initialize new row checkboxes based on header checkbox state
                                newCheckboxesState[newName] = isProductHeaderChecked;
                                // If header checkbox is checked, add product ID to the camera's products array
                                if (isProductHeaderChecked && updatedCamerasObject[object.id]) {
                                    const cameraProducts = updatedCamerasObject[object.id].products;
                                    const blockedProductIds = (0, $2cdc286d7222c539$export$9a3d8fc14dd5f8c9)(cameraProducts, productsArray);
                                    if (!blockedProductIds.has(productId) && !cameraProducts.includes(productId)) updatedCamerasObject[object.id] = {
                                        ...updatedCamerasObject[object.id],
                                        products: [
                                            ...cameraProducts,
                                            productId
                                        ]
                                    };
                                    else if (blockedProductIds.has(productId)) newCheckboxesState[newName] = false;
                                }
                            }
                        });
                    }
                });
                return updatedCamerasObject;
            });
            // Single state update instead of multiple individual updates
            setCheckboxesChecked(newCheckboxesState);
        });
        setLoadingMoreAutoAddData(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setLoadingMoreAutoAddData(false);
        });
    });
};





var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");

var $815yO = parcelRequire("815yO");
const $2844b9177f6f3f6b$export$c442a5e1a717e2a5 = {
    open: false,
    camerasChanged: [],
    uidsFixed: 0,
    updateMessages: [],
    error: false
};
const $2844b9177f6f3f6b$export$be98998873c77329 = (row)=>!!row?.camera_current_recording_server && !!row?.recorder_name && row.camera_current_recording_server.toUpperCase() !== row.recorder_name.toUpperCase();
/** A 400 from autofix carries a user-facing reason (e.g. a stale camera list). */ const $2844b9177f6f3f6b$var$errorMessageFrom = (reason)=>{
    if (reason.response?.status !== 400) return undefined;
    const data = reason.response?.data;
    if (Array.isArray(data) && typeof data[0] === "string") return data[0];
    if (typeof data?.detail === "string") return data.detail;
    return undefined;
};
const $2844b9177f6f3f6b$export$86ada9eacde07a99 = (setFixingCameras, setFixResult, refreshCameraList, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const siteId = localStorage.siteId;
    setFixingCameras(true);
    const retryFunction = ()=>{
        $2844b9177f6f3f6b$export$86ada9eacde07a99(setFixingCameras, setFixResult, refreshCameraList, navigate);
    };
    AxiosUI.post(`nvr_camera/${siteId}/autofix/`).then((response)=>{
        const data = response.data || {};
        const camerasChanged = Array.isArray(data.names_fixed) ? data.names_fixed : [];
        const uidsFixed = Array.isArray(data.uids_fixed) ? data.uids_fixed.length : 0;
        const updateMessages = (Array.isArray(data.messages) ? data.messages : []).map((m)=>m?.message).filter((text)=>typeof text === "string" && !text.startsWith("Updated camera_uid"));
        setFixingCameras(false);
        setFixResult({
            open: true,
            camerasChanged: camerasChanged,
            uidsFixed: uidsFixed,
            updateMessages: updateMessages,
            error: false
        });
        if (camerasChanged.length > 0 || uidsFixed > 0 || updateMessages.length) {
            // These change connector settings — flag the site unsynced so the
            // Sync controls/banner light up. The auto-add route
            // (/sites/autoaddcamera) doesn't carry the site id, so pass it.
            (0, $815yO.markSiteUnsynced)(siteId);
            // Re-fetch the NVR list so the deployed names and servers update and
            // the old -> new hints clear for the cameras that were fixed.
            refreshCameraList();
        }
    }, (reason)=>{
        setFixingCameras(false);
        const errorMessage = $2844b9177f6f3f6b$var$errorMessageFrom(reason);
        if (errorMessage) {
            setFixResult({
                ...$2844b9177f6f3f6b$export$c442a5e1a717e2a5,
                open: true,
                error: true,
                errorMessage: errorMessage
            });
            return;
        }
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setFixResult({
                ...$2844b9177f6f3f6b$export$c442a5e1a717e2a5,
                open: true,
                error: true
            });
        });
    });
};


/**
 * Genetec stream choice in the auto-add table (ENG-2043).
 *
 * actuate_admin's nvr_camera rows carry `genetec_stream_options`: probed
 * `[label, value]` pairs, value "" = Auto (the smallest stream the camera
 * offers). Rows without a probe (other integrations) carry null, so the Stream
 * column only appears when at least one row has options.
 */ const $6eb51f05503e8a27$export$22b2e93233949012 = (row)=>Array.isArray(row?.genetec_stream_options) ? row.genetec_stream_options : [];
const $6eb51f05503e8a27$export$9f3fc2ae6a9b671b = (rows)=>Array.isArray(rows) && rows.some((row)=>$6eb51f05503e8a27$export$22b2e93233949012(row).length > 0);
const $6eb51f05503e8a27$export$d5d3e2f9cd3a0b33 = (camerasObject, rowId)=>camerasObject?.[rowId]?.genetec_stream ?? "";
const $6eb51f05503e8a27$export$12b9a5254d0112fb = (setCamerasObject, value, rowId)=>{
    setCamerasObject((previousState)=>({
            ...previousState,
            [rowId]: {
                ...previousState[rowId],
                genetec_stream: value
            }
        }));
};


// Memoized table row component to prevent unnecessary re-renders
const $9151e83927c89871$var$TableRowMemo = /*#__PURE__*/ $8T3gX.memo(({ obj: obj, selectedProducts: selectedProducts, additionalFieldNamesArray: additionalFieldNamesArray, checkboxesChecked: checkboxesChecked, setCheckboxesChecked: setCheckboxesChecked, setCamerasObject: setCamerasObject, camerasObject: camerasObject, productsArray: productsArray, immixSite: immixSite, diceSite: diceSite, sureViewSite: sureViewSite, evalinkSite: evalinkSite, largerScreen: largerScreen, genetecStreamSite: genetecStreamSite })=>{
    const immixAlertPostObject = JSON.parse(localStorage.immixAlertPostObject);
    if (immixAlertPostObject.immix_server) camerasObject[obj.id].immix.immix_server = immixAlertPostObject.immix_server;
    if (immixAlertPostObject.immix_port) camerasObject[obj.id].immix.immix_port = immixAlertPostObject.immix_port;
    const diceAlertPostObject = JSON.parse(localStorage.diceAlertPostObject || "{}");
    if (diceAlertPostObject.dice_server) camerasObject[obj.id].dice.dice_server = diceAlertPostObject.dice_server;
    if (diceAlertPostObject.dice_port) camerasObject[obj.id].dice.dice_port = diceAlertPostObject.dice_port;
    const sentinelAlertPostObject = JSON.parse(localStorage.sentinelAlertPostObject);
    if (sentinelAlertPostObject.sentinel_server) camerasObject[obj.id].sentinel.sentinel_server = sentinelAlertPostObject.sentinel_server;
    if (sentinelAlertPostObject.sentinel_site_id) camerasObject[obj.id].sentinel.sentinel_site_id = sentinelAlertPostObject.sentinel_site_id;
    if (sentinelAlertPostObject.sentinel_device_address) camerasObject[obj.id].sentinel.sentinel_device_address = sentinelAlertPostObject.sentinel_device_address;
    if (sentinelAlertPostObject.draw_ignore_zones) camerasObject[obj.id].sentinel.draw_ignore_zones = sentinelAlertPostObject.draw_ignore_zones;
    const patriotAlertPostObject = JSON.parse(localStorage.patriotAlertPostObject || "{}");
    if (patriotAlertPostObject.patriot_server) camerasObject[obj.id].patriot.patriot_server = patriotAlertPostObject.patriot_server;
    if (patriotAlertPostObject.patriot_client_no) camerasObject[obj.id].patriot.patriot_client_no = patriotAlertPostObject.patriot_client_no;
    if (patriotAlertPostObject.patriot_username) camerasObject[obj.id].patriot.patriot_username = patriotAlertPostObject.patriot_username;
    if (patriotAlertPostObject.patriot_password) camerasObject[obj.id].patriot.patriot_password = patriotAlertPostObject.patriot_password;
    if (patriotAlertPostObject.patriot_zone_number) camerasObject[obj.id].patriot.patriot_zone_number = patriotAlertPostObject.patriot_zone_number;
    if (patriotAlertPostObject.patriot_type_number) camerasObject[obj.id].patriot.patriot_type_number = patriotAlertPostObject.patriot_type_number;
    if (patriotAlertPostObject.patriot_send_video) camerasObject[obj.id].patriot.patriot_send_video = patriotAlertPostObject.patriot_send_video;
    if (patriotAlertPostObject.draw_ignore_zones) camerasObject[obj.id].patriot.draw_ignore_zones = patriotAlertPostObject.draw_ignore_zones;
    // Evalink site-level fields are shared across cameras; alarm_zone_id is
    // per camera and intentionally not seeded (each camera's zone must be
    // entered deliberately — ENG-352).
    const evalinkAlertPostObject = JSON.parse(localStorage.evalinkAlertPostObject || "{}");
    if (evalinkAlertPostObject.evalink_token) camerasObject[obj.id].evalink.evalink_token = evalinkAlertPostObject.evalink_token;
    if (evalinkAlertPostObject.evalink_device_id) camerasObject[obj.id].evalink.evalink_device_id = evalinkAlertPostObject.evalink_device_id;
    if (evalinkAlertPostObject.evalink_company_id) camerasObject[obj.id].evalink.evalink_company_id = evalinkAlertPostObject.evalink_company_id;
    if (evalinkAlertPostObject.partition_id) camerasObject[obj.id].evalink.partition_id = evalinkAlertPostObject.partition_id;
    return obj.camera ? /*#__PURE__*/ (0, $k4ank.jsx)($8T3gX.Fragment, {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                    sx: {
                        fontFamily: "Mulish"
                    },
                    children: [
                        obj.camera_current_name && obj.camera_current_name !== obj.camera_name ? // The camera was renamed on the NVR: show the deployed (current)
                        // name struck through, then the new incoming name. Applying it is
                        // done via "Fix Camera Names" (keeps the camera id / device UID).
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "text-[#0000EE] hover:text-actuate-orange line-through",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                                        to: `/sites/${localStorage.siteId}/editcamera/${obj.camera}`,
                                        target: "_blank",
                                        children: obj.camera_current_name
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "text-[12px] text-gray-500",
                                    children: "New name:"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: obj.camera_name
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "text-[#0000EE] hover:text-actuate-orange",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                                to: `/sites/${localStorage.siteId}/editcamera/${obj.camera}`,
                                target: "_blank",
                                children: obj.camera_name
                            })
                        }),
                        (0, $2844b9177f6f3f6b$export$be98998873c77329)(obj) && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "text-[12px] text-gray-500 italic",
                            children: [
                                "Old server: ",
                                obj.camera_current_recording_server
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    sx: {
                        fontFamily: "Mulish"
                    },
                    children: obj.nvr_id
                }),
                additionalFieldNamesArray && additionalFieldNamesArray.length > 0 ? additionalFieldNamesArray.map((object)=>{
                    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                        sx: {
                            fontFamily: "Mulish"
                        },
                        children: (0, $ad162c242e35003e$export$36bfae36e6dd07ae)(object.type, object.id, obj, largerScreen)
                    }, object.id);
                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}),
                genetecStreamSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    sx: {
                        fontFamily: "Mulish"
                    },
                    children: "--"
                }),
                selectedProducts.map((productName)=>{
                    const name = `${productName}${obj.id}`;
                    return /*#__PURE__*/ (0, $k4ank.jsx)($8T3gX.Fragment, {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {})
                        })
                    }, productName);
                }),
                immixSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {})
                }),
                immixSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {})
                }),
                sureViewSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {})
                }),
                sureViewSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {})
                }),
                diceSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {})
                }),
                diceSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {})
                }),
                evalinkSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {})
                })
            ]
        })
    }, obj.id) : /*#__PURE__*/ (0, $k4ank.jsx)($8T3gX.Fragment, {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    sx: {
                        fontFamily: "Mulish"
                    },
                    children: obj.camera_name
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    sx: {
                        fontFamily: "Mulish"
                    },
                    children: obj.nvr_id
                }),
                additionalFieldNamesArray && additionalFieldNamesArray.length > 0 ? additionalFieldNamesArray.map((object)=>{
                    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                        sx: {
                            fontFamily: "Mulish"
                        },
                        children: (0, $ad162c242e35003e$export$36bfae36e6dd07ae)(object.type, object.id, obj, largerScreen)
                    }, object.id);
                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}),
                genetecStreamSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    sx: {
                        fontFamily: "Mulish"
                    },
                    children: (0, $6eb51f05503e8a27$export$22b2e93233949012)(obj).length > 0 ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        id: `genetecStream${obj.id}`,
                        select: true,
                        variant: "standard",
                        sx: {
                            minWidth: 240
                        },
                        inputProps: {
                            "aria-label": `Stream for ${obj.camera_name}`
                        },
                        value: (0, $6eb51f05503e8a27$export$d5d3e2f9cd3a0b33)(camerasObject, obj.id),
                        onChange: (event)=>(0, $6eb51f05503e8a27$export$12b9a5254d0112fb)(setCamerasObject, event.target.value, obj.id),
                        children: (0, $6eb51f05503e8a27$export$22b2e93233949012)(obj).map(([label, value])=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                value: value,
                                children: label
                            }, value || "auto"))
                    }) : "Auto"
                }),
                selectedProducts.map((productName)=>{
                    const name = `${productName}${obj.id}`;
                    const selectedProductIds = camerasObject?.[obj.id]?.products || [];
                    const productId = (0, $471d518762e7af5e$export$8744c2893a65a5bc)("Id", productName, productsArray);
                    const disabledByConflict = productId !== undefined && productId !== null && (0, $2cdc286d7222c539$export$9a3d8fc14dd5f8c9)(selectedProductIds, productsArray).has(productId);
                    return /*#__PURE__*/ (0, $k4ank.jsx)($8T3gX.Fragment, {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                    checked: Boolean(checkboxesChecked[name]),
                                    color: "primary",
                                    disabled: disabledByConflict,
                                    onClick: (event)=>{
                                        setCheckboxesChecked((previousState)=>{
                                            return {
                                                ...previousState,
                                                [name]: event.target.checked
                                            };
                                        });
                                        (0, $320890599a031ab1$export$3604bb5ed997fb8a)(productName, setCamerasObject, camerasObject, obj.id, event.target.checked, productsArray);
                                    }
                                }),
                                label: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                    sx: {
                                        fontFamily: "Mulish",
                                        fontSize: "14px"
                                    },
                                    children: productName
                                })
                            })
                        })
                    }, productName);
                }),
                immixSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                        id: "immixPortInput",
                        defaultValue: "",
                        value: "",
                        onChange: (event)=>{
                            (0, $24183b825f8ca9ac$export$e0710f738d4ba871)(setCamerasObject, camerasObject, event.target.value, obj.id);
                        },
                        helperText: "",
                        stylingWidth: 200,
                        label: "Immix Email",
                        error: false
                    })
                }),
                immixSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                        id: "immixInput1",
                        defaultValue: "",
                        value: "",
                        onChange: (event)=>{
                            (0, $baaa9165d4f9ae3c$export$97e3ebff0644dab4)(setCamerasObject, camerasObject, event.target.value, obj.id);
                        },
                        helperText: "",
                        stylingWidth: 100,
                        label: "Immix input 1",
                        error: false
                    })
                }),
                sureViewSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                        id: "sureViewEmail",
                        defaultValue: "",
                        value: "",
                        onChange: (event)=>{
                            (0, $5db882ded2483122$export$70069f6b0fdcaadf)(setCamerasObject, camerasObject, event.target.value, obj.id);
                        },
                        helperText: "",
                        stylingWidth: 200,
                        label: "Sureview Email",
                        error: false
                    })
                }),
                sureViewSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                        id: "sureViewCC",
                        defaultValue: "",
                        value: "",
                        onChange: (event)=>{
                            (0, $e0ec7b6c2fb7f8c9$export$e9d21c509adf2c17)(setCamerasObject, camerasObject, event.target.value, obj.id);
                        },
                        helperText: "",
                        stylingWidth: 200,
                        label: "Sureview cc",
                        error: false
                    })
                }),
                diceSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                        id: "diceEmail",
                        defaultValue: "",
                        value: "",
                        onChange: (event)=>{
                            (0, $8941a3d3b533e314$export$113e0ad827f5ec14)(setCamerasObject, camerasObject, event.target.value, obj.id);
                        },
                        helperText: "",
                        stylingWidth: 200,
                        label: "Dice Email",
                        error: false
                    })
                }),
                diceSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                        id: "diceInput1",
                        defaultValue: "",
                        value: "",
                        onChange: (event)=>{
                            (0, $9be8edf253b6dd2c$export$43b6f40d8d72fe1e)(setCamerasObject, camerasObject, event.target.value, obj.id);
                        },
                        helperText: "",
                        stylingWidth: 100,
                        label: "Dice input 1",
                        error: false
                    })
                }),
                evalinkSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                        id: "evalinkAlarmZoneId",
                        defaultValue: "",
                        value: "",
                        onChange: (event)=>{
                            (0, $28ef544f83a091a4$export$b9c8d142e906be5d)(setCamerasObject, camerasObject, event.target.value, obj.id, "alarmZoneId");
                        },
                        helperText: "",
                        stylingWidth: 150,
                        label: "Alarm Zone ID",
                        error: false
                    })
                })
            ]
        })
    }, obj.id);
}, (prevProps, nextProps)=>{
    // Re-render if the row object itself changed
    if (prevProps.obj !== nextProps.obj) return false;
    // Re-render if selected products changed
    // Optimize: only re-render if the array contents actually changed, not just the reference
    if (prevProps.selectedProducts !== nextProps.selectedProducts) {
        // Check if arrays have different lengths
        if (prevProps.selectedProducts.length !== nextProps.selectedProducts.length) return false;
        // Check if any product was added or removed
        const prevSet = new Set(prevProps.selectedProducts);
        const nextSet = new Set(nextProps.selectedProducts);
        if (prevSet.size !== nextSet.size) return false;
        for (const product of prevSet){
            if (!nextSet.has(product)) return false;
        }
        // Arrays have same contents, skip re-render
        return true;
    }
    // Re-render if other important props changed
    if (prevProps.additionalFieldNamesArray !== nextProps.additionalFieldNamesArray || prevProps.immixSite !== nextProps.immixSite || prevProps.diceSite !== nextProps.diceSite || prevProps.sureViewSite !== nextProps.sureViewSite || prevProps.evalinkSite !== nextProps.evalinkSite || prevProps.largerScreen !== nextProps.largerScreen || prevProps.genetecStreamSite !== nextProps.genetecStreamSite) return false;
    // Check if camerasObject changed for this specific row
    const rowId = prevProps.obj.id;
    if (prevProps.camerasObject[rowId] !== nextProps.camerasObject[rowId]) return false;
    // Most importantly: check if any checkbox values for this specific row have changed
    // Only check the checkboxes relevant to this row, not the entire object
    const rowIdStr = String(rowId);
    for (const productName of prevProps.selectedProducts){
        const checkboxName = `${productName}${rowIdStr}`;
        const prevChecked = Boolean(prevProps.checkboxesChecked[checkboxName]);
        const nextChecked = Boolean(nextProps.checkboxesChecked[checkboxName]);
        if (prevChecked !== nextChecked) return false; // Checkbox value changed, should re-render
    }
    // If checkboxesChecked object reference changed, only re-render if values for this row changed
    // This is the key optimization - we don't re-render if other rows' checkboxes changed
    if (prevProps.checkboxesChecked !== nextProps.checkboxesChecked) {
        // Check if any checkbox for this specific row changed
        for (const productName of prevProps.selectedProducts){
            const checkboxName = `${productName}${rowIdStr}`;
            if (prevProps.checkboxesChecked[checkboxName] !== nextProps.checkboxesChecked[checkboxName]) return false; // This row's checkbox changed
        }
        // If reference changed but this row's values are the same, skip re-render
        return true;
    }
    return true; // No changes detected, skip re-render
});
$9151e83927c89871$var$TableRowMemo.displayName = "TableRowMemo";
const $9151e83927c89871$export$b880830c492984f5 = ({ camerasList: camerasList, selectedProducts: selectedProducts, camerasObject: camerasObject, setCamerasObject: setCamerasObject, checkboxesChecked: checkboxesChecked, setCheckboxesChecked: setCheckboxesChecked, additionalFieldNamesArray: additionalFieldNamesArray, immixSite: immixSite, diceSite: diceSite, sureViewSite: sureViewSite, productsArray: productsArray, sentinelSite: sentinelSite, patriotSite: patriotSite, evalinkSite: evalinkSite, setCamerasList: setCamerasList, largerScreen: largerScreen, hanwhaSite: hanwhaSite })=>{
    const { moreDataToLoadAutoAdd: moreDataToLoadAutoAdd, setMoreDataToLoadAutoAdd: setMoreDataToLoadAutoAdd, loadingMoreAutoAddData: loadingMoreAutoAddData, setLoadingMoreAutoAddData: setLoadingMoreAutoAddData, columnSpan: columnSpan, setColumnSpan: setColumnSpan, page: page, setPage: setPage, rowsPerPage: rowsPerPage, setRowsPerPage: setRowsPerPage, totalCamerasPerAPIResponse: totalCamerasPerAPIResponse } = (0, $a4d6ac0c9ead9c31$export$2b7358df2c708c72)();
    // Genetec sites with a stream probe get a per-camera Stream picker (ENG-2043).
    const genetecStreamSite = (0, $6eb51f05503e8a27$export$9f3fc2ae6a9b671b)(camerasList?.results);
    $8T3gX.useEffect(()=>{
        // Base columns (camera name + device id + spacing) plus one per selected
        // product. Each alarm type that renders per-camera columns adds two
        // (email + input1/cc); Evalink adds one (alarm zone id); the Genetec
        // Stream picker adds one.
        let span = 4 + selectedProducts.length + (genetecStreamSite ? 1 : 0);
        if (immixSite) span += 2;
        if (sureViewSite) span += 2;
        if (diceSite) span += 2;
        if (evalinkSite) span += 1;
        setColumnSpan(span);
    }, [
        selectedProducts,
        immixSite,
        sureViewSite,
        diceSite,
        evalinkSite,
        genetecStreamSite,
        setColumnSpan
    ]);
    // Reset to first page if current page is out of bounds
    $8T3gX.useEffect(()=>{
        const maxPage = Math.max(0, Math.ceil(camerasList.results.length / rowsPerPage) - 1);
        if (page > maxPage) setPage(0);
    }, [
        camerasList.results.length,
        rowsPerPage,
        page,
        setPage
    ]);
    const navigate = (0, $3T949.useNavigate)();
    // Memoize the header checkbox handler to prevent unnecessary re-renders
    const handleHeaderCheckboxChange = $8T3gX.useCallback((productName)=>{
        return (event)=>{
            const checked = event.target.checked;
            setCheckboxesChecked((previousState)=>{
                return {
                    ...previousState,
                    [productName]: checked
                };
            });
            (0, $5795c0d73879d0d7$export$903c7efd8f42ee6d)(camerasObject, setCamerasObject, productName, checked, checkboxesChecked, setCheckboxesChecked, productsArray);
        };
    }, [
        camerasObject,
        setCamerasObject,
        checkboxesChecked,
        setCheckboxesChecked,
        productsArray
    ]);
    // Memoize the table head to prevent unnecessary re-renders
    const EnhancedTableHead = $8T3gX.useMemo(()=>{
        return /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold",
                            minWidth: 200
                        },
                        children: "Camera Name"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold"
                        },
                        children: "Device ID"
                    }),
                    additionalFieldNamesArray && additionalFieldNamesArray.length > 0 ? additionalFieldNamesArray.map((object)=>{
                        return /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                            sx: {
                                fontFamily: "Mulish",
                                fontWeight: "Bold"
                            },
                            children: object.label
                        }, object.id);
                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}),
                    genetecStreamSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold"
                        },
                        children: "Stream"
                    }),
                    selectedProducts.map((productName)=>{
                        return /*#__PURE__*/ (0, $k4ank.jsx)($8T3gX.Fragment, {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                padding: "checkbox",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                    sx: {
                                        fontFamily: "Mulish",
                                        width: 135
                                    },
                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                        checked: checkboxesChecked[productName],
                                        color: "primary",
                                        onChange: handleHeaderCheckboxChange(productName)
                                    }),
                                    label: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                        sx: {
                                            fontFamily: "Mulish",
                                            fontSize: "14px",
                                            fontWeight: "Bold"
                                        },
                                        children: productName
                                    })
                                })
                            })
                        }, productName);
                    }),
                    immixSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold"
                        },
                        children: "Immix Email"
                    }),
                    immixSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold"
                        },
                        children: `Immix input 1 (optional)`
                    }),
                    sureViewSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold"
                        },
                        children: `Sureview Email`
                    }),
                    sureViewSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold"
                        },
                        children: `Sureview cc`
                    }),
                    diceSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold"
                        },
                        children: "Dice Email"
                    }),
                    diceSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold"
                        },
                        children: `Dice input 1 (optional)`
                    }),
                    evalinkSite && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: "Bold"
                        },
                        children: "Evalink Alarm Zone ID"
                    })
                ]
            })
        });
    }, [
        additionalFieldNamesArray,
        selectedProducts,
        checkboxesChecked,
        handleHeaderCheckboxChange,
        immixSite,
        diceSite,
        sureViewSite,
        evalinkSite,
        genetecStreamSite
    ]);
    // Calculate pagination
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const paginatedResults = camerasList.results.slice(startIndex, endIndex);
    const isLastPage = endIndex >= camerasList.results.length;
    const shouldShowLoadMore = moreDataToLoadAutoAdd && isLastPage;
    // Memoize table rows to prevent unnecessary re-renders
    // Note: We include checkboxesChecked and camerasObject in dependencies
    // because rows need to reflect their current state, but React.memo on TableRowMemo
    // will prevent individual rows from re-rendering unless their specific props change
    const tableRows = $8T3gX.useMemo(()=>{
        return paginatedResults.map((obj)=>/*#__PURE__*/ (0, $k4ank.jsx)($9151e83927c89871$var$TableRowMemo, {
                obj: obj,
                selectedProducts: selectedProducts,
                additionalFieldNamesArray: additionalFieldNamesArray,
                checkboxesChecked: checkboxesChecked,
                setCheckboxesChecked: setCheckboxesChecked,
                setCamerasObject: setCamerasObject,
                camerasObject: camerasObject,
                productsArray: productsArray,
                immixSite: immixSite,
                diceSite: diceSite,
                sureViewSite: sureViewSite,
                evalinkSite: evalinkSite,
                largerScreen: largerScreen,
                genetecStreamSite: genetecStreamSite
            }, obj.id));
    }, [
        paginatedResults,
        selectedProducts,
        additionalFieldNamesArray,
        // Use a more stable reference check - only recreate if the object keys/values for visible rows changed
        checkboxesChecked,
        camerasObject,
        productsArray,
        immixSite,
        diceSite,
        sureViewSite,
        evalinkSite,
        largerScreen,
        genetecStreamSite,
        setCheckboxesChecked,
        setCamerasObject
    ]);
    const handleChangePage = $8T3gX.useCallback((event, newPage)=>{
        setPage(newPage);
    }, [
        setPage
    ]);
    const handleChangeRowsPerPage = $8T3gX.useCallback((event)=>{
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    }, [
        setRowsPerPage,
        setPage
    ]);
    const shouldLimitHeight = immixSite || diceSite || sureViewSite || sentinelSite || patriotSite || evalinkSite || hanwhaSite;
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                style: shouldLimitHeight ? // table (server/port, ignore-zone toggle, etc.), so cap the table
                // and give it its own scroll to keep those reachable. Use a
                // viewport-relative height (not a fixed 350px) so the table grows
                // with the window instead of stranding rows on tall screens; the
                // 340px reserves the nav/toolbar above and the config block below.
                {
                    maxHeight: "calc(100vh - 340px)",
                    minHeight: "350px",
                    overflowY: "auto"
                } : {},
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                    stickyHeader: true,
                    "aria-label": "sticky table",
                    children: [
                        EnhancedTableHead,
                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $gXvgZ.default), {
                            children: [
                                tableRows,
                                shouldShowLoadMore && /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        colSpan: columnSpan,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "flex justify-center",
                                            children: loadingMoreAutoAddData ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                                color: "primary"
                                            }) : /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                className: "flex flex-col items-center gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                                        className: "text-center text-sm text-gray-500",
                                                        children: [
                                                            " ",
                                                            camerasList.results.length,
                                                            " cameras loaded of",
                                                            " ",
                                                            totalCamerasPerAPIResponse,
                                                            " total cameras"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                        onClick: ()=>{
                                                            setLoadingMoreAutoAddData(true);
                                                            (0, $2bce7a63b3b30c9d$export$93479f6cc51139d3)(setCamerasList, setCamerasObject, navigate, productsArray, setCheckboxesChecked, checkboxesChecked);
                                                        },
                                                        text: totalCamerasPerAPIResponse - camerasList.results.length >= 100 ? "Load Next 100 Cameras" : `Load Next ${totalCamerasPerAPIResponse - camerasList.results.length} Cameras`,
                                                        disabled: false
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wcxl.default), {
                rowsPerPageOptions: [
                    10,
                    25,
                    50
                ],
                component: "div",
                count: camerasList.results.length,
                rowsPerPage: rowsPerPage,
                page: page,
                onPageChange: handleChangePage,
                onRowsPerPageChange: handleChangeRowsPerPage
            })
        ]
    });
};



var $8jTCz = parcelRequire("8jTCz");

const $1fa43aac1fc2c060$export$949f7b925aba1352 = (camerasObject, setCamerasObject, inputString)=>{
    // Update localStorage first so AutoAddTable doesn't overwrite our changes
    const immixAlertPostObject = JSON.parse(localStorage.immixAlertPostObject || "{}");
    immixAlertPostObject.immix_server = inputString;
    localStorage.setItem("immixAlertPostObject", JSON.stringify(immixAlertPostObject));
    // Create a deep copy of the camerasObject to ensure React detects the change
    const newCamerasObject = {
        ...camerasObject
    };
    for(const key in camerasObject){
        newCamerasObject[key] = {
            ...camerasObject[key],
            immix: {
                ...camerasObject[key].immix
            }
        };
        newCamerasObject[key].immix.immix_server = inputString;
    }
    setCamerasObject(newCamerasObject);
};


const $197b38236d96da4a$export$767edeb86a59daf7 = (camerasObject, setCamerasObject, inputString)=>{
    // Update localStorage first so AutoAddTable doesn't overwrite our changes
    const immixAlertPostObject = JSON.parse(localStorage.immixAlertPostObject || "{}");
    immixAlertPostObject.immix_port = inputString;
    localStorage.setItem("immixAlertPostObject", JSON.stringify(immixAlertPostObject));
    // Create a deep copy of the camerasObject to ensure React detects the change
    const newCamerasObject = {
        ...camerasObject
    };
    for(const key in camerasObject){
        newCamerasObject[key] = {
            ...camerasObject[key],
            immix: {
                ...camerasObject[key].immix
            }
        };
        newCamerasObject[key].immix.immix_port = inputString;
    }
    setCamerasObject(newCamerasObject);
};


const $60f8b4d0f2c992b9$export$c80e064a3f45bf73 = (camerasObject, setCamerasObject, inputString)=>{
    // Update localStorage first so AutoAddTable doesn't overwrite our changes
    const diceAlertPostObject = JSON.parse(localStorage.diceAlertPostObject || "{}");
    diceAlertPostObject.dice_server = inputString;
    localStorage.setItem("diceAlertPostObject", JSON.stringify(diceAlertPostObject));
    // Create a deep copy of the camerasObject to ensure React detects the change
    const newCamerasObject = {
        ...camerasObject
    };
    for(const key in camerasObject){
        newCamerasObject[key] = {
            ...camerasObject[key],
            dice: {
                ...camerasObject[key].dice
            }
        };
        newCamerasObject[key].dice.dice_server = inputString;
    }
    setCamerasObject(newCamerasObject);
};


const $fbf953b87034d063$export$448ca91ebdf560eb = (camerasObject, setCamerasObject, inputString)=>{
    // Update localStorage first so AutoAddTable doesn't overwrite our changes
    const diceAlertPostObject = JSON.parse(localStorage.diceAlertPostObject || "{}");
    diceAlertPostObject.dice_port = inputString;
    localStorage.setItem("diceAlertPostObject", JSON.stringify(diceAlertPostObject));
    // Create a deep copy of the camerasObject to ensure React detects the change
    const newCamerasObject = {
        ...camerasObject
    };
    for(const key in camerasObject){
        newCamerasObject[key] = {
            ...camerasObject[key],
            dice: {
                ...camerasObject[key].dice
            }
        };
        newCamerasObject[key].dice.dice_port = inputString;
    }
    setCamerasObject(newCamerasObject);
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");


var $195EM = parcelRequire("195EM");

var $815yO = parcelRequire("815yO");


const $84e814737f81e294$export$486cad066e8d835f = (camerasObject)=>{
    const returnObject = {
        items: []
    };
    const localProducts = JSON.parse(localStorage.products || "[]");
    const productsArray = localProducts.map((product)=>[
            product.name,
            product.id
        ]);
    const sanitizeProductsForCamera = (productIds)=>{
        const sanitized = [];
        productIds.forEach((productId)=>{
            const blockedForCurrent = (0, $2cdc286d7222c539$export$9a3d8fc14dd5f8c9)(sanitized, productsArray);
            if (!blockedForCurrent.has(productId)) sanitized.push(productId);
        });
        return sanitized;
    };
    for(const key in camerasObject){
        if (key !== "objectId" && key !== "key" && camerasObject[key].products[0]) {
            if (!camerasObject[key].camera) {
                const sanitizedProducts = sanitizeProductsForCamera(camerasObject[key].products);
                if (sanitizedProducts[0]) returnObject.items.push({
                    ...camerasObject[key],
                    products: sanitizedProducts
                });
            }
        }
    }
    return returnObject;
};




var $3Zv1D = parcelRequire("3Zv1D");


var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $3GvXV = parcelRequire("3GvXV");

var $jyh06 = parcelRequire("jyh06");
const $d998a79d863f8a3b$export$7f80b2a231beea61 = ({ siteId: siteId, onDone: onDone, navigate: navigate, pollOptions: pollOptions, lookupTimeoutMs: lookupTimeoutMs = 10000 })=>{
    const [setup, setSetup] = $8T3gX.useState(null);
    const doneRef = $8T3gX.useRef(false);
    const onDoneRef = $8T3gX.useRef(onDone);
    onDoneRef.current = onDone;
    const finish = $8T3gX.useCallback(()=>{
        if (doneRef.current) return;
        doneRef.current = true;
        setSetup(null);
        onDoneRef.current();
    }, []);
    $8T3gX.useEffect(()=>{
        const controller = new AbortController();
        // Never hold up onboarding on a slow admin: give up and move on.
        const giveUp = setTimeout(()=>{
            controller.abort();
            finish();
        }, lookupTimeoutMs);
        (0, $jyh06.fetchGenetecAlarmSetup)(siteId, controller.signal).then((data)=>{
            clearTimeout(giveUp);
            if (controller.signal.aborted) return;
            if ((0, $jyh06.shouldPromptGenetecAlarmSetup)(data)) setSetup(data);
            else finish();
        }, ()=>{
            clearTimeout(giveUp);
            if (!controller.signal.aborted) finish();
        });
        return ()=>{
            clearTimeout(giveUp);
            controller.abort();
        };
    }, [
        siteId,
        finish,
        lookupTimeoutMs
    ]);
    if (!setup) return null;
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3GvXV.GenetecAlarmSetupDialog), {
        open: true,
        siteId: siteId,
        setup: setup,
        onClose: finish,
        navigate: navigate,
        pollOptions: pollOptions
    });
};


// How long "Camera Add successful!" shows before the flow moves on.
const $be6604b7aaa96627$var$SUCCESS_SCREEN_MS = 2000;
const $be6604b7aaa96627$export$9429a4eadaf8fb7 = async (camerasObject, setVisibleScreen, setLargerScreen, largerScreen, setCameraCheckFinsihedAlertOpen, setGoodCameras, setConnectivityCameras, setLowResolutionCameras, setCameraCheckResultDownloadURL, sentinelSite, patriotSite, streamChangesMade, streamPatchObject, navigate)=>{
    const retryFunction = ()=>{
        $be6604b7aaa96627$export$9429a4eadaf8fb7(camerasObject, setVisibleScreen, setLargerScreen, largerScreen, setCameraCheckFinsihedAlertOpen, setGoodCameras, setConnectivityCameras, setLowResolutionCameras, setCameraCheckResultDownloadURL, sentinelSite, patriotSite, streamChangesMade, streamPatchObject, navigate);
    };
    setLargerScreen(false);
    setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $f05a511d40a0fd8d$export$3c049d782df88a0e), {
        styling: "absolute first-line:font-black font-mulish text-[20px] right-[150px] text-center text-[#283E6D] top-80",
        text: /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
            children: [
                "Camera Add in process.",
                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                "This might take a few seconds."
            ]
        })
    }));
    const AxiosUI = (0, $195EM.createApi)(``);
    const ActuateUI = (0, $195EM.createApi)(``);
    let nvrCameraFetchFail = false;
    let siteCamerasFetchFail = false;
    const sentinelCamsWithErrors = [];
    const patriotCamsWithErrors = [];
    const sentinelAlertObject = Object.keys(camerasObject).length > 0 ? camerasObject[Object.keys(camerasObject)[0]].sentinel : {
        sentinel_server: "",
        sentinel_site_id: "",
        sentinel_device_address: "",
        draw_ignore_zones: false
    };
    const patriotAlertObject = Object.keys(camerasObject).length > 0 ? camerasObject[Object.keys(camerasObject)[0]].patriot : {
        patriot_server: "",
        patriot_client_no: "",
        patriot_username: "",
        patriot_password: "",
        patriot_zone_number: "",
        patriot_type_number: "",
        patriot_send_video: false,
        draw_ignore_zones: false
    };
    const createNewStreamsObject = (streams)=>{
        const updatedStreams = streams;
        updatedStreams.forEach((object, index)=>{
            const updatedSentinelAlerts = object.sentinel_alerts;
            updatedSentinelAlerts.push(sentinelAlertObject);
            updatedStreams[index].sentinel_alerts = updatedSentinelAlerts;
        });
        return updatedStreams;
    };
    const createNewStreamsObjectPatriot = (streams)=>{
        const updatedStreams = streams;
        updatedStreams.forEach((object, index)=>{
            const updatedPatriotAlerts = object.patriot_alerts || [];
            updatedPatriotAlerts.push(patriotAlertObject);
            updatedStreams[index].patriot_alerts = updatedPatriotAlerts;
        });
        return updatedStreams;
    };
    const streamPatchErrorsCameras = [];
    const postSentinelAlert = (cameraId, streamsObject, cameraName, lastCamera)=>{
        AxiosUI.patch(`/camera/${cameraId}/general_info/`, {
            streams: createNewStreamsObject(streamsObject)
        }).then(()=>{
            if (lastCamera) {
                if (sentinelCamsWithErrors.length > 0) alert(`The following cameras had errors in adding the Sentinel alert: ${sentinelCamsWithErrors.join(", ")}`);
            }
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                sentinelCamsWithErrors.push(cameraName);
                if (lastCamera) {
                    if (sentinelCamsWithErrors.length > 0) alert(`The following cameras had errors in adding the Sentinel alert: ${sentinelCamsWithErrors.join(", ")}`);
                }
            });
        });
    };
    const postPatriotAlert = (cameraId, streamsObject, cameraName, lastCamera)=>{
        AxiosUI.patch(`/camera/${cameraId}/general_info/`, {
            streams: createNewStreamsObjectPatriot(streamsObject)
        }).then(()=>{
            if (lastCamera) {
                if (patriotCamsWithErrors.length > 0) alert(`The following cameras had errors in adding the Patriot alert: ${patriotCamsWithErrors.join(", ")}`);
            }
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                patriotCamsWithErrors.push(cameraName);
                if (lastCamera) {
                    if (patriotCamsWithErrors.length > 0) alert(`The following cameras had errors in adding the Patriot alert: ${patriotCamsWithErrors.join(", ")}`);
                }
            });
        });
    };
    await AxiosUI.post("/nvr_camera/auto_add/", (0, $84e814737f81e294$export$486cad066e8d835f)(camerasObject)).then((response)=>{
        nvrCameraFetchFail = false;
        localStorage.setItem("cameraId", response.data.id);
    }, (reason)=>{
        nvrCameraFetchFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            localStorage.setItem("autoAddError", "true");
            // setLargerScreen(true);
            setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $3e7ad1fea613135d$export$93fc82c3a3170234), {
                setVisibleScreen: setVisibleScreen,
                setLargerScreen: setLargerScreen,
                largerScreen: largerScreen,
                setCameraCheckFinsihedAlertOpen: setCameraCheckFinsihedAlertOpen,
                setGoodCameras: setGoodCameras,
                setConnectivityCameras: setConnectivityCameras,
                setLowResolutionCameras: setLowResolutionCameras,
                setCameraCheckResultDownloadURL: setCameraCheckResultDownloadURL
            }));
        });
    });
    !nvrCameraFetchFail && await ActuateUI.get(`camera/site/?customer__id=${localStorage.siteId}`).then((response)=>{
        siteCamerasFetchFail = false;
        localStorage.setItem("siteCameras", JSON.stringify(response.data));
        const cameraResults = response.data.results;
        if (cameraResults.length > 0 && sentinelSite) cameraResults.forEach((camera, index)=>{
            AxiosUI.get(`camera/${camera.id}/general_info/`).then((responseTwo)=>{
                const streams = responseTwo.data.streams;
                postSentinelAlert(camera.id, streams, camera.camera_name, cameraResults.length === index + 1);
            }, (reason)=>{
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
            });
        });
        if (cameraResults.length > 0 && patriotSite) cameraResults.forEach((camera, index)=>{
            AxiosUI.get(`camera/${camera.id}/general_info/`).then((responseTwo)=>{
                const streams = responseTwo.data.streams;
                postPatriotAlert(camera.id, streams, camera.camera_name, cameraResults.length === index + 1);
            }, (reason)=>{
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
            });
        });
        if (cameraResults.length > 0 && streamChangesMade) cameraResults.forEach((camera, index)=>{
            AxiosUI.patch(`camera/${camera.id}/extra_fields/`, streamPatchObject).then(()=>{
                if (cameraResults.length === index + 1) {
                    if (streamPatchErrorsCameras.length > 0) alert(`The following cameras had errors in adding the stream parameters: ${streamPatchErrorsCameras.join(", ")}`);
                }
            }, (reason)=>{
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    streamPatchErrorsCameras.push(camera.camera_name);
                    if (cameraResults.length === index + 1) {
                        if (streamPatchErrorsCameras.length > 0) alert(`The following cameras had errors in adding the stream parameters: ${streamPatchErrorsCameras.join(", ")}`);
                    }
                });
            });
        });
    }, (reason)=>{
        siteCamerasFetchFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
    });
    if (!nvrCameraFetchFail && !siteCamerasFetchFail) {
        // Auto-add no longer auto-syncs. Mark the site as having unsynced changes;
        // the operator syncs explicitly (the About-page Sync control shows the
        // unsynced state on arrival).
        (0, $815yO.markSiteUnsynced)();
        const successScreen = /*#__PURE__*/ (0, $k4ank.jsx)((0, $f05a511d40a0fd8d$export$3c049d782df88a0e), {
            styling: "absolute first-line:font-black font-mulish text-[20px] right-[190px] text-center text-[#283E6D] top-80",
            text: "Camera Add successful!"
        });
        const continueFlow = ()=>{
            if (localStorage.addAdditionalCamera === "true" || localStorage.clickedFromSiteAboutPage === "true") {
                if ((0, $1444c94c32ef2738$export$79b714ae571551b5)()) {
                    localStorage.setItem("cameraCheckAlertOpen", "true");
                    localStorage.setItem("clickedId", localStorage.siteId);
                    localStorage.setItem("navigatedFromSitesAboutPage", "true");
                    localStorage.setItem("level0Click", "true");
                    localStorage.setItem("cameraChecksiteId", localStorage.siteId);
                    (0, $37903a6140fe6ab4$export$82756491d6fa579)(setCameraCheckFinsihedAlertOpen, setGoodCameras, setConnectivityCameras, setLowResolutionCameras, localStorage.siteId, setCameraCheckResultDownloadURL, navigate);
                }
                navigate(`/sites/aboutsite/${localStorage.siteId}`);
                localStorage.removeItem("addAdditionalCamera");
            } else if (localStorage.healthcheckOnly === "true") {
                // setVisibleScreen(<ProgressFinishedScreen />);
                navigate(`/sites/aboutsite/${localStorage.siteId}`);
                localStorage.setItem("healthcheckOnly", "false");
            } else setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $e4a2260e96905f88$export$770d5a29da7608e0), {
                percentage: (0, $1444c94c32ef2738$export$79b714ae571551b5)() ? localStorage.healthMonitoringOnly === "true" ? 66 : 50 : 66,
                step: 2,
                setVisibleScreen: setVisibleScreen
            }));
        };
        // ENG-2219: before moving on, offer to create the Security Center alarms
        // for a Genetec site. The prompt asks admin (GET genetec_alarm_setup)
        // whether there is anything to set up — it renders nothing and calls
        // onDone at once for non-Genetec sites, so the success screen still shows
        // for its usual 2 s. localStorage.integrationType can be stale here (it is
        // set by the site About page), so the backend's is_genetec decides.
        const shownAt = Date.now();
        setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
            children: [
                successScreen,
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $d998a79d863f8a3b$export$7f80b2a231beea61), {
                    siteId: localStorage.siteId,
                    navigate: navigate,
                    onDone: ()=>{
                        setTimeout(continueFlow, Math.max(0, $be6604b7aaa96627$var$SUCCESS_SCREEN_MS - (Date.now() - shownAt)));
                    }
                })
            ]
        }));
    }
};


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $b5aa1036eb73c18b$export$e2cea609f160409a = (camerasObject, setCamerasObject, inputString)=>{
    const newCamerasObject = camerasObject;
    for(const key in newCamerasObject)newCamerasObject[key].sureview.sureview_server = inputString;
    setCamerasObject(newCamerasObject);
};


const $e8a5855e0625295f$export$2fb67fb4418ec47c = (camerasObject, setCamerasObject, inputString)=>{
    const newCamerasObject = camerasObject;
    for(const key in newCamerasObject)newCamerasObject[key].sureview.sureview_subject = inputString;
    setCamerasObject(newCamerasObject);
};



var $3QMQN = parcelRequire("3QMQN");

var $9df30a3db5199d1b$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($9df30a3db5199d1b$exports, "__esModule", {
    value: true
});
$9df30a3db5199d1b$exports.default = void 0;

var $9df30a3db5199d1b$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $9df30a3db5199d1b$var$_default = $9df30a3db5199d1b$exports.default = (0, $9df30a3db5199d1b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "m22.7 19-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4"
}), 'Build');



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");


parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");


var $3Zv1D = parcelRequire("3Zv1D");


const $93f2e906b2eb061e$export$852ad47495ae4b22 = (setCamerasList, setCamerasObject, searchString, navigate, productsArray, setCheckboxesChecked, checkboxesChecked, currentSearchRef)=>{
    const retryFunction = ()=>{
        $93f2e906b2eb061e$export$852ad47495ae4b22(setCamerasList, setCamerasObject, searchString, navigate, productsArray, setCheckboxesChecked, checkboxesChecked, currentSearchRef);
    };
    const { setMoreDataToLoadAutoAdd: setMoreDataToLoadAutoAdd, setNvrNextString: setNvrNextString, setSearchingCameras: setSearchingCameras, setTotalCamerasPerAPIResponse: setTotalCamerasPerAPIResponse } = (0, $a4d6ac0c9ead9c31$export$2b7358df2c708c72).getState();
    // Reset all checkboxesChecked values to false when search is performed
    setCheckboxesChecked((previousState)=>{
        const resetState = {};
        // Set all existing keys to false
        Object.keys(previousState).forEach((key)=>{
            resetState[key] = false;
        });
        return resetState;
    });
    const AxiosUI = (0, $195EM.createApi)(``);
    AxiosUI.get(`nvr_camera/?customer__id=${localStorage.siteId}&search=${searchString}`).then((response)=>{
        // Only update state if this response matches the current search term
        if (!currentSearchRef || currentSearchRef.current === searchString) {
            setCamerasList(response.data);
            setTotalCamerasPerAPIResponse(response.data.count);
            setCamerasObject((0, $1527cf3e70fe5162$export$28aa6ff945d84e88)(response.data.results));
            setSearchingCameras(false);
            if (response.data.next) {
                setMoreDataToLoadAutoAdd(true);
                setNvrNextString(response.data.next.slice(response.data.next.indexOf("?")));
            } else setMoreDataToLoadAutoAdd(false);
            const nvrResults = response.data.results;
            AxiosUI.get(`nvr_camera/product/?customer__id=${localStorage.siteId}`).then((response)=>{
                const productResponse = response.data;
                const idsArray = [];
                productResponse.forEach((array)=>{
                    idsArray.push(array[1]);
                });
                idsArray.forEach((id)=>{
                    if ((0, $471d518762e7af5e$export$8744c2893a65a5bc)("Name", id, productResponse)) {
                        const name = (0, $471d518762e7af5e$export$8744c2893a65a5bc)("Name", id, productResponse);
                        setCheckboxesChecked((previousState)=>{
                            return {
                                ...previousState,
                                [name]: false
                            };
                        });
                        checkboxesChecked[name] = false;
                    }
                    nvrResults.forEach((object)=>{
                        if (!object.camera) {
                            const name = (0, $471d518762e7af5e$export$8744c2893a65a5bc)("Name", id, productResponse);
                            const newName = `${name}${object.id}`;
                            setCheckboxesChecked((previousState)=>{
                                return {
                                    ...previousState,
                                    [newName]: false
                                };
                            });
                        }
                    });
                });
            });
        }
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
    });
};



const $70f0d15999d305f6$export$126950802e8c305b = ({ setCamerasList: setCamerasList, setCamerasObject: setCamerasObject, navigate: navigate, productsArray: productsArray, setCheckboxesChecked: setCheckboxesChecked, checkboxesChecked: checkboxesChecked })=>{
    const [inputValue, setInputValue] = (0, $8T3gX.useState)("");
    const currentSearchRef = (0, $8T3gX.useRef)("");
    const { setSearchingCameras: setSearchingCameras } = (0, $a4d6ac0c9ead9c31$export$2b7358df2c708c72)();
    (0, $8T3gX.useEffect)(()=>{
        // Update the current search ref
        currentSearchRef.current = inputValue;
        const timer = setTimeout(()=>{
            // Only proceed if the input value hasn't changed
            if (currentSearchRef.current === inputValue) (0, $93f2e906b2eb061e$export$852ad47495ae4b22)(setCamerasList, setCamerasObject, inputValue, navigate, productsArray, setCheckboxesChecked, checkboxesChecked, currentSearchRef);
        }, 500);
        return ()=>clearTimeout(timer);
    }, [
        inputValue,
        setCamerasList,
        setCamerasObject,
        navigate,
        productsArray,
        setCheckboxesChecked
    ]);
    const handleChange = (event)=>{
        setSearchingCameras(true);
        setInputValue(event.target.value);
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $c9d4fba0d4c728e8$export$4b85d3515bd863a5), {
        sx: {
            width: 150
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $c9d4fba0d4c728e8$export$e9ad429a7452907b), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0f42bd3abae37cbe$exports))), {})
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $c9d4fba0d4c728e8$export$b030dc24f7f252a3), {
                value: inputValue,
                placeholder: "Search Cameras...",
                onChange: handleChange,
                inputProps: {
                    "aria-label": "search"
                }
            })
        ]
    });
};


parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");







var $3Zv1D = parcelRequire("3Zv1D");
const $233f08f65c7ba9a7$export$79a035a079a2f6fa = (setCamerasObject, camerasObject, inputString, inputBoolean, objectId, inputNameString)=>{
    // Update localStorage first so AutoAddTable doesn't overwrite our changes
    const sentinelAlertPostObject = JSON.parse(localStorage.sentinelAlertPostObject || "{}");
    if (inputNameString === "drawIgnoreZones") sentinelAlertPostObject.draw_ignore_zones = inputBoolean;
    if (inputNameString === "sentinelServer") sentinelAlertPostObject.sentinel_server = inputString;
    if (inputNameString === "sentinelSiteId") sentinelAlertPostObject.sentinel_site_id = inputString;
    if (inputNameString === "sentinelDeviceAddress") sentinelAlertPostObject.sentinel_device_address = inputString;
    localStorage.setItem("sentinelAlertPostObject", JSON.stringify(sentinelAlertPostObject));
    // Create a deep copy of the camerasObject to ensure React detects the change
    const newCamerasObject = {
        ...camerasObject
    };
    for(const key in camerasObject)newCamerasObject[key] = {
        ...camerasObject[key],
        sentinel: {
            ...camerasObject[key].sentinel
        }
    };
    if (objectId) {
        // Handle single object update
        if (inputNameString === "drawIgnoreZones") newCamerasObject[objectId].sentinel.draw_ignore_zones = inputBoolean;
        if (inputNameString === "sentinelServer") newCamerasObject[objectId].sentinel.sentinel_server = inputString;
        if (inputNameString === "sentinelSiteId") newCamerasObject[objectId].sentinel.sentinel_site_id = inputString;
        if (inputNameString === "sentinelDeviceAddress") newCamerasObject[objectId].sentinel.sentinel_device_address = inputString;
        setCamerasObject((previousState)=>{
            return {
                ...previousState,
                [objectId]: newCamerasObject[objectId]
            };
        });
    } else {
        // Handle all objects update
        if (inputNameString === "drawIgnoreZones") for(const key in newCamerasObject)newCamerasObject[key].sentinel.draw_ignore_zones = inputBoolean;
        if (inputNameString === "sentinelServer") for(const key in newCamerasObject)newCamerasObject[key].sentinel.sentinel_server = inputString;
        if (inputNameString === "sentinelSiteId") for(const key in newCamerasObject)newCamerasObject[key].sentinel.sentinel_site_id = inputString;
        if (inputNameString === "sentinelDeviceAddress") for(const key in newCamerasObject)newCamerasObject[key].sentinel.sentinel_device_address = inputString;
        setCamerasObject(newCamerasObject);
    }
};




const $21d07a178a41003b$export$f3abddc51de925b9 = (setCamerasList, setCamerasObject, setFetchingAutoAddData, checkboxesChecked, setCheckboxesChecked, setClientProducts, setImmixSite, setSureviewSite, setProductsArray, setAutoAddSiteInfo, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const { setMoreDataToLoadAutoAdd: setMoreDataToLoadAutoAdd, setNvrNextString: setNvrNextString, setTotalCamerasPerAPIResponse: setTotalCamerasPerAPIResponse } = (0, $a4d6ac0c9ead9c31$export$2b7358df2c708c72).getState();
    const retryFunction = ()=>{
        $21d07a178a41003b$export$f3abddc51de925b9(setCamerasList, setCamerasObject, setFetchingAutoAddData, checkboxesChecked, setCheckboxesChecked, setClientProducts, setImmixSite, setSureviewSite, setProductsArray, setAutoAddSiteInfo, navigate);
    };
    AxiosUI.get(`nvr_camera/?customer__id=${localStorage.siteId}`).then((response)=>{
        if (response.data.count === 0) localStorage.setItem("noAutoAddCamerasDialogOpen", "true");
        if (response.data.count > 0) {
            setTotalCamerasPerAPIResponse(response.data.count);
            localStorage.setItem("noAutoAddCamerasDialogOpen", "false");
        }
        if (response.data.next) {
            setMoreDataToLoadAutoAdd(true);
            setNvrNextString(response.data.next.slice(response.data.next.indexOf("?")));
        }
        setCamerasList(response.data);
        setCamerasObject((0, $1527cf3e70fe5162$export$28aa6ff945d84e88)(response.data.results));
        const createdCamerasObject = (0, $1527cf3e70fe5162$export$28aa6ff945d84e88)(response.data.results);
        const immixAlertPostObject = JSON.parse(localStorage.immixAlertPostObject);
        if (immixAlertPostObject.immix_server) (0, $1fa43aac1fc2c060$export$949f7b925aba1352)(createdCamerasObject, setCamerasObject, immixAlertPostObject.immix_server);
        if (immixAlertPostObject.immix_port) (0, $197b38236d96da4a$export$767edeb86a59daf7)(createdCamerasObject, setCamerasObject, immixAlertPostObject.immix_port);
        const diceAlertPostObject = JSON.parse(localStorage.diceAlertPostObject || "{}");
        if (diceAlertPostObject.dice_server) (0, $60f8b4d0f2c992b9$export$c80e064a3f45bf73)(createdCamerasObject, setCamerasObject, diceAlertPostObject.dice_server);
        if (diceAlertPostObject.dice_port) (0, $fbf953b87034d063$export$448ca91ebdf560eb)(createdCamerasObject, setCamerasObject, diceAlertPostObject.dice_port);
        const sentinelAlertPostObject = JSON.parse(localStorage.sentinelAlertPostObject);
        if (sentinelAlertPostObject.sentinel_server) (0, $233f08f65c7ba9a7$export$79a035a079a2f6fa)(setCamerasObject, createdCamerasObject, sentinelAlertPostObject.sentinel_server.toString(), false, null, "sentinelServer");
        if (sentinelAlertPostObject.sentinel_site_id) (0, $233f08f65c7ba9a7$export$79a035a079a2f6fa)(setCamerasObject, createdCamerasObject, sentinelAlertPostObject.sentinel_site_id.toString(), false, null, "sentinelSiteId");
        if (sentinelAlertPostObject.sentinel_device_address) (0, $233f08f65c7ba9a7$export$79a035a079a2f6fa)(setCamerasObject, createdCamerasObject, sentinelAlertPostObject.sentinel_device_address.toString(), false, null, "sentinelDeviceAddress");
        if (sentinelAlertPostObject.draw_ignore_zones) (0, $233f08f65c7ba9a7$export$79a035a079a2f6fa)(setCamerasObject, createdCamerasObject, "", sentinelAlertPostObject.draw_ignore_zones, null, "drawIgnoreZones");
        // Evalink: reseed site-level fields only; alarm_zone_id stays per
        // camera and is never carried over (ENG-352).
        const evalinkAlertPostObject = JSON.parse(localStorage.evalinkAlertPostObject || "{}");
        if (evalinkAlertPostObject.evalink_token) (0, $28ef544f83a091a4$export$b9c8d142e906be5d)(setCamerasObject, createdCamerasObject, evalinkAlertPostObject.evalink_token, null, "evalinkToken");
        if (evalinkAlertPostObject.evalink_device_id) (0, $28ef544f83a091a4$export$b9c8d142e906be5d)(setCamerasObject, createdCamerasObject, evalinkAlertPostObject.evalink_device_id, null, "evalinkDeviceId");
        if (evalinkAlertPostObject.evalink_company_id) (0, $28ef544f83a091a4$export$b9c8d142e906be5d)(setCamerasObject, createdCamerasObject, evalinkAlertPostObject.evalink_company_id, null, "evalinkCompanyId");
        if (evalinkAlertPostObject.partition_id) (0, $28ef544f83a091a4$export$b9c8d142e906be5d)(setCamerasObject, createdCamerasObject, evalinkAlertPostObject.partition_id, null, "partitionId");
        const nvrResults = response.data.results;
        AxiosUI.get(`nvr_camera/product/?customer__id=${localStorage.siteId}`).then((response)=>{
            const productResponse = response.data;
            setClientProducts(productResponse);
            setProductsArray(response.data);
            const productsArray = [];
            productResponse.forEach((array)=>{
                productsArray.push(array[0]);
            });
            setClientProducts(productsArray);
            const idsArray = [];
            productResponse.forEach((array)=>{
                idsArray.push(array[1]);
            });
            // Batch all checkbox state updates into a single update to prevent multiple re-renders
            const newCheckboxesState = {
                ...checkboxesChecked
            };
            idsArray.forEach((id)=>{
                if ((0, $471d518762e7af5e$export$8744c2893a65a5bc)("Name", id, productResponse)) {
                    const name = (0, $471d518762e7af5e$export$8744c2893a65a5bc)("Name", id, productResponse);
                    newCheckboxesState[name] = false;
                }
                nvrResults.forEach((object)=>{
                    if (!object.camera) {
                        const name = (0, $471d518762e7af5e$export$8744c2893a65a5bc)("Name", id, productResponse);
                        const newName = `${name}${object.id}`;
                        newCheckboxesState[newName] = false;
                    }
                });
            });
            // Single state update instead of multiple individual updates
            setCheckboxesChecked(newCheckboxesState);
            // if (localStorage.immixAlertsSite === "true") {
            //   setImmixSite(true);
            // }
            // if (localStorage.sureviewAlertsSite === "true") {
            //   setSureviewSite(true);
            // }
            AxiosUI.get(`customer/${localStorage.siteId}/about/`).then((response)=>{
                setAutoAddSiteInfo(response.data);
                setFetchingAutoAddData(false);
            }, (reason)=>{
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setAutoAddSiteInfo(localStorage.siteInfo ? JSON.parse(localStorage.siteInfo) : {});
                    setFetchingAutoAddData(false);
                });
            });
        }), (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                alert("Error retrieving data, please refresh and try again");
                setFetchingAutoAddData(false);
            });
        };
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setFetchingAutoAddData(false);
        });
    });
};


/**
 * Products to pre-select in the auto-add "Products" box.
 *
 * The per-product checkbox columns only appear once a product is selected, so
 * an empty box leaves no way to pick cameras (a Genetec operator hit this on
 * 2026-10-05 and deployed an empty site). Never selects every product by
 * default — that would add detection the customer didn't choose.
 *
 * - The site's own onboarding products (ids), when any are on offer.
 * - Otherwise the only product, when the site offers exactly one.
 * - Otherwise nothing (the operator chooses).
 *
 * @param productPairs `[name, id]` pairs from `nvr_camera/product/`
 * @param siteProductIds the site's onboarding product ids
 *   (`customer/{id}/camera_onboarding_forms/` → `initial_data.products`)
 */ const $23704bc81f77767a$export$c9e981d7ab9ad5c9 = (productPairs, siteProductIds)=>{
    if (!Array.isArray(productPairs) || productPairs.length === 0) return [];
    const pairs = productPairs.filter((pair)=>Array.isArray(pair) && pair.length >= 2);
    const ids = new Set((Array.isArray(siteProductIds) ? siteProductIds : []).map((id)=>Number(id)).filter((id)=>!Number.isNaN(id)));
    const siteProducts = pairs.filter((pair)=>ids.has(Number(pair[1]))).map((pair)=>String(pair[0]));
    if (siteProducts.length > 0) return siteProducts;
    if (pairs.length === 1) return [
        String(pairs[0][0])
    ];
    return [];
};



var $195EM = parcelRequire("195EM");

var $4wo2Y = parcelRequire("4wo2Y");

var $crpct = parcelRequire("crpct");


var $cIfQ5 = parcelRequire("cIfQ5");
parcelRequire("8T3gX");


var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
// Function to check site status and poll until refresh is completed
const $b7a73ce80e922a63$var$checkSiteStatusAndPoll = (setCamerasList, setCamerasObject, setFetchingAutoAddData, checkboxesChecked, setCheckboxesChecked, setClientProducts, setImmixSite, setSureviewSite, setProductsArray, setSelectedProducts, setAutoAddError, setAutoAddSiteInfo, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const startTime = Date.now();
    const maxWaitTime = 90000; // 1 minute and 30 seconds in milliseconds
    const pollSiteStatus = ()=>{
        // Check if we've exceeded the maximum wait time
        if (Date.now() - startTime > maxWaitTime) {
            // Timeout reached, proceed with getAutoAddData
            (0, $21d07a178a41003b$export$f3abddc51de925b9)(setCamerasList, setCamerasObject, setFetchingAutoAddData, checkboxesChecked, setCheckboxesChecked, setClientProducts, setImmixSite, setSureviewSite, setProductsArray, setAutoAddSiteInfo, navigate);
            return;
        }
        AxiosUI.get(`site_status/?customer=${localStorage.siteId}`).then((response)=>{
            const { results: results } = response.data;
            if (results && results.length > 0) {
                const siteStatus = results[0];
                const lastRefreshStarted = siteStatus.last_refresh_started;
                const lastRefreshCompleted = siteStatus.last_refresh_completed;
                if (lastRefreshCompleted && Number(lastRefreshStarted) < Number(lastRefreshCompleted)) // Refresh is completed, proceed with getAutoAddData
                (0, $21d07a178a41003b$export$f3abddc51de925b9)(setCamerasList, setCamerasObject, setFetchingAutoAddData, checkboxesChecked, setCheckboxesChecked, setClientProducts, setImmixSite, setSureviewSite, setProductsArray, setAutoAddSiteInfo, navigate);
                else // Refresh not completed yet, continue polling every 3 seconds
                setTimeout(pollSiteStatus, 3000);
            } else // No results, continue polling
            setTimeout(pollSiteStatus, 3000);
        }).catch((error)=>{
            // On error, continue polling
            (0, $21d07a178a41003b$export$f3abddc51de925b9)(setCamerasList, setCamerasObject, setFetchingAutoAddData, checkboxesChecked, setCheckboxesChecked, setClientProducts, setImmixSite, setSureviewSite, setProductsArray, setAutoAddSiteInfo, navigate);
        });
    };
    // Start polling
    pollSiteStatus();
};
const $b7a73ce80e922a63$export$f2af785f2e551b2 = (setCamerasList, setCamerasObject, setFetchingAutoAddData, checkboxesChecked, setCheckboxesChecked, setClientProducts, setImmixSite, setSureviewSite, setProductsArray, setSelectedProducts, setAutoAddError, setAutoAddSiteInfo, navigate)=>{
    setCamerasList({});
    setCamerasObject([]);
    setFetchingAutoAddData(true);
    setClientProducts([]);
    setSelectedProducts([]);
    setCheckboxesChecked({});
    setImmixSite(false);
    setSureviewSite(false);
    setAutoAddError(false);
    setProductsArray([]);
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $b7a73ce80e922a63$export$f2af785f2e551b2(setCamerasList, setCamerasObject, setFetchingAutoAddData, checkboxesChecked, setCheckboxesChecked, setClientProducts, setImmixSite, setSureviewSite, setProductsArray, setSelectedProducts, setAutoAddError, setAutoAddSiteInfo, navigate);
    };
    AxiosUI.post(`customer/${localStorage.siteId}/action/refresh_camera_list/`).then(()=>{
        // Start polling for site status until refresh is completed
        $b7a73ce80e922a63$var$checkSiteStatusAndPoll(setCamerasList, setCamerasObject, setFetchingAutoAddData, checkboxesChecked, setCheckboxesChecked, setClientProducts, setImmixSite, setSureviewSite, setProductsArray, setSelectedProducts, setAutoAddError, setAutoAddSiteInfo, navigate);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            (0, $21d07a178a41003b$export$f3abddc51de925b9)(setCamerasList, setCamerasObject, setFetchingAutoAddData, checkboxesChecked, setCheckboxesChecked, setClientProducts, setImmixSite, setSureviewSite, setProductsArray, setAutoAddSiteInfo, navigate);
        });
    });
};



const $99a43ac89c34d2f7$var$PATRIOT_INPUT_FIELDS = {
    patriotServer: "patriot_server",
    patriotClientNo: "patriot_client_no",
    patriotUsername: "patriot_username",
    patriotPassword: "patriot_password",
    patriotZoneNumber: "patriot_zone_number",
    patriotTypeNumber: "patriot_type_number",
    patriotSendVideo: "patriot_send_video",
    drawIgnoreZones: "draw_ignore_zones"
};
const $99a43ac89c34d2f7$var$BOOLEAN_INPUTS = new Set([
    "patriotSendVideo",
    "drawIgnoreZones"
]);
const $99a43ac89c34d2f7$export$d6617eb3b0fbfec9 = (setCamerasObject, camerasObject, patch, objectId)=>{
    // Update localStorage first so AutoAddTable doesn't overwrite our changes
    const patriotAlertPostObject = JSON.parse(localStorage.patriotAlertPostObject || "{}");
    Object.assign(patriotAlertPostObject, patch);
    localStorage.setItem("patriotAlertPostObject", JSON.stringify(patriotAlertPostObject));
    // Create a deep copy of the camerasObject to ensure React detects the change
    const newCamerasObject = {
        ...camerasObject
    };
    for(const key in camerasObject)newCamerasObject[key] = {
        ...camerasObject[key],
        patriot: {
            ...camerasObject[key].patriot
        }
    };
    if (objectId) {
        // Handle single object update
        Object.assign(newCamerasObject[objectId].patriot, patch);
        setCamerasObject((previousState)=>{
            return {
                ...previousState,
                [objectId]: newCamerasObject[objectId]
            };
        });
    } else {
        // Handle all objects update
        for(const key in newCamerasObject)Object.assign(newCamerasObject[key].patriot, patch);
        setCamerasObject(newCamerasObject);
    }
};
const $99a43ac89c34d2f7$export$e74825755bd7b28c = (setCamerasObject, camerasObject, inputString, inputBoolean, objectId, inputNameString)=>{
    const field = $99a43ac89c34d2f7$var$PATRIOT_INPUT_FIELDS[inputNameString];
    const patch = field ? {
        [field]: $99a43ac89c34d2f7$var$BOOLEAN_INPUTS.has(inputNameString) ? inputBoolean : inputString
    } : {};
    $99a43ac89c34d2f7$export$d6617eb3b0fbfec9(setCamerasObject, camerasObject, patch, objectId);
};



var $hG03Q = parcelRequire("hG03Q");


var $kbChx = parcelRequire("kbChx");

var $3baw3 = parcelRequire("3baw3");

var $k4ank = parcelRequire("k4ank");

var $9qNow = parcelRequire("9qNow");

var $kbChx = parcelRequire("kbChx");

var $3baw3 = parcelRequire("3baw3");
const $0d126d28580d25cd$export$3f258336f377c01f = ({ id: id, label: label, checked: checked, disabled: disabled, onChange: onChange, helperText: helperText })=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                sx: {
                    fontFamily: "Mulish",
                    color: "#001943"
                },
                label: label,
                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                    color: "primary",
                    defaultChecked: checked,
                    disabled: disabled,
                    onChange: onChange
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                children: `${helperText}`
            })
        ]
    }, id);
};


const $aa603f165c402142$export$959cf4ab46edfcc8 = (camerasObject, setCamerasObject, checked)=>{
    // Update localStorage first so AutoAddTable doesn't overwrite our changes
    const immixAlertPostObject = JSON.parse(localStorage.immixAlertPostObject || "{}");
    immixAlertPostObject.draw_ignore_zones = checked;
    localStorage.setItem("immixAlertPostObject", JSON.stringify(immixAlertPostObject));
    // Create a deep copy of the camerasObject to ensure React detects the change
    const newCamerasObject = {
        ...camerasObject
    };
    for(const key in camerasObject){
        newCamerasObject[key] = {
            ...camerasObject[key],
            immix: {
                ...camerasObject[key].immix
            }
        };
        newCamerasObject[key].immix.draw_ignore_zones = checked;
    }
    setCamerasObject(newCamerasObject);
};


const $292da2c95306a612$export$3434d33f9ec476f7 = (camerasObject, setCamerasObject, checked)=>{
    // Update localStorage first so AutoAddTable doesn't overwrite our changes
    const diceAlertPostObject = JSON.parse(localStorage.diceAlertPostObject || "{}");
    diceAlertPostObject.draw_ignore_zones = checked;
    localStorage.setItem("diceAlertPostObject", JSON.stringify(diceAlertPostObject));
    // Create a deep copy of the camerasObject to ensure React detects the change
    const newCamerasObject = {
        ...camerasObject
    };
    for(const key in camerasObject){
        newCamerasObject[key] = {
            ...camerasObject[key],
            dice: {
                ...camerasObject[key].dice
            }
        };
        newCamerasObject[key].dice.draw_ignore_zones = checked;
    }
    setCamerasObject(newCamerasObject);
};



const $3e7ad1fea613135d$export$93fc82c3a3170234 = ({ setVisibleScreen: setVisibleScreen, setLargerScreen: setLargerScreen, largerScreen: largerScreen, setCameraCheckFinsihedAlertOpen: setCameraCheckFinsihedAlertOpen, setGoodCameras: setGoodCameras, setConnectivityCameras: setConnectivityCameras, setLowResolutionCameras: setLowResolutionCameras, setCameraCheckResultDownloadURL: setCameraCheckResultDownloadURL })=>{
    const { searchingCameras: searchingCameras, setPage: setPage, setRowsPerPage: setRowsPerPage } = (0, $a4d6ac0c9ead9c31$export$2b7358df2c708c72)();
    const [camerasList, setCamerasList] = $8T3gX.useState({});
    const [camerasObject, setCamerasObject] = $8T3gX.useState([]);
    const [fetchingAutoAddData, setFetchingAutoAddData] = $8T3gX.useState(true);
    const [clientProducts, setClientProducts] = $8T3gX.useState([]);
    const [selectedProducts, setSelectedProducts] = $8T3gX.useState([]);
    const [checkboxesChecked, setCheckboxesChecked] = $8T3gX.useState({});
    const [immixSite, setImmixSite] = $8T3gX.useState(false);
    const [diceSite, setDiceSite] = $8T3gX.useState(false);
    const [sureViewSite, setSureviewSite] = $8T3gX.useState(false);
    const [sentinelSite, setSentinelSite] = $8T3gX.useState(false);
    const [patriotSite, setPatriotSite] = $8T3gX.useState(false);
    const [evalinkSite, setEvalinkSite] = $8T3gX.useState(false);
    const [hanwhaSite, setHanwhaSite] = $8T3gX.useState(false);
    const [autoAddError, setAutoAddError] = $8T3gX.useState(localStorage.autoAddError);
    const [productsArray, setProductsArray] = $8T3gX.useState([]);
    const [autoAddSiteInfo, setAutoAddSiteInfo] = $8T3gX.useState({});
    const [streamPatchObject, setStreamPatchObject] = $8T3gX.useState({
        resolution: "",
        stream_type: "",
        stream_quality: "",
        codec: ""
    });
    const [streamChangesMade, setStreamChangesMade] = $8T3gX.useState(false);
    const [fixingCameras, setFixingCameras] = $8T3gX.useState(false);
    const [fixResult, setFixResult] = $8T3gX.useState((0, $2844b9177f6f3f6b$export$c442a5e1a717e2a5));
    const fixChangeCount = fixResult.camerasChanged.length + fixResult.uidsFixed + fixResult.updateMessages.length;
    const camerasMovedServers = (camerasList.results || []).some((0, $2844b9177f6f3f6b$export$be98998873c77329));
    const { width: width } = (0, $crpct.default)();
    const serverOptions = [
        [
            "US SMTP Server",
            "us-smtp.sureviewops.com"
        ],
        [
            "EU SMTP Server",
            "eu-smtp.sureviewops.com"
        ]
    ];
    const optionsIds = new Map();
    const optionNames = new Map();
    serverOptions.forEach((option)=>{
        optionsIds.set(option[0], option[1]);
    });
    serverOptions.forEach((option)=>{
        optionNames.set(option[1], option[0]);
    });
    const alarmOptions = JSON.parse(localStorage.alarmOptions);
    const alarmIds = new Map();
    alarmOptions.forEach((object)=>{
        alarmIds.set(object.value, object.name);
    });
    const integrationsTypes = JSON.parse(localStorage.integrationTypes);
    const integrationIds = new Map();
    integrationsTypes.forEach((object)=>{
        integrationIds.set(object.id, object.name);
    });
    const navigate = (0, $3T949.useNavigate)();
    const [additionalFieldNamesArray, setAdditionalFieldNamesArray] = $8T3gX.useState(JSON.parse(localStorage?.additionalFieldNamesArray || "[]"));
    const immixAlertPostObject = JSON.parse(localStorage.immixAlertPostObject);
    const diceAlertPostObject = JSON.parse(localStorage.diceAlertPostObject || "{}");
    const sentinelAlertPostObject = JSON.parse(localStorage.sentinelAlertPostObject);
    const patriotAlertPostObject = JSON.parse(localStorage.patriotAlertPostObject || "{}");
    // handlePatriotInput / applyPatriotAlertPatch write localStorage before
    // setting state, so the delivery choice re-derives on the re-render.
    const evalinkAlertPostObject = JSON.parse(localStorage.evalinkAlertPostObject || "{}");
    $8T3gX.useEffect(()=>{
        // Reset pagination state on component mount
        setPage(0);
        setRowsPerPage(10);
        (0, $21d07a178a41003b$export$f3abddc51de925b9)(setCamerasList, setCamerasObject, setFetchingAutoAddData, checkboxesChecked, setCheckboxesChecked, setClientProducts, setImmixSite, setSureviewSite, setProductsArray, setAutoAddSiteInfo, navigate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Cleanup timeout on unmount
    $8T3gX.useEffect(()=>{
        return ()=>{
            if (helperTextTimeoutRef.current) clearTimeout(helperTextTimeoutRef.current);
        };
    }, []);
    $8T3gX.useEffect(()=>{
        if (Object.keys(autoAddSiteInfo).length > 0) {
            if (alarmIds.get(autoAddSiteInfo.default_alarm) === "Immix") setImmixSite(true);
            if (alarmIds.get(autoAddSiteInfo.default_alarm) === "Dice") setDiceSite(true);
            if (alarmIds.get(autoAddSiteInfo.default_alarm) === "SureView") setSureviewSite(true);
            if (alarmIds.get(autoAddSiteInfo.default_alarm) === "Sentinel") setSentinelSite(true);
            if (alarmIds.get(autoAddSiteInfo.default_alarm) === "Patriot") setPatriotSite(true);
            if (alarmIds.get(autoAddSiteInfo.default_alarm) === "Evalink") setEvalinkSite(true);
            if (integrationIds.get(Number(localStorage.integrationType)) === "digital_watchdog") setHanwhaSite(true);
        }
    }, [
        autoAddSiteInfo
    ]);
    const buttonText = /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            "Save Changes",
            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($53b11234ecc265c7$exports))), {})
        ]
    });
    // Lightweight reload of the NVR camera list (no NVR re-poll) so the deployed
    // names and servers refresh after a "Fix Cameras" run and the old -> new diffs clear.
    const refreshCameraListLight = ()=>{
        (0, $21d07a178a41003b$export$f3abddc51de925b9)(setCamerasList, setCamerasObject, setFetchingAutoAddData, checkboxesChecked, setCheckboxesChecked, setClientProducts, setImmixSite, setSureviewSite, setProductsArray, setAutoAddSiteInfo, navigate);
    };
    const [helperText, setHelperText] = $8T3gX.useState("");
    // Pre-select products once the site's product list loads: the per-product
    // checkbox columns only appear when a product is selected, so an empty box
    // leaves no way to pick cameras. Never selects every product by default.
    $8T3gX.useEffect(()=>{
        if (!Array.isArray(productsArray) || productsArray.length === 0) return;
        if (selectedProducts.length > 0) return;
        let cancelled = false;
        const apply = (siteProductIds)=>{
            const picked = (0, $23704bc81f77767a$export$c9e981d7ab9ad5c9)(productsArray, siteProductIds);
            if (cancelled || picked.length === 0) return;
            setSelectedProducts(picked);
            (0, $d8f875ed9a0fa5f4$export$dd632f6ca29d1fa1)(setHelperText, picked, productsArray, navigate);
        };
        if (productsArray.length === 1) apply([]);
        else (0, $195EM.createApi)(``).get(`customer/${localStorage.siteId}/camera_onboarding_forms/`).then((response)=>apply(response.data?.initial_data?.products), ()=>undefined);
        return ()=>{
            cancelled = true;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        productsArray
    ]);
    const helperTextTimeoutRef = $8T3gX.useRef(null);
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: fetchingAutoAddData ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: "flex flex-col items-center justify-center pt-[200px]",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                    color: "warning"
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                    className: "font-mulish text-[20px] pt-[20px] text-center",
                    children: [
                        "Fetching Cameras.",
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "font-mulish text-[16px]",
                            children: "This may take a few seconds."
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                children: [
                    autoAddError && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute w-[600px] h-[50px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                            severity: "error",
                            onClose: ()=>{
                                setAutoAddError(false);
                                localStorage.removeItem("autoAddError");
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "font-mulish font-bold text-[16px]",
                                children: "Problem adding Camera(s). Please try again."
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                        open: fixResult.open,
                        onClose: ()=>setFixResult({
                                ...fixResult,
                                open: false
                            }),
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: fixResult.error ? "Couldn't fix cameras" : fixChangeCount > 0 ? "Cameras updated" : "No cameras needed fixing"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: fixResult.error ? /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "font-mulish",
                                    children: fixResult.errorMessage || "Something went wrong applying the NVR camera list. Please try again."
                                }) : fixChangeCount > 0 ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "font-mulish pb-[8px]",
                                            children: "These cameras now match the NVR (the camera id was preserved). Sync the site to push the changes to the connector."
                                        }),
                                        fixResult.updateMessages.length > 0 && /*#__PURE__*/ (0, $k4ank.jsx)("ul", {
                                            className: "list-disc pl-[20px] pb-[8px] font-mulish",
                                            children: fixResult.updateMessages.map((text)=>/*#__PURE__*/ (0, $k4ank.jsx)("li", {
                                                    children: text
                                                }, text))
                                        }),
                                        fixResult.camerasChanged.length > 0 && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                    className: "font-mulish font-bold",
                                                    children: "Renamed"
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)("ul", {
                                                    className: "list-disc pl-[20px] pb-[8px] font-mulish",
                                                    children: fixResult.camerasChanged.map((camera)=>/*#__PURE__*/ (0, $k4ank.jsx)("li", {
                                                            children: camera.camera_name
                                                        }, camera.id))
                                                })
                                            ]
                                        }),
                                        fixResult.uidsFixed > 0 && /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                            className: "font-mulish",
                                            children: [
                                                "Updated the device ID of ",
                                                fixResult.uidsFixed,
                                                " camera",
                                                fixResult.uidsFixed === 1 ? "" : "s",
                                                "."
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "font-mulish",
                                    children: "All deployed cameras already match the NVR."
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    text: "Close",
                                    disabled: false,
                                    onClick: ()=>setFixResult({
                                            ...fixResult,
                                            open: false
                                        })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-[75px] right-[30px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            onClick: ()=>{
                                localStorage.removeItem("autoAddError");
                                (0, $be6604b7aaa96627$export$9429a4eadaf8fb7)(camerasObject, setVisibleScreen, setLargerScreen, largerScreen, setCameraCheckFinsihedAlertOpen, setGoodCameras, setConnectivityCameras, setLowResolutionCameras, setCameraCheckResultDownloadURL, sentinelSite, patriotSite, streamChangesMade, streamPatchObject, navigate);
                            },
                            text: buttonText,
                            disabled: !camerasList.results[0]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "font-mulish  absolute text-[#283E6D] top-[80px] left-[20px] text-[18px]",
                        children: "Cameras"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-[120px] left-[30px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $0553efca519c1dc2$export$209b1f883cb1691c), {
                                        id: "product_input",
                                        options: clientProducts,
                                        onChange: (event, value)=>{
                                            // Update selected products immediately for responsive UI
                                            setSelectedProducts(value);
                                            // Debounce the helper text API call to prevent blocking
                                            // This prevents the API call from freezing the UI during rapid selections
                                            if (helperTextTimeoutRef.current) clearTimeout(helperTextTimeoutRef.current);
                                            helperTextTimeoutRef.current = setTimeout(()=>{
                                                (0, $d8f875ed9a0fa5f4$export$dd632f6ca29d1fa1)(setHelperText, value, productsArray, navigate);
                                            }, 300);
                                        },
                                        stylingWidth: 500,
                                        label: "Products",
                                        helperText: helperText,
                                        defaultValue: [],
                                        value: selectedProducts
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "relative left-[-15px]",
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3Nm8Z.default), {
                                        sx: largerScreen ? {
                                            width: width - 25
                                        } : {
                                            width: 560
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                className: "flex",
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "w-[350px]",
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $70f0d15999d305f6$export$126950802e8c305b), {
                                                            setCamerasList: setCamerasList,
                                                            setCamerasObject: setCamerasObject,
                                                            navigate: navigate,
                                                            productsArray: productsArray,
                                                            setCheckboxesChecked: setCheckboxesChecked,
                                                            checkboxesChecked: checkboxesChecked
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "pl-15",
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                            text: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cIfQ5))), {
                                                                        fontSize: "small"
                                                                    }),
                                                                    "\xa0 Refresh Camera List"
                                                                ]
                                                            }),
                                                            disabled: false,
                                                            onClick: ()=>{
                                                                setHelperText("");
                                                                (0, $b7a73ce80e922a63$export$f2af785f2e551b2)(setCamerasList, setCamerasObject, setFetchingAutoAddData, checkboxesChecked, setCheckboxesChecked, setClientProducts, setImmixSite, setSureviewSite, setProductsArray, setSelectedProducts, setAutoAddError, setAutoAddSiteInfo, navigate);
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "pl-15",
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                            text: fixingCameras ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                                                        size: 16,
                                                                        color: "inherit"
                                                                    }),
                                                                    "\xa0 Fixing Cameras..."
                                                                ]
                                                            }) : /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9df30a3db5199d1b$exports))), {
                                                                        fontSize: "small"
                                                                    }),
                                                                    "\xa0 Fix Cameras"
                                                                ]
                                                            }),
                                                            disabled: fixingCameras || !camerasList.results?.[0],
                                                            onClick: ()=>{
                                                                (0, $2844b9177f6f3f6b$export$86ada9eacde07a99)(setFixingCameras, setFixResult, refreshCameraListLight, navigate);
                                                            }
                                                        })
                                                    })
                                                ]
                                            }),
                                            camerasMovedServers && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "font-mulish text-[13px] text-[#283E6D] px-[20px] pb-[8px]",
                                                children: 'Some cameras moved to a new recording server (see "Old server"). Click Fix Cameras to update them.'
                                            }),
                                            searchingCameras && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                className: "p-[20px]",
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                                        color: "warning"
                                                    }),
                                                    " \xa0 Searching Cameras..."
                                                ]
                                            }),
                                            !searchingCameras && /*#__PURE__*/ (0, $k4ank.jsx)((0, $9151e83927c89871$export$b880830c492984f5), {
                                                camerasList: camerasList,
                                                selectedProducts: selectedProducts,
                                                camerasObject: camerasObject,
                                                setCamerasObject: setCamerasObject,
                                                checkboxesChecked: checkboxesChecked,
                                                setCheckboxesChecked: setCheckboxesChecked,
                                                additionalFieldNamesArray: additionalFieldNamesArray,
                                                immixSite: immixSite,
                                                diceSite: diceSite,
                                                sureViewSite: sureViewSite,
                                                productsArray: productsArray,
                                                sentinelSite: sentinelSite,
                                                patriotSite: patriotSite,
                                                evalinkSite: evalinkSite,
                                                setCamerasList: setCamerasList,
                                                largerScreen: largerScreen,
                                                hanwhaSite: hanwhaSite
                                            })
                                        ]
                                    })
                                }),
                                immixSite && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "relative h-[35px] font-mulish w-[300px] text-[#283E6D] text-[18px]",
                                            children: "Immix Alerts"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "relative h-[75px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                                                id: "immixServerInput",
                                                defaultValue: immixAlertPostObject.immix_server,
                                                value: "",
                                                onChange: (event)=>{
                                                    (0, $1fa43aac1fc2c060$export$949f7b925aba1352)(camerasObject, setCamerasObject, event.target.value);
                                                },
                                                helperText: "",
                                                stylingWidth: 300,
                                                label: "Immix Server",
                                                error: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                                                id: "immixPortInput",
                                                defaultValue: immixAlertPostObject.immix_port,
                                                value: "",
                                                onChange: (event)=>{
                                                    (0, $197b38236d96da4a$export$767edeb86a59daf7)(camerasObject, setCamerasObject, event.target.value);
                                                },
                                                helperText: "",
                                                stylingWidth: 300,
                                                label: "Immix Port",
                                                error: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "pt-[10px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $0d126d28580d25cd$export$3f258336f377c01f), {
                                                id: "drawIgnoreZones",
                                                checked: false,
                                                disabled: false,
                                                label: "Draw Ignore Zones",
                                                onChange: (event)=>{
                                                    (0, $aa603f165c402142$export$959cf4ab46edfcc8)(camerasObject, setCamerasObject, event.target.checked);
                                                },
                                                helperText: "If checked, draws ignore zones in the alert images."
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                                    ]
                                }),
                                diceSite && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "relative h-[35px] font-mulish w-[300px] text-[#283E6D] text-[18px]",
                                            children: "Dice Alerts"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "relative h-[75px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                                                id: "diceServerInput",
                                                defaultValue: diceAlertPostObject.dice_server,
                                                value: "",
                                                onChange: (event)=>{
                                                    (0, $60f8b4d0f2c992b9$export$c80e064a3f45bf73)(camerasObject, setCamerasObject, event.target.value);
                                                },
                                                helperText: "",
                                                stylingWidth: 300,
                                                label: "Dice Server",
                                                error: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                                                id: "dicePortInput",
                                                defaultValue: diceAlertPostObject.dice_port,
                                                value: "",
                                                onChange: (event)=>{
                                                    (0, $fbf953b87034d063$export$448ca91ebdf560eb)(camerasObject, setCamerasObject, event.target.value);
                                                },
                                                helperText: "",
                                                stylingWidth: 300,
                                                label: "Dice Port",
                                                error: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "pt-[10px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $0d126d28580d25cd$export$3f258336f377c01f), {
                                                id: "diceDrawIgnoreZones",
                                                checked: false,
                                                disabled: false,
                                                label: "Draw Ignore Zones",
                                                onChange: (event)=>{
                                                    (0, $292da2c95306a612$export$3434d33f9ec476f7)(camerasObject, setCamerasObject, event.target.checked);
                                                },
                                                helperText: "If checked, draws ignore zones in the alert images."
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                                    ]
                                }),
                                sureViewSite && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "relative h-[35px] font-mulish w-[300px] text-[#283E6D] text-[18px]",
                                            children: "Sureview Alerts"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "relative h-[75px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                                disablePortal: true,
                                                id: "sureViewServer",
                                                options: serverOptions.map((option)=>{
                                                    return option[0];
                                                }),
                                                onChange: (event, newInputValue)=>{
                                                    (0, $b5aa1036eb73c18b$export$e2cea609f160409a)(camerasObject, setCamerasObject, optionsIds.get(newInputValue));
                                                },
                                                sx: {
                                                    width: 300
                                                },
                                                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                        ...params,
                                                        variant: "standard",
                                                        label: "Sureview Server",
                                                        autoComplete: "off",
                                                        sx: {
                                                            width: 300
                                                        }
                                                    })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                                                id: "sureViewSubject",
                                                defaultValue: "",
                                                value: "",
                                                onChange: (event)=>{
                                                    (0, $e8a5855e0625295f$export$2fb67fb4418ec47c)(camerasObject, setCamerasObject, event.target.value);
                                                },
                                                helperText: "",
                                                stylingWidth: 300,
                                                label: "Sureview Subject",
                                                error: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                                    ]
                                }),
                                sentinelSite && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "relative h-[35px] font-mulish w-[300px] text-[#283E6D] text-[18px]",
                                            children: "Sentinel Alerts"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "relative h-[75px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                                                id: "sentinelServerInput",
                                                defaultValue: sentinelAlertPostObject.sentinel_server,
                                                value: "",
                                                onChange: (event)=>{
                                                    (0, $233f08f65c7ba9a7$export$79a035a079a2f6fa)(setCamerasObject, camerasObject, event.target.value, false, null, "sentinelServer");
                                                },
                                                helperText: "",
                                                stylingWidth: 300,
                                                label: "Sentinel Server",
                                                error: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "relative h-[75px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                                                id: "sentinelSiteIdInput",
                                                defaultValue: sentinelAlertPostObject.sentinel_site_id,
                                                value: "",
                                                onChange: (event)=>{
                                                    (0, $233f08f65c7ba9a7$export$79a035a079a2f6fa)(setCamerasObject, camerasObject, event.target.value, false, null, "sentinelSiteId");
                                                },
                                                helperText: "",
                                                stylingWidth: 300,
                                                label: "Sentinel Site Id",
                                                error: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "relative h-[75px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                                                id: "sentinelDeviceAddressInput",
                                                defaultValue: sentinelAlertPostObject.sentinel_device_address,
                                                value: "",
                                                onChange: (event)=>{
                                                    (0, $233f08f65c7ba9a7$export$79a035a079a2f6fa)(setCamerasObject, camerasObject, event.target.value, false, null, "sentinelDeviceAddress");
                                                },
                                                helperText: "",
                                                stylingWidth: 300,
                                                label: "Sentinel Device Address",
                                                error: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "relative h-[75px]",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                    sx: {
                                                        fontFamily: "Mulish",
                                                        color: "#001943"
                                                    },
                                                    label: "Draw Ignore Zones",
                                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                        color: "primary",
                                                        defaultChecked: sentinelAlertPostObject.draw_ignore_zones,
                                                        onChange: (event, checked)=>{
                                                            (0, $233f08f65c7ba9a7$export$79a035a079a2f6fa)(setCamerasObject, camerasObject, "", checked, null, "drawIgnoreZones");
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                                                    children: "If checked, draws ignore zones in the alert images."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                                    ]
                                }),
                                evalinkSite && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "relative h-[35px] font-mulish w-[300px] text-[#283E6D] text-[18px]",
                                            children: "Evalink Alerts"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "relative h-[75px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                                                id: "evalinkTokenInput",
                                                defaultValue: evalinkAlertPostObject.evalink_token,
                                                value: "",
                                                onChange: (event)=>{
                                                    (0, $28ef544f83a091a4$export$b9c8d142e906be5d)(setCamerasObject, camerasObject, event.target.value, null, "evalinkToken");
                                                },
                                                helperText: "",
                                                stylingWidth: 300,
                                                label: "Evalink Token",
                                                error: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "relative h-[75px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                                                id: "evalinkDeviceIdInput",
                                                defaultValue: evalinkAlertPostObject.evalink_device_id,
                                                value: "",
                                                onChange: (event)=>{
                                                    (0, $28ef544f83a091a4$export$b9c8d142e906be5d)(setCamerasObject, camerasObject, event.target.value, null, "evalinkDeviceId");
                                                },
                                                helperText: "",
                                                stylingWidth: 300,
                                                label: "Evalink Device Id",
                                                error: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "relative h-[75px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                                                id: "evalinkCompanyIdInput",
                                                defaultValue: evalinkAlertPostObject.evalink_company_id,
                                                value: "",
                                                onChange: (event)=>{
                                                    (0, $28ef544f83a091a4$export$b9c8d142e906be5d)(setCamerasObject, camerasObject, event.target.value, null, "evalinkCompanyId");
                                                },
                                                helperText: "",
                                                stylingWidth: 300,
                                                label: "Evalink Company Id",
                                                error: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "relative h-[75px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                                                id: "evalinkPartitionIdInput",
                                                defaultValue: evalinkAlertPostObject.partition_id,
                                                value: "",
                                                onChange: (event)=>{
                                                    (0, $28ef544f83a091a4$export$b9c8d142e906be5d)(setCamerasObject, camerasObject, event.target.value, null, "partitionId");
                                                },
                                                helperText: "Applies to all cameras on this site. Each camera's Alarm Zone ID is set in the table above.",
                                                stylingWidth: 300,
                                                label: "Evalink Partition Id",
                                                error: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                                    ]
                                }),
                                patriotSite && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "relative h-[35px] font-mulish w-[300px] text-[#283E6D] text-[18px]",
                                            children: "Patriot Alerts"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "relative h-[75px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                                                id: "patriotServerInput",
                                                defaultValue: patriotAlertPostObject.patriot_server,
                                                value: "",
                                                onChange: (event)=>{
                                                    (0, $99a43ac89c34d2f7$export$e74825755bd7b28c)(setCamerasObject, camerasObject, event.target.value, false, null, "patriotServer");
                                                },
                                                helperText: "",
                                                stylingWidth: 300,
                                                label: "Patriot Server",
                                                error: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "relative h-[75px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                                                id: "patriotClientNoInput",
                                                defaultValue: patriotAlertPostObject.patriot_client_no,
                                                value: "",
                                                onChange: (event)=>{
                                                    (0, $99a43ac89c34d2f7$export$e74825755bd7b28c)(setCamerasObject, camerasObject, event.target.value, false, null, "patriotClientNo");
                                                },
                                                helperText: "",
                                                stylingWidth: 300,
                                                label: "Patriot Client No",
                                                error: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "relative h-[75px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                                                id: "patriotUsernameInput",
                                                defaultValue: patriotAlertPostObject.patriot_username,
                                                value: "",
                                                onChange: (event)=>{
                                                    (0, $99a43ac89c34d2f7$export$e74825755bd7b28c)(setCamerasObject, camerasObject, event.target.value, false, null, "patriotUsername");
                                                },
                                                helperText: "",
                                                stylingWidth: 300,
                                                label: "Patriot Username",
                                                error: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "relative h-[75px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                                                id: "patriotPasswordInput",
                                                defaultValue: patriotAlertPostObject.patriot_password,
                                                value: "",
                                                onChange: (event)=>{
                                                    (0, $99a43ac89c34d2f7$export$e74825755bd7b28c)(setCamerasObject, camerasObject, event.target.value, false, null, "patriotPassword");
                                                },
                                                helperText: "",
                                                stylingWidth: 300,
                                                label: "Patriot Password",
                                                error: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "relative h-[75px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                                                id: "patriotZoneNumberInput",
                                                defaultValue: patriotAlertPostObject.patriot_zone_number,
                                                value: "",
                                                onChange: (event)=>{
                                                    (0, $99a43ac89c34d2f7$export$e74825755bd7b28c)(setCamerasObject, camerasObject, event.target.value, false, null, "patriotZoneNumber");
                                                },
                                                helperText: "",
                                                stylingWidth: 300,
                                                label: "Patriot Zone Number",
                                                error: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "relative h-[75px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                                                id: "patriotTypeNumberInput",
                                                defaultValue: patriotAlertPostObject.patriot_type_number,
                                                value: "",
                                                onChange: (event)=>{
                                                    (0, $99a43ac89c34d2f7$export$e74825755bd7b28c)(setCamerasObject, camerasObject, event.target.value, false, null, "patriotTypeNumber");
                                                },
                                                helperText: "Defaults to 100 if left blank.",
                                                stylingWidth: 300,
                                                label: "Patriot Type Number",
                                                error: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "relative pb-2",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $hG03Q.PatriotDeliveryChoice), {
                                                name: "auto-add-patriot-delivery",
                                                sendVideo: patriotAlertPostObject.patriot_send_video,
                                                drawIgnoreZones: patriotAlertPostObject.draw_ignore_zones,
                                                onChange: (values)=>{
                                                    (0, $99a43ac89c34d2f7$export$d6617eb3b0fbfec9)(setCamerasObject, camerasObject, {
                                                        ...values
                                                    }, null);
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                                    ]
                                }),
                                hanwhaSite && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "relative h-[35px] font-mulish w-[300px] text-[#283E6D] text-[18px]",
                                            children: `Stream Parameters (optional)`
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "relative h-[75px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                                                id: "streamParamsResolution",
                                                defaultValue: "",
                                                value: "",
                                                onChange: (event)=>{
                                                    setStreamChangesMade(true);
                                                    setStreamPatchObject({
                                                        ...streamPatchObject,
                                                        resolution: event.target.value
                                                    });
                                                },
                                                helperText: "Example: 720p",
                                                stylingWidth: 300,
                                                label: "Resolution",
                                                error: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "relative h-[75px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                                                id: "streamParamsStreamType",
                                                defaultValue: "",
                                                value: "",
                                                onChange: (event)=>{
                                                    setStreamChangesMade(true);
                                                    setStreamPatchObject({
                                                        ...streamPatchObject,
                                                        stream_type: event.target.value
                                                    });
                                                },
                                                helperText: "rtsp or http",
                                                stylingWidth: 300,
                                                label: "Stream Type",
                                                error: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "relative h-[75px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                                                id: "streamParamsStreamQuality",
                                                defaultValue: "",
                                                value: "",
                                                onChange: (event)=>{
                                                    setStreamChangesMade(true);
                                                    setStreamPatchObject({
                                                        ...streamPatchObject,
                                                        stream_quality: event.target.value
                                                    });
                                                },
                                                helperText: "For DW, 0 is high quality 1 is low quality. Preferably use 1.",
                                                stylingWidth: 300,
                                                label: "Stream Quality",
                                                error: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "relative h-[75px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $871b236273f4a325$export$a316a94c1bd540e2), {
                                                id: "streamParamsCodec",
                                                defaultValue: "",
                                                value: "",
                                                onChange: (event)=>{
                                                    setStreamChangesMade(true);
                                                    setStreamPatchObject({
                                                        ...streamPatchObject,
                                                        codec: event.target.value
                                                    });
                                                },
                                                helperText: "Example: H264 for rtsp. For Http use webm, mpegts, mpjpeg, mp4 or mkv",
                                                stylingWidth: 300,
                                                label: "Codec",
                                                error: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $axLMO = parcelRequire("axLMO");

var $cVCJe = parcelRequire("cVCJe");
const $ce686a880d23b2e0$export$bd89ba5689ecaffc = ({ setCameraCheckFinsihedAlertOpen: setCameraCheckFinsihedAlertOpen, setGoodCameras: setGoodCameras, setConnectivityCameras: setConnectivityCameras, setLowResolutionCameras: setLowResolutionCameras, setCameraCheckResultDownloadURL: setCameraCheckResultDownloadURL, ...props })=>{
    const [visibleScreen, setVisibleScreen] = $8T3gX.useState(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
    const [largerScreen, setLargerScreen] = $8T3gX.useState(true);
    const navigate = (0, $3T949.useNavigate)();
    $8T3gX.useEffect(()=>{
        // if (localStorage.noAutoAddCamerasDialogOpen === "true") {
        //   handleNavigateToSitesPage(navigate);
        // } else {
        setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $3e7ad1fea613135d$export$93fc82c3a3170234), {
            setVisibleScreen: setVisibleScreen,
            setLargerScreen: setLargerScreen,
            largerScreen: largerScreen,
            setCameraCheckFinsihedAlertOpen: setCameraCheckFinsihedAlertOpen,
            setGoodCameras: setGoodCameras,
            setConnectivityCameras: setConnectivityCameras,
            setLowResolutionCameras: setLowResolutionCameras,
            setCameraCheckResultDownloadURL: setCameraCheckResultDownloadURL
        }));
    // }
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "bg-black fixed w-full h-full opacity-90",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "bg-black fixed w-full h-full opacity-10 pointer-events-none"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "flex justify-end text-left",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: largerScreen ? "absolute top-[50px] h-full bg-white w-full" : "absolute top-[50px] h-full bg-white w-[600px]"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "flex justify-end text-left",
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: largerScreen ? "absolute h-full bg-white w-full" : "absolute h-full bg-white w-[600px]",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: largerScreen ? "bg-actuate-blue absolute w-full h-[50px]" : "bg-actuate-blue absolute w-[600px] h-[50px]",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                        className: "absolute right-6 top-[10px] text-white text-[18px]",
                                        onClick: ()=>{
                                            localStorage.setItem("cameraNumber", "1");
                                            const cameFromSiteAbout = localStorage.navigatedFromSitesAboutPage === "true" || localStorage.clickedFromSiteAboutPage === "true" || localStorage.addAdditionalCamera === "true";
                                            if (cameFromSiteAbout && localStorage.siteId) navigate(`/sites/aboutsite/${localStorage.siteId}`);
                                            else navigate("/sites");
                                        },
                                        children: "X"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: largerScreen ? "text-white absolute top-[1px] left-[0px] w-[220px] font-mulish text-[18px] p-3" : "text-white absolute top-[1px] left-[0px]  w-[220px] font-mulish text-[18px] p-3",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                                onClick: ()=>{
                                                    setLargerScreen(!largerScreen);
                                                    setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $3e7ad1fea613135d$export$93fc82c3a3170234), {
                                                        setVisibleScreen: setVisibleScreen,
                                                        setLargerScreen: setLargerScreen,
                                                        largerScreen: !largerScreen,
                                                        setCameraCheckFinsihedAlertOpen: setCameraCheckFinsihedAlertOpen,
                                                        setGoodCameras: setGoodCameras,
                                                        setConnectivityCameras: setConnectivityCameras,
                                                        setLowResolutionCameras: setLowResolutionCameras,
                                                        setCameraCheckResultDownloadURL: setCameraCheckResultDownloadURL
                                                    }));
                                                },
                                                children: largerScreen ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                    title: "Collapse",
                                                    placement: "right",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                                                        ...props,
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                                                            fill: "currentColor",
                                                            d: "M4 6h2v12H4zm4 7h8.586l-4.293 4.293 1.414 1.414L20.414 12l-6.707-6.707-1.414 1.414L16.586 11H8z"
                                                        })
                                                    })
                                                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                    title: "Expand",
                                                    placement: "right",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $axLMO.default), {
                                                        ...props,
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                                                            fill: "currentColor",
                                                            d: "M18 6h2v12h-2zm-2 5H7.414l4.293-4.293-1.414-1.414L3.586 12l6.707 6.707 1.414-1.414L7.414 13H16z"
                                                        })
                                                    })
                                                })
                                            }),
                                            "\xa0 Auto Add Camera"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                children: visibleScreen
                            })
                        ]
                    })
                })
            ]
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $jVN1H = parcelRequire("jVN1H");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $3QMQN = parcelRequire("3QMQN");
var $eDfvp = parcelRequire("eDfvp");
var $a65wX = parcelRequire("a65wX");
var $60vL1 = parcelRequire("60vL1");
var $7UDCh = parcelRequire("7UDCh");
var $iKAtE = parcelRequire("iKAtE");
var $6gU8O = parcelRequire("6gU8O");
var $cxknk = parcelRequire("cxknk");
var $4reBM = parcelRequire("4reBM");
var $2eEqG = parcelRequire("2eEqG");
var $3IuQ3 = parcelRequire("3IuQ3");
var $eejVe = parcelRequire("eejVe");
var $f3puC = parcelRequire("f3puC");
var $6e7077adf77ebc0f$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($6e7077adf77ebc0f$exports, "__esModule", {
    value: true
});
$6e7077adf77ebc0f$exports.default = void 0;

var $6e7077adf77ebc0f$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $6e7077adf77ebc0f$var$_default = $6e7077adf77ebc0f$exports.default = (0, $6e7077adf77ebc0f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), 'Add');


var $ea2ee23932ed374d$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($ea2ee23932ed374d$exports, "__esModule", {
    value: true
});
$ea2ee23932ed374d$exports.default = void 0;

var $ea2ee23932ed374d$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $ea2ee23932ed374d$var$_default = $ea2ee23932ed374d$exports.default = (0, $ea2ee23932ed374d$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM8 9h8v10H8zm7.5-5-1-1h-5l-1 1H5v2h14V4z"
}), 'DeleteOutline');


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
var $3T949 = parcelRequire("3T949");

var $h5NlZ = parcelRequire("h5NlZ");

var $195EM = parcelRequire("195EM");

var $9OjAn = parcelRequire("9OjAn");
const $7efbe771df2391dd$var$initialState = {
    mode: "discover",
    tunnelId: null,
    credentials: [
        {
            username: "",
            password: ""
        }
    ],
    scanCredentials: [],
    subnet: "",
    scanStatus: "idle",
    taskId: null,
    hosts: [],
    errorMessage: "",
    selectedKeys: {},
    selectedProfiles: {},
    submitting: false,
    unitScanTargets: null,
    unitScanCredentialRefs: [],
    unitScanResult: null,
    unitSelectedIds: {},
    applying: false,
    applyResult: null
};
const $7efbe771df2391dd$export$b37e90458ab57966 = (0, $9OjAn.create)((set)=>({
        ...$7efbe771df2391dd$var$initialState,
        setMode: (value)=>set({
                mode: value
            }),
        setTunnelId: (value)=>set({
                tunnelId: value
            }),
        setCredentials: (value)=>set({
                credentials: value
            }),
        setScanCredentials: (value)=>set({
                scanCredentials: value
            }),
        setSubnet: (value)=>set({
                subnet: value
            }),
        setScanStatus: (value)=>set({
                scanStatus: value
            }),
        setTaskId: (value)=>set({
                taskId: value
            }),
        setHosts: (value)=>set({
                hosts: value
            }),
        setErrorMessage: (value)=>set({
                errorMessage: value
            }),
        setSelectedKeys: (value)=>set({
                selectedKeys: value
            }),
        setSelectedProfile: (key, token)=>set((state)=>({
                    selectedProfiles: {
                        ...state.selectedProfiles,
                        [key]: token
                    }
                })),
        setSubmitting: (value)=>set({
                submitting: value
            }),
        setUnitScanTargets: (value)=>set({
                unitScanTargets: value
            }),
        setUnitScanCredentialRefs: (value)=>set({
                unitScanCredentialRefs: value
            }),
        setUnitScanResult: (value)=>set({
                unitScanResult: value
            }),
        setUnitSelectedIds: (value)=>set({
                unitSelectedIds: value
            }),
        setApplying: (value)=>set({
                applying: value
            }),
        setApplyResult: (value)=>set({
                applyResult: value
            }),
        // Keeps `mode`: the route wrapper owns it, and reset() runs on every visit.
        reset: ()=>set((state)=>({
                    ...$7efbe771df2391dd$var$initialState,
                    mode: state.mode
                }))
    }));



var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");


var $195EM = parcelRequire("195EM");

const $40080e79ec1add96$var$POLL_INTERVAL_MS = 3000;
// SSM-driven subnet scans are slower than the NVR refresh; give them 5 minutes.
const $40080e79ec1add96$var$MAX_WAIT_MS = 300000;
const $40080e79ec1add96$export$5b9b108f994ff600 = (taskId, startTime)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const { setHosts: setHosts, setScanStatus: setScanStatus, setErrorMessage: setErrorMessage } = (0, $7efbe771df2391dd$export$b37e90458ab57966).getState();
    const finishFailed = (message)=>{
        setErrorMessage(message);
        setScanStatus("failed");
    };
    if (Date.now() - startTime > $40080e79ec1add96$var$MAX_WAIT_MS) {
        finishFailed("Scan timed out. Please try again.");
        return;
    }
    AxiosUI.get(`network-auto-discovery/${taskId}/`).then((response)=>{
        const data = response.data || {};
        if (data.status === "success") {
            setHosts(data.result?.hosts ?? []);
            setScanStatus("success");
            return;
        }
        if (data.status === "failed") {
            finishFailed(data.detail || data.error || "Discovery job failed.");
            return;
        }
        // pending (or unknown) — keep polling
        setTimeout(()=>$40080e79ec1add96$export$5b9b108f994ff600(taskId, startTime), $40080e79ec1add96$var$POLL_INTERVAL_MS);
    }, (_reason)=>{
        // Transient poll error — retry until the max wait elapses.
        setTimeout(()=>$40080e79ec1add96$export$5b9b108f994ff600(taskId, startTime), $40080e79ec1add96$var$POLL_INTERVAL_MS);
    });
};


const $8c0f6a5975d65f58$export$555379c717f75d23 = ({ tunnelId: tunnelId, credentials: credentials, subnet: subnet, navigate: navigate })=>{
    const { setScanStatus: setScanStatus, setTaskId: setTaskId, setHosts: setHosts, setErrorMessage: setErrorMessage, setSelectedKeys: setSelectedKeys, setScanCredentials: setScanCredentials } = (0, $7efbe771df2391dd$export$b37e90458ab57966).getState();
    // Only send credentials that have a username filled in.
    const cleanedCredentials = credentials.filter((c)=>c.username && c.username.trim() !== "");
    setHosts([]);
    setSelectedKeys({});
    setErrorMessage("");
    setTaskId(null);
    // Freeze the exact list that goes to the scan: results identify the
    // authenticating credential by index into it, and the operator may edit the
    // credential rows (or the filter may drop some) before onboarding runs.
    setScanCredentials(cleanedCredentials);
    setScanStatus("pending");
    const AxiosUI = (0, $195EM.createApi)("");
    const body = {
        tunnel_id: tunnelId,
        credentials: cleanedCredentials
    };
    if (subnet && subnet.trim() !== "") body.subnet = subnet.trim();
    const retryFunction = ()=>$8c0f6a5975d65f58$export$555379c717f75d23({
            tunnelId: tunnelId,
            credentials: credentials,
            subnet: subnet,
            navigate: navigate
        });
    AxiosUI.post("network-auto-discovery/", body).then((response)=>{
        const taskId = response.data?.task_id;
        if (!taskId) {
            setErrorMessage("Scan did not return a task id.");
            setScanStatus("failed");
            return;
        }
        setTaskId(taskId);
        (0, $40080e79ec1add96$export$5b9b108f994ff600)(taskId, Date.now());
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            const data = reason.response?.data;
            setErrorMessage(data?.error || "Failed to start the scan. Please try again.");
            setScanStatus("failed");
        });
    });
};



var $195EM = parcelRequire("195EM");

var $815yO = parcelRequire("815yO");

var $3Zv1D = parcelRequire("3Zv1D");



var $7kQyB = parcelRequire("7kQyB");
const $e70c4d2af2c79dd6$var$DEFAULT_RTSP_PORT = 554;
const $e70c4d2af2c79dd6$export$1e06de1a69299a8b = (uri, fallbackIp = "")=>{
    const empty = {
        ip: fallbackIp,
        port: $e70c4d2af2c79dd6$var$DEFAULT_RTSP_PORT,
        path: "",
        username: "",
        password: ""
    };
    if (!uri || typeof uri !== "string") return empty;
    // Strip scheme (rtsp:// or rtsps://); tolerate a missing scheme.
    const withoutScheme = uri.replace(/^rtsps?:\/\//i, "");
    // Split authority from path at the first "/".
    const slashIndex = withoutScheme.indexOf("/");
    const authority = slashIndex === -1 ? withoutScheme : withoutScheme.slice(0, slashIndex);
    const path = slashIndex === -1 ? "" : withoutScheme.slice(slashIndex); // keeps leading "/"
    // Split optional credentials from host:port at the last "@".
    let credsPart = "";
    let hostPart = authority;
    const atIndex = authority.lastIndexOf("@");
    if (atIndex !== -1) {
        credsPart = authority.slice(0, atIndex);
        hostPart = authority.slice(atIndex + 1);
    }
    let username = "";
    let password = "";
    if (credsPart) {
        const colon = credsPart.indexOf(":");
        if (colon === -1) username = decodeURIComponent(credsPart);
        else {
            username = decodeURIComponent(credsPart.slice(0, colon));
            password = decodeURIComponent(credsPart.slice(colon + 1));
        }
    }
    // IPv6 literal (e.g. [::1]:554) — return the bracketed host, skip port parse.
    if (hostPart.startsWith("[")) return {
        ip: hostPart || fallbackIp,
        port: $e70c4d2af2c79dd6$var$DEFAULT_RTSP_PORT,
        path: path,
        username: username,
        password: password
    };
    let ip = hostPart;
    let port = $e70c4d2af2c79dd6$var$DEFAULT_RTSP_PORT;
    const portColon = hostPart.lastIndexOf(":");
    if (portColon !== -1) {
        ip = hostPart.slice(0, portColon);
        const parsedPort = Number(hostPart.slice(portColon + 1));
        if (Number.isFinite(parsedPort) && parsedPort > 0) port = parsedPort;
    }
    return {
        ip: ip || fallbackIp,
        port: port,
        path: path,
        username: username,
        password: password
    };
};


const $8d15214ca8a77ddd$export$7d73c8281356c623 = (camera, credentials, parsedUsername, parsedPassword)=>{
    if (parsedUsername) return {
        username: parsedUsername,
        password: parsedPassword
    };
    const index = camera.credentialIndex;
    if (index != null && index >= 0 && index < credentials.length) return credentials[index];
    if (camera.onvifUsernameUsed) {
        const match = credentials.find((c)=>c.username === camera.onvifUsernameUsed);
        if (match) return match;
    }
    return credentials[0] || {
        username: "",
        password: ""
    };
};
const $8d15214ca8a77ddd$export$11f05d775b794f28 = (camera, credentials)=>{
    const parsed = (0, $e70c4d2af2c79dd6$export$1e06de1a69299a8b)(camera.rtspUri, camera.ip);
    const cred = $8d15214ca8a77ddd$export$7d73c8281356c623(camera, credentials, parsed.username, parsed.password);
    const vendorParts = [
        camera.manufacturer,
        camera.model
    ].filter((p)=>!!p && `${p}`.trim() !== "");
    const vendor = vendorParts.length > 0 ? vendorParts.join(" ") : "ONVIF Camera";
    // Channel-qualified, because one NVR host can contribute several cameras and
    // CameraOnboardingSerializer.check_valid_camera_name rejects duplicate names
    // within a site -- an unqualified name would onboard the first channel and
    // fail every one after it.
    const channelSuffix = camera.channel == null ? "" : ` ch${camera.channel}`;
    const cameraName = `${vendor} ${camera.ip}${channelSuffix}`.trim();
    // Products come from the site's onboarding selection; camera_view defaults to
    // "normal". Both are required by the RTSP camera onboarding submit_object.
    let products = [];
    try {
        products = JSON.parse(localStorage.getItem("selectedProducts") || "[]");
    } catch  {
        products = [];
    }
    return {
        products: products,
        camera_view: "normal",
        camera_name: cameraName,
        ip: parsed.ip,
        rtsp: parsed.port,
        tcp: parsed.port,
        http: 80,
        // The RTSP stream path derived from ONVIF GetStreamUri.
        channel: parsed.path,
        username: cred.username,
        password: cred.password,
        camera_type: "",
        stream_parameters: "",
        // Extras carried through in case the rtsp integration template references
        // the full stream URL rather than decomposed fields.
        rtsp_url: camera.rtspUri,
        stream_url: camera.rtspUri
    };
};


const $493f85016dbef01e$export$8077b7bd445fdd8e = async (selectedCameras, credentials, siteId, setSubmitting, navigate, tunnelServerId, onSuccess)=>{
    if (selectedCameras.length === 0) return;
    setSubmitting(true);
    // Set the site's WireGuard availability zone to the server behind the tunnel we
    // scanned, so the site is tied to the same AZ as its cameras' tunnel.
    if (tunnelServerId != null) try {
        const customerApi = (0, $195EM.createApi)("");
        // The /about/ action uses SiteAboutSerializer, where `wireguard` is
        // writable (a plain customer PATCH ignores it).
        await customerApi.patch(`customer/${siteId}/about/`, {
            wireguard: tunnelServerId
        });
    } catch  {
    // Non-fatal: cameras still add; AZ can be set later on Site About.
    }
    // Ensure the site's onboarding template (submit_object + forms) is loaded.
    await (0, $7kQyB.fetchAddCameraInfo)(siteId, navigate, {
        silent: true
    });
    const addCameraInfo = (0, $20c574c628764d10$export$d63df7ba22be0539)();
    const submitObject = addCameraInfo?.submit_object;
    const forms = addCameraInfo?.forms;
    const onboardingApi = (0, $195EM.createApi)("camera/onboarding/");
    const failures = [];
    for (const camera of selectedCameras){
        const values = (0, $8d15214ca8a77ddd$export$11f05d775b794f28)(camera, credentials);
        const body = (0, $7594ecf03fc2d0d0$export$3bad86e60f9f9c4e)(values, submitObject, forms);
        try {
            // eslint-disable-next-line no-await-in-loop
            await onboardingApi.post("", body);
        } catch (error) {
            failures.push(`${camera.ip} (${camera.rtspUri})`);
        }
    }
    // Refetch the site cameras so SiteAbout shows the newly added ones on arrival.
    const AxiosUI = (0, $195EM.createApi)("");
    await AxiosUI.get(`camera/site/?customer__id=${siteId}`).then((response)=>{
        localStorage.setItem("siteCameras", JSON.stringify(response.data));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, ()=>{}, ()=>{});
    });
    (0, $815yO.markSiteUnsynced)();
    setSubmitting(false);
    if (failures.length > 0) alert(`Some cameras could not be added:\n${failures.join("\n")}\n\nThe rest were added successfully.`);
    if (onSuccess) onSuccess();
    else navigate(`/sites/aboutsite/${siteId}`);
};


const $ff104a2f8e12e3fe$var$roleForIndex = (streamIndex)=>{
    if (streamIndex == null) return "";
    return streamIndex === 0 ? "main" : `sub${streamIndex}`;
};
const $ff104a2f8e12e3fe$var$firstNumber = (value)=>{
    if (value == null) return null;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
};
const $ff104a2f8e12e3fe$export$2b42a525fcb5b262 = (profile)=>{
    const uri = profile.rtsp_uri || "";
    const token = profile.profile_token || "";
    let channel = null;
    let streamIndex = null;
    // 1. Query args on the RTSP URI. `Ch=`/`Streamtype=` is LTS
    //    (`/video/livemedia?Ch=1&Streamtype=0`).
    const channelQuery = uri.match(/[?&](?:channel|ch)=(\d+)/i);
    if (channelQuery) channel = $ff104a2f8e12e3fe$var$firstNumber(channelQuery[1]);
    const subtypeQuery = uri.match(/[?&](?:subtype|stream|streamtype)=(\d+)/i);
    if (subtypeQuery) streamIndex = $ff104a2f8e12e3fe$var$firstNumber(subtypeQuery[1]);
    // 2. Hikvision channel id in the path.
    if (channel == null) {
        const hikvision = uri.match(/\/Streaming\/Channels\/(\d+)/i);
        if (hikvision) {
            const channelId = $ff104a2f8e12e3fe$var$firstNumber(hikvision[1]);
            if (channelId != null) {
                // 101 -> channel 1 stream 0; a bare "1" means channel 1 with no stream id.
                channel = channelId >= 100 ? Math.floor(channelId / 100) : channelId;
                const trailing = channelId >= 100 ? channelId % 100 : 0;
                if (streamIndex == null && trailing > 0) streamIndex = trailing - 1;
            }
        }
    }
    // 3. Dahua-style profile token: three channel digits (0-based) + two stream digits.
    if (channel == null) {
        const dahuaToken = token.match(/(\d{3})(\d{2})$/);
        if (dahuaToken) {
            const channelIndex = $ff104a2f8e12e3fe$var$firstNumber(dahuaToken[1]);
            if (channelIndex != null) channel = channelIndex + 1;
            if (streamIndex == null) streamIndex = $ff104a2f8e12e3fe$var$firstNumber(dahuaToken[2]);
        }
    }
    // 4. /media/videoN — one channel, stream N-1.
    if (channel == null) {
        const mediaVideo = uri.match(/\/media\/video(\d+)/i);
        if (mediaVideo) {
            const videoNumber = $ff104a2f8e12e3fe$var$firstNumber(mediaVideo[1]);
            if (videoNumber != null && videoNumber >= 1) {
                channel = 1;
                if (streamIndex == null) streamIndex = videoNumber - 1;
            }
        }
    }
    // 5. Profile name ending in "MainStream" / "SubStreamN" -- the office LTS
    //    names them "MediaProfile_Channel1_MainStream". Only the stream,
    //    never the channel: the name says nothing about which camera it is. This
    //    matters most when the device omits its encoder config (H.265 on Media1),
    //    since there is then no resolution to fall back on either.
    if (streamIndex == null) {
        const name = (profile.profile_name || "").replace(/[\s_-]/g, "");
        if (/mainstream$/i.test(name)) streamIndex = 0;
        else {
            const sub = name.match(/substream(\d*)$/i);
            if (sub) streamIndex = sub[1] ? $ff104a2f8e12e3fe$var$firstNumber(sub[1]) : 1;
        }
    }
    return {
        channel: channel,
        streamIndex: streamIndex,
        role: $ff104a2f8e12e3fe$var$roleForIndex(streamIndex)
    };
};



const $5e211e7a5f5eafd8$var$formatResolution = (width, height)=>{
    if (width && height) return `${width}x${height}`;
    return undefined;
};
const $5e211e7a5f5eafd8$var$NO_CHANNEL = "single";
/**
 * Pick the stream to onboard by default for one channel.
 *
 * Stream index wins over resolution: it is the vendor's own main/sub numbering
 * and stays correct even when the device misreports its encoder settings. Some
 * firmware answers every encoder query with one shared config, which makes every
 * profile look identical and turns a resolution-based choice into "whichever the
 * device happened to list first". Resolution is only the tiebreak.
 */ const $5e211e7a5f5eafd8$var$pickPrimary = (options)=>{
    const areaOf = (option)=>{
        const [w, h] = (option.resolution || "0x0").split("x").map(Number);
        return (w || 0) * (h || 0);
    };
    return options.reduce((best, option)=>{
        const bestIndex = best.streamIndex;
        const optionIndex = option.streamIndex;
        if (optionIndex != null && bestIndex != null && optionIndex !== bestIndex) return optionIndex < bestIndex ? option : best;
        if (optionIndex != null && bestIndex == null) return option;
        if (optionIndex == null && bestIndex != null) return best;
        return areaOf(option) > areaOf(best) ? option : best;
    });
};
const $5e211e7a5f5eafd8$var$toProfileOption = (profile, index)=>{
    const { streamIndex: streamIndex, role: role } = (0, $ff104a2f8e12e3fe$export$2b42a525fcb5b262)(profile);
    const token = profile.profile_token || String(index);
    const resolution = $5e211e7a5f5eafd8$var$formatResolution(profile.resolution_width, profile.resolution_height);
    const path = (0, $e70c4d2af2c79dd6$export$1e06de1a69299a8b)(profile.rtsp_uri).path;
    // The path is part of the label on purpose: when a device reports the same
    // resolution for every stream, the path is the only thing that distinguishes
    // "/cam/realmonitor?channel=2&subtype=0" from "...&subtype=2".
    //
    // A resolution the device's own encoder options exclude is known to be wrong
    // (some NVR firmware reports one shared config for every profile through every
    // ONVIF operation), so it is marked rather than stated as fact.
    const resolutionLabel = resolution && profile.resolution_supported === false ? `${resolution} (unverified)` : resolution;
    const labelParts = [
        role,
        resolutionLabel,
        profile.encoding
    ].filter(Boolean);
    const label = labelParts.length > 0 ? labelParts.join(" \xb7 ") : token;
    return {
        token: token,
        rtspUri: profile.rtsp_uri,
        resolution: resolution,
        encoding: profile.encoding,
        label: path ? `${label} \xb7 ${path}` : label,
        streamIndex: streamIndex,
        role: role,
        path: path,
        resolutionSupported: profile.resolution_supported ?? null
    };
};
const $5e211e7a5f5eafd8$export$d84ed2485a858a4e = (hosts)=>{
    const cameras = [];
    (hosts || []).forEach((host)=>{
        const profiles = (host.profiles || []).filter((p)=>!!p.rtsp_uri);
        if (profiles.length === 0) return;
        // Group by channel, preserving the order the device returned them in.
        const byChannel = new Map();
        const channelNumbers = new Map();
        profiles.forEach((profile, index)=>{
            const { channel: channel } = (0, $ff104a2f8e12e3fe$export$2b42a525fcb5b262)(profile);
            const key = channel == null ? $5e211e7a5f5eafd8$var$NO_CHANNEL : String(channel);
            if (!byChannel.has(key)) {
                byChannel.set(key, []);
                channelNumbers.set(key, channel);
            }
            byChannel.get(key).push($5e211e7a5f5eafd8$var$toProfileOption(profile, index));
        });
        byChannel.forEach((profileOptions, channelKey)=>{
            const channel = channelNumbers.get(channelKey) ?? null;
            const primary = $5e211e7a5f5eafd8$var$pickPrimary(profileOptions);
            // Every stream reporting the same resolution means the device's encoder
            // data cannot distinguish them -- either genuinely identical streams or,
            // far more often, firmware answering every encoder query with one config.
            // Streams with no reported resolution (no encoder config, e.g. H.265 on
            // Media1) are left out: the device said nothing, so it contradicted
            // nothing.
            const reported = profileOptions.filter((option)=>!!option.resolution);
            const distinctResolutions = new Set(reported.map((option)=>option.resolution));
            const resolutionsAmbiguous = reported.length > 1 && distinctResolutions.size === 1 || profileOptions.some((option)=>option.resolutionSupported === false);
            cameras.push({
                key: channel == null ? host.ip : `${host.ip}::${channel}`,
                ip: host.ip,
                manufacturer: host.onvif?.manufacturer,
                model: host.onvif?.model,
                resolution: primary.resolution,
                rtspUri: primary.rtspUri,
                onvifUsernameUsed: host.onvif_username_used ?? null,
                credentialIndex: host.onvif_credential_index ?? null,
                profileToken: primary.token,
                channel: channel,
                resolutionsAmbiguous: resolutionsAmbiguous,
                profiles: profileOptions
            });
        });
    });
    return cameras;
};


const $e8db57e197dae36c$export$9d17a79a735d4369 = (host)=>host.onvif_auth_status === "success" && !(host.profiles || []).some((profile)=>!!profile.rtsp_uri);
// Cameras that count failed logins say so in the SOAP fault, e.g.
// "Invalid username or password! You still have 12 attempt(s)."
const $e8db57e197dae36c$var$LOCKOUT_PATTERN = /attempt\(s\)|attempts remaining|locked/i;
const $e8db57e197dae36c$export$fb6870c0a3b2a565 = (hosts)=>{
    const authFailedIps = [];
    const noStreamIps = [];
    let lockoutRisk = false;
    (hosts || []).forEach((host)=>{
        if ($e8db57e197dae36c$export$9d17a79a735d4369(host)) {
            noStreamIps.push(host.ip);
            return;
        }
        if (host.onvif_auth_status !== "auth_failed") return;
        authFailedIps.push(host.ip);
        if (host.onvif_error && $e8db57e197dae36c$var$LOCKOUT_PATTERN.test(host.onvif_error)) lockoutRisk = true;
    });
    return {
        authFailedIps: authFailedIps,
        lockoutRisk: lockoutRisk,
        noStreamIps: noStreamIps
    };
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kbChx = parcelRequire("kbChx");
var $7UDCh = parcelRequire("7UDCh");
var $cxknk = parcelRequire("cxknk");
var $4reBM = parcelRequire("4reBM");
var $2eEqG = parcelRequire("2eEqG");
var $k8Qy8 = parcelRequire("k8Qy8");
var $gXvgZ = parcelRequire("gXvgZ");
var $aVDw9 = parcelRequire("aVDw9");
var $3Nm8Z = parcelRequire("3Nm8Z");
var $ha39s = parcelRequire("ha39s");
var $4o6Cs = parcelRequire("4o6Cs");
var $cVCJe = parcelRequire("cVCJe");

var $6PfL8 = parcelRequire("6PfL8");
const $2ef21cb4bc4aaba2$var$headerSx = {
    fontFamily: "Mulish",
    fontWeight: 700,
    color: "#001943"
};
const $2ef21cb4bc4aaba2$var$cellSx = {
    fontFamily: "Mulish",
    color: "#283E6D"
};
const $2ef21cb4bc4aaba2$var$AMBIGUOUS_RESOLUTION_HINT = "This device reported the same encoder settings for every stream, or a resolution its own encoder options exclude. The resolutions below are not reliable \u2014 pick the stream by its main/sub role and RTSP path.";
const $2ef21cb4bc4aaba2$var$effectiveProfileToken = (camera, selectedProfiles)=>selectedProfiles[camera.key] || camera.profileToken || camera.profiles[0]?.token || "";
const $2ef21cb4bc4aaba2$export$d1dfe2a0b516a63d = ({ cameras: cameras, selectedKeys: selectedKeys, selectedProfiles: selectedProfiles, onToggle: onToggle, onToggleAll: onToggleAll, onProfileChange: onProfileChange })=>{
    const selectedCount = cameras.filter((c)=>selectedKeys[c.key]).length;
    const allSelected = cameras.length > 0 && selectedCount === cameras.length;
    const someSelected = selectedCount > 0 && selectedCount < cameras.length;
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        sx: {
            maxHeight: "50vh"
        },
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
            stickyHeader: true,
            size: "small",
            "aria-label": "discovered cameras",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                padding: "checkbox",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                    checked: allSelected,
                                    indeterminate: someSelected,
                                    onChange: (e)=>onToggleAll(e.target.checked),
                                    inputProps: {
                                        "aria-label": "select all discovered cameras"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                sx: $2ef21cb4bc4aaba2$var$headerSx,
                                children: "IP"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                sx: $2ef21cb4bc4aaba2$var$headerSx,
                                children: "Channel"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                sx: $2ef21cb4bc4aaba2$var$headerSx,
                                children: "Manufacturer"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                sx: $2ef21cb4bc4aaba2$var$headerSx,
                                children: "Model"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                sx: $2ef21cb4bc4aaba2$var$headerSx,
                                children: "Stream"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                sx: $2ef21cb4bc4aaba2$var$headerSx,
                                children: "RTSP URL"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                    children: cameras.map((camera)=>{
                        const token = $2ef21cb4bc4aaba2$var$effectiveProfileToken(camera, selectedProfiles);
                        const activeProfile = camera.profiles.find((p)=>p.token === token) || camera.profiles[0];
                        const rtspUri = activeProfile?.rtspUri || camera.rtspUri;
                        return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            hover: true,
                            onClick: ()=>onToggle(camera.key),
                            sx: {
                                cursor: "pointer"
                            },
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    padding: "checkbox",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                        checked: !!selectedKeys[camera.key],
                                        onChange: ()=>onToggle(camera.key),
                                        onClick: (e)=>e.stopPropagation(),
                                        inputProps: {
                                            "aria-label": `select camera ${camera.ip}`
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: $2ef21cb4bc4aaba2$var$cellSx,
                                    children: camera.ip
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: $2ef21cb4bc4aaba2$var$cellSx,
                                    children: camera.channel == null ? "\u2014" : camera.channel
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: $2ef21cb4bc4aaba2$var$cellSx,
                                    children: camera.manufacturer || "\u2014"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: $2ef21cb4bc4aaba2$var$cellSx,
                                    children: camera.model || "\u2014"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                    sx: $2ef21cb4bc4aaba2$var$cellSx,
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $7UDCh.default), {
                                            size: "small",
                                            sx: {
                                                minWidth: 260
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $2eEqG.default), {
                                                value: token,
                                                onChange: (e)=>onProfileChange(camera.key, e.target.value),
                                                onClick: (e)=>e.stopPropagation(),
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    fontSize: 13
                                                },
                                                children: camera.profiles.map((p)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                        value: p.token,
                                                        sx: {
                                                            fontFamily: "Mulish",
                                                            fontSize: 13
                                                        },
                                                        children: p.label
                                                    }, p.token))
                                            })
                                        }),
                                        camera.resolutionsAmbiguous && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                            title: $2ef21cb4bc4aaba2$var$AMBIGUOUS_RESOLUTION_HINT,
                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                                                style: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 4,
                                                    marginTop: 4,
                                                    color: "#B26A00",
                                                    fontSize: 11
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6PfL8))), {
                                                        sx: {
                                                            fontSize: 14
                                                        }
                                                    }),
                                                    "Reported resolutions unreliable"
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: {
                                        ...$2ef21cb4bc4aaba2$var$cellSx,
                                        maxWidth: 360
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                        title: rtspUri,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                            style: {
                                                display: "block",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap"
                                            },
                                            children: rtspUri
                                        })
                                    })
                                })
                            ]
                        }, camera.key);
                    })
                })
            ]
        })
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $4reBM = parcelRequire("4reBM");
var $k8Qy8 = parcelRequire("k8Qy8");
var $gXvgZ = parcelRequire("gXvgZ");
var $aVDw9 = parcelRequire("aVDw9");
var $3Nm8Z = parcelRequire("3Nm8Z");
var $ha39s = parcelRequire("ha39s");
var $4o6Cs = parcelRequire("4o6Cs");

const $6168b0c37488718a$var$headerSx = {
    fontFamily: "Mulish",
    fontWeight: 700,
    color: "#001943"
};
const $6168b0c37488718a$var$cellSx = {
    fontFamily: "Mulish",
    color: "#283E6D"
};
const $6168b0c37488718a$export$c5b42a561e995f20 = ({ hosts: hosts })=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        sx: {
            maxHeight: "40vh"
        },
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
            stickyHeader: true,
            size: "small",
            "aria-label": "discovered hosts",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                sx: $6168b0c37488718a$var$headerSx,
                                children: "IP"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                sx: $6168b0c37488718a$var$headerSx,
                                children: "Open ports"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                sx: $6168b0c37488718a$var$headerSx,
                                children: "HTTP"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                sx: $6168b0c37488718a$var$headerSx,
                                children: "HTTP title / server"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                sx: $6168b0c37488718a$var$headerSx,
                                children: "ONVIF"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                    children: hosts.map((host)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            hover: true,
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: $6168b0c37488718a$var$cellSx,
                                    children: host.ip
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: $6168b0c37488718a$var$cellSx,
                                    children: (host.open_ports || []).join(", ") || "\u2014"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: $6168b0c37488718a$var$cellSx,
                                    children: host.http_status == null ? "\u2014" : host.http_status
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: $6168b0c37488718a$var$cellSx,
                                    children: host.http_title || host.http_server || "\u2014"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                    sx: $6168b0c37488718a$var$cellSx,
                                    children: [
                                        host.onvif_auth_status || "\u2014",
                                        host.onvif_error && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            style: {
                                                fontSize: 11,
                                                color: "#7A7A7A",
                                                whiteSpace: "normal"
                                            },
                                            children: host.onvif_error
                                        }),
                                        (0, $e8db57e197dae36c$export$9d17a79a735d4369)(host) && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            style: {
                                                fontSize: 11,
                                                color: "#B26A00",
                                                whiteSpace: "normal"
                                            },
                                            children: "Logged in, but the camera returned no stream address. Add it manually with its RTSP URL."
                                        })
                                    ]
                                })
                            ]
                        }, host.ip))
                })
            ]
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $3QMQN = parcelRequire("3QMQN");
var $eDfvp = parcelRequire("eDfvp");
var $a65wX = parcelRequire("a65wX");
var $6MI6A = parcelRequire("6MI6A");
var $60vL1 = parcelRequire("60vL1");
var $iKAtE = parcelRequire("iKAtE");
var $4reBM = parcelRequire("4reBM");
var $3IuQ3 = parcelRequire("3IuQ3");
var $eejVe = parcelRequire("eejVe");
var $f3puC = parcelRequire("f3puC");


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");


var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");

/**
 * Pure helpers for the "update existing cameras" mode of the scan page
 * (Camera Admin `camera-unit-scan/`). Everything here is side-effect free so
 * the request bodies and the table rows can be unit-tested without a DOM.
 */ const $dc2ecfcd50af421b$var$DEFAULT_RTSP_PORT = "554";
const $dc2ecfcd50af421b$export$63a458d87f4623e6 = ({ customerId: customerId, cameraIds: cameraIds, credentials: credentials, onvifTimeout: onvifTimeout })=>{
    const body = {
        customer_id: Number(customerId)
    };
    if (cameraIds && cameraIds.length > 0) body.camera_ids = cameraIds;
    const typed = (credentials ?? []).filter((c)=>c.username && c.username.trim() !== "").map((c)=>({
            username: c.username.trim(),
            password: c.password ?? ""
        }));
    if (typed.length > 0) body.credentials = typed;
    if (onvifTimeout != null && Number.isFinite(onvifTimeout)) body.onvif_timeout = onvifTimeout;
    return body;
};
const $dc2ecfcd50af421b$export$738ac9dc8d42b49c = (selectedIds)=>{
    const ids = Array.isArray(selectedIds) ? selectedIds : Object.entries(selectedIds).filter(([, checked])=>checked).map(([id])=>Number(id));
    return {
        camera_ids: ids.filter((id)=>Number.isFinite(id))
    };
};
const $dc2ecfcd50af421b$export$b26918a162098bf8 = {
    site: "site login",
    camera: "camera login",
    typed: "typed"
};
const $dc2ecfcd50af421b$export$78a53be771fa6924 = (kind)=>$dc2ecfcd50af421b$export$b26918a162098bf8[kind] ?? String(kind ?? "");
const $dc2ecfcd50af421b$export$4b8760309b1dbbab = (ref)=>`${ref.username || "(no username)"} (${$dc2ecfcd50af421b$export$78a53be771fa6924(ref.kind)})`;
const $dc2ecfcd50af421b$export$7fc7954715e99058 = {
    unreachable: "Unreachable",
    auth_failed: "Login rejected",
    not_onvif: "No ONVIF",
    probe_error: "Probe failed",
    no_substream: "No substream",
    smallest_stream_hd: "Smallest stream is 1080p+"
};
const $dc2ecfcd50af421b$export$4972e0e950e8cd89 = {
    ip: "Host",
    host: "Host",
    rtsp: "Port",
    rtsp_port: "Port",
    stream_parameters: "Stream path",
    stream_path: "Stream path",
    credential_id: "Login",
    credential: "Login",
    username: "Login"
};
const $dc2ecfcd50af421b$export$6a6dfaf7b868b0ed = (field)=>$dc2ecfcd50af421b$export$4972e0e950e8cd89[field] ?? field.replace(/_/g, " ");
const $dc2ecfcd50af421b$var$formatChangeValue = (value)=>{
    if (value == null || value === "") return "\u2014";
    return String(value);
};
const $dc2ecfcd50af421b$export$cace9eebf2b4b602 = (field, change)=>{
    const pair = Array.isArray(change) ? change : [
        undefined,
        change
    ];
    return `${$dc2ecfcd50af421b$export$6a6dfaf7b868b0ed(field)}: ${$dc2ecfcd50af421b$var$formatChangeValue(pair[0])} \u{2192} ${$dc2ecfcd50af421b$var$formatChangeValue(pair[1])}`;
};
// ---------------------------------------------------------------------------
// Streams
// ---------------------------------------------------------------------------
const $dc2ecfcd50af421b$var$portSuffix = (port)=>{
    const text = String(port ?? "").trim();
    return text && text !== $dc2ecfcd50af421b$var$DEFAULT_RTSP_PORT ? ` (port ${text})` : "";
};
const $dc2ecfcd50af421b$export$1fde05c5dcc8e939 = (current)=>{
    const path = String(current?.stream_parameters ?? "").trim();
    const port = $dc2ecfcd50af421b$var$portSuffix(current?.rtsp);
    if (!path && !port) return "\u2014";
    return `${path || "\u2014"}${port}`;
};
const $dc2ecfcd50af421b$export$ab2b5f889ef9d9b0 = (suggested)=>{
    if (!suggested) return "\u2014";
    const parts = [
        suggested.resolution,
        suggested.stream_path
    ].map((part)=>String(part ?? "").trim()).filter(Boolean);
    const text = parts.join(" ") + $dc2ecfcd50af421b$var$portSuffix(suggested.rtsp_port);
    return text.trim() || "\u2014";
};
const $dc2ecfcd50af421b$export$c4de33d517067414 = (suggested, credentialRefs)=>{
    if (!suggested) return "\u2014";
    const ref = suggested.credential_index != null ? (credentialRefs ?? []).find((r)=>r.index === suggested.credential_index) : undefined;
    const username = suggested.credential_username ?? ref?.username ?? "";
    if (!username) return "\u2014";
    return ref ? `${username} (${$dc2ecfcd50af421b$export$78a53be771fa6924(ref.kind)})` : username;
};
const $dc2ecfcd50af421b$export$fab59da06805c4ec = (host)=>{
    const parts = [
        host.onvif?.manufacturer,
        host.onvif?.model
    ].map((part)=>String(part ?? "").trim()).filter(Boolean);
    return parts.join(" ") || "\u2014";
};
const $dc2ecfcd50af421b$export$febce69e0efd9acd = (flags)=>{
    const order = [
        "unreachable",
        "auth_failed",
        "not_onvif",
        "probe_error",
        "no_substream",
        "smallest_stream_hd"
    ];
    const set = new Set(flags ?? []);
    return order.find((flag)=>set.has(flag)) ?? null;
};
const $dc2ecfcd50af421b$export$d9ef29bb9a3a25a0 = (host)=>{
    const flags = new Set(host.flags ?? []);
    if (flags.has("unreachable")) return {
        text: "Unreachable",
        kind: "error"
    };
    if (flags.has("not_onvif")) return {
        text: "Reachable, no ONVIF",
        kind: "error"
    };
    if (flags.has("auth_failed") || host.onvif_auth_status === "auth_failed") return {
        text: "Reachable, login rejected",
        kind: "error"
    };
    if (flags.has("probe_error")) return {
        text: "Reachable, probe failed",
        kind: "error"
    };
    if (host.onvif_auth_status === "success") return {
        text: "Reachable, ONVIF OK",
        kind: "ok"
    };
    if (host.onvif_auth_status) return {
        text: `Reachable, ONVIF ${host.onvif_auth_status}`,
        kind: "warning"
    };
    return {
        text: "Reachable",
        kind: "warning"
    };
};
const $dc2ecfcd50af421b$export$214ff71d76f80d98 = (result)=>{
    const rows = [];
    const credentialRefs = result?.credentials ?? [];
    (result?.hosts ?? []).forEach((host)=>{
        const flags = host.flags ?? [];
        const status = $dc2ecfcd50af421b$export$d9ef29bb9a3a25a0(host);
        const failure = $dc2ecfcd50af421b$export$febce69e0efd9acd(flags);
        const unit = $dc2ecfcd50af421b$export$fab59da06805c4ec(host);
        const suggestedStream = $dc2ecfcd50af421b$export$ab2b5f889ef9d9b0(host.suggested);
        const login = $dc2ecfcd50af421b$export$c4de33d517067414(host.suggested, credentialRefs);
        (host.cameras ?? []).forEach((camera)=>{
            const changes = camera.changes ?? {};
            const changeChips = Object.entries(changes).map(([field, change])=>$dc2ecfcd50af421b$export$cace9eebf2b4b602(field, change));
            const willChange = !camera.up_to_date && changeChips.length > 0;
            let changeText = null;
            if (changeChips.length === 0) {
                if (failure) changeText = $dc2ecfcd50af421b$export$7fc7954715e99058[failure] ?? failure;
                else if (camera.up_to_date) changeText = "Up to date";
                else changeText = host.suggested ? "No changes" : "No suggestion";
            }
            rows.push({
                id: camera.id,
                name: camera.name,
                active: camera.active !== false,
                host: camera.current?.ip || host.ip,
                statusText: status.text,
                statusKind: status.kind,
                unit: unit,
                currentStream: $dc2ecfcd50af421b$export$1fde05c5dcc8e939(camera.current),
                suggestedStream: suggestedStream,
                login: login,
                changeChips: changeChips,
                changeText: changeText,
                willChange: willChange,
                upToDate: Boolean(camera.up_to_date),
                canApply: Boolean(host.suggested) && willChange,
                flags: flags,
                onvifError: host.onvif_error ?? null
            });
        });
    });
    return rows;
};
const $dc2ecfcd50af421b$export$c008345b906818f5 = (rows)=>{
    const selected = {};
    rows.forEach((row)=>{
        if (row.canApply && row.willChange) selected[row.id] = true;
    });
    return selected;
};
const $dc2ecfcd50af421b$export$b238b5958b0c7de9 = (selected)=>Object.values(selected).filter(Boolean).length;



var $195EM = parcelRequire("195EM");


const $68d6421965e8bf85$var$POLL_INTERVAL_MS = 3000;
// Same budget as the discovery scan: a site can have dozens of units behind a
// VPN, each probed with several logins.
const $68d6421965e8bf85$var$MAX_WAIT_MS = 300000;
const $68d6421965e8bf85$export$5ab77c412e92fe65 = (taskId, startTime)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const { setUnitScanResult: setUnitScanResult, setUnitSelectedIds: setUnitSelectedIds, setUnitScanCredentialRefs: setUnitScanCredentialRefs, setScanStatus: setScanStatus, setErrorMessage: setErrorMessage } = (0, $7efbe771df2391dd$export$b37e90458ab57966).getState();
    const finishFailed = (message)=>{
        setErrorMessage(message);
        setScanStatus("failed");
    };
    if (Date.now() - startTime > $68d6421965e8bf85$var$MAX_WAIT_MS) {
        finishFailed("Scan timed out. Please try again.");
        return;
    }
    AxiosUI.get(`camera-unit-scan/${taskId}/`).then((response)=>{
        const data = response.data || {};
        if (data.status === "success") {
            const result = data.result ?? null;
            setUnitScanResult(result);
            if (result?.credentials) setUnitScanCredentialRefs(result.credentials);
            setUnitSelectedIds((0, $dc2ecfcd50af421b$export$c008345b906818f5)((0, $dc2ecfcd50af421b$export$214ff71d76f80d98)(result)));
            setScanStatus("success");
            return;
        }
        if (data.status === "failed") {
            finishFailed(data.detail || data.error || "Camera unit scan failed.");
            return;
        }
        // pending (or unknown) — keep polling
        setTimeout(()=>$68d6421965e8bf85$export$5ab77c412e92fe65(taskId, startTime), $68d6421965e8bf85$var$POLL_INTERVAL_MS);
    }, (_reason)=>{
        // Transient poll error — retry until the max wait elapses.
        setTimeout(()=>$68d6421965e8bf85$export$5ab77c412e92fe65(taskId, startTime), $68d6421965e8bf85$var$POLL_INTERVAL_MS);
    });
};


const $892ddaeb85e57f99$export$2b9542ddd0bb2601 = ({ siteId: siteId, credentials: credentials, cameraIds: cameraIds, navigate: navigate })=>{
    const { setScanStatus: setScanStatus, setTaskId: setTaskId, setErrorMessage: setErrorMessage, setUnitScanResult: setUnitScanResult, setUnitSelectedIds: setUnitSelectedIds, setUnitScanTargets: setUnitScanTargets, setUnitScanCredentialRefs: setUnitScanCredentialRefs, setApplyResult: setApplyResult } = (0, $7efbe771df2391dd$export$b37e90458ab57966).getState();
    setUnitScanResult(null);
    setUnitSelectedIds({});
    setApplyResult(null);
    setUnitScanTargets(null);
    setUnitScanCredentialRefs([]);
    setErrorMessage("");
    setTaskId(null);
    setScanStatus("pending");
    const AxiosUI = (0, $195EM.createApi)("");
    const body = (0, $dc2ecfcd50af421b$export$63a458d87f4623e6)({
        customerId: siteId,
        cameraIds: cameraIds,
        credentials: credentials
    });
    const retryFunction = ()=>$892ddaeb85e57f99$export$2b9542ddd0bb2601({
            siteId: siteId,
            credentials: credentials,
            cameraIds: cameraIds,
            navigate: navigate
        });
    AxiosUI.post("camera-unit-scan/", body).then((response)=>{
        const taskId = response.data?.task_id;
        if (!taskId) {
            setErrorMessage("Scan did not return a task id.");
            setScanStatus("failed");
            return;
        }
        setTaskId(taskId);
        setUnitScanTargets(response.data?.targets ?? null);
        setUnitScanCredentialRefs(response.data?.credentials ?? []);
        (0, $68d6421965e8bf85$export$5ab77c412e92fe65)(taskId, Date.now());
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            const data = reason.response?.data;
            setErrorMessage(data?.error || "Failed to start the scan. Please try again.");
            setScanStatus("failed");
        });
    });
};



var $195EM = parcelRequire("195EM");

var $815yO = parcelRequire("815yO");

var $3Zv1D = parcelRequire("3Zv1D");


const $3e9532190ebb3458$export$722d7257e0abdc20 = ({ taskId: taskId, siteId: siteId, selectedIds: selectedIds, navigate: navigate, onSuccess: onSuccess })=>{
    const { setApplying: setApplying, setApplyResult: setApplyResult, setErrorMessage: setErrorMessage } = (0, $7efbe771df2391dd$export$b37e90458ab57966).getState();
    const body = (0, $dc2ecfcd50af421b$export$738ac9dc8d42b49c)(selectedIds);
    if (body.camera_ids.length === 0) return Promise.resolve(null);
    setApplying(true);
    setErrorMessage("");
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>$3e9532190ebb3458$export$722d7257e0abdc20({
            taskId: taskId,
            siteId: siteId,
            selectedIds: selectedIds,
            navigate: navigate,
            onSuccess: onSuccess
        });
    return AxiosUI.post(`camera-unit-scan/${taskId}/apply/`, body).then((response)=>{
        const data = response.data;
        setApplyResult(data);
        if (data?.site_unsynced) (0, $815yO.markSiteUnsynced)(siteId);
        setApplying(false);
        if (onSuccess) onSuccess();
        else navigate(`/sites/aboutsite/${siteId}`);
        return data;
    }, (reason)=>{
        setApplying(false);
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            const data = reason.response?.data;
            setErrorMessage(data?.error || "Failed to apply the changes. Please try again.");
        });
        return null;
    });
};




var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kbChx = parcelRequire("kbChx");
var $6MI6A = parcelRequire("6MI6A");
var $4reBM = parcelRequire("4reBM");
var $3IuQ3 = parcelRequire("3IuQ3");
var $k8Qy8 = parcelRequire("k8Qy8");
var $gXvgZ = parcelRequire("gXvgZ");
var $aVDw9 = parcelRequire("aVDw9");
var $3Nm8Z = parcelRequire("3Nm8Z");
var $ha39s = parcelRequire("ha39s");
var $4o6Cs = parcelRequire("4o6Cs");
var $cVCJe = parcelRequire("cVCJe");
const $ee5492c050a30e8d$var$headerSx = {
    fontFamily: "Mulish",
    fontWeight: 700,
    color: "#001943"
};
const $ee5492c050a30e8d$var$cellSx = {
    fontFamily: "Mulish",
    color: "#283E6D"
};
const $ee5492c050a30e8d$var$STATUS_COLORS = {
    ok: "#1B7F3B",
    warning: "#B26A00",
    error: "#C62828"
};
const $ee5492c050a30e8d$export$c56998a076dff208 = ({ rows: rows, selectedIds: selectedIds, onToggle: onToggle, onToggleAll: onToggleAll, disabled: disabled = false })=>{
    const selectable = rows.filter((row)=>row.canApply);
    const selectedCount = selectable.filter((row)=>selectedIds[row.id]).length;
    const allSelected = selectable.length > 0 && selectedCount === selectable.length;
    const someSelected = selectedCount > 0 && selectedCount < selectable.length;
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        sx: {
            maxHeight: "55vh"
        },
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
            stickyHeader: true,
            size: "small",
            "aria-label": "camera unit scan results",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                padding: "checkbox",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                    checked: allSelected,
                                    indeterminate: someSelected,
                                    disabled: disabled || selectable.length === 0,
                                    onChange: (e)=>onToggleAll(e.target.checked),
                                    inputProps: {
                                        "aria-label": "select all cameras to update"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                sx: $ee5492c050a30e8d$var$headerSx,
                                children: "Camera"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                sx: $ee5492c050a30e8d$var$headerSx,
                                children: "Host"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                sx: $ee5492c050a30e8d$var$headerSx,
                                children: "Status"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                sx: $ee5492c050a30e8d$var$headerSx,
                                children: "Unit"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                sx: $ee5492c050a30e8d$var$headerSx,
                                children: "Current stream"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                sx: $ee5492c050a30e8d$var$headerSx,
                                children: "Suggested stream"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                sx: $ee5492c050a30e8d$var$headerSx,
                                children: "Login"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                sx: $ee5492c050a30e8d$var$headerSx,
                                children: "Change"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                    children: rows.map((row)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            hover: true,
                            selected: Boolean(selectedIds[row.id]),
                            "data-testid": `unit-scan-row-${row.id}`,
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    padding: "checkbox",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                        checked: Boolean(selectedIds[row.id]),
                                        disabled: disabled || !row.canApply,
                                        onChange: ()=>onToggle(row.id),
                                        inputProps: {
                                            "aria-label": `select ${row.name}`
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                    sx: $ee5492c050a30e8d$var$cellSx,
                                    children: [
                                        row.name,
                                        !row.active && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            style: {
                                                fontSize: 11,
                                                color: "#7A7A7A"
                                            },
                                            children: "inactive"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: $ee5492c050a30e8d$var$cellSx,
                                    children: row.host || "\u2014"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: {
                                        ...$ee5492c050a30e8d$var$cellSx,
                                        color: $ee5492c050a30e8d$var$STATUS_COLORS[row.statusKind]
                                    },
                                    children: row.onvifError ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                        title: row.onvifError,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                            children: row.statusText
                                        })
                                    }) : row.statusText
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: $ee5492c050a30e8d$var$cellSx,
                                    children: row.unit
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: {
                                        ...$ee5492c050a30e8d$var$cellSx,
                                        fontFamily: "monospace",
                                        fontSize: 12
                                    },
                                    children: row.currentStream
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: {
                                        ...$ee5492c050a30e8d$var$cellSx,
                                        fontFamily: "monospace",
                                        fontSize: 12
                                    },
                                    children: row.suggestedStream
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: $ee5492c050a30e8d$var$cellSx,
                                    children: row.login
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: $ee5492c050a30e8d$var$cellSx,
                                    children: row.changeChips.length > 0 ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $3IuQ3.default), {
                                        direction: "row",
                                        spacing: 0.5,
                                        flexWrap: "wrap",
                                        useFlexGap: true,
                                        children: row.changeChips.map((chip)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $6MI6A.default), {
                                                label: chip,
                                                size: "small",
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    fontSize: 11,
                                                    backgroundColor: "#FFF3E0",
                                                    color: "#8A4B00"
                                                }
                                            }, chip))
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                        style: {
                                            color: row.upToDate ? "#1B7F3B" : "#C62828"
                                        },
                                        children: row.changeText
                                    })
                                })
                            ]
                        }, row.id))
                })
            ]
        })
    });
};


const $e12fd98c971b3d48$var$headingSx = {
    fontFamily: "Mulish",
    fontWeight: 700,
    color: "#001943"
};
const $e12fd98c971b3d48$export$ad83332fdca09ff9 = "Reads every camera's unit over ONVIF using the site's camera login, and updates host, streaming port, stream path and login on the existing cameras.";
const $e12fd98c971b3d48$var$SUMMARY_LABELS = [
    {
        key: "hosts",
        label: "hosts"
    },
    {
        key: "reachable",
        label: "reachable"
    },
    {
        key: "authenticated",
        label: "logged in"
    },
    {
        key: "with_substream",
        label: "with substream"
    },
    {
        key: "up_to_date",
        label: "up to date"
    },
    {
        key: "will_change",
        label: "will change"
    },
    {
        key: "failed",
        label: "failed"
    }
];
const $e12fd98c971b3d48$export$a25b3375ab24f260 = ({ siteId: siteId, onSuccess: onSuccess })=>{
    const navigate = (0, $3T949.useNavigate)();
    const { credentials: credentials, setCredentials: setCredentials, scanStatus: scanStatus, errorMessage: errorMessage, taskId: taskId, unitScanTargets: unitScanTargets, unitScanCredentialRefs: unitScanCredentialRefs, unitScanResult: unitScanResult, unitSelectedIds: unitSelectedIds, setUnitSelectedIds: setUnitSelectedIds, applying: applying, applyResult: applyResult } = (0, $7efbe771df2391dd$export$b37e90458ab57966)();
    const scanning = scanStatus === "pending";
    const rows = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>(0, $dc2ecfcd50af421b$export$214ff71d76f80d98)(unitScanResult), [
        unitScanResult
    ]);
    const selectedCount = (0, $dc2ecfcd50af421b$export$b238b5958b0c7de9)(unitSelectedIds);
    const summary = unitScanResult?.summary ?? {};
    const credentialRefs = unitScanResult?.credentials && unitScanResult.credentials.length > 0 ? unitScanResult.credentials : unitScanCredentialRefs;
    const updateCredential = (index, field, value)=>{
        setCredentials(credentials.map((c, i)=>i === index ? {
                ...c,
                [field]: value
            } : c));
    };
    const addCredentialRow = ()=>setCredentials([
            ...credentials,
            {
                username: "",
                password: ""
            }
        ]);
    const removeCredentialRow = (index)=>setCredentials(credentials.filter((_, i)=>i !== index));
    const handleScan = ()=>{
        if (!siteId) return;
        (0, $892ddaeb85e57f99$export$2b9542ddd0bb2601)({
            siteId: siteId,
            credentials: credentials,
            navigate: navigate
        });
    };
    const toggle = (id)=>setUnitSelectedIds({
            ...unitSelectedIds,
            [id]: !unitSelectedIds[id]
        });
    const toggleAll = (checked)=>{
        const next = {};
        rows.forEach((row)=>{
            if (row.canApply) next[row.id] = checked;
        });
        setUnitSelectedIds(next);
    };
    const handleApply = ()=>{
        if (!taskId) return;
        (0, $3e9532190ebb3458$export$722d7257e0abdc20)({
            taskId: taskId,
            siteId: siteId,
            selectedIds: unitSelectedIds,
            navigate: navigate,
            onSuccess: onSuccess
        });
    };
    const busy = scanning || applying;
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
        sx: {
            p: 3,
            maxWidth: 1400
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                sx: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            ...$e12fd98c971b3d48$var$headingSx,
                            fontSize: 22
                        },
                        children: "Refresh camera streams"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                        variant: "contained",
                        onClick: ()=>navigate(`/sites/aboutsite/${siteId}`),
                        disabled: busy,
                        sx: {
                            fontFamily: "Mulish",
                            textTransform: "none",
                            backgroundColor: "#283E6D",
                            color: "#FFFFFF",
                            "&:hover": {
                                backgroundColor: "#1f2f54"
                            }
                        },
                        children: "Back to site"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4reBM.default), {
                sx: {
                    p: 2.5,
                    mb: 3
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            fontFamily: "Mulish",
                            color: "#283E6D",
                            mb: 2
                        },
                        children: $e12fd98c971b3d48$export$ad83332fdca09ff9
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            ...$e12fd98c971b3d48$var$headingSx,
                            fontSize: 16,
                            mb: 0.5
                        },
                        children: "Extra logins (optional)"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            fontFamily: "Mulish",
                            color: "#7A7A7A",
                            fontSize: 13,
                            mb: 1
                        },
                        children: "The site's camera login and each camera's own login are always tried. Add more here only if some units use a different one."
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3IuQ3.default), {
                        spacing: 1,
                        sx: {
                            mb: 1
                        },
                        children: credentials.map((cred, index)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $3IuQ3.default), {
                                direction: "row",
                                spacing: 1,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        size: "small",
                                        label: "Username",
                                        value: cred.username,
                                        onChange: (e)=>updateCredential(index, "username", e.target.value),
                                        disabled: busy,
                                        sx: {
                                            fontFamily: "Mulish"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        size: "small",
                                        label: "Password",
                                        type: "password",
                                        value: cred.password,
                                        onChange: (e)=>updateCredential(index, "password", e.target.value),
                                        disabled: busy,
                                        sx: {
                                            fontFamily: "Mulish"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                        "aria-label": "remove credential",
                                        onClick: ()=>removeCredentialRow(index),
                                        disabled: credentials.length <= 1 || busy,
                                        size: "small",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ea2ee23932ed374d$exports))), {
                                            fontSize: "small"
                                        })
                                    })
                                ]
                            }, index))
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                        startIcon: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6e7077adf77ebc0f$exports))), {}),
                        onClick: addCredentialRow,
                        disabled: busy,
                        sx: {
                            fontFamily: "Mulish",
                            textTransform: "none",
                            display: "block"
                        },
                        children: "Add login"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                variant: "contained",
                onClick: handleScan,
                disabled: !siteId || busy,
                sx: {
                    fontFamily: "Mulish",
                    textTransform: "none",
                    backgroundColor: "#FF8400",
                    "&:hover": {
                        backgroundColor: "#E67300"
                    }
                },
                children: scanning ? "Scanning\u2026" : "Scan"
            }),
            scanning && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3IuQ3.default), {
                spacing: 1,
                sx: {
                    mt: 3
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3IuQ3.default), {
                        direction: "row",
                        spacing: 2,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                size: 22
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                sx: {
                                    fontFamily: "Mulish",
                                    color: "#283E6D"
                                },
                                children: [
                                    "Reading",
                                    " ",
                                    unitScanTargets != null ? `${unitScanTargets} camera unit${unitScanTargets === 1 ? "" : "s"}` : "camera units",
                                    " ",
                                    "over ONVIF. This can take up to a few minutes\u2026"
                                ]
                            })
                        ]
                    }),
                    credentialRefs.length > 0 && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                        sx: {
                            fontFamily: "Mulish",
                            color: "#7A7A7A",
                            fontSize: 13
                        },
                        children: [
                            "Logins tried:",
                            " ",
                            credentialRefs.map((0, $dc2ecfcd50af421b$export$4b8760309b1dbbab)).join(", ")
                        ]
                    })
                ]
            }),
            errorMessage && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                severity: "error",
                sx: {
                    fontFamily: "Mulish",
                    mt: 3
                },
                children: errorMessage
            }),
            applyResult && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3QMQN.default), {
                severity: applyResult.skipped.length > 0 ? "warning" : "success",
                sx: {
                    fontFamily: "Mulish",
                    mt: 3
                },
                children: [
                    "Updated ",
                    applyResult.updated.length,
                    " camera",
                    applyResult.updated.length === 1 ? "" : "s",
                    applyResult.updated.length > 0 ? `: ${applyResult.updated.map((u)=>u.name).join(", ")}` : "",
                    ".",
                    applyResult.skipped.length > 0 && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        style: {
                            marginTop: 6
                        },
                        children: [
                            "Skipped ",
                            applyResult.skipped.length,
                            ":",
                            " ",
                            applyResult.skipped.map((s)=>`camera ${s.camera_id} (${s.reason})`).join(", ")
                        ]
                    })
                ]
            }),
            scanStatus === "success" && unitScanResult && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                sx: {
                    mt: 3
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3IuQ3.default), {
                        direction: "row",
                        spacing: 1,
                        flexWrap: "wrap",
                        useFlexGap: true,
                        sx: {
                            mb: 2
                        },
                        "data-testid": "unit-scan-summary",
                        children: $e12fd98c971b3d48$var$SUMMARY_LABELS.filter(({ key: key })=>summary[key] != null).map(({ key: key, label: label })=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $6MI6A.default), {
                                size: "small",
                                label: `${summary[key]} ${label}`,
                                sx: {
                                    fontFamily: "Mulish",
                                    backgroundColor: key === "will_change" ? "#FFF3E0" : key === "failed" ? "#FDECEA" : "#EEF2F8",
                                    color: "#283E6D"
                                }
                            }, key))
                    }),
                    credentialRefs.length > 0 && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                        sx: {
                            fontFamily: "Mulish",
                            color: "#7A7A7A",
                            fontSize: 13,
                            mb: 1
                        },
                        children: [
                            "Logins tried:",
                            " ",
                            credentialRefs.map((0, $dc2ecfcd50af421b$export$4b8760309b1dbbab)).join(", ")
                        ]
                    }),
                    rows.length === 0 ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                        severity: "info",
                        sx: {
                            fontFamily: "Mulish"
                        },
                        children: "The scan returned no cameras. Only cameras with a host are scanned."
                    }) : /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                sx: {
                                    ...$e12fd98c971b3d48$var$headingSx,
                                    fontSize: 16,
                                    mb: 1
                                },
                                children: [
                                    rows.length,
                                    " camera",
                                    rows.length === 1 ? "" : "s",
                                    selectedCount > 0 ? ` \u{2014} ${selectedCount} selected` : ""
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ee5492c050a30e8d$export$c56998a076dff208), {
                                rows: rows,
                                selectedIds: unitSelectedIds,
                                onToggle: toggle,
                                onToggleAll: toggleAll,
                                disabled: applying
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                variant: "contained",
                                onClick: handleApply,
                                disabled: selectedCount === 0 || busy || !taskId,
                                sx: {
                                    fontFamily: "Mulish",
                                    textTransform: "none",
                                    mt: 2,
                                    backgroundColor: "#FF8400",
                                    "&:hover": {
                                        backgroundColor: "#E67300"
                                    }
                                },
                                children: applying ? "Applying\u2026" : `Apply to ${selectedCount} camera${selectedCount === 1 ? "" : "s"}`
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


const $bdc6a10e1e107a47$var$headingSx = {
    fontFamily: "Mulish",
    fontWeight: 700,
    color: "#001943"
};
const $bdc6a10e1e107a47$export$a3aa0757d1516cc5 = (props)=>{
    const { siteId: siteIdParam } = (0, $3T949.useParams)();
    const siteId = props.siteIdOverride ?? siteIdParam ?? "";
    if (props.mode === "update") // Update mode never touches WireGuard: no tunnel fetch, no subnet, no
    // `wireguard` PATCH. It is a separate component so none of the discovery
    // effects below run.
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $e12fd98c971b3d48$export$a25b3375ab24f260), {
        siteId: siteId,
        onSuccess: props.onSuccess
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)($bdc6a10e1e107a47$var$OnvifDiscoverScreen, {
        ...props
    });
};
const $bdc6a10e1e107a47$var$OnvifDiscoverScreen = ({ variant: variant = "page", onSuccess: onSuccess, onNoTunnels: onNoTunnels, siteIdOverride: siteIdOverride })=>{
    const navigate = (0, $3T949.useNavigate)();
    const { siteId: siteIdParam } = (0, $3T949.useParams)();
    const siteId = siteIdOverride ?? siteIdParam ?? "";
    const isOnboarding = variant === "onboarding";
    const [tunnels, setTunnels] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [tunnelsLoading, setTunnelsLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [tunnelsError, setTunnelsError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const { tunnelId: tunnelId, setTunnelId: setTunnelId, credentials: credentials, setCredentials: setCredentials, scanCredentials: scanCredentials, subnet: subnet, setSubnet: setSubnet, scanStatus: scanStatus, hosts: hosts, errorMessage: errorMessage, selectedKeys: selectedKeys, setSelectedKeys: setSelectedKeys, selectedProfiles: selectedProfiles, setSelectedProfile: setSelectedProfile, submitting: submitting, setSubmitting: setSubmitting } = (0, $7efbe771df2391dd$export$b37e90458ab57966)();
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!siteId) return;
        let cancelled = false;
        setTunnelsLoading(true);
        // Only existing tunnels in this site's group hierarchy — never provision one.
        (0, $h5NlZ.fetchWireguardTunnelsForCustomer)(siteId).then((result)=>{
            if (cancelled) return;
            setTunnels(result);
            if (result.length > 0 && tunnelId == null) setTunnelId(result[0].id);
        }).catch(()=>{
            if (!cancelled) setTunnelsError("Failed to load WireGuard tunnels for this site.");
        }).finally(()=>{
            if (!cancelled) setTunnelsLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        siteId
    ]);
    // Onboarding: show the empty-tunnel warning briefly, then leave for Site About.
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!isOnboarding || !onNoTunnels || tunnelsLoading || tunnels.length > 0) return;
        const timeoutId = window.setTimeout(()=>{
            onNoTunnels();
        }, 2500);
        return ()=>{
            window.clearTimeout(timeoutId);
        };
    }, [
        isOnboarding,
        onNoTunnels,
        tunnelsLoading,
        tunnels.length
    ]);
    const cameras = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>(0, $5e211e7a5f5eafd8$export$d84ed2485a858a4e)(hosts), [
        hosts
    ]);
    const hostSummary = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>(0, $e8db57e197dae36c$export$fb6870c0a3b2a565)(hosts), [
        hosts
    ]);
    // Apply the chosen stream/profile per camera (defaults to the primary).
    const selectedCameras = cameras.filter((c)=>selectedKeys[c.key]).map((c)=>{
        const token = selectedProfiles[c.key];
        const profile = token ? c.profiles.find((p)=>p.token === token) : undefined;
        return profile ? {
            ...c,
            rtspUri: profile.rtspUri,
            resolution: profile.resolution,
            profileToken: profile.token
        } : c;
    });
    const scanning = scanStatus === "pending";
    const updateCredential = (index, field, value)=>{
        const next = credentials.map((c, i)=>i === index ? {
                ...c,
                [field]: value
            } : c);
        setCredentials(next);
    };
    const addCredentialRow = ()=>setCredentials([
            ...credentials,
            {
                username: "",
                password: ""
            }
        ]);
    const removeCredentialRow = (index)=>setCredentials(credentials.filter((_, i)=>i !== index));
    const handleScan = ()=>{
        if (tunnelId == null) return;
        // Auto-select the site's WireGuard endpoint (AZ) from the tunnel being
        // scanned, so the General Info WireGuard selector reflects it without the
        // operator having to set it manually. Best-effort; the scan proceeds either way.
        const scannedServer = tunnels.find((t)=>t.id === tunnelId)?.server;
        if (scannedServer != null && siteId) (0, $195EM.createApi)("").patch(`customer/${siteId}/about/`, {
            wireguard: scannedServer
        }).catch(()=>{});
        (0, $8c0f6a5975d65f58$export$555379c717f75d23)({
            tunnelId: tunnelId,
            credentials: credentials,
            subnet: subnet,
            navigate: navigate
        });
    };
    const toggle = (key)=>setSelectedKeys({
            ...selectedKeys,
            [key]: !selectedKeys[key]
        });
    const toggleAll = (checked)=>{
        const next = {};
        cameras.forEach((c)=>{
            next[c.key] = checked;
        });
        setSelectedKeys(next);
    };
    const hasCredential = credentials.some((c)=>c.username && c.username.trim() !== "");
    const canScan = tunnelId != null && hasCredential && !scanning && !submitting;
    // Onboarding with no tunnels: message only (redirect handled by effect above).
    // Hold an empty frame while tunnels load so the scan form does not flash first.
    if (isOnboarding && (tunnelsLoading || tunnels.length === 0)) {
        if (tunnelsLoading) return null;
        return /*#__PURE__*/ (0, $k4ank.jsx)("p", {
            className: "absolute first-line:font-black font-mulish text-[20px] right-[40px] left-10 text-center text-[#283E6D] top-80",
            children: "This site's group has no WireGuard tunnels. A tunnel is required to scan the customer network. Rerouting to site's about page..."
        });
    }
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
        sx: {
            p: 3,
            maxWidth: isOnboarding ? "100%" : 1100
        },
        children: [
            !isOnboarding && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                sx: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 2
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            ...$bdc6a10e1e107a47$var$headingSx,
                            fontSize: 22
                        },
                        children: "ONVIF Camera Discovery"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                        variant: "contained",
                        onClick: ()=>navigate(`/sites/aboutsite/${siteId}`),
                        disabled: scanning || submitting,
                        sx: {
                            fontFamily: "Mulish",
                            textTransform: "none",
                            backgroundColor: "#283E6D",
                            color: "#FFFFFF",
                            "&:hover": {
                                backgroundColor: "#1f2f54"
                            }
                        },
                        children: "Skip for now"
                    })
                ]
            }),
            tunnelsError && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                severity: "error",
                sx: {
                    fontFamily: "Mulish",
                    mb: 2
                },
                children: tunnelsError
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4reBM.default), {
                sx: {
                    p: 2.5,
                    mb: 3
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                        sx: {
                            minWidth: 320,
                            mb: 3
                        },
                        size: "small",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $6gU8O.default), {
                                id: "onvif-tunnel-label",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: "Target tunnel"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $2eEqG.default), {
                                labelId: "onvif-tunnel-label",
                                label: "Target tunnel",
                                value: tunnelId != null && tunnels.length > 0 ? tunnelId : "",
                                onChange: (e)=>setTunnelId(Number(e.target.value)),
                                disabled: tunnelsLoading || scanning,
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: tunnels.map((t)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $cxknk.default), {
                                        value: t.id,
                                        sx: {
                                            fontFamily: "Mulish"
                                        },
                                        children: [
                                            t.name,
                                            t.subnets && t.subnets.length > 0 ? ` \u{2014} ${t.subnets.join(", ")}` : ""
                                        ]
                                    }, t.id))
                            })
                        ]
                    }),
                    !isOnboarding && !tunnelsLoading && tunnels.length === 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                        severity: "warning",
                        sx: {
                            fontFamily: "Mulish",
                            mb: 2
                        },
                        children: "This site's group has no WireGuard tunnels. A tunnel is required to scan the customer network."
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            ...$bdc6a10e1e107a47$var$headingSx,
                            fontSize: 16,
                            mb: 1
                        },
                        children: "ONVIF credentials"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3IuQ3.default), {
                        spacing: 1,
                        sx: {
                            mb: 1
                        },
                        children: credentials.map((cred, index)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $3IuQ3.default), {
                                direction: "row",
                                spacing: 1,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        size: "small",
                                        label: "Username",
                                        value: cred.username,
                                        onChange: (e)=>updateCredential(index, "username", e.target.value),
                                        disabled: scanning,
                                        sx: {
                                            fontFamily: "Mulish"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        size: "small",
                                        label: "Password",
                                        type: "password",
                                        value: cred.password,
                                        onChange: (e)=>updateCredential(index, "password", e.target.value),
                                        disabled: scanning,
                                        sx: {
                                            fontFamily: "Mulish"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                        "aria-label": "remove credential",
                                        onClick: ()=>removeCredentialRow(index),
                                        disabled: credentials.length <= 1 || scanning,
                                        size: "small",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ea2ee23932ed374d$exports))), {
                                            fontSize: "small"
                                        })
                                    })
                                ]
                            }, index))
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                        startIcon: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6e7077adf77ebc0f$exports))), {}),
                        onClick: addCredentialRow,
                        disabled: scanning,
                        sx: {
                            fontFamily: "Mulish",
                            textTransform: "none",
                            mb: 3,
                            display: "block"
                        },
                        children: "Add credential"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                            size: "small",
                            label: "Subnet override (optional)",
                            placeholder: "e.g. 192.168.1.0/24",
                            value: subnet,
                            onChange: (e)=>setSubnet(e.target.value),
                            disabled: scanning,
                            helperText: "Defaults to the tunnel's first subnet.",
                            sx: {
                                minWidth: 320,
                                fontFamily: "Mulish"
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                variant: "contained",
                onClick: handleScan,
                disabled: !canScan,
                sx: {
                    fontFamily: "Mulish",
                    textTransform: "none",
                    backgroundColor: "#FF8400",
                    "&:hover": {
                        backgroundColor: "#E67300"
                    }
                },
                children: scanning ? "Scanning\u2026" : "Scan for cameras"
            }),
            scanning && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3IuQ3.default), {
                direction: "row",
                spacing: 2,
                alignItems: "center",
                sx: {
                    mt: 3
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                        size: 22
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            fontFamily: "Mulish",
                            color: "#283E6D"
                        },
                        children: "Scanning the network over the tunnel. This can take up to a few minutes\u2026"
                    })
                ]
            }),
            scanStatus === "failed" && errorMessage && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                severity: "error",
                sx: {
                    fontFamily: "Mulish",
                    mt: 3
                },
                children: errorMessage
            }),
            scanStatus === "success" && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                sx: {
                    mt: 3
                },
                children: [
                    hostSummary.authFailedIps.length > 0 && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3QMQN.default), {
                        severity: "warning",
                        sx: {
                            fontFamily: "Mulish",
                            mb: 2
                        },
                        children: [
                            hostSummary.authFailedIps.length,
                            " host",
                            hostSummary.authFailedIps.length === 1 ? "" : "s",
                            " responded to ONVIF but rejected the credential",
                            credentials.length === 1 ? "" : "s",
                            " supplied. These are likely cameras \u2014 add their credentials above and scan again:",
                            " ",
                            hostSummary.authFailedIps.join(", "),
                            hostSummary.lockoutRisk && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                style: {
                                    marginTop: 6
                                },
                                children: "At least one device is counting failed logins. Repeated scans with the wrong credentials can lock it out \u2014 confirm the credentials before re-scanning."
                            })
                        ]
                    }),
                    hosts.length > 0 && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                        sx: {
                            mb: 3
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                sx: {
                                    ...$bdc6a10e1e107a47$var$headingSx,
                                    fontSize: 16,
                                    mb: 1
                                },
                                children: [
                                    hosts.length,
                                    " host",
                                    hosts.length === 1 ? "" : "s",
                                    " discovered"
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $6168b0c37488718a$export$c5b42a561e995f20), {
                                hosts: hosts
                            })
                        ]
                    }),
                    cameras.length === 0 ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3QMQN.default), {
                        severity: "info",
                        sx: {
                            fontFamily: "Mulish"
                        },
                        children: [
                            "No ONVIF cameras with an RTSP stream were found.",
                            " ",
                            hostSummary.noStreamIps.length > 0 ? `Logged in to ${hostSummary.noStreamIps.join(", ")}, but ` + "the device returned no stream address. Add it manually " + "with its RTSP URL." : "Check the credentials and subnet, then scan again."
                        ]
                    }) : /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                sx: {
                                    ...$bdc6a10e1e107a47$var$headingSx,
                                    fontSize: 16,
                                    mb: 1
                                },
                                children: [
                                    cameras.length,
                                    " camera",
                                    cameras.length === 1 ? "" : "s",
                                    " found",
                                    selectedCameras.length > 0 ? ` \u{2014} ${selectedCameras.length} selected` : ""
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $2ef21cb4bc4aaba2$export$d1dfe2a0b516a63d), {
                                cameras: cameras,
                                selectedKeys: selectedKeys,
                                selectedProfiles: selectedProfiles,
                                onToggle: toggle,
                                onToggleAll: toggleAll,
                                onProfileChange: setSelectedProfile
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                variant: "contained",
                                onClick: ()=>(0, $493f85016dbef01e$export$8077b7bd445fdd8e)(selectedCameras, // The list the scan used, in scan order: results identify the
                                    // authenticating credential by index into exactly this list.
                                    scanCredentials.length > 0 ? scanCredentials : credentials, siteId, setSubmitting, navigate, tunnels.find((t)=>t.id === tunnelId)?.server ?? null, onSuccess),
                                disabled: selectedCameras.length === 0 || submitting,
                                sx: {
                                    fontFamily: "Mulish",
                                    textTransform: "none",
                                    mt: 2,
                                    backgroundColor: "#FF8400",
                                    "&:hover": {
                                        backgroundColor: "#E67300"
                                    }
                                },
                                children: submitting ? "Adding cameras\u2026" : `Add ${selectedCameras.length || ""} selected camera${selectedCameras.length === 1 ? "" : "s"}`
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



const $a466acfbdf930dea$export$ded845d1eea1f233 = ({ navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed, mode: mode = "discover" })=>{
    const reset = (0, $7efbe771df2391dd$export$b37e90458ab57966)((state)=>state.reset);
    const setMode = (0, $7efbe771df2391dd$export$b37e90458ab57966)((state)=>state.setMode);
    // Start each visit from a clean slate (no stale hosts/selection).
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        reset();
        setMode(mode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mode
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "bg-actuate-grey absolute w-full h-full overflow-scroll",
                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: !navBarCollapsed ? "pl-[170px] pt-[10px]" : "pl-[95px] pt-[10px]",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $bdc6a10e1e107a47$export$a3aa0757d1516cc5), {
                        mode: mode
                    })
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "justify-start",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jVN1H.NavBar), {
                    navBarCollapsed: navBarCollapsed,
                    setNavBarCollapsed: setNavBarCollapsed,
                    props: {}
                })
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
var $3T949 = parcelRequire("3T949");

var $4wo2Y = parcelRequire("4wo2Y");



/** Half of the prior 1600px discovery shell; progress returns to Add Site width. */ const $9074a18862e2aa7b$var$DISCOVERY_PANEL_WIDTH_PX = 800;
const $9074a18862e2aa7b$var$PROGRESS_PANEL_WIDTH_PX = 600;
const $9074a18862e2aa7b$export$1cd946f61ee6c5f7 = ()=>{
    const navigate = (0, $3T949.useNavigate)();
    const { siteId: siteIdParam } = (0, $3T949.useParams)();
    const siteId = siteIdParam || localStorage.siteId || "";
    const resetScan = (0, $7efbe771df2391dd$export$b37e90458ab57966)((state)=>state.reset);
    const navigateToNewSite = $8T3gX.useCallback(()=>{
        localStorage.setItem("cameraNumber", "1");
        if (siteId) navigate(`/sites/aboutsite/${siteId}`);
        else navigate("/sites");
    }, [
        navigate,
        siteId
    ]);
    const [largerScreen, setLargerScreen] = $8T3gX.useState(true);
    const [visibleScreen, setVisibleScreen] = $8T3gX.useState(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
    $8T3gX.useEffect(()=>{
        resetScan();
        setLargerScreen(true);
        setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $bdc6a10e1e107a47$export$a3aa0757d1516cc5), {
            variant: "onboarding",
            siteIdOverride: siteId,
            onNoTunnels: navigateToNewSite,
            onSuccess: ()=>{
                setLargerScreen(false);
                setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $e4a2260e96905f88$export$770d5a29da7608e0), {
                    percentage: 66,
                    step: 2,
                    setVisibleScreen: setVisibleScreen
                }));
            }
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        siteId
    ]);
    const panelWidth = largerScreen ? $9074a18862e2aa7b$var$DISCOVERY_PANEL_WIDTH_PX : $9074a18862e2aa7b$var$PROGRESS_PANEL_WIDTH_PX;
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "bg-black fixed w-full h-full opacity-90",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "bg-black fixed w-full h-full opacity-10 pointer-events-none"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "flex justify-end text-left",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "absolute top-[50px] h-full bg-white",
                                style: {
                                    width: panelWidth
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "flex justify-end text-left",
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "absolute h-full bg-white overflow-y-auto",
                        style: {
                            width: panelWidth
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "bg-actuate-blue absolute h-[50px] z-10",
                                style: {
                                    width: panelWidth
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                        className: "absolute right-6 top-[10px] text-white text-[18px]",
                                        onClick: navigateToNewSite,
                                        children: "X"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "text-white absolute top-[1px] left-3 font-mulish text-[18px] p-3",
                                        children: "ONVIF Camera Discovery"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "pt-[50px]",
                                children: visibleScreen
                            })
                        ]
                    })
                })
            ]
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k4ank = parcelRequire("k4ank");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");



var $3Zv1D = parcelRequire("3Zv1D");

const $e049ae76a6b87095$export$2a870fa3afcb8f0c = async (submittedArray, setVisibleScreen, visibleScreen, setLargerScreen, navigate, navigateSitesPage, selectedCalendars)=>{
    const retryFunction = ()=>{
        $e049ae76a6b87095$export$2a870fa3afcb8f0c(submittedArray, setVisibleScreen, visibleScreen, setLargerScreen, navigate, navigateSitesPage, selectedCalendars);
    };
    const resizeScreenPlusSetVisibleScreen = ()=>{
        setLargerScreen(true);
        // setVisibleScreen(<ProgressFinishedScreen />);
        navigate(`/sites/aboutsite/${localStorage.siteId}`);
    };
    const setTimeoutAndNavigate = ()=>{
        setTimeout(()=>{
            setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $f05a511d40a0fd8d$export$3c049d782df88a0e), {
                styling: "absolute first-line:font-black font-mulish text-[20px] right-[170px] text-center text-[#283E6D] top-80",
                text: "Schedule Added successfully!"
            }));
            setTimeout(()=>{
                if (localStorage.addAnotherScheduleScreen === "true") navigateSitesPage();
                else if ((0, $1444c94c32ef2738$export$79b714ae571551b5)()) navigate(`/sites/cameracheck`);
                else resizeScreenPlusSetVisibleScreen();
            }, 2000);
        }, 2000);
    };
    const scheduleToSubmit = submittedArray.filter((schedule)=>schedule.start_time !== ":00");
    scheduleToSubmit.map((schedule)=>{
        schedule.customer = localStorage.siteId;
    });
    setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $f05a511d40a0fd8d$export$3c049d782df88a0e), {
        styling: "absolute first-line:font-black font-mulish text-[20px] right-[150px] text-center text-[#283E6D] top-80",
        text: /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
            children: [
                "We're submitting this information.",
                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                "This might take a few seconds."
            ]
        })
    }));
    const AxiosUI = (0, $195EM.createApi)(``);
    let submitScheduleFail = false;
    let setInfoFetchFail = false;
    let siteCamerasFetchFail = false;
    await AxiosUI.post(`schedule/`, scheduleToSubmit).then(()=>{
        submitScheduleFail = false;
        localStorage.removeItem("addScheduleError");
        if (selectedCalendars[0]) {
            let anyFailures = false;
            selectedCalendars.forEach((calendarId, index)=>{
                AxiosUI.post(`calendar/${calendarId}/apply/`, {
                    customer: [
                        Number(localStorage.siteId)
                    ]
                }).then(()=>{
                    if (index === selectedCalendars.length - 1) {
                        setTimeoutAndNavigate();
                        if (anyFailures) alert("One or more calendars failed adding to the site.  Please try to add again on Calendars page.");
                    }
                }, ()=>{
                    anyFailures = true;
                    if (index === selectedCalendars.length - 1) {
                        setTimeoutAndNavigate();
                        alert("One or more calendars failed adding to the site.  Please try to add again on Calendars page.");
                    }
                });
            });
        } else setTimeoutAndNavigate();
    }, (reason)=>{
        submitScheduleFail = true;
        if (reason.request.response.includes("overlaps with existing enabled schedule")) {
            alert(`Schedule Changes not accepted: One or more days overlaps with day(s) from another scheulde at this Site.`);
            localStorage.setItem("addScheduleError", "true");
            setLargerScreen(true);
            setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $587106709f764810$export$e17dd955aca1d504), {
                setVisibleScreen: setVisibleScreen,
                visibleScreen: visibleScreen,
                setLargerScreen: setLargerScreen
            }));
        } else (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            localStorage.setItem("addScheduleError", "true");
            setLargerScreen(true);
            setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $587106709f764810$export$e17dd955aca1d504), {
                setVisibleScreen: setVisibleScreen,
                visibleScreen: visibleScreen,
                setLargerScreen: setLargerScreen
            }));
        });
    });
    !submitScheduleFail && await AxiosUI.get(`customer/${localStorage.siteId}/about/`).then((response)=>{
        setInfoFetchFail = false;
        localStorage.setItem("siteInfo", JSON.stringify(response.data));
    }, (reason)=>{
        setInfoFetchFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
    });
    !submitScheduleFail && !setInfoFetchFail && await AxiosUI.get(`camera/site/?customer__id=${localStorage.siteId}`).then((response)=>{
        siteCamerasFetchFail = false;
        localStorage.setItem("siteCameras", JSON.stringify(response.data));
    }, (reason)=>{
        siteCamerasFetchFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
    });
    !submitScheduleFail && !setInfoFetchFail && !siteCamerasFetchFail && await AxiosUI.get(`schedule/by_customer/${localStorage.siteId}/`).then((response)=>{
        localStorage.setItem("siteSchedule", JSON.stringify(response.data));
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
    });
};



var $8T3gX = parcelRequire("8T3gX");

parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $3QMQN = parcelRequire("3QMQN");

var $djxj8 = parcelRequire("djxj8");

var $cFPmV = parcelRequire("cFPmV");

var $4wo2Y = parcelRequire("4wo2Y");

var $idDbD = parcelRequire("idDbD");

var $axLUl = parcelRequire("axLUl");

var $bILSL = parcelRequire("bILSL");

var $7Gmex = parcelRequire("7Gmex");

var $cpJfj = parcelRequire("cpJfj");

var $2JO2V = parcelRequire("2JO2V");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $kbChx = parcelRequire("kbChx");
var $ha39s = parcelRequire("ha39s");

var $8jTCz = parcelRequire("8jTCz");

const $c556ad7b683a6cde$export$1d185119fc1b8bf8 = ({ calendarsData: calendarsData, setLoadingEventData: setLoadingEventData, setSelectedRow: setSelectedRow, setCalendarEvents: setCalendarEvents, navigate: navigate, setShowMoreDialogOpen: setShowMoreDialogOpen, selectedCalendars: selectedCalendars, setSelectedCalendars: setSelectedCalendars })=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $4reBM.default), {
        sx: {
            width: "100%",
            overflow: "hidden"
        },
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
            sx: {
                height: 250,
                width: 1420
            },
            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                sx: {
                    fontFamily: "Mulish"
                },
                "aria-label": "calendars_table",
                stickyHeader: true,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {}),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: {
                                        fontSize: "15px",
                                        fontFamily: "mulish",
                                        fontWeight: "Bold",
                                        maxWidth: 250,
                                        minWidth: 200
                                    },
                                    align: "left",
                                    children: "Group"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: {
                                        fontSize: "15px",
                                        fontFamily: "mulish",
                                        fontWeight: "Bold",
                                        maxWidth: 250,
                                        minWidth: 200
                                    },
                                    align: "left",
                                    children: "Name"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: {
                                        fontSize: "15px",
                                        fontFamily: "mulish",
                                        fontWeight: "Bold",
                                        maxWidth: 250,
                                        minWidth: 200
                                    },
                                    align: "left",
                                    children: "More Info"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                        children: calendarsData.map((obj, index)=>{
                            return /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                    role: "checkbox",
                                    tabIndex: -1,
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                color: "primary",
                                                defaultChecked: false,
                                                onChange: (event, checked)=>{
                                                    // add the obj.id to the selectedCalendars array if checked, if not remove it from the array
                                                    if (checked) setSelectedCalendars([
                                                        ...selectedCalendars,
                                                        obj.id
                                                    ]);
                                                    else setSelectedCalendars(selectedCalendars.filter((calendarId)=>calendarId !== obj.id));
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            align: "left",
                                            children: obj.group.name
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            align: "left",
                                            children: obj.name
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            align: "left",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                text: "SHOW MORE",
                                                onClick: ()=>{
                                                    setLoadingEventData(true);
                                                    setSelectedRow(obj);
                                                    (0, $61840df64dd1d37b$export$204a2f369a393ad4)(setCalendarEvents, setLoadingEventData, obj, navigate);
                                                    setShowMoreDialogOpen(true);
                                                },
                                                disabled: false
                                            })
                                        })
                                    ]
                                })
                            }, obj.id);
                        })
                    })
                ]
            })
        })
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $iKAtE = parcelRequire("iKAtE");

var $433j1 = parcelRequire("433j1");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $kRZvb = parcelRequire("kRZvb");
var $cVCJe = parcelRequire("cVCJe");
var $f3puC = parcelRequire("f3puC");

var $dHtmK = parcelRequire("dHtmK");
const $93a7347530730fb4$var$monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
const $93a7347530730fb4$var$getMouthName = (monthNumber)=>{
    return $93a7347530730fb4$var$monthNames[monthNumber - 1];
};
const $93a7347530730fb4$var$formatDate = (date)=>{
    if (date === "--") return "--";
    const parts = date.split("-");
    return `${$93a7347530730fb4$var$getMouthName(parts[1])} ${parts[2]}, ${parts[0]}`;
};
const $93a7347530730fb4$export$ba5e4979fed91164 = ({ setCalendarInfoDialogOpen: setCalendarInfoDialogOpen, selectedRow: selectedRow, calendarEvents: calendarEvents, setCalendarEvents: setCalendarEvents, editingCalendar: editingCalendar, loadingEventData: loadingEventData })=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "absolute align-middle",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                openState: editingCalendar || loadingEventData
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4reBM.default), {
                sx: {
                    width: 600,
                    overflow: "hidden"
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kRZvb.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                sx: {
                                    flex: "1 1 100%"
                                },
                                variant: "h6",
                                id: "tableTitle",
                                component: "div",
                                children: [
                                    selectedRow.name,
                                    " | ",
                                    selectedRow.group.name
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                title: "Close Screen",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                    "aria-label": "close",
                                    onClick: ()=>{
                                        setCalendarInfoDialogOpen(false);
                                        setCalendarEvents([]);
                                    },
                                    sx: {
                                        position: "absolute",
                                        right: 8,
                                        top: 8,
                                        color: (theme)=>theme.palette.grey[500]
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                        sx: {
                            maxHeight: 440
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                            sx: {
                                fontFamily: "Mulish",
                                width: "100%",
                                overflow: "scroll"
                            },
                            "aria-label": "simple table",
                            stickyHeader: true,
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                    titlesArray: [
                                        "Event Date",
                                        "Event Name"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                    children: calendarEvents.map((object)=>{
                                        return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    sx: {
                                                        fontFamily: "Mulish"
                                                    },
                                                    children: $93a7347530730fb4$var$formatDate(object.event_date)
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    sx: {
                                                        fontFamily: "Mulish"
                                                    },
                                                    children: object.name
                                                })
                                            ]
                                        }, object.name);
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};



var $3FJ79 = parcelRequire("3FJ79");

var $k1C5l = parcelRequire("k1C5l");

var $2Mk2P = parcelRequire("2Mk2P");
const $587106709f764810$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $587106709f764810$export$e17dd955aca1d504 = ({ setVisibleScreen: setVisibleScreen, visibleScreen: visibleScreen, setLargerScreen: setLargerScreen })=>{
    const locations = JSON.parse(localStorage.locations) || [];
    const locationIds = new Map();
    locations.forEach((element)=>{
        locationIds.set(`${element.name}, ${element.region}`, element.id);
    });
    const navigate = (0, $3T949.useNavigate)();
    const { setScheduleGridEditable: setScheduleGridEditable, setSiteSchedules: setSiteSchedules, setTimeRanges: setTimeRanges, setGrid: setGrid, setDuskToDawn: setDuskToDawn, setDuskToDawnLocation: setDuskToDawnLocation, editTimeScheduleDialogOpen: editTimeScheduleDialogOpen, siteSchedules: siteSchedules } = (0, $3FJ79.useSiteAboutStore)();
    const emptySchedule = (0, $k1C5l.temporaryUpdateScheduleData)([
        {
            customer: localStorage.siteId,
            start_time: null,
            end_time: "00:00:00",
            always_on: false,
            day_of_week: [
                "5",
                "6",
                "2",
                "4",
                "3",
                "1",
                "0"
            ],
            schedule_status: true,
            is_override: false,
            location_dusk_dawn: null,
            enabled: true,
            override_start_date: null,
            override_end_date: null,
            buffer_time: null
        }
    ]);
    const calendarsData = JSON.parse(localStorage.calendarsData).results.filter((calendar)=>calendar.group.name === localStorage.groupSelected);
    const [calendarInfoDialogOpen, setCalendarInfoDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [selectedRow, setSelectedRow] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [calendarEvents, setCalendarEvents] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [editingCalendar] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [loadingEventData, setLoadingEventData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [selectedCalendars, setSelectedCalendars] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [addScheduleError, setAddSchedulError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(localStorage.addScheduleError);
    const navigateSitesPage = ()=>{
        navigate(`/sites/aboutsite/${localStorage.siteId}`);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setScheduleGridEditable(true);
        setSiteSchedules(emptySchedule);
        setTimeRanges((0, $2Mk2P.handleCreateInitialTimeSchedules)(emptySchedule[0].schedule));
        setGrid((0, $axLUl.handleConvertSchedulesToBooleanArrays)(emptySchedule[0].schedule));
        setDuskToDawn((0, $bILSL.handleCreateDuskToDawn)(emptySchedule[0].schedule));
        setDuskToDawnLocation((0, $7Gmex.handleCreateDuskToDawnLocationPlusBuffer)(emptySchedule[0].schedule));
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            children: [
                editTimeScheduleDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2JO2V.EditScheduleTimesDialog), {
                    setActiveTab: ()=>{},
                    setEditMode: ()=>{}
                }),
                addScheduleError && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "absolute w-[600px] h-[50px]",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                        severity: "error",
                        onClose: ()=>{
                            setAddSchedulError(false);
                            localStorage.removeItem("addScheduleError");
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "font-mulish font-bold text-[16px]",
                            children: "Problem adding Schedule. Please try again."
                        })
                    })
                }),
                calendarInfoDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "absolute",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $djxj8.default), {
                        sx: {
                            color: "#fff",
                            zIndex: (theme)=>theme.zIndex.drawer + 1
                        },
                        open: calendarInfoDialogOpen,
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $93a7347530730fb4$export$ba5e4979fed91164), {
                            setCalendarInfoDialogOpen: setCalendarInfoDialogOpen,
                            selectedRow: selectedRow,
                            calendarEvents: calendarEvents,
                            setCalendarEvents: setCalendarEvents,
                            editingCalendar: editingCalendar,
                            loadingEventData: loadingEventData
                        })
                    })
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "font-mulish absolute top-[70px] text-[#283E6D] right-[1070px] text-[21px]",
                    children: "Please create a schedule for this Site"
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "pt-[120px] pl-[30px]",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $idDbD.ScheduleGrid), {}),
                        calendarsData.length > 0 && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "font-mulish font-bold text-[#283E6D] pt-[10px] text-[16px]",
                                    children: `Calendars (optional)`
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "pt-[10px]",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $c556ad7b683a6cde$export$1d185119fc1b8bf8), {
                                        calendarsData: calendarsData,
                                        setLoadingEventData: setLoadingEventData,
                                        setSelectedRow: setSelectedRow,
                                        setCalendarEvents: setCalendarEvents,
                                        navigate: navigate,
                                        setShowMoreDialogOpen: setCalendarInfoDialogOpen,
                                        selectedCalendars: selectedCalendars,
                                        setSelectedCalendars: setSelectedCalendars
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "absolute right-[50px] top-[70px]",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cpJfj.ActuateButton), {
                        onClick: ()=>{
                            setLargerScreen(false);
                            (0, $e049ae76a6b87095$export$2a870fa3afcb8f0c)(siteSchedules, setVisibleScreen, visibleScreen, setLargerScreen, navigate, navigateSitesPage, selectedCalendars);
                            setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $f05a511d40a0fd8d$export$3c049d782df88a0e), {
                                styling: "absolute first-line:font-black font-mulish text-[20px] right-[150px] text-center text-[#283E6D] top-80",
                                text: /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                    children: [
                                        "We're submitting this information.",
                                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                        "This might take a few seconds."
                                    ]
                                })
                            }));
                        },
                        text: "Submit",
                        disabled: false
                    })
                })
            ]
        })
    });
};


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $57b606d5a2664a02$export$3417f92f857e1806 = ()=>{
    const [visibleScreen, setVisibleScreen] = $8T3gX.useState(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
    const [largerScreen, setLargerScreen] = $8T3gX.useState(true);
    $8T3gX.useEffect(()=>{
        setVisibleScreen(/*#__PURE__*/ (0, $k4ank.jsx)((0, $587106709f764810$export$e17dd955aca1d504), {
            setVisibleScreen: setVisibleScreen,
            visibleScreen: visibleScreen,
            setLargerScreen: setLargerScreen
        }));
    }, []);
    const navigate = (0, $3T949.useNavigate)();
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "bg-black fixed w-full h-full opacity-90",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "bg-black fixed w-full h-full opacity-10 pointer-events-none"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "flex justify-end text-left",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: largerScreen ? "absolute top-[50px] h-full bg-white w-[1450px]" : "absolute top-[50px] h-full bg-white w-[600px]"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "flex justify-end text-left",
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: largerScreen ? "absolute h-full bg-white w-[1450]px]" : "absolute h-full bg-white w-[600px]",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: largerScreen ? "bg-actuate-blue absolute w-[1450px] h-[50px]" : "bg-actuate-blue absolute w-[600px] h-[50px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                    className: "absolute right-6 top-[10px] text-white text-[18px]",
                                    onClick: ()=>{
                                        localStorage.setItem("cameraNumber", "1");
                                        if (localStorage.navigatedFromSitesAboutPage === "true") navigate(-1);
                                        else navigate("/sites");
                                    },
                                    children: "X"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: largerScreen ? "text-white absolute top-[1px] right-[1300px] font-mulish text-[18px] p-3" : "text-white absolute top-[1px] right-[450px] font-mulish text-[18px] p-3",
                                    children: "Add Schedule"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            children: visibleScreen
                        })
                    ]
                })
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $aK4Bb = parcelRequire("aK4Bb");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $ax3yI = parcelRequire("ax3yI");

var $1BWfV = parcelRequire("1BWfV");

var $8T3gX = parcelRequire("8T3gX");

var $ebTQj = parcelRequire("ebTQj");
const $49a30112aa406a1c$export$8ef2ed426dede42d = ({ children: children, loadingShell: loadingShell })=>{
    const navigate = (0, $3T949.useNavigate)();
    const [isChecking, setIsChecking] = (0, $8T3gX.useState)(true);
    const [shouldRender, setShouldRender] = (0, $8T3gX.useState)(false);
    // Debug functions available globally for console testing (development only)
    (0, $8T3gX.useEffect)(()=>{
        window.forceTokenExpiration = ()=>{
            console.log("\uD83E\uDDEA DEBUG: Forcing token expiration for testing");
            (0, $1BWfV.authStateManager).clearAuthState();
            localStorage.removeItem("loggedIn");
            localStorage.removeItem("token");
            localStorage.removeItem("token_secret");
            window.location.reload();
        };
        window.simulateExpiredToken = ()=>{
            console.log("\uD83E\uDDEA DEBUG: Simulating expired token (keeping tokens but marking as invalid)");
            localStorage.removeItem("loggedIn");
            window.location.reload();
        };
    }, []);
    (0, $8T3gX.useEffect)(()=>{
        const checkAuthState = async ()=>{
            try {
                // Quick check using cookies only
                const authState = (0, $1BWfV.authStateManager).getAuthState();
                if (authState.isAuthenticated) {
                    // Render immediately if we have valid authentication
                    setShouldRender(true);
                    setIsChecking(false);
                    return;
                }
                // If we have no tokens at all, redirect immediately
                if (!authState.hasValidToken && !authState.hasValidRefreshToken) {
                    (0, $ebTQj.logger).warn("No valid tokens found, redirecting to Cognito immediately");
                    // Store only the path portion for security and proper handling
                    const currentPath = window.location.pathname + window.location.search + window.location.hash;
                    localStorage.setItem("redirectURL", currentPath);
                    (0, $ax3yI.handleRedirect)();
                    return;
                }
                // If we have a refresh token but no access token, try to refresh
                if (authState.hasValidRefreshToken && !authState.hasValidToken) {
                    (0, $ebTQj.logger).info("Attempting background token refresh...");
                    try {
                        await new Promise((resolve, reject)=>{
                            (0, $aK4Bb.getRefreshToken)(navigate, ()=>{
                                // Check state again after refresh attempt
                                const newState = (0, $1BWfV.authStateManager).getAuthState();
                                if (newState.isAuthenticated && newState.hasValidToken) {
                                    setShouldRender(true);
                                    setIsChecking(false);
                                    resolve();
                                } else reject(new Error("Token refresh failed"));
                            });
                        });
                        return;
                    } catch (error) {
                        (0, $ebTQj.logger).error("Token refresh failed:", error);
                        // If refresh fails, clear auth state and redirect to Cognito
                        (0, $1BWfV.authStateManager).clearAuthState();
                        // Store only the path portion for security and proper handling
                        const currentPath = window.location.pathname + window.location.search + window.location.hash;
                        localStorage.setItem("redirectURL", currentPath);
                        (0, $ax3yI.handleRedirect)();
                        return;
                    }
                }
                // If we reach here, authentication failed
                (0, $ebTQj.logger).warn("Authentication failed, redirecting to Cognito");
                // Store only the path portion for security and proper handling
                const currentPath = window.location.pathname + window.location.search + window.location.hash;
                localStorage.setItem("redirectURL", currentPath);
                (0, $ax3yI.handleRedirect)();
            } catch (error) {
                (0, $ebTQj.logger).error("Error checking authentication state:", error);
                // Store only the path portion for security and proper handling
                const currentPath = window.location.pathname + window.location.search + window.location.hash;
                localStorage.setItem("redirectURL", currentPath);
                (0, $ax3yI.handleRedirect)();
            } finally{
                setIsChecking(false);
            }
        };
        checkAuthState();
    }, [
        navigate
    ]);
    // Show loading state while checking authentication
    if (isChecking) {
        if (loadingShell) return loadingShell;
        return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
            className: "flex items-center justify-center h-screen bg-gray-50",
            children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "text-center",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "lds-facebook font-black mb-4",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {}),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {}),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "text-gray-600 text-sm",
                        children: "Loading..."
                    })
                ]
            })
        });
    }
    // Render children if authenticated
    if (shouldRender) return children;
    // This should not be reached due to the redirect in useEffect
    // Redirect to Cognito instead of /login page
    return null; // Will redirect to Cognito via handleRedirect()
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $jVN1H = parcelRequire("jVN1H");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $b9p11 = parcelRequire("b9p11");

var $faP87 = parcelRequire("faP87");

var $a65wX = parcelRequire("a65wX");
const $f7388cb452bfd3ac$export$cb9d5b24bb2f81dd = ({ setAddGroupUserScreenOpen: setAddGroupUserScreenOpen, setAlertState: setAlertState })=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
        theme: (0, $faP87.theme),
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
            type: "button",
            color: "primary",
            onClick: ()=>{
                setAddGroupUserScreenOpen(true);
                setAlertState((previousState)=>{
                    return {
                        ...previousState,
                        updateUserSuccess: false,
                        deleteUserSuccess: false,
                        addUserSuccess: false,
                        emailSent: false,
                        noData: false
                    };
                });
            },
            children: "+ Add Group User"
        })
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");


const $c2f888309f655ce6$export$ef1630a032cdff70 = ({ setGroupUsersSearchString: setGroupUsersSearchString })=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $c9d4fba0d4c728e8$export$4b85d3515bd863a5), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $c9d4fba0d4c728e8$export$e9ad429a7452907b), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0f42bd3abae37cbe$exports))), {})
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $c9d4fba0d4c728e8$export$b030dc24f7f252a3), {
                // placeholder="Search Calendar Names"
                onChange: (event)=>setGroupUsersSearchString(event.target.value),
                inputProps: {
                    "aria-label": "search"
                }
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $73a394d7259def7a$export$1614696ef5abad76 = (setGroupUserData, groupUserData, setFetchingGroupUserData, pageNumber, searchString, setBackgroundLoadingData, setAlertState, setFilteredData, setActiveData, setMoreUsersToLoad, setMoreUsersToLoadPageNumber, navigate)=>{
    const retryFunction = ()=>{
        $73a394d7259def7a$export$1614696ef5abad76(setGroupUserData, groupUserData, setFetchingGroupUserData, pageNumber, searchString, setBackgroundLoadingData, setAlertState, setFilteredData, setActiveData, setMoreUsersToLoad, setMoreUsersToLoadPageNumber, navigate);
    };
    let searchParam = `?`;
    if (searchString) searchParam += `search=${searchString}&`;
    searchParam += `page=${pageNumber}`;
    const AxiosUI = (0, $195EM.createApi)(``);
    const allGroupUserData = groupUserData;
    AxiosUI.get(`group_user/${searchParam}`).then((response)=>{
        response.data.results.forEach((object)=>{
            allGroupUserData.push(object);
        });
        if (!allGroupUserData[0]) setAlertState((previousState)=>{
            return {
                ...previousState,
                noData: true,
                updateUserSuccess: false,
                deleteUserSuccess: false,
                addUserSuccess: false,
                emailSent: false
            };
        });
        setActiveData(allGroupUserData);
        setGroupUserData(allGroupUserData);
        if (searchString) {
            setFilteredData(allGroupUserData);
            setActiveData(allGroupUserData);
        }
        setFetchingGroupUserData(false);
        setBackgroundLoadingData(false);
        if (response.data.next) {
            setMoreUsersToLoad(true);
            setMoreUsersToLoadPageNumber((prev)=>prev + 1);
        }
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setFetchingGroupUserData(false);
        });
    });
};


const $3d4237145fb94641$export$f128da6ab8fef046 = ({ setGroupUserData: setGroupUserData, setFetchingGroupUserData: setFetchingGroupUserData, groupUsersSearchString: groupUsersSearchString, backgroundLoadingData: backgroundLoadingData, setBackgroundLoadingData: setBackgroundLoadingData, setAlertState: setAlertState, setPage: setPage, setFilteredDataExists: setFilteredDataExists, setFilteredData: setFilteredData, setActiveData: setActiveData, setMoreUsersToLoad: setMoreUsersToLoad, setMoreUsersToLoadPageNumber: setMoreUsersToLoadPageNumber, navigate: navigate })=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)("button", {
            className: // backgroundLoadingData
            //   ? "shadow-button bg-actuate-grey border-2	border-actuate-grey rounded font-mulish text-white text-base p-1.5 w-[160px]"
            //   :
            "shadow-button bg-actuate-orange border-2	border-actuate-orange rounded font-mulish text-white text-base p-1.5 w-[120px]",
            onClick: ()=>{
                setAlertState((previousState)=>{
                    setPage(0);
                    setMoreUsersToLoad(false);
                    setMoreUsersToLoadPageNumber(1);
                    return {
                        ...previousState,
                        updateUserSuccess: false,
                        deleteUserSuccess: false,
                        addUserSuccess: false,
                        emailSent: false,
                        noData: false
                    };
                });
                if (groupUsersSearchString) {
                    setFilteredDataExists(true);
                    setFetchingGroupUserData(true);
                    setBackgroundLoadingData(true);
                    (0, $73a394d7259def7a$export$1614696ef5abad76)(setFilteredData, [], setFetchingGroupUserData, 1, groupUsersSearchString, setBackgroundLoadingData, setAlertState, setFilteredData, setActiveData, setMoreUsersToLoad, setMoreUsersToLoadPageNumber, navigate);
                } else {
                    setFilteredDataExists(false);
                    setFilteredData([]);
                }
            },
            children: "Search Users"
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $lcmJi = parcelRequire("lcmJi");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $1wcxl = parcelRequire("1wcxl");

var $4reBM = parcelRequire("4reBM");

var $fWsn7 = parcelRequire("fWsn7");

var $iKAtE = parcelRequire("iKAtE");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");


var $crpct = parcelRequire("crpct");

var $2aMB5 = parcelRequire("2aMB5");

var $lWchQ = parcelRequire("lWchQ");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $aVDw9 = parcelRequire("aVDw9");
var $ha39s = parcelRequire("ha39s");
var $4o6Cs = parcelRequire("4o6Cs");
const $7749fc26afd8afa4$var$headCells = [
    {
        id: "username",
        numeric: false,
        label: "User"
    },
    {
        id: "group",
        numeric: false,
        label: "Group"
    },
    {
        id: "self_service",
        numeric: false,
        label: "Self Service"
    },
    {
        id: "last_login",
        numeric: false,
        label: "Last Login"
    },
    {
        id: "site_count",
        numeric: false,
        label: "Site Access"
    }
];
const $7749fc26afd8afa4$export$b5a0fc4a74ab47ea = (props)=>{
    const { onRequestSort: onRequestSort, orderBy: orderBy, order: order } = props;
    const createSortHandler = (property)=>(event)=>{
            onRequestSort(event, property);
        };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
            children: [
                $7749fc26afd8afa4$var$headCells.map((headCell)=>{
                    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                        sx: {
                            fontSize: "15px",
                            fontFamily: "mulish",
                            fontWeight: "Bold",
                            maxWidth: 250
                        },
                        style: {
                            minWidth: 200
                        },
                        align: "left",
                        sortDirection: orderBy === headCell.id ? order : false,
                        children: headCell.label
                    }, headCell.id);
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    align: "center"
                })
            ]
        })
    });
};


parcelRequire("8T3gX");
const $c5c2eb0780a90a39$export$39bc600700bd9d9 = (inputDate)=>{
    const date = new Date(inputDate);
    return date.toLocaleString("en-US");
};


parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $77604ddf6aa99163$export$6e31aec3a913543e = (groupUserId, setAlertState, setUpdatingGroupUserData, setUserNameString, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $77604ddf6aa99163$export$6e31aec3a913543e(groupUserId, setAlertState, setUpdatingGroupUserData, setUserNameString, navigate);
    };
    AxiosUI.post(`group_user/${groupUserId}/resend_password/`).then(()=>{
        setAlertState((previousState)=>{
            return {
                ...previousState,
                updateUserSuccess: false,
                deleteUserSuccess: false,
                addUserSuccess: false,
                emailSent: true,
                noData: false
            };
        });
        setUpdatingGroupUserData(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Error sending email, please try again");
            setUpdatingGroupUserData(false);
        });
    });
};



var $8jTCz = parcelRequire("8jTCz");

const $92b1d119bcfac9c4$export$a53b0a5290ddc923 = ({ groupUserData: groupUserData, page: page, setPage: setPage, rowsPerPage: rowsPerPage, setRowsPerPage: setRowsPerPage, setSelectedRow: setSelectedRow, setAboutUserDialogOpen: setAboutUserDialogOpen, setSelectedRowIndex: setSelectedRowIndex, setGroupUserId: setGroupUserId, setDeleteGroupUserDialogOpen: setDeleteGroupUserDialogOpen, setUpdatingGroupUserData: setUpdatingGroupUserData, setAlertState: setAlertState, setUserNameString: setUserNameString, filteredDataExists: filteredDataExists, filteredData: filteredData, activeData: activeData, moreUsersToLoad: moreUsersToLoad, setGroupUserData: setGroupUserData, setFetchingGroupUserData: setFetchingGroupUserData, moreUsersToLoadPageNumber: moreUsersToLoadPageNumber, searchString: searchString, setBackgroundLoadingData: setBackgroundLoadingData, setFilteredData: setFilteredData, setActiveData: setActiveData, setMoreUsersToLoad: setMoreUsersToLoad, setMoreUsersToLoadPageNumber: setMoreUsersToLoadPageNumber, navigate: navigate })=>{
    const [order, setOrder] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("asc");
    const [orderBy, setOrderBy] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [anchorEl, setAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const ITEM_HEIGHT = 48;
    const handleRequestSort = (event, property)=>{
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };
    const handleChangePage = (event, newPage)=>{
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event)=>{
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const visibleRows = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>(0, $fWsn7.stableSort)(activeData, (0, $fWsn7.getComparator)(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        order,
        orderBy,
        page,
        rowsPerPage
    ]);
    const { height: height, width: width } = (0, $crpct.default)();
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setCalculatedHeight(height - 205);
        setCalculatedWidth(width - 150);
    }, [
        height,
        width
    ]);
    const [calcuatedHeight, setCalculatedHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [calcuatedWidth, setCalculatedWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [displayShowMoreButton, setDisplayShowMoreButton] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (rowsPerPage === 25) setDisplayShowMoreButton(activeData.length / 25 === page + 1);
        if (rowsPerPage === 10) setDisplayShowMoreButton(activeData.length / 10 === page + 1);
        if (rowsPerPage === 5) setDisplayShowMoreButton(activeData.length / 5 === page + 1);
    }, [
        rowsPerPage,
        page,
        activeData
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4reBM.default), {
        sx: {
            width: "100%",
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                sx: {
                    maxHeight: calcuatedHeight,
                    minWidth: calcuatedWidth
                },
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                    sx: {
                        fontFamily: "Mulish"
                    },
                    stickyHeader: true,
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $7749fc26afd8afa4$export$b5a0fc4a74ab47ea), {
                            onRequestSort: handleRequestSort,
                            orderBy: orderBy,
                            order: order
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $gXvgZ.default), {
                            children: [
                                activeData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((obj, index)=>{
                                    return /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                            tabIndex: -1,
                                            hover: true,
                                            onClick: ()=>{
                                                setSelectedRow(obj);
                                                setSelectedRowIndex(activeData.findIndex((item)=>item === obj));
                                            },
                                            sx: {
                                                cursor: "pointer",
                                                fontFamily: "Mulish"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    sx: {
                                                        fontFamily: "Mulish"
                                                    },
                                                    align: "left",
                                                    onClick: ()=>{
                                                        setSelectedRow(obj);
                                                        setSelectedRowIndex(activeData.findIndex((item)=>item === obj));
                                                        setAboutUserDialogOpen(true);
                                                        setAlertState((previousState)=>{
                                                            return {
                                                                ...previousState,
                                                                updateUserSuccess: false,
                                                                deleteUserSuccess: false,
                                                                addUserSuccess: false,
                                                                emailSent: false,
                                                                noData: false
                                                            };
                                                        });
                                                    },
                                                    children: obj.user.username
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    sx: {
                                                        fontFamily: "Mulish"
                                                    },
                                                    align: "left",
                                                    onClick: ()=>{
                                                        setSelectedRow(obj);
                                                        setSelectedRowIndex(activeData.findIndex((item)=>item === obj));
                                                        setAboutUserDialogOpen(true);
                                                        setAlertState((previousState)=>{
                                                            return {
                                                                ...previousState,
                                                                updateUserSuccess: false,
                                                                deleteUserSuccess: false,
                                                                addUserSuccess: false,
                                                                emailSent: false,
                                                                noData: false
                                                            };
                                                        });
                                                    },
                                                    children: obj.group.name
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    sx: {
                                                        fontFamily: "Mulish"
                                                    },
                                                    align: "left",
                                                    onClick: ()=>{
                                                        setSelectedRow(obj);
                                                        setSelectedRowIndex(activeData.findIndex((item)=>item === obj));
                                                        setAboutUserDialogOpen(true);
                                                        setAlertState((previousState)=>{
                                                            return {
                                                                ...previousState,
                                                                updateUserSuccess: false,
                                                                deleteUserSuccess: false,
                                                                addUserSuccess: false,
                                                                emailSent: false,
                                                                noData: false
                                                            };
                                                        });
                                                    },
                                                    children: obj.access_level > 2 && !(0, $lcmJi.isViewOnly)(obj.access_level) ? (0, $lWchQ.checkedCircleIcon) : (0, $2aMB5.cancelIconRed)
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    sx: {
                                                        fontFamily: "Mulish"
                                                    },
                                                    align: "left",
                                                    onClick: ()=>{
                                                        setSelectedRow(obj);
                                                        setSelectedRowIndex(activeData.findIndex((item)=>item === obj));
                                                        setAboutUserDialogOpen(true);
                                                        setAlertState((previousState)=>{
                                                            return {
                                                                ...previousState,
                                                                updateUserSuccess: false,
                                                                deleteUserSuccess: false,
                                                                addUserSuccess: false,
                                                                emailSent: false,
                                                                noData: false
                                                            };
                                                        });
                                                    },
                                                    children: (0, $c5c2eb0780a90a39$export$39bc600700bd9d9)(obj.user.last_login)
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    sx: {
                                                        fontFamily: "Mulish"
                                                    },
                                                    align: "left",
                                                    onClick: ()=>{
                                                        setSelectedRow(obj);
                                                        setSelectedRowIndex(activeData.findIndex((item)=>item === obj));
                                                        setAboutUserDialogOpen(true);
                                                        setAlertState((previousState)=>{
                                                            return {
                                                                ...previousState,
                                                                updateUserSuccess: false,
                                                                deleteUserSuccess: false,
                                                                addUserSuccess: false,
                                                                emailSent: false,
                                                                noData: false
                                                            };
                                                        });
                                                    },
                                                    children: `${obj.site_count} sites`
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                                    align: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                                            "aria-label": "more",
                                                            id: "long-button",
                                                            "aria-controls": open ? "long-menu" : undefined,
                                                            "aria-expanded": open ? "true" : undefined,
                                                            "aria-haspopup": "true",
                                                            onClick: (event)=>{
                                                                setAlertState((previousState)=>{
                                                                    return {
                                                                        ...previousState,
                                                                        updateUserSuccess: false,
                                                                        deleteUserSuccess: false,
                                                                        addUserSuccess: false,
                                                                        emailSent: false,
                                                                        noData: false
                                                                    };
                                                                });
                                                                setUserNameString(obj.user.username);
                                                                handleClick(event);
                                                                setGroupUserId(obj.id);
                                                                setSelectedRow(obj);
                                                                setSelectedRowIndex(activeData.findIndex((item)=>item === obj));
                                                            },
                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4edf75b704cab85d$export$6eaba7fcfbaac527), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                                                            id: "long-menu",
                                                            MenuListProps: {
                                                                "aria-labelledby": "long-button"
                                                            },
                                                            anchorOrigin: {
                                                                vertical: "top",
                                                                horizontal: "left"
                                                            },
                                                            transformOrigin: {
                                                                vertical: "top",
                                                                horizontal: "left"
                                                            },
                                                            anchorEl: anchorEl,
                                                            open: open,
                                                            onClose: handleClose,
                                                            PaperProps: {
                                                                style: {
                                                                    maxHeight: ITEM_HEIGHT * 4.5,
                                                                    width: "250px"
                                                                }
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                                    onClick: ()=>{
                                                                        handleClose();
                                                                        setUpdatingGroupUserData(true);
                                                                        (0, $77604ddf6aa99163$export$6e31aec3a913543e)(obj.id, setAlertState, setUpdatingGroupUserData, setUserNameString, navigate);
                                                                    },
                                                                    children: "Resend Temp Password"
                                                                }, "resend-temp-password"),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                                    onClick: ()=>{
                                                                        setDeleteGroupUserDialogOpen(true);
                                                                        setUpdatingGroupUserData(true);
                                                                        handleClose();
                                                                    },
                                                                    children: "Delete User"
                                                                }, "delete")
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, obj.id);
                                }),
                                moreUsersToLoad && displayShowMoreButton && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {}),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {}),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                onClick: ()=>{
                                                    setUpdatingGroupUserData(true);
                                                    setDisplayShowMoreButton(false);
                                                    (0, $73a394d7259def7a$export$1614696ef5abad76)(setGroupUserData, activeData, setUpdatingGroupUserData, moreUsersToLoadPageNumber, searchString, setBackgroundLoadingData, setAlertState, setFilteredData, setActiveData, setMoreUsersToLoad, setMoreUsersToLoadPageNumber, navigate);
                                                },
                                                text: "Load More",
                                                disabled: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {}),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {}),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {})
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wcxl.default), {
                rowsPerPageOptions: [
                    5,
                    10,
                    25
                ],
                component: "div",
                count: activeData.length,
                rowsPerPage: rowsPerPage,
                page: page,
                onPageChange: handleChangePage,
                onRowsPerPageChange: handleChangeRowsPerPage
            })
        ]
    });
};


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $dHtmK = parcelRequire("dHtmK");


var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $kUcVg = parcelRequire("kUcVg");
var $1TOOV = parcelRequire("1TOOV");
var $eejVe = parcelRequire("eejVe");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");


var $iKAtE = parcelRequire("iKAtE");

var $433j1 = parcelRequire("433j1");

var $gus0k = parcelRequire("gus0k");

var $kRZvb = parcelRequire("kRZvb");

var $f3puC = parcelRequire("f3puC");

var $gfzcx = parcelRequire("gfzcx");

var $k1BHZ = parcelRequire("k1BHZ");

var $imWqP = parcelRequire("imWqP");

var $3baw3 = parcelRequire("3baw3");

var $7UDCh = parcelRequire("7UDCh");

var $2SHRA = parcelRequire("2SHRA");

var $9qNow = parcelRequire("9qNow");

var $kbChx = parcelRequire("kbChx");

var $iHk77 = parcelRequire("iHk77");


var $8jTCz = parcelRequire("8jTCz");

parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $6dcca898ea49bebf$export$93738d59b2299b5e = (groupUserid, selectedRowIndex, changesMade, patchObject, setGroupUserData, setUpdatingGroupUserData, setAlertState, nameChangesMade, namePatchObject, userID, setActiveData, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $6dcca898ea49bebf$export$93738d59b2299b5e(groupUserid, selectedRowIndex, changesMade, patchObject, setGroupUserData, setUpdatingGroupUserData, setAlertState, nameChangesMade, namePatchObject, userID, setActiveData, navigate);
    };
    if (changesMade && nameChangesMade) AxiosUI.patch(`group_user/${groupUserid}/`, patchObject).then((response)=>{
        setGroupUserData((prevState)=>{
            const newState = [
                ...prevState
            ];
            newState[selectedRowIndex] = response.data;
            return newState;
        });
        setActiveData((prevState)=>{
            const newState = [
                ...prevState
            ];
            newState[selectedRowIndex] = response.data;
            return newState;
        });
        AxiosUI.patch(`user/${userID}/`, namePatchObject).then((response)=>{
            setGroupUserData((prevState)=>{
                const newState = [
                    ...prevState
                ];
                newState[selectedRowIndex] = response.data;
                return newState;
            });
            setActiveData((prevState)=>{
                const newState = [
                    ...prevState
                ];
                newState[selectedRowIndex] = response.data;
                return newState;
            });
            setUpdatingGroupUserData(false);
            setAlertState((previousState)=>{
                return {
                    ...previousState,
                    updateUserSuccess: true,
                    deleteUserSuccess: false,
                    addUserSuccess: false,
                    emailSent: false,
                    noData: false
                };
            });
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                alert("Error updating user, please try again");
                setUpdatingGroupUserData(false);
            });
        });
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            const responseData = reason.response?.data;
            if (responseData?.clips?.[0]) alert(responseData.clips[0]);
            else alert("Error updating user, please try again");
            setUpdatingGroupUserData(false);
        });
    });
    if (nameChangesMade && !changesMade) AxiosUI.patch(`user/${userID}/`, namePatchObject).then((response)=>{
        setGroupUserData((prevState)=>{
            const newState = [
                ...prevState
            ];
            newState[selectedRowIndex] = response.data;
            return newState;
        });
        setActiveData((prevState)=>{
            const newState = [
                ...prevState
            ];
            newState[selectedRowIndex] = response.data;
            return newState;
        });
        setUpdatingGroupUserData(false);
        setAlertState((previousState)=>{
            return {
                ...previousState,
                updateUserSuccess: true,
                deleteUserSuccess: false,
                addUserSuccess: false,
                emailSent: false,
                noData: false
            };
        });
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            const responseData = reason.response?.data;
            if (responseData?.clips?.[0]) alert(responseData.clips[0]);
            else alert("Error updating user, please try again");
            setUpdatingGroupUserData(false);
        });
    });
    if (changesMade && !nameChangesMade) AxiosUI.patch(`group_user/${groupUserid}/`, patchObject).then((response)=>{
        setGroupUserData((prevState)=>{
            const newState = [
                ...prevState
            ];
            newState[selectedRowIndex] = response.data;
            return newState;
        });
        setActiveData((prevState)=>{
            const newState = [
                ...prevState
            ];
            newState[selectedRowIndex] = response.data;
            return newState;
        });
        setUpdatingGroupUserData(false);
        setAlertState((previousState)=>{
            return {
                ...previousState,
                updateUserSuccess: true,
                deleteUserSuccess: false,
                addUserSuccess: false,
                emailSent: false,
                noData: false
            };
        });
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            const responseData = reason.response?.data;
            if (responseData?.clips?.[0]) alert(responseData.clips[0]);
            else alert("Error updating user, please try again");
            setUpdatingGroupUserData(false);
        });
    });
};



var $aYdit = parcelRequire("aYdit");

var $ebTQj = parcelRequire("ebTQj");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");

var $9qNow = parcelRequire("9qNow");

var $lcmJi = parcelRequire("lcmJi");
const $11faf9247d3e13d7$export$b3da7612c25d77cf = ({ value: value, onChange: onChange, options: options, disabled: disabled = false, width: width = 300, loadError: loadError = null })=>{
    const selected = value.length === 0 ? [
        (0, $lcmJi.VIEW_ALL_OPTION)
    ] : value.map((key)=>options.find((option)=>option.key === key) ?? {
            key: key,
            label: key
        });
    // A saved key the vocabulary does not (yet) list — e.g. before the list has
    // loaded — still needs to be an option so the chip renders and can be removed.
    const unlistedSelected = selected.filter((item)=>item.key !== (0, $lcmJi.VIEW_ALL_OPTION).key && !options.some((option)=>option.key === item.key));
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "pt-[10px]",
        style: {
            width: width
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                multiple: true,
                disablePortal: true,
                disableClearable: true,
                disabled: disabled,
                value: selected,
                options: [
                    (0, $lcmJi.VIEW_ALL_OPTION),
                    ...options,
                    ...unlistedSelected
                ],
                getOptionLabel: (option)=>option.label,
                isOptionEqualToValue: (option, current)=>option.key === current.key,
                onChange: (event, next)=>{
                    onChange((0, $lcmJi.applyScreenSelection)(value, next.map((option)=>option.key)));
                },
                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        ...params,
                        variant: "standard",
                        label: "Visible Screens",
                        id: "visible_screens",
                        name: "visible_screens"
                    }),
                renderOption: (props, option)=>/*#__PURE__*/ (0, $8T3gX.createElement)("li", {
                        ...props,
                        key: option.key
                    }, option.label)
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                error: Boolean(loadError),
                children: loadError ? `Screen options could not be loaded (${loadError}). Saved screens still apply.` : "Screens this user can open. View All keeps every screen available."
            })
        ]
    });
};



var $lcmJi = parcelRequire("lcmJi");
const $5cf0a80d84c73879$export$88da4aff6349c23 = ({ aboutUserDialogOpen: aboutUserDialogOpen, setAboutUserDialogOpen: setAboutUserDialogOpen, row: row, selectedRowIndex: selectedRowIndex, setGroupUserData: setGroupUserData, setUpdatingGroupUserData: setUpdatingGroupUserData, setAlertState: setAlertState, setActiveData: setActiveData, navigate: navigate })=>{
    const [selectedRow, setSelectedRow] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(row);
    const [editMode, setEditMode] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [changesMade, setChangesMade] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [nameChangesMade, setNameChangesMade] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const parentAccounts = JSON.parse(localStorage.parentAccounts);
    const userID = selectedRow.user.id;
    const parentIds = new Map();
    const parentNames = new Map();
    parentAccounts.forEach((object)=>{
        parentIds.set(object.name, object.id);
    });
    parentAccounts.forEach((object)=>{
        parentNames.set(object.id, object.name);
    });
    const backupSelectedRow = row;
    const [patchObject, setPatchObject] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [namePatchObject, setNamePatchObject] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    // ENG-1815: View Only screen picker. Only editors who manage users get the
    // control; everyone else sees the dialog exactly as before.
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    const canManageUsers = Boolean(userPermissions?.manage_users);
    const savedVisibleScreens = (0, $lcmJi.readVisibleScreens)(row);
    const [visibleScreens, setVisibleScreens] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(savedVisibleScreens);
    const [screenVocabulary, setScreenVocabulary] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [vocabularyError, setVocabularyError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!canManageUsers) return;
        let cancelled = false;
        (0, $lcmJi.fetchScreenVocabulary)().then((options)=>{
            if (!cancelled) {
                setScreenVocabulary(options);
                setVocabularyError(null);
            }
        }, (reason)=>{
            // Without the vocabulary the picker offers View All only; the rest of
            // the dialog is unaffected. Surface the status so an empty list is
            // explained rather than silent.
            (0, $ebTQj.logger).warn("Could not load the visible-screens vocabulary:", reason);
            if (!cancelled) setVocabularyError((0, $lcmJi.describeVocabularyError)(reason));
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        canManageUsers
    ]);
    // Health / Patrols / WireGuard are offered only when this user's row says
    // they have CHM sites / patrol sites / tunnels.
    const screenOptions = (0, $lcmJi.selectableScreens)(screenVocabulary, row);
    // The radio group is controlled off the pending patch so the picker
    // appears/disappears as the level changes, not only on reopen.
    const currentAccessLevel = patchObject.access_level ?? selectedRow.access_level;
    const screensChanged = JSON.stringify(visibleScreens) !== JSON.stringify(savedVisibleScreens);
    const selectAccessLevel = (level)=>{
        setChangesMade(true);
        setPatchObject((previousState)=>{
            const next = {
                ...previousState,
                access_level: level
            };
            if ((0, $lcmJi.isViewOnly)(level)) {
                if (screensChanged) next[0, $lcmJi.VISIBLE_SCREENS_FIELD] = visibleScreens;
                return next;
            }
            return (0, $lcmJi.withVisibleScreensForLevel)(next, level);
        });
    };
    const selectVisibleScreens = (next)=>{
        setChangesMade(true);
        setVisibleScreens(next);
        setPatchObject((previousState)=>({
                ...previousState,
                [(0, $lcmJi.VISIBLE_SCREENS_FIELD)]: next
            }));
    };
    // Rendered under the selected read-only radio (View Only or Alarm Review).
    const screenPicker = canManageUsers && (0, $lcmJi.isViewOnly)(currentAccessLevel) ? /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "pl-[32px] pb-[8px]",
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $11faf9247d3e13d7$export$b3da7612c25d77cf), {
            value: visibleScreens,
            onChange: selectVisibleScreens,
            options: screenOptions,
            disabled: !editMode,
            loadError: vocabularyError
        })
    }) : null;
    const discardEdits = ()=>{
        setSelectedRow(backupSelectedRow);
        setVisibleScreens(savedVisibleScreens);
        setPatchObject({});
        setNamePatchObject({});
        setChangesMade(false);
        setNameChangesMade(false);
        setEditMode(false);
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "absolute",
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
            open: aboutUserDialogOpen,
            TransitionComponent: (0, $8fd061cf8e8d69d2$export$be58926105124dd4),
            fullScreen: true,
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gus0k.default), {
                    sx: {
                        position: "relative"
                    },
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kRZvb.default), {
                        sx: {
                            backgroundColor: "#001943"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                edge: "start",
                                color: "inherit",
                                onClick: ()=>{
                                    setAboutUserDialogOpen(false);
                                },
                                "aria-label": "close",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                sx: {
                                    ml: 2,
                                    flex: 1
                                },
                                variant: "h6",
                                component: "div",
                                children: "User Info"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                    children: [
                        !editMode && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "absolute right-[25px] top-[80px]",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    setEditMode(true);
                                },
                                text: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($983e97e2604996b4$exports))), {}),
                                        "\xa0Edit"
                                    ]
                                }),
                                disabled: false
                            })
                        }),
                        editMode && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "absolute right-[180px] top-[80px]",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: discardEdits,
                                text: "Cancel",
                                disabled: false
                            })
                        }),
                        editMode && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "absolute right-[25px] top-[80px]",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    setUpdatingGroupUserData(true);
                                    setAboutUserDialogOpen(false);
                                    (0, $6dcca898ea49bebf$export$93738d59b2299b5e)(selectedRow.id, selectedRowIndex, changesMade, // The screen list rides along only for View Only.
                                    (0, $lcmJi.withVisibleScreensForLevel)(patchObject, currentAccessLevel), setGroupUserData, setUpdatingGroupUserData, setAlertState, nameChangesMade, namePatchObject, userID, setActiveData, navigate);
                                },
                                text: "Save Changes",
                                disabled: !changesMade && !nameChangesMade
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "font-mulish text-[20px] font-bold",
                            children: "General Info"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                sx: {
                                    fontFamily: "Mulish",
                                    width: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                        titlesArray: [
                                            "Group",
                                            "Username",
                                            "First Name",
                                            "Last Name",
                                            "Email"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    sx: {
                                                        fontFamily: "Mulish",
                                                        width: 250
                                                    },
                                                    children: !editMode ? selectedRow.group.name : /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                                        disablePortal: true,
                                                        options: parentAccounts[0] ? parentAccounts.map((object, index)=>({
                                                                id: object.id,
                                                                name: object.name,
                                                                index: index
                                                            })) : [],
                                                        getOptionLabel: (option)=>option.name || "",
                                                        isOptionEqualToValue: (option, value)=>option.id === value.id,
                                                        value: selectedRow.group.id ? {
                                                            id: selectedRow.group.id,
                                                            name: selectedRow.group.name,
                                                            index: parentAccounts.findIndex((obj)=>obj.id === selectedRow.group.id)
                                                        } : null,
                                                        onChange: (event, value)=>{
                                                            if (value) {
                                                                setChangesMade(true);
                                                                setSelectedRow((previousState)=>{
                                                                    return {
                                                                        ...previousState,
                                                                        group: {
                                                                            id: value.id,
                                                                            name: value.name
                                                                        }
                                                                    };
                                                                });
                                                                setPatchObject((previousState)=>{
                                                                    return {
                                                                        ...previousState,
                                                                        group: value.id
                                                                    };
                                                                });
                                                            }
                                                        },
                                                        sx: {
                                                            width: 250
                                                        },
                                                        renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                                ...params,
                                                                variant: "standard",
                                                                label: "Group",
                                                                autoComplete: "off",
                                                                id: "group_name",
                                                                name: "group_name"
                                                            }),
                                                        renderOption: (props, option)=>/*#__PURE__*/ (0, $8T3gX.createElement)("li", {
                                                                ...props,
                                                                key: option.id
                                                            }, option.name)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    sx: {
                                                        fontFamily: "Mulish",
                                                        width: 250
                                                    },
                                                    children: // !editMode ? (
                                                    selectedRow.user.username
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    sx: {
                                                        fontFamily: "Mulish",
                                                        width: 250
                                                    },
                                                    children: !editMode ? selectedRow.user.first_name : /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                        variant: "standard",
                                                        value: selectedRow.user.first_name,
                                                        onChange: (event)=>{
                                                            setNameChangesMade(true);
                                                            setSelectedRow((previousState)=>{
                                                                const updatedUser = previousState.user;
                                                                updatedUser.first_name = event.target.value;
                                                                return {
                                                                    ...previousState,
                                                                    user: updatedUser
                                                                };
                                                            });
                                                            setNamePatchObject((previousState)=>{
                                                                return {
                                                                    ...previousState,
                                                                    first_name: event.target.value
                                                                };
                                                            });
                                                        },
                                                        sx: {
                                                            width: 250
                                                        },
                                                        helperText: "",
                                                        type: "string"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    sx: {
                                                        fontFamily: "Mulish",
                                                        width: 250
                                                    },
                                                    children: !editMode ? selectedRow.user.last_name : /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                        variant: "standard",
                                                        value: selectedRow.user.last_name,
                                                        onChange: (event)=>{
                                                            setNameChangesMade(true);
                                                            setSelectedRow((previousState)=>{
                                                                const updatedUser = previousState.user;
                                                                updatedUser.last_name = event.target.value;
                                                                return {
                                                                    ...previousState,
                                                                    user: updatedUser
                                                                };
                                                            });
                                                            setNamePatchObject((previousState)=>{
                                                                return {
                                                                    ...previousState,
                                                                    last_name: event.target.value
                                                                };
                                                            });
                                                        },
                                                        sx: {
                                                            width: 250
                                                        },
                                                        helperText: "",
                                                        type: "string"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    sx: {
                                                        fontFamily: "Mulish",
                                                        width: 250
                                                    },
                                                    children: selectedRow.user.email
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $iHk77.b), {
                            theme: (0, $635b38046a5de67e$export$bca14c5b3b88a9c9),
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "font-mulish flex columns-2",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "w-[50%]",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "font-mulish text-[20px] font-bold",
                                                children: "Access Level"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "pl-[10px] py-[10px]",
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $7UDCh.default), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $imWqP.default), {
                                                        value: currentAccessLevel,
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                                onClick: ()=>{
                                                                    if (editMode) selectAccessLevel((0, $lcmJi.VIEW_ONLY_ACCESS_LEVEL));
                                                                },
                                                                value: (0, $lcmJi.VIEW_ONLY_ACCESS_LEVEL),
                                                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {}),
                                                                label: "View Only",
                                                                disabled: !editMode
                                                            }),
                                                            Number(currentAccessLevel) === (0, $lcmJi.VIEW_ONLY_ACCESS_LEVEL) && screenPicker,
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                                onClick: ()=>{
                                                                    if (editMode) selectAccessLevel((0, $lcmJi.ALARM_REVIEW_ACCESS_LEVEL));
                                                                },
                                                                value: (0, $lcmJi.ALARM_REVIEW_ACCESS_LEVEL),
                                                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {}),
                                                                label: "Alarm Review (View Only + set alert outcomes)",
                                                                disabled: !editMode
                                                            }),
                                                            Number(currentAccessLevel) === (0, $lcmJi.ALARM_REVIEW_ACCESS_LEVEL) && screenPicker,
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                                onClick: ()=>{
                                                                    if (editMode) selectAccessLevel(1);
                                                                },
                                                                value: 1,
                                                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {}),
                                                                label: "Arm and Disarm Only",
                                                                disabled: !editMode
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                                onClick: ()=>{
                                                                    if (editMode) selectAccessLevel(2);
                                                                },
                                                                value: 2,
                                                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {}),
                                                                label: "Manage Existing Cameras",
                                                                disabled: !editMode
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                                onClick: ()=>{
                                                                    if (editMode) selectAccessLevel(3);
                                                                },
                                                                value: 3,
                                                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {}),
                                                                label: "Self-Service (can add new cameras)",
                                                                disabled: !editMode
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                                onClick: ()=>{
                                                                    if (editMode) selectAccessLevel(4);
                                                                },
                                                                value: 4,
                                                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {}),
                                                                label: "Self-Service with Delete Permissions",
                                                                disabled: !editMode
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }, "access_level"),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "w-[50%]",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "font-mulish text-[20px] font-bold",
                                                children: "Permissions"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                className: "pl-[10px] py-[10px]",
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                                                            variant: "standard",
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $2SHRA.default), {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                                            color: "primary",
                                                                            checked: selectedRow.create_user,
                                                                            onChange: (event, checked)=>{
                                                                                setChangesMade(true);
                                                                                setSelectedRow((previousState)=>{
                                                                                    return {
                                                                                        ...previousState,
                                                                                        create_user: checked
                                                                                    };
                                                                                });
                                                                                setPatchObject((previousState)=>{
                                                                                    return {
                                                                                        ...previousState,
                                                                                        create_user: checked
                                                                                    };
                                                                                });
                                                                            },
                                                                            disabled: !editMode
                                                                        }),
                                                                        label: "Create User"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                                                                    children: "User can create other users under their group"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "pt-[10px]",
                                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                                                            variant: "standard",
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $2SHRA.default), {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                                            color: "primary",
                                                                            checked: selectedRow.clips,
                                                                            onChange: (event, checked)=>{
                                                                                setChangesMade(true);
                                                                                setSelectedRow((previousState)=>{
                                                                                    return {
                                                                                        ...previousState,
                                                                                        clips: checked
                                                                                    };
                                                                                });
                                                                                setPatchObject((previousState)=>{
                                                                                    return {
                                                                                        ...previousState,
                                                                                        clips: checked
                                                                                    };
                                                                                });
                                                                            },
                                                                            disabled: !editMode
                                                                        }),
                                                                        label: "Clips / AI Link"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                                                                    children: "User can view Clips / AI Link"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "pt-[10px]",
                                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                                                            variant: "standard",
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $2SHRA.default), {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                                            color: "primary",
                                                                            checked: selectedRow.view_empty_group,
                                                                            onChange: (event, checked)=>{
                                                                                setChangesMade(true);
                                                                                setSelectedRow((previousState)=>{
                                                                                    return {
                                                                                        ...previousState,
                                                                                        view_empty_group: checked
                                                                                    };
                                                                                });
                                                                                setPatchObject((previousState)=>{
                                                                                    return {
                                                                                        ...previousState,
                                                                                        view_empty_group: checked
                                                                                    };
                                                                                });
                                                                            },
                                                                            disabled: !editMode
                                                                        }),
                                                                        label: "Show Empty Group Folders"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                                                                    children: `User can view empty group folders on the Site's page.`
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "pt-[10px]",
                                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                                                            variant: "standard",
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $2SHRA.default), {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                                            color: "primary",
                                                                            checked: selectedRow.view_passwords,
                                                                            onChange: (event, checked)=>{
                                                                                setChangesMade(true);
                                                                                setSelectedRow((previousState)=>{
                                                                                    return {
                                                                                        ...previousState,
                                                                                        view_passwords: checked
                                                                                    };
                                                                                });
                                                                                setPatchObject((previousState)=>{
                                                                                    return {
                                                                                        ...previousState,
                                                                                        view_passwords: checked
                                                                                    };
                                                                                });
                                                                            },
                                                                            disabled: !editMode
                                                                        }),
                                                                        label: "View Passwords"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                                                                    children: `User can view passwords. We recommend this be enabled if this user will be tasked with camera onboarding.`
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "pt-[10px]",
                                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                                                            variant: "standard",
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $2SHRA.default), {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                                            color: "primary",
                                                                            checked: selectedRow.autopatrol,
                                                                            onChange: (event, checked)=>{
                                                                                setChangesMade(true);
                                                                                setSelectedRow((previousState)=>{
                                                                                    return {
                                                                                        ...previousState,
                                                                                        autopatrol: checked
                                                                                    };
                                                                                });
                                                                                setPatchObject((previousState)=>{
                                                                                    return {
                                                                                        ...previousState,
                                                                                        autopatrol: checked
                                                                                    };
                                                                                });
                                                                            },
                                                                            disabled: !editMode
                                                                        }),
                                                                        label: "Auto Patrol / Visual Camera Health"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                                                                    children: `Access to views specific to Auto Patrol / Visual Camera Health.`
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "pt-[10px]",
                                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                                                            variant: "standard",
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $2SHRA.default), {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                                            color: "primary",
                                                                            checked: selectedRow.alert_muting,
                                                                            onChange: (event, checked)=>{
                                                                                setChangesMade(true);
                                                                                setSelectedRow((previousState)=>{
                                                                                    return {
                                                                                        ...previousState,
                                                                                        alert_muting: checked
                                                                                    };
                                                                                });
                                                                                setPatchObject((previousState)=>{
                                                                                    return {
                                                                                        ...previousState,
                                                                                        alert_muting: checked
                                                                                    };
                                                                                });
                                                                            },
                                                                            disabled: !editMode
                                                                        }),
                                                                        label: "View Alert Muting"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                                                                    children: "User can mute alerts from their triage on the Alerts page"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "pt-[10px]",
                                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                                                            variant: "standard",
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $2SHRA.default), {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                                            color: "primary",
                                                                            checked: selectedRow.live_streaming,
                                                                            onChange: (event, checked)=>{
                                                                                setChangesMade(true);
                                                                                setSelectedRow((previousState)=>{
                                                                                    return {
                                                                                        ...previousState,
                                                                                        live_streaming: checked
                                                                                    };
                                                                                });
                                                                                setPatchObject((previousState)=>{
                                                                                    return {
                                                                                        ...previousState,
                                                                                        live_streaming: checked
                                                                                    };
                                                                                });
                                                                            },
                                                                            disabled: !editMode
                                                                        }),
                                                                        label: "Live Streaming"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                                                                    children: "User can view live camera streams from the Alerts page"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                                                            variant: "standard",
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $2SHRA.default), {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                                            color: "primary",
                                                                            checked: selectedRow.create_wireguard_tunnels,
                                                                            onChange: (event, checked)=>{
                                                                                setChangesMade(true);
                                                                                setSelectedRow((previousState)=>{
                                                                                    return {
                                                                                        ...previousState,
                                                                                        create_wireguard_tunnels: checked
                                                                                    };
                                                                                });
                                                                                setPatchObject((previousState)=>{
                                                                                    return {
                                                                                        ...previousState,
                                                                                        create_wireguard_tunnels: checked
                                                                                    };
                                                                                });
                                                                            },
                                                                            disabled: !editMode
                                                                        }),
                                                                        label: "Create WireGuard Tunnels"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                                                                    children: "User can create and manage WireGuard tunnels"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }, "permissions")
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $b9p11 = parcelRequire("b9p11");



var $8jTCz = parcelRequire("8jTCz");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");
const $114c84cec00c5559$export$83708946230f7c8b = ({ newUserInfo: newUserInfo, setNewUserInfo: setNewUserInfo, parentAccounts: parentAccounts, parentNames: parentNames, navigate: navigate })=>{
    const [emailValue, setEmailValue] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(newUserInfo.email);
    const [firstNameValue, setFirstNameValue] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(newUserInfo.first_name);
    const [lastNameValue, setLastNameValue] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(newUserInfo.last_name);
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: "absolute top-[160px] left-[30px]",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                    disablePortal: true,
                    value: newUserInfo.group ? {
                        id: newUserInfo.group,
                        name: parentNames.get(newUserInfo.group) ?? ""
                    } : null,
                    options: parentAccounts[0] ? parentAccounts.map((object, index)=>({
                            id: object.id,
                            name: object.name,
                            index: index
                        })) : [],
                    getOptionLabel: (option)=>option.name || "",
                    isOptionEqualToValue: (option, value)=>option.id === value.id,
                    onChange: (event, newInputValue)=>{
                        setNewUserInfo((previousState)=>({
                                ...previousState,
                                group: newInputValue?.id ?? ""
                            }));
                    },
                    sx: {
                        width: 350
                    },
                    renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                            ...params,
                            variant: "standard",
                            label: "Group *",
                            autoComplete: "off",
                            id: "group_name",
                            name: "group_name"
                        }),
                    renderOption: (props, option)=>/*#__PURE__*/ (0, $8T3gX.createElement)("li", {
                            ...props,
                            key: option.id
                        }, option.name)
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    variant: "standard",
                    label: "Email *",
                    value: emailValue,
                    onChange: (event)=>{
                        setNewUserInfo((previousState)=>{
                            return {
                                ...previousState,
                                email: event.target.value
                            };
                        });
                        setEmailValue(event.target.value);
                    },
                    sx: {
                        width: "350px"
                    },
                    helperText: "",
                    type: "string"
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    variant: "standard",
                    label: "First Name *",
                    value: firstNameValue,
                    onChange: (event)=>{
                        setNewUserInfo((previousState)=>{
                            return {
                                ...previousState,
                                first_name: event.target.value
                            };
                        });
                        setFirstNameValue(event.target.value);
                    },
                    sx: {
                        width: "350px"
                    },
                    helperText: "",
                    type: "string"
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                " ",
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    variant: "standard",
                    label: "Last Name *",
                    value: lastNameValue,
                    onChange: (event)=>{
                        setNewUserInfo((previousState)=>{
                            return {
                                ...previousState,
                                last_name: event.target.value
                            };
                        });
                        setLastNameValue(event.target.value);
                    },
                    sx: {
                        width: "350px"
                    },
                    helperText: "",
                    type: "string"
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                " ",
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "font-mulish absolute text-black",
                    children: `* Required fields`
                })
            ]
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $iHk77 = parcelRequire("iHk77");

var $k1BHZ = parcelRequire("k1BHZ");

var $imWqP = parcelRequire("imWqP");

var $3baw3 = parcelRequire("3baw3");

var $7UDCh = parcelRequire("7UDCh");

var $2SHRA = parcelRequire("2SHRA");

var $9qNow = parcelRequire("9qNow");

var $kbChx = parcelRequire("kbChx");


var $8jTCz = parcelRequire("8jTCz");

var $887xF = parcelRequire("887xF");

var $195EM = parcelRequire("195EM");

var $aK4Bb = parcelRequire("aK4Bb");

var $3Zv1D = parcelRequire("3Zv1D");

var $ebTQj = parcelRequire("ebTQj");
const $fcf5fb25aba0bf32$export$f7ac3203e9f4cc98 = (newUserInfo, setAddGroupUserScreenOpen, setUserNameString, setAlertState, groupUsersSearchString, activeData, setActiveData, setNewUserInfo, setErrorStateMessage, setSubmitErrorState, setActiveStep, navigate)=>{
    const retryFunction = ()=>{
        $fcf5fb25aba0bf32$export$f7ac3203e9f4cc98(newUserInfo, setAddGroupUserScreenOpen, setUserNameString, setAlertState, groupUsersSearchString, activeData, setActiveData, setNewUserInfo, setErrorStateMessage, setSubmitErrorState, setActiveStep, navigate);
    };
    const AxiosUI = (0, $195EM.createApi)(``);
    AxiosUI.post(`group_user/`, newUserInfo).then((response)=>{
        if (groupUsersSearchString === "" || response.data.user.username.includes(groupUsersSearchString)) setActiveData([
            ...activeData,
            response.data
        ]);
        setUserNameString(response.data.user.username);
        setAlertState((previousState)=>{
            return {
                ...previousState,
                updateUserSuccess: false,
                deleteUserSuccess: false,
                addUserSuccess: true,
                emailSent: false,
                noData: false
            };
        });
        setAddGroupUserScreenOpen(false);
    }, (reason)=>{
        if (reason.response.data) {
            if (reason.response.data.email) alert(reason.response.data.email[0]);
            if (reason.response.data.clips) {
                if (reason.response.data.clips[0].includes(`does not have any sites that process clips. Either uncheck clips or select a different group`)) {
                    setActiveStep(1);
                    alert(reason.response.data.clips[0]);
                }
            } else if (reason.response.data.visible_screens) {
                // ENG-1815: e.g. Health picked for a group with no CHM sites. Send
                // the admin back to the permissions step with the backend's message.
                setActiveStep(1);
                alert(Array.isArray(reason.response.data.visible_screens) ? reason.response.data.visible_screens[0] : String(reason.response.data.visible_screens));
            } else if (reason.response.data.detail === "Token is expired") (0, $aK4Bb.getRefreshToken)(navigate, retryFunction);
            else {
                alert("Error adding new user, please try again");
                setAddGroupUserScreenOpen(false);
                (0, $ebTQj.logger).log("Error adding new user:", reason.message);
            }
        } else (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Error adding new user, please try again");
            setAddGroupUserScreenOpen(false);
        });
    });
};



var $aYdit = parcelRequire("aYdit");

var $ebTQj = parcelRequire("ebTQj");


var $lcmJi = parcelRequire("lcmJi");
const $cd6163fa6f03a373$export$2c2f87522d247847 = ({ newUserInfo: newUserInfo, setNewUserInfo: setNewUserInfo, setAddGroupUserScreenOpen: setAddGroupUserScreenOpen, setUserNameString: setUserNameString, setAlertState: setAlertState, groupUsersSearchString: groupUsersSearchString, activeData: activeData, setActiveData: setActiveData, setErrorStateMessage: setErrorStateMessage, setSubmitErrorState: setSubmitErrorState, setActiveStep: setActiveStep, navigate: navigate })=>{
    const [stepTwoInfo, setStepTwoInfo] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        ...newUserInfo,
        send_cognito_invitation: newUserInfo.send_cognito_invitation,
        create_user: newUserInfo.create_user,
        clips: newUserInfo.clips,
        view_passwords: newUserInfo.view_passwords,
        alert_muting: newUserInfo.alert_muting,
        live_streaming: newUserInfo.live_streaming,
        create_wireguard_tunnels: newUserInfo.create_wireguard_tunnels
    });
    // ENG-1815: same View Only screen picker as AboutUserDialog, so a View Only
    // user can be scoped at creation. The user does not exist yet, so there is
    // no per-user CHM signal here; Health is offered and the backend validates
    // it on create (ENG-1814).
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    const canManageUsers = Boolean(userPermissions?.manage_users);
    const [screenVocabulary, setScreenVocabulary] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [vocabularyError, setVocabularyError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!canManageUsers) return;
        let cancelled = false;
        (0, $lcmJi.fetchScreenVocabulary)().then((options)=>{
            if (!cancelled) {
                setScreenVocabulary(options);
                setVocabularyError(null);
            }
        }, (reason)=>{
            (0, $ebTQj.logger).warn("Could not load the visible-screens vocabulary:", reason);
            if (!cancelled) setVocabularyError((0, $lcmJi.describeVocabularyError)(reason));
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        canManageUsers
    ]);
    const selectAccessLevel = (level)=>{
        setStepTwoInfo((previousState)=>{
            return {
                ...previousState,
                access_level: level
            };
        });
    };
    // Rendered under the selected read-only radio (View Only or Alarm Review).
    const screenPicker = canManageUsers && (0, $lcmJi.isViewOnly)(stepTwoInfo.access_level) ? /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "pl-[32px] pb-[8px]",
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $11faf9247d3e13d7$export$b3da7612c25d77cf), {
            value: (0, $lcmJi.readVisibleScreens)(stepTwoInfo),
            onChange: (next)=>{
                setStepTwoInfo((previousState)=>({
                        ...previousState,
                        [(0, $lcmJi.VISIBLE_SCREENS_FIELD)]: next
                    }));
            },
            options: screenVocabulary,
            loadError: vocabularyError
        })
    }) : null;
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: "absolute top-[160px] left-[30px] w-[540px]",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $iHk77.b), {
                    theme: (0, $635b38046a5de67e$export$bca14c5b3b88a9c9),
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                                variant: "standard",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $2SHRA.default), {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                            control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                color: "primary",
                                                checked: stepTwoInfo.send_cognito_invitation,
                                                onChange: (event, checked)=>{
                                                    setNewUserInfo((previousState)=>{
                                                        return {
                                                            ...previousState,
                                                            send_cognito_invitation: checked
                                                        };
                                                    });
                                                    setStepTwoInfo((previousState)=>{
                                                        return {
                                                            ...previousState,
                                                            send_cognito_invitation: checked
                                                        };
                                                    });
                                                }
                                            }),
                                            label: "Send Cognito Invitation",
                                            sx: {
                                                color: "#001943"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                                        children: "Send new user an email to create their password."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "font-mulish text-[18px]  text-actuate-blue",
                                    children: "Access Level"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "pl-[10px] py-[10px]",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $7UDCh.default), {
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $imWqP.default), {
                                            value: stepTwoInfo.access_level,
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                    onClick: ()=>selectAccessLevel((0, $lcmJi.VIEW_ONLY_ACCESS_LEVEL)),
                                                    value: (0, $lcmJi.VIEW_ONLY_ACCESS_LEVEL),
                                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {}),
                                                    label: "View Only",
                                                    sx: {
                                                        color: "#001943"
                                                    }
                                                }),
                                                Number(stepTwoInfo.access_level) === (0, $lcmJi.VIEW_ONLY_ACCESS_LEVEL) && screenPicker,
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                    onClick: ()=>selectAccessLevel((0, $lcmJi.ALARM_REVIEW_ACCESS_LEVEL)),
                                                    value: (0, $lcmJi.ALARM_REVIEW_ACCESS_LEVEL),
                                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {}),
                                                    label: "Alarm Review (View Only + set alert outcomes)",
                                                    sx: {
                                                        color: "#001943"
                                                    }
                                                }),
                                                Number(stepTwoInfo.access_level) === (0, $lcmJi.ALARM_REVIEW_ACCESS_LEVEL) && screenPicker,
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                    onClick: ()=>selectAccessLevel(1),
                                                    value: 1,
                                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {}),
                                                    label: "Arm and Disarm Only (Lowest)",
                                                    sx: {
                                                        color: "#001943"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                    onClick: ()=>selectAccessLevel(2),
                                                    value: 2,
                                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {}),
                                                    label: "Manage Existing Cameras",
                                                    sx: {
                                                        color: "#001943"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                    onClick: ()=>selectAccessLevel(3),
                                                    value: 3,
                                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {}),
                                                    label: "Self-Service (can add new cameras)",
                                                    sx: {
                                                        color: "#001943"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                    onClick: ()=>selectAccessLevel(4),
                                                    value: 4,
                                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {}),
                                                    label: "Self-Service with Delete Permissions (Highest)",
                                                    sx: {
                                                        color: "#001943"
                                                    }
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "font-mulish text-[18px]  text-actuate-blue",
                            children: "Permissions"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "pl-[11px] ",
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                                variant: "standard",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $2SHRA.default), {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                            control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                color: "primary",
                                                checked: stepTwoInfo.create_user,
                                                onChange: (event, checked)=>{
                                                    setNewUserInfo((previousState)=>{
                                                        return {
                                                            ...previousState,
                                                            create_user: checked
                                                        };
                                                    });
                                                    setStepTwoInfo((previousState)=>{
                                                        return {
                                                            ...previousState,
                                                            create_user: checked
                                                        };
                                                    });
                                                }
                                            }),
                                            label: "Create User",
                                            sx: {
                                                color: "#001943"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                                        children: "User can create other users under their group"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "pl-[11px]",
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                                variant: "standard",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $2SHRA.default), {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                            control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                color: "primary",
                                                checked: stepTwoInfo.clips,
                                                onChange: (event, checked)=>{
                                                    setNewUserInfo((previousState)=>{
                                                        return {
                                                            ...previousState,
                                                            clips: checked
                                                        };
                                                    });
                                                    setStepTwoInfo((previousState)=>{
                                                        return {
                                                            ...previousState,
                                                            clips: checked
                                                        };
                                                    });
                                                }
                                            }),
                                            label: "Clips / AI Link",
                                            sx: {
                                                color: "#001943"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                                        children: "User can view Clips / AI Link"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "pl-[11px]",
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                                variant: "standard",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $2SHRA.default), {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                            control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                color: "primary",
                                                checked: stepTwoInfo.view_passwords,
                                                onChange: (event, checked)=>{
                                                    setNewUserInfo((previousState)=>{
                                                        return {
                                                            ...previousState,
                                                            view_passwords: checked
                                                        };
                                                    });
                                                    setStepTwoInfo((previousState)=>{
                                                        return {
                                                            ...previousState,
                                                            view_passwords: checked
                                                        };
                                                    });
                                                }
                                            }),
                                            label: "View Passwords",
                                            sx: {
                                                color: "#001943"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $9qNow.default), {
                                        children: [
                                            "User can view passwords. We recommend this be enabled if this user will be tasked with camera onboarding.",
                                            " "
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "pl-[11px]",
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                                variant: "standard",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $2SHRA.default), {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                            control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                color: "primary",
                                                checked: stepTwoInfo.alert_muting,
                                                onChange: (event, checked)=>{
                                                    setNewUserInfo((previousState)=>{
                                                        return {
                                                            ...previousState,
                                                            alert_muting: checked
                                                        };
                                                    });
                                                    setStepTwoInfo((previousState)=>{
                                                        return {
                                                            ...previousState,
                                                            alert_muting: checked
                                                        };
                                                    });
                                                }
                                            }),
                                            label: "View Alert Muting",
                                            sx: {
                                                color: "#001943"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                                        children: "User can mute alerts from their triage on the Alerts page."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "pl-[11px]",
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                                variant: "standard",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $2SHRA.default), {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                            control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                color: "primary",
                                                checked: stepTwoInfo.live_streaming,
                                                onChange: (event, checked)=>{
                                                    setNewUserInfo((previousState)=>{
                                                        return {
                                                            ...previousState,
                                                            live_streaming: checked
                                                        };
                                                    });
                                                    setStepTwoInfo((previousState)=>{
                                                        return {
                                                            ...previousState,
                                                            live_streaming: checked
                                                        };
                                                    });
                                                }
                                            }),
                                            label: "Live Streaming",
                                            sx: {
                                                color: "#001943"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                                        children: "User can view live camera streams from the Alerts page."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "pl-[11px]",
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                                variant: "standard",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $2SHRA.default), {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                            control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                color: "primary",
                                                checked: stepTwoInfo.create_wireguard_tunnels,
                                                onChange: (event, checked)=>{
                                                    setNewUserInfo((previousState)=>{
                                                        return {
                                                            ...previousState,
                                                            create_wireguard_tunnels: checked
                                                        };
                                                    });
                                                    setStepTwoInfo((previousState)=>{
                                                        return {
                                                            ...previousState,
                                                            create_wireguard_tunnels: checked
                                                        };
                                                    });
                                                }
                                            }),
                                            label: "Create WireGuard Tunnels",
                                            sx: {
                                                color: "#001943"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                                        children: "User can create and manage WireGuard tunnels."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            text: "Submit",
                            disabled: false,
                            onClick: ()=>{
                                setActiveStep(3);
                                (0, $fcf5fb25aba0bf32$export$f7ac3203e9f4cc98)(// The screen list is only posted for a View Only user.
                                (0, $lcmJi.withVisibleScreensForLevel)(stepTwoInfo, stepTwoInfo.access_level), setAddGroupUserScreenOpen, setUserNameString, setAlertState, groupUsersSearchString, activeData, setActiveData, setNewUserInfo, setErrorStateMessage, setSubmitErrorState, setActiveStep, navigate);
                            }
                        })
                    })
                })
            ]
        })
    });
};



const $0a803b731d8683ba$export$8ac471d6114ad24e = ({ setAddGroupUserScreenOpen: setAddGroupUserScreenOpen, setUserNameString: setUserNameString, setAlertState: setAlertState, groupUsersSearchString: groupUsersSearchString, activeData: activeData, setActiveData: setActiveData })=>{
    const parentAccounts = localStorage.parentAccounts ? JSON.parse(localStorage.parentAccounts) : [];
    const parentNames = new Map();
    parentAccounts.forEach((object)=>{
        parentNames.set(object.id, object.name);
    });
    const [newUserInfo, setNewUserInfo] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        group: "",
        email: "",
        first_name: "",
        last_name: "",
        send_cognito_invitation: true,
        access_level: 1,
        create_user: false,
        clips: false,
        alert_muting: false,
        live_streaming: false
    });
    const navigate = (0, $3T949.useNavigate)();
    const steps = [
        "User Information",
        "Permissions"
    ];
    const [activeStep, setActiveStep] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [submitErrorState, setSubmitErrorState] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        noAILink: false
    });
    const [errorStateMessage, setErrorStateMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "z-50",
        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
            className: "absolute top-0 right-[600px] h-full bg-white",
            children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "absolute h-full bg-white w-[600px] overflow-y-auto",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "bg-actuate-blue absolute w-[600px] h-[50px]",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                className: "absolute right-6 top-[10px] text-white text-[18px] z-50",
                                onClick: ()=>{
                                    setAddGroupUserScreenOpen(false);
                                },
                                children: "X"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "text-white absolute top-[1px] right-[430px] font-mulish text-[18px] p-3",
                                children: "Add Group User"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "absolute top-[0px] left-0 right-0 bottom-0 overflow-y-auto",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                                theme: (0, $635b38046a5de67e$export$bca14c5b3b88a9c9),
                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "absolute top-[70px] left-[20px]",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $91c8cb97eec976fc$export$2e2bcd8739ae039), {
                                        activeStep: activeStep,
                                        sx: {
                                            width: 565
                                        },
                                        children: steps.map((label)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $4238740b0329aed2$export$2e2bcd8739ae039), {
                                                color: "primary",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $e5e8e6de71eb5805$export$2e2bcd8739ae039), {
                                                    children: label
                                                })
                                            }, label))
                                    })
                                })
                            }),
                            activeStep === 0 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "absolute right-4 top-28",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    disabled: !newUserInfo.group || !newUserInfo.email || !newUserInfo.first_name || !newUserInfo.last_name,
                                    onClick: ()=>{
                                        if (activeStep === 0) setActiveStep(1);
                                    },
                                    text: "Next"
                                })
                            })
                        ]
                    }),
                    activeStep === 1 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute right-[520px] top-28",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            disabled: false,
                            onClick: ()=>{
                                if (activeStep === 1) setActiveStep(0);
                            },
                            text: "Back"
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            activeStep === 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $114c84cec00c5559$export$83708946230f7c8b), {
                                newUserInfo: newUserInfo,
                                setNewUserInfo: setNewUserInfo,
                                parentAccounts: parentAccounts,
                                parentNames: parentNames,
                                navigate: navigate
                            }),
                            activeStep === 1 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cd6163fa6f03a373$export$2c2f87522d247847), {
                                newUserInfo: newUserInfo,
                                setNewUserInfo: setNewUserInfo,
                                setAddGroupUserScreenOpen: setAddGroupUserScreenOpen,
                                setUserNameString: setUserNameString,
                                setAlertState: setAlertState,
                                groupUsersSearchString: groupUsersSearchString,
                                activeData: activeData,
                                setActiveData: setActiveData,
                                setErrorStateMessage: setErrorStateMessage,
                                setSubmitErrorState: setSubmitErrorState,
                                setActiveStep: setActiveStep,
                                navigate: navigate
                            }),
                            activeStep === 3 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $f05a511d40a0fd8d$export$3c049d782df88a0e), {
                                styling: "absolute first-line:font-black font-mulish text-[20px] left-[130px] text-center text-[#283E6D] w-[400px] top-80",
                                text: /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                    children: [
                                        "Adding new User.",
                                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                        "This might take a few seconds."
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};



var $djxj8 = parcelRequire("djxj8");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $353d0bee69dff1f3$export$fcc956522ded1c3d = (groupUserId, setAlertState, setUpdatingGroupUserData, activeData, setActiveData, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $353d0bee69dff1f3$export$fcc956522ded1c3d(groupUserId, setAlertState, setUpdatingGroupUserData, activeData, setActiveData, navigate);
    };
    AxiosUI.delete(`group_user/${groupUserId}/`).then(()=>{
        setActiveData(activeData.filter((obj)=>obj.id !== groupUserId));
        setAlertState((previousState)=>{
            return {
                ...previousState,
                updateUserSuccess: false,
                deleteUserSuccess: true,
                addUserSuccess: false,
                emailSent: false,
                noData: false
            };
        });
        setUpdatingGroupUserData(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Error deleting user, please try again");
            setUpdatingGroupUserData(false);
        });
    });
};


const $210aa5d972af57b8$var$DeleteGroupUserDialog = ({ deleteGroupUserDialogOpen: deleteGroupUserDialogOpen, setDeleteGroupUserDialogOpen: setDeleteGroupUserDialogOpen, setAlertState: setAlertState, groupUserId: groupUserId, activeData: activeData, setActiveData: setActiveData, setUpdatingGroupUserData: setUpdatingGroupUserData, navigate: navigate })=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: deleteGroupUserDialogOpen,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: " Are you sure you want to delete this User?"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setDeleteGroupUserDialogOpen(false);
                            setUpdatingGroupUserData(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setDeleteGroupUserDialogOpen(false);
                            (0, $353d0bee69dff1f3$export$fcc956522ded1c3d)(groupUserId, setAlertState, setUpdatingGroupUserData, activeData, setActiveData, navigate);
                        },
                        text: "Delete User",
                        disabled: false
                    })
                ]
            })
        ]
    });
};
var $210aa5d972af57b8$export$2e2bcd8739ae039 = $210aa5d972af57b8$var$DeleteGroupUserDialog;



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $3QMQN = parcelRequire("3QMQN");
const $b6d8f150d7fd9fb6$export$5f5ae4f098ee35d8 = ({ alertState: alertState, setAlertState: setAlertState, userNameString: userNameString })=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            alertState.deleteUserSuccess && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                onClose: ()=>{
                    setAlertState((previousState)=>{
                        return {
                            ...previousState,
                            deleteUserSuccess: false
                        };
                    });
                },
                children: `User ${userNameString} deleted successfully.`
            }),
            alertState.updateUserSuccess && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                onClose: ()=>{
                    setAlertState((previousState)=>{
                        return {
                            ...previousState,
                            updateUserSuccess: false
                        };
                    });
                },
                children: `User ${userNameString} updated successfully.`
            }),
            alertState.addUserSuccess && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                onClose: ()=>{
                    setAlertState((previousState)=>{
                        return {
                            ...previousState,
                            addUserSuccess: false
                        };
                    });
                },
                children: `User ${userNameString} added successfully.`
            }),
            alertState.emailSent && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                onClose: ()=>{
                    setAlertState((previousState)=>{
                        return {
                            ...previousState,
                            emailSent: false
                        };
                    });
                },
                children: `Temporary password email sent to ${userNameString}`
            }),
            alertState.noData && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                severity: "warning",
                onClose: ()=>{
                    setAlertState((previousState)=>{
                        return {
                            ...previousState,
                            noData: false
                        };
                    });
                },
                children: `No users matched your search query.`
            })
        ]
    });
};



var $4wo2Y = parcelRequire("4wo2Y");

var $aYdit = parcelRequire("aYdit");
const $f908a9295259f46c$export$aca851be5a22d4 = ({ navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed })=>{
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
    const [groupUserData, setGroupUserData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [filteredData, setFilteredData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [filteredDataExists, setFilteredDataExists] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [groupUsersSearchString, setGroupUsersSearchString] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [fetchingGroupUserData, setFetchingGroupUserData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [backgroundLoadingData, setBackgroundLoadingData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [deleteGroupUserDialogOpen, setDeleteGroupUserDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [page, setPage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [rowsPerPage, setRowsPerPage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(5);
    const [aboutUserDialogOpen, setAboutUserDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [selectedRow, setSelectedRow] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [selectedRowIndex, setSelectedRowIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [groupUserId, setGroupUserId] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [updatingGroupUserData, setUpdatingGroupUserData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [alertState, setAlertState] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        updateUserSuccess: false,
        deleteUserSuccess: false,
        addUserSuccess: false,
        emailSent: false,
        noData: false
    });
    const [addGroupUserScreenOpen, setAddGroupUserScreenOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [userNameString, setUserNameString] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [activeData, setActiveData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(groupUserData);
    const [moreUsersToLoad, setMoreUsersToLoad] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [moreUsersToLoadPageNumber, setMoreUsersToLoadPageNumber] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(1);
    const navigate = (0, $3T949.useNavigate)();
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        (0, $73a394d7259def7a$export$1614696ef5abad76)(setGroupUserData, [], setFetchingGroupUserData, 1, "", setBackgroundLoadingData, setAlertState, setFilteredData, setActiveData, setMoreUsersToLoad, setMoreUsersToLoadPageNumber, navigate);
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $b6d8f150d7fd9fb6$export$5f5ae4f098ee35d8), {
                alertState: alertState,
                setAlertState: setAlertState,
                userNameString: userNameString
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "bg-actuate-grey absolute w-screen h-screen",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                        openState: fetchingGroupUserData,
                        message: "Fetching all Group Users..."
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                        openState: updatingGroupUserData
                    }),
                    aboutUserDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $5cf0a80d84c73879$export$88da4aff6349c23), {
                        aboutUserDialogOpen: aboutUserDialogOpen,
                        setAboutUserDialogOpen: setAboutUserDialogOpen,
                        row: selectedRow,
                        selectedRowIndex: selectedRowIndex,
                        setGroupUserData: setGroupUserData,
                        setUpdatingGroupUserData: setUpdatingGroupUserData,
                        setAlertState: setAlertState,
                        setActiveData: setActiveData,
                        navigate: navigate
                    }),
                    deleteGroupUserDialogOpen && groupUserData && /*#__PURE__*/ (0, $k4ank.jsx)((0, $210aa5d972af57b8$export$2e2bcd8739ae039), {
                        deleteGroupUserDialogOpen: deleteGroupUserDialogOpen,
                        setDeleteGroupUserDialogOpen: setDeleteGroupUserDialogOpen,
                        setAlertState: setAlertState,
                        groupUserId: groupUserId,
                        activeData: activeData,
                        setActiveData: setActiveData,
                        setUpdatingGroupUserData: setUpdatingGroupUserData,
                        navigate: navigate
                    }),
                    addGroupUserScreenOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $djxj8.default), {
                        sx: {
                            color: "#fff",
                            zIndex: (theme)=>theme.zIndex.drawer + 1
                        },
                        open: addGroupUserScreenOpen,
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $0a803b731d8683ba$export$8ac471d6114ad24e), {
                                setAddGroupUserScreenOpen: setAddGroupUserScreenOpen,
                                setUserNameString: setUserNameString,
                                setAlertState: setAlertState,
                                groupUsersSearchString: groupUsersSearchString,
                                activeData: activeData,
                                setActiveData: setActiveData
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: !navBarCollapsed ? "absolute top-[60px] left-[150px] right-[1px] h-[19px]] bg-white" : "absolute top-[60px] left-[75px] right-[1px] h-[19px]] bg-white",
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "font-black font-mulish text-[20px] p-3 indent-6",
                                children: "Group Users"
                            }),
                            userPermissions.manage_users && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "absolute top-[7px] right-[30px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f7388cb452bfd3ac$export$cb9d5b24bb2f81dd), {
                                    setAddGroupUserScreenOpen: setAddGroupUserScreenOpen,
                                    setAlertState: setAlertState
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: !navBarCollapsed ? "absolute left-[135px] top-[10px]" : "absolute left-[60px] top-[10px]",
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $c2f888309f655ce6$export$ef1630a032cdff70), {
                                setGroupUsersSearchString: setGroupUsersSearchString
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: !navBarCollapsed ? "absolute left-[500px] top-[10px]" : "absolute left-[425px] top-[10px]",
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3d4237145fb94641$export$f128da6ab8fef046), {
                                setGroupUserData: setGroupUserData,
                                setFetchingGroupUserData: setFetchingGroupUserData,
                                groupUsersSearchString: groupUsersSearchString,
                                backgroundLoadingData: backgroundLoadingData,
                                setBackgroundLoadingData: setBackgroundLoadingData,
                                setAlertState: setAlertState,
                                setPage: setPage,
                                setFilteredDataExists: setFilteredDataExists,
                                setFilteredData: setFilteredData,
                                setActiveData: setActiveData,
                                setMoreUsersToLoad: setMoreUsersToLoad,
                                setMoreUsersToLoadPageNumber: setMoreUsersToLoadPageNumber,
                                navigate: navigate
                            })
                        ]
                    }),
                    !fetchingGroupUserData && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: !navBarCollapsed ? "absolute left-[150px] top-[130px]" : "absolute left-[75px] top-[130px]",
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $92b1d119bcfac9c4$export$a53b0a5290ddc923), {
                                groupUserData: groupUserData,
                                page: page,
                                setPage: setPage,
                                rowsPerPage: rowsPerPage,
                                setRowsPerPage: setRowsPerPage,
                                setSelectedRow: setSelectedRow,
                                setAboutUserDialogOpen: setAboutUserDialogOpen,
                                setSelectedRowIndex: setSelectedRowIndex,
                                setGroupUserId: setGroupUserId,
                                setDeleteGroupUserDialogOpen: setDeleteGroupUserDialogOpen,
                                setUpdatingGroupUserData: setUpdatingGroupUserData,
                                setAlertState: setAlertState,
                                setUserNameString: setUserNameString,
                                filteredDataExists: filteredDataExists,
                                filteredData: filteredData,
                                activeData: activeData,
                                moreUsersToLoad: moreUsersToLoad,
                                setGroupUserData: setGroupUserData,
                                setFetchingGroupUserData: setFetchingGroupUserData,
                                moreUsersToLoadPageNumber: moreUsersToLoadPageNumber,
                                searchString: groupUsersSearchString,
                                setBackgroundLoadingData: setBackgroundLoadingData,
                                setFilteredData: setFilteredData,
                                setActiveData: setActiveData,
                                setMoreUsersToLoad: setMoreUsersToLoad,
                                setMoreUsersToLoadPageNumber: setMoreUsersToLoadPageNumber,
                                navigate: navigate
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "justify-start",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jVN1H.NavBar), {
                    navBarCollapsed: navBarCollapsed,
                    setNavBarCollapsed: setNavBarCollapsed,
                    props: {}
                })
            })
        ]
    });
};


/* eslint-disable react-hooks/exhaustive-deps */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $jVN1H = parcelRequire("jVN1H");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");

parcelRequire("8T3gX");
const $361dd3e7be612e92$export$75935ad7f1142eef = (inputDate)=>{
    if (!inputDate) return "";
    const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ];
    const year = inputDate.getFullYear();
    const month = monthNames[inputDate.getMonth()];
    const date = inputDate.getDate().toString().padStart(2, "0");
    return `${month}-${date}-${year}`;
};
const $361dd3e7be612e92$export$62d9148ecc46c98a = (metrics)=>{
    const formattedMetrics = metrics.map((metric)=>{
        return metric.toLowerCase().replace(" ", "_");
    });
    return formattedMetrics;
};
const $361dd3e7be612e92$export$59b2b76630cf930b = (userFilters, searchParams, setSearchParams, detectionType)=>{
    const params = new URLSearchParams(searchParams);
    if (userFilters.parent_group) params.set("group", userFilters.parent_group);
    else params.delete("group");
    if (userFilters.site) params.set("site", userFilters.site);
    else params.delete("site");
    if (userFilters.camera) params.set("camera", userFilters.camera);
    else params.delete("camera");
    if (userFilters.start_date) params.set("start_date", $361dd3e7be612e92$export$75935ad7f1142eef(userFilters.start_date));
    else params.delete("start_date");
    if (userFilters.end_date) params.set("end_date", $361dd3e7be612e92$export$75935ad7f1142eef(userFilters.end_date));
    else params.delete("end_date");
    if (userFilters.start_time) params.set("start_time", userFilters.start_time.toString().slice(16, 21).replace(":", ""));
    else params.delete("start_time");
    if (userFilters.end_time) params.set("end_time", userFilters.end_time.toString().slice(16, 21).replace(":", ""));
    else params.delete("end_time");
    if (userFilters.metrics) {
        if (userFilters.metrics.length > 0) params.set("metrics", $361dd3e7be612e92$export$62d9148ecc46c98a(userFilters.metrics).join(","));
        else params.delete("metrics");
    }
    if (userFilters.filter_type) params.set("filter_type", userFilters.filter_type);
    else params.delete("filter_type");
    if (detectionType) params.set("detection_type", detectionType);
    else params.delete("detection_type");
    if (userFilters.has_video) params.set("has_video", "true");
    else params.delete("has_video");
    setSearchParams(params);
};


const $a023b6d1002cc6b4$export$7d23aa6b071246c1 = ({ navigate: navigate, navBarCollapsed: navBarCollapsed, searchParams: searchParams, setSearchParams: setSearchParams })=>{
    const { userFilters: userFilters, setUserFilters: setUserFilters, setSiteDropDownValue: setSiteDropDownValue, setCameraDropDownValue: setCameraDropDownValue, setSiteOptions: setSiteOptions } = (0, $0acc3663e9cf84b8$export$e69ca36e0aa135e7)();
    const parentAccounts = JSON.parse(localStorage?.parentAccounts || "[]");
    const parentIds = new Map();
    const parentNames = new Map();
    parentAccounts.forEach((object)=>{
        parentIds.set(object.name, object.id);
    });
    parentAccounts.forEach((object)=>{
        parentNames.set(object.id, object.name);
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            disablePortal: true,
            options: parentAccounts[0] ? parentAccounts.map((object, index)=>({
                    id: object.id,
                    name: object.name,
                    index: index
                })) : [],
            getOptionLabel: (option)=>option.name || "",
            isOptionEqualToValue: (option, value)=>option.id === value.id,
            value: userFilters.parent_group ? {
                id: Number(userFilters.parent_group),
                name: parentNames.get(Number(userFilters.parent_group)),
                index: parentAccounts.findIndex((obj)=>obj.id === Number(userFilters.parent_group))
            } : null,
            onChange: (event, value)=>{
                setSiteDropDownValue([]);
                localStorage.setItem("siteDropDownValueAnalytics", JSON.stringify([]));
                setCameraDropDownValue([]);
                localStorage.setItem("cameraDropDownValueAnalytics", JSON.stringify([]));
                if (localStorage.filtersSavedClicked === "true") localStorage.setItem("savedAnalyticsFilters", JSON.stringify({
                    parent_group: value?.id || "",
                    site: [],
                    camera: [],
                    start_date: userFilters.start_date,
                    end_date: userFilters.end_date
                }));
                if (value !== null) {
                    localStorage.setItem("analyticsParentGroupId", value.id);
                    (0, $0acc3663e9cf84b8$export$664d1b7592a4aa30)(value.id, navigate);
                    setUserFilters((previousState)=>{
                        return {
                            ...previousState,
                            parent_group: value.id,
                            site: [],
                            camera: []
                        };
                    });
                    (0, $361dd3e7be612e92$export$59b2b76630cf930b)({
                        ...userFilters,
                        parent_group: value.id,
                        site: [],
                        camera: []
                    }, searchParams, setSearchParams, "");
                } else {
                    setSiteDropDownValue([]);
                    localStorage.setItem("siteDropDownValueAnalytics", JSON.stringify([]));
                    setSiteOptions([]);
                    localStorage.setItem("analyticsParentGroupId", "");
                    setUserFilters((previousState)=>{
                        return {
                            ...previousState,
                            parent_group: "",
                            site: [],
                            camera: []
                        };
                    });
                    (0, $361dd3e7be612e92$export$59b2b76630cf930b)({
                        ...userFilters,
                        parent_group: "",
                        site: [],
                        camera: []
                    }, searchParams, setSearchParams, "");
                }
            },
            sx: navBarCollapsed ? {
                width: 275
            } : {
                width: 200
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    label: "Parent Group",
                    autoComplete: "off"
                }),
            renderOption: (props, option)=>/*#__PURE__*/ (0, $8T3gX.createElement)("li", {
                    ...props,
                    key: option.id
                }, option.name)
        })
    }, "parent_groups_dropdown");
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $60vL1 = parcelRequire("60vL1");
var $eejVe = parcelRequire("eejVe");


const $3584f976f7216e17$export$1842888d8c53627 = ({ navigate: navigate, searchParams: searchParams, setSearchParams: setSearchParams })=>{
    const { userFilters: userFilters, setUserFilters: setUserFilters, siteOptions: siteOptions, setCameraOptions: setCameraOptions, siteDropDownValue: siteDropDownValue, setSiteDropDownValue: setSiteDropDownValue, setCameraDropDownValue: setCameraDropDownValue, loadingSites: loadingSites } = (0, $0acc3663e9cf84b8$export$e69ca36e0aa135e7)();
    const siteIds = new Map();
    siteOptions.forEach((object)=>{
        siteIds.set(object.name, object.id);
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            multiple: true,
            limitTags: 1,
            value: siteDropDownValue && siteDropDownValue.length > 0 ? siteDropDownValue.map((siteName)=>{
                const siteOption = siteOptions.find((site)=>site.name === siteName);
                return siteOption ? {
                    id: siteOption.id,
                    name: siteOption.name
                } : null;
            }).filter((item)=>item !== null) : [],
            disablePortal: true,
            options: siteOptions && siteOptions.length > 0 ? siteOptions.map((object)=>({
                    id: object.id,
                    name: object.name
                })) : [],
            getOptionLabel: (option)=>{
                if (!option || typeof option === "string") return option || "";
                return option.name || "";
            },
            isOptionEqualToValue: (option, value)=>{
                if (!option || !value) return false;
                return option.id === value.id;
            },
            loading: loadingSites,
            onChange: (event, value)=>{
                if (value && value.length > 0) {
                    const siteIdsArray = [];
                    const siteValuesArray = [];
                    value.forEach((element)=>{
                        if (element && element.id && element.name) {
                            siteIdsArray.push(element.id);
                            siteValuesArray.push(element.name);
                        }
                    });
                    if (localStorage.filtersSavedClicked === "true") {
                        localStorage.setItem("siteDropDownValues", JSON.stringify(siteValuesArray));
                        localStorage.setItem("savedAnalyticsFilters", JSON.stringify({
                            parent_group: userFilters.parent_group,
                            site: siteIdsArray,
                            camera: [],
                            start_date: userFilters.start_date,
                            end_date: userFilters.end_date
                        }));
                    }
                    setSiteDropDownValue(siteValuesArray);
                    localStorage.setItem("siteDropDownValueAnalytics", JSON.stringify(siteValuesArray));
                    setCameraDropDownValue([]);
                    localStorage.setItem("cameraDropDownValues", "[]");
                    (0, $0acc3663e9cf84b8$export$a14df7b657d0c56a)(siteIdsArray, navigate);
                    setUserFilters((previousState)=>{
                        return {
                            ...previousState,
                            site: siteIdsArray,
                            camera: []
                        };
                    });
                    (0, $361dd3e7be612e92$export$59b2b76630cf930b)({
                        ...userFilters,
                        site: siteIdsArray,
                        camera: []
                    }, searchParams, setSearchParams, "");
                } else {
                    setSiteDropDownValue([]);
                    localStorage.setItem("siteDropDownValueAnalytics", JSON.stringify([]));
                    setCameraDropDownValue([]);
                    localStorage.setItem("cameraDropDownValueAnalytics", JSON.stringify([]));
                    setCameraOptions([]);
                    setUserFilters((previousState)=>{
                        return {
                            ...previousState,
                            site: [],
                            camera: []
                        };
                    });
                    (0, $361dd3e7be612e92$export$59b2b76630cf930b)({
                        ...userFilters,
                        site: [],
                        camera: []
                    }, searchParams, setSearchParams, "");
                    if (localStorage.filtersSavedClicked === "true") {
                        localStorage.setItem("siteDropDownValues", JSON.stringify([]));
                        localStorage.setItem("cameraDropDownValues", JSON.stringify([]));
                        localStorage.setItem("savedAnalyticsFilters", JSON.stringify({
                            parent_group: userFilters.parent_group,
                            site: [],
                            camera: [],
                            start_date: userFilters.start_date,
                            end_date: userFilters.end_date
                        }));
                    }
                }
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    label: "Sites",
                    InputProps: {
                        ...params.InputProps,
                        endAdornment: /*#__PURE__*/ (0, $k4ank.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                            children: [
                                loadingSites ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                    color: "inherit",
                                    size: 20
                                }) : null,
                                params.InputProps.endAdornment
                            ]
                        })
                    },
                    sx: {
                        width: 285
                    }
                }),
            renderOption: (props, option)=>/*#__PURE__*/ (0, $8T3gX.createElement)("li", {
                    ...props,
                    key: option?.id || Math.random()
                }, option?.name || "")
        })
    }, "site_dropdown");
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $60vL1 = parcelRequire("60vL1");
var $eejVe = parcelRequire("eejVe");


const $f90c597dd583ee7e$export$25c9aaa7160564ac = ({ searchParams: searchParams, setSearchParams: setSearchParams })=>{
    const { userFilters: userFilters, setUserFilters: setUserFilters, cameraOptions: cameraOptions, cameraDropDownValue: cameraDropDownValue, setCameraDropDownValue: setCameraDropDownValue, loadingCameras: loadingCameras } = (0, $0acc3663e9cf84b8$export$e69ca36e0aa135e7)();
    const cameraIds = new Map();
    cameraOptions.forEach((object)=>{
        cameraIds.set(object.camera_name, object.id);
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            disablePortal: true,
            multiple: true,
            limitTags: 1,
            value: cameraDropDownValue && cameraDropDownValue.length > 0 ? cameraDropDownValue.map((cameraName)=>{
                const cameraOption = cameraOptions.find((camera)=>camera.camera_name === cameraName);
                return cameraOption ? {
                    id: cameraOption.id,
                    name: cameraOption.camera_name
                } : null;
            }).filter((item)=>item !== null) : [],
            options: cameraOptions && cameraOptions.length > 0 ? cameraOptions.map((object)=>({
                    id: object.id,
                    name: object.camera_name
                })) : [],
            getOptionLabel: (option)=>{
                if (!option || typeof option === "string") return option || "";
                return option.name || "";
            },
            isOptionEqualToValue: (option, value)=>{
                if (!option || !value) return false;
                return option.id === value.id;
            },
            loading: loadingCameras,
            onChange: (event, value)=>{
                if (value !== null) {
                    const cameraIdsArray = [];
                    const cameraValuesArray = [];
                    value.forEach((element)=>{
                        if (element && element.id && element.name) {
                            cameraIdsArray.push(element.id);
                            cameraValuesArray.push(element.name);
                        }
                    });
                    if (localStorage.filtersSavedClicked === "true") {
                        localStorage.setItem("cameraDropDownValues", JSON.stringify(cameraValuesArray));
                        localStorage.setItem("savedAnalyticsFilters", JSON.stringify({
                            parent_group: userFilters.parent_group,
                            site: userFilters.site,
                            camera: cameraIdsArray,
                            start_date: userFilters.start_date,
                            end_date: userFilters.end_date
                        }));
                    }
                    setCameraDropDownValue(cameraValuesArray);
                    localStorage.setItem("cameraDropDownValueAnalytics", JSON.stringify(cameraValuesArray));
                    setUserFilters((previousState)=>{
                        return {
                            ...previousState,
                            camera: cameraIdsArray
                        };
                    });
                    (0, $361dd3e7be612e92$export$59b2b76630cf930b)({
                        ...userFilters,
                        camera: cameraIdsArray
                    }, searchParams, setSearchParams, "");
                }
            },
            sx: {
                width: 285
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    label: "Cameras",
                    InputProps: {
                        ...params.InputProps,
                        endAdornment: /*#__PURE__*/ (0, $k4ank.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                            children: [
                                loadingCameras ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                    color: "inherit",
                                    size: 20
                                }) : null,
                                params.InputProps.endAdornment
                            ]
                        })
                    }
                }),
            renderOption: (props, option)=>/*#__PURE__*/ (0, $8T3gX.createElement)("li", {
                    ...props,
                    key: option?.id || Math.random()
                }, option?.name || "")
        })
    }, "camera_dropdown");
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $hfM8m = parcelRequire("hfM8m");

var $hwWkD = parcelRequire("hwWkD");


var $eejVe = parcelRequire("eejVe");

var $iKAtE = parcelRequire("iKAtE");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");

var $i5MAs = parcelRequire("i5MAs");

var $aYdit = parcelRequire("aYdit");


var $9HNQQ = parcelRequire("9HNQQ");

var $h9XEd = parcelRequire("h9XEd");

var $kklX3 = parcelRequire("kklX3");

var $f2M1w = parcelRequire("f2M1w");

var $gms4p = parcelRequire("gms4p");
var $8b1052a9e0a3a1e9$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $8b1052a9e0a3a1e9$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $8b1052a9e0a3a1e9$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $8b1052a9e0a3a1e9$var$formatLong = {
    date: (0, $gms4p.default)({
        formats: $8b1052a9e0a3a1e9$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $gms4p.default)({
        formats: $8b1052a9e0a3a1e9$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $gms4p.default)({
        formats: $8b1052a9e0a3a1e9$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $8b1052a9e0a3a1e9$export$2e2bcd8739ae039 = $8b1052a9e0a3a1e9$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik]{@link https://github.com/glintik}
 */ var $253608f850203ed2$var$locale = {
    code: 'en-GB',
    formatDistance: (0, $9HNQQ.default),
    formatLong: (0, $8b1052a9e0a3a1e9$export$2e2bcd8739ae039),
    formatRelative: (0, $h9XEd.default),
    localize: (0, $kklX3.default),
    match: (0, $f2M1w.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $253608f850203ed2$export$2e2bcd8739ae039 = $253608f850203ed2$var$locale;


var $jgags = parcelRequire("jgags");

const $135b860d1b01af2e$export$e6a9e9489cd100d0 = ({ searchParams: searchParams, setSearchParams: setSearchParams })=>{
    const { userFilters: userFilters, setUserFilters: setUserFilters, setAlertState: setAlertState, setShowMoreVisible: setShowMoreVisible, setShowMoreOpen: setShowMoreOpen, setDateChangesMade: setDateChangesMade } = (0, $0acc3663e9cf84b8$export$e69ca36e0aa135e7)();
    const [startTimeAnchorEl, setStartTimeAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const startTimeOpen = Boolean(startTimeAnchorEl);
    const handleStartTimeClick = (event)=>{
        setStartTimeAnchorEl(event.currentTarget);
    };
    const handleStartTimeClose = (event)=>{
        event.stopPropagation();
        setStartTimeAnchorEl(null);
    };
    const { dateMMDDYYYY: dateMMDDYYYY, setDateMMDDYYYY: setDateMMDDYYYY } = (0, $aYdit.useAppStore)();
    const selectedLocale = dateMMDDYYYY ? (0, $jgags.default) : (0, $253608f850203ed2$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
        dateAdapter: (0, $hfM8m.AdapterDateFns),
        adapterLocale: selectedLocale,
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cbaf068f14972fdf$export$5109c6dd95d8fb00), {
            label: userFilters.start_date ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                        children: "Start Date"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                "aria-label": "more",
                                id: "long-button",
                                "aria-controls": startTimeOpen ? "long-menu" : undefined,
                                "aria-expanded": startTimeOpen ? "true" : undefined,
                                "aria-haspopup": "true",
                                onClick: handleStartTimeClick,
                                sx: {
                                    marginLeft: "5px",
                                    padding: 0,
                                    color: "#000000",
                                    "&:hover": {
                                        backgroundColor: "transparent"
                                    }
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5MAs))), {})
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                                id: "long-menu",
                                MenuListProps: {
                                    "aria-labelledby": "long-button"
                                },
                                anchorOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                anchorEl: startTimeAnchorEl,
                                open: startTimeOpen,
                                onClose: handleStartTimeClose,
                                slotProps: {
                                    paper: {
                                        style: {
                                            maxHeight: 216,
                                            width: "20ch"
                                        }
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: (event)=>{
                                            setDateMMDDYYYY(true);
                                            handleStartTimeClose(event);
                                        },
                                        children: "MM/DD/YYYY"
                                    }, "mm-dd-yyyy-start"),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: (event)=>{
                                            setDateMMDDYYYY(false);
                                            handleStartTimeClose(event);
                                        },
                                        children: "DD/MM/YYYY"
                                    }, "dd-mm-yyyy-start")
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                children: "Start Date"
            }),
            value: userFilters.start_date,
            onChange: (newValue)=>{
                if (newValue === null) {
                    setUserFilters((previousState)=>({
                            ...previousState,
                            start_date: new Date()
                        }));
                    (0, $361dd3e7be612e92$export$59b2b76630cf930b)({
                        ...userFilters,
                        start_date: new Date()
                    }, searchParams, setSearchParams, "");
                    return;
                }
                setDateChangesMade(true);
                const furthestDate = new Date();
                furthestDate.setDate(furthestDate.getDate() - 62);
                setShowMoreVisible(false);
                setShowMoreOpen(false);
                if (localStorage.filtersSavedClicked === "true") localStorage.setItem("savedAnalyticsFilters", JSON.stringify({
                    parent_group: userFilters.parent_group,
                    site: userFilters.site,
                    camera: userFilters.camera,
                    start_date: newValue,
                    end_date: userFilters.end_date
                }));
                setAlertState({
                    dateTooFar: false,
                    startAfterEnd: false,
                    endBeforeStart: false
                });
                if (newValue !== null && newValue > furthestDate && (newValue <= userFilters.end_date || userFilters.end_date === null)) {
                    setUserFilters((previousState)=>({
                            ...previousState,
                            start_date: newValue
                        }));
                    (0, $361dd3e7be612e92$export$59b2b76630cf930b)({
                        ...userFilters,
                        start_date: newValue
                    }, searchParams, setSearchParams, "");
                }
                if (newValue !== null && newValue <= furthestDate && userFilters.end_date !== null) setAlertState({
                    dateTooFar: true,
                    startAfterEnd: false,
                    endBeforeStart: false
                });
                if (newValue !== null && newValue > userFilters.end_date && userFilters.end_date !== null) setAlertState({
                    dateTooFar: false,
                    startAfterEnd: true,
                    endBeforeStart: false
                });
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    sx: {
                        width: 150
                    },
                    helperText: "*Required",
                    ...params
                })
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $hfM8m = parcelRequire("hfM8m");

var $hwWkD = parcelRequire("hwWkD");


var $eejVe = parcelRequire("eejVe");

var $iKAtE = parcelRequire("iKAtE");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");

var $i5MAs = parcelRequire("i5MAs");

var $aYdit = parcelRequire("aYdit");


var $jgags = parcelRequire("jgags");

const $ef51eb25f198b378$export$b6561c99a15830c3 = ({ searchParams: searchParams, setSearchParams: setSearchParams })=>{
    const { userFilters: userFilters, setUserFilters: setUserFilters, setAlertState: setAlertState, setShowMoreVisible: setShowMoreVisible, setShowMoreOpen: setShowMoreOpen, setDateChangesMade: setDateChangesMade } = (0, $0acc3663e9cf84b8$export$e69ca36e0aa135e7)();
    const [endTimeAnchorEl, setEndTimeAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const endTimeOpen = Boolean(endTimeAnchorEl);
    const handleEndTimeClick = (event)=>{
        setEndTimeAnchorEl(event.currentTarget);
    };
    const handleEndTimeClose = (event)=>{
        event.stopPropagation();
        setEndTimeAnchorEl(null);
    };
    const { dateMMDDYYYY: dateMMDDYYYY, setDateMMDDYYYY: setDateMMDDYYYY } = (0, $aYdit.useAppStore)();
    const selectedLocale = dateMMDDYYYY ? (0, $jgags.default) : (0, $253608f850203ed2$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
        dateAdapter: (0, $hfM8m.AdapterDateFns),
        adapterLocale: selectedLocale,
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cbaf068f14972fdf$export$5109c6dd95d8fb00), {
            label: userFilters.end_date ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                        children: "End Date"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                "aria-label": "more",
                                id: "long-button",
                                "aria-controls": endTimeOpen ? "long-menu" : undefined,
                                "aria-expanded": endTimeOpen ? "true" : undefined,
                                "aria-haspopup": "true",
                                onClick: handleEndTimeClick,
                                sx: {
                                    marginLeft: "5px",
                                    padding: 0,
                                    color: "#000000",
                                    "&:hover": {
                                        backgroundColor: "transparent"
                                    }
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5MAs))), {})
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                                id: "long-menu",
                                MenuListProps: {
                                    "aria-labelledby": "long-button"
                                },
                                anchorOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                anchorEl: endTimeAnchorEl,
                                open: endTimeOpen,
                                onClose: handleEndTimeClose,
                                slotProps: {
                                    paper: {
                                        style: {
                                            maxHeight: 216,
                                            width: "20ch"
                                        }
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: (event)=>{
                                            setDateMMDDYYYY(true);
                                            handleEndTimeClose(event);
                                        },
                                        children: "MM/DD/YYYY"
                                    }, "mm-dd-yyyy-end"),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: (event)=>{
                                            setDateMMDDYYYY(false);
                                            handleEndTimeClose(event);
                                        },
                                        children: "DD/MM/YYYY"
                                    }, "dd-mm-yyyy-end")
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                children: "End Date"
            }),
            value: userFilters.end_date,
            onChange: (newValue)=>{
                if (newValue === null) {
                    setUserFilters((previousState)=>({
                            ...previousState,
                            end_date: new Date()
                        }));
                    (0, $361dd3e7be612e92$export$59b2b76630cf930b)({
                        ...userFilters,
                        end_date: new Date()
                    }, searchParams, setSearchParams, "");
                    return;
                }
                setDateChangesMade(true);
                setShowMoreVisible(false);
                setShowMoreOpen(false);
                if (localStorage.filtersSavedClicked === "true") localStorage.setItem("savedAnalyticsFilters", JSON.stringify({
                    parent_group: userFilters.parent_group,
                    site: userFilters.site,
                    camera: userFilters.camera,
                    start_date: userFilters.start_date,
                    end_date: newValue
                }));
                setAlertState({
                    dateTooFar: false,
                    startAfterEnd: false,
                    endBeforeStart: false
                });
                if (newValue !== null && (newValue > userFilters.start_date || newValue.toString() === userFilters.start_date.toString())) {
                    setUserFilters((previousState)=>({
                            ...previousState,
                            end_date: newValue
                        }));
                    (0, $361dd3e7be612e92$export$59b2b76630cf930b)({
                        ...userFilters,
                        end_date: newValue
                    }, searchParams, setSearchParams, "");
                }
                if (newValue !== null && newValue < userFilters.start_date && newValue.toString() !== userFilters.start_date.toString() && userFilters.start_date !== null) setAlertState({
                    dateTooFar: false,
                    startAfterEnd: false,
                    endBeforeStart: true
                });
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    sx: {
                        width: 150
                    },
                    helperText: "*Required",
                    ...params
                })
        })
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");
const $e463268c7e8e327a$export$ed9212dd4ba77236 = ({ navBarCollapsed: navBarCollapsed })=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                className: "absolute top-[35px] left-[20px]",
                children: /*#__PURE__*/ (0, $k4ank.jsx)("line", {
                    pathLength: "1535",
                    x1: "0",
                    y1: "0",
                    x2: "300",
                    y2: "0",
                    style: {
                        stroke: `#BDBDBD`,
                        strokeWidth: 2
                    }
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                className: "absolute top-[35px] left-[320px]",
                children: /*#__PURE__*/ (0, $k4ank.jsx)("line", {
                    pathLength: "1535",
                    x1: "0",
                    y1: "0",
                    x2: "300",
                    y2: "0",
                    style: {
                        stroke: `#BDBDBD`,
                        strokeWidth: 2
                    }
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                className: "absolute top-[35px] left-[620px]",
                children: /*#__PURE__*/ (0, $k4ank.jsx)("line", {
                    pathLength: "1535",
                    x1: "0",
                    y1: "0",
                    x2: "300",
                    y2: "0",
                    style: {
                        stroke: `#BDBDBD`,
                        strokeWidth: 2
                    }
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                className: "absolute top-[35px] left-[920px]",
                children: /*#__PURE__*/ (0, $k4ank.jsx)("line", {
                    pathLength: "1535",
                    x1: "0",
                    y1: "0",
                    x2: "300",
                    y2: "0",
                    style: {
                        stroke: `#BDBDBD`,
                        strokeWidth: 2
                    }
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                className: "absolute top-[35px] left-[970px]",
                children: /*#__PURE__*/ (0, $k4ank.jsx)("line", {
                    pathLength: "1535",
                    x1: "0",
                    y1: "0",
                    x2: "300",
                    y2: "0",
                    style: {
                        stroke: `#BDBDBD`,
                        strokeWidth: 2
                    }
                })
            }),
            navBarCollapsed && /*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                className: "absolute top-[35px] left-[1045px]",
                children: /*#__PURE__*/ (0, $k4ank.jsx)("line", {
                    pathLength: "1535",
                    x1: "0",
                    y1: "0",
                    x2: "300",
                    y2: "0",
                    style: {
                        stroke: `#BDBDBD`,
                        strokeWidth: 2
                    }
                })
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $8jTCz = parcelRequire("8jTCz");

var $a7uO0 = parcelRequire("a7uO0");

var $k4ank = parcelRequire("k4ank");
"use client";
var $68f1b505950a9d00$export$2e2bcd8739ae039 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "m20 12-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8z"
}), 'ArrowDownward');



const $5c9eb981c615598b$export$fc9722a813484b48 = ()=>{
    const { downloadURL: downloadURL } = (0, $0acc3663e9cf84b8$export$e69ca36e0aa135e7)();
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
        onClick: "",
        text: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $68f1b505950a9d00$export$2e2bcd8739ae039), {}),
                "\xa0",
                /*#__PURE__*/ (0, $k4ank.jsx)("a", {
                    href: downloadURL,
                    download: true,
                    children: downloadURL ? "Download" : "Retrieving Download Data..."
                })
            ]
        }),
        disabled: !downloadURL
    });
};



var $kbChx = parcelRequire("kbChx");

var $k4ank = parcelRequire("k4ank");


var $60vL1 = parcelRequire("60vL1");

parcelRequire("8T3gX");
const $fa3cc2782da460a5$export$377ae678b127bf92 = (dateGraphName)=>{
    switch(dateGraphName){
        case "Parent Group":
            return `Total alerts for selected Parent Group during selected dates`;
        case "":
            return `Total alerts for all Parent Groups during selected dates`;
        case "Site":
            return `Total alerts for selected Site(s) during selected dates`;
        case "Camera":
            return `Total alerts for selected Camera(s) during selected dates`;
    }
};


parcelRequire("8T3gX");
const $b06959827efb70d8$var$colorsArray = [
    "#FF8400",
    "#01579B",
    "#D32F2F",
    "#2E7D32",
    "#8830FC",
    "#FFC208",
    "#AD1457",
    "#0288D1",
    "#019B8C",
    "#38019B",
    "#CCA409",
    "#019B4D",
    "#CC4809",
    "#9B0157",
    "#9B0152",
    "#01589B",
    "#C00030",
    "#90C000",
    "#E67700",
    "#0267B3",
    "#B92727",
    "#26802E",
    "#7A29E6",
    "#FFB700",
    "#9C124E",
    "#0273A8",
    "#018571",
    "#31018A",
    "#B28F07",
    "#018B44",
    "#B84307",
    "#8A014B",
    "#8A0146",
    "#014D8A",
    "#AA002B",
    "#7FAA00",
    "#D9480F",
    "#6001A8"
];
const $b06959827efb70d8$var$labelsArray = [
    "intruder",
    "vehicle",
    "bike",
    "intruder_plus",
    "vehicle_plus",
    "bike_plus",
    "gun",
    "pistol",
    "crowd",
    "loiterer",
    "vehicle_loiterer",
    "people_flow",
    "social_distancing",
    "fall_person",
    "mask",
    "mask_compliance",
    "no_mask",
    "no_hard_hat",
    "left_object",
    "package",
    "amazon",
    "dhl",
    "fedex",
    "school_bus",
    "ups",
    "usps",
    "envera",
    "sudden_scene_change",
    "fire",
    "smoke",
    "car",
    "bicycle",
    "bus",
    "motorcycle",
    "truck",
    "fall",
    "fire_truck",
    "non_ups"
];
const $b06959827efb70d8$export$5e8707888a87d695 = (label, colorString)=>{
    switch(label){
        case $b06959827efb70d8$var$labelsArray[0]:
            return $b06959827efb70d8$var$colorsArray[0];
        case $b06959827efb70d8$var$labelsArray[1]:
            return $b06959827efb70d8$var$colorsArray[1];
        case $b06959827efb70d8$var$labelsArray[2]:
            return $b06959827efb70d8$var$colorsArray[2];
        case $b06959827efb70d8$var$labelsArray[3]:
            return $b06959827efb70d8$var$colorsArray[3];
        case $b06959827efb70d8$var$labelsArray[4]:
            return $b06959827efb70d8$var$colorsArray[4];
        case $b06959827efb70d8$var$labelsArray[5]:
            return $b06959827efb70d8$var$colorsArray[5];
        case $b06959827efb70d8$var$labelsArray[6]:
            return $b06959827efb70d8$var$colorsArray[6];
        case $b06959827efb70d8$var$labelsArray[7]:
            return $b06959827efb70d8$var$colorsArray[7];
        case $b06959827efb70d8$var$labelsArray[8]:
            return $b06959827efb70d8$var$colorsArray[8];
        case $b06959827efb70d8$var$labelsArray[9]:
            return $b06959827efb70d8$var$colorsArray[9];
        case $b06959827efb70d8$var$labelsArray[10]:
            return $b06959827efb70d8$var$colorsArray[10];
        case $b06959827efb70d8$var$labelsArray[11]:
            return $b06959827efb70d8$var$colorsArray[11];
        case $b06959827efb70d8$var$labelsArray[12]:
            return $b06959827efb70d8$var$colorsArray[12];
        case $b06959827efb70d8$var$labelsArray[13]:
            return $b06959827efb70d8$var$colorsArray[13];
        case $b06959827efb70d8$var$labelsArray[14]:
            return $b06959827efb70d8$var$colorsArray[14];
        case $b06959827efb70d8$var$labelsArray[15]:
            return $b06959827efb70d8$var$colorsArray[15];
        case $b06959827efb70d8$var$labelsArray[16]:
            return $b06959827efb70d8$var$colorsArray[16];
        case $b06959827efb70d8$var$labelsArray[17]:
            return $b06959827efb70d8$var$colorsArray[17];
        case $b06959827efb70d8$var$labelsArray[18]:
            return $b06959827efb70d8$var$colorsArray[18];
        case $b06959827efb70d8$var$labelsArray[19]:
            return $b06959827efb70d8$var$colorsArray[19];
        case $b06959827efb70d8$var$labelsArray[20]:
            return $b06959827efb70d8$var$colorsArray[20];
        case $b06959827efb70d8$var$labelsArray[21]:
            return $b06959827efb70d8$var$colorsArray[21];
        case $b06959827efb70d8$var$labelsArray[22]:
            return $b06959827efb70d8$var$colorsArray[22];
        case $b06959827efb70d8$var$labelsArray[23]:
            return $b06959827efb70d8$var$colorsArray[23];
        case $b06959827efb70d8$var$labelsArray[24]:
            return $b06959827efb70d8$var$colorsArray[24];
        case $b06959827efb70d8$var$labelsArray[25]:
            return $b06959827efb70d8$var$colorsArray[25];
        case $b06959827efb70d8$var$labelsArray[26]:
            return $b06959827efb70d8$var$colorsArray[26];
        case $b06959827efb70d8$var$labelsArray[27]:
            return $b06959827efb70d8$var$colorsArray[27];
        case $b06959827efb70d8$var$labelsArray[28]:
            return $b06959827efb70d8$var$colorsArray[28];
        case $b06959827efb70d8$var$labelsArray[29]:
            return $b06959827efb70d8$var$colorsArray[29];
        case $b06959827efb70d8$var$labelsArray[30]:
            return $b06959827efb70d8$var$colorsArray[30];
        case $b06959827efb70d8$var$labelsArray[31]:
            return $b06959827efb70d8$var$colorsArray[31];
        case $b06959827efb70d8$var$labelsArray[32]:
            return $b06959827efb70d8$var$colorsArray[32];
        case $b06959827efb70d8$var$labelsArray[33]:
            return $b06959827efb70d8$var$colorsArray[33];
        case $b06959827efb70d8$var$labelsArray[34]:
            return $b06959827efb70d8$var$colorsArray[34];
        case $b06959827efb70d8$var$labelsArray[35]:
            return $b06959827efb70d8$var$colorsArray[35];
        case $b06959827efb70d8$var$labelsArray[36]:
            return $b06959827efb70d8$var$colorsArray[36];
        case $b06959827efb70d8$var$labelsArray[37]:
            return $b06959827efb70d8$var$colorsArray[37];
        case $b06959827efb70d8$var$labelsArray[38]:
            return $b06959827efb70d8$var$colorsArray[38];
        default:
            return colorString;
    }
};


const $6f68f8ae1baffd60$export$7aaf3a0014fad3dd = ({ navBarCollapsed: navBarCollapsed })=>{
    const { allAlertsData: allAlertsData, loadingData: loadingData, dateGraphName: dateGraphName } = (0, $0acc3663e9cf84b8$export$e69ca36e0aa135e7)();
    const labelNames = [];
    const labelsAndColorsArray = [];
    const labelDisplayNames = [];
    let labelStringLength = 0;
    allAlertsData.forEach((object)=>{
        if (object.label && object.label.display_name) {
            if (!labelDisplayNames.includes(object.label.display_name)) {
                labelDisplayNames.push(object.label.display_name);
                labelStringLength += object.label.display_name.length;
            }
        }
        if (!labelsAndColorsArray[0]) {
            labelNames.push(object.label.name);
            labelsAndColorsArray.push({
                label: object.label
            });
        }
        labelsAndColorsArray.forEach(()=>{
            if (!labelNames.includes(object.label.name)) {
                labelsAndColorsArray.push({
                    label: object.label
                });
                labelNames.push(object.label.name);
            }
        });
    });
    let bottomLength = 36;
    if (labelStringLength > 47 && labelStringLength < 95) bottomLength = 56;
    if (labelStringLength > 94) bottomLength = 76;
    const conversionArray = [];
    allAlertsData.forEach((object)=>{
        if (!conversionArray[0]) {
            const pushedObject = {
                date: object.date,
                [object.label.name]: object.alert_volume
            };
            conversionArray.push(pushedObject);
        }
        let dateExists = false;
        conversionArray.forEach((obj, index)=>{
            if (object.date === obj.date) {
                dateExists = true;
                conversionArray[index][object.label.name] = object.alert_volume;
            }
            if (index === conversionArray.length - 1 && !dateExists) conversionArray.push({
                date: object.date,
                [object.label.name]: object.alert_volume
            });
        });
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: navBarCollapsed ? "absolute top-[70px] left-[20px] right-[1px] h-[425px] w-[652px] bg-[#BDBDBD]" : "absolute top-[70px] left-[20px] right-[1px] h-[425px] w-[610px] bg-[#BDBDBD]",
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: navBarCollapsed ? "absolute top-[1px] left-[1px] right-[1px] h-[423px] w-[650px] bg-white" : "absolute top-[1px] left-[1px] right-[1px] h-[423px] w-[608px] bg-white",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "text-actuate-blue font-mulish text-[22px] font-bold absolute top-[8px] left-[40px]",
                    children: "Alerts by Date"
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "text-actuate-blue font-mulish text-[14px] absolute top-[36px] left-[40px]",
                    children: (0, $fa3cc2782da460a5$export$377ae678b127bf92)(dateGraphName)
                }),
                !loadingData.allAlertsData && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "absolute top-[60px] left-[0px]",
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $dc284d0fb10e6f6a$export$94aefc399ef206a9), {
                        width: !navBarCollapsed ? 610 : 652,
                        height: 365,
                        ...conversionArray.length < 4 && {
                            barSize: 120
                        },
                        data: conversionArray,
                        margin: {
                            top: 5,
                            right: 30,
                            left: 5,
                            bottom: 5
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $381060c808bbe825$export$6440e27b9f186856), {
                                strokeDasharray: "3 3"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $e3fbaf009dcc8585$export$ea77231de273b52d), {
                                dataKey: "date"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $c7554316bfb1649b$export$f96c4024c52de8f4), {
                                allowDecimals: false
                            }),
                            conversionArray[0] && /*#__PURE__*/ (0, $k4ank.jsx)((0, $45dbb8bb277f9d9d$export$28c660c63b792dea), {}),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $a67bff487a060557$export$ed247974535929c7), {
                                height: bottomLength
                            }),
                            labelsAndColorsArray.map((object)=>{
                                return /*#__PURE__*/ (0, $k4ank.jsx)((0, $7d5fe63ca2eb078d$export$bbc6c6369b38e3d1), {
                                    dataKey: object.label.name,
                                    stackId: "a",
                                    fill: (0, $b06959827efb70d8$export$5e8707888a87d695)(object.label.name, object.label.color),
                                    name: object.label.display_name.charAt(0).toUpperCase() + object.label.display_name.slice(1)
                                }, object.label.name);
                            })
                        ]
                    })
                }),
                loadingData.allAlertsData && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "absolute top-[170px] left-[230px]",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                            size: 25,
                            sx: {
                                position: "relative",
                                left: 40
                            }
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "font-mulish text-actuate-blue test-bold",
                            children: "Fetching Data..."
                        })
                    ]
                })
            ]
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");


var $60vL1 = parcelRequire("60vL1");

var $fHwDV = parcelRequire("fHwDV");


parcelRequire("8T3gX");
const $93fec414155a6ce6$export$5b1fba83bd6768a7 = (conversionArray)=>{
    const totalsArray = [];
    conversionArray.forEach((obj)=>{
        let total = 0;
        for(const key in obj)if (key !== "name" && key !== "abreviated_name") total += Number(obj[key]);
        totalsArray.push([
            total,
            obj
        ]);
    });
    const sortingFucntion = (a, b)=>{
        return b[0] - a[0];
    };
    totalsArray.sort(sortingFucntion);
    const finalArray = [];
    totalsArray.forEach((array)=>{
        finalArray.push(array[1]);
    });
    return finalArray;
};


const $e8b4cc21e0ba7dad$export$b8bf835684db10af = ({ navigate: navigate, navBarCollapsed: navBarCollapsed })=>{
    const [outerBoxHeight, setOuterBoxHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(425);
    const [innerBoxHeight, setInnerBoxHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(423);
    const { parentGroupsAlertsData: parentGroupsAlertsData, conversionArray: conversionArray, loadingData: loadingData, alertGraphName: alertGraphName, setDisplayOnLeftBool: setDisplayOnLeftBool, setShowMoreOpen: setShowMoreOpen, setVisibleArray: setVisibleArray, showMoreVisible: showMoreVisible } = (0, $0acc3663e9cf84b8$export$e69ca36e0aa135e7)();
    const optionIds = new Map();
    parentGroupsAlertsData.forEach((object)=>{
        optionIds.set(object.name, object.id);
    });
    const labelNames = [];
    const labelDisplayNames = [];
    const labelsArray = [];
    let labelStringLength = 0;
    parentGroupsAlertsData.forEach((object)=>{
        if (object.label && object.label.display_name) {
            if (!labelDisplayNames.includes(object.label.display_name)) {
                labelDisplayNames.push(object.label.display_name);
                labelStringLength += object.label.display_name.length;
            }
        }
        if (!labelsArray[0]) {
            labelNames.push(object.label.name);
            labelsArray.push({
                label: object.label
            });
        }
        labelsArray.forEach(()=>{
            if (!labelNames.includes(object.label.name)) {
                labelsArray.push({
                    label: object.label
                });
                labelNames.push(object.label.name);
            }
        });
    });
    let bottomLength = 56;
    if (labelStringLength > 47 && labelStringLength < 95) bottomLength = 76;
    if (labelStringLength > 94) bottomLength = 96;
    const fullArray = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>(0, $93fec414155a6ce6$export$5b1fba83bd6768a7)(conversionArray), [
        conversionArray
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setDisplayOnLeftBool(false);
        setShowMoreOpen(false);
        setVisibleArray(fullArray);
        setOuterBoxHeight(425);
        setInnerBoxHeight(423);
    }, [
        fullArray,
        setDisplayOnLeftBool,
        setShowMoreOpen,
        setVisibleArray
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        style: navBarCollapsed ? {
            position: "absolute",
            top: 70,
            left: 690,
            right: 1,
            height: outerBoxHeight,
            width: 656,
            backgroundColor: "#BDBDBD"
        } : {
            position: "absolute",
            top: 70,
            left: 650,
            right: 1,
            height: outerBoxHeight,
            width: 620,
            backgroundColor: "#BDBDBD"
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                style: {
                    position: "absolute",
                    top: 1,
                    left: 1,
                    right: 1,
                    height: innerBoxHeight,
                    background: "white"
                }
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "text-actuate-blue font-mulish text-[22px] font-bold absolute top-[8px] left-[40px]",
                children: `Alerts by ${alertGraphName}`
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "text-actuate-blue font-mulish text-[14px] absolute top-[36px] left-[40px]",
                children: `Total alerts for each ${alertGraphName} during the selected dates`
            }),
            showMoreVisible && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: !navBarCollapsed ? "absolute top-[5px] left-[480px]" : "absolute top-[5px] left-[516px]"
            }),
            !loadingData.parentGroupsData && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "absolute top-[60px] left-[0px] h-[290px] overflow-scroll scrollbar-hide z-10",
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $dc284d0fb10e6f6a$export$94aefc399ef206a9), {
                    layout: "vertical",
                    width: !navBarCollapsed ? 620 : 656,
                    height: fullArray.length > 3 ? Number(fullArray.length) * 66 : 290,
                    data: fullArray,
                    barSize: 50,
                    margin: {
                        top: 5,
                        right: 30,
                        left: 50,
                        bottom: 5
                    },
                    onClick: (event)=>{
                        if (alertGraphName === "Parent Group") (0, $fHwDV.handleLevel1IndexClick)(optionIds.get(event.activePayload[0].payload.name), navigate);
                        if (alertGraphName === "Site") navigate(`/sites/aboutsite/${optionIds.get(event.activePayload[0].payload.name)}`);
                    //  if (alertGraphName === "Camera"){
                    //   getCameraGeneralInfo(optionIds.get(event.activePayload[0].payload.name), navigate)
                    //  }
                    },
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $381060c808bbe825$export$6440e27b9f186856), {
                            strokeDasharray: "3 3"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $e3fbaf009dcc8585$export$ea77231de273b52d), {
                            type: "number",
                            allowDecimals: false
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $c7554316bfb1649b$export$f96c4024c52de8f4), {
                            dataKey: "name",
                            type: "category",
                            hide: true
                        }),
                        fullArray[0] && /*#__PURE__*/ (0, $k4ank.jsx)((0, $45dbb8bb277f9d9d$export$28c660c63b792dea), {}),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $a67bff487a060557$export$ed247974535929c7), {
                            height: bottomLength
                        }),
                        labelsArray.map((object, index)=>{
                            if (index === 0) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $7d5fe63ca2eb078d$export$bbc6c6369b38e3d1), {
                                cursor: "pointer",
                                dataKey: object.label.name,
                                stackId: "a",
                                fill: (0, $b06959827efb70d8$export$5e8707888a87d695)(object.label.name, object.label.color),
                                name: object.label.display_name.charAt(0).toUpperCase() + object.label.display_name.slice(1),
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1778bc5734fdac4c$export$835fcf23ab7bf88), {
                                    dataKey: "abreviated_name",
                                    position: "left",
                                    width: 220
                                })
                            }, object.label.name);
                            else return /*#__PURE__*/ (0, $k4ank.jsx)((0, $7d5fe63ca2eb078d$export$bbc6c6369b38e3d1), {
                                cursor: "pointer",
                                dataKey: object.label.name,
                                stackId: "a",
                                fill: (0, $b06959827efb70d8$export$5e8707888a87d695)(object.label.name, object.label.color),
                                name: object.label.display_name.charAt(0).toUpperCase() + object.label.display_name.slice(1)
                            }, object.label.name);
                        })
                    ]
                })
            }),
            loadingData.parentGroupsData && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "absolute top-[170px] left-[230px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                        size: 25,
                        sx: {
                            position: "relative",
                            left: 40
                        }
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "font-mulish text-actuate-blue test-bold",
                        children: "Fetching Data..."
                    })
                ]
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");


var $60vL1 = parcelRequire("60vL1");

const $776ee0a2dc128c7f$export$6f667df28ae9d10d = ({ navBarCollapsed: navBarCollapsed })=>{
    const { falsePostiveData: falsePostiveData, loadingData: loadingData } = (0, $0acc3663e9cf84b8$export$e69ca36e0aa135e7)();
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: navBarCollapsed ? "absolute top-[515px] left-[20px] right-[1px] h-[370px] w-[652px] bg-[#BDBDBD]" : "absolute top-[515px] left-[20px] right-[1px] h-[370px] w-[610px] bg-[#BDBDBD]",
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: navBarCollapsed ? "absolute top-[1px] left-[1px] right-[1px] h-[368px] w-[650px] bg-white" : "absolute top-[1px] left-[1px] right-[1px] h-[368px] w-[608px] bg-white",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "text-actuate-blue font-mulish text-[22px] font-bold absolute top-[7px] left-[40px]",
                    children: "False Positive Reduction"
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "text-actuate-blue font-mulish text-[14px] absolute top-[36px] left-[40px]",
                    children: "Compare alerts you received against motion counts during the selected dates"
                }),
                loadingData.falsePositiveData && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "absolute top-[170px] left-[230px]",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                            size: 25,
                            sx: {
                                position: "relative",
                                left: 40
                            }
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "font-mulish text-actuate-blue test-bold",
                            children: "Fetching Data..."
                        })
                    ]
                }),
                !loadingData.falsePositiveData && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "absolute top-[60px] left-[0px]",
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $dc284d0fb10e6f6a$export$94aefc399ef206a9), {
                        width: !navBarCollapsed ? 580 : 622,
                        height: 310,
                        ...falsePostiveData.length < 5 && {
                            barSize: 120
                        },
                        data: falsePostiveData,
                        margin: {
                            top: 5,
                            right: 0,
                            left: 40,
                            bottom: 5
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $381060c808bbe825$export$6440e27b9f186856), {
                                strokeDasharray: "3 3"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $e3fbaf009dcc8585$export$ea77231de273b52d), {
                                dataKey: "date"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $c7554316bfb1649b$export$f96c4024c52de8f4), {
                                allowDecimals: false
                            }),
                            falsePostiveData[0] && /*#__PURE__*/ (0, $k4ank.jsx)((0, $45dbb8bb277f9d9d$export$28c660c63b792dea), {}),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $a67bff487a060557$export$ed247974535929c7), {
                                verticalAlign: "top",
                                height: 36
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $7d5fe63ca2eb078d$export$bbc6c6369b38e3d1), {
                                dataKey: "detections",
                                stackId: "a",
                                fill: "#283E6D",
                                name: "Detections"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $7d5fe63ca2eb078d$export$bbc6c6369b38e3d1), {
                                dataKey: "motion_counts",
                                stackId: "b",
                                fill: "#FF8400",
                                name: "Motion Counts"
                            })
                        ]
                    })
                })
            ]
        })
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");


var $60vL1 = parcelRequire("60vL1");

const $093133c64af7c8c6$var$CustomizedLabel = (props)=>{
    const { x: x, y: y, stroke: stroke, value: value } = props;
    return /*#__PURE__*/ (0, $k4ank.jsx)("text", {
        x: x + 40,
        y: y - 5,
        fill: stroke,
        fontSize: 13,
        textAnchor: "middle",
        children: `${value}%`
    });
};
const $093133c64af7c8c6$export$f1742e4455314889 = ({ navBarCollapsed: navBarCollapsed })=>{
    const { percetageOfMotionData: percetageOfMotionData, loadingData: loadingData, displayOnLeftBool: displayOnLeftBool } = (0, $0acc3663e9cf84b8$export$e69ca36e0aa135e7)();
    const toPercent = (decimal)=>`${decimal}%`;
    const displayOnLeft = /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: navBarCollapsed ? "absolute top-[515px] left-[20px] right-[1px] h-[370px] w-[652px] bg-[#BDBDBD]" : "absolute top-[515px] left-[20px] right-[1px] h-[370px] w-[610px] bg-[#BDBDBD]",
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: navBarCollapsed ? "absolute top-[1px] left-[1px] right-[1px] h-[368px] w-[650px] bg-white" : "absolute top-[1px] left-[1px] right-[1px] h-[368px] w-[608px] bg-white",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "text-actuate-blue font-mulish text-[22px] font-bold absolute top-[7px] left-[40px]",
                    children: "Percentage of Motion Counts Filtered"
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "text-actuate-blue font-mulish text-[14px] absolute top-[36px] left-[40px]",
                    children: "Motion counts the system filtered during the selected dates"
                }),
                loadingData.percetageOfMotionData && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "absolute top-[170px] left-[230px]",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                            size: 25,
                            sx: {
                                position: "relative",
                                left: 40
                            }
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "font-mulish text-actuate-blue test-bold",
                            children: "Fetching Data..."
                        })
                    ]
                }),
                !loadingData.percetageOfMotionData && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "absolute top-[60px] left-[0px]",
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $dc284d0fb10e6f6a$export$94aefc399ef206a9), {
                        width: !navBarCollapsed ? 590 : 630,
                        ...percetageOfMotionData.length < 4 && {
                            barSize: 120
                        },
                        height: 310,
                        data: percetageOfMotionData,
                        margin: {
                            top: 5,
                            right: 0,
                            left: 5,
                            bottom: 5
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $381060c808bbe825$export$6440e27b9f186856), {
                                strokeDasharray: "3 3"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $e3fbaf009dcc8585$export$ea77231de273b52d), {
                                dataKey: "date"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $c7554316bfb1649b$export$f96c4024c52de8f4), {
                                tickFormatter: toPercent,
                                allowDecimals: false
                            }),
                            percetageOfMotionData[0] && /*#__PURE__*/ (0, $k4ank.jsx)((0, $45dbb8bb277f9d9d$export$28c660c63b792dea), {}),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $a67bff487a060557$export$ed247974535929c7), {
                                verticalAlign: "top",
                                height: 36
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $7d5fe63ca2eb078d$export$bbc6c6369b38e3d1), {
                                dataKey: "percentage_filtered",
                                fill: "#283E6D",
                                name: "Motion Counts % Filtered"
                            })
                        ]
                    })
                })
            ]
        })
    });
    const displayOnRight = /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: navBarCollapsed ? "absolute top-[515px] left-[690px] right-[1px] h-[370px] w-[656px] bg-[#BDBDBD]" : "absolute top-[515px] left-[650px] right-[1px] h-[370px] w-[620px] bg-[#BDBDBD]",
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: "absolute top-[1px] left-[1px] right-[1px] h-[368px] w-[619x] bg-white",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "text-actuate-blue font-mulish text-[22px] font-bold absolute top-[7px] left-[40px]",
                    children: "Percentage of Motion Counts Filtered"
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "text-actuate-blue font-mulish text-[14px] absolute top-[36px] left-[40px]",
                    children: "Motion counts the system filtered during the selected dates"
                }),
                loadingData.percetageOfMotionData && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "absolute top-[170px] left-[230px]",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                            size: 25,
                            sx: {
                                position: "relative",
                                left: 40
                            }
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "font-mulish text-actuate-blue test-bold",
                            children: "Fetching Data..."
                        })
                    ]
                }),
                !loadingData.percetageOfMotionData && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "absolute top-[60px] left-[0px]",
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $dc284d0fb10e6f6a$export$94aefc399ef206a9), {
                        width: !navBarCollapsed ? 590 : 630,
                        ...percetageOfMotionData.length < 4 && {
                            barSize: 120
                        },
                        height: 310,
                        data: percetageOfMotionData,
                        margin: {
                            top: 5,
                            right: 0,
                            left: 5,
                            bottom: 5
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $381060c808bbe825$export$6440e27b9f186856), {
                                strokeDasharray: "3 3"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $e3fbaf009dcc8585$export$ea77231de273b52d), {
                                dataKey: "date"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $c7554316bfb1649b$export$f96c4024c52de8f4), {
                                tickFormatter: toPercent,
                                allowDecimals: false
                            }),
                            percetageOfMotionData[0] && /*#__PURE__*/ (0, $k4ank.jsx)((0, $45dbb8bb277f9d9d$export$28c660c63b792dea), {}),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $a67bff487a060557$export$ed247974535929c7), {
                                verticalAlign: "top",
                                height: 36
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $7d5fe63ca2eb078d$export$bbc6c6369b38e3d1), {
                                dataKey: "percentage_filtered",
                                fill: "#283E6D",
                                name: "Motion Counts % Filtered"
                            })
                        ]
                    })
                })
            ]
        })
    });
    return displayOnLeftBool ? displayOnLeft : displayOnRight;
};



var $k4ank = parcelRequire("k4ank");

var $3QMQN = parcelRequire("3QMQN");
parcelRequire("8T3gX");

const $985e10783001a4df$export$7c21b9c924144935 = ()=>{
    const { alertState: alertState, setAlertState: setAlertState } = (0, $0acc3663e9cf84b8$export$e69ca36e0aa135e7)();
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            alertState.dateTooFar && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                severity: "warning",
                onClose: ()=>{
                    setAlertState({
                        ...alertState,
                        dateTooFar: false
                    });
                },
                children: "Only data from 2 months or less can be filtered. Please choose a date within the past 2 months."
            }),
            alertState.startAfterEnd && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                severity: "warning",
                onClose: ()=>{
                    setAlertState({
                        ...alertState,
                        startAfterEnd: false
                    });
                },
                children: "Please choose a start date that is before your selected end date."
            }),
            alertState.endBeforeStart && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                severity: "warning",
                onClose: ()=>{
                    setAlertState({
                        ...alertState,
                        endBeforeStart: false
                    });
                },
                children: "Please choose an end date that is after, or the same as, your selected start date."
            })
        ]
    });
};



var $a65wX = parcelRequire("a65wX");
var $5GP2e = parcelRequire("5GP2e");
var $cVCJe = parcelRequire("cVCJe");

var $gouAT = parcelRequire("gouAT");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
var $fIsAN = parcelRequire("fIsAN");


var $aYdit = parcelRequire("aYdit");
const $6cbd5436fba8f051$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $6cbd5436fba8f051$export$2b3af6baec22bd98 = ({ navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed })=>{
    const navigate = (0, $3T949.useNavigate)();
    const parseNumberList = (str)=>{
        if (!str) return [];
        // Decode URL encoding and split by comma
        const decoded = decodeURIComponent(str);
        return decoded.split(",").map(Number);
    };
    const { loadingData: loadingData, userFilters: userFilters, filtersSavedClicked: filtersSavedClicked, alertURL: alertURL, setDownloadURL: setDownloadURL, setDateGraphName: setDateGraphName, setAlertsGraphName: setAlertsGraphName, setDateChangesMade: setDateChangesMade, fetchAllGraphsData: fetchAllGraphsData, resetState: resetState, setAlertURL: setAlertURL, totalAlerts: totalAlerts, setUserFilters: setUserFilters, setFiltersApplied: setFiltersApplied, filtersApplied: filtersApplied } = (0, $0acc3663e9cf84b8$export$e69ca36e0aa135e7)();
    const [searchParams, setSearchParams] = (0, $fIsAN.useSearchParams)();
    const group = searchParams.get("group");
    const site = searchParams.get("site");
    const camera = searchParams.get("camera");
    const start_date = searchParams.get("start_date");
    const end_date = searchParams.get("end_date");
    const { setNavigatedToAlertsFromAnalytics: setNavigatedToAlertsFromAnalytics } = (0, $aYdit.useAppStore)();
    $8T3gX.useEffect(()=>{
        if (!group && !site && !camera && !start_date && !end_date) setFiltersApplied(false);
        else setFiltersApplied(true);
    }, []);
    $8T3gX.useEffect(()=>{
        setUserFilters({
            parent_group: group || "",
            site: site ? parseNumberList(site).map(String) : [],
            camera: camera ? parseNumberList(camera).map(String) : [],
            start_date: start_date ? new Date(start_date) : new Date(),
            end_date: end_date ? new Date(end_date) : new Date()
        });
        if (group) {
            if (site) {
                // If we have both group and site, use the function that sets dropdown values
                const siteIds = parseNumberList(site);
                (0, $0acc3663e9cf84b8$export$c96eb7d11a0b2c94)(group, siteIds, navigate);
            } else // If we only have group, use the regular function
            (0, $0acc3663e9cf84b8$export$664d1b7592a4aa30)(group, navigate);
        }
        if (site) {
            if (camera) {
                // If we have both site and camera, use the function that sets dropdown values
                const siteIds = parseNumberList(site).map(String);
                const cameraIds = parseNumberList(camera);
                (0, $0acc3663e9cf84b8$export$6a85d43941d325e8)(siteIds, cameraIds, navigate);
            } else // If we only have site, use the regular function
            (0, $0acc3663e9cf84b8$export$a14df7b657d0c56a)([
                site
            ], navigate);
        }
    }, []);
    const seeAlertText = /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gouAT))), {
                fontSize: "small"
            }),
            "\xa0See Alerts"
        ]
    });
    $8T3gX.useEffect(()=>{
        // Remove the initial resetState call since we only want it on unmount
        if (localStorage.navigatedToAnalyticsFromSitesPage === "false" && localStorage.filtersSavedClicked === "false") (0, $0acc3663e9cf84b8$export$3d053cc9d93dcd6c)(navigate);
        if (localStorage.filtersSavedClicked === "true" && localStorage.navigatedToAnalyticsFromSitesPage === "false") {
            (0, $0acc3663e9cf84b8$export$3d053cc9d93dcd6c)(navigate);
            const savedAnalyticsFilters = JSON.parse(localStorage.savedAnalyticsFilters);
            if (savedAnalyticsFilters?.parent_group) (0, $0acc3663e9cf84b8$export$664d1b7592a4aa30)(savedAnalyticsFilters.parent_group, navigate);
            if (savedAnalyticsFilters?.site) (0, $0acc3663e9cf84b8$export$a14df7b657d0c56a)(savedAnalyticsFilters.site, navigate);
        }
        if (localStorage.navigatedToAnalyticsFromSitesPage === "true") (0, $0acc3663e9cf84b8$export$2b01a829fc5d8171)(navigate);
        // Only run resetState when component unmounts
        return ()=>{
            resetState();
        };
    }, []);
    $8T3gX.useEffect(()=>{
        let newAlertURL = `/alerts?group=${userFilters.parent_group}`;
        if (userFilters.site.length === 1) newAlertURL += `&site=${userFilters.site[0]}`;
        if (userFilters.camera.length === 1) newAlertURL += `&camera=${userFilters.camera[0]}`;
        newAlertURL += `&start_date=${(0, $361dd3e7be612e92$export$75935ad7f1142eef)(userFilters.start_date)}&end_date=${(0, $361dd3e7be612e92$export$75935ad7f1142eef)(userFilters.end_date)}`;
        setAlertURL(newAlertURL);
    }, [
        userFilters
    ]);
    const handleApplyFilters = ()=>{
        setFiltersApplied(true);
        setDownloadURL("");
        (0, $0acc3663e9cf84b8$export$f6aa9e254c3ecd77)(navigate);
        // updateSearchParamValues(userFilters, searchParams, setSearchParams, "");
        // Update graph names based on filters
        if (!userFilters.parent_group) {
            setAlertsGraphName("Parent Group");
            setDateGraphName("");
        } else if (userFilters.parent_group && userFilters.site.length === 0) {
            setAlertsGraphName("Site");
            setDateGraphName("Parent Group");
        } else if (userFilters.site[0] && userFilters.camera.length === 0) {
            setAlertsGraphName("Camera");
            setDateGraphName("Site");
        }
        if (userFilters.camera[0]) {
            setAlertsGraphName("Camera");
            setDateGraphName("Camera");
        }
        // Fetch all data
        fetchAllGraphsData(navigate);
        setDateChangesMade(false);
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $985e10783001a4df$export$7c21b9c924144935), {}),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "bg-actuate-grey absolute w-full h-full overflow-scroll",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: !navBarCollapsed ? "absolute left-[150px] right-[1px] h-full bg-white overflow-scroll" : "absolute left-[75px] right-[1px] h-full bg-white overflow-scroll",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "font-mulish absolute left-[20px] top-[20px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a023b6d1002cc6b4$export$7d23aa6b071246c1), {
                                    navigate: navigate,
                                    navBarCollapsed: navBarCollapsed,
                                    searchParams: searchParams,
                                    setSearchParams: setSearchParams
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: !navBarCollapsed ? "font-mulish relative left-[233px] top-[20px] max-w-[800px] max-h-full" : "font-mulish relative left-[308px] top-[20px] max-w-[800px] max-h-full",
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "relative top-0 left-0 w-[580px] columns-2",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3584f976f7216e17$export$1842888d8c53627), {
                                                navigate: navigate,
                                                searchParams: searchParams,
                                                setSearchParams: setSearchParams
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f90c597dd583ee7e$export$25c9aaa7160564ac), {
                                                searchParams: searchParams,
                                                setSearchParams: setSearchParams
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: !navBarCollapsed ? "font-mulish absolute left-[830px] top-[20px]" : "font-mulish absolute left-[905px] top-[20px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $135b860d1b01af2e$export$e6a9e9489cd100d0), {
                                    searchParams: searchParams,
                                    setSearchParams: setSearchParams
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: !navBarCollapsed ? "font-mulish absolute left-[990px] top-[20px]" : "font-mulish absolute left-[1065px] top-[20px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ef51eb25f198b378$export$b6561c99a15830c3), {
                                    searchParams: searchParams,
                                    setSearchParams: setSearchParams
                                })
                            }),
                            userFilters.start_date && userFilters.end_date ? /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: !navBarCollapsed ? "absolute top-[25px] left-[1150px]" : "absolute top-[25px] left-[1225px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                    className: loadingData.allAlertsData || loadingData.falsePositiveData || loadingData.parentGroupsData || loadingData.percetageOfMotionData ? "shadow-button bg-actuate-grey border-2	border-actuate-grey rounded font-mulish text-white text-base p-1.5 w-[120px]" : "shadow-button bg-actuate-orange border-2	border-actuate-orange rounded font-mulish text-white text-base p-1.5 w-[120px] hover:bg-[#E67300]",
                                    onClick: handleApplyFilters,
                                    disabled: loadingData.allAlertsData || loadingData.falsePositiveData || loadingData.parentGroupsData || loadingData.percetageOfMotionData,
                                    children: loadingData.allAlertsData || loadingData.falsePositiveData || loadingData.parentGroupsData || loadingData.percetageOfMotionData ? `Loading...` : ` Apply Filters`
                                })
                            }) : /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: !navBarCollapsed ? "absolute top-[25px] left-[1150px]" : "absolute top-[25px] left-[1225px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                    title: "Start and End Dates required",
                                    placement: "bottom",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                            className: "shadow-button bg-[#A9A9A9] rounded font-mulish text-white text-base p-1.5",
                                            disabled: true,
                                            children: "Apply Filters"
                                        })
                                    })
                                })
                            }),
                            filtersApplied ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                children: [
                                    userFilters.parent_group && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: !navBarCollapsed ? "font-mulish absolute left-[980px] top-[95px]" : "font-mulish absolute left-[1055px] top-[95px]",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                                            theme: $6cbd5436fba8f051$var$theme,
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                                type: "button",
                                                color: "primary",
                                                onClick: ()=>navigate(alertURL),
                                                className: "hover:bg-[#E67300]",
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                                                    href: alertURL,
                                                    onClick: (e)=>{
                                                        setNavigatedToAlertsFromAnalytics(true);
                                                        e.preventDefault();
                                                        navigate(alertURL);
                                                    },
                                                    sx: {
                                                        textDecoration: "none",
                                                        color: "inherit",
                                                        cursor: "pointer",
                                                        height: "100%"
                                                    },
                                                    children: seeAlertText
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: !navBarCollapsed ? "font-mulish absolute left-[1140px] top-[95px]" : "font-mulish absolute left-[1215px] top-[95px]",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $5c9eb981c615598b$export$fc9722a813484b48), {})
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "font-mulish relative left-[20px] top-[25px] w-[500px]",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                checked: filtersSavedClicked,
                                                onChange: (event, result)=>{
                                                    (0, $0acc3663e9cf84b8$export$3fa0309c53a1947e)(result);
                                                }
                                            }),
                                            "\xa0 Set these filters as default configuration."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $e463268c7e8e327a$export$ed9212dd4ba77236), {
                                                navBarCollapsed: navBarCollapsed
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $6f68f8ae1baffd60$export$7aaf3a0014fad3dd), {
                                                navBarCollapsed: navBarCollapsed
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "font-mulish absolute top-[40px] left-[20px] font-bold",
                                                children: `Total Alerts for selected dates: ${totalAlerts}`
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $e8b4cc21e0ba7dad$export$b8bf835684db10af), {
                                                navigate: navigate,
                                                navBarCollapsed: navBarCollapsed
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $776ee0a2dc128c7f$export$6f667df28ae9d10d), {
                                                navBarCollapsed: navBarCollapsed
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $093133c64af7c8c6$export$f1742e4455314889), {
                                                navBarCollapsed: navBarCollapsed
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "relative top-[200px] left-[500px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "font-mulish text-[22px]",
                                    children: "Please Apply Filters to view data."
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "justify-start",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jVN1H.NavBar), {
                            navBarCollapsed: navBarCollapsed,
                            setNavBarCollapsed: setNavBarCollapsed,
                            props: {}
                        })
                    })
                ]
            })
        ]
    });
};


/* eslint-disable no-console */ 
var $k4ank = parcelRequire("k4ank");

var $7pFvC = parcelRequire("7pFvC");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $2LUuS = parcelRequire("2LUuS");

var $8T3gX = parcelRequire("8T3gX");


var $8T3gX = parcelRequire("8T3gX");

function $4eab44aa9f09823d$export$23b68da80b41ce8c() {
    return typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';
}


function $06b75fd778f185ee$export$2e2bcd8739ae039(dependencies) {
    var cookies = (0, $8T3gX.useContext)((0, $2df597f88289f000$export$2e2bcd8739ae039));
    if (!cookies) throw new Error('Missing <CookiesProvider>');
    var initialCookies = cookies.getAll();
    var _a = (0, $8T3gX.useState)(initialCookies), allCookies = _a[0], setCookies = _a[1];
    var previousCookiesRef = (0, $8T3gX.useRef)(allCookies);
    if ((0, $4eab44aa9f09823d$export$23b68da80b41ce8c)()) (0, $8T3gX.useLayoutEffect)(function() {
        function onChange() {
            var newCookies = cookies.getAll();
            if ($06b75fd778f185ee$var$shouldUpdate(dependencies || null, newCookies, previousCookiesRef.current)) setCookies(newCookies);
            previousCookiesRef.current = newCookies;
        }
        cookies.addChangeListener(onChange);
        return function() {
            cookies.removeChangeListener(onChange);
        };
    }, [
        cookies
    ]);
    var setCookie = (0, $8T3gX.useMemo)(function() {
        return cookies.set.bind(cookies);
    }, [
        cookies
    ]);
    var removeCookie = (0, $8T3gX.useMemo)(function() {
        return cookies.remove.bind(cookies);
    }, [
        cookies
    ]);
    return [
        allCookies,
        setCookie,
        removeCookie
    ];
}
function $06b75fd778f185ee$var$shouldUpdate(dependencies, newCookies, oldCookies) {
    if (!dependencies) return true;
    for(var _i = 0, dependencies_1 = dependencies; _i < dependencies_1.length; _i++){
        var dependency = dependencies_1[_i];
        if (newCookies[dependency] !== oldCookies[dependency]) return true;
    }
    return false;
}



var $195EM = parcelRequire("195EM");

var $815yO = parcelRequire("815yO");
/* eslint-disable no-console */ 
var $ebTQj = parcelRequire("ebTQj");
const $67ad16c9b937b803$export$a3d03eb12bd6264 = ()=>{
    try {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        // Check if localStorage is available
        if (typeof window !== "undefined" && window.localStorage) localStorage.setItem("userTimezone", timezone);
        else (0, $ebTQj.logger).warn("localStorage is not available.");
    } catch (error) {
        (0, $ebTQj.logger).error("Error retrieving or saving timezone:", error);
    }
};



var $aYdit = parcelRequire("aYdit");

var $2uwzz = parcelRequire("2uwzz");

var $ebTQj = parcelRequire("ebTQj");
parcelRequire("8T3gX");

var $hAnMZ = parcelRequire("hAnMZ");

var $ebTQj = parcelRequire("ebTQj");
const $1f018041dfd027b5$export$725a563b452f57c6 = (id)=>{
    const AxiosUI = (0, $hAnMZ.createMonitoringAPICall)(``);
    AxiosUI.get(`group/${id}`).then((response)=>{
        localStorage.setItem("refresh_interval", JSON.stringify(response.data.refresh_interval_seconds * 1000));
        return response.data.refresh_interval_seconds * 1000;
    }, (reason)=>{
        (0, $ebTQj.logger).log("error reason:", reason);
        localStorage.setItem("refresh_interval", "1000");
        return 1000;
    });
};



var $4G44R = parcelRequire("4G44R");
const $d8fc994dc8794292$var$apiResources = [
    [
        `user/info/`,
        "userInfo"
    ],
    [
        `timezone/`,
        "timeZoneArray"
    ],
    [
        `option/product/`,
        "products"
    ],
    [
        `integration_type/onboarding/`,
        "integrationTypes"
    ],
    [
        `integration_type/`,
        "integrationTypesNonOnboarding"
    ],
    [
        `group/?page_size=2027`,
        "groupArray"
    ],
    [
        `schedule_location/`,
        "locations"
    ],
    [
        `group/?page_size=10000`,
        "parentGroups"
    ],
    // [`analytics/data_usage/?date_range=last_24_hours`, "top5DataUsage"],
    [
        `analytics/date_range_choices/`,
        "rangeChoices"
    ],
    [
        `group/?parent_account=true&page_size=10000`,
        "parentAccounts"
    ],
    [
        `customer/default_alarm_option/`,
        "alarmOptions"
    ],
    [
        `immix_credential/?user_type=ailink`,
        "aiLinkUsers"
    ],
    [
        `immix_credential/?user_type=sentinel`,
        "sentinelUsers"
    ],
    [
        `product_requirements`,
        "productRequirements"
    ],
    [
        `option/?parent__value=camera_view`,
        "cameraViewOptions"
    ],
    [
        `webhook/event_types/`,
        "webHookEventTypeOptions"
    ],
    [
        `calendar/`,
        "calendarsData"
    ],
    [
        `storage/user/`,
        "userStorage"
    ],
    [
        `group/tree/?group_type=patrol`,
        "groupTreesPatrolOnly"
    ]
];
async function $d8fc994dc8794292$var$getResource(resource, setPermissions, setUserPermissions) {
    const AxiosUI = (0, $195EM.createApi)(``);
    localStorage.setItem("navBarCollapsed", "true");
    localStorage.setItem("siteSchedule", "false");
    localStorage.setItem("selectedProducts", "false");
    localStorage.setItem("siteInfo", "false");
    localStorage.setItem("ignoreZones", "false");
    localStorage.setItem("cameraNumber", "1");
    localStorage.setItem("currentCamera", "");
    localStorage.setItem("preview_url", "false");
    localStorage.setItem("clickedFromSiteAboutPage", "false");
    localStorage.setItem("siteDeletedAlert", "false");
    (0, $815yO.useSyncStore).getState().clearAllUnsynced();
    localStorage.setItem("sitesTablePage", "0");
    localStorage.setItem("sitesRowsPerPage", "10");
    localStorage.setItem("siteGroupListScrollTop", "0");
    localStorage.setItem("level0Click", "true");
    localStorage.setItem("siteAboutScrollTop", "0");
    localStorage.setItem("groupNameChange", "true");
    localStorage.setItem("dashboardTotal", "false");
    localStorage.setItem("falsePostiveData", "false");
    localStorage.setItem("camerasErrorInfo", "false");
    localStorage.setItem("camerasWarningInfo", "false");
    localStorage.setItem("rebootSite", "false");
    localStorage.setItem("immixAlertsSite", "false");
    localStorage.setItem("sentinelAlertsSite", "false");
    localStorage.setItem("sureviewAlertsSite", "false");
    localStorage.setItem("diceAlertsSite", "false");
    localStorage.setItem("SMTPSite", "false");
    localStorage.setItem("noAutoAddCamerasDialogOpen", "false");
    localStorage.setItem("currentSiteBreadcrumbs", JSON.stringify([]));
    localStorage.setItem("top5DataUsage", JSON.stringify([]));
    localStorage.setItem("percetageOfMotionData", JSON.stringify([]));
    localStorage.setItem("navigatedToAnalyticsFromSitesPage", "false");
    localStorage.setItem("filtersSavedClicked", "false");
    localStorage.setItem("groupID", "1");
    localStorage.setItem("refresh_interval", JSON.stringify(30000));
    localStorage.setItem("alertsIconOpen", "");
    localStorage.setItem("patrolsIconOpen", "");
    localStorage.setItem("newCalendarName", "");
    localStorage.setItem("tokenRefreshing", "false");
    (0, $2uwzz.safeSetItem)("alertsAllData", [], {
        maxRetries: 0,
        clearOnQuotaExceeded: false
    });
    (0, $2uwzz.safeSetItem)("alertsErrorsData", [], {
        maxRetries: 0,
        clearOnQuotaExceeded: false
    });
    (0, $2uwzz.safeSetItem)("alertsWarningsData", [], {
        maxRetries: 0,
        clearOnQuotaExceeded: false
    });
    (0, $2uwzz.safeSetItem)("alertsResolvedData", [], {
        maxRetries: 0,
        clearOnQuotaExceeded: false
    });
    (0, $2uwzz.safeSetItem)("alertsPendingData", [], {
        maxRetries: 0,
        clearOnQuotaExceeded: false
    });
    localStorage.setItem("editCamerActiveTab", "one");
    (0, $2uwzz.safeSetItem)("sortedHMAlertsRows", [], {
        maxRetries: 0,
        clearOnQuotaExceeded: false
    });
    localStorage.setItem("healthcheckOnly", "false");
    localStorage.setItem("queryString", JSON.stringify(``));
    localStorage.setItem("moreThan100InvestigationsData", "false");
    localStorage.setItem("last_timestamp", "false");
    localStorage.setItem("showWebHooksOnboardingScreen", JSON.stringify(false));
    localStorage.setItem("last_file_id_sentinal", "");
    localStorage.setItem("last_timestamp_sentinal", "");
    localStorage.setItem("last_file_id_ailink", "");
    localStorage.setItem("last_timestamp_ailink", "");
    localStorage.setItem("armButtonCheckURL", "");
    localStorage.setItem("siteCamerasTablePagePreferences", JSON.stringify({}));
    localStorage.setItem("cameraCheckAlertOpen", "false");
    (0, $2uwzz.safeSetItem)("selectedCHMAlertsArray", [], {
        maxRetries: 0,
        clearOnQuotaExceeded: false
    });
    localStorage.setItem("selectedRowAlerts", "{}");
    localStorage.setItem("selectedGroupOrSiteId", "0");
    (0, $2uwzz.safeSetItem)("selectedItemSiteGroupList", {}, {
        maxRetries: 0,
        clearOnQuotaExceeded: false
    });
    (0, $2uwzz.safeSetItem)("backupHealthCheckMetricsData", {}, {
        maxRetries: 0,
        clearOnQuotaExceeded: false
    });
    localStorage.setItem("schedulesIndex", "0");
    (0, $2uwzz.safeSetItem)("backUpFlexSchedule", [], {
        maxRetries: 0,
        clearOnQuotaExceeded: false
    });
    localStorage.setItem("flexSchedulingChanged", "false");
    localStorage.setItem("selectedImmixAlertId", "");
    localStorage.setItem("getIndividualGroupId", "");
    localStorage.setItem("searchCameraInputValue", "");
    localStorage.setItem("healthMonitoringOnly", "false");
    localStorage.setItem("alertsFailRetryCount", "0");
    // safeSetItem("parentAccounts", [], {
    //   maxRetries: 0,
    //   clearOnQuotaExceeded: false,
    // });
    (0, $2uwzz.safeSetItem)("addCameraInfo", {}, {
        maxRetries: 0,
        clearOnQuotaExceeded: false
    });
    localStorage.setItem("visibleSchedules", JSON.stringify({
        one: true,
        two: false,
        three: false
    }));
    localStorage.setItem("clickedSchedulesTab", "one");
    localStorage.setItem("flexSchedulesOn", "false");
    localStorage.setItem("immixAlertPostObject", JSON.stringify({
        id: -1,
        immix_server: "",
        immix_port: ""
    }));
    localStorage.setItem("sentinelAlertPostObject", JSON.stringify({
        sentinel_server: "",
        sentinel_site_id: "",
        sentinel_device_address: "",
        draw_ignore_zones: false
    }));
    localStorage.setItem("patriotAlertPostObject", JSON.stringify({
        patriot_server: "",
        patriot_client_no: "",
        patriot_username: "",
        patriot_password: "",
        patriot_zone_number: "",
        patriot_type_number: "",
        patriot_send_video: false,
        draw_ignore_zones: false
    }));
    localStorage.setItem("storedSelectedIndex", JSON.stringify({
        level1: "",
        level2: "",
        level3: "",
        level4: "",
        level5: "",
        level6: ""
    }));
    (0, $67ad16c9b937b803$export$a3d03eb12bd6264)();
    const { data: data } = await AxiosUI.get(resource[0]);
    if (resource[1] === "parentAccounts") {
        localStorage.setItem("groupID", data.results[0].id);
        (0, $1f018041dfd027b5$export$725a563b452f57c6)(data.results[0].id);
    }
    if (resource[1] === "userInfo") {
        localStorage.setItem("username", data.username);
        localStorage.setItem("first_name", data.first_name);
        localStorage.setItem("last_name", data.last_name);
        localStorage.setItem("userInfo", JSON.stringify(data));
        const responsePermissions = data.permission;
        if (data.permission.patrol_only) localStorage.setItem("patrolOnly", "true");
        // Create a new permissions object to update both state values
        const newPermissions = {};
        // run a for loop on the responsePermissions and set every key to the value of the key
        for(const key in responsePermissions){
            setPermissions((prev)=>{
                return {
                    ...prev,
                    [key]: responsePermissions[key]
                };
            });
            // Add to the new permissions object
            newPermissions[key] = responsePermissions[key];
        }
        // Update the global permissions state with the complete object
        setUserPermissions(newPermissions);
        localStorage.setItem("userPermissions", JSON.stringify(newPermissions));
    } else if (resource[1] === "timeZoneArray") {
        const tzArray = [];
        data.forEach((item)=>{
            tzArray.push(item.value);
        });
        localStorage.setItem(`${resource[1]}`, JSON.stringify(tzArray));
    } else if (resource[1] === "products" || resource[1] === "integrationTypes" || resource[1] === "integrationTypesNonOnboarding" || resource[1] === "locations" || resource[1] === "rangeChoices" || resource[1] === "alertsByParentGroups" || resource[1] === "alarmOptions" || resource[1] === "aiLinkUsers" || resource[1] === "sentinelUsers" || resource[1] === "productRequirements" || resource[1] === "cameraViewOptions" || resource[1] === "webHookEventTypeOptions" || resource[1] === "calendarsData" || resource[1] === "userStorage") {
        localStorage.setItem(`${resource[1]}`, JSON.stringify(data));
        if (resource[1] === "aiLinkUsers") localStorage.setItem(`aiLinkUserName`, data[0]?.username);
        if (resource[1] === "sentinelUsers") localStorage.setItem(`sentinelUserName`, data[0]?.username);
        if (resource[1] === "userStorage") {
            const setDateMMDDYYYY = (0, $aYdit.useAppStore).getState().setDateMMDDYYYY;
            if (data?.data?.alert_date_format) {
                if (data.data.alert_date_format === "DD/MM/YYYY") setDateMMDDYYYY(false);
                if (data.data.alert_date_format === "MM/DD/YYYY") setDateMMDDYYYY(true);
            } else setDateMMDDYYYY(true);
        }
    } else if (resource[1] === "top5DataUsage") {
        const updatedData = data;
        for(const key in updatedData){
            const updatedKey = updatedData[key];
            updatedKey.abreviated_name = `${updatedKey.display_name.slice(0, 7)}...`;
            if (updatedKey.kbs) {
                const updatedKBS = Math.round(updatedKey.kbs / 10) / 100;
                updatedKey.kbs = updatedKBS;
            }
        }
        (0, $2uwzz.safeSetItem)(`${resource[1]}`, updatedData, {
            maxRetries: 1,
            clearOnQuotaExceeded: true
        });
    } else if (resource[1] === "groupTreesPatrolOnly") (0, $aYdit.useAppStore).getState().setGroupTreesPatrolOnly(data.results);
    else (0, $2uwzz.safeSetItem)(`${resource[1]}`, data.results, {
        maxRetries: 1,
        clearOnQuotaExceeded: true
    });
}
async function $d8fc994dc8794292$var$getGroupTrees() {
    const AxiosUI = (0, $195EM.createApi)(``);
    try {
        const { data: data } = await AxiosUI.get(`group/tree/?group_type=connector&page_size=1000`);
        (0, $aYdit.useAppStore).getState().setGroupTrees(data.results);
        return data.results;
    } catch (error) {
        (0, $ebTQj.logger).error("Error fetching group trees:", error);
        throw error;
    }
}
async function $d8fc994dc8794292$export$5f76b3c51e55718(setPermissions, setUserPermissions, navigate) {
    const apiPromises = $d8fc994dc8794292$var$apiResources.map((resource)=>$d8fc994dc8794292$var$getResource(resource, setPermissions, setUserPermissions));
    const groupTreesPromise = $d8fc994dc8794292$var$getGroupTrees();
    try {
        const results = await Promise.all([
            ...apiPromises,
            groupTreesPromise
        ]);
        const groupTreesData = results[results.length - 1]; // Last result is from groupTreesPromise
        // Fetch Frontel user groups after all resources are loaded (await so showFrontelTab
        // is set before login completes and user can land on Clips with tab=frontel)
        if (navigate) {
            const { getUserGroupsFrontel: getUserGroupsFrontel } = (0, $4G44R.useClipsStore).getState();
            await getUserGroupsFrontel(navigate);
        }
        // Dispatch custom event to notify that user resources have been loaded
        window.dispatchEvent(new CustomEvent("userResourcesLoaded"));
        return groupTreesData;
    } catch (response) {
        if (response.response) {
            if (response.response.data) {
                if (response.response.data.detail === "Pending MFA Setup") localStorage.setItem("getMFA", "true");
            }
        }
        throw response;
    }
}




var $aYdit = parcelRequire("aYdit");

var $ebTQj = parcelRequire("ebTQj");

var $195EM = parcelRequire("195EM");

var $8QmWm = parcelRequire("8QmWm");

var $lcmJi = parcelRequire("lcmJi");

var $4PFLW = parcelRequire("4PFLW");

const $da2c98fc7332ce30$export$78f58e2a70333412 = ({ setPermissions: setPermissions })=>{
    const queryString = window.location.search;
    const code = queryString.slice(6);
    const auth = (0, $a72857d2c4579fd9$export$1d39dc5b47e56ff0)();
    const navigate = (0, $3T949.useNavigate)();
    const { flags: flags } = (0, $4PFLW.useFeatureFlag)();
    const wireguardPageEnabled = Boolean(flags?.showWireguardTunnelsPage);
    const baseURL = (0, $2LUuS.getApiUrl)();
    const [statusMessage, setStatusMessage] = (0, $8T3gX.useState)("Logging in...");
    const [cookies, setCookie] = (0, $06b75fd778f185ee$export$2e2bcd8739ae039)(undefined);
    const { setUserPermissions: setUserPermissions } = (0, $aYdit.useAppStore)();
    const AcuateUI = (0, (/*@__PURE__*/$parcel$interopDefault($7pFvC))).create({
        baseURL: `${baseURL}api/auth/`,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${code}`
        }
    });
    localStorage.setItem("getMFA", "false");
    const getPatrolOnlySites = ()=>{
        const AxiosUI = (0, $195EM.createApi)(``);
        AxiosUI.get(`group/tree/?group_type=patrol`).then((resopnse)=>{
            localStorage.setItem("groupTreesPatrolOnly", JSON.stringify(resopnse.data.results));
        // navigate("/sites");
        }, (error)=>{
            (0, $ebTQj.logger).error("Error fetching patrol only sites:", error);
            localStorage.setItem("groupTreesPatrolOnly", JSON.stringify([]));
        // navigate("/sites");
        });
    };
    // Default landing after login: patrol-only users go to their sites, and a
    // View Only user scoped to specific screens lands on the first one they can
    // see (ENG-1816). Everyone else keeps landing on the dashboard.
    const navigateToLanding = (reason)=>{
        const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
        const landing = (0, $lcmJi.landingRouteFor)(userInfo?.permission, {
            wireguardPageEnabled: wireguardPageEnabled
        }) ?? "/dashboard";
        console.warn(`\u{2705} CALLBACK: Navigating to ${landing} (${reason})`, {
            timestamp: new Date().toISOString()
        });
        navigate(landing);
    };
    const navigateAfter = (0, $8T3gX.useCallback)(async ()=>{
        await (0, $d8fc994dc8794292$export$5f76b3c51e55718)(setPermissions, setUserPermissions, navigate).then(async ()=>{
            // If the user has already navigated away from the callback page (e.g. via
            // URL or nav), do not redirect—leave them on their current page.
            if (!window.location.pathname.includes("callback")) return;
            // handleSetPermissions(navigate, setPermissions, setUserPermissions);
            // getPatrolOnlySites();
            // getNonPatrolSites();
            if (localStorage.getMFA === "true") navigate(`/MFA`);
            else if (localStorage.redirectURL) {
                const redirectUrl = localStorage.redirectURL;
                // Validate the redirect URL for safety and route validity
                const isValidPath = (0, $8QmWm.isValidInternalPath)(redirectUrl);
                const isValidRoute = (0, $8QmWm.isValidAppRoute)(redirectUrl);
                if (isValidPath && isValidRoute) {
                    // Check if the redirect URL contains "login" (should not redirect to login page)
                    if (!redirectUrl.includes("login")) {
                        // Special case: if redirect URL is just "/", use the landing route instead
                        if (redirectUrl === "/") {
                            navigateToLanding("redirectURL was /");
                            localStorage.setItem("getMFA", "false");
                        } else {
                            // Navigate to the validated path
                            navigate(redirectUrl);
                            localStorage.setItem("getMFA", "false");
                        }
                    } else {
                        // If redirect URL contains "login", navigate based on user permissions
                        navigateToLanding("redirectURL pointed at login");
                        localStorage.setItem("getMFA", "false");
                    }
                } else {
                    // Invalid redirect URL, navigate to the landing route
                    (0, $ebTQj.logger).warn(`Invalid redirect URL detected: ${redirectUrl}, redirecting to landing route`);
                    navigateToLanding("invalid redirectURL");
                    localStorage.setItem("getMFA", "false");
                }
                // Clean up the redirect URL
                localStorage.removeItem("redirectURL");
            } else {
                navigateToLanding("no redirectURL");
                localStorage.setItem("getMFA", "false");
            }
        }).catch((err)=>{
            (0, $ebTQj.logger).error("Error loading resources:", err);
            // Only redirect if user is still on the callback page
            if (!window.location.pathname.includes("callback")) return;
            // Check if this is an MFA setup error
            if (localStorage.getItem("getMFA") === "true") {
                navigate("/MFA");
                return;
            }
            // Navigate to dashboard even if resources fail to load
            navigate("/dashboard");
        });
    }, []);
    const getToken = (0, $8T3gX.useCallback)(async ()=>{
        try {
            const response = await AcuateUI.get(`token/${queryString}`);
            // Use centralized auth state management
            const { authStateManager: authStateManager } = await Promise.resolve((parcelRequire("1BWfV")));
            authStateManager.setAuthState(response.data.token, response.data.token_secret);
            auth.login();
            navigateAfter(); // This handles navigation on success
        } catch (error) {
            const axiosError = error;
            (0, $ebTQj.logger).error("Error fetching token:", axiosError);
            // Check if this is an invalid_grant error (authorization code already used)
            const detailMessage = axiosError.response?.data?.detail;
            if (detailMessage && detailMessage.includes("invalid_grant")) {
                (0, $ebTQj.logger).warn("Authorization code already consumed - this is expected if getToken was called twice");
                return; // Don't show error or redirect, just return silently
            }
            setStatusMessage(`Login failed: ${detailMessage || axiosError.message}. Redirecting to login...`);
            setTimeout(()=>{
                navigate("/login?error=failed", {
                    replace: true
                });
            }, 3000);
        }
    }, [
        queryString,
        navigateAfter,
        (0, $1f018041dfd027b5$export$725a563b452f57c6),
        navigate
    ]);
    (0, $8T3gX.useEffect)(()=>{
        // Check if token already exists to prevent duplicate token requests
        const existingToken = cookies.token;
        if (existingToken) {
            (0, $ebTQj.logger).info("Token already exists, skipping getToken call");
            // If token exists, just navigate after without fetching a new token
            navigateAfter();
            return;
        }
        getToken();
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "flex flex-col items-center justify-center align-center h-screen m-auto",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "lds-facebook font-black",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {})
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "mt-4 text-gray-600 text-[20px]",
                children: statusMessage
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $jVN1H = parcelRequire("jVN1H");

var $1o017 = parcelRequire("1o017");
const $b16e9ee470e936e1$export$479dc530b3dbf38d = ({ navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed })=>{
    // State for IgnoreZoneBuilder props
    const [ignorezoneEditorVisible, setIgnorezoneEditorVisible] = (0, $8T3gX.useState)(false);
    const [editsMade, setEditsMade] = (0, $8T3gX.useState)(false);
    const [visibleIgnoreZones, setVisibleIgnoreZones] = (0, $8T3gX.useState)({});
    const [largerMode, setLargerMode] = (0, $8T3gX.useState)(false);
    const [izBuilder, setIZBuilder] = (0, $8T3gX.useState)(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "bg-actuate-grey absolute w-screen h-screen",
                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "absolute top-[0px] left-[150px] right-[1px] h-[19px]]",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "pl-[20px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1o017.default), {
                            shapeColor: "#50FF00",
                            height: 576,
                            width: 720,
                            imageURL: "https://actuate-analytics-ui.s3.amazonaws.com/actuate_nyc_alibi_vigilant/background/ip_camera_02.jpg?AWSAccessKeyId=ASIAVU6HT3QYG7BFI5PM&Signature=sNm7yZfqJiwcdXl6r2RiP%2BvLkJk%3D&x-amz-security-token=IQoJb3JpZ2luX2VjEPj%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCXVzLXdlc3QtMiJIMEYCIQCDAwCoiRYLDq6DwN1%2BHha9a3DMehH5%2BW77tug669gaZgIhAOSNZHjnO3Y2e%2B4NVJkQGzmiommPoZ%2BLWmoy7EqCPo1gKvcDCDEQBRoMMzg4NTc2MzA0MTc2IgxoxKldNoPNgmjpTvQq1AM%2Bs3HjWiJ6o0%2FziSLw%2B7cnik82xUUds21iYOSr7Z8wQGGVZkpfIGx6pM4FdlKOTtmnddT8o0c9liONYoQOdr4PIeVafEdmUCtwa18adMPf%2BIGynD1pEe3DMUla1wFFog1qPRNRfS6MCr%2BNo%2FREDVIvVECR4cJrYAHlGqW7nGjzazuHkaysjQahYcAvfDddqjGlnBVLNv6t%2BpLzSvaSNB9mMi0kZVSz233OKaeyvtywoEM0UEWVTVNZke6eP%2Fy%2Bha2giUTUqcEf1rNjoXcNUqZp%2FOUh1AyNu0CwsrabeJHGPcz5wvA9KBgcLE8sZhsLuWlsk3LAtk7jq2%2FWewSlHv3KDMWJAo95S4tgBUn2LyyltXXynmvn8s2Ew%2BDs5K9YVdQ2lgXhdlpVXoXeL8IdqPS1SD%2B2bRFPs2GoRMtnQvPM6m8B22gMHrLTErKPALGu0FNbxsnoGE3OOdU%2BQyPSJZ3Pif3oOs%2FWmWMAMxoYLQc0BlbISiLxaNZ7Na%2Bj5E3RTk%2FnqwWLqhvgLQNqIMaBKdapxGthpfGR6tXNCNv7BcE%2BRyh2OPx%2FjrwF%2F2aPYm%2FIdW2a2yjbGNzYLy2GpQ6O8N9gUv9aSWwiSSF%2B0ap4nfIJGS5ZiH4w9tWmtwY6pAHY%2FuG1UYuxQFrbpONkvwGlSvQDIIKFsgTA9Jy9CGn92yheoKQj7d72m12puKF0Bqb0vWkfL0xSL3Vo8jdSXJmzKiM2YppPZd4B8hKhEAZnO6yfR2rt%2FnzIiDYyXPQ0h2qqegWYq%2B1SxHmHMkQQFze8xoGrFCVheHk82kJaY07bwe4tUFA9qvgmpDCxIwFhW53Zy8Dg6%2B7SNnEPXMNc5pIeXcq0RA%3D%3D&Expires=1726611391",
                            shapesArray: [],
                            setIgnorezoneEditorVisible: setIgnorezoneEditorVisible,
                            setEditsMade: setEditsMade,
                            visibleIgnoreZones: visibleIgnoreZones,
                            selectedIgnoreZone: "",
                            setVisibleIgnoreZones: setVisibleIgnoreZones,
                            largerMode: largerMode,
                            setLargerMode: setLargerMode,
                            setIZBuilder: setIZBuilder,
                            allIgnoreZonesShown: false,
                            siteSchedules: []
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "justify-start",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jVN1H.NavBar), {
                    navBarCollapsed: navBarCollapsed,
                    setNavBarCollapsed: setNavBarCollapsed,
                    props: {}
                })
            })
        ]
    });
};


/**
 * StreamTest — verifies the live-streaming end-to-end flow over either WHEP
 * (WebRTC, sub-second latency, the live operator default) or LL-HLS (2-3s
 * latency, works behind firewalls that block UDP/8189, and the cost lever
 * for high-fan-out scenarios — see the Live Streaming Architecture page).
 *
 *   1. POST  /monitoring-api/streaming/stream-session/<camera_id>/  (Bearer)
 *      → { whep_url, hls_url, token, session_id, lookback_seconds, ... }
 *      The POST also writes the publish-on-demand lease: the connector only
 *      publishes this camera to MediaMTX while a lease exists.
 *   2a. WHEP: POST <whep_url>?jwt=<token>  with WebRTC SDP offer
 *       → SDP answer; ICE-UDP via NLB :8189; RTP/H.264 flows
 *   2b. HLS:  GET <hls_url>?jwt=<token>  via hls.js (low-latency mode)
 *       → MediaMTX serves the same H.264 stream as cacheable segments.
 *          hls.js keeps a client back-buffer (lookback_seconds from the
 *          session, per-customer entitlement) so you can pause / scrub back.
 *
 * Keepalive: while playing, the session POST is repeated every ~4 min,
 * echoing session_id. One mechanism, three jobs: re-mints the 5-min JWT
 * (long views no longer die at token expiry), renews the 10-min publish
 * lease (the connector keeps publishing while you watch), and ticks the
 * billing record (+4 min per keepalive). For LL-HLS the fresh token is
 * injected per-request via hls.js xhrSetup; WHEP needs no re-auth after ICE.
 *
 * Cold start: a camera nobody is watching isn't publishing. The first Play
 * writes the lease and the connector comes up in ~3-8s, so both players
 * retry through that window ("starting stream…") instead of failing.
 */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $hAnMZ = parcelRequire("hAnMZ");
const $a2933d8f4100309e$var$KEEPALIVE_MS = 240000; // < both the 5-min JWT and 10-min lease
// A hidden tab would otherwise keepalive forever: lease keeps renewing, the
// camera keeps publishing, minutes keep metering — with nobody watching.
// After this long continuously in the background we release the stream.
const $a2933d8f4100309e$var$HIDDEN_AUTO_STOP_MS = 600000;
const $a2933d8f4100309e$var$START_RETRIES = 20; // × 2.5s ≈ 50s: covers a scale-from-zero streaming deployment wake, not just a warm connector cold start
const $a2933d8f4100309e$var$START_RETRY_DELAY_MS = 2500;

const $a2933d8f4100309e$export$161ab3e12c669209 = ()=>{
    const [cameraId, setCameraId] = (0, $8T3gX.useState)("testpattern");
    const [protocol, setProtocol] = (0, $8T3gX.useState)("whep");
    const [logLines, setLogLines] = (0, $8T3gX.useState)([]);
    const [busy, setBusy] = (0, $8T3gX.useState)(false);
    const videoRef = (0, $8T3gX.useRef)(null);
    const pcRef = (0, $8T3gX.useRef)(null);
    // hls.js Hls instance; typed as any so this file doesn't depend on
    // @types/hls.js (the package ships types; we keep this loose to avoid
    // a hard build dep in case the package is added lazily).
    const hlsRef = (0, $8T3gX.useRef)(null);
    // Current JWT + billing session, refreshed by the keepalive. tokenRef is
    // read per-request by hls.js xhrSetup so a re-mint takes effect without
    // reloading the source.
    const tokenRef = (0, $8T3gX.useRef)("");
    const sessionIdRef = (0, $8T3gX.useRef)(null);
    const keepaliveTimerRef = (0, $8T3gX.useRef)(null);
    const retryTimerRef = (0, $8T3gX.useRef)(null);
    // De-dupe noisy non-fatal hls errors (a rough seek can emit a dozen
    // identical fragGap events in one second).
    const lastHlsErrRef = (0, $8T3gX.useRef)({
        key: "",
        t: 0,
        n: 0
    });
    // Periodic readout of the client-side buffer so we can see how much rewind
    // (back-buffer) is available and how far behind the live edge we are.
    const statsTimerRef = (0, $8T3gX.useRef)(null);
    const [bufInfo, setBufInfo] = (0, $8T3gX.useState)("");
    // Background-tab auto-release + session/usage readout.
    const hiddenTimerRef = (0, $8T3gX.useRef)(null);
    const sessionStartRef = (0, $8T3gX.useRef)(0);
    const meterTicksRef = (0, $8T3gX.useRef)(0); // 1 per mint; each tick ≈ 4 metered min
    const [notice, setNotice] = (0, $8T3gX.useState)("");
    const log = (msg)=>{
        const stamp = new Date().toLocaleTimeString();
        setLogLines((prev)=>[
                ...prev,
                `${stamp}  ${msg}`
            ]);
    };
    const stop = ()=>{
        if (pcRef.current) {
            pcRef.current.close();
            pcRef.current = null;
            log("peer connection closed");
        }
        if (hlsRef.current) {
            hlsRef.current.destroy();
            hlsRef.current = null;
            log("hls player destroyed");
        }
        if (keepaliveTimerRef.current) {
            clearInterval(keepaliveTimerRef.current);
            keepaliveTimerRef.current = null;
        }
        if (retryTimerRef.current) {
            clearTimeout(retryTimerRef.current);
            retryTimerRef.current = null;
        }
        if (statsTimerRef.current) {
            clearInterval(statsTimerRef.current);
            statsTimerRef.current = null;
        }
        if (hiddenTimerRef.current) {
            clearTimeout(hiddenTimerRef.current);
            hiddenTimerRef.current = null;
        }
        // New Play = new distinct billing session.
        sessionIdRef.current = null;
        setBufInfo("");
        if (videoRef.current) {
            videoRef.current.srcObject = null;
            videoRef.current.removeAttribute("src");
            videoRef.current.load();
        }
    };
    (0, $8T3gX.useEffect)(()=>stop, []);
    // Auto-release on abandoned background tabs: when the document stays
    // hidden for HIDDEN_AUTO_STOP_MS while a stream is active, stop cleanly —
    // the lease lapses behind us (~11 min) and the camera's publisher shuts
    // off. Returning to the tab and pressing Play resumes in ~1s (the lease
    // is usually still warm). Production viewers should adopt this pattern.
    (0, $8T3gX.useEffect)(()=>{
        const onVisibility = ()=>{
            if (document.hidden) {
                if (keepaliveTimerRef.current && !hiddenTimerRef.current) hiddenTimerRef.current = setTimeout(()=>{
                    hiddenTimerRef.current = null;
                    stop();
                    setNotice("\u23F9 stream released after 10 min in a background tab \u2014 press Play to resume");
                    log("\u23F9 auto-released: tab hidden 10 min (lease lapses; publisher stops)");
                }, $a2933d8f4100309e$var$HIDDEN_AUTO_STOP_MS);
            } else if (hiddenTimerRef.current) {
                clearTimeout(hiddenTimerRef.current);
                hiddenTimerRef.current = null;
            }
        };
        document.addEventListener("visibilitychange", onVisibility);
        return ()=>document.removeEventListener("visibilitychange", onVisibility);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- refs only
    }, []);
    const mintSession = async (camId)=>{
        const api = (0, $hAnMZ.createMonitoringAPICall)("");
        const resp = await api.post(`streaming/stream-session/${camId}/`, {
            session_id: sessionIdRef.current
        });
        tokenRef.current = resp.data.token;
        sessionIdRef.current = resp.data.session_id ?? sessionIdRef.current;
        meterTicksRef.current += 1; // server adds STREAMING_METER_TICK (4 min)/mint
        return resp.data;
    };
    // Re-mint every ~4 min while playing: refreshes the 5-min JWT, renews the
    // 10-min publish lease, and ticks the billing record — one POST, three jobs.
    const startKeepalive = (camId)=>{
        if (keepaliveTimerRef.current) clearInterval(keepaliveTimerRef.current);
        keepaliveTimerRef.current = setInterval(async ()=>{
            try {
                await mintSession(camId);
                log(`\u{27F3} keepalive: token re-minted + lease renewed (session ${sessionIdRef.current ?? "-"})`);
            } catch (e) {
                log(`\u{2717} keepalive failed: ${e?.response?.status ?? e?.message ?? e}`);
            }
        }, $a2933d8f4100309e$var$KEEPALIVE_MS);
    };
    // Surface the client buffer state: how far back you can scrub (rewind
    // available = currentTime − buffered.start) and how far behind live you are.
    const startBufferStats = ()=>{
        if (statsTimerRef.current) clearInterval(statsTimerRef.current);
        statsTimerRef.current = setInterval(()=>{
            const v = videoRef.current;
            if (!v || v.buffered.length === 0) return;
            const start = v.buffered.start(0);
            const end = v.buffered.end(v.buffered.length - 1);
            const rewind = Math.max(0, v.currentTime - start);
            const behindLive = Math.max(0, end - v.currentTime);
            const sessionMin = sessionStartRef.current ? Math.floor((Date.now() - sessionStartRef.current) / 60000) : 0;
            setBufInfo(`${v.paused ? "\u23F8 paused" : "\u25B6 playing"}  \xb7  session: ${sessionMin}m (metered \u{2248}${meterTicksRef.current * 4}min)  \xb7  rewind available: ${rewind.toFixed(0)}s  \xb7  behind live: ${behindLive.toFixed(1)}s  \xb7  buffered window: ${(end - start).toFixed(0)}s`);
        }, 500);
    };
    const sleep = (ms)=>new Promise((resolve)=>{
            retryTimerRef.current = setTimeout(resolve, ms);
        });
    const playWhep = async (whep_url)=>{
        log("\u2461 new RTCPeerConnection()");
        const pc = new RTCPeerConnection();
        pcRef.current = pc;
        pc.addTransceiver("video", {
            direction: "recvonly"
        });
        pc.addTransceiver("audio", {
            direction: "recvonly"
        });
        pc.ontrack = (e)=>{
            log(`   \u{21AA} ontrack: kind=${e.track.kind}`);
            if (videoRef.current && e.streams[0]) videoRef.current.srcObject = e.streams[0];
        };
        pc.onconnectionstatechange = ()=>log(`   \u{21AA} connectionState=${pc.connectionState}`);
        pc.oniceconnectionstatechange = ()=>log(`   \u{21AA} iceConnectionState=${pc.iceConnectionState}`);
        // ③ createOffer + ICE-gathering wait. MediaMTX doesn't support trickle
        //    ICE on WHEP, so the offer must carry all candidates before POST.
        log("\u2462 createOffer + setLocalDescription");
        const offer = await pc.createOffer();
        await pc.setLocalDescription(offer);
        log("   \u21AA waiting for ICE gathering\u2026");
        await new Promise((resolve)=>{
            if (pc.iceGatheringState === "complete") return resolve();
            const onState = ()=>{
                if (pc.iceGatheringState === "complete") {
                    pc.removeEventListener("icegatheringstatechange", onState);
                    resolve();
                }
            };
            pc.addEventListener("icegatheringstatechange", onState);
            setTimeout(resolve, 3000);
        });
        // ④ POST the SDP offer, retrying through the publish-on-demand cold
        //    start (~3-8s for the connector to start publishing a camera nobody
        //    was watching). MediaMTX 404s until the path is ready.
        for(let attempt = 1; attempt <= $a2933d8f4100309e$var$START_RETRIES; attempt++){
            log(attempt === 1 ? "\u2463 POST WHEP offer" : `\u{2463} POST WHEP offer (retry ${attempt}/${$a2933d8f4100309e$var$START_RETRIES})`);
            const whepResp = await fetch(`${whep_url}?jwt=${encodeURIComponent(tokenRef.current)}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/sdp"
                },
                body: pc.localDescription.sdp
            });
            if (whepResp.ok) {
                const answerSdp = await whepResp.text();
                log("\u2464 setRemoteDescription(answer)");
                await pc.setRemoteDescription({
                    type: "answer",
                    sdp: answerSdp
                });
                log("   \u21AA awaiting media\u2026");
                return;
            }
            const body = await whepResp.text();
            if (whepResp.status === 404 && attempt < $a2933d8f4100309e$var$START_RETRIES) {
                log(`   \u{21AA} starting stream\u{2026} (camera not publishing yet, ~${$a2933d8f4100309e$var$START_RETRY_DELAY_MS / 1000}s)`);
                await sleep($a2933d8f4100309e$var$START_RETRY_DELAY_MS);
                continue;
            }
            log(`   \u{2717} ${whepResp.status}: ${body}`);
            return;
        }
    };
    const playHls = async (hls_url, lookbackSeconds)=>{
        if (!videoRef.current) return;
        // Lazy-load hls.js so a missing dep degrades gracefully (Safari native
        // can fall back, but it flakes on MediaMTX's 302 session redirects —
        // see the local comparison sandbox lessons in EDOCS).
        log("\u2461 import hls.js");
        const Hls = (await (parcelRequire("fWdZn"))).default;
        if (!Hls.isSupported()) {
            if (videoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
                // Safari native fallback. Known to flake on MediaMTX 302 session
                // redirects, and it can't pick up re-minted tokens — long views
                // will die at JWT expiry on this path.
                log("\u2462 falling back to Safari native HLS (may flake on 302s)");
                videoRef.current.src = `${hls_url}?jwt=${encodeURIComponent(tokenRef.current)}`;
                videoRef.current.play().catch((e)=>log(`   \u{2717} play(): ${e}`));
                startBufferStats();
            } else log("   \u2717 no HLS support in this browser");
            return;
        }
        const startAttempt = (attempt)=>{
            if (!videoRef.current) return;
            log(attempt === 1 ? "\u2462 attaching hls.js player" : `\u{2462} starting stream\u{2026} (cold start, attempt ${attempt}/${$a2933d8f4100309e$var$START_RETRIES})`);
            const hls = new Hls({
                lowLatencyMode: true,
                // Client back-buffer for pause / scrub-back; depth is the
                // per-customer entitlement from the session response.
                backBufferLength: lookbackSeconds,
                // Birth-of-stream gap tolerance: with publish-on-demand, a cold
                // camera's stream is born when the viewer clicks Play, so rewinding
                // near the oldest buffered point can land on the ragged first
                // segments. Jump holes up to 1s (default 0.1) and keep nudging
                // instead of error-flooding; playback hops the gap and continues.
                maxBufferHole: 1.0,
                nudgeMaxRetry: 10,
                // Inject the CURRENT token on every manifest/segment request — the
                // keepalive re-mints it every ~4 min, so long views survive the
                // 5-min JWT TTL without reloading the source.
                xhrSetup: (xhr, url)=>{
                    try {
                        const u = new URL(url);
                        u.searchParams.set("jwt", tokenRef.current);
                        xhr.open("GET", u.toString(), true);
                    } catch  {
                    // Malformed URL — let hls.js open it unmodified.
                    }
                }
            });
            hlsRef.current = hls;
            hls.on(Hls.Events.ERROR, (_evt, data)=>{
                if (!data.fatal) {
                    // De-dupe: identical non-fatal errors within 5s collapse into one
                    // line with a repeat count.
                    const key = `${data.type}/${data.details}`;
                    const now = Date.now();
                    const last = lastHlsErrRef.current;
                    if (key === last.key && now - last.t < 5000) {
                        last.n += 1;
                        last.t = now;
                        return;
                    }
                    if (last.n > 0) log(`   \u{21AA} (hls ${last.key} repeated \xd7${last.n} more)`);
                    lastHlsErrRef.current = {
                        key: key,
                        t: now,
                        n: 0
                    };
                    log(`   \u{21AA} hls error: ${key}`);
                    return;
                }
                // Fatal during startup is almost always the publish-on-demand cold
                // start (manifest 404 before the connector begins publishing).
                hls.destroy();
                if (hlsRef.current === hls) hlsRef.current = null;
                if (attempt < $a2933d8f4100309e$var$START_RETRIES) retryTimerRef.current = setTimeout(()=>startAttempt(attempt + 1), $a2933d8f4100309e$var$START_RETRY_DELAY_MS);
                else log(`   \u{2717} hls fatal: ${data.type} / ${data.details} (gave up after ${$a2933d8f4100309e$var$START_RETRIES} attempts)`);
            });
            hls.on(Hls.Events.MANIFEST_PARSED, ()=>{
                log("   \u21AA manifest parsed; playing");
                videoRef.current?.play().catch((e)=>log(`   \u{2717} play(): ${e}`));
            });
            hls.loadSource(`${hls_url}?jwt=${encodeURIComponent(tokenRef.current)}`);
            hls.attachMedia(videoRef.current);
            startBufferStats();
        };
        startAttempt(1);
    };
    const play = async ()=>{
        stop();
        setLogLines([]);
        setBusy(true);
        setNotice("");
        sessionStartRef.current = Date.now();
        meterTicksRef.current = 0;
        try {
            log(`\u{2460} POST /monitoring-api/streaming/stream-session/${cameraId}/`);
            const data = await mintSession(cameraId);
            const lookbackSeconds = data.lookback_seconds ?? 120;
            log(`   \u{2192} ${protocol === "whep" ? `whep_url=${data.whep_url}` : `hls_url=${data.hls_url}`}`);
            log(`   \u{2192} token=${data.token.slice(0, 30)}\u{2026}  session=${data.session_id ?? "-"}  lookback=${lookbackSeconds}s  (expires in ${data.expires_at - Math.floor(Date.now() / 1000)}s; keepalive every ${$a2933d8f4100309e$var$KEEPALIVE_MS / 60000}min)`);
            startKeepalive(cameraId);
            if (protocol === "whep") await playWhep(data.whep_url);
            else await playHls(data.hls_url, lookbackSeconds);
        } catch (err) {
            const detail = err?.response?.data ? `${err.response.status}: ${JSON.stringify(err.response.data)}` : err?.message ?? String(err);
            log(`\u{2717} ${detail}`);
        } finally{
            setBusy(false);
        }
    };
    (0, $8T3gX.useEffect)(()=>{
        play();
        return ()=>stop();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once on mount
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        style: {
            padding: 24,
            fontFamily: "system-ui, sans-serif"
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("h2", {
                style: {
                    marginTop: 0
                },
                children: "Stream Smoke Test"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                style: {
                    color: "#555",
                    marginTop: 0
                },
                children: [
                    "Synthetic ",
                    /*#__PURE__*/ (0, $k4ank.jsx)("code", {
                        children: "testpattern"
                    }),
                    " source is open to any logged-in user; real camera_ids resolve to a Camera row and are gated by the operator\u2019s Group access to the camera\u2019s customer. Real cameras publish on demand \u2014 first open takes a few seconds."
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                style: {
                    display: "flex",
                    gap: 12,
                    alignItems: "center",
                    marginBottom: 12,
                    flexWrap: "wrap"
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("label", {
                        children: [
                            "camera_id:\xa0",
                            /*#__PURE__*/ (0, $k4ank.jsx)("input", {
                                value: cameraId,
                                onChange: (e)=>setCameraId(e.target.value),
                                disabled: busy,
                                style: {
                                    padding: 4,
                                    width: 240
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("label", {
                        children: [
                            "protocol:\xa0",
                            /*#__PURE__*/ (0, $k4ank.jsxs)("select", {
                                value: protocol,
                                onChange: (e)=>setProtocol(e.target.value),
                                disabled: busy,
                                style: {
                                    padding: 4
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("option", {
                                        value: "whep",
                                        children: "WHEP (WebRTC, <1s)"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("option", {
                                        value: "hls",
                                        children: "LL-HLS (~2-3s, firewall-friendly)"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                        onClick: play,
                        disabled: busy,
                        children: "Play"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                        onClick: stop,
                        children: "Stop"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("video", {
                ref: videoRef,
                autoPlay: true,
                playsInline: true,
                muted: true,
                controls: true,
                style: {
                    display: "block",
                    width: 720,
                    maxWidth: "100%",
                    background: "#000",
                    marginBottom: 8
                }
            }),
            notice && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                style: {
                    background: "#fff7e0",
                    border: "1px solid #e0c860",
                    padding: "6px 10px",
                    fontSize: 13,
                    marginBottom: 8
                },
                children: notice
            }),
            bufInfo && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                style: {
                    fontFamily: "ui-monospace, monospace",
                    fontSize: 12,
                    color: "#333",
                    marginBottom: 12
                },
                children: bufInfo
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("pre", {
                style: {
                    background: "#f4f4f4",
                    padding: 12,
                    maxHeight: 360,
                    overflow: "auto",
                    fontSize: 12
                },
                children: logLines.join("\n") || "(idle)"
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $7pFvC = parcelRequire("7pFvC");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $2LUuS = parcelRequire("2LUuS");

var $8T3gX = parcelRequire("8T3gX");

// Module-level guard: survives component unmount/remount (e.g. when
// LaunchDarklyProvider swaps its wrapper type and causes the subtree to
// remount). OAuth authorization codes are single-use, so re-posting the same
// code revokes the refresh token issued by the first exchange.
const $c2220021aa7dddac$var$sentCodes = new Set();
const $c2220021aa7dddac$export$1f5fef2a1a84d30b = ()=>{
    const queryString = window.location.search;
    const code = queryString.slice(6);
    const navigate = (0, $3T949.useNavigate)();
    const url = (0, $2LUuS.getApiUrl)();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [cookies, setCookie] = (0, $06b75fd778f185ee$export$2e2bcd8739ae039)(undefined);
    const AcuateUI = (0, (/*@__PURE__*/$parcel$interopDefault($7pFvC))).create({
        baseURL: `${url}api/eagle_eye/`,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${cookies.token}`
        }
    });
    const sendCode = async ()=>{
        await AcuateUI.post(`callback/`, {
            code: code,
            customer_id: localStorage.getItem("siteId")
        }).then((response)=>{
            navigate("/sites/autoaddcamera");
        }).catch((err)=>alert(`${err}`));
    };
    (0, $8T3gX.useEffect)(()=>{
        if (!code || $c2220021aa7dddac$var$sentCodes.has(code)) return;
        $c2220021aa7dddac$var$sentCodes.add(code);
        sendCode();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "flex items-center justify-center align-center h-screen m-auto",
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: "lds-facebook font-black",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {}),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {}),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {})
            ]
        })
    });
};



var $elyck = parcelRequire("elyck");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $jVN1H = parcelRequire("jVN1H");
const $c9d28e6ea372b2fa$export$a65c2c055de52e1d = ({ navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed })=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "bg-actuate-grey absolute w-screen h-screen",
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "relative top-[100px] text-center",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "text-mulish text-actuate-blue text-[80px]",
                            children: "404"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "text-mulish text-actuate-blue text-[30px]",
                            children: "Page not found."
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "justify-start",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jVN1H.NavBar), {
                    navBarCollapsed: navBarCollapsed,
                    setNavBarCollapsed: setNavBarCollapsed,
                    props: {}
                })
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $jVN1H = parcelRequire("jVN1H");
const $357b3d6d3c1d2bdb$var$buildCopy = (resource, id)=>{
    const idSuffix = id ? ` ${id}` : "";
    if (resource === "site") return {
        heading: "Site not found",
        body: `Site${idSuffix} doesn't exist, or you no longer have access to it. It may have been deleted, or moved to another account.`
    };
    if (resource === "camera") return {
        heading: "Camera not found",
        body: `Camera${idSuffix} doesn't exist, or you no longer have access to it. It may have been deleted, or moved to another site.`
    };
    return {
        heading: "Not found",
        body: "The page you're looking for isn't available. It may have been deleted, or you may no longer have access to it."
    };
};
const $357b3d6d3c1d2bdb$export$e0cf1661d881410f = ({ navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed })=>{
    const navigate = (0, $3T949.useNavigate)();
    const location = (0, $3T949.useLocation)();
    const { resource: resource, id: id } = location.state || {};
    const { heading: heading, body: body } = $357b3d6d3c1d2bdb$var$buildCopy(resource, id);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "bg-actuate-grey absolute w-screen h-screen",
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "relative top-[140px] mx-auto max-w-[600px] text-center px-6",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "text-mulish text-actuate-blue text-[80px] leading-none",
                            children: "404"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "text-mulish text-actuate-blue text-[30px] mt-4",
                            children: heading
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "text-mulish text-actuate-blue text-[16px] mt-4",
                            children: body
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                            className: "text-mulish text-white bg-actuate-blue hover:bg-actuate-orange rounded-md mt-8 px-6 py-2 text-[16px]",
                            onClick: ()=>navigate("/sites"),
                            children: "Back to Sites"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "justify-start",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jVN1H.NavBar), {
                    navBarCollapsed: navBarCollapsed,
                    setNavBarCollapsed: setNavBarCollapsed,
                    props: {}
                })
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $jVN1H = parcelRequire("jVN1H");
const $040bff954342b7e4$export$ae1acd55a119cb17 = ({ navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed })=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "bg-actuate-grey absolute w-screen h-screen",
                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "relative top-[100px] text-center",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "text-mulish text-actuate-blue text-[30px]",
                        children: "Your user permissions do not allow access to this page."
                    })
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "justify-start",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jVN1H.NavBar), {
                    navBarCollapsed: navBarCollapsed,
                    setNavBarCollapsed: setNavBarCollapsed,
                    props: {}
                })
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $jVN1H = parcelRequire("jVN1H");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $cVCJe = parcelRequire("cVCJe");

var $ePwXE = parcelRequire("ePwXE");
const $4454260b9c6617a2$var$titlesArray = [
    [
        "Product",
        "product"
    ],
    [
        "Resolution",
        "resolution"
    ],
    [
        "Frame Rate",
        "frame_rate"
    ],
    [
        "Aspect Ratio",
        "aspect_ratio"
    ],
    [
        "Codec",
        "codec"
    ]
];
const $4454260b9c6617a2$var$toolTipText = {
    resolution: `The sharpness/clarity of an image based on the number of image pixels.`,
    frame_rate: `How many frames are contained within a second of video (fps). If the frame rate is too low, we run the risk of missing key frames and key detections.`,
    aspect_ratio: `We run frames through our models at a specific width and height (i.e. aspect ratio).`,
    codec: `Compresses/decompresses large amounts of video data for the sake of creating, playing, and sending media files.`
};
const $4454260b9c6617a2$export$d143e5858993e7d1 = ({ navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed })=>{
    const requirementsData = JSON.parse(localStorage.productRequirements);
    //remove left object, mask, no mask, package, people flow, social distancing from requirementsData
    const filteredRequirementsData = requirementsData.filter((row)=>{
        return ![
            "Left Object",
            "Mask",
            "No Mask",
            "Package",
            "People Flow",
            "Social Distancing"
        ].includes(row.product.name);
    });
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "flex h-screen",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "fixed h-screen",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jVN1H.NavBar), {
                    navBarCollapsed: navBarCollapsed,
                    setNavBarCollapsed: setNavBarCollapsed,
                    props: {}
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: `flex-1 overflow-auto ${navBarCollapsed ? "ml-[75px]" : "ml-[150px]"}`,
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "bg-actuate-grey min-h-screen",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "h-[8px]"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: !navBarCollapsed ? "mr-[1px] bg-white" : "mr-[1px] bg-white",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "font-black font-mulish text-[20px] text-[16px] pb-3 pl-9 pt-3",
                                children: `Product Requirements for Optimal Performance`
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: !navBarCollapsed ? "mt-[8px] mr-[1px] bg-white" : "mt-[8px] mr-[1px] bg-white",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "text-actuate-blue font-mulish text-[16px] p-3",
                                    children: `Our DS team recommends the following camera settings to support "optimal" / desired AI performance. Adhering to these recommendations will decrease your likelihood of errors such as false positives and misses.`
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                    className: "text-actuate-blue font-mulish text-[16px] p-3",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                            className: "font-bold",
                                            children: "Please note: "
                                        }),
                                        " While these settings support desired AI performance, there are factors that may require additional tuning. To learn more about Actuate's features for tuning AI performance, contact",
                                        /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                                            children: [
                                                "\xa0",
                                                /*#__PURE__*/ (0, $k4ank.jsx)("a", {
                                                    className: "text-[#0000EE]",
                                                    href: "mailto:support@actuate.ai",
                                                    children: "support@actuate.ai."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: !navBarCollapsed ? "mt-[8px] mr-[1px] bg-white" : "mt-[8px] mr-[1px] bg-white",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4reBM.default), {
                                sx: {
                                    width: "100%"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                        sx: {
                                            minWidth: 1000,
                                            fontFamily: "Mulish"
                                        },
                                        stickyHeader: true,
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TooltipTableHeadComponent), {
                                                titlesArray: $4454260b9c6617a2$var$titlesArray,
                                                toolTipText: $4454260b9c6617a2$var$toolTipText
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                children: filteredRequirementsData.map((row)=>{
                                                    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                children: row.product.name === "Intruder+" ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                                                    children: [
                                                                        row.product.name,
                                                                        "\xa0",
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                                            title: `Actuate's primary model works in 99.9% of cases, similar to a real human operator. This excellently addresses the use cases of most of our customers. For customers that are interested in going above and beyond the industry standard accuracy, we also offer a bigger deep learning network that has more layers and costs more for us to compute: Intruder+. This bumps that accuracy up to 99.99%, which is worth the cost to some.`,
                                                                            placement: "top",
                                                                            sx: {
                                                                                fontSize: "15px",
                                                                                fontFamily: "mulish"
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                                                                fontSize: "small"
                                                                            })
                                                                        })
                                                                    ]
                                                                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                                                                    children: row.product.name
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                children: `${row.width_optimal} x ${row.height_optimal}`
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                children: `${row.frame_rate_range.slice(0, 3)} fps`
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                children: `${row.aspect_ratio_width}:${row.aspect_ratio_height}`
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                children: row.codec
                                                            })
                                                        ]
                                                    }, row.product.value);
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};


/* eslint-disable react-hooks/exhaustive-deps */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");
var $887xF = parcelRequire("887xF");
var $ce8iU = parcelRequire("ce8iU");
var $eejVe = parcelRequire("eejVe");

var $k1BHZ = parcelRequire("k1BHZ");

var $imWqP = parcelRequire("imWqP");

var $3baw3 = parcelRequire("3baw3");

var $7UDCh = parcelRequire("7UDCh");

var $lk6eW = parcelRequire("lk6eW");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $b279354ed152da48$export$32f02cf57a03b000 = (setQRCode, setPageLoading, navigate)=>{
    const retryFunction = ()=>{
        $b279354ed152da48$export$32f02cf57a03b000(setQRCode, setPageLoading, navigate);
    };
    const AxiosUI = (0, $195EM.createApi)(``);
    AxiosUI.get(`auth/mfa_info/`).then((response)=>{
        setQRCode(response.data.qr_code_url);
        setPageLoading(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setPageLoading(false);
        });
    });
};


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $dHtmK = parcelRequire("dHtmK");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");

var $8QmWm = parcelRequire("8QmWm");
const $d6dca29f904fc905$export$cdb31af798cdc179 = (authenticationData, setPageLoading, navigate)=>{
    const retryFunction = ()=>{
        $d6dca29f904fc905$export$cdb31af798cdc179(authenticationData, setPageLoading, navigate);
    };
    const AxiosUI = (0, $195EM.createApi)(``);
    AxiosUI.post(`auth/mfa_setup/`, authenticationData).then((response)=>{
        // Use safe redirect for logout URL
        (0, $8QmWm.safeRedirect)(response.data.logout_url, [
            "actuateui.net",
            "amazoncognito.com"
        ], "/login");
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Failed to send authentication, please try again");
            setPageLoading(false);
        });
    });
};



var $3EhHS = parcelRequire("3EhHS");
const $0498ae720de2cdde$export$409b3619e7bab7d1 = ()=>{
    const [authenticationMethod, setAuthenticationMethod] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("sms");
    const [authenticationData, setAuthenticationData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        authentication_method: "sms"
    });
    const [maxWidth, setMaxWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("sm");
    const [height, setHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(540);
    const [qRCode, setQRCode] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const navigate = (0, $3T949.useNavigate)();
    const [pageLoading, setPageLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    // ENG-2302: the SMS code goes to this number, so it must be valid E.164.
    const [phoneInput, setPhoneInput] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const phoneResult = phoneInput.trim() ? (0, $3EhHS.normalizePhone)(phoneInput) : null;
    const phoneInvalid = authenticationMethod === "sms" && phoneResult !== null && !phoneResult.ok;
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        (0, $b279354ed152da48$export$32f02cf57a03b000)(setQRCode, setPageLoading, navigate);
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                openState: pageLoading
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "bg-actuate-grey absolute w-screen h-screen",
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                    open: true,
                    fullWidth: true,
                    maxWidth: maxWidth,
                    sx: {
                        height: height
                    },
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                            sx: {
                                color: "#001943"
                            },
                            children: "Multi-factor Authentication Setup"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: maxWidth === "sm" ? "relative h-[530px] w-[520px] bg-white" : "relative h-[630px] w-[870px] bg-white",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: " pt-[10px] pl-[35px] text-mulish",
                                    children: "Please select how you would like to authenticate with"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "pt-[10px] pl-[35px] text-mulish font-bold",
                                    children: localStorage.username
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "pt-[40px] pl-[35px] text-mulish",
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $lk6eW.default), {
                                                children: "Authentication Method"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $imWqP.default), {
                                                defaultValue: authenticationMethod,
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                        value: "sms",
                                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {}),
                                                        label: "SMS",
                                                        onClick: ()=>{
                                                            setMaxWidth("sm");
                                                            setHeight(530);
                                                            setAuthenticationMethod("sms");
                                                            setPhoneInput("");
                                                            setAuthenticationData({
                                                                authentication_method: "sms"
                                                            });
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                                        value: "app",
                                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {}),
                                                        label: "Authenticator App",
                                                        onClick: ()=>{
                                                            setMaxWidth("md");
                                                            setHeight(620);
                                                            setAuthenticationMethod("app");
                                                            setAuthenticationData({
                                                                authentication_method: "app"
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "pt-[20px] pl-[35px] text-mulish",
                                    children: maxWidth === "sm" ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        value: phoneInput,
                                        onChange: (event)=>{
                                            const nextValue = event.target.value;
                                            const result = (0, $3EhHS.normalizePhone)(nextValue);
                                            setPhoneInput(nextValue);
                                            setAuthenticationData((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    phone_number: result.ok ? result.e164 : nextValue
                                                };
                                            });
                                        },
                                        id: "outlined-basic",
                                        label: "Phone Number",
                                        variant: "outlined",
                                        sx: {
                                            width: 350
                                        },
                                        error: phoneInvalid,
                                        helperText: phoneResult === null ? "Enter a phone number to receive codes via SMS, including the country code, e.g. +1 225 465 9357" : phoneResult.ok ? `Will text ${phoneResult.display}` : phoneResult.reason
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        onChange: (event)=>{
                                            setAuthenticationData((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    authenticator_code: event.target.value
                                                };
                                            });
                                        },
                                        id: "outlined-basic",
                                        label: "Authentication Code",
                                        variant: "outlined",
                                        sx: {
                                            width: 350
                                        },
                                        helperText: "Enter the code from your authenticator app once you've scanned the QR code"
                                    })
                                }),
                                maxWidth !== "sm" && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "pt-[20px] pl-[35px] text-mulish",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        onChange: (event)=>{
                                            setAuthenticationData((previousState)=>{
                                                return {
                                                    ...previousState,
                                                    authenticator_name: event.target.value
                                                };
                                            });
                                        },
                                        id: "outlined-basic",
                                        label: "Friendly Name *",
                                        variant: "outlined",
                                        sx: {
                                            width: 350
                                        },
                                        helperText: "Optional. Add a friendly name for the authenticator."
                                    })
                                }),
                                maxWidth !== "sm" && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "absolute top-[10px] right-[35px]",
                                    children: "Scan this QR Code with your Authenticator App:"
                                }),
                                maxWidth !== "sm" && qRCode && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "absolute top-[70px] right-[75px]",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                                        className: "w-[250px]",
                                        src: qRCode,
                                        alt: "Video_clip_coming_soon_image"
                                    })
                                }),
                                maxWidth !== "sm" && !qRCode && /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                    className: "absolute top-[130px] right-[100px] text-red-500 font-bold text-center",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            children: "QR CODE NOT AVAILABLE."
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            children: "Try refreshing screen"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            children: "or use SMS method."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    setPageLoading(true);
                                    (0, $d6dca29f904fc905$export$cdb31af798cdc179)(authenticationData, setPageLoading, navigate);
                                },
                                text: "Save",
                                disabled: phoneInvalid
                            })
                        })
                    ]
                })
            })
        ]
    });
};


/* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable jsx-a11y/interactive-supports-focus */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $jVN1H = parcelRequire("jVN1H");

var $lukvk = parcelRequire("lukvk");

var $h0DCc = parcelRequire("h0DCc");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $7UDCh = parcelRequire("7UDCh");
var $6gU8O = parcelRequire("6gU8O");
var $cxknk = parcelRequire("cxknk");
var $2eEqG = parcelRequire("2eEqG");
var $eejVe = parcelRequire("eejVe");
var $cVCJe = parcelRequire("cVCJe");

var $4PFLW = parcelRequire("4PFLW");

var $eYzFO = parcelRequire("eYzFO");

var $9mFrR = parcelRequire("9mFrR");

var $qyGZG = parcelRequire("qyGZG");

var $9s9JO = parcelRequire("9s9JO");

var $195EM = parcelRequire("195EM");

var $815yO = parcelRequire("815yO");

var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");

var $7ulPk = parcelRequire("7ulPk");

var $eYzFO = parcelRequire("eYzFO");

var $3FJ79 = parcelRequire("3FJ79");
const $404a08a34a94bb0b$export$54795c8232430cec = (data)=>{
    const raw = Array.isArray(data?.results) ? data.results : Array.isArray(data) ? data : [];
    return raw.map((row)=>Number(row?.id)).filter((id)=>Number.isFinite(id));
};
const $404a08a34a94bb0b$export$ed82ce4272024e44 = (zones, freshRowIds)=>{
    const sorted = Array.from(new Set(freshRowIds.map((n)=>Number(n)).filter((id)=>Number.isFinite(id)))).sort((a, b)=>a - b);
    if (sorted.length === 0) return new Map();
    if (sorted.length === 1) return new Map([
        [
            sorted[0],
            [
                ...zones
            ]
        ]
    ]);
    const freshSet = new Set(sorted);
    /** Rows removed server-side: merge those zones into the highest id (newest row). */ const staleIdFallback = Math.max(...sorted);
    const m = new Map();
    for (const z of zones){
        const raw = z.preset_zone_id;
        const id = raw != null && Number.isFinite(Number(raw)) ? Number(raw) : null;
        const key = id != null && freshSet.has(id) ? id : staleIdFallback;
        const arr = m.get(key) || [];
        arr.push(z);
        m.set(key, arr);
    }
    return m;
};



var $9s9JO = parcelRequire("9s9JO");

var $6JE7U = parcelRequire("6JE7U");
const $e107f9de0defb7bd$var$normalizeDisplay = (s)=>(s || "").trim().toLowerCase();
const $e107f9de0defb7bd$export$8340ee2cd9968ee4 = (template, presetZones)=>{
    const byLabel = presetZones.find((z)=>z.label === template.label);
    if (byLabel) return byLabel;
    const tType = Number(template.zone_type);
    if (tType === 0) return presetZones.find((z)=>Number(z.zone_type) === 0);
    const tMetric = Number(template.metric_id);
    const byMetricType = presetZones.find((z)=>Number(z.zone_type) === tType && Number(z.metric_id) === tMetric);
    if (byMetricType) return byMetricType;
    const tName = $e107f9de0defb7bd$var$normalizeDisplay(template.label_display_name);
    if (!tName) return undefined;
    return presetZones.find((z)=>Number(z.zone_type) === tType && $e107f9de0defb7bd$var$normalizeDisplay(z.label_display_name) === tName);
};
const $e107f9de0defb7bd$export$202dbbd51dc5653f = (p)=>JSON.stringify({
        zones: p.zones || [],
        name: (p.name || "").trim()
    });
const $e107f9de0defb7bd$export$ebff7978ad3201e1 = (raw)=>{
    if (raw == null) return undefined;
    try {
        const o = JSON.parse(raw);
        if (o && typeof o === "object" && !Array.isArray(o) && "name" in o && typeof o.name === "string") return (o.name || "").trim();
    } catch  {
    /* ignore */ }
    return undefined;
};
const $e107f9de0defb7bd$export$28b1ac19631ad5cd = (presets)=>{
    const o = {};
    for (const p of presets){
        if (p.localId === (0, $9s9JO.FLEX_IZ_NO_IGNORE_ZONES_OPTION)) continue;
        o[p.localId] = $e107f9de0defb7bd$export$202dbbd51dc5653f(p);
    }
    return o;
};
const $e107f9de0defb7bd$export$d7977cd6169b1e95 = (presets, preferredLocalId)=>(0, $6JE7U.collapseNoIgnoreZonesPresetOptions)((0, $6JE7U.filterFlexPresetsForApiPresetDropdown)(presets), preferredLocalId).filter((p)=>!(0, $6JE7U.isNoIgnorePreset)(p));
const $e107f9de0defb7bd$export$b202a0d03f39c35f = (presets, baseline)=>{
    const dirty = [];
    for (const p of presets){
        if (p.localId === (0, $9s9JO.FLEX_IZ_NO_IGNORE_ZONES_OPTION)) continue;
        const cur = $e107f9de0defb7bd$export$202dbbd51dc5653f(p);
        const base = baseline[p.localId];
        if (base !== cur) dirty.push(p.localId);
    }
    return dirty;
};


const $e89cf803e1812a77$var$resolveZoneGroupsWithFallback = async (AxiosUI, cameraId, presetId, zones)=>{
    const res = await AxiosUI.get(`preset-zone/?camera=${cameraId}&preset=${presetId}`);
    const freshIds = (0, $404a08a34a94bb0b$export$54795c8232430cec)(res.data);
    if (freshIds.length === 0) throw new Error(`No preset-zone rows for camera ${cameraId} preset ${presetId}.`);
    return (0, $404a08a34a94bb0b$export$ed82ce4272024e44)(zones, freshIds);
};
const $e89cf803e1812a77$var$ensureMetricRows = async (customerIdNum)=>{
    const siteStore = (0, $3FJ79.useSiteAboutStore).getState();
    let metricRows = siteStore.siteMetricsSimplifiedCustomerId === customerIdNum ? siteStore.siteMetricsSimplified : [];
    if (metricRows.length === 0) {
        const AxiosUI = (0, $195EM.createApi)("");
        const metricSimplifiedResponse = await AxiosUI.get("metric/simplified/", {
            params: {
                customer: customerIdNum
            }
        });
        if (Array.isArray(metricSimplifiedResponse.data?.results)) metricRows = metricSimplifiedResponse.data.results;
        else if (Array.isArray(metricSimplifiedResponse.data)) metricRows = metricSimplifiedResponse.data;
        siteStore.setSiteMetricsSimplifiedData(metricRows, customerIdNum);
    }
    return metricRows;
};
const $e89cf803e1812a77$export$b85949d1ee902d15 = async ({ cameraId: cameraId, customerId: customerId, dirtyPresetLocalIds: dirtyPresetLocalIds, flexZonesBaseline: flexZonesBaseline, navigate: navigate, setPageLoading: setPageLoading })=>{
    const retryFunction = ()=>{
        $e89cf803e1812a77$export$b85949d1ee902d15({
            cameraId: cameraId,
            customerId: customerId,
            dirtyPresetLocalIds: dirtyPresetLocalIds,
            flexZonesBaseline: flexZonesBaseline,
            navigate: navigate,
            setPageLoading: setPageLoading
        });
    };
    const AxiosUI = (0, $195EM.createApi)("");
    setPageLoading(true);
    let metricRows = [];
    try {
        metricRows = await $e89cf803e1812a77$var$ensureMetricRows(customerId);
    } catch (reason) {
        setPageLoading(false);
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Unable to load metrics for saving flex ignore zones.");
        });
        return;
    }
    for (const localId of dirtyPresetLocalIds){
        const state = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore).getState();
        const preset = (state.presetsByCamera[cameraId] || []).find((p)=>p.localId === localId);
        if (!preset) continue;
        if (preset.persistedId == null) {
            const persistResult = await state.persistFlexPresetDraftToApi(cameraId, localId);
            if (!persistResult.ok) {
                setPageLoading(false);
                alert(persistResult.error);
                return;
            }
            continue;
        }
        const presetId = preset.persistedId;
        const trimmedName = (preset.name || "").trim();
        const baselineTrimmedName = flexZonesBaseline ? (0, $e107f9de0defb7bd$export$ebff7978ad3201e1)(flexZonesBaseline[localId]) : undefined;
        if (baselineTrimmedName !== undefined && baselineTrimmedName !== trimmedName) try {
            await AxiosUI.patch(`preset/${presetId}/`, {
                name: trimmedName
            });
        } catch (reason) {
            setPageLoading(false);
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                alert(reason?.message || "Error updating flex preset name, please try again");
            });
            return;
        }
        const apiName = `${trimmedName} #${presetId}`;
        try {
            const groups = await $e89cf803e1812a77$var$resolveZoneGroupsWithFallback(AxiosUI, cameraId, presetId, preset.zones || []);
            for (const [zoneRowId, rowZones] of groups){
                const body = (0, $7ulPk.buildPresetZonePatchBodyFromZones)({
                    cameraId: cameraId,
                    presetId: presetId,
                    presetApiName: apiName,
                    zones: rowZones,
                    metricRows: metricRows
                });
                await AxiosUI.patch(`preset-zone/${zoneRowId}/`, body);
            }
        } catch (reason) {
            setPageLoading(false);
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                alert(reason?.message || "Error submitting flex preset zone changes, please try again");
            });
            return;
        }
    }
    // Saving no longer auto-syncs. Mark the site as having unsynced changes;
    // the operator syncs explicitly from the site About page.
    (0, $815yO.markSiteUnsynced)();
    try {
        await (0, $eYzFO.useFlexIgnoreZonesOnboardingStore).getState().loadCameraContext(cameraId, true);
    } catch  {
    /* best-effort: re-fetch preset-zone rows so Default preset UI matches API */ }
    if (location.href.includes("editignorezones")) await AxiosUI.get(`camera/site/?customer__id=${customerId}`).then((response)=>{
        localStorage.setItem("siteCameras", JSON.stringify(response.data));
        navigate(`/sites/${Number((0, $a8BPe.getNumbersAfterSites)(location.href))}/editcamera/${Number((0, $a8BPe.getNumbersAfterEditCamera)(location.href))}`);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
    });
    setPageLoading(false);
};



parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");

var $2nm0w = parcelRequire("2nm0w");

var $eYzFO = parcelRequire("eYzFO");


var $eYzFO = parcelRequire("eYzFO");
async function $2e09c12e698fbe5e$export$942fb94d3f99fb83(cameraId, signal, maxWaitMs = 120000) {
    const start = Date.now();
    while(Date.now() - start < maxWaitMs){
        if (signal.aborted) return;
        const ctx = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore).getState().cameraContexts[cameraId];
        if (ctx && !ctx.loading) return;
        await new Promise((r)=>setTimeout(r, 50));
    }
}


async function $555ed3dab76dab5c$export$2c0ba388100651a4({ signal: signal, showFlexIgnoreZones: showFlexIgnoreZones, hasFlexSchedule: hasFlexSchedule, setPageLoading: setPageLoading, setVisibleIgnoreZones: setVisibleIgnoreZones, setLoadProgress: setLoadProgress, setLoadMessage: setLoadMessage, setFlexZonesBaseline: setFlexZonesBaseline, setSelectedFlexPresetLocalId: setSelectedFlexPresetLocalId, isMounted: isMounted }) {
    const cameraId = Number((0, $a8BPe.getNumbersAfterEditCamera)(location.href));
    const siteId = Number((0, $a8BPe.getNumbersAfterSites)(location.href));
    if (!showFlexIgnoreZones || !hasFlexSchedule) {
        if (isMounted()) setPageLoading(false);
        return;
    }
    try {
        if (isMounted()) {
            setLoadMessage("Loading flex ignore zones\u2026");
            setLoadProgress(82);
        }
        await (0, $2nm0w.hydrateFlexIgnoreZonesForEditCameraPage)(siteId, {
            signal: signal,
            focusCameraId: cameraId
        });
        if (!isMounted() || signal.aborted) return;
        const enabled = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore).getState().enabledBySite[siteId] === true;
        if (!enabled) {
            if (isMounted()) {
                setLoadProgress(undefined);
                setLoadMessage("");
                setPageLoading(false);
            }
            return;
        }
        if (isMounted()) {
            setLoadProgress(88);
            setLoadMessage("Loading flex schedule presets\u2026");
        }
        // `syncFlexIgnoreZonesEnabledFromApi` (inside hydrate) already loads camera contexts when presets exist.
        await (0, $2e09c12e698fbe5e$export$942fb94d3f99fb83)(cameraId, signal);
        if (!isMounted() || signal.aborted) return;
        const presets = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore).getState().presetsByCamera[cameraId] || [];
        const menuPresets = (0, $e107f9de0defb7bd$export$d7977cd6169b1e95)(presets);
        if (isMounted()) {
            setFlexZonesBaseline((0, $e107f9de0defb7bd$export$28b1ac19631ad5cd)(presets));
            if (menuPresets.length > 0) {
                setSelectedFlexPresetLocalId(menuPresets[0].localId);
                setVisibleIgnoreZones(JSON.parse(JSON.stringify(menuPresets[0].zones || [])));
            }
        }
    } catch  {
    /* best-effort */ } finally{
        if (isMounted()) {
            setLoadProgress(undefined);
            setLoadMessage("");
            setPageLoading(false);
        }
    }
}



var $QUu0n = parcelRequire("QUu0n");

var $8jTCz = parcelRequire("8jTCz");

var $8ZARq = parcelRequire("8ZARq");

var $8gqnT = parcelRequire("8gqnT");

var $195EM = parcelRequire("195EM");

var $815yO = parcelRequire("815yO");

var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");

var $6NUqI = parcelRequire("6NUqI");
const $ba9bf15a0210b580$var$replaceNegativeWithZero = (data)=>{
    if (!data || data.length === 0) return data;
    for(let i = 0; i < data.length; i++)for(let j = 0; j < data[i].length; j++){
        for(let k = 0; k < data[i][j].length; k++)if (data[i][j][k] < 0) data[i][j][k] = 0;
    }
    return data;
};
const $ba9bf15a0210b580$export$d318419605bae6b2 = async (submitObject, navigate, setPageLoading)=>{
    const retryFunction = ()=>{
        $ba9bf15a0210b580$export$d318419605bae6b2(submitObject, navigate, setPageLoading);
    };
    let submitIZfail = false;
    const AxiosUI = (0, $195EM.createApi)(``);
    setPageLoading(true);
    submitObject = submitObject.map((obj)=>{
        return {
            ...obj,
            coordinates: (0, $6NUqI.dedupePolygons)($ba9bf15a0210b580$var$replaceNegativeWithZero(obj.coordinates).filter((arr)=>arr.length > 0))
        };
    });
    await AxiosUI.post(`/camera/${(0, $a8BPe.getNumbersAfterEditCamera)(location.href)}/ignore_zones/`, submitObject).then(()=>{
        submitIZfail = false;
        // Saving no longer auto-syncs. Mark the site as having unsynced changes;
        // the operator syncs explicitly from the site About page.
        (0, $815yO.markSiteUnsynced)();
    }, (reason)=>{
        submitIZfail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Error submitting Ignore Zone changes, please try again");
        });
    });
    !submitIZfail && location.href.includes("editignorezones") && await AxiosUI.get(`camera/site/?customer__id=${(0, $a8BPe.getNumbersAfterSites)(location.href)}`).then((response)=>{
        localStorage.setItem("siteCameras", JSON.stringify(response.data));
        navigate(`/sites/${Number((0, $a8BPe.getNumbersAfterSites)(location.href))}/editcamera/${Number((0, $a8BPe.getNumbersAfterEditCamera)(location.href))}`);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
    });
};



var $dHtmK = parcelRequire("dHtmK");

var $195EM = parcelRequire("195EM");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");
parcelRequire("8T3gX");
const $f3f7f2b4dd3477d9$export$628303c6555cdbbe = (input)=>{
    if (input) {
        const [widthStr, heightStr] = input.split("x").map((str)=>parseInt(str.trim()));
        const aspectRatio = widthStr / heightStr;
        let adjustedWidth = widthStr;
        let adjustedHeight = heightStr;
        if (adjustedWidth / aspectRatio > 360) {
            adjustedWidth = 640;
            adjustedHeight = adjustedWidth / aspectRatio;
        } else {
            adjustedHeight = 360;
            adjustedWidth = adjustedHeight * aspectRatio;
        }
        if (adjustedWidth > 640) {
            adjustedWidth = 640;
            adjustedHeight = adjustedWidth / aspectRatio;
        }
        if (adjustedHeight > 360) {
            adjustedHeight = 360;
            adjustedWidth = adjustedHeight * aspectRatio;
        }
        return {
            width: adjustedWidth,
            height: adjustedHeight
        };
    } else return {
        height: 360,
        width: 640
    };
};



var $83bsI = parcelRequire("83bsI");
const $c59813e119cd9e91$export$76679b463cbcf969 = (setPageLoading, setBreadCrumbs, setVisibleIgnoreZones, setDimensions, setAdjustedDimensions, options)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const cameraId = (0, $a8BPe.getNumbersAfterEditCamera)(location.href);
    const adjustDimensions = (dimensions)=>{
        const [width, height] = dimensions.split(" x ").map(Number);
        if (!width || !height) return; // Exit if parsing fails
        const aspectRatio = height / width;
        const adjustedHeight = Math.round(720 * aspectRatio);
        setAdjustedDimensions({
            x: 720,
            y: adjustedHeight
        });
    };
    AxiosUI.get(`/camera/${cameraId}/status/`).then((response)=>{
        localStorage.setItem("zwibblerDimensions", JSON.stringify((0, $f3f7f2b4dd3477d9$export$628303c6555cdbbe)(response.data.frame_dimensions)));
        localStorage.setItem("preview_url", JSON.stringify(response.data.preview_url));
        setDimensions((0, $f3f7f2b4dd3477d9$export$628303c6555cdbbe)(response.data.frame_dimensions));
        adjustDimensions(response.data.frame_dimensions);
        localStorage.setItem("currentCamera", response.data.camera_name);
        AxiosUI.get(`/camera/${cameraId}/ignore_zones/`).then((response)=>{
            setVisibleIgnoreZones((0, $83bsI.addIgnoreLabel)(response.data));
            AxiosUI.get(`customer/${(0, $a8BPe.getNumbersAfterSites)(location.href)}/about/`).then((response)=>{
                setBreadCrumbs(response.data.breadcrumbs);
                const hasFlexSchedule = response.data?.has_flex_schedule === true;
                options?.setHasFlexSchedule?.(hasFlexSchedule);
                const finish = ()=>{
                    if (options?.deferPageLoadingFinish) {
                        Promise.resolve(options.onBaseLoadComplete?.({
                            has_flex_schedule: hasFlexSchedule
                        }));
                        return;
                    }
                    setPageLoading(false);
                };
                if (!localStorage.currentCamera) AxiosUI.get(`/camera/${cameraId}/general_info/`).then((response)=>{
                    localStorage.setItem("currentCamera", response.data.camera_name);
                    finish();
                });
                else finish();
            });
        });
    });
};



var $a2fXs = parcelRequire("a2fXs");

var $frXOV = parcelRequire("frXOV");

var $2qUoo = parcelRequire("2qUoo");

var $2hXui = parcelRequire("2hXui");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");
parcelRequire("8T3gX");
const $a6067036be07cb5d$export$e3b257868d26b4e = (setBreadCrumbs, setVisibleIgnoreZones, setIgnorezoneEditorVisible, setSelectedIgnoreZone, setEditsMade, setPageLoading, setDimensions, setAllCamerasData, setCameraIndex)=>{
    setBreadCrumbs([]);
    setVisibleIgnoreZones([]);
    setIgnorezoneEditorVisible(false);
    setSelectedIgnoreZone("");
    setEditsMade(false);
    setPageLoading(true);
    setDimensions({
        width: 640,
        height: 360
    });
    setAllCamerasData([]);
    setCameraIndex(0);
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $gus0k = parcelRequire("gus0k");

var $kRZvb = parcelRequire("kRZvb");

var $iKAtE = parcelRequire("iKAtE");

var $433j1 = parcelRequire("433j1");


var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");


const $9390e888264cd723$export$4a587b3eb8320aaf = (hexColor, magnitude)=>{
    hexColor = hexColor.replace(`#`, ``);
    if (hexColor.length === 6) {
        const decimalColor = parseInt(hexColor, 16);
        let r = (decimalColor >> 16) + magnitude;
        r > 255 && (r = 255);
        r < 0 && (r = 0);
        let g = (decimalColor & 0x0000ff) + magnitude;
        g > 255 && (g = 255);
        g < 0 && (g = 0);
        let b = (decimalColor >> 8 & 0x00ff) + magnitude;
        b > 255 && (b = 255);
        b < 0 && (b = 0);
        return `#${(g | b << 8 | r << 16).toString(16).toUpperCase()}`;
    } else return hexColor;
};


const $493391a1afe0cfbd$var$ZwibblerComponent = /*#__PURE__*/ (0, $8T3gX.forwardRef)((props, ref)=>{
    // Zwibbler configuration, see
    // https://zwibbler.com/configurator.html
    // All names are lower case due to react convention.
    // const backgroundImage = JSON.parse(localStorage.preview_url)
    const [zwibblerConfig, setZwibblerConfig] = $8T3gX.useState({
        zwibbler: "",
        showtoolbar: "true",
        // "z-controller": "mycontroller",
        defaultarrowsize: "10",
        defaultarrowstyle: "solid",
        defaultLineWidth: "5",
        adaptivebrushwidth: "true",
        defaultfillstyle: "transparent",
        background: "transparent",
        showarrowtool: "false",
        showbrushtool: "false",
        showcircletool: "false",
        showcopypaste: "false",
        showcurvetool: "false",
        showroundrecttool: "false",
        showshapebrushtool: "false",
        showsquaretool: "false",
        showtexttool: "false",
        allowzoom: "false",
        allowtextinshape: "false",
        defaultstrokestyle: "black",
        scrollbars: "false",
        allowresize: "false",
        confine: "view",
        showUndoredo: "false"
    });
    const dimensions = JSON.parse(localStorage.zwibblerDimensions);
    const zwibblerEl = (0, $8T3gX.useRef)(null);
    const ctx = (0, $8T3gX.useRef)(null);
    const [shapesObject, setShapesObject] = $8T3gX.useState({});
    const [currentNode, setCurrentNode] = $8T3gX.useState("");
    const [shiftedObj, setShiftedObj] = $8T3gX.useState({});
    const shapesMoveHandler = (event)=>{
        event.nodes.forEach((item)=>{
            setShiftedObj((previousState)=>{
                return {
                    ...previousState,
                    [item.id]: [
                        item.shift.x,
                        item.shift.y
                    ]
                };
            });
        });
    };
    const nodeChangeHandler = (node)=>{
        setShapesObject((previousState)=>{
            return {
                ...previousState,
                [node[0]]: coordinatesArrayCreator(ctx.current.summary.properties.commands)
            };
        });
    };
    // ctx.current.deleteNode()
    // When component is unmounted, destroy Zwibbler.
    (0, $8T3gX.useEffect)(()=>{
        if (!zwibblerEl.current) return;
        let scope, cancel = false;
        $493391a1afe0cfbd$var$waitForZwibblerLoad().then(()=>{
            const nodeChecker = (node)=>{
                if (// (scope.ctx.summary.properties.commands.length < 10 &&
                //   scope.ctx.summary.properties.commands[1] !==
                //     scope.ctx.summary.properties.commands[4]) ||
                scope.ctx.summary.properties.commands.length > 7 && Number(scope.ctx.summary.properties.commands[scope.ctx.summary.properties.commands.length - 1]) !== 7) scope.ctx.deleteNode(node[0]);
            };
            if (!cancel) {
                scope = window.Zwibbler.attach(zwibblerEl.current, {});
                ctx.current = scope.ctx;
                scope.ctx.on("drop-shape", shapesMoveHandler);
                scope.ctx.on("nodes-changed", nodeChangeHandler);
                scope.ctx.on("nodes-added", nodeChecker);
                const newShapesObject = {};
                JSON.parse(localStorage.ignoreZones).map((coordinatesArray)=>{
                    const shapeArray = [];
                    coordinatesArray.forEach((array)=>{
                        shapeArray.push(array[0] * dimensions.width);
                        shapeArray.push(array[1] * dimensions.height + 175);
                    });
                    ctx.current.createShape(shapeArray);
                    const selectedNode = ctx.current.getNodeUnderPoint(coordinatesArray[0][0] * dimensions.width, coordinatesArray[0][1] * dimensions.height + 175);
                    newShapesObject[selectedNode] = convertedCoordinatesArrayCreator(shapeArray);
                });
                setShapesObject(newShapesObject);
                const deleteNode = (node)=>{
                    delete newShapesObject[node];
                    setShapesObject(newShapesObject);
                };
                const nodeDeleteHandler = (node)=>{
                    deleteNode(node[0]);
                };
                scope.ctx.on("nodes-removed", nodeDeleteHandler);
            }
        });
        return ()=>{
            cancel = true;
            if (scope) scope.ctx.destroy();
        };
    }, []);
    (0, $8T3gX.useEffect)(()=>{
        setZwibblerConfig((previousState)=>{
            return {
                ...previousState,
                defaultStrokeStyle: localStorage.ignoreZoneColor,
                defaultfillstyle: (0, $9390e888264cd723$export$4a587b3eb8320aaf)(localStorage.ignoreZoneColor, 70)
            };
        });
    }, []);
    const coordinatesArrayCreator = (inputArray)=>{
        const returnArray = [];
        let y = 0;
        let pushedArray = [];
        for(let x = 0; x < inputArray.length - 4; x += 1){
            if (y === 0) {
                y = 1;
                pushedArray = [];
            } else if (y === 1) {
                pushedArray.push(inputArray[x] / dimensions.width);
                y = 2;
            } else {
                pushedArray.push((inputArray[x] - 175) / dimensions.height);
                returnArray.push(pushedArray);
                y = 0;
            }
        }
        return returnArray;
    };
    const convertedCoordinatesArrayCreator = (inputArray)=>{
        const returnArray = [];
        let pushedArray = [];
        for(let x = 0; x < inputArray.length; x += 1)if (x % 2 === 0) pushedArray.push(inputArray[x] / dimensions.width);
        else {
            pushedArray.push((inputArray[x] - 175) / dimensions.height);
            returnArray.push(pushedArray);
            pushedArray = [];
        }
        return returnArray;
    };
    const listener = (event)=>{
        localStorage.setItem("shiftedObj", JSON.stringify(shiftedObj));
        const xAxis = event.clientX - 301;
        const yAxis = event.clientY - 224;
        const selectedNode = ctx.current.getNodeUnderPoint(xAxis, yAxis);
        if (selectedNode) setCurrentNode(selectedNode);
        const coordinatesArray = ctx.current.summary.properties.commands;
        if (coordinatesArray && coordinatesArray[coordinatesArray.length - 1] === 7) {
            const updatedShapesObject = shapesObject;
            updatedShapesObject[ctx.current.summary.nodes[0]] = coordinatesArrayCreator(coordinatesArray);
            setShapesObject(updatedShapesObject);
            const selectedNode = ctx.current.getNodeUnderPoint(event.clientX - 301, event.clientY - 224);
            if (ctx.current.summary.nodes[0] === selectedNode) {
                const newShapesObject = shapesObject;
                const currentCoordinates = coordinatesArrayCreator(coordinatesArray);
                newShapesObject[selectedNode] = currentCoordinates;
                setShapesObject(newShapesObject);
            }
        }
        localStorage.setItem("shapesObject", JSON.stringify(shapesObject));
    };
    const deleteNode = (event)=>{
        if (event.key === "Backspace") {
            const newShapesObject = shapesObject;
            delete newShapesObject[currentNode];
            setShapesObject(newShapesObject);
        }
    };
    (0, $8T3gX.useEffect)(()=>{
        window.addEventListener("mousemove", listener);
        return ()=>{
            window.removeEventListener("mousemove", listener);
        };
    });
    // useEffect(() => {
    //   window.addEventListener("keyup", deleteNode);
    //   return () => {
    //     window.removeEventListener("keyup", deleteNode);
    //   };
    // }),
    //   [];
    // useEffect(() => {
    //   window.addEventListener("keypress", deleteNode);
    //   return () => {
    //     window.removeEventListener("keypress", deleteNode);
    //   };
    // }),
    //   [];
    // Here we define things that we want to make available in our ref
    (0, $8T3gX.useImperativeHandle)(ref, ()=>({
            get ctx () {
                return ctx.current;
            }
        }));
    // You may freely mix react and Zwibbler-framework directives (eg, z-if, z-for) here.
    // But you will be unable to use z-on:click because of the colon.
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        ...zwibblerConfig,
        ref: zwibblerEl,
        className: "zwibbler",
        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
            "z-canvas": "",
            className: "stretch"
        })
    });
});
// HACK for STACKBLIZ ONLY. THIS IS NOT NECESSARY IF YOU INCLUDE
// zwibbler-demo.js in your index.html file or as part of  your project.
const $493391a1afe0cfbd$var$loadPromise = new Promise((resolve)=>{
    const interval = setInterval(()=>{
        if ("Zwibbler" in window) {
            // Zwibbler = window["Zwibbler"];
            clearInterval(interval);
            resolve();
            return;
        }
    }, 100);
});
function $493391a1afe0cfbd$var$waitForZwibblerLoad() {
    return $493391a1afe0cfbd$var$loadPromise;
}
$493391a1afe0cfbd$var$ZwibblerComponent.displayName = "ZwibblerComponent";
var $493391a1afe0cfbd$export$2e2bcd8739ae039 = $493391a1afe0cfbd$var$ZwibblerComponent;


const $14f558c545bbd811$var$Transition = /*#__PURE__*/ $8T3gX.forwardRef(function Transition(props, ref) {
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $212a5a6a44b7f18e$export$2e2bcd8739ae039), {
        direction: "up",
        ref: ref,
        ...props
    });
});
const $14f558c545bbd811$export$1a23eafc8f50ba44 = ({ popOutEditorDialogOpen: popOutEditorDialogOpen, setPopOutEditorDialogOpen: setPopOutEditorDialogOpen })=>{
    const handleClickOpen = ()=>{
        setPopOutEditorDialogOpen(true);
    };
    const handleClose = ()=>{
        setPopOutEditorDialogOpen(false);
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)($8T3gX.Fragment, {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
            fullScreen: true,
            open: popOutEditorDialogOpen,
            onClose: handleClose,
            TransitionComponent: $14f558c545bbd811$var$Transition,
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gus0k.default), {
                    sx: {
                        position: "relative"
                    },
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kRZvb.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                            edge: "start",
                            color: "inherit",
                            onClick: handleClose,
                            "aria-label": "close",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
                        })
                    })
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "player absolute top-[70px] left-[20px] w-[1475px] h-[200px]",
                    role: "button",
                    tabIndex: 0,
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $493391a1afe0cfbd$export$2e2bcd8739ae039), {})
                })
            ]
        })
    });
};



var $1o017 = parcelRequire("1o017");
const $d5e1a870b2f29fa5$var$readHasFlexScheduleFromSiteInfo = ()=>{
    try {
        const raw = localStorage.getItem("siteInfo");
        if (!raw) return false;
        const parsed = JSON.parse(raw);
        return parsed?.has_flex_schedule === true;
    } catch  {
        return false;
    }
};
const $d5e1a870b2f29fa5$export$b731b475761cc2a0 = ({ navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed })=>{
    const [breadcrumbs, setBreadCrumbs] = $8T3gX.useState([]);
    const [visibleIgnoreZones, setVisibleIgnoreZones] = $8T3gX.useState([]);
    const [ignorezoneEditorVisible, setIgnorezoneEditorVisible] = $8T3gX.useState(false);
    const [selectedIgnoreZone, setSelectedIgnoreZone] = $8T3gX.useState("");
    const ignoreZonesLiveRef = $8T3gX.useRef([]);
    const selectedIgnoreZoneLiveRef = $8T3gX.useRef("");
    ignoreZonesLiveRef.current = visibleIgnoreZones;
    selectedIgnoreZoneLiveRef.current = selectedIgnoreZone;
    const [editsMade, setEditsMade] = $8T3gX.useState(false);
    const [pageLoading, setPageLoading] = $8T3gX.useState(true);
    const [largerMode, setLargerMode] = $8T3gX.useState(false);
    // const [dimensions, setDimensions] = React.useState({
    //   width: 640,
    //   height: 360,
    // });
    const [adjustedDimensions, setAdjustedDimensions] = $8T3gX.useState({
        x: 720,
        y: 576
    });
    const [dimensions, setDimensions] = $8T3gX.useState(null);
    const handleImageLoad = (event)=>{
        const { naturalWidth: naturalWidth, naturalHeight: naturalHeight } = event.currentTarget;
    // setDimensions(resizeImage(naturalWidth, naturalHeight));
    };
    const navigate = (0, $3T949.useNavigate)();
    const { isFeatureEnabled: isFeatureEnabled } = (0, $4PFLW.useFeatureFlag)();
    const showFlexIgnoreZones = isFeatureEnabled("showFlexIgnoreZones", false);
    const siteId = Number((0, $a8BPe.getNumbersAfterSites)(location.href));
    const cameraIdForPage = Number((0, $a8BPe.getNumbersAfterEditCamera)(location.href));
    const enabledBySite = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((s)=>s.enabledBySite);
    const flexPresetsForCamera = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((s)=>s.presetsByCamera[cameraIdForPage] ?? (0, $9mFrR.EMPTY_FLEX_PRESETS_LIST));
    const updatePresetZones = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((s)=>s.updatePresetZones);
    const loadCameraContext = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((s)=>s.loadCameraContext);
    const createCustomPresetDraft = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((s)=>s.createCustomPresetDraft);
    const removeLocalPresetDraft = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((s)=>s.removeLocalPresetDraft);
    const updatePresetName = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((s)=>s.updatePresetName);
    const cameraContexts = (0, $eYzFO.useFlexIgnoreZonesOnboardingStore)((s)=>s.cameraContexts);
    const [hasFlexSchedule, setHasFlexSchedule] = $8T3gX.useState($d5e1a870b2f29fa5$var$readHasFlexScheduleFromSiteInfo);
    const flexIgnoreZonesEnabledForSite = showFlexIgnoreZones && enabledBySite[siteId] === true;
    const flexIzActive = flexIgnoreZonesEnabledForSite && hasFlexSchedule;
    const flexIzActiveRef = $8T3gX.useRef(false);
    $8T3gX.useEffect(()=>{
        flexIzActiveRef.current = flexIzActive;
    }, [
        flexIzActive
    ]);
    const [loadProgressPercent, setLoadProgressPercent] = $8T3gX.useState(undefined);
    const [loadProgressMessage, setLoadProgressMessage] = $8T3gX.useState("");
    const [flexZonesBaseline, setFlexZonesBaseline] = $8T3gX.useState({});
    const [selectedFlexPresetLocalId, setSelectedFlexPresetLocalId] = $8T3gX.useState("");
    const selectedFlexPresetLocalIdRef = $8T3gX.useRef("");
    $8T3gX.useEffect(()=>{
        selectedFlexPresetLocalIdRef.current = selectedFlexPresetLocalId;
    }, [
        selectedFlexPresetLocalId
    ]);
    const [newPresetDialog, setNewPresetDialog] = $8T3gX.useState(null);
    const isMountedRef = $8T3gX.useRef(true);
    const flexLoadAbortRef = $8T3gX.useRef(null);
    const flexHasUnsavedChanges = $8T3gX.useMemo(()=>{
        if (!flexIzActive) return false;
        return (0, $e107f9de0defb7bd$export$b202a0d03f39c35f)((0, $e107f9de0defb7bd$export$d7977cd6169b1e95)(flexPresetsForCamera), flexZonesBaseline).length > 0;
    }, [
        flexIzActive,
        flexPresetsForCamera,
        flexZonesBaseline
    ]);
    const selectedFlexPreset = $8T3gX.useMemo(()=>flexPresetsForCamera.find((p)=>p.localId === selectedFlexPresetLocalId) ?? null, [
        flexPresetsForCamera,
        selectedFlexPresetLocalId
    ]);
    const presetNameFieldWidth = $8T3gX.useMemo(()=>Math.min(Math.max(adjustedDimensions.x, 280), 720), [
        adjustedDimensions.x
    ]);
    const setVisibleIgnoreZonesForPage = $8T3gX.useCallback((updater)=>{
        setVisibleIgnoreZones((prev)=>{
            const next = typeof updater === "function" ? updater(prev) : updater;
            if (flexIzActiveRef.current && selectedFlexPresetLocalIdRef.current && selectedFlexPresetLocalIdRef.current !== (0, $9s9JO.FLEX_IZ_NO_IGNORE_ZONES_OPTION)) updatePresetZones(cameraIdForPage, selectedFlexPresetLocalIdRef.current, next);
            return next;
        });
    }, [
        updatePresetZones,
        cameraIdForPage
    ]);
    /**
   * Sidebar rows always mirror `GET /camera/{id}/ignore_zones/` (store: `defaultZones`)
   * so every preset shows the same product list; the active preset row is resolved on click.
   */ const flexSidebarZones = $8T3gX.useMemo(()=>{
        if (!flexIzActive) return visibleIgnoreZones;
        const defaultZones = cameraContexts[cameraIdForPage]?.defaultZones ?? [];
        return defaultZones.length > 0 ? defaultZones : visibleIgnoreZones;
    }, [
        flexIzActive,
        cameraContexts,
        cameraIdForPage,
        visibleIgnoreZones
    ]);
    const zonesForSidebarList = flexIzActive ? flexSidebarZones : visibleIgnoreZones;
    const handleFlexSidebarZoneClick = $8T3gX.useCallback((templateRow)=>{
        const fromPreset = (0, $e107f9de0defb7bd$export$8340ee2cd9968ee4)(templateRow, visibleIgnoreZones);
        let zoneForEditor;
        if (fromPreset) zoneForEditor = fromPreset;
        else {
            zoneForEditor = {
                ...templateRow,
                coordinates: Array.isArray(templateRow.coordinates) ? JSON.parse(JSON.stringify(templateRow.coordinates)) : []
            };
            if (!zoneForEditor.coordinates?.length) zoneForEditor.coordinates = [];
            setVisibleIgnoreZonesForPage([
                ...visibleIgnoreZones,
                zoneForEditor
            ]);
        }
        setSelectedIgnoreZone(zoneForEditor.label);
        setIgnorezoneEditorVisible(true);
        localStorage.setItem("ignoreZoneColor", zoneForEditor.line_color);
        localStorage.setItem("ignoreZones", JSON.stringify(zoneForEditor.coordinates || []));
        setLargerMode(false);
    }, [
        visibleIgnoreZones,
        setVisibleIgnoreZonesForPage
    ]);
    const beginEditIgnoreZonesReload = $8T3gX.useCallback(()=>{
        flexLoadAbortRef.current?.abort();
        flexLoadAbortRef.current = new AbortController();
        const ac = flexLoadAbortRef.current;
        (0, $c59813e119cd9e91$export$76679b463cbcf969)(setPageLoading, setBreadCrumbs, setVisibleIgnoreZones, setDimensions, setAdjustedDimensions, showFlexIgnoreZones ? {
            deferPageLoadingFinish: true,
            setHasFlexSchedule: setHasFlexSchedule,
            onBaseLoadComplete: (siteAbout)=>(0, $555ed3dab76dab5c$export$2c0ba388100651a4)({
                    signal: ac.signal,
                    showFlexIgnoreZones: showFlexIgnoreZones,
                    hasFlexSchedule: siteAbout.has_flex_schedule === true,
                    setPageLoading: setPageLoading,
                    setVisibleIgnoreZones: setVisibleIgnoreZones,
                    setLoadProgress: setLoadProgressPercent,
                    setLoadMessage: setLoadProgressMessage,
                    setFlexZonesBaseline: setFlexZonesBaseline,
                    setSelectedFlexPresetLocalId: setSelectedFlexPresetLocalId,
                    isMounted: ()=>isMountedRef.current
                })
        } : {
            setHasFlexSchedule: setHasFlexSchedule
        });
    }, [
        showFlexIgnoreZones
    ]);
    const handleSitesBreadcrumbClick = (event)=>{
        event.preventDefault();
        localStorage.setItem("level0Click", "false");
        localStorage.setItem("navigatedFromSitesAboutPage", "false");
        navigate("/sites");
    };
    const handleSingularSiteBreadcrumbClick = ()=>{
        navigate(`/sites/aboutsite/${siteId}`);
    };
    const handleIgnoreZoneClick = (object)=>{
        setIgnorezoneEditorVisible(true);
        localStorage.setItem("ignoreZoneColor", object.line_color);
        localStorage.setItem("ignoreZones", JSON.stringify(object.coordinates));
    };
    const transformCoordinates = (coords)=>{
        return coords.map((group)=>group.map(([x, y])=>[
                    x * adjustedDimensions.x,
                    y * adjustedDimensions.y
                ]));
    };
    const [allCamerasData, setAllCamerasData] = $8T3gX.useState([]);
    const [cameraIndex, setCameraIndex] = $8T3gX.useState(0);
    const [popOutEditorDialogOpen, setPopOutEditorDialogOpen] = $8T3gX.useState(false);
    const [iZBuilder, setIZBuilder] = $8T3gX.useState(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
    const [siteSchedules, setSiteSchedules] = $8T3gX.useState([]);
    $8T3gX.useEffect(()=>{
        isMountedRef.current = true;
        beginEditIgnoreZonesReload();
        (0, $2hXui.getAllCameras)(Number((0, $a8BPe.getNumbersAfterSites)(location.href)), Number((0, $a8BPe.getNumbersAfterEditCamera)(location.href)), setAllCamerasData, setCameraIndex);
        localStorage.setItem("siteId", (0, $a8BPe.getNumbersAfterSites)(location.href));
        localStorage.setItem("currentCameraId", (0, $a8BPe.getNumbersAfterEditCamera)(location.href));
        return ()=>{
            isMountedRef.current = false;
            flexLoadAbortRef.current?.abort();
        };
    }, [
        beginEditIgnoreZonesReload
    ]);
    $8T3gX.useEffect(()=>{
        if (!flexIzActive) {
            setSelectedFlexPresetLocalId((prev)=>prev === "" ? prev : "");
            setFlexZonesBaseline((prev)=>Object.keys(prev).length === 0 ? prev : {});
            return;
        }
        const menu = (0, $e107f9de0defb7bd$export$d7977cd6169b1e95)(flexPresetsForCamera, selectedFlexPresetLocalId);
        if (menu.length === 0) return;
        const valid = selectedFlexPresetLocalId && menu.some((p)=>p.localId === selectedFlexPresetLocalId);
        if (!valid) {
            setSelectedFlexPresetLocalId(menu[0].localId);
            setVisibleIgnoreZones(JSON.parse(JSON.stringify(menu[0].zones || [])));
        }
    }, [
        flexIzActive,
        flexPresetsForCamera,
        selectedFlexPresetLocalId
    ]);
    $8T3gX.useEffect(()=>{
        if (ignorezoneEditorVisible) setIZBuilder(/*#__PURE__*/ (0, $k4ank.jsx)((0, $1o017.default), {
            shapeColor: localStorage.ignoreZoneColor,
            height: adjustedDimensions.y,
            width: adjustedDimensions.x,
            imageURL: JSON.parse(localStorage.preview_url),
            shapesArray: transformCoordinates(JSON.parse(localStorage.ignoreZones)),
            setIgnorezoneEditorVisible: setIgnorezoneEditorVisible,
            setEditsMade: setEditsMade,
            visibleIgnoreZones: visibleIgnoreZones,
            selectedIgnoreZone: selectedIgnoreZone,
            setVisibleIgnoreZones: flexIzActive ? setVisibleIgnoreZonesForPage : setVisibleIgnoreZones,
            largerMode: largerMode,
            setLargerMode: setLargerMode,
            dimensions: dimensions,
            setIZBuilder: setIZBuilder,
            allIgnoreZonesShown: false,
            siteSchedules: siteSchedules,
            visibleIgnoreZonesLiveRef: ignoreZonesLiveRef,
            selectedIgnoreZoneLiveRef: selectedIgnoreZoneLiveRef
        }));
        else setIZBuilder(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
    }, [
        ignorezoneEditorVisible,
        flexIzActive,
        setVisibleIgnoreZonesForPage
    ]);
    const flexPresetMenuPresets = $8T3gX.useMemo(()=>(0, $e107f9de0defb7bd$export$d7977cd6169b1e95)(flexPresetsForCamera, selectedFlexPresetLocalId), [
        flexPresetsForCamera,
        selectedFlexPresetLocalId
    ]);
    const flexCameraCtx = cameraContexts[cameraIdForPage];
    const handleFlexPresetSelectChange = (nextValue)=>{
        if (nextValue === (0, $9s9JO.FLEX_IZ_CREATE_NEW_PRESET_OPTION)) {
            const ctxZones = cameraContexts[cameraIdForPage]?.defaultZones;
            const zones = ctxZones && ctxZones.length > 0 ? ctxZones : visibleIgnoreZones;
            const localId = createCustomPresetDraft(cameraIdForPage, zones);
            setNewPresetDialog({
                cameraId: cameraIdForPage,
                presetLocalId: localId,
                cameraName: String(localStorage.currentCamera || "")
            });
            loadCameraContext(cameraIdForPage);
            return;
        }
        if (selectedFlexPresetLocalId) updatePresetZones(cameraIdForPage, selectedFlexPresetLocalId, visibleIgnoreZones);
        setSelectedFlexPresetLocalId(nextValue);
        const nextPreset = ((0, $eYzFO.useFlexIgnoreZonesOnboardingStore).getState().presetsByCamera[cameraIdForPage] || []).find((p)=>p.localId === nextValue);
        setVisibleIgnoreZones(JSON.parse(JSON.stringify(nextPreset?.zones || [])));
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8gqnT.SyncNeededBanner), {
                navigate: navigate
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                openState: pageLoading,
                progressPercent: loadProgressPercent,
                message: loadProgressMessage || undefined
            }),
            showFlexIgnoreZones && /*#__PURE__*/ (0, $k4ank.jsx)((0, $qyGZG.FlexIgnoreZonesNewPresetDialog), {
                open: newPresetDialog != null,
                cameraId: newPresetDialog?.cameraId ?? 0,
                presetLocalId: newPresetDialog?.presetLocalId ?? null,
                cameraName: newPresetDialog?.cameraName ?? "",
                assignToSchedule: false,
                onClose: (reason, meta)=>{
                    if (reason === "submitted" && newPresetDialog) {
                        setSelectedFlexPresetLocalId(meta?.presetLocalId ?? newPresetDialog.presetLocalId);
                        loadCameraContext(cameraIdForPage);
                    }
                    if (reason === "cancelled" && newPresetDialog) removeLocalPresetDraft(newPresetDialog.cameraId, newPresetDialog.presetLocalId);
                    setNewPresetDialog(null);
                }
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $14f558c545bbd811$export$1a23eafc8f50ba44), {
                popOutEditorDialogOpen: popOutEditorDialogOpen,
                setPopOutEditorDialogOpen: setPopOutEditorDialogOpen
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "bg-actuate-grey absolute w-full h-full overflow-scroll",
                children: !pageLoading && allCamerasData[0] && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: !navBarCollapsed ? "absolute top-[15px] left-[150px] right-[1px] h-[59px] bg-white" : "absolute top-[15px] left-[75px] right-[1px] h-[59px] bg-white",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $lukvk.IgnoreZonesBreadCrumbs), {
                                    linksArray: (0, $h0DCc.createIgnoreZonesLinksArray)(breadcrumbs),
                                    handleSitesBreadcrumbClick: handleSitesBreadcrumbClick,
                                    handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick,
                                    styling: "absolute top-[15px] left-[30px]"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "absolute top-[10px] right-[100px]",
                                    children: !ignorezoneEditorVisible && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8ZARq.EditViewSyncButton), {
                                        navigate: navigate
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: !navBarCollapsed ? "absolute top-[87px] left-[150px] right-[1px] h-[58px] bg-white" : "absolute top-[87px] left-[75px] right-[1px] h-[58px] bg-white",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "font-black font-mulish text-[20px] p-3 indent-4",
                                children: localStorage.currentCamera
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "absolute top-[97px] right-[100px]",
                            children: !ignorezoneEditorVisible && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    if (flexIzActive) {
                                        const dirty = (0, $e107f9de0defb7bd$export$b202a0d03f39c35f)((0, $e107f9de0defb7bd$export$d7977cd6169b1e95)(flexPresetsForCamera), flexZonesBaseline);
                                        (0, $e89cf803e1812a77$export$b85949d1ee902d15)({
                                            cameraId: cameraIdForPage,
                                            customerId: siteId,
                                            dirtyPresetLocalIds: dirty,
                                            flexZonesBaseline: flexZonesBaseline,
                                            navigate: navigate,
                                            setPageLoading: setPageLoading
                                        });
                                        return;
                                    }
                                    (0, $ba9bf15a0210b580$export$d318419605bae6b2)(visibleIgnoreZones, navigate, setPageLoading);
                                },
                                text: "Submit Changes",
                                disabled: flexIzActive ? !flexHasUnsavedChanges : !editsMade
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: !navBarCollapsed ? "absolute top-[145px] left-[150px] right-[1px] h-full bg-white" : "absolute top-[145px] left-[75px] right-[1px] h-full bg-white",
                            children: [
                                !ignorezoneEditorVisible && allCamerasData.length > 1 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "pt-[200px] w-[40px]",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                        title: `Previous Camera: ${cameraIndex === 0 ? allCamerasData[allCamerasData.length - 1].camera_name : allCamerasData[cameraIndex - 1].camera_name}`,
                                        placement: "top",
                                        sx: {
                                            fontSize: "12px",
                                            fontFamily: "mulish"
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                onClick: ()=>{
                                                    localStorage.setItem("currentCamera", cameraIndex === 0 ? allCamerasData[allCamerasData.length - 1].camera_name : allCamerasData[cameraIndex - 1].camera_name);
                                                    (0, $a6067036be07cb5d$export$e3b257868d26b4e)(setBreadCrumbs, setVisibleIgnoreZones, setIgnorezoneEditorVisible, setSelectedIgnoreZone, setEditsMade, setPageLoading, setDimensions, setAllCamerasData, setCameraIndex);
                                                    setFlexZonesBaseline({});
                                                    setSelectedFlexPresetLocalId("");
                                                    if (cameraIndex === 0) {
                                                        navigate(`/sites/${siteId}/editcamera/${allCamerasData[allCamerasData.length - 1].id}/editignorezones`);
                                                        beginEditIgnoreZonesReload();
                                                        (0, $2hXui.getAllCameras)(Number((0, $a8BPe.getNumbersAfterSites)(location.href)), Number((0, $a8BPe.getNumbersAfterEditCamera)(location.href)), setAllCamerasData, setCameraIndex);
                                                    } else {
                                                        navigate(`/sites/${siteId}/editcamera/${allCamerasData[cameraIndex - 1].id}/editignorezones`);
                                                        beginEditIgnoreZonesReload();
                                                        (0, $2hXui.getAllCameras)(Number((0, $a8BPe.getNumbersAfterSites)(location.href)), Number((0, $a8BPe.getNumbersAfterEditCamera)(location.href)), setAllCamerasData, setCameraIndex);
                                                    }
                                                },
                                                text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($frXOV))), {
                                                    fontSize: "large",
                                                    id: "backButton"
                                                }),
                                                disabled: allCamerasData.length < 2
                                            })
                                        })
                                    })
                                }),
                                !ignorezoneEditorVisible && allCamerasData.length > 1 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "absolute top-[200px] left-[1250px]",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                        title: `Next Camera: ${cameraIndex + 1 === allCamerasData.length ? allCamerasData[0].camera_name : allCamerasData[cameraIndex + 1].camera_name}`,
                                        placement: "top",
                                        sx: {
                                            fontSize: "12px",
                                            fontFamily: "mulish"
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                onClick: ()=>{
                                                    localStorage.setItem("currentCamera", cameraIndex + 1 === allCamerasData.length ? allCamerasData[0].camera_name : allCamerasData[cameraIndex + 1].camera_name);
                                                    (0, $a6067036be07cb5d$export$e3b257868d26b4e)(setBreadCrumbs, setVisibleIgnoreZones, setIgnorezoneEditorVisible, setSelectedIgnoreZone, setEditsMade, setPageLoading, setDimensions, setAllCamerasData, setCameraIndex);
                                                    setFlexZonesBaseline({});
                                                    setSelectedFlexPresetLocalId("");
                                                    if (cameraIndex + 1 === allCamerasData.length) {
                                                        navigate(`/sites/${siteId}/editcamera/${allCamerasData[0].id}/editignorezones`);
                                                        beginEditIgnoreZonesReload();
                                                        (0, $2hXui.getAllCameras)(Number((0, $a8BPe.getNumbersAfterSites)(location.href)), Number((0, $a8BPe.getNumbersAfterEditCamera)(location.href)), setAllCamerasData, setCameraIndex);
                                                    } else {
                                                        navigate(`/sites/${siteId}/editcamera/${allCamerasData[cameraIndex + 1].id}/editignorezones`);
                                                        beginEditIgnoreZonesReload();
                                                        (0, $2hXui.getAllCameras)(Number((0, $a8BPe.getNumbersAfterSites)(location.href)), Number((0, $a8BPe.getNumbersAfterEditCamera)(location.href)), setAllCamerasData, setCameraIndex);
                                                    }
                                                },
                                                text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2qUoo))), {
                                                    fontSize: "large",
                                                    id: "backButton"
                                                }),
                                                disabled: allCamerasData.length < 2
                                            })
                                        })
                                    })
                                }),
                                !ignorezoneEditorVisible && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: !navBarCollapsed ? "overflow-auto absolute left-[855px] top-[75px] min-h-[360px] w-[305px]" : "overflow-auto absolute left-[855px] top-[75px] min-h-[360px] w-[305px]",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "absolute left-[0px] top-[0px] w-[275px]",
                                            children: zonesForSidebarList.map((object)=>{
                                                return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                    role: "button",
                                                    onClick: ()=>{
                                                        if (flexIzActive) {
                                                            handleFlexSidebarZoneClick(object);
                                                            return;
                                                        }
                                                        setSelectedIgnoreZone(object.label);
                                                        handleIgnoreZoneClick(object);
                                                        setLargerMode(false);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                            style: {
                                                                height: 25,
                                                                width: 6,
                                                                background: `${object.line_color}`
                                                            },
                                                            className: "absolute"
                                                        }, object.label),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                            className: "font-mulish text-[16px] indent-5",
                                                            children: object.label_display_name
                                                        }),
                                                        "\xa0"
                                                    ]
                                                }, object.label);
                                            })
                                        })
                                    })
                                }),
                                !pageLoading && !ignorezoneEditorVisible && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "absolute top-[13px] left-[70px] z-[1] flex flex-col gap-2 items-start",
                                    children: [
                                        flexIzActive && selectedFlexPresetLocalId && selectedFlexPresetLocalId !== (0, $9s9JO.FLEX_IZ_NO_IGNORE_ZONES_OPTION) && selectedFlexPreset && /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                            variant: "standard",
                                            label: "Preset name",
                                            size: "small",
                                            value: selectedFlexPreset.name ?? "",
                                            onChange: (e)=>updatePresetName(cameraIdForPage, selectedFlexPresetLocalId, e.target.value, true),
                                            sx: {
                                                paddingBottom: "20px",
                                                width: presetNameFieldWidth,
                                                "& .MuiInputBase-input": {
                                                    fontFamily: "Mulish"
                                                },
                                                "& .MuiInputLabel-root": {
                                                    fontFamily: "Mulish"
                                                }
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $a2fXs.IgnoreZonePreviewHoverLayer), {
                                            className: "relative",
                                            zones: visibleIgnoreZones,
                                            enabled: !ignorezoneEditorVisible && !pageLoading && visibleIgnoreZones.length > 0,
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                                                    src: JSON.parse(localStorage.preview_url),
                                                    style: {
                                                        width: `${adjustedDimensions.x}px`,
                                                        height: `${adjustedDimensions.y}px`
                                                    },
                                                    onLoad: handleImageLoad,
                                                    alt: "TestCameraPhoto"
                                                }),
                                                !ignorezoneEditorVisible && visibleIgnoreZones.map((object)=>{
                                                    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "absolute top-[0px]",
                                                        children: object.coordinates[0] && object.coordinates.map((array, index)=>{
                                                            return /*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                                                                className: "absolute top-[0px]",
                                                                style: {
                                                                    width: `${adjustedDimensions.x}px`,
                                                                    height: `${adjustedDimensions.y}px`
                                                                },
                                                                children: dimensions && /*#__PURE__*/ (0, $k4ank.jsx)("polygon", {
                                                                    points: (0, $QUu0n.pointsCreator)(object.coordinates[index], adjustedDimensions.y, adjustedDimensions.x),
                                                                    stroke: object.line_color,
                                                                    strokeWidth: "5",
                                                                    fill: object.line_color,
                                                                    fillOpacity: "50%"
                                                                })
                                                            }, index);
                                                        })
                                                    }, object.label);
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: ignorezoneEditorVisible ? "player pointer-events-auto absolute top-[0px] left-[67px] z-[2] w-[775px] h-[200px]" : "player pointer-events-none absolute top-[0px] left-[67px] z-0 w-[775px] h-[200px]",
                                    role: "button",
                                    tabIndex: ignorezoneEditorVisible ? 0 : -1,
                                    children: // <ZwibblerComponent />
                                    // <IgnoreZoneBuilder
                                    //   shapeColor={localStorage.ignoreZoneColor}
                                    //   height={adjustedDimensions.y}
                                    //   width={adjustedDimensions.x}
                                    //   imageURL={JSON.parse(localStorage.preview_url)}
                                    //   shapesArray={transformCoordinates(
                                    //     JSON.parse(localStorage.ignoreZones)
                                    //   )}
                                    //   setIgnorezoneEditorVisible={setIgnorezoneEditorVisible}
                                    //   setEditsMade={setEditsMade}
                                    //   visibleIgnoreZones={visibleIgnoreZones}
                                    //   selectedIgnoreZone={selectedIgnoreZone}
                                    //   setVisibleIgnoreZones={setVisibleIgnoreZones}
                                    //   largerMode={largerMode}
                                    //   setLargerMode={setLargerMode}
                                    //   dimensions={dimensions}
                                    // />
                                    iZBuilder
                                })
                            ]
                        }),
                        !ignorezoneEditorVisible && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: !navBarCollapsed ? "absolute top-[130px] left-[980px] w-[420px] font-mulish text-[18px] text-actuate-blue" : "absolute top-[130px] left-[905px] w-[420px] font-mulish text-[18px] text-actuate-blue",
                            children: [
                                flexIzActive && (flexCameraCtx?.loading ? /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "font-mulish text-[12px] text-gray-600 py-[4px]",
                                    children: "Loading presets\u2026"
                                }) : /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                                    fullWidth: true,
                                    size: "small",
                                    sx: {
                                        maxWidth: 360,
                                        mt: "4px",
                                        mb: "12px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $6gU8O.default), {
                                            id: "flex-iz-preset-label-edit-iz",
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            children: "Preset"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $2eEqG.default), {
                                            labelId: "flex-iz-preset-label-edit-iz",
                                            label: "Preset",
                                            value: selectedFlexPresetLocalId || "",
                                            onChange: (e)=>handleFlexPresetSelectChange(String(e.target.value)),
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            children: [
                                                flexPresetMenuPresets.length === 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                    disabled: true,
                                                    value: "",
                                                    sx: {
                                                        fontFamily: "Mulish"
                                                    },
                                                    children: "No presets available"
                                                }),
                                                flexPresetMenuPresets.map((preset)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                        value: preset.localId,
                                                        sx: {
                                                            fontFamily: "Mulish"
                                                        },
                                                        children: preset.name
                                                    }, preset.localId)),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                    value: (0, $9s9JO.FLEX_IZ_CREATE_NEW_PRESET_OPTION),
                                                    sx: {
                                                        color: "#FF8400",
                                                        fontFamily: "Mulish",
                                                        fontWeight: 700
                                                    },
                                                    children: "+ CREATE NEW PRESET"
                                                })
                                            ]
                                        })
                                    ]
                                })),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "mt-[4px]",
                                    children: "\xa0 Click the Ignore Zone below you'd like to edit."
                                })
                            ]
                        }),
                        ignorezoneEditorVisible && !largerMode && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: !navBarCollapsed ? "absolute top-[172px] left-[1020px] font-mulish text-[20px] text-actuate-blue min-w-[470px] pr-[40px]" : "absolute top-[172px] left-[945px] font-mulish text-[20px] text-actuate-blue min-w-[500px] pr-[40px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "font-bold text-[17px]",
                                    children: "INSTRUCTIONS:"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "font-normal text-[17px] ",
                                    children: "To begin creating a shape click anywhere on the image to start adding points."
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "font-normal text-[17px]",
                                    children: "To finish creating a shape, click on the first point created."
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "font-normal text-[17px]",
                                    children: "To modify the shape click and drag the points to the desired location."
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "font-normal text-[17px]",
                                    children: "To add additional points to the shape, click on the line between two points."
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "font-normal text-[17px]",
                                    children: "To create an additional shape, click anywhere on the image to start adding points."
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "font-normal text-[17px]",
                                    children: "To delete a shape hover anywhere over the shape and click to select. Then press the delete key on your keyboard."
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "font-normal text-[17px]",
                                    children: "To delete a single point double click on the point. This action will only work if the remaining shape will have at least 3 points."
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "justify-start",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jVN1H.NavBar), {
                    navBarCollapsed: navBarCollapsed,
                    setNavBarCollapsed: setNavBarCollapsed,
                    props: {}
                })
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $cVCJe = parcelRequire("cVCJe");

var $frXOV = parcelRequire("frXOV");

var $2qUoo = parcelRequire("2qUoo");

var $jVN1H = parcelRequire("jVN1H");

var $dHtmK = parcelRequire("dHtmK");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");

var $2hXui = parcelRequire("2hXui");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $j0ZEU = parcelRequire("j0ZEU");

var $3IuQ3 = parcelRequire("3IuQ3");

var $f3puC = parcelRequire("f3puC");

var $5GP2e = parcelRequire("5GP2e");

var $eXOoR = parcelRequire("eXOoR");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");
const $711135323e7a9623$export$68a908f34f47ac33 = ({ linksArray: linksArray, cameraName: cameraName, handleSitesBreadcrumbClick: handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick, styling: styling })=>{
    const navigate = (0, $3T949.useNavigate)();
    const handleCameraBreadcrumbClick = (event)=>{
        event.preventDefault();
        navigate(`/sites/${(0, $a8BPe.getNumbersAfterSites)(location.href)}/editcamera/${(0, $a8BPe.getNumbersAfterEditCamera)(location.href)}`);
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3IuQ3.default), {
        spacing: 2,
        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
            className: styling,
            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $j0ZEU.default), {
                separator: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXOoR))), {
                    fontSize: "medium"
                }),
                "aria-label": "breadcrumb",
                children: [
                    linksArray.map((object, index)=>{
                        if (index === 0) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                            underline: "hover",
                            color: "inherit",
                            href: "/sites",
                            sx: {
                                fontSize: "18px",
                                fontFamily: "Mulish",
                                fontWeight: "bold",
                                cursor: "pointer"
                            },
                            variant: "h5",
                            onClick: handleSitesBreadcrumbClick,
                            children: object.name
                        }, object.name);
                        if (index === linksArray.length - 1) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                            underline: "hover",
                            color: "inherit",
                            sx: {
                                fontSize: "18px",
                                fontFamily: "Mulish",
                                fontWeight: "bold",
                                cursor: "pointer"
                            },
                            variant: "h5",
                            onClick: handleSingularSiteBreadcrumbClick,
                            children: object.name
                        }, object.name);
                        return null;
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                        underline: "hover",
                        color: "inherit",
                        sx: {
                            fontSize: "18px",
                            fontFamily: "Mulish",
                            fontWeight: "bold",
                            cursor: "pointer"
                        },
                        variant: "h5",
                        onClick: handleCameraBreadcrumbClick,
                        children: cameraName
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        color: "text.primary",
                        fontSize: "18px",
                        fontFamily: "Mulish",
                        fontWeight: "bold",
                        children: "Ignore Zones"
                    })
                ]
            })
        })
    });
};
const $711135323e7a9623$export$239ff243aaf842dd = (pushedArray)=>{
    const linksArray = [
        {
            name: "Sites"
        }
    ];
    pushedArray.forEach((name)=>{
        linksArray.push({
            name: name
        });
    });
    return linksArray;
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $QUu0n = parcelRequire("QUu0n");

var $9OjAn = parcelRequire("9OjAn");

var $83bsI = parcelRequire("83bsI");

var $83bsI = parcelRequire("83bsI");
const $401d26e92c33e792$export$83a87b0fc434a4d8 = (apiRows)=>{
    const labeled = (0, $83bsI.addIgnoreLabel)(apiRows);
    return labeled.filter((row)=>Number(row.zone_type) !== 0).map((row)=>({
            metricId: Number(row.metric_id),
            label: row.label,
            labelDisplayName: row.label_display_name,
            zoneType: Number(row.zone_type)
        }));
};
const $401d26e92c33e792$export$75907d7f23296bf8 = (metrics)=>metrics.map((m)=>m.metricId);
const $401d26e92c33e792$export$d219289ec58eb5d = (assignment, availableMetrics)=>{
    if (assignment.isIgnoreAll) return availableMetrics.map((m)=>m.labelDisplayName);
    const idSet = new Set(assignment.metricIds);
    return availableMetrics.filter((m)=>idSet.has(m.metricId)).map((m)=>m.labelDisplayName);
};



var $aHe9T = parcelRequire("aHe9T");
const $ea82079335c00742$export$9e6be2d8340c154b = (usedColors)=>{
    for (const color of (0, $aHe9T.metadataTagZonesColorArray)){
        if (!usedColors.includes(color)) return color;
    }
    return (0, $aHe9T.metadataTagZonesColorArray)[usedColors.length % (0, $aHe9T.metadataTagZonesColorArray).length];
};


const $7a972a45ab470387$var$hasCoordinates = (coordinates)=>{
    if (!Array.isArray(coordinates) || coordinates.length === 0) return false;
    const polygons = coordinates;
    return polygons.some((polygon)=>Array.isArray(polygon) && polygon.length >= 3);
};
const $7a972a45ab470387$var$normalizeCoordinates = (coordinates)=>JSON.stringify(coordinates);
const $7a972a45ab470387$var$createLocalId = ()=>`assignment-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
const $7a972a45ab470387$export$303478e668e5630a = (apiRows)=>{
    const labeledRows = (0, $83bsI.addIgnoreLabel)(apiRows);
    const availableMetrics = (0, $401d26e92c33e792$export$83a87b0fc434a4d8)(labeledRows);
    const allMetricIds = (0, $401d26e92c33e792$export$75907d7f23296bf8)(availableMetrics);
    const fingerprints = new Map();
    const usedColors = new Set();
    labeledRows.forEach((row)=>{
        if (!$7a972a45ab470387$var$hasCoordinates(row.coordinates)) return;
        const isIgnoreAll = Number(row.zone_type) === 0;
        const metricIds = isIgnoreAll ? [
            ...allMetricIds
        ] : [
            Number(row.metric_id)
        ];
        const coordinatesKey = $7a972a45ab470387$var$normalizeCoordinates(row.coordinates);
        const metricIdsKey = [
            ...metricIds
        ].sort((a, b)=>a - b).join(",");
        const fingerprintKey = `${row.line_color}|${coordinatesKey}|${metricIdsKey}`;
        const existing = fingerprints.get(fingerprintKey);
        if (existing) {
            if (!existing.sourceApiLabels.includes(row.label)) existing.sourceApiLabels.push(row.label);
            return;
        }
        let color = row.line_color;
        if (usedColors.has(color)) color = (0, $ea82079335c00742$export$9e6be2d8340c154b)([
            ...usedColors
        ]);
        usedColors.add(color);
        fingerprints.set(fingerprintKey, {
            color: color,
            coordinatesKey: coordinatesKey,
            metricIdsKey: metricIdsKey,
            coordinates: JSON.parse(coordinatesKey),
            metricIds: metricIds,
            isIgnoreAll: isIgnoreAll,
            sourceApiLabels: [
                row.label
            ]
        });
    });
    return [
        ...fingerprints.values()
    ].map((entry, index)=>({
            localId: $7a972a45ab470387$var$createLocalId(),
            name: `Zone ${index + 1}`,
            color: entry.color,
            coordinates: entry.coordinates,
            metricIds: entry.metricIds,
            isIgnoreAll: entry.isIgnoreAll,
            sourceApiLabels: entry.sourceApiLabels
        }));
};




var $195EM = parcelRequire("195EM");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");

var $83bsI = parcelRequire("83bsI");

const $7f4d1fd4e99cfa90$export$46fed5ffe0672ffe = (frameDimensions)=>{
    if (!frameDimensions) return {
        x: 720,
        y: 576
    };
    const [width, height] = frameDimensions.split(" x ").map(Number);
    if (!width || !height) return {
        x: 720,
        y: 576
    };
    const aspectRatio = height / width;
    return {
        x: 720,
        y: Math.round(720 * aspectRatio)
    };
};
const $7f4d1fd4e99cfa90$export$4634b1ea022db412 = (coordinates, width, height)=>coordinates.map((polygon)=>polygon.map(([x, y])=>[
                x * width,
                y * height
            ]));
const $7f4d1fd4e99cfa90$export$3d9204f92c3e5573 = (coordinates, width, height)=>coordinates.map((polygon)=>polygon.map(([x, y])=>[
                x / width,
                y / height
            ]));
const $7f4d1fd4e99cfa90$export$62fca67a46b19555 = (assignments)=>assignments.filter((a)=>a.coordinates.length > 0).map((assignment)=>({
            label: assignment.localId,
            line_color: assignment.color,
            coordinates: assignment.coordinates
        }));


const $60538f3b719dc8e3$export$3e641c5b29dba6aa = async ()=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const cameraId = (0, $a8BPe.getNumbersAfterEditCamera)(location.href);
    const siteId = (0, $a8BPe.getNumbersAfterSites)(location.href);
    const statusResponse = await AxiosUI.get(`/camera/${cameraId}/status/`);
    const dimensions = (0, $f3f7f2b4dd3477d9$export$628303c6555cdbbe)(statusResponse.data.frame_dimensions);
    const adjustedDimensions = (0, $7f4d1fd4e99cfa90$export$46fed5ffe0672ffe)(statusResponse.data.frame_dimensions);
    const previewUrl = statusResponse.data.preview_url;
    let cameraName = statusResponse.data.camera_name;
    const ignoreZonesResponse = await AxiosUI.get(`/camera/${cameraId}/ignore_zones/`);
    const apiRows = (0, $83bsI.addIgnoreLabel)(ignoreZonesResponse.data);
    const aboutResponse = await AxiosUI.get(`customer/${siteId}/about/`);
    if (!cameraName) {
        const generalInfoResponse = await AxiosUI.get(`/camera/${cameraId}/general_info/`);
        cameraName = generalInfoResponse.data.camera_name;
    }
    return {
        previewUrl: previewUrl,
        cameraName: cameraName,
        dimensions: dimensions,
        adjustedDimensions: adjustedDimensions,
        breadcrumbs: aboutResponse.data.breadcrumbs,
        apiRows: apiRows
    };
};
const $60538f3b719dc8e3$export$96f7e6db4105d70c = (error)=>error?.isAxiosError === true;



const $0d1179c88acc7707$export$3baa4d956fb592e9 = (zoneNumber)=>`Zone ${zoneNumber}`;
const $0d1179c88acc7707$export$9b6d6e3946833368 = (name)=>{
    if (name == null) return null;
    const match = name.trim().match(/^Zone\s+(\d+)$/i);
    return match ? Number(match[1]) : null;
};
const $0d1179c88acc7707$export$c1fb7691731bec1e = (assignments, excludeLocalId)=>{
    let max = 0;
    assignments.forEach((assignment)=>{
        if (excludeLocalId && assignment.localId === excludeLocalId) return;
        const zoneNumber = $0d1179c88acc7707$export$9b6d6e3946833368(assignment.name);
        if (zoneNumber !== null && zoneNumber > max) max = zoneNumber;
    });
    return max + 1;
};
const $0d1179c88acc7707$export$be2a3a41e8b0b176 = (name, assignments, localId)=>{
    const trimmed = (name ?? "").trim();
    if (trimmed) return trimmed;
    return $0d1179c88acc7707$export$3baa4d956fb592e9($0d1179c88acc7707$export$c1fb7691731bec1e(assignments, localId));
};
const $0d1179c88acc7707$export$a2ed851128e4c4ea = (assignments)=>assignments.map((assignment, index)=>({
            ...assignment,
            name: assignment.name?.trim() || $0d1179c88acc7707$export$3baa4d956fb592e9(index + 1)
        }));




var $3Zv1D = parcelRequire("3Zv1D");
const $d1c6a111b10a5885$var$createLocalId = ()=>`assignment-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
const $d1c6a111b10a5885$var$cloneAssignment = (assignment)=>JSON.parse(JSON.stringify(assignment));
const $d1c6a111b10a5885$var$cloneEditSession = (session)=>JSON.parse(JSON.stringify(session));
const $d1c6a111b10a5885$var$emptyEditSession = ()=>({
        localId: "",
        name: "",
        color: "",
        coordinates: [],
        metricIds: [],
        isIgnoreAll: false,
        isNew: false
    });
const $d1c6a111b10a5885$var$initialState = {
    pageLoading: true,
    breadcrumbs: [],
    cameraName: "",
    previewUrl: "",
    dimensions: {
        width: 640,
        height: 360
    },
    adjustedDimensions: {
        x: 720,
        y: 576
    },
    apiRows: [],
    availableMetrics: [],
    assignments: [],
    editorVisible: false,
    selectedAssignmentLocalId: null,
    editSession: null,
    editSessionSnapshot: null,
    shapesArray: [],
    editsMade: false,
    saveValidationError: ""
};
const $d1c6a111b10a5885$export$9bf4593fa0eca1d3 = (0, $9OjAn.create)((set, get)=>({
        ...$d1c6a111b10a5885$var$initialState,
        resetStore: ()=>set({
                ...$d1c6a111b10a5885$var$initialState
            }),
        getNewIgnoreZonesPageInfo: async (navigate)=>{
            set({
                pageLoading: true,
                saveValidationError: ""
            });
            const retry = ()=>{
                get().getNewIgnoreZonesPageInfo(navigate);
            };
            try {
                const data = await (0, $60538f3b719dc8e3$export$3e641c5b29dba6aa)();
                const availableMetrics = (0, $401d26e92c33e792$export$83a87b0fc434a4d8)(data.apiRows);
                const assignments = (0, $0d1179c88acc7707$export$a2ed851128e4c4ea)((0, $7a972a45ab470387$export$303478e668e5630a)(data.apiRows));
                set({
                    pageLoading: false,
                    previewUrl: data.previewUrl,
                    cameraName: data.cameraName,
                    dimensions: data.dimensions,
                    adjustedDimensions: data.adjustedDimensions,
                    breadcrumbs: data.breadcrumbs,
                    apiRows: data.apiRows,
                    availableMetrics: availableMetrics,
                    assignments: assignments,
                    editorVisible: false,
                    selectedAssignmentLocalId: null,
                    editSession: null,
                    editSessionSnapshot: null,
                    shapesArray: [],
                    editsMade: false,
                    saveValidationError: ""
                });
            } catch (error) {
                set({
                    pageLoading: false
                });
                if ((0, $60538f3b719dc8e3$export$96f7e6db4105d70c)(error)) (0, $3Zv1D.universalAPIErrorHandler)(error, navigate, retry, ()=>{
                    alert("Error loading ignore zones, please try again");
                });
                else {
                    console.error(error);
                    alert("Error loading ignore zones, please try again");
                }
            }
        },
        openEditAssignment: (localId)=>{
            const assignment = get().assignments.find((a)=>a.localId === localId);
            if (!assignment) return;
            const { adjustedDimensions: adjustedDimensions } = get();
            const assignmentIndex = get().assignments.findIndex((a)=>a.localId === localId);
            const session = {
                localId: assignment.localId,
                name: assignment.name?.trim() || (0, $0d1179c88acc7707$export$3baa4d956fb592e9)(Math.max(assignmentIndex + 1, 1)),
                color: assignment.color,
                coordinates: $d1c6a111b10a5885$var$cloneAssignment(assignment).coordinates,
                metricIds: [
                    ...assignment.metricIds
                ],
                isIgnoreAll: assignment.isIgnoreAll,
                isNew: false
            };
            const shapesArray = (0, $7f4d1fd4e99cfa90$export$4634b1ea022db412)(session.coordinates, adjustedDimensions.x, adjustedDimensions.y);
            set({
                editorVisible: true,
                selectedAssignmentLocalId: localId,
                editSession: session,
                editSessionSnapshot: $d1c6a111b10a5885$var$cloneEditSession(session),
                shapesArray: shapesArray,
                saveValidationError: ""
            });
        },
        openNewAssignment: ()=>{
            const { assignments: assignments } = get();
            const usedColors = assignments.map((a)=>a.color);
            const color = (0, $ea82079335c00742$export$9e6be2d8340c154b)(usedColors);
            const localId = $d1c6a111b10a5885$var$createLocalId();
            const session = {
                localId: localId,
                name: (0, $0d1179c88acc7707$export$3baa4d956fb592e9)((0, $0d1179c88acc7707$export$c1fb7691731bec1e)(assignments)),
                color: color,
                coordinates: [],
                metricIds: [],
                isIgnoreAll: false,
                isNew: true
            };
            set({
                editorVisible: true,
                selectedAssignmentLocalId: localId,
                editSession: session,
                editSessionSnapshot: $d1c6a111b10a5885$var$cloneEditSession(session),
                shapesArray: [],
                saveValidationError: ""
            });
        },
        updateEditSessionColor: (color)=>{
            const { editSession: editSession } = get();
            if (!editSession) return;
            set({
                editSession: {
                    ...editSession,
                    color: color
                },
                editsMade: true,
                saveValidationError: ""
            });
        },
        updateEditSessionName: (name)=>{
            const { editSession: editSession } = get();
            if (!editSession) return;
            set({
                editSession: {
                    ...editSession,
                    name: name
                },
                editsMade: true,
                saveValidationError: ""
            });
        },
        setEditSessionIgnoreAll: (checked)=>{
            const { editSession: editSession, availableMetrics: availableMetrics } = get();
            if (!editSession) return;
            const allMetricIds = (0, $401d26e92c33e792$export$75907d7f23296bf8)(availableMetrics);
            set({
                editSession: {
                    ...editSession,
                    isIgnoreAll: checked,
                    metricIds: checked ? allMetricIds : []
                },
                editsMade: true,
                saveValidationError: ""
            });
        },
        toggleEditSessionMetric: (metricId, checked)=>{
            const { editSession: editSession, availableMetrics: availableMetrics } = get();
            if (!editSession) return;
            let metricIds = [
                ...editSession.metricIds
            ];
            if (checked) {
                if (!metricIds.includes(metricId)) metricIds.push(metricId);
            } else metricIds = metricIds.filter((id)=>id !== metricId);
            const allMetricIds = (0, $401d26e92c33e792$export$75907d7f23296bf8)(availableMetrics);
            const isIgnoreAll = allMetricIds.length > 0 && allMetricIds.every((id)=>metricIds.includes(id));
            set({
                editSession: {
                    ...editSession,
                    metricIds: metricIds,
                    isIgnoreAll: isIgnoreAll
                },
                editsMade: true,
                saveValidationError: ""
            });
        },
        setShapesArray: (shapesArray)=>{
            set({
                shapesArray: shapesArray,
                editsMade: true,
                saveValidationError: ""
            });
        },
        saveEditSession: ()=>{
            const { editSession: editSession, shapesArray: shapesArray, assignments: assignments, adjustedDimensions: adjustedDimensions, availableMetrics: availableMetrics } = get();
            if (!editSession) return false;
            const hasMetrics = editSession.isIgnoreAll || editSession.metricIds.length > 0;
            if (!hasMetrics) {
                set({
                    saveValidationError: "Select at least one product or Ignore All before saving."
                });
                return false;
            }
            const normalizedCoordinates = (0, $7f4d1fd4e99cfa90$export$3d9204f92c3e5573)(shapesArray, adjustedDimensions.x, adjustedDimensions.y);
            if (normalizedCoordinates.length === 0) {
                set({
                    saveValidationError: "Draw at least one ignore zone shape before saving."
                });
                return false;
            }
            const existingIndex = assignments.findIndex((a)=>a.localId === editSession.localId);
            const updatedAssignment = {
                localId: editSession.localId,
                name: (0, $0d1179c88acc7707$export$be2a3a41e8b0b176)(editSession.name, assignments, editSession.localId),
                color: editSession.color,
                coordinates: normalizedCoordinates,
                metricIds: editSession.isIgnoreAll ? (0, $401d26e92c33e792$export$75907d7f23296bf8)(availableMetrics) : [
                    ...editSession.metricIds
                ],
                isIgnoreAll: editSession.isIgnoreAll,
                sourceApiLabels: existingIndex >= 0 ? assignments[existingIndex].sourceApiLabels : []
            };
            const nextAssignments = [
                ...assignments
            ];
            if (existingIndex >= 0) nextAssignments[existingIndex] = updatedAssignment;
            else nextAssignments.push(updatedAssignment);
            set({
                assignments: nextAssignments,
                editorVisible: false,
                selectedAssignmentLocalId: null,
                editSession: null,
                editSessionSnapshot: null,
                shapesArray: [],
                editsMade: true,
                saveValidationError: ""
            });
            return true;
        },
        cancelEditSession: ()=>{
            set({
                editorVisible: false,
                selectedAssignmentLocalId: null,
                editSession: null,
                editSessionSnapshot: null,
                shapesArray: [],
                saveValidationError: ""
            });
        },
        deleteAssignment: (localId)=>{
            const { assignments: assignments, selectedAssignmentLocalId: selectedAssignmentLocalId, editorVisible: editorVisible } = get();
            const nextAssignments = assignments.filter((assignment)=>assignment.localId !== localId);
            if (editorVisible && selectedAssignmentLocalId === localId) {
                set({
                    assignments: nextAssignments,
                    editorVisible: false,
                    selectedAssignmentLocalId: null,
                    editSession: null,
                    editSessionSnapshot: null,
                    shapesArray: [],
                    editsMade: true,
                    saveValidationError: ""
                });
                return;
            }
            set({
                assignments: nextAssignments,
                editsMade: true
            });
        },
        getUsedColors: (excludeLocalId)=>{
            const { assignments: assignments } = get();
            return assignments.filter((a)=>a.localId !== excludeLocalId).map((a)=>a.color);
        }
    }));



const $8a6539c8bfc9779b$export$fd11aa13a8052277 = ()=>{
    const previewUrl = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.previewUrl);
    const assignments = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.assignments);
    const adjustedDimensions = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.adjustedDimensions);
    const dimensions = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.dimensions);
    const previewZones = $8T3gX.useMemo(()=>(0, $7f4d1fd4e99cfa90$export$62fca67a46b19555)(assignments), [
        assignments
    ]);
    if (!previewUrl) return null;
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                src: previewUrl,
                style: {
                    width: `${adjustedDimensions.x}px`,
                    height: `${adjustedDimensions.y}px`
                },
                alt: "Camera preview"
            }),
            previewZones.map((zone)=>/*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "absolute top-0 left-0",
                    children: zone.coordinates.map((polygon, index)=>/*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                            className: "absolute top-0 left-0",
                            style: {
                                width: `${adjustedDimensions.x}px`,
                                height: `${adjustedDimensions.y}px`
                            },
                            children: dimensions && /*#__PURE__*/ (0, $k4ank.jsx)("polygon", {
                                points: (0, $QUu0n.pointsCreator)(polygon, adjustedDimensions.y, adjustedDimensions.x),
                                stroke: zone.line_color,
                                strokeWidth: "5",
                                fill: zone.line_color,
                                fillOpacity: "50%"
                            })
                        }, `${zone.label}-${index}`))
                }, zone.label))
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $6pdiI = parcelRequire("6pdiI");

var $ka01y = parcelRequire("ka01y");

var $cVCJe = parcelRequire("cVCJe");

var $8jTCz = parcelRequire("8jTCz");



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");
const $6cd35f5fc15eb54e$export$1574c9c543ee366a = ({ open: open, onCancel: onCancel, onConfirm: onConfirm })=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: open,
        onClose: onCancel,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "delete-ignore-zone-assignment-dialog",
                sx: {
                    fontFamily: "Mulish"
                },
                children: "Are you sure you'd like to delete this Ignore zone assignment?"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: onCancel,
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: onConfirm,
                        text: "Delete",
                        disabled: false
                    })
                ]
            })
        ]
    });


const $7107d7e25d2445a2$var$iconButtonSx = {
    minWidth: 0,
    px: "4px",
    py: "2px"
};
const $7107d7e25d2445a2$var$tooltipSx = {
    fontSize: "12px",
    fontFamily: "Mulish"
};
const $7107d7e25d2445a2$export$c946e0bc456f8b1 = ()=>{
    const assignments = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.assignments);
    const availableMetrics = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.availableMetrics);
    const openEditAssignment = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.openEditAssignment);
    const openNewAssignment = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.openNewAssignment);
    const deleteAssignment = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.deleteAssignment);
    const [assignmentToDelete, setAssignmentToDelete] = $8T3gX.useState(null);
    const visibleAssignments = assignments.filter((assignment)=>assignment.coordinates.length > 0);
    const handleConfirmDelete = ()=>{
        if (assignmentToDelete) deleteAssignment(assignmentToDelete);
        setAssignmentToDelete(null);
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "font-mulish text-actuate-blue",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "text-[18px] font-bold mb-[16px]",
                children: "Ignore Zone Assignments"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "flex flex-col gap-[16px] mt-[30px]",
                children: visibleAssignments.map((assignment)=>{
                    const labels = (0, $401d26e92c33e792$export$d219289ec58eb5d)(assignment, availableMetrics);
                    const zoneName = assignment.name || "Zone";
                    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "flex gap-[12px]",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "flex min-w-0 flex-1 gap-[12px]",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "mt-[6px] size-[18px] shrink-0 border border-actuate-blue",
                                        style: {
                                            backgroundColor: assignment.color
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "ml-[10px] flex min-w-0 flex-col",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                className: "text-[16px] font-bold leading-normal",
                                                children: zoneName
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                className: "text-[16px] leading-normal",
                                                children: labels.join(", ")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "flex shrink-0 self-start gap-[15px]",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                        title: `Edit ${zoneName}`,
                                        placement: "top",
                                        sx: $7107d7e25d2445a2$var$tooltipSx,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                "aria-label": `Edit ${zoneName}`,
                                                onClick: ()=>openEditAssignment(assignment.localId),
                                                text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {
                                                    fontSize: "small"
                                                }),
                                                disabled: false,
                                                sx: $7107d7e25d2445a2$var$iconButtonSx
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                        title: `Delete ${zoneName}`,
                                        placement: "top",
                                        sx: $7107d7e25d2445a2$var$tooltipSx,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                "aria-label": `Delete ${zoneName}`,
                                                onClick: ()=>setAssignmentToDelete(assignment.localId),
                                                text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ka01y))), {
                                                    fontSize: "small"
                                                }),
                                                disabled: false,
                                                sx: $7107d7e25d2445a2$var$iconButtonSx
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }, assignment.localId);
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "mt-[28px] ml-[15px]",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                    onClick: openNewAssignment,
                    text: "+ Add new ignore zone assignment",
                    disabled: false
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $6cd35f5fc15eb54e$export$1574c9c543ee366a), {
                open: assignmentToDelete !== null,
                onCancel: ()=>setAssignmentToDelete(null),
                onConfirm: handleConfirmDelete
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $eAYze = parcelRequire("eAYze");
/** Mouse coords from getBoundingClientRect; no CSS border on this canvas (outline only). */ function $a310b8d01e004f2d$var$getMouseCanvasCoords(e, canvas, imageWidth, imageHeight) {
    const rect = canvas.getBoundingClientRect();
    let mouseX = e.clientX - rect.left;
    let mouseY = e.clientY - rect.top;
    if (mouseX < 30) mouseX = 30;
    if (mouseX > imageWidth + 30) mouseX = imageWidth + 30;
    if (mouseY < 30) mouseY = 30;
    if (mouseY > imageHeight + 30) mouseY = imageHeight + 30;
    return [
        mouseX,
        mouseY
    ];
}
/** Preset / API zones may include empty or malformed coordinate pairs; skip them safely. */ function $a310b8d01e004f2d$var$isValidPolygonVertex(p) {
    return Array.isArray(p) && p.length >= 2 && typeof p[0] === "number" && typeof p[1] === "number" && Number.isFinite(p[0]) && Number.isFinite(p[1]);
}
function $a310b8d01e004f2d$var$isEditableElementFocused() {
    const active = document.activeElement;
    if (!active || !(active instanceof HTMLElement)) return false;
    const tag = active.tagName;
    if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return true;
    return active.isContentEditable;
}
const $a310b8d01e004f2d$export$d5f156ac08088eed = ({ initialPoints: initialPoints, shapes: shapes, shapeColor: shapeColor, setShapes: setShapes, imageHeight: imageHeight, imageWidth: imageWidth, setIZPolygonPoints: setIZPolygonPoints })=>{
    const canvasRef = (0, $8T3gX.useRef)(null);
    const [polygonPoints, setPolygonPoints] = (0, $8T3gX.useState)(initialPoints[0] ? initialPoints : []);
    const [drawing, setDrawing] = (0, $8T3gX.useState)(false);
    const [closed, setClosed] = (0, $8T3gX.useState)(initialPoints[0] ? true : false);
    const [dragging, setDragging] = (0, $8T3gX.useState)(false);
    const [selectedPointIndex, setSelectedPointIndex] = (0, $8T3gX.useState)(null);
    const [hoveredPointIndex, setHoveredPointIndex] = (0, $8T3gX.useState)(null);
    const [hoveredLineIndex, setHoveredLineIndex] = (0, $8T3gX.useState)(null);
    const [hoveredShapeIndex, setHoveredShapeIndex] = (0, $8T3gX.useState)(null);
    const [cursorType, setCursorType] = (0, $8T3gX.useState)("crosshair");
    const [shapesArray, setShapesArray] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(shapes);
    const [mousePosition, setMousePosition] = (0, $8T3gX.useState)(null);
    const padding = 20;
    const isPointInPolygon = (polygonPoints, point, index)=>{
        const [x, y] = point;
        let isInside = false;
        let j = polygonPoints.length - 1;
        // const updatedPolygonPoints = polygonPoints.map(([x, y]) => [x + 172, y + 110]);
        for(let i = 0; i < polygonPoints.length; i++){
            const pi = polygonPoints[i];
            const pj = polygonPoints[j];
            if (!$a310b8d01e004f2d$var$isValidPolygonVertex(pi) || !$a310b8d01e004f2d$var$isValidPolygonVertex(pj)) {
                j = i;
                continue;
            }
            const [xi, yi] = pi;
            const [xj, yj] = pj;
            const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
            if (intersect) isInside = !isInside;
            j = i;
        }
        if (!dragging && isInside && hoveredShapeIndex !== index) setHoveredShapeIndex(index);
        if (!isInside && hoveredShapeIndex === index && !dragging && !hoveredPointIndex) setHoveredShapeIndex(null);
    };
    (0, $8T3gX.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if ($a310b8d01e004f2d$var$isEditableElementFocused()) return;
            if (event.key === "Backspace" || event.key === "Delete") {
                if (closed) {
                    //delete the the polygon that is currently displaying the polygonPoints
                    setPolygonPoints([]);
                    setIZPolygonPoints([]);
                    const updatedShapes = [
                        ...shapesArray.filter((shape)=>shape !== polygonPoints)
                    ];
                    setShapes((0, $eAYze.handleDecreasePointsBy30)(updatedShapes));
                    setShapesArray([
                        ...shapesArray.filter((shape)=>shape !== polygonPoints)
                    ]);
                    setHoveredShapeIndex(null);
                    setHoveredLineIndex(null);
                    setHoveredPointIndex(null);
                    setClosed(false);
                }
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return ()=>{
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        selectedPointIndex,
        hoveredShapeIndex,
        polygonPoints,
        shapesArray,
        setShapes
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (hoveredPointIndex === null && hoveredLineIndex === null && hoveredShapeIndex === null) setCursorType("crosshair");
        else setCursorType("pointer");
    }, [
        hoveredLineIndex,
        hoveredPointIndex,
        hoveredShapeIndex
    ]);
    (0, $8T3gX.useEffect)(()=>{
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext("2d");
        if (!ctx) return;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        if (polygonPoints && polygonPoints.length > 0) {
            const validForPath = polygonPoints.filter($a310b8d01e004f2d$var$isValidPolygonVertex);
            if (closed && validForPath.length >= 2) {
                if (hoveredShapeIndex !== null) {
                    const shapesArrayToUpdate = shapesArray;
                    shapesArrayToUpdate[hoveredShapeIndex] = polygonPoints;
                    setShapesArray(shapesArrayToUpdate);
                }
                ctx.fillStyle = `${shapeColor}50`;
                ctx.beginPath();
                ctx.moveTo(validForPath[0][0], validForPath[0][1]);
                for(let i = 1; i < validForPath.length; i++)ctx.lineTo(validForPath[i][0], validForPath[i][1]);
                ctx.closePath();
                ctx.fill();
            }
            ctx.strokeStyle = shapeColor;
            ctx.lineWidth = 2;
            ctx.beginPath();
            if (validForPath.length > 1) {
                ctx.moveTo(validForPath[0][0], validForPath[0][1]);
                for(let i = 1; i < validForPath.length; i++)ctx.lineTo(validForPath[i][0], validForPath[i][1]);
                if (closed) ctx.closePath();
            }
            ctx.stroke();
            for(let i = 0; i < polygonPoints.length; i++){
                const pt = polygonPoints[i];
                if (!$a310b8d01e004f2d$var$isValidPolygonVertex(pt)) continue;
                const [x, y] = pt;
                ctx.beginPath();
                ctx.arc(x, y, 5, 0, Math.PI * 2);
                ctx.fillStyle = selectedPointIndex === i ? "red" : hoveredPointIndex === i ? "#001943" : shapeColor;
                ctx.fill();
            }
            if (closed && hoveredLineIndex !== null && !dragging && polygonPoints.length > 0) {
                const start = polygonPoints[hoveredLineIndex];
                const end = polygonPoints[(hoveredLineIndex + 1) % polygonPoints.length];
                if ($a310b8d01e004f2d$var$isValidPolygonVertex(start) && $a310b8d01e004f2d$var$isValidPolygonVertex(end)) {
                    const [startX, startY] = start;
                    const [endX, endY] = end;
                    ctx.beginPath();
                    ctx.moveTo(startX, startY);
                    ctx.lineTo(endX, endY);
                    ctx.strokeStyle = "red";
                    ctx.stroke();
                }
            }
            if (!closed && mousePosition && polygonPoints.length > 0 && !drawing) {
                const last = polygonPoints[polygonPoints.length - 1];
                if (!$a310b8d01e004f2d$var$isValidPolygonVertex(last)) ;
                else {
                    const [lastX, lastY] = last;
                    let [mouseX, mouseY] = mousePosition;
                    if (mouseX < 30) mouseX = 30;
                    if (mouseX > imageWidth + 30) mouseX = imageWidth + 30;
                    if (mouseY < 30) mouseY = 30;
                    if (mouseY > imageHeight + 30) mouseY = imageHeight + 30;
                    ctx.beginPath();
                    ctx.moveTo(lastX, lastY);
                    ctx.lineTo(mouseX, mouseY);
                    ctx.strokeStyle = shapeColor;
                    ctx.lineWidth = 1;
                    ctx.stroke();
                }
            }
        }
    }, [
        polygonPoints,
        closed,
        selectedPointIndex,
        hoveredLineIndex,
        dragging,
        hoveredPointIndex,
        mousePosition,
        shapeColor
    ]);
    const handleMouseDown = (e)=>{
        const canvas = canvasRef.current;
        if (!canvas) return;
        const [mouseX, mouseY] = $a310b8d01e004f2d$var$getMouseCanvasCoords(e, canvas, imageWidth, imageHeight);
        const firstPoint = polygonPoints[0];
        if (!closed) {
            if (hoveredShapeIndex !== null) {
                setPolygonPoints(shapesArray[hoveredShapeIndex]);
                setIZPolygonPoints(shapesArray[hoveredShapeIndex]);
                const updatedShapes = [
                    ...shapesArray.filter((shape, index)=>index !== hoveredShapeIndex)
                ];
                setShapes((0, $eAYze.handleDecreasePointsBy30)(updatedShapes));
                setHoveredShapeIndex(null);
                setClosed(true);
                return;
            }
            if (!drawing && polygonPoints.length > 2 && $a310b8d01e004f2d$var$isValidPolygonVertex(firstPoint) && Math.abs(firstPoint[0] - mouseX) < 5 && Math.abs(firstPoint[1] - mouseY) < 5) {
                setHoveredShapeIndex(shapesArray.length);
                setShapesArray([
                    ...shapesArray,
                    polygonPoints
                ]);
                setClosed(true);
                return;
            }
            if (!drawing) {
                setDrawing(true);
                setPolygonPoints([
                    ...polygonPoints,
                    [
                        mouseX,
                        mouseY
                    ]
                ]);
                setIZPolygonPoints([
                    ...polygonPoints,
                    [
                        mouseX,
                        mouseY
                    ]
                ]);
            }
        } else {
            if (hoveredShapeIndex !== null && hoveredLineIndex === null && hoveredPointIndex === null) {
                if (polygonPoints === shapesArray[hoveredShapeIndex]) return;
            }
            const clickedPointIndex = polygonPoints.findIndex((pt)=>$a310b8d01e004f2d$var$isValidPolygonVertex(pt) && Math.abs(pt[0] - mouseX) < 5 && Math.abs(pt[1] - mouseY) < 5);
            if (clickedPointIndex !== -1) {
                setDragging(true);
                setSelectedPointIndex(clickedPointIndex);
                setHoveredLineIndex(null); // Clear the hovered line index when a point is clicked
                //set the hoveredShapeIndex to the index of the shape from the shapesArray that is closest to the clicked point
                setHoveredShapeIndex(shapesArray.findIndex((shape)=>shape === polygonPoints));
            }
            if (hoveredShapeIndex !== null) {
                if (polygonPoints === shapesArray[hoveredShapeIndex]) return;
                const updatedShapes = [
                    ...shapesArray.filter((shape, index)=>index !== hoveredShapeIndex),
                    polygonPoints
                ];
                setShapes((0, $eAYze.handleDecreasePointsBy30)(updatedShapes));
                setPolygonPoints(shapesArray[hoveredShapeIndex]);
                setIZPolygonPoints(shapesArray[hoveredShapeIndex]);
            }
            if (hoveredShapeIndex === null && hoveredLineIndex === null && hoveredPointIndex === null) {
                setShapes((0, $eAYze.handleDecreasePointsBy30)(shapesArray));
                setPolygonPoints([]);
                setIZPolygonPoints([]);
                setClosed(false);
                setDrawing(true);
                setPolygonPoints([
                    [
                        mouseX,
                        mouseY
                    ]
                ]);
                setIZPolygonPoints([
                    [
                        mouseX,
                        mouseY
                    ]
                ]);
            }
        }
    };
    const handleMouseMove = (e)=>{
        const canvas = canvasRef.current;
        if (canvas) {
            const [mouseX1, mouseY1] = $a310b8d01e004f2d$var$getMouseCanvasCoords(e, canvas, imageWidth, imageHeight);
            shapesArray.forEach((shape, index)=>{
                isPointInPolygon(shape, [
                    mouseX1,
                    mouseY1
                ], index);
            });
            if (!closed && !dragging) setMousePosition([
                mouseX1,
                mouseY1
            ]);
        }
        if (drawing && !closed && !dragging) {
            if (!canvas) return;
            const [mouseX, mouseY] = $a310b8d01e004f2d$var$getMouseCanvasCoords(e, canvas, imageWidth, imageHeight);
            setPolygonPoints([
                ...polygonPoints.slice(0, -1),
                [
                    mouseX,
                    mouseY
                ]
            ]);
            setIZPolygonPoints([
                ...polygonPoints.slice(0, -1),
                [
                    mouseX,
                    mouseY
                ]
            ]);
        } else if (dragging) {
            const canvas = canvasRef.current;
            if (!canvas) return;
            const [mouseX, mouseY] = $a310b8d01e004f2d$var$getMouseCanvasCoords(e, canvas, imageWidth, imageHeight);
            const updatedPoints = [
                ...polygonPoints
            ];
            updatedPoints[selectedPointIndex] = [
                mouseX,
                mouseY
            ];
            setPolygonPoints(updatedPoints);
            setIZPolygonPoints(updatedPoints);
            if (hoveredShapeIndex !== null) {
                const shapesArrayToUpdate = shapesArray;
                shapesArrayToUpdate[hoveredShapeIndex] = updatedPoints;
                setShapesArray(shapesArrayToUpdate);
            }
        } else if (closed && polygonPoints.length > 0) {
            const canvas = canvasRef.current;
            if (!canvas) return;
            const [mouseX, mouseY] = $a310b8d01e004f2d$var$getMouseCanvasCoords(e, canvas, imageWidth, imageHeight);
            const lineIndex = polygonPoints.findIndex((_, index)=>{
                const p1 = polygonPoints[index];
                const p2 = polygonPoints[(index + 1) % polygonPoints.length];
                if (!$a310b8d01e004f2d$var$isValidPolygonVertex(p1) || !$a310b8d01e004f2d$var$isValidPolygonVertex(p2)) return false;
                const [x1, y1] = p1;
                const [x2, y2] = p2;
                // Vector from first point of the line to the second
                const dx = x2 - x1;
                const dy = y2 - y1;
                const segmentLengthSquared = dx * dx + dy * dy;
                // If the segment is a point (both endpoints are the same)
                if (segmentLengthSquared === 0) return false;
                // Calculate the projection of the mouse onto the line segment
                const t = ((mouseX - x1) * dx + (mouseY - y1) * dy) / segmentLengthSquared;
                // Clamp the projection to stay within the segment bounds (0 <= t <= 1)
                const clampedT = Math.max(0, Math.min(1, t));
                // Compute the closest point on the line segment
                const closestX = x1 + clampedT * dx;
                const closestY = y1 + clampedT * dy;
                // Calculate the distance between the mouse and the closest point on the line
                const distanceToLine = Math.hypot(mouseX - closestX, mouseY - closestY);
                // Return true if the mouse is within 5px of the line segment
                return distanceToLine < 5;
            });
            const pointIndex = polygonPoints.findIndex((pt)=>$a310b8d01e004f2d$var$isValidPolygonVertex(pt) && Math.abs(pt[0] - mouseX) < 5 && Math.abs(pt[1] - mouseY) < 5);
            if (lineIndex !== -1) {
                if (pointIndex !== -1) {
                    setHoveredLineIndex(null);
                    setHoveredPointIndex(pointIndex);
                } else {
                    setHoveredLineIndex(lineIndex);
                    setHoveredPointIndex(null);
                }
            } else {
                setHoveredLineIndex(null); // Clear the hovered line index when no line is hovered
                setHoveredPointIndex(null);
            }
        }
    };
    const handleMouseUp = ()=>{
        if (drawing && !closed) setDrawing(false);
        else if (dragging) {
            if (hoveredShapeIndex !== null) {
                const shapesArrayToUpdate = shapesArray;
                shapesArrayToUpdate[hoveredShapeIndex] = polygonPoints;
                setShapesArray(shapesArrayToUpdate);
            }
            setDragging(false);
            setSelectedPointIndex(null);
        }
    };
    const insertPointBetween = (lineIndex)=>{
        const p1 = polygonPoints[lineIndex];
        const p2 = polygonPoints[(lineIndex + 1) % polygonPoints.length];
        if (!$a310b8d01e004f2d$var$isValidPolygonVertex(p1) || !$a310b8d01e004f2d$var$isValidPolygonVertex(p2)) return;
        const [x1, y1] = p1;
        const [x2, y2] = p2;
        const newPointX = (x1 + x2) / 2;
        const newPointY = (y1 + y2) / 2;
        const updatedPoints = [
            ...polygonPoints.slice(0, lineIndex + 1),
            [
                newPointX,
                newPointY
            ],
            ...polygonPoints.slice(lineIndex + 1)
        ];
        setPolygonPoints(updatedPoints);
        setIZPolygonPoints(updatedPoints);
    };
    const handleRemovePoint = (pointIndex)=>{
        if (polygonPoints.length > 3) {
            const updatedPoints = [
                ...polygonPoints.slice(0, pointIndex),
                ...polygonPoints.slice(pointIndex + 1)
            ];
            setPolygonPoints(updatedPoints);
            setIZPolygonPoints(updatedPoints);
        }
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)("canvas", {
        ref: canvasRef,
        width: imageWidth + padding * 3,
        height: imageHeight + padding * 3,
        onMouseDown: handleMouseDown,
        onMouseMove: handleMouseMove,
        onMouseUp: handleMouseUp,
        onClick: ()=>closed && hoveredLineIndex !== null && !dragging && insertPointBetween(hoveredLineIndex),
        onDoubleClick: ()=>hoveredPointIndex !== null && handleRemovePoint(hoveredPointIndex),
        style: {
            cursor: cursorType,
            outline: "2px solid black"
        }
    });
};



var $eAYze = parcelRequire("eAYze");

var $8jTCz = parcelRequire("8jTCz");

var $cpJfj = parcelRequire("cpJfj");

const $b11a8a986805109f$export$9ddb86e9e7003ae7 = ()=>{
    const previewUrl = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.previewUrl);
    const editorActive = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.editSession != null);
    const shapeColor = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.editSession?.color ?? "#FF8400");
    const adjustedDimensions = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.adjustedDimensions);
    const setShapesArray = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.setShapesArray);
    const saveEditSession = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.saveEditSession);
    const cancelEditSession = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.cancelEditSession);
    const [shapes, setShapes] = $8T3gX.useState(()=>(0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3).getState().shapesArray);
    const [iZpolygonPoints, setIZPolygonPoints] = $8T3gX.useState([]);
    const [drawerKey, setDrawerKey] = $8T3gX.useState(0);
    const initialCanvasShapesRef = $8T3gX.useRef((0, $eAYze.handleIncrementPointsBy30)((0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3).getState().shapesArray));
    const imageWidth = adjustedDimensions.x;
    const imageHeight = adjustedDimensions.y;
    const setShapesFromDrawer = $8T3gX.useCallback((nextShapes)=>{
        setShapes(nextShapes);
        setShapesArray(nextShapes);
    }, [
        setShapesArray
    ]);
    const handleClearAll = ()=>{
        setShapes([]);
        setShapesArray([]);
        setIZPolygonPoints([]);
        setDrawerKey((key)=>key + 1);
    };
    const handleSave = ()=>{
        const updatedIZPolygonPoints = iZpolygonPoints.map((array)=>array.map((num)=>num - 30));
        const updatedShapes = [
            ...shapes
        ];
        if (updatedIZPolygonPoints.length >= 3) updatedShapes.push(updatedIZPolygonPoints);
        setShapesArray(updatedShapes.filter((shape)=>shape.length >= 3));
        saveEditSession();
    };
    if (!editorActive || !previewUrl) return null;
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                style: {
                    position: "relative",
                    padding: "8px",
                    borderRadius: "4px",
                    backgroundColor: "white",
                    display: "inline-block"
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a310b8d01e004f2d$export$d5f156ac08088eed), {
                            initialPoints: [],
                            shapes: drawerKey === 0 ? initialCanvasShapesRef.current : [],
                            shapeColor: shapeColor,
                            setShapes: setShapesFromDrawer,
                            imageHeight: imageHeight,
                            imageWidth: imageWidth,
                            setIZPolygonPoints: setIZPolygonPoints
                        }, drawerKey)
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "pt-[30px] pl-[30px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                            width: imageWidth,
                            height: imageHeight,
                            style: {
                                backgroundImage: `url(${previewUrl})`,
                                backgroundSize: `${imageWidth}px ${imageHeight}px`
                            },
                            children: shapes.map((shape, index)=>/*#__PURE__*/ (0, $k4ank.jsx)("polygon", {
                                    points: shape.map((point)=>point.join(",")).join(" "),
                                    fill: `${shapeColor}40`,
                                    stroke: shapeColor,
                                    strokeWidth: 2
                                }, index))
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "pt-[40px] pl-[20px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            onClick: handleClearAll,
                            text: "Clear All",
                            disabled: false
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "absolute -top-[37px] right-[200px] z-[10]",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                    onClick: cancelEditSession,
                    text: "Cancel",
                    disabled: false
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "absolute -top-[37px] right-[40px] z-[10]",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cpJfj.ActuateButton), {
                    onClick: handleSave,
                    text: "Save Edits",
                    disabled: false
                })
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eejVe = parcelRequire("eejVe");

var $kbChx = parcelRequire("kbChx");

var $3baw3 = parcelRequire("3baw3");

var $2SHRA = parcelRequire("2SHRA");

var $aHe9T = parcelRequire("aHe9T");

const $80e6be9014c15940$export$bf83ed94f39f5cbd = ()=>{
    const editSession = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.editSession);
    const availableMetrics = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.availableMetrics);
    const saveValidationError = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.saveValidationError);
    const updateEditSessionColor = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.updateEditSessionColor);
    const updateEditSessionName = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.updateEditSessionName);
    const setEditSessionIgnoreAll = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.setEditSessionIgnoreAll);
    const toggleEditSessionMetric = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.toggleEditSessionMetric);
    const getUsedColors = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.getUsedColors);
    if (!editSession) return null;
    const usedColors = getUsedColors(editSession.localId);
    const checkboxSx = {
        color: "#001943",
        "&.Mui-checked": {
            color: editSession.color
        }
    };
    const formControlLabelSx = {
        marginLeft: 0,
        marginRight: 0,
        "& .MuiFormControlLabel-label": {
            fontFamily: "Mulish",
            color: "#001943"
        }
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "font-mulish text-actuate-blue min-w-[420px] pr-[40px]",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "font-bold text-[17px] mb-[16px]",
                children: "Ignore Zone Configuration"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "text-[15px] font-semibold mb-[8px]",
                children: "Name"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                value: editSession.name ?? "",
                variant: "standard",
                fullWidth: true,
                placeholder: "Zone name",
                onChange: (event)=>updateEditSessionName(event.target.value),
                sx: {
                    mb: "24px",
                    fontFamily: "Mulish",
                    "& .MuiInputBase-input": {
                        fontFamily: "Mulish",
                        color: "#001943"
                    },
                    "& .MuiInput-underline:before": {
                        borderBottomColor: "#001943"
                    },
                    "& .MuiInput-underline:after": {
                        borderBottomColor: "#001943"
                    }
                }
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "text-[15px] font-semibold mb-[8px]",
                children: "Color"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "grid grid-cols-8 gap-[8px] mb-[24px] w-fit",
                children: (0, $aHe9T.metadataTagZonesColorArray).map((color)=>{
                    const isUsed = usedColors.includes(color);
                    const isSelected = editSession.color === color;
                    return /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                        type: "button",
                        "aria-label": `Select color ${color}`,
                        disabled: isUsed && !isSelected,
                        onClick: ()=>updateEditSessionColor(color),
                        style: {
                            width: 28,
                            height: 28,
                            backgroundColor: color,
                            border: isSelected ? "3px solid #001943" : "1px solid #001943",
                            opacity: isUsed && !isSelected ? 0.35 : 1,
                            cursor: isUsed && !isSelected ? "not-allowed" : "pointer"
                        }
                    }, color);
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "text-[15px] font-semibold mb-[8px]",
                children: "Products"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $2SHRA.default), {
                sx: {
                    gap: 0,
                    alignItems: "flex-start"
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                            checked: editSession.isIgnoreAll,
                            onChange: (event)=>setEditSessionIgnoreAll(event.target.checked),
                            sx: checkboxSx
                        }),
                        label: "Select All",
                        sx: formControlLabelSx
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "ml-[20px] flex flex-col",
                        children: availableMetrics.map((metric)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                    checked: editSession.metricIds.includes(metric.metricId),
                                    onChange: (event)=>toggleEditSessionMetric(metric.metricId, event.target.checked),
                                    sx: checkboxSx
                                }),
                                label: metric.labelDisplayName,
                                sx: formControlLabelSx
                            }, metric.metricId))
                    })
                ]
            }),
            saveValidationError && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "text-[14px] text-red-600 mt-[16px]",
                children: saveValidationError
            })
        ]
    });
};



const $9736146db7d63c95$export$f5da4331e1f58dc8 = ({ navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed })=>{
    const navigate = (0, $3T949.useNavigate)();
    const siteId = Number((0, $a8BPe.getNumbersAfterSites)(location.href));
    const pageLoading = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.pageLoading);
    const breadcrumbs = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.breadcrumbs);
    const cameraName = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.cameraName);
    const editorVisible = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.editorVisible);
    const selectedAssignmentLocalId = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.selectedAssignmentLocalId);
    const getNewIgnoreZonesPageInfo = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.getNewIgnoreZonesPageInfo);
    const resetStore = (0, $d1c6a111b10a5885$export$9bf4593fa0eca1d3)((s)=>s.resetStore);
    const [allCamerasData, setAllCamerasData] = $8T3gX.useState([]);
    const [cameraIndex, setCameraIndex] = $8T3gX.useState(0);
    const handleSitesBreadcrumbClick = (event)=>{
        event.preventDefault();
        navigate("/sites");
    };
    const handleSingularSiteBreadcrumbClick = ()=>{
        navigate(`/sites/aboutsite/${siteId}`);
    };
    const navigateToCamera = (targetCameraId)=>{
        resetStore();
        navigate(`/sites/${siteId}/editcamera/${targetCameraId}/ignorezones`);
        (0, $2hXui.getAllCameras)(siteId, targetCameraId, setAllCamerasData, setCameraIndex);
        getNewIgnoreZonesPageInfo(navigate);
    };
    $8T3gX.useEffect(()=>{
        resetStore();
        getNewIgnoreZonesPageInfo(navigate);
        (0, $2hXui.getAllCameras)(siteId, Number((0, $a8BPe.getNumbersAfterEditCamera)(location.href)), setAllCamerasData, setCameraIndex);
        return ()=>{
            resetStore();
        };
    }, [
        getNewIgnoreZonesPageInfo,
        navigate,
        resetStore,
        siteId
    ]);
    const contentLeft = navBarCollapsed ? "left-[75px]" : "left-[150px]";
    const listLeft = navBarCollapsed ? "left-[905px]" : "left-[980px]";
    const configLeft = navBarCollapsed ? "left-[970px]" : "left-[1035px]";
    const mainPanelClass = navBarCollapsed ? "absolute top-[145px] left-[75px] right-[1px] h-full bg-white" : "absolute top-[145px] left-[150px] right-[1px] h-full bg-white";
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                openState: pageLoading
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "bg-actuate-grey absolute w-full h-full overflow-scroll",
                children: !pageLoading && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: `absolute top-[15px] ${contentLeft} right-[1px] h-[59px] bg-white`,
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $711135323e7a9623$export$68a908f34f47ac33), {
                                linksArray: (0, $711135323e7a9623$export$239ff243aaf842dd)(breadcrumbs),
                                cameraName: cameraName,
                                handleSitesBreadcrumbClick: handleSitesBreadcrumbClick,
                                handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick,
                                styling: "absolute top-[15px] left-[30px]"
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: `absolute top-[87px] ${contentLeft} right-[1px] h-[58px] bg-white`,
                            children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "font-black font-mulish text-[20px] p-3 indent-4",
                                children: cameraName
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: mainPanelClass,
                            children: [
                                !editorVisible && allCamerasData.length > 1 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "pt-[200px] w-[40px]",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                        title: `Previous Camera: ${cameraIndex === 0 ? allCamerasData[allCamerasData.length - 1].camera_name : allCamerasData[cameraIndex - 1].camera_name}`,
                                        placement: "top",
                                        sx: {
                                            fontSize: "12px",
                                            fontFamily: "Mulish"
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                onClick: ()=>{
                                                    const targetCameraId = cameraIndex === 0 ? allCamerasData[allCamerasData.length - 1].id : allCamerasData[cameraIndex - 1].id;
                                                    navigateToCamera(targetCameraId);
                                                },
                                                text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($frXOV))), {
                                                    fontSize: "large",
                                                    id: "backButton"
                                                }),
                                                disabled: allCamerasData.length < 2
                                            })
                                        })
                                    })
                                }),
                                !editorVisible && allCamerasData.length > 1 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "absolute top-[200px] left-[1250px]",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                        title: `Next Camera: ${cameraIndex + 1 === allCamerasData.length ? allCamerasData[0].camera_name : allCamerasData[cameraIndex + 1].camera_name}`,
                                        placement: "top",
                                        sx: {
                                            fontSize: "12px",
                                            fontFamily: "Mulish"
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                onClick: ()=>{
                                                    const targetCameraId = cameraIndex + 1 === allCamerasData.length ? allCamerasData[0].id : allCamerasData[cameraIndex + 1].id;
                                                    navigateToCamera(targetCameraId);
                                                },
                                                text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2qUoo))), {
                                                    fontSize: "large",
                                                    id: "backButton"
                                                }),
                                                disabled: allCamerasData.length < 2
                                            })
                                        })
                                    })
                                }),
                                !editorVisible && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "absolute top-[13px] left-[70px] z-[1] flex flex-col items-start",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8a6539c8bfc9779b$export$fd11aa13a8052277), {})
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: editorVisible ? "player pointer-events-auto absolute top-[0px] left-[67px] z-[2] w-[775px] h-[200px] overflow-visible" : "player pointer-events-none absolute top-[0px] left-[67px] z-0 w-[775px] h-[200px]",
                                    children: editorVisible && /*#__PURE__*/ (0, $k4ank.jsx)((0, $b11a8a986805109f$export$9ddb86e9e7003ae7), {}, selectedAssignmentLocalId ?? "editor")
                                })
                            ]
                        }),
                        !editorVisible && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: `absolute top-[130px] ${listLeft} w-[420px]`,
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $7107d7e25d2445a2$export$c946e0bc456f8b1), {})
                        }),
                        editorVisible && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: `absolute top-[172px] ${configLeft}`,
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $80e6be9014c15940$export$bf83ed94f39f5cbd), {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "justify-start",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jVN1H.NavBar), {
                    navBarCollapsed: navBarCollapsed,
                    setNavBarCollapsed: setNavBarCollapsed,
                    props: {}
                })
            })
        ]
    });
};


/* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable jsx-a11y/interactive-supports-focus */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $jVN1H = parcelRequire("jVN1H");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $j0ZEU = parcelRequire("j0ZEU");

var $3IuQ3 = parcelRequire("3IuQ3");

var $f3puC = parcelRequire("f3puC");

var $5GP2e = parcelRequire("5GP2e");

var $eXOoR = parcelRequire("eXOoR");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");

var $9OjAn = parcelRequire("9OjAn");

var $8T3gX = parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");
parcelRequire("8T3gX");
const $da6abf73ed9ea30a$export$909675b0a8fc80ee = (input)=>{
    if (input) {
        const [widthStr, heightStr] = input.split("x").map((str)=>parseInt(str.trim()));
        const aspectRatio = widthStr / heightStr;
        let adjustedWidth = widthStr;
        let adjustedHeight = heightStr;
        if (adjustedWidth / aspectRatio > 360) {
            adjustedWidth = 640;
            adjustedHeight = adjustedWidth / aspectRatio;
        } else {
            adjustedHeight = 360;
            adjustedWidth = adjustedHeight * aspectRatio;
        }
        if (adjustedWidth > 640) {
            adjustedWidth = 640;
            adjustedHeight = adjustedWidth / aspectRatio;
        }
        if (adjustedHeight > 360) {
            adjustedHeight = 360;
            adjustedWidth = adjustedHeight * aspectRatio;
        }
        return {
            width: adjustedWidth,
            height: adjustedHeight
        };
    } else return {
        height: 360,
        width: 640
    };
};


const $cca596e8c0fe6d2e$var$adjustDimensions = (dimensions)=>{
    const [width, height] = dimensions.split(" x ").map(Number);
    if (!width || !height) return; // Exit if parsing fails
    const aspectRatio = height / width;
    const adjustedHeight = Math.round(720 * aspectRatio);
    return {
        x: 720,
        y: adjustedHeight
    };
};
const $cca596e8c0fe6d2e$export$d71c92fb98393c7a = (0, $9OjAn.create)((set, get)=>({
        metadataTagZones: [],
        setMetadataTagZones: (metadataTagZones)=>set({
                metadataTagZones: metadataTagZones
            }),
        cameraInfo: {
            camera_name: ""
        },
        setCameraInfo: (cameraInfo)=>set({
                cameraInfo: cameraInfo
            }),
        breadcrumbs: [],
        setBreadcrumbs: (breadcrumbs)=>set({
                breadcrumbs: breadcrumbs
            }),
        editorVisible: false,
        setEditorVisible: (editorVisible)=>set({
                editorVisible: editorVisible
            }),
        selectedMetadataTagZone: {
            // Don't include id property - let API assign it
            camera: Number((0, $a8BPe.getNumbersAfterEditCamera)(location.href)),
            name: "",
            description: "",
            line_color: "",
            coordinates: [],
            metric_labels: []
        },
        newMetadataTagZone: {
            // Don't include id property - let API assign it
            camera: Number((0, $a8BPe.getNumbersAfterEditCamera)(location.href)),
            name: "",
            description: "",
            line_color: "",
            coordinates: [],
            metric_labels: []
        },
        setNewMetadataTagZone: (newMetadataTagZone)=>set({
                newMetadataTagZone: newMetadataTagZone
            }),
        setSelectedMetadataTagZone: (selectedMetadataTagZone)=>set({
                selectedMetadataTagZone: selectedMetadataTagZone
            }),
        editsMade: false,
        setEditsMade: (editsMade)=>set({
                editsMade: editsMade
            }),
        pageLoading: true,
        setPageLoading: (pageLoading)=>set({
                pageLoading: pageLoading
            }),
        largerMode: false,
        setLargerMode: (largerMode)=>set({
                largerMode: largerMode
            }),
        adjustedDimensions: {
            x: 720,
            y: 576
        },
        setAdjustedDimensions: (adjustedDimensions)=>set({
                adjustedDimensions: adjustedDimensions
            }),
        dimensions: {
            width: 720,
            height: 576
        },
        setDimensions: (dimensions)=>set({
                dimensions: dimensions
            }),
        shapesArray: [],
        setShapesArray: (shapesArray)=>set({
                shapesArray: shapesArray
            }),
        selectedShapeIndex: 0,
        setSelectedShapeIndex: (selectedShapeIndex)=>set({
                selectedShapeIndex: selectedShapeIndex
            }),
        selectedMetadataTagZoneIndex: 0,
        setSelectedMetadataTagZoneIndex: (selectedMetadataTagZoneIndex)=>set({
                selectedMetadataTagZoneIndex: selectedMetadataTagZoneIndex
            }),
        editedTagZoneIndexes: [],
        setEditedTagZoneIndexes: (editedTagZoneIndexes)=>set({
                editedTagZoneIndexes: editedTagZoneIndexes
            }),
        mtzPolygonPoints: [],
        setMtzPolygonPoints: (mtzPolygonPoints)=>set({
                mtzPolygonPoints: mtzPolygonPoints
            }),
        showAllMetadataTagZones: false,
        setShowAllMetadataTagZones: (showAllMetadataTagZones)=>set({
                showAllMetadataTagZones: showAllMetadataTagZones
            }),
        shapeColor: "",
        setShapeColor: (shapeColor)=>set({
                shapeColor: shapeColor
            }),
        shapeColorIndex: 0,
        setShapeColorIndex: (shapeColorIndex)=>set({
                shapeColorIndex: shapeColorIndex
            }),
        imageURLmdtz: "",
        setImageURLmdtz: (imageURLmdtz)=>set({
                imageURLmdtz: imageURLmdtz
            }),
        metricLabels: [],
        setMetricLabels: (metricLabels)=>set({
                metricLabels: metricLabels
            }),
        addMetaDataIgnoreZoneDialogOpen: false,
        setAddMetaDataIgnoreZoneDialogOpen: (addMetaDataIgnoreZoneDialogOpen)=>set({
                addMetaDataIgnoreZoneDialogOpen: addMetaDataIgnoreZoneDialogOpen
            }),
        instructionsDialogOpen: false,
        setInstructionsDialogOpen: (instructionsDialogOpen)=>set({
                instructionsDialogOpen: instructionsDialogOpen
            }),
        mdtzBuilder: (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment),
        setMdtzBuilder: (mdtzBuilder)=>set({
                mdtzBuilder: mdtzBuilder
            }),
        getAllEditMetaDataTagZonesPageInfo: async (navigate)=>{
            const { getAllEditMetaDataTagZonesPageInfo: getAllEditMetaDataTagZonesPageInfo, setDimensions: setDimensions, setAdjustedDimensions: setAdjustedDimensions, setImageURLmdtz: setImageURLmdtz, setPageLoading: setPageLoading, setMetadataTagZones: setMetadataTagZones, setBreadcrumbs: setBreadcrumbs, setMetricLabels: setMetricLabels, setCameraInfo: setCameraInfo } = get();
            const AxiosUI = (0, $195EM.createApi)(``);
            const cameraId = (0, $a8BPe.getNumbersAfterEditCamera)(location.href);
            const retryFunction = ()=>{
                getAllEditMetaDataTagZonesPageInfo(navigate);
            };
            try {
                // Run all API calls concurrently using Promise.all
                const [cameraStatusResponse, tagZonesResponse, customerAboutResponse, metricLabelsResponse] = await Promise.all([
                    AxiosUI.get(`/camera/${cameraId}/status/`),
                    AxiosUI.get(`tagzone/?camera=${cameraId}`),
                    AxiosUI.get(`/customer/${(0, $a8BPe.getNumbersAfterSites)(location.href)}/about/`),
                    AxiosUI.get(`/metric_label/?camera=${cameraId}`)
                ]);
                // Process all responses
                setDimensions((0, $da6abf73ed9ea30a$export$909675b0a8fc80ee)(cameraStatusResponse.data.frame_dimensions));
                const adjustedDims = $cca596e8c0fe6d2e$var$adjustDimensions(cameraStatusResponse.data.frame_dimensions);
                if (adjustedDims) setAdjustedDimensions(adjustedDims);
                setCameraInfo(cameraStatusResponse.data);
                setImageURLmdtz(cameraStatusResponse.data.preview_url);
                setMetadataTagZones(tagZonesResponse.data.results);
                setBreadcrumbs(customerAboutResponse.data.breadcrumbs);
                setMetricLabels(metricLabelsResponse.data);
                // Set loading to false only after all requests complete successfully
                setPageLoading(false);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    alert("Unable to load page information. Please try refreshing the page.");
                    setPageLoading(false);
                });
            }
        },
        handlePostMetadataTagZones: async (navigate)=>{
            const { handlePostMetadataTagZones: handlePostMetadataTagZones, metadataTagZones: metadataTagZones, setPageLoading: setPageLoading, getAllEditMetaDataTagZonesPageInfo: getAllEditMetaDataTagZonesPageInfo } = get();
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                handlePostMetadataTagZones(navigate);
            };
            try {
                // Create array of promises for all API calls
                const apiPromises = metadataTagZones.map((metadataTagZone)=>{
                    if (!metadataTagZone.id) return AxiosUI.post(`/tagzone/`, metadataTagZone);
                    else return AxiosUI.patch(`/tagzone/${metadataTagZone.id}/`, metadataTagZone);
                });
                // Wait for all API calls to complete
                await Promise.all(apiPromises);
                // Refresh the data to get updated zones with proper IDs
                await getAllEditMetaDataTagZonesPageInfo(navigate);
                navigate(`/sites/${(0, $a8BPe.getNumbersAfterSites)(location.href)}/editcamera/${(0, $a8BPe.getNumbersAfterEditCamera)(location.href)}/`);
                // Set loading to false only after all requests complete successfully
                setPageLoading(false);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    alert("Unable to post metadata tag zones. Please try again.");
                    setPageLoading(false);
                });
            }
        },
        handleDeleteMetadataTagZone: async (tagZoneId, navigate)=>{
            const { handleDeleteMetadataTagZone: handleDeleteMetadataTagZone, setPageLoading: setPageLoading, setMetadataTagZones: setMetadataTagZones } = get();
            const AxiosUI = (0, $195EM.createApi)(``);
            const cameraId = (0, $a8BPe.getNumbersAfterEditCamera)(location.href);
            const retryFunction = ()=>{
                handleDeleteMetadataTagZone(tagZoneId, navigate);
            };
            try {
                // Delete the metadata tag zone
                await AxiosUI.delete(`/tagzone/${tagZoneId}/`);
                // Fetch updated tag zones
                const tagZonesResponse = await AxiosUI.get(`tagzone/?camera=${cameraId}`);
                setMetadataTagZones(tagZonesResponse.data.results);
                // Set loading to false only after all requests complete successfully
                setPageLoading(false);
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    alert("Unable to delete metadata tag zone. Please try again.");
                    setPageLoading(false);
                });
            }
        }
    }));


const $4d2348fce80d73d0$export$44a63809e8a3a64a = ({ linksArray: linksArray, handleSitesBreadcrumbClick: handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick, styling: styling })=>{
    const navigate = (0, $3T949.useNavigate)();
    const { cameraInfo: cameraInfo } = (0, $cca596e8c0fe6d2e$export$d71c92fb98393c7a)();
    const handleCameraBreadcrumbClick = (event)=>{
        event.preventDefault();
        navigate(`/sites/${(0, $a8BPe.getNumbersAfterSites)(location.href)}/editcamera/${(0, $a8BPe.getNumbersAfterEditCamera)(location.href)}`);
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3IuQ3.default), {
        spacing: 2,
        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
            className: styling,
            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $j0ZEU.default), {
                separator: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXOoR))), {
                    fontSize: "medium"
                }),
                "aria-label": "breadcrumb",
                children: [
                    linksArray.map((object, index)=>{
                        if (index === 0) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                            underline: "hover",
                            color: "inherit",
                            href: "/sites",
                            sx: {
                                fontSize: "18px",
                                fontFamily: "Mulish",
                                fontWeight: "bold",
                                cursor: "pointer"
                            },
                            variant: "h5",
                            onClick: handleSitesBreadcrumbClick,
                            children: object.name
                        }, index);
                        else if (index === linksArray.length - 1) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                            underline: "hover",
                            color: "inherit",
                            // href="/sites/aboutsite"
                            sx: {
                                fontSize: "18px",
                                fontFamily: "Mulish",
                                fontWeight: "bold",
                                cursor: "pointer"
                            },
                            variant: "h5",
                            onClick: handleSingularSiteBreadcrumbClick,
                            children: object.name
                        }, index);
                        else if (index === linksArray.length && !window.location.href.includes("editignorezones")) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                            color: "text.primary",
                            fontSize: "18px",
                            fontFamily: "Mulish",
                            fontWeight: "bold",
                            children: object.name
                        }, index);
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                        underline: "hover",
                        color: "inherit",
                        sx: {
                            fontSize: "18px",
                            fontFamily: "Mulish",
                            fontWeight: "bold",
                            cursor: "pointer"
                        },
                        variant: "h5",
                        onClick: handleCameraBreadcrumbClick,
                        children: cameraInfo.camera_name
                    }, cameraInfo.camera_name)
                ]
            })
        })
    });
};


const $5b5f0ca6080675b7$export$89c67b564440f6c = (pushedArray)=>{
    const linksArray = [
        {
            name: "Sites"
        }
    ];
    pushedArray.forEach((name)=>{
        linksArray.push({
            name: name
        });
    });
    return linksArray;
};


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $35d84607375812b2$export$c2c757e9d9431ca3 = (array, height, width)=>{
    let returnString = ``;
    array.forEach((array)=>{
        returnString += `${array[0] * width},${array[1] * height} `;
    });
    return returnString;
};
const $35d84607375812b2$export$3eae1676999df59c = (array, height, width)=>{
    let returnString = ``;
    array.forEach((array)=>{
        returnString += `${array[0] * width + 30},${array[1] * height + 30} `;
    });
    return returnString;
};



var $8jTCz = parcelRequire("8jTCz");

var $dHtmK = parcelRequire("dHtmK");

var $8ZARq = parcelRequire("8ZARq");

var $8gqnT = parcelRequire("8gqnT");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");
var $cVCJe = parcelRequire("cVCJe");

var $frXOV = parcelRequire("frXOV");

var $2qUoo = parcelRequire("2qUoo");

var $2hXui = parcelRequire("2hXui");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");


var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $dPkR1 = parcelRequire("dPkR1");

var $8jTCz = parcelRequire("8jTCz");

var $cpJfj = parcelRequire("cpJfj");

var $3baw3 = parcelRequire("3baw3");

var $ddLR4 = parcelRequire("ddLR4");

var $kbChx = parcelRequire("kbChx");


parcelRequire("8T3gX");
const $1668ac8ae9fd9396$export$20d02e2cb1b23d75 = (array)=>{
    return array.map((subArray)=>subArray.map((numberArray)=>numberArray.map((num)=>num - 30)));
};
const $1668ac8ae9fd9396$export$a9cab48816615acd = (array)=>{
    return array.map((subArray)=>subArray.map((numberArray)=>numberArray.map((num)=>num + 30)));
};


/**
 * Transforms normalized coordinates (0-1 range) to pixel coordinates
 * @param normalizedCoords - Array of normalized coordinates in format [[[x1,y1], [x2,y2], ...], ...]
 * @param imageWidth - Width of the image in pixels
 * @param imageHeight - Height of the image in pixels
 * @returns Array of pixel coordinates
 */ const $913bd57b3bd883fb$export$4634b1ea022db412 = (normalizedCoords, imageWidth, imageHeight)=>{
    return normalizedCoords.map((polygon)=>polygon.map(([x, y])=>[
                x * imageWidth,
                y * imageHeight
            ]));
};
const $913bd57b3bd883fb$export$3d9204f92c3e5573 = (pixelCoords, imageWidth, imageHeight)=>{
    return pixelCoords.map((polygon)=>polygon.map(([x, y])=>[
                x / imageWidth,
                y / imageHeight
            ]));
};



var $cVCJe = parcelRequire("cVCJe");

var $ePwXE = parcelRequire("ePwXE");

var $k4ank = parcelRequire("k4ank");

var $kUcVg = parcelRequire("kUcVg");

var $1TOOV = parcelRequire("1TOOV");

var $ce8iU = parcelRequire("ce8iU");
parcelRequire("8T3gX");


var $iKAtE = parcelRequire("iKAtE");

var $433j1 = parcelRequire("433j1");
const $05ed9b73f3d83b70$export$609b5a0a977f0694 = ()=>{
    const { instructionsDialogOpen: instructionsDialogOpen, setInstructionsDialogOpen: setInstructionsDialogOpen } = (0, $cca596e8c0fe6d2e$export$d71c92fb98393c7a)();
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: instructionsDialogOpen,
        onClose: ()=>setInstructionsDialogOpen(false),
        fullWidth: true,
        maxWidth: "md",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                children: "Metadata Tag Zone Drawing Instructions"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                "aria-label": "close",
                onClick: ()=>setInstructionsDialogOpen(false),
                sx: {
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme)=>theme.palette.grey[500]
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "pb-[20px]",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "font-normal text-[17px] ",
                            children: "To begin creating a shape click anywhere on the image to start adding points."
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "font-normal text-[17px]",
                            children: "To finish creating a shape, click on the first point created."
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "font-normal text-[17px]",
                            children: "To modify the shape click and drag the points to the desired location."
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "font-normal text-[17px]",
                            children: "To add additional points to the shape, click on the line between two points."
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "font-normal text-[17px]",
                            children: "To create an additional shape, click anywhere on the image to start adding points."
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "font-normal text-[17px]",
                            children: "To delete a shape hover anywhere over the shape and click to select. Then press the delete key on your keyboard."
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "font-normal text-[17px]",
                            children: "To delete a single point double click on the point. This action will only work if the remaining shape will have at least 3 points."
                        })
                    ]
                })
            })
        ]
    });
};


const $b26551d30fab69e2$export$ac5978a2456900d6 = ()=>{
    const { shapesArray: shapesArray, setShapesArray: setShapesArray, dimensions: dimensions, metadataTagZones: metadataTagZones, setShowAllMetadataTagZones: setShowAllMetadataTagZones, setLargerMode: setLargerMode, setDimensions: setDimensions, mtzPolygonPoints: mtzPolygonPoints, setMtzPolygonPoints: setMtzPolygonPoints, setEditorVisible: setEditorVisible, largerMode: largerMode, imageURLmdtz: imageURLmdtz, setEditsMade: setEditsMade, selectedMetadataTagZone: selectedMetadataTagZone, setMetadataTagZones: setMetadataTagZones, shapeColor: shapeColor, showAllMetadataTagZones: showAllMetadataTagZones, setMdtzBuilder: setMdtzBuilder, instructionsDialogOpen: instructionsDialogOpen, setInstructionsDialogOpen: setInstructionsDialogOpen, selectedMetadataTagZoneIndex: selectedMetadataTagZoneIndex, editedTagZoneIndexes: editedTagZoneIndexes, setEditedTagZoneIndexes: setEditedTagZoneIndexes } = (0, $cca596e8c0fe6d2e$export$d71c92fb98393c7a)();
    const [shapes, setShapes] = (0, $8T3gX.useState)(shapesArray || []);
    const [selectedShapeIndex, setSelectedShapeIndex] = (0, $8T3gX.useState)(null);
    const [polygonDrawer, setPolygonDrawer] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
    const imageHeight = dimensions.height;
    const imageWidth = dimensions.width;
    const shapesSizeIncreaser = (shapes)=>{
        // Increase the size of the shapes by 1.5
        return shapes.map((shape)=>{
            return shape.map((point)=>{
                return point.map((coord)=>coord * 1.5);
            });
        });
    };
    const shapesSizeDecreaser = (shapes)=>{
        // Decrease the size of the shapes by 1.5
        return shapes.map((shape)=>{
            return shape.map((point)=>{
                return point.map((coord)=>coord / 1.5);
            });
        });
    };
    (0, $8T3gX.useEffect)(()=>{
        if (shapesArray && shapesArray.length > 0) setShapes(shapesArray);
    }, [
        shapesArray
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setPolygonDrawer(/*#__PURE__*/ (0, $k4ank.jsx)((0, $dPkR1.PolygonDrawer), {
            initialPoints: [],
            shapes: (0, $1668ac8ae9fd9396$export$a9cab48816615acd)(shapes),
            shapeColor: shapeColor,
            setShapes: setShapes,
            imageHeight: imageHeight,
            imageWidth: imageWidth,
            setIZPolygonPoints: setMtzPolygonPoints
        }));
    }, [
        shapes,
        shapeColor,
        imageHeight,
        imageWidth,
        setMtzPolygonPoints
    ]);
    const handleMakeLarger = ()=>{
        setPolygonDrawer(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
        setMdtzBuilder(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
        setLargerMode(true);
        setTimeout(()=>{
            setDimensions({
                width: imageWidth * 1.5,
                height: imageHeight * 1.5
            });
            // Follow IgnoreZoneBuilder pattern: add current polygon to shapes array
            const updatedShapes = [
                ...shapes,
                mtzPolygonPoints.map((numArray)=>numArray.map((num)=>num - 30))
            ];
            // Transform existing shapes (including current polygon)
            setShapesArray(shapesSizeIncreaser(updatedShapes));
            // Clear current polygon points since it's now part of shapes
            setMtzPolygonPoints([]);
            setMdtzBuilder(/*#__PURE__*/ (0, $k4ank.jsx)($b26551d30fab69e2$export$ac5978a2456900d6, {}));
        }, 100);
    };
    const handleMakeSmaller = ()=>{
        setPolygonDrawer(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
        setMdtzBuilder(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
        setLargerMode(false);
        setTimeout(()=>{
            setDimensions({
                width: imageWidth / 1.5,
                height: imageHeight / 1.5
            });
            // Follow IgnoreZoneBuilder pattern: add current polygon to shapes array
            const updatedShapes = [
                ...shapes,
                mtzPolygonPoints.map((numArray)=>numArray.map((num)=>num - 30))
            ];
            // Transform existing shapes (including current polygon)
            setShapesArray(shapesSizeDecreaser(updatedShapes));
            // Clear current polygon points since it's now part of shapes
            setMtzPolygonPoints([]);
            setMdtzBuilder(/*#__PURE__*/ (0, $k4ank.jsx)($b26551d30fab69e2$export$ac5978a2456900d6, {}));
        }, 100);
    };
    const handleClearAll = ()=>{
        setShapes([]);
        setSelectedShapeIndex(null);
        setMtzPolygonPoints([]);
    // setTimeout(() => {
    //   setIZBuilder(
    //     <IgnoreZoneBuilder
    //       shapeColor={localStorage.ignoreZoneColor}
    //       height={imageHeight}
    //       width={imageWidth}
    //       imageURL={JSON.parse(localStorage.preview_url)}
    //       shapesArray={[]}
    //       setIgnorezoneEditorVisible={setIgnorezoneEditorVisible}
    //       setEditsMade={setEditsMade}
    //       visibleIgnoreZones={visibleIgnoreZones}
    //       selectedIgnoreZone={selectedIgnoreZone}
    //       setVisibleIgnoreZones={setVisibleIgnoreZones}
    //       largerMode={largerMode}
    //       setLargerMode={setLargerMode}
    //       dimensions={dimensions}
    //       setIZBuilder={setIZBuilder}
    //       allIgnoreZonesShown={showAllIgnoreZones}
    //       siteSchedules={siteSchedules}
    //     />
    //   );
    // }, 1);
    };
    const handleCancel = ()=>{
        setEditorVisible(false);
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            instructionsDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $05ed9b73f3d83b70$export$609b5a0a977f0694), {}),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "font-mulish",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                        sx: {
                            fontFamily: "Mulish"
                        },
                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                            color: "warning",
                            defaultChecked: largerMode,
                            disabled: false,
                            onChange: (event)=>{
                                if (event.target.checked) {
                                    handleMakeLarger();
                                    setLargerMode(true);
                                } else {
                                    handleMakeSmaller();
                                    setLargerMode(false);
                                }
                            }
                        }),
                        label: "Larger Mode"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                        sx: {
                            fontFamily: "Mulish",
                            color: "#001943"
                        },
                        label: "Show All Metadata Tag Zones",
                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                            checked: showAllMetadataTagZones,
                            color: "primary",
                            onChange: (event, result)=>{
                                if (result === true) setShowAllMetadataTagZones(true);
                                else setShowAllMetadataTagZones(false);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                style: {
                    marginBottom: "10px"
                }
            }),
            showAllMetadataTagZones && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "absolute top-[60px] left-[10px]",
                children: metadataTagZones.filter((object)=>object.line_color !== shapeColor).map((object)=>{
                    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-[0px]",
                        children: object.coordinates[0] && object.coordinates.map((array, index)=>{
                            return /*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                                className: "absolute top-[0px]",
                                style: {
                                    width: `${imageWidth + 30}px`,
                                    height: `${imageHeight + 30}px`
                                },
                                children: dimensions && /*#__PURE__*/ (0, $k4ank.jsx)("polygon", {
                                    points: (0, $35d84607375812b2$export$3eae1676999df59c)(object.coordinates[index], imageHeight, imageWidth),
                                    stroke: object.line_color,
                                    strokeWidth: "5",
                                    fill: object.line_color,
                                    fillOpacity: "50%"
                                })
                            }, index);
                        })
                    }, object.label);
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                style: {
                    padding: "8px",
                    borderRadius: "4px",
                    backgroundColor: "white",
                    display: "inline-block"
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute",
                        children: polygonDrawer
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "pt-[30px] pl-[30px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                            width: imageWidth,
                            height: imageHeight,
                            style: {
                                backgroundImage: `url(${imageURLmdtz})`,
                                backgroundSize: `${imageWidth}px ${imageHeight}px`
                            },
                            children: shapes.map((shape, i)=>/*#__PURE__*/ (0, $k4ank.jsx)("polygon", {
                                    points: shape.map((point)=>point.join(",")).join(" "),
                                    fill: i === selectedShapeIndex ? shapeColor : `${shapeColor}40`,
                                    stroke: shapeColor,
                                    strokeWidth: 2
                                }, i))
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "pt-[40px] pl-[20px] flex",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: handleClearAll,
                                text: "Clear All",
                                disabled: false
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: largerMode ? "pl-[730px]" : "pl-[430px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    onClick: ()=>setInstructionsDialogOpen(true),
                                    text: "See Instructions",
                                    disabled: false
                                })
                            })
                        ]
                    }),
                    showAllMetadataTagZones && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute pt-[20px] flex w-[1200px] overflow-scroll",
                        children: metadataTagZones.map((object)=>{
                            return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "pr-[35px] cursor-default min-w-[100px] flex",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        style: {
                                            height: 25,
                                            width: 6,
                                            background: `${object.line_color}`,
                                            cursor: "default"
                                        },
                                        className: "absolute cursor-default"
                                    }, object.label),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "font-mulish text-[16px] indent-5 cursor-default",
                                        children: object.name
                                    }),
                                    "\xa0",
                                    object.description && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                        title: object.description,
                                        placement: "top",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                            fontSize: "small"
                                        })
                                    })
                                ]
                            }, object.label);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: largerMode ? `absolute top-[0px] left-[1250px]` : `absolute top-[0px] left-[950px]`,
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                    onClick: handleCancel,
                    text: "Cancel",
                    disabled: false
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: largerMode ? `absolute top-[0px] left-[1370px] w-[100px]` : `absolute top-[0px] left-[1070px] w-[100px]`,
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cpJfj.ActuateButton), {
                    onClick: ()=>{
                        setEditorVisible(false);
                        setEditsMade(true);
                        // Reset to smaller mode when saving (only if currently in larger mode)
                        if (largerMode) {
                            setLargerMode(false);
                            setDimensions({
                                width: imageWidth / 1.5,
                                height: imageHeight / 1.5
                            });
                        }
                        // Follow IgnoreZoneBuilder pattern for coordinate handling
                        // Decrease polygon points by 30 (like IgnoreZoneBuilder line 407-411)
                        const updatedMDTZPolygonPoints = mtzPolygonPoints.map((array)=>{
                            return array.map((num)=>num - 30);
                        });
                        // Combine existing shapes with new polygon points
                        const updatedShapes = [
                            ...shapes,
                            updatedMDTZPolygonPoints
                        ];
                        // Convert pixel coordinates back to normalized coordinates for API
                        const normalizedCoordinates = (0, $913bd57b3bd883fb$export$3d9204f92c3e5573)(updatedShapes, imageWidth, imageHeight);
                        // Create updated metadata tag zone with new coordinates
                        const updatedSelectedZone = {
                            ...selectedMetadataTagZone,
                            coordinates: normalizedCoordinates
                        };
                        // Check if the zone already exists in metadataTagZones by id
                        // Only check by ID if both zones have IDs
                        const existingZoneIndex = selectedMetadataTagZone.id ? metadataTagZones.findIndex((zone)=>zone.id === selectedMetadataTagZone.id) : -1; // If no ID, treat as new zone
                        let updatedMetadataTagZones;
                        if (existingZoneIndex !== -1) {
                            // Update existing zone - preserve all existing zones and update the specific one
                            updatedMetadataTagZones = [
                                ...metadataTagZones
                            ];
                            updatedMetadataTagZones[existingZoneIndex] = {
                                ...updatedSelectedZone,
                                name: selectedMetadataTagZone.name,
                                description: selectedMetadataTagZone.description,
                                metric_labels: selectedMetadataTagZone.metric_labels
                            };
                            // Track that this zone was edited
                            if (!editedTagZoneIndexes.includes(existingZoneIndex)) setEditedTagZoneIndexes([
                                ...editedTagZoneIndexes,
                                existingZoneIndex
                            ]);
                        } else // Add new zone - preserve all existing zones and add the new one
                        // Don't assign an ID - let the API handle it
                        updatedMetadataTagZones = [
                            ...metadataTagZones,
                            {
                                ...updatedSelectedZone,
                                // Remove id property entirely - let API assign it
                                name: selectedMetadataTagZone.name,
                                description: selectedMetadataTagZone.description,
                                metric_labels: selectedMetadataTagZone.metric_labels
                            }
                        ];
                        setMetadataTagZones(updatedMetadataTagZones);
                    },
                    text: "Save Edits",
                    disabled: false
                })
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8B8vg = parcelRequire("8B8vg");
var $887xF = parcelRequire("887xF");
var $eejVe = parcelRequire("eejVe");

var $kUcVg = parcelRequire("kUcVg");

var $1TOOV = parcelRequire("1TOOV");

var $ce8iU = parcelRequire("ce8iU");
parcelRequire("8T3gX");


var $8jTCz = parcelRequire("8jTCz");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");
const $49ca59357b702eb7$export$6a5b28cd9c30c5d = ()=>{
    const { addMetaDataIgnoreZoneDialogOpen: addMetaDataIgnoreZoneDialogOpen, setAddMetaDataIgnoreZoneDialogOpen: setAddMetaDataIgnoreZoneDialogOpen, metadataTagZones: metadataTagZones, metricLabels: metricLabels, setSelectedMetadataTagZone: setSelectedMetadataTagZone, setEditorVisible: setEditorVisible, shapeColor: shapeColor, newMetadataTagZone: newMetadataTagZone, setNewMetadataTagZone: setNewMetadataTagZone } = (0, $cca596e8c0fe6d2e$export$d71c92fb98393c7a)();
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: addMetaDataIgnoreZoneDialogOpen,
        onClose: ()=>setAddMetaDataIgnoreZoneDialogOpen(false),
        fullWidth: true,
        maxWidth: "xs",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                children: "Add Metadata Ignore Zone"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                sx: {
                    height: "390px"
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "pt-[10px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                            label: "Name",
                            variant: "standard",
                            value: newMetadataTagZone.name,
                            onChange: (event)=>{
                                setNewMetadataTagZone({
                                    ...newMetadataTagZone,
                                    name: event.target.value
                                });
                            },
                            sx: {
                                width: 395
                            },
                            helperText: "",
                            type: "string"
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "pt-[30px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                            multiple: true,
                            disablePortal: true,
                            options: metricLabels,
                            value: metricLabels.filter((metric)=>newMetadataTagZone.metric_labels.includes(metric.id)),
                            onChange: (event, value)=>{
                                setNewMetadataTagZone({
                                    ...newMetadataTagZone,
                                    metric_labels: value.map((metric)=>metric.id)
                                });
                            },
                            getOptionLabel: (option)=>option.display_name,
                            isOptionEqualToValue: (option, value)=>option.id === value.id,
                            sx: {
                                width: 395
                            },
                            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                    ...params,
                                    variant: "standard",
                                    label: "Metrics"
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "pt-[40px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                            label: "Description",
                            multiline: true,
                            rows: 4,
                            value: newMetadataTagZone.description,
                            onChange: (event)=>{
                                setNewMetadataTagZone({
                                    ...newMetadataTagZone,
                                    description: event.target.value
                                });
                            },
                            sx: {
                                width: 395
                            },
                            helperText: "Optional",
                            type: "string"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>setAddMetaDataIgnoreZoneDialogOpen(false),
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setAddMetaDataIgnoreZoneDialogOpen(false);
                            setSelectedMetadataTagZone({
                                // Don't include id property - let API assign it
                                camera: Number((0, $a8BPe.getNumbersAfterEditCamera)(location.href)),
                                name: newMetadataTagZone.name,
                                description: newMetadataTagZone.description,
                                line_color: shapeColor,
                                coordinates: newMetadataTagZone.coordinates,
                                metric_labels: newMetadataTagZone.metric_labels
                            });
                            setEditorVisible(true);
                        },
                        text: "Add",
                        disabled: !newMetadataTagZone.name
                    })
                ]
            })
        ]
    });
};



var $aHe9T = parcelRequire("aHe9T");


var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $ha39s = parcelRequire("ha39s");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $ePwXE = parcelRequire("ePwXE");

var $ka01y = parcelRequire("ka01y");
const $a85835ec83c9e44d$export$cd791c42ebc5b399 = ({ navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed })=>{
    const { metadataTagZones: metadataTagZones, breadcrumbs: breadcrumbs, editorVisible: editorVisible, setEditorVisible: setEditorVisible, setSelectedMetadataTagZone: setSelectedMetadataTagZone, editsMade: editsMade, pageLoading: pageLoading, largerMode: largerMode, dimensions: dimensions, getAllEditMetaDataTagZonesPageInfo: getAllEditMetaDataTagZonesPageInfo, imageURLmdtz: imageURLmdtz, setImageURLmdtz: setImageURLmdtz, setAddMetaDataIgnoreZoneDialogOpen: setAddMetaDataIgnoreZoneDialogOpen, setShapeColor: setShapeColor, shapeColorIndex: shapeColorIndex, setShapeColorIndex: setShapeColorIndex, addMetaDataIgnoreZoneDialogOpen: addMetaDataIgnoreZoneDialogOpen, setNewMetadataTagZone: setNewMetadataTagZone, setShapesArray: setShapesArray, setMtzPolygonPoints: setMtzPolygonPoints, mdtzBuilder: mdtzBuilder, setMdtzBuilder: setMdtzBuilder, selectedMetadataTagZone: selectedMetadataTagZone, metricLabels: metricLabels, setSelectedMetadataTagZoneIndex: setSelectedMetadataTagZoneIndex, editedTagZoneIndexes: editedTagZoneIndexes, setEditedTagZoneIndexes: setEditedTagZoneIndexes, selectedMetadataTagZoneIndex: selectedMetadataTagZoneIndex, setEditsMade: setEditsMade, handlePostMetadataTagZones: handlePostMetadataTagZones, setPageLoading: setPageLoading, handleDeleteMetadataTagZone: handleDeleteMetadataTagZone, cameraInfo: cameraInfo } = (0, $cca596e8c0fe6d2e$export$d71c92fb98393c7a)();
    const handleImageLoad = ()=>{
    // Image loaded successfully
    // setDimensions(resizeImage(naturalWidth, naturalHeight));
    };
    const navigate = (0, $3T949.useNavigate)();
    const siteId = Number((0, $a8BPe.getNumbersAfterSites)(location.href));
    const handleSitesBreadcrumbClick = (event)=>{
        event.preventDefault();
        localStorage.setItem("level0Click", "false");
        localStorage.setItem("navigatedFromSitesAboutPage", "false");
        navigate("/sites");
    };
    const handleSingularSiteBreadcrumbClick = ()=>{
        navigate(`/sites/aboutsite/${siteId}`);
    };
    const handleIgnoreZoneClick = (object)=>{
        setSelectedMetadataTagZone(object);
        setShapeColor(object.line_color);
        // Transform normalized coordinates to pixel coordinates for editing
        const pixelCoordinates = (0, $913bd57b3bd883fb$export$4634b1ea022db412)(object.coordinates, dimensions.width, dimensions.height);
        setShapesArray(pixelCoordinates);
        setEditorVisible(true);
    };
    const [allCamerasData, setAllCamerasData] = $8T3gX.useState([]);
    const [cameraIndex, setCameraIndex] = $8T3gX.useState(0);
    $8T3gX.useEffect(()=>{
        getAllEditMetaDataTagZonesPageInfo(navigate);
        (0, $2hXui.getAllCameras)(Number((0, $a8BPe.getNumbersAfterSites)(location.href)), Number((0, $a8BPe.getNumbersAfterEditCamera)(location.href)), setAllCamerasData, setCameraIndex);
        localStorage.setItem("siteId", (0, $a8BPe.getNumbersAfterSites)(location.href));
        localStorage.setItem("currentCameraId", (0, $a8BPe.getNumbersAfterEditCamera)(location.href));
    }, [
        getAllEditMetaDataTagZonesPageInfo,
        navigate
    ]);
    // Add effect to handle camera changes
    $8T3gX.useEffect(()=>{
        const currentCameraId = (0, $a8BPe.getNumbersAfterEditCamera)(location.href);
        if (currentCameraId) getAllEditMetaDataTagZonesPageInfo(navigate);
    }, [
        getAllEditMetaDataTagZonesPageInfo,
        navigate
    ]);
    $8T3gX.useEffect(()=>{
        if (editorVisible) setMdtzBuilder(/*#__PURE__*/ (0, $k4ank.jsx)((0, $b26551d30fab69e2$export$ac5978a2456900d6), {}));
        else setMdtzBuilder(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
    }, [
        editorVisible,
        setMdtzBuilder
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8gqnT.SyncNeededBanner), {
                navigate: navigate
            }),
            addMetaDataIgnoreZoneDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $49ca59357b702eb7$export$6a5b28cd9c30c5d), {}),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $49ca59357b702eb7$export$6a5b28cd9c30c5d), {}),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "bg-actuate-grey absolute w-full h-full overflow-scroll",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                        openState: pageLoading
                    }),
                    // !pageLoading &&
                    allCamerasData[0] && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: !navBarCollapsed ? "absolute top-[15px] left-[150px] right-[1px] h-[59px] bg-white" : "absolute top-[15px] left-[75px] right-[1px] h-[59px] bg-white",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $4d2348fce80d73d0$export$44a63809e8a3a64a), {
                                        linksArray: (0, $5b5f0ca6080675b7$export$89c67b564440f6c)(breadcrumbs),
                                        handleSitesBreadcrumbClick: handleSitesBreadcrumbClick,
                                        handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick,
                                        styling: "absolute top-[15px] left-[30px]"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "absolute top-[10px] right-[100px]",
                                        children: !editorVisible && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8ZARq.EditViewSyncButton), {
                                            navigate: navigate
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: !navBarCollapsed ? "absolute top-[87px] left-[150px] right-[1px] h-[58px] bg-white" : "absolute top-[87px] left-[75px] right-[1px] h-[58px] bg-white",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "font-black font-mulish text-[20px] p-3 indent-4",
                                    children: cameraInfo.camera_name
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "absolute top-[97px] right-[100px]",
                                children: !editorVisible && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    onClick: ()=>{
                                        setPageLoading(true);
                                        setEditsMade(false);
                                        handlePostMetadataTagZones(navigate);
                                    },
                                    text: "Submit Changes",
                                    disabled: !editsMade
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: !navBarCollapsed ? "absolute top-[145px] left-[150px] right-[1px] h-full bg-white" : "absolute top-[145px] left-[75px] right-[1px] h-full bg-white",
                                children: [
                                    !editorVisible && allCamerasData.length > 1 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "pt-[200px] w-[40px]",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                            title: `Previous Camera: ${cameraIndex === 0 ? allCamerasData[allCamerasData.length - 1].camera_name : allCamerasData[cameraIndex - 1].camera_name}`,
                                            placement: "top",
                                            sx: {
                                                fontSize: "12px",
                                                fontFamily: "mulish"
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                    onClick: ()=>{
                                                        const targetCameraId = cameraIndex === 0 ? allCamerasData[allCamerasData.length - 1].id : allCamerasData[cameraIndex - 1].id;
                                                        navigate(`/sites/${siteId}/editcamera/${targetCameraId}/editmetadatatagzones`);
                                                        // Reset state and reload data for the new camera
                                                        setPageLoading(true);
                                                        setEditorVisible(false);
                                                        setEditsMade(false);
                                                        setImageURLmdtz(""); // Clear image URL immediately
                                                        setSelectedMetadataTagZone({
                                                            camera: targetCameraId,
                                                            name: "",
                                                            description: "",
                                                            line_color: "",
                                                            coordinates: [],
                                                            metric_labels: []
                                                        });
                                                        // Reload camera data
                                                        (0, $2hXui.getAllCameras)(siteId, targetCameraId, setAllCamerasData, setCameraIndex);
                                                        // Reload page info for the new camera
                                                        setTimeout(()=>{
                                                            getAllEditMetaDataTagZonesPageInfo(navigate);
                                                        }, 100);
                                                    },
                                                    text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($frXOV))), {
                                                        fontSize: "large",
                                                        id: "backButton"
                                                    }),
                                                    disabled: allCamerasData.length < 2
                                                })
                                            })
                                        })
                                    }),
                                    !editorVisible && allCamerasData.length > 1 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "absolute top-[200px] left-[1300px]",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                            title: `Next Camera: ${cameraIndex + 1 === allCamerasData.length ? allCamerasData[0].camera_name : allCamerasData[cameraIndex + 1].camera_name}`,
                                            placement: "top",
                                            sx: {
                                                fontSize: "12px",
                                                fontFamily: "mulish"
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                    onClick: ()=>{
                                                        const targetCameraId = cameraIndex + 1 === allCamerasData.length ? allCamerasData[0].id : allCamerasData[cameraIndex + 1].id;
                                                        navigate(`/sites/${siteId}/editcamera/${targetCameraId}/editmetadatatagzones`);
                                                        // Reset state and reload data for the new camera
                                                        setPageLoading(true);
                                                        setEditorVisible(false);
                                                        setEditsMade(false);
                                                        setImageURLmdtz(""); // Clear image URL immediately
                                                        setSelectedMetadataTagZone({
                                                            camera: targetCameraId,
                                                            name: "",
                                                            description: "",
                                                            line_color: "",
                                                            coordinates: [],
                                                            metric_labels: []
                                                        });
                                                        // Reload camera data
                                                        (0, $2hXui.getAllCameras)(siteId, targetCameraId, setAllCamerasData, setCameraIndex);
                                                        // Reload page info for the new camera
                                                        setTimeout(()=>{
                                                            getAllEditMetaDataTagZonesPageInfo(navigate);
                                                        }, 100);
                                                    },
                                                    text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2qUoo))), {
                                                        fontSize: "large",
                                                        id: "backButton"
                                                    }),
                                                    disabled: allCamerasData.length < 2
                                                })
                                            })
                                        })
                                    }),
                                    !editorVisible && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: !navBarCollapsed ? "absolute left-[745px] top-[75px]" : "absolute left-[755px] top-[75px]",
                                            children: [
                                                metadataTagZones.length > 0 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "absolute left-[0px] top-[0px]",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4reBM.default), {
                                                        sx: {
                                                            width: 550,
                                                            height: 360
                                                        },
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                                            sx: {
                                                                maxHeight: 360
                                                            },
                                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                                                sx: {
                                                                    fontFamily: "Mulish",
                                                                    tableLayout: "auto",
                                                                    minWidth: 500
                                                                },
                                                                "aria-label": "simple table",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                                    sx: {
                                                                                        fontWeight: "bold",
                                                                                        width: "60px",
                                                                                        padding: "8px"
                                                                                    },
                                                                                    children: "Color"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                                    sx: {
                                                                                        fontWeight: "bold",
                                                                                        padding: "8px"
                                                                                    },
                                                                                    children: "Name"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                                    sx: {
                                                                                        fontWeight: "bold",
                                                                                        padding: "8px"
                                                                                    },
                                                                                    children: "Metrics"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                                    sx: {
                                                                                        fontWeight: "bold",
                                                                                        width: "80px",
                                                                                        padding: "8px"
                                                                                    }
                                                                                }),
                                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                                    sx: {
                                                                                        fontWeight: "bold",
                                                                                        width: "80px",
                                                                                        padding: "8px"
                                                                                    }
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                                        children: metadataTagZones.map((object, index)=>{
                                                                            return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                                        sx: {
                                                                                            width: "60px",
                                                                                            padding: "8px"
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                                            style: {
                                                                                                height: 25,
                                                                                                width: 25,
                                                                                                background: `${object.line_color}`,
                                                                                                borderRadius: 4,
                                                                                                margin: "0 auto"
                                                                                            }
                                                                                        }, object.label)
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                                        sx: {
                                                                                            padding: "8px"
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                                            style: {
                                                                                                display: "flex",
                                                                                                alignItems: "center",
                                                                                                gap: "4px"
                                                                                            },
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                                                                    style: {
                                                                                                        maxWidth: "150px"
                                                                                                    },
                                                                                                    children: object.name
                                                                                                }),
                                                                                                object.description && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                                                                    title: object.description,
                                                                                                    placement: "top",
                                                                                                    sx: {
                                                                                                        fontSize: "15px",
                                                                                                        fontFamily: "mulish"
                                                                                                    },
                                                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                                                                                        fontSize: "small"
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                                        sx: {
                                                                                            padding: "8px"
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                                            style: {
                                                                                                maxWidth: "200px"
                                                                                            },
                                                                                            children: object.metric_labels.map((metricId)=>{
                                                                                                const metric = metricLabels.find((m)=>m.id === metricId);
                                                                                                return metric ? metric.display_name : `Unknown (${metricId})`;
                                                                                            }).join(", ")
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                                        sx: {
                                                                                            width: "80px",
                                                                                            padding: "8px"
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                                                            onClick: ()=>{
                                                                                                setSelectedMetadataTagZone(object);
                                                                                                setSelectedMetadataTagZoneIndex(index);
                                                                                                handleIgnoreZoneClick(object);
                                                                                            },
                                                                                            text: "Edit",
                                                                                            disabled: false
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                                        sx: {
                                                                                            width: "80px",
                                                                                            padding: "8px"
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                                                            title: "Delete",
                                                                                            placement: "top",
                                                                                            sx: {
                                                                                                fontSize: "15px",
                                                                                                fontFamily: "mulish"
                                                                                            },
                                                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                                                                onClick: ()=>{
                                                                                                    setPageLoading(true);
                                                                                                    handleDeleteMetadataTagZone(object.id, navigate);
                                                                                                },
                                                                                                text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ka01y))), {
                                                                                                    fontSize: "small"
                                                                                                }),
                                                                                                disabled: false
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }, object.id);
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                }),
                                                metadataTagZones.length === 0 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "absolute left-[80px] top-[130px] w-[275px]",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                        className: "font-mulish text-[16px] indent-5",
                                                        children: "No Metadata Tag Zones added"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    // !pageLoading &&
                                    !editorVisible && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "absolute top-[53px] left-[70px]",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                                                src: imageURLmdtz,
                                                style: {
                                                    width: `${dimensions.width}px`,
                                                    height: `${dimensions.height}px`
                                                },
                                                onLoad: handleImageLoad,
                                                alt: "TestCameraPhoto"
                                            }),
                                            !editorVisible && metadataTagZones.map((object)=>{
                                                return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "absolute top-[0px]",
                                                    children: object.coordinates[0] && object.coordinates.map((array, index)=>{
                                                        return /*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                                                            className: "absolute top-[0px]",
                                                            style: {
                                                                width: `${dimensions.width}px`,
                                                                height: `${dimensions.height}px`
                                                            },
                                                            children: dimensions && /*#__PURE__*/ (0, $k4ank.jsx)("polygon", {
                                                                points: (0, $35d84607375812b2$export$c2c757e9d9431ca3)(object.coordinates[index], dimensions.height, dimensions.width),
                                                                stroke: object.line_color,
                                                                strokeWidth: "5",
                                                                fill: object.line_color,
                                                                fillOpacity: "50%"
                                                            })
                                                        }, index);
                                                    })
                                                }, object.label);
                                            })
                                        ]
                                    }),
                                    editorVisible && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "player absolute top-[0px] left-[67px] w-[775px] h-[200px]",
                                        role: "button",
                                        tabIndex: 0,
                                        children: mdtzBuilder
                                    })
                                ]
                            }),
                            !editorVisible && // metadataTagZones.length > 0 &&
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: !navBarCollapsed ? "absolute top-[167px] left-[900px] w-[460px] font-mulish text-[18px] font-bold text-actuate-blue flex" : "absolute top-[167px] left-[825px] w-[460px] font-mulish text-[18px] font-bold text-actuate-blue flex",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                                    children: "Metadata Tag Zones"
                                })
                            }),
                            !editorVisible && // metadataTagZones.length > 0 &&
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: !navBarCollapsed ? "absolute top-[164px] left-[1190px] w-[210px]" : "absolute top-[164px] left-[1115px] w-[210px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    onClick: ()=>{
                                        // Find the next available color that's not already used
                                        const usedColors = metadataTagZones.map((zone)=>zone.line_color);
                                        let nextColorIndex = 0;
                                        // Find the first color that's not already used
                                        for(let i = 0; i < (0, $aHe9T.metadataTagZonesColorArray).length; i++)if (!usedColors.includes((0, $aHe9T.metadataTagZonesColorArray)[i])) {
                                            nextColorIndex = i;
                                            break;
                                        }
                                        // If all colors are used, cycle through them starting from the current index
                                        if (usedColors.length >= (0, $aHe9T.metadataTagZonesColorArray).length) {
                                            nextColorIndex = shapeColorIndex;
                                            setShapeColorIndex((shapeColorIndex + 1) % (0, $aHe9T.metadataTagZonesColorArray).length);
                                        } else setShapeColorIndex(nextColorIndex);
                                        const selectedColor = (0, $aHe9T.metadataTagZonesColorArray)[nextColorIndex];
                                        setShapeColor(selectedColor);
                                        setNewMetadataTagZone({
                                            camera: Number((0, $a8BPe.getNumbersAfterEditCamera)(location.href)),
                                            name: "",
                                            description: "",
                                            line_color: selectedColor,
                                            coordinates: [],
                                            metric_labels: []
                                        });
                                        // Clear shapes for new metadata tag zone
                                        setShapesArray([]);
                                        setMtzPolygonPoints([]);
                                        setAddMetaDataIgnoreZoneDialogOpen(true);
                                    },
                                    text: "+ Add Metadata Tag Zone",
                                    disabled: false
                                })
                            }),
                            editorVisible && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: !navBarCollapsed ? largerMode ? "absolute top-[212px] left-[1280px] font-mulish text-[20px] text-actuate-blue min-w-[470px] pr-[40px]" : "absolute top-[212px] left-[980px] font-mulish text-[20px] text-actuate-blue min-w-[470px] pr-[40px]" : largerMode ? "absolute top-[212px] left-[1200px] font-mulish text-[20px] text-actuate-blue min-w-[500px] pr-[40px]" : "absolute top-[212px] left-[900px] font-mulish text-[20px] text-actuate-blue min-w-[500px] pr-[40px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "pt-[10px]",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                            label: "Name",
                                            variant: "standard",
                                            value: selectedMetadataTagZone.name,
                                            onChange: (event)=>{
                                                if (selectedMetadataTagZoneIndex !== null && !editedTagZoneIndexes.includes(selectedMetadataTagZoneIndex)) setEditedTagZoneIndexes([
                                                    ...editedTagZoneIndexes,
                                                    selectedMetadataTagZoneIndex
                                                ]);
                                                setEditsMade(true);
                                                setSelectedMetadataTagZone({
                                                    ...selectedMetadataTagZone,
                                                    name: event.target.value
                                                });
                                            },
                                            onKeyDown: (event)=>{
                                                // Prevent backspace from bubbling up to PolygonDrawer
                                                event.stopPropagation();
                                            },
                                            sx: {
                                                width: 395
                                            },
                                            helperText: "",
                                            type: "string"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "pt-[30px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                                multiple: true,
                                                disablePortal: true,
                                                options: metricLabels,
                                                value: metricLabels.filter((metric)=>selectedMetadataTagZone.metric_labels.includes(metric.id)),
                                                onChange: (event, value)=>{
                                                    if (selectedMetadataTagZoneIndex !== null && !editedTagZoneIndexes.includes(selectedMetadataTagZoneIndex)) setEditedTagZoneIndexes([
                                                        ...editedTagZoneIndexes,
                                                        selectedMetadataTagZoneIndex
                                                    ]);
                                                    setEditsMade(true);
                                                    setSelectedMetadataTagZone({
                                                        ...selectedMetadataTagZone,
                                                        metric_labels: value.map((metric)=>metric.id)
                                                    });
                                                },
                                                onKeyDown: (event)=>{
                                                    // Prevent backspace from bubbling up to PolygonDrawer
                                                    event.stopPropagation();
                                                },
                                                getOptionLabel: (option)=>option.display_name,
                                                isOptionEqualToValue: (option, value)=>option.id === value.id,
                                                sx: {
                                                    width: 395
                                                },
                                                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                        ...params,
                                                        variant: "standard",
                                                        label: "Metrics",
                                                        onKeyDown: (event)=>{
                                                            // Prevent backspace from bubbling up to PolygonDrawer
                                                            event.stopPropagation();
                                                        }
                                                    })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "pt-[40px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                label: "Description",
                                                multiline: true,
                                                rows: 4,
                                                value: selectedMetadataTagZone.description,
                                                onChange: (event)=>{
                                                    if (selectedMetadataTagZoneIndex !== null && !editedTagZoneIndexes.includes(selectedMetadataTagZoneIndex)) setEditedTagZoneIndexes([
                                                        ...editedTagZoneIndexes,
                                                        selectedMetadataTagZoneIndex
                                                    ]);
                                                    setEditsMade(true);
                                                    setSelectedMetadataTagZone({
                                                        ...selectedMetadataTagZone,
                                                        description: event.target.value
                                                    });
                                                },
                                                onKeyDown: (event)=>{
                                                    // Prevent backspace from bubbling up to PolygonDrawer
                                                    event.stopPropagation();
                                                },
                                                sx: {
                                                    width: 395
                                                },
                                                helperText: "Optional",
                                                type: "string"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "justify-start",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jVN1H.NavBar), {
                    navBarCollapsed: navBarCollapsed,
                    setNavBarCollapsed: setNavBarCollapsed,
                    props: {}
                })
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $jVN1H = parcelRequire("jVN1H");

var $iMum1 = parcelRequire("iMum1");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $3baw3 = parcelRequire("3baw3");

var $ddLR4 = parcelRequire("ddLR4");

var $iMum1 = parcelRequire("iMum1");

var $1Xths = parcelRequire("1Xths");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");
const $01d0fa6d6db7eaa4$var$LARGER_MODE_SCALE = 1.5;
// Draw perpendicular crossing line with arrow
const $01d0fa6d6db7eaa4$var$drawArrow = (ctx, start, end, direction, lineColor)=>{
    const centerX = (start[0] + end[0]) / 2;
    const centerY = (start[1] + end[1]) / 2;
    // Calculate the main line vector
    const dx = end[0] - start[0];
    const dy = end[1] - start[1];
    const lineLength = Math.sqrt(dx * dx + dy * dy);
    if (lineLength === 0) return;
    // Calculate perpendicular vector (rotate 90 degrees)
    // For a vector (dx, dy), the perpendicular is (-dy, dx) or (dy, -dx)
    // We'll use (-dy, dx) to get the left side when facing from A to B
    const perpDx = -dy / lineLength;
    const perpDy = dx / lineLength;
    // Length of the crossing line - longer
    const crossingLineLength = 50;
    const halfLength = crossingLineLength / 2;
    // Arrow properties - equilateral triangle
    const arrowLength = 12;
    // For equilateral triangle: base = 2 * height / sqrt(3)
    // Making it wider for equilateral triangle look
    const arrowWidth = 2 * arrowLength / Math.sqrt(3); // Approximately 13.86 for equilateral
    // Use actuate-blue for the crossing arrow
    const crossingArrowColor = "#FF1744"; // Neon red
    const drawCrossingLineWithArrow = (sideMultiplier, fromCenter)=>{
        // Calculate the perpendicular offset
        const offsetX = perpDx * halfLength * sideMultiplier;
        const offsetY = perpDy * halfLength * sideMultiplier;
        // Calculate the arrow tip position (end of the crossing line)
        const arrowTipX = centerX + offsetX;
        const arrowTipY = centerY + offsetY;
        // Calculate where the line should end (arrowhead base, which is arrowLength back from tip)
        const arrowBaseOffsetX = perpDx * arrowLength * sideMultiplier;
        const arrowBaseOffsetY = perpDy * arrowLength * sideMultiplier;
        const lineEndX = arrowTipX - arrowBaseOffsetX;
        const lineEndY = arrowTipY - arrowBaseOffsetY;
        // Start point of the crossing line
        // For single direction: from opposite side (full line)
        // For "Both": from center (half line on each side)
        const crossStartX = fromCenter ? centerX : centerX - offsetX; // Opposite side
        const crossStartY = fromCenter ? centerY : centerY - offsetY; // Opposite side
        // Draw the crossing line (stops at arrowhead base)
        ctx.strokeStyle = crossingArrowColor;
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(crossStartX, crossStartY);
        ctx.lineTo(lineEndX, lineEndY);
        ctx.stroke();
        // Draw arrowhead at the tip (pointing away from the main line)
        const arrowAngle = Math.atan2(offsetY, offsetX);
        ctx.save();
        ctx.translate(arrowTipX, arrowTipY);
        ctx.rotate(arrowAngle);
        ctx.fillStyle = crossingArrowColor;
        ctx.beginPath();
        ctx.moveTo(0, 0); // Arrow tip
        ctx.lineTo(-arrowLength, -arrowWidth / 2); // Base corner 1
        ctx.lineTo(-arrowLength, arrowWidth / 2); // Base corner 2
        ctx.closePath();
        ctx.fill();
        ctx.restore();
    };
    // Draw based on direction
    // AtoB: arrow on side B (pointing from A toward B)
    // BtoA: arrow on side A (pointing from B toward A)
    // Both: draw arrows on both sides
    // Note: sideMultiplier = -1 puts arrow on side A, sideMultiplier = 1 puts arrow on side B
    if (direction === "AtoB") // Full line from side A to side B arrowhead base
    drawCrossingLineWithArrow(1, false); // Side B (counter-clockwise/left) - pointing from A to B
    else if (direction === "BtoA") // Full line from side B to side A arrowhead base
    drawCrossingLineWithArrow(-1, false); // Side A (clockwise/right) - pointing from B to A
    else if (direction === "Both") {
        // For "Both", draw two separate lines from center, each stopping at arrowhead base
        // Side A (clockwise/right)
        drawCrossingLineWithArrow(-1, true);
        // Side B (counter-clockwise/left)
        drawCrossingLineWithArrow(1, true);
    }
};
const $01d0fa6d6db7eaa4$export$360e6f46aa8bdfbf = ({ largerMode: largerMode = false, setLargerMode: setLargerMode } = {})=>{
    const canvasRef = (0, $8T3gX.useRef)(null);
    const { lines: lines, setLines: setLines, currentLine: currentLine, setCurrentLine: setCurrentLine, isDrawing: isDrawing, setIsDrawing: setIsDrawing, selectedLineIndex: selectedLineIndex, setSelectedLineIndex: setSelectedLineIndex, lineColor: lineColor, dimensions: dimensions, imageURL: imageURL, metricLabels: metricLabels, setEditsMade: setEditsMade, lineCrossingActive: lineCrossingActive } = (0, $iMum1.useEditLineCrossingsStore)();
    const imageWidth = dimensions.width;
    const imageHeight = dimensions.height;
    const [hoveredLineIndex, setHoveredLineIndex] = (0, $8T3gX.useState)(null);
    const [hoveredPointIndex, setHoveredPointIndex] = (0, $8T3gX.useState)(null);
    const [dragging, setDragging] = (0, $8T3gX.useState)(false);
    const [draggedPointIndex, setDraggedPointIndex] = (0, $8T3gX.useState)(null);
    const [mousePosition, setMousePosition] = (0, $8T3gX.useState)(null);
    const padding = 20;
    const logicalWidth = imageWidth + padding * 2;
    const logicalHeight = imageHeight + padding * 2;
    // Convert display (scaled) coordinates to logical canvas coordinates
    const displayToLogical = (displayX, displayY, rect)=>{
        const mouseX = displayX * logicalWidth / rect.width;
        const mouseY = displayY * logicalHeight / rect.height;
        return [
            mouseX,
            mouseY
        ];
    };
    // Calculate distance between point and mouse
    const getDistance = (point, mouse)=>{
        return Math.hypot(point[0] - mouse[0], point[1] - mouse[1]);
    };
    // Check if mouse is near a line segment
    const isNearLine = (start, end, mouse, threshold = 5)=>{
        const dx = end[0] - start[0];
        const dy = end[1] - start[1];
        const lengthSquared = dx * dx + dy * dy;
        if (lengthSquared === 0) return getDistance(start, mouse) < threshold;
        const t = Math.max(0, Math.min(1, ((mouse[0] - start[0]) * dx + (mouse[1] - start[1]) * dy) / lengthSquared));
        const closestX = start[0] + t * dx;
        const closestY = start[1] + t * dy;
        const distance = Math.hypot(mouse[0] - closestX, mouse[1] - closestY);
        return distance < threshold;
    };
    // Draw canvas
    (0, $8T3gX.useEffect)(()=>{
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext("2d");
        if (!ctx) return;
        const redrawCanvas = ()=>{
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            // Draw all completed lines
            lines.forEach((line, index)=>{
                const isSelected = selectedLineIndex === index;
                const isHovered = hoveredLineIndex === index;
                // Use line's own color, with overrides for selected/hovered states
                // Hover: #FF2400 (red)
                const displayColor = isHovered ? "#FF2400" : line.color;
                ctx.strokeStyle = displayColor;
                // Selected lines are thicker to make them more obvious
                ctx.lineWidth = isSelected ? 5 : isHovered ? 3 : 2;
                ctx.beginPath();
                ctx.moveTo(line.coordinates[0][0], line.coordinates[0][1]);
                ctx.lineTo(line.coordinates[1][0], line.coordinates[1][1]);
                ctx.stroke();
                // Draw arrow(s) in the center
                $01d0fa6d6db7eaa4$var$drawArrow(ctx, line.coordinates[0], line.coordinates[1], line.direction, displayColor);
                // Draw points only for selected line
                if (isSelected) line.coordinates.forEach((point, pointIdx)=>{
                    const isPointHovered = hoveredPointIndex === index * 2 + pointIdx || dragging && draggedPointIndex === index * 2 + pointIdx;
                    ctx.beginPath();
                    const pointRadius = 7;
                    ctx.arc(point[0], point[1], pointRadius, 0, Math.PI * 2);
                    ctx.fillStyle = isPointHovered ? "#FF2400" // Red when point is hovered
                     : line.color; // Line's own color
                    ctx.fill();
                });
                // Draw A and B labels on the sides of the line for selected line
                if (isSelected) {
                    ctx.fillStyle = "#FF1744"; // Neon red
                    ctx.font = "bold 16px Arial";
                    ctx.textAlign = "center";
                    ctx.textBaseline = "middle";
                    // Add subtle drop shadow for better visibility
                    ctx.shadowColor = "rgba(0, 0, 0, 0.5)";
                    ctx.shadowBlur = 3;
                    ctx.shadowOffsetX = 1;
                    ctx.shadowOffsetY = 1;
                    // Calculate the center of the line
                    const centerX = (line.coordinates[0][0] + line.coordinates[1][0]) / 2;
                    const centerY = (line.coordinates[0][1] + line.coordinates[1][1]) / 2;
                    // Calculate the line vector
                    const dx = line.coordinates[1][0] - line.coordinates[0][0];
                    const dy = line.coordinates[1][1] - line.coordinates[0][1];
                    const lineLength = Math.sqrt(dx * dx + dy * dy);
                    if (lineLength > 0) {
                        // Calculate perpendicular vector (for side labels)
                        const perpDx = -dy / lineLength;
                        const perpDy = dx / lineLength;
                        // Label offset from the line - increased to avoid overlapping with arrows
                        const labelOffset = 40;
                        // Going clockwise: point 1 -> side A (clockwise/right) -> point 2 -> side B (counter-clockwise/left)
                        // Draw "A" on the clockwise/right side (when facing from point 1 to point 2)
                        const sideAX = centerX - perpDx * labelOffset;
                        const sideAY = centerY - perpDy * labelOffset;
                        ctx.fillText("A", sideAX, sideAY);
                        // Draw "B" on the counter-clockwise/left side (when facing from point 1 to point 2)
                        const sideBX = centerX + perpDx * labelOffset;
                        const sideBY = centerY + perpDy * labelOffset;
                        ctx.fillText("B", sideBX, sideBY);
                    }
                    // Reset shadow for subsequent drawing
                    ctx.shadowColor = "transparent";
                    ctx.shadowBlur = 0;
                    ctx.shadowOffsetX = 0;
                    ctx.shadowOffsetY = 0;
                }
            });
            // Draw current line being drawn
            if (currentLine && isDrawing) {
                ctx.strokeStyle = currentLine.color;
                ctx.lineWidth = 2;
                ctx.beginPath();
                ctx.moveTo(currentLine.coordinates[0][0], currentLine.coordinates[0][1]);
                if (mousePosition) ctx.lineTo(mousePosition[0], mousePosition[1]);
                else ctx.lineTo(currentLine.coordinates[1][0], currentLine.coordinates[1][1]);
                ctx.stroke();
                // Draw start point
                ctx.beginPath();
                ctx.arc(currentLine.coordinates[0][0], currentLine.coordinates[0][1], 5, 0, Math.PI * 2);
                ctx.fillStyle = currentLine.color;
                ctx.fill();
            }
        };
        // Draw the canvas
        redrawCanvas();
    }, [
        lines,
        currentLine,
        isDrawing,
        selectedLineIndex,
        hoveredLineIndex,
        hoveredPointIndex,
        dragging,
        draggedPointIndex,
        mousePosition,
        lineColor,
        imageWidth,
        imageHeight,
        imageURL
    ]);
    const handleMouseDown = (e)=>{
        const canvas = canvasRef.current;
        if (!canvas) return;
        const rect = canvas.getBoundingClientRect();
        const [mouseXDisplay, mouseYDisplay] = displayToLogical(e.clientX - rect.left, e.clientY - rect.top, rect);
        let mouseX = mouseXDisplay;
        let mouseY = mouseYDisplay;
        // Constrain to image bounds
        if (mouseX < padding) mouseX = padding;
        if (mouseX > imageWidth + padding) mouseX = imageWidth + padding;
        if (mouseY < padding) mouseY = padding;
        if (mouseY > imageHeight + padding) mouseY = imageHeight + padding;
        // Check if clicking on an existing point
        let clickedPointIndex = null;
        lines.forEach((line, lineIdx)=>{
            if (getDistance(line.coordinates[0], [
                mouseX,
                mouseY
            ]) < 5) {
                clickedPointIndex = lineIdx * 2;
                setSelectedLineIndex(lineIdx);
                setDragging(true);
                setDraggedPointIndex(clickedPointIndex);
                return;
            }
            if (getDistance(line.coordinates[1], [
                mouseX,
                mouseY
            ]) < 5) {
                clickedPointIndex = lineIdx * 2 + 1;
                setSelectedLineIndex(lineIdx);
                setDragging(true);
                setDraggedPointIndex(clickedPointIndex);
                return;
            }
        });
        if (clickedPointIndex !== null) return;
        // Check if clicking on an existing line
        let clickedLineIndex = null;
        lines.forEach((line, lineIdx)=>{
            if (isNearLine(line.coordinates[0], line.coordinates[1], [
                mouseX,
                mouseY
            ])) {
                clickedLineIndex = lineIdx;
                setSelectedLineIndex(lineIdx);
                return;
            }
        });
        if (clickedLineIndex !== null) return;
        // Start drawing a new line
        if (!isDrawing) {
            const cameraId = Number((0, $a8BPe.getNumbersAfterEditCamera)(location.href));
            const newLineColor = (0, $1Xths.getNextLineColor)(lines);
            // Only include metrics for active detection types
            const activeMetricIds = metricLabels.filter((m)=>{
                if (m.label_name === "intruder_line_crossing") return lineCrossingActive.intruder;
                if (m.label_name === "vehicle_line_crossing" || m.label_name === "bike_line_crossing") return lineCrossingActive.vehicle;
                return false;
            }).map((m)=>m.id);
            setIsDrawing(true);
            setCurrentLine({
                // id is omitted for new lines - API will assign it
                camera: cameraId,
                metric_labels: activeMetricIds,
                coordinates: [
                    [
                        mouseX,
                        mouseY
                    ],
                    [
                        mouseX,
                        mouseY
                    ]
                ],
                color: newLineColor,
                direction: "AtoB"
            });
            setSelectedLineIndex(null);
        } else if (currentLine) {
            // Complete the line
            const completedLine = {
                ...currentLine,
                coordinates: [
                    currentLine.coordinates[0],
                    [
                        mouseX,
                        mouseY
                    ]
                ]
            };
            const newLines = [
                ...lines,
                completedLine
            ];
            setLines(newLines);
            setCurrentLine(null);
            setIsDrawing(false);
            setMousePosition(null);
            // Select the newly created line (it's at the last index)
            setSelectedLineIndex(newLines.length - 1);
        }
    };
    const handleMouseMove = (e)=>{
        const canvas = canvasRef.current;
        if (!canvas) return;
        const rect = canvas.getBoundingClientRect();
        const [mouseXDisplay, mouseYDisplay] = displayToLogical(e.clientX - rect.left, e.clientY - rect.top, rect);
        let mouseX = mouseXDisplay;
        let mouseY = mouseYDisplay;
        // Constrain to image bounds
        if (mouseX < padding) mouseX = padding;
        if (mouseX > imageWidth + padding) mouseX = imageWidth + padding;
        if (mouseY < padding) mouseY = padding;
        if (mouseY > imageHeight + padding) mouseY = imageHeight + padding;
        if (dragging && draggedPointIndex !== null && selectedLineIndex !== null) {
            // Update the dragged point - create new line object to avoid mutating original
            const updatedLines = lines.map((line, index)=>{
                if (index !== selectedLineIndex) return line;
                // Create new line with updated coordinates
                const newCoordinates = draggedPointIndex % 2 === 0 ? [
                    [
                        mouseX,
                        mouseY
                    ],
                    line.coordinates[1]
                ] : [
                    line.coordinates[0],
                    [
                        mouseX,
                        mouseY
                    ]
                ];
                return {
                    ...line,
                    coordinates: newCoordinates
                };
            });
            setLines(updatedLines);
            setEditsMade(true);
        } else if (isDrawing && currentLine) // Update preview line
        setMousePosition([
            mouseX,
            mouseY
        ]);
        else {
            // Check for hover states
            let foundHover = false;
            // Check points first
            lines.forEach((line, lineIdx)=>{
                if (getDistance(line.coordinates[0], [
                    mouseX,
                    mouseY
                ]) < 5) {
                    setHoveredPointIndex(lineIdx * 2);
                    setHoveredLineIndex(null);
                    foundHover = true;
                    return;
                }
                if (getDistance(line.coordinates[1], [
                    mouseX,
                    mouseY
                ]) < 5) {
                    setHoveredPointIndex(lineIdx * 2 + 1);
                    setHoveredLineIndex(null);
                    foundHover = true;
                    return;
                }
            });
            if (!foundHover) {
                setHoveredPointIndex(null);
                // Check lines
                let hoveredLine = null;
                lines.forEach((line, lineIdx)=>{
                    if (isNearLine(line.coordinates[0], line.coordinates[1], [
                        mouseX,
                        mouseY
                    ])) hoveredLine = lineIdx;
                });
                setHoveredLineIndex(hoveredLine);
            }
        }
    };
    const handleMouseUp = ()=>{
        if (dragging) {
            setDragging(false);
            setDraggedPointIndex(null);
        }
    };
    // Handle delete key
    (0, $8T3gX.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Backspace" || event.key === "Delete") {
                if (selectedLineIndex !== null) {
                    const updatedLines = lines.filter((_, index)=>index !== selectedLineIndex);
                    setLines(updatedLines);
                    setSelectedLineIndex(null);
                }
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return ()=>{
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        selectedLineIndex,
        lines,
        setLines,
        setSelectedLineIndex
    ]);
    const cursorType = dragging || hoveredPointIndex !== null || hoveredLineIndex !== null ? "pointer" : "crosshair";
    const drawingArea = /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        style: {
            position: "relative",
            width: logicalWidth,
            height: logicalHeight,
            border: "2px solid black"
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                src: imageURL,
                alt: "Camera Preview",
                style: {
                    position: "absolute",
                    top: padding,
                    left: padding,
                    width: imageWidth,
                    height: imageHeight,
                    pointerEvents: "none"
                }
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("canvas", {
                ref: canvasRef,
                width: logicalWidth,
                height: logicalHeight,
                onMouseDown: handleMouseDown,
                onMouseMove: handleMouseMove,
                onMouseUp: handleMouseUp,
                style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    cursor: cursorType,
                    background: "transparent"
                }
            })
        ]
    });
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            setLargerMode && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "font-mulish",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                    sx: {
                        fontFamily: "Mulish"
                    },
                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ddLR4.default), {
                        color: "warning",
                        checked: largerMode,
                        disabled: false,
                        onChange: (event)=>{
                            setLargerMode(event.target.checked);
                        }
                    }),
                    label: "Larger Mode"
                })
            }),
            setLargerMode && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                style: {
                    marginBottom: "10px"
                }
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                style: {
                    position: "relative",
                    width: largerMode ? logicalWidth * $01d0fa6d6db7eaa4$var$LARGER_MODE_SCALE : logicalWidth,
                    height: largerMode ? logicalHeight * $01d0fa6d6db7eaa4$var$LARGER_MODE_SCALE : logicalHeight
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    style: {
                        transform: largerMode ? `scale(${$01d0fa6d6db7eaa4$var$LARGER_MODE_SCALE})` : "none",
                        transformOrigin: "top left",
                        width: logicalWidth,
                        height: logicalHeight
                    },
                    children: drawingArea
                })
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");
var $kbChx = parcelRequire("kbChx");
var $7UDCh = parcelRequire("7UDCh");
var $3baw3 = parcelRequire("3baw3");
var $2SHRA = parcelRequire("2SHRA");
var $lk6eW = parcelRequire("lk6eW");
var $k1BHZ = parcelRequire("k1BHZ");
var $imWqP = parcelRequire("imWqP");

var $iMum1 = parcelRequire("iMum1");
const $0e6900355b5ad911$export$eea8660070751cac = ()=>{
    const { lines: lines, selectedLineIndex: selectedLineIndex, updateLineDirection: updateLineDirection, metricLabels: metricLabels, updateLineMetricLabels: updateLineMetricLabels, lineCrossingActive: lineCrossingActive } = (0, $iMum1.useEditLineCrossingsStore)();
    const selectedLine = selectedLineIndex !== null ? lines[selectedLineIndex] : null;
    // Only show a direction if a line is actually selected
    const currentDirection = selectedLine?.direction || "";
    const currentMetricLabels = selectedLine?.metric_labels || [];
    // Get the selected line's color, default to orange if no line selected
    const lineColor = selectedLine?.color || "#ed6c02";
    const handleDirectionChange = (event)=>{
        const newDirection = event.target.value;
        if (selectedLineIndex !== null) updateLineDirection(selectedLineIndex, newDirection);
    };
    // Separate intruder from vehicle/bike metrics
    const intruderMetric = metricLabels.find((m)=>m.label_name === "intruder_line_crossing");
    const vehicleMetric = metricLabels.find((m)=>m.label_name === "vehicle_line_crossing");
    const bikeMetric = metricLabels.find((m)=>m.label_name === "bike_line_crossing");
    // Check if vehicle/bike combined checkbox should be checked (either one is checked)
    const isVehicleBikeChecked = vehicleMetric && currentMetricLabels.includes(vehicleMetric.id) || bikeMetric && currentMetricLabels.includes(bikeMetric.id);
    const handleMetricChange = (metricId, checked)=>{
        if (selectedLineIndex === null) return;
        let newMetricLabels;
        if (checked) // Add the metric if it's not already present
        newMetricLabels = [
            ...currentMetricLabels,
            metricId
        ];
        else {
            // Remove the metric, but prevent unchecking if it's the last one
            newMetricLabels = currentMetricLabels.filter((id)=>id !== metricId);
            // Ensure at least one metric remains selected
            if (newMetricLabels.length === 0) return; // Don't allow unchecking the last metric
        }
        updateLineMetricLabels(selectedLineIndex, newMetricLabels);
    };
    // Handle combined Vehicle/Bike checkbox
    const handleVehicleBikeChange = (checked)=>{
        if (selectedLineIndex === null) return;
        let newMetricLabels = [
            ...currentMetricLabels
        ];
        if (checked) {
            // Add both vehicle and bike IDs if they exist and aren't already present
            if (vehicleMetric && !newMetricLabels.includes(vehicleMetric.id)) newMetricLabels.push(vehicleMetric.id);
            if (bikeMetric && !newMetricLabels.includes(bikeMetric.id)) newMetricLabels.push(bikeMetric.id);
        } else {
            // Remove both vehicle and bike IDs, but prevent if it would leave no metrics
            const vehicleId = vehicleMetric?.id;
            const bikeId = bikeMetric?.id;
            const potentialNewLabels = newMetricLabels.filter((id)=>id !== vehicleId && id !== bikeId);
            // Ensure at least one metric remains selected
            if (potentialNewLabels.length === 0) return; // Don't allow unchecking if it would remove all metrics
            newMetricLabels = potentialNewLabels;
        }
        updateLineMetricLabels(selectedLineIndex, newMetricLabels);
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
        sx: {
            p: 2,
            bgcolor: "background.paper",
            minWidth: "250px",
            height: "fit-content"
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                component: "fieldset",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $lk6eW.default), {
                        component: "legend",
                        sx: {
                            fontFamily: "Mulish",
                            fontSize: "16px",
                            fontWeight: "bold",
                            color: "black !important",
                            "&.Mui-focused": {
                                color: "black !important"
                            },
                            "&:hover": {
                                color: "black !important"
                            }
                        },
                        children: "Line Crossing Direction"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $imWqP.default), {
                        value: currentDirection,
                        onChange: handleDirectionChange,
                        row: true,
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                value: "AtoB",
                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {
                                    sx: {
                                        color: "black",
                                        "&.Mui-checked": {
                                            color: lineColor
                                        }
                                    }
                                }),
                                label: "A to B",
                                disabled: selectedLineIndex === null,
                                sx: {
                                    fontFamily: "Mulish",
                                    "& .MuiFormControlLabel-label": {
                                        fontFamily: "Mulish",
                                        color: "black"
                                    },
                                    "&.Mui-disabled .MuiFormControlLabel-label": {
                                        color: "rgba(0, 0, 0, 0.26) !important"
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                value: "BtoA",
                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {
                                    sx: {
                                        color: "black",
                                        "&.Mui-checked": {
                                            color: lineColor
                                        }
                                    }
                                }),
                                label: "B to A",
                                disabled: selectedLineIndex === null,
                                sx: {
                                    fontFamily: "Mulish",
                                    "& .MuiFormControlLabel-label": {
                                        fontFamily: "Mulish",
                                        color: "black"
                                    },
                                    "&.Mui-disabled .MuiFormControlLabel-label": {
                                        color: "rgba(0, 0, 0, 0.26) !important"
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                value: "Both",
                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {
                                    sx: {
                                        color: "black",
                                        "&.Mui-checked": {
                                            color: lineColor
                                        }
                                    }
                                }),
                                label: "Both",
                                disabled: selectedLineIndex === null,
                                sx: {
                                    fontFamily: "Mulish",
                                    "& .MuiFormControlLabel-label": {
                                        fontFamily: "Mulish",
                                        color: "black"
                                    },
                                    "&.Mui-disabled .MuiFormControlLabel-label": {
                                        color: "rgba(0, 0, 0, 0.26) !important"
                                    }
                                }
                            })
                        ]
                    }),
                    selectedLineIndex === null && /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                        sx: {
                            mt: 1,
                            fontSize: "0.875rem",
                            color: "text.secondary",
                            fontFamily: "Mulish"
                        },
                        children: "Select a line to change its direction. Or click anywhere on the image to start a new line."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                component: "fieldset",
                fullWidth: true,
                sx: {
                    mt: 3
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $lk6eW.default), {
                        component: "legend",
                        sx: {
                            fontFamily: "Mulish",
                            fontSize: "16px",
                            fontWeight: "bold",
                            color: "black !important",
                            "&.Mui-focused": {
                                color: "black !important"
                            },
                            "&:hover": {
                                color: "black !important"
                            }
                        },
                        children: "Detection Types"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $2SHRA.default), {
                        children: [
                            intruderMetric && lineCrossingActive.intruder && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                    checked: currentMetricLabels.includes(intruderMetric.id),
                                    onChange: (e)=>handleMetricChange(intruderMetric.id, e.target.checked),
                                    disabled: selectedLineIndex === null || currentMetricLabels.includes(intruderMetric.id) && currentMetricLabels.length === 1,
                                    sx: {
                                        color: "black",
                                        "&.Mui-checked": {
                                            color: lineColor
                                        }
                                    }
                                }),
                                label: "Intruder",
                                sx: {
                                    fontFamily: "Mulish",
                                    "& .MuiFormControlLabel-label": {
                                        fontFamily: "Mulish",
                                        color: "black"
                                    },
                                    "&.Mui-disabled .MuiFormControlLabel-label": {
                                        color: "rgba(0, 0, 0, 0.26) !important"
                                    }
                                }
                            }),
                            (vehicleMetric || bikeMetric) && lineCrossingActive.vehicle && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                    checked: !!isVehicleBikeChecked,
                                    onChange: (e)=>handleVehicleBikeChange(e.target.checked),
                                    disabled: selectedLineIndex === null || isVehicleBikeChecked && (!intruderMetric || !lineCrossingActive.intruder) || isVehicleBikeChecked && intruderMetric && lineCrossingActive.intruder && !currentMetricLabels.includes(intruderMetric.id),
                                    sx: {
                                        color: "black",
                                        "&.Mui-checked": {
                                            color: lineColor
                                        }
                                    }
                                }),
                                label: "Vehicle / Bike",
                                sx: {
                                    fontFamily: "Mulish",
                                    "& .MuiFormControlLabel-label": {
                                        fontFamily: "Mulish",
                                        color: "black"
                                    },
                                    "&.Mui-disabled .MuiFormControlLabel-label": {
                                        color: "rgba(0, 0, 0, 0.26) !important"
                                    }
                                }
                            })
                        ]
                    }),
                    selectedLineIndex === null && metricLabels.length > 0 && (lineCrossingActive.intruder || lineCrossingActive.vehicle) && /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                        sx: {
                            mt: 1,
                            fontSize: "0.875rem",
                            color: "text.secondary",
                            fontFamily: "Mulish"
                        },
                        children: "Select a line to change its detection types, or click anywhere on the image to start a new line."
                    }),
                    (metricLabels.length === 0 || !lineCrossingActive.intruder && !lineCrossingActive.vehicle) && /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                        sx: {
                            mt: 1,
                            fontSize: "0.875rem",
                            color: "text.secondary",
                            fontFamily: "Mulish"
                        },
                        children: "No detection types available for this camera"
                    }),
                    metricLabels.length > 0 && selectedLineIndex !== null && (lineCrossingActive.intruder || lineCrossingActive.vehicle) && /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                        sx: {
                            mt: 1,
                            fontSize: "0.75rem",
                            color: "text.secondary",
                            fontFamily: "Mulish"
                        },
                        children: "At least one detection type must be selected"
                    })
                ]
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $j0ZEU = parcelRequire("j0ZEU");

var $3IuQ3 = parcelRequire("3IuQ3");

var $f3puC = parcelRequire("f3puC");

var $5GP2e = parcelRequire("5GP2e");

var $eXOoR = parcelRequire("eXOoR");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");

var $iMum1 = parcelRequire("iMum1");
const $59069d06b9b214f3$export$4a486843eab109e1 = ({ linksArray: linksArray, handleSitesBreadcrumbClick: handleSitesBreadcrumbClick, handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick, styling: styling })=>{
    const navigate = (0, $3T949.useNavigate)();
    const { cameraInfo: cameraInfo } = (0, $iMum1.useEditLineCrossingsStore)();
    const handleCameraBreadcrumbClick = (event)=>{
        event.preventDefault();
        navigate(`/sites/${(0, $a8BPe.getNumbersAfterSites)(location.href)}/editcamera/${(0, $a8BPe.getNumbersAfterEditCamera)(location.href)}`);
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3IuQ3.default), {
        spacing: 2,
        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
            className: styling,
            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $j0ZEU.default), {
                separator: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXOoR))), {
                    fontSize: "medium"
                }),
                "aria-label": "breadcrumb",
                children: [
                    linksArray.map((object, index)=>{
                        if (index === 0) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                            underline: "hover",
                            color: "inherit",
                            href: "/sites",
                            sx: {
                                fontSize: "18px",
                                fontFamily: "Mulish",
                                fontWeight: "bold",
                                cursor: "pointer"
                            },
                            variant: "h5",
                            onClick: handleSitesBreadcrumbClick,
                            children: object.name
                        }, index);
                        else if (index === linksArray.length - 1) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                            underline: "hover",
                            color: "inherit",
                            sx: {
                                fontSize: "18px",
                                fontFamily: "Mulish",
                                fontWeight: "bold",
                                cursor: "pointer"
                            },
                            variant: "h5",
                            onClick: handleSingularSiteBreadcrumbClick,
                            children: object.name
                        }, index);
                        else if (index === linksArray.length && !window.location.href.includes("editlinecrossings")) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                            color: "text.primary",
                            fontSize: "18px",
                            fontFamily: "Mulish",
                            fontWeight: "bold",
                            children: object.name
                        }, index);
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                        underline: "hover",
                        color: "inherit",
                        sx: {
                            fontSize: "18px",
                            fontFamily: "Mulish",
                            fontWeight: "bold",
                            cursor: "pointer"
                        },
                        variant: "h5",
                        onClick: handleCameraBreadcrumbClick,
                        children: cameraInfo.camera_name
                    }, cameraInfo.camera_name)
                ]
            })
        })
    });
};


const $b84c5a956426ddce$export$669336751db8b3b2 = (pushedArray)=>{
    const linksArray = [
        {
            name: "Sites"
        }
    ];
    pushedArray.forEach((name)=>{
        linksArray.push({
            name: name
        });
    });
    return linksArray;
};


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $7UDCh = parcelRequire("7UDCh");
var $9qNow = parcelRequire("9qNow");
var $6gU8O = parcelRequire("6gU8O");
var $cxknk = parcelRequire("cxknk");
var $2eEqG = parcelRequire("2eEqG");
var $cVCJe = parcelRequire("cVCJe");

var $frXOV = parcelRequire("frXOV");

var $2qUoo = parcelRequire("2qUoo");

var $ka01y = parcelRequire("ka01y");

var $8jTCz = parcelRequire("8jTCz");

var $8ZARq = parcelRequire("8ZARq");

var $8gqnT = parcelRequire("8gqnT");

var $cpJfj = parcelRequire("cpJfj");

var $dHtmK = parcelRequire("dHtmK");

var $2hXui = parcelRequire("2hXui");
parcelRequire("dfWDO");
var $a8BPe = parcelRequire("a8BPe");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");
// The LineDrawer uses 20px padding, so coordinates are stored with that offset
const $c6d3511fb69bff3b$var$PADDING_OFFSET = 20;
// Calculate arrow path for a given direction
const $c6d3511fb69bff3b$var$getArrowPath = (centerX, centerY, perpDx, perpDy, sideMultiplier, fromCenter)=>{
    const crossingLineLength = 50;
    const halfLength = crossingLineLength / 2;
    const arrowLength = 12;
    const arrowWidth = 2 * arrowLength / Math.sqrt(3);
    // Calculate the perpendicular offset
    const offsetX = perpDx * halfLength * sideMultiplier;
    const offsetY = perpDy * halfLength * sideMultiplier;
    // Calculate the arrow tip position
    const arrowTipX = centerX + offsetX;
    const arrowTipY = centerY + offsetY;
    // Calculate where the line should end (arrowhead base)
    const arrowBaseOffsetX = perpDx * arrowLength * sideMultiplier;
    const arrowBaseOffsetY = perpDy * arrowLength * sideMultiplier;
    const lineEndX = arrowTipX - arrowBaseOffsetX;
    const lineEndY = arrowTipY - arrowBaseOffsetY;
    // Start point of the crossing line
    const crossStartX = fromCenter ? centerX : centerX - offsetX;
    const crossStartY = fromCenter ? centerY : centerY - offsetY;
    // Line path
    const linePath = `M ${crossStartX} ${crossStartY} L ${lineEndX} ${lineEndY}`;
    // Arrow head path (triangle)
    // Calculate the two base corners of the arrow
    const arrowAngle = Math.atan2(offsetY, offsetX);
    const cos = Math.cos(arrowAngle);
    const sin = Math.sin(arrowAngle);
    // Arrow base corners (perpendicular to arrow direction)
    const baseCorner1X = arrowTipX - arrowLength * cos + arrowWidth / 2 * sin;
    const baseCorner1Y = arrowTipY - arrowLength * sin - arrowWidth / 2 * cos;
    const baseCorner2X = arrowTipX - arrowLength * cos - arrowWidth / 2 * sin;
    const baseCorner2Y = arrowTipY - arrowLength * sin + arrowWidth / 2 * cos;
    const arrowPath = `M ${arrowTipX} ${arrowTipY} L ${baseCorner1X} ${baseCorner1Y} L ${baseCorner2X} ${baseCorner2Y} Z`;
    return {
        linePath: linePath,
        arrowPath: arrowPath
    };
};
const $c6d3511fb69bff3b$var$renderDirectionArrow = (line, index)=>{
    // Adjust coordinates by subtracting the padding offset
    const start = [
        line.coordinates[0][0] - $c6d3511fb69bff3b$var$PADDING_OFFSET,
        line.coordinates[0][1] - $c6d3511fb69bff3b$var$PADDING_OFFSET
    ];
    const end = [
        line.coordinates[1][0] - $c6d3511fb69bff3b$var$PADDING_OFFSET,
        line.coordinates[1][1] - $c6d3511fb69bff3b$var$PADDING_OFFSET
    ];
    const centerX = (start[0] + end[0]) / 2;
    const centerY = (start[1] + end[1]) / 2;
    const dx = end[0] - start[0];
    const dy = end[1] - start[1];
    const lineLength = Math.sqrt(dx * dx + dy * dy);
    if (lineLength === 0) return [];
    const perpDx = -dy / lineLength;
    const perpDy = dx / lineLength;
    const arrowColor = "#FF1744"; // Neon red
    const elements = [];
    if (line.direction === "AtoB") {
        const { linePath: linePath, arrowPath: arrowPath } = $c6d3511fb69bff3b$var$getArrowPath(centerX, centerY, perpDx, perpDy, 1, false);
        elements.push(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
            d: linePath,
            stroke: arrowColor,
            strokeWidth: 2,
            fill: "none"
        }, `line-${index}-arrow-line`), /*#__PURE__*/ (0, $k4ank.jsx)("path", {
            d: arrowPath,
            fill: arrowColor
        }, `line-${index}-arrow-head`));
    } else if (line.direction === "BtoA") {
        const { linePath: linePath, arrowPath: arrowPath } = $c6d3511fb69bff3b$var$getArrowPath(centerX, centerY, perpDx, perpDy, -1, false);
        elements.push(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
            d: linePath,
            stroke: arrowColor,
            strokeWidth: 2,
            fill: "none"
        }, `line-${index}-arrow-line`), /*#__PURE__*/ (0, $k4ank.jsx)("path", {
            d: arrowPath,
            fill: arrowColor
        }, `line-${index}-arrow-head`));
    } else if (line.direction === "Both") {
        const arrow1 = $c6d3511fb69bff3b$var$getArrowPath(centerX, centerY, perpDx, perpDy, -1, true);
        const arrow2 = $c6d3511fb69bff3b$var$getArrowPath(centerX, centerY, perpDx, perpDy, 1, true);
        elements.push(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
            d: arrow1.linePath,
            stroke: arrowColor,
            strokeWidth: 2,
            fill: "none"
        }, `line-${index}-arrow-line-1`), /*#__PURE__*/ (0, $k4ank.jsx)("path", {
            d: arrow1.arrowPath,
            fill: arrowColor
        }, `line-${index}-arrow-head-1`), /*#__PURE__*/ (0, $k4ank.jsx)("path", {
            d: arrow2.linePath,
            stroke: arrowColor,
            strokeWidth: 2,
            fill: "none"
        }, `line-${index}-arrow-line-2`), /*#__PURE__*/ (0, $k4ank.jsx)("path", {
            d: arrow2.arrowPath,
            fill: arrowColor
        }, `line-${index}-arrow-head-2`));
    }
    return elements;
};
const $c6d3511fb69bff3b$export$d056f3ce77b890c1 = ({ lines: lines, width: width, height: height })=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)("svg", {
        width: width,
        height: height,
        style: {
            position: "absolute",
            top: 0,
            left: 0,
            pointerEvents: "none"
        },
        children: lines.map((line, index)=>{
            // Adjust coordinates by subtracting the padding offset
            const x1 = line.coordinates[0][0] - $c6d3511fb69bff3b$var$PADDING_OFFSET;
            const y1 = line.coordinates[0][1] - $c6d3511fb69bff3b$var$PADDING_OFFSET;
            const x2 = line.coordinates[1][0] - $c6d3511fb69bff3b$var$PADDING_OFFSET;
            const y2 = line.coordinates[1][1] - $c6d3511fb69bff3b$var$PADDING_OFFSET;
            return /*#__PURE__*/ (0, $k4ank.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("line", {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2,
                        stroke: line.color,
                        strokeWidth: 2
                    }),
                    $c6d3511fb69bff3b$var$renderDirectionArrow(line, index)
                ]
            }, `line-group-${index}`);
        })
    });
};



var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $ha39s = parcelRequire("ha39s");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $ce8iU = parcelRequire("ce8iU");

var $8jTCz = parcelRequire("8jTCz");

var $iMum1 = parcelRequire("iMum1");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $17ffac74606250af$export$72bca74d8232314d = ()=>{
    const navigate = (0, $3T949.useNavigate)();
    const { deleteLineCrossingDialogOpen: deleteLineCrossingDialogOpen, setDeleteLineCrossingDialogOpen: setDeleteLineCrossingDialogOpen, setLineToDeleteId: setLineToDeleteId, handleDeleteLineCrossing: handleDeleteLineCrossing, setPageLoading: setPageLoading } = (0, $iMum1.useEditLineCrossingsStore)();
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: deleteLineCrossingDialogOpen,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: "Are you sure you want to delete this line crossing?"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setLineToDeleteId(null);
                            setDeleteLineCrossingDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setPageLoading(true);
                            handleDeleteLineCrossing(navigate);
                        },
                        text: "Delete",
                        disabled: false
                    })
                ]
            })
        ]
    });
};



var $2wOL1 = parcelRequire("2wOL1");
/** Select value for the camera-wide Default configuration (no preset). */ const $dd8354e141c081ef$var$DEFAULT_CONFIGURATION_OPTION = "__default__";
const $dd8354e141c081ef$export$67c0a53e49e9b96c = ({ navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed })=>{
    const { pageLoading: pageLoading, editorVisible: editorVisible, setEditorVisible: setEditorVisible, breadcrumbs: breadcrumbs, cameraInfo: cameraInfo, dimensions: dimensions, imageURL: imageURL, setImageURL: setImageURL, setPageLoading: setPageLoading, setEditsMade: setEditsMade, getAllEditLineCrossingsPageInfo: getAllEditLineCrossingsPageInfo, lines: lines, setLines: setLines, originalLines: originalLines, setOriginalLines: setOriginalLines, setSelectedLineIndex: setSelectedLineIndex, metricLabels: metricLabels, handlePostLineCrossings: handlePostLineCrossings, setDeleteLineCrossingDialogOpen: setDeleteLineCrossingDialogOpen, setLineToDeleteId: setLineToDeleteId, lineCrossingActive: lineCrossingActive, selectedPresetId: selectedPresetId, cameraPresets: cameraPresets, switchConfiguration: switchConfiguration } = (0, $iMum1.useEditLineCrossingsStore)();
    const lineCrossingProductEnabled = lineCrossingActive.intruder || lineCrossingActive.vehicle;
    const navigate = (0, $3T949.useNavigate)();
    const siteId = Number((0, $a8BPe.getNumbersAfterSites)(location.href));
    const [allCamerasData, setAllCamerasData] = $8T3gX.useState([]);
    const [cameraIndex, setCameraIndex] = $8T3gX.useState(0);
    const [largerMode, setLargerMode] = $8T3gX.useState(false);
    const handleSitesBreadcrumbClick = (event)=>{
        event.preventDefault();
        localStorage.setItem("level0Click", "false");
        localStorage.setItem("navigatedFromSitesAboutPage", "false");
        navigate("/sites");
    };
    const handleSingularSiteBreadcrumbClick = ()=>{
        navigate(`/sites/aboutsite/${siteId}`);
    };
    // Configuration switcher (ENG-1610): Default (camera-wide lines) plus the
    // camera's named presets. Mirrors the flex preset picker on the Site About
    // camera row; `?preset=` on the route pre-selects it on entry.
    const showConfigurationSwitcher = cameraPresets.length > 0 || selectedPresetId != null;
    const selectedConfigurationValue = selectedPresetId == null ? $dd8354e141c081ef$var$DEFAULT_CONFIGURATION_OPTION : String(selectedPresetId);
    const selectedPresetMissingFromList = selectedPresetId != null && !cameraPresets.some((preset)=>preset.id === selectedPresetId);
    const handleConfigurationChange = (value)=>{
        if (editorVisible) return; // unsaved edits belong to the current configuration
        const nextPresetId = value === $dd8354e141c081ef$var$DEFAULT_CONFIGURATION_OPTION ? null : Number(value);
        if (nextPresetId === selectedPresetId) return;
        // Keep the URL in step so a refresh (or the back button) reopens the same
        // configuration; the camera id in the path is unchanged.
        navigate({
            search: (0, $2wOL1.lineCrossingsPresetSearch)(nextPresetId)
        }, {
            replace: true
        });
        switchConfiguration(navigate, nextPresetId);
    };
    const handleEditAddLinesClick = ()=>{
        setLargerMode(false);
        // Store current lines as original (for cancel functionality)
        // Deep copy to prevent reference issues when editing coordinates
        setOriginalLines(lines.map((line)=>({
                ...line,
                coordinates: [
                    [
                        ...line.coordinates[0]
                    ],
                    [
                        ...line.coordinates[1]
                    ]
                ],
                metric_labels: [
                    ...line.metric_labels
                ]
            })));
        setEditorVisible(true);
    };
    const handleSaveClick = ()=>{
        setLargerMode(false);
        // Save lines to API (POST new lines, PATCH modified lines)
        setPageLoading(true);
        setSelectedLineIndex(null);
        handlePostLineCrossings(navigate);
    };
    const handleCancelClick = ()=>{
        // Reset lines to original state and exit edit mode
        // Deep copy to prevent reference issues
        setLines(originalLines.map((line)=>({
                ...line,
                coordinates: [
                    [
                        ...line.coordinates[0]
                    ],
                    [
                        ...line.coordinates[1]
                    ]
                ],
                metric_labels: [
                    ...line.metric_labels
                ]
            })));
        setEditorVisible(false);
        setSelectedLineIndex(null);
        setEditsMade(false);
        setLargerMode(false);
    };
    $8T3gX.useEffect(()=>{
        getAllEditLineCrossingsPageInfo(navigate);
        (0, $2hXui.getAllCameras)(Number((0, $a8BPe.getNumbersAfterSites)(location.href)), Number((0, $a8BPe.getNumbersAfterEditCamera)(location.href)), setAllCamerasData, setCameraIndex);
        localStorage.setItem("siteId", (0, $a8BPe.getNumbersAfterSites)(location.href));
        localStorage.setItem("currentCameraId", (0, $a8BPe.getNumbersAfterEditCamera)(location.href));
    }, [
        getAllEditLineCrossingsPageInfo,
        navigate
    ]);
    // Add effect to handle camera changes
    $8T3gX.useEffect(()=>{
        const currentCameraId = (0, $a8BPe.getNumbersAfterEditCamera)(location.href);
        if (currentCameraId) getAllEditLineCrossingsPageInfo(navigate);
    }, [
        getAllEditLineCrossingsPageInfo,
        navigate
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8gqnT.SyncNeededBanner), {
                navigate: navigate
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $17ffac74606250af$export$72bca74d8232314d), {}),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "bg-actuate-grey absolute w-full h-full overflow-scroll",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                        openState: pageLoading
                    }),
                    allCamerasData[0] && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: !navBarCollapsed ? "absolute top-[15px] left-[150px] right-[1px] h-[59px] bg-white" : "absolute top-[15px] left-[75px] right-[1px] h-[59px] bg-white",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $59069d06b9b214f3$export$4a486843eab109e1), {
                                    linksArray: (0, $b84c5a956426ddce$export$669336751db8b3b2)(breadcrumbs),
                                    handleSitesBreadcrumbClick: handleSitesBreadcrumbClick,
                                    handleSingularSiteBreadcrumbClick: handleSingularSiteBreadcrumbClick,
                                    styling: "absolute top-[15px] left-[30px]"
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: !navBarCollapsed ? "absolute top-[87px] left-[150px] right-[1px] h-[58px] bg-white" : "absolute top-[87px] left-[75px] right-[1px] h-[58px] bg-white",
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "flex items-start gap-[24px]",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "font-black font-mulish text-[20px] p-3 indent-4",
                                            children: cameraInfo.camera_name
                                        }),
                                        showConfigurationSwitcher && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                            title: editorVisible ? "Save or cancel your line edits before switching configuration" : "",
                                            placement: "bottom",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                                                    size: "small",
                                                    sx: {
                                                        minWidth: 240,
                                                        maxWidth: 560,
                                                        mt: "9px",
                                                        fontFamily: "Mulish"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $6gU8O.default), {
                                                            id: "line-crossings-configuration-label",
                                                            sx: {
                                                                fontFamily: "Mulish"
                                                            },
                                                            children: "Configuration"
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $2eEqG.default), {
                                                            labelId: "line-crossings-configuration-label",
                                                            id: "line-crossings-configuration-select",
                                                            label: "Configuration",
                                                            value: selectedConfigurationValue,
                                                            disabled: editorVisible,
                                                            onChange: (event)=>handleConfigurationChange(String(event.target.value)),
                                                            sx: {
                                                                fontFamily: "Mulish",
                                                                bgcolor: "#fff"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                                    value: $dd8354e141c081ef$var$DEFAULT_CONFIGURATION_OPTION,
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: "Default"
                                                                }),
                                                                cameraPresets.map((preset)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                                        value: String(preset.id),
                                                                        sx: {
                                                                            fontFamily: "Mulish"
                                                                        },
                                                                        children: preset.name
                                                                    }, preset.id)),
                                                                selectedPresetMissingFromList && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                                    value: String(selectedPresetId),
                                                                    sx: {
                                                                        fontFamily: "Mulish"
                                                                    },
                                                                    children: `Preset #${selectedPresetId}`
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $9qNow.default), {
                                                            sx: {
                                                                fontFamily: "Mulish",
                                                                mx: 0
                                                            },
                                                            children: [
                                                                selectedPresetId == null ? "Default lines run whenever no configuration is assigned to the active flex schedule. " : "These lines run only while a flex schedule assigned to this configuration is active. ",
                                                                "Saved changes reach the camera after the site is synced."
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "absolute top-[97px] right-[100px]",
                                children: !editorVisible && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8ZARq.EditViewSyncButton), {
                                    navigate: navigate
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: !navBarCollapsed ? "absolute top-[145px] left-[150px] right-[1px] h-full bg-white" : "absolute top-[145px] left-[75px] right-[1px] h-full bg-white",
                                children: [
                                    !editorVisible && allCamerasData.length > 1 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "pt-[200px] w-[40px]",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                            title: `Previous Camera: ${cameraIndex === 0 ? allCamerasData[allCamerasData.length - 1].camera_name : allCamerasData[cameraIndex - 1].camera_name}`,
                                            placement: "top",
                                            sx: {
                                                fontSize: "12px",
                                                fontFamily: "mulish"
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                    onClick: ()=>{
                                                        const targetCameraId = cameraIndex === 0 ? allCamerasData[allCamerasData.length - 1].id : allCamerasData[cameraIndex - 1].id;
                                                        navigate(`/sites/${siteId}/editcamera/${targetCameraId}/editlinecrossings`);
                                                        // Reset state and reload data for the new camera
                                                        setPageLoading(true);
                                                        setEditorVisible(false);
                                                        setEditsMade(false);
                                                        setImageURL(""); // Clear image URL immediately
                                                        // Reload camera data
                                                        (0, $2hXui.getAllCameras)(siteId, targetCameraId, setAllCamerasData, setCameraIndex);
                                                        // Reload page info for the new camera
                                                        setTimeout(()=>{
                                                            getAllEditLineCrossingsPageInfo(navigate);
                                                        }, 100);
                                                    },
                                                    text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($frXOV))), {
                                                        fontSize: "large",
                                                        id: "backButton"
                                                    }),
                                                    disabled: allCamerasData.length < 2
                                                })
                                            })
                                        })
                                    }),
                                    !editorVisible && allCamerasData.length > 1 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "absolute top-[200px] left-[1300px]",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                            title: `Next Camera: ${cameraIndex + 1 === allCamerasData.length ? allCamerasData[0].camera_name : allCamerasData[cameraIndex + 1].camera_name}`,
                                            placement: "top",
                                            sx: {
                                                fontSize: "12px",
                                                fontFamily: "mulish"
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                    onClick: ()=>{
                                                        const targetCameraId = cameraIndex + 1 === allCamerasData.length ? allCamerasData[0].id : allCamerasData[cameraIndex + 1].id;
                                                        navigate(`/sites/${siteId}/editcamera/${targetCameraId}/editlinecrossings`);
                                                        // Reset state and reload data for the new camera
                                                        setPageLoading(true);
                                                        setEditorVisible(false);
                                                        setEditsMade(false);
                                                        setImageURL(""); // Clear image URL immediately
                                                        // Reload camera data
                                                        (0, $2hXui.getAllCameras)(siteId, targetCameraId, setAllCamerasData, setCameraIndex);
                                                        // Reload page info for the new camera
                                                        setTimeout(()=>{
                                                            getAllEditLineCrossingsPageInfo(navigate);
                                                        }, 100);
                                                    },
                                                    text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2qUoo))), {
                                                        fontSize: "large",
                                                        id: "backButton"
                                                    }),
                                                    disabled: allCamerasData.length < 2
                                                })
                                            })
                                        })
                                    }),
                                    !editorVisible && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "absolute top-[53px] left-[70px]",
                                        children: [
                                            lineCrossingProductEnabled && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                style: {
                                                    position: "absolute",
                                                    top: -38,
                                                    right: 0
                                                },
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                    onClick: handleEditAddLinesClick,
                                                    text: "Edit/Add Lines",
                                                    disabled: false
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                style: {
                                                    position: "relative",
                                                    width: dimensions.width,
                                                    height: dimensions.height
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                                                        src: imageURL,
                                                        style: {
                                                            width: `${dimensions.width}px`,
                                                            height: `${dimensions.height}px`
                                                        },
                                                        alt: "Camera Preview"
                                                    }),
                                                    lineCrossingProductEnabled && /*#__PURE__*/ (0, $k4ank.jsx)((0, $c6d3511fb69bff3b$export$d056f3ce77b890c1), {
                                                        lines: lines,
                                                        width: dimensions.width,
                                                        height: dimensions.height
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    !editorVisible && lineCrossingProductEnabled && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: !navBarCollapsed ? "absolute left-[775px] top-[20px] font-mulish text-[18px] font-bold text-actuate-blue" : "absolute left-[680px] top-[20px] font-mulish text-[18px] font-bold text-actuate-blue",
                                        children: "Active Line Crossings"
                                    }),
                                    !editorVisible && lineCrossingProductEnabled && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: !navBarCollapsed ? "absolute left-[775px] top-[73px]" : "absolute left-[680px] top-[73px]",
                                        children: [
                                            lines.length > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $4reBM.default), {
                                                sx: {
                                                    width: 400,
                                                    maxHeight: 360
                                                },
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                                    sx: {
                                                        maxHeight: 360
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                                        sx: {
                                                            fontFamily: "Mulish",
                                                            tableLayout: "auto"
                                                        },
                                                        "aria-label": "lines table",
                                                        size: "small",
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                            sx: {
                                                                                fontWeight: "bold",
                                                                                width: "120px",
                                                                                padding: "8px",
                                                                                paddingLeft: "18px"
                                                                            },
                                                                            children: "Line Color"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                            sx: {
                                                                                fontWeight: "bold",
                                                                                padding: "8px"
                                                                            },
                                                                            children: "Metrics"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                            sx: {
                                                                                fontWeight: "bold",
                                                                                width: "50px",
                                                                                padding: "8px"
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                                children: lines.map((line, index)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                                sx: {
                                                                                    width: "120px",
                                                                                    padding: "8px",
                                                                                    paddingLeft: "18px"
                                                                                },
                                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                                    style: {
                                                                                        height: 25,
                                                                                        width: 25,
                                                                                        background: line.color,
                                                                                        borderRadius: 4
                                                                                    }
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                                sx: {
                                                                                    padding: "8px"
                                                                                },
                                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                                    style: {
                                                                                        maxWidth: "200px"
                                                                                    },
                                                                                    children: (()=>{
                                                                                        const displayLabels = [];
                                                                                        const hasIntruder = line.metric_labels.some((id)=>metricLabels.find((m)=>m.id === id)?.label_name === "intruder_line_crossing");
                                                                                        const hasVehicle = line.metric_labels.some((id)=>metricLabels.find((m)=>m.id === id)?.label_name === "vehicle_line_crossing");
                                                                                        const hasBike = line.metric_labels.some((id)=>metricLabels.find((m)=>m.id === id)?.label_name === "bike_line_crossing");
                                                                                        if (hasIntruder) displayLabels.push("Intruder");
                                                                                        if (hasVehicle || hasBike) displayLabels.push("Vehicle/Bike");
                                                                                        return displayLabels.join(", ");
                                                                                    })()
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                                sx: {
                                                                                    width: "50px",
                                                                                    padding: "8px"
                                                                                },
                                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                                                    title: "Delete",
                                                                                    placement: "top",
                                                                                    sx: {
                                                                                        fontSize: "15px",
                                                                                        fontFamily: "mulish"
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                                                            onClick: ()=>{
                                                                                                if (line.id) {
                                                                                                    setLineToDeleteId(line.id);
                                                                                                    setDeleteLineCrossingDialogOpen(true);
                                                                                                }
                                                                                            },
                                                                                            text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ka01y))), {
                                                                                                fontSize: "small"
                                                                                            }),
                                                                                            disabled: !line.id
                                                                                        })
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    }, `line-row-${index}`))
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            lines.length === 0 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                style: {
                                                    width: 400,
                                                    height: 300,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    paddingLeft: 120,
                                                    paddingTop: 35
                                                },
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                    className: "font-mulish text-[18px]",
                                                    children: "No line crossings added."
                                                })
                                            })
                                        ]
                                    }),
                                    !editorVisible && !lineCrossingProductEnabled && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: !navBarCollapsed ? "absolute left-[775px] top-[53px]" : "absolute left-[680px] top-[53px]",
                                        style: {
                                            width: 400,
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-start",
                                            gap: "16px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "font-mulish text-[18px] text-gray-700",
                                                children: "The Line Crossing product has not been added for this camera."
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                                className: "font-mulish text-[18px] text-gray-700",
                                                children: [
                                                    "Please navigate to the",
                                                    " ",
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("a", {
                                                        href: `/sites/${siteId}/editcamera/${(0, $a8BPe.getNumbersAfterEditCamera)(location.href)}`,
                                                        className: "text-blue-600 hover:underline cursor-pointer",
                                                        onClick: (e)=>{
                                                            e.preventDefault();
                                                            navigate(`/sites/${siteId}/editcamera/${(0, $a8BPe.getNumbersAfterEditCamera)(location.href)}`);
                                                        },
                                                        children: "Edit Camera"
                                                    }),
                                                    " ",
                                                    "page and enable it under the Products tab."
                                                ]
                                            })
                                        ]
                                    }),
                                    editorVisible && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "p-4 pt-3",
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "flex gap-4",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                    style: {
                                                        position: "relative"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                            style: {
                                                                position: "absolute",
                                                                top: -38,
                                                                left: 1100,
                                                                display: "flex",
                                                                width: "100%",
                                                                gap: "16px"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                                    onClick: handleCancelClick,
                                                                    text: "Cancel",
                                                                    disabled: false
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $cpJfj.ActuateButton), {
                                                                    onClick: handleSaveClick,
                                                                    text: "Save and Submit",
                                                                    disabled: false
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                            className: "bg-white p-4 rounded",
                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $01d0fa6d6db7eaa4$export$360e6f46aa8bdfbf), {
                                                                largerMode: largerMode,
                                                                setLargerMode: setLargerMode
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $0e6900355b5ad911$export$eea8660070751cac), {})
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "justify-start",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jVN1H.NavBar), {
                    navBarCollapsed: navBarCollapsed,
                    setNavBarCollapsed: setNavBarCollapsed,
                    props: {}
                })
            })
        ]
    });
};



var $dfWDO = parcelRequire("dfWDO");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");


var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

var $eDfvp = parcelRequire("eDfvp");
var $a65wX = parcelRequire("a65wX");
var $f3puC = parcelRequire("f3puC");

var $2CHqP = parcelRequire("2CHqP");

var $kbChx = parcelRequire("kbChx");

var $3baw3 = parcelRequire("3baw3");

var $4wo2Y = parcelRequire("4wo2Y");

parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

const $0e35fc3545913e76$export$443d01f0943e8654 = ({ setCameraCheckFinsihedAlertOpen: setCameraCheckFinsihedAlertOpen, setGoodCameras: setGoodCameras, setConnectivityCameras: setConnectivityCameras, setLowResolutionCameras: setLowResolutionCameras, setCameraCheckResultDownloadURL: setCameraCheckResultDownloadURL })=>{
    const theme = (0, $cFPmV.default)({
        palette: {
            primary: {
                main: "#FF8400"
            }
        }
    });
    const navigate = (0, $3T949.useNavigate)();
    const onboardingScreen = /*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $b9p11.default), {
                theme: theme,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-[142px] right-44",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $2CHqP.default), {
                            color: "primary",
                            variant: "determinate",
                            value: 75,
                            sx: {
                                width: 275
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-32 right-32",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                            variant: "body1",
                            children: [
                                75,
                                "%"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-[195px] right-[150px] font-mulish text-actuate-blue",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            children: " Please complete the following information. "
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-[220px] right-[190px] font-mulish text-actuate-blue",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            children: " Otherwise the site won't run."
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-[275px] right-[350px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                            sx: {
                                display: "flex",
                                flexDirection: "column",
                                ml: 3
                            },
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                    sx: {
                                        fontFamily: "Mulish",
                                        color: "#001943"
                                    },
                                    label: "Site Creation",
                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                        color: "primary",
                                        checked: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                    sx: {
                                        fontFamily: "Mulish",
                                        color: "#001943"
                                    },
                                    label: "Camera Setup",
                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                        color: "primary",
                                        checked: true
                                    })
                                }),
                                localStorage.healthcheckOnly === "false" && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                            label: "Schedule Setup",
                                            control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                color: "primary",
                                                checked: true
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                    label: "Check Cameras",
                                    control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                        color: "primary",
                                        checked: false
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: localStorage.healthcheckOnly === "false" ? "absolute top-[474px] right-24" : "absolute top-[411px] right-24",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                            color: "primary",
                            disabled: false,
                            onClick: ()=>{
                                localStorage.setItem("healthcheckOnly", "false");
                                localStorage.setItem("healthMonitoringOnly", "false");
                                localStorage.setItem("cameraCheckAlertOpen", "true");
                                localStorage.setItem("clickedId", localStorage.siteId);
                                (0, $3d5e2464ea939321$export$702c539eae400f89)(navigate);
                                localStorage.setItem("navigatedFromSitesAboutPage", "true");
                                localStorage.setItem("level0Click", "true");
                                localStorage.setItem("cameraChecksiteId", localStorage.siteId);
                                (0, $37903a6140fe6ab4$export$82756491d6fa579)(setCameraCheckFinsihedAlertOpen, setGoodCameras, setConnectivityCameras, setLowResolutionCameras, localStorage.siteId, setCameraCheckResultDownloadURL, navigate);
                            },
                            children: "TEST CAMERAS"
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $fc1f706f45bf72ab$export$f81d45315d235306), {
        text: "Camera Check",
        visibleScreen: onboardingScreen,
        styling: "text-white absolute top-[1px] right-[450px] font-mulish text-[18px] p-3"
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");
const $15f8433cf226288b$export$dc15ce0bc6b510ba = ()=>{
    document.cookie.split(";").forEach((c)=>{
        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
};



var $jVN1H = parcelRequire("jVN1H");

var $ax3yI = parcelRequire("ax3yI");


var $8jTCz = parcelRequire("8jTCz");
var $6746cc1c4c159cb3$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($6746cc1c4c159cb3$exports, "__esModule", {
    value: true
});
$6746cc1c4c159cb3$exports.default = void 0;

var $6746cc1c4c159cb3$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $6746cc1c4c159cb3$var$_default = $6746cc1c4c159cb3$exports.default = (0, $6746cc1c4c159cb3$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3m-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3m0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5m8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5"
}), 'Group');


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $ebTQj = parcelRequire("ebTQj");

var $kUNf4 = parcelRequire("kUNf4");
const $d3d32d33bd82afae$var$LogoutAPI = (0, $195EM.createApi)(`auth/`);
const $d3d32d33bd82afae$export$297d1113e3afbc21 = ()=>{
    localStorage.clear();
    // Session-scoped UI preferences shouldn't carry over to the next sign-in.
    (0, $kUNf4.resetSyncBannerPreference)();
    $d3d32d33bd82afae$var$LogoutAPI.post("logout/").then((response)=>{
        (0, $15f8433cf226288b$export$dc15ce0bc6b510ba)();
        document.location = response.data.logout_url;
        (0, $ax3yI.handleRedirect)();
    }).catch((err)=>{
        (0, $ebTQj.logger).log(`Error: ${err}`);
        (0, $15f8433cf226288b$export$dc15ce0bc6b510ba)();
        (0, $ax3yI.handleRedirect)();
    });
};
const $d3d32d33bd82afae$export$b94310965bed44e6 = ({ navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed, permissions: permissions })=>{
    const userName = localStorage.username;
    const firstName = localStorage.first_name;
    const navigate = (0, $3T949.useNavigate)();
    const pageDiv = /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "bg-actuate-grey absolute w-full h-full",
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: !navBarCollapsed ? "absolute left-[160px] top-5 font-black font-mulish text-3xl p-3" : "absolute left-[85px] top-5 font-black font-mulish text-3xl p-3",
                    children: [
                        !firstName ? /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                            className: "font-black font-mulish text-3xl",
                            children: [
                                "Hello, ",
                                userName
                            ]
                        }) : /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                            className: "font-black font-mulish text-3xl",
                            children: [
                                "Hello, ",
                                firstName
                            ]
                        }),
                        permissions.manage_users && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "relative top-5 left-[-8px]",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    navigate("/groupuser");
                                },
                                text: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6746cc1c4c159cb3$exports))), {}),
                                        "\xa0 Manage Group User Access"
                                    ]
                                }),
                                disabled: false
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                        /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                            className: "shadow-button bg-actuate-orange rounded font-mulish text-white text-base p-1.5",
                            onClick: $d3d32d33bd82afae$export$297d1113e3afbc21,
                            children: "Logout"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "justify-start",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jVN1H.NavBar), {
                    navBarCollapsed: navBarCollapsed,
                    setNavBarCollapsed: setNavBarCollapsed,
                    props: {}
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: pageDiv
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $jVN1H = parcelRequire("jVN1H");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");

var $3n3uW = parcelRequire("3n3uW");

var $2suvB = parcelRequire("2suvB");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

var $4G44R = parcelRequire("4G44R");
const $8ac4bf0f042118db$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
function $8ac4bf0f042118db$var$a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`
    };
}
const $8ac4bf0f042118db$export$a64baa35607abce6 = ({ clickedTab: clickedTab, setClickedTab: setClickedTab })=>{
    const userInfo = JSON.parse(localStorage.userInfo);
    const { setActiveClipsTab: setActiveClipsTab, showFrontelTab: showFrontelTab } = (0, $4G44R.useClipsStore)();
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
        children: [
            userInfo.permission.sentinel,
            userInfo.permission.ailink,
            userInfo.permission.smtp,
            showFrontelTab
        ].filter(Boolean).length >= 2 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
            sx: {
                borderBottom: 1,
                borderColor: "divider"
            },
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                theme: $8ac4bf0f042118db$var$theme,
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3n3uW.default), {
                    value: clickedTab,
                    onChange: (event, tabValue)=>{
                        setClickedTab(tabValue);
                        if (tabValue === "one") //   setPage(0);
                        setActiveClipsTab("ailink");
                        if (tabValue === "two") //   setPage(0);
                        setActiveClipsTab("sentinel");
                        if (tabValue === "three") //   setPage(0);
                        setActiveClipsTab("smtp");
                        if (tabValue === "four") //   setPage(0);
                        setActiveClipsTab("frontel");
                    },
                    "aria-label": "intestigation_tabs",
                    color: "primary",
                    children: [
                        userInfo.permission.ailink && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                            value: "one",
                            label: `AI Link`,
                            sx: {
                                fontFamily: "Mulish",
                                fontWeight: "Bold",
                                color: "primary"
                            },
                            ...$8ac4bf0f042118db$var$a11yProps(0)
                        }),
                        userInfo.permission.sentinel && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                            value: "two",
                            label: `Sentinel`,
                            sx: {
                                fontFamily: "Mulish",
                                fontWeight: "Bold",
                                color: "primary"
                            },
                            ...$8ac4bf0f042118db$var$a11yProps(1)
                        }),
                        userInfo.permission.smtp && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                            value: "three",
                            label: `SMTP`,
                            sx: {
                                fontFamily: "Mulish",
                                fontWeight: "Bold",
                                color: "primary"
                            }
                        }),
                        showFrontelTab && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                            value: "four",
                            label: `Frontel`,
                            sx: {
                                fontFamily: "Mulish",
                                fontWeight: "Bold",
                                color: "primary"
                            }
                        })
                    ]
                })
            })
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $60vL1 = parcelRequire("60vL1");
var $eejVe = parcelRequire("eejVe");
// eslint-disable-next-line @typescript-eslint/no-unused-vars
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $1a511a220e4442ce$export$1fedd6e3f8d8e03e = (idArray, navigate, setCameraOptions, setLoadingCameras)=>{
    setLoadingCameras(true);
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $1a511a220e4442ce$export$1fedd6e3f8d8e03e(idArray, navigate, setCameraOptions, setLoadingCameras);
    };
    let idString = "";
    if (idArray.length === 1) idString = `${idArray[0]}`;
    if (idArray.length > 1) {
        idString = `${idArray[0]}`;
        idArray.forEach((id, index)=>{
            if (index > 0) idString += `,${id}`;
        });
    }
    let allSiteCameras;
    const getSiteCameras = (pageNumber)=>{
        AxiosUI.get(`camera/site/?customers=${idString}&page=${pageNumber}`).then((response)=>{
            if (response.data.count > 0) {
                if (pageNumber === 1) allSiteCameras = response.data.results;
                if (pageNumber > 1) allSiteCameras.push(...response.data.results);
                if (response.data.next) getSiteCameras(pageNumber + 1);
                else {
                    setCameraOptions(allSiteCameras);
                    setLoadingCameras(false);
                }
            }
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                alert("Error retrieving cameras. Please try again");
                setLoadingCameras(false);
            });
        });
    };
    idArray.length === 0 ? setCameraOptions([]) : getSiteCameras(1);
};


const $b06f4e3e9c7cad7b$export$ff9e07ee8eeea54e = ({ siteOptions: siteOptions, loadingSites: loadingSites, siteDropDownValue: siteDropDownValue, setSiteDropDownValue: setSiteDropDownValue, setCameraDropDownValue: setCameraDropDownValue, userFilters: userFilters, setUserFilters: setUserFilters, setCameraOptions: setCameraOptions, setLoadingCameras: setLoadingCameras, showUserDropDown: showUserDropDown, navBarCollapsed: navBarCollapsed, navigate: navigate })=>{
    const siteIds = new Map();
    siteOptions.forEach((object)=>{
        siteIds.set(object.name, object.id);
    });
    // Create a Set to track unique names and ensure we only add each name once
    const uniqueNames = new Set();
    const options = [];
    // First pass: collect unique names
    siteOptions.forEach((object)=>{
        if (!uniqueNames.has(object.name)) {
            uniqueNames.add(object.name);
            options.push(object.name);
        }
    });
    let sx;
    if (showUserDropDown && navBarCollapsed) sx = {
        width: 140
    };
    if (showUserDropDown && !navBarCollapsed) sx = {
        width: 120
    };
    if (!showUserDropDown && navBarCollapsed) sx = {
        width: 180
    };
    if (!showUserDropDown && !navBarCollapsed) sx = {
        width: 160
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            value: siteDropDownValue,
            disablePortal: true,
            options: options,
            loading: loadingSites,
            onChange: (event, value)=>{
                if (value !== null) {
                    setSiteDropDownValue(value);
                    setCameraDropDownValue(null);
                    (0, $1a511a220e4442ce$export$1fedd6e3f8d8e03e)([
                        siteIds.get(value)
                    ], navigate, setCameraOptions, setLoadingCameras);
                    setUserFilters((previousState)=>{
                        return {
                            ...previousState,
                            site_ids: [
                                siteIds.get(value)
                            ],
                            camera_ids: []
                        };
                    });
                } else {
                    // setFetchingFilteredData(true);
                    setSiteDropDownValue(value);
                    setCameraDropDownValue(null);
                    setCameraOptions([]);
                    setUserFilters((previousState)=>{
                        return {
                            ...previousState,
                            site_ids: [],
                            camera_ids: []
                        };
                    });
                }
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    label: "Site",
                    InputProps: {
                        ...params.InputProps,
                        endAdornment: /*#__PURE__*/ (0, $k4ank.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                            children: [
                                loadingSites ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                    color: "inherit",
                                    size: 20
                                }) : null,
                                params.InputProps.endAdornment
                            ]
                        })
                    },
                    autoComplete: "off",
                    sx: sx
                })
        })
    }, "site_dropdown");
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $60vL1 = parcelRequire("60vL1");
var $eejVe = parcelRequire("eejVe");
const $b1d0f09af465fc66$export$83fafb7693b98b92 = ({ userFilters: userFilters, setUserFilters: setUserFilters, cameraOptions: cameraOptions, cameraDropDownValue: cameraDropDownValue, setCameraDropDownValue: setCameraDropDownValue, siteOptions: siteOptions, loadingCameras: loadingCameras, showUserDropDown: showUserDropDown, navBarCollapsed: navBarCollapsed, navigate: navigate })=>{
    const cameraIds = new Map();
    cameraOptions.forEach((object)=>{
        cameraIds.set(object.camera_name, object.id);
    });
    const siteIds = new Map();
    siteOptions.forEach((object)=>{
        siteIds.set(object.name, object.id);
    });
    let sx;
    if (showUserDropDown && navBarCollapsed) sx = {
        width: 140
    };
    if (showUserDropDown && !navBarCollapsed) sx = {
        width: 120
    };
    if (!showUserDropDown && navBarCollapsed) sx = {
        width: 180
    };
    if (!showUserDropDown && !navBarCollapsed) sx = {
        width: 160
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            value: cameraDropDownValue,
            disablePortal: true,
            options: cameraOptions[0] ? cameraOptions.map((object)=>{
                return object.camera_name;
            }) : [],
            loading: loadingCameras,
            onChange: (event, value)=>{
                if (value !== "") {
                    setCameraDropDownValue(value);
                    setUserFilters((previousState)=>{
                        return {
                            ...previousState,
                            camera_ids: [
                                cameraIds.get(value)
                            ]
                        };
                    });
                } else {
                    setCameraDropDownValue(value);
                    setUserFilters((previousState)=>{
                        return {
                            ...previousState,
                            camera_ids: []
                        };
                    });
                }
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    label: "Camera",
                    InputProps: {
                        ...params.InputProps,
                        endAdornment: /*#__PURE__*/ (0, $k4ank.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                            children: [
                                loadingCameras ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                    color: "inherit",
                                    size: 20
                                }) : null,
                                params.InputProps.endAdornment
                            ]
                        })
                    },
                    autoComplete: "off",
                    sx: sx
                })
        })
    }, "camera_dropdown");
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $hfM8m = parcelRequire("hfM8m");

var $hwWkD = parcelRequire("hwWkD");


var $eejVe = parcelRequire("eejVe");

var $5L5iJ = parcelRequire("5L5iJ");

var $iKAtE = parcelRequire("iKAtE");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");

var $i5MAs = parcelRequire("i5MAs");

var $aYdit = parcelRequire("aYdit");

var $jgags = parcelRequire("jgags");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $aed70cd9b6f46f8d$export$af7bf6e810cbe511 = ({ userFilters: userFilters, setUserFilters: setUserFilters, setTimeFiltersDisabledAILink: setTimeFiltersDisabledAILink })=>{
    const navigate = (0, $3T949.useNavigate)();
    const [startTimeAnchorEl, setStartTimeAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const startTimeOpen = Boolean(startTimeAnchorEl);
    const handleStartTimeClick = (event)=>{
        setStartTimeAnchorEl(event.currentTarget);
    };
    const handleStartTimeClose = (event)=>{
        event.stopPropagation();
        setStartTimeAnchorEl(null);
    };
    const { dateMMDDYYYY: dateMMDDYYYY, setDateMMDDYYYY: setDateMMDDYYYY } = (0, $aYdit.useAppStore)();
    const selectedLocale = dateMMDDYYYY ? (0, $jgags.default) : (0, $253608f850203ed2$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
        dateAdapter: (0, $hfM8m.AdapterDateFns),
        adapterLocale: selectedLocale,
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cbaf068f14972fdf$export$5109c6dd95d8fb00), {
            label: userFilters.start_date ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                        children: "Start Date"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                "aria-label": "more",
                                id: "long-button",
                                "aria-controls": startTimeOpen ? "long-menu" : undefined,
                                "aria-expanded": startTimeOpen ? "true" : undefined,
                                "aria-haspopup": "true",
                                onClick: handleStartTimeClick,
                                sx: {
                                    marginLeft: "5px",
                                    padding: 0,
                                    color: "#000000",
                                    "&:hover": {
                                        backgroundColor: "transparent"
                                    }
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5MAs))), {})
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                                id: "long-menu",
                                MenuListProps: {
                                    "aria-labelledby": "long-button"
                                },
                                anchorOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                anchorEl: startTimeAnchorEl,
                                open: startTimeOpen,
                                onClose: handleStartTimeClose,
                                slotProps: {
                                    paper: {
                                        style: {
                                            maxHeight: 216,
                                            width: "20ch"
                                        }
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: (event)=>{
                                            setDateMMDDYYYY(true);
                                            handleStartTimeClose(event);
                                        },
                                        children: "MM/DD/YYYY"
                                    }, "mm-dd-yyyy-start"),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: (event)=>{
                                            setDateMMDDYYYY(false);
                                            handleStartTimeClose(event);
                                        },
                                        children: "DD/MM/YYYY"
                                    }, "dd-mm-yyyy-start")
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                children: "Start Date"
            }),
            value: userFilters.start_date,
            onChange: (newValue)=>{
                if (newValue !== null) setUserFilters((previousState)=>{
                    return {
                        ...previousState,
                        start_date: newValue
                    };
                });
                if (newValue === null) setUserFilters((previousState)=>{
                    return {
                        ...previousState,
                        start_date: null
                    };
                });
                if ((0, $5L5iJ.yyyymmddGenerator)(newValue) !== (0, $5L5iJ.yyyymmddGenerator)(userFilters.end_date)) {
                    setTimeFiltersDisabledAILink(true);
                    setUserFilters((previousState)=>{
                        return {
                            ...previousState,
                            start_time: null,
                            end_time: null
                        };
                    });
                }
                if ((0, $5L5iJ.yyyymmddGenerator)(newValue) === (0, $5L5iJ.yyyymmddGenerator)(userFilters.end_date)) setTimeFiltersDisabledAILink(false);
                let updatedFilters = {
                    ...userFilters,
                    start_date: newValue
                };
                if ((0, $5L5iJ.yyyymmddGenerator)(newValue) !== (0, $5L5iJ.yyyymmddGenerator)(userFilters.end_date)) updatedFilters = {
                    ...updatedFilters,
                    start_time: null,
                    end_time: null
                };
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    sx: {
                        width: 150
                    },
                    ...params
                })
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $hfM8m = parcelRequire("hfM8m");

var $hwWkD = parcelRequire("hwWkD");


var $eejVe = parcelRequire("eejVe");

var $5L5iJ = parcelRequire("5L5iJ");

var $iKAtE = parcelRequire("iKAtE");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");

var $i5MAs = parcelRequire("i5MAs");

var $aYdit = parcelRequire("aYdit");

var $jgags = parcelRequire("jgags");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $0f9f2f66963aafab$export$d570e110580e29f0 = ({ userFilters: userFilters, setUserFilters: setUserFilters, setTimeFiltersDisabledAILink: setTimeFiltersDisabledAILink })=>{
    const navigate = (0, $3T949.useNavigate)();
    const [endTimeAnchorEl, setEndTimeAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const endTimeOpen = Boolean(endTimeAnchorEl);
    const handleEndTimeClick = (event)=>{
        setEndTimeAnchorEl(event.currentTarget);
    };
    const handleEndTimeClose = (event)=>{
        event.stopPropagation();
        setEndTimeAnchorEl(null);
    };
    const { dateMMDDYYYY: dateMMDDYYYY, setDateMMDDYYYY: setDateMMDDYYYY } = (0, $aYdit.useAppStore)();
    const selectedLocale = dateMMDDYYYY ? (0, $jgags.default) : (0, $253608f850203ed2$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
        dateAdapter: (0, $hfM8m.AdapterDateFns),
        adapterLocale: selectedLocale,
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cbaf068f14972fdf$export$5109c6dd95d8fb00), {
            label: userFilters.end_date ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                        children: "End Date"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                "aria-label": "more",
                                id: "long-button",
                                "aria-controls": endTimeOpen ? "long-menu" : undefined,
                                "aria-expanded": endTimeOpen ? "true" : undefined,
                                "aria-haspopup": "true",
                                onClick: handleEndTimeClick,
                                sx: {
                                    marginLeft: "5px",
                                    padding: 0,
                                    color: "#000000",
                                    "&:hover": {
                                        backgroundColor: "transparent"
                                    }
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5MAs))), {})
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                                id: "long-menu",
                                MenuListProps: {
                                    "aria-labelledby": "long-button"
                                },
                                anchorOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                anchorEl: endTimeAnchorEl,
                                open: endTimeOpen,
                                onClose: handleEndTimeClose,
                                slotProps: {
                                    paper: {
                                        style: {
                                            maxHeight: 216,
                                            width: "20ch"
                                        }
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: (event)=>{
                                            setDateMMDDYYYY(true);
                                            handleEndTimeClose(event);
                                        },
                                        children: "MM/DD/YYYY"
                                    }, "mm-dd-yyyy-end"),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: (event)=>{
                                            setDateMMDDYYYY(false);
                                            handleEndTimeClose(event);
                                        },
                                        children: "DD/MM/YYYY"
                                    }, "dd-mm-yyyy-end")
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                children: "End Date"
            }),
            value: userFilters.end_date,
            onChange: (newValue)=>{
                if (newValue !== null) setUserFilters((previousState)=>{
                    return {
                        ...previousState,
                        end_date: newValue
                    };
                });
                if (newValue === null) setUserFilters((previousState)=>{
                    return {
                        ...previousState,
                        end_date: null
                    };
                });
                if ((0, $5L5iJ.yyyymmddGenerator)(newValue) !== (0, $5L5iJ.yyyymmddGenerator)(userFilters.start_date)) {
                    setTimeFiltersDisabledAILink(true);
                    setUserFilters((previousState)=>{
                        return {
                            ...previousState,
                            start_time: null,
                            end_time: null
                        };
                    });
                }
                if ((0, $5L5iJ.yyyymmddGenerator)(newValue) === (0, $5L5iJ.yyyymmddGenerator)(userFilters.start_date)) setTimeFiltersDisabledAILink(false);
                let updatedFilters = {
                    ...userFilters,
                    end_date: newValue
                };
                if ((0, $5L5iJ.yyyymmddGenerator)(newValue) !== (0, $5L5iJ.yyyymmddGenerator)(userFilters.start_date)) updatedFilters = {
                    ...updatedFilters,
                    start_time: null,
                    end_time: null
                };
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    sx: {
                        width: 150
                    },
                    ...params
                })
        })
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");
const $1f441af7d8bd507f$export$d64b982d1df0bde5 = ({ userFilters: userFilters, setUserFilters: setUserFilters, showUserDropDown: showUserDropDown, onFiltersChange: onFiltersChange })=>{
    const sx = showUserDropDown ? {
        width: 120
    } : {
        width: 130
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            value: userFilters.clip_result || "",
            disablePortal: true,
            options: [
                "All",
                "Verified",
                "Unverified",
                "Faulted",
                "Unprocessed"
            ],
            onChange: (event, value)=>{
                setUserFilters((previousState)=>{
                    return {
                        ...previousState,
                        clip_result: value || null
                    };
                });
                if (onFiltersChange) onFiltersChange({
                    ...userFilters,
                    clip_result: value || null
                });
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    label: "Clip Result",
                    autoComplete: "off",
                    sx: sx
                })
        })
    }, "clip_result_dropdown");
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $60d5cc508a56c0de$export$34f28e0dae5347d5 = ({ userFilters: userFilters, setUserFilters: setUserFilters, showUserDropDown: showUserDropDown, navBarCollapsed: navBarCollapsed })=>{
    const navigate = (0, $3T949.useNavigate)();
    // const sx = showUserDropDown ? { width: 120 } : { width: 190 };
    let sx;
    if (showUserDropDown && navBarCollapsed) sx = {
        width: 135
    };
    if (showUserDropDown && !navBarCollapsed) sx = {
        width: 120
    };
    if (!showUserDropDown && navBarCollapsed) sx = {
        width: 150
    };
    if (!showUserDropDown && !navBarCollapsed) sx = {
        width: 145
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            value: userFilters.ground_truth || "",
            disablePortal: true,
            options: [
                "Verified",
                "Unverified"
            ],
            onChange: (event, value)=>{
                setUserFilters((previousState)=>{
                    return {
                        ...previousState,
                        ground_truth: value || null
                    };
                });
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    label: "Ground Truth",
                    autoComplete: "off",
                    sx: sx
                })
        })
    }, "ground_truth_dropdown");
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $a65wX = parcelRequire("a65wX");




var $cVCJe = parcelRequire("cVCJe");

var $eg2OC = parcelRequire("eg2OC");

var $6CjWJ = parcelRequire("6CjWJ");

var $4reBM = parcelRequire("4reBM");

var $cWqfz = parcelRequire("cWqfz");

var $cxknk = parcelRequire("cxknk");

var $eJK3E = parcelRequire("eJK3E");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $6II5K = parcelRequire("6II5K");
parcelRequire("8T3gX");
const $0465d401e2e7f520$export$44bad2a4de61b28d = (row, setVerifiedClicked, setUnverifiedClicked)=>{
    if (row.ground_truth === "Verified") {
        setVerifiedClicked(true);
        setUnverifiedClicked(false);
    } else if (row.ground_truth === "Unverified") {
        setVerifiedClicked(false);
        setUnverifiedClicked(true);
    } else {
        setVerifiedClicked(true);
        setUnverifiedClicked(true);
    }
};



var $5L5iJ = parcelRequire("5L5iJ");

var $3Zv1D = parcelRequire("3Zv1D");

var $w8ml8 = parcelRequire("w8ml8");

var $gk2F6 = parcelRequire("gk2F6");

var $9OM1a = parcelRequire("9OM1a");
const $3463043b4c6b2a57$export$bfad5f19668a7346 = (setClipsData, setPageLoading, setSelectedRow, setPrecisionRecallData, setVideoURL, setVideoClipLoading, setClipsIndexOrder, setVerifiedClicked, setUnverifiedClicked, selectedRow, setNoDataToDisplay, setSiteOptions, setLoadingSites, userFilters, setFetchingFilteredData, setPage, moreThan100, lastTimeStamp, lastFileId, setLoadingAdditionalData, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $3463043b4c6b2a57$export$bfad5f19668a7346(setClipsData, setPageLoading, setSelectedRow, setPrecisionRecallData, setVideoURL, setVideoClipLoading, setClipsIndexOrder, setVerifiedClicked, setUnverifiedClicked, selectedRow, setNoDataToDisplay, setSiteOptions, setLoadingSites, userFilters, setFetchingFilteredData, setPage, moreThan100, lastTimeStamp, lastFileId, setLoadingAdditionalData, navigate);
    };
    const convertTimeToUTCFormat = (time)=>{
        const [hours, minutes, seconds] = time.split(":");
        return encodeURIComponent(`${hours}:${minutes}`);
    };
    let searchParamsString = `&start_date=${(0, $5L5iJ.yyyymmddGenerator)(userFilters.start_date)}&end_date=${(0, $5L5iJ.yyyymmddGenerator)(userFilters.end_date)}`;
    if (userFilters.start_date.toString() === userFilters.end_date.toString() && userFilters.start_time !== null) searchParamsString += `&start_time=${convertTimeToUTCFormat((0, $gk2F6.timeSlicer)(userFilters.start_time))}`;
    if (userFilters.start_date.toString() === userFilters.end_date.toString() && userFilters.end_time !== null) searchParamsString += `&end_time=${convertTimeToUTCFormat((0, $gk2F6.timeSlicer)(userFilters.end_time))}`;
    if (userFilters.ground_truth) searchParamsString += `&ground_truth=${userFilters.ground_truth}`;
    searchParamsString += (0, $9OM1a.clipResultParam)(userFilters.clip_result);
    if (userFilters.site_ids[0]) searchParamsString += `&site_ids=${userFilters.site_ids[0]}`;
    if (userFilters.camera_ids[0]) searchParamsString += `&camera_ids=${userFilters.camera_ids[0]}`;
    if (lastTimeStamp) searchParamsString += `&last_timestamp=${lastTimeStamp}`;
    if (lastFileId) searchParamsString += `&last_file_id=${lastFileId}`;
    searchParamsString += `&page_size=100`;
    let dataResponse;
    let last_timestamp = lastTimeStamp;
    let last_file_id = lastFileId;
    AxiosUI.get(`clip/?username=${userFilters.user}${searchParamsString}`).then((response)=>{
        dataResponse = response.data;
        let lastFileIdAILink = "";
        if (localStorage.last_file_id_ailink) lastFileIdAILink = JSON.parse(localStorage.last_file_id_ailink);
        let lastTimeStampAILink = "";
        if (localStorage.last_timestamp_ailink) lastTimeStampAILink = JSON.parse(localStorage.last_timestamp_ailink);
        if (lastFileIdAILink === lastFileId && lastTimeStampAILink === lastTimeStamp) {
            const results = response.data.results;
            if (response.data.count === 0) {
                setNoDataToDisplay(true);
                setPageLoading(false);
                setVideoClipLoading(false);
                setFetchingFilteredData(false);
            }
            if (response.data.count === 100) {
                setClipsData((previousState)=>{
                    return (0, $6II5K.addSelectedParam)([
                        ...previousState,
                        ...results
                    ], setClipsIndexOrder, lastFileId);
                });
                const responsePrecisionRecall = (0, $w8ml8.totalUpPrecisionRecallData)(response.data.summary);
                setPrecisionRecallData((previousState)=>{
                    let precisionResponse = previousState.precision;
                    let recallResposne = previousState.recall;
                    if (!precisionResponse) precisionResponse = responsePrecisionRecall.precision;
                    if (!recallResposne) recallResposne = responsePrecisionRecall.recall;
                    return {
                        date: responsePrecisionRecall.date,
                        date_str: responsePrecisionRecall.date_str,
                        true_positives: responsePrecisionRecall.true_positives + previousState.true_positives,
                        false_positives: responsePrecisionRecall.false_positives + previousState.false_positives,
                        false_negatives: responsePrecisionRecall.false_negatives + previousState.false_negatives,
                        true_negatives: responsePrecisionRecall.true_negatives + previousState.true_negatives,
                        unclassified: responsePrecisionRecall.unclassified + previousState.unclassified,
                        total_clips: responsePrecisionRecall.total_clips + previousState.total_clips,
                        precision: precisionResponse,
                        recall: recallResposne
                    };
                });
                localStorage.setItem("last_file_id_ailink", JSON.stringify(response.data.last_file_id));
                localStorage.setItem("last_timestamp_ailink", JSON.stringify(response.data.last_timestamp));
                last_timestamp = response.data.last_timestamp;
                last_file_id = response.data.last_file_id;
                if (lastFileId === "") {
                    setSelectedRow(results[0]);
                    (0, $0465d401e2e7f520$export$44bad2a4de61b28d)(results[0], setVerifiedClicked, setUnverifiedClicked);
                    AxiosUI.get(`clip/info/?username=${userFilters.user}&file_id=${results[0].file_id}`).then((response)=>{
                        if (response.data.file_id) {
                            for(const key in response.data)setSelectedRow((previousState)=>{
                                return {
                                    ...previousState,
                                    [key]: response.data[key]
                                };
                            });
                            localStorage.setItem("clipsSelectedRow", JSON.stringify(selectedRow));
                            AxiosUI.get(`clip/url/?username=${userFilters.user}&file_id=${response.data.file_id}`).then((response)=>{
                                setNoDataToDisplay(false);
                                setVideoURL(response.data);
                                setPageLoading(false);
                                setVideoClipLoading(false);
                                setFetchingFilteredData(false);
                                if (last_timestamp && last_file_id) $3463043b4c6b2a57$export$bfad5f19668a7346(setClipsData, setPageLoading, setSelectedRow, setPrecisionRecallData, setVideoURL, setVideoClipLoading, setClipsIndexOrder, setVerifiedClicked, setUnverifiedClicked, selectedRow, setNoDataToDisplay, setSiteOptions, setLoadingSites, userFilters, setFetchingFilteredData, setPage, true, last_timestamp, last_file_id, setLoadingAdditionalData, navigate);
                                else {
                                    if (dataResponse.results[0]) {
                                        if (dataResponse.results[0].file_id) AxiosUI.get(`clip/info/?username=${userFilters.user}&file_id=${results[0].file_id}`).then((response)=>{
                                            if (response.data.event_timestamp) {
                                                localStorage.setItem("last_file_id_ailink", JSON.stringify(response.data.file_id));
                                                localStorage.setItem("last_timestamp_ailink", JSON.stringify(response.data.event_timestamp));
                                                $3463043b4c6b2a57$export$bfad5f19668a7346(setClipsData, setPageLoading, setSelectedRow, setPrecisionRecallData, setVideoURL, setVideoClipLoading, setClipsIndexOrder, setVerifiedClicked, setUnverifiedClicked, selectedRow, setNoDataToDisplay, setSiteOptions, setLoadingSites, userFilters, setFetchingFilteredData, setPage, true, response.data.event_timestamp, response.data.file_id, setLoadingAdditionalData, navigate);
                                            }
                                        });
                                    }
                                }
                            }, (reason)=>{
                                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                                    setNoDataToDisplay(false);
                                    setPageLoading(false);
                                    setVideoClipLoading(false);
                                    setFetchingFilteredData(false);
                                    setLoadingAdditionalData(false);
                                });
                            });
                        }
                    }, (reason)=>{
                        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                            setPageLoading(false);
                            setVideoClipLoading(false);
                            setFetchingFilteredData(false);
                        });
                    });
                } else {
                    localStorage.setItem("last_file_id_ailink", JSON.stringify(response.data.last_file_id));
                    localStorage.setItem("last_timestamp_ailink", JSON.stringify(response.data.last_timestamp));
                    if (last_timestamp && last_file_id) $3463043b4c6b2a57$export$bfad5f19668a7346(setClipsData, setPageLoading, setSelectedRow, setPrecisionRecallData, setVideoURL, setVideoClipLoading, setClipsIndexOrder, setVerifiedClicked, setUnverifiedClicked, selectedRow, setNoDataToDisplay, setSiteOptions, setLoadingSites, userFilters, setFetchingFilteredData, setPage, true, last_timestamp, last_file_id, setLoadingAdditionalData, navigate);
                    else {
                        if (dataResponse.results[0]) {
                            if (dataResponse.results[0].file_id) AxiosUI.get(`clip/info/?username=${userFilters.user}&file_id=${results[0].file_id}`).then((response)=>{
                                if (response.data.event_timestamp) {
                                    localStorage.setItem("last_file_id_ailink", JSON.stringify(response.data.file_id));
                                    localStorage.setItem("last_timestamp_ailink", JSON.stringify(response.data.event_timestamp));
                                    $3463043b4c6b2a57$export$bfad5f19668a7346(setClipsData, setPageLoading, setSelectedRow, setPrecisionRecallData, setVideoURL, setVideoClipLoading, setClipsIndexOrder, setVerifiedClicked, setUnverifiedClicked, selectedRow, setNoDataToDisplay, setSiteOptions, setLoadingSites, userFilters, setFetchingFilteredData, setPage, true, response.data.event_timestamp, response.data.file_id, setLoadingAdditionalData, navigate);
                                }
                            });
                        }
                    }
                }
            }
            if (response.data.count < 100) {
                if (results[0] && moreThan100) {
                    setClipsData((previousState)=>{
                        return (0, $6II5K.addSelectedParam)([
                            ...previousState,
                            ...results
                        ], setClipsIndexOrder, lastFileId);
                    });
                    const responsePrecisionRecall = (0, $w8ml8.totalUpPrecisionRecallData)(response.data.summary);
                    setPrecisionRecallData((previousState)=>{
                        let precisionResponse = previousState.precision;
                        let recallResposne = previousState.recall;
                        if (!precisionResponse) precisionResponse = responsePrecisionRecall.precision;
                        if (!recallResposne) recallResposne = responsePrecisionRecall.recall;
                        return {
                            date: responsePrecisionRecall.date,
                            date_str: responsePrecisionRecall.date_str,
                            true_positives: responsePrecisionRecall.true_positives + previousState.true_positives,
                            false_positives: responsePrecisionRecall.false_positives + previousState.false_positives,
                            false_negatives: responsePrecisionRecall.false_negatives + previousState.false_negatives,
                            true_negatives: responsePrecisionRecall.true_negatives + previousState.true_negatives,
                            unclassified: responsePrecisionRecall.unclassified + previousState.unclassified,
                            total_clips: responsePrecisionRecall.total_clips + previousState.total_clips,
                            precision: precisionResponse,
                            recall: recallResposne
                        };
                    });
                    setNoDataToDisplay(false);
                    setPageLoading(false);
                    setFetchingFilteredData(false);
                    setLoadingAdditionalData(false);
                }
                if (results[0] && !moreThan100) {
                    setSelectedRow(results[0]);
                    (0, $0465d401e2e7f520$export$44bad2a4de61b28d)(results[0], setVerifiedClicked, setUnverifiedClicked);
                    setClipsData((previousState)=>{
                        return (0, $6II5K.addSelectedParam)([
                            ...previousState,
                            ...results
                        ], setClipsIndexOrder, lastFileId);
                    });
                    const responsePrecisionRecall = (0, $w8ml8.totalUpPrecisionRecallData)(response.data.summary);
                    setPrecisionRecallData((previousState)=>{
                        let precisionResponse = previousState.precision;
                        let recallResposne = previousState.recall;
                        if (!precisionResponse) precisionResponse = responsePrecisionRecall.precision;
                        if (!recallResposne) recallResposne = responsePrecisionRecall.recall;
                        return {
                            date: responsePrecisionRecall.date,
                            date_str: responsePrecisionRecall.date_str,
                            true_positives: responsePrecisionRecall.true_positives + previousState.true_positives,
                            false_positives: responsePrecisionRecall.false_positives + previousState.false_positives,
                            false_negatives: responsePrecisionRecall.false_negatives + previousState.false_negatives,
                            true_negatives: responsePrecisionRecall.true_negatives + previousState.true_negatives,
                            unclassified: responsePrecisionRecall.unclassified + previousState.unclassified,
                            total_clips: responsePrecisionRecall.total_clips + previousState.total_clips,
                            precision: precisionResponse,
                            recall: recallResposne
                        };
                    });
                    AxiosUI.get(`clip/info/?username=${userFilters.user}&file_id=${results[0].file_id}`).then((response)=>{
                        if (response.data.file_id) {
                            for(const key in response.data)setSelectedRow((previousState)=>{
                                return {
                                    ...previousState,
                                    [key]: response.data[key]
                                };
                            });
                            localStorage.setItem("clipsSelectedRow", JSON.stringify(selectedRow));
                            AxiosUI.get(`clip/url/?username=${userFilters.user}&file_id=${response.data.file_id}`).then((response)=>{
                                setNoDataToDisplay(false);
                                setVideoURL(response.data);
                                setPageLoading(false);
                                setVideoClipLoading(false);
                                setFetchingFilteredData(false);
                                setLoadingAdditionalData(false);
                            }, (reason)=>{
                                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                                    setPageLoading(false);
                                    setVideoClipLoading(false);
                                    setLoadingAdditionalData(false);
                                });
                            });
                        }
                    }, (reason)=>{
                        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                            setNoDataToDisplay(false);
                            setPageLoading(false);
                            setVideoClipLoading(false);
                            setFetchingFilteredData(false);
                            setLoadingAdditionalData(false);
                        });
                    });
                }
                if (!results[0] && !moreThan100) {
                    setNoDataToDisplay(true);
                    setPageLoading(false);
                    setLoadingAdditionalData(false);
                }
            }
        }
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setPageLoading(false);
            setLoadingAdditionalData(false);
        });
    });
};



const $1eebf2e16e3156e5$export$b12cd7d42b630446 = (militaryTime)=>{
    // Extract hours and minutes from military time (e.g., "1800" -> 18:00)
    const hours = parseInt(militaryTime.substring(0, 2), 10);
    const minutes = parseInt(militaryTime.substring(2, 4), 10);
    // Get the current date
    const date = new Date();
    // Set the time from the military time
    date.setHours(hours); // Hours from military time
    date.setMinutes(minutes); // Minutes from military time
    date.setSeconds(0); // Set seconds to 58
    // Return the date string including timezone information
    return date.toString();
};


const $60d1d427e7f38222$var$VALID_TABS = [
    "ailink",
    "sentinel",
    "smtp",
    "frontel"
];
const $60d1d427e7f38222$var$parseNumberList = (str)=>{
    if (!str || !str.trim()) return [];
    return str.split(",").map((s)=>parseInt(s.trim(), 10)).filter((n)=>!Number.isNaN(n));
};
const $60d1d427e7f38222$export$85acc667c334b9a6 = (str)=>{
    if (!str || !str.trim()) return null;
    const monthNames = {
        Jan: 0,
        Feb: 1,
        Mar: 2,
        Apr: 3,
        May: 4,
        Jun: 5,
        Jul: 6,
        Aug: 7,
        Sep: 8,
        Oct: 9,
        Nov: 10,
        Dec: 11
    };
    const parts = str.trim().split("-");
    if (parts.length !== 3) return null;
    const [monthStr, dayStr, yearStr] = parts;
    const month = monthNames[monthStr];
    if (month === undefined) return null;
    const day = parseInt(dayStr, 10);
    const year = parseInt(yearStr, 10);
    if (Number.isNaN(day) || Number.isNaN(year)) return null;
    const date = new Date(year, month, day);
    if (Number.isNaN(date.getTime())) return null;
    return date;
};
const $60d1d427e7f38222$export$db3fe5d7f69c66e3 = (str)=>{
    if (!str || !str.trim() || str.length < 4) return null;
    try {
        const dateStr = (0, $1eebf2e16e3156e5$export$b12cd7d42b630446)(str.trim());
        return new Date(dateStr);
    } catch  {
        return null;
    }
};
const $60d1d427e7f38222$export$7bec5a0d32106be6 = (searchParams)=>{
    const tabRaw = searchParams.get("tab");
    const tab = tabRaw && $60d1d427e7f38222$var$VALID_TABS.includes(tabRaw) ? tabRaw : null;
    const user = searchParams.get("user") || null;
    const group = searchParams.get("group") || null;
    const file_id = searchParams.get("file_id") || null;
    const clip_id = searchParams.get("clip_id") || null;
    const siteIds = $60d1d427e7f38222$var$parseNumberList(searchParams.get("site"));
    const cameraIds = $60d1d427e7f38222$var$parseNumberList(searchParams.get("camera"));
    const start_date = $60d1d427e7f38222$export$85acc667c334b9a6(searchParams.get("start_date"));
    const end_date = $60d1d427e7f38222$export$85acc667c334b9a6(searchParams.get("end_date"));
    const start_time = $60d1d427e7f38222$export$db3fe5d7f69c66e3(searchParams.get("start_time"));
    const end_time = $60d1d427e7f38222$export$db3fe5d7f69c66e3(searchParams.get("end_time"));
    const clip_result = searchParams.get("clip_result") || null;
    const ground_truth = searchParams.get("ground_truth") || null;
    const hasAnyFilterParam = !!user || !!group || siteIds.length > 0 || cameraIds.length > 0 || !!start_date || !!end_date || !!start_time || !!end_time || !!clip_result || !!ground_truth;
    return {
        tab: tab,
        user: user,
        group: group,
        file_id: file_id,
        clip_id: clip_id,
        siteIds: siteIds,
        cameraIds: cameraIds,
        start_date: start_date,
        end_date: end_date,
        start_time: start_time,
        end_time: end_time,
        clip_result: clip_result,
        ground_truth: ground_truth,
        hasAnyFilterParam: hasAnyFilterParam
    };
};
const $60d1d427e7f38222$var$toHHMM = (t)=>{
    if (!t) return "";
    const d = t instanceof Date ? t : new Date(t);
    if (Number.isNaN(d.getTime())) return "";
    const h = d.getHours().toString().padStart(2, "0");
    const m = d.getMinutes().toString().padStart(2, "0");
    return `${h}${m}`;
};
const $60d1d427e7f38222$var$toRoundedMinute = (date)=>{
    const rounded = new Date(date.getTime());
    rounded.setSeconds(0, 0);
    return rounded;
};
const $60d1d427e7f38222$var$getClipDateFromRow = (row)=>{
    if (!row) return null;
    const rawTimestamp = row.clip_received_local ?? row.clip_header_received ?? row.clip_received ?? row.local_time_received ?? row.formatted_date;
    if (!rawTimestamp) return null;
    if (typeof rawTimestamp === "string") {
        const isoLikeMatch = rawTimestamp.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2})(?:\.(\d+))?)?/);
        if (isoLikeMatch) {
            const year = Number(isoLikeMatch[1]);
            const month = Number(isoLikeMatch[2]) - 1;
            const day = Number(isoLikeMatch[3]);
            const hour = Number(isoLikeMatch[4]);
            const minute = Number(isoLikeMatch[5]);
            const second = Number(isoLikeMatch[6] ?? 0);
            const millisecond = Number((isoLikeMatch[7] ?? "0").slice(0, 3));
            const fromIso = new Date(year, month, day, hour, minute, second, millisecond);
            return Number.isNaN(fromIso.getTime()) ? null : fromIso;
        }
    }
    const parsed = new Date(rawTimestamp);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
};
const $60d1d427e7f38222$export$d0ea5288e6803239 = (setSearchParams, searchParams)=>{
    const currentFileId = searchParams.get("file_id");
    const currentClipId = searchParams.get("clip_id");
    if (!currentFileId && !currentClipId) return;
    const nextParams = new URLSearchParams(searchParams);
    nextParams.delete("file_id");
    nextParams.delete("clip_id");
    setSearchParams(nextParams);
};
const $60d1d427e7f38222$export$ebaabfbed7661a81 = (tab, selectedRow, searchParams)=>{
    const clipDate = $60d1d427e7f38222$var$getClipDateFromRow(selectedRow);
    if (!clipDate) return null;
    const selectedRowId = tab === "smtp" ? selectedRow?.clip_id ?? null : selectedRow?.file_id ?? null;
    if (!selectedRowId) return null;
    const roundedStart = $60d1d427e7f38222$var$toRoundedMinute(clipDate);
    const roundedEnd = new Date(roundedStart.getTime());
    roundedEnd.setMinutes(roundedEnd.getMinutes() + 1);
    const shareParams = new URLSearchParams(searchParams);
    shareParams.set("tab", tab);
    shareParams.set("start_date", (0, $361dd3e7be612e92$export$75935ad7f1142eef)(roundedStart));
    shareParams.set("end_date", (0, $361dd3e7be612e92$export$75935ad7f1142eef)(roundedStart));
    shareParams.set("start_time", $60d1d427e7f38222$var$toHHMM(roundedStart));
    shareParams.set("end_time", $60d1d427e7f38222$var$toHHMM(roundedEnd));
    if (tab === "smtp") {
        shareParams.set("clip_id", String(selectedRowId));
        shareParams.delete("file_id");
    } else {
        shareParams.set("file_id", String(selectedRowId));
        shareParams.delete("clip_id");
    }
    if (typeof window === "undefined") return `/clips?${shareParams.toString()}`;
    return `${window.location.origin}${window.location.pathname}?${shareParams.toString()}`;
};
const $60d1d427e7f38222$export$867258f8bab37ec = (setSearchParams, tab, filters, options)=>{
    const params = new URLSearchParams();
    params.set("tab", tab);
    if (options?.groupId != null) params.set("group", String(options.groupId));
    else params.delete("group");
    if (filters.user) params.set("user", filters.user);
    else params.delete("user");
    const siteIds = filters.site_ids;
    if (siteIds && siteIds.length > 0) {
        const first = siteIds[0];
        params.set("site", Array.isArray(siteIds) ? siteIds.map(String).join(",") : String(first));
    } else params.delete("site");
    const cameraIds = filters.camera_ids;
    if (cameraIds && cameraIds.length > 0) params.set("camera", Array.isArray(cameraIds) ? cameraIds.map(String).join(",") : String(cameraIds[0]));
    else params.delete("camera");
    if (filters.start_date) params.set("start_date", (0, $361dd3e7be612e92$export$75935ad7f1142eef)(filters.start_date));
    else params.delete("start_date");
    if (filters.end_date) params.set("end_date", (0, $361dd3e7be612e92$export$75935ad7f1142eef)(filters.end_date));
    else params.delete("end_date");
    const startTimeStr = $60d1d427e7f38222$var$toHHMM(filters.start_time ?? undefined);
    if (startTimeStr) params.set("start_time", startTimeStr);
    else params.delete("start_time");
    const endTimeStr = $60d1d427e7f38222$var$toHHMM(filters.end_time ?? undefined);
    if (endTimeStr) params.set("end_time", endTimeStr);
    else params.delete("end_time");
    if (filters.clip_result) params.set("clip_result", filters.clip_result);
    else params.delete("clip_result");
    if (filters.ground_truth) params.set("ground_truth", filters.ground_truth);
    else params.delete("ground_truth");
    if (tab === "smtp") {
        if (options?.selectedClipId) params.set("clip_id", options.selectedClipId);
        else params.delete("clip_id");
        params.delete("file_id");
    } else {
        if (options?.selectedFileId) params.set("file_id", options.selectedFileId);
        else params.delete("file_id");
        params.delete("clip_id");
    }
    setSearchParams(params);
};



var $4G44R = parcelRequire("4G44R");
const $d169e7ce04c38141$export$c3c758fb067464a8 = ({ setClipsData: setClipsData, setPageLoading: setPageLoading, setSelectedRow: setSelectedRow, setPrecisionRecallData: setPrecisionRecallData, setVideoURL: setVideoURL, setVideoClipLoading: setVideoClipLoading, setClipsIndexOrder: setClipsIndexOrder, setVerifiedClicked: setVerifiedClicked, setUnverifiedClicked: setUnverifiedClicked, selectedRow: selectedRow, setNoDataToDisplay: setNoDataToDisplay, setSiteOptions: setSiteOptions, setLoadingSites: setLoadingSites, userFilters: userFilters, setFetchingFilteredData: setFetchingFilteredData, setPage: setPage, setAiLinkClipsTotal: setAiLinkClipsTotal, setLoadingAdditionalData: setLoadingAdditionalData, setFiltersApplied: setFiltersApplied, navigate: navigate, setSearchParams: setSearchParams, groupID: groupID })=>{
    const options = [
        "Apply Filters",
        "Download Report"
    ];
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const anchorRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const [option, setOption] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(options[0]);
    const { downloadURLAILink: downloadURLAILink, fetchingDownloadURLAILink: fetchingDownloadURLAILink, getDownloadURLAILink: getDownloadURLAILink } = (0, $4G44R.useClipsStore)();
    const handleRefreshReport = ()=>{
        getDownloadURLAILink(navigate, userFilters, true, groupID);
    };
    const handleClick = ()=>{
        if (option === "Apply Filters") {
            setFiltersApplied(true);
            setLoadingAdditionalData(true);
            setAiLinkClipsTotal(0);
            setSelectedRow({});
            setNoDataToDisplay(true);
            setFetchingFilteredData(true);
            setClipsData([]);
            setPage(0);
            setPrecisionRecallData({
                date: "",
                date_str: "",
                true_positives: 0,
                false_positives: 0,
                false_negatives: 0,
                true_negatives: 0,
                unclassified: 0,
                total_clips: 0,
                precision: null,
                recall: null
            });
            localStorage.setItem("last_file_id_ailink", "");
            localStorage.setItem("last_timestamp_ailink", "");
            (0, $3463043b4c6b2a57$export$bfad5f19668a7346)(setClipsData, setPageLoading, setSelectedRow, setPrecisionRecallData, setVideoURL, setVideoClipLoading, setClipsIndexOrder, setVerifiedClicked, setUnverifiedClicked, selectedRow, setNoDataToDisplay, setSiteOptions, setLoadingSites, userFilters, setFetchingFilteredData, setPage, false, "", "", setLoadingAdditionalData, navigate);
            if (setSearchParams) (0, $60d1d427e7f38222$export$867258f8bab37ec)(setSearchParams, "ailink", userFilters, {
                groupId: groupID ?? undefined
            });
        }
    };
    const handleMenuItemClick = (event, index)=>{
        setOption(options[index]);
        setOpen(false);
    };
    const handleToggle = ()=>{
        setOpen((prevOpen)=>!prevOpen);
    };
    const handleClose = (event)=>{
        if (anchorRef.current && anchorRef.current.contains(event.target)) return;
        setOpen(false);
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "z-10",
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $d685fbaea40075f4$export$2e2bcd8739ae039), {
                    variant: "contained",
                    ref: anchorRef,
                    "aria-label": "Site Group Actions",
                    disabled: false,
                    color: "warning",
                    children: [
                        option === "Apply Filters" ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                            onClick: handleClick,
                            disabled: false,
                            sx: {
                                backgroundColor: "#FF8400",
                                "&:hover": {
                                    backgroundColor: "#E67300"
                                },
                                width: "140px"
                            },
                            children: option
                        }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                            onClick: ()=>{},
                            component: "a",
                            href: downloadURLAILink,
                            download: true,
                            disabled: !downloadURLAILink,
                            sx: {
                                color: "white",
                                backgroundColor: "#FF8400",
                                "&:hover": {
                                    backgroundColor: "#E67300",
                                    color: "white"
                                },
                                width: "178px",
                                textDecoration: "none"
                            },
                            children: fetchingDownloadURLAILink ? "Fetching Report..." : "Download Report"
                        }),
                        option === "Download Report" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                            title: "Regenerate the report with the latest clips",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                size: "small",
                                "aria-label": "refresh report",
                                disabled: fetchingDownloadURLAILink,
                                sx: {
                                    backgroundColor: "#FF8400",
                                    "&:hover": {
                                        backgroundColor: "#E67300"
                                    }
                                },
                                onClick: handleRefreshReport,
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9222626528c451ae$exports))), {})
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                            size: "small",
                            "aria-controls": open ? "split-button-menu" : undefined,
                            "aria-expanded": open ? "true" : undefined,
                            "aria-label": "select group action",
                            "aria-haspopup": "menu",
                            sx: {
                                backgroundColor: "#FF8400",
                                "&:hover": {
                                    backgroundColor: "#E67300"
                                }
                            },
                            onClick: handleToggle,
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bf807683d00d38ca$exports))), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $cWqfz.default), {
                    sx: {
                        zIndex: 1
                    },
                    open: open,
                    anchorEl: anchorRef.current,
                    role: undefined,
                    transition: true,
                    disablePortal: true,
                    children: ({ TransitionProps: TransitionProps, placement: placement })=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $6CjWJ.default), {
                            ...TransitionProps,
                            style: {
                                transformOrigin: placement === "bottom" ? "center top" : "center bottom"
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4reBM.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eg2OC.ClickAwayListener), {
                                    onClickAway: handleClose,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eJK3E.default), {
                                        className: "absolute",
                                        id: "split-button-menu",
                                        autoFocusItem: true,
                                        children: options.map((option, index)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                selected: index === options.indexOf(option),
                                                onClick: (event)=>handleMenuItemClick(event, index),
                                                children: option
                                            }, option))
                                    })
                                })
                            })
                        })
                })
            ]
        })
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $b94416ec814c369f$export$e8f5d2acbd281022 = (setSiteOptions, setLoadingSites, groupID, navigate)=>{
    setLoadingSites(true);
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $b94416ec814c369f$export$e8f5d2acbd281022(setSiteOptions, setLoadingSites, groupID, navigate);
    };
    AxiosUI.get(`customer/names/${groupID}/`).then((response)=>{
        setSiteOptions(response.data);
        setLoadingSites(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setLoadingSites(false);
        });
    });
};


const $33fd419e27bf1d1b$export$baab627727ff11a7 = ({ userDropDownValue: userDropDownValue, userOptions: userOptions, setUserDropDownValue: setUserDropDownValue, setCameraDropDownValue: setCameraDropDownValue, userFilters: userFilters, setUserFilters: setUserFilters, setSiteDropDownValue: setSiteDropDownValue, setSiteOptions: setSiteOptions, setCameraOptions: setCameraOptions, setLoadingSites: setLoadingSites, groupID: groupID, setGroupID: setGroupID, navBarCollapsed: navBarCollapsed, navigate: navigate })=>{
    const options = [];
    const optionUserIds = new Map();
    userOptions.map((object)=>{
        if (object.group) options.push(object.group.name);
    });
    userOptions.forEach((object)=>{
        if (object.group) optionUserIds.set(object.group.name, object.group.id);
    });
    const optionUserNames = new Map();
    userOptions.forEach((object)=>{
        if (object.group) optionUserNames.set(object.group.name, object.username);
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            value: userDropDownValue,
            disablePortal: true,
            options: options,
            onChange: (event, value)=>{
                if (value !== null) {
                    setUserDropDownValue(value);
                    setCameraDropDownValue(null);
                    setGroupID(optionUserIds.get(value));
                    setSiteDropDownValue(null);
                    setSiteOptions([]);
                    (0, $b94416ec814c369f$export$e8f5d2acbd281022)(setSiteOptions, setLoadingSites, optionUserIds.get(value), navigate);
                    setUserFilters((previousState)=>{
                        return {
                            ...previousState,
                            user: optionUserNames.get(value),
                            site_ids: [],
                            camera_ids: []
                        };
                    });
                } else {
                    // setFetchingFilteredData(true);
                    setUserDropDownValue(value);
                    setGroupID(null);
                    setSiteDropDownValue(null);
                    setSiteOptions([]);
                    setCameraDropDownValue(null);
                    setCameraOptions([]);
                    setUserFilters((previousState)=>{
                        return {
                            ...previousState,
                            user: "testuser",
                            site_ids: [],
                            camera_ids: []
                        };
                    });
                }
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    label: "User",
                    autoComplete: "off",
                    sx: !navBarCollapsed ? {
                        width: 120
                    } : {
                        width: 140
                    }
                })
        })
    }, "user_dropdown");
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eejVe = parcelRequire("eejVe");
var $cVCJe = parcelRequire("cVCJe");

var $hwWkD = parcelRequire("hwWkD");

var $a50J4 = parcelRequire("a50J4");

var $hfM8m = parcelRequire("hfM8m");
/** Tooltip when start/end time pickers are disabled until start and end dates match. */ const $ffbec3bd61ee0d21$export$e5ad0d4cfb9b77f4 = "Both start and end date must be the same in order for start and end time filters to be enabled.";
const $ffbec3bd61ee0d21$export$e05dfa29a5a8721a = {
    tooltip: {
        sx: {
            fontFamily: "Mulish",
            maxWidth: 320
        }
    }
};
const $ffbec3bd61ee0d21$export$b1886b315cb3d290 = {
    placement: "bottom",
    componentsProps: $ffbec3bd61ee0d21$export$e05dfa29a5a8721a,
    PopperProps: {
        modifiers: [
            {
                name: "flip",
                enabled: false
            },
            {
                name: "preventOverflow",
                options: {
                    altAxis: false,
                    padding: 8
                }
            }
        ]
    }
};


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $60846fa53ec438a6$export$7d27908384db4a68 = ({ userFilters: userFilters, setUserFilters: setUserFilters, showUserDropDown: showUserDropDown, timeFiltersDisabledAILink: timeFiltersDisabledAILink })=>{
    const navigate = (0, $3T949.useNavigate)();
    const sx = showUserDropDown ? {
        width: 132
    } : {
        width: 135
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
        dateAdapter: (0, $hfM8m.AdapterDateFns),
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
            title: (0, $ffbec3bd61ee0d21$export$e5ad0d4cfb9b77f4),
            disableHoverListener: !timeFiltersDisabledAILink,
            disableFocusListener: !timeFiltersDisabledAILink,
            disableTouchListener: !timeFiltersDisabledAILink,
            ...(0, $ffbec3bd61ee0d21$export$b1886b315cb3d290),
            children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                style: {
                    display: "inline-block"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a50J4.DesktopTimePicker), {
                    label: "Start Time",
                    value: userFilters.start_time ? userFilters.start_time : null,
                    onChange: (newValue)=>{
                        setUserFilters((previousState)=>{
                            return {
                                ...previousState,
                                start_time: newValue
                            };
                        });
                    },
                    disabled: timeFiltersDisabledAILink,
                    renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                            ...params,
                            autoComplete: "off",
                            sx: sx
                        })
                })
            })
        })
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eejVe = parcelRequire("eejVe");
var $cVCJe = parcelRequire("cVCJe");

var $hwWkD = parcelRequire("hwWkD");

var $a50J4 = parcelRequire("a50J4");

var $hfM8m = parcelRequire("hfM8m");

parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $36edd5e4f30f4fb3$export$d61463baa1c1fd73 = ({ userFilters: userFilters, setUserFilters: setUserFilters, showUserDropDown: showUserDropDown, timeFiltersDisabledAILink: timeFiltersDisabledAILink })=>{
    const navigate = (0, $3T949.useNavigate)();
    const sx = showUserDropDown ? {
        width: 132
    } : {
        width: 135
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
        dateAdapter: (0, $hfM8m.AdapterDateFns),
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
            title: (0, $ffbec3bd61ee0d21$export$e5ad0d4cfb9b77f4),
            disableHoverListener: !timeFiltersDisabledAILink,
            disableFocusListener: !timeFiltersDisabledAILink,
            disableTouchListener: !timeFiltersDisabledAILink,
            ...(0, $ffbec3bd61ee0d21$export$b1886b315cb3d290),
            children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                style: {
                    display: "inline-block"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a50J4.DesktopTimePicker), {
                    label: "End Time",
                    value: userFilters.end_time ? userFilters.end_time : null,
                    onChange: (newValue)=>{
                        setUserFilters((previousState)=>{
                            return {
                                ...previousState,
                                end_time: newValue
                            };
                        });
                    },
                    disabled: timeFiltersDisabledAILink,
                    renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                            ...params,
                            autoComplete: "off",
                            sx: sx
                        })
                })
            })
        })
    });
};



var $4G44R = parcelRequire("4G44R");
const $10079186e7068381$export$7bb930e6ad93bc7b = ({ siteOptions: siteOptions, loadingSites: loadingSites, siteDropDownValue: siteDropDownValue, setSiteDropDownValue: setSiteDropDownValue, setCameraDropDownValue: setCameraDropDownValue, setUserFilters: setUserFilters, setCameraOptions: setCameraOptions, setLoadingCameras: setLoadingCameras, cameraOptions: cameraOptions, cameraDropDownValue: cameraDropDownValue, loadingCameras: loadingCameras, setClipsData: setClipsData, setPageLoading: setPageLoading, setSelectedRow: setSelectedRow, setPrecisionRecallData: setPrecisionRecallData, setVideoURL: setVideoURL, setVideoClipLoading: setVideoClipLoading, setClipsIndexOrder: setClipsIndexOrder, setVerifiedClicked: setVerifiedClicked, setUnverifiedClicked: setUnverifiedClicked, selectedRow: selectedRow, setNoDataToDisplay: setNoDataToDisplay, setSiteOptions: setSiteOptions, setLoadingSites: setLoadingSites, userFilters: userFilters, setFetchingFilteredData: setFetchingFilteredData, setPage: setPage, showUserDropDown: showUserDropDown, userDropDownValue: userDropDownValue, userOptions: userOptions, setUserDropDownValue: setUserDropDownValue, groupID: groupID, setGroupID: setGroupID, setAiLinkClipsTotal: setAiLinkClipsTotal, setLoadingAdditionalData: setLoadingAdditionalData, navBarCollapsed: navBarCollapsed, userInfo: userInfo, setFiltersApplied: setFiltersApplied, timeFiltersDisabledAILink: timeFiltersDisabledAILink, setTimeFiltersDisabledAILink: setTimeFiltersDisabledAILink, navigate: navigate, setSearchParams: setSearchParams })=>{
    const { showFrontelTab: showFrontelTab, getDownloadURLAILink: getDownloadURLAILink } = (0, $4G44R.useClipsStore)();
    // Prefetch the report download URL from filter STATE rather than from
    // dropdown onChange handlers, so every path that sets filters is covered —
    // including URL-param hydration and drill-down navigation, which never
    // touch the dropdowns (PROD-47: camera-level drill-down had no report URL).
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!userFilters?.user) return;
        getDownloadURLAILink(navigate, userFilters, false, groupID);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        userFilters,
        groupID
    ]);
    let noUserDropDownCSS = showUserDropDown ? [
        "absolute top-0 left-[125px]",
        "absolute top-0 left-[250px]",
        "absolute top-0 left-[375px]",
        "absolute top-0 left-[530px]",
        "absolute top-0 left-[685px]",
        "absolute top-0 left-[822px]",
        "absolute top-[8px] left-[1215px]",
        "absolute top-0",
        "absolute top-0 left-[959px]",
        "absolute top-0 left-[1084px]"
    ] : [
        "absolute top-0",
        "absolute top-0 left-[165px]",
        "absolute top-0 left-[330px]",
        "absolute top-0 left-[485px]",
        "absolute top-0 left-[640px]",
        "absolute top-0 left-[780px]",
        "absolute top-[8px] left-[1215px]",
        "absolute top-0",
        "absolute top-0 left-[920px]",
        "absolute top-0 left-[1055px]"
    ];
    if (showUserDropDown && navBarCollapsed) noUserDropDownCSS = [
        "absolute top-0 left-[145px]",
        "absolute top-0 left-[290px]",
        "absolute top-0 left-[435px]",
        "absolute top-0 left-[590px]",
        "absolute top-0 left-[745px]",
        "absolute top-0 left-[882px]",
        "absolute top-[8px] left-[1290px]",
        "absolute top-0",
        "absolute top-[0px] left-[1020px]",
        "absolute top-[0px] left-[1145px]"
    ];
    if (!showUserDropDown && navBarCollapsed) noUserDropDownCSS = [
        "absolute top-0",
        "absolute top-0 left-[190px]",
        "absolute top-0 left-[380px]",
        "absolute top-0 left-[540px]",
        "absolute top-0 left-[700px]",
        "absolute top-0 left-[845px]",
        "absolute top-[8px] left-[1290px]",
        "absolute top-0",
        "absolute top-[0px] left-[990px]",
        "absolute top-[0px] left-[1130px]"
    ];
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: (userInfo.permission.sentinel || userInfo.permission.smtp || showFrontelTab) && userInfo.permission.ailink ? "absolute top-[60px] left-0" : "absolute top-[0px] left-0",
        children: [
            showUserDropDown && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[7],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $33fd419e27bf1d1b$export$baab627727ff11a7), {
                    userDropDownValue: userDropDownValue,
                    userOptions: userOptions,
                    setUserDropDownValue: setUserDropDownValue,
                    setCameraDropDownValue: setCameraDropDownValue,
                    userFilters: userFilters,
                    setUserFilters: setUserFilters,
                    setSiteDropDownValue: setSiteDropDownValue,
                    setSiteOptions: setSiteOptions,
                    setCameraOptions: setCameraOptions,
                    setLoadingSites: setLoadingSites,
                    groupID: groupID,
                    setGroupID: setGroupID,
                    navBarCollapsed: navBarCollapsed,
                    navigate: navigate
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[0],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b06f4e3e9c7cad7b$export$ff9e07ee8eeea54e), {
                    siteOptions: siteOptions,
                    loadingSites: loadingSites,
                    siteDropDownValue: siteDropDownValue,
                    setSiteDropDownValue: setSiteDropDownValue,
                    setCameraDropDownValue: setCameraDropDownValue,
                    userFilters: userFilters,
                    setUserFilters: setUserFilters,
                    setCameraOptions: setCameraOptions,
                    setLoadingCameras: setLoadingCameras,
                    showUserDropDown: showUserDropDown,
                    navBarCollapsed: navBarCollapsed,
                    navigate: navigate
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[1],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b1d0f09af465fc66$export$83fafb7693b98b92), {
                    userFilters: userFilters,
                    setUserFilters: setUserFilters,
                    cameraOptions: cameraOptions,
                    cameraDropDownValue: cameraDropDownValue,
                    setCameraDropDownValue: setCameraDropDownValue,
                    siteOptions: siteOptions,
                    loadingCameras: loadingCameras,
                    showUserDropDown: showUserDropDown,
                    navBarCollapsed: navBarCollapsed,
                    navigate: navigate
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[2],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aed70cd9b6f46f8d$export$af7bf6e810cbe511), {
                    userFilters: userFilters,
                    setUserFilters: setUserFilters,
                    setTimeFiltersDisabledAILink: setTimeFiltersDisabledAILink
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[3],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $0f9f2f66963aafab$export$d570e110580e29f0), {
                    userFilters: userFilters,
                    setUserFilters: setUserFilters,
                    setTimeFiltersDisabledAILink: setTimeFiltersDisabledAILink
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[4],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60846fa53ec438a6$export$7d27908384db4a68), {
                    userFilters: userFilters,
                    setUserFilters: setUserFilters,
                    showUserDropDown: showUserDropDown,
                    timeFiltersDisabledAILink: timeFiltersDisabledAILink
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[5],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $36edd5e4f30f4fb3$export$d61463baa1c1fd73), {
                    userFilters: userFilters,
                    setUserFilters: setUserFilters,
                    showUserDropDown: showUserDropDown,
                    timeFiltersDisabledAILink: timeFiltersDisabledAILink
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[8],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1f441af7d8bd507f$export$d64b982d1df0bde5), {
                    userFilters: userFilters,
                    setUserFilters: setUserFilters,
                    showUserDropDown: showUserDropDown
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[9],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60d5cc508a56c0de$export$34f28e0dae5347d5), {
                    userFilters: userFilters,
                    setUserFilters: setUserFilters,
                    showUserDropDown: showUserDropDown,
                    navBarCollapsed: navBarCollapsed
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[6],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $d169e7ce04c38141$export$c3c758fb067464a8), {
                    setClipsData: setClipsData,
                    setPageLoading: setPageLoading,
                    setSelectedRow: setSelectedRow,
                    setPrecisionRecallData: setPrecisionRecallData,
                    setVideoURL: setVideoURL,
                    setVideoClipLoading: setVideoClipLoading,
                    setClipsIndexOrder: setClipsIndexOrder,
                    setVerifiedClicked: setVerifiedClicked,
                    setUnverifiedClicked: setUnverifiedClicked,
                    selectedRow: selectedRow,
                    setNoDataToDisplay: setNoDataToDisplay,
                    setSiteOptions: setSiteOptions,
                    setLoadingSites: setLoadingSites,
                    userFilters: userFilters,
                    setFetchingFilteredData: setFetchingFilteredData,
                    setPage: setPage,
                    setAiLinkClipsTotal: setAiLinkClipsTotal,
                    setLoadingAdditionalData: setLoadingAdditionalData,
                    setFiltersApplied: setFiltersApplied,
                    navigate: navigate,
                    setSearchParams: setSearchParams,
                    groupID: groupID
                })
            })
        ]
    });
};


/* eslint-disable jsx-a11y/media-has-caption */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");


var $3Zv1D = parcelRequire("3Zv1D");
const $ac94b438835877c7$export$7e115a3e3cf5b320 = (inputString, selectedRow, clipsData, setClipsData, setSelectedRow, setPageLoading, setVerifiedClicked, setUnverifiedClicked, navigate)=>{
    const backupInvestigationData = clipsData;
    const updatedInvestigationData = clipsData;
    updatedInvestigationData.forEach((object, index)=>{
        if (selectedRow.file_id === object.file_id) updatedInvestigationData[index].ground_truth = inputString;
    });
    setClipsData(updatedInvestigationData);
    const postedOutcome = {
        username: selectedRow.username,
        file_id: selectedRow.file_id,
        ground_truth: inputString
    };
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $ac94b438835877c7$export$7e115a3e3cf5b320(inputString, selectedRow, clipsData, setClipsData, setSelectedRow, setPageLoading, setVerifiedClicked, setUnverifiedClicked, navigate);
    };
    AxiosUI.post(`/clip/ground_truth/`, postedOutcome).then(()=>{
        setSelectedRow((previousState)=>{
            return {
                ...previousState,
                ground_truth: inputString
            };
        });
        localStorage.setItem("clipsSelectedRow", JSON.stringify(selectedRow));
        setPageLoading(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setClipsData(backupInvestigationData);
            localStorage.setItem("clipsData", JSON.stringify(backupInvestigationData));
            (0, $0465d401e2e7f520$export$44bad2a4de61b28d)(selectedRow, setVerifiedClicked, setUnverifiedClicked);
            setPageLoading(false);
            alert("Error submitting verificaiton status, please try again");
        });
    });
};


const $1d8e64c40a846f87$export$cce750db302eb1aa = ({ unverifiedClicked: unverifiedClicked, setVerifiedClicked: setVerifiedClicked, setUnverifiedClicked: setUnverifiedClicked, selectedRow: selectedRow, clipsData: clipsData, setClipsData: setClipsData, setSelectedRow: setSelectedRow, setPageLoading: setPageLoading, navigate: navigate })=>{
    const filledButton = /*#__PURE__*/ (0, $k4ank.jsx)("button", {
        className: "shadow-button bg-[#D32F2F] border-2 border-[#D32F2F] rounded font-mulish text-white text-base p-1.5 w-[170px]",
        onClick: ()=>{
            setVerifiedClicked(false);
            setUnverifiedClicked(true);
            (0, $ac94b438835877c7$export$7e115a3e3cf5b320)("Unverified", selectedRow, clipsData, setClipsData, setSelectedRow, setPageLoading, setVerifiedClicked, setUnverifiedClicked, navigate);
        },
        disabled: false,
        children: "Unverified"
    });
    const unfilledButton = /*#__PURE__*/ (0, $k4ank.jsx)("button", {
        className: "shadow-button bg-white border-2 border-[#D32F2F] rounded font-mulish text-[#D32F2F] text-base p-1.5 w-[170px]",
        onClick: ()=>{
            setVerifiedClicked(false);
            setUnverifiedClicked(true);
            (0, $ac94b438835877c7$export$7e115a3e3cf5b320)("Unverified", selectedRow, clipsData, setClipsData, setSelectedRow, setPageLoading, setVerifiedClicked, setUnverifiedClicked, navigate);
        },
        disabled: false,
        children: "Unverified"
    });
    return unverifiedClicked ? filledButton : unfilledButton;
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

const $26bd36353098b79e$export$f98c100ce5ec321a = ({ verifiedClicked: verifiedClicked, setVerifiedClicked: setVerifiedClicked, setUnverifiedClicked: setUnverifiedClicked, selectedRow: selectedRow, clipsData: clipsData, setClipsData: setClipsData, setSelectedRow: setSelectedRow, setPageLoading: setPageLoading, navigate: navigate })=>{
    const filledButton = /*#__PURE__*/ (0, $k4ank.jsx)("button", {
        className: "shadow-button bg-[#2E7D32] border-2 border-[#2E7D32] rounded font-mulish text-white text-base p-1.5 w-[170px]",
        onClick: ()=>{
            setVerifiedClicked(true);
            setUnverifiedClicked(false);
            (0, $ac94b438835877c7$export$7e115a3e3cf5b320)("Verified", selectedRow, clipsData, setClipsData, setSelectedRow, setPageLoading, setVerifiedClicked, setUnverifiedClicked, navigate);
        },
        disabled: false,
        children: "Verified"
    });
    const unfilledButton = /*#__PURE__*/ (0, $k4ank.jsx)("button", {
        className: "shadow-button bg-white border-2 border-[#2E7D32] rounded font-mulish text-[#2E7D32] text-base p-1.5 w-[170px]",
        onClick: ()=>{
            setVerifiedClicked(true);
            setUnverifiedClicked(false);
            (0, $ac94b438835877c7$export$7e115a3e3cf5b320)("Verified", selectedRow, clipsData, setClipsData, setSelectedRow, setPageLoading, setVerifiedClicked, setUnverifiedClicked, navigate);
        },
        disabled: false,
        children: "Verified"
    });
    return verifiedClicked ? filledButton : unfilledButton;
};


const $787224e216f1f6bd$export$f5d0ef76d4dc14de = ({ verifiedClicked: verifiedClicked, unverifiedClicked: unverifiedClicked, setVerifiedClicked: setVerifiedClicked, setUnverifiedClicked: setUnverifiedClicked, selectedRow: selectedRow, clipsData: clipsData, setClipsData: setClipsData, setSelectedRow: setSelectedRow, setPageLoading: setPageLoading, navBarCollapsed: navBarCollapsed, navigate: navigate })=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "relative left-[0px] w-[600px] h-[60px] rounded-lg  bg-white",
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: "flex items-center justify-between w-[580px] pl-[15px] pt-[10px]",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "text-actuate-blue font-mulish text-[16px]",
                    children: "Clip Verification Status"
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "w-[170px]",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1d8e64c40a846f87$export$cce750db302eb1aa), {
                        unverifiedClicked: unverifiedClicked,
                        setVerifiedClicked: setVerifiedClicked,
                        setUnverifiedClicked: setUnverifiedClicked,
                        selectedRow: selectedRow,
                        clipsData: clipsData,
                        setClipsData: setClipsData,
                        setSelectedRow: setSelectedRow,
                        setPageLoading: setPageLoading,
                        navigate: navigate
                    })
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "w-[170px]",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $26bd36353098b79e$export$f98c100ce5ec321a), {
                        verifiedClicked: verifiedClicked,
                        setVerifiedClicked: setVerifiedClicked,
                        setUnverifiedClicked: setUnverifiedClicked,
                        selectedRow: selectedRow,
                        clipsData: clipsData,
                        setClipsData: setClipsData,
                        setSelectedRow: setSelectedRow,
                        setPageLoading: setPageLoading,
                        navigate: navigate
                    })
                })
            ]
        })
    });
};


/* eslint-disable jsx-a11y/media-has-caption */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $gus0k = parcelRequire("gus0k");

var $kRZvb = parcelRequire("kRZvb");

var $iKAtE = parcelRequire("iKAtE");

var $f3puC = parcelRequire("f3puC");

var $433j1 = parcelRequire("433j1");


var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $8jTCz = parcelRequire("8jTCz");

var $2aMB5 = parcelRequire("2aMB5");

var $lWchQ = parcelRequire("lWchQ");
parcelRequire("8T3gX");
const $c0433b3a957ff718$var$MONTHS = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
const $c0433b3a957ff718$export$c98629952d5edcb = (dateString, timezone)=>{
    const date = new Date(dateString);
    try {
        const formatter = new Intl.DateTimeFormat("en-US", {
            timeZone: timezone,
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
        const parts = formatter.formatToParts(date);
        const monthNum = parseInt(parts.find((part)=>part.type === "month")?.value || "1", 10);
        const day = parseInt(parts.find((part)=>part.type === "day")?.value || "1", 10);
        const year = parts.find((part)=>part.type === "year")?.value || "";
        const hour = parts.find((part)=>part.type === "hour")?.value || "12";
        const minutes = parts.find((part)=>part.type === "minute")?.value || "00";
        const seconds = parts.find((part)=>part.type === "second")?.value || "00";
        const amPm = parts.find((part)=>part.type === "dayPeriod")?.value?.toUpperCase() || "AM";
        return `${$c0433b3a957ff718$var$MONTHS[monthNum - 1]} ${day}, ${year}, ${hour}:${minutes}:${seconds} ${amPm}`;
    } catch  {
        return $c0433b3a957ff718$export$6a6c5e33e36c4dc4(dateString);
    }
};
const $c0433b3a957ff718$export$36a24ca552645e4e = (clipHeaderReceived, clipReceivedLocal, siteTimezone)=>{
    const utcSource = clipHeaderReceived || clipReceivedLocal;
    if (!utcSource) return "";
    if (siteTimezone) return $c0433b3a957ff718$export$c98629952d5edcb(utcSource, siteTimezone);
    if (clipReceivedLocal && !clipReceivedLocal.endsWith("Z")) return $c0433b3a957ff718$export$a42f1efec9282da9(clipReceivedLocal);
    return $c0433b3a957ff718$export$184a24560d1e87ce(clipReceivedLocal || utcSource);
};
const $c0433b3a957ff718$export$184a24560d1e87ce = (dateString)=>{
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = $c0433b3a957ff718$var$MONTHS[date.getUTCMonth()];
    const day = date.getUTCDate();
    // Formatting the hour for 12-hour clock and calculating AM/PM
    let hour = date.getUTCHours();
    const amPm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12;
    hour = hour ? hour : 12; // the hour '0' should be '12'
    const minutes = date.getUTCMinutes().toString().padStart(2, "0");
    const seconds = date.getUTCSeconds().toString().padStart(2, "0");
    return `${month} ${day}, ${year}, ${hour}:${minutes}:${seconds} ${amPm}`;
};
const $c0433b3a957ff718$export$6a6c5e33e36c4dc4 = (dateString)=>{
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = $c0433b3a957ff718$var$MONTHS[date.getUTCMonth()];
    const day = date.getUTCDate();
    // Formatting the hour for 12-hour clock and calculating AM/PM in UTC
    let hour = date.getUTCHours();
    const amPm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12;
    hour = hour ? hour : 12; // the hour '0' should be '12'
    const minutes = date.getUTCMinutes().toString().padStart(2, "0");
    const seconds = date.getUTCSeconds().toString().padStart(2, "0");
    return `${month} ${day}, ${year}, ${hour}:${minutes}:${seconds} ${amPm}`;
};
const $c0433b3a957ff718$export$a42f1efec9282da9 = (dateString)=>{
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    // Parse the ISO string to extract the local time components
    const isoString = dateString;
    const date = new Date(isoString);
    // Extract the local time from the original string (before timezone conversion)
    const localTimeMatch = isoString.match(/T(\d{2}):(\d{2}):(\d{2})/);
    const dateMatch = isoString.match(/(\d{4})-(\d{2})-(\d{2})/);
    if (!localTimeMatch || !dateMatch) // Fallback to UTC if parsing fails
    return $c0433b3a957ff718$export$6a6c5e33e36c4dc4(dateString);
    const year = parseInt(dateMatch[1]);
    const month = parseInt(dateMatch[2]) - 1; // Month is 0-indexed
    const day = parseInt(dateMatch[3]);
    const hour = parseInt(localTimeMatch[1]);
    const minutes = parseInt(localTimeMatch[2]);
    const seconds = parseInt(localTimeMatch[3]);
    // Formatting the hour for 12-hour clock and calculating AM/PM
    let displayHour = hour;
    const amPm = displayHour >= 12 ? "PM" : "AM";
    displayHour = displayHour % 12;
    displayHour = displayHour ? displayHour : 12; // the hour '0' should be '12'
    const displayMinutes = minutes.toString().padStart(2, "0");
    const displaySeconds = seconds.toString().padStart(2, "0");
    return `${months[month]} ${day}, ${year}, ${displayHour}:${displayMinutes}:${displaySeconds} ${amPm}`;
};
const $c0433b3a957ff718$export$b72c7c7112e7208b = (dateString)=>{
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    // Parse the ISO string and convert to UTC
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = months[date.getUTCMonth()];
    const day = date.getUTCDate();
    // Formatting the hour for 12-hour clock and calculating AM/PM in UTC
    let hour = date.getUTCHours();
    const amPm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12;
    hour = hour ? hour : 12; // the hour '0' should be '12'
    const minutes = date.getUTCMinutes().toString().padStart(2, "0");
    const seconds = date.getUTCSeconds().toString().padStart(2, "0");
    return `${month} ${day}, ${year}, ${hour}:${minutes}:${seconds} ${amPm}`;
};
const $c0433b3a957ff718$export$88bd78e774161c12 = (unixTimestamp)=>{
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    // Convert Unix timestamp (seconds) to milliseconds for JavaScript Date
    const date = new Date(unixTimestamp * 1000);
    const year = date.getFullYear();
    const month = months[date.getMonth()];
    const day = date.getDate();
    // Formatting the hour for 12-hour clock and calculating AM/PM
    let hour = date.getHours();
    const amPm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12;
    hour = hour ? hour : 12; // the hour '0' should be '12'
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");
    return `${month} ${day}, ${year}, ${hour}:${minutes}:${seconds} ${amPm}`;
};


const $4d091d434dee0594$var$Transition = /*#__PURE__*/ $8T3gX.forwardRef(function Transition(props, ref) {
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $212a5a6a44b7f18e$export$2e2bcd8739ae039), {
        direction: "up",
        ref: ref,
        ...props
    });
});
const $4d091d434dee0594$export$cf631d458a2ae4fd = ({ showMoreDialogOpen: showMoreDialogOpen, setShowMoreDialogOpen: setShowMoreDialogOpen, selectedRow: selectedRow, videoURL: videoURL })=>{
    const handleClickOpen = ()=>{
        setShowMoreDialogOpen(true);
    };
    const handleClose = ()=>{
        setShowMoreDialogOpen(false);
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                onClick: handleClickOpen,
                text: "Full Clip Info",
                disabled: false
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                fullScreen: true,
                open: showMoreDialogOpen,
                onClose: handleClose,
                TransitionComponent: $4d091d434dee0594$var$Transition,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gus0k.default), {
                        sx: {
                            position: "relative"
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kRZvb.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                    edge: "start",
                                    color: "inherit",
                                    onClick: handleClose,
                                    "aria-label": "close",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                    sx: {
                                        ml: 2,
                                        flex: 1
                                    },
                                    variant: "h6",
                                    component: "div",
                                    children: [
                                        selectedRow.customer_name,
                                        " | ",
                                        selectedRow.camera_name
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "relative w-[1300px] top-[20px] left-[20px]",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)($8T3gX.Fragment, {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)("video", {
                                    width: "550",
                                    controls: true,
                                    autoPlay: true,
                                    loop: true,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("source", {
                                        src: videoURL,
                                        type: "video/mp4"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                component: (0, $4reBM.default),
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                    sx: {
                                        fontFamily: "Mulish",
                                        width: "100%"
                                    },
                                    "aria-label": "simple table",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                            titlesArray: [
                                                "AI Result",
                                                "Ground Truth",
                                                "Updated by",
                                                "Clip FPS",
                                                "Analyzed FPS",
                                                "Slice",
                                                "Stationary"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish"
                                                        },
                                                        children: selectedRow.clip_result
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish"
                                                        },
                                                        children: selectedRow.ground_truth
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish"
                                                        },
                                                        children: selectedRow.username
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish"
                                                        },
                                                        children: selectedRow.fps
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish"
                                                        },
                                                        children: selectedRow.stream_fps
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish"
                                                        },
                                                        children: selectedRow.slice ? (0, $lWchQ.checkedCircleIcon) : (0, $2aMB5.cancelIconRed)
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish"
                                                        },
                                                        children: selectedRow.stationary_filter ? (0, $lWchQ.checkedCircleIcon) : (0, $2aMB5.cancelIconRed)
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "absolute left-[620px] top-[110px] w-[250px] text-black font-mulish text-[16px] font-bold",
                        children: "Site"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "absolute left-[620px] top-[135px] w-[250px] text-black font-mulish text-[16px]",
                        children: selectedRow.customer_name
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "absolute left-[950px] top-[110px] w-[250px] text-black font-mulish text-[16px] font-bold",
                        children: "Camera Name"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "absolute left-[950px] top-[135px] w-[250px] text-black font-mulish text-[16px]",
                        children: selectedRow.camera_name
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "absolute left-[620px] top-[195px] w-[250px] text-black font-mulish text-[16px] font-bold",
                        children: "Local Time"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "absolute left-[620px] top-[220px] w-[250px] text-black font-mulish text-[16px]",
                        children: (0, $c0433b3a957ff718$export$36a24ca552645e4e)(selectedRow.clip_header_received, selectedRow.clip_received_local, selectedRow.site_timezone)
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "absolute left-[950px] top-[195px] w-[250px] text-black font-mulish text-[16px] font-bold",
                        children: "File ID"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "absolute left-[950px] top-[220px] w-[250px] text-black font-mulish text-[16px]",
                        children: selectedRow.file_id
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "absolute left-[620px] top-[285px] w-[250px] text-black font-mulish text-[16px] font-bold",
                        children: "Event ID"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "absolute left-[620px] top-[310px] w-[250px] text-black font-mulish text-[16px]",
                        children: selectedRow.event_id
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "absolute left-[950px] top-[285px] w-[250px] text-black font-mulish text-[16px] font-bold",
                        children: "Internal Log ID"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "absolute left-[950px] top-[310px] w-[250px] text-black font-mulish text-[16px]",
                        children: selectedRow.internal_id
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "absolute left-[620px] top-[380px] w-[250px] text-black font-mulish text-[16px] font-bold",
                        children: "Camera ID"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "absolute left-[620px] top-[400px] w-[250px] text-black font-mulish text-[16px]",
                        children: selectedRow.camera_id
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "relative min-w-[1450px] "
                    })
                ]
            })
        ]
    });
};



var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

var $60vL1 = parcelRequire("60vL1");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $1wcxl = parcelRequire("1wcxl");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $fWsn7 = parcelRequire("fWsn7");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");
var $aVDw9 = parcelRequire("aVDw9");
var $ha39s = parcelRequire("ha39s");
var $4o6Cs = parcelRequire("4o6Cs");
var $kLvBh = parcelRequire("kLvBh");

var $9lVTU = parcelRequire("9lVTU");
const $bac603583f7eca6b$var$headCells = [
    {
        id: "site",
        numeric: false,
        label: "Site"
    },
    {
        id: "camera_name",
        numeric: false,
        label: "Camera Name"
    },
    {
        id: "utc_time",
        numeric: false,
        label: "Received (UTC)"
    },
    {
        id: "time",
        numeric: false,
        label: `Received (Local)`
    },
    {
        id: "clip_result",
        numeric: false,
        label: "AI Clip Result"
    },
    {
        id: "file_id",
        numeric: true,
        label: "File ID"
    }
];
const $bac603583f7eca6b$export$dd5a0aba87262f97 = (props)=>{
    const { onRequestSort: onRequestSort, orderBy: orderBy, order: order } = props;
    const createSortHandler = (property)=>(event)=>{
            onRequestSort(event, property);
        };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
            children: $bac603583f7eca6b$var$headCells.map((headCell)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    align: "left",
                    sortDirection: orderBy === headCell.id ? order : false,
                    style: {
                        width: 30
                    },
                    sx: {
                        fontFamily: "mulish",
                        fontWeight: 700,
                        fontSize: 8.5,
                        width: 150
                    },
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kLvBh.default), {
                        active: orderBy === headCell.id,
                        direction: orderBy === headCell.id ? order : "asc",
                        onClick: createSortHandler(headCell.id),
                        children: [
                            headCell.label,
                            orderBy === headCell.id ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                component: "span",
                                sx: (0, $9lVTU.default),
                                children: order === "desc" ? "sorted descending" : "sorted ascending"
                            }) : null
                        ]
                    })
                }, headCell.id))
        })
    });
};



parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $54027012fff01b21$export$2fd5d64b4d451d7b = (row, setSelectedRow, setVideoURL, setVideoClipLoading, clipsData, setClipsData, selectedRow, userFilters, tabString, username, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $54027012fff01b21$export$2fd5d64b4d451d7b(row, setSelectedRow, setVideoURL, setVideoClipLoading, clipsData, setClipsData, selectedRow, userFilters, tabString, username, navigate);
    };
    const newInvestigationData = clipsData;
    newInvestigationData.forEach((object)=>{
        object.selected = false;
    });
    newInvestigationData.forEach((object, index)=>{
        if (row.file_id === object.file_id) newInvestigationData[index].selected = true;
    });
    setClipsData(newInvestigationData);
    AxiosUI.get(`clip/info/?username=${username}&file_id=${row.file_id}`).then((response)=>{
        if (response.data.file_id) {
            for(const key in response.data)setSelectedRow((previousState)=>{
                return {
                    ...previousState,
                    [key]: response.data[key]
                };
            });
            localStorage.setItem("clipsSelectedRow", JSON.stringify(selectedRow));
            AxiosUI.get(`clip/url/?username=${userFilters.user}&file_id=${response.data.file_id}`).then((response)=>{
                setVideoURL(response.data);
                setVideoClipLoading(false);
            }, (reason)=>{
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setVideoClipLoading(false);
                });
            });
        }
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setVideoClipLoading(false);
        });
    });
};



var $fIsAN = parcelRequire("fIsAN");

// import React from "react";
// export const handleReorderIndex = (
//   visibleRows: any,
//   setIndexOrder: any,
//   alertData: any,
//   setData: any,
//   pageString: string
// ) => {
//   const updatedOrder: any[] = [];
//   const updatedData: any[] = [];
//   visibleRows.forEach((object: any) => {
//     updatedOrder.push(object.index);
//     alertData.forEach((obj: any) => {
//       if (object.index === obj.index) {
//         updatedData.push(obj);
//       }
//     });
//   });
//   setIndexOrder(updatedOrder), setData(updatedData);
//   if (pageString === "investigations") {
//     localStorage.setItem("clipsData", JSON.stringify(updatedData));
//     localStorage.setItem("clipsIndexOrder", JSON.stringify(updatedOrder));
//   }
// };
parcelRequire("8T3gX");
const $8ac871b862929cdd$export$826adfa26b8f8d30 = (visibleRows, setIndexOrder, alertData, setData, pageString, detectionType)=>{
    const updatedOrder = [];
    const updatedData = [];
    // Create a map to store alertData objects by index for faster lookup
    const alertDataMap = new Map();
    alertData.forEach((obj)=>{
        alertDataMap.set(obj.index, obj);
    });
    // Iterate through visibleRows once
    if (detectionType === "All") visibleRows.forEach((object)=>{
        const alertObj = alertDataMap.get(object.index);
        if (alertObj) {
            updatedOrder.push(object.index);
            updatedData.push(alertObj);
        }
    });
    else {
        const detectionTypeLower = detectionType.slice(0, 1).toLowerCase() + detectionType.slice(1);
        visibleRows.forEach((object)=>{
            const alertObj = alertDataMap.get(object.index);
            if (alertObj && alertObj.alert_labels === detectionTypeLower) {
                updatedOrder.push(object.index);
                updatedData.push(alertObj);
            }
        });
    }
    // Update state
    setIndexOrder(updatedOrder);
    // If pageString is "investigations", update localStorage
    if (pageString === "investigations") {
        localStorage.setItem("investigationsData", JSON.stringify(updatedData));
        localStorage.setItem("investigationsIndexOrder", JSON.stringify(updatedOrder));
        setData(updatedData);
    }
    // If pageString is "clips", update localStorage
    if (pageString === "clips") {
        localStorage.setItem("clipsData", JSON.stringify(updatedData));
        localStorage.setItem("clipsIndexOrder", JSON.stringify(updatedOrder));
        setData(updatedData);
    }
};



const $10fbd1628a0bd730$export$907e843ae2105cf = ({ clipsData: clipsData, setClipsData: setClipsData, setSelectedRow: setSelectedRow, page: page, setPage: setPage, setVideoClipLoading: setVideoClipLoading, setVideoURL: setVideoURL, scrollToTop: scrollToTop, setVerifiedClicked: setVerifiedClicked, setUnverifiedClicked: setUnverifiedClicked, selectedRow: selectedRow, setClipsIndexOrder: setClipsIndexOrder, userFilters: userFilters, navigate: navigate })=>{
    const [searchParams, setSearchParams] = (0, $fIsAN.useSearchParams)();
    const [order, setOrder] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("asc");
    const [orderBy, setOrderBy] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("formatted_date");
    const [rowsPerPage, setRowsPerPage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(5);
    const lastAutoPagedSelectionRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const handleRequestSort = (event, property)=>{
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };
    const handleChangePage = (event, newPage)=>{
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event)=>{
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - clipsData.length) : 0;
    const sortingFunction = (0, $fWsn7.stableSort)(clipsData, (0, $fWsn7.getComparator)(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    const visibleRows = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>sortingFunction, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        order,
        orderBy,
        page,
        rowsPerPage,
        clipsData
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        const sortedRows = (0, $fWsn7.stableSort)(clipsData, (0, $fWsn7.getComparator)(order, orderBy));
        const selectedIndex = sortedRows.findIndex((row)=>row.selected);
        const selectedFileId = selectedIndex >= 0 && sortedRows[selectedIndex]?.file_id != null ? String(sortedRows[selectedIndex].file_id) : null;
        const expectedPage = selectedIndex >= 0 ? Math.floor(selectedIndex / rowsPerPage) : 0;
        if (selectedFileId && selectedFileId !== lastAutoPagedSelectionRef.current && expectedPage !== page) {
            lastAutoPagedSelectionRef.current = selectedFileId;
            setPage(expectedPage);
        }
    }, [
        clipsData,
        order,
        orderBy,
        page,
        rowsPerPage,
        setPage
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        (0, $8ac871b862929cdd$export$826adfa26b8f8d30)((0, $fWsn7.stableSort)(clipsData, (0, $fWsn7.getComparator)(order, orderBy)), setClipsIndexOrder, clipsData, setClipsData, "", "All");
    }, [
        order,
        visibleRows
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4reBM.default), {
        className: "overflow-scroll scrollbar-hide w-[100%]",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                sx: {
                    maxHeight: 490,
                    width: 755
                },
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                    sx: {
                        fontFamily: "Mulish",
                        postion: "absolute",
                        tableLayout: "fixed"
                    },
                    "aria-labelledby": "clips-table",
                    stickyHeader: true,
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $bac603583f7eca6b$export$dd5a0aba87262f97), {
                            onRequestSort: handleRequestSort,
                            orderBy: orderBy,
                            order: order
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $gXvgZ.default), {
                            children: [
                                visibleRows.map((row, index)=>{
                                    let sx = {
                                        cursor: "pointer"
                                    };
                                    if (row.selected) sx = {
                                        cursor: "pointer",
                                        backgroundColor: "rgba(2, 136, 209, 0.2)"
                                    };
                                    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                        hover: true,
                                        onClick: ()=>{
                                            scrollToTop();
                                            setVideoClipLoading(true);
                                            setSelectedRow(row);
                                            localStorage.setItem("clipsSelectedRow", JSON.stringify(row));
                                            (0, $0465d401e2e7f520$export$44bad2a4de61b28d)(row, setVerifiedClicked, setUnverifiedClicked);
                                            (0, $54027012fff01b21$export$2fd5d64b4d451d7b)(row, setSelectedRow, setVideoURL, setVideoClipLoading, clipsData, setClipsData, selectedRow, userFilters, "ailink", userFilters.user, navigate);
                                            (0, $60d1d427e7f38222$export$d0ea5288e6803239)(setSearchParams, searchParams);
                                        },
                                        tabIndex: -1,
                                        sx: sx,
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontSize: "10px",
                                                    fontFamily: "mulish"
                                                },
                                                children: row.customer_name
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontSize: "10px",
                                                    fontFamily: "mulish"
                                                },
                                                children: row.camera_name
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontSize: "10px",
                                                    fontFamily: "mulish"
                                                },
                                                children: row.clip_header_received ? (0, $c0433b3a957ff718$export$6a6c5e33e36c4dc4)(row.clip_header_received) : ""
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontSize: "10px",
                                                    fontFamily: "mulish"
                                                },
                                                children: (0, $c0433b3a957ff718$export$36a24ca552645e4e)(row.clip_header_received, row.clip_received_local, row.site_timezone)
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontSize: "10px",
                                                    fontFamily: "mulish"
                                                },
                                                children: row.clip_result
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontSize: "10px",
                                                    fontFamily: "mulish"
                                                },
                                                children: row.file_id
                                            })
                                        ]
                                    }, row.id);
                                }),
                                emptyRows > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                    style: {
                                        height: 53 * emptyRows
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        colSpan: 6
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wcxl.default), {
                rowsPerPageOptions: [
                    5,
                    10,
                    25
                ],
                component: "div",
                count: clipsData.length,
                rowsPerPage: rowsPerPage,
                page: page,
                onPageChange: handleChangePage,
                onRowsPerPageChange: handleChangeRowsPerPage
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");
const $ac1526c367c6b6aa$export$5d04df22b5df85a0 = ({ precisionRecallData: precisionRecallData })=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
            sx: {
                minWidth: 1000,
                fontFamily: "Mulish"
            },
            "aria-label": "simple table",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                    titlesArray: [
                        "Date",
                        "Clips",
                        "TP",
                        "FP",
                        "FN",
                        "TN",
                        "N/A",
                        "Precision",
                        "Recall"
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: precisionRecallData?.date_str
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: precisionRecallData?.total_clips
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: precisionRecallData?.true_positives
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: precisionRecallData?.false_positives
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: precisionRecallData?.false_negatives
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: precisionRecallData?.true_negatives
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: precisionRecallData?.unclassified
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: precisionRecallData?.precision
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                align: "left",
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: precisionRecallData?.recall
                            })
                        ]
                    })
                })
            ]
        })
    });
};



var $fIsAN = parcelRequire("fIsAN");

var $8jTCz = parcelRequire("8jTCz");

var $frXOV = parcelRequire("frXOV");

var $2qUoo = parcelRequire("2qUoo");
parcelRequire("8T3gX");
parcelRequire("8T3gX");
const $383cff3d7cc17d76$export$f8c49e79d1708ea0 = (alertsIndexOrder, alertIndexNum)=>{
    let indexNumber = 0;
    alertsIndexOrder.forEach((num, index)=>{
        if (num === alertIndexNum) indexNumber = index;
    });
    return indexNumber;
};



var $195EM = parcelRequire("195EM");


var $3Zv1D = parcelRequire("3Zv1D");
const $6ffe9bce231338f8$export$a0a7f97c31933ae5 = (clipsData, selectedRow, clipsIndexOrder, directionString, setSelectedRow, setClipsData, setVideoClipLoading, setVerifiedClicked, setUnverifiedClicked, setVideoURL, userFilters, navigate, onRowChange)=>{
    // const clipsData = JSON.parse(localStorage.clipsData);
    // const selectedRow = JSON.parse(localStorage.clipsSelectedRow);
    // const clipsIndexOrder = JSON.parse(localStorage.clipsIndexOrder);
    if (directionString === "forward" && selectedRow.index !== clipsIndexOrder[clipsIndexOrder.length - 1] || directionString === "back" && selectedRow.index !== clipsIndexOrder[0]) {
        setVideoClipLoading(true);
        const currentIndex = (0, $383cff3d7cc17d76$export$f8c49e79d1708ea0)(clipsIndexOrder, selectedRow.index);
        let newSelectedRow;
        directionString === "forward" ? newSelectedRow = clipsData[currentIndex + 1] : newSelectedRow = clipsData[currentIndex - 1];
        setSelectedRow(newSelectedRow);
        localStorage.setItem("clipsSelectedRow", JSON.stringify(newSelectedRow));
        onRowChange?.(newSelectedRow);
        const updatedInvestigationData = clipsData;
        updatedInvestigationData.forEach((object)=>{
            object.selected = false;
        });
        directionString === "forward" ? updatedInvestigationData[currentIndex + 1].selected = true : updatedInvestigationData[currentIndex - 1].selected = true;
        setClipsData(updatedInvestigationData);
        // localStorage.setItem(
        //   "clipsData",
        //   JSON.stringify(updatedInvestigationData)
        // );
        const AxiosUI = (0, $195EM.createApi)("");
        const retryFunction = ()=>{
            $6ffe9bce231338f8$export$a0a7f97c31933ae5(clipsData, selectedRow, clipsIndexOrder, directionString, setSelectedRow, setClipsData, setVideoClipLoading, setVerifiedClicked, setUnverifiedClicked, setVideoURL, userFilters, navigate, onRowChange);
        };
        // First, fetch complete row information (same as handleRowSelected)
        AxiosUI.get(`clip/info/?username=${userFilters.user}&file_id=${newSelectedRow.file_id}`).then((response)=>{
            if (response.data.file_id) {
                // Update selectedRow with complete data from API
                for(const key in response.data)setSelectedRow((previousState)=>{
                    return {
                        ...previousState,
                        [key]: response.data[key]
                    };
                });
                localStorage.setItem("clipsSelectedRow", JSON.stringify(selectedRow));
                // Then fetch the video URL
                AxiosUI.get(`clip/url/?username=${userFilters.user}&file_id=${response.data.file_id}`).then((videoResponse)=>{
                    (0, $0465d401e2e7f520$export$44bad2a4de61b28d)(newSelectedRow, setVerifiedClicked, setUnverifiedClicked);
                    setVideoURL(videoResponse.data);
                    setVideoClipLoading(false);
                }, (reason)=>{
                    (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                        (0, $0465d401e2e7f520$export$44bad2a4de61b28d)(newSelectedRow, setVerifiedClicked, setUnverifiedClicked);
                        const newInvestigationData = clipsData;
                        newInvestigationData.forEach((object)=>{
                            object.selected = false;
                        });
                        directionString === "forward" ? newInvestigationData[currentIndex + 1].selected = true : newInvestigationData[currentIndex - 1].selected = true;
                        setClipsData(newInvestigationData);
                        localStorage.setItem("clipsData", JSON.stringify(newInvestigationData));
                        setVideoURL("");
                        setVideoClipLoading(false);
                    });
                });
            }
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                (0, $0465d401e2e7f520$export$44bad2a4de61b28d)(newSelectedRow, setVerifiedClicked, setUnverifiedClicked);
                const newInvestigationData = clipsData;
                newInvestigationData.forEach((object)=>{
                    object.selected = false;
                });
                directionString === "forward" ? newInvestigationData[currentIndex + 1].selected = true : newInvestigationData[currentIndex - 1].selected = true;
                setClipsData(newInvestigationData);
                localStorage.setItem("clipsData", JSON.stringify(newInvestigationData));
                setVideoURL("");
                setVideoClipLoading(false);
            });
        });
    }
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");
const $851fcbe833f3eb8b$export$b08b517936747730 = ()=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)("svg", {
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        width: "40",
        height: "40",
        style: {
            shapeRendering: "auto",
            display: "block",
            background: "#E5E5E5"
        },
        children: /*#__PURE__*/ (0, $k4ank.jsx)("g", {
            children: /*#__PURE__*/ (0, $k4ank.jsx)("circle", {
                cx: "50",
                cy: "50",
                r: "32",
                strokeWidth: "8",
                stroke: "#FF8400",
                strokeDasharray: "50.26548245743669 50.26548245743669",
                fill: "none",
                strokeLinecap: "round",
                children: /*#__PURE__*/ (0, $k4ank.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    repeatCount: "indefinite",
                    dur: "1s",
                    keyTimes: "0;1",
                    values: "0 50 50;360 50 50"
                })
            })
        })
    });
};



var $iIAML = parcelRequire("iIAML");

var $4wo2Y = parcelRequire("4wo2Y");

var $k4ank = parcelRequire("k4ank");

var $5GP2e = parcelRequire("5GP2e");
const $a17e6a81e499c7af$export$d6488c46934633a3 = (siteName, siteId)=>{
    const href = `/sites/aboutsite/${siteId}`;
    if (siteId) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
        underline: "hover",
        color: "inherit",
        href: href,
        sx: {
            fontSize: "20px",
            fontFamily: "Mulish"
        },
        variant: "h5",
        children: siteName
    });
    else return /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
        children: siteName
    });
};



var $k4ank = parcelRequire("k4ank");

var $5GP2e = parcelRequire("5GP2e");
const $33b4b9464ea6ea5e$export$f28ee0a44f93351f = (cameraName, siteId, cameraId)=>{
    const href = `/sites/${siteId}/editcamera/${cameraId}`;
    if (siteId && cameraId) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
        underline: "hover",
        color: "inherit",
        href: href,
        sx: {
            fontSize: "20px",
            fontFamily: "Mulish"
        },
        variant: "h5",
        children: cameraName
    });
    else return /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
        children: cameraName
    });
};



var $4G44R = parcelRequire("4G44R");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $cVCJe = parcelRequire("cVCJe");

var $8E01L = parcelRequire("8E01L");

var $3QMQN = parcelRequire("3QMQN");

var $fIsAN = parcelRequire("fIsAN");

var $8jTCz = parcelRequire("8jTCz");

const $42175367ea4c1e61$var$fallbackCopyToClipboard = async (value)=>{
    const textArea = document.createElement("textarea");
    textArea.value = value;
    textArea.setAttribute("readonly", "");
    textArea.style.position = "absolute";
    textArea.style.left = "-9999px";
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
};
const $42175367ea4c1e61$export$d994c77890cfb1f4 = ({ tab: tab, selectedRow: selectedRow })=>{
    const [searchParams] = (0, $fIsAN.useSearchParams)();
    const [copiedOpen, setCopiedOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const shareUrl = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>(0, $60d1d427e7f38222$export$ebaabfbed7661a81)(tab, selectedRow, searchParams), [
        tab,
        selectedRow,
        searchParams
    ]);
    const handleCopy = async ()=>{
        if (!shareUrl) return;
        try {
            if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(shareUrl);
            else await $42175367ea4c1e61$var$fallbackCopyToClipboard(shareUrl);
            setCopiedOpen(true);
        } catch  {
        // no-op, button remains enabled and user can retry
        }
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                title: "Copy clip URL to clipboard",
                arrow: true,
                children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: handleCopy,
                        text: "Share clip URL",
                        disabled: !shareUrl
                    })
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8E01L.default), {
                open: copiedOpen,
                autoHideDuration: 4000,
                onClose: ()=>setCopiedOpen(false),
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                    elevation: 6,
                    variant: "filled",
                    severity: "success",
                    onClose: ()=>setCopiedOpen(false),
                    sx: {
                        width: "100%",
                        fontFamily: "Mulish"
                    },
                    children: "Clip was successfully copied to clipboard"
                })
            })
        ]
    });
};



const $7547e21e20af6a91$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $7547e21e20af6a91$export$e9ae1b6c451fd3eb = ({ showMoreDialogOpen: showMoreDialogOpen, setShowMoreDialogOpen: setShowMoreDialogOpen, selectedRow: selectedRow, videoURL: videoURL, clipsData: clipsData, page: page, setPage: setPage, precisionRecallData: precisionRecallData, videoClipLoading: videoClipLoading, setVideoURL: setVideoURL, setVideoClipLoading: setVideoClipLoading, setSelectedRow: setSelectedRow, setClipsData: setClipsData, scrollToTop: scrollToTop, verifiedClicked: verifiedClicked, unverifiedClicked: unverifiedClicked, setVerifiedClicked: setVerifiedClicked, setUnverifiedClicked: setUnverifiedClicked, setPageLoading: setPageLoading, clipsIndexOrder: clipsIndexOrder, setClipsIndexOrder: setClipsIndexOrder, fetchingFilteredData: fetchingFilteredData, userFilters: userFilters, loadingAdditionalData: loadingAdditionalData, navBarCollapsed: navBarCollapsed, userInfo: userInfo, navigate: navigate })=>{
    const { showFrontelTab: showFrontelTab } = (0, $4G44R.useClipsStore)();
    const [searchParams, setSearchParams] = (0, $fIsAN.useSearchParams)();
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: navBarCollapsed ? (userInfo.permission.sentinel || userInfo.permission.smtp || showFrontelTab) && userInfo.permission.ailink ? "relative left-[75px] top-[150px] w-[600px]" : "relative left-[75px] top-[90px] w-[600px]" : (userInfo.permission.sentinel || userInfo.permission.smtp || showFrontelTab) && userInfo.permission.ailink ? "relative left-[150px] top-[150px] w-[600px]" : "relative left-[150px] top-[90px] w-[600px]",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                className: "relative left-[20px] top-[15px] text-actuate-blue font-mulish text-[20px]",
                children: [
                    selectedRow.display_name ? (0, $a17e6a81e499c7af$export$d6488c46934633a3)(selectedRow.display_name, selectedRow.customer_pk) : (0, $a17e6a81e499c7af$export$d6488c46934633a3)(selectedRow.customer_name, selectedRow.customer_pk),
                    " ",
                    "|",
                    " ",
                    (0, $33b4b9464ea6ea5e$export$f28ee0a44f93351f)(selectedRow.camera_name, selectedRow.customer_pk, selectedRow.camera_pk),
                    " "
                ]
            }),
            !videoClipLoading && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "absolute left-[1150px] top-[0px] w-[150px] pt-[10px]",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4d091d434dee0594$export$cf631d458a2ae4fd), {
                    showMoreDialogOpen: showMoreDialogOpen,
                    setShowMoreDialogOpen: setShowMoreDialogOpen,
                    selectedRow: selectedRow,
                    videoURL: videoURL
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex pt-[20px] pl-[10px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        children: !fetchingFilteredData && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: !navBarCollapsed ? "w-[655px]" : "w-[725px]",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $10fbd1628a0bd730$export$907e843ae2105cf), {
                                            clipsData: clipsData,
                                            setClipsData: setClipsData,
                                            setSelectedRow: setSelectedRow,
                                            page: page,
                                            setPage: setPage,
                                            setVideoClipLoading: setVideoClipLoading,
                                            setVideoURL: setVideoURL,
                                            scrollToTop: scrollToTop,
                                            setVerifiedClicked: setVerifiedClicked,
                                            setUnverifiedClicked: setUnverifiedClicked,
                                            selectedRow: selectedRow,
                                            setClipsIndexOrder: setClipsIndexOrder,
                                            userFilters: userFilters,
                                            navigate: navigate
                                        })
                                    }),
                                    loadingAdditionalData && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "relative pt-[5px]",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "relative left-[10px]",
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $851fcbe833f3eb8b$export$b08b517936747730), {})
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "absolute left-[58px] top-[7px] font-mulish text-actuate-orange",
                                                children: "Loading Additional Data"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "w-[660px]",
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "w-[660px]",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        children: [
                                            videoClipLoading && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "text-center",
                                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $b9p11.default), {
                                                    theme: $7547e21e20af6a91$var$theme,
                                                    children: [
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                                                color: "primary"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                            className: "font-mulish text-[20px]",
                                                            children: "Video Loading..."
                                                        })
                                                    ]
                                                })
                                            }),
                                            !videoClipLoading && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                className: "flex items-center justify-between w-[660px]",
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "flex-none",
                                                        id: "arrow_back",
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                            onClick: ()=>{
                                                                (0, $6ffe9bce231338f8$export$a0a7f97c31933ae5)(clipsData, selectedRow, clipsIndexOrder, "back", setSelectedRow, setClipsData, setVideoClipLoading, setVerifiedClicked, setUnverifiedClicked, setVideoURL, userFilters, navigate, ()=>(0, $60d1d427e7f38222$export$d0ea5288e6803239)(setSearchParams, searchParams));
                                                            },
                                                            text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($frXOV))), {
                                                                fontSize: "large",
                                                                id: "BackButton"
                                                            }),
                                                            disabled: selectedRow.index === clipsIndexOrder[0]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                        className: "flex-auto",
                                                        id: "video",
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("video", {
                                                                    width: "540",
                                                                    autoPlay: true,
                                                                    controls: true,
                                                                    loop: true,
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("source", {
                                                                        src: videoURL,
                                                                        type: "video/mp4"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                className: "flex gap-[12px]",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                                        onClick: ()=>(0, $iIAML.saveAs)(videoURL, "video.mp4"),
                                                                        text: "Download Video",
                                                                        disabled: false
                                                                    }),
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $42175367ea4c1e61$export$d994c77890cfb1f4), {
                                                                        tab: "ailink",
                                                                        selectedRow: selectedRow
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "flex-none",
                                                        id: "arrow_forward",
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                            onClick: ()=>{
                                                                (0, $6ffe9bce231338f8$export$a0a7f97c31933ae5)(clipsData, selectedRow, clipsIndexOrder, "forward", setSelectedRow, setClipsData, setVideoClipLoading, setVerifiedClicked, setUnverifiedClicked, setVideoURL, userFilters, navigate, ()=>(0, $60d1d427e7f38222$export$d0ea5288e6803239)(setSearchParams, searchParams));
                                                            },
                                                            text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2qUoo))), {
                                                                fontSize: "large",
                                                                id: "forwardButton"
                                                            }),
                                                            disabled: selectedRow.index === clipsIndexOrder[clipsIndexOrder.length - 1]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "pt-[10px] pl-[30px]",
                                        children: !videoClipLoading && /*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $787224e216f1f6bd$export$f5d0ef76d4dc14de), {
                                                verifiedClicked: verifiedClicked,
                                                unverifiedClicked: unverifiedClicked,
                                                setVerifiedClicked: setVerifiedClicked,
                                                setUnverifiedClicked: setUnverifiedClicked,
                                                selectedRow: selectedRow,
                                                clipsData: clipsData,
                                                setClipsData: setClipsData,
                                                setSelectedRow: setSelectedRow,
                                                setPageLoading: setPageLoading,
                                                navBarCollapsed: navBarCollapsed,
                                                navigate: navigate
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: !navBarCollapsed ? "bg-white h-[55px] w-[1305px]" : "bg-white h-[55px] w-[1380px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-black font-mulish text-[20px] p-3 indent-4",
                        children: "Precision and Recall"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $ac1526c367c6b6aa$export$5d04df22b5df85a0), {
                        precisionRecallData: precisionRecallData
                    })
                ]
            })
        ]
    });
};


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
var $fIsAN = parcelRequire("fIsAN");


var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");

const $6e659094c6eb6020$export$b1adbeb8891ae9b5 = ({ userDropDownValueSentinel: userDropDownValueSentinel, userOptions: userOptions, setUserDropDownValueSentinel: setUserDropDownValueSentinel, setCameraDropDownValueSentinel: setCameraDropDownValueSentinel, setUserFiltersSentinel: setUserFiltersSentinel, setSiteDropDownValueSentinel: setSiteDropDownValueSentinel, setSiteOptionsSentinel: setSiteOptionsSentinel, setCameraOptionsSentinel: setCameraOptionsSentinel, setLoadingSitesSentinel: setLoadingSitesSentinel, navBarCollapsed: navBarCollapsed, navigate: navigate })=>{
    const options = [];
    const optionUserIds = new Map();
    userOptions.map((object)=>{
        if (object.group) options.push(object.group.name);
    });
    userOptions.forEach((object)=>{
        if (object.group) optionUserIds.set(object.group.name, object.group.id);
    });
    const optionUserNames = new Map();
    userOptions.forEach((object)=>{
        if (object.group) optionUserNames.set(object.group.name, object.username);
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            value: userDropDownValueSentinel,
            disablePortal: true,
            options: options,
            onChange: (event, value)=>{
                if (value !== null) {
                    setUserDropDownValueSentinel(value);
                    setCameraDropDownValueSentinel(null);
                    setSiteDropDownValueSentinel(null);
                    setSiteOptionsSentinel([]);
                    (0, $b94416ec814c369f$export$e8f5d2acbd281022)(setSiteOptionsSentinel, setLoadingSitesSentinel, optionUserIds.get(value), navigate);
                    setUserFiltersSentinel((previousState)=>{
                        return {
                            ...previousState,
                            user: optionUserNames.get(value),
                            group_id: optionUserIds.get(value),
                            site_ids: [],
                            camera_ids: []
                        };
                    });
                } else {
                    // setFetchingFilteredData(true);
                    setUserDropDownValueSentinel(value);
                    setSiteDropDownValueSentinel(null);
                    setSiteOptionsSentinel([]);
                    setCameraDropDownValueSentinel(null);
                    setCameraOptionsSentinel([]);
                    setUserFiltersSentinel((previousState)=>{
                        return {
                            ...previousState,
                            user: "testuser",
                            group_id: null,
                            site_ids: [],
                            camera_ids: []
                        };
                    });
                }
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    label: "User",
                    autoComplete: "off",
                    sx: !navBarCollapsed ? {
                        width: 150
                    } : {
                        width: 175
                    }
                })
        })
    }, "user_dropdown");
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $60vL1 = parcelRequire("60vL1");
var $eejVe = parcelRequire("eejVe");

const $882b52372a83ae29$export$7099014a312295de = ({ siteOptionsSentinel: siteOptionsSentinel, loadingSitesSentinel: loadingSitesSentinel, siteDropDownValueSentinel: siteDropDownValueSentinel, setSiteDropDownValueSentinel: setSiteDropDownValueSentinel, setCameraDropDownValueSentinel: setCameraDropDownValueSentinel, setUserFiltersSentinel: setUserFiltersSentinel, setCameraOptionsSentinel: setCameraOptionsSentinel, setLoadingCamerasSentinel: setLoadingCamerasSentinel, showUserDropDown: showUserDropDown, navBarCollapsed: navBarCollapsed, navigate: navigate })=>{
    const siteIds = new Map();
    siteOptionsSentinel.forEach((object)=>{
        siteIds.set(object.name, object.id);
    });
    // Create a Set to track unique names and ensure we only add each name once
    const uniqueNames = new Set();
    const options = [];
    // First pass: collect unique names
    siteOptionsSentinel.forEach((object)=>{
        if (!uniqueNames.has(object.name)) {
            uniqueNames.add(object.name);
            options.push(object.name);
        }
    });
    let sx;
    if (showUserDropDown && navBarCollapsed) sx = {
        width: 175
    };
    if (showUserDropDown && !navBarCollapsed) sx = {
        width: 150
    };
    if (!showUserDropDown && navBarCollapsed) sx = {
        width: 240
    };
    if (!showUserDropDown && !navBarCollapsed) sx = {
        width: 200
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            value: siteDropDownValueSentinel,
            disablePortal: true,
            options: options,
            loading: loadingSitesSentinel,
            onChange: (event, value)=>{
                if (value !== null) {
                    setSiteDropDownValueSentinel(value);
                    setCameraDropDownValueSentinel(null);
                    (0, $1a511a220e4442ce$export$1fedd6e3f8d8e03e)([
                        siteIds.get(value)
                    ], navigate, setCameraOptionsSentinel, setLoadingCamerasSentinel);
                    setUserFiltersSentinel((previousState)=>{
                        return {
                            ...previousState,
                            site_ids: [
                                siteIds.get(value)
                            ],
                            camera_ids: []
                        };
                    });
                } else {
                    setSiteDropDownValueSentinel(value);
                    setCameraDropDownValueSentinel(null);
                    setCameraOptionsSentinel([]);
                    setUserFiltersSentinel((previousState)=>{
                        return {
                            ...previousState,
                            site_ids: [],
                            camera_ids: []
                        };
                    });
                }
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    label: "Site",
                    InputProps: {
                        ...params.InputProps,
                        endAdornment: /*#__PURE__*/ (0, $k4ank.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                            children: [
                                loadingSitesSentinel ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                    color: "inherit",
                                    size: 20
                                }) : null,
                                params.InputProps.endAdornment
                            ]
                        })
                    },
                    autoComplete: "off",
                    sx: sx
                })
        })
    }, "site_dropdown");
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $60vL1 = parcelRequire("60vL1");
var $eejVe = parcelRequire("eejVe");
const $91b133353099c762$export$62d8c3fd3b374f43 = ({ setUserFiltersSentinel: setUserFiltersSentinel, cameraOptionsSentinel: cameraOptionsSentinel, cameraDropDownValueSentinel: cameraDropDownValueSentinel, setCameraDropDownValueSentinel: setCameraDropDownValueSentinel, siteOptionsSentinel: siteOptionsSentinel, loadingCamerasSentinel: loadingCamerasSentinel, showUserDropDown: showUserDropDown, navBarCollapsed: navBarCollapsed })=>{
    const cameraIds = new Map();
    cameraOptionsSentinel.forEach((object)=>{
        cameraIds.set(object.camera_name, object.id);
    });
    const siteIds = new Map();
    siteOptionsSentinel.forEach((object)=>{
        siteIds.set(object.name, object.id);
    });
    let sx;
    if (showUserDropDown && navBarCollapsed) sx = {
        width: 175
    };
    if (showUserDropDown && !navBarCollapsed) sx = {
        width: 150
    };
    if (!showUserDropDown && navBarCollapsed) sx = {
        width: 235
    };
    if (!showUserDropDown && !navBarCollapsed) sx = {
        width: 200
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            value: cameraDropDownValueSentinel,
            disablePortal: true,
            options: cameraOptionsSentinel[0] ? cameraOptionsSentinel.map((object)=>{
                return object.camera_name;
            }) : [],
            loading: loadingCamerasSentinel,
            onChange: (event, value)=>{
                if (value !== "") {
                    setCameraDropDownValueSentinel(value);
                    setUserFiltersSentinel((previousState)=>{
                        return {
                            ...previousState,
                            camera_ids: [
                                cameraIds.get(value)
                            ]
                        };
                    });
                } else {
                    setCameraDropDownValueSentinel(value);
                    setUserFiltersSentinel((previousState)=>{
                        return {
                            ...previousState,
                            camera_ids: []
                        };
                    });
                }
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    label: "Camera",
                    InputProps: {
                        ...params.InputProps,
                        endAdornment: /*#__PURE__*/ (0, $k4ank.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                            children: [
                                loadingCamerasSentinel ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                    color: "inherit",
                                    size: 20
                                }) : null,
                                params.InputProps.endAdornment
                            ]
                        })
                    },
                    autoComplete: "off",
                    sx: sx
                })
        })
    }, "camera_dropdown");
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $hfM8m = parcelRequire("hfM8m");

var $hwWkD = parcelRequire("hwWkD");


var $eejVe = parcelRequire("eejVe");

var $5L5iJ = parcelRequire("5L5iJ");

var $iKAtE = parcelRequire("iKAtE");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");

var $i5MAs = parcelRequire("i5MAs");

var $aYdit = parcelRequire("aYdit");

var $jgags = parcelRequire("jgags");
const $1cf6950897e08b03$export$ef5c0482c00d4214 = ({ userFiltersSentinel: userFiltersSentinel, setUserFiltersSentinel: setUserFiltersSentinel, setTimeFiltersDisabledSentinel: setTimeFiltersDisabledSentinel })=>{
    const [startTimeAnchorEl, setStartTimeAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const startTimeOpen = Boolean(startTimeAnchorEl);
    const handleStartTimeClick = (event)=>{
        setStartTimeAnchorEl(event.currentTarget);
    };
    const handleStartTimeClose = (event)=>{
        event.stopPropagation();
        setStartTimeAnchorEl(null);
    };
    const { dateMMDDYYYY: dateMMDDYYYY, setDateMMDDYYYY: setDateMMDDYYYY } = (0, $aYdit.useAppStore)();
    const selectedLocale = dateMMDDYYYY ? (0, $jgags.default) : (0, $253608f850203ed2$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
        dateAdapter: (0, $hfM8m.AdapterDateFns),
        adapterLocale: selectedLocale,
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cbaf068f14972fdf$export$5109c6dd95d8fb00), {
            label: userFiltersSentinel.start_date ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                        children: "Start Date"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                "aria-label": "more",
                                id: "long-button",
                                "aria-controls": startTimeOpen ? "long-menu" : undefined,
                                "aria-expanded": startTimeOpen ? "true" : undefined,
                                "aria-haspopup": "true",
                                onClick: handleStartTimeClick,
                                sx: {
                                    marginLeft: "5px",
                                    padding: 0,
                                    color: "#000000",
                                    "&:hover": {
                                        backgroundColor: "transparent"
                                    }
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5MAs))), {})
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                                id: "long-menu",
                                MenuListProps: {
                                    "aria-labelledby": "long-button"
                                },
                                anchorOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                anchorEl: startTimeAnchorEl,
                                open: startTimeOpen,
                                onClose: handleStartTimeClose,
                                slotProps: {
                                    paper: {
                                        style: {
                                            maxHeight: 216,
                                            width: "20ch"
                                        }
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: (event)=>{
                                            setDateMMDDYYYY(true);
                                            handleStartTimeClose(event);
                                        },
                                        children: "MM/DD/YYYY"
                                    }, "mm-dd-yyyy-start"),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: (event)=>{
                                            setDateMMDDYYYY(false);
                                            handleStartTimeClose(event);
                                        },
                                        children: "DD/MM/YYYY"
                                    }, "dd-mm-yyyy-start")
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                children: "Start Date"
            }),
            value: userFiltersSentinel.start_date,
            onChange: (newValue)=>{
                if (newValue !== null) setUserFiltersSentinel((previousState)=>{
                    return {
                        ...previousState,
                        start_date: newValue
                    };
                });
                if (newValue === null) setUserFiltersSentinel((previousState)=>{
                    return {
                        ...previousState,
                        start_date: null
                    };
                });
                if ((0, $5L5iJ.yyyymmddGenerator)(newValue) !== (0, $5L5iJ.yyyymmddGenerator)(userFiltersSentinel.end_date)) {
                    setTimeFiltersDisabledSentinel(true);
                    setUserFiltersSentinel((previousState)=>{
                        return {
                            ...previousState,
                            start_time: null,
                            end_time: null
                        };
                    });
                }
                if ((0, $5L5iJ.yyyymmddGenerator)(newValue) === (0, $5L5iJ.yyyymmddGenerator)(userFiltersSentinel.end_date)) setTimeFiltersDisabledSentinel(false);
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    sx: {
                        width: 150
                    },
                    ...params
                })
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $hfM8m = parcelRequire("hfM8m");

var $hwWkD = parcelRequire("hwWkD");


var $eejVe = parcelRequire("eejVe");

var $5L5iJ = parcelRequire("5L5iJ");

var $iKAtE = parcelRequire("iKAtE");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");

var $i5MAs = parcelRequire("i5MAs");

var $aYdit = parcelRequire("aYdit");

var $jgags = parcelRequire("jgags");
const $c8d36ebd584b3e6a$export$ab606ac7892ca322 = ({ userFiltersSentinel: userFiltersSentinel, setUserFiltersSentinel: setUserFiltersSentinel, setTimeFiltersDisabledSentinel: setTimeFiltersDisabledSentinel })=>{
    const [endTimeAnchorEl, setEndTimeAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const endTimeOpen = Boolean(endTimeAnchorEl);
    const handleEndTimeClick = (event)=>{
        setEndTimeAnchorEl(event.currentTarget);
    };
    const handleEndTimeClose = (event)=>{
        event.stopPropagation();
        setEndTimeAnchorEl(null);
    };
    const { dateMMDDYYYY: dateMMDDYYYY, setDateMMDDYYYY: setDateMMDDYYYY } = (0, $aYdit.useAppStore)();
    const selectedLocale = dateMMDDYYYY ? (0, $jgags.default) : (0, $253608f850203ed2$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
        dateAdapter: (0, $hfM8m.AdapterDateFns),
        adapterLocale: selectedLocale,
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cbaf068f14972fdf$export$5109c6dd95d8fb00), {
            label: userFiltersSentinel.end_date ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                        children: "End Date"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                "aria-label": "more",
                                id: "long-button",
                                "aria-controls": endTimeOpen ? "long-menu" : undefined,
                                "aria-expanded": endTimeOpen ? "true" : undefined,
                                "aria-haspopup": "true",
                                onClick: handleEndTimeClick,
                                sx: {
                                    marginLeft: "5px",
                                    padding: 0,
                                    color: "#000000",
                                    "&:hover": {
                                        backgroundColor: "transparent"
                                    }
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5MAs))), {})
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                                id: "long-menu",
                                MenuListProps: {
                                    "aria-labelledby": "long-button"
                                },
                                anchorOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                anchorEl: endTimeAnchorEl,
                                open: endTimeOpen,
                                onClose: handleEndTimeClose,
                                slotProps: {
                                    paper: {
                                        style: {
                                            maxHeight: 216,
                                            width: "20ch"
                                        }
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: (event)=>{
                                            setDateMMDDYYYY(true);
                                            handleEndTimeClose(event);
                                        },
                                        children: "MM/DD/YYYY"
                                    }, "mm-dd-yyyy-end"),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: (event)=>{
                                            setDateMMDDYYYY(false);
                                            handleEndTimeClose(event);
                                        },
                                        children: "DD/MM/YYYY"
                                    }, "dd-mm-yyyy-end")
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                children: "End Date"
            }),
            value: userFiltersSentinel.end_date,
            onChange: (newValue)=>{
                if (newValue !== null) setUserFiltersSentinel((previousState)=>{
                    return {
                        ...previousState,
                        end_date: newValue
                    };
                });
                if (newValue === null) setUserFiltersSentinel((previousState)=>{
                    return {
                        ...previousState,
                        end_date: null
                    };
                });
                if ((0, $5L5iJ.yyyymmddGenerator)(newValue) !== (0, $5L5iJ.yyyymmddGenerator)(userFiltersSentinel.start_date)) {
                    setTimeFiltersDisabledSentinel(true);
                    setUserFiltersSentinel((previousState)=>{
                        return {
                            ...previousState,
                            start_time: null,
                            end_time: null
                        };
                    });
                }
                if ((0, $5L5iJ.yyyymmddGenerator)(newValue) === (0, $5L5iJ.yyyymmddGenerator)(userFiltersSentinel.start_date)) setTimeFiltersDisabledSentinel(false);
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    sx: {
                        width: 150
                    },
                    ...params
                })
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $a65wX = parcelRequire("a65wX");




var $cVCJe = parcelRequire("cVCJe");

var $eg2OC = parcelRequire("eg2OC");

var $6CjWJ = parcelRequire("6CjWJ");

var $4reBM = parcelRequire("4reBM");

var $cWqfz = parcelRequire("cWqfz");

var $cxknk = parcelRequire("cxknk");

var $eJK3E = parcelRequire("eJK3E");

var $88GbJ = parcelRequire("88GbJ");

var $w8ml8 = parcelRequire("w8ml8");


var $4G44R = parcelRequire("4G44R");
const $0de156887eadba61$export$b6911ec207ffe2fc = ({ setSentinelData: setSentinelData, setPageLoadingSentinel: setPageLoadingSentinel, setSelectedRowSentinel: setSelectedRowSentinel, setPrecisionRecallDataSentinel: setPrecisionRecallDataSentinel, setVideoURLSentinel: setVideoURLSentinel, setVideoClipLoadingSentinel: setVideoClipLoadingSentinel, setClipsIndexOrderSentinel: setClipsIndexOrderSentinel, selectedRowSentinel: selectedRowSentinel, setNoDataToDisplaySentinel: setNoDataToDisplaySentinel, setSiteOptionsSentinel: setSiteOptionsSentinel, setLoadingSitesSentinel: setLoadingSitesSentinel, userFiltersSentinel: userFiltersSentinel, setFetchingFilteredDataSentinel: setFetchingFilteredDataSentinel, setPageSentinel: setPageSentinel, onSentinelFiltersApply: onSentinelFiltersApply, setLoadingAdditionalData: setLoadingAdditionalData, setFiltersApplied: setFiltersApplied, navigate: navigate, setSearchParams: setSearchParams })=>{
    const options = [
        "Apply Filters",
        "Download Report"
    ];
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const anchorRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const [option, setOption] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(options[0]);
    const { downloadURLSentinel: downloadURLSentinel, fetchingDownloadURLSentinel: fetchingDownloadURLSentinel, getDownloadURLSentinel: getDownloadURLSentinel } = (0, $4G44R.useClipsStore)();
    const handleRefreshReport = ()=>{
        getDownloadURLSentinel(navigate, userFiltersSentinel, true);
    };
    const handleClick = ()=>{
        if (option === "Apply Filters") {
            onSentinelFiltersApply?.();
            setPageSentinel(0);
            setFiltersApplied(true);
            setLoadingAdditionalData(true);
            setSentinelData([]);
            setNoDataToDisplaySentinel(true);
            setSelectedRowSentinel({});
            setPrecisionRecallDataSentinel((0, $w8ml8.createEmptyPrecisionRecallData)());
            setFetchingFilteredDataSentinel(true);
            localStorage.setItem("last_file_id_sentinal", "");
            localStorage.setItem("last_timestamp_sentinal", "");
            (0, $88GbJ.getSentinelClipsWithQuerry)(setSentinelData, setPageLoadingSentinel, setSelectedRowSentinel, setPrecisionRecallDataSentinel, setVideoURLSentinel, setVideoClipLoadingSentinel, setClipsIndexOrderSentinel, selectedRowSentinel, setNoDataToDisplaySentinel, setSiteOptionsSentinel, setLoadingSitesSentinel, userFiltersSentinel, setFetchingFilteredDataSentinel, setPageSentinel, "", "", false, setLoadingAdditionalData, navigate);
            if (setSearchParams) (0, $60d1d427e7f38222$export$867258f8bab37ec)(setSearchParams, "sentinel", userFiltersSentinel);
        }
    };
    const handleMenuItemClick = (event, index)=>{
        setOption(options[index]);
        setOpen(false);
    };
    const handleToggle = ()=>{
        setOpen((prevOpen)=>!prevOpen);
    };
    const handleClose = (event)=>{
        if (anchorRef.current && anchorRef.current.contains(event.target)) return;
        setOpen(false);
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "z-10",
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $d685fbaea40075f4$export$2e2bcd8739ae039), {
                    variant: "contained",
                    ref: anchorRef,
                    "aria-label": "Site Group Actions",
                    disabled: false,
                    color: "warning",
                    children: [
                        option === "Apply Filters" ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                            onClick: handleClick,
                            disabled: false,
                            sx: {
                                backgroundColor: "#FF8400",
                                "&:hover": {
                                    backgroundColor: "#E67300"
                                },
                                width: "140px"
                            },
                            children: option
                        }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                            onClick: ()=>{},
                            component: "a",
                            href: downloadURLSentinel,
                            download: true,
                            disabled: !downloadURLSentinel,
                            sx: {
                                color: "white",
                                backgroundColor: "#FF8400",
                                "&:hover": {
                                    backgroundColor: "#E67300",
                                    color: "white"
                                },
                                width: "178px",
                                textDecoration: "none"
                            },
                            children: fetchingDownloadURLSentinel ? "Fetching Report..." : "Download Report"
                        }),
                        option === "Download Report" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                            title: "Regenerate the report with the latest clips",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                size: "small",
                                "aria-label": "refresh report",
                                disabled: fetchingDownloadURLSentinel,
                                sx: {
                                    backgroundColor: "#FF8400",
                                    "&:hover": {
                                        backgroundColor: "#E67300"
                                    }
                                },
                                onClick: handleRefreshReport,
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9222626528c451ae$exports))), {})
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                            size: "small",
                            "aria-controls": open ? "split-button-menu" : undefined,
                            "aria-expanded": open ? "true" : undefined,
                            "aria-label": "select group action",
                            "aria-haspopup": "menu",
                            sx: {
                                backgroundColor: "#FF8400",
                                "&:hover": {
                                    backgroundColor: "#E67300"
                                }
                            },
                            onClick: handleToggle,
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bf807683d00d38ca$exports))), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $cWqfz.default), {
                    sx: {
                        zIndex: 1
                    },
                    open: open,
                    anchorEl: anchorRef.current,
                    role: undefined,
                    transition: true,
                    disablePortal: true,
                    children: ({ TransitionProps: TransitionProps, placement: placement })=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $6CjWJ.default), {
                            ...TransitionProps,
                            style: {
                                transformOrigin: placement === "bottom" ? "center top" : "center bottom"
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4reBM.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eg2OC.ClickAwayListener), {
                                    onClickAway: handleClose,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eJK3E.default), {
                                        className: "absolute",
                                        id: "split-button-menu",
                                        autoFocusItem: true,
                                        children: options.map((option, index)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                selected: index === options.indexOf(option),
                                                onClick: (event)=>handleMenuItemClick(event, index),
                                                children: option
                                            }, option))
                                    })
                                })
                            })
                        })
                })
            ]
        })
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eejVe = parcelRequire("eejVe");
var $cVCJe = parcelRequire("cVCJe");

var $hwWkD = parcelRequire("hwWkD");

var $a50J4 = parcelRequire("a50J4");

var $hfM8m = parcelRequire("hfM8m");

const $332c0dcebb970b51$export$3bbdb9bcaa1ca523 = ({ userFiltersSentinel: userFiltersSentinel, setUserFiltersSentinel: setUserFiltersSentinel, timeFiltersDisabledSentinel: timeFiltersDisabledSentinel, showUserDropDownSentinel: showUserDropDownSentinel })=>{
    const sx = showUserDropDownSentinel ? {
        width: 132
    } : {
        width: 135
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
        dateAdapter: (0, $hfM8m.AdapterDateFns),
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
            title: (0, $ffbec3bd61ee0d21$export$e5ad0d4cfb9b77f4),
            disableHoverListener: !timeFiltersDisabledSentinel,
            disableFocusListener: !timeFiltersDisabledSentinel,
            disableTouchListener: !timeFiltersDisabledSentinel,
            ...(0, $ffbec3bd61ee0d21$export$b1886b315cb3d290),
            children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                style: {
                    display: "inline-block"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a50J4.DesktopTimePicker), {
                    label: "Start Time",
                    value: userFiltersSentinel.start_time ? userFiltersSentinel.start_time : null,
                    onChange: (newValue)=>{
                        setUserFiltersSentinel((previousState)=>{
                            return {
                                ...previousState,
                                start_time: newValue
                            };
                        });
                    },
                    disabled: timeFiltersDisabledSentinel,
                    renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                            ...params,
                            autoComplete: "off",
                            sx: sx
                        })
                })
            })
        })
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eejVe = parcelRequire("eejVe");
var $cVCJe = parcelRequire("cVCJe");

var $hwWkD = parcelRequire("hwWkD");

var $a50J4 = parcelRequire("a50J4");

var $hfM8m = parcelRequire("hfM8m");

const $920ec8d1d1f479c9$export$ae4d3003f2bee3cb = ({ userFiltersSentinel: userFiltersSentinel, setUserFiltersSentinel: setUserFiltersSentinel, timeFiltersDisabledSentinel: timeFiltersDisabledSentinel, showUserDropDownSentinel: showUserDropDownSentinel })=>{
    const sx = showUserDropDownSentinel ? {
        width: 132
    } : {
        width: 135
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
        dateAdapter: (0, $hfM8m.AdapterDateFns),
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
            title: (0, $ffbec3bd61ee0d21$export$e5ad0d4cfb9b77f4),
            disableHoverListener: !timeFiltersDisabledSentinel,
            disableFocusListener: !timeFiltersDisabledSentinel,
            disableTouchListener: !timeFiltersDisabledSentinel,
            ...(0, $ffbec3bd61ee0d21$export$b1886b315cb3d290),
            children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                style: {
                    display: "inline-block"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a50J4.DesktopTimePicker), {
                    label: "End Time",
                    value: userFiltersSentinel.end_time ? userFiltersSentinel.end_time : null,
                    onChange: (newValue)=>{
                        setUserFiltersSentinel((previousState)=>{
                            return {
                                ...previousState,
                                end_time: newValue
                            };
                        });
                    },
                    disabled: timeFiltersDisabledSentinel,
                    renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                            ...params,
                            autoComplete: "off",
                            sx: sx
                        })
                })
            })
        })
    });
};




var $4G44R = parcelRequire("4G44R");
const $e3a860ea1a5370e4$export$4453df94902799fa = ({ showUserDropDownSentinel: showUserDropDownSentinel, userDropDownValueSentinel: userDropDownValueSentinel, userOptions: userOptions, setUserDropDownValueSentinel: setUserDropDownValueSentinel, setCameraDropDownValueSentinel: setCameraDropDownValueSentinel, setUserFiltersSentinel: setUserFiltersSentinel, setSiteDropDownValueSentinel: setSiteDropDownValueSentinel, setSiteOptionsSentinel: setSiteOptionsSentinel, setCameraOptionsSentinel: setCameraOptionsSentinel, setLoadingSitesSentinel: setLoadingSitesSentinel, siteOptionsSentinel: siteOptionsSentinel, loadingSitesSentinel: loadingSitesSentinel, siteDropDownValueSentinel: siteDropDownValueSentinel, setLoadingCamerasSentinel: setLoadingCamerasSentinel, cameraOptionsSentinel: cameraOptionsSentinel, cameraDropDownValueSentinel: cameraDropDownValueSentinel, loadingCamerasSentinel: loadingCamerasSentinel, userFiltersSentinel: userFiltersSentinel, setSentinelData: setSentinelData, setPageLoadingSentinel: setPageLoadingSentinel, setSelectedRowSentinel: setSelectedRowSentinel, setPrecisionRecallDataSentinel: setPrecisionRecallDataSentinel, setVideoURLSentinel: setVideoURLSentinel, setVideoClipLoadingSentinel: setVideoClipLoadingSentinel, setClipsIndexOrderSentinel: setClipsIndexOrderSentinel, selectedRowSentinel: selectedRowSentinel, setNoDataToDisplaySentinel: setNoDataToDisplaySentinel, setFetchingFilteredDataSentinel: setFetchingFilteredDataSentinel, setPageSentinel: setPageSentinel, onSentinelFiltersApply: onSentinelFiltersApply, setLoadingAdditionalData: setLoadingAdditionalData, navBarCollapsed: navBarCollapsed, setFiltersApplied: setFiltersApplied, userInfo: userInfo, timeFiltersDisabledSentinel: timeFiltersDisabledSentinel, setTimeFiltersDisabledSentinel: setTimeFiltersDisabledSentinel, navigate: navigate, setSearchParams: setSearchParams })=>{
    const { getDownloadURLSentinel: getDownloadURLSentinel } = (0, $4G44R.useClipsStore)();
    // Prefetch the report download URL from filter STATE rather than from
    // dropdown onChange handlers, so every path that sets filters is covered —
    // including URL-param hydration and drill-down navigation, which never
    // touch the dropdowns (PROD-47: camera-level drill-down had no report URL).
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!userFiltersSentinel?.user) return;
        getDownloadURLSentinel(navigate, userFiltersSentinel);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        userFiltersSentinel
    ]);
    let noUserDropDownCSS = showUserDropDownSentinel ? [
        "absolute top-0 left-[160px]",
        "absolute top-0 left-[320px]",
        "absolute top-0 left-[480px]",
        "absolute top-0 left-[640px]",
        "absolute top-0 left-[800px]",
        "absolute top-0 left-[944px]",
        "absolute top-0 left-[1088px]",
        "absolute top-0",
        "absolute top-[8px] left-[1228px]"
    ] : [
        "absolute top-0",
        "absolute top-0 left-[210px]",
        "absolute top-0 left-[420px]",
        "absolute top-0 left-[580px]",
        "absolute top-0 left-[740px]",
        "absolute top-0 left-[882px]",
        "absolute top-0 left-[1024px]",
        "absolute top-[8px] left-[1164px]"
    ];
    if (showUserDropDownSentinel && navBarCollapsed) noUserDropDownCSS = [
        "absolute top-0 left-[185px]",
        "absolute top-0 left-[370px]",
        "absolute top-0 left-[555px]",
        "absolute top-0 left-[715px]",
        "absolute top-0 left-[875px]",
        "absolute top-0 left-[1012px]",
        "absolute top-0 left-[1154px]",
        "absolute top-0",
        "absolute top-[8px] left-[1294px]"
    ];
    if (!showUserDropDownSentinel && navBarCollapsed) noUserDropDownCSS = [
        "absolute top-0",
        "absolute top-0 left-[250px]",
        "absolute top-0 left-[495px]",
        "absolute top-0 left-[655px]",
        "absolute top-0 left-[815px]",
        "absolute top-0 left-[957px]",
        "absolute top-0 left-[1099px]",
        "absolute top-[8px] left-[1240px]"
    ];
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: userInfo.permission.sentinel && (userInfo.permission.ailink || userInfo.permission.smtp) ? "absolute top-[60px] left-0" : "absolute top-[0px] left-0",
        children: [
            showUserDropDownSentinel && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[7],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $6e659094c6eb6020$export$b1adbeb8891ae9b5), {
                    userDropDownValueSentinel: userDropDownValueSentinel,
                    userOptions: userOptions,
                    setUserDropDownValueSentinel: setUserDropDownValueSentinel,
                    setCameraDropDownValueSentinel: setCameraDropDownValueSentinel,
                    setUserFiltersSentinel: setUserFiltersSentinel,
                    setSiteDropDownValueSentinel: setSiteDropDownValueSentinel,
                    setSiteOptionsSentinel: setSiteOptionsSentinel,
                    setCameraOptionsSentinel: setCameraOptionsSentinel,
                    setLoadingSitesSentinel: setLoadingSitesSentinel,
                    navBarCollapsed: navBarCollapsed,
                    navigate: navigate
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[0],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $882b52372a83ae29$export$7099014a312295de), {
                    siteOptionsSentinel: siteOptionsSentinel,
                    loadingSitesSentinel: loadingSitesSentinel,
                    siteDropDownValueSentinel: siteDropDownValueSentinel,
                    setSiteDropDownValueSentinel: setSiteDropDownValueSentinel,
                    setCameraDropDownValueSentinel: setCameraDropDownValueSentinel,
                    setUserFiltersSentinel: setUserFiltersSentinel,
                    setCameraOptionsSentinel: setCameraOptionsSentinel,
                    setLoadingCamerasSentinel: setLoadingCamerasSentinel,
                    showUserDropDown: showUserDropDownSentinel,
                    navBarCollapsed: navBarCollapsed,
                    navigate: navigate
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[1],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $91b133353099c762$export$62d8c3fd3b374f43), {
                    setUserFiltersSentinel: setUserFiltersSentinel,
                    cameraOptionsSentinel: cameraOptionsSentinel,
                    cameraDropDownValueSentinel: cameraDropDownValueSentinel,
                    setCameraDropDownValueSentinel: setCameraDropDownValueSentinel,
                    siteOptionsSentinel: siteOptionsSentinel,
                    loadingCamerasSentinel: loadingCamerasSentinel,
                    navBarCollapsed: navBarCollapsed,
                    showUserDropDown: showUserDropDownSentinel
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[2],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1cf6950897e08b03$export$ef5c0482c00d4214), {
                    userFiltersSentinel: userFiltersSentinel,
                    setUserFiltersSentinel: setUserFiltersSentinel,
                    setTimeFiltersDisabledSentinel: setTimeFiltersDisabledSentinel
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[3],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $c8d36ebd584b3e6a$export$ab606ac7892ca322), {
                    userFiltersSentinel: userFiltersSentinel,
                    setUserFiltersSentinel: setUserFiltersSentinel,
                    setTimeFiltersDisabledSentinel: setTimeFiltersDisabledSentinel
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[4],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $332c0dcebb970b51$export$3bbdb9bcaa1ca523), {
                    userFiltersSentinel: userFiltersSentinel,
                    setUserFiltersSentinel: setUserFiltersSentinel,
                    timeFiltersDisabledSentinel: timeFiltersDisabledSentinel,
                    showUserDropDownSentinel: showUserDropDownSentinel
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[5],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $920ec8d1d1f479c9$export$ae4d3003f2bee3cb), {
                    userFiltersSentinel: userFiltersSentinel,
                    setUserFiltersSentinel: setUserFiltersSentinel,
                    timeFiltersDisabledSentinel: timeFiltersDisabledSentinel,
                    showUserDropDownSentinel: showUserDropDownSentinel
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[6],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1f441af7d8bd507f$export$d64b982d1df0bde5), {
                    userFilters: userFiltersSentinel,
                    setUserFilters: setUserFiltersSentinel,
                    showUserDropDown: showUserDropDownSentinel
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[showUserDropDownSentinel ? 8 : 7],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $0de156887eadba61$export$b6911ec207ffe2fc), {
                    setSentinelData: setSentinelData,
                    setPageLoadingSentinel: setPageLoadingSentinel,
                    setSelectedRowSentinel: setSelectedRowSentinel,
                    setPrecisionRecallDataSentinel: setPrecisionRecallDataSentinel,
                    setVideoURLSentinel: setVideoURLSentinel,
                    setVideoClipLoadingSentinel: setVideoClipLoadingSentinel,
                    setClipsIndexOrderSentinel: setClipsIndexOrderSentinel,
                    selectedRowSentinel: selectedRowSentinel,
                    setNoDataToDisplaySentinel: setNoDataToDisplaySentinel,
                    setSiteOptionsSentinel: setSiteOptionsSentinel,
                    setLoadingSitesSentinel: setLoadingSitesSentinel,
                    userFiltersSentinel: userFiltersSentinel,
                    setFetchingFilteredDataSentinel: setFetchingFilteredDataSentinel,
                    setPageSentinel: setPageSentinel,
                    onSentinelFiltersApply: onSentinelFiltersApply,
                    setLoadingAdditionalData: setLoadingAdditionalData,
                    setFiltersApplied: setFiltersApplied,
                    navigate: navigate,
                    setSearchParams: setSearchParams
                })
            })
        ]
    });
};




/* eslint-disable jsx-a11y/media-has-caption */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

var $60vL1 = parcelRequire("60vL1");


var $fIsAN = parcelRequire("fIsAN");

var $8jTCz = parcelRequire("8jTCz");

var $frXOV = parcelRequire("frXOV");

var $2qUoo = parcelRequire("2qUoo");
parcelRequire("8T3gX");


var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $a3a262a81b634fbd$export$3ee098ba5e04ff00 = (sentinelData, selectedRowSentinel, clipsIndexOrderSentinel, directionString, setSelectedRowSentinel, setSentinelData, setVideoClipLoadingSentinel, setVideoURLSentinel, userFiltersSentinel, navigate, onRowChange)=>{
    // const clipsData = JSON.parse(localStorage.clipsData);
    // const selectedRow = JSON.parse(localStorage.clipsSelectedRow);
    // const clipsIndexOrder = JSON.parse(localStorage.clipsIndexOrder);
    if (directionString === "forward" && selectedRowSentinel.index !== clipsIndexOrderSentinel[clipsIndexOrderSentinel.length - 1] || directionString === "back" && selectedRowSentinel.index !== clipsIndexOrderSentinel[0]) {
        setVideoClipLoadingSentinel(true);
        const currentIndex = (0, $383cff3d7cc17d76$export$f8c49e79d1708ea0)(clipsIndexOrderSentinel, selectedRowSentinel.index);
        let newSelectedRow;
        directionString === "forward" ? newSelectedRow = sentinelData[currentIndex + 1] : newSelectedRow = sentinelData[currentIndex - 1];
        setSelectedRowSentinel(newSelectedRow);
        localStorage.setItem("clipsSelectedRow", JSON.stringify(newSelectedRow));
        onRowChange?.(newSelectedRow);
        const updatedSentinelData = sentinelData;
        updatedSentinelData.forEach((object)=>{
            object.selected = false;
        });
        directionString === "forward" ? updatedSentinelData[currentIndex + 1].selected = true : updatedSentinelData[currentIndex - 1].selected = true;
        setSentinelData(updatedSentinelData);
        // localStorage.setItem("sentinelData", JSON.stringify(updatedSentinelData));
        const AxiosUI = (0, $195EM.createApi)("");
        const retryFunction = ()=>{
            $a3a262a81b634fbd$export$3ee098ba5e04ff00(sentinelData, selectedRowSentinel, clipsIndexOrderSentinel, directionString, setSelectedRowSentinel, setSentinelData, setVideoClipLoadingSentinel, setVideoURLSentinel, userFiltersSentinel, navigate, onRowChange);
        };
        // First, fetch complete row information (same as handleRowSelected)
        AxiosUI.get(`clip/info/?username=${userFiltersSentinel.user}&file_id=${newSelectedRow.file_id}`).then((response)=>{
            if (response.data.file_id) {
                // Update selectedRow with complete data from API
                for(const key in response.data)setSelectedRowSentinel((previousState)=>{
                    return {
                        ...previousState,
                        [key]: response.data[key]
                    };
                });
                localStorage.setItem("clipsSelectedRow", JSON.stringify(selectedRowSentinel));
                // Then fetch the video URL
                AxiosUI.get(`clip/url/?username=${userFiltersSentinel.user}&file_id=${response.data.file_id}`).then((videoResponse)=>{
                    setVideoURLSentinel(videoResponse.data);
                    setVideoClipLoadingSentinel(false);
                }, (reason)=>{
                    (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                        const newSentinelData = sentinelData;
                        newSentinelData.forEach((object)=>{
                            object.selected = false;
                        });
                        directionString === "forward" ? newSentinelData[currentIndex + 1].selected = true : newSentinelData[currentIndex - 1].selected = true;
                        setSentinelData(newSentinelData);
                        localStorage.setItem("sentinelData", JSON.stringify(newSentinelData));
                        setVideoURLSentinel("");
                        setVideoClipLoadingSentinel(false);
                    });
                });
            }
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                const newSentinelData = sentinelData;
                newSentinelData.forEach((object)=>{
                    object.selected = false;
                });
                directionString === "forward" ? newSentinelData[currentIndex + 1].selected = true : newSentinelData[currentIndex - 1].selected = true;
                setSentinelData(newSentinelData);
                localStorage.setItem("sentinelData", JSON.stringify(newSentinelData));
                setVideoURLSentinel("");
                setVideoClipLoadingSentinel(false);
            });
        });
    }
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $1wcxl = parcelRequire("1wcxl");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $fWsn7 = parcelRequire("fWsn7");



var $fIsAN = parcelRequire("fIsAN");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");
var $aVDw9 = parcelRequire("aVDw9");
var $ha39s = parcelRequire("ha39s");
var $4o6Cs = parcelRequire("4o6Cs");
var $kLvBh = parcelRequire("kLvBh");

var $9lVTU = parcelRequire("9lVTU");
const $d1916ca667664de4$var$headCells = [
    {
        id: "file_id",
        numeric: true,
        label: "File ID"
    },
    // {
    //   id: "utc_time",
    //   numeric: false,
    //   label: "Received (UTC)",
    // },
    {
        id: "time",
        numeric: false,
        label: "Received (Local)"
    },
    {
        id: "site",
        numeric: false,
        label: "Site"
    },
    {
        id: "camera_name",
        numeric: false,
        label: "Camera Name"
    },
    {
        id: "probability",
        numeric: true,
        label: "Probability"
    },
    {
        id: "clip_result",
        numeric: false,
        label: "Clip Result"
    }
];
const $d1916ca667664de4$export$76a056fe8a3b1e09 = (props)=>{
    const { onRequestSort: onRequestSort, orderBy: orderBy, order: order } = props;
    const createSortHandler = (property)=>(event)=>{
            onRequestSort(event, property);
        };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
            children: $d1916ca667664de4$var$headCells.map((headCell)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    align: "left",
                    sortDirection: orderBy === headCell.id ? order : false,
                    sx: {
                        fontFamily: "mulish",
                        fontWeight: 700,
                        fontSize: 9,
                        whiteSpace: "nowrap"
                    },
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kLvBh.default), {
                        active: orderBy === headCell.id,
                        direction: orderBy === headCell.id ? order : "asc",
                        onClick: createSortHandler(headCell.id),
                        sx: {
                            whiteSpace: "nowrap"
                        },
                        children: [
                            headCell.label,
                            orderBy === headCell.id ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                component: "span",
                                sx: (0, $9lVTU.default),
                                children: order === "desc" ? "sorted descending" : "sorted ascending"
                            }) : null
                        ]
                    })
                }, headCell.id))
        })
    });
};



const $656867db00140520$export$efea31d41815cb2f = ({ sentinelData: sentinelData, setSentinelData: setSentinelData, setSelectedRowSentinel: setSelectedRowSentinel, pageSentinel: pageSentinel, setPageSentinel: setPageSentinel, setVideoClipLoadingSentinel: setVideoClipLoadingSentinel, setVideoURLSentinel: setVideoURLSentinel, scrollToTop: scrollToTop, selectedRowSentinel: selectedRowSentinel, setClipsIndexOrderSentinel: setClipsIndexOrderSentinel, userFiltersSentinel: userFiltersSentinel, navigate: navigate, sentinelFilterApplyToken: sentinelFilterApplyToken = 0 })=>{
    const [searchParams, setSearchParams] = (0, $fIsAN.useSearchParams)();
    const [order, setOrder] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("asc");
    const [orderBy, setOrderBy] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("formatted_date");
    const [rowsPerPage, setRowsPerPage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(5);
    const lastAutoPagedSelectionRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef({
        selectedFileId: null,
        expectedPage: null
    });
    const lastFilterApplyTokenRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(sentinelFilterApplyToken);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (sentinelFilterApplyToken === lastFilterApplyTokenRef.current) return;
        lastFilterApplyTokenRef.current = sentinelFilterApplyToken;
        setPageSentinel(0);
        lastAutoPagedSelectionRef.current = {
            selectedFileId: null,
            expectedPage: 0
        };
    }, [
        sentinelFilterApplyToken,
        setPageSentinel
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        const maxPage = Math.max(0, Math.ceil(sentinelData.length / rowsPerPage) - 1);
        if (pageSentinel > maxPage) setPageSentinel(0);
    }, [
        sentinelData.length,
        rowsPerPage,
        pageSentinel,
        setPageSentinel
    ]);
    const handleRequestSort = (event, property)=>{
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };
    const handleChangePage = (event, newPage)=>{
        setPageSentinel(newPage);
    };
    const handleChangeRowsPerPage = (event)=>{
        setRowsPerPage(parseInt(event.target.value, 10));
        setPageSentinel(0);
    };
    const emptyRows = pageSentinel > 0 ? Math.max(0, (1 + pageSentinel) * rowsPerPage - sentinelData.length) : 0;
    const visibleRows = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>(0, $fWsn7.stableSort)(sentinelData, (0, $fWsn7.getComparator)(order, orderBy)).slice(pageSentinel * rowsPerPage, pageSentinel * rowsPerPage + rowsPerPage), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        order,
        orderBy,
        pageSentinel,
        rowsPerPage
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        const sortedRows = (0, $fWsn7.stableSort)(sentinelData, (0, $fWsn7.getComparator)(order, orderBy));
        const selectedIndex = sortedRows.findIndex((row)=>row.selected);
        const selectedFileId = selectedIndex >= 0 && sortedRows[selectedIndex]?.file_id != null ? String(sortedRows[selectedIndex].file_id) : null;
        const expectedPage = selectedIndex >= 0 ? Math.floor(selectedIndex / rowsPerPage) : 0;
        const hasSelectionChanged = selectedFileId !== lastAutoPagedSelectionRef.current.selectedFileId;
        if (selectedFileId && hasSelectionChanged) {
            lastAutoPagedSelectionRef.current = {
                selectedFileId: selectedFileId,
                expectedPage: expectedPage
            };
            if (expectedPage !== pageSentinel) setPageSentinel(expectedPage);
        }
    }, [
        sentinelData,
        pageSentinel,
        rowsPerPage,
        setPageSentinel
    ]);
    const roundToHundredth = (number)=>{
        const newNumber = number * 100;
        return Math.round(newNumber * 100) / 100;
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4reBM.default), {
        sx: {
            width: "100%",
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                sx: {
                    maxHeight: 490
                },
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                    sx: {
                        fontFamily: "Mulish",
                        postion: "absolute"
                    },
                    "aria-labelledby": "clips-table",
                    stickyHeader: true,
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $d1916ca667664de4$export$76a056fe8a3b1e09), {
                            onRequestSort: handleRequestSort,
                            orderBy: orderBy,
                            order: order
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $gXvgZ.default), {
                            children: [
                                visibleRows.map((row, index)=>{
                                    let sx = {
                                        cursor: "pointer"
                                    };
                                    if (row.selected) sx = {
                                        cursor: "pointer",
                                        backgroundColor: "rgba(2, 136, 209, 0.2)"
                                    };
                                    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                        hover: true,
                                        onClick: ()=>{
                                            scrollToTop();
                                            setVideoClipLoadingSentinel(true);
                                            setSelectedRowSentinel(row);
                                            localStorage.setItem("clipsSelectedRow", JSON.stringify(row));
                                            (0, $54027012fff01b21$export$2fd5d64b4d451d7b)(row, setSelectedRowSentinel, setVideoURLSentinel, setVideoClipLoadingSentinel, sentinelData, setSentinelData, selectedRowSentinel, userFiltersSentinel, "sentinel", userFiltersSentinel.user, navigate);
                                            (0, $60d1d427e7f38222$export$d0ea5288e6803239)(setSearchParams, searchParams);
                                        },
                                        tabIndex: -1,
                                        sx: sx,
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontSize: "10px",
                                                    fontFamily: "mulish"
                                                },
                                                children: row.file_id
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontSize: "10px",
                                                    fontFamily: "mulish"
                                                },
                                                children: (0, $c0433b3a957ff718$export$36a24ca552645e4e)(row.clip_header_received, row.clip_received_local, row.site_timezone)
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontSize: "10px",
                                                    fontFamily: "mulish"
                                                },
                                                children: row.customer_name
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontSize: "10px",
                                                    fontFamily: "mulish"
                                                },
                                                children: row.camera_name
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontSize: "10px",
                                                    fontFamily: "mulish"
                                                },
                                                children: `${roundToHundredth(row.probability)}%`
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontSize: "10px",
                                                    fontFamily: "mulish"
                                                },
                                                children: row.clip_result
                                            })
                                        ]
                                    }, row.id);
                                }),
                                emptyRows > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                    style: {
                                        height: 53 * emptyRows
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        colSpan: 7
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wcxl.default), {
                rowsPerPageOptions: [
                    5,
                    10,
                    25
                ],
                component: "div",
                count: sentinelData.length,
                rowsPerPage: rowsPerPage,
                page: pageSentinel,
                onPageChange: handleChangePage,
                onRowsPerPageChange: handleChangeRowsPerPage
            })
        ]
    });
};




var $iIAML = parcelRequire("iIAML");
/* eslint-disable jsx-a11y/media-has-caption */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $gus0k = parcelRequire("gus0k");

var $kRZvb = parcelRequire("kRZvb");

var $iKAtE = parcelRequire("iKAtE");

var $f3puC = parcelRequire("f3puC");

var $433j1 = parcelRequire("433j1");


var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $8jTCz = parcelRequire("8jTCz");

var $2aMB5 = parcelRequire("2aMB5");

var $lWchQ = parcelRequire("lWchQ");


var $5Vost = parcelRequire("5Vost");
const $ae717f38449e1aa8$var$Transition = /*#__PURE__*/ $8T3gX.forwardRef(function Transition(props, ref) {
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $212a5a6a44b7f18e$export$2e2bcd8739ae039), {
        direction: "up",
        ref: ref,
        ...props
    });
});
const $ae717f38449e1aa8$export$e114759dcf34c147 = ({ showMoreDialogOpenSentinel: showMoreDialogOpenSentinel, setShowMoreDialogOpenSentinel: setShowMoreDialogOpenSentinel, selectedRowSentinel: selectedRowSentinel, videoURLSentinel: videoURLSentinel })=>{
    const handleClickOpen = ()=>{
        setShowMoreDialogOpenSentinel(true);
    };
    const handleClose = ()=>{
        setShowMoreDialogOpenSentinel(false);
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                onClick: handleClickOpen,
                text: "Full Clip Info",
                disabled: false
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                fullScreen: true,
                open: showMoreDialogOpenSentinel,
                onClose: handleClose,
                TransitionComponent: $ae717f38449e1aa8$var$Transition,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gus0k.default), {
                        sx: {
                            position: "relative"
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kRZvb.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                    edge: "start",
                                    color: "inherit",
                                    onClick: handleClose,
                                    "aria-label": "close",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                    sx: {
                                        ml: 2,
                                        flex: 1
                                    },
                                    variant: "h6",
                                    component: "div",
                                    children: [
                                        selectedRowSentinel.customer_name,
                                        " |",
                                        " ",
                                        selectedRowSentinel.camera_name
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "flex pt-[20px] pl-[20px]",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)($8T3gX.Fragment, {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("video", {
                                        width: "550",
                                        controls: true,
                                        autoPlay: true,
                                        loop: true,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("source", {
                                            src: videoURLSentinel,
                                            type: "video/mp4"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        id: "column1",
                                        className: "pl-[20px]",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "text-black font-mulish text-[16px] font-bold",
                                                children: "Site"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "w-[250px] text-black font-mulish text-[16px]",
                                                children: selectedRowSentinel.customer_name ? selectedRowSentinel.customer_name : "--"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "pt-[20px] w-[250px] text-black font-mulish text-[16px] font-bold",
                                                children: "Event ID"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "w-[250px] text-black font-mulish text-[16px]",
                                                children: selectedRowSentinel.event_id ? selectedRowSentinel.event_id : "--"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "pt-[20px] w-[250px] text-black font-mulish text-[16px] font-bold",
                                                children: "Camera Name"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "w-[250px] text-black font-mulish text-[16px]",
                                                children: selectedRowSentinel.camera_name ? selectedRowSentinel.camera_name : "--"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "pt-[20px] w-[250px] text-black font-mulish text-[16px] font-bold",
                                                children: "Camera ID"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "w-[250px] text-black font-mulish text-[16px]",
                                                children: selectedRowSentinel.camera_id ? selectedRowSentinel.camera_id : "--"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        id: "column2",
                                        className: "pl-[100px]",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "text-black font-mulish text-[16px] font-bold",
                                                children: "Local Time"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "w-[250px] text-black font-mulish text-[16px]",
                                                children: (0, $c0433b3a957ff718$export$36a24ca552645e4e)(selectedRowSentinel.clip_header_received, selectedRowSentinel.clip_received_local, selectedRowSentinel.site_timezone) || "--"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "pt-[20px] w-[250px] text-black font-mulish text-[16px] font-bold",
                                                children: "UTC Time"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "w-[250px] text-black font-mulish text-[16px]",
                                                children: selectedRowSentinel.clip_header_received ? (0, $c0433b3a957ff718$export$6a6c5e33e36c4dc4)(selectedRowSentinel.clip_header_received) : ""
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "pt-[20px] w-[250px] text-black font-mulish text-[16px] font-bold",
                                                children: "Internal Log ID"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "w-[250px] text-black font-mulish text-[16px]",
                                                children: selectedRowSentinel.internal_id ? selectedRowSentinel.internal_id : "--"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "pt-[20px] w-[250px] text-black font-mulish text-[16px] font-bold",
                                                children: "File ID"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "w-[250px] text-black font-mulish text-[16px]",
                                                children: selectedRowSentinel.file_id ? selectedRowSentinel.file_id : "--"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                        component: (0, $4reBM.default),
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                            sx: {
                                fontFamily: "Mulish",
                                width: "100%"
                            },
                            "aria-label": "simple table",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                    titlesArray: [
                                        "Clip Result",
                                        "Probability",
                                        "Analyzed FPS",
                                        "Clip FPS",
                                        "Slice",
                                        "Stationary"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: selectedRowSentinel.clip_result ? selectedRowSentinel.clip_result : "--"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: `${(0, $5Vost.roundToHundredth)(selectedRowSentinel.probability)}%`
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: selectedRowSentinel.fps
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: selectedRowSentinel.stream_fps
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: selectedRowSentinel.slice ? (0, $lWchQ.checkedCircleIcon) : (0, $2aMB5.cancelIconRed)
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: selectedRowSentinel.stationary_filter ? (0, $lWchQ.checkedCircleIcon) : (0, $2aMB5.cancelIconRed)
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "relative min-w-[1450px] "
                    })
                ]
            })
        ]
    });
};






const $2df369e4e369b790$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $2df369e4e369b790$export$63b101394cabb828 = ({ showMoreDialogOpenSentinel: showMoreDialogOpenSentinel, setShowMoreDialogOpenSentinel: setShowMoreDialogOpenSentinel, selectedRowSentinel: selectedRowSentinel, videoURLSentinel: videoURLSentinel, sentinelData: sentinelData, pageSentinel: pageSentinel, setPageSentinel: setPageSentinel, sentinelFilterApplyToken: sentinelFilterApplyToken, precisionRecallDataSentinel: precisionRecallDataSentinel, videoClipLoadingSentinel: videoClipLoadingSentinel, setVideoURLSentinel: setVideoURLSentinel, setVideoClipLoadingSentinel: setVideoClipLoadingSentinel, setSelectedRowSentinel: setSelectedRowSentinel, setSentinelData: setSentinelData, scrollToTop: scrollToTop, setPageLoadingSentinel: setPageLoadingSentinel, clipsIndexOrderSentinel: clipsIndexOrderSentinel, setClipsIndexOrderSentinel: setClipsIndexOrderSentinel, fetchingFilteredDataSentinel: fetchingFilteredDataSentinel, userFiltersSentinel: userFiltersSentinel, loadingAdditionalData: loadingAdditionalData, navBarCollapsed: navBarCollapsed, userInfo: userInfo, navigate: navigate })=>{
    const [searchParams, setSearchParams] = (0, $fIsAN.useSearchParams)();
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: navBarCollapsed ? userInfo.permission.sentinel && (userInfo.permission.ailink || userInfo.permission.smtp) ? "relative left-[75px] top-[150px] w-[1200px]" : "relative left-[75px] top-[90px] w-[1200px]" : userInfo.permission.sentinel && (userInfo.permission.ailink || userInfo.permission.smtp) ? "relative left-[150px] top-[150px] w-[1200px]" : "relative left-[150px] top-[90px] w-[1200px]",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                className: "relative left-[20px] top-[15px] text-actuate-blue font-mulish text-[20px]",
                children: [
                    selectedRowSentinel.display_name ? (0, $a17e6a81e499c7af$export$d6488c46934633a3)(selectedRowSentinel.display_name, selectedRowSentinel.customer_pk) : (0, $a17e6a81e499c7af$export$d6488c46934633a3)(selectedRowSentinel.customer_name, selectedRowSentinel.customer_pk),
                    " ",
                    "|",
                    " ",
                    (0, $33b4b9464ea6ea5e$export$f28ee0a44f93351f)(selectedRowSentinel.camera_name, selectedRowSentinel.customer_pk, selectedRowSentinel.camera_pk)
                ]
            }),
            !videoClipLoadingSentinel && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "absolute left-[1150px] top-[0px] w-[150px] pt-[10px]",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ae717f38449e1aa8$export$e114759dcf34c147), {
                    showMoreDialogOpenSentinel: showMoreDialogOpenSentinel,
                    setShowMoreDialogOpenSentinel: setShowMoreDialogOpenSentinel,
                    selectedRowSentinel: selectedRowSentinel,
                    videoURLSentinel: videoURLSentinel
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex pt-[20px] pl-[10px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        children: !fetchingFilteredDataSentinel && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: !navBarCollapsed ? "w-[655px]" : "w-[725px]",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $656867db00140520$export$efea31d41815cb2f), {
                                            sentinelData: sentinelData,
                                            setSentinelData: setSentinelData,
                                            setSelectedRowSentinel: setSelectedRowSentinel,
                                            pageSentinel: pageSentinel,
                                            setPageSentinel: setPageSentinel,
                                            setVideoClipLoadingSentinel: setVideoClipLoadingSentinel,
                                            setVideoURLSentinel: setVideoURLSentinel,
                                            scrollToTop: scrollToTop,
                                            selectedRowSentinel: selectedRowSentinel,
                                            setClipsIndexOrderSentinel: setClipsIndexOrderSentinel,
                                            userFiltersSentinel: userFiltersSentinel,
                                            navigate: navigate,
                                            sentinelFilterApplyToken: sentinelFilterApplyToken
                                        })
                                    }),
                                    loadingAdditionalData && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "relative pt-[5px]",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "relative left-[10px]",
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $851fcbe833f3eb8b$export$b08b517936747730), {})
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "absolute left-[58px] top-[7px] font-mulish text-actuate-orange",
                                                children: "Loading Additional Data"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "w-[660px]",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "w-[660px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    children: [
                                        videoClipLoadingSentinel && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "text-center",
                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $b9p11.default), {
                                                theme: $2df369e4e369b790$var$theme,
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                                            color: "primary"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                        className: "font-mulish text-[20px]",
                                                        children: "Video Loading..."
                                                    })
                                                ]
                                            })
                                        }),
                                        !videoClipLoadingSentinel && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "flex items-center justify-between w-[660px]",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "flex-none",
                                                    id: "arrow_back",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                        onClick: ()=>{
                                                            (0, $a3a262a81b634fbd$export$3ee098ba5e04ff00)(sentinelData, selectedRowSentinel, clipsIndexOrderSentinel, "back", setSelectedRowSentinel, setSentinelData, setVideoClipLoadingSentinel, setVideoURLSentinel, userFiltersSentinel, navigate, ()=>(0, $60d1d427e7f38222$export$d0ea5288e6803239)(setSearchParams, searchParams));
                                                        },
                                                        text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($frXOV))), {
                                                            fontSize: "large",
                                                            id: "BackButton"
                                                        }),
                                                        disabled: selectedRowSentinel.index === clipsIndexOrderSentinel[0]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                    className: "flex-auto",
                                                    id: "video",
                                                    children: [
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("video", {
                                                                width: "550",
                                                                autoPlay: true,
                                                                controls: true,
                                                                loop: true,
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("source", {
                                                                    src: videoURLSentinel,
                                                                    type: "video/mp4"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                            className: "flex gap-[12px]",
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                                    onClick: ()=>(0, $iIAML.saveAs)(videoURLSentinel, "video.mp4"),
                                                                    text: "Download Video",
                                                                    disabled: false
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $42175367ea4c1e61$export$d994c77890cfb1f4), {
                                                                    tab: "sentinel",
                                                                    selectedRow: selectedRowSentinel
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "flex-none",
                                                    id: "arrow_forward",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                        onClick: ()=>{
                                                            (0, $a3a262a81b634fbd$export$3ee098ba5e04ff00)(sentinelData, selectedRowSentinel, clipsIndexOrderSentinel, "forward", setSelectedRowSentinel, setSentinelData, setVideoClipLoadingSentinel, setVideoURLSentinel, userFiltersSentinel, navigate, ()=>(0, $60d1d427e7f38222$export$d0ea5288e6803239)(setSearchParams, searchParams));
                                                        },
                                                        text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2qUoo))), {
                                                            fontSize: "large",
                                                            id: "forwardButton"
                                                        }),
                                                        disabled: selectedRowSentinel.index === clipsIndexOrderSentinel[clipsIndexOrderSentinel.length - 1]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: !navBarCollapsed ? "bg-white h-[55px] w-[1305px]" : "bg-white h-[55px] w-[1380px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "bg-white h-[55px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "font-black font-mulish text-[20px] p-3 indent-4",
                            children: "Precision and Recall"
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $ac1526c367c6b6aa$export$5d04df22b5df85a0), {
                        precisionRecallData: precisionRecallDataSentinel
                    })
                ]
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $djxj8 = parcelRequire("djxj8");

var $60vL1 = parcelRequire("60vL1");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");
const $a0e715ead9417e7e$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
function $a0e715ead9417e7e$export$2e2bcd8739ae039({ openState: openState }) {
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
        theme: $a0e715ead9417e7e$var$theme,
        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $djxj8.default), {
                sx: {
                    color: "#fff",
                    zIndex: (theme)=>theme.zIndex.drawer + 1
                },
                open: openState,
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    children: [
                        "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0",
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                            color: "primary"
                        })
                    ]
                })
            })
        })
    });
}



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $djxj8 = parcelRequire("djxj8");

var $60vL1 = parcelRequire("60vL1");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");
const $4311f8367c4f9b57$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
function $4311f8367c4f9b57$export$2e2bcd8739ae039({ openState: openState, aiLinkClipsTotal: aiLinkClipsTotal }) {
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
        theme: $4311f8367c4f9b57$var$theme,
        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $djxj8.default), {
                sx: {
                    color: "#fff",
                    zIndex: (theme)=>theme.zIndex.drawer + 1
                },
                open: openState,
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    children: [
                        "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0",
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                            color: "primary"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "text-actuate-orange"
                        })
                    ]
                })
            })
        })
    });
}



var $4G44R = parcelRequire("4G44R");
/* eslint-disable jsx-a11y/media-has-caption */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $aYdit = parcelRequire("aYdit");



var $4G44R = parcelRequire("4G44R");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $1wcxl = parcelRequire("1wcxl");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $a65wX = parcelRequire("a65wX");
var $1fWBE = parcelRequire("1fWBE");
var $cxknk = parcelRequire("cxknk");
var $cVCJe = parcelRequire("cVCJe");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

var $fWsn7 = parcelRequire("fWsn7");

var $4G44R = parcelRequire("4G44R");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");
var $aVDw9 = parcelRequire("aVDw9");
var $ha39s = parcelRequire("ha39s");
var $4o6Cs = parcelRequire("4o6Cs");
var $kLvBh = parcelRequire("kLvBh");
var $cVCJe = parcelRequire("cVCJe");

var $9lVTU = parcelRequire("9lVTU");

var $4G44R = parcelRequire("4G44R");

var $ePwXE = parcelRequire("ePwXE");
const $ebd0ca41d384a9c1$var$headCells = [
    {
        id: "site",
        numeric: false,
        label: "Site"
    },
    {
        id: "camera_name",
        numeric: false,
        label: "Camera Name"
    },
    {
        id: "timestamp_received",
        numeric: true,
        label: "Received (UTC)"
    },
    {
        id: "local_time_received",
        numeric: true,
        label: `Received (Local)`
    },
    // {
    //   id: "clip_result",
    //   numeric: false,
    //   label: "Clip Result",
    // },
    {
        id: "clip_id",
        numeric: true,
        label: "Clip ID"
    },
    {
        id: "armed",
        numeric: false,
        label: "Armed"
    }
];
const $ebd0ca41d384a9c1$export$b05db259568e62d2 = (props)=>{
    const { onRequestSort: onRequestSort, orderBy: orderBy, order: order } = props;
    const createSortHandler = (property)=>(event)=>{
            onRequestSort(event, property);
        };
    const { siteTimeZoneSMTP: siteTimeZoneSMTP } = (0, $4G44R.useClipsStore)();
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
            children: $ebd0ca41d384a9c1$var$headCells.map((headCell)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    align: "left",
                    sortDirection: orderBy === headCell.id ? order : false,
                    // style={{
                    //   width: "20%",
                    // }}
                    sx: {
                        fontFamily: "mulish",
                        fontWeight: 700,
                        fontSize: 10,
                        whiteSpace: "nowrap"
                    },
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kLvBh.default), {
                        active: orderBy === headCell.id,
                        direction: orderBy === headCell.id ? order : "asc",
                        onClick: createSortHandler(headCell.id),
                        children: [
                            headCell.label,
                            "\xa0",
                            headCell.id === "local_time_received" && siteTimeZoneSMTP && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                title: `${siteTimeZoneSMTP}`,
                                placement: "top",
                                sx: {
                                    fontSize: "10px",
                                    fontFamily: "mulish"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                    fontSize: "small"
                                })
                            }),
                            headCell.id === "armed" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                title: `Clips files are not stored and displayed when the site is not armed.`,
                                placement: "top",
                                sx: {
                                    fontSize: "10px",
                                    fontFamily: "mulish"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                    fontSize: "small"
                                })
                            }),
                            orderBy === headCell.id ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                component: "span",
                                sx: (0, $9lVTU.default),
                                children: order === "desc" ? "sorted descending" : "sorted ascending"
                            }) : null
                        ]
                    })
                }, headCell.id))
        })
    });
};




var $aYdit = parcelRequire("aYdit");
const $f20a59a7d5a09462$export$a6af2821505a7b50 = (userFiltersSMTP, groupIDSMTP, type)=>{
    // Format date to MMM-DD-YYYY format
    const formatDateForNavigation = (date)=>{
        if (!date) return "";
        const months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ];
        const month = months[date.getMonth()];
        const day = date.getDate().toString().padStart(2, "0");
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
    };
    // Format time to HHMM format
    const formatTimeForNavigation = (time)=>{
        if (!time) return "";
        const hours = time.getHours().toString().padStart(2, "0");
        const minutes = time.getMinutes().toString().padStart(2, "0");
        return `${hours}${minutes}`;
    };
    const queryParams = [];
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore).getState();
    const userInfo = JSON.parse(localStorage.userInfo);
    // Add group if it exists
    if (groupIDSMTP) queryParams.push(`group=${groupIDSMTP}`);
    if (!groupIDSMTP && userPermissions.smtp) {
        if (userInfo?.group?.id) queryParams.push(`group=${userInfo?.group?.id}`);
    }
    // Add site if it exists
    if (userFiltersSMTP.site_ids?.[0]) queryParams.push(`site=${userFiltersSMTP.site_ids[0]}`);
    // Add camera if it exists
    if (userFiltersSMTP.camera_ids?.[0]) queryParams.push(`camera=${userFiltersSMTP.camera_ids[0]}`);
    // Add start_date if it exists
    const startDate = formatDateForNavigation(userFiltersSMTP.start_date);
    if (startDate) queryParams.push(`start_date=${startDate}`);
    // Add end_date if it exists
    const endDate = formatDateForNavigation(userFiltersSMTP.end_date);
    if (endDate) queryParams.push(`end_date=${endDate}`);
    if (type === "alerts") {
        queryParams.push(`filter_type=All`);
        queryParams.push(`detection_type=All`);
    }
    // Add start_time if it exists
    const startTime = formatTimeForNavigation(userFiltersSMTP.start_time);
    if (startTime) queryParams.push(`start_time=${startTime}`);
    // Add end_time if it exists
    const endTime = formatTimeForNavigation(userFiltersSMTP.end_time);
    if (endTime) queryParams.push(`end_time=${endTime}`);
    return queryParams.join("&");
};


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
var $fIsAN = parcelRequire("fIsAN");

var $ePwXE = parcelRequire("ePwXE");

var $2aMB5 = parcelRequire("2aMB5");

var $lWchQ = parcelRequire("lWchQ");

const $e6023089cddb5cf1$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $e6023089cddb5cf1$export$b9b2bdc2d0ed93f8 = ({ order: order, orderBy: orderBy, setOrder: setOrder, setOrderBy: setOrderBy })=>{
    const [rowsPerPage, setRowsPerPage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(5);
    const lastAutoPagedSelectionRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const navigate = (0, $3T949.useNavigate)();
    const [searchParams, setSearchParams] = (0, $fIsAN.useSearchParams)();
    const { setPageSMTP: setPageSMTP, pageSMTP: pageSMTP, smtpData: smtpData, setSmtpData: setSmtpData, setSelectedRowSMTP: setSelectedRowSMTP, setVideoClipLoadingSMTP: setVideoClipLoadingSMTP, getVideoURLSMTP: getVideoURLSMTP, smtpSite: smtpSite, userFiltersSMTP: userFiltersSMTP, groupIDSMTP: groupIDSMTP, smtpTableFilter: smtpTableFilter, setSmtpTableFilter: setSmtpTableFilter } = (0, $4G44R.useClipsStore)();
    // Reset page to 0 when showOnlyClipsWithAlerts changes
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setPageSMTP(0);
    }, [
        smtpTableFilter,
        setPageSMTP
    ]);
    const handleRequestSort = (event, property)=>{
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };
    const handleChangePage = (event, newPage)=>{
        setPageSMTP(newPage);
    };
    const handleChangeRowsPerPage = (event)=>{
        setRowsPerPage(parseInt(event.target.value, 10));
        setPageSMTP(0);
    };
    const handleRowClick = (row)=>{
        // Update all rows to set selected to false
        const updatedData = smtpData.map((item)=>({
                ...item,
                selected: false
            }));
        // Find and update the clicked row to set selected to true
        const updatedDataWithSelection = updatedData.map((item)=>{
            if (item.clip_id === row.clip_id) return {
                ...item,
                selected: true
            };
            return item;
        });
        // Update the data in the store
        setSmtpData(updatedDataWithSelection);
        // Set the selected row and get video URL
        setVideoClipLoadingSMTP(true);
        setSelectedRowSMTP(row);
        getVideoURLSMTP(row.clip_id, navigate);
        localStorage.setItem("clipsSelectedRow", JSON.stringify(row));
        (0, $60d1d427e7f38222$export$d0ea5288e6803239)(setSearchParams, searchParams);
    };
    const filteredData = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>smtpTableFilter === "alerts" ? smtpData.filter((row)=>row.alerts && row.alerts.length > 0) : smtpTableFilter === "no_alerts" ? smtpData.filter((row)=>!row.alerts || row.alerts.length === 0) : smtpData, [
        smtpData,
        smtpTableFilter
    ]);
    const optionsArrayArray = [
        {
            name: "All Clips",
            value: "all"
        },
        {
            name: "Only Clips with Alerts",
            value: "alerts"
        },
        {
            name: "Only Clips without Alerts",
            value: "no_alerts"
        }
    ];
    const optionMaps = new Map();
    optionsArrayArray.forEach((option)=>{
        optionMaps.set(`${option.value}`, `${option.name}`);
    });
    const [anchorEl, setAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const emptyRows = pageSMTP > 0 ? Math.max(0, (1 + pageSMTP) * rowsPerPage - filteredData.length) : 0;
    const visibleRows = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>(0, $fWsn7.stableSort)(filteredData, (0, $fWsn7.getComparator)(order, orderBy)).slice(pageSMTP * rowsPerPage, pageSMTP * rowsPerPage + rowsPerPage), [
        filteredData,
        order,
        orderBy,
        pageSMTP,
        rowsPerPage
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        const sortedRows = (0, $fWsn7.stableSort)(filteredData, (0, $fWsn7.getComparator)(order, orderBy));
        const selectedIndex = sortedRows.findIndex((row)=>row.selected);
        const selectedClipId = selectedIndex >= 0 && sortedRows[selectedIndex]?.clip_id != null ? String(sortedRows[selectedIndex].clip_id) : null;
        const expectedPage = selectedIndex >= 0 ? Math.floor(selectedIndex / rowsPerPage) : 0;
        if (selectedClipId && selectedClipId !== lastAutoPagedSelectionRef.current && expectedPage !== pageSMTP) {
            lastAutoPagedSelectionRef.current = selectedClipId;
            setPageSMTP(expectedPage);
        }
    }, [
        filteredData,
        order,
        orderBy,
        pageSMTP,
        rowsPerPage,
        setPageSMTP
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4reBM.default), {
        sx: {
            width: "100%",
            overflow: "hidden",
            paddingBottom: "10px"
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3Nm8Z.default), {
                sx: {
                    maxHeight: 550
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "pl-[10px] pt-[5px] h-[30px] flex",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "text-[14px] pt-[7px]",
                                children: "FILTER BY"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "pl-[2px]",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                        id: "filter-button",
                                        "aria-controls": open ? "filter-menu" : undefined,
                                        "aria-haspopup": "true",
                                        "aria-expanded": open ? "true" : undefined,
                                        onClick: handleClick,
                                        children: optionMaps.get(smtpTableFilter)
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $1fWBE.default), {
                                        id: "filter-menu",
                                        anchorEl: anchorEl,
                                        open: open,
                                        onClose: handleClose,
                                        MenuListProps: {
                                            "aria-labelledby": "filter-button"
                                        },
                                        children: optionsArrayArray.map((option)=>{
                                            return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                onClick: ()=>{
                                                    setSmtpTableFilter(option.value);
                                                    const filteredData = option.value === "alerts" ? smtpData.filter((row)=>row.alerts && row.alerts.length > 0) : option.value === "no_alerts" ? smtpData.filter((row)=>!row.alerts || row.alerts.length === 0) : smtpData;
                                                    handleRowClick(filteredData[0]);
                                                    handleClose();
                                                },
                                                children: option.name
                                            }, option.value);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "pl-[1px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                    title: `Note: In certain cases, multiple clips may be associated to the same alert. This may explain a difference in count between the number of "Only Clips with Alerts" and the number of alerts on the Alerts/Analytics pages of our UI."`,
                                    placement: "top",
                                    sx: {
                                        fontSize: "10px",
                                        fontFamily: "mulish"
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                        fontSize: "small"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                        sx: {
                            fontFamily: "Mulish",
                            postion: "absolute"
                        },
                        "aria-labelledby": "clips-table",
                        stickyHeader: true,
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ebd0ca41d384a9c1$export$b05db259568e62d2), {
                                onRequestSort: handleRequestSort,
                                orderBy: orderBy,
                                order: order
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $gXvgZ.default), {
                                children: [
                                    visibleRows.map((row)=>{
                                        let sx = {
                                            cursor: "pointer"
                                        };
                                        if (row.selected) sx = {
                                            cursor: "pointer",
                                            backgroundColor: "rgba(2, 136, 209, 0.2)"
                                        };
                                        return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                            hover: true,
                                            onClick: ()=>handleRowClick(row),
                                            tabIndex: -1,
                                            sx: sx,
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    sx: {
                                                        fontSize: "10px",
                                                        fontFamily: "mulish",
                                                        width: "20%",
                                                        wordBreak: "break-word",
                                                        overflowWrap: "break-word"
                                                    },
                                                    children: smtpSite.site_name
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    sx: {
                                                        fontSize: "10px",
                                                        fontFamily: "mulish",
                                                        width: "20%",
                                                        wordBreak: "break-word",
                                                        overflowWrap: "break-word"
                                                    },
                                                    children: row.camera_name
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    sx: {
                                                        fontSize: "10px",
                                                        fontFamily: "mulish",
                                                        width: "20%",
                                                        wordBreak: "break-word",
                                                        overflowWrap: "break-word"
                                                    },
                                                    children: row.local_time_received ? (0, $c0433b3a957ff718$export$b72c7c7112e7208b)(row.local_time_received) : ""
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    sx: {
                                                        fontSize: "10px",
                                                        fontFamily: "mulish",
                                                        width: "20%",
                                                        wordBreak: "break-word",
                                                        overflowWrap: "break-word"
                                                    },
                                                    children: row.local_time_received ? (0, $c0433b3a957ff718$export$a42f1efec9282da9)(row.local_time_received) : ""
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    sx: {
                                                        fontSize: "10px",
                                                        fontFamily: "mulish",
                                                        width: "20%",
                                                        wordBreak: "break-word",
                                                        overflowWrap: "break-word"
                                                    },
                                                    children: row.clip_id
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    sx: {
                                                        fontSize: "10px",
                                                        fontFamily: "mulish",
                                                        width: "10%"
                                                    },
                                                    children: row.armed ? (0, $lWchQ.checkedCircleIconSmall) : (0, $2aMB5.cancelIconRedSmall)
                                                })
                                            ]
                                        }, row.id);
                                    }),
                                    emptyRows > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                        style: {
                                            height: 53 * emptyRows
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            colSpan: 6
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "absolute pt-[12px] pl-[5px] z-20 flex",
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "pl-[8px] flex",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                            theme: $e6023089cddb5cf1$var$theme,
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                type: "button",
                                color: "primary",
                                size: "small",
                                onClick: ()=>{
                                    const navigationString = (0, $f20a59a7d5a09462$export$a6af2821505a7b50)(userFiltersSMTP, groupIDSMTP, "alerts");
                                    window.open(`/alerts?${navigationString}`, "_blank");
                                },
                                disabled: false,
                                className: "hover:bg-[#E67300]",
                                children: "See Alerts"
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "pl-[8px]",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                                theme: $e6023089cddb5cf1$var$theme,
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                    type: "button",
                                    color: "primary",
                                    size: "small",
                                    onClick: ()=>{
                                        const navigationString = (0, $f20a59a7d5a09462$export$a6af2821505a7b50)(userFiltersSMTP, groupIDSMTP, "analytics");
                                        window.open(`/analytics?${navigationString}`, "_blank");
                                    },
                                    disabled: false,
                                    className: "hover:bg-[#E67300]",
                                    children: "See Analytics"
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wcxl.default), {
                rowsPerPageOptions: [
                    5,
                    10,
                    25
                ],
                component: "div",
                count: filteredData.length,
                rowsPerPage: rowsPerPage,
                page: pageSMTP,
                onPageChange: handleChangePage,
                onRowsPerPageChange: handleChangeRowsPerPage
            })
        ]
    });
};




var $60vL1 = parcelRequire("60vL1");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

var $8jTCz = parcelRequire("8jTCz");

var $frXOV = parcelRequire("frXOV");

var $2qUoo = parcelRequire("2qUoo");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
var $fIsAN = parcelRequire("fIsAN");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $4G44R = parcelRequire("4G44R");

var $8jTCz = parcelRequire("8jTCz");

var $gfzcx = parcelRequire("gfzcx");
const $ed7ae02543c13356$export$bc599e2fa6706c40 = ()=>{
    const { selectedRowAlertsSMTP: selectedRowAlertsSMTP } = (0, $4G44R.useClipsStore)();
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $4reBM.default), {
        sx: {
            width: 450,
            overflow: "hidden"
        },
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                sx: {
                    "& .MuiTableCell-root": {
                        padding: "4px 16px"
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponentSmallerText), {
                        titlesArray: [
                            "Alert",
                            ""
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                        children: selectedRowAlertsSMTP.length === 0 ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                colSpan: 2,
                                align: "center",
                                children: "No Alerts for selected clip"
                            })
                        }) : selectedRowAlertsSMTP.map((alert)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        sx: {
                                            textTransform: "capitalize"
                                        },
                                        children: alert.label
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        align: "center",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                            text: "See Alert",
                                            onClick: ()=>{
                                                if (alert.url) window.open(alert.url, "_blank", "noopener,noreferrer");
                                            },
                                            disabled: !alert.url
                                        })
                                    })
                                ]
                            }, alert.custcam_id))
                    })
                ]
            })
        })
    });
};



var $fWsn7 = parcelRequire("fWsn7");
const $82f230f1f245ffb6$export$db51bd49681472dd = (smtpData, filteredData, selectedRowSMTP, directionString, setSelectedRowSMTP, setSmtpData, setVideoClipLoadingSMTP, navigate, order, orderBy, getVideoURLSMTP, onRowChange)=>{
    // Get the sorted filtered data (same as what's displayed in the table)
    const sortedData = (0, $fWsn7.stableSort)(filteredData, (0, $fWsn7.getComparator)(order, orderBy));
    // Find the current selected row index in the sorted data
    const currentIndex = sortedData.findIndex((item)=>item.clip_id === selectedRowSMTP.clip_id);
    // Check if we can move in the requested direction
    const canMoveForward = directionString === "forward" && currentIndex < sortedData.length - 1;
    const canMoveBackward = directionString === "back" && currentIndex > 0;
    if (canMoveForward || canMoveBackward) {
        setVideoClipLoadingSMTP(true);
        // Determine the new selected row
        let newSelectedRow;
        if (directionString === "forward") newSelectedRow = sortedData[currentIndex + 1];
        else newSelectedRow = sortedData[currentIndex - 1];
        // Update the selected row
        setSelectedRowSMTP(newSelectedRow);
        localStorage.setItem("clipsSelectedRow", JSON.stringify(newSelectedRow));
        onRowChange?.(newSelectedRow);
        // Update the data to reflect the new selection
        const updatedSmtpData = smtpData.map((item)=>({
                ...item,
                selected: item.clip_id === newSelectedRow.clip_id
            }));
        setSmtpData(updatedSmtpData);
        // Use the existing getVideoURLSMTP function from the store
        // This will handle the API call and set the appropriate video/photo URLs
        getVideoURLSMTP(newSelectedRow.clip_id, navigate);
    }
};


/* eslint-disable jsx-a11y/media-has-caption */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");



var $4G44R = parcelRequire("4G44R");

var $8jTCz = parcelRequire("8jTCz");
var $1ae3d8eb0e22e7c8$exports = {};
"use strict";
Object.defineProperty($1ae3d8eb0e22e7c8$exports, "__esModule", {
    value: true
});
$1ae3d8eb0e22e7c8$exports["default"] = void 0;

var $1ae3d8eb0e22e7c8$var$_slider = $1ae3d8eb0e22e7c8$var$_interopRequireDefault((parcelRequire("6JVXJ")));
function $1ae3d8eb0e22e7c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $1ae3d8eb0e22e7c8$var$_default = $1ae3d8eb0e22e7c8$exports["default"] = $1ae3d8eb0e22e7c8$var$_slider["default"];


var $d5391b1a0745592e$require$Slider = $1ae3d8eb0e22e7c8$exports.default;
const $d5391b1a0745592e$export$adb5ee38cdd8685a = ()=>{
    const [currentSlide, setCurrentSlide] = (0, $8T3gX.useState)(0);
    const sliderRef = (0, $8T3gX.useRef)(null);
    const { selectedClipSMTPMedia: selectedClipSMTPMedia } = (0, $4G44R.useClipsStore)();
    const handleDownload = (media)=>{
        if (media.url) {
            const link = document.createElement("a");
            link.href = media.url;
            link.download = media.filename || "download";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };
    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        beforeChange: (current, next)=>setCurrentSlide(next)
    };
    let mediaWithURLs = 0;
    selectedClipSMTPMedia.forEach((media)=>{
        if (media.url) mediaWithURLs++;
    });
    const totalSlides = mediaWithURLs; // Since you have 3 slides
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        style: {
            position: "relative",
            display: "flex",
            flexDirection: "column"
        },
        children: [
            totalSlides > 1 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                style: {
                    position: "absolute",
                    top: "-25px",
                    left: "50%",
                    transform: "translateX(-170%)",
                    zIndex: 10,
                    display: "flex",
                    gap: "10px"
                },
                children: Array.from({
                    length: totalSlides
                }).map((_, index)=>/*#__PURE__*/ (0, $k4ank.jsx)("button", {
                        style: {
                            width: "10px",
                            height: "10px",
                            borderRadius: "50%",
                            border: "none",
                            backgroundColor: currentSlide === index ? "#333" : "#ccc",
                            cursor: "pointer",
                            padding: "0",
                            margin: "0"
                        },
                        onClick: ()=>{
                            setCurrentSlide(index);
                            sliderRef.current?.slickGoTo(index);
                        }
                    }, index))
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)($d5391b1a0745592e$require$Slider, {
                ref: sliderRef,
                ...settings,
                children: selectedClipSMTPMedia.map((media, index)=>media.filename.includes("jpg") && media.url ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                                width: "450",
                                src: media.url,
                                alt: "clip"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                style: {
                                    marginTop: "10px"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    onClick: ()=>handleDownload(media),
                                    text: "Download Image",
                                    disabled: false
                                })
                            })
                        ]
                    }, index) : (media.filename.includes("mp4") || media.filename.includes("mkv")) && media.url ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)("video", {
                                width: "450",
                                autoPlay: true,
                                controls: true,
                                loop: true,
                                onError: (e)=>{
                                    console.error("Video playback error:", e);
                                },
                                children: [
                                    media.filename.includes("mkv") ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)("source", {
                                                src: media.url,
                                                type: "video/x-matroska"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("source", {
                                                src: media.url,
                                                type: "video/mkv"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("source", {
                                                src: media.url
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)("source", {
                                        src: media.url,
                                        type: "video/mp4"
                                    }),
                                    "Your browser does not support the video tag or this video format."
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                style: {
                                    marginTop: "10px"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    onClick: ()=>handleDownload(media),
                                    text: "Download Video",
                                    disabled: false
                                })
                            })
                        ]
                    }, index) : null)
            })
        ]
    });
};




const $3f9f1c29f4deaae4$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $3f9f1c29f4deaae4$export$91fa97cc40700815 = ({ navBarCollapsed: navBarCollapsed })=>{
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    const { selectedRowSMTP: selectedRowSMTP, fetchingFilteredDataSMTP: fetchingFilteredDataSMTP, loadingAdditionalDataSMTP: loadingAdditionalDataSMTP, videoClipLoadingSMTP: videoClipLoadingSMTP, smtpSite: smtpSite, smtpData: smtpData, setSmtpData: setSmtpData, setSelectedRowSMTP: setSelectedRowSMTP, setVideoClipLoadingSMTP: setVideoClipLoadingSMTP, getVideoURLSMTP: getVideoURLSMTP, smtpTableFilter: smtpTableFilter } = (0, $4G44R.useClipsStore)();
    const [order, setOrder] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("asc");
    const [orderBy, setOrderBy] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("formatted_date");
    const navigate = (0, $3T949.useNavigate)();
    const [searchParams, setSearchParams] = (0, $fIsAN.useSearchParams)();
    // Calculate filtered data (same logic as in SMTPTable)
    const filteredData = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>smtpTableFilter === "alerts" ? smtpData.filter((row)=>row.alerts && row.alerts.length > 0) : smtpTableFilter === "no_alerts" ? smtpData.filter((row)=>!row.alerts || row.alerts.length === 0) : smtpData, [
        smtpData,
        smtpTableFilter
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: navBarCollapsed ? userPermissions.sentinel || userPermissions.ailink ? "relative left-[75px] top-[150px] w-[600px]" : "relative left-[75px] top-[90px] w-[600px]" : userPermissions.sentinel || userPermissions.ailink ? "relative left-[150px] top-[150px] w-[600px]" : "relative left-[150px] top-[90px] w-[600px]",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                className: "relative left-[20px] top-[15px] text-actuate-blue font-mulish text-[20px]",
                children: [
                    smtpSite.site_name ? (0, $a17e6a81e499c7af$export$d6488c46934633a3)(smtpSite.site_name, smtpSite.site_id) : "",
                    " ",
                    "|",
                    " ",
                    (0, $33b4b9464ea6ea5e$export$f28ee0a44f93351f)(selectedRowSMTP.camera_name, smtpSite.site_id, selectedRowSMTP.camera_id),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex pt-[20px] pl-[10px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        children: !fetchingFilteredDataSMTP && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: !navBarCollapsed ? "w-[745px]" : "w-[815px]",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $e6023089cddb5cf1$export$b9b2bdc2d0ed93f8), {
                                            order: order,
                                            orderBy: orderBy,
                                            setOrder: setOrder,
                                            setOrderBy: setOrderBy
                                        })
                                    }),
                                    loadingAdditionalDataSMTP && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "relative pt-[5px]",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "relative left-[10px]",
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $851fcbe833f3eb8b$export$b08b517936747730), {})
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "absolute left-[58px] top-[7px] font-mulish text-actuate-orange",
                                                children: "Loading Additional Data"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "w-[660px]",
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "w-[660px]",
                                children: [
                                    !videoClipLoadingSMTP && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "absolute left-[760px] top-[200px] z-10",
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                    onClick: ()=>{
                                                        (0, $82f230f1f245ffb6$export$db51bd49681472dd)(smtpData, filteredData, selectedRowSMTP, "back", setSelectedRowSMTP, setSmtpData, setVideoClipLoadingSMTP, navigate, order, orderBy, getVideoURLSMTP, ()=>(0, $60d1d427e7f38222$export$d0ea5288e6803239)(setSearchParams, searchParams));
                                                    },
                                                    text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($frXOV))), {
                                                        fontSize: "large",
                                                        id: "BackButton"
                                                    }),
                                                    disabled: filteredData.length === 0 || filteredData.findIndex((item)=>item.clip_id === selectedRowSMTP.clip_id) === 0
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "absolute left-[1270px] top-[200px] z-10",
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                    onClick: ()=>{
                                                        (0, $82f230f1f245ffb6$export$db51bd49681472dd)(smtpData, filteredData, selectedRowSMTP, "forward", setSelectedRowSMTP, setSmtpData, setVideoClipLoadingSMTP, navigate, order, orderBy, getVideoURLSMTP, ()=>(0, $60d1d427e7f38222$export$d0ea5288e6803239)(setSearchParams, searchParams));
                                                    },
                                                    text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2qUoo))), {
                                                        fontSize: "large",
                                                        id: "forwardButton"
                                                    }),
                                                    disabled: filteredData.length === 0 || filteredData.findIndex((item)=>item.clip_id === selectedRowSMTP.clip_id) === filteredData.length - 1
                                                })
                                            }),
                                            selectedRowSMTP.armed && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                className: "pl-[65px]",
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "pb-[10px]",
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $42175367ea4c1e61$export$d994c77890cfb1f4), {
                                                            tab: "smtp",
                                                            selectedRow: selectedRowSMTP
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $d5391b1a0745592e$export$adb5ee38cdd8685a), {}),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "pt-[10px] pb-[10px]",
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ed7ae02543c13356$export$bc599e2fa6706c40), {})
                                                    })
                                                ]
                                            }),
                                            !selectedRowSMTP.armed && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                className: "absolute left-[785px] top-[190px] text-center w-[500px]",
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "pb-[10px]",
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $42175367ea4c1e61$export$d994c77890cfb1f4), {
                                                            tab: "smtp",
                                                            selectedRow: selectedRowSMTP
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                        className: "font-mulish text-[22px]",
                                                        children: "Site was not armed."
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                        className: "font-mulish text-[22px]",
                                                        children: "No files to display."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        children: videoClipLoadingSMTP && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "absolute left-[785px] top-[190px] text-center w-[500px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $b9p11.default), {
                                                theme: $3f9f1c29f4deaae4$var$theme,
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                                            color: "primary"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                        className: "font-mulish text-[20px]",
                                                        children: "Loading..."
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $aYdit = parcelRequire("aYdit");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $60vL1 = parcelRequire("60vL1");
var $eejVe = parcelRequire("eejVe");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $4G44R = parcelRequire("4G44R");
const $3a3ab98e6fa0a92a$export$667924892c714a29 = ({ navBarCollapsed: navBarCollapsed })=>{
    const { groupOptionsSMTP: groupOptionsSMTP, userDropDownValueSMTP: userDropDownValueSMTP, setUserDropDownValueSMTP: setUserDropDownValueSMTP, setCameraDropDownValueSMTP: setCameraDropDownValueSMTP, setGroupIDSMTP: setGroupIDSMTP, setSiteDropDownValueSMTP: setSiteDropDownValueSMTP, setSiteOptionsSMTP: setSiteOptionsSMTP, setUserFiltersSMTP: setUserFiltersSMTP, getAllSitesClipsSMTP: getAllSitesClipsSMTP, setCameraOptionsSMTP: setCameraOptionsSMTP, loadingGroupsSMTP: loadingGroupsSMTP, getDownloadURLSMTP: getDownloadURLSMTP, setDownloadURLSMTP: setDownloadURLSMTP } = (0, $4G44R.useClipsStore)();
    const navigate = (0, $3T949.useNavigate)();
    // Create a Set to track unique names and ensure we only add each name once
    const uniqueNames = new Set();
    const options = [];
    const optionUserIds = new Map();
    const allGroupOptions = JSON.parse(localStorage.parentAccounts);
    // First pass: collect unique names and their corresponding IDs
    (allGroupOptions || []).forEach((object)=>{
        // if (object.group) {
        if (!uniqueNames.has(object.name)) {
            uniqueNames.add(object.name);
            options.push(object.name);
            optionUserIds.set(object.name, object.id);
        }
    // }
    });
    const optionUserNames = new Map();
    // Second pass: populate optionUserNames (this could be the same as optionUserIds)
    (allGroupOptions || []).forEach((object)=>{
        // if (object.group) {
        optionUserNames.set(object.name, object.id);
    // }
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            value: userDropDownValueSMTP,
            disablePortal: true,
            options: options,
            onChange: (event, value)=>{
                if (value !== null) {
                    setUserDropDownValueSMTP(value);
                    setCameraDropDownValueSMTP(null);
                    setGroupIDSMTP(optionUserIds.get(value));
                    setSiteDropDownValueSMTP(null);
                    setSiteOptionsSMTP([]);
                    getAllSitesClipsSMTP(optionUserIds.get(value), navigate);
                    setUserFiltersSMTP((previousState)=>{
                        return {
                            ...previousState,
                            user: optionUserNames.get(value),
                            group_id: optionUserIds.get(value),
                            site_ids: [],
                            camera_ids: []
                        };
                    });
                    getDownloadURLSMTP(navigate);
                } else {
                    // setFetchingFilteredData(true);
                    setUserDropDownValueSMTP(value);
                    setSiteDropDownValueSMTP(null);
                    setSiteOptionsSMTP([]);
                    setCameraDropDownValueSMTP(null);
                    setCameraOptionsSMTP([]);
                    setUserFiltersSMTP((previousState)=>{
                        return {
                            ...previousState,
                            user: "testuser",
                            group_id: null,
                            site_ids: [],
                            camera_ids: []
                        };
                    });
                    setDownloadURLSMTP("");
                }
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    label: "Group",
                    InputProps: {
                        ...params.InputProps,
                        endAdornment: /*#__PURE__*/ (0, $k4ank.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                            children: [
                                loadingGroupsSMTP ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                    color: "inherit",
                                    size: 20
                                }) : null,
                                params.InputProps.endAdornment
                            ]
                        })
                    },
                    autoComplete: "off",
                    helperText: "*Required",
                    sx: !navBarCollapsed ? {
                        width: 150
                    } : {
                        width: 175
                    }
                })
        })
    }, "user_dropdown_smtp");
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $60vL1 = parcelRequire("60vL1");
var $eejVe = parcelRequire("eejVe");

var $4G44R = parcelRequire("4G44R");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $4c2f987196a0448f$export$b0d439d45b9fcb58 = ({ showUserDropDown: showUserDropDown, navBarCollapsed: navBarCollapsed })=>{
    const navigate = (0, $3T949.useNavigate)();
    const { siteOptionsSMTP: siteOptionsSMTP, siteDropDownValueSMTP: siteDropDownValueSMTP, setSiteDropDownValueSMTP: setSiteDropDownValueSMTP, setCameraDropDownValueSMTP: setCameraDropDownValueSMTP, setUserFiltersSMTP: setUserFiltersSMTP, setCameraOptionsSMTP: setCameraOptionsSMTP, loadingSitesSMTP: loadingSitesSMTP, getCamerasBySiteSMTP: getCamerasBySiteSMTP, getDownloadURLSMTP: getDownloadURLSMTP, getSiteTimeZone: getSiteTimeZone } = (0, $4G44R.useClipsStore)();
    const siteIds = new Map();
    (siteOptionsSMTP || []).forEach((object)=>{
        siteIds.set(object.name, object.id);
    });
    // Create a Set to track unique names and ensure we only add each name once
    const uniqueNames = new Set();
    const options = [];
    // First pass: collect unique names
    (siteOptionsSMTP || []).forEach((object)=>{
        if (!uniqueNames.has(object.name)) {
            uniqueNames.add(object.name);
            options.push(object.name);
        }
    });
    let sx;
    if (showUserDropDown && navBarCollapsed) sx = {
        width: 175
    };
    if (showUserDropDown && !navBarCollapsed) sx = {
        width: 150
    };
    if (!showUserDropDown && navBarCollapsed) sx = {
        width: 240
    };
    if (!showUserDropDown && !navBarCollapsed) sx = {
        width: 200
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            value: siteDropDownValueSMTP,
            disablePortal: true,
            options: options,
            loading: loadingSitesSMTP,
            onChange: (event, value)=>{
                if (value !== null) {
                    const id = siteIds.get(value);
                    getSiteTimeZone(id, navigate);
                    setSiteDropDownValueSMTP(value);
                    setCameraDropDownValueSMTP(null);
                    getCamerasBySiteSMTP([
                        id
                    ], navigate);
                    setUserFiltersSMTP((previousState)=>{
                        return {
                            ...previousState,
                            site_ids: [
                                siteIds.get(value)
                            ],
                            camera_ids: []
                        };
                    });
                } else {
                    setSiteDropDownValueSMTP(value);
                    setCameraDropDownValueSMTP(null);
                    setCameraOptionsSMTP([]);
                    setUserFiltersSMTP((previousState)=>{
                        return {
                            ...previousState,
                            site_ids: [],
                            camera_ids: []
                        };
                    });
                }
                getDownloadURLSMTP(navigate);
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    label: "Site",
                    InputProps: {
                        ...params.InputProps,
                        endAdornment: /*#__PURE__*/ (0, $k4ank.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                            children: [
                                loadingSitesSMTP ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                    color: "inherit",
                                    size: 20
                                }) : null,
                                params.InputProps.endAdornment
                            ]
                        })
                    },
                    helperText: "*Required",
                    autoComplete: "off",
                    sx: sx
                })
        })
    }, "site_dropdown_smtp");
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $60vL1 = parcelRequire("60vL1");
var $eejVe = parcelRequire("eejVe");

var $4G44R = parcelRequire("4G44R");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $7c1e9a14e9efad48$export$1613e6d5f2867a88 = ({ showUserDropDown: showUserDropDown, navBarCollapsed: navBarCollapsed })=>{
    const navigate = (0, $3T949.useNavigate)();
    const { cameraOptionsSMTP: cameraOptionsSMTP, siteOptionsSMTP: siteOptionsSMTP, cameraDropDownValueSMTP: cameraDropDownValueSMTP, setCameraDropDownValueSMTP: setCameraDropDownValueSMTP, setUserFiltersSMTP: setUserFiltersSMTP, loadingCamerasSMTP: loadingCamerasSMTP, getDownloadURLSMTP: getDownloadURLSMTP } = (0, $4G44R.useClipsStore)();
    const cameraIds = new Map();
    (cameraOptionsSMTP || []).forEach((object)=>{
        cameraIds.set(object.camera_name, object.id);
    });
    const siteIds = new Map();
    (siteOptionsSMTP || []).forEach((object)=>{
        siteIds.set(object.name, object.id);
    });
    // Create a Set to track unique camera names and ensure we only add each name once
    const uniqueCameraNames = new Set();
    const options = [];
    // First pass: collect unique camera names
    (cameraOptionsSMTP || []).forEach((object)=>{
        if (!uniqueCameraNames.has(object.camera_name)) {
            uniqueCameraNames.add(object.camera_name);
            options.push(object.camera_name);
        }
    });
    let sx;
    if (showUserDropDown && navBarCollapsed) sx = {
        width: 175
    };
    if (showUserDropDown && !navBarCollapsed) sx = {
        width: 150
    };
    if (!showUserDropDown && navBarCollapsed) sx = {
        width: 235
    };
    if (!showUserDropDown && !navBarCollapsed) sx = {
        width: 200
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            value: cameraDropDownValueSMTP,
            disablePortal: true,
            options: options,
            loading: loadingCamerasSMTP,
            onChange: (event, value)=>{
                if (value !== null) {
                    setCameraDropDownValueSMTP(value);
                    setUserFiltersSMTP((previousState)=>{
                        return {
                            ...previousState,
                            camera_ids: [
                                cameraIds.get(value)
                            ]
                        };
                    });
                } else {
                    setCameraDropDownValueSMTP(value);
                    setUserFiltersSMTP((previousState)=>{
                        return {
                            ...previousState,
                            camera_ids: []
                        };
                    });
                }
                getDownloadURLSMTP(navigate);
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    label: "Camera",
                    InputProps: {
                        ...params.InputProps,
                        endAdornment: /*#__PURE__*/ (0, $k4ank.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                            children: [
                                loadingCamerasSMTP ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                    color: "inherit",
                                    size: 20
                                }) : null,
                                params.InputProps.endAdornment
                            ]
                        })
                    },
                    autoComplete: "off",
                    sx: sx
                })
        })
    }, "camera_dropdown_smtp");
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $hfM8m = parcelRequire("hfM8m");

var $hwWkD = parcelRequire("hwWkD");


var $eejVe = parcelRequire("eejVe");

var $5L5iJ = parcelRequire("5L5iJ");

var $iKAtE = parcelRequire("iKAtE");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");

var $i5MAs = parcelRequire("i5MAs");

var $aYdit = parcelRequire("aYdit");

var $jgags = parcelRequire("jgags");

var $4G44R = parcelRequire("4G44R");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $6dba515c8d2597e1$export$ca0e08940fb7108e = (startDateStr, endDateStr)=>{
    if (!startDateStr || !endDateStr) return false;
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);
    // Normalize dates to midnight to avoid time-of-day issues
    const startDateNormalized = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    const endDateNormalized = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
    const diffMs = endDateNormalized.getTime() - startDateNormalized.getTime();
    const diffDays = diffMs / 86400000;
    // Both types check for > 7 days (i.e., >= 8 days) to match "no more than 7 days" rule
    // 7 days is allowed, 8+ days should be flagged
    return diffDays > 7;
};


const $162379642460cee8$export$c3b7d0014653a60d = ()=>{
    const { userFiltersSMTP: userFiltersSMTP, setUserFiltersSMTP: setUserFiltersSMTP, setTimeFiltersDisabledSMTP: setTimeFiltersDisabledSMTP, getDownloadURLSMTP: getDownloadURLSMTP } = (0, $4G44R.useClipsStore)();
    const navigate = (0, $3T949.useNavigate)();
    const [startTimeAnchorEl, setStartTimeAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const startTimeOpen = Boolean(startTimeAnchorEl);
    const handleStartTimeClick = (event)=>{
        setStartTimeAnchorEl(event.currentTarget);
    };
    const handleStartTimeClose = (event)=>{
        event.stopPropagation();
        setStartTimeAnchorEl(null);
    };
    const { dateMMDDYYYY: dateMMDDYYYY, setDateMMDDYYYY: setDateMMDDYYYY } = (0, $aYdit.useAppStore)();
    const selectedLocale = dateMMDDYYYY ? (0, $jgags.default) : (0, $253608f850203ed2$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
        dateAdapter: (0, $hfM8m.AdapterDateFns),
        adapterLocale: selectedLocale,
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cbaf068f14972fdf$export$5109c6dd95d8fb00), {
            label: userFiltersSMTP.start_date ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                        children: "Start Date"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                "aria-label": "more",
                                id: "long-button",
                                "aria-controls": startTimeOpen ? "long-menu" : undefined,
                                "aria-expanded": startTimeOpen ? "true" : undefined,
                                "aria-haspopup": "true",
                                onClick: handleStartTimeClick,
                                sx: {
                                    marginLeft: "5px",
                                    padding: 0,
                                    color: "#000000",
                                    "&:hover": {
                                        backgroundColor: "transparent"
                                    }
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5MAs))), {})
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                                id: "long-menu",
                                MenuListProps: {
                                    "aria-labelledby": "long-button"
                                },
                                anchorOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                anchorEl: startTimeAnchorEl,
                                open: startTimeOpen,
                                onClose: handleStartTimeClose,
                                slotProps: {
                                    paper: {
                                        style: {
                                            maxHeight: 216,
                                            width: "20ch"
                                        }
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: (event)=>{
                                            setDateMMDDYYYY(true);
                                            handleStartTimeClose(event);
                                        },
                                        children: "MM/DD/YYYY"
                                    }, "mm-dd-yyyy-start"),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: (event)=>{
                                            setDateMMDDYYYY(false);
                                            handleStartTimeClose(event);
                                        },
                                        children: "DD/MM/YYYY"
                                    }, "dd-mm-yyyy-start")
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                children: "Start Date"
            }),
            value: userFiltersSMTP.start_date,
            onChange: (newValue)=>{
                if ((0, $6dba515c8d2597e1$export$ca0e08940fb7108e)(newValue, userFiltersSMTP.end_date)) {
                    alert("Start date can be no more than 7 days before end date");
                    return;
                }
                if (newValue !== null) setUserFiltersSMTP((previousState)=>({
                        ...previousState,
                        start_date: newValue
                    }));
                if (newValue === null) setUserFiltersSMTP((previousState)=>({
                        ...previousState,
                        start_date: null
                    }));
                if ((0, $5L5iJ.yyyymmddGenerator)(newValue) !== (0, $5L5iJ.yyyymmddGenerator)(userFiltersSMTP.end_date)) {
                    setTimeFiltersDisabledSMTP(true);
                    setUserFiltersSMTP((previousState)=>({
                            ...previousState,
                            start_time: null,
                            end_time: null
                        }));
                }
                if ((0, $5L5iJ.yyyymmddGenerator)(newValue) === (0, $5L5iJ.yyyymmddGenerator)(userFiltersSMTP.end_date)) setTimeFiltersDisabledSMTP(false);
                getDownloadURLSMTP(navigate);
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    sx: {
                        width: 150
                    },
                    ...params
                })
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $hfM8m = parcelRequire("hfM8m");

var $hwWkD = parcelRequire("hwWkD");


var $eejVe = parcelRequire("eejVe");

var $5L5iJ = parcelRequire("5L5iJ");

var $iKAtE = parcelRequire("iKAtE");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");

var $i5MAs = parcelRequire("i5MAs");

var $aYdit = parcelRequire("aYdit");

var $jgags = parcelRequire("jgags");

var $4G44R = parcelRequire("4G44R");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

const $f43fa27f5e0b7840$export$2ca3403463ce7054 = ()=>{
    const { userFiltersSMTP: userFiltersSMTP, setUserFiltersSMTP: setUserFiltersSMTP, setTimeFiltersDisabledSMTP: setTimeFiltersDisabledSMTP, getDownloadURLSMTP: getDownloadURLSMTP } = (0, $4G44R.useClipsStore)();
    const navigate = (0, $3T949.useNavigate)();
    const [endTimeAnchorEl, setEndTimeAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const endTimeOpen = Boolean(endTimeAnchorEl);
    const handleEndTimeClick = (event)=>{
        setEndTimeAnchorEl(event.currentTarget);
    };
    const handleEndTimeClose = (event)=>{
        event.stopPropagation();
        setEndTimeAnchorEl(null);
    };
    const { dateMMDDYYYY: dateMMDDYYYY, setDateMMDDYYYY: setDateMMDDYYYY } = (0, $aYdit.useAppStore)();
    const selectedLocale = dateMMDDYYYY ? (0, $jgags.default) : (0, $253608f850203ed2$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
        dateAdapter: (0, $hfM8m.AdapterDateFns),
        adapterLocale: selectedLocale,
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cbaf068f14972fdf$export$5109c6dd95d8fb00), {
            label: userFiltersSMTP.end_date ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                        children: "End Date"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                "aria-label": "more",
                                id: "long-button",
                                "aria-controls": endTimeOpen ? "long-menu" : undefined,
                                "aria-expanded": endTimeOpen ? "true" : undefined,
                                "aria-haspopup": "true",
                                onClick: handleEndTimeClick,
                                sx: {
                                    marginLeft: "5px",
                                    padding: 0,
                                    color: "#000000",
                                    "&:hover": {
                                        backgroundColor: "transparent"
                                    }
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5MAs))), {})
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                                id: "long-menu",
                                MenuListProps: {
                                    "aria-labelledby": "long-button"
                                },
                                anchorOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                anchorEl: endTimeAnchorEl,
                                open: endTimeOpen,
                                onClose: handleEndTimeClose,
                                slotProps: {
                                    paper: {
                                        style: {
                                            maxHeight: 216,
                                            width: "20ch"
                                        }
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: (event)=>{
                                            setDateMMDDYYYY(true);
                                            handleEndTimeClose(event);
                                        },
                                        children: "MM/DD/YYYY"
                                    }, "mm-dd-yyyy-end"),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: (event)=>{
                                            setDateMMDDYYYY(false);
                                            handleEndTimeClose(event);
                                        },
                                        children: "DD/MM/YYYY"
                                    }, "dd-mm-yyyy-end")
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                children: "End Date"
            }),
            value: userFiltersSMTP.end_date,
            onChange: (newValue)=>{
                if ((0, $6dba515c8d2597e1$export$ca0e08940fb7108e)(userFiltersSMTP.start_date, newValue)) {
                    alert("End date can be no more than 7 days after start date");
                    return;
                }
                if (newValue !== null) setUserFiltersSMTP((previousState)=>({
                        ...previousState,
                        end_date: newValue
                    }));
                if (newValue === null) setUserFiltersSMTP((previousState)=>({
                        ...previousState,
                        end_date: null
                    }));
                if ((0, $5L5iJ.yyyymmddGenerator)(newValue) !== (0, $5L5iJ.yyyymmddGenerator)(userFiltersSMTP.start_date)) {
                    setTimeFiltersDisabledSMTP(true);
                    setUserFiltersSMTP((previousState)=>({
                            ...previousState,
                            start_time: null,
                            end_time: null
                        }));
                }
                if ((0, $5L5iJ.yyyymmddGenerator)(newValue) === (0, $5L5iJ.yyyymmddGenerator)(userFiltersSMTP.start_date)) setTimeFiltersDisabledSMTP(false);
                getDownloadURLSMTP(navigate);
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    sx: {
                        width: 150
                    },
                    ...params
                })
        })
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eejVe = parcelRequire("eejVe");
var $cVCJe = parcelRequire("cVCJe");

var $hwWkD = parcelRequire("hwWkD");

var $a50J4 = parcelRequire("a50J4");

var $hfM8m = parcelRequire("hfM8m");

var $4G44R = parcelRequire("4G44R");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

const $70429021eeca4e0e$export$a3aa29b97247d908 = ()=>{
    const { userFiltersSMTP: userFiltersSMTP, setUserFiltersSMTP: setUserFiltersSMTP, timeFiltersDisabledSMTP: timeFiltersDisabledSMTP, getDownloadURLSMTP: getDownloadURLSMTP } = (0, $4G44R.useClipsStore)();
    const navigate = (0, $3T949.useNavigate)();
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
        dateAdapter: (0, $hfM8m.AdapterDateFns),
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
            title: (0, $ffbec3bd61ee0d21$export$e5ad0d4cfb9b77f4),
            disableHoverListener: !timeFiltersDisabledSMTP,
            disableFocusListener: !timeFiltersDisabledSMTP,
            disableTouchListener: !timeFiltersDisabledSMTP,
            ...(0, $ffbec3bd61ee0d21$export$b1886b315cb3d290),
            children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                style: {
                    display: "inline-block"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a50J4.DesktopTimePicker), {
                    label: "Start Time",
                    value: userFiltersSMTP.start_time ? userFiltersSMTP.start_time : null,
                    onChange: (newValue)=>{
                        setUserFiltersSMTP((previousState)=>({
                                ...previousState,
                                start_time: newValue
                            }));
                        getDownloadURLSMTP(navigate);
                    },
                    disabled: timeFiltersDisabledSMTP,
                    renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                            ...params,
                            autoComplete: "off",
                            sx: {
                                width: 150
                            }
                        })
                })
            })
        })
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eejVe = parcelRequire("eejVe");
var $cVCJe = parcelRequire("cVCJe");

var $hwWkD = parcelRequire("hwWkD");

var $a50J4 = parcelRequire("a50J4");

var $hfM8m = parcelRequire("hfM8m");

var $4G44R = parcelRequire("4G44R");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

const $b753d730daf2e3b7$export$3df5db2f82f8c028 = ()=>{
    const { userFiltersSMTP: userFiltersSMTP, setUserFiltersSMTP: setUserFiltersSMTP, timeFiltersDisabledSMTP: timeFiltersDisabledSMTP, getDownloadURLSMTP: getDownloadURLSMTP } = (0, $4G44R.useClipsStore)();
    const navigate = (0, $3T949.useNavigate)();
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
        dateAdapter: (0, $hfM8m.AdapterDateFns),
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
            title: (0, $ffbec3bd61ee0d21$export$e5ad0d4cfb9b77f4),
            disableHoverListener: !timeFiltersDisabledSMTP,
            disableFocusListener: !timeFiltersDisabledSMTP,
            disableTouchListener: !timeFiltersDisabledSMTP,
            ...(0, $ffbec3bd61ee0d21$export$b1886b315cb3d290),
            children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                style: {
                    display: "inline-block"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a50J4.DesktopTimePicker), {
                    label: "End Time",
                    value: userFiltersSMTP.end_time ? userFiltersSMTP.end_time : null,
                    onChange: (newValue)=>{
                        setUserFiltersSMTP((previousState)=>({
                                ...previousState,
                                end_time: newValue
                            }));
                        getDownloadURLSMTP(navigate);
                    },
                    disabled: timeFiltersDisabledSMTP,
                    renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                            ...params,
                            autoComplete: "off",
                            sx: {
                                width: 150
                            }
                        })
                })
            })
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $a65wX = parcelRequire("a65wX");



var $eg2OC = parcelRequire("eg2OC");

var $6CjWJ = parcelRequire("6CjWJ");

var $4reBM = parcelRequire("4reBM");

var $cWqfz = parcelRequire("cWqfz");

var $cxknk = parcelRequire("cxknk");

var $eJK3E = parcelRequire("eJK3E");

var $4G44R = parcelRequire("4G44R");

const $4f15d0864d0e3e96$export$d2a9f4ca2a70474c = (props)=>{
    const { setSearchParams: setSearchParams } = props ?? {};
    const navigate = (0, $3T949.useNavigate)();
    const options = [
        "Apply Filters",
        "Download Report"
    ];
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const anchorRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const [option, setOption] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(options[0]);
    const { getSMTPData: getSMTPData, setFiltersAppliedSMTP: setFiltersAppliedSMTP, setFetchingFilteredDataSMTP: setFetchingFilteredDataSMTP, setPageSMTP: setPageSMTP, downloadURLSMTP: downloadURLSMTP, userFiltersSMTP: userFiltersSMTP, fetchingDownloadURLSMTP: fetchingDownloadURLSMTP, setSmtpTableFilter: setSmtpTableFilter } = (0, $4G44R.useClipsStore)();
    const handleClick = ()=>{
        if (option === "Apply Filters") {
            setSmtpTableFilter("all");
            setPageSMTP(0);
            setFiltersAppliedSMTP(true);
            setFetchingFilteredDataSMTP(true);
            getSMTPData(navigate);
            if (setSearchParams) (0, $60d1d427e7f38222$export$867258f8bab37ec)(setSearchParams, "smtp", userFiltersSMTP);
        }
    };
    const handleMenuItemClick = (event, index)=>{
        setOption(options[index]);
        setOpen(false);
    };
    const handleToggle = ()=>{
        setOpen((prevOpen)=>!prevOpen);
    };
    const handleClose = (event)=>{
        if (anchorRef.current && anchorRef.current.contains(event.target)) return;
        setOpen(false);
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "z-10",
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $d685fbaea40075f4$export$2e2bcd8739ae039), {
                    variant: "contained",
                    ref: anchorRef,
                    "aria-label": "Site Group Actions",
                    disabled: false,
                    color: "warning",
                    children: [
                        option === "Apply Filters" ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                            onClick: handleClick,
                            disabled: !userFiltersSMTP.site_ids[0],
                            sx: {
                                backgroundColor: "#FF8400",
                                "&:hover": {
                                    backgroundColor: "#E67300"
                                },
                                width: "140px"
                            },
                            children: option
                        }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                            onClick: ()=>{},
                            component: "a",
                            href: downloadURLSMTP,
                            download: true,
                            disabled: !downloadURLSMTP,
                            sx: {
                                color: "white",
                                backgroundColor: "#FF8400",
                                "&:hover": {
                                    backgroundColor: "#E67300",
                                    color: "white"
                                },
                                width: "178px",
                                textDecoration: "none"
                            },
                            children: fetchingDownloadURLSMTP ? "Fetching Report..." : "Download Report"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                            size: "small",
                            "aria-controls": open ? "split-button-menu" : undefined,
                            "aria-expanded": open ? "true" : undefined,
                            "aria-label": "select group action",
                            "aria-haspopup": "menu",
                            sx: {
                                backgroundColor: "#FF8400",
                                "&:hover": {
                                    backgroundColor: "#E67300"
                                }
                            },
                            onClick: handleToggle,
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bf807683d00d38ca$exports))), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $cWqfz.default), {
                    sx: {
                        zIndex: 1
                    },
                    open: open,
                    anchorEl: anchorRef.current,
                    role: undefined,
                    transition: true,
                    disablePortal: true,
                    children: ({ TransitionProps: TransitionProps, placement: placement })=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $6CjWJ.default), {
                            ...TransitionProps,
                            style: {
                                transformOrigin: placement === "bottom" ? "center top" : "center bottom"
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4reBM.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eg2OC.ClickAwayListener), {
                                    onClickAway: handleClose,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eJK3E.default), {
                                        className: "absolute",
                                        id: "split-button-menu",
                                        autoFocusItem: true,
                                        children: options.map((option, index)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                // disabled={index === 2}
                                                selected: index === options.indexOf(option),
                                                onClick: (event)=>handleMenuItemClick(event, index),
                                                children: option
                                            }, option))
                                    })
                                })
                            })
                        })
                })
            ]
        })
    });
};


const $54ec604d0cb2a34d$export$df038345ec00c266 = ({ navBarCollapsed: navBarCollapsed, showUserDropDown: showUserDropDown, userOptions: userOptions, setSearchParams: setSearchParams })=>{
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    let noUserDropDownCSS = showUserDropDown ? [
        "absolute top-0 left-[160px]",
        "absolute top-0 left-[320px]",
        "absolute top-0 left-[480px]",
        "absolute top-0 left-[640px]",
        "absolute top-0 left-[800px]",
        "absolute top-0 left-[960px]",
        "absolute top-[8px] left-[1130px]",
        "absolute top-0"
    ] : [
        "absolute top-0",
        "absolute top-0 left-[210px]",
        "absolute top-0 left-[420px]",
        "absolute top-0 left-[580px]",
        "absolute top-0 left-[740px]",
        "absolute top-0 left-[900px]",
        "absolute top-[8px] left-[1065px]"
    ];
    if (showUserDropDown && navBarCollapsed) noUserDropDownCSS = [
        "absolute top-0 left-[185px]",
        "absolute top-0 left-[370px]",
        "absolute top-0 left-[555px]",
        "absolute top-0 left-[715px]",
        "absolute top-0 left-[875px]",
        "absolute top-0 left-[1035px]",
        "absolute top-[8px] left-[1205px]",
        "absolute top-0"
    ];
    if (!showUserDropDown && navBarCollapsed) noUserDropDownCSS = [
        "absolute top-0",
        "absolute top-0 left-[250px]",
        "absolute top-0 left-[495px]",
        "absolute top-0 left-[655px]",
        "absolute top-0 left-[815px]",
        "absolute top-0 left-[975px]",
        "absolute top-[8px] left-[1140px]"
    ];
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: userPermissions.smtp && (userPermissions.sentinel || userPermissions.ailink) ? "absolute top-[60px] left-0" : "absolute top-[0px] left-0",
        children: [
            showUserDropDown && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[7],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3a3ab98e6fa0a92a$export$667924892c714a29), {
                    navBarCollapsed: navBarCollapsed
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[0],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4c2f987196a0448f$export$b0d439d45b9fcb58), {
                    showUserDropDown: showUserDropDown,
                    navBarCollapsed: navBarCollapsed
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[1],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $7c1e9a14e9efad48$export$1613e6d5f2867a88), {
                    showUserDropDown: showUserDropDown,
                    navBarCollapsed: navBarCollapsed
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[2],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $162379642460cee8$export$c3b7d0014653a60d), {})
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[3],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f43fa27f5e0b7840$export$2ca3403463ce7054), {})
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[4],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $70429021eeca4e0e$export$a3aa29b97247d908), {})
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[5],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b753d730daf2e3b7$export$3df5db2f82f8c028), {})
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[6],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4f15d0864d0e3e96$export$d2a9f4ca2a70474c), {
                    setSearchParams: setSearchParams
                })
            })
        ]
    });
};



var $dHtmK = parcelRequire("dHtmK");

var $aYdit = parcelRequire("aYdit");
/* eslint-disable jsx-a11y/media-has-caption */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $aYdit = parcelRequire("aYdit");



var $4G44R = parcelRequire("4G44R");


var $60vL1 = parcelRequire("60vL1");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

var $8jTCz = parcelRequire("8jTCz");

var $frXOV = parcelRequire("frXOV");

var $2qUoo = parcelRequire("2qUoo");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
var $fIsAN = parcelRequire("fIsAN");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $1wcxl = parcelRequire("1wcxl");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $fWsn7 = parcelRequire("fWsn7");

var $4G44R = parcelRequire("4G44R");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");
var $aVDw9 = parcelRequire("aVDw9");
var $ha39s = parcelRequire("ha39s");
var $4o6Cs = parcelRequire("4o6Cs");
var $kLvBh = parcelRequire("kLvBh");

var $9lVTU = parcelRequire("9lVTU");
const $d9a5c72a8a8f786a$var$headCells = [
    {
        id: "customer_name",
        numeric: false,
        label: "Site"
    },
    {
        id: "camera_name",
        numeric: false,
        label: "Camera Name"
    },
    {
        id: "clip_received_local",
        numeric: false,
        label: "Received"
    },
    {
        id: "clip_result",
        numeric: false,
        label: "Clip Result"
    },
    {
        id: "probability",
        numeric: true,
        label: "Probability"
    },
    {
        id: "file_id",
        numeric: false,
        label: "File ID"
    }
];
const $d9a5c72a8a8f786a$export$6380d4af33987683 = (props)=>{
    const { onRequestSort: onRequestSort, orderBy: orderBy, order: order } = props;
    const createSortHandler = (property)=>(event)=>{
            onRequestSort(event, property);
        };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
            children: $d9a5c72a8a8f786a$var$headCells.map((headCell)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    align: "left",
                    sortDirection: orderBy === headCell.id ? order : false,
                    sx: {
                        fontFamily: "mulish",
                        fontWeight: 700,
                        fontSize: 10,
                        whiteSpace: "nowrap"
                    },
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kLvBh.default), {
                        active: orderBy === headCell.id,
                        direction: orderBy === headCell.id ? order : "asc",
                        onClick: createSortHandler(headCell.id),
                        children: [
                            headCell.label,
                            orderBy === headCell.id ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                component: "span",
                                sx: (0, $9lVTU.default),
                                children: order === "desc" ? "sorted descending" : "sorted ascending"
                            }) : null
                        ]
                    })
                }, headCell.id))
        })
    });
};



parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
var $fIsAN = parcelRequire("fIsAN");
const $914ff183d8ca9dd6$export$f44402e41fb4d26 = (row, setVerifiedClicked, setUnverifiedClicked)=>{
    if (row.ground_truth === "Verified") {
        setVerifiedClicked(true);
        setUnverifiedClicked(false);
    } else if (row.ground_truth === "Unverified") {
        setVerifiedClicked(false);
        setUnverifiedClicked(true);
    } else {
        setVerifiedClicked(false);
        setUnverifiedClicked(false);
    }
};



const $5117acc2af9ded40$export$8d5393c358ad5162 = ({ order: order, orderBy: orderBy, setOrder: setOrder, setOrderBy: setOrderBy })=>{
    const [rowsPerPage, setRowsPerPage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(5);
    const lastAutoPagedSelectionRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const navigate = (0, $3T949.useNavigate)();
    const [searchParams, setSearchParams] = (0, $fIsAN.useSearchParams)();
    const { pageFrontel: pageFrontel, setPageFrontel: setPageFrontel, frontelData: frontelData, setFrontelData: setFrontelData, setSelectedRowFrontel: setSelectedRowFrontel, setVideoClipLoadingFrontel: setVideoClipLoadingFrontel, getClipInfoFrontel: getClipInfoFrontel, getVideoURLFrontel: getVideoURLFrontel, frontelSite: frontelSite, setVerifiedClickedFrontel: setVerifiedClickedFrontel, setUnverifiedClickedFrontel: setUnverifiedClickedFrontel } = (0, $4G44R.useClipsStore)();
    const handleRequestSort = (event, property)=>{
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };
    const handleChangePage = (event, newPage)=>{
        setPageFrontel(newPage);
    };
    const handleChangeRowsPerPage = (event)=>{
        setRowsPerPage(parseInt(event.target.value, 10));
        setPageFrontel(0);
    };
    const handleRowClick = (row)=>{
        // Update all rows to set selected to false
        const updatedData = frontelData.map((item)=>({
                ...item,
                selected: false
            }));
        // Find and update the clicked row to set selected to true
        const updatedDataWithSelection = updatedData.map((item)=>{
            if (item.file_id === row.file_id) return {
                ...item,
                selected: true
            };
            return item;
        });
        // Update the data in the store
        setFrontelData(updatedDataWithSelection);
        // Set the selected row and trigger loading
        setVideoClipLoadingFrontel(true);
        setSelectedRowFrontel(row);
        localStorage.setItem("clipsSelectedRow", JSON.stringify(row));
        // Update verification button shading based on row's ground_truth
        (0, $914ff183d8ca9dd6$export$f44402e41fb4d26)(row, setVerifiedClickedFrontel, setUnverifiedClickedFrontel);
        // Fetch the full clip details (internal_id etc.) and the video URL for
        // the selected row
        getClipInfoFrontel(row.file_id, navigate);
        getVideoURLFrontel(row.file_id, navigate);
        (0, $60d1d427e7f38222$export$d0ea5288e6803239)(setSearchParams, searchParams);
    };
    const roundToHundredth = (number)=>{
        const newNumber = number * 100;
        return Math.round(newNumber * 100) / 100;
    };
    const emptyRows = pageFrontel > 0 ? Math.max(0, (1 + pageFrontel) * rowsPerPage - frontelData.length) : 0;
    const visibleRows = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>(0, $fWsn7.stableSort)(frontelData, (0, $fWsn7.getComparator)(order, orderBy)).slice(pageFrontel * rowsPerPage, pageFrontel * rowsPerPage + rowsPerPage), [
        frontelData,
        order,
        orderBy,
        pageFrontel,
        rowsPerPage
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        const sortedRows = (0, $fWsn7.stableSort)(frontelData, (0, $fWsn7.getComparator)(order, orderBy));
        const selectedIndex = sortedRows.findIndex((row)=>row.selected);
        const selectedFileId = selectedIndex >= 0 && sortedRows[selectedIndex]?.file_id != null ? String(sortedRows[selectedIndex].file_id) : null;
        const expectedPage = selectedIndex >= 0 ? Math.floor(selectedIndex / rowsPerPage) : 0;
        if (selectedFileId && selectedFileId !== lastAutoPagedSelectionRef.current && expectedPage !== pageFrontel) {
            lastAutoPagedSelectionRef.current = selectedFileId;
            setPageFrontel(expectedPage);
        }
    }, [
        frontelData,
        order,
        orderBy,
        pageFrontel,
        rowsPerPage
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4reBM.default), {
        sx: {
            width: "100%",
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                sx: {
                    maxHeight: 490
                },
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                    sx: {
                        fontFamily: "Mulish",
                        postion: "absolute"
                    },
                    "aria-labelledby": "frontel-clips-table",
                    stickyHeader: true,
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $d9a5c72a8a8f786a$export$6380d4af33987683), {
                            onRequestSort: handleRequestSort,
                            orderBy: orderBy,
                            order: order
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $gXvgZ.default), {
                            children: [
                                visibleRows.map((row)=>{
                                    let sx = {
                                        cursor: "pointer"
                                    };
                                    if (row.selected) sx = {
                                        cursor: "pointer",
                                        backgroundColor: "rgba(2, 136, 209, 0.2)"
                                    };
                                    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                        hover: true,
                                        onClick: ()=>handleRowClick(row),
                                        tabIndex: -1,
                                        sx: sx,
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontSize: "10px",
                                                    fontFamily: "mulish",
                                                    width: "20%",
                                                    wordBreak: "break-word",
                                                    overflowWrap: "break-word"
                                                },
                                                children: row.customer_name || frontelSite.site_name
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontSize: "10px",
                                                    fontFamily: "mulish",
                                                    width: "20%",
                                                    wordBreak: "break-word",
                                                    overflowWrap: "break-word"
                                                },
                                                children: row.camera_name
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontSize: "10px",
                                                    fontFamily: "mulish",
                                                    width: "20%",
                                                    wordBreak: "break-word",
                                                    overflowWrap: "break-word"
                                                },
                                                children: (0, $c0433b3a957ff718$export$36a24ca552645e4e)(row.clip_header_received, row.clip_received_local, row.site_timezone)
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontSize: "10px",
                                                    fontFamily: "mulish",
                                                    width: "20%",
                                                    wordBreak: "break-word",
                                                    overflowWrap: "break-word"
                                                },
                                                children: row.clip_result
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontSize: "10px",
                                                    fontFamily: "mulish",
                                                    width: "15%"
                                                },
                                                children: row.probability != null ? `${roundToHundredth(row.probability)}%` : ""
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontSize: "10px",
                                                    fontFamily: "mulish",
                                                    width: "15%",
                                                    wordBreak: "break-word",
                                                    overflowWrap: "break-word"
                                                },
                                                children: row.file_id
                                            })
                                        ]
                                    }, row.file_id);
                                }),
                                emptyRows > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                    style: {
                                        height: 53 * emptyRows
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        colSpan: 6
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wcxl.default), {
                rowsPerPageOptions: [
                    5,
                    10,
                    25
                ],
                component: "div",
                count: frontelData.length,
                rowsPerPage: rowsPerPage,
                page: pageFrontel,
                onPageChange: handleChangePage,
                onRowsPerPageChange: handleChangeRowsPerPage
            })
        ]
    });
};



var $iIAML = parcelRequire("iIAML");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");
const $3422029d08cdee20$export$b51acfbf6fcfba49 = ({ precisionRecallData: precisionRecallData })=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        sx: {
            maxHeight: 300
        },
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
            sx: {
                minWidth: 1000,
                fontFamily: "Mulish"
            },
            "aria-label": "precision-recall-table",
            stickyHeader: true,
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                    titlesArray: [
                        "Date",
                        "Clips",
                        "TP",
                        "FP",
                        "FN",
                        "TN",
                        "N/A",
                        "Precision",
                        "Recall"
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                    children: precisionRecallData?.map((row, index)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: row.date_str
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: row.total_clips
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: row.true_positives
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: row.false_positives
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: row.false_negatives
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: row.true_negatives
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: row.unclassified
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: row.precision ?? "-"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: row.recall ?? "-"
                                })
                            ]
                        }, row.date || index))
                })
            ]
        })
    });
};


/* eslint-disable jsx-a11y/media-has-caption */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $gus0k = parcelRequire("gus0k");

var $kRZvb = parcelRequire("kRZvb");

var $iKAtE = parcelRequire("iKAtE");

var $f3puC = parcelRequire("f3puC");

var $433j1 = parcelRequire("433j1");


var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $gfzcx = parcelRequire("gfzcx");

var $8jTCz = parcelRequire("8jTCz");

var $2aMB5 = parcelRequire("2aMB5");

var $lWchQ = parcelRequire("lWchQ");


var $5Vost = parcelRequire("5Vost");
const $b35fc9b4c1ed5477$var$Transition = /*#__PURE__*/ $8T3gX.forwardRef(function Transition(props, ref) {
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $212a5a6a44b7f18e$export$2e2bcd8739ae039), {
        direction: "up",
        ref: ref,
        ...props
    });
});
const $b35fc9b4c1ed5477$export$61ae022c53661a3b = ({ showMoreDialogOpenFrontel: showMoreDialogOpenFrontel, setShowMoreDialogOpenFrontel: setShowMoreDialogOpenFrontel, selectedRowFrontel: selectedRowFrontel, videoURLFrontel: videoURLFrontel })=>{
    const handleClickOpen = ()=>{
        setShowMoreDialogOpenFrontel(true);
    };
    const handleClose = ()=>{
        setShowMoreDialogOpenFrontel(false);
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                onClick: handleClickOpen,
                text: "Full Clip Info",
                disabled: false
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                fullScreen: true,
                open: showMoreDialogOpenFrontel,
                onClose: handleClose,
                TransitionComponent: $b35fc9b4c1ed5477$var$Transition,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gus0k.default), {
                        sx: {
                            position: "relative"
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kRZvb.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                    edge: "start",
                                    color: "inherit",
                                    onClick: handleClose,
                                    "aria-label": "close",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                    sx: {
                                        ml: 2,
                                        flex: 1
                                    },
                                    variant: "h6",
                                    component: "div",
                                    children: [
                                        selectedRowFrontel.customer_name,
                                        selectedRowFrontel.customer_name && selectedRowFrontel.camera_name ? " | " : " ",
                                        selectedRowFrontel.camera_name
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "flex pt-[20px] pl-[20px]",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)($8T3gX.Fragment, {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("video", {
                                        width: "550",
                                        controls: true,
                                        autoPlay: true,
                                        loop: true,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("source", {
                                            src: videoURLFrontel,
                                            type: "video/mp4"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        id: "column1",
                                        className: "pl-[20px]",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "text-black font-mulish text-[16px] font-bold",
                                                children: "Site"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "w-[250px] text-black font-mulish text-[16px]",
                                                children: selectedRowFrontel.customer_name ? selectedRowFrontel.customer_name : "--"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "pt-[20px] w-[250px] text-black font-mulish text-[16px] font-bold",
                                                children: "Event ID"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "w-[250px] text-black font-mulish text-[16px]",
                                                children: selectedRowFrontel.event_id ? selectedRowFrontel.event_id : "--"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "pt-[20px] w-[250px] text-black font-mulish text-[16px] font-bold",
                                                children: "Camera Name"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "w-[250px] text-black font-mulish text-[16px]",
                                                children: selectedRowFrontel.camera_name ? selectedRowFrontel.camera_name : "--"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "pt-[20px] w-[250px] text-black font-mulish text-[16px] font-bold",
                                                children: "Camera ID"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "w-[250px] text-black font-mulish text-[16px]",
                                                children: selectedRowFrontel.camera_id ? selectedRowFrontel.camera_id : "--"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        id: "column2",
                                        className: "pl-[100px]",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "text-black font-mulish text-[16px] font-bold",
                                                children: "Local Time"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "w-[250px] text-black font-mulish text-[16px]",
                                                children: (0, $c0433b3a957ff718$export$36a24ca552645e4e)(selectedRowFrontel.clip_header_received, selectedRowFrontel.clip_received_local, selectedRowFrontel.site_timezone) || "--"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "pt-[20px] w-[250px] text-black font-mulish text-[16px] font-bold",
                                                children: "UTC Time"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "w-[250px] text-black font-mulish text-[16px]",
                                                children: selectedRowFrontel.clip_header_received ? (0, $c0433b3a957ff718$export$6a6c5e33e36c4dc4)(selectedRowFrontel.clip_header_received) : ""
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "pt-[20px] w-[250px] text-black font-mulish text-[16px] font-bold",
                                                children: "Internal Log ID"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "w-[250px] text-black font-mulish text-[16px]",
                                                children: selectedRowFrontel.internal_id ? selectedRowFrontel.internal_id : "--"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "pt-[20px] w-[250px] text-black font-mulish text-[16px] font-bold",
                                                children: "File ID"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "w-[250px] text-black font-mulish text-[16px]",
                                                children: selectedRowFrontel.file_id ? selectedRowFrontel.file_id : "--"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                        component: (0, $4reBM.default),
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                            sx: {
                                fontFamily: "Mulish",
                                width: "100%"
                            },
                            "aria-label": "simple table",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gfzcx.TableHeadComponent), {
                                    titlesArray: [
                                        "Probability",
                                        "Analyzed FPS",
                                        "Clip FPS",
                                        "Slice",
                                        "Stationary"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: selectedRowFrontel.probability != null ? `${(0, $5Vost.roundToHundredth)(selectedRowFrontel.probability)}%` : "--"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: selectedRowFrontel.fps ?? "--"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: selectedRowFrontel.stream_fps ?? "--"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: selectedRowFrontel.slice ? (0, $lWchQ.checkedCircleIcon) : (0, $2aMB5.cancelIconRed)
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                align: "left",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: selectedRowFrontel.stationary_filter ? (0, $lWchQ.checkedCircleIcon) : (0, $2aMB5.cancelIconRed)
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "relative min-w-[1450px] "
                    })
                ]
            })
        ]
    });
};





const $de33098d550b4fe6$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $de33098d550b4fe6$export$3e78047c5430a474 = ({ navBarCollapsed: navBarCollapsed })=>{
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    const { selectedRowFrontel: selectedRowFrontel, fetchingFilteredDataFrontel: fetchingFilteredDataFrontel, loadingAdditionalDataFrontel: loadingAdditionalDataFrontel, videoClipLoadingFrontel: videoClipLoadingFrontel, videoURLFrontel: videoURLFrontel, frontelSite: frontelSite, frontelData: frontelData, setFrontelData: setFrontelData, setSelectedRowFrontel: setSelectedRowFrontel, setVideoClipLoadingFrontel: setVideoClipLoadingFrontel, getClipInfoFrontel: getClipInfoFrontel, getVideoURLFrontel: getVideoURLFrontel, precisionRecallDataFrontel: precisionRecallDataFrontel, showMoreDialogOpenFrontel: showMoreDialogOpenFrontel, setShowMoreDialogOpenFrontel: setShowMoreDialogOpenFrontel, verifiedClickedFrontel: verifiedClickedFrontel, unverifiedClickedFrontel: unverifiedClickedFrontel, setVerifiedClickedFrontel: setVerifiedClickedFrontel, setUnverifiedClickedFrontel: setUnverifiedClickedFrontel, frontelUsername: frontelUsername, userFiltersFrontel: userFiltersFrontel, groupIDFrontel: groupIDFrontel } = (0, $4G44R.useClipsStore)();
    const [order, setOrder] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("asc");
    const [orderBy, setOrderBy] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("formatted_date");
    const navigate = (0, $3T949.useNavigate)();
    const [searchParams, setSearchParams] = (0, $fIsAN.useSearchParams)();
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: navBarCollapsed ? userPermissions.sentinel || userPermissions.ailink || userPermissions.frontel ? "relative left-[75px] top-[150px] w-[600px]" : "relative left-[75px] top-[90px] w-[600px]" : userPermissions.sentinel || userPermissions.ailink || userPermissions.frontel ? "relative left-[150px] top-[150px] w-[600px]" : "relative left-[150px] top-[90px] w-[600px]",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                className: "relative left-[20px] top-[15px] text-actuate-blue font-mulish text-[20px]",
                children: [
                    frontelSite.site_name ? (0, $a17e6a81e499c7af$export$d6488c46934633a3)(frontelSite.site_name, frontelSite.site_id) : "",
                    frontelSite.site_name && selectedRowFrontel.camera_name ? " | " : " ",
                    (0, $33b4b9464ea6ea5e$export$f28ee0a44f93351f)(selectedRowFrontel.camera_name, frontelSite.site_id, selectedRowFrontel.camera_id)
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex pt-[20px] pl-[10px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        children: !fetchingFilteredDataFrontel && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: !navBarCollapsed ? "w-[745px]" : "w-[815px]",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $5117acc2af9ded40$export$8d5393c358ad5162), {
                                            order: order,
                                            orderBy: orderBy,
                                            setOrder: setOrder,
                                            setOrderBy: setOrderBy
                                        })
                                    }),
                                    loadingAdditionalDataFrontel && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "relative pt-[5px]",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "relative left-[10px]",
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $851fcbe833f3eb8b$export$b08b517936747730), {})
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "absolute left-[58px] top-[7px] font-mulish text-actuate-orange",
                                                children: "Loading Additional Data"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "w-[660px]",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "w-[660px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    children: [
                                        videoClipLoadingFrontel && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: "text-center",
                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $b9p11.default), {
                                                theme: $de33098d550b4fe6$var$theme,
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                                            color: "primary"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                        className: "font-mulish text-[20px]",
                                                        children: "Video Loading..."
                                                    })
                                                ]
                                            })
                                        }),
                                        !videoClipLoadingFrontel && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "flex items-center justify-between w-[660px]",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "flex-none",
                                                    id: "arrow_back",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                        onClick: ()=>{
                                                            const currentIndex = frontelData.findIndex((item)=>item.file_id === selectedRowFrontel.file_id);
                                                            if (currentIndex > 0) {
                                                                const prevRow = frontelData[currentIndex - 1];
                                                                // Update selection in data
                                                                const updatedData = frontelData.map((item)=>({
                                                                        ...item,
                                                                        selected: item.file_id === prevRow.file_id
                                                                    }));
                                                                setFrontelData(updatedData);
                                                                setSelectedRowFrontel(prevRow);
                                                                setVideoClipLoadingFrontel(true);
                                                                (0, $914ff183d8ca9dd6$export$f44402e41fb4d26)(prevRow, setVerifiedClickedFrontel, setUnverifiedClickedFrontel);
                                                                getClipInfoFrontel(prevRow.file_id, navigate);
                                                                getVideoURLFrontel(prevRow.file_id, navigate);
                                                                (0, $60d1d427e7f38222$export$d0ea5288e6803239)(setSearchParams, searchParams);
                                                            }
                                                        },
                                                        text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($frXOV))), {
                                                            fontSize: "large",
                                                            id: "BackButton"
                                                        }),
                                                        disabled: frontelData.length === 0 || frontelData.findIndex((item)=>item.file_id === selectedRowFrontel.file_id) === 0
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                    className: "flex-auto",
                                                    id: "video",
                                                    children: [
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("video", {
                                                                width: "550",
                                                                autoPlay: true,
                                                                controls: true,
                                                                loop: true,
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("source", {
                                                                    src: videoURLFrontel,
                                                                    type: "video/mp4"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                            className: "flex gap-[16px]",
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                                    onClick: ()=>(0, $iIAML.saveAs)(videoURLFrontel, "video.mp4"),
                                                                    text: "Download Video",
                                                                    disabled: false
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $42175367ea4c1e61$export$d994c77890cfb1f4), {
                                                                    tab: "frontel",
                                                                    selectedRow: selectedRowFrontel
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $b35fc9b4c1ed5477$export$61ae022c53661a3b), {
                                                                    showMoreDialogOpenFrontel: showMoreDialogOpenFrontel,
                                                                    setShowMoreDialogOpenFrontel: setShowMoreDialogOpenFrontel,
                                                                    selectedRowFrontel: selectedRowFrontel,
                                                                    videoURLFrontel: videoURLFrontel
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "flex-none",
                                                    id: "arrow_forward",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                        onClick: ()=>{
                                                            const currentIndex = frontelData.findIndex((item)=>item.file_id === selectedRowFrontel.file_id);
                                                            if (currentIndex < frontelData.length - 1) {
                                                                const nextRow = frontelData[currentIndex + 1];
                                                                // Update selection in data
                                                                const updatedData = frontelData.map((item)=>({
                                                                        ...item,
                                                                        selected: item.file_id === nextRow.file_id
                                                                    }));
                                                                setFrontelData(updatedData);
                                                                setSelectedRowFrontel(nextRow);
                                                                setVideoClipLoadingFrontel(true);
                                                                (0, $914ff183d8ca9dd6$export$f44402e41fb4d26)(nextRow, setVerifiedClickedFrontel, setUnverifiedClickedFrontel);
                                                                getClipInfoFrontel(nextRow.file_id, navigate);
                                                                getVideoURLFrontel(nextRow.file_id, navigate);
                                                                (0, $60d1d427e7f38222$export$d0ea5288e6803239)(setSearchParams, searchParams);
                                                            }
                                                        },
                                                        text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2qUoo))), {
                                                            fontSize: "large",
                                                            id: "forwardButton"
                                                        }),
                                                        disabled: frontelData.length === 0 || frontelData.findIndex((item)=>item.file_id === selectedRowFrontel.file_id) === frontelData.length - 1
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: !navBarCollapsed ? "bg-white h-[55px] w-[1305px]" : "bg-white h-[55px] w-[1380px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "bg-white h-[55px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "font-black font-mulish text-[20px] p-3 indent-4",
                            children: "Precision and Recall"
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3422029d08cdee20$export$b51acfbf6fcfba49), {
                        precisionRecallData: precisionRecallDataFrontel
                    })
                ]
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $aYdit = parcelRequire("aYdit");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $60vL1 = parcelRequire("60vL1");
var $eejVe = parcelRequire("eejVe");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $4G44R = parcelRequire("4G44R");
const $c8e245301d133198$export$9000c08e2a0c2dea = ({ navBarCollapsed: navBarCollapsed })=>{
    const { groupOptionsFrontel: groupOptionsFrontel, userDropDownValueFrontel: userDropDownValueFrontel, setUserDropDownValueFrontel: setUserDropDownValueFrontel, setCameraDropDownValueFrontel: setCameraDropDownValueFrontel, setGroupIDFrontel: setGroupIDFrontel, setFrontelUsername: setFrontelUsername, setSiteDropDownValueFrontel: setSiteDropDownValueFrontel, setSiteOptionsFrontel: setSiteOptionsFrontel, setUserFiltersFrontel: setUserFiltersFrontel, setCameraOptionsFrontel: setCameraOptionsFrontel, loadingGroupsFrontel: loadingGroupsFrontel, getAllSitesFrontel: getAllSitesFrontel } = (0, $4G44R.useClipsStore)();
    const navigate = (0, $3T949.useNavigate)();
    // Create a Set to track unique names and ensure we only add each name once
    const uniqueNames = new Set();
    const options = [];
    const optionGroupIds = new Map();
    const optionUsernames = new Map();
    // First pass: collect unique names and their corresponding IDs and usernames.
    // Credentials can have group=null (SET_NULL on group delete) — skip them,
    // matching UserDropDownAILink, instead of crashing the whole Clips page.
    (groupOptionsFrontel || []).forEach((object)=>{
        if (object.group && !uniqueNames.has(object.group.name)) {
            uniqueNames.add(object.group.name);
            options.push(object.group.name);
            optionGroupIds.set(object.group.name, object.group.id);
            optionUsernames.set(object.group.name, object.username);
        }
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            value: userDropDownValueFrontel,
            disablePortal: true,
            options: options,
            onChange: (event, value)=>{
                if (value !== null) {
                    setUserDropDownValueFrontel(value);
                    setCameraDropDownValueFrontel(null);
                    setGroupIDFrontel(optionGroupIds.get(value));
                    setFrontelUsername(optionUsernames.get(value));
                    setSiteDropDownValueFrontel(null);
                    setSiteOptionsFrontel([]);
                    getAllSitesFrontel(optionGroupIds.get(value), navigate);
                    setUserFiltersFrontel((previousState)=>{
                        return {
                            ...previousState,
                            user: optionUsernames.get(value),
                            site_ids: [],
                            camera_ids: []
                        };
                    });
                } else {
                    setUserDropDownValueFrontel(value);
                    setSiteDropDownValueFrontel(null);
                    setSiteOptionsFrontel([]);
                    setCameraDropDownValueFrontel(null);
                    setCameraOptionsFrontel([]);
                    setFrontelUsername("");
                    setUserFiltersFrontel((previousState)=>{
                        return {
                            ...previousState,
                            user: "",
                            site_ids: [],
                            camera_ids: []
                        };
                    });
                }
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    label: "Group",
                    InputProps: {
                        ...params.InputProps,
                        endAdornment: /*#__PURE__*/ (0, $k4ank.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                            children: [
                                loadingGroupsFrontel ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                    color: "inherit",
                                    size: 20
                                }) : null,
                                params.InputProps.endAdornment
                            ]
                        })
                    },
                    autoComplete: "off",
                    helperText: "*Required",
                    sx: !navBarCollapsed ? {
                        width: 150
                    } : {
                        width: 175
                    }
                })
        })
    }, "user_dropdown_frontel");
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $60vL1 = parcelRequire("60vL1");
var $eejVe = parcelRequire("eejVe");

var $4G44R = parcelRequire("4G44R");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $a182660eb1a06f89$export$202083df1c7b2 = ({ showUserDropDown: showUserDropDown, navBarCollapsed: navBarCollapsed })=>{
    const navigate = (0, $3T949.useNavigate)();
    const { siteOptionsFrontel: siteOptionsFrontel, siteDropDownValueFrontel: siteDropDownValueFrontel, setSiteDropDownValueFrontel: setSiteDropDownValueFrontel, setCameraDropDownValueFrontel: setCameraDropDownValueFrontel, setUserFiltersFrontel: setUserFiltersFrontel, setCameraOptionsFrontel: setCameraOptionsFrontel, loadingSitesFrontel: loadingSitesFrontel, getCamerasBySiteFrontel: getCamerasBySiteFrontel } = (0, $4G44R.useClipsStore)();
    const siteIds = new Map();
    (siteOptionsFrontel || []).forEach((object)=>{
        siteIds.set(object.name, object.id);
    });
    // Create a Set to track unique names and ensure we only add each name once
    const uniqueNames = new Set();
    const options = [];
    // First pass: collect unique names
    (siteOptionsFrontel || []).forEach((object)=>{
        if (!uniqueNames.has(object.name)) {
            uniqueNames.add(object.name);
            options.push(object.name);
        }
    });
    let sx;
    if (showUserDropDown && navBarCollapsed) sx = {
        width: 175
    };
    if (showUserDropDown && !navBarCollapsed) sx = {
        width: 150
    };
    if (!showUserDropDown && navBarCollapsed) sx = {
        width: 240
    };
    if (!showUserDropDown && !navBarCollapsed) sx = {
        width: 200
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            value: siteDropDownValueFrontel,
            disablePortal: true,
            options: options,
            loading: loadingSitesFrontel,
            onChange: (event, value)=>{
                if (value !== null) {
                    const id = siteIds.get(value);
                    setSiteDropDownValueFrontel(value);
                    setCameraDropDownValueFrontel(null);
                    getCamerasBySiteFrontel([
                        id
                    ], navigate);
                    setUserFiltersFrontel((previousState)=>{
                        return {
                            ...previousState,
                            site_ids: [
                                siteIds.get(value)
                            ],
                            camera_ids: []
                        };
                    });
                } else {
                    setSiteDropDownValueFrontel(value);
                    setCameraDropDownValueFrontel(null);
                    setCameraOptionsFrontel([]);
                    setUserFiltersFrontel((previousState)=>{
                        return {
                            ...previousState,
                            site_ids: [],
                            camera_ids: []
                        };
                    });
                }
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    label: "Site",
                    InputProps: {
                        ...params.InputProps,
                        endAdornment: /*#__PURE__*/ (0, $k4ank.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                            children: [
                                loadingSitesFrontel ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                    color: "inherit",
                                    size: 20
                                }) : null,
                                params.InputProps.endAdornment
                            ]
                        })
                    },
                    autoComplete: "off",
                    sx: sx
                })
        })
    }, "site_dropdown_frontel");
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $60vL1 = parcelRequire("60vL1");
var $eejVe = parcelRequire("eejVe");

var $4G44R = parcelRequire("4G44R");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $ab47b10f303c9680$export$df6d7e26c79922e4 = ({ showUserDropDown: showUserDropDown, navBarCollapsed: navBarCollapsed })=>{
    const navigate = (0, $3T949.useNavigate)();
    const { cameraOptionsFrontel: cameraOptionsFrontel, siteOptionsFrontel: siteOptionsFrontel, cameraDropDownValueFrontel: cameraDropDownValueFrontel, setCameraDropDownValueFrontel: setCameraDropDownValueFrontel, setUserFiltersFrontel: setUserFiltersFrontel, loadingCamerasFrontel: loadingCamerasFrontel } = (0, $4G44R.useClipsStore)();
    const cameraIds = new Map();
    (cameraOptionsFrontel || []).forEach((object)=>{
        cameraIds.set(object.camera_name, object.id);
    });
    const siteIds = new Map();
    (siteOptionsFrontel || []).forEach((object)=>{
        siteIds.set(object.name, object.id);
    });
    // Create a Set to track unique camera names and ensure we only add each name once
    const uniqueCameraNames = new Set();
    const options = [];
    // First pass: collect unique camera names
    (cameraOptionsFrontel || []).forEach((object)=>{
        if (!uniqueCameraNames.has(object.camera_name)) {
            uniqueCameraNames.add(object.camera_name);
            options.push(object.camera_name);
        }
    });
    let sx;
    if (showUserDropDown && navBarCollapsed) sx = {
        width: 175
    };
    if (showUserDropDown && !navBarCollapsed) sx = {
        width: 150
    };
    if (!showUserDropDown && navBarCollapsed) sx = {
        width: 235
    };
    if (!showUserDropDown && !navBarCollapsed) sx = {
        width: 200
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            value: cameraDropDownValueFrontel,
            disablePortal: true,
            options: options,
            loading: loadingCamerasFrontel,
            onChange: (event, value)=>{
                if (value !== null) {
                    setCameraDropDownValueFrontel(value);
                    setUserFiltersFrontel((previousState)=>{
                        return {
                            ...previousState,
                            camera_ids: [
                                cameraIds.get(value)
                            ]
                        };
                    });
                } else {
                    setCameraDropDownValueFrontel(value);
                    setUserFiltersFrontel((previousState)=>{
                        return {
                            ...previousState,
                            camera_ids: []
                        };
                    });
                }
            // TODO: Add getDownloadURLFrontel call when API function is ready
            // getDownloadURLFrontel(navigate);
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    label: "Camera",
                    InputProps: {
                        ...params.InputProps,
                        endAdornment: /*#__PURE__*/ (0, $k4ank.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                            children: [
                                loadingCamerasFrontel ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                    color: "inherit",
                                    size: 20
                                }) : null,
                                params.InputProps.endAdornment
                            ]
                        })
                    },
                    autoComplete: "off",
                    sx: sx
                })
        })
    }, "camera_dropdown_frontel");
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $hfM8m = parcelRequire("hfM8m");

var $hwWkD = parcelRequire("hwWkD");


var $eejVe = parcelRequire("eejVe");

var $5L5iJ = parcelRequire("5L5iJ");

var $iKAtE = parcelRequire("iKAtE");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");

var $i5MAs = parcelRequire("i5MAs");

var $aYdit = parcelRequire("aYdit");

var $jgags = parcelRequire("jgags");

var $4G44R = parcelRequire("4G44R");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $ab5d8cf87f44fdd1$export$c76ba7c18f1f4a6a = ()=>{
    const { userFiltersFrontel: userFiltersFrontel, setUserFiltersFrontel: setUserFiltersFrontel, setTimeFiltersDisabledFrontel: setTimeFiltersDisabledFrontel } = (0, $4G44R.useClipsStore)();
    const navigate = (0, $3T949.useNavigate)();
    const [startTimeAnchorEl, setStartTimeAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const startTimeOpen = Boolean(startTimeAnchorEl);
    const handleStartTimeClick = (event)=>{
        setStartTimeAnchorEl(event.currentTarget);
    };
    const handleStartTimeClose = (event)=>{
        event.stopPropagation();
        setStartTimeAnchorEl(null);
    };
    const { dateMMDDYYYY: dateMMDDYYYY, setDateMMDDYYYY: setDateMMDDYYYY } = (0, $aYdit.useAppStore)();
    const selectedLocale = dateMMDDYYYY ? (0, $jgags.default) : (0, $253608f850203ed2$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
        dateAdapter: (0, $hfM8m.AdapterDateFns),
        adapterLocale: selectedLocale,
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cbaf068f14972fdf$export$5109c6dd95d8fb00), {
            label: userFiltersFrontel.start_date ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                        children: "Start Date"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                "aria-label": "more",
                                id: "long-button-frontel-start",
                                "aria-controls": startTimeOpen ? "long-menu-frontel-start" : undefined,
                                "aria-expanded": startTimeOpen ? "true" : undefined,
                                "aria-haspopup": "true",
                                onClick: handleStartTimeClick,
                                sx: {
                                    marginLeft: "5px",
                                    padding: 0,
                                    color: "#000000",
                                    "&:hover": {
                                        backgroundColor: "transparent"
                                    }
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5MAs))), {})
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                                id: "long-menu-frontel-start",
                                MenuListProps: {
                                    "aria-labelledby": "long-button-frontel-start"
                                },
                                anchorOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                anchorEl: startTimeAnchorEl,
                                open: startTimeOpen,
                                onClose: handleStartTimeClose,
                                slotProps: {
                                    paper: {
                                        style: {
                                            maxHeight: 216,
                                            width: "20ch"
                                        }
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: (event)=>{
                                            setDateMMDDYYYY(true);
                                            handleStartTimeClose(event);
                                        },
                                        children: "MM/DD/YYYY"
                                    }, "mm-dd-yyyy-start-frontel"),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: (event)=>{
                                            setDateMMDDYYYY(false);
                                            handleStartTimeClose(event);
                                        },
                                        children: "DD/MM/YYYY"
                                    }, "dd-mm-yyyy-start-frontel")
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                children: "Start Date"
            }),
            value: userFiltersFrontel.start_date,
            onChange: (newValue)=>{
                if (newValue !== null) setUserFiltersFrontel((previousState)=>({
                        ...previousState,
                        start_date: newValue
                    }));
                if (newValue === null) setUserFiltersFrontel((previousState)=>({
                        ...previousState,
                        start_date: null
                    }));
                if ((0, $5L5iJ.yyyymmddGenerator)(newValue) !== (0, $5L5iJ.yyyymmddGenerator)(userFiltersFrontel.end_date)) {
                    setTimeFiltersDisabledFrontel(true);
                    setUserFiltersFrontel((previousState)=>({
                            ...previousState,
                            start_time: null,
                            end_time: null
                        }));
                }
                if ((0, $5L5iJ.yyyymmddGenerator)(newValue) === (0, $5L5iJ.yyyymmddGenerator)(userFiltersFrontel.end_date)) setTimeFiltersDisabledFrontel(false);
            // TODO: Add getDownloadURLFrontel call when API function is ready
            // getDownloadURLFrontel(navigate);
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    sx: {
                        width: 150
                    },
                    ...params
                })
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $hfM8m = parcelRequire("hfM8m");

var $hwWkD = parcelRequire("hwWkD");


var $eejVe = parcelRequire("eejVe");

var $5L5iJ = parcelRequire("5L5iJ");

var $iKAtE = parcelRequire("iKAtE");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");

var $i5MAs = parcelRequire("i5MAs");

var $aYdit = parcelRequire("aYdit");

var $jgags = parcelRequire("jgags");

var $4G44R = parcelRequire("4G44R");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $8dce8593fd31fb97$export$c92093f4ed2112e7 = ()=>{
    const { userFiltersFrontel: userFiltersFrontel, setUserFiltersFrontel: setUserFiltersFrontel, setTimeFiltersDisabledFrontel: setTimeFiltersDisabledFrontel } = (0, $4G44R.useClipsStore)();
    const navigate = (0, $3T949.useNavigate)();
    const [endTimeAnchorEl, setEndTimeAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const endTimeOpen = Boolean(endTimeAnchorEl);
    const handleEndTimeClick = (event)=>{
        setEndTimeAnchorEl(event.currentTarget);
    };
    const handleEndTimeClose = (event)=>{
        event.stopPropagation();
        setEndTimeAnchorEl(null);
    };
    const { dateMMDDYYYY: dateMMDDYYYY, setDateMMDDYYYY: setDateMMDDYYYY } = (0, $aYdit.useAppStore)();
    const selectedLocale = dateMMDDYYYY ? (0, $jgags.default) : (0, $253608f850203ed2$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
        dateAdapter: (0, $hfM8m.AdapterDateFns),
        adapterLocale: selectedLocale,
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cbaf068f14972fdf$export$5109c6dd95d8fb00), {
            label: userFiltersFrontel.end_date ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                        children: "End Date"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                "aria-label": "more",
                                id: "long-button-frontel-end",
                                "aria-controls": endTimeOpen ? "long-menu-frontel-end" : undefined,
                                "aria-expanded": endTimeOpen ? "true" : undefined,
                                "aria-haspopup": "true",
                                onClick: handleEndTimeClick,
                                sx: {
                                    marginLeft: "5px",
                                    padding: 0,
                                    color: "#000000",
                                    "&:hover": {
                                        backgroundColor: "transparent"
                                    }
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5MAs))), {})
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                                id: "long-menu-frontel-end",
                                MenuListProps: {
                                    "aria-labelledby": "long-button-frontel-end"
                                },
                                anchorOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                anchorEl: endTimeAnchorEl,
                                open: endTimeOpen,
                                onClose: handleEndTimeClose,
                                slotProps: {
                                    paper: {
                                        style: {
                                            maxHeight: 216,
                                            width: "20ch"
                                        }
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: (event)=>{
                                            setDateMMDDYYYY(true);
                                            handleEndTimeClose(event);
                                        },
                                        children: "MM/DD/YYYY"
                                    }, "mm-dd-yyyy-end-frontel"),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: (event)=>{
                                            setDateMMDDYYYY(false);
                                            handleEndTimeClose(event);
                                        },
                                        children: "DD/MM/YYYY"
                                    }, "dd-mm-yyyy-end-frontel")
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                children: "End Date"
            }),
            value: userFiltersFrontel.end_date,
            onChange: (newValue)=>{
                if (newValue !== null) setUserFiltersFrontel((previousState)=>({
                        ...previousState,
                        end_date: newValue
                    }));
                if (newValue === null) setUserFiltersFrontel((previousState)=>({
                        ...previousState,
                        end_date: null
                    }));
                if ((0, $5L5iJ.yyyymmddGenerator)(newValue) !== (0, $5L5iJ.yyyymmddGenerator)(userFiltersFrontel.start_date)) {
                    setTimeFiltersDisabledFrontel(true);
                    setUserFiltersFrontel((previousState)=>({
                            ...previousState,
                            start_time: null,
                            end_time: null
                        }));
                }
                if ((0, $5L5iJ.yyyymmddGenerator)(newValue) === (0, $5L5iJ.yyyymmddGenerator)(userFiltersFrontel.start_date)) setTimeFiltersDisabledFrontel(false);
            // TODO: Add getDownloadURLFrontel call when API function is ready
            // getDownloadURLFrontel(navigate);
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    sx: {
                        width: 150
                    },
                    ...params
                })
        })
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eejVe = parcelRequire("eejVe");
var $cVCJe = parcelRequire("cVCJe");

var $hwWkD = parcelRequire("hwWkD");

var $a50J4 = parcelRequire("a50J4");

var $hfM8m = parcelRequire("hfM8m");

var $4G44R = parcelRequire("4G44R");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

const $98a2ec5f7c296c53$export$9be7d5711b617321 = ()=>{
    const { userFiltersFrontel: userFiltersFrontel, setUserFiltersFrontel: setUserFiltersFrontel, timeFiltersDisabledFrontel: timeFiltersDisabledFrontel } = (0, $4G44R.useClipsStore)();
    const navigate = (0, $3T949.useNavigate)();
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
        dateAdapter: (0, $hfM8m.AdapterDateFns),
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
            title: (0, $ffbec3bd61ee0d21$export$e5ad0d4cfb9b77f4),
            disableHoverListener: !timeFiltersDisabledFrontel,
            disableFocusListener: !timeFiltersDisabledFrontel,
            disableTouchListener: !timeFiltersDisabledFrontel,
            ...(0, $ffbec3bd61ee0d21$export$b1886b315cb3d290),
            children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                style: {
                    display: "inline-block"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a50J4.DesktopTimePicker), {
                    label: "Start Time",
                    value: userFiltersFrontel.start_time ? userFiltersFrontel.start_time : null,
                    onChange: (newValue)=>{
                        setUserFiltersFrontel((previousState)=>({
                                ...previousState,
                                start_time: newValue
                            }));
                    // TODO: Add getDownloadURLFrontel call when API function is ready
                    // getDownloadURLFrontel(navigate);
                    },
                    disabled: timeFiltersDisabledFrontel,
                    renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                            ...params,
                            autoComplete: "off",
                            sx: {
                                width: 150
                            }
                        })
                })
            })
        })
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eejVe = parcelRequire("eejVe");
var $cVCJe = parcelRequire("cVCJe");

var $hwWkD = parcelRequire("hwWkD");

var $a50J4 = parcelRequire("a50J4");

var $hfM8m = parcelRequire("hfM8m");

var $4G44R = parcelRequire("4G44R");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

const $6bb52288c8679715$export$f350c2b2a202f239 = ()=>{
    const { userFiltersFrontel: userFiltersFrontel, setUserFiltersFrontel: setUserFiltersFrontel, timeFiltersDisabledFrontel: timeFiltersDisabledFrontel } = (0, $4G44R.useClipsStore)();
    const navigate = (0, $3T949.useNavigate)();
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
        dateAdapter: (0, $hfM8m.AdapterDateFns),
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
            title: (0, $ffbec3bd61ee0d21$export$e5ad0d4cfb9b77f4),
            disableHoverListener: !timeFiltersDisabledFrontel,
            disableFocusListener: !timeFiltersDisabledFrontel,
            disableTouchListener: !timeFiltersDisabledFrontel,
            ...(0, $ffbec3bd61ee0d21$export$b1886b315cb3d290),
            children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                style: {
                    display: "inline-block"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a50J4.DesktopTimePicker), {
                    label: "End Time",
                    value: userFiltersFrontel.end_time ? userFiltersFrontel.end_time : null,
                    onChange: (newValue)=>{
                        setUserFiltersFrontel((previousState)=>({
                                ...previousState,
                                end_time: newValue
                            }));
                    // TODO: Add getDownloadURLFrontel call when API function is ready
                    // getDownloadURLFrontel(navigate);
                    },
                    disabled: timeFiltersDisabledFrontel,
                    renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                            ...params,
                            autoComplete: "off",
                            sx: {
                                width: 150
                            }
                        })
                })
            })
        })
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $4G44R = parcelRequire("4G44R");

const $852d85825486980c$export$a48927cd0cbdd48b = (props)=>{
    const { setSearchParams: setSearchParams } = props ?? {};
    const navigate = (0, $3T949.useNavigate)();
    const { setFrontelData: setFrontelData, setPageFrontel: setPageFrontel, setSelectedRowFrontel: setSelectedRowFrontel, setPrecisionRecallDataFrontel: setPrecisionRecallDataFrontel, setNoDataToDisplayFrontel: setNoDataToDisplayFrontel, setFetchingFilteredDataFrontel: setFetchingFilteredDataFrontel, setFiltersAppliedFrontel: setFiltersAppliedFrontel, setLoadingAdditionalDataFrontel: setLoadingAdditionalDataFrontel, getFrontelData: getFrontelData, userFiltersFrontel: userFiltersFrontel } = (0, $4G44R.useClipsStore)();
    return /*#__PURE__*/ (0, $k4ank.jsx)("button", {
        className: "shadow-button bg-actuate-orange border-2 border-actuate-orange rounded font-mulish text-white text-base p-1.5 w-[120px] hover:bg-[#E67300]",
        onClick: ()=>{
            setFiltersAppliedFrontel(true);
            setLoadingAdditionalDataFrontel(true);
            setFrontelData([]);
            setPageFrontel(0);
            setNoDataToDisplayFrontel(true);
            setSelectedRowFrontel({});
            setPrecisionRecallDataFrontel([]);
            setFetchingFilteredDataFrontel(true);
            getFrontelData(navigate);
            if (setSearchParams) (0, $60d1d427e7f38222$export$867258f8bab37ec)(setSearchParams, "frontel", userFiltersFrontel);
        },
        disabled: false,
        children: "Apply Filters"
    });
};


const $ffba2081b6c8d397$export$fd0b4c8efafb178c = ({ navBarCollapsed: navBarCollapsed, showUserDropDown: showUserDropDown, setSearchParams: setSearchParams })=>{
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    let noUserDropDownCSS = showUserDropDown ? [
        "absolute top-0 left-[160px]",
        "absolute top-0 left-[320px]",
        "absolute top-0 left-[480px]",
        "absolute top-0 left-[640px]",
        "absolute top-0 left-[800px]",
        "absolute top-0 left-[960px]",
        "absolute top-[8px] left-[1130px]",
        "absolute top-0"
    ] : [
        "absolute top-0",
        "absolute top-0 left-[210px]",
        "absolute top-0 left-[420px]",
        "absolute top-0 left-[580px]",
        "absolute top-0 left-[740px]",
        "absolute top-0 left-[900px]",
        "absolute top-[8px] left-[1065px]"
    ];
    if (showUserDropDown && navBarCollapsed) noUserDropDownCSS = [
        "absolute top-0 left-[185px]",
        "absolute top-0 left-[370px]",
        "absolute top-0 left-[555px]",
        "absolute top-0 left-[715px]",
        "absolute top-0 left-[875px]",
        "absolute top-0 left-[1035px]",
        "absolute top-[8px] left-[1205px]",
        "absolute top-0"
    ];
    if (!showUserDropDown && navBarCollapsed) noUserDropDownCSS = [
        "absolute top-0",
        "absolute top-0 left-[250px]",
        "absolute top-0 left-[495px]",
        "absolute top-0 left-[655px]",
        "absolute top-0 left-[815px]",
        "absolute top-0 left-[975px]",
        "absolute top-[8px] left-[1140px]"
    ];
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: userPermissions.sentinel || userPermissions.ailink || userPermissions.smtp ? "absolute top-[60px] left-0" : "absolute top-[0px] left-0",
        children: [
            showUserDropDown && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[7],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $c8e245301d133198$export$9000c08e2a0c2dea), {
                    navBarCollapsed: navBarCollapsed
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[0],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a182660eb1a06f89$export$202083df1c7b2), {
                    showUserDropDown: showUserDropDown,
                    navBarCollapsed: navBarCollapsed
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[1],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ab47b10f303c9680$export$df6d7e26c79922e4), {
                    showUserDropDown: showUserDropDown,
                    navBarCollapsed: navBarCollapsed
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[2],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ab5d8cf87f44fdd1$export$c76ba7c18f1f4a6a), {})
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[3],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8dce8593fd31fb97$export$c92093f4ed2112e7), {})
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[4],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $98a2ec5f7c296c53$export$9be7d5711b617321), {})
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[5],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $6bb52288c8679715$export$f350c2b2a202f239), {})
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: noUserDropDownCSS[6],
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $852d85825486980c$export$a48927cd0cbdd48b), {
                    setSearchParams: setSearchParams
                })
            })
        ]
    });
};





var $88GbJ = parcelRequire("88GbJ");

var $w8ml8 = parcelRequire("w8ml8");



const $e2db034a6b9f3a4e$export$15f561d1a43ca288 = ({ tab: tab, targetId: targetId, clipsData: clipsData, sentinelData: sentinelData, smtpData: smtpData, frontelData: frontelData, fetchingFilteredData: fetchingFilteredData, fetchingFilteredDataSentinel: fetchingFilteredDataSentinel, fetchingFilteredDataSMTP: fetchingFilteredDataSMTP, fetchingFilteredDataFrontel: fetchingFilteredDataFrontel, filtersApplied: filtersApplied, filtersAppliedSMTP: filtersAppliedSMTP, filtersAppliedFrontel: filtersAppliedFrontel })=>{
    if (tab === "ailink") {
        if (fetchingFilteredData || !filtersApplied || clipsData.length === 0) return {
            status: "skip",
            row: null
        };
        const row = clipsData.find((item)=>item.file_id === targetId) ?? null;
        return row ? {
            status: "found",
            row: row
        } : {
            status: "not_found",
            row: null
        };
    }
    if (tab === "sentinel") {
        if (fetchingFilteredDataSentinel || !filtersApplied || sentinelData.length === 0) return {
            status: "skip",
            row: null
        };
        const row = sentinelData.find((item)=>item.file_id === targetId) ?? null;
        return row ? {
            status: "found",
            row: row
        } : {
            status: "not_found",
            row: null
        };
    }
    if (tab === "smtp") {
        if (fetchingFilteredDataSMTP || !filtersAppliedSMTP || smtpData.length === 0) return {
            status: "skip",
            row: null
        };
        const row = smtpData.find((item)=>item.clip_id === targetId) ?? null;
        return row ? {
            status: "found",
            row: row
        } : {
            status: "not_found",
            row: null
        };
    }
    if (fetchingFilteredDataFrontel || !filtersAppliedFrontel || frontelData.length === 0) return {
        status: "skip",
        row: null
    };
    const row = frontelData.find((item)=>item.file_id === targetId) ?? null;
    return row ? {
        status: "found",
        row: row
    } : {
        status: "not_found",
        row: null
    };
};



var $8E01L = parcelRequire("8E01L");

var $3QMQN = parcelRequire("3QMQN");
const $e67139ca3a67d820$export$78d384c3ba0c37b8 = ({ navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        resetState();
    }, []);
    const [clipsData, setClipsData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [sentinelData, setSentinelData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const navigate = (0, $3T949.useNavigate)();
    // Remove the local activeTab state - it's now managed by Zustand store
    const { activeClipsTab: activeClipsTab, setActiveClipsTab: setActiveClipsTab, pageLoadingSMTP: pageLoadingSMTP, filtersAppliedSMTP: filtersAppliedSMTP, getSMTPData: getSMTPData, getUserGroupsSMTP: getUserGroupsSMTP, getAllSitesClipsSMTP: getAllSitesClipsSMTP, getUserGroupsFrontel: getUserGroupsFrontel, resetState: resetState, setUserFiltersSMTP: setUserFiltersSMTP, setUserFiltersFrontel: setUserFiltersFrontel, setFiltersAppliedSMTP: setFiltersAppliedSMTP, setFiltersAppliedFrontel: setFiltersAppliedFrontel, getFrontelData: getFrontelData, setUserDropDownValueFrontel: setUserDropDownValueFrontel, setGroupIDFrontel: setGroupIDFrontel, setFrontelUsername: setFrontelUsername, getAllSitesFrontel: getAllSitesFrontel, siteOptionsSMTP: siteOptionsSMTP, setSiteDropDownValueSMTP: setSiteDropDownValueSMTP, getCamerasBySiteSMTP: getCamerasBySiteSMTP, siteOptionsFrontel: siteOptionsFrontel, setSiteDropDownValueFrontel: setSiteDropDownValueFrontel, getCamerasBySiteFrontel: getCamerasBySiteFrontel, loadingGroupsFrontel: loadingGroupsFrontel, setLoadingGroupsFrontel: setLoadingGroupsFrontel } = (0, $4G44R.useClipsStore)();
    const [searchParams, setSearchParams] = (0, $fIsAN.useSearchParams)();
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    const [selectedRow, setSelectedRow] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [selectedRowSentinel, setSelectedRowSentinel] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(sentinelData[0]);
    const [page, setPage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [pageSentinel, setPageSentinel] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [sentinelFilterApplyToken, setSentinelFilterApplyToken] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [showMoreDialogOpen, setShowMoreDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [showMoreDialogOpenSentinel, setShowMoreDialogOpenSentinel] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [pageLoading, setPageLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [pageLoadingSentinel, setPageLoadingSentinel] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [videoURL, setVideoURL] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [videoURLSentinel, setVideoURLSentinel] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [precisionRecallData, setPrecisionRecallData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        date: "",
        date_str: "",
        true_positives: 0,
        false_positives: 0,
        false_negatives: 0,
        true_negatives: 0,
        unclassified: 0,
        total_clips: 0,
        precision: null,
        recall: null
    });
    const [precisionRecallDataSentinel, setPrecisionRecallDataSentinel] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState((0, $w8ml8.createEmptyPrecisionRecallData)());
    const [videoClipLoading, setVideoClipLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [videoClipLoadingSentinel, setVideoClipLoadingSentinel] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [clipsIndexOrder, setClipsIndexOrder] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [clipsIndexOrderSentinel, setClipsIndexOrderSentinel] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [verifiedClicked, setVerifiedClicked] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [unverifiedClicked, setUnverifiedClicked] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [noDataToDisplay, setNoDataToDisplay] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [noDataToDisplaySentinel, setNoDataToDisplaySentinel] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [siteOptions, setSiteOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [loadingSites, setLoadingSites] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const startDate = new Date();
    // startDate.setDate(startDate.getDate() - 2);
    const endDate = new Date();
    const [userFilters, setUserFilters] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        user: "",
        start_date: startDate,
        end_date: endDate,
        start_time: null,
        end_time: null,
        ground_truth: null,
        clip_result: null,
        site_ids: [],
        camera_ids: []
    });
    const [siteDropDownValue, setSiteDropDownValue] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [cameraDropDownValue, setCameraDropDownValue] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [cameraOptions, setCameraOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [loadingCameras, setLoadingCameras] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [fetchingFilteredData, setFetchingFilteredData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [fetchingFilteredDataSentinel, setFetchingFilteredDataSentinel] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const userInfo = JSON.parse(localStorage.userInfo);
    const showUserDropDown = userInfo.permission.ailink_index || userInfo.permission.super_user;
    const showUserDropDownSentinel = userInfo.permission.ailink_index;
    const [userDropDownValue, setUserDropDownValue] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [groupID, setGroupID] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const aiLinkUsers = JSON.parse(localStorage.aiLinkUsers);
    const sentinelUsers = JSON.parse(localStorage.sentinelUsers);
    const [userDropDownValueSentinel, setUserDropDownValueSentinel] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [cameraDropDownValueSentinel, setCameraDropDownValueSentinel] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [userFiltersSentinel, setUserFiltersSentinel] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        user: "sentinel",
        group_id: null,
        start_date: startDate,
        end_date: endDate,
        start_time: null,
        end_time: null,
        clip_result: null,
        site_ids: [],
        camera_ids: []
    });
    const [siteDropDownValueSentinel, setSiteDropDownValueSentinel] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [siteOptionsSentinel, setSiteOptionsSentinel] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [loadingCamerasSentinel, setLoadingCamerasSentinel] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [cameraOptionsSentinel, setCameraOptionsSentinel] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [loadingSitesSentinel, setLoadingSitesSentinel] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [aiLinkClipsTotal, setAiLinkClipsTotal] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [loadingAdditionalData, setLoadingAdditionalData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [loadingAdditionalDataSentinel, setLoadingAdditionalDataSentinel] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const { noDataToDisplaySMTP: noDataToDisplaySMTP, fetchingFilteredDataSMTP: fetchingFilteredDataSMTP, noDataToDisplayFrontel: noDataToDisplayFrontel, filtersAppliedFrontel: filtersAppliedFrontel, fetchingFilteredDataFrontel: fetchingFilteredDataFrontel, showFrontelTab: showFrontelTab, smtpData: smtpData, setSmtpData: setSmtpData, selectedRowSMTP: selectedRowSMTP, setSelectedRowSMTP: setSelectedRowSMTP, setVideoClipLoadingSMTP: setVideoClipLoadingSMTP, getVideoURLSMTP: getVideoURLSMTP, userFiltersSMTP: userFiltersSMTP, frontelData: frontelData, setFrontelData: setFrontelData, selectedRowFrontel: selectedRowFrontel, setSelectedRowFrontel: setSelectedRowFrontel, setVideoClipLoadingFrontel: setVideoClipLoadingFrontel, getClipInfoFrontel: getClipInfoFrontel, getVideoURLFrontel: getVideoURLFrontel, userFiltersFrontel: userFiltersFrontel, setVerifiedClickedFrontel: setVerifiedClickedFrontel, setUnverifiedClickedFrontel: setUnverifiedClickedFrontel } = (0, $4G44R.useClipsStore)();
    const forwardClick = ()=>{
        (0, $6ffe9bce231338f8$export$a0a7f97c31933ae5)(clipsData, selectedRow, clipsIndexOrder, "forward", setSelectedRow, setClipsData, setVideoClipLoading, setVerifiedClicked, setUnverifiedClicked, setVideoURL, userFilters, navigate);
    };
    const backClick = ()=>{
        (0, $6ffe9bce231338f8$export$a0a7f97c31933ae5)(clipsData, selectedRow, clipsIndexOrder, "back", setSelectedRow, setClipsData, setVideoClipLoading, setVerifiedClicked, setUnverifiedClicked, setVideoURL, userFilters, navigate);
    };
    const handlers = {
        FORWARD_CLICK: forwardClick,
        BACK_CLICK: backClick
    };
    const keyMap = {
        FORWARD_CLICK: "right",
        BACK_CLICK: "left"
    };
    const [clickedTab, setClickedTab] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("one");
    const [filtersApplied, setFiltersApplied] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [timeFiltersDisabledAILink, setTimeFiltersDisabledAILink] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [timeFiltersDisabledSentinel, setTimeFiltersDisabledSentinel] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [tabsReady, setTabsReady] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const frontelCheckStartedRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(false);
    const handledUrlClipSelectionRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef("");
    const [urlClipNotFoundOpen, setUrlClipNotFoundOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const handleUrlClipNotFoundClose = (_event, reason)=>{
        if (reason === "clickaway") return;
        setUrlClipNotFoundOpen(false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        frontelCheckStartedRef.current = true;
        setLoadingGroupsFrontel(true);
        getUserGroupsFrontel(navigate);
    }, [
        navigate
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (frontelCheckStartedRef.current && !loadingGroupsFrontel) setTabsReady(true);
    }, [
        loadingGroupsFrontel
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        const userInfo = JSON.parse(localStorage.userInfo);
        if (showUserDropDown && userInfo.permission.ailink && !userInfo.permission.sentinel) {
            setActiveClipsTab("ailink");
            setClickedTab("one");
            setPageLoading(false);
        }
        if (showUserDropDown && userInfo.permission.ailink && userInfo.permission.sentinel) {
            setActiveClipsTab("ailink");
            setClickedTab("one");
            setPageLoading(false);
            setPageLoadingSentinel(false);
        }
        if (showUserDropDown && !userInfo.permission.ailink && userInfo.permission.sentinel) {
            setActiveClipsTab("sentinel");
            setClickedTab("one");
            setPageLoadingSentinel(false);
        }
        const aiLinkUsers = JSON.parse(localStorage.aiLinkUsers);
        const sentinelUsers = JSON.parse(localStorage.sentinelUsers);
        if (!showUserDropDown && userInfo.permission.ailink) {
            const userInfo = JSON.parse(localStorage.userInfo);
            // setFetchingFilteredData(true);
            if (userInfo.permission.ailink) {
                setActiveClipsTab("ailink");
                setClickedTab("one");
                // Plain ailink users never see the user dropdown that would set
                // userFilters.user / groupID, so self-populate them from the user's
                // own immix credential. Without this, userFilters.user stays "" and
                // the report prefetch in AILinkFilters bails on `!userFilters?.user`,
                // leaving the Download Report button permanently disabled (BT-1136).
                if (aiLinkUsers[0]) {
                    setUserFilters((previousState)=>{
                        return {
                            ...previousState,
                            user: aiLinkUsers[0].username
                        };
                    });
                    if (aiLinkUsers[0].group) {
                        setUserDropDownValue(aiLinkUsers[0].group.name);
                        setGroupID(aiLinkUsers[0].group.id);
                    }
                }
                (0, $b94416ec814c369f$export$e8f5d2acbd281022)(setSiteOptions, setLoadingSites, userInfo.group.id, navigate);
            }
        }
        if (!showUserDropDown && userInfo.permission.sentinel) {
            // setFetchingFilteredDataSentinel(true);
            setActiveClipsTab("sentinel");
            setClickedTab("two");
            if (sentinelUsers[0]) {
                setUserFiltersSentinel((previousState)=>{
                    return {
                        ...previousState,
                        user: sentinelUsers[0].username,
                        group_id: sentinelUsers[0].group?.id ?? null
                    };
                });
                (0, $b94416ec814c369f$export$e8f5d2acbd281022)(setSiteOptionsSentinel, setLoadingSitesSentinel, sentinelUsers[0].group.id, navigate);
            }
        }
        if (!showUserDropDown && userInfo.permission.smtp && !userInfo.permission.ailink && !userInfo.permission.sentinel) {
            setActiveClipsTab("smtp");
            setClickedTab("three");
            setPageLoading(false);
        }
        if (!showUserDropDown && userInfo.permission.sentinel && userInfo.permission.smtp && !userInfo.permission.ailink) {
            setActiveClipsTab("sentinel");
            setClickedTab("two");
            if (sentinelUsers[0]) {
                setUserFiltersSentinel((previousState)=>{
                    return {
                        ...previousState,
                        user: sentinelUsers[0].username,
                        group_id: sentinelUsers[0].group?.id ?? null
                    };
                });
                (0, $b94416ec814c369f$export$e8f5d2acbd281022)(setSiteOptionsSentinel, setLoadingSitesSentinel, sentinelUsers[0].group.id, navigate);
            }
        }
        if (!userInfo.permission.ailink && !userInfo.permission.sentinel && !userInfo.permission.smtp && showFrontelTab) {
            setActiveClipsTab("frontel");
            setClickedTab("four");
            setPageLoading(false);
        }
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        const userInfo = JSON.parse(localStorage.userInfo);
        if (!userInfo.permission.ailink && !userInfo.permission.sentinel && !userInfo.permission.smtp && showFrontelTab) {
            setActiveClipsTab("frontel");
            setClickedTab("four");
            setPageLoading(false);
        }
    }, [
        showFrontelTab
    ]);
    const hasAppliedUrlParamsRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (Array.from(searchParams).length === 0) return;
        const userInfo = JSON.parse(localStorage.userInfo);
        const parsed = (0, $60d1d427e7f38222$export$7bec5a0d32106be6)(searchParams);
        const tabToClickedTab = {
            ailink: "one",
            sentinel: "two",
            smtp: "three",
            frontel: "four"
        };
        const isTabVisible = (tab)=>{
            if (tab === "ailink") return !!userInfo.permission.ailink;
            if (tab === "sentinel") return !!userInfo.permission.sentinel;
            if (tab === "smtp") return !!userInfo.permission.smtp;
            if (tab === "frontel") return !!showFrontelTab;
            return false;
        };
        const urlTabVisible = parsed.tab ? isTabVisible(parsed.tab) : false;
        if (parsed.tab && urlTabVisible) {
            setActiveClipsTab(parsed.tab);
            setClickedTab(tabToClickedTab[parsed.tab] || "one");
        }
        const effectiveTab = parsed.tab && isTabVisible(parsed.tab) ? parsed.tab : activeClipsTab;
        const validTabs = [
            "ailink",
            "sentinel",
            "smtp",
            "frontel"
        ];
        if (!effectiveTab || !validTabs.includes(effectiveTab)) return;
        if (parsed.hasAnyFilterParam && effectiveTab === parsed.tab) {
            if (hasAppliedUrlParamsRef.current) return;
            hasAppliedUrlParamsRef.current = true;
            const baseStart = userFilters.start_date;
            const baseEnd = userFilters.end_date;
            if (effectiveTab === "ailink") {
                setUserFilters((prev)=>({
                        ...prev,
                        user: parsed.user ?? prev.user,
                        site_ids: parsed.siteIds.length ? parsed.siteIds : prev.site_ids,
                        camera_ids: parsed.cameraIds.length ? parsed.cameraIds : prev.camera_ids,
                        start_date: parsed.start_date ?? baseStart,
                        end_date: parsed.end_date ?? baseEnd,
                        start_time: parsed.start_time ?? prev.start_time,
                        end_time: parsed.end_time ?? prev.end_time,
                        ground_truth: parsed.ground_truth ?? prev.ground_truth,
                        clip_result: parsed.clip_result ?? prev.clip_result
                    }));
                const ailinkUsersFromStorage = (()=>{
                    try {
                        return JSON.parse(localStorage.aiLinkUsers || "[]");
                    } catch  {
                        return [];
                    }
                })();
                const ailinkMatch = ailinkUsersFromStorage.find((o)=>o?.username === (parsed.user ?? parsed.group) || o?.group?.name === (parsed.user ?? parsed.group));
                if (ailinkMatch?.group?.name) {
                    setUserDropDownValue(ailinkMatch.group.name);
                    if (ailinkMatch.group.id != null) {
                        setGroupID(ailinkMatch.group.id);
                        (0, $b94416ec814c369f$export$e8f5d2acbd281022)(setSiteOptions, setLoadingSites, ailinkMatch.group.id, navigate);
                    }
                }
            } else if (effectiveTab === "sentinel") {
                setUserFiltersSentinel((prev)=>({
                        ...prev,
                        user: parsed.user ?? prev.user,
                        site_ids: parsed.siteIds.length ? parsed.siteIds : prev.site_ids,
                        camera_ids: parsed.cameraIds.length ? parsed.cameraIds : prev.camera_ids,
                        start_date: parsed.start_date ?? baseStart,
                        end_date: parsed.end_date ?? baseEnd,
                        start_time: parsed.start_time ?? prev.start_time,
                        end_time: parsed.end_time ?? prev.end_time,
                        clip_result: parsed.clip_result ?? prev.clip_result
                    }));
                const sentinelUsersFromStorage = (()=>{
                    try {
                        return JSON.parse(localStorage.sentinelUsers || "[]");
                    } catch  {
                        return [];
                    }
                })();
                const sentinelMatch = sentinelUsersFromStorage.find((o)=>o?.username === (parsed.user ?? parsed.group) || o?.group?.name === (parsed.user ?? parsed.group));
                if (sentinelMatch?.group?.name) {
                    setUserDropDownValueSentinel(sentinelMatch.group.name);
                    if (sentinelMatch.group.id != null) {
                        setUserFiltersSentinel((prev)=>({
                                ...prev,
                                group_id: sentinelMatch.group.id
                            }));
                        (0, $b94416ec814c369f$export$e8f5d2acbd281022)(setSiteOptionsSentinel, setLoadingSitesSentinel, sentinelMatch.group.id, navigate);
                    }
                }
            } else if (effectiveTab === "smtp") {
                setUserFiltersSMTP((prev)=>({
                        ...prev,
                        site_ids: parsed.siteIds.length ? parsed.siteIds : prev.site_ids,
                        camera_ids: parsed.cameraIds.length ? parsed.cameraIds : prev.camera_ids,
                        start_date: parsed.start_date ?? prev.start_date,
                        end_date: parsed.end_date ?? prev.end_date,
                        start_time: parsed.start_time ?? prev.start_time,
                        end_time: parsed.end_time ?? prev.end_time
                    }));
                const smtpUserParam = parsed.user ?? parsed.group;
                if (smtpUserParam) try {
                    const parentAccounts = JSON.parse(localStorage.parentAccounts || "[]");
                    const idNum = parseInt(String(smtpUserParam).trim(), 10);
                    const matchById = !Number.isNaN(idNum);
                    const smtpMatch = (parentAccounts || []).find((o)=>matchById ? o?.id === idNum || o?.id == smtpUserParam : o?.name === smtpUserParam);
                    if (smtpMatch?.id != null) {
                        const store = (0, $4G44R.useClipsStore).getState();
                        store.setUserDropDownValueSMTP(smtpMatch.name);
                        store.setGroupIDSMTP(smtpMatch.id);
                        setUserFiltersSMTP((prev)=>({
                                ...prev,
                                user: smtpMatch.id,
                                group_id: smtpMatch.id
                            }));
                        getAllSitesClipsSMTP(smtpMatch.id, navigate);
                        store.getDownloadURLSMTP(navigate);
                    }
                } catch  {
                // ignore
                }
            } else if (effectiveTab === "frontel") {
                const groupOptionsFrontel = (0, $4G44R.useClipsStore).getState().groupOptionsFrontel || [];
                const userParam = parsed.user ?? parsed.group;
                let resolvedUsername = userParam ?? "";
                let resolvedGroupName = null;
                let resolvedGroupId = null;
                if (userParam && groupOptionsFrontel.length > 0) {
                    const match = groupOptionsFrontel.find((o)=>o?.username === userParam || o?.group?.name === userParam);
                    if (match?.group) {
                        resolvedUsername = match.username ?? userParam;
                        resolvedGroupName = match.group.name;
                        resolvedGroupId = match.group.id ?? null;
                    }
                }
                setUserFiltersFrontel((prev)=>({
                        ...prev,
                        user: resolvedUsername || prev.user,
                        site_ids: parsed.siteIds.length ? parsed.siteIds : prev.site_ids,
                        camera_ids: parsed.cameraIds.length ? parsed.cameraIds : prev.camera_ids,
                        start_date: parsed.start_date ?? prev.start_date,
                        end_date: parsed.end_date ?? prev.end_date,
                        start_time: parsed.start_time ?? prev.start_time,
                        end_time: parsed.end_time ?? prev.end_time
                    }));
                if (resolvedUsername) setFrontelUsername(resolvedUsername);
                if (resolvedGroupName !== null) setUserDropDownValueFrontel(resolvedGroupName);
                if (resolvedGroupId !== null) {
                    setGroupIDFrontel(resolvedGroupId);
                    getAllSitesFrontel(resolvedGroupId, navigate);
                }
            }
            if (effectiveTab === "ailink") {
                const ailinkFilters = {
                    ...userFilters,
                    user: parsed.user ?? userFilters.user,
                    site_ids: parsed.siteIds.length ? parsed.siteIds : userFilters.site_ids,
                    camera_ids: parsed.cameraIds.length ? parsed.cameraIds : userFilters.camera_ids,
                    start_date: parsed.start_date ?? userFilters.start_date,
                    end_date: parsed.end_date ?? userFilters.end_date,
                    start_time: parsed.start_time ?? userFilters.start_time,
                    end_time: parsed.end_time ?? userFilters.end_time,
                    ground_truth: parsed.ground_truth ?? userFilters.ground_truth,
                    clip_result: parsed.clip_result ?? userFilters.clip_result
                };
                setFiltersApplied(true);
                setFetchingFilteredData(true);
                setClipsData([]);
                setPage(0);
                setNoDataToDisplay(true);
                setSelectedRow({});
                (0, $3463043b4c6b2a57$export$bfad5f19668a7346)(setClipsData, setPageLoading, setSelectedRow, setPrecisionRecallData, setVideoURL, setVideoClipLoading, setClipsIndexOrder, setVerifiedClicked, setUnverifiedClicked, selectedRow, setNoDataToDisplay, setSiteOptions, setLoadingSites, ailinkFilters, setFetchingFilteredData, setPage, false, "", "", setLoadingAdditionalData, navigate);
            } else if (effectiveTab === "sentinel") {
                const sentinelFilters = {
                    ...userFiltersSentinel,
                    user: parsed.user ?? userFiltersSentinel.user,
                    site_ids: parsed.siteIds.length ? parsed.siteIds : userFiltersSentinel.site_ids,
                    camera_ids: parsed.cameraIds.length ? parsed.cameraIds : userFiltersSentinel.camera_ids,
                    start_date: parsed.start_date ?? userFiltersSentinel.start_date,
                    end_date: parsed.end_date ?? userFiltersSentinel.end_date,
                    start_time: parsed.start_time ?? userFiltersSentinel.start_time,
                    end_time: parsed.end_time ?? userFiltersSentinel.end_time,
                    clip_result: parsed.clip_result ?? userFiltersSentinel.clip_result
                };
                setFiltersApplied(true);
                setFetchingFilteredDataSentinel(true);
                setSentinelData([]);
                setPageSentinel(0);
                setNoDataToDisplaySentinel(true);
                setSelectedRowSentinel({});
                (0, $88GbJ.getSentinelClipsWithQuerry)(setSentinelData, setPageLoadingSentinel, setSelectedRowSentinel, setPrecisionRecallDataSentinel, setVideoURLSentinel, setVideoClipLoadingSentinel, setClipsIndexOrderSentinel, selectedRowSentinel, setNoDataToDisplaySentinel, setSiteOptionsSentinel, setLoadingSitesSentinel, sentinelFilters, setFetchingFilteredDataSentinel, setPageSentinel, "", "", false, setLoadingAdditionalDataSentinel, navigate);
            } else if (effectiveTab === "smtp" && parsed.siteIds.length > 0) {
                setFiltersAppliedSMTP(true);
                getSMTPData(navigate);
            } else if (effectiveTab === "frontel") {
                setFiltersAppliedFrontel(true);
                getFrontelData(navigate);
            }
        }
    }, [
        showFrontelTab
    ]);
    // When Sentinel URL params change (e.g. initial load or after Apply), sync dropdown and load sites from URL.
    // Deps only [searchParams] so we do NOT run on every re-render (sentinelUsers is read inside; including it would overwrite user's dropdown choice).
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!hasAppliedUrlParamsRef.current || !searchParams.get("tab") || searchParams.get("tab") !== "sentinel") return;
        const userParam = searchParams.get("user") || searchParams.get("group");
        if (!userParam) return;
        let users = [];
        try {
            users = JSON.parse(localStorage.sentinelUsers || "[]");
        } catch  {
            return;
        }
        if (!users?.length) return;
        const match = users.find((o)=>o?.username === userParam || o?.group?.name === userParam);
        if (match?.group?.name) {
            setUserDropDownValueSentinel(match.group.name);
            if (match.group.id != null) {
                setUserFiltersSentinel((prev)=>({
                        ...prev,
                        group_id: match.group.id
                    }));
                (0, $b94416ec814c369f$export$e8f5d2acbd281022)(setSiteOptionsSentinel, setLoadingSitesSentinel, match.group.id, navigate);
            }
        }
    }, [
        searchParams
    ]);
    // When Sentinel URL params included site= and sites have loaded, set site dropdown and load cameras.
    // Only sync site from URL when URL user/group matches the currently selected dropdown (userDropDownValueSentinel = group name).
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!hasAppliedUrlParamsRef.current || searchParams.get("tab") !== "sentinel") return;
        const parsed = (0, $60d1d427e7f38222$export$7bec5a0d32106be6)(searchParams);
        if (!parsed.siteIds?.length || !siteOptionsSentinel?.length) return;
        let urlMatchesSelection = true;
        try {
            const users = JSON.parse(localStorage.sentinelUsers || "[]");
            const sel = users?.find((o)=>o?.group?.name === userDropDownValueSentinel);
            if (sel && (parsed.user || parsed.group)) urlMatchesSelection = parsed.user === sel.username || parsed.user === sel.group?.name || String(parsed.group) === String(sel.group?.id);
        } catch  {
        // ignore
        }
        if (!urlMatchesSelection) return;
        const siteId = parsed.siteIds[0];
        const site = siteOptionsSentinel.find((s)=>s.id === siteId);
        if (!site || siteDropDownValueSentinel === site.name) return;
        setSiteDropDownValueSentinel(site.name);
        (0, $1a511a220e4442ce$export$1fedd6e3f8d8e03e)([
            String(siteId)
        ], navigate, setCameraOptionsSentinel, setLoadingCamerasSentinel);
    }, [
        searchParams,
        siteOptionsSentinel,
        siteDropDownValueSentinel,
        userDropDownValueSentinel
    ]);
    // When AILink URL params change (e.g. initial load or after Apply), sync dropdown and load sites from URL.
    // Deps only [searchParams] so we do NOT run on every re-render (aiLinkUsers is read inside; including it would run every render and overwrite user's dropdown choice).
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!hasAppliedUrlParamsRef.current || searchParams.get("tab") !== "ailink") return;
        const userParam = searchParams.get("user") || searchParams.get("group");
        if (!userParam) return;
        let users = [];
        try {
            users = JSON.parse(localStorage.aiLinkUsers || "[]");
        } catch  {
            return;
        }
        if (!users?.length) return;
        const match = users.find((o)=>o?.username === userParam || o?.group?.name === userParam);
        if (match?.group?.name) {
            setUserDropDownValue(match.group.name);
            if (match.group.id != null) {
                setGroupID(match.group.id);
                (0, $b94416ec814c369f$export$e8f5d2acbd281022)(setSiteOptions, setLoadingSites, match.group.id, navigate);
            }
        }
    }, [
        searchParams
    ]);
    // When AILink URL params included site= and sites have loaded, set site dropdown and load cameras.
    // Only sync site from URL when URL group matches the currently selected user's group (by userDropDownValue), not groupID state which can be stale.
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!hasAppliedUrlParamsRef.current || searchParams.get("tab") !== "ailink") return;
        const parsed = (0, $60d1d427e7f38222$export$7bec5a0d32106be6)(searchParams);
        if (!parsed.siteIds?.length || !siteOptions?.length) return;
        const urlGroupId = parsed.group ? parseInt(parsed.group, 10) : null;
        let selectedGroupId = null;
        try {
            const users = JSON.parse(localStorage.aiLinkUsers || "[]");
            const sel = users?.find((o)=>o?.group?.name === userDropDownValue);
            selectedGroupId = sel?.group?.id ?? null;
        } catch  {
        // ignore
        }
        if (urlGroupId != null && selectedGroupId != null && urlGroupId !== selectedGroupId) return;
        const siteId = parsed.siteIds[0];
        const site = siteOptions.find((s)=>s.id === siteId);
        if (!site || siteDropDownValue === site.name) return;
        setSiteDropDownValue(site.name);
        (0, $1a511a220e4442ce$export$1fedd6e3f8d8e03e)([
            String(siteId)
        ], navigate, setCameraOptions, setLoadingCameras);
    }, [
        searchParams,
        siteOptions,
        siteDropDownValue,
        userDropDownValue
    ]);
    // When SMTP URL params included site= and sites have loaded, set site dropdown and load cameras
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!hasAppliedUrlParamsRef.current || searchParams.get("tab") !== "smtp") return;
        const parsed = (0, $60d1d427e7f38222$export$7bec5a0d32106be6)(searchParams);
        if (!parsed.siteIds?.length || !siteOptionsSMTP?.length) return;
        const siteId = parsed.siteIds[0];
        const site = siteOptionsSMTP.find((s)=>s.id === siteId || s.id == siteId);
        if (!site) return;
        const store = (0, $4G44R.useClipsStore).getState();
        if (store.siteDropDownValueSMTP === site.name) return;
        setSiteDropDownValueSMTP(site.name);
        getCamerasBySiteSMTP([
            String(siteId)
        ], navigate);
    }, [
        searchParams,
        siteOptionsSMTP
    ]);
    // When Frontel URL params included site= and sites have loaded, set site dropdown and load cameras
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!hasAppliedUrlParamsRef.current || searchParams.get("tab") !== "frontel") return;
        const parsed = (0, $60d1d427e7f38222$export$7bec5a0d32106be6)(searchParams);
        if (!parsed.siteIds?.length || !siteOptionsFrontel?.length) return;
        const siteId = parsed.siteIds[0];
        const site = siteOptionsFrontel.find((s)=>s.id === siteId);
        if (!site) return;
        const store = (0, $4G44R.useClipsStore).getState();
        if (store.siteDropDownValueFrontel === site.name) return;
        setSiteDropDownValueFrontel(site.name);
        getCamerasBySiteFrontel([
            String(siteId)
        ], navigate);
    }, [
        searchParams,
        siteOptionsFrontel
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        const parsed = (0, $60d1d427e7f38222$export$7bec5a0d32106be6)(searchParams);
        const tab = parsed.tab;
        if (!tab) return;
        const targetId = tab === "smtp" ? parsed.clip_id : parsed.file_id;
        if (!targetId) return;
        const selectionKey = `${tab}:${targetId}`;
        if (handledUrlClipSelectionRef.current === selectionKey) return;
        const uuidV4LikeRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        if (tab === "ailink") {
            const outcome = (0, $e2db034a6b9f3a4e$export$15f561d1a43ca288)({
                tab: "ailink",
                targetId: targetId,
                clipsData: clipsData,
                sentinelData: sentinelData,
                smtpData: smtpData,
                frontelData: frontelData,
                fetchingFilteredData: fetchingFilteredData,
                fetchingFilteredDataSentinel: fetchingFilteredDataSentinel,
                fetchingFilteredDataSMTP: fetchingFilteredDataSMTP,
                fetchingFilteredDataFrontel: fetchingFilteredDataFrontel,
                filtersApplied: filtersApplied,
                filtersAppliedSMTP: filtersAppliedSMTP,
                filtersAppliedFrontel: filtersAppliedFrontel
            });
            if (outcome.status === "skip") return;
            if (outcome.status === "not_found") {
                handledUrlClipSelectionRef.current = selectionKey;
                setUrlClipNotFoundOpen(true);
                return;
            }
            const row = outcome.row;
            handledUrlClipSelectionRef.current = selectionKey;
            setVideoClipLoading(true);
            (0, $0465d401e2e7f520$export$44bad2a4de61b28d)(row, setVerifiedClicked, setUnverifiedClicked);
            (0, $54027012fff01b21$export$2fd5d64b4d451d7b)(row, setSelectedRow, setVideoURL, setVideoClipLoading, clipsData, setClipsData, selectedRow, userFilters, "ailink", userFilters.user, navigate);
            return;
        }
        if (tab === "sentinel") {
            if (!uuidV4LikeRegex.test(targetId)) {
                handledUrlClipSelectionRef.current = selectionKey;
                setUrlClipNotFoundOpen(true);
                return;
            }
            if (loadingAdditionalDataSentinel) {
                const rowWhileLoading = sentinelData.find((item)=>item.file_id === targetId) ?? null;
                if (rowWhileLoading) {
                    handledUrlClipSelectionRef.current = selectionKey;
                    setVideoClipLoadingSentinel(true);
                    (0, $54027012fff01b21$export$2fd5d64b4d451d7b)(rowWhileLoading, setSelectedRowSentinel, setVideoURLSentinel, setVideoClipLoadingSentinel, sentinelData, setSentinelData, selectedRowSentinel, userFiltersSentinel, "sentinel", userFiltersSentinel.user, navigate);
                }
                return;
            }
            const outcome = (0, $e2db034a6b9f3a4e$export$15f561d1a43ca288)({
                tab: "sentinel",
                targetId: targetId,
                clipsData: clipsData,
                sentinelData: sentinelData,
                smtpData: smtpData,
                frontelData: frontelData,
                fetchingFilteredData: fetchingFilteredData,
                fetchingFilteredDataSentinel: fetchingFilteredDataSentinel,
                fetchingFilteredDataSMTP: fetchingFilteredDataSMTP,
                fetchingFilteredDataFrontel: fetchingFilteredDataFrontel,
                filtersApplied: filtersApplied,
                filtersAppliedSMTP: filtersAppliedSMTP,
                filtersAppliedFrontel: filtersAppliedFrontel
            });
            if (outcome.status === "skip") return;
            if (outcome.status === "not_found") {
                handledUrlClipSelectionRef.current = selectionKey;
                setUrlClipNotFoundOpen(true);
                return;
            }
            const row = outcome.row;
            handledUrlClipSelectionRef.current = selectionKey;
            setVideoClipLoadingSentinel(true);
            (0, $54027012fff01b21$export$2fd5d64b4d451d7b)(row, setSelectedRowSentinel, setVideoURLSentinel, setVideoClipLoadingSentinel, sentinelData, setSentinelData, selectedRowSentinel, userFiltersSentinel, "sentinel", userFiltersSentinel.user, navigate);
            return;
        }
        if (tab === "smtp") {
            const outcome = (0, $e2db034a6b9f3a4e$export$15f561d1a43ca288)({
                tab: "smtp",
                targetId: targetId,
                clipsData: clipsData,
                sentinelData: sentinelData,
                smtpData: smtpData,
                frontelData: frontelData,
                fetchingFilteredData: fetchingFilteredData,
                fetchingFilteredDataSentinel: fetchingFilteredDataSentinel,
                fetchingFilteredDataSMTP: fetchingFilteredDataSMTP,
                fetchingFilteredDataFrontel: fetchingFilteredDataFrontel,
                filtersApplied: filtersApplied,
                filtersAppliedSMTP: filtersAppliedSMTP,
                filtersAppliedFrontel: filtersAppliedFrontel
            });
            if (outcome.status === "skip") return;
            if (outcome.status === "not_found") {
                handledUrlClipSelectionRef.current = selectionKey;
                setUrlClipNotFoundOpen(true);
                return;
            }
            const row = outcome.row;
            handledUrlClipSelectionRef.current = selectionKey;
            setSmtpData(smtpData.map((item)=>({
                    ...item,
                    selected: item.clip_id === row.clip_id
                })));
            setVideoClipLoadingSMTP(true);
            setSelectedRowSMTP(row);
            getVideoURLSMTP(row.clip_id, navigate);
            localStorage.setItem("clipsSelectedRow", JSON.stringify(row));
            return;
        }
        if (tab === "frontel") {
            const outcome = (0, $e2db034a6b9f3a4e$export$15f561d1a43ca288)({
                tab: "frontel",
                targetId: targetId,
                clipsData: clipsData,
                sentinelData: sentinelData,
                smtpData: smtpData,
                frontelData: frontelData,
                fetchingFilteredData: fetchingFilteredData,
                fetchingFilteredDataSentinel: fetchingFilteredDataSentinel,
                fetchingFilteredDataSMTP: fetchingFilteredDataSMTP,
                fetchingFilteredDataFrontel: fetchingFilteredDataFrontel,
                filtersApplied: filtersApplied,
                filtersAppliedSMTP: filtersAppliedSMTP,
                filtersAppliedFrontel: filtersAppliedFrontel
            });
            if (outcome.status === "skip") return;
            if (outcome.status === "not_found") {
                handledUrlClipSelectionRef.current = selectionKey;
                setUrlClipNotFoundOpen(true);
                return;
            }
            const row = outcome.row;
            handledUrlClipSelectionRef.current = selectionKey;
            setFrontelData(frontelData.map((item)=>({
                    ...item,
                    selected: item.file_id === row.file_id
                })));
            setVideoClipLoadingFrontel(true);
            setSelectedRowFrontel(row);
            (0, $914ff183d8ca9dd6$export$f44402e41fb4d26)(row, setVerifiedClickedFrontel, setUnverifiedClickedFrontel);
            getClipInfoFrontel(row.file_id, navigate);
            getVideoURLFrontel(row.file_id, navigate);
            localStorage.setItem("clipsSelectedRow", JSON.stringify(row));
        }
    }, [
        searchParams,
        clipsData,
        sentinelData,
        smtpData,
        frontelData,
        fetchingFilteredData,
        fetchingFilteredDataSentinel,
        fetchingFilteredDataSMTP,
        fetchingFilteredDataFrontel,
        filtersApplied,
        filtersAppliedSMTP,
        filtersAppliedFrontel,
        selectedRow,
        selectedRowSentinel,
        userFilters,
        userFiltersSentinel,
        navigate,
        setVideoClipLoading,
        setVideoClipLoadingSentinel,
        setVideoClipLoadingSMTP,
        setVideoClipLoadingFrontel,
        setSelectedRow,
        setSelectedRowSentinel,
        setSelectedRowSMTP,
        setSelectedRowFrontel,
        setClipsData,
        setSentinelData,
        setSmtpData,
        setFrontelData,
        setVideoURL,
        setVideoURLSentinel,
        setVerifiedClicked,
        setUnverifiedClicked,
        setVerifiedClickedFrontel,
        setUnverifiedClickedFrontel,
        getVideoURLSMTP,
        getClipInfoFrontel,
        getVideoURLFrontel
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setAiLinkClipsTotal(clipsData.length);
    }, [
        clipsData
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        // if (userPermissions.super_user) {
        //   getUserGroupsSMTP(navigate);
        // }
        // else {
        const userInfo = JSON.parse(localStorage.userInfo);
        getAllSitesClipsSMTP(userInfo.group.id, navigate);
    // }
    }, []);
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const setScrollTop = (event)=>{
        localStorage.setItem("clipsScrollTop", event.target.scrollTop);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (ref) {
            if (ref.current !== null) ref.current.scrollTop = localStorage.clipsScrollTop;
        }
    }, [
        clipsData
    ]);
    const scrollToTop = ()=>{
        if (ref) {
            if (ref.current !== null) ref.current.scrollTop = 62;
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        const userInfo = JSON.parse(localStorage.userInfo);
        if (!userInfo.permission.ailink || !userInfo.permission.sentinel) scrollToTop();
    }, []);
    // React.useEffect(() => {
    //     getSMTPData(groupID, navigate);
    // }, []);
    const parentAccounts = JSON.parse(localStorage.parentAccounts);
    let userPerissionNumber = 0;
    if (userInfo.permission.ailink) userPerissionNumber++;
    if (userInfo.permission.sentinel) userPerissionNumber++;
    if (userInfo.permission.smtp) userPerissionNumber++;
    if (showFrontelTab) userPerissionNumber++;
    const hasUrlParams = Array.from(searchParams).length > 0;
    const parsedUrlTab = hasUrlParams ? (0, $60d1d427e7f38222$export$7bec5a0d32106be6)(searchParams).tab : null;
    const urlWantsFrontel = hasUrlParams && parsedUrlTab === "frontel";
    const showTabs = tabsReady && (!hasUrlParams || !urlWantsFrontel || showFrontelTab);
    const clipsFilterBandHeight = userPerissionNumber > 1 ? 152 : 92;
    return(// <HotKeys handlers={handlers} keyMap={keyMap}>
    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $4311f8367c4f9b57$export$2e2bcd8739ae039), {
                openState: fetchingFilteredData,
                aiLinkClipsTotal: aiLinkClipsTotal
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $a0e715ead9417e7e$export$2e2bcd8739ae039), {
                openState: fetchingFilteredDataSentinel
            }),
            fetchingFilteredDataSMTP && /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                openState: fetchingFilteredDataSMTP
            }),
            fetchingFilteredDataFrontel && /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                openState: fetchingFilteredDataFrontel
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "absolute w-full h-full overflow-scroll",
                style: {
                    background: `linear-gradient(to bottom, #FFFFFF 0px, #FFFFFF ${clipsFilterBandHeight}px, #E5E5E5 ${clipsFilterBandHeight}px, #E5E5E5 100%)`,
                    backgroundAttachment: "local"
                },
                onScroll: setScrollTop,
                ref: ref,
                children: showTabs && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: !navBarCollapsed ? "absolute top-0 left-[170px] right-[1px] z-10" : "absolute top-0 left-[95px] right-[1px] z-10",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8ac4bf0f042118db$export$a64baa35607abce6), {
                                clickedTab: clickedTab,
                                setClickedTab: setClickedTab
                            })
                        }),
                        !pageLoadingSentinel && activeClipsTab === "sentinel" && !(userInfo.permission.smtp && !userInfo.permission.ailink && !userInfo.permission.sentinel) && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: userPerissionNumber > 1 ? `absolute h-[152px] left-[0px] right-0` : `absolute h-[92px] left-[0px] right-0`,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: !navBarCollapsed ? "font-mulish absolute left-[160px] top-[15px]" : "font-mulish absolute left-[85px] top-[15px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $e3a860ea1a5370e4$export$4453df94902799fa), {
                                                showUserDropDownSentinel: showUserDropDownSentinel,
                                                userDropDownValueSentinel: userDropDownValueSentinel,
                                                userOptions: sentinelUsers,
                                                setUserDropDownValueSentinel: setUserDropDownValueSentinel,
                                                setCameraDropDownValueSentinel: setCameraDropDownValueSentinel,
                                                setUserFiltersSentinel: setUserFiltersSentinel,
                                                setSiteDropDownValueSentinel: setSiteDropDownValueSentinel,
                                                setSiteOptionsSentinel: setSiteOptionsSentinel,
                                                setCameraOptionsSentinel: setCameraOptionsSentinel,
                                                setLoadingSitesSentinel: setLoadingSitesSentinel,
                                                siteOptionsSentinel: siteOptionsSentinel,
                                                loadingSitesSentinel: loadingSitesSentinel,
                                                siteDropDownValueSentinel: siteDropDownValueSentinel,
                                                setLoadingCamerasSentinel: setLoadingCamerasSentinel,
                                                cameraOptionsSentinel: cameraOptionsSentinel,
                                                cameraDropDownValueSentinel: cameraDropDownValueSentinel,
                                                loadingCamerasSentinel: loadingCamerasSentinel,
                                                userFiltersSentinel: userFiltersSentinel,
                                                setSentinelData: setSentinelData,
                                                setPageLoadingSentinel: setPageLoadingSentinel,
                                                setSelectedRowSentinel: setSelectedRowSentinel,
                                                setPrecisionRecallDataSentinel: setPrecisionRecallDataSentinel,
                                                setVideoURLSentinel: setVideoURLSentinel,
                                                setVideoClipLoadingSentinel: setVideoClipLoadingSentinel,
                                                setClipsIndexOrderSentinel: setClipsIndexOrderSentinel,
                                                selectedRowSentinel: selectedRowSentinel,
                                                setNoDataToDisplaySentinel: setNoDataToDisplaySentinel,
                                                setFetchingFilteredDataSentinel: setFetchingFilteredDataSentinel,
                                                setPageSentinel: setPageSentinel,
                                                onSentinelFiltersApply: ()=>{
                                                    setSentinelFilterApplyToken((previous)=>previous + 1);
                                                    setPageSentinel(0);
                                                },
                                                setLoadingAdditionalData: setLoadingAdditionalDataSentinel,
                                                navBarCollapsed: navBarCollapsed,
                                                setFiltersApplied: setFiltersApplied,
                                                timeFiltersDisabledSentinel: timeFiltersDisabledSentinel,
                                                setTimeFiltersDisabledSentinel: setTimeFiltersDisabledSentinel,
                                                userInfo: userInfo,
                                                navigate: navigate,
                                                setSearchParams: setSearchParams
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        children: [
                                            !noDataToDisplaySentinel && filtersApplied && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $2df369e4e369b790$export$63b101394cabb828), {
                                                    showMoreDialogOpenSentinel: showMoreDialogOpenSentinel,
                                                    setShowMoreDialogOpenSentinel: setShowMoreDialogOpenSentinel,
                                                    selectedRowSentinel: selectedRowSentinel,
                                                    videoURLSentinel: videoURLSentinel,
                                                    sentinelData: sentinelData,
                                                    pageSentinel: pageSentinel,
                                                    setPageSentinel: setPageSentinel,
                                                    sentinelFilterApplyToken: sentinelFilterApplyToken,
                                                    precisionRecallDataSentinel: precisionRecallDataSentinel,
                                                    videoClipLoadingSentinel: videoClipLoadingSentinel,
                                                    setVideoURLSentinel: setVideoURLSentinel,
                                                    setVideoClipLoadingSentinel: setVideoClipLoadingSentinel,
                                                    setSelectedRowSentinel: setSelectedRowSentinel,
                                                    setSentinelData: setSentinelData,
                                                    scrollToTop: scrollToTop,
                                                    setPageLoadingSentinel: setPageLoadingSentinel,
                                                    clipsIndexOrderSentinel: clipsIndexOrderSentinel,
                                                    setClipsIndexOrderSentinel: setClipsIndexOrderSentinel,
                                                    fetchingFilteredDataSentinel: fetchingFilteredDataSentinel,
                                                    userFiltersSentinel: userFiltersSentinel,
                                                    loadingAdditionalData: loadingAdditionalDataSentinel,
                                                    navBarCollapsed: navBarCollapsed,
                                                    userInfo: userInfo,
                                                    navigate: navigate
                                                })
                                            }),
                                            noDataToDisplaySentinel && filtersApplied && !fetchingFilteredDataSentinel && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "relative top-[200px] text-center",
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                    className: "font-mulish text-[22px]",
                                                    children: "No Clips to Display."
                                                })
                                            }),
                                            !filtersApplied && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                className: "relative top-[200px] text-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                        className: "font-mulish text-[22px]",
                                                        children: "Please Apply Filters to View Clips."
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                        className: "font-mulish text-[18px]",
                                                        children: "To view clips for all sites, leave the Site and Camera filters empty."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        !pageLoading && activeClipsTab === "ailink" && !(userInfo.permission.smtp && !userInfo.permission.ailink && !userInfo.permission.sentinel) && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: userPerissionNumber > 1 ? `absolute h-[152px] left-[0px] right-0` : `absolute h-[92px] left-[0px] right-0`,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: !navBarCollapsed ? "font-mulish absolute left-[160px] top-[15px]" : "font-mulish absolute left-[85px] top-[15px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $10079186e7068381$export$7bb930e6ad93bc7b), {
                                                siteOptions: siteOptions,
                                                loadingSites: loadingSites,
                                                siteDropDownValue: siteDropDownValue,
                                                setSiteDropDownValue: setSiteDropDownValue,
                                                setCameraDropDownValue: setCameraDropDownValue,
                                                setUserFilters: setUserFilters,
                                                setCameraOptions: setCameraOptions,
                                                setLoadingCameras: setLoadingCameras,
                                                cameraDropDownValue: cameraDropDownValue,
                                                cameraOptions: cameraOptions,
                                                loadingCameras: loadingCameras,
                                                userFilters: userFilters,
                                                setClipsData: setClipsData,
                                                setPageLoading: setPageLoading,
                                                setSelectedRow: setSelectedRow,
                                                setPrecisionRecallData: setPrecisionRecallData,
                                                setVideoURL: setVideoURL,
                                                setVideoClipLoading: setVideoClipLoading,
                                                setClipsIndexOrder: setClipsIndexOrder,
                                                setVerifiedClicked: setVerifiedClicked,
                                                setUnverifiedClicked: setUnverifiedClicked,
                                                selectedRow: selectedRow,
                                                setNoDataToDisplay: setNoDataToDisplay,
                                                setSiteOptions: setSiteOptions,
                                                setLoadingSites: setLoadingSites,
                                                setFetchingFilteredData: setFetchingFilteredData,
                                                setPage: setPage,
                                                showUserDropDown: showUserDropDown,
                                                userDropDownValue: userDropDownValue,
                                                userOptions: aiLinkUsers,
                                                setUserDropDownValue: setUserDropDownValue,
                                                groupID: groupID,
                                                setGroupID: setGroupID,
                                                setAiLinkClipsTotal: setAiLinkClipsTotal,
                                                setLoadingAdditionalData: setLoadingAdditionalData,
                                                navBarCollapsed: navBarCollapsed,
                                                userInfo: userInfo,
                                                setFiltersApplied: setFiltersApplied,
                                                timeFiltersDisabledAILink: timeFiltersDisabledAILink,
                                                setTimeFiltersDisabledAILink: setTimeFiltersDisabledAILink,
                                                navigate: navigate,
                                                setSearchParams: setSearchParams
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        children: [
                                            !noDataToDisplay && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $7547e21e20af6a91$export$e9ae1b6c451fd3eb), {
                                                    showMoreDialogOpen: showMoreDialogOpen,
                                                    setShowMoreDialogOpen: setShowMoreDialogOpen,
                                                    selectedRow: selectedRow,
                                                    videoURL: videoURL,
                                                    clipsData: clipsData,
                                                    page: page,
                                                    setPage: setPage,
                                                    precisionRecallData: precisionRecallData,
                                                    videoClipLoading: videoClipLoading,
                                                    setVideoClipLoading: setVideoClipLoading,
                                                    setVideoURL: setVideoURL,
                                                    setSelectedRow: setSelectedRow,
                                                    setClipsData: setClipsData,
                                                    scrollToTop: scrollToTop,
                                                    verifiedClicked: verifiedClicked,
                                                    unverifiedClicked: unverifiedClicked,
                                                    setVerifiedClicked: setVerifiedClicked,
                                                    setUnverifiedClicked: setUnverifiedClicked,
                                                    setPageLoading: setPageLoading,
                                                    clipsIndexOrder: clipsIndexOrder,
                                                    setClipsIndexOrder: setClipsIndexOrder,
                                                    fetchingFilteredData: fetchingFilteredData,
                                                    userFilters: userFilters,
                                                    loadingAdditionalData: loadingAdditionalData,
                                                    navBarCollapsed: navBarCollapsed,
                                                    userInfo: userInfo,
                                                    navigate: navigate
                                                })
                                            }),
                                            noDataToDisplay && filtersApplied && !fetchingFilteredData && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "relative top-[200px] text-center",
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                    className: "font-mulish text-[22px]",
                                                    children: "No Clips to Display."
                                                })
                                            }),
                                            !filtersApplied && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                className: "relative top-[200px] text-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                        className: "font-mulish text-[22px]",
                                                        children: "Please Apply Filters to View Clips."
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                        className: "font-mulish text-[18px]",
                                                        children: "To view clips for all sites, leave the Site and Camera filters empty."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        !pageLoadingSMTP && activeClipsTab === "smtp" && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: userPerissionNumber > 1 ? `absolute h-[152px] left-[0px] right-0` : `absolute h-[92px] left-[0px] right-0`,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: !navBarCollapsed ? "font-mulish absolute left-[160px] top-[15px]" : "font-mulish absolute left-[85px] top-[15px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $54ec604d0cb2a34d$export$df038345ec00c266), {
                                                showUserDropDown: showUserDropDown,
                                                navBarCollapsed: navBarCollapsed,
                                                userOptions: parentAccounts,
                                                setSearchParams: setSearchParams
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        children: [
                                            !noDataToDisplaySMTP && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3f9f1c29f4deaae4$export$91fa97cc40700815), {
                                                    navBarCollapsed: navBarCollapsed
                                                })
                                            }),
                                            noDataToDisplaySMTP && filtersAppliedSMTP && !fetchingFilteredDataSMTP && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "relative top-[200px] text-center",
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                    className: "font-mulish text-[22px]",
                                                    children: "No Clips to Display."
                                                })
                                            }),
                                            !filtersAppliedSMTP && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "relative top-[200px] text-center",
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                    className: "font-mulish text-[22px]",
                                                    children: "Please Apply Filters to View Clips."
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        activeClipsTab === "frontel" && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: userPerissionNumber > 1 ? `absolute h-[152px] left-[0px] right-0` : `absolute h-[92px] left-[0px] right-0`,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                            className: !navBarCollapsed ? "font-mulish absolute left-[160px] top-[15px]" : "font-mulish absolute left-[85px] top-[15px]",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ffba2081b6c8d397$export$fd0b4c8efafb178c), {
                                                showUserDropDown: true,
                                                navBarCollapsed: navBarCollapsed,
                                                setSearchParams: setSearchParams
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        children: [
                                            !noDataToDisplayFrontel && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $de33098d550b4fe6$export$3e78047c5430a474), {
                                                    navBarCollapsed: navBarCollapsed
                                                })
                                            }),
                                            noDataToDisplayFrontel && filtersAppliedFrontel && !fetchingFilteredDataFrontel && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "relative top-[200px] text-center",
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                    className: "font-mulish text-[22px]",
                                                    children: "No Clips to Display."
                                                })
                                            }),
                                            !filtersAppliedFrontel && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "relative top-[200px] text-center",
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                    className: "font-mulish text-[22px]",
                                                    children: "Please Apply Filters to View Clips."
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8E01L.default), {
                open: urlClipNotFoundOpen,
                autoHideDuration: 12000,
                onClose: handleUrlClipNotFoundClose,
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "center"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                    onClose: handleUrlClipNotFoundClose,
                    severity: "warning",
                    sx: {
                        width: "100%",
                        fontFamily: "Mulish"
                    },
                    children: "Requested clip from URL was not found in current results."
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "justify-start",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jVN1H.NavBar), {
                    navBarCollapsed: navBarCollapsed,
                    setNavBarCollapsed: setNavBarCollapsed,
                    props: {}
                })
            })
        ]
    }));
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $jVN1H = parcelRequire("jVN1H");

var $9OjAn = parcelRequire("9OjAn");

var $195EM = parcelRequire("195EM");

var $hAnMZ = parcelRequire("hAnMZ");

var $3Zv1D = parcelRequire("3Zv1D");
/**
 * Convert Unix timestamp to "March 01, 2025" format
 * @param timestamp - Unix timestamp as string (e.g., "1768413601.00000000")
 * @returns Formatted date string (e.g., "March 01, 2025")
 */ const $e5f2bfdc8a7a750b$export$27e1ee6aa36d6e2e = (timestamp)=>{
    const date = new Date(parseFloat(timestamp) * 1000);
    return date.toLocaleDateString("en-US", {
        month: "long",
        day: "2-digit",
        year: "numeric",
        timeZone: "UTC"
    });
};
const $e5f2bfdc8a7a750b$export$7884fc1e42dd8dd0 = (timestamp)=>{
    const date = new Date(parseFloat(timestamp) * 1000);
    return date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone: "UTC"
    });
};


const $91ed8bde22a5429a$export$a3768d425d575143 = (0, $9OjAn.create)((set, get)=>({
        // Basic data state
        patrolsData: [],
        setPatrolsData: (data)=>{
            const newState = typeof data === "function" ? data(get().patrolsData) : data;
            set({
                patrolsData: newState
            });
        },
        // Loading states
        patrolsPageBackdropLoading: false,
        setPatrolsPageBackdropLoading: (loading)=>set({
                patrolsPageBackdropLoading: loading
            }),
        parentAccountsLoadingPatrols: true,
        setParentAccountsLoadingPatrols: (loading)=>{
            const newState = typeof loading === "function" ? loading(get().parentAccountsLoadingPatrols) : loading;
            set({
                parentAccountsLoadingPatrols: newState
            });
        },
        loadingSitesPatrols: false,
        setLoadingSitesPatrols: (loading)=>{
            const newState = typeof loading === "function" ? loading(get().loadingSitesPatrols) : loading;
            set({
                loadingSitesPatrols: newState
            });
        },
        loadingCamerasPatrols: false,
        setLoadingCamerasPatrols: (loading)=>set({
                loadingCamerasPatrols: loading
            }),
        patrolsHistoryLoading: false,
        setPatrolsHistoryLoading: (loading)=>set({
                patrolsHistoryLoading: loading
            }),
        filtersAppliedPatrols: false,
        setFiltersAppliedPatrols: (applied)=>set({
                filtersAppliedPatrols: applied
            }),
        // Pagination
        page: 0,
        setPage: (page)=>set({
                page: page
            }),
        rowsPerPage: 10,
        setRowsPerPage: (rowsPerPage)=>set({
                rowsPerPage: rowsPerPage
            }),
        // UI states
        selectedPatrol: null,
        setSelectedPatrol: (patrol)=>set({
                selectedPatrol: patrol
            }),
        isDialogOpen: false,
        setIsDialogOpen: (open)=>set({
                isDialogOpen: open
            }),
        parentAccountsPatrols: [],
        setParentAccountsPatrols: (parentAccountsPatrols)=>{
            const newState = typeof parentAccountsPatrols === "function" ? parentAccountsPatrols(get().parentAccountsPatrols) : parentAccountsPatrols;
            set({
                parentAccountsPatrols: newState
            });
        },
        siteOptionsPatrols: [],
        setSiteOptionsPatrols: (siteOptionsPatrols)=>{
            const newState = typeof siteOptionsPatrols === "function" ? siteOptionsPatrols(get().siteOptionsPatrols) : siteOptionsPatrols;
            set({
                siteOptionsPatrols: newState
            });
        },
        cameraOptionsPatrols: [],
        setCameraOptionsPatrols: (cameraOptionsPatrols)=>set({
                cameraOptionsPatrols: cameraOptionsPatrols
            }),
        selectedPatrolIndex: 0,
        setSelectedPatrolIndex: (selectedPatrolIndex)=>set({
                selectedPatrolIndex: selectedPatrolIndex
            }),
        // Search and filters
        searchQueryPatrols: "",
        setSearchQueryPatrols: (query)=>set({
                searchQueryPatrols: query
            }),
        filtersPatrols: {
            parent_group: "",
            site: [],
            camera: [],
            start_date: null,
            end_date: null
        },
        setFiltersPatrols: (filters)=>set((state)=>({
                    filtersPatrols: typeof filters === "function" ? filters(state.filtersPatrols) : filters
                })),
        patrolDialogOpen: false,
        setPatrolDialogOpen: (patrolDialogOpen)=>set({
                patrolDialogOpen: patrolDialogOpen
            }),
        // Patrol dialog data
        patrolAlerts: [],
        setPatrolAlerts: (alerts)=>set({
                patrolAlerts: alerts
            }),
        patrolCHMIssues: [],
        setPatrolCHMIssues: (issues)=>set({
                patrolCHMIssues: issues
            }),
        patrolSummary: "",
        setPatrolSummary: (summary)=>set({
                patrolSummary: summary
            }),
        patrolDialogDataLoading: false,
        setPatrolDialogDataLoading: (loading)=>set({
                patrolDialogDataLoading: loading
            }),
        // Selected alert for video playback
        selectedPatrolAlertIndex: 0,
        setSelectedPatrolAlertIndex: (index)=>set({
                selectedPatrolAlertIndex: index
            }),
        patrolAlertVideoUrl: "",
        setPatrolAlertVideoUrl: (url)=>set({
                patrolAlertVideoUrl: url
            }),
        patrolAlertVideoLoading: false,
        setPatrolAlertVideoLoading: (loading)=>set({
                patrolAlertVideoLoading: loading
            }),
        // Selected CHM issue for image display
        selectedPatrolCHMIndex: 0,
        setSelectedPatrolCHMIndex: (index)=>set({
                selectedPatrolCHMIndex: index
            }),
        patrolCHMImageUrl: "",
        setPatrolCHMImageUrl: (url)=>set({
                patrolCHMImageUrl: url
            }),
        patrolCHMImageLoading: false,
        setPatrolCHMImageLoading: (loading)=>set({
                patrolCHMImageLoading: loading
            }),
        // API Actions
        fetchPatrols: async (navigate)=>{
            const { setPatrolsData: setPatrolsData } = get();
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().fetchPatrols(navigate);
            };
        },
        getPatrolGroups: (navigate)=>{
            const { setParentAccountsLoadingPatrols: setParentAccountsLoadingPatrols, setParentAccountsPatrols: setParentAccountsPatrols } = get();
            setParentAccountsLoadingPatrols(true);
            const AxiosUI = (0, $195EM.createApi)("");
            AxiosUI.get("group/?group_type=patrol&page_size=10000").then((response)=>{
                setParentAccountsPatrols(response.data.results);
                setParentAccountsLoadingPatrols(false);
            }, (reason)=>{
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, ()=>get().getPatrolGroups(navigate), ()=>{
                    setParentAccountsPatrols([]);
                    setParentAccountsLoadingPatrols(false);
                });
            });
        },
        getPatrolsHistory: (navigate)=>{
            const { filtersPatrols: filtersPatrols, setPatrolsData: setPatrolsData, setPatrolsHistoryLoading: setPatrolsHistoryLoading, setPage: setPage, setFiltersAppliedPatrols: setFiltersAppliedPatrols } = get();
            setPatrolsHistoryLoading(true);
            const AxiosUI = (0, $195EM.createApi)("");
            // Determine which endpoint to use based on filters
            let endpoint = "";
            if (filtersPatrols.site && filtersPatrols.site.length > 0) // If site is selected, use history_by_site_id
            endpoint = `autopatrol_data/history_by_site_id/?site_id=${filtersPatrols.site[0]}`;
            else if (filtersPatrols.parent_group) // If only group is selected, use history_by_group_id
            endpoint = `autopatrol_data/history_by_group_id/?group_id=${filtersPatrols.parent_group}`;
            else {
                // No filters selected
                setPatrolsHistoryLoading(false);
                return;
            }
            // Add optional timestamp filters (converted to Unix epoch)
            if (filtersPatrols.start_date) {
                const startDate = new Date(filtersPatrols.start_date);
                startDate.setHours(0, 0, 0, 0);
                const startTimestamp = Math.floor(startDate.getTime() / 1000);
                endpoint += `&start_timestamp=${startTimestamp}`;
            }
            if (filtersPatrols.end_date) {
                const endDate = new Date(filtersPatrols.end_date);
                endDate.setHours(23, 59, 59, 999);
                const endTimestamp = Math.floor(endDate.getTime() / 1000);
                endpoint += `&end_timestamp=${endTimestamp}`;
            }
            AxiosUI.get(endpoint).then((response)=>{
                const apiData = response.data.results;
                // Transform API response to table data format
                const transformedData = apiData.map((patrol)=>{
                    const timestampUnix = Math.floor(Number.parseFloat(patrol.timestamp));
                    return {
                        patrol_id: patrol.patrol_id,
                        patrol_date: (0, $e5f2bfdc8a7a750b$export$27e1ee6aa36d6e2e)(patrol.timestamp),
                        start_time: (0, $e5f2bfdc8a7a750b$export$7884fc1e42dd8dd0)(patrol.timestamp),
                        timestamp_unix: Number.isFinite(timestampUnix) ? timestampUnix : 0,
                        site: patrol.site_name || "",
                        schedule_name: patrol.schedule_name?.trim() || "",
                        total_alerts: Array.isArray(patrol.alert_window_ids) ? patrol.alert_window_ids.length : 0,
                        total_cameras: 0,
                        cameras_with_problems: 0,
                        alert_window_ids: patrol.alert_window_ids,
                        site_id: patrol.site_id,
                        group_id: patrol.group_id,
                        schedule_id: patrol.schedule_id
                    };
                }).sort((a, b)=>b.timestamp_unix - a.timestamp_unix);
                setPatrolsData(transformedData);
                setPage(0); // Reset to first page
                setPatrolsHistoryLoading(false);
                setFiltersAppliedPatrols(true);
            }, (reason)=>{
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, ()=>get().getPatrolsHistory(navigate), ()=>{
                    setPatrolsData([]);
                    setPatrolsHistoryLoading(false);
                });
            });
        },
        fetchPatrolDialogData: (patrolId, navigate)=>{
            const { setPatrolAlerts: setPatrolAlerts, setPatrolCHMIssues: setPatrolCHMIssues, setPatrolSummary: setPatrolSummary, setPatrolDialogDataLoading: setPatrolDialogDataLoading, setPatrolAlertVideoUrl: setPatrolAlertVideoUrl, setPatrolAlertVideoLoading: setPatrolAlertVideoLoading } = get();
            // Clear previous data and set loading (reset video so next patrol doesn't show previous patrol's clip)
            setPatrolAlerts([]);
            setPatrolCHMIssues([]);
            setPatrolSummary("");
            setPatrolAlertVideoUrl("");
            setPatrolAlertVideoLoading(false);
            setPatrolDialogDataLoading(true);
            const AxiosUI = (0, $195EM.createApi)("");
            // Fetch alerts, CHM issues, and patrol summary in parallel
            const alertsPromise = AxiosUI.get(`autopatrol_data/alerts_by_patrol_id/?patrol_id=${patrolId}`);
            const chmPromise = AxiosUI.get(`autopatrol_data/chm_issues_by_patrol_id/?patrol_id=${patrolId}`);
            const summaryPromise = AxiosUI.get(`autopatrol_data/summary_by_patrol_id/?patrol_id=${patrolId}`);
            Promise.all([
                alertsPromise,
                chmPromise,
                summaryPromise
            ]).then(([alertsResponse, chmResponse, summaryResponse])=>{
                setPatrolAlerts(alertsResponse.data.alerts || []);
                setPatrolCHMIssues(chmResponse.data.chm_issues || []);
                const summaryText = summaryResponse.data?.summary?.patrol_summary ?? "";
                setPatrolSummary(summaryText);
                setPatrolDialogDataLoading(false);
            }).catch((reason)=>{
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, ()=>get().fetchPatrolDialogData(patrolId, navigate), ()=>{
                    setPatrolAlerts([]);
                    setPatrolCHMIssues([]);
                    setPatrolSummary("");
                    setPatrolDialogDataLoading(false);
                });
            });
        },
        fetchPatrolAlertVideo: (windowId, navigate)=>{
            const { setPatrolAlertVideoUrl: setPatrolAlertVideoUrl, setPatrolAlertVideoLoading: setPatrolAlertVideoLoading } = get();
            setPatrolAlertVideoUrl("");
            setPatrolAlertVideoLoading(true);
            const AxiosUI = (0, $hAnMZ.createMonitoringAPICall)("");
            const pollForVideo = (pollUrl, retriesRemaining)=>{
                setTimeout(()=>{
                    AxiosUI.get(pollUrl).then((response)=>{
                        // If the response is a URL string, we're done
                        if (typeof response.data === "string") {
                            setPatrolAlertVideoUrl(response.data);
                            setPatrolAlertVideoLoading(false);
                            return;
                        }
                        // If still processing, keep polling
                        if (response.data && typeof response.data === "object" && response.data.status === "processing") {
                            if (retriesRemaining > 1) {
                                pollForVideo(pollUrl, retriesRemaining - 1);
                                return;
                            }
                        }
                        // Exhausted retries or unexpected response
                        setPatrolAlertVideoUrl("");
                        setPatrolAlertVideoLoading(false);
                    }).catch((error)=>{
                        const status = error.response?.status;
                        // 404 means still processing, keep polling
                        if (status === 404 && retriesRemaining > 1) {
                            pollForVideo(pollUrl, retriesRemaining - 1);
                            return;
                        }
                        (0, $3Zv1D.universalAPIErrorHandler)(error, navigate, ()=>get().fetchPatrolAlertVideo(windowId, navigate), ()=>{
                            setPatrolAlertVideoUrl("");
                            setPatrolAlertVideoLoading(false);
                        });
                    });
                }, 500);
            };
            AxiosUI.get(`alert/clip/?window_id=${windowId}&async_generation=true`).then((response)=>{
                const responseData = response.data;
                // If we get a processing response, start polling
                if (responseData && typeof responseData === "object" && responseData.status === "processing") {
                    const pollUrl = responseData.poll_url ? responseData.poll_url.replace(/^\/?monitoring-api\//, "") : `alert/video/?window_id=${windowId}&poll=True`;
                    pollForVideo(pollUrl, 10);
                    return;
                }
                // If response is a URL string, we're done
                if (typeof responseData === "string") {
                    setPatrolAlertVideoUrl(responseData);
                    setPatrolAlertVideoLoading(false);
                    return;
                }
                // Unexpected response format
                setPatrolAlertVideoUrl("");
                setPatrolAlertVideoLoading(false);
            }).catch((reason)=>{
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, ()=>get().fetchPatrolAlertVideo(windowId, navigate), ()=>{
                    setPatrolAlertVideoUrl("");
                    setPatrolAlertVideoLoading(false);
                });
            });
        },
        fetchPatrolCHMImage: (imageS3Key, navigate)=>{
            const { setPatrolCHMImageUrl: setPatrolCHMImageUrl, setPatrolCHMImageLoading: setPatrolCHMImageLoading } = get();
            setPatrolCHMImageUrl("");
            setPatrolCHMImageLoading(true);
            if (!imageS3Key) {
                setPatrolCHMImageLoading(false);
                return;
            }
            const AxiosUI = (0, $195EM.createApi)("");
            // Replace # with %23 in the key (same as Health Monitoring does)
            const encodedKey = imageS3Key.replace(/#/g, "%23");
            AxiosUI.get(`/images/get_image_url/?frame_key=${encodedKey}`).then((response)=>{
                setPatrolCHMImageUrl(response.data.frame_url);
                setPatrolCHMImageLoading(false);
            }).catch((reason)=>{
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, ()=>get().fetchPatrolCHMImage(imageS3Key, navigate), ()=>{
                    setPatrolCHMImageUrl("");
                    setPatrolCHMImageLoading(false);
                });
            });
        },
        // Utility functions
        resetStatePatrols: ()=>set({
                patrolsData: [],
                patrolsPageBackdropLoading: false,
                parentAccountsLoadingPatrols: true,
                loadingSitesPatrols: false,
                loadingCamerasPatrols: false,
                patrolsHistoryLoading: false,
                filtersAppliedPatrols: false,
                page: 0,
                rowsPerPage: 10,
                selectedPatrol: null,
                isDialogOpen: false,
                parentAccountsPatrols: [],
                siteOptionsPatrols: [],
                cameraOptionsPatrols: [],
                patrolDialogOpen: false,
                selectedPatrolIndex: 0,
                searchQueryPatrols: "",
                filtersPatrols: {
                    parent_group: "",
                    site: [],
                    camera: [],
                    start_date: null,
                    end_date: null
                },
                patrolAlerts: [],
                patrolCHMIssues: [],
                patrolSummary: "",
                patrolDialogDataLoading: false,
                selectedPatrolAlertIndex: 0,
                patrolAlertVideoUrl: "",
                patrolAlertVideoLoading: false,
                selectedPatrolCHMIndex: 0,
                patrolCHMImageUrl: "",
                patrolCHMImageLoading: false
            })
    }));



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $60vL1 = parcelRequire("60vL1");
var $eejVe = parcelRequire("eejVe");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");


const $deb71cbb233803ac$export$e46dc2957e9a11e3 = ({ navBarCollapsed: navBarCollapsed })=>{
    const { filtersPatrols: filtersPatrols, setFiltersPatrols: setFiltersPatrols, setSiteOptionsPatrols: setSiteOptionsPatrols, setCameraOptionsPatrols: setCameraOptionsPatrols, parentAccountsPatrols: parentAccountsPatrols, parentAccountsLoadingPatrols: parentAccountsLoadingPatrols, setLoadingSitesPatrols: setLoadingSitesPatrols, getPatrolGroups: getPatrolGroups } = (0, $91ed8bde22a5429a$export$a3768d425d575143)();
    const navigate = (0, $3T949.useNavigate)();
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        getPatrolGroups(navigate);
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            disablePortal: true,
            options: parentAccountsPatrols && parentAccountsPatrols.length > 0 ? parentAccountsPatrols.map((object, index)=>({
                    id: object.id,
                    name: object.name,
                    index: index
                })) : [],
            getOptionLabel: (option)=>option.name || "",
            isOptionEqualToValue: (option, value)=>option.id === value.id,
            value: filtersPatrols.parent_group && parentAccountsPatrols && parentAccountsPatrols.length > 0 ? {
                id: Number(filtersPatrols.parent_group),
                name: parentAccountsPatrols.find((obj)=>obj.id === Number(filtersPatrols.parent_group))?.name || "",
                index: parentAccountsPatrols.findIndex((obj)=>obj.id === Number(filtersPatrols.parent_group))
            } : null,
            // loading={parentAccountsLoading}
            onChange: (event, value)=>{
                setSiteOptionsPatrols([]);
                setCameraOptionsPatrols([]);
                if (value !== null) {
                    (0, $27fa563d59549059$export$6b28e0ddc2fe699b)(value.id, navigate, setSiteOptionsPatrols, setLoadingSitesPatrols);
                    setFiltersPatrols((previousState)=>{
                        return {
                            ...previousState,
                            parent_group: value.id,
                            site: "",
                            camera: ""
                        };
                    });
                } else setFiltersPatrols((previousState)=>{
                    return {
                        ...previousState,
                        parent_group: "",
                        site: "",
                        camera: ""
                    };
                });
            },
            sx: !navBarCollapsed ? {
                width: 250
            } : {
                width: 280
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    label: "Parent Group",
                    helperText: "*required",
                    InputProps: {
                        ...params.InputProps,
                        endAdornment: /*#__PURE__*/ (0, $k4ank.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                            children: [
                                parentAccountsLoadingPatrols ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                    color: "inherit",
                                    size: 20
                                }) : null,
                                params.InputProps.endAdornment
                            ]
                        })
                    },
                    autoComplete: "off"
                }),
            renderOption: (props, option)=>/*#__PURE__*/ (0, $8T3gX.createElement)("li", {
                    ...props,
                    key: option.id
                }, option.name)
        })
    }, "parent_groups_dropdown");
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $60vL1 = parcelRequire("60vL1");
var $eejVe = parcelRequire("eejVe");

const $053d112dc481941b$export$de3eb578468f4dbe = ({ navBarCollapsed: navBarCollapsed })=>{
    const { filtersPatrols: filtersPatrols, setFiltersPatrols: setFiltersPatrols, siteOptionsPatrols: siteOptionsPatrols, setCameraOptionsPatrols: setCameraOptionsPatrols, loadingSitesPatrols: loadingSitesPatrols, setLoadingCamerasPatrols: setLoadingCamerasPatrols } = (0, $91ed8bde22a5429a$export$a3768d425d575143)();
    const siteNamesMap = new Map();
    siteOptionsPatrols.forEach((object)=>{
        siteNamesMap.set(object.id, object.name);
    });
    // Convert stored site ID to single object for the Autocomplete (single selection only)
    const siteIds = Array.isArray(filtersPatrols.site) ? filtersPatrols.site : [];
    const selectedSiteObject = siteIds.length > 0 ? (()=>{
        const siteId = siteIds[0];
        const siteName = siteNamesMap.get(siteId);
        const siteIndex = siteOptionsPatrols.findIndex((site)=>site.id === siteId);
        return {
            id: siteId,
            name: siteName,
            index: siteIndex
        };
    })() : null;
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            value: selectedSiteObject,
            disablePortal: true,
            options: siteOptionsPatrols[0] ? siteOptionsPatrols.map((object, index)=>({
                    id: object.id,
                    name: object.name,
                    index: index
                })) : [],
            getOptionLabel: (option)=>(option?.name ?? option) || "",
            isOptionEqualToValue: (option, value)=>option?.id === value?.id,
            loading: loadingSitesPatrols,
            onChange: (event, value)=>{
                if (value) {
                    localStorage.setItem("siteDropDownValue", JSON.stringify([
                        value.name
                    ]));
                    setFiltersPatrols((previousState)=>({
                            ...previousState,
                            site: [
                                value.id
                            ],
                            camera: ""
                        }));
                } else {
                    setCameraOptionsPatrols([]);
                    setFiltersPatrols((previousState)=>({
                            ...previousState,
                            site: [],
                            camera: []
                        }));
                    setLoadingCamerasPatrols(false);
                }
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    label: "Site",
                    InputProps: {
                        ...params.InputProps,
                        endAdornment: /*#__PURE__*/ (0, $k4ank.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                            children: [
                                loadingSitesPatrols ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                    color: "inherit",
                                    size: 20
                                }) : null,
                                params.InputProps.endAdornment
                            ]
                        })
                    },
                    autoComplete: "off",
                    sx: !navBarCollapsed ? {
                        width: 250
                    } : {
                        width: 275
                    }
                }),
            renderOption: (props, option)=>/*#__PURE__*/ (0, $8T3gX.createElement)("li", {
                    ...props,
                    key: option.id
                }, option.name)
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $hfM8m = parcelRequire("hfM8m");

var $hwWkD = parcelRequire("hwWkD");


var $eejVe = parcelRequire("eejVe");

var $iKAtE = parcelRequire("iKAtE");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");

var $i5MAs = parcelRequire("i5MAs");

var $aYdit = parcelRequire("aYdit");

var $jgags = parcelRequire("jgags");

const $1b3e7002efb52266$export$947cb68dd9740d78 = ()=>{
    const { filtersPatrols: filtersPatrols, setFiltersPatrols: setFiltersPatrols } = (0, $91ed8bde22a5429a$export$a3768d425d575143)();
    const [startTimeAnchorEl, setStartTimeAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const startTimeOpen = Boolean(startTimeAnchorEl);
    const handleStartTimeClick = (event)=>{
        // event.stopPropagation(); // Stop event propagation to prevent table sorting
        setStartTimeAnchorEl(event.currentTarget);
    };
    const handleStartTimeClose = (event)=>{
        event.stopPropagation(); // Stop event propagation to prevent table sorting
        setStartTimeAnchorEl(null);
    };
    const { dateMMDDYYYY: dateMMDDYYYY, setDateMMDDYYYY: setDateMMDDYYYY } = (0, $aYdit.useAppStore)();
    const selectedLocale = dateMMDDYYYY ? (0, $jgags.default) : (0, $253608f850203ed2$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "flex-shrink-0",
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
            dateAdapter: (0, $hfM8m.AdapterDateFns),
            adapterLocale: selectedLocale,
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cbaf068f14972fdf$export$5109c6dd95d8fb00), {
                label: filtersPatrols.start_date ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                            children: `Start Date`
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                    "aria-label": "more",
                                    id: "long-button",
                                    "aria-controls": startTimeOpen ? "long-menu" : undefined,
                                    "aria-expanded": startTimeOpen ? "true" : undefined,
                                    "aria-haspopup": "true",
                                    onClick: handleStartTimeClick,
                                    sx: {
                                        marginLeft: "5px",
                                        padding: 0,
                                        color: "#000000",
                                        "&:hover": {
                                            backgroundColor: "transparent"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5MAs))), {})
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                                    id: "long-menu",
                                    MenuListProps: {
                                        "aria-labelledby": "long-button"
                                    },
                                    anchorOrigin: {
                                        vertical: "top",
                                        horizontal: "left"
                                    },
                                    transformOrigin: {
                                        vertical: "top",
                                        horizontal: "left"
                                    },
                                    anchorEl: startTimeAnchorEl,
                                    open: startTimeOpen,
                                    onClose: handleStartTimeClose,
                                    slotProps: {
                                        paper: {
                                            style: {
                                                maxHeight: 216,
                                                width: "20ch"
                                            }
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                            onClick: (event)=>{
                                                setDateMMDDYYYY(true);
                                                handleStartTimeClose(event);
                                            },
                                            children: "MM/DD/YYYY"
                                        }, "mm-dd-yyyy-start"),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                            onClick: (event)=>{
                                                setDateMMDDYYYY(false);
                                                handleStartTimeClose(event);
                                            },
                                            children: "DD/MM/YYYY"
                                        }, "dd-mm-yyyy-start")
                                    ]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                    children: "Start Date"
                }),
                value: filtersPatrols.start_date,
                onChange: (newValue)=>{
                    if (newValue !== null) setFiltersPatrols((previousState)=>({
                            ...previousState,
                            start_date: newValue
                        }));
                    if (newValue === null) setFiltersPatrols((previousState)=>{
                        return {
                            ...previousState,
                            start_date: null
                        };
                    });
                },
                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        sx: {
                            width: 150,
                            minWidth: 150,
                            flexShrink: 0
                        },
                        ...params
                    })
            })
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $hfM8m = parcelRequire("hfM8m");

var $hwWkD = parcelRequire("hwWkD");


var $eejVe = parcelRequire("eejVe");

var $iKAtE = parcelRequire("iKAtE");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");

var $i5MAs = parcelRequire("i5MAs");

var $aYdit = parcelRequire("aYdit");

var $jgags = parcelRequire("jgags");

const $7c1c790d8da1f852$export$1ab72452c1a1e90 = ()=>{
    const { filtersPatrols: filtersPatrols, setFiltersPatrols: setFiltersPatrols } = (0, $91ed8bde22a5429a$export$a3768d425d575143)();
    const [endTimeAnchorEl, setEndTimeAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const endTimeOpen = Boolean(endTimeAnchorEl);
    const handleEndTimeClick = (event)=>{
        // event.stopPropagation(); // Stop event propagation to prevent table sorting
        setEndTimeAnchorEl(event.currentTarget);
    };
    const handleEndTimeClose = (event)=>{
        event.stopPropagation(); // Stop event propagation to prevent table sorting
        setEndTimeAnchorEl(null);
    };
    const { dateMMDDYYYY: dateMMDDYYYY, setDateMMDDYYYY: setDateMMDDYYYY } = (0, $aYdit.useAppStore)();
    const selectedLocale = dateMMDDYYYY ? (0, $jgags.default) : (0, $253608f850203ed2$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "flex-shrink-0",
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
            dateAdapter: (0, $hfM8m.AdapterDateFns),
            adapterLocale: selectedLocale,
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cbaf068f14972fdf$export$5109c6dd95d8fb00), {
                label: filtersPatrols.end_date ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                            children: `End Date`
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                    "aria-label": "more",
                                    id: "long-button",
                                    "aria-controls": endTimeOpen ? "long-menu" : undefined,
                                    "aria-expanded": endTimeOpen ? "true" : undefined,
                                    "aria-haspopup": "true",
                                    onClick: handleEndTimeClick,
                                    sx: {
                                        marginLeft: "5px",
                                        padding: 0,
                                        color: "#000000",
                                        "&:hover": {
                                            backgroundColor: "transparent"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5MAs))), {})
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                                    id: "long-menu",
                                    MenuListProps: {
                                        "aria-labelledby": "long-button"
                                    },
                                    anchorOrigin: {
                                        vertical: "top",
                                        horizontal: "left"
                                    },
                                    transformOrigin: {
                                        vertical: "top",
                                        horizontal: "left"
                                    },
                                    anchorEl: endTimeAnchorEl,
                                    open: endTimeOpen,
                                    onClose: handleEndTimeClose,
                                    slotProps: {
                                        paper: {
                                            style: {
                                                maxHeight: 216,
                                                width: "20ch"
                                            }
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                            onClick: (event)=>{
                                                setDateMMDDYYYY(true);
                                                handleEndTimeClose(event);
                                            },
                                            children: "MM/DD/YYYY"
                                        }, "mm-dd-yyyy-end"),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                            onClick: (event)=>{
                                                setDateMMDDYYYY(false);
                                                handleEndTimeClose(event);
                                            },
                                            children: "DD/MM/YYYY"
                                        }, "dd-mm-yyyy-end")
                                    ]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                    children: "End Date"
                }),
                value: filtersPatrols.end_date,
                onChange: (newValue)=>{
                    if (newValue !== null) setFiltersPatrols((previousState)=>({
                            ...previousState,
                            end_date: newValue
                        }));
                    if (newValue === null) setFiltersPatrols((previousState)=>{
                        return {
                            ...previousState,
                            end_date: null
                        };
                    });
                },
                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        sx: {
                            width: 150,
                            minWidth: 150,
                            flexShrink: 0
                        },
                        ...params
                    })
            })
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $a65wX = parcelRequire("a65wX");



var $eg2OC = parcelRequire("eg2OC");

var $6CjWJ = parcelRequire("6CjWJ");

var $4reBM = parcelRequire("4reBM");

var $cWqfz = parcelRequire("cWqfz");

var $cxknk = parcelRequire("cxknk");

var $eJK3E = parcelRequire("eJK3E");


var $195EM = parcelRequire("195EM");

var $iIAML = parcelRequire("iIAML");
const $4e3d772205fa01b2$export$eaa10c7a5d496c50 = async (siteId, startDate, endDate)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    let endpoint = `autopatrol_data/report_by_site_id/?site_id=${siteId}`;
    if (startDate) {
        const normalizedStartDate = new Date(startDate);
        normalizedStartDate.setHours(0, 0, 0, 0);
        const startTimestamp = Math.floor(normalizedStartDate.getTime() / 1000);
        endpoint += `&start_timestamp=${startTimestamp}`;
    }
    if (endDate) {
        const normalizedEndDate = new Date(endDate);
        normalizedEndDate.setHours(23, 59, 59, 999);
        const endTimestamp = Math.floor(normalizedEndDate.getTime() / 1000);
        endpoint += `&end_timestamp=${endTimestamp}`;
    }
    const response = await AxiosUI.get(endpoint, {
        responseType: "blob"
    });
    const blob = new Blob([
        response.data
    ], {
        type: "text/csv"
    });
    (0, $iIAML.saveAs)(blob, `patrol_report_site_${siteId}.csv`);
};


const $b73b46e5ec0a8979$var$OPTIONS = [
    "Apply Filters",
    "Download Report"
];
const $b73b46e5ec0a8979$export$d5a57ffd3f35b42b = ()=>{
    const { filtersPatrols: filtersPatrols, getPatrolsHistory: getPatrolsHistory, patrolsHistoryLoading: patrolsHistoryLoading, setPage: setPage } = (0, $91ed8bde22a5429a$export$a3768d425d575143)();
    const navigate = (0, $3T949.useNavigate)();
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const anchorRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const [option, setOption] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState($b73b46e5ec0a8979$var$OPTIONS[0]);
    const [downloadingReport, setDownloadingReport] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const siteSelected = filtersPatrols.site && filtersPatrols.site.length > 0;
    const isApplyDisabled = patrolsHistoryLoading || !filtersPatrols.parent_group && (!filtersPatrols.site || filtersPatrols.site.length === 0);
    const handleApplyFilters = ()=>{
        setPage(0);
        getPatrolsHistory(navigate);
    };
    const handleDownloadReport = async ()=>{
        if (!siteSelected || !filtersPatrols.site[0]) return;
        setDownloadingReport(true);
        try {
            await (0, $4e3d772205fa01b2$export$eaa10c7a5d496c50)(filtersPatrols.site[0], filtersPatrols.start_date, filtersPatrols.end_date);
        } finally{
            setDownloadingReport(false);
        }
    };
    const handlePrimaryClick = ()=>{
        if (option === "Apply Filters") handleApplyFilters();
        else handleDownloadReport();
    };
    const handleMenuItemClick = (event, index)=>{
        setOption($b73b46e5ec0a8979$var$OPTIONS[index]);
        setOpen(false);
    };
    const handleToggle = ()=>{
        setOpen((prevOpen)=>!prevOpen);
    };
    const handleClose = (event)=>{
        if (anchorRef.current && anchorRef.current.contains(event.target)) return;
        setOpen(false);
    };
    // No site selected: single Apply Filters button only
    if (!siteSelected) return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "pt-[7px] z-10",
        children: /*#__PURE__*/ (0, $k4ank.jsx)("button", {
            className: `shadow-button border-2 rounded font-mulish text-white text-base p-1.5 w-[120px] ${isApplyDisabled ? "bg-gray-400 border-gray-400 cursor-not-allowed" : "bg-actuate-orange border-actuate-orange hover:bg-[#E67300]"}`,
            onClick: handleApplyFilters,
            disabled: isApplyDisabled,
            children: patrolsHistoryLoading ? "Loading..." : "Apply Filters"
        })
    });
    // Site selected: split button with Apply Filters + Download Report
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "pt-[7px] z-10",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $d685fbaea40075f4$export$2e2bcd8739ae039), {
                variant: "contained",
                ref: anchorRef,
                "aria-label": "Patrol actions",
                color: "warning",
                sx: {
                    fontFamily: "Mulish"
                },
                children: [
                    option === "Apply Filters" ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                        onClick: handlePrimaryClick,
                        disabled: isApplyDisabled,
                        sx: {
                            backgroundColor: "#FF8400",
                            "&:hover": {
                                backgroundColor: "#E67300"
                            },
                            width: "140px",
                            fontFamily: "Mulish"
                        },
                        children: patrolsHistoryLoading ? "Loading..." : "Apply Filters"
                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                        onClick: handlePrimaryClick,
                        disabled: downloadingReport,
                        sx: {
                            color: "white",
                            backgroundColor: "#FF8400",
                            "&:hover": {
                                backgroundColor: "#E67300",
                                color: "white"
                            },
                            width: "200px",
                            fontFamily: "Mulish"
                        },
                        children: downloadingReport ? "Downloading..." : "Download Report"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                        size: "small",
                        "aria-controls": open ? "split-button-menu" : undefined,
                        "aria-expanded": open ? "true" : undefined,
                        "aria-label": "select action",
                        "aria-haspopup": "menu",
                        sx: {
                            backgroundColor: "#FF8400",
                            "&:hover": {
                                backgroundColor: "#E67300"
                            },
                            fontFamily: "Mulish"
                        },
                        onClick: handleToggle,
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bf807683d00d38ca$exports))), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cWqfz.default), {
                sx: {
                    zIndex: 1
                },
                open: open,
                anchorEl: anchorRef.current,
                role: undefined,
                transition: true,
                disablePortal: true,
                children: ({ TransitionProps: TransitionProps, placement: placement })=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $6CjWJ.default), {
                        ...TransitionProps,
                        style: {
                            transformOrigin: placement === "bottom" ? "center top" : "center bottom"
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4reBM.default), {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eg2OC.ClickAwayListener), {
                                onClickAway: handleClose,
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eJK3E.default), {
                                    className: "absolute",
                                    id: "split-button-menu",
                                    autoFocusItem: true,
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: $b73b46e5ec0a8979$var$OPTIONS.map((opt, index)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                            selected: option === opt,
                                            onClick: (event)=>handleMenuItemClick(event, index),
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            children: opt
                                        }, opt))
                                })
                            })
                        })
                    })
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $1wcxl = parcelRequire("1wcxl");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");


var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");
var $aVDw9 = parcelRequire("aVDw9");
var $ha39s = parcelRequire("ha39s");
var $4o6Cs = parcelRequire("4o6Cs");
var $kLvBh = parcelRequire("kLvBh");

var $9lVTU = parcelRequire("9lVTU");
const $70a8370edb3a909f$export$efc44a49183353c0 = (props)=>{
    const { headCells: headCells, order: order, orderBy: orderBy, onRequestSort: onRequestSort, backgroundColor: backgroundColor, nonSortableCells: nonSortableCells = [] } = props;
    const createSortHandler = (property)=>(event)=>{
            onRequestSort(event, property);
        };
    const tableHeadSx = backgroundColor ? {
        backgroundColor: `${backgroundColor} !important`,
        "& .MuiTableCell-head": {
            backgroundColor: `${backgroundColor} !important`,
            position: "sticky",
            top: 0,
            zIndex: 1
        }
    } : undefined;
    const cellSx = {
        fontFamily: "Mulish",
        fontWeight: "Bold",
        ...backgroundColor && {
            backgroundColor: `${backgroundColor} !important`
        }
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
        sx: tableHeadSx,
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
            sx: backgroundColor ? {
                backgroundColor: backgroundColor
            } : undefined,
            children: [
                headCells.map((headCell)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                        align: "left",
                        sortDirection: orderBy === headCell.id ? order : false,
                        sx: cellSx,
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kLvBh.default), {
                            active: orderBy === headCell.id,
                            direction: orderBy === headCell.id ? order : "asc",
                            onClick: createSortHandler(headCell.id),
                            children: [
                                headCell.label,
                                orderBy === headCell.id ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                    component: "span",
                                    sx: (0, $9lVTU.default),
                                    children: order === "desc" ? "sorted descending" : "sorted ascending"
                                }) : null
                            ]
                        })
                    }, headCell.id)),
                nonSortableCells.map((cell, index)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                        align: "left",
                        sx: cellSx,
                        children: cell.label
                    }, `non-sortable-${index}`))
            ]
        })
    });
};



var $3RYg6 = parcelRequire("3RYg6");
var $anJSP = parcelRequire("anJSP");

var $iFXjq = parcelRequire("iFXjq");
const $618a3c08eeccc818$export$727f12b1590025 = (0, $anJSP.default)("div")(({ theme: theme })=>({
        position: "relative",
        borderRadius: theme.shape.borderRadius,
        backgroundColor: (0, $3RYg6.alpha)(theme.palette.common.white, 0.75),
        border: "1px solid white",
        // "&:hover": {
        //     border: "1px solid #e5e5e5",
        // },
        marginRight: theme.spacing(2),
        marginLeft: 0,
        width: "400px"
    }));
const $618a3c08eeccc818$export$f1b716ebc12c5251 = (0, $anJSP.default)("div")(({ theme: theme })=>({
        padding: theme.spacing(0, 2),
        height: "100%",
        position: "absolute",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }));
const $618a3c08eeccc818$export$2da9ff219c8e564d = (0, $anJSP.default)((0, $iFXjq.default))(({ theme: theme })=>({
        color: "inherit",
        "& .MuiInputBase-input": {
            padding: theme.spacing(1, 1, 1, 0),
            // vertical padding + font size from searchIcon
            paddingLeft: `calc(1em + ${theme.spacing(4)})`,
            transition: theme.transitions.create("width"),
            width: "100%",
            [theme.breakpoints.up("md")]: {
                width: "30ch"
            }
        }
    }));




var $8jTCz = parcelRequire("8jTCz");

var $2zBdB = parcelRequire("2zBdB");

var $cVCJe = parcelRequire("cVCJe");

var $60vL1 = parcelRequire("60vL1");

var $195EM = parcelRequire("195EM");

var $iIAML = parcelRequire("iIAML");
const $ec6ad63153372911$export$5263d2f4dc2b5050 = async (patrolId)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const response = await AxiosUI.get(`autopatrol_data/report_by_patrol_id/?patrol_id=${patrolId}`, {
        responseType: "blob"
    });
    const blob = new Blob([
        response.data
    ], {
        type: "text/csv"
    });
    (0, $iIAML.saveAs)(blob, `patrol_report_${patrolId}.csv`);
};



var $fWsn7 = parcelRequire("fWsn7");
function $344feb892c8eaecf$var$getPatrolsTableComparator(order, orderBy) {
    const effectiveKey = orderBy === "patrol_date" || orderBy === "start_time" ? "timestamp_unix" : orderBy;
    return order === "desc" ? (a, b)=>(0, $fWsn7.descendingComparator)(a, b, effectiveKey) : (a, b)=>-(0, $fWsn7.descendingComparator)(a, b, effectiveKey);
}
const $344feb892c8eaecf$export$4ac570cdb377962e = ()=>{
    const { patrolsData: patrolsData, page: page, setPage: setPage, rowsPerPage: rowsPerPage, setRowsPerPage: setRowsPerPage, searchQueryPatrols: searchQueryPatrols, setSearchQueryPatrols: setSearchQueryPatrols, setSelectedPatrol: setSelectedPatrol, setPatrolDialogOpen: setPatrolDialogOpen, setSelectedPatrolIndex: setSelectedPatrolIndex } = (0, $91ed8bde22a5429a$export$a3768d425d575143)();
    // Sort state for table header (default: newest patrol first)
    const [order, setOrder] = (0, $8T3gX.useState)("desc");
    const [orderBy, setOrderBy] = (0, $8T3gX.useState)("patrol_date");
    // Track which patrol is currently downloading
    const [downloadingPatrolId, setDownloadingPatrolId] = (0, $8T3gX.useState)(null);
    const handleRequestSort = (_event, property)=>{
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };
    // Handle download patrol report
    const handleDownloadPatrolReport = async (patrolId)=>{
        setDownloadingPatrolId(patrolId);
        try {
            await (0, $ec6ad63153372911$export$5263d2f4dc2b5050)(patrolId);
        } catch (error) {
            console.error("Error downloading patrol report:", error);
            alert("Unable to download patrol report");
        } finally{
            setDownloadingPatrolId(null);
        }
    };
    // Handle page change
    const handleChangePage = (event, newPage)=>{
        setPage(newPage);
    };
    // Handle rows per page change
    const handleChangeRowsPerPage = (event)=>{
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    // Filter data based on search query
    const filteredData = patrolsData.filter((patrol)=>patrol.site?.toLowerCase().includes(searchQueryPatrols.toLowerCase()) || patrol.patrol_date?.toLowerCase().includes(searchQueryPatrols.toLowerCase()) || patrol.start_time?.toLowerCase().includes(searchQueryPatrols.toLowerCase()) || patrol.schedule_name?.toLowerCase().includes(searchQueryPatrols.toLowerCase()));
    // Sort filtered data (patrol date / start time use Unix seconds — formatted labels are not sortable)
    const sortedData = (0, $fWsn7.stableSort)(filteredData, $344feb892c8eaecf$var$getPatrolsTableComparator(order, orderBy));
    // Calculate the maximum valid page (minimum of 0 for empty data)
    const maxPage = Math.max(0, Math.ceil(sortedData.length / rowsPerPage) - 1);
    // Clamp page to valid range to prevent MUI TablePagination warning
    // This handles the case when data changes and page is temporarily out of range
    const safePage = Math.min(page, maxPage);
    // Calculate paginated data using safe page value
    const paginatedData = sortedData.slice(safePage * rowsPerPage, safePage * rowsPerPage + rowsPerPage);
    // Update the store's page if it's out of range
    (0, $8T3gX.useEffect)(()=>{
        if (page > maxPage) setPage(maxPage);
    }, [
        filteredData.length,
        page,
        maxPage,
        setPage
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $618a3c08eeccc818$export$727f12b1590025), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $618a3c08eeccc818$export$f1b716ebc12c5251), {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0f42bd3abae37cbe$exports))), {})
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $618a3c08eeccc818$export$2da9ff219c8e564d), {
                            value: searchQueryPatrols,
                            placeholder: "Search Patrols...",
                            onChange: (e)=>setSearchQueryPatrols(e.target.value),
                            inputProps: {
                                "aria-label": "search"
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                sx: {
                    fontFamily: "Mulish"
                },
                "aria-label": "patrols_table",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $70a8370edb3a909f$export$efc44a49183353c0), {
                        headCells: [
                            {
                                id: "patrol_date",
                                label: "Patrol Date"
                            },
                            {
                                id: "start_time",
                                label: "Patrol Start Time"
                            },
                            {
                                id: "site",
                                label: "Site"
                            },
                            {
                                id: "schedule_name",
                                label: "Schedule"
                            },
                            {
                                id: "total_alerts",
                                label: "Total Alerts"
                            }
                        ],
                        order: order,
                        orderBy: orderBy,
                        onRequestSort: handleRequestSort,
                        nonSortableCells: [
                            {
                                label: ""
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                        children: paginatedData.length > 0 ? paginatedData.map((patrol, index)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                hover: true,
                                onClick: ()=>{
                                    const globalIndex = safePage * rowsPerPage + index;
                                    setSelectedPatrol(patrol);
                                    setSelectedPatrolIndex(globalIndex);
                                    setPatrolDialogOpen(true);
                                },
                                sx: {
                                    cursor: "pointer",
                                    "&:hover": {
                                        backgroundColor: "#e3ecfa !important",
                                        "& .MuiTableCell-root": {
                                            backgroundColor: "#e3ecfa !important"
                                        }
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        sx: {
                                            width: "20%"
                                        },
                                        children: patrol.patrol_date || "N/A"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        sx: {
                                            width: "20%"
                                        },
                                        children: patrol.start_time || "N/A"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        sx: {
                                            width: "20%"
                                        },
                                        children: patrol.site || "N/A"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        sx: {
                                            width: "20%"
                                        },
                                        children: patrol.schedule_name?.trim() ? patrol.schedule_name : "\u2014"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        sx: {
                                            width: "20%"
                                        },
                                        children: patrol.total_alerts ?? 0
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        sx: {
                                            width: "auto",
                                            minWidth: "48px"
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                            onClick: (e)=>{
                                                e.stopPropagation();
                                                handleDownloadPatrolReport(String(patrol.patrol_id));
                                            },
                                            text: downloadingPatrolId === patrol.patrol_id ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                                size: 20,
                                                sx: {
                                                    color: "#FF8400"
                                                }
                                            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                title: "Download Patrol",
                                                placement: "top",
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2zBdB))), {})
                                            }),
                                            disabled: downloadingPatrolId === patrol.patrol_id
                                        })
                                    })
                                ]
                            }, index)) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                colSpan: 6,
                                align: "center",
                                sx: {
                                    padding: "20px"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "font-mulish text-gray-500",
                                    children: searchQueryPatrols ? "No patrols found matching your search." : "No patrols data available."
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wcxl.default), {
                rowsPerPageOptions: [
                    5,
                    10,
                    25,
                    50
                ],
                component: "div",
                count: sortedData.length,
                rowsPerPage: rowsPerPage,
                page: safePage,
                onPageChange: handleChangePage,
                onRowsPerPageChange: handleChangeRowsPerPage
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $ce8iU = parcelRequire("ce8iU");

var $iKAtE = parcelRequire("iKAtE");

var $433j1 = parcelRequire("433j1");

var $1TOOV = parcelRequire("1TOOV");

var $60vL1 = parcelRequire("60vL1");

var $cVCJe = parcelRequire("cVCJe");

var $2zBdB = parcelRequire("2zBdB");


var $8jTCz = parcelRequire("8jTCz");

var $frXOV = parcelRequire("frXOV");

var $2qUoo = parcelRequire("2qUoo");

var $3n3uW = parcelRequire("3n3uW");

var $2suvB = parcelRequire("2suvB");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4reBM = parcelRequire("4reBM");

var $k8Qy8 = parcelRequire("k8Qy8");


var $gXvgZ = parcelRequire("gXvgZ");

var $4o6Cs = parcelRequire("4o6Cs");

var $aVDw9 = parcelRequire("aVDw9");


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $fWsn7 = parcelRequire("fWsn7");
const $88cde253f4b9e981$var$ALERTS_HEAD_CELLS = [
    {
        id: "camera_name",
        label: "Camera Name"
    },
    {
        id: "timestamp",
        label: "Time"
    },
    {
        id: "detection_code",
        label: "Alert Type"
    },
    {
        id: "schedule_name",
        label: "Schedule"
    }
];
const $88cde253f4b9e981$export$20614d9da850e6c8 = ()=>{
    const navigate = (0, $3T949.useNavigate)();
    const { patrolAlerts: patrolAlerts, selectedPatrolAlertIndex: selectedPatrolAlertIndex, setSelectedPatrolAlertIndex: setSelectedPatrolAlertIndex, fetchPatrolAlertVideo: fetchPatrolAlertVideo } = (0, $91ed8bde22a5429a$export$a3768d425d575143)();
    const [order, setOrder] = (0, $8T3gX.useState)("asc");
    const [orderBy, setOrderBy] = (0, $8T3gX.useState)("timestamp");
    const sortedAlerts = (0, $8T3gX.useMemo)(()=>(0, $fWsn7.stableSort)(patrolAlerts, (0, $fWsn7.getComparator)(order, orderBy)), [
        patrolAlerts,
        order,
        orderBy
    ]);
    const handleRequestSort = (_event, property)=>{
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };
    // Auto-select first row and fetch video when alerts data changes (use first row of sorted list)
    (0, $8T3gX.useEffect)(()=>{
        const sorted = (0, $fWsn7.stableSort)(patrolAlerts, (0, $fWsn7.getComparator)(order, orderBy));
        const firstWindowId = sorted[0]?.window_id;
        if (sorted.length > 0 && firstWindowId) {
            setSelectedPatrolAlertIndex(0);
            fetchPatrolAlertVideo(String(firstWindowId), navigate);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only reset selection when alerts data changes, not when sort order changes
    }, [
        patrolAlerts,
        setSelectedPatrolAlertIndex,
        fetchPatrolAlertVideo,
        navigate
    ]);
    const handleRowClick = (index)=>{
        setSelectedPatrolAlertIndex(index);
        const windowId = sortedAlerts[index]?.window_id;
        if (windowId) fetchPatrolAlertVideo(String(windowId), navigate);
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        sx: {
            height: 450,
            width: "100%",
            maxWidth: 800,
            minWidth: 0,
            backgroundColor: "#f8fafd",
            overflow: "auto"
        },
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
            stickyHeader: true,
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $70a8370edb3a909f$export$efc44a49183353c0), {
                    headCells: [
                        ...$88cde253f4b9e981$var$ALERTS_HEAD_CELLS
                    ],
                    order: order,
                    orderBy: orderBy,
                    onRequestSort: handleRequestSort,
                    backgroundColor: "#e3ecfa"
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                    children: sortedAlerts.length > 0 ? sortedAlerts.map((alert, index)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            onClick: ()=>handleRowClick(index),
                            sx: {
                                backgroundColor: selectedPatrolAlertIndex === index ? "#d4e4f7" : "inherit",
                                "&:hover": {
                                    backgroundColor: selectedPatrolAlertIndex === index ? "#c4d8f0" : "#eaf1fb",
                                    cursor: "pointer"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: {
                                        width: "35%"
                                    },
                                    children: alert.site_id && alert.camera_id && alert.camera_name ? /*#__PURE__*/ (0, $k4ank.jsx)("a", {
                                        href: `sites/${alert.site_id}/editcamera/${alert.camera_id}`,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        style: {
                                            color: "#0d47a1",
                                            textDecoration: "none",
                                            cursor: "pointer"
                                        },
                                        onMouseEnter: (e)=>{
                                            e.currentTarget.style.color = "#002171";
                                            e.currentTarget.style.textDecoration = "underline";
                                        },
                                        onMouseLeave: (e)=>{
                                            e.currentTarget.style.color = "#0d47a1";
                                            e.currentTarget.style.textDecoration = "none";
                                        },
                                        children: alert.camera_name
                                    }) : alert.camera_name || "N/A"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: {
                                        width: "20%"
                                    },
                                    children: (0, $e5f2bfdc8a7a750b$export$7884fc1e42dd8dd0)(typeof alert.timestamp === "string" ? alert.timestamp : String(alert.timestamp))
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: {
                                        width: "25%"
                                    },
                                    children: alert.detection_code
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: {
                                        width: "20%"
                                    },
                                    children: alert.schedule_name ?? "\u2014"
                                })
                            ]
                        }, `${alert.camera_id}-${index}`)) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                            colSpan: 4,
                            align: "center",
                            children: "No alerts for this patrol"
                        })
                    })
                })
            ]
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4reBM = parcelRequire("4reBM");

var $k8Qy8 = parcelRequire("k8Qy8");


var $gXvgZ = parcelRequire("gXvgZ");

var $4o6Cs = parcelRequire("4o6Cs");

var $aVDw9 = parcelRequire("aVDw9");


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $fWsn7 = parcelRequire("fWsn7");
const $f4dc89fe48ec4918$var$CHM_HEAD_CELLS = [
    {
        id: "camera_name",
        label: "Camera Name"
    },
    {
        id: "timestamp",
        label: "Time"
    },
    {
        id: "description",
        label: "Issue Type"
    }
];
const $f4dc89fe48ec4918$export$d0980e8261e9f1a6 = ()=>{
    const navigate = (0, $3T949.useNavigate)();
    const { patrolCHMIssues: patrolCHMIssues, selectedPatrolCHMIndex: selectedPatrolCHMIndex, setSelectedPatrolCHMIndex: setSelectedPatrolCHMIndex, fetchPatrolCHMImage: fetchPatrolCHMImage } = (0, $91ed8bde22a5429a$export$a3768d425d575143)();
    const [order, setOrder] = (0, $8T3gX.useState)("asc");
    const [orderBy, setOrderBy] = (0, $8T3gX.useState)("timestamp");
    const sortedIssues = (0, $8T3gX.useMemo)(()=>(0, $fWsn7.stableSort)(patrolCHMIssues, (0, $fWsn7.getComparator)(order, orderBy)), [
        patrolCHMIssues,
        order,
        orderBy
    ]);
    const handleRequestSort = (_event, property)=>{
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };
    // Auto-select first row and fetch image when CHM data changes (use first row of sorted list)
    (0, $8T3gX.useEffect)(()=>{
        const sorted = (0, $fWsn7.stableSort)(patrolCHMIssues, (0, $fWsn7.getComparator)(order, orderBy));
        if (sorted.length > 0) {
            setSelectedPatrolCHMIndex(0);
            const imageKey = sorted[0]?.image_s3_key;
            if (imageKey != null) fetchPatrolCHMImage(typeof imageKey === "string" ? imageKey : String(imageKey), navigate);
        }
    }, [
        patrolCHMIssues,
        setSelectedPatrolCHMIndex,
        fetchPatrolCHMImage,
        navigate
    ]);
    const handleRowClick = (index)=>{
        setSelectedPatrolCHMIndex(index);
        const imageKey = sortedIssues[index]?.image_s3_key;
        if (imageKey != null) fetchPatrolCHMImage(typeof imageKey === "string" ? imageKey : String(imageKey), navigate);
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
        component: (0, $4reBM.default),
        sx: {
            height: 450,
            width: "100%",
            maxWidth: 800,
            minWidth: 0,
            backgroundColor: "#f8fafd",
            overflow: "auto"
        },
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
            stickyHeader: true,
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $70a8370edb3a909f$export$efc44a49183353c0), {
                    headCells: [
                        ...$f4dc89fe48ec4918$var$CHM_HEAD_CELLS
                    ],
                    order: order,
                    orderBy: orderBy,
                    onRequestSort: handleRequestSort,
                    backgroundColor: "#e3ecfa"
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                    children: sortedIssues.length > 0 ? sortedIssues.map((issue, index)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            onClick: ()=>handleRowClick(index),
                            sx: {
                                backgroundColor: selectedPatrolCHMIndex === index ? "#d4e4f7" : "inherit",
                                "&:hover": {
                                    backgroundColor: selectedPatrolCHMIndex === index ? "#c4d8f0" : "#eaf1fb",
                                    cursor: "pointer"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: {
                                        width: "35%"
                                    },
                                    children: issue.site_id && issue.camera_id && issue.camera_name ? /*#__PURE__*/ (0, $k4ank.jsx)("a", {
                                        href: `sites/${issue.site_id}/editcamera/${issue.camera_id}`,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        style: {
                                            color: "#0d47a1",
                                            textDecoration: "none",
                                            cursor: "pointer"
                                        },
                                        onMouseEnter: (e)=>{
                                            e.currentTarget.style.color = "#002171";
                                            e.currentTarget.style.textDecoration = "underline";
                                        },
                                        onMouseLeave: (e)=>{
                                            e.currentTarget.style.color = "#0d47a1";
                                            e.currentTarget.style.textDecoration = "none";
                                        },
                                        children: issue.camera_name
                                    }) : issue.camera_name || "N/A"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: {
                                        width: "20%"
                                    },
                                    children: (0, $e5f2bfdc8a7a750b$export$7884fc1e42dd8dd0)(typeof issue.timestamp === "string" ? issue.timestamp : String(issue.timestamp))
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    sx: {
                                        width: "30%"
                                    },
                                    children: issue.description
                                })
                            ]
                        }, `${issue.device_id}-${index}`)) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                            colSpan: 3,
                            align: "center",
                            children: "No connectivity issues for this patrol"
                        })
                    })
                })
            ]
        })
    });
};


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

const $dd5117ac4e0d3cbb$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $dd5117ac4e0d3cbb$export$68c3d29dcd809662 = ()=>{
    const navigate = (0, $3T949.useNavigate)();
    const { patrolDialogOpen: patrolDialogOpen, setPatrolDialogOpen: setPatrolDialogOpen, selectedPatrol: selectedPatrol, patrolsData: patrolsData, selectedPatrolIndex: selectedPatrolIndex, setSelectedPatrolIndex: setSelectedPatrolIndex, setSelectedPatrol: setSelectedPatrol, fetchPatrolDialogData: fetchPatrolDialogData, patrolDialogDataLoading: patrolDialogDataLoading, patrolAlertVideoUrl: patrolAlertVideoUrl, patrolAlertVideoLoading: patrolAlertVideoLoading, selectedPatrolAlertIndex: selectedPatrolAlertIndex, patrolCHMImageUrl: patrolCHMImageUrl, patrolCHMImageLoading: patrolCHMImageLoading, selectedPatrolCHMIndex: selectedPatrolCHMIndex, setSelectedPatrolAlertIndex: setSelectedPatrolAlertIndex, setSelectedPatrolCHMIndex: setSelectedPatrolCHMIndex, patrolAlerts: patrolAlerts, patrolCHMIssues: patrolCHMIssues, fetchPatrolAlertVideo: fetchPatrolAlertVideo, fetchPatrolCHMImage: fetchPatrolCHMImage, patrolSummary: patrolSummary, searchQueryPatrols: searchQueryPatrols } = (0, $91ed8bde22a5429a$export$a3768d425d575143)();
    const [selectedTab, setSelectedTab] = $8T3gX.useState("one");
    const [downloadingReport, setDownloadingReport] = $8T3gX.useState(false);
    // Handle download patrol report
    const handleDownloadPatrolReport = async ()=>{
        if (!selectedPatrol?.patrol_id) return;
        setDownloadingReport(true);
        try {
            await (0, $ec6ad63153372911$export$5263d2f4dc2b5050)(String(selectedPatrol.patrol_id));
        } catch (error) {
            console.error("Error downloading patrol report:", error);
            alert("Unable to download patrol report");
        } finally{
            setDownloadingReport(false);
        }
    };
    // Fetch alerts and CHM warnings when selectedPatrol changes
    $8T3gX.useEffect(()=>{
        if (selectedPatrol?.patrol_id && patrolDialogOpen) fetchPatrolDialogData(selectedPatrol.patrol_id, navigate);
    }, [
        selectedPatrol?.patrol_id,
        patrolDialogOpen,
        fetchPatrolDialogData,
        navigate
    ]);
    const filteredPatrols = $8T3gX.useMemo(()=>patrolsData.filter((patrol)=>patrol.site?.toLowerCase().includes(searchQueryPatrols.toLowerCase()) || patrol.patrol_date?.toLowerCase().includes(searchQueryPatrols.toLowerCase()) || patrol.start_time?.toLowerCase().includes(searchQueryPatrols.toLowerCase()) || patrol.schedule_name?.toLowerCase().includes(searchQueryPatrols.toLowerCase())), [
        patrolsData,
        searchQueryPatrols
    ]);
    const hasPatrols = filteredPatrols.length > 0;
    const clampedPatrolIndex = hasPatrols ? Math.min(Math.max(selectedPatrolIndex, 0), filteredPatrols.length - 1) : 0;
    const canPrevAlert = patrolAlerts.length > 0 && selectedPatrolAlertIndex > 0;
    const canNextAlert = patrolAlerts.length > 0 && selectedPatrolAlertIndex < patrolAlerts.length - 1;
    const canPrevCHM = patrolCHMIssues.length > 0 && selectedPatrolCHMIndex > 0;
    const canNextCHM = patrolCHMIssues.length > 0 && selectedPatrolCHMIndex < patrolCHMIssues.length - 1;
    const handlePrevMedia = ()=>{
        if (selectedTab === "one") {
            if (!canPrevAlert) return;
            const newIndex = selectedPatrolAlertIndex - 1;
            setSelectedPatrolAlertIndex(newIndex);
            const windowId = patrolAlerts[newIndex]?.window_id;
            if (windowId) fetchPatrolAlertVideo(windowId, navigate);
        } else {
            if (!canPrevCHM) return;
            const newIndex = selectedPatrolCHMIndex - 1;
            setSelectedPatrolCHMIndex(newIndex);
            const imageKey = patrolCHMIssues[newIndex]?.image_s3_key;
            fetchPatrolCHMImage(imageKey, navigate);
        }
    };
    const handleNextMedia = ()=>{
        if (selectedTab === "one") {
            if (!canNextAlert) return;
            const newIndex = selectedPatrolAlertIndex + 1;
            setSelectedPatrolAlertIndex(newIndex);
            const windowId = patrolAlerts[newIndex]?.window_id;
            if (windowId) fetchPatrolAlertVideo(windowId, navigate);
        } else {
            if (!canNextCHM) return;
            const newIndex = selectedPatrolCHMIndex + 1;
            setSelectedPatrolCHMIndex(newIndex);
            const imageKey = patrolCHMIssues[newIndex]?.image_s3_key;
            fetchPatrolCHMImage(imageKey, navigate);
        }
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
            open: patrolDialogOpen,
            fullWidth: true,
            maxWidth: "xl",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                    sx: {
                        marginLeft: 2,
                        p: 2,
                        position: "relative"
                    },
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "flex items-center flex-1 pr-4",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "font-mulish text-actuate-blue",
                                        children: selectedPatrol ? `${selectedPatrol.site} | ${selectedPatrol.patrol_date} ${selectedPatrol.start_time} Patrol` : "Patrol Details"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                        onClick: handleDownloadPatrolReport,
                                        text: downloadingReport ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                            size: 20,
                                            sx: {
                                                color: "#FF8400"
                                            }
                                        }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                            title: "Download Patrol",
                                            placement: "top",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2zBdB))), {})
                                        }),
                                        disabled: downloadingReport || !selectedPatrol?.patrol_id
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "flex items-center text-gray-600 text-[14px]",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                                        className: "mr-4",
                                        children: [
                                            hasPatrols ? clampedPatrolIndex + 1 : 0,
                                            " of",
                                            " ",
                                            filteredPatrols.length
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                        onClick: ()=>{
                                            const nextIndex = clampedPatrolIndex - 1;
                                            setSelectedPatrolIndex(nextIndex);
                                            setSelectedPatrol(filteredPatrols[nextIndex]);
                                        },
                                        text: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                            title: "Previous Patrol",
                                            placement: "top",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($frXOV))), {
                                                fontSize: "small",
                                                id: "fowardButton"
                                            })
                                        }),
                                        disabled: !hasPatrols || clampedPatrolIndex === 0
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                        onClick: ()=>{
                                            const nextIndex = clampedPatrolIndex + 1;
                                            setSelectedPatrolIndex(nextIndex);
                                            setSelectedPatrol(filteredPatrols[nextIndex]);
                                        },
                                        text: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                            title: "Next Patrol",
                                            placement: "top",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2qUoo))), {
                                                fontSize: "small",
                                                id: "backButton"
                                            })
                                        }),
                                        disabled: !hasPatrols || clampedPatrolIndex === filteredPatrols.length - 1
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                        "aria-label": "close",
                                        onClick: ()=>{
                                            setPatrolDialogOpen(false);
                                        },
                                        sx: {
                                            color: (theme)=>theme.palette.grey[500],
                                            ml: 1
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                    dividers: true,
                    sx: {
                        height: 550
                    },
                    children: patrolDialogDataLoading ? /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "flex justify-center items-center h-full",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                            sx: {
                                color: "#FF8400"
                            }
                        })
                    }) : /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "flex flex-col w-full",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "flex flex-col w-full pb-4 mb-4 font-mulish border-b border-gray-200",
                                style: {
                                    fontFamily: "Mulish, sans-serif"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "font-mulish font-bold text-actuate-blue mb-1",
                                        children: "Patrol Summary"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "font-mulish text-gray-700",
                                        style: {
                                            fontSize: "0.875rem"
                                        },
                                        children: patrolSummary || "No summary available."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "flex gap-2 justify-center items-start min-w-0",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "flex flex-col flex-1 min-w-0 max-w-[800px]",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                                                theme: $dd5117ac4e0d3cbb$var$theme,
                                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3n3uW.default), {
                                                    value: selectedTab,
                                                    onChange: (event, tabValue)=>{
                                                        setSelectedTab(tabValue);
                                                    },
                                                    "aria-label": "patrol tabs",
                                                    color: "primary",
                                                    variant: "fullWidth",
                                                    sx: {
                                                        width: "100%",
                                                        maxWidth: 800,
                                                        marginBottom: "16px"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                                                            value: "one",
                                                            label: `Alerts (${patrolAlerts.length})`,
                                                            sx: {
                                                                fontFamily: "Mulish",
                                                                fontWeight: "Bold",
                                                                color: "primary"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                                                            value: "two",
                                                            label: `Connectivity (${patrolCHMIssues.length})`,
                                                            sx: {
                                                                fontFamily: "Mulish",
                                                                fontWeight: "Bold",
                                                                color: "primary"
                                                            }
                                                        })
                                                    ]
                                                })
                                            }),
                                            selectedTab === "one" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $88cde253f4b9e981$export$20614d9da850e6c8), {}),
                                            selectedTab === "two" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $f4dc89fe48ec4918$export$d0980e8261e9f1a6), {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "flex items-center justify-center gap-2 pl-[25px] pt-[25px]",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                onClick: handlePrevMedia,
                                                text: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                    title: selectedTab === "one" ? "Previous Alert" : "Previous CHM Warning",
                                                    placement: "top",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($frXOV))), {
                                                        fontSize: "small"
                                                    })
                                                }),
                                                disabled: selectedTab === "one" ? !canPrevAlert : !canPrevCHM
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "flex flex-col items-center justify-center",
                                                style: {
                                                    width: 500,
                                                    height: 300
                                                },
                                                children: selectedTab === "one" ? patrolAlertVideoLoading ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                                    sx: {
                                                        color: "#FF8400"
                                                    }
                                                }) : patrolAlertVideoUrl ? /*#__PURE__*/ (0, $k4ank.jsxs)("video", {
                                                    width: "500",
                                                    controls: true,
                                                    autoPlay: true,
                                                    loop: true,
                                                    children: [
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("source", {
                                                            src: patrolAlertVideoUrl,
                                                            type: "video/mp4"
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("track", {
                                                            kind: "captions",
                                                            src: ""
                                                        })
                                                    ]
                                                }, `${selectedPatrolIndex}-${selectedPatrolAlertIndex}`) : /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                    className: "text-gray-500 font-mulish",
                                                    children: "No video available"
                                                }) : patrolCHMImageLoading ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                                    sx: {
                                                        color: "#FF8400"
                                                    }
                                                }) : patrolCHMImageUrl ? /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                                                    src: patrolCHMImageUrl,
                                                    alt: "CHM Warning",
                                                    style: {
                                                        maxWidth: 500,
                                                        maxHeight: 300,
                                                        objectFit: "contain"
                                                    }
                                                }, `${selectedPatrolIndex}-${selectedPatrolCHMIndex}`) : /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                    className: "text-gray-500 font-mulish",
                                                    children: "No image available"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                onClick: handleNextMedia,
                                                text: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                    title: selectedTab === "one" ? "Next Alert" : "Next CHM Warning",
                                                    placement: "top",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2qUoo))), {
                                                        fontSize: "small"
                                                    })
                                                }),
                                                disabled: selectedTab === "one" ? !canNextAlert : !canNextCHM
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};



var $4PFLW = parcelRequire("4PFLW");

var $dHtmK = parcelRequire("dHtmK");
const $3e9a0170683494d1$export$b9e5c0acf002729a = ({ navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed })=>{
    const { resetStatePatrols: resetStatePatrols, patrolDialogOpen: patrolDialogOpen, patrolsHistoryLoading: patrolsHistoryLoading, filtersAppliedPatrols: filtersAppliedPatrols } = (0, $91ed8bde22a5429a$export$a3768d425d575143)();
    // Reset all patrol state when navigating away from the Patrols page
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        return ()=>{
            resetStatePatrols();
        };
    }, [
        resetStatePatrols
    ]);
    const { flags: flags } = (0, $4PFLW.useFeatureFlag)();
    const showPatrolsPage = flags.showPatrolsPage;
    if (showPatrolsPage) return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                openState: patrolsHistoryLoading
            }),
            patrolDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $dd5117ac4e0d3cbb$export$68c3d29dcd809662), {}),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "bg-actuate-grey absolute w-screen h-screen overflow-scroll",
                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: !navBarCollapsed ? "font-mulish w-full min-w-[1200px]" : "font-mulish w-full min-w-[1200px]",
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: !navBarCollapsed ? "ml-[150px]" : "ml-[75px]",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "bg-white p-4 w-full min-w-fit h-full flex gap-4",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $deb71cbb233803ac$export$e46dc2957e9a11e3), {
                                        navBarCollapsed: navBarCollapsed
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $053d112dc481941b$export$de3eb578468f4dbe), {
                                        navBarCollapsed: navBarCollapsed
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $1b3e7002efb52266$export$947cb68dd9740d78), {}),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $7c1c790d8da1f852$export$1ab72452c1a1e90), {}),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $b73b46e5ec0a8979$export$d5a57ffd3f35b42b), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "mt-[20px]",
                                children: filtersAppliedPatrols ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $344feb892c8eaecf$export$4ac570cdb377962e), {}) : /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "relative top-[200px] text-center",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "font-mulish text-[22px]",
                                        children: "Please Apply Filters to View Patrols."
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "justify-start",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jVN1H.NavBar), {
                    navBarCollapsed: navBarCollapsed,
                    setNavBarCollapsed: setNavBarCollapsed,
                    props: {}
                })
            })
        ]
    });
    else if (!showPatrolsPage) return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "bg-actuate-grey absolute w-screen h-screen overflow-scroll",
                children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "font-mulish pt-[200px] text-[24px] text-actuate-blue text-center",
                    children: "Patrols page coming soon"
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "justify-start",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jVN1H.NavBar), {
                    navBarCollapsed: navBarCollapsed,
                    setNavBarCollapsed: setNavBarCollapsed,
                    props: {}
                })
            })
        ]
    });
    // Return null or default content when feature flag is false
    return null;
};





var $7isVd = parcelRequire("7isVd");
/* eslint-disable jsx-a11y/media-has-caption */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $jVN1H = parcelRequire("jVN1H");
/* eslint-disable jsx-a11y/media-has-caption */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $fIsAN = parcelRequire("fIsAN");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $1wcxl = parcelRequire("1wcxl");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $ePwXE = parcelRequire("ePwXE");

var $g0plP = parcelRequire("g0plP");

var $fWsn7 = parcelRequire("fWsn7");

var $fWsn7 = parcelRequire("fWsn7");
const $94e6bb80767641a9$export$a2c9a5662351211 = (filterType)=>filterType === "UNCLAIMED";
/**
 * Trims a timestamp to the first 10 digits
 * @param timestamp - The timestamp to trim (can be string or number)
 * @returns The trimmed timestamp as a number
 */ const $94e6bb80767641a9$var$trimTimestamp = (timestamp)=>{
    if (timestamp === undefined || timestamp === null) return 0;
    const timestampStr = timestamp.toString();
    // Extract first 10 digits from the timestamp string
    const firstTenDigits = timestampStr.substring(0, 10);
    return parseInt(firstTenDigits, 10);
};
const $94e6bb80767641a9$export$1874ac93f6160b49 = (alert, mutedAlertSites, mutedAlertCameras)=>{
    if (!alert) return false;
    // Server truth (ENG-1309): the connector stamps dispatch_muted on the
    // alert record when an operational mute suppressed delivery. This is
    // authoritative for the alert itself; the muted lists below are the shared
    // fleet-wide mute state (ENG-2103) and also cover not-yet-stamped alerts.
    if (alert.dispatch_muted === true) return true;
    // Early return if alert is missing required properties
    if (!alert.approx_capture_timestamp) return false;
    const alertTimestamp = $94e6bb80767641a9$var$trimTimestamp(alert.approx_capture_timestamp);
    // Check if alert is muted by site
    const isMutedBySite = mutedAlertSites.some((mutedSite)=>{
        const trimmedStartTime = $94e6bb80767641a9$var$trimTimestamp(mutedSite.mute_start_time);
        const trimmedEndTime = $94e6bb80767641a9$var$trimTimestamp(mutedSite.mute_end_time);
        return alert.customer_pk === mutedSite.site_id && alertTimestamp >= trimmedStartTime && alertTimestamp <= trimmedEndTime;
    });
    // Check if alert is muted by camera
    const isMutedByCamera = mutedAlertCameras.some((mutedCamera)=>{
        const trimmedStartTime = $94e6bb80767641a9$var$trimTimestamp(mutedCamera.mute_start_time);
        const trimmedEndTime = $94e6bb80767641a9$var$trimTimestamp(mutedCamera.mute_end_time);
        return alert.camera_pk === mutedCamera.camera_id && alertTimestamp >= trimmedStartTime && alertTimestamp <= trimmedEndTime;
    });
    return isMutedBySite || isMutedByCamera;
};



var $biDrR = parcelRequire("biDrR");
const $6e02db388b82b823$var$defaultContext = {
    detectionType: "All",
    outcomeFilterType: "All",
    vlmFilterType: "All",
    showVlmFilters: false,
    mutedAlertSites: [],
    mutedAlertCameras: [],
    filterType: undefined,
    order: "asc",
    orderBy: ""
};
let $6e02db388b82b823$var$navigableAlertsContext = {
    ...$6e02db388b82b823$var$defaultContext
};
const $6e02db388b82b823$export$52961540270454ba = (next)=>{
    $6e02db388b82b823$var$navigableAlertsContext = next;
};
const $6e02db388b82b823$export$4f1961990ac2c404 = ()=>$6e02db388b82b823$var$navigableAlertsContext;
const $6e02db388b82b823$export$d95673b906883801 = ()=>({
        order: localStorage.getItem("alertsTableOrder"),
        orderBy: localStorage.getItem("alertsTableOrderBy")
    });
const $6e02db388b82b823$export$7a01cfb15849021d = (a, b)=>{
    if (!a || !b) return false;
    if (a?.id && b?.id) return a.id === b.id;
    return a.approx_capture_timestamp === b.approx_capture_timestamp && a.window_id === b.window_id;
};
const $6e02db388b82b823$export$c18f05524cab3606 = (index, length)=>{
    if (length <= 1 || index < 0) return {
        backDisabled: true,
        forwardDisabled: true
    };
    return {
        backDisabled: index <= 0,
        forwardDisabled: index >= length - 1
    };
};
const $6e02db388b82b823$export$6ee189a072663b57 = ({ alertData: alertData, detectionType: detectionType = "All", outcomeFilterType: outcomeFilterType = "All", mutedAlertSites: mutedAlertSites = [], mutedAlertCameras: mutedAlertCameras = [], filterType: filterType, applyMuteFilter: applyMuteFilter })=>{
    const rows = Array.isArray(alertData) ? alertData : [];
    const shouldMuteFilter = applyMuteFilter ?? (0, $94e6bb80767641a9$export$a2c9a5662351211)(filterType);
    const visibleRows = shouldMuteFilter ? rows.filter((row)=>!(0, $94e6bb80767641a9$export$1874ac93f6160b49)(row, mutedAlertSites, mutedAlertCameras)) : rows;
    if (detectionType === "All" && outcomeFilterType === "All") return visibleRows;
    if (detectionType !== "All" && outcomeFilterType === "All") {
        const label = (0, $fWsn7.setDetectionTypeLower)(detectionType);
        return visibleRows.filter((row)=>row.alert_labels === label);
    }
    if (detectionType === "All" && outcomeFilterType !== "All") return visibleRows.filter((row)=>row.detection_type === outcomeFilterType);
    const label = (0, $fWsn7.setDetectionTypeLower)(detectionType);
    return visibleRows.filter((row)=>row.alert_labels === label && row.detection_type === outcomeFilterType);
};
const $6e02db388b82b823$export$cdfae0e972447b21 = (args)=>{
    const beforeVlm = $6e02db388b82b823$export$6ee189a072663b57(args);
    const rows = args.showVlmFilters ? (0, $biDrR.applyVlmFilter)(beforeVlm, args.vlmFilterType ?? "All") : beforeVlm;
    if (!args.order || !args.orderBy) return rows;
    const order = args.order === "desc" ? "desc" : "asc";
    return (0, $fWsn7.stableSort)(rows, (0, $fWsn7.getComparator)(order, args.orderBy));
};


var $6416eab92432523e$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($6416eab92432523e$exports, "__esModule", {
    value: true
});
$6416eab92432523e$exports.default = void 0;

var $6416eab92432523e$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $6416eab92432523e$var$_default = $6416eab92432523e$exports.default = (0, $6416eab92432523e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("circle", {
    cx: "12",
    cy: "12",
    r: "8"
}), 'FiberManualRecord');



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");
var $aVDw9 = parcelRequire("aVDw9");
var $ha39s = parcelRequire("ha39s");
var $4o6Cs = parcelRequire("4o6Cs");
var $kLvBh = parcelRequire("kLvBh");

var $9lVTU = parcelRequire("9lVTU");

var $iKAtE = parcelRequire("iKAtE");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");

var $i5MAs = parcelRequire("i5MAs");

var $aYdit = parcelRequire("aYdit");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");
var $cb272c078529d073$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($cb272c078529d073$exports, "__esModule", {
    value: true
});
$cb272c078529d073$exports.default = void 0;

var $cb272c078529d073$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $cb272c078529d073$var$_default = $cb272c078529d073$exports.default = (0, $cb272c078529d073$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M21 11V3h-8l3.29 3.29-10 10L3 13v8h8l-3.29-3.29 10-10z"
}), 'OpenInFull');


var $eb63a519b5f90cfa$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($eb63a519b5f90cfa$exports, "__esModule", {
    value: true
});
$eb63a519b5f90cfa$exports.default = void 0;

var $eb63a519b5f90cfa$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $eb63a519b5f90cfa$var$_default = $eb63a519b5f90cfa$exports.default = (0, $eb63a519b5f90cfa$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M12 5.83 15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15z"
}), 'UnfoldMore');


const $5ca90d495b313c72$export$f7d2ba1270db97c7 = 540;
const $5ca90d495b313c72$export$75369d05e87cce05 = 304;
const $5ca90d495b313c72$export$28ac97e8d179c860 = 2;
const $5ca90d495b313c72$export$17598dea07183dd4 = 70;
const $5ca90d495b313c72$export$ba9700a38b3eed0a = 360;
const $5ca90d495b313c72$export$96fa3ceaceb0d484 = 200;
const $5ca90d495b313c72$export$7b2d104900cc4efe = 960;
const $5ca90d495b313c72$export$f541aa2ea32672a4 = 540;
const $5ca90d495b313c72$export$6fc6fa9e6d10dd1f = 680;
const $5ca90d495b313c72$export$e75acedb05cc6dcc = (height)=>Math.min($5ca90d495b313c72$export$f541aa2ea32672a4, Math.max($5ca90d495b313c72$export$96fa3ceaceb0d484, Math.round(height)));
const $5ca90d495b313c72$export$a7b1bc13e45d1a1f = (width, height)=>({
        width: Math.min($5ca90d495b313c72$export$7b2d104900cc4efe, Math.max($5ca90d495b313c72$export$ba9700a38b3eed0a, Math.round(width))),
        height: Math.min($5ca90d495b313c72$export$f541aa2ea32672a4, Math.max($5ca90d495b313c72$export$96fa3ceaceb0d484, Math.round(height)))
    });
const $5ca90d495b313c72$export$78c5fa173e03e8e0 = (totalWidth)=>(totalWidth - $5ca90d495b313c72$export$28ac97e8d179c860) / 2;
const $5ca90d495b313c72$export$51b57390f3de9843 = (contentWidth, useResizableLayout)=>useResizableLayout ? contentWidth + $5ca90d495b313c72$export$17598dea07183dd4 * 2 : $5ca90d495b313c72$export$6fc6fa9e6d10dd1f;
const $5ca90d495b313c72$export$1860282aae834e25 = (videoHeight)=>Math.round(42 + videoHeight / 2 - 20);
const $5ca90d495b313c72$export$195eb5257ab87be3 = $5ca90d495b313c72$export$1860282aae834e25;
const $5ca90d495b313c72$export$82ef4010e204d1ed = ({ ariaLabel: ariaLabel, cursorClass: cursorClass, iconClassName: iconClassName = "", iconSx: iconSx, onMouseDown: onMouseDown })=>/*#__PURE__*/ (0, $k4ank.jsx)("button", {
        type: "button",
        "aria-label": ariaLabel,
        onMouseDown: onMouseDown,
        className: `flex h-8 w-8 ${cursorClass} items-center justify-center rounded-full border border-actuate-grey bg-white font-mulish text-actuate-blue shadow-sm transition-colors hover:border-actuate-orange hover:text-actuate-orange`,
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cb272c078529d073$exports))), {
            fontSize: "small",
            className: iconClassName,
            sx: iconSx,
            "aria-hidden": true
        })
    });
const $5ca90d495b313c72$export$524f9ced0e401d3f = ({ size: size, onResize: onResize })=>{
    const handleMouseDown = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        const startX = event.clientX;
        const startY = event.clientY;
        const startWidth = size.width;
        const startHeight = size.height;
        const handleMouseMove = (moveEvent)=>{
            onResize($5ca90d495b313c72$export$a7b1bc13e45d1a1f(startWidth + (moveEvent.clientX - startX), startHeight + (moveEvent.clientY - startY)));
        };
        const handleMouseUp = ()=>{
            document.removeEventListener("mousemove", handleMouseMove);
            document.removeEventListener("mouseup", handleMouseUp);
            document.body.style.cursor = "";
            document.body.style.userSelect = "";
        };
        document.body.style.cursor = "nwse-resize";
        document.body.style.userSelect = "none";
        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)($5ca90d495b313c72$export$82ef4010e204d1ed, {
        ariaLabel: "Resize video panel",
        cursorClass: "cursor-nwse-resize",
        iconClassName: "-scale-x-100",
        onMouseDown: handleMouseDown
    });
};
const $5ca90d495b313c72$export$84850014cec2e9df = ({ height: height, onHeightChange: onHeightChange })=>{
    const handleMouseDown = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        const startY = event.clientY;
        const startHeight = height;
        const handleMouseMove = (moveEvent)=>{
            onHeightChange($5ca90d495b313c72$export$e75acedb05cc6dcc(startHeight + (moveEvent.clientY - startY)));
        };
        const handleMouseUp = ()=>{
            document.removeEventListener("mousemove", handleMouseMove);
            document.removeEventListener("mouseup", handleMouseUp);
            document.body.style.cursor = "";
            document.body.style.userSelect = "";
        };
        document.body.style.cursor = "ns-resize";
        document.body.style.userSelect = "none";
        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)("button", {
        type: "button",
        "aria-label": "Resize video height",
        onMouseDown: handleMouseDown,
        className: "flex h-8 w-8 cursor-ns-resize items-center justify-center rounded-full border border-actuate-grey bg-white font-mulish text-actuate-blue shadow-sm transition-colors hover:border-actuate-orange hover:text-actuate-orange",
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eb63a519b5f90cfa$exports))), {
            fontSize: "small",
            "aria-hidden": true
        })
    });
};


const $d09f1be34538e2b9$export$860bfff3808c6d5a = 650;
const $d09f1be34538e2b9$export$6091ec612948f11d = 655;
const $d09f1be34538e2b9$export$8303e5efb9c8fe9d = 400;
const $d09f1be34538e2b9$export$4744536e04f030c5 = -150;
const $d09f1be34538e2b9$export$cd06ddcba6bde71b = 20;
const $d09f1be34538e2b9$export$a1e42d23e9171cb5 = {
    width: $d09f1be34538e2b9$export$cd06ddcba6bde71b,
    maxWidth: $d09f1be34538e2b9$export$cd06ddcba6bde71b,
    minWidth: $d09f1be34538e2b9$export$cd06ddcba6bde71b,
    padding: "4px 0 4px 4px",
    boxSizing: "border-box",
    overflow: "hidden"
};
const $d09f1be34538e2b9$export$afc98fd3f390bb92 = {
    fontSize: "11.5px",
    fontFamily: "Mulish",
    whiteSpace: "normal",
    wordBreak: "break-word",
    overflowWrap: "anywhere",
    verticalAlign: "top"
};
const $d09f1be34538e2b9$export$bfd8741867c21309 = 0.45;
const $d09f1be34538e2b9$export$517b0874e012d50a = "alertsTableWidthOffset";
const $d09f1be34538e2b9$export$aac3bd7552583088 = (contentAreaWidth)=>Math.max($d09f1be34538e2b9$export$860bfff3808c6d5a, Math.round(contentAreaWidth * $d09f1be34538e2b9$export$bfd8741867c21309));
const $d09f1be34538e2b9$export$c659834e3bed84c3 = ()=>{
    try {
        const raw = window.localStorage.getItem($d09f1be34538e2b9$export$517b0874e012d50a);
        if (raw === null) return 0;
        const parsed = Number(raw);
        return Number.isFinite(parsed) ? $d09f1be34538e2b9$export$165409351d6bb720(parsed) : 0;
    } catch  {
        return 0;
    }
};
const $d09f1be34538e2b9$export$921a907c40e3873d = (offset)=>{
    try {
        window.localStorage.setItem($d09f1be34538e2b9$export$517b0874e012d50a, String(offset));
    } catch  {
    // localStorage unavailable (private mode) — width just won't persist
    }
};
const $d09f1be34538e2b9$export$165409351d6bb720 = (offset)=>Math.min($d09f1be34538e2b9$export$8303e5efb9c8fe9d, Math.max($d09f1be34538e2b9$export$4744536e04f030c5, Math.round(offset)));
const $d09f1be34538e2b9$export$13513e963d29be4e = (offset)=>$d09f1be34538e2b9$export$860bfff3808c6d5a + offset;
const $d09f1be34538e2b9$export$4d2709c9efad1df0 = (offset)=>$d09f1be34538e2b9$export$6091ec612948f11d + offset;
const $d09f1be34538e2b9$export$349bd64be0aff708 = ({ offset: offset, onOffsetChange: onOffsetChange })=>{
    const handleMouseDown = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        const startX = event.clientX;
        const startOffset = offset;
        const handleMouseMove = (moveEvent)=>{
            onOffsetChange($d09f1be34538e2b9$export$165409351d6bb720(startOffset + (moveEvent.clientX - startX)));
        };
        const handleMouseUp = ()=>{
            document.removeEventListener("mousemove", handleMouseMove);
            document.removeEventListener("mouseup", handleMouseUp);
            document.body.style.cursor = "";
            document.body.style.userSelect = "";
        };
        document.body.style.cursor = "ew-resize";
        document.body.style.userSelect = "none";
        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $5ca90d495b313c72$export$82ef4010e204d1ed), {
        ariaLabel: "Resize alerts table",
        cursorClass: "cursor-ew-resize",
        iconSx: {
            transform: "rotate(45deg)"
        },
        onMouseDown: handleMouseDown
    });
};


const $4c3639747a19c087$export$70718678ea0eb7ea = (props)=>{
    const { onRequestSort: onRequestSort, orderBy: orderBy, order: order, showVlmVerdictColumn: showVlmVerdictColumn } = props;
    // Move state and handlers inside the component
    const [anchorEl, setAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        event.stopPropagation(); // Stop event propagation to prevent table sorting
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (event)=>{
        event.stopPropagation(); // Stop event propagation to prevent table sorting
        setAnchorEl(null);
    };
    const { setDateMMDDYYYY: setDateMMDDYYYY } = (0, $aYdit.useAppStore)();
    // Define headCells inside the component so it can access the state and handlers
    const headCells = [
        {
            id: "display_name",
            numeric: false,
            label: "Site"
        },
        {
            id: "camera_name",
            numeric: false,
            label: "Camera"
        },
        {
            id: "formatted_date",
            numeric: true,
            label: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex shrink-0 whitespace-nowrap",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                        children: `Site Time`
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                "aria-label": "more",
                                id: "long-button",
                                "aria-controls": open ? "long-menu" : undefined,
                                "aria-expanded": open ? "true" : undefined,
                                "aria-haspopup": "true",
                                onClick: handleClick,
                                sx: {
                                    width: "18px",
                                    height: "18px",
                                    padding: "0px"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5MAs))), {
                                    sx: {
                                        fontSize: "18px"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                                id: "long-menu",
                                MenuListProps: {
                                    "aria-labelledby": "long-button"
                                },
                                anchorOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                anchorEl: anchorEl,
                                open: open,
                                onClose: handleClose,
                                slotProps: {
                                    paper: {
                                        style: {
                                            maxHeight: 216,
                                            width: "20ch"
                                        }
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: (event)=>{
                                            setDateMMDDYYYY(true);
                                            event.stopPropagation(); // Stop event propagation to prevent table sorting
                                            handleClose(event);
                                        },
                                        children: "MM/DD/YYYY"
                                    }, "mm-dd-yyyy"),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: (event)=>{
                                            setDateMMDDYYYY(false);
                                            event.stopPropagation(); // Stop event propagation to prevent table sorting
                                            handleClose(event);
                                        },
                                        children: "DD/MM/YYYY"
                                    }, "dd-mm-yyyy")
                                ]
                            })
                        ]
                    })
                ]
            })
        },
        {
            id: "alert_labels",
            numeric: false,
            label: "Type"
        },
        {
            id: "detection_type",
            numeric: false,
            label: "Detection"
        },
        // DoubleTake verdict column (ENG-1756). Ranked sort in shared comparator
        // (ENG-1820) so prev/next matches the table.
        ...showVlmVerdictColumn ? [
            {
                id: "vlm_verdict",
                numeric: false,
                label: "DT Verdict"
            }
        ] : []
    ];
    const createSortHandler = (property)=>(event)=>{
            onRequestSort(event, property);
        };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    align: "left",
                    sortDirection: orderBy === "seen" ? order : false,
                    sx: (0, $d09f1be34538e2b9$export$a1e42d23e9171cb5),
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kLvBh.default), {
                        active: orderBy === "seen",
                        direction: orderBy === "seen" ? order : "asc",
                        onClick: createSortHandler("seen"),
                        children: orderBy === "seen" ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                            component: "span",
                            sx: (0, $9lVTU.default),
                            children: order === "desc" ? "sorted descending" : "sorted ascending"
                        }) : null
                    })
                }, "seen"),
                headCells.map((headCell)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                        align: "left",
                        sortDirection: orderBy === headCell.id ? order : false,
                        style: {
                            width: `20%`
                        },
                        sx: {
                            fontFamily: "mulish",
                            fontWeight: 700,
                            fontSize: 11
                        },
                        children: headCell.sortable === false ? headCell.label : /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kLvBh.default), {
                            active: orderBy === headCell.id,
                            direction: orderBy === headCell.id ? order : "asc",
                            onClick: createSortHandler(headCell.id),
                            children: [
                                headCell.label,
                                orderBy === headCell.id ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                    component: "span",
                                    sx: (0, $9lVTU.default),
                                    children: order === "desc" ? "sorted descending" : "sorted ascending"
                                }) : null
                            ]
                        })
                    }, headCell.id))
            ]
        })
    });
};


parcelRequire("8T3gX");
const $e16b4c67693640c8$export$e44ee059113f075d = (row, setSelectedButtonsFilled)=>{
    if (!row.detection_type) setSelectedButtonsFilled({
        true_threat: true,
        true_non_threat: true,
        false_positive: true,
        escalated_true_threat: true
    });
    if (row.detection_type === "true_threat") setSelectedButtonsFilled({
        true_threat: true,
        true_non_threat: false,
        false_positive: false,
        escalated_true_threat: false
    });
    if (row.detection_type === "true_non_threat") setSelectedButtonsFilled({
        true_threat: false,
        true_non_threat: true,
        false_positive: false,
        escalated_true_threat: false
    });
    if (row.detection_type === "false_positive") setSelectedButtonsFilled({
        true_threat: false,
        true_non_threat: false,
        false_positive: true,
        escalated_true_threat: false
    });
    if (row.detection_type === "escalated_true_threat") setSelectedButtonsFilled({
        true_threat: false,
        true_non_threat: false,
        false_positive: false,
        escalated_true_threat: true
    });
};



var $3Zv1D = parcelRequire("3Zv1D");

var $hAnMZ = parcelRequire("hAnMZ");
/**
 * Simple in-memory cache for video URLs with expiry.
 * Cache is cleared when user revisits the Alerts page.
 *
 * Also provides request tracking to prevent stale API responses from
 * setting video URLs when the user has already selected a different alert.
 */ const $f3879d0f44faa78a$export$9eec69cddf174afd = (row)=>{
    const ts = row?.approx_capture_timestamp ?? "";
    const windowId = row?.window_id ?? "";
    return `${String(ts)}|${String(windowId)}`;
};
const $f3879d0f44faa78a$export$4a87c6b5ff8fd60d = (url)=>{
    return typeof url === "string" && url.toLowerCase().includes("temp");
};
// Cache storage
let $f3879d0f44faa78a$var$videoUrlCache = {};
/**
 * Request tracking to prevent race conditions.
 * Each time a new row is selected, we increment the request ID.
 * When an API response comes back, we check if the request ID matches
 * the current expected ID - if not, the response is stale and should be ignored.
 */ let $f3879d0f44faa78a$var$currentVideoRequestId = 0;
/**
 * Track the row key that currently has an in-flight fetch request.
 * Used to deduplicate multiple fetch calls for the same row.
 */ let $f3879d0f44faa78a$var$currentlyFetchingRowKey = null;
const $f3879d0f44faa78a$export$c97510e344e07687 = ()=>{
    $f3879d0f44faa78a$var$currentVideoRequestId += 1;
    return $f3879d0f44faa78a$var$currentVideoRequestId;
};
const $f3879d0f44faa78a$export$d1cfaba9e8573694 = (requestId)=>{
    return requestId === $f3879d0f44faa78a$var$currentVideoRequestId;
};
const $f3879d0f44faa78a$export$4dec14471a419156 = ()=>{
    return $f3879d0f44faa78a$var$currentVideoRequestId;
};
const $f3879d0f44faa78a$export$80b36d03fd557813 = (rowKey)=>{
    return $f3879d0f44faa78a$var$currentlyFetchingRowKey === rowKey;
};
const $f3879d0f44faa78a$export$aa032ae1b352f844 = (rowKey)=>{
    if ($f3879d0f44faa78a$var$currentlyFetchingRowKey === rowKey) return false;
    $f3879d0f44faa78a$var$currentlyFetchingRowKey = rowKey;
    return true;
};
const $f3879d0f44faa78a$export$58024f8ad30f55ec = (rowKey)=>{
    $f3879d0f44faa78a$var$currentlyFetchingRowKey = rowKey;
};
const $f3879d0f44faa78a$export$a771af35e5682253 = ()=>{
    $f3879d0f44faa78a$var$currentlyFetchingRowKey = null;
};
const $f3879d0f44faa78a$export$847021a4339a3bbe = ()=>{
    $f3879d0f44faa78a$var$currentVideoRequestId += 1;
    $f3879d0f44faa78a$var$currentlyFetchingRowKey = null;
};
// Cache expiry time in milliseconds (5 minutes)
const $f3879d0f44faa78a$var$CACHE_EXPIRY_MS = 300000;
const $f3879d0f44faa78a$export$36920e0f06e448e = (cacheKey)=>{
    const entry = $f3879d0f44faa78a$var$videoUrlCache[cacheKey];
    if (!entry) return null;
    // Check if entry has expired
    const now = Date.now();
    if (now - entry.timestamp > $f3879d0f44faa78a$var$CACHE_EXPIRY_MS) {
        // Remove expired entry
        delete $f3879d0f44faa78a$var$videoUrlCache[cacheKey];
        return null;
    }
    return entry.url;
};
const $f3879d0f44faa78a$export$557be0ee92bfdc47 = (cacheKey, url)=>{
    $f3879d0f44faa78a$var$videoUrlCache[cacheKey] = {
        url: url,
        timestamp: Date.now()
    };
};
const $f3879d0f44faa78a$export$eb990a362b7d891f = ()=>{
    $f3879d0f44faa78a$var$videoUrlCache = {};
    $f3879d0f44faa78a$var$currentlyFetchingRowKey = null;
};
const $f3879d0f44faa78a$export$c234307a536b8361 = ()=>{
    const now = Date.now();
    Object.keys($f3879d0f44faa78a$var$videoUrlCache).forEach((key)=>{
        if (now - $f3879d0f44faa78a$var$videoUrlCache[key].timestamp > $f3879d0f44faa78a$var$CACHE_EXPIRY_MS) delete $f3879d0f44faa78a$var$videoUrlCache[key];
    });
};


const $6b057cfee512ff1e$export$c5f684b415548de8 = (selectedRow, navigate, setMP4URL, setVideoClipLoading, setShowRefreshButton, useCache = false, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration = true)=>{
    if (!selectedRow) return;
    const cacheKey = (0, $f3879d0f44faa78a$export$9eec69cddf174afd)(selectedRow);
    const applyVideoUrl = (url)=>{
        setMP4URL(url, selectedRow);
    };
    // Check if a fetch is already in progress for this exact row
    // If so, skip this duplicate fetch - the existing one will handle it
    // IMPORTANT: This check must happen BEFORE generateVideoRequestId() to avoid
    // invalidating the in-flight request
    if (useCache && !(0, $f3879d0f44faa78a$export$aa032ae1b352f844)(cacheKey)) return;
    if (!useCache) (0, $f3879d0f44faa78a$export$58024f8ad30f55ec)(cacheKey);
    const AxiosUI = (0, $hAnMZ.createMonitoringAPICall)(``);
    // Generate a new request ID for this fetch operation.
    // This invalidates any pending requests for previously selected rows.
    // IMPORTANT: Only generate after passing the dedup check above
    const requestId = (0, $f3879d0f44faa78a$export$c97510e344e07687)();
    const retryFunction = ()=>{
        // Only retry if this request is still valid (user hasn't selected another row)
        if ((0, $f3879d0f44faa78a$export$d1cfaba9e8573694)(requestId)) $6b057cfee512ff1e$export$c5f684b415548de8(selectedRow, navigate, setMP4URL, setVideoClipLoading, setShowRefreshButton, useCache, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration);
    };
    const clipBaseUrl = `alert/clip/?approx_capture_timestamp=${selectedRow.approx_capture_timestamp}&window_id=${selectedRow.window_id}`;
    const pollBaseUrl = `alert/video/?approx_capture_timestamp=${selectedRow.approx_capture_timestamp}&window_id=${selectedRow.window_id}`;
    // Always clear URL + set loading immediately so we never keep showing a previous row's video
    applyVideoUrl("");
    setVideoClipLoading(true);
    setShowRefreshButton(false);
    if (setVideoProcessing) setVideoProcessing(false);
    // Only check cache if explicitly enabled (row re-selection, not initial load)
    if (useCache) {
        const cachedUrl = (0, $f3879d0f44faa78a$export$36920e0f06e448e)(cacheKey);
        if (cachedUrl) {
            setShowRefreshButton(false);
            setVideoClipLoading(false);
            applyVideoUrl(cachedUrl);
            (0, $f3879d0f44faa78a$export$a771af35e5682253)();
            return;
        }
    }
    const fetchClip = (shouldUseAsync)=>{
        const clipUrl = shouldUseAsync ? `${clipBaseUrl}&async_generation=true` : clipBaseUrl;
        AxiosUI.get(clipUrl).then((response)=>{
            // CRITICAL: Check if request is still valid BEFORE any state updates
            // This prevents state updates on unmounted components
            if (!(0, $f3879d0f44faa78a$export$d1cfaba9e8573694)(requestId)) {
                // Still cache the result if it's a valid URL
                if (typeof response.data === "string") (0, $f3879d0f44faa78a$export$557be0ee92bfdc47)(cacheKey, response.data);
                (0, $f3879d0f44faa78a$export$a771af35e5682253)();
                return;
            }
            const responseData = response.data;
            if (responseData && typeof responseData === "object" && responseData.status === "processing") {
                if (setVideoProcessing) setVideoProcessing(true);
                setShowRefreshButton(false);
                applyVideoUrl("");
                if (shouldUseAsync) {
                    setVideoClipLoading(true);
                    const pollUrl = responseData.poll_url ? responseData.poll_url.replace(/^\/?monitoring-api\//, "") : pollBaseUrl;
                    pollForVideo(pollUrl, 10);
                } else {
                    // Can't poll without async - show processing message instead of spinner
                    setVideoClipLoading(false);
                    (0, $f3879d0f44faa78a$export$a771af35e5682253)();
                }
                return;
            }
            if (typeof responseData !== "string") {
                if (setVideoProcessing) setVideoProcessing(false);
                setShowRefreshButton(true);
                applyVideoUrl("");
                setVideoClipLoading(false);
                (0, $f3879d0f44faa78a$export$a771af35e5682253)();
                return;
            }
            // Cache the result
            (0, $f3879d0f44faa78a$export$557be0ee92bfdc47)(cacheKey, responseData);
            // Additional validation: Check if current selection still matches this request
            // But only if the ref has been set (has a valid key with actual data)
            if (getCurrentSelectedRowKey) {
                const currentSelectedRowKey = getCurrentSelectedRowKey();
                const expectedRowKey = (0, $f3879d0f44faa78a$export$9eec69cddf174afd)(selectedRow);
                // Only reject if current key is valid (not empty) AND doesn't match
                // An empty key "|" means the ref hasn't been set yet (initial load)
                const isCurrentKeyValid = currentSelectedRowKey && currentSelectedRowKey !== "|";
                if (isCurrentKeyValid && currentSelectedRowKey !== expectedRowKey) {
                    // Row changed but no new request was started - clear loading state
                    // but don't set the URL (it's for the wrong row)
                    if (setVideoProcessing) setVideoProcessing(false);
                    setVideoClipLoading(false);
                    (0, $f3879d0f44faa78a$export$a771af35e5682253)();
                    return;
                }
            }
            if (setVideoProcessing) setVideoProcessing(false);
            setShowRefreshButton(false);
            applyVideoUrl(responseData);
            setVideoClipLoading(false);
            (0, $f3879d0f44faa78a$export$a771af35e5682253)();
        }, (reason)=>{
            // Only handle errors if this request is still valid
            if (!(0, $f3879d0f44faa78a$export$d1cfaba9e8573694)(requestId)) {
                (0, $f3879d0f44faa78a$export$a771af35e5682253)();
                return;
            }
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                // Check again before state updates (component may have unmounted)
                if (!(0, $f3879d0f44faa78a$export$d1cfaba9e8573694)(requestId)) {
                    (0, $f3879d0f44faa78a$export$a771af35e5682253)();
                    return;
                }
                if (setVideoProcessing) setVideoProcessing(false);
                setShowRefreshButton(true);
                setTimeout(()=>{
                    // Final check before updating loading state
                    if ((0, $f3879d0f44faa78a$export$d1cfaba9e8573694)(requestId)) setVideoClipLoading(false);
                    (0, $f3879d0f44faa78a$export$a771af35e5682253)();
                }, 2000);
            });
        });
    };
    const pollForVideo = (pollUrl, retriesRemaining)=>{
        // Don't cancel early - let the poll complete and cache the result
        // so it's ready if user clicks back to this alert
        setTimeout(()=>{
            AxiosUI.get(pollUrl).then((response)=>{
                if (typeof response.data === "string") {
                    // Always cache the result so it's available for quick access later
                    (0, $f3879d0f44faa78a$export$557be0ee92bfdc47)(cacheKey, response.data);
                    // Only update UI if this request is still active
                    if (!(0, $f3879d0f44faa78a$export$d1cfaba9e8573694)(requestId)) {
                        // Another request has taken over - it will handle loading state
                        (0, $f3879d0f44faa78a$export$a771af35e5682253)();
                        return;
                    }
                    if (getCurrentSelectedRowKey) {
                        const currentSelectedRowKey = getCurrentSelectedRowKey();
                        const expectedRowKey = (0, $f3879d0f44faa78a$export$9eec69cddf174afd)(selectedRow);
                        // Only reject if current key is valid (not empty) AND doesn't match
                        const isCurrentKeyValid = currentSelectedRowKey && currentSelectedRowKey !== "|";
                        if (isCurrentKeyValid && currentSelectedRowKey !== expectedRowKey) {
                            // Row changed but no new request - clear loading but don't set URL
                            if (setVideoProcessing) setVideoProcessing(false);
                            setVideoClipLoading(false);
                            (0, $f3879d0f44faa78a$export$a771af35e5682253)();
                            return;
                        }
                    }
                    if (setVideoProcessing) setVideoProcessing(false);
                    setShowRefreshButton(false);
                    applyVideoUrl(response.data);
                    setVideoClipLoading(false);
                    (0, $f3879d0f44faa78a$export$a771af35e5682253)();
                    return;
                }
                // Only update UI if still active
                if (!(0, $f3879d0f44faa78a$export$d1cfaba9e8573694)(requestId)) {
                    // Another request has taken over
                    (0, $f3879d0f44faa78a$export$a771af35e5682253)();
                    return;
                }
                if (setVideoProcessing) setVideoProcessing(false);
                setShowRefreshButton(true);
                setVideoClipLoading(false);
                (0, $f3879d0f44faa78a$export$a771af35e5682253)();
            }, (error)=>{
                const status = error.response?.status;
                if (status === 404) {
                    if (retriesRemaining > 1) {
                        pollForVideo(pollUrl, retriesRemaining - 1);
                        return;
                    }
                    // Only fallback to sync if still active
                    if (!(0, $f3879d0f44faa78a$export$d1cfaba9e8573694)(requestId)) {
                        // Another request has taken over - it will handle loading state
                        (0, $f3879d0f44faa78a$export$a771af35e5682253)();
                        return;
                    }
                    setVideoClipLoading(true);
                    fetchClip(false);
                    return;
                }
                // Only handle other errors if still active
                if (!(0, $f3879d0f44faa78a$export$d1cfaba9e8573694)(requestId)) {
                    // Another request has taken over
                    (0, $f3879d0f44faa78a$export$a771af35e5682253)();
                    return;
                }
                (0, $3Zv1D.universalAPIErrorHandler)(error, navigate, retryFunction, ()=>{
                    // Check again before state updates (component may have unmounted)
                    if (!(0, $f3879d0f44faa78a$export$d1cfaba9e8573694)(requestId)) {
                        (0, $f3879d0f44faa78a$export$a771af35e5682253)();
                        return;
                    }
                    if (setVideoProcessing) setVideoProcessing(false);
                    setShowRefreshButton(true);
                    setVideoClipLoading(false);
                    (0, $f3879d0f44faa78a$export$a771af35e5682253)();
                });
            });
        }, 500); // Poll every 500ms for faster video display
    };
    fetchClip(useAsyncGeneration);
};



const $988d77d60168e773$export$2fd5d64b4d451d7b = (row, alertData, setAlertData, setSelectedButtonsFilled, setSeeMoreURL, navigate, setMP4URL, setVideoClipLoading, setSelectedRow, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, refreshingToken, visibleRows, setBackArrowDisabled, setForwardArrowDisabled, setShowRefreshButton, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration = true, setSelectedRowRef)=>{
    // Handle null row gracefully
    if (!row) {
        setSelectedRow(null);
        return;
    }
    // Hard reset video immediately on selection change so we never keep showing a previous row's clip
    const cacheKey = (0, $f3879d0f44faa78a$export$9eec69cddf174afd)(row);
    const fetchAlreadyInProgress = (0, $f3879d0f44faa78a$export$80b36d03fd557813)(cacheKey);
    if (!fetchAlreadyInProgress) {
        setMP4URL("");
        setVideoClipLoading(true);
    }
    setShowRefreshButton(false);
    setSelectedRow(row);
    if (setSelectedRowRef) setSelectedRowRef(row);
    localStorage.setItem("selectedRowAlerts", JSON.stringify(row));
    setIgnoreZonesSelectedAlert([]);
    setSelectedAlertCameraInfo({});
    const currentIndex = visibleRows.findIndex((alert)=>alert?.id && row?.id && alert.id === row.id || alert.approx_capture_timestamp === row.approx_capture_timestamp && alert.window_id === row.window_id);
    if (currentIndex < 0 || visibleRows.length === 0) {
        setForwardArrowDisabled(true);
        setBackArrowDisabled(true);
    } else {
        const singleRow = visibleRows.length === 1;
        setBackArrowDisabled(singleRow || currentIndex === 0);
        setForwardArrowDisabled(singleRow || currentIndex === visibleRows.length - 1);
    }
    if (!refreshingToken) {
        if (row) {
            // if (!row.camera_pk) {
            //   const newAlertData = alertData;
            //   newAlertData.forEach((object: AlertData) => {
            //     object.selected = false;
            //   });
            //   newAlertData.forEach((object: AlertData, index: number) => {
            //     if (
            //       `${row.approx_capture_timestamp}${row.camera_name}` ===
            //       `${object.approx_capture_timestamp}${object.camera_name}`
            //     ) {
            //       newAlertData[index].selected = true;
            //     }
            //   });
            //   setSeeMoreURL(row.alert_url);
            //   setAlertData(newAlertData);
            //   setMP4URL("");
            //   setVideoClipLoading(false);
            //   alert(
            //     "This camera has not been added to this site, therefore video can not be retrieved. Please navigate to this site's page and add the camera"
            //   );
            // }
            // if (row.camera_pk) {
            (0, $e16b4c67693640c8$export$e44ee059113f075d)(row, setSelectedButtonsFilled);
            const newAlertData = alertData;
            newAlertData.forEach((object)=>{
                object.selected = false;
            });
            newAlertData.forEach((object, index)=>{
                if (row?.id && object?.id && row.id === object.id || row.approx_capture_timestamp === object.approx_capture_timestamp && row.window_id === object.window_id) newAlertData[index].selected = true;
            });
            setSeeMoreURL(row.alert_url);
            setAlertData(newAlertData);
            if (setVideoProcessing) (0, $6b057cfee512ff1e$export$c5f684b415548de8)(row, navigate, setMP4URL, setVideoClipLoading, setShowRefreshButton, true, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration);
            else (0, $6b057cfee512ff1e$export$c5f684b415548de8)(row, navigate, setMP4URL, setVideoClipLoading, setShowRefreshButton, true, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration);
        // AxiosMonUI.get(
        //   `alert/clip/?approx_capture_timestamp=${row.approx_capture_timestamp}&window_id=${row.window_id}`
        // ).then(
        //   (response: AxiosResponse) => {
        //     const selectedRowAlerts = JSON.parse(
        //       localStorage.selectedRowAlerts
        //     );
        //     if (
        //       row.approx_capture_timestamp ===
        //       selectedRowAlerts.approx_capture_timestamp
        //     ) {
        //       setMP4URL(response.data);
        //       setVideoClipLoading(false);
        //     }
        //   },
        //   (reason: AxiosError) => {
        //     universalAPIErrorHandler(reason, navigate, retryFunction, () => {
        //       setTimeout(() => {
        //         setVideoClipLoading(false);
        //       }, 2000);
        //     });
        //   }
        // );
        // }
        }
    }
};


/**
 * `set_alert_outcome` — who may mark an alert's outcome or edit its notes
 * (ENG-1810 → ENG-1813).
 *
 * The one place camera-ui names the `/user/info/` flag behind the True Threat /
 * Escalated / True Non-Threat / False Positive buttons and the notes editor.
 * actuate_admin exposes it as `permission.set_alert_outcome` (ENG-1811) and the
 * monitoring API checks the same permission on `alert/outcome/` and
 * `alert/unresolved/` (ENG-1812). Hiding the controls here only keeps the UI
 * honest about what the API will accept.
 */ 
var $aYdit = parcelRequire("aYdit");

var $ebTQj = parcelRequire("ebTQj");

var $3Zv1D = parcelRequire("3Zv1D");
const $c0b3a83d600c7aa1$export$d1a6a06498726d04 = "set_alert_outcome";
const $c0b3a83d600c7aa1$export$8b600cba9dd73c53 = "Your account can no longer set alert outcomes or edit alert notes. The controls have been hidden.";
const $c0b3a83d600c7aa1$export$544f58273da8c441 = (permissions)=>permissions?.[$c0b3a83d600c7aa1$export$d1a6a06498726d04] !== false;
const $c0b3a83d600c7aa1$export$e91639a9eb43f6ad = "You do not have permission to set alert outcomes.";
const $c0b3a83d600c7aa1$export$6774c9fd1e0c28f9 = (error)=>{
    const axiosError = error;
    if (axiosError?.response?.status !== 403) return false;
    const data = axiosError.response?.data;
    return data?.detail === $c0b3a83d600c7aa1$export$e91639a9eb43f6ad;
};
const $c0b3a83d600c7aa1$export$6251ce535adde2f4 = ()=>{
    try {
        const { userPermissions: userPermissions, setUserPermissions: setUserPermissions } = (0, $aYdit.useAppStore).getState();
        if ($c0b3a83d600c7aa1$export$544f58273da8c441(userPermissions)) {
            const next = {
                ...userPermissions,
                [$c0b3a83d600c7aa1$export$d1a6a06498726d04]: false
            };
            setUserPermissions(next);
            localStorage.setItem("userPermissions", JSON.stringify(next));
        }
    } catch (reason) {
        (0, $ebTQj.logger).warn("Could not revoke cached set_alert_outcome:", reason);
    }
};
const $c0b3a83d600c7aa1$export$5646bda7f69a98da = (reason, navigate, retryFunction, errorHandlingFunction, cleanup)=>{
    if ($c0b3a83d600c7aa1$export$6774c9fd1e0c28f9(reason)) {
        cleanup?.();
        $c0b3a83d600c7aa1$export$6251ce535adde2f4();
        alert($c0b3a83d600c7aa1$export$8b600cba9dd73c53);
        return;
    }
    (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, errorHandlingFunction);
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $5Ibhh = parcelRequire("5Ibhh");

var $cye0Y = parcelRequire("cye0Y");

var $gouAT = parcelRequire("gouAT");
var $ec84ed9eb84fe0cb$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($ec84ed9eb84fe0cb$exports, "__esModule", {
    value: true
});
$ec84ed9eb84fe0cb$exports.default = void 0;

var $ec84ed9eb84fe0cb$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $ec84ed9eb84fe0cb$var$_default = $ec84ed9eb84fe0cb$exports.default = (0, $ec84ed9eb84fe0cb$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M20 18.69 7.84 6.14 5.27 3.49 4 4.76l2.8 2.8v.01c-.52.99-.8 2.16-.8 3.42v5l-2 2v1h13.73l2 2L21 19.72zM12 22c1.11 0 2-.89 2-2h-4c0 1.11.89 2 2 2m6-7.32V11c0-3.08-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.15.03-.29.08-.42.12-.1.03-.2.07-.3.11h-.01c-.01 0-.01 0-.02.01-.23.09-.46.2-.68.31 0 0-.01 0-.01.01z"
}), 'NotificationsOff');


var $8305c1f774930efe$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($8305c1f774930efe$exports, "__esModule", {
    value: true
});
$8305c1f774930efe$exports.default = void 0;

var $8305c1f774930efe$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $8305c1f774930efe$var$_default = $8305c1f774930efe$exports.default = (0, $8305c1f774930efe$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5z"
}), 'Shield');



var $cVCJe = parcelRequire("cVCJe");
const $485e51885dc90d99$export$bc1b44a7a3adae46 = "Withheld by DoubleTake \u2014 recorded, not sent to the monitoring center";
const $485e51885dc90d99$export$a57fd01c1a4f0d20 = (detection_type, outcome, dispatchMuted = false, withheldByDoubleTake = false)=>{
    // outcome === null is the browser-applied "Muted" outcome; dispatchMuted is
    // the connector's stamp on the alert record (ENG-1309) — the same state
    // from an authoritative source, shown even if no browser auto-resolved it.
    if (outcome === null || dispatchMuted) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: dispatchMuted ? "Muted \u2014 recorded, not sent to the monitoring center" : "Muted",
        placement: "top",
        sx: {
            fontSize: "14px",
            fontFamily: "mulish"
        },
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ec84ed9eb84fe0cb$exports))), {
            sx: {
                color: "darkgray"
            }
        })
    });
    // ENG-1599: the DoubleTake receiver gate withheld this alarm from
    // Immix/Patriot (dispatch_suppressed_by === "doubletake"). Unlike a mute the
    // alert is NOT auto-resolved: operators still review it, and the outcome they
    // pick is the ground truth the gate is measured against. An operator outcome
    // (true threat etc.) therefore takes precedence over this badge below.
    if (withheldByDoubleTake && !detection_type) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: $485e51885dc90d99$export$bc1b44a7a3adae46,
        placement: "top",
        sx: {
            fontSize: "14px",
            fontFamily: "mulish"
        },
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8305c1f774930efe$exports))), {
            sx: {
                color: "#7d2e72"
            }
        })
    });
    if (detection_type === "true_threat") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: "True Threat",
        placement: "top",
        sx: {
            fontSize: "14px",
            fontFamily: "mulish"
        },
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5Ibhh))), {
            sx: {
                color: "#2E7D32"
            }
        })
    });
    else if (detection_type === "true_non_threat") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: "True Non-Threat",
        placement: "top",
        sx: {
            fontSize: "14px",
            fontFamily: "mulish"
        },
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5Ibhh))), {
            sx: {
                color: "#FF8400"
            }
        })
    });
    else if (detection_type === "false_positive") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: "False Positive",
        placement: "top",
        sx: {
            fontSize: "14px",
            fontFamily: "mulish"
        },
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cye0Y))), {
            sx: {
                color: "#D32F2F"
            }
        })
    });
    else if (detection_type === "escalated_true_threat") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: "Escalated True Threat",
        placement: "top",
        sx: {
            fontSize: "14px",
            fontFamily: "mulish"
        },
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gouAT))), {
            sx: {
                color: "#7d2e72"
            }
        })
    });
    else return "";
};



var $kbChx = parcelRequire("kbChx");
var $3baw3 = parcelRequire("3baw3");
var $ha39s = parcelRequire("ha39s");
var $cVCJe = parcelRequire("cVCJe");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");

var $hAnMZ = parcelRequire("hAnMZ");

const $ae0eda0a8a76aaee$export$1ab6fea4cf8d4bfc = (data, setAlertsIndexOrder, mutedAlertSites = [], mutedAlertCameras = [])=>{
    const newData = [];
    const indexOrder = [];
    // Find the index of the first non-muted alert
    let firstNonMutedIndex = -1;
    for(let i = 0; i < data.length; i++){
        const row = data[i];
        if (!(0, $94e6bb80767641a9$export$1874ac93f6160b49)(row, mutedAlertSites, mutedAlertCameras)) {
            firstNonMutedIndex = i;
            break;
        }
    }
    data.forEach((object, index)=>{
        indexOrder.push(index);
        const newObject = object;
        newObject.index = index;
        if (index === firstNonMutedIndex) {
            newObject.selected = true;
            newObject.checked = false;
            if (object.engineering_outcome) {
                newObject.seen = true;
                newObject.notes = object.engineering_outcome.notes;
                newObject.user = object.engineering_outcome.user;
                newObject.updated = object.engineering_outcome.updated;
                if (object.engineering_outcome.outcome_v2) {
                    newObject.detection_type = object.engineering_outcome.outcome_v2;
                    if (object.engineering_outcome.outcome_v2 === "true_non_threat") newObject.outcome_number = 2;
                    if (object.engineering_outcome.outcome_v2 === "true_threat") newObject.outcome_number = 1;
                    if (object.engineering_outcome.outcome_v2 === "false_positive") newObject.outcome_number = 3;
                }
                if (!object.engineering_outcome.outcome_v2) {
                    if (object.engineering_outcome.outcome === "intruder_detected") {
                        newObject.detection_type = "true_threat";
                        newObject.outcome_number = 1;
                    }
                    if (object.engineering_outcome.outcome === "false_positive") {
                        newObject.detection_type = "false_positive";
                        newObject.outcome_number = 3;
                    }
                }
            } else if (object.customer_outcome) {
                newObject.seen = true;
                newObject.notes = object.customer_outcome.notes;
                newObject.user = object.customer_outcome.user;
                newObject.updated = object.customer_outcome.updated;
                if (object.customer_outcome.outcome_v2) {
                    newObject.detection_type = object.customer_outcome.outcome_v2;
                    if (object.customer_outcome.outcome_v2 === "true_non_threat") newObject.outcome_number = 2;
                    if (object.customer_outcome.outcome_v2 === "true_threat") newObject.outcome_number = 1;
                    if (object.customer_outcome.outcome_v2 === "false_positive") newObject.outcome_number = 3;
                }
                if (!object.customer_outcome.outcome_v2) {
                    if (object.customer_outcome.outcome === "intruder_detected") {
                        newObject.detection_type = "true_threat";
                        newObject.outcome_number = 1;
                    }
                    if (object.customer_outcome.outcome === "false_positive") {
                        newObject.detection_type = "false_positive";
                        newObject.outcome_number = 3;
                    }
                }
            } else {
                newObject.checked = false;
                newObject.seen = false;
                newObject.detection_type = "";
            }
        } else {
            newObject.selected = false;
            if (object.engineering_outcome) {
                newObject.seen = true;
                newObject.notes = object.engineering_outcome.notes;
                newObject.user = object.engineering_outcome.user;
                newObject.updated = object.engineering_outcome.updated;
                if (object.engineering_outcome.outcome_v2) {
                    newObject.detection_type = object.engineering_outcome.outcome_v2;
                    if (object.engineering_outcome.outcome_v2 === "true_non_threat") newObject.outcome_number = 2;
                    if (object.engineering_outcome.outcome_v2 === "true_threat") newObject.outcome_number = 1;
                    if (object.engineering_outcome.outcome_v2 === "false_positive") newObject.outcome_number = 3;
                }
                if (!object.engineering_outcome.outcome_v2) {
                    if (object.engineering_outcome.outcome === "intruder_detected") {
                        newObject.detection_type = "true_threat";
                        newObject.outcome_number = 1;
                    }
                    if (object.engineering_outcome.outcome === "false_positive") {
                        newObject.detection_type = "false_positive";
                        newObject.outcome_number = 3;
                    }
                }
            } else if (object.customer_outcome) {
                newObject.seen = true;
                newObject.notes = object.customer_outcome.notes;
                newObject.user = object.customer_outcome.user;
                newObject.updated = object.customer_outcome.updated;
                if (object.customer_outcome.outcome_v2) {
                    newObject.detection_type = object.customer_outcome.outcome_v2;
                    if (object.customer_outcome.outcome_v2 === "true_non_threat") newObject.outcome_number = 2;
                    if (object.customer_outcome.outcome_v2 === "true_threat") newObject.outcome_number = 1;
                    if (object.customer_outcome.outcome_v2 === "false_positive") newObject.outcome_number = 3;
                }
                if (!object.customer_outcome.outcome_v2) {
                    if (object.customer_outcome.outcome === "intruder_detected") {
                        newObject.detection_type = "true_threat";
                        newObject.outcome_number = 1;
                    }
                    if (object.customer_outcome.outcome === "false_positive") {
                        newObject.detection_type = "false_positive";
                        newObject.outcome_number = 3;
                    }
                }
            } else {
                newObject.checked = false;
                newObject.seen = false;
                newObject.detection_type = "";
            }
        }
        newData.push(newObject);
    });
    setAlertsIndexOrder(indexOrder);
    return newData;
};




var $gk2F6 = parcelRequire("gk2F6");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $b68d5e91295063d7$export$f4980018d5f7dd7 = (cameraId, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, navigate)=>{
    const retryFunction = ()=>{
        $b68d5e91295063d7$export$f4980018d5f7dd7(cameraId, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, navigate);
    };
    const AxiosUI = (0, $195EM.createApi)(``);
    let getCameraStatusFail = false;
    AxiosUI.get(`/camera/${cameraId}/status/`).then((response)=>{
        getCameraStatusFail = false;
        setSelectedAlertCameraInfo(response.data);
    }, (reason)=>{
        getCameraStatusFail = true;
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setSelectedAlertCameraInfo({});
        });
    });
    !getCameraStatusFail && AxiosUI.get(`/camera/${cameraId}/ignore_zones/`).then((response)=>{
        setIgnoreZonesSelectedAlert(response.data);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setIgnoreZonesSelectedAlert([]);
        });
    });
};


parcelRequire("8T3gX");
const $78fdb6a5d4421a11$export$98085851b02142a0 = (detection_type, setSelectedButtonsFilled)=>{
    if (!detection_type) setSelectedButtonsFilled({
        true_threat: true,
        true_non_threat: true,
        false_positive: true,
        escalated_true_threat: true
    });
    if (detection_type === "true_threat") setSelectedButtonsFilled({
        true_threat: true,
        true_non_threat: false,
        false_positive: false,
        escalated_true_threat: false
    });
    if (detection_type === "true_non_threat") setSelectedButtonsFilled({
        true_threat: false,
        true_non_threat: true,
        false_positive: false,
        escalated_true_threat: false
    });
    if (detection_type === "false_positive") setSelectedButtonsFilled({
        true_threat: false,
        true_non_threat: false,
        false_positive: true,
        escalated_true_threat: false
    });
    if (detection_type === "escalated_true_threat") setSelectedButtonsFilled({
        true_threat: false,
        true_non_threat: false,
        false_positive: false,
        escalated_true_threat: true
    });
};





const $390b465fec80488c$export$ec42887886e7060b = (data, setAlertsIndexOrder, setSeeMoreURL, setSelectedRow, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, navigate, setMP4URL, setVideoClipLoading, setSelectedButtonsFilled, alertData, setAlertData, refreshingToken, setBackArrowDisabled, setForwardArrowDisabled, setShowRefreshButton, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration = true)=>{
    const currentSelectedRowKey = getCurrentSelectedRowKey ? getCurrentSelectedRowKey() : null;
    let selectedRowStillPresent = false;
    let matchedSelectedRow = null;
    // Use map instead of forEach for cleaner array transformation
    const indexOrder = [];
    const newData = data.map((object, index)=>{
        const engineeringOutcome = object.engineering_outcome;
        const customerOutcome = object.customer_outcome;
        const newObject = {
            ...object,
            index: index,
            selected: false,
            seen: false,
            detection_type: ""
        };
        indexOrder.push(index);
        // Check if this object should be selected
        if (currentSelectedRowKey && (0, $f3879d0f44faa78a$export$9eec69cddf174afd)(object) === currentSelectedRowKey) {
            newObject.selected = true;
            matchedSelectedRow = newObject;
            selectedRowStillPresent = true;
            if (customerOutcome) (0, $78fdb6a5d4421a11$export$98085851b02142a0)(customerOutcome.outcome, setSelectedButtonsFilled);
        // Keep selectedRow stable during refresh reconciliation when key matches.
        // Re-setting selectedRow here can race against row-selection/video updates.
        }
        // Handle engineering outcomes and detection types
        const outcome = engineeringOutcome ? engineeringOutcome.outcome : customerOutcome?.outcome;
        const outcomeV2 = engineeringOutcome ? engineeringOutcome.outcome_v2 : customerOutcome?.outcome_v2;
        const user = engineeringOutcome ? engineeringOutcome.user : customerOutcome?.user;
        const updated = engineeringOutcome ? engineeringOutcome.updated : customerOutcome?.updated;
        // Mark as seen if there's an outcome OR if it's been reviewed (has user/updated)
        // This handles muted alerts where outcome_v2 is null but alert has been reviewed
        if (outcome || outcomeV2 || user || updated) {
            newObject.seen = true;
            newObject.notes = engineeringOutcome ? engineeringOutcome.notes : customerOutcome?.notes;
            newObject.user = engineeringOutcome ? engineeringOutcome.user : customerOutcome?.user;
            newObject.updated = engineeringOutcome ? engineeringOutcome.updated : customerOutcome?.updated;
            // Assign detection_type and outcome_number based on outcome_v2 or fallback outcome
            if (outcomeV2) {
                newObject.detection_type = outcomeV2;
                newObject.outcome_number = outcomeV2 === "true_threat" ? 1 : outcomeV2 === "true_non_threat" ? 2 : 3; // false_positive = 3
            } else if (outcome) {
                newObject.detection_type = outcome === "intruder_detected" ? "true_threat" : "false_positive";
                newObject.outcome_number = outcome === "intruder_detected" ? 1 : 3;
            }
        }
        return newObject;
    });
    // Update index order
    setAlertsIndexOrder(indexOrder);
    if (matchedSelectedRow) setSelectedRow(matchedSelectedRow);
    const navigable = (0, $6e02db388b82b823$export$cdfae0e972447b21)({
        alertData: newData,
        ...(0, $6e02db388b82b823$export$4f1961990ac2c404)()
    });
    const navigableIndex = matchedSelectedRow ? navigable.findIndex((row)=>row === matchedSelectedRow) : -1;
    if (navigable.length <= 1 || selectedRowStillPresent && navigableIndex < 0) {
        setBackArrowDisabled(true);
        setForwardArrowDisabled(true);
    } else if (navigableIndex >= 0) {
        setBackArrowDisabled(navigableIndex <= 0);
        setForwardArrowDisabled(navigableIndex >= navigable.length - 1);
    }
    // If selected row no longer present, select the first item by default
    if (!selectedRowStillPresent && newData.length > 0) {
        newData[0].selected = true;
        // Perform row selection once for the first item
        (0, $988d77d60168e773$export$2fd5d64b4d451d7b)(newData[0], newData, setAlertData, setSelectedButtonsFilled, setSeeMoreURL, navigate, setMP4URL, setVideoClipLoading, setSelectedRow, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, refreshingToken, newData, setBackArrowDisabled, setForwardArrowDisabled, setShowRefreshButton, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration);
    }
    return newData;
};



var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("8T3gX");
const $3d9ada870c0cfeca$var$getCurrentDate = ()=>{
    const today = new Date();
    const year = today.getFullYear();
    // getMonth() returns month from 0-11; add 1 to get 1-12
    const month = `0${today.getMonth() + 1}`.slice(-2); // Add leading 0 if needed
    const day = `0${today.getDate()}`.slice(-2); // Add leading 0 if needed
    return `${year}${month}${day}`;
};
const $3d9ada870c0cfeca$var$formatDate = (date)=>{
    return date.replace(/-/g, "");
};
const $3d9ada870c0cfeca$export$f3932c991a110bf = (inputDate)=>{
    const currentDate = $3d9ada870c0cfeca$var$getCurrentDate();
    const endDate = $3d9ada870c0cfeca$var$formatDate(inputDate);
    return Number(currentDate) - Number(endDate) > 1;
};



var $gk2F6 = parcelRequire("gk2F6");


var $hAnMZ = parcelRequire("hAnMZ");



var $gk2F6 = parcelRequire("gk2F6");



var $9OjAn = parcelRequire("9OjAn");
const $09aa3d4abe0406ed$export$7112a6722fc7ddb1 = (0, $9OjAn.create)((set)=>({
        groupSnapshot: null,
        accountSnapshot: null,
        setGroupSnapshot: (groupSnapshot)=>set((state)=>{
                const sameQuery = state.groupSnapshot?.groupId === groupSnapshot.groupId && state.groupSnapshot?.filterType === groupSnapshot.filterType && state.groupSnapshot?.searchParamsString === groupSnapshot.searchParamsString;
                return {
                    groupSnapshot: groupSnapshot,
                    accountSnapshot: sameQuery ? state.accountSnapshot : null
                };
            }),
        setAccountSnapshot: (accountSnapshot)=>set({
                accountSnapshot: accountSnapshot
            })
    }));
const $09aa3d4abe0406ed$export$3e428e207129570 = (response)=>{
    const records = response?.records;
    const parsed = Number(response?.item_count);
    const recordCount = Array.isArray(records) ? records.length : 0;
    const itemCount = Number.isFinite(parsed) ? parsed : recordCount;
    const limited = Boolean(response?.parameters?.query_limit) && recordCount > 99;
    const minStart = response?.min_start_timestamp;
    return {
        itemCount: itemCount,
        limited: limited,
        minStartTimestamp: typeof minStart === "number" && Number.isFinite(minStart) ? minStart : null
    };
};
const $09aa3d4abe0406ed$export$82ae3b5cddb8719c = (response, groupId, filterType, searchParamsString)=>{
    const parsed = $09aa3d4abe0406ed$export$3e428e207129570(response);
    const id = groupId != null && groupId !== "" && groupId !== "undefined" ? String(groupId) : "";
    $09aa3d4abe0406ed$export$7112a6722fc7ddb1.getState().setGroupSnapshot({
        groupId: id,
        filterType: filterType,
        searchParamsString: searchParamsString,
        ...parsed
    });
};


const $2b033c7e53772cf7$var$isAlertsUrl = ()=>{
    const currentUrl = window.location.href;
    return currentUrl.includes("alerts");
};
const $2b033c7e53772cf7$export$8a865fd27a92b98c = (setAlertData, navigate, groupId, siteId, cameraId, startDate, endDate, startTime, endTime, filterType, setSelectedRow, setRefreshingData, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, setAlertsIndexOrder, refreshInterval, setRefreshInterval, pageLoadedNumber, setSeeMoreURL, setMP4URL, setVideoClipLoading, setSelectedButtonsFilled, setAlertsToDisplay, setCurrentName, setPage, setDateOutsideRange, setFetchingFilteredData, setPageLoading, setUserFilters, userFilters, cameraOptions, siteOptions, startTimeStamp, setRefreshingToken, refreshingToken, previousLength, setBackArrowDisabled, setForwardArrowDisabled, setShowRefreshButton, setAlertsRefreshing, triggeredFromDetectionLabeling, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration = true)=>{
    const AxiosUI = (0, $hAnMZ.createMonitoringAPICall)(``);
    let searchingPastDates = false;
    let searchParamsString = ``;
    if (startDate) searchParamsString += `&start=${startDate}`;
    if (endDate) {
        searchParamsString += `&end=${endDate}`;
        searchingPastDates = (0, $3d9ada870c0cfeca$export$f3932c991a110bf)(endDate);
    }
    if (groupId) {
        if (groupId !== "undefined") searchParamsString += `&group_id=${groupId}`;
    }
    if (siteId[0]) searchParamsString += `&customer_id=${(0, $8bebe2f317b7d60b$export$5d5bdfe4e9e15b15)(siteId)}`;
    if (cameraId) searchParamsString += `&camera_id=${(0, $8bebe2f317b7d60b$export$5d5bdfe4e9e15b15)(cameraId)}`;
    if (startDate.toString() === endDate.toString() && startTime !== null) searchParamsString += `&start_time=${(0, $gk2F6.timeSlicer)(startTime)}`;
    if (startDate.toString() === endDate.toString() && endTime !== null) searchParamsString += `&end_time=${(0, $gk2F6.timeSlicer)(endTime)}`;
    if (userFilters.has_video) searchParamsString += `&has_video=true`;
    localStorage.setItem("queryString", JSON.stringify(`${filterType}${searchParamsString}`));
    const areObjectsEqual = (obj1, obj2)=>{
        for(const key in obj1)if (obj1[key] !== null && obj2[key] !== null) {
            if (obj1[key].toString() !== obj2[key].toString()) return false;
        }
        return true;
    };
    setAlertsRefreshing(true);
    // setTimeout(
    //   () => {
    if (areObjectsEqual(userFilters, JSON.parse(localStorage.latestAlertFilters)) && Number(pageLoadedNumber) === Number(localStorage.pageLoadedNumber) && $2b033c7e53772cf7$var$isAlertsUrl() && !searchingPastDates && location.href.includes("alerts")) {
        setAlertsRefreshing(true);
        AxiosUI.get(`alert/?window_filter=${filterType}${searchParamsString}`).then((response)=>{
            (0, $09aa3d4abe0406ed$export$82ae3b5cddb8719c)(response.data, groupId, filterType, searchParamsString);
            let previousTimeStamps = startTimeStamp;
            if (!response.data.records[0]) {
                setAlertData([]);
                setAlertsToDisplay(false);
                setRefreshingData(false);
            }
            if (response.data.records[0]) {
                previousTimeStamps = response.data.records[0].approx_capture_timestamp;
                if (previousTimeStamps !== startTimeStamp || previousTimeStamps === startTimeStamp && response.data.records.length !== previousLength) {
                    setRefreshingData(true);
                    const newData = response.data;
                    setAlertsToDisplay(true);
                    if (JSON.parse(localStorage.queryString) === `${filterType}${searchParamsString}`) setAlertData((0, $390b465fec80488c$export$ec42887886e7060b)(newData.records, setAlertsIndexOrder, setSeeMoreURL, setSelectedRow, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, navigate, setMP4URL, setVideoClipLoading, setSelectedButtonsFilled, newData, setAlertData, refreshingToken, setBackArrowDisabled, setForwardArrowDisabled, setShowRefreshButton, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration));
                    setRefreshingData(false);
                }
            }
            if (localStorage.tokenRefreshing === "false") setTimeout(()=>{
                (0, $50931580b7d7a15b$export$e3104307e6100e11)(setAlertData, navigate, groupId, siteId, cameraId, startDate, endDate, startTime, endTime, filterType, setSelectedRow, setRefreshingData, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, setAlertsIndexOrder, refreshInterval, setRefreshInterval, pageLoadedNumber, setSeeMoreURL, setMP4URL, setVideoClipLoading, setSelectedButtonsFilled, setAlertsToDisplay, setCurrentName, setPage, setDateOutsideRange, setFetchingFilteredData, setPageLoading, setUserFilters, userFilters, cameraOptions, siteOptions, previousTimeStamps, setRefreshingToken, refreshingToken, response.data.records.length, setBackArrowDisabled, setForwardArrowDisabled, setShowRefreshButton, setAlertsRefreshing, false, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration);
            }, refreshInterval);
        }, (reason)=>{
            // if (Number(localStorage.alertsFailRetryCount) < 5) {
            //   localStorage.setItem(
            //     "alertsFailRetryCount",
            //     JSON.stringify(Number(localStorage.alertsFailRetryCount) + 1)
            //   );
            //   setTimeout(() => {
            //     getRefreshToken(
            //       navigate,
            //       getAlertsRefreshNoNetworkError(
            //         setAlertData,
            //         navigate,
            //         groupId,
            //         siteId,
            //         cameraId,
            //         startDate,
            //         endDate,
            //         startTime,
            //         endTime,
            //         filterType,
            //         setSelectedRow,
            //         setRefreshingData,
            //         setSelectedAlertCameraInfo,
            //         setIgnoreZonesSelectedAlert,
            //         setAlertsIndexOrder,
            //         refreshInterval,
            //         setRefreshInterval,
            //         pageLoadedNumber,
            //         setSeeMoreURL,
            //         setMP4URL,
            //         setVideoClipLoading,
            //         setSelectedButtonsFilled,
            //         setAlertsToDisplay,
            //         setCurrentName,
            //         setPage,
            //         setDateOutsideRange,
            //         setFetchingFilteredData,
            //         setPageLoading,
            //         setUserFilters,
            //         userFilters,
            //         cameraOptions,
            //         siteOptions,
            //         startTimeStamp,
            //         setRefreshingToken,
            //         refreshingToken,
            //         previousLength,
            //         setBackArrowDisabled,
            //         setForwardArrowDisabled,
            //         setShowRefreshButton,
            //         setAlertsRefreshing,
            //         false
            //       )
            //     );
            //   }, 10000);
            // } else {
            localStorage.setItem("alertsFailRetryCount", "0");
            setRefreshingToken(false);
            setRefreshingData(false);
            setAlertsRefreshing(false);
            // Only redirect to no-internet when the browser is actually offline.
            if (!navigator.onLine && !window.location.pathname.includes("/no-internet")) navigate("/no-internet", {
                replace: true
            });
            else alert("Alerts have stopped refreshing due to an Network Error. Please try refreshing page or logging out and back in.");
        // }
        });
    } else setAlertsRefreshing(false);
//   },
//   triggeredFromDetectionLabeling ? 0 : refreshInterval
// );
};



var $aK4Bb = parcelRequire("aK4Bb");

var $hAnMZ = parcelRequire("hAnMZ");

var $ebTQj = parcelRequire("ebTQj");
const $2b15fd61b31c2ea0$var$AxiosUI = (0, $hAnMZ.createMonitoringAPICall)(``); // Instance can be created here or passed in
// Track in-flight requests to prevent duplicate API calls
const $2b15fd61b31c2ea0$var$pendingRequests = new Map();
const $2b15fd61b31c2ea0$export$899219e2395ac333 = {
    getAlerts: async (params)=>{
        const { filterType: filterType, searchParamsString: searchParamsString } = params;
        const url = `alert/?window_filter=${filterType}${searchParamsString}`;
        // If there's already an identical request in flight, return that promise
        const existingRequest = $2b15fd61b31c2ea0$var$pendingRequests.get(url);
        if (existingRequest) {
            (0, $ebTQj.logger).log("[alertService] Deduplicating request, reusing in-flight call");
            return existingRequest;
        }
        // The service method focuses *only* on making the call and returning data or throwing an error
        const request = (async ()=>{
            try {
                const response = await $2b15fd61b31c2ea0$var$AxiosUI.get(url);
                return response.data; // Return only the data part of the response
            } catch (error) {
                // Re-throw the error to be handled by the caller (or perform minimal logging)
                (0, $ebTQj.logger).error("Error fetching alerts:", error);
                throw error; // Let the calling function handle UI logic/error state
            } finally{
                // Clear the pending request when done (success or failure)
                $2b15fd61b31c2ea0$var$pendingRequests.delete(url);
            }
        })();
        $2b15fd61b31c2ea0$var$pendingRequests.set(url, request);
        return request;
    }
};



const $50931580b7d7a15b$var$isAlertsUrl = ()=>{
    const currentUrl = window.location.href;
    return currentUrl.includes("alerts");
};
const $50931580b7d7a15b$export$e3104307e6100e11 = (setAlertData, navigate, groupId, siteId, cameraId, startDate, endDate, startTime, endTime, filterType, setSelectedRow, setRefreshingData, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, setAlertsIndexOrder, refreshInterval, setRefreshInterval, pageLoadedNumber, setSeeMoreURL, setMP4URL, setVideoClipLoading, setSelectedButtonsFilled, setAlertsToDisplay, setCurrentName, setPage, setDateOutsideRange, setFetchingFilteredData, setPageLoading, setUserFilters, userFilters, cameraOptions, siteOptions, startTimeStamp, setRefreshingToken, refreshingToken, previousLength, setBackArrowDisabled, setForwardArrowDisabled, setShowRefreshButton, setAlertsRefreshing, triggeredFromDetectionLabeling, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration = true)=>{
    const retryFunction = ()=>{
        localStorage.tokenRefreshing === "false" && $50931580b7d7a15b$export$e3104307e6100e11(setAlertData, navigate, groupId, siteId, cameraId, startDate, endDate, startTime, endTime, filterType, setSelectedRow, setRefreshingData, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, setAlertsIndexOrder, refreshInterval, setRefreshInterval, pageLoadedNumber, setSeeMoreURL, setMP4URL, setVideoClipLoading, setSelectedButtonsFilled, setAlertsToDisplay, setCurrentName, setPage, setDateOutsideRange, setFetchingFilteredData, setPageLoading, setUserFilters, userFilters, cameraOptions, siteOptions, startTimeStamp, setRefreshingToken, refreshingToken, previousLength, setBackArrowDisabled, setForwardArrowDisabled, setShowRefreshButton, setAlertsRefreshing, false, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration);
    };
    let searchingPastDates = false;
    let searchParamsString = ``;
    if (startDate) searchParamsString += `&start=${startDate}`;
    if (endDate) {
        searchParamsString += `&end=${endDate}`;
        searchingPastDates = (0, $3d9ada870c0cfeca$export$f3932c991a110bf)(endDate);
    }
    if (groupId) {
        if (groupId !== "undefined") searchParamsString += `&group_id=${groupId}`;
    }
    if (siteId[0]) searchParamsString += `&customer_id=${(0, $8bebe2f317b7d60b$export$5d5bdfe4e9e15b15)(siteId)}`;
    if (cameraId) searchParamsString += `&camera_id=${(0, $8bebe2f317b7d60b$export$5d5bdfe4e9e15b15)(cameraId)}`;
    if (startDate.toString() === endDate.toString() && startTime !== null) searchParamsString += `&start_time=${(0, $gk2F6.timeSlicer)(startTime)}`;
    if (startDate.toString() === endDate.toString() && endTime !== null) searchParamsString += `&end_time=${(0, $gk2F6.timeSlicer)(endTime)}`;
    if (userFilters.has_video) searchParamsString += `&has_video=true`;
    localStorage.setItem("queryString", JSON.stringify(`${filterType}${searchParamsString}`));
    const areObjectsEqual = (obj1, obj2)=>{
        for(const key in obj1)if (obj1[key] !== null && obj2[key] !== null) {
            if (obj1[key].toString() !== obj2[key].toString()) return false;
        }
        return true;
    };
    const filtersMatch = areObjectsEqual(userFilters, JSON.parse(localStorage.latestAlertFilters));
    const pageNumbersMatch = Number(pageLoadedNumber) === Number(localStorage.pageLoadedNumber);
    const isAlertsPage = $50931580b7d7a15b$var$isAlertsUrl();
    const notSearchingPastDates = !searchingPastDates;
    const urlIncludesAlerts = location.href.includes("alerts");
    if (filtersMatch && pageNumbersMatch && isAlertsPage && notSearchingPastDates && urlIncludesAlerts) setAlertsRefreshing(true);
    setTimeout(async ()=>{
        const filtersMatchTimeout = areObjectsEqual(userFilters, JSON.parse(localStorage.latestAlertFilters));
        const pageNumbersMatchTimeout = Number(pageLoadedNumber) === Number(localStorage.pageLoadedNumber);
        const isAlertsPageTimeout = $50931580b7d7a15b$var$isAlertsUrl();
        const notSearchingPastDatesTimeout = !searchingPastDates;
        const urlIncludesAlertsTimeout = location.href.includes("alerts");
        if (filtersMatchTimeout && pageNumbersMatchTimeout && isAlertsPageTimeout && notSearchingPastDatesTimeout && urlIncludesAlertsTimeout) {
            setAlertsRefreshing(true);
            try {
                const responseData = await (0, $2b15fd61b31c2ea0$export$899219e2395ac333).getAlerts({
                    filterType: filterType,
                    searchParamsString: searchParamsString
                });
                (0, $09aa3d4abe0406ed$export$82ae3b5cddb8719c)(responseData, groupId, filterType, searchParamsString);
                let previousTimeStamps = startTimeStamp;
                if (!responseData.records[0]) {
                    setAlertData([]);
                    setAlertsToDisplay(false);
                    setRefreshingData(false);
                }
                if (responseData.records[0]) {
                    previousTimeStamps = responseData.records[0].approx_capture_timestamp;
                    if (previousTimeStamps !== startTimeStamp || previousTimeStamps === startTimeStamp && responseData.records.length !== previousLength) {
                        setRefreshingData(true);
                        const newData = responseData;
                        setAlertsToDisplay(true);
                        if (JSON.parse(localStorage.queryString) === `${filterType}${searchParamsString}`) setAlertData((0, $390b465fec80488c$export$ec42887886e7060b)(newData.records, setAlertsIndexOrder, setSeeMoreURL, setSelectedRow, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, navigate, setMP4URL, setVideoClipLoading, setSelectedButtonsFilled, newData, setAlertData, refreshingToken, setBackArrowDisabled, setForwardArrowDisabled, setShowRefreshButton, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration));
                        setRefreshingData(false);
                    }
                }
                if (localStorage.tokenRefreshing === "false" || localStorage.tokenRefreshing === undefined) setTimeout(()=>{
                    $50931580b7d7a15b$export$e3104307e6100e11(setAlertData, navigate, groupId, siteId, cameraId, startDate, endDate, startTime, endTime, filterType, setSelectedRow, setRefreshingData, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, setAlertsIndexOrder, refreshInterval, setRefreshInterval, pageLoadedNumber, setSeeMoreURL, setMP4URL, setVideoClipLoading, setSelectedButtonsFilled, setAlertsToDisplay, setCurrentName, setPage, setDateOutsideRange, setFetchingFilteredData, setPageLoading, setUserFilters, userFilters, cameraOptions, siteOptions, previousTimeStamps, setRefreshingToken, refreshingToken, responseData.records.length, setBackArrowDisabled, setForwardArrowDisabled, setShowRefreshButton, setAlertsRefreshing, false, getCurrentSelectedRowKey);
                }, refreshInterval);
                else setAlertsRefreshing(false);
            } catch (error) {
                setRefreshingToken(true);
                (0, $3Zv1D.universalAPIErrorHandler)(error, navigate, ()=>{
                    retryFunction();
                    setRefreshingToken(false);
                }, ()=>{
                    (0, $aK4Bb.getRefreshToken)(navigate, (0, $2b033c7e53772cf7$export$8a865fd27a92b98c)(setAlertData, navigate, groupId, siteId, cameraId, startDate, endDate, startTime, endTime, filterType, setSelectedRow, setRefreshingData, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, setAlertsIndexOrder, refreshInterval, setRefreshInterval, pageLoadedNumber, setSeeMoreURL, setMP4URL, setVideoClipLoading, setSelectedButtonsFilled, setAlertsToDisplay, setCurrentName, setPage, setDateOutsideRange, setFetchingFilteredData, setPageLoading, setUserFilters, userFilters, cameraOptions, siteOptions, startTimeStamp, setRefreshingToken, refreshingToken, previousLength, setBackArrowDisabled, setForwardArrowDisabled, setShowRefreshButton, setAlertsRefreshing, false, getCurrentSelectedRowKey));
                });
            }
        } else // Only set alertsRefreshing to false if we're not on the alerts page
        // or if we're searching past dates (which disables refresh)
        if (!isAlertsPage || !urlIncludesAlerts || searchingPastDates) setAlertsRefreshing(false);
    }, triggeredFromDetectionLabeling ? 0 : refreshInterval);
};



var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("8T3gX");
const $2f189bddd5c99efb$export$89bf317f972eb0c3 = (newData, setAlertLabels)=>{
    const alertLabels = [
        "All"
    ];
    newData.forEach((alert)=>{
        if (alert.alert_labels) {
            if (alert.alert_labels !== "UNIDENTIFIABLE") {
                if (!alertLabels.includes(alert.alert_labels.charAt(0).toUpperCase() + alert.alert_labels.slice(1).replace(/_/g, " "))) alertLabels.push(alert.alert_labels.charAt(0).toUpperCase() + alert.alert_labels.slice(1).replace(/_/g, " "));
            }
        }
    });
    if (setAlertLabels) setAlertLabels(alertLabels);
};





var $ebTQj = parcelRequire("ebTQj");


var $9OjAn = parcelRequire("9OjAn");
const $ffd916f32bf91472$export$c0092f66ffb2a592 = (0, $9OjAn.create)((set)=>({
        fetchError: null,
        setFetchError: (fetchError)=>set({
                fetchError: fetchError
            }),
        clearFetchError: ()=>set({
                fetchError: null
            })
    }));
const $ffd916f32bf91472$var$MAX_DETAIL_LENGTH = 200;
const $ffd916f32bf91472$export$fc1f102d8ee5406 = (data)=>{
    if (data === null || data === undefined) return "";
    if (typeof data === "string") return data.slice(0, $ffd916f32bf91472$var$MAX_DETAIL_LENGTH);
    if (Array.isArray(data)) {
        const firstError = data.find((entry)=>entry && typeof entry === "object" && Object.keys(entry).length > 0);
        return firstError ? $ffd916f32bf91472$export$fc1f102d8ee5406(firstError) : "";
    }
    if (typeof data === "object") {
        const record = data;
        if (typeof record.detail === "string") return record.detail.slice(0, $ffd916f32bf91472$var$MAX_DETAIL_LENGTH);
        try {
            return JSON.stringify(record).slice(0, $ffd916f32bf91472$var$MAX_DETAIL_LENGTH);
        } catch  {
            return "";
        }
    }
    return String(data).slice(0, $ffd916f32bf91472$var$MAX_DETAIL_LENGTH);
};
const $ffd916f32bf91472$export$936012393c4de259 = (error, context)=>{
    if (context?.willRetry) return;
    const axiosError = error;
    const status = axiosError?.response?.status ?? null;
    const detail = context?.offline ? "You appear to be offline." : $ffd916f32bf91472$export$fc1f102d8ee5406(axiosError?.response?.data);
    $ffd916f32bf91472$export$c0092f66ffb2a592.getState().setFetchError({
        status: status,
        detail: detail,
        at: Date.now()
    });
};
const $ffd916f32bf91472$export$dda1917e5b995f19 = ()=>{
    $ffd916f32bf91472$export$c0092f66ffb2a592.getState().clearFetchError();
};



const $8bebe2f317b7d60b$var$isCurrentDate = (inputDate)=>{
    const currentDate = new Date();
    const formattedCurrentDate = currentDate.toISOString().slice(0, 10); // Get the current date in YYYY-MM-DD format
    return inputDate === formattedCurrentDate;
};
const $8bebe2f317b7d60b$export$5d5bdfe4e9e15b15 = (numbers)=>numbers.join(",");
const $8bebe2f317b7d60b$export$f0c03502af15d107 = (setAlertData, navigate, setSelectedRow, setFetchingFilteredData, setSeeMoreURL, setMP4URL, groupId, siteId, cameraId, startDate, endDate, startTime, endTime, filterType, setSelectedButtonsFilled, setThumbnailVideos, setDateOutsideRange, setPage, setVideoClipLoading, setAlertsToDisplay, setPageLoading, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, setAlertsIndexOrder, setRefreshInterval, setCurrentName, setUserFilters, setRefreshingData, pageLoadedNumber, refreshInterval, userFilters, cameraOptions, siteOptions, setRefreshingToken, refreshingToken, setAlertLabels, setPeriodHours, setQueryLimitHit, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setRowsSortable, setAlertsRefreshing, getCurrentSelectedRowKey, mutedAlertSites, mutedAlertCameras, setVideoProcessing)=>{
    const AxiosUI = (0, $hAnMZ.createMonitoringAPICall)(``);
    const useAsyncGeneration = !userFilters?.has_video;
    const retryFunction = ()=>{
        $8bebe2f317b7d60b$export$f0c03502af15d107(setAlertData, navigate, setSelectedRow, setFetchingFilteredData, setSeeMoreURL, setMP4URL, groupId, siteId, cameraId, startDate, endDate, startTime, endTime, filterType, setSelectedButtonsFilled, setThumbnailVideos, setDateOutsideRange, setPage, setVideoClipLoading, setAlertsToDisplay, setPageLoading, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, setAlertsIndexOrder, setRefreshInterval, setCurrentName, setUserFilters, setRefreshingData, pageLoadedNumber, refreshInterval, userFilters, cameraOptions, siteOptions, setRefreshingToken, refreshingToken, setAlertLabels, setPeriodHours, setQueryLimitHit, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setRowsSortable, setAlertsRefreshing, getCurrentSelectedRowKey, mutedAlertSites, mutedAlertCameras, setVideoProcessing);
    };
    let searchParamsString = ``;
    if (startDate) searchParamsString += `&start=${startDate}`;
    if (endDate) searchParamsString += `&end=${endDate}`;
    if (groupId) {
        if (groupId !== "undefined") searchParamsString += `&group_id=${groupId}`;
    }
    if (Array.isArray(siteId) && siteId.length > 0) searchParamsString += `&customer_id=${$8bebe2f317b7d60b$export$5d5bdfe4e9e15b15(siteId)}`;
    if (Array.isArray(cameraId) && cameraId.length > 0) searchParamsString += `&camera_id=${$8bebe2f317b7d60b$export$5d5bdfe4e9e15b15(cameraId)}`;
    if (startDate.toString() === endDate.toString() && startTime !== null) searchParamsString += `&start_time=${(0, $gk2F6.timeSlicer)(startTime)}`;
    if (startDate.toString() === endDate.toString() && endTime !== null) searchParamsString += `&end_time=${(0, $gk2F6.timeSlicer)(endTime)}`;
    if (userFilters.has_video) searchParamsString += `&has_video=true`;
    localStorage.setItem("queryString", JSON.stringify(`${filterType}${searchParamsString}`));
    // Make getAlertsFunction async directly
    const getAlertsFunction = async (refreshInt)=>{
        // Remove the inner async () => { ... } wrapper
        (0, $ffd916f32bf91472$export$dda1917e5b995f19)();
        try {
            const responseData = await (0, $2b15fd61b31c2ea0$export$899219e2395ac333).getAlerts({
                filterType: filterType,
                searchParamsString: searchParamsString
            });
            // Hide muted alerts from the live (Unresolved) queue only — the
            // Resolved queue retains them, including for the muting user.
            const filteredRecords = (0, $94e6bb80767641a9$export$a2c9a5662351211)(filterType) ? responseData.records.filter((row)=>{
                return !(0, $94e6bb80767641a9$export$1874ac93f6160b49)(row, mutedAlertSites, mutedAlertCameras);
            }) : responseData.records;
            // Update responseData.records with filtered data
            // responseData.records = filteredRecords;
            (0, $09aa3d4abe0406ed$export$82ae3b5cddb8719c)(responseData, groupId, filterType, searchParamsString);
            if (responseData.parameters) {
                if (responseData.parameters.period_hours) setPeriodHours(responseData.parameters.period_hours);
            }
            setRowsSortable(true);
            if (filteredRecords[0]) {
                if (startDate && endDate && !siteId && !cameraId && responseData.parameters.query_limit) {
                    if (responseData.records.length > 99) setQueryLimitHit(true);
                    else setQueryLimitHit(false);
                }
                setSelectedRow(filteredRecords[0]);
                (0, $e16b4c67693640c8$export$e44ee059113f075d)(filteredRecords[0], setSelectedButtonsFilled);
                localStorage.setItem("selectedRowAlerts", JSON.stringify(filteredRecords[0]));
                filteredRecords[0].camera_pk && (0, $b68d5e91295063d7$export$f4980018d5f7dd7)(filteredRecords[0].camera_pk, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, navigate);
            }
            if (responseData.parameters?.period_hours) setAlertData((0, $ae0eda0a8a76aaee$export$1ab6fea4cf8d4bfc)(responseData.records, setAlertsIndexOrder, (0, $94e6bb80767641a9$export$a2c9a5662351211)(filterType) ? mutedAlertSites : [], (0, $94e6bb80767641a9$export$a2c9a5662351211)(filterType) ? mutedAlertCameras : []));
            if (filteredRecords[0]) {
                (0, $6b057cfee512ff1e$export$c5f684b415548de8)(filteredRecords[0], navigate, setMP4URL, setVideoClipLoading, setShowRefreshButton, false, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration);
                setAlertsToDisplay(true);
                setPage(0);
                setSeeMoreURL(filteredRecords[0].alert_url);
                if (filteredRecords.length === 1) {
                    setForwardArrowDisabled(true);
                    setBackArrowDisabled(true);
                }
                if (filteredRecords.length > 1) {
                    setForwardArrowDisabled(false);
                    setBackArrowDisabled(true);
                }
                setAlertsToDisplay(true);
                setFetchingFilteredData(false);
                setPageLoading(false);
                (0, $2f189bddd5c99efb$export$89bf317f972eb0c3)(responseData.records, setAlertLabels);
            }
            if (!filteredRecords[0]) {
                setAlertsToDisplay(false);
                setPageLoading(false);
                setFetchingFilteredData(false);
            }
            if (localStorage.tokenRefreshing === "false" || localStorage.tokenRefreshing === undefined) {
                let dataRecordTimeStamp = "";
                if (filteredRecords[0]) dataRecordTimeStamp = filteredRecords[0].approx_capture_timestamp;
                if ((!startDate || startDate === "") && (!endDate || endDate === "") || startDate && startDate !== "" && !endDate && $8bebe2f317b7d60b$var$isCurrentDate(startDate) || endDate && endDate !== "" && !startDate && $8bebe2f317b7d60b$var$isCurrentDate(endDate) || startDate && startDate !== "" && endDate && endDate !== "" && $8bebe2f317b7d60b$var$isCurrentDate(startDate) && $8bebe2f317b7d60b$var$isCurrentDate(endDate)) {
                    if (!endTime) {
                        setRowsSortable(false);
                        (0, $50931580b7d7a15b$export$e3104307e6100e11)(setAlertData, navigate, groupId, siteId, cameraId, startDate, endDate, startTime, endTime, filterType, setSelectedRow, setRefreshingData, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, setAlertsIndexOrder, refreshInt, setRefreshInterval, pageLoadedNumber, setSeeMoreURL, setMP4URL, setVideoClipLoading, setSelectedButtonsFilled, setAlertsToDisplay, setCurrentName, setPage, setDateOutsideRange, setFetchingFilteredData, setPageLoading, setUserFilters, userFilters, cameraOptions, siteOptions, dataRecordTimeStamp, setRefreshingToken, refreshingToken, responseData.records.length, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setAlertsRefreshing, false, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration);
                    } else setAlertsRefreshing(false);
                } else setAlertsRefreshing(false);
            }
            localStorage.setItem("newQueryRunning", "false");
        } catch (error) {
            // Handle error
            setPage(0);
            (0, $3Zv1D.universalAPIErrorHandler)(error, navigate, retryFunction, (context)=>{
                // Surface the failure (SUP-445): without this a 400/5xx from the
                // backend rendered as "No alerts to display".
                (0, $ffd916f32bf91472$export$936012393c4de259)(error, context);
                setAlertsToDisplay(false);
                setPageLoading(false);
                setFetchingFilteredData(false);
            });
        }
    };
    if (groupId) AxiosUI.get(`group/${groupId}`).then((response)=>{
        if (response.data.refresh_interval_seconds) getAlertsFunction(response.data.refresh_interval_seconds * 1000);
        else getAlertsFunction(refreshInterval);
    }, (reason)=>{
        (0, $ebTQj.logger).log("error reason:", reason.message);
        getAlertsFunction(refreshInterval);
    });
    else getAlertsFunction(refreshInterval);
};



var $5L5iJ = parcelRequire("5L5iJ");


var $9OjAn = parcelRequire("9OjAn");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");

var $hAnMZ = parcelRequire("hAnMZ");

const $328cd9f389bda6d1$var$toMs = (seconds)=>Number(seconds) * 1000;
const $328cd9f389bda6d1$var$durationMinutes = (mutedAt, expiresAt)=>Math.max(0, Math.round((Number(expiresAt) - Number(mutedAt)) / 60));
const $328cd9f389bda6d1$export$30d0cdda3c784e44 = (data)=>{
    const sites = (data?.sites ?? []).map((row)=>({
            site_id: row.site_id,
            site_name: row.site_name,
            ...row.camera_id != null ? {
                camera_id: row.camera_id
            } : {},
            mute_start_time: $328cd9f389bda6d1$var$toMs(row.muted_at),
            mute_end_time: $328cd9f389bda6d1$var$toMs(row.expires_at),
            mute_duration: $328cd9f389bda6d1$var$durationMinutes(row.muted_at, row.expires_at),
            timezone: "",
            muted_by: row.muted_by ?? null
        }));
    const cameras = (data?.cameras ?? []).map((row)=>({
            camera_id: row.camera_id,
            camera_name: row.camera_name,
            site_id: row.site_id,
            site_name: row.site_name,
            scope: row.scope,
            mute_start_time: $328cd9f389bda6d1$var$toMs(row.muted_at),
            mute_end_time: $328cd9f389bda6d1$var$toMs(row.expires_at),
            mute_duration: $328cd9f389bda6d1$var$durationMinutes(row.muted_at, row.expires_at),
            timezone: "",
            muted_by: row.muted_by ?? null
        }));
    return {
        sites: sites,
        cameras: cameras
    };
};



var $ebTQj = parcelRequire("ebTQj");
// Latest fetchSharedMutes request; older responses are dropped.
let $a4c0e7e0c5cf28c3$var$sharedMutesRequestSeq = 0;
// Camera whose notes were last requested; a slower response for a camera the
// user has already stepped past is dropped (ENG-2421).
let $a4c0e7e0c5cf28c3$var$cameraNotesRequestedFor = null;
const $a4c0e7e0c5cf28c3$export$52a528b1f45cfa42 = (0, $9OjAn.create)((set, get)=>({
        // Initial state
        siteId: 0,
        setSiteId: (siteId)=>set({
                siteId: siteId
            }),
        siteNotes: "",
        setSiteNotes: (notes)=>set({
                siteNotes: notes
            }),
        viewSiteProtocolDialogOpen: false,
        setViewSiteProtocolDialogOpen: (open)=>set({
                viewSiteProtocolDialogOpen: open
            }),
        retrievingSiteNotes: false,
        setRetrievingSiteNotes: (loading)=>set({
                retrievingSiteNotes: loading
            }),
        notesCache: {},
        setNotesCache: (notesCache)=>set({
                notesCache: notesCache
            }),
        cameraNotes: "",
        retrievingCameraNotes: false,
        cameraNotesCache: {},
        siteIntegrationTypes: {},
        mutedAlertsDialogOpen: false,
        setMutedAlertsDialogOpen: (open)=>set({
                mutedAlertsDialogOpen: open
            }),
        mutedAlertSites: [],
        setMutedAlertSites: (mutedAlertSites)=>set({
                mutedAlertSites: mutedAlertSites
            }),
        mutedAlertCameras: [],
        setMutedAlertCameras: (mutedAlertCameras)=>set({
                mutedAlertCameras: mutedAlertCameras
            }),
        seeMutedSiteAndCamerasDialogOpen: false,
        setSeeMutedSiteAndCamerasDialogOpen: (open)=>set({
                seeMutedSiteAndCamerasDialogOpen: open
            }),
        alertState: {
            cameraMutedSuccess: false,
            siteMutedSuccess: false
        },
        setAlertState: (alertState)=>set({
                alertState: alertState
            }),
        mutedAlertInfo: {
            siteName: "",
            cameraName: "",
            alertEndTime: 0
        },
        setMutedAlertInfo: (mutedAlertInfo)=>set({
                mutedAlertInfo: mutedAlertInfo
            }),
        selectedRowIsMuted: false,
        setSelectedRowIsMuted: (selectedRowIsMuted)=>set({
                selectedRowIsMuted: selectedRowIsMuted
            }),
        // Shared (fleet-wide) mute list, ENG-2103. Mutes are operational and apply
        // to every operator, so the list is read from monitoring-api rather than
        // the muting user's own storage/user record (which left other operators
        // seeing "No muted sites" — SUP-727). Called on page load, on the page's
        // 30 s tick, when the see-muted dialog opens, and after every mute/unmute.
        // Failures keep the last known lists; this never throws.
        fetchSharedMutes: async (navigate)=>{
            const requestSeq = ++$a4c0e7e0c5cf28c3$var$sharedMutesRequestSeq;
            const AxiosUI = (0, $hAnMZ.createMonitoringAPICall)(``);
            const retryFunction = ()=>{
                get().fetchSharedMutes(navigate);
            };
            try {
                const response = await AxiosUI.get(`streaming/mutes/`);
                // A slower, older response must not overwrite a newer one (e.g. the
                // tick's fetch landing after the post-unmute refetch).
                if (requestSeq !== $a4c0e7e0c5cf28c3$var$sharedMutesRequestSeq) return;
                const { sites: sites, cameras: cameras } = (0, $328cd9f389bda6d1$export$30d0cdda3c784e44)(response.data);
                set({
                    mutedAlertSites: sites,
                    mutedAlertCameras: cameras
                });
            } catch (reason) {
                const error = reason;
                // Only an auth failure is worth handing on (token refresh + retry);
                // anything else is a background read the user never asked for.
                if (error?.response?.status === 403) (0, $3Zv1D.universalAPIErrorHandler)(error, navigate, retryFunction, ()=>{});
                else (0, $ebTQj.logger).warn("Failed to fetch shared mutes:", error?.message);
            }
        },
        // Unmute a row of the shared list, then refetch it. A site-scope unmute
        // goes through any camera of the site, which the shared list carries on
        // each site row (monitoring-api #220).
        unmuteSharedMute: async (scope, entry, navigate)=>{
            const { handleMuteAlerts: handleMuteAlerts, fetchSharedMutes: fetchSharedMutes, setMuteAlertsError: setMuteAlertsError } = get();
            const cameraId = entry.camera_id;
            if (cameraId == null) {
                setMuteAlertsError("Unable to unmute: this site has no cameras. Please refresh and try again.");
                return false;
            }
            const unmuted = await handleMuteAlerts(scope, "unmute", cameraId, 0, navigate);
            if (unmuted) await fetchSharedMutes(navigate);
            return unmuted;
        },
        // API call to get site notes/protocol
        getSiteNotes: async (siteId, navigate)=>{
            const { setRetrievingSiteNotes: setRetrievingSiteNotes, setSiteNotes: setSiteNotes, notesCache: notesCache, setNotesCache: setNotesCache } = get();
            setSiteNotes("");
            const cachedNoteKeys = Object.keys(notesCache);
            if (cachedNoteKeys.includes(siteId.toString())) {
                setSiteNotes(notesCache[siteId]);
                return;
            }
            setRetrievingSiteNotes(true);
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().getSiteNotes(siteId, navigate);
            };
            try {
                const response = await AxiosUI.get(`customer/${siteId}/about/`);
                // Extract notes from the response - adjust this based on actual API response structure
                const notes = response.data?.notes || response.data?.instructions || "";
                setSiteNotes(notes);
                setNotesCache({
                    ...notesCache,
                    [siteId]: notes
                });
                // Same response carries the site's integration type; the talk-down
                // control (ENG-2135) gates on it. Cached alongside the notes.
                set({
                    siteIntegrationTypes: {
                        ...get().siteIntegrationTypes,
                        [siteId]: response.data?.integration_type_name ?? null
                    }
                });
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    setSiteNotes("");
                });
            } finally{
                setRetrievingSiteNotes(false);
            }
        },
        getCameraNotes: async (cameraId, navigate)=>{
            $a4c0e7e0c5cf28c3$var$cameraNotesRequestedFor = cameraId;
            const cached = get().cameraNotesCache[cameraId];
            if (cached !== undefined) {
                set({
                    cameraNotes: cached,
                    retrievingCameraNotes: false
                });
                return;
            }
            set({
                cameraNotes: "",
                retrievingCameraNotes: true
            });
            const AxiosUI = (0, $195EM.createApi)(``);
            const retryFunction = ()=>{
                get().getCameraNotes(cameraId, navigate);
            };
            try {
                const response = await AxiosUI.get(`/camera/${cameraId}/general_info/`);
                const notes = response.data?.notes || "";
                set({
                    cameraNotesCache: {
                        ...get().cameraNotesCache,
                        [cameraId]: notes
                    }
                });
                if ($a4c0e7e0c5cf28c3$var$cameraNotesRequestedFor === cameraId) set({
                    cameraNotes: notes
                });
            } catch (reason) {
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    if ($a4c0e7e0c5cf28c3$var$cameraNotesRequestedFor === cameraId) set({
                        cameraNotes: ""
                    });
                });
            } finally{
                if ($a4c0e7e0c5cf28c3$var$cameraNotesRequestedFor === cameraId) set({
                    retrievingCameraNotes: false
                });
            }
        },
        muteAlertsError: "",
        setMuteAlertsError: (muteAlertsError)=>set({
                muteAlertsError: muteAlertsError
            }),
        // Operational mute: suppresses third-party alert dispatch (SMS/Immix/
        // Milestone/webhooks) at the connector for ALL operators via monitoring-api,
        // instead of the old per-user storage/user display filter.
        // For scope "site", any camera pk belonging to the site works as the URL
        // param — the backend expands site scope to all the site's cameras.
        // Returns true on success so callers can update local muted lists.
        handleMuteAlerts: async (alertType, muteType, cameraId, durationMinutes, navigate)=>{
            const { handleMuteAlerts: handleMuteAlerts, setAlertState: setAlertState, setMuteAlertsError: setMuteAlertsError } = get();
            if (cameraId === null || cameraId === undefined || cameraId === "") {
                setMuteAlertsError("Unable to identify a camera for this mute request. Please refresh and try again.");
                return false;
            }
            const AxiosUI = (0, $hAnMZ.createMonitoringAPICall)(``);
            const retryFunction = ()=>{
                handleMuteAlerts(alertType, muteType, cameraId, durationMinutes, navigate);
            };
            const action = muteType === "mute" ? "mute" : "unmute";
            const body = action === "mute" ? {
                scope: alertType,
                duration_minutes: durationMinutes
            } : {
                scope: alertType
            };
            try {
                await AxiosUI.post(`streaming/${action}/${cameraId}/`, body);
                if (action === "mute") setAlertState({
                    cameraMutedSuccess: alertType === "camera",
                    siteMutedSuccess: alertType === "site"
                });
                return true;
            } catch (reason) {
                const error = reason;
                // Only a real denial ("you do not have permission to mute alerts") is a
                // permissions problem. An expired session also answers 403, and that
                // must renew the token and retry like every other request (ENG-1975).
                const detail = String(error.response?.data?.detail ?? "");
                if (error.response?.status === 403 && /permission/i.test(detail)) setMuteAlertsError("You don't have permission to mute alerts. Contact an administrator to request alert-muting access.");
                else (0, $3Zv1D.universalAPIErrorHandler)(error, navigate, retryFunction, ()=>{});
                return false;
            }
        },
        handleSubmitMutedAlert: async (selectedRow, navigate)=>{
            const { handleSubmitMutedAlert: handleSubmitMutedAlert } = get();
            const postedAlert = {
                approx_capture_timestamp: selectedRow.approx_capture_timestamp,
                window_id: selectedRow.window_id,
                alert_outcome: null,
                threat_level: 1,
                notes: selectedRow.unresolved_notes
            };
            const AxiosUI = (0, $hAnMZ.createMonitoringAPICall)(``);
            const retryFunction = ()=>{
                handleSubmitMutedAlert(selectedRow, navigate);
            };
            try {
                await AxiosUI.post(`alert/outcome/`, postedAlert);
            } catch (reason) {
                // A background write the user never clicked: on a set_alert_outcome
                // denial, drop the cached flag quietly (stops further attempts) rather
                // than alerting or retrying.
                if ((0, $c0b3a83d600c7aa1$export$6774c9fd1e0c28f9)(reason)) {
                    (0, $c0b3a83d600c7aa1$export$6251ce535adde2f4)();
                    return;
                }
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
            }
        },
        resetAlertsStore: ()=>{
            set({
                siteId: 0,
                siteNotes: "",
                viewSiteProtocolDialogOpen: false,
                retrievingSiteNotes: false,
                notesCache: {},
                cameraNotes: "",
                retrievingCameraNotes: false,
                cameraNotesCache: {},
                siteIntegrationTypes: {},
                mutedAlertsDialogOpen: false,
                alertState: {
                    cameraMutedSuccess: false,
                    siteMutedSuccess: false
                },
                mutedAlertSites: [],
                mutedAlertCameras: [],
                seeMutedSiteAndCamerasDialogOpen: false,
                muteAlertsError: "",
                mutedAlertInfo: {
                    siteName: "",
                    cameraName: "",
                    alertEndTime: 0
                },
                selectedRowIsMuted: false
            });
        }
    }));


const $30e263c4a2b86f06$export$67a8e4ea3e28249e = 120;
const $30e263c4a2b86f06$export$dae50d79c4815d6 = 140;
const $30e263c4a2b86f06$export$d5a98072eaa4b24f = 150;
const $30e263c4a2b86f06$export$ee9d106374f8d0f = 12;
const $30e263c4a2b86f06$export$f49471be287e6a83 = 3;
const $30e263c4a2b86f06$export$217be90a51061de3 = 4;
const $30e263c4a2b86f06$export$a267c4bae9647b62 = 32;
const $30e263c4a2b86f06$export$7a694a8c519a660 = $30e263c4a2b86f06$export$dae50d79c4815d6 * $30e263c4a2b86f06$export$f49471be287e6a83 + $30e263c4a2b86f06$export$d5a98072eaa4b24f * $30e263c4a2b86f06$export$217be90a51061de3 + $30e263c4a2b86f06$export$ee9d106374f8d0f * ($30e263c4a2b86f06$export$f49471be287e6a83 + $30e263c4a2b86f06$export$217be90a51061de3 - 1);
const $30e263c4a2b86f06$export$e77754fa72f453c5 = $30e263c4a2b86f06$export$7a694a8c519a660 + $30e263c4a2b86f06$export$ee9d106374f8d0f + $30e263c4a2b86f06$export$67a8e4ea3e28249e + $30e263c4a2b86f06$export$a267c4bae9647b62;
const $30e263c4a2b86f06$export$a02b83257882a15e = (containerWidth)=>containerWidth > 0 && containerWidth < $30e263c4a2b86f06$export$e77754fa72f453c5;
const $30e263c4a2b86f06$export$e9df3b5e8d88d9f4 = "min-w-[140px] flex-1";
const $30e263c4a2b86f06$export$9e0a043f575674e8 = "min-w-[150px] flex-1";
const $30e263c4a2b86f06$export$4e3c1b210884a471 = "w-[140px] min-w-[140px]";
const $30e263c4a2b86f06$export$4686fcabe874c7a2 = "w-[150px] min-w-[150px]";
const $30e263c4a2b86f06$export$ecfc84a6abb7ab21 = "flex min-w-0 w-full flex-1 items-end gap-3";
const $30e263c4a2b86f06$export$69e198e12714b7c2 = "flex w-full flex-wrap items-end gap-3";
const $30e263c4a2b86f06$export$e61f5a7dec67de43 = {
    width: "100%",
    minWidth: 0
};
const $30e263c4a2b86f06$export$d1adbbb4317b1e3f = 100;
const $30e263c4a2b86f06$export$5bd018d38b39464e = `min-w-[${$30e263c4a2b86f06$export$d1adbbb4317b1e3f}px] flex-1`;
const $30e263c4a2b86f06$export$b19352cbfd0048a7 = "flex min-w-0 flex-1 flex-wrap items-start gap-x-2 gap-y-2";
const $30e263c4a2b86f06$export$bce33fbc275ec825 = {
    ...$30e263c4a2b86f06$export$e61f5a7dec67de43,
    fontFamily: "Mulish",
    "& .MuiInputLabel-root": {
        fontFamily: "Mulish"
    },
    "& .MuiOutlinedInput-root": {
        fontFamily: "Mulish"
    }
};
const $30e263c4a2b86f06$export$e39095426be65fc6 = {
    ...$30e263c4a2b86f06$export$e61f5a7dec67de43,
    "& .MuiAutocomplete-inputRoot:not(.Mui-focused)": {
        flexWrap: "nowrap",
        "& .MuiAutocomplete-input": {
            minWidth: 0
        }
    },
    "& .MuiChip-root.MuiAutocomplete-tag": {
        minWidth: 0
    },
    "& span.MuiAutocomplete-tag": {
        flexShrink: 0
    }
};
const $30e263c4a2b86f06$export$74781f6aa62ac4d1 = {
    ...$30e263c4a2b86f06$export$e61f5a7dec67de43,
    "& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus": {
        WebkitBoxShadow: "0 0 0 1000px #fff inset",
        WebkitTextFillColor: "inherit",
        caretColor: "inherit"
    }
};
const $30e263c4a2b86f06$export$32ca9c91d1977728 = "shadow-button shrink-0 border-2 border-actuate-orange bg-actuate-orange p-1.5 font-mulish text-base text-white rounded w-[120px] hover:bg-[#E67300]";


const $9bccc5797fb1948e$var$FILTER_BY_OPTIONS = [
    {
        name: "Unresolved Alerts",
        value: "UNCLAIMED"
    },
    {
        name: "Resolved Alerts",
        value: "CLAIMED"
    },
    {
        name: "All Alerts",
        value: "ALL"
    }
];
const $9bccc5797fb1948e$export$9a4e1638c9039348 = ({ userFilters: userFilters, setFetchingFilteredData: setFetchingFilteredData, setAlertData: setAlertData, navigate: navigate, setSelectedRow: setSelectedRow, setSeeMoreURL: setSeeMoreURL, setMP4URL: setMP4URL, setUserFilters: setUserFilters, setSelectedButtonsFilled: setSelectedButtonsFilled, setThumbnailVideos: setThumbnailVideos, setDateOutsideRange: setDateOutsideRange, setPage: setPage, setVideoClipLoading: setVideoClipLoading, setAlertsToDisplay: setAlertsToDisplay, setPageLoading: setPageLoading, setSelectedAlertCameraInfo: setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert: setIgnoreZonesSelectedAlert, setAlertsIndexOrder: setAlertsIndexOrder, setRefreshInterval: setRefreshInterval, currentName: currentName, setCurrentName: setCurrentName, pageLoadedNumber: pageLoadedNumber, setPageLoadedNumber: setPageLoadedNumber, setRefreshingData: setRefreshingData, cameraOptions: cameraOptions, siteOptions: siteOptions, setRefreshingToken: setRefreshingToken, refreshingToken: refreshingToken, setAlertLabels: setAlertLabels, setPeriodHours: setPeriodHours, setQueryLimitHit: setQueryLimitHit, searchParams: searchParams, setSearchParams: setSearchParams, detectionType: detectionType, refreshInterval: refreshInterval, setOutcomeFilterType: setOutcomeFilterType, setForwardArrowDisabled: setForwardArrowDisabled, setBackArrowDisabled: setBackArrowDisabled, setShowRefreshButton: setShowRefreshButton, setRowsSortable: setRowsSortable, setAlertsRefreshing: setAlertsRefreshing, getCurrentSelectedRowKey: getCurrentSelectedRowKey, setVideoProcessing: setVideoProcessing })=>{
    const { mutedAlertSites: mutedAlertSites, mutedAlertCameras: mutedAlertCameras } = (0, $a4c0e7e0c5cf28c3$export$52a528b1f45cfa42)();
    const selectedOption = $9bccc5797fb1948e$var$FILTER_BY_OPTIONS.find((option)=>option.name === currentName) ?? $9bccc5797fb1948e$var$FILTER_BY_OPTIONS[0];
    const applyFilter = (object)=>{
        let newNumber = Number(pageLoadedNumber);
        newNumber += 1;
        setPageLoadedNumber(newNumber);
        localStorage.setItem("pageLoadedNumber", `${newNumber}`);
        localStorage.setItem("latestAlertFilters", JSON.stringify(userFilters));
        setPage(0);
        setOutcomeFilterType("All");
        setFetchingFilteredData(true);
        setCurrentName(object.name);
        (0, $8bebe2f317b7d60b$export$f0c03502af15d107)(setAlertData, navigate, setSelectedRow, setFetchingFilteredData, setSeeMoreURL, setMP4URL, userFilters.parent_group, userFilters.site, userFilters.camera, (0, $5L5iJ.yyyymmddGenerator)(userFilters.start_date), (0, $5L5iJ.yyyymmddGenerator)(userFilters.end_date), userFilters.start_time, userFilters.end_time, object.value, setSelectedButtonsFilled, setThumbnailVideos, setDateOutsideRange, setPage, setVideoClipLoading, setAlertsToDisplay, setPageLoading, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, setAlertsIndexOrder, setRefreshInterval, setCurrentName, setUserFilters, setRefreshingData, newNumber, refreshInterval, userFilters, cameraOptions, siteOptions, setRefreshingToken, refreshingToken, setAlertLabels, setPeriodHours, setQueryLimitHit, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setRowsSortable, setAlertsRefreshing, getCurrentSelectedRowKey, mutedAlertSites, mutedAlertCameras, setVideoProcessing);
        setUserFilters((previousState)=>{
            return {
                ...previousState,
                filter_type: object.value
            };
        });
        (0, $361dd3e7be612e92$export$59b2b76630cf930b)({
            ...userFilters,
            filter_type: object.value
        }, searchParams, setSearchParams, detectionType);
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: `${(0, $30e263c4a2b86f06$export$5bd018d38b39464e)} font-mulish`,
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            disablePortal: true,
            disableClearable: true,
            options: $9bccc5797fb1948e$var$FILTER_BY_OPTIONS,
            getOptionLabel: (option)=>option.name || "",
            isOptionEqualToValue: (option, value)=>option.value === value.value,
            value: selectedOption,
            onChange: (_event, value)=>{
                if (value) applyFilter(value);
            },
            sx: (0, $30e263c4a2b86f06$export$bce33fbc275ec825),
            ListboxProps: {
                sx: {
                    fontFamily: "Mulish"
                }
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    size: "small",
                    label: "Filter by",
                    autoComplete: "off"
                }),
            renderOption: (props, option)=>/*#__PURE__*/ (0, $8T3gX.createElement)("li", {
                    ...props,
                    key: option.value
                }, option.name)
        })
    });
};




var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");


const $536ac5479298ea5c$export$477348a21311abc1 = ({ alertLabels: alertLabels, detectionType: detectionType, setDetectionType: setDetectionType, userFilters: userFilters, searchParams: searchParams, setSearchParams: setSearchParams, setPage: setPage })=>{
    const options = Array.isArray(alertLabels) ? alertLabels : [];
    const selectedValue = options.includes(detectionType) ? detectionType : options[0] ?? "All";
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: `${(0, $30e263c4a2b86f06$export$5bd018d38b39464e)} font-mulish`,
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            disablePortal: true,
            disableClearable: true,
            options: options.length > 0 ? options : [
                selectedValue
            ],
            value: selectedValue,
            onChange: (_event, name)=>{
                if (!name) return;
                setDetectionType(name);
                (0, $361dd3e7be612e92$export$59b2b76630cf930b)(userFilters, searchParams, setSearchParams, name);
                setPage(0);
            },
            sx: (0, $30e263c4a2b86f06$export$bce33fbc275ec825),
            ListboxProps: {
                sx: {
                    fontFamily: "Mulish"
                }
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    size: "small",
                    label: "Detection types",
                    autoComplete: "off"
                }),
            renderOption: (props, option)=>/*#__PURE__*/ (0, $8T3gX.createElement)("li", {
                    ...props,
                    key: option
                }, option)
        })
    });
};



var $8jTCz = parcelRequire("8jTCz");

var $iIAML = parcelRequire("iIAML");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");

const $4e015c4ebef076fb$var$OUTCOME_OPTIONS = [
    {
        name: "All",
        value: "All"
    },
    {
        name: "True Threat",
        value: "true_threat"
    },
    {
        name: "Escalated True Threat",
        value: "escalated_true_threat"
    },
    {
        name: "True Non-Threat",
        value: "true_non_threat"
    },
    {
        name: "False",
        value: "false_positive"
    }
];
const $4e015c4ebef076fb$export$abca0dbb54977a6f = ({ outcomeFilterType: outcomeFilterType, setOutcomeFilterType: setOutcomeFilterType, setPage: setPage })=>{
    const selectedOption = $4e015c4ebef076fb$var$OUTCOME_OPTIONS.find((option)=>option.value === outcomeFilterType) ?? $4e015c4ebef076fb$var$OUTCOME_OPTIONS[0];
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: `${(0, $30e263c4a2b86f06$export$5bd018d38b39464e)} font-mulish`,
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            disablePortal: true,
            disableClearable: true,
            options: $4e015c4ebef076fb$var$OUTCOME_OPTIONS,
            getOptionLabel: (option)=>option.name || "",
            isOptionEqualToValue: (option, value)=>option.value === value.value,
            value: selectedOption,
            onChange: (_event, value)=>{
                if (!value) return;
                setOutcomeFilterType(value.value);
                setPage(0);
            },
            sx: (0, $30e263c4a2b86f06$export$bce33fbc275ec825),
            ListboxProps: {
                sx: {
                    fontFamily: "Mulish"
                }
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    size: "small",
                    label: "Outcome",
                    autoComplete: "off"
                }),
            renderOption: (props, option)=>/*#__PURE__*/ (0, $8T3gX.createElement)("li", {
                    ...props,
                    key: option.value
                }, option.name)
        })
    });
};


var $0bc50af9b02a5c81$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($0bc50af9b02a5c81$exports, "__esModule", {
    value: true
});
$0bc50af9b02a5c81$exports.default = void 0;

var $0bc50af9b02a5c81$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $0bc50af9b02a5c81$var$_default = $0bc50af9b02a5c81$exports.default = (0, $0bc50af9b02a5c81$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8m0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4z"
}), 'Loop');


var $a09d8a49c5a30d92$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($a09d8a49c5a30d92$exports, "__esModule", {
    value: true
});
$a09d8a49c5a30d92$exports.default = void 0;

var $a09d8a49c5a30d92$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $a09d8a49c5a30d92$var$_default = $a09d8a49c5a30d92$exports.default = (0, $a09d8a49c5a30d92$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M10 6.35V4.26c-.8.21-1.55.54-2.23.96l1.46 1.46c.25-.12.5-.24.77-.33m-7.14-.94 2.36 2.36C4.45 8.99 4 10.44 4 12c0 2.21.91 4.2 2.36 5.64L4 20h6v-6l-2.24 2.24C6.68 15.15 6 13.66 6 12c0-1 .25-1.94.68-2.77l8.08 8.08c-.25.13-.5.25-.77.34v2.09c.8-.21 1.55-.54 2.23-.96l2.36 2.36 1.27-1.27L4.14 4.14zM20 4h-6v6l2.24-2.24C17.32 8.85 18 10.34 18 12c0 1-.25 1.94-.68 2.77l1.46 1.46C19.55 15.01 20 13.56 20 12c0-2.21-.91-4.2-2.36-5.64z"
}), 'SyncDisabled');



var $aYdit = parcelRequire("aYdit");

var $iKAtE = parcelRequire("iKAtE");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");

var $i5MAs = parcelRequire("i5MAs");



var $4PFLW = parcelRequire("4PFLW");



var $5L5iJ = parcelRequire("5L5iJ");

parcelRequire("8T3gX");

var $hAnMZ = parcelRequire("hAnMZ");

var $gk2F6 = parcelRequire("gk2F6");

var $ebTQj = parcelRequire("ebTQj");
const $25ae21820f1aa870$export$d115d726eab6599b = 2000;
const $25ae21820f1aa870$export$f07e283e4758be92 = 15000;
const $25ae21820f1aa870$export$449a48dbd165ef3 = 300000;
const $25ae21820f1aa870$var$abortableSleep = (ms, signal)=>new Promise((resolve, reject)=>{
        const timer = setTimeout(()=>{
            signal?.removeEventListener("abort", onAbort);
            resolve();
        }, ms);
        const onAbort = ()=>{
            clearTimeout(timer);
            reject(new DOMException("Aborted", "AbortError"));
        };
        signal?.addEventListener("abort", onAbort, {
            once: true
        });
    });
const $25ae21820f1aa870$export$cecea10c8580a141 = async (groupId, siteId, cameraId, startDate, endDate, startTime, endTime, signal)=>{
    const AxiosUI = (0, $hAnMZ.createMonitoringAPICall)(``);
    let searchParamsString = ``;
    if (groupId) {
        if (groupId !== "undefined") searchParamsString += `?group_id=${groupId}`;
    }
    if (siteId) {
        if (siteId !== "undefined") {
            if (groupId !== "undefined") searchParamsString += `&customer_id=${siteId}`;
            else searchParamsString += `?customer_id=${siteId}`;
        }
    }
    if (cameraId) {
        if (cameraId !== "undefined") {
            if (groupId !== "undefined" && siteId !== "undefined") searchParamsString += `&camera_id=${cameraId}`;
            else searchParamsString += `?camera_id=${cameraId}`;
        }
    }
    if (startDate) {
        if (groupId !== "undefined" && siteId !== "undefined" && cameraId !== "undefined") searchParamsString += `&start=${startDate}`;
        else searchParamsString += `?start=${startDate}`;
    }
    if (endDate) {
        if (groupId !== "undefined" && siteId !== "undefined" && cameraId !== "undefined" && startDate) searchParamsString += `&end=${endDate}`;
        else searchParamsString += `?end=${endDate}`;
    }
    if (startDate.toString() === endDate.toString() && startTime !== null) searchParamsString += `&start_time=${(0, $gk2F6.timeSlicer)(startTime)}`;
    if (startDate.toString() === endDate.toString() && endTime !== null) searchParamsString += `&end_time=${(0, $gk2F6.timeSlicer)(endTime)}`;
    if (searchParamsString.length > 0) searchParamsString += `&source=v2`;
    try {
        // ENG-1842: for ranges older than the DynamoDB retention the backend
        // generates the report asynchronously in Athena and answers 202
        // {status: "processing", poll_url} until it's ready. Repeating the same
        // request is the poll — the backend keys the query on the request
        // parameters, so every retry lands on the same report. The caller's
        // AbortSignal stops the loop on unmount or filter change; abandoning the
        // poll never abandons the report (it finishes server-side and a later
        // identical request picks it up).
        const deadline = Date.now() + $25ae21820f1aa870$export$449a48dbd165ef3;
        let interval = $25ae21820f1aa870$export$d115d726eab6599b;
        for(;;){
            const response = await AxiosUI.get(`alert/download_v2/${searchParamsString}`, {
                signal: signal
            });
            if (response.status !== 202) return response.data.url;
            if (Date.now() > deadline) throw new Error("Report generation timed out. Please try fetching it again.");
            await $25ae21820f1aa870$var$abortableSleep(interval, signal);
            interval = Math.min(interval * 2, $25ae21820f1aa870$export$f07e283e4758be92);
        }
    } catch (error) {
        const axiosError = error;
        (0, $ebTQj.logger).log("error", axiosError.message);
        throw error;
    }
};


// ENG-1842: alert rows expire out of DynamoDB after ~60 days; older ranges are
// served as an asynchronously generated CSV report from the Athena mirror, and
// their media (frames at 14 days, MP4s to Deep Archive at 60) is gone. This
// mirrors monitoring-api's `is_archived_range` gate so the UI can explain an
// empty grid and steer the user to the report download instead.
// Must agree with monitoring-api's DDB_ALERT_RETENTION_DAYS (env-tunable,
// default 60, monitoring/settings.py) — the backend gate AND the customer-facing
// sentence in the notice both derive from this number. If the backend value ever
// changes, change this with it (or better: have the list response expose the
// horizon and drop this constant).
const $74572e7331880165$export$b251626c1ee2fc7a = 60;
const $74572e7331880165$export$c5ba5169ea3216c8 = (startDate)=>{
    if (!startDate) // No explicit start date = the default recent view; never archived.
    return false;
    const start = startDate instanceof Date ? startDate : new Date(`${String(startDate).slice(0, 10)}T00:00:00`);
    if (isNaN(start.getTime())) return false;
    const horizon = new Date();
    horizon.setHours(0, 0, 0, 0);
    horizon.setDate(horizon.getDate() - ($74572e7331880165$export$b251626c1ee2fc7a - 1));
    return start < horizon;
};





var $biDrR = parcelRequire("biDrR");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $biDrR = parcelRequire("biDrR");
const $e46e67fbb04d9482$export$d95c562fc8f7c2d7 = "#2E7D32";
const $e46e67fbb04d9482$export$58dfbfd5d2f57aed = "#D32F2F";
const $e46e67fbb04d9482$export$ee1ec9f1df34e12f = "#4D5E7B";
const $e46e67fbb04d9482$export$a076d3f93826af8f = (row)=>{
    const verdict = (0, $biDrR.getAlertVlmVerdict)(row);
    if (verdict === "passed") return $e46e67fbb04d9482$export$d95c562fc8f7c2d7;
    if (verdict === "filtered") return $e46e67fbb04d9482$export$58dfbfd5d2f57aed;
    return $e46e67fbb04d9482$export$ee1ec9f1df34e12f;
};
const $e46e67fbb04d9482$export$462404aa702cbaf4 = {
    passed: "Likely TP",
    filtered: "Likely FP"
};
const $e46e67fbb04d9482$export$29b7dd3aeaf1715b = ({ row: row })=>{
    const verdict = (0, $biDrR.getAlertVlmVerdict)(row);
    if (!verdict) return null;
    const color = verdict === "passed" ? $e46e67fbb04d9482$export$d95c562fc8f7c2d7 : $e46e67fbb04d9482$export$58dfbfd5d2f57aed;
    const label = $e46e67fbb04d9482$export$462404aa702cbaf4[verdict];
    return /*#__PURE__*/ (0, $k4ank.jsx)("span", {
        className: "inline-flex items-center rounded px-1.5 py-0.5 font-mulish text-[10px] font-bold leading-none",
        style: {
            color: color,
            backgroundColor: `${color}1A`,
            border: `1px solid ${color}59`
        },
        children: label
    });
};
const $e46e67fbb04d9482$export$381190240de59398 = ({ row: row })=>{
    const verdict = (0, $biDrR.getAlertVlmVerdict)(row);
    if (!verdict) return /*#__PURE__*/ (0, $k4ank.jsx)("span", {
        className: "font-mulish text-[11.5px] font-bold",
        style: {
            color: $e46e67fbb04d9482$export$ee1ec9f1df34e12f
        },
        "aria-label": "No DOUBLETAKE verdict",
        children: "N/A"
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)("span", {
        className: "whitespace-nowrap font-mulish text-[11.5px] font-bold",
        style: {
            color: verdict === "passed" ? $e46e67fbb04d9482$export$d95c562fc8f7c2d7 : $e46e67fbb04d9482$export$58dfbfd5d2f57aed
        },
        children: $e46e67fbb04d9482$export$462404aa702cbaf4[verdict]
    });
};



// "Rows per page" on the alerts table is local state in AlertsTable, and the
// parent unmounts the table for every list refresh (`!refreshingData &&`), so
// a plain useState(25) snapped back to 25 the moment the background sync
// found a new alert (SUP-510). Persist it like the column width offset so it
// survives remounts (and, as a bonus, reloads).
const $71280fd12553052d$export$d8daa0293fd45f6f = "alertsTableRowsPerPage";
const $71280fd12553052d$export$43df365616a0df93 = [
    25,
    50,
    100
];
const $71280fd12553052d$export$c50cc39e9a9014b0 = $71280fd12553052d$export$43df365616a0df93[0];
const $71280fd12553052d$export$bd12d67f855cad71 = ()=>{
    try {
        const raw = window.localStorage.getItem($71280fd12553052d$export$d8daa0293fd45f6f);
        const parsed = raw === null ? NaN : Number(raw);
        return $71280fd12553052d$export$43df365616a0df93.includes(parsed) ? parsed : $71280fd12553052d$export$c50cc39e9a9014b0;
    } catch  {
        return $71280fd12553052d$export$c50cc39e9a9014b0;
    }
};
const $71280fd12553052d$export$638aeec760a77a58 = (rowsPerPage)=>{
    try {
        window.localStorage.setItem($71280fd12553052d$export$d8daa0293fd45f6f, String(rowsPerPage));
    } catch  {
    // localStorage unavailable (private mode) — the choice just won't persist
    }
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");
const $33baa4d90519a2f0$export$cfc13311b9039b69 = ({ density: density, onDensityChange: onDensityChange })=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "flex shrink-0 rounded border border-actuate-blue/25",
        role: "group",
        "aria-label": "Table density",
        children: [
            "detailed",
            "condensed"
        ].map((option)=>{
            const isActive = density === option;
            return /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                type: "button",
                onClick: ()=>onDensityChange(option),
                className: `px-2 py-1 font-mulish text-[11px] font-bold ${isActive ? "bg-actuate-orange text-white" : "bg-white text-actuate-blue"}`,
                children: option === "detailed" ? "Detailed" : "Condensed"
            }, option);
        })
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");
const $36f1c5bc563bba72$export$86882abe7c214037 = (alertLabels)=>{
    const labels = Array.isArray(alertLabels) ? alertLabels : typeof alertLabels === "string" ? [
        alertLabels
    ] : [];
    return labels.some((label)=>String(label).toLowerCase().replace(/_/g, " ").includes("line crossing"));
};
const $36f1c5bc563bba72$export$1e43853507c2d294 = (name)=>{
    if (typeof name !== "string" || name.length === 0) return "";
    let newName = name.slice(0, 1).toUpperCase() + name.slice(1);
    if (newName.includes("_")) newName = newName.replace(/_/g, " ");
    return newName;
};
const $36f1c5bc563bba72$export$117eacc6f266987e = {
    intruder: "#FF8400",
    vehicle: "#0288D1",
    loiterer: "#7B1FA2"
};
const $36f1c5bc563bba72$export$1d3bce3483df5f41 = "#FF8400";
const $36f1c5bc563bba72$export$6a65cc9369fb4109 = (alertLabels)=>{
    const key = (alertLabels || "").toLowerCase().replace(/ /g, "_");
    if (key.includes("vehicle")) return $36f1c5bc563bba72$export$117eacc6f266987e.vehicle;
    if (key.includes("loiter")) return $36f1c5bc563bba72$export$117eacc6f266987e.loiterer;
    if (key.includes("intruder")) return $36f1c5bc563bba72$export$117eacc6f266987e.intruder;
    return $36f1c5bc563bba72$export$1d3bce3483df5f41;
};
const $36f1c5bc563bba72$export$a5dbe591b225e4c0 = (row)=>Boolean(row?.detection_type);
const $36f1c5bc563bba72$export$81ac7c18264f7cd8 = (rows)=>rows.filter((row)=>!$36f1c5bc563bba72$export$a5dbe591b225e4c0(row)).length;
// The date filters are Date objects (Alerts.tsx builds them with `new Date`),
// so interpolating them directly printed Date.toString() with the timezone
// name in the condensed header (ENG-1663).
const $36f1c5bc563bba72$var$formatFilterDate = (value)=>{
    if (value == null || value === "") return undefined;
    if (value instanceof Date) return Number.isNaN(value.getTime()) ? undefined : value.toLocaleDateString();
    return value;
};
const $36f1c5bc563bba72$export$efed371f2d8fd411 = ({ periodHours: periodHours, userFilters: userFilters })=>{
    const start = $36f1c5bc563bba72$var$formatFilterDate(userFilters?.start_date);
    const end = $36f1c5bc563bba72$var$formatFilterDate(userFilters?.end_date);
    if (start || end) {
        if (start && end) return `${start} \u{2013} ${end}`;
        if (start) return `From ${start}`;
        return `Through ${end}`;
    }
    if (periodHours === 1) return "Last hour";
    return `Last ${periodHours} hours`;
};


const $46deb238b79847bd$export$baed8097318953ad = ({ alertLabels: alertLabels })=>{
    const label = (0, $36f1c5bc563bba72$export$1e43853507c2d294)(alertLabels);
    if (!label) return null;
    const color = (0, $36f1c5bc563bba72$export$6a65cc9369fb4109)(alertLabels);
    return /*#__PURE__*/ (0, $k4ank.jsx)("span", {
        className: "inline-flex items-center rounded px-1.5 py-0.5 font-mulish text-[10px] font-bold leading-none",
        style: {
            color: color,
            backgroundColor: `${color}1A`,
            border: `1px solid ${color}59`
        },
        children: label
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $cVCJe = parcelRequire("cVCJe");
const $4ba9d3b7f89da3b9$export$9f5e614342ed6b61 = ({ text: text, className: className })=>{
    const textRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const [isTruncated, setIsTruncated] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const updateTruncation = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback(()=>{
        const node = textRef.current;
        if (!node) return;
        setIsTruncated(node.scrollWidth > node.clientWidth);
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useLayoutEffect(()=>{
        updateTruncation();
        const node = textRef.current;
        if (!node || typeof ResizeObserver === "undefined") return undefined;
        const observer = new ResizeObserver(updateTruncation);
        observer.observe(node);
        return ()=>observer.disconnect();
    }, [
        text,
        updateTruncation
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: text,
        placement: "top",
        disableHoverListener: !isTruncated,
        componentsProps: {
            tooltip: {
                sx: {
                    fontFamily: "Mulish",
                    fontSize: "12px"
                }
            }
        },
        children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
            ref: textRef,
            className: className,
            children: text
        })
    });
};


/**
 * ENG-1901: make the Alerts page say which group is in scope.
 *
 * Parent accounts can nest (TV Wall under Genesis) but the picker used to
 * render them as peers. These helpers turn that flat list into a tree, decide
 * when the selection is narrower than the account, and build the copy for the
 * scope line and the empty state.
 */ const $9fba8663fe17aa61$var$PATH_SEPARATOR = " \u203A ";
const $9fba8663fe17aa61$var$asId = (value)=>{
    if (value == null || value === "") return null;
    const id = Number(value);
    return Number.isFinite(id) ? id : null;
};
const $9fba8663fe17aa61$var$byName = (a, b)=>a.name.localeCompare(b.name);
const $9fba8663fe17aa61$export$efb248e57120c2a5 = (groups)=>{
    const byId = new Map();
    (groups ?? []).forEach((group)=>{
        if (group && typeof group.id === "number" && group.name) byId.set(group.id, group);
    });
    const children = new Map();
    const roots = [];
    byId.forEach((group)=>{
        const parentId = $9fba8663fe17aa61$var$asId(group.parent);
        if (parentId != null && parentId !== group.id && byId.has(parentId)) {
            const list = children.get(parentId) ?? [];
            list.push(group);
            children.set(parentId, list);
        } else roots.push(group);
    });
    roots.sort($9fba8663fe17aa61$var$byName);
    children.forEach((list)=>list.sort($9fba8663fe17aa61$var$byName));
    const options = [];
    const visit = (group, depth, ancestors, seen)=>{
        if (seen.has(group.id)) return;
        seen.add(group.id);
        const pathNames = [
            ...ancestors,
            group.name
        ];
        options.push({
            id: group.id,
            name: group.name,
            depth: depth,
            path: pathNames.join($9fba8663fe17aa61$var$PATH_SEPARATOR),
            siteCount: typeof group.site_count === "number" ? group.site_count : null,
            parentId: $9fba8663fe17aa61$var$asId(group.parent)
        });
        (children.get(group.id) ?? []).forEach((child)=>visit(child, depth + 1, pathNames, seen));
    };
    const seen = new Set();
    roots.forEach((root)=>visit(root, 0, [], seen));
    // A parent cycle has no root. Visit whatever the walk never reached so those
    // groups still appear, instead of disappearing from the picker.
    byId.forEach((group)=>{
        if (!seen.has(group.id)) visit(group, 0, [], seen);
    });
    return options;
};
const $9fba8663fe17aa61$export$294daa950f46c61 = (groups, selectedId)=>{
    const id = $9fba8663fe17aa61$var$asId(selectedId);
    if (id == null || selectedId === "undefined") return {
        narrower: false,
        selected: null,
        accountRoot: null
    };
    const options = $9fba8663fe17aa61$export$efb248e57120c2a5(groups);
    const byId = new Map(options.map((option)=>[
            option.id,
            option
        ]));
    const selected = byId.get(id) ?? null;
    if (!selected) return {
        narrower: false,
        selected: null,
        accountRoot: null
    };
    let root = selected;
    const seen = new Set();
    while(root.parentId != null && byId.has(root.parentId) && !seen.has(root.id)){
        seen.add(root.id);
        const parent = byId.get(root.parentId);
        if (!parent) break;
        root = parent;
    }
    return {
        narrower: selected.id !== root.id,
        selected: selected,
        accountRoot: root
    };
};
const $9fba8663fe17aa61$export$7038b1c7d7f32a4b = (accountCount, groupCount, accountLimited, groupLimited)=>{
    const count = Math.max(0, accountCount - groupCount);
    const atLeast = accountLimited || groupLimited;
    return {
        count: count,
        atLeast: atLeast,
        known: !(atLeast && count === 0)
    };
};
const $9fba8663fe17aa61$export$6a83f1dd02a46a33 = (siteCount)=>{
    if (siteCount == null) return null;
    return siteCount === 1 ? "1 site" : `${siteCount} sites`;
};
const $9fba8663fe17aa61$export$2c089059d4727a89 = (other)=>{
    if (!other || !other.known) return null;
    if (other.atLeast) return `at least ${other.count} other alerts`;
    return other.count === 1 ? "1 other alert" : `${other.count} other alerts`;
};
const $9fba8663fe17aa61$var$timestampToDate = (timestamp)=>{
    if (typeof timestamp !== "number" || !Number.isFinite(timestamp) || timestamp <= 0) return null;
    const ms = timestamp < 1e12 ? timestamp * 1000 : timestamp;
    const date = new Date(ms);
    return Number.isNaN(date.getTime()) ? null : date;
};
const $9fba8663fe17aa61$var$dateFromFilter = (startDate, startTime)=>{
    if (!startDate) return null;
    const date = startDate instanceof Date ? new Date(startDate.getTime()) : new Date(startDate);
    if (Number.isNaN(date.getTime())) return null;
    if (startTime) {
        const time = startTime instanceof Date ? startTime : new Date(startTime);
        if (!Number.isNaN(time.getTime())) date.setHours(time.getHours(), time.getMinutes(), 0, 0);
    }
    return date;
};
const $9fba8663fe17aa61$var$formatClock = (date)=>{
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const suffix = date.getHours() >= 12 ? "PM" : "AM";
    const hour = date.getHours() % 12 || 12;
    return `${hour}:${minutes} ${suffix}`;
};
const $9fba8663fe17aa61$var$formatSince = (date, now)=>{
    const time = $9fba8663fe17aa61$var$formatClock(date);
    if (date.toDateString() === now.toDateString()) return time;
    const day = date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric"
    });
    return `${day}, ${time}`;
};
const $9fba8663fe17aa61$export$5c554dd96f80bfe7 = ({ minStartTimestamp: minStartTimestamp, startDate: startDate, startTime: startTime, periodHours: periodHours, now: now = new Date() })=>{
    const fromResponse = $9fba8663fe17aa61$var$timestampToDate(minStartTimestamp);
    const fromFilter = $9fba8663fe17aa61$var$dateFromFilter(startDate, startTime);
    const hours = Number.isFinite(periodHours) && periodHours > 0 ? periodHours : 2;
    const start = fromResponse ?? fromFilter ?? new Date(now.getTime() - hours * 3600000);
    return $9fba8663fe17aa61$var$formatSince(start, now);
};
const $9fba8663fe17aa61$var$alertsArrivedPhrase = (other)=>{
    if (other.atLeast) return `at least ${other.count} alerts arrived`;
    const noun = other.count === 1 ? "alert" : "alerts";
    return `${other.count} ${noun} arrived`;
};
const $9fba8663fe17aa61$export$8af2a9dd09e8638a = ({ narrower: narrower, groupName: groupName, accountName: accountName, sinceLabel: sinceLabel, other: other, hasSiteOrCameraFilter: hasSiteOrCameraFilter })=>{
    const othersKnown = Boolean(other?.known && other.count > 0);
    if (hasSiteOrCameraFilter && !othersKnown) return null;
    const since = `since ${sinceLabel}`;
    const accountIsEmpty = !narrower || other?.known && other.count === 0 && !other.atLeast;
    if (accountIsEmpty) return `No alerts in your account ${since}.`;
    if (othersKnown && groupName && accountName && other) return `No alerts for ${groupName} ${since}. ${$9fba8663fe17aa61$var$alertsArrivedPhrase(other)} for other ${accountName} groups in the same window.`;
    if (narrower && groupName) return `No alerts for ${groupName} ${since}.`;
    return `No alerts in your account ${since}.`;
};
const $9fba8663fe17aa61$export$d41fc0fa5637859d = (searchParamsString, groupId)=>{
    const raw = searchParamsString.startsWith("&") ? searchParamsString.slice(1) : searchParamsString;
    const params = new URLSearchParams(raw);
    params.set("group_id", String(groupId));
    const next = params.toString();
    return next ? `&${next}` : "";
};



var $8T3gX = parcelRequire("8T3gX");



const $d0ff96bb2de1a237$export$e81b059015aec241 = ({ enabled: enabled, parentAccounts: parentAccounts, appliedGroupId: appliedGroupId })=>{
    const scope = enabled ? (0, $9fba8663fe17aa61$export$294daa950f46c61)(parentAccounts, appliedGroupId) : null;
    const groupSnapshot = (0, $09aa3d4abe0406ed$export$7112a6722fc7ddb1)((state)=>state.groupSnapshot);
    const accountSnapshot = (0, $09aa3d4abe0406ed$export$7112a6722fc7ddb1)((state)=>state.accountSnapshot);
    const setAccountSnapshot = (0, $09aa3d4abe0406ed$export$7112a6722fc7ddb1)((state)=>state.setAccountSnapshot);
    const accountRootId = scope?.narrower ? scope.accountRoot?.id ?? null : null;
    const groupMatches = Boolean(groupSnapshot) && groupSnapshot?.groupId === String(appliedGroupId ?? "");
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!enabled || accountRootId == null || !groupSnapshot || !groupMatches) return undefined;
        let cancelled = false;
        const searchParamsString = (0, $9fba8663fe17aa61$export$d41fc0fa5637859d)(groupSnapshot.searchParamsString, accountRootId);
        const filterType = groupSnapshot.filterType;
        (0, $2b15fd61b31c2ea0$export$899219e2395ac333).getAlerts({
            filterType: filterType,
            searchParamsString: searchParamsString
        }).then((response)=>{
            if (cancelled) return;
            setAccountSnapshot({
                groupId: String(accountRootId),
                filterType: filterType,
                searchParamsString: searchParamsString,
                ...(0, $09aa3d4abe0406ed$export$3e428e207129570)(response)
            });
        }).catch(()=>{
            if (!cancelled) setAccountSnapshot(null);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        enabled,
        accountRootId,
        groupMatches,
        groupSnapshot,
        setAccountSnapshot
    ]);
    const accountCount = accountRootId != null && accountSnapshot && accountSnapshot.groupId === String(accountRootId) ? accountSnapshot : null;
    const other = scope?.narrower && accountCount && groupSnapshot && groupMatches ? (0, $9fba8663fe17aa61$export$7038b1c7d7f32a4b)(accountCount.itemCount, groupSnapshot.itemCount, accountCount.limited, groupSnapshot.limited) : null;
    return {
        scope: scope,
        other: other,
        minStartTimestamp: groupMatches && groupSnapshot ? groupSnapshot.minStartTimestamp : null
    };
};



// Function to swap MM/DD in a date string
const $e9636137eea334cc$var$formatDateBasedOnPreference = (dateString, isMMDDYYYY)=>{
    if (isMMDDYYYY) return dateString; // Return original format if MM/DD/YYYY is preferred
    // Parse the date string - expected format: "MM/DD/YYYY, HH:MM:SS AM/PM"
    const parts = dateString.split(", ");
    if (parts.length !== 2) return dateString; // Return original if format is unexpected
    const datePart = parts[0];
    const timePart = parts[1];
    // Split the date part by "/"
    const dateSections = datePart.split("/");
    if (dateSections.length !== 3) return dateString; // Return original if format is unexpected
    // Swap month and day
    const [month, day, year] = dateSections;
    const swappedDatePart = `${day}/${month}/${year}`;
    // Return the swapped date with the original time
    return `${swappedDatePart}, ${timePart}`;
};
const $e9636137eea334cc$export$9960d810154cf987 = (scrollTop, scrollHeight, clientHeight, scrollAwayThresholdPx = 8)=>{
    const canScroll = scrollHeight > clientHeight + 1;
    return canScroll && scrollTop > scrollAwayThresholdPx;
};
const $e9636137eea334cc$export$8ca283aa6f9cad20 = (container, rowEl)=>{
    const containerRect = container.getBoundingClientRect();
    const rowRect = rowEl.getBoundingClientRect();
    const headerHeight = container.querySelector("thead")?.getBoundingClientRect().height ?? 0;
    const visibleTop = containerRect.top + headerHeight;
    if (rowRect.top < visibleTop) container.scrollTop -= visibleTop - rowRect.top;
    else if (rowRect.bottom > containerRect.bottom) container.scrollTop += rowRect.bottom - containerRect.bottom;
};
const $e9636137eea334cc$var$compactTablePaginationSx = {
    "& .MuiTablePagination-toolbar": {
        minHeight: "36px",
        paddingLeft: "0",
        paddingRight: "4px",
        // Let "Rows per page" drop onto its own line rather than pushing the
        // page arrows past the card edge when the table column is narrow.
        flexWrap: "wrap",
        justifyContent: "flex-end"
    },
    "& .MuiTablePagination-spacer": {
        display: "none"
    },
    "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiTablePagination-select": {
        fontSize: "12px",
        fontFamily: "Mulish"
    }
};
/**
 * Tile colors per bucket (ENG-1756): the working queue is the orange primary,
 * All is neutral, and the two verdict buckets reuse the Likely TP green /
 * Likely FP red (the False outcome button's red) that the row indicators use.
 */ const $e9636137eea334cc$var$VLM_TILE_PALETTE = {
    "Filtered Queue": {
        idle: "border-actuate-orange/35 bg-actuate-orange/10 text-actuate-orange",
        active: "border-actuate-orange bg-actuate-orange text-white"
    },
    All: {
        idle: "border-[#6B7280]/35 bg-[#6B7280]/10 text-actuate-blue",
        active: "border-[#6B7280] bg-[#6B7280] text-white"
    },
    "Likely TP": {
        idle: "border-[#2E7D32]/35 bg-[#2E7D32]/10 text-[#2E7D32]",
        active: "border-[#2E7D32] bg-[#2E7D32] text-white"
    },
    "Likely FP": {
        idle: "border-[#D32F2F]/35 bg-[#D32F2F]/10 text-[#D32F2F]",
        active: "border-[#D32F2F] bg-[#D32F2F] text-white"
    },
    // ENG-1599: alerts the connector withheld from Immix/Patriot on the verdict.
    Withheld: {
        idle: "border-[#7d2e72]/35 bg-[#7d2e72]/10 text-[#7d2e72]",
        active: "border-[#7d2e72] bg-[#7d2e72] text-white"
    }
};
const $e9636137eea334cc$export$90d89a9276091a91 = ({ tableBodyHeight: tableBodyHeight = "550px", fillAvailableHeight: fillAvailableHeight = false, selected: selected, alertData: alertData, setAlertData: setAlertData, setSelected: setSelected, selectedRow: selectedRow, setSelectedRow: setSelectedRow, setSelectedButtonsFilled: setSelectedButtonsFilled, setSeeMoreURL: setSeeMoreURL, navigate: navigate, setMP4URL: setMP4URL, page: page, setPage: setPage, pageSyncedKeyRef: pageSyncedKeyRef, userFilters: userFilters, setFetchingFilteredData: setFetchingFilteredData, setUserFilters: setUserFilters, setThumbnailVideos: setThumbnailVideos, setDateOutsideRange: setDateOutsideRange, setVideoClipLoading: setVideoClipLoading, setAlertsToDisplay: setAlertsToDisplay, setPageLoading: setPageLoading, setSelectedAlertCameraInfo: setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert: setIgnoreZonesSelectedAlert, setAlertsIndexOrder: setAlertsIndexOrder, setRefreshInterval: setRefreshInterval, currentName: currentName, setCurrentName: setCurrentName, pageLoadedNumber: pageLoadedNumber, setPageLoadedNumber: setPageLoadedNumber, setRefreshingData: setRefreshingData, cameraOptions: cameraOptions, siteOptions: siteOptions, scrollToTop: scrollToTop, refreshingToken: refreshingToken, setRefreshingToken: setRefreshingToken, setAlertLabels: setAlertLabels, alertLabels: alertLabels, detectionType: detectionType, setDetectionType: setDetectionType, setPeriodHours: setPeriodHours, setQueryLimitHit: setQueryLimitHit, searchParams: searchParams, setSearchParams: setSearchParams, refreshInterval: refreshInterval, outcomeFilterType: outcomeFilterType, setOutcomeFilterType: setOutcomeFilterType, setBackArrowDisabled: setBackArrowDisabled, setForwardArrowDisabled: setForwardArrowDisabled, setShowRefreshButton: setShowRefreshButton, setRowsSortable: setRowsSortable, rowsSortable: rowsSortable, setAlertsRefreshing: setAlertsRefreshing, alertsRefreshing: alertsRefreshing, getCurrentSelectedRowKey: getCurrentSelectedRowKey, setVideoProcessing: setVideoProcessing, useAsyncGeneration: useAsyncGeneration, setSelectedRowRef: setSelectedRowRef, vlmFilterType: vlmFilterType, setVlmFilterType: setVlmFilterType, tableDensity: tableDensity = "detailed", onDensityChange: onDensityChange, periodHours: periodHours = 2, filtersApplied: filtersApplied = false, parentAccounts: parentAccounts = [], onTableSortChange: onTableSortChange })=>{
    const { flags: flags } = (0, $4PFLW.useFeatureFlag)();
    // The flag enables DoubleTake; the tiles, DT Verdict column and chips only
    // render when the alerts in view include a DoubleTake camera. Alerts.tsx
    // derives the same value, so the applied tile filter and the tiles agree.
    const showVlmFilters = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>Boolean(flags.showVlmFilters) && (0, $biDrR.hasDoubleTakeInAlerts)(alertData), [
        flags.showVlmFilters,
        alertData
    ]);
    // ENG-1842: archived-range reports need the whole backend chain live (Athena
    // workgroup + IAM + Glue mirror view + ATHENA_REPORTS_WORKGROUP on the pod).
    // Until then download_v2 takes the DynamoDB path for old ranges and returns a
    // headers-only CSV — worse than no button — so the notice ships dark behind
    // this flag and is flipped on per environment after backend activation.
    const showArchivedReports = Boolean(flags.showArchivedAlertReports);
    const showAlertsScopeContext = Boolean(flags.showAlertsScopeContext);
    const showTroubleshootingPage = Boolean(flags.showTroubleshootingPage);
    const appliedGroupId = showAlertsScopeContext && typeof searchParams?.get === "function" ? searchParams.get("group") : null;
    const { scope: scope, other: other, minStartTimestamp: minStartTimestamp } = (0, $d0ff96bb2de1a237$export$e81b059015aec241)({
        enabled: showAlertsScopeContext,
        parentAccounts: parentAccounts,
        appliedGroupId: appliedGroupId
    });
    const hasSiteOrCameraFilter = Boolean(typeof searchParams?.get === "function" && searchParams.get("site") || typeof searchParams?.get === "function" && searchParams.get("camera"));
    const scopeEmptyCopy = showAlertsScopeContext && filtersApplied ? (0, $9fba8663fe17aa61$export$8af2a9dd09e8638a)({
        narrower: Boolean(scope?.narrower),
        groupName: scope?.selected?.name ?? null,
        accountName: scope?.accountRoot?.name ?? null,
        sinceLabel: (0, $9fba8663fe17aa61$export$5c554dd96f80bfe7)({
            minStartTimestamp: minStartTimestamp,
            startDate: userFilters?.start_date,
            startTime: userFilters?.start_time,
            periodHours: Number(periodHours) || 2
        }),
        other: other,
        hasSiteOrCameraFilter: hasSiteOrCameraFilter
    }) : null;
    const showOutcomeFilter = currentName === "Resolved Alerts";
    const [order, setOrder] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("asc");
    const [orderBy, setOrderBy] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    // Lazy-read from storage: the parent remounts this table on every list
    // refresh, so plain useState(25) reset the user's choice (SUP-510).
    const [rowsPerPage, setRowsPerPage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState((0, $71280fd12553052d$export$bd12d67f855cad71));
    const { dateMMDDYYYY: dateMMDDYYYY, setDateMMDDYYYY: setDateMMDDYYYY, userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    const viewAlertMuting = userPermissions.alert_muting;
    const { mutedAlertSites: mutedAlertSites, mutedAlertCameras: mutedAlertCameras, setSeeMutedSiteAndCamerasDialogOpen: setSeeMutedSiteAndCamerasDialogOpen, handleSubmitMutedAlert: handleSubmitMutedAlert } = (0, $a4c0e7e0c5cf28c3$export$52a528b1f45cfa42)();
    // Set by the alert fetchers when /monitoring-api/alert/ fails (SUP-445).
    const fetchError = (0, $ffd916f32bf91472$export$c0092f66ffb2a592)((state)=>state.fetchError);
    const fetchErrorMessage = fetchError ? `Alerts could not be loaded${fetchError.status ? ` (HTTP ${fetchError.status})` : ""}. Try applying the filters again; if this keeps happening, contact support.` : null;
    const isCondensed = tableDensity === "condensed";
    const [anchorEl, setAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [footerMenuAnchor, setFooterMenuAnchor] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const open = Boolean(anchorEl);
    const footerMenuOpen = Boolean(footerMenuAnchor);
    const handleClick = (event)=>{
        event.stopPropagation(); // Stop event propagation to prevent table sorting
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (event)=>{
        event.stopPropagation(); // Stop event propagation to prevent table sorting
        setAnchorEl(null);
    };
    const [count, setCount] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(alertData.length);
    // ENG-1842 review: the fetched report URL is keyed to the filters it was
    // fetched FOR — after a range/site/camera change the button must fetch again,
    // never hand back the previous filter set's CSV.
    const [fetchedReport, setFetchedReport] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [isFetchingReport, setIsFetchingReport] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const reportAbortRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(true);
    const reportKey = JSON.stringify([
        userFilters.parent_group,
        userFilters.site,
        userFilters.camera,
        (0, $5L5iJ.yyyymmddGenerator)(userFilters.start_date),
        (0, $5L5iJ.yyyymmddGenerator)(userFilters.end_date),
        userFilters.start_time,
        userFilters.end_time
    ]);
    const reportDownloadUrl = fetchedReport?.key === reportKey ? fetchedReport.url : null;
    // Mirrors getAlertsDownloadURL's own "send camera_id" condition: when a
    // camera filter would be sent, an archived-range report is a guaranteed 400
    // (the mirror has no camera ids), so the CTA is replaced with an explanation.
    const reportCameraFilterActive = Boolean(userFilters.camera) && String(userFilters.camera) !== "undefined" && String(userFilters.camera) !== "";
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        // Filter change (or unmount, via the effect below): abort any in-flight
        // report poll — its URL would belong to a filter set the user has left.
        // The server-side report still completes and is reused when re-requested
        // (the backend keys the Athena query on the request parameters).
        return ()=>{
            reportAbortRef.current?.abort();
            reportAbortRef.current = null;
        };
    }, [
        reportKey
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    const handleRequestSort = (event, property)=>{
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };
    const handleChangePage = (event, newPage)=>{
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event)=>{
        const nextRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(nextRowsPerPage);
        (0, $71280fd12553052d$export$638aeec760a77a58)(nextRowsPerPage);
        setPage(0);
    };
    const theme = (0, $cFPmV.default)({
        palette: {
            primary: {
                main: "#FF8400"
            }
        }
    });
    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - alertData.length) : 0;
    /**
   * Every row filter except DoubleTake: muted, Type and Outcome.
   *
   * This is the input both the table rows and the DoubleTake tile counts are
   * built from, so a tile count and the rows that tile shows can never be
   * drawn from different populations (ENG-1756). Counting before Type/Outcome
   * let a tile read "Likely TP 12" while the table showed none.
   */ const getRowsBeforeVlmFilter = (alertData, detectionType, outcomeFilterType)=>(0, $6e02db388b82b823$export$6ee189a072663b57)({
            alertData: alertData,
            detectionType: detectionType,
            outcomeFilterType: outcomeFilterType,
            mutedAlertSites: mutedAlertSites,
            mutedAlertCameras: mutedAlertCameras,
            filterType: userFilters?.filter_type
        });
    const checkRowsForFilter = (alertData, detectionType, outcomeFilterType, currentVlmFilterType)=>{
        const baseRows = getRowsBeforeVlmFilter(alertData, detectionType, outcomeFilterType);
        return showVlmFilters ? (0, $biDrR.applyVlmFilter)(baseRows, currentVlmFilterType) : baseRows;
    };
    const filteredRows = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>checkRowsForFilter(alertData, detectionType, outcomeFilterType, vlmFilterType), [
        alertData,
        detectionType,
        outcomeFilterType,
        mutedAlertSites,
        mutedAlertCameras,
        showVlmFilters,
        vlmFilterType
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setCount(filteredRows.length);
    }, [
        filteredRows
    ]);
    const sortedRows = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>(0, $6e02db388b82b823$export$cdfae0e972447b21)({
            alertData: alertData,
            detectionType: detectionType,
            outcomeFilterType: outcomeFilterType,
            vlmFilterType: vlmFilterType,
            showVlmFilters: showVlmFilters,
            mutedAlertSites: mutedAlertSites,
            mutedAlertCameras: mutedAlertCameras,
            filterType: userFilters?.filter_type,
            order: order,
            orderBy: orderBy
        }), [
        alertData,
        detectionType,
        outcomeFilterType,
        vlmFilterType,
        showVlmFilters,
        mutedAlertSites,
        mutedAlertCameras,
        userFilters?.filter_type,
        order,
        orderBy
    ]);
    const visibleRows = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage), [
        sortedRows,
        page,
        rowsPerPage
    ]);
    // Follow the selection. Keyboard / arrow / auto-advance navigation changes
    // selectedRow without touching the table, and background refreshes remount
    // it (page and scroll reset), so the alert being viewed could sit on
    // another page or outside the scroll viewport. Whenever the selected alert
    // changes (or the table mounts) flip to its page, then nudge the scroll
    // container just enough to show its row under the sticky header. Manual
    // paging is respected: the page is only synced when the selection changes.
    //
    // The two memories live in different places on purpose. A remount resets the
    // scroll position, so "already scrolled to this row" is per mount and the row
    // is nudged back into view each time. It does NOT reset `page` (the parent
    // owns it), so "already synced to this selection" must be the parent's too:
    // held here, every refresh that found new alerts read as a new selection and
    // pulled an operator who had paged away back to the selected alert's page.
    const tableContainerRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const selectedRowKey = selectedRow ? (0, $f3879d0f44faa78a$export$9eec69cddf174afd)(selectedRow) : null;
    const localPageSyncedKeyRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const lastPageSyncedKeyRef = pageSyncedKeyRef ?? localPageSyncedKeyRef;
    const lastScrolledKeyRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    // Viewport anchor for the selected row: where it sat relative to the scroll
    // container the last time it was rendered (null = not on the displayed
    // page). When a background refresh prepends new alerts, the row shifts down
    // the list; we put it back at the same offset (or follow it onto the next
    // page) so the operator's view doesn't jump. Only applied when the *data*
    // changed, never for the user's own sort / paging / scrolling.
    const anchorRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef({
        key: null,
        offset: null
    });
    const prevAlertDataRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(alertData);
    const pendingAnchorRestoreRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(false);
    const getSelectedRowOffset = ()=>{
        const container = tableContainerRef.current;
        const rowEl = container?.querySelector('[data-alert-row-selected="true"]');
        if (!container || !rowEl) return null;
        return rowEl.getBoundingClientRect().top - container.getBoundingClientRect().top;
    };
    const recordAnchor = ()=>{
        anchorRef.current = {
            key: selectedRowKey,
            offset: getSelectedRowOffset()
        };
    };
    // Floating jump back to the newest alerts (top of page 1) once the operator
    // has scrolled the list or paged away. New rows still land in the table
    // immediately; this only offers a way back to the top.
    const [showNewestAlertsButton, setShowNewestAlertsButton] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const scrollingToNewestRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(false);
    const updateNewestAlertsButtonVisibility = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback(()=>{
        const el = tableContainerRef.current;
        const scrolledAway = el ? $e9636137eea334cc$export$9960d810154cf987(el.scrollTop, el.scrollHeight, el.clientHeight) : false;
        if (scrollingToNewestRef.current) {
            if (page === 0 && !scrolledAway) scrollingToNewestRef.current = false;
            else {
                setShowNewestAlertsButton(false);
                return;
            }
        }
        setShowNewestAlertsButton(page > 0 || scrolledAway);
    }, [
        page
    ]);
    const handleTableScroll = ()=>{
        recordAnchor();
        updateNewestAlertsButtonVisibility();
    };
    const handleScrollToNewestAlerts = ()=>{
        scrollingToNewestRef.current = true;
        if (page !== 0) setPage(0);
        const el = tableContainerRef.current;
        if (el) el.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        setShowNewestAlertsButton(false);
    };
    const selectedSortedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>selectedRowKey ? sortedRows.findIndex((row)=>(0, $f3879d0f44faa78a$export$9eec69cddf174afd)(row) === selectedRowKey) : -1, [
        sortedRows,
        selectedRowKey
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useLayoutEffect(()=>{
        const dataChanged = prevAlertDataRef.current !== alertData;
        prevAlertDataRef.current = alertData;
        if (!selectedRowKey || selectedSortedIndex < 0) return;
        const targetPage = Math.floor(selectedSortedIndex / rowsPerPage);
        if (lastPageSyncedKeyRef.current !== selectedRowKey) {
            // Selection changed (keyboard / arrows / click / auto-advance).
            lastPageSyncedKeyRef.current = selectedRowKey;
            pendingAnchorRestoreRef.current = false;
            if (targetPage !== page) {
                setPage(targetPage);
                return; // re-runs once the page renders
            }
        } else if ((dataChanged || pendingAnchorRestoreRef.current) && anchorRef.current.key === selectedRowKey && anchorRef.current.offset !== null) {
            // Same selection, new data (background refresh): the row was on screen
            // before, keep it exactly where it was.
            if (targetPage !== page) {
                pendingAnchorRestoreRef.current = true;
                setPage(targetPage);
                return; // re-runs once the page renders, then restores the offset
            }
            pendingAnchorRestoreRef.current = false;
            const container = tableContainerRef.current;
            const currentOffset = getSelectedRowOffset();
            if (container && currentOffset !== null) {
                const delta = currentOffset - anchorRef.current.offset;
                if (Math.abs(delta) >= 1) container.scrollTop += delta;
            }
            recordAnchor();
            return;
        }
        if (lastScrolledKeyRef.current !== selectedRowKey) {
            const container = tableContainerRef.current;
            const rowEl = container?.querySelector('[data-alert-row-selected="true"]');
            if (container && rowEl) {
                lastScrolledKeyRef.current = selectedRowKey;
                $e9636137eea334cc$export$8ca283aa6f9cad20(container, rowEl);
            }
        }
        recordAnchor();
    }, [
        alertData,
        selectedRowKey,
        selectedSortedIndex,
        page,
        rowsPerPage,
        setPage,
        lastPageSyncedKeyRef
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useLayoutEffect(()=>{
        updateNewestAlertsButtonVisibility();
    }, [
        updateNewestAlertsButtonVisibility,
        alertData,
        visibleRows,
        page,
        rowsPerPage,
        tableDensity,
        fillAvailableHeight,
        tableBodyHeight
    ]);
    // Tile counts come from the same rows the table is built from, minus the
    // DoubleTake filter itself — so each tile counts what clicking it shows.
    const queueRows = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>getRowsBeforeVlmFilter(alertData, detectionType, outcomeFilterType), [
        alertData,
        detectionType,
        outcomeFilterType,
        mutedAlertSites,
        mutedAlertCameras,
        userFilters?.filter_type
    ]);
    const queueCounts = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>(0, $biDrR.getVlmQueueCounts)(queueRows), [
        queueRows
    ]);
    const vlmPassedCount = queueCounts.passed;
    // Auto-resolve incoming muted alerts. Only from the live (Unresolved)
    // queue — rows in the Resolved/All views are already resolved, and
    // re-submitting outcomes for them would post duplicates on every fetch.
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!(0, $94e6bb80767641a9$export$a2c9a5662351211)(userFilters?.filter_type)) return;
        // Resolving is an outcome write; users without set_alert_outcome (View
        // Only) would only collect 403s (ENG-1813).
        if (!(0, $c0b3a83d600c7aa1$export$544f58273da8c441)(userPermissions)) return;
        if (alertData.length > 0) {
            const mutedAlerts = alertData.filter((row)=>(0, $94e6bb80767641a9$export$1874ac93f6160b49)(row, mutedAlertSites, mutedAlertCameras));
            mutedAlerts.forEach((mutedAlert)=>{
                handleSubmitMutedAlert(mutedAlert, navigate);
            });
        }
    }, [
        alertData,
        mutedAlertSites,
        mutedAlertCameras,
        userFilters?.filter_type,
        userPermissions
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        (0, $8ac871b862929cdd$export$826adfa26b8f8d30)((0, $fWsn7.stableSort)(alertData, (0, $fWsn7.getComparator)(order, orderBy)), setAlertsIndexOrder, alertData, setAlertData, "alerts", detectionType);
    }, [
        order,
        visibleRows
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        localStorage.setItem("alertsTableOrder", order);
        if (orderBy === "utc_time") localStorage.setItem("alertsTableOrderBy", "clip_header_received");
        else if (orderBy === "time") localStorage.setItem("alertsTableOrderBy", "clip_received_local");
        else if (orderBy === "site") localStorage.setItem("alertsTableOrderBy", "customer_name");
        else if (orderBy === "formatted_date") localStorage.setItem("alertsTableOrderBy", "approx_capture_timestamp");
        else localStorage.setItem("alertsTableOrderBy", orderBy);
        onTableSortChange?.(order, orderBy);
    }, [
        order,
        orderBy,
        onTableSortChange
    ]);
    const currentSelectedRowKeyGetter = getCurrentSelectedRowKey ?? (()=>null);
    const handleHasVideoToggle = (event, checked)=>{
        const nextFilters = {
            ...userFilters,
            has_video: checked
        };
        let newNumber = Number(pageLoadedNumber);
        newNumber += 1;
        setPageLoadedNumber(newNumber);
        localStorage.setItem("pageLoadedNumber", `${newNumber}`);
        localStorage.setItem("latestAlertFilters", JSON.stringify(nextFilters));
        setPage(0);
        setFetchingFilteredData(true);
        setUserFilters(nextFilters);
        (0, $361dd3e7be612e92$export$59b2b76630cf930b)(nextFilters, searchParams, setSearchParams, detectionType);
        (0, $8bebe2f317b7d60b$export$f0c03502af15d107)(setAlertData, navigate, setSelectedRow, setFetchingFilteredData, setSeeMoreURL, setMP4URL, userFilters.parent_group, userFilters.site, userFilters.camera, (0, $5L5iJ.yyyymmddGenerator)(userFilters.start_date), (0, $5L5iJ.yyyymmddGenerator)(userFilters.end_date), userFilters.start_time, userFilters.end_time, userFilters.filter_type, setSelectedButtonsFilled, setThumbnailVideos, setDateOutsideRange, setPage, setVideoClipLoading, setAlertsToDisplay, setPageLoading, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, setAlertsIndexOrder, setRefreshInterval, setCurrentName, setUserFilters, setRefreshingData, newNumber, refreshInterval, nextFilters, cameraOptions, siteOptions, setRefreshingToken, refreshingToken, setAlertLabels, setPeriodHours, setQueryLimitHit, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setRowsSortable, setAlertsRefreshing, currentSelectedRowKeyGetter, mutedAlertSites, mutedAlertCameras, setVideoProcessing);
    };
    const handleDownloadReportClick = async ()=>{
        if (reportDownloadUrl) {
            (0, $iIAML.saveAs)(reportDownloadUrl, "report.csv");
            return;
        }
        reportAbortRef.current?.abort();
        const controller = new AbortController();
        reportAbortRef.current = controller;
        const keyAtFetch = reportKey;
        try {
            setIsFetchingReport(true);
            const downloadUrl = await (0, $25ae21820f1aa870$export$cecea10c8580a141)(userFilters.parent_group, userFilters.site, userFilters.camera, (0, $5L5iJ.yyyymmddGenerator)(userFilters.start_date), (0, $5L5iJ.yyyymmddGenerator)(userFilters.end_date), userFilters.start_time, userFilters.end_time, controller.signal);
            if (mountedRef.current) setFetchedReport({
                key: keyAtFetch,
                url: downloadUrl
            });
        } catch (error) {
            const name = error?.name;
            const code = error?.code;
            if (name === "AbortError" || name === "CanceledError" || code === "ERR_CANCELED") return; // user changed filters / left the page — not an error
            // Surface the backend's actionable detail (e.g. "camera filters are not
            // supported for ranges older than 60 days", "alert history begins
            // 2026-04-28…") instead of a generic shrug.
            const detail = error?.response?.data?.detail;
            // Only once the archived-range feature is on: before that the old copy
            // stands, and an axios message like "Request failed with status code
            // 500" is no help to a customer.
            alert(showArchivedReports ? detail || error?.message || "Unable to download report" : "Unable to download report");
        } finally{
            if (mountedRef.current) setIsFetchingReport(false);
        }
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4reBM.default), {
        className: `w-full ${fillAvailableHeight ? "flex h-full min-h-0 flex-col" : ""}`,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: `flex shrink-0 flex-col gap-2 ${fillAvailableHeight ? "pt-2" : "relative top-[8px]"} ${isCondensed ? "pb-1" : ""}`,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "flex items-start justify-between gap-2 px-[15px] pr-[5px] pt-3",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: (0, $30e263c4a2b86f06$export$b19352cbfd0048a7),
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $9bccc5797fb1948e$export$9a4e1638c9039348), {
                                        userFilters: userFilters,
                                        setFetchingFilteredData: setFetchingFilteredData,
                                        setAlertData: setAlertData,
                                        navigate: navigate,
                                        setSelectedRow: setSelectedRow,
                                        setSeeMoreURL: setSeeMoreURL,
                                        setMP4URL: setMP4URL,
                                        setUserFilters: setUserFilters,
                                        setSelectedButtonsFilled: setSelectedButtonsFilled,
                                        setThumbnailVideos: setThumbnailVideos,
                                        setDateOutsideRange: setDateOutsideRange,
                                        setPage: setPage,
                                        setVideoClipLoading: setVideoClipLoading,
                                        setAlertsToDisplay: setAlertsToDisplay,
                                        setPageLoading: setPageLoading,
                                        setSelectedAlertCameraInfo: setSelectedAlertCameraInfo,
                                        setIgnoreZonesSelectedAlert: setIgnoreZonesSelectedAlert,
                                        setAlertsIndexOrder: setAlertsIndexOrder,
                                        setRefreshInterval: setRefreshInterval,
                                        currentName: currentName,
                                        setCurrentName: setCurrentName,
                                        pageLoadedNumber: pageLoadedNumber,
                                        setPageLoadedNumber: setPageLoadedNumber,
                                        setRefreshingData: setRefreshingData,
                                        cameraOptions: cameraOptions,
                                        siteOptions: siteOptions,
                                        setRefreshingToken: setRefreshingToken,
                                        refreshingToken: refreshingToken,
                                        setAlertLabels: setAlertLabels,
                                        setPeriodHours: setPeriodHours,
                                        setQueryLimitHit: setQueryLimitHit,
                                        searchParams: searchParams,
                                        setSearchParams: setSearchParams,
                                        detectionType: detectionType,
                                        refreshInterval: refreshInterval,
                                        setOutcomeFilterType: setOutcomeFilterType,
                                        setForwardArrowDisabled: setForwardArrowDisabled,
                                        setBackArrowDisabled: setBackArrowDisabled,
                                        setShowRefreshButton: setShowRefreshButton,
                                        setRowsSortable: setRowsSortable,
                                        setAlertsRefreshing: setAlertsRefreshing,
                                        getCurrentSelectedRowKey: currentSelectedRowKeyGetter,
                                        setVideoProcessing: setVideoProcessing
                                    }),
                                    showOutcomeFilter && /*#__PURE__*/ (0, $k4ank.jsx)((0, $4e015c4ebef076fb$export$abca0dbb54977a6f), {
                                        outcomeFilterType: outcomeFilterType,
                                        setOutcomeFilterType: setOutcomeFilterType,
                                        setPage: setPage
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $536ac5479298ea5c$export$477348a21311abc1), {
                                        alertLabels: alertLabels,
                                        detectionType: detectionType,
                                        setDetectionType: setDetectionType,
                                        userFilters: userFilters,
                                        searchParams: searchParams,
                                        setSearchParams: setSearchParams,
                                        setPage: setPage
                                    })
                                ]
                            }),
                            onDensityChange && /*#__PURE__*/ (0, $k4ank.jsx)((0, $33baa4d90519a2f0$export$cfc13311b9039b69), {
                                density: tableDensity,
                                onDensityChange: onDensityChange
                            })
                        ]
                    }),
                    showVlmFilters && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "grid grid-cols-5 gap-2 px-[15px]",
                        children: (0, $biDrR.VLM_FILTER_ORDER).map((filterOption)=>{
                            const isActive = vlmFilterType === filterOption;
                            const label = (0, $biDrR.VLM_FILTER_LABELS)[filterOption];
                            const count = (0, $biDrR.getVlmFilterCount)(queueCounts, filterOption);
                            const palette = $e9636137eea334cc$var$VLM_TILE_PALETTE[filterOption];
                            return /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
                                type: "button",
                                "aria-pressed": isActive,
                                "aria-label": `${label} (${count})`,
                                className: `min-w-0 overflow-hidden rounded border px-1 py-1 text-center ${isActive ? palette.active : palette.idle}`,
                                onClick: ()=>{
                                    setVlmFilterType(filterOption);
                                    setPage(0);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "font-mulish text-[16px] font-bold leading-none",
                                        children: count
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "min-w-0 pt-[2px] font-mulish text-[9px] font-bold uppercase leading-tight tracking-normal break-words",
                                        children: label
                                    })
                                ]
                            }, filterOption);
                        })
                    }),
                    !isCondensed && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "pl-[15px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                            sx: {
                                color: "#001943",
                                "& .MuiFormControlLabel-label": {
                                    fontFamily: "Mulish",
                                    fontSize: "12px"
                                }
                            },
                            label: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                        children: "Completed Alerts Only"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                        title: `Selecting this option shows alerts only after their processing window has closed. If unchecked, alerts appear as soon as they are dispatched, and temporary (usually shorter) clips will be created until processing is complete.`,
                                        placement: "top",
                                        sx: {
                                            fontSize: "12px",
                                            fontFamily: "mulish"
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                            className: "ml-[4px] flex items-center",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                                sx: {
                                                    fontSize: "12px"
                                                }
                                            })
                                        })
                                    })
                                ]
                            }),
                            control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                color: "warning",
                                checked: Boolean(userFilters?.has_video),
                                onChange: handleHasVideoToggle
                            })
                        })
                    })
                ]
            }),
            fetchErrorMessage && alertData.length > 0 && // Rows from the previous successful fetch are still on screen, so the
            // empty-state message below won't show — flag the stale data here.
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                role: "alert",
                className: "font-mulish text-[14px] text-red-700 bg-red-50 border border-red-200 rounded px-[12px] py-[8px] mx-[8px] mb-[8px]",
                children: [
                    fetchErrorMessage,
                    " The list below may be out of date."
                ]
            }),
            showArchivedReports && filtersApplied && alertData.length > 0 && (0, $74572e7331880165$export$c5ba5169ea3216c8)(userFilters.start_date) && // ENG-1842: a range straddling the retention horizon renders only
            // its most recent ~60 days here — without this banner the older part
            // is silently missing, which reads as a bug. The report download
            // includes the full range (the backend merges the archived part from
            // the Athena mirror with the recent DynamoDB tail).
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                role: "status",
                className: "font-mulish text-[14px] text-actuate-blue bg-blue-50 border border-blue-200 rounded px-[12px] py-[8px] mx-[8px] mb-[8px]",
                children: [
                    "Alerts older than ",
                    (0, $74572e7331880165$export$b251626c1ee2fc7a),
                    " days are not shown in this list. The report download includes the full selected range."
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: fillAvailableHeight ? "relative flex min-h-0 flex-1 flex-col" : "relative",
                children: [
                    showNewestAlertsButton && /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
                        type: "button",
                        "data-testid": "newest-alerts-button",
                        onClick: handleScrollToNewestAlerts,
                        className: "absolute left-1/2 top-10 z-20 flex -translate-x-1/2 items-center gap-0.5 rounded-full border border-actuate-blue/15 bg-white px-2.5 py-1 font-mulish text-[12px] font-semibold text-actuate-blue shadow-md hover:bg-[#F5F8FC]",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g0plP))), {
                                sx: {
                                    fontSize: 17
                                }
                            }),
                            "Newest Alerts"
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                        ref: tableContainerRef,
                        onScroll: handleTableScroll,
                        sx: fillAvailableHeight ? {
                            flex: 1,
                            minHeight: 0,
                            overflow: "auto"
                        } : {
                            height: tableBodyHeight,
                            overflowX: "auto"
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                            sx: {
                                fontFamily: "Mulish",
                                tableLayout: "fixed",
                                "& .MuiTableHead-root .MuiTableCell-root": {
                                    whiteSpace: "nowrap"
                                },
                                "& .MuiTableHead-root .MuiTableSortLabel-root": {
                                    whiteSpace: "nowrap"
                                }
                            },
                            "aria-labelledby": "tableTitle",
                            stickyHeader: true,
                            size: "small",
                            children: [
                                isCondensed ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            sx: {
                                                py: 0.75,
                                                px: 1.5,
                                                fontFamily: "Mulish",
                                                fontWeight: 700,
                                                fontSize: 12,
                                                backgroundColor: "#fff",
                                                borderBottom: "1px solid #E5E5E5"
                                            },
                                            children: `${(0, $36f1c5bc563bba72$export$efed371f2d8fd411)({
                                                periodHours: periodHours,
                                                userFilters: userFilters
                                            })} \xb7 ${(0, $36f1c5bc563bba72$export$81ac7c18264f7cd8)(filteredRows)} unresolved`
                                        })
                                    })
                                }) : rowsSortable ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $4c3639747a19c087$export$70718678ea0eb7ea), {
                                    onRequestSort: handleRequestSort,
                                    orderBy: orderBy,
                                    order: order,
                                    showVlmVerdictColumn: showVlmFilters
                                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: (0, $d09f1be34538e2b9$export$a1e42d23e9171cb5)
                                            }),
                                            [
                                                "Site",
                                                "Camera",
                                                "Site's Time",
                                                "Type",
                                                "Detection",
                                                ...showVlmFilters ? [
                                                    "DT Verdict"
                                                ] : []
                                            ].map((title)=>{
                                                return /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    align: "left",
                                                    style: {
                                                        width: `20%`
                                                    },
                                                    sx: {
                                                        fontFamily: "mulish",
                                                        fontWeight: 700,
                                                        fontSize: 10
                                                    },
                                                    children: title === "Site's Time" ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                        className: "flex shrink-0 whitespace-nowrap",
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                                                                children: `Site Time`
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                                                        "aria-label": "more",
                                                                        id: "long-button",
                                                                        "aria-controls": open ? "long-menu" : undefined,
                                                                        "aria-expanded": open ? "true" : undefined,
                                                                        "aria-haspopup": "true",
                                                                        onClick: handleClick,
                                                                        sx: {
                                                                            width: "18px",
                                                                            height: "18px",
                                                                            padding: "0px"
                                                                        },
                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5MAs))), {
                                                                            sx: {
                                                                                fontSize: "18px"
                                                                            }
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                                                                        id: "long-menu",
                                                                        MenuListProps: {
                                                                            "aria-labelledby": "long-button"
                                                                        },
                                                                        anchorOrigin: {
                                                                            vertical: "top",
                                                                            horizontal: "left"
                                                                        },
                                                                        transformOrigin: {
                                                                            vertical: "top",
                                                                            horizontal: "left"
                                                                        },
                                                                        anchorEl: anchorEl,
                                                                        open: open,
                                                                        onClose: handleClose,
                                                                        slotProps: {
                                                                            paper: {
                                                                                style: {
                                                                                    maxHeight: 216,
                                                                                    width: "20ch"
                                                                                }
                                                                            }
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                                                onClick: (event)=>{
                                                                                    setDateMMDDYYYY(true);
                                                                                    event.stopPropagation(); // Stop event propagation to prevent table sorting
                                                                                    handleClose(event);
                                                                                },
                                                                                children: "MM/DD/YYYY"
                                                                            }, "mm-dd-yyyy"),
                                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                                                onClick: (event)=>{
                                                                                    setDateMMDDYYYY(false);
                                                                                    event.stopPropagation(); // Stop event propagation to prevent table sorting
                                                                                    handleClose(event);
                                                                                },
                                                                                children: "DD/MM/YYYY"
                                                                            }, "dd-mm-yyyy")
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }) : title
                                                }, title);
                                            })
                                        ]
                                    })
                                }),
                                alertData.length === 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            colSpan: 99,
                                            align: "center",
                                            sx: {
                                                border: 0
                                            },
                                            children: fetchErrorMessage ? /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                role: "alert",
                                                className: "font-mulish text-[18px] pt-[60px] pb-[20px] text-center text-red-700",
                                                children: fetchErrorMessage
                                            }) : showArchivedReports && filtersApplied && (0, $74572e7331880165$export$c5ba5169ea3216c8)(userFilters.start_date) ? /* ENG-1842: rows past the retention window are gone from
                       DynamoDB, so the grid is empty by design — say so and
                       route to the Athena-backed report instead of looking
                       like a bug. Media is genuinely unavailable at this age
                       (frames expire at 14 days, MP4s archive at 60).
                       filtersApplied keeps the CTA from flashing during the
                       initial fetch, when alertData is empty while loading. */ /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                className: "pt-[60px] pb-[20px] text-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                                        role: "status",
                                                        className: "font-mulish text-[18px]",
                                                        children: [
                                                            "Alerts older than ",
                                                            (0, $74572e7331880165$export$b251626c1ee2fc7a),
                                                            " days are available as a report download only; media is no longer available."
                                                        ]
                                                    }),
                                                    reportCameraFilterActive ? /* The backend refuses camera filters for archived
                           ranges (the mirror has no camera ids) — offering the
                           button here is a guaranteed dead end. */ /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                        className: "font-mulish pt-[8px] text-[14px]",
                                                        children: "Camera filters are not available for archived ranges \u2014 clear the camera filter to fetch the report."
                                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                        onClick: handleDownloadReportClick,
                                                        disabled: isFetchingReport,
                                                        text: isFetchingReport ? "Generating report\u2026 this can take a few minutes" : reportDownloadUrl ? "Download Report" : "Fetch Report"
                                                    })
                                                ]
                                            }) : scopeEmptyCopy ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                className: "pt-[60px] pb-[20px] text-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                        role: "status",
                                                        className: "font-mulish text-[18px]",
                                                        children: scopeEmptyCopy
                                                    }),
                                                    showTroubleshootingPage && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                        className: "font-mulish pt-[8px]",
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                                                            to: "/troubleshooter",
                                                            className: "font-mulish text-[16px] text-actuate-orange underline",
                                                            children: "Check delivery"
                                                        })
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "font-mulish text-[18px] pt-[60px] pb-[20px] text-center",
                                                children: !userFilters.start_date && !userFilters.end_date && !userFilters.start_time && !userFilters.end_time ? "No recent alerts over the past 2 hours. Please apply date filters to see past alerts." : "No alerts to display for the selected filters."
                                            })
                                        })
                                    })
                                }),
                                alertData.length > 0 && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $gXvgZ.default), {
                                    children: [
                                        visibleRows.map((row, index)=>{
                                            const isRowSelected = selectedRow && (0, $f3879d0f44faa78a$export$9eec69cddf174afd)(selectedRow) === (0, $f3879d0f44faa78a$export$9eec69cddf174afd)(row);
                                            const rowResolved = (0, $36f1c5bc563bba72$export$a5dbe591b225e4c0)(row);
                                            let sx = {
                                                cursor: "pointer"
                                            };
                                            if (!row.seen && !rowResolved && !isRowSelected) sx = {
                                                cursor: "pointer",
                                                backgroundColor: "rgba(255, 132, 0, 0.08)"
                                            };
                                            if (isRowSelected) sx = {
                                                cursor: "pointer",
                                                backgroundColor: "rgba(2, 136, 209, 0.2)"
                                            };
                                            return /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                                                    theme: theme,
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                                        hover: true,
                                                        onClick: ()=>{
                                                            (0, $988d77d60168e773$export$2fd5d64b4d451d7b)(row, alertData, setAlertData, setSelectedButtonsFilled, setSeeMoreURL, navigate, setMP4URL, setVideoClipLoading, setSelectedRow, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, refreshingToken, visibleRows, setBackArrowDisabled, setForwardArrowDisabled, setShowRefreshButton, currentSelectedRowKeyGetter, setVideoProcessing, useAsyncGeneration, setSelectedRowRef);
                                                            scrollToTop();
                                                        },
                                                        tabIndex: -1,
                                                        sx: sx,
                                                        "data-alert-row-selected": isRowSelected ? "true" : undefined,
                                                        children: isCondensed ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            sx: {
                                                                fontFamily: "Mulish",
                                                                padding: 0,
                                                                borderBottom: "1px solid #E5E5E5"
                                                            },
                                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                className: "flex",
                                                                children: [
                                                                    rowResolved ? /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                        className: "flex w-7 shrink-0 items-center justify-center",
                                                                        children: (0, $485e51885dc90d99$export$a57fd01c1a4f0d20)(row.detection_type, row.engineering_outcome?.outcome_v2, row.dispatch_muted === true, (0, $biDrR.isAlertWithheldFromReceiver)(row))
                                                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                        className: "w-1 shrink-0",
                                                                        style: {
                                                                            backgroundColor: (0, $36f1c5bc563bba72$export$6a65cc9369fb4109)(row.alert_labels)
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                        className: "min-w-0 flex-1 px-2 py-1.5",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                                className: "flex items-start justify-between gap-2",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $4ba9d3b7f89da3b9$export$9f5e614342ed6b61), {
                                                                                        text: `${row.display_name || row.customer_name || ""} \xb7 ${row.camera_name || ""}`,
                                                                                        className: "min-w-0 flex-1 truncate font-mulish text-[12px] font-bold text-actuate-blue"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                                                        className: "shrink-0 font-mulish text-[11px] text-actuate-blue",
                                                                                        children: $e9636137eea334cc$var$formatDateBasedOnPreference(row.formatted_date, dateMMDDYYYY)
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                                className: "flex flex-wrap items-center gap-1 pt-1",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $46deb238b79847bd$export$baed8097318953ad), {
                                                                                        alertLabels: row.alert_labels
                                                                                    }),
                                                                                    showVlmFilters && /*#__PURE__*/ (0, $k4ank.jsx)((0, $e46e67fbb04d9482$export$29b7dd3aeaf1715b), {
                                                                                        row: row
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }) : /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    sx: (0, $d09f1be34538e2b9$export$a1e42d23e9171cb5),
                                                                    children: !row.seen && !rowResolved && /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6416eab92432523e$exports))), {
                                                                        fontSize: "small",
                                                                        color: "warning",
                                                                        sx: {
                                                                            display: "block",
                                                                            fontSize: 14
                                                                        }
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    sx: (0, $d09f1be34538e2b9$export$afc98fd3f390bb92),
                                                                    children: row.display_name ? row.display_name : row.customer_name
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    sx: (0, $d09f1be34538e2b9$export$afc98fd3f390bb92),
                                                                    children: row.camera_name
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    sx: {
                                                                        fontSize: "11.5px",
                                                                        fontFamily: "mulish"
                                                                    },
                                                                    children: [
                                                                        $e9636137eea334cc$var$formatDateBasedOnPreference(row.formatted_date, dateMMDDYYYY),
                                                                        "\xa0",
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                                            title: row.timezone,
                                                                            placement: "top",
                                                                            sx: {
                                                                                fontSize: "11.5px",
                                                                                fontFamily: "mulish"
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                                                                fontSize: "small"
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    sx: {
                                                                        fontSize: "11.5px",
                                                                        fontFamily: "mulish"
                                                                    },
                                                                    children: `${(0, $36f1c5bc563bba72$export$1e43853507c2d294)(row.alert_labels)}`
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    children: (0, $485e51885dc90d99$export$a57fd01c1a4f0d20)(row.detection_type, row.engineering_outcome?.outcome_v2, row.dispatch_muted === true, (0, $biDrR.isAlertWithheldFromReceiver)(row))
                                                                }),
                                                                showVlmFilters && /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    align: "left",
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $e46e67fbb04d9482$export$381190240de59398), {
                                                                        row: row
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }, row.id)
                                                })
                                            }, `${row.formatted_date}_${index}`);
                                        }),
                                        emptyRows > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                            style: {
                                                height: 53 * emptyRows
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                colSpan: isCondensed ? 1 : showVlmFilters ? 7 : 6
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "shrink-0 font-mulish",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "grid grid-cols-[auto_1fr_auto] items-center gap-1 px-1 py-0.5",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "justify-self-start",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                        "aria-label": "Table actions",
                                        onClick: (event)=>setFooterMenuAnchor(event.currentTarget),
                                        size: "small",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5MAs))), {})
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                                        anchorEl: footerMenuAnchor,
                                        open: footerMenuOpen,
                                        onClose: ()=>setFooterMenuAnchor(null),
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                disabled: isFetchingReport,
                                                onClick: ()=>{
                                                    handleDownloadReportClick();
                                                    setFooterMenuAnchor(null);
                                                },
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: isFetchingReport ? "Fetching Report" : reportDownloadUrl ? "Download Report" : "Fetch Report"
                                            }),
                                            viewAlertMuting && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                                onClick: ()=>{
                                                    setSeeMutedSiteAndCamerasDialogOpen(true);
                                                    setFooterMenuAnchor(null);
                                                },
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: "See Muted Sites & Cameras"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "justify-self-center text-actuate-blue",
                                children: alertsRefreshing ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                    title: "Alerts refreshing in background",
                                    placement: "top",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "animate-spin",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0bc50af9b02a5c81$exports))), {
                                            fontSize: "small"
                                        })
                                    })
                                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                    title: "Alerts not refreshing in background.",
                                    placement: "top",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a09d8a49c5a30d92$exports))), {
                                            fontSize: "small"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "min-w-0 justify-self-end",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wcxl.default), {
                                    // ENG-1489 hides the picker in condensed mode only; detailed
                                    // mode keeps the SUP-510 rows-per-page control.
                                    rowsPerPageOptions: isCondensed ? [] : (0, $71280fd12553052d$export$43df365616a0df93),
                                    component: "div",
                                    count: count,
                                    rowsPerPage: rowsPerPage,
                                    page: page,
                                    onPageChange: handleChangePage,
                                    onRowsPerPageChange: handleChangeRowsPerPage,
                                    sx: $e9636137eea334cc$var$compactTablePaginationSx
                                })
                            })
                        ]
                    }),
                    !isCondensed && !userFilters?.start_date && !userFilters?.end_date && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "px-[15px] pb-2 font-mulish text-[12px]",
                        children: alertData.length === 100 ? periodHours === 1 ? `Displaying ${detectionType === "All" ? 100 : ""} most recent alerts from the past hour.` : `Displaying ${detectionType === "All" ? 100 : ""} most recent alerts from the past ${periodHours} hours.` : periodHours === 1 ? "Displaying alerts from the past hour." : `Displaying alerts from the past ${periodHours} hours.`
                    })
                ]
            })
        ]
    });
};




var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $a7uO0 = parcelRequire("a7uO0");

var $k4ank = parcelRequire("k4ank");
"use client";
var $576ffd2fe75a0656$export$2e2bcd8739ae039 = (0, $a7uO0.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');



var $hAnMZ = parcelRequire("hAnMZ");
const $c8c1df60a42bcf00$export$af16cf31077a6c4c = ()=>{
    const currentDate = new Date().getTime() / 1000;
    return currentDate.toString();
};




var $ebTQj = parcelRequire("ebTQj");




const $6ed745252743982b$export$f7b09dd08ca9dfb3 = (currentRow, alertData, setAlertData, setSelectedRow, setSelectedButtonsFilled, setMP4URL, setVideoClipLoading, setSeeMoreURL, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, navigate, userFilters, detectionType, outcomeFilterType, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration, syncSelectedRowRef, vlmFilterType = "All")=>{
    setMP4URL("");
    setVideoClipLoading(true);
    setShowRefreshButton(false);
    const isUnresolvedFilter = userFilters?.filter_type === "UNCLAIMED";
    const storedSort = (0, $6e02db388b82b823$export$d95673b906883801)();
    const navigableFrom = (rows)=>(0, $6e02db388b82b823$export$cdfae0e972447b21)({
            alertData: rows,
            detectionType: detectionType,
            outcomeFilterType: outcomeFilterType,
            vlmFilterType: vlmFilterType,
            showVlmFilters: true,
            order: storedSort.order,
            orderBy: storedSort.orderBy
        });
    const filteredAlertData = navigableFrom(alertData);
    const currentIndex = filteredAlertData.findIndex((alert)=>(0, $6e02db388b82b823$export$7a01cfb15849021d)(alert, currentRow));
    let newAlertData = [
        ...alertData
    ];
    let nextRow = null;
    if (isUnresolvedFilter) {
        newAlertData = newAlertData.filter((alert)=>!(0, $6e02db388b82b823$export$7a01cfb15849021d)(alert, currentRow));
        const remainingFilteredData = navigableFrom(newAlertData);
        if (remainingFilteredData.length > 0) {
            const nextIndex = currentIndex >= remainingFilteredData.length ? 0 : currentIndex;
            nextRow = remainingFilteredData[nextIndex];
        }
    } else if (filteredAlertData.length <= 1) nextRow = currentRow;
    else if (currentIndex === filteredAlertData.length - 1) nextRow = filteredAlertData[0];
    else nextRow = filteredAlertData[currentIndex + 1];
    if (isUnresolvedFilter) setAlertData(newAlertData);
    if (nextRow) {
        const finalAlertData = isUnresolvedFilter ? newAlertData : alertData;
        finalAlertData.forEach((object)=>{
            object.selected = false;
        });
        const nextRowIndex = finalAlertData.findIndex((alert)=>(0, $6e02db388b82b823$export$7a01cfb15849021d)(alert, nextRow));
        if (nextRowIndex >= 0) finalAlertData[nextRowIndex].selected = true;
        setSelectedRow(nextRow);
        syncSelectedRowRef(nextRow);
        localStorage.setItem("selectedRowAlerts", JSON.stringify(nextRow));
        setSeeMoreURL(nextRow.alert_url);
        setAlertData([
            ...finalAlertData
        ]);
        (0, $e16b4c67693640c8$export$e44ee059113f075d)(nextRow, setSelectedButtonsFilled);
        (0, $b68d5e91295063d7$export$f4980018d5f7dd7)(nextRow.camera_pk, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, navigate);
        (0, $6b057cfee512ff1e$export$c5f684b415548de8)(nextRow, navigate, setMP4URL, setVideoClipLoading, setShowRefreshButton, true, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration);
        const remainingForArrows = navigableFrom(isUnresolvedFilter ? newAlertData : alertData);
        const newPositionIndex = remainingForArrows.findIndex((alert)=>(0, $6e02db388b82b823$export$7a01cfb15849021d)(alert, nextRow));
        const arrows = (0, $6e02db388b82b823$export$c18f05524cab3606)(newPositionIndex, remainingForArrows.length);
        setBackArrowDisabled(arrows.backDisabled);
        setForwardArrowDisabled(arrows.forwardDisabled);
    } else {
        setSelectedRow(null);
        syncSelectedRowRef(null);
        localStorage.removeItem("selectedRowAlerts");
        setSeeMoreURL("");
        setBackArrowDisabled(true);
        setForwardArrowDisabled(true);
        setVideoClipLoading(false);
    }
};


const $78eb297494bde96d$export$4ef8bbe76cec7214 = ({ compact: compact = false, wide: wide = false } = {})=>{
    if (compact) return "min-h-[38px] w-full min-w-0 max-w-full overflow-hidden px-1 py-1 text-center text-[12px] leading-tight [&_svg]:h-[14px] [&_svg]:w-[14px] [&_svg]:align-middle";
    return wide ? "w-[240px] p-1 text-[12px] [&_svg]:h-[22px] [&_svg]:w-[22px] [&_svg]:align-middle" : "w-[170px] p-1 text-[12px] [&_svg]:h-[22px] [&_svg]:w-[22px] [&_svg]:align-middle";
};


const $397f4ef6888b6958$export$77bfb478d4c5279b = (alertData, setAlertData, selectedRow, setSelectedRow, navigate, setSelectedButtonsFilled, setPageLoading, setButtonClicked, // New parameters for auto-advance functionality
setMP4URL, setVideoClipLoading, setSeeMoreURL, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, userFilters, detectionType, outcomeFilterType, vlmFilterType, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration, syncSelectedRowRef)=>{
    const AxiosUI = (0, $hAnMZ.createMonitoringAPICall)(``);
    const retryFunction = ()=>{
        $397f4ef6888b6958$export$77bfb478d4c5279b(alertData, setAlertData, selectedRow, setSelectedRow, navigate, setSelectedButtonsFilled, setPageLoading, setButtonClicked, setMP4URL, setVideoClipLoading, setSeeMoreURL, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, userFilters, detectionType, outcomeFilterType, vlmFilterType, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration, syncSelectedRowRef);
    };
    const postedAlert = {
        approx_capture_timestamp: selectedRow.approx_capture_timestamp,
        window_id: selectedRow.window_id,
        alert_outcome: 1,
        threat_level: 1,
        notes: selectedRow.unresolved_notes
    };
    AxiosUI.post(`alert/outcome/`, postedAlert).then(()=>{
        // Update the current row's detection type in alertData
        const newAlertData = [
            ...alertData
        ];
        newAlertData.forEach((object, index)=>{
            if (selectedRow.approx_capture_timestamp === object.approx_capture_timestamp && selectedRow.window_id === object.window_id) {
                newAlertData[index].detection_type = "true_threat";
                newAlertData[index].seen = true;
                newAlertData[index].outcome_number = 1;
                newAlertData[index].notes = selectedRow.unresolved_notes;
                // Update engineering_outcome.outcome_v2 for icon display
                const alertItem = newAlertData[index];
                if (alertItem.engineering_outcome) {
                    alertItem.engineering_outcome.outcome_v2 = "true_threat";
                    alertItem.engineering_outcome.outcome = "intruder_detected";
                }
            }
        });
        // Update the selected row object
        const updatedSelectedRow = {
            ...selectedRow
        };
        updatedSelectedRow.detection_type = "true_threat";
        updatedSelectedRow.seen = true;
        updatedSelectedRow.updated = (0, $c8c1df60a42bcf00$export$af16cf31077a6c4c)();
        updatedSelectedRow.user = localStorage.username;
        if (updatedSelectedRow.engineering_outcome) {
            updatedSelectedRow.engineering_outcome.outcome_v2 = "true_threat";
            updatedSelectedRow.engineering_outcome.outcome = "intruder_detected";
        }
        // Check if auto-advance props are provided
        if (setMP4URL && setVideoClipLoading && setSeeMoreURL && setForwardArrowDisabled && setBackArrowDisabled && setShowRefreshButton && setSelectedAlertCameraInfo && setIgnoreZonesSelectedAlert && userFilters && getCurrentSelectedRowKey && setVideoProcessing && syncSelectedRowRef) // Use auto-advance functionality
        // Note: handleAutoAdvanceAfterLabeling will call handleAlertButtonsFill
        // to set the correct button states for the NEW row
        (0, $6ed745252743982b$export$f7b09dd08ca9dfb3)(updatedSelectedRow, newAlertData, setAlertData, setSelectedRow, setSelectedButtonsFilled, setMP4URL, setVideoClipLoading, setSeeMoreURL, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, navigate, userFilters, detectionType || "All", outcomeFilterType || "All", getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration ?? true, syncSelectedRowRef, vlmFilterType || "All");
        else {
            // Fallback to original behavior if auto-advance props not provided
            setAlertData(newAlertData);
            localStorage.setItem("selectedRowAlerts", JSON.stringify(updatedSelectedRow));
            setSelectedRow(updatedSelectedRow);
            // Only set button fill state in fallback mode (for the current labeled row)
            setSelectedButtonsFilled(()=>{
                return {
                    true_threat: true,
                    true_non_threat: false,
                    false_positive: false,
                    escalated_true_threat: false
                };
            });
        }
        setButtonClicked(false);
    }, (reason)=>{
        (0, $c0b3a83d600c7aa1$export$5646bda7f69a98da)(reason, navigate, retryFunction, ()=>{
            setButtonClicked(false);
            alert("Error saving alert type, please try again");
            (0, $ebTQj.logger).log("Error saving alert type:", reason.message);
        }, ()=>setButtonClicked(false));
    });
};
const $397f4ef6888b6958$export$88768068b77f1e25 = (props)=>{
    const { selectdButtonsFilled: selectdButtonsFilled, setSelectedButtonsFilled: setSelectedButtonsFilled, alertData: alertData, setAlertData: setAlertData, selectedRow: selectedRow, setSelectedRow: setSelectedRow, navigate: navigate, setPageLoading: setPageLoading, setButtonClicked: setButtonClicked, setMP4URL: // New props for auto-advance functionality
    setMP4URL, setVideoClipLoading: setVideoClipLoading, setSeeMoreURL: setSeeMoreURL, setForwardArrowDisabled: setForwardArrowDisabled, setBackArrowDisabled: setBackArrowDisabled, setShowRefreshButton: setShowRefreshButton, setSelectedAlertCameraInfo: setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert: setIgnoreZonesSelectedAlert, userFilters: userFilters, detectionType: detectionType, outcomeFilterType: outcomeFilterType, vlmFilterType: vlmFilterType, getCurrentSelectedRowKey: getCurrentSelectedRowKey, setVideoProcessing: setVideoProcessing, useAsyncGeneration: useAsyncGeneration, syncSelectedRowRef: syncSelectedRowRef, compact: compact } = props;
    const layoutClass = (0, $78eb297494bde96d$export$4ef8bbe76cec7214)({
        compact: compact,
        wide: selectedRow.detection_type === "escalated_true_threat" || selectedRow.detection_type === "true_threat"
    });
    const handleClick = ()=>{
        setButtonClicked(true);
        $397f4ef6888b6958$export$77bfb478d4c5279b(alertData, setAlertData, selectedRow, setSelectedRow, navigate, setSelectedButtonsFilled, setPageLoading, setButtonClicked, setMP4URL, setVideoClipLoading, setSeeMoreURL, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, userFilters, detectionType, outcomeFilterType, vlmFilterType, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration, syncSelectedRowRef);
    };
    const filledButton = /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
        className: `shadow-button bg-[#2E7D32] border-2	border-[#2E7D32] rounded font-mulish text-white ${layoutClass}`,
        onClick: handleClick,
        disabled: false,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $576ffd2fe75a0656$export$2e2bcd8739ae039), {}),
            " True Threat"
        ]
    });
    const unfilledButton = /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
        className: `shadow-button bg-white border-2	border-[#2E7D32] rounded font-mulish text-[#2E7D32] ${layoutClass}`,
        onClick: handleClick,
        disabled: false,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $576ffd2fe75a0656$export$2e2bcd8739ae039), {}),
            " True Threat"
        ]
    });
    return selectdButtonsFilled.true_threat ? filledButton : unfilledButton;
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");


var $hAnMZ = parcelRequire("hAnMZ");



var $ebTQj = parcelRequire("ebTQj");


const $24d3387fa1eb3011$export$34616ebf94deb730 = (alertData, setAlertData, selectedRow, setSelectedRow, navigate, setSelectedButtonsFilled, setPageLoading, setButtonClicked, // New parameters for auto-advance functionality
setMP4URL, setVideoClipLoading, setSeeMoreURL, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, userFilters, detectionType, outcomeFilterType, vlmFilterType, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration, syncSelectedRowRef)=>{
    const AxiosUI = (0, $hAnMZ.createMonitoringAPICall)(``);
    const retryFunction = ()=>{
        $24d3387fa1eb3011$export$34616ebf94deb730(alertData, setAlertData, selectedRow, setSelectedRow, navigate, setSelectedButtonsFilled, setPageLoading, setButtonClicked, setMP4URL, setVideoClipLoading, setSeeMoreURL, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, userFilters, detectionType, outcomeFilterType, vlmFilterType, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration, syncSelectedRowRef);
    };
    const postedAlert = {
        approx_capture_timestamp: selectedRow.approx_capture_timestamp,
        window_id: selectedRow.window_id,
        alert_outcome: 2,
        threat_level: 1,
        notes: selectedRow.unresolved_notes
    };
    AxiosUI.post(`alert/outcome/`, postedAlert).then(()=>{
        // Update the current row's detection type in alertData
        const newAlertData = [
            ...alertData
        ];
        newAlertData.forEach((object, index)=>{
            if (selectedRow.approx_capture_timestamp === object.approx_capture_timestamp && selectedRow.window_id === object.window_id) {
                newAlertData[index].detection_type = "true_non_threat";
                newAlertData[index].seen = true;
                newAlertData[index].outcome_number = 2;
                newAlertData[index].notes = selectedRow.unresolved_notes;
                // Update engineering_outcome.outcome_v2 for icon display
                const alertItem = newAlertData[index];
                if (alertItem.engineering_outcome) {
                    alertItem.engineering_outcome.outcome_v2 = "true_non_threat";
                    alertItem.engineering_outcome.outcome = "intruder_detected";
                }
            }
        });
        // Update the selected row object
        const updatedSelectedRow = {
            ...selectedRow
        };
        updatedSelectedRow.detection_type = "true_non_threat";
        updatedSelectedRow.seen = true;
        updatedSelectedRow.updated = (0, $c8c1df60a42bcf00$export$af16cf31077a6c4c)();
        updatedSelectedRow.user = localStorage.username;
        if (updatedSelectedRow.engineering_outcome) {
            updatedSelectedRow.engineering_outcome.outcome_v2 = "true_non_threat";
            updatedSelectedRow.engineering_outcome.outcome = "intruder_detected";
        }
        // Check if auto-advance props are provided
        if (setMP4URL && setVideoClipLoading && setSeeMoreURL && setForwardArrowDisabled && setBackArrowDisabled && setShowRefreshButton && setSelectedAlertCameraInfo && setIgnoreZonesSelectedAlert && userFilters && getCurrentSelectedRowKey && setVideoProcessing && syncSelectedRowRef) // Use auto-advance functionality
        // Note: handleAutoAdvanceAfterLabeling will call handleAlertButtonsFill
        // to set the correct button states for the NEW row
        (0, $6ed745252743982b$export$f7b09dd08ca9dfb3)(updatedSelectedRow, newAlertData, setAlertData, setSelectedRow, setSelectedButtonsFilled, setMP4URL, setVideoClipLoading, setSeeMoreURL, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, navigate, userFilters, detectionType || "All", outcomeFilterType || "All", getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration ?? true, syncSelectedRowRef, vlmFilterType || "All");
        else {
            // Fallback to original behavior if auto-advance props not provided
            setAlertData(newAlertData);
            localStorage.setItem("selectedRowAlerts", JSON.stringify(updatedSelectedRow));
            setSelectedRow(updatedSelectedRow);
            // Only set button fill state in fallback mode (for the current labeled row)
            setSelectedButtonsFilled(()=>{
                return {
                    true_threat: false,
                    true_non_threat: true,
                    false_positive: false,
                    escalated_true_threat: false
                };
            });
        }
        setButtonClicked(false);
    }, (reason)=>{
        (0, $c0b3a83d600c7aa1$export$5646bda7f69a98da)(reason, navigate, retryFunction, ()=>{
            setButtonClicked(false);
            alert("Error saving alert type, please try again");
            (0, $ebTQj.logger).log("Error saving alert type:", reason.message);
        }, ()=>setButtonClicked(false));
    });
};
const $24d3387fa1eb3011$export$576ae02131407312 = (props)=>{
    const { selectdButtonsFilled: selectdButtonsFilled, setSelectedButtonsFilled: setSelectedButtonsFilled, alertData: alertData, setAlertData: setAlertData, selectedRow: selectedRow, setSelectedRow: setSelectedRow, navigate: navigate, setPageLoading: setPageLoading, setButtonClicked: setButtonClicked, setMP4URL: // New props for auto-advance functionality
    setMP4URL, setVideoClipLoading: setVideoClipLoading, setSeeMoreURL: setSeeMoreURL, setForwardArrowDisabled: setForwardArrowDisabled, setBackArrowDisabled: setBackArrowDisabled, setShowRefreshButton: setShowRefreshButton, setSelectedAlertCameraInfo: setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert: setIgnoreZonesSelectedAlert, userFilters: userFilters, detectionType: detectionType, outcomeFilterType: outcomeFilterType, vlmFilterType: vlmFilterType, getCurrentSelectedRowKey: getCurrentSelectedRowKey, setVideoProcessing: setVideoProcessing, useAsyncGeneration: useAsyncGeneration, syncSelectedRowRef: syncSelectedRowRef, compact: compact } = props;
    const layoutClass = (0, $78eb297494bde96d$export$4ef8bbe76cec7214)({
        compact: compact,
        wide: selectedRow.detection_type === "escalated_true_threat" || selectedRow.detection_type === "true_threat"
    });
    const handleClick = ()=>{
        setButtonClicked(true);
        $24d3387fa1eb3011$export$34616ebf94deb730(alertData, setAlertData, selectedRow, setSelectedRow, navigate, setSelectedButtonsFilled, setPageLoading, setButtonClicked, setMP4URL, setVideoClipLoading, setSeeMoreURL, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, userFilters, detectionType, outcomeFilterType, vlmFilterType, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration, syncSelectedRowRef);
    };
    const filledButton = /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
        className: `shadow-button bg-actuate-orange border-2	border-actuate-orange rounded font-mulish text-white ${layoutClass}`,
        onClick: handleClick,
        disabled: false,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $576ffd2fe75a0656$export$2e2bcd8739ae039), {}),
            " True Non-Threat"
        ]
    });
    const unfilledButton = /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
        className: `shadow-button bg-white border-2	border-actuate-orange rounded font-mulish text-actuate-orange ${layoutClass}`,
        onClick: handleClick,
        disabled: false,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $576ffd2fe75a0656$export$2e2bcd8739ae039), {}),
            " True Non-Threat"
        ]
    });
    return selectdButtonsFilled.true_non_threat ? filledButton : unfilledButton;
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $433j1 = parcelRequire("433j1");

var $hAnMZ = parcelRequire("hAnMZ");




const $82b86b959f12476e$export$9d892cfa259f1ee6 = (alertData, setAlertData, selectedRow, setSelectedRow, navigate, setSelectedButtonsFilled, setPageLoading, setButtonClicked, // New parameters for auto-advance functionality
setMP4URL, setVideoClipLoading, setSeeMoreURL, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, userFilters, detectionType, outcomeFilterType, vlmFilterType, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration, syncSelectedRowRef)=>{
    const AxiosUI = (0, $hAnMZ.createMonitoringAPICall)(``);
    const retryFunction = ()=>{
        $82b86b959f12476e$export$9d892cfa259f1ee6(alertData, setAlertData, selectedRow, setSelectedRow, navigate, setSelectedButtonsFilled, setPageLoading, setButtonClicked, setMP4URL, setVideoClipLoading, setSeeMoreURL, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, userFilters, detectionType, outcomeFilterType, vlmFilterType, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration, syncSelectedRowRef);
    };
    const postedAlert = {
        approx_capture_timestamp: selectedRow.approx_capture_timestamp,
        window_id: selectedRow.window_id,
        alert_outcome: 3,
        threat_level: 1,
        notes: selectedRow.unresolved_notes
    };
    AxiosUI.post(`alert/outcome/`, postedAlert).then(()=>{
        // Update the current row's detection type in alertData
        const newAlertData = [
            ...alertData
        ];
        newAlertData.forEach((object, index)=>{
            if (selectedRow.approx_capture_timestamp === object.approx_capture_timestamp && selectedRow.window_id === object.window_id) {
                newAlertData[index].detection_type = "false_positive";
                newAlertData[index].seen = true;
                newAlertData[index].outcome_number = 3;
                newAlertData[index].notes = selectedRow.unresolved_notes;
                // Update engineering_outcome.outcome_v2 for icon display
                const alertItem = newAlertData[index];
                if (alertItem.engineering_outcome) {
                    alertItem.engineering_outcome.outcome_v2 = "false_positive";
                    alertItem.engineering_outcome.outcome = "false_positive";
                }
            }
        });
        // Update the selected row object
        const updatedSelectedRow = {
            ...selectedRow
        };
        updatedSelectedRow.detection_type = "false_positive";
        updatedSelectedRow.seen = true;
        updatedSelectedRow.updated = (0, $c8c1df60a42bcf00$export$af16cf31077a6c4c)();
        updatedSelectedRow.user = localStorage.username;
        if (updatedSelectedRow.engineering_outcome) {
            updatedSelectedRow.engineering_outcome.outcome_v2 = "false_positive";
            updatedSelectedRow.engineering_outcome.outcome = "false_positive";
        }
        // Check if auto-advance props are provided
        if (setMP4URL && setVideoClipLoading && setSeeMoreURL && setForwardArrowDisabled && setBackArrowDisabled && setShowRefreshButton && setSelectedAlertCameraInfo && setIgnoreZonesSelectedAlert && userFilters && getCurrentSelectedRowKey && setVideoProcessing && syncSelectedRowRef) // Use auto-advance functionality
        // Note: handleAutoAdvanceAfterLabeling will call handleAlertButtonsFill
        // to set the correct button states for the NEW row
        (0, $6ed745252743982b$export$f7b09dd08ca9dfb3)(updatedSelectedRow, newAlertData, setAlertData, setSelectedRow, setSelectedButtonsFilled, setMP4URL, setVideoClipLoading, setSeeMoreURL, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, navigate, userFilters, detectionType || "All", outcomeFilterType || "All", getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration ?? true, syncSelectedRowRef, vlmFilterType || "All");
        else {
            // Fallback to original behavior if auto-advance props not provided
            setAlertData(newAlertData);
            localStorage.setItem("selectedRowAlerts", JSON.stringify(updatedSelectedRow));
            setSelectedRow(updatedSelectedRow);
            // Only set button fill state in fallback mode (for the current labeled row)
            setSelectedButtonsFilled(()=>{
                return {
                    true_threat: false,
                    true_non_threat: false,
                    false_positive: true,
                    escalated_true_threat: false
                };
            });
        }
        setButtonClicked(false);
    }, (reason)=>{
        (0, $c0b3a83d600c7aa1$export$5646bda7f69a98da)(reason, navigate, retryFunction, ()=>{
            setButtonClicked(false);
            alert("Error saving alert type, please try again");
        }, ()=>setButtonClicked(false));
    });
};
const $82b86b959f12476e$export$913c7b0787442e36 = (props)=>{
    const { selectdButtonsFilled: selectdButtonsFilled, setSelectedButtonsFilled: setSelectedButtonsFilled, alertData: alertData, setAlertData: setAlertData, selectedRow: selectedRow, setSelectedRow: setSelectedRow, navigate: navigate, setPageLoading: setPageLoading, setButtonClicked: setButtonClicked, setMP4URL: // New props for auto-advance functionality
    setMP4URL, setVideoClipLoading: setVideoClipLoading, setSeeMoreURL: setSeeMoreURL, setForwardArrowDisabled: setForwardArrowDisabled, setBackArrowDisabled: setBackArrowDisabled, setShowRefreshButton: setShowRefreshButton, setSelectedAlertCameraInfo: setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert: setIgnoreZonesSelectedAlert, userFilters: userFilters, detectionType: detectionType, outcomeFilterType: outcomeFilterType, vlmFilterType: vlmFilterType, getCurrentSelectedRowKey: getCurrentSelectedRowKey, setVideoProcessing: setVideoProcessing, useAsyncGeneration: useAsyncGeneration, syncSelectedRowRef: syncSelectedRowRef, compact: compact } = props;
    const layoutClass = (0, $78eb297494bde96d$export$4ef8bbe76cec7214)({
        compact: compact,
        wide: selectedRow.detection_type === "escalated_true_threat" || selectedRow.detection_type === "true_threat"
    });
    const handleClick = ()=>{
        setButtonClicked(true);
        $82b86b959f12476e$export$9d892cfa259f1ee6(alertData, setAlertData, selectedRow, setSelectedRow, navigate, setSelectedButtonsFilled, setPageLoading, setButtonClicked, setMP4URL, setVideoClipLoading, setSeeMoreURL, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, userFilters, detectionType, outcomeFilterType, vlmFilterType, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration, syncSelectedRowRef);
    };
    const filledButton = /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
        id: "falseButton",
        className: `shadow-button bg-[#D32F2F] border-2	border-[#D32F2F] rounded font-mulish text-white ${layoutClass}`,
        onClick: handleClick,
        disabled: false,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {}),
            "\xa0 False"
        ]
    });
    const unfilledButton = /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
        className: `shadow-button bg-white border-2	border-[#D32F2F] rounded font-mulish text-[#D32F2F] ${layoutClass}`,
        onClick: handleClick,
        disabled: false,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {}),
            "\xa0 False"
        ]
    });
    return selectdButtonsFilled.false_positive ? filledButton : unfilledButton;
};




var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");
var $2f03677477341f00$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($2f03677477341f00$exports, "__esModule", {
    value: true
});
$2f03677477341f00$exports.default = void 0;

var $2f03677477341f00$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $2f03677477341f00$var$_default = $2f03677477341f00$exports.default = (0, $2f03677477341f00$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $k4ank.jsx)("circle", {
        cx: "12",
        cy: "19",
        r: "2"
    }, "0"),
    /*#__PURE__*/ (0, $k4ank.jsx)("path", {
        d: "M10 3h4v12h-4z"
    }, "1")
], 'PriorityHigh');



var $hAnMZ = parcelRequire("hAnMZ");



var $ebTQj = parcelRequire("ebTQj");


const $80122896f69019ef$export$d1b9c1209da62f4b = (alertData, setAlertData, selectedRow, setSelectedRow, navigate, setSelectedButtonsFilled, setPageLoading, setButtonClicked, // New parameters for auto-advance functionality
setMP4URL, setVideoClipLoading, setSeeMoreURL, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, userFilters, detectionType, outcomeFilterType, vlmFilterType, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration, syncSelectedRowRef)=>{
    const AxiosUI = (0, $hAnMZ.createMonitoringAPICall)(``);
    const retryFunction = ()=>{
        $80122896f69019ef$export$d1b9c1209da62f4b(alertData, setAlertData, selectedRow, setSelectedRow, navigate, setSelectedButtonsFilled, setPageLoading, setButtonClicked, setMP4URL, setVideoClipLoading, setSeeMoreURL, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, userFilters, detectionType, outcomeFilterType, vlmFilterType, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration, syncSelectedRowRef);
    };
    const postedAlert = {
        approx_capture_timestamp: selectedRow.approx_capture_timestamp,
        window_id: selectedRow.window_id,
        alert_outcome: 4,
        threat_level: 4,
        notes: selectedRow.unresolved_notes
    };
    AxiosUI.post(`alert/outcome/`, postedAlert).then(()=>{
        // Update the current row's detection type in alertData
        const newAlertData = [
            ...alertData
        ];
        newAlertData.forEach((object, index)=>{
            if (selectedRow.approx_capture_timestamp === object.approx_capture_timestamp && selectedRow.window_id === object.window_id) {
                newAlertData[index].detection_type = "escalated_true_threat";
                newAlertData[index].seen = true;
                newAlertData[index].outcome_number = 4;
                newAlertData[index].notes = selectedRow.unresolved_notes;
                // Update engineering_outcome.outcome_v2 for icon display
                const alertItem = newAlertData[index];
                if (alertItem.engineering_outcome) {
                    alertItem.engineering_outcome.outcome_v2 = "escalated_true_threat";
                    alertItem.engineering_outcome.outcome = "intruder_detected";
                }
            }
        });
        // Update the selected row object
        const updatedSelectedRow = {
            ...selectedRow
        };
        updatedSelectedRow.detection_type = "escalated_true_threat";
        updatedSelectedRow.seen = true;
        updatedSelectedRow.updated = (0, $c8c1df60a42bcf00$export$af16cf31077a6c4c)();
        updatedSelectedRow.user = localStorage.username;
        if (updatedSelectedRow.engineering_outcome) {
            updatedSelectedRow.engineering_outcome.outcome_v2 = "escalated_true_threat";
            updatedSelectedRow.engineering_outcome.outcome = "intruder_detected";
        }
        // Check if auto-advance props are provided
        if (setMP4URL && setVideoClipLoading && setSeeMoreURL && setForwardArrowDisabled && setBackArrowDisabled && setShowRefreshButton && setSelectedAlertCameraInfo && setIgnoreZonesSelectedAlert && userFilters && getCurrentSelectedRowKey && setVideoProcessing && syncSelectedRowRef) // Use auto-advance functionality
        // Note: handleAutoAdvanceAfterLabeling will call handleAlertButtonsFill
        // to set the correct button states for the NEW row
        (0, $6ed745252743982b$export$f7b09dd08ca9dfb3)(updatedSelectedRow, newAlertData, setAlertData, setSelectedRow, setSelectedButtonsFilled, setMP4URL, setVideoClipLoading, setSeeMoreURL, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, navigate, userFilters, detectionType || "All", outcomeFilterType || "All", getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration ?? true, syncSelectedRowRef, vlmFilterType || "All");
        else {
            // Fallback to original behavior if auto-advance props not provided
            setAlertData(newAlertData);
            localStorage.setItem("selectedRowAlerts", JSON.stringify(updatedSelectedRow));
            setSelectedRow(updatedSelectedRow);
            // Only set button fill state in fallback mode (for the current labeled row)
            setSelectedButtonsFilled(()=>{
                return {
                    true_threat: false,
                    true_non_threat: false,
                    false_positive: false,
                    escalated_true_threat: true
                };
            });
        }
        setButtonClicked(false);
    }, (reason)=>{
        (0, $c0b3a83d600c7aa1$export$5646bda7f69a98da)(reason, navigate, retryFunction, ()=>{
            setButtonClicked(false);
            alert("Error saving alert type, please try again");
            (0, $ebTQj.logger).log(reason.message || String(reason));
        }, ()=>setButtonClicked(false));
    });
};
const $80122896f69019ef$export$e42a978e6bb68ab8 = (props)=>{
    const { selectdButtonsFilled: selectdButtonsFilled, setSelectedButtonsFilled: setSelectedButtonsFilled, alertData: alertData, setAlertData: setAlertData, selectedRow: selectedRow, setSelectedRow: setSelectedRow, navigate: navigate, setPageLoading: setPageLoading, setButtonClicked: setButtonClicked, setMP4URL: // New props for auto-advance functionality
    setMP4URL, setVideoClipLoading: setVideoClipLoading, setSeeMoreURL: setSeeMoreURL, setForwardArrowDisabled: setForwardArrowDisabled, setBackArrowDisabled: setBackArrowDisabled, setShowRefreshButton: setShowRefreshButton, setSelectedAlertCameraInfo: setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert: setIgnoreZonesSelectedAlert, userFilters: userFilters, detectionType: detectionType, outcomeFilterType: outcomeFilterType, vlmFilterType: vlmFilterType, getCurrentSelectedRowKey: getCurrentSelectedRowKey, setVideoProcessing: setVideoProcessing, useAsyncGeneration: useAsyncGeneration, syncSelectedRowRef: syncSelectedRowRef, compact: compact } = props;
    const layoutClass = (0, $78eb297494bde96d$export$4ef8bbe76cec7214)({
        compact: compact,
        wide: true
    });
    const handleClick = ()=>{
        setButtonClicked(true);
        $80122896f69019ef$export$d1b9c1209da62f4b(alertData, setAlertData, selectedRow, setSelectedRow, navigate, setSelectedButtonsFilled, setPageLoading, setButtonClicked, setMP4URL, setVideoClipLoading, setSeeMoreURL, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, userFilters, detectionType, outcomeFilterType, vlmFilterType, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration, syncSelectedRowRef);
    };
    const filledButton = /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
        className: `shadow-button bg-[#7d2e72] border-2	border-[#7d2e72] rounded font-mulish text-white ${layoutClass}`,
        onClick: handleClick,
        disabled: false,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2f03677477341f00$exports))), {}),
            " Escalated True Threat"
        ]
    });
    const unfilledButton = /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
        className: `shadow-button bg-white border-2	border-[#7d2e72] rounded font-mulish text-[#7d2e72] ${layoutClass}`,
        onClick: handleClick,
        disabled: false,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2f03677477341f00$exports))), {}),
            " Escalated True Threat"
        ]
    });
    return selectdButtonsFilled.escalated_true_threat ? filledButton : unfilledButton;
};



var $aYdit = parcelRequire("aYdit");

const $8d098a274bfe17bc$export$d153b474e995d388 = ({ selectedRow: selectedRow, alertData: alertData, setAlertData: setAlertData, setSelectedRow: setSelectedRow, selectdButtonsFilled: selectdButtonsFilled, setSelectedButtonsFilled: setSelectedButtonsFilled, navigate: navigate, setPageLoading: setPageLoading, setButtonClicked: setButtonClicked, pageLoadedNumber: pageLoadedNumber, setPageLoadedNumber: setPageLoadedNumber, setFetchingFilteredData: setFetchingFilteredData, setSeeMoreURL: setSeeMoreURL, setMP4URL: setMP4URL, userFilters: userFilters, setThumbnailVideos: setThumbnailVideos, setDateOutsideRange: setDateOutsideRange, setPage: setPage, setVideoClipLoading: setVideoClipLoading, setAlertsToDisplay: setAlertsToDisplay, setSelectedAlertCameraInfo: setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert: setIgnoreZonesSelectedAlert, setAlertsIndexOrder: setAlertsIndexOrder, setRefreshInterval: setRefreshInterval, setCurrentName: setCurrentName, setUserFilters: setUserFilters, setRefreshingData: setRefreshingData, refreshInterval: refreshInterval, cameraOptions: cameraOptions, siteOptions: siteOptions, setRefreshingToken: setRefreshingToken, refreshingToken: refreshingToken, setAlertLabels: setAlertLabels, setPeriodHours: setPeriodHours, setQueryLimitHit: setQueryLimitHit, setForwardArrowDisabled: setForwardArrowDisabled, setBackArrowDisabled: setBackArrowDisabled, setShowRefreshButton: setShowRefreshButton, setRowsSortable: setRowsSortable, setAlertsRefreshing: setAlertsRefreshing, detectionType: // New props for auto-advance functionality
detectionType, outcomeFilterType: outcomeFilterType, vlmFilterType: vlmFilterType, getCurrentSelectedRowKey: getCurrentSelectedRowKey, setVideoProcessing: setVideoProcessing, useAsyncGeneration: useAsyncGeneration, syncSelectedRowRef: syncSelectedRowRef, compact: compact = false })=>{
    // ENG-1813: the outcome buttons, their prompt and the t/n/f/e shortcuts are
    // only offered to users whose /user/info/ says they may set outcomes. The
    // monitoring API checks the same permission, so this just keeps the UI in
    // step with what it will accept. Reading the store (not a prop) means a
    // stale grant revoked mid-session un-renders the box reactively.
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    const canSetOutcome = (0, $c0b3a83d600c7aa1$export$544f58273da8c441)(userPermissions);
    // Keyboard shortcuts handler
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (!canSetOutcome) return;
            // Only handle shortcuts when not in a dialog or input field
            if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement || event.target instanceof HTMLSelectElement) return;
            switch(event.key.toLowerCase()){
                case "t":
                    event.preventDefault();
                    setButtonClicked(true);
                    (0, $397f4ef6888b6958$export$77bfb478d4c5279b)(alertData, setAlertData, selectedRow, setSelectedRow, navigate, setSelectedButtonsFilled, setPageLoading, setButtonClicked, setMP4URL, setVideoClipLoading, setSeeMoreURL, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, userFilters, detectionType, outcomeFilterType, vlmFilterType, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration, syncSelectedRowRef);
                    break;
                case "n":
                    event.preventDefault();
                    setButtonClicked(true);
                    (0, $24d3387fa1eb3011$export$34616ebf94deb730)(alertData, setAlertData, selectedRow, setSelectedRow, navigate, setSelectedButtonsFilled, setPageLoading, setButtonClicked, setMP4URL, setVideoClipLoading, setSeeMoreURL, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, userFilters, detectionType, outcomeFilterType, vlmFilterType, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration, syncSelectedRowRef);
                    break;
                case "f":
                    event.preventDefault();
                    setButtonClicked(true);
                    (0, $82b86b959f12476e$export$9d892cfa259f1ee6)(alertData, setAlertData, selectedRow, setSelectedRow, navigate, setSelectedButtonsFilled, setPageLoading, setButtonClicked, setMP4URL, setVideoClipLoading, setSeeMoreURL, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, userFilters, detectionType, outcomeFilterType, vlmFilterType, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration, syncSelectedRowRef);
                    break;
                case "e":
                    event.preventDefault();
                    setButtonClicked(true);
                    (0, $80122896f69019ef$export$d1b9c1209da62f4b)(alertData, setAlertData, selectedRow, setSelectedRow, navigate, setSelectedButtonsFilled, setPageLoading, setButtonClicked, setMP4URL, setVideoClipLoading, setSeeMoreURL, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, userFilters, detectionType, outcomeFilterType, vlmFilterType, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration, syncSelectedRowRef);
                    break;
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        alertData,
        setAlertData,
        selectedRow,
        setSelectedRow,
        navigate,
        setSelectedButtonsFilled,
        setPageLoading,
        setButtonClicked,
        pageLoadedNumber,
        setPageLoadedNumber,
        setFetchingFilteredData,
        setSeeMoreURL,
        setMP4URL,
        userFilters,
        setThumbnailVideos,
        setDateOutsideRange,
        setPage,
        setVideoClipLoading,
        setAlertsToDisplay,
        setSelectedAlertCameraInfo,
        setIgnoreZonesSelectedAlert,
        setAlertsIndexOrder,
        setRefreshInterval,
        setCurrentName,
        setUserFilters,
        setRefreshingData,
        refreshInterval,
        cameraOptions,
        siteOptions,
        setRefreshingToken,
        refreshingToken,
        setAlertLabels,
        setPeriodHours,
        setQueryLimitHit,
        setForwardArrowDisabled,
        setBackArrowDisabled,
        setShowRefreshButton,
        setRowsSortable,
        setAlertsRefreshing,
        detectionType,
        outcomeFilterType,
        vlmFilterType,
        getCurrentSelectedRowKey,
        setVideoProcessing,
        useAsyncGeneration,
        syncSelectedRowRef,
        canSetOutcome
    ]);
    if (!canSetOutcome) return null;
    return selectedRow.detection_type === "escalated_true_threat" || selectedRow.detection_type === "true_threat" ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "flex w-full grow flex-col justify-center rounded border border-actuate-grey bg-[#F0F1F3] pt-2 pb-[10px]",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "px-2 text-center font-mulish text-[14px] text-actuate-blue",
                children: selectedRow.alert_labels ? `Was this alert a true ${(0, $36f1c5bc563bba72$export$1e43853507c2d294)(selectedRow.alert_labels)} detection?` : ""
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "grid w-full min-w-0 grid-cols-2 gap-2 px-2 pt-2",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "flex w-full min-w-0 justify-center",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $80122896f69019ef$export$e42a978e6bb68ab8), {
                            detection_type: selectedRow.detection_type,
                            alertData: alertData,
                            setAlertData: setAlertData,
                            selectedRow: selectedRow,
                            setSelectedRow: setSelectedRow,
                            selectdButtonsFilled: selectdButtonsFilled,
                            setSelectedButtonsFilled: setSelectedButtonsFilled,
                            navigate: navigate,
                            setPageLoading: setPageLoading,
                            setButtonClicked: setButtonClicked,
                            setMP4URL: setMP4URL,
                            setVideoClipLoading: setVideoClipLoading,
                            setSeeMoreURL: setSeeMoreURL,
                            setForwardArrowDisabled: setForwardArrowDisabled,
                            setBackArrowDisabled: setBackArrowDisabled,
                            setShowRefreshButton: setShowRefreshButton,
                            setSelectedAlertCameraInfo: setSelectedAlertCameraInfo,
                            setIgnoreZonesSelectedAlert: setIgnoreZonesSelectedAlert,
                            userFilters: userFilters,
                            detectionType: detectionType,
                            outcomeFilterType: outcomeFilterType,
                            vlmFilterType: vlmFilterType,
                            getCurrentSelectedRowKey: getCurrentSelectedRowKey,
                            setVideoProcessing: setVideoProcessing,
                            useAsyncGeneration: useAsyncGeneration,
                            syncSelectedRowRef: syncSelectedRowRef,
                            compact: compact
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "flex w-full min-w-0 justify-center",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $397f4ef6888b6958$export$88768068b77f1e25), {
                            selectdButtonsFilled: selectdButtonsFilled,
                            setSelectedButtonsFilled: setSelectedButtonsFilled,
                            alertData: alertData,
                            setAlertData: setAlertData,
                            selectedRow: selectedRow,
                            setSelectedRow: setSelectedRow,
                            navigate: navigate,
                            setPageLoading: setPageLoading,
                            setButtonClicked: setButtonClicked,
                            setMP4URL: setMP4URL,
                            setVideoClipLoading: setVideoClipLoading,
                            setSeeMoreURL: setSeeMoreURL,
                            setForwardArrowDisabled: setForwardArrowDisabled,
                            setBackArrowDisabled: setBackArrowDisabled,
                            setShowRefreshButton: setShowRefreshButton,
                            setSelectedAlertCameraInfo: setSelectedAlertCameraInfo,
                            setIgnoreZonesSelectedAlert: setIgnoreZonesSelectedAlert,
                            userFilters: userFilters,
                            detectionType: detectionType,
                            outcomeFilterType: outcomeFilterType,
                            vlmFilterType: vlmFilterType,
                            getCurrentSelectedRowKey: getCurrentSelectedRowKey,
                            setVideoProcessing: setVideoProcessing,
                            useAsyncGeneration: useAsyncGeneration,
                            syncSelectedRowRef: syncSelectedRowRef,
                            compact: compact
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "grid w-full min-w-0 grid-cols-2 gap-2 px-2 pt-[15px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "flex w-full min-w-0 justify-center",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $24d3387fa1eb3011$export$576ae02131407312), {
                            detection_type: selectedRow.detection_type,
                            alertData: alertData,
                            setAlertData: setAlertData,
                            selectedRow: selectedRow,
                            setSelectedRow: setSelectedRow,
                            selectdButtonsFilled: selectdButtonsFilled,
                            setSelectedButtonsFilled: setSelectedButtonsFilled,
                            navigate: navigate,
                            setPageLoading: setPageLoading,
                            setButtonClicked: setButtonClicked,
                            setMP4URL: setMP4URL,
                            setVideoClipLoading: setVideoClipLoading,
                            setSeeMoreURL: setSeeMoreURL,
                            setForwardArrowDisabled: setForwardArrowDisabled,
                            setBackArrowDisabled: setBackArrowDisabled,
                            setShowRefreshButton: setShowRefreshButton,
                            setSelectedAlertCameraInfo: setSelectedAlertCameraInfo,
                            setIgnoreZonesSelectedAlert: setIgnoreZonesSelectedAlert,
                            userFilters: userFilters,
                            detectionType: detectionType,
                            outcomeFilterType: outcomeFilterType,
                            vlmFilterType: vlmFilterType,
                            getCurrentSelectedRowKey: getCurrentSelectedRowKey,
                            setVideoProcessing: setVideoProcessing,
                            useAsyncGeneration: useAsyncGeneration,
                            syncSelectedRowRef: syncSelectedRowRef,
                            compact: compact
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "flex w-full min-w-0 justify-center",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $82b86b959f12476e$export$913c7b0787442e36), {
                            detection_type: selectedRow.detection_type,
                            alertData: alertData,
                            setAlertData: setAlertData,
                            selectedRow: selectedRow,
                            setSelectedRow: setSelectedRow,
                            selectdButtonsFilled: selectdButtonsFilled,
                            setSelectedButtonsFilled: setSelectedButtonsFilled,
                            navigate: navigate,
                            setPageLoading: setPageLoading,
                            setButtonClicked: setButtonClicked,
                            setMP4URL: setMP4URL,
                            setVideoClipLoading: setVideoClipLoading,
                            setSeeMoreURL: setSeeMoreURL,
                            setForwardArrowDisabled: setForwardArrowDisabled,
                            setBackArrowDisabled: setBackArrowDisabled,
                            setShowRefreshButton: setShowRefreshButton,
                            setSelectedAlertCameraInfo: setSelectedAlertCameraInfo,
                            setIgnoreZonesSelectedAlert: setIgnoreZonesSelectedAlert,
                            userFilters: userFilters,
                            detectionType: detectionType,
                            outcomeFilterType: outcomeFilterType,
                            vlmFilterType: vlmFilterType,
                            getCurrentSelectedRowKey: getCurrentSelectedRowKey,
                            setVideoProcessing: setVideoProcessing,
                            useAsyncGeneration: useAsyncGeneration,
                            syncSelectedRowRef: syncSelectedRowRef,
                            compact: compact
                        })
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "flex w-full grow flex-col justify-center rounded border border-actuate-grey bg-[#F0F1F3] pt-2 pb-[10px]",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "px-2 text-center font-mulish text-[14px] text-actuate-blue",
                children: selectedRow.alert_labels ? `Was this alert a true ${(0, $36f1c5bc563bba72$export$1e43853507c2d294)(selectedRow.alert_labels)} detection?` : ""
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "grid w-full min-w-0 grid-cols-3 gap-2 px-2 pt-2",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "flex w-full min-w-0 justify-center",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $397f4ef6888b6958$export$88768068b77f1e25), {
                            selectdButtonsFilled: selectdButtonsFilled,
                            setSelectedButtonsFilled: setSelectedButtonsFilled,
                            alertData: alertData,
                            setAlertData: setAlertData,
                            selectedRow: selectedRow,
                            setSelectedRow: setSelectedRow,
                            navigate: navigate,
                            setPageLoading: setPageLoading,
                            setButtonClicked: setButtonClicked,
                            setMP4URL: setMP4URL,
                            setVideoClipLoading: setVideoClipLoading,
                            setSeeMoreURL: setSeeMoreURL,
                            setForwardArrowDisabled: setForwardArrowDisabled,
                            setBackArrowDisabled: setBackArrowDisabled,
                            setShowRefreshButton: setShowRefreshButton,
                            setSelectedAlertCameraInfo: setSelectedAlertCameraInfo,
                            setIgnoreZonesSelectedAlert: setIgnoreZonesSelectedAlert,
                            userFilters: userFilters,
                            detectionType: detectionType,
                            outcomeFilterType: outcomeFilterType,
                            vlmFilterType: vlmFilterType,
                            getCurrentSelectedRowKey: getCurrentSelectedRowKey,
                            setVideoProcessing: setVideoProcessing,
                            useAsyncGeneration: useAsyncGeneration,
                            syncSelectedRowRef: syncSelectedRowRef,
                            compact: compact
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "flex w-full min-w-0 justify-center",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $24d3387fa1eb3011$export$576ae02131407312), {
                            detection_type: selectedRow.detection_type,
                            alertData: alertData,
                            setAlertData: setAlertData,
                            selectedRow: selectedRow,
                            setSelectedRow: setSelectedRow,
                            selectdButtonsFilled: selectdButtonsFilled,
                            setSelectedButtonsFilled: setSelectedButtonsFilled,
                            navigate: navigate,
                            setPageLoading: setPageLoading,
                            setButtonClicked: setButtonClicked,
                            setMP4URL: setMP4URL,
                            setVideoClipLoading: setVideoClipLoading,
                            setSeeMoreURL: setSeeMoreURL,
                            setForwardArrowDisabled: setForwardArrowDisabled,
                            setBackArrowDisabled: setBackArrowDisabled,
                            setShowRefreshButton: setShowRefreshButton,
                            setSelectedAlertCameraInfo: setSelectedAlertCameraInfo,
                            setIgnoreZonesSelectedAlert: setIgnoreZonesSelectedAlert,
                            userFilters: userFilters,
                            detectionType: detectionType,
                            outcomeFilterType: outcomeFilterType,
                            vlmFilterType: vlmFilterType,
                            getCurrentSelectedRowKey: getCurrentSelectedRowKey,
                            setVideoProcessing: setVideoProcessing,
                            useAsyncGeneration: useAsyncGeneration,
                            syncSelectedRowRef: syncSelectedRowRef,
                            compact: compact
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "flex w-full min-w-0 justify-center",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $82b86b959f12476e$export$913c7b0787442e36), {
                            detection_type: selectedRow.detection_type,
                            alertData: alertData,
                            setAlertData: setAlertData,
                            selectedRow: selectedRow,
                            setSelectedRow: setSelectedRow,
                            selectdButtonsFilled: selectdButtonsFilled,
                            setSelectedButtonsFilled: setSelectedButtonsFilled,
                            navigate: navigate,
                            setPageLoading: setPageLoading,
                            setButtonClicked: setButtonClicked,
                            setMP4URL: setMP4URL,
                            setVideoClipLoading: setVideoClipLoading,
                            setSeeMoreURL: setSeeMoreURL,
                            setForwardArrowDisabled: setForwardArrowDisabled,
                            setBackArrowDisabled: setBackArrowDisabled,
                            setShowRefreshButton: setShowRefreshButton,
                            setSelectedAlertCameraInfo: setSelectedAlertCameraInfo,
                            setIgnoreZonesSelectedAlert: setIgnoreZonesSelectedAlert,
                            userFilters: userFilters,
                            detectionType: detectionType,
                            outcomeFilterType: outcomeFilterType,
                            vlmFilterType: vlmFilterType,
                            getCurrentSelectedRowKey: getCurrentSelectedRowKey,
                            setVideoProcessing: setVideoProcessing,
                            useAsyncGeneration: useAsyncGeneration,
                            syncSelectedRowRef: syncSelectedRowRef,
                            compact: compact
                        })
                    })
                ]
            })
        ]
    });
};


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
var $fIsAN = parcelRequire("fIsAN");

var $hAnMZ = parcelRequire("hAnMZ");


var $5L5iJ = parcelRequire("5L5iJ");



var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $d48a20dfd96c3668$export$2361627156cf7f48 = (setParentAccountsLoading, setParentAccounts, setParentIds, setParentNames, navigate)=>{
    setParentAccountsLoading(true);
    const AxiosUI = (0, $195EM.createApi)("");
    AxiosUI.get("group/?parent_account=true&page_size=10000").then((response)=>{
        const results = response.data.results;
        setParentAccounts(results);
        const parentIds = new Map();
        const parentNames = new Map();
        results.forEach((object)=>{
            // Consider defining a specific type for `object`
            parentIds.set(object.name, object.id);
            parentNames.set(object.id, object.name);
        });
        setParentIds(parentIds);
        setParentNames(parentNames);
        setParentAccountsLoading(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, ()=>$d48a20dfd96c3668$export$2361627156cf7f48(setParentAccountsLoading, setParentAccounts, setParentIds, setParentNames, navigate), ()=>{
            setParentAccounts([]);
            setParentAccountsLoading(false);
        });
    });
}; // import React from "react";
 // import { createApi } from "../utils/createApi";
 // import { AxiosError, AxiosResponse } from "axios";
 // import { NavigateFunction } from "react-router-dom";
 // import { Dispatcher } from "../pages/Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
 // import { universalAPIErrorHandler } from "./universalAPIErrorHandler";
 // export const getParentAccounts = (
 //   setParentAccountsLoading: Dispatcher<boolean>,
 //   setParentAccounts: any,
 //   setParentIds: any,
 //   setParentNames: any,
 //   navigate: NavigateFunction
 // ) => {
 //   const retryFunction = () => {
 //     getParentAccounts(
 //       setParentAccountsLoading,
 //       setParentAccounts,
 //       setParentIds,
 //       setParentNames,
 //       navigate
 //     );
 //   };
 //   const AxiosUI = createApi(``);
 //   const parentIds = new Map();
 //   const parentNames = new Map();
 //   AxiosUI.get(`group/?parent_account=true&page_size=10000`).then(
 //     (response: AxiosResponse) => {
 //       setParentAccounts(response.data.results);
 //       response.data.results.forEach((object: any) => {
 //         parentIds.set(object.name, object.id);
 //       });
 //       response.data.results.forEach((object: any) => {
 //         parentNames.set(object.id, object.name);
 //       });
 //       setParentIds(parentIds);
 //       setParentNames(parentNames);
 //       setParentAccountsLoading(false);
 //     },
 //     (reason: AxiosError) => {
 //       universalAPIErrorHandler(reason, navigate, retryFunction, () => {
 //         setParentAccounts([]);
 //         setParentAccountsLoading(false);
 //       });
 //     }
 //   );
 // };





var $gk2F6 = parcelRequire("gk2F6");



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $hfM8m = parcelRequire("hfM8m");

var $hwWkD = parcelRequire("hwWkD");


var $eejVe = parcelRequire("eejVe");

var $5L5iJ = parcelRequire("5L5iJ");

var $iKAtE = parcelRequire("iKAtE");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");

var $i5MAs = parcelRequire("i5MAs");

var $aYdit = parcelRequire("aYdit");

var $jgags = parcelRequire("jgags");

const $f4d34d563874b92a$export$66d91271a14601c5 = (selectedDate)=>{
    const currentDate = new Date();
    const formattedCurrentDate = currentDate.toDateString(); // Get the current date without time
    const selectedDateObj = new Date(selectedDate);
    const formattedSelectedDate = selectedDateObj.toDateString(); // Get the selected date without time
    return formattedSelectedDate === formattedCurrentDate;
};
const $f4d34d563874b92a$export$e3e45797a05b86cf = ({ userFilters: userFilters, setUserFilters: setUserFilters, siteOptions: siteOptions, setTimeFiltersDisabled: setTimeFiltersDisabled, warningIssued: warningIssued, setWarningIssued: setWarningIssued })=>{
    const parentAccounts = JSON.parse(localStorage?.getItem?.("parentAccounts") ?? "[]");
    const siteIds = new Map();
    siteOptions.forEach((object)=>{
        siteIds.set(object.name, object.id);
    });
    const parentIds = new Map();
    parentAccounts.forEach((object)=>{
        parentIds.set(object.name, object.id);
    });
    const [endTimeAnchorEl, setEndTimeAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const endTimeOpen = Boolean(endTimeAnchorEl);
    const handleEndTimeClick = (event)=>{
        // event.stopPropagation(); // Stop event propagation to prevent table sorting
        setEndTimeAnchorEl(event.currentTarget);
    };
    const handleEndTimeClose = (event)=>{
        event.stopPropagation(); // Stop event propagation to prevent table sorting
        setEndTimeAnchorEl(null);
    };
    const { dateMMDDYYYY: dateMMDDYYYY, setDateMMDDYYYY: setDateMMDDYYYY } = (0, $aYdit.useAppStore)();
    const selectedLocale = dateMMDDYYYY ? (0, $jgags.default) : (0, $253608f850203ed2$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
        dateAdapter: (0, $hfM8m.AdapterDateFns),
        adapterLocale: selectedLocale,
        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
            className: "w-full",
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cbaf068f14972fdf$export$5109c6dd95d8fb00), {
                label: userFilters.end_date ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                            children: `End Date`
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                    "aria-label": "more",
                                    id: "long-button",
                                    "aria-controls": endTimeOpen ? "long-menu" : undefined,
                                    "aria-expanded": endTimeOpen ? "true" : undefined,
                                    "aria-haspopup": "true",
                                    onClick: handleEndTimeClick,
                                    sx: {
                                        marginLeft: "5px",
                                        padding: 0,
                                        color: "#000000",
                                        "&:hover": {
                                            backgroundColor: "transparent"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5MAs))), {})
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                                    id: "long-menu",
                                    MenuListProps: {
                                        "aria-labelledby": "long-button"
                                    },
                                    anchorOrigin: {
                                        vertical: "top",
                                        horizontal: "left"
                                    },
                                    transformOrigin: {
                                        vertical: "top",
                                        horizontal: "left"
                                    },
                                    anchorEl: endTimeAnchorEl,
                                    open: endTimeOpen,
                                    onClose: handleEndTimeClose,
                                    slotProps: {
                                        paper: {
                                            style: {
                                                maxHeight: 216,
                                                width: "20ch"
                                            }
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                            onClick: (event)=>{
                                                setDateMMDDYYYY(true);
                                                handleEndTimeClose(event);
                                            },
                                            children: "MM/DD/YYYY"
                                        }, "mm-dd-yyyy-end"),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                            onClick: (event)=>{
                                                setDateMMDDYYYY(false);
                                                handleEndTimeClose(event);
                                            },
                                            children: "DD/MM/YYYY"
                                        }, "dd-mm-yyyy-end")
                                    ]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                    children: "End Date"
                }),
                value: userFilters.end_date,
                onChange: (newValue)=>{
                    if (!warningIssued && !$f4d34d563874b92a$export$66d91271a14601c5(newValue)) {
                        alert(`Selecting any dates for start date or end date which are not the current date will prevent new alerts from being refreshed in the background`);
                        setWarningIssued(true);
                    }
                    if (newValue !== null) {
                        if (userFilters.start_date && newValue < userFilters.start_date) {
                            alert("End date cannot be before start date");
                            return;
                        }
                        setUserFilters((previousState)=>({
                                ...previousState,
                                end_date: newValue
                            }));
                    }
                    if (newValue === null) {
                        setTimeFiltersDisabled(true);
                        setUserFilters((previousState)=>{
                            return {
                                ...previousState,
                                end_date: null,
                                start_time: null,
                                end_time: null
                            };
                        });
                    }
                    if ((0, $5L5iJ.yyyymmddGenerator)(newValue) !== (0, $5L5iJ.yyyymmddGenerator)(userFilters.start_date)) {
                        setTimeFiltersDisabled(true);
                        setUserFilters((previousState)=>{
                            return {
                                ...previousState,
                                start_time: null,
                                end_time: null
                            };
                        });
                    }
                    if ((0, $5L5iJ.yyyymmddGenerator)(newValue) === (0, $5L5iJ.yyyymmddGenerator)(userFilters.start_date)) setTimeFiltersDisabled(false);
                },
                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        size: "small",
                        ...params,
                        inputProps: {
                            ...params.inputProps,
                            autoComplete: "off"
                        },
                        sx: (0, $30e263c4a2b86f06$export$74781f6aa62ac4d1)
                    })
            })
        })
    });
};




var $aYdit = parcelRequire("aYdit");

var $ebTQj = parcelRequire("ebTQj");


const $f4e2c8d6b10b3915$export$8239abe85d231080 = (setAlertData, navigate, setSelectedRow, setPageLoading, setSeeMoreURL, setMP4URL, userFilters, setThumbnailVideos, setDateOutsideRange, setVideoClipLoading, setAlertsToDisplay, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, setAlertsIndexOrder, setRefreshInterval, setFetchingFilteredData, setCurrentName, setPage, setSelectedButtonsFilled, setUserFilters, cameraOptions, siteOptions, setRefreshingData, pageLoadedNumber, refreshInterval, setParentAccountsLoading, setParentAccounts, setParentIds, setParentNames, setRefreshingToken, refreshingToken, setAlertLabels, setPeriodHours, setFiltersApplied, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setRowsSortable, setAlertsRefreshing, getCurrentSelectedRowKey, mutedAlertSites, mutedAlertCameras, setVideoProcessing)=>{
    const useAsyncGeneration = !userFilters?.has_video;
    const cameraIds = new Map();
    cameraOptions.forEach((object)=>{
        cameraIds.set(object.camera_name, object.id);
    });
    const siteIds = new Map();
    siteOptions.forEach((object)=>{
        siteIds.set(object.name, object.id);
    });
    const parentAccounts = JSON.parse(localStorage.parentAccounts);
    const parentIds = new Map();
    parentAccounts.forEach((object)=>{
        parentIds.set(object.name, object.id);
    });
    const { setNavigatedToAlertsFromAnalytics: setNavigatedToAlertsFromAnalytics, navigatedToAlertsFromAnalytics: navigatedToAlertsFromAnalytics } = (0, $aYdit.useAppStore).getState();
    const AxiosUI = (0, $hAnMZ.createMonitoringAPICall)(``);
    const retryFunction = ()=>{
        $f4e2c8d6b10b3915$export$8239abe85d231080(setAlertData, navigate, setSelectedRow, setPageLoading, setSeeMoreURL, setMP4URL, userFilters, setThumbnailVideos, setDateOutsideRange, setVideoClipLoading, setAlertsToDisplay, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, setAlertsIndexOrder, setRefreshInterval, setFetchingFilteredData, setCurrentName, setPage, setSelectedButtonsFilled, setUserFilters, cameraOptions, siteOptions, setRefreshingData, pageLoadedNumber, refreshInterval, setParentAccountsLoading, setParentAccounts, setParentIds, setParentNames, setRefreshingToken, refreshingToken, setAlertLabels, setPeriodHours, setFiltersApplied, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setRowsSortable, setAlertsRefreshing, getCurrentSelectedRowKey, mutedAlertSites, mutedAlertCameras, setVideoProcessing);
    };
    let searchParamsString = ``;
    const startDate = (0, $5L5iJ.yyyymmddGenerator)(userFilters.start_date);
    const endDate = (0, $5L5iJ.yyyymmddGenerator)(userFilters.end_date);
    if (startDate) searchParamsString += `&start=${startDate}`;
    if (endDate) searchParamsString += `&end=${endDate}`;
    if (userFilters.parent_group) {
        if (userFilters.parent_group !== "undefined") searchParamsString += `&group_id=${userFilters.parent_group}`;
    }
    if (userFilters.site) {
        if (userFilters.site !== "undefined") searchParamsString += `&customer_id=${userFilters.site}`;
    }
    if (userFilters.camera) {
        if (userFilters.camera !== "undefined") searchParamsString += `&camera_id=${userFilters.camera}`;
    }
    if (startDate && endDate) {
        if (startDate.toString() === endDate.toString() && userFilters.start_time !== null) searchParamsString += `&start_time=${(0, $gk2F6.timeSlicer)(userFilters.start_time)}`;
        if (startDate.toString() === endDate.toString() && userFilters.end_time !== null) searchParamsString += `&end_time=${(0, $gk2F6.timeSlicer)(userFilters.end_time)}`;
    }
    if (userFilters.has_video) searchParamsString += `&has_video=true`;
    // let noAlertsOutsideRange = true;
    const getAlertsFunction = async (refreshInt)=>{
        const filterType = userFilters.filter_type;
        (0, $ffd916f32bf91472$export$dda1917e5b995f19)();
        try {
            const responseData = await (0, $2b15fd61b31c2ea0$export$899219e2395ac333).getAlerts({
                filterType: filterType,
                searchParamsString: searchParamsString
            });
            // Hide muted alerts from the live (Unresolved) queue only — the
            // Resolved queue retains them, including for the muting user.
            const filteredRecords = (0, $94e6bb80767641a9$export$a2c9a5662351211)(filterType) ? responseData.records.filter((row)=>{
                return !(0, $94e6bb80767641a9$export$1874ac93f6160b49)(row, mutedAlertSites, mutedAlertCameras);
            }) : responseData.records;
            // Update responseData.records with filtered data
            // responseData.records = filteredRecords;
            (0, $09aa3d4abe0406ed$export$82ae3b5cddb8719c)(responseData, userFilters.parent_group, filterType, searchParamsString);
            (0, $d48a20dfd96c3668$export$2361627156cf7f48)(setParentAccountsLoading, setParentAccounts, setParentIds, setParentNames, navigate);
            if (responseData.parameters) {
                if (responseData.parameters.period_hours) setPeriodHours(responseData.parameters.period_hours);
            }
            if (navigatedToAlertsFromAnalytics) {
                setAlertsRefreshing(false);
                setNavigatedToAlertsFromAnalytics(false);
            }
            setRowsSortable(true);
            if (filteredRecords[0]) {
                setSelectedRow(filteredRecords[0]);
                (0, $e16b4c67693640c8$export$e44ee059113f075d)(filteredRecords[0], setSelectedButtonsFilled);
                localStorage.setItem("selectedRowAlerts", JSON.stringify(filteredRecords[0]));
                if (filteredRecords[0].camera_pk) (0, $b68d5e91295063d7$export$f4980018d5f7dd7)(filteredRecords[0].camera_pk, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, navigate);
                else {
                    setSelectedAlertCameraInfo({});
                    setIgnoreZonesSelectedAlert([]);
                }
            }
            setAlertData((0, $ae0eda0a8a76aaee$export$1ab6fea4cf8d4bfc)(responseData.records, setAlertsIndexOrder, (0, $94e6bb80767641a9$export$a2c9a5662351211)(filterType) ? mutedAlertSites : [], (0, $94e6bb80767641a9$export$a2c9a5662351211)(filterType) ? mutedAlertCameras : []));
            if (filteredRecords[0]) {
                (0, $6b057cfee512ff1e$export$c5f684b415548de8)(filteredRecords[0], navigate, setMP4URL, setVideoClipLoading, setShowRefreshButton, false, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration);
                setFetchingFilteredData(false);
                setPageLoading(false);
                setFiltersApplied(true);
                setAlertsToDisplay(true);
                setSeeMoreURL(filteredRecords[0].alert_url);
                if (responseData.records.length === 1) setForwardArrowDisabled(true);
                (0, $2f189bddd5c99efb$export$89bf317f972eb0c3)(responseData.records, setAlertLabels);
            } else {
                setPageLoading(false);
                setFiltersApplied(true);
            }
            if (localStorage.tokenRefreshing === "false" || localStorage.tokenRefreshing === undefined) {
                let dataRecordsTimeStamp = "";
                if (filteredRecords[0]) dataRecordsTimeStamp = filteredRecords[0].approx_capture_timestamp;
                if (userFilters.end_date && !(0, $f4d34d563874b92a$export$66d91271a14601c5)(userFilters.end_date)) setRowsSortable(true);
                else setRowsSortable(false);
                if ((!startDate || startDate === "") && (!endDate || endDate === "") || startDate && startDate !== "" && !endDate && (0, $f4d34d563874b92a$export$66d91271a14601c5)(startDate) || endDate && endDate !== "" && !startDate && (0, $f4d34d563874b92a$export$66d91271a14601c5)(endDate) || startDate && startDate !== "" && endDate && endDate !== "" && (0, $f4d34d563874b92a$export$66d91271a14601c5)(startDate) && (0, $f4d34d563874b92a$export$66d91271a14601c5)(endDate)) {
                    if (!userFilters.end_time) (0, $50931580b7d7a15b$export$e3104307e6100e11)(setAlertData, navigate, userFilters.parent_group, userFilters.site, userFilters.camera, (0, $5L5iJ.yyyymmddGenerator)(userFilters.start_date), (0, $5L5iJ.yyyymmddGenerator)(userFilters.end_date), userFilters.start_time, userFilters.end_time, userFilters.filter_type, setSelectedRow, setRefreshingData, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, setAlertsIndexOrder, refreshInt, setRefreshInterval, pageLoadedNumber, setSeeMoreURL, setMP4URL, setVideoClipLoading, setSelectedButtonsFilled, setAlertsToDisplay, setCurrentName, setPage, setDateOutsideRange, setFetchingFilteredData, setPageLoading, setUserFilters, userFilters, cameraOptions, siteOptions, dataRecordsTimeStamp, setRefreshingToken, refreshingToken, responseData.records.length, setBackArrowDisabled, setForwardArrowDisabled, setShowRefreshButton, setAlertsRefreshing, false, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration);
                    else setAlertsRefreshing(false);
                }
            }
        } catch (error) {
            (0, $3Zv1D.universalAPIErrorHandler)(error, navigate, retryFunction, (context)=>{
                // Surface the failure (SUP-445): without this a 400/5xx from the
                // backend rendered as "No alerts to display".
                (0, $ffd916f32bf91472$export$936012393c4de259)(error, context);
                setPageLoading(false);
                setAlertsToDisplay(false);
            });
        }
    };
    if (userFilters.parent_group) AxiosUI.get(`group/${userFilters.parent_group}`).then((response)=>{
        if (response.data.refresh_interval_seconds) getAlertsFunction(response.data.refresh_interval_seconds * 1000);
        else getAlertsFunction(refreshInterval);
    }, (reason)=>{
        (0, $ebTQj.logger).log("error reason:", reason.message);
        getAlertsFunction(refreshInterval);
    });
    else getAlertsFunction(refreshInterval);
};



var $dHtmK = parcelRequire("dHtmK");

var $8jTCz = parcelRequire("8jTCz");

var $crpct = parcelRequire("crpct");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $iLEpm = parcelRequire("iLEpm");

var $8jTCz = parcelRequire("8jTCz");

var $iKAtE = parcelRequire("iKAtE");

var $433j1 = parcelRequire("433j1");

var $eejVe = parcelRequire("eejVe");
parcelRequire("8T3gX");

var $hAnMZ = parcelRequire("hAnMZ");

const $fc163f0d69722191$export$7f5c871a6de4801e = (selectedRow, noteText, setEditMode, alertData, setAlertData, setSelectedRow, navigate)=>{
    const AxiosUI = (0, $hAnMZ.createMonitoringAPICall)(``);
    const postedAlert = {
        approx_capture_timestamp: selectedRow.approx_capture_timestamp,
        window_id: selectedRow.window_id,
        alert_outcome: selectedRow.outcome_number,
        notes: noteText
    };
    const retryFunction = ()=>{
        $fc163f0d69722191$export$7f5c871a6de4801e(selectedRow, noteText, setEditMode, alertData, setAlertData, setSelectedRow, navigate);
    };
    AxiosUI.post(`alert/outcome/`, postedAlert).then(()=>{
        const newSelectedRow = selectedRow;
        const newAlertData = alertData;
        newAlertData.forEach((object, index)=>{
            if (newSelectedRow.approx_capture_timestamp === object.approx_capture_timestamp) newAlertData[index].notes = noteText;
        });
        setAlertData(newAlertData);
        localStorage.setItem("selectedRowAlerts", JSON.stringify(newSelectedRow));
        setSelectedRow(newSelectedRow);
        setEditMode(false);
    }, (reason)=>{
        (0, $c0b3a83d600c7aa1$export$5646bda7f69a98da)(reason, navigate, retryFunction, ()=>{
            alert("Error saving note, please try again");
        });
    });
};


parcelRequire("8T3gX");

var $hAnMZ = parcelRequire("hAnMZ");

const $41b53c433ea27c91$export$50138a98eba34a56 = (selectedRow, noteText, setEditMode, alertData, setAlertData, setSelectedRow, navigate)=>{
    const AxiosUI = (0, $hAnMZ.createMonitoringAPICall)(``);
    const postedAlert = {
        approx_capture_timestamp: selectedRow.approx_capture_timestamp,
        window_id: selectedRow.window_id,
        unresolved_notes: noteText
    };
    const retryFunction = ()=>{
        $41b53c433ea27c91$export$50138a98eba34a56(selectedRow, noteText, setEditMode, alertData, setAlertData, setSelectedRow, navigate);
    };
    AxiosUI.post(`alert/unresolved/`, postedAlert).then(()=>{
        const newSelectedRow = selectedRow;
        const newAlertData = alertData;
        newAlertData.forEach((object, index)=>{
            if (newSelectedRow.approx_capture_timestamp === object.approx_capture_timestamp) newAlertData[index].unresolved_notes = noteText;
        });
        setAlertData(newAlertData);
        localStorage.setItem("selectedRowAlerts", JSON.stringify(newSelectedRow));
        newSelectedRow.unresolved_notes = noteText;
        setSelectedRow(newSelectedRow);
        setEditMode(false);
    }, (reason)=>{
        (0, $c0b3a83d600c7aa1$export$5646bda7f69a98da)(reason, navigate, retryFunction, ()=>{
            alert("Error saving note, please try again");
        });
    });
};


parcelRequire("8T3gX");
const $05a40111e52c2aea$export$4356d16f4d68cf31 = (outcomeType)=>{
    switch(outcomeType){
        case "true_threat":
            return "True Threat";
        case "false_positive":
            return "False";
        case "true_non_threat":
            return "True Non-Threat";
        case "escalated_true_threat":
            return "Escalated True Threat";
        default:
            return "";
    }
};



var $aYdit = parcelRequire("aYdit");

const $8baed87f3c759bf6$export$132e12ea55142936 = ({ notesDialogOpen: notesDialogOpen, setNotesDialogOpen: setNotesDialogOpen, selectedRow: selectedRow, noteText: noteText, setNoteText: setNoteText, navigate: navigate, alertData: alertData, setAlertData: setAlertData, setSelectedRow: setSelectedRow })=>{
    const [editMode, setEditMode] = $8T3gX.useState(false);
    // ENG-1813: notes are written through the same permission as outcomes
    // (alert/unresolved/ and alert/outcome/), so without it the dialog is
    // read-only: notes still show, the Edit/Save controls do not.
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    const canEditNotes = (0, $c0b3a83d600c7aa1$export$544f58273da8c441)(userPermissions);
    $8T3gX.useEffect(()=>{
        if (!canEditNotes && editMode) setEditMode(false);
    }, [
        canEditNotes,
        editMode
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: notesDialogOpen,
        maxWidth: "xs",
        fullWidth: true,
        sx: {
            height: 750
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                "aria-label": "close",
                onClick: ()=>{
                    setNotesDialogOpen(false);
                    setNoteText("");
                },
                sx: {
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme)=>theme.palette.grey[500]
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                        sx: {
                            fontSize: 14,
                            fontFamily: "Mulish"
                        },
                        children: "Site Name"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                        sx: {
                            fontSize: 18,
                            fontFamily: "Mulish",
                            color: "rgb(0 0 0)"
                        },
                        children: selectedRow.customer_name
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                        sx: {
                            fontSize: 14,
                            fontFamily: "Mulish"
                        },
                        children: "Camera"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                        sx: {
                            fontSize: 18,
                            fontFamily: "Mulish",
                            color: "rgb(0 0 0)"
                        },
                        children: selectedRow.camera_name
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                        sx: {
                            fontSize: 14,
                            fontFamily: "Mulish"
                        },
                        children: "Outcome"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                        sx: {
                            fontSize: 18,
                            fontFamily: "Mulish",
                            color: "rgb(0 0 0)"
                        },
                        children: selectedRow.detection_type ? (0, $05a40111e52c2aea$export$4356d16f4d68cf31)(selectedRow.detection_type) : ""
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    !editMode && /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                        sx: {
                            fontSize: 14,
                            fontFamily: "Mulish"
                        },
                        children: "Notes"
                    }),
                    !editMode && /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                        sx: {
                            fontSize: 18,
                            fontFamily: "Mulish",
                            color: "rgb(0 0 0)",
                            maxWidth: 400
                        },
                        children: noteText ? noteText.split("\n").map((line, index)=>/*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                                children: [
                                    line,
                                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                                ]
                            }, index)) : ""
                    }),
                    editMode && /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        onChange: (event)=>{
                            const input = event.target.value;
                            if (input.length <= 1000) setNoteText(input);
                        },
                        value: noteText,
                        label: "Notes",
                        variant: "outlined",
                        multiline: true,
                        rows: 3,
                        sx: {
                            fontFamily: "Mulish",
                            width: 400
                        },
                        helperText: noteText ? `${noteText.length}/1000` : "0/1000"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                        children: [
                            canEditNotes && !editMode && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    setEditMode(true);
                                },
                                text: "Edit Note",
                                disabled: false
                            }),
                            canEditNotes && editMode && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    selectedRow.detection_type ? (0, $fc163f0d69722191$export$7f5c871a6de4801e)(selectedRow, noteText, setEditMode, alertData, setAlertData, setSelectedRow, navigate) : (0, $41b53c433ea27c91$export$50138a98eba34a56)(selectedRow, noteText, setEditMode, alertData, setAlertData, setSelectedRow, navigate);
                                },
                                text: "Save Changes",
                                disabled: false
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $3QMQN = parcelRequire("3QMQN");
var $kUcVg = parcelRequire("kUcVg");
var $1TOOV = parcelRequire("1TOOV");
var $4reBM = parcelRequire("4reBM");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

var $60vL1 = parcelRequire("60vL1");

parcelRequire("8T3gX");




const $1476c118ed5e23cf$export$394358f75a9145d3 = (selectedRow, setAlertIndex, setSelectedRow, alertData, navigate, setMP4URL, setVideoClipLoading, setSelectedButtonsFilled, setSeeMoreURL, setAlertData, setRefreshingData, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, alertsIndexOrder, detectionType, outcomeFilterType, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, mutedAlertSites, mutedAlertCameras, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration = true, setSelectedRowRef, vlmFilterType = "All", filterType = "UNCLAIMED")=>{
    const storedSort = (0, $6e02db388b82b823$export$d95673b906883801)();
    const listArgs = {
        alertData: alertData,
        detectionType: detectionType,
        outcomeFilterType: outcomeFilterType,
        mutedAlertSites: mutedAlertSites,
        mutedAlertCameras: mutedAlertCameras,
        filterType: filterType,
        order: storedSort.order,
        orderBy: storedSort.orderBy
    };
    const filteredBeforeVlm = (0, $6e02db388b82b823$export$6ee189a072663b57)(listArgs);
    const filteredAlertData = (0, $6e02db388b82b823$export$cdfae0e972447b21)({
        ...listArgs,
        vlmFilterType: vlmFilterType,
        showVlmFilters: true,
        applyMuteFilter: true
    });
    const currentIndex = filteredAlertData.findIndex((alert)=>(0, $6e02db388b82b823$export$7a01cfb15849021d)(alert, selectedRow));
    const hiddenByVlmFilter = currentIndex < 0 && vlmFilterType !== "All" && filteredAlertData.length > 0 && filteredBeforeVlm.some((alert)=>(0, $6e02db388b82b823$export$7a01cfb15849021d)(alert, selectedRow));
    if (!hiddenByVlmFilter && (!filteredAlertData || filteredAlertData.length <= 1 || currentIndex < 0)) {
        setBackArrowDisabled(true);
        setForwardArrowDisabled(true);
        setRefreshingData(false);
        return;
    }
    const nextIndex = currentIndex + 1;
    if (nextIndex >= filteredAlertData.length) {
        const arrows = (0, $6e02db388b82b823$export$c18f05524cab3606)(currentIndex, filteredAlertData.length);
        setForwardArrowDisabled(arrows.forwardDisabled);
        setBackArrowDisabled(arrows.backDisabled);
        setRefreshingData(false);
        return;
    }
    const nextArrows = (0, $6e02db388b82b823$export$c18f05524cab3606)(nextIndex, filteredAlertData.length);
    setBackArrowDisabled(nextArrows.backDisabled);
    setForwardArrowDisabled(nextArrows.forwardDisabled);
    const newSelectedRow = filteredAlertData[currentIndex + 1];
    setSelectedRow(newSelectedRow);
    if (setSelectedRowRef) setSelectedRowRef(newSelectedRow);
    localStorage.setItem("selectedRowAlerts", JSON.stringify(newSelectedRow));
    (0, $b68d5e91295063d7$export$f4980018d5f7dd7)(newSelectedRow.camera_pk, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, navigate);
    (0, $6b057cfee512ff1e$export$c5f684b415548de8)(newSelectedRow, navigate, setMP4URL, setVideoClipLoading, setShowRefreshButton, true, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration);
    (0, $e16b4c67693640c8$export$e44ee059113f075d)(newSelectedRow, setSelectedButtonsFilled);
    const newAlertData = alertData;
    const newSelectedRowIndex = alertData.findIndex((alert)=>(0, $6e02db388b82b823$export$7a01cfb15849021d)(alert, newSelectedRow));
    if (newSelectedRowIndex < 0) {
        setRefreshingData(false);
        return;
    }
    newAlertData.forEach((object)=>{
        object.selected = false;
    });
    newAlertData[newSelectedRowIndex].selected = true;
    setSeeMoreURL(newSelectedRow.alert_url);
    setAlertData(newAlertData);
    setRefreshingData(false);
};


parcelRequire("8T3gX");




const $03de40ac258827c1$export$9bb28914c0b5a1d2 = (selectedRow, setAlertIndex, setSelectedRow, alertData, navigate, setMP4URL, setVideoClipLoading, setSelectedButtonsFilled, setSeeMoreURL, setAlertData, setRefreshingData, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, alertsIndexOrder, detectionType, outcomeFilterType, setBackArrowDisabled, setForwardArrowDisabled, setShowRefreshButton, mutedAlertSites, mutedAlertCameras, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration = true, setSelectedRowRef, vlmFilterType = "All", filterType = "UNCLAIMED")=>{
    const storedSort = (0, $6e02db388b82b823$export$d95673b906883801)();
    const filteredAlertData = (0, $6e02db388b82b823$export$cdfae0e972447b21)({
        alertData: alertData,
        detectionType: detectionType,
        outcomeFilterType: outcomeFilterType,
        vlmFilterType: vlmFilterType,
        showVlmFilters: true,
        mutedAlertSites: mutedAlertSites,
        mutedAlertCameras: mutedAlertCameras,
        filterType: filterType,
        order: storedSort.order,
        orderBy: storedSort.orderBy,
        applyMuteFilter: true
    });
    const currentIndex = filteredAlertData.findIndex((alert)=>(0, $6e02db388b82b823$export$7a01cfb15849021d)(alert, selectedRow));
    if (!filteredAlertData || filteredAlertData.length <= 1 || currentIndex < 0) {
        setBackArrowDisabled(true);
        setForwardArrowDisabled(true);
        setRefreshingData(false);
        return;
    }
    const prevIndex = currentIndex - 1;
    if (prevIndex < 0) {
        const arrows = (0, $6e02db388b82b823$export$c18f05524cab3606)(currentIndex, filteredAlertData.length);
        setBackArrowDisabled(arrows.backDisabled);
        setForwardArrowDisabled(arrows.forwardDisabled);
        setRefreshingData(false);
        return;
    }
    const prevArrows = (0, $6e02db388b82b823$export$c18f05524cab3606)(prevIndex, filteredAlertData.length);
    setBackArrowDisabled(prevArrows.backDisabled);
    setForwardArrowDisabled(prevArrows.forwardDisabled);
    const newSelectedRow = filteredAlertData[currentIndex - 1];
    setSelectedRow(newSelectedRow);
    if (setSelectedRowRef) setSelectedRowRef(newSelectedRow);
    localStorage.setItem("selectedRowAlerts", JSON.stringify(newSelectedRow));
    (0, $b68d5e91295063d7$export$f4980018d5f7dd7)(newSelectedRow.camera_pk, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, navigate);
    (0, $6b057cfee512ff1e$export$c5f684b415548de8)(newSelectedRow, navigate, setMP4URL, setVideoClipLoading, setShowRefreshButton, true, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration);
    (0, $e16b4c67693640c8$export$e44ee059113f075d)(newSelectedRow, setSelectedButtonsFilled);
    const newAlertData = alertData;
    const newSelectedRowIndex = alertData.findIndex((alert)=>(0, $6e02db388b82b823$export$7a01cfb15849021d)(alert, newSelectedRow));
    if (newSelectedRowIndex < 0) {
        setRefreshingData(false);
        return;
    }
    newAlertData.forEach((object)=>{
        object.selected = false;
    });
    newAlertData[newSelectedRowIndex].selected = true;
    setSeeMoreURL(newSelectedRow.alert_url);
    setAlertData(newAlertData);
    setRefreshingData(false);
};



/**
 * Scroll container for the alert detail pane (header, clip, verdict buttons,
 * history table).
 *
 * `scrollbar-gutter: stable` is load-bearing, not cosmetic. The clip's width is
 * measured from inside this container with a ResizeObserver and its height is
 * derived from that width, so the pane's content height depends on the pane's
 * width. With a classic (layout-consuming) scrollbar — Windows, or macOS with
 * a mouse / "Always show scroll bars" — and content within one scrollbar's
 * worth of fitting, the scrollbar appearing shrank the clip enough to make the
 * content fit, which removed the scrollbar, which widened the clip again…
 * flipping between the two layouts on every frame (SUP-581, SUP-582; 5.3.11).
 * Reserving the gutter permanently means the scrollbar never changes the
 * measured width, so the loop cannot start.
 */ const $d6220914811f5775$export$90f70e9b247a5564 = "[scrollbar-gutter:stable]";
const $d6220914811f5775$export$fe17bacbe54340a2 = `min-h-0 min-w-0 max-w-full overflow-y-auto ${$d6220914811f5775$export$90f70e9b247a5564} pt-[10px] pb-2`;



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $iKAtE = parcelRequire("iKAtE");
var $bAwA3 = parcelRequire("bAwA3");
var $1fWBE = parcelRequire("1fWBE");
var $cxknk = parcelRequire("cxknk");
var $cVCJe = parcelRequire("cVCJe");
var $e30c86e2413d25c2$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($e30c86e2413d25c2$exports, "__esModule", {
    value: true
});
$e30c86e2413d25c2$exports.default = void 0;

var $e30c86e2413d25c2$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $e30c86e2413d25c2$var$_default = $e30c86e2413d25c2$exports.default = (0, $e30c86e2413d25c2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3z"
}), 'OpenInNew');


var $587cddf1e94c7e77$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($587cddf1e94c7e77$exports, "__esModule", {
    value: true
});
$587cddf1e94c7e77$exports.default = void 0;

var $587cddf1e94c7e77$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $587cddf1e94c7e77$var$_default = $587cddf1e94c7e77$exports.default = (0, $587cddf1e94c7e77$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3z"
}), 'OpenInNewOutlined');




var $i5MAs = parcelRequire("i5MAs");

const $9a906dc34b9865aa$export$da3753097ed14b63 = ({ siteName: siteName, cameraName: cameraName, siteHref: siteHref, cameraHref: cameraHref, alertLabels: alertLabels, siteTime: siteTime, seeMoreURL: seeMoreURL, canMute: canMute, isMuted: isMuted, onMute: onMute, onDownloadVideo: onDownloadVideo, canDownloadVideo: canDownloadVideo, onSiteVideoWall: onSiteVideoWall, canShowSiteVideoWall: canShowSiteVideoWall, onSeeIgnoreZones: onSeeIgnoreZones, onSeeLineCrossings: onSeeLineCrossings, showLineCrossings: showLineCrossings })=>{
    const [menuAnchor, setMenuAnchor] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const menuOpen = Boolean(menuAnchor);
    const handleCopyAlertLink = async ()=>{
        if (!seeMoreURL) return;
        try {
            await navigator.clipboard.writeText(seeMoreURL);
        } catch  {
            window.prompt("Copy alert link", seeMoreURL);
        }
        setMenuAnchor(null);
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "flex items-start justify-between gap-3 pb-2",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "min-w-0",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "flex flex-wrap items-center gap-x-1 font-mulish text-[14px] leading-tight",
                        children: [
                            siteHref ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                title: "Open site page",
                                placement: "top",
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)("a", {
                                    href: siteHref,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "inline-flex items-center gap-0.5 text-[#1976d2] underline",
                                    children: [
                                        siteName,
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($587cddf1e94c7e77$exports))), {
                                            sx: {
                                                fontSize: 14
                                            }
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                className: "text-actuate-blue",
                                children: siteName
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                className: "text-actuate-blue",
                                children: "/"
                            }),
                            cameraHref ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                title: "Open camera page",
                                placement: "top",
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)("a", {
                                    href: cameraHref,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "inline-flex items-center gap-0.5 text-[#1976d2] underline",
                                    children: [
                                        cameraName,
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($587cddf1e94c7e77$exports))), {
                                            sx: {
                                                fontSize: 14
                                            }
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                className: "text-actuate-blue",
                                children: cameraName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "mt-1 flex flex-wrap items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $46deb238b79847bd$export$baed8097318953ad), {
                                alertLabels: alertLabels
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                className: "font-mulish text-[12px] text-actuate-blue",
                                children: siteTime
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex shrink-0 items-center gap-1",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
                        type: "button",
                        onClick: ()=>window.open(seeMoreURL, "_blank"),
                        className: "inline-flex h-9 items-center gap-1 whitespace-nowrap rounded bg-actuate-orange px-3 font-mulish text-[13px] font-bold text-white",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e30c86e2413d25c2$exports))), {
                                sx: {
                                    fontSize: 16
                                }
                            }),
                            "See alert"
                        ]
                    }),
                    canMute && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                        title: isMuted ? "Alerts already muted for this site or camera." : "Mute alerts",
                        placement: "top",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                "aria-label": "Mute alerts",
                                onClick: onMute,
                                disabled: isMuted,
                                size: "small",
                                sx: {
                                    color: "#001943"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ec84ed9eb84fe0cb$exports))), {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                        "aria-label": "More alert actions",
                        onClick: (event)=>setMenuAnchor(event.currentTarget),
                        size: "small",
                        sx: {
                            color: "#001943"
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5MAs))), {})
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                        anchorEl: menuAnchor,
                        open: menuOpen,
                        onClose: ()=>setMenuAnchor(null),
                        MenuListProps: {
                            "aria-label": "Alert actions"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $bAwA3.default), {
                                className: "font-mulish",
                                children: "Clip"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                disabled: !canDownloadVideo,
                                onClick: ()=>{
                                    onDownloadVideo();
                                    setMenuAnchor(null);
                                },
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: "Download video"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                disabled: !canShowSiteVideoWall,
                                onClick: ()=>{
                                    onSiteVideoWall();
                                    setMenuAnchor(null);
                                },
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: "Site video wall"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $bAwA3.default), {
                                className: "font-mulish",
                                children: "Camera"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                onClick: ()=>{
                                    onSeeIgnoreZones();
                                    setMenuAnchor(null);
                                },
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: "See ignore zones"
                            }),
                            showLineCrossings && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                onClick: ()=>{
                                    onSeeLineCrossings();
                                    setMenuAnchor(null);
                                },
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: "See line crossings"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                onClick: handleCopyAlertLink,
                                sx: {
                                    fontFamily: "Mulish"
                                },
                                children: "Copy alert link"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/* eslint-disable jsx-a11y/media-has-caption */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");



var $2zBdB = parcelRequire("2zBdB");
var $605af9bcde39fb3a$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($605af9bcde39fb3a$exports, "__esModule", {
    value: true
});
$605af9bcde39fb3a$exports.default = void 0;

var $605af9bcde39fb3a$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $605af9bcde39fb3a$var$_default = $605af9bcde39fb3a$exports.default = (0, $605af9bcde39fb3a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M6 19h4V5H6zm8-14v14h4V5z"
}), 'Pause');


var $c368c1d0d7f3677e$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($c368c1d0d7f3677e$exports, "__esModule", {
    value: true
});
$c368c1d0d7f3677e$exports.default = void 0;

var $c368c1d0d7f3677e$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $c368c1d0d7f3677e$var$_default = $c368c1d0d7f3677e$exports.default = (0, $c368c1d0d7f3677e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M8 5v14l11-7z"
}), 'PlayArrow');



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");
const $db79d6ea551e2d43$export$968d76c8bd522229 = (containerWidth, containerHeight, mediaWidth, mediaHeight)=>{
    if (!containerWidth || !containerHeight || !mediaWidth || !mediaHeight) return {
        x: 0,
        y: 0,
        width: containerWidth,
        height: containerHeight
    };
    const scale = Math.min(containerWidth / mediaWidth, containerHeight / mediaHeight);
    const width = mediaWidth * scale;
    const height = mediaHeight * scale;
    return {
        x: (containerWidth - width) / 2,
        y: (containerHeight - height) / 2,
        width: width,
        height: height
    };
};
const $db79d6ea551e2d43$export$8761bd123cfa7819 = (coordinates)=>{
    if (!Array.isArray(coordinates) || coordinates.length === 0) return [];
    const first = coordinates[0];
    if (!Array.isArray(first)) return [];
    if (typeof first[0] === "number") return [
        coordinates
    ];
    return coordinates.filter((polygon)=>Array.isArray(polygon) && polygon.length > 0);
};
const $db79d6ea551e2d43$export$57024467efe7c07b = (polygon)=>polygon.filter((point)=>Array.isArray(point) && point.length >= 2).map(([x, y])=>`${x},${y}`).join(" ");
const $db79d6ea551e2d43$export$7bb59b5043ab0a17 = ({ durationSeconds: durationSeconds, approxCaptureTimestamp: approxCaptureTimestamp, clipStartTimestamp: clipStartTimestamp })=>{
    // `null` = unknown: the player hides the marker rather than drawing it at
    // an invented mid-clip position (ENG-1663).
    if (!durationSeconds || durationSeconds <= 0) return null;
    if (approxCaptureTimestamp == null || clipStartTimestamp == null || approxCaptureTimestamp === "" || clipStartTimestamp === "") return null;
    let capture = Number(approxCaptureTimestamp);
    let start = Number(clipStartTimestamp);
    if (!Number.isFinite(capture) || !Number.isFinite(start)) return null;
    if (capture > 1e12) capture /= 1000;
    if (start > 1e12) start /= 1000;
    const offset = capture - start;
    if (offset >= 0 && offset <= durationSeconds) return offset / durationSeconds;
    return null;
};
const $db79d6ea551e2d43$export$560adc7f37ada25 = (seconds)=>{
    if (!Number.isFinite(seconds) || seconds < 0) return "0:00";
    const total = Math.floor(seconds);
    const minutes = Math.floor(total / 60);
    const remainder = total % 60;
    return `${minutes}:${remainder.toString().padStart(2, "0")}`;
};


const $e036bf36ccf8adac$export$7c5c2d48052ffc0f = (ignoreZones)=>ignoreZones.filter((zone)=>(0, $db79d6ea551e2d43$export$8761bd123cfa7819)(zone.coordinates).length > 0).length;
const $e036bf36ccf8adac$export$265bb9ca2fdc7d1d = ({ contentRect: contentRect, ignoreZones: ignoreZones, lineCrossings: lineCrossings, showIgnoreZones: showIgnoreZones, showLineCrossings: showLineCrossings })=>{
    if (!showIgnoreZones && !showLineCrossings) return null;
    if (!contentRect.width || !contentRect.height) return null;
    // The ignore_zones endpoint returns one entry per zone *type* the camera
    // supports, whether or not anything is drawn for it. Only zones with at
    // least one polygon are active, so count those (same rule the SVG uses).
    const zoneCount = showIgnoreZones ? $e036bf36ccf8adac$export$7c5c2d48052ffc0f(ignoreZones) : 0;
    const crossingCount = showLineCrossings ? lineCrossings.length : 0;
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("svg", {
                className: "pointer-events-none absolute",
                viewBox: "0 0 1 1",
                preserveAspectRatio: "none",
                style: {
                    left: contentRect.x,
                    top: contentRect.y,
                    width: contentRect.width,
                    height: contentRect.height
                },
                children: [
                    showIgnoreZones && ignoreZones.map((zone, zoneIndex)=>(0, $db79d6ea551e2d43$export$8761bd123cfa7819)(zone.coordinates).map((polygon, polygonIndex)=>/*#__PURE__*/ (0, $k4ank.jsx)("polygon", {
                                points: (0, $db79d6ea551e2d43$export$57024467efe7c07b)(polygon),
                                stroke: zone.line_color || "#FF8400",
                                strokeWidth: "0.006",
                                fill: zone.line_color || "#FF8400",
                                fillOpacity: "0.28"
                            }, `${zone.label || zoneIndex}-${polygonIndex}`))),
                    showLineCrossings && lineCrossings.map((line, index)=>{
                        const [start, end] = line.coordinates || [];
                        if (!start || !end) return null;
                        return /*#__PURE__*/ (0, $k4ank.jsx)("line", {
                            x1: start[0],
                            y1: start[1],
                            x2: end[0],
                            y2: end[1],
                            stroke: line.color || "#0288D1",
                            strokeWidth: "0.01"
                        }, line.id ?? index);
                    })
                ]
            }),
            (zoneCount > 0 || crossingCount > 0) && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "absolute left-2 top-2 z-10 rounded bg-black/65 px-2 py-1 font-mulish text-[11px] font-bold text-white",
                children: [
                    zoneCount > 0 && `${zoneCount} active ignore zone${zoneCount === 1 ? "" : "s"}`,
                    zoneCount > 0 && crossingCount > 0 && " \xb7 ",
                    crossingCount > 0 && `${crossingCount} line crossing${crossingCount === 1 ? "" : "s"}`
                ]
            })
        ]
    });
};



const $5b0f4cdaaaa7c62e$export$f7b8859931844aee = 250;
const $5b0f4cdaaaa7c62e$var$getFullscreenElement = ()=>{
    const doc = document;
    return doc.fullscreenElement ?? doc.webkitFullscreenElement ?? null;
};
const $5b0f4cdaaaa7c62e$var$getViewportSize = ()=>({
        width: window.innerWidth,
        height: window.innerHeight
    });
const $5b0f4cdaaaa7c62e$export$e174bedc18cda727 = ({ src: src, width: width, height: height, videoKey: videoKey, approxCaptureTimestamp: approxCaptureTimestamp, clipStartTimestamp: clipStartTimestamp, ignoreZones: ignoreZones, lineCrossings: lineCrossings, showIgnoreZones: showIgnoreZones, showLineCrossings: showLineCrossings, canDownload: canDownload = false, onDownload: onDownload })=>{
    const videoRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const clickTimerRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const [isFullscreen, setIsFullscreen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [viewportSize, setViewportSize] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState($5b0f4cdaaaa7c62e$var$getViewportSize);
    const [isPlaying, setIsPlaying] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [currentTime, setCurrentTime] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [duration, setDuration] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [mediaSize, setMediaSize] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        width: 0,
        height: 0
    });
    const syncFromVideo = ()=>{
        const video = videoRef.current;
        if (!video) return;
        setCurrentTime(video.currentTime || 0);
        setDuration(video.duration && Number.isFinite(video.duration) ? video.duration : 0);
        setIsPlaying(!video.paused);
        if (video.videoWidth && video.videoHeight) setMediaSize({
            width: video.videoWidth,
            height: video.videoHeight
        });
    };
    const handleTogglePlay = ()=>{
        const video = videoRef.current;
        if (!video) return;
        if (video.paused) video.play();
        else video.pause();
    };
    const clearClickTimer = ()=>{
        if (clickTimerRef.current !== null) {
            window.clearTimeout(clickTimerRef.current);
            clickTimerRef.current = null;
        }
    };
    const handleVideoClick = ()=>{
        clearClickTimer();
        clickTimerRef.current = window.setTimeout(()=>{
            clickTimerRef.current = null;
            handleTogglePlay();
        }, $5b0f4cdaaaa7c62e$export$f7b8859931844aee);
    };
    const handleToggleFullscreen = ()=>{
        const container = containerRef.current;
        if (!container) return;
        const doc = document;
        // Fullscreen the container, not the <video>, so the zone overlays and
        // this control bar come along.
        const request = $5b0f4cdaaaa7c62e$var$getFullscreenElement() ? doc.exitFullscreen?.bind(doc) ?? doc.webkitExitFullscreen?.bind(doc) : container.requestFullscreen?.bind(container) ?? container.webkitRequestFullscreen?.bind(container);
        try {
            // Rejects when the browser refuses (e.g. no user gesture); nothing to do.
            Promise.resolve(request?.()).catch(()=>undefined);
        } catch  {
        // The prefixed API throws instead of rejecting.
        }
    };
    const handleVideoDoubleClick = ()=>{
        clearClickTimer();
        handleToggleFullscreen();
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        const handleFullscreenChange = ()=>{
            const active = $5b0f4cdaaaa7c62e$var$getFullscreenElement() !== null && $5b0f4cdaaaa7c62e$var$getFullscreenElement() === containerRef.current;
            setIsFullscreen(active);
            if (active) setViewportSize($5b0f4cdaaaa7c62e$var$getViewportSize());
        };
        const handleResize = ()=>setViewportSize($5b0f4cdaaaa7c62e$var$getViewportSize());
        document.addEventListener("fullscreenchange", handleFullscreenChange);
        document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
        window.addEventListener("resize", handleResize);
        return ()=>{
            document.removeEventListener("fullscreenchange", handleFullscreenChange);
            document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
            window.removeEventListener("resize", handleResize);
            clearClickTimer();
        };
    }, []);
    const handleSeek = (event)=>{
        const video = videoRef.current;
        if (!video) return;
        const nextTime = Number(event.target.value);
        video.currentTime = nextTime;
        setCurrentTime(nextTime);
    };
    // In fullscreen the container fills the screen, so the overlays have to be
    // laid out against the screen, not the pane size we were given.
    const playerWidth = isFullscreen ? viewportSize.width : width;
    const playerHeight = isFullscreen ? viewportSize.height : height;
    const contentRect = (0, $db79d6ea551e2d43$export$968d76c8bd522229)(playerWidth, playerHeight, mediaSize.width, mediaSize.height);
    const markerRatio = (0, $db79d6ea551e2d43$export$7bb59b5043ab0a17)({
        durationSeconds: duration,
        approxCaptureTimestamp: approxCaptureTimestamp,
        clipStartTimestamp: clipStartTimestamp
    });
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        ref: containerRef,
        className: "relative bg-black",
        style: {
            width: playerWidth,
            height: playerHeight
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("video", {
                ref: videoRef,
                className: "block h-full w-full object-contain",
                autoPlay: true,
                loop: true,
                preload: "auto",
                onClick: handleVideoClick,
                onDoubleClick: handleVideoDoubleClick,
                onPlay: syncFromVideo,
                onPause: syncFromVideo,
                onTimeUpdate: syncFromVideo,
                onLoadedMetadata: syncFromVideo,
                onDurationChange: syncFromVideo,
                children: /*#__PURE__*/ (0, $k4ank.jsx)("source", {
                    src: src,
                    type: "video/mp4"
                })
            }, videoKey),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $e036bf36ccf8adac$export$265bb9ca2fdc7d1d), {
                contentRect: contentRect,
                ignoreZones: ignoreZones,
                lineCrossings: lineCrossings,
                showIgnoreZones: showIgnoreZones,
                showLineCrossings: showLineCrossings
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "absolute inset-x-0 bottom-0 z-10 bg-gradient-to-t from-black/80 to-transparent px-2 pb-1.5 pt-6",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "relative mb-1 h-2",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("input", {
                                type: "range",
                                min: 0,
                                max: duration || 0,
                                step: 0.05,
                                value: Math.min(currentTime, duration || 0),
                                onChange: handleSeek,
                                "aria-label": "Clip progress",
                                className: "absolute inset-0 z-10 h-2 w-full cursor-pointer appearance-none bg-transparent"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "pointer-events-none absolute inset-x-0 top-1/2 h-1 -translate-y-1/2 rounded bg-white/35"
                            }),
                            markerRatio !== null && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "pointer-events-none absolute top-1/2 z-20 h-2 w-0.5 -translate-y-1/2 bg-actuate-orange",
                                style: {
                                    left: `${markerRatio * 100}%`
                                },
                                "aria-hidden": true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "flex items-center gap-2 text-white",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                type: "button",
                                onClick: handleTogglePlay,
                                "aria-label": isPlaying ? "Pause" : "Play",
                                className: "flex h-7 w-7 items-center justify-center",
                                children: isPlaying ? /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($605af9bcde39fb3a$exports))), {
                                    fontSize: "small"
                                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c368c1d0d7f3677e$exports))), {
                                    fontSize: "small"
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                                className: "font-mulish text-[11px] tabular-nums",
                                children: [
                                    (0, $db79d6ea551e2d43$export$560adc7f37ada25)(currentTime),
                                    " / ",
                                    (0, $db79d6ea551e2d43$export$560adc7f37ada25)(duration)
                                ]
                            }),
                            onDownload && /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                type: "button",
                                onClick: onDownload,
                                disabled: !canDownload,
                                "aria-label": "Download video",
                                title: "Download video",
                                className: "ml-auto flex h-7 w-7 items-center justify-center disabled:cursor-default disabled:opacity-40",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2zBdB))), {
                                    fontSize: "small"
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                type: "button",
                                onClick: handleToggleFullscreen,
                                "aria-label": isFullscreen ? "Exit full screen" : "Full screen",
                                title: isFullscreen ? "Exit full screen" : "Full screen",
                                className: `${onDownload ? "" : "ml-auto "}flex h-7 w-7 items-center justify-center`,
                                children: isFullscreen ? /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2ef2d4a2b40b785b$exports))), {
                                    fontSize: "small"
                                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($36ccc3b2bca62ab4$exports))), {
                                    fontSize: "small"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");
var $067eb26bd2e21768$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($067eb26bd2e21768$exports, "__esModule", {
    value: true
});
$067eb26bd2e21768$exports.default = void 0;

var $067eb26bd2e21768$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $067eb26bd2e21768$var$_default = $067eb26bd2e21768$exports.default = (0, $067eb26bd2e21768$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2M8 20H4v-4h4zm0-6H4v-4h4zm0-6H4V4h4zm6 12h-4v-4h4zm0-6h-4v-4h4zm0-6h-4V4h4zm6 12h-4v-4h4zm0-6h-4v-4h4zm0-6h-4V4h4z"
}), 'GridOn');


var $06d43940eb4417df$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($06d43940eb4417df$exports, "__esModule", {
    value: true
});
$06d43940eb4417df$exports.default = void 0;

var $06d43940eb4417df$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $06d43940eb4417df$var$_default = $06d43940eb4417df$exports.default = (0, $06d43940eb4417df$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M19 5v9h-5v5H5V5zm0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10l6-6V5c0-1.1-.9-2-2-2m-7 11H7v-2h5zm5-4H7V8h10z"
}), 'StickyNote2Outlined');



var $8jTCz = parcelRequire("8jTCz");
const $92f1f3dee329c8aa$export$8da4def50d61aa89 = ({ showIgnoreZones: showIgnoreZones, showLineCrossings: showLineCrossings, onToggleIgnoreZones: onToggleIgnoreZones, onToggleLineCrossings: onToggleLineCrossings, canShowLineCrossings: canShowLineCrossings, canShowSiteVideoWall: canShowSiteVideoWall, onSiteVideoWall: onSiteVideoWall, canViewProtocolNotes: canViewProtocolNotes = false, onViewProtocolNotes: onViewProtocolNotes })=>{
    return(// Two columns: show-chips on the left, protocol notes / wall on the right.
    // min-h keeps the row the same height between alerts whichever controls
    // are showing.
    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "mt-1 grid min-h-[30px] grid-cols-[minmax(0,1fr)_auto] items-center gap-2",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex flex-wrap items-center gap-2",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                        className: "font-mulish text-[11px] font-bold text-actuate-blue",
                        children: "Show:"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                        type: "button",
                        onClick: onToggleIgnoreZones,
                        className: `rounded-full border px-2 py-0.5 font-mulish text-[11px] font-bold ${showIgnoreZones ? "border-actuate-orange bg-actuate-orange text-white" : "border-actuate-blue/30 bg-white text-actuate-blue"}`,
                        children: "Ignore zones"
                    }),
                    canShowLineCrossings && /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                        type: "button",
                        onClick: onToggleLineCrossings,
                        className: `rounded-full border px-2 py-0.5 font-mulish text-[11px] font-bold ${showLineCrossings ? "border-actuate-orange bg-actuate-orange text-white" : "border-actuate-blue/30 bg-white text-actuate-blue"}`,
                        children: "Line crossings"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex items-center justify-end gap-2",
                children: [
                    canViewProtocolNotes && onViewProtocolNotes && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        text: /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                            className: "inline-flex items-center gap-1 font-mulish text-[11px] font-bold",
                            children: [
                                "View Protocol / Notes",
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($06d43940eb4417df$exports))), {
                                    fontSize: "small"
                                })
                            ]
                        }),
                        onClick: onViewProtocolNotes,
                        disabled: false,
                        sx: {
                            minWidth: "auto",
                            padding: "2px 4px"
                        }
                    }),
                    canShowSiteVideoWall && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        text: /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                            className: "inline-flex items-center gap-1 font-mulish text-[11px] font-bold",
                            children: [
                                "Site Video Wall",
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($067eb26bd2e21768$exports))), {
                                    fontSize: "small"
                                })
                            ]
                        }),
                        onClick: onSiteVideoWall,
                        disabled: false,
                        sx: {
                            minWidth: "auto",
                            padding: "2px 4px"
                        }
                    })
                ]
            })
        ]
    }));
};


const $c20b65e3c5a5154b$export$58291b75bed158c8 = "alertsTableDensity";
const $c20b65e3c5a5154b$export$f250cd4746414cf4 = 1150;
const $c20b65e3c5a5154b$export$d535640177923c2e = 1400;
const $c20b65e3c5a5154b$export$7ecdc8972c71c558 = 850;
const $c20b65e3c5a5154b$export$9692675834824848 = (windowWidth)=>Math.max(windowWidth, $c20b65e3c5a5154b$export$7ecdc8972c71c558);
const $c20b65e3c5a5154b$export$4462e54cf073388e = ()=>{
    try {
        const value = localStorage.getItem($c20b65e3c5a5154b$export$58291b75bed158c8);
        if (value === "detailed" || value === "condensed") return value;
    } catch  {
    // Ignore quota / private-mode failures and fall back to auto.
    }
    return null;
};
const $c20b65e3c5a5154b$export$1fca0425b779c0fa = (mode)=>{
    localStorage.setItem($c20b65e3c5a5154b$export$58291b75bed158c8, mode);
};
const $c20b65e3c5a5154b$export$680d987d6cc59363 = ({ workspaceWidth: workspaceWidth, pinnedMode: pinnedMode })=>{
    if (pinnedMode === "detailed" || pinnedMode === "condensed") return pinnedMode;
    return workspaceWidth < $c20b65e3c5a5154b$export$f250cd4746414cf4 ? "condensed" : "detailed";
};
const $c20b65e3c5a5154b$export$1058c2bab79df168 = (density)=>density === "condensed" ? "7fr 13fr" : "11fr 13fr";
const $c20b65e3c5a5154b$export$b7cc65953b4c577b = ({ pageLoading: pageLoading, filtersApplied: filtersApplied })=>!pageLoading && !filtersApplied;
const $c20b65e3c5a5154b$export$34acb5eada330508 = ({ seeMoreURL: seeMoreURL, alertsToDisplay: alertsToDisplay, selectedRow: selectedRow })=>Boolean(seeMoreURL && alertsToDisplay && selectedRow);



var $4wo2Y = parcelRequire("4wo2Y");


var $iKAtE = parcelRequire("iKAtE");

var $433j1 = parcelRequire("433j1");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");
const $7c6f6acc5b8af98d$var$IMAGE_WIDTH = 333;
const $7c6f6acc5b8af98d$var$IMAGE_HEIGHT = 187;
const $7c6f6acc5b8af98d$export$b96b13a0906ff111 = ({ selectedAlertCameraInfo: selectedAlertCameraInfo, ignoreZonesSelectedAlert: ignoreZonesSelectedAlert, loadingIgnoreZonesInfo: loadingIgnoreZonesInfo })=>{
    const pointsCreator = (polygon)=>{
        return polygon.map(([x, y])=>`${x * $7c6f6acc5b8af98d$var$IMAGE_WIDTH},${y * $7c6f6acc5b8af98d$var$IMAGE_HEIGHT}`).join(" ");
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "h-[260px] w-[350px]",
        children: [
            selectedAlertCameraInfo.preview_url && ignoreZonesSelectedAlert && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "relative w-[333px] h-[187px]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                        className: "w-[333px] h-[187px] block",
                        src: selectedAlertCameraInfo.preview_url,
                        alt: "Camera preview with ignore zones"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("svg", {
                        className: "absolute top-0 left-0 w-[333px] h-[187px] pointer-events-none",
                        width: $7c6f6acc5b8af98d$var$IMAGE_WIDTH,
                        height: $7c6f6acc5b8af98d$var$IMAGE_HEIGHT,
                        style: {
                            overflow: "visible"
                        },
                        children: ignoreZonesSelectedAlert.map((object)=>object.coordinates.map((polygon, polygonIndex)=>/*#__PURE__*/ (0, $k4ank.jsx)("polygon", {
                                    points: pointsCreator(polygon),
                                    stroke: object.line_color,
                                    strokeWidth: "2",
                                    fill: object.line_color,
                                    fillOpacity: "0.3"
                                }, `${object.label}-${polygonIndex}`)))
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "mt-2 space-y-1",
                        children: ignoreZonesSelectedAlert.map((object)=>/*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "w-3 h-2 shrink-0 rounded-sm",
                                        style: {
                                            background: object.line_color
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "font-mulish text-[10px] text-actuate-blue",
                                        children: object.label_display_name
                                    })
                                ]
                            }, object.label))
                    })
                ]
            }),
            !loadingIgnoreZonesInfo && !selectedAlertCameraInfo.preview_url && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "font-mulish text-[12px]",
                    children: "Unable to Display Ignore Zones"
                })
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $ha39s = parcelRequire("ha39s");
var $cVCJe = parcelRequire("cVCJe");

var $ePwXE = parcelRequire("ePwXE");


var $6pdiI = parcelRequire("6pdiI");
var $80590442417236a5$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($80590442417236a5$exports, "__esModule", {
    value: true
});
$80590442417236a5$exports.default = void 0;

var $80590442417236a5$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $80590442417236a5$var$_default = $80590442417236a5$exports.default = (0, $80590442417236a5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"
}), 'Visibility');



var $8jTCz = parcelRequire("8jTCz");

var $k4ank = parcelRequire("k4ank");

var $cVCJe = parcelRequire("cVCJe");
parcelRequire("8T3gX");
const $d8cdfeb75dda1b24$export$affa77350763efbf = (userString)=>{
    if (userString.length < 8) return userString;
    else return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: userString,
        placement: "top",
        sx: {
            fontSize: "14px",
            fontFamily: "mulish"
        },
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            children: [
                userString.slice(0, 7),
                "..."
            ]
        })
    });
};




var $ebTQj = parcelRequire("ebTQj");

var $aYdit = parcelRequire("aYdit");

const $652b253a1b8c9880$var$CameraInfoTable = ({ selectedRow: selectedRow, setNoteText: setNoteText, setNotesDialogOpen: setNotesDialogOpen })=>{
    // ENG-1813: the Notes cell opens the same dialog either way; without the
    // outcome permission it reads as "view", not "edit".
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    const canEditNotes = (0, $c0b3a83d600c7aa1$export$544f58273da8c441)(userPermissions);
    const epochToDateTime = (epoch, timezone)=>{
        const date = new Date(epoch * 1000);
        // If timezone is provided, convert to that timezone
        if (timezone) try {
            // Use Intl.DateTimeFormat to format the date in the specified timezone
            const formatter = new Intl.DateTimeFormat("en-US", {
                timeZone: timezone,
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true
            });
            const parts = formatter.formatToParts(date);
            const month = parts.find((part)=>part.type === "month")?.value || "";
            const day = parts.find((part)=>part.type === "day")?.value || "";
            const year = parts.find((part)=>part.type === "year")?.value || "";
            const hour = parts.find((part)=>part.type === "hour")?.value || "";
            const minute = parts.find((part)=>part.type === "minute")?.value || "";
            const second = parts.find((part)=>part.type === "second")?.value || "";
            const dayPeriod = parts.find((part)=>part.type === "dayPeriod")?.value || "";
            return `${month}/${day}/${year}, ${hour}:${minute}:${second} ${dayPeriod}`;
        } catch (error) {
            (0, $ebTQj.logger).warn("Invalid timezone provided, falling back to local time:", timezone);
        // Fall back to original logic if timezone is invalid
        }
        // Original logic for local time or fallback
        let month = (date.getMonth() + 1).toString();
        if (month.length !== 2) month = `0${month}`;
        let day = date.getDate().toString();
        if (day.length !== 2) day = `0${day}`;
        const year = date.getFullYear();
        let hour = date.getHours();
        if (hour >= 12) hour = hour - 12;
        let newHour = hour.toString();
        if (newHour.length !== 2) newHour = `0${newHour}`;
        let minute = date.getMinutes().toString();
        if (minute.length !== 2) minute = `0${minute}`;
        let second = date.getSeconds().toString();
        if (second.length !== 2) second = `0${second}`;
        const ampm = date.getHours() >= 12 ? "PM" : "AM";
        return `${month}/${day}/${year}, ${newHour}:${minute}:${second} ${ampm}`;
    };
    const headCellSx = {
        fontSize: "11px",
        fontFamily: "Mulish",
        fontWeight: 700,
        width: "20%",
        py: 0.5,
        px: 1
    };
    const bodyCellSx = {
        fontSize: "12px",
        fontFamily: "Mulish",
        py: 0.5,
        px: 1
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $4reBM.default), {
        elevation: 0,
        sx: {
            width: "100%",
            // Grows with spare height in the alert detail card (rows stretch).
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "auto",
            boxShadow: "none",
            border: "1px solid #E5E5E5",
            borderRadius: "4px"
        },
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
            sx: {
                flexGrow: 1,
                display: "flex",
                flexDirection: "column"
            },
            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                size: "small",
                sx: {
                    minWidth: 500,
                    fontFamily: "Mulish",
                    flexGrow: 1
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: headCellSx,
                                    children: "Alert Type"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: headCellSx,
                                    children: "Time Stamp"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: headCellSx,
                                    children: "Outcome"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: headCellSx,
                                    children: "User"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: headCellSx,
                                    children: "Date Resolved"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: headCellSx,
                                    children: "Notes"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: bodyCellSx,
                                    children: (0, $36f1c5bc563bba72$export$1e43853507c2d294)(selectedRow.alert_labels)
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: bodyCellSx,
                                    children: [
                                        selectedRow.formatted_date,
                                        "\xa0",
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                            title: selectedRow.timezone,
                                            placement: "top",
                                            sx: {
                                                fontSize: "12px",
                                                fontFamily: "mulish"
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                                fontSize: "small"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: bodyCellSx,
                                    children: selectedRow.detection_type ? (0, $485e51885dc90d99$export$a57fd01c1a4f0d20)(selectedRow.detection_type, selectedRow.engineering_outcome?.outcome_v2) : "--"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: bodyCellSx,
                                    children: selectedRow.user ? (0, $d8cdfeb75dda1b24$export$affa77350763efbf)(selectedRow.user) : "--"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: bodyCellSx,
                                    children: selectedRow.updated ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        children: [
                                            epochToDateTime(selectedRow.updated, selectedRow.timezone),
                                            "\xa0",
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                title: selectedRow.timezone,
                                                placement: "top",
                                                sx: {
                                                    fontSize: "14px",
                                                    fontFamily: "mulish"
                                                },
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                                    fontSize: "small"
                                                })
                                            })
                                        ]
                                    }) : "--"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    align: "left",
                                    sx: bodyCellSx,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                        text: canEditNotes ? /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {
                                            fontSize: "small"
                                        }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($80590442417236a5$exports))), {
                                            fontSize: "small"
                                        }),
                                        onClick: ()=>{
                                            setNoteText(selectedRow.detection_type ? selectedRow.notes : selectedRow.unresolved_notes);
                                            setNotesDialogOpen(true);
                                        },
                                        disabled: false
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var $652b253a1b8c9880$export$2e2bcd8739ae039 = $652b253a1b8c9880$var$CameraInfoTable;



var $iIAML = parcelRequire("iIAML");



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");


var $5gr4N = parcelRequire("5gr4N");

var $cVCJe = parcelRequire("cVCJe");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $60vL1 = parcelRequire("60vL1");
var $eejVe = parcelRequire("eejVe");




var $4PFLW = parcelRequire("4PFLW");

const $9c8d48690069f26e$export$58885a5ebd8b6b01 = ({ userFilters: userFilters, setUserFilters: setUserFilters, navigate: navigate, setSiteOptions: setSiteOptions, setSiteDropDownValue: setSiteDropDownValue, setCameraOptions: setCameraOptions, setCameraDropDownValue: setCameraDropDownValue, setLoadingSites: setLoadingSites, setRefreshInterval: setRefreshInterval, parentAccounts: parentAccounts, parentIds: parentIds, parentAccountsLoading: parentAccountsLoading })=>{
    const { flags: flags } = (0, $4PFLW.useFeatureFlag)();
    const showAlertsScopeContext = Boolean(flags.showAlertsScopeContext);
    const parentAccountsData = JSON.parse(localStorage?.parentAccounts || "[]");
    const liveAccounts = Array.isArray(parentAccounts) && parentAccounts.length > 0 ? parentAccounts : parentAccountsData;
    const parentNamesMap = new Map();
    parentAccountsData.forEach((object)=>{
        parentNamesMap.set(object.id, object.name);
    });
    const flatOptions = parentAccountsData[0] ? parentAccountsData.map((object)=>({
            id: object.id,
            name: object.name,
            depth: 0,
            path: object.name,
            siteCount: null,
            parentId: null
        })) : [];
    const options = showAlertsScopeContext ? (0, $9fba8663fe17aa61$export$efb248e57120c2a5)(liveAccounts) : flatOptions;
    const selectedId = userFilters.parent_group ? Number(userFilters.parent_group) : null;
    const selectedOption = selectedId == null ? null : options.find((option)=>option.id === selectedId) ?? {
        id: selectedId,
        name: parentNamesMap.get(selectedId) || "",
        depth: 0,
        path: parentNamesMap.get(selectedId) || "",
        siteCount: null,
        parentId: null
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            disablePortal: true,
            options: options,
            getOptionLabel: (option)=>(showAlertsScopeContext ? option.path : option.name) || "",
            isOptionEqualToValue: (option, value)=>option.id === value.id,
            value: selectedOption,
            loading: parentAccountsLoading,
            onChange: (event, value)=>{
                setRefreshInterval((0, $1f018041dfd027b5$export$725a563b452f57c6)(value?.id));
                setSiteOptions([]);
                setCameraOptions([]);
                setSiteDropDownValue([]);
                setCameraDropDownValue([]);
                if (value !== null) {
                    (0, $27fa563d59549059$export$6b28e0ddc2fe699b)(value.id, navigate, setSiteOptions, setLoadingSites);
                    setUserFilters((previousState)=>{
                        return {
                            ...previousState,
                            parent_group: value.id,
                            site: "",
                            camera: ""
                        };
                    });
                } else setUserFilters((previousState)=>{
                    return {
                        ...previousState,
                        parent_group: "",
                        site: "",
                        camera: ""
                    };
                });
            },
            sx: (0, $30e263c4a2b86f06$export$e39095426be65fc6),
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    size: "small",
                    label: "Parent Group",
                    InputProps: {
                        ...params.InputProps,
                        endAdornment: /*#__PURE__*/ (0, $k4ank.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                            children: [
                                parentAccountsLoading ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                    color: "inherit",
                                    size: 20
                                }) : null,
                                params.InputProps.endAdornment
                            ]
                        })
                    },
                    autoComplete: "off"
                }),
            renderOption: (props, option)=>/*#__PURE__*/ (0, $8T3gX.createElement)("li", {
                    ...props,
                    key: option.id,
                    style: {
                        ...props.style,
                        paddingLeft: showAlertsScopeContext ? 16 + option.depth * 16 : props.style?.paddingLeft
                    }
                }, option.name)
        })
    }, "parent_groups_dropdown");
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $60vL1 = parcelRequire("60vL1");
var $eejVe = parcelRequire("eejVe");


const $723a02e612f424d9$export$dcd6b0196e97e17d = ({ userFilters: userFilters, setUserFilters: setUserFilters, siteOptions: siteOptions, setCameraOptions: setCameraOptions, setCameraDropDownValue: setCameraDropDownValue, navigate: navigate, siteDropDownValue: siteDropDownValue, setSiteDropDownValue: setSiteDropDownValue, loadingSites: loadingSites, setLoadingCameras: setLoadingCameras })=>{
    const siteNamesMap = new Map();
    siteOptions.forEach((object)=>{
        siteNamesMap.set(object.id, object.name);
    });
    const parentAccounts = JSON.parse(localStorage?.parentAccounts || "[]");
    const parentIdsMap = new Map();
    parentAccounts.forEach((object)=>{
        parentIdsMap.set(object.name, object.id);
    });
    // Convert siteDropDownValue strings to objects for the Autocomplete.
    // Memoized so the array keeps its identity across unrelated re-renders:
    // MUI treats a new `value` reference as a selection change and clears
    // the typed search text (SUP-868).
    const selectedSiteObjects = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>siteDropDownValue.map((siteName)=>({
                id: siteOptions.find((object)=>object.name === siteName)?.id,
                name: siteName
            })), [
        siteDropDownValue,
        siteOptions
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            multiple: true,
            size: "small",
            limitTags: 1,
            sx: (0, $30e263c4a2b86f06$export$e39095426be65fc6),
            value: selectedSiteObjects,
            disablePortal: true,
            options: siteOptions[0] ? siteOptions.map((object, index)=>({
                    id: object.id,
                    name: object.name,
                    index: index
                })) : [],
            getOptionLabel: (option)=>option.name || "",
            isOptionEqualToValue: (option, value)=>option.id === value.id,
            loading: loadingSites,
            onChange: (event, value)=>{
                if (value && value.length > 0) {
                    const siteIdsArray = [];
                    const siteValuesArray = [];
                    value.forEach((siteObject)=>{
                        siteIdsArray.push(siteObject.id);
                        siteValuesArray.push(siteObject.name);
                    });
                    setSiteDropDownValue(siteValuesArray);
                    localStorage.setItem("siteDropDownValue", JSON.stringify(siteValuesArray));
                    setCameraDropDownValue([]);
                    localStorage.setItem("cameraDropDownValue", JSON.stringify([]));
                    (0, $1a511a220e4442ce$export$1fedd6e3f8d8e03e)(siteIdsArray, navigate, setCameraOptions, setLoadingCameras);
                    setUserFilters((previousState)=>{
                        return {
                            ...previousState,
                            site: siteIdsArray,
                            camera: ""
                        };
                    });
                } else {
                    setSiteDropDownValue([]);
                    setCameraDropDownValue([]);
                    setCameraOptions([]);
                    setUserFilters((previousState)=>{
                        return {
                            ...previousState,
                            site: [],
                            camera: []
                        };
                    });
                    setLoadingCameras(false);
                }
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    size: "small",
                    label: "Site",
                    InputProps: {
                        ...params.InputProps,
                        endAdornment: /*#__PURE__*/ (0, $k4ank.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                            children: [
                                loadingSites ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                    color: "inherit",
                                    size: 20
                                }) : null,
                                params.InputProps.endAdornment
                            ]
                        })
                    },
                    autoComplete: "off"
                }),
            renderOption: (props, option)=>/*#__PURE__*/ (0, $8T3gX.createElement)("li", {
                    ...props,
                    key: option.id
                }, option.name)
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $60vL1 = parcelRequire("60vL1");
var $eejVe = parcelRequire("eejVe");

const $f299600a0b6541a6$export$28c134749b74088 = ({ setUserFilters: setUserFilters, cameraOptions: cameraOptions, cameraDropDownValue: cameraDropDownValue, setCameraDropDownValue: setCameraDropDownValue, siteOptions: siteOptions, loadingCameras: loadingCameras })=>{
    const cameraNamesMap = new Map();
    cameraOptions.forEach((object)=>{
        cameraNamesMap.set(object.id, object.camera_name);
    });
    const siteIdsMap = new Map();
    siteOptions.forEach((object)=>{
        siteIdsMap.set(object.name, object.id);
    });
    // Convert cameraDropDownValue strings to objects for the Autocomplete.
    // Memoized so the array keeps its identity across unrelated re-renders:
    // MUI treats a new `value` reference as a selection change and clears
    // the typed search text (SUP-868).
    const selectedCameraObjects = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>cameraDropDownValue.map((cameraName)=>({
                id: cameraOptions.find((object)=>object.camera_name === cameraName)?.id,
                name: cameraName
            })), [
        cameraDropDownValue,
        cameraOptions
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            disablePortal: true,
            multiple: true,
            size: "small",
            sx: (0, $30e263c4a2b86f06$export$e39095426be65fc6),
            limitTags: 1,
            value: selectedCameraObjects,
            options: cameraOptions[0] ? cameraOptions.map((object, index)=>({
                    id: object.id,
                    name: object.camera_name,
                    index: index
                })) : [],
            getOptionLabel: (option)=>option.name || "",
            isOptionEqualToValue: (option, value)=>option.id === value.id,
            loading: loadingCameras,
            onChange: (event, value)=>{
                if (value && value.length > 0) {
                    const cameraIdsArray = [];
                    const cameraValuesArray = [];
                    value.forEach((cameraObject)=>{
                        cameraIdsArray.push(cameraObject.id);
                        cameraValuesArray.push(cameraObject.name);
                    });
                    setCameraDropDownValue(cameraValuesArray);
                    setUserFilters((previousState)=>{
                        return {
                            ...previousState,
                            camera: cameraIdsArray
                        };
                    });
                } else {
                    setCameraDropDownValue([]);
                    setUserFilters((previousState)=>{
                        return {
                            ...previousState,
                            camera: []
                        };
                    });
                }
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    size: "small",
                    label: "Camera",
                    InputProps: {
                        ...params.InputProps,
                        endAdornment: /*#__PURE__*/ (0, $k4ank.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                            children: [
                                loadingCameras ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                    color: "inherit",
                                    size: 20
                                }) : null,
                                params.InputProps.endAdornment
                            ]
                        })
                    },
                    autoComplete: "off"
                }),
            renderOption: (props, option)=>/*#__PURE__*/ (0, $8T3gX.createElement)("li", {
                    ...props,
                    key: option.id
                }, option.name)
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $hfM8m = parcelRequire("hfM8m");

var $hwWkD = parcelRequire("hwWkD");


var $eejVe = parcelRequire("eejVe");

var $5L5iJ = parcelRequire("5L5iJ");


var $iKAtE = parcelRequire("iKAtE");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");

var $i5MAs = parcelRequire("i5MAs");

var $aYdit = parcelRequire("aYdit");

var $jgags = parcelRequire("jgags");

const $3c2ddc20075bdf9c$export$75cc480278ad332d = ({ userFilters: userFilters, setUserFilters: setUserFilters, siteOptions: siteOptions, setTimeFiltersDisabled: setTimeFiltersDisabled, warningIssued: warningIssued, setWarningIssued: setWarningIssued })=>{
    const parentAccounts = JSON.parse(localStorage?.getItem?.("parentAccounts") ?? "[]");
    const siteIds = new Map();
    siteOptions.forEach((object)=>{
        siteIds.set(object.name, object.id);
    });
    const parentIds = new Map();
    parentAccounts.forEach((object)=>{
        parentIds.set(object.name, object.id);
    });
    const [startTimeAnchorEl, setStartTimeAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const startTimeOpen = Boolean(startTimeAnchorEl);
    const handleStartTimeClick = (event)=>{
        // event.stopPropagation(); // Stop event propagation to prevent table sorting
        setStartTimeAnchorEl(event.currentTarget);
    };
    const handleStartTimeClose = (event)=>{
        event.stopPropagation(); // Stop event propagation to prevent table sorting
        setStartTimeAnchorEl(null);
    };
    const { dateMMDDYYYY: dateMMDDYYYY, setDateMMDDYYYY: setDateMMDDYYYY } = (0, $aYdit.useAppStore)();
    const selectedLocale = dateMMDDYYYY ? (0, $jgags.default) : (0, $253608f850203ed2$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
        dateAdapter: (0, $hfM8m.AdapterDateFns),
        adapterLocale: selectedLocale,
        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
            className: "w-full",
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cbaf068f14972fdf$export$5109c6dd95d8fb00), {
                label: userFilters.start_date ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                            children: `Site Date`
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                    "aria-label": "more",
                                    id: "long-button",
                                    "aria-controls": startTimeOpen ? "long-menu" : undefined,
                                    "aria-expanded": startTimeOpen ? "true" : undefined,
                                    "aria-haspopup": "true",
                                    onClick: handleStartTimeClick,
                                    sx: {
                                        marginLeft: "5px",
                                        padding: 0,
                                        color: "#000000",
                                        "&:hover": {
                                            backgroundColor: "transparent"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5MAs))), {})
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                                    id: "long-menu",
                                    MenuListProps: {
                                        "aria-labelledby": "long-button"
                                    },
                                    anchorOrigin: {
                                        vertical: "top",
                                        horizontal: "left"
                                    },
                                    transformOrigin: {
                                        vertical: "top",
                                        horizontal: "left"
                                    },
                                    anchorEl: startTimeAnchorEl,
                                    open: startTimeOpen,
                                    onClose: handleStartTimeClose,
                                    slotProps: {
                                        paper: {
                                            style: {
                                                maxHeight: 216,
                                                width: "20ch"
                                            }
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                            onClick: (event)=>{
                                                setDateMMDDYYYY(true);
                                                handleStartTimeClose(event);
                                            },
                                            children: "MM/DD/YYYY"
                                        }, "mm-dd-yyyy-start"),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                            onClick: (event)=>{
                                                setDateMMDDYYYY(false);
                                                handleStartTimeClose(event);
                                            },
                                            children: "DD/MM/YYYY"
                                        }, "dd-mm-yyyy-start")
                                    ]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                    children: "Start Date"
                }),
                value: userFilters.start_date,
                onChange: (newValue)=>{
                    if (!warningIssued && !(0, $f4d34d563874b92a$export$66d91271a14601c5)(newValue)) {
                        alert(`Selecting any dates for start date or end date which are not the current date will prevent new alerts from being refreshed in the background`);
                        setWarningIssued(true);
                    }
                    if (newValue !== null) {
                        if (userFilters.end_date && newValue > userFilters.end_date) {
                            alert("Start date cannot be after end date");
                            return;
                        }
                        setUserFilters((previousState)=>({
                                ...previousState,
                                start_date: newValue
                            }));
                    }
                    if (newValue === null) {
                        setTimeFiltersDisabled(true);
                        setUserFilters((previousState)=>{
                            return {
                                ...previousState,
                                start_date: null,
                                start_time: null,
                                end_time: null
                            };
                        });
                    }
                    if ((0, $5L5iJ.yyyymmddGenerator)(newValue) !== (0, $5L5iJ.yyyymmddGenerator)(userFilters.end_date)) {
                        setTimeFiltersDisabled(true);
                        setUserFilters((previousState)=>{
                            return {
                                ...previousState,
                                start_time: null,
                                end_time: null
                            };
                        });
                    }
                    if ((0, $5L5iJ.yyyymmddGenerator)(newValue) === (0, $5L5iJ.yyyymmddGenerator)(userFilters.end_date)) setTimeFiltersDisabled(false);
                },
                renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                        size: "small",
                        ...params,
                        inputProps: {
                            ...params.inputProps,
                            autoComplete: "off"
                        },
                        sx: (0, $30e263c4a2b86f06$export$74781f6aa62ac4d1)
                    })
            })
        })
    });
};




var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eejVe = parcelRequire("eejVe");
var $cVCJe = parcelRequire("cVCJe");

var $hwWkD = parcelRequire("hwWkD");

var $a50J4 = parcelRequire("a50J4");

var $hfM8m = parcelRequire("hfM8m");


const $496497d692e29f84$export$1fcbc6e4cade8968 = ({ userFilters: userFilters, setUserFilters: setUserFilters, navigate: navigate, setFetchingFilteredData: setFetchingFilteredData, setAlertData: setAlertData, setSelectedRow: setSelectedRow, setSeeMoreURL: setSeeMoreURL, setMP4URL: setMP4URL, siteOptions: siteOptions, setSelectedButtonsFilled: setSelectedButtonsFilled, setThumbnailVideos: setThumbnailVideos, setDateOutsideRange: setDateOutsideRange, setPage: setPage, setVideoClipLoading: setVideoClipLoading, setAlertsToDisplay: setAlertsToDisplay, setPageLoading: setPageLoading, timeFiltersDisabled: timeFiltersDisabled })=>{
    const parentAccounts = JSON.parse(localStorage?.getItem?.("parentAccounts") ?? "[]");
    const siteIds = new Map();
    siteOptions.forEach((object)=>{
        siteIds.set(object.name, object.id);
    });
    const parentIds = new Map();
    parentAccounts.forEach((object)=>{
        parentIds.set(object.name, object.id);
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
        dateAdapter: (0, $hfM8m.AdapterDateFns),
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
            title: (0, $ffbec3bd61ee0d21$export$e5ad0d4cfb9b77f4),
            disableHoverListener: !timeFiltersDisabled,
            disableFocusListener: !timeFiltersDisabled,
            disableTouchListener: !timeFiltersDisabled,
            ...(0, $ffbec3bd61ee0d21$export$b1886b315cb3d290),
            children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                className: "block w-full",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a50J4.DesktopTimePicker), {
                    label: "Start Time",
                    value: userFilters.start_time,
                    onChange: (newValue)=>{
                        if (userFilters.end_time && newValue > userFilters.end_time) {
                            alert("Start time must be before end time");
                            return;
                        }
                        setUserFilters((previousState)=>({
                                ...previousState,
                                start_time: newValue
                            }));
                    },
                    disabled: timeFiltersDisabled,
                    renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                            size: "small",
                            ...params,
                            inputProps: {
                                ...params.inputProps,
                                autoComplete: "off"
                            },
                            sx: (0, $30e263c4a2b86f06$export$74781f6aa62ac4d1)
                        })
                })
            })
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $eejVe = parcelRequire("eejVe");
var $cVCJe = parcelRequire("cVCJe");

var $hwWkD = parcelRequire("hwWkD");

var $a50J4 = parcelRequire("a50J4");

var $hfM8m = parcelRequire("hfM8m");


const $622d356f90e3c6c9$export$8917cb152d9ad33e = ({ userFilters: userFilters, setUserFilters: setUserFilters, navigate: navigate, setFetchingFilteredData: setFetchingFilteredData, setAlertData: setAlertData, setSelectedRow: setSelectedRow, setSeeMoreURL: setSeeMoreURL, setMP4URL: setMP4URL, siteOptions: siteOptions, setSelectedButtonsFilled: setSelectedButtonsFilled, setThumbnailVideos: setThumbnailVideos, setDateOutsideRange: setDateOutsideRange, setPage: setPage, setVideoClipLoading: setVideoClipLoading, setAlertsToDisplay: setAlertsToDisplay, setPageLoading: setPageLoading, timeFiltersDisabled: timeFiltersDisabled })=>{
    const parentAccounts = JSON.parse(localStorage?.getItem?.("parentAccounts") ?? "[]");
    const siteIds = new Map();
    siteOptions.forEach((object)=>{
        siteIds.set(object.name, object.id);
    });
    const parentIds = new Map();
    parentAccounts.forEach((object)=>{
        parentIds.set(object.name, object.id);
    });
    const [endTimeWarningIssues, setEndTimeWarningIssuedFasle] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
        dateAdapter: (0, $hfM8m.AdapterDateFns),
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
            title: (0, $ffbec3bd61ee0d21$export$e5ad0d4cfb9b77f4),
            disableHoverListener: !timeFiltersDisabled,
            disableFocusListener: !timeFiltersDisabled,
            disableTouchListener: !timeFiltersDisabled,
            ...(0, $ffbec3bd61ee0d21$export$b1886b315cb3d290),
            children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                className: "block w-full",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a50J4.DesktopTimePicker), {
                    label: "End Time",
                    value: userFilters.end_time,
                    onChange: (newValue)=>{
                        if (!endTimeWarningIssues) {
                            alert(`Selecting an end time will prevent new alerts from being refreshed in the background`);
                            setEndTimeWarningIssuedFasle(true);
                        }
                        if (userFilters.start_time && newValue < userFilters.start_time) {
                            alert("End time must be after start time");
                            return;
                        }
                        setUserFilters((previousState)=>({
                                ...previousState,
                                end_time: newValue
                            }));
                    },
                    disabled: timeFiltersDisabled,
                    renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                            size: "small",
                            ...params,
                            inputProps: {
                                ...params.inputProps,
                                autoComplete: "off"
                            },
                            sx: (0, $30e263c4a2b86f06$export$74781f6aa62ac4d1)
                        })
                })
            })
        })
    });
};





var $5L5iJ = parcelRequire("5L5iJ");



var $4PFLW = parcelRequire("4PFLW");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");
const $7304ed7f20bfd7d8$export$c4c20c9068d3628c = ({ pathLabel: pathLabel, siteLabel: siteLabel, otherLabel: otherLabel, onViewAll: onViewAll })=>/*#__PURE__*/ (0, $k4ank.jsxs)("p", {
        role: "status",
        className: "font-mulish px-4 pb-2 text-[14px] text-actuate-blue",
        children: [
            "Showing ",
            /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                className: "font-bold",
                children: pathLabel
            }),
            siteLabel ? ` \u{2014} ${siteLabel}` : "",
            otherLabel ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                children: [
                    ". ",
                    /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                        className: "font-bold",
                        children: otherLabel
                    }),
                    " in your account in this window"
                ]
            }) : null,
            " \xb7 ",
            /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                type: "button",
                onClick: onViewAll,
                className: "font-mulish text-actuate-orange underline",
                children: "View all"
            })
        ]
    });





const $bc72e6eb2c6a3f8c$export$c40d95d7bc60a58 = ({ navBarCollapsed: navBarCollapsed, userFilters: userFilters, setUserFilters: setUserFilters, navigate: navigate, setSiteOptions: setSiteOptions, setSiteDropDownValue: setSiteDropDownValue, setCameraOptions: setCameraOptions, setCameraDropDownValue: setCameraDropDownValue, setLoadingSites: setLoadingSites, setRefreshInterval: setRefreshInterval, parentAccounts: parentAccounts, parentIds: parentIds, parentAccountsLoading: parentAccountsLoading, siteOptions: siteOptions, siteDropDownValue: siteDropDownValue, loadingSites: loadingSites, setLoadingCameras: setLoadingCameras, cameraOptions: cameraOptions, cameraDropDownValue: cameraDropDownValue, loadingCameras: loadingCameras, setFetchingFilteredData: setFetchingFilteredData, setAlertData: setAlertData, setSelectedRow: setSelectedRow, setSeeMoreURL: setSeeMoreURL, setMP4URL: setMP4URL, setSelectedButtonsFilled: setSelectedButtonsFilled, setThumbnailVideos: setThumbnailVideos, setDateOutsideRange: setDateOutsideRange, setPage: setPage, setVideoClipLoading: setVideoClipLoading, setAlertsToDisplay: setAlertsToDisplay, setPageLoading: setPageLoading, setTimeFiltersDisabled: setTimeFiltersDisabled, warningIssued: warningIssued, setWarningIssued: setWarningIssued, timeFiltersDisabled: timeFiltersDisabled, setFiltersApplied: setFiltersApplied, pageLoadedNumber: pageLoadedNumber, setPageLoadedNumber: setPageLoadedNumber, searchParams: searchParams, setSearchParams: setSearchParams, detectionType: detectionType, setDetectionType: setDetectionType, setSelectedAlertCameraInfo: setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert: setIgnoreZonesSelectedAlert, setAlertsIndexOrder: setAlertsIndexOrder, setCurrentName: setCurrentName, setRefreshingData: setRefreshingData, setRefreshingToken: setRefreshingToken, refreshingToken: refreshingToken, setAlertLabels: setAlertLabels, setPeriodHours: setPeriodHours, setQueryLimitHit: setQueryLimitHit, refreshInterval: refreshInterval, setOutcomeFilterType: setOutcomeFilterType, setForwardArrowDisabled: setForwardArrowDisabled, setBackArrowDisabled: setBackArrowDisabled, setShowRefreshButton: setShowRefreshButton, setRowsSortable: setRowsSortable, setAlertsRefreshing: setAlertsRefreshing, getCurrentSelectedRowKey: getCurrentSelectedRowKey, setVideoProcessing: setVideoProcessing })=>{
    const { mutedAlertSites: mutedAlertSites, mutedAlertCameras: mutedAlertCameras } = (0, $a4c0e7e0c5cf28c3$export$52a528b1f45cfa42)();
    const { flags: flags } = (0, $4PFLW.useFeatureFlag)();
    const showAlertsScopeContext = Boolean(flags.showAlertsScopeContext);
    const appliedGroupId = typeof searchParams?.get === "function" ? searchParams.get("group") : null;
    const { scope: scope, other: other } = (0, $d0ff96bb2de1a237$export$e81b059015aec241)({
        enabled: showAlertsScopeContext,
        parentAccounts: Array.isArray(parentAccounts) ? parentAccounts : [],
        appliedGroupId: appliedGroupId
    });
    const containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const [containerWidth, setContainerWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [filtersCollapsed, setFiltersCollapsed] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const stackFilters = (0, $30e263c4a2b86f06$export$a02b83257882a15e)(containerWidth);
    const fieldClassName = stackFilters ? (0, $30e263c4a2b86f06$export$4e3c1b210884a471) : (0, $30e263c4a2b86f06$export$e9df3b5e8d88d9f4);
    const dateFieldClassName = stackFilters ? (0, $30e263c4a2b86f06$export$4686fcabe874c7a2) : (0, $30e263c4a2b86f06$export$9e0a043f575674e8);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useLayoutEffect(()=>{
        const node = containerRef.current;
        if (!node) return undefined;
        const updateWidth = ()=>{
            setContainerWidth(node.clientWidth);
        };
        updateWidth();
        if (typeof ResizeObserver === "undefined") return undefined;
        const observer = new ResizeObserver(updateWidth);
        observer.observe(node);
        return ()=>observer.disconnect();
    }, []);
    const applyFilters = (filtersOverride)=>{
        const filters = filtersOverride ?? userFilters;
        let searchingPastDates = false;
        if (filters.end_date) searchingPastDates = (0, $3d9ada870c0cfeca$export$f3932c991a110bf)((0, $5L5iJ.yyyymmddGenerator)(filters.end_date));
        if (filters.start_date) {
            if ((0, $5L5iJ.yyyymmddGenerator)(filters.start_date) !== (0, $5L5iJ.yyyymmddGenerator)(filters?.end_date)) searchingPastDates = true;
        }
        if (filters.start_time || filters.end_time) searchingPastDates = true;
        if (searchingPastDates) setAlertsRefreshing(false);
        localStorage.setItem("pageLoadedNumber", JSON.stringify(0));
        localStorage.setItem("latestAlertFilters", JSON.stringify(filters));
        setPage(0);
        let newNumber = Number(pageLoadedNumber);
        newNumber += 1;
        setPageLoadedNumber(newNumber);
        localStorage.setItem("pageLoadedNumber", `${newNumber}`);
        setRefreshingData(false);
        setFiltersApplied(true);
        setFetchingFilteredData(true);
        setDateOutsideRange(false);
        localStorage.setItem("newQueryRunning", "true");
        (0, $361dd3e7be612e92$export$59b2b76630cf930b)(filters, searchParams, setSearchParams, "All");
        (0, $8bebe2f317b7d60b$export$f0c03502af15d107)(setAlertData, navigate, setSelectedRow, setFetchingFilteredData, setSeeMoreURL, setMP4URL, filters.parent_group, filters.site, filters.camera, (0, $5L5iJ.yyyymmddGenerator)(filters.start_date), (0, $5L5iJ.yyyymmddGenerator)(filters.end_date), filters.start_time, filters.end_time, filters.filter_type, setSelectedButtonsFilled, setThumbnailVideos, setDateOutsideRange, setPage, setVideoClipLoading, setAlertsToDisplay, setPageLoading, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, setAlertsIndexOrder, setRefreshInterval, setCurrentName, setUserFilters, setRefreshingData, newNumber, refreshInterval, filters, cameraOptions, siteOptions, setRefreshingToken, refreshingToken, setAlertLabels, setPeriodHours, setQueryLimitHit, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setRowsSortable, setAlertsRefreshing, getCurrentSelectedRowKey, mutedAlertSites, mutedAlertCameras, setVideoProcessing);
        setDetectionType("All");
        setOutcomeFilterType("All");
    };
    const handleViewAll = ()=>{
        const nextFilters = {
            ...userFilters,
            parent_group: "",
            site: "",
            camera: ""
        };
        setUserFilters(nextFilters);
        setSiteDropDownValue([]);
        setCameraDropDownValue([]);
        setSiteOptions([]);
        setCameraOptions([]);
        applyFilters(nextFilters);
    };
    const applyFiltersButton = /*#__PURE__*/ (0, $k4ank.jsx)("button", {
        className: (0, $30e263c4a2b86f06$export$32ca9c91d1977728),
        onClick: ()=>applyFilters(),
        disabled: false,
        children: "Apply Filters"
    });
    const filtersToggleButton = /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: filtersCollapsed ? "Expand filters" : "Collapse filters",
        placement: "top",
        children: /*#__PURE__*/ (0, $k4ank.jsx)("button", {
            type: "button",
            "aria-label": filtersCollapsed ? "Expand filters" : "Collapse filters",
            "aria-expanded": !filtersCollapsed,
            "aria-controls": "alerts-filters-fields",
            onClick: ()=>setFiltersCollapsed((current)=>!current),
            className: "inline-flex items-center justify-center text-actuate-blue",
            children: filtersCollapsed ? /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5gr4N))), {
                sx: {
                    fontSize: 22
                }
            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($879ea8b84720ab7f$exports))), {
                sx: {
                    fontSize: 22
                }
            })
        })
    });
    const filterFields = /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: fieldClassName,
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $9c8d48690069f26e$export$58885a5ebd8b6b01), {
                    userFilters: userFilters,
                    setUserFilters: setUserFilters,
                    navigate: navigate,
                    setSiteOptions: setSiteOptions,
                    setSiteDropDownValue: setSiteDropDownValue,
                    setCameraOptions: setCameraOptions,
                    setCameraDropDownValue: setCameraDropDownValue,
                    setLoadingSites: setLoadingSites,
                    setRefreshInterval: setRefreshInterval,
                    parentAccounts: parentAccounts,
                    parentIds: parentIds,
                    parentAccountsLoading: parentAccountsLoading,
                    navBarCollapsed: navBarCollapsed
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: fieldClassName,
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $723a02e612f424d9$export$dcd6b0196e97e17d), {
                    userFilters: userFilters,
                    setUserFilters: setUserFilters,
                    siteOptions: siteOptions,
                    setCameraOptions: setCameraOptions,
                    setCameraDropDownValue: setCameraDropDownValue,
                    navigate: navigate,
                    siteDropDownValue: siteDropDownValue,
                    setSiteDropDownValue: setSiteDropDownValue,
                    loadingSites: loadingSites,
                    setLoadingCameras: setLoadingCameras,
                    navBarCollapsed: navBarCollapsed
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: fieldClassName,
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f299600a0b6541a6$export$28c134749b74088), {
                    setUserFilters: setUserFilters,
                    cameraOptions: cameraOptions,
                    cameraDropDownValue: cameraDropDownValue,
                    setCameraDropDownValue: setCameraDropDownValue,
                    siteOptions: siteOptions,
                    loadingCameras: loadingCameras,
                    navBarCollapsed: navBarCollapsed
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: dateFieldClassName,
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3c2ddc20075bdf9c$export$75cc480278ad332d), {
                    userFilters: userFilters,
                    setUserFilters: setUserFilters,
                    siteOptions: siteOptions,
                    setTimeFiltersDisabled: setTimeFiltersDisabled,
                    warningIssued: warningIssued,
                    setWarningIssued: setWarningIssued
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: dateFieldClassName,
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f4d34d563874b92a$export$e3e45797a05b86cf), {
                    userFilters: userFilters,
                    setUserFilters: setUserFilters,
                    siteOptions: siteOptions,
                    setTimeFiltersDisabled: setTimeFiltersDisabled,
                    warningIssued: warningIssued,
                    setWarningIssued: setWarningIssued
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: dateFieldClassName,
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $496497d692e29f84$export$1fcbc6e4cade8968), {
                    userFilters: userFilters,
                    setUserFilters: setUserFilters,
                    navigate: navigate,
                    setFetchingFilteredData: setFetchingFilteredData,
                    setAlertData: setAlertData,
                    setSelectedRow: setSelectedRow,
                    setSeeMoreURL: setSeeMoreURL,
                    setMP4URL: setMP4URL,
                    siteOptions: siteOptions,
                    setSelectedButtonsFilled: setSelectedButtonsFilled,
                    setThumbnailVideos: setThumbnailVideos,
                    setDateOutsideRange: setDateOutsideRange,
                    setPage: setPage,
                    setVideoClipLoading: setVideoClipLoading,
                    setAlertsToDisplay: setAlertsToDisplay,
                    setPageLoading: setPageLoading,
                    timeFiltersDisabled: timeFiltersDisabled
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: dateFieldClassName,
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $622d356f90e3c6c9$export$8917cb152d9ad33e), {
                    userFilters: userFilters,
                    setUserFilters: setUserFilters,
                    navigate: navigate,
                    setFetchingFilteredData: setFetchingFilteredData,
                    setAlertData: setAlertData,
                    setSelectedRow: setSelectedRow,
                    setSeeMoreURL: setSeeMoreURL,
                    setMP4URL: setMP4URL,
                    siteOptions: siteOptions,
                    setSelectedButtonsFilled: setSelectedButtonsFilled,
                    setThumbnailVideos: setThumbnailVideos,
                    setDateOutsideRange: setDateOutsideRange,
                    setPage: setPage,
                    setVideoClipLoading: setVideoClipLoading,
                    setAlertsToDisplay: setAlertsToDisplay,
                    setPageLoading: setPageLoading,
                    timeFiltersDisabled: timeFiltersDisabled
                })
            })
        ]
    });
    // The collapse toggle sits to the right of Apply Filters at every width
    // so operators can reclaim the strip for the alert list on wide screens
    // too; the collapsed state survives window resizes.
    const filterActions = /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "ml-auto flex shrink-0 items-center gap-1",
        children: [
            applyFiltersButton,
            filtersToggleButton
        ]
    });
    const scopeLine = showAlertsScopeContext && scope?.narrower && scope.selected ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $7304ed7f20bfd7d8$export$c4c20c9068d3628c), {
        pathLabel: scope.selected.path,
        siteLabel: (0, $9fba8663fe17aa61$export$6a83f1dd02a46a33)(scope.selected.siteCount),
        otherLabel: (0, $9fba8663fe17aa61$export$2c089059d4727a89)(other),
        onViewAll: handleViewAll
    }) : null;
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                ref: containerRef,
                className: filtersCollapsed ? "flex w-full justify-end px-4 py-1" : "flex w-full items-end gap-3 px-4 pb-4 pt-4",
                children: filtersCollapsed ? filtersToggleButton : /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "flex w-full items-start gap-3",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            id: "alerts-filters-fields",
                            className: stackFilters ? `${0, $30e263c4a2b86f06$export$69e198e12714b7c2} min-w-0 flex-1` : (0, $30e263c4a2b86f06$export$ecfc84a6abb7ab21),
                            children: filterFields
                        }),
                        filterActions
                    ]
                })
            }),
            scopeLine
        ]
    });
};



parcelRequire("8T3gX");
const $24253afce9c84c17$export$e4286fff6522e786 = (filterString)=>{
    if (!filterString) return "";
    switch(filterString){
        case "ALL":
            return "All Alerts";
        case "CLAIMED":
            return "Resolved Alerts";
        case "UNCLAIMED":
            return "Unresolved Alerts";
    }
};


parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $48eee419f07e2823$export$e97f54758ce8c671 = (row, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, setLoadingIgnoreZonesInfo, navigate, onComplete)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $48eee419f07e2823$export$e97f54758ce8c671(row, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, setLoadingIgnoreZonesInfo, navigate, onComplete);
    };
    const handleComplete = ()=>{
        setLoadingIgnoreZonesInfo(false);
        onComplete?.();
    };
    AxiosUI.get(`/camera/${row.camera_pk}/status/`).then((response)=>{
        setSelectedAlertCameraInfo(response.data);
        AxiosUI.get(`/camera/${row.camera_pk}/ignore_zones/`).then((response)=>{
            setIgnoreZonesSelectedAlert(response.data);
            handleComplete();
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                setIgnoreZonesSelectedAlert([]);
                handleComplete();
            });
        });
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setSelectedAlertCameraInfo({});
            handleComplete();
        });
    });
};


parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");

var $1Xths = parcelRequire("1Xths");

var $2wOL1 = parcelRequire("2wOL1");

var $fLtYK = parcelRequire("fLtYK");
const $515f0dbc25108112$var$isSideAOnLeft = (coordinates)=>{
    const [point1, point2] = coordinates;
    const dx = point2[0] - point1[0];
    const dy = point2[1] - point1[1];
    if (dy !== 0) return dy < 0;
    return dx < 0;
};
const $515f0dbc25108112$var$backendToFrontendDirection = (rawBackendDirection, coordinates)=>{
    // ENG-1317: case-insensitive; see normalizeBackendDirection.
    const backendDirection = (0, $fLtYK.normalizeBackendDirection)(rawBackendDirection);
    if (backendDirection === "both") return "Both";
    const sideAIsLeft = $515f0dbc25108112$var$isSideAOnLeft(coordinates);
    if (backendDirection === "l2r") return sideAIsLeft ? "AtoB" : "BtoA";
    return sideAIsLeft ? "BtoA" : "AtoB";
};
const $515f0dbc25108112$var$isLegacyDirectionFormat = (direction)=>direction === "AtoB" || direction === "BtoA" || direction === "Both";
const $515f0dbc25108112$export$7f758f5babb89955 = (row, setSelectedAlertCameraInfo, setLineCrossingsSelectedAlert, setLoadingLineCrossingsInfo, navigate, onComplete)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $515f0dbc25108112$export$7f758f5babb89955(row, setSelectedAlertCameraInfo, setLineCrossingsSelectedAlert, setLoadingLineCrossingsInfo, navigate, onComplete);
    };
    const handleComplete = ()=>{
        setLoadingLineCrossingsInfo(false);
        onComplete?.();
    };
    AxiosUI.get(`/camera/${row.camera_pk}/status/`).then((statusResponse)=>{
        setSelectedAlertCameraInfo(statusResponse.data);
        return Promise.all([
            // Default (camera-wide) lines only — preset-scoped lines stay out of the alert dialog.
            AxiosUI.get((0, $2wOL1.buildLineCrossingsListPath)(row.camera_pk)),
            AxiosUI.get(`/metric/?camera_id=${row.camera_pk}`)
        ]);
    }).then(([lineCrossingsResponse, metricsResponse])=>{
        const allowedLabels = [
            "intruder_line_crossing",
            "vehicle_line_crossing",
            "bike_line_crossing"
        ];
        const lineCrossings = lineCrossingsResponse.data.results || [];
        const processedLines = lineCrossings.map((line, index)=>{
            let frontendDirection;
            if ($515f0dbc25108112$var$isLegacyDirectionFormat(line.direction || "")) frontendDirection = line.direction || "Both";
            else frontendDirection = $515f0dbc25108112$var$backendToFrontendDirection(line.direction || "both", line.coordinates);
            return {
                id: line.id,
                camera: line.camera,
                metric_labels: line.metric_labels || [],
                coordinates: line.coordinates,
                direction: frontendDirection,
                color: (0, $1Xths.LINE_COLORS)[index % (0, $1Xths.LINE_COLORS).length]
            };
        });
        setLineCrossingsSelectedAlert(processedLines);
        handleComplete();
    }).catch((reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setLineCrossingsSelectedAlert([]);
            handleComplete();
        });
    });
};




var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $60vL1 = parcelRequire("60vL1");

var $5axmO = parcelRequire("5axmO");
const $57f9dbe81a9427b6$var$PREVIEW_WIDTH = 283;
const $57f9dbe81a9427b6$var$PREVIEW_HEIGHT = 187;
const $57f9dbe81a9427b6$export$b652cc54385516b = ({ selectedAlertCameraInfo: selectedAlertCameraInfo, lineCrossingsSelectedAlert: lineCrossingsSelectedAlert, loadingLineCrossingsInfo: loadingLineCrossingsInfo })=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "h-[260px] w-[350px] max-h-[260px] max-w-[350px] overflow-hidden box-border",
        children: [
            loadingLineCrossingsInfo && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex flex-col items-center justify-center h-[187px] w-[283px] max-w-[283px] gap-3 shrink-0",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                        size: 24
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-mulish text-[12px]",
                        children: "Fetching Line Crossings"
                    })
                ]
            }),
            !loadingLineCrossingsInfo && selectedAlertCameraInfo.preview_url && lineCrossingsSelectedAlert && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "relative shrink-0",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                        className: "w-[283px] h-[187px] block",
                        src: selectedAlertCameraInfo.preview_url,
                        alt: "Camera preview"
                    }),
                    lineCrossingsSelectedAlert.length > 0 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-0 left-0",
                        style: {
                            width: 283,
                            height: 187
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $5axmO.LineCrossingsOverlay), {
                            lines: lineCrossingsSelectedAlert,
                            width: $57f9dbe81a9427b6$var$PREVIEW_WIDTH,
                            height: $57f9dbe81a9427b6$var$PREVIEW_HEIGHT
                        })
                    })
                ]
            }),
            !loadingLineCrossingsInfo && selectedAlertCameraInfo.preview_url && lineCrossingsSelectedAlert && lineCrossingsSelectedAlert.length > 0 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "absolute top-[220px] w-[283px] h-[57px] overflow-auto",
                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "absolute left-0 top-0 min-h-[57px] w-[283px]",
                    children: lineCrossingsSelectedAlert.map((line, index)=>/*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "flex items-center gap-2 py-0.5",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    style: {
                                        height: 10,
                                        width: 6,
                                        background: line.color
                                    },
                                    className: "shrink-0"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                    className: "font-mulish text-[10px]",
                                    children: [
                                        "Line crossing ",
                                        index + 1
                                    ]
                                })
                            ]
                        }, line.id ?? index))
                })
            }),
            !loadingLineCrossingsInfo && selectedAlertCameraInfo.preview_url && lineCrossingsSelectedAlert && lineCrossingsSelectedAlert.length === 0 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "absolute top-[220px] w-[283px]",
                children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "font-mulish text-[10px]",
                    children: "No line crossings configured"
                })
            }),
            !loadingLineCrossingsInfo && !selectedAlertCameraInfo.preview_url && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "font-mulish text-[12px]",
                    children: "Unable to Display Line Crossings"
                })
            })
        ]
    });
};



// eslint-disable-next-line @typescript-eslint/no-unused-vars
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $f116d278642eaee3$export$89cd944bf12efbec = (id, navigate, setSiteOptions, setLoadingSites, sitesArray, setSiteDropDownValue)=>{
    setLoadingSites(true);
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $f116d278642eaee3$export$89cd944bf12efbec(id, navigate, setSiteOptions, setLoadingSites, sitesArray, setSiteDropDownValue);
    };
    AxiosUI.get(`customer/names/${id}/`).then((response)=>{
        setSiteOptions(response.data);
        const siteIds = new Map();
        response.data.forEach((object)=>{
            siteIds.set(object.name, object.id);
        });
        const siteNames = new Map();
        response.data.forEach((object)=>{
            siteNames.set(object.id, object.name);
        });
        setSiteDropDownValue(sitesArray.map((site)=>{
            return siteNames.get(site);
        }));
        setLoadingSites(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Error retrieving sites. Please try again");
            setLoadingSites(false);
        });
    });
};


// eslint-disable-next-line @typescript-eslint/no-unused-vars
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $86f1a0ab2c742656$export$a307f389749b22c4 = (idArray, navigate, setCameraOptions, setLoadingCameras, setCameraDropDownValue, cameraArray)=>{
    setLoadingCameras(true);
    const AxiosUI = (0, $195EM.createApi)("");
    const retryFunction = ()=>{
        $86f1a0ab2c742656$export$a307f389749b22c4(idArray, navigate, setCameraOptions, setLoadingCameras, setCameraDropDownValue, cameraArray);
    };
    let idString = "";
    if (idArray.length === 1) idString = `${idArray[0]}`;
    if (idArray.length > 1) {
        idString = `${idArray[0]}`;
        idArray.forEach((id, index)=>{
            if (index > 0) idString += `,${id}`;
        });
    }
    let allSiteCameras;
    const cameraNames = new Map();
    const getSiteCameras = (pageNumber)=>{
        AxiosUI.get(`camera/site/?customers=${idString}&page=${pageNumber}`).then((response)=>{
            if (response.data.count > 0) {
                if (pageNumber === 1) {
                    allSiteCameras = response.data.results;
                    response.data.results.forEach((object)=>{
                        cameraNames.set(object.id, object.camera_name);
                    });
                }
                if (pageNumber > 1) {
                    allSiteCameras.push(...response.data.results);
                    response.data.results.forEach((object)=>{
                        cameraNames.set(object.id, object.camera_name);
                    });
                }
                if (response.data.next) getSiteCameras(pageNumber + 1);
                else {
                    setCameraOptions(allSiteCameras);
                    setLoadingCameras(false);
                    setCameraDropDownValue(cameraArray.map((id)=>{
                        return cameraNames.get(id);
                    }));
                }
            }
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                alert("Error retrieving sites. Please try again");
                setLoadingCameras(false);
            });
        });
    };
    idArray.length === 0 ? setCameraOptions([]) : getSiteCameras(1);
};




var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $60vL1 = parcelRequire("60vL1");
var $kUcVg = parcelRequire("kUcVg");
var $1TOOV = parcelRequire("1TOOV");
var $iLEpm = parcelRequire("iLEpm");
var $ce8iU = parcelRequire("ce8iU");
var $iKAtE = parcelRequire("iKAtE");


var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

var $433j1 = parcelRequire("433j1");
const $444cc57251e01c92$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $444cc57251e01c92$var$NotesSection = ({ heading: heading, notes: notes, loading: loading, emptyText: emptyText })=>/*#__PURE__*/ (0, $k4ank.jsxs)("section", {
        "aria-label": heading,
        className: "mb-4 last:mb-0",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("h3", {
                className: "mb-1 font-mulish text-[14px] font-bold text-actuate-blue",
                children: heading
            }),
            loading ? /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "flex min-h-[40px] items-center justify-center",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                    theme: $444cc57251e01c92$var$theme,
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                        color: "primary",
                        size: 24
                    })
                })
            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                sx: {
                    whiteSpace: "pre-line"
                },
                children: notes || emptyText
            })
        ]
    });
const $444cc57251e01c92$export$666c1e0066ebe8f0 = ()=>{
    const { siteNotes: siteNotes, viewSiteProtocolDialogOpen: viewSiteProtocolDialogOpen, setViewSiteProtocolDialogOpen: setViewSiteProtocolDialogOpen, retrievingSiteNotes: retrievingSiteNotes, cameraNotes: cameraNotes, retrievingCameraNotes: retrievingCameraNotes } = (0, $a4c0e7e0c5cf28c3$export$52a528b1f45cfa42)();
    const handleClose = ()=>{
        setViewSiteProtocolDialogOpen(false);
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: viewSiteProtocolDialogOpen,
        onClose: handleClose,
        fullWidth: true,
        maxWidth: "xs",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                children: "Protocol / Notes"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                "aria-label": "close",
                onClick: handleClose,
                sx: {
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme)=>theme.palette.grey[500]
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                sx: {
                    minHeight: "100px"
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)($444cc57251e01c92$var$NotesSection, {
                        heading: "Site Notes / Protocol",
                        notes: siteNotes,
                        loading: retrievingSiteNotes,
                        emptyText: "No site notes."
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)($444cc57251e01c92$var$NotesSection, {
                        heading: "Camera Notes / Protocol",
                        notes: cameraNotes,
                        loading: retrievingCameraNotes,
                        emptyText: "No camera notes."
                    })
                ]
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $1TOOV = parcelRequire("1TOOV");

var $k1BHZ = parcelRequire("k1BHZ");

var $imWqP = parcelRequire("imWqP");

var $7UDCh = parcelRequire("7UDCh");

var $f3puC = parcelRequire("f3puC");

var $eDfvp = parcelRequire("eDfvp");


var $887xF = parcelRequire("887xF");
var $eejVe = parcelRequire("eejVe");

var $8jTCz = parcelRequire("8jTCz");
const $0b93534abfa1b2dc$export$55589e37db492f67 = ({ selectedRow: selectedRow, navigate: navigate })=>{
    const { handleMuteAlerts: handleMuteAlerts, fetchSharedMutes: fetchSharedMutes, setMutedAlertInfo: setMutedAlertInfo } = (0, $a4c0e7e0c5cf28c3$export$52a528b1f45cfa42)();
    const { mutedAlertsDialogOpen: mutedAlertsDialogOpen, setMutedAlertsDialogOpen: setMutedAlertsDialogOpen } = (0, $a4c0e7e0c5cf28c3$export$52a528b1f45cfa42)();
    const [selectedMuteType, setSelectedMuteType] = $8T3gX.useState("site");
    const [muteDuration, setMuteDuration] = $8T3gX.useState(30);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: mutedAlertsDialogOpen,
        maxWidth: "xs",
        fullWidth: true,
        sx: {
            height: 750
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "pt-[5px]",
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                            sx: {
                                fontFamily: "Mulish",
                                fontSize: 14,
                                fontWeight: 700,
                                color: "#d32f2f",
                                pb: 2
                            },
                            children: "In addition to muting live alerts, muting also stops alert delivery to the monitoring center and third-party integrations (SMS, Immix, Milestone, webhooks) for the selected duration. This affects all operators \u2014 it does not just hide alerts from your view. Muted alerts are retained in your Resolved queue."
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $7UDCh.default), {
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $imWqP.default), {
                                value: selectedMuteType,
                                name: "radio-buttons-group",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                                        sx: {
                                            display: "flex",
                                            alignItems: "center",
                                            mb: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {
                                                value: "site",
                                                onChange: (event)=>{
                                                    setSelectedMuteType(event.target.value);
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                                sx: {
                                                    ml: 1,
                                                    fontFamily: "Mulish"
                                                },
                                                children: [
                                                    "Mute All",
                                                    " ",
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                                        component: "span",
                                                        sx: {
                                                            fontFamily: "Mulish",
                                                            fontWeight: 900
                                                        },
                                                        children: selectedRow.display_name
                                                    }),
                                                    " ",
                                                    "Site Alerts"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                                        sx: {
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {
                                                value: "camera",
                                                onChange: (event)=>{
                                                    setSelectedMuteType(event.target.value);
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                                sx: {
                                                    ml: 1,
                                                    fontFamily: "Mulish"
                                                },
                                                children: [
                                                    "Mute Only",
                                                    " ",
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                                        component: "span",
                                                        sx: {
                                                            fontFamily: "Mulish",
                                                            fontWeight: 900
                                                        },
                                                        children: selectedRow.camera_name
                                                    }),
                                                    " ",
                                                    "Camera Alerts"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "pt-[30px] pl-[10px]",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                sx: {
                                    fontFamily: "Mulish",
                                    fontSize: 16,
                                    fontWeight: 500
                                },
                                children: "Mute Duration (minutes)"
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "pt-[10px] pl-[10px]",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                value: muteDuration,
                                onChange: (event)=>{
                                    const value = event.target.value;
                                    // Only allow numbers (including empty string for clearing)
                                    if (value === "" || /^\d+$/.test(value)) setMuteDuration(value === "" ? 0 : Number(value));
                                },
                                onKeyDown: (event)=>{
                                    // Prevent non-numeric characters from being typed
                                    if (!/[0-9]/.test(event.key) && ![
                                        "Backspace",
                                        "Delete",
                                        "Tab",
                                        "Enter",
                                        "ArrowLeft",
                                        "ArrowRight"
                                    ].includes(event.key)) event.preventDefault();
                                },
                                sx: {
                                    width: "100px"
                                },
                                type: "text",
                                inputProps: {
                                    inputMode: "numeric",
                                    pattern: "[0-9]*"
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        text: "Cancel",
                        onClick: ()=>setMutedAlertsDialogOpen(false),
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        text: "Save",
                        onClick: async ()=>{
                            // The operational mute endpoint takes a camera pk for both scopes;
                            // the backend expands "site" scope to all of the site's cameras.
                            const muteSucceeded = await handleMuteAlerts(selectedMuteType, "mute", selectedRow.camera_pk, muteDuration, navigate);
                            // The muted lists are the shared fleet-wide state (ENG-2103):
                            // refetch rather than appending locally.
                            if (muteSucceeded) fetchSharedMutes(navigate);
                            if (muteSucceeded && selectedMuteType === "site") setMutedAlertInfo({
                                siteName: selectedRow.display_name,
                                cameraName: "",
                                alertEndTime: Date.now() + muteDuration * 60000
                            });
                            else if (muteSucceeded) setMutedAlertInfo({
                                siteName: selectedRow.display_name,
                                cameraName: selectedRow.camera_name,
                                alertEndTime: Date.now() + muteDuration * 60000
                            });
                            // Auto-select first visible row after muting
                            // Filter out the row that was just muted to get the correct first row
                            // const filteredVisibleRows = visibleRows.filter((row: any) => {
                            //   if (selectedMuteType === "site") {
                            //     return row.customer_pk !== selectedRow.customer_pk;
                            //   } else {
                            //     return row.camera_pk !== selectedRow.camera_pk;
                            //   }
                            // });
                            // if (visibleRows.length > 1) {
                            //   const firstRow = visibleRows[1];
                            //   handleRowSelected(
                            //     firstRow,
                            //     alertData,
                            //     setAlertData,
                            //     setSelectedButtonsFilled,
                            //     setSeeMoreURL,
                            //     navigate,
                            //     setMP4URL,
                            //     setVideoClipLoading,
                            //     setSelectedRow,
                            //     setSelectedAlertCameraInfo,
                            //     setIgnoreZonesSelectedAlert,
                            //     refreshingToken,
                            //     visibleRows,
                            //     setBackArrowDisabled,
                            //     setForwardArrowDisabled,
                            //     setShowRefreshButton
                            //   );
                            //   scrollToTop();
                            // }
                            setMutedAlertsDialogOpen(false);
                        },
                        disabled: false
                    })
                ]
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $1TOOV = parcelRequire("1TOOV");


var $f3puC = parcelRequire("f3puC");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $k8Qy8 = parcelRequire("k8Qy8");

var $ha39s = parcelRequire("ha39s");

var $4o6Cs = parcelRequire("4o6Cs");

var $aVDw9 = parcelRequire("aVDw9");

var $iKAtE = parcelRequire("iKAtE");
var $4reBM = parcelRequire("4reBM");
var $gXvgZ = parcelRequire("gXvgZ");
var $cVCJe = parcelRequire("cVCJe");

var $ka01y = parcelRequire("ka01y");

var $8jTCz = parcelRequire("8jTCz");

var $ePwXE = parcelRequire("ePwXE");

var $ebTQj = parcelRequire("ebTQj");
const $9a5c317778c381ce$export$96bb40b6f4974acf = ()=>{
    try {
        // First try to get from localStorage
        if (typeof window !== "undefined" && window.localStorage) {
            const storedTimezone = localStorage.getItem("userTimezone");
            if (storedTimezone) return storedTimezone;
        }
        // Fallback to browser's detected timezone
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (error) {
        (0, $ebTQj.logger).error("Error getting user timezone:", error);
        // Final fallback
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
};



var $433j1 = parcelRequire("433j1");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
const $0a0cb6ffc5ad760e$export$ab060d6e82607889 = (timestamp, timezone)=>{
    const date = new Date(timestamp);
    return date.toLocaleString("en-US", {
        timeZone: timezone,
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true
    });
};
const $0a0cb6ffc5ad760e$export$9fdb9e7466b0eff6 = (startMs, nowMs)=>{
    const minutes = Math.max(0, Math.floor((nowMs - startMs) / 60000));
    if (minutes < 1) return "just now";
    if (minutes < 60) return `${minutes} min ago`;
    const hours = Math.floor(minutes / 60);
    const rest = minutes % 60;
    return rest > 0 ? `${hours} hr ${rest} min ago` : `${hours} hr ago`;
};
const $0a0cb6ffc5ad760e$var$mutedByLabel = (mutedBy)=>mutedBy ? mutedBy : "\u2014";
const $0a0cb6ffc5ad760e$export$5e17d2ea5ebc0db0 = ()=>{
    const { seeMutedSiteAndCamerasDialogOpen: seeMutedSiteAndCamerasDialogOpen, setSeeMutedSiteAndCamerasDialogOpen: setSeeMutedSiteAndCamerasDialogOpen, mutedAlertSites: mutedAlertSites, mutedAlertCameras: mutedAlertCameras, fetchSharedMutes: fetchSharedMutes, unmuteSharedMute: unmuteSharedMute } = (0, $a4c0e7e0c5cf28c3$export$52a528b1f45cfa42)();
    const navigate = (0, $3T949.useNavigate)();
    // Row key of the unmute in flight, so it can't be double-fired.
    const [unmutingKey, setUnmutingKey] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (seeMutedSiteAndCamerasDialogOpen) fetchSharedMutes(navigate);
    // Fetch once per open; navigate's identity is irrelevant here.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        seeMutedSiteAndCamerasDialogOpen,
        fetchSharedMutes
    ]);
    const handleUnmute = async (key, scope, entry)=>{
        setUnmutingKey(key);
        try {
            await unmuteSharedMute(scope, entry, navigate);
        } finally{
            setUnmutingKey(null);
        }
    };
    // Get the current user's timezone
    const userTimezone = (0, $9a5c317778c381ce$export$96bb40b6f4974acf)();
    const now = Date.now();
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: seeMutedSiteAndCamerasDialogOpen,
        fullWidth: mutedAlertSites.length > 0 || mutedAlertCameras.length > 0 ? true : false,
        maxWidth: mutedAlertSites.length > 0 || mutedAlertCameras.length > 0 ? "md" : "xs",
        onClose: ()=>setSeeMutedSiteAndCamerasDialogOpen(false),
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                "aria-label": "close",
                onClick: ()=>{
                    setSeeMutedSiteAndCamerasDialogOpen(false);
                },
                sx: {
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme)=>theme.palette.grey[500]
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                sx: {
                    minHeight: 200,
                    maxHeight: 600
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            fontFamily: "Mulish",
                            fontSize: 18,
                            fontWeight: 500
                        },
                        children: "Muted Sites"
                    }),
                    mutedAlertSites.length > 0 ? /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "pt-[20px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4reBM.default), {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                    sx: {
                                        width: "100%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsxs)("colgroup", {
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)("col", {
                                                    style: {
                                                        width: "31.67%"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)("col", {
                                                    style: {
                                                        width: "31.67%"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)("col", {
                                                    style: {
                                                        width: "31.67%"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)("col", {
                                                    style: {
                                                        width: "5%",
                                                        minWidth: "50px"
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        children: "Site Name"
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        children: "Muted Until"
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        children: "Muted By"
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {})
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                            children: mutedAlertSites.map((site)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            children: site.site_name
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                                            children: [
                                                                "until",
                                                                " ",
                                                                $0a0cb6ffc5ad760e$export$ab060d6e82607889(site.mute_end_time, userTimezone),
                                                                "\xa0",
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                                    title: `${userTimezone}`,
                                                                    placement: "top",
                                                                    sx: {
                                                                        fontSize: "10px",
                                                                        fontFamily: "mulish"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                                                        fontSize: "small"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                                            children: [
                                                                "muted ",
                                                                $0a0cb6ffc5ad760e$export$9fdb9e7466b0eff6(site.mute_start_time, now),
                                                                " by",
                                                                " ",
                                                                $0a0cb6ffc5ad760e$var$mutedByLabel(site.muted_by)
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                                onClick: ()=>handleUnmute(`site-${site.site_id}`, "site", site),
                                                                disabled: unmutingKey === `site-${site.site_id}`,
                                                                text: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                                    title: "Unmute Site",
                                                                    placement: "top",
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ka01y))), {})
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }, `site-${site.site_id}`))
                                        })
                                    ]
                                })
                            })
                        })
                    }) : /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "pt-[5px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                            sx: {
                                fontFamily: "Mulish",
                                fontSize: 16,
                                fontWeight: 500
                            },
                            children: "No muted sites"
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "pt-[20px]"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "pt-[20px]",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                sx: {
                                    fontFamily: "Mulish",
                                    fontSize: 18,
                                    fontWeight: 500
                                },
                                children: "Muted Cameras"
                            }),
                            mutedAlertCameras.length > 0 ? /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "pt-[20px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4reBM.default), {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                            sx: {
                                                width: "100%"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsxs)("colgroup", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("col", {
                                                            style: {
                                                                width: "23.75%"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("col", {
                                                            style: {
                                                                width: "23.75%"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("col", {
                                                            style: {
                                                                width: "23.75%"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("col", {
                                                            style: {
                                                                width: "23.75%"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("col", {
                                                            style: {
                                                                width: "5%",
                                                                minWidth: "50px"
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                children: "Camera Name"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                children: "Site Name"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                children: "Muted Until"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                children: "Muted By"
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {})
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                                    children: mutedAlertCameras.map((camera)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                                                    children: [
                                                                        camera.camera_name,
                                                                        " "
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    children: camera.site_name
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                                                    children: [
                                                                        "until",
                                                                        " ",
                                                                        $0a0cb6ffc5ad760e$export$ab060d6e82607889(camera.mute_end_time, userTimezone),
                                                                        "\xa0",
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                                            title: `${userTimezone}`,
                                                                            placement: "top",
                                                                            sx: {
                                                                                fontSize: "10px",
                                                                                fontFamily: "mulish"
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                                                                fontSize: "small"
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                                                    children: [
                                                                        "muted ",
                                                                        $0a0cb6ffc5ad760e$export$9fdb9e7466b0eff6(camera.mute_start_time, now),
                                                                        " ",
                                                                        "by ",
                                                                        $0a0cb6ffc5ad760e$var$mutedByLabel(camera.muted_by)
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                                        onClick: ()=>// scope="site" rows are the cameras left over
                                                                            // from a split site mute: unmute per camera.
                                                                            handleUnmute(`camera-${camera.camera_id}`, "camera", camera),
                                                                        text: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                                            title: "Unmute Camera",
                                                                            placement: "top",
                                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ka01y))), {})
                                                                        }),
                                                                        disabled: unmutingKey === `camera-${camera.camera_id}`
                                                                    })
                                                                })
                                                            ]
                                                        }, `camera-${camera.camera_id}`))
                                                })
                                            ]
                                        })
                                    })
                                })
                            }) : /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "pt-[5px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                    sx: {
                                        fontFamily: "Mulish",
                                        fontSize: 16,
                                        fontWeight: 500
                                    },
                                    children: "No muted cameras"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $4PFLW = parcelRequire("4PFLW");

var $aYdit = parcelRequire("aYdit");

const $5a19cf5e0e4098f6$export$1a2d5fe7be2083ce = (selectedRow, mutedAlertSites, mutedAlertCameras, setSelectedRowIsMuted)=>{
    // Early return if selectedRow is invalid or empty
    if (!selectedRow) {
        setSelectedRowIsMuted(false);
        return;
    }
    let isMuted = false;
    mutedAlertSites.forEach((mutedSite)=>{
        if (mutedSite.site_id === selectedRow.customer_pk) isMuted = true;
    });
    mutedAlertCameras.forEach((mutedCamera)=>{
        if (mutedCamera.camera_id === selectedRow.camera_pk) isMuted = true;
    });
    setSelectedRowIsMuted(isMuted);
};


const $6251a0d926b9101e$export$6d5de491accea1ad = ({ selectedCameraPk: selectedCameraPk, videoCameraPk: videoCameraPk, selectedRowKey: selectedRowKey, videoRowKey: videoRowKey, hasVideoUrl: hasVideoUrl, isLoading: isLoading })=>{
    if (!hasVideoUrl || isLoading) return false;
    // Row-key mismatch is the strongest signal that the visible clip
    // belongs to a different alert than the currently selected one.
    if (selectedRowKey && videoRowKey) return selectedRowKey !== videoRowKey;
    // Fallback for older states where row keys are unavailable.
    if (!selectedCameraPk || !videoCameraPk) return false;
    return selectedCameraPk !== videoCameraPk;
};




var $hAnMZ = parcelRequire("hAnMZ");

var $biDrR = parcelRequire("biDrR");

var $8T3gX = parcelRequire("8T3gX");
const $30ce4f6d944a4dd5$export$7d5fecdcb1e02566 = ({ fetchingFilteredData: fetchingFilteredData, detectionType: detectionType, outcomeFilterType: outcomeFilterType, setVlmFilterType: setVlmFilterType })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (fetchingFilteredData) setVlmFilterType("Filtered Queue");
    }, [
        fetchingFilteredData,
        setVlmFilterType
    ]);
    const isFirstRender = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(true);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        setVlmFilterType("Filtered Queue");
    }, [
        detectionType,
        outcomeFilterType,
        setVlmFilterType
    ]);
};



/**
 * Whether the Live Stream / Split View tabs (and the Site Video Wall) should be
 * offered for an alert. The alerts API carries `live_streaming_site_enabled`
 * (Customer.live_streaming_enabled, the flag the stream mint gates on) per
 * alert; a site with it off can only ever answer "Live View not Available",
 * so the tabs are pointless there.
 *
 * Only an explicit `false` hides them. A missing/null flag is "unknown"
 * (older API), and unknown is not "off". The user-level gate (LaunchDarkly
 * flag + live_streaming permission) is checked by the caller.
 */ const $c81fb78bce1907ac$export$9ad94dfd18e4b176 = (row)=>row?.live_streaming_site_enabled !== false;




var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $4PFLW = parcelRequire("4PFLW");

var $jboFg = parcelRequire("jboFg");
/**
 * Alerts Option A megaphone: hold-to-talk live talk-down (ENG-1721 transport)
 * with Jess's mockup chrome (icon button + status banner under the tab row).
 */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $9sPDj = parcelRequire("9sPDj");

var $jboFg = parcelRequire("jboFg");

var $kggiO = parcelRequire("kggiO");

var $8jTKl = parcelRequire("8jTKl");

var $8sbJd = parcelRequire("8sbJd");

var $4ysU8 = parcelRequire("4ysU8");
const $0ce17b4bf3bfca1e$export$1a8dba0c37579682 = "Hold to talk down (live)";
const $0ce17b4bf3bfca1e$export$dedf99b98c5c5c52 = "Talk-down isn't available for this camera";
const $0ce17b4bf3bfca1e$export$510e40bde20050d5 = "Live talk down in progress";
const $0ce17b4bf3bfca1e$export$f3a6b6cae2508c1 = "Release the megaphone to end";
const $0ce17b4bf3bfca1e$export$8be6d21d7fd2506f = "Dismiss talk-down status";
const $0ce17b4bf3bfca1e$var$idleButtonClassName = "inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-[10px] border-[1.5px] border-[#cfd8e6] bg-white text-[#233762] disabled:cursor-default";
const $0ce17b4bf3bfca1e$var$unavailableButtonClassName = "inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-[10px] border-[1.5px] border-[#e2e8f2] bg-[#f5f7fa] text-[#9AA3B5] disabled:cursor-default";
const $0ce17b4bf3bfca1e$var$activeButtonClassName = "talk-down-pulse inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-[10px] border-[1.5px] border-actuate-orange bg-actuate-orange text-white";
const $0ce17b4bf3bfca1e$var$pendingButtonClassName = "inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-[10px] border-[1.5px] border-[#9CA3AF] bg-[#9CA3AF] text-white disabled:cursor-default";
const $0ce17b4bf3bfca1e$var$MegaphoneIcon = ()=>/*#__PURE__*/ (0, $k4ank.jsxs)("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.8",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                d: "m3 11 18-5v12L3 14v-3z"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                d: "M11.6 16.8a3 3 0 1 1-5.8-1.6"
            })
        ]
    });
/** Megaphone with a slash — used when talk-down isn't available for the camera. */ const $0ce17b4bf3bfca1e$var$MegaphoneUnavailableIcon = ()=>/*#__PURE__*/ (0, $k4ank.jsxs)("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.8",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                d: "m3 11 18-5v12L3 14v-3z"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                d: "M11.6 16.8a3 3 0 1 1-5.8-1.6"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("line", {
                x1: "3",
                y1: "3",
                x2: "21",
                y2: "21"
            })
        ]
    });
const $0ce17b4bf3bfca1e$var$MicIcon = ()=>/*#__PURE__*/ (0, $k4ank.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "#e57600",
        strokeWidth: "1.8",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                d: "M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                d: "M19 10v2a7 7 0 0 1-14 0v-2"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("line", {
                x1: "12",
                x2: "12",
                y1: "19",
                y2: "22"
            })
        ]
    });
const $0ce17b4bf3bfca1e$var$CloseIcon = ()=>/*#__PURE__*/ (0, $k4ank.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("line", {
                x1: "18",
                y1: "6",
                x2: "6",
                y2: "18"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("line", {
                x1: "6",
                y1: "6",
                x2: "18",
                y2: "18"
            })
        ]
    });
const $0ce17b4bf3bfca1e$var$WAVEFORM_HEIGHTS = [
    6,
    12,
    18,
    10,
    16,
    8,
    14,
    11,
    17,
    9,
    13,
    7
];
const $0ce17b4bf3bfca1e$var$LiveWaveform = ()=>/*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "ml-1 flex h-5 items-end gap-[3px]",
        "aria-hidden": "true",
        children: $0ce17b4bf3bfca1e$var$WAVEFORM_HEIGHTS.map((height, index)=>/*#__PURE__*/ (0, $k4ank.jsx)("span", {
                className: "inline-block w-[3px] rounded-sm bg-actuate-orange",
                style: {
                    height: height
                }
            }, index))
    });
const $0ce17b4bf3bfca1e$var$isActivationKey = (key)=>key === " " || key === "Enter";
const $0ce17b4bf3bfca1e$var$TalkDownPulseStyles = ()=>/*#__PURE__*/ (0, $k4ank.jsx)("style", {
        children: `
    @keyframes talk-down-pulse {
      0% { box-shadow: 0 0 0 0 rgba(255, 132, 0, 0.45); }
      100% { box-shadow: 0 0 0 12px rgba(255, 132, 0, 0); }
    }
    .talk-down-pulse {
      animation: talk-down-pulse 1.2s ease-out infinite;
    }
    @keyframes talk-down-dot {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.35; }
    }
    .talk-down-dot {
      animation: talk-down-dot 1s ease-in-out infinite;
    }
  `
    });
const $0ce17b4bf3bfca1e$export$4a349117e19b50fb = ({ status: status, onDismiss: onDismiss })=>{
    const { phase: phase, message: message, elapsedSeconds: elapsedSeconds, detail: detail } = status;
    const staff = (0, $4ysU8.useIsStaffUser)();
    const isLive = phase === "live";
    const isConnecting = phase === "connecting";
    const isError = phase === "error" || phase === "failed";
    const isOk = phase === "ended";
    const canDismiss = Boolean(onDismiss) && !isLive && !isConnecting;
    const title = isLive ? $0ce17b4bf3bfca1e$export$510e40bde20050d5 : isConnecting ? "Connecting..." : message || "Talk-down";
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        role: "status",
        "data-testid": "alert-talk-down-live-banner",
        className: `mb-3 flex items-center gap-3 rounded-[10px] border-[1.5px] px-4 py-3 font-mulish text-[#20283a] ${isError ? "border-[#B3261E] bg-[#FCE8E6]" : isOk ? "border-[#1B7F3B] bg-[#E8F5EC]" : "border-actuate-orange bg-[#fff4e8]"}`,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)($0ce17b4bf3bfca1e$var$TalkDownPulseStyles, {}),
            /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                className: `talk-down-dot inline-block h-2.5 w-2.5 shrink-0 rounded-full ${isError ? "bg-[#B3261E]" : isOk ? "bg-[#1B7F3B]" : "bg-[#d64545]"}`
            }),
            !isError && !isOk && /*#__PURE__*/ (0, $k4ank.jsx)($0ce17b4bf3bfca1e$var$MicIcon, {}),
            /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                className: "text-[15px] font-semibold",
                children: title
            }),
            isLive && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                        className: "font-mono text-[14px] text-[#54595f]",
                        children: (0, $9sPDj.formatLiveElapsed)(elapsedSeconds)
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)($0ce17b4bf3bfca1e$var$LiveWaveform, {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                        className: "ml-auto text-[13px] text-[#54595f]",
                        children: $0ce17b4bf3bfca1e$export$f3a6b6cae2508c1
                    })
                ]
            }),
            !isLive && message && title !== message && /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                className: "text-[13px] text-[#54595f]",
                children: message
            }),
            staff && detail && (isError || isOk) && /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                "data-testid": "alert-talk-down-live-detail",
                className: "break-all font-mono text-[11px] text-[#7a8090]",
                children: detail
            }),
            canDismiss && /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                type: "button",
                "aria-label": $0ce17b4bf3bfca1e$export$8be6d21d7fd2506f,
                title: $0ce17b4bf3bfca1e$export$8be6d21d7fd2506f,
                onClick: onDismiss,
                className: "ml-auto -mr-1 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-[#54595f] hover:bg-black/5 hover:text-[#20283a]",
                children: /*#__PURE__*/ (0, $k4ank.jsx)($0ce17b4bf3bfca1e$var$CloseIcon, {})
            })
        ]
    });
};
const $0ce17b4bf3bfca1e$var$AlertTalkDownMegaphoneStub = ({ label: label = $0ce17b4bf3bfca1e$export$dedf99b98c5c5c52 })=>/*#__PURE__*/ (0, $k4ank.jsx)("button", {
        type: "button",
        "aria-label": label,
        title: label,
        className: $0ce17b4bf3bfca1e$var$unavailableButtonClassName,
        disabled: true,
        children: /*#__PURE__*/ (0, $k4ank.jsx)($0ce17b4bf3bfca1e$var$MegaphoneUnavailableIcon, {})
    });
const $0ce17b4bf3bfca1e$var$AlertTalkDownMegaphoneLive = ({ cameraId: cameraId, cameraName: cameraName, liveOptions: liveOptions, onStatusChange: onStatusChange, onRegisterEndSession: onRegisterEndSession })=>{
    const live = (0, $9sPDj.useLiveTalkDown)({
        cameraId: cameraId,
        cameraName: cameraName,
        statusPoll: liveOptions?.statusPoll,
        idleMs: liveOptions?.idleMs,
        whipDeps: liveOptions?.whipDeps
    });
    const { state: state, elapsedSeconds: elapsedSeconds, busy: busy, press: press, release: release, reset: reset } = live;
    const heldKeyRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (state.phase === "idle") {
            onStatusChange?.(null);
            return;
        }
        onStatusChange?.({
            phase: state.phase,
            message: state.message,
            elapsedSeconds: elapsedSeconds,
            ...state.detail ? {
                detail: state.detail
            } : {}
        });
    }, [
        state.phase,
        state.message,
        state.detail,
        elapsedSeconds,
        onStatusChange
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        onRegisterEndSession?.(reset);
        return ()=>onRegisterEndSession?.(null);
    }, [
        reset,
        onRegisterEndSession
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        return ()=>onStatusChange?.(null);
    }, [
        onStatusChange
    ]);
    const isLive = state.phase === "live";
    const isConnecting = state.phase === "connecting";
    const holding = isLive || isConnecting;
    const buttonClassName = isLive ? $0ce17b4bf3bfca1e$var$activeButtonClassName : isConnecting || busy ? $0ce17b4bf3bfca1e$var$pendingButtonClassName : $0ce17b4bf3bfca1e$var$idleButtonClassName;
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)($0ce17b4bf3bfca1e$var$TalkDownPulseStyles, {}),
            /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                type: "button",
                "aria-label": $0ce17b4bf3bfca1e$export$1a8dba0c37579682,
                "aria-pressed": isLive,
                title: isLive ? $0ce17b4bf3bfca1e$export$f3a6b6cae2508c1 : isConnecting ? "Connecting..." : state.phase === "closing" ? "Still closing the last session\u2026" : $0ce17b4bf3bfca1e$export$1a8dba0c37579682,
                disabled: busy,
                onPointerDown: (event)=>{
                    if (event.button !== undefined && event.button !== 0) return;
                    event.preventDefault();
                    press();
                },
                onPointerUp: release,
                onPointerLeave: ()=>{
                    if (holding) release();
                },
                onPointerCancel: release,
                onKeyDown: (event)=>{
                    if (!$0ce17b4bf3bfca1e$var$isActivationKey(event.key) || event.repeat) return;
                    event.preventDefault();
                    heldKeyRef.current = true;
                    press();
                },
                onKeyUp: (event)=>{
                    if (!$0ce17b4bf3bfca1e$var$isActivationKey(event.key) || !heldKeyRef.current) return;
                    heldKeyRef.current = false;
                    release();
                },
                onBlur: ()=>{
                    if (holding) release();
                },
                onContextMenu: (event)=>event.preventDefault(),
                style: {
                    touchAction: "none",
                    userSelect: "none"
                },
                className: buttonClassName,
                children: /*#__PURE__*/ (0, $k4ank.jsx)($0ce17b4bf3bfca1e$var$MegaphoneIcon, {})
            })
        ]
    });
};
const $0ce17b4bf3bfca1e$export$7f893d92355e6893 = ({ cameraId: cameraId, cameraName: cameraName, integrationTypeName: integrationTypeName, skipSiteTypeGate: skipSiteTypeGate, talkDownCapable: talkDownCapable, liveOptions: liveOptions, onStatusChange: onStatusChange, onRegisterEndSession: onRegisterEndSession })=>{
    const enabled = (0, $jboFg.useTalkDownEnabled)({
        integrationTypeName: integrationTypeName,
        skipSiteTypeGate: skipSiteTypeGate,
        talkDownCapable: talkDownCapable
    });
    const mode = (0, $jboFg.useTalkDownMode)();
    const learnedIncapable = (0, $kggiO.useTalkDownLearnedIncapable)(cameraId);
    const staff = (0, $4ysU8.useIsStaffUser)();
    // dev/redesign on staging with Use production off: no real cameras, so a
    // start can only fail. Disabled, with the reason, and no transport.
    const needsProductionMode = (0, $8sbJd.liveMediaNeedsProductionMode)();
    const canLive = enabled && !learnedIncapable && !needsProductionMode && mode === "live" && cameraId != null && cameraId !== "";
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!canLive) {
            onStatusChange?.(null);
            onRegisterEndSession?.(null);
        }
    }, [
        canLive,
        onStatusChange,
        onRegisterEndSession
    ]);
    if (!canLive) {
        const label = needsProductionMode && enabled && !learnedIncapable ? staff ? (0, $8jTKl.TALK_DOWN_NEEDS_PRODUCTION_MODE_STAFF_MESSAGE) : (0, $8jTKl.TALK_DOWN_NEEDS_PRODUCTION_MODE_MESSAGE) : undefined;
        return /*#__PURE__*/ (0, $k4ank.jsx)($0ce17b4bf3bfca1e$var$AlertTalkDownMegaphoneStub, {
            label: label
        });
    }
    return /*#__PURE__*/ (0, $k4ank.jsx)($0ce17b4bf3bfca1e$var$AlertTalkDownMegaphoneLive, {
        cameraId: cameraId,
        cameraName: cameraName,
        liveOptions: liveOptions,
        onStatusChange: onStatusChange,
        onRegisterEndSession: onRegisterEndSession
    }, `alert-live-${cameraId}`);
};


/**
 * Alerts Option A waveform control: pick a library message for this camera,
 * preview it, play it on the speaker (ENG-2232), or record a new one.
 */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $60vL1 = parcelRequire("60vL1");
var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $aYNpO = parcelRequire("aYNpO");

var $aBrLz = parcelRequire("aBrLz");

var $anJSP = parcelRequire("anJSP");

var $7AQZl = parcelRequire("7AQZl");

var $d1ZPE = parcelRequire("d1ZPE");

var $k4ank = parcelRequire("k4ank");
'use client';
const $c092706b06a9e6ab$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $c092706b06a9e6ab$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $d1ZPE.getDividerUtilityClass), classes);
};
const $c092706b06a9e6ab$var$DividerRoot = (0, $anJSP.default)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin'
    }, ownerState.absolute && {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%'
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $aBrLz.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === 'inset' && {
        marginLeft: 72
    }, ownerState.variant === 'middle' && ownerState.orientation === 'horizontal' && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === 'middle' && ownerState.orientation === 'vertical' && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === 'vertical' && {
        height: '100%',
        borderBottomWidth: 0,
        borderRightWidth: 'thin'
    }, ownerState.flexItem && {
        alignSelf: 'stretch',
        height: 'auto'
    }), ({ ownerState: ownerState })=>(0, $eJfrs.default)({}, ownerState.children && {
        display: 'flex',
        whiteSpace: 'nowrap',
        textAlign: 'center',
        border: 0,
        borderTopStyle: 'solid',
        borderLeftStyle: 'solid',
        '&::before, &::after': {
            content: '""',
            alignSelf: 'center'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({}, ownerState.children && ownerState.orientation !== 'vertical' && {
        '&::before, &::after': {
            width: '100%',
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
            borderTopStyle: 'inherit'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({}, ownerState.children && ownerState.orientation === 'vertical' && {
        flexDirection: 'column',
        '&::before, &::after': {
            height: '100%',
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
            borderLeftStyle: 'inherit'
        }
    }), ({ ownerState: ownerState })=>(0, $eJfrs.default)({}, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '90%'
        },
        '&::after': {
            width: '10%'
        }
    }, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '10%'
        },
        '&::after': {
            width: '90%'
        }
    }));
const $c092706b06a9e6ab$var$DividerWrapper = (0, $anJSP.default)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === 'vertical' && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $c092706b06a9e6ab$var$Divider = /*#__PURE__*/ $8T3gX.forwardRef(function Divider(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, orientation: orientation = 'horizontal', role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth' } = props, other = (0, $fAJB5.default)(props, $c092706b06a9e6ab$var$_excluded);
    const ownerState = (0, $eJfrs.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $c092706b06a9e6ab$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $k4ank.jsx)($c092706b06a9e6ab$var$DividerRoot, (0, $eJfrs.default)({
        as: component,
        className: (0, $iVyaN.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $k4ank.jsx)($c092706b06a9e6ab$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ $c092706b06a9e6ab$var$Divider.muiSkipListHighlight = true;
$c092706b06a9e6ab$var$Divider.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Absolutely position the element.
   * @default false
   */ absolute: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).elementType,
    /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */ flexItem: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * If `true`, the divider will have a lighter color.
   * @default false
   * @deprecated Use <Divider sx={{ opacity: 0.6 }} /> (or any opacity or color) instead. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/)
   */ light: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * The component orientation.
   * @default 'horizontal'
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'horizontal',
        'vertical'
    ]),
    /**
   * @ignore
   */ role: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).string,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * The text alignment.
   * @default 'center'
   */ textAlign: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'center',
        'left',
        'right'
    ]),
    /**
   * The variant to use.
   * @default 'fullWidth'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT)) /* @typescript-to-proptypes-ignore */ ).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
            'fullWidth',
            'inset',
            'middle'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string
    ])
};
var $c092706b06a9e6ab$export$2e2bcd8739ae039 = $c092706b06a9e6ab$var$Divider;


var $1fWBE = parcelRequire("1fWBE");
var $cxknk = parcelRequire("cxknk");

var $8jTCz = parcelRequire("8jTCz");

var $8jTKl = parcelRequire("8jTKl");

var $kggiO = parcelRequire("kggiO");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $60vL1 = parcelRequire("60vL1");
var $kUcVg = parcelRequire("kUcVg");
var $887xF = parcelRequire("887xF");
var $1TOOV = parcelRequire("1TOOV");
var $ce8iU = parcelRequire("ce8iU");
var $iKAtE = parcelRequire("iKAtE");
var $eejVe = parcelRequire("eejVe");

var $433j1 = parcelRequire("433j1");

var $b9p11 = parcelRequire("b9p11");


var $8jTCz = parcelRequire("8jTCz");

var $8kxcc = parcelRequire("8kxcc");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kbChx = parcelRequire("kbChx");
var $yndCB = parcelRequire("yndCB");
var $3baw3 = parcelRequire("3baw3");
var $iKAtE = parcelRequire("iKAtE");

var $5gr4N = parcelRequire("5gr4N");

const $b97869735a5c700b$export$5341a20088efd68 = ({ sites: sites, search: search, onSearchChange: onSearchChange, assignments: assignments, onChange: onChange, searchPlaceholder: searchPlaceholder = "Search sites and cameras", camerasOnlySiteId: camerasOnlySiteId })=>{
    const [expanded, setExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const camerasOnly = camerasOnlySiteId != null && camerasOnlySiteId !== "";
    const q = search.trim().toLowerCase();
    const filtered = sites.filter((site)=>{
        if (camerasOnly && String(site.siteId) !== String(camerasOnlySiteId)) return false;
        if (!q) return true;
        if (site.siteName.toLowerCase().includes(q)) return true;
        return site.cameras.some((c)=>c.cameraName.toLowerCase().includes(q));
    });
    const getAssignment = (siteId)=>assignments.find((a)=>String(a.siteId) === String(siteId));
    const setSiteEntire = (site, checked)=>{
        const without = assignments.filter((a)=>String(a.siteId) !== String(site.siteId));
        if (!checked) {
            onChange(without);
            return;
        }
        onChange([
            ...without,
            {
                siteId: site.siteId,
                siteName: site.siteName,
                mode: "entire_site",
                cameraIds: [],
                cameraNames: site.cameras.map((c)=>c.cameraName)
            }
        ]);
    };
    const toggleCamera = (site, cameraId, cameraName, checked)=>{
        const existing = getAssignment(site.siteId);
        const without = assignments.filter((a)=>String(a.siteId) !== String(site.siteId));
        if (existing?.mode === "entire_site") {
            // Switching from entire site to per-camera: start with all except this one if unchecked
            const cameras = site.cameras.filter((c)=>checked ? true : String(c.cameraId) !== String(cameraId));
            if (!cameras.length) {
                onChange(without);
                return;
            }
            if (cameras.length === site.cameras.length) {
                setSiteEntire(site, true);
                return;
            }
            onChange([
                ...without,
                {
                    siteId: site.siteId,
                    siteName: site.siteName,
                    mode: "cameras",
                    cameraIds: cameras.map((c)=>c.cameraId),
                    cameraNames: cameras.map((c)=>c.cameraName)
                }
            ]);
            return;
        }
        const currentIds = existing?.cameraIds.map(String) ?? [];
        let nextIds = checked ? [
            ...currentIds,
            String(cameraId)
        ] : currentIds.filter((id)=>id !== String(cameraId));
        nextIds = Array.from(new Set(nextIds));
        if (!nextIds.length) {
            onChange(without);
            return;
        }
        if (nextIds.length === site.cameras.length && site.cameras.length > 0) {
            setSiteEntire(site, true);
            return;
        }
        const nameById = new Map(site.cameras.map((c)=>[
                String(c.cameraId),
                c.cameraName
            ]));
        onChange([
            ...without,
            {
                siteId: site.siteId,
                siteName: site.siteName,
                mode: "cameras",
                cameraIds: nextIds,
                cameraNames: nextIds.map((id)=>nameById.get(id) || cameraName)
            }
        ]);
    };
    const selectedSummary = ()=>{
        const siteN = assignments.length;
        const camN = assignments.reduce((n, a)=>{
            if (a.mode === "entire_site") return n + (a.cameraNames.length || 0);
            return n + a.cameraIds.length;
        }, 0);
        return `SELECTED \xb7 ${siteN} SITE${siteN === 1 ? "" : "S"}, ${camN} CAMERA${camN === 1 ? "" : "S"}`;
    };
    const renderCameraCheckboxes = (site, selectedCamIds, indent = false)=>/*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: indent ? "pb-2 pl-10" : "px-3 py-2",
            children: [
                site.cameras.map((cam)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                        className: "!m-0 block",
                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                            size: "small",
                            checked: selectedCamIds.has(String(cam.cameraId)),
                            onChange: (e)=>toggleCamera(site, cam.cameraId, cam.cameraName, e.target.checked)
                        }),
                        label: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                            className: "text-[13px] text-actuate-blue",
                            children: cam.cameraName
                        })
                    }, String(cam.cameraId))),
                !site.cameras.length && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "text-[13px] text-gray-500",
                    children: "No cameras at this site."
                })
            ]
        });
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "font-mulish",
        children: [
            !camerasOnly && /*#__PURE__*/ (0, $k4ank.jsx)("input", {
                type: "search",
                value: search,
                onChange: (e)=>onSearchChange(e.target.value),
                placeholder: searchPlaceholder,
                "aria-label": searchPlaceholder,
                className: "mb-3 w-full rounded border border-actuate-grey px-3 py-2 text-[14px] text-actuate-blue"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "max-h-[320px] overflow-y-auto rounded border border-actuate-grey",
                children: [
                    filtered.map((site)=>{
                        const key = String(site.siteId);
                        const assignment = getAssignment(site.siteId);
                        const entire = assignment?.mode === "entire_site";
                        const selectedCamIds = new Set((assignment?.mode === "cameras" ? assignment.cameraIds : entire ? site.cameras.map((c)=>c.cameraId) : []).map(String));
                        const isOpen = expanded[key] ?? false;
                        if (camerasOnly) return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            children: renderCameraCheckboxes(site, selectedCamIds)
                        }, key);
                        return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "border-b border-actuate-grey last:border-b-0",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "flex items-center gap-1 px-2 py-1",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                            className: "flex-1 !m-0",
                                            control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                size: "small",
                                                checked: Boolean(assignment),
                                                indeterminate: assignment?.mode === "cameras" && assignment.cameraIds.length > 0 && assignment.cameraIds.length < site.cameras.length,
                                                onChange: (e)=>setSiteEntire(site, e.target.checked)
                                            }),
                                            label: /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                                                className: "text-[14px] text-actuate-blue",
                                                children: [
                                                    site.siteName,
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                        className: "ml-2 text-[12px] text-gray-500",
                                                        children: entire ? `Entire site \xb7 ${site.cameras.length || "all"} cameras` : `${site.cameras.length} cameras`
                                                    })
                                                ]
                                            })
                                        }),
                                        site.cameras.length > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                            size: "small",
                                            "aria-label": isOpen ? "Collapse cameras" : "Expand cameras",
                                            onClick: ()=>setExpanded((prev)=>({
                                                        ...prev,
                                                        [key]: !isOpen
                                                    })),
                                            children: isOpen ? /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($879ea8b84720ab7f$exports))), {}) : /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5gr4N))), {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $yndCB.default), {
                                    in: isOpen,
                                    children: renderCameraCheckboxes(site, selectedCamIds, true)
                                })
                            ]
                        }, key);
                    }),
                    !filtered.length && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "p-4 text-[13px] text-gray-500",
                        children: camerasOnly ? "No cameras for this site." : "No sites match."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "mt-4 text-[12px] font-bold uppercase tracking-wide text-actuate-blue",
                children: selectedSummary()
            })
        ]
    });
};


/**
 * Live group / site / camera loaders for the Talk Down Messages assign UI.
 */ 
var $195EM = parcelRequire("195EM");
const $f18c618421bb94cb$var$sortByName = (rows, key)=>[
        ...rows
    ].sort((a, b)=>String(a[key] || "").localeCompare(String(b[key] || "")));
const $f18c618421bb94cb$var$readCachedParentAccounts = ()=>{
    try {
        const raw = localStorage.getItem("parentAccounts");
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return [];
        return $f18c618421bb94cb$var$sortByName(parsed.filter((g)=>g && g.id != null && g.name).map((g)=>({
                id: g.id,
                name: String(g.name)
            })), "name");
    } catch  {
        return [];
    }
};
const $f18c618421bb94cb$export$e9529af042ee40f9 = async ()=>{
    const cached = $f18c618421bb94cb$var$readCachedParentAccounts();
    if (cached.length) return cached;
    const { data: data } = await (0, $195EM.createApi)("").get("group/?parent_account=true&page_size=10000");
    const results = Array.isArray(data?.results) ? data.results : [];
    return $f18c618421bb94cb$var$sortByName(results.filter((g)=>g?.id != null && g?.name).map((g)=>({
            id: g.id,
            name: String(g.name)
        })), "name");
};
const $f18c618421bb94cb$var$fetchCamerasForSite = async (siteId)=>{
    const api = (0, $195EM.createApi)("");
    const cameras = [];
    let page = 1;
    let hasNext = true;
    while(hasNext){
        const { data: data } = await api.get(`camera/site/?customer__id=${siteId}&page=${page}`);
        const results = Array.isArray(data?.results) ? data.results : [];
        for (const cam of results){
            if (cam?.id == null) continue;
            cameras.push({
                cameraId: cam.id,
                cameraName: cam.camera_name || `Camera ${cam.id}`
            });
        }
        hasNext = Boolean(data?.next);
        page += 1;
        if (page > 100) break;
    }
    return cameras.sort((a, b)=>String(a.cameraName).localeCompare(String(b.cameraName)));
};
/** Run async work over items with a fixed concurrency cap. */ const $f18c618421bb94cb$var$mapWithConcurrency = async (items, concurrency, fn)=>{
    const results = new Array(items.length);
    let nextIndex = 0;
    const workers = Array.from({
        length: Math.min(concurrency, items.length)
    }, async ()=>{
        while(nextIndex < items.length){
            const index = nextIndex;
            nextIndex += 1;
            results[index] = await fn(items[index]);
        }
    });
    await Promise.all(workers);
    return results;
};
const $f18c618421bb94cb$export$14112600e9dd8260 = async (groupId)=>{
    const { data: data } = await (0, $195EM.createApi)("").get(`customer/names/${groupId}/`);
    const sites = Array.isArray(data) ? data : Array.isArray(data?.results) ? data.results : [];
    const built = await $f18c618421bb94cb$var$mapWithConcurrency(sites, 8, async (site)=>{
        let cameras = [];
        try {
            cameras = await $f18c618421bb94cb$var$fetchCamerasForSite(site.id);
        } catch  {
            cameras = [];
        }
        return {
            siteId: site.id,
            siteName: site.name || `Site ${site.id}`,
            cameras: cameras
        };
    });
    return $f18c618421bb94cb$var$sortByName(built, "siteName");
};


/**
 * Talk Down Messages store. Loads from the admin CRUD API (ENG-2179).
 * Starts empty; shows an empty table when the user has no messages.
 */ 
var $9OjAn = parcelRequire("9OjAn");
/**
 * Admin talk-down message library API (ENG-2179 / ENG-2232).
 * Maps snake_case responses onto the UI TalkDownMessage shape.
 */ 
var $195EM = parcelRequire("195EM");
const $d2ad5572b0a3f46a$var$api = ()=>(0, $195EM.createApi)("talk_down_messages/");
const $d2ad5572b0a3f46a$var$mapAssignment = (a)=>({
        siteId: a.site_id,
        siteName: a.site_name,
        mode: a.mode,
        cameraIds: [
            ...a.camera_ids || []
        ],
        cameraNames: [
            ...a.camera_names || []
        ]
    });
const $d2ad5572b0a3f46a$export$205b1627a0b8b682 = (m)=>({
        id: m.id,
        name: m.name,
        groupId: m.group_id,
        groupName: m.group_name,
        durationSeconds: m.duration_seconds,
        recordedBy: m.recorded_by || "",
        recordedAt: m.recorded_at,
        playCount: m.play_count ?? 0,
        audioUrl: m.audio_url,
        assignments: (m.assignments || []).map($d2ad5572b0a3f46a$var$mapAssignment)
    });
const $d2ad5572b0a3f46a$var$toApiAssignments = (assignments)=>assignments.map((a)=>({
            site_id: a.siteId,
            mode: a.mode,
            camera_ids: a.cameraIds
        }));
const $d2ad5572b0a3f46a$export$70d2714286d831b9 = async (url, filename)=>{
    const res = await fetch(url);
    const blob = await res.blob();
    return new File([
        blob
    ], filename, {
        type: blob.type || "audio/webm"
    });
};
const $d2ad5572b0a3f46a$export$58f976f83368f13f = async (groupId)=>{
    const params = groupId != null ? {
        group_id: groupId
    } : undefined;
    const { data: data } = await $d2ad5572b0a3f46a$var$api().get("", {
        params: params
    });
    return (data.results || []).map($d2ad5572b0a3f46a$export$205b1627a0b8b682);
};
const $d2ad5572b0a3f46a$export$d3a3b74f994d90c7 = (m)=>({
        id: m.id,
        name: m.name,
        durationSeconds: m.duration_seconds,
        recordedBy: m.recorded_by || "",
        recordedAt: m.recorded_at,
        playCount: m.play_count ?? 0,
        audioUrl: m.audio_url
    });
const $d2ad5572b0a3f46a$export$6dd73743eeee4720 = async (cameraId)=>{
    const { data: data } = await (0, $195EM.createApi)("").get(`camera/${cameraId}/talk_down_messages/`);
    const rows = Array.isArray(data) ? data : [];
    return rows.map($d2ad5572b0a3f46a$export$d3a3b74f994d90c7);
};
const $d2ad5572b0a3f46a$export$3a3113cd7fe00a2a = async (cameraId, messageId)=>{
    const { data: data } = await (0, $195EM.createApi)("").post(`camera/${cameraId}/talk_down_messages/${messageId}/play/`);
    return data;
};
const $d2ad5572b0a3f46a$export$cd84e5b691f5385 = async (input)=>{
    const form = new FormData();
    form.append("name", input.name);
    form.append("group_id", String(input.groupId));
    form.append("duration_seconds", String(input.durationSeconds));
    const file = input.audio instanceof File ? input.audio : new File([
        input.audio
    ], input.filename || "message.webm", {
        type: input.audio.type || "audio/webm"
    });
    form.append("audio", file);
    if (input.assignments?.length) form.append("assignments", JSON.stringify($d2ad5572b0a3f46a$var$toApiAssignments(input.assignments)));
    const { data: data } = await $d2ad5572b0a3f46a$var$api().post("", form, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
    return $d2ad5572b0a3f46a$export$205b1627a0b8b682(data);
};
const $d2ad5572b0a3f46a$export$1d094de235210030 = async (id, patch)=>{
    const form = new FormData();
    if (patch.name != null) form.append("name", patch.name);
    if (patch.durationSeconds != null) form.append("duration_seconds", String(patch.durationSeconds));
    if (patch.audio) {
        const file = patch.audio instanceof File ? patch.audio : new File([
            patch.audio
        ], "message.webm", {
            type: patch.audio.type || "audio/webm"
        });
        form.append("audio", file);
    }
    const { data: data } = await $d2ad5572b0a3f46a$var$api().patch(`${id}/`, form, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
    return $d2ad5572b0a3f46a$export$205b1627a0b8b682(data);
};
const $d2ad5572b0a3f46a$export$79039ddb542c8391 = async (id, assignments)=>{
    const { data: data } = await $d2ad5572b0a3f46a$var$api().put(`${id}/assignments/`, {
        assignments: $d2ad5572b0a3f46a$var$toApiAssignments(assignments)
    });
    return $d2ad5572b0a3f46a$export$205b1627a0b8b682(data);
};
const $d2ad5572b0a3f46a$export$64729d5900d05d7c = async (id)=>{
    await $d2ad5572b0a3f46a$var$api().delete(`${id}/`);
};
const $d2ad5572b0a3f46a$export$b1232b51c6db770 = (err)=>{
    const status = err?.response?.status;
    return status === 404 || status === 502 || status === 503 || !status;
};


let $5fe762dced2f1f3d$var$nextId = 100;
const $5fe762dced2f1f3d$var$localAdd = (input)=>{
    $5fe762dced2f1f3d$var$nextId += 1;
    return {
        id: `msg-${$5fe762dced2f1f3d$var$nextId}`,
        name: input.name,
        groupId: input.groupId,
        groupName: input.groupName,
        durationSeconds: input.durationSeconds,
        recordedBy: input.recordedBy,
        recordedAt: new Date().toISOString(),
        playCount: 0,
        audioUrl: input.audioUrl,
        assignments: input.assignments.map((a)=>({
                ...a,
                cameraIds: [
                    ...a.cameraIds
                ],
                cameraNames: [
                    ...a.cameraNames
                ]
            }))
    };
};
const $5fe762dced2f1f3d$export$eddecb1f05de5e25 = (0, $9OjAn.create)((set, get)=>({
        messages: [],
        apiLive: false,
        loading: true,
        loadError: null,
        reset: ()=>{
            $5fe762dced2f1f3d$var$nextId = 100;
            set({
                messages: [],
                apiLive: false,
                loading: true,
                loadError: null
            });
        },
        loadMessages: async (groupId)=>{
            set({
                loading: true,
                loadError: null
            });
            try {
                const messages = await (0, $d2ad5572b0a3f46a$export$58f976f83368f13f)(groupId);
                set({
                    messages: messages,
                    apiLive: true,
                    loading: false,
                    loadError: null
                });
            } catch (err) {
                if ((0, $d2ad5572b0a3f46a$export$b1232b51c6db770)(err)) {
                    set({
                        messages: [],
                        apiLive: false,
                        loading: false,
                        loadError: null
                    });
                    return;
                }
                set({
                    loading: false,
                    loadError: "Failed to load talk-down messages."
                });
            }
        },
        addMessage: async (input)=>{
            // Always try the admin API first (Alerts wizard never visits /talkdown,
            // so apiLive may still be false). Fall back to local only if undeployed.
            if (input.audioUrl) try {
                const file = await (0, $d2ad5572b0a3f46a$export$70d2714286d831b9)(input.audioUrl, `${input.name.replace(/\s+/g, "_").toLowerCase()}.webm`);
                const created = await (0, $d2ad5572b0a3f46a$export$cd84e5b691f5385)({
                    name: input.name,
                    groupId: input.groupId,
                    audio: file,
                    durationSeconds: input.durationSeconds,
                    assignments: input.assignments
                });
                set((state)=>({
                        messages: [
                            created,
                            ...state.messages
                        ],
                        apiLive: true
                    }));
                return created;
            } catch (err) {
                if (!(0, $d2ad5572b0a3f46a$export$b1232b51c6db770)(err)) throw err;
            }
            const message = $5fe762dced2f1f3d$var$localAdd(input);
            set((state)=>({
                    messages: [
                        message,
                        ...state.messages
                    ]
                }));
            return message;
        },
        updateMessage: async (id, patch)=>{
            if (patch.name != null || patch.audioUrl) try {
                let audio;
                if (patch.audioUrl?.startsWith("blob:")) audio = await (0, $d2ad5572b0a3f46a$export$70d2714286d831b9)(patch.audioUrl, "message.webm");
                const updated = await (0, $d2ad5572b0a3f46a$export$1d094de235210030)(id, {
                    name: patch.name,
                    audio: audio,
                    durationSeconds: patch.durationSeconds
                });
                set((state)=>({
                        apiLive: true,
                        messages: state.messages.map((m)=>m.id === id ? {
                                ...updated,
                                ...patch,
                                ...updated
                            } : m)
                    }));
                // Merge local-only fields (e.g. playCount bumps) after server patch.
                if (patch.playCount != null) set((state)=>({
                        messages: state.messages.map((m)=>m.id === id ? {
                                ...m,
                                playCount: patch.playCount
                            } : m)
                    }));
                return;
            } catch (err) {
                if (!(0, $d2ad5572b0a3f46a$export$b1232b51c6db770)(err)) throw err;
            }
            set((state)=>({
                    messages: state.messages.map((m)=>m.id === id ? {
                            ...m,
                            ...patch
                        } : m)
                }));
        },
        setAssignments: async (id, assignments)=>{
            try {
                const updated = await (0, $d2ad5572b0a3f46a$export$79039ddb542c8391)(id, assignments);
                set((state)=>({
                        apiLive: true,
                        messages: state.messages.map((m)=>m.id === id ? updated : m)
                    }));
                return;
            } catch (err) {
                if (!(0, $d2ad5572b0a3f46a$export$b1232b51c6db770)(err)) throw err;
            }
            set((state)=>({
                    messages: state.messages.map((m)=>m.id === id ? {
                            ...m,
                            assignments: assignments.map((a)=>({
                                    ...a,
                                    cameraIds: [
                                        ...a.cameraIds
                                    ],
                                    cameraNames: [
                                        ...a.cameraNames
                                    ]
                                }))
                        } : m)
                }));
        },
        removeAssignment: async (id, siteId)=>{
            const current = get().messages.find((m)=>m.id === id);
            if (!current) return;
            const next = current.assignments.filter((a)=>String(a.siteId) !== String(siteId));
            await get().setAssignments(id, next);
        },
        deleteMessage: async (id)=>{
            try {
                await (0, $d2ad5572b0a3f46a$export$64729d5900d05d7c)(id);
                set({
                    apiLive: true
                });
            } catch (err) {
                if (!(0, $d2ad5572b0a3f46a$export$b1232b51c6db770)(err)) throw err;
            }
            set((state)=>({
                    messages: state.messages.filter((m)=>m.id !== id)
                }));
        },
        getById: (id)=>get().messages.find((m)=>m.id === id)
    }));


/**
 * Canonical Talk Down Messages shapes for the UI-first library (C1–C5).
 * These types will back the future admin CRUD API ticket.
 */ const $12037e7a4c3f6675$export$30398d3192ef3048 = (seconds)=>{
    const whole = Math.max(0, Math.floor(seconds));
    const m = Math.floor(whole / 60);
    const s = whole % 60;
    return `${m}:${String(s).padStart(2, "0")}`;
};
const $12037e7a4c3f6675$export$ee2aad92dd186a4c = (assignments)=>{
    if (!assignments.length) return "Unassigned";
    const siteCount = assignments.length;
    const allEntire = assignments.every((a)=>a.mode === "entire_site");
    const allPartial = assignments.every((a)=>a.mode === "cameras");
    const countedCameras = assignments.reduce((sum, a)=>{
        if (a.mode === "cameras") return sum + a.cameraIds.length;
        return sum + (a.cameraNames.length || a.cameraIds.length);
    }, 0);
    if (allEntire) {
        if (siteCount === 1) {
            const n = countedCameras;
            return n > 0 ? `1 site \xb7 ${n} cameras` : "1 site \xb7 all cameras";
        }
        return countedCameras > 0 ? `${siteCount} sites \xb7 ${countedCameras} cameras` : `${siteCount} sites \xb7 all cameras`;
    }
    if (allPartial && siteCount === 1) {
        const n = assignments[0].cameraIds.length;
        return `${n} camera${n === 1 ? "" : "s"}`;
    }
    return `${siteCount} site${siteCount === 1 ? "" : "s"} \xb7 ${countedCameras} cameras`;
};


const $9423b3d41063fd06$var$STEPS = [
    "Record",
    "Assign",
    "Review"
];
const $9423b3d41063fd06$export$c1ddb5544e24e8b5 = ({ open: open, onClose: onClose, recordedBy: recordedBy = "You", onSaved: onSaved, initialGroupId: initialGroupId, defaultAssignment: defaultAssignment })=>{
    const addMessage = (0, $5fe762dced2f1f3d$export$eddecb1f05de5e25)((s)=>s.addMessage);
    const [activeStep, setActiveStep] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [name, setName] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [parentGroups, setParentGroups] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [groupsLoading, setGroupsLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [groupsError, setGroupsError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [groupId, setGroupId] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [assignSites, setAssignSites] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [assignSitesLoading, setAssignSitesLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [assignSitesError, setAssignSitesError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [audioUrl, setAudioUrl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [durationSeconds, setDurationSeconds] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [assignments, setAssignments] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [assignSearch, setAssignSearch] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [recordError, setRecordError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [saveError, setSaveError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [saving, setSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const fileInputRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const elapsedRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(0);
    const loadedAssignGroupRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const revokeAudio = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback((url)=>{
        if (url && url.startsWith("blob:")) URL.revokeObjectURL(url);
    }, []);
    const setNewAudio = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback((url, seconds)=>{
        setAudioUrl((prev)=>{
            if (prev && prev !== url) revokeAudio(prev);
            return url;
        });
        setDurationSeconds(seconds);
    }, [
        revokeAudio
    ]);
    const recorder = (0, $8kxcc.useAudioRecorder)({
        maxSeconds: 30,
        onRecorded: (blob)=>{
            const url = URL.createObjectURL(blob);
            setNewAudio(url, Math.max(1, Math.min(30, elapsedRef.current || 1)));
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        elapsedRef.current = recorder.elapsedSeconds;
    }, [
        recorder.elapsedSeconds
    ]);
    const handleStopRecord = ()=>{
        elapsedRef.current = recorder.elapsedSeconds || elapsedRef.current || 1;
        recorder.stop();
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (recorder.error) setRecordError(recorder.error);
    }, [
        recorder.error
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!open) return;
        setActiveStep(0);
        setName("");
        setGroupId("");
        setParentGroups([]);
        setGroupsError(null);
        setAssignSites([]);
        setAssignSitesError(null);
        setAssignSitesLoading(false);
        loadedAssignGroupRef.current = null;
        setNewAudio(null, 0);
        setAssignments([]);
        setAssignSearch("");
        setRecordError(null);
        setSaveError(null);
        setSaving(false);
        let cancelled = false;
        setGroupsLoading(true);
        (0, $f18c618421bb94cb$export$e9529af042ee40f9)().then((groups)=>{
            if (cancelled) return;
            setParentGroups(groups);
            if (!groups.length) return;
            const preferred = initialGroupId != null && initialGroupId !== "" ? groups.find((g)=>String(g.id) === String(initialGroupId)) : undefined;
            setGroupId(preferred ? preferred.id : groups[0].id);
        }).catch(()=>{
            if (cancelled) return;
            setGroupsError("Could not load groups.");
            setParentGroups([]);
        }).finally(()=>{
            if (!cancelled) setGroupsLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        open,
        initialGroupId,
        setNewAudio
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!open || activeStep !== 1 || groupId === "") return;
        const key = String(groupId);
        if (loadedAssignGroupRef.current === key) return;
        let cancelled = false;
        setAssignSitesLoading(true);
        setAssignSitesError(null);
        (0, $f18c618421bb94cb$export$14112600e9dd8260)(groupId).then((sites)=>{
            if (cancelled) return;
            setAssignSites(sites);
            loadedAssignGroupRef.current = key;
        }).catch(()=>{
            if (cancelled) return;
            setAssignSites([]);
            setAssignSitesError("Could not load sites for this group.");
            loadedAssignGroupRef.current = null;
        }).finally(()=>{
            if (!cancelled) setAssignSitesLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        open,
        activeStep,
        groupId
    ]);
    if (!open) return null;
    const selectedGroup = parentGroups.find((g)=>String(g.id) === String(groupId)) ?? null;
    const groupName = selectedGroup?.name || "Group";
    const canNextFromRecord = Boolean(name.trim()) && Boolean(audioUrl) && durationSeconds > 0 && groupId !== "" && !groupsLoading;
    const resolveAssignments = (withAssignments)=>{
        if (withAssignments.length) return withAssignments;
        if (defaultAssignment) return [
            defaultAssignment
        ];
        return [];
    };
    const save = async (withAssignments)=>{
        if (saving) return;
        setSaving(true);
        setSaveError(null);
        try {
            await addMessage({
                name: name.trim(),
                groupId: groupId,
                groupName: groupName,
                durationSeconds: durationSeconds,
                recordedBy: recordedBy,
                audioUrl: audioUrl,
                assignments: resolveAssignments(withAssignments)
            });
            onSaved?.();
            onClose();
        } catch  {
            setSaveError("Could not save message. Please try again.");
        } finally{
            setSaving(false);
        }
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: open,
        onClose: onClose,
        fullWidth: true,
        maxWidth: "sm",
        PaperProps: {
            sx: {
                fontFamily: "Mulish",
                maxHeight: "90vh"
            }
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $ce8iU.default), {
                sx: {
                    fontFamily: "Mulish",
                    fontWeight: 800,
                    color: "#001943",
                    pr: 6
                },
                children: [
                    "New talk down message",
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                        "aria-label": "Close",
                        onClick: onClose,
                        sx: {
                            position: "absolute",
                            right: 8,
                            top: 8
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                dividers: true,
                sx: {
                    px: 3,
                    py: 2.5
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "mb-4",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                            theme: (0, $635b38046a5de67e$export$bca14c5b3b88a9c9),
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $91c8cb97eec976fc$export$2e2bcd8739ae039), {
                                activeStep: activeStep,
                                alternativeLabel: true,
                                children: $9423b3d41063fd06$var$STEPS.map((label)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $4238740b0329aed2$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $e5e8e6de71eb5805$export$2e2bcd8739ae039), {
                                            children: label
                                        })
                                    }, label))
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "font-mulish text-actuate-blue",
                        children: [
                            activeStep === 0 && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                        fullWidth: true,
                                        size: "small",
                                        options: parentGroups,
                                        loading: groupsLoading,
                                        disabled: groupsLoading || !parentGroups.length,
                                        value: selectedGroup,
                                        onChange: (_, value)=>{
                                            if (!value) return;
                                            setGroupId(value.id);
                                            setAssignments([]);
                                            setAssignSites([]);
                                            loadedAssignGroupRef.current = null;
                                        },
                                        getOptionLabel: (option)=>option.name || "",
                                        isOptionEqualToValue: (a, b)=>String(a.id) === String(b.id),
                                        disableClearable: Boolean(selectedGroup),
                                        sx: {
                                            fontFamily: "Mulish",
                                            "& .MuiAutocomplete-inputRoot": {
                                                fontFamily: "Mulish"
                                            }
                                        },
                                        ListboxProps: {
                                            sx: {
                                                fontFamily: "Mulish",
                                                "& .MuiAutocomplete-option": {
                                                    display: "block",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap"
                                                }
                                            }
                                        },
                                        renderOption: (props, option)=>/*#__PURE__*/ (0, $8T3gX.createElement)("li", {
                                                ...props,
                                                key: String(option.id),
                                                title: option.name
                                            }, option.name),
                                        renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                                ...params,
                                                label: "Group",
                                                size: "small",
                                                autoComplete: "off",
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                InputProps: {
                                                    ...params.InputProps,
                                                    endAdornment: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                                        children: [
                                                            groupsLoading ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                                                color: "inherit",
                                                                size: 20
                                                            }) : null,
                                                            params.InputProps.endAdornment
                                                        ]
                                                    })
                                                }
                                            })
                                    }),
                                    groupsError && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "text-[13px] text-[#B3261E]",
                                        children: groupsError
                                    }),
                                    !groupsLoading && !groupsError && !parentGroups.length && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "text-[13px] text-gray-500",
                                        children: "No parent groups available for your account."
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        fullWidth: true,
                                        size: "small",
                                        label: "Message name",
                                        value: name,
                                        onChange: (e)=>setName(e.target.value),
                                        sx: {
                                            fontFamily: "Mulish"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                                className: "mb-1 text-[14px] font-semibold",
                                                children: [
                                                    "Recording",
                                                    " ",
                                                    /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                                                        className: "font-normal text-gray-500",
                                                        children: [
                                                            "\xb7 max ",
                                                            (0, $12037e7a4c3f6675$export$30398d3192ef3048)(30)
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                className: "flex items-center gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                                        type: "button",
                                                        className: `inline-flex h-12 w-12 items-center justify-center rounded-full text-white ${recorder.recording ? "bg-[#B3261E]" : "bg-actuate-orange"}`,
                                                        "aria-label": recorder.recording ? "Stop recording" : "Start recording",
                                                        onPointerDown: (e)=>{
                                                            if (e.button !== 0) return;
                                                            e.preventDefault();
                                                            setRecordError(null);
                                                            recorder.clearError();
                                                            recorder.start();
                                                        },
                                                        onPointerUp: handleStopRecord,
                                                        onPointerLeave: ()=>{
                                                            if (recorder.recording) handleStopRecord();
                                                        },
                                                        style: {
                                                            touchAction: "none"
                                                        },
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                            className: "text-[12px] font-bold",
                                                            children: recorder.recording ? (0, $12037e7a4c3f6675$export$30398d3192ef3048)(recorder.elapsedSeconds) : "REC"
                                                        })
                                                    }),
                                                    audioUrl && /*#__PURE__*/ (0, $k4ank.jsx)("audio", {
                                                        controls: true,
                                                        src: audioUrl,
                                                        className: "h-10 flex-1",
                                                        "data-testid": "talk-down-message-preview"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "mt-2 text-[12px] text-gray-500",
                                                children: recorder.recording ? "Release to stop. You can play it back before assigning." : "Hold REC to record, or upload a file below. Hold again to replace."
                                            }),
                                            recordError && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "mt-2 text-[13px] text-[#B3261E]",
                                                children: recordError
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                className: "mb-1 text-[14px] font-semibold",
                                                children: "Or upload an existing audio file"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("input", {
                                                ref: fileInputRef,
                                                type: "file",
                                                accept: "audio/mpeg,audio/wav,.mp3,.wav",
                                                className: "hidden",
                                                onChange: (e)=>{
                                                    const file = e.target.files?.[0];
                                                    if (!file) return;
                                                    const url = URL.createObjectURL(file);
                                                    const audio = new Audio(url);
                                                    audio.addEventListener("loadedmetadata", ()=>{
                                                        const secs = Number.isFinite(audio.duration) ? Math.min(30, Math.max(1, Math.round(audio.duration))) : 1;
                                                        setNewAudio(url, secs);
                                                    });
                                                    audio.addEventListener("error", ()=>{
                                                        setNewAudio(url, 1);
                                                    });
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                text: "Browse (.mp3, .wav)",
                                                disabled: false,
                                                onClick: ()=>fileInputRef.current?.click()
                                            })
                                        ]
                                    })
                                ]
                            }),
                            activeStep === 1 && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                        className: "mb-1 text-[15px] font-semibold",
                                        children: [
                                            name.trim() || "Untitled",
                                            " \xb7 ",
                                            groupName
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                        className: "mb-4 text-[13px] text-gray-500",
                                        children: [
                                            (0, $12037e7a4c3f6675$export$30398d3192ef3048)(durationSeconds),
                                            " \xb7",
                                            " ",
                                            /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                                type: "button",
                                                className: "text-actuate-orange underline",
                                                onClick: ()=>setActiveStep(0),
                                                children: "Re-record"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "mb-3 text-[14px]",
                                        children: "Where should operators be able to play this message?"
                                    }),
                                    assignSitesLoading && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "mb-3 flex items-center gap-3 text-[13px] text-gray-500",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                                size: 22,
                                                sx: {
                                                    color: "#FF8400"
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                children: "Loading sites and cameras\u2026"
                                            })
                                        ]
                                    }),
                                    assignSitesError && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "mb-3 text-[13px] text-[#B3261E]",
                                        children: assignSitesError
                                    }),
                                    !assignSitesLoading && !assignSitesError && /*#__PURE__*/ (0, $k4ank.jsx)((0, $b97869735a5c700b$export$5341a20088efd68), {
                                        sites: assignSites,
                                        search: assignSearch,
                                        onSearchChange: setAssignSearch,
                                        assignments: assignments,
                                        onChange: setAssignments,
                                        searchPlaceholder: `Search sites and cameras in ${groupName}`
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "mt-3 text-[12px] text-gray-500",
                                        children: "You can skip this and assign later from the message."
                                    })
                                ]
                            }),
                            activeStep === 2 && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "space-y-3 text-[14px]",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                className: "font-semibold",
                                                children: "Name:"
                                            }),
                                            " ",
                                            name.trim()
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                className: "font-semibold",
                                                children: "Group:"
                                            }),
                                            " ",
                                            groupName
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                className: "font-semibold",
                                                children: "Length:"
                                            }),
                                            " ",
                                            (0, $12037e7a4c3f6675$export$30398d3192ef3048)(durationSeconds)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                className: "font-semibold",
                                                children: "Assignments:"
                                            }),
                                            " ",
                                            resolveAssignments(assignments).length ? `${resolveAssignments(assignments).length} site(s)` : "None (unassigned)"
                                        ]
                                    }),
                                    audioUrl && /*#__PURE__*/ (0, $k4ank.jsx)("audio", {
                                        controls: true,
                                        src: audioUrl,
                                        className: "w-full"
                                    })
                                ]
                            }),
                            saveError && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "mt-3 text-[13px] text-[#B3261E]",
                                children: saveError
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), {
                sx: {
                    px: 3,
                    py: 2,
                    justifyContent: "space-between"
                },
                children: activeStep === 0 ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            text: "Cancel",
                            disabled: saving,
                            onClick: onClose
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            text: "Next: Assign",
                            disabled: !canNextFromRecord || saving,
                            onClick: ()=>setActiveStep(1)
                        })
                    ]
                }) : activeStep === 1 ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            text: "Back",
                            disabled: saving,
                            onClick: ()=>setActiveStep(0)
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "flex gap-3",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    text: "Skip for now",
                                    disabled: saving,
                                    onClick: ()=>{
                                        setAssignments([]);
                                        setActiveStep(2);
                                    }
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                    text: saving ? "Saving\u2026" : "Save message",
                                    disabled: saving,
                                    onClick: ()=>save(assignments)
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            text: "Back",
                            disabled: saving,
                            onClick: ()=>setActiveStep(1)
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            text: saving ? "Saving\u2026" : "Save message",
                            disabled: saving,
                            onClick: ()=>save(assignments)
                        })
                    ]
                })
            })
        ]
    });
};




const $20b5fbd86f103da2$var$talkDownIconButtonClassName = "inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-[10px] border-[1.5px] border-[#cfd8e6] bg-white text-[#233762]";
const $20b5fbd86f103da2$var$WaveformIcon = ()=>/*#__PURE__*/ (0, $k4ank.jsxs)("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.8",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                d: "M2 10v3"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                d: "M6 6v11"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                d: "M10 3v18"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                d: "M14 8v7"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                d: "M18 5v13"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                d: "M22 10v3"
            })
        ]
    });
const $20b5fbd86f103da2$var$IDLE_PLAY = {
    phase: "idle",
    message: ""
};
/** Per-camera cache for the session (ENG-2232: temporary UI state). */ const $20b5fbd86f103da2$var$messagesCache = new Map();
const $20b5fbd86f103da2$export$bb763b42db752996 = ()=>{
    $20b5fbd86f103da2$var$messagesCache.clear();
};
const $20b5fbd86f103da2$export$4b2a6a6c9a3b2545 = (cameraId, cameraName, parentGroupId, siteId, siteName)=>{
    const cameraKey = cameraId == null || cameraId === "" ? null : String(cameraId);
    const [menuAnchor, setMenuAnchor] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [loading, setLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [loadError, setLoadError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [selected, setSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [playState, setPlayState] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState($20b5fbd86f103da2$var$IDLE_PLAY);
    const [wizardOpen, setWizardOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const abortRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        abortRef.current?.abort();
        abortRef.current = null;
        setSelected(null);
        setPlayState($20b5fbd86f103da2$var$IDLE_PLAY);
        setMenuAnchor(null);
        setLoadError(null);
        if (cameraKey && $20b5fbd86f103da2$var$messagesCache.has(cameraKey)) setMessages($20b5fbd86f103da2$var$messagesCache.get(cameraKey));
        else setMessages([]);
    }, [
        cameraKey
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        return ()=>{
            abortRef.current?.abort();
        };
    }, []);
    const loadMessages = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback(async (force = false)=>{
        if (!cameraKey) {
            setMessages([]);
            setLoadError("No camera selected.");
            setLoading(false);
            return;
        }
        if (!force && $20b5fbd86f103da2$var$messagesCache.has(cameraKey)) {
            setMessages($20b5fbd86f103da2$var$messagesCache.get(cameraKey));
            setLoading(false);
            setLoadError(null);
            return;
        }
        setLoading(true);
        setLoadError(null);
        try {
            const rows = await (0, $d2ad5572b0a3f46a$export$6dd73743eeee4720)(cameraKey);
            $20b5fbd86f103da2$var$messagesCache.set(cameraKey, rows);
            setMessages(rows);
        } catch  {
            setLoadError("Could not load messages for this camera.");
            setMessages([]);
        } finally{
            setLoading(false);
        }
    }, [
        cameraKey
    ]);
    const openMenu = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        setMenuAnchor(event.currentTarget);
        loadMessages(false);
    };
    const closeMenu = ()=>setMenuAnchor(null);
    const invalidateCache = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback(()=>{
        if (cameraKey) $20b5fbd86f103da2$var$messagesCache.delete(cameraKey);
    }, [
        cameraKey
    ]);
    const selectMessage = (message)=>{
        setSelected(message);
        setPlayState($20b5fbd86f103da2$var$IDLE_PLAY);
        closeMenu();
    };
    const playBusy = playState.phase === "sending" || playState.phase === "waiting";
    const handlePlayOnCamera = async ()=>{
        if (!cameraKey || !selected) return;
        abortRef.current?.abort();
        const controller = new AbortController();
        abortRef.current = controller;
        const live = ()=>abortRef.current === controller && !controller.signal.aborted;
        setPlayState({
            phase: "sending",
            message: "Sending..."
        });
        try {
            const dispatch = await (0, $d2ad5572b0a3f46a$export$3a3113cd7fe00a2a)(cameraKey, selected.id);
            if (!live()) return;
            setPlayState({
                phase: "waiting",
                message: (0, $8jTKl.TALK_DOWN_SENT_MESSAGE)
            });
            const result = await (0, $8jTKl.pollTalkDownOutcome)(dispatch.site_id, dispatch.command_id, {
                signal: controller.signal
            });
            if (!live() || result.kind === "aborted") return;
            if (result.kind === "not_received") {
                setPlayState({
                    phase: "failed",
                    message: "Couldn't confirm the talk-down was received"
                });
                return;
            }
            const row = result.kind === "done" ? result.row : null;
            const outcome = (0, $8jTKl.describeTalkDownOutcome)(row, cameraName);
            setPlayState({
                phase: row == null ? "failed" : outcome.ok ? "played" : "failed",
                message: outcome.message
            });
            (0, $kggiO.noteTalkDownErrorCode)(cameraKey, row?.result?.error_code);
            invalidateCache();
            loadMessages(true);
        } catch (reason) {
            if (!live()) return;
            setPlayState({
                phase: "error",
                message: (0, $8jTKl.describeTalkDownSendError)(reason)
            });
            // Keep detail available for staff debugging via console.
            const detail = (0, $8jTKl.describeTalkDownErrorDetail)(reason);
            if (detail) // eslint-disable-next-line no-console
            console.warn("[talk-down library play]", detail);
        }
    };
    const button = /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                type: "button",
                "aria-label": "Play pre-recorded message",
                title: "Play pre-recorded message",
                "aria-haspopup": "menu",
                "aria-expanded": Boolean(menuAnchor),
                className: $20b5fbd86f103da2$var$talkDownIconButtonClassName,
                onClick: openMenu,
                onMouseDown: (e)=>e.stopPropagation(),
                children: /*#__PURE__*/ (0, $k4ank.jsx)($20b5fbd86f103da2$var$WaveformIcon, {})
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                anchorEl: menuAnchor,
                open: Boolean(menuAnchor),
                onClose: closeMenu,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "right"
                },
                disableScrollLock: true,
                sx: {
                    zIndex: 10000
                },
                PaperProps: {
                    sx: {
                        minWidth: 260,
                        maxWidth: 320,
                        maxHeight: 360,
                        fontFamily: "Mulish"
                    }
                },
                MenuListProps: {
                    "aria-label": "Pre-recorded talk-down messages"
                },
                children: [
                    loading && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $cxknk.default), {
                        disabled: true,
                        sx: {
                            fontFamily: "Mulish",
                            gap: 1.5
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                size: 18,
                                sx: {
                                    color: "#FF8400"
                                }
                            }),
                            "Loading messages\u2026"
                        ]
                    }),
                    !loading && loadError && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                        disabled: true,
                        sx: {
                            fontFamily: "Mulish",
                            color: "#B3261E"
                        },
                        children: loadError
                    }),
                    !loading && !loadError && messages.map((m)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $cxknk.default), {
                            onClick: ()=>selectMessage(m),
                            selected: selected?.id === m.id,
                            sx: {
                                fontFamily: "Mulish",
                                display: "block",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                            },
                            title: m.name,
                            children: [
                                m.name,
                                /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                    className: "ml-2 text-[12px] text-gray-500",
                                    children: (0, $12037e7a4c3f6675$export$30398d3192ef3048)(m.durationSeconds)
                                })
                            ]
                        }, m.id)),
                    !loading && !loadError && !messages.length && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                        disabled: true,
                        sx: {
                            fontFamily: "Mulish",
                            color: "#6b7280"
                        },
                        children: "No messages for this camera"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $c092706b06a9e6ab$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                        onClick: ()=>{
                            closeMenu();
                            setWizardOpen(true);
                        },
                        sx: {
                            fontFamily: "Mulish",
                            color: "#FF8400",
                            fontWeight: 700
                        },
                        children: "Record new message"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $9423b3d41063fd06$export$c1ddb5544e24e8b5), {
                open: wizardOpen,
                onClose: ()=>setWizardOpen(false),
                initialGroupId: parentGroupId,
                defaultAssignment: cameraKey && siteId != null && siteId !== "" ? {
                    siteId: siteId,
                    siteName: siteName || "Site",
                    mode: "cameras",
                    cameraIds: [
                        cameraKey
                    ],
                    cameraNames: cameraName ? [
                        cameraName
                    ] : []
                } : null,
                onSaved: ()=>{
                    invalidateCache();
                    loadMessages(true);
                }
            })
        ]
    });
    const panel = selected == null ? null : /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        "data-testid": "alert-talk-down-library-panel",
        className: "mb-3 w-full rounded-[10px] border-[1.5px] border-[#cfd8e6] bg-white px-4 py-3 font-mulish text-[#20283a]",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "mb-2 flex items-start justify-between gap-3",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "text-[15px] font-semibold text-actuate-blue",
                                children: selected.name
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                className: "text-[12px] text-gray-500",
                                children: [
                                    (0, $12037e7a4c3f6675$export$30398d3192ef3048)(selected.durationSeconds),
                                    selected.recordedBy ? ` \xb7 ${selected.recordedBy}` : ""
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                        type: "button",
                        "aria-label": "Close selected message",
                        className: "text-[13px] text-gray-500 underline hover:text-actuate-blue",
                        onClick: ()=>{
                            setSelected(null);
                            setPlayState($20b5fbd86f103da2$var$IDLE_PLAY);
                        },
                        children: "Close"
                    })
                ]
            }),
            selected.audioUrl ? /*#__PURE__*/ (0, $k4ank.jsx)("audio", {
                controls: true,
                src: selected.audioUrl,
                className: "mb-3 h-10 w-full",
                "data-testid": "alert-talk-down-library-preview"
            }) : /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "mb-3 text-[13px] text-gray-500",
                children: "No audio available to preview."
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex flex-wrap items-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        text: playBusy ? "Playing\u2026" : "Play this now on camera",
                        disabled: playBusy || !selected.audioUrl,
                        onClick: ()=>void handlePlayOnCamera()
                    }),
                    playState.phase !== "idle" && /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                        className: `text-[13px] ${playState.phase === "error" || playState.phase === "failed" ? "text-[#B3261E]" : playState.phase === "played" ? "text-[#1B7F3B]" : "text-gray-600"}`,
                        children: playState.message
                    })
                ]
            })
        ]
    });
    return {
        button: button,
        panel: panel,
        hasSelection: Boolean(selected)
    };
};


/**
 * Alerts Option A ear: hold-to-listen (ENG-2136 transport via the live player).
 * Presses register on listenInHoldStore; LiveStreamPlayer unmutes while held.
 * Only shown on Live Stream / Split View (hidden on Alert Clip).
 */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $iMovf = parcelRequire("iMovf");

var $8sbJd = parcelRequire("8sbJd");

var $4ysU8 = parcelRequire("4ysU8");
/**
 * Listen-in (ENG-2136): hear a camera's microphone in live view.
 *
 * Gate: the LaunchDarkly flag `showListenIn` AND the camera has audio (the
 * player decides "has audio" — the mint's has_audio, else a received audio
 * track). Players always start muted (autoplay rules + operator expectation);
 * this button is the user gesture that unmutes. While the operator is
 * talking down to the same camera the button is disabled and the player is
 * forced muted (half-duplex), then the previous listen state comes back.
 */ 
var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $iKAtE = parcelRequire("iKAtE");

var $cVCJe = parcelRequire("cVCJe");
var $feea236c3366565f$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($feea236c3366565f$exports, "__esModule", {
    value: true
});
$feea236c3366565f$exports.default = void 0;

var $feea236c3366565f$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $feea236c3366565f$var$_default = $feea236c3366565f$exports.default = (0, $feea236c3366565f$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M3 9v6h4l5 5V4L7 9zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02M14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77"
}), 'VolumeUp');


var $9c2ea8609b4228a9$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($9c2ea8609b4228a9$exports, "__esModule", {
    value: true
});
$9c2ea8609b4228a9$exports.default = void 0;

var $9c2ea8609b4228a9$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $9c2ea8609b4228a9$var$_default = $9c2ea8609b4228a9$exports.default = (0, $9c2ea8609b4228a9$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63m2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71M4.27 3 3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9zM12 4 9.91 6.09 12 8.18z"
}), 'VolumeOff');



var $4PFLW = parcelRequire("4PFLW");
const $dfff4fad957c9a73$export$5862ff916e2da692 = "showListenIn";
const $dfff4fad957c9a73$export$cfec3a4e5bf05dc1 = "Listen in";
const $dfff4fad957c9a73$export$ce391f82ec1920c7 = "Mute camera audio";
const $dfff4fad957c9a73$export$f2d4dd915f02d45b = "Muted while you're talking";
const $dfff4fad957c9a73$export$69a33c7152d6e9e2 = ()=>{
    const { flags: flags } = (0, $4PFLW.useFeatureFlag)();
    return Boolean(flags?.[$dfff4fad957c9a73$export$5862ff916e2da692]);
};
const $dfff4fad957c9a73$export$7d0a227b3a86e909 = ({ listening: listening, talking: talking, onToggle: onToggle, size: size = "medium" })=>{
    const audible = listening && !talking;
    const label = audible ? $dfff4fad957c9a73$export$ce391f82ec1920c7 : $dfff4fad957c9a73$export$cfec3a4e5bf05dc1;
    const button = /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
        "aria-label": label,
        "aria-pressed": audible,
        disabled: talking,
        size: size,
        onClick: (event)=>{
            // Wall tiles are clickable (focus a camera); don't also do that.
            event.stopPropagation();
            onToggle();
        },
        onKeyDown: (event)=>event.stopPropagation(),
        sx: {
            color: "#fff",
            backgroundColor: audible ? "#FF8400" : "rgba(0,0,0,0.55)",
            "&:hover": {
                backgroundColor: audible ? "#E67300" : "rgba(0,0,0,0.75)"
            },
            "&.Mui-disabled": {
                color: "rgba(255,255,255,0.5)",
                backgroundColor: "rgba(0,0,0,0.55)"
            }
        },
        children: audible ? /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($feea236c3366565f$exports))), {
            fontSize: size === "small" ? "small" : "medium"
        }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9c2ea8609b4228a9$exports))), {
            fontSize: size === "small" ? "small" : "medium"
        })
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
        title: talking ? $dfff4fad957c9a73$export$f2d4dd915f02d45b : label,
        children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
            className: "inline-flex",
            children: button
        })
    });
};


/**
 * Hold-to-listen (Option A ear button) + player audio capability.
 *
 * The Alerts tab-row ear control registers a momentary hold here; LiveStreamPlayer
 * ORs that with its click-to-toggle listen state so either path unmutes the
 * camera mic. Players also publish whether the current stream has audio so the
 * ear can show the unavailable (crossed-out) state.
 */ 
var $9OjAn = parcelRequire("9OjAn");
const $2c93485817abd844$export$76df6223e234efc0 = (0, $9OjAn.create)((set)=>({
        holdCameraId: null,
        setHold: (cameraId)=>set((state)=>state.holdCameraId === cameraId ? state : {
                    holdCameraId: cameraId
                }),
        hasAudioByCamera: {},
        setHasAudio: (cameraId, hasAudio)=>set((state)=>{
                const key = String(cameraId);
                if (hasAudio == null) {
                    if (!(key in state.hasAudioByCamera)) return state;
                    const next = {
                        ...state.hasAudioByCamera
                    };
                    delete next[key];
                    return {
                        hasAudioByCamera: next
                    };
                }
                if (state.hasAudioByCamera[key] === hasAudio) return state;
                return {
                    hasAudioByCamera: {
                        ...state.hasAudioByCamera,
                        [key]: hasAudio
                    }
                };
            })
    }));
const $2c93485817abd844$export$78bbd668af63d494 = (cameraId)=>$2c93485817abd844$export$76df6223e234efc0((state)=>cameraId == null || cameraId === "" ? false : state.holdCameraId === String(cameraId));
const $2c93485817abd844$export$1294e407ba6e1916 = (cameraId)=>$2c93485817abd844$export$76df6223e234efc0((state)=>{
        if (cameraId == null || cameraId === "") return undefined;
        const key = String(cameraId);
        return key in state.hasAudioByCamera ? state.hasAudioByCamera[key] : undefined;
    });


const $c4d41e48f2f75aa6$export$f3aa081276142f4b = "Hold to listen in";
const $c4d41e48f2f75aa6$export$6fe9c4ec31817bc = "Listen-in isn't available for this camera";
const $c4d41e48f2f75aa6$export$8fd54a5e46432af6 = "Listen-in uses real cameras. Switch on Use production to try it.";
const $c4d41e48f2f75aa6$export$aac3fc0f7ac58644 = "Listen-in isn't available on this test site.";
const $c4d41e48f2f75aa6$var$idleButtonClassName = "inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-[10px] border-[1.5px] border-[#cfd8e6] bg-white text-[#233762] disabled:cursor-default";
const $c4d41e48f2f75aa6$var$unavailableButtonClassName = "inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-[10px] border-[1.5px] border-[#e2e8f2] bg-[#f5f7fa] text-[#9AA3B5] disabled:cursor-default";
const $c4d41e48f2f75aa6$var$activeButtonClassName = "inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-[10px] border-[1.5px] border-actuate-orange bg-actuate-orange text-white";
const $c4d41e48f2f75aa6$var$EarIcon = ()=>/*#__PURE__*/ (0, $k4ank.jsxs)("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.8",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                d: "M6 8.5a6.5 6.5 0 1 1 13 0c0 6-6 6-6 10a3.5 3.5 0 1 1-7 0"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                d: "M15 8.5a2.5 2.5 0 0 0-5 0v1a2 2 0 1 1 0 4"
            })
        ]
    });
/** Ear with a slash — used when listen-in isn't available. */ const $c4d41e48f2f75aa6$var$EarUnavailableIcon = ()=>/*#__PURE__*/ (0, $k4ank.jsxs)("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.8",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                d: "M6 8.5a6.5 6.5 0 1 1 13 0c0 6-6 6-6 10a3.5 3.5 0 1 1-7 0"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("path", {
                d: "M15 8.5a2.5 2.5 0 0 0-5 0v1a2 2 0 1 1 0 4"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("line", {
                x1: "3",
                y1: "3",
                x2: "21",
                y2: "21"
            })
        ]
    });
const $c4d41e48f2f75aa6$var$isActivationKey = (key)=>key === " " || key === "Enter";
const $c4d41e48f2f75aa6$export$a4ceb561b96b3a5d = ({ cameraId: cameraId, viewMode: viewMode })=>{
    const listenInEnabled = (0, $dfff4fad957c9a73$export$69a33c7152d6e9e2)();
    const hasAudio = (0, $2c93485817abd844$export$1294e407ba6e1916)(cameraId);
    const talking = (0, $iMovf.useIsTalkingToCamera)(cameraId);
    const setHold = (0, $2c93485817abd844$export$76df6223e234efc0)((s)=>s.setHold);
    const holding = (0, $2c93485817abd844$export$76df6223e234efc0)((s)=>cameraId != null && cameraId !== "" && s.holdCameraId === String(cameraId));
    const heldKeyRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(false);
    const staff = (0, $4ysU8.useIsStaffUser)();
    const cameraKey = cameraId != null && cameraId !== "" ? String(cameraId) : null;
    const liveReady = viewMode === "live" || viewMode === "split";
    // Crossed out when listen-in isn't available:
    // - showListenIn flag off
    // - no camera
    // - talking down (half-duplex)
    // - player/mint reported no audio (hasAudio === false)
    // Until a player reports, stay optimistic so we don't flash unavailable
    // while the live stream is still starting.
    // - staging build with Use production off: the player can't play, so the
    //   optimistic ear would otherwise show and silently do nothing
    const needsProductionMode = (0, $8sbJd.liveMediaNeedsProductionMode)();
    const unavailable = !listenInEnabled || !cameraKey || talking || hasAudio === false || needsProductionMode;
    const canHold = !unavailable;
    const clearHoldIfOurs = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback(()=>{
        if (!cameraKey) return;
        const current = (0, $2c93485817abd844$export$76df6223e234efc0).getState().holdCameraId;
        if (current === cameraKey) (0, $2c93485817abd844$export$76df6223e234efc0).getState().setHold(null);
    }, [
        cameraKey
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!liveReady) clearHoldIfOurs();
    }, [
        liveReady,
        clearHoldIfOurs
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        return ()=>clearHoldIfOurs();
    }, [
        clearHoldIfOurs
    ]);
    const startHold = ()=>{
        if (!canHold || !cameraKey || !liveReady) return;
        setHold(cameraKey);
    };
    const endHold = ()=>{
        clearHoldIfOurs();
    };
    if (!liveReady) return null;
    if (!canHold) {
        const label = talking ? (0, $dfff4fad957c9a73$export$f2d4dd915f02d45b) : needsProductionMode && listenInEnabled && cameraKey ? staff ? $c4d41e48f2f75aa6$export$8fd54a5e46432af6 : $c4d41e48f2f75aa6$export$aac3fc0f7ac58644 : $c4d41e48f2f75aa6$export$6fe9c4ec31817bc;
        return /*#__PURE__*/ (0, $k4ank.jsx)("button", {
            type: "button",
            "aria-label": label,
            title: label,
            className: $c4d41e48f2f75aa6$var$unavailableButtonClassName,
            disabled: true,
            children: /*#__PURE__*/ (0, $k4ank.jsx)($c4d41e48f2f75aa6$var$EarUnavailableIcon, {})
        });
    }
    return /*#__PURE__*/ (0, $k4ank.jsx)("button", {
        type: "button",
        "aria-label": $c4d41e48f2f75aa6$export$f3aa081276142f4b,
        "aria-pressed": holding,
        title: $c4d41e48f2f75aa6$export$f3aa081276142f4b,
        onPointerDown: (event)=>{
            if (event.button !== undefined && event.button !== 0) return;
            event.preventDefault();
            startHold();
        },
        onPointerUp: endHold,
        onPointerLeave: ()=>{
            if (holding) endHold();
        },
        onPointerCancel: endHold,
        onKeyDown: (event)=>{
            if (!$c4d41e48f2f75aa6$var$isActivationKey(event.key) || event.repeat) return;
            event.preventDefault();
            heldKeyRef.current = true;
            startHold();
        },
        onKeyUp: (event)=>{
            if (!$c4d41e48f2f75aa6$var$isActivationKey(event.key) || !heldKeyRef.current) return;
            heldKeyRef.current = false;
            endHold();
        },
        onBlur: ()=>{
            if (holding) endHold();
        },
        onContextMenu: (event)=>event.preventDefault(),
        style: {
            touchAction: "none",
            userSelect: "none"
        },
        className: holding ? $c4d41e48f2f75aa6$var$activeButtonClassName : $c4d41e48f2f75aa6$var$idleButtonClassName,
        children: /*#__PURE__*/ (0, $k4ank.jsx)($c4d41e48f2f75aa6$var$EarIcon, {})
    });
};


const $bfc547cd541f8a8d$var$TABS = [
    {
        id: "clip",
        label: "Alert Clip"
    },
    {
        id: "live",
        label: "Live Stream"
    },
    {
        id: "split",
        label: "Split View"
    }
];
const $bfc547cd541f8a8d$export$258f1fab2757b534 = ({ viewMode: viewMode, onViewModeChange: onViewModeChange, streamProtocol: streamProtocol, onStreamProtocolChange: onStreamProtocolChange, showStreamProtocolSelector: showStreamProtocolSelector = false, width: width = 540, talkDownCameraId: talkDownCameraId, talkDownCameraName: talkDownCameraName = "", talkDownIntegrationTypeName: talkDownIntegrationTypeName, talkDownCapable: talkDownCapable, talkDownParentGroupId: talkDownParentGroupId, talkDownSiteId: talkDownSiteId, talkDownSiteName: talkDownSiteName })=>{
    const { flags: flags } = (0, $4PFLW.useFeatureFlag)();
    const showTalkDown = Boolean(flags?.[0, $jboFg.TALK_DOWN_FLAG]);
    const [liveStatus, setLiveStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const endSessionRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const library = (0, $20b5fbd86f103da2$export$4b2a6a6c9a3b2545)(talkDownCameraId, talkDownCameraName, talkDownParentGroupId, talkDownSiteId, talkDownSiteName);
    const handleLiveStatusChange = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback((status)=>{
        setLiveStatus(status);
    }, []);
    const handleRegisterEndSession = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback((endSession)=>{
        endSessionRef.current = endSession;
    }, []);
    const handleDismissBanner = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback(()=>{
        endSessionRef.current?.();
        setLiveStatus(null);
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        style: {
            width: width
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "mb-[10px] flex items-stretch gap-[2px] border-b border-actuate-grey bg-[#FAFAFB] font-mulish",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "flex items-end gap-[2px]",
                        role: "tablist",
                        children: $bfc547cd541f8a8d$var$TABS.map((tab)=>{
                            const isActive = viewMode === tab.id;
                            return /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                type: "button",
                                role: "tab",
                                "aria-selected": isActive,
                                onClick: ()=>onViewModeChange(tab.id),
                                className: `border-b-2 px-4 py-[10px] text-[12px] font-medium transition-colors ${isActive ? "border-actuate-orange text-actuate-blue" : "border-transparent text-gray-500 hover:text-actuate-blue"}`,
                                children: tab.label
                            }, tab.id);
                        })
                    }),
                    showStreamProtocolSelector && viewMode !== "clip" && /*#__PURE__*/ (0, $k4ank.jsxs)("select", {
                        value: streamProtocol,
                        onChange: (e)=>onStreamProtocolChange(e.target.value),
                        "aria-label": "Live stream protocol",
                        className: `self-center rounded border border-actuate-grey bg-white px-2 py-1 text-[12px] font-medium text-actuate-blue ${showTalkDown ? "ml-1 mr-auto" : "ml-auto mr-1"}`,
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("option", {
                                value: "hls",
                                children: "LL-HLS (~2-3s)"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("option", {
                                value: "whep",
                                children: "WHEP (<1s)"
                            })
                        ]
                    }),
                    showTalkDown && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: `flex items-center justify-end gap-2.5 self-center py-1 ${showStreamProtocolSelector && viewMode !== "clip" ? "" : "ml-auto"}`,
                        "data-testid": "talk-down-controls",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $0ce17b4bf3bfca1e$export$7f893d92355e6893), {
                                cameraId: talkDownCameraId,
                                cameraName: talkDownCameraName,
                                integrationTypeName: talkDownIntegrationTypeName,
                                talkDownCapable: talkDownCapable,
                                onStatusChange: handleLiveStatusChange,
                                onRegisterEndSession: handleRegisterEndSession
                            }),
                            library.button,
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $c4d41e48f2f75aa6$export$a4ceb561b96b3a5d), {
                                cameraId: talkDownCameraId,
                                viewMode: viewMode
                            })
                        ]
                    })
                ]
            }),
            showTalkDown && liveStatus && /*#__PURE__*/ (0, $k4ank.jsx)((0, $0ce17b4bf3bfca1e$export$4a349117e19b50fb), {
                status: liveStatus,
                onDismiss: handleDismissBanner
            }),
            showTalkDown && !liveStatus && library.panel
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8T3gX = parcelRequire("8T3gX");
// Any of these on the document counts as "someone is at the desk". Passive
// listeners so they never block scrolling; a tab coming back to the foreground
// also counts (the operator just switched back to look).
const $9113f37e441dbb18$var$ACTIVITY_EVENTS = [
    "pointerdown",
    "pointermove",
    "keydown",
    "touchstart",
    "wheel",
    "scroll"
];
const $9113f37e441dbb18$export$3e1c2ef16041091f = (enabled, timeoutMs, graceMs = 0, held = false)=>{
    const [phase, setPhase] = (0, $8T3gX.useState)("active");
    const phaseRef = (0, $8T3gX.useRef)("active");
    const timerRef = (0, $8T3gX.useRef)(null);
    const heldRef = (0, $8T3gX.useRef)(held);
    heldRef.current = held;
    const clear = ()=>{
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    };
    const transition = (next)=>{
        phaseRef.current = next;
        setPhase(next);
    };
    const arm = (0, $8T3gX.useCallback)(()=>{
        clear();
        // Held: the clock stays stopped; the held effect re-arms on release.
        if (heldRef.current) return;
        timerRef.current = setTimeout(()=>{
            timerRef.current = null;
            if (graceMs <= 0) {
                transition("idle");
                return;
            }
            transition("prompting");
            timerRef.current = setTimeout(()=>{
                timerRef.current = null;
                transition("idle");
            }, graceMs);
        }, timeoutMs);
    }, [
        timeoutMs,
        graceMs
    ]);
    // Explicit confirm/resume: back to active and start counting again.
    const reset = (0, $8T3gX.useCallback)(()=>{
        transition("active");
        if (enabled) arm();
        else clear();
    }, [
        enabled,
        arm
    ]);
    (0, $8T3gX.useEffect)(()=>{
        if (!enabled) {
            clear();
            transition("active");
            return;
        }
        arm();
        const onActivity = ()=>{
            // Once prompting or idle, only reset() (the button) moves on.
            if (phaseRef.current !== "active") return;
            arm();
        };
        const onVisibility = ()=>{
            if (document.visibilityState === "visible") onActivity();
        };
        $9113f37e441dbb18$var$ACTIVITY_EVENTS.forEach((ev)=>document.addEventListener(ev, onActivity, {
                passive: true
            }));
        document.addEventListener("visibilitychange", onVisibility);
        return ()=>{
            clear();
            $9113f37e441dbb18$var$ACTIVITY_EVENTS.forEach((ev)=>document.removeEventListener(ev, onActivity));
            document.removeEventListener("visibilitychange", onVisibility);
        };
    }, [
        enabled,
        arm
    ]);
    (0, $8T3gX.useEffect)(()=>{
        if (!enabled) return;
        if (held) {
            clear();
            if (phaseRef.current === "prompting") transition("active");
        } else if (phaseRef.current === "active") arm();
    }, [
        held,
        enabled,
        arm
    ]);
    return {
        idle: phase === "idle",
        prompting: phase === "prompting",
        reset: reset
    };
};


// Live-view idle timeouts (ENG-1132, tightened in ENG-2149). Live view is
// metered on relay PUBLISH time, and the publisher runs as long as any player
// keeps pulling the playlist — a tab left open with nobody at the desk burns
// the customer's per-camera monthly allowance at full rate.
//
// Flow: once the stream is actually PLAYING (the clock never runs during a
// cold start), IDLE_MS with no user activity anywhere on the page shows a
// "Still watching?" prompt over the live video. If nobody confirms within
// IDLE_GRACE_MS the player is torn down (the relay's viewer-reaper then stops
// the publisher within ~30 s) and stays paused until the operator clicks
// Resume.
//
// Live view is an event-REVIEW tool (monitoring happens via event generation),
// not a standing video wall, so the window is deliberately short — and it is
// the SAME for every viewer. Staff (the mint's `cap_exempt`) and uncapped
// plans (`cap_minutes: 0`, which covers the internal "Actuate" leads as well
// as any 24/7 opt-in) used to get a 30 min window; that carve-out hid the
// prompt from every internal tester and was removed in ENG-2149. The cap
// fields still drive billing/overage, just not the idle prompt.
//
// Not configurable per build or per customer for now (ENG-2149 asked for a
// per-customer setting; revisit if a second customer wants a different value).
/** Single Live View / Split View player. */ const $aba069a58fac4b62$export$6d1b5bdb223f6f6d = 30000;
const $aba069a58fac4b62$export$a533ba79d5ca3f5 = 30000;
const $aba069a58fac4b62$export$711964b711fb496d = 5000;



var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

var $60vL1 = parcelRequire("60vL1");

var $8T3gX = parcelRequire("8T3gX");

var $hAnMZ = parcelRequire("hAnMZ");

var $aYdit = parcelRequire("aYdit");

var $5BK6w = parcelRequire("5BK6w");

var $9BnvG = parcelRequire("9BnvG");

var $1BWfV = parcelRequire("1BWfV");

var $aYdit = parcelRequire("aYdit");

var $ebTQj = parcelRequire("ebTQj");
// How long a caller waits for a refresh that another caller already started.
// Matches concurrentAPIErrorHandler's REFRESH_FLAG_TIMEOUT.
const $0e37e3988da6d6c9$var$WAIT_FOR_INFLIGHT_MS = 15000;
const $0e37e3988da6d6c9$var$WAIT_POLL_MS = 250;
const $0e37e3988da6d6c9$export$9b76211583236161 = (error)=>{
    const err = error;
    const status = err?.response?.status;
    if (status === 401) return true;
    if (status !== 403) return false;
    let body = "";
    try {
        const data = err.response?.data;
        body = typeof data === "string" ? data : JSON.stringify(data ?? "");
    } catch  {
        body = "";
    }
    return body.includes("Invalid token") || body.includes("Token is expired") || body.includes("Token not found") || body.includes("Returned invalid token from cache") || body.includes("SocialToken matching query does not exist");
};
const $0e37e3988da6d6c9$var$waitForInflightRefresh = async ()=>{
    const deadline = Date.now() + $0e37e3988da6d6c9$var$WAIT_FOR_INFLIGHT_MS;
    while((0, $aYdit.useAppStore).getState().refreshingToken && Date.now() < deadline)await new Promise((resolve)=>setTimeout(resolve, $0e37e3988da6d6c9$var$WAIT_POLL_MS));
    return Boolean((0, $5BK6w.getCookie)("token"));
};
const $0e37e3988da6d6c9$export$5eec284f74fc084e = async ()=>{
    const refreshToken = (0, $5BK6w.getCookie)("token_secret");
    if (!refreshToken) return false;
    const store = (0, $aYdit.useAppStore).getState();
    if (store.refreshingToken) return $0e37e3988da6d6c9$var$waitForInflightRefresh();
    store.setRefreshingToken(true);
    try {
        const response = await (0, $9BnvG.createRefreshApi)("").post("/auth/refresh/", {
            refresh_token: refreshToken
        });
        const { token: token, token_secret: nextRefreshToken } = response.data ?? {};
        if (!token) return false;
        (0, $1BWfV.authStateManager).setAuthState(token, nextRefreshToken ?? refreshToken);
        return true;
    } catch (error) {
        (0, $ebTQj.logger).log("refreshAuthToken failed", error);
        return false;
    } finally{
        (0, $aYdit.useAppStore).getState().setRefreshingToken(false);
        localStorage.setItem("tokenRefreshing", "false");
    }
};


// Renew the publish lease while a viewer is actually connected. Must be shorter
// than the backend lease TTL (6 min) so a watched stream never lapses between
// renewals; when the player disconnects we stop renewing and release, so the
// connector stops publishing instead of pushing frames to nobody.
const $c73f13b6242fb522$var$KEEPALIVE_MS = 240000;
// Only "failed"/"closed" are terminal. "disconnected" is a TRANSIENT ICE state
// that usually recovers on its own within a second or two — tearing down on it
// is what made the alert-view stream flap on every network hiccup (StreamTest,
// which only logs the state, doesn't flap). We give "disconnected" a grace
// window (DISCONNECT_GRACE_MS) to recover before treating it as dead.
const $c73f13b6242fb522$var$DEAD_STATES = [
    "failed",
    "closed"
];
const $c73f13b6242fb522$var$DISCONNECT_GRACE_MS = 8000;
// Publish-on-demand cold start: MediaMTX 404s until the publisher begins
// publishing. Warm connector: ~3-8s. Publish-only streaming deployment
// waking from scale-zero (unarmed sites, EDOCS 593657869): pod schedule +
// boot + boot-time lease read, ~15-45s. Retry player setup through that
// whole window (~50s) instead of hard-failing to "unavailable".
const $c73f13b6242fb522$var$START_RETRIES = 20;
const $c73f13b6242fb522$var$START_RETRY_DELAY_MS = 2500;
// After this many attempts (~8s), flip status to "starting" so the UI can
// say "starting the stream" instead of generic connecting copy.
const $c73f13b6242fb522$var$STARTING_STATUS_AFTER_ATTEMPT = 3;
// Mid-play resilience (PLT-344): a fatal AFTER playback started (publisher
// restart, disarm→arm publisher swap, LL-HLS sequence reset) cannot be cured
// by reloading the same manifest — recovery needs a fresh session MINT,
// which is also what re-evaluates publish routing (on an arm transition the
// warm connector only starts publishing when a mint/renewal routes a lease
// signal to it; manifest reloads never re-mint, so without this the stream
// died permanently on a 1s publisher blip). Bounded so a camera that dies
// mid-play still lands on camera_offline; the budget resets once playback
// resumes, so a recoverable stream keeps recovering.
const $c73f13b6242fb522$var$MID_PLAY_RESTARTS = 3;
const $c73f13b6242fb522$var$MID_PLAY_RESTART_DELAY_MS = 2000;
const $c73f13b6242fb522$var$waitForIceGathering = (pc, timeoutMs = 3000)=>new Promise((resolve)=>{
        if (pc.iceGatheringState === "complete") return resolve();
        const onState = ()=>{
            if (pc.iceGatheringState === "complete") {
                pc.removeEventListener("icegatheringstatechange", onState);
                resolve();
            }
        };
        pc.addEventListener("icegatheringstatechange", onState);
        setTimeout(resolve, timeoutMs);
    });
const $c73f13b6242fb522$var$isValidSession = (data, protocol)=>{
    if (!data?.token) return false;
    return protocol === "whep" ? Boolean(data.whep_url) : Boolean(data.hls_url);
};
const $c73f13b6242fb522$var$isMonthlyLiveStreamQuotaError = (error)=>{
    const err = error;
    if (err?.response?.status !== 429) return false;
    const detail = err.response?.data?.detail;
    return typeof detail === "string" && detail.toLowerCase().includes("monthly live-stream quota reached");
};
// User-level permission denial from the mint (ENG-1548): the operator's
// account lacks inframap.live_streaming — including the deliberate-suspension
// case. Matched on the backend's distinctive 403 detail, same pattern as the
// quota detection above.
const $c73f13b6242fb522$var$isLiveStreamNotPermittedError = (error)=>{
    const err = error;
    if (err?.response?.status !== 403) return false;
    const detail = err.response?.data?.detail;
    return typeof detail === "string" && detail.toLowerCase().includes("permission to view live streams");
};
// The 403 is the backend telling us the cached permission is stale: the
// grant was revoked AFTER this tab's user/info fetch, and monitoring-center
// tabs live for weeks without a reload (ENG-1548 — 13 suspended operators
// kept seeing live affordances for 8+ days). Flip the store so every gated
// surface (alerts live panel, video wall) un-renders reactively instead of
// offering a button that can only 403, and keep the localStorage mirror in
// sync so the next boot doesn't resurrect it. user/info remains the source
// of truth: a re-grant shows up on the next login/page load as before.
const $c73f13b6242fb522$var$revokeCachedLiveStreamingPermission = ()=>{
    try {
        const { userPermissions: userPermissions, setUserPermissions: setUserPermissions } = (0, $aYdit.useAppStore).getState();
        if (userPermissions?.live_streaming) {
            const next = {
                ...userPermissions,
                live_streaming: false
            };
            setUserPermissions(next);
            localStorage.setItem("userPermissions", JSON.stringify(next));
        }
    } catch  {
    /* best-effort: the not_permitted status still renders regardless */ }
};
// The quota 429 carries overage_available=true when the backend will accept a
// re-mint with overage_opt_in (the "continue for an additional fee" contract,
// ENG-719/721). Absent/false = a hard cap (e.g. plan without overage).
const $c73f13b6242fb522$var$isOverageAvailable = (error)=>{
    const err = error;
    return err?.response?.data?.overage_available === true;
};
const $c73f13b6242fb522$export$1ceb9e2b9822f3dc = "actuate:live-view:idle_paused";
const $c73f13b6242fb522$var$logIdlePaused = (cameraId, sessionId)=>{
    const detail = {
        event: "idle_paused",
        camera_id: cameraId,
        session_id: sessionId,
        at: new Date().toISOString()
    };
    try {
        console.info("[live-view] idle_paused", detail);
        window.dispatchEvent(new CustomEvent($c73f13b6242fb522$export$1ceb9e2b9822f3dc, {
            detail: detail
        }));
    } catch  {
    /* telemetry is best-effort */ }
};

const $c73f13b6242fb522$export$6e435a92cc94ea59 = (cameraId, enabled, videoRef, protocol = "whep", // HLS latency profile. Default true = low-latency (sub-second, small buffer) —
// right for a single focused view. Pass false for a buffered profile (a few
// seconds of cushion) — right for wall tiles, where a bursty source otherwise
// starves the small low-latency buffer and the tile flickers. Ignored for WHEP.
lowLatency = true, // Idle-prompt gate (ENG-1132). true = the owning view decided nobody is
// watching: tear the player down (stop pulling, stop keepalives, release the
// lease) and report "idle_paused"; flipping back to false re-runs the full
// play() cycle (fresh mint), never a manifest reload.
idlePaused = false)=>{
    const [status, setStatus] = (0, $8T3gX.useState)("idle");
    // Monthly-cap overage consent (ENG-721). overageAvailable turns on when a
    // mint 429s with overage_available (the backend's "continue for a fee"
    // offer). continueWithOverage records consent for THIS camera view and
    // re-mints with overage_opt_in, which the keepalive then echoes so
    // renewals past the cap don't 429 and kill playback mid-session. Consent
    // deliberately resets when the camera changes or the view closes — every
    // over-cap viewing is an explicit choice, never ambient.
    const [overageAvailable, setOverageAvailable] = (0, $8T3gX.useState)(false);
    const overageOptInRef = (0, $8T3gX.useRef)(false);
    // ENG-1284: a mint rejected for a stale token gets ONE refresh-and-retry
    // per play cycle. Long idle pauses routinely outlive the ~1h access token,
    // so Resume used to land on "Live View not Available" instead of video.
    // Cleared on a successful mint, so every fresh cycle gets its own retry.
    const authRetriedRef = (0, $8T3gX.useRef)(false);
    const pcRef = (0, $8T3gX.useRef)(null);
    const hlsRef = (0, $8T3gX.useRef)(null);
    const playIdRef = (0, $8T3gX.useRef)(0);
    const activeCameraRef = (0, $8T3gX.useRef)(null);
    const sessionIdRef = (0, $8T3gX.useRef)(null);
    // Last minted session id, for idle_paused telemetry. Unlike sessionIdRef it
    // is NOT cleared by stop() — the idle effect runs after the previous effect's
    // cleanup has already torn the session down.
    const lastSessionIdRef = (0, $8T3gX.useRef)(null);
    const keepaliveRef = (0, $8T3gX.useRef)(null);
    // Pending "disconnected" grace timer (cleared if the connection recovers).
    const disconnectGraceRef = (0, $8T3gX.useRef)(null);
    // In-flight cold-start retry timer (cleared by stop()).
    const retryTimerRef = (0, $8T3gX.useRef)(null);
    // Current JWT, refreshed by the keepalive and read per-request by the HLS
    // xhrSetup so long HLS views survive the ~5-min token TTL (HLS authenticates
    // every segment; WHEP only needs the token once at setup).
    const tokenRef = (0, $8T3gX.useRef)("");
    // CloudFront signed-URL params for CDN-served sessions (empty = origin).
    // Refreshed with the token — the signature expires on the same TTL.
    const cdnParamsRef = (0, $8T3gX.useRef)("");
    // Mid-play restart machinery (PLT-344). playedRef: playback was achieved in
    // the current play cycle (manifest parsed / first WHEP track) — only then
    // does a fatal qualify for a full re-mint restart instead of the cold-start
    // reload loop. restartsRef: bounded budget, reset when playback resumes.
    // playRef: late-bound play() so the restart timer (and playHls/playWhep,
    // defined before play) can trigger a full fresh-mint cycle.
    const playedRef = (0, $8T3gX.useRef)(false);
    const restartsRef = (0, $8T3gX.useRef)(0);
    const playRef = (0, $8T3gX.useRef)(()=>{});
    // Tell the backend the viewer is gone so the connector stops publishing now,
    // instead of tailing out the lease (~6 min). Best-effort fire-and-forget.
    const releaseLease = (0, $8T3gX.useCallback)((camId)=>{
        try {
            (0, $hAnMZ.createMonitoringAPICall)("").delete(`streaming/stream-session/${camId}/`).catch(()=>{});
        } catch  {
        /* best-effort */ }
    }, []);
    const stop = (0, $8T3gX.useCallback)(()=>{
        if (keepaliveRef.current) {
            clearInterval(keepaliveRef.current);
            keepaliveRef.current = null;
        }
        if (disconnectGraceRef.current) {
            clearTimeout(disconnectGraceRef.current);
            disconnectGraceRef.current = null;
        }
        if (retryTimerRef.current) {
            clearTimeout(retryTimerRef.current);
            retryTimerRef.current = null;
        }
        if (activeCameraRef.current) {
            releaseLease(activeCameraRef.current);
            activeCameraRef.current = null;
        }
        sessionIdRef.current = null;
        if (pcRef.current) {
            pcRef.current.close();
            pcRef.current = null;
        }
        if (hlsRef.current) {
            hlsRef.current.destroy();
            hlsRef.current = null;
        }
        if (videoRef.current) {
            videoRef.current.srcObject = null;
            videoRef.current.removeAttribute("src");
            videoRef.current.load();
        }
    }, [
        videoRef,
        releaseLease
    ]);
    // Full recovery from a mid-play fatal (PLT-344): tear down, then re-run the
    // whole play() cycle — fresh mint, fresh URLs/token, fresh player. Returns
    // true when a restart was scheduled; false = budget spent or playback never
    // started (caller falls through to its terminal status). The timer is set
    // AFTER stop() (stop clears retryTimerRef) and playId-gated so a disable
    // or a newer play cycle orphans it safely.
    const attemptMidPlayRestart = (0, $8T3gX.useCallback)(()=>{
        if (!playedRef.current) return false;
        if (restartsRef.current >= $c73f13b6242fb522$var$MID_PLAY_RESTARTS) return false;
        restartsRef.current += 1;
        stop();
        setStatus("loading");
        const pid = playIdRef.current;
        retryTimerRef.current = setTimeout(()=>{
            if (pid === playIdRef.current) playRef.current();
        }, $c73f13b6242fb522$var$MID_PLAY_RESTART_DELAY_MS);
        return true;
    }, [
        stop
    ]);
    // setTimeout-based sleep whose handle lives in retryTimerRef, so stop() can
    // cancel an in-flight cold-start retry.
    const sleep = (0, $8T3gX.useCallback)((ms)=>new Promise((resolve)=>{
            retryTimerRef.current = setTimeout(resolve, ms);
        }), []);
    // Renew the lease every KEEPALIVE_MS, but ONLY while the player is still
    // connected — the "gate". A failed/closed connection (or a destroyed hls
    // player) stops renewing and releases, so the lease lapses promptly.
    const startKeepalive = (0, $8T3gX.useCallback)((camId)=>{
        if (keepaliveRef.current) clearInterval(keepaliveRef.current);
        keepaliveRef.current = setInterval(()=>{
            const pc = pcRef.current;
            const connected = pc && !$c73f13b6242fb522$var$DEAD_STATES.includes(pc.connectionState) || hlsRef.current != null;
            if (!connected) {
                if (attemptMidPlayRestart()) return;
                stop();
                setStatus("camera_offline");
                return;
            }
            (0, $hAnMZ.createMonitoringAPICall)("").post(`streaming/stream-session/${camId}/`, {
                session_id: sessionIdRef.current,
                ...overageOptInRef.current ? {
                    overage_opt_in: true
                } : {}
            }).then((resp)=>{
                // Refresh the JWT (HLS xhrSetup reads tokenRef per request) and keep
                // the billing session continuous across renewals.
                if (resp?.data?.token) tokenRef.current = resp.data.token;
                cdnParamsRef.current = resp?.data?.cdn_auth_params || "";
                if (resp?.data?.session_id) {
                    sessionIdRef.current = resp.data.session_id;
                    lastSessionIdRef.current = resp.data.session_id;
                }
            }).catch(()=>{});
        }, $c73f13b6242fb522$var$KEEPALIVE_MS);
    }, [
        stop,
        attemptMidPlayRestart
    ]);
    const playWhep = (0, $8T3gX.useCallback)(async (whepUrl, token, playId)=>{
        const pc = new RTCPeerConnection();
        pcRef.current = pc;
        pc.addTransceiver("video", {
            direction: "recvonly"
        });
        pc.addTransceiver("audio", {
            direction: "recvonly"
        });
        pc.ontrack = (e)=>{
            if (playId !== playIdRef.current) return;
            if (videoRef.current && e.streams[0]) {
                videoRef.current.srcObject = e.streams[0];
                playedRef.current = true;
                restartsRef.current = 0;
                setStatus("playing");
            }
        };
        // The viewer's connection dropped (closed tab mid-stream, network loss,
        // ICE failure): stop + release so the connector isn't left publishing to
        // nobody until the lease lapses. But "disconnected" is transient — ICE
        // usually recovers — so we ride it out for DISCONNECT_GRACE_MS and only
        // tear down if it hasn't returned to "connected" by then (or it goes
        // straight to a terminal state).
        pc.onconnectionstatechange = ()=>{
            if (playId !== playIdRef.current) return;
            const state = pc.connectionState;
            // Recovered (or still (re)connecting): cancel any pending grace timer.
            if (state === "connected" || state === "connecting" || state === "new") {
                if (disconnectGraceRef.current) {
                    clearTimeout(disconnectGraceRef.current);
                    disconnectGraceRef.current = null;
                }
                return;
            }
            // Terminal — recover with a fresh mint if we were playing, else tear
            // down now.
            if ($c73f13b6242fb522$var$DEAD_STATES.includes(state)) {
                if (attemptMidPlayRestart()) return;
                stop();
                setStatus("camera_offline");
                return;
            }
            // "disconnected" — give ICE a chance to recover before tearing down.
            if (state === "disconnected" && !disconnectGraceRef.current) disconnectGraceRef.current = setTimeout(()=>{
                disconnectGraceRef.current = null;
                if (playId !== playIdRef.current) return;
                if (pcRef.current?.connectionState !== "connected") {
                    if (attemptMidPlayRestart()) return;
                    stop();
                    setStatus("camera_offline");
                }
            }, $c73f13b6242fb522$var$DISCONNECT_GRACE_MS);
        };
        const offer = await pc.createOffer();
        if (playId !== playIdRef.current) return;
        await pc.setLocalDescription(offer);
        await $c73f13b6242fb522$var$waitForIceGathering(pc);
        if (playId !== playIdRef.current) return;
        // POST the SDP offer, retrying through the publish-on-demand cold start
        // (MediaMTX 404s until the connector starts publishing the camera).
        for(let attempt = 1; attempt <= $c73f13b6242fb522$var$START_RETRIES; attempt++){
            const whepResp = await fetch(`${whepUrl}?jwt=${encodeURIComponent(token)}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/sdp"
                },
                body: pc.localDescription.sdp
            });
            if (playId !== playIdRef.current) return;
            if (whepResp.ok) {
                const answerSdp = await whepResp.text();
                if (playId !== playIdRef.current) return;
                await pc.setRemoteDescription({
                    type: "answer",
                    sdp: answerSdp
                });
                return;
            }
            // Cold start: retry on 404 until the path is publishing.
            if (whepResp.status === 404 && attempt < $c73f13b6242fb522$var$START_RETRIES) {
                if (attempt >= $c73f13b6242fb522$var$STARTING_STATUS_AFTER_ATTEMPT) setStatus("starting");
                await sleep($c73f13b6242fb522$var$START_RETRY_DELAY_MS);
                if (playId !== playIdRef.current) return;
                continue;
            }
            stop();
            setStatus("camera_offline");
            return;
        }
    }, [
        stop,
        videoRef,
        sleep,
        attemptMidPlayRestart
    ]);
    const playHls = (0, $8T3gX.useCallback)(async (hlsUrl, token, playId)=>{
        if (!videoRef.current) {
            setStatus("unavailable");
            return;
        }
        // CDN sessions additionally carry the CloudFront signature on every
        // request (camera-ui is same-site with the CDN, but URL params are the
        // one mechanism proven across all viewers — cookies stay unused).
        const applyCdnParams = (u)=>{
            const raw = cdnParamsRef.current;
            if (!raw) return;
            new URLSearchParams(raw).forEach((value, key)=>{
                u.searchParams.set(key, value);
            });
        };
        const initialUrl = new URL(hlsUrl);
        initialUrl.searchParams.set("jwt", token);
        applyCdnParams(initialUrl);
        const url = initialUrl.toString();
        const Hls = (await (parcelRequire("fWdZn"))).default;
        if (playId !== playIdRef.current) return;
        if (Hls.isSupported()) {
            // One attempt at building + attaching the player; retries through the
            // publish-on-demand cold start (a fatal error is usually the manifest
            // 404 before the connector begins publishing).
            const startAttempt = (attempt)=>{
                if (playId !== playIdRef.current || !videoRef.current) return;
                const hls = new Hls({
                    // Latency profile: low-latency (small buffer, sub-second) for a
                    // single focused view; buffered for wall tiles, where a bursty
                    // source starves the LL buffer and the tile flickers.
                    lowLatencyMode: lowLatency,
                    ...lowLatency ? {} : {
                        // Buffered profile: keep several segments of cushion behind
                        // the live edge so bursty delivery is absorbed rather than
                        // starving playback (costs a few seconds of latency — fine
                        // for a monitoring grid).
                        liveSyncDurationCount: 6,
                        maxBufferLength: 30
                    },
                    backBufferLength: 120,
                    // Gap tolerance for a bursty source: jump buffer holes up to 1s
                    // and keep nudging instead of escalating to a fatal error, so a
                    // rebuffer stall doesn't tear the stream down.
                    maxBufferHole: 1.0,
                    nudgeMaxRetry: 10,
                    // Inject the CURRENT token on every manifest/segment request. The
                    // keepalive re-mints it every ~4 min, so an HLS view survives the
                    // ~5-min JWT TTL without reloading the source (otherwise segment
                    // requests 401 once the original token expires and playback dies).
                    xhrSetup: (xhr, requestUrl)=>{
                        try {
                            const u = new URL(requestUrl);
                            u.searchParams.set("jwt", tokenRef.current);
                            applyCdnParams(u);
                            xhr.open("GET", u.toString(), true);
                        } catch  {
                        /* malformed URL — let hls.js open it unmodified */ }
                    }
                });
                hlsRef.current = hls;
                hls.on(Hls.Events.ERROR, (_evt, data)=>{
                    if (playId !== playIdRef.current) return;
                    // Non-fatal (fragGap, bufferStalled, …): hls.js recovers/nudges.
                    if (!data.fatal) return;
                    hls.destroy();
                    if (hlsRef.current === hls) hlsRef.current = null;
                    // Decode capability is a device property, not a stream failure —
                    // retrying can't help (H.265 camera on a browser without HEVC
                    // support). Skip the retry window and name the real problem.
                    if (data.details != null && data.details === Hls.ErrorDetails?.BUFFER_INCOMPATIBLE_CODECS_ERROR) {
                        stop();
                        setStatus("codec_unsupported");
                        return;
                    }
                    // Fatal after playback had started: the manifest-reload loop below
                    // can't recover from a publisher restart or an arm-transition swap
                    // — only a fresh mint can (PLT-344). Skip straight to a full
                    // restart while budget remains.
                    if (attemptMidPlayRestart()) return;
                    if (attempt < $c73f13b6242fb522$var$START_RETRIES) {
                        if (attempt >= $c73f13b6242fb522$var$STARTING_STATUS_AFTER_ATTEMPT) setStatus("starting");
                        retryTimerRef.current = setTimeout(()=>startAttempt(attempt + 1), $c73f13b6242fb522$var$START_RETRY_DELAY_MS);
                    } else {
                        stop();
                        setStatus("camera_offline");
                    }
                });
                hls.on(Hls.Events.MANIFEST_PARSED, ()=>{
                    if (playId !== playIdRef.current) return;
                    playedRef.current = true;
                    restartsRef.current = 0;
                    videoRef.current?.play().catch(()=>{
                        stop();
                        setStatus("camera_offline");
                    });
                    setStatus("playing");
                });
                hls.loadSource(url);
                hls.attachMedia(videoRef.current);
            };
            startAttempt(1);
        } else if (videoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
            videoRef.current.src = url;
            await videoRef.current.play().catch(()=>{
                stop();
                setStatus("camera_offline");
            });
            if (playId !== playIdRef.current) return;
            setStatus("playing");
        } else setStatus("unavailable");
    }, [
        stop,
        videoRef,
        lowLatency,
        attemptMidPlayRestart
    ]);
    const play = (0, $8T3gX.useCallback)(async ()=>{
        const playId = ++playIdRef.current;
        stop();
        // New cycle: playback not yet achieved. restartsRef deliberately persists
        // across restarts (it IS the cross-cycle budget) and resets on playback.
        playedRef.current = false;
        setStatus("loading");
        if (!cameraId) {
            setStatus("unavailable");
            return;
        }
        try {
            const api = (0, $hAnMZ.createMonitoringAPICall)("");
            const sessResp = await api.post(`streaming/stream-session/${cameraId}/`, overageOptInRef.current ? {
                overage_opt_in: true
            } : {});
            if (playId !== playIdRef.current) return;
            if (!$c73f13b6242fb522$var$isValidSession(sessResp.data, protocol)) {
                setStatus("unavailable");
                return;
            }
            authRetriedRef.current = false;
            const { whep_url: whep_url, hls_url: hls_url, token: token } = sessResp.data;
            tokenRef.current = token;
            cdnParamsRef.current = sessResp.data.cdn_auth_params || "";
            // Lease is live: track it for release + start renewing while connected.
            activeCameraRef.current = cameraId;
            sessionIdRef.current = sessResp.data.session_id ?? null;
            lastSessionIdRef.current = sessionIdRef.current;
            startKeepalive(cameraId);
            if (protocol === "whep") await playWhep(whep_url, token, playId);
            else await playHls(hls_url, token, playId);
        } catch (error) {
            if (playId !== playIdRef.current) return;
            stop();
            if ($c73f13b6242fb522$var$isMonthlyLiveStreamQuotaError(error)) {
                setOverageAvailable($c73f13b6242fb522$var$isOverageAvailable(error));
                setStatus("quota_reached");
            } else if ($c73f13b6242fb522$var$isLiveStreamNotPermittedError(error)) {
                setStatus("not_permitted");
                $c73f13b6242fb522$var$revokeCachedLiveStreamingPermission();
            } else if ((0, $0e37e3988da6d6c9$export$9b76211583236161)(error)) {
                // Stale access token (typically a view idle-paused past the token
                // TTL): refresh once and re-run the whole cycle — a fresh mint with
                // the new token, same as Resume. Only if that fails (or a retried
                // mint is rejected again) is the session really expired.
                if (!authRetriedRef.current) {
                    authRetriedRef.current = true;
                    const refreshed = await (0, $0e37e3988da6d6c9$export$5eec284f74fc084e)();
                    if (playId !== playIdRef.current) return;
                    if (refreshed) {
                        playRef.current();
                        return;
                    }
                }
                setStatus("session_expired");
            } else setStatus("unavailable");
        }
    }, [
        cameraId,
        protocol,
        stop,
        playWhep,
        playHls,
        startKeepalive
    ]);
    // Late-bind so attemptMidPlayRestart (defined before play) always invokes
    // the current play cycle.
    (0, $8T3gX.useEffect)(()=>{
        playRef.current = play;
    }, [
        play
    ]);
    // Operator accepted the overage offer: record consent for this view and
    // re-mint. Consent survives background-tab recovery and mid-play restarts
    // (same viewing), but not a camera switch or closing the view (below).
    const continueWithOverage = (0, $8T3gX.useCallback)(()=>{
        overageOptInRef.current = true;
        setOverageAvailable(false);
        play();
    }, [
        play
    ]);
    // Overage consent is per camera view — a different camera or a re-opened
    // view must re-prompt rather than silently keep billing.
    (0, $8T3gX.useEffect)(()=>{
        overageOptInRef.current = false;
        setOverageAvailable(false);
    }, [
        cameraId,
        enabled
    ]);
    (0, $8T3gX.useEffect)(()=>{
        if (!enabled) {
            playIdRef.current += 1;
            stop();
            setStatus("idle");
            return;
        }
        if (idlePaused) {
            $c73f13b6242fb522$var$logIdlePaused(cameraId, lastSessionIdRef.current);
            playIdRef.current += 1;
            stop();
            setStatus("idle_paused");
            return;
        }
        play();
        return ()=>{
            playIdRef.current += 1;
            stop();
        };
    }, [
        enabled,
        idlePaused,
        cameraId,
        protocol,
        play,
        stop
    ]);
    // Recover after the tab was backgrounded. Browsers throttle hidden tabs, so
    // the player stops pulling (HLS especially) and the stream is torn down /
    // released while we're away. None of the deps above change when the tab
    // returns, so without this a tile stays stuck on "unavailable". On return to a
    // visible tab, re-acquire if the stream isn't currently alive.
    (0, $8T3gX.useEffect)(()=>{
        // While idle-paused the teardown is deliberate — returning to the tab must
        // not silently re-mint; the operator clicks Resume.
        if (!enabled || idlePaused) return;
        const onVisibility = ()=>{
            if (document.visibilityState !== "visible") return;
            const pcAlive = !!pcRef.current && !$c73f13b6242fb522$var$DEAD_STATES.includes(pcRef.current.connectionState);
            const hlsAlive = hlsRef.current != null;
            if (!pcAlive && !hlsAlive) play(); // stream went down while backgrounded -> re-establish
        };
        document.addEventListener("visibilitychange", onVisibility);
        return ()=>document.removeEventListener("visibilitychange", onVisibility);
    }, [
        enabled,
        idlePaused,
        play
    ]);
    return {
        status: status,
        stop: stop,
        overageAvailable: overageAvailable,
        continueWithOverage: continueWithOverage
    };
};



var $iMovf = parcelRequire("iMovf");


const $8cc62c6d4d7b8f3a$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $8cc62c6d4d7b8f3a$export$7bc0647149a36975 = "Live View not Available for this site";
const $8cc62c6d4d7b8f3a$export$fc2f78953860c572 = "Live view for this camera is currently unavailable.";
const $8cc62c6d4d7b8f3a$export$392fecee24a9d945 = "Monthly live stream quota has been reached for this camera.";
const $8cc62c6d4d7b8f3a$export$6ae5ef1bda13d31e = "Live streaming is not enabled for your account. Contact your administrator to enable it.";
const $8cc62c6d4d7b8f3a$export$e24ee863ba9f5d24 = "Your session has expired. Reload the page to continue watching live video.";
const $8cc62c6d4d7b8f3a$export$9347e11e8f420685 = "Still watching?";
const $8cc62c6d4d7b8f3a$export$8d7c495a320d27b3 = "Live view was paused after a period of inactivity to save your streaming allowance.";
const $8cc62c6d4d7b8f3a$export$69c4387519752e40 = `Live view will pause in ${(0, $aba069a58fac4b62$export$711964b711fb496d) / 1000} seconds unless you confirm you're still watching.`;
const $8cc62c6d4d7b8f3a$export$70ed6353c05d5864 = "I'm still watching";
const $8cc62c6d4d7b8f3a$export$99d6e362da251621 = (status)=>{
    if (status === "quota_reached") return $8cc62c6d4d7b8f3a$export$392fecee24a9d945;
    if (status === "not_permitted") // Account-level denial (403 from the mint) — incl. deliberate suspension
    // (ENG-1548). Retrying can't help; say it's the account, not the site.
    return $8cc62c6d4d7b8f3a$export$6ae5ef1bda13d31e;
    if (status === "codec_unsupported") // Device can't decode the camera's format (e.g. H.265 without hardware
    // support — Firefox, older machines). Distinct from a dead camera.
    return "This camera's video format isn't supported on this device. Try Chrome or Safari on newer hardware.";
    if (status === "session_expired") // The mint was rejected for a stale token and a refresh couldn't recover
    // it (ENG-1284) — an auth problem, not a site one.
    return $8cc62c6d4d7b8f3a$export$e24ee863ba9f5d24;
    if (status === "camera_offline") // The session minted fine but this camera's stream never came up (or
    // died): a per-camera problem — the site-level message would mislead.
    return $8cc62c6d4d7b8f3a$export$fc2f78953860c572;
    return $8cc62c6d4d7b8f3a$export$7bc0647149a36975;
};
const $8cc62c6d4d7b8f3a$export$41370dce390d0afb = ({ cameraId: cameraId, enabled: enabled, protocol: protocol = "hls", width: width = 540, height: height = 304, className: className = "", liveBadgeTopClass: liveBadgeTopClass = "top-3" })=>{
    const videoRef = (0, $8T3gX.useRef)(null);
    // Idle prompt (ENG-1132 / ENG-2149): the clock only runs once the stream is
    // actually PLAYING (a cold start can take longer than the idle window). After
    // the window with no activity, "Still watching?" shows over the live video;
    // if nobody confirms within the grace period the hook tears the player down
    // (publish stops → metering stops) and we show the paused prompt. Resume /
    // confirm = reset the timer; Resume also flips idlePaused off, which re-runs
    // the fresh-mint play() path. One window for every viewer — staff and
    // uncapped (24/7 opt-in) plans included (ENG-2149). The player hook and the
    // timer are mutually dependent (idlePaused → hook; status → timer), so idle
    // lives in state fed from the timer below. The timer stays armed through
    // idle_paused so the pause isn't cleared out from under the hook.
    const [idle, setIdle] = (0, $8T3gX.useState)(false);
    const { status: status, overageAvailable: overageAvailable, continueWithOverage: continueWithOverage } = (0, $c73f13b6242fb522$export$6e435a92cc94ea59)(cameraId, enabled, videoRef, protocol, true, idle);
    // Listen-in / talk-down state (ENG-2136) — read up here because an active
    // talk-down hold or listen-in hold is engagement with the stream: it stops
    // the idle clock and dismisses a showing "Still watching?". The listen-in
    // TOGGLE deliberately does not: left on, it would keep an unattended stream
    // (and its metering) alive forever, which is what the idle prompt prevents.
    const talking = (0, $iMovf.useIsTalkingToCamera)(cameraId);
    const holdingListenIn = (0, $2c93485817abd844$export$78bbd668af63d494)(cameraId);
    const idleTimerArmed = enabled && (status === "playing" || status === "idle_paused");
    const idleHeld = talking || holdingListenIn;
    const { idle: timerIdle, prompting: stillWatchingPrompt, reset: resumeFromIdle } = (0, $9113f37e441dbb18$export$3e1c2ef16041091f)(idleTimerArmed, (0, $aba069a58fac4b62$export$6d1b5bdb223f6f6d), (0, $aba069a58fac4b62$export$711964b711fb496d), idleHeld);
    (0, $8T3gX.useEffect)(()=>{
        setIdle(timerIdle);
    }, [
        timerIdle
    ]);
    const showVideo = enabled && status === "playing";
    // Listen-in (ENG-2136): hold-to-listen from AlertViewModeTabs + overlay
    // toggle. Half-duplex with talk-down via talkingCamerasStore. Until the
    // stream-session mint exposes has_audio on develop, treat a playing stream
    // as audio-capable so the Option A ear stays usable.
    const listenInEnabled = (0, $dfff4fad957c9a73$export$69a33c7152d6e9e2)();
    const setHasAudio = (0, $2c93485817abd844$export$76df6223e234efc0)((s)=>s.setHasAudio);
    const [toggleListening, setToggleListening] = (0, $8T3gX.useState)(false);
    const talkingRef = (0, $8T3gX.useRef)(talking);
    talkingRef.current = talking;
    const holdingListenInRef = (0, $8T3gX.useRef)(holdingListenIn);
    holdingListenInRef.current = holdingListenIn;
    (0, $8T3gX.useEffect)(()=>{
        if (!showVideo) setToggleListening(false);
    }, [
        showVideo,
        cameraId
    ]);
    (0, $8T3gX.useEffect)(()=>{
        if (cameraId == null || cameraId === "") return;
        if (!enabled || !showVideo) {
            setHasAudio(cameraId, null);
            return ()=>setHasAudio(cameraId, null);
        }
        setHasAudio(cameraId, true);
        return ()=>setHasAudio(cameraId, null);
    }, [
        cameraId,
        enabled,
        showVideo,
        setHasAudio
    ]);
    const listening = toggleListening || holdingListenIn;
    const muted = !listening || talking;
    (0, $8T3gX.useEffect)(()=>{
        const video = videoRef.current;
        if (video && video.muted !== muted) video.muted = muted;
    }, [
        muted
    ]);
    (0, $8T3gX.useEffect)(()=>{
        const video = videoRef.current;
        if (!video) return;
        const onVolumeChange = ()=>{
            if (talkingRef.current) {
                if (!video.muted) video.muted = true;
                return;
            }
            if (holdingListenInRef.current) return;
            setToggleListening(!video.muted);
        };
        video.addEventListener("volumechange", onVolumeChange);
        return ()=>video.removeEventListener("volumechange", onVolumeChange);
    }, []);
    const showListenIn = showVideo && listenInEnabled;
    const showIdlePaused = enabled && status === "idle_paused";
    const showLoading = enabled && (status === "loading" || status === "idle" || status === "starting");
    const showUnavailable = enabled && (status === "unavailable" || status === "camera_offline" || status === "quota_reached" || status === "not_permitted" || status === "session_expired" || status === "codec_unsupported");
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: `relative bg-black ${className}`,
        style: {
            width: width,
            height: height
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("video", {
                ref: videoRef,
                autoPlay: true,
                playsInline: true,
                muted: true,
                controls: true,
                className: "block h-full w-full object-contain",
                style: {
                    display: showVideo ? "block" : "none"
                }
            }),
            showVideo && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: `pointer-events-none absolute left-3 z-10 inline-flex items-center gap-1.5 rounded bg-[#D93636] px-2.5 py-1.5 font-mulish text-[11px] font-bold uppercase tracking-[0.08em] text-white shadow-[0_2px_8px_rgba(217,54,54,0.4)] ${liveBadgeTopClass}`,
                "aria-label": "Live stream",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                        className: "h-2 w-2 shrink-0 animate-pulse rounded-full bg-white"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                        children: "LIVE"
                    })
                ]
            }),
            showListenIn && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "absolute bottom-12 right-3 z-30",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dfff4fad957c9a73$export$7d0a227b3a86e909), {
                    listening: toggleListening || holdingListenIn,
                    talking: talking,
                    onToggle: ()=>setToggleListening((prev)=>!prev)
                })
            }),
            showVideo && stillWatchingPrompt && // Centred card under the listen-in control (z-30), so it stays
            // clickable while the prompt shows.
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "absolute left-1/2 top-1/2 z-20 flex w-[calc(100%-24px)] max-w-[360px] -translate-x-1/2 -translate-y-1/2 flex-col items-center rounded bg-black/85 px-4 py-3 shadow-lg",
                "data-testid": "live-still-watching-prompt",
                role: "alertdialog",
                "aria-label": $8cc62c6d4d7b8f3a$export$9347e11e8f420685,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-mulish text-center text-[16px] font-bold text-white",
                        children: $8cc62c6d4d7b8f3a$export$9347e11e8f420685
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-mulish mt-1 text-center text-[12px] text-white/80",
                        children: $8cc62c6d4d7b8f3a$export$69c4387519752e40
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                        type: "button",
                        onClick: resumeFromIdle,
                        className: "font-mulish mt-2 rounded bg-[#FF8400] px-4 py-1.5 text-[13px] font-bold text-white hover:bg-[#e67700]",
                        children: $8cc62c6d4d7b8f3a$export$70ed6353c05d5864
                    })
                ]
            }),
            showIdlePaused && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "absolute inset-0 flex flex-col items-center justify-center bg-black px-4",
                "data-testid": "live-idle-prompt",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-mulish text-center text-[20px] font-bold text-white",
                        children: $8cc62c6d4d7b8f3a$export$9347e11e8f420685
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-mulish mt-2 text-center text-[14px] text-white/80",
                        children: $8cc62c6d4d7b8f3a$export$8d7c495a320d27b3
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                        type: "button",
                        onClick: resumeFromIdle,
                        className: "font-mulish mt-4 rounded bg-[#FF8400] px-4 py-2 text-[14px] font-bold text-white hover:bg-[#e67700]",
                        children: "Resume"
                    })
                ]
            }),
            (showLoading || showUnavailable) && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "absolute inset-0 flex flex-col items-center justify-center px-4",
                children: showLoading ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                            theme: $8cc62c6d4d7b8f3a$var$theme,
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                color: "primary"
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "font-mulish mt-4 text-center text-[16px] text-white",
                            children: status === "starting" ? "Starting camera stream\u2026" : "Connecting live view..."
                        })
                    ]
                }) : status === "quota_reached" && overageAvailable ? // Soft cap (ENG-721): the mint offered overage. One explicit
                // click is the billing consent — the hook re-mints with
                // overage_opt_in and its keepalives carry it for this view.
                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "font-mulish text-center text-[18px] text-white",
                            children: $8cc62c6d4d7b8f3a$export$392fecee24a9d945
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "font-mulish mt-2 text-center text-[14px] text-white/80",
                            children: "You can keep streaming this camera \u2014 additional charges will apply to your account."
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                            type: "button",
                            onClick: continueWithOverage,
                            className: "font-mulish mt-4 rounded bg-[#FF8400] px-4 py-2 text-[14px] font-bold text-white hover:bg-[#e67700]",
                            children: "Continue streaming"
                        })
                    ]
                }) : /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "font-mulish text-center text-[18px] text-white",
                    children: $8cc62c6d4d7b8f3a$export$99d6e362da251621(status)
                })
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8T3gX = parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");
const $74c8423a8d9ec73a$export$c53a4e69ab4f344c = (siteId, enabled)=>{
    const [status, setStatus] = (0, $8T3gX.useState)("idle");
    const [cameras, setCameras] = (0, $8T3gX.useState)([]);
    const [totalCount, setTotalCount] = (0, $8T3gX.useState)(0);
    const nextPageRef = (0, $8T3gX.useRef)(null);
    const fetchIdRef = (0, $8T3gX.useRef)(0);
    const loadingMoreRef = (0, $8T3gX.useRef)(false);
    const camerasLengthRef = (0, $8T3gX.useRef)(0);
    const reset = (0, $8T3gX.useCallback)(()=>{
        setStatus("idle");
        setCameras([]);
        setTotalCount(0);
        nextPageRef.current = null;
        loadingMoreRef.current = false;
        camerasLengthRef.current = 0;
    }, []);
    const fetchPage = (0, $8T3gX.useCallback)(async (pageNumber, fetchId)=>{
        if (!siteId) return [];
        const AxiosUI = (0, $195EM.createApi)("");
        const response = await AxiosUI.get(`camera/site/?customer__id=${siteId}&page=${pageNumber}`);
        if (fetchId !== fetchIdRef.current) return [];
        const { count: count, next: next, results: results } = response.data;
        setTotalCount(count);
        nextPageRef.current = next ? pageNumber + 1 : null;
        setCameras((prev)=>{
            const merged = pageNumber === 1 ? results : [
                ...prev,
                ...results
            ];
            camerasLengthRef.current = merged.length;
            return merged;
        });
        setStatus("ready");
        return results;
    }, [
        siteId
    ]);
    (0, $8T3gX.useEffect)(()=>{
        if (!enabled || !siteId) {
            fetchIdRef.current += 1;
            reset();
            return;
        }
        const fetchId = ++fetchIdRef.current;
        setStatus("loading");
        setCameras([]);
        setTotalCount(0);
        nextPageRef.current = null;
        camerasLengthRef.current = 0;
        fetchPage(1, fetchId).catch(()=>{
            if (fetchId !== fetchIdRef.current) return;
            setStatus("error");
        });
    }, [
        enabled,
        siteId,
        fetchPage,
        reset
    ]);
    const ensureCamerasLoaded = (0, $8T3gX.useCallback)(async (upToIndex)=>{
        if (!siteId || status === "idle" || status === "loading") return;
        if (camerasLengthRef.current > upToIndex) return;
        if (!nextPageRef.current || loadingMoreRef.current) return;
        const fetchId = fetchIdRef.current;
        loadingMoreRef.current = true;
        try {
            while(nextPageRef.current && camerasLengthRef.current <= upToIndex && fetchId === fetchIdRef.current)await fetchPage(nextPageRef.current, fetchId);
        } catch  {
            if (fetchId === fetchIdRef.current) setStatus("error");
        } finally{
            loadingMoreRef.current = false;
        }
    }, [
        siteId,
        status,
        fetchPage
    ]);
    return {
        status: status,
        cameras: cameras,
        totalCount: totalCount,
        ensureCamerasLoaded: ensureCamerasLoaded,
        reset: reset
    };
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

var $60vL1 = parcelRequire("60vL1");

var $iKAtE = parcelRequire("iKAtE");

var $433j1 = parcelRequire("433j1");
const $a75edc692a8a5bf4$export$fa1535b8e7318f4a = 9;
const $a75edc692a8a5bf4$export$4cfc0b3df2c5d5a1 = 9;
const $a75edc692a8a5bf4$export$9fe5bc88fdfadd78 = 12;
const $a75edc692a8a5bf4$export$cb71459d0d2230aa = "hls";
const $a75edc692a8a5bf4$export$5ccaa03abac529f4 = "overflow-hidden rounded";
const $a75edc692a8a5bf4$export$74fb60dfe521e15c = `${$a75edc692a8a5bf4$export$5ccaa03abac529f4} border-2 bg-black`;



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $frXOV = parcelRequire("frXOV");

var $2qUoo = parcelRequire("2qUoo");

var $8jTCz = parcelRequire("8jTCz");
const $20fe3c74f4782423$export$1aaab2b84e6c1008 = ({ page: page, totalPages: totalPages, onPageChange: onPageChange, className: className = "", label: label, variant: variant = "dark", size: size = "default" })=>{
    const isXLarge = size === "xlarge";
    const isLarge = size === "large" || isXLarge;
    const textSizeClass = isXLarge ? "text-[16px]" : isLarge ? "text-[18px]" : "text-[11px]";
    const gapClass = isXLarge ? "gap-4" : isLarge ? "gap-4" : "gap-2";
    const textClass = variant === "light" ? "text-gray-500" : "text-[#8b97a8]";
    const buttonClass = `rounded border border-[#33404f] bg-[#1c2530] font-bold text-[#dfe6ef] disabled:cursor-default disabled:opacity-30 ${isXLarge ? "px-6 py-1.5 text-[22px]" : isLarge ? "px-5 py-1 text-[18px]" : "px-2.5 py-0.5 text-[11px]"}`;
    const arrowIconSx = isXLarge ? {
        fontSize: 26
    } : isLarge ? {
        fontSize: 24
    } : {
        fontSize: 18
    };
    const orangeArrowButtonSx = {
        minWidth: "auto",
        px: isXLarge ? 1 : isLarge ? 0.5 : 0.25,
        py: isXLarge ? 0.5 : 0.25
    };
    const renderArrowButton = (direction, disabled, onClick)=>{
        const Icon = direction === "prev" ? (0, (/*@__PURE__*/$parcel$interopDefault($frXOV))) : (0, (/*@__PURE__*/$parcel$interopDefault($2qUoo)));
        if (variant === "light") return /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
            text: /*#__PURE__*/ (0, $k4ank.jsx)(Icon, {
                sx: arrowIconSx
            }),
            disabled: disabled,
            onClick: onClick,
            sx: orangeArrowButtonSx
        });
        return /*#__PURE__*/ (0, $k4ank.jsx)("button", {
            type: "button",
            disabled: disabled,
            onClick: onClick,
            className: buttonClass,
            children: /*#__PURE__*/ (0, $k4ank.jsx)(Icon, {
                sx: arrowIconSx
            })
        });
    };
    if (totalPages <= 1) return label ? /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: `font-mulish text-center ${textSizeClass} ${textClass} ${className}`,
        children: label
    }) : null;
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: `flex items-center justify-center font-mulish ${gapClass} ${textSizeClass} ${textClass} ${className}`,
        children: [
            renderArrowButton("prev", page <= 0, ()=>onPageChange(page - 1)),
            /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                children: label ?? `${page + 1} / ${totalPages}`
            }),
            renderArrowButton("next", page >= totalPages - 1, ()=>onPageChange(page + 1))
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");

var $60vL1 = parcelRequire("60vL1");



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");




var $iMovf = parcelRequire("iMovf");

/**
 * Persistent video-wall stream registry.
 *
 * Problem: the wall renders the same camera in different React subtrees per
 * layout (mini panel, Focus+Grid spotlight vs side grid, Equal Grid). Switching
 * modes/panels unmounts one subtree and mounts another, which — when each tile
 * owned its own <video> + player — tore the player down and forced a fresh
 * stream-session request (cold-start), churning the lease and resetting the
 * MediaMTX HLS muxer (→ segment 404s, "in and out").
 *
 * Fix: own the player + <video> here, keyed by camera id, for as long as the
 * camera is in the active set. Each <video> is created IMPERATIVELY
 * (document.createElement) — never rendered by React — and moved into the
 * current tile slot with appendChild. appendChild RE-PARENTS the same DOM node
 * (it does not recreate it), so srcObject / the attached hls.js media survive
 * the move; the player keeps running across a layout change with no teardown,
 * no re-request, no muxer reset.
 *
 * (This is why a React portal does NOT work here: changing a portal's container
 * unmounts + remounts its content, recreating the <video> and orphaning the
 * stream. The element must be moved imperatively.)
 *
 * Active set is DERIVED from slot registrations with a short removal grace, so a
 * mode/panel toggle's unmount→remount keeps the player alive (same camera, new
 * slot) while a paged-away camera is still reaped.
 */ const $e0c5ad9c4efb0aa1$var$REMOVE_GRACE_MS = 1500;
const $e0c5ad9c4efb0aa1$var$VIDEO_CLASS = "absolute inset-0 h-full w-full rounded object-contain";
const $e0c5ad9c4efb0aa1$var$WallStreamsContext = /*#__PURE__*/ (0, $8T3gX.createContext)(null);
const $e0c5ad9c4efb0aa1$export$854185e195a44373 = ()=>{
    const ctx = (0, $8T3gX.useContext)($e0c5ad9c4efb0aa1$var$WallStreamsContext);
    if (!ctx) throw new Error("useWallStreams must be used within a WallStreamsProvider");
    return ctx;
};
const $e0c5ad9c4efb0aa1$var$HOLDER_STYLE = {
    position: "absolute",
    width: 0,
    height: 0,
    overflow: "hidden",
    pointerEvents: "none",
    opacity: 0
};
const $e0c5ad9c4efb0aa1$var$PersistentStream = ({ cameraId: cameraId, protocol: protocol, lowLatency: lowLatency, enabled: enabled, idlePaused: idlePaused, slotNode: slotNode, onStatusChange: onStatusChange })=>{
    // The <video> is created once, imperatively, and lives in this ref for the
    // lifetime of the component (i.e. as long as the camera is active). React
    // never renders it, so it is never recreated — only re-parented via
    // appendChild below.
    const videoRef = (0, $8T3gX.useRef)(null);
    if (!videoRef.current && typeof document !== "undefined") {
        const v = document.createElement("video");
        v.autoplay = true;
        v.muted = true;
        v.playsInline = true;
        v.className = $e0c5ad9c4efb0aa1$var$VIDEO_CLASS;
        videoRef.current = v;
    }
    // A per-stream offscreen holder that is always in the DOM (rendered below).
    // The <video> parks here whenever no tile slot is displaying the camera.
    const holderRef = (0, $8T3gX.useRef)(null);
    // Attach the <video> to the DOM (current slot, else the holder) in a LAYOUT
    // effect — this runs before the player hook's passive play() effect, so the
    // element is already in the document when WHEP/HLS attaches + play()s. (A
    // detached element at play() time was why the stream never started.)
    // appendChild re-parents the SAME node, preserving srcObject / hls media.
    (0, $8T3gX.useLayoutEffect)(()=>{
        const v = videoRef.current;
        const target = slotNode ?? holderRef.current;
        if (v && target && v.parentNode !== target) target.appendChild(v);
    }, [
        slotNode
    ]);
    // Bind the player to the stable element. videoRef.current never changes, so
    // the srcObject / hls attachment is preserved across moves.
    const { status: status } = (0, $c73f13b6242fb522$export$6e435a92cc94ea59)(cameraId, enabled, videoRef, protocol, lowLatency, idlePaused);
    (0, $8T3gX.useEffect)(()=>{
        onStatusChange(cameraId, status);
    }, [
        cameraId,
        status,
        onStatusChange
    ]);
    // Remove the element from the DOM when this camera leaves the active set.
    (0, $8T3gX.useEffect)(()=>{
        const v = videoRef.current;
        return ()=>{
            v?.remove();
        };
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        ref: holderRef,
        "aria-hidden": true,
        style: $e0c5ad9c4efb0aa1$var$HOLDER_STYLE
    });
};
const $e0c5ad9c4efb0aa1$export$1554c900c4f203ae = ({ protocol: protocol, lowLatency: lowLatency, enabled: enabled, children: children })=>{
    const [slots, setSlots] = (0, $8T3gX.useState)({});
    const [activeIds, setActiveIds] = (0, $8T3gX.useState)([]);
    const [statuses, setStatuses] = (0, $8T3gX.useState)({});
    const removalTimers = (0, $8T3gX.useRef)({});
    // One idle timer for the whole wall (ENG-1132 / ENG-2149): any interaction
    // anywhere on the document resets it; when it fires the panel shows a single
    // "Still watching?" prompt, and if nobody confirms within the grace period
    // every tile pauses together. Only armed once at least one tile is actually
    // PLAYING (cold starts don't count), and kept armed through the pause so the
    // pause isn't cleared out from under the players. One window for every
    // viewer — staff and uncapped plans included (ENG-2149).
    const wallStreaming = activeIds.some((id)=>statuses[id] === "playing" || statuses[id] === "idle_paused");
    // Talking to, or holding listen-in on, any wall camera is engagement: it
    // stops the wall clock and dismisses a showing prompt. A listen-in toggle
    // left on does not (it would keep an unattended wall streaming forever).
    const talkingHolds = (0, $iMovf.useTalkingCamerasStore)((s)=>s.holds);
    const listenInHoldCameraId = (0, $2c93485817abd844$export$76df6223e234efc0)((s)=>s.holdCameraId);
    const talkingIds = Object.values(talkingHolds);
    const wallHeld = activeIds.some((id)=>talkingIds.includes(id) || listenInHoldCameraId === id);
    const { idle: idlePaused, prompting: idlePrompting, reset: resumeFromIdle } = (0, $9113f37e441dbb18$export$3e1c2ef16041091f)(enabled && wallStreaming, (0, $aba069a58fac4b62$export$a533ba79d5ca3f5), (0, $aba069a58fac4b62$export$711964b711fb496d), wallHeld);
    const clearRemoval = (cameraId)=>{
        const t = removalTimers.current[cameraId];
        if (t) {
            clearTimeout(t);
            delete removalTimers.current[cameraId];
        }
    };
    const registerSlot = (0, $8T3gX.useCallback)((cameraId, node)=>{
        if (node) {
            clearRemoval(cameraId);
            setSlots((prev)=>prev[cameraId] === node ? prev : {
                    ...prev,
                    [cameraId]: node
                });
            setActiveIds((prev)=>prev.includes(cameraId) ? prev : [
                    ...prev,
                    cameraId
                ]);
            return;
        }
        setSlots((prev)=>{
            if (!(cameraId in prev)) return prev;
            const next = {
                ...prev
            };
            delete next[cameraId];
            return next;
        });
        if (!removalTimers.current[cameraId]) removalTimers.current[cameraId] = setTimeout(()=>{
            delete removalTimers.current[cameraId];
            setActiveIds((prev)=>prev.filter((id)=>id !== cameraId));
            setStatuses((prev)=>{
                if (!(cameraId in prev)) return prev;
                const next = {
                    ...prev
                };
                delete next[cameraId];
                return next;
            });
        }, $e0c5ad9c4efb0aa1$var$REMOVE_GRACE_MS);
    }, []);
    const onStatusChange = (0, $8T3gX.useCallback)((cameraId, status)=>{
        setStatuses((prev)=>prev[cameraId] === status ? prev : {
                ...prev,
                [cameraId]: status
            });
    }, []);
    const useStreamStatus = (0, $8T3gX.useCallback)((cameraId)=>statuses[cameraId] ?? "idle", [
        statuses
    ]);
    (0, $8T3gX.useEffect)(()=>{
        if (enabled) return;
        Object.keys(removalTimers.current).forEach(clearRemoval);
        setActiveIds([]);
        setSlots({});
        setStatuses({});
    }, [
        enabled
    ]);
    (0, $8T3gX.useEffect)(()=>()=>{
            Object.values(removalTimers.current).forEach(clearTimeout);
            removalTimers.current = {};
        }, []);
    const ctx = (0, $8T3gX.useMemo)(()=>({
            registerSlot: registerSlot,
            useStreamStatus: useStreamStatus,
            idlePrompting: idlePrompting,
            idlePaused: idlePaused,
            resumeFromIdle: resumeFromIdle
        }), [
        registerSlot,
        useStreamStatus,
        idlePrompting,
        idlePaused,
        resumeFromIdle
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)($e0c5ad9c4efb0aa1$var$WallStreamsContext.Provider, {
        value: ctx,
        children: [
            enabled && activeIds.map((cameraId)=>/*#__PURE__*/ (0, $k4ank.jsx)($e0c5ad9c4efb0aa1$var$PersistentStream, {
                    cameraId: cameraId,
                    protocol: protocol,
                    lowLatency: lowLatency,
                    enabled: enabled,
                    idlePaused: idlePaused,
                    slotNode: slots[cameraId] ?? null,
                    onStatusChange: onStatusChange
                }, cameraId)),
            children
        ]
    });
};
const $e0c5ad9c4efb0aa1$export$637091a9b9014aed = `The video wall will pause in ${(0, $aba069a58fac4b62$export$711964b711fb496d) / 1000} seconds unless you confirm you're still watching.`;
const $e0c5ad9c4efb0aa1$export$666ee0fec2c29d70 = "The video wall was paused after a period of inactivity to save your streaming allowance.";
const $e0c5ad9c4efb0aa1$export$2795e1bb40fa84e0 = ({ compact: compact = false })=>{
    // Tolerate rendering outside a provider (unit tests render the panels bare).
    const ctx = (0, $8T3gX.useContext)($e0c5ad9c4efb0aa1$var$WallStreamsContext);
    if (!ctx?.idlePaused && !ctx?.idlePrompting) return null;
    const { resumeFromIdle: resumeFromIdle, idlePaused: idlePaused } = ctx;
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: `flex flex-col items-center justify-center rounded border border-actuate-grey bg-[#FAFAFB] text-center font-mulish ${compact ? "gap-1 px-3 py-3" : "gap-2 px-6 py-5"}`,
        "data-testid": idlePaused ? "wall-idle-prompt" : "wall-still-watching-prompt",
        role: idlePaused ? undefined : "alertdialog",
        "aria-label": "Still watching?",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: `font-bold text-actuate-blue ${compact ? "text-[14px]" : "text-[20px]"}`,
                children: "Still watching?"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: `text-gray-600 ${compact ? "text-[11px]" : "text-[14px]"}`,
                children: idlePaused ? $e0c5ad9c4efb0aa1$export$666ee0fec2c29d70 : $e0c5ad9c4efb0aa1$export$637091a9b9014aed
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                type: "button",
                onClick: resumeFromIdle,
                className: `shadow-button mt-1 rounded border-2 border-actuate-orange bg-actuate-orange font-mulish text-white hover:bg-[#E67300] ${compact ? "px-3 py-1 text-[13px]" : "px-4 py-1.5 text-base"}`,
                children: idlePaused ? "Resume" : "I'm still watching"
            })
        ]
    });
};


const $eeea941a6177ab43$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $eeea941a6177ab43$export$6c19a72ec72dc6b4 = ({ cameraId: cameraId, cameraName: cameraName, enabled: enabled, isFocused: isFocused = false, onClick: onClick, className: className = "", compact: compact = true, placeholderMessage: // showControls is accepted for API compatibility but no longer used: the
// <video> is owned by WallStreamsProvider, so controls aren't attached here.
placeholderMessage, fitToContainer: fitToContainer = false })=>{
    const { registerSlot: registerSlot, useStreamStatus: useStreamStatus } = (0, $e0c5ad9c4efb0aa1$export$854185e195a44373)();
    const status = useStreamStatus(cameraId);
    // This tile actually displays the camera (vs a placeholder slot — e.g. the
    // focused camera's spot in the side grid, which reads "Displaying video on
    // left" while the video shows in the spotlight tile).
    const streamHere = enabled && !placeholderMessage;
    // Claim the persistent <video> into our slot while we're the displaying tile;
    // release it (→ holder / another slot) on unmount or when we become a
    // placeholder. The player is NOT torn down by this register/unregister.
    const slotRef = (0, $8T3gX.useCallback)((node)=>{
        registerSlot(cameraId, streamHere ? node : null);
    }, [
        registerSlot,
        cameraId,
        streamHere
    ]);
    const showVideo = streamHere && status === "playing";
    const showLoading = streamHere && (status === "loading" || status === "idle" || status === "starting");
    const showUnavailable = streamHere && (status === "unavailable" || status === "camera_offline" || status === "quota_reached" || status === "session_expired" || status === "codec_unsupported");
    const showIdlePaused = streamHere && status === "idle_paused";
    const showPlaceholder = Boolean(placeholderMessage);
    const frameRing = isFocused ? "border-actuate-orange" : onClick ? "border-transparent hover:border-actuate-orange" : "border-transparent";
    const frameClassName = fitToContainer ? `relative box-border aspect-[4/3] max-h-full w-full max-w-full ${0, $a75edc692a8a5bf4$export$74fb60dfe521e15c} ${frameRing}` : `relative box-border aspect-[4/3] w-full ${0, $a75edc692a8a5bf4$export$74fb60dfe521e15c} ${frameRing}`;
    const cameraNameClass = compact ? "pointer-events-none absolute left-1 top-1 z-10 max-w-[calc(100%-8px)] truncate rounded bg-black/55 px-1.5 py-0.5 font-mulish text-[10px] text-white" : "pointer-events-none absolute left-3 top-3 z-10 max-w-[calc(100%-24px)] truncate rounded bg-black/55 px-3 py-1.5 font-mulish text-[20px] text-white";
    const unavailableMessageClass = compact ? "font-mulish text-center text-[9px] leading-tight text-white/80" : "font-mulish px-4 text-center text-xl font-semibold leading-snug text-white/90";
    const liveBadgeClass = compact ? "pointer-events-none absolute right-1 top-1 z-10 inline-flex items-center gap-1 rounded bg-[#D93636] px-1.5 py-0.5 font-mulish text-[8px] font-bold uppercase tracking-[0.08em] text-white" : "pointer-events-none absolute right-3 top-3 z-10 inline-flex items-center gap-2 rounded bg-[#D93636] px-3 py-1.5 font-mulish text-[14px] font-bold uppercase tracking-[0.08em] text-white shadow-[0_2px_8px_rgba(217,54,54,0.4)]";
    const liveDotClass = compact ? "h-1.5 w-1.5 shrink-0 animate-pulse rounded-full bg-white" : "h-2.5 w-2.5 shrink-0 animate-pulse rounded-full bg-white";
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        role: onClick ? "button" : undefined,
        tabIndex: onClick ? 0 : undefined,
        onClick: onClick,
        onKeyDown: onClick ? (e)=>{
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick();
            }
        } : undefined,
        className: fitToContainer ? `flex h-full w-full min-h-0 min-w-0 items-center justify-center ${onClick ? "cursor-pointer" : ""} ${className}` : `w-full min-w-0 self-start ${onClick ? "cursor-pointer" : ""} ${className}`,
        "data-testid": `wall-tile-${cameraId}`,
        "data-enabled": String(streamHere),
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: frameClassName,
            children: [
                streamHere && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    ref: slotRef,
                    className: "pointer-events-none absolute inset-0 overflow-hidden rounded"
                }),
                showVideo && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: liveBadgeClass,
                    "aria-label": "Live stream",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                            className: liveDotClass
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                            children: "LIVE"
                        })
                    ]
                }),
                (showLoading || showUnavailable) && !showPlaceholder && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: `pointer-events-none absolute inset-0 flex flex-col items-center justify-center bg-black ${compact ? "px-1" : "px-4"}`,
                    children: showLoading ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                                theme: $eeea941a6177ab43$var$theme,
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                    color: "primary",
                                    size: compact ? 18 : 32
                                })
                            }),
                            compact ? null : /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "font-mulish mt-2 text-center text-[12px] text-white",
                                children: "Connecting..."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: unavailableMessageClass,
                        children: (0, $8cc62c6d4d7b8f3a$export$99d6e362da251621)(status)
                    })
                }),
                showIdlePaused && !showPlaceholder && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "pointer-events-none absolute inset-0 flex items-center justify-center bg-black px-2",
                    "data-testid": `wall-tile-paused-${cameraId}`,
                    children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: compact ? "font-mulish text-center text-[9px] text-white/70" : "font-mulish text-center text-lg font-semibold text-white/80",
                        children: "Paused"
                    })
                }),
                showPlaceholder && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "absolute inset-0 flex items-center justify-center bg-black px-2",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-mulish text-center text-[10px] font-semibold leading-snug text-actuate-orange",
                        children: placeholderMessage
                    })
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                    className: cameraNameClass,
                    children: cameraName
                })
            ]
        })
    });
};



const $4a94dea04c3eb227$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $4a94dea04c3eb227$export$729777d9cbf89324 = ({ open: open, onClose: onClose, onExpand: onExpand, expandHref: expandHref, status: status, cameras: cameras, totalCount: totalCount, page: page, onPageChange: onPageChange, ensureCamerasLoaded: ensureCamerasLoaded })=>{
    const totalPages = Math.max(1, Math.ceil(totalCount / (0, $a75edc692a8a5bf4$export$fa1535b8e7318f4a)));
    const startIndex = page * (0, $a75edc692a8a5bf4$export$fa1535b8e7318f4a);
    const endIndex = startIndex + (0, $a75edc692a8a5bf4$export$fa1535b8e7318f4a) - 1;
    (0, $8T3gX.useEffect)(()=>{
        if (!open || status !== "ready") return;
        ensureCamerasLoaded(endIndex);
    }, [
        open,
        status,
        page,
        endIndex,
        ensureCamerasLoaded
    ]);
    if (!open) return null;
    const visibleCameras = cameras.slice(startIndex, startIndex + (0, $a75edc692a8a5bf4$export$fa1535b8e7318f4a));
    const placeholderCount = Math.max(0, Math.min((0, $a75edc692a8a5bf4$export$fa1535b8e7318f4a), totalCount - startIndex) - visibleCameras.length);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: "absolute bottom-14 right-3.5 z-20 flex max-w-[70%] flex-col gap-2 rounded border border-actuate-grey bg-white p-2.5 font-mulish shadow-sm",
        style: {
            width: 430
        },
        "data-testid": "site-video-wall-mini-panel",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex items-center gap-2 text-[14px] font-extrabold uppercase tracking-[0.5px] text-actuate-blue",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                        children: [
                            "Site Wall \u2014 ",
                            totalCount,
                            " Camera",
                            totalCount === 1 ? "" : "s"
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                        "aria-label": "Close site wall",
                        onClick: onClose,
                        size: "small",
                        sx: {
                            marginLeft: "auto",
                            color: "#001943",
                            padding: 0
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {
                            fontSize: "small"
                        })
                    })
                ]
            }),
            status === "loading" && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex flex-col items-center justify-center py-8",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                        theme: $4a94dea04c3eb227$var$theme,
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                            color: "primary",
                            size: 28
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "mt-3 text-[12px] text-gray-500",
                        children: "Retrieving cameras..."
                    })
                ]
            }),
            status === "error" && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "py-6 text-center text-[12px] text-gray-500",
                children: "Unable to load cameras for this site."
            }),
            status === "ready" && totalCount === 0 && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "py-6 text-center text-[12px] text-gray-500",
                children: "No cameras found for this site."
            }),
            status === "ready" && totalCount > 0 && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $e0c5ad9c4efb0aa1$export$2795e1bb40fa84e0), {
                        compact: true
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "grid grid-cols-3 gap-1.5",
                        children: [
                            visibleCameras.map((camera)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eeea941a6177ab43$export$6c19a72ec72dc6b4), {
                                    cameraId: String(camera.id),
                                    cameraName: camera.camera_name,
                                    enabled: open
                                }, camera.id)),
                            Array.from({
                                length: placeholderCount
                            }).map((_, i)=>/*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: `flex aspect-[4/3] w-full items-center justify-center self-start ${(0, $a75edc692a8a5bf4$export$74fb60dfe521e15c)} border-transparent`,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                                        theme: $4a94dea04c3eb227$var$theme,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                            color: "primary",
                                            size: 16
                                        })
                                    })
                                }, `placeholder-${i}`))
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $20fe3c74f4782423$export$1aaab2b84e6c1008), {
                        page: page,
                        totalPages: totalPages,
                        onPageChange: onPageChange,
                        variant: "light",
                        size: "large"
                    }),
                    expandHref ? /*#__PURE__*/ (0, $k4ank.jsx)("a", {
                        href: expandHref,
                        onClick: (e)=>{
                            // Plain left-click keeps in-page expand; modifiers / middle-click
                            // and right-click "Open in new tab" use the real href.
                            if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
                            e.preventDefault();
                            onExpand();
                        },
                        className: "shadow-button self-center rounded border-2 border-actuate-orange bg-actuate-orange px-3 py-1.5 font-mulish text-base text-white no-underline hover:bg-[#E67300]",
                        children: "Expand to full wall"
                    }) : /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                        type: "button",
                        onClick: onExpand,
                        className: "shadow-button self-center rounded border-2 border-actuate-orange bg-actuate-orange px-3 py-1.5 font-mulish text-base text-white hover:bg-[#E67300]",
                        children: "Expand to full wall"
                    })
                ]
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");





const $2debd1b6295fdea0$var$Transition = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).forwardRef(function Transition(props, ref) {
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $212a5a6a44b7f18e$export$2e2bcd8739ae039), {
        direction: "up",
        ref: ref,
        ...props
    });
});
const $2debd1b6295fdea0$export$c15a0d91f9d412f2 = ({ open: open, onClose: onClose, siteName: siteName, alertContextLabel: alertContextLabel, status: status, cameras: cameras, totalCount: totalCount, mode: mode, onModeChange: onModeChange, page: page, onPageChange: onPageChange, focusedCameraId: focusedCameraId, onFocusedCameraChange: onFocusedCameraChange, ensureCamerasLoaded: ensureCamerasLoaded, closeLabel: closeLabel = "Back to Alert" })=>{
    const focusedCamera = cameras.find((c)=>String(c.id) === focusedCameraId);
    const focusSideTotalPages = Math.max(1, Math.ceil(totalCount / (0, $a75edc692a8a5bf4$export$4cfc0b3df2c5d5a1)));
    const equalTotalPages = Math.max(1, Math.ceil(totalCount / (0, $a75edc692a8a5bf4$export$9fe5bc88fdfadd78)));
    const focusSideStart = page * (0, $a75edc692a8a5bf4$export$4cfc0b3df2c5d5a1);
    const focusSideEnd = focusSideStart + (0, $a75edc692a8a5bf4$export$4cfc0b3df2c5d5a1) - 1;
    const equalStart = page * (0, $a75edc692a8a5bf4$export$9fe5bc88fdfadd78);
    const equalEnd = equalStart + (0, $a75edc692a8a5bf4$export$9fe5bc88fdfadd78) - 1;
    (0, $8T3gX.useEffect)(()=>{
        if (!open || status !== "ready") return;
        if (mode === "focus") ensureCamerasLoaded(focusSideEnd);
        else ensureCamerasLoaded(equalEnd);
    }, [
        open,
        status,
        mode,
        page,
        focusSideEnd,
        equalEnd,
        ensureCamerasLoaded
    ]);
    const sideCameras = mode === "focus" ? cameras.slice(focusSideStart, focusSideStart + (0, $a75edc692a8a5bf4$export$4cfc0b3df2c5d5a1)) : [];
    const equalCameras = mode === "equal" ? cameras.slice(equalStart, equalStart + (0, $a75edc692a8a5bf4$export$9fe5bc88fdfadd78)) : [];
    const equalPlaceholderCount = mode === "equal" ? Math.max(0, Math.min((0, $a75edc692a8a5bf4$export$9fe5bc88fdfadd78), totalCount - equalStart) - equalCameras.length) : 0;
    const equalGridCols = totalCount <= 2 ? 2 : totalCount <= 6 ? 3 : 4;
    const equalGridTileCount = Math.min((0, $a75edc692a8a5bf4$export$9fe5bc88fdfadd78), Math.max(equalCameras.length + equalPlaceholderCount, 1));
    const equalGridRows = Math.ceil(equalGridTileCount / equalGridCols);
    // Always reserve 3 rows so 4–6 camera pages don't stretch two visible rows
    // to fill the full panel height; empty row tracks stay blank (no placeholder tiles).
    const focusSideRows = 3;
    const paginationLabel = mode === "focus" && totalCount > (0, $a75edc692a8a5bf4$export$4cfc0b3df2c5d5a1) ? `Cameras ${focusSideStart + 1}\u{2013}${Math.min(focusSideStart + (0, $a75edc692a8a5bf4$export$4cfc0b3df2c5d5a1), totalCount)} of ${totalCount}` : undefined;
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $kUcVg.default), {
        fullScreen: true,
        open: open,
        onClose: onClose,
        TransitionComponent: $2debd1b6295fdea0$var$Transition,
        "data-testid": "site-video-wall-full-dialog",
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: "flex h-full flex-col gap-2.5 bg-white p-3.5 font-mulish md:p-4",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "flex flex-none flex-wrap items-center gap-3",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                            className: "text-[18px] font-extrabold uppercase tracking-[0.8px] text-actuate-blue",
                            children: [
                                "Site Video Wall \u2014 ",
                                siteName
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                            className: "rounded border border-actuate-grey bg-[#FAFAFB] px-3 py-1 text-[14px] text-gray-600",
                            children: [
                                "Reviewing:",
                                " ",
                                /*#__PURE__*/ (0, $k4ank.jsx)("b", {
                                    className: "font-bold text-actuate-blue",
                                    children: alertContextLabel
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "shadow-button ml-auto flex overflow-hidden rounded border-2 border-actuate-orange",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>onModeChange("focus"),
                                    className: `border-r border-actuate-orange p-1.5 font-mulish text-base ${mode === "focus" ? "bg-actuate-orange text-white hover:bg-[#E67300]" : "bg-white text-actuate-orange"}`,
                                    children: "Focus + Grid"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>onModeChange("equal"),
                                    className: `p-1.5 font-mulish text-base ${mode === "equal" ? "bg-actuate-orange text-white hover:bg-[#E67300]" : "bg-white text-actuate-orange"}`,
                                    children: "Equal Grid"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                            type: "button",
                            onClick: onClose,
                            className: "shadow-button rounded border-2 border-actuate-orange bg-actuate-orange p-1.5 font-mulish text-base text-white hover:bg-[#E67300]",
                            children: closeLabel
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $e0c5ad9c4efb0aa1$export$2795e1bb40fa84e0), {}),
                status === "loading" && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "flex flex-1 items-center justify-center text-gray-500",
                    children: "Retrieving cameras..."
                }),
                status === "error" && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "flex flex-1 items-center justify-center text-gray-500",
                    children: "Unable to load cameras for this site."
                }),
                status === "ready" && totalCount === 0 && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "flex flex-1 items-center justify-center text-gray-500",
                    children: "No cameras found for this site."
                }),
                status === "ready" && totalCount > 0 && mode === "focus" && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "flex min-h-0 flex-1 gap-2.5 overflow-hidden",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "flex min-h-0 min-w-0 flex-[2.4] items-center justify-center",
                            children: focusedCamera ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $eeea941a6177ab43$export$6c19a72ec72dc6b4), {
                                cameraId: String(focusedCamera.id),
                                cameraName: focusedCamera.camera_name,
                                enabled: open,
                                isFocused: true,
                                compact: false,
                                showControls: true,
                                fitToContainer: true,
                                className: "h-full w-full"
                            }) : /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: `flex aspect-[4/3] max-h-full w-full max-w-full items-center justify-center ${(0, $a75edc692a8a5bf4$export$5ccaa03abac529f4)} border border-actuate-grey bg-[#FAFAFB] text-gray-500`,
                                children: "Select a camera"
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "flex min-h-0 min-w-0 flex-[1.6] flex-col gap-2",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "grid min-h-0 flex-1 grid-cols-3 gap-2",
                                    "data-testid": "focus-side-grid",
                                    style: {
                                        gridTemplateRows: `repeat(${focusSideRows}, minmax(0, 1fr))`
                                    },
                                    children: sideCameras.map((camera)=>{
                                        const isSelected = String(camera.id) === focusedCameraId;
                                        return /*#__PURE__*/ (0, $k4ank.jsx)((0, $eeea941a6177ab43$export$6c19a72ec72dc6b4), {
                                            cameraId: String(camera.id),
                                            cameraName: camera.camera_name,
                                            enabled: open,
                                            isFocused: isSelected,
                                            onClick: ()=>onFocusedCameraChange(String(camera.id)),
                                            placeholderMessage: isSelected ? "Displaying video on left" : undefined,
                                            fitToContainer: true
                                        }, camera.id);
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $20fe3c74f4782423$export$1aaab2b84e6c1008), {
                                    page: page,
                                    totalPages: focusSideTotalPages,
                                    onPageChange: onPageChange,
                                    label: paginationLabel,
                                    className: "flex-none justify-center py-1",
                                    variant: "light",
                                    size: "xlarge"
                                })
                            ]
                        })
                    ]
                }),
                status === "ready" && totalCount > 0 && mode === "equal" && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "grid min-h-0 flex-1 gap-2",
                    style: {
                        gridTemplateColumns: `repeat(${equalGridCols}, minmax(0, 1fr))`,
                        gridTemplateRows: `repeat(${equalGridRows}, minmax(0, 1fr))`
                    },
                    children: [
                        equalCameras.map((camera)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eeea941a6177ab43$export$6c19a72ec72dc6b4), {
                                cameraId: String(camera.id),
                                cameraName: camera.camera_name,
                                enabled: open,
                                isFocused: String(camera.id) === focusedCameraId,
                                onClick: ()=>onFocusedCameraChange(String(camera.id)),
                                showControls: true,
                                fitToContainer: true
                            }, camera.id)),
                        Array.from({
                            length: equalPlaceholderCount
                        }).map((_, i)=>/*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "flex min-h-0 min-w-0 items-center justify-center",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: `aspect-[4/3] max-h-full w-full max-w-full ${(0, $a75edc692a8a5bf4$export$74fb60dfe521e15c)} border-transparent`
                                })
                            }, `equal-placeholder-${i}`))
                    ]
                }),
                status === "ready" && totalCount > 0 && mode === "equal" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $20fe3c74f4782423$export$1aaab2b84e6c1008), {
                    page: page,
                    totalPages: equalTotalPages,
                    onPageChange: onPageChange,
                    className: "flex-none justify-center py-2",
                    variant: "light",
                    size: "xlarge"
                })
            ]
        })
    });
};



const $9ba45c9953aa0a9d$export$9fdea5360a93ed4a = (cameraId, cameras, pageSize = (0, $a75edc692a8a5bf4$export$4cfc0b3df2c5d5a1))=>{
    if (!cameraId) return 0;
    const index = cameras.findIndex((camera)=>String(camera.id) === cameraId);
    if (index < 0) return null;
    return Math.floor(index / pageSize);
};
const $9ba45c9953aa0a9d$export$a5e13741ab401bc = ({ siteId: siteId, siteName: siteName, cameraId: cameraId, alertContext: alertContext })=>{
    const params = new URLSearchParams();
    if (siteName) params.set("siteName", siteName);
    if (cameraId) params.set("cameraId", cameraId);
    if (alertContext?.detectionType) params.set("detectionType", alertContext.detectionType);
    if (alertContext?.cameraName) params.set("cameraName", alertContext.cameraName);
    if (alertContext?.formattedDate) params.set("date", alertContext.formattedDate);
    const query = params.toString();
    return `/sites/${siteId}/videowall${query ? `?${query}` : ""}`;
};




const $49ff3e8c05072b45$export$af7c760892830ecd = ({ siteId: siteId, siteName: siteName, alertContext: alertContext, defaultFocusedCameraId: defaultFocusedCameraId, miniOpen: miniOpen, onMiniOpenChange: onMiniOpenChange })=>{
    const [fullOpen, setFullOpen] = (0, $8T3gX.useState)(false);
    const [miniPage, setMiniPage] = (0, $8T3gX.useState)(0);
    const [fullPage, setFullPage] = (0, $8T3gX.useState)(0);
    const [fullMode, setFullMode] = (0, $8T3gX.useState)("focus");
    const [focusedCameraId, setFocusedCameraId] = (0, $8T3gX.useState)(defaultFocusedCameraId);
    const focusGridPageSyncedRef = (0, $8T3gX.useRef)(false);
    const camerasEnabled = miniOpen || fullOpen;
    const { status: status, cameras: cameras, totalCount: totalCount, ensureCamerasLoaded: ensureCamerasLoaded } = (0, $74c8423a8d9ec73a$export$c53a4e69ab4f344c)(siteId, camerasEnabled);
    (0, $8T3gX.useEffect)(()=>{
        setFocusedCameraId(defaultFocusedCameraId);
    }, [
        siteId
    ]);
    (0, $8T3gX.useEffect)(()=>{
        if (fullOpen) setFocusedCameraId(defaultFocusedCameraId);
    }, [
        fullOpen,
        defaultFocusedCameraId
    ]);
    (0, $8T3gX.useEffect)(()=>{
        setMiniPage(0);
        setFullPage(0);
        setFullOpen(false);
        onMiniOpenChange(false);
        focusGridPageSyncedRef.current = false;
    }, [
        siteId,
        onMiniOpenChange
    ]);
    (0, $8T3gX.useEffect)(()=>{
        if (!fullOpen) focusGridPageSyncedRef.current = false;
    }, [
        fullOpen
    ]);
    (0, $8T3gX.useEffect)(()=>{
        if (!fullOpen || fullMode !== "focus" || status !== "ready" || !focusedCameraId) return;
        if (focusGridPageSyncedRef.current) return;
        const pageForCamera = (0, $9ba45c9953aa0a9d$export$9fdea5360a93ed4a)(focusedCameraId, cameras);
        if (pageForCamera !== null) {
            setFullPage(pageForCamera);
            focusGridPageSyncedRef.current = true;
            return;
        }
        if (cameras.length < totalCount) ensureCamerasLoaded(totalCount - 1);
    }, [
        fullOpen,
        fullMode,
        status,
        focusedCameraId,
        cameras,
        totalCount,
        ensureCamerasLoaded
    ]);
    const handleCloseMini = (0, $8T3gX.useCallback)(()=>{
        onMiniOpenChange(false);
    }, [
        onMiniOpenChange
    ]);
    const handleExpand = (0, $8T3gX.useCallback)(()=>{
        onMiniOpenChange(false);
        setFullOpen(true);
    }, [
        onMiniOpenChange
    ]);
    const handleCloseFull = (0, $8T3gX.useCallback)(()=>{
        setFullOpen(false);
    }, []);
    const handleModeChange = (0, $8T3gX.useCallback)((mode)=>{
        setFullMode(mode);
        if (mode === "focus") focusGridPageSyncedRef.current = false;
        else setFullPage(0);
    }, []);
    const alertContextLabel = `${alertContext.detectionType} \xb7 ${alertContext.cameraName} \xb7 ${alertContext.formattedDate}`;
    const expandHref = siteId != null ? (0, $9ba45c9953aa0a9d$export$a5e13741ab401bc)({
        siteId: siteId,
        siteName: siteName,
        cameraId: defaultFocusedCameraId,
        alertContext: alertContext
    }) : undefined;
    return(// One stream registry across both panels: a camera's player persists across
    // mini ⇆ full and Focus ⇆ Equal ⇆ page changes (its <video> is re-parented
    // into the new tile slot) instead of being torn down + re-requested.
    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $e0c5ad9c4efb0aa1$export$1554c900c4f203ae), {
        protocol: (0, $a75edc692a8a5bf4$export$cb71459d0d2230aa),
        lowLatency: false,
        enabled: camerasEnabled,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $4a94dea04c3eb227$export$729777d9cbf89324), {
                open: miniOpen,
                onClose: handleCloseMini,
                onExpand: handleExpand,
                expandHref: expandHref,
                status: status,
                cameras: cameras,
                totalCount: totalCount,
                page: miniPage,
                onPageChange: setMiniPage,
                ensureCamerasLoaded: ensureCamerasLoaded
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $2debd1b6295fdea0$export$c15a0d91f9d412f2), {
                open: fullOpen,
                onClose: handleCloseFull,
                siteName: siteName,
                alertContextLabel: alertContextLabel,
                status: status,
                cameras: cameras,
                totalCount: totalCount,
                mode: fullMode,
                onModeChange: handleModeChange,
                page: fullPage,
                onPageChange: setFullPage,
                focusedCameraId: focusedCameraId,
                onFocusedCameraChange: setFocusedCameraId,
                ensureCamerasLoaded: ensureCamerasLoaded
            })
        ]
    }));
};


var $8171e8cad3c7deee$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($8171e8cad3c7deee$exports, "__esModule", {
    value: true
});
$8171e8cad3c7deee$exports.default = void 0;

var $8171e8cad3c7deee$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $8171e8cad3c7deee$var$_default = $8171e8cad3c7deee$exports.default = (0, $8171e8cad3c7deee$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'ChevronLeft');


var $93c4ee683cfcd691$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($93c4ee683cfcd691$exports, "__esModule", {
    value: true
});
$93c4ee683cfcd691$exports.default = void 0;

var $93c4ee683cfcd691$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $93c4ee683cfcd691$var$_default = $93c4ee683cfcd691$exports.default = (0, $93c4ee683cfcd691$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'ChevronRight');



/** Side slots between the alert-pane edge and the clip (ENG-2070). */ const $dfbb1eaa7354951b$var$ALERT_NAV_ARROW_GUTTER_PX = 26;
/** ChevronLeft/Right are optically centered; keep the button icon-sized only. */ const $dfbb1eaa7354951b$var$ALERT_NAV_ARROW_ICON_SX = {
    fontSize: 40
};
const $dfbb1eaa7354951b$var$ALERT_NAV_ARROW_BUTTON_SX = {
    minWidth: 0,
    padding: 0,
    lineHeight: 1
};
const $dfbb1eaa7354951b$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $dfbb1eaa7354951b$var$parseNumberList = (str)=>str.split(",").map(Number);
const $dfbb1eaa7354951b$var$Alerts = ({ navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed })=>{
    const [searchParams, setSearchParams] = (0, $fIsAN.useSearchParams)();
    const { flags: flags } = (0, $4PFLW.useFeatureFlag)();
    const { userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    const viewAlertMuting = userPermissions.alert_muting;
    const showLineCrossings = flags?.showLineCrossings;
    const vlmFiltersFlag = Boolean(flags.showVlmFilters);
    // User-level gate. Whether a given alert can actually stream is decided per
    // selected row below (liveStreamingAvailable).
    const showLiveStreaming = Boolean(flags.showLiveStreaming) && userPermissions.live_streaming;
    const [viewMode, setViewMode] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("clip");
    const [streamProtocol, setStreamProtocol] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("hls");
    const [siteWallMiniOpen, setSiteWallMiniOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [detailPaneWidth, setDetailPaneWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [videoPanelHeight, setVideoPanelHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const detailPaneRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const [pinnedDensity, setPinnedDensity] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(()=>(0, $c20b65e3c5a5154b$export$4462e54cf073388e)());
    const [showIgnoreZoneOverlay, setShowIgnoreZoneOverlay] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [showLineCrossingOverlay, setShowLineCrossingOverlay] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const { setSiteId: setSiteId, setViewSiteProtocolDialogOpen: setViewSiteProtocolDialogOpen, siteNotes: siteNotes, setSiteNotes: setSiteNotes, getSiteNotes: getSiteNotes, cameraNotes: cameraNotes, getCameraNotes: getCameraNotes, siteIntegrationTypes: siteIntegrationTypes, setMutedAlertsDialogOpen: setMutedAlertsDialogOpen, mutedAlertsDialogOpen: mutedAlertsDialogOpen, mutedAlertSites: mutedAlertSites, mutedAlertCameras: mutedAlertCameras, seeMutedSiteAndCamerasDialogOpen: seeMutedSiteAndCamerasDialogOpen, resetAlertsStore: resetAlertsStore, fetchSharedMutes: fetchSharedMutes, alertState: alertState, setAlertState: setAlertState, mutedAlertInfo: mutedAlertInfo, muteAlertsError: muteAlertsError, setMuteAlertsError: setMuteAlertsError, selectedRowIsMuted: selectedRowIsMuted, setSelectedRowIsMuted: setSelectedRowIsMuted } = (0, $a4c0e7e0c5cf28c3$export$52a528b1f45cfa42)();
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        resetAlertsStore();
        (0, $f3879d0f44faa78a$export$eb990a362b7d891f)(); // Clear video URL cache on page visit
        // Cleanup function - invalidate pending requests when component unmounts
        // This prevents state updates on unmounted components
        return ()=>{
            (0, $f3879d0f44faa78a$export$847021a4339a3bbe)();
        };
    }, []);
    const group = searchParams.get("group");
    const site = searchParams.get("site");
    const camera = searchParams.get("camera");
    const start_date = searchParams.get("start_date");
    const end_date = searchParams.get("end_date");
    const start_time = searchParams.get("start_time");
    const end_time = searchParams.get("end_time");
    const filter_type = searchParams.get("filter_type");
    const detection_type = searchParams.get("detection_type");
    const has_video = searchParams.get("has_video");
    const [userFilters, setUserFilters] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        parent_group: group,
        site: site ? $dfbb1eaa7354951b$var$parseNumberList(site) : [],
        camera: camera ? $dfbb1eaa7354951b$var$parseNumberList(camera) : [],
        start_date: start_date ? new Date(start_date) : null,
        end_date: end_date ? new Date(end_date) : null,
        start_time: start_time ? (0, $1eebf2e16e3156e5$export$b12cd7d42b630446)(start_time) : null,
        end_time: end_time ? (0, $1eebf2e16e3156e5$export$b12cd7d42b630446)(end_time) : null,
        filter_type: filter_type ? filter_type : "UNCLAIMED",
        has_video: has_video === "true"
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (Array.from(searchParams).length > 0) {
            localStorage.setItem("latestAlertFilters", JSON.stringify(userFilters));
            (0, $361dd3e7be612e92$export$59b2b76630cf930b)(userFilters, searchParams, setSearchParams, detectionType);
        }
    }, []);
    const [alertData, setAlertData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const navigate = (0, $3T949.useNavigate)();
    const [pageLoading, setPageLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [selected, setSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [selectedRow, setSelectedRowState] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    // The flag enables DoubleTake; the UI for it (queue tiles, verdict column,
    // banner) only renders when the alerts in view — the group/site/camera
    // filter's result — include a DoubleTake camera. Otherwise the tiles have
    // nothing to sort and just take up space.
    const showVlmFilters = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>vlmFiltersFlag && (0, $biDrR.hasDoubleTakeInAlerts)(alertData), [
        vlmFiltersFlag,
        alertData
    ]);
    const selectedRowRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const videoMetaRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const getCurrentSelectedRow = ()=>selectedRowRef.current;
    const syncSelectedRowRef = (row)=>{
        selectedRowRef.current = row ?? null;
    };
    const setSelectedRow = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback((value)=>{
        if (typeof value === "function") {
            setSelectedRowState((prev)=>{
                const nextValue = value(prev);
                selectedRowRef.current = nextValue ?? null;
                return nextValue;
            });
            return;
        }
        selectedRowRef.current = value ?? null;
        setSelectedRowState(value);
    }, []);
    const getCurrentSelectedRowKey = ()=>{
        const row = selectedRowRef.current;
        if (!row) return null;
        const key = (0, $f3879d0f44faa78a$export$9eec69cddf174afd)(row);
        return key === "|" ? null : key;
    };
    const setMP4URLWithMeta = (value, sourceRow)=>{
        const nextUrl = typeof value === "function" ? value(mP4URL) : value;
        setMP4URL(value);
        if (!nextUrl) {
            videoMetaRef.current = null;
            return;
        }
        const row = sourceRow ?? selectedRowRef.current;
        videoMetaRef.current = {
            cameraPk: row?.camera_pk ?? null,
            rowKey: row ? (0, $f3879d0f44faa78a$export$9eec69cddf174afd)(row) : null
        };
    };
    const [page, setPage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    // Which selection AlertsTable last synced `page` to. Lives here, beside
    // `page`, because the table is unmounted during every background refresh.
    const alertsTablePageSyncedKeyRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const [selectdButtonsFilled, setSelectedButtonsFilled] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        true_threat: true,
        true_non_threat: true,
        false_positive: true,
        escalated_true_threat: true
    });
    const userTimezone = (0, $9a5c317778c381ce$export$96bb40b6f4974acf)();
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        selectedRowRef.current = selectedRow ?? null;
    }, [
        selectedRow
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        const initializeData = async ()=>{
            // if(
            //   end_date && !isCurrentDate(end_date)
            // ) {
            //   setRowsSortable(true);
            // }
            (0, $d48a20dfd96c3668$export$2361627156cf7f48)(setParentAccountsLoading, setParentAccounts, setParentIds, setParentNames, navigate);
            await fetchSharedMutes(navigate);
            if (group) {
                setLoadingSites(true);
                (0, $f116d278642eaee3$export$89cd944bf12efbec)(group, navigate, setSiteOptions, setLoadingSites, site ? $dfbb1eaa7354951b$var$parseNumberList(site) : [], setSiteDropDownValue);
            }
            if (site) (0, $86f1a0ab2c742656$export$a307f389749b22c4)([
                site
            ], navigate, setCameraOptions, setLoadingCameras, setCameraDropDownValue, camera ? $dfbb1eaa7354951b$var$parseNumberList(camera) : []);
        };
        initializeData();
    }, []);
    // Refresh the shared (fleet-wide) muted lists every 30 seconds (ENG-2103)
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        const interval = setInterval(()=>{
            fetchSharedMutes(navigate);
        }, 30000); // 30 seconds
        // Cleanup interval on component unmount
        return ()=>clearInterval(interval);
    }, [
        navigate
    ]);
    const [refreshingToken, setRefreshingToken] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [buttonClicked, setButtonClicked] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [fetchingFilteredData, setFetchingFilteredData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [seeMoreURL, setSeeMoreURL] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [mP4URL, setMP4URL] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [thumbnailVideos, setThumbnailVideos] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [dateOutsideRange, setDateOutsideRange] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [ignoreZoneDialogOpen, setIgnoreZoneDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [siteOptions, setSiteOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [cameraOptions, setCameraOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [notesDialogOpen, setNotesDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [noteText, setNoteText] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [videoClipLoading, setVideoClipLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [alertsToDisplay, setAlertsToDisplay] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [refreshingData, setRefreshingData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const useAsyncGeneration = !userFilters?.has_video;
    const { width: width } = (0, $crpct.default)();
    // Auto-collapse the nav once when the window is (or becomes) narrower than
    // the threshold. Only the crossing collapses it, so the user can re-expand
    // it afterwards; with `navBarCollapsed` in the deps, their expand click was
    // reverted on the next render (ENG-1663).
    const previousWidthRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        const previousWidth = previousWidthRef.current;
        previousWidthRef.current = width;
        if (width <= 0) return;
        const crossedBelowThreshold = previousWidth === null || previousWidth <= 0 || previousWidth >= (0, $c20b65e3c5a5154b$export$d535640177923c2e);
        if (width < (0, $c20b65e3c5a5154b$export$d535640177923c2e) && crossedBelowThreshold) setNavBarCollapsed(true);
    }, [
        width,
        setNavBarCollapsed
    ]);
    const [alertIndex, setAlertIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [timeFiltersDisabled, setTimeFiltersDisabled] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [loadingSites, setLoadingSites] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(group ? true : false);
    const [loadingCameras, setLoadingCameras] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(site ? true : false);
    const [selectedAlertCameraInfo, setSelectedAlertCameraInfo] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({});
    const [ignoreZonesSelectedAlert, setIgnoreZonesSelectedAlert] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [alertsIndexOrder, setAlertsIndexOrder] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [refreshInterval, setRefreshInterval] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(JSON.parse(localStorage.refresh_interval));
    const [currentName, setCurrentName] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(filter_type ? (0, $24253afce9c84c17$export$e4286fff6522e786)(filter_type) : "Unresolved Alerts");
    const [pageLoadedNumber, setPageLoadedNumber] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [parentAccounts, setParentAccounts] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [parentAccountsLoading, setParentAccountsLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [parentIds, setParentIds] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(new Map());
    const [parentNames, setParentNames] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(new Map());
    const [warningIssued, setWarningIssued] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [alertLabels, setAlertLabels] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([
        "All"
    ]);
    const [detectionType, setDetectionType] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(detection_type ? detection_type : "All");
    const [outcomeFilterType, setOutcomeFilterType] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("All");
    // Default to the working queue: everything except the likely false
    // positives (ENG-1756). Ignored entirely when showVlmFilters is off.
    const [vlmFilterType, setVlmFilterType] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("Filtered Queue");
    const [tableSort, setTableSort] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        order: "asc",
        orderBy: ""
    });
    const handleTableSortChange = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback((order, orderBy)=>{
        setTableSort((prev)=>prev.order === order && prev.orderBy === orderBy ? prev : {
                order: order,
                orderBy: orderBy
            });
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (showVlmFilters) setVlmFilterType("Filtered Queue");
    }, [
        showVlmFilters
    ]);
    (0, $30ce4f6d944a4dd5$export$7d5fecdcb1e02566)({
        fetchingFilteredData: fetchingFilteredData,
        detectionType: detectionType,
        outcomeFilterType: outcomeFilterType,
        setVlmFilterType: setVlmFilterType
    });
    const vlmSelectionSyncRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef({
        selectionKey: null,
        vlmFilterType: "All",
        showVlmFilters: false
    });
    const [periodHours, setPeriodHours] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(2);
    const [queryLimitHit, setQueryLimitHit] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [filtersApplied, setFiltersApplied] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [loadingIgnoreZonesInfo, setLoadingIgnoreZonesInfo] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [lineCrossingsDialogOpen, setLineCrossingsDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [lineCrossingsSelectedAlert, setLineCrossingsSelectedAlert] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [loadingLineCrossingsInfo, setLoadingLineCrossingsInfo] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [forwardArrowDisabled, setForwardArrowDisabled] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [backArrowDisabled, setBackArrowDisabled] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [showRefreshButton, setShowRefreshButton] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [, setVideoProcessing] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [partialVideoStatus, setPartialVideoStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [rowsSortable, setRowsSortable] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [alertsRefreshing, setAlertsRefreshing] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    // Detect temp/partial video URLs and set status accordingly
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (mP4URL && (0, $f3879d0f44faa78a$export$4a87c6b5ff8fd60d)(mP4URL)) setPartialVideoStatus("partial");
        else setPartialVideoStatus(null);
    }, [
        mP4URL
    ]);
    // SAFEGUARD: Validate that the current video URL matches the selected row.
    // If there's a mismatch (e.g., due to a race condition), clear the video URL.
    // This ensures we never display a video from a different alert than the one selected.
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (selectedRow) {
            const selectedRowKey = (0, $f3879d0f44faa78a$export$9eec69cddf174afd)(selectedRow);
            const currentSelectedRowKey = getCurrentSelectedRowKey();
            // If the selectedRow state and ref don't match, there might be a sync issue.
            // Clear the video URL to be safe and trigger a re-fetch.
            if (currentSelectedRowKey && selectedRowKey !== currentSelectedRowKey) {
                setMP4URLWithMeta("");
                setVideoClipLoading(true);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedRow
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!selectedRow) return;
        const selectedRowKey = (0, $f3879d0f44faa78a$export$9eec69cddf174afd)(selectedRow);
        const shouldRefetch = (0, $6251a0d926b9101e$export$6d5de491accea1ad)({
            selectedCameraPk: selectedRow.camera_pk,
            videoCameraPk: videoMetaRef.current?.cameraPk,
            selectedRowKey: selectedRowKey,
            videoRowKey: videoMetaRef.current?.rowKey,
            hasVideoUrl: Boolean(mP4URL),
            isLoading: videoClipLoading
        });
        const shouldRecoverStuckLoading = !mP4URL && videoClipLoading && !(0, $f3879d0f44faa78a$export$80b36d03fd557813)(selectedRowKey) && !(0, $f3879d0f44faa78a$export$36920e0f06e448e)(selectedRowKey);
        if (shouldRefetch || shouldRecoverStuckLoading) {
            setMP4URLWithMeta("");
            setVideoClipLoading(true);
            (0, $6b057cfee512ff1e$export$c5f684b415548de8)(selectedRow, navigate, setMP4URLWithMeta, setVideoClipLoading, setShowRefreshButton, true, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration);
        }
    }, [
        selectedRow,
        mP4URL,
        videoClipLoading,
        navigate,
        setShowRefreshButton
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useLayoutEffect(()=>{
        if (!selectedRow || !mP4URL || videoClipLoading) return;
        const selectedRowKey = (0, $f3879d0f44faa78a$export$9eec69cddf174afd)(selectedRow);
        const videoRowKey = videoMetaRef.current?.rowKey;
        if (!videoRowKey || selectedRowKey === videoRowKey) return;
        setMP4URLWithMeta("");
        setVideoClipLoading(true);
        (0, $6b057cfee512ff1e$export$c5f684b415548de8)(selectedRow, navigate, setMP4URLWithMeta, setVideoClipLoading, setShowRefreshButton, true, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration);
    }, [
        selectedRow,
        mP4URL,
        videoClipLoading,
        navigate,
        setShowRefreshButton,
        useAsyncGeneration
    ]);
    // Handler to check for updated video when user clicks the button
    const handleCheckForUpdatedVideo = ()=>{
        if (!selectedRow) return;
        setPartialVideoStatus("checking");
        const AxiosUI = (0, $hAnMZ.createMonitoringAPICall)(``);
        const cacheKey = (0, $f3879d0f44faa78a$export$9eec69cddf174afd)(selectedRow);
        // Generate a new request ID to track this specific request
        const requestId = (0, $f3879d0f44faa78a$export$c97510e344e07687)();
        // Capture the selected row's key at the time of the request
        const selectedRowKey = (0, $f3879d0f44faa78a$export$9eec69cddf174afd)(selectedRow);
        // Poll function to check for updated video
        const pollForUpdatedVideo = (pollUrl, retriesRemaining)=>{
            if (!(0, $f3879d0f44faa78a$export$d1cfaba9e8573694)(requestId)) return; // Request is stale
            setTimeout(()=>{
                AxiosUI.get(pollUrl).then((response)=>{
                    if (!(0, $f3879d0f44faa78a$export$d1cfaba9e8573694)(requestId)) return;
                    if (getCurrentSelectedRowKey() !== selectedRowKey) return;
                    if (typeof response.data === "string") {
                        // Got the new video URL
                        (0, $f3879d0f44faa78a$export$557be0ee92bfdc47)(cacheKey, response.data);
                        setMP4URLWithMeta(response.data);
                        setPartialVideoStatus("loading");
                        setTimeout(()=>{
                            setPartialVideoStatus((prev)=>prev === "loading" ? null : prev);
                        }, 2000);
                        return;
                    }
                    // Still processing — retry if we have retries left
                    if (response.data?.status === "processing" && retriesRemaining > 1) {
                        pollForUpdatedVideo(pollUrl, retriesRemaining - 1);
                        return;
                    }
                    setPartialVideoStatus("partial");
                }, (error)=>{
                    if (!(0, $f3879d0f44faa78a$export$d1cfaba9e8573694)(requestId)) return;
                    const status = error.response?.status;
                    if (status === 404 && retriesRemaining > 1) {
                        // Video not ready yet, keep polling
                        pollForUpdatedVideo(pollUrl, retriesRemaining - 1);
                        return;
                    }
                    // Retries exhausted or other error
                    setPartialVideoStatus("partial");
                });
            }, 500);
        };
        AxiosUI.get(`alert/clip/?approx_capture_timestamp=${selectedRow.approx_capture_timestamp}&window_id=${selectedRow.window_id}&async_generation=true&force_video=true`).then((response)=>{
            // CRITICAL: Validate that this request is still valid and the selected row hasn't changed.
            // This prevents showing video from a previously selected alert.
            if (!(0, $f3879d0f44faa78a$export$d1cfaba9e8573694)(requestId)) // Request is stale - user has selected a different row. Ignore this response.
            return;
            // Additional validation: check if the current selected row matches
            if (getCurrentSelectedRowKey() !== selectedRowKey) // Selected row has changed - ignore this response
            return;
            const responseData = response.data;
            if (responseData && typeof responseData === "object" && responseData.status === "processing") {
                // Got 202 - start polling for the new video
                const pollBaseUrl = `alert/video/?approx_capture_timestamp=${selectedRow.approx_capture_timestamp}&window_id=${selectedRow.window_id}&poll=true`;
                const pollUrl = responseData.poll_url ? responseData.poll_url.replace(/^\/?monitoring-api\//, "") : pollBaseUrl;
                pollForUpdatedVideo(pollUrl, 15); // Poll up to 15 times (7.5 seconds)
                return;
            }
            if (typeof responseData === "string") {
                // Got URL directly - update video and cache
                (0, $f3879d0f44faa78a$export$557be0ee92bfdc47)(cacheKey, responseData);
                setMP4URLWithMeta(responseData);
                setPartialVideoStatus("loading");
                setTimeout(()=>{
                    setPartialVideoStatus((prev)=>prev === "loading" ? null : prev);
                }, 2000);
            } else // Unexpected response
            setPartialVideoStatus("partial");
        }, ()=>{
            // On error, only update status if request is still valid
            if ((0, $f3879d0f44faa78a$export$d1cfaba9e8573694)(requestId)) setPartialVideoStatus("partial");
        });
    };
    const refreshText = /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9222626528c451ae$exports))), {
                fontSize: "small"
            }),
            "\xa0Try Refresh"
        ]
    });
    // Step to the previous / next alert in the filtered list. Shared by the
    // arrow-key shortcuts and the orange arrows beside the clip. Do not flip
    // refreshingData here: under React 17 a native listener's update is not
    // batched with the helper's own setRefreshingData(false), and the table
    // would unmount/remount (page + scroll reset) on every step.
    const goToPreviousAlert = ()=>{
        (0, $03de40ac258827c1$export$9bb28914c0b5a1d2)(selectedRow, setAlertIndex, setSelectedRow, alertData, navigate, setMP4URLWithMeta, setVideoClipLoading, setSelectedButtonsFilled, setSeeMoreURL, setAlertData, setRefreshingData, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, alertsIndexOrder, detectionType, outcomeFilterType, setBackArrowDisabled, setForwardArrowDisabled, setShowRefreshButton, (0, $94e6bb80767641a9$export$a2c9a5662351211)(userFilters.filter_type) ? mutedAlertSites : [], (0, $94e6bb80767641a9$export$a2c9a5662351211)(userFilters.filter_type) ? mutedAlertCameras : [], getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration, syncSelectedRowRef, showVlmFilters ? vlmFilterType : "All", userFilters.filter_type);
    };
    const goToNextAlert = ()=>{
        (0, $1476c118ed5e23cf$export$394358f75a9145d3)(selectedRow, setAlertIndex, setSelectedRow, alertData, navigate, setMP4URLWithMeta, setVideoClipLoading, setSelectedButtonsFilled, setSeeMoreURL, setAlertData, setRefreshingData, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, alertsIndexOrder, detectionType, outcomeFilterType, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, (0, $94e6bb80767641a9$export$a2c9a5662351211)(userFilters.filter_type) ? mutedAlertSites : [], (0, $94e6bb80767641a9$export$a2c9a5662351211)(userFilters.filter_type) ? mutedAlertCameras : [], getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration, syncSelectedRowRef, showVlmFilters ? vlmFilterType : "All", userFilters.filter_type);
    };
    // Keyboard shortcuts handler
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        const handleKeyDown = (event)=>{
            // Only handle shortcuts when video is loaded and not in a dialog
            if (!mP4URL || videoClipLoading || ignoreZoneDialogOpen || notesDialogOpen) return;
            switch(event.key){
                case "ArrowLeft":
                    if (!backArrowDisabled) {
                        event.preventDefault();
                        goToPreviousAlert();
                    }
                    break;
                case "ArrowRight":
                    if (!forwardArrowDisabled) {
                        event.preventDefault();
                        goToNextAlert();
                    }
                    break;
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        mP4URL,
        videoClipLoading,
        ignoreZoneDialogOpen,
        notesDialogOpen,
        backArrowDisabled,
        forwardArrowDisabled,
        selectedRow,
        alertData,
        navigate,
        alertsIndexOrder,
        detectionType,
        outcomeFilterType,
        showVlmFilters,
        vlmFilterType
    ]);
    const parsedSiteList = site ? $dfbb1eaa7354951b$var$parseNumberList(site) : [];
    const parseSiteListNames = [];
    const cameraIds = new Map();
    cameraOptions.forEach((object)=>{
        cameraIds.set(object.camera_name, object.id);
    });
    const siteIds = new Map();
    siteOptions.forEach((object)=>{
        siteIds.set(object.name, object.id);
    });
    const siteNames = new Map();
    parsedSiteList.forEach((object)=>{
        siteNames.set(object.id, object.name);
    });
    const [siteDropDownValue, setSiteDropDownValue] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [cameraDropDownValue, setCameraDropDownValue] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const setScrollTop = (event)=>{
        localStorage.setItem("aletsScrollTop", event.target.scrollTop);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (ref) {
            if (ref.current !== null) ref.current.scrollTop = localStorage.aletsScrollTop;
        }
    }, [
        alertData
    ]);
    const scrollToTop = ()=>{
        if (ref) {
            if (ref.current !== null) ref.current.scrollTop = 0;
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (Array.from(searchParams).length > 0) {
            localStorage.setItem("pageLoadedNumber", "0");
            setPageLoadedNumber(0);
            setPageLoading(true);
            if (start_date && end_date) {
                if (start_date === end_date) setTimeFiltersDisabled(false);
                else setTimeFiltersDisabled(true);
            }
            (0, $f4e2c8d6b10b3915$export$8239abe85d231080)(setAlertData, navigate, setSelectedRow, setPageLoading, setSeeMoreURL, setMP4URLWithMeta, userFilters, setThumbnailVideos, setDateOutsideRange, setVideoClipLoading, setAlertsToDisplay, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, setAlertsIndexOrder, setRefreshInterval, setFetchingFilteredData, setCurrentName, setPage, setSelectedButtonsFilled, setUserFilters, cameraOptions, siteOptions, setRefreshingData, 0, refreshInterval, setParentAccountsLoading, setParentAccounts, setParentIds, setParentNames, setRefreshingToken, refreshingToken, setAlertLabels, setPeriodHours, setFiltersApplied, setForwardArrowDisabled, setBackArrowDisabled, setShowRefreshButton, setRowsSortable, setAlertsRefreshing, getCurrentSelectedRowKey, mutedAlertSites, mutedAlertCameras, setVideoProcessing);
        }
    }, []);
    (0, $6e02db388b82b823$export$52961540270454ba)({
        detectionType: detectionType,
        outcomeFilterType: outcomeFilterType,
        vlmFilterType: vlmFilterType,
        showVlmFilters: showVlmFilters,
        mutedAlertSites: mutedAlertSites,
        mutedAlertCameras: mutedAlertCameras,
        filterType: userFilters?.filter_type,
        order: tableSort.order,
        orderBy: tableSort.orderBy
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        const navigationArgs = {
            alertData: alertData,
            detectionType: detectionType,
            outcomeFilterType: outcomeFilterType,
            vlmFilterType: vlmFilterType,
            showVlmFilters: showVlmFilters,
            mutedAlertSites: mutedAlertSites,
            mutedAlertCameras: mutedAlertCameras,
            filterType: userFilters?.filter_type,
            order: tableSort.order,
            orderBy: tableSort.orderBy
        };
        const filteredBeforeVlm = (0, $6e02db388b82b823$export$6ee189a072663b57)(navigationArgs);
        const filteredData = (0, $6e02db388b82b823$export$cdfae0e972447b21)(navigationArgs);
        // Use the ref to get the most current selected row value
        // This avoids stale closure issues when alertData updates trigger this effect
        const currentSelectedRow = getCurrentSelectedRow() ?? selectedRow;
        const selectionKey = currentSelectedRow ? `${currentSelectedRow.id ?? ""}|${currentSelectedRow.approx_capture_timestamp ?? ""}|${currentSelectedRow.window_id ?? ""}` : null;
        // Helper to find a row in filtered data by matching identifiers
        const findRowInFilteredData = (rowToFind)=>{
            if (!rowToFind) return null;
            return filteredData.find((row)=>row?.id && rowToFind?.id && row.id === rowToFind.id || row.approx_capture_timestamp === rowToFind.approx_capture_timestamp && row.window_id === rowToFind.window_id);
        };
        // If we have no current selection but filteredData has items, select the first one
        if (!currentSelectedRow && filteredData.length > 0) {
            (0, $988d77d60168e773$export$2fd5d64b4d451d7b)(filteredData[0], alertData, setAlertData, setSelectedButtonsFilled, setSeeMoreURL, navigate, setMP4URLWithMeta, setVideoClipLoading, setSelectedRow, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, refreshingToken, filteredData, setBackArrowDisabled, setForwardArrowDisabled, setShowRefreshButton, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration, syncSelectedRowRef);
            const firstArrows = (0, $6e02db388b82b823$export$c18f05524cab3606)(0, filteredData.length);
            setBackArrowDisabled(firstArrows.backDisabled);
            setForwardArrowDisabled(firstArrows.forwardDisabled);
            return;
        }
        // Check if the current selected row is still in the filtered data
        if (currentSelectedRow) {
            const selectedRowInFilteredData = findRowInFilteredData(currentSelectedRow);
            if (!selectedRowInFilteredData) {
                // Current selection not found in new data - fall back to localStorage or first row
                const getStoredSelectedRow = ()=>{
                    try {
                        if (localStorage.selectedRowAlerts && localStorage.selectedRowAlerts !== "undefined") return JSON.parse(localStorage.selectedRowAlerts);
                    } catch (error) {
                        return null;
                    }
                    return null;
                };
                const storedSelectedRow = getStoredSelectedRow();
                const storedSelectedRowMatch = findRowInFilteredData(storedSelectedRow);
                const hiddenByVlmFilter = showVlmFilters && vlmFilterType !== "All" && filteredBeforeVlm.some((row)=>row?.id && currentSelectedRow?.id && row.id === currentSelectedRow.id || row.approx_capture_timestamp === currentSelectedRow.approx_capture_timestamp && row.window_id === currentSelectedRow.window_id);
                const outsideVlmFilterAction = hiddenByVlmFilter ? (0, $biDrR.resolveSelectionOutsideVlmFilter)({
                    selectionChanged: vlmSelectionSyncRef.current.selectionKey !== selectionKey,
                    filterChanged: vlmSelectionSyncRef.current.vlmFilterType !== vlmFilterType || vlmSelectionSyncRef.current.showVlmFilters !== showVlmFilters,
                    filteredCount: filteredData.length
                }) : "keep";
                if (outsideVlmFilterAction === "select-first") {
                    // Nobody picked this alert on purpose (page load, flag flip, tile
                    // click, programmatic selection): go to the first one in the queue
                    // rather than show an alert the table does not contain (ENG-1756).
                    (0, $988d77d60168e773$export$2fd5d64b4d451d7b)(filteredData[0], alertData, setAlertData, setSelectedButtonsFilled, setSeeMoreURL, navigate, setMP4URLWithMeta, setVideoClipLoading, setSelectedRow, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, refreshingToken, filteredData, setBackArrowDisabled, setForwardArrowDisabled, setShowRefreshButton, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration, syncSelectedRowRef);
                    const firstArrows = (0, $6e02db388b82b823$export$c18f05524cab3606)(0, filteredData.length);
                    setBackArrowDisabled(firstArrows.backDisabled);
                    setForwardArrowDisabled(firstArrows.forwardDisabled);
                } else {
                    // Preserve the user's current selection instead of auto-jumping to
                    // another row when refresh/filtering temporarily excludes it. When it
                    // was a DoubleTake verdict that moved it out of the queue mid-review,
                    // "next" still carries on into the queue (handleForwardButtonClick).
                    setBackArrowDisabled(true);
                    setForwardArrowDisabled(outsideVlmFilterAction !== "keep-and-allow-forward");
                }
            } else {
                // Current selection IS in filtered data - just update arrow states
                const selectedRowIndex = filteredData.findIndex((row)=>row?.id && currentSelectedRow?.id && row.id === currentSelectedRow.id || row.approx_capture_timestamp === currentSelectedRow.approx_capture_timestamp && row.window_id === currentSelectedRow.window_id);
                const arrows = (0, $6e02db388b82b823$export$c18f05524cab3606)(selectedRowIndex, filteredData.length);
                setBackArrowDisabled(arrows.backDisabled);
                setForwardArrowDisabled(arrows.forwardDisabled);
            }
        }
        // What this run saw, so the next one can tell "the data moved under the
        // operator" from "the selection or the DoubleTake filter changed".
        vlmSelectionSyncRef.current = {
            selectionKey: selectionKey,
            vlmFilterType: vlmFilterType,
            showVlmFilters: showVlmFilters
        };
    }, [
        alertData,
        detectionType,
        outcomeFilterType,
        showVlmFilters,
        vlmFilterType,
        selectedRow,
        mutedAlertSites,
        mutedAlertCameras,
        userFilters?.filter_type,
        tableSort
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setSiteNotes("");
        if (selectedRow?.customer_pk) getSiteNotes(selectedRow.customer_pk, navigate);
        if (selectedRow?.camera_pk) getCameraNotes(selectedRow.camera_pk, navigate);
    }, [
        selectedRow
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        (0, $5a19cf5e0e4098f6$export$1a2d5fe7be2083ce)(selectedRow, mutedAlertSites, mutedAlertCameras, setSelectedRowIsMuted);
    }, [
        selectedRow,
        mutedAlertSites,
        mutedAlertCameras,
        setSelectedRowIsMuted
    ]);
    const selectedRowKeyForRender = selectedRow ? (0, $f3879d0f44faa78a$export$9eec69cddf174afd)(selectedRow) : null;
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setShowIgnoreZoneOverlay(false);
        setShowLineCrossingOverlay(false);
        // The overlay toggle only refetches when this is empty; without the reset
        // the previous alert's camera lines were drawn over the new alert's clip
        // (ignore zones are already reset per row in handleRowSelected).
        setLineCrossingsSelectedAlert([]);
    }, [
        selectedRowKeyForRender
    ]);
    const canShowLineCrossings = Boolean(showLineCrossings) && (0, $36f1c5bc563bba72$export$86882abe7c214037)(selectedRow?.alert_labels);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!canShowLineCrossings) setShowLineCrossingOverlay(false);
    }, [
        canShowLineCrossings
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useLayoutEffect(()=>{
        const node = detailPaneRef.current;
        if (!node) return undefined;
        const updateWidth = ()=>{
            setDetailPaneWidth(Math.floor(node.clientWidth));
        };
        updateWidth();
        const observer = new ResizeObserver(updateWidth);
        observer.observe(node);
        return ()=>observer.disconnect();
    }, [
        seeMoreURL,
        alertsToDisplay,
        selectedRowKeyForRender
    ]);
    const hasStaleVideoForCurrentSelection = Boolean(mP4URL) && Boolean(selectedRowKeyForRender) && Boolean(videoMetaRef.current?.rowKey) && selectedRowKeyForRender !== videoMetaRef.current?.rowKey;
    const showFetchingVideoOverlay = hasStaleVideoForCurrentSelection || videoClipLoading && !mP4URL;
    const hasVlmClassificationForSelectedRow = !!selectedRow && (0, $biDrR.hasAlertVlmClassification)(selectedRow);
    const liveStreamCameraId = selectedRow?.camera_pk != null ? String(selectedRow.camera_pk) : null;
    // ENG-2135: undefined until the site's about/ has loaded (getSiteNotes);
    // the talk-down control stays hidden until then.
    const selectedSiteIntegrationType = selectedRow?.customer_pk != null ? siteIntegrationTypes[String(selectedRow.customer_pk)] : undefined;
    // Per-alert gate: hide the Live Stream / Split View tabs and the video wall
    // for alerts whose site has live streaming off — the mint would only 403.
    // When no alert in the current filter can stream, nothing live is offered.
    const liveStreamingAvailable = showLiveStreaming && (0, $c81fb78bce1907ac$export$9ad94dfd18e4b176)(selectedRow);
    const isSplitView = liveStreamingAvailable && viewMode === "split";
    const showClipPanel = !liveStreamingAvailable || viewMode === "clip" || viewMode === "split";
    const showLivePanel = liveStreamingAvailable && (viewMode === "live" || viewMode === "split");
    const navBarOffset = navBarCollapsed ? 75 : 150;
    const pageWidth = (0, $c20b65e3c5a5154b$export$9692675834824848)(width);
    const contentAreaWidth = Math.max(0, pageWidth - navBarOffset - 32);
    const workspaceWidth = Math.max(0, pageWidth - navBarOffset);
    const tableDensity = (0, $c20b65e3c5a5154b$export$680d987d6cc59363)({
        workspaceWidth: workspaceWidth,
        pinnedMode: pinnedDensity
    });
    const tableFraction = tableDensity === "condensed" ? 0.35 : 11 / 24;
    const videoColumnWidth = contentAreaWidth * (1 - tableFraction);
    // Side slots for the orange prev/next arrows (ENG-2070). Equal gutters on
    // both sides of the clip; the arrows are flex-centered inside each slot.
    const availableVideoWidth = Math.max((0, $5ca90d495b313c72$export$ba9700a38b3eed0a) + $dfbb1eaa7354951b$var$ALERT_NAV_ARROW_GUTTER_PX * 2, detailPaneWidth || Math.floor(videoColumnWidth - 24));
    const arrowGutterWidth = $dfbb1eaa7354951b$var$ALERT_NAV_ARROW_GUTTER_PX;
    const videoContentWidth = Math.max((0, $5ca90d495b313c72$export$ba9700a38b3eed0a), availableVideoWidth - arrowGutterWidth * 2);
    const videoLayoutWidth = videoContentWidth + arrowGutterWidth * 2;
    const videoContentHeight = videoPanelHeight ?? Math.round(videoContentWidth * (0, $5ca90d495b313c72$export$75369d05e87cce05) / (0, $5ca90d495b313c72$export$f7d2ba1270db97c7));
    const videoPanelArrowTopPx = (0, $5ca90d495b313c72$export$1860282aae834e25)(videoContentHeight);
    const splitPaneWidth = isSplitView ? (0, $5ca90d495b313c72$export$78c5fa173e03e8e0)(videoContentWidth) : videoContentWidth;
    const clipPanelWidth = isSplitView ? splitPaneWidth : videoContentWidth;
    const livePanelWidth = isSplitView ? splitPaneWidth : videoContentWidth;
    const canDownloadVideo = Boolean(mP4URL) && !videoClipLoading && !hasStaleVideoForCurrentSelection && partialVideoStatus !== "partial" && partialVideoStatus !== "checking";
    const canShowSiteVideoWall = liveStreamingAvailable && Boolean(selectedRow?.customer_pk);
    const showAlertDetailPane = (0, $c20b65e3c5a5154b$export$34acb5eada330508)({
        seeMoreURL: seeMoreURL,
        alertsToDisplay: alertsToDisplay,
        selectedRow: selectedRow
    });
    const showApplyFiltersPrompt = (0, $c20b65e3c5a5154b$export$b7cc65953b4c577b)({
        pageLoading: pageLoading,
        filtersApplied: filtersApplied
    });
    const alertsGridTemplateColumns = (0, $c20b65e3c5a5154b$export$1058c2bab79df168)(tableDensity);
    const handleDensityChange = (mode)=>{
        (0, $c20b65e3c5a5154b$export$1fca0425b779c0fa)(mode);
        setPinnedDensity(mode);
    };
    const handleDownloadVideo = ()=>{
        if (mP4URL) (0, $iIAML.saveAs)(mP4URL, "video.mp4");
    };
    const handleOpenIgnoreZones = ()=>{
        setLoadingIgnoreZonesInfo(true);
        (0, $48eee419f07e2823$export$e97f54758ce8c671)(selectedRow, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, setLoadingIgnoreZonesInfo, navigate);
        setIgnoreZoneDialogOpen(true);
    };
    const handleOpenLineCrossings = ()=>{
        setLoadingLineCrossingsInfo(true);
        (0, $515f0dbc25108112$export$7f758f5babb89955)(selectedRow, setSelectedAlertCameraInfo, setLineCrossingsSelectedAlert, setLoadingLineCrossingsInfo, navigate);
        setLineCrossingsDialogOpen(true);
    };
    const handleToggleIgnoreZoneOverlay = ()=>{
        const next = !showIgnoreZoneOverlay;
        setShowIgnoreZoneOverlay(next);
        if (next && selectedRow && (!ignoreZonesSelectedAlert || ignoreZonesSelectedAlert.length === 0)) (0, $48eee419f07e2823$export$e97f54758ce8c671)(selectedRow, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, setLoadingIgnoreZonesInfo, navigate);
    };
    const handleToggleLineCrossingOverlay = ()=>{
        const next = !showLineCrossingOverlay;
        setShowLineCrossingOverlay(next);
        if (next && selectedRow && (!lineCrossingsSelectedAlert || lineCrossingsSelectedAlert.length === 0)) (0, $515f0dbc25108112$export$7f758f5babb89955)(selectedRow, setSelectedAlertCameraInfo, setLineCrossingsSelectedAlert, setLoadingLineCrossingsInfo, navigate);
    };
    const alertsContentMarginClass = navBarCollapsed ? "ml-[75px]" : "ml-[150px]";
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            selectedRow && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8baed87f3c759bf6$export$132e12ea55142936), {
                notesDialogOpen: notesDialogOpen,
                setNotesDialogOpen: setNotesDialogOpen,
                selectedRow: selectedRow,
                noteText: noteText,
                setNoteText: setNoteText,
                alertData: alertData,
                setAlertData: setAlertData,
                setSelectedRow: setSelectedRow,
                navigate: navigate
            }),
            mutedAlertsDialogOpen && viewAlertMuting && /*#__PURE__*/ (0, $k4ank.jsx)((0, $0b93534abfa1b2dc$export$55589e37db492f67), {
                selectedRow: selectedRow,
                navigate: navigate
            }),
            seeMutedSiteAndCamerasDialogOpen && viewAlertMuting && /*#__PURE__*/ (0, $k4ank.jsx)((0, $0a0cb6ffc5ad760e$export$5e17d2ea5ebc0db0), {}),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                open: ignoreZoneDialogOpen,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                        "aria-label": "close",
                        onClick: ()=>{
                            setIgnoreZoneDialogOpen(false);
                        },
                        sx: {
                            position: "absolute",
                            right: 8,
                            top: 8,
                            zIndex: 2,
                            color: (theme)=>theme.palette.grey[500]
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $7c6f6acc5b8af98d$export$b96b13a0906ff111), {
                            selectedAlertCameraInfo: selectedAlertCameraInfo,
                            ignoreZonesSelectedAlert: ignoreZonesSelectedAlert,
                            loadingIgnoreZonesInfo: loadingIgnoreZonesInfo
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                open: lineCrossingsDialogOpen,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                        "aria-label": "close",
                        onClick: ()=>{
                            setLineCrossingsDialogOpen(false);
                        },
                        sx: {
                            position: "absolute",
                            right: 8,
                            top: 8,
                            zIndex: 2,
                            color: (theme)=>theme.palette.grey[500]
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $57f9dbe81a9427b6$export$b652cc54385516b), {
                            selectedAlertCameraInfo: selectedAlertCameraInfo,
                            lineCrossingsSelectedAlert: lineCrossingsSelectedAlert,
                            loadingLineCrossingsInfo: loadingLineCrossingsInfo
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $444cc57251e01c92$export$666c1e0066ebe8f0), {}),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                openState: fetchingFilteredData
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                openState: buttonClicked
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                openState: pageLoading
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "absolute inset-0 overflow-x-auto overflow-y-hidden bg-actuate-grey",
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "relative flex h-full min-h-0 w-full flex-col font-mulish",
                    style: {
                        minWidth: (0, $c20b65e3c5a5154b$export$7ecdc8972c71c558)
                    },
                    children: [
                        showApplyFiltersPrompt && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: `pointer-events-none absolute top-[200px] left-0 right-0 z-10 ${alertsContentMarginClass} pr-4`,
                            children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "text-center font-mulish text-[22px] text-actuate-blue",
                                children: "Please Apply Filters to view alerts."
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: `shrink-0 ${alertsContentMarginClass} pr-4`,
                            children: [
                                muteAlertsError && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                                    severity: "error",
                                    onClose: ()=>{
                                        setMuteAlertsError("");
                                    },
                                    children: muteAlertsError
                                }),
                                alertState.siteMutedSuccess && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3QMQN.default), {
                                    severity: "success",
                                    onClose: ()=>{
                                        setAlertState({
                                            cameraMutedSuccess: false,
                                            siteMutedSuccess: false
                                        });
                                    },
                                    children: [
                                        "Alert delivery for site ",
                                        mutedAlertInfo.siteName,
                                        " muted for all operators until",
                                        " ",
                                        (0, $0a0cb6ffc5ad760e$export$ab060d6e82607889)(mutedAlertInfo.alertEndTime, userTimezone),
                                        "."
                                    ]
                                }),
                                alertState.cameraMutedSuccess && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3QMQN.default), {
                                    severity: "success",
                                    onClose: ()=>{
                                        setAlertState({
                                            cameraMutedSuccess: false,
                                            siteMutedSuccess: false
                                        });
                                    },
                                    children: [
                                        "Alert delivery for camera ",
                                        mutedAlertInfo.cameraName,
                                        " from site",
                                        " ",
                                        mutedAlertInfo.siteName,
                                        " muted for all operators until",
                                        " ",
                                        (0, $0a0cb6ffc5ad760e$export$ab060d6e82607889)(mutedAlertInfo.alertEndTime, userTimezone),
                                        "."
                                    ]
                                }),
                                dateOutsideRange && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                                    severity: "warning",
                                    onClose: ()=>{
                                        setDateOutsideRange(false);
                                    },
                                    children: "Alerts with dates outside of selected range are displayed."
                                }),
                                queryLimitHit && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                                    severity: "warning",
                                    onClose: ()=>{
                                        setQueryLimitHit(false);
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "font-mulish font-bold text-[16px]",
                                        children: "The selected parent group is too large. Only the 100 most recent alerts are displayed. Please select a specific site to view the accurate number of alerts."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "w-full shrink-0 bg-white",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: alertsContentMarginClass,
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $bc72e6eb2c6a3f8c$export$c40d95d7bc60a58), {
                                    navBarCollapsed: navBarCollapsed,
                                    userFilters: userFilters,
                                    setUserFilters: setUserFilters,
                                    navigate: navigate,
                                    setSiteOptions: setSiteOptions,
                                    setSiteDropDownValue: setSiteDropDownValue,
                                    setCameraOptions: setCameraOptions,
                                    setCameraDropDownValue: setCameraDropDownValue,
                                    setLoadingSites: setLoadingSites,
                                    setRefreshInterval: setRefreshInterval,
                                    parentAccounts: parentAccounts,
                                    parentIds: parentIds,
                                    parentAccountsLoading: parentAccountsLoading,
                                    siteOptions: siteOptions,
                                    siteDropDownValue: siteDropDownValue,
                                    loadingSites: loadingSites,
                                    setLoadingCameras: setLoadingCameras,
                                    cameraOptions: cameraOptions,
                                    cameraDropDownValue: cameraDropDownValue,
                                    loadingCameras: loadingCameras,
                                    setFetchingFilteredData: setFetchingFilteredData,
                                    setAlertData: setAlertData,
                                    setSelectedRow: setSelectedRow,
                                    setSeeMoreURL: setSeeMoreURL,
                                    setMP4URL: setMP4URLWithMeta,
                                    setSelectedButtonsFilled: setSelectedButtonsFilled,
                                    setThumbnailVideos: setThumbnailVideos,
                                    setDateOutsideRange: setDateOutsideRange,
                                    setPage: setPage,
                                    setVideoClipLoading: setVideoClipLoading,
                                    setAlertsToDisplay: setAlertsToDisplay,
                                    setPageLoading: setPageLoading,
                                    setTimeFiltersDisabled: setTimeFiltersDisabled,
                                    warningIssued: warningIssued,
                                    setWarningIssued: setWarningIssued,
                                    timeFiltersDisabled: timeFiltersDisabled,
                                    setFiltersApplied: setFiltersApplied,
                                    pageLoadedNumber: pageLoadedNumber,
                                    setPageLoadedNumber: setPageLoadedNumber,
                                    searchParams: searchParams,
                                    setSearchParams: setSearchParams,
                                    detectionType: detectionType,
                                    setDetectionType: setDetectionType,
                                    setSelectedAlertCameraInfo: setSelectedAlertCameraInfo,
                                    setIgnoreZonesSelectedAlert: setIgnoreZonesSelectedAlert,
                                    setAlertsIndexOrder: setAlertsIndexOrder,
                                    setCurrentName: setCurrentName,
                                    setRefreshingData: setRefreshingData,
                                    setRefreshingToken: setRefreshingToken,
                                    refreshingToken: refreshingToken,
                                    setAlertLabels: setAlertLabels,
                                    setPeriodHours: setPeriodHours,
                                    setQueryLimitHit: setQueryLimitHit,
                                    refreshInterval: refreshInterval,
                                    setOutcomeFilterType: setOutcomeFilterType,
                                    setForwardArrowDisabled: setForwardArrowDisabled,
                                    setBackArrowDisabled: setBackArrowDisabled,
                                    setShowRefreshButton: setShowRefreshButton,
                                    setRowsSortable: setRowsSortable,
                                    setAlertsRefreshing: setAlertsRefreshing,
                                    getCurrentSelectedRowKey: getCurrentSelectedRowKey,
                                    setVideoProcessing: setVideoProcessing
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: `relative min-h-0 w-auto max-w-full flex-1 ${alertsContentMarginClass} pr-4`,
                            children: filtersApplied && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "grid h-full min-h-0",
                                style: {
                                    display: "grid",
                                    gridTemplateColumns: showAlertDetailPane ? alertsGridTemplateColumns : "1fr",
                                    columnGap: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "relative flex h-full min-h-0 min-w-0 flex-col overflow-hidden pt-[10px] pb-2",
                                        children: !pageLoading && /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                                            children: !fetchingFilteredData && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                className: "flex min-h-0 flex-1 flex-col",
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                    className: "min-h-0 flex-1",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $e9636137eea334cc$export$90d89a9276091a91), {
                                                        fillAvailableHeight: true,
                                                        selected: selected,
                                                        alertData: alertData,
                                                        setAlertData: setAlertData,
                                                        setSelected: setSelected,
                                                        selectedRow: selectedRow,
                                                        setSelectedRow: setSelectedRow,
                                                        setSelectedButtonsFilled: setSelectedButtonsFilled,
                                                        setSeeMoreURL: setSeeMoreURL,
                                                        navigate: navigate,
                                                        setMP4URL: setMP4URLWithMeta,
                                                        page: page,
                                                        setPage: setPage,
                                                        pageSyncedKeyRef: alertsTablePageSyncedKeyRef,
                                                        userFilters: userFilters,
                                                        setFetchingFilteredData: setFetchingFilteredData,
                                                        setUserFilters: setUserFilters,
                                                        setThumbnailVideos: setThumbnailVideos,
                                                        setDateOutsideRange: setDateOutsideRange,
                                                        setVideoClipLoading: setVideoClipLoading,
                                                        setAlertsToDisplay: setAlertsToDisplay,
                                                        setPageLoading: setPageLoading,
                                                        setSelectedAlertCameraInfo: setSelectedAlertCameraInfo,
                                                        setIgnoreZonesSelectedAlert: setIgnoreZonesSelectedAlert,
                                                        setAlertsIndexOrder: setAlertsIndexOrder,
                                                        setRefreshInterval: setRefreshInterval,
                                                        currentName: currentName,
                                                        setCurrentName: setCurrentName,
                                                        pageLoadedNumber: pageLoadedNumber,
                                                        setPageLoadedNumber: setPageLoadedNumber,
                                                        setRefreshingData: setRefreshingData,
                                                        cameraOptions: cameraOptions,
                                                        siteOptions: siteOptions,
                                                        scrollToTop: scrollToTop,
                                                        refreshingToken: refreshingToken,
                                                        setRefreshingToken: setRefreshingToken,
                                                        setAlertLabels: setAlertLabels,
                                                        alertLabels: alertLabels,
                                                        detectionType: detectionType,
                                                        setDetectionType: setDetectionType,
                                                        setPeriodHours: setPeriodHours,
                                                        setQueryLimitHit: setQueryLimitHit,
                                                        searchParams: searchParams,
                                                        setSearchParams: setSearchParams,
                                                        refreshInterval: refreshInterval,
                                                        outcomeFilterType: outcomeFilterType,
                                                        setOutcomeFilterType: setOutcomeFilterType,
                                                        setBackArrowDisabled: setBackArrowDisabled,
                                                        setForwardArrowDisabled: setForwardArrowDisabled,
                                                        setShowRefreshButton: setShowRefreshButton,
                                                        setRowsSortable: setRowsSortable,
                                                        rowsSortable: rowsSortable,
                                                        setAlertsRefreshing: setAlertsRefreshing,
                                                        alertsRefreshing: alertsRefreshing,
                                                        getCurrentSelectedRowKey: getCurrentSelectedRowKey,
                                                        setVideoProcessing: setVideoProcessing,
                                                        useAsyncGeneration: useAsyncGeneration,
                                                        setSelectedRowRef: syncSelectedRowRef,
                                                        vlmFilterType: vlmFilterType,
                                                        setVlmFilterType: setVlmFilterType,
                                                        tableDensity: tableDensity,
                                                        onDensityChange: handleDensityChange,
                                                        periodHours: periodHours,
                                                        filtersApplied: filtersApplied,
                                                        parentAccounts: parentAccounts,
                                                        onTableSortChange: handleTableSortChange
                                                    })
                                                })
                                            })
                                        })
                                    }),
                                    showAlertDetailPane && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        ref: ref,
                                        className: (0, $d6220914811f5775$export$fe17bacbe54340a2),
                                        onScroll: setScrollTop,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4reBM.default), {
                                            className: "flex w-full flex-col font-mulish",
                                            sx: {
                                                p: 1.5,
                                                minHeight: "100%"
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                ref: detailPaneRef,
                                                className: "flex w-full min-w-0 grow flex-col",
                                                children: [
                                                    seeMoreURL && alertsToDisplay && selectedRow && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $9a906dc34b9865aa$export$da3753097ed14b63), {
                                                                    siteName: selectedRow.display_name || selectedRow.customer_name || "",
                                                                    cameraName: selectedRow.camera_name || "",
                                                                    siteHref: selectedRow.customer_pk ? `/sites/aboutsite/${selectedRow.customer_pk}` : undefined,
                                                                    cameraHref: selectedRow.customer_pk && selectedRow.camera_pk ? `/sites/${selectedRow.customer_pk}/editcamera/${selectedRow.camera_pk}` : undefined,
                                                                    alertLabels: selectedRow.alert_labels,
                                                                    siteTime: selectedRow.formatted_date || "",
                                                                    seeMoreURL: seeMoreURL,
                                                                    canMute: Boolean(viewAlertMuting),
                                                                    isMuted: Boolean(selectedRowIsMuted),
                                                                    onMute: ()=>setMutedAlertsDialogOpen(true),
                                                                    onDownloadVideo: handleDownloadVideo,
                                                                    canDownloadVideo: canDownloadVideo,
                                                                    onSiteVideoWall: ()=>setSiteWallMiniOpen(true),
                                                                    canShowSiteVideoWall: canShowSiteVideoWall,
                                                                    onSeeIgnoreZones: handleOpenIgnoreZones,
                                                                    onSeeLineCrossings: handleOpenLineCrossings,
                                                                    showLineCrossings: canShowLineCrossings
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                className: "mt-2",
                                                                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                    className: "grid items-start",
                                                                    style: {
                                                                        width: videoLayoutWidth,
                                                                        gridTemplateColumns: `${arrowGutterWidth}px ${videoContentWidth}px ${arrowGutterWidth}px`
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                            className: "flex justify-center pr-[10px]",
                                                                            style: {
                                                                                paddingTop: videoPanelArrowTopPx
                                                                            },
                                                                            id: "arrow_back",
                                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                                                onClick: goToPreviousAlert,
                                                                                text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8171e8cad3c7deee$exports))), {
                                                                                    id: "backButton",
                                                                                    sx: $dfbb1eaa7354951b$var$ALERT_NAV_ARROW_ICON_SX
                                                                                }),
                                                                                disabled: backArrowDisabled,
                                                                                sx: $dfbb1eaa7354951b$var$ALERT_NAV_ARROW_BUTTON_SX
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                            className: "relative min-w-0",
                                                                            id: "video",
                                                                            children: [
                                                                                liveStreamingAvailable && /*#__PURE__*/ (0, $k4ank.jsx)((0, $bfc547cd541f8a8d$export$258f1fab2757b534), {
                                                                                    viewMode: viewMode,
                                                                                    onViewModeChange: setViewMode,
                                                                                    streamProtocol: streamProtocol,
                                                                                    onStreamProtocolChange: setStreamProtocol,
                                                                                    showStreamProtocolSelector: userPermissions.super_user,
                                                                                    width: videoContentWidth,
                                                                                    talkDownCameraId: liveStreamCameraId,
                                                                                    talkDownCameraName: selectedRow?.camera_name || "",
                                                                                    talkDownIntegrationTypeName: selectedSiteIntegrationType,
                                                                                    talkDownCapable: selectedRow?.talk_down_capable,
                                                                                    talkDownParentGroupId: userFilters.parent_group,
                                                                                    talkDownSiteId: selectedRow?.customer_pk,
                                                                                    talkDownSiteName: selectedRow?.display_name || selectedRow?.customer_name || ""
                                                                                }),
                                                                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                                    className: "w-full",
                                                                                    style: {
                                                                                        width: videoContentWidth
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                                            className: "relative w-full",
                                                                                            style: {
                                                                                                width: videoContentWidth
                                                                                            },
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                                                    className: "relative mb-4",
                                                                                                    style: {
                                                                                                        width: videoContentWidth,
                                                                                                        height: videoContentHeight
                                                                                                    },
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                                                            className: "pointer-events-none absolute bottom-0 left-1/2 z-20 -translate-x-1/2 translate-y-1/2",
                                                                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                                                                className: "pointer-events-auto",
                                                                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $5ca90d495b313c72$export$84850014cec2e9df), {
                                                                                                                    height: videoContentHeight,
                                                                                                                    onHeightChange: setVideoPanelHeight
                                                                                                                })
                                                                                                            })
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                                                            className: isSplitView ? "grid grid-cols-2 gap-[2px]" : "",
                                                                                                            style: {
                                                                                                                width: videoContentWidth,
                                                                                                                height: videoContentHeight
                                                                                                            },
                                                                                                            children: [
                                                                                                                showClipPanel && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                                                                    className: "relative",
                                                                                                                    style: {
                                                                                                                        width: clipPanelWidth
                                                                                                                    },
                                                                                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                                                                        style: {
                                                                                                                            width: clipPanelWidth,
                                                                                                                            height: videoContentHeight
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            showVlmFilters && hasVlmClassificationForSelectedRow && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                                                                                className: "absolute right-[10px] top-[10px] z-10",
                                                                                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                                                                                    className: "rounded-md border border-white/25 bg-black/65 px-[10px] py-[5px] font-mulish text-[11px] font-bold uppercase tracking-[0.08em] shadow-sm backdrop-blur-[1px]",
                                                                                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                                                                                                        style: {
                                                                                                                                            color: (0, $e46e67fbb04d9482$export$a076d3f93826af8f)(selectedRow)
                                                                                                                                        },
                                                                                                                                        children: "DOUBLETAKE"
                                                                                                                                    })
                                                                                                                                })
                                                                                                                            }),
                                                                                                                            showFetchingVideoOverlay ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                                                                                className: "flex flex-col items-center justify-center bg-black",
                                                                                                                                style: {
                                                                                                                                    width: clipPanelWidth,
                                                                                                                                    height: videoContentHeight
                                                                                                                                },
                                                                                                                                children: [
                                                                                                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                                                                                                                                        theme: $dfbb1eaa7354951b$var$theme,
                                                                                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                                                                                                                            color: "primary"
                                                                                                                                        })
                                                                                                                                    }),
                                                                                                                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                                                                                                        className: "font-mulish text-[20px] text-white mt-4",
                                                                                                                                        children: "Fetching Video..."
                                                                                                                                    })
                                                                                                                                ]
                                                                                                                            }) : !mP4URL ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                                                                                className: "flex flex-col items-center justify-center bg-black",
                                                                                                                                style: {
                                                                                                                                    width: clipPanelWidth,
                                                                                                                                    height: videoContentHeight
                                                                                                                                },
                                                                                                                                children: [
                                                                                                                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                                                                                                        className: "font-mulish text-[20px] text-white text-center",
                                                                                                                                        children: "Video not available yet."
                                                                                                                                    }),
                                                                                                                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                                                                                                        className: "font-mulish text-[20px] text-white text-center",
                                                                                                                                        children: "Use Try Refresh to check again."
                                                                                                                                    }),
                                                                                                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                                                                                        className: "mt-4",
                                                                                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                                                                                                            onClick: ()=>{
                                                                                                                                                (0, $988d77d60168e773$export$2fd5d64b4d451d7b)(getCurrentSelectedRow(), alertData, setAlertData, setSelectedButtonsFilled, setSeeMoreURL, navigate, setMP4URLWithMeta, setVideoClipLoading, setSelectedRow, setSelectedAlertCameraInfo, setIgnoreZonesSelectedAlert, refreshingToken, alertData, setBackArrowDisabled, setForwardArrowDisabled, setShowRefreshButton, getCurrentSelectedRowKey, setVideoProcessing, useAsyncGeneration, syncSelectedRowRef);
                                                                                                                                            },
                                                                                                                                            text: refreshText,
                                                                                                                                            disabled: false
                                                                                                                                        })
                                                                                                                                    })
                                                                                                                                ]
                                                                                                                            }) : /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                                                                                className: isSplitView ? "pb-[10px]" : "",
                                                                                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $5b0f4cdaaaa7c62e$export$e174bedc18cda727), {
                                                                                                                                    src: mP4URL,
                                                                                                                                    width: clipPanelWidth,
                                                                                                                                    height: videoContentHeight,
                                                                                                                                    videoKey: `${(0, $f3879d0f44faa78a$export$9eec69cddf174afd)(selectedRow)}-${mP4URL}`,
                                                                                                                                    approxCaptureTimestamp: selectedRow.approx_capture_timestamp,
                                                                                                                                    ignoreZones: ignoreZonesSelectedAlert || [],
                                                                                                                                    lineCrossings: lineCrossingsSelectedAlert || [],
                                                                                                                                    showIgnoreZones: showIgnoreZoneOverlay,
                                                                                                                                    showLineCrossings: showLineCrossingOverlay,
                                                                                                                                    canDownload: canDownloadVideo,
                                                                                                                                    onDownload: handleDownloadVideo
                                                                                                                                })
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    })
                                                                                                                }),
                                                                                                                showLivePanel && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8cc62c6d4d7b8f3a$export$41370dce390d0afb), {
                                                                                                                    cameraId: liveStreamCameraId,
                                                                                                                    enabled: showLivePanel,
                                                                                                                    protocol: streamProtocol,
                                                                                                                    width: livePanelWidth,
                                                                                                                    height: videoContentHeight,
                                                                                                                    liveBadgeTopClass: viewMode === "live" ? "top-8" : "top-3"
                                                                                                                })
                                                                                                            ]
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                liveStreamingAvailable && selectedRow?.customer_pk && /*#__PURE__*/ (0, $k4ank.jsx)((0, $49ff3e8c05072b45$export$af7c760892830ecd), {
                                                                                                    siteId: selectedRow.customer_pk,
                                                                                                    siteName: selectedRow.display_name ?? selectedRow.customer_name ?? "",
                                                                                                    alertContext: {
                                                                                                        detectionType: selectedRow.detection_type ?? selectedRow.alert_labels?.[0] ?? "Alert",
                                                                                                        cameraName: selectedRow.camera_name ?? "",
                                                                                                        formattedDate: selectedRow.formatted_date ?? ""
                                                                                                    },
                                                                                                    defaultFocusedCameraId: liveStreamCameraId,
                                                                                                    miniOpen: siteWallMiniOpen,
                                                                                                    onMiniOpenChange: setSiteWallMiniOpen
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        showClipPanel && mP4URL && !videoClipLoading && !hasStaleVideoForCurrentSelection && partialVideoStatus !== null && // Only mounted when there is a message, so
                                                                                        // stepping between alerts doesn't add and
                                                                                        // remove an empty strip below the clip.
                                                                                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                                            className: "relative clear-both mt-1 space-y-1 font-mulish",
                                                                                            style: {
                                                                                                width: videoContentWidth
                                                                                            },
                                                                                            children: [
                                                                                                partialVideoStatus === "partial" && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                                                    className: "flex flex-wrap items-center justify-center gap-x-1 px-1 py-2 text-center text-[14px] leading-snug text-gray-600",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                                                                            children: "Partial video displayed,"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                                                                            onClick: handleCheckForUpdatedVideo,
                                                                                                            text: "CLICK HERE",
                                                                                                            disabled: false
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                                                                            children: "to check for updated video"
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                partialVideoStatus === "checking" && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                                                    className: "flex items-center justify-center py-2",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                                                                                            size: 16,
                                                                                                            color: "primary"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                                                                            className: "ml-2 text-[14px] text-gray-600",
                                                                                                            children: "Checking for updated video..."
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                partialVideoStatus === "loading" && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                                                    className: "flex items-center justify-center py-2",
                                                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                                                                        className: "text-[14px] text-green-600",
                                                                                                        children: "Loading updated video"
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        showVlmFilters && showClipPanel && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                                            className: "relative clear-both mt-2 rounded-md border px-[12px] py-[8px] font-mulish",
                                                                                            "data-testid": "vlm-status-banner",
                                                                                            style: {
                                                                                                width: videoContentWidth,
                                                                                                // Same colour as the tile, chip and column
                                                                                                // for this alert (hex alpha: 66 = 40%,
                                                                                                // 1A = 10%). Red is only ever Likely FP.
                                                                                                borderColor: `${(0, $e46e67fbb04d9482$export$a076d3f93826af8f)(selectedRow)}66`,
                                                                                                backgroundColor: `${(0, $e46e67fbb04d9482$export$a076d3f93826af8f)(selectedRow)}1A`
                                                                                            },
                                                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                                                                                className: "text-[12px] font-semibold",
                                                                                                style: {
                                                                                                    color: (0, $e46e67fbb04d9482$export$a076d3f93826af8f)(selectedRow)
                                                                                                },
                                                                                                children: (0, $biDrR.getVlmStatusMessage)(selectedRow)
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                showClipPanel && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                                    className: "relative mx-auto",
                                                                                    style: {
                                                                                        width: videoContentWidth
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $92f1f3dee329c8aa$export$8da4def50d61aa89), {
                                                                                        showIgnoreZones: showIgnoreZoneOverlay,
                                                                                        showLineCrossings: showLineCrossingOverlay,
                                                                                        onToggleIgnoreZones: handleToggleIgnoreZoneOverlay,
                                                                                        onToggleLineCrossings: handleToggleLineCrossingOverlay,
                                                                                        canShowLineCrossings: canShowLineCrossings,
                                                                                        canShowSiteVideoWall: canShowSiteVideoWall,
                                                                                        onSiteVideoWall: ()=>setSiteWallMiniOpen(true),
                                                                                        canViewProtocolNotes: !!(siteNotes || cameraNotes) && !!selectedRow && !pageLoading,
                                                                                        onViewProtocolNotes: ()=>{
                                                                                            setSiteId(selectedRow.customer_pk);
                                                                                            setViewSiteProtocolDialogOpen(true);
                                                                                        }
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                            className: "flex justify-center pl-[10px]",
                                                                            style: {
                                                                                paddingTop: videoPanelArrowTopPx
                                                                            },
                                                                            id: "arrow_forward",
                                                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                                                onClick: goToNextAlert,
                                                                                text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($93c4ee683cfcd691$exports))), {
                                                                                    id: "forwardButton",
                                                                                    sx: $dfbb1eaa7354951b$var$ALERT_NAV_ARROW_ICON_SX
                                                                                }),
                                                                                disabled: forwardArrowDisabled,
                                                                                sx: $dfbb1eaa7354951b$var$ALERT_NAV_ARROW_BUTTON_SX
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                        className: "flex grow flex-col pt-2",
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                            className: "flex w-full max-w-full grow flex-col",
                                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                                className: "flex w-full max-w-full grow flex-col",
                                                                children: [
                                                                    seeMoreURL && alertsToDisplay && selectedRow && /*#__PURE__*/ (0, $k4ank.jsx)((0, $4wo2Y.default), {
                                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8d098a274bfe17bc$export$d153b474e995d388), {
                                                                            selectedRow: selectedRow,
                                                                            alertData: alertData,
                                                                            setAlertData: setAlertData,
                                                                            setSelectedRow: setSelectedRow,
                                                                            selectdButtonsFilled: selectdButtonsFilled,
                                                                            setSelectedButtonsFilled: setSelectedButtonsFilled,
                                                                            navigate: navigate,
                                                                            setPageLoading: setPageLoading,
                                                                            setButtonClicked: setButtonClicked,
                                                                            pageLoadedNumber: pageLoadedNumber,
                                                                            setPageLoadedNumber: setPageLoadedNumber,
                                                                            setFetchingFilteredData: setFetchingFilteredData,
                                                                            setSeeMoreURL: setSeeMoreURL,
                                                                            setMP4URL: setMP4URLWithMeta,
                                                                            userFilters: userFilters,
                                                                            setThumbnailVideos: setThumbnailVideos,
                                                                            setDateOutsideRange: setDateOutsideRange,
                                                                            setPage: setPage,
                                                                            setVideoClipLoading: setVideoClipLoading,
                                                                            setAlertsToDisplay: setAlertsToDisplay,
                                                                            setSelectedAlertCameraInfo: setSelectedAlertCameraInfo,
                                                                            setIgnoreZonesSelectedAlert: setIgnoreZonesSelectedAlert,
                                                                            setAlertsIndexOrder: setAlertsIndexOrder,
                                                                            setRefreshInterval: setRefreshInterval,
                                                                            setCurrentName: setCurrentName,
                                                                            setUserFilters: setUserFilters,
                                                                            setRefreshingData: setRefreshingData,
                                                                            refreshInterval: refreshInterval,
                                                                            cameraOptions: cameraOptions,
                                                                            siteOptions: siteOptions,
                                                                            setRefreshingToken: setRefreshingToken,
                                                                            refreshingToken: refreshingToken,
                                                                            setAlertLabels: setAlertLabels,
                                                                            setPeriodHours: setPeriodHours,
                                                                            setQueryLimitHit: setQueryLimitHit,
                                                                            setForwardArrowDisabled: setForwardArrowDisabled,
                                                                            setBackArrowDisabled: setBackArrowDisabled,
                                                                            setShowRefreshButton: setShowRefreshButton,
                                                                            setRowsSortable: setRowsSortable,
                                                                            setAlertsRefreshing: setAlertsRefreshing,
                                                                            detectionType: detectionType,
                                                                            outcomeFilterType: outcomeFilterType,
                                                                            vlmFilterType: showVlmFilters ? vlmFilterType : "All",
                                                                            getCurrentSelectedRowKey: getCurrentSelectedRowKey,
                                                                            setVideoProcessing: setVideoProcessing,
                                                                            useAsyncGeneration: useAsyncGeneration,
                                                                            syncSelectedRowRef: syncSelectedRowRef,
                                                                            compact: tableDensity === "condensed"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                                                        className: "flex max-w-full grow flex-col overflow-x-auto pt-2",
                                                                        children: alertsToDisplay && seeMoreURL && !pageLoading && selectedRow && /*#__PURE__*/ (0, $k4ank.jsx)((0, $652b253a1b8c9880$export$2e2bcd8739ae039), {
                                                                            selectedRow: selectedRow,
                                                                            setNoteText: setNoteText,
                                                                            setNotesDialogOpen: setNotesDialogOpen
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "justify-start",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jVN1H.NavBar), {
                    navBarCollapsed: navBarCollapsed,
                    setNavBarCollapsed: setNavBarCollapsed,
                    props: {}
                })
            })
        ]
    });
};
var $dfbb1eaa7354951b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).memo($dfbb1eaa7354951b$var$Alerts);



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
var $fIsAN = parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");





const $81f1cc9a36ff0ec7$export$fd671f193334f5e = ()=>{
    const navigate = (0, $3T949.useNavigate)();
    const { siteId: siteIdParam } = (0, $3T949.useParams)();
    const [searchParams] = (0, $fIsAN.useSearchParams)();
    const siteId = siteIdParam ? Number(siteIdParam) : null;
    const siteName = searchParams.get("siteName") ?? "";
    const defaultFocusedCameraId = searchParams.get("cameraId");
    const detectionType = searchParams.get("detectionType") ?? "Alert";
    const cameraName = searchParams.get("cameraName") ?? "";
    const formattedDate = searchParams.get("date") ?? "";
    const [fullPage, setFullPage] = (0, $8T3gX.useState)(0);
    const [fullMode, setFullMode] = (0, $8T3gX.useState)("focus");
    const [focusedCameraId, setFocusedCameraId] = (0, $8T3gX.useState)(defaultFocusedCameraId);
    const focusGridPageSyncedRef = (0, $8T3gX.useRef)(false);
    const { status: status, cameras: cameras, totalCount: totalCount, ensureCamerasLoaded: ensureCamerasLoaded } = (0, $74c8423a8d9ec73a$export$c53a4e69ab4f344c)(siteId, true);
    (0, $8T3gX.useEffect)(()=>{
        setFocusedCameraId(defaultFocusedCameraId);
        focusGridPageSyncedRef.current = false;
    }, [
        siteId,
        defaultFocusedCameraId
    ]);
    (0, $8T3gX.useEffect)(()=>{
        if (fullMode !== "focus" || status !== "ready" || !focusedCameraId) return;
        if (focusGridPageSyncedRef.current) return;
        const pageForCamera = (0, $9ba45c9953aa0a9d$export$9fdea5360a93ed4a)(focusedCameraId, cameras);
        if (pageForCamera !== null) {
            setFullPage(pageForCamera);
            focusGridPageSyncedRef.current = true;
            return;
        }
        if (cameras.length < totalCount) ensureCamerasLoaded(totalCount - 1);
    }, [
        fullMode,
        status,
        focusedCameraId,
        cameras,
        totalCount,
        ensureCamerasLoaded
    ]);
    const handleClose = (0, $8T3gX.useCallback)(()=>{
        navigate("/alerts");
    }, [
        navigate
    ]);
    const handleModeChange = (0, $8T3gX.useCallback)((mode)=>{
        setFullMode(mode);
        if (mode === "focus") focusGridPageSyncedRef.current = false;
        else setFullPage(0);
    }, []);
    const alertContextLabel = `${detectionType} \xb7 ${cameraName} \xb7 ${formattedDate}`;
    if (!siteId || Number.isNaN(siteId)) return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "flex h-screen items-center justify-center font-mulish text-gray-500",
        children: "Invalid site for video wall."
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $e0c5ad9c4efb0aa1$export$1554c900c4f203ae), {
        protocol: (0, $a75edc692a8a5bf4$export$cb71459d0d2230aa),
        lowLatency: false,
        enabled: true,
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $2debd1b6295fdea0$export$c15a0d91f9d412f2), {
            open: true,
            onClose: handleClose,
            siteName: siteName || `Site ${siteId}`,
            alertContextLabel: alertContextLabel,
            status: status,
            cameras: cameras,
            totalCount: totalCount,
            mode: fullMode,
            onModeChange: handleModeChange,
            page: fullPage,
            onPageChange: setFullPage,
            focusedCameraId: focusedCameraId,
            onFocusedCameraChange: setFocusedCameraId,
            ensureCamerasLoaded: ensureCamerasLoaded,
            closeLabel: "Back to Alerts"
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $jVN1H = parcelRequire("jVN1H");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");

const $65e6fbab159b42e4$export$8eb89bad9a19c3d8 = ({ userFilters: userFilters, setUserFilters: setUserFilters, setSiteOptions: setSiteOptions, setSiteDropDownValue: setSiteDropDownValue, setCameraOptions: setCameraOptions, setCameraDropDownValue: setCameraDropDownValue, setLoadingSites: setLoadingSites, navBarCollapsed: navBarCollapsed, navigate: navigate })=>{
    const parentAccounts = JSON.parse(localStorage?.parentAccounts || "[]");
    const parentIdsMap = new Map();
    const parentNamesMap = new Map();
    parentAccounts.forEach((object)=>{
        parentIdsMap.set(object.name, object.id);
    });
    parentAccounts.forEach((object)=>{
        parentNamesMap.set(object.id, object.name);
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            disablePortal: true,
            options: parentAccounts[0] ? parentAccounts.map((object, index)=>({
                    id: object.id,
                    name: object.name,
                    index: index
                })) : [],
            getOptionLabel: (option)=>option.name || "",
            isOptionEqualToValue: (option, value)=>option.id === value.id,
            value: userFilters.parent_group ? {
                id: Number(userFilters.parent_group),
                name: parentNamesMap.get(Number(userFilters.parent_group)),
                index: parentAccounts.findIndex((obj)=>obj.id === Number(userFilters.parent_group))
            } : null,
            onChange: (event, value)=>{
                setSiteOptions([]);
                setCameraOptions([]);
                setSiteDropDownValue("");
                setCameraDropDownValue("");
                if (value !== null) {
                    (0, $27fa563d59549059$export$6b28e0ddc2fe699b)(value.id, navigate, setSiteOptions, setLoadingSites);
                    setUserFilters((previousState)=>{
                        return {
                            ...previousState,
                            parent_group: value.id,
                            site: "",
                            camera: ""
                        };
                    });
                } else setUserFilters((previousState)=>{
                    return {
                        ...previousState,
                        parent_group: "",
                        site: "",
                        camera: ""
                    };
                });
            },
            sx: !navBarCollapsed ? {
                width: 175
            } : {
                width: 200
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    label: "Parent Group",
                    autoComplete: "off"
                }),
            renderOption: (props, option)=>/*#__PURE__*/ (0, $8T3gX.createElement)("li", {
                    ...props,
                    key: option.id
                }, option.name)
        })
    }, "parent_groups_dropdown");
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $60vL1 = parcelRequire("60vL1");
var $eejVe = parcelRequire("eejVe");

const $d705da981577a7f7$export$9b4eb3dee1be7ea = ({ userFilters: userFilters, setUserFilters: setUserFilters, siteOptions: siteOptions, setCameraOptions: setCameraOptions, setCameraDropDownValue: setCameraDropDownValue, siteDropDownValue: siteDropDownValue, setSiteDropDownValue: setSiteDropDownValue, loadingSites: loadingSites, setLoadingCameras: setLoadingCameras, navBarCollapsed: navBarCollapsed, navigate: navigate })=>{
    const siteIdsMap = new Map();
    const siteNamesMap = new Map();
    siteOptions.forEach((object)=>{
        siteIdsMap.set(object.name, object.id);
    });
    siteOptions.forEach((object)=>{
        siteNamesMap.set(object.id, object.name);
    });
    const parentAccounts = JSON.parse(localStorage?.parentAccounts || "[]");
    const parentIdsMap = new Map();
    parentAccounts.forEach((object)=>{
        parentIdsMap.set(object.name, object.id);
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            disablePortal: true,
            options: siteOptions[0] ? siteOptions.map((object, index)=>({
                    id: object.id,
                    name: object.name,
                    index: index
                })) : [],
            getOptionLabel: (option)=>option.name || "",
            isOptionEqualToValue: (option, value)=>option.id === value.id,
            value: userFilters.site ? {
                id: Number(userFilters.site),
                name: siteNamesMap.get(Number(userFilters.site)),
                index: siteOptions.findIndex((obj)=>obj.id === Number(userFilters.site))
            } : null,
            loading: loadingSites,
            onChange: (event, value)=>{
                if (value !== null) {
                    setSiteDropDownValue(value.name);
                    setCameraDropDownValue("");
                    (0, $1a511a220e4442ce$export$1fedd6e3f8d8e03e)([
                        value.id
                    ], navigate, setCameraOptions, setLoadingCameras);
                    setUserFilters((previousState)=>{
                        return {
                            ...previousState,
                            site: value.id,
                            camera: ""
                        };
                    });
                } else {
                    setSiteDropDownValue("");
                    setCameraDropDownValue("");
                    setCameraOptions([]);
                    setUserFilters((previousState)=>{
                        return {
                            ...previousState,
                            site: "",
                            camera: ""
                        };
                    });
                }
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    label: "Site",
                    InputProps: {
                        ...params.InputProps,
                        endAdornment: /*#__PURE__*/ (0, $k4ank.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                            children: [
                                loadingSites ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                    color: "inherit",
                                    size: 20
                                }) : null,
                                params.InputProps.endAdornment
                            ]
                        })
                    },
                    autoComplete: "off",
                    sx: !navBarCollapsed ? {
                        width: 175
                    } : {
                        width: 200
                    }
                }),
            renderOption: (props, option)=>/*#__PURE__*/ (0, $8T3gX.createElement)("li", {
                    ...props,
                    key: option.id
                }, option.name)
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $60vL1 = parcelRequire("60vL1");
var $eejVe = parcelRequire("eejVe");
const $6d629799594ebba4$export$f8d8233490b588a9 = ({ userFilters: userFilters, setUserFilters: setUserFilters, cameraOptions: cameraOptions, cameraDropDownValue: cameraDropDownValue, setCameraDropDownValue: setCameraDropDownValue, siteOptions: siteOptions, loadingCameras: loadingCameras, navBarCollapsed: navBarCollapsed })=>{
    const cameraIdsMap = new Map();
    const cameraNamesMap = new Map();
    cameraOptions.forEach((object)=>{
        cameraIdsMap.set(object.camera_name, object.id);
    });
    cameraOptions.forEach((object)=>{
        cameraNamesMap.set(object.id, object.camera_name);
    });
    const siteIdsMap = new Map();
    siteOptions.forEach((object)=>{
        siteIdsMap.set(object.name, object.id);
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            disablePortal: true,
            options: cameraOptions[0] ? cameraOptions.map((object, index)=>({
                    id: object.id,
                    name: object.camera_name,
                    index: index
                })) : [],
            getOptionLabel: (option)=>option.name || "",
            isOptionEqualToValue: (option, value)=>option.id === value.id,
            value: userFilters.camera ? {
                id: Number(userFilters.camera),
                name: cameraNamesMap.get(Number(userFilters.camera)),
                index: cameraOptions.findIndex((obj)=>obj.id === Number(userFilters.camera))
            } : null,
            loading: loadingCameras,
            onChange: (event, value)=>{
                if (value !== null) {
                    setCameraDropDownValue(value.name);
                    setUserFilters((previousState)=>{
                        return {
                            ...previousState,
                            camera: value.id
                        };
                    });
                } else {
                    setCameraDropDownValue("");
                    setUserFilters((previousState)=>{
                        return {
                            ...previousState,
                            camera: ""
                        };
                    });
                }
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    label: "Camera",
                    InputProps: {
                        ...params.InputProps,
                        endAdornment: /*#__PURE__*/ (0, $k4ank.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).Fragment, {
                            children: [
                                loadingCameras ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                    color: "inherit",
                                    size: 20
                                }) : null,
                                params.InputProps.endAdornment
                            ]
                        })
                    },
                    autoComplete: "off",
                    sx: !navBarCollapsed ? {
                        width: 175
                    } : {
                        width: 200
                    }
                }),
            renderOption: (props, option)=>/*#__PURE__*/ (0, $8T3gX.createElement)("li", {
                    ...props,
                    key: option.id
                }, option.name)
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $hfM8m = parcelRequire("hfM8m");

var $hwWkD = parcelRequire("hwWkD");


var $eejVe = parcelRequire("eejVe");
parcelRequire("8T3gX");
const $a85a110800b9834b$export$982c92d18baf151f = (newValue, userFilters, setUserFilters)=>{
    if (!userFilters.end_date) setUserFilters((previousState)=>{
        return {
            ...previousState,
            start_date: newValue
        };
    });
    if (userFilters.end_date) {
        if (newValue <= userFilters.end_date) setUserFilters((previousState)=>{
            return {
                ...previousState,
                start_date: newValue
            };
        });
        if (newValue > userFilters.end_date) alert("Start date cannot be after end date");
    }
};



var $iKAtE = parcelRequire("iKAtE");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");

var $i5MAs = parcelRequire("i5MAs");

var $aYdit = parcelRequire("aYdit");

var $jgags = parcelRequire("jgags");
const $4c6076c76de9df08$export$279ccc6f70efa427 = ({ userFilters: userFilters, setUserFilters: setUserFilters })=>{
    const [startTimeAnchorEl, setStartTimeAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const startTimeOpen = Boolean(startTimeAnchorEl);
    const handleStartTimeClick = (event)=>{
        setStartTimeAnchorEl(event.currentTarget);
    };
    const handleStartTimeClose = (event)=>{
        event.stopPropagation();
        setStartTimeAnchorEl(null);
    };
    const { dateMMDDYYYY: dateMMDDYYYY, setDateMMDDYYYY: setDateMMDDYYYY } = (0, $aYdit.useAppStore)();
    const selectedLocale = dateMMDDYYYY ? (0, $jgags.default) : (0, $253608f850203ed2$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
        dateAdapter: (0, $hfM8m.AdapterDateFns),
        adapterLocale: selectedLocale,
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cbaf068f14972fdf$export$5109c6dd95d8fb00), {
            label: userFilters.start_date ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                        children: "Start Date"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                "aria-label": "more",
                                id: "long-button",
                                "aria-controls": startTimeOpen ? "long-menu" : undefined,
                                "aria-expanded": startTimeOpen ? "true" : undefined,
                                "aria-haspopup": "true",
                                onClick: handleStartTimeClick,
                                sx: {
                                    marginLeft: "5px",
                                    padding: 0,
                                    color: "#000000",
                                    "&:hover": {
                                        backgroundColor: "transparent"
                                    }
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5MAs))), {})
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                                id: "long-menu",
                                MenuListProps: {
                                    "aria-labelledby": "long-button"
                                },
                                anchorOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                anchorEl: startTimeAnchorEl,
                                open: startTimeOpen,
                                onClose: handleStartTimeClose,
                                slotProps: {
                                    paper: {
                                        style: {
                                            maxHeight: 216,
                                            width: "20ch"
                                        }
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: (event)=>{
                                            setDateMMDDYYYY(true);
                                            handleStartTimeClose(event);
                                        },
                                        children: "MM/DD/YYYY"
                                    }, "mm-dd-yyyy-start"),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: (event)=>{
                                            setDateMMDDYYYY(false);
                                            handleStartTimeClose(event);
                                        },
                                        children: "DD/MM/YYYY"
                                    }, "dd-mm-yyyy-start")
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                children: "Start Date"
            }),
            value: userFilters.start_date,
            onChange: (newValue)=>{
                if (newValue !== null) (0, $a85a110800b9834b$export$982c92d18baf151f)(newValue, userFilters, setUserFilters);
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    sx: {
                        width: 150
                    },
                    helperText: "*Required",
                    ...params
                })
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $hfM8m = parcelRequire("hfM8m");

var $hwWkD = parcelRequire("hwWkD");


var $eejVe = parcelRequire("eejVe");
const $aab472f9580aa805$export$6b11d54de77d68dc = (newValue, userFilters, setUserFilters)=>{
    if (!userFilters.start_date) setUserFilters((previousState)=>{
        return {
            ...previousState,
            end_date: newValue
        };
    });
    if (userFilters.start_date) {
        if (newValue >= userFilters.start_date) setUserFilters((previousState)=>{
            return {
                ...previousState,
                end_date: newValue
            };
        });
        if (newValue < userFilters.start_date) alert("End date cannot be before start date");
    }
};



var $iKAtE = parcelRequire("iKAtE");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");

var $i5MAs = parcelRequire("i5MAs");

var $aYdit = parcelRequire("aYdit");

var $jgags = parcelRequire("jgags");
const $9921a8ed5e7b4c68$export$e0a32d6e7aff5b = ({ userFilters: userFilters, setUserFilters: setUserFilters })=>{
    const [endTimeAnchorEl, setEndTimeAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const endTimeOpen = Boolean(endTimeAnchorEl);
    const handleEndTimeClick = (event)=>{
        setEndTimeAnchorEl(event.currentTarget);
    };
    const handleEndTimeClose = (event)=>{
        event.stopPropagation();
        setEndTimeAnchorEl(null);
    };
    const { dateMMDDYYYY: dateMMDDYYYY, setDateMMDDYYYY: setDateMMDDYYYY } = (0, $aYdit.useAppStore)();
    const selectedLocale = dateMMDDYYYY ? (0, $jgags.default) : (0, $253608f850203ed2$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $hwWkD.LocalizationProvider), {
        dateAdapter: (0, $hfM8m.AdapterDateFns),
        adapterLocale: selectedLocale,
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cbaf068f14972fdf$export$5109c6dd95d8fb00), {
            label: userFilters.end_date ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                        children: "End Date"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                "aria-label": "more",
                                id: "long-button",
                                "aria-controls": endTimeOpen ? "long-menu" : undefined,
                                "aria-expanded": endTimeOpen ? "true" : undefined,
                                "aria-haspopup": "true",
                                onClick: handleEndTimeClick,
                                sx: {
                                    marginLeft: "5px",
                                    padding: 0,
                                    color: "#000000",
                                    "&:hover": {
                                        backgroundColor: "transparent"
                                    }
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5MAs))), {})
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                                id: "long-menu",
                                MenuListProps: {
                                    "aria-labelledby": "long-button"
                                },
                                anchorOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                anchorEl: endTimeAnchorEl,
                                open: endTimeOpen,
                                onClose: handleEndTimeClose,
                                slotProps: {
                                    paper: {
                                        style: {
                                            maxHeight: 216,
                                            width: "20ch"
                                        }
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: (event)=>{
                                            setDateMMDDYYYY(true);
                                            handleEndTimeClose(event);
                                        },
                                        children: "MM/DD/YYYY"
                                    }, "mm-dd-yyyy-end"),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        onClick: (event)=>{
                                            setDateMMDDYYYY(false);
                                            handleEndTimeClose(event);
                                        },
                                        children: "DD/MM/YYYY"
                                    }, "dd-mm-yyyy-end")
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                children: "End Date"
            }),
            value: userFilters.end_date,
            onChange: (newValue)=>{
                if (newValue !== null) (0, $aab472f9580aa805$export$6b11d54de77d68dc)(newValue, userFilters, setUserFilters);
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    sx: {
                        width: 150
                    },
                    ...params
                })
        })
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $eejVe = parcelRequire("eejVe");
const $47fbf2deff9dd9fa$export$9045ed8615ad7c06 = ({ navBarCollapsed: navBarCollapsed, metricsSelected: metricsSelected, setMetricsSelected: setMetricsSelected })=>{
    const metricOptions = [
        "Connectivity",
        "Image Quality",
        "Scene Change",
        "Stream Quality",
        "Motion Status",
        "Recording Status"
    ];
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            multiple: true,
            value: metricsSelected,
            disablePortal: true,
            options: metricOptions,
            onChange: (event, value)=>{
                setMetricsSelected(value);
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    label: "Metrics",
                    autoComplete: "off",
                    sx: !navBarCollapsed ? {
                        width: 175
                    } : {
                        width: 200
                    }
                })
        })
    });
};


const $8341367ea5303818$export$fc132bc4d040493b = ({ userFilters: userFilters, setUserFilters: setUserFilters, setSiteOptions: setSiteOptions, setSiteDropDownValue: setSiteDropDownValue, setCameraOptions: setCameraOptions, setCameraDropDownValue: setCameraDropDownValue, siteOptions: siteOptions, siteDropDownValue: siteDropDownValue, loadingSites: loadingSites, setLoadingCameras: setLoadingCameras, setLoadingSites: setLoadingSites, cameraOptions: cameraOptions, cameraDropDownValue: cameraDropDownValue, loadingCameras: loadingCameras, navBarCollapsed: navBarCollapsed, metricsSelected: metricsSelected, setMetricsSelected: setMetricsSelected, navigate: navigate })=>{
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        className: !navBarCollapsed ? "columns-5 w-[1090px]" : "columns-5 w-[1170px]",
        style: {
            display: "grid",
            gridTemplateColumns: "auto auto auto auto auto auto"
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $65e6fbab159b42e4$export$8eb89bad9a19c3d8), {
                    userFilters: userFilters,
                    setUserFilters: setUserFilters,
                    setSiteOptions: setSiteOptions,
                    setSiteDropDownValue: setSiteDropDownValue,
                    setCameraOptions: setCameraOptions,
                    setCameraDropDownValue: setCameraDropDownValue,
                    setLoadingSites: setLoadingSites,
                    navBarCollapsed: navBarCollapsed,
                    navigate: navigate
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $d705da981577a7f7$export$9b4eb3dee1be7ea), {
                    userFilters: userFilters,
                    setUserFilters: setUserFilters,
                    siteOptions: siteOptions,
                    setCameraOptions: setCameraOptions,
                    setCameraDropDownValue: setCameraDropDownValue,
                    siteDropDownValue: siteDropDownValue,
                    setSiteDropDownValue: setSiteDropDownValue,
                    loadingSites: loadingSites,
                    setLoadingCameras: setLoadingCameras,
                    navBarCollapsed: navBarCollapsed,
                    navigate: navigate
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $6d629799594ebba4$export$f8d8233490b588a9), {
                    userFilters: userFilters,
                    setUserFilters: setUserFilters,
                    cameraOptions: cameraOptions,
                    cameraDropDownValue: cameraDropDownValue,
                    setCameraDropDownValue: setCameraDropDownValue,
                    siteOptions: siteOptions,
                    loadingCameras: loadingCameras,
                    navBarCollapsed: navBarCollapsed
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $47fbf2deff9dd9fa$export$9045ed8615ad7c06), {
                    navBarCollapsed: navBarCollapsed,
                    metricsSelected: metricsSelected,
                    setMetricsSelected: setMetricsSelected
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "h-[50px]",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4c6076c76de9df08$export$279ccc6f70efa427), {
                    userFilters: userFilters,
                    setUserFilters: setUserFilters
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "h-[50px]",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $9921a8ed5e7b4c68$export$e0a32d6e7aff5b), {
                    userFilters: userFilters,
                    setUserFilters: setUserFilters
                })
            })
        ]
    });
};


parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
var $fIsAN = parcelRequire("fIsAN");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");
parcelRequire("8T3gX");
const $6ea8bc2ad1052ffd$export$7c253626761b7bf9 = (alertsData, setErrorsOverviewData)=>{
    const updatedErrorsOverviewData = {
        connectivity: 0,
        image_quality: 0,
        // license_info: 0,
        motion_status: 0,
        recording_status: 0,
        scene_change: 0,
        stream_quality: 0
    };
    alertsData.all.forEach((object)=>{
        if (object.status === "ongoing" || object.status === "pending") {
            if (object.error_type === "connectivity") updatedErrorsOverviewData.connectivity = updatedErrorsOverviewData.connectivity + 1;
            if (object.error_type === "image_quality") updatedErrorsOverviewData.image_quality = updatedErrorsOverviewData.image_quality + 1;
            // if (object.error_type === "license_info") {
            //   updatedErrorsOverviewData.license_info =
            //     updatedErrorsOverviewData.license_info + 1;
            // }
            if (object.error_type === "motion_status") updatedErrorsOverviewData.motion_status = updatedErrorsOverviewData.motion_status + 1;
            if (object.error_type === "recording_status") updatedErrorsOverviewData.recording_status = updatedErrorsOverviewData.recording_status + 1;
            if (object.error_type === "scene_change") updatedErrorsOverviewData.scene_change = updatedErrorsOverviewData.scene_change + 1;
            if (object.error_type === "stream_quality") updatedErrorsOverviewData.stream_quality = updatedErrorsOverviewData.stream_quality + 1;
        }
    });
    setErrorsOverviewData(updatedErrorsOverviewData);
};


parcelRequire("8T3gX");
const $82a36171a8cf0b7a$var$filterData = (camera_id, cameraStatsData, alertData)=>{
    const updatedCountObject = {};
    cameraStatsData.forEach((object)=>{
        object.connectivity = 0;
        object.scene_change = 0;
        object.recording_status = 0;
        object.motion_status = 0;
        object.image_quality = 0;
        object.stream_quality = 0;
        object.license_info = 0;
        object.total = 0;
        updatedCountObject[`${object.camera_name}${object.site_name}`] = object;
    });
    alertData.forEach((object)=>{
        if (updatedCountObject[`${object.camera_name}${object.site_name}`]) {
            if (object.error_type === "connectivity") {
                updatedCountObject[`${object.camera_name}${object.site_name}`].connectivity = updatedCountObject[`${object.camera_name}${object.site_name}`].connectivity + 1;
                updatedCountObject[`${object.camera_name}${object.site_name}`].total = updatedCountObject[`${object.camera_name}${object.site_name}`].total + 1;
            }
            if (object.error_type === "scene_change") {
                updatedCountObject[`${object.camera_name}${object.site_name}`].scene_change = updatedCountObject[`${object.camera_name}${object.site_name}`].scene_change + 1;
                updatedCountObject[`${object.camera_name}${object.site_name}`].total = updatedCountObject[`${object.camera_name}${object.site_name}`].total + 1;
            }
            if (object.error_type === "recording_status") {
                updatedCountObject[`${object.camera_name}${object.site_name}`].recording_status = updatedCountObject[`${object.camera_name}${object.site_name}`].recording_status + 1;
                updatedCountObject[`${object.camera_name}${object.site_name}`].total = updatedCountObject[`${object.camera_name}${object.site_name}`].total + 1;
            }
            if (object.error_type === "motion_status") {
                updatedCountObject[`${object.camera_name}${object.site_name}`].motion_status = updatedCountObject[`${object.camera_name}${object.site_name}`].motion_status + 1;
                updatedCountObject[`${object.camera_name}${object.site_name}`].total = updatedCountObject[`${object.camera_name}${object.site_name}`].total + 1;
            }
            if (object.error_type === "image_quality") {
                updatedCountObject[`${object.camera_name}${object.site_name}`].image_quality = updatedCountObject[`${object.camera_name}${object.site_name}`].image_quality + 1;
                updatedCountObject[`${object.camera_name}${object.site_name}`].total = updatedCountObject[`${object.camera_name}${object.site_name}`].total + 1;
            }
            if (object.error_type === "stream_quality") {
                updatedCountObject[`${object.camera_name}${object.site_name}`].stream_quality = updatedCountObject[`${object.camera_name}${object.site_name}`].stream_quality + 1;
                updatedCountObject[`${object.camera_name}${object.site_name}`].total = updatedCountObject[`${object.camera_name}${object.site_name}`].total + 1;
            }
            if (object.error_type === "license_info") {
                updatedCountObject[`${object.camera_name}${object.site_name}`].license_info = updatedCountObject[`${object.camera_name}${object.site_name}`].license_info + 1;
                updatedCountObject[`${object.camera_name}${object.site_name}`].total = updatedCountObject[`${object.camera_name}${object.site_name}`].total + 1;
            }
        }
    });
    const returnData = [];
    for(const key in updatedCountObject)returnData.push(updatedCountObject[key]);
    if (camera_id) return returnData.filter((camera)=>camera.camera_id === camera_id);
    return returnData;
};
const $82a36171a8cf0b7a$export$474f7cb3f9dd064b = (cameraStatsData, setCameraStatsData, setLoadingCameraStatsData, showSiteStats, userFilters, alertData)=>{
    let updatedCameraStatsData = [];
    if (!showSiteStats) {
        updatedCameraStatsData = $82a36171a8cf0b7a$var$filterData(Number(userFilters.camera), cameraStatsData, alertData);
        updatedCameraStatsData.forEach((object)=>{
            if (object.camera_name.length > 11) object.display_name = `${object.camera_name.slice(0, 10)}..`;
            if (object.camera_name.length <= 11) object.display_name = object.camera_name;
            object.name = object.camera_name;
        });
    } else {
        const cameraNamesArray = [];
        cameraStatsData.forEach((object)=>{
            if (!cameraNamesArray.includes(object.site_name)) cameraNamesArray.push(object.site_name);
        });
        const temporarySiteObject = {};
        const createAbreviatedDisplayName = (inputString)=>{
            if (inputString.length > 11) return `${inputString.slice(0, 10)}..`;
            if (inputString.length <= 11) return inputString;
        };
        cameraNamesArray.forEach((name)=>{
            temporarySiteObject[name] = {
                name: name,
                display_name: createAbreviatedDisplayName(name),
                connectivity: 0,
                scene_change: 0,
                recording_status: 0,
                motion_status: 0,
                image_quality: 0,
                stream_quality: 0,
                total: 0
            };
        });
        alertData.forEach((object)=>{
            if (temporarySiteObject[`${object.site_name}`]) {
                if (object.error_type === "connectivity") {
                    temporarySiteObject[`${object.site_name}`].connectivity = temporarySiteObject[`${object.site_name}`].connectivity + 1;
                    temporarySiteObject[`${object.site_name}`].total = temporarySiteObject[`${object.site_name}`].total + 1;
                }
                if (object.error_type === "scene_change") {
                    temporarySiteObject[`${object.site_name}`].scene_change = temporarySiteObject[`${object.site_name}`].scene_change + 1;
                    temporarySiteObject[`${object.site_name}`].total = temporarySiteObject[`${object.site_name}`].total + 1;
                }
                if (object.error_type === "recording_status") {
                    temporarySiteObject[`${object.site_name}`].recording_status = temporarySiteObject[`${object.site_name}`].recording_status + 1;
                    temporarySiteObject[`${object.site_name}`].total = temporarySiteObject[`${object.site_name}`].total + 1;
                }
                if (object.error_type === "motion_status") {
                    temporarySiteObject[`${object.site_name}`].motion_status = temporarySiteObject[`${object.site_name}`].motion_status + 1;
                    temporarySiteObject[`${object.site_name}`].total = temporarySiteObject[`${object.site_name}`].total + 1;
                }
                if (object.error_type === "image_quality") {
                    temporarySiteObject[`${object.site_name}`].image_quality = temporarySiteObject[`${object.site_name}`].image_quality + 1;
                    temporarySiteObject[`${object.site_name}`].total = temporarySiteObject[`${object.site_name}`].total + 1;
                }
                if (object.error_type === "stream_quality") {
                    temporarySiteObject[`${object.site_name}`].stream_quality = temporarySiteObject[`${object.site_name}`].stream_quality + 1;
                    temporarySiteObject[`${object.site_name}`].total = temporarySiteObject[`${object.site_name}`].total + 1;
                }
                if (object.error_type === "license_info") {
                    temporarySiteObject[`${object.site_name}`].license_info = temporarySiteObject[`${object.site_name}`].license_info + 1;
                    temporarySiteObject[`${object.site_name}`].total = temporarySiteObject[`${object.site_name}`].total + 1;
                }
            }
        });
        for(const key in temporarySiteObject)updatedCameraStatsData.push(temporarySiteObject[key]);
    }
    setCameraStatsData(updatedCameraStatsData);
    setLoadingCameraStatsData(false);
};



var $5L5iJ = parcelRequire("5L5iJ");
parcelRequire("8T3gX");
const $1c8c8d23486a2b93$export$bc0181ac37992f1 = (objects)=>{
    return objects.filter((obj)=>{
        // Filter based on error_type and status
        return obj.status !== "healthy" && obj.status !== "resolved";
    });
};
const $1c8c8d23486a2b93$export$6addae8b33e5b695 = (objects)=>{
    return objects.filter((obj)=>{
        // Filter based on error_type and status
        return (obj.error_type === "motion_status" || obj.error_type === "image_quality" || obj.error_type === "stream_quality" || obj.error_type === "license_info" || obj.error_type === "recording_status") && obj.status === "ongoing";
    });
};
const $1c8c8d23486a2b93$export$3d21b7cdecda7bf0 = (objects)=>{
    return objects.filter((obj)=>{
        // Filter based on error_type and status
        return (obj.error_type === "connectivity" || obj.error_type === "scene_change") && obj.status === "ongoing";
    });
};
const $1c8c8d23486a2b93$export$3674d01f8b8470a1 = (objects)=>{
    return objects.filter((obj)=>{
        // Filter based on error_type and status
        return obj.status === "resolved";
    });
};
const $1c8c8d23486a2b93$export$ef2bd9189ca85cfc = (objects)=>{
    return objects.filter((obj)=>{
        // Filter based on error_type and status
        return obj.status === "pending";
    });
};



var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("8T3gX");
const $8a06d9beefbfc894$export$55525f7b84e38fa9 = (userFilters, healthCheckSites)=>{
    if (userFilters.metrics.length === 0) return healthCheckSites;
    const updatedHealthCheckSites = [];
    const filterTypes = [
        [
            "Connectivity",
            "connectivity"
        ],
        [
            "Image Quality",
            "image_quality"
        ],
        [
            "Scene Change",
            "scene_change"
        ],
        [
            "Stream Quality",
            "stream_quality"
        ],
        [
            "Motion Status",
            "motion_status"
        ],
        [
            "Recording Status",
            "recording_status"
        ]
    ];
    userFilters.metrics.forEach((metric)=>{
        filterTypes.forEach((filterType)=>{
            if (metric === filterType[0]) healthCheckSites.forEach((site)=>{
                if (site.error_type === filterType[1]) updatedHealthCheckSites.push(site);
            });
        });
    });
    return updatedHealthCheckSites;
};


parcelRequire("8T3gX");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $ccb8c8b679fbc7d2$export$63091a9c71aa4423 = (cameraId, setLoadingImage, setPreviewURL, navigate)=>{
    const retryFunction = ()=>{
        $ccb8c8b679fbc7d2$export$63091a9c71aa4423(cameraId, setLoadingImage, setPreviewURL, navigate);
    };
    const AxiosUI = (0, $195EM.createApi)(``);
    AxiosUI.get(`/camera/${cameraId}/status/`).then((response)=>{
        setPreviewURL(response.data.preview_url);
        setLoadingImage(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setPreviewURL("");
            setLoadingImage(false);
        });
    });
};



var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $c0ba81b0f635eb8e$export$16e99fc6f28468a5 = (inputString)=>{
    if (inputString) return inputString.replace(/#/g, "%23");
    else return "";
};
const $c0ba81b0f635eb8e$export$670c6be62c0305bd = (row, setBackgroundFrame, setDetectedFrame, navigate)=>{
    const retryFunction = ()=>{
        $c0ba81b0f635eb8e$export$670c6be62c0305bd(row, setBackgroundFrame, setDetectedFrame, navigate);
    };
    const AxiosUI = (0, $195EM.createApi)(``);
    AxiosUI.get(`/images/get_image_url/?frame_key=${$c0ba81b0f635eb8e$export$16e99fc6f28468a5(row.background_frame_key)}`).then((response)=>{
        setBackgroundFrame(response.data.frame_url);
        AxiosUI.get(`/images/get_image_url/?frame_key=${$c0ba81b0f635eb8e$export$16e99fc6f28468a5(row.detected_frame_key)}`).then((response)=>{
            setDetectedFrame(response.data.frame_url);
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
        });
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
    });
};
const $c0ba81b0f635eb8e$export$609316fd606b5e1 = (row, setDetectedFrame, navigate)=>{
    const retryFunction = ()=>{
        $c0ba81b0f635eb8e$export$609316fd606b5e1(row, setDetectedFrame, navigate);
    };
    const AxiosUI = (0, $195EM.createApi)(``);
    if (row.detected_frame_key) AxiosUI.get(`/images/get_image_url/?frame_key=${$c0ba81b0f635eb8e$export$16e99fc6f28468a5(row.detected_frame_key)}`).then((response)=>{
        setDetectedFrame(response.data.frame_url);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
    });
    else setDetectedFrame("");
};


const $5ea6299425b2a6d2$export$815ef45b734c5d65 = (setSearchParams, setAlertStatusDialogOpen, activeData, setSelectedRowIndex, setSelectedRow, setNotesValue, setBackgroundFrame, setDetectedFrame, setNoAlertsDialogOpen, setClickedTab, navigate)=>{
    const params = new URLSearchParams(window.location.search);
    const openAlert = params.get("open_alert");
    if (openAlert) {
        const [cameraId, errorType, createdTimestamp] = openAlert.split("-");
        let activeIndex = -1;
        let alertFound = false;
        let alertFoundResolved = false;
        activeData.all.forEach((chmAlert, index)=>{
            if (Number(chmAlert.camera_id) === Number(cameraId) && chmAlert.error_type === errorType && Number(chmAlert.created_timestamp) === Number(createdTimestamp)) {
                alertFound = true;
                activeIndex = index;
                (0, $ccb8c8b679fbc7d2$export$63091a9c71aa4423)(activeData.all[index].camera_id, ()=>{}, ()=>{}, navigate);
                setBackgroundFrame("");
                setDetectedFrame("");
                if (activeData.all[index].error_type === "scene_change") (0, $c0ba81b0f635eb8e$export$670c6be62c0305bd)(activeData.all[index], setBackgroundFrame, setDetectedFrame, navigate);
                setSelectedRowIndex(index);
                setSelectedRow(activeData.all[index]);
                setNotesValue(activeData.all[index].notes);
                setAlertStatusDialogOpen(true);
            }
            if (index === activeData.all.length - 1 && !alertFound) activeData.resolved.forEach((chmAlert, index)=>{
                if (Number(chmAlert.camera_id) === Number(cameraId) && chmAlert.error_type === errorType && Number(chmAlert.created_timestamp) === Number(createdTimestamp)) {
                    alertFoundResolved = true;
                    activeIndex = index;
                    (0, $ccb8c8b679fbc7d2$export$63091a9c71aa4423)(activeData.resolved[index].camera_id, ()=>{}, ()=>{}, navigate);
                    setBackgroundFrame("");
                    setDetectedFrame("");
                    if (activeData.resolved[index].error_type === "scene_change") (0, $c0ba81b0f635eb8e$export$670c6be62c0305bd)(activeData.resolved[index], setBackgroundFrame, setDetectedFrame, navigate);
                    setSelectedRowIndex(index);
                    setSelectedRow(activeData.resolved[index]);
                    setNotesValue(activeData.resolved[index].notes);
                    setAlertStatusDialogOpen(true);
                }
                if (index === activeData.resolved.length - 1 && !alertFoundResolved) setNoAlertsDialogOpen(true);
                if (index === activeData.resolved.length - 1 && alertFoundResolved) setClickedTab("resolved");
            });
        });
        if (activeIndex === -1) {
            params.delete("open_alert");
            setSearchParams(params);
        }
    }
};


parcelRequire("8T3gX");
const $a10397fbf3df1ab2$export$b3e02ac8bc6acd25 = (healthCheckSites)=>{
    const returnedHealthCheckSites = [
        ...healthCheckSites
    ];
    returnedHealthCheckSites.forEach((object, index)=>{
        if (object.error_type === "connectivity") returnedHealthCheckSites[index].severity = 1;
        if (object.error_type === "image_quality") returnedHealthCheckSites[index].severity = 2;
        if (object.error_type === "motion_status") returnedHealthCheckSites[index].severity = 2;
        if (object.error_type === "recording_status") returnedHealthCheckSites[index].severity = 2;
        if (object.error_type === "scene_change") returnedHealthCheckSites[index].severity = 2;
        if (object.error_type === "stream_quality") returnedHealthCheckSites[index].severity = 3;
    });
    return returnedHealthCheckSites;
};



var $ebTQj = parcelRequire("ebTQj");
const $67f834272aa34a6e$export$a86190deb5c4a8d0 = ()=>{
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const formattedMonth = month < 10 ? `0${month}` : `${month}`;
    const day = now.getDate();
    const formattedDay = day < 10 ? `0${day}` : `${day}`;
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const meridiem = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    const formattedDate = `${formattedDay}/${formattedMonth}/${year}`;
    const formattedTime = `${formattedHours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}${meridiem}`;
    return `${formattedDate} ${formattedTime}`;
};
const $67f834272aa34a6e$export$f60a425dad8947cf = (startTimestamp)=>{
    const currentTime = Date.now() / 1000; // Get the current time in Unix epoch format in seconds
    const timeDifference = currentTime - startTimestamp; // Calculate the time difference in seconds
    const hoursDifference = timeDifference / 3600; // Convert the time difference to hours
    return hoursDifference > 24;
};
const $67f834272aa34a6e$export$985fc4c1c7a3a77a = (inputString, aMPMString)=>{
    if (aMPMString === "PM") return `${Number(inputString) + 12}`;
    if (aMPMString === "AM" && inputString !== "12") return inputString;
    if (aMPMString === "AM" && inputString === "12") return "00";
};
const $67f834272aa34a6e$export$78e1df0e572bda86 = (setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setUnhealthyCamsData, setAlertsData, setFectchingAllData, filters, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setUpdatingStatus, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setBandwidthLoadingError, setSearchParams, setNotesValue, setBackgroundFrame, setDetectedFrame, setNoAlertsDialogOpen, setClickedTab, setFiltersApplied, navigate)=>{
    setErrorsOverviewData({
        connectivity: 0,
        image_quality: 0,
        license_info: 0,
        motion_status: 0,
        recording_status: 0,
        scene_change: 0,
        stream_quality: 0
    });
    setUnhealthyCamsData({
        unhealthy_cameras: 0,
        total_cameras: 0,
        errors: 0,
        warnings: 0,
        resolved: 0
    });
    setCameraStatsData([]);
    setAlertsData({
        all: [],
        errors: [],
        warnings: [],
        pending: [],
        resolved: []
    });
    const retryFunction = ()=>{
        $67f834272aa34a6e$export$78e1df0e572bda86(setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setUnhealthyCamsData, setAlertsData, setFectchingAllData, filters, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setUpdatingStatus, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setBandwidthLoadingError, setSearchParams, setNotesValue, setBackgroundFrame, setDetectedFrame, setNoAlertsDialogOpen, setClickedTab, setFiltersApplied, navigate);
    };
    let tempShowSiteStats = true;
    setShowSiteStats(true);
    const AxiosUI = (0, $195EM.createApi)(``);
    let searchQueryString = `?`;
    searchQueryString += `start_date=${(0, $5L5iJ.yyyymmddGenerator)(filters.start_date)}`;
    filters.end_date ? searchQueryString += `&end_date=${(0, $5L5iJ.yyyymmddGenerator)(filters.end_date)}` : searchQueryString += `&end_date=${(0, $5L5iJ.yyyymmddGenerator)(new Date())}`;
    if (filters.parent_group) {
        filters.start_date || filters.end_date ? searchQueryString += `&group=${filters.parent_group}` : searchQueryString += `group=${filters.parent_group}`;
        tempShowSiteStats = true;
    }
    if (filters.site) {
        filters.start_date || filters.end_date || filters.parent_group ? searchQueryString += `&site=${filters.site}` : searchQueryString += `site=${filters.site}`;
        setShowSiteStats(false);
        tempShowSiteStats = false;
    }
    if (filters.camera) {
        filters.start_date || filters.end_date || filters.parent_group || filters.site ? searchQueryString += `&camera=${filters.camera}` : searchQueryString += `camera=${filters.camera}`;
        setShowSiteStats(false);
        tempShowSiteStats = false;
    }
    AxiosUI.get(`analytics/data_usage/${searchQueryString}&limit=20`).then((response)=>{
        setBandwidthLoadingError(false);
        const updatedData = response.data;
        for(const key in updatedData){
            const updatedKey = updatedData[key];
            updatedKey.abreviated_name = `${updatedKey.display_name.slice(0, 7)}...`;
            if (updatedKey.kbs) {
                const updatedKBS = Math.round(updatedKey.kbs / 10000) / 100;
                updatedKey.kbs = updatedKBS;
            }
        }
        setBandwidthData(updatedData);
        setLoadingBandwidthData(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setLoadingBandwidthData(false);
            setBandwidthLoadingError(true);
        });
    });
    const functionalityAfterAllResolved = (resolvedOlderUnhealthyCamsData, cameraStatsData)=>{
        const healthCheckSitesSorted = (0, $8a06d9beefbfc894$export$55525f7b84e38fa9)(filters, resolvedOlderUnhealthyCamsData);
        healthCheckSitesSorted.sort((a, b)=>{
            return Number(`${b.formatted_start_date.slice(6, 10)}${b.formatted_start_date.slice(3, 5)}${b.formatted_start_date.slice(0, 2)}${$67f834272aa34a6e$export$985fc4c1c7a3a77a(b.formatted_start_date.slice(11, 13), b.formatted_start_date.slice(19, 21))}${b.formatted_start_date.slice(14, 16)}${b.formatted_start_date.slice(17, 19)}`) - Number(`${a.formatted_start_date.slice(6, 10)}${a.formatted_start_date.slice(3, 5)}${a.formatted_start_date.slice(0, 2)}${$67f834272aa34a6e$export$985fc4c1c7a3a77a(a.formatted_start_date.slice(11, 13), a.formatted_start_date.slice(19, 21))}${a.formatted_start_date.slice(14, 16)}${a.formatted_start_date.slice(17, 19)}`);
        });
        const filterDuplicatesAndUnhealthy = (arr)=>{
            const uniqueCombinations = {};
            return arr.filter((obj)=>{
                const key = obj.camera_id + obj.error_type + obj.created_timestamp;
                if (obj.status === "healthy") return false;
                if (uniqueCombinations[key]) return false;
                else {
                    uniqueCombinations[key] = true;
                    return true;
                }
            });
        };
        const sortedAndNonDuplictdHealthCheckSites = filterDuplicatesAndUnhealthy(healthCheckSitesSorted);
        const cameraFilteredData = sortedAndNonDuplictdHealthCheckSites.filter((camera)=>camera.camera_id === Number(filters.camera));
        const newAlertsData = filters.camera ? {
            all: (0, $1c8c8d23486a2b93$export$bc0181ac37992f1)(cameraFilteredData),
            errors: (0, $1c8c8d23486a2b93$export$3d21b7cdecda7bf0)(cameraFilteredData),
            warnings: (0, $1c8c8d23486a2b93$export$6addae8b33e5b695)(cameraFilteredData),
            pending: (0, $1c8c8d23486a2b93$export$ef2bd9189ca85cfc)(cameraFilteredData),
            resolved: (0, $1c8c8d23486a2b93$export$3674d01f8b8470a1)(cameraFilteredData)
        } : {
            all: (0, $1c8c8d23486a2b93$export$bc0181ac37992f1)(sortedAndNonDuplictdHealthCheckSites),
            errors: (0, $1c8c8d23486a2b93$export$3d21b7cdecda7bf0)(sortedAndNonDuplictdHealthCheckSites),
            warnings: (0, $1c8c8d23486a2b93$export$6addae8b33e5b695)(sortedAndNonDuplictdHealthCheckSites),
            pending: (0, $1c8c8d23486a2b93$export$ef2bd9189ca85cfc)(sortedAndNonDuplictdHealthCheckSites),
            resolved: (0, $1c8c8d23486a2b93$export$3674d01f8b8470a1)(sortedAndNonDuplictdHealthCheckSites)
        };
        setAlertsData(newAlertsData);
        (0, $6ea8bc2ad1052ffd$export$7c253626761b7bf9)(newAlertsData, setErrorsOverviewData);
        (0, $82a36171a8cf0b7a$export$474f7cb3f9dd064b)(cameraStatsData, setCameraStatsData, setLoadingCameraStatsData, tempShowSiteStats, filters, newAlertsData.all);
        (0, $5ea6299425b2a6d2$export$815ef45b734c5d65)(setSearchParams, setAlertStatusDialogOpen, newAlertsData, setSelectedRowIndex, setSelectedRow, setNotesValue, setBackgroundFrame, setDetectedFrame, setNoAlertsDialogOpen, setClickedTab, navigate);
        setFectchingAllData(false);
    };
    AxiosUI.get(`healthcheck_result/rollup/${searchQueryString}`).then((response)=>{
        setUnhealthyCamsData(response.data.unhealthy_cams);
        const cameraStatsData = response.data.camera_stats;
        const healthCheckSitesWithSeverity = (0, $a10397fbf3df1ab2$export$b3e02ac8bc6acd25)(response.data.healthcheck_sites);
        const resolvedOlderUnhealthyCamsData = [
            ...healthCheckSitesWithSeverity
        ];
        if (cameraStatsData.length === 0) setLoadingCameraStatsData(false);
        if (resolvedOlderUnhealthyCamsData[0]) {
            let finalIndex = 0;
            let totalFound = 0;
            resolvedOlderUnhealthyCamsData.forEach((alert1, index)=>{
                if (alert1.status === "pending") {
                    if (alert1.error_type === "connectivity" && $67f834272aa34a6e$export$f60a425dad8947cf(alert1.start_timestamp) || alert1.error_type === "scene_change" && $67f834272aa34a6e$export$f60a425dad8947cf(alert1.end_timestamp)) {
                        finalIndex = index;
                        totalFound++;
                    }
                }
            });
            if (totalFound === 0) functionalityAfterAllResolved(resolvedOlderUnhealthyCamsData, cameraStatsData);
            else resolvedOlderUnhealthyCamsData.forEach((alert1, index)=>{
                const newAlert = {
                    ...alert1
                };
                const previousAlert = {
                    ...alert1
                };
                if (alert1.status) {
                    if (alert1.status === "pending") {
                        if (alert1.error_type === "connectivity" && $67f834272aa34a6e$export$f60a425dad8947cf(alert1.start_timestamp) || alert1.error_type === "scene_change" && $67f834272aa34a6e$export$f60a425dad8947cf(alert1.end_timestamp)) {
                            newAlert.status = "resolved";
                            // newAlert.formatted_end_date = getCurrentTime();
                            if (alert1.notes) newAlert.notes = alert1.notes + " Resolved automatically after 24 hours.";
                            else newAlert.notes = "Resolved automatically after 24 hours.";
                            AxiosUI.post(`/healthcheck_result/update_healthcheck/?camera_id=${alert1.camera_id}&created_timestamp=${alert1.created_timestamp}&healthcheck_type=${alert1.error_type}&status=${alert1.status}`, newAlert).then(()=>{
                                if (!newAlert.formatted_end_date) newAlert.formatted_end_date = $67f834272aa34a6e$export$a86190deb5c4a8d0();
                                resolvedOlderUnhealthyCamsData[index] = newAlert;
                                if (index === finalIndex) functionalityAfterAllResolved(resolvedOlderUnhealthyCamsData, cameraStatsData);
                            }, (reason)=>{
                                (0, $ebTQj.logger).log("Reason: ", reason);
                                resolvedOlderUnhealthyCamsData[index] = previousAlert;
                                if (index === finalIndex) functionalityAfterAllResolved(resolvedOlderUnhealthyCamsData, cameraStatsData);
                            });
                        }
                    }
                }
            });
        } else {
            setAlertsData({
                all: [],
                errors: [],
                warnings: [],
                pending: [],
                resolved: []
            });
            setFectchingAllData(false);
        }
    }, (reason)=>{
        if (reason.response?.status === 0 || reason.response?.status === 502) {
            (0, $ebTQj.logger).error("API timeout - Data request timed out, likely due to large dataset");
            // Set both states to false as requested
            setFectchingAllData(false);
            setFiltersApplied(false);
            setFectchingAllData(false);
            setLoadingCameraStatsData(false);
            alert("Data request timed out, likely due to large dataset. Try setting filters to a smaller time range.");
            return;
        }
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setFectchingAllData(false);
            setLoadingCameraStatsData(false);
        });
    // }
    });
};


parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");

var $5L5iJ = parcelRequire("5L5iJ");
const $b232a2fa3ad35646$export$1e752cf26bbb2ef6 = (userFilters, setDownloadURL, setFetchingDownloadReport, navigate)=>{
    const retryFunction = ()=>{
        $b232a2fa3ad35646$export$1e752cf26bbb2ef6(userFilters, setDownloadURL, setFetchingDownloadReport, navigate);
    };
    const AxiosUI = (0, $195EM.createApi)(``);
    if (userFilters?.parent_group) {
        setFetchingDownloadReport(true);
        const queryParams = new URLSearchParams({
            group: userFilters.parent_group
        });
        if (userFilters.site) queryParams.append("site", userFilters.site);
        if (userFilters.start_date) queryParams.append("start_date", (0, $5L5iJ.yyyymmddGenerator)(userFilters.start_date));
        if (userFilters.end_date) queryParams.append("end_date", (0, $5L5iJ.yyyymmddGenerator)(userFilters.end_date));
        AxiosUI.get(`healthcheck_result/download/?${queryParams.toString()}`).then((response)=>{
            setDownloadURL(response.data.url);
            setFetchingDownloadReport(false);
        }, (reason)=>{
            setFetchingDownloadReport(false);
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
        });
    } else setFetchingDownloadReport(false);
};



const $b44c05f5a5e884ad$export$d361b4384a0b664 = ({ userFilters: userFilters, setUserFilters: setUserFilters, setErrorsOverviewData: setErrorsOverviewData, setCameraStatsData: setCameraStatsData, setLoadingCameraStatsData: setLoadingCameraStatsData, setUnhealthyCamsData: setUnhealthyCamsData, setAlertsData: setAlertsData, setFectchingAllData: setFectchingAllData, setActiveTable: setActiveTable, setAlertStatusDialogOpen: setAlertStatusDialogOpen, setSelectedRow: setSelectedRow, setSelectedRowIndex: setSelectedRowIndex, setUpdatingStatus: setUpdatingStatus, setBandwidthData: setBandwidthData, setLoadingBandwidthData: setLoadingBandwidthData, setShowSiteStats: setShowSiteStats, setSingleCellActivated: setSingleCellActivated, setActiveName: setActiveName, cameraDropDownValue: cameraDropDownValue, setDownloadURL: setDownloadURL, setFetchingDownloadReport: setFetchingDownloadReport, searchParams: searchParams, setSearchParams: setSearchParams, metricsSelected: metricsSelected, setBandwidthLoadingError: setBandwidthLoadingError, setNotesValue: setNotesValue, setBackgroundFrame: setBackgroundFrame, setDetectedFrame: setDetectedFrame, setNoAlertsDialogOpen: setNoAlertsDialogOpen, setFiltersApplied: setFiltersApplied, setClickedTab: setClickedTab, navigate: navigate })=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)("button", {
        className: "shadow-button bg-actuate-orange border-2 border-actuate-orange rounded font-mulish text-white text-base p-1.5 w-[120px] hover:bg-[#E67300]",
        onClick: ()=>{
            setFiltersApplied(true);
            (0, $361dd3e7be612e92$export$59b2b76630cf930b)({
                parent_group: userFilters.parent_group,
                site: userFilters.site,
                camera: userFilters.camera,
                metrics: metricsSelected,
                start_date: userFilters.start_date,
                end_date: userFilters.end_date
            }, searchParams, setSearchParams, "");
            setDownloadURL("");
            (0, $b232a2fa3ad35646$export$1e752cf26bbb2ef6)(userFilters, setDownloadURL, setFetchingDownloadReport, navigate);
            setSingleCellActivated(false);
            setActiveName("");
            setLoadingCameraStatsData(true);
            setFectchingAllData(true);
            setLoadingBandwidthData(true);
            setUserFilters((previousState)=>{
                return {
                    ...previousState,
                    metrics: metricsSelected
                };
            });
            setAlertsData({
                all: [],
                errors: [],
                warnings: [],
                pending: [],
                resolved: []
            });
            (0, $67f834272aa34a6e$export$78e1df0e572bda86)(setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setUnhealthyCamsData, setAlertsData, setFectchingAllData, {
                parent_group: userFilters.parent_group,
                site: userFilters.site,
                camera: userFilters.camera,
                metrics: metricsSelected,
                start_date: userFilters.start_date,
                end_date: userFilters.end_date
            }, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setUpdatingStatus, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setBandwidthLoadingError, setSearchParams, setNotesValue, setBackgroundFrame, setDetectedFrame, setNoAlertsDialogOpen, setClickedTab, setFiltersApplied, navigate);
        },
        disabled: false,
        children: "Apply Filters"
    });
};




var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $anJSP = parcelRequire("anJSP");

var $ddLR4 = parcelRequire("ddLR4");

var $3IuQ3 = parcelRequire("3IuQ3");

var $f3puC = parcelRequire("f3puC");
const $4961a0ad31373e5c$var$ErrorsWarningToggle = ({ setErrorWarningData: setErrorWarningData })=>{
    const AntSwitch = (0, $anJSP.default)((0, $ddLR4.default))(({ theme: theme })=>({
            width: 28,
            height: 16,
            padding: 0,
            display: "flex",
            "&:active": {
                "& .MuiSwitch-thumb": {
                    width: 15
                },
                "& .MuiSwitch-switchBase.Mui-checked": {
                    transform: "translateX(9px)"
                }
            },
            "& .MuiSwitch-switchBase": {
                padding: 2,
                "&.Mui-checked": {
                    transform: "translateX(12px)",
                    color: "#fff",
                    "& + .MuiSwitch-track": {
                        opacity: 1,
                        backgroundColor: "#F44336"
                    }
                }
            },
            "& .MuiSwitch-thumb": {
                boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
                width: 12,
                height: 12,
                borderRadius: 6,
                transition: theme.transitions.create([
                    "width"
                ], {
                    duration: 200
                })
            },
            "& .MuiSwitch-track": {
                borderRadius: 8,
                opacity: 1,
                backgroundColor: "#FF8400",
                boxSizing: "border-box"
            }
        }));
    const [warningsOn, setWarningsOn] = $8T3gX.useState(true);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3IuQ3.default), {
        direction: "row",
        spacing: 1,
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                className: "text-actuate-orange ",
                children: "Warnings"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)(AntSwitch, {
                checked: warningsOn,
                inputProps: {
                    "aria-label": "ant design"
                },
                onChange: (event, value)=>{
                    if (value) {
                        setWarningsOn(true);
                        setErrorWarningData("error");
                    } else {
                        setWarningsOn(false);
                        setErrorWarningData("warning");
                    }
                }
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                className: "text-[#F44336] ",
                children: "Errors"
            })
        ]
    });
};
var $4961a0ad31373e5c$export$2e2bcd8739ae039 = $4961a0ad31373e5c$var$ErrorsWarningToggle;



const $090c97a3a87e46af$export$da471478d5e7b7db = ({ errorsOverviewData: errorsOverviewData, errorWarningData: errorWarningData, setErrorWarningData: setErrorWarningData, navBarCollapsed: navBarCollapsed, userFilters: userFilters })=>{
    const errorData = [];
    if (userFilters.metrics.includes("Connectivity")) errorData.push({
        quantity: errorsOverviewData.connectivity,
        display_name: "Connectivity"
    });
    if (userFilters.metrics.includes("Scene Change")) errorData.push({
        quantity: errorsOverviewData.scene_change,
        display_name: "Scene Change"
    });
    const warningData = [];
    if (userFilters.metrics.length === 0) {
        errorData.push({
            quantity: errorsOverviewData.connectivity,
            display_name: "Connectivity"
        });
        errorData.push({
            quantity: errorsOverviewData.scene_change,
            display_name: "Scene Change"
        });
        warningData.push({
            quantity: errorsOverviewData.motion_status,
            display_name: "Motion Status"
        });
        warningData.push({
            quantity: errorsOverviewData.image_quality,
            display_name: "Image Quality"
        });
        warningData.push({
            quantity: errorsOverviewData.stream_quality,
            display_name: "Stream Quality"
        });
        warningData.push({
            quantity: errorsOverviewData.recording_status,
            display_name: "Recording Status"
        });
    }
    if (userFilters.metrics.includes("Motion Status")) warningData.push({
        quantity: errorsOverviewData.motion_status,
        display_name: "Motion Status"
    });
    if (userFilters.metrics.includes("Image Quality")) warningData.push({
        quantity: errorsOverviewData.image_quality,
        display_name: "Image Quality"
    });
    if (userFilters.metrics.includes("Stream Quality")) warningData.push({
        quantity: errorsOverviewData.stream_quality,
        display_name: "Stream Quality"
    });
    if (userFilters.metrics.includes("Recording Status")) warningData.push({
        quantity: errorsOverviewData.recording_status,
        display_name: "Recording Status"
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: !navBarCollapsed ? "absolute top-[50px] left-[20px] right-[1px] h-[425px] w-[610px] bg-[#BDBDBD]" : "absolute top-[50px] left-[20px] right-[1px] h-[425px] w-[648px] bg-[#BDBDBD]",
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: !navBarCollapsed ? "absolute top-[1px] left-[1px] right-[1px] h-[423px] w-[608px] bg-white" : "absolute top-[1px] left-[1px] right-[1px] h-[423px] w-[646px] bg-white",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "text-actuate-blue font-mulish text-[22px] font-bold absolute top-[8px] left-[30px]",
                    children: errorWarningData === "warning" ? `Warnings Overview` : `Errors Overview`
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "text-actuate-blue font-mulish text-[14px] absolute top-[40px] left-[31px]",
                    children: errorWarningData === "warning" ? `Warnings are non-fatal and lower priority issues that should still be attended to in a timely manner.` : `Errors are fatal issues that prevent the proper monitoring of cameras and require immediate attention.`
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: navBarCollapsed ? "absolute top-[12px] left-[468px]" : "absolute top-[12px] left-[430px]",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4961a0ad31373e5c$export$2e2bcd8739ae039), {
                        setErrorWarningData: setErrorWarningData
                    })
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: !navBarCollapsed ? "absolute top-[90px] left-[10px] h-[340px] w-[590px] overflow-scroll scrollbar-hide" : "absolute top-[90px] left-[10px] h-[340px] w-[618px] overflow-scroll scrollbar-hide",
                    children: errorWarningData === "warning" ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $dc284d0fb10e6f6a$export$94aefc399ef206a9), {
                        width: !navBarCollapsed ? 580 : 618,
                        height: 330,
                        data: warningData,
                        barSize: 120,
                        margin: {
                            top: 5,
                            right: 0,
                            left: 18,
                            bottom: 5
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $381060c808bbe825$export$6440e27b9f186856), {
                                strokeDasharray: "3 3"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $e3fbaf009dcc8585$export$ea77231de273b52d), {
                                dataKey: "display_name",
                                type: "category"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $c7554316bfb1649b$export$f96c4024c52de8f4), {
                                allowDecimals: false,
                                label: {
                                    value: "Warnings Volume",
                                    angle: -90,
                                    position: "insideLeft",
                                    offset: -10
                                }
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $45dbb8bb277f9d9d$export$28c660c63b792dea), {}),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $7d5fe63ca2eb078d$export$bbc6c6369b38e3d1), {
                                // cursor="pointer"
                                dataKey: "quantity",
                                fill: "#FF8400",
                                name: "Warnings",
                                onClick: ()=>{}
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $k4ank.jsxs)((0, $dc284d0fb10e6f6a$export$94aefc399ef206a9), {
                        width: !navBarCollapsed ? 580 : 618,
                        height: 330,
                        data: errorData,
                        barSize: 120,
                        margin: {
                            top: 5,
                            right: 0,
                            left: 18,
                            bottom: 5
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $381060c808bbe825$export$6440e27b9f186856), {
                                strokeDasharray: "3 3"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $e3fbaf009dcc8585$export$ea77231de273b52d), {
                                dataKey: "display_name",
                                type: "category"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $c7554316bfb1649b$export$f96c4024c52de8f4), {
                                allowDecimals: false,
                                label: {
                                    value: "Errors Volume",
                                    angle: -90,
                                    position: "insideLeft",
                                    offset: -10
                                }
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $45dbb8bb277f9d9d$export$28c660c63b792dea), {}),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $7d5fe63ca2eb078d$export$bbc6c6369b38e3d1), {
                                // cursor="pointer"
                                dataKey: "quantity",
                                fill: "#F44336",
                                name: "Errors",
                                onClick: ()=>{}
                            })
                        ]
                    })
                })
            ]
        })
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $60vL1 = parcelRequire("60vL1");


var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

const $28694d530352034f$export$5db079623073b7f0 = (array, sortString)=>{
    return array.sort((a, b)=>b[sortString] - a[sortString]);
};


const $bd67b430f762760e$export$679dbe3e1db9c825 = ({ bandwidthData: bandwidthData })=>{
    const calculatedWidth = bandwidthData.length < 5 ? 580 : bandwidthData.length * 145;
    const [sortedData, setSortedData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(bandwidthData);
    const [currentBandwidthSort, setCurrentBandwidthSort] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(`Volume (High to Low)`);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        (0, $28694d530352034f$export$5db079623073b7f0)(bandwidthData, "kbs");
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $dc284d0fb10e6f6a$export$94aefc399ef206a9), {
            width: calculatedWidth,
            height: 375,
            data: sortedData,
            barSize: 120,
            margin: {
                top: 55,
                right: 0,
                left: 18,
                bottom: 25
            },
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $381060c808bbe825$export$6440e27b9f186856), {
                    strokeDasharray: "3 3"
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $e3fbaf009dcc8585$export$ea77231de273b52d), {
                    dataKey: "display_name",
                    type: "category",
                    hide: true
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $c7554316bfb1649b$export$f96c4024c52de8f4), {
                    label: {
                        value: "Bandwidth Usage",
                        angle: -90,
                        position: "insideLeft",
                        offset: -10
                    },
                    scale: "sqrt"
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $45dbb8bb277f9d9d$export$28c660c63b792dea), {}),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $7d5fe63ca2eb078d$export$bbc6c6369b38e3d1), {
                    // cursor="pointer"
                    dataKey: "kbs",
                    fill: "#CD4A81",
                    name: "GB",
                    onClick: ()=>{},
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1778bc5734fdac4c$export$835fcf23ab7bf88), {
                        dataKey: "abreviated_name",
                        position: "bottom"
                    })
                })
            ]
        })
    });
};



var $8jTCz = parcelRequire("8jTCz");
parcelRequire("8T3gX");

var $5L5iJ = parcelRequire("5L5iJ");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $20fcf34ce8546236$export$9cbac8653de80e85 = (filters, setBandwidthData, setLoadingBandwidthData, setBandwidthLoadingError, navigate)=>{
    let searchQueryString = `?start_date=${(0, $5L5iJ.yyyymmddGenerator)(filters.start_date)}&end_date=${(0, $5L5iJ.yyyymmddGenerator)(filters.end_date)}`;
    if (filters.parent_group) searchQueryString += `&group=${filters.parent_group}`;
    if (filters.site) searchQueryString += `&site=${filters.site}`;
    if (filters.camera) searchQueryString += `&camera=${filters.camera}`;
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $20fcf34ce8546236$export$9cbac8653de80e85(filters, setBandwidthData, setLoadingBandwidthData, setBandwidthLoadingError, navigate);
    };
    AxiosUI.get(`analytics/data_usage/${searchQueryString}&limit=20`).then((response)=>{
        setBandwidthLoadingError(false);
        const updatedData = response.data;
        for(const key in updatedData){
            const updatedKey = updatedData[key];
            updatedKey.abreviated_name = `${updatedKey.display_name.slice(0, 7)}...`;
            if (updatedKey.kbs) {
                const updatedKBS = Math.round(updatedKey.kbs / 10000) / 100;
                updatedKey.kbs = updatedKBS;
            }
        }
        setBandwidthData(updatedData);
        setLoadingBandwidthData(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setLoadingBandwidthData(false);
            setBandwidthLoadingError(true);
        });
    });
};


const $83e3dc0b11863bfc$export$887438ac3c872c46 = ({ bandwidthData: bandwidthData, loadingBandwidthData: loadingBandwidthData, navBarCollapsed: navBarCollapsed, bandwidthLoadingError: bandwidthLoadingError, setLoadingBandwidthData: setLoadingBandwidthData, setBandwidthLoadingError: setBandwidthLoadingError, filters: filters, setBandwidthData: setBandwidthData, navigate: navigate })=>{
    const retryText = /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9222626528c451ae$exports))), {
                fontSize: "small"
            }),
            "\xa0Retry"
        ]
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: !navBarCollapsed ? "absolute top-[50px] left-[20px] right-[1px] h-[425px] w-[610px] bg-[#BDBDBD]" : "absolute top-[50px] left-[58px] right-[1px] h-[425px] w-[647px] bg-[#BDBDBD]",
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: !navBarCollapsed ? "absolute top-[1px] left-[1px] right-[1px] h-[423px] w-[608px] bg-white" : "absolute top-[1px] left-[1px] right-[1px] h-[423px] w-[645px] bg-white",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "text-actuate-blue font-mulish text-[22px] font-bold absolute top-[8px] left-[30px]",
                    children: "Bandwidth by Site"
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "text-actuate-blue font-mulish text-[14px] absolute top-[40px] left-[31px]",
                    children: "Bandwidth used in GB over selected dates."
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: !navBarCollapsed ? "absolute top-[25px] left-[10px] h-[380px] w-[590px] overflow-scroll scrollbar-hide" : "absolute top-[25px] left-[10px] h-[380px] w-[617px] overflow-scroll scrollbar-hide",
                    children: [
                        !loadingBandwidthData && !bandwidthLoadingError && /*#__PURE__*/ (0, $k4ank.jsx)((0, $bd67b430f762760e$export$679dbe3e1db9c825), {
                            bandwidthData: bandwidthData
                        }),
                        !loadingBandwidthData && bandwidthLoadingError && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "absolute top-[170px] left-[200px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "font-mulish text-actuate-blue test-bold text-[20px]",
                                    children: "Error fetching data."
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "pl-[35px]",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                        onClick: ()=>{
                                            setLoadingBandwidthData(true);
                                            setBandwidthLoadingError(false);
                                            (0, $20fcf34ce8546236$export$9cbac8653de80e85)(filters, setBandwidthData, setLoadingBandwidthData, setBandwidthLoadingError, navigate);
                                        },
                                        text: retryText,
                                        disabled: false
                                    })
                                })
                            ]
                        }),
                        loadingBandwidthData && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "absolute top-[170px] left-[230px]",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                    size: 25,
                                    sx: {
                                        position: "relative",
                                        left: 40
                                    }
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "font-mulish text-actuate-blue test-bold",
                                    children: "Fetching Data..."
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $a65wX = parcelRequire("a65wX");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");
/* eslint-env browser */ 
var $8T3gX = parcelRequire("8T3gX");

var $8T3gX = parcelRequire("8T3gX");
function $212c78737ca263de$export$90fc3a17d93f704c(handler) {
    // istanbul ignore next
    if (typeof window === 'undefined') // useLayoutEffect doesn't work on the server side, don't bother
    // trying to make callback functions stable
    return handler;
    const handlerRef = $8T3gX.useRef(null);
    $8T3gX.useLayoutEffect(()=>{
        handlerRef.current = handler;
    });
    return $8T3gX.useCallback((...args)=>{
        var _handlerRef$current;
        (_handlerRef$current = handlerRef.current) === null || _handlerRef$current === void 0 || _handlerRef$current.call(handlerRef, ...args);
    }, []);
}


const $6d64378f74892bd3$var$printedWarnings = {};
function $6d64378f74892bd3$var$warn(key, message) {
    if ($6d64378f74892bd3$var$printedWarnings[key]) return;
    $6d64378f74892bd3$var$printedWarnings[key] = true;
    // eslint-disable-next-line no-console
    console.error('[material-ui-popup-state] WARNING', message);
}
const $6d64378f74892bd3$export$46b52ca915760e7c = {
    isOpen: false,
    setAnchorElUsed: false,
    anchorEl: undefined,
    anchorPosition: undefined,
    hovered: false,
    focused: false,
    _openEventType: null,
    _childPopupState: null,
    _deferNextOpen: false,
    _deferNextClose: false
};
// https://github.com/jcoreio/material-ui-popup-state/issues/138
// Webpack prod build doesn't like it if we refer to React.useId conditionally,
// but aliasing to a variable like this works
const $6d64378f74892bd3$var$_react = $8T3gX;
const $6d64378f74892bd3$var$defaultPopupId = 'useId' in $6d64378f74892bd3$var$_react ? ()=>$6d64378f74892bd3$var$_react.useId() : ()=>undefined;
function $6d64378f74892bd3$export$1b18525a6259c687({ parentPopupState: parentPopupState, popupId: popupId = $6d64378f74892bd3$var$defaultPopupId(), variant: variant, disableAutoFocus: disableAutoFocus }) {
    const isMounted = (0, $8T3gX.useRef)(true);
    (0, $8T3gX.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    const [state, _setState] = (0, $8T3gX.useState)($6d64378f74892bd3$export$46b52ca915760e7c);
    const setState = (0, $8T3gX.useCallback)((state)=>{
        if (isMounted.current) _setState(state);
    }, []);
    const setAnchorEl = (0, $8T3gX.useCallback)((anchorEl)=>setState((state)=>({
                ...state,
                setAnchorElUsed: true,
                anchorEl: anchorEl ?? undefined
            })), []);
    const toggle = (0, $212c78737ca263de$export$90fc3a17d93f704c)((eventOrAnchorEl)=>{
        if (state.isOpen) close(eventOrAnchorEl);
        else open(eventOrAnchorEl);
        return state;
    });
    const open = (0, $212c78737ca263de$export$90fc3a17d93f704c)((eventOrAnchorEl)=>{
        const event = eventOrAnchorEl instanceof Element ? undefined : eventOrAnchorEl;
        const element = eventOrAnchorEl instanceof Element ? eventOrAnchorEl : (eventOrAnchorEl === null || eventOrAnchorEl === void 0 ? void 0 : eventOrAnchorEl.currentTarget) instanceof Element ? eventOrAnchorEl.currentTarget : undefined;
        if ((event === null || event === void 0 ? void 0 : event.type) === 'touchstart') {
            setState((state)=>({
                    ...state,
                    _deferNextOpen: true
                }));
            return;
        }
        const clientX = event === null || event === void 0 ? void 0 : event.clientX;
        const clientY = event === null || event === void 0 ? void 0 : event.clientY;
        const anchorPosition = typeof clientX === 'number' && typeof clientY === 'number' ? {
            left: clientX,
            top: clientY
        } : undefined;
        const doOpen = (state)=>{
            if (!eventOrAnchorEl && !state.setAnchorElUsed && variant !== 'dialog') $6d64378f74892bd3$var$warn('missingEventOrAnchorEl', 'eventOrAnchorEl should be defined if setAnchorEl is not used');
            if (parentPopupState) {
                if (!parentPopupState.isOpen) return state;
                setTimeout(()=>parentPopupState._setChildPopupState(popupState));
            }
            const newState = {
                ...state,
                isOpen: true,
                anchorPosition: anchorPosition,
                hovered: (event === null || event === void 0 ? void 0 : event.type) === 'mouseover' || state.hovered,
                focused: (event === null || event === void 0 ? void 0 : event.type) === 'focus' || state.focused,
                _openEventType: event === null || event === void 0 ? void 0 : event.type
            };
            if (!state.setAnchorElUsed) {
                if (event !== null && event !== void 0 && event.currentTarget) newState.anchorEl = event.currentTarget;
                else if (element) newState.anchorEl = element;
            }
            return newState;
        };
        setState((state)=>{
            if (state._deferNextOpen) {
                setTimeout(()=>setState(doOpen), 0);
                return {
                    ...state,
                    _deferNextOpen: false
                };
            } else return doOpen(state);
        });
    });
    const doClose = (state)=>{
        const { _childPopupState: _childPopupState } = state;
        setTimeout(()=>{
            _childPopupState === null || _childPopupState === void 0 || _childPopupState.close();
            parentPopupState === null || parentPopupState === void 0 || parentPopupState._setChildPopupState(null);
        });
        return {
            ...state,
            isOpen: false,
            hovered: false,
            focused: false
        };
    };
    const close = (0, $212c78737ca263de$export$90fc3a17d93f704c)((eventOrAnchorEl)=>{
        const event = eventOrAnchorEl instanceof Element ? undefined : eventOrAnchorEl;
        if ((event === null || event === void 0 ? void 0 : event.type) === 'touchstart') {
            setState((state)=>({
                    ...state,
                    _deferNextClose: true
                }));
            return;
        }
        setState((state)=>{
            if (state._deferNextClose) {
                setTimeout(()=>setState(doClose), 0);
                return {
                    ...state,
                    _deferNextClose: false
                };
            } else return doClose(state);
        });
    });
    const setOpen = (0, $8T3gX.useCallback)((nextOpen, eventOrAnchorEl)=>{
        if (nextOpen) open(eventOrAnchorEl);
        else close(eventOrAnchorEl);
    }, []);
    const onMouseLeave = (0, $212c78737ca263de$export$90fc3a17d93f704c)((event)=>{
        const { relatedTarget: relatedTarget } = event;
        setState((state)=>{
            if (state.hovered && !(relatedTarget instanceof Element && $6d64378f74892bd3$var$isElementInPopup(relatedTarget, popupState))) {
                if (state.focused) return {
                    ...state,
                    hovered: false
                };
                else return doClose(state);
            }
            return state;
        });
    });
    const onBlur = (0, $212c78737ca263de$export$90fc3a17d93f704c)((event)=>{
        if (!event) return;
        const { relatedTarget: relatedTarget } = event;
        setState((state)=>{
            if (state.focused && !(relatedTarget instanceof Element && $6d64378f74892bd3$var$isElementInPopup(relatedTarget, popupState))) {
                if (state.hovered) return {
                    ...state,
                    focused: false
                };
                else return doClose(state);
            }
            return state;
        });
    });
    const _setChildPopupState = (0, $8T3gX.useCallback)((_childPopupState)=>setState((state)=>({
                ...state,
                _childPopupState: _childPopupState
            })), []);
    const popupState = {
        ...state,
        setAnchorEl: setAnchorEl,
        popupId: popupId ?? undefined,
        variant: variant,
        open: open,
        close: close,
        toggle: toggle,
        setOpen: setOpen,
        onBlur: onBlur,
        onMouseLeave: onMouseLeave,
        disableAutoFocus: disableAutoFocus ?? Boolean(state.hovered || state.focused),
        _setChildPopupState: _setChildPopupState
    };
    return popupState;
}
function $6d64378f74892bd3$export$f55d1144cf1f13c9({ setAnchorEl: setAnchorEl }) {
    return setAnchorEl;
}
function $6d64378f74892bd3$var$controlAriaProps({ isOpen: isOpen, popupId: popupId, variant: variant }) {
    return {
        ...variant === 'popover' ? {
            'aria-haspopup': true,
            'aria-controls': isOpen ? popupId : undefined
        } : variant === 'popper' ? {
            'aria-describedby': isOpen ? popupId : undefined
        } : undefined
    };
}
function $6d64378f74892bd3$export$5ebf1c6bf19d91fc(popupState) {
    return {
        ...$6d64378f74892bd3$var$controlAriaProps(popupState),
        onClick: popupState.open,
        onTouchStart: popupState.open
    };
}
function $6d64378f74892bd3$export$33b28e62c000029b(popupState) {
    return {
        ...$6d64378f74892bd3$var$controlAriaProps(popupState),
        onContextMenu: (e)=>{
            e.preventDefault();
            popupState.open(e);
        }
    };
}
function $6d64378f74892bd3$export$565eb13a8048a500(popupState) {
    return {
        ...$6d64378f74892bd3$var$controlAriaProps(popupState),
        onClick: popupState.toggle,
        onTouchStart: popupState.toggle
    };
}
function $6d64378f74892bd3$export$f0ffae7e5dd44cf4(popupState) {
    const { open: open, onMouseLeave: onMouseLeave } = popupState;
    return {
        ...$6d64378f74892bd3$var$controlAriaProps(popupState),
        onTouchStart: open,
        onMouseOver: open,
        onMouseLeave: onMouseLeave
    };
}
function $6d64378f74892bd3$export$761b5c0b51043c74(popupState) {
    const { open: open, onBlur: onBlur } = popupState;
    return {
        ...$6d64378f74892bd3$var$controlAriaProps(popupState),
        onFocus: open,
        onBlur: onBlur
    };
}
function $6d64378f74892bd3$export$4c706dd6747d6da1({ isOpen: isOpen, open: open, popupId: popupId, variant: variant }) {
    return {
        // $FlowFixMe
        [variant === 'popover' ? 'aria-controls' : 'aria-describedby']: isOpen ? popupId : null,
        'aria-haspopup': variant === 'popover' ? true : undefined,
        onDoubleClick: open
    };
}
function $6d64378f74892bd3$export$834c28856744d16c({ isOpen: isOpen, anchorEl: anchorEl, anchorPosition: anchorPosition, close: close, popupId: popupId, onMouseLeave: onMouseLeave, disableAutoFocus: disableAutoFocus, _openEventType: _openEventType }) {
    const usePopoverPosition = _openEventType === 'contextmenu';
    return {
        id: popupId,
        anchorEl: anchorEl,
        anchorPosition: anchorPosition,
        anchorReference: usePopoverPosition ? 'anchorPosition' : 'anchorEl',
        open: isOpen,
        onClose: close,
        onMouseLeave: onMouseLeave,
        ...disableAutoFocus && {
            disableAutoFocus: true,
            disableEnforceFocus: true,
            disableRestoreFocus: true
        }
    };
}
function $6d64378f74892bd3$export$f356294d7f2e42e1({ isOpen: isOpen, anchorEl: anchorEl, anchorPosition: anchorPosition, close: close, popupId: popupId, onMouseLeave: onMouseLeave, disableAutoFocus: disableAutoFocus, _openEventType: _openEventType }) {
    const usePopoverPosition = _openEventType === 'contextmenu';
    return {
        id: popupId,
        anchorEl: anchorEl,
        anchorPosition: anchorPosition,
        anchorReference: usePopoverPosition ? 'anchorPosition' : 'anchorEl',
        open: isOpen,
        onClose: close,
        onMouseLeave: onMouseLeave,
        ...disableAutoFocus && {
            autoFocus: false,
            disableAutoFocusItem: true,
            disableAutoFocus: true,
            disableEnforceFocus: true,
            disableRestoreFocus: true
        }
    };
}
function $6d64378f74892bd3$export$3199cdaad2efc48e({ isOpen: isOpen, anchorEl: anchorEl, popupId: popupId, onMouseLeave: onMouseLeave }) {
    return {
        id: popupId,
        anchorEl: anchorEl,
        open: isOpen,
        onMouseLeave: onMouseLeave
    };
}
function $6d64378f74892bd3$export$3b3ae6f7899d06c7({ isOpen: isOpen, close: close }) {
    return {
        open: isOpen,
        onClose: close
    };
}
function $6d64378f74892bd3$var$getPopup(element, { popupId: popupId }) {
    if (!popupId) return null;
    const rootNode = typeof element.getRootNode === 'function' ? element.getRootNode() : document;
    if (typeof rootNode.getElementById === 'function') return rootNode.getElementById(popupId);
    return null;
}
function $6d64378f74892bd3$var$isElementInPopup(element, popupState) {
    const { anchorEl: anchorEl, _childPopupState: _childPopupState } = popupState;
    return $6d64378f74892bd3$var$isAncestor(anchorEl, element) || $6d64378f74892bd3$var$isAncestor($6d64378f74892bd3$var$getPopup(element, popupState), element) || _childPopupState != null && $6d64378f74892bd3$var$isElementInPopup(element, _childPopupState);
}
function $6d64378f74892bd3$var$isAncestor(parent, child) {
    if (!parent) return false;
    while(child){
        if (child === parent) return true;
        child = child.parentElement;
    }
    return false;
}


var $fdGrT = parcelRequire("fdGrT");

function $039b109a8b4e0079$export$2e2bcd8739ae039({ children: children, popupId: popupId, variant: variant, parentPopupState: parentPopupState, disableAutoFocus: disableAutoFocus }) {
    const popupState = (0, $6d64378f74892bd3$export$1b18525a6259c687)({
        popupId: popupId,
        variant: variant,
        parentPopupState: parentPopupState,
        disableAutoFocus: disableAutoFocus
    });
    const result = children(popupState);
    return result != null ? result : null;
}
$039b109a8b4e0079$export$2e2bcd8739ae039.propTypes = {
    /**
   * The render function.
   *
   * @param {object} props the properties injected by `PopupState`:
   * <ul>
   *   <li>`open(eventOrAnchorEl)`: opens the popup</li>
   *   <li>`close()`: closes the popup</li>
   *   <li>`toggle(eventOrAnchorEl)`: opens the popup if it is closed, or
   *     closes the popup if it is open.
   *   </li>
   *   <li>`setOpen(open, [eventOrAnchorEl])`: sets whether the popup is open.
   *     `eventOrAnchorEl` is required if `open` is truthy.
   *   </li>
   *   <li>`isOpen`: `true`/`false` if the popup is open/closed</li>
   *   <li>`anchorEl`: the current anchor element (`null` the popup is closed)</li>
   *   <li>`popupId`: the `popupId` prop you passed</li>
   * </ul>
   *
   * @returns {React.Node} the content to display
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func.isRequired,
    /**
   * The `id` property to use for the popup.  Will be passed to the render
   * function as `bindPopup.id`, and also used for the `aria-controls` property
   * passed to the trigger component via `bindTrigger`.
   */ popupId: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * Which type of popup you are controlling.  Use `'popover'` for `Popover`
   * and `Menu`; use `'popper'` for `Popper`s.  Right now this only affects
   * whether `aria-controls` or `aria-describedby` is used on the trigger
   * component.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'popover',
        'popper'
    ]).isRequired,
    /**
   * The popupState of the parent menu (for cascading menus)
   */ parentPopupState: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Will focus the popup when it opens unless disableAutoFocus is explicitly false.
   */ disableAutoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
};



const $be8a9e3d5cb47c9c$export$ae8e3af8685ef74a = (array, sortString)=>{
    return array.sort((a, b)=>a[sortString] - b[sortString]);
};


const $ebec43c5bca5dc10$export$90a8419b54150e3 = (array, sortString)=>{
    return array.sort((a, b)=>{
        return a[sortString].localeCompare(b[sortString]);
    });
};


const $8e7bd9660f3c73c1$export$d052c7c5449ddde5 = (array, sortString)=>{
    return array.sort((a, b)=>{
        return b[sortString].localeCompare(a[sortString]);
    });
};


const $ee9a771e2956a24e$export$9e621b76b2a3ce09 = ({ currentSort: currentSort, setCurrentSort: setCurrentSort, setSortedData: setSortedData, volumeSortString: volumeSortString, nameSortString: nameSortString, data: data })=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $039b109a8b4e0079$export$2e2bcd8739ae039), {
        variant: "popover",
        children: (popupState)=>/*#__PURE__*/ (0, $k4ank.jsxs)($8T3gX.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                        variant: "outlined",
                        color: "warning",
                        sx: {
                            minWidth: 200
                        },
                        ...(0, $6d64378f74892bd3$export$5ebf1c6bf19d91fc)(popupState),
                        children: currentSort
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                        ...(0, $6d64378f74892bd3$export$f356294d7f2e42e1)(popupState),
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                id: "high_to_low_item",
                                onClick: ()=>{
                                    popupState.close;
                                    setCurrentSort(`Volume (High to Low)`);
                                    setSortedData((0, $28694d530352034f$export$5db079623073b7f0)(data, volumeSortString));
                                },
                                children: `Volume (High to Low)`
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                id: "low_to_high_item",
                                onClick: ()=>{
                                    popupState.close;
                                    setCurrentSort(`Volume (Low to High)`);
                                    setSortedData((0, $be8a9e3d5cb47c9c$export$ae8e3af8685ef74a)(data, volumeSortString));
                                },
                                children: `Volume (Low to High)`
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                id: "a_to_z_item",
                                onClick: ()=>{
                                    popupState.close;
                                    setCurrentSort(`Site Name (A to Z)`);
                                    setSortedData((0, $ebec43c5bca5dc10$export$90a8419b54150e3)(data, nameSortString));
                                },
                                children: `Site Name (A to Z)`
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                id: "z_to_a_item",
                                onClick: ()=>{
                                    popupState.close;
                                    setCurrentSort(`Site Name (Z to A)`);
                                    setSortedData((0, $8e7bd9660f3c73c1$export$d052c7c5449ddde5)(data, nameSortString));
                                },
                                children: `Site Name (Z to A)`
                            })
                        ]
                    })
                ]
            })
    });
};





var $60vL1 = parcelRequire("60vL1");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $1wcxl = parcelRequire("1wcxl");

var $4o6Cs = parcelRequire("4o6Cs");

var $4reBM = parcelRequire("4reBM");

var $fWsn7 = parcelRequire("fWsn7");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");
var $kbChx = parcelRequire("kbChx");
var $aVDw9 = parcelRequire("aVDw9");
var $ha39s = parcelRequire("ha39s");
var $4o6Cs = parcelRequire("4o6Cs");
var $kLvBh = parcelRequire("kLvBh");

var $9lVTU = parcelRequire("9lVTU");

var $iKAtE = parcelRequire("iKAtE");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");

var $i5MAs = parcelRequire("i5MAs");

var $aYdit = parcelRequire("aYdit");
const $9e37f361caa9aba0$var$headCells = [
    {
        id: "display_name",
        numeric: false,
        label: "Site"
    },
    {
        id: "camera_name",
        numeric: false,
        label: "Camera"
    },
    {
        id: "formatted_start_date",
        numeric: false,
        label: `Start Time`
    },
    {
        id: "formatted_end_date",
        numeric: false,
        label: `End Time`
    },
    {
        id: "error_type",
        numeric: false,
        label: "Alert Type"
    },
    {
        id: "severity",
        numeric: true,
        label: "Severity"
    },
    {
        id: "status",
        numeric: false,
        label: "Status"
    }
];
const $9e37f361caa9aba0$export$dadd0b4ac15beece = ({ onRequestSort: onRequestSort, orderBy: orderBy, order: order, activeData: activeData, setSelected: setSelected, setAlertsArray: setAlertsArray })=>{
    const { setDateMMDDYYYY: setDateMMDDYYYY } = (0, $aYdit.useAppStore)();
    // State and handlers for Start Time menu
    const [startTimeAnchorEl, setStartTimeAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const startTimeOpen = Boolean(startTimeAnchorEl);
    const handleStartTimeClick = (event)=>{
        event.stopPropagation(); // Stop event propagation to prevent table sorting
        setStartTimeAnchorEl(event.currentTarget);
    };
    const handleStartTimeClose = (event)=>{
        event.stopPropagation(); // Stop event propagation to prevent table sorting
        setStartTimeAnchorEl(null);
    };
    // State and handlers for End Time menu
    const [endTimeAnchorEl, setEndTimeAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const endTimeOpen = Boolean(endTimeAnchorEl);
    const handleEndTimeClick = (event)=>{
        event.stopPropagation(); // Stop event propagation to prevent table sorting
        setEndTimeAnchorEl(event.currentTarget);
    };
    const handleEndTimeClose = (event)=>{
        event.stopPropagation(); // Stop event propagation to prevent table sorting
        setEndTimeAnchorEl(null);
    };
    const createSortHandler = (property)=>(event)=>{
            onRequestSort(event, property);
        };
    const handleSelectAllClick = (event)=>{
        if (event.target.checked) {
            setAlertsArray(activeData);
            const newSelecteds = activeData.map((obj)=>obj.start_timestamp);
            setSelected(newSelecteds);
            return;
        }
        if (!event.target.checked) setAlertsArray([]);
        setSelected([]);
    };
    // Modified headCells with menu components
    const getHeadCellLabel = (headCell)=>{
        if (headCell.id === "formatted_start_date") return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: "flex",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                    children: "Start Time"
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                            "aria-label": "more",
                            id: "start-time-button",
                            "aria-controls": startTimeOpen ? "start-time-menu" : undefined,
                            "aria-expanded": startTimeOpen ? "true" : undefined,
                            "aria-haspopup": "true",
                            onClick: handleStartTimeClick,
                            sx: {
                                width: "18px",
                                height: "18px",
                                padding: "0px"
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5MAs))), {
                                sx: {
                                    fontSize: "18px"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                            id: "start-time-menu",
                            MenuListProps: {
                                "aria-labelledby": "start-time-button"
                            },
                            anchorOrigin: {
                                vertical: "top",
                                horizontal: "left"
                            },
                            transformOrigin: {
                                vertical: "top",
                                horizontal: "left"
                            },
                            anchorEl: startTimeAnchorEl,
                            open: startTimeOpen,
                            onClose: handleStartTimeClose,
                            slotProps: {
                                paper: {
                                    style: {
                                        maxHeight: 216,
                                        width: "20ch"
                                    }
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                    onClick: (event)=>{
                                        setDateMMDDYYYY(true);
                                        event.stopPropagation(); // Stop event propagation to prevent table sorting
                                        handleStartTimeClose(event);
                                    },
                                    children: "MM/DD/YYYY"
                                }, "mm-dd-yyyy-start"),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                    onClick: (event)=>{
                                        setDateMMDDYYYY(false);
                                        event.stopPropagation(); // Stop event propagation to prevent table sorting
                                        handleStartTimeClose(event);
                                    },
                                    children: "DD/MM/YYYY"
                                }, "dd-mm-yyyy-start")
                            ]
                        })
                    ]
                })
            ]
        });
        else if (headCell.id === "formatted_end_date") return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: "flex",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                    children: "End Time"
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                            "aria-label": "more",
                            id: "end-time-button",
                            "aria-controls": endTimeOpen ? "end-time-menu" : undefined,
                            "aria-expanded": endTimeOpen ? "true" : undefined,
                            "aria-haspopup": "true",
                            onClick: handleEndTimeClick,
                            sx: {
                                width: "18px",
                                height: "18px",
                                padding: "0px"
                            },
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i5MAs))), {
                                sx: {
                                    fontSize: "18px"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                            id: "end-time-menu",
                            MenuListProps: {
                                "aria-labelledby": "end-time-button"
                            },
                            anchorOrigin: {
                                vertical: "top",
                                horizontal: "left"
                            },
                            transformOrigin: {
                                vertical: "top",
                                horizontal: "left"
                            },
                            anchorEl: endTimeAnchorEl,
                            open: endTimeOpen,
                            onClose: handleEndTimeClose,
                            slotProps: {
                                paper: {
                                    style: {
                                        maxHeight: 216,
                                        width: "20ch"
                                    }
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                    onClick: (event)=>{
                                        setDateMMDDYYYY(true);
                                        event.stopPropagation(); // Stop event propagation to prevent table sorting
                                        handleEndTimeClose(event);
                                    },
                                    children: "MM/DD/YYYY"
                                }, "mm-dd-yyyy-end"),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                    onClick: (event)=>{
                                        setDateMMDDYYYY(false);
                                        event.stopPropagation(); // Stop event propagation to prevent table sorting
                                        handleEndTimeClose(event);
                                    },
                                    children: "DD/MM/YYYY"
                                }, "dd-mm-yyyy-end")
                            ]
                        })
                    ]
                })
            ]
        });
        else return headCell.label;
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    padding: "checkbox",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                        color: "primary",
                        onClick: (event)=>{
                            handleSelectAllClick(event);
                        }
                    })
                }),
                $9e37f361caa9aba0$var$headCells.map((headCell)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                        align: "left",
                        sortDirection: orderBy === headCell.id ? order : false,
                        sx: {
                            fontFamily: "mulish",
                            fontWeight: 700,
                            width: 208
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kLvBh.default), {
                            active: orderBy === headCell.id,
                            direction: orderBy === headCell.id ? order : "asc",
                            onClick: createSortHandler(headCell.id),
                            children: [
                                getHeadCellLabel(headCell),
                                orderBy === headCell.id ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                    component: "span",
                                    sx: (0, $9lVTU.default),
                                    children: order === "desc" ? "sorted descending" : "sorted ascending"
                                }) : null
                            ]
                        })
                    }, headCell.id))
            ]
        })
    });
};



var $k4ank = parcelRequire("k4ank");
var $b073caba25701ad9$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($b073caba25701ad9$exports, "__esModule", {
    value: true
});
$b073caba25701ad9$exports.default = void 0;

var $b073caba25701ad9$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $b073caba25701ad9$var$_default = $b073caba25701ad9$exports.default = (0, $b073caba25701ad9$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M3 3h18v18H3z"
}), 'Square');


const $858af3912d307ca8$export$9dd1f1537b83c8cd = (errorString)=>{
    switch(errorString){
        case "connectivity":
            return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b073caba25701ad9$exports))), {
                        fontSize: "small",
                        sx: {
                            color: "#53B2AD"
                        }
                    }),
                    "\xa0 Connectivity"
                ]
            });
        case "scene_change":
            return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b073caba25701ad9$exports))), {
                        fontSize: "small",
                        sx: {
                            color: "#E68B37"
                        }
                    }),
                    "\xa0 Scene Change"
                ]
            });
        case "recording_status":
            return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b073caba25701ad9$exports))), {
                        fontSize: "small",
                        sx: {
                            color: "#CD4A81"
                        }
                    }),
                    "\xa0 Recording Status"
                ]
            });
        case "motion_status":
            return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b073caba25701ad9$exports))), {
                        fontSize: "small",
                        sx: {
                            color: "#7F83F3"
                        }
                    }),
                    "\xa0 Motion Status"
                ]
            });
        case "image_quality":
            return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b073caba25701ad9$exports))), {
                        fontSize: "small",
                        sx: {
                            color: "#8EDE79"
                        }
                    }),
                    "\xa0 Image Quality"
                ]
            });
        case "stream_quality":
            return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b073caba25701ad9$exports))), {
                        fontSize: "small",
                        sx: {
                            color: "#39B1EA"
                        }
                    }),
                    "\xa0 Stream Quality"
                ]
            });
    }
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $6MI6A = parcelRequire("6MI6A");


var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");
parcelRequire("8T3gX");
const $f60a1aba69db03ed$export$97faadc272bd3f57 = (setUnhealthyCamsData, unhealthyCamsData, tableString, previousString)=>{
    if (tableString === "resolved") setUnhealthyCamsData((previousState)=>{
        return {
            ...previousState,
            resolved: unhealthyCamsData.resolved += 1
        };
    });
    if (previousString === "resolved") setUnhealthyCamsData((previousState)=>{
        return {
            ...previousState,
            resolved: unhealthyCamsData.resolved -= 1
        };
    });
};


parcelRequire("8T3gX");
const $859f3bc47dffb4d3$export$db02ace95b174694 = (postedAlert, previousStatus, alertsData)=>{
    let updatedAlertsAllData = alertsData.all;
    let updatedAlertsErrorsData = alertsData.errors;
    let updatedAlertsWarningsData = alertsData.warnings;
    let updatedAlertsPendingData = alertsData.pending;
    let updatedAlertsResolvedData = alertsData.resolved;
    if (postedAlert.error_type === "connectivity" || postedAlert.error_type === "scene_change") {
        const selectedIndexAllData = updatedAlertsAllData.findIndex((object)=>object.start_timestamp === postedAlert.start_timestamp);
        updatedAlertsAllData[selectedIndexAllData] = postedAlert;
        const selectedIndexErrorsData = updatedAlertsErrorsData.findIndex((object)=>object.start_timestamp === postedAlert.start_timestamp);
        updatedAlertsErrorsData[selectedIndexErrorsData] = postedAlert;
    }
    if (postedAlert.error_type === "motion_status" || postedAlert.error_type === "image_quality" || postedAlert.error_type === "stream_quality" || postedAlert.error_type === "recording_status") {
        const selectedIndexAllData = updatedAlertsAllData.findIndex((object)=>object.start_timestamp === postedAlert.start_timestamp);
        updatedAlertsAllData[selectedIndexAllData] = postedAlert;
        const selectedIndexWarningsData = updatedAlertsWarningsData.findIndex((object)=>object.start_timestamp === postedAlert.start_timestamp);
        updatedAlertsWarningsData[selectedIndexWarningsData] = postedAlert;
    }
    if (postedAlert.status === "resolved") {
        updatedAlertsResolvedData.push(postedAlert);
        // filter through updatedAlertsAllData and remove any alert that matches the start_timestamp and camera_id of the postedAlert
        updatedAlertsAllData = updatedAlertsAllData.filter((object)=>JSON.stringify(object) !== JSON.stringify(postedAlert));
        updatedAlertsPendingData = updatedAlertsPendingData.filter((object)=>JSON.stringify(object) !== JSON.stringify(postedAlert));
    }
    if (postedAlert.status === "pending") updatedAlertsPendingData.push(postedAlert);
    if (postedAlert.status === "ongoing") {
        if (postedAlert.error_type === "connectivity" || postedAlert.error_type === "scene_change") updatedAlertsErrorsData.push(postedAlert);
        if (postedAlert.error_type === "motion_status" || postedAlert.error_type === "image_quality" || postedAlert.error_type === "stream_quality" || postedAlert.error_type === "recording_status") updatedAlertsWarningsData.push(postedAlert);
    }
    if (previousStatus === "ongoing") {
        const selectedIndexWarningsData = updatedAlertsWarningsData.findIndex((object)=>object.start_timestamp === postedAlert.start_timestamp);
        updatedAlertsWarningsData = updatedAlertsWarningsData.filter((obj, index)=>index !== selectedIndexWarningsData);
        const selectedIndexErrorsData = updatedAlertsErrorsData.findIndex((object)=>object.start_timestamp === postedAlert.start_timestamp);
        updatedAlertsErrorsData = updatedAlertsErrorsData.filter((obj, index)=>index !== selectedIndexErrorsData);
    }
    if (previousStatus === "resolved") {
        const selectedIndexResolvedData = updatedAlertsResolvedData.findIndex((object)=>object.start_timestamp === postedAlert.start_timestamp);
        updatedAlertsResolvedData = updatedAlertsResolvedData.filter((obj, index)=>index !== selectedIndexResolvedData);
        updatedAlertsAllData.unshift(postedAlert);
    }
    if (previousStatus === "pending") {
        const selectedIndexPendingData = updatedAlertsPendingData.findIndex((object)=>object.start_timestamp === postedAlert.start_timestamp);
        updatedAlertsPendingData = updatedAlertsPendingData.filter((obj, index)=>index !== selectedIndexPendingData);
    }
    return {
        all: updatedAlertsAllData,
        errors: updatedAlertsErrorsData,
        warnings: updatedAlertsWarningsData,
        pending: updatedAlertsPendingData,
        resolved: updatedAlertsResolvedData
    };
};




var $5L5iJ = parcelRequire("5L5iJ");

var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("8T3gX");
const $6f9706a8669f5dad$export$2141590f0f3c4415 = (timestamp)=>{
    const date = new Date(timestamp * 1000);
    const estDateString = date.toLocaleString("en-US", {
        timeZone: "America/New_York",
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true
    });
    return estDateString;
};




var $ebTQj = parcelRequire("ebTQj");
const $6503e7a8f971a2bc$export$b09c52318be48923 = (setAlertsData, statusString, previousStatus, selectedAlert, alertsData, setFectchingAllData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, setUpdatingStatus, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setFilteredDataLengths, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate)=>{
    const cleanDateTimeString = (input)=>{
        // Split the string into date and time parts
        const [datePart, timePart, aMPM] = input.replace(",", "").split(" ");
        // Combine the date and cleaned time part
        return `${datePart} ${timePart}${aMPM}`;
    };
    const rearrangeDateString = (inputString)=>{
        const [day, month, year] = inputString.split("/");
        const rearrangedString = `${month}/${day}/${year}`;
        return rearrangedString;
    };
    const postedAlert = selectedAlert;
    selectedAlert.status = statusString;
    const retryFunction = ()=>{
        $6503e7a8f971a2bc$export$b09c52318be48923(setAlertsData, statusString, previousStatus, selectedAlert, alertsData, setFectchingAllData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, setUpdatingStatus, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setFilteredDataLengths, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate);
    };
    const updatedAlertData = alertsData[clickedTab];
    const selectedIndex = alertsData[clickedTab].findIndex((object)=>object.start_timestamp === selectedAlert.start_timestamp);
    updatedAlertData[selectedIndex] = postedAlert;
    const AxiosUI = (0, $195EM.createApi)(``);
    let searchQueryString = `?start_date=${(0, $5L5iJ.yyyymmddGenerator)(filters.start_date)}&end_date=${(0, $5L5iJ.yyyymmddGenerator)(filters.end_date)}`;
    if (filters.parent_group) searchQueryString += `&group=${filters.parent_group}`;
    if (filters.site) searchQueryString += `&site=${filters.site}`;
    if (filters.camera) searchQueryString += `&camera=${filters.camera}`;
    AxiosUI.post(`/healthcheck_result/update_healthcheck/?camera_id=${postedAlert.camera_id}&created_timestamp=${postedAlert.created_timestamp}&healthcheck_type=${postedAlert.error_type}&status=${postedAlert.status}`, postedAlert).then((response)=>{
        if (response.data.end_timestamp) postedAlert.formatted_end_date = cleanDateTimeString(rearrangeDateString((0, $6f9706a8669f5dad$export$2141590f0f3c4415)(response.data.end_timestamp)));
        const submittedAlertData = (0, $859f3bc47dffb4d3$export$db02ace95b174694)(postedAlert, previousStatus, alertsData);
        AxiosUI.get(`healthcheck_result/unhealthy_cameras/${searchQueryString}`).then((response)=>{
            setUnhealthyCamsData(response.data);
            setActiveTable(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
            setAlertsData(submittedAlertData);
            (0, $f60a1aba69db03ed$export$97faadc272bd3f57)(setUnhealthyCamsData, unhealthyCamsData, statusString, previousStatus);
            setUpdatingStatus(false);
            setTimeout(()=>{
                setActiveTable(/*#__PURE__*/ (0, $k4ank.jsx)((0, $51b9c926dce642ac$export$90c542b47ca9ed4a), {
                    alertsData: submittedAlertData,
                    setAlertStatusDialogOpen: setAlertStatusDialogOpen,
                    setSelectedRow: setSelectedRow,
                    setSelectedRowIndex: setSelectedRowIndex,
                    setFectchingAllData: setFectchingAllData,
                    setAlertsData: setAlertsData,
                    setUnhealthyCamsData: setUnhealthyCamsData,
                    unhealthyCamsData: unhealthyCamsData,
                    clickedTab: clickedTab,
                    setActiveTable: setActiveTable,
                    setSortedData: setSortedData,
                    singleCellActivated: singleCellActivated,
                    activeName: activeName,
                    setUpdatingStatus: setUpdatingStatus,
                    filters: filters,
                    alertFilter: alertFilter,
                    setSceneChangeOutcomesDialogOpen: setSceneChangeOutcomesDialogOpen,
                    setBackgroundFrame: setBackgroundFrame,
                    setDetectedFrame: setDetectedFrame,
                    setSelectedRows: setSelectedRows,
                    selectedRows: selectedRows,
                    setErrorsOverviewData: setErrorsOverviewData,
                    setCameraStatsData: setCameraStatsData,
                    setLoadingCameraStatsData: setLoadingCameraStatsData,
                    setBandwidthData: setBandwidthData,
                    setLoadingBandwidthData: setLoadingBandwidthData,
                    setShowSiteStats: setShowSiteStats,
                    cameraDropDownValue: cameraDropDownValue,
                    setFilteredDataLengths: setFilteredDataLengths,
                    sceneChangeValueString: sceneChangeValueString,
                    setBulkSceneChangeOutcomesDialogOpen: setBulkSceneChangeOutcomesDialogOpen,
                    navigate: navigate
                }));
                (0, $6ea8bc2ad1052ffd$export$7c253626761b7bf9)(submittedAlertData, setErrorsOverviewData);
            }, 1);
        });
    }, (reason)=>{
        (0, $ebTQj.logger).log("reason", reason);
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Unable to update status, please try again");
            if (localStorage.backupCHMAlertsData) setAlertsData(JSON.parse(localStorage.backupCHMAlertsData));
            setUpdatingStatus(false);
        });
    });
};


const $bd1d8462dad1652b$export$d3307b259f060f85 = ({ labelString: labelString, row: row, setFectchingAllData: setFectchingAllData, setAlertsData: setAlertsData, alertsData: alertsData, setUnhealthyCamsData: setUnhealthyCamsData, unhealthyCamsData: unhealthyCamsData, clickedTab: clickedTab, setActiveTable: setActiveTable, setAlertStatusDialogOpen: setAlertStatusDialogOpen, setSelectedRow: setSelectedRow, setSelectedRowIndex: setSelectedRowIndex, setSortedData: setSortedData, singleCellActivated: singleCellActivated, activeName: activeName, setUpdatingStatus: setUpdatingStatus, filters: filters, alertFilter: alertFilter, setSceneChangeOutcomesDialogOpen: setSceneChangeOutcomesDialogOpen, setBackgroundFrame: setBackgroundFrame, setDetectedFrame: setDetectedFrame, setSelectedRows: setSelectedRows, selectedRows: selectedRows, setErrorsOverviewData: setErrorsOverviewData, setCameraStatsData: setCameraStatsData, setLoadingCameraStatsData: setLoadingCameraStatsData, setBandwidthData: setBandwidthData, setLoadingBandwidthData: setLoadingBandwidthData, setShowSiteStats: setShowSiteStats, cameraDropDownValue: cameraDropDownValue, setFilteredDataLengths: setFilteredDataLengths, sceneChangeValueString: sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen: setBulkSceneChangeOutcomesDialogOpen, navigate: navigate })=>{
    const [anchorEl, setAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const open = Boolean(anchorEl);
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    switch(labelString){
        case "ongoing":
            return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $6MI6A.default), {
                        label: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                            children: [
                                "Ongoing",
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bf807683d00d38ca$exports))), {})
                            ]
                        }),
                        color: "error",
                        variant: "outlined",
                        onClick: (event)=>{
                            setAnchorEl(event.currentTarget);
                            setSelectedRow(row);
                        }
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                        id: "basic-menu",
                        anchorEl: anchorEl,
                        open: open,
                        onClose: handleClose,
                        MenuListProps: {
                            "aria-labelledby": "basic-button"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                id: "ongoing_menu_item",
                                onClick: ()=>{
                                    localStorage.setItem("backupCHMAlertsData", JSON.stringify(alertsData));
                                    setUpdatingStatus(true);
                                    (0, $6503e7a8f971a2bc$export$b09c52318be48923)(setAlertsData, "ongoing", "ongoing", row, alertsData, setFectchingAllData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, setUpdatingStatus, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setFilteredDataLengths, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate);
                                    handleClose();
                                },
                                children: "Ongoing"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                id: "pending_menu_item",
                                onClick: ()=>{
                                    localStorage.setItem("backupCHMAlertsData", JSON.stringify(alertsData));
                                    setUpdatingStatus(true);
                                    (0, $6503e7a8f971a2bc$export$b09c52318be48923)(setAlertsData, "pending", "ongoing", row, alertsData, setFectchingAllData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, setUpdatingStatus, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setFilteredDataLengths, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate);
                                    handleClose();
                                },
                                children: "Pending"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                id: "resolved_menu_item",
                                onClick: ()=>{
                                    if (row.error_type === "scene_change") setSceneChangeOutcomesDialogOpen(true);
                                    else {
                                        localStorage.setItem("backupCHMAlertsData", JSON.stringify(alertsData));
                                        setUpdatingStatus(true);
                                        (0, $6503e7a8f971a2bc$export$b09c52318be48923)(setAlertsData, "resolved", "ongoing", row, alertsData, setFectchingAllData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, setUpdatingStatus, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setFilteredDataLengths, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate);
                                    }
                                    handleClose();
                                },
                                children: "Resolved"
                            })
                        ]
                    })
                ]
            });
        case "resolved":
            return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $6MI6A.default), {
                        label: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                            children: [
                                "Resolved",
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bf807683d00d38ca$exports))), {})
                            ]
                        }),
                        color: "success",
                        variant: "outlined",
                        onClick: (event)=>{
                            setAnchorEl(event.currentTarget);
                            setSelectedRow(row);
                        }
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                        id: "basic-menu",
                        anchorEl: anchorEl,
                        open: open,
                        onClose: handleClose,
                        MenuListProps: {
                            "aria-labelledby": "basic-button"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                id: "ongoing_menu_item",
                                onClick: ()=>{
                                    localStorage.setItem("backupCHMAlertsData", JSON.stringify(alertsData));
                                    setUpdatingStatus(true);
                                    (0, $6503e7a8f971a2bc$export$b09c52318be48923)(setAlertsData, "ongoing", "resolved", row, alertsData, setFectchingAllData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, setUpdatingStatus, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setFilteredDataLengths, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate);
                                    handleClose();
                                },
                                children: "Ongoing"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                id: "pending_menu_item",
                                onClick: ()=>{
                                    localStorage.setItem("backupCHMAlertsData", JSON.stringify(alertsData));
                                    setUpdatingStatus(true);
                                    (0, $6503e7a8f971a2bc$export$b09c52318be48923)(setAlertsData, "pending", "resolved", row, alertsData, setFectchingAllData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, setUpdatingStatus, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setFilteredDataLengths, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate);
                                    handleClose();
                                },
                                children: "Pending"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                id: "resolved_menu_item",
                                onClick: ()=>{
                                    localStorage.setItem("backupCHMAlertsData", JSON.stringify(alertsData));
                                    setUpdatingStatus(true);
                                    (0, $6503e7a8f971a2bc$export$b09c52318be48923)(setAlertsData, "resolved", "resolved", row, alertsData, setFectchingAllData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, setUpdatingStatus, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setFilteredDataLengths, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate);
                                    handleClose();
                                },
                                children: "Resolved"
                            })
                        ]
                    })
                ]
            });
        case "pending":
            return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $6MI6A.default), {
                        label: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                            children: [
                                "Pending",
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bf807683d00d38ca$exports))), {})
                            ]
                        }),
                        color: "warning",
                        variant: "outlined",
                        onClick: (event)=>{
                            setAnchorEl(event.currentTarget);
                            setSelectedRow(row);
                        }
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1fWBE.default), {
                        id: "basic-menu",
                        anchorEl: anchorEl,
                        open: open,
                        onClose: handleClose,
                        MenuListProps: {
                            "aria-labelledby": "basic-button"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                id: "ongoing_menu_item",
                                onClick: ()=>{
                                    localStorage.setItem("backupCHMAlertsData", JSON.stringify(alertsData));
                                    setUpdatingStatus(true);
                                    (0, $6503e7a8f971a2bc$export$b09c52318be48923)(setAlertsData, "ongoing", "pending", row, alertsData, setFectchingAllData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, setUpdatingStatus, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setFilteredDataLengths, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate);
                                    handleClose();
                                },
                                children: "Ongoing"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                id: "pending_menu_item",
                                onClick: ()=>{
                                    localStorage.setItem("backupCHMAlertsData", JSON.stringify(alertsData));
                                    setUpdatingStatus(true);
                                    (0, $6503e7a8f971a2bc$export$b09c52318be48923)(setAlertsData, "pending", "pending", row, alertsData, setFectchingAllData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, setUpdatingStatus, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setFilteredDataLengths, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate);
                                    handleClose();
                                },
                                children: "Pending"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                id: "resolved_menu_item",
                                onClick: ()=>{
                                    if (row.error_type === "scene_change") {
                                        setSceneChangeOutcomesDialogOpen(true);
                                        localStorage.setItem("backupCHMAlertsData", JSON.stringify(alertsData));
                                    } else {
                                        localStorage.setItem("backupCHMAlertsData", JSON.stringify(alertsData));
                                        setUpdatingStatus(true);
                                        (0, $6503e7a8f971a2bc$export$b09c52318be48923)(setAlertsData, "resolved", "pending", row, alertsData, setFectchingAllData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, setUpdatingStatus, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setFilteredDataLengths, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate);
                                    }
                                    handleClose();
                                },
                                children: "Resolved"
                            })
                        ]
                    })
                ]
            });
    }
};


const $870a053e6d764c4f$export$bc265303ffc7c32d = (statusString, row, setFectchingAllData, setAlertsData, alertsData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, setUpdatingStatus, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setFilteredDataLengths, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate)=>{
    switch(statusString){
        case "ongoing":
            return /*#__PURE__*/ (0, $k4ank.jsx)((0, $bd1d8462dad1652b$export$d3307b259f060f85), {
                labelString: "ongoing",
                row: row,
                setFectchingAllData: setFectchingAllData,
                setAlertsData: setAlertsData,
                alertsData: alertsData,
                setUnhealthyCamsData: setUnhealthyCamsData,
                unhealthyCamsData: unhealthyCamsData,
                clickedTab: clickedTab,
                setActiveTable: setActiveTable,
                setAlertStatusDialogOpen: setAlertStatusDialogOpen,
                setSelectedRow: setSelectedRow,
                setSelectedRowIndex: setSelectedRowIndex,
                setSortedData: setSortedData,
                singleCellActivated: singleCellActivated,
                activeName: activeName,
                setUpdatingStatus: setUpdatingStatus,
                filters: filters,
                alertFilter: alertFilter,
                setSceneChangeOutcomesDialogOpen: setSceneChangeOutcomesDialogOpen,
                setBackgroundFrame: setBackgroundFrame,
                setDetectedFrame: setDetectedFrame,
                setSelectedRows: setSelectedRows,
                selectedRows: selectedRows,
                setErrorsOverviewData: setErrorsOverviewData,
                setCameraStatsData: setCameraStatsData,
                setLoadingCameraStatsData: setLoadingCameraStatsData,
                setBandwidthData: setBandwidthData,
                setLoadingBandwidthData: setLoadingBandwidthData,
                setShowSiteStats: setShowSiteStats,
                cameraDropDownValue: cameraDropDownValue,
                setFilteredDataLengths: setFilteredDataLengths,
                sceneChangeValueString: sceneChangeValueString,
                setBulkSceneChangeOutcomesDialogOpen: setBulkSceneChangeOutcomesDialogOpen,
                navigate: navigate
            });
        case "pending":
            return /*#__PURE__*/ (0, $k4ank.jsx)((0, $bd1d8462dad1652b$export$d3307b259f060f85), {
                labelString: "pending",
                row: row,
                setFectchingAllData: setFectchingAllData,
                setAlertsData: setAlertsData,
                alertsData: alertsData,
                setUnhealthyCamsData: setUnhealthyCamsData,
                unhealthyCamsData: unhealthyCamsData,
                clickedTab: clickedTab,
                setActiveTable: setActiveTable,
                setAlertStatusDialogOpen: setAlertStatusDialogOpen,
                setSelectedRow: setSelectedRow,
                setSelectedRowIndex: setSelectedRowIndex,
                setSortedData: setSortedData,
                singleCellActivated: singleCellActivated,
                activeName: activeName,
                setUpdatingStatus: setUpdatingStatus,
                filters: filters,
                alertFilter: alertFilter,
                setSceneChangeOutcomesDialogOpen: setSceneChangeOutcomesDialogOpen,
                setBackgroundFrame: setBackgroundFrame,
                setDetectedFrame: setDetectedFrame,
                setSelectedRows: setSelectedRows,
                selectedRows: selectedRows,
                setErrorsOverviewData: setErrorsOverviewData,
                setCameraStatsData: setCameraStatsData,
                setLoadingCameraStatsData: setLoadingCameraStatsData,
                setBandwidthData: setBandwidthData,
                setLoadingBandwidthData: setLoadingBandwidthData,
                setShowSiteStats: setShowSiteStats,
                cameraDropDownValue: cameraDropDownValue,
                setFilteredDataLengths: setFilteredDataLengths,
                setBulkSceneChangeOutcomesDialogOpen: setBulkSceneChangeOutcomesDialogOpen,
                navigate: navigate
            });
        case "resolved":
            return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                children: "Resolved"
            });
    }
};


parcelRequire("8T3gX");
const $5006cb2dc77aa250$export$5a8f63dcb7ebcc92 = (dateString, dateMMDDYYYY)=>{
    if (dateMMDDYYYY) // Return in MM/DD/YYYY format (US format)
    return `${dateString.slice(3, 5)}/${dateString.slice(0, 2)}${dateString.slice(5)}`;
    else // Return in DD/MM/YYYY format (European format)
    return dateString;
};


parcelRequire("8T3gX");
const $be5851ae90665265$export$d6ad891437e8c72c = (alertsData, selectedName, alertFilter, singleCellActivated)=>{
    const updatedAlertsAllData = [];
    const updatedAlertsErrorsData = [];
    const updatedAlertsWarningsData = [];
    const updatedAlertsPendingData = [];
    const updatedAlertsResolvedData = [];
    if (singleCellActivated && alertFilter !== "all") {
        alertsData.all.forEach((object)=>{
            if ((object.camera_name === selectedName || object.site_name === selectedName) && object.error_type === alertFilter) updatedAlertsAllData.push(object);
        });
        alertsData.errors.forEach((object)=>{
            if ((object.camera_name === selectedName || object.site_name === selectedName) && object.error_type === alertFilter) updatedAlertsErrorsData.push(object);
        });
        alertsData.warnings.forEach((object)=>{
            if ((object.camera_name === selectedName || object.site_name === selectedName) && object.error_type === alertFilter) updatedAlertsWarningsData.push(object);
        });
        alertsData.pending.forEach((object)=>{
            if ((object.camera_name === selectedName || object.site_name === selectedName) && object.error_type === alertFilter) updatedAlertsPendingData.push(object);
        });
        alertsData.resolved.forEach((object)=>{
            if ((object.camera_name === selectedName || object.site_name === selectedName) && object.error_type === alertFilter) updatedAlertsResolvedData.push(object);
        });
    } else if (singleCellActivated && alertFilter === "all") {
        alertsData.all.forEach((object)=>{
            if (object.camera_name === selectedName || object.site_name === selectedName) updatedAlertsAllData.push(object);
        });
        alertsData.errors.forEach((object)=>{
            if (object.camera_name === selectedName || object.site_name === selectedName) updatedAlertsErrorsData.push(object);
        });
        alertsData.warnings.forEach((object)=>{
            if (object.camera_name === selectedName || object.site_name === selectedName) updatedAlertsWarningsData.push(object);
        });
        alertsData.pending.forEach((object)=>{
            if (object.camera_name === selectedName || object.site_name === selectedName) updatedAlertsPendingData.push(object);
        });
        alertsData.resolved.forEach((object)=>{
            if (object.camera_name === selectedName || object.site_name === selectedName) updatedAlertsResolvedData.push(object);
        });
    } else if (!singleCellActivated && alertFilter !== "all") {
        alertsData.all.forEach((object)=>{
            if (object.error_type === alertFilter) updatedAlertsAllData.push(object);
        });
        alertsData.errors.forEach((object)=>{
            if (object.error_type === alertFilter) updatedAlertsErrorsData.push(object);
        });
        alertsData.warnings.forEach((object)=>{
            if (object.error_type === alertFilter) updatedAlertsWarningsData.push(object);
        });
        alertsData.pending.forEach((object)=>{
            if (object.error_type === alertFilter) updatedAlertsPendingData.push(object);
        });
        alertsData.resolved.forEach((object)=>{
            if (object.error_type === alertFilter) updatedAlertsResolvedData.push(object);
        });
    } else {
        alertsData.all.forEach((object)=>{
            updatedAlertsAllData.push(object);
        });
        alertsData.errors.forEach((object)=>{
            updatedAlertsErrorsData.push(object);
        });
        alertsData.warnings.forEach((object)=>{
            updatedAlertsWarningsData.push(object);
        });
        alertsData.pending.forEach((object)=>{
            updatedAlertsPendingData.push(object);
        });
        alertsData.resolved.forEach((object)=>{
            updatedAlertsResolvedData.push(object);
        });
    }
    return {
        all: updatedAlertsAllData,
        errors: updatedAlertsErrorsData,
        warnings: updatedAlertsWarningsData,
        pending: updatedAlertsPendingData,
        resolved: updatedAlertsResolvedData
    };
};




var $8B8vg = parcelRequire("8B8vg");
var $kbChx = parcelRequire("kbChx");
var $eejVe = parcelRequire("eejVe");
var $cVCJe = parcelRequire("cVCJe");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");


var $5L5iJ = parcelRequire("5L5iJ");

var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("8T3gX");
const $215d7e41a28f0d44$export$b369c619b6c894e7 = (singleCellActivated, alertsData, activeName, setFilteredDataLengths, alertFilter)=>{
    // if (singleCellActivated) {
    const updatedAlertsAllData = [];
    const updatedAlertsErrorsData = [];
    const updatedAlertsWarningsData = [];
    const updatedAlertsPendingData = [];
    const updatedAlertsResolvedData = [];
    if (singleCellActivated && alertFilter !== "all") {
        alertsData.all.forEach((object)=>{
            if ((object.camera_name === activeName || object.site_name === activeName) && object.error_type === alertFilter) updatedAlertsAllData.push(object);
        });
        alertsData.errors.forEach((object)=>{
            if ((object.camera_name === activeName || object.site_name === activeName) && object.error_type === alertFilter) updatedAlertsErrorsData.push(object);
        });
        alertsData.warnings.forEach((object)=>{
            if ((object.camera_name === activeName || object.site_name === activeName) && object.error_type === alertFilter) updatedAlertsWarningsData.push(object);
        });
        alertsData.pending.forEach((object)=>{
            if ((object.camera_name === activeName || object.site_name === activeName) && object.error_type === alertFilter) updatedAlertsPendingData.push(object);
        });
        alertsData.resolved.forEach((object)=>{
            if ((object.camera_name === activeName || object.site_name === activeName) && object.error_type === alertFilter) updatedAlertsResolvedData.push(object);
        });
    } else if (singleCellActivated && alertFilter === "all") {
        alertsData.all.forEach((object)=>{
            if (object.camera_name === activeName || object.site_name === activeName) updatedAlertsAllData.push(object);
        });
        alertsData.errors.forEach((object)=>{
            if (object.camera_name === activeName || object.site_name === activeName) updatedAlertsErrorsData.push(object);
        });
        alertsData.warnings.forEach((object)=>{
            if (object.camera_name === activeName || object.site_name === activeName) updatedAlertsWarningsData.push(object);
        });
        alertsData.pending.forEach((object)=>{
            if (object.camera_name === activeName || object.site_name === activeName) updatedAlertsPendingData.push(object);
        });
        alertsData.resolved.forEach((object)=>{
            if (object.camera_name === activeName || object.site_name === activeName) updatedAlertsResolvedData.push(object);
        });
    } else if (!singleCellActivated && alertFilter !== "all") {
        alertsData.all.forEach((object)=>{
            if (object.error_type === alertFilter) updatedAlertsAllData.push(object);
        });
        alertsData.errors.forEach((object)=>{
            if (object.error_type === alertFilter) updatedAlertsErrorsData.push(object);
        });
        alertsData.warnings.forEach((object)=>{
            if (object.error_type === alertFilter) updatedAlertsWarningsData.push(object);
        });
        alertsData.pending.forEach((object)=>{
            if (object.error_type === alertFilter) updatedAlertsPendingData.push(object);
        });
        alertsData.resolved.forEach((object)=>{
            if (object.error_type === alertFilter) updatedAlertsResolvedData.push(object);
        });
    } else {
        alertsData.all.forEach((object)=>{
            updatedAlertsAllData.push(object);
        });
        alertsData.errors.forEach((object)=>{
            updatedAlertsErrorsData.push(object);
        });
        alertsData.warnings.forEach((object)=>{
            updatedAlertsWarningsData.push(object);
        });
        alertsData.pending.forEach((object)=>{
            updatedAlertsPendingData.push(object);
        });
        alertsData.resolved.forEach((object)=>{
            updatedAlertsResolvedData.push(object);
        });
    }
    setFilteredDataLengths({
        all: updatedAlertsAllData.length,
        errors: updatedAlertsErrorsData.length,
        warnings: updatedAlertsWarningsData.length,
        pending: updatedAlertsPendingData.length,
        resolved: updatedAlertsResolvedData.length
    });
// }
};


const $1427adc7a2f88a3f$export$2225ffec5884e675 = (alertsArray, setAlertsData, statusString, alertsData, setFectchingAllData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, setUpdatingStatus, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setFilteredDataLengths, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate)=>{
    setUpdatingStatus(true);
    const retryFunction = ()=>{
        $1427adc7a2f88a3f$export$2225ffec5884e675(alertsArray, setAlertsData, statusString, alertsData, setFectchingAllData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, setUpdatingStatus, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setFilteredDataLengths, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate);
    };
    const AxiosUI = (0, $195EM.createApi)(``);
    let searchQueryString = `?start_date=${(0, $5L5iJ.yyyymmddGenerator)(filters.start_date)}&end_date=${(0, $5L5iJ.yyyymmddGenerator)(filters.end_date)}`;
    if (filters.parent_group) searchQueryString += `&group=${filters.parent_group}`;
    if (filters.site) searchQueryString += `&site=${filters.site}`;
    if (filters.camera) searchQueryString += `&camera=${filters.camera}`;
    const successfulAlertsArray = [];
    const failedAlertsArray = [];
    let anyAlertsUpdateFail = false;
    let timesRun = 0;
    const updateData = (submittedAlertData)=>{
        if (anyAlertsUpdateFail) alert("Some alerts were not updated, please try updating them again");
        setActiveTable(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
        setAlertsData(submittedAlertData);
        setFectchingAllData(false);
        setTimeout(()=>{
            setActiveTable(/*#__PURE__*/ (0, $k4ank.jsx)((0, $51b9c926dce642ac$export$90c542b47ca9ed4a), {
                alertsData: submittedAlertData,
                setAlertStatusDialogOpen: setAlertStatusDialogOpen,
                setSelectedRow: setSelectedRow,
                setSelectedRowIndex: setSelectedRowIndex,
                setFectchingAllData: setFectchingAllData,
                setAlertsData: setAlertsData,
                setUnhealthyCamsData: setUnhealthyCamsData,
                unhealthyCamsData: unhealthyCamsData,
                clickedTab: clickedTab,
                setActiveTable: setActiveTable,
                setSortedData: setSortedData,
                singleCellActivated: singleCellActivated,
                activeName: activeName,
                setUpdatingStatus: setUpdatingStatus,
                filters: filters,
                alertFilter: alertFilter,
                setSceneChangeOutcomesDialogOpen: setSceneChangeOutcomesDialogOpen,
                setBackgroundFrame: setBackgroundFrame,
                setDetectedFrame: setDetectedFrame,
                setSelectedRows: setSelectedRows,
                selectedRows: selectedRows,
                setErrorsOverviewData: setErrorsOverviewData,
                setCameraStatsData: setCameraStatsData,
                setLoadingCameraStatsData: setLoadingCameraStatsData,
                setBandwidthData: setBandwidthData,
                setLoadingBandwidthData: setLoadingBandwidthData,
                setShowSiteStats: setShowSiteStats,
                cameraDropDownValue: cameraDropDownValue,
                setFilteredDataLengths: setFilteredDataLengths,
                sceneChangeValueString: sceneChangeValueString,
                setBulkSceneChangeOutcomesDialogOpen: setBulkSceneChangeOutcomesDialogOpen,
                navigate: navigate
            }));
            (0, $215d7e41a28f0d44$export$b369c619b6c894e7)(singleCellActivated, submittedAlertData, activeName, setFilteredDataLengths, alertFilter);
        }, 1);
    };
    const finalAlertFunctionality = (submittedAlertData)=>{
        if (timesRun === 0) {
            AxiosUI.get(`healthcheck_result/unhealthy_cameras/${searchQueryString}`).then((response)=>{
                setUnhealthyCamsData(response.data);
                successfulAlertsArray.forEach((chmAlert, indexAlerts)=>{
                    const foundAlertAllIndex = submittedAlertData.all.findIndex((submittedAlert)=>submittedAlert.start_timestamp === chmAlert.start_timestamp && submittedAlert.camera_name === chmAlert.camera_name);
                    const foundAlertErrorsIndex = submittedAlertData.errors.findIndex((submittedAlert)=>submittedAlert.start_timestamp === chmAlert.start_timestamp && submittedAlert.camera_name === chmAlert.camera_name);
                    const foundAlertWarningsIndex = submittedAlertData.warnings.findIndex((submittedAlert)=>submittedAlert.start_timestamp === chmAlert.start_timestamp && submittedAlert.camera_name === chmAlert.camera_name);
                    const foundAlertPendingIndex = submittedAlertData.pending.findIndex((submittedAlert)=>submittedAlert.start_timestamp === chmAlert.start_timestamp && submittedAlert.camera_name === chmAlert.camera_name);
                    if (chmAlert.status === "resolved") {
                        submittedAlertData.all.splice(foundAlertAllIndex, 1);
                        submittedAlertData.resolved.push(chmAlert);
                        if (foundAlertErrorsIndex >= 0) submittedAlertData.errors.splice(foundAlertErrorsIndex, 1);
                        if (foundAlertWarningsIndex >= 0) submittedAlertData.warnings.splice(foundAlertWarningsIndex, 1);
                        if (foundAlertPendingIndex >= 0) submittedAlertData.pending.splice(foundAlertPendingIndex, 1);
                    }
                    if (chmAlert.status === "pending") {
                        submittedAlertData[foundAlertAllIndex] = chmAlert;
                        submittedAlertData.pending.push(chmAlert);
                        if (foundAlertErrorsIndex >= 0) submittedAlertData.errors[foundAlertErrorsIndex] = chmAlert;
                        if (foundAlertWarningsIndex >= 0) submittedAlertData.warnings[foundAlertWarningsIndex] = alert;
                    }
                    if (indexAlerts === successfulAlertsArray.length - 1) {
                        if (!failedAlertsArray[0]) {
                            updateData(submittedAlertData);
                            setUpdatingStatus(false);
                        } else failedAlertsArray.forEach((chmFailAlert, indexFailedAlerts)=>{
                            const foundAlertAllFailIndex = submittedAlertData.all.findIndex((submittedAlert)=>submittedAlert.start_timestamp === chmFailAlert.start_timestamp && submittedAlert.camera_name === chmFailAlert.camera_name);
                            const foundAlertErrorsFailIndex = submittedAlertData.errors.findIndex((submittedAlert)=>submittedAlert.start_timestamp === chmFailAlert.start_timestamp && submittedAlert.camera_name === chmFailAlert.camera_name);
                            const foundAlertWarningsFailIndex = submittedAlertData.warnings.findIndex((submittedAlert)=>submittedAlert.start_timestamp === chmFailAlert.start_timestamp && submittedAlert.camera_name === chmFailAlert.camera_name);
                            const foundAlertPendingFailIndex = submittedAlertData.pending.findIndex((submittedAlert)=>submittedAlert.start_timestamp === chmFailAlert.start_timestamp && submittedAlert.camera_name === chmFailAlert.camera_name);
                            if (chmFailAlert.status === "resolved") {
                                if (foundAlertPendingFailIndex >= 0 && !(foundAlertErrorsFailIndex >= 0) && !(foundAlertWarningsFailIndex >= 0)) {
                                    submittedAlertData.all[foundAlertAllFailIndex].status = "pending";
                                    submittedAlertData.pending[foundAlertPendingFailIndex] = "pending";
                                }
                                if (foundAlertPendingFailIndex >= 0 && foundAlertErrorsFailIndex >= 0) {
                                    submittedAlertData.all[foundAlertAllFailIndex].status = "pending";
                                    submittedAlertData.pending[foundAlertPendingFailIndex] = "pending";
                                    submittedAlertData.errors[foundAlertErrorsFailIndex] = "pending";
                                }
                                if (foundAlertPendingFailIndex >= 0 && foundAlertWarningsFailIndex >= 0) {
                                    submittedAlertData.all[foundAlertAllFailIndex].status = "pending";
                                    submittedAlertData.pending[foundAlertPendingFailIndex] = "pending";
                                    submittedAlertData.warnings[foundAlertWarningsFailIndex] = "pending";
                                }
                                if (!(foundAlertPendingFailIndex >= 0) && !(foundAlertErrorsFailIndex >= 0) && !(foundAlertWarningsFailIndex >= 0)) submittedAlertData.all[foundAlertAllFailIndex].status = "ongoing";
                                if (!(foundAlertPendingFailIndex >= 0) && foundAlertErrorsFailIndex >= 0) {
                                    submittedAlertData.all[foundAlertAllFailIndex].status = "ongoing";
                                    submittedAlertData.errors[foundAlertErrorsFailIndex] = "ongoing";
                                }
                                if (!(foundAlertPendingFailIndex >= 0) && foundAlertWarningsFailIndex >= 0) {
                                    submittedAlertData.all[foundAlertAllFailIndex].status = "ongoing";
                                    submittedAlertData.warnings[foundAlertWarningsFailIndex] = "ongoing";
                                }
                            }
                            if (chmFailAlert.status === "pending") {
                                submittedAlertData.all[foundAlertAllFailIndex].status = "ongoing";
                                if (foundAlertErrorsFailIndex >= 0) submittedAlertData.errors[foundAlertErrorsFailIndex] = "ongoing";
                                if (foundAlertWarningsFailIndex >= 0) submittedAlertData.warnings[foundAlertWarningsFailIndex] = "ongoing";
                            }
                            if (indexFailedAlerts === failedAlertsArray.length - 1) {
                                updateData(submittedAlertData);
                                setUpdatingStatus(false);
                            }
                        });
                    }
                });
            });
            timesRun++;
        }
    };
    let index = 0;
    const resolveAPICall = (object)=>{
        const postedAlert = object;
        postedAlert.status = statusString;
        const submittedAlertData = alertsData;
        const resolveFunction = ()=>{
            AxiosUI.post(`/healthcheck_result/update_healthcheck/?camera_id=${postedAlert.camera_id}&created_timestamp=${postedAlert.created_timestamp}&healthcheck_type=${postedAlert.error_type}&status=${statusString}`, postedAlert).then((response)=>{
                if (response.data.status === "resolved" && postedAlert.status === "resolved" || response.data.status === "pending" && postedAlert.status === "pending") successfulAlertsArray.push(postedAlert);
                if (index !== alertsArray.length - 1) {
                    index++;
                    resolveAPICall(alertsArray[index]);
                }
                if (index === alertsArray.length - 1) finalAlertFunctionality(submittedAlertData);
            }, (reason)=>{
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    failedAlertsArray.push(postedAlert);
                    if (index !== alertsArray.length - 1) {
                        anyAlertsUpdateFail = true;
                        index++;
                        resolveAPICall(alertsArray[index]);
                    }
                    if (index === alertsArray.length - 1) finalAlertFunctionality(submittedAlertData);
                });
            });
        };
        if (postedAlert.error_type === "scene_change" && statusString === "resolved") {
            // Add functionality from handleResolveSuddenSceneChange here
            const submittedObject = {
                camera_id: postedAlert.camera_id,
                action: "clear",
                detected_frame_key: postedAlert.detected_frame_key,
                background_frame_key: postedAlert.background_frame_key,
                incident_timestamp: postedAlert.start_timestamp
            };
            if (sceneChangeValueString === "reset") AxiosUI.post(`/healthcheck_result/update_sudden_scene/?camera_id=${postedAlert.camera_id}&action=clear&detected_frame_key=${postedAlert.detected_frame_key}&background_frame_key=${postedAlert.background_frame_key}&incident_timestamp=${postedAlert.start_timestamp}`, submittedObject).then(()=>{
                resolveFunction();
            }, (reason)=>{
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    resolveFunction();
                });
            });
            if (sceneChangeValueString === "add") {
                submittedObject.action = "update";
                AxiosUI.post(`/healthcheck_result/update_sudden_scene/?camera_id=${postedAlert.camera_id}&action=clear&detected_frame_key=${postedAlert.detected_frame_key}&background_frame_key=${postedAlert.background_frame_key}&incident_timestamp=${postedAlert.start_timestamp}`, submittedObject).then(()=>{
                    resolveFunction();
                }, (reason)=>{
                    (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                        resolveFunction();
                    });
                });
            }
        } else resolveFunction();
    };
    resolveAPICall(alertsArray[index]);
};


parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $5L5iJ = parcelRequire("5L5iJ");

var $3Zv1D = parcelRequire("3Zv1D");







var $ebTQj = parcelRequire("ebTQj");
const $cab03c450f044009$export$fdf38b2130ce6d6a = (alertsArray, setAlertsData, setFectchingAllData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, setUpdatingStatus, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, navigate)=>{
    setUpdatingStatus(true);
    const siteIds = [];
    alertsArray.forEach((object)=>{
        if (!siteIds.includes(object.site_id)) siteIds.push(object.site_id);
    });
    const functionalityAfterAllResolved = (resolvedOlderUnhealthyCamsData, cameraStatsData)=>{
        const healthCheckSitesSorted = (0, $8a06d9beefbfc894$export$55525f7b84e38fa9)(filters, resolvedOlderUnhealthyCamsData);
        healthCheckSitesSorted.sort((a, b)=>{
            return Number(`${b.formatted_start_date.slice(6, 10)}${b.formatted_start_date.slice(3, 5)}${b.formatted_start_date.slice(0, 2)}${(0, $67f834272aa34a6e$export$985fc4c1c7a3a77a)(b.formatted_start_date.slice(11, 13), b.formatted_start_date.slice(19, 21))}${b.formatted_start_date.slice(14, 16)}${b.formatted_start_date.slice(17, 19)}`) - Number(`${a.formatted_start_date.slice(6, 10)}${a.formatted_start_date.slice(3, 5)}${a.formatted_start_date.slice(0, 2)}${(0, $67f834272aa34a6e$export$985fc4c1c7a3a77a)(a.formatted_start_date.slice(11, 13), a.formatted_start_date.slice(19, 21))}${a.formatted_start_date.slice(14, 16)}${a.formatted_start_date.slice(17, 19)}`);
        });
        const filterDuplicatesAndUnhealthy = (arr)=>{
            const uniqueCombinations = {};
            return arr.filter((obj)=>{
                const key = obj.camera_id + obj.error_type + obj.created_timestamp;
                if (obj.status === "healthy") return false;
                if (uniqueCombinations[key]) return false;
                else {
                    uniqueCombinations[key] = true;
                    return true;
                }
            });
        };
        const sortedAndNonDuplictdHealthCheckSites = filterDuplicatesAndUnhealthy(healthCheckSitesSorted);
        const cameraFilteredData = sortedAndNonDuplictdHealthCheckSites.filter((camera)=>camera.camera_id === Number(filters.camera));
        const newAlertsData = filters.camera ? {
            all: (0, $1c8c8d23486a2b93$export$bc0181ac37992f1)(cameraFilteredData),
            errors: (0, $1c8c8d23486a2b93$export$3d21b7cdecda7bf0)(cameraFilteredData),
            warnings: (0, $1c8c8d23486a2b93$export$6addae8b33e5b695)(cameraFilteredData),
            pending: (0, $1c8c8d23486a2b93$export$ef2bd9189ca85cfc)(cameraFilteredData),
            resolved: (0, $1c8c8d23486a2b93$export$3674d01f8b8470a1)(cameraFilteredData)
        } : {
            all: (0, $1c8c8d23486a2b93$export$bc0181ac37992f1)(sortedAndNonDuplictdHealthCheckSites),
            errors: (0, $1c8c8d23486a2b93$export$3d21b7cdecda7bf0)(sortedAndNonDuplictdHealthCheckSites),
            warnings: (0, $1c8c8d23486a2b93$export$6addae8b33e5b695)(sortedAndNonDuplictdHealthCheckSites),
            pending: (0, $1c8c8d23486a2b93$export$ef2bd9189ca85cfc)(sortedAndNonDuplictdHealthCheckSites),
            resolved: (0, $1c8c8d23486a2b93$export$3674d01f8b8470a1)(sortedAndNonDuplictdHealthCheckSites)
        };
        setAlertsData(newAlertsData);
        (0, $6ea8bc2ad1052ffd$export$7c253626761b7bf9)(newAlertsData, setErrorsOverviewData);
        (0, $82a36171a8cf0b7a$export$474f7cb3f9dd064b)(cameraStatsData, setCameraStatsData, setLoadingCameraStatsData, true, filters, newAlertsData.all);
        setFectchingAllData(false);
    };
    const retryFunction = ()=>{
        $cab03c450f044009$export$fdf38b2130ce6d6a(alertsArray, setAlertsData, setFectchingAllData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, setUpdatingStatus, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, navigate);
    };
    const AxiosUI = (0, $195EM.createApi)(``);
    let searchQueryString = `?start_date=${(0, $5L5iJ.yyyymmddGenerator)(filters.start_date)}&end_date=${(0, $5L5iJ.yyyymmddGenerator)(filters.end_date)}`;
    if (filters.parent_group) searchQueryString += `&group=${filters.parent_group}`;
    if (filters.site) searchQueryString += `&site=${filters.site}`;
    if (filters.camera) searchQueryString += `&camera=${filters.camera}`;
    siteIds.forEach((id, index)=>{
        AxiosUI.post(`/customer/${id}/task/`, {
            batch_id: "string",
            deployment_type: "string"
        }).then(()=>{
            if (index === siteIds.length - 1) AxiosUI.get(`healthcheck_result/unhealthy_cameras/${searchQueryString}`).then((response)=>{
                setUnhealthyCamsData(response.data);
                AxiosUI.get(`healthcheck_result/rollup/${searchQueryString}`).then((response)=>{
                    setUnhealthyCamsData(response.data.unhealthy_cams);
                    const cameraStatsData = response.data.camera_stats;
                    const healthCheckSitesWithSeverity = (0, $a10397fbf3df1ab2$export$b3e02ac8bc6acd25)(response.data.healthcheck_sites);
                    const resolvedOlderUnhealthyCamsData = [
                        ...healthCheckSitesWithSeverity
                    ];
                    if (resolvedOlderUnhealthyCamsData[0]) {
                        let finalIndex = 0;
                        let totalFound = 0;
                        resolvedOlderUnhealthyCamsData.forEach((alert1, index)=>{
                            if (alert1.status === "pending") {
                                if (alert1.error_type === "connectivity" && (0, $67f834272aa34a6e$export$f60a425dad8947cf)(alert1.start_timestamp) || alert1.error_type === "scene_change" && (0, $67f834272aa34a6e$export$f60a425dad8947cf)(alert1.end_timestamp)) {
                                    finalIndex = index;
                                    totalFound++;
                                }
                            }
                        });
                        if (totalFound === 0) functionalityAfterAllResolved(resolvedOlderUnhealthyCamsData, cameraStatsData);
                        else resolvedOlderUnhealthyCamsData.forEach((alert1, index)=>{
                            const newAlert = {
                                ...alert1
                            };
                            const previousAlert = {
                                ...alert1
                            };
                            if (alert1.status) {
                                if (alert1.status === "pending") {
                                    if (alert1.error_type === "connectivity" && (0, $67f834272aa34a6e$export$f60a425dad8947cf)(alert1.start_timestamp) || alert1.error_type === "scene_change" && (0, $67f834272aa34a6e$export$f60a425dad8947cf)(alert1.end_timestamp)) {
                                        newAlert.status = "resolved";
                                        // camsToResolve.push(newAlert);
                                        newAlert.formatted_end_date = (0, $67f834272aa34a6e$export$a86190deb5c4a8d0)();
                                        if (alert1.notes) newAlert.notes = alert1.notes + " Resolved automatically after 24 hours.";
                                        else newAlert.notes = "Resolved automatically after 24 hours.";
                                        AxiosUI.post(`/healthcheck_result/update_healthcheck/?camera_id=${alert1.camera_id}&created_timestamp=${alert1.created_timestamp}&healthcheck_type=${alert1.error_type}&status=${alert1.status}`, newAlert).then(()=>{
                                            resolvedOlderUnhealthyCamsData[index] = newAlert;
                                            if (index === finalIndex) functionalityAfterAllResolved(resolvedOlderUnhealthyCamsData, cameraStatsData);
                                        }, (reason)=>{
                                            (0, $ebTQj.logger).log("Reason: ", reason);
                                            resolvedOlderUnhealthyCamsData[index] = previousAlert;
                                            if (index === finalIndex) functionalityAfterAllResolved(resolvedOlderUnhealthyCamsData, cameraStatsData);
                                        });
                                    }
                                }
                            }
                        });
                    } else {
                        setAlertsData({
                            all: [],
                            errors: [],
                            warnings: [],
                            pending: [],
                            resolved: []
                        });
                        setFectchingAllData(false);
                    }
                }, (reason)=>{
                    if (reason.request.status === 500) setLoadingCameraStatsData(false);
                    else (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                        setFectchingAllData(false);
                        setLoadingCameraStatsData(false);
                    });
                });
            // AxiosUI.get(
            //   `healthcheck_result/healthcheck_sites/${searchQueryString}`
            // ).then(
            //   (response: AxiosResponse) => {
            //     const healthCheckSitesSorted = response.data;
            //     const convertToMilitary = (
            //       inputString: string,
            //       aMPMString: string
            //     ) => {
            //       if (aMPMString === "PM") {
            //         return `${Number(inputString) + 12}`;
            //       }
            //       if (aMPMString === "AM" && inputString !== "12") {
            //         return inputString;
            //       }
            //       if (aMPMString === "AM" && inputString === "12") {
            //         return "00";
            //       }
            //     };
            //     healthCheckSitesSorted.sort((a: any, b: any) => {
            //       return (
            //         Number(
            //           `${b.formatted_start_date.slice(
            //             6,
            //             10
            //           )}${b.formatted_start_date.slice(
            //             3,
            //             5
            //           )}${b.formatted_start_date.slice(
            //             0,
            //             2
            //           )}${convertToMilitary(
            //             b.formatted_start_date.slice(11, 13),
            //             b.formatted_start_date.slice(19, 21)
            //           )}${b.formatted_start_date.slice(
            //             14,
            //             16
            //           )}${b.formatted_start_date.slice(17, 19)}`
            //         ) -
            //         Number(
            //           `${a.formatted_start_date.slice(
            //             6,
            //             10
            //           )}${a.formatted_start_date.slice(
            //             3,
            //             5
            //           )}${a.formatted_start_date.slice(
            //             0,
            //             2
            //           )}${convertToMilitary(
            //             a.formatted_start_date.slice(11, 13),
            //             a.formatted_start_date.slice(19, 21)
            //           )}${a.formatted_start_date.slice(
            //             14,
            //             16
            //           )}${a.formatted_start_date.slice(17, 19)}`
            //         )
            //       );
            //     });
            //     setActiveTable(<></>);
            //     setTimeout(() => {
            //       setFectchingAllData(false);
            //       createAlertsData(
            //         healthCheckSitesSorted,
            //         setAlertsData,
            //         cameraDropDownValue
            //       );
            //       const newAlertsData = createReturnedAlertsData(
            //         healthCheckSitesSorted,
            //         cameraDropDownValue
            //       );
            //       setActiveTable(
            //         <AlertsTableHealthMonitoring
            //           alertsData={newAlertsData}
            //           setAlertStatusDialogOpen={setAlertStatusDialogOpen}
            //           setSelectedRow={setSelectedRow}
            //           setSelectedRowIndex={setSelectedRowIndex}
            //           setFectchingAllData={setFectchingAllData}
            //           setAlertsData={setAlertsData}
            //           setUnhealthyCamsData={setUnhealthyCamsData}
            //           unhealthyCamsData={unhealthyCamsData}
            //           clickedTab={clickedTab}
            //           setActiveTable={setActiveTable}
            //           setSortedData={setSortedData}
            //           singleCellActivated={singleCellActivated}
            //           activeName={activeName}
            //           setUpdatingStatus={setUpdatingStatus}
            //           filters={filters}
            //           alertFilter={alertFilter}
            //           setSceneChangeOutcomesDialogOpen={
            //             setSceneChangeOutcomesDialogOpen
            //           }
            //           setBackgroundFrame={setBackgroundFrame}
            //           setDetectedFrame={setDetectedFrame}
            //           setSelectedRows={setSelectedRows}
            //           selectedRows={selectedRows}
            //           setErrorsOverviewData={setErrorsOverviewData}
            //           setCameraStatsData={setCameraStatsData}
            //           setLoadingCameraStatsData={setLoadingCameraStatsData}
            //           setBandwidthData={setBandwidthData}
            //           setLoadingBandwidthData={setLoadingBandwidthData}
            //           setShowSiteStats={setShowSiteStats}
            //           cameraDropDownValue={cameraDropDownValue}
            //           navigate={navigate}
            //         />
            //       );
            //     }, 1);
            //   },
            //   (reason: AxiosError) => {
            //     if (reason.request.status === 500) {
            //       setLoadingCameraStatsData(false);
            //     } else {
            //       universalAPIErrorHandler(
            //         reason,
            //         navigate,
            //         retryFunction,
            //         () => {
            //           setFectchingAllData(false);
            //           setLoadingCameraStatsData(false);
            //         }
            //       );
            //     }
            //   }
            // );
            });
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                alert("Unable to rerun health check, please try again");
                setUpdatingStatus(false);
            });
        });
    });
};



var $ePwXE = parcelRequire("ePwXE");

var $fIsAN = parcelRequire("fIsAN");
parcelRequire("8T3gX");
const $a1645dbc2cc1afcc$export$a81b388df4ea4922 = (row, searchParams, setSearchParams)=>{
    const params = new URLSearchParams(searchParams);
    params.set("open_alert", `${row.camera_id}-${row.error_type}-${row.created_timestamp}`);
    setSearchParams(params);
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");
var $ef024fb239144ebe$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($ef024fb239144ebe$exports, "__esModule", {
    value: true
});
$ef024fb239144ebe$exports.default = void 0;

var $ef024fb239144ebe$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $ef024fb239144ebe$var$_default = $ef024fb239144ebe$exports.default = (0, $ef024fb239144ebe$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8z"
}), 'ArrowUpward');


var $c22f07f7b83e667e$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($c22f07f7b83e667e$exports, "__esModule", {
    value: true
});
$c22f07f7b83e667e$exports.default = void 0;

var $c22f07f7b83e667e$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $c22f07f7b83e667e$var$_default = $c22f07f7b83e667e$exports.default = (0, $c22f07f7b83e667e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    fillRule: "evenodd",
    d: "M4 11h16v2H4z"
}), 'HorizontalRule');


var $44e43c7aece47ccd$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($44e43c7aece47ccd$exports, "__esModule", {
    value: true
});
$44e43c7aece47ccd$exports.default = void 0;

var $44e43c7aece47ccd$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $44e43c7aece47ccd$var$_default = $44e43c7aece47ccd$exports.default = (0, $44e43c7aece47ccd$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "m20 12-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8z"
}), 'ArrowDownward');


const $97d69305fb184ec9$export$13e5c872d721dc0a = (severityNumber)=>{
    switch(severityNumber){
        case 1:
            return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ef024fb239144ebe$exports))), {
                        fontSize: "small",
                        sx: {
                            color: "#D32F2F"
                        }
                    }),
                    "\xa0 High"
                ]
            });
        case 2:
            return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c22f07f7b83e667e$exports))), {
                        fontSize: "small",
                        sx: {
                            color: "#FF9800"
                        }
                    }),
                    "\xa0 Medium"
                ]
            });
        case 3:
            return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($44e43c7aece47ccd$exports))), {
                        fontSize: "small",
                        sx: {
                            color: "#0288D1"
                        }
                    }),
                    "\xa0 Low"
                ]
            });
    }
};



var $aYdit = parcelRequire("aYdit");
const $51b9c926dce642ac$export$90c542b47ca9ed4a = ({ alertsData: alertsData, setAlertStatusDialogOpen: setAlertStatusDialogOpen, setSelectedRow: setSelectedRow, setSelectedRowIndex: setSelectedRowIndex, setFectchingAllData: setFectchingAllData, setAlertsData: setAlertsData, setUnhealthyCamsData: setUnhealthyCamsData, unhealthyCamsData: unhealthyCamsData, clickedTab: clickedTab, setActiveTable: setActiveTable, setSortedData: setSortedData, singleCellActivated: singleCellActivated, activeName: activeName, setUpdatingStatus: setUpdatingStatus, filters: filters, alertFilter: alertFilter, setSceneChangeOutcomesDialogOpen: setSceneChangeOutcomesDialogOpen, setBackgroundFrame: setBackgroundFrame, setDetectedFrame: setDetectedFrame, setSelectedRows: setSelectedRows, selectedRows: selectedRows, setErrorsOverviewData: setErrorsOverviewData, setCameraStatsData: setCameraStatsData, setLoadingCameraStatsData: setLoadingCameraStatsData, setBandwidthData: setBandwidthData, setLoadingBandwidthData: setLoadingBandwidthData, setShowSiteStats: setShowSiteStats, cameraDropDownValue: cameraDropDownValue, setFilteredDataLengths: setFilteredDataLengths, sceneChangeValueString: sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen: setBulkSceneChangeOutcomesDialogOpen, navigate: navigate })=>{
    const filteredData = (0, $be5851ae90665265$export$d6ad891437e8c72c)(alertsData, activeName, alertFilter, singleCellActivated);
    const [searchParams, setSearchParams] = (0, $fIsAN.useSearchParams)();
    const activeData = singleCellActivated || alertFilter !== "all" ? filteredData[clickedTab] : alertsData[clickedTab];
    const [order, setOrder] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("asc");
    const [orderBy, setOrderBy] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [rowsPerPage, setRowsPerPage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(25);
    const [page, setPage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const { dateMMDDYYYY: dateMMDDYYYY } = (0, $aYdit.useAppStore)();
    const convertToMilitary = (inputString, aMPMString)=>{
        if (aMPMString === "PM" && inputString !== "12") return `${Number(inputString) + 12}`;
        if (aMPMString === "AM" && inputString !== "12" || aMPMString === "PM" && inputString === "12") return inputString;
        if (aMPMString === "AM" && inputString === "12") return "00";
    };
    const setIndex = (page, rowsPerPage, index)=>{
        return rowsPerPage * page + index;
    };
    const handleRequestSort = (event, property)=>{
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };
    const handleChangePage = (event, newPage)=>{
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event)=>{
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const sortingFunction = orderBy !== "formatted_start_date" && orderBy !== "formatted_end_date" ? (0, $fWsn7.stableSort)(activeData, (0, $fWsn7.getComparator)(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : activeData.sort((a, b)=>{
        if (orderBy === "formatted_start_date" && order === "asc") return Number(`${b.formatted_start_date.slice(6, 10)}${b.formatted_start_date.slice(3, 5)}${b.formatted_start_date.slice(0, 2)}${convertToMilitary(b.formatted_start_date.slice(11, 13), b.formatted_start_date.slice(19, 21))}${b.formatted_start_date.slice(14, 16)}${b.formatted_start_date.slice(17, 19)}`) - Number(`${a.formatted_start_date.slice(6, 10)}${a.formatted_start_date.slice(3, 5)}${a.formatted_start_date.slice(0, 2)}${convertToMilitary(a.formatted_start_date.slice(11, 13), a.formatted_start_date.slice(19, 21))}${a.formatted_start_date.slice(14, 16)}${a.formatted_start_date.slice(17, 19)}`);
        else if (orderBy === "formatted_start_date" && order === "desc") return Number(`${a.formatted_start_date.slice(6, 10)}${a.formatted_start_date.slice(3, 5)}${a.formatted_start_date.slice(0, 2)}${convertToMilitary(a.formatted_start_date.slice(11, 13), a.formatted_start_date.slice(19, 21))}${a.formatted_start_date.slice(14, 16)}${a.formatted_start_date.slice(17, 19)}`) - Number(`${b.formatted_start_date.slice(6, 10)}${b.formatted_start_date.slice(3, 5)}${b.formatted_start_date.slice(0, 2)}${convertToMilitary(b.formatted_start_date.slice(11, 13), b.formatted_start_date.slice(19, 21))}${b.formatted_start_date.slice(14, 16)}${b.formatted_start_date.slice(17, 19)}`);
        else if (orderBy === "formatted_end_date" && order === "asc") {
            if (b.formatted_end_date && a.formatted_end_date) return Number(`${b.formatted_end_date.slice(6, 10)}${b.formatted_end_date.slice(3, 5)}${b.formatted_end_date.slice(0, 2)}${convertToMilitary(b.formatted_end_date.slice(11, 13), b.formatted_end_date.slice(19, 21))}${b.formatted_end_date.slice(14, 16)}${b.formatted_end_date.slice(17, 19)}`) - Number(`${a.formatted_end_date.slice(6, 10)}${a.formatted_end_date.slice(3, 5)}${a.formatted_end_date.slice(0, 2)}${convertToMilitary(a.formatted_end_date.slice(11, 13), a.formatted_end_date.slice(19, 21))}${a.formatted_end_date.slice(14, 16)}${a.formatted_start_date.slice(17, 19)}`);
            else if (b.formatted_end_date && !a.formatted_end_date) return Number(`${b.formatted_end_date.slice(6, 10)}${b.formatted_end_date.slice(3, 5)}${b.formatted_end_date.slice(0, 2)}${convertToMilitary(b.formatted_end_date.slice(11, 13), b.formatted_end_date.slice(19, 21))}${b.formatted_end_date.slice(14, 16)}${b.formatted_end_date.slice(17, 19)}`) - Number(`10000000000000`);
            else if (!b.formatted_end_date && a.formatted_end_date) return Number(`10000000000000`) - Number(`${a.formatted_end_date.slice(6, 10)}${a.formatted_end_date.slice(3, 5)}${a.formatted_end_date.slice(0, 2)}${convertToMilitary(a.formatted_end_date.slice(11, 13), a.formatted_end_date.slice(19, 21))}${a.formatted_end_date.slice(14, 16)}${a.formatted_start_date.slice(17, 19)}`);
            else return Number(`10000000000000`) - Number(`10000000000000`);
        } else if (orderBy === "formatted_end_date" && order === "desc") {
            if (a.formatted_end_date && b.formatted_end_date) return Number(`${a.formatted_end_date.slice(6, 10)}${a.formatted_end_date.slice(3, 5)}${a.formatted_end_date.slice(0, 2)}${convertToMilitary(a.formatted_end_date.slice(11, 13), a.formatted_end_date.slice(19, 21))}${a.formatted_end_date.slice(14, 16)}${a.formatted_end_date.slice(17, 19)}`) - Number(`${b.formatted_end_date.slice(6, 10)}${b.formatted_end_date.slice(3, 5)}${b.formatted_end_date.slice(0, 2)}${convertToMilitary(b.formatted_end_date.slice(11, 13), b.formatted_end_date.slice(19, 21))}${b.formatted_end_date.slice(14, 16)}${b.formatted_end_date.slice(17, 19)}`);
            else if (!a.formatted_end_date && b.formatted_end_date) return Number(`10000000000000`) - Number(`${b.formatted_end_date.slice(6, 10)}${b.formatted_end_date.slice(3, 5)}${b.formatted_end_date.slice(0, 2)}${convertToMilitary(b.formatted_end_date.slice(11, 13), b.formatted_end_date.slice(19, 21))}${b.formatted_end_date.slice(14, 16)}${b.formatted_end_date.slice(17, 19)}`);
            else if (a.formatted_end_date && !b.formatted_end_date) return Number(`${a.formatted_end_date.slice(6, 10)}${a.formatted_end_date.slice(3, 5)}${a.formatted_end_date.slice(0, 2)}${convertToMilitary(a.formatted_end_date.slice(11, 13), a.formatted_end_date.slice(19, 21))}${a.formatted_end_date.slice(14, 16)}${a.formatted_end_date.slice(17, 19)}`) - Number(`10000000000000`);
            else return Number(`10000000000000`) - Number(`10000000000000`);
        }
    }).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    const visibleRows = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>sortingFunction, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        order,
        orderBy,
        page,
        rowsPerPage,
        alertsData
    ]);
    const [selected, setSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const handleSingleCheckboxClick = (event, id)=>{
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];
        if (selectedIndex === -1) newSelected = newSelected.concat(selected, id);
        else if (selectedIndex === 0) newSelected = newSelected.concat(selected.slice(1));
        else if (selectedIndex === selected.length - 1) newSelected = newSelected.concat(selected.slice(0, -1));
        else if (selectedIndex > 0) newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        setSelected(newSelected);
    };
    const isSelected = (id)=>selected.indexOf(id) !== -1;
    const [selectedOption, setSelectedOption] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [alertsArray, setAlertsArray] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const dropDown = /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "pt-4 pl-4",
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
            size: "small",
            disablePortal: true,
            options: [
                "Rerun Health Check",
                "Move to Pending",
                "Resolve"
            ],
            onChange: (event, value)=>{
                setSelectedOption(value);
                if (!value) setSelectedOption("");
            },
            sx: {
                width: 200
            },
            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                    ...params,
                    autoComplete: "off"
                })
        })
    });
    const applyButton = /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: "absolute left-[250px] top-[65px]",
        children: /*#__PURE__*/ (0, $k4ank.jsx)("button", {
            className: selectedOption !== "" ? "shadow-button bg-actuate-orange rounded font-mulish text-white text-base	p-1.5" : "shadow-button bg-actuate-grey rounded font-mulish text-white text-base	p-1.5",
            onClick: ()=>{
                if (selectedOption === "Resolve") {
                    let sceneChangeIncluded = false;
                    alertsArray.forEach((alert)=>{
                        if (alert.error_type === "scene_change") sceneChangeIncluded = true;
                    });
                    if (sceneChangeIncluded) setBulkSceneChangeOutcomesDialogOpen(true);
                    else (0, $1427adc7a2f88a3f$export$2225ffec5884e675)(alertsArray, setAlertsData, "resolved", alertsData, setFectchingAllData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, setUpdatingStatus, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setFilteredDataLengths, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate);
                }
                if (selectedOption === "Move to Pending") (0, $1427adc7a2f88a3f$export$2225ffec5884e675)(alertsArray, setAlertsData, "pending", alertsData, setFectchingAllData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, setUpdatingStatus, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setFilteredDataLengths, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate);
                if (selectedOption === "Rerun Health Check") (0, $cab03c450f044009$export$fdf38b2130ce6d6a)(alertsArray, setAlertsData, setFectchingAllData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, setUpdatingStatus, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, navigate);
            },
            disabled: selectedOption === "",
            children: "\xa0 Apply \xa0"
        })
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        orderBy !== "formatted_start_date" && orderBy !== "formatted_end_date" ? setSortedData((0, $fWsn7.stableSort)(activeData, (0, $fWsn7.getComparator)(order, orderBy))) : setSortedData(activeData.sort((a, b)=>{
            if (orderBy === "formatted_start_date" && order === "asc") return Number(`${b.formatted_start_date.slice(6, 10)}${b.formatted_start_date.slice(3, 5)}${b.formatted_start_date.slice(0, 2)}${convertToMilitary(b.formatted_start_date.slice(11, 13), b.formatted_start_date.slice(19, 21))}${b.formatted_start_date.slice(14, 16)}${b.formatted_start_date.slice(17, 19)}`) - Number(`${a.formatted_start_date.slice(6, 10)}${a.formatted_start_date.slice(3, 5)}${a.formatted_start_date.slice(0, 2)}${convertToMilitary(a.formatted_start_date.slice(11, 13), a.formatted_start_date.slice(19, 21))}${a.formatted_start_date.slice(14, 16)}${a.formatted_start_date.slice(17, 19)}`);
            else if (orderBy === "formatted_start_date" && order === "desc") return Number(`${a.formatted_start_date.slice(6, 10)}${a.formatted_start_date.slice(3, 5)}${a.formatted_start_date.slice(0, 2)}${convertToMilitary(a.formatted_start_date.slice(11, 13), a.formatted_start_date.slice(19, 21))}${a.formatted_start_date.slice(14, 16)}${a.formatted_start_date.slice(17, 19)}`) - Number(`${b.formatted_start_date.slice(6, 10)}${b.formatted_start_date.slice(3, 5)}${b.formatted_start_date.slice(0, 2)}${convertToMilitary(b.formatted_start_date.slice(11, 13), b.formatted_start_date.slice(19, 21))}${b.formatted_start_date.slice(14, 16)}${b.formatted_start_date.slice(17, 19)}`);
            else if (orderBy === "formatted_end_date" && order === "asc") {
                if (b.formatted_end_date && a.formatted_end_date) return Number(`${b.formatted_end_date.slice(6, 10)}${b.formatted_end_date.slice(3, 5)}${b.formatted_end_date.slice(0, 2)}${convertToMilitary(b.formatted_end_date.slice(11, 13), b.formatted_end_date.slice(19, 21))}${b.formatted_end_date.slice(14, 16)}${b.formatted_end_date.slice(17, 19)}`) - Number(`${a.formatted_end_date.slice(6, 10)}${a.formatted_end_date.slice(3, 5)}${a.formatted_end_date.slice(0, 2)}${convertToMilitary(a.formatted_end_date.slice(11, 13), a.formatted_end_date.slice(19, 21))}${a.formatted_end_date.slice(14, 16)}${a.formatted_start_date.slice(17, 19)}`);
                else if (b.formatted_end_date && !a.formatted_end_date) return Number(`${b.formatted_end_date.slice(6, 10)}${b.formatted_end_date.slice(3, 5)}${b.formatted_end_date.slice(0, 2)}${convertToMilitary(b.formatted_end_date.slice(11, 13), b.formatted_end_date.slice(19, 21))}${b.formatted_end_date.slice(14, 16)}${b.formatted_end_date.slice(17, 19)}`) - Number(`10000000000000`);
                else if (!b.formatted_end_date && a.formatted_end_date) return Number(`10000000000000`) - Number(`${a.formatted_end_date.slice(6, 10)}${a.formatted_end_date.slice(3, 5)}${a.formatted_end_date.slice(0, 2)}${convertToMilitary(a.formatted_end_date.slice(11, 13), a.formatted_end_date.slice(19, 21))}${a.formatted_end_date.slice(14, 16)}${a.formatted_start_date.slice(17, 19)}`);
                else return Number(`10000000000000`) - Number(`10000000000000`);
            } else if (orderBy === "formatted_end_date" && order === "desc") {
                if (a.formatted_end_date && b.formatted_end_date) return Number(`${a.formatted_end_date.slice(6, 10)}${a.formatted_end_date.slice(3, 5)}${a.formatted_end_date.slice(0, 2)}${convertToMilitary(a.formatted_end_date.slice(11, 13), a.formatted_end_date.slice(19, 21))}${a.formatted_end_date.slice(14, 16)}${a.formatted_end_date.slice(17, 19)}`) - Number(`${b.formatted_end_date.slice(6, 10)}${b.formatted_end_date.slice(3, 5)}${b.formatted_end_date.slice(0, 2)}${convertToMilitary(b.formatted_end_date.slice(11, 13), b.formatted_end_date.slice(19, 21))}${b.formatted_end_date.slice(14, 16)}${b.formatted_end_date.slice(17, 19)}`);
                else if (!a.formatted_end_date && b.formatted_end_date) return Number(`10000000000000`) - Number(`${b.formatted_end_date.slice(6, 10)}${b.formatted_end_date.slice(3, 5)}${b.formatted_end_date.slice(0, 2)}${convertToMilitary(b.formatted_end_date.slice(11, 13), b.formatted_end_date.slice(19, 21))}${b.formatted_end_date.slice(14, 16)}${b.formatted_end_date.slice(17, 19)}`);
                else if (a.formatted_end_date && !b.formatted_end_date) return Number(`${a.formatted_end_date.slice(6, 10)}${a.formatted_end_date.slice(3, 5)}${a.formatted_end_date.slice(0, 2)}${convertToMilitary(a.formatted_end_date.slice(11, 13), a.formatted_end_date.slice(19, 21))}${a.formatted_end_date.slice(14, 16)}${a.formatted_end_date.slice(17, 19)}`) - Number(`10000000000000`);
                else return Number(`10000000000000`) - Number(`10000000000000`);
            }
        }));
    }, [
        order,
        orderBy,
        page,
        rowsPerPage,
        alertsData
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        localStorage.setItem("selectedCHMAlertsArray", JSON.stringify(alertsArray));
    }, [
        alertsArray
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4reBM.default), {
        square: true,
        children: [
            selected[0] && dropDown,
            selected[0] && applyButton,
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $9e37f361caa9aba0$export$dadd0b4ac15beece), {
                onRequestSort: handleRequestSort,
                orderBy: orderBy,
                order: order,
                activeData: activeData,
                setSelected: setSelected,
                setAlertsArray: setAlertsArray
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                sx: {
                    height: 233
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k8Qy8.default), {
                    sx: {
                        minWidth: 700,
                        fontFamily: "Mulish",
                        overflow: "scroll"
                    },
                    "aria-labelledby": "tableTitle",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                        children: visibleRows.map((row, index)=>{
                            const isItemSelected = isSelected(row.start_timestamp);
                            return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                hover: true,
                                tabIndex: -1,
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        padding: "checkbox",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                            color: "primary",
                                            checked: isItemSelected,
                                            onClick: (event)=>{
                                                handleSingleCheckboxClick(event, row.start_timestamp);
                                                if (event.target.checked === true) {
                                                    const updatedAlertsArray = [
                                                        ...alertsArray,
                                                        row
                                                    ];
                                                    setAlertsArray(updatedAlertsArray);
                                                    localStorage.setItem("selectedCHMAlertsArray", JSON.stringify(updatedAlertsArray));
                                                } else {
                                                    setAlertsArray(alertsArray.filter((obj)=>obj.start_timestamp !== row.start_timestamp));
                                                    localStorage.setItem("selectedCHMAlertsArray", JSON.stringify(alertsArray.filter((obj)=>obj.start_timestamp !== row.start_timestamp)));
                                                }
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        sx: {
                                            fontSize: "13px",
                                            fontFamily: "mulish",
                                            width: 190,
                                            cursor: "pointer"
                                        },
                                        onClick: ()=>{
                                            if (row.error_type === "scene_change") {
                                                setBackgroundFrame("");
                                                setDetectedFrame("");
                                                (0, $c0ba81b0f635eb8e$export$670c6be62c0305bd)(row, setBackgroundFrame, setDetectedFrame, navigate);
                                            }
                                            setAlertStatusDialogOpen(true);
                                            setSelectedRow(row);
                                            (0, $a1645dbc2cc1afcc$export$a81b388df4ea4922)(row, searchParams, setSearchParams);
                                            setSelectedRowIndex(setIndex(page, rowsPerPage, index));
                                        },
                                        children: row.site_name
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        sx: {
                                            fontSize: "13px",
                                            fontFamily: "mulish",
                                            width: 208,
                                            cursor: "pointer"
                                        },
                                        onClick: ()=>{
                                            if (row.error_type === "scene_change") {
                                                setBackgroundFrame("");
                                                setDetectedFrame("");
                                                (0, $c0ba81b0f635eb8e$export$670c6be62c0305bd)(row, setBackgroundFrame, setDetectedFrame, navigate);
                                            }
                                            setAlertStatusDialogOpen(true);
                                            setSelectedRow(row);
                                            (0, $a1645dbc2cc1afcc$export$a81b388df4ea4922)(row, searchParams, setSearchParams);
                                            setSelectedRowIndex(setIndex(page, rowsPerPage, index));
                                        },
                                        children: row.camera_name
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        sx: {
                                            fontSize: "13px",
                                            fontFamily: "mulish",
                                            width: 208,
                                            cursor: "pointer"
                                        },
                                        onClick: ()=>{
                                            if (row.error_type === "scene_change") {
                                                setBackgroundFrame("");
                                                setDetectedFrame("");
                                                (0, $c0ba81b0f635eb8e$export$670c6be62c0305bd)(row, setBackgroundFrame, setDetectedFrame, navigate);
                                            }
                                            setAlertStatusDialogOpen(true);
                                            setSelectedRow(row);
                                            (0, $a1645dbc2cc1afcc$export$a81b388df4ea4922)(row, searchParams, setSearchParams);
                                            setSelectedRowIndex(setIndex(page, rowsPerPage, index));
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                            children: [
                                                (0, $5006cb2dc77aa250$export$5a8f63dcb7ebcc92)(row.formatted_start_date, dateMMDDYYYY),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                    title: row.timezone,
                                                    placement: "top",
                                                    sx: {
                                                        fontSize: "15px",
                                                        fontFamily: "mulish"
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                                        fontSize: "small"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        sx: {
                                            fontSize: "13px",
                                            fontFamily: "mulish",
                                            width: 208,
                                            cursor: "pointer"
                                        },
                                        onClick: ()=>{
                                            if (row.error_type === "scene_change") {
                                                setBackgroundFrame("");
                                                setDetectedFrame("");
                                                (0, $c0ba81b0f635eb8e$export$670c6be62c0305bd)(row, setBackgroundFrame, setDetectedFrame, navigate);
                                            }
                                            setAlertStatusDialogOpen(true);
                                            setSelectedRow(row);
                                            (0, $a1645dbc2cc1afcc$export$a81b388df4ea4922)(row, searchParams, setSearchParams);
                                            setSelectedRowIndex(setIndex(page, rowsPerPage, index));
                                        },
                                        children: row.formatted_end_date ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                            children: [
                                                (0, $5006cb2dc77aa250$export$5a8f63dcb7ebcc92)(row.formatted_end_date, dateMMDDYYYY),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                    title: row.timezone,
                                                    placement: "top",
                                                    sx: {
                                                        fontSize: "15px",
                                                        fontFamily: "mulish"
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                                        fontSize: "small"
                                                    })
                                                })
                                            ]
                                        }) : ""
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        sx: {
                                            fontSize: "13px",
                                            fontFamily: "mulish",
                                            width: 208,
                                            cursor: "pointer"
                                        },
                                        onClick: ()=>{
                                            if (row.error_type === "scene_change") {
                                                setBackgroundFrame("");
                                                setDetectedFrame("");
                                                (0, $c0ba81b0f635eb8e$export$670c6be62c0305bd)(row, setBackgroundFrame, setDetectedFrame, navigate);
                                            }
                                            setAlertStatusDialogOpen(true);
                                            setSelectedRow(row);
                                            (0, $a1645dbc2cc1afcc$export$a81b388df4ea4922)(row, searchParams, setSearchParams);
                                            setSelectedRowIndex(setIndex(page, rowsPerPage, index));
                                        },
                                        children: (0, $858af3912d307ca8$export$9dd1f1537b83c8cd)(row.error_type)
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        sx: {
                                            fontSize: "13px",
                                            fontFamily: "mulish",
                                            width: 208,
                                            cursor: "pointer"
                                        },
                                        onClick: ()=>{
                                            if (row.error_type === "scene_change") {
                                                setBackgroundFrame("");
                                                setDetectedFrame("");
                                                (0, $c0ba81b0f635eb8e$export$670c6be62c0305bd)(row, setBackgroundFrame, setDetectedFrame, navigate);
                                            }
                                            setAlertStatusDialogOpen(true);
                                            setSelectedRow(row);
                                            (0, $a1645dbc2cc1afcc$export$a81b388df4ea4922)(row, searchParams, setSearchParams);
                                            setSelectedRowIndex(setIndex(page, rowsPerPage, index));
                                        },
                                        children: row.severity ? (0, $97d69305fb184ec9$export$13e5c872d721dc0a)(row.severity) : ""
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                        sx: {
                                            fontSize: "13px",
                                            fontFamily: "mulish",
                                            width: 208
                                        },
                                        children: [
                                            (0, $870a053e6d764c4f$export$bc265303ffc7c32d)(row.status, row, setFectchingAllData, setAlertsData, alertsData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, setUpdatingStatus, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setFilteredDataLengths, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate),
                                            " "
                                        ]
                                    })
                                ]
                            }, index);
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wcxl.default), {
                rowsPerPageOptions: [
                    25,
                    50,
                    100
                ],
                component: "div",
                count: activeData.length,
                rowsPerPage: rowsPerPage,
                page: page,
                onPageChange: handleChangePage,
                onRowsPerPageChange: handleChangeRowsPerPage
            })
        ]
    });
};


const $1a8d7063bb30dc08$export$200cf8913388bd37 = (alertsData, selectedName, singleCellActivated, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setFectchingAllData, setAlertsData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setSortedData, setFilteredDataLengths, setUpdatingStatus, activeName, entryName, showSiteStats, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate)=>{
    if (singleCellActivated || activeName !== entryName) {
        const updatedAlertsAllData = [];
        const updatedAlertsErrorsData = [];
        const updatedAlertsWarningsData = [];
        const updatedAlertsPendingData = [];
        const updatedAlertsResolvedData = [];
        if (!showSiteStats) {
            alertsData.all.forEach((object)=>{
                if (object.camera_name === selectedName) updatedAlertsAllData.push(object);
            });
            alertsData.errors.forEach((object)=>{
                if (object.camera_name === selectedName) updatedAlertsErrorsData.push(object);
            });
            alertsData.warnings.forEach((object)=>{
                if (object.camera_name === selectedName) updatedAlertsWarningsData.push(object);
            });
            alertsData.pending.forEach((object)=>{
                if (object.camera_name === selectedName) updatedAlertsPendingData.push(object);
            });
            alertsData.resolved.forEach((object)=>{
                if (object.camera_name === selectedName) updatedAlertsResolvedData.push(object);
            });
        } else {
            alertsData.all.forEach((object)=>{
                if (object.site_name === selectedName) updatedAlertsAllData.push(object);
            });
            alertsData.errors.forEach((object)=>{
                if (object.site_name === selectedName) updatedAlertsErrorsData.push(object);
            });
            alertsData.warnings.forEach((object)=>{
                if (object.site_name === selectedName) updatedAlertsWarningsData.push(object);
            });
            alertsData.pending.forEach((object)=>{
                if (object.site_name === selectedName) updatedAlertsPendingData.push(object);
            });
            alertsData.resolved.forEach((object)=>{
                if (object.site_name === selectedName) updatedAlertsResolvedData.push(object);
            });
        }
        setFilteredDataLengths({
            all: updatedAlertsAllData.length,
            errors: updatedAlertsErrorsData.length,
            warnings: updatedAlertsWarningsData.length,
            pending: updatedAlertsPendingData.length,
            resolved: updatedAlertsResolvedData.length
        });
        setTimeout(()=>{
            setActiveTable(/*#__PURE__*/ (0, $k4ank.jsx)((0, $51b9c926dce642ac$export$90c542b47ca9ed4a), {
                alertsData: alertsData,
                setAlertStatusDialogOpen: setAlertStatusDialogOpen,
                setSelectedRow: setSelectedRow,
                setSelectedRowIndex: setSelectedRowIndex,
                setFectchingAllData: setFectchingAllData,
                setAlertsData: setAlertsData,
                setUnhealthyCamsData: setUnhealthyCamsData,
                unhealthyCamsData: unhealthyCamsData,
                clickedTab: clickedTab,
                setActiveTable: setActiveTable,
                setSortedData: setSortedData,
                singleCellActivated: true,
                activeName: selectedName,
                setUpdatingStatus: setUpdatingStatus,
                filters: filters,
                alertFilter: alertFilter,
                setSceneChangeOutcomesDialogOpen: setSceneChangeOutcomesDialogOpen,
                setBackgroundFrame: setBackgroundFrame,
                setDetectedFrame: setDetectedFrame,
                setSelectedRows: setSelectedRows,
                selectedRows: selectedRows,
                setErrorsOverviewData: setErrorsOverviewData,
                setCameraStatsData: setCameraStatsData,
                setLoadingCameraStatsData: setLoadingCameraStatsData,
                setBandwidthData: setBandwidthData,
                setLoadingBandwidthData: setLoadingBandwidthData,
                setShowSiteStats: setShowSiteStats,
                cameraDropDownValue: cameraDropDownValue,
                setFilteredDataLengths: setFilteredDataLengths,
                sceneChangeValueString: sceneChangeValueString,
                setBulkSceneChangeOutcomesDialogOpen: setBulkSceneChangeOutcomesDialogOpen,
                navigate: navigate
            }));
        }, 1);
    } else setActiveTable(/*#__PURE__*/ (0, $k4ank.jsx)((0, $51b9c926dce642ac$export$90c542b47ca9ed4a), {
        alertsData: alertsData,
        setAlertStatusDialogOpen: setAlertStatusDialogOpen,
        setSelectedRow: setSelectedRow,
        setSelectedRowIndex: setSelectedRowIndex,
        setFectchingAllData: setFectchingAllData,
        setAlertsData: setAlertsData,
        setUnhealthyCamsData: setUnhealthyCamsData,
        unhealthyCamsData: unhealthyCamsData,
        clickedTab: clickedTab,
        setActiveTable: setActiveTable,
        setSortedData: setSortedData,
        singleCellActivated: false,
        activeName: selectedName,
        setUpdatingStatus: setUpdatingStatus,
        filters: filters,
        alertFilter: alertFilter,
        setSceneChangeOutcomesDialogOpen: setSceneChangeOutcomesDialogOpen,
        setBackgroundFrame: setBackgroundFrame,
        setDetectedFrame: setDetectedFrame,
        setSelectedRows: setSelectedRows,
        selectedRows: selectedRows,
        setErrorsOverviewData: setErrorsOverviewData,
        setCameraStatsData: setCameraStatsData,
        setLoadingCameraStatsData: setLoadingCameraStatsData,
        setBandwidthData: setBandwidthData,
        setLoadingBandwidthData: setLoadingBandwidthData,
        setShowSiteStats: setShowSiteStats,
        cameraDropDownValue: cameraDropDownValue,
        setFilteredDataLengths: setFilteredDataLengths,
        sceneChangeValueString: sceneChangeValueString,
        setBulkSceneChangeOutcomesDialogOpen: setBulkSceneChangeOutcomesDialogOpen,
        navigate: navigate
    }));
};


const $230e66660cbd6ce3$export$cbb2337b4727ef7b = ({ cameraStatsData: cameraStatsData, loadingCameraStatsData: loadingCameraStatsData, alertsData: alertsData, setActiveTable: setActiveTable, setAlertStatusDialogOpen: setAlertStatusDialogOpen, setSelectedRow: setSelectedRow, setSelectedRowIndex: setSelectedRowIndex, setFectchingAllData: setFectchingAllData, setAlertsData: setAlertsData, setUnhealthyCamsData: setUnhealthyCamsData, unhealthyCamsData: unhealthyCamsData, clickedTab: clickedTab, setSortedData: setSortedData, activeName: activeName, setActiveName: setActiveName, singleCellActivated: singleCellActivated, setSingleCellActivated: setSingleCellActivated, setFilteredDataLengths: setFilteredDataLengths, setUpdatingStatus: setUpdatingStatus, showSiteStats: showSiteStats, filters: filters, alertFilter: alertFilter, setSceneChangeOutcomesDialogOpen: setSceneChangeOutcomesDialogOpen, setBackgroundFrame: setBackgroundFrame, setDetectedFrame: setDetectedFrame, setSelectedRows: setSelectedRows, selectedRows: selectedRows, setErrorsOverviewData: setErrorsOverviewData, setCameraStatsData: setCameraStatsData, setLoadingCameraStatsData: setLoadingCameraStatsData, setBandwidthData: setBandwidthData, setLoadingBandwidthData: setLoadingBandwidthData, setShowSiteStats: setShowSiteStats, cameraDropDownValue: cameraDropDownValue, navBarCollapsed: navBarCollapsed, userFilters: userFilters, sceneChangeValueString: sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen: setBulkSceneChangeOutcomesDialogOpen, navigate: navigate })=>{
    const [currentBandwidthSort, setCurrentBandwidthSort] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(`Volume (High to Low)`);
    const [sortedCameraStatsData, setSortedCameraStatsData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(cameraStatsData);
    let calculatedWidth = 1160;
    if (navBarCollapsed) calculatedWidth = 1235;
    if (cameraStatsData.length > 8) calculatedWidth = cameraStatsData.length * 145;
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setSortedCameraStatsData((0, $28694d530352034f$export$5db079623073b7f0)(sortedCameraStatsData, "total"));
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: !navBarCollapsed ? "absolute top-[50px] left-[20px] right-[1px] h-[475px] w-[1250px] bg-[#BDBDBD]" : "absolute top-[50px] left-[20px] right-[1px] h-[475px] w-[1325px] bg-[#BDBDBD]",
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: !navBarCollapsed ? "absolute top-[1px] left-[1px] right-[1px] h-[473px] w-[1248px] bg-white" : "absolute top-[1px] left-[1px] right-[1px] h-[473px] w-[1323px] bg-white",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "text-actuate-blue font-mulish text-[22px] font-bold absolute top-[8px] left-[30px]",
                    children: showSiteStats ? `Site Stats` : `Camera Stats`
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "text-actuate-blue font-mulish text-[14px] absolute top-[36px] left-[31px]",
                    children: showSiteStats ? `Total of each error and warning type per site during selected dates.` : `Total of each error and warning type per camera during selected dates.`
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: !navBarCollapsed ? "absolute top-[12px] left-[1040px]" : "absolute top-[12px] left-[1115px]",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ee9a771e2956a24e$export$9e621b76b2a3ce09), {
                        currentSort: currentBandwidthSort,
                        setCurrentSort: setCurrentBandwidthSort,
                        setSortedData: setSortedCameraStatsData,
                        volumeSortString: `total`,
                        nameSortString: `name`,
                        data: cameraStatsData
                    })
                }),
                loadingCameraStatsData && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "absolute top-[75px] left-[10px] h-[390px] w-[1230px] overflow-scroll scrollbar-hide",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                            size: 25,
                            sx: {
                                position: "relative",
                                left: 40
                            }
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "font-mulish text-actuate-blue test-bold",
                            children: "Fetching Data..."
                        })
                    ]
                }),
                !loadingCameraStatsData && (sortedCameraStatsData.length === 0 ? /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "text-actuate-blue font-mulish text-[22px]  absolute top-[230px] left-[500px]",
                    children: "No Data Available."
                }) : /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: !navBarCollapsed ? "absolute top-[75px] left-[10px] h-[390px] w-[1230px] overflow-scroll scrollbar-hide" : "absolute top-[75px] left-[10px] h-[390px] w-[1305px] overflow-scroll scrollbar-hide",
                    id: "stats_bar",
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $dc284d0fb10e6f6a$export$94aefc399ef206a9), {
                        id: "stats_bar",
                        width: calculatedWidth,
                        height: 380,
                        data: sortedCameraStatsData,
                        barSize: 120,
                        margin: {
                            top: 5,
                            right: 0,
                            left: 18,
                            bottom: 35
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $381060c808bbe825$export$6440e27b9f186856), {
                                strokeDasharray: "3 3"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $e3fbaf009dcc8585$export$ea77231de273b52d), {
                                dataKey: "name",
                                type: "category",
                                hide: true
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $c7554316bfb1649b$export$f96c4024c52de8f4), {
                                allowDecimals: false,
                                label: {
                                    value: "Total Volume",
                                    angle: -90,
                                    position: "insideLeft",
                                    offset: -10
                                }
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $a67bff487a060557$export$ed247974535929c7), {
                                verticalAlign: "top",
                                align: "left",
                                height: 50
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $45dbb8bb277f9d9d$export$28c660c63b792dea), {}),
                            (userFilters.metrics.includes("Connectivity") || userFilters.metrics.length === 0) && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7d5fe63ca2eb078d$export$bbc6c6369b38e3d1), {
                                id: "stats_bar",
                                cursor: "pointer",
                                dataKey: "connectivity",
                                fill: "#53B2AD",
                                stackId: "a",
                                name: "Connectivity",
                                onClick: (event, eventIndex)=>{
                                    sortedCameraStatsData.map((entry, index)=>{
                                        if (eventIndex === index) {
                                            if (singleCellActivated && activeName !== entry.name) setSingleCellActivated(true);
                                            if (singleCellActivated && activeName === entry.name) setSingleCellActivated(false);
                                            if (!singleCellActivated) setSingleCellActivated(true);
                                            setActiveName(entry.name);
                                            setActiveTable(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
                                            setTimeout(()=>{
                                                (0, $1a8d7063bb30dc08$export$200cf8913388bd37)(alertsData, entry.name, !singleCellActivated, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setFectchingAllData, setAlertsData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setSortedData, setFilteredDataLengths, setUpdatingStatus, activeName, entry.name, showSiteStats, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate);
                                            }, 1);
                                        }
                                    });
                                },
                                children: [
                                    singleCellActivated && sortedCameraStatsData.map((entry, index)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $fe1584e453ed4ef4$export$f6f0c3fe4ec306ea), {
                                            cursor: "pointer",
                                            fill: entry.name === activeName ? "#53B2AD" : "#888888"
                                        }, `cell-${index}`)),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $1778bc5734fdac4c$export$835fcf23ab7bf88), {
                                        dataKey: "display_name",
                                        position: "bottom"
                                    })
                                ]
                            }),
                            (userFilters.metrics.includes("Scene Change") || userFilters.metrics.length === 0) && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7d5fe63ca2eb078d$export$bbc6c6369b38e3d1), {
                                id: "stats_bar",
                                cursor: "pointer",
                                dataKey: "scene_change",
                                fill: "#E68B37",
                                stackId: "a",
                                name: "Scene Change",
                                onClick: (event, eventIndex)=>{
                                    sortedCameraStatsData.map((entry, index)=>{
                                        if (eventIndex === index) {
                                            setActiveName(entry.name);
                                            setActiveTable(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
                                            setTimeout(()=>{
                                                setSingleCellActivated(!singleCellActivated);
                                                (0, $1a8d7063bb30dc08$export$200cf8913388bd37)(alertsData, entry.name, !singleCellActivated, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setFectchingAllData, setAlertsData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setSortedData, setFilteredDataLengths, setUpdatingStatus, activeName, entry.name, showSiteStats, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate);
                                            }, 1);
                                        }
                                    });
                                },
                                children: [
                                    singleCellActivated && sortedCameraStatsData.map((entry, index)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $fe1584e453ed4ef4$export$f6f0c3fe4ec306ea), {
                                            cursor: "pointer",
                                            fill: entry.name === activeName ? "#E68B37" : "#888888"
                                        }, `cell-${index}`)),
                                    !userFilters.metrics.includes("Connectivity") && userFilters.metrics.length > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $1778bc5734fdac4c$export$835fcf23ab7bf88), {
                                        dataKey: "display_name",
                                        position: "bottom"
                                    })
                                ]
                            }),
                            (userFilters.metrics.includes("Recording Status") || userFilters.metrics.length === 0) && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7d5fe63ca2eb078d$export$bbc6c6369b38e3d1), {
                                id: "stats_bar",
                                cursor: "pointer",
                                dataKey: "recording_status",
                                fill: "#CD4A81",
                                stackId: "a",
                                name: "Recording Status",
                                onClick: (event, eventIndex)=>{
                                    sortedCameraStatsData.map((entry, index)=>{
                                        if (eventIndex === index) {
                                            setActiveName(entry.name);
                                            setActiveTable(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
                                            setTimeout(()=>{
                                                setSingleCellActivated(!singleCellActivated);
                                                (0, $1a8d7063bb30dc08$export$200cf8913388bd37)(alertsData, entry.name, !singleCellActivated, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setFectchingAllData, setAlertsData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setSortedData, setFilteredDataLengths, setUpdatingStatus, activeName, entry.name, showSiteStats, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate);
                                            }, 1);
                                        }
                                    });
                                },
                                children: [
                                    singleCellActivated && sortedCameraStatsData.map((entry, index)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $fe1584e453ed4ef4$export$f6f0c3fe4ec306ea), {
                                            cursor: "pointer",
                                            fill: entry.name === activeName ? "#CD4A81" : "#888888"
                                        }, `cell-${index}`)),
                                    !userFilters.metrics.includes("Connectivity") && !userFilters.metrics.includes("Scene Change") && userFilters.metrics.length > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $1778bc5734fdac4c$export$835fcf23ab7bf88), {
                                        dataKey: "display_name",
                                        position: "bottom"
                                    })
                                ]
                            }),
                            (userFilters.metrics.includes("Motion Status") || userFilters.metrics.length === 0) && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7d5fe63ca2eb078d$export$bbc6c6369b38e3d1), {
                                id: "stats_bar",
                                cursor: "pointer",
                                dataKey: "motion_status",
                                fill: "#7F83F3",
                                stackId: "a",
                                name: "Motion Status",
                                onClick: (event, eventIndex)=>{
                                    sortedCameraStatsData.map((entry, index)=>{
                                        if (eventIndex === index) {
                                            setActiveName(entry.name);
                                            setActiveTable(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
                                            setTimeout(()=>{
                                                setSingleCellActivated(!singleCellActivated);
                                                (0, $1a8d7063bb30dc08$export$200cf8913388bd37)(alertsData, entry.name, !singleCellActivated, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setFectchingAllData, setAlertsData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setSortedData, setFilteredDataLengths, setUpdatingStatus, activeName, entry.name, showSiteStats, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate);
                                            }, 1);
                                        }
                                    });
                                },
                                children: [
                                    singleCellActivated && sortedCameraStatsData.map((entry, index)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $fe1584e453ed4ef4$export$f6f0c3fe4ec306ea), {
                                            cursor: "pointer",
                                            fill: entry.name === activeName ? "#7F83F3" : "#888888"
                                        }, `cell-${index}`)),
                                    !userFilters.metrics.includes("Connectivity") && !userFilters.metrics.includes("Scene Change") && !userFilters.metrics.includes("Recording Status") && userFilters.metrics.length > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $1778bc5734fdac4c$export$835fcf23ab7bf88), {
                                        dataKey: "display_name",
                                        position: "bottom"
                                    })
                                ]
                            }),
                            (userFilters.metrics.includes("Image Quality") || userFilters.metrics.length === 0) && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7d5fe63ca2eb078d$export$bbc6c6369b38e3d1), {
                                id: "stats_bar",
                                cursor: "pointer",
                                dataKey: "image_quality",
                                fill: "#8EDE79",
                                stackId: "a",
                                name: "Image Quality",
                                onClick: (event, eventIndex)=>{
                                    sortedCameraStatsData.map((entry, index)=>{
                                        if (eventIndex === index) {
                                            setActiveName(entry.name);
                                            setActiveTable(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
                                            setTimeout(()=>{
                                                setSingleCellActivated(!singleCellActivated);
                                                (0, $1a8d7063bb30dc08$export$200cf8913388bd37)(alertsData, entry.name, !singleCellActivated, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setFectchingAllData, setAlertsData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setSortedData, setFilteredDataLengths, setUpdatingStatus, activeName, entry.name, showSiteStats, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate);
                                            }, 1);
                                        }
                                    });
                                },
                                children: [
                                    singleCellActivated && sortedCameraStatsData.map((entry, index)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $fe1584e453ed4ef4$export$f6f0c3fe4ec306ea), {
                                            cursor: "pointer",
                                            fill: entry.name === activeName ? "#8EDE79" : "#888888"
                                        }, `cell-${index}`)),
                                    !userFilters.metrics.includes("Connectivity") && !userFilters.metrics.includes("Scene Change") && !userFilters.metrics.includes("Recording Status") && !userFilters.metrics.includes("Motion Status") && userFilters.metrics.length > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $1778bc5734fdac4c$export$835fcf23ab7bf88), {
                                        dataKey: "display_name",
                                        position: "bottom"
                                    }),
                                    " "
                                ]
                            }),
                            (userFilters.metrics.includes("Stream Quality") || userFilters.metrics.length === 0) && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7d5fe63ca2eb078d$export$bbc6c6369b38e3d1), {
                                id: "stats_bar",
                                cursor: "pointer",
                                dataKey: "stream_quality",
                                fill: "#39B1EA",
                                stackId: "a",
                                name: "Stream Quality",
                                onClick: (event, eventIndex)=>{
                                    sortedCameraStatsData.map((entry, index)=>{
                                        if (eventIndex === index) {
                                            setActiveName(entry.name);
                                            setActiveTable(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
                                            setTimeout(()=>{
                                                setSingleCellActivated(!singleCellActivated);
                                                (0, $1a8d7063bb30dc08$export$200cf8913388bd37)(alertsData, entry.name, !singleCellActivated, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setFectchingAllData, setAlertsData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setSortedData, setFilteredDataLengths, setUpdatingStatus, activeName, entry.name, showSiteStats, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate);
                                            }, 1);
                                        }
                                    });
                                },
                                children: [
                                    singleCellActivated && sortedCameraStatsData.map((entry, index)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $fe1584e453ed4ef4$export$f6f0c3fe4ec306ea), {
                                            cursor: "pointer",
                                            fill: entry.name === activeName ? "#39B1EA" : "#888888"
                                        }, `cell-${index}`)),
                                    !userFilters.metrics.includes("Connectivity") && !userFilters.metrics.includes("Scene Change") && !userFilters.metrics.includes("Recording Status") && !userFilters.metrics.includes("Image Quality") && !userFilters.metrics.includes("Motion Status") && userFilters.metrics.length > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $1778bc5734fdac4c$export$835fcf23ab7bf88), {
                                        dataKey: "display_name",
                                        position: "bottom"
                                    }),
                                    " "
                                ]
                            })
                        ]
                    })
                }))
            ]
        })
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $8jTCz = parcelRequire("8jTCz");


var $60vL1 = parcelRequire("60vL1");
const $71ee7518316e8b2b$export$5e34da326b60d8f0 = ({ downloadURL: downloadURL, loading: loading })=>{
    if (loading) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
        onClick: ()=>{},
        text: /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
            className: "inline-flex items-center",
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                    size: 16,
                    sx: {
                        color: "white"
                    }
                }),
                "\xa0Fetching Report..."
            ]
        }),
        disabled: true
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
        onClick: ()=>{},
        text: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $68f1b505950a9d00$export$2e2bcd8739ae039), {}),
                "\xa0",
                /*#__PURE__*/ (0, $k4ank.jsx)("a", {
                    href: downloadURL,
                    download: true,
                    children: "Download Report"
                })
            ]
        }),
        disabled: !downloadURL
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $cye0Y = parcelRequire("cye0Y");

var $gouAT = parcelRequire("gouAT");

var $5Ibhh = parcelRequire("5Ibhh");

var $eDfvp = parcelRequire("eDfvp");

var $3n3uW = parcelRequire("3n3uW");

var $2suvB = parcelRequire("2suvB");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");


var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

const $a62e7bbf38ef7afc$export$a2de4af979043477 = (event, newValue, setActiveTable, setClickedTab, alertsData, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setFectchingAllData, setAlertsData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setSortedData, singleCellActivated, activeName, setUpdatingStatus, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setFilteredDataLengths, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate)=>{
    setClickedTab(newValue);
    if (newValue === "all") setTimeout(()=>{
        setActiveTable(/*#__PURE__*/ (0, $k4ank.jsx)((0, $51b9c926dce642ac$export$90c542b47ca9ed4a), {
            alertsData: alertsData,
            setAlertStatusDialogOpen: setAlertStatusDialogOpen,
            setSelectedRow: setSelectedRow,
            setSelectedRowIndex: setSelectedRowIndex,
            setFectchingAllData: setFectchingAllData,
            setAlertsData: setAlertsData,
            setUnhealthyCamsData: setUnhealthyCamsData,
            unhealthyCamsData: unhealthyCamsData,
            clickedTab: "all",
            setActiveTable: setActiveTable,
            setSortedData: setSortedData,
            singleCellActivated: singleCellActivated,
            activeName: activeName,
            setUpdatingStatus: setUpdatingStatus,
            filters: filters,
            alertFilter: alertFilter,
            setSceneChangeOutcomesDialogOpen: setSceneChangeOutcomesDialogOpen,
            setBackgroundFrame: setBackgroundFrame,
            setDetectedFrame: setDetectedFrame,
            setSelectedRows: setSelectedRows,
            selectedRows: selectedRows,
            setErrorsOverviewData: setErrorsOverviewData,
            setCameraStatsData: setCameraStatsData,
            setLoadingCameraStatsData: setLoadingCameraStatsData,
            setBandwidthData: setBandwidthData,
            setLoadingBandwidthData: setLoadingBandwidthData,
            setShowSiteStats: setShowSiteStats,
            cameraDropDownValue: cameraDropDownValue,
            setFilteredDataLengths: setFilteredDataLengths,
            sceneChangeValueString: sceneChangeValueString,
            setBulkSceneChangeOutcomesDialogOpen: setBulkSceneChangeOutcomesDialogOpen,
            navigate: navigate
        }));
    }, 1);
    if (newValue === "errors") setTimeout(()=>{
        setActiveTable(/*#__PURE__*/ (0, $k4ank.jsx)((0, $51b9c926dce642ac$export$90c542b47ca9ed4a), {
            alertsData: alertsData,
            setAlertStatusDialogOpen: setAlertStatusDialogOpen,
            setSelectedRow: setSelectedRow,
            setSelectedRowIndex: setSelectedRowIndex,
            setFectchingAllData: setFectchingAllData,
            setAlertsData: setAlertsData,
            setUnhealthyCamsData: setUnhealthyCamsData,
            unhealthyCamsData: unhealthyCamsData,
            clickedTab: "errors",
            setActiveTable: setActiveTable,
            setSortedData: setSortedData,
            singleCellActivated: singleCellActivated,
            activeName: activeName,
            setUpdatingStatus: setUpdatingStatus,
            filters: filters,
            alertFilter: alertFilter,
            setSceneChangeOutcomesDialogOpen: setSceneChangeOutcomesDialogOpen,
            setBackgroundFrame: setBackgroundFrame,
            setDetectedFrame: setDetectedFrame,
            setSelectedRows: setSelectedRows,
            selectedRows: selectedRows,
            setErrorsOverviewData: setErrorsOverviewData,
            setCameraStatsData: setCameraStatsData,
            setLoadingCameraStatsData: setLoadingCameraStatsData,
            setBandwidthData: setBandwidthData,
            setLoadingBandwidthData: setLoadingBandwidthData,
            setShowSiteStats: setShowSiteStats,
            cameraDropDownValue: cameraDropDownValue,
            setFilteredDataLengths: setFilteredDataLengths,
            sceneChangeValueString: sceneChangeValueString,
            setBulkSceneChangeOutcomesDialogOpen: setBulkSceneChangeOutcomesDialogOpen,
            navigate: navigate
        }));
    }, 1);
    if (newValue === "warnings") setTimeout(()=>{
        setActiveTable(/*#__PURE__*/ (0, $k4ank.jsx)((0, $51b9c926dce642ac$export$90c542b47ca9ed4a), {
            alertsData: alertsData,
            setAlertStatusDialogOpen: setAlertStatusDialogOpen,
            setSelectedRow: setSelectedRow,
            setSelectedRowIndex: setSelectedRowIndex,
            setFectchingAllData: setFectchingAllData,
            setAlertsData: setAlertsData,
            setUnhealthyCamsData: setUnhealthyCamsData,
            unhealthyCamsData: unhealthyCamsData,
            clickedTab: "warnings",
            setActiveTable: setActiveTable,
            setSortedData: setSortedData,
            singleCellActivated: singleCellActivated,
            activeName: activeName,
            setUpdatingStatus: setUpdatingStatus,
            filters: filters,
            alertFilter: alertFilter,
            setSceneChangeOutcomesDialogOpen: setSceneChangeOutcomesDialogOpen,
            setBackgroundFrame: setBackgroundFrame,
            setDetectedFrame: setDetectedFrame,
            setSelectedRows: setSelectedRows,
            selectedRows: selectedRows,
            setErrorsOverviewData: setErrorsOverviewData,
            setCameraStatsData: setCameraStatsData,
            setLoadingCameraStatsData: setLoadingCameraStatsData,
            setBandwidthData: setBandwidthData,
            setLoadingBandwidthData: setLoadingBandwidthData,
            setShowSiteStats: setShowSiteStats,
            cameraDropDownValue: cameraDropDownValue,
            setFilteredDataLengths: setFilteredDataLengths,
            sceneChangeValueString: sceneChangeValueString,
            setBulkSceneChangeOutcomesDialogOpen: setBulkSceneChangeOutcomesDialogOpen,
            navigate: navigate
        }));
    }, 1);
    if (newValue === "pending") setTimeout(()=>{
        setActiveTable(/*#__PURE__*/ (0, $k4ank.jsx)((0, $51b9c926dce642ac$export$90c542b47ca9ed4a), {
            alertsData: alertsData,
            setAlertStatusDialogOpen: setAlertStatusDialogOpen,
            setSelectedRow: setSelectedRow,
            setSelectedRowIndex: setSelectedRowIndex,
            setFectchingAllData: setFectchingAllData,
            setAlertsData: setAlertsData,
            setUnhealthyCamsData: setUnhealthyCamsData,
            unhealthyCamsData: unhealthyCamsData,
            clickedTab: "pending",
            setActiveTable: setActiveTable,
            setSortedData: setSortedData,
            singleCellActivated: singleCellActivated,
            activeName: activeName,
            setUpdatingStatus: setUpdatingStatus,
            filters: filters,
            alertFilter: alertFilter,
            setSceneChangeOutcomesDialogOpen: setSceneChangeOutcomesDialogOpen,
            setBackgroundFrame: setBackgroundFrame,
            setDetectedFrame: setDetectedFrame,
            setSelectedRows: setSelectedRows,
            selectedRows: selectedRows,
            setErrorsOverviewData: setErrorsOverviewData,
            setCameraStatsData: setCameraStatsData,
            setLoadingCameraStatsData: setLoadingCameraStatsData,
            setBandwidthData: setBandwidthData,
            setLoadingBandwidthData: setLoadingBandwidthData,
            setShowSiteStats: setShowSiteStats,
            cameraDropDownValue: cameraDropDownValue,
            setFilteredDataLengths: setFilteredDataLengths,
            sceneChangeValueString: sceneChangeValueString,
            setBulkSceneChangeOutcomesDialogOpen: setBulkSceneChangeOutcomesDialogOpen,
            navigate: navigate
        }));
    }, 1);
    if (newValue === "resolved") setTimeout(()=>{
        setActiveTable(/*#__PURE__*/ (0, $k4ank.jsx)((0, $51b9c926dce642ac$export$90c542b47ca9ed4a), {
            alertsData: alertsData,
            setAlertStatusDialogOpen: setAlertStatusDialogOpen,
            setSelectedRow: setSelectedRow,
            setSelectedRowIndex: setSelectedRowIndex,
            setFectchingAllData: setFectchingAllData,
            setAlertsData: setAlertsData,
            setUnhealthyCamsData: setUnhealthyCamsData,
            unhealthyCamsData: unhealthyCamsData,
            clickedTab: "resolved",
            setActiveTable: setActiveTable,
            setSortedData: setSortedData,
            singleCellActivated: singleCellActivated,
            activeName: activeName,
            setUpdatingStatus: setUpdatingStatus,
            filters: filters,
            alertFilter: alertFilter,
            setSceneChangeOutcomesDialogOpen: setSceneChangeOutcomesDialogOpen,
            setBackgroundFrame: setBackgroundFrame,
            setDetectedFrame: setDetectedFrame,
            setSelectedRows: setSelectedRows,
            selectedRows: selectedRows,
            setErrorsOverviewData: setErrorsOverviewData,
            setCameraStatsData: setCameraStatsData,
            setLoadingCameraStatsData: setLoadingCameraStatsData,
            setBandwidthData: setBandwidthData,
            setLoadingBandwidthData: setLoadingBandwidthData,
            setShowSiteStats: setShowSiteStats,
            cameraDropDownValue: cameraDropDownValue,
            setFilteredDataLengths: setFilteredDataLengths,
            sceneChangeValueString: sceneChangeValueString,
            setBulkSceneChangeOutcomesDialogOpen: setBulkSceneChangeOutcomesDialogOpen,
            navigate: navigate
        }));
    }, 1);
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $a65wX = parcelRequire("a65wX");

var $1fWBE = parcelRequire("1fWBE");

var $cxknk = parcelRequire("cxknk");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

const $d7ab45335e91aaa3$export$291477d786c8cb37 = (alertFilter, alertsData, setFilteredDataLengths, singleCellActivated, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setFectchingAllData, setAlertsData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setSortedData, setUpdatingStatus, filters, activeName, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate)=>{
    const updatedAlertsAllData = [];
    const updatedAlertsErrorsData = [];
    const updatedAlertsWarningsData = [];
    const updatedAlertsPendingData = [];
    const updatedAlertsResolvedData = [];
    if (singleCellActivated && alertFilter !== "all") {
        alertsData.all.forEach((object)=>{
            if ((object.camera_name === activeName || object.site_name === activeName) && object.error_type === alertFilter) updatedAlertsAllData.push(object);
        });
        alertsData.errors.forEach((object)=>{
            if ((object.camera_name === activeName || object.site_name === activeName) && object.error_type === alertFilter) updatedAlertsErrorsData.push(object);
        });
        alertsData.warnings.forEach((object)=>{
            if ((object.camera_name === activeName || object.site_name === activeName) && object.error_type === alertFilter) updatedAlertsWarningsData.push(object);
        });
        alertsData.pending.forEach((object)=>{
            if ((object.camera_name === activeName || object.site_name === activeName) && object.error_type === alertFilter) updatedAlertsPendingData.push(object);
        });
        alertsData.resolved.forEach((object)=>{
            if ((object.camera_name === activeName || object.site_name === activeName) && object.error_type === alertFilter) updatedAlertsResolvedData.push(object);
        });
    } else if (singleCellActivated && alertFilter === "all") {
        alertsData.all.forEach((object)=>{
            if (object.camera_name === activeName || object.site_name === activeName) updatedAlertsAllData.push(object);
        });
        alertsData.errors.forEach((object)=>{
            if (object.camera_name === activeName || object.site_name === activeName) updatedAlertsErrorsData.push(object);
        });
        alertsData.warnings.forEach((object)=>{
            if (object.camera_name === activeName || object.site_name === activeName) updatedAlertsWarningsData.push(object);
        });
        alertsData.pending.forEach((object)=>{
            if (object.camera_name === activeName || object.site_name === activeName) updatedAlertsPendingData.push(object);
        });
        alertsData.resolved.forEach((object)=>{
            if (object.camera_name === activeName || object.site_name === activeName) updatedAlertsResolvedData.push(object);
        });
    } else if (!singleCellActivated && alertFilter !== "all") {
        alertsData.all.forEach((object)=>{
            if (object.error_type === alertFilter) updatedAlertsAllData.push(object);
        });
        alertsData.errors.forEach((object)=>{
            if (object.error_type === alertFilter) updatedAlertsErrorsData.push(object);
        });
        alertsData.warnings.forEach((object)=>{
            if (object.error_type === alertFilter) updatedAlertsWarningsData.push(object);
        });
        alertsData.pending.forEach((object)=>{
            if (object.error_type === alertFilter) updatedAlertsPendingData.push(object);
        });
        alertsData.resolved.forEach((object)=>{
            if (object.error_type === alertFilter) updatedAlertsResolvedData.push(object);
        });
    } else {
        alertsData.all.forEach((object)=>{
            updatedAlertsAllData.push(object);
        });
        alertsData.errors.forEach((object)=>{
            updatedAlertsErrorsData.push(object);
        });
        alertsData.warnings.forEach((object)=>{
            updatedAlertsWarningsData.push(object);
        });
        alertsData.pending.forEach((object)=>{
            updatedAlertsPendingData.push(object);
        });
        alertsData.resolved.forEach((object)=>{
            updatedAlertsResolvedData.push(object);
        });
    }
    setFilteredDataLengths({
        all: updatedAlertsAllData.length,
        errors: updatedAlertsErrorsData.length,
        warnings: updatedAlertsWarningsData.length,
        pending: updatedAlertsPendingData.length,
        resolved: updatedAlertsResolvedData.length
    });
    setTimeout(()=>{
        setActiveTable(/*#__PURE__*/ (0, $k4ank.jsx)((0, $51b9c926dce642ac$export$90c542b47ca9ed4a), {
            alertsData: alertsData,
            setAlertStatusDialogOpen: setAlertStatusDialogOpen,
            setSelectedRow: setSelectedRow,
            setSelectedRowIndex: setSelectedRowIndex,
            setFectchingAllData: setFectchingAllData,
            setAlertsData: setAlertsData,
            setUnhealthyCamsData: setUnhealthyCamsData,
            unhealthyCamsData: unhealthyCamsData,
            clickedTab: clickedTab,
            setActiveTable: setActiveTable,
            setSortedData: setSortedData,
            singleCellActivated: singleCellActivated,
            activeName: activeName,
            setUpdatingStatus: setUpdatingStatus,
            filters: filters,
            alertFilter: alertFilter,
            setSceneChangeOutcomesDialogOpen: setSceneChangeOutcomesDialogOpen,
            setBackgroundFrame: setBackgroundFrame,
            setDetectedFrame: setDetectedFrame,
            setSelectedRows: setSelectedRows,
            selectedRows: selectedRows,
            setErrorsOverviewData: setErrorsOverviewData,
            setCameraStatsData: setCameraStatsData,
            setLoadingCameraStatsData: setLoadingCameraStatsData,
            setBandwidthData: setBandwidthData,
            setLoadingBandwidthData: setLoadingBandwidthData,
            setShowSiteStats: setShowSiteStats,
            cameraDropDownValue: cameraDropDownValue,
            setFilteredDataLengths: setFilteredDataLengths,
            sceneChangeValueString: sceneChangeValueString,
            setBulkSceneChangeOutcomesDialogOpen: setBulkSceneChangeOutcomesDialogOpen,
            navigate: navigate
        }));
    }, 1);
};


const $0c09780047ea8af9$export$aa9fab813503c459 = ({ alertFilter: alertFilter, setAlertFilter: setAlertFilter, alertsData: alertsData, setFilteredDataLengths: setFilteredDataLengths, singleCellActivated: singleCellActivated, setActiveTable: setActiveTable, setAlertStatusDialogOpen: setAlertStatusDialogOpen, setSelectedRow: setSelectedRow, setSelectedRowIndex: setSelectedRowIndex, setFectchingAllData: setFectchingAllData, setAlertsData: setAlertsData, setUnhealthyCamsData: setUnhealthyCamsData, unhealthyCamsData: unhealthyCamsData, clickedTab: clickedTab, setSortedData: setSortedData, setUpdatingStatus: setUpdatingStatus, filters: filters, activeName: activeName, setSceneChangeOutcomesDialogOpen: setSceneChangeOutcomesDialogOpen, setBackgroundFrame: setBackgroundFrame, setDetectedFrame: setDetectedFrame, setSelectedRows: setSelectedRows, selectedRows: selectedRows, setErrorsOverviewData: setErrorsOverviewData, setCameraStatsData: setCameraStatsData, setLoadingCameraStatsData: setLoadingCameraStatsData, setBandwidthData: setBandwidthData, setLoadingBandwidthData: setLoadingBandwidthData, setShowSiteStats: setShowSiteStats, cameraDropDownValue: cameraDropDownValue, sceneChangeValueString: sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen: setBulkSceneChangeOutcomesDialogOpen, navigate: navigate })=>{
    const optionsArrayArray = [
        {
            name: "All Alerts",
            value: "all"
        }
    ];
    if (filters.metrics.includes("Connectivity") || filters.metrics.length === 0) optionsArrayArray.push({
        name: "Connectivity Alerts",
        value: "connectivity"
    });
    if (filters.metrics.includes("Image Quality") || filters.metrics.length === 0) optionsArrayArray.push({
        name: "Image Quality Alerts",
        value: "image_quality"
    });
    if (filters.metrics.includes("Scene Change") || filters.metrics.length === 0) optionsArrayArray.push({
        name: "Scene Change Alerts",
        value: "scene_change"
    });
    if (filters.metrics.includes("Stream Quality") || filters.metrics.length === 0) optionsArrayArray.push({
        name: "Stream Quality Alerts",
        value: "stream_quality"
    });
    if (filters.metrics.includes("Motion Status") || filters.metrics.length === 0) optionsArrayArray.push({
        name: "Motion Status Alerts",
        value: "motion_status"
    });
    if (filters.metrics.includes("Recording Status") || filters.metrics.length === 0) optionsArrayArray.push({
        name: "Recording Status Alerts",
        value: "recording_status"
    });
    const optionMaps = new Map();
    optionsArrayArray.forEach((option)=>{
        optionMaps.set(`${option.value}`, `${option.name}`);
    });
    const [anchorEl, setAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "absolute text-[14px] top-[7.5px] w-[80px] left-[10px]",
                    children: "FILTER BY"
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "absolute left-[77px] w-[220px]",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                            id: "filter-button",
                            "aria-controls": open ? "filter-menu" : undefined,
                            "aria-haspopup": "true",
                            "aria-expanded": open ? "true" : undefined,
                            onClick: handleClick,
                            children: optionMaps.get(alertFilter)
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $1fWBE.default), {
                            id: "filter-menu",
                            anchorEl: anchorEl,
                            open: open,
                            onClose: handleClose,
                            MenuListProps: {
                                "aria-labelledby": "filter-button"
                            },
                            children: optionsArrayArray.map((object)=>{
                                return /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                    onClick: ()=>{
                                        setAlertFilter(object.value);
                                        setActiveTable(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
                                        (0, $d7ab45335e91aaa3$export$291477d786c8cb37)(object.value, alertsData, setFilteredDataLengths, singleCellActivated, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setFectchingAllData, setAlertsData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setSortedData, setUpdatingStatus, filters, activeName, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate);
                                        handleClose();
                                    },
                                    children: object.name
                                }, object.value);
                            })
                        })
                    ]
                })
            ]
        })
    });
};


const $553166b111a7b130$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $553166b111a7b130$export$275636fcbaf1f952 = ({ unhealthyCamsData: unhealthyCamsData, clickedTab: clickedTab, setClickedTab: setClickedTab, alertsData: alertsData, activeTable: activeTable, setActiveTable: setActiveTable, setAlertStatusDialogOpen: setAlertStatusDialogOpen, setSelectedRow: setSelectedRow, setSelectedRowIndex: setSelectedRowIndex, setFectchingAllData: setFectchingAllData, setAlertsData: setAlertsData, updatingStatus: updatingStatus, setUnhealthyCamsData: setUnhealthyCamsData, setSortedData: setSortedData, singleCellActivated: singleCellActivated, activeName: activeName, filteredDataLengths: filteredDataLengths, setUpdatingStatus: setUpdatingStatus, cameraDropDownValue: cameraDropDownValue, filters: filters, alertFilter: alertFilter, setAlertFilter: setAlertFilter, setFilteredDataLengths: setFilteredDataLengths, setSceneChangeOutcomesDialogOpen: setSceneChangeOutcomesDialogOpen, setBackgroundFrame: setBackgroundFrame, setDetectedFrame: setDetectedFrame, setSelectedRows: setSelectedRows, selectedRows: selectedRows, setErrorsOverviewData: setErrorsOverviewData, setCameraStatsData: setCameraStatsData, setLoadingCameraStatsData: setLoadingCameraStatsData, setBandwidthData: setBandwidthData, setLoadingBandwidthData: setLoadingBandwidthData, setShowSiteStats: setShowSiteStats, navBarCollapsed: navBarCollapsed, sceneChangeValueString: sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen: setBulkSceneChangeOutcomesDialogOpen, navigate: navigate })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setActiveTable(/*#__PURE__*/ (0, $k4ank.jsx)((0, $51b9c926dce642ac$export$90c542b47ca9ed4a), {
            alertsData: alertsData,
            setAlertStatusDialogOpen: setAlertStatusDialogOpen,
            setSelectedRow: setSelectedRow,
            setSelectedRowIndex: setSelectedRowIndex,
            setFectchingAllData: setFectchingAllData,
            setAlertsData: setAlertsData,
            setUnhealthyCamsData: setUnhealthyCamsData,
            unhealthyCamsData: unhealthyCamsData,
            clickedTab: clickedTab,
            setActiveTable: setActiveTable,
            setSortedData: setSortedData,
            singleCellActivated: singleCellActivated,
            activeName: activeName,
            setUpdatingStatus: setUpdatingStatus,
            filters: filters,
            alertFilter: alertFilter,
            setSceneChangeOutcomesDialogOpen: setSceneChangeOutcomesDialogOpen,
            setBackgroundFrame: setBackgroundFrame,
            setDetectedFrame: setDetectedFrame,
            setSelectedRows: setSelectedRows,
            selectedRows: selectedRows,
            setErrorsOverviewData: setErrorsOverviewData,
            setCameraStatsData: setCameraStatsData,
            setLoadingCameraStatsData: setLoadingCameraStatsData,
            setBandwidthData: setBandwidthData,
            setLoadingBandwidthData: setLoadingBandwidthData,
            setShowSiteStats: setShowSiteStats,
            cameraDropDownValue: cameraDropDownValue,
            setFilteredDataLengths: setFilteredDataLengths,
            sceneChangeValueString: sceneChangeValueString,
            setBulkSceneChangeOutcomesDialogOpen: setBulkSceneChangeOutcomesDialogOpen,
            navigate: navigate
        }));
    }, [
        alertsData
    ]);
    const tableWidth = !navBarCollapsed ? [
        1250,
        1248
    ] : [
        1325,
        1323
    ];
    return /*#__PURE__*/ (0, $k4ank.jsx)("div", {
        className: singleCellActivated || cameraDropDownValue ? `absolute top-[50px] left-[20px] right-[1px] h-[455px] w-[${tableWidth[0]}px] bg-[#BDBDBD]` : `absolute top-[50px] left-[20px] right-[1px] h-[575px] w-[${tableWidth[0]}px] bg-[#BDBDBD]`,
        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
            className: singleCellActivated || cameraDropDownValue ? `absolute top-[1px] left-[1px] right-[1px] h-[453px] w-[${tableWidth[1]}px] bg-white` : `absolute top-[1px] left-[1px] right-[1px] h-[573px] w-[${tableWidth[1]}px] bg-white`,
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                    className: "text-actuate-blue font-mulish text-[22px] font-bold absolute top-[8px] left-[30px]",
                    children: singleCellActivated || cameraDropDownValue ? `Alerts ${activeName ? activeName : cameraDropDownValue}` : `Alerts`
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: !navBarCollapsed ? "absolute top-[8px] left-[940px]" : "absolute top-[8px] left-[1015px]",
                    children: (filters.metrics.length === 0 || filters.metrics.length > 1) && /*#__PURE__*/ (0, $k4ank.jsx)((0, $0c09780047ea8af9$export$aa9fab813503c459), {
                        alertFilter: alertFilter,
                        setAlertFilter: setAlertFilter,
                        alertsData: alertsData,
                        setFilteredDataLengths: setFilteredDataLengths,
                        singleCellActivated: singleCellActivated,
                        setActiveTable: setActiveTable,
                        setAlertStatusDialogOpen: setAlertStatusDialogOpen,
                        setSelectedRow: setSelectedRow,
                        setSelectedRowIndex: setSelectedRowIndex,
                        setFectchingAllData: setFectchingAllData,
                        setAlertsData: setAlertsData,
                        setUnhealthyCamsData: setUnhealthyCamsData,
                        unhealthyCamsData: unhealthyCamsData,
                        clickedTab: clickedTab,
                        setSortedData: setSortedData,
                        setUpdatingStatus: setUpdatingStatus,
                        filters: filters,
                        activeName: activeName,
                        setSceneChangeOutcomesDialogOpen: setSceneChangeOutcomesDialogOpen,
                        setBackgroundFrame: setBackgroundFrame,
                        setDetectedFrame: setDetectedFrame,
                        setSelectedRows: setSelectedRows,
                        selectedRows: selectedRows,
                        setErrorsOverviewData: setErrorsOverviewData,
                        setCameraStatsData: setCameraStatsData,
                        setLoadingCameraStatsData: setLoadingCameraStatsData,
                        setBandwidthData: setBandwidthData,
                        setLoadingBandwidthData: setLoadingBandwidthData,
                        setShowSiteStats: setShowSiteStats,
                        cameraDropDownValue: cameraDropDownValue,
                        sceneChangeValueString: sceneChangeValueString,
                        setBulkSceneChangeOutcomesDialogOpen: setBulkSceneChangeOutcomesDialogOpen,
                        navigate: navigate
                    })
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)("div", {}),
                !singleCellActivated && !cameraDropDownValue && filters.metrics.length === 0 && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: !navBarCollapsed ? "absolute left-[50px]" : "absolute left-[88px]",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "absolute top-[50px] left-[0px] right-[1px] h-[100px] w-[250px] bg-[#BDBDBD]",
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "absolute top-[1px] left-[1px] right-[1px] h-[98px] w-[248px] bg-white",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "font-mulish text-[18px] text-actuate-blue pt-[10px] pl-[15px]",
                                        children: "Unhealthy Cameras"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                            className: "absolute font-mulish text-[28px] text-actuate-blue top-[42px] left-[15px] font-bold",
                                            children: [
                                                `${unhealthyCamsData.unhealthy_cameras}`,
                                                /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                    className: "font-mulish text-[28px] text-[#182E54]  opacity-30 font-bold",
                                                    children: `/`
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                    className: "font-mulish text-[28px] text-[#182E54]  opacity-30  font-bold",
                                                    children: `${unhealthyCamsData.total_cameras}`
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "absolute top-[50px] left-[300px] right-[1px] h-[100px] w-[250px] bg-[#BDBDBD]",
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "absolute top-[1px] left-[1px] right-[1px] h-[98px] w-[248px] bg-white",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                        className: "font-mulish text-[18px] text-actuate-blue pt-[10px] pl-[15px]",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cye0Y))), {
                                                sx: {
                                                    color: "#D32F2F"
                                                }
                                            }),
                                            " \xa0 Total Errors"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "absolute font-mulish text-[28px] text-actuate-blue top-[42px] left-[18px] font-bold",
                                            children: `${alertsData.errors.length}`
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "absolute top-[50px] left-[600px] right-[1px] h-[100px] w-[250px] bg-[#BDBDBD]",
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "absolute top-[1px] left-[1px] right-[1px] h-[98px] w-[248px] bg-white",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                        className: "font-mulish text-[18px] text-actuate-blue pt-[10px] pl-[15px]",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gouAT))), {
                                                sx: {
                                                    color: "#F57C00"
                                                }
                                            }),
                                            " \xa0 Total Warnings"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "absolute font-mulish text-[28px] text-actuate-blue top-[42px] left-[18px] font-bold",
                                            children: `${alertsData.warnings.length}`
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "absolute top-[50px] left-[900px] right-[1px] h-[100px] w-[250px] bg-[#BDBDBD]",
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "absolute top-[1px] left-[1px] right-[1px] h-[98px] w-[248px] bg-white",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                        className: "font-mulish text-[18px] text-actuate-blue pt-[10px] pl-[15px]",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5Ibhh))), {
                                                sx: {
                                                    color: "#2E7D32"
                                                }
                                            }),
                                            " \xa0 Total Resolved"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "absolute font-mulish text-[28px] text-actuate-blue top-[42px] left-[18px] font-bold",
                                            children: !updatingStatus && // `${unhealthyCamsData.resolved}`
                                            `${alertsData.resolved.length}`
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: singleCellActivated || cameraDropDownValue || filters.metrics.length > 0 ? `absolute top-[60px] w-[${tableWidth[0]}px]` : `absolute top-[180px] w-[${tableWidth[0]}px]`,
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                                theme: $553166b111a7b130$var$theme,
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3n3uW.default), {
                                    value: clickedTab,
                                    onChange: (event, tabValue)=>{
                                        setActiveTable(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
                                        (0, $a62e7bbf38ef7afc$export$a2de4af979043477)(event, tabValue, setActiveTable, setClickedTab, alertsData, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setFectchingAllData, setAlertsData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setSortedData, singleCellActivated, activeName, setUpdatingStatus, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setFilteredDataLengths, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate);
                                    },
                                    "aria-label": "intestigation_tabs",
                                    color: "primary",
                                    variant: "fullWidth",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                                            value: "all",
                                            label: singleCellActivated || cameraDropDownValue || alertFilter !== "all" ? `All (${filteredDataLengths.all})` : `All (${alertsData.all.length})`,
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: "Bold",
                                                color: "primary"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                                            value: "errors",
                                            label: singleCellActivated || cameraDropDownValue || alertFilter !== "all" ? `Error (${filteredDataLengths.errors})` : `Error (${alertsData.errors.length})`,
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: "Bold",
                                                color: "primary"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                                            value: "warnings",
                                            label: singleCellActivated || cameraDropDownValue || alertFilter !== "all" ? `Warning (${filteredDataLengths.warnings})` : `Warning (${alertsData.warnings.length})`,
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: "Bold",
                                                color: "primary"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                                            value: "pending",
                                            label: singleCellActivated || cameraDropDownValue || alertFilter !== "all" ? `Pending (${filteredDataLengths.pending})` : `Pending (${alertsData.pending.length})`,
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: "Bold",
                                                color: "primary"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                                            value: "resolved",
                                            label: singleCellActivated || cameraDropDownValue || alertFilter !== "all" ? `Resolved (${filteredDataLengths.resolved})` : `Resolved (${alertsData.resolved.length})`,
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: "Bold",
                                                color: "primary"
                                            }
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: !navBarCollapsed ? "w-[1248px]" : "w-[1323px]",
                            children: activeTable
                        })
                    ]
                })
            ]
        })
    });
};


const $0482ee504c3ff692$export$e40e32a01043e426 = [
    {
        display_name: "Site 1",
        camera_name: "Camera 1",
        formatted_date: "10/23/2023, 05:21:11 PM",
        error_type: "connectivity",
        severity: "high",
        status: "resolved"
    },
    {
        display_name: "Site 2",
        camera_name: "Camera 2",
        formatted_date: "10/23/2023, 05:08:43 PM",
        error_type: "scene_change",
        severity: "medium",
        status: "pending"
    },
    {
        display_name: "Site 3",
        camera_name: "Camera 3",
        formatted_date: "10/23/2023, 04:08:43 PM",
        error_type: "recording_status",
        severity: "low",
        status: "pending"
    },
    {
        display_name: "Site 4",
        camera_name: "Camera 4",
        formatted_date: "10/22/2023, 03:03:43 PM",
        error_type: "motion_status",
        severity: "high",
        status: "resolved"
    },
    {
        display_name: "Site 5",
        camera_name: "Camera 5",
        formatted_date: "10/20/2023, 01:03:43 PM",
        error_type: "image_quality",
        severity: "medium",
        status: "ongoing"
    },
    {
        display_name: "Site 6",
        camera_name: "Camera 6",
        formatted_date: "10/19/2023, 11:03:43 PM",
        error_type: "stream_quality",
        severity: "low",
        status: "resolved"
    },
    {
        display_name: "Site 7",
        camera_name: "Camera 7",
        formatted_date: "10/19/2023, 01:03:43 PM",
        error_type: "license_info",
        severity: "low",
        status: "ongoing"
    }
];



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $b1uoD = parcelRequire("b1uoD");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $ce8iU = parcelRequire("ce8iU");

var $iKAtE = parcelRequire("iKAtE");

var $433j1 = parcelRequire("433j1");

var $1TOOV = parcelRequire("1TOOV");

var $6pdiI = parcelRequire("6pdiI");


var $fIsAN = parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $k8Qy8 = parcelRequire("k8Qy8");
var $gXvgZ = parcelRequire("gXvgZ");
var $aVDw9 = parcelRequire("aVDw9");
var $ha39s = parcelRequire("ha39s");
var $4o6Cs = parcelRequire("4o6Cs");
var $eejVe = parcelRequire("eejVe");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $cye0Y = parcelRequire("cye0Y");

var $gouAT = parcelRequire("gouAT");
const $af9ed329fa9e484b$export$ff051cf276d4e967 = (nameString)=>{
    switch(nameString){
        case "connectivity":
            return /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                className: "font-mulish text-red-600",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cye0Y))), {
                        sx: {
                            color: "#D32F2F"
                        }
                    }),
                    "\xa0 Connectivity"
                ]
            });
        case "scene_change":
            return /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                className: "font-mulish text-red-600",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cye0Y))), {
                        sx: {
                            color: "#D32F2F"
                        }
                    }),
                    "\xa0 Scene Change"
                ]
            });
        case "recording_status":
            return /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                className: "font-mulish text-red-600",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cye0Y))), {
                        sx: {
                            color: "#D32F2F"
                        }
                    }),
                    "\xa0 Recording Status"
                ]
            });
        case "motion_status":
            return /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                className: "font-mulish text-actuate-orange",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gouAT))), {
                        sx: {
                            color: "#F57C00"
                        }
                    }),
                    "\xa0 Motion Status"
                ]
            });
        case "image_quality":
            return /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                className: "font-mulish text-actuate-orange",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gouAT))), {
                        sx: {
                            color: "#F57C00"
                        }
                    }),
                    "\xa0 Image Quality"
                ]
            });
        case "stream_quality":
            return /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                className: "font-mulish text-actuate-orange",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gouAT))), {
                        sx: {
                            color: "#F57C00"
                        }
                    }),
                    "\xa0 Stream Quality"
                ]
            });
    }
};



var $frXOV = parcelRequire("frXOV");

var $2qUoo = parcelRequire("2qUoo");

var $8jTCz = parcelRequire("8jTCz");


parcelRequire("8T3gX");
const $e4a008ec36b000d1$export$39cccba7ba84bc8e = {
    //Connectivity
    connectivity_default_cause: "Unexpected connection interruption.",
    connectivity_default_next_steps: "Our health check has concluded that we are unable to connect to this camera though the IP, port, and credentials seem to be valid.",
    invalid_credentials_cause: "Invalid credentials.",
    invalid_credentials_next_steps: "Our health check has concluded that we are unable to connect to this camera because the credentials are invalid. Check the camera credentials and ensure they match what is entered on Actuate.",
    filtered_port_cause: "RTSP port filtered.",
    filtered_port_next_steps: "Our health check has concluded that we are unable to connect to this camera because the port is filtered. Check that the port information entered on Actuate is correct and reachable.",
    connection_interuption_cause: "Unexpected connection interruption.",
    connection_interuption_next_steps: "Our health check has concluded that we are unable to connect to this camera though the IP, port, and credentials seem to be valid.",
    ip_unreachable_cause: "IP/DNS unreachable.",
    ip_unreachable_next_steps: "Our health check has concluded that we are unable to connect to this camera because the IP and/or port is down. Confirm that the IP and port entered on Actuate are correct and reachable.",
    //Stream Quality
    stream_quality_default_cause: "Camera configuration issue.",
    stream_quality_default_next_steps: "Our health check has concluded that the camera stream connection is unstable.",
    fps_too_high_cause: "Frame rate (FPS) and/or resolution too high",
    fps_too_high_next_steps: "Our health check has concluded that the camera stream connection is unstable while the frame rate is high. Adjust the frame rate of the substream to 2 FPS and confirm there are no bandwidth limitations.",
    resolution_too_high_cause: "Resolution too high ( > 1080 p)",
    resolution_too_high_next_steps: "Our health check has concluded that the camera stream connection is unstable while the resolution is high. Adjust the resolution of the substream to 480p to reduce bandwidth consumption and prevent streaming issues.",
    fps_too_low_cause: "Frame rate (FPS) too low.",
    fps_too_low_next_steps: "Our health check has concluded that this camera stream has an invalid frame rate. Adjust the frame rate of the substream to 2 FPS and confirm there are no bandwidth limitations. ",
    //Image Quality
    image_quality_default_cause: "Resolution too high or too low.",
    image_quality_default_next_steps: "Our health check has concluded that this camera stream has an invalid resolution. Adjust the resolution of the substream.",
    resolution_low_cause: "Resolution too low( < 480 p)",
    resolution_low_next_steps: "Our health check has concluded that this camera stream has an invalid resolution. Adjust the resolution of the substream to 480p and confirm there are no bandwidth limitations.",
    resolution_high_cause: "Resolution too high ( > 1080 p) ",
    resolution_high_next_steps: "Our health check has concluded that this camera stream has an invalid resolution. Adjust the resolution of the substream to 480p to reduce bandwidth consumption and prevent streaming issues.",
    //Motion Status
    motion_status_default_cause: "Low activity",
    motion_status_default_next_steps: " Our health check has concluded that there has been no motion on this camera in 24 hours.",
    //Recording Status
    recording_status_default_cause: "Camera livestream is not being recorded.",
    recording_status_default_next_steps: "Ensure that the recording settings on your camera or NVR are correct.",
    //Scene Change
    scene_change_default_cause: "Possible tampering.",
    scene_change_default_next_steps: "Please review camera view. If camera view has changed, respond to and resolve change at earliest convenience.",
    camera_moved_cause: "Camera physically moved.",
    camera_moved_next_steps: "Please review camera view and ensure proper camera position. If camera has been rotated, reposition camera at earliest convenience.",
    camera_tampering_cause: "Possible tampering.",
    camera_tampering_next_steps: "Please review camera view. If camera has been tampered with, respond to and resolve tampered camera at earliest convenience.",
    camera_blocked_cause: "Camera view blocked.",
    camera_blocked_next_steps: "Please review camera view. If camera has been blocked, respond to and resolve blockage at earliest convenience."
};


const $d547cb9546c0476b$export$1300968e0521463a = (selectedRow)=>{
    if (selectedRow.error_type === "connectivity") {
        if (selectedRow.likely_cause) return selectedRow.likely_cause;
        else return (0, $e4a008ec36b000d1$export$39cccba7ba84bc8e).connectivity_default_cause;
    }
    if (selectedRow.error_type === "image_quality") {
        if (selectedRow.likely_cause) return selectedRow.likely_cause;
        else return (0, $e4a008ec36b000d1$export$39cccba7ba84bc8e).image_quality_default_cause;
    }
    if (selectedRow.error_type === "stream_quality") {
        if (selectedRow.likely_cause) return selectedRow.likely_cause;
        else return (0, $e4a008ec36b000d1$export$39cccba7ba84bc8e).stream_quality_default_cause;
    }
    if (selectedRow.error_type === "motion_status") {
        if (selectedRow.likely_cause) return selectedRow.likely_cause;
        else return (0, $e4a008ec36b000d1$export$39cccba7ba84bc8e).motion_status_default_cause;
    }
    if (selectedRow.error_type === "recording_status") {
        if (selectedRow.likely_cause) return selectedRow.likely_cause;
        else return (0, $e4a008ec36b000d1$export$39cccba7ba84bc8e).recording_status_default_cause;
    }
    if (selectedRow.error_type === "scene_change") {
        if (selectedRow.likely_cause) return selectedRow.likely_cause;
        else return (0, $e4a008ec36b000d1$export$39cccba7ba84bc8e).scene_change_default_cause;
    }
};


parcelRequire("8T3gX");

const $47568cc24f075229$export$4cda2afba7394dcd = (selectedRow)=>{
    if (selectedRow.error_type === "connectivity") {
        if (selectedRow.next_steps) return selectedRow.next_steps;
        else return (0, $e4a008ec36b000d1$export$39cccba7ba84bc8e).connectivity_default_next_steps;
    }
    if (selectedRow.error_type === "image_quality") {
        if (selectedRow.next_steps) return selectedRow.next_steps;
        else return (0, $e4a008ec36b000d1$export$39cccba7ba84bc8e).image_quality_default_next_steps;
    }
    if (selectedRow.error_type === "stream_quality") {
        if (selectedRow.next_steps) return selectedRow.next_steps;
        else return (0, $e4a008ec36b000d1$export$39cccba7ba84bc8e).stream_quality_default_next_steps;
    }
    if (selectedRow.error_type === "motion_status") {
        if (selectedRow.next_steps) return selectedRow.next_steps;
        else return (0, $e4a008ec36b000d1$export$39cccba7ba84bc8e).motion_status_default_next_steps;
    }
    if (selectedRow.error_type === "recording_status") {
        if (selectedRow.next_steps) return selectedRow.next_steps;
        else return (0, $e4a008ec36b000d1$export$39cccba7ba84bc8e).recording_status_default_next_steps;
    }
    if (selectedRow.error_type === "scene_change") {
        if (selectedRow.next_steps) return selectedRow.next_steps;
        else return (0, $e4a008ec36b000d1$export$39cccba7ba84bc8e).scene_change_default_next_steps;
    }
// switch (selectedRow.error_type) {
//   case "connectivity":
//     return errorsCopy.connectivity_next_steps;
//   case "image_quality":
//     return errorsCopy.image_quality_next_steps;
//   case "motion_status":
//     return errorsCopy.motion_status_next_steps;
//   case "recording_status":
//     return errorsCopy.recording_status_next_steps;
//   case "scene_change":
//     return errorsCopy.scene_change_next_steps;
//   // case "license_info":
//   //   return errorsCopy.license_info_next_steps;
//   case "stream_quality":
//     return errorsCopy.stream_quality_next_steps;
// }
};


parcelRequire("8T3gX");
const $3ec9fba3c3ac1358$export$7a39771beeef4111 = (selectedRow, noteText, alertsData, setAlertsData)=>{
    const updatedAlertsAllData = alertsData.all;
    const updatedAlertsErrorsData = alertsData.errors;
    const updatedAlertsWarningsData = alertsData.warnings;
    const updatedAlertsPendingData = alertsData.pending;
    const updatedAlertsResolvedData = alertsData.resolved;
    const updatedSelectedRow = selectedRow;
    updatedSelectedRow.notes = noteText;
    if (updatedSelectedRow.error_type === "connectivity" || updatedSelectedRow.error_type === "scene_change") {
        const selectedIndexAllData = updatedAlertsAllData.findIndex((object)=>object.start_timestamp === updatedSelectedRow.start_timestamp);
        updatedAlertsAllData[selectedIndexAllData] = updatedSelectedRow;
        const selectedIndexErrorsData = updatedAlertsErrorsData.findIndex((object)=>object.start_timestamp === updatedSelectedRow.start_timestamp);
        updatedAlertsErrorsData[selectedIndexErrorsData] = updatedSelectedRow;
    }
    if (updatedSelectedRow.error_type === "motion_status" || updatedSelectedRow.error_type === "image_quality" || updatedSelectedRow.error_type === "stream_quality" || updatedSelectedRow.error_type === "recording_status") {
        const selectedIndexAllData = updatedAlertsAllData.findIndex((object)=>object.start_timestamp === updatedSelectedRow.start_timestamp);
        updatedAlertsAllData[selectedIndexAllData] = updatedSelectedRow;
        const selectedIndexWarningsData = updatedAlertsWarningsData.findIndex((object)=>object.start_timestamp === updatedSelectedRow.start_timestamp);
        updatedAlertsWarningsData[selectedIndexWarningsData] = updatedSelectedRow;
    }
    if (updatedSelectedRow.status === "resolved") updatedAlertsResolvedData.push(updatedSelectedRow);
    if (updatedSelectedRow.status === "pending") updatedAlertsPendingData.push(updatedSelectedRow);
    setAlertsData({
        all: updatedAlertsAllData,
        errors: updatedAlertsErrorsData,
        warnings: updatedAlertsWarningsData,
        pending: updatedAlertsPendingData,
        resolved: updatedAlertsResolvedData
    });
};


parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $229de32ac15cab05$export$d51c4225e9e3934b = (selectedRowsToSend, setSelectedRowsToSend, navigate)=>{
    const retryFunction = ()=>{
        $229de32ac15cab05$export$d51c4225e9e3934b(selectedRowsToSend, setSelectedRowsToSend, navigate);
    };
    const arrayToParse = selectedRowsToSend;
    setSelectedRowsToSend([]);
    const AxiosUI = (0, $195EM.createApi)(``);
    arrayToParse.forEach((object)=>{
        AxiosUI.post(`/healthcheck_result/update_healthcheck/?camera_id=${object.camera_id}&created_timestamp=${object.created_timestamp}&healthcheck_type=${object.error_type}&status=${object.status}&notes=${object.notes}`, object).then(()=>{}, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{});
        });
    });
};



parcelRequire("8T3gX");
const $f97ee2944d93ec1a$export$d971b6fe3d0b28f = (searchParams, setSearchParams)=>{
    const params = new URLSearchParams(searchParams);
    params.delete("open_alert");
    setSearchParams(params);
};





var $aYdit = parcelRequire("aYdit");
const $cb772917f7b89b6b$var$AlertStatusDialog = ({ alertsData: alertsData, alertStatusDialogOpen: alertStatusDialogOpen, setAlertStatusDialogOpen: setAlertStatusDialogOpen, selectedRow: selectedRow, selectedRowIndex: selectedRowIndex, setSelectedRowIndex: setSelectedRowIndex, setSelectedRow: setSelectedRow, clickedTab: clickedTab, setFectchingAllData: setFectchingAllData, setUnhealthyCamsData: setUnhealthyCamsData, unhealthyCamsData: unhealthyCamsData, setAlertsData: setAlertsData, notesValue: notesValue, setNotesValue: setNotesValue, selectedRowsToSend: selectedRowsToSend, setSelectedRowsToSend: setSelectedRowsToSend, setSortedData: setSortedData, setActiveTable: setActiveTable, sortedData: sortedData, singleCellActivated: singleCellActivated, activeName: activeName, filters: filters, alertFilter: alertFilter, setSceneChangeOutcomesDialogOpen: setSceneChangeOutcomesDialogOpen, setUpdatingStatus: setUpdatingStatus, backgroundFrame: backgroundFrame, detectedFrame: detectedFrame, setBackgroundFrame: setBackgroundFrame, setDetectedFrame: setDetectedFrame, setSelectedRows: setSelectedRows, selectedRows: selectedRows, setErrorsOverviewData: setErrorsOverviewData, setCameraStatsData: setCameraStatsData, setLoadingCameraStatsData: setLoadingCameraStatsData, setBandwidthData: setBandwidthData, setLoadingBandwidthData: setLoadingBandwidthData, setShowSiteStats: setShowSiteStats, cameraDropDownValue: cameraDropDownValue, setFilteredDataLengths: setFilteredDataLengths, sceneChangeValueString: sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen: setBulkSceneChangeOutcomesDialogOpen })=>{
    const activeData = sortedData;
    const [previewURL, setPreviewURL] = $8T3gX.useState("");
    const [loadingImage, setLoadingImage] = $8T3gX.useState(true);
    const [detectedFrameURL, setDetectedFrameURL] = $8T3gX.useState("");
    const [editNotesValue, setEditNotesValue] = $8T3gX.useState(notesValue);
    const [changesMade, setChangesMade] = $8T3gX.useState(false);
    const [searchParams, setSearchParams] = (0, $fIsAN.useSearchParams)();
    const [editNotesDialogOpen, setEditNotesDialogOpen] = $8T3gX.useState(false);
    const { dateMMDDYYYY: dateMMDDYYYY } = (0, $aYdit.useAppStore)();
    const navigate = (0, $3T949.useNavigate)();
    $8T3gX.useEffect(()=>{
        setNotesValue(selectedRow.notes);
        (0, $c0ba81b0f635eb8e$export$609316fd606b5e1)(selectedRow, setDetectedFrameURL, navigate);
    }, [
        selectedRow
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                open: editNotesDialogOpen,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $ce8iU.default), {
                        sx: {
                            paddingBottom: 4
                        },
                        children: [
                            "Edit Notes",
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                "aria-label": "close",
                                onClick: ()=>{
                                    setEditNotesDialogOpen(false);
                                },
                                sx: {
                                    position: "absolute",
                                    right: 8,
                                    top: 8,
                                    color: (theme)=>theme.palette.grey[500]
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                            onChange: (event)=>{
                                setChangesMade(true);
                                setEditNotesValue(event.target.value);
                            },
                            value: editNotesValue,
                            variant: "outlined",
                            multiline: true,
                            rows: 4,
                            sx: {
                                fontFamily: "Mulish",
                                width: 500
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            disabled: false,
                            onClick: ()=>{
                                setChangesMade(true);
                                setEditNotesDialogOpen(false);
                                setNotesValue(editNotesValue);
                                (0, $3ec9fba3c3ac1358$export$7a39771beeef4111)(selectedRow, editNotesValue, alertsData, setAlertsData);
                            },
                            text: "Save"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                open: alertStatusDialogOpen,
                fullWidth: true,
                maxWidth: "lg",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $ce8iU.default), {
                        sx: {
                            marginLeft: 5,
                            p: 2
                        },
                        id: "customized-dialog-title",
                        children: [
                            (0, $af9ed329fa9e484b$export$ff051cf276d4e967)(selectedRow.error_type),
                            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "absolute top-4 right-[100px] text-gray-600 text-[14px]",
                                children: [
                                    selectedRowIndex + 1,
                                    " of ",
                                    activeData.length,
                                    "\xa0 \xa0 \xa0 \xa0\xa0",
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                        onClick: ()=>{
                                            setLoadingImage(true);
                                            setDetectedFrameURL("");
                                            (0, $ccb8c8b679fbc7d2$export$63091a9c71aa4423)(activeData[selectedRowIndex - 1].camera_id, setLoadingImage, setPreviewURL, navigate);
                                            setBackgroundFrame("");
                                            setDetectedFrame("");
                                            if (activeData[selectedRowIndex - 1].error_type === "scene_change") (0, $c0ba81b0f635eb8e$export$670c6be62c0305bd)(activeData[selectedRowIndex - 1], setBackgroundFrame, setDetectedFrame, navigate);
                                            setSelectedRowIndex(selectedRowIndex - 1);
                                            setSelectedRow(activeData[selectedRowIndex - 1]);
                                            setNotesValue(activeData[selectedRowIndex - 1].notes);
                                            (0, $a1645dbc2cc1afcc$export$a81b388df4ea4922)(activeData[selectedRowIndex - 1], searchParams, setSearchParams);
                                            if (changesMade) {
                                                setSelectedRowsToSend((previousState)=>{
                                                    return [
                                                        ...previousState,
                                                        activeData[selectedRowIndex]
                                                    ];
                                                });
                                                setChangesMade(false);
                                            }
                                        },
                                        text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($frXOV))), {
                                            fontSize: "small",
                                            id: "fowardButton"
                                        }),
                                        disabled: selectedRowIndex === 0
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                        onClick: ()=>{
                                            setLoadingImage(true);
                                            setDetectedFrameURL("");
                                            (0, $ccb8c8b679fbc7d2$export$63091a9c71aa4423)(activeData[selectedRowIndex + 1].camera_id, setLoadingImage, setPreviewURL, navigate);
                                            setBackgroundFrame("");
                                            setDetectedFrame("");
                                            if (activeData[selectedRowIndex + 1].error_type === "scene_change") (0, $c0ba81b0f635eb8e$export$670c6be62c0305bd)(activeData[selectedRowIndex + 1], setBackgroundFrame, setDetectedFrame, navigate);
                                            setSelectedRowIndex(selectedRowIndex + 1);
                                            setSelectedRow(activeData[selectedRowIndex + 1]);
                                            setNotesValue(activeData[selectedRowIndex + 1].notes);
                                            (0, $a1645dbc2cc1afcc$export$a81b388df4ea4922)(activeData[selectedRowIndex + 1], searchParams, setSearchParams);
                                            if (changesMade) {
                                                setSelectedRowsToSend((previousState)=>{
                                                    return [
                                                        ...previousState,
                                                        activeData[selectedRowIndex]
                                                    ];
                                                });
                                                setChangesMade(false);
                                            }
                                        },
                                        text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2qUoo))), {
                                            fontSize: "small",
                                            id: "backButton"
                                        }),
                                        disabled: selectedRowIndex === activeData.length - 1
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                        "aria-label": "close",
                        onClick: ()=>{
                            const updatedSelectedRowsToSend = selectedRowsToSend;
                            if (changesMade) updatedSelectedRowsToSend.push(activeData[selectedRowIndex]);
                            setAlertStatusDialogOpen(false);
                            (0, $f97ee2944d93ec1a$export$d971b6fe3d0b28f)(searchParams, setSearchParams);
                            (0, $229de32ac15cab05$export$d51c4225e9e3934b)(updatedSelectedRowsToSend, setSelectedRowsToSend, navigate);
                        },
                        sx: {
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme)=>theme.palette.grey[500]
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                        dividers: true,
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish"
                                                        },
                                                        children: "Site"
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish"
                                                        },
                                                        children: "Camera"
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish"
                                                        },
                                                        children: "Start Time"
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish"
                                                        },
                                                        children: "End Time"
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish"
                                                        },
                                                        children: "Last Updated"
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish"
                                                        },
                                                        children: "Severity"
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish"
                                                        },
                                                        children: "Status"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish",
                                                            width: 95,
                                                            color: "#0000EE"
                                                        },
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                                                            to: `/sites/aboutsite/${selectedRow.site_id}`,
                                                            target: "_blank",
                                                            children: selectedRow.site_name
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish",
                                                            width: 95,
                                                            color: "#0000EE"
                                                        },
                                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.Link), {
                                                            to: `/sites/${selectedRow.site_id}/editcamera/${selectedRow.camera_id}`,
                                                            target: "_blank",
                                                            children: selectedRow.camera_name
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish",
                                                            width: 95
                                                        },
                                                        children: (0, $5006cb2dc77aa250$export$5a8f63dcb7ebcc92)(selectedRow.formatted_start_date, dateMMDDYYYY)
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish",
                                                            width: 95
                                                        },
                                                        children: [
                                                            selectedRow.formatted_end_date ? (0, $5006cb2dc77aa250$export$5a8f63dcb7ebcc92)(selectedRow.formatted_end_date, dateMMDDYYYY) : "",
                                                            " "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish",
                                                            width: 95
                                                        },
                                                        children: [
                                                            selectedRow.formatted_updated_date ? (0, $5006cb2dc77aa250$export$5a8f63dcb7ebcc92)(selectedRow.formatted_updated_date, dateMMDDYYYY) : "",
                                                            " "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish",
                                                            width: 95
                                                        },
                                                        children: (0, $97d69305fb184ec9$export$13e5c872d721dc0a)(selectedRow.severity)
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                                        align: "left",
                                                        sx: {
                                                            fontFamily: "Mulish",
                                                            width: 95
                                                        },
                                                        children: [
                                                            (0, $870a053e6d764c4f$export$bc265303ffc7c32d)(selectedRow.status, selectedRow, setFectchingAllData, setAlertsData, alertsData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, setUpdatingStatus, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setFilteredDataLengths, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate),
                                                            " "
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "font-mulish text-actuate-blue text-[20px] pt-3",
                                    children: "Likely Cause"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "font-mulish pt-2",
                                    children: (0, $d547cb9546c0476b$export$1300968e0521463a)(selectedRow)
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "font-mulish text-actuate-blue text-[20px] pt-3",
                                    children: "Next Steps"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                    className: "font-mulish pt-2",
                                    children: [
                                        `${(0, $47568cc24f075229$export$4cda2afba7394dcd)(selectedRow)} Please refer to our support wiki for common troubleshooting steps `,
                                        /*#__PURE__*/ (0, $k4ank.jsx)("a", {
                                            className: "text-[#0000EE]",
                                            href: (0, $b1uoD.getSupportUrl)("/camera-health-monitoring/camera-health-troubleshooting/"),
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: (0, $b1uoD.getSupportUrl)("/camera-health-monitoring/camera-health-troubleshooting/")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                /*#__PURE__*/ (0, $k4ank.jsx)("hr", {}),
                                selectedRow.error_type === "scene_change" && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                            className: "columns-2 pt-3 w-[895]",
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                                    children: [
                                                        "Reference Image",
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                                                            className: "w-[413px]",
                                                            src: backgroundFrame,
                                                            alt: "camera_image"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                                    children: [
                                                        "Detected Image",
                                                        /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                                                            className: "w-[413px]",
                                                            src: detectedFrame,
                                                            alt: "camera_image"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("hr", {})
                                    ]
                                }),
                                detectedFrameURL && selectedRow.error_type !== "scene_change" && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                                        className: "font-mulish text-actuate-blue text-[20px] pt-3",
                                        children: [
                                            "Reference Image",
                                            /*#__PURE__*/ (0, $k4ank.jsx)("img", {
                                                className: "w-[413px]",
                                                src: detectedFrameURL,
                                                alt: "camera_image"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                            className: "font-mulish text-actuate-blue text-[20px] pt-3",
                                            children: "Notes"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                            onClick: ()=>{
                                                setEditNotesValue(notesValue);
                                                setEditNotesDialogOpen(true);
                                            },
                                            text: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6pdiI))), {
                                                fontSize: "small"
                                            }),
                                            disabled: false
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                    className: "font-mulish pt-2",
                                    children: notesValue ? notesValue : ""
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                                /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $cb772917f7b89b6b$export$2e2bcd8739ae039 = $cb772917f7b89b6b$var$AlertStatusDialog;




var $dHtmK = parcelRequire("dHtmK");



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $iLEpm = parcelRequire("iLEpm");

var $k1BHZ = parcelRequire("k1BHZ");

var $imWqP = parcelRequire("imWqP");

var $3baw3 = parcelRequire("3baw3");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");


var $3Zv1D = parcelRequire("3Zv1D");
const $ac9f0d8db4fde560$export$cbb0056546bbec0d = (valueString, selectedObject, setUpdatingStatus, setAlertsData, alertsData, setFectchingAllData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setFilteredDataLengths, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate)=>{
    //   const extractSubstring = (inputString: string): string => {
    //     const startIndex = inputString.indexOf(".com/") + 5; // Add 5 to include ".com/"
    //     const endIndex = inputString.indexOf("?AWS");
    //     if (startIndex >= 5 && endIndex !== -1 && endIndex > startIndex) {
    //       return inputString.substring(startIndex, endIndex);
    //     }
    //     // Return an empty string if the pattern is not found
    //     return "";
    //   };
    const AxiosUI = (0, $195EM.createApi)(``);
    //   const detectedFrameKey = extractSubstring(selectedObject.detected_frame);
    //   const backgroundFrameKey = extractSubstring(selectedObject.background_frame);
    const submittedObject = {
        camera_id: selectedObject.camera_id,
        action: "clear",
        detected_frame_key: selectedObject.detected_frame_key,
        background_frame_key: selectedObject.background_frame_key,
        incident_timestamp: selectedObject.start_timestamp
    };
    // const postedAlert = selectedObject;
    // postedAlert.status = "resolved";
    const retryFunction = ()=>{
        $ac9f0d8db4fde560$export$cbb0056546bbec0d(valueString, selectedObject, setUpdatingStatus, setAlertsData, alertsData, setFectchingAllData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setFilteredDataLengths, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate);
    };
    if (valueString === "reset") AxiosUI.post(`/healthcheck_result/update_sudden_scene/?camera_id=${selectedObject.camera_id}&action=clear&detected_frame_key=${selectedObject.detected_frame_key}&background_frame_key=${selectedObject.background_frame_key}&incident_timestamp=${selectedObject.start_timestamp}`, submittedObject).then(()=>{
        (0, $6503e7a8f971a2bc$export$b09c52318be48923)(setAlertsData, "resolved", "pending", selectedObject, alertsData, setFectchingAllData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, setUpdatingStatus, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setFilteredDataLengths, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Unable to update status, please try again");
            setUpdatingStatus(false);
        });
    });
    if (valueString === "add") {
        submittedObject.action = "update";
        AxiosUI.post(`/healthcheck_result/update_sudden_scene/`, submittedObject).then(()=>{
            (0, $6503e7a8f971a2bc$export$b09c52318be48923)(setAlertsData, "resolved", "pending", selectedObject, alertsData, setFectchingAllData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, setUpdatingStatus, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setFilteredDataLengths, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate);
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                alert("Unable to update status, please try again");
                setUpdatingStatus(false);
            });
        });
    }
    if (valueString === "proceed") (0, $6503e7a8f971a2bc$export$b09c52318be48923)(setAlertsData, "resolved", "pending", selectedObject, alertsData, setFectchingAllData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, setUpdatingStatus, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setFilteredDataLengths, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate);
};


const $f61f747413fa2004$export$be5acaf1ef616e50 = ({ sceneChangeOutcomesDialogOpen: sceneChangeOutcomesDialogOpen, setSceneChangeOutcomesDialogOpen: setSceneChangeOutcomesDialogOpen, selectedObject: selectedObject, setUpdatingStatus: setUpdatingStatus, setAlertsData: setAlertsData, alertsData: alertsData, setFectchingAllData: setFectchingAllData, setUnhealthyCamsData: setUnhealthyCamsData, unhealthyCamsData: unhealthyCamsData, clickedTab: clickedTab, setActiveTable: setActiveTable, setAlertStatusDialogOpen: setAlertStatusDialogOpen, setSelectedRow: setSelectedRow, setSelectedRowIndex: setSelectedRowIndex, setSortedData: setSortedData, singleCellActivated: singleCellActivated, activeName: activeName, filters: filters, alertFilter: alertFilter, setBackgroundFrame: setBackgroundFrame, setDetectedFrame: setDetectedFrame, setSelectedRows: setSelectedRows, selectedRows: selectedRows, setErrorsOverviewData: setErrorsOverviewData, setCameraStatsData: setCameraStatsData, setLoadingCameraStatsData: setLoadingCameraStatsData, setBandwidthData: setBandwidthData, setLoadingBandwidthData: setLoadingBandwidthData, setShowSiteStats: setShowSiteStats, cameraDropDownValue: cameraDropDownValue, setFilteredDataLengths: setFilteredDataLengths, sceneChangeValueString: sceneChangeValueString, setSceneChangeValueString: setSceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen: setBulkSceneChangeOutcomesDialogOpen, navigate: navigate })=>{
    const handleRadioChange = (event)=>{
        setSceneChangeValueString(event.target.value);
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: sceneChangeOutcomesDialogOpen,
        children: [
            " ",
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                sx: {
                    width: 575,
                    padding: 4
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                        sx: {
                            fontSize: 18,
                            color: "black",
                            fontFamily: "mulish",
                            fontWeight: "bold"
                        },
                        children: "Choose the preferred action for your current reference image bank:"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $imWqP.default), {
                        "aria-labelledby": "demo-radio-buttons-group-label",
                        defaultValue: "female",
                        name: "radio-buttons-group",
                        onChange: handleRadioChange,
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                sx: {
                                    fontFamily: "mulish"
                                },
                                value: "reset",
                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {}),
                                label: "Reset all reference images to current view."
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                sx: {
                                    fontFamily: "mulish"
                                },
                                value: "add",
                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {}),
                                label: "Add this detected image to your current reference image library."
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                sx: {
                                    fontFamily: "mulish"
                                },
                                value: "proceed",
                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {}),
                                label: "Proceed with current reference image library (No changes). "
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                sx: {
                    padding: 3
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: ()=>{
                            setSceneChangeOutcomesDialogOpen(false);
                        },
                        text: "Cancel",
                        disabled: false
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                        className: "shadow-button bg-actuate-orange border-1 border-actuate-orange rounded font-mulish text-white text-base p-1.5 w-[100px]",
                        onClick: ()=>{
                            setSceneChangeOutcomesDialogOpen(false);
                            setUpdatingStatus(true);
                            (0, $ac9f0d8db4fde560$export$cbb0056546bbec0d)(sceneChangeValueString, selectedObject, setUpdatingStatus, setAlertsData, alertsData, setFectchingAllData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setFilteredDataLengths, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate);
                        },
                        children: "Submit"
                    })
                ]
            })
        ]
    });
};





parcelRequire("8T3gX");
const $0e6c5f67f634f2df$export$45d6d44438743f07 = (metrics)=>{
    return metrics.split(",").map((metric)=>metric.split("_").map((word)=>word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" "));
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $iLEpm = parcelRequire("iLEpm");

var $8jTCz = parcelRequire("8jTCz");
const $eb4bc880360bad21$export$e54738405e53c3bd = ({ noAlertsDialogOpen: noAlertsDialogOpen, setNoAlertsDialogOpen: setNoAlertsDialogOpen, cameraID: cameraID, errorType: errorType, createdTimestamp: createdTimestamp, siteID: siteID })=>{
    const [dialogText, setDialogText] = $8T3gX.useState(`No individual alerts were found with the provided parameters: Camera id: ${cameraID}, Error Type: ${errorType}, Created Timestamp: ${createdTimestamp}.`);
    $8T3gX.useEffect(()=>{
        if (!siteID && !cameraID) setDialogText(`No individual alerts were found with the provided parameters: Camera id: ${cameraID}, Error Type: ${errorType}, Created Timestamp: ${createdTimestamp}. Try adding both a site and camera id to the URL search paramaters, this can help generate more accurate alert results which may contain the desired alert.`);
        if (siteID && !cameraID) setDialogText(`No individual alerts were found with the provided parameters: Camera id: ${cameraID}, Error Type: ${errorType}, Created Timestamp: ${createdTimestamp}. Try adding a camera id to the URL search paramaters, this can help generate more accurate alert results which may contain the desired alert.`);
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: noAlertsDialogOpen,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                    id: "alert-dialog-description",
                    children: dialogText
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                    onClick: ()=>{
                        setNoAlertsDialogOpen(false);
                    },
                    text: "Ok",
                    disabled: false
                })
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $887xF = parcelRequire("887xF");

var $1TOOV = parcelRequire("1TOOV");

var $iLEpm = parcelRequire("iLEpm");

var $k1BHZ = parcelRequire("k1BHZ");

var $imWqP = parcelRequire("imWqP");

var $3baw3 = parcelRequire("3baw3");

const $b648b1f7299dbe95$export$e80fc8c3f586bcdd = ({ bulkSceneChangeOutcomesDialogOpen: bulkSceneChangeOutcomesDialogOpen, setBulkSceneChangeOutcomesDialogOpen: setBulkSceneChangeOutcomesDialogOpen, setUpdatingStatus: setUpdatingStatus, setAlertsData: setAlertsData, alertsData: alertsData, setFectchingAllData: setFectchingAllData, setUnhealthyCamsData: setUnhealthyCamsData, unhealthyCamsData: unhealthyCamsData, clickedTab: clickedTab, setActiveTable: setActiveTable, setAlertStatusDialogOpen: setAlertStatusDialogOpen, setSelectedRow: setSelectedRow, setSelectedRowIndex: setSelectedRowIndex, setSortedData: setSortedData, singleCellActivated: singleCellActivated, activeName: activeName, filters: filters, alertFilter: alertFilter, setBackgroundFrame: setBackgroundFrame, setDetectedFrame: setDetectedFrame, setSelectedRows: setSelectedRows, selectedRows: selectedRows, setErrorsOverviewData: setErrorsOverviewData, setCameraStatsData: setCameraStatsData, setLoadingCameraStatsData: setLoadingCameraStatsData, setBandwidthData: setBandwidthData, setLoadingBandwidthData: setLoadingBandwidthData, setShowSiteStats: setShowSiteStats, cameraDropDownValue: cameraDropDownValue, setFilteredDataLengths: setFilteredDataLengths, setSceneChangeOutcomesDialogOpen: setSceneChangeOutcomesDialogOpen, sceneChangeValueString: sceneChangeValueString, setSceneChangeValueString: setSceneChangeValueString, navigate: navigate })=>{
    const handleRadioChange = (event)=>{
        setSceneChangeValueString(event.target.value);
    };
    const alertsArray = JSON.parse(localStorage.getItem("selectedCHMAlertsArray") || "[]");
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: bulkSceneChangeOutcomesDialogOpen,
        children: [
            " ",
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                sx: {
                    width: 575,
                    padding: 4
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                        sx: {
                            fontSize: 18,
                            color: "black",
                            fontFamily: "mulish",
                            fontWeight: "bold"
                        },
                        children: "Some of these alerts are for sudden scene changes."
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                        sx: {
                            fontSize: 18,
                            color: "black",
                            fontFamily: "mulish",
                            fontWeight: "bold"
                        },
                        children: "Choose the preferred action for your current reference image bank:"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $imWqP.default), {
                        "aria-labelledby": "demo-radio-buttons-group-label",
                        defaultValue: "female",
                        name: "radio-buttons-group",
                        onChange: handleRadioChange,
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                sx: {
                                    fontFamily: "mulish"
                                },
                                value: "reset",
                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {}),
                                label: "Reset all reference images to current view."
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                sx: {
                                    fontFamily: "mulish"
                                },
                                value: "add",
                                control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {}),
                                label: "Add the detected image to your current reference image library."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), {
                sx: {
                    padding: 3
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                    className: "shadow-button bg-actuate-orange border-1 border-actuate-orange rounded font-mulish text-white text-base p-1.5 w-[100px]",
                    onClick: ()=>{
                        setBulkSceneChangeOutcomesDialogOpen(false);
                        setUpdatingStatus(true);
                        (0, $1427adc7a2f88a3f$export$2225ffec5884e675)(alertsArray, setAlertsData, "resolved", alertsData, setFectchingAllData, setUnhealthyCamsData, unhealthyCamsData, clickedTab, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setSortedData, singleCellActivated, activeName, setUpdatingStatus, filters, alertFilter, setSceneChangeOutcomesDialogOpen, setBackgroundFrame, setDetectedFrame, setSelectedRows, selectedRows, setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setFilteredDataLengths, sceneChangeValueString, setBulkSceneChangeOutcomesDialogOpen, navigate);
                    },
                    children: "Submit"
                })
            })
        ]
    });
};



var $cVCJe = parcelRequire("cVCJe");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $djxj8 = parcelRequire("djxj8");

var $60vL1 = parcelRequire("60vL1");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");
const $ce48977e9b06d0a3$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
function $ce48977e9b06d0a3$export$2e2bcd8739ae039({ openState: openState }) {
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
        theme: $ce48977e9b06d0a3$var$theme,
        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $djxj8.default), {
                sx: {
                    color: "#fff",
                    zIndex: (theme)=>theme.zIndex.drawer + 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center"
                },
                open: openState,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                        color: "primary"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        style: {
                            textAlign: "center",
                            marginTop: "16px"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "text-white text-[18px]",
                                children: "Loading Health Monitoring Data."
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "text-white text-[18px]",
                                children: "Larger date ranges may take longer to load."
                            })
                        ]
                    })
                ]
            })
        })
    });
}


const $75c8446086b0e388$export$c874b3080281d6db = ({ navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed })=>{
    const [searchParams, setSearchParams] = (0, $fIsAN.useSearchParams)();
    const group = searchParams.get("group");
    const site = searchParams.get("site");
    const camera = searchParams.get("camera");
    const start_date = searchParams.get("start_date");
    const end_date = searchParams.get("end_date");
    const metricsParam = searchParams.get("metrics");
    const [userFilters, setUserFilters] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        parent_group: group,
        site: site,
        camera: camera,
        metrics: metricsParam ? (0, $0e6c5f67f634f2df$export$45d6d44438743f07)(metricsParam) : [],
        start_date: start_date ? new Date(start_date) : null,
        end_date: end_date ? new Date(end_date) : null
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        (0, $361dd3e7be612e92$export$59b2b76630cf930b)(userFilters, searchParams, setSearchParams, "");
    }, []);
    const [siteOptions, setSiteOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [cameraOptions, setCameraOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [siteDropDownValue, setSiteDropDownValue] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [cameraDropDownValue, setCameraDropDownValue] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [loadingSites, setLoadingSites] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(group ? true : false);
    const [loadingCameras, setLoadingCameras] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(site ? true : false);
    const [errorWarningData, setErrorWarningData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("error");
    const [clickedTab, setClickedTab] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("all");
    const [activeTable, setActiveTable] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(/*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {}));
    const [alertStatusDialogOpen, setAlertStatusDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [selectedRow, setSelectedRow] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState((0, $0482ee504c3ff692$export$e40e32a01043e426)[0]);
    const [selectedRowIndex, setSelectedRowIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [fetchingAllData, setFectchingAllData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [bandwidthData, setBandwidthData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [errorsOverviewData, setErrorsOverviewData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        connectivity: 0,
        image_quality: 0,
        license_info: 0,
        motion_status: 0,
        recording_status: 0,
        scene_change: 0,
        stream_quality: 0
    });
    const [alertsData, setAlertsData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        all: [],
        errors: [],
        warnings: [],
        pending: [],
        resolved: []
    });
    const [cameraStatsData, setCameraStatsData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [sortedData, setSortedData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [loadingCameraStatsData, setLoadingCameraStatsData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [unhealthyCamsData, setUnhealthyCamsData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        unhealthy_cameras: 0,
        total_cameras: 0,
        errors: 0,
        warnings: 0,
        resolved: 0
    });
    const [updatingStatus, setUpdatingStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [loadingBandwidthData, setLoadingBandwidthData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [notesValue, setNotesValue] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [selectedRowsToSend, setSelectedRowsToSend] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [activeName, setActiveName] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [singleCellActivated, setSingleCellActivated] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [showSiteStats, setShowSiteStats] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [filteredDataLengths, setFilteredDataLengths] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        all: 0,
        errors: 0,
        warnings: 0,
        pending: 0,
        resolved: 0
    });
    const [alertFilter, setAlertFilter] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("all");
    const [downloadURL, setDownloadURL] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [fetchingDownloadReport, setFetchingDownloadReport] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [sceneChangeOutcomesDialogOpen, setSceneChangeOutcomesDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [backgroundFrame, setBackgroundFrame] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [detectedFrame, setDetectedFrame] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [selectedRows, setSelectedRows] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [metricsSelected, setMetricsSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(metricsParam ? (0, $0e6c5f67f634f2df$export$45d6d44438743f07)(metricsParam) : []);
    const [bandwidthLoadingError, setBandwidthLoadingError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [noAlertsDialogOpen, setNoAlertsDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const openAlert = searchParams.get("open_alert");
    const [openAlertCameraId, openAlertErrorType, openAlertcreatedTimestamp] = openAlert ? openAlert.split("-") : [
        "",
        "",
        ""
    ];
    const [filtersApplied, setFiltersApplied] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [sceneChangeValueString, setSceneChangeValueString] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("reset");
    const [bulkSceneChangeOutcomesDialogOpen, setBulkSceneChangeOutcomesDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const navigate = (0, $3T949.useNavigate)();
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (group) (0, $27fa563d59549059$export$6b28e0ddc2fe699b)(group, navigate, setSiteOptions, setLoadingSites);
        if (site) (0, $1a511a220e4442ce$export$1fedd6e3f8d8e03e)([
            site
        ], navigate, setCameraOptions, setLoadingCameras);
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (Array.from(searchParams).length > 0) {
            setFiltersApplied(true);
            setFectchingAllData(true);
            localStorage.removeItem("backupCHMAlertsData");
            (0, $67f834272aa34a6e$export$78e1df0e572bda86)(setErrorsOverviewData, setCameraStatsData, setLoadingCameraStatsData, setUnhealthyCamsData, setAlertsData, setFectchingAllData, userFilters, setActiveTable, setAlertStatusDialogOpen, setSelectedRow, setSelectedRowIndex, setUpdatingStatus, setBandwidthData, setLoadingBandwidthData, setShowSiteStats, cameraDropDownValue, setBandwidthLoadingError, setSearchParams, setNotesValue, setBackgroundFrame, setDetectedFrame, setNoAlertsDialogOpen, setClickedTab, setFiltersApplied, navigate);
        }
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (filtersApplied) (0, $215d7e41a28f0d44$export$b369c619b6c894e7)(singleCellActivated, alertsData, activeName, setFilteredDataLengths, alertFilter);
    }, [
        updatingStatus,
        activeTable
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setDownloadURL("");
        (0, $b232a2fa3ad35646$export$1e752cf26bbb2ef6)(userFilters, setDownloadURL, setFetchingDownloadReport, navigate);
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce48977e9b06d0a3$export$2e2bcd8739ae039), {
                openState: fetchingAllData
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                openState: updatingStatus
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "bg-actuate-white absolute w-full h-full overflow-scroll",
                children: [
                    alertStatusDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cb772917f7b89b6b$export$2e2bcd8739ae039), {
                        alertsData: alertsData,
                        alertStatusDialogOpen: alertStatusDialogOpen,
                        setAlertStatusDialogOpen: setAlertStatusDialogOpen,
                        selectedRow: selectedRow,
                        selectedRowIndex: selectedRowIndex,
                        setSelectedRowIndex: setSelectedRowIndex,
                        setSelectedRow: setSelectedRow,
                        clickedTab: clickedTab,
                        setFectchingAllData: setUpdatingStatus,
                        setUnhealthyCamsData: setUnhealthyCamsData,
                        unhealthyCamsData: unhealthyCamsData,
                        setAlertsData: setAlertsData,
                        notesValue: notesValue,
                        setNotesValue: setNotesValue,
                        selectedRowsToSend: selectedRowsToSend,
                        setSelectedRowsToSend: setSelectedRowsToSend,
                        setSortedData: setSortedData,
                        setActiveTable: setActiveTable,
                        sortedData: sortedData,
                        singleCellActivated: singleCellActivated,
                        activeName: activeName,
                        filters: userFilters,
                        alertFilter: alertFilter,
                        setSceneChangeOutcomesDialogOpen: setSceneChangeOutcomesDialogOpen,
                        setUpdatingStatus: setUpdatingStatus,
                        backgroundFrame: backgroundFrame,
                        detectedFrame: detectedFrame,
                        setBackgroundFrame: setBackgroundFrame,
                        setDetectedFrame: setDetectedFrame,
                        setSelectedRows: setSelectedRows,
                        selectedRows: selectedRows,
                        setErrorsOverviewData: setErrorsOverviewData,
                        setCameraStatsData: setCameraStatsData,
                        setLoadingCameraStatsData: setLoadingCameraStatsData,
                        setBandwidthData: setBandwidthData,
                        setLoadingBandwidthData: setLoadingBandwidthData,
                        setShowSiteStats: setShowSiteStats,
                        cameraDropDownValue: cameraDropDownValue,
                        setFilteredDataLengths: setFilteredDataLengths,
                        sceneChangeValueString: sceneChangeValueString,
                        setBulkSceneChangeOutcomesDialogOpen: setBulkSceneChangeOutcomesDialogOpen
                    }),
                    sceneChangeOutcomesDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $f61f747413fa2004$export$be5acaf1ef616e50), {
                        sceneChangeOutcomesDialogOpen: sceneChangeOutcomesDialogOpen,
                        setSceneChangeOutcomesDialogOpen: setSceneChangeOutcomesDialogOpen,
                        setUpdatingStatus: setUpdatingStatus,
                        selectedObject: selectedRow,
                        setAlertsData: setAlertsData,
                        alertsData: alertsData,
                        setFectchingAllData: setFectchingAllData,
                        setUnhealthyCamsData: setUnhealthyCamsData,
                        unhealthyCamsData: unhealthyCamsData,
                        clickedTab: clickedTab,
                        setActiveTable: setActiveTable,
                        setAlertStatusDialogOpen: setAlertStatusDialogOpen,
                        setSelectedRow: setSelectedRow,
                        setSelectedRowIndex: setSelectedRowIndex,
                        setSortedData: setSortedData,
                        singleCellActivated: singleCellActivated,
                        activeName: activeName,
                        filters: userFilters,
                        alertFilter: alertFilter,
                        setBackgroundFrame: setBackgroundFrame,
                        setDetectedFrame: setDetectedFrame,
                        setSelectedRows: setSelectedRows,
                        selectedRows: selectedRows,
                        setErrorsOverviewData: setErrorsOverviewData,
                        setCameraStatsData: setCameraStatsData,
                        setLoadingCameraStatsData: setLoadingCameraStatsData,
                        setBandwidthData: setBandwidthData,
                        setLoadingBandwidthData: setLoadingBandwidthData,
                        setShowSiteStats: setShowSiteStats,
                        cameraDropDownValue: cameraDropDownValue,
                        setFilteredDataLengths: setFilteredDataLengths,
                        sceneChangeValueString: sceneChangeValueString,
                        setSceneChangeValueString: setSceneChangeValueString,
                        setBulkSceneChangeOutcomesDialogOpen: setBulkSceneChangeOutcomesDialogOpen,
                        navigate: navigate
                    }),
                    bulkSceneChangeOutcomesDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $b648b1f7299dbe95$export$e80fc8c3f586bcdd), {
                        bulkSceneChangeOutcomesDialogOpen: bulkSceneChangeOutcomesDialogOpen,
                        setBulkSceneChangeOutcomesDialogOpen: setBulkSceneChangeOutcomesDialogOpen,
                        alertsArray: JSON.parse(localStorage.selectedCHMAlertsArray),
                        setUpdatingStatus: setUpdatingStatus,
                        setAlertsData: setAlertsData,
                        alertsData: alertsData,
                        setFectchingAllData: setFectchingAllData,
                        setUnhealthyCamsData: setUnhealthyCamsData,
                        unhealthyCamsData: unhealthyCamsData,
                        clickedTab: clickedTab,
                        setActiveTable: setActiveTable,
                        setAlertStatusDialogOpen: setAlertStatusDialogOpen,
                        setSelectedRow: setSelectedRow,
                        setSelectedRowIndex: setSelectedRowIndex,
                        setSortedData: setSortedData,
                        singleCellActivated: singleCellActivated,
                        activeName: activeName,
                        filters: userFilters,
                        alertFilter: alertFilter,
                        setBackgroundFrame: setBackgroundFrame,
                        setDetectedFrame: setDetectedFrame,
                        setSelectedRows: setSelectedRows,
                        selectedRows: selectedRows,
                        setErrorsOverviewData: setErrorsOverviewData,
                        setCameraStatsData: setCameraStatsData,
                        setLoadingCameraStatsData: setLoadingCameraStatsData,
                        setBandwidthData: setBandwidthData,
                        setLoadingBandwidthData: setLoadingBandwidthData,
                        setShowSiteStats: setShowSiteStats,
                        cameraDropDownValue: cameraDropDownValue,
                        setFilteredDataLengths: setFilteredDataLengths,
                        setSceneChangeOutcomesDialogOpen: setSceneChangeOutcomesDialogOpen,
                        sceneChangeValueString: sceneChangeValueString,
                        setSceneChangeValueString: setSceneChangeValueString,
                        navigate: navigate
                    }),
                    noAlertsDialogOpen && /*#__PURE__*/ (0, $k4ank.jsx)((0, $eb4bc880360bad21$export$e54738405e53c3bd), {
                        noAlertsDialogOpen: noAlertsDialogOpen,
                        setNoAlertsDialogOpen: setNoAlertsDialogOpen,
                        cameraID: openAlertCameraId,
                        errorType: openAlertErrorType,
                        createdTimestamp: openAlertcreatedTimestamp,
                        siteID: searchParams.get("site") ? searchParams.get("site") : ""
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: !navBarCollapsed ? "pl-[170px] pt-[10px]" : "pl-[95px] pt-[10px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8341367ea5303818$export$fc132bc4d040493b), {
                            userFilters: userFilters,
                            setUserFilters: setUserFilters,
                            setSiteOptions: setSiteOptions,
                            setSiteDropDownValue: setSiteDropDownValue,
                            setCameraOptions: setCameraOptions,
                            setCameraDropDownValue: setCameraDropDownValue,
                            siteOptions: siteOptions,
                            siteDropDownValue: siteDropDownValue,
                            loadingSites: loadingSites,
                            setLoadingCameras: setLoadingCameras,
                            setLoadingSites: setLoadingSites,
                            cameraOptions: cameraOptions,
                            cameraDropDownValue: cameraDropDownValue,
                            loadingCameras: loadingCameras,
                            navBarCollapsed: navBarCollapsed,
                            metricsSelected: metricsSelected,
                            setMetricsSelected: setMetricsSelected,
                            navigate: navigate
                        })
                    }),
                    userFilters.start_date ? /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-[17px] left-[1270px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b44c05f5a5e884ad$export$d361b4384a0b664), {
                            userFilters: userFilters,
                            setUserFilters: setUserFilters,
                            metricsSelected: metricsSelected,
                            setErrorsOverviewData: setErrorsOverviewData,
                            setCameraStatsData: setCameraStatsData,
                            setLoadingCameraStatsData: setLoadingCameraStatsData,
                            setUnhealthyCamsData: setUnhealthyCamsData,
                            setAlertsData: setAlertsData,
                            setFectchingAllData: setFectchingAllData,
                            setActiveTable: setActiveTable,
                            setAlertStatusDialogOpen: setAlertStatusDialogOpen,
                            setSelectedRow: setSelectedRow,
                            setSelectedRowIndex: setSelectedRowIndex,
                            setUpdatingStatus: setUpdatingStatus,
                            setBandwidthData: setBandwidthData,
                            setLoadingBandwidthData: setLoadingBandwidthData,
                            setShowSiteStats: setShowSiteStats,
                            setSingleCellActivated: setSingleCellActivated,
                            setActiveName: setActiveName,
                            cameraDropDownValue: cameraDropDownValue,
                            setDownloadURL: setDownloadURL,
                            setFetchingDownloadReport: setFetchingDownloadReport,
                            searchParams: searchParams,
                            setSearchParams: setSearchParams,
                            setBandwidthLoadingError: setBandwidthLoadingError,
                            setNotesValue: setNotesValue,
                            setBackgroundFrame: setBackgroundFrame,
                            setDetectedFrame: setDetectedFrame,
                            setNoAlertsDialogOpen: setNoAlertsDialogOpen,
                            setFiltersApplied: setFiltersApplied,
                            setClickedTab: setClickedTab,
                            navigate: navigate
                        })
                    }) : /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-[17px] left-[1270px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                            title: "Start Date required",
                            placement: "bottom",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                                    className: "shadow-button bg-[#A9A9A9] rounded font-mulish text-white text-base p-1.5",
                                    onClick: ()=>{},
                                    disabled: true,
                                    children: "Apply Filters"
                                })
                            })
                        })
                    }),
                    !fetchingAllData && filtersApplied && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: !navBarCollapsed ? "absolute left-[150px]" : "absolute left-[75px]",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "absolute",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $e463268c7e8e327a$export$ed9212dd4ba77236), {
                                    navBarCollapsed: navBarCollapsed
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: !navBarCollapsed ? "absolute top-[38px] left-[1090px] w-[200px]" : "absolute top-[38px] left-[1165px] w-[200px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $71ee7518316e8b2b$export$5e34da326b60d8f0), {
                                    downloadURL: downloadURL,
                                    loading: fetchingDownloadReport
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "absolute top-[30px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $090c97a3a87e46af$export$da471478d5e7b7db), {
                                    errorsOverviewData: errorsOverviewData,
                                    errorWarningData: errorWarningData,
                                    setErrorWarningData: setErrorWarningData,
                                    navBarCollapsed: navBarCollapsed,
                                    userFilters: userFilters
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "absolute top-[30px] left-[640px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $83e3dc0b11863bfc$export$887438ac3c872c46), {
                                    bandwidthData: bandwidthData,
                                    loadingBandwidthData: loadingBandwidthData,
                                    navBarCollapsed: navBarCollapsed,
                                    bandwidthLoadingError: bandwidthLoadingError,
                                    setLoadingBandwidthData: setLoadingBandwidthData,
                                    setBandwidthLoadingError: setBandwidthLoadingError,
                                    filters: userFilters,
                                    setBandwidthData: setBandwidthData,
                                    navigate: navigate
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "absolute top-[480px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $230e66660cbd6ce3$export$cbb2337b4727ef7b), {
                                    cameraStatsData: cameraStatsData,
                                    loadingCameraStatsData: loadingCameraStatsData,
                                    alertsData: alertsData,
                                    setActiveTable: setActiveTable,
                                    setAlertStatusDialogOpen: setAlertStatusDialogOpen,
                                    setSelectedRow: setSelectedRow,
                                    setSelectedRowIndex: setSelectedRowIndex,
                                    setFectchingAllData: setFectchingAllData,
                                    setAlertsData: setAlertsData,
                                    setUnhealthyCamsData: setUnhealthyCamsData,
                                    unhealthyCamsData: unhealthyCamsData,
                                    clickedTab: clickedTab,
                                    setSortedData: setSortedData,
                                    activeName: activeName,
                                    setActiveName: setActiveName,
                                    singleCellActivated: singleCellActivated,
                                    setSingleCellActivated: setSingleCellActivated,
                                    setFilteredDataLengths: setFilteredDataLengths,
                                    setUpdatingStatus: setUpdatingStatus,
                                    showSiteStats: showSiteStats,
                                    filters: userFilters,
                                    alertFilter: alertFilter,
                                    setSceneChangeOutcomesDialogOpen: setSceneChangeOutcomesDialogOpen,
                                    setBackgroundFrame: setBackgroundFrame,
                                    setDetectedFrame: setDetectedFrame,
                                    setSelectedRows: setSelectedRows,
                                    selectedRows: selectedRows,
                                    setErrorsOverviewData: setErrorsOverviewData,
                                    setCameraStatsData: setCameraStatsData,
                                    setLoadingCameraStatsData: setLoadingCameraStatsData,
                                    setBandwidthData: setBandwidthData,
                                    setLoadingBandwidthData: setLoadingBandwidthData,
                                    setShowSiteStats: setShowSiteStats,
                                    cameraDropDownValue: cameraDropDownValue,
                                    navBarCollapsed: navBarCollapsed,
                                    userFilters: userFilters,
                                    sceneChangeValueString: sceneChangeValueString,
                                    setBulkSceneChangeOutcomesDialogOpen: setBulkSceneChangeOutcomesDialogOpen,
                                    navigate: navigate
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "absolute top-[975px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $553166b111a7b130$export$275636fcbaf1f952), {
                                    unhealthyCamsData: unhealthyCamsData,
                                    clickedTab: clickedTab,
                                    setClickedTab: setClickedTab,
                                    alertsData: alertsData,
                                    activeTable: activeTable,
                                    setActiveTable: setActiveTable,
                                    setAlertStatusDialogOpen: setAlertStatusDialogOpen,
                                    setSelectedRow: setSelectedRow,
                                    setSelectedRowIndex: setSelectedRowIndex,
                                    setFectchingAllData: setUpdatingStatus,
                                    setAlertsData: setAlertsData,
                                    updatingStatus: updatingStatus,
                                    setUnhealthyCamsData: setUnhealthyCamsData,
                                    setSortedData: setSortedData,
                                    singleCellActivated: singleCellActivated,
                                    activeName: activeName,
                                    filteredDataLengths: filteredDataLengths,
                                    setUpdatingStatus: setUpdatingStatus,
                                    cameraDropDownValue: cameraDropDownValue,
                                    filters: userFilters,
                                    alertFilter: alertFilter,
                                    setAlertFilter: setAlertFilter,
                                    setFilteredDataLengths: setFilteredDataLengths,
                                    setSceneChangeOutcomesDialogOpen: setSceneChangeOutcomesDialogOpen,
                                    setBackgroundFrame: setBackgroundFrame,
                                    setDetectedFrame: setDetectedFrame,
                                    setSelectedRows: setSelectedRows,
                                    selectedRows: selectedRows,
                                    setErrorsOverviewData: setErrorsOverviewData,
                                    setCameraStatsData: setCameraStatsData,
                                    setLoadingCameraStatsData: setLoadingCameraStatsData,
                                    setBandwidthData: setBandwidthData,
                                    setLoadingBandwidthData: setLoadingBandwidthData,
                                    setShowSiteStats: setShowSiteStats,
                                    navBarCollapsed: navBarCollapsed,
                                    sceneChangeValueString: sceneChangeValueString,
                                    setBulkSceneChangeOutcomesDialogOpen: setBulkSceneChangeOutcomesDialogOpen,
                                    navigate: navigate
                                })
                            })
                        ]
                    }),
                    !filtersApplied && !fetchingAllData && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "relative top-[200px] text-center",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "font-mulish text-[22px]",
                                children: "Please Apply Filters to view data."
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "font-mulish text-[18px]",
                                children: "To view data for all sites, leave the Site and Camera filters empty."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "justify-start",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jVN1H.NavBar), {
                    navBarCollapsed: navBarCollapsed,
                    setNavBarCollapsed: setNavBarCollapsed,
                    props: {}
                })
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $jVN1H = parcelRequire("jVN1H");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $4o6Cs = parcelRequire("4o6Cs");

var $1wcxl = parcelRequire("1wcxl");

var $4reBM = parcelRequire("4reBM");

var $crpct = parcelRequire("crpct");

var $8jTCz = parcelRequire("8jTCz");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");
var $aVDw9 = parcelRequire("aVDw9");
var $ha39s = parcelRequire("ha39s");
var $4o6Cs = parcelRequire("4o6Cs");
var $kLvBh = parcelRequire("kLvBh");

var $9lVTU = parcelRequire("9lVTU");
const $8acd4467d07b7015$var$headCells = [
    {
        id: "request_date",
        numeric: false,
        label: "Date"
    },
    {
        id: "description",
        numeric: false,
        label: "Action"
    },
    {
        id: "user",
        numeric: false,
        label: "User"
    }
];
const $8acd4467d07b7015$export$7c263197dede4757 = ({ orderBy: orderBy, onRequestSort: onRequestSort, order: order })=>{
    const createSortHandler = (property)=>(event)=>{
            onRequestSort(event, property);
        };
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
            children: $8acd4467d07b7015$var$headCells.map((headCell)=>{
                return /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                    sx: {
                        fontSize: "15px",
                        fontFamily: "mulish",
                        fontWeight: "Bold"
                    },
                    style: {
                        maxWidth: 100
                    },
                    align: "left",
                    sortDirection: orderBy === headCell.id ? order : false,
                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kLvBh.default), {
                        active: orderBy === headCell.id,
                        direction: orderBy === headCell.id ? order : "asc",
                        onClick: createSortHandler(headCell.id),
                        children: [
                            headCell.label,
                            orderBy === headCell.id ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                component: "span",
                                sx: (0, $9lVTU.default),
                                children: order === "desc" ? "sorted descending" : "sorted ascending"
                            }) : null
                        ]
                    })
                }, headCell.id);
            })
        })
    });
};


parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $5cff8b3c7086ae36$export$3b2acc893fb2beaf = (url)=>{
    const match = url.match(/\/actionlogs\/(\d+)/);
    if (match) return match[1];
    else return "";
};
const $5cff8b3c7086ae36$export$3706ec355d599872 = (setActionLogsData, setFetchingActionLogsData, setSiteName, navigate, setSiteTimezone)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $5cff8b3c7086ae36$export$3706ec355d599872(setActionLogsData, setFetchingActionLogsData, setSiteName, navigate, setSiteTimezone);
    };
    const customerID = $5cff8b3c7086ae36$export$3b2acc893fb2beaf(location.href);
    AxiosUI.get(`command_history/action_log/?customer=${customerID}`).then((response)=>{
        const results = response.data.results;
        setActionLogsData(results);
        AxiosUI.get(`customer/${customerID}/`).then((response)=>{
            setSiteName(response.data.name);
            setSiteTimezone?.(response.data.timezone ?? null);
            setFetchingActionLogsData(false);
        }, (reason)=>{
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                setFetchingActionLogsData(false);
            });
        });
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setFetchingActionLogsData(false);
        });
    });
};


const $7bd401b60d2398a1$export$19f9a6515d26e988 = (setActionLogsData, setLoadingMoreActionLogsData, paginationNumber, setPaginationNumber, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $7bd401b60d2398a1$export$19f9a6515d26e988(setActionLogsData, setLoadingMoreActionLogsData, paginationNumber, setPaginationNumber, navigate);
    };
    AxiosUI.get(`command_history/action_log/?customer=${(0, $5cff8b3c7086ae36$export$3b2acc893fb2beaf)(location.href)}&page=${paginationNumber + 1}`).then((response)=>{
        const results = response.data.results;
        setPaginationNumber(paginationNumber + 1);
        setActionLogsData((previousState)=>[
                ...previousState,
                ...results
            ]);
        setLoadingMoreActionLogsData(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Error fetching more audit logs data, please try again.");
            setActionLogsData((previousState)=>[
                    ...previousState
                ]);
            setLoadingMoreActionLogsData(false);
        });
    });
};



var $6ZGvG = parcelRequire("6ZGvG");
const $e6763af66cf2554a$export$68e691a5370f90fa = ({ auditLogsData: auditLogsData, page: page, setPage: setPage, rowsPerPage: rowsPerPage, setRowsPerPage: setRowsPerPage, paginationNumber: paginationNumber, setLoadingMoreActionLogsData: setLoadingMoreActionLogsData, setActionLogsData: setActionLogsData, setPaginationNumber: setPaginationNumber, navigate: navigate, siteTimezone: siteTimezone = null })=>{
    const [order, setOrder] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("asc");
    const [orderBy, setOrderBy] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("formatted_date");
    const [displayLoadMoreButton, setDisplayLoadMoreButton] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const handleRequestSort = (event, property)=>{
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };
    const handleChangePage = (event, newPage)=>{
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event)=>{
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) return -1;
        if (b[orderBy] > a[orderBy]) return 1;
        return 0;
    }
    function getComparator(order, orderBy) {
        return order === "desc" ? (a, b)=>descendingComparator(a, b, orderBy) : (a, b)=>-descendingComparator(a, b, orderBy);
    }
    function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index)=>[
                el,
                index
            ]);
        stabilizedThis.sort((a, b)=>{
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map((el)=>el[0]);
    }
    const formatDateString = (dateString)=>(0, $6ZGvG.formatSiteTimestamp)(new Date(dateString), siteTimezone);
    const visibleRows = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>stableSort(auditLogsData, getComparator(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        order,
        orderBy,
        page,
        rowsPerPage
    ]);
    const { height: height, width: width } = (0, $crpct.default)();
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setCalculatedHeight(height - 205);
        setCalculatedWidth(width - 150);
    }, [
        height,
        width
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (auditLogsData.length % 100 !== 0) setDisplayLoadMoreButton(false);
        else {
            if (rowsPerPage === 100) setDisplayLoadMoreButton(paginationNumber === Number(page) + 1);
            if (rowsPerPage === 25) setDisplayLoadMoreButton(auditLogsData.length / 25 === Number(page) + 1);
            if (rowsPerPage === 10) setDisplayLoadMoreButton(auditLogsData.length / 10 === Number(page) + 1);
        }
    }, [
        rowsPerPage,
        page,
        paginationNumber,
        auditLogsData
    ]);
    const [calcuatedHeight, setCalculatedHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [calcuatedWidth, setCalculatedWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4reBM.default), {
        sx: {
            width: "100%",
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                sx: {
                    maxHeight: calcuatedHeight,
                    minWidth: calcuatedWidth
                },
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                    sx: {
                        fontFamily: "Mulish"
                    },
                    "aria-label": "audit_logs_table",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $8acd4467d07b7015$export$7c263197dede4757), {
                            orderBy: orderBy,
                            onRequestSort: handleRequestSort,
                            order: order
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $gXvgZ.default), {
                            children: [
                                visibleRows.map((obj, index)=>{
                                    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                align: "left",
                                                children: formatDateString(obj.request_date)
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                align: "left",
                                                children: obj.description
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                align: "left",
                                                children: obj.user
                                            })
                                        ]
                                    }, obj.id);
                                }),
                                displayLoadMoreButton && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {}),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                onClick: ()=>{
                                                    setLoadingMoreActionLogsData(true);
                                                    setDisplayLoadMoreButton(false);
                                                    (0, $7bd401b60d2398a1$export$19f9a6515d26e988)(setActionLogsData, setLoadingMoreActionLogsData, paginationNumber, setPaginationNumber, navigate);
                                                },
                                                text: "Load More",
                                                disabled: false
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {})
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wcxl.default), {
                rowsPerPageOptions: [
                    10,
                    25,
                    100
                ],
                component: "div",
                count: auditLogsData.length,
                rowsPerPage: rowsPerPage,
                page: page,
                onPageChange: handleChangePage,
                onRowsPerPageChange: handleChangeRowsPerPage
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $ha39s = parcelRequire("ha39s");

var $4o6Cs = parcelRequire("4o6Cs");

var $1wcxl = parcelRequire("1wcxl");

var $4reBM = parcelRequire("4reBM");

var $crpct = parcelRequire("crpct");

var $lWchQ = parcelRequire("lWchQ");

var $2aMB5 = parcelRequire("2aMB5");

var $6ZGvG = parcelRequire("6ZGvG");
const $cf9817f5f19866cf$var$HEADERS = [
    "Date",
    "Action",
    "Days",
    "Start Time",
    "End Time",
    "Flex Schedule",
    "User"
];
// Only the save timestamp is converted; start/end times are the schedule's
// own wall-clock values and render as stored.
function $cf9817f5f19866cf$var$formatDateString(dateString, siteTimezone) {
    return (0, $6ZGvG.formatSiteTimestamp)(new Date(dateString), siteTimezone);
}
const $cf9817f5f19866cf$var$ACTION_LABELS = {
    added: "Added",
    changed: "Changed",
    removed: "Removed"
};
function $cf9817f5f19866cf$var$stateTime(state, field) {
    if (state == null) return "-";
    if (state.always_on) return "Always On";
    return state[field] ?? "-";
}
// added → the new value; removed → the old value; changed → "old → new"
function $cf9817f5f19866cf$var$timeCell(change, field) {
    if (change.change_type === "changed") {
        const before = $cf9817f5f19866cf$var$stateTime(change.before, field);
        const after = $cf9817f5f19866cf$var$stateTime(change.after, field);
        return before === after ? after : `${before} \u{2192} ${after}`;
    }
    return $cf9817f5f19866cf$var$stateTime(change.change_type === "removed" ? change.before : change.after, field);
}
const $cf9817f5f19866cf$export$6d94f9234a00d16f = ({ scheduleHistoryResults: scheduleHistoryResults, siteTimezone: siteTimezone = null })=>{
    const { height: height, width: width } = (0, $crpct.default)();
    const [calculatedHeight, setCalculatedHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [calculatedWidth, setCalculatedWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [page, setPage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [rowsPerPage, setRowsPerPage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(10);
    const rows = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>scheduleHistoryResults.flatMap((entry, entryIndex)=>(entry.changes ?? []).map((change, changeIndex)=>({
                    key: `${entry.history_date}-${entryIndex}-${changeIndex}`,
                    entry: entry,
                    change: change
                }))), [
        scheduleHistoryResults
    ]);
    const handleChangePage = (_event, newPage)=>{
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event)=>{
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const pageClamped = Math.min(page, Math.max(0, Math.ceil(rows.length / rowsPerPage) - 1));
    const visibleRows = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>rows.slice(pageClamped * rowsPerPage, pageClamped * rowsPerPage + rowsPerPage), [
        rows,
        pageClamped,
        rowsPerPage
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setCalculatedHeight(height - 205);
        setCalculatedWidth(width - 150);
    }, [
        height,
        width
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (page > pageClamped) setPage(pageClamped);
    }, [
        pageClamped,
        page
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4reBM.default), {
        sx: {
            width: "100%",
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                sx: {
                    maxHeight: calculatedHeight,
                    minWidth: calculatedWidth
                },
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                    sx: {
                        fontFamily: "Mulish"
                    },
                    "aria-label": "schedule action logs table",
                    stickyHeader: true,
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                children: $cf9817f5f19866cf$var$HEADERS.map((label)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        sx: {
                                            fontSize: "15px",
                                            fontFamily: "Mulish",
                                            fontWeight: "Bold"
                                        },
                                        align: "left",
                                        children: label
                                    }, label))
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                            children: rows.length === 0 ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    colSpan: $cf9817f5f19866cf$var$HEADERS.length,
                                    align: "center",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: "No schedule action logs to display."
                                })
                            }) : visibleRows.map(({ key: key, entry: entry, change: change })=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            align: "left",
                                            children: $cf9817f5f19866cf$var$formatDateString(entry.history_date, siteTimezone)
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            align: "left",
                                            children: $cf9817f5f19866cf$var$ACTION_LABELS[change.change_type] ?? change.change_type
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $aVDw9.default), {
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            align: "left",
                                            children: [
                                                change.day_of_week_str,
                                                change.is_override ? " (override)" : ""
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            align: "left",
                                            children: $cf9817f5f19866cf$var$timeCell(change, "start_time")
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            align: "left",
                                            children: $cf9817f5f19866cf$var$timeCell(change, "end_time")
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            align: "left",
                                            children: change.flex_schedule != null ? (0, $lWchQ.checkedCircleIconSmall) : (0, $2aMB5.cancelIconRedSmall)
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            align: "left",
                                            children: entry.username ?? "-"
                                        })
                                    ]
                                }, key))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wcxl.default), {
                rowsPerPageOptions: [
                    10,
                    25,
                    100
                ],
                component: "div",
                count: rows.length,
                rowsPerPage: rowsPerPage,
                page: pageClamped,
                onPageChange: handleChangePage,
                onRowsPerPageChange: handleChangeRowsPerPage
            })
        ]
    });
};



var $dHtmK = parcelRequire("dHtmK");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $eDfvp = parcelRequire("eDfvp");

var $3IuQ3 = parcelRequire("3IuQ3");

var $5GP2e = parcelRequire("5GP2e");

var $eXOoR = parcelRequire("eXOoR");

var $3n3uW = parcelRequire("3n3uW");

var $2suvB = parcelRequire("2suvB");

var $j0ZEU = parcelRequire("j0ZEU");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");


var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $1cd6d361ee89c0b7$export$9682fa6fbabadaf5 = (siteId, setScheduleHistoryData, setFetchingScheduleHistoryData, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $1cd6d361ee89c0b7$export$9682fa6fbabadaf5(siteId, setScheduleHistoryData, setFetchingScheduleHistoryData, navigate);
    };
    // consolidated=true (ED-14): one entry per save with per-day changes,
    // instead of the raw replace-the-week history rows.
    AxiosUI.get(`schedule/history/?customer__id=${siteId}&consolidated=true`).then((response)=>{
        const results = response.data.results ?? [];
        setScheduleHistoryData(results);
        setFetchingScheduleHistoryData(false);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            setFetchingScheduleHistoryData(false);
        });
    });
};



var $195EM = parcelRequire("195EM");

var $hAnMZ = parcelRequire("hAnMZ");
const $5a2a497a06b95c8c$export$8269f9048ba6ff99 = 90;
const $5a2a497a06b95c8c$export$578bb2e5fc414682 = (siteId, setMuteHistoryData, setCameraNames, setFetchingMuteHistoryData, setMuteHistoryUnavailable)=>{
    const MonitoringAPI = (0, $hAnMZ.createMonitoringAPICall)(``);
    const AxiosUI = (0, $195EM.createApi)(``);
    const to = Math.floor(Date.now() / 1000);
    const from = to - $5a2a497a06b95c8c$export$8269f9048ba6ff99 * 86400;
    MonitoringAPI.get(`streaming/mute-history/?customer=${siteId}&from=${from}&to=${to}&limit=500`).then((response)=>{
        setMuteHistoryData(response.data.events ?? []);
        setMuteHistoryUnavailable(false);
        // Camera names for the pk list — best effort; ids still render if it fails.
        AxiosUI.get(`camera/site/?customer__id=${siteId}`).then((response)=>{
            const names = new Map();
            (response.data.results ?? []).forEach((camera)=>{
                names.set(String(camera.id), camera.camera_name);
            });
            setCameraNames(names);
            setFetchingMuteHistoryData(false);
        }, ()=>{
            setFetchingMuteHistoryData(false);
        });
    }, ()=>{
        setMuteHistoryData([]);
        setMuteHistoryUnavailable(true);
        setFetchingMuteHistoryData(false);
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $k8Qy8 = parcelRequire("k8Qy8");

var $gXvgZ = parcelRequire("gXvgZ");

var $aVDw9 = parcelRequire("aVDw9");

var $3Nm8Z = parcelRequire("3Nm8Z");

var $ha39s = parcelRequire("ha39s");

var $4o6Cs = parcelRequire("4o6Cs");

var $1wcxl = parcelRequire("1wcxl");

var $4reBM = parcelRequire("4reBM");

var $cVCJe = parcelRequire("cVCJe");

var $crpct = parcelRequire("crpct");


var $6ZGvG = parcelRequire("6ZGvG");
// PROD-27: one row per mute/unmute action. Site-scope mutes list every
// camera they covered; we show the first few names and tooltip the rest.
const $6da82f4d2e870187$var$HEADERS = [
    "Date",
    "Action",
    "Scope",
    "Cameras",
    "Duration",
    "Until",
    "User"
];
const $6da82f4d2e870187$var$MAX_INLINE_CAMERAS = 3;
function $6da82f4d2e870187$export$3a0e5999dee698e6(epochSeconds, siteTimezone = null) {
    if (epochSeconds == null) return "-";
    return (0, $6ZGvG.formatSiteTimestamp)(new Date(epochSeconds * 1000), siteTimezone);
}
function $6da82f4d2e870187$export$bc733b0c5cbb3e8a(minutes) {
    if (minutes == null) return "-";
    if (minutes < 60) return `${minutes} min`;
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return m ? `${h} hr ${m} min` : `${h} hr`;
}
function $6da82f4d2e870187$export$2252516a0db60b69(event, cameraNames) {
    const names = (event.camera_ids ?? []).map((id)=>cameraNames.get(String(id)) ?? `#${id}`);
    const shown = names.slice(0, $6da82f4d2e870187$var$MAX_INLINE_CAMERAS).join(", ");
    const extra = names.length - $6da82f4d2e870187$var$MAX_INLINE_CAMERAS;
    return {
        inline: extra > 0 ? `${shown} +${extra} more` : shown || "-",
        tooltip: names.join(", ")
    };
}
const $6da82f4d2e870187$export$28aa63939e486c04 = ({ muteHistoryResults: muteHistoryResults, cameraNames: cameraNames, unavailable: unavailable = false, siteTimezone: siteTimezone = null })=>{
    const { height: height, width: width } = (0, $crpct.default)();
    const [calculatedHeight, setCalculatedHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [calculatedWidth, setCalculatedWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [page, setPage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [rowsPerPage, setRowsPerPage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(10);
    const rows = muteHistoryResults;
    const pageClamped = Math.min(page, Math.max(0, Math.ceil(rows.length / rowsPerPage) - 1));
    const visibleRows = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>rows.slice(pageClamped * rowsPerPage, pageClamped * rowsPerPage + rowsPerPage), [
        rows,
        pageClamped,
        rowsPerPage
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setCalculatedHeight(height - 205);
        setCalculatedWidth(width - 150);
    }, [
        height,
        width
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (page > pageClamped) setPage(pageClamped);
    }, [
        pageClamped,
        page
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4reBM.default), {
        sx: {
            width: "100%",
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                sx: {
                    maxHeight: calculatedHeight,
                    minWidth: calculatedWidth
                },
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                    sx: {
                        fontFamily: "Mulish"
                    },
                    "aria-label": "mute history table",
                    stickyHeader: true,
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                children: $6da82f4d2e870187$var$HEADERS.map((label)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        sx: {
                                            fontSize: "15px",
                                            fontFamily: "Mulish",
                                            fontWeight: "Bold"
                                        },
                                        align: "left",
                                        children: label
                                    }, label))
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                            children: rows.length === 0 ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                    colSpan: $6da82f4d2e870187$var$HEADERS.length,
                                    align: "center",
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: unavailable ? "Mute history is unavailable right now." : `No mutes or unmutes in the last ${0, $5a2a497a06b95c8c$export$8269f9048ba6ff99} days.`
                                })
                            }) : visibleRows.map((event, index)=>{
                                const cams = $6da82f4d2e870187$export$2252516a0db60b69(event, cameraNames);
                                return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            align: "left",
                                            children: $6da82f4d2e870187$export$3a0e5999dee698e6(event.ts, siteTimezone)
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: "Bold",
                                                color: event.action === "mute" ? "#d32f2f" : "#2e7d32"
                                            },
                                            align: "left",
                                            children: event.action === "mute" ? "Muted" : "Unmuted"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            align: "left",
                                            children: event.scope === "site" ? "Site" : "Camera"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            align: "left",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                title: cams.tooltip,
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                    children: cams.inline
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            align: "left",
                                            children: $6da82f4d2e870187$export$bc733b0c5cbb3e8a(event.duration_minutes)
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            align: "left",
                                            children: $6da82f4d2e870187$export$3a0e5999dee698e6(event.expires_at, siteTimezone)
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            sx: {
                                                fontFamily: "Mulish"
                                            },
                                            align: "left",
                                            children: event.user ?? "-"
                                        })
                                    ]
                                }, `${event.ts}-${event.action}-${event.camera_pk}-${index}`);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wcxl.default), {
                rowsPerPageOptions: [
                    10,
                    25,
                    100
                ],
                component: "div",
                count: rows.length,
                rowsPerPage: rowsPerPage,
                page: pageClamped,
                onPageChange: (_e, p)=>setPage(p),
                onRowsPerPageChange: (e)=>{
                    setRowsPerPage(parseInt(e.target.value, 10));
                    setPage(0);
                }
            })
        ]
    });
};



var $4PFLW = parcelRequire("4PFLW");
const $8a72acb32332a3d2$var$tabsTheme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
const $8a72acb32332a3d2$export$e241ab6b9aa14723 = ({ navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed })=>{
    const [auditLogsData, setActionLogsData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [fetchingActionLogsData, setFetchingActionLogsData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [page, setPage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [rowsPerPage, setRowsPerPage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(10);
    const [paginationNumber, setPaginationNumber] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(1);
    const [loadingMoreActionLogsData, setLoadingMoreActionLogsData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [siteName, setSiteName] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [siteTimezone, setSiteTimezone] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [clickedTab, setClickedTab] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("general");
    const [scheduleHistoryData, setScheduleHistoryData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [fetchingScheduleHistoryData, setFetchingScheduleHistoryData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    // PROD-27: mute/unmute history from monitoring-api's durable audit rows.
    const [muteHistoryData, setMuteHistoryData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [muteCameraNames, setMuteCameraNames] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(new Map());
    const [fetchingMuteHistoryData, setFetchingMuteHistoryData] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [muteHistoryUnavailable, setMuteHistoryUnavailable] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const navigate = (0, $3T949.useNavigate)();
    const { isFeatureEnabled: isFeatureEnabled } = (0, $4PFLW.useFeatureFlag)();
    const showScheduleActionLogs = isFeatureEnabled("showScheduleActionLogs", false);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        const siteId = (0, $5cff8b3c7086ae36$export$3b2acc893fb2beaf)(location.href);
        (0, $5cff8b3c7086ae36$export$3706ec355d599872)(setActionLogsData, setFetchingActionLogsData, setSiteName, navigate, setSiteTimezone);
        if (showScheduleActionLogs && siteId) (0, $1cd6d361ee89c0b7$export$9682fa6fbabadaf5)(siteId, setScheduleHistoryData, setFetchingScheduleHistoryData, navigate);
        else setFetchingScheduleHistoryData(false);
        // Mute history is for everyone who can mute — no flag (PROD-27).
        if (siteId) (0, $5a2a497a06b95c8c$export$578bb2e5fc414682)(siteId, setMuteHistoryData, setMuteCameraNames, setFetchingMuteHistoryData, setMuteHistoryUnavailable);
        else setFetchingMuteHistoryData(false);
    }, [
        navigate,
        showScheduleActionLogs
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "bg-actuate-grey absolute w-screen h-screen",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                        openState: fetchingActionLogsData || showScheduleActionLogs && fetchingScheduleHistoryData || fetchingMuteHistoryData
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                        openState: loadingMoreActionLogsData
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: !navBarCollapsed ? "absolute top-[20px] left-[150px] right-[1px] h-[19px]] bg-white" : "absolute top-[20px] left-[75px] right-[1px] h-[19px]] bg-white",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3IuQ3.default), {
                            spacing: 2,
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $j0ZEU.default), {
                                separator: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXOoR))), {
                                    fontSize: "medium"
                                }),
                                "aria-label": "breadcrumb",
                                sx: {
                                    paddingLeft: "20px"
                                },
                                children: [
                                    siteName && /*#__PURE__*/ (0, $k4ank.jsx)((0, $5GP2e.default), {
                                        underline: "hover",
                                        color: "inherit",
                                        href: `/sites/aboutsite/${(0, $5cff8b3c7086ae36$export$3b2acc893fb2beaf)(location.href)}`,
                                        sx: {
                                            fontSize: "20px",
                                            fontFamily: "Mulish",
                                            fontWeight: "bold"
                                        },
                                        variant: "h5",
                                        children: siteName
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                        className: "text-black font-bold font-mulish text-[20px] pt-3 pb-3",
                                        children: "Action Logs"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: !navBarCollapsed ? "absolute left-[150px] top-[95px] right-[1px]" : "absolute left-[75px] top-[95px] right-[1px]",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                sx: {
                                    borderBottom: 1,
                                    borderColor: "divider",
                                    marginBottom: 0,
                                    backgroundColor: "white"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                                    theme: $8a72acb32332a3d2$var$tabsTheme,
                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3n3uW.default), {
                                        value: clickedTab,
                                        onChange: (_event, tabValue)=>setClickedTab(tabValue),
                                        "aria-label": "action logs tabs",
                                        color: "primary",
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                                                value: "general",
                                                label: "General Action Logs",
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    fontWeight: "Bold",
                                                    color: "primary"
                                                }
                                            }),
                                            showScheduleActionLogs && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                                                value: "schedule",
                                                label: "Schedule Action Logs",
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    fontWeight: "Bold",
                                                    color: "primary"
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                                                value: "mute",
                                                label: "Mute History",
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    fontWeight: "Bold",
                                                    color: "primary"
                                                }
                                            })
                                        ]
                                    })
                                })
                            }),
                            clickedTab === "general" && !fetchingActionLogsData && /*#__PURE__*/ (0, $k4ank.jsx)((0, $e6763af66cf2554a$export$68e691a5370f90fa), {
                                auditLogsData: auditLogsData,
                                page: page,
                                setPage: setPage,
                                rowsPerPage: rowsPerPage,
                                setRowsPerPage: setRowsPerPage,
                                paginationNumber: paginationNumber,
                                setLoadingMoreActionLogsData: setLoadingMoreActionLogsData,
                                setActionLogsData: setActionLogsData,
                                setPaginationNumber: setPaginationNumber,
                                navigate: navigate,
                                siteTimezone: siteTimezone
                            }),
                            clickedTab === "schedule" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $cf9817f5f19866cf$export$6d94f9234a00d16f), {
                                scheduleHistoryResults: scheduleHistoryData,
                                siteTimezone: siteTimezone
                            }),
                            clickedTab === "mute" && /*#__PURE__*/ (0, $k4ank.jsx)((0, $6da82f4d2e870187$export$28aa63939e486c04), {
                                muteHistoryResults: muteHistoryData,
                                cameraNames: muteCameraNames,
                                unavailable: muteHistoryUnavailable,
                                siteTimezone: siteTimezone
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "justify-start",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jVN1H.NavBar), {
                    navBarCollapsed: navBarCollapsed,
                    setNavBarCollapsed: setNavBarCollapsed,
                    props: {}
                })
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");


var $a65wX = parcelRequire("a65wX");

var $b9p11 = parcelRequire("b9p11");

var $dHtmK = parcelRequire("dHtmK");

var $jVN1H = parcelRequire("jVN1H");


var $faP87 = parcelRequire("faP87");


var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $a65wX = parcelRequire("a65wX");
var $60vL1 = parcelRequire("60vL1");
var $kUcVg = parcelRequire("kUcVg");
var $1TOOV = parcelRequire("1TOOV");
var $ce8iU = parcelRequire("ce8iU");
var $iKAtE = parcelRequire("iKAtE");
var $k8Qy8 = parcelRequire("k8Qy8");
var $gXvgZ = parcelRequire("gXvgZ");
var $aVDw9 = parcelRequire("aVDw9");
var $ha39s = parcelRequire("ha39s");
var $4o6Cs = parcelRequire("4o6Cs");
var $cVCJe = parcelRequire("cVCJe");

var $433j1 = parcelRequire("433j1");

var $2zBdB = parcelRequire("2zBdB");
var $34f136bbfa236f69$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($34f136bbfa236f69$exports, "__esModule", {
    value: true
});
$34f136bbfa236f69$exports.default = void 0;

var $34f136bbfa236f69$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $34f136bbfa236f69$var$_default = $34f136bbfa236f69$exports.default = (0, $34f136bbfa236f69$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "m14.06 9.02.92.92L5.92 19H5v-.92zM17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29m-3.6 3.19L3 17.25V21h3.75L17.81 9.94z"
}), 'EditOutlined');




var $b9p11 = parcelRequire("b9p11");

var $8jTCz = parcelRequire("8jTCz");

var $faP87 = parcelRequire("faP87");





var $8kxcc = parcelRequire("8kxcc");
const $1a21b6e89c61649b$var$formatRecordedDate = (iso)=>{
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric"
    });
};
const $1a21b6e89c61649b$var$formatCamerasCell = (a)=>{
    if (a.mode === "entire_site") return "All cameras";
    return a.cameraNames.join(", ");
};
const $1a21b6e89c61649b$export$8dfe8443e4368bc0 = ({ message: message, onClose: onClose })=>{
    const updateMessage = (0, $5fe762dced2f1f3d$export$eddecb1f05de5e25)((s)=>s.updateMessage);
    const setAssignments = (0, $5fe762dced2f1f3d$export$eddecb1f05de5e25)((s)=>s.setAssignments);
    const removeAssignment = (0, $5fe762dced2f1f3d$export$eddecb1f05de5e25)((s)=>s.removeAssignment);
    const deleteMessage = (0, $5fe762dced2f1f3d$export$eddecb1f05de5e25)((s)=>s.deleteMessage);
    const live = (0, $5fe762dced2f1f3d$export$eddecb1f05de5e25)((s)=>message ? s.messages.find((m)=>m.id === message.id) : undefined);
    const [editingAssignments, setEditingAssignments] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [editingSiteId, setEditingSiteId] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [draftAssignments, setDraftAssignments] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [assignSearch, setAssignSearch] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [assignSites, setAssignSites] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [assignSitesLoading, setAssignSitesLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [assignSitesError, setAssignSitesError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [currentTime, setCurrentTime] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const audioRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const elapsedRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(0);
    const loadedAssignGroupRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(null);
    const row = live ?? message;
    const recorder = (0, $8kxcc.useAudioRecorder)({
        maxSeconds: 30,
        onRecorded: (blob)=>{
            if (!row) return;
            const url = URL.createObjectURL(blob);
            if (row.audioUrl?.startsWith("blob:")) URL.revokeObjectURL(row.audioUrl);
            updateMessage(row.id, {
                audioUrl: url,
                durationSeconds: Math.max(1, elapsedRef.current || 1),
                recordedAt: new Date().toISOString()
            });
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        elapsedRef.current = recorder.elapsedSeconds;
    }, [
        recorder.elapsedSeconds
    ]);
    const resetAssignEditor = ()=>{
        setEditingAssignments(false);
        setEditingSiteId(null);
        setDraftAssignments([]);
        setAssignSearch("");
    };
    // Dialog stays mounted when closed; clear edit mode so reopen is not stuck editing.
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setEditingAssignments(false);
        setEditingSiteId(null);
        setDraftAssignments([]);
        setAssignSearch("");
        setAssignSites([]);
        setAssignSitesError(null);
        setAssignSitesLoading(false);
        loadedAssignGroupRef.current = null;
        setCurrentTime(0);
    }, [
        message?.id
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!editingAssignments || !row?.groupId) return;
        const key = String(row.groupId);
        if (loadedAssignGroupRef.current === key) return;
        let cancelled = false;
        setAssignSitesLoading(true);
        setAssignSitesError(null);
        (0, $f18c618421bb94cb$export$14112600e9dd8260)(row.groupId).then((sites)=>{
            if (cancelled) return;
            setAssignSites(sites);
            loadedAssignGroupRef.current = key;
        }).catch(()=>{
            if (cancelled) return;
            setAssignSites([]);
            setAssignSitesError("Could not load sites for this group.");
            loadedAssignGroupRef.current = null;
        }).finally(()=>{
            if (!cancelled) setAssignSitesLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        editingAssignments,
        row?.groupId
    ]);
    if (!row) return null;
    const openAssignEditor = ()=>{
        setDraftAssignments(row.assignments);
        setAssignSearch("");
        setEditingSiteId(null);
        setEditingAssignments(true);
    };
    const openSiteCameraEditor = (siteId)=>{
        setDraftAssignments(row.assignments);
        setAssignSearch("");
        setEditingSiteId(siteId);
        setEditingAssignments(true);
    };
    const closeAssignEditor = (save)=>{
        if (save) setAssignments(row.id, draftAssignments);
        resetAssignEditor();
    };
    const handleClose = ()=>{
        resetAssignEditor();
        onClose();
    };
    const handleDownload = ()=>{
        if (!row.audioUrl) return;
        const a = document.createElement("a");
        a.href = row.audioUrl;
        a.download = `${row.name.replace(/\s+/g, "_").toLowerCase()}.webm`;
        a.click();
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: Boolean(message),
        onClose: handleClose,
        fullWidth: true,
        maxWidth: "md",
        PaperProps: {
            sx: {
                fontFamily: "Mulish"
            }
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $ce8iU.default), {
                sx: {
                    fontFamily: "Mulish",
                    fontWeight: 800,
                    pr: 6,
                    color: "#001943"
                },
                children: [
                    row.name,
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                        "aria-label": "Close",
                        onClick: handleClose,
                        sx: {
                            position: "absolute",
                            right: 8,
                            top: 8
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                        className: "mb-3 font-mulish text-[13px] text-gray-600",
                        children: [
                            row.groupName,
                            " \xb7 Recorded by ",
                            row.recordedBy,
                            " on",
                            " ",
                            $1a21b6e89c61649b$var$formatRecordedDate(row.recordedAt),
                            " \xb7 Played ",
                            row.playCount,
                            " times"
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "mb-4 flex flex-wrap items-center gap-3",
                        children: row.audioUrl ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)("audio", {
                                    ref: audioRef,
                                    controls: true,
                                    src: row.audioUrl,
                                    className: "max-w-full flex-1",
                                    onTimeUpdate: ()=>setCurrentTime(audioRef.current?.currentTime ?? 0),
                                    onPlay: ()=>void updateMessage(row.id, {
                                            playCount: row.playCount + 1
                                        })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                                    className: "font-mulish text-[13px] text-gray-600",
                                    children: [
                                        (0, $12037e7a4c3f6675$export$30398d3192ef3048)(currentTime),
                                        " /",
                                        " ",
                                        (0, $12037e7a4c3f6675$export$30398d3192ef3048)(row.durationSeconds)
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "font-mulish text-[13px] text-gray-500",
                            children: "No audio attached. Hold to re-record to add audio."
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "mb-6 flex flex-wrap items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)("button", {
                                type: "button",
                                className: `inline-flex h-10 items-center justify-center gap-1.5 rounded-md px-3 font-mulish text-[13px] font-semibold text-white ${recorder.recording ? "bg-[#B3261E]" : "bg-actuate-orange"}`,
                                "aria-label": recorder.recording ? "Stop re-record" : "Hold to re-record",
                                title: recorder.recording ? "Release to stop" : "Hold to re-record",
                                onPointerDown: (e)=>{
                                    if (e.button !== 0) return;
                                    e.preventDefault();
                                    recorder.start();
                                },
                                onPointerUp: ()=>recorder.stop(),
                                onPointerLeave: ()=>{
                                    if (recorder.recording) recorder.stop();
                                },
                                style: {
                                    touchAction: "none"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6416eab92432523e$exports))), {
                                        sx: {
                                            fontSize: 14
                                        },
                                        className: recorder.recording ? "animate-pulse" : undefined
                                    }),
                                    recorder.recording ? `Recording ${(0, $12037e7a4c3f6675$export$30398d3192ef3048)(recorder.elapsedSeconds)}` : "Hold to re-record"
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $b9p11.default), {
                                theme: (0, $faP87.theme),
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                        type: "button",
                                        color: "primary",
                                        disabled: !row.audioUrl,
                                        onClick: handleDownload,
                                        startIcon: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2zBdB))), {}),
                                        "aria-label": "Download",
                                        className: "hover:bg-[#E67300]",
                                        children: "Download"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                        type: "button",
                                        onClick: ()=>{
                                            deleteMessage(row.id).then(()=>handleClose());
                                        },
                                        "aria-label": "Delete message",
                                        sx: {
                                            color: "#B3261E",
                                            fontFamily: "Mulish",
                                            fontWeight: 600,
                                            "&:hover": {
                                                backgroundColor: "rgba(179, 38, 30, 0.08)"
                                            }
                                        },
                                        children: "Delete message"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "mb-2 flex items-center justify-between gap-3",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("h3", {
                                className: "font-mulish text-[16px] font-bold text-actuate-blue",
                                children: "Assigned to"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                text: editingAssignments ? "Done" : "+ Add sites or cameras",
                                disabled: false,
                                onClick: ()=>{
                                    if (editingAssignments) closeAssignEditor(true);
                                    else openAssignEditor();
                                }
                            })
                        ]
                    }),
                    editingAssignments ? assignSitesLoading ? /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: "flex items-center gap-3 font-mulish text-[13px] text-gray-500",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                size: 22,
                                sx: {
                                    color: "#FF8400"
                                }
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                children: "Loading sites and cameras\u2026"
                            })
                        ]
                    }) : assignSitesError ? /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-mulish text-[13px] text-[#B3261E]",
                        children: assignSitesError
                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $b97869735a5c700b$export$5341a20088efd68), {
                        sites: assignSites,
                        search: assignSearch,
                        onSearchChange: setAssignSearch,
                        assignments: draftAssignments,
                        onChange: setDraftAssignments,
                        camerasOnlySiteId: editingSiteId
                    }) : /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                        size: "small",
                        sx: {
                            tableLayout: "fixed",
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: 700,
                                                width: "42%"
                                            },
                                            children: "Site"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: 700,
                                                width: "42%"
                                            },
                                            children: "Cameras"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: 700,
                                                width: "16%",
                                                textAlign: "right"
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $gXvgZ.default), {
                                children: [
                                    row.assignments.map((a)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    sx: {
                                                        fontFamily: "Mulish",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis"
                                                    },
                                                    children: a.siteName
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    sx: {
                                                        fontFamily: "Mulish",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis"
                                                    },
                                                    children: $1a21b6e89c61649b$var$formatCamerasCell(a)
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    sx: {
                                                        fontFamily: "Mulish",
                                                        whiteSpace: "nowrap"
                                                    },
                                                    align: "right",
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                                        className: "inline-flex items-center justify-end gap-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                                title: "Edit cameras",
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                                                    size: "small",
                                                                    "aria-label": "Edit cameras",
                                                                    onClick: ()=>openSiteCameraEditor(a.siteId),
                                                                    sx: {
                                                                        color: "#FF8400"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($34f136bbfa236f69$exports))), {
                                                                        fontSize: "small"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                                                title: "Remove",
                                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                                                                    size: "small",
                                                                    "aria-label": "Remove",
                                                                    onClick: ()=>void removeAssignment(row.id, a.siteId),
                                                                    sx: {
                                                                        color: "#B3261E",
                                                                        "&:hover": {
                                                                            backgroundColor: "rgba(179, 38, 30, 0.08)"
                                                                        }
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {
                                                                        fontSize: "small"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }, String(a.siteId))),
                                    !row.assignments.length && /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            colSpan: 3,
                                            sx: {
                                                fontFamily: "Mulish",
                                                color: "#6b7280"
                                            },
                                            children: "Unassigned"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $4reBM = parcelRequire("4reBM");
var $k8Qy8 = parcelRequire("k8Qy8");
var $gXvgZ = parcelRequire("gXvgZ");
var $aVDw9 = parcelRequire("aVDw9");
var $3Nm8Z = parcelRequire("3Nm8Z");
var $ha39s = parcelRequire("ha39s");
var $1wcxl = parcelRequire("1wcxl");
var $4o6Cs = parcelRequire("4o6Cs");

const $900a19ae45958a78$var$formatRecordedDate = (iso)=>{
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric"
    });
};
const $900a19ae45958a78$export$48cf256b3825f518 = ({ rows: rows, page: page, rowsPerPage: rowsPerPage, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, onOpenDetail: onOpenDetail })=>{
    const visible = rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4reBM.default), {
        sx: {
            width: "100%",
            overflow: "hidden",
            minWidth: 700
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $3Nm8Z.default), {
                sx: {
                    maxHeight: window.innerHeight - 205,
                    width: window.innerWidth - 150
                },
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                    stickyHeader: true,
                    sx: {
                        fontFamily: "Mulish"
                    },
                    size: "small",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                children: [
                                    "Name",
                                    "Group",
                                    "Length",
                                    "Assigned to",
                                    "Recorded by",
                                    "More Info"
                                ].map((label)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        sx: {
                                            fontFamily: "Mulish",
                                            fontWeight: 700,
                                            backgroundColor: "#fff"
                                        },
                                        children: label
                                    }, label))
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $gXvgZ.default), {
                            children: [
                                visible.map((row)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                        hover: true,
                                        sx: {
                                            cursor: "pointer"
                                        },
                                        onClick: ()=>onOpenDetail(row),
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: row.name
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: row.groupName
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: (0, $12037e7a4c3f6675$export$30398d3192ef3048)(row.durationSeconds)
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: (0, $12037e7a4c3f6675$export$ee2aad92dd186a4c)(row.assignments)
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: row.recordedBy
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: $900a19ae45958a78$var$formatRecordedDate(row.recordedAt)
                                            })
                                        ]
                                    }, row.id)),
                                !visible.length && /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                        colSpan: 6,
                                        align: "center",
                                        sx: {
                                            fontFamily: "Mulish",
                                            py: 4
                                        },
                                        children: "No talk down messages found."
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wcxl.default), {
                rowsPerPageOptions: [
                    5,
                    10,
                    25
                ],
                component: "div",
                count: rows.length,
                rowsPerPage: rowsPerPage,
                page: page,
                onPageChange: (_e, next)=>onPageChange(next),
                onRowsPerPageChange: (e)=>{
                    onRowsPerPageChange(parseInt(e.target.value, 10));
                    onPageChange(0);
                },
                sx: {
                    fontFamily: "Mulish"
                }
            })
        ]
    });
};



const $5a31bd68b991a0f9$export$d42ebf9a5234ff08 = ({ navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed })=>{
    const messages = (0, $5fe762dced2f1f3d$export$eddecb1f05de5e25)((s)=>s.messages);
    const loadMessages = (0, $5fe762dced2f1f3d$export$eddecb1f05de5e25)((s)=>s.loadMessages);
    const loading = (0, $5fe762dced2f1f3d$export$eddecb1f05de5e25)((s)=>s.loading);
    const loadError = (0, $5fe762dced2f1f3d$export$eddecb1f05de5e25)((s)=>s.loadError);
    const [searchInput, setSearchInput] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [appliedSearch, setAppliedSearch] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [page, setPage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [rowsPerPage, setRowsPerPage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(5);
    const [addOpen, setAddOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [selected, setSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        loadMessages();
    }, [
        loadMessages
    ]);
    const filtered = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>{
        const q = appliedSearch.trim().toLowerCase();
        if (!q) return messages;
        return messages.filter((m)=>m.name.toLowerCase().includes(q) || m.groupName.toLowerCase().includes(q) || m.recordedBy.toLowerCase().includes(q));
    }, [
        messages,
        appliedSearch
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setPage(0);
    }, [
        appliedSearch
    ]);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                openState: loading
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "absolute h-screen w-screen bg-actuate-grey",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: !navBarCollapsed ? "absolute top-[60px] left-[150px] right-[1px] h-[19px]] bg-white" : "absolute top-[60px] left-[75px] right-[1px] h-[19px]] bg-white",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "indent-6 p-3 font-mulish text-[20px] font-black",
                                children: "Talk Down Messages"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                className: "absolute top-[7px] right-[30px]",
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
                                    theme: (0, $faP87.theme),
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                        type: "button",
                                        color: "primary",
                                        onClick: ()=>setAddOpen(true),
                                        children: "+ ADD MESSAGE"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: !navBarCollapsed ? "absolute left-[135px] top-[10px]" : "absolute left-[60px] top-[10px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $c9d4fba0d4c728e8$export$4b85d3515bd863a5), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $c9d4fba0d4c728e8$export$e9ad429a7452907b), {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0f42bd3abae37cbe$exports))), {})
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $c9d4fba0d4c728e8$export$b030dc24f7f252a3), {
                                    value: searchInput,
                                    onChange: (event)=>setSearchInput(event.target.value),
                                    onKeyDown: (event)=>{
                                        if (event.key === "Enter") setAppliedSearch(searchInput);
                                    },
                                    inputProps: {
                                        "aria-label": "search talk down messages"
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: !navBarCollapsed ? "absolute left-[500px] top-[10px]" : "absolute left-[425px] top-[10px]",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                            type: "button",
                            className: "h-[39px] w-[120px] rounded bg-actuate-orange font-mulish text-[16px] text-white shadow-button",
                            onClick: ()=>setAppliedSearch(searchInput),
                            children: "Search"
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        className: !navBarCollapsed ? "absolute left-[150px] top-[130px]" : "absolute left-[75px] top-[130px]",
                        children: [
                            loadError && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "mb-3 font-mulish text-[13px] text-[#B3261E]",
                                children: loadError
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $900a19ae45958a78$export$48cf256b3825f518), {
                                rows: filtered,
                                page: page,
                                rowsPerPage: rowsPerPage,
                                onPageChange: setPage,
                                onRowsPerPageChange: setRowsPerPage,
                                onOpenDetail: setSelected
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $9423b3d41063fd06$export$c1ddb5544e24e8b5), {
                open: addOpen,
                onClose: ()=>setAddOpen(false)
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1a21b6e89c61649b$export$8dfe8443e4368bc0), {
                message: selected,
                onClose: ()=>setSelected(null)
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "justify-start",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jVN1H.NavBar), {
                    navBarCollapsed: navBarCollapsed,
                    setNavBarCollapsed: setNavBarCollapsed,
                    props: {}
                })
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $3QMQN = parcelRequire("3QMQN");
var $eDfvp = parcelRequire("eDfvp");
var $3IuQ3 = parcelRequire("3IuQ3");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");

var $iIAML = parcelRequire("iIAML");

var $jVN1H = parcelRequire("jVN1H");

var $dHtmK = parcelRequire("dHtmK");

var $aYdit = parcelRequire("aYdit");

var $195EM = parcelRequire("195EM");


var $jBpii = parcelRequire("jBpii");

var $iIAML = parcelRequire("iIAML");

var $195EM = parcelRequire("195EM");
const $689ad66d447894bb$var$getRelativeApiPath = (nextUrl)=>{
    if (!nextUrl.startsWith("http")) return nextUrl;
    try {
        const parsedUrl = new URL(nextUrl);
        const apiSplit = parsedUrl.pathname.split("/api/");
        const relativePath = apiSplit[1] || "";
        return `${relativePath}${parsedUrl.search}`;
    } catch  {
        return nextUrl;
    }
};
const $689ad66d447894bb$export$cac4a218a65b6cba = async ()=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const allDevices = [];
    const visitedUrls = new Set();
    let nextUrl = "edge_devices/";
    while(nextUrl){
        const relativeUrl = $689ad66d447894bb$var$getRelativeApiPath(nextUrl);
        if (visitedUrls.has(relativeUrl)) break;
        visitedUrls.add(relativeUrl);
        const response = await AxiosUI.get(relativeUrl);
        allDevices.push(...response.data?.results ?? []);
        nextUrl = response.data?.next ?? null;
    }
    return allDevices;
};
const $689ad66d447894bb$export$6a196bc83ef63016 = (reason)=>{
    const err = reason;
    const message = typeof err.response?.data === "object" && err.response?.data !== null ? err.response.data.error ?? err.response.data.detail : typeof err.response?.data === "string" ? err.response.data : null;
    return message ?? "Failed to get edge device provision token.";
};
const $689ad66d447894bb$export$6755f5e8a0b1541b = async (payload)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const response = await AxiosUI.post("edge_devices/provision-token/", payload);
    return response.data;
};
const $689ad66d447894bb$export$674085d0a29f4ff9 = async ()=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const response = await AxiosUI.get("edge_devices/staging-wireguard-server/");
    const data = response.data;
    if (!data || typeof data.wireguard_server !== "string") return null;
    return {
        ...data,
        pool: Array.isArray(data.pool) ? data.pool : []
    };
};
const $689ad66d447894bb$export$c8e406e352128d33 = async ()=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const response = await AxiosUI.get("edge_devices/bootstrap-scripts/", {
        responseType: "blob"
    });
    const blob = new Blob([
        response.data
    ], {
        type: "application/zip"
    });
    (0, $iIAML.saveAs)(blob, "edge_device_bootstrap.zip");
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $a65wX = parcelRequire("a65wX");
var $kbChx = parcelRequire("kbChx");
var $kUcVg = parcelRequire("kUcVg");
var $887xF = parcelRequire("887xF");
var $1TOOV = parcelRequire("1TOOV");
var $ce8iU = parcelRequire("ce8iU");
var $1SPe4 = parcelRequire("1SPe4");
var $4reBM = parcelRequire("4reBM");
var $k8Qy8 = parcelRequire("k8Qy8");
var $gXvgZ = parcelRequire("gXvgZ");
var $aVDw9 = parcelRequire("aVDw9");
var $3Nm8Z = parcelRequire("3Nm8Z");
var $ha39s = parcelRequire("ha39s");
var $1wcxl = parcelRequire("1wcxl");
var $4o6Cs = parcelRequire("4o6Cs");
var $kLvBh = parcelRequire("kLvBh");
var $eejVe = parcelRequire("eejVe");


var $2zBdB = parcelRequire("2zBdB");
var $1adfa4ec9db0d3a4$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($1adfa4ec9db0d3a4$exports, "__esModule", {
    value: true
});
$1adfa4ec9db0d3a4$exports.default = void 0;

var $1adfa4ec9db0d3a4$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $1adfa4ec9db0d3a4$var$_default = $1adfa4ec9db0d3a4$exports.default = (0, $1adfa4ec9db0d3a4$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8zm2 16H8v-2h8zm0-4H8v-2h8zm-3-5V3.5L18.5 9z"
}), 'Description');


var $48683ccff024d056$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($48683ccff024d056$exports, "__esModule", {
    value: true
});
$48683ccff024d056$exports.default = void 0;

var $48683ccff024d056$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $48683ccff024d056$var$_default = $48683ccff024d056$exports.default = (0, $48683ccff024d056$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z"
}), 'FileUpload');



var $8jTCz = parcelRequire("8jTCz");
const $3f5432f1e85a6ce2$var$FIFTEEN_MINUTES_MS = 900000;
const $3f5432f1e85a6ce2$export$7e4f333133ecc582 = (lastHandshake, nowMs = Date.now())=>{
    if (!lastHandshake) return "Unknown";
    const parsed = new Date(lastHandshake).getTime();
    if (!Number.isFinite(parsed)) return "Unknown";
    return nowMs - parsed <= $3f5432f1e85a6ce2$var$FIFTEEN_MINUTES_MS ? "Up" : "Down";
};


const $2750413bcc00e5b4$var$TABLE_MIN_WIDTH = 1330;
const $2750413bcc00e5b4$var$getStatusStyles = (status)=>{
    if (status === "Up") return {
        backgroundColor: "#e6f4ea",
        color: "#1e7d34",
        dotColor: "#1e7d34"
    };
    if (status === "Down") return {
        backgroundColor: "#fdecec",
        color: "#b3261e",
        dotColor: "#b3261e"
    };
    return {
        backgroundColor: "#eceff3",
        color: "#5f6368",
        dotColor: "#5f6368"
    };
};
const $2750413bcc00e5b4$var$headCells = [
    {
        id: "name",
        label: "Tunnel Name"
    },
    {
        id: "group",
        label: "Group"
    },
    {
        id: "server",
        label: "WireGuard Server"
    },
    {
        id: "client_public_key",
        label: "Public Key"
    },
    {
        id: "client_tunnel_ip",
        label: "Tunnel IP"
    },
    {
        id: "subnet",
        label: "Subnet"
    },
    {
        id: "tunnel_status",
        label: "Status"
    }
];
const $2750413bcc00e5b4$export$e98d2a9d6b1a19f8 = ({ rows: rows, searchText: searchText, onSearchTextChange: onSearchTextChange, page: page, rowsPerPage: rowsPerPage, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, onRowClick: onRowClick, getGroupName: getGroupName, getServerName: getServerName, onDeleteSelectedRows: onDeleteSelectedRows, onDownloadCsvTemplate: onDownloadCsvTemplate, isDownloadingTemplate: isDownloadingTemplate, onBulkUploadClick: onBulkUploadClick, onExportCsv: onExportCsv, isExportingCsv: isExportingCsv, onAddTunnelClick: onAddTunnelClick, canCreateTunnels: canCreateTunnels })=>{
    const [orderBy, setOrderBy] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("name");
    const [order, setOrder] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("asc");
    const [selectedIds, setSelectedIds] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [isDeletingSelected, setIsDeletingSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [bulkDeleteConfirmOpen, setBulkDeleteConfirmOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const sortedRows = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>{
        const sorted = [
            ...rows
        ];
        sorted.sort((first, second)=>{
            let firstValue = "";
            let secondValue = "";
            if (orderBy === "group") {
                firstValue = getGroupName(first.group);
                secondValue = getGroupName(second.group);
            } else if (orderBy === "server") {
                firstValue = getServerName(first.server);
                secondValue = getServerName(second.server);
            } else if (orderBy === "subnet") {
                firstValue = first.subnets?.join(", ") ?? "";
                secondValue = second.subnets?.join(", ") ?? "";
            } else if (orderBy === "tunnel_status") {
                firstValue = (0, $3f5432f1e85a6ce2$export$7e4f333133ecc582)(first.last_handshake);
                secondValue = (0, $3f5432f1e85a6ce2$export$7e4f333133ecc582)(second.last_handshake);
            } else {
                firstValue = first[orderBy] ?? "";
                secondValue = second[orderBy] ?? "";
            }
            if (typeof firstValue === "number" && typeof secondValue === "number") return order === "asc" ? firstValue - secondValue : secondValue - firstValue;
            const compareValue = String(firstValue).localeCompare(String(secondValue));
            return order === "asc" ? compareValue : -compareValue;
        });
        return sorted;
    }, [
        getGroupName,
        getServerName,
        order,
        orderBy,
        rows
    ]);
    const visibleRows = sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    const requestSort = (property)=>{
        const isAscending = orderBy === property && order === "asc";
        setOrder(isAscending ? "desc" : "asc");
        setOrderBy(property);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        const idsInRows = new Set(rows.map((row)=>row.id));
        setSelectedIds((prev)=>prev.filter((id)=>idsInRows.has(id)));
    }, [
        rows
    ]);
    const allVisibleSelected = sortedRows.length > 0 && sortedRows.every((row)=>selectedIds.includes(row.id));
    const selectedCount = selectedIds.length;
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4reBM.default), {
        sx: {
            width: "100%",
            height: "100%",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column"
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3Nm8Z.default), {
                sx: {
                    overflowX: "auto",
                    overflowY: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                    minHeight: 0
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "relative",
                        style: {
                            position: "sticky",
                            top: 0,
                            zIndex: 4,
                            background: "white"
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "px-4 pt-[10px] pb-[10px]",
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "flex items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        size: "small",
                                        placeholder: "Filter by name, IP, subnet, server, group...",
                                        value: searchText,
                                        onChange: (event)=>onSearchTextChange(event.target.value),
                                        sx: {
                                            width: "33%",
                                            minWidth: 340,
                                            maxWidth: 520,
                                            flexShrink: 0,
                                            backgroundColor: "#e9edf2",
                                            "& *": {
                                                fontFamily: "Mulish"
                                            }
                                        },
                                        InputProps: {
                                            startAdornment: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1SPe4.default), {
                                                position: "start",
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0f42bd3abae37cbe$exports))), {
                                                    fontSize: "small"
                                                })
                                            })
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                        className: "ml-auto flex flex-wrap items-center justify-end gap-2",
                                        children: [
                                            canCreateTunnels && selectedCount > 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                                onClick: ()=>setBulkDeleteConfirmOpen(true),
                                                text: isDeletingSelected ? "Deleting..." : "Delete Tunnel",
                                                disabled: isDeletingSelected
                                            }),
                                            canCreateTunnels && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                                        variant: "outlined",
                                                        onClick: onDownloadCsvTemplate,
                                                        disabled: isDownloadingTemplate,
                                                        startIcon: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1adfa4ec9db0d3a4$exports))), {}),
                                                        sx: {
                                                            fontFamily: "Mulish",
                                                            textTransform: "none"
                                                        },
                                                        children: isDownloadingTemplate ? "Downloading..." : "CSV TEMPLATE"
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                                        variant: "outlined",
                                                        onClick: onBulkUploadClick,
                                                        startIcon: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($48683ccff024d056$exports))), {}),
                                                        sx: {
                                                            fontFamily: "Mulish",
                                                            textTransform: "none"
                                                        },
                                                        children: "BULK UPLOAD"
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                                        variant: "outlined",
                                                        onClick: onExportCsv,
                                                        disabled: isExportingCsv,
                                                        startIcon: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2zBdB))), {}),
                                                        sx: {
                                                            fontFamily: "Mulish",
                                                            textTransform: "none"
                                                        },
                                                        children: isExportingCsv ? "Exporting..." : "EXPORT CSV"
                                                    }),
                                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                                        variant: "contained",
                                                        onClick: onAddTunnelClick,
                                                        sx: {
                                                            fontFamily: "Mulish",
                                                            textTransform: "none",
                                                            backgroundColor: "#FF8400",
                                                            "&:hover": {
                                                                backgroundColor: "#E67300"
                                                            }
                                                        },
                                                        children: "+ ADD TUNNEL"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                        sx: {
                            tableLayout: "fixed",
                            width: $2750413bcc00e5b4$var$TABLE_MIN_WIDTH,
                            minWidth: $2750413bcc00e5b4$var$TABLE_MIN_WIDTH,
                            display: "flex",
                            flexDirection: "column",
                            flex: 1,
                            minHeight: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                sx: {
                                    display: "table",
                                    width: $2750413bcc00e5b4$var$TABLE_MIN_WIDTH,
                                    tableLayout: "fixed"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            padding: "checkbox",
                                            sx: {
                                                width: 56
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                size: "small",
                                                checked: allVisibleSelected,
                                                indeterminate: selectedCount > 0 && !allVisibleSelected,
                                                onChange: (event)=>{
                                                    if (event.target.checked) setSelectedIds(sortedRows.map((row)=>row.id));
                                                    else setSelectedIds([]);
                                                },
                                                inputProps: {
                                                    "aria-label": "select all tunnels"
                                                }
                                            })
                                        }),
                                        $2750413bcc00e5b4$var$headCells.map((cell)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    fontWeight: 700
                                                },
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kLvBh.default), {
                                                    active: orderBy === cell.id,
                                                    direction: orderBy === cell.id ? order : "asc",
                                                    onClick: ()=>requestSort(cell.id),
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                        style: {
                                                            fontFamily: "Mulish"
                                                        },
                                                        children: cell.label
                                                    })
                                                })
                                            }, cell.id))
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $gXvgZ.default), {
                                sx: {
                                    display: "block",
                                    overflowY: "auto",
                                    flex: 1,
                                    minHeight: 0,
                                    width: $2750413bcc00e5b4$var$TABLE_MIN_WIDTH
                                },
                                children: [
                                    visibleRows.map((row)=>{
                                        const computedStatus = (0, $3f5432f1e85a6ce2$export$7e4f333133ecc582)(row.last_handshake);
                                        const statusStyles = $2750413bcc00e5b4$var$getStatusStyles(computedStatus);
                                        return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                            hover: true,
                                            onClick: ()=>onRowClick(row),
                                            sx: {
                                                display: "table",
                                                tableLayout: "fixed",
                                                width: $2750413bcc00e5b4$var$TABLE_MIN_WIDTH,
                                                cursor: "pointer",
                                                "&:hover": {
                                                    backgroundColor: "#e3ecfa !important",
                                                    "& .MuiTableCell-root": {
                                                        backgroundColor: "#e3ecfa !important"
                                                    }
                                                }
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    padding: "checkbox",
                                                    onClick: (event)=>event.stopPropagation(),
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                        size: "small",
                                                        checked: selectedIds.includes(row.id),
                                                        onChange: (event)=>{
                                                            const checked = event.target.checked;
                                                            setSelectedIds((prev)=>checked ? [
                                                                    ...prev,
                                                                    row.id
                                                                ] : prev.filter((id)=>id !== row.id));
                                                        },
                                                        inputProps: {
                                                            "aria-label": `select tunnel ${row.name}`
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    sx: {
                                                        fontFamily: "Mulish"
                                                    },
                                                    children: row.name
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    sx: {
                                                        fontFamily: "Mulish"
                                                    },
                                                    children: getGroupName(row.group)
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    sx: {
                                                        fontFamily: "Mulish"
                                                    },
                                                    children: getServerName(row.server)
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    sx: {
                                                        fontFamily: "Mulish"
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                        title: row.client_public_key || "",
                                                        style: {
                                                            display: "block",
                                                            whiteSpace: "normal",
                                                            overflowWrap: "anywhere",
                                                            wordBreak: "break-word",
                                                            lineHeight: 1.25
                                                        },
                                                        children: row.client_public_key || "-"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    sx: {
                                                        fontFamily: "Mulish"
                                                    },
                                                    children: row.client_tunnel_ip || "-"
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    sx: {
                                                        fontFamily: "Mulish"
                                                    },
                                                    children: row.subnets?.length ? row.subnets.join(", ") : "-"
                                                }),
                                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                    sx: {
                                                        fontFamily: "Mulish"
                                                    },
                                                    children: /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                                                        style: {
                                                            display: "inline-flex",
                                                            alignItems: "center",
                                                            gap: 6,
                                                            borderRadius: 999,
                                                            padding: "3px 10px",
                                                            fontFamily: "Mulish",
                                                            fontWeight: 600,
                                                            fontSize: 12,
                                                            backgroundColor: statusStyles.backgroundColor,
                                                            color: statusStyles.color
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                                style: {
                                                                    width: 8,
                                                                    height: 8,
                                                                    borderRadius: "50%",
                                                                    backgroundColor: statusStyles.dotColor,
                                                                    display: "inline-block"
                                                                }
                                                            }),
                                                            computedStatus
                                                        ]
                                                    })
                                                })
                                            ]
                                        }, row.id);
                                    }),
                                    visibleRows.length === 0 && /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            colSpan: 8,
                                            align: "center",
                                            sx: {
                                                display: "table-cell",
                                                fontFamily: "Mulish",
                                                py: 4,
                                                width: "100%"
                                            },
                                            children: "No tunnels match the current filters."
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wcxl.default), {
                rowsPerPageOptions: [
                    10,
                    25,
                    50
                ],
                component: "div",
                count: sortedRows.length,
                rowsPerPage: rowsPerPage,
                page: page,
                onPageChange: onPageChange,
                onRowsPerPageChange: onRowsPerPageChange,
                sx: {
                    borderTop: "1px solid #d1d5db"
                }
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                open: bulkDeleteConfirmOpen,
                onClose: ()=>setBulkDeleteConfirmOpen(false),
                PaperProps: {
                    sx: {
                        "& *": {
                            fontFamily: "Mulish"
                        }
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                        children: "Delete Selected Tunnels?"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
                            style: {
                                fontFamily: "Mulish"
                            },
                            children: [
                                "Are you sure you want to delete ",
                                selectedCount,
                                " selected",
                                " ",
                                selectedCount === 1 ? "tunnel" : "tunnels",
                                "?"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                onClick: ()=>setBulkDeleteConfirmOpen(false),
                                disabled: isDeletingSelected,
                                sx: {
                                    fontFamily: "Mulish",
                                    textTransform: "none"
                                },
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                onClick: async ()=>{
                                    if (isDeletingSelected) return;
                                    setIsDeletingSelected(true);
                                    try {
                                        await onDeleteSelectedRows(selectedIds);
                                        setSelectedIds([]);
                                        setBulkDeleteConfirmOpen(false);
                                    } finally{
                                        setIsDeletingSelected(false);
                                    }
                                },
                                disabled: isDeletingSelected,
                                sx: {
                                    fontFamily: "Mulish",
                                    textTransform: "none",
                                    color: "#d32f2f"
                                },
                                children: isDeletingSelected ? "Deleting..." : "Delete"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");
var $a65wX = parcelRequire("a65wX");
var $1SPe4 = parcelRequire("1SPe4");
var $4reBM = parcelRequire("4reBM");
var $k8Qy8 = parcelRequire("k8Qy8");
var $gXvgZ = parcelRequire("gXvgZ");
var $aVDw9 = parcelRequire("aVDw9");
var $3Nm8Z = parcelRequire("3Nm8Z");
var $ha39s = parcelRequire("ha39s");
var $1wcxl = parcelRequire("1wcxl");
var $4o6Cs = parcelRequire("4o6Cs");
var $kLvBh = parcelRequire("kLvBh");
var $eejVe = parcelRequire("eejVe");

const $2652805b503ba213$var$getWireguardTunnelLabel = (device)=>{
    return device.tunnel?.tunnel_name ?? "";
};
const $2652805b503ba213$export$5943ca1e54075d01 = (devices, searchText)=>{
    const normalizedSearch = searchText.trim().toLowerCase();
    if (!normalizedSearch) return devices;
    return devices.filter((device)=>{
        const searchableValues = [
            device.serial_number,
            device.mac_address,
            device.manufacturer,
            device.sku,
            $2652805b503ba213$var$getWireguardTunnelLabel(device),
            device.provisioning_state
        ];
        return searchableValues.some((value)=>String(value ?? "").toLowerCase().includes(normalizedSearch));
    });
};
const $2652805b503ba213$export$5bb9905dc7b47806 = $2652805b503ba213$var$getWireguardTunnelLabel;


const $e864e642f468f483$var$TABLE_MIN_WIDTH = 1050;
const $e864e642f468f483$var$headCells = [
    {
        id: "serial_number",
        label: "Serial Number"
    },
    {
        id: "mac_address",
        label: "Mac Address"
    },
    {
        id: "manufacturer",
        label: "Manufacturer"
    },
    {
        id: "sku",
        label: "Sku"
    },
    {
        id: "wireguard_tunnel",
        label: "Wireguard Tunnel"
    },
    {
        id: "provisioning_state",
        label: "Provisioning State"
    }
];
const $e864e642f468f483$var$getSortValue = (row, sortKey)=>{
    if (sortKey === "wireguard_tunnel") return (0, $2652805b503ba213$export$5bb9905dc7b47806)(row);
    return String(row[sortKey] ?? "");
};
const $e864e642f468f483$export$c814102b681efe0e = ({ rows: rows, searchText: searchText, onSearchTextChange: onSearchTextChange, page: page, rowsPerPage: rowsPerPage, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, onAddEdgeDeviceClick: onAddEdgeDeviceClick, onRowClick: onRowClick, wireguardTunnels: wireguardTunnels, onOpenWireguardTunnel: onOpenWireguardTunnel })=>{
    const [orderBy, setOrderBy] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("serial_number");
    const [order, setOrder] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("asc");
    const sortedRows = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>{
        const sorted = [
            ...rows
        ];
        sorted.sort((first, second)=>{
            const firstValue = $e864e642f468f483$var$getSortValue(first, orderBy);
            const secondValue = $e864e642f468f483$var$getSortValue(second, orderBy);
            const compareValue = firstValue.localeCompare(secondValue);
            return order === "asc" ? compareValue : -compareValue;
        });
        return sorted;
    }, [
        order,
        orderBy,
        rows
    ]);
    const visibleRows = sortedRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    const requestSort = (property)=>{
        const isAscending = orderBy === property && order === "asc";
        setOrder(isAscending ? "desc" : "asc");
        setOrderBy(property);
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4reBM.default), {
        sx: {
            width: "100%",
            height: "100%",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column"
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3Nm8Z.default), {
                sx: {
                    overflowX: "auto",
                    overflowY: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                    minHeight: 0
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "relative",
                        style: {
                            position: "sticky",
                            top: 0,
                            zIndex: 4,
                            background: "white"
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "px-4 pt-[10px] pb-[10px]",
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                className: "flex items-center gap-3",
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        size: "small",
                                        placeholder: "Filter by serial number, MAC address, manufacturer, tunnel...",
                                        value: searchText,
                                        onChange: (event)=>onSearchTextChange(event.target.value),
                                        sx: {
                                            width: "33%",
                                            minWidth: 340,
                                            maxWidth: 520,
                                            flexShrink: 0,
                                            backgroundColor: "#e9edf2",
                                            "& *": {
                                                fontFamily: "Mulish"
                                            }
                                        },
                                        InputProps: {
                                            startAdornment: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1SPe4.default), {
                                                position: "start",
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($0f42bd3abae37cbe$exports))), {
                                                    fontSize: "small"
                                                })
                                            })
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                        className: "ml-auto flex flex-wrap items-center justify-end gap-2",
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                            variant: "contained",
                                            onClick: onAddEdgeDeviceClick,
                                            sx: {
                                                fontFamily: "Mulish",
                                                textTransform: "none",
                                                backgroundColor: "#FF8400",
                                                "&:hover": {
                                                    backgroundColor: "#E67300"
                                                }
                                            },
                                            children: "+ GENERATE PROVISION TOKEN"
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k8Qy8.default), {
                        sx: {
                            tableLayout: "fixed",
                            width: "100%",
                            minWidth: $e864e642f468f483$var$TABLE_MIN_WIDTH,
                            display: "flex",
                            flexDirection: "column",
                            flex: 1,
                            minHeight: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ha39s.default), {
                                sx: {
                                    display: "table",
                                    width: "100%",
                                    minWidth: $e864e642f468f483$var$TABLE_MIN_WIDTH,
                                    tableLayout: "fixed"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4o6Cs.default), {
                                    children: $e864e642f468f483$var$headCells.map((cell)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontWeight: 700
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kLvBh.default), {
                                                active: orderBy === cell.id,
                                                direction: orderBy === cell.id ? order : "asc",
                                                onClick: ()=>requestSort(cell.id),
                                                children: /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                                                    style: {
                                                        fontFamily: "Mulish"
                                                    },
                                                    children: cell.label
                                                })
                                            })
                                        }, cell.id))
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $gXvgZ.default), {
                                sx: {
                                    display: visibleRows.length === 0 ? "flex" : "block",
                                    alignItems: visibleRows.length === 0 ? "center" : undefined,
                                    justifyContent: visibleRows.length === 0 ? "center" : undefined,
                                    overflowY: "auto",
                                    flex: 1,
                                    minHeight: 0,
                                    width: "100%",
                                    minWidth: $e864e642f468f483$var$TABLE_MIN_WIDTH
                                },
                                children: visibleRows.length === 0 ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                    sx: {
                                        fontFamily: "Mulish",
                                        color: "text.secondary",
                                        px: 2,
                                        textAlign: "center"
                                    },
                                    children: "No edge devices match the current search."
                                }) : visibleRows.map((row)=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $4o6Cs.default), {
                                        hover: true,
                                        onClick: ()=>onRowClick(row),
                                        sx: {
                                            display: "table",
                                            tableLayout: "fixed",
                                            width: "100%",
                                            minWidth: $e864e642f468f483$var$TABLE_MIN_WIDTH,
                                            cursor: "pointer",
                                            "&:hover": {
                                                backgroundColor: "#e3ecfa !important",
                                                "& .MuiTableCell-root": {
                                                    backgroundColor: "#e3ecfa !important"
                                                }
                                            }
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: row.serial_number || "-"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: row.mac_address || "-"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: row.manufacturer || "-"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: row.sku || "-"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: row.tunnel?.tunnel_name || "-"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $aVDw9.default), {
                                                sx: {
                                                    fontFamily: "Mulish"
                                                },
                                                children: row.provisioning_state || "-"
                                            })
                                        ]
                                    }, row.id))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1wcxl.default), {
                rowsPerPageOptions: [
                    10,
                    25,
                    50
                ],
                component: "div",
                count: sortedRows.length,
                rowsPerPage: rowsPerPage,
                page: page,
                onPageChange: onPageChange,
                onRowsPerPageChange: onRowsPerPageChange,
                sx: {
                    borderTop: "1px solid #d1d5db"
                }
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");
var $a65wX = parcelRequire("a65wX");
var $kUcVg = parcelRequire("kUcVg");
var $887xF = parcelRequire("887xF");
var $1TOOV = parcelRequire("1TOOV");
var $ce8iU = parcelRequire("ce8iU");
var $fAJB5 = parcelRequire("fAJB5");

var $eJfrs = parcelRequire("eJfrs");

var $8T3gX = parcelRequire("8T3gX");

var $fdGrT = parcelRequire("fdGrT");

var $iVyaN = parcelRequire("iVyaN");

var $97LlG = parcelRequire("97LlG");

var $aYNpO = parcelRequire("aYNpO");

var $yILjC = parcelRequire("yILjC");

var $kE1sg = parcelRequire("kE1sg");


var $4reBM = parcelRequire("4reBM");

var $iMOmE = parcelRequire("iMOmE");

var $4nWZ9 = parcelRequire("4nWZ9");

var $7AQZl = parcelRequire("7AQZl");

var $anJSP = parcelRequire("anJSP");
var $3dQcH = parcelRequire("3dQcH");

var $jh2Zm = parcelRequire("jh2Zm");

var $kfTYv = parcelRequire("kfTYv");
function $61e4466367f9f676$export$b801318a856c9cd2(slot) {
    return (0, $kfTYv.default)('MuiDrawer', slot);
}
const $61e4466367f9f676$var$drawerClasses = (0, $jh2Zm.default)('MuiDrawer', [
    'root',
    'docked',
    'paper',
    'paperAnchorLeft',
    'paperAnchorRight',
    'paperAnchorTop',
    'paperAnchorBottom',
    'paperAnchorDockedLeft',
    'paperAnchorDockedRight',
    'paperAnchorDockedTop',
    'paperAnchorDockedBottom',
    'modal'
]);
var $61e4466367f9f676$export$2e2bcd8739ae039 = $61e4466367f9f676$var$drawerClasses;



var $k4ank = parcelRequire("k4ank");
'use client';
const $14dd0c4334b54826$var$_excluded = [
    "BackdropProps"
], $14dd0c4334b54826$var$_excluded2 = [
    "anchor",
    "BackdropProps",
    "children",
    "className",
    "elevation",
    "hideBackdrop",
    "ModalProps",
    "onClose",
    "open",
    "PaperProps",
    "SlideProps",
    "TransitionComponent",
    "transitionDuration",
    "variant"
];
const $14dd0c4334b54826$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked,
        styles.modal
    ];
};
const $14dd0c4334b54826$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchor: anchor, variant: variant } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        docked: [
            (variant === 'permanent' || variant === 'persistent') && 'docked'
        ],
        modal: [
            'modal'
        ],
        paper: [
            'paper',
            `paperAnchor${(0, $iMOmE.default)(anchor)}`,
            variant !== 'temporary' && `paperAnchorDocked${(0, $iMOmE.default)(anchor)}`
        ]
    };
    return (0, $aYNpO.default)(slots, (0, $61e4466367f9f676$export$b801318a856c9cd2), classes);
};
const $14dd0c4334b54826$var$DrawerRoot = (0, $anJSP.default)((0, $kE1sg.default), {
    name: 'MuiDrawer',
    slot: 'Root',
    overridesResolver: $14dd0c4334b54826$var$overridesResolver
})(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.drawer
    }));
const $14dd0c4334b54826$var$DrawerDockedRoot = (0, $anJSP.default)('div', {
    shouldForwardProp: (0, $3dQcH.default),
    name: 'MuiDrawer',
    slot: 'Docked',
    skipVariantsResolver: false,
    overridesResolver: $14dd0c4334b54826$var$overridesResolver
})({
    flex: '0 0 auto'
});
const $14dd0c4334b54826$var$DrawerPaper = (0, $anJSP.default)((0, $4reBM.default), {
    name: 'MuiDrawer',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`paperAnchor${(0, $iMOmE.default)(ownerState.anchor)}`],
            ownerState.variant !== 'temporary' && styles[`paperAnchorDocked${(0, $iMOmE.default)(ownerState.anchor)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eJfrs.default)({
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        flex: '1 0 auto',
        zIndex: (theme.vars || theme).zIndex.drawer,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        // temporary style
        position: 'fixed',
        top: 0,
        // We disable the focus ring for mouse, touch and keyboard users.
        // At some point, it would be better to keep it for keyboard users.
        // :focus-ring CSS pseudo-class will help.
        outline: 0
    }, ownerState.anchor === 'left' && {
        left: 0
    }, ownerState.anchor === 'top' && {
        top: 0,
        left: 0,
        right: 0,
        height: 'auto',
        maxHeight: '100%'
    }, ownerState.anchor === 'right' && {
        right: 0
    }, ownerState.anchor === 'bottom' && {
        top: 'auto',
        left: 0,
        bottom: 0,
        right: 0,
        height: 'auto',
        maxHeight: '100%'
    }, ownerState.anchor === 'left' && ownerState.variant !== 'temporary' && {
        borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === 'top' && ownerState.variant !== 'temporary' && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === 'right' && ownerState.variant !== 'temporary' && {
        borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary' && {
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
const $14dd0c4334b54826$var$oppositeDirection = {
    left: 'right',
    right: 'left',
    top: 'down',
    bottom: 'up'
};
function $14dd0c4334b54826$export$2a62b49acb270576(anchor) {
    return [
        'left',
        'right'
    ].indexOf(anchor) !== -1;
}
function $14dd0c4334b54826$export$830f4f08342d299e({ direction: direction }, anchor) {
    return direction === 'rtl' && $14dd0c4334b54826$export$2a62b49acb270576(anchor) ? $14dd0c4334b54826$var$oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ const $14dd0c4334b54826$var$Drawer = /*#__PURE__*/ $8T3gX.forwardRef(function Drawer(inProps, ref) {
    const props = (0, $7AQZl.useDefaultProps)({
        props: inProps,
        name: 'MuiDrawer'
    });
    const theme = (0, $4nWZ9.default)();
    const isRtl = (0, $yILjC.useRtl)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchorProp = 'left', BackdropProps: BackdropProps, children: children, className: className, elevation: elevation = 16, hideBackdrop: hideBackdrop = false, ModalProps: { BackdropProps: BackdropPropsProp } = {}, onClose: onClose, open: open = false, PaperProps: PaperProps = {}, SlideProps: SlideProps, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $212a5a6a44b7f18e$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, variant: variant = 'temporary' } = props, ModalProps = (0, $fAJB5.default)(props.ModalProps, $14dd0c4334b54826$var$_excluded), other = (0, $fAJB5.default)(props, $14dd0c4334b54826$var$_excluded2);
    // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    const mounted = $8T3gX.useRef(false);
    $8T3gX.useEffect(()=>{
        mounted.current = true;
    }, []);
    const anchorInvariant = $14dd0c4334b54826$export$830f4f08342d299e({
        direction: isRtl ? 'rtl' : 'ltr'
    }, anchorProp);
    const anchor = anchorProp;
    const ownerState = (0, $eJfrs.default)({}, props, {
        anchor: anchor,
        elevation: elevation,
        open: open,
        variant: variant
    }, other);
    const classes = $14dd0c4334b54826$var$useUtilityClasses(ownerState);
    const drawer = /*#__PURE__*/ (0, $k4ank.jsx)($14dd0c4334b54826$var$DrawerPaper, (0, $eJfrs.default)({
        elevation: variant === 'temporary' ? elevation : 0,
        square: true
    }, PaperProps, {
        className: (0, $iVyaN.default)(classes.paper, PaperProps.className),
        ownerState: ownerState,
        children: children
    }));
    if (variant === 'permanent') return /*#__PURE__*/ (0, $k4ank.jsx)($14dd0c4334b54826$var$DrawerDockedRoot, (0, $eJfrs.default)({
        className: (0, $iVyaN.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: drawer
    }));
    const slidingDrawer = /*#__PURE__*/ (0, $k4ank.jsx)(TransitionComponent, (0, $eJfrs.default)({
        in: open,
        direction: $14dd0c4334b54826$var$oppositeDirection[anchorInvariant],
        timeout: transitionDuration,
        appear: mounted.current
    }, SlideProps, {
        children: drawer
    }));
    if (variant === 'persistent') return /*#__PURE__*/ (0, $k4ank.jsx)($14dd0c4334b54826$var$DrawerDockedRoot, (0, $eJfrs.default)({
        className: (0, $iVyaN.default)(classes.root, classes.docked, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: slidingDrawer
    }));
    // variant === temporary
    return /*#__PURE__*/ (0, $k4ank.jsx)($14dd0c4334b54826$var$DrawerRoot, (0, $eJfrs.default)({
        BackdropProps: (0, $eJfrs.default)({}, BackdropProps, BackdropPropsProp, {
            transitionDuration: transitionDuration
        }),
        className: (0, $iVyaN.default)(classes.root, classes.modal, className),
        open: open,
        ownerState: ownerState,
        onClose: onClose,
        hideBackdrop: hideBackdrop,
        ref: ref
    }, other, ModalProps, {
        children: slidingDrawer
    }));
});
$14dd0c4334b54826$var$Drawer.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * Side from which the drawer will appear.
   * @default 'left'
   */ anchor: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'bottom',
        'left',
        'right',
        'top'
    ]),
    /**
   * @ignore
   */ BackdropProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The content of the component.
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * @ignore
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).string,
    /**
   * The elevation of the drawer.
   * @default 16
   */ elevation: (0, $97LlG.default),
    /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */ hideBackdrop: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Props applied to the [`Modal`](/material-ui/api/modal/) element.
   * @default {}
   */ ModalProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
    /**
   * If `true`, the component is shown.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool,
    /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   * @default {}
   */ PaperProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * Props applied to the [`Slide`](/material-ui/api/slide/) element.
   */ SlideProps: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).object
    ]),
    /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */ transitionDuration: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).shape({
            appear: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            enter: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number,
            exit: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).number
        })
    ]),
    /**
   * The variant to use.
   * @default 'temporary'
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fdGrT))).oneOf([
        'permanent',
        'persistent',
        'temporary'
    ])
};
var $14dd0c4334b54826$export$2e2bcd8739ae039 = $14dd0c4334b54826$var$Drawer;


var $9qNow = parcelRequire("9qNow");
var $3IuQ3 = parcelRequire("3IuQ3");
var $eejVe = parcelRequire("eejVe");
var $f3puC = parcelRequire("f3puC");


var $195EM = parcelRequire("195EM");
/**
 * Error text a person can act on (ENG-2002).
 *
 * The admin API answers an expired session with a 403 whose body is
 * "Returned invalid token from cache" (or "Token is expired", …). Dialogs that
 * show the server's own text verbatim then tell a customer to "review the
 * values", which sends them looking for a mistake that isn't there (SUP-683).
 * Use `withAuthRetry` around the request so an expired session is renewed and
 * the request re-run; use `userFacingApiError` for whatever still fails.
 */ 
const $7fb4182fb89b8c6f$export$e24ee863ba9f5d24 = "Your session has expired. Reload the page and sign in again, then retry.";
const $7fb4182fb89b8c6f$export$69e48a0c77f82dfa = async (request)=>{
    try {
        return await request();
    } catch (reason) {
        if (!(0, $0e37e3988da6d6c9$export$9b76211583236161)(reason)) throw reason;
        const renewed = await (0, $0e37e3988da6d6c9$export$5eec284f74fc084e)();
        if (!renewed) throw reason;
        return request();
    }
};
/** The server's `error` / `detail` text, or the body when it's a string, else null. */ const $7fb4182fb89b8c6f$var$serverMessage = (reason)=>{
    const data = reason?.response?.data;
    if (typeof data === "string") return data || null;
    if (data && typeof data === "object") {
        const { error: error, detail: detail } = data;
        if (typeof error === "string" && error) return error;
        if (typeof detail === "string" && detail) return detail;
    }
    return null;
};
const $7fb4182fb89b8c6f$export$d829f44e03865f01 = (reason, fallback = null)=>{
    if ((0, $0e37e3988da6d6c9$export$9b76211583236161)(reason)) return $7fb4182fb89b8c6f$export$e24ee863ba9f5d24;
    return $7fb4182fb89b8c6f$var$serverMessage(reason) ?? fallback;
};


const $95782dc726d1b648$var$Row = ({ label: label, value: value })=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                sx: {
                    fontFamily: "Mulish",
                    fontSize: 12,
                    color: "#5f6368"
                },
                children: label
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                sx: {
                    fontFamily: "Mulish",
                    fontSize: 14,
                    overflowWrap: "anywhere"
                },
                children: value
            })
        ]
    });
const $95782dc726d1b648$var$ExpandableHelperText = ({ text: text })=>{
    const [expanded, setExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
        className: "font-mulish text-[12px] text-[#6B7280]",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                style: {
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: expanded ? "unset" : 1,
                    overflow: "hidden"
                },
                children: text
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                type: "button",
                className: "font-mulish mt-1 p-0 text-[12px] text-[#283E6D] underline",
                onClick: ()=>setExpanded((prev)=>!prev),
                children: expanded ? "Show less" : "Read more"
            })
        ]
    });
};
const $95782dc726d1b648$export$baf953c4fc3dcc5b = ({ open: open, selectedTunnel: selectedTunnel, onClose: onClose, getGroupName: getGroupName, getServerName: getServerName, getServerPublicKey: getServerPublicKey, onTunnelPatched: onTunnelPatched, onTunnelDeleted: onTunnelDeleted, canCreateTunnels: canCreateTunnels })=>{
    const [isEditMode, setIsEditMode] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [isSaving, setIsSaving] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [isDeleting, setIsDeleting] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [saveError, setSaveError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [editValues, setEditValues] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        name: "",
        serverId: "",
        groupId: "",
        clientPublicKey: "",
        clientTunnelIp: "",
        subnets: "",
        subnetsVirtuallyAssigned: false
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!selectedTunnel) {
            setIsEditMode(false);
            setEditValues({
                name: "",
                serverId: "",
                groupId: "",
                clientPublicKey: "",
                clientTunnelIp: "",
                subnets: "",
                subnetsVirtuallyAssigned: false
            });
            return;
        }
        setIsEditMode(false);
        setEditValues({
            name: selectedTunnel.name || "",
            serverId: selectedTunnel.server !== null && selectedTunnel.server !== undefined ? String(selectedTunnel.server) : "",
            groupId: selectedTunnel.group !== null && selectedTunnel.group !== undefined ? String(selectedTunnel.group) : "",
            clientPublicKey: selectedTunnel.client_public_key || "",
            clientTunnelIp: selectedTunnel.client_tunnel_ip || "",
            subnets: selectedTunnel.subnets?.join(", ") || "",
            subnetsVirtuallyAssigned: Boolean(selectedTunnel.subnets_are_virtually_assigned)
        });
    }, [
        selectedTunnel
    ]);
    const handleCancelEdit = ()=>{
        if (!selectedTunnel) {
            setIsEditMode(false);
            return;
        }
        setEditValues({
            name: selectedTunnel.name || "",
            serverId: selectedTunnel.server !== null && selectedTunnel.server !== undefined ? String(selectedTunnel.server) : "",
            groupId: selectedTunnel.group !== null && selectedTunnel.group !== undefined ? String(selectedTunnel.group) : "",
            clientPublicKey: selectedTunnel.client_public_key || "",
            clientTunnelIp: selectedTunnel.client_tunnel_ip || "",
            subnets: selectedTunnel.subnets?.join(", ") || "",
            subnetsVirtuallyAssigned: Boolean(selectedTunnel.subnets_are_virtually_assigned)
        });
        setSaveError("");
        setIsEditMode(false);
    };
    const handleDrawerClose = ()=>{
        setIsEditMode(false);
        setDeleteConfirmOpen(false);
        setSaveError("");
        onClose();
    };
    const handleSaveChanges = async ()=>{
        if (!selectedTunnel) return;
        const hasRelevantChanges = editValues.name !== (selectedTunnel.name || "") || editValues.clientPublicKey !== (selectedTunnel.client_public_key || "");
        if (!hasRelevantChanges) {
            setSaveError("");
            setIsEditMode(false);
            return;
        }
        setIsSaving(true);
        setSaveError("");
        const baseErrorMessage = "Unable to save tunnel changes.";
        try {
            await (0, $7fb4182fb89b8c6f$export$69e48a0c77f82dfa)(()=>(0, $195EM.createApi)("").patch(`wireguard_tunnel/${selectedTunnel.id}/`, {
                    name: editValues.name,
                    client_public_key: editValues.clientPublicKey
                }));
            await onTunnelPatched(selectedTunnel.id);
            setIsEditMode(false);
        } catch (reason) {
            const apiErrorMessage = (0, $7fb4182fb89b8c6f$export$d829f44e03865f01)(reason);
            setSaveError(apiErrorMessage ? `${baseErrorMessage} ${apiErrorMessage}` : baseErrorMessage);
        } finally{
            setIsSaving(false);
        }
    };
    const handleDeleteTunnel = async ()=>{
        if (!selectedTunnel) return;
        setIsDeleting(true);
        setSaveError("");
        const baseErrorMessage = "Unable to delete tunnel.";
        try {
            await (0, $7fb4182fb89b8c6f$export$69e48a0c77f82dfa)(()=>(0, $195EM.createApi)("").delete(`wireguard_tunnel/${selectedTunnel.id}/`));
            await onTunnelDeleted(selectedTunnel.id);
            handleDrawerClose();
        } catch (reason) {
            const apiErrorMessage = (0, $7fb4182fb89b8c6f$export$d829f44e03865f01)(reason);
            setSaveError(apiErrorMessage ? `${baseErrorMessage} ${apiErrorMessage}` : baseErrorMessage);
        } finally{
            setIsDeleting(false);
        }
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $14dd0c4334b54826$export$2e2bcd8739ae039), {
        anchor: "right",
        open: open,
        onClose: handleDrawerClose,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                sx: {
                    width: 420,
                    p: 3
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3IuQ3.default), {
                        direction: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                sx: {
                                    fontFamily: "Mulish",
                                    fontSize: 22,
                                    fontWeight: 700
                                },
                                children: "Tunnel Details"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3IuQ3.default), {
                                direction: "row",
                                gap: 1,
                                children: [
                                    !isEditMode && canCreateTunnels && /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                        onClick: ()=>setIsEditMode(true),
                                        startIcon: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($34f136bbfa236f69$exports))), {}),
                                        sx: {
                                            fontFamily: "Mulish",
                                            textTransform: "none"
                                        },
                                        disabled: !selectedTunnel,
                                        children: "Edit"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                        onClick: handleDrawerClose,
                                        sx: {
                                            fontFamily: "Mulish",
                                            textTransform: "none"
                                        },
                                        children: "Close"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $c092706b06a9e6ab$export$2e2bcd8739ae039), {
                        sx: {
                            my: 2
                        }
                    }),
                    selectedTunnel ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3IuQ3.default), {
                        gap: 3,
                        children: [
                            isEditMode ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)($95782dc726d1b648$var$Row, {
                                        label: "Group",
                                        value: getGroupName(selectedTunnel.group)
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)($95782dc726d1b648$var$Row, {
                                        label: "WireGuard Server",
                                        value: getServerName(selectedTunnel.server)
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)($95782dc726d1b648$var$Row, {
                                        label: "Server Public Key",
                                        value: getServerPublicKey(selectedTunnel.server)
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)($95782dc726d1b648$var$Row, {
                                        label: "Status",
                                        value: selectedTunnel.tunnel_status || "unknown"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        variant: "standard",
                                        label: "Name",
                                        value: editValues.name,
                                        onChange: (event)=>setEditValues((prev)=>({
                                                    ...prev,
                                                    name: event.target.value
                                                })),
                                        sx: {
                                            "& *": {
                                                fontFamily: "Mulish"
                                            }
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        variant: "standard",
                                        label: "Client Public Key",
                                        multiline: true,
                                        minRows: 2,
                                        maxRows: 2,
                                        value: editValues.clientPublicKey,
                                        helperText: "WireGuard client public key (must be unique)",
                                        onChange: (event)=>setEditValues((prev)=>({
                                                    ...prev,
                                                    clientPublicKey: event.target.value
                                                })),
                                        sx: {
                                            "& *": {
                                                fontFamily: "Mulish"
                                            },
                                            "& .MuiInputBase-inputMultiline": {
                                                overflowWrap: "anywhere",
                                                wordBreak: "break-all"
                                            }
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)($95782dc726d1b648$var$Row, {
                                        label: "Client Tunnel IP",
                                        value: selectedTunnel.client_tunnel_ip || "-"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)($95782dc726d1b648$var$Row, {
                                        label: "Subnets",
                                        value: selectedTunnel.subnets?.join(", ") || "-"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)($95782dc726d1b648$var$Row, {
                                        label: "Virtually Assign Subnets",
                                        value: selectedTunnel.subnets_are_virtually_assigned ? "Yes" : "No"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)($95782dc726d1b648$var$Row, {
                                        label: "Last Handshake",
                                        value: selectedTunnel.last_handshake ? new Date(selectedTunnel.last_handshake).toLocaleString() : "Never"
                                    }),
                                    saveError && /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                                        sx: {
                                            color: "#d32f2f",
                                            fontFamily: "Mulish"
                                        },
                                        children: saveError
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)($95782dc726d1b648$var$Row, {
                                        label: "Tunnel Name",
                                        value: selectedTunnel.name
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)($95782dc726d1b648$var$Row, {
                                        label: "Group",
                                        value: getGroupName(selectedTunnel.group)
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)($95782dc726d1b648$var$Row, {
                                        label: "WireGuard Server",
                                        value: getServerName(selectedTunnel.server)
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)($95782dc726d1b648$var$Row, {
                                        label: "Server Public Key",
                                        value: getServerPublicKey(selectedTunnel.server)
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)($95782dc726d1b648$var$Row, {
                                        label: "Status",
                                        value: selectedTunnel.tunnel_status || "unknown"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)($95782dc726d1b648$var$Row, {
                                        label: "Client Public Key",
                                        value: selectedTunnel.client_public_key || "-"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)($95782dc726d1b648$var$Row, {
                                        label: "Client Tunnel IP",
                                        value: selectedTunnel.client_tunnel_ip || "-"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)($95782dc726d1b648$var$Row, {
                                        label: "Subnets",
                                        value: selectedTunnel.subnets?.join(", ") || "-"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)($95782dc726d1b648$var$Row, {
                                        label: "Last Handshake",
                                        value: selectedTunnel.last_handshake ? new Date(selectedTunnel.last_handshake).toLocaleString() : "Never"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3IuQ3.default), {
                                direction: "row",
                                gap: 1,
                                justifyContent: "flex-end",
                                pt: 2,
                                children: [
                                    !isEditMode && canCreateTunnels && /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                        variant: "outlined",
                                        onClick: ()=>setDeleteConfirmOpen(true),
                                        disabled: isDeleting,
                                        sx: {
                                            fontFamily: "Mulish",
                                            textTransform: "none",
                                            borderColor: "#d32f2f",
                                            color: "#d32f2f"
                                        },
                                        children: isDeleting ? "Deleting..." : "Delete"
                                    }),
                                    isEditMode && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                                variant: "outlined",
                                                onClick: handleCancelEdit,
                                                disabled: isSaving || isDeleting,
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    textTransform: "none"
                                                },
                                                children: "Cancel"
                                            }),
                                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                                variant: "contained",
                                                onClick: handleSaveChanges,
                                                disabled: isSaving || isDeleting,
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    textTransform: "none",
                                                    backgroundColor: "#FF8400",
                                                    "&:hover": {
                                                        backgroundColor: "#E67300"
                                                    }
                                                },
                                                children: isSaving ? "Saving..." : "Save Changes"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            fontFamily: "Mulish"
                        },
                        children: "Select a tunnel to view details."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                open: deleteConfirmOpen,
                onClose: ()=>setDeleteConfirmOpen(false),
                PaperProps: {
                    sx: {
                        "& *": {
                            fontFamily: "Mulish"
                        }
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                        children: "Delete Tunnel?"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                            sx: {
                                fontFamily: "Mulish"
                            },
                            children: "Are you sure you want to delete this tunnel?"
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                onClick: ()=>setDeleteConfirmOpen(false),
                                disabled: isDeleting,
                                sx: {
                                    fontFamily: "Mulish",
                                    textTransform: "none"
                                },
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                onClick: async ()=>{
                                    await handleDeleteTunnel();
                                },
                                disabled: isDeleting,
                                sx: {
                                    fontFamily: "Mulish",
                                    textTransform: "none",
                                    color: "#d32f2f"
                                },
                                children: isDeleting ? "Deleting..." : "Delete"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");
var $kbChx = parcelRequire("kbChx");
var $3baw3 = parcelRequire("3baw3");
var $2SHRA = parcelRequire("2SHRA");
var $4reBM = parcelRequire("4reBM");
var $f3puC = parcelRequire("f3puC");

var $8jTCz = parcelRequire("8jTCz");
const $ada58adb1b934745$var$defaultFilters = {
    groupIds: [],
    serverIds: [],
    tunnelStatuses: [],
    subnetVirtuallyAssigned: "all",
    searchText: ""
};
const $ada58adb1b934745$export$7e432690f6224add = ({ filters: filters, setFilters: setFilters, parentAccounts: parentAccounts, wireGuardOptions: wireGuardOptions, tunnelStatuses: tunnelStatuses })=>{
    const toggleNumberFilter = (key, value, checked)=>{
        setFilters((prev)=>({
                ...prev,
                [key]: checked ? [
                    value
                ] : []
            }));
    };
    const toggleStatusFilter = (value, checked)=>{
        setFilters((prev)=>({
                ...prev,
                tunnelStatuses: checked ? [
                    value
                ] : []
            }));
    };
    const setSubnetVirtuallyAssignedFilter = (value)=>{
        setFilters((prev)=>({
                ...prev,
                subnetVirtuallyAssigned: value
            }));
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4reBM.default), {
        sx: {
            width: 340,
            minWidth: 340,
            height: "100%",
            maxHeight: "100%",
            px: 2,
            pb: 2,
            pt: 0,
            borderRadius: 2,
            borderTop: "1px solid #d1d5db",
            overflowY: "auto",
            fontFamily: "Mulish"
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 0.5,
                sx: {
                    position: "sticky",
                    top: 0,
                    zIndex: 2,
                    backgroundColor: "white",
                    pt: 1,
                    pb: 0.5,
                    height: 46,
                    borderBottom: "1px solid #d1d5db"
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: 700,
                            fontSize: 14
                        },
                        children: "FILTERS"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                        sx: {
                            transform: "scale(0.82)",
                            transformOrigin: "right center",
                            mr: "-10px"
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            onClick: ()=>setFilters($ada58adb1b934745$var$defaultFilters),
                            text: "Reset",
                            disabled: false
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                display: "flex",
                flexDirection: "column",
                gap: 2,
                pt: 1,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                sx: {
                                    fontFamily: "Mulish",
                                    fontWeight: 700,
                                    fontSize: 15
                                },
                                children: "Group"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $2SHRA.default), {
                                sx: {
                                    maxHeight: 180,
                                    overflowY: "auto"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                        sx: {
                                            m: 0
                                        },
                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                            checked: filters.groupIds.length === 0,
                                            onChange: ()=>setFilters((prev)=>({
                                                        ...prev,
                                                        groupIds: []
                                                    })),
                                            size: "small"
                                        }),
                                        label: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontSize: 14
                                            },
                                            children: "All Groups"
                                        })
                                    }),
                                    parentAccounts.map((account)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                            sx: {
                                                m: 0
                                            },
                                            control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                checked: filters.groupIds.includes(account.id),
                                                onChange: (event)=>toggleNumberFilter("groupIds", account.id, event.target.checked),
                                                size: "small"
                                            }),
                                            label: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    fontSize: 14
                                                },
                                                children: account.name
                                            })
                                        }, account.id))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $c092706b06a9e6ab$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                sx: {
                                    fontFamily: "Mulish",
                                    fontWeight: 700,
                                    fontSize: 15
                                },
                                children: "WireGuard Server"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $2SHRA.default), {
                                sx: {
                                    maxHeight: 280,
                                    overflowY: "auto"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                        sx: {
                                            m: 0
                                        },
                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                            checked: filters.serverIds.length === 0,
                                            onChange: ()=>setFilters((prev)=>({
                                                        ...prev,
                                                        serverIds: []
                                                    })),
                                            size: "small"
                                        }),
                                        label: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontSize: 14
                                            },
                                            children: "All Servers"
                                        })
                                    }),
                                    wireGuardOptions.map((option)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                            sx: {
                                                m: 0
                                            },
                                            control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                checked: filters.serverIds.includes(option.id),
                                                onChange: (event)=>toggleNumberFilter("serverIds", option.id, event.target.checked),
                                                size: "small"
                                            }),
                                            label: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    fontSize: 14
                                                },
                                                children: option.name
                                            })
                                        }, option.id))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $c092706b06a9e6ab$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                sx: {
                                    fontFamily: "Mulish",
                                    fontWeight: 700,
                                    fontSize: 15
                                },
                                children: "Tunnel Status"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $2SHRA.default), {
                                sx: {
                                    maxHeight: 180,
                                    overflowY: "auto"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                        sx: {
                                            m: 0
                                        },
                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                            checked: filters.tunnelStatuses.length === 0,
                                            onChange: ()=>setFilters((prev)=>({
                                                        ...prev,
                                                        tunnelStatuses: []
                                                    })),
                                            size: "small"
                                        }),
                                        label: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontSize: 14
                                            },
                                            children: "All"
                                        })
                                    }),
                                    tunnelStatuses.map((status)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                            sx: {
                                                m: 0
                                            },
                                            control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                checked: filters.tunnelStatuses.includes(status),
                                                onChange: (event)=>toggleStatusFilter(status, event.target.checked),
                                                size: "small"
                                            }),
                                            label: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                                sx: {
                                                    fontFamily: "Mulish",
                                                    fontSize: 14
                                                },
                                                children: status
                                            })
                                        }, status))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $c092706b06a9e6ab$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                sx: {
                                    fontFamily: "Mulish",
                                    fontWeight: 700,
                                    fontSize: 15
                                },
                                children: "Subnet Virtually Assigned"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $2SHRA.default), {
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                        sx: {
                                            m: 0
                                        },
                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                            checked: filters.subnetVirtuallyAssigned !== "yes" && filters.subnetVirtuallyAssigned !== "no",
                                            onChange: ()=>setSubnetVirtuallyAssignedFilter("all"),
                                            size: "small"
                                        }),
                                        label: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontSize: 14
                                            },
                                            children: "All"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                        sx: {
                                            m: 0
                                        },
                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                            checked: filters.subnetVirtuallyAssigned === "yes",
                                            onChange: ()=>setSubnetVirtuallyAssignedFilter("yes"),
                                            size: "small"
                                        }),
                                        label: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontSize: 14
                                            },
                                            children: "Yes"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                        sx: {
                                            m: 0
                                        },
                                        control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                            checked: filters.subnetVirtuallyAssigned === "no",
                                            onChange: ()=>setSubnetVirtuallyAssignedFilter("no"),
                                            size: "small"
                                        }),
                                        label: /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontSize: 14
                                            },
                                            children: "No"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $60vL1 = parcelRequire("60vL1");
var $kUcVg = parcelRequire("kUcVg");
var $887xF = parcelRequire("887xF");
var $1TOOV = parcelRequire("1TOOV");
var $ce8iU = parcelRequire("ce8iU");
var $9qNow = parcelRequire("9qNow");
var $1SPe4 = parcelRequire("1SPe4");
var $eejVe = parcelRequire("eejVe");

var $kbChx = parcelRequire("kbChx");

var $3baw3 = parcelRequire("3baw3");

var $8jTCz = parcelRequire("8jTCz");

var $195EM = parcelRequire("195EM");


var $3JJWq = parcelRequire("3JJWq");
const $5501f060781801f3$export$bc43bfddfdede5fd = ()=>{
    const groups = (0, $3JJWq.safeGetItem)("parentGroups", []) ?? [];
    return Array.isArray(groups) ? groups.filter((group)=>group && typeof group.id === "number" && Boolean(group.name)) : [];
};
const $5501f060781801f3$export$27bc9adcc62e620c = (groups)=>[
        ...groups
    ].sort((a, b)=>a.name.localeCompare(b.name));
const $5501f060781801f3$export$db4f2674d92cb641 = (groups)=>{
    if (groups.length === 0) return null;
    const accessibleIds = new Set(groups.map((group)=>group.id));
    const roots = groups.filter((group)=>group.parent == null || !accessibleIds.has(group.parent));
    // No root at all means the cached rows are cyclic or partial; fall back to the
    // whole list rather than leaving the field empty.
    const candidates = roots.length > 0 ? roots : groups;
    return [
        ...candidates
    ].sort((a, b)=>{
        if (a.parent_account !== b.parent_account) return a.parent_account ? -1 : 1;
        return a.name.localeCompare(b.name);
    })[0];
};


const $5d81cbf7fbf7732e$var$ExpandableHelperText = ({ text: text })=>{
    const [expanded, setExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    return /*#__PURE__*/ (0, $k4ank.jsxs)("span", {
        className: "font-mulish text-[12px] text-[#6B7280]",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                style: {
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: expanded ? "unset" : 1,
                    overflow: "hidden"
                },
                children: text
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                type: "button",
                className: "font-mulish mt-1 p-0 text-[12px] text-[#283E6D] underline",
                onClick: ()=>setExpanded((prev)=>!prev),
                children: expanded ? "Show less" : "Read more"
            })
        ]
    });
};
const $5d81cbf7fbf7732e$var$parseSubnetsInput = (subnetsInput)=>{
    const trimmed = subnetsInput.trim();
    if (!trimmed) return [];
    if (trimmed.startsWith("[") && trimmed.endsWith("]")) try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) return parsed.map((item)=>typeof item === "string" ? item.trim() : "").filter(Boolean);
    } catch  {
    // Fall through to comma-separated parsing.
    }
    return trimmed.split(",").map((value)=>value.trim().replace(/^\[/, "").replace(/\]$/, "").replace(/^['"]/, "").replace(/['"]$/, "")).filter(Boolean);
};
const $5d81cbf7fbf7732e$var$SERVER_SELECTION_HELPER_TEXT = {
    site_affinity: "Matches the group's existing tunnels",
    round_robin: "Assigned by round robin across zones",
    fallback: "No round-robin pool configured"
};
const $5d81cbf7fbf7732e$var$initialFormState = {
    wireguard_server: "",
    group_id: "",
    name: "",
    client_public_key: "",
    client_tunnel_ip: "",
    subnets: "",
    subnets_are_virtually_assigned: false
};
const $5d81cbf7fbf7732e$export$4572b13546aff4b0 = ({ open: open, onClose: onClose, onTunnelCreated: onTunnelCreated, wireGuardOptions: wireGuardOptions, accessibleGroups: accessibleGroups })=>{
    const sortedGroups = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>(0, $5501f060781801f3$export$27bc9adcc62e620c)(accessibleGroups), [
        accessibleGroups
    ]);
    const sortedServerOptions = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>[
            ...wireGuardOptions
        ].sort((a, b)=>a.name.localeCompare(b.name)), [
        wireGuardOptions
    ]);
    const [formState, setFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState($5d81cbf7fbf7732e$var$initialFormState);
    // Once the operator picks a server themselves, the round-robin suggestion must
    // stop overwriting it — including when they then change the group.
    const [serverTouched, setServerTouched] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [serverSelection, setServerSelection] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [submitting, setSubmitting] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [isClientTunnelIpLoading, setIsClientTunnelIpLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [cameraCount, setCameraCount] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [cidrPrefixLength, setCidrPrefixLength] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("24");
    const [isSuggestingSubnet, setIsSuggestingSubnet] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [subnetSuggestionError, setSubnetSuggestionError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [showFailureDialog, setShowFailureDialog] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [failureErrorMessage, setFailureErrorMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!open) return;
        let isMounted = true;
        const AxiosUI = (0, $195EM.createApi)("");
        setIsClientTunnelIpLoading(true);
        setSubnetSuggestionError(null);
        // Group is required (ENG-272) and defaults to the top of the user's tree.
        const defaultGroup = (0, $5501f060781801f3$export$db4f2674d92cb641)(accessibleGroups);
        setFormState((prev)=>({
                ...prev,
                group_id: prev.group_id || (defaultGroup ? String(defaultGroup.id) : "")
            }));
        AxiosUI.get("wireguard_tunnel/suggest-next-client-ip/").then((response)=>{
            if (!isMounted || !response?.data?.client_tunnel_ip) return;
            setFormState((prev)=>({
                    ...prev,
                    client_tunnel_ip: response.data.client_tunnel_ip || ""
                }));
        }).catch(()=>{
        // Allow manual entry if suggestion endpoint fails.
        }).finally(()=>{
            if (isMounted) setIsClientTunnelIpLoading(false);
        });
        return ()=>{
            isMounted = false;
        };
    }, [
        open,
        accessibleGroups
    ]);
    // ENG-273: the server default comes from the backend, which round-robins across
    // the *-2 zones by how many tunnels the group's top parent account already owns
    // and overrides that with the group's existing zone when it has one. Re-asked
    // whenever the group changes, since the answer depends on it.
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!open || serverTouched || !formState.group_id) return;
        let isMounted = true;
        const AxiosUI = (0, $195EM.createApi)("");
        AxiosUI.get(`wireguard_tunnel/suggest-server/?group_id=${encodeURIComponent(formState.group_id)}`).then((response)=>{
            if (!isMounted || !response?.data?.wireguard_server) return;
            setFormState((prev)=>({
                    ...prev,
                    wireguard_server: response.data.wireguard_server || ""
                }));
            setServerSelection(response.data.selection ?? null);
        }).catch(()=>{
            // Keep the dialog usable if the suggestion endpoint is unavailable: fall
            // back to the first server so the field is never left blank.
            if (!isMounted) return;
            setFormState((prev)=>({
                    ...prev,
                    wireguard_server: prev.wireguard_server || (sortedServerOptions[0]?.name ?? "")
                }));
            setServerSelection(null);
        });
        return ()=>{
            isMounted = false;
        };
    }, [
        open,
        serverTouched,
        formState.group_id,
        sortedServerOptions
    ]);
    const resetStateAndClose = ()=>{
        setFormState($5d81cbf7fbf7732e$var$initialFormState);
        setSubmitting(false);
        setServerTouched(false);
        setServerSelection(null);
        setCameraCount("");
        setCidrPrefixLength("24");
        setSubnetSuggestionError(null);
        setFailureErrorMessage(null);
        setShowFailureDialog(false);
        onClose();
    };
    const handleSuggestNextSubnet = async ()=>{
        const AxiosUI = (0, $195EM.createApi)("");
        setSubnetSuggestionError(null);
        setIsSuggestingSubnet(true);
        try {
            const trimmedCameraCount = cameraCount.trim();
            const trimmedPrefixLength = cidrPrefixLength.trim().replace("/", "");
            const queryParam = trimmedCameraCount ? `camera_count=${encodeURIComponent(trimmedCameraCount)}` : `prefix_length=${encodeURIComponent(trimmedPrefixLength || "24")}`;
            const response = await AxiosUI.get(`wireguard_tunnel/suggest-next-subnet/?${queryParam}`);
            const suggestedSubnet = response?.data?.subnet;
            if (!suggestedSubnet) {
                setSubnetSuggestionError("Unable to suggest a subnet right now.");
                return;
            }
            setFormState((prev)=>({
                    ...prev,
                    subnets: `["${suggestedSubnet}"]`
                }));
        } catch  {
            setSubnetSuggestionError("Unable to suggest a subnet right now.");
        } finally{
            setIsSuggestingSubnet(false);
        }
    };
    const handleSubmit = async ()=>{
        const payload = {
            name: formState.name.trim(),
            wireguard_server: formState.wireguard_server,
            group_id: formState.group_id ? Number(formState.group_id) : undefined,
            client_public_key: formState.client_public_key.trim(),
            client_tunnel_ip: formState.client_tunnel_ip.trim() || undefined,
            subnets: $5d81cbf7fbf7732e$var$parseSubnetsInput(formState.subnets),
            subnets_are_virtually_assigned: formState.subnets_are_virtually_assigned
        };
        setSubmitting(true);
        try {
            // The client is built inside the request so a session renewed by
            // withAuthRetry is what the retry sends (ENG-2002).
            await (0, $7fb4182fb89b8c6f$export$69e48a0c77f82dfa)(()=>(0, $195EM.createApi)("").post("wireguard_tunnel/", payload));
            await onTunnelCreated();
            resetStateAndClose();
        } catch (reason) {
            setFailureErrorMessage((0, $7fb4182fb89b8c6f$export$d829f44e03865f01)(reason));
            setShowFailureDialog(true);
        } finally{
            setSubmitting(false);
        }
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                open: open,
                onClose: resetStateAndClose,
                fullWidth: true,
                maxWidth: "sm",
                "aria-labelledby": "add-wireguard-tunnel-title",
                sx: {
                    "& *": {
                        fontFamily: "Mulish"
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                        id: "add-wireguard-tunnel-title",
                        sx: {
                            fontFamily: "Mulish",
                            fontWeight: 700,
                            color: "#283E6D"
                        },
                        children: "Add WireGuard Tunnel"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                        dividers: true,
                        sx: {
                            px: 4,
                            py: 3
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "flex flex-col gap-5",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eejVe.default), {
                                    id: "wireguard_server",
                                    select: true,
                                    SelectProps: {
                                        native: true
                                    },
                                    value: formState.wireguard_server,
                                    label: "WireGuard Server",
                                    required: true,
                                    helperText: serverSelection ? $5d81cbf7fbf7732e$var$SERVER_SELECTION_HELPER_TEXT[serverSelection] ?? undefined : undefined,
                                    onChange: (event)=>{
                                        // Captured before the updater runs: React restores the controlled
                                        // input's DOM value first, so a lazy read returns the old value.
                                        const selectedServer = event.target.value;
                                        setServerTouched(true);
                                        setServerSelection(null);
                                        setFormState((prev)=>({
                                                ...prev,
                                                wireguard_server: selectedServer
                                            }));
                                    },
                                    variant: "standard",
                                    sx: {
                                        width: "100%",
                                        "& *": {
                                            fontFamily: "Mulish"
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("option", {
                                            "aria-label": "None",
                                            value: ""
                                        }),
                                        sortedServerOptions.map((option)=>/*#__PURE__*/ (0, $k4ank.jsx)("option", {
                                                value: option.name,
                                                children: option.name
                                            }, option.id))
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                                    id: "group_id",
                                    options: sortedGroups,
                                    value: sortedGroups.find((group)=>String(group.id) === formState.group_id) || null,
                                    onChange: (_, value)=>{
                                        if (!value) // disableClearable keeps this from firing once a group is set;
                                        // ignoring an empty change means the field can never go blank.
                                        return;
                                        setFormState((prev)=>({
                                                ...prev,
                                                group_id: String(value.id)
                                            }));
                                    },
                                    getOptionLabel: (option)=>option.name || "",
                                    isOptionEqualToValue: (option, value)=>option.id === value.id,
                                    disableClearable: Boolean(formState.group_id),
                                    renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                            ...params,
                                            label: "Group",
                                            required: true,
                                            helperText: "*Required \u2014 the tunnel is only visible to users of this group",
                                            variant: "standard",
                                            sx: {
                                                width: "100%",
                                                "& *": {
                                                    fontFamily: "Mulish"
                                                }
                                            }
                                        })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                    id: "wireguard_name",
                                    value: formState.name,
                                    variant: "standard",
                                    label: "Name",
                                    required: true,
                                    onChange: (event)=>{
                                        // Captured eagerly: read inside the updater it comes back
                                        // stale under fireEvent/act(), so the field can't be
                                        // exercised in tests. Identical behaviour in the browser.
                                        const nextValue = event.target.value;
                                        setFormState((prev)=>({
                                                ...prev,
                                                name: nextValue
                                            }));
                                    },
                                    sx: {
                                        width: "100%",
                                        "& *": {
                                            fontFamily: "Mulish"
                                        }
                                    },
                                    type: "string"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                    id: "client_public_key",
                                    value: formState.client_public_key,
                                    variant: "standard",
                                    label: "Client Public Key",
                                    required: true,
                                    helperText: "WireGuard client public key (must be unique)",
                                    onChange: (event)=>{
                                        // Captured eagerly: read inside the updater it comes back
                                        // stale under fireEvent/act(), so the field can't be
                                        // exercised in tests. Identical behaviour in the browser.
                                        const nextValue = event.target.value;
                                        setFormState((prev)=>({
                                                ...prev,
                                                client_public_key: nextValue
                                            }));
                                    },
                                    sx: {
                                        width: "100%",
                                        "& *": {
                                            fontFamily: "Mulish"
                                        }
                                    },
                                    type: "string"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                    id: "client_tunnel_ip",
                                    value: formState.client_tunnel_ip,
                                    variant: "standard",
                                    label: "Client Tunnel IP",
                                    helperText: /*#__PURE__*/ (0, $k4ank.jsx)($5d81cbf7fbf7732e$var$ExpandableHelperText, {
                                        text: "Client tunnel IP address (must end with /32, e.g., '10.0.0.1/32'). By default this is pre-populated with the first available IP from the pool, but you can change it if the client already has one assigned."
                                    }),
                                    disabled: isClientTunnelIpLoading,
                                    InputProps: {
                                        endAdornment: isClientTunnelIpLoading ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $1SPe4.default), {
                                            position: "end",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                                size: 16
                                            })
                                        }) : undefined
                                    },
                                    onChange: (event)=>setFormState((prev)=>({
                                                ...prev,
                                                client_tunnel_ip: event.target.value
                                            })),
                                    sx: {
                                        width: "100%",
                                        "& *": {
                                            fontFamily: "Mulish"
                                        }
                                    },
                                    type: "string"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                    value: formState.subnets,
                                    label: "Subnets",
                                    multiline: true,
                                    minRows: 2,
                                    onChange: (event)=>setFormState((prev)=>({
                                                ...prev,
                                                subnets: event.target.value
                                            })),
                                    sx: {
                                        width: "100%",
                                        "& *": {
                                            fontFamily: "Mulish"
                                        }
                                    },
                                    helperText: /*#__PURE__*/ (0, $k4ank.jsx)($5d81cbf7fbf7732e$var$ExpandableHelperText, {
                                        text: `The range of IP addresses on the customer's local network, in CIDR format (e.g., ["192.168.1.0/24"]). If the NVR/recording server is on the same machine as the WireGuard client, you can leave this empty. If the cameras are on a different IP range (e.g., the client routes traffic across their network), enter the local subnet(s) where their cameras live. Always use the smallest subnet that covers the required hosts - a /32 for a single IP is better than a /24 for an entire block.`
                                    })
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "flex gap-4 pl-12",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                            value: cameraCount,
                                            label: "Approx camera count",
                                            type: "number",
                                            onChange: (event)=>{
                                                setSubnetSuggestionError(null);
                                                setCameraCount(event.target.value);
                                            },
                                            placeholder: "-",
                                            sx: {
                                                width: "220px",
                                                "& *": {
                                                    fontFamily: "Mulish"
                                                }
                                            },
                                            helperText: "Leave blank if unknown"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                            value: cidrPrefixLength,
                                            label: "CIDR size",
                                            type: "number",
                                            onChange: (event)=>{
                                                setSubnetSuggestionError(null);
                                                setCidrPrefixLength(event.target.value);
                                            },
                                            sx: {
                                                width: "120px",
                                                "& *": {
                                                    fontFamily: "Mulish"
                                                }
                                            },
                                            InputProps: {
                                                startAdornment: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1SPe4.default), {
                                                    position: "start",
                                                    children: "/"
                                                })
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                                    className: "pl-12",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                        onClick: handleSuggestNextSubnet,
                                        text: isSuggestingSubnet ? "Suggesting..." : "Suggest Next Subnet",
                                        disabled: isSuggestingSubnet
                                    })
                                }),
                                subnetSuggestionError && /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                                    className: "font-mulish mt-1 text-red-600",
                                    role: "alert",
                                    children: subnetSuggestionError
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                            sx: {
                                                fontFamily: "Mulish",
                                                color: "#001943"
                                            },
                                            label: "Virtually Assign Subnets",
                                            control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $kbChx.default), {
                                                color: "primary",
                                                checked: formState.subnets_are_virtually_assigned,
                                                onChange: (_, checked)=>setFormState((prev)=>({
                                                            ...prev,
                                                            subnets_are_virtually_assigned: checked
                                                        }))
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)($5d81cbf7fbf7732e$var$ExpandableHelperText, {
                                                text: `Check this if the customer's real subnet overlaps with an existing tunnel's subnet. When enabled, the customer sets up DNAT/SNAT on their side to translate traffic to a virtual IP range, and you enter that virtual range in the Subnets field above. This avoids routing conflicts while keeping both tunnels operational.`
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                        sx: {
                            p: 2,
                            px: 4
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: resetStateAndClose,
                                text: "Cancel",
                                disabled: submitting
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: handleSubmit,
                                text: submitting ? "Submitting..." : "Submit",
                                disabled: submitting || !formState.wireguard_server || !formState.group_id || !formState.name.trim() || !formState.client_public_key.trim()
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                open: showFailureDialog,
                onClose: ()=>{
                    setShowFailureDialog(false);
                    setFailureErrorMessage(null);
                },
                "aria-labelledby": "wireguard-failure-dialog-title",
                sx: {
                    "& *": {
                        fontFamily: "Mulish"
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                        id: "wireguard-failure-dialog-title",
                        sx: {
                            fontFamily: "Mulish"
                        },
                        children: "WireGuard configuration could not be saved"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $1TOOV.default), {
                        sx: {
                            fontFamily: "Mulish"
                        },
                        children: [
                            failureErrorMessage && /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "font-mulish mb-3 text-[14px] text-red-600",
                                role: "alert",
                                children: failureErrorMessage
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                children: "Please review the values and try again."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), {
                        sx: {
                            px: 2,
                            pb: 2
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            onClick: ()=>{
                                setShowFailureDialog(false);
                                setFailureErrorMessage(null);
                            },
                            text: "Try Again",
                            disabled: false
                        })
                    })
                ]
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");
var $60vL1 = parcelRequire("60vL1");
var $kUcVg = parcelRequire("kUcVg");
var $887xF = parcelRequire("887xF");
var $1TOOV = parcelRequire("1TOOV");
var $ce8iU = parcelRequire("ce8iU");
var $9qNow = parcelRequire("9qNow");
var $iKAtE = parcelRequire("iKAtE");
var $eejVe = parcelRequire("eejVe");

var $433j1 = parcelRequire("433j1");

var $8jTCz = parcelRequire("8jTCz");


var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");
var $60vL1 = parcelRequire("60vL1");
var $9qNow = parcelRequire("9qNow");
var $iKAtE = parcelRequire("iKAtE");
var $8E01L = parcelRequire("8E01L");
var $cVCJe = parcelRequire("cVCJe");
var $f3puC = parcelRequire("f3puC");

var $3QMQN = parcelRequire("3QMQN");

var $8iD8e = parcelRequire("8iD8e");

var $8jTCz = parcelRequire("8jTCz");

const $4c10df7bb36c725d$var$DEFAULT_HOST = "<router-wan-ip>";
const $4c10df7bb36c725d$var$DEFAULT_SSH_USER = "root";
// Both scripts refuse to run without a server, so never drop the flag.
const $4c10df7bb36c725d$var$DEFAULT_WIREGUARD_SERVER = "<wireguard-server>";
// Same key as media/scripts/edge_device_provision_command.js in actuate_admin.
// The backend round-robin only advances when stage omits wireguard_server, and
// the scripts always send it, so rotation has to happen where the command is built.
const $4c10df7bb36c725d$var$WIREGUARD_ROUND_ROBIN_KEY = "edge_device_staging_wg_rr_idx";
const $4c10df7bb36c725d$var$readRoundRobinIndex = ()=>{
    try {
        return parseInt(localStorage.getItem($4c10df7bb36c725d$var$WIREGUARD_ROUND_ROBIN_KEY) || "0", 10) || 0;
    } catch  {
        return 0;
    }
};
const $4c10df7bb36c725d$export$9276e4d0c997e064 = (pool)=>{
    if (!pool.length) return "";
    const idx = ($4c10df7bb36c725d$var$readRoundRobinIndex() % pool.length + pool.length) % pool.length;
    return pool[idx];
};
const $4c10df7bb36c725d$export$16a47a80fdd2e8e2 = (pool, used)=>{
    const usedIdx = pool.indexOf(used);
    if (usedIdx < 0) return;
    try {
        localStorage.setItem($4c10df7bb36c725d$var$WIREGUARD_ROUND_ROBIN_KEY, String((usedIdx + 1) % pool.length));
    } catch  {
    // ignore quota / private mode
    }
};
const $4c10df7bb36c725d$var$resolveOptions = (options)=>({
        host: options.routerWanIp.trim() || $4c10df7bb36c725d$var$DEFAULT_HOST,
        sshUser: options.sshUser.trim() || $4c10df7bb36c725d$var$DEFAULT_SSH_USER,
        wireguardServer: options.wireguardServer.trim() || $4c10df7bb36c725d$var$DEFAULT_WIREGUARD_SERVER,
        cameraSubnet: options.cameraLocalSubnet.trim()
    });
const $4c10df7bb36c725d$export$6c6c013bd9c5b38c = (provisionToken, options)=>{
    const { host: host, sshUser: sshUser, wireguardServer: wireguardServer, cameraSubnet: cameraSubnet } = $4c10df7bb36c725d$var$resolveOptions(options);
    const args = [
        `--host ${host}`,
        `--ssh-user ${sshUser}`,
        "--ask-pass",
        `--provision-token '${provisionToken}'`,
        `--wireguard-server ${wireguardServer}`,
        "--use-virtual-subnets"
    ];
    if (cameraSubnet) args.push(`--camera-local-subnet ${cameraSubnet}`);
    let command = `unzip actuate-edge-device-bootstrap.zip\n\n./provision-wireguard.sh \\\n  ${args.join(" \\\n  ")}`;
    if (!cameraSubnet) command += "\n\n# Cameras on WAN/upstream (not network.lan) \u2014 NETMAP local side:\n#   --camera-local-subnet 192.168.0.0/24";
    return command;
};
const $4c10df7bb36c725d$export$bda1f9fba2a72b9f = (provisionToken, options)=>{
    const { host: host, sshUser: sshUser, wireguardServer: wireguardServer, cameraSubnet: cameraSubnet } = $4c10df7bb36c725d$var$resolveOptions(options);
    const args = [
        `-RouterHost ${host}`,
        `-SshUser ${sshUser}`,
        `-ProvisionToken '${provisionToken}'`,
        `-WireguardServer ${wireguardServer}`,
        "-UseVirtualSubnets"
    ];
    if (cameraSubnet) args.push(`-CameraLocalSubnet ${cameraSubnet}`);
    let command = `.\\provision-wireguard.ps1 \`\n  ${args.join(" `\n  ")}`;
    if (!cameraSubnet) command += "\n\n# Cameras on WAN/upstream (not network.lan):\n#   -CameraLocalSubnet 192.168.0.0/24";
    return command;
};



const $eb2943098b0586f2$var$fallbackCopyToClipboard = async (value)=>{
    const textArea = document.createElement("textarea");
    textArea.value = value;
    textArea.setAttribute("readonly", "");
    textArea.style.position = "absolute";
    textArea.style.left = "-9999px";
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
};
const $eb2943098b0586f2$var$copyTextToClipboard = async (value)=>{
    if (navigator.clipboard?.writeText) await navigator.clipboard.writeText(value);
    else await $eb2943098b0586f2$var$fallbackCopyToClipboard(value);
};
const $eb2943098b0586f2$var$CommandBlock = ({ title: title, command: command, copyLabel: copyLabel, onCopy: onCopy })=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
        sx: {
            display: "flex",
            flexDirection: "column",
            gap: 0.5
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                className: "font-mulish text-[14px] font-bold text-[#001943]",
                children: title
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                sx: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1,
                    border: "1px solid #E5E5E5",
                    borderRadius: "4px",
                    p: 1.5,
                    backgroundColor: "#F8F8F8"
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                        component: "pre",
                        sx: {
                            flex: 1,
                            m: 0,
                            fontFamily: "monospace",
                            fontSize: 13,
                            whiteSpace: "pre-wrap",
                            overflowWrap: "anywhere"
                        },
                        children: command
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                        title: "Copy to clipboard",
                        arrow: true,
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                            "aria-label": copyLabel,
                            onClick: ()=>onCopy(command),
                            size: "small",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8iD8e))), {
                                fontSize: "small"
                            })
                        })
                    })
                ]
            })
        ]
    });
const $eb2943098b0586f2$export$3d820d8994bf36d = ({ provisionResponse: provisionResponse, isDownloadingBootstrap: isDownloadingBootstrap, bootstrapDownloadError: bootstrapDownloadError, onDownloadBootstrapZip: onDownloadBootstrapZip, showBootstrapDownload: showBootstrapDownload = true, commandOptions: commandOptions })=>{
    const [copiedOpen, setCopiedOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [copiedMessage, setCopiedMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("Token copied to clipboard");
    const handleCopyCommand = async (value)=>{
        try {
            await $eb2943098b0586f2$var$copyTextToClipboard(value);
            setCopiedMessage("Command copied to clipboard");
            setCopiedOpen(true);
        } catch  {
        // no-op, user can retry
        }
    };
    const formattedExpiresAt = provisionResponse.expires_at ? (0, $c5c2eb0780a90a39$export$39bc600700bd9d9)(provisionResponse.expires_at) : "";
    const handleCopyToken = async ()=>{
        if (!provisionResponse.provision_token) return;
        try {
            await $eb2943098b0586f2$var$copyTextToClipboard(provisionResponse.provision_token);
            setCopiedMessage("Token copied to clipboard");
            setCopiedOpen(true);
        } catch  {
        // no-op, user can retry
        }
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                className: "font-mulish text-[16px] text-[#001943]",
                children: [
                    "Here is your Provision Token, which will be active until ",
                    formattedExpiresAt,
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                sx: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1,
                    border: "1px solid #E5E5E5",
                    borderRadius: "4px",
                    p: 1.5
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                        component: "span",
                        sx: {
                            flex: 1,
                            fontFamily: "monospace",
                            fontSize: 14,
                            overflowWrap: "anywhere",
                            wordBreak: "break-all"
                        },
                        children: provisionResponse.provision_token
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                        title: "Copy to clipboard",
                        arrow: true,
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                            "aria-label": "copy provision token to clipboard",
                            onClick: handleCopyToken,
                            size: "small",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8iD8e))), {
                                fontSize: "small"
                            })
                        })
                    })
                ]
            }),
            showBootstrapDownload && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: onDownloadBootstrapZip,
                        text: isDownloadingBootstrap ? "Downloading..." : "Download Bootstrap ZIP",
                        disabled: isDownloadingBootstrap
                    }),
                    bootstrapDownloadError && /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                        className: "font-mulish text-red-600",
                        role: "alert",
                        children: bootstrapDownloadError
                    })
                ]
            }),
            commandOptions && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "font-mulish text-[16px] text-[#001943]",
                        children: "Run one of these commands from the unzipped bootstrap scripts:"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)($eb2943098b0586f2$var$CommandBlock, {
                        title: "Provision (Linux / macOS)",
                        command: (0, $4c10df7bb36c725d$export$6c6c013bd9c5b38c)(provisionResponse.provision_token, commandOptions),
                        copyLabel: "copy Linux / macOS provision command to clipboard",
                        onCopy: handleCopyCommand
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)($eb2943098b0586f2$var$CommandBlock, {
                        title: "Provision (Windows PowerShell)",
                        command: (0, $4c10df7bb36c725d$export$bda1f9fba2a72b9f)(provisionResponse.provision_token, commandOptions),
                        copyLabel: "copy Windows PowerShell provision command to clipboard",
                        onCopy: handleCopyCommand
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8E01L.default), {
                open: copiedOpen,
                autoHideDuration: 4000,
                onClose: ()=>setCopiedOpen(false),
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                    elevation: 6,
                    variant: "filled",
                    severity: "success",
                    onClose: ()=>setCopiedOpen(false),
                    sx: {
                        width: "100%",
                        fontFamily: "Mulish"
                    },
                    children: copiedMessage
                })
            })
        ]
    });
};
const $eb2943098b0586f2$export$d9cf8efebf623bd8 = ({ serialNumber: serialNumber, macAddress: macAddress })=>{
    const [provisionResponse, setProvisionResponse] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [isGenerating, setIsGenerating] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [errorMessage, setErrorMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [isDownloadingBootstrap, setIsDownloadingBootstrap] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [bootstrapDownloadError, setBootstrapDownloadError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const trimmedSerial = serialNumber.trim();
    const trimmedMac = macAddress.trim();
    const canGenerate = Boolean(trimmedSerial || trimmedMac);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setProvisionResponse(null);
        setErrorMessage("");
        setIsGenerating(false);
        setBootstrapDownloadError("");
    }, [
        serialNumber,
        macAddress
    ]);
    const handleGenerateToken = async ()=>{
        setErrorMessage("");
        setIsGenerating(true);
        try {
            const response = await (0, $689ad66d447894bb$export$6755f5e8a0b1541b)({
                serial_number: trimmedSerial,
                mac_address: trimmedMac
            });
            setProvisionResponse(response);
        } catch (reason) {
            setErrorMessage((0, $689ad66d447894bb$export$6a196bc83ef63016)(reason));
        } finally{
            setIsGenerating(false);
        }
    };
    const handleDownloadBootstrapZip = async ()=>{
        setBootstrapDownloadError("");
        setIsDownloadingBootstrap(true);
        try {
            await (0, $689ad66d447894bb$export$c8e406e352128d33)();
        } catch  {
            setBootstrapDownloadError("Failed to download bootstrap ZIP.");
        } finally{
            setIsDownloadingBootstrap(false);
        }
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
        sx: {
            display: "flex",
            flexDirection: "column",
            gap: 2
        },
        children: [
            isGenerating ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 2,
                    py: 2
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                        size: 32
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            fontFamily: "Mulish",
                            fontSize: 16,
                            color: "#001943"
                        },
                        children: "Getting Edge Device token..."
                    })
                ]
            }) : provisionResponse ? /*#__PURE__*/ (0, $k4ank.jsx)($eb2943098b0586f2$export$3d820d8994bf36d, {
                provisionResponse: provisionResponse,
                isDownloadingBootstrap: isDownloadingBootstrap,
                bootstrapDownloadError: bootstrapDownloadError,
                onDownloadBootstrapZip: handleDownloadBootstrapZip,
                showBootstrapDownload: false
            }) : /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: handleGenerateToken,
                        text: "Generate Provisional Token (15 mins)",
                        disabled: !canGenerate
                    }),
                    errorMessage && /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                        className: "font-mulish text-red-600",
                        role: "alert",
                        children: errorMessage
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                onClick: handleDownloadBootstrapZip,
                text: isDownloadingBootstrap ? "Downloading..." : "Download Bootstrap ZIP",
                disabled: isDownloadingBootstrap
            }),
            bootstrapDownloadError && /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                className: "font-mulish text-red-600",
                role: "alert",
                children: bootstrapDownloadError
            })
        ]
    });
};



const $445fc6405cd0298a$var$DEFAULT_SSH_USER = "root";
const $445fc6405cd0298a$export$886d99f87703aa90 = ({ open: open, onClose: onClose })=>{
    const [step, setStep] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("form");
    const [serialNumber, setSerialNumber] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [macAddress, setMacAddress] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [routerWanIp, setRouterWanIp] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [sshUser, setSshUser] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState($445fc6405cd0298a$var$DEFAULT_SSH_USER);
    const [cameraLocalSubnet, setCameraLocalSubnet] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [wireguardServer, setWireguardServer] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [wireguardPool, setWireguardPool] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [wireguardPoolFailed, setWireguardPoolFailed] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [commandOptions, setCommandOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [provisionResponse, setProvisionResponse] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [errorMessage, setErrorMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [isDownloadingBootstrap, setIsDownloadingBootstrap] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [bootstrapDownloadError, setBootstrapDownloadError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!open) return;
        let cancelled = false;
        (0, $689ad66d447894bb$export$674085d0a29f4ff9)().then((result)=>{
            if (cancelled || !result) return;
            // A pinned server comes back with an empty pool: it is the only choice.
            const pool = result.pool.length ? result.pool : [
                result.wireguard_server
            ].filter(Boolean);
            setWireguardPool(pool);
            setWireguardServer((current)=>current || (0, $4c10df7bb36c725d$export$9276e4d0c997e064)(pool));
        }).catch(()=>{
            // Commands fall back to a <wireguard-server> placeholder.
            if (!cancelled) setWireguardPoolFailed(true);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        open
    ]);
    const resetStateAndClose = ()=>{
        setStep("form");
        setSerialNumber("");
        setMacAddress("");
        setRouterWanIp("");
        setSshUser($445fc6405cd0298a$var$DEFAULT_SSH_USER);
        setCameraLocalSubnet("");
        // Preselect the next zone now (the index advanced on submit) so the select
        // never shows a zone it isn't holding while the pool is re-fetched.
        setWireguardServer((0, $4c10df7bb36c725d$export$9276e4d0c997e064)(wireguardPool));
        setCommandOptions(null);
        setProvisionResponse(null);
        setErrorMessage("");
        setIsDownloadingBootstrap(false);
        setBootstrapDownloadError("");
        onClose();
    };
    const handleClose = ()=>{
        if (step === "loading") return;
        resetStateAndClose();
    };
    const handleSubmit = async ()=>{
        setErrorMessage("");
        setStep("loading");
        try {
            const response = await (0, $689ad66d447894bb$export$6755f5e8a0b1541b)({
                serial_number: serialNumber.trim(),
                mac_address: macAddress.trim()
            });
            (0, $4c10df7bb36c725d$export$16a47a80fdd2e8e2)(wireguardPool, wireguardServer);
            setCommandOptions({
                routerWanIp: routerWanIp,
                sshUser: sshUser,
                cameraLocalSubnet: cameraLocalSubnet,
                wireguardServer: wireguardServer
            });
            setProvisionResponse(response);
            setStep("success");
        } catch (reason) {
            setErrorMessage((0, $689ad66d447894bb$export$6a196bc83ef63016)(reason));
            setStep("form");
        }
    };
    const handleDownloadBootstrapZip = async ()=>{
        setBootstrapDownloadError("");
        setIsDownloadingBootstrap(true);
        try {
            await (0, $689ad66d447894bb$export$c8e406e352128d33)();
        } catch  {
            setBootstrapDownloadError("Failed to download bootstrap ZIP.");
        } finally{
            setIsDownloadingBootstrap(false);
        }
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: open,
        onClose: handleClose,
        fullWidth: true,
        maxWidth: "sm",
        "aria-labelledby": "add-edge-device-title",
        sx: {
            "& *": {
                fontFamily: "Mulish"
            }
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "add-edge-device-title",
                sx: {
                    fontFamily: "Mulish",
                    fontWeight: 700,
                    color: "#001943",
                    pr: 6
                },
                children: "Generate Provision Token"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                "aria-label": "close add edge device dialog",
                onClick: handleClose,
                disabled: step === "loading",
                sx: {
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme)=>theme.palette.grey[500]
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
            }),
            step === "loading" ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                dividers: true,
                sx: {
                    px: 4,
                    py: 6
                },
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                    sx: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 2
                    },
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                            size: 32
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                            className: "font-mulish text-[16px] text-[#001943]",
                            children: "Getting Edge Device token..."
                        })
                    ]
                })
            }) : step === "success" && provisionResponse ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                        dividers: true,
                        sx: {
                            px: 4,
                            py: 3
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            className: "flex flex-col gap-4",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eb2943098b0586f2$export$3d820d8994bf36d), {
                                provisionResponse: provisionResponse,
                                isDownloadingBootstrap: isDownloadingBootstrap,
                                bootstrapDownloadError: bootstrapDownloadError,
                                onDownloadBootstrapZip: handleDownloadBootstrapZip,
                                commandOptions: commandOptions ?? undefined
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), {
                        sx: {
                            p: 2,
                            px: 4
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            onClick: resetStateAndClose,
                            text: "Finish",
                            disabled: false
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                        dividers: true,
                        sx: {
                            px: 4,
                            py: 3
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                            className: "flex flex-col gap-5",
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                    id: "edge_device_serial_number",
                                    value: serialNumber,
                                    variant: "standard",
                                    label: "Serial number",
                                    required: true,
                                    onChange: (event)=>setSerialNumber(event.target.value),
                                    sx: {
                                        width: "100%",
                                        "& *": {
                                            fontFamily: "Mulish"
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                    id: "edge_device_mac_address",
                                    value: macAddress,
                                    variant: "standard",
                                    label: "MAC address",
                                    onChange: (event)=>setMacAddress(event.target.value),
                                    sx: {
                                        width: "100%",
                                        "& *": {
                                            fontFamily: "Mulish"
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                    id: "edge_device_router_wan_ip",
                                    value: routerWanIp,
                                    variant: "standard",
                                    label: "Router current WAN IP (optional)",
                                    onChange: (event)=>setRouterWanIp(event.target.value),
                                    sx: {
                                        width: "100%",
                                        "& *": {
                                            fontFamily: "Mulish"
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                    id: "edge_device_ssh_user",
                                    value: sshUser,
                                    variant: "standard",
                                    label: "SSH user",
                                    onChange: (event)=>setSshUser(event.target.value),
                                    sx: {
                                        width: "100%",
                                        "& *": {
                                            fontFamily: "Mulish"
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                    id: "edge_device_camera_local_subnet",
                                    value: cameraLocalSubnet,
                                    variant: "standard",
                                    label: "Camera local subnet (optional)",
                                    placeholder: "e.g. 192.168.0.0/24",
                                    helperText: "Only needed if the cameras are not on the same LAN as the router.",
                                    onChange: (event)=>setCameraLocalSubnet(event.target.value),
                                    sx: {
                                        width: "100%",
                                        "& *": {
                                            fontFamily: "Mulish"
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eejVe.default), {
                                    id: "edge_device_wireguard_server",
                                    select: true,
                                    value: wireguardServer,
                                    variant: "standard",
                                    label: "WireGuard server",
                                    helperText: "Rotates to the next zone for each new device. Change it to keep this site in the same zone as its existing tunnels.",
                                    SelectProps: {
                                        native: true
                                    },
                                    onChange: (event)=>{
                                        const nextValue = event.target.value;
                                        setWireguardServer(nextValue);
                                    },
                                    sx: {
                                        width: "100%",
                                        "& *": {
                                            fontFamily: "Mulish"
                                        }
                                    },
                                    children: [
                                        !wireguardServer && /*#__PURE__*/ (0, $k4ank.jsx)("option", {
                                            value: "",
                                            children: wireguardPoolFailed ? "Unavailable" : "Loading zones\u2026"
                                        }),
                                        wireguardPool.map((host)=>/*#__PURE__*/ (0, $k4ank.jsx)("option", {
                                                value: host,
                                                children: host
                                            }, host))
                                    ]
                                }),
                                errorMessage && /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                                    className: "font-mulish text-red-600",
                                    role: "alert",
                                    children: errorMessage
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                        sx: {
                            p: 2,
                            px: 4
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: handleClose,
                                text: "Cancel",
                                disabled: false
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: handleSubmit,
                                text: "Submit",
                                disabled: !serialNumber.trim()
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $8B8vg = parcelRequire("8B8vg");
var $a65wX = parcelRequire("a65wX");
var $kUcVg = parcelRequire("kUcVg");
var $887xF = parcelRequire("887xF");
var $1TOOV = parcelRequire("1TOOV");
var $ce8iU = parcelRequire("ce8iU");
var $7UDCh = parcelRequire("7UDCh");
var $3baw3 = parcelRequire("3baw3");
var $9qNow = parcelRequire("9qNow");
var $lk6eW = parcelRequire("lk6eW");
var $k1BHZ = parcelRequire("k1BHZ");
var $imWqP = parcelRequire("imWqP");
var $eejVe = parcelRequire("eejVe");
var $f3puC = parcelRequire("f3puC");

var $8jTCz = parcelRequire("8jTCz");

var $195EM = parcelRequire("195EM");

const $06f92ade4c4bdbc2$var$buildBulkUploadFailureMessage = (data)=>{
    if (!data) return null;
    const failureRows = data.results?.filter((row)=>row.success === false && row.error) ?? [];
    const failureCount = data.summary?.failure_count ?? failureRows.length;
    const totalCount = data.summary?.total ?? data.results?.length ?? 0;
    if (failureCount <= 0 && failureRows.length === 0) return null;
    const previewRows = failureRows.slice(0, 5);
    const rowDetails = previewRows.map((row)=>`Row ${row.row_number ?? "?"}: ${row.error}`).join(" | ");
    const additionalCount = failureRows.length - previewRows.length;
    const overflowText = additionalCount > 0 ? ` | +${additionalCount} more row error(s)` : "";
    return `${failureCount} of ${totalCount} row(s) failed validation/upload.${rowDetails ? ` ${rowDetails}${overflowText}` : ""}`;
};
const $06f92ade4c4bdbc2$export$fb637ef9c75ef27 = ({ open: open, onClose: onClose, accessibleGroups: accessibleGroups, onUploadSuccess: onUploadSuccess })=>{
    const [selectedFile, setSelectedFile] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [validateOnlyMode, setValidateOnlyMode] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("false");
    const [selectedGroup, setSelectedGroup] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [isSubmitting, setIsSubmitting] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [errorMessage, setErrorMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const sortedGroups = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>(0, $5501f060781801f3$export$27bc9adcc62e620c)(accessibleGroups), [
        accessibleGroups
    ]);
    // Group is required (ENG-272); default to the top of the user's tree so the
    // common case is one click. Cleared on close, re-applied on the next open.
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!open) return;
        setSelectedGroup((prev)=>prev ?? (0, $5501f060781801f3$export$db4f2674d92cb641)(accessibleGroups));
    }, [
        open,
        accessibleGroups
    ]);
    const handleClose = ()=>{
        if (isSubmitting) return;
        setSelectedFile(null);
        setValidateOnlyMode("false");
        setSelectedGroup(null);
        setErrorMessage("");
        onClose();
    };
    const handleSubmit = async ()=>{
        if (!selectedFile || !selectedGroup) return;
        const AxiosUI = (0, $195EM.createApi)("");
        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("validate_only_mode", validateOnlyMode);
        formData.append("group_id", String(selectedGroup.id));
        setIsSubmitting(true);
        setErrorMessage("");
        try {
            const response = await AxiosUI.post("wireguard_tunnel_batch/from-csv/", formData);
            const failureMessage = $06f92ade4c4bdbc2$var$buildBulkUploadFailureMessage(response.data);
            if (failureMessage) {
                setErrorMessage(failureMessage);
                const successCount = response.data?.summary?.success_count ?? 0;
                if (validateOnlyMode === "false" && successCount > 0) await onUploadSuccess(false);
                return;
            }
            await onUploadSuccess(validateOnlyMode === "true");
            handleClose();
        } catch (reason) {
            const err = reason;
            const structuredFailureMessage = $06f92ade4c4bdbc2$var$buildBulkUploadFailureMessage(err.response?.data);
            const message = structuredFailureMessage || err.response?.data?.error || err.response?.data?.detail || "Bulk upload failed.";
            setErrorMessage(message);
        } finally{
            setIsSubmitting(false);
        }
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: open,
        onClose: handleClose,
        fullWidth: true,
        maxWidth: "sm",
        "aria-labelledby": "wireguard-bulk-upload-title",
        sx: {
            "& *": {
                fontFamily: "Mulish"
            }
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "wireguard-bulk-upload-title",
                sx: {
                    fontFamily: "Mulish",
                    fontWeight: 700,
                    color: "#283E6D"
                },
                children: "Bulk Upload WireGuard Tunnels"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                dividers: true,
                sx: {
                    px: 4,
                    py: 3
                },
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                    className: "flex flex-col gap-5",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $lk6eW.default), {
                                    sx: {
                                        fontFamily: "Mulish",
                                        color: "#001943",
                                        mb: 1
                                    },
                                    children: "File"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                                    className: "flex items-center gap-3",
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)("input", {
                                            id: "wireguard-bulk-upload-file-input",
                                            type: "file",
                                            accept: ".csv,.xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/csv",
                                            onChange: (event)=>{
                                                const file = event.target.files?.[0] || null;
                                                setSelectedFile(file);
                                            },
                                            style: {
                                                display: "none"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)("label", {
                                            htmlFor: "wireguard-bulk-upload-file-input",
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                                variant: "outlined",
                                                component: "span",
                                                sx: {
                                                    textTransform: "none",
                                                    width: 128,
                                                    minWidth: 128,
                                                    flexShrink: 0
                                                },
                                                children: "Choose File"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                            sx: {
                                                fontFamily: "Mulish",
                                                fontSize: 14,
                                                color: "#5f6368",
                                                minWidth: 0,
                                                maxWidth: 280,
                                                whiteSpace: "normal",
                                                overflowWrap: "anywhere",
                                                wordBreak: "break-all"
                                            },
                                            children: selectedFile ? selectedFile.name : "No chosen file"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                                    sx: {
                                        fontFamily: "Mulish",
                                        mt: 1
                                    },
                                    children: "CSV or Excel file with tunnel rows"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $7UDCh.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $lk6eW.default), {
                                    sx: {
                                        fontFamily: "Mulish",
                                        color: "#001943",
                                        mb: 1
                                    },
                                    children: "Validate Only Mode"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $imWqP.default), {
                                    row: true,
                                    value: validateOnlyMode,
                                    onChange: (event)=>setValidateOnlyMode(event.target.value),
                                    children: [
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                            value: "false",
                                            control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {}),
                                            label: "False"
                                        }),
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3baw3.default), {
                                            value: "true",
                                            control: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k1BHZ.default), {}),
                                            label: "True"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                                    sx: {
                                        fontFamily: "Mulish"
                                    },
                                    children: "If true, validate only; if false, create tunnels."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $8B8vg.default), {
                            options: sortedGroups,
                            value: selectedGroup,
                            onChange: (_, value)=>{
                                if (!value) // Keeps the field from going blank once a group is set.
                                return;
                                setSelectedGroup(value);
                            },
                            getOptionLabel: (option)=>option.name || "",
                            isOptionEqualToValue: (option, value)=>option.id === value.id,
                            disableClearable: Boolean(selectedGroup),
                            renderInput: (params)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                    ...params,
                                    label: "Group",
                                    required: true,
                                    helperText: "*Required \u2014 uploaded tunnels are assigned to this group",
                                    variant: "standard",
                                    sx: {
                                        width: "100%",
                                        "& *": {
                                            fontFamily: "Mulish"
                                        }
                                    }
                                })
                        }),
                        errorMessage && /*#__PURE__*/ (0, $k4ank.jsx)((0, $9qNow.default), {
                            sx: {
                                color: "#d32f2f",
                                fontFamily: "Mulish"
                            },
                            children: errorMessage
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                sx: {
                    p: 2,
                    px: 4
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: handleClose,
                        text: "Cancel",
                        disabled: isSubmitting
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                        onClick: handleSubmit,
                        text: isSubmitting ? "Uploading..." : "Upload",
                        disabled: isSubmitting || !selectedFile || !selectedGroup
                    })
                ]
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");

var $3n3uW = parcelRequire("3n3uW");

var $2suvB = parcelRequire("2suvB");

var $cFPmV = parcelRequire("cFPmV");
var $b9p11 = parcelRequire("b9p11");
const $93261b072de7533b$var$theme = (0, $cFPmV.default)({
    palette: {
        primary: {
            main: "#FF8400"
        }
    }
});
function $93261b072de7533b$var$a11yProps(index) {
    return {
        id: `wireguard-page-tab-${index}`,
        "aria-controls": `wireguard-page-tabpanel-${index}`
    };
}
const $93261b072de7533b$var$tabSx = {
    fontFamily: "Mulish",
    fontWeight: "Bold",
    color: "primary"
};
const $93261b072de7533b$export$83021195b5dcc364 = ({ activeTab: activeTab, setActiveTab: setActiveTab, showEdgeDevices: showEdgeDevices })=>{
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
        sx: {
            borderBottom: 1,
            borderColor: "divider",
            backgroundColor: "white"
        },
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $b9p11.default), {
            theme: $93261b072de7533b$var$theme,
            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3n3uW.default), {
                value: activeTab,
                onChange: (_, tabValue)=>{
                    setActiveTab(tabValue);
                },
                "aria-label": "wireguard_page_tabs",
                color: "primary",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                        value: "wireguard-tunnels",
                        label: "WireGuard Tunnels",
                        sx: $93261b072de7533b$var$tabSx,
                        ...$93261b072de7533b$var$a11yProps(0)
                    }),
                    showEdgeDevices && /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                        value: "edge-devices",
                        label: "Edge Devices",
                        sx: $93261b072de7533b$var$tabSx,
                        ...$93261b072de7533b$var$a11yProps(1)
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $2suvB.default), {
                        value: "vpn-debugger",
                        label: "VPN Debugger",
                        sx: $93261b072de7533b$var$tabSx,
                        ...$93261b072de7533b$var$a11yProps(2)
                    })
                ]
            })
        })
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $3QMQN = parcelRequire("3QMQN");
var $eDfvp = parcelRequire("eDfvp");
var $a65wX = parcelRequire("a65wX");
var $4reBM = parcelRequire("4reBM");
var $3IuQ3 = parcelRequire("3IuQ3");
var $f3puC = parcelRequire("f3puC");
parcelRequire("fIsAN");
var $3T949 = parcelRequire("3T949");
/**
 * Ladder shape and palette for the VPN debugger.
 *
 * STEP_ORDER / STEP_TITLES duplicate the server's `diagnosis.STEP_ORDER` on
 * purpose: the UI draws every step before the first response lands, so it needs
 * the list without having asked for it. If a step is added server-side it must
 * be added here too, or it renders under its raw id.
 *
 * The status palette is the same one `getStatusStyles` uses in
 * WireGuardTunnelsTable, so green means the same thing on both tabs.
 */ const $f78cbb54da682e17$export$ee14340141c11674 = 3000;
const $f78cbb54da682e17$export$83e46e2a99cad5f4 = 600000;
const $f78cbb54da682e17$export$fe5882e1cacea70d = [
    "tunnel_config",
    "tunnel_status",
    "tunnel_flow",
    "tunnel_reachability",
    "service_reachability",
    "authentication",
    "stream_validation",
    "media_inspection",
    "snapshot"
];
const $f78cbb54da682e17$export$890d393a6e6704bf = [
    "tunnel_config",
    "tunnel_status",
    "tunnel_reachability"
];
const $f78cbb54da682e17$export$2619df4efe1fac76 = [
    "tunnel_status.stale_handshake_gateway_healthy",
    "tunnel_status.stale_handshake_gateway_quiet"
];
const $f78cbb54da682e17$export$575c774f27df8d17 = 30;
const $f78cbb54da682e17$export$a41be3b9ccef93a9 = {
    tunnel_config: "Tunnel configuration",
    tunnel_status: "Tunnel status",
    tunnel_flow: "Packet flow",
    tunnel_reachability: "Tunnel reachability (ICMP)",
    service_reachability: "Service reachability (TCP)",
    authentication: "Authentication",
    stream_validation: "Stream validation",
    media_inspection: "Media inspection",
    snapshot: "Snapshot"
};
const $f78cbb54da682e17$export$34a6f089e328cef5 = {
    pass: {
        backgroundColor: "#e6f4ea",
        color: "#1e7d34",
        dotColor: "#1e7d34",
        label: "Pass"
    },
    fail: {
        backgroundColor: "#fdecec",
        color: "#b3261e",
        dotColor: "#b3261e",
        label: "Fail"
    },
    warn: {
        backgroundColor: "#fff4e5",
        color: "#b25e00",
        dotColor: "#b25e00",
        label: "Warning"
    },
    skipped: {
        backgroundColor: "#eceff3",
        color: "#5f6368",
        dotColor: "",
        label: "Skipped"
    },
    running: {
        backgroundColor: "#eaf1fb",
        color: "#283e6d",
        dotColor: "#283e6d",
        label: "Running"
    },
    pending: {
        backgroundColor: "#f5f6f8",
        color: "#9aa0a6",
        dotColor: "",
        label: "Waiting"
    }
};
const $f78cbb54da682e17$export$de84d81ebc6e0814 = {
    healthy: {
        backgroundColor: "#e6f4ea",
        accent: "#1e7d34"
    },
    tunnel_down: {
        backgroundColor: "#fdecec",
        accent: "#b3261e"
    },
    routing_firewall: {
        backgroundColor: "#fdecec",
        accent: "#b3261e"
    },
    service_unreachable: {
        backgroundColor: "#fff4e5",
        accent: "#b25e00"
    },
    auth_failure: {
        backgroundColor: "#fff4e5",
        accent: "#b25e00"
    },
    stream_encoding: {
        backgroundColor: "#fff4e5",
        accent: "#b25e00"
    },
    inconclusive: {
        backgroundColor: "#eceff3",
        accent: "#5f6368"
    }
};
const $f78cbb54da682e17$export$80ece1c0a000a342 = {
    customer: "Customer side",
    actuate: "Our side",
    device: "Device side"
};
const $f78cbb54da682e17$export$e5b085a761864240 = "554";
const $f78cbb54da682e17$export$fc23a942a792770d = "80";
const $f78cbb54da682e17$export$d528bb51d10101d = "1px solid #d1d5db";
const $f78cbb54da682e17$export$289d5a40a63935cc = 360;
const $f78cbb54da682e17$export$d0e02a3e834eb2cd = {
    fontFamily: "Mulish"
};
const $f78cbb54da682e17$export$78148981eebf8674 = {
    fontFamily: "Mulish",
    fontWeight: 700,
    fontSize: 11,
    letterSpacing: "0.6px",
    color: "#6b7280",
    textTransform: "uppercase"
};
const $f78cbb54da682e17$export$e970c7957bdb2fb = {
    fontFamily: "Mulish",
    fontWeight: 700,
    fontSize: 13,
    color: "#001943"
};
const $f78cbb54da682e17$export$f7351ad9be319510 = {
    fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace"
};
/**
 * Warn when the server sends a step this build does not know about.
 *
 * The ladder grew twice server-side (`tunnel_config`, `tunnel_flow`) while this
 * UI stayed on seven steps, and the only symptom was a step rendering under its
 * raw id -- easy to miss in a list of nine. Drift is now noisy instead of
 * silent. Deliberately a warning, not a throw: a newer server must never break
 * an older UI, it should just be visible that it happened.
 */ const $f78cbb54da682e17$var$warnedStepIds = new Set();
const $f78cbb54da682e17$export$986932cebbe2048f = (ids)=>{
    (ids || []).forEach((id)=>{
        if ($f78cbb54da682e17$export$fe5882e1cacea70d.includes(id) || $f78cbb54da682e17$var$warnedStepIds.has(id)) return;
        $f78cbb54da682e17$var$warnedStepIds.add(id);
        // eslint-disable-next-line no-console
        console.warn(`[vpn-debugger] server sent unknown step "${id}" -- this UI is behind ` + "the server ladder; add it to STEP_ORDER/STEP_TITLES/VpnDebugStepId.");
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");
var $2CHqP = parcelRequire("2CHqP");
var $f3puC = parcelRequire("f3puC");

const $2ffe1bc08e202417$var$Chip = ({ label: label, color: color, border: border })=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
        component: "span",
        sx: {
            ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: "0.3px",
            color: color,
            border: `1px solid ${border}`,
            backgroundColor: "rgba(255,255,255,0.65)",
            borderRadius: "999px",
            px: 1,
            py: "2px"
        },
        children: label
    });
const $2ffe1bc08e202417$var$eyebrowSx = {
    ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: "0.8px",
    color: "#6b7280"
};
const $2ffe1bc08e202417$export$d0bedf8a2ad3823e = ({ running: running, stage: stage, steps: steps, pendingSteps: pendingSteps, classification: classification })=>{
    if (running) {
        const done = (0, $f78cbb54da682e17$export$fe5882e1cacea70d).filter((id)=>steps[id] && !pendingSteps.includes(id)).length;
        return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
            sx: {
                backgroundColor: "#eaf1fb",
                border: "1px solid #cddcf3",
                borderLeft: "5px solid #283e6d",
                borderRadius: "8px",
                p: 2,
                mb: 2.5
            },
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                    sx: $2ffe1bc08e202417$var$eyebrowSx,
                    children: "DIAGNOSTICS RUNNING"
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                    sx: {
                        ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                        fontSize: 19,
                        fontWeight: 700,
                        color: "#001943",
                        mt: 0.25
                    },
                    children: stage || "Working\u2026"
                }),
                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                    sx: {
                        ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                        fontSize: 13,
                        color: "#283e6d",
                        mt: 0.5
                    },
                    children: [
                        done,
                        " of ",
                        (0, $f78cbb54da682e17$export$fe5882e1cacea70d).length,
                        " checks complete."
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $2CHqP.default), {
                    variant: "determinate",
                    value: done / (0, $f78cbb54da682e17$export$fe5882e1cacea70d).length * 100,
                    sx: {
                        mt: 1.25,
                        height: 5,
                        borderRadius: 3,
                        backgroundColor: "#cddcf3",
                        "& .MuiLinearProgress-bar": {
                            backgroundColor: "#283e6d"
                        }
                    }
                })
            ]
        });
    }
    if (!classification) return null;
    const style = (0, $f78cbb54da682e17$export$de84d81ebc6e0814)[classification.code] || (0, $f78cbb54da682e17$export$de84d81ebc6e0814).inconclusive;
    const ownerLabel = (0, $f78cbb54da682e17$export$80ece1c0a000a342)[classification.owner];
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
        sx: {
            backgroundColor: style.backgroundColor,
            border: `1px solid ${style.accent}33`,
            borderLeft: `5px solid ${style.accent}`,
            borderRadius: "8px",
            p: 2,
            mb: 2.5
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                sx: $2ffe1bc08e202417$var$eyebrowSx,
                children: "FINAL CLASSIFICATION"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                sx: {
                    display: "flex",
                    alignItems: "baseline",
                    flexWrap: "wrap",
                    gap: 1,
                    mt: 0.25
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                            fontSize: 22,
                            fontWeight: 700,
                            color: "#001943"
                        },
                        children: classification.label
                    }),
                    ownerLabel && /*#__PURE__*/ (0, $k4ank.jsx)($2ffe1bc08e202417$var$Chip, {
                        label: ownerLabel,
                        color: style.accent,
                        border: style.accent
                    }),
                    classification.confidence && /*#__PURE__*/ (0, $k4ank.jsx)($2ffe1bc08e202417$var$Chip, {
                        label: `confidence ${classification.confidence}`,
                        color: "#5f6368",
                        border: "#c9ced6"
                    })
                ]
            }),
            classification.summary && /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                sx: {
                    ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                    fontSize: 14,
                    color: "#283e6d",
                    mt: 0.75,
                    lineHeight: 1.5
                },
                children: classification.summary
            }),
            classification.next_actions.length > 0 && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                sx: {
                    mt: 1.25
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: $2ffe1bc08e202417$var$eyebrowSx,
                        children: classification.next_actions.length > 1 ? "NEXT ACTIONS" : "NEXT ACTION"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                        component: "ul",
                        sx: {
                            m: 0,
                            mt: 0.5,
                            pl: 2.5
                        },
                        children: classification.next_actions.map((action)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                component: "li",
                                sx: {
                                    ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                                    fontSize: 13,
                                    color: "#283e6d",
                                    lineHeight: 1.55
                                },
                                children: action
                            }, action))
                    })
                ]
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");
var $yndCB = parcelRequire("yndCB");
var $f3puC = parcelRequire("f3puC");

var $5gr4N = parcelRequire("5gr4N");


var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");

const $4455fb2a90316655$export$f57f9a9f2cecc0a6 = ({ status: status })=>{
    const style = (0, $f78cbb54da682e17$export$34a6f089e328cef5)[status] || (0, $f78cbb54da682e17$export$34a6f089e328cef5).pending;
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
        component: "span",
        sx: {
            display: "inline-flex",
            alignItems: "center",
            borderRadius: "999px",
            px: 1.25,
            py: 0.4,
            fontFamily: "Mulish",
            fontWeight: 600,
            fontSize: 12,
            backgroundColor: style.backgroundColor,
            color: style.color
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                component: "span",
                sx: {
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    mr: 0.75,
                    boxSizing: "border-box",
                    ...style.dotColor ? {
                        backgroundColor: style.dotColor
                    } : {
                        border: "2px solid #5f6368"
                    }
                }
            }),
            style.label
        ]
    });
};


const $ed392f0ec626405d$var$RAIL_COL_PX = 34;
/** Number badge that carries the step's colour, so the ladder reads at a glance. */ const $ed392f0ec626405d$var$StepBadge = ({ index: index, status: status })=>{
    const style = (0, $f78cbb54da682e17$export$34a6f089e328cef5)[status] || (0, $f78cbb54da682e17$export$34a6f089e328cef5).pending;
    const solid = status === "pass" || status === "fail" || status === "warn";
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
        sx: {
            width: 26,
            height: 26,
            borderRadius: "50%",
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "Mulish",
            fontWeight: 700,
            fontSize: 12,
            border: `2px solid ${solid ? style.color : "#d1d5db"}`,
            backgroundColor: solid ? style.color : "#fff",
            color: solid ? "#fff" : "#9aa0a6"
        },
        children: index
    });
};
const $ed392f0ec626405d$export$b1da33d07e8eac37 = ({ stepId: stepId, step: step, isPending: isPending, autoExpandEvidence: autoExpandEvidence, isLast: isLast })=>{
    // The server's title wins once the step has run. For operators it is the
    // same text as STEP_TITLES; for customers it is the customer-safe wording
    // ("Connection", "Traffic from your site") the projection sends on purpose.
    const title = step?.title || (0, $f78cbb54da682e17$export$a41be3b9ccef93a9)[stepId] || stepId;
    // A step the next plane is about to run must not sit there showing the
    // previous plane's "skipped", which reads as a finished, negative result.
    const status = isPending ? "running" : step ? step.status : "pending";
    const [evidenceOpen, setEvidenceOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(autoExpandEvidence);
    // Re-sync when a new run changes which step is the first failure.
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>setEvidenceOpen(autoExpandEvidence), [
        autoExpandEvidence
    ]);
    const hasEvidence = step != null && step.evidence != null && Object.keys(step.evidence).length > 0;
    const accent = ((0, $f78cbb54da682e17$export$34a6f089e328cef5)[status] || (0, $f78cbb54da682e17$export$34a6f089e328cef5).pending).color;
    const isQuiet = status === "pending" || status === "skipped";
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
        sx: {
            display: "flex",
            gap: 1.5
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                sx: {
                    width: $ed392f0ec626405d$var$RAIL_COL_PX,
                    flexShrink: 0,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)($ed392f0ec626405d$var$StepBadge, {
                        index: (0, $f78cbb54da682e17$export$fe5882e1cacea70d).indexOf(stepId) + 1,
                        status: status
                    }),
                    !isLast && /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                        sx: {
                            flex: 1,
                            width: "2px",
                            backgroundColor: "#e3e7ee",
                            mt: 0.5
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                sx: {
                    flex: 1,
                    minWidth: 0,
                    pb: isLast ? 0 : 2,
                    opacity: isQuiet ? 0.72 : 1
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                        sx: {
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            flexWrap: "wrap",
                            minHeight: 26
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                sx: {
                                    ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                                    fontWeight: 700,
                                    fontSize: 15,
                                    color: "#001943"
                                },
                                children: title
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $4455fb2a90316655$export$f57f9a9f2cecc0a6), {
                                status: status
                            }),
                            step?.partial && /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                component: "span",
                                title: "Observed, not decode-verified",
                                sx: {
                                    ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                                    fontSize: 11,
                                    fontWeight: 600,
                                    border: "1px solid #b25e00",
                                    color: "#b25e00",
                                    borderRadius: "999px",
                                    px: 1,
                                    py: "1px"
                                },
                                children: "Partial"
                            }),
                            step && step.decisive === false && /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                component: "span",
                                title: "Cannot move the final verdict on its own \u2014 firewalls routinely drop ICMP, and plenty of working NVR channels expose no snapshot.",
                                sx: {
                                    ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                                    fontSize: 11,
                                    fontWeight: 600,
                                    border: "1px solid #d1d5db",
                                    color: "#6b7280",
                                    borderRadius: "999px",
                                    px: 1,
                                    py: "1px"
                                },
                                children: "Not decisive"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                sx: {
                                    flexGrow: 1
                                }
                            }),
                            step?.duration_ms != null && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $f3puC.default), {
                                sx: {
                                    ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                                    ...(0, $f78cbb54da682e17$export$f7351ad9be319510),
                                    fontSize: 12,
                                    color: "#9aa0a6"
                                },
                                children: [
                                    Math.round(step.duration_ms),
                                    " ms"
                                ]
                            })
                        ]
                    }),
                    isPending ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                            fontSize: 13,
                            color: "#6b7280",
                            mt: 0.5
                        },
                        children: "Running on the gateway\u2026"
                    }) : !step ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                            fontSize: 13,
                            color: "#9aa0a6",
                            mt: 0.5
                        },
                        children: "Not started."
                    }) : step.status === "skipped" ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                            fontSize: 13,
                            color: "#6b7280",
                            fontStyle: "italic",
                            mt: 0.5
                        },
                        children: step.skipped_reason || "Not run."
                    }) : /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                sx: {
                                    ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                                    fontSize: 14,
                                    color: "#283e6d",
                                    mt: 0.5,
                                    fontWeight: 600
                                },
                                children: step.summary
                            }),
                            step.diagnosis && /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                sx: {
                                    ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                                    fontSize: 13,
                                    color: "#3c4858",
                                    mt: 0.75,
                                    lineHeight: 1.5
                                },
                                children: step.diagnosis
                            }),
                            step.next_action && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                                sx: {
                                    mt: 1,
                                    p: 1.25,
                                    borderRadius: "6px",
                                    borderLeft: `3px solid ${accent}`,
                                    backgroundColor: "#f8f9fb"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                        sx: {
                                            ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                                            fontSize: 10,
                                            fontWeight: 700,
                                            letterSpacing: "0.6px",
                                            color: "#6b7280"
                                        },
                                        children: "NEXT ACTION"
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                        sx: {
                                            ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                                            fontSize: 13,
                                            color: "#283e6d",
                                            mt: 0.25,
                                            lineHeight: 1.5
                                        },
                                        children: step.next_action
                                    })
                                ]
                            })
                        ]
                    }),
                    hasEvidence && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                        sx: {
                            mt: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                                component: "button",
                                type: "button",
                                "aria-expanded": evidenceOpen,
                                onClick: ()=>setEvidenceOpen((prev)=>!prev),
                                sx: {
                                    ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: 0.25,
                                    fontSize: 12,
                                    fontWeight: 600,
                                    color: "#283e6d",
                                    background: "none",
                                    border: "none",
                                    p: 0,
                                    cursor: "pointer",
                                    "&:hover": {
                                        textDecoration: "underline"
                                    }
                                },
                                children: [
                                    "Evidence",
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5gr4N))), {
                                        sx: {
                                            fontSize: 18,
                                            transition: "transform 150ms",
                                            transform: evidenceOpen ? "rotate(180deg)" : "none"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $yndCB.default), {
                                in: evidenceOpen,
                                unmountOnExit: true,
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                    component: "pre",
                                    sx: {
                                        ...(0, $f78cbb54da682e17$export$f7351ad9be319510),
                                        backgroundColor: "#f4f6f8",
                                        border: "1px solid #e3e7ee",
                                        borderRadius: "6px",
                                        p: 1.25,
                                        mt: 0.75,
                                        mb: 0,
                                        maxHeight: 300,
                                        overflow: "auto",
                                        fontSize: 11.5,
                                        lineHeight: 1.55,
                                        color: "#3c4858"
                                    },
                                    children: JSON.stringify(step?.evidence, null, 2)
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");
var $a65wX = parcelRequire("a65wX");
var $60vL1 = parcelRequire("60vL1");
var $7UDCh = parcelRequire("7UDCh");
var $bAwA3 = parcelRequire("bAwA3");
var $cxknk = parcelRequire("cxknk");
var $4reBM = parcelRequire("4reBM");
var $2eEqG = parcelRequire("2eEqG");
var $eejVe = parcelRequire("eejVe");
var $f3puC = parcelRequire("f3puC");

var $8jTCz = parcelRequire("8jTCz");


var $9OjAn = parcelRequire("9OjAn");

const $d780a4127f4a85f5$var$initialRunState = {
    steps: {},
    classification: null,
    running: false,
    stage: "",
    pendingSteps: [],
    flowOffered: false,
    flowTunnelTaskId: "",
    statusMessage: "",
    statusIsError: false
};
const $d780a4127f4a85f5$var$initialState = {
    customerStepIds: null,
    tunnelId: null,
    targets: null,
    targetsLoading: false,
    targetsError: "",
    selectedCameraId: null,
    host: "",
    rtspPort: (0, $f78cbb54da682e17$export$e5b085a761864240),
    onvifPort: (0, $f78cbb54da682e17$export$fc23a942a792770d),
    username: "",
    password: "",
    credentialSource: "none",
    credentialMasked: false,
    credentialEdited: false,
    runToken: 0,
    ...$d780a4127f4a85f5$var$initialRunState
};
const $d780a4127f4a85f5$export$58caa69774d352e0 = (0, $9OjAn.create)((set, get)=>({
        ...$d780a4127f4a85f5$var$initialState,
        setTunnelId: (value)=>set({
                tunnelId: value
            }),
        setTargets: (value)=>set({
                targets: value
            }),
        setTargetsLoading: (value)=>set({
                targetsLoading: value
            }),
        setTargetsError: (value)=>set({
                targetsError: value
            }),
        setSelectedCameraId: (value)=>set({
                selectedCameraId: value
            }),
        setHost: (value)=>set({
                host: value
            }),
        setRtspPort: (value)=>set({
                rtspPort: value
            }),
        setOnvifPort: (value)=>set({
                onvifPort: value
            }),
        // Any direct edit is operator intent, so it flips the override switch.
        setUsername: (value)=>set({
                username: value,
                credentialEdited: true
            }),
        setPassword: (value)=>set({
                password: value,
                credentialEdited: true
            }),
        applyPrefilledCredential: ({ username: username, password: password, source: source, masked: masked })=>set({
                username: username,
                password: password,
                credentialSource: source,
                credentialMasked: masked,
                credentialEdited: false
            }),
        setCredentialEdited: (value)=>set({
                credentialEdited: value
            }),
        nextRunToken: ()=>{
            const token = get().runToken + 1;
            set({
                runToken: token
            });
            return token;
        },
        setSteps: (value)=>set({
                steps: value
            }),
        setClassification: (value)=>set({
                classification: value
            }),
        setCustomerStepIds: (value)=>set({
                customerStepIds: value
            }),
        setRunning: (value)=>set({
                running: value
            }),
        setStage: (value)=>set({
                stage: value
            }),
        setPendingSteps: (value)=>set({
                pendingSteps: value
            }),
        setStatus: (message, isError = false)=>set({
                statusMessage: message,
                statusIsError: isError
            }),
        setFlowOffered: (value)=>set({
                flowOffered: value
            }),
        setFlowTunnelTaskId: (value)=>set({
                flowTunnelTaskId: value
            }),
        resetRun: ()=>set({
                ...$d780a4127f4a85f5$var$initialRunState
            }),
        // Deliberately keeps runToken: resetting it would let a still-in-flight run
        // from before the reset match the new token and write into the fresh ladder.
        reset: ()=>set({
                ...$d780a4127f4a85f5$var$initialState,
                runToken: get().runToken
            })
    }));



var $195EM = parcelRequire("195EM");
const $60a22f14b3eb46cc$export$1e6b33d6088d1e7a = "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022";
const $60a22f14b3eb46cc$var$isMasked = (value)=>value === $60a22f14b3eb46cc$export$1e6b33d6088d1e7a;
const $60a22f14b3eb46cc$var$clean = (value)=>typeof value === "string" && value.trim() !== "" ? value : "";
const $60a22f14b3eb46cc$export$b8ce8d379cee23d7 = async (cameraId, customerId)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    let username = "";
    let password = "";
    let masked = false;
    let source = "none";
    try {
        const response = await AxiosUI.get(`camera/${cameraId}/general_info/`);
        const data = response.data || {};
        if ($60a22f14b3eb46cc$var$clean(data.username) || $60a22f14b3eb46cc$var$clean(data.password)) {
            username = $60a22f14b3eb46cc$var$clean(data.username);
            masked = $60a22f14b3eb46cc$var$isMasked(data.password);
            password = masked ? "" : $60a22f14b3eb46cc$var$clean(data.password);
            source = "camera";
        }
    } catch  {
    // Non-fatal: fall through to the site, then to "none". The run still works
    // via camera_id, where the server resolves the secret itself.
    }
    if (source === "none" && customerId != null) try {
        const response = await AxiosUI.get(`customer/${customerId}/about/`);
        const data = response.data || {};
        if ($60a22f14b3eb46cc$var$clean(data.username) || $60a22f14b3eb46cc$var$clean(data.password)) {
            username = $60a22f14b3eb46cc$var$clean(data.username);
            masked = $60a22f14b3eb46cc$var$isMasked(data.password);
            password = masked ? "" : $60a22f14b3eb46cc$var$clean(data.password);
            source = "site";
        }
    } catch  {
    // Same: leave it as "none".
    }
    return {
        username: username,
        password: password,
        source: source,
        masked: masked
    };
};


const $9ae8014b249d4f18$var$selectSx = {
    ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
    backgroundColor: "#e9edf2",
    "& *": {
        fontFamily: "Mulish"
    }
};
const $9ae8014b249d4f18$var$fieldSx = {
    ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
    backgroundColor: "#e9edf2",
    "& *": {
        fontFamily: "Mulish"
    }
};
const $9ae8014b249d4f18$var$Field = ({ label: label, children: children })=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                sx: {
                    ...(0, $f78cbb54da682e17$export$e970c7957bdb2fb),
                    mb: 0.5
                },
                children: label
            }),
            children
        ]
    });
const $9ae8014b249d4f18$var$cameraLabel = (camera)=>{
    const name = camera.camera_name || `Camera ${camera.camera_id}`;
    const site = camera.customer_name ? ` \xb7 ${camera.customer_name}` : "";
    return `${name} \u{2014} ${camera.ip}${site}`;
};
const $9ae8014b249d4f18$export$8dbfa1da3ec339c3 = ({ tunnels: tunnels, getServerName: getServerName, onRun: onRun })=>{
    const { tunnelId: tunnelId, setTunnelId: setTunnelId, targets: targets, targetsLoading: targetsLoading, selectedCameraId: selectedCameraId, setSelectedCameraId: setSelectedCameraId, host: host, setHost: setHost, rtspPort: rtspPort, setRtspPort: setRtspPort, onvifPort: onvifPort, setOnvifPort: setOnvifPort, username: username, setUsername: setUsername, password: password, setPassword: setPassword, credentialSource: credentialSource, credentialMasked: credentialMasked, credentialEdited: credentialEdited, applyPrefilledCredential: applyPrefilledCredential, running: running, reset: reset } = (0, $d780a4127f4a85f5$export$58caa69774d352e0)();
    const allCandidates = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>[
            ...targets?.cameras || [],
            ...targets?.other_cameras || []
        ], [
        targets
    ]);
    const selectedCamera = allCandidates.find((entry)=>entry.camera_id === selectedCameraId) || null;
    const handleCameraChange = (rawValue)=>{
        if (!rawValue) {
            setSelectedCameraId(null);
            return;
        }
        const cameraId = Number(rawValue);
        setSelectedCameraId(cameraId);
        const camera = allCandidates.find((entry)=>entry.camera_id === cameraId);
        if (!camera) return;
        setHost(camera.ip || "");
        setRtspPort(String(camera.rtsp_port || (0, $f78cbb54da682e17$export$e5b085a761864240)));
        setOnvifPort(String(camera.http_port || (0, $f78cbb54da682e17$export$fc23a942a792770d)));
        // Prefill the credential plane B would actually use, resolved camera -> site
        // exactly as the server does. applyPrefilledCredential deliberately does not
        // set credentialEdited, so an untouched prefill still runs down the
        // camera_id path where the server reads the secret itself.
        (0, $60a22f14b3eb46cc$export$b8ce8d379cee23d7)(cameraId, camera.customer_id).then((found)=>{
            if ((0, $d780a4127f4a85f5$export$58caa69774d352e0).getState().selectedCameraId !== cameraId) return;
            applyPrefilledCredential(found);
        });
    };
    const credentialNote = ()=>{
        if (credentialEdited) return {
            text: "Overridden - this run uses what you typed instead of the stored credential.",
            color: "#b25e00"
        };
        if (credentialMasked) return {
            text: `A ${credentialSource} credential is stored but hidden - you lack permission to view passwords. The run still uses it.`,
            color: "#6b7280"
        };
        if (credentialSource === "camera") return {
            text: "From this camera's settings.",
            color: "#1e7d34"
        };
        if (credentialSource === "site") return {
            text: "Inherited from the site - this camera has none of its own.",
            color: "#1e7d34"
        };
        return {
            text: "Nothing stored on the camera or the site. Enter credentials to run authenticated checks.",
            color: "#b25e00"
        };
    };
    // MUI's Select matches `value` against a flat child list, so the two groups are
    // built as one array with ListSubheader separators rather than nested nodes.
    const cameraOptions = [
        /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
            value: "",
            sx: (0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
            children: "\u2014 enter a target manually \u2014"
        }, "__manual")
    ];
    if (targets?.cameras.length) {
        cameraOptions.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $bAwA3.default), {
            sx: {
                ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                fontWeight: 700,
                fontSize: 12
            },
            children: "In this tunnel's routed ranges"
        }, "__in_range"));
        targets.cameras.forEach((camera)=>{
            cameraOptions.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                value: camera.camera_id,
                sx: (0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                children: $9ae8014b249d4f18$var$cameraLabel(camera)
            }, camera.camera_id));
        });
    }
    if (targets?.other_cameras.length) {
        // Kept available, not hidden: subnet metadata goes stale and virtually
        // assigned ranges are real, so a strict filter would hide exactly the camera
        // being chased.
        cameraOptions.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $bAwA3.default), {
            sx: {
                ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                fontWeight: 700,
                fontSize: 12
            },
            children: "Outside the routed ranges"
        }, "__out_of_range"));
        targets.other_cameras.forEach((camera)=>{
            cameraOptions.push(/*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                value: camera.camera_id,
                sx: (0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                children: $9ae8014b249d4f18$var$cameraLabel(camera)
            }, camera.camera_id));
        });
    }
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4reBM.default), {
        sx: {
            width: (0, $f78cbb54da682e17$export$289d5a40a63935cc),
            minWidth: (0, $f78cbb54da682e17$export$289d5a40a63935cc),
            height: "100%",
            maxHeight: "100%",
            borderRadius: 2,
            borderTop: (0, $f78cbb54da682e17$export$d528bb51d10101d),
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd)
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                sx: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    px: 2,
                    height: 46,
                    flexShrink: 0,
                    borderBottom: (0, $f78cbb54da682e17$export$d528bb51d10101d),
                    backgroundColor: "white"
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                            fontWeight: 700,
                            fontSize: 14
                        },
                        children: "TARGET"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                        sx: {
                            transform: "scale(0.82)",
                            transformOrigin: "right center",
                            mr: "-10px"
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            onClick: ()=>reset(),
                            text: "Reset",
                            disabled: running
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                sx: {
                    px: 2,
                    py: 2,
                    overflowY: "auto",
                    flex: 1,
                    minHeight: 0
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            ...(0, $f78cbb54da682e17$export$78148981eebf8674),
                            mb: 1
                        },
                        children: "Gateway"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)($9ae8014b249d4f18$var$Field, {
                        label: "Tunnel",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $7UDCh.default), {
                            fullWidth: true,
                            size: "small",
                            children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $2eEqG.default), {
                                displayEmpty: true,
                                inputProps: {
                                    "aria-label": "Tunnel"
                                },
                                value: tunnelId ?? "",
                                onChange: (event)=>{
                                    const nextValue = event.target.value;
                                    setTunnelId(nextValue === "" ? null : Number(nextValue));
                                },
                                disabled: running,
                                sx: $9ae8014b249d4f18$var$selectSx,
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                        value: "",
                                        sx: (0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                                        children: "\u2014 select a tunnel \u2014"
                                    }),
                                    tunnels.map((tunnel)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $cxknk.default), {
                                            value: tunnel.id,
                                            sx: (0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                                            children: tunnel.name
                                        }, tunnel.id))
                                ]
                            })
                        })
                    }),
                    tunnelId != null && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                        sx: {
                            mt: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                sx: {
                                    ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                                    fontSize: 12,
                                    color: "#6b7280"
                                },
                                children: getServerName(tunnels.find((t)=>t.id === tunnelId)?.server ?? null)
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                                sx: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.75,
                                    flexWrap: "wrap",
                                    mt: 0.75
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                        sx: {
                                            ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                                            fontSize: 12,
                                            color: "#6b7280"
                                        },
                                        children: "Routed:"
                                    }),
                                    targetsLoading && /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                                        size: 13
                                    }),
                                    !targetsLoading && targets?.scan_targets.length ? targets.scan_targets.map((cidr)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                            component: "span",
                                            sx: {
                                                ...(0, $f78cbb54da682e17$export$f7351ad9be319510),
                                                fontSize: 11,
                                                backgroundColor: "#eef1f5",
                                                border: "1px solid #dde2e9",
                                                borderRadius: "4px",
                                                px: 0.75,
                                                py: "1px",
                                                color: "#3c4858"
                                            },
                                            children: cidr
                                        }, cidr)) : !targetsLoading && /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                        sx: {
                                            ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                                            fontSize: 12,
                                            color: "#b3261e",
                                            fontStyle: "italic"
                                        },
                                        children: "none configured"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $c092706b06a9e6ab$export$2e2bcd8739ae039), {
                        sx: {
                            my: 2
                        }
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            ...(0, $f78cbb54da682e17$export$78148981eebf8674),
                            mb: 1
                        },
                        children: "Device"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)($9ae8014b249d4f18$var$Field, {
                        label: "Camera",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $7UDCh.default), {
                            fullWidth: true,
                            size: "small",
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $2eEqG.default), {
                                displayEmpty: true,
                                inputProps: {
                                    "aria-label": "Camera"
                                },
                                value: selectedCameraId ?? "",
                                onChange: (event)=>{
                                    const nextValue = String(event.target.value ?? "");
                                    handleCameraChange(nextValue);
                                },
                                disabled: running || tunnelId == null,
                                sx: $9ae8014b249d4f18$var$selectSx,
                                children: cameraOptions
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                        sx: {
                            display: "flex",
                            gap: 1,
                            mt: 1.5
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                sx: {
                                    flex: 1.6
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)($9ae8014b249d4f18$var$Field, {
                                    label: "Host",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        fullWidth: true,
                                        size: "small",
                                        placeholder: "172.16.1.50",
                                        value: host,
                                        onChange: (event)=>{
                                            const nextValue = event.target.value;
                                            setHost(nextValue);
                                        },
                                        disabled: running,
                                        sx: $9ae8014b249d4f18$var$fieldSx
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                sx: {
                                    flex: 1
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)($9ae8014b249d4f18$var$Field, {
                                    label: "RTSP",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        fullWidth: true,
                                        size: "small",
                                        value: rtspPort,
                                        onChange: (event)=>{
                                            const nextValue = event.target.value;
                                            setRtspPort(nextValue);
                                        },
                                        disabled: running,
                                        sx: $9ae8014b249d4f18$var$fieldSx
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                sx: {
                                    flex: 1
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)($9ae8014b249d4f18$var$Field, {
                                    label: "ONVIF",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        fullWidth: true,
                                        size: "small",
                                        value: onvifPort,
                                        onChange: (event)=>{
                                            const nextValue = event.target.value;
                                            setOnvifPort(nextValue);
                                        },
                                        disabled: running,
                                        sx: $9ae8014b249d4f18$var$fieldSx
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $c092706b06a9e6ab$export$2e2bcd8739ae039), {
                        sx: {
                            my: 2
                        }
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            ...(0, $f78cbb54da682e17$export$78148981eebf8674)
                        },
                        children: "Credentials"
                    }),
                    selectedCamera ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                            fontSize: 12,
                            mt: 0.5,
                            mb: 1.25,
                            color: credentialNote().color
                        },
                        children: credentialNote().text
                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                            fontSize: 12,
                            color: "#6b7280",
                            mt: 0.5,
                            mb: 1.25
                        },
                        children: "Used for the ONVIF and RTSP checks. Nothing typed here is saved to the camera."
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                        sx: {
                            display: "flex",
                            gap: 1
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                sx: {
                                    flex: 1
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)($9ae8014b249d4f18$var$Field, {
                                    label: "Username",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        fullWidth: true,
                                        size: "small",
                                        autoComplete: "off",
                                        value: username,
                                        onChange: (event)=>{
                                            const nextValue = event.target.value;
                                            setUsername(nextValue);
                                        },
                                        disabled: running,
                                        sx: $9ae8014b249d4f18$var$fieldSx
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                sx: {
                                    flex: 1
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)($9ae8014b249d4f18$var$Field, {
                                    label: "Password",
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                                        fullWidth: true,
                                        size: "small",
                                        type: "password",
                                        autoComplete: "new-password",
                                        value: password,
                                        onChange: (event)=>{
                                            const nextValue = event.target.value;
                                            setPassword(nextValue);
                                        },
                                        disabled: running,
                                        sx: $9ae8014b249d4f18$var$fieldSx
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                sx: {
                    px: 2,
                    py: 1.5,
                    flexShrink: 0,
                    borderTop: (0, $f78cbb54da682e17$export$d528bb51d10101d)
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                        fullWidth: true,
                        variant: "contained",
                        disableElevation: true,
                        onClick: onRun,
                        disabled: running || tunnelId == null,
                        startIcon: running ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $60vL1.default), {
                            size: 16,
                            sx: {
                                color: "#fff"
                            }
                        }) : undefined,
                        sx: {
                            ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                            textTransform: "none",
                            fontWeight: 700,
                            fontSize: 14,
                            py: 1,
                            backgroundColor: "#FF8400",
                            "&:hover": {
                                backgroundColor: "#E67300"
                            }
                        },
                        children: running ? "Running\u2026" : "Run diagnostics"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                        sx: {
                            ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                            fontSize: 11.5,
                            color: "#6b7280",
                            mt: 1,
                            textAlign: "center"
                        },
                        children: "Tunnel checks run first (~15s), then the device checks."
                    })
                ]
            })
        ]
    });
};



var $195EM = parcelRequire("195EM");
const $927f7fe92af361b9$export$310e82af982d8687 = async (tunnelId)=>{
    const AxiosUI = (0, $195EM.createApi)("");
    const response = await AxiosUI.get(`network-vpn-debug/targets/?tunnel_id=${tunnelId}`);
    return response.data;
};



var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");

/**
 * Wire types for the VPN debugger API (admin `api/serializers/network_vpn_debug/`).
 *
 * These mirror the server's `diagnosis.build_result()` payload exactly. The step
 * id list is a *contract*, not presentation — the server returns every step in
 * ladder order, and the UI draws them all before any result exists.
 *
 * Keep this union in step with `diagnosis.STEP_ORDER`. A step the server sends
 * and this list omits renders under its raw id with no title; `assertKnownSteps`
 * in vpnDebugConstants turns that silent drift into a console warning.
 */ const $0f5898f2e22317bc$export$21c93bcb302f801b = (result)=>Boolean(result) && result.audience === "customer";




/** The codes the banner knows how to style. */ const $ad7f91e23ef00b35$var$CLASSIFICATION_CODES = [
    "tunnel_down",
    "routing_firewall",
    "service_unreachable",
    "auth_failure",
    "stream_encoding",
    "healthy",
    "inconclusive"
];
const $ad7f91e23ef00b35$export$4b51bc8842ae2b68 = (result)=>({
        schema_version: result.schema_version,
        tunnel: {
            id: result.tunnel?.id ?? 0,
            name: "",
            gateway_name: "",
            gateway_instance_id: ""
        },
        target: {
            host: ""
        },
        planned_step_ids: [
            ...(0, $f78cbb54da682e17$export$fe5882e1cacea70d)
        ],
        steps: (result.steps || []).map((step)=>({
                id: step.id,
                order: step.order,
                title: step.title,
                status: step.status,
                decisive: null,
                reason_code: step.reason_code,
                summary: step.summary,
                diagnosis: step.detail || null,
                next_action: step.next_action,
                skipped_reason: step.status === "skipped" ? step.detail || null : null,
                partial: false,
                confidence: "",
                evidence: {},
                duration_ms: null
            })),
        classification: {
            // Same code vocabulary on both sides, so the banner colours the verdict
            // correctly; anything unrecognised falls back rather than throwing.
            code: $ad7f91e23ef00b35$var$CLASSIFICATION_CODES.includes(result.verdict?.code) ? result.verdict.code : "inconclusive",
            label: result.verdict?.owner_label || "",
            owner: "unknown",
            confidence: "",
            summary: result.verdict?.headline || "",
            evidence_step_ids: [],
            next_actions: result.verdict?.next_actions || []
        },
        degraded: [],
        cli_missing: false
    });
const $ad7f91e23ef00b35$export$2d5572d875fc964c = (result)=>{
    if (!result) return null;
    return (0, $0f5898f2e22317bc$export$21c93bcb302f801b)(result) ? $ad7f91e23ef00b35$export$4b51bc8842ae2b68(result) : result;
};



const $fb96fbc86671df37$export$dcfa6d7d4d673cf2 = (reason, fallback)=>{
    const data = reason.response?.data;
    if (typeof data === "string" && data.trim() !== "") return data;
    if (!data || typeof data !== "object") return fallback;
    if (typeof data.error === "string" && data.error.trim() !== "") return data.error;
    // DRF field errors: take the first message we can find, prefixed with its
    // field unless it is the catch-all.
    for (const [field, value] of Object.entries(data)){
        const message = Array.isArray(value) ? value[0] : value;
        if (typeof message === "string" && message.trim() !== "") return field === "non_field_errors" ? message : `${field}: ${message}`;
    }
    return fallback;
};



var $195EM = parcelRequire("195EM");


const $d765ad42bda8d981$export$f475230321aa6939 = (taskId, token, startedAt, label)=>new Promise((resolve, reject)=>{
        const tick = ()=>{
            if (token !== (0, $d780a4127f4a85f5$export$58caa69774d352e0).getState().runToken) {
                resolve(null);
                return;
            }
            if (Date.now() - startedAt > (0, $f78cbb54da682e17$export$83e46e2a99cad5f4)) {
                reject(new Error(`${label} timed out after 10 minutes.`));
                return;
            }
            const AxiosUI = (0, $195EM.createApi)("");
            AxiosUI.get(`network-vpn-debug/${taskId}/`).then((response)=>{
                if (token !== (0, $d780a4127f4a85f5$export$58caa69774d352e0).getState().runToken) {
                    resolve(null);
                    return;
                }
                const data = response.data || {};
                if (data.status === "success") {
                    resolve(data.result ?? null);
                    return;
                }
                if (data.status === "failed") {
                    reject(new Error(data.detail || data.error || `${label} failed.`));
                    return;
                }
                // pending (or an unknown task id, which the server also reports as
                // pending because an enqueued-but-unclaimed job has no row yet)
                setTimeout(tick, (0, $f78cbb54da682e17$export$ee14340141c11674));
            }, ()=>{
                setTimeout(tick, (0, $f78cbb54da682e17$export$ee14340141c11674));
            });
        };
        tick();
    });


/**
 * Runs the diagnostic ladder as two sequential jobs — tunnel plane, then device
 * plane — rendering each half as it lands.
 *
 * The split is not a UX nicety. `_emit_compressed` runs under `set -euo
 * pipefail` on the gateway, so a single monolithic SSM invocation loses
 * everything when any part fails, including `tunnel_down` — which is decidable
 * from the tunnel plane alone and is the commonest answer. The tunnel plane also
 * carries no credentials, so its S3-persisted SSM output holds no secret
 * material. And admin configures no CACHES, so the qcluster worker cannot
 * publish per-step progress to the web pod: two jobs are what buys progressive
 * rendering, with no new infrastructure.
 *
 * Three behaviours are load-bearing and should survive future edits:
 *   1. Polling keeps going through transient network errors until the wall clock
 *      cap (see pollVpnDebugTask). A dropped packet must not kill a two-minute job.
 *   2. Every write checks the active run token first. Without it, starting a
 *      second run lets the first one's late response overwrite the new ladder.
 *   3. Skipped steps are merged, never allowed to overwrite a completed step.
 *      The device plane replays the tunnel steps as `skipped` because it did not
 *      run them; keeping the tunnel plane's real answers is the whole point of
 *      splitting the run.
 */ const $e93913ad2ac614d2$var$isCurrent = (token)=>token === (0, $d780a4127f4a85f5$export$58caa69774d352e0).getState().runToken;
const $e93913ad2ac614d2$export$6dd2479399165b0e = (payload)=>{
    // Both audiences funnel through here -- tunnel plane, device plane and the
    // flow window -- so this is the one place the customer payload has to be
    // widened. Branching per renderer instead would put the tenancy boundary in
    // three components and leak through whichever one was missed.
    const result = (0, $ad7f91e23ef00b35$export$2d5572d875fc964c)(payload);
    if (!result) return;
    // Surface ladder drift rather than rendering an unknown step under its raw id.
    (0, $f78cbb54da682e17$export$986932cebbe2048f)((result.steps || []).map((step)=>step.id));
    const store = (0, $d780a4127f4a85f5$export$58caa69774d352e0).getState();
    const steps = {
        ...store.steps
    };
    (result.steps || []).forEach((step)=>{
        const existing = steps[step.id];
        if (existing && existing.status !== "skipped" && step.status === "skipped") return;
        steps[step.id] = step;
    });
    store.setSteps(steps);
    // Remember which steps a customer payload carries (a union, so a partial
    // payload can only ever add). An operator payload clears it.
    if ((0, $0f5898f2e22317bc$export$21c93bcb302f801b)(payload)) {
        const seen = new Set(store.customerStepIds || []);
        (payload.steps || []).forEach((step)=>seen.add(step.id));
        store.setCustomerStepIds((0, $f78cbb54da682e17$export$fe5882e1cacea70d).filter((id)=>seen.has(id)));
    } else store.setCustomerStepIds(null);
    // A plane that saw only its own half reports `inconclusive`; never let that
    // displace a real verdict the other plane already produced.
    const incoming = result.classification;
    if (incoming && (incoming.code !== "inconclusive" || !store.classification)) store.setClassification(incoming);
};
const $e93913ad2ac614d2$var$postVpnDebugJob = (path, body, navigate, retryFunction, fallbackMessage)=>new Promise((resolve, reject)=>{
        const AxiosUI = (0, $195EM.createApi)("");
        AxiosUI.post(path, body).then((response)=>{
            resolve(response.data);
        }, (reason)=>{
            // When the handler decides to refresh the token and retry, it calls
            // retryFunction and this promise never settles — the retried run bumps
            // runToken, so the chain hanging off it is already dead.
            (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                reject(new Error((0, $fb96fbc86671df37$export$dcfa6d7d4d673cf2)(reason, fallbackMessage)));
            });
        });
    });
const $e93913ad2ac614d2$export$7cc384715657f661 = async ({ navigate: navigate })=>{
    const start = (0, $d780a4127f4a85f5$export$58caa69774d352e0).getState();
    const tunnelId = start.tunnelId;
    if (tunnelId == null) return;
    // Bump the token before anything else so any in-flight older run stops writing.
    const token = start.nextRunToken();
    const retryFunction = ()=>{
        $e93913ad2ac614d2$export$7cc384715657f661({
            navigate: navigate
        });
    };
    const cameraId = start.selectedCameraId;
    const candidate = cameraId ? [
        ...start.targets?.cameras || [],
        ...start.targets?.other_cameras || []
    ].find((entry)=>entry.camera_id === cameraId) || null : null;
    const typedHost = start.host.trim();
    // The address the ladder probes. Also handed to the tunnel plane as `target`
    // so `ip route get` has something to resolve — admin's console only does that
    // on the manual-host path, which silently costs the camera path (the preferred
    // one) all three route-shaped reason codes under tunnel_status.
    const targetAddress = candidate?.ip?.trim() || typedHost;
    const hasTarget = cameraId != null || typedHost !== "";
    // Two request shapes, and which one we send is decided by whether the
    // operator changed the credential.
    //
    // Untouched: send `camera_id`. The server resolves the secret itself through
    // the CredentialOwner accessors (camera, then site), no password crosses the
    // wire, and `expected_codec` comes off the camera record so media_inspection
    // can still fail a stream that does not match what admin has recorded.
    //
    // Edited: send the manual `host` path instead. `_resolve_credential` returns
    // the *stored* secret whenever a camera_id is present and ignores anything
    // supplied alongside it, so dropping camera_id is the only way to make an
    // override take effect. The cost is `expected_codec`, which the device
    // serializer has no field for — so an overridden run cannot raise
    // `media_inspection.unexpected_encoding`. Normal runs keep it.
    const overrideCredential = cameraId != null && start.credentialEdited;
    const deviceBody = {
        tunnel_id: tunnelId
    };
    if (cameraId != null && !overrideCredential) deviceBody.camera_id = cameraId;
    else deviceBody.host = overrideCredential ? targetAddress : typedHost;
    const rtspPort = parseInt(start.rtspPort, 10);
    const onvifPort = parseInt(start.onvifPort, 10);
    if (rtspPort) deviceBody.rtsp_port = rtspPort;
    if (onvifPort) deviceBody.onvif_port = onvifPort;
    const username = start.username.trim();
    const password = start.password;
    if (username || password) deviceBody.credentials = [
        {
            username: username,
            password: password
        }
    ];
    start.resetRun();
    start.setRunning(true);
    start.setStage("Checking the tunnel on the gateway\u2026");
    // Every step is outstanding until its plane reports.
    start.setPendingSteps([
        ...(0, $f78cbb54da682e17$export$fe5882e1cacea70d)
    ]);
    start.setStatus("Running tunnel checks on the gateway\u2026");
    const startedAt = Date.now();
    const finishRun = (message)=>{
        const store = (0, $d780a4127f4a85f5$export$58caa69774d352e0).getState();
        store.setRunning(false);
        store.setStage("");
        store.setPendingSteps([]);
        store.setStatus(message);
    };
    try {
        const tunnelJob = await $e93913ad2ac614d2$var$postVpnDebugJob("network-vpn-debug/tunnel/", {
            tunnel_id: tunnelId,
            target: targetAddress
        }, navigate, retryFunction, "Could not start the tunnel checks.");
        if (!$e93913ad2ac614d2$var$isCurrent(token)) return;
        const tunnelResult = await (0, $d765ad42bda8d981$export$f475230321aa6939)(tunnelJob.task_id, token, startedAt, "Tunnel checks");
        if (!$e93913ad2ac614d2$var$isCurrent(token)) return;
        (0, $d780a4127f4a85f5$export$58caa69774d352e0).getState().setPendingSteps((0, $d780a4127f4a85f5$export$58caa69774d352e0).getState().pendingSteps.filter((id)=>!(0, $f78cbb54da682e17$export$890d393a6e6704bf).includes(id)));
        $e93913ad2ac614d2$export$6dd2479399165b0e(tunnelResult);
        const tunnelStep = (tunnelResult?.steps || []).find((step)=>step.id === "tunnel_status");
        // The flow window answers a TUNNEL question, so the offer has to be made
        // before the no-target exit below. Admin's console had this the other way
        // round and the button was unreachable in the one configuration an operator
        // debugging a dead tunnel actually uses: no camera, no host, just "is this
        // thing up" (actuate_admin #2899).
        const staleHandshake = Boolean(tunnelStep && tunnelStep.status === "fail" && tunnelStep.reason_code && (0, $f78cbb54da682e17$export$2619df4efe1fac76).includes(tunnelStep.reason_code));
        if (staleHandshake) {
            const current = (0, $d780a4127f4a85f5$export$58caa69774d352e0).getState();
            current.setFlowTunnelTaskId(tunnelJob.task_id);
            current.setFlowOffered(true);
        }
        if (!hasTarget) {
            // No target is a legitimate way to ask for tunnel checks alone — which is
            // why there is no separate button for it.
            finishRun(staleHandshake ? "Tunnel checks complete, but the handshake is stale." : "Tunnel checks complete. Pick a camera or enter a host to check a device too.");
            return;
        }
        if (tunnelStep && tunnelStep.status === "fail") {
            // Device checks cannot succeed through a dead tunnel, and the ladder
            // already says so. Spending another 60-120s to prove it helps nobody.
            finishRun("Tunnel is down \u2014 device checks skipped. Fix the tunnel first.");
            return;
        }
        const running = (0, $d780a4127f4a85f5$export$58caa69774d352e0).getState();
        running.setStage("Checking the device through the tunnel\u2026");
        running.setStatus("Running device checks (this can take a minute)\u2026");
        // Hand the device plane this run's tunnel task id so the server can classify
        // the complete ladder. Without it each plane only ever sees its own half and
        // an all-green run reports "inconclusive".
        deviceBody.tunnel_task_id = tunnelJob.task_id;
        const deviceJob = await $e93913ad2ac614d2$var$postVpnDebugJob("network-vpn-debug/device/", deviceBody, navigate, retryFunction, "Could not start the device checks.");
        if (!$e93913ad2ac614d2$var$isCurrent(token)) return;
        const deviceResult = await (0, $d765ad42bda8d981$export$f475230321aa6939)(deviceJob.task_id, token, startedAt, "Device checks");
        if (!$e93913ad2ac614d2$var$isCurrent(token)) return;
        (0, $d780a4127f4a85f5$export$58caa69774d352e0).getState().setPendingSteps([]);
        $e93913ad2ac614d2$export$6dd2479399165b0e(deviceResult);
        finishRun("Diagnostics complete.");
    } catch (error) {
        if (!$e93913ad2ac614d2$var$isCurrent(token)) return;
        // Clear `running` so whatever DID complete gets a verdict rather than being
        // stuck behind a progress banner forever.
        const store = (0, $d780a4127f4a85f5$export$58caa69774d352e0).getState();
        store.setRunning(false);
        store.setStage("");
        store.setPendingSteps([]);
        store.setStatus(error instanceof Error ? error.message : String(error), true);
    }
};



var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");





const $544583370bf59da5$export$ed47ca9a7bc3c021 = async (tunnelId, tunnelTaskId, navigate, retryFunction)=>{
    const store = (0, $d780a4127f4a85f5$export$58caa69774d352e0).getState();
    const token = store.runToken;
    const startedAt = Date.now();
    store.setFlowOffered(false);
    store.setRunning(true);
    store.setStage("Watching the wire on the gateway\u2026");
    store.setPendingSteps([
        "tunnel_flow"
    ]);
    store.setStatus(`Watching for ${(0, $f78cbb54da682e17$export$575c774f27df8d17)}s. Best run while the tunnel at ` + "the site is being restarted.");
    const isCurrent = ()=>token === (0, $d780a4127f4a85f5$export$58caa69774d352e0).getState().runToken;
    const finish = (message, isError = false)=>{
        const current = (0, $d780a4127f4a85f5$export$58caa69774d352e0).getState();
        current.setRunning(false);
        current.setStage("");
        current.setPendingSteps([]);
        current.setStatus(message, isError);
    };
    try {
        const job = await new Promise((resolve, reject)=>{
            const AxiosUI = (0, $195EM.createApi)("");
            AxiosUI.post("network-vpn-debug/flow/", {
                tunnel_id: tunnelId,
                tunnel_task_id: tunnelTaskId,
                window_seconds: (0, $f78cbb54da682e17$export$575c774f27df8d17)
            }).then((response)=>resolve(response.data), (reason)=>{
                (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
                    reject(new Error((0, $fb96fbc86671df37$export$dcfa6d7d4d673cf2)(reason, "Could not start the packet-flow window.")));
                });
            });
        });
        if (!isCurrent()) return;
        const result = await (0, $d765ad42bda8d981$export$f475230321aa6939)(job.task_id, token, startedAt, "Packet flow");
        if (!isCurrent()) return;
        (0, $e93913ad2ac614d2$export$6dd2479399165b0e)(result);
        finish("Packet-flow window complete.");
    } catch (error) {
        if (!isCurrent()) return;
        finish(error instanceof Error ? error.message : String(error), true);
    }
};



const $a65806c5ef8b2069$var$COUNT_ORDER = [
    "pass",
    "fail",
    "warn",
    "skipped"
];
const $a65806c5ef8b2069$export$7424f81ed22b3825 = ({ tunnels: tunnels, getServerName: getServerName })=>{
    const navigate = (0, $3T949.useNavigate)();
    const { tunnelId: tunnelId, targetsError: targetsError, setTargets: setTargets, setTargetsLoading: setTargetsLoading, setTargetsError: setTargetsError, setSelectedCameraId: setSelectedCameraId, steps: steps, pendingSteps: pendingSteps, classification: classification, customerStepIds: customerStepIds, running: running, stage: stage, statusMessage: statusMessage, statusIsError: statusIsError, flowOffered: flowOffered, flowTunnelTaskId: flowTunnelTaskId, reset: reset } = (0, $d780a4127f4a85f5$export$58caa69774d352e0)();
    // Start each visit from a clean slate (no stale ladder or target).
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Camera candidates for the picker. Synchronous server-side — no SSM, so this
    // is cheap enough to refetch on every tunnel change.
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (tunnelId == null) {
            setTargets(null);
            setTargetsError("");
            return;
        }
        let cancelled = false;
        setSelectedCameraId(null);
        setTargetsLoading(true);
        setTargetsError("");
        (0, $927f7fe92af361b9$export$310e82af982d8687)(tunnelId).then((data)=>{
            if (cancelled) return;
            setTargets(data);
        }).catch(()=>{
            if (cancelled) return;
            setTargets(null);
            setTargetsError("Failed to load cameras for this tunnel.");
        }).finally(()=>{
            if (!cancelled) setTargetsLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tunnelId
    ]);
    // Evidence auto-expands on the first failing step only: that is the one thing
    // the operator opened this tab for.
    const firstFailingStepId = (0, $f78cbb54da682e17$export$fe5882e1cacea70d).find((id)=>steps[id]?.status === "fail");
    const counts = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>{
        const tally = {};
        (0, $f78cbb54da682e17$export$fe5882e1cacea70d).forEach((id)=>{
            const status = steps[id]?.status;
            if (status) tally[status] = (tally[status] || 0) + 1;
        });
        return tally;
    }, [
        steps
    ]);
    const hasResults = Object.keys(counts).length > 0;
    // null = operator, or no result yet: draw the whole ladder.
    const visibleStepIds = customerStepIds ? (0, $f78cbb54da682e17$export$fe5882e1cacea70d).filter((id)=>customerStepIds.includes(id)) : (0, $f78cbb54da682e17$export$fe5882e1cacea70d);
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3IuQ3.default), {
        direction: "row",
        gap: 2,
        alignItems: "stretch",
        sx: {
            height: "100%",
            minHeight: 0,
            minWidth: 900,
            overflowX: "auto"
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $4reBM.default), {
                sx: {
                    flex: 1,
                    minWidth: 520,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    borderRadius: 2,
                    borderTop: (0, $f78cbb54da682e17$export$d528bb51d10101d)
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                        sx: {
                            px: 2.5,
                            py: 1.25,
                            flexShrink: 0,
                            borderBottom: (0, $f78cbb54da682e17$export$d528bb51d10101d),
                            backgroundColor: "white",
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5,
                            flexWrap: "wrap",
                            minHeight: 46
                        },
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                sx: {
                                    ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                                    fontWeight: 700,
                                    fontSize: 14
                                },
                                children: "DIAGNOSTIC LADDER"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                sx: {
                                    flexGrow: 1
                                }
                            }),
                            hasResults && $a65806c5ef8b2069$var$COUNT_ORDER.filter((status)=>counts[status]).map((status)=>{
                                const style = (0, $f78cbb54da682e17$export$34a6f089e328cef5)[status];
                                return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                                    component: "span",
                                    sx: {
                                        ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                                        fontSize: 11.5,
                                        fontWeight: 700,
                                        color: style.color,
                                        backgroundColor: style.backgroundColor,
                                        borderRadius: "999px",
                                        px: 1,
                                        py: "2px"
                                    },
                                    children: [
                                        counts[status],
                                        " ",
                                        style.label.toLowerCase()
                                    ]
                                }, status);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                        sx: {
                            px: 2.5,
                            py: 2,
                            overflowY: "auto",
                            flex: 1,
                            minHeight: 0
                        },
                        children: [
                            targetsError && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                                severity: "warning",
                                sx: {
                                    ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                                    mb: 2
                                },
                                children: targetsError
                            }),
                            statusMessage && statusIsError && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                                severity: "error",
                                sx: {
                                    ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                                    mb: 2
                                },
                                children: statusMessage
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $2ffe1bc08e202417$export$d0bedf8a2ad3823e), {
                                running: running,
                                stage: stage,
                                steps: steps,
                                pendingSteps: pendingSteps,
                                classification: classification
                            }),
                            !running && !hasResults && !statusIsError && /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                sx: {
                                    ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                                    fontSize: 13,
                                    color: "#6b7280",
                                    mb: 2.5
                                },
                                children: "Pick a tunnel and a camera, then run the ladder. Every check runs from the tunnel's WireGuard gateway \u2014 the only host that can route into the site's network \u2014 and reports a diagnosis and a next action."
                            }),
                            statusMessage && !statusIsError && !running && /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                sx: {
                                    ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                                    fontSize: 13,
                                    color: "#6b7280",
                                    mb: 2.5
                                },
                                children: statusMessage
                            }),
                            flowOffered && !running && tunnelId != null && /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                                sx: {
                                    mb: 2.5
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                        sx: {
                                            ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                                            fontSize: 13,
                                            color: "#6b7280",
                                            mb: 1
                                        },
                                        children: "The handshake is stale. Watch the gateway to see whether packets from the site arrive at all."
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                                        variant: "outlined",
                                        size: "small",
                                        "data-testid": "watch-packet-flow-button",
                                        onClick: ()=>{
                                            (0, $544583370bf59da5$export$ed47ca9a7bc3c021)(tunnelId, flowTunnelTaskId, navigate, ()=>{
                                                (0, $544583370bf59da5$export$ed47ca9a7bc3c021)(tunnelId, flowTunnelTaskId, navigate, ()=>undefined);
                                            });
                                        },
                                        sx: {
                                            ...(0, $f78cbb54da682e17$export$d0e02a3e834eb2cd),
                                            textTransform: "none"
                                        },
                                        children: `Watch packet flow for ${(0, $f78cbb54da682e17$export$575c774f27df8d17)}s`
                                    })
                                ]
                            }),
                            visibleStepIds.map((stepId, index)=>/*#__PURE__*/ (0, $k4ank.jsx)((0, $ed392f0ec626405d$export$b1da33d07e8eac37), {
                                    stepId: stepId,
                                    step: steps[stepId],
                                    isPending: running && pendingSteps.includes(stepId),
                                    autoExpandEvidence: stepId === firstFailingStepId,
                                    isLast: index === visibleStepIds.length - 1
                                }, stepId))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                sx: {
                    height: "100%",
                    minHeight: 0,
                    flexShrink: 0,
                    width: (0, $f78cbb54da682e17$export$289d5a40a63935cc)
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $9ae8014b249d4f18$export$8dbfa1da3ec339c3), {
                    tunnels: tunnels,
                    getServerName: getServerName,
                    onRun: ()=>{
                        (0, $e93913ad2ac614d2$export$7cc384715657f661)({
                            navigate: navigate
                        });
                    }
                })
            })
        ]
    });
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");
var $a65wX = parcelRequire("a65wX");
var $3IuQ3 = parcelRequire("3IuQ3");
var $f3puC = parcelRequire("f3puC");


const $c8672cdce228b41d$export$3e0c26fbc285f1b3 = (device, tunnels)=>{
    const tunnelRef = device.tunnel;
    if (!tunnelRef) return null;
    if (tunnelRef.tunnel_id != null) {
        const matchedById = tunnels.find((tunnel)=>tunnel.id === tunnelRef.tunnel_id);
        if (matchedById) return matchedById;
    }
    const tunnelName = tunnelRef.tunnel_name?.trim();
    if (!tunnelName) return null;
    return tunnels.find((tunnel)=>tunnel.name === tunnelName) ?? null;
};



var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $eDfvp = parcelRequire("eDfvp");
const $5565c8cd79871ace$export$96b37c9b6cdc0ef6 = ({ tunnelName: tunnelName, matchedTunnel: matchedTunnel, onOpenTunnel: onOpenTunnel })=>{
    if (!tunnelName) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
        children: "-"
    });
    if (!matchedTunnel) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
        children: tunnelName
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
        component: "button",
        type: "button",
        onClick: (event)=>{
            event.stopPropagation();
            onOpenTunnel(matchedTunnel);
        },
        sx: {
            fontFamily: "Mulish",
            fontSize: "inherit",
            color: "#283E6D",
            textDecoration: "underline",
            cursor: "pointer",
            p: 0,
            border: 0,
            background: "none",
            textAlign: "left",
            overflowWrap: "anywhere",
            wordBreak: "break-word"
        },
        children: tunnelName
    });
};


const $48759305553339af$var$Row = ({ label: label, value: value })=>/*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                sx: {
                    fontFamily: "Mulish",
                    fontSize: 12,
                    color: "#5f6368"
                },
                children: label
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                sx: {
                    fontFamily: "Mulish",
                    fontSize: 14,
                    overflowWrap: "anywhere",
                    wordBreak: "break-word"
                },
                children: value
            })
        ]
    });
const $48759305553339af$var$displayValue = (value)=>{
    if (value == null || value === "") return "-";
    return value;
};
const $48759305553339af$var$formatLastHandshake = (lastHandshake)=>{
    if (!lastHandshake) return "Never";
    const parsed = new Date(lastHandshake);
    if (!Number.isFinite(parsed.getTime())) return "-";
    return parsed.toLocaleString("en-US");
};
const $48759305553339af$export$92b53b993c6be367 = ({ open: open, selectedDevice: selectedDevice, onClose: onClose, wireguardTunnels: wireguardTunnels, onOpenWireguardTunnel: onOpenWireguardTunnel })=>{
    const tunnel = selectedDevice?.tunnel;
    const matchedTunnel = selectedDevice ? (0, $c8672cdce228b41d$export$3e0c26fbc285f1b3)(selectedDevice, wireguardTunnels) : null;
    const tunnelName = selectedDevice ? (0, $2652805b503ba213$export$5bb9905dc7b47806)(selectedDevice) : "";
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $14dd0c4334b54826$export$2e2bcd8739ae039), {
        anchor: "right",
        open: open,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
            sx: {
                width: 420,
                p: 3
            },
            children: [
                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3IuQ3.default), {
                    direction: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                            sx: {
                                fontFamily: "Mulish",
                                fontSize: 22,
                                fontWeight: 700
                            },
                            children: "Edge Device Details"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                            onClick: onClose,
                            sx: {
                                fontFamily: "Mulish",
                                textTransform: "none"
                            },
                            children: "Close"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $c092706b06a9e6ab$export$2e2bcd8739ae039), {
                    sx: {
                        my: 2
                    }
                }),
                selectedDevice ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3IuQ3.default), {
                    gap: 3,
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)($48759305553339af$var$Row, {
                            label: "Serial Number",
                            value: $48759305553339af$var$displayValue(selectedDevice.serial_number)
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)($48759305553339af$var$Row, {
                            label: "Mac Address",
                            value: $48759305553339af$var$displayValue(selectedDevice.mac_address)
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)($48759305553339af$var$Row, {
                            label: "Manufacturer",
                            value: $48759305553339af$var$displayValue(selectedDevice.manufacturer)
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)($48759305553339af$var$Row, {
                            label: "Sku",
                            value: $48759305553339af$var$displayValue(selectedDevice.sku)
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)($48759305553339af$var$Row, {
                            label: "Provisioning State",
                            value: $48759305553339af$var$displayValue(selectedDevice.provisioning_state)
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $c092706b06a9e6ab$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                            sx: {
                                fontFamily: "Mulish",
                                fontSize: 16,
                                fontWeight: 700
                            },
                            children: "Wireguard Tunnel Details"
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                            children: [
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                    sx: {
                                        fontFamily: "Mulish",
                                        fontSize: 12,
                                        color: "#5f6368"
                                    },
                                    children: "Wireguard Tunnel Name"
                                }),
                                /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                                    component: "div",
                                    sx: {
                                        fontFamily: "Mulish",
                                        fontSize: 14,
                                        overflowWrap: "anywhere",
                                        wordBreak: "break-word"
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $5565c8cd79871ace$export$96b37c9b6cdc0ef6), {
                                        tunnelName: tunnelName,
                                        matchedTunnel: matchedTunnel,
                                        onOpenTunnel: onOpenWireguardTunnel
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)($48759305553339af$var$Row, {
                            label: "Firmware Version",
                            value: $48759305553339af$var$displayValue(selectedDevice.firmware_version)
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)($48759305553339af$var$Row, {
                            label: "Site Name",
                            value: $48759305553339af$var$displayValue(selectedDevice.site_name)
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)($48759305553339af$var$Row, {
                            label: "Deployment Location",
                            value: $48759305553339af$var$displayValue(selectedDevice.deployment_location)
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)($48759305553339af$var$Row, {
                            label: "Wireguard Tunnel Status",
                            value: (0, $3f5432f1e85a6ce2$export$7e4f333133ecc582)(tunnel?.last_handshake ?? null)
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)($48759305553339af$var$Row, {
                            label: "Last Handshake",
                            value: $48759305553339af$var$formatLastHandshake(tunnel?.last_handshake)
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)($48759305553339af$var$Row, {
                            label: "Client Tunnel IP",
                            value: $48759305553339af$var$displayValue(tunnel?.client_tunnel_ip)
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)($48759305553339af$var$Row, {
                            label: "Server Name",
                            value: $48759305553339af$var$displayValue(tunnel?.server_name)
                        })
                    ]
                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $f3puC.default), {
                    sx: {
                        fontFamily: "Mulish"
                    },
                    children: "Select an edge device to view details."
                })
            ]
        })
    });
};



var $4PFLW = parcelRequire("4PFLW");

const $dea2073815687b34$export$8d8f5d6f38f37651 = (tunnels, filters, parentAccounts)=>{
    const parentGroupNameById = new Map();
    parentAccounts.forEach((parent)=>{
        parentGroupNameById.set(parent.id, parent.name);
    });
    const searchLower = filters.searchText.trim().toLowerCase();
    return tunnels.filter((tunnel)=>{
        const tunnelStatus = (0, $3f5432f1e85a6ce2$export$7e4f333133ecc582)(tunnel.last_handshake);
        if (filters.groupIds.length > 0 && (tunnel.group === null || !filters.groupIds.includes(tunnel.group))) return false;
        if (filters.serverIds.length > 0 && (tunnel.server === null || !filters.serverIds.includes(tunnel.server))) return false;
        if (filters.tunnelStatuses.length > 0 && !filters.tunnelStatuses.includes(tunnelStatus)) return false;
        if (filters.subnetVirtuallyAssigned === "yes" && !tunnel.subnets_are_virtually_assigned) return false;
        if (filters.subnetVirtuallyAssigned === "no" && tunnel.subnets_are_virtually_assigned) return false;
        if (!searchLower) return true;
        const haystack = [
            tunnel.name,
            tunnel.client_tunnel_ip,
            tunnel.client_public_key,
            tunnel.subnets?.join(" ") ?? "",
            tunnelStatus,
            tunnel.group ? parentGroupNameById.get(tunnel.group) ?? "" : ""
        ].join(" ").toLowerCase();
        return haystack.includes(searchLower);
    });
};





const $7c5370c03631568b$var$defaultFilters = {
    groupIds: [],
    serverIds: [],
    tunnelStatuses: [],
    subnetVirtuallyAssigned: "all",
    searchText: ""
};
const $7c5370c03631568b$var$VIEWPORT_LAYOUT_FLOOR_PX = 1545;
const $7c5370c03631568b$var$EDGE_DEVICES_VIEWPORT_FLOOR_PX = 1300;
const $7c5370c03631568b$var$FILTERS_PANEL_WIDTH_PX = 340;
const $7c5370c03631568b$var$LAYOUT_STACK_GAP_PX = 16;
const $7c5370c03631568b$var$CONTENT_RIGHT_INSET_PX = 18;
const $7c5370c03631568b$var$TAB_BAND_HEIGHT_PX = 49;
const $7c5370c03631568b$export$be59470a5a0a96f2 = ({ navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed })=>{
    const navigate = (0, $3T949.useNavigate)();
    const { wireGuardOptions: wireGuardOptions, userPermissions: userPermissions } = (0, $aYdit.useAppStore)();
    const { isFeatureEnabled: isFeatureEnabled } = (0, $4PFLW.useFeatureFlag)();
    // ENG-278: creating/editing tunnels needs the create_wireguard_tunnels
    // permission. Viewing the list does not, so only the write controls are gated.
    const canCreateTunnels = Boolean(userPermissions?.create_wireguard_tunnels);
    // Every group the user can assign a tunnel to (ENG-272). Cached at login, but
    // fall back to the parent accounts this page fetches live so a cold or evicted
    // cache can't leave the required Group field with nothing to pick.
    const cachedGroups = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>(0, $5501f060781801f3$export$bc43bfddfdede5fd)(), []);
    const showEdgeDevices = isFeatureEnabled("showEdgeDevices", false);
    const [activeTab, setActiveTab] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("wireguard-tunnels");
    const [isLoading, setIsLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [edgeDevicesLoading, setEdgeDevicesLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [parentAccountsLoading, setParentAccountsLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(true);
    const [fetchError, setFetchError] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [allTunnels, setAllTunnels] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [allEdgeDevices, setAllEdgeDevices] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [edgeDeviceSearchText, setEdgeDeviceSearchText] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const [selectedTunnel, setSelectedTunnel] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [selectedEdgeDevice, setSelectedEdgeDevice] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(null);
    const [detailsOpen, setDetailsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [edgeDeviceDetailsOpen, setEdgeDeviceDetailsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [addDialogOpen, setAddDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [addEdgeDeviceDialogOpen, setAddEdgeDeviceDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [bulkUploadOpen, setBulkUploadOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [filters, setFilters] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState($7c5370c03631568b$var$defaultFilters);
    const [parentAccounts, setParentAccounts] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const accessibleGroups = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>cachedGroups.length > 0 ? cachedGroups : parentAccounts.map((account)=>({
                id: account.id,
                name: account.name,
                parent: null,
                parent_account: true
            })), [
        cachedGroups,
        parentAccounts
    ]);
    const [, setParentIds] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(new Map());
    const [parentNames, setParentNames] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(new Map());
    const [page, setPage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [edgeDevicesPage, setEdgeDevicesPage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(0);
    const [rowsPerPage, setRowsPerPage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(10);
    const [edgeDevicesRowsPerPage, setEdgeDevicesRowsPerPage] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(10);
    const [isExportingCsv, setIsExportingCsv] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [isDownloadingTemplate, setIsDownloadingTemplate] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        (0, $d48a20dfd96c3668$export$2361627156cf7f48)(setParentAccountsLoading, setParentAccounts, setParentIds, setParentNames, navigate);
    }, [
        navigate
    ]);
    const loadTunnels = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback(async ()=>{
        setIsLoading(true);
        try {
            const tunnels = await (0, $jBpii.fetchAllWireGuardTunnels)();
            setAllTunnels(tunnels);
            setFetchError("");
            return tunnels;
        } catch  {
            setFetchError("Failed to load WireGuard tunnels.");
            setAllTunnels([]);
            return [];
        } finally{
            setIsLoading(false);
        }
    }, []);
    const loadEdgeDevices = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback(async ()=>{
        setEdgeDevicesLoading(true);
        try {
            const devices = await (0, $689ad66d447894bb$export$cac4a218a65b6cba)();
            setAllEdgeDevices(devices);
            setFetchError("");
            return devices;
        } catch  {
            setFetchError("Failed to load edge devices.");
            setAllEdgeDevices([]);
            return [];
        } finally{
            setEdgeDevicesLoading(false);
        }
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        loadTunnels();
    }, [
        loadTunnels
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (showEdgeDevices && activeTab === "edge-devices") loadEdgeDevices();
    }, [
        activeTab,
        loadEdgeDevices,
        showEdgeDevices
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (activeTab === "wireguard-tunnels") {
            setEdgeDeviceDetailsOpen(false);
            setSelectedEdgeDevice(null);
        } else {
            setDetailsOpen(false);
            setSelectedTunnel(null);
        }
    }, [
        activeTab
    ]);
    const getGroupName = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback((groupId)=>{
        if (!groupId) return "Unassigned";
        if (parentNames.has(groupId)) return parentNames.get(groupId) || "Unknown group";
        const fromAccounts = parentAccounts.find((account)=>account.id === groupId);
        if (fromAccounts?.name) return fromAccounts.name;
        // parentAccounts only holds parent accounts, so a tunnel on a site-level
        // subgroup falls through to the full accessible list.
        const fromAccessible = accessibleGroups.find((group)=>group.id === groupId);
        return fromAccessible?.name || `Unknown group ${groupId}`;
    }, [
        accessibleGroups,
        parentAccounts,
        parentNames
    ]);
    const getServerName = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback((serverId)=>{
        if (!serverId) return "Unassigned";
        const matchedOption = wireGuardOptions.find((option)=>option.id === serverId);
        return matchedOption?.name || `Unknown server ${serverId}`;
    }, [
        wireGuardOptions
    ]);
    const getServerPublicKey = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback((serverId)=>{
        if (!serverId) return "-";
        const matchedOption = wireGuardOptions.find((option)=>option.id === serverId);
        return matchedOption?.server_public_key || "-";
    }, [
        wireGuardOptions
    ]);
    const filteredRows = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>(0, $dea2073815687b34$export$8d8f5d6f38f37651)(allTunnels, filters, parentAccounts), [
        allTunnels,
        filters,
        parentAccounts
    ]);
    const filteredEdgeDevices = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>(0, $2652805b503ba213$export$5943ca1e54075d01)(allEdgeDevices, edgeDeviceSearchText), [
        allEdgeDevices,
        edgeDeviceSearchText
    ]);
    const tunnelStatuses = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>{
        return Array.from(new Set(allTunnels.map((tunnel)=>(0, $3f5432f1e85a6ce2$export$7e4f333133ecc582)(tunnel.last_handshake)).filter((status)=>Boolean(status))));
    }, [
        allTunnels
    ]);
    const groupFilterOptions = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useMemo(()=>{
        const groupIdsInRows = new Set();
        allTunnels.forEach((tunnel)=>{
            if (typeof tunnel.group === "number") groupIdsInRows.add(tunnel.group);
        });
        const options = Array.from(groupIdsInRows).map((groupId)=>({
                id: groupId,
                name: getGroupName(groupId)
            }));
        return options.sort((a, b)=>a.name.localeCompare(b.name));
    }, [
        allTunnels,
        getGroupName
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setPage(0);
    }, [
        filters
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        setEdgeDevicesPage(0);
    }, [
        edgeDeviceSearchText
    ]);
    const handleExportCsv = async ()=>{
        setIsExportingCsv(true);
        const AxiosUI = (0, $195EM.createApi)("");
        try {
            const searchParams = new URLSearchParams();
            searchParams.set("all_levels", "true");
            if (filters.searchText.trim()) searchParams.set("search", filters.searchText.trim());
            filters.groupIds.forEach((groupId)=>{
                searchParams.append("group", String(groupId));
            });
            filters.serverIds.forEach((serverId)=>{
                searchParams.append("server", String(serverId));
            });
            filters.tunnelStatuses.forEach((status)=>{
                searchParams.append("tunnel_status", status.toLowerCase());
            });
            if (filters.subnetVirtuallyAssigned === "yes") searchParams.set("subnets_are_virtually_assigned", "true");
            else if (filters.subnetVirtuallyAssigned === "no") searchParams.set("subnets_are_virtually_assigned", "false");
            const endpoint = `wireguard_tunnel/export-csv/?${searchParams.toString()}`;
            const response = await AxiosUI.get(endpoint, {
                responseType: "blob"
            });
            const blob = new Blob([
                response.data
            ], {
                type: "text/csv"
            });
            (0, $iIAML.saveAs)(blob, "wireguard_tunnels_export.csv");
            setFetchError("");
        } catch  {
            setFetchError("Failed to export WireGuard tunnels CSV.");
        } finally{
            setIsExportingCsv(false);
        }
    };
    const handleDownloadCsvTemplate = async ()=>{
        setIsDownloadingTemplate(true);
        const AxiosUI = (0, $195EM.createApi)("");
        try {
            const response = await AxiosUI.get("wireguard_tunnel/csv-template/", {
                responseType: "blob"
            });
            const blob = new Blob([
                response.data
            ], {
                type: "text/csv"
            });
            (0, $iIAML.saveAs)(blob, "wireguard_tunnels_template.csv");
            setFetchError("");
        } catch  {
            setFetchError("Failed to download WireGuard tunnels CSV template.");
        } finally{
            setIsDownloadingTemplate(false);
        }
    };
    const handleOpenWireguardTunnelFromEdgeDevice = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useCallback((tunnel)=>{
        setEdgeDeviceDetailsOpen(false);
        setSelectedEdgeDevice(null);
        setSelectedTunnel(tunnel);
        setDetailsOpen(true);
        setActiveTab("wireguard-tunnels");
    }, []);
    const leftOffset = navBarCollapsed ? 75 : 150;
    const tabsLeftOffset = navBarCollapsed ? 95 : 170;
    const contentTopOffset = $7c5370c03631568b$var$TAB_BAND_HEIGHT_PX + 9;
    const contentMinWidth = $7c5370c03631568b$var$VIEWPORT_LAYOUT_FLOOR_PX - leftOffset - $7c5370c03631568b$var$CONTENT_RIGHT_INSET_PX;
    const tableMinWidth = contentMinWidth - $7c5370c03631568b$var$FILTERS_PANEL_WIDTH_PX - $7c5370c03631568b$var$LAYOUT_STACK_GAP_PX;
    const edgeDevicesContentMinWidth = $7c5370c03631568b$var$EDGE_DEVICES_VIEWPORT_FLOOR_PX - leftOffset - $7c5370c03631568b$var$CONTENT_RIGHT_INSET_PX;
    const effectiveTab = activeTab === "edge-devices" && !showEdgeDevices ? "wireguard-tunnels" : activeTab;
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                openState: isLoading || parentAccountsLoading || edgeDevicesLoading
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "absolute w-screen h-screen",
                style: {
                    background: `linear-gradient(to bottom, #FFFFFF 0px, #FFFFFF ${$7c5370c03631568b$var$TAB_BAND_HEIGHT_PX}px, #E5E5E5 ${$7c5370c03631568b$var$TAB_BAND_HEIGHT_PX}px, #E5E5E5 100%)`
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "absolute top-0 right-[1px] z-10",
                        style: {
                            left: `${tabsLeftOffset}px`
                        },
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $93261b072de7533b$export$83021195b5dcc364), {
                            activeTab: activeTab,
                            setActiveTab: setActiveTab,
                            showEdgeDevices: showEdgeDevices
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $eDfvp.default), {
                        sx: {
                            position: "absolute",
                            top: `${contentTopOffset}px`,
                            left: `${leftOffset}px`,
                            right: "10px",
                            bottom: "10px",
                            pr: 1
                        },
                        children: [
                            fetchError && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                                sx: {
                                    fontFamily: "Mulish",
                                    mb: 2
                                },
                                severity: "error",
                                children: fetchError
                            }),
                            effectiveTab === "wireguard-tunnels" ? /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3IuQ3.default), {
                                direction: "row",
                                gap: 2,
                                alignItems: "stretch",
                                sx: {
                                    height: "100%",
                                    minHeight: 0,
                                    minWidth: contentMinWidth,
                                    overflowX: "auto"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                        sx: {
                                            flex: 1,
                                            minWidth: tableMinWidth,
                                            height: "100%",
                                            minHeight: 0,
                                            flexShrink: 0
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $2750413bcc00e5b4$export$e98d2a9d6b1a19f8), {
                                            rows: filteredRows,
                                            searchText: filters.searchText,
                                            onSearchTextChange: (value)=>setFilters((prev)=>({
                                                        ...prev,
                                                        searchText: value
                                                    })),
                                            page: page,
                                            rowsPerPage: rowsPerPage,
                                            onPageChange: (_, newPage)=>setPage(newPage),
                                            onRowsPerPageChange: (event)=>{
                                                setRowsPerPage(parseInt(event.target.value, 10));
                                                setPage(0);
                                            },
                                            onRowClick: (row)=>{
                                                setSelectedTunnel(row);
                                                setDetailsOpen(true);
                                            },
                                            getGroupName: getGroupName,
                                            getServerName: getServerName,
                                            onDownloadCsvTemplate: handleDownloadCsvTemplate,
                                            isDownloadingTemplate: isDownloadingTemplate,
                                            onBulkUploadClick: ()=>setBulkUploadOpen(true),
                                            onExportCsv: handleExportCsv,
                                            isExportingCsv: isExportingCsv,
                                            onAddTunnelClick: ()=>setAddDialogOpen(true),
                                            canCreateTunnels: canCreateTunnels,
                                            onDeleteSelectedRows: async (selectedIds)=>{
                                                const AxiosUI = (0, $195EM.createApi)("");
                                                try {
                                                    await Promise.all(selectedIds.map((id)=>AxiosUI.delete(`wireguard_tunnel/${id}/`)));
                                                    const freshTunnels = await loadTunnels();
                                                    if (selectedTunnel && selectedIds.includes(selectedTunnel.id)) {
                                                        setDetailsOpen(false);
                                                        setSelectedTunnel(null);
                                                    } else if (selectedTunnel) {
                                                        const refreshedTunnel = freshTunnels.find((tunnel)=>tunnel.id === selectedTunnel.id) || null;
                                                        setSelectedTunnel(refreshedTunnel);
                                                    }
                                                } catch  {
                                                    setFetchError("Failed to delete selected WireGuard tunnels.");
                                                }
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                        sx: {
                                            height: "100%",
                                            minHeight: 0,
                                            flexShrink: 0
                                        },
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ada58adb1b934745$export$7e432690f6224add), {
                                            filters: filters,
                                            setFilters: setFilters,
                                            parentAccounts: groupFilterOptions,
                                            wireGuardOptions: wireGuardOptions,
                                            tunnelStatuses: tunnelStatuses
                                        })
                                    })
                                ]
                            }) : effectiveTab === "vpn-debugger" ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65806c5ef8b2069$export$7424f81ed22b3825), {
                                tunnels: allTunnels,
                                getServerName: getServerName
                            }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                sx: {
                                    height: "100%",
                                    minHeight: 0,
                                    minWidth: edgeDevicesContentMinWidth,
                                    overflowX: "auto"
                                },
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eDfvp.default), {
                                    sx: {
                                        height: "100%",
                                        minHeight: 0,
                                        minWidth: edgeDevicesContentMinWidth,
                                        flexShrink: 0
                                    },
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $e864e642f468f483$export$c814102b681efe0e), {
                                        rows: filteredEdgeDevices,
                                        searchText: edgeDeviceSearchText,
                                        onSearchTextChange: setEdgeDeviceSearchText,
                                        page: edgeDevicesPage,
                                        rowsPerPage: edgeDevicesRowsPerPage,
                                        onPageChange: (_, newPage)=>setEdgeDevicesPage(newPage),
                                        onRowsPerPageChange: (event)=>{
                                            setEdgeDevicesRowsPerPage(parseInt(event.target.value, 10));
                                            setEdgeDevicesPage(0);
                                        },
                                        onAddEdgeDeviceClick: ()=>setAddEdgeDeviceDialogOpen(true),
                                        onRowClick: (row)=>{
                                            setSelectedEdgeDevice(row);
                                            setEdgeDeviceDetailsOpen(true);
                                        },
                                        wireguardTunnels: allTunnels,
                                        onOpenWireguardTunnel: handleOpenWireguardTunnelFromEdgeDevice
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            showEdgeDevices && /*#__PURE__*/ (0, $k4ank.jsx)((0, $445fc6405cd0298a$export$886d99f87703aa90), {
                open: addEdgeDeviceDialogOpen,
                onClose: ()=>{
                    setAddEdgeDeviceDialogOpen(false);
                    if (activeTab === "edge-devices") loadEdgeDevices();
                }
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $5d81cbf7fbf7732e$export$4572b13546aff4b0), {
                open: addDialogOpen,
                onClose: ()=>setAddDialogOpen(false),
                onTunnelCreated: async ()=>{
                    await loadTunnels();
                },
                wireGuardOptions: wireGuardOptions,
                accessibleGroups: accessibleGroups
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $06f92ade4c4bdbc2$export$fb637ef9c75ef27), {
                open: bulkUploadOpen,
                onClose: ()=>setBulkUploadOpen(false),
                accessibleGroups: accessibleGroups,
                onUploadSuccess: async (validateOnlyMode)=>{
                    if (!validateOnlyMode) await loadTunnels();
                }
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $95782dc726d1b648$export$baf953c4fc3dcc5b), {
                open: detailsOpen,
                selectedTunnel: selectedTunnel,
                onClose: ()=>setDetailsOpen(false),
                canCreateTunnels: canCreateTunnels,
                getGroupName: getGroupName,
                getServerName: getServerName,
                getServerPublicKey: getServerPublicKey,
                onTunnelPatched: async (tunnelId)=>{
                    const freshTunnels = await loadTunnels();
                    const refreshedTunnel = freshTunnels.find((tunnel)=>tunnel.id === tunnelId) || null;
                    setSelectedTunnel(refreshedTunnel);
                },
                onTunnelDeleted: async ()=>{
                    await loadTunnels();
                    setSelectedTunnel(null);
                }
            }),
            showEdgeDevices && /*#__PURE__*/ (0, $k4ank.jsx)((0, $48759305553339af$export$92b53b993c6be367), {
                open: edgeDeviceDetailsOpen,
                selectedDevice: selectedEdgeDevice,
                onClose: ()=>setEdgeDeviceDetailsOpen(false),
                wireguardTunnels: allTunnels,
                onOpenWireguardTunnel: handleOpenWireguardTunnelFromEdgeDevice
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                className: "justify-start",
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $jVN1H.NavBar), {
                    navBarCollapsed: navBarCollapsed,
                    setNavBarCollapsed: setNavBarCollapsed,
                    props: {}
                })
            })
        ]
    });
};



var $iKAtE = parcelRequire("iKAtE");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");
var $c0c303f373e249c4$exports = {};
"use strict";
"use client";

var $Bx5pa = parcelRequire("Bx5pa");
Object.defineProperty($c0c303f373e249c4$exports, "__esModule", {
    value: true
});
$c0c303f373e249c4$exports.default = void 0;

var $c0c303f373e249c4$var$_createSvgIcon = $Bx5pa((parcelRequire("4E8mP")));

var $k4ank = parcelRequire("k4ank");
var $c0c303f373e249c4$var$_default = $c0c303f373e249c4$exports.default = (0, $c0c303f373e249c4$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $k4ank.jsx)("path", {
    d: "M22.99 9C19.15 5.16 13.8 3.76 8.84 4.78l2.52 2.52c3.47-.17 6.99 1.05 9.63 3.7zm-4 4c-1.29-1.29-2.84-2.13-4.49-2.56l3.53 3.53zM2 3.05 5.07 6.1C3.6 6.82 2.22 7.78 1 9l1.99 2c1.24-1.24 2.67-2.16 4.2-2.77l2.24 2.24C7.81 10.89 6.27 11.73 5 13v.01L6.99 15c1.36-1.36 3.14-2.04 4.92-2.06L18.98 20l1.27-1.26L3.29 1.79zM9 17l3 3 3-3c-1.65-1.66-4.34-1.66-6 0"
}), 'WifiOff');


const $bb602ee58150f194$export$c06e27611c3cd220 = ()=>{
    const handleRetry = ()=>{
        // Attempt to reload the previous page or navigate home
        // Check if online first before navigating away
        if (navigator.onLine) window.history.back(); // Go back to the previous page if possible
        else // Optionally, provide feedback that there's still no connection
        alert("Still no internet connection detected.");
    };
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            textAlign: "center",
            fontFamily: "sans-serif",
            color: "#5f6368"
        },
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c0c303f373e249c4$exports))), {
                style: {
                    fontSize: 100,
                    marginBottom: 20,
                    color: "#5f6368"
                }
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("h1", {
                style: {
                    fontSize: "24px",
                    margin: "0 0 10px 0"
                },
                children: "No Internet"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                style: {
                    fontSize: "16px",
                    marginBottom: 5
                },
                children: "Try:"
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("ul", {
                style: {
                    listStyle: "none",
                    padding: 0,
                    margin: "0 0 20px 0",
                    fontSize: "14px"
                },
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("li", {
                        children: "Checking the network cables, modem, and router"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("li", {
                        children: "Reconnecting to Wi-Fi"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                style: {
                    fontSize: "12px",
                    marginBottom: 20
                },
                children: "ERR_INTERNET_DISCONNECTED"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                onClick: handleRetry,
                style: {
                    padding: "10px 20px",
                    fontSize: "14px",
                    color: "#fff",
                    backgroundColor: "#1a73e8",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer"
                },
                children: "Retry"
            })
        ]
    });
};



var $433j1 = parcelRequire("433j1");

var $aYdit = parcelRequire("aYdit");

var $4G44R = parcelRequire("4G44R");

var $4PFLW = parcelRequire("4PFLW");
/**
 * Cache validation and cleanup utilities to prevent authentication issues
 */ 
var $1BWfV = parcelRequire("1BWfV");

var $ebTQj = parcelRequire("ebTQj");



class $1aa17ed2c10ac6d1$export$af5c1930ee37cd9e {
    constructor(){
        this.validationInterval = null;
    }
    static getInstance() {
        if (!$1aa17ed2c10ac6d1$export$af5c1930ee37cd9e.instance) $1aa17ed2c10ac6d1$export$af5c1930ee37cd9e.instance = new $1aa17ed2c10ac6d1$export$af5c1930ee37cd9e();
        return $1aa17ed2c10ac6d1$export$af5c1930ee37cd9e.instance;
    }
    /**
   * Validate and clean up cache on app startup
   */ async validateOnStartup() {
        try {
            (0, $ebTQj.logger).info("Validating cache on startup...");
            // Check for authentication state inconsistencies
            const validation = (0, $1BWfV.authStateManager).validateAuthState();
            if (!validation.isValid) {
                (0, $ebTQj.logger).warn("Cache validation found issues:", validation.issues);
                // Try to fix inconsistencies
                const fixed = (0, $1BWfV.authStateManager).fixAuthStateInconsistencies();
                if (!fixed) {
                    (0, $ebTQj.logger).warn("Could not fix cache inconsistencies, clearing auth state");
                    (0, $1BWfV.authStateManager).clearAuthState();
                }
            }
            // Check for localStorage quota issues
            const { isLocalStorageGettingFull: isLocalStorageGettingFull } = await Promise.resolve((parcelRequire("2uwzz")));
            if (isLocalStorageGettingFull(85)) {
                (0, $ebTQj.logger).warn("localStorage is getting full, clearing non-essential data");
                const { clearNonEssentialData: clearNonEssentialData } = await Promise.resolve((parcelRequire("2uwzz")));
                clearNonEssentialData();
            }
            // Clear any stale retry counters
            localStorage.removeItem("networkErrorRetryCount");
            localStorage.removeItem("tokenRefreshing");
            (0, $ebTQj.logger).info("Cache validation completed");
        } catch (error) {
            (0, $ebTQj.logger).error("Error during cache validation:", error);
        }
    }
    /**
   * Start periodic cache validation
   */ startPeriodicValidation(intervalMs = 300000) {
        // 5 minutes default
        if (this.validationInterval) clearInterval(this.validationInterval);
        this.validationInterval = setInterval(async ()=>{
            try {
                const validation = (0, $1BWfV.authStateManager).validateAuthState();
                if (!validation.isValid) {
                    (0, $ebTQj.logger).warn("Periodic validation found issues:", validation.issues);
                    (0, $1BWfV.authStateManager).fixAuthStateInconsistencies();
                }
            } catch (error) {
                (0, $ebTQj.logger).error("Error during periodic validation:", error);
            }
        }, intervalMs);
        (0, $ebTQj.logger).info(`Started periodic cache validation every ${intervalMs}ms`);
    }
    /**
   * Stop periodic cache validation
   */ stopPeriodicValidation() {
        if (this.validationInterval) {
            clearInterval(this.validationInterval);
            this.validationInterval = null;
            (0, $ebTQj.logger).info("Stopped periodic cache validation");
        }
    }
    /**
   * Clear all caches and reset authentication state
   */ async clearAllCaches() {
        try {
            (0, $ebTQj.logger).info("Clearing all caches...");
            // Clear authentication state
            (0, $1BWfV.authStateManager).clearAuthState();
            // Clear other localStorage data
            const keysToKeep = [
                "packageJsonVersion",
                "userStorage",
                "dateMMDDYYYY"
            ];
            const allKeys = Object.keys(localStorage);
            allKeys.forEach((key)=>{
                if (!keysToKeep.includes(key)) try {
                    localStorage.removeItem(key);
                } catch (error) {
                    (0, $ebTQj.logger).warn(`Failed to remove ${key} from localStorage:`, error);
                }
            });
            // Clear session storage
            try {
                sessionStorage.clear();
            } catch (error) {
                (0, $ebTQj.logger).warn("Failed to clear sessionStorage:", error);
            }
            (0, $ebTQj.logger).info("All caches cleared successfully");
        } catch (error) {
            (0, $ebTQj.logger).error("Error clearing caches:", error);
        }
    }
    /**
   * Check for and handle browser storage quota issues
   */ async handleStorageQuotaIssues() {
        try {
            const { getLocalStorageUsage: getLocalStorageUsage, clearNonEssentialData: clearNonEssentialData } = await Promise.resolve((parcelRequire("2uwzz")));
            const usage = getLocalStorageUsage();
            if (usage.percentage > 90) {
                (0, $ebTQj.logger).warn(`localStorage usage is at ${usage.percentage.toFixed(2)}%, clearing non-essential data`);
                clearNonEssentialData();
                // Check again after clearing
                const newUsage = getLocalStorageUsage();
                if (newUsage.percentage > 95) {
                    (0, $ebTQj.logger).error("localStorage still too full after clearing, may cause issues");
                    return false;
                }
            }
            return true;
        } catch (error) {
            (0, $ebTQj.logger).error("Error handling storage quota issues:", error);
            return false;
        }
    }
}
const $1aa17ed2c10ac6d1$export$72c5813af8fda9d3 = $1aa17ed2c10ac6d1$export$af5c1930ee37cd9e.getInstance();


/**
 * Authentication debugging utilities
 */ 
var $1BWfV = parcelRequire("1BWfV");

var $ebTQj = parcelRequire("ebTQj");

var $iJyAr = parcelRequire("iJyAr");

class $df9cbfc65f2b700a$export$fff8f5e4d6e2cea8 {
    constructor(){
        this.cookies = new (0, $iJyAr.default)();
    }
    static getInstance() {
        if (!$df9cbfc65f2b700a$export$fff8f5e4d6e2cea8.instance) $df9cbfc65f2b700a$export$fff8f5e4d6e2cea8.instance = new $df9cbfc65f2b700a$export$fff8f5e4d6e2cea8();
        return $df9cbfc65f2b700a$export$fff8f5e4d6e2cea8.instance;
    }
    /**
   * Get comprehensive authentication debug information
   */ async getDebugInfo() {
        const issues = [];
        const timestamp = new Date().toISOString();
        // Get auth state
        const authState = (0, $1BWfV.authStateManager).getAuthState();
        // Get validation results
        const validation = (0, $1BWfV.authStateManager).validateAuthState();
        if (!validation.isValid) issues.push(...validation.issues);
        // Get storage information
        const storageInfo = await this.getStorageInfo();
        if (storageInfo.localStorageUsage.percentage > 90) issues.push(`localStorage usage is high: ${storageInfo.localStorageUsage.percentage.toFixed(2)}%`);
        // Get cookie information
        const cookies = {
            token: this.cookies.get("token") ? "Present" : "Missing",
            token_secret: this.cookies.get("token_secret") ? "Present" : "Missing",
            allCookies: this.cookies.getAll()
        };
        // Get localStorage auth-related items
        const localStorageData = {
            loggedIn: localStorage.getItem("loggedIn"),
            token: localStorage.getItem("token") ? "Present" : "Missing",
            token_secret: localStorage.getItem("token_secret") ? "Present" : "Missing",
            tokenRefreshing: localStorage.getItem("tokenRefreshing"),
            redirectURL: localStorage.getItem("redirectURL")
        };
        return {
            timestamp: timestamp,
            authState: authState,
            validation: validation,
            storageInfo: storageInfo,
            cookies: cookies,
            localStorage: localStorageData,
            issues: issues
        };
    }
    /**
   * Get storage usage information
   */ async getStorageInfo() {
        try {
            const { getLocalStorageUsage: getLocalStorageUsage } = await Promise.resolve((parcelRequire("2uwzz")));
            return {
                localStorageUsage: getLocalStorageUsage(),
                sessionStorageKeys: Object.keys(sessionStorage).length,
                localStorageKeys: Object.keys(localStorage).length
            };
        } catch (error) {
            return {
                localStorageUsage: {
                    used: 0,
                    available: 0,
                    percentage: 0
                },
                sessionStorageKeys: 0,
                localStorageKeys: 0,
                error: "Could not get storage info"
            };
        }
    }
    /**
   * Log debug information
   */ async logDebugInfo() {
        const debugInfo = await this.getDebugInfo();
        (0, $ebTQj.logger).info("=== AUTH DEBUG INFO ===");
        (0, $ebTQj.logger).info("Timestamp:", debugInfo.timestamp);
        (0, $ebTQj.logger).info("Auth State:", debugInfo.authState);
        (0, $ebTQj.logger).info("Validation:", debugInfo.validation);
        (0, $ebTQj.logger).info("Storage Info:", debugInfo.storageInfo);
        (0, $ebTQj.logger).info("Cookies:", debugInfo.cookies);
        (0, $ebTQj.logger).info("LocalStorage:", debugInfo.localStorage);
        if (debugInfo.issues.length > 0) (0, $ebTQj.logger).warn("Issues found:", debugInfo.issues);
        else (0, $ebTQj.logger).info("No issues found");
        (0, $ebTQj.logger).info("=== END AUTH DEBUG INFO ===");
    }
    /**
   * Export debug information as JSON
   */ async exportDebugInfo() {
        const debugInfo = await this.getDebugInfo();
        return JSON.stringify(debugInfo, null, 2);
    }
    /**
   * Check for common authentication issues
   */ async checkCommonIssues() {
        const issues = [];
        const debugInfo = await this.getDebugInfo();
        // Check for token/cookie mismatches
        if (debugInfo.authState.hasValidToken && debugInfo.cookies.token === "Missing") issues.push("Token exists in state but not in cookies");
        if (debugInfo.authState.hasValidRefreshToken && debugInfo.cookies.token_secret === "Missing") issues.push("Refresh token exists in state but not in cookies");
        // Check for localStorage/cookie mismatches
        if (debugInfo.localStorage.token === "Present" && debugInfo.cookies.token === "Missing") issues.push("Token in localStorage but not in cookies");
        if (debugInfo.localStorage.token_secret === "Present" && debugInfo.cookies.token_secret === "Missing") issues.push("Refresh token in localStorage but not in cookies");
        // Check for authentication state inconsistencies
        if ((document.cookie.includes("token=") || document.cookie.includes("token_secret=")) && !debugInfo.authState.isAuthenticated) issues.push("localStorage says logged in but auth state says not authenticated");
        // Check for stale refresh flags
        if (debugInfo.localStorage.tokenRefreshing === "true") issues.push("Token refresh flag is still set - may indicate stuck refresh process");
        return issues;
    }
    /**
   * Auto-fix common issues
   */ async autoFixIssues() {
        const issues = await this.checkCommonIssues();
        if (issues.length === 0) {
            (0, $ebTQj.logger).info("No issues to fix");
            return true;
        }
        (0, $ebTQj.logger).warn("Attempting to auto-fix issues:", issues);
        try {
            // Try to fix authentication state inconsistencies
            const fixed = (0, $1BWfV.authStateManager).fixAuthStateInconsistencies();
            if (fixed) (0, $ebTQj.logger).info("Successfully fixed authentication state inconsistencies");
            else {
                (0, $ebTQj.logger).warn("Could not fix authentication state inconsistencies, clearing auth state");
                (0, $1BWfV.authStateManager).clearAuthState();
            }
            // Clear stale refresh flags
            localStorage.removeItem("tokenRefreshing");
            return true;
        } catch (error) {
            (0, $ebTQj.logger).error("Error during auto-fix:", error);
            return false;
        }
    }
}
const $df9cbfc65f2b700a$export$c45a5d67276420d6 = $df9cbfc65f2b700a$export$fff8f5e4d6e2cea8.getInstance();
// Add to window for debugging in console (development only)
if (typeof window !== "undefined" && true) {
    window.authDebugger = $df9cbfc65f2b700a$export$c45a5d67276420d6;
    window.authStateManager = (0, $1BWfV.authStateManager);
    (0, $ebTQj.logger).log("Auth debugging tools available: authDebugger, authStateManager");
}



var $5BK6w = parcelRequire("5BK6w");

var $8T3gX = parcelRequire("8T3gX");

var $3QMQN = parcelRequire("3QMQN");
var $a65wX = parcelRequire("a65wX");
var $kUcVg = parcelRequire("kUcVg");
var $1TOOV = parcelRequire("1TOOV");
var $ce8iU = parcelRequire("ce8iU");

var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $cFPmV = parcelRequire("cFPmV");
var $kUcVg = parcelRequire("kUcVg");
var $887xF = parcelRequire("887xF");
var $1TOOV = parcelRequire("1TOOV");
var $ce8iU = parcelRequire("ce8iU");
var $eejVe = parcelRequire("eejVe");
var $cVCJe = parcelRequire("cVCJe");

var $8jTCz = parcelRequire("8jTCz");
parcelRequire("8T3gX");

var $195EM = parcelRequire("195EM");

var $3Zv1D = parcelRequire("3Zv1D");
const $6ee63f60c44d4cdb$export$18332398bcfc2be = (inputEmailAddress, navigate)=>{
    const AxiosUI = (0, $195EM.createApi)(``);
    const retryFunction = ()=>{
        $6ee63f60c44d4cdb$export$18332398bcfc2be(inputEmailAddress, navigate);
    };
    AxiosUI.post(`proactive_alerting/${localStorage.cameraChecksiteId}/send/`, {
        email: inputEmailAddress
    }).then((response)=>{
        alert(response.data[0].message);
    }, (reason)=>{
        (0, $3Zv1D.universalAPIErrorHandler)(reason, navigate, retryFunction, ()=>{
            alert("Error sending email, please try again");
        });
    });
};


const $d48411e03ac7aa1a$export$c9e73fbda7da57b6 = ()=>{
    const { protocol: protocol, hostname: hostname, port: port } = window.location;
    let baseURL = `${protocol}//${hostname}`;
    // Append port if it's not the default port for the protocol
    if (port && (protocol === "http:" && port !== "80" || protocol === "https:" && port !== "443")) baseURL += `:${port}`;
    return baseURL;
};



var $ePwXE = parcelRequire("ePwXE");
const $169371a7ad7e67be$export$bc1a30f2d813a0cd = ({ goodCameras: goodCameras, connectivityCameras: connectivityCameras, lowResolutionCameras: lowResolutionCameras, cameraCheckResultDownloadURL: cameraCheckResultDownloadURL, navigate: navigate })=>{
    const theme = (0, $cFPmV.default)({
        palette: {
            primary: {
                main: "#FF8400"
            }
        }
    });
    const [emailReportDialgOpen, setEmailReportDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [inputEmailAddress, setInputEmailAddress] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    return /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
                open: emailReportDialgOpen,
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                        id: "alert-dialog-title",
                        children: "Email Report"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $eejVe.default), {
                            onChange: (event)=>{
                                setInputEmailAddress(event.target.value);
                            },
                            value: inputEmailAddress,
                            label: "Email Address",
                            helperText: "",
                            variant: "standard",
                            sx: {
                                fontFamily: "Mulish",
                                width: 350
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsxs)((0, $887xF.default), {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    setEmailReportDialogOpen(false);
                                },
                                text: "Cancel",
                                disabled: false
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>{
                                    setEmailReportDialogOpen(false);
                                    (0, $6ee63f60c44d4cdb$export$18332398bcfc2be)(inputEmailAddress, navigate);
                                },
                                text: "Submit",
                                disabled: false
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                className: "first-line:font-black font-mulish text-[18px] pl-[20px] text-[#283E6D]",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {}),
                    goodCameras[0] && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "first-line:font-black",
                                children: "The following camera(s) have passed our check:"
                            }),
                            goodCameras.map((camera)=>{
                                return /*#__PURE__*/ (0, $k4ank.jsx)("li", {
                                    className: "pl-[15px] text-[#2E7D32]",
                                    children: camera
                                }, camera);
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                        ]
                    }),
                    connectivityCameras[0] && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "first-line:font-black",
                                children: "Unable to connect to the following camera(s):"
                            }),
                            connectivityCameras.map((camera)=>{
                                return /*#__PURE__*/ (0, $k4ank.jsx)("li", {
                                    className: "pl-[15px] text-[#D32F2F]",
                                    children: camera
                                }, camera);
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                children: "Please ensure that all site and camera information is"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                children: "correct. To see likely cause download and check the report."
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                        ]
                    }),
                    lowResolutionCameras[0] && /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "first-line:font-black",
                                children: "The following camera(s) have suboptimal settings:"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                className: "text-[#D32F2F] first-line:font-black",
                                children: `Low Resolution Cameras (<480p):`
                            }),
                            lowResolutionCameras.map((object)=>{
                                return /*#__PURE__*/ (0, $k4ank.jsxs)("li", {
                                    className: "pl-[15px] text-[#D32F2F]",
                                    children: [
                                        object.cameraName,
                                        "\xa0",
                                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $cVCJe.default), {
                                            title: object.detail,
                                            placement: "right",
                                            sx: {
                                                fontSize: "15px",
                                                fontFamily: "mulish"
                                            },
                                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ePwXE))), {
                                                sx: {
                                                    color: "#001943",
                                                    fontSize: 14
                                                }
                                            })
                                        })
                                    ]
                                }, object.cameraName);
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                children: "If unchangeable, please update the Sensitivity of the"
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                children: `products on your camera to "High" (Navigate to the`
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                children: `camera: EDIT CAMERA > PRODUCTS > EDIT`
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                                children: `INFORMATION > SHOW ALL > Sensitivity to "High")`
                            }),
                            /*#__PURE__*/ (0, $k4ank.jsx)("br", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "first-line:font-black",
                        children: "Download the report for a summary of results. To email"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "first-line:font-black",
                        children: `the report hit the "Email Report" button below and`
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("p", {
                        className: "first-line:font-black",
                        children: `insert the desired email address.`
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("br", {}),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                            onClick: ()=>{
                                localStorage.setItem("cameraCheckAlertOpen", "false");
                                window.open(`${(0, $d48411e03ac7aa1a$export$c9e73fbda7da57b6)()}/sites/aboutsite/${localStorage.cameraChecksiteId}`);
                            },
                            text: "See Site",
                            disabled: false
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        className: "flex",
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: "",
                                text: /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)("a", {
                                        href: cameraCheckResultDownloadURL,
                                        download: true,
                                        children: "Download Report"
                                    })
                                }),
                                disabled: !cameraCheckResultDownloadURL
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                        children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                                onClick: ()=>setEmailReportDialogOpen(true),
                                text: "Email Report",
                                disabled: !cameraCheckResultDownloadURL
                            })
                        })
                    })
                ]
            })
        ]
    });
};



var $dHtmK = parcelRequire("dHtmK");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $1BWfV = parcelRequire("1BWfV");

var $ax3yI = parcelRequire("ax3yI");

var $8sbJd = parcelRequire("8sbJd");
const $6623934433771279$export$9a79e29c52a9cca5 = (toProduction)=>{
    (0, $8sbJd.setProductionMode)(toProduction);
    (0, $1BWfV.authStateManager).clearAuthState();
    try {
        localStorage.removeItem("userInfo");
        localStorage.setItem("redirectURL", window.location.pathname + window.location.search + window.location.hash);
    } catch  {
    // Storage blocked: sign-in still works, it just lands on the home page.
    }
    (0, $ax3yI.handleRedirect)();
};
const $6623934433771279$export$24bd30391083795a = ()=>{
    if (!(0, $8sbJd.isNonProdBuild)()) return null;
    const on = (0, $8sbJd.isProductionModeOn)();
    if (on) // Never on top of the page: the app is laid out full-screen, so a top
    // bar covered the tabs and the nav. A red frame round the window plus a
    // pill at the bottom keeps it unmissable without hiding anything.
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $k4ank.Fragment), {
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                "aria-hidden": "true",
                "data-testid": "production-mode-frame",
                className: "pointer-events-none fixed inset-0 z-[2000]",
                style: {
                    boxShadow: "inset 0 0 0 4px #B91C1C"
                }
            }),
            /*#__PURE__*/ (0, $k4ank.jsxs)("div", {
                "data-testid": "production-mode-bar",
                role: "alert",
                className: "fixed bottom-3 left-1/2 z-[2001] flex -translate-x-1/2 items-center gap-3 rounded-full bg-[#B91C1C] px-4 py-1 font-mulish text-[13px] text-white shadow-lg",
                children: [
                    /*#__PURE__*/ (0, $k4ank.jsx)("b", {
                        children: "LIVE PRODUCTION DATA"
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("span", {
                        children: "This is production. Saves, sync, arm/disarm, talk-down and alerts act on real sites and cameras."
                    }),
                    /*#__PURE__*/ (0, $k4ank.jsx)("button", {
                        type: "button",
                        "data-testid": "production-mode-off",
                        onClick: ()=>$6623934433771279$export$9a79e29c52a9cca5(false),
                        className: "rounded-full border border-white px-2 py-[1px] font-bold hover:bg-white hover:text-[#B91C1C]",
                        children: "Switch back to staging"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)("button", {
        type: "button",
        "data-testid": "production-mode-on",
        title: "Test this build against live production data",
        onClick: ()=>$6623934433771279$export$9a79e29c52a9cca5(true),
        className: "fixed bottom-3 right-3 z-[2000] rounded-full border border-[#B45309] bg-white px-3 py-1 font-mulish text-[12px] text-[#B45309] shadow hover:bg-[#FEF3C7]",
        children: "Staging data \xb7 Use production"
    });
};


parcelRequire("jVN1H");

var $k4ank = parcelRequire("k4ank");
parcelRequire("8T3gX");

var $3T949 = parcelRequire("3T949");


var $lcmJi = parcelRequire("lcmJi");
const $b025acc92f1be866$export$e6024d62728f289b = ({ screen: screen, permission: permission, navBarCollapsed: navBarCollapsed, setNavBarCollapsed: setNavBarCollapsed, landingOptions: landingOptions, children: children })=>{
    // A patrol-only user's whole app is Patrols and their landing route is
    // /sites_patrol, so hiding that screen would redirect them to the page
    // they are already on, forever. Their screen list can never hide it.
    const flags = permission ?? {};
    if (screen === "patrols" && flags.patrol_only) return children;
    if ((0, $lcmJi.isScreenVisible)((0, $lcmJi.readVisibleScreens)(permission), screen)) return children;
    const landing = (0, $lcmJi.landingRouteFor)(permission, landingOptions);
    if (landing) return /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Navigate), {
        to: landing,
        replace: true
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
        navBarCollapsed: navBarCollapsed,
        setNavBarCollapsed: setNavBarCollapsed
    });
};



var $jYCat = parcelRequire("jYCat");
const $acdad01ca69cf12c$var$App = (packageJson)=>{
    localStorage.setItem("packageJsonVersion", packageJson.packageJson.version);
    const { flags: flags } = (0, $4PFLW.useFeatureFlag)();
    const viewEditMetadataTagZonesPage = flags.viewEditMetadataTagZonesPage;
    const showLineCrossings = flags.showLineCrossings;
    const showNewIgnoreZonesPage = flags.showNewIgnoreZonesPage;
    const showWireguardTunnelsPage = flags.showWireguardTunnelsPage;
    const showStreamTest = flags.showStreamTest;
    const showTalkDown = Boolean(flags.showTalkDown);
    // Initialize cache validation on app startup
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        (0, $1aa17ed2c10ac6d1$export$72c5813af8fda9d3).validateOnStartup();
        // Start periodic validation every 5 minutes
        (0, $1aa17ed2c10ac6d1$export$72c5813af8fda9d3).startPeriodicValidation(300000);
        // Initialize auth debugger for console access
        (0, $df9cbfc65f2b700a$export$c45a5d67276420d6).logDebugInfo();
        // Cleanup on unmount
        return ()=>{
            (0, $1aa17ed2c10ac6d1$export$72c5813af8fda9d3).stopPeriodicValidation();
        };
    }, []);
    const { userPermissions: userPermissions, getWireGuardOptions: getWireGuardOptions } = (0, $aYdit.useAppStore)();
    const { showFrontelTab: showFrontelTab } = (0, $4G44R.useClipsStore)();
    const [permissions, setPermissions] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState({
        arm_disarm: false,
        add_cameras: false,
        edit_cameras: false,
        delete_cameras: false,
        manage_users: false,
        super_user: false,
        configure_wireguard_cameras: false,
        view_analytics: false,
        view_alerts: false,
        view_passwords: false,
        direct_camera_access: false
    });
    const [navBarCollapsed, setNavBarCollapsed] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    // ENG-1816 / ENG-2000: routes for the View Only screens (Sites, Alerts,
    // Analytics, Health, Patrols, WireGuard) wrap their existing gate's positive
    // branch in this, so a screen missing from the user's `visible_screens`
    // redirects to their landing route instead of rendering. Empty list = View
    // All = every route as today.
    const screenGateProps = {
        permission: userPermissions,
        navBarCollapsed: navBarCollapsed,
        setNavBarCollapsed: setNavBarCollapsed,
        landingOptions: {
            wireguardPageEnabled: Boolean(showWireguardTunnelsPage)
        }
    };
    const [cameraCheckFinsihedAlertOpen, setCameraCheckFinsihedAlertOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [cameraCheckResultsDialogOpen, setCameraCheckResultsDialogOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState(false);
    const [goodCameras, setGoodCameras] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [connectivityCameras, setConnectivityCameras] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [lowResolutionCameras, setLowResolutionCameras] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState([]);
    const [cameraCheckResultDownloadURL, setCameraCheckResultDownloadURL] = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useState("");
    const navigate = (0, $3T949.useNavigate)();
    const location = (0, $3T949.useLocation)();
    // when a user attempts to go to any page before login save the page in local storage as redirect url
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (!window.location.pathname.includes("callback")) localStorage.setItem("redirectUrl", window.location.pathname);
        if (!window.location.pathname.includes("callback")) {
            if (window.location.pathname.includes("login")) localStorage.setItem("redirectUrl", "/dashboard");
            else localStorage.setItem("redirectUrl", window.location.pathname);
        }
    }, []);
    const { backdropLoadingScreenRefreshTokenOn: backdropLoadingScreenRefreshTokenOn, refreshingToken: refreshingToken, setBackdropLoadingScreenRefreshTokenOn: setBackdropLoadingScreenRefreshTokenOn, dateMMDDYYYY: dateMMDDYYYY, updateUserStorageDateFormat: updateUserStorageDateFormat, setUserPermissions: setUserPermissions } = (0, $aYdit.useAppStore)();
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        // Check authentication using cookies instead of localStorage
        const token = document.cookie.includes("token=");
        const refreshToken = document.cookie.includes("token_secret=");
        if (token || refreshToken) {
            const defaultPermissions = {
                arm_disarm: false,
                add_cameras: false,
                edit_cameras: false,
                delete_cameras: false,
                manage_users: false,
                super_user: false,
                configure_wireguard_cameras: false,
                view_analytics: false,
                view_alerts: false,
                view_passwords: false,
                direct_camera_access: false
            };
            let userPermissions;
            try {
                const raw = localStorage.getItem("userPermissions");
                userPermissions = raw ? JSON.parse(raw) : null;
            } catch (e) {
                userPermissions = null;
            }
            const safePermissions = {
                ...defaultPermissions,
                ...userPermissions || {}
            };
            setUserPermissions(safePermissions);
            setPermissions(safePermissions);
        }
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (refreshingToken) setBackdropLoadingScreenRefreshTokenOn(true);
    }, [
        refreshingToken
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        const userStorage = JSON.parse(localStorage.getItem("userStorage"));
        if (userStorage) updateUserStorageDateFormat(navigate, dateMMDDYYYY);
    }, [
        dateMMDDYYYY
    ]);
    // Defer WireGuard fetch until we're past the auth callback and have a token,
    // so we never hit the API without auth (avoids 403 and unnecessary failures).
    const hasFetchedWireGuardRef = (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useRef(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($8T3gX))).useEffect(()=>{
        if (location.pathname.includes("callback")) return;
        if (hasFetchedWireGuardRef.current) return;
        if (!(0, $5BK6w.getCookie)("token")) return;
        hasFetchedWireGuardRef.current = true;
        getWireGuardOptions(navigate);
    }, [
        location.pathname,
        navigate
    ]);
    const cameraCheckFinsihedAlert = /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
        children: cameraCheckFinsihedAlertOpen && /*#__PURE__*/ (0, $k4ank.jsx)("div", {
            className: "fixed top-0 left-0 w-full z-50",
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3QMQN.default), {
                severity: "success",
                onClose: ()=>setCameraCheckFinsihedAlertOpen(false),
                children: /*#__PURE__*/ (0, $k4ank.jsxs)("p", {
                    className: "font-mulish",
                    children: [
                        "Camera check finished",
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $a65wX.default), {
                            type: "button",
                            onClick: ()=>{
                                localStorage.setItem("cameraCheckAlertOpen", "false");
                                setCameraCheckFinsihedAlertOpen(false);
                                setCameraCheckResultsDialogOpen(true);
                            },
                            disabled: false,
                            size: "small",
                            children: "CLICK HERE"
                        }),
                        "to see results."
                    ]
                })
            })
        })
    });
    const cameraCheckResultsDialog = /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: cameraCheckResultsDialogOpen,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce8iU.default), {
                id: "alert-dialog-title",
                children: "Camera Check Results"
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $iKAtE.default), {
                "aria-label": "close",
                onClick: ()=>setCameraCheckResultsDialogOpen(false),
                sx: {
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme)=>theme.palette.grey[500]
                },
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($433j1))), {})
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)("div", {
                    className: "w-[1000px]",
                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $169371a7ad7e67be$export$bc1a30f2d813a0cd), {
                        goodCameras: goodCameras,
                        connectivityCameras: connectivityCameras,
                        lowResolutionCameras: lowResolutionCameras,
                        cameraCheckResultDownloadURL: cameraCheckResultDownloadURL,
                        navigate: navigate
                    })
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $a72857d2c4579fd9$export$87091915187a1a85), {
        children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $406fbd5b4df51c19$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $dHtmK.default), {
                    openState: backdropLoadingScreenRefreshTokenOn
                }),
                /*#__PURE__*/ (0, $k4ank.jsx)((0, $6623934433771279$export$24bd30391083795a), {}),
                /*#__PURE__*/ (0, $k4ank.jsxs)((0, $3T949.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "/login",
                            element: /*#__PURE__*/ (0, $k4ank.jsx)((0, $ax3yI.Login), {})
                        }),
                        showStreamTest && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "stream-test",
                            element: /*#__PURE__*/ (0, $k4ank.jsx)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $a2933d8f4100309e$export$161ab3e12c669209), {})
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "/",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $d3d32d33bd82afae$export$b94310965bed44e6), {
                                        permissions: permissions,
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "dashboard",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    !userPermissions.patrol_only ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $b025acc92f1be866$export$e6024d62728f289b), {
                                        screen: "sites",
                                        ...screenGateProps,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $4a4e6e8a12b91557$export$fe82a520fc33e5f4), {
                                            navBarCollapsed: navBarCollapsed,
                                            setNavBarCollapsed: setNavBarCollapsed
                                        })
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "sites",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    !userPermissions.patrol_only ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $b025acc92f1be866$export$e6024d62728f289b), {
                                        screen: "sites",
                                        ...screenGateProps,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1ddaf0c78cfa4126$export$590a034acff5c40e), {
                                            permissions: permissions,
                                            navBarCollapsed: navBarCollapsed,
                                            setNavBarCollapsed: setNavBarCollapsed
                                        })
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "sites_patrol",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    userPermissions.view_patrol ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $b025acc92f1be866$export$e6024d62728f289b), {
                                        screen: "patrols",
                                        ...screenGateProps,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $1ddaf0c78cfa4126$export$590a034acff5c40e), {
                                            permissions: permissions,
                                            navBarCollapsed: navBarCollapsed,
                                            setNavBarCollapsed: setNavBarCollapsed
                                        })
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "clips",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    userPermissions.ailink || userPermissions.sentinel || userPermissions.smtp || showFrontelTab ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $b025acc92f1be866$export$e6024d62728f289b), {
                                        screen: "alerts",
                                        ...screenGateProps,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $e67139ca3a67d820$export$78d384c3ba0c37b8), {
                                            navBarCollapsed: navBarCollapsed,
                                            setNavBarCollapsed: setNavBarCollapsed
                                        })
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $c9d28e6ea372b2fa$export$a65c2c055de52e1d), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "patrols",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    userPermissions.view_patrol || userPermissions.patrol_only ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $b025acc92f1be866$export$e6024d62728f289b), {
                                        screen: "patrols",
                                        ...screenGateProps,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $3e9a0170683494d1$export$b9e5c0acf002729a), {
                                            navBarCollapsed: navBarCollapsed,
                                            setNavBarCollapsed: setNavBarCollapsed
                                        })
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "patrols_test",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $3e9a0170683494d1$export$b9e5c0acf002729a), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "sites/addsite",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    permissions.add_cameras ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $f195e9d0021846f0$export$150cfcc54fa9f63a), {}) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "/smtp",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    !userPermissions.patrol_only ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $b025acc92f1be866$export$e6024d62728f289b), {
                                        screen: "sites",
                                        ...screenGateProps,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $7isVd.SMTPTab), {
                                            navBarCollapsed: navBarCollapsed,
                                            setNavBarCollapsed: setNavBarCollapsed
                                        })
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "sites/cameracheck",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    userPermissions.add_cameras ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $0e35fc3545913e76$export$443d01f0943e8654), {
                                        setCameraCheckFinsihedAlertOpen: setCameraCheckFinsihedAlertOpen,
                                        setGoodCameras: setGoodCameras,
                                        setConnectivityCameras: setConnectivityCameras,
                                        setLowResolutionCameras: setLowResolutionCameras,
                                        setCameraCheckResultDownloadURL: setCameraCheckResultDownloadURL
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "sites/addCamera",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    userPermissions.add_cameras ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $78eceafc35b75d85$export$df0ffe8c4365c7a5), {
                                        setCameraCheckFinsihedAlertOpen: setCameraCheckFinsihedAlertOpen,
                                        setGoodCameras: setGoodCameras,
                                        setConnectivityCameras: setConnectivityCameras,
                                        setLowResolutionCameras: setLowResolutionCameras,
                                        setCameraCheckResultDownloadURL: setCameraCheckResultDownloadURL
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "sites/autoaddcamera",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    userPermissions.add_cameras ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $ce686a880d23b2e0$export$bd89ba5689ecaffc), {
                                        setCameraCheckFinsihedAlertOpen: setCameraCheckFinsihedAlertOpen,
                                        setGoodCameras: setGoodCameras,
                                        setConnectivityCameras: setConnectivityCameras,
                                        setLowResolutionCameras: setLowResolutionCameras,
                                        setCameraCheckResultDownloadURL: setCameraCheckResultDownloadURL
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "sites/:siteId/onvifscan",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    (0, $jYCat.canUseOnvifScan)(userPermissions) ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $a466acfbdf930dea$export$ded845d1eea1f233), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "sites/:siteId/unitscan",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    (0, $jYCat.canUseCameraUnitScan)(userPermissions) ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $a466acfbdf930dea$export$ded845d1eea1f233), {
                                        mode: "update",
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "sites/:siteId/onvifdiscovery",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    (0, $jYCat.canUseOnvifScan)(userPermissions) ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $9074a18862e2aa7b$export$1cd946f61ee6c5f7), {}) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "sites/addschedule",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    userPermissions.add_cameras ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $57b606d5a2664a02$export$3417f92f857e1806), {}) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "sites/addschedulesecret",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    userPermissions.add_cameras ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $57b606d5a2664a02$export$3417f92f857e1806), {}) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "sites/aboutsite/:siteid",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $b025acc92f1be866$export$e6024d62728f289b), {
                                        screen: "sites",
                                        ...screenGateProps,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $elyck.SiteAbout), {
                                            permissions: permissions,
                                            navBarCollapsed: navBarCollapsed,
                                            setNavBarCollapsed: setNavBarCollapsed
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "sites/:siteid/editcamera/:cameraid/editignorezones",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    userPermissions.edit_cameras ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $d5e1a870b2f29fa5$export$b731b475761cc2a0), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        showNewIgnoreZonesPage && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "sites/:siteid/editcamera/:cameraid/ignorezones",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    userPermissions.edit_cameras ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $9736146db7d63c95$export$f5da4331e1f58dc8), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "sites/:siteid/editcamera/:cameraid/editmetadatatagzones",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    userPermissions.edit_cameras && viewEditMetadataTagZonesPage ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $a85835ec83c9e44d$export$cd791c42ebc5b399), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        showLineCrossings && /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "sites/:siteid/editcamera/:cameraid/editlinecrossings",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $dd8354e141c081ef$export$67c0a53e49e9b96c), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "sites/:siteid/editcamera/:cameraid",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $b025acc92f1be866$export$e6024d62728f289b), {
                                        screen: "sites",
                                        ...screenGateProps,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dfWDO.EditCamera), {
                                            permissions: permissions,
                                            navBarCollapsed: navBarCollapsed,
                                            setNavBarCollapsed: setNavBarCollapsed
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "calendars",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    userPermissions.add_cameras ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $8fd061cf8e8d69d2$export$39d78c94fb91ad03), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "actionlogs/:siteid",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    !userPermissions.patrol_only ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $b025acc92f1be866$export$e6024d62728f289b), {
                                        screen: "sites",
                                        ...screenGateProps,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8a72acb32332a3d2$export$e241ab6b9aa14723), {
                                            navBarCollapsed: navBarCollapsed,
                                            setNavBarCollapsed: setNavBarCollapsed
                                        })
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "alerts&:alertsFilters",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    userPermissions.view_alerts ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $b025acc92f1be866$export$e6024d62728f289b), {
                                        screen: "alerts",
                                        ...screenGateProps,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dfbb1eaa7354951b$export$2e2bcd8739ae039), {
                                            navBarCollapsed: navBarCollapsed,
                                            setNavBarCollapsed: setNavBarCollapsed
                                        })
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "alerts",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    permissions.view_alerts ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $b025acc92f1be866$export$e6024d62728f289b), {
                                        screen: "alerts",
                                        ...screenGateProps,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $dfbb1eaa7354951b$export$2e2bcd8739ae039), {
                                            navBarCollapsed: navBarCollapsed,
                                            setNavBarCollapsed: setNavBarCollapsed
                                        })
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "sites/:siteId/videowall",
                            element: /*#__PURE__*/ (0, $k4ank.jsx)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: permissions.view_alerts ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $b025acc92f1be866$export$e6024d62728f289b), {
                                    screen: "alerts",
                                    ...screenGateProps,
                                    children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $81f1cc9a36ff0ec7$export$fd671f193334f5e), {})
                                }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
                                    navBarCollapsed: navBarCollapsed,
                                    setNavBarCollapsed: setNavBarCollapsed
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "analytics",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    userPermissions.view_analytics && !userPermissions.patrol_only ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $b025acc92f1be866$export$e6024d62728f289b), {
                                        screen: "analytics",
                                        ...screenGateProps,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $6cbd5436fba8f051$export$2b3af6baec22bd98), {
                                            navBarCollapsed: navBarCollapsed,
                                            setNavBarCollapsed: setNavBarCollapsed
                                        })
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "analytics&:analyticsFilters",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    userPermissions.view_analytics && !userPermissions.patrol_only ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $b025acc92f1be866$export$e6024d62728f289b), {
                                        screen: "analytics",
                                        ...screenGateProps,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $6cbd5436fba8f051$export$2b3af6baec22bd98), {
                                            navBarCollapsed: navBarCollapsed,
                                            setNavBarCollapsed: setNavBarCollapsed
                                        })
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "groupuser",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    userPermissions.manage_users ? // && !userPermissions.patrol_only
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $f908a9295259f46c$export$aca851be5a22d4), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "talkdown",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    showTalkDown && userPermissions.talk_down ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $5a31bd68b991a0f9$export$d42ebf9a5234ff08), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "wireguardtunnels",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    showWireguardTunnelsPage ? /*#__PURE__*/ (0, $k4ank.jsx)((0, $b025acc92f1be866$export$e6024d62728f289b), {
                                        screen: "wireguard",
                                        ...screenGateProps,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $7c5370c03631568b$export$be59470a5a0a96f2), {
                                            navBarCollapsed: navBarCollapsed,
                                            setNavBarCollapsed: setNavBarCollapsed
                                        })
                                    }) : /*#__PURE__*/ (0, $k4ank.jsx)((0, $040bff954342b7e4$export$ae1acd55a119cb17), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "health",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $b025acc92f1be866$export$e6024d62728f289b), {
                                        screen: "health",
                                        ...screenGateProps,
                                        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $75c8446086b0e388$export$c874b3080281d6db), {
                                            navBarCollapsed: navBarCollapsed,
                                            setNavBarCollapsed: setNavBarCollapsed
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "productrequirements",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $4454260b9c6617a2$export$d143e5858993e7d1), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "callback",
                            element: /*#__PURE__*/ (0, $k4ank.jsx)((0, $da2c98fc7332ce30$export$78f58e2a70333412), {
                                setPermissions: setPermissions
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "eecallback",
                            element: /*#__PURE__*/ (0, $k4ank.jsx)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $c2220021aa7dddac$export$1f5fef2a1a84d30b), {})
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "MFA",
                            element: // <RequireAuth>
                            /*#__PURE__*/ (0, $k4ank.jsx)((0, $0498ae720de2cdde$export$409b3619e7bab7d1), {})
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "/no-internet",
                            element: /*#__PURE__*/ (0, $k4ank.jsx)((0, $bb602ee58150f194$export$c06e27611c3cd220), {})
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "/not-found",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $357b3d6d3c1d2bdb$export$e0cf1661d881410f), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $3T949.Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $49a30112aa406a1c$export$8ef2ed426dede42d), {
                                children: [
                                    cameraCheckFinsihedAlert,
                                    cameraCheckResultsDialog,
                                    /*#__PURE__*/ (0, $k4ank.jsx)((0, $c9d28e6ea372b2fa$export$a65c2c055de52e1d), {
                                        navBarCollapsed: navBarCollapsed,
                                        setNavBarCollapsed: setNavBarCollapsed
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $acdad01ca69cf12c$export$2e2bcd8739ae039 = $acdad01ca69cf12c$var$App;




var $fIsAN = parcelRequire("fIsAN");

var $eJfrs = parcelRequire("eJfrs");
/**
 * Actions represent the type of change to a location value.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#action
 */ var $f58047ad30d6cc19$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($f58047ad30d6cc19$export$e19cd5f9376f8cee || ($f58047ad30d6cc19$export$e19cd5f9376f8cee = {}));
var $f58047ad30d6cc19$var$readOnly = function(obj) {
    return Object.freeze(obj);
};
function $f58047ad30d6cc19$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== 'undefined') console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
var $f58047ad30d6cc19$var$BeforeUnloadEventType = 'beforeunload';
var $f58047ad30d6cc19$var$HashChangeEventType = 'hashchange';
var $f58047ad30d6cc19$var$PopStateEventType = 'popstate';
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $f58047ad30d6cc19$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    var _options = options, _options$window = _options.window, window = _options$window === void 0 ? document.defaultView : _options$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $f58047ad30d6cc19$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || 'default'
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $f58047ad30d6cc19$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation = getIndexAndLocation(), nextIndex = _getIndexAndLocation[0], nextLocation = _getIndexAndLocation[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                } else // Trying to POP to a location with no index. We did not create
                // this location, so we can't effectively block the navigation.
                $f58047ad30d6cc19$var$warning(false, // detail and link to it here so people can understand better what
                // is going on and how to avoid it.
                "You are trying to block a POP navigation to a location that was not created by the history library. The block will fail silently in production, but in general you should do all navigation with the history library (instead of using window.history.pushState directly) to avoid this situation.");
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($f58047ad30d6cc19$var$PopStateEventType, handlePop);
    var action = $f58047ad30d6cc19$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation2 = getIndexAndLocation(), index = _getIndexAndLocation2[0], location = _getIndexAndLocation2[1];
    var listeners = $f58047ad30d6cc19$var$createEvents();
    var blockers = $f58047ad30d6cc19$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $eJfrs.default)({}, globalHistory.state, {
            idx: index
        }), '');
    }
    function createHref(to) {
        return typeof to === 'string' ? to : $f58047ad30d6cc19$export$fe53371bee54353d(to);
    } // state defaults to `null` because `window.history.state` does
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $f58047ad30d6cc19$var$readOnly((0, $eJfrs.default)({
            pathname: location.pathname,
            hash: '',
            search: ''
        }, typeof to === 'string' ? $f58047ad30d6cc19$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $f58047ad30d6cc19$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation3 = getIndexAndLocation();
        index = _getIndexAndLocation3[0];
        location = _getIndexAndLocation3[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $f58047ad30d6cc19$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr[0], url = _getHistoryStateAndUr[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, '', url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $f58047ad30d6cc19$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr2 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr2[0], url = _getHistoryStateAndUr2[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, '', url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($f58047ad30d6cc19$var$BeforeUnloadEventType, $f58047ad30d6cc19$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($f58047ad30d6cc19$var$BeforeUnloadEventType, $f58047ad30d6cc19$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $f58047ad30d6cc19$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    var _options2 = options, _options2$window = _options2.window, window = _options2$window === void 0 ? document.defaultView : _options2$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _parsePath = $f58047ad30d6cc19$export$8ccf933b0513f8d0(window.location.hash.substr(1)), _parsePath$pathname = _parsePath.pathname, pathname = _parsePath$pathname === void 0 ? '/' : _parsePath$pathname, _parsePath$search = _parsePath.search, search = _parsePath$search === void 0 ? '' : _parsePath$search, _parsePath$hash = _parsePath.hash, hash = _parsePath$hash === void 0 ? '' : _parsePath$hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $f58047ad30d6cc19$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || 'default'
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $f58047ad30d6cc19$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation4 = getIndexAndLocation(), nextIndex = _getIndexAndLocation4[0], nextLocation = _getIndexAndLocation4[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                } else // Trying to POP to a location with no index. We did not create
                // this location, so we can't effectively block the navigation.
                $f58047ad30d6cc19$var$warning(false, // detail and link to it here so people can understand better
                // what is going on and how to avoid it.
                "You are trying to block a POP navigation to a location that was not created by the history library. The block will fail silently in production, but in general you should do all navigation with the history library (instead of using window.history.pushState directly) to avoid this situation.");
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($f58047ad30d6cc19$var$PopStateEventType, handlePop); // popstate does not fire on hashchange in IE 11 and old (trident) Edge
    // https://developer.mozilla.org/de/docs/Web/API/Window/popstate_event
    window.addEventListener($f58047ad30d6cc19$var$HashChangeEventType, function() {
        var _getIndexAndLocation5 = getIndexAndLocation(), nextLocation = _getIndexAndLocation5[1]; // Ignore extraneous hashchange events.
        if ($f58047ad30d6cc19$export$fe53371bee54353d(nextLocation) !== $f58047ad30d6cc19$export$fe53371bee54353d(location)) handlePop();
    });
    var action = $f58047ad30d6cc19$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation6 = getIndexAndLocation(), index = _getIndexAndLocation6[0], location = _getIndexAndLocation6[1];
    var listeners = $f58047ad30d6cc19$var$createEvents();
    var blockers = $f58047ad30d6cc19$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $eJfrs.default)({}, globalHistory.state, {
            idx: index
        }), '');
    }
    function getBaseHref() {
        var base = document.querySelector('base');
        var href = '';
        if (base && base.getAttribute('href')) {
            var url = window.location.href;
            var hashIndex = url.indexOf('#');
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href;
    }
    function createHref(to) {
        return getBaseHref() + '#' + (typeof to === 'string' ? to : $f58047ad30d6cc19$export$fe53371bee54353d(to));
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $f58047ad30d6cc19$var$readOnly((0, $eJfrs.default)({
            pathname: location.pathname,
            hash: '',
            search: ''
        }, typeof to === 'string' ? $f58047ad30d6cc19$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $f58047ad30d6cc19$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation7 = getIndexAndLocation();
        index = _getIndexAndLocation7[0];
        location = _getIndexAndLocation7[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $f58047ad30d6cc19$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        $f58047ad30d6cc19$var$warning(nextLocation.pathname.charAt(0) === '/', "Relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr3 = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr3[0], url = _getHistoryStateAndUr3[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, '', url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $f58047ad30d6cc19$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        $f58047ad30d6cc19$var$warning(nextLocation.pathname.charAt(0) === '/', "Relative pathnames are not supported in hash history.replace(" + JSON.stringify(to) + ")");
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr4 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr4[0], url = _getHistoryStateAndUr4[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, '', url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($f58047ad30d6cc19$var$BeforeUnloadEventType, $f58047ad30d6cc19$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($f58047ad30d6cc19$var$BeforeUnloadEventType, $f58047ad30d6cc19$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#creatememoryhistory
 */ function $f58047ad30d6cc19$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options3 = options, _options3$initialEntr = _options3.initialEntries, initialEntries = _options3$initialEntr === void 0 ? [
        '/'
    ] : _options3$initialEntr, initialIndex = _options3.initialIndex;
    var entries = initialEntries.map(function(entry) {
        var location = $f58047ad30d6cc19$var$readOnly((0, $eJfrs.default)({
            pathname: '/',
            search: '',
            hash: '',
            state: null,
            key: $f58047ad30d6cc19$var$createKey()
        }, typeof entry === 'string' ? $f58047ad30d6cc19$export$8ccf933b0513f8d0(entry) : entry));
        $f58047ad30d6cc19$var$warning(location.pathname.charAt(0) === '/', "Relative pathnames are not supported in createMemoryHistory({ initialEntries }) (invalid entry: " + JSON.stringify(entry) + ")");
        return location;
    });
    var index = $f58047ad30d6cc19$var$clamp(initialIndex == null ? entries.length - 1 : initialIndex, 0, entries.length - 1);
    var action = $f58047ad30d6cc19$export$e19cd5f9376f8cee.Pop;
    var location = entries[index];
    var listeners = $f58047ad30d6cc19$var$createEvents();
    var blockers = $f58047ad30d6cc19$var$createEvents();
    function createHref(to) {
        return typeof to === 'string' ? to : $f58047ad30d6cc19$export$fe53371bee54353d(to);
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $f58047ad30d6cc19$var$readOnly((0, $eJfrs.default)({
            pathname: location.pathname,
            search: '',
            hash: ''
        }, typeof to === 'string' ? $f58047ad30d6cc19$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $f58047ad30d6cc19$var$createKey()
        }));
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction, nextLocation) {
        action = nextAction;
        location = nextLocation;
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $f58047ad30d6cc19$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        $f58047ad30d6cc19$var$warning(location.pathname.charAt(0) === '/', "Relative pathnames are not supported in memory history.push(" + JSON.stringify(to) + ")");
        if (allowTx(nextAction, nextLocation, retry)) {
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            applyTx(nextAction, nextLocation);
        }
    }
    function replace(to, state) {
        var nextAction = $f58047ad30d6cc19$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        $f58047ad30d6cc19$var$warning(location.pathname.charAt(0) === '/', "Relative pathnames are not supported in memory history.replace(" + JSON.stringify(to) + ")");
        if (allowTx(nextAction, nextLocation, retry)) {
            entries[index] = nextLocation;
            applyTx(nextAction, nextLocation);
        }
    }
    function go(delta) {
        var nextIndex = $f58047ad30d6cc19$var$clamp(index + delta, 0, entries.length - 1);
        var nextAction = $f58047ad30d6cc19$export$e19cd5f9376f8cee.Pop;
        var nextLocation = entries[nextIndex];
        function retry() {
            go(delta);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index = nextIndex;
            applyTx(nextAction, nextLocation);
        }
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            return blockers.push(blocker);
        }
    };
    return history;
} ////////////////////////////////////////////////////////////////////////////////
// UTILS
////////////////////////////////////////////////////////////////////////////////
function $f58047ad30d6cc19$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
function $f58047ad30d6cc19$var$promptBeforeUnload(event) {
    // Cancel the event.
    event.preventDefault(); // Chrome (and legacy IE) requires returnValue to be set.
    event.returnValue = '';
}
function $f58047ad30d6cc19$var$createEvents() {
    var handlers = [];
    return {
        get length () {
            return handlers.length;
        },
        push: function push(fn) {
            handlers.push(fn);
            return function() {
                handlers = handlers.filter(function(handler) {
                    return handler !== fn;
                });
            };
        },
        call: function call(arg) {
            handlers.forEach(function(fn) {
                return fn && fn(arg);
            });
        }
    };
}
function $f58047ad30d6cc19$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createpath
 */ function $f58047ad30d6cc19$export$fe53371bee54353d(_ref) {
    var _ref$pathname = _ref.pathname, pathname = _ref$pathname === void 0 ? '/' : _ref$pathname, _ref$search = _ref.search, search = _ref$search === void 0 ? '' : _ref$search, _ref$hash = _ref.hash, hash = _ref$hash === void 0 ? '' : _ref$hash;
    if (search && search !== '?') pathname += search.charAt(0) === '?' ? search : '?' + search;
    if (hash && hash !== '#') pathname += hash.charAt(0) === '#' ? hash : '#' + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#parsepath
 */ function $f58047ad30d6cc19$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf('#');
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf('?');
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}


var $679aa726c88cbae0$exports = {};
$679aa726c88cbae0$exports = JSON.parse("{\"name\":\"actuate-camera-ui\",\"version\":\"6.46.1\",\"description\":\"\",\"scripts\":{\"dev\":\"HMR_ERROR_OVERLAY=false parcel src/index.html\",\"dev:clean\":\"npm run kill:dev && npm run clean:cache && HMR_ERROR_OVERLAY=false parcel src/index.html\",\"kill:dev\":\"lsof -ti:1234 | xargs kill -9 2>/dev/null || true\",\"clean:cache\":\"rm -rf .parcel-cache dist node_modules/.cache\",\"build\":\"parcel build src/index.html\",\"format\":\"prettier --write \\\"src/**/*.{js,jsx,ts,tsx}\\\"\",\"lint\":\"eslint \\\"src/**/*.{js,jsx,ts,tsx}\\\" --quiet\",\"test\":\"jest\",\"test:watch\":\"jest --watch\",\"test:coverage\":\"jest --coverage --coverageReporters=text --coverageReporters=html --coverageReporters=lcov\",\"test:coverage:ci\":\"jest --coverage --coverageReporters=lcov --coverageReporters=text\"},\"author\":\"Actuate AI\",\"license\":\"Apache-2.0\",\"devDependencies\":{\"@jest/test-sequencer\":\"^29.7.0\",\"@parcel/transformer-sass\":\"^2.13.3\",\"@testing-library/jest-dom\":\"^5.16.5\",\"@testing-library/react\":\"^12.1.5\",\"@testing-library/user-event\":\"^14.4.3\",\"@types/file-saver\":\"^2.0.7\",\"@types/jest\":\"^29.5.0\",\"@types/mui-image\":\"^1.0.1\",\"@types/node\":\"^17.0.35\",\"@types/react\":\"^17.0.39\",\"@types/react-dom\":\"^17.0.11\",\"@types/react-slick\":\"^0.23.13\",\"@types/react-virtualized\":\"^9.21.21\",\"@types/react-window\":\"^1.8.5\",\"@types/tailwindcss\":\"^3.1.0\",\"@typescript-eslint/eslint-plugin\":\"^5.26.0\",\"@typescript-eslint/parser\":\"^5.27.0\",\"assert\":\"^2.0.0\",\"autoprefixer\":\"^10.4.2\",\"buffer\":\"^6.0.3\",\"console-browserify\":\"^1.2.0\",\"eslint\":\"8.8.0\",\"eslint-config-prettier\":\"8.3.0\",\"eslint-import-resolver-typescript\":\"^2.7.1\",\"eslint-plugin-import\":\"^2.26.0\",\"eslint-plugin-jsx-a11y\":\"^6.5.1\",\"eslint-plugin-react\":\"^7.28.0\",\"eslint-plugin-react-hooks\":\"^4.3.0\",\"jest\":\"^29.5.0\",\"jest-environment-jsdom\":\"^29.5.0\",\"parcel\":\"^2.13.3\",\"path-browserify\":\"^1.0.1\",\"postcss\":\"^8.4.6\",\"prettier\":\"2.5.1\",\"process\":\"^0.11.10\",\"querystring-es3\":\"^0.2.1\",\"svgo\":\"^3.3.2\",\"tailwindcss\":\"^3.3.1\",\"ts-jest\":\"^29.1.0\",\"typescript\":\"^4.5.5\",\"util\":\"^0.12.4\"},\"dependencies\":{\"@emotion/react\":\"^11.13.0\",\"@emotion/styled\":\"^11.13.0\",\"@excalidraw/excalidraw\":\"^0.12.0\",\"@mui/icons-material\":\"^5.8.3\",\"@mui/material\":\"^5.16.6\",\"@mui/x-data-grid\":\"^5.13.4\",\"@mui/x-date-pickers\":\"^5.0.0-beta.4\",\"axios\":\"^0.27.2\",\"chart.js\":\"^4.2.1\",\"cookie-parser\":\"^1.4.6\",\"date-fns\":\"^2.29.1\",\"dayjs\":\"^1.11.9\",\"env-cmd\":\"^10.1.0\",\"file-saver\":\"^2.0.5\",\"formik\":\"^2.2.9\",\"history\":\"^5.3.0\",\"hls.js\":\"^1.6.16\",\"js-file-download\":\"^0.4.12\",\"launchdarkly-react-client-sdk\":\"^3.0.6\",\"local-storage\":\"^2.0.0\",\"lodash\":\"^4.17.21\",\"lodash.debounce\":\"^4.0.8\",\"material-ui-popup-state\":\"^5.0.9\",\"moment\":\"^2.29.4\",\"moment-timezone\":\"^0.5.43\",\"react\":\"^17.0.2\",\"react-chartjs-2\":\"^5.2.0\",\"react-cookie\":\"^4.1.1\",\"react-dom\":\"^17.0.2\",\"react-hotkeys\":\"^2.0.0\",\"react-infinite-scroll-component\":\"^6.1.0\",\"react-moment\":\"^1.1.3\",\"react-player\":\"^2.16.0\",\"react-router-dom\":\"^6.3.0\",\"react-slick\":\"^0.31.0\",\"react-window\":\"^1.8.7\",\"recharts\":\"^2.15.1\",\"slick-carousel\":\"^1.8.1\",\"svg\":\"^0.1.0\",\"swiper\":\"^12.0.2\",\"universal-cookie\":\"^4.0.4\",\"video-react\":\"^0.16.0\",\"yup\":\"^0.32.11\",\"zustand\":\"^4.5.1\"},\"browserslist\":[\"last 2 Chrome versions\"],\"alias\":{\"@parcel/error-overlay\":\"./src/no-error-overlay.js\"}}");


/* eslint-disable no-console */ 
var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $9mVTu = parcelRequire("9mVTu");
// LaunchDarkly configuration
const $8384e029443289be$export$e45ddd51efe4cb0c = {
    clientSideID: "68267cd35e1392093d35b8b2",
    options: {
        // Optional configuration settings
        streaming: false,
        // Disable event sending in development to avoid CORS issues
        sendEvents: false,
        // Use polling instead of streaming in development to avoid CORS issues
        useReport: false,
        // Disable console logging in production
        logger: undefined
    }
};
const $8384e029443289be$export$2fff46f9fa5ab8a7 = {
    key: "anonymous-user-default-key",
    anonymous: true,
    // Add custom attributes as needed
    custom: {
        appVersion: undefined
    }
};



var $ebTQj = parcelRequire("ebTQj");
// Component that will be rendered while LaunchDarkly is initializing
const $44f1cf888dfe292a$var$LoadingComponent = ()=>/*#__PURE__*/ (0, $k4ank.jsx)("div", {});
// Helper function for controlled logging
const $44f1cf888dfe292a$var$logLaunchDarkly = (message, data)=>{
    {
        if (data) (0, $ebTQj.logger).log(`[LaunchDarkly] ${message}`, data);
        else (0, $ebTQj.logger).log(`[LaunchDarkly] ${message}`);
    }
};
const $44f1cf888dfe292a$var$LaunchDarklyProvider = ({ children: children, user: user })=>{
    const [LDProvider, setLDProvider] = (0, $8T3gX.useState)(null);
    const [isLoading, setIsLoading] = (0, $8T3gX.useState)(false);
    const [resourcesLoaded, setResourcesLoaded] = (0, $8T3gX.useState)(false);
    // Function to get authenticated user context from localStorage
    const getAuthenticatedUserContext = ()=>{
        try {
            // Check for tokens in cookies (primary) and localStorage (fallback)
            const hasLocalStorageToken = localStorage.getItem("token") || localStorage.getItem("token_secret");
            const hasCookieToken = document.cookie.includes("token=") || document.cookie.includes("token_secret=");
            const hasToken = hasLocalStorageToken || hasCookieToken;
            const hasUserInfo = localStorage.getItem("userInfo");
            // Only proceed if user has tokens and userInfo
            // Note: We don't require token to be present immediately (it might be refreshing)
            if (hasToken && hasUserInfo) {
                const userInfo = JSON.parse(localStorage.userInfo);
                return {
                    key: userInfo.id || userInfo.email || `user-${Date.now()}`,
                    name: userInfo.name || userInfo.email,
                    email: userInfo.email,
                    custom: {
                        superUser: userInfo.permission?.super_user,
                        addCameras: userInfo.permission?.add_cameras,
                        editCameras: userInfo.permission?.edit_cameras,
                        deleteCameras: userInfo.permission?.delete_cameras,
                        manageUsers: userInfo.permission?.manage_users,
                        armDisarm: userInfo.permission?.arm_disarm,
                        appVersion: localStorage.getItem("packageJsonVersion") || undefined
                    }
                };
            }
        } catch (error) {
            (0, $ebTQj.logger).error("Failed to parse userInfo from localStorage:", error);
        }
        return null;
    };
    // Listen for userResourcesLoaded event
    (0, $8T3gX.useEffect)(()=>{
        const handleResourcesLoaded = ()=>{
            $44f1cf888dfe292a$var$logLaunchDarkly("User resources loaded, proceeding with initialization");
            setResourcesLoaded(true);
        };
        // Check if resources are already loaded (for returning users)
        const isLoggedIn = document.cookie.includes("token=") || document.cookie.includes("token_secret=");
        const hasUserInfo = localStorage.getItem("userInfo");
        if (isLoggedIn && hasUserInfo) {
            // User is already logged in and has data, proceed immediately
            $44f1cf888dfe292a$var$logLaunchDarkly("User already authenticated, proceeding with initialization");
            setResourcesLoaded(true);
        } else {
            // Wait for resources to be loaded
            window.addEventListener("userResourcesLoaded", handleResourcesLoaded);
            // Fallback: if no event fires within 5 seconds, proceed anyway
            const fallbackTimer = setTimeout(()=>{
                $44f1cf888dfe292a$var$logLaunchDarkly("No userResourcesLoaded event received, proceeding with fallback initialization");
                setResourcesLoaded(true);
            }, 5000);
            return ()=>{
                window.removeEventListener("userResourcesLoaded", handleResourcesLoaded);
                clearTimeout(fallbackTimer);
            };
        }
    }, []);
    (0, $8T3gX.useEffect)(()=>{
        // Only initialize when resources are loaded
        if (!resourcesLoaded) return;
        let isMounted = true;
        setIsLoading(true);
        const initializeLDProvider = async ()=>{
            try {
                // Check for authenticated user context first
                const authenticatedUser = getAuthenticatedUserContext();
                {
                    const isLoggedIn = document.cookie.includes("token=") || document.cookie.includes("token_secret=");
                    const hasUserInfo = localStorage.getItem("userInfo");
                    const hasLocalStorageToken = localStorage.getItem("token") || localStorage.getItem("token_secret");
                    const hasCookieToken = document.cookie.includes("token=") || document.cookie.includes("token_secret=");
                    const hasToken = hasLocalStorageToken || hasCookieToken;
                    $44f1cf888dfe292a$var$logLaunchDarkly("Authentication check", {
                        isLoggedIn: isLoggedIn,
                        hasUserInfo: !!hasUserInfo,
                        hasLocalStorageToken: !!hasLocalStorageToken,
                        hasCookieToken: !!hasCookieToken,
                        hasToken: hasToken,
                        authenticatedUserFound: !!authenticatedUser
                    });
                }
                // Use authenticated user if available, otherwise use provided user or default
                const userToUse = authenticatedUser || user || (0, $8384e029443289be$export$2fff46f9fa5ab8a7);
                // Ensure the user object has the required 'kind' property for LDContext
                const ldUser = {
                    kind: "user",
                    ...userToUse
                };
                $44f1cf888dfe292a$var$logLaunchDarkly("Initializing with user", {
                    key: "key" in ldUser ? ldUser.key : "anonymous",
                    name: "name" in ldUser ? ldUser.name : "anonymous",
                    email: "email" in ldUser ? ldUser.email : "anonymous",
                    // Don't log sensitive custom attributes in production
                    custom: "custom" in ldUser ? ldUser.custom : "[REDACTED]"
                });
                if (!(0, $8384e029443289be$export$e45ddd51efe4cb0c).clientSideID) (0, $ebTQj.logger).error("LaunchDarklyProvider: FATAL ERROR - clientSideID is empty! Check .env files and environment variable setup.");
                const LDProviderComponent = await (0, $9mVTu.asyncWithLDProvider)({
                    clientSideID: (0, $8384e029443289be$export$e45ddd51efe4cb0c).clientSideID,
                    user: ldUser,
                    options: (0, $8384e029443289be$export$e45ddd51efe4cb0c).options
                });
                if (isMounted) {
                    setLDProvider(()=>LDProviderComponent);
                    setIsLoading(false);
                }
            } catch (error) {
                (0, $ebTQj.logger).error("Failed to initialize LaunchDarkly:", error);
                // Continue rendering the app even if LaunchDarkly fails to initialize
                if (isMounted) setIsLoading(false);
            }
        };
        // Add a small delay to allow localStorage to be available and check for existing user context
        const timer = setTimeout(()=>{
            initializeLDProvider();
        }, 100);
        return ()=>{
            isMounted = false;
            clearTimeout(timer);
        };
    }, [
        user,
        resourcesLoaded
    ]);
    // Listen for changes to localStorage.userInfo to re-initialize when user logs in
    (0, $8T3gX.useEffect)(()=>{
        const handleStorageChange = (e)=>{
            if (e.key === "userInfo" && e.newValue) {
                // Check if user is actually logged in before re-initializing
                const isLoggedIn = document.cookie.includes("token=") || document.cookie.includes("token_secret=");
                const hasLocalStorageToken = localStorage.getItem("token") || localStorage.getItem("token_secret");
                const hasCookieToken = document.cookie.includes("token=") || document.cookie.includes("token_secret=");
                const hasToken = hasLocalStorageToken || hasCookieToken;
                if (isLoggedIn && hasToken) {
                    $44f1cf888dfe292a$var$logLaunchDarkly("User context changed, re-initializing...");
                    setIsLoading(true);
                    setLDProvider(null);
                    // Re-initialize with new user context
                    const initializeWithNewUser = async ()=>{
                        try {
                            const userInfo = JSON.parse(e.newValue);
                            const ldUser = {
                                kind: "user",
                                key: userInfo.id || userInfo.email || `user-${Date.now()}`,
                                name: userInfo.name || userInfo.email,
                                email: userInfo.email,
                                custom: {
                                    superUser: userInfo.permission?.super_user,
                                    addCameras: userInfo.permission?.add_cameras,
                                    editCameras: userInfo.permission?.edit_cameras,
                                    deleteCameras: userInfo.permission?.delete_cameras,
                                    manageUsers: userInfo.permission?.manage_users,
                                    armDisarm: userInfo.permission?.arm_disarm,
                                    appVersion: localStorage.getItem("packageJsonVersion") || undefined
                                }
                            };
                            $44f1cf888dfe292a$var$logLaunchDarkly("Re-initializing with authenticated user", {
                                key: ldUser.key,
                                name: ldUser.name,
                                email: ldUser.email,
                                // Don't log sensitive custom attributes in production
                                custom: (0, ldUser.custom)
                            });
                            const LDProviderComponent = await (0, $9mVTu.asyncWithLDProvider)({
                                clientSideID: (0, $8384e029443289be$export$e45ddd51efe4cb0c).clientSideID,
                                user: ldUser,
                                options: (0, $8384e029443289be$export$e45ddd51efe4cb0c).options
                            });
                            setLDProvider(()=>LDProviderComponent);
                            setIsLoading(false);
                        } catch (error) {
                            (0, $ebTQj.logger).error("Failed to re-initialize LaunchDarkly with new user:", error);
                            setIsLoading(false);
                        }
                    };
                    initializeWithNewUser();
                }
            }
        };
        // Listen for storage events (for cross-tab synchronization)
        window.addEventListener("storage", handleStorageChange);
        // Also check for userInfo changes on the current tab
        const checkUserInfoInterval = setInterval(()=>{
            const currentUserInfo = localStorage.getItem("userInfo");
            const isLoggedIn = document.cookie.includes("token=") || document.cookie.includes("token_secret=");
            const hasLocalStorageToken = localStorage.getItem("token") || localStorage.getItem("token_secret");
            const hasCookieToken = document.cookie.includes("token=") || document.cookie.includes("token_secret=");
            const hasToken = hasLocalStorageToken || hasCookieToken;
            if (currentUserInfo && isLoggedIn && hasToken && !isLoading && resourcesLoaded) {
                // If we have userInfo and we're not loading, we might need to re-initialize
                // This is a fallback for cases where storage event doesn't fire
                const authenticatedUser = getAuthenticatedUserContext();
                if (authenticatedUser && !LDProvider) {
                    $44f1cf888dfe292a$var$logLaunchDarkly("Detected userInfo but no provider, re-initializing...");
                    setIsLoading(true);
                    setLDProvider(null);
                // The useEffect above will handle re-initialization
                }
            }
        }, 1000);
        return ()=>{
            window.removeEventListener("storage", handleStorageChange);
            clearInterval(checkUserInfoInterval);
        };
    }, [
        isLoading,
        LDProvider,
        resourcesLoaded
    ]);
    // Always render the app, even if LaunchDarkly is not ready
    // The app will work without feature flags until LaunchDarkly is initialized
    if (!LDProvider) {
        if (!resourcesLoaded) $44f1cf888dfe292a$var$logLaunchDarkly("Waiting for user resources to load...");
        // Return children directly instead of LoadingComponent
        return /*#__PURE__*/ (0, $k4ank.jsx)((0, $k4ank.Fragment), {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $k4ank.jsx)(LDProvider, {
        children: children
    });
};
var $44f1cf888dfe292a$export$2e2bcd8739ae039 = $44f1cf888dfe292a$var$LaunchDarklyProvider;



/**
 * Console authentication tools for debugging
 */ 

var $1BWfV = parcelRequire("1BWfV");
// Make debugging tools available globally
if (typeof window !== "undefined") {
    window.authDebugger = (0, $df9cbfc65f2b700a$export$c45a5d67276420d6);
    window.authStateManager = (0, $1BWfV.authStateManager);
    // Add some convenience functions
    window.authDebug = ()=>{
        console.log("=== AUTH DEBUG TOOLS ===");
        console.log("Available commands:");
        console.log("- await authDebugger.logDebugInfo() - Show detailed auth state");
        console.log("- authStateManager.getAuthState() - Get current auth state");
        console.log("- authStateManager.validateAuthState() - Validate auth state");
        console.log("- await authDebugger.autoFixIssues() - Try to fix auth issues");
        console.log("- authStateManager.clearAuthState() - Clear all auth data");
        console.log("=========================");
    };
    console.log("\uD83D\uDD27 Auth debugging tools loaded!");
    console.log("Type 'authDebug()' for available commands");
    // Show initial auth state
    setTimeout(async ()=>{
        console.log("\uD83D\uDCCA Initial auth state:");
        await (0, $df9cbfc65f2b700a$export$c45a5d67276420d6).logDebugInfo();
    }, 1000);
}



var $7pFvC = parcelRequire("7pFvC");

const $aa9ec24788ad27d8$export$8ee1df3c6367a60 = (0, (/*@__PURE__*/$parcel$interopDefault($679aa726c88cbae0$exports))).version;
(0, (/*@__PURE__*/$parcel$interopDefault($7pFvC))).defaults.headers.common["X-App-Version"] = $aa9ec24788ad27d8$export$8ee1df3c6367a60;



var $k4ank = parcelRequire("k4ank");

var $8T3gX = parcelRequire("8T3gX");

var $kUcVg = parcelRequire("kUcVg");

var $1TOOV = parcelRequire("1TOOV");

var $iLEpm = parcelRequire("iLEpm");

var $887xF = parcelRequire("887xF");

var $8jTCz = parcelRequire("8jTCz");
const $d47fc1a49bea066a$export$70f3a56110317d56 = ()=>{
    const [queue, setQueue] = $8T3gX.useState([]);
    $8T3gX.useEffect(()=>{
        const nativeAlert = window.alert;
        window.alert = (message)=>{
            setQueue((prev)=>[
                    ...prev,
                    String(message ?? "")
                ]);
        };
        return ()=>{
            window.alert = nativeAlert;
        };
    }, []);
    const current = queue[0];
    const dismiss = ()=>setQueue((prev)=>prev.slice(1));
    return /*#__PURE__*/ (0, $k4ank.jsxs)((0, $kUcVg.default), {
        open: current !== undefined,
        onClose: dismiss,
        children: [
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $1TOOV.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $iLEpm.default), {
                    sx: {
                        whiteSpace: "pre-line"
                    },
                    children: current
                })
            }),
            /*#__PURE__*/ (0, $k4ank.jsx)((0, $887xF.default), {
                children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $8jTCz.OrangeTextButton), {
                    onClick: dismiss,
                    text: "OK",
                    disabled: false
                })
            })
        ]
    });
};


let $4e91a088c8a50000$var$rootElement = document.getElementById("root");
const $4e91a088c8a50000$var$history = (0, $f58047ad30d6cc19$export$719fc203c4e16dee)({
    window: window
});
// Function to detect OS and apply class to <body>
const $4e91a088c8a50000$var$detectOS = ()=>{
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (userAgent.includes("win") || userAgent.includes("linux")) document.body.classList.add("pc-scrollbars");
    else document.body.classList.remove("pc-scrollbars");
};
// Wrapper component to run OS detection on mount
const $4e91a088c8a50000$var$Root = ()=>{
    (0, $8T3gX.useEffect)(()=>{
        $4e91a088c8a50000$var$detectOS();
        console.log("Auth debugging tools available: authDebugger, authStateManager");
    }, []);
    return /*#__PURE__*/ (0, $k4ank.jsx)((0, $a72857d2c4579fd9$export$87091915187a1a85), {
        children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $fIsAN.unstable_HistoryRouter), {
            history: $4e91a088c8a50000$var$history,
            children: /*#__PURE__*/ (0, $k4ank.jsx)((0, $44f1cf888dfe292a$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $k4ank.jsxs)((0, $8T3gX.Profiler), {
                    id: "App",
                    onRender: $4e91a088c8a50000$var$onRenderCallback,
                    children: [
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $d47fc1a49bea066a$export$70f3a56110317d56), {}),
                        /*#__PURE__*/ (0, $k4ank.jsx)((0, $acdad01ca69cf12c$export$2e2bcd8739ae039), {
                            packageJson: (0, (/*@__PURE__*/$parcel$interopDefault($679aa726c88cbae0$exports)))
                        })
                    ]
                })
            })
        })
    });
};
const $4e91a088c8a50000$var$onRenderCallback = (id, phase, actualDuration, baseDuration, startTime, commitTime, interactions // the Set of interactions belonging to this update
)=>{};
(0, (/*@__PURE__*/$parcel$interopDefault($8VQWA))).render(/*#__PURE__*/ (0, $k4ank.jsx)($4e91a088c8a50000$var$Root, {}), $4e91a088c8a50000$var$rootElement);


//# sourceMappingURL=camera-ui.327ffc30.js.map
